// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"lfXpc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _client = require("react-dom/client");
var _globalsCss = require("./globals.css");
var _styleguideCss = require("./styleguide.css");
var _app = require("./App");
var _appDefault = parcelHelpers.interopDefault(_app);
const container = document.getElementById("app");
const root = (0, _client.createRoot)(container);
root.render(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appDefault.default), {}));

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-dom/client":"5eZdG","./globals.css":"fK2YX","./styleguide.css":"8Y7Ec","./App":"bARwf","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gonF6":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("e5e9711c2edf1a4e");

},{"e5e9711c2edf1a4e":"84Frb"}],"84Frb":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var f = require("3fd2a064dc1f3641"), k = Symbol.for("react.element"), l = Symbol.for("react.fragment"), m = Object.prototype.hasOwnProperty, n = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)m.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: n.current
    };
}
exports.Fragment = l;
exports.jsx = q;
exports.jsxs = q;

},{"3fd2a064dc1f3641":"bmhQu"}],"bmhQu":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("956f36295e4e0134");

},{"956f36295e4e0134":"7cX1V"}],"7cX1V":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var l = Symbol.for("react.element"), n = Symbol.for("react.portal"), p = Symbol.for("react.fragment"), q = Symbol.for("react.strict_mode"), r = Symbol.for("react.profiler"), t = Symbol.for("react.provider"), u = Symbol.for("react.context"), v = Symbol.for("react.forward_ref"), w = Symbol.for("react.suspense"), x = Symbol.for("react.memo"), y = Symbol.for("react.lazy"), z = Symbol.iterator;
function A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = z && a[z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, C = Object.assign, D = {};
function E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = D;
    this.updater = e || B;
}
E.prototype.isReactComponent = {};
E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function F() {}
F.prototype = E.prototype;
function G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = D;
    this.updater = e || B;
}
var H = G.prototype = new F;
H.constructor = G;
C(H, E.prototype);
H.isPureReactComponent = !0;
var I = Array.isArray, J = Object.prototype.hasOwnProperty, K = {
    current: null
}, L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)J.call(b, d) && !L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: K.current
    };
}
function N(a, b) {
    return {
        $$typeof: l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === l;
}
function escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var P = /\/+/g;
function Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? escape("" + a.key) : b.toString(36);
}
function R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case l:
                case n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + Q(h, 0) : d, I(c) ? (e = "", null != a && (e = a.replace(P, "$&/") + "/"), R(c, b, e, "", function(a) {
        return a;
    })) : null != c && (O(c) && (c = N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace(P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if (I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + Q(k, g);
        h += R(k, b, e, f, c);
    }
    else if (f = A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + Q(k, g++), h += R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var U = {
    current: null
}, V = {
    transition: null
}, W = {
    ReactCurrentDispatcher: U,
    ReactCurrentBatchConfig: V,
    ReactCurrentOwner: K
};
function X() {
    throw Error("act(...) is not supported in production builds of React.");
}
exports.Children = {
    map: S,
    forEach: function(a, b, e) {
        S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
exports.Component = E;
exports.Fragment = p;
exports.Profiler = r;
exports.PureComponent = G;
exports.StrictMode = q;
exports.Suspense = w;
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = W;
exports.act = X;
exports.cloneElement = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)J.call(b, f) && !L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
exports.createContext = function(a) {
    a = {
        $$typeof: u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: t,
        _context: a
    };
    return a.Consumer = a;
};
exports.createElement = M;
exports.createFactory = function(a) {
    var b = M.bind(null, a);
    b.type = a;
    return b;
};
exports.createRef = function() {
    return {
        current: null
    };
};
exports.forwardRef = function(a) {
    return {
        $$typeof: v,
        render: a
    };
};
exports.isValidElement = O;
exports.lazy = function(a) {
    return {
        $$typeof: y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: T
    };
};
exports.memo = function(a, b) {
    return {
        $$typeof: x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
exports.startTransition = function(a) {
    var b = V.transition;
    V.transition = {};
    try {
        a();
    } finally{
        V.transition = b;
    }
};
exports.unstable_act = X;
exports.useCallback = function(a, b) {
    return U.current.useCallback(a, b);
};
exports.useContext = function(a) {
    return U.current.useContext(a);
};
exports.useDebugValue = function() {};
exports.useDeferredValue = function(a) {
    return U.current.useDeferredValue(a);
};
exports.useEffect = function(a, b) {
    return U.current.useEffect(a, b);
};
exports.useId = function() {
    return U.current.useId();
};
exports.useImperativeHandle = function(a, b, e) {
    return U.current.useImperativeHandle(a, b, e);
};
exports.useInsertionEffect = function(a, b) {
    return U.current.useInsertionEffect(a, b);
};
exports.useLayoutEffect = function(a, b) {
    return U.current.useLayoutEffect(a, b);
};
exports.useMemo = function(a, b) {
    return U.current.useMemo(a, b);
};
exports.useReducer = function(a, b, e) {
    return U.current.useReducer(a, b, e);
};
exports.useRef = function(a) {
    return U.current.useRef(a);
};
exports.useState = function(a) {
    return U.current.useState(a);
};
exports.useSyncExternalStore = function(a, b, e) {
    return U.current.useSyncExternalStore(a, b, e);
};
exports.useTransition = function() {
    return U.current.useTransition();
};
exports.version = "18.3.1";

},{}],"5eZdG":[function(require,module,exports,__globalThis) {
'use strict';
var m = require("aaccff5d309d9239");
var i;
exports.createRoot = m.createRoot;
exports.hydrateRoot = m.hydrateRoot;

},{"aaccff5d309d9239":"82aNB"}],"82aNB":[function(require,module,exports,__globalThis) {
'use strict';
function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
checkDCE();
module.exports = require("9223fb8c5161e54b");

},{"9223fb8c5161e54b":"cfGqX"}],"cfGqX":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 'use strict';
var aa = require("5393afc8c463ef07"), ca = require("ece50e903283a22f");
function p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var da = new Set, ea = {};
function fa(a, b) {
    ha(a, b);
    ha(a + "Capture", b);
}
function ha(a, b) {
    ea[a] = b;
    for(a = 0; a < b.length; a++)da.add(b[a]);
}
var ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ja = Object.prototype.hasOwnProperty, ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, la = {}, ma = {};
function oa(a) {
    if (ja.call(ma, a)) return !0;
    if (ja.call(la, a)) return !1;
    if (ka.test(a)) return ma[a] = !0;
    la[a] = !0;
    return !1;
}
function pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    z[a] = new v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    z[b] = new v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    z[a] = new v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    z[a] = new v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    z[a] = new v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    z[a] = new v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    z[a] = new v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    z[a] = new v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    z[a] = new v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var ra = /[\-:]([a-z])/g;
function sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    z[a] = new v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
z.xlinkHref = new v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    z[a] = new v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function ta(a, b, c, d) {
    var e = z.hasOwnProperty(b) ? z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) qa(b, c, e, d) && (c = null), d || null === e ? oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var ua = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, va = Symbol.for("react.element"), wa = Symbol.for("react.portal"), ya = Symbol.for("react.fragment"), za = Symbol.for("react.strict_mode"), Aa = Symbol.for("react.profiler"), Ba = Symbol.for("react.provider"), Ca = Symbol.for("react.context"), Da = Symbol.for("react.forward_ref"), Ea = Symbol.for("react.suspense"), Fa = Symbol.for("react.suspense_list"), Ga = Symbol.for("react.memo"), Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var Ja = Symbol.iterator;
function Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ja && a[Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var A = Object.assign, La;
function Ma(a) {
    if (void 0 === La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        La = b && b[1] || "";
    }
    return "\n" + La + a;
}
var Na = !1;
function Oa(a, b) {
    if (!a || Na) return "";
    Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Ma(a) : "";
}
function Pa(a) {
    switch(a.tag){
        case 5:
            return Ma(a.type);
        case 16:
            return Ma("Lazy");
        case 13:
            return Ma("Suspense");
        case 19:
            return Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Oa(a.type, !1), a;
        case 11:
            return a = Oa(a.type.render, !1), a;
        case 1:
            return a = Oa(a.type, !0), a;
        default:
            return "";
    }
}
function Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ya:
            return "Fragment";
        case wa:
            return "Portal";
        case Aa:
            return "Profiler";
        case za:
            return "StrictMode";
        case Ea:
            return "Suspense";
        case Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case Ca:
            return (a.displayName || "Context") + ".Consumer";
        case Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case Ga:
            return b = a.displayName || null, null !== b ? b : Qa(a.type) || "Memo";
        case Ha:
            b = a._payload;
            a = a._init;
            try {
                return Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return Qa(b);
        case 8:
            return b === za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function ab(a, b) {
    b = b.checked;
    null != b && ta(a, "checked", b, !1);
}
function bb(a, b) {
    ab(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && cb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function cb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var eb = Array.isArray;
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(p(91));
    return A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(p(92));
            if (eb(c)) {
                if (1 < c.length) throw Error(p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var mb, nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        mb = mb || document.createElement("div");
        mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(pb).forEach(function(a) {
    qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        pb[b] = pb[a];
    });
});
function rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || pb.hasOwnProperty(a) && pb[a] ? ("" + b).trim() : b + "px";
}
function sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var tb = A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function ub(a, b) {
    if (b) {
        if (tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error(p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(p(62));
    }
}
function vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var wb = null;
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(p(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb() {}
var Ib = !1;
function Jb(a, b, c) {
    if (Ib) return a(b, c);
    Ib = !0;
    try {
        return Gb(a, b, c);
    } finally{
        if (Ib = !1, null !== zb || null !== Ab) Hb(), Fb();
    }
}
function Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(p(231, b, typeof c));
    return c;
}
var Lb = !1;
if (ia) try {
    var Mb = {};
    Object.defineProperty(Mb, "passive", {
        get: function() {
            Lb = !0;
        }
    });
    window.addEventListener("test", Mb, Mb);
    window.removeEventListener("test", Mb, Mb);
} catch (a) {
    Lb = !1;
}
function Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var Ob = !1, Pb = null, Qb = !1, Rb = null, Sb = {
    onError: function(a) {
        Ob = !0;
        Pb = a;
    }
};
function Tb(a, b, c, d, e, f, g, h, k) {
    Ob = !1;
    Pb = null;
    Nb.apply(Sb, arguments);
}
function Ub(a, b, c, d, e, f, g, h, k) {
    Tb.apply(this, arguments);
    if (Ob) {
        if (Ob) {
            var l = Pb;
            Ob = !1;
            Pb = null;
        } else throw Error(p(198));
        Qb || (Qb = !0, Rb = l);
    }
}
function Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function Xb(a) {
    if (Vb(a) !== a) throw Error(p(188));
}
function Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = Vb(a);
        if (null === b) throw Error(p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return Xb(e), a;
                if (f === d) return Xb(e), b;
                f = f.sibling;
            }
            throw Error(p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(p(189));
            }
        }
        if (c.alternate !== d) throw Error(p(190));
    }
    if (3 !== c.tag) throw Error(p(188));
    return c.stateNode.current === c ? a : b;
}
function Zb(a) {
    a = Yb(a);
    return null !== a ? $b(a) : null;
}
function $b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var ac = ca.unstable_scheduleCallback, bc = ca.unstable_cancelCallback, cc = ca.unstable_shouldYield, dc = ca.unstable_requestPaint, B = ca.unstable_now, ec = ca.unstable_getCurrentPriorityLevel, fc = ca.unstable_ImmediatePriority, gc = ca.unstable_UserBlockingPriority, hc = ca.unstable_NormalPriority, ic = ca.unstable_LowPriority, jc = ca.unstable_IdlePriority, kc = null, lc = null;
function mc(a) {
    if (lc && "function" === typeof lc.onCommitFiberRoot) try {
        lc.onCommitFiberRoot(kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var oc = Math.clz32 ? Math.clz32 : nc, pc = Math.log, qc = Math.LN2;
function nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - (pc(a) / qc | 0) | 0;
}
var rc = 64, sc = 4194304;
function tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = tc(h) : (f &= g, 0 !== f && (d = tc(f)));
    } else g = c & ~e, 0 !== g ? d = tc(g) : 0 !== f && (d = tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function yc() {
    var a = rc;
    rc <<= 1;
    0 === (rc & 4194240) && (rc = 64);
    return a;
}
function zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - oc(b);
    a[b] = c;
}
function Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var C = 0;
function Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var Ec, Fc, Gc, Hc, Ic, Jc = !1, Kc = [], Lc = null, Mc = null, Nc = null, Oc = new Map, Pc = new Map, Qc = [], Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            Pc.delete(b.pointerId);
    }
}
function Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = Cb(b), null !== b && Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return Lc = Tc(Lc, a, b, c, d, e), !0;
        case "dragenter":
            return Mc = Tc(Mc, a, b, c, d, e), !0;
        case "mouseover":
            return Nc = Tc(Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            Oc.set(f, Tc(Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, Pc.set(f, Tc(Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function Vc(a) {
    var b = Wc(a.target);
    if (null !== b) {
        var c = Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = Wb(c), null !== b) {
                    a.blockedOn = b;
                    Ic(a.priority, function() {
                        Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            wb = d;
            c.target.dispatchEvent(d);
            wb = null;
        } else return b = Cb(c), null !== b && Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function Zc(a, b, c) {
    Xc(a) && c.delete(b);
}
function $c() {
    Jc = !1;
    null !== Lc && Xc(Lc) && (Lc = null);
    null !== Mc && Xc(Mc) && (Mc = null);
    null !== Nc && Xc(Nc) && (Nc = null);
    Oc.forEach(Zc);
    Pc.forEach(Zc);
}
function ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, Jc || (Jc = !0, ca.unstable_scheduleCallback(ca.unstable_NormalPriority, $c)));
}
function bd(a) {
    function b(b) {
        return ad(b, a);
    }
    if (0 < Kc.length) {
        ad(Kc[0], a);
        for(var c = 1; c < Kc.length; c++){
            var d = Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== Lc && ad(Lc, a);
    null !== Mc && ad(Mc, a);
    null !== Nc && ad(Nc, a);
    Oc.forEach(b);
    Pc.forEach(b);
    for(c = 0; c < Qc.length; c++)d = Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < Qc.length && (c = Qc[0], null === c.blockedOn);)Vc(c), null === c.blockedOn && Qc.shift();
}
var cd = ua.ReactCurrentBatchConfig, dd = !0;
function ed(a, b, c, d) {
    var e = C, f = cd.transition;
    cd.transition = null;
    try {
        C = 1, fd(a, b, c, d);
    } finally{
        C = e, cd.transition = f;
    }
}
function gd(a, b, c, d) {
    var e = C, f = cd.transition;
    cd.transition = null;
    try {
        C = 4, fd(a, b, c, d);
    } finally{
        C = e, cd.transition = f;
    }
}
function fd(a, b, c, d) {
    if (dd) {
        var e = Yc(a, b, c, d);
        if (null === e) hd(a, b, d, id, c), Sc(a, d);
        else if (Uc(e, a, b, c, d)) d.stopPropagation();
        else if (Sc(a, d), b & 4 && -1 < Rc.indexOf(a)) {
            for(; null !== e;){
                var f = Cb(e);
                null !== f && Ec(f);
                f = Yc(a, b, c, d);
                null === f && hd(a, b, d, id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else hd(a, b, d, null, c);
    }
}
var id = null;
function Yc(a, b, c, d) {
    id = null;
    a = xb(d);
    a = Wc(a);
    if (null !== a) {
        if (b = Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    id = a;
    return null;
}
function jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch(ec()){
                case fc:
                    return 1;
                case gc:
                    return 4;
                case hc:
                case ic:
                    return 16;
                case jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = A({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = A({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = A({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = A({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = A({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = A({}, sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = A({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = A({}, ud, {
    key: function(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = A({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = A({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = A({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = A({}, Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = ia && "CompositionEvent" in window, be = null;
ia && "documentMode" in document && (be = document.documentMode);
var ce = ia && "TextEvent" in window && !be, de = ia && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (ia) {
    var xe;
    if (ia) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        Jb(re, b);
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge;
function Ie(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!ja.call(b, e) || !He(a[e], b[e])) return !1;
    }
    return !0;
}
function Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Ke(a, b) {
    var c = Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Je(c);
    }
}
function Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Me() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function Oe(a) {
    var b = Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = Ke(c, f);
                var g = Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var Pe = ia && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Ie(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
function Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var We = {
    animationend: Ve("Animation", "AnimationEnd"),
    animationiteration: Ve("Animation", "AnimationIteration"),
    animationstart: Ve("Animation", "AnimationStart"),
    transitionend: Ve("Transition", "TransitionEnd")
}, Xe = {}, Ye = {};
ia && (Ye = document.createElement("div").style, "AnimationEvent" in window || (delete We.animationend.animation, delete We.animationiteration.animation, delete We.animationstart.animation), "TransitionEvent" in window || delete We.transitionend.transition);
function Ze(a) {
    if (Xe[a]) return Xe[a];
    if (!We[a]) return a;
    var b = We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Ye) return Xe[a] = b[c];
    return a;
}
var $e = Ze("animationend"), af = Ze("animationiteration"), bf = Ze("animationstart"), cf = Ze("transitionend"), df = new Map, ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function ff(a, b) {
    df.set(a, b);
    fa(b, [
        a
    ]);
}
for(var gf = 0; gf < ef.length; gf++){
    var hf = ef[gf], jf = hf.toLowerCase(), kf = hf[0].toUpperCase() + hf.slice(1);
    ff(jf, "on" + kf);
}
ff($e, "onAnimationEnd");
ff(af, "onAnimationIteration");
ff(bf, "onAnimationStart");
ff("dblclick", "onDoubleClick");
ff("focusin", "onFocus");
ff("focusout", "onBlur");
ff(cf, "onTransitionEnd");
ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), mf = new Set("cancel close invalid load scroll toggle".split(" ").concat(lf));
function nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                nf(e, h, l);
                f = k;
            }
        }
    }
    if (Qb) throw a = Rb, Qb = !1, Rb = null, a;
}
function D(a, b) {
    var c = b[of];
    void 0 === c && (c = b[of] = new Set);
    var d = a + "__bubble";
    c.has(d) || (pf(b, a, 2, !1), c.add(d));
}
function qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    pf(c, a, d, b);
}
var rf = "_reactListening" + Math.random().toString(36).slice(2);
function sf(a) {
    if (!a[rf]) {
        a[rf] = !0;
        da.forEach(function(b) {
            "selectionchange" !== b && (mf.has(b) || qf(b, !1, a), qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[rf] || (b[rf] = !0, qf("selectionchange", !1, b));
    }
}
function pf(a, b, c, d) {
    switch(jd(b)){
        case 1:
            var e = ed;
            break;
        case 4:
            e = gd;
            break;
        default:
            e = fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Jb(function() {
        var d = f, e = xb(c), g = [];
        a: {
            var h = df.get(a);
            if (void 0 !== h) {
                var k = td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case $e:
                    case af:
                    case bf:
                        k = Hd;
                        break;
                    case cf:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = Kb(w, x), null != F && t.push(tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== wb && (n = c.relatedTarget || c.fromElement) && (Wc(n) || n[uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? Wc(n) : null, null !== n && (J = Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : ue(k);
                        u = null == n ? h : ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = vf(u))w++;
                            u = 0;
                            for(F = x; F; F = vf(F))u++;
                            for(; 0 < w - u;)t = vf(t), w--;
                            for(; 0 < u - w;)x = vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = vf(t);
                                x = vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && wf(g, h, k, t, !1);
                        null !== n && null !== J && wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = ve;
                else if (me(h)) {
                    if (we) na = Fe;
                    else {
                        na = De;
                        var xa = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = Ee);
                if (na && (na = na(a, d))) {
                    ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && cb(h, "number", h.value);
            }
            xa = d ? ue(d) : window;
            switch(a){
                case "focusin":
                    if (me(xa) || "true" === xa.contentEditable) Qe = xa, Re = d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, e);
            }
            var $a;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else ie ? ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && ie && ($a = nd()) : (kd = e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), xa = oe(d, ba), 0 < xa.length && (ba = new Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = he(c), null !== $a && (ba.data = $a))));
            if ($a = ce ? je(a, c) : ke(a, c)) d = oe(d, "onBeforeInput"), 0 < d.length && (e = new Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        se(g, b);
    });
}
function tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Kb(a, c), null != f && d.unshift(tf(a, f, e)), f = Kb(a, b), null != f && d.push(tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Kb(c, f), null != k && g.unshift(tf(c, k, h))) : e || (k = Kb(c, f), null != k && g.push(tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var xf = /\r\n?/g, yf = /\u0000|\uFFFD/g;
function zf(a) {
    return ("string" === typeof a ? a : "" + a).replace(xf, "\n").replace(yf, "");
}
function Af(a, b, c) {
    b = zf(b);
    if (zf(a) !== b && c) throw Error(p(425));
}
function Bf() {}
var Cf = null, Df = null;
function Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var Ff = "function" === typeof setTimeout ? setTimeout : void 0, Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, Hf = "function" === typeof Promise ? Promise : void 0, Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof Hf ? function(a) {
    return Hf.resolve(null).then(a).catch(If);
} : Ff;
function If(a) {
    setTimeout(function() {
        throw a;
    });
}
function Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    bd(b);
}
function Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var Nf = Math.random().toString(36).slice(2), Of = "__reactFiber$" + Nf, Pf = "__reactProps$" + Nf, uf = "__reactContainer$" + Nf, of = "__reactEvents$" + Nf, Qf = "__reactListeners$" + Nf, Rf = "__reactHandles$" + Nf;
function Wc(a) {
    var b = a[Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[uf] || c[Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = Mf(a); null !== a;){
                if (c = a[Of]) return c;
                a = Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[Of] || a[uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(p(33));
}
function Db(a) {
    return a[Pf] || null;
}
var Sf = [], Tf = -1;
function Uf(a) {
    return {
        current: a
    };
}
function E(a) {
    0 > Tf || (a.current = Sf[Tf], Sf[Tf] = null, Tf--);
}
function G(a, b) {
    Tf++;
    Sf[Tf] = a.current;
    a.current = b;
}
var Vf = {}, H = Uf(Vf), Wf = Uf(!1), Xf = Vf;
function Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $f() {
    E(Wf);
    E(H);
}
function ag(a, b, c) {
    if (H.current !== Vf) throw Error(p(168));
    G(H, b);
    G(Wf, c);
}
function bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error(p(108, Ra(a) || "Unknown", e));
    return A({}, c, d);
}
function cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Vf;
    Xf = H.current;
    G(H, a);
    G(Wf, Wf.current);
    return !0;
}
function dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(p(169));
    c ? (a = bg(a, b, Xf), d.__reactInternalMemoizedMergedChildContext = a, E(Wf), E(H), G(H, a)) : E(Wf);
    G(Wf, c);
}
var eg = null, fg = !1, gg = !1;
function hg(a) {
    null === eg ? eg = [
        a
    ] : eg.push(a);
}
function ig(a) {
    fg = !0;
    hg(a);
}
function jg() {
    if (!gg && null !== eg) {
        gg = !0;
        var a = 0, b = C;
        try {
            var c = eg;
            for(C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            eg = null;
            fg = !1;
        } catch (e) {
            throw null !== eg && (eg = eg.slice(a + 1)), ac(fc, jg), e;
        } finally{
            C = b, gg = !1;
        }
    }
    return null;
}
var kg = [], lg = 0, mg = null, ng = 0, og = [], pg = 0, qg = null, rg = 1, sg = "";
function tg(a, b) {
    kg[lg++] = ng;
    kg[lg++] = mg;
    mg = a;
    ng = b;
}
function ug(a, b, c) {
    og[pg++] = rg;
    og[pg++] = sg;
    og[pg++] = qg;
    qg = a;
    var d = rg;
    a = sg;
    var e = 32 - oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        rg = 1 << 32 - oc(b) + e | c << e | d;
        sg = f + a;
    } else rg = 1 << f | c << e | d, sg = a;
}
function vg(a) {
    null !== a.return && (tg(a, 1), ug(a, 1, 0));
}
function wg(a) {
    for(; a === mg;)mg = kg[--lg], kg[lg] = null, ng = kg[--lg], kg[lg] = null;
    for(; a === qg;)qg = og[--pg], og[pg] = null, sg = og[--pg], og[pg] = null, rg = og[--pg], og[pg] = null;
}
var xg = null, yg = null, I = !1, zg = null;
function Ag(a, b) {
    var c = Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, xg = a, yg = Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, xg = a, yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== qg ? {
                id: rg,
                overflow: sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, xg = a, yg = null, !0) : !1;
        default:
            return !1;
    }
}
function Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function Eg(a) {
    if (I) {
        var b = yg;
        if (b) {
            var c = b;
            if (!Cg(a, b)) {
                if (Dg(a)) throw Error(p(418));
                b = Lf(c.nextSibling);
                var d = xg;
                b && Cg(a, b) ? Ag(d, c) : (a.flags = a.flags & -4097 | 2, I = !1, xg = a);
            }
        } else {
            if (Dg(a)) throw Error(p(418));
            a.flags = a.flags & -4097 | 2;
            I = !1;
            xg = a;
        }
    }
}
function Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    xg = a;
}
function Gg(a) {
    if (a !== xg) return !1;
    if (!I) return Fg(a), I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !Ef(a.type, a.memoizedProps));
    if (b && (b = yg)) {
        if (Dg(a)) throw Hg(), Error(p(418));
        for(; b;)Ag(a, b), b = Lf(b.nextSibling);
    }
    Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            yg = Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            yg = null;
        }
    } else yg = xg ? Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function Hg() {
    for(var a = yg; a;)a = Lf(a.nextSibling);
}
function Ig() {
    yg = xg = null;
    I = !1;
}
function Jg(a) {
    null === zg ? zg = [
        a
    ] : zg.push(a);
}
var Kg = ua.ReactCurrentBatchConfig;
function Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error(p(284));
        if (!c._owner) throw Error(p(290, a));
    }
    return a;
}
function Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error(p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === Ha && Ng(f) === b.type)) return d = e(b, c.props), d.ref = Lg(a, b, c), d.return = a, d;
        d = Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case va:
                    return c = Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = Lg(a, null, b), c.return = a, c;
                case wa:
                    return b = Sg(b, a.mode, c), b.return = a, b;
                case Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if (eb(b) || Ka(b)) return b = Tg(b, a.mode, c, null), b.return = a, b;
            Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case va:
                    return c.key === e ? k(a, b, c, d) : null;
                case wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if (eb(c) || Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if (eb(d) || Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), I && tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            I && tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        I && tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = Ka(h);
        if ("function" !== typeof l) throw Error(p(150));
        h = l.call(h);
        if (null == h) throw Error(p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), I && tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            I && tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        I && tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === Ha && Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === ya ? (d = Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if (eb(f)) return n(a, d, f, h);
            if (Ka(f)) return t(a, d, f, h);
            Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var Ug = Og(!0), Vg = Og(!1), Wg = Uf(null), Xg = null, Yg = null, Zg = null;
function $g() {
    Zg = Yg = Xg = null;
}
function ah(a) {
    var b = Wg.current;
    E(Wg);
    a._currentValue = b;
}
function bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function ch(a, b) {
    Xg = a;
    Zg = Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (dh = !0), a.firstContext = null);
}
function eh(a) {
    var b = a._currentValue;
    if (Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === Yg) {
            if (null === Xg) throw Error(p(308));
            Yg = a;
            Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else Yg = Yg.next = a;
    }
    return b;
}
var fh = null;
function gh(a) {
    null === fh ? fh = [
        a
    ] : fh.push(a);
}
function hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return ih(a, d);
}
function ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var jh = !1;
function kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== (K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return ih(a, c);
}
function oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        Cc(a, c);
    }
}
function ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function qh(a, b, c, d) {
    var e = a.updateQueue;
    jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = A({}, q, r);
                            break a;
                        case 2:
                            jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(p(191, e));
            e.call(d);
        }
    }
}
var th = {}, uh = Uf(th), vh = Uf(th), wh = Uf(th);
function xh(a) {
    if (a === th) throw Error(p(174));
    return a;
}
function yh(a, b) {
    G(wh, b);
    G(vh, a);
    G(uh, th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = lb(b, a);
    }
    E(uh);
    G(uh, b);
}
function zh() {
    E(uh);
    E(vh);
    E(wh);
}
function Ah(a) {
    xh(wh.current);
    var b = xh(uh.current);
    var c = lb(b, a.type);
    b !== c && (G(vh, a), G(uh, c));
}
function Bh(a) {
    vh.current === a && (E(uh), E(vh));
}
var L = Uf(0);
function Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var Dh = [];
function Eh() {
    for(var a = 0; a < Dh.length; a++)Dh[a]._workInProgressVersionPrimary = null;
    Dh.length = 0;
}
var Fh = ua.ReactCurrentDispatcher, Gh = ua.ReactCurrentBatchConfig, Hh = 0, M = null, N = null, O = null, Ih = !1, Jh = !1, Kh = 0, Lh = 0;
function P() {
    throw Error(p(321));
}
function Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Nh(a, b, c, d, e, f) {
    Hh = f;
    M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    Fh.current = null === a || null === a.memoizedState ? Oh : Ph;
    a = c(d, e);
    if (Jh) {
        f = 0;
        do {
            Jh = !1;
            Kh = 0;
            if (25 <= f) throw Error(p(301));
            f += 1;
            O = N = null;
            b.updateQueue = null;
            Fh.current = Qh;
            a = c(d, e);
        }while (Jh);
    }
    Fh.current = Rh;
    b = null !== N && null !== N.next;
    Hh = 0;
    O = N = M = null;
    Ih = !1;
    if (b) throw Error(p(300));
    return a;
}
function Sh() {
    var a = 0 !== Kh;
    Kh = 0;
    return a;
}
function Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === O ? M.memoizedState = O = a : O = O.next = a;
    return O;
}
function Uh() {
    if (null === N) {
        var a = M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = N.next;
    var b = null === O ? M.memoizedState : O.next;
    if (null !== b) O = b, N = a;
    else {
        if (null === a) throw Error(p(310));
        N = a;
        a = {
            memoizedState: N.memoizedState,
            baseState: N.baseState,
            baseQueue: N.baseQueue,
            queue: N.queue,
            next: null
        };
        null === O ? M.memoizedState = O = a : O = O.next = a;
    }
    return O;
}
function Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function Wh(a) {
    var b = Uh(), c = b.queue;
    if (null === c) throw Error(p(311));
    c.lastRenderedReducer = a;
    var d = N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if ((Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                M.lanes |= m;
                rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        He(d, b.memoizedState) || (dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, M.lanes |= f, rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function Xh(a) {
    var b = Uh(), c = b.queue;
    if (null === c) throw Error(p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function Yh() {}
function Zh(a, b) {
    var c = M, d = Uh(), e = b(), f = !He(d.memoizedState, e);
    f && (d.memoizedState = e, dh = !0);
    d = d.queue;
    $h(ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== O && O.memoizedState.tag & 1) {
        c.flags |= 2048;
        bi(9, ci.bind(null, c, d, e, b), void 0, null);
        if (null === Q) throw Error(p(349));
        0 !== (Hh & 30) || di(c, b, e);
    }
    return e;
}
function di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    ei(b) && fi(a);
}
function ai(a, b, c) {
    return c(function() {
        ei(b) && fi(a);
    });
}
function ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !He(a, c);
    } catch (d) {
        return !0;
    }
}
function fi(a) {
    var b = ih(a, 1);
    null !== b && gi(b, a, 1, -1);
}
function hi(a) {
    var b = Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = ii.bind(null, M, a);
    return [
        b.memoizedState,
        a
    ];
}
function bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function ji() {
    return Uh().memoizedState;
}
function ki(a, b, c, d) {
    var e = Th();
    M.flags |= a;
    e.memoizedState = bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function li(a, b, c, d) {
    var e = Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== N) {
        var g = N.memoizedState;
        f = g.destroy;
        if (null !== d && Mh(d, g.deps)) {
            e.memoizedState = bi(b, c, f, d);
            return;
        }
    }
    M.flags |= a;
    e.memoizedState = bi(1 | b, c, f, d);
}
function mi(a, b) {
    return ki(8390656, 8, a, b);
}
function $h(a, b) {
    return li(2048, 8, a, b);
}
function ni(a, b) {
    return li(4, 2, a, b);
}
function oi(a, b) {
    return li(4, 4, a, b);
}
function pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return li(4, 4, pi.bind(null, b, a), c);
}
function ri() {}
function si(a, b) {
    var c = Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ti(a, b) {
    var c = Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ui(a, b, c) {
    if (0 === (Hh & 21)) return a.baseState && (a.baseState = !1, dh = !0), a.memoizedState = c;
    He(c, b) || (c = yc(), M.lanes |= c, rh |= c, a.baseState = !0);
    return b;
}
function vi(a, b) {
    var c = C;
    C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = Gh.transition;
    Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        C = c, Gh.transition = d;
    }
}
function wi() {
    return Uh().memoizedState;
}
function xi(a, b, c) {
    var d = yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (zi(a)) Ai(b, c);
    else if (c = hh(a, b, c, d), null !== c) {
        var e = R();
        gi(c, a, d, e);
        Bi(c, b, d);
    }
}
function ii(a, b, c) {
    var d = yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (zi(a)) Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if (He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = hh(a, b, e, d);
        null !== c && (e = R(), gi(c, a, d, e), Bi(c, b, d));
    }
}
function zi(a) {
    var b = a.alternate;
    return a === M || null !== b && b === M;
}
function Ai(a, b) {
    Jh = Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        Cc(a, c);
    }
}
var Rh = {
    readContext: eh,
    useCallback: P,
    useContext: P,
    useEffect: P,
    useImperativeHandle: P,
    useInsertionEffect: P,
    useLayoutEffect: P,
    useMemo: P,
    useReducer: P,
    useRef: P,
    useState: P,
    useDebugValue: P,
    useDeferredValue: P,
    useTransition: P,
    useMutableSource: P,
    useSyncExternalStore: P,
    useId: P,
    unstable_isNewReconciler: !1
}, Oh = {
    readContext: eh,
    useCallback: function(a, b) {
        Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: eh,
    useEffect: mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return ki(4194308, 4, pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = xi.bind(null, M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: hi,
    useDebugValue: ri,
    useDeferredValue: function(a) {
        return Th().memoizedState = a;
    },
    useTransition: function() {
        var a = hi(!1), b = a[0];
        a = vi.bind(null, a[1]);
        Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = M, e = Th();
        if (I) {
            if (void 0 === c) throw Error(p(407));
            c = c();
        } else {
            c = b();
            if (null === Q) throw Error(p(349));
            0 !== (Hh & 30) || di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        mi(ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        bi(9, ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = Th(), b = Q.identifierPrefix;
        if (I) {
            var c = sg;
            var d = rg;
            c = (d & ~(1 << 32 - oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, Ph = {
    readContext: eh,
    useCallback: si,
    useContext: eh,
    useEffect: $h,
    useImperativeHandle: qi,
    useInsertionEffect: ni,
    useLayoutEffect: oi,
    useMemo: ti,
    useReducer: Wh,
    useRef: ji,
    useState: function() {
        return Wh(Vh);
    },
    useDebugValue: ri,
    useDeferredValue: function(a) {
        var b = Uh();
        return ui(b, N.memoizedState, a);
    },
    useTransition: function() {
        var a = Wh(Vh)[0], b = Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: Yh,
    useSyncExternalStore: Zh,
    useId: wi,
    unstable_isNewReconciler: !1
}, Qh = {
    readContext: eh,
    useCallback: si,
    useContext: eh,
    useEffect: $h,
    useImperativeHandle: qi,
    useInsertionEffect: ni,
    useLayoutEffect: oi,
    useMemo: ti,
    useReducer: Xh,
    useRef: ji,
    useState: function() {
        return Xh(Vh);
    },
    useDebugValue: ri,
    useDeferredValue: function(a) {
        var b = Uh();
        return null === N ? b.memoizedState = a : ui(b, N.memoizedState, a);
    },
    useTransition: function() {
        var a = Xh(Vh)[0], b = Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: Yh,
    useSyncExternalStore: Zh,
    useId: wi,
    unstable_isNewReconciler: !1
};
function Ci(a, b) {
    if (a && a.defaultProps) {
        b = A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = R(), e = yi(a), f = mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = nh(a, f, e);
        null !== b && (gi(b, a, e, d), oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = R(), e = yi(a), f = mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = nh(a, f, e);
        null !== b && (gi(b, a, e, d), oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = R(), d = yi(a), e = mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = nh(a, e, d);
        null !== b && (gi(b, a, d, c), oh(b, a, d));
    }
};
function Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Ie(c, d) || !Ie(e, f) : !0;
}
function Gi(a, b, c) {
    var d = !1, e = Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = eh(f) : (e = Zf(b) ? Xf : H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Yf(a, e) : Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Ei.enqueueReplaceState(b, b.state, null);
}
function Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = eh(f) : (f = Zf(b) ? Xf : H.current, e.context = Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Ei.enqueueReplaceState(e, e.state, null), qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function Ji(a, b) {
    try {
        var c = "", d = b;
        do c += Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Mi = "function" === typeof WeakMap ? WeakMap : Map;
function Ni(a, b, c) {
    c = mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Oi || (Oi = !0, Pi = d);
        Li(a, b);
    };
    return c;
}
function Qi(a, b, c) {
    c = mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        Li(a, b);
        "function" !== typeof d && (null === Ri ? Ri = new Set([
            this
        ]) : Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = Ti.bind(null, a, b, c), b.then(a, a));
}
function Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = mh(-1, 1), b.tag = 2, nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var Wi = ua.ReactCurrentOwner, dh = !1;
function Xi(a, b, c, d) {
    b.child = null === a ? Vg(b, null, c, d) : Ug(b, a.child, c, d);
}
function Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    ch(b, e);
    d = Nh(a, b, c, d, f, e);
    c = Sh();
    if (null !== a && !dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, Zi(a, b, e);
    I && c && vg(b);
    b.flags |= 1;
    Xi(a, b, d, e);
    return b.child;
}
function $i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, bj(a, b, f, d, e);
        a = Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : Ie;
        if (c(g, d) && a.ref === b.ref) return Zi(a, b, e);
    }
    b.flags |= 1;
    a = Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if (Ie(f, d) && a.ref === b.ref) {
            if (dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && (dh = !0);
            else return b.lanes = a.lanes, Zi(a, b, e);
        }
    }
    return cj(a, b, c, d, e);
}
function dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, G(ej, fj), fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, G(ej, fj), fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            G(ej, fj);
            fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, G(ej, fj), fj |= d;
    Xi(a, b, e, c);
    return b.child;
}
function gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function cj(a, b, c, d, e) {
    var f = Zf(c) ? Xf : H.current;
    f = Yf(b, f);
    ch(b, e);
    c = Nh(a, b, c, d, f, e);
    d = Sh();
    if (null !== a && !dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, Zi(a, b, e);
    I && d && vg(b);
    b.flags |= 1;
    Xi(a, b, c, e);
    return b.child;
}
function hj(a, b, c, d, e) {
    if (Zf(c)) {
        var f = !0;
        cg(b);
    } else f = !1;
    ch(b, e);
    if (null === b.stateNode) ij(a, b), Gi(b, c, d), Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = eh(l) : (l = Zf(c) ? Xf : H.current, l = Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Hi(b, g, d, l);
        jh = !1;
        var r = b.memoizedState;
        g.state = r;
        qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || Wf.current || jh ? ("function" === typeof m && (Di(b, c, m, d), k = b.memoizedState), (h = jh || Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = eh(k) : (k = Zf(c) ? Xf : H.current, k = Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && Hi(b, g, d, k);
        jh = !1;
        r = b.memoizedState;
        g.state = r;
        qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || Wf.current || jh ? ("function" === typeof y && (Di(b, c, y, d), n = b.memoizedState), (l = jh || Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return jj(a, b, c, d, f, e);
}
function jj(a, b, c, d, e, f) {
    gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && dg(b, c, !1), Zi(a, b, f);
    d = b.stateNode;
    Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Ug(b, a.child, null, f), b.child = Ug(b, null, h, f)) : Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && dg(b, c, !0);
    return b.child;
}
function kj(a) {
    var b = a.stateNode;
    b.pendingContext ? ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && ag(a, b.context, !1);
    yh(a, b.containerInfo);
}
function lj(a, b, c, d, e) {
    Ig();
    Jg(e);
    b.flags |= 256;
    Xi(a, b, c, d);
    return b.child;
}
var mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function oj(a, b, c) {
    var d = b.pendingProps, e = L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    G(L, e & 1);
    if (null === a) {
        Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = pj(g, d, 0, null), a = Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = nj(c), b.memoizedState = mj, a) : qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = Pg(h, f) : (f = Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function qj(a, b) {
    b = pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function sj(a, b, c, d) {
    null !== d && Jg(d);
    Ug(b, a.child, null, c);
    a = qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = Ki(Error(p(422))), sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && Ug(b, a.child, null, g);
        b.child.memoizedState = nj(g);
        b.memoizedState = mj;
        return f;
    }
    if (0 === (b.mode & 1)) return sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error(p(419));
        d = Ki(f, d, void 0);
        return sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if (dh || h) {
        d = Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, ih(a, e), gi(d, a, e, -1));
        }
        tj();
        d = Ki(Error(p(421)));
        return sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    yg = Lf(e.nextSibling);
    xg = b;
    I = !0;
    zg = null;
    null !== a && (og[pg++] = rg, og[pg++] = sg, og[pg++] = qg, rg = a.id, sg = a.overflow, qg = b);
    b = qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    bh(a.return, b, c);
}
function wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    Xi(a, b, d.children, c);
    d = L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && vj(a, c, b);
            else if (19 === a.tag) vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    G(L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            wj(b, !0, c, null, f);
            break;
        case "together":
            wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error(p(153));
    if (null !== b.child) {
        a = b.child;
        c = Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function yj(a, b, c) {
    switch(b.tag){
        case 3:
            kj(b);
            Ig();
            break;
        case 5:
            Ah(b);
            break;
        case 1:
            Zf(b.type) && cg(b);
            break;
        case 4:
            yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            G(Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return G(L, L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return oj(a, b, c);
                G(L, L.current & 1);
                a = Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            G(L, L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            G(L, L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, dj(a, b, c);
    }
    return Zi(a, b, c);
}
var zj, Aj, Bj, Cj;
zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Aj = function() {};
Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        xh(uh.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "select":
                e = A({}, e, {
                    value: void 0
                });
                d = A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = Bf);
        }
        ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Dj(a, b) {
    if (!I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function Ej(a, b, c) {
    var d = b.pendingProps;
    wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return S(b), null;
        case 1:
            return Zf(b.type) && $f(), S(b), null;
        case 3:
            d = b.stateNode;
            zh();
            E(Wf);
            E(H);
            Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== zg && (Fj(zg), zg = null));
            Aj(a, b);
            S(b);
            return null;
        case 5:
            Bh(b);
            var e = xh(wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(p(166));
                    S(b);
                    return null;
                }
                a = xh(uh.current);
                if (Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[Of] = b;
                    d[Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            D("cancel", d);
                            D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < lf.length; e++)D(lf[e], d);
                            break;
                        case "source":
                            D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            D("error", d);
                            D("load", d);
                            break;
                        case "details":
                            D("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            D("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), D("invalid", d);
                    }
                    ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : ea.hasOwnProperty(g) && null != h && "onScroll" === g && D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            Va(d);
                            db(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[Of] = b;
                    a[Pf] = d;
                    zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = vb(c, d);
                        switch(c){
                            case "dialog":
                                D("cancel", a);
                                D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < lf.length; e++)D(lf[e], a);
                                e = d;
                                break;
                            case "source":
                                D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                D("error", a);
                                D("load", a);
                                e = d;
                                break;
                            case "details":
                                D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                Za(a, d);
                                e = Ya(a, d);
                                D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = A({}, d, {
                                    value: void 0
                                });
                                D("invalid", a);
                                break;
                            case "textarea":
                                hb(a, d);
                                e = gb(a, d);
                                D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && ob(a, k) : "number" === typeof k && ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ea.hasOwnProperty(f) ? null != k && "onScroll" === f && D("scroll", a) : null != k && ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                Va(a);
                                db(a, d, !1);
                                break;
                            case "textarea":
                                Va(a);
                                jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(p(166));
                c = xh(wh.current);
                xh(uh.current);
                if (Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = xg, null !== a) switch(a.tag){
                            case 3:
                                Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[Of] = b, b.stateNode = d;
            }
            S(b);
            return null;
        case 13:
            E(L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if (I && null !== yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) Hg(), Ig(), b.flags |= 98560, f = !1;
                else if (f = Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error(p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error(p(317));
                        f[Of] = b;
                    } else Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    S(b);
                    f = !1;
                } else null !== zg && (Fj(zg), zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== (L.current & 1) ? 0 === T && (T = 3) : tj()));
            null !== b.updateQueue && (b.flags |= 4);
            S(b);
            return null;
        case 4:
            return zh(), Aj(a, b), null === a && sf(b.stateNode.containerInfo), S(b), null;
        case 10:
            return ah(b.type._context), S(b), null;
        case 17:
            return Zf(b.type) && $f(), S(b), null;
        case 19:
            E(L);
            f = b.memoizedState;
            if (null === f) return S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) Dj(f, !1);
                else {
                    if (0 !== T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            G(L, L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && B() > Gj && (b.flags |= 128, d = !0, Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !I) return S(b), null;
                    } else 2 * B() - f.renderingStartTime > Gj && 1073741824 !== c && (b.flags |= 128, d = !0, Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = B(), b.sibling = null, c = L.current, G(L, d ? c & 1 | 2 : c & 1), b;
            S(b);
            return null;
        case 22:
        case 23:
            return Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== (fj & 1073741824) && (S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error(p(156, b.tag));
}
function Ij(a, b) {
    wg(b);
    switch(b.tag){
        case 1:
            return Zf(b.type) && $f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return zh(), E(Wf), E(H), Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return Bh(b), null;
        case 13:
            E(L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error(p(340));
                Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return E(L), null;
        case 4:
            return zh(), null;
        case 10:
            return ah(b.type._context), null;
        case 22:
        case 23:
            return Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var Jj = !1, U = !1, Kj = "function" === typeof WeakSet ? WeakSet : Set, V = null;
function Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            W(a, b, d);
        }
        else c.current = null;
    }
}
function Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        W(a, b, d);
    }
}
var Nj = !1;
function Oj(a, b) {
    Cf = dd;
    a = Me();
    if (Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    Df = {
        focusedElem: a,
        selectionRange: c
    };
    dd = !1;
    for(V = b; null !== V;)if (b = V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, V = a;
    else for(; null !== V;){
        b = V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error(p(163));
            }
        } catch (F) {
            W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            V = a;
            break;
        }
        V = b.return;
    }
    n = Nj;
    Nj = !1;
    return n;
}
function Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[Of], delete b[Pf], delete b[of], delete b[Qf], delete b[Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = Bf));
    else if (4 !== d && (a = a.child, null !== a)) for(Vj(a, b, c), a = a.sibling; null !== a;)Vj(a, b, c), a = a.sibling;
}
function Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(Wj(a, b, c), a = a.sibling; null !== a;)Wj(a, b, c), a = a.sibling;
}
var X = null, Xj = !1;
function Yj(a, b, c) {
    for(c = c.child; null !== c;)Zj(a, b, c), c = c.sibling;
}
function Zj(a, b, c) {
    if (lc && "function" === typeof lc.onCommitFiberUnmount) try {
        lc.onCommitFiberUnmount(kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            U || Lj(c, b);
        case 6:
            var d = X, e = Xj;
            X = null;
            Yj(a, b, c);
            X = d;
            Xj = e;
            null !== X && (Xj ? (a = X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : X.removeChild(c.stateNode));
            break;
        case 18:
            null !== X && (Xj ? (a = X, c = c.stateNode, 8 === a.nodeType ? Kf(a.parentNode, c) : 1 === a.nodeType && Kf(a, c), bd(a)) : Kf(X, c.stateNode));
            break;
        case 4:
            d = X;
            e = Xj;
            X = c.stateNode.containerInfo;
            Xj = !0;
            Yj(a, b, c);
            X = d;
            Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? Mj(c, b, g) : 0 !== (f & 4) && Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            Yj(a, b, c);
            break;
        case 1:
            if (!U && (Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                W(c, b, h);
            }
            Yj(a, b, c);
            break;
        case 21:
            Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? (U = (d = U) || null !== c.memoizedState, Yj(a, b, c), U = d) : Yj(a, b, c);
            break;
        default:
            Yj(a, b, c);
    }
}
function ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Kj);
        b.forEach(function(b) {
            var d = bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        X = h.stateNode;
                        Xj = !1;
                        break a;
                    case 3:
                        X = h.stateNode.containerInfo;
                        Xj = !0;
                        break a;
                    case 4:
                        X = h.stateNode.containerInfo;
                        Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === X) throw Error(p(160));
            Zj(f, g, e);
            X = null;
            Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)dk(b, a), b = b.sibling;
}
function dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            ck(b, a);
            ek(a);
            if (d & 4) {
                try {
                    Pj(3, a, a.return), Qj(3, a);
                } catch (t) {
                    W(a, a.return, t);
                }
                try {
                    Pj(5, a, a.return);
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 1:
            ck(b, a);
            ek(a);
            d & 512 && null !== c && Lj(c, c.return);
            break;
        case 5:
            ck(b, a);
            ek(a);
            d & 512 && null !== c && Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    ob(e, "");
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && ab(e, f);
                    vb(h, g);
                    var l = vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? sb(e, q) : "dangerouslySetInnerHTML" === m ? nb(e, q) : "children" === m ? ob(e, q) : ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            bb(e, f);
                            break;
                        case "textarea":
                            ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? fb(e, !!f.multiple, f.defaultValue, !0) : fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[Pf] = f;
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 6:
            ck(b, a);
            ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error(p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 3:
            ck(b, a);
            ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                bd(b.containerInfo);
            } catch (t) {
                W(a, a.return, t);
            }
            break;
        case 4:
            ck(b, a);
            ek(a);
            break;
        case 13:
            ck(b, a);
            ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || (fk = B()));
            d & 4 && ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? (U = (l = U) || m, ck(b, a), U = l) : ck(b, a);
            ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for(V = a, m = a.child; null !== m;){
                    for(q = V = m; null !== V;){
                        r = V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                Pj(4, r, r.return);
                                break;
                            case 1:
                                Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, V = y) : gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = rb("display", g));
                            } catch (t) {
                                W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            ck(b, a);
            ek(a);
            d & 4 && ak(a);
            break;
        case 21:
            break;
        default:
            ck(b, a), ek(a);
    }
}
function ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if (Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error(p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && (ob(e, ""), d.flags &= -33);
                    var f = Uj(a);
                    Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = Uj(a);
                    Vj(a, h, g);
                    break;
                default:
                    throw Error(p(161));
            }
        } catch (k) {
            W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function hk(a, b, c) {
    V = a;
    ik(a, b, c);
}
function ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== V;){
        var e = V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || U;
                h = Jj;
                var l = U;
                Jj = g;
                if ((U = k) && !l) for(V = e; null !== V;)g = V, k = g.child, 22 === g.tag && null !== g.memoizedState ? jk(e) : null !== k ? (k.return = g, V = k) : jk(e);
                for(; null !== f;)V = f, ik(f, b, c), f = f.sibling;
                V = e;
                Jj = h;
                U = l;
            }
            kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, V = f) : kk(a, b, c);
    }
}
function kk(a) {
    for(; null !== V;){
        var b = V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        U || Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error(p(163));
                }
                U || b.flags & 512 && Rj(b);
            } catch (r) {
                W(b, b.return, r);
            }
        }
        if (b === a) {
            V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            V = c;
            break;
        }
        V = b.return;
    }
}
function gk(a) {
    for(; null !== V;){
        var b = V;
        if (b === a) {
            V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            V = c;
            break;
        }
        V = b.return;
    }
}
function jk(a) {
    for(; null !== V;){
        var b = V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        Qj(4, b);
                    } catch (k) {
                        W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        Rj(b);
                    } catch (k) {
                        W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        Rj(b);
                    } catch (k) {
                        W(b, g, k);
                    }
            }
        } catch (k) {
            W(b, b.return, k);
        }
        if (b === a) {
            V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            V = h;
            break;
        }
        V = b.return;
    }
}
var lk = Math.ceil, mk = ua.ReactCurrentDispatcher, nk = ua.ReactCurrentOwner, ok = ua.ReactCurrentBatchConfig, K = 0, Q = null, Y = null, Z = 0, fj = 0, ej = Uf(0), T = 0, pk = null, rh = 0, qk = 0, rk = 0, sk = null, tk = null, fk = 0, Gj = Infinity, uk = null, Oi = !1, Pi = null, Ri = null, vk = !1, wk = null, xk = 0, yk = 0, zk = null, Ak = -1, Bk = 0;
function R() {
    return 0 !== (K & 6) ? B() : -1 !== Ak ? Ak : Ak = B();
}
function yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== (K & 2) && 0 !== Z) return Z & -Z;
    if (null !== Kg.transition) return 0 === Bk && (Bk = yc()), Bk;
    a = C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : jd(a.type);
    return a;
}
function gi(a, b, c, d) {
    if (50 < yk) throw yk = 0, zk = null, Error(p(185));
    Ac(a, c, d);
    if (0 === (K & 2) || a !== Q) a === Q && (0 === (K & 2) && (qk |= c), 4 === T && Ck(a, Z)), Dk(a, d), 1 === c && 0 === K && 0 === (b.mode & 1) && (Gj = B() + 500, fg && jg());
}
function Dk(a, b) {
    var c = a.callbackNode;
    wc(a, b);
    var d = uc(a, a === Q ? Z : 0);
    if (0 === d) null !== c && bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && bc(c);
        if (1 === b) 0 === a.tag ? ig(Ek.bind(null, a)) : hg(Ek.bind(null, a)), Jf(function() {
            0 === (K & 6) && jg();
        }), c = null;
        else {
            switch(Dc(d)){
                case 1:
                    c = fc;
                    break;
                case 4:
                    c = gc;
                    break;
                case 16:
                    c = hc;
                    break;
                case 536870912:
                    c = jc;
                    break;
                default:
                    c = hc;
            }
            c = Fk(c, Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Gk(a, b) {
    Ak = -1;
    Bk = 0;
    if (0 !== (K & 6)) throw Error(p(327));
    var c = a.callbackNode;
    if (Hk() && a.callbackNode !== c) return null;
    var d = uc(a, a === Q ? Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = Ik(a, d);
    else {
        b = d;
        var e = K;
        K |= 2;
        var f = Jk();
        if (Q !== a || Z !== b) uk = null, Gj = B() + 500, Kk(a, b);
        for(;;)try {
            Lk();
            break;
        } catch (h) {
            Mk(a, h);
        }
        $g();
        mk.current = f;
        K = e;
        null !== Y ? b = 0 : (Q = null, Z = 0, b = T);
    }
    if (0 !== b) {
        2 === b && (e = xc(a), 0 !== e && (d = e, b = Nk(a, e)));
        if (1 === b) throw c = pk, Kk(a, 0), Ck(a, d), Dk(a, B()), c;
        if (6 === b) Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !Ok(e) && (b = Ik(a, d), 2 === b && (f = xc(a), 0 !== f && (d = f, b = Nk(a, f))), 1 === b)) throw c = pk, Kk(a, 0), Ck(a, d), Dk(a, B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error(p(345));
                case 2:
                    Pk(a, tk, uk);
                    break;
                case 3:
                    Ck(a, d);
                    if ((d & 130023424) === d && (b = fk + 500 - B(), 10 < b)) {
                        if (0 !== uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = Ff(Pk.bind(null, a, tk, uk), b);
                        break;
                    }
                    Pk(a, tk, uk);
                    break;
                case 4:
                    Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = Ff(Pk.bind(null, a, tk, uk), d);
                        break;
                    }
                    Pk(a, tk, uk);
                    break;
                case 5:
                    Pk(a, tk, uk);
                    break;
                default:
                    throw Error(p(329));
            }
        }
    }
    Dk(a, B());
    return a.callbackNode === c ? Gk.bind(null, a) : null;
}
function Nk(a, b) {
    var c = sk;
    a.current.memoizedState.isDehydrated && (Kk(a, b).flags |= 256);
    a = Ik(a, b);
    2 !== a && (b = tk, tk = c, null !== b && Fj(b));
    return a;
}
function Fj(a) {
    null === tk ? tk = a : tk.push.apply(tk, a);
}
function Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function Ck(a, b) {
    b &= ~rk;
    b &= ~qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Ek(a) {
    if (0 !== (K & 6)) throw Error(p(327));
    Hk();
    var b = uc(a, 0);
    if (0 === (b & 1)) return Dk(a, B()), null;
    var c = Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = xc(a);
        0 !== d && (b = d, c = Nk(a, d));
    }
    if (1 === c) throw c = pk, Kk(a, 0), Ck(a, b), Dk(a, B()), c;
    if (6 === c) throw Error(p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Pk(a, tk, uk);
    Dk(a, B());
    return null;
}
function Qk(a, b) {
    var c = K;
    K |= 1;
    try {
        return a(b);
    } finally{
        K = c, 0 === K && (Gj = B() + 500, fg && jg());
    }
}
function Rk(a) {
    null !== wk && 0 === wk.tag && 0 === (K & 6) && Hk();
    var b = K;
    K |= 1;
    var c = ok.transition, d = C;
    try {
        if (ok.transition = null, C = 1, a) return a();
    } finally{
        C = d, ok.transition = c, K = b, 0 === (K & 6) && jg();
    }
}
function Hj() {
    fj = ej.current;
    E(ej);
}
function Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, Gf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $f();
                break;
            case 3:
                zh();
                E(Wf);
                E(H);
                Eh();
                break;
            case 5:
                Bh(d);
                break;
            case 4:
                zh();
                break;
            case 13:
                E(L);
                break;
            case 19:
                E(L);
                break;
            case 10:
                ah(d.type._context);
                break;
            case 22:
            case 23:
                Hj();
        }
        c = c.return;
    }
    Q = a;
    Y = a = Pg(a.current, null);
    Z = fj = b;
    T = 0;
    pk = null;
    rk = qk = rh = 0;
    tk = sk = null;
    if (null !== fh) {
        for(b = 0; b < fh.length; b++)if (c = fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        fh = null;
    }
    return a;
}
function Mk(a, b) {
    do {
        var c = Y;
        try {
            $g();
            Fh.current = Rh;
            if (Ih) {
                for(var d = M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                Ih = !1;
            }
            Hh = 0;
            O = N = M = null;
            Jh = !1;
            Kh = 0;
            nk.current = null;
            if (null === c || null === c.return) {
                T = 1;
                pk = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        Vi(y, g, h, f, b);
                        y.mode & 1 && Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            Si(f, l, b);
                            tj();
                            break a;
                        }
                        k = Error(p(426));
                    }
                } else if (I && h.mode & 1) {
                    var J = Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        Vi(J, g, h, f, b);
                        Jg(Ji(k, h));
                        break a;
                    }
                }
                f = k = Ji(k, h);
                4 !== T && (T = 2);
                null === sk ? sk = [
                    f
                ] : sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = Ni(f, k, b);
                            ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === Ri || !Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = Qi(f, h, b);
                                ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            Sk(c);
        } catch (na) {
            b = na;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Jk() {
    var a = mk.current;
    mk.current = Rh;
    return null === a ? Rh : a;
}
function tj() {
    if (0 === T || 3 === T || 2 === T) T = 4;
    null === Q || 0 === (rh & 268435455) && 0 === (qk & 268435455) || Ck(Q, Z);
}
function Ik(a, b) {
    var c = K;
    K |= 2;
    var d = Jk();
    if (Q !== a || Z !== b) uk = null, Kk(a, b);
    for(;;)try {
        Tk();
        break;
    } catch (e) {
        Mk(a, e);
    }
    $g();
    K = c;
    mk.current = d;
    if (null !== Y) throw Error(p(261));
    Q = null;
    Z = 0;
    return T;
}
function Tk() {
    for(; null !== Y;)Uk(Y);
}
function Lk() {
    for(; null !== Y && !cc();)Uk(Y);
}
function Uk(a) {
    var b = Vk(a.alternate, a, fj);
    a.memoizedProps = a.pendingProps;
    null === b ? Sk(a) : Y = b;
    nk.current = null;
}
function Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = Ej(c, b, fj), null !== c) {
                Y = c;
                return;
            }
        } else {
            c = Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                T = 6;
                Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === T && (T = 5);
}
function Pk(a, b, c) {
    var d = C, e = ok.transition;
    try {
        ok.transition = null, C = 1, Wk(a, b, c, d);
    } finally{
        ok.transition = e, C = d;
    }
    return null;
}
function Wk(a, b, c, d) {
    do Hk();
    while (null !== wk);
    if (0 !== (K & 6)) throw Error(p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    Bc(a, f);
    a === Q && (Y = Q = null, Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || vk || (vk = !0, Fk(hc, function() {
        Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = ok.transition;
        ok.transition = null;
        var g = C;
        C = 1;
        var h = K;
        K |= 4;
        nk.current = null;
        Oj(a, c);
        dk(c, a);
        Oe(Df);
        dd = !!Cf;
        Df = Cf = null;
        a.current = c;
        hk(c, a, e);
        dc();
        K = h;
        C = g;
        ok.transition = f;
    } else a.current = c;
    vk && (vk = !1, wk = a, xk = e);
    f = a.pendingLanes;
    0 === f && (Ri = null);
    mc(c.stateNode, d);
    Dk(a, B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if (Oi) throw Oi = !1, a = Pi, Pi = null, a;
    0 !== (xk & 1) && 0 !== a.tag && Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === zk ? yk++ : (yk = 0, zk = a) : yk = 0;
    jg();
    return null;
}
function Hk() {
    if (null !== wk) {
        var a = Dc(xk), b = ok.transition, c = C;
        try {
            ok.transition = null;
            C = 16 > a ? 16 : a;
            if (null === wk) var d = !1;
            else {
                a = wk;
                wk = null;
                xk = 0;
                if (0 !== (K & 6)) throw Error(p(331));
                var e = K;
                K |= 4;
                for(V = a.current; null !== V;){
                    var f = V, g = f.child;
                    if (0 !== (V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for(V = l; null !== V;){
                                    var m = V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, V = q;
                                    else for(; null !== V;){
                                        m = V;
                                        var r = m.sibling, y = m.return;
                                        Sj(m);
                                        if (m === l) {
                                            V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            V = r;
                                            break;
                                        }
                                        V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, V = g;
                    else b: for(; null !== V;){
                        f = V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            V = x;
                            break b;
                        }
                        V = f.return;
                    }
                }
                var w = a.current;
                for(V = w; null !== V;){
                    g = V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, V = u;
                    else b: for(g = w; null !== V;){
                        h = V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    Qj(9, h);
                            }
                        } catch (na) {
                            W(h, h.return, na);
                        }
                        if (h === g) {
                            V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            V = F;
                            break b;
                        }
                        V = h.return;
                    }
                }
                K = e;
                jg();
                if (lc && "function" === typeof lc.onPostCommitFiberRoot) try {
                    lc.onPostCommitFiberRoot(kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            C = c, ok.transition = b;
        }
    }
    return !1;
}
function Xk(a, b, c) {
    b = Ji(c, b);
    b = Ni(a, b, 1);
    a = nh(a, b, 1);
    b = R();
    null !== a && (Ac(a, 1, b), Dk(a, b));
}
function W(a, b, c) {
    if (3 === a.tag) Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ri || !Ri.has(d))) {
                a = Ji(c, a);
                a = Qi(b, a, 1);
                b = nh(b, a, 1);
                a = R();
                null !== b && (Ac(b, 1, a), Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = R();
    a.pingedLanes |= a.suspendedLanes & c;
    Q === a && (Z & c) === c && (4 === T || 3 === T && (Z & 130023424) === Z && 500 > B() - fk ? Kk(a, 0) : rk |= c);
    Dk(a, b);
}
function Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = sc, sc <<= 1, 0 === (sc & 130023424) && (sc = 4194304)));
    var c = R();
    a = ih(a, b);
    null !== a && (Ac(a, b, c), Dk(a, c));
}
function uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    Yk(a, c);
}
function bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error(p(314));
    }
    null !== d && d.delete(b);
    Yk(a, c);
}
var Vk;
Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || Wf.current) dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return dh = !1, yj(a, b, c);
            dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else dh = !1, I && 0 !== (b.flags & 1048576) && ug(b, ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            ij(a, b);
            a = b.pendingProps;
            var e = Yf(b, H.current);
            ch(b, c);
            e = Nh(null, b, d, a, e, c);
            var f = Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, Zf(d) ? (f = !0, cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, kh(b), e.updater = Ei, b.stateNode = e, e._reactInternals = b, Ii(b, d, a, c), b = jj(null, b, d, !0, f, c)) : (b.tag = 0, I && f && vg(b), Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = Zk(d);
                a = Ci(d, a);
                switch(e){
                    case 0:
                        b = cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $i(null, b, d, Ci(d.type, a), c);
                        break a;
                }
                throw Error(p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), hj(a, b, d, e, c);
        case 3:
            a: {
                kj(b);
                if (null === a) throw Error(p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                lh(a, b);
                qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = Ji(Error(p(423)), b);
                        b = lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = Ji(Error(p(424)), b);
                        b = lj(a, b, d, c, e);
                        break a;
                    } else for(yg = Lf(b.stateNode.containerInfo.firstChild), xg = b, I = !0, zg = null, c = Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    Ig();
                    if (d === e) {
                        b = Zi(a, b, c);
                        break a;
                    }
                    Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return Ah(b), null === a && Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, Ef(d, e) ? g = null : null !== f && Ef(d, f) && (b.flags |= 32), gj(a, b), Xi(a, b, g, c), b.child;
        case 6:
            return null === a && Eg(b), null;
        case 13:
            return oj(a, b, c);
        case 4:
            return yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Ug(b, null, d, c) : Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), Yi(a, b, d, e, c);
        case 7:
            return Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                G(Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if (He(f.value, g)) {
                        if (f.children === e.children && !Wf.current) {
                            b = Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error(p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, ch(b, c), e = eh(e), d = d(e), b.flags |= 1, Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = Ci(d, b.pendingProps), e = Ci(d.type, e), $i(a, b, d, e, c);
        case 15:
            return bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), ij(a, b), b.tag = 1, Zf(d) ? (a = !0, cg(b)) : a = !1, ch(b, c), Gi(b, d, e), Ii(b, d, e, c), jj(null, b, d, !0, a, c);
        case 19:
            return xj(a, b, c);
        case 22:
            return dj(a, b, c);
    }
    throw Error(p(156, b.tag));
};
function Fk(a, b) {
    return ac(a, b);
}
function $k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function Bg(a, b, c, d) {
    return new $k(a, b, c, d);
}
function aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function Zk(a) {
    if ("function" === typeof a) return aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Da) return 11;
        if (a === Ga) return 14;
    }
    return 2;
}
function Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ya:
            return Tg(c.children, e, f, b);
        case za:
            g = 8;
            e |= 8;
            break;
        case Aa:
            return a = Bg(12, c, b, e | 2), a.elementType = Aa, a.lanes = f, a;
        case Ea:
            return a = Bg(13, c, b, e), a.elementType = Ea, a.lanes = f, a;
        case Fa:
            return a = Bg(19, c, b, e), a.elementType = Fa, a.lanes = f, a;
        case Ia:
            return pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case Ba:
                    g = 10;
                    break a;
                case Ca:
                    g = 9;
                    break a;
                case Da:
                    g = 11;
                    break a;
                case Ga:
                    g = 14;
                    break a;
                case Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error(p(130, null == a ? a : typeof a, ""));
    }
    b = Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Tg(a, b, c, d) {
    a = Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function pj(a, b, c, d) {
    a = Bg(22, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function Qg(a, b, c) {
    a = Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function Sg(a, b, c) {
    b = Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = zc(0);
    this.expirationTimes = zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function bl(a, b, c, d, e, f, g, h, k) {
    a = new al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    kh(f);
    return a;
}
function cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function dl(a) {
    if (!a) return Vf;
    a = a._reactInternals;
    a: {
        if (Vb(a) !== a || 1 !== a.tag) throw Error(p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if (Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error(p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if (Zf(c)) return bg(a, c, b);
    }
    return b;
}
function el(a, b, c, d, e, f, g, h, k) {
    a = bl(c, d, !0, a, e, f, g, h, k);
    a.context = dl(null);
    c = a.current;
    d = R();
    e = yi(c);
    f = mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    nh(c, f, e);
    a.current.lanes = e;
    Ac(a, e, d);
    Dk(a, d);
    return a;
}
function fl(a, b, c, d) {
    var e = b.current, f = R(), g = yi(e);
    c = dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = nh(e, b, g);
    null !== a && (gi(a, e, g, f), oh(a, e, g));
    return g;
}
function gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function il(a, b) {
    hl(a, b);
    (a = a.alternate) && hl(a, b);
}
function jl() {
    return null;
}
var kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function ll(a) {
    this._internalRoot = a;
}
ml.prototype.render = ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error(p(409));
    fl(a, b, null, null);
};
ml.prototype.unmount = ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        Rk(function() {
            fl(null, a, null, null);
        });
        b[uf] = null;
    }
};
function ml(a) {
    this._internalRoot = a;
}
ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < Qc.length && 0 !== b && b < Qc[c].priority; c++);
        Qc.splice(c, 0, a);
        0 === c && Vc(a);
    }
};
function nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function pl() {}
function ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = gl(g);
                f.call(a);
            };
        }
        var g = el(b, d, a, 0, null, !1, !1, "", pl);
        a._reactRootContainer = g;
        a[uf] = g.current;
        sf(8 === a.nodeType ? a.parentNode : a);
        Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = gl(k);
            h.call(a);
        };
    }
    var k = bl(a, 0, !1, null, null, !1, !1, "", pl);
    a._reactRootContainer = k;
    a[uf] = k.current;
    sf(8 === a.nodeType ? a.parentNode : a);
    Rk(function() {
        fl(b, k, c, d);
    });
    return k;
}
function rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = gl(g);
                h.call(a);
            };
        }
        fl(b, g, a, e);
    } else g = ql(c, b, a, e, d);
    return gl(g);
}
Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = tc(b.pendingLanes);
                0 !== c && (Cc(b, c | 1), Dk(b, B()), 0 === (K & 6) && (Gj = B() + 500, jg()));
            }
            break;
        case 13:
            Rk(function() {
                var b = ih(a, 1);
                if (null !== b) {
                    var c = R();
                    gi(b, a, 1, c);
                }
            }), il(a, 1);
    }
};
Fc = function(a) {
    if (13 === a.tag) {
        var b = ih(a, 134217728);
        if (null !== b) {
            var c = R();
            gi(b, a, 134217728, c);
        }
        il(a, 134217728);
    }
};
Gc = function(a) {
    if (13 === a.tag) {
        var b = yi(a), c = ih(a, b);
        if (null !== c) {
            var d = R();
            gi(c, a, b, d);
        }
        il(a, b);
    }
};
Hc = function() {
    return C;
};
Ic = function(a, b) {
    var c = C;
    try {
        return C = a, b();
    } finally{
        C = c;
    }
};
yb = function(a, b, c) {
    switch(b){
        case "input":
            bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(p(90));
                        Wa(d);
                        bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Qk;
Hb = Rk;
var sl = {
    usingClientEntryPoint: !1,
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Qk
    ]
}, tl = {
    findFiberByHostInstance: Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var ul = {
    bundleType: tl.bundleType,
    version: tl.version,
    rendererPackageName: tl.rendererPackageName,
    rendererConfig: tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: tl.findFiberByHostInstance || jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!vl.isDisabled && vl.supportsFiber) try {
        kc = vl.inject(ul), lc = vl;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = sl;
exports.createPortal = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!nl(b)) throw Error(p(200));
    return cl(a, b, null, c);
};
exports.createRoot = function(a, b) {
    if (!nl(a)) throw Error(p(299));
    var c = !1, d = "", e = kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = bl(a, 1, !1, null, null, c, !1, d, e);
    a[uf] = b.current;
    sf(8 === a.nodeType ? a.parentNode : a);
    return new ll(b);
};
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(p(188));
        a = Object.keys(a).join(",");
        throw Error(p(268, a));
    }
    a = Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a) {
    return Rk(a);
};
exports.hydrate = function(a, b, c) {
    if (!ol(b)) throw Error(p(200));
    return rl(null, a, b, !0, c);
};
exports.hydrateRoot = function(a, b, c) {
    if (!nl(a)) throw Error(p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[uf] = b.current;
    sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new ml(b);
};
exports.render = function(a, b, c) {
    if (!ol(b)) throw Error(p(200));
    return rl(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!ol(a)) throw Error(p(40));
    return a._reactRootContainer ? (Rk(function() {
        rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[uf] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Qk;
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!ol(c)) throw Error(p(200));
    if (null == a || void 0 === a._reactInternals) throw Error(p(38));
    return rl(a, b, c, !1, d);
};
exports.version = "18.3.1-next-f1338f8080-20240426";

},{"5393afc8c463ef07":"bmhQu","ece50e903283a22f":"dHubo"}],"dHubo":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("15840f0beed8ff36");

},{"15840f0beed8ff36":"cUjz3"}],"cUjz3":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
function f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function h(a) {
    return 0 === a.length ? null : a[0];
}
function k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > g(C, c)) n < e && 0 > g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var l = performance;
    exports.unstable_now = function() {
        return l.now();
    };
} else {
    var p = Date, q = p.now();
    exports.unstable_now = function() {
        return p.now() - q;
    };
}
var r = [], t = [], u = 1, v = null, y = 3, z = !1, A = !1, B = !1, D = "function" === typeof setTimeout ? setTimeout : null, E = "function" === typeof clearTimeout ? clearTimeout : null, F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function G(a) {
    for(var b = h(t); null !== b;){
        if (null === b.callback) k(t);
        else if (b.startTime <= a) k(t), b.sortIndex = b.expirationTime, f(r, b);
        else break;
        b = h(t);
    }
}
function H(a) {
    B = !1;
    G(a);
    if (!A) {
        if (null !== h(r)) A = !0, I(J);
        else {
            var b = h(t);
            null !== b && K(H, b.startTime - a);
        }
    }
}
function J(a, b) {
    A = !1;
    B && (B = !1, E(L), L = -1);
    z = !0;
    var c = y;
    try {
        G(b);
        for(v = h(r); null !== v && (!(v.expirationTime > b) || a && !M());){
            var d = v.callback;
            if ("function" === typeof d) {
                v.callback = null;
                y = v.priorityLevel;
                var e = d(v.expirationTime <= b);
                b = exports.unstable_now();
                "function" === typeof e ? v.callback = e : v === h(r) && k(r);
                G(b);
            } else k(r);
            v = h(r);
        }
        if (null !== v) var w = !0;
        else {
            var m = h(t);
            null !== m && K(H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        v = null, y = c, z = !1;
    }
}
var N = !1, O = null, L = -1, P = 5, Q = -1;
function M() {
    return exports.unstable_now() - Q < P ? !1 : !0;
}
function R() {
    if (null !== O) {
        var a = exports.unstable_now();
        Q = a;
        var b = !0;
        try {
            b = O(!0, a);
        } finally{
            b ? S() : (N = !1, O = null);
        }
    } else N = !1;
}
var S;
if ("function" === typeof F) S = function() {
    F(R);
};
else if ("undefined" !== typeof MessageChannel) {
    var T = new MessageChannel, U = T.port2;
    T.port1.onmessage = R;
    S = function() {
        U.postMessage(null);
    };
} else S = function() {
    D(R, 0);
};
function I(a) {
    O = a;
    N || (N = !0, S());
}
function K(a, b) {
    L = D(function() {
        a(exports.unstable_now());
    }, b);
}
exports.unstable_IdlePriority = 5;
exports.unstable_ImmediatePriority = 1;
exports.unstable_LowPriority = 4;
exports.unstable_NormalPriority = 3;
exports.unstable_Profiling = null;
exports.unstable_UserBlockingPriority = 2;
exports.unstable_cancelCallback = function(a) {
    a.callback = null;
};
exports.unstable_continueExecution = function() {
    A || z || (A = !0, I(J));
};
exports.unstable_forceFrameRate = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : P = 0 < a ? Math.floor(1E3 / a) : 5;
};
exports.unstable_getCurrentPriorityLevel = function() {
    return y;
};
exports.unstable_getFirstCallbackNode = function() {
    return h(r);
};
exports.unstable_next = function(a) {
    switch(y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = y;
    }
    var c = y;
    y = b;
    try {
        return a();
    } finally{
        y = c;
    }
};
exports.unstable_pauseExecution = function() {};
exports.unstable_requestPaint = function() {};
exports.unstable_runWithPriority = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = y;
    y = a;
    try {
        return b();
    } finally{
        y = c;
    }
};
exports.unstable_scheduleCallback = function(a, b, c) {
    var d = exports.unstable_now();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, f(t, a), null === h(r) && a === h(t) && (B ? (E(L), L = -1) : B = !0, K(H, c - d))) : (a.sortIndex = e, f(r, a), A || z || (A = !0, I(J)));
    return a;
};
exports.unstable_shouldYield = M;
exports.unstable_wrapCallback = function(a) {
    var b = y;
    return function() {
        var c = y;
        y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            y = c;
        }
    };
};

},{}],"fK2YX":[function() {},{}],"8Y7Ec":[function() {},{}],"bARwf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _appCss = require("./App.css");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _headerProviderCss = require("./components/Navigation/HeaderProvider.css");
var _loadingScreen = require("./components/LoadingScreen");
var _loadingScreenDefault = parcelHelpers.interopDefault(_loadingScreen);
var _caseDetails = require("./components/CaseDetails");
var _caseDetailsDefault = parcelHelpers.interopDefault(_caseDetails);
var _conception = require("./components/Conception");
var _conceptionDefault = parcelHelpers.interopDefault(_conception);
var _authContext = require("./context/AuthContext");
var _enterpriseContext = require("./context/EnterpriseContext");
// Ajoutez cette ligne avec les autres imports
var _navigation = require("./components/Navigation");
var _reactRouterDom = require("react-router-dom");
var _admin = require("./components/Admin/Admin");
var _adminDefault = parcelHelpers.interopDefault(_admin);
var _home = require("./components/Home");
var _homeDefault = parcelHelpers.interopDefault(_home);
var _functionalView1 = require("./components/FunctionalView1");
var _functionalView1Default = parcelHelpers.interopDefault(_functionalView1);
var _acquisition = require("./components/Acquisition");
var _acquisitionDefault = parcelHelpers.interopDefault(_acquisition);
var _physicalModel1 = require("./components/PhysicalModel1");
var _physicalModel1Default = parcelHelpers.interopDefault(_physicalModel1);
var _existingCase = require("./components/ExistingCase");
var _existingCaseDefault = parcelHelpers.interopDefault(_existingCase);
var _decisionalModel1 = require("./components/DecisionalModel1");
var _decisionalModel1Default = parcelHelpers.interopDefault(_decisionalModel1);
var _processView1 = require("./components/ProcessView1");
var _processView1Default = parcelHelpers.interopDefault(_processView1);
var _informationalModel1 = require("./components/InformationalModel1");
var _informationalModel1Default = parcelHelpers.interopDefault(_informationalModel1);
var _environmental1 = require("./components/Environmental1");
var _environmental1Default = parcelHelpers.interopDefault(_environmental1);
var _environmental11 = require("./components/Environmental1_");
var _environmental1Default1 = parcelHelpers.interopDefault(_environmental11);
var _measuringForm = require("./components/MeasuringForm");
var _measuringFormDefault = parcelHelpers.interopDefault(_measuringForm);
var _measuringForm1 = require("./components/MeasuringForm_");
var _measuringFormDefault1 = parcelHelpers.interopDefault(_measuringForm1);
var _leanVSM1 = require("./components/LeanVSM1");
var _leanVSM1Default = parcelHelpers.interopDefault(_leanVSM1);
var _x5S1 = require("./components/X5S1");
var _x5S1Default = parcelHelpers.interopDefault(_x5S1);
var _analysis = require("./components/Analysis");
var _analysisDefault = parcelHelpers.interopDefault(_analysis);
var _analysisBeta = require("./components/AnalysisBeta");
var _analysisBetaDefault = parcelHelpers.interopDefault(_analysisBeta);
var _visualManagement1 = require("./components/VisualManagement1");
var _visualManagement1Default = parcelHelpers.interopDefault(_visualManagement1);
var _objectives = require("./components/Objectives");
var _objectivesDefault = parcelHelpers.interopDefault(_objectives);
var _smed2 = require("./components/SMED2");
var _smed2Default = parcelHelpers.interopDefault(_smed2);
var _smed3 = require("./components/SMED3");
var _smed3Default = parcelHelpers.interopDefault(_smed3);
var _visualManagement2 = require("./components/VisualManagement2");
var _visualManagement2Default = parcelHelpers.interopDefault(_visualManagement2);
var _kaizen3 = require("./components/Kaizen3");
var _kaizen3Default = parcelHelpers.interopDefault(_kaizen3);
var _visualManagement3 = require("./components/VisualManagement3");
var _visualManagement3Default = parcelHelpers.interopDefault(_visualManagement3);
var _inscription = require("./components/Inscription");
var _inscriptionDefault = parcelHelpers.interopDefault(_inscription);
var _clientConsommateur2 = require("./components/ClientConsommateur2");
var _clientConsommateur2Default = parcelHelpers.interopDefault(_clientConsommateur2);
var _clientConsommateur21 = require("./components/ClientConsommateur2_");
var _clientConsommateur2Default1 = parcelHelpers.interopDefault(_clientConsommateur21);
var _social1 = require("./components/Social1");
var _social1Default = parcelHelpers.interopDefault(_social1);
var _social11 = require("./components/Social1_");
var _social1Default1 = parcelHelpers.interopDefault(_social11);
var _modernization1 = require("./components/Modernization1");
var _modernization1Default = parcelHelpers.interopDefault(_modernization1);
var _modernization11 = require("./components/Modernization1_");
var _modernization1Default1 = parcelHelpers.interopDefault(_modernization11);
var _clientConsommateur1 = require("./components/ClientConsommateur1");
var _clientConsommateur1Default = parcelHelpers.interopDefault(_clientConsommateur1);
var _clientConsommateur11 = require("./components/ClientConsommateur1_");
var _clientConsommateur1Default1 = parcelHelpers.interopDefault(_clientConsommateur11);
var _leadTime1 = require("./components/LeadTime1");
var _leadTime1Default = parcelHelpers.interopDefault(_leadTime1);
var _leadTime11 = require("./components/LeadTime1_");
var _leadTime1Default1 = parcelHelpers.interopDefault(_leadTime11);
var _cost1 = require("./components/Cost1");
var _cost1Default = parcelHelpers.interopDefault(_cost1);
var _cost11 = require("./components/Cost1_");
var _cost1Default1 = parcelHelpers.interopDefault(_cost11);
var _quality1 = require("./components/Quality1");
var _quality1Default = parcelHelpers.interopDefault(_quality1);
var _quality11 = require("./components/Quality1_");
var _quality1Default1 = parcelHelpers.interopDefault(_quality11);
var _environmental2 = require("./components/Environmental2");
var _environmental2Default = parcelHelpers.interopDefault(_environmental2);
var _environmental21 = require("./components/Environmental2_");
var _environmental2Default1 = parcelHelpers.interopDefault(_environmental21);
var _environmental3 = require("./components/Environmental3");
var _environmental3Default = parcelHelpers.interopDefault(_environmental3);
var _environmental31 = require("./components/Environmental3_");
var _environmental3Default1 = parcelHelpers.interopDefault(_environmental31);
var _social2 = require("./components/Social2");
var _social2Default = parcelHelpers.interopDefault(_social2);
var _social21 = require("./components/Social2_");
var _social2Default1 = parcelHelpers.interopDefault(_social21);
var _modernization2 = require("./components/Modernization2");
var _modernization2Default = parcelHelpers.interopDefault(_modernization2);
var _modernization21 = require("./components/Modernization2_");
var _modernization2Default1 = parcelHelpers.interopDefault(_modernization21);
var _cost2 = require("./components/Cost2");
var _cost2Default = parcelHelpers.interopDefault(_cost2);
var _cost21 = require("./components/Cost2_");
var _cost2Default1 = parcelHelpers.interopDefault(_cost21);
var _leadTime2 = require("./components/LeadTime2");
var _leadTime2Default = parcelHelpers.interopDefault(_leadTime2);
var _leadTime21 = require("./components/LeadTime2_");
var _leadTime2Default1 = parcelHelpers.interopDefault(_leadTime21);
var _quality6 = require("./components/Quality6");
var _quality6Default = parcelHelpers.interopDefault(_quality6);
var _quality61 = require("./components/Quality6_");
var _quality6Default1 = parcelHelpers.interopDefault(_quality61);
var _informationalModel3 = require("./components/InformationalModel3");
var _informationalModel3Default = parcelHelpers.interopDefault(_informationalModel3);
var _informationalModel2 = require("./components/InformationalModel2");
var _informationalModel2Default = parcelHelpers.interopDefault(_informationalModel2);
var _processView2 = require("./components/ProcessView2");
var _processView2Default = parcelHelpers.interopDefault(_processView2);
var _quality2 = require("./components/Quality2");
var _quality2Default = parcelHelpers.interopDefault(_quality2);
var _quality21 = require("./components/Quality2_");
var _quality2Default1 = parcelHelpers.interopDefault(_quality21);
var _processView3 = require("./components/ProcessView3");
var _processView3Default = parcelHelpers.interopDefault(_processView3);
var _decisionalView2 = require("./components/DecisionalView2");
var _decisionalView2Default = parcelHelpers.interopDefault(_decisionalView2);
var _physicalModel2 = require("./components/PhysicalModel2");
var _physicalModel2Default = parcelHelpers.interopDefault(_physicalModel2);
var _decisionalView3 = require("./components/DecisionalView3");
var _decisionalView3Default = parcelHelpers.interopDefault(_decisionalView3);
var _quality5 = require("./components/Quality5");
var _quality5Default = parcelHelpers.interopDefault(_quality5);
var _quality51 = require("./components/Quality5_");
var _quality5Default1 = parcelHelpers.interopDefault(_quality51);
var _physicalModel3 = require("./components/PhysicalModel3");
var _physicalModel3Default = parcelHelpers.interopDefault(_physicalModel3);
var _functionnalView2 = require("./components/FunctionnalView2");
var _functionnalView2Default = parcelHelpers.interopDefault(_functionnalView2);
var _functionnalView3 = require("./components/FunctionnalView3");
var _functionnalView3Default = parcelHelpers.interopDefault(_functionnalView3);
var _functionnalView4 = require("./components/FunctionnalView4");
var _functionnalView4Default = parcelHelpers.interopDefault(_functionnalView4);
var _loadingPage = require("./components/LoadingPage");
var _loadingPageDefault = parcelHelpers.interopDefault(_loadingPage);
var _kaizen1 = require("./components/Kaizen1");
var _kaizen1Default = parcelHelpers.interopDefault(_kaizen1);
var _existingSystems = require("./components/ExistingSystems");
var _existingSystemsDefault = parcelHelpers.interopDefault(_existingSystems);
var _kanban1 = require("./components/Kanban1");
var _kanban1Default = parcelHelpers.interopDefault(_kanban1);
var _leanVSM = require("./components/LeanVSM");
var _leanVSMDefault = parcelHelpers.interopDefault(_leanVSM);
var _smed1 = require("./components/SMED1");
var _smed1Default = parcelHelpers.interopDefault(_smed1);
var _x5S = require("./components/X5S");
var _x5SDefault = parcelHelpers.interopDefault(_x5S);
var _kaizen12 = require("./components/Kaizen12");
var _kaizen12Default = parcelHelpers.interopDefault(_kaizen12);
var _quality4 = require("./components/Quality4");
var _quality4Default = parcelHelpers.interopDefault(_quality4);
var _quality41 = require("./components/Quality4_");
var _quality4Default1 = parcelHelpers.interopDefault(_quality41);
var _kaizen = require("./components/Kaizen");
var _kaizenDefault = parcelHelpers.interopDefault(_kaizen);
var _smed = require("./components/SMED");
var _smedDefault = parcelHelpers.interopDefault(_smed);
var _visualManagement = require("./components/VisualManagement");
var _visualManagementDefault = parcelHelpers.interopDefault(_visualManagement);
var _kanban = require("./components/Kanban");
var _kanbanDefault = parcelHelpers.interopDefault(_kanban);
var _kaizen2 = require("./components/Kaizen2");
var _kaizen2Default = parcelHelpers.interopDefault(_kaizen2);
var _kanban3 = require("./components/Kanban3");
var _kanban3Default = parcelHelpers.interopDefault(_kanban3);
var _mesureDePerformancesFutures = require("./components/MesureDePerformancesFutures");
var _mesureDePerformancesFuturesDefault = parcelHelpers.interopDefault(_mesureDePerformancesFutures);
var _x5S2 = require("./components/X5s2");
var _x5S2Default = parcelHelpers.interopDefault(_x5S2);
var _kanban2 = require("./components/Kanban2");
var _kanban2Default = parcelHelpers.interopDefault(_kanban2);
var _x5S3 = require("./components/X5s3");
var _x5S3Default = parcelHelpers.interopDefault(_x5S3);
var _leanVSM3 = require("./components/LeanVSM3");
var _leanVSM3Default = parcelHelpers.interopDefault(_leanVSM3);
var _leanVSM2 = require("./components/LeanVSM2");
var _leanVSM2Default = parcelHelpers.interopDefault(_leanVSM2);
var _kaizen11 = require("./components/Kaizen11");
var _kaizen11Default = parcelHelpers.interopDefault(_kaizen11);
var _quality3 = require("./components/Quality3");
var _quality3Default = parcelHelpers.interopDefault(_quality3);
var _quality31 = require("./components/Quality3_");
var _quality3Default1 = parcelHelpers.interopDefault(_quality31);
var _leanVSM4 = require("./components/LeanVSM4");
var _leanVSM4Default = parcelHelpers.interopDefault(_leanVSM4);
var _mesureDePerformancesFutures1 = require("./components/MesureDePerformancesFutures1");
var _mesureDePerformancesFutures1Default = parcelHelpers.interopDefault(_mesureDePerformancesFutures1);
var _existingSystems2 = require("./components/ExistingSystems2");
var _existingSystems2Default = parcelHelpers.interopDefault(_existingSystems2);
var _environmental5 = require("./components/Environmental5");
var _environmental5Default = parcelHelpers.interopDefault(_environmental5);
var _environmental51 = require("./components/Environmental5_");
var _environmental5Default1 = parcelHelpers.interopDefault(_environmental51);
var _social3 = require("./components/Social3");
var _social3Default = parcelHelpers.interopDefault(_social3);
var _social31 = require("./components/Social3_");
var _social3Default1 = parcelHelpers.interopDefault(_social31);
var _environmental4 = require("./components/Environmental4");
var _environmental4Default = parcelHelpers.interopDefault(_environmental4);
var _environmental41 = require("./components/Environmental4_");
var _environmental4Default1 = parcelHelpers.interopDefault(_environmental41);
var _modernization3 = require("./components/Modernization3");
var _modernization3Default = parcelHelpers.interopDefault(_modernization3);
var _modernization31 = require("./components/Modernization3_");
var _modernization3Default1 = parcelHelpers.interopDefault(_modernization31);
var _social4 = require("./components/Social4");
var _social4Default = parcelHelpers.interopDefault(_social4);
var _social41 = require("./components/Social4_");
var _social4Default1 = parcelHelpers.interopDefault(_social41);
var _social6 = require("./components/Social6");
var _social6Default = parcelHelpers.interopDefault(_social6);
var _social61 = require("./components/Social6_");
var _social6Default1 = parcelHelpers.interopDefault(_social61);
var _social5 = require("./components/Social5");
var _social5Default = parcelHelpers.interopDefault(_social5);
var _social51 = require("./components/Social5_");
var _social5Default1 = parcelHelpers.interopDefault(_social51);
var _modernization4 = require("./components/Modernization4");
var _modernization4Default = parcelHelpers.interopDefault(_modernization4);
var _modernization41 = require("./components/Modernization4_");
var _modernization4Default1 = parcelHelpers.interopDefault(_modernization41);
var _clientConsommateur3 = require("./components/ClientConsommateur3");
var _clientConsommateur3Default = parcelHelpers.interopDefault(_clientConsommateur3);
var _clientConsommateur31 = require("./components/ClientConsommateur3_");
var _clientConsommateur3Default1 = parcelHelpers.interopDefault(_clientConsommateur31);
var _references = require("./components/References");
var _referencesDefault = parcelHelpers.interopDefault(_references);
var _curPerformance = require("./components/CurPerformance");
var _curPerformanceDefault = parcelHelpers.interopDefault(_curPerformance);
var _curperformance = require("./components/Curperformance_");
var _curperformanceDefault = parcelHelpers.interopDefault(_curperformance);
var _leadTime = require("./components/LeadTime");
var _leadTimeDefault = parcelHelpers.interopDefault(_leadTime);
var _cost = require("./components/Cost");
var _costDefault = parcelHelpers.interopDefault(_cost);
var _modernization = require("./components/Modernization");
var _modernizationDefault = parcelHelpers.interopDefault(_modernization);
var _login = require("./components/Login/Login");
var _loginDefault = parcelHelpers.interopDefault(_login);
var _analysis1 = require("./components/Analysis1/Analysis");
var _analysisDefault1 = parcelHelpers.interopDefault(_analysis1);
var _implementation = require("./components/Implementation");
var _implementationDefault = parcelHelpers.interopDefault(_implementation);
var _pdfUploader = require("./components/PdfUploader");
var _pdfUploaderDefault = parcelHelpers.interopDefault(_pdfUploader);
var _companyCases = require("./components/CompanyCases");
var _companyCasesDefault = parcelHelpers.interopDefault(_companyCases);
var _savingUploadPage = require("./components/SavingUploadPage");
var _savingUploadPageDefault = parcelHelpers.interopDefault(_savingUploadPage);
var _compareCases = require("./components/CompareCases");
var _compareCasesDefault = parcelHelpers.interopDefault(_compareCases);
const AdminRoute = ({ children, ...rest })=>{
    const { isAuthenticated, isAdmin } = (0, _authContext.useAuth)();
    console.log("AdminRoute - \xe0\u2030tat d'authentification:", isAuthenticated, "Est admin:", isAdmin);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
        ...rest,
        render: ({ location })=>isAuthenticated && isAdmin ? children : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Redirect), {
                to: {
                    pathname: isAuthenticated ? "/home" : "/",
                    state: {
                        from: location
                    }
                }
            })
    });
};
// Composant PrivateRoute pour protéger les routes
const PrivateRoute = ({ children, ...rest })=>{
    const { isAuthenticated } = (0, _authContext.useAuth)();
    console.log("PrivateRoute - \xe0\u2030tat d'authentification:", isAuthenticated);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
        ...rest,
        render: ({ location })=>isAuthenticated ? children : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Redirect), {
                to: {
                    pathname: "/",
                    state: {
                        from: location
                    }
                }
            })
    });
};
function App() {
    const [loading, setLoading] = (0, _react.useState)(true);
    // à€ ajouter dans la fonction App(), après la déclaration de l'état loading
    const [performanceData, setPerformanceData] = (0, _react.useState)({
        currentResults: {},
        enterpriseData: {}
    });
    const handleLoadingComplete = ()=>{
        setLoading(false);
    };
    // à€ ajouter dans la fonction App(), après les autres useEffect
    (0, _react.useEffect)(()=>{
        // Récupérer l'ID de l'entreprise depuis le localStorage
        const enterpriseId = localStorage.getItem('enterpriseId');
        // Fonctions pour récupérer les données si l'ID existe
        if (enterpriseId) {
            const fetchData = async ()=>{
                try {
                    // 1. Récupérer les scores
                    const apiUrl = `${"/api"}/api/enterprise-scores/${enterpriseId}`;
                    const response = await fetch(apiUrl, {
                        headers: {
                            "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
                        }
                    });
                    if (response.ok) {
                        const data = await response.json();
                        console.log("Scores r\xe9cup\xe9r\xe9s avec succ\xe8s:", data);
                        // 2. Récupérer les informations de l'entreprise
                        const enterpriseUrl = `${"/api"}/api/enterprise/${enterpriseId}`;
                        const enterpriseResponse = await fetch(enterpriseUrl, {
                            headers: {
                                "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
                            }
                        });
                        if (enterpriseResponse.ok) {
                            const enterpriseData = await enterpriseResponse.json();
                            console.log("Donn\xe9es entreprise r\xe9cup\xe9r\xe9es:", enterpriseData);
                            // 3. Mettre à  jour l'état avec les données
                            setPerformanceData({
                                currentResults: data,
                                enterpriseData: enterpriseData
                            });
                        }
                    }
                } catch (err) {
                    console.error("Erreur lors de la r\xe9cup\xe9ration des donn\xe9es de performance:", err);
                }
            };
            fetchData();
        }
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _authContext.AuthProvider), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _enterpriseContext.EnterpriseProvider), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    loading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loadingScreenDefault.default), {
                        onLoadingComplete: handleLoadingComplete
                    }),
                    !loading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.BrowserRouter), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navigation.HeaderProvider), {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Switch), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                        exact: true,
                                        path: "/",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loginDefault.default), {})
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                        path: "/login",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loginDefault.default), {})
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/analysis1",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _analysisDefault1.default), {})
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/admin",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _adminDefault.default), {})
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/connexion",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Redirect), {
                                            to: "/"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/conception",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _conceptionDefault.default), {})
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/implementation",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _implementationDefault.default), {})
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/home",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _homeDefault.default), {
                                            ...homeData
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/functional-view-1",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _functionalView1Default.default), {
                                            ...functionalView1Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/acquisition",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _acquisitionDefault.default), {
                                            ...acquisitionData
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/physical-model-1",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _physicalModel1Default.default), {
                                            ...physicalModel1Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/existing-case",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _existingCaseDefault.default), {
                                            x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
                                            existingCase: "Existing Case",
                                            frame11622Props: existingCaseData.frame11622Props
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/decisional-model-1",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _decisionalModel1Default.default), {
                                            ...decisionalModel1Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/pdf-uploader",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pdfUploaderDefault.default), {})
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/process-view-1",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _processView1Default.default), {
                                            ...processView1Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/informational-model-1",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _informationalModel1Default.default), {
                                            ...informationalModel1Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/environmental-1",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _environmental1Default.default), {
                                            ...environmental1Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/environmental-1_",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _environmental1Default1.default), {
                                            ...environmental1Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/measuring-form",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _measuringFormDefault.default), {
                                            ...measuringFormData
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/measuring-form_",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _measuringFormDefault1.default), {
                                            ...measuringFormData
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/lean-vsm-1",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _leanVSM1Default.default), {
                                            ...leanVSM1Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/5s-1",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _x5S1Default.default), {
                                            ...x5S1Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/analysis",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _analysisDefault.default), {
                                            ...analysisData
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/analysisbeta",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _analysisBetaDefault.default), {
                                            ...analysisData
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/visual-management-1",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _visualManagement1Default.default), {
                                            ...visualManagement1Data
                                        })
                                    }),
                                    "s",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/objectives",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _objectivesDefault.default), {
                                            ...objectivesData
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/smed-2",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _smed2Default.default), {
                                            ...sMED2Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/smed-3",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _smed3Default.default), {
                                            ...sMED3Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/visual-management-2",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _visualManagement2Default.default), {
                                            ...visualManagement2Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/kaizen-3",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kaizen3Default.default), {
                                            ...kaizen3Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/compare-cases",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _compareCasesDefault.default), {
                                            ...(0, _compareCasesDefault.default)
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/visual-management-3",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _visualManagement3Default.default), {
                                            x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
                                            pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
                                            goOnToTheNextStep: "Go on to the next Step",
                                            navItems2Props: visualManagement3Data.navItems2Props,
                                            navItems3Props: visualManagement3Data.navItems3Props,
                                            toggleProps: visualManagement3Data.toggleProps
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                        path: "/inscription",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inscriptionDefault.default), {
                                            ...inscriptionData
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/client-consommateur-2",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clientConsommateur2Default.default), {
                                            ...clientConsommateur2Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/client-consommateur-2_",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clientConsommateur2Default1.default), {
                                            ...clientConsommateur2Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/social-1",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _social1Default.default), {
                                            ...social1Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/social-1_",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _social1Default1.default), {
                                            ...social1Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/modernization-1",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modernization1Default.default), {
                                            ...modernization1Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/modernization-1_",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modernization1Default1.default), {
                                            ...modernization1Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/client-consommateur-1",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clientConsommateur1Default.default), {
                                            ...clientConsommateur1Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/client-consommateur-1_",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clientConsommateur1Default1.default), {
                                            ...clientConsommateur1Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/lead-time-1",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _leadTime1Default.default), {
                                            ...leadTime1Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/lead-time-1_",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _leadTime1Default1.default), {
                                            ...leadTime1Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/cost-1",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cost1Default.default), {
                                            ...cost1Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/cost-1_",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cost1Default1.default), {
                                            ...cost1Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/quality-1",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _quality1Default.default), {
                                            ...quality1Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/quality-1_",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _quality1Default1.default), {
                                            ...quality1Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/environmental-2",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _environmental2Default.default), {
                                            ...environmental2Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/environmental-2_",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _environmental2Default1.default), {
                                            ...environmental2Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/environmental-3",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _environmental3Default.default), {
                                            ...environmental3Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/environmental-3_",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _environmental3Default1.default), {
                                            ...environmental3Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/social-2",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _social2Default.default), {
                                            ...social2Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/social-2_",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _social2Default1.default), {
                                            ...social2Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/modernization-2",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modernization2Default.default), {
                                            ...modernization2Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/modernization-2_",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modernization2Default1.default), {
                                            ...modernization2Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/cost-2",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cost2Default.default), {
                                            ...cost2Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/cost-2_",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cost2Default1.default), {
                                            ...cost2Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/lead-time-2",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _leadTime2Default.default), {
                                            ...leadTime2Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/lead-time-2_",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _leadTime2Default1.default), {
                                            ...leadTime2Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/quality-6",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _quality6Default.default), {
                                            ...quality6Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/quality-6_",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _quality6Default1.default), {
                                            ...quality6Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/informational-model-3",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _informationalModel3Default.default), {
                                            x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
                                            pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
                                            navItems2Props: informationalModel3Data.navItems2Props,
                                            navItems3Props: informationalModel3Data.navItems3Props,
                                            toggleProps: informationalModel3Data.toggleProps
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/informational-model-2",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _informationalModel2Default.default), {
                                            ...informationalModel2Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/process-view-2",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _processView2Default.default), {
                                            ...processView2Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/quality-2",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _quality2Default.default), {
                                            ...quality2Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/quality-2_",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _quality2Default1.default), {
                                            ...quality2Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/process-view-3",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _processView3Default.default), {
                                            x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
                                            pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
                                            informationalModel: "Informational Model",
                                            navItems2Props: processView3Data.navItems2Props,
                                            navItems3Props: processView3Data.navItems3Props,
                                            toggleProps: processView3Data.toggleProps
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/decisional-view-2",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _decisionalView2Default.default), {
                                            ...decisionalView2Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/physical-model-2",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _physicalModel2Default.default), {
                                            ...physicalModel2Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/decisional-view-3",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _decisionalView3Default.default), {
                                            ...decisionalView3Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/quality-5",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _quality5Default.default), {
                                            ...quality5Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/quality-5_",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _quality5Default1.default), {
                                            ...quality5Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/physical-model-3",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _physicalModel3Default.default), {
                                            ...physicalModel3Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/functionnal-view-2",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _functionnalView2Default.default), {
                                            x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
                                            pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
                                            navItems2Props: functionnalView2Data.navItems2Props,
                                            navItems3Props: functionnalView2Data.navItems3Props,
                                            frame922Props: functionnalView2Data.frame922Props,
                                            frame93Props: functionnalView2Data.frame93Props,
                                            toggleProps: functionnalView2Data.toggleProps
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/functionnal-view-3",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _functionnalView3Default.default), {
                                            ...functionnalView3Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/functionnal-view-4",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _functionnalView4Default.default), {
                                            ...functionnalView4Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/loading-page",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loadingPageDefault.default), {
                                            x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
                                            inViewOfTheAnswe: "IN VIEW OF THE ANSWERS TO THE PREVIOUS QUESTIONNAIRES, WE PROPOSE TO MAKE THE FOLLOWING MODELS",
                                            navItems3Props: loadingPageData.navItems3Props,
                                            frame112Props: loadingPageData.frame112Props
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/kaizen-1",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kaizen1Default.default), {
                                            ...kaizen1Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/existing-systems-2",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _existingSystemsDefault.default), {
                                            ...existingSystemsData
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/kanban-1",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kanban1Default.default), {
                                            ...kanban1Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/lean-vsm",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _leanVSMDefault.default), {
                                            ...leanVSMData
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/smed-1",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _smed1Default.default), {
                                            ...sMED1Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/5s",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _x5SDefault.default), {
                                            ...x5SData
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/kaizen1",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kaizen12Default.default), {
                                            ...kaizen12Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/quality-4",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _quality4Default.default), {
                                            ...quality4Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/quality-4_",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _quality4Default1.default), {
                                            ...quality4Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/kaizen",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kaizenDefault.default), {
                                            ...kaizenData
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/smed",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _smedDefault.default), {
                                            ...sMEDData
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/visual-management",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _visualManagementDefault.default), {
                                            ...visualManagementData
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/kanban",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kanbanDefault.default), {
                                            ...kanbanData
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/kaizen-2",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kaizen2Default.default), {
                                            ...kaizen2Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/kanban-3",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kanban3Default.default), {
                                            x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
                                            pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
                                            kaizen: "Kaizen",
                                            navItems3Props: kanban3Data.navItems3Props,
                                            frame101Props: kanban3Data.frame101Props,
                                            frame102Props: kanban3Data.frame102Props,
                                            toggleProps: kanban3Data.toggleProps
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/mesure-de-performances-futures",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mesureDePerformancesFuturesDefault.default), {
                                            ...mesureDePerformancesFuturesData
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/5s-2",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _x5S2Default.default), {
                                            ...x5s2Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/kanban-2",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kanban2Default.default), {
                                            ...kanban2Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/5s-3",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _x5S3Default.default), {
                                            ...x5s3Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/lean-vsm-3",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _leanVSM3Default.default), {
                                            ...leanVSM3Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/lean-vsm-2",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _leanVSM2Default.default), {
                                            ...leanVSM2Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/kaizen1-1",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kaizen11Default.default), {
                                            ...kaizen11Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/quality-3",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _quality3Default.default), {
                                            ...quality3Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/quality-3_",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _quality3Default1.default), {
                                            ...quality3Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/lean-vsm-4",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _leanVSM4Default.default), {
                                            ...leanVSM4Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/mesure-de-performances-futures-1",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mesureDePerformancesFutures1Default.default), {
                                            ...mesureDePerformancesFutures1Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/existing-systems",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _existingSystems2Default.default), {
                                            ...existingSystems2Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/environmental-5",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _environmental5Default.default), {
                                            ...environmental5Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/environmental-5_",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _environmental5Default1.default), {
                                            ...environmental5Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/case-details/:id",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _caseDetailsDefault.default), {})
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/social-3",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _social3Default.default), {
                                            ...social3Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/social-3_",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _social3Default1.default), {
                                            ...social3Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/environmental-4",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _environmental4Default.default), {
                                            ...environmental4Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/environmental-4_",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _environmental4Default1.default), {
                                            ...environmental4Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/modernization-3",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modernization3Default.default), {
                                            ...modernization3Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/modernization-3_",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modernization3Default1.default), {
                                            ...modernization3Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/social-4",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _social4Default.default), {
                                            ...social4Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/social-4_",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _social4Default1.default), {
                                            ...social4Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/social-6",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _social6Default.default), {
                                            ...social6Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/social-6_",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _social6Default1.default), {
                                            ...social6Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/social-5",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _social5Default.default), {
                                            ...social5Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/social-5_",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _social5Default1.default), {
                                            ...social5Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/modernization-4",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modernization4Default.default), {
                                            ...modernization4Data
                                        })
                                    }),
                                    "*",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/modernization-4_",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modernization4Default1.default), {
                                            ...modernization4Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/client-consommateur-3",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clientConsommateur3Default.default), {
                                            ...clientConsommateur3Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/client-consommateur-3_",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clientConsommateur3Default1.default), {
                                            ...clientConsommateur3Data
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/references",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _referencesDefault.default), {
                                            ...referencesData
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/cur-performance",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _curPerformanceDefault.default), {
                                            x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
                                            resultPropositions: "Result & Propositions",
                                            place: "Back",
                                            formalismesEnFonct: "FORMALISMES  EN FONCTION DES PROBL\xe0\u02C6MES TROUV\xe0\u2030S",
                                            navItems3Props: curPerformanceData.navItems3Props,
                                            frame11332Props: curPerformanceData.frame11332Props,
                                            currentResults: performanceData.currentResults,
                                            enterpriseData: performanceData.enterpriseData
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/cur-performance_",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _curperformanceDefault.default), {
                                            x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
                                            resultPropositions: "Result & Propositions",
                                            place: "Back",
                                            formalismesEnFonct: "FORMALISMES  EN FONCTION DES PROBL\xe0\u02C6MES TROUV\xe0\u2030S",
                                            navItems3Props: curPerformanceData.navItems3Props,
                                            frame11332Props: curPerformanceData.frame11332Props,
                                            currentResults: performanceData.currentResults,
                                            enterpriseData: performanceData.enterpriseData
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/lead-time",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _leadTimeDefault.default), {
                                            ...leadTimeData
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/cost",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _costDefault.default), {
                                            ...costData
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/modernization",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modernizationDefault.default), {
                                            ...modernizationData
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                        path: "/company-cases/:companyId",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _companyCasesDefault.default), {})
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivateRoute, {
                                        path: "/saving-upload-page",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _savingUploadPageDefault.default), {
                                            ...connexionData
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        })
    });
}
exports.default = App;
const connexionData = {
    polygon3: "/img/polygon-3@2x.png",
    aerialViewContainerCargoShipSea1: "/img/aerial-view-container-cargo-ship-sea-1.png",
    subtract: "/img/subtract.png",
    polygon1: "/img/polygon-1@2x.png",
    polygon2: "/img/polygon-2@2x.png",
    login1: "login",
    login2: "If you din\xe2\u20AC\u2122t have an account",
    frame126: "/img/1200px-logo-icam---20081@2x.png"
};
const frame116221Data = {
    children: "Decisional Model"
};
const frame117221Data = {
    children: "Process view"
};
const frame11361Data = {
    children: "Informational model"
};
const navItems452Data = {
    frame1162Props: frame116221Data,
    frame1172Props: frame117221Data,
    frame1136Props: frame11361Data
};
const tableHeader1Data = {
    children: ""
};
const tableHeader2Data = {
    children: "Company",
    className: "table-header-4"
};
const tableNumberBase41Data = {
    bottomLine: "/img/bottom-line-3@2x.png",
    leftLine: "/img/left-line-3@2x.png",
    rightLine: "/img/right-line-3@2x.png",
    className: ""
};
const tableNumberPrimaryKey21Data = {
    tableNumberBase4Props: tableNumberBase41Data
};
const key3Data = {
    className: "key-2"
};
const tableNumberBase51Data = {
    type: "property1:string",
    bottomLine: "/img/bottom-line-4@2x.png",
    leftLine: "/img/left-line-4@2x.png",
    rightLine: "/img/right-line-4@2x.png",
    className: "",
    keyProps: key3Data
};
const tableTextBase21Data = {
    tableNumberBase5Props: tableNumberBase51Data
};
const key4Data = {
    className: "key-3"
};
const tableNumberBase61Data = {
    bottomLine: "/img/bottom-line-5@2x.png",
    leftLine: "/img/left-line-5@2x.png",
    rightLine: "/img/right-line-5@2x.png",
    className: "",
    keyProps: key4Data
};
const tableNumberBaseNull21Data = {
    tableNumberBase6Props: tableNumberBase61Data
};
const tableTextBaseNull21Data = {
    tableNumberBaseNull2Props: tableNumberBaseNull21Data
};
const crewMember1Data = {
    tableHeaderProps: tableHeader2Data,
    tableNumberPrimaryKey2Props: tableNumberPrimaryKey21Data,
    tableTextBase2Props: tableTextBase21Data,
    tableTextBaseNull2Props: tableTextBaseNull21Data
};
const tableHeader3Data = {
    children: "Insurances",
    className: "table-header-5"
};
const tableNumberBase42Data = {
    bottomLine: "/img/bottom-line@2x.png",
    leftLine: "/img/left-line@2x.png",
    rightLine: "/img/right-line@2x.png",
    className: ""
};
const tableNumberPrimaryKey22Data = {
    tableNumberBase4Props: tableNumberBase42Data
};
const key5Data = {
    className: "key-4"
};
const tableNumberBase71Data = {
    keyProps: key5Data
};
const tableTextBase31Data = {
    tableNumberBase7Props: tableNumberBase71Data
};
const key6Data = {
    className: "key-5"
};
const tableNumberBase62Data = {
    bottomLine: "/img/bottom-line-2@2x.png",
    leftLine: "/img/left-line-2@2x.png",
    rightLine: "/img/right-line-2@2x.png",
    className: "",
    keyProps: key6Data
};
const tableNumberBaseNull22Data = {
    tableNumberBase6Props: tableNumberBase62Data
};
const tableTextBaseNull22Data = {
    tableNumberBaseNull2Props: tableNumberBaseNull22Data
};
const crewMember21Data = {
    tableHeaderProps: tableHeader3Data,
    tableNumberPrimaryKey2Props: tableNumberPrimaryKey22Data,
    tableTextBase3Props: tableTextBase31Data,
    tableTextBaseNull2Props: tableTextBaseNull22Data
};
const tableHeader4Data = {
    children: "Cars",
    className: "table-header-6"
};
const tableNumberBase43Data = {
    bottomLine: "/img/bottom-line@2x.png",
    leftLine: "/img/left-line@2x.png",
    rightLine: "/img/right-line@2x.png",
    className: ""
};
const tableNumberPrimaryKey23Data = {
    tableNumberBase4Props: tableNumberBase43Data
};
const key7Data = {
    className: "key-6"
};
const tableNumberBase52Data = {
    type: "registrationplate:string",
    bottomLine: "/img/bottom-line-10@2x.png",
    leftLine: "/img/left-line-10@2x.png",
    rightLine: "/img/right-line-10@2x.png",
    className: "table-number-base-10",
    keyProps: key7Data
};
const tableTextBase22Data = {
    className: "table-text-base-4",
    tableNumberBase5Props: tableNumberBase52Data
};
const key8Data = {
    className: "key-7"
};
const tableNumberBase81Data = {
    keyProps: key8Data
};
const tableNumberBaseNull31Data = {
    tableNumberBase8Props: tableNumberBase81Data
};
const tableTextBaseNull31Data = {
    tableNumberBaseNull3Props: tableNumberBaseNull31Data
};
const crewMember31Data = {
    tableHeaderProps: tableHeader4Data,
    tableNumberPrimaryKey2Props: tableNumberPrimaryKey23Data,
    tableTextBase2Props: tableTextBase22Data,
    tableTextBaseNull3Props: tableTextBaseNull31Data
};
const tableHeader5Data = {
    children: "Employees",
    className: "table-header-7"
};
const tableNumberBase44Data = {
    bottomLine: "/img/bottom-line-12@2x.png",
    leftLine: "/img/left-line-12@2x.png",
    rightLine: "/img/right-line-12@2x.png",
    className: ""
};
const tableNumberPrimaryKey24Data = {
    tableNumberBase4Props: tableNumberBase44Data
};
const key9Data = {
    className: "key-8"
};
const tableNumberBase53Data = {
    type: "name:string",
    bottomLine: "/img/bottom-line-13@2x.png",
    leftLine: "/img/left-line-13@2x.png",
    rightLine: "/img/right-line-13@2x.png",
    className: "table-number-base-8-2",
    keyProps: key9Data
};
const tableTextBase23Data = {
    tableNumberBase5Props: tableNumberBase53Data
};
const key10Data = {
    className: "key-9"
};
const tableNumberBase63Data = {
    bottomLine: "/img/bottom-line-14@2x.png",
    leftLine: "/img/left-line-14@2x.png",
    rightLine: "/img/right-line-14@2x.png",
    className: "",
    keyProps: key10Data
};
const tableNumberBaseNull23Data = {
    tableNumberBase6Props: tableNumberBase63Data
};
const tableTextBaseNull23Data = {
    tableNumberBaseNull2Props: tableNumberBaseNull23Data
};
const crewMember41Data = {
    tableHeaderProps: tableHeader5Data,
    tableNumberPrimaryKey2Props: tableNumberPrimaryKey24Data,
    tableTextBase2Props: tableTextBase23Data,
    tableTextBaseNull2Props: tableTextBaseNull23Data
};
const tableHeader6Data = {
    children: "Bonus",
    className: "table-header"
};
const tableNumberBase45Data = {
    bottomLine: "/img/bottom-line@2x.png",
    leftLine: "/img/left-line@2x.png",
    rightLine: "/img/right-line@2x.png",
    className: ""
};
const tableNumberPrimaryKey25Data = {
    tableNumberBase4Props: tableNumberBase45Data
};
const key11Data = {
    className: "key-10"
};
const tableNumberBase54Data = {
    type: "amount:int32",
    bottomLine: "/img/bottom-line-1@2x.png",
    leftLine: "/img/left-line-1@2x.png",
    rightLine: "/img/right-line-1@2x.png",
    className: "table-number-base-8",
    keyProps: key11Data
};
const tableTextBase24Data = {
    className: "table-text-base-5",
    tableNumberBase5Props: tableNumberBase54Data
};
const key12Data = {
    className: "key-11"
};
const tableNumberBase64Data = {
    bottomLine: "/img/bottom-line-2@2x.png",
    leftLine: "/img/left-line-2@2x.png",
    rightLine: "/img/right-line-2@2x.png",
    className: "",
    keyProps: key12Data
};
const tableNumberBaseNull24Data = {
    tableNumberBase6Props: tableNumberBase64Data
};
const tableTextBaseNull24Data = {
    className: "table-text-base-null-4",
    tableNumberBaseNull2Props: tableNumberBaseNull24Data
};
const crewMember51Data = {
    tableHeaderProps: tableHeader6Data,
    tableNumberPrimaryKey2Props: tableNumberPrimaryKey25Data,
    tableTextBase2Props: tableTextBase24Data,
    tableTextBaseNull2Props: tableTextBaseNull24Data
};
const informationalModelData = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    design: "Design",
    arrow7: "/img/arrow-1-2@2x.png",
    arrow8: "/img/arrow-2-2@2x.png",
    line31: "/img/line-3@2x.png",
    line4: "/img/line-4@2x.png",
    line2: "/img/line-2@2x.png",
    label1: "Zoom",
    textFormat: "/img/text-format@2x.png",
    label2: "Text",
    line1: "/img/line-1.png",
    place: "Back",
    clickOnModeling: "CLICK ON \xe2\u20AC\u0153MODELING\xe2\u20AC\x9d BUTTON TO CREATE YOUR DIAGRAM",
    arrow1: "/img/arrow-1-12@2x.png",
    arrow2: "/img/arrow-2-7@2x.png",
    line32: "/img/line-3-2.png",
    arrow5: "/img/arrow-5-5@2x.png",
    arrow6: "/img/arrow-5-5@2x.png",
    modeling: "Modeling",
    nextStep: "Next Step",
    navItems452Props: navItems452Data,
    tableHeaderProps: tableHeader1Data,
    crewMemberProps: crewMember1Data,
    crewMember2Props: crewMember21Data,
    crewMember3Props: crewMember31Data,
    crewMember4Props: crewMember41Data,
    crewMember5Props: crewMember51Data
};
const headerMenuDefault1Data = {
    children: "Get Started ->"
};
const frame117222Data = {
    children: "Existing Case"
};
const frame116222Data = {
    children: "Reference Cases"
};
const frame11Data = {
    src: "/img/unsplash-ym--msbz0ro.png"
};
const frame13Data = {
    src: "/img/unsplash-ym--msbz0ro-2.png",
    className: "frame-6-1"
};
const frame14Data = {
    src: "/img/unsplash-ym--msbz0ro-1.png",
    className: "frame-5-2"
};
const homeData = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    takeYourCompanyToTheNextLevel: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "Take your",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "Company to the",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "next level"
        ]
    }),
    discoverFromDiffer: "Discover from differentes cases the ideal form of your company's Supply Chain.",
    newCase: "NEW CASE",
    existingCase: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "EXISTING",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            " CASE"
        ]
    }),
    referenceCase: "REFERENCE CASE",
    headerMenuDefaultProps: headerMenuDefault1Data,
    frame11722Props: frame117222Data,
    frame11622Props: frame116222Data,
    frame11Props: frame11Data,
    frame12Props: frame13Data,
    frame13Props: frame14Data
};
const frame116223Data = {
    children: "Decisional Model"
};
const frame117223Data = {
    children: "Process view"
};
const frame1181Data = {
    children: "Informational model"
};
const navItems41Data = {
    frame1162Props: frame116223Data,
    frame1172Props: frame117223Data,
    frame118Props: frame1181Data
};
const functionalView1Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    acquisition: "Acquisition",
    arrow1: "/img/arrow-1@2x.png",
    arrow2: "/img/arrow-2@2x.png",
    line2: "/img/line-2@2x.png",
    label1: "Zoom",
    textFormat: "/img/text-format@2x.png",
    label2: "Text",
    line1: "/img/line-1.png",
    place: "Back",
    clickOnModeling: "CLICK ON \xe2\u20AC\u0153MODELING\xe2\u20AC\x9d BUTTON TO CREATE YOUR DIAGRAM",
    label3: "Controllers",
    arrow5: "/img/arrow-5@2x.png",
    label4: "Input",
    arrow6: "/img/arrow-6@2x.png",
    label5: "Resources",
    arrow8: "/img/arrow-8@2x.png",
    label6: "Constrains",
    label7: "Output",
    arrow3: "/img/arrow-3@2x.png",
    arrow4: "/img/arrow-4@2x.png",
    arrow7: "/img/arrow-7@2x.png",
    label8: "Resources",
    arrow9: "/img/arrow-9@2x.png",
    modeling: "Modeling",
    xcontinue: "Continue",
    navItems4Props: navItems41Data
};
const frame117224Data = {
    children: "Existing Case"
};
const frame116224Data = {
    children: "Reference Cases"
};
const frame113224Data = {
    className: ""
};
const navItems31Data = {
    frame1172Props: frame117224Data,
    frame1162Props: frame116224Data,
    frame1132Props: frame113224Data
};
const acquisitionData = {
    ellipse116: "/img/polygon-3@2x.png",
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    companyName: "Company Name",
    inputType1: "text",
    inputPlaceholder1: "Tap here",
    companySize: "Company Size",
    inputType2: "number",
    inputPlaceholder2: "Tap here",
    activitySector: "Activity sector",
    inputType3: "text",
    inputPlaceholder3: "Tap here",
    measuringForm: "Measuring Form",
    navItems3Props: navItems31Data
};
const frame116225Data = {
    children: "Decisional Model"
};
const frame117225Data = {
    children: "Process view"
};
const frame1182Data = {
    children: "Informational model"
};
const physicalModel1Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    acquisition: "Acquisition",
    functionalView: "Functional view",
    arrow1: "/img/arrow-1@2x.png",
    arrow2: "/img/arrow-2@2x.png",
    line2: "/img/line-2@2x.png",
    label1: "Zoom",
    textFormat: "/img/text-format@2x.png",
    label2: "Text",
    line1: "/img/line-1.png",
    place: "Back",
    clickOnModeling: "CLICK ON \xe2\u20AC\u0153MODELING\xe2\u20AC\x9d BUTTON TO CREATE YOUR DIAGRAM",
    label3: "Cut",
    arrow5: "/img/arrow-5@2x.png",
    label4: "Wood",
    arrow6: "/img/arrow-6@2x.png",
    label5: "Assembling",
    label6: "Tables",
    arrow3: "/img/arrow-3@2x.png",
    arrow4: "/img/arrow-4@2x.png",
    arrow7: "/img/arrow-7@2x.png",
    label7: "Machines",
    arrow8: "/img/arrow-8@2x.png",
    label8: "Workers",
    arrow9: "/img/arrow-9@2x.png",
    modeling: "Modeling",
    xcontinue: "Continue",
    frame11622Props: frame116225Data,
    frame11722Props: frame117225Data,
    frame118Props: frame1182Data
};
const frame116226Data = {
    children: "Reference Cases"
};
const existingCaseData = {
    frame11622Props: frame116226Data
};
const frame117226Data = {
    children: "Process view"
};
const frame1183Data = {
    children: "Informational model"
};
const decisionalModel1Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    acquisition: "Acquisition",
    functionalView: "Functional view",
    arrow3: "/img/arrow-1@2x.png",
    arrow4: "/img/arrow-2@2x.png",
    line2: "/img/line-2@2x.png",
    label1: "Zoom",
    textFormat: "/img/text-format@2x.png",
    label2: "Text",
    line1: "/img/line-1.png",
    place: "Back",
    clickOnModeling: "CLICK ON \xe2\u20AC\u0153MODELING\xe2\u20AC\x9d BUTTON TO CREATE YOUR DIAGRAM",
    modeling: "Modeling",
    xcontinue: "Continue",
    frame11722Props: frame117226Data,
    frame118Props: frame1183Data
};
const frame116227Data = {
    children: "Decisional Model"
};
const frame1184Data = {
    children: "Informational model"
};
const processView1Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    acquisition: "Acquisition",
    functionalView: "Functional view",
    arrow1: "/img/arrow-1-2@2x.png",
    arrow2: "/img/arrow-2-2@2x.png",
    rectangle7: "/img/rectangle-7@2x.png",
    line3: "/img/line-3@2x.png",
    line4: "/img/line-4@2x.png",
    line2: "/img/line-2@2x.png",
    label1: "Zoom",
    textFormat: "/img/text-format@2x.png",
    label2: "Text",
    line1: "/img/line-1.png",
    place: "Back",
    clickOnFlexsimB: "CLICK ON \xe2\u20AC\u0153FLEXSIM\xe2\u20AC\x9d BUTTON TO OPEN VMWARE HORIZON",
    overlapGroup1: "/img/rectangle-4@2x.png",
    cut: "Cut",
    label3: "Design",
    rectangle5: "/img/rectangle-5@2x.png",
    manufacturing: "Manufacturing",
    arrow6: "/img/arrow-6-2@2x.png",
    arrow11: "/img/arrow-11@2x.png",
    label4: "Machine",
    arrow8: "/img/arrow-8-2@2x.png",
    label5: "Human",
    arrow9: "/img/arrow-9-2@2x.png",
    flexsim: "Flexsim",
    rectangle6: "/img/rectangle-6@2x.png",
    assembly: "Assembly",
    arrow10: "/img/arrow-10@2x.png",
    xcontinue: "Continue",
    frame11622Props: frame116227Data,
    frame118Props: frame1184Data
};
const frame116228Data = {
    children: "Decisional Model"
};
const frame117227Data = {
    children: "Process view"
};
const frame11362Data = {
    children: "Informational model"
};
const tableHeader7Data = {
    children: ""
};
const tableHeader8Data = {
    children: "Company",
    className: "table-header-1-1"
};
const tableNumberBase46Data = {
    bottomLine: "/img/bottom-line-3@2x.png",
    leftLine: "/img/left-line-3@2x.png",
    rightLine: "/img/right-line-3@2x.png",
    className: "table-number-base-7-1"
};
const tableNumberPrimaryKey26Data = {
    tableNumberBase4Props: tableNumberBase46Data
};
const key15Data = {
    className: "key-14"
};
const tableNumberBase55Data = {
    type: "property1:string",
    bottomLine: "/img/bottom-line-4@2x.png",
    leftLine: "/img/left-line-4@2x.png",
    rightLine: "/img/right-line-4@2x.png",
    className: "table-number-base-9-1",
    keyProps: key15Data
};
const tableTextBase25Data = {
    tableNumberBase5Props: tableNumberBase55Data
};
const key16Data = {
    className: "key-15"
};
const tableNumberBase65Data = {
    bottomLine: "/img/bottom-line-5@2x.png",
    leftLine: "/img/left-line-5@2x.png",
    rightLine: "/img/right-line-5@2x.png",
    className: "table-number-base-13",
    keyProps: key16Data
};
const tableNumberBaseNull25Data = {
    tableNumberBase6Props: tableNumberBase65Data
};
const tableTextBaseNull25Data = {
    tableNumberBaseNull2Props: tableNumberBaseNull25Data
};
const crewMember6Data = {
    tableHeaderProps: tableHeader8Data,
    tableNumberPrimaryKey2Props: tableNumberPrimaryKey26Data,
    tableTextBase2Props: tableTextBase25Data,
    tableTextBaseNull2Props: tableTextBaseNull25Data
};
const tableHeader9Data = {
    children: "Insurances",
    className: "table-header-1-2"
};
const tableNumberBase47Data = {
    bottomLine: "/img/bottom-line@2x.png",
    leftLine: "/img/left-line@2x.png",
    rightLine: "/img/right-line@2x.png",
    className: ""
};
const tableNumberPrimaryKey27Data = {
    tableNumberBase4Props: tableNumberBase47Data
};
const key17Data = {
    className: "key-16"
};
const tableNumberBase72Data = {
    keyProps: key17Data
};
const tableTextBase32Data = {
    tableNumberBase7Props: tableNumberBase72Data
};
const key18Data = {
    className: "key-17"
};
const tableNumberBase66Data = {
    bottomLine: "/img/bottom-line-2@2x.png",
    leftLine: "/img/left-line-2@2x.png",
    rightLine: "/img/right-line-2@2x.png",
    className: "",
    keyProps: key18Data
};
const tableNumberBaseNull26Data = {
    tableNumberBase6Props: tableNumberBase66Data
};
const tableTextBaseNull26Data = {
    tableNumberBaseNull2Props: tableNumberBaseNull26Data
};
const crewMember22Data = {
    tableHeaderProps: tableHeader9Data,
    tableNumberPrimaryKey2Props: tableNumberPrimaryKey27Data,
    tableTextBase3Props: tableTextBase32Data,
    tableTextBaseNull2Props: tableTextBaseNull26Data
};
const tableHeader10Data = {
    children: "Cars",
    className: "table-header-1-3"
};
const tableNumberBase48Data = {
    bottomLine: "/img/bottom-line@2x.png",
    leftLine: "/img/left-line@2x.png",
    rightLine: "/img/right-line@2x.png",
    className: "table-number-base-7-2"
};
const tableNumberPrimaryKey28Data = {
    tableNumberBase4Props: tableNumberBase48Data
};
const key19Data = {
    className: "key-18"
};
const tableNumberBase56Data = {
    type: "registrationplate:string",
    bottomLine: "/img/bottom-line-10@2x.png",
    leftLine: "/img/left-line-10@2x.png",
    rightLine: "/img/right-line-10@2x.png",
    className: "table-number-base-11",
    keyProps: key19Data
};
const tableTextBase26Data = {
    className: "table-text-base-6",
    tableNumberBase5Props: tableNumberBase56Data
};
const key20Data = {
    className: "key-19"
};
const tableNumberBase82Data = {
    keyProps: key20Data
};
const tableNumberBaseNull32Data = {
    tableNumberBase8Props: tableNumberBase82Data
};
const tableTextBaseNull32Data = {
    tableNumberBaseNull3Props: tableNumberBaseNull32Data
};
const crewMember32Data = {
    tableHeaderProps: tableHeader10Data,
    tableNumberPrimaryKey2Props: tableNumberPrimaryKey28Data,
    tableTextBase2Props: tableTextBase26Data,
    tableTextBaseNull3Props: tableTextBaseNull32Data
};
const tableHeader11Data = {
    children: "Employees",
    className: "table-header-1-4"
};
const tableNumberBase49Data = {
    bottomLine: "/img/bottom-line-12@2x.png",
    leftLine: "/img/left-line-12@2x.png",
    rightLine: "/img/right-line-12@2x.png",
    className: "table-number-base-7"
};
const tableNumberPrimaryKey29Data = {
    tableNumberBase4Props: tableNumberBase49Data
};
const key21Data = {
    className: "key-20"
};
const tableNumberBase57Data = {
    type: "name:string",
    bottomLine: "/img/bottom-line-13@2x.png",
    leftLine: "/img/left-line-13@2x.png",
    rightLine: "/img/right-line-13@2x.png",
    className: "table-number-base-9-2",
    keyProps: key21Data
};
const tableTextBase27Data = {
    tableNumberBase5Props: tableNumberBase57Data
};
const key22Data = {
    className: "key-21"
};
const tableNumberBase67Data = {
    bottomLine: "/img/bottom-line-14@2x.png",
    leftLine: "/img/left-line-14@2x.png",
    rightLine: "/img/right-line-14@2x.png",
    className: "",
    keyProps: key22Data
};
const tableNumberBaseNull27Data = {
    tableNumberBase6Props: tableNumberBase67Data
};
const tableTextBaseNull27Data = {
    tableNumberBaseNull2Props: tableNumberBaseNull27Data
};
const crewMember42Data = {
    tableHeaderProps: tableHeader11Data,
    tableNumberPrimaryKey2Props: tableNumberPrimaryKey29Data,
    tableTextBase2Props: tableTextBase27Data,
    tableTextBaseNull2Props: tableTextBaseNull27Data
};
const tableHeader12Data = {
    children: "Bonus",
    className: "table-header-1"
};
const tableNumberBase410Data = {
    bottomLine: "/img/bottom-line@2x.png",
    leftLine: "/img/left-line@2x.png",
    rightLine: "/img/right-line@2x.png",
    className: ""
};
const tableNumberPrimaryKey210Data = {
    tableNumberBase4Props: tableNumberBase410Data
};
const key23Data = {
    className: "key-22"
};
const tableNumberBase58Data = {
    type: "amount:int32",
    bottomLine: "/img/bottom-line-1@2x.png",
    leftLine: "/img/left-line-1@2x.png",
    rightLine: "/img/right-line-1@2x.png",
    className: "table-number-base-9",
    keyProps: key23Data
};
const tableTextBase28Data = {
    className: "table-text-base-7",
    tableNumberBase5Props: tableNumberBase58Data
};
const key24Data = {
    className: "key-23"
};
const tableNumberBase68Data = {
    bottomLine: "/img/bottom-line-2@2x.png",
    leftLine: "/img/left-line-2@2x.png",
    rightLine: "/img/right-line-2@2x.png",
    className: "",
    keyProps: key24Data
};
const tableNumberBaseNull28Data = {
    tableNumberBase6Props: tableNumberBase68Data
};
const tableTextBaseNull28Data = {
    className: "table-text-base-null-5",
    tableNumberBaseNull2Props: tableNumberBaseNull28Data
};
const crewMember52Data = {
    tableHeaderProps: tableHeader12Data,
    tableNumberPrimaryKey2Props: tableNumberPrimaryKey210Data,
    tableTextBase2Props: tableTextBase28Data,
    tableTextBaseNull2Props: tableTextBaseNull28Data
};
const informationalModel1Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    acquisition: "Acquisition",
    functionalView: "Functional view",
    arrow7: "/img/arrow-1-2@2x.png",
    arrow8: "/img/arrow-2-2@2x.png",
    line31: "/img/line-3@2x.png",
    line4: "/img/line-4@2x.png",
    line2: "/img/line-2@2x.png",
    label1: "Zoom",
    textFormat: "/img/text-format@2x.png",
    label2: "Text",
    line1: "/img/line-1.png",
    place: "Back",
    clickOnModeling: "CLICK ON \xe2\u20AC\u0153MODELING\xe2\u20AC\x9d BUTTON TO CREATE YOUR DIAGRAM",
    arrow1: "/img/arrow-1-7@2x.png",
    arrow2: "/img/arrow-2-7@2x.png",
    line32: "/img/line-3-2.png",
    arrow5: "/img/arrow-5-5@2x.png",
    arrow6: "/img/arrow-5-5@2x.png",
    modeling: "Modeling",
    goOnToTheNextPage: "Next",
    frame11622Props: frame116228Data,
    frame11722Props: frame117227Data,
    frame1136Props: frame11362Data,
    tableHeaderProps: tableHeader7Data,
    crewMemberProps: crewMember6Data,
    crewMember2Props: crewMember22Data,
    crewMember3Props: crewMember32Data,
    crewMember4Props: crewMember42Data,
    crewMember5Props: crewMember52Data
};
const frame117228Data = {
    children: "Existing Case"
};
const frame116229Data = {
    children: "Reference Cases"
};
const frame1132210Data = {
    className: "frame-113-14"
};
const navItems32Data = {
    className: "nav-items-3-2",
    frame1172Props: frame117228Data,
    frame1162Props: frame116229Data,
    frame1132Props: frame1132210Data
};
const buttonSecondary1Data = {
    children: "D\xe9marche Environnementale 1",
    className: ""
};
const toggle1Data = {
    buttonSecondaryProps: buttonSecondary1Data
};
const ouinon1Data = {
    yes: "Yes",
    place: "No"
};
const frame1361Data = {
    ouinonProps: ouinon1Data
};
const group901Data = {
    children: "Avez-vous des objectifs environnementaux planifi\xe9s et r\xe9alis\xe9s ?"
};
const ouinon2Data = {
    yes: "Yes",
    place: "No"
};
const frame1362Data = {
    ouinonProps: ouinon2Data
};
const group902Data = {
    children: "Quel est le pourcentage d\xe2\u20AC\u2122objectifs r\xe9alis\xe9s sur les objectifs planifi\xe9s?"
};
const ouinon3Data = {
    yes: "Yes",
    place: "No"
};
const frame1363Data = {
    className: "frame-138",
    ouinonProps: ouinon3Data
};
const buttonSecondary2Data = {
    children: "D\xe9marche Environnementale 2",
    className: ""
};
const toggle2Data = {
    className: "toggle-33",
    buttonSecondaryProps: buttonSecondary2Data
};
const ouinon4Data = {
    yes: "Yes",
    place: "No"
};
const frame1364Data = {
    ouinonProps: ouinon4Data
};
const ouinon5Data = {
    yes: "Yes",
    place: "No"
};
const frame1365Data = {
    ouinonProps: ouinon5Data
};
const ouinon6Data = {
    yes: "Yes",
    place: "No"
};
const frame1366Data = {
    ouinonProps: ouinon6Data
};
const buttonSecondary3Data = {
    children: "1/5",
    className: "button-secondary-52"
};
const toggle3Data = {
    className: "x15",
    buttonSecondaryProps: buttonSecondary3Data
};
const environmental1Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1-19@2x.png",
    pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS ON THE FORM",
    grezVousLesRisqu: "G\xe9rez vous les risques et impacts de votre activit\xe9 sur l'environnement?",
    inputType1: "text",
    inputPlaceholder1: "En moyenne dans quelle p\xe9rim\xe8tre vous approvisionnez vous?",
    inputType2: "text",
    inputPlaceholder2: "Connaissez vous le tonnage du transport des produits de vos fournisseurs externes?",
    inputType3: "text",
    inputPlaceholder3: "Connaissez vous le tonnage du transport des produits de vos fournisseurs externes?",
    navItems3Props: navItems32Data,
    toggle1Props: toggle1Data,
    frame1361Props: frame1361Data,
    group901Props: group901Data,
    frame1362Props: frame1362Data,
    group902Props: group902Data,
    frame1363Props: frame1363Data,
    toggle2Props: toggle2Data,
    frame1364Props: frame1364Data,
    frame1365Props: frame1365Data,
    frame1366Props: frame1366Data,
    toggle3Props: toggle3Data
};
const frame117229Data = {
    children: "Existing Case"
};
const frame1162210Data = {
    children: "Reference Cases"
};
const frame1132211Data = {
    className: ""
};
const navItems33Data = {
    className: "nav-items-3-3",
    frame1172Props: frame117229Data,
    frame1162Props: frame1162210Data,
    frame1132Props: frame1132211Data
};
const measuringFormData = {
    ellipse116: "/img/polygon-3@2x.png",
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    criteriaMeasurementForm: "CRITERIA MEASUREMENT FORM",
    environnementCriteria1: "Environnement criteria",
    environnementCriteria2: "Environnement criteria",
    x4LeadTimeCriteria: "4. Lead time criteria",
    x2SocialCriteria: "2. Social Criteria",
    x5CostCriteria: "5. Cost criteria",
    x3ModernizationCriteria: "3. Modernization criteria",
    x6QualityCriteria: "6. Quality criteria",
    navItems3Props: navItems33Data
};
const frame1185Data = {
    children: "Visual management",
    className: "frame-113-23"
};
const headerMenuDefault321Data = {
    inputPlaceholder: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "Definition de",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            " la famille",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            " de produits"
        ]
    })
};
const headerMenuDefault322Data = {
    inputPlaceholder: "VSM Actuel",
    className: "menu-item-default-14"
};
const menuItemDefaultData = {
    headerMenuDefault3Props: headerMenuDefault322Data
};
const headerMenuDefault323Data = {
    inputPlaceholder: "Analysis",
    className: "menu-item-default-15"
};
const headerMenuDefault324Data = {
    inputPlaceholder: "VSM Futur",
    className: "menu-item-default-16"
};
const headerMenuDefault325Data = {
    inputPlaceholder: "Plan d\xe2\u20AC\u2122action",
    className: "menu-item-default-17"
};
const leanVSM1Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    leanVsm: "Lean VSM",
    arrow1: "/img/arrow-1@2x.png",
    arrow2: "/img/arrow-2@2x.png",
    rectangle6: "/img/rectangle-7@2x.png",
    line2: "/img/line-2@2x.png",
    label1: "Zoom",
    textFormat: "/img/text-format@2x.png",
    label2: "Text",
    line1: "/img/line-1.png",
    place: "Back",
    clickOnModeling: "CLICK ON \xe2\u20AC\u0153MODELING\xe2\u20AC\x9d BUTTON TO CREATE YOUR DIAGRAM",
    arrow3: "/img/arrow-3-4@2x.png",
    modeling: "Modeling",
    arrow4: "/img/arrow-4-4@2x.png",
    arrow6: "/img/arrow-4-4@2x.png",
    arrow5: "/img/arrow-5-3@2x.png",
    rectangle7: "/img/rectangle-7-1@2x.png",
    xcontinue: "Continue",
    frame118Props: frame1185Data,
    headerMenuDefault321Props: headerMenuDefault321Data,
    menuItemDefaultProps: menuItemDefaultData,
    headerMenuDefault322Props: headerMenuDefault323Data,
    headerMenuDefault323Props: headerMenuDefault324Data,
    headerMenuDefault324Props: headerMenuDefault325Data
};
const frame1186Data = {
    children: "Visual management",
    className: "frame-113-26"
};
const x5S1Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    arrow1: "/img/arrow-1@2x.png",
    arrow2: "/img/arrow-2@2x.png",
    rectangle6: "/img/rectangle-7@2x.png",
    line2: "/img/line-2@2x.png",
    label1: "Zoom",
    textFormat: "/img/text-format@2x.png",
    label2: "Text",
    line1: "/img/line-1.png",
    place: "Back",
    clickOnModeling: "CLICK ON \xe2\u20AC\u0153MODELING\xe2\u20AC\x9d BUTTON TO CREATE YOUR DIAGRAM",
    seiri: "SEIRI",
    arrow7: "/img/arrow-7-6@2x.png",
    inputType1: "text",
    inputPlaceholder1: "ELIMINER",
    arrow3: "/img/arrow-3-4@2x.png",
    seiton: "SEITON",
    arrow8: "/img/arrow-8-8@2x.png",
    inputType2: "text",
    inputPlaceholder2: "RANGER",
    modeling: "Modeling",
    arrow4: "/img/arrow-4-4@2x.png",
    seison: "SEISON",
    arrow9: "/img/arrow-7-6@2x.png",
    inputType3: "text",
    inputPlaceholder3: "NETTOYER",
    arrow6: "/img/arrow-4-4@2x.png",
    seiketsu: "SEIKETSU",
    shitsuke: "SHITSUKE",
    arrow10: "/img/arrow-8-8@2x.png",
    arrow11: "/img/arrow-8-8@2x.png",
    arrow5: "/img/arrow-5-3@2x.png",
    rectangle7: "/img/rectangle-7-1@2x.png",
    inputType4: "text",
    inputPlaceholder4: "STANDARDISER",
    inputType5: "text",
    inputPlaceholder5: "RESPECTER",
    xcontinue: "Continue",
    frame118Props: frame1186Data
};
const frame1172210Data = {
    children: "Existing Case"
};
const frame1162211Data = {
    children: "Reference Cases"
};
const frame1132214Data = {
    className: ""
};
const navItems34Data = {
    className: "nav-items-3-4",
    frame1172Props: frame1172210Data,
    frame1162Props: frame1162211Data,
    frame1132Props: frame1132214Data
};
const frame113324Data = {
    className: "frame-113-3"
};
const headerMenuDefault21Data = {
    children: "Results & Objectives",
    className: ""
};
const frame2321Data = {
    headerMenuDefault2Props: headerMenuDefault21Data
};
const frame222Data = {
    children: "Continue"
};
const analysisData = {
    analysis: "Analysis",
    label: "Design",
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    place: "Back",
    formalismesEnFonct: "FORMALISMES EN FONCTION DES PROBL\xe0\u02C6MES TROUV\xe0\u2030S",
    navItems3Props: navItems34Data,
    frame11332Props: frame113324Data,
    frame232Props: frame2321Data,
    frame222Props: frame222Data
};
const frame11363Data = {
    children: "Visual management",
    className: "frame-113-5"
};
const buttonSecondary4Data = {
    children: "Analysis",
    className: "button-secondary-53"
};
const toggle4Data = {
    className: "finish",
    buttonSecondaryProps: buttonSecondary4Data
};
const visualManagement1Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    arrow9: "/img/arrow-1@2x.png",
    arrow10: "/img/arrow-2@2x.png",
    line2: "/img/line-2@2x.png",
    label1: "Zoom",
    textFormat: "/img/text-format@2x.png",
    label2: "Text",
    line1: "/img/line-1.png",
    place: "Back",
    clickOnModeling: "CLICK ON \xe2\u20AC\u0153MODELING\xe2\u20AC\x9d BUTTON TO CREATE YOUR DIAGRAM",
    inputType1: "text",
    inputPlaceholder1: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "Connaissances",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "Competences"
        ]
    }),
    inputType2: "text",
    inputPlaceholder2: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "Collaborateurs",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "Equipes"
        ]
    }),
    inputType3: "text",
    inputPlaceholder3: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "Strategies",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "Projets"
        ]
    }),
    inputType4: "text",
    inputPlaceholder4: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "Idees",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "Informations"
        ]
    }),
    inputType5: "text",
    inputPlaceholder5: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "Temps ",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "Priorites"
        ]
    }),
    arrow11: "/img/arrow-11-1@2x.png",
    arrow16: "/img/arrow-16@2x.png",
    arrow13: "/img/arrow-13@2x.png",
    arrow14: "/img/arrow-14@2x.png",
    inputType6: "text",
    inputPlaceholder6: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "Mieux",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            " Manager"
        ]
    }),
    arrow12: "/img/arrow-12@2x.png",
    arrow15: "/img/arrow-15@2x.png",
    inputType7: "text",
    inputPlaceholder7: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "Problemes",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "Decision"
        ]
    }),
    modeling: "Modeling",
    frame1136Props: frame11363Data,
    toggleProps: toggle4Data
};
const frame1162212Data = {
    children: "Decisional Model"
};
const frame1172211Data = {
    children: "Process view"
};
const frame1187Data = {
    children: "Informational model"
};
const navItems42Data = {
    className: "nav-items-4-2",
    frame1162Props: frame1162212Data,
    frame1172Props: frame1172211Data,
    frame118Props: frame1187Data
};
const functionalViewData = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    design: "Design",
    arrow1: "/img/arrow-1@2x.png",
    arrow2: "/img/arrow-2@2x.png",
    line2: "/img/line-2@2x.png",
    label1: "Zoom",
    textFormat: "/img/text-format@2x.png",
    label2: "Text",
    line1: "/img/line-1.png",
    place: "Back",
    clickOnModeling: "CLICK ON \xe2\u20AC\u0153MODELING\xe2\u20AC\x9d BUTTON TO CREATE YOUR DIAGRAM",
    label3: "Controllers",
    arrow5: "/img/arrow-5@2x.png",
    label4: "Input",
    arrow6: "/img/arrow-6@2x.png",
    label5: "Resources",
    arrow8: "/img/arrow-8@2x.png",
    modeling: "Modeling",
    label6: "Constrains",
    label7: "Output",
    arrow3: "/img/arrow-3@2x.png",
    arrow4: "/img/arrow-4@2x.png",
    arrow7: "/img/arrow-7@2x.png",
    label8: "Resources",
    arrow9: "/img/arrow-9-3@2x.png",
    xcontinue: "Continue",
    navItems4Props: navItems42Data
};
const frame1172212Data = {
    children: "Existing Case"
};
const frame1162213Data = {
    children: "Reference Cases"
};
const frame1132217Data = {
    className: ""
};
const navItems35Data = {
    className: "nav-items-3-5",
    frame1172Props: frame1172212Data,
    frame1162Props: frame1162213Data,
    frame1132Props: frame1132217Data
};
const frame113327Data = {
    className: "frame-113-6"
};
const navItems222Data = {
    frame11332Props: frame113327Data
};
const pricing31Data = {
    cost: "Cost"
};
const pricing32Data = {
    cost: "Modernization",
    className: "pricing-8"
};
const pricing33Data = {
    cost: "Social",
    className: "pricing-5"
};
const pricing34Data = {
    cost: "Client/Consumer",
    className: "pricing-7"
};
const objectivesData = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    place1: "Back",
    notesAtteindre: "NOTES \xe0\u20AC ATTEINDRE",
    place2: "Quality",
    inputType1: "text",
    inputPlaceholder1: "      /25",
    line211: "/img/line-21@2x.png",
    leadTime: "Lead Time",
    inputType2: "text",
    inputPlaceholder2: "      /25",
    line212: "/img/line-21-5@2x.png",
    environment: "Environment",
    inputType3: "text",
    inputPlaceholder3: "      /25",
    line213: "/img/line-21-5@2x.png",
    xcontinue: "Continue",
    navItems3Props: navItems35Data,
    navItems22Props: navItems222Data,
    pricing31Props: pricing31Data,
    pricing32Props: pricing32Data,
    pricing33Props: pricing33Data,
    pricing34Props: pricing34Data
};
const frame1162214Data = {
    children: "Decisional Model"
};
const frame1172213Data = {
    children: "Process view"
};
const frame1188Data = {
    children: "Informational model"
};
const navItems422Data = {
    frame1162Props: frame1162214Data,
    frame1172Props: frame1172213Data,
    frame118Props: frame1188Data
};
const physicalModelData = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    design: "Design",
    arrow1: "/img/arrow-1@2x.png",
    arrow2: "/img/arrow-2@2x.png",
    line2: "/img/line-2@2x.png",
    label1: "Zoom",
    textFormat: "/img/text-format@2x.png",
    label2: "Text",
    line1: "/img/line-1.png",
    place: "Back",
    clickOnModeling: "CLICK ON \xe2\u20AC\u0153MODELING\xe2\u20AC\x9d BUTTON TO CREATE YOUR DIAGRAM",
    label3: "Cut",
    arrow5: "/img/arrow-5@2x.png",
    label4: "Wood",
    arrow6: "/img/arrow-6@2x.png",
    label5: "Machines",
    arrow8: "/img/arrow-8@2x.png",
    modeling: "Modeling",
    label6: "Assembling",
    label7: "Tables",
    arrow3: "/img/arrow-3@2x.png",
    arrow4: "/img/arrow-4@2x.png",
    arrow7: "/img/arrow-7@2x.png",
    label8: "Workers",
    arrow9: "/img/arrow-9-3@2x.png",
    xcontinue: "Continue",
    navItems42Props: navItems422Data
};
const frame1172214Data = {
    children: "Process view"
};
const frame1189Data = {
    children: "Informational model"
};
const navItems43Data = {
    frame1172Props: frame1172214Data,
    frame118Props: frame1189Data
};
const decisionalModelData = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    design: "Design",
    arrow3: "/img/arrow-1@2x.png",
    arrow4: "/img/arrow-2@2x.png",
    line2: "/img/line-2@2x.png",
    label1: "Zoom",
    textFormat: "/img/text-format@2x.png",
    label2: "Text",
    line1: "/img/line-1.png",
    place: "Back",
    clickOnModeling: "CLICK ON \xe2\u20AC\u0153MODELING\xe2\u20AC\x9d BUTTON TO CREATE YOUR DIAGRAM",
    modeling: "Modeling",
    xcontinue: "Continue",
    navItems43Props: navItems43Data
};
const frame1162215Data = {
    children: "Decisional Model"
};
const frame11810Data = {
    children: "Informational model"
};
const navItems44Data = {
    frame1162Props: frame1162215Data,
    frame118Props: frame11810Data
};
const processViewData = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    design: "Design",
    arrow1: "/img/arrow-1-2@2x.png",
    arrow2: "/img/arrow-2-2@2x.png",
    rectangle7: "/img/rectangle-7@2x.png",
    line3: "/img/line-3@2x.png",
    line4: "/img/line-4@2x.png",
    line2: "/img/line-2@2x.png",
    label1: "Zoom",
    textFormat: "/img/text-format@2x.png",
    label2: "Text",
    line1: "/img/line-1.png",
    place: "Back",
    clickOnFlexsimB: "CLICK ON \xe2\u20AC\u0153FLEXSIM\xe2\u20AC\x9d BUTTON TO OPEN VMWARE HORIZON",
    overlapGroup2: "/img/rectangle-4@2x.png",
    cut: "Cut",
    label3: "Design",
    rectangle5: "/img/rectangle-5@2x.png",
    manufacturing: "Manufacturing",
    arrow6: "/img/arrow-6-2@2x.png",
    arrow11: "/img/arrow-11@2x.png",
    label4: "Machine",
    arrow8: "/img/arrow-8-2@2x.png",
    label5: "Human",
    arrow9: "/img/arrow-9-2@2x.png",
    spanText1: "F",
    spanText2: "lexsim",
    rectangle6: "/img/rectangle-6@2x.png",
    assembly: "Assembly",
    arrow10: "/img/arrow-10@2x.png",
    xcontinue: "Continue",
    navItems44Props: navItems44Data
};
const frame114322Data = {
    className: "frame-114-87"
};
const frame11527Data = {
    className: "frame-115-105"
};
const headerMenuDefault22Data = {
    children: "Existing case"
};
const frame1132221Data = {
    className: "frame-113-29"
};
const frame11445Data = {
    className: "frame-114-98"
};
const headerMenuDefault23Data = {
    children: "Results & Objectives",
    className: ""
};
const frame2322Data = {
    headerMenuDefault2Props: headerMenuDefault23Data
};
const buttonSecondary5Data = {
    children: "ISO 50001 Norm",
    className: "button-secondary-27"
};
const toggle5Data = {
    className: "toggle-7",
    buttonSecondaryProps: buttonSecondary5Data
};
const group1021Data = {
    line24: "/img/line-24.png",
    className: ""
};
const group1022Data = {
    line24: "/img/line-24-1.png",
    className: ""
};
const group1023Data = {
    line24: "/img/line-24-12.png",
    className: ""
};
const group1024Data = {
    line24: "/img/line-24-3.png",
    className: ""
};
const group1025Data = {
    line24: "/img/line-24-4.png",
    className: ""
};
const frame1011Data = {
    toggleProps: toggle5Data,
    group1021Props: group1021Data,
    group1022Props: group1022Data,
    group1023Props: group1023Data,
    group1024Props: group1024Data,
    group1025Props: group1025Data
};
const buttonSecondary6Data = {
    children: "1/2",
    className: "button-secondary-27"
};
const toggle6Data = {
    className: "toggle-34",
    buttonSecondaryProps: buttonSecondary6Data
};
const buttonSecondary7Data = {
    children: "ISO 14001 Norm",
    className: "button-secondary-27"
};
const toggle7Data = {
    className: "toggle-7",
    buttonSecondaryProps: buttonSecondary7Data
};
const group1026Data = {
    line24: "/img/line-24-5.png",
    className: ""
};
const group1027Data = {
    line24: "/img/line-24-6.png",
    className: ""
};
const group1028Data = {
    line24: "/img/line-24-7.png",
    className: ""
};
const group1029Data = {
    line24: "/img/line-24-18.png",
    className: ""
};
const group10210Data = {
    line24: "/img/line-24-19.png",
    className: ""
};
const frame1021Data = {
    toggleProps: toggle7Data,
    group1021Props: group1026Data,
    group1022Props: group1027Data,
    group1023Props: group1028Data,
    group1024Props: group1029Data,
    group1025Props: group10210Data
};
const frame117323Data = {
    className: "frame-116-157"
};
const sMED2Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    label1: "Reference case",
    acquisition: "Acquisition",
    analysis: "Analysis",
    label2: "Design",
    pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
    frame11432Props: frame114322Data,
    frame1152Props: frame11527Data,
    headerMenuDefault2Props: headerMenuDefault22Data,
    frame11322Props: frame1132221Data,
    frame1144Props: frame11445Data,
    frame232Props: frame2322Data,
    frame101Props: frame1011Data,
    toggleProps: toggle6Data,
    frame102Props: frame1021Data,
    frame11732Props: frame117323Data
};
const navItems23Data = {
    className: "nav-items-2-4"
};
const frame1172215Data = {
    children: "Existing Case"
};
const frame1162216Data = {
    children: "Reference Cases"
};
const frame1132222Data = {
    className: ""
};
const navItems36Data = {
    className: "nav-items-3-6",
    frame1172Props: frame1172215Data,
    frame1162Props: frame1162216Data,
    frame1132Props: frame1132222Data
};
const buttonSecondary8Data = {
    children: "ISO 50001 Norm",
    className: "button-secondary-28"
};
const toggle8Data = {
    className: "toggle-8",
    buttonSecondaryProps: buttonSecondary8Data
};
const group10211Data = {
    line24: "/img/line-24.png",
    className: ""
};
const group10212Data = {
    line24: "/img/line-24-1.png",
    className: ""
};
const group10213Data = {
    line24: "/img/line-24-12.png",
    className: ""
};
const group10214Data = {
    line24: "/img/line-24-3.png",
    className: ""
};
const group10215Data = {
    line24: "/img/line-24-4.png",
    className: ""
};
const frame1012Data = {
    className: "frame-97",
    toggleProps: toggle8Data,
    group1021Props: group10211Data,
    group1022Props: group10212Data,
    group1023Props: group10213Data,
    group1024Props: group10214Data,
    group1025Props: group10215Data
};
const buttonSecondary9Data = {
    children: "ISO 14001 Norm",
    className: "button-secondary-28"
};
const toggle9Data = {
    className: "toggle-8",
    buttonSecondaryProps: buttonSecondary9Data
};
const group10216Data = {
    line24: "/img/line-24-5.png",
    className: ""
};
const group10217Data = {
    line24: "/img/line-24-6.png",
    className: ""
};
const group10218Data = {
    line24: "/img/line-24-7.png",
    className: ""
};
const group10219Data = {
    line24: "/img/line-24-18.png",
    className: ""
};
const group10220Data = {
    line24: "/img/line-24-19.png",
    className: ""
};
const frame1022Data = {
    className: "frame-98",
    toggleProps: toggle9Data,
    group1021Props: group10216Data,
    group1022Props: group10217Data,
    group1023Props: group10218Data,
    group1024Props: group10219Data,
    group1025Props: group10220Data
};
const buttonSecondary10Data = {
    children: "2/2",
    className: "button-secondary-28"
};
const toggle10Data = {
    className: "toggle-35",
    buttonSecondaryProps: buttonSecondary10Data
};
const sMED3Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
    visualManagement: "Visual Management",
    navItems2Props: navItems23Data,
    navItems3Props: navItems36Data,
    frame101Props: frame1012Data,
    frame102Props: frame1022Data,
    toggleProps: toggle10Data
};
const navItems24Data = {
    className: "nav-items-2-5"
};
const frame1172216Data = {
    children: "Existing Case"
};
const frame1162217Data = {
    children: "Reference Cases"
};
const frame1132223Data = {
    className: ""
};
const navItems37Data = {
    className: "nav-items-3-7",
    frame1172Props: frame1172216Data,
    frame1162Props: frame1162217Data,
    frame1132Props: frame1132223Data
};
const buttonSecondary11Data = {
    children: "ISO 50001 Norm",
    className: "button-secondary-29"
};
const toggle11Data = {
    className: "toggle-9",
    buttonSecondaryProps: buttonSecondary11Data
};
const group10221Data = {
    line24: "/img/line-24.png",
    className: ""
};
const group10222Data = {
    line24: "/img/line-24-1.png",
    className: ""
};
const group10223Data = {
    line24: "/img/line-24-2.png",
    className: ""
};
const group10224Data = {
    line24: "/img/line-24-3.png",
    className: ""
};
const group10225Data = {
    line24: "/img/line-24-4.png",
    className: ""
};
const frame1013Data = {
    toggleProps: toggle11Data,
    group1021Props: group10221Data,
    group1022Props: group10222Data,
    group1023Props: group10223Data,
    group1024Props: group10224Data,
    group1025Props: group10225Data
};
const buttonSecondary12Data = {
    children: "1/2",
    className: "button-secondary-29"
};
const toggle12Data = {
    className: "toggle-36",
    buttonSecondaryProps: buttonSecondary12Data
};
const buttonSecondary13Data = {
    children: "ISO 14001 Norm",
    className: "button-secondary-29"
};
const toggle13Data = {
    className: "toggle-9",
    buttonSecondaryProps: buttonSecondary13Data
};
const group10226Data = {
    line24: "/img/line-24-5.png",
    className: ""
};
const group10227Data = {
    line24: "/img/line-24-6.png",
    className: ""
};
const group10228Data = {
    line24: "/img/line-24-7.png",
    className: ""
};
const group10229Data = {
    line24: "/img/line-24-8.png",
    className: ""
};
const group10230Data = {
    line24: "/img/line-24-9.png",
    className: ""
};
const frame1023Data = {
    toggleProps: toggle13Data,
    group1021Props: group10226Data,
    group1022Props: group10227Data,
    group1023Props: group10228Data,
    group1024Props: group10229Data,
    group1025Props: group10230Data
};
const frame117324Data = {
    className: "frame-117-75"
};
const visualManagement2Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
    navItems2Props: navItems24Data,
    navItems3Props: navItems37Data,
    frame101Props: frame1013Data,
    toggleProps: toggle12Data,
    frame102Props: frame1023Data,
    frame11732Props: frame117324Data
};
const navItems25Data = {
    className: "nav-items-2-6"
};
const frame1172217Data = {
    children: "Existing Case"
};
const frame1162218Data = {
    children: "Reference Cases"
};
const frame1132224Data = {
    className: ""
};
const navItems38Data = {
    className: "nav-items-3-8",
    frame1172Props: frame1172217Data,
    frame1162Props: frame1162218Data,
    frame1132Props: frame1132224Data
};
const buttonSecondary14Data = {
    children: "ISO 50001 Norm",
    className: "button-secondary-30"
};
const toggle14Data = {
    className: "toggle-10",
    buttonSecondaryProps: buttonSecondary14Data
};
const group10231Data = {
    line24: "/img/line-24.png",
    className: ""
};
const group10232Data = {
    line24: "/img/line-24-1.png",
    className: "group-3-2"
};
const group10233Data = {
    line24: "/img/line-24-32.png",
    className: "group-3-3"
};
const group10234Data = {
    line24: "/img/line-24-3.png",
    className: "group-3-4"
};
const group10235Data = {
    line24: "/img/line-24-4.png",
    className: "group-3-5"
};
const frame1014Data = {
    className: "frame-97-1",
    toggleProps: toggle14Data,
    group1021Props: group10231Data,
    group1022Props: group10232Data,
    group1023Props: group10233Data,
    group1024Props: group10234Data,
    group1025Props: group10235Data
};
const buttonSecondary15Data = {
    children: "ISO 14001 Norm",
    className: "button-secondary-30"
};
const toggle15Data = {
    className: "toggle-10",
    buttonSecondaryProps: buttonSecondary15Data
};
const group10236Data = {
    line24: "/img/line-24-5.png",
    className: ""
};
const group10237Data = {
    line24: "/img/line-24-6.png",
    className: "group-3-6"
};
const group10238Data = {
    line24: "/img/line-24-7.png",
    className: "group-3-7"
};
const group10239Data = {
    line24: "/img/line-24-18.png",
    className: "group-3-8"
};
const group10240Data = {
    line24: "/img/line-24-19.png",
    className: "group-3"
};
const frame1024Data = {
    className: "frame-98-1",
    toggleProps: toggle15Data,
    group1021Props: group10236Data,
    group1022Props: group10237Data,
    group1023Props: group10238Data,
    group1024Props: group10239Data,
    group1025Props: group10240Data
};
const buttonSecondary16Data = {
    children: "2/2",
    className: "button-secondary-30"
};
const toggle16Data = {
    className: "toggle-37",
    buttonSecondaryProps: buttonSecondary16Data
};
const kaizen3Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
    smed: "SMED",
    navItems2Props: navItems25Data,
    navItems3Props: navItems38Data,
    frame101Props: frame1014Data,
    frame102Props: frame1024Data,
    toggleProps: toggle16Data
};
const navItems26Data = {
    className: "nav-items-2-7"
};
const frame1172218Data = {
    children: "Existing Case"
};
const frame1162219Data = {
    children: "Reference Cases"
};
const frame1132225Data = {
    className: ""
};
const navItems39Data = {
    className: "nav-items-3-9",
    frame1172Props: frame1172218Data,
    frame1162Props: frame1162219Data,
    frame1132Props: frame1132225Data
};
const buttonSecondary17Data = {
    children: "2/2",
    className: "button-secondary-54"
};
const toggle17Data = {
    className: "toggle-38",
    buttonSecondaryProps: buttonSecondary17Data
};
const visualManagement3Data = {
    navItems2Props: navItems26Data,
    navItems3Props: navItems39Data,
    toggleProps: toggle17Data
};
const frame1133211Data = {
    className: "frame-113-10"
};
const navItems223Data = {
    className: "nav-items-2-21",
    frame11332Props: frame1133211Data
};
const frame114212Data = {
    className: "frame-114-100"
};
const frame1132226Data = {
    className: "frame-113-34"
};
const pricing35Data = {
    cost: "Cost"
};
const pricing36Data = {
    cost: "Modernization",
    className: "pricing-8-1"
};
const pricing37Data = {
    cost: "Social",
    className: "pricing-5-1"
};
const pricing38Data = {
    cost: "Client/Consumer",
    className: "pricing-7-1"
};
const curPerformancesData = {
    label1: "Existing case",
    label2: "Reference case",
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    place1: "Back",
    place2: "Quality",
    inputType1: "text",
    inputPlaceholder1: "      /25",
    line211: "/img/line-21@2x.png",
    leadTime: "Lead Time",
    inputType2: "text",
    inputPlaceholder2: "      /25",
    line212: "/img/line-21-5@2x.png",
    environment: "Environment",
    inputType3: "text",
    inputPlaceholder3: "      /25",
    line213: "/img/line-21-5@2x.png",
    propositions: "Propositions",
    navItems22Props: navItems223Data,
    frame1142Props: frame114212Data,
    frame11322Props: frame1132226Data,
    pricing31Props: pricing35Data,
    pricing32Props: pricing36Data,
    pricing33Props: pricing37Data,
    pricing34Props: pricing38Data
};
const frame942Data = {
    className: "frame-94-1"
};
const frame952Data = {
    className: "frame-95-1"
};
const inscriptionData = {
    aerialViewContainerCargoShipSea1: "/img/aerial-view-container-cargo-ship-sea-1.png",
    subtract: "/img/subtract.png",
    polygon1: "/img/polygon-1-1@2x.png",
    polygon2: "/img/polygon-2@2x.png",
    login: "Sign in",
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---20081@2x.png",
    polygon3: "/img/polygon-3@2x.png",
    frame94Props: frame942Data,
    frame95Props: frame952Data
};
const frame1172219Data = {
    children: "Existing Case"
};
const frame1162220Data = {
    children: "Reference Cases"
};
const frame1132227Data = {
    className: ""
};
const navItems310Data = {
    className: "nav-items-3-10",
    frame1172Props: frame1172219Data,
    frame1162Props: frame1162220Data,
    frame1132Props: frame1132227Data
};
const buttonSecondary18Data = {
    children: "After-sales service and dispute resolution 1",
    className: ""
};
const toggle18Data = {
    className: "toggle-39",
    buttonSecondaryProps: buttonSecondary18Data
};
const ouinon7Data = {
    yes: "Yes",
    place: "No"
};
const frame1367Data = {
    ouinonProps: ouinon7Data
};
const ouinon8Data = {
    yes: "Yes",
    place: "No"
};
const frame1368Data = {
    ouinonProps: ouinon8Data
};
const ouinon9Data = {
    yes: "Yes",
    place: "No"
};
const frame1369Data = {
    ouinonProps: ouinon9Data
};
const ouinon10Data = {
    yes: "Yes",
    place: "No"
};
const frame13610Data = {
    ouinonProps: ouinon10Data
};
const buttonSecondary19Data = {
    children: "After-sales service and dispute resolution 2",
    className: "button-secondary-56"
};
const toggle19Data = {
    className: "toggle-40",
    buttonSecondaryProps: buttonSecondary19Data
};
const ouinon11Data = {
    yes: "Yes",
    place: "No"
};
const frame13611Data = {
    ouinonProps: ouinon11Data
};
const ouinon12Data = {
    yes: "Yes",
    place: "No"
};
const frame13612Data = {
    ouinonProps: ouinon12Data
};
const ouinon13Data = {
    yes: "Yes",
    place: "No"
};
const frame13613Data = {
    ouinonProps: ouinon13Data
};
const ouinon14Data = {
    yes: "Yes",
    place: "No"
};
const frame13614Data = {
    ouinonProps: ouinon14Data
};
const buttonSecondary20Data = {
    children: "2/2",
    className: "button-secondary-57"
};
const toggle20Data = {
    className: "toggle-41",
    buttonSecondaryProps: buttonSecondary20Data
};
const clientConsommateur2Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    inputType1: "text",
    inputPlaceholder1: "Connaissez vous votre bilan carbone?",
    inputType2: "text",
    inputPlaceholder2: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType3: "text",
    inputPlaceholder3: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    inputType4: "text",
    inputPlaceholder4: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    inputType5: "text",
    inputPlaceholder5: "Connaissez vous votre bilan carbone?",
    inputType6: "text",
    inputPlaceholder6: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType7: "text",
    inputPlaceholder7: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    inputType8: "text",
    inputPlaceholder8: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    next: "Next",
    navItems3Props: navItems310Data,
    toggle1Props: toggle18Data,
    frame1361Props: frame1367Data,
    frame1362Props: frame1368Data,
    frame1363Props: frame1369Data,
    frame1364Props: frame13610Data,
    toggle2Props: toggle19Data,
    frame1365Props: frame13611Data,
    frame1366Props: frame13612Data,
    frame1367Props: frame13613Data,
    frame1368Props: frame13614Data,
    toggle3Props: toggle20Data
};
const frame1172220Data = {
    children: "Existing Case"
};
const frame1162221Data = {
    children: "Reference Cases"
};
const frame1132228Data = {
    className: "frame-113-36"
};
const navItems311Data = {
    className: "nav-items-3-11",
    frame1172Props: frame1172220Data,
    frame1162Props: frame1162221Data,
    frame1132Props: frame1132228Data
};
const frame11311Data = {
    className: "frame-113-47"
};
const frame11719Data = {
    className: "frame-117-89"
};
const buttonSecondary21Data = {
    children: "Emploi/Relation Employeur- employ\xe9 1",
    className: ""
};
const toggle21Data = {
    className: "toggle",
    buttonSecondaryProps: buttonSecondary21Data
};
const ouinon15Data = {
    yes: "Yes",
    place: "No"
};
const frame13615Data = {
    ouinonProps: ouinon15Data
};
const ouinon16Data = {
    yes: "Yes",
    place: "No"
};
const frame13616Data = {
    ouinonProps: ouinon16Data
};
const ouinon17Data = {
    yes: "Yes",
    place: "No"
};
const frame13617Data = {
    ouinonProps: ouinon17Data
};
const buttonSecondary22Data = {
    children: "Emploi/Relation Employeur- employ\xe9 2",
    className: ""
};
const toggle22Data = {
    className: "toggle",
    buttonSecondaryProps: buttonSecondary22Data
};
const ouinon18Data = {
    yes: "Yes",
    place: "No"
};
const frame13618Data = {
    ouinonProps: ouinon18Data
};
const ouinon19Data = {
    yes: "Yes",
    place: "No"
};
const frame13619Data = {
    className: "frame-153",
    ouinonProps: ouinon19Data
};
const frame1331Data = {
    frame136Props: frame13619Data
};
const frame1441Data = {
    frame133Props: frame1331Data
};
const ouinon20Data = {
    yes: "Yes",
    place: "No"
};
const frame13620Data = {
    ouinonProps: ouinon20Data
};
const ouinon21Data = {
    yes: "Yes",
    place: "No"
};
const frame13621Data = {
    ouinonProps: ouinon21Data
};
const buttonSecondary23Data = {
    children: "1/6",
    className: "button-secondary-58"
};
const toggle23Data = {
    className: "toggle-42",
    buttonSecondaryProps: buttonSecondary23Data
};
const social1Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1-43@2x.png",
    pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
    inputType1: "text",
    inputPlaceholder1: "Connaissez vous votre bilan carbone?",
    inputType2: "text",
    inputPlaceholder2: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType3: "text",
    inputPlaceholder3: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    inputType4: "text",
    inputPlaceholder4: "Connaissez vous votre bilan carbone?",
    inputType5: "text",
    inputPlaceholder5: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType6: "text",
    inputPlaceholder6: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    inputType7: "text",
    inputPlaceholder7: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    navItems3Props: navItems311Data,
    frame113Props: frame11311Data,
    frame117Props: frame11719Data,
    toggle1Props: toggle21Data,
    frame1361Props: frame13615Data,
    frame1362Props: frame13616Data,
    frame1363Props: frame13617Data,
    toggle2Props: toggle22Data,
    frame1364Props: frame13618Data,
    frame144Props: frame1441Data,
    frame1365Props: frame13620Data,
    frame1366Props: frame13621Data,
    toggle3Props: toggle23Data
};
const navItems28Data = {
    className: "nav-items-2-9"
};
const frame1172221Data = {
    children: "Existing Case"
};
const frame1162222Data = {
    children: "Reference Cases"
};
const frame1132229Data = {
    className: ""
};
const navItems312Data = {
    className: "nav-items-3-12",
    frame1172Props: frame1172221Data,
    frame1162Props: frame1162222Data,
    frame1132Props: frame1132229Data
};
const buttonSecondary24Data = {
    children: "Artificial Intellignece (AI) 1",
    className: ""
};
const toggle24Data = {
    className: "toggle-1",
    buttonSecondaryProps: buttonSecondary24Data
};
const ouinon22Data = {
    yes: "Yes",
    place: "No"
};
const frame13622Data = {
    ouinonProps: ouinon22Data
};
const ouinon23Data = {
    yes: "Yes",
    place: "No"
};
const frame13623Data = {
    ouinonProps: ouinon23Data
};
const ouinon24Data = {
    yes: "Yes",
    place: "No"
};
const frame13624Data = {
    ouinonProps: ouinon24Data
};
const ouinon25Data = {
    yes: "Yes",
    place: "No"
};
const frame13625Data = {
    ouinonProps: ouinon25Data
};
const buttonSecondary25Data = {
    children: "Artificial Intellignece (AI) 2",
    className: ""
};
const toggle25Data = {
    className: "toggle-1",
    buttonSecondaryProps: buttonSecondary25Data
};
const ouinon26Data = {
    yes: "Yes",
    place: "No"
};
const frame13626Data = {
    ouinonProps: ouinon26Data
};
const ouinon27Data = {
    yes: "Yes",
    place: "No"
};
const frame13627Data = {
    className: "frame-153-1",
    ouinonProps: ouinon27Data
};
const frame1332Data = {
    frame136Props: frame13627Data
};
const frame1442Data = {
    frame133Props: frame1332Data
};
const ouinon28Data = {
    yes: "Yes",
    place: "No"
};
const frame13628Data = {
    ouinonProps: ouinon28Data
};
const buttonSecondary26Data = {
    children: "1/4",
    className: "button-secondary-59"
};
const toggle26Data = {
    className: "toggle-43",
    buttonSecondaryProps: buttonSecondary26Data
};
const modernization1Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
    inputType1: "text",
    inputPlaceholder1: "Connaissez vous votre bilan carbone?",
    inputType2: "text",
    inputPlaceholder2: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType3: "text",
    inputPlaceholder3: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    inputType4: "text",
    inputPlaceholder4: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    inputType5: "text",
    inputPlaceholder5: "Connaissez vous votre bilan carbone?",
    inputType6: "text",
    inputPlaceholder6: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType7: "text",
    inputPlaceholder7: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    navItems2Props: navItems28Data,
    navItems3Props: navItems312Data,
    toggle1Props: toggle24Data,
    frame1361Props: frame13622Data,
    frame1362Props: frame13623Data,
    frame1363Props: frame13624Data,
    frame1364Props: frame13625Data,
    toggle2Props: toggle25Data,
    frame1365Props: frame13626Data,
    frame144Props: frame1442Data,
    frame1366Props: frame13628Data,
    toggle3Props: toggle26Data
};
const frame1172222Data = {
    children: "Existing Case"
};
const frame1162223Data = {
    children: "Reference Cases"
};
const frame1132230Data = {
    className: ""
};
const navItems313Data = {
    className: "nav-items-3-13",
    frame1172Props: frame1172222Data,
    frame1162Props: frame1162223Data,
    frame1132Props: frame1132230Data
};
const buttonSecondary27Data = {
    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "Fair information and contract practices",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "and contracts"
        ]
    }),
    className: "button-secondary-60"
};
const toggle27Data = {
    className: "toggle-44",
    buttonSecondaryProps: buttonSecondary27Data
};
const ouinon29Data = {
    yes: "Yes",
    place: "No"
};
const frame13629Data = {
    ouinonProps: ouinon29Data
};
const ouinon30Data = {
    yes: "Yes",
    place: "No"
};
const frame13630Data = {
    ouinonProps: ouinon30Data
};
const ouinon31Data = {
    yes: "Yes",
    place: "No"
};
const frame13631Data = {
    ouinonProps: ouinon31Data
};
const buttonSecondary28Data = {
    children: "Protection of the health and safety of customers/consumers",
    className: "button-secondary-61"
};
const toggle28Data = {
    className: "toggle-45",
    buttonSecondaryProps: buttonSecondary28Data
};
const ouinon32Data = {
    yes: "Yes",
    place: "No"
};
const frame13632Data = {
    ouinonProps: ouinon32Data
};
const ouinon33Data = {
    yes: "Yes",
    place: "No"
};
const frame13633Data = {
    ouinonProps: ouinon33Data
};
const ouinon34Data = {
    yes: "Yes",
    place: "No"
};
const frame13634Data = {
    ouinonProps: ouinon34Data
};
const buttonSecondary29Data = {
    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "Customer / consumer data protection",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "consumers"
        ]
    }),
    className: "button-secondary-62"
};
const toggle29Data = {
    className: "toggle-46",
    buttonSecondaryProps: buttonSecondary29Data
};
const ouinon35Data = {
    yes: "Yes",
    place: "No"
};
const frame13635Data = {
    ouinonProps: ouinon35Data
};
const ouinon36Data = {
    yes: "Yes",
    place: "No"
};
const frame13636Data = {
    className: "frame-153-2",
    ouinonProps: ouinon36Data
};
const frame1333Data = {
    frame136Props: frame13636Data
};
const frame1443Data = {
    frame133Props: frame1333Data
};
const ouinon37Data = {
    yes: "Yes",
    place: "No"
};
const frame13637Data = {
    ouinonProps: ouinon37Data
};
const buttonSecondary30Data = {
    children: "1/2",
    className: "button-secondary-63"
};
const toggle30Data = {
    className: "toggle-47",
    buttonSecondaryProps: buttonSecondary30Data
};
const clientConsommateur1Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
    inputType1: "text",
    inputPlaceholder1: "Connaissez vous votre bilan carbone?",
    inputType2: "text",
    inputPlaceholder2: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType3: "text",
    inputPlaceholder3: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    inputType4: "text",
    inputPlaceholder4: "Connaissez vous votre bilan carbone?",
    inputType5: "text",
    inputPlaceholder5: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType6: "text",
    inputPlaceholder6: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    inputType7: "text",
    inputPlaceholder7: "Connaissez vous votre bilan carbone?",
    inputType8: "text",
    inputPlaceholder8: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType9: "text",
    inputPlaceholder9: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    navItems3Props: navItems313Data,
    toggle1Props: toggle27Data,
    frame1361Props: frame13629Data,
    frame1362Props: frame13630Data,
    frame1363Props: frame13631Data,
    toggle2Props: toggle28Data,
    frame1364Props: frame13632Data,
    frame1365Props: frame13633Data,
    frame1366Props: frame13634Data,
    toggle3Props: toggle29Data,
    frame1367Props: frame13635Data,
    frame144Props: frame1443Data,
    frame1368Props: frame13637Data,
    toggle4Props: toggle30Data
};
const frame1172223Data = {
    children: "Existing Case"
};
const frame1162224Data = {
    children: "Reference Cases"
};
const frame1132231Data = {
    className: ""
};
const navItems314Data = {
    className: "nav-items-3-14",
    frame1172Props: frame1172223Data,
    frame1162Props: frame1162224Data,
    frame1132Props: frame1132231Data
};
const buttonSecondary31Data = {
    children: "Procurement 1",
    className: ""
};
const toggle31Data = {
    className: "toggle-48",
    buttonSecondaryProps: buttonSecondary31Data
};
const frame422Data = {
    className: ""
};
const frame432Data = {
    className: ""
};
const ouinon210Data = {
    frame42Props: frame422Data,
    frame43Props: frame432Data
};
const frame423Data = {
    className: ""
};
const frame433Data = {
    className: ""
};
const ouinon211Data = {
    className: "ouinon-49",
    frame42Props: frame423Data,
    frame43Props: frame433Data
};
const buttonSecondary32Data = {
    children: "Procurement 2",
    className: ""
};
const toggle32Data = {
    className: "toggle-49",
    buttonSecondaryProps: buttonSecondary32Data
};
const frame424Data = {
    className: "frame-4-53-1"
};
const frame434Data = {
    className: "frame-4-61-1"
};
const ouinon212Data = {
    className: "ouinon-46",
    frame42Props: frame424Data,
    frame43Props: frame434Data
};
const frame425Data = {
    className: "frame-4-53"
};
const frame435Data = {
    className: "frame-4-61"
};
const ouinon213Data = {
    className: "ouinon-46",
    frame42Props: frame425Data,
    frame43Props: frame435Data
};
const buttonSecondary33Data = {
    children: "Procurement 3",
    className: ""
};
const toggle33Data = {
    className: "toggle-50",
    buttonSecondaryProps: buttonSecondary33Data
};
const ouinon38Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-22-1"
};
const ouinon39Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-22-2"
};
const ouinon40Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-22-3"
};
const ouinon41Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-22"
};
const buttonSecondary34Data = {
    children: "1/2",
    className: "button-secondary-64"
};
const toggle34Data = {
    className: "toggle-51",
    buttonSecondaryProps: buttonSecondary34Data
};
const leadTime1Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
    inputType1: "text",
    inputPlaceholder1: "Connaissez vous votre bilan carbone?",
    inputType2: "text",
    inputPlaceholder2: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType3: "text",
    inputPlaceholder3: "Connaissez vous votre bilan carbone?",
    inputType4: "text",
    inputPlaceholder4: "Connaissez vous votre bilan carbone?",
    inputType5: "text",
    inputPlaceholder5: "Connaissez vous votre bilan carbone?",
    inputType6: "text",
    inputPlaceholder6: "Connaissez vous votre bilan carbone?",
    inputType7: "text",
    inputPlaceholder7: "Connaissez vous votre bilan carbone?",
    inputType8: "text",
    inputPlaceholder8: "Connaissez vous votre bilan carbone?",
    navItems3Props: navItems314Data,
    toggle1Props: toggle31Data,
    ouinon21Props: ouinon210Data,
    ouinon22Props: ouinon211Data,
    toggle2Props: toggle32Data,
    ouinon23Props: ouinon212Data,
    ouinon24Props: ouinon213Data,
    toggle3Props: toggle33Data,
    ouinon1Props: ouinon38Data,
    ouinon2Props: ouinon39Data,
    ouinon3Props: ouinon40Data,
    ouinon4Props: ouinon41Data,
    toggle4Props: toggle34Data
};
const navItems211Data = {
    className: "nav-items-2-12"
};
const frame1172224Data = {
    children: "Existing Case"
};
const frame1162225Data = {
    children: "Reference Cases"
};
const frame1132232Data = {
    className: ""
};
const navItems315Data = {
    className: "nav-items-3-15",
    frame1172Props: frame1172224Data,
    frame1162Props: frame1162225Data,
    frame1132Props: frame1132232Data
};
const buttonSecondary35Data = {
    children: "Stock  1",
    className: ""
};
const toggle35Data = {
    className: "toggle-52",
    buttonSecondaryProps: buttonSecondary35Data
};
const ouinon42Data = {
    yes: "Yes",
    place: "No"
};
const frame13638Data = {
    ouinonProps: ouinon42Data
};
const ouinon43Data = {
    yes: "Yes",
    place: "No"
};
const frame13639Data = {
    ouinonProps: ouinon43Data
};
const ouinon44Data = {
    yes: "Yes",
    place: "No"
};
const frame13640Data = {
    ouinonProps: ouinon44Data
};
const ouinon45Data = {
    yes: "Yes",
    place: "No"
};
const frame13641Data = {
    ouinonProps: ouinon45Data
};
const buttonSecondary36Data = {
    children: "Stock 2",
    className: ""
};
const toggle36Data = {
    className: "toggle-53",
    buttonSecondaryProps: buttonSecondary36Data
};
const ouinon46Data = {
    yes: "Yes",
    place: "No"
};
const frame13642Data = {
    ouinonProps: ouinon46Data
};
const ouinon47Data = {
    yes: "Yes",
    place: "No"
};
const frame13643Data = {
    ouinonProps: ouinon47Data
};
const ouinon48Data = {
    yes: "Yes",
    place: "No"
};
const frame13644Data = {
    ouinonProps: ouinon48Data
};
const ouinon49Data = {
    yes: "Yes",
    place: "No"
};
const frame13645Data = {
    ouinonProps: ouinon49Data
};
const buttonSecondary37Data = {
    children: "Market",
    className: ""
};
const toggle37Data = {
    className: "toggle-54",
    buttonSecondaryProps: buttonSecondary37Data
};
const ouinon50Data = {
    yes: "Yes",
    place: "No"
};
const frame13646Data = {
    ouinonProps: ouinon50Data
};
const ouinon51Data = {
    yes: "Yes",
    place: "No"
};
const frame13647Data = {
    className: "frame-153-3",
    ouinonProps: ouinon51Data
};
const frame1334Data = {
    frame136Props: frame13647Data
};
const frame1444Data = {
    frame133Props: frame1334Data
};
const ouinon52Data = {
    yes: "Yes",
    place: "No"
};
const frame13648Data = {
    ouinonProps: ouinon52Data
};
const ouinon53Data = {
    yes: "Yes",
    place: "No"
};
const frame13649Data = {
    ouinonProps: ouinon53Data
};
const ouinon54Data = {
    yes: "Yes",
    place: "No"
};
const frame13650Data = {
    ouinonProps: ouinon54Data
};
const buttonSecondary38Data = {
    children: "1/2",
    className: "button-secondary-65"
};
const toggle38Data = {
    className: "toggle-55",
    buttonSecondaryProps: buttonSecondary38Data
};
const cost1Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
    inputType1: "text",
    inputPlaceholder1: "Connaissez vous votre bilan carbone?",
    inputType2: "text",
    inputPlaceholder2: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType3: "text",
    inputPlaceholder3: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    inputType4: "text",
    inputPlaceholder4: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    inputType5: "text",
    inputPlaceholder5: "Connaissez vous votre bilan carbone?",
    inputType6: "text",
    inputPlaceholder6: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType7: "text",
    inputPlaceholder7: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    inputType8: "text",
    inputPlaceholder8: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    inputType9: "text",
    inputPlaceholder9: "Connaissez vous votre bilan carbone?",
    inputType10: "text",
    inputPlaceholder10: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType11: "text",
    inputPlaceholder11: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    inputType12: "text",
    inputPlaceholder12: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    inputType13: "text",
    inputPlaceholder13: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    navItems2Props: navItems211Data,
    navItems3Props: navItems315Data,
    toggle1Props: toggle35Data,
    frame1361Props: frame13638Data,
    frame1362Props: frame13639Data,
    frame1363Props: frame13640Data,
    frame1364Props: frame13641Data,
    toggle2Props: toggle36Data,
    frame1365Props: frame13642Data,
    frame1366Props: frame13643Data,
    frame1367Props: frame13644Data,
    frame1368Props: frame13645Data,
    toggle3Props: toggle37Data,
    frame1369Props: frame13646Data,
    frame144Props: frame1444Data,
    frame13610Props: frame13648Data,
    frame13611Props: frame13649Data,
    frame13612Props: frame13650Data,
    toggle4Props: toggle38Data
};
const navItems212Data = {
    className: "nav-items-2-13"
};
const frame1172225Data = {
    children: "Existing Case"
};
const frame1162226Data = {
    children: "Reference Cases"
};
const frame1132233Data = {
    className: ""
};
const navItems316Data = {
    className: "nav-items-3-16",
    frame1172Props: frame1172225Data,
    frame1162Props: frame1162226Data,
    frame1132Props: frame1132233Data
};
const buttonSecondary39Data = {
    children: "Customer Requirements 1",
    className: ""
};
const toggle39Data = {
    className: "toggle-56",
    buttonSecondaryProps: buttonSecondary39Data
};
const ouinon55Data = {
    yes: "Yes",
    place: "No"
};
const frame13651Data = {
    ouinonProps: ouinon55Data
};
const ouinon56Data = {
    yes: "Yes",
    place: "No"
};
const frame13652Data = {
    ouinonProps: ouinon56Data
};
const ouinon57Data = {
    yes: "Yes",
    place: "No"
};
const frame13653Data = {
    ouinonProps: ouinon57Data
};
const buttonSecondary40Data = {
    children: "Customer Requirements 2",
    className: ""
};
const toggle40Data = {
    className: "toggle-57",
    buttonSecondaryProps: buttonSecondary40Data
};
const ouinon58Data = {
    yes: "Yes",
    place: "No"
};
const frame13654Data = {
    ouinonProps: ouinon58Data
};
const ouinon59Data = {
    yes: "Yes",
    place: "No"
};
const frame13655Data = {
    ouinonProps: ouinon59Data
};
const ouinon60Data = {
    yes: "Yes",
    place: "No"
};
const frame13656Data = {
    ouinonProps: ouinon60Data
};
const buttonSecondary41Data = {
    children: "Customer Requirements 3",
    className: ""
};
const toggle41Data = {
    className: "toggle-58",
    buttonSecondaryProps: buttonSecondary41Data
};
const ouinon61Data = {
    yes: "Yes",
    place: "No"
};
const frame13657Data = {
    ouinonProps: ouinon61Data
};
const ouinon62Data = {
    yes: "Yes",
    place: "No"
};
const frame13658Data = {
    className: "frame-153-4",
    ouinonProps: ouinon62Data
};
const frame1335Data = {
    frame136Props: frame13658Data
};
const frame1445Data = {
    frame133Props: frame1335Data
};
const ouinon63Data = {
    yes: "Yes",
    place: "No"
};
const frame13659Data = {
    ouinonProps: ouinon63Data
};
const buttonSecondary42Data = {
    children: "1/7",
    className: "button-secondary-66"
};
const toggle42Data = {
    className: "toggle-59",
    buttonSecondaryProps: buttonSecondary42Data
};
const quality1Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
    inputType1: "text",
    inputPlaceholder1: "Connaissez vous votre bilan carbone?",
    inputType2: "text",
    inputPlaceholder2: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType3: "text",
    inputPlaceholder3: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    inputType4: "text",
    inputPlaceholder4: "Connaissez vous votre bilan carbone?",
    inputType5: "text",
    inputPlaceholder5: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType6: "text",
    inputPlaceholder6: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    inputType7: "text",
    inputPlaceholder7: "Connaissez vous votre bilan carbone?",
    inputType8: "text",
    inputPlaceholder8: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType9: "text",
    inputPlaceholder9: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    navItems2Props: navItems212Data,
    navItems3Props: navItems316Data,
    toggle1Props: toggle39Data,
    frame1361Props: frame13651Data,
    frame1362Props: frame13652Data,
    frame1363Props: frame13653Data,
    toggle2Props: toggle40Data,
    frame1364Props: frame13654Data,
    frame1365Props: frame13655Data,
    frame1366Props: frame13656Data,
    toggle3Props: toggle41Data,
    frame1367Props: frame13657Data,
    frame144Props: frame1445Data,
    frame1368Props: frame13659Data,
    toggle4Props: toggle42Data
};
const frame1172226Data = {
    children: "Existing Case"
};
const frame1162227Data = {
    children: "Reference Cases"
};
const frame1132234Data = {
    className: ""
};
const navItems317Data = {
    className: "nav-items-3-17",
    frame1172Props: frame1172226Data,
    frame1162Props: frame1162227Data,
    frame1132Props: frame1132234Data
};
const buttonSecondary43Data = {
    children: "External Providers 1",
    className: ""
};
const toggle43Data = {
    className: "toggle-28",
    buttonSecondaryProps: buttonSecondary43Data
};
const ouinon64Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-24-1"
};
const ouinon65Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-24-2"
};
const ouinon66Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-24-3"
};
const buttonSecondary44Data = {
    children: "External Providers 2",
    className: ""
};
const toggle44Data = {
    className: "toggle-28",
    buttonSecondaryProps: buttonSecondary44Data
};
const ouinon67Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-24-4"
};
const ouinon68Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-29"
};
const buttonSecondary45Data = {
    children: "Process Approach",
    className: ""
};
const toggle45Data = {
    className: "toggle-60",
    buttonSecondaryProps: buttonSecondary45Data
};
const ouinon69Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-24-5"
};
const ouinon70Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-24-6"
};
const ouinon71Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-24-7"
};
const ouinon72Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-24"
};
const frame1111Data = {
    toggle1Props: toggle43Data,
    ouinon1Props: ouinon64Data,
    ouinon2Props: ouinon65Data,
    ouinon3Props: ouinon66Data,
    toggle2Props: toggle44Data,
    ouinon4Props: ouinon67Data,
    ouinon5Props: ouinon68Data,
    toggle3Props: toggle45Data,
    ouinon6Props: ouinon69Data,
    ouinon7Props: ouinon70Data,
    ouinon8Props: ouinon71Data,
    ouinon9Props: ouinon72Data
};
const buttonSecondary46Data = {
    children: "7/7",
    className: "button-secondary-67"
};
const toggle46Data = {
    className: "toggle-61",
    buttonSecondaryProps: buttonSecondary46Data
};
const frame1172227Data = {
    children: "Existing Case"
};
const frame1162228Data = {
    children: "Reference Cases"
};
const frame1132235Data = {
    className: ""
};
const navItems318Data = {
    className: "nav-items-3-18",
    frame1172Props: frame1172227Data,
    frame1162Props: frame1162228Data,
    frame1132Props: frame1132235Data
};
const buttonSecondary47Data = {
    children: "Pollution de l'eau et des Sols",
    className: ""
};
const toggle47Data = {
    className: "toggle-2",
    buttonSecondaryProps: buttonSecondary47Data
};
const ouinon73Data = {
    yes: "Yes",
    place: "No"
};
const frame13660Data = {
    className: "frame-136",
    ouinonProps: ouinon73Data
};
const frame1336Data = {
    className: "frame-133-2",
    frame136Props: frame13660Data
};
const ouinon74Data = {
    yes: "Yes",
    place: "No"
};
const frame13661Data = {
    className: "frame-130",
    ouinonProps: ouinon74Data
};
const ouinon75Data = {
    yes: "Yes",
    place: "No"
};
const frame13662Data = {
    className: "frame-133",
    ouinonProps: ouinon75Data
};
const ouinon76Data = {
    yes: "Yes",
    place: "No"
};
const frame13663Data = {
    className: "frame-134",
    ouinonProps: ouinon76Data
};
const ouinon77Data = {
    yes: "Yes",
    place: "No"
};
const frame13664Data = {
    className: "frame-133-1",
    ouinonProps: ouinon77Data
};
const buttonSecondary48Data = {
    children: "Pollution de l'air",
    className: ""
};
const toggle48Data = {
    className: "toggle-2",
    buttonSecondaryProps: buttonSecondary48Data
};
const ouinon78Data = {
    yes: "Yes",
    place: "No"
};
const frame13665Data = {
    className: "frame-130-1",
    ouinonProps: ouinon78Data
};
const ouinon79Data = {
    yes: "Yes",
    place: "No"
};
const frame13666Data = {
    className: "frame-130-2",
    ouinonProps: ouinon79Data
};
const ouinon80Data = {
    yes: "Yes",
    place: "No"
};
const frame13667Data = {
    className: "frame-130-3",
    ouinonProps: ouinon80Data
};
const ouinon81Data = {
    yes: "Yes",
    place: "No"
};
const frame13668Data = {
    className: "frame-131",
    ouinonProps: ouinon81Data
};
const ouinon82Data = {
    yes: "Yes",
    place: "No"
};
const frame13669Data = {
    className: "frame-132",
    ouinonProps: ouinon82Data
};
const buttonSecondary49Data = {
    children: "2/5",
    className: "button-secondary-68"
};
const toggle49Data = {
    className: "x25",
    buttonSecondaryProps: buttonSecondary49Data
};
const environmental2Data = {
    inputType1: "text",
    inputPlaceholder1: "Connaissez vous votre bilan carbone?",
    inputType2: "text",
    inputPlaceholder2: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType3: "text",
    inputPlaceholder3: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    inputType4: "text",
    inputPlaceholder4: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    inputType5: "text",
    inputPlaceholder5: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    inputType6: "text",
    inputPlaceholder6: "Connaissez vous votre bilan carbone?",
    inputType7: "text",
    inputPlaceholder7: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType8: "text",
    inputPlaceholder8: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    inputType9: "text",
    inputPlaceholder9: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    inputType10: "text",
    inputPlaceholder10: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    inputType11: "text",
    inputPlaceholder11: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    navItems3Props: navItems318Data,
    toggle1Props: toggle47Data,
    frame133Props: frame1336Data,
    frame1361Props: frame13661Data,
    frame1362Props: frame13662Data,
    frame1363Props: frame13663Data,
    frame1364Props: frame13664Data,
    toggle2Props: toggle48Data,
    frame1365Props: frame13665Data,
    frame1366Props: frame13666Data,
    frame1367Props: frame13667Data,
    frame1368Props: frame13668Data,
    frame1369Props: frame13669Data,
    toggle3Props: toggle49Data
};
const frame1172228Data = {
    children: "Existing Case"
};
const frame1162229Data = {
    children: "Reference Cases"
};
const frame1132236Data = {
    className: ""
};
const navItems319Data = {
    className: "nav-items-3-19",
    frame1172Props: frame1172228Data,
    frame1162Props: frame1162229Data,
    frame1132Props: frame1132236Data
};
const buttonSecondary50Data = {
    children: "Energie",
    className: ""
};
const toggle50Data = {
    className: "toggle-62",
    buttonSecondaryProps: buttonSecondary50Data
};
const ouinon83Data = {
    yes: "Yes",
    place: "No",
    className: "ouinon-30"
};
const ouinon84Data = {
    yes: "Yes",
    place: "No",
    className: "ouinon-20"
};
const ouinon85Data = {
    yes: "Yes",
    place: "No",
    className: "ouinon-20"
};
const buttonSecondary51Data = {
    children: "Biodiversit\xe9",
    className: ""
};
const toggle51Data = {
    className: "toggle-63",
    buttonSecondaryProps: buttonSecondary51Data
};
const ouinon86Data = {
    yes: "Yes",
    place: "No",
    className: "ouinon-21"
};
const ouinon87Data = {
    yes: "Yes",
    place: "No",
    className: "ouinon-31"
};
const ouinon88Data = {
    yes: "Yes",
    place: "No",
    className: "ouinon-21"
};
const buttonSecondary52Data = {
    children: "3/5",
    className: "button-secondary-69"
};
const toggle52Data = {
    className: "toggle-64",
    buttonSecondaryProps: buttonSecondary52Data
};
const environmental3Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    inputType1: "text",
    inputPlaceholder1: "Connaissez vous votre bilan carbone?",
    inputType2: "text",
    inputPlaceholder2: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType3: "text",
    inputPlaceholder3: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    inputType4: "text",
    inputPlaceholder4: "Connaissez vous votre bilan carbone?",
    inputType5: "text",
    inputPlaceholder5: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType6: "text",
    inputPlaceholder6: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    navItems3Props: navItems319Data,
    toggle1Props: toggle50Data,
    ouinon1Props: ouinon83Data,
    ouinon2Props: ouinon84Data,
    ouinon3Props: ouinon85Data,
    toggle2Props: toggle51Data,
    ouinon4Props: ouinon86Data,
    ouinon5Props: ouinon87Data,
    ouinon6Props: ouinon88Data,
    toggle3Props: toggle52Data
};
const frame1172229Data = {
    children: "Existing Case"
};
const frame1162230Data = {
    children: "Reference Cases"
};
const frame1132237Data = {
    className: ""
};
const navItems320Data = {
    className: "nav-items-3-20",
    frame1172Props: frame1172229Data,
    frame1162Props: frame1162230Data,
    frame1132Props: frame1132237Data
};
const buttonSecondary53Data = {
    children: "Emploi/Relation Employeur- employ\xe9 3",
    className: ""
};
const toggle53Data = {
    className: "toggle-65",
    buttonSecondaryProps: buttonSecondary53Data
};
const ouinon89Data = {
    yes: "Yes",
    place: "No"
};
const frame13670Data = {
    ouinonProps: ouinon89Data
};
const ouinon90Data = {
    yes: "Yes",
    place: "No"
};
const frame13671Data = {
    ouinonProps: ouinon90Data
};
const ouinon91Data = {
    yes: "Yes",
    place: "No"
};
const frame13672Data = {
    ouinonProps: ouinon91Data
};
const buttonSecondary54Data = {
    children: "2/6",
    className: "button-secondary-71"
};
const toggle54Data = {
    className: "toggle-66",
    buttonSecondaryProps: buttonSecondary54Data
};
const social2Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    inputType1: "text",
    inputPlaceholder1: "Connaissez vous votre bilan carbone?",
    inputType2: "text",
    inputPlaceholder2: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType3: "text",
    inputPlaceholder3: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    navItems3Props: navItems320Data,
    toggle1Props: toggle53Data,
    frame1361Props: frame13670Data,
    frame1362Props: frame13671Data,
    frame1363Props: frame13672Data,
    toggle2Props: toggle54Data
};
const frame1172230Data = {
    children: "Existing Case"
};
const frame1162231Data = {
    children: "Reference Cases"
};
const frame1132238Data = {
    className: ""
};
const navItems321Data = {
    className: "nav-items-3-21",
    frame1172Props: frame1172230Data,
    frame1162Props: frame1162231Data,
    frame1132Props: frame1132238Data
};
const buttonSecondary55Data = {
    children: "Big data and cloud computing 1",
    className: ""
};
const toggle55Data = {
    className: "toggle-3",
    buttonSecondaryProps: buttonSecondary55Data
};
const ouinon92Data = {
    yes: "Yes",
    place: "No"
};
const frame13673Data = {
    ouinonProps: ouinon92Data
};
const ouinon93Data = {
    yes: "Yes",
    place: "No"
};
const frame13674Data = {
    ouinonProps: ouinon93Data
};
const ouinon94Data = {
    yes: "Yes",
    place: "No"
};
const frame13675Data = {
    ouinonProps: ouinon94Data
};
const buttonSecondary56Data = {
    children: "Big data and cloud computing 2",
    className: ""
};
const toggle56Data = {
    className: "toggle-3",
    buttonSecondaryProps: buttonSecondary56Data
};
const ouinon95Data = {
    yes: "Yes",
    place: "No"
};
const frame13676Data = {
    ouinonProps: ouinon95Data
};
const ouinon96Data = {
    yes: "Yes",
    place: "No"
};
const frame13677Data = {
    className: "frame-153-5",
    ouinonProps: ouinon96Data
};
const frame1337Data = {
    frame136Props: frame13677Data
};
const frame1446Data = {
    frame133Props: frame1337Data
};
const ouinon97Data = {
    yes: "Yes",
    place: "No"
};
const frame13678Data = {
    ouinonProps: ouinon97Data
};
const ouinon98Data = {
    yes: "Yes",
    place: "No"
};
const frame13679Data = {
    ouinonProps: ouinon98Data
};
const buttonSecondary57Data = {
    children: "2/4",
    className: "button-secondary-72"
};
const toggle57Data = {
    className: "toggle-67",
    buttonSecondaryProps: buttonSecondary57Data
};
const modernization2Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    inputType1: "text",
    inputPlaceholder1: "Connaissez vous votre bilan carbone?",
    inputType2: "text",
    inputPlaceholder2: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType3: "text",
    inputPlaceholder3: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    inputType4: "text",
    inputPlaceholder4: "Connaissez vous votre bilan carbone?",
    inputType5: "text",
    inputPlaceholder5: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType6: "text",
    inputPlaceholder6: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    inputType7: "text",
    inputPlaceholder7: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    next: "Next",
    navItems3Props: navItems321Data,
    toggle1Props: toggle55Data,
    frame1361Props: frame13673Data,
    frame1362Props: frame13674Data,
    frame1363Props: frame13675Data,
    toggle2Props: toggle56Data,
    frame1364Props: frame13676Data,
    frame144Props: frame1446Data,
    frame1365Props: frame13678Data,
    frame1366Props: frame13679Data,
    toggle3Props: toggle57Data
};
const frame1172231Data = {
    children: "Existing Case"
};
const frame1162232Data = {
    children: "Reference Cases"
};
const frame1132239Data = {
    className: ""
};
const navItems322Data = {
    className: "nav-items-3-22",
    frame1172Props: frame1172231Data,
    frame1162Props: frame1162232Data,
    frame1132Props: frame1132239Data
};
const buttonSecondary58Data = {
    children: "Resources",
    className: ""
};
const toggle58Data = {
    className: "toggle-68",
    buttonSecondaryProps: buttonSecondary58Data
};
const ouinon99Data = {
    yes: "Yes",
    place: "No"
};
const frame13680Data = {
    ouinonProps: ouinon99Data
};
const ouinon100Data = {
    yes: "Yes",
    place: "No"
};
const frame13681Data = {
    ouinonProps: ouinon100Data
};
const ouinon101Data = {
    yes: "Yes",
    place: "No"
};
const frame13682Data = {
    ouinonProps: ouinon101Data
};
const ouinon102Data = {
    yes: "Yes",
    place: "No"
};
const frame13683Data = {
    ouinonProps: ouinon102Data
};
const ouinon103Data = {
    yes: "Yes",
    place: "No"
};
const frame13684Data = {
    ouinonProps: ouinon103Data
};
const buttonSecondary59Data = {
    children: "Product 1",
    className: ""
};
const toggle59Data = {
    className: "toggle-69",
    buttonSecondaryProps: buttonSecondary59Data
};
const ouinon104Data = {
    yes: "Yes",
    place: "No"
};
const frame13685Data = {
    ouinonProps: ouinon104Data
};
const ouinon105Data = {
    yes: "Yes",
    place: "No"
};
const frame13686Data = {
    ouinonProps: ouinon105Data
};
const ouinon106Data = {
    yes: "Yes",
    place: "No"
};
const frame13687Data = {
    ouinonProps: ouinon106Data
};
const ouinon107Data = {
    yes: "Yes",
    place: "No"
};
const frame13688Data = {
    ouinonProps: ouinon107Data
};
const buttonSecondary60Data = {
    children: "2/2",
    className: "button-secondary-73"
};
const toggle60Data = {
    className: "toggle-70",
    buttonSecondaryProps: buttonSecondary60Data
};
const cost2Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    inputType1: "text",
    inputPlaceholder1: "Connaissez vous votre bilan carbone?",
    inputType2: "text",
    inputPlaceholder2: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType3: "text",
    inputPlaceholder3: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    inputType4: "text",
    inputPlaceholder4: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    inputType5: "text",
    inputPlaceholder5: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    inputType6: "text",
    inputPlaceholder6: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    inputType7: "text",
    inputPlaceholder7: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    inputType8: "text",
    inputPlaceholder8: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    inputType9: "text",
    inputPlaceholder9: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    qualityCriteria: "Quality  criteria",
    navItems3Props: navItems322Data,
    toggle1Props: toggle58Data,
    frame1361Props: frame13680Data,
    frame1362Props: frame13681Data,
    frame1363Props: frame13682Data,
    frame1364Props: frame13683Data,
    frame1365Props: frame13684Data,
    toggle2Props: toggle59Data,
    frame1366Props: frame13685Data,
    frame1367Props: frame13686Data,
    frame1368Props: frame13687Data,
    frame1369Props: frame13688Data,
    toggle3Props: toggle60Data
};
const frame1172232Data = {
    children: "Existing Case"
};
const frame1162233Data = {
    children: "Reference Cases"
};
const frame1132240Data = {
    className: ""
};
const navItems323Data = {
    className: "nav-items-3-23",
    frame1172Props: frame1172232Data,
    frame1162Props: frame1162233Data,
    frame1132Props: frame1132240Data
};
const buttonSecondary61Data = {
    children: "Manufacturing",
    className: ""
};
const toggle61Data = {
    className: "toggle-71",
    buttonSecondaryProps: buttonSecondary61Data
};
const ouinon108Data = {
    yes: "Yes",
    place: "No"
};
const frame13689Data = {
    ouinonProps: ouinon108Data
};
const ouinon109Data = {
    yes: "Yes",
    place: "No"
};
const frame13690Data = {
    ouinonProps: ouinon109Data
};
const ouinon110Data = {
    yes: "Yes",
    place: "No"
};
const frame13691Data = {
    ouinonProps: ouinon110Data
};
const buttonSecondary62Data = {
    children: "Storage",
    className: ""
};
const toggle62Data = {
    className: "toggle-72",
    buttonSecondaryProps: buttonSecondary62Data
};
const ouinon111Data = {
    yes: "Yes",
    place: "No"
};
const frame13692Data = {
    ouinonProps: ouinon111Data
};
const ouinon112Data = {
    yes: "Yes",
    place: "No"
};
const frame13693Data = {
    ouinonProps: ouinon112Data
};
const ouinon113Data = {
    yes: "Yes",
    place: "No"
};
const frame13694Data = {
    ouinonProps: ouinon113Data
};
const buttonSecondary63Data = {
    children: "Delivery",
    className: ""
};
const toggle63Data = {
    className: "toggle-73",
    buttonSecondaryProps: buttonSecondary63Data
};
const ouinon114Data = {
    yes: "Yes",
    place: "No"
};
const frame13695Data = {
    ouinonProps: ouinon114Data
};
const ouinon115Data = {
    yes: "Yes",
    place: "No"
};
const frame13696Data = {
    className: "frame-153-6",
    ouinonProps: ouinon115Data
};
const frame1338Data = {
    frame136Props: frame13696Data
};
const frame1447Data = {
    frame133Props: frame1338Data
};
const ouinon116Data = {
    yes: "Yes",
    place: "No"
};
const frame13697Data = {
    ouinonProps: ouinon116Data
};
const ouinon117Data = {
    yes: "Yes",
    place: "No"
};
const frame13698Data = {
    className: "frame-146",
    ouinonProps: ouinon117Data
};
const buttonSecondary64Data = {
    children: "2/2",
    className: "button-secondary-74"
};
const toggle64Data = {
    className: "toggle-74",
    buttonSecondaryProps: buttonSecondary64Data
};
const leadTime2Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    inputType1: "text",
    inputPlaceholder1: "Connaissez vous votre bilan carbone?",
    inputType2: "text",
    inputPlaceholder2: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType3: "text",
    inputPlaceholder3: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    inputType4: "text",
    inputPlaceholder4: "Connaissez vous votre bilan carbone?",
    inputType5: "text",
    inputPlaceholder5: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType6: "text",
    inputPlaceholder6: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    inputType7: "text",
    inputPlaceholder7: "Connaissez vous votre bilan carbone?",
    inputType8: "text",
    inputPlaceholder8: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType9: "text",
    inputPlaceholder9: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    inputType10: "text",
    inputPlaceholder10: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    costCriteria: "Cost criteria",
    navItems3Props: navItems323Data,
    toggle1Props: toggle61Data,
    frame1361Props: frame13689Data,
    frame1362Props: frame13690Data,
    frame1363Props: frame13691Data,
    toggle2Props: toggle62Data,
    frame1364Props: frame13692Data,
    frame1365Props: frame13693Data,
    frame1366Props: frame13694Data,
    toggle3Props: toggle63Data,
    frame1367Props: frame13695Data,
    frame144Props: frame1447Data,
    frame1368Props: frame13697Data,
    frame1369Props: frame13698Data,
    toggle4Props: toggle64Data
};
const frame1172233Data = {
    children: "Existing Case"
};
const frame1162234Data = {
    children: "Reference Cases"
};
const frame1132241Data = {
    className: ""
};
const navItems324Data = {
    className: "nav-items-3-24",
    frame1172Props: frame1172233Data,
    frame1162Props: frame1162234Data,
    frame1132Props: frame1132241Data
};
const buttonSecondary65Data = {
    children: "Traceability",
    className: ""
};
const toggle65Data = {
    className: "toggle-75",
    buttonSecondaryProps: buttonSecondary65Data
};
const ouinon118Data = {
    yes: "Yes",
    place: "No"
};
const frame13699Data = {
    ouinonProps: ouinon118Data
};
const ouinon119Data = {
    yes: "Yes",
    place: "No"
};
const frame136100Data = {
    ouinonProps: ouinon119Data
};
const ouinon120Data = {
    yes: "Yes",
    place: "No"
};
const frame136101Data = {
    ouinonProps: ouinon120Data
};
const ouinon121Data = {
    yes: "Yes",
    place: "No"
};
const frame136102Data = {
    ouinonProps: ouinon121Data
};
const buttonSecondary66Data = {
    children: "Improvement 1",
    className: ""
};
const toggle66Data = {
    className: "toggle-76",
    buttonSecondaryProps: buttonSecondary66Data
};
const ouinon122Data = {
    yes: "Yes",
    place: "No"
};
const frame136103Data = {
    ouinonProps: ouinon122Data
};
const ouinon123Data = {
    yes: "Yes",
    place: "No"
};
const frame136104Data = {
    ouinonProps: ouinon123Data
};
const ouinon124Data = {
    yes: "Yes",
    place: "No"
};
const frame136105Data = {
    ouinonProps: ouinon124Data
};
const ouinon125Data = {
    yes: "Yes",
    place: "No"
};
const frame136106Data = {
    ouinonProps: ouinon125Data
};
const buttonSecondary67Data = {
    children: "Improvement 2",
    className: "button-secondary-75"
};
const toggle67Data = {
    className: "toggle-77",
    buttonSecondaryProps: buttonSecondary67Data
};
const ouinon126Data = {
    yes: "Yes",
    place: "No"
};
const frame136107Data = {
    ouinonProps: ouinon126Data
};
const ouinon127Data = {
    yes: "Yes",
    place: "No"
};
const frame136108Data = {
    ouinonProps: ouinon127Data
};
const ouinon128Data = {
    yes: "Yes",
    place: "No"
};
const frame136109Data = {
    ouinonProps: ouinon128Data
};
const buttonSecondary68Data = {
    children: "6/7",
    className: "button-secondary-76"
};
const toggle68Data = {
    className: "toggle-78",
    buttonSecondaryProps: buttonSecondary68Data
};
const quality6Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    inputType1: "text",
    inputPlaceholder1: "Connaissez vous votre bilan carbone?",
    inputType2: "text",
    inputPlaceholder2: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType3: "text",
    inputPlaceholder3: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    inputType4: "text",
    inputPlaceholder4: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    inputType5: "text",
    inputPlaceholder5: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    inputType6: "text",
    inputPlaceholder6: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    inputType7: "text",
    inputPlaceholder7: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    inputType8: "text",
    inputPlaceholder8: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    inputType9: "text",
    inputPlaceholder9: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    inputType10: "text",
    inputPlaceholder10: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    inputType11: "text",
    inputPlaceholder11: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    navItems3Props: navItems324Data,
    toggle1Props: toggle65Data,
    frame1361Props: frame13699Data,
    frame1362Props: frame136100Data,
    frame1363Props: frame136101Data,
    frame1364Props: frame136102Data,
    toggle2Props: toggle66Data,
    frame1365Props: frame136103Data,
    frame1366Props: frame136104Data,
    frame1367Props: frame136105Data,
    frame1368Props: frame136106Data,
    toggle3Props: toggle67Data,
    frame1369Props: frame136107Data,
    frame13610Props: frame136108Data,
    frame13611Props: frame136109Data,
    toggle4Props: toggle68Data
};
const navItems221Data = {
    className: "nav-items-2-22"
};
const frame1172234Data = {
    children: "Existing Case"
};
const frame1162235Data = {
    children: "Reference Cases"
};
const frame1132242Data = {
    className: ""
};
const navItems325Data = {
    className: "nav-items-3-25",
    frame1172Props: frame1172234Data,
    frame1162Props: frame1162235Data,
    frame1132Props: frame1132242Data
};
const buttonSecondary69Data = {
    children: "2/2",
    className: "button-secondary-77"
};
const toggle69Data = {
    className: "toggle-79",
    buttonSecondaryProps: buttonSecondary69Data
};
const informationalModel3Data = {
    navItems2Props: navItems221Data,
    navItems3Props: navItems325Data,
    toggleProps: toggle69Data
};
const frame1172235Data = {
    children: "Existing Case"
};
const frame1162236Data = {
    children: "Reference Cases"
};
const frame1132243Data = {
    className: ""
};
const navItems326Data = {
    className: "nav-items-3-26",
    frame1172Props: frame1172235Data,
    frame1162Props: frame1162236Data,
    frame1132Props: frame1132243Data
};
const buttonSecondary70Data = {
    children: "1/2",
    className: "button-secondary-31"
};
const toggle70Data = {
    className: "toggle-80",
    buttonSecondaryProps: buttonSecondary70Data
};
const buttonSecondary71Data = {
    children: "Strength of proposal and employee autonomy",
    className: "button-secondary-31"
};
const toggle71Data = {
    className: "toggle-11",
    buttonSecondaryProps: buttonSecondary71Data
};
const group10241Data = {
    line24: "/img/line-24-80.png"
};
const group10242Data = {
    line24: "/img/line-24-81.png"
};
const group10243Data = {
    line24: "/img/line-24-42.png"
};
const group10244Data = {
    line24: "/img/line-24-83.png"
};
const group10245Data = {
    line24: "/img/line-24-84.png"
};
const buttonSecondary72Data = {
    children: "Career evolution",
    className: "button-secondary-31"
};
const toggle72Data = {
    className: "toggle-11",
    buttonSecondaryProps: buttonSecondary72Data
};
const group10246Data = {
    line24: "/img/line-24-5.png",
    className: ""
};
const group10247Data = {
    line24: "/img/line-24-6.png",
    className: ""
};
const group10248Data = {
    line24: "/img/line-24-7.png",
    className: ""
};
const group10249Data = {
    line24: "/img/line-24-8.png",
    className: ""
};
const group10250Data = {
    line24: "/img/line-24-9.png",
    className: ""
};
const frame971Data = {
    toggleProps: toggle72Data,
    group1021Props: group10246Data,
    group1022Props: group10247Data,
    group1023Props: group10248Data,
    group1024Props: group10249Data,
    group1025Props: group10250Data
};
const frame1173216Data = {
    className: "frame-113-49"
};
const informationalModel2Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
    inputType1: "text",
    inputPlaceholder1: "Vos employ\xe9s sont-ils force de propositions concernant les innovations?",
    inputType2: "text",
    inputPlaceholder2: "Avez vous un management qui favorise l cr\xe9ativit\xe9 des salari\xe9s?",
    inputType3: "text",
    inputPlaceholder3: "Garantissez vous l\xe2\u20AC\u2122\xe9galit\xe9 des chances de tous les travailleurs? Comment?",
    inputType4: "text",
    inputPlaceholder4: "Quel management utilisez vous?",
    inputType5: "text",
    inputPlaceholder5: "Est-ce que les journ\xe9es de travail sont adapt\xe9es au volume de travail?",
    navItems3Props: navItems326Data,
    toggle1Props: toggle70Data,
    toggle2Props: toggle71Data,
    group1021Props: group10241Data,
    group1022Props: group10242Data,
    group1023Props: group10243Data,
    group1024Props: group10244Data,
    group1025Props: group10245Data,
    frame97Props: frame971Data,
    frame11732Props: frame1173216Data
};
const navItems225Data = {
    className: "nav-items-2-24"
};
const frame1172236Data = {
    children: "Existing Case"
};
const frame1162237Data = {
    children: "Reference Cases"
};
const frame1132244Data = {
    className: ""
};
const navItems327Data = {
    className: "nav-items-3-27",
    frame1172Props: frame1172236Data,
    frame1162Props: frame1162237Data,
    frame1132Props: frame1132244Data
};
const buttonSecondary73Data = {
    children: "Strength of proposal and employee autonomy",
    className: "button-secondary-32"
};
const toggle73Data = {
    className: "toggle-12",
    buttonSecondaryProps: buttonSecondary73Data
};
const group10251Data = {
    line24: "/img/line-24-80.png"
};
const group10252Data = {
    line24: "/img/line-24-81.png"
};
const group10253Data = {
    line24: "/img/line-24-82.png",
    className: ""
};
const group10254Data = {
    line24: "/img/line-24-83.png",
    className: ""
};
const group10255Data = {
    line24: "/img/line-24-84.png",
    className: ""
};
const frame961Data = {
    toggleProps: toggle73Data,
    group1021Props: group10251Data,
    group1022Props: group10252Data,
    group1023Props: group10253Data,
    group1024Props: group10254Data,
    group1025Props: group10255Data
};
const buttonSecondary74Data = {
    children: "Career evolution",
    className: "button-secondary-32"
};
const toggle74Data = {
    className: "toggle-12",
    buttonSecondaryProps: buttonSecondary74Data
};
const group10256Data = {
    line24: "/img/line-24-5.png",
    className: ""
};
const group10257Data = {
    line24: "/img/line-24-6.png",
    className: ""
};
const group10258Data = {
    line24: "/img/line-24-7.png",
    className: ""
};
const group10259Data = {
    line24: "/img/line-24-18.png",
    className: ""
};
const group10260Data = {
    line24: "/img/line-24-19.png",
    className: ""
};
const frame972Data = {
    className: "frame-97-5",
    toggleProps: toggle74Data,
    group1021Props: group10256Data,
    group1022Props: group10257Data,
    group1023Props: group10258Data,
    group1024Props: group10259Data,
    group1025Props: group10260Data
};
const frame1173217Data = {
    className: "frame-113-50"
};
const buttonSecondary75Data = {
    children: "1/2",
    className: "button-secondary-32"
};
const toggle75Data = {
    className: "toggle-81",
    buttonSecondaryProps: buttonSecondary75Data
};
const processView2Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
    navItems2Props: navItems225Data,
    navItems3Props: navItems327Data,
    frame96Props: frame961Data,
    frame97Props: frame972Data,
    frame11732Props: frame1173217Data,
    toggleProps: toggle75Data
};
const frame1172237Data = {
    children: "Existing Case"
};
const frame1162238Data = {
    children: "Reference Cases"
};
const frame1132245Data = {
    className: ""
};
const navItems328Data = {
    className: "nav-items-3-28",
    frame1172Props: frame1172237Data,
    frame1162Props: frame1162238Data,
    frame1132Props: frame1132245Data
};
const buttonSecondary76Data = {
    children: "Customer Satisfaction 1",
    className: ""
};
const toggle76Data = {
    className: "toggle-82",
    buttonSecondaryProps: buttonSecondary76Data
};
const ouinon129Data = {
    yes: "Yes",
    place: "No"
};
const frame136110Data = {
    ouinonProps: ouinon129Data
};
const ouinon130Data = {
    yes: "Yes",
    place: "No"
};
const frame136111Data = {
    ouinonProps: ouinon130Data
};
const ouinon131Data = {
    yes: "Yes",
    place: "No"
};
const frame136112Data = {
    ouinonProps: ouinon131Data
};
const buttonSecondary77Data = {
    children: "Customer Satisfaction 2",
    className: ""
};
const toggle77Data = {
    className: "toggle-83",
    buttonSecondaryProps: buttonSecondary77Data
};
const ouinon132Data = {
    yes: "Yes",
    place: "No"
};
const frame136113Data = {
    ouinonProps: ouinon132Data
};
const ouinon133Data = {
    yes: "Yes",
    place: "No"
};
const frame136114Data = {
    ouinonProps: ouinon133Data
};
const ouinon134Data = {
    yes: "Yes",
    place: "No"
};
const frame136115Data = {
    ouinonProps: ouinon134Data
};
const buttonSecondary78Data = {
    children: "Communication with employees",
    className: "button-secondary-78"
};
const toggle78Data = {
    className: "toggle-84",
    buttonSecondaryProps: buttonSecondary78Data
};
const ouinon135Data = {
    yes: "Yes",
    place: "No"
};
const frame136116Data = {
    ouinonProps: ouinon135Data
};
const buttonSecondary79Data = {
    children: "2/7",
    className: "button-secondary-79"
};
const toggle79Data = {
    className: "toggle-85",
    buttonSecondaryProps: buttonSecondary79Data
};
const quality2Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    inputType1: "text",
    inputPlaceholder1: "Connaissez vous votre bilan carbone?",
    inputType2: "text",
    inputPlaceholder2: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType3: "text",
    inputPlaceholder3: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    inputType4: "text",
    inputPlaceholder4: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    inputType5: "text",
    inputPlaceholder5: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    inputType6: "text",
    inputPlaceholder6: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    inputType7: "text",
    inputPlaceholder7: "Connaissez vous votre bilan carbone?",
    navItems3Props: navItems328Data,
    toggle1Props: toggle76Data,
    frame1361Props: frame136110Data,
    frame1362Props: frame136111Data,
    frame1363Props: frame136112Data,
    toggle2Props: toggle77Data,
    frame1364Props: frame136113Data,
    frame1365Props: frame136114Data,
    frame1366Props: frame136115Data,
    toggle3Props: toggle78Data,
    frame1367Props: frame136116Data,
    toggle4Props: toggle79Data
};
const navItems227Data = {
    className: "nav-items-2-26"
};
const frame1172238Data = {
    children: "Existing Case"
};
const frame1162239Data = {
    children: "Reference Cases"
};
const frame1132246Data = {
    className: ""
};
const navItems329Data = {
    className: "nav-items-3-29",
    frame1172Props: frame1172238Data,
    frame1162Props: frame1162239Data,
    frame1132Props: frame1132246Data
};
const buttonSecondary80Data = {
    children: "2/2",
    className: "button-secondary-80"
};
const toggle80Data = {
    className: "toggle-86",
    buttonSecondaryProps: buttonSecondary80Data
};
const processView3Data = {
    navItems2Props: navItems227Data,
    navItems3Props: navItems329Data,
    toggleProps: toggle80Data
};
const navItems228Data = {
    className: "nav-items-2-27"
};
const frame1172239Data = {
    children: "Existing Case"
};
const frame1162240Data = {
    children: "Reference Cases"
};
const frame1132247Data = {
    className: ""
};
const navItems330Data = {
    className: "nav-items-3-30",
    frame1172Props: frame1172239Data,
    frame1162Props: frame1162240Data,
    frame1132Props: frame1132247Data
};
const frame1173219Data = {
    className: "frame-113-52"
};
const buttonSecondary81Data = {
    children: "1/2",
    className: "button-secondary-33"
};
const toggle81Data = {
    className: "toggle-87",
    buttonSecondaryProps: buttonSecondary81Data
};
const buttonSecondary82Data = {
    children: "Strength of proposal and employee autonomy",
    className: "button-secondary-33"
};
const toggle82Data = {
    className: "toggle-13",
    buttonSecondaryProps: buttonSecondary82Data
};
const group10261Data = {
    line24: "/img/line-24-80.png"
};
const group10262Data = {
    line24: "/img/line-24-81.png"
};
const group10263Data = {
    line24: "/img/line-24-62.png",
    className: "group-6-2"
};
const group10264Data = {
    line24: "/img/line-24-83.png",
    className: "group-6-3"
};
const group10265Data = {
    line24: "/img/line-24-84.png",
    className: "group-6-4"
};
const frame962Data = {
    className: "frame-94-2",
    toggleProps: toggle82Data,
    group1021Props: group10261Data,
    group1022Props: group10262Data,
    group1023Props: group10263Data,
    group1024Props: group10264Data,
    group1025Props: group10265Data
};
const buttonSecondary83Data = {
    children: "Career evolution",
    className: "button-secondary-33"
};
const toggle83Data = {
    className: "toggle-13",
    buttonSecondaryProps: buttonSecondary83Data
};
const group10266Data = {
    line24: "/img/line-24-5.png",
    className: ""
};
const group10267Data = {
    line24: "/img/line-24-6.png",
    className: ""
};
const group10268Data = {
    line24: "/img/line-24-7.png",
    className: "group-6-5"
};
const group10269Data = {
    line24: "/img/line-24-18.png",
    className: "group-6-6"
};
const group10270Data = {
    line24: "/img/line-24-19.png",
    className: "group-6"
};
const frame973Data = {
    className: "frame-95-4",
    toggleProps: toggle83Data,
    group1021Props: group10266Data,
    group1022Props: group10267Data,
    group1023Props: group10268Data,
    group1024Props: group10269Data,
    group1025Props: group10270Data
};
const decisionalView2Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
    navItems2Props: navItems228Data,
    navItems3Props: navItems330Data,
    frame11732Props: frame1173219Data,
    toggleProps: toggle81Data,
    frame96Props: frame962Data,
    frame97Props: frame973Data
};
const navItems229Data = {
    className: "nav-items-2-28"
};
const frame1172240Data = {
    children: "Existing Case"
};
const frame1162241Data = {
    children: "Reference Cases"
};
const frame1132248Data = {
    className: ""
};
const navItems331Data = {
    className: "nav-items-3-31",
    frame1172Props: frame1172240Data,
    frame1162Props: frame1162241Data,
    frame1132Props: frame1132248Data
};
const buttonSecondary84Data = {
    children: "1/2",
    className: "button-secondary-34"
};
const toggle84Data = {
    className: "toggle-88",
    buttonSecondaryProps: buttonSecondary84Data
};
const buttonSecondary85Data = {
    children: "Strength of proposal and employee autonomy",
    className: "button-secondary-34"
};
const toggle85Data = {
    className: "toggle-14",
    buttonSecondaryProps: buttonSecondary85Data
};
const group10271Data = {
    line24: "/img/line-24-80.png",
    className: "group-7-1"
};
const group10272Data = {
    line24: "/img/line-24-81.png",
    className: "group-7-2"
};
const group10273Data = {
    line24: "/img/line-24-42.png",
    className: "group-7-3"
};
const group10274Data = {
    line24: "/img/line-24-83.png",
    className: "group-7-4"
};
const group10275Data = {
    line24: "/img/line-24-84.png",
    className: "group-7-5"
};
const frame921Data = {
    toggleProps: toggle85Data,
    group1021Props: group10271Data,
    group1022Props: group10272Data,
    group1023Props: group10273Data,
    group1024Props: group10274Data,
    group1025Props: group10275Data
};
const frame1173220Data = {
    className: "frame-113-53"
};
const buttonSecondary86Data = {
    children: "Career evolution",
    className: "button-secondary-34"
};
const toggle86Data = {
    className: "toggle-14",
    buttonSecondaryProps: buttonSecondary86Data
};
const group10276Data = {
    line24: "/img/line-24-5.png",
    className: "group-7-6"
};
const group10277Data = {
    line24: "/img/line-24-6.png",
    className: "group-7-7"
};
const group10278Data = {
    line24: "/img/line-24-7.png",
    className: "group-7-8"
};
const group10279Data = {
    line24: "/img/line-24-18.png",
    className: "group-7-9"
};
const group10280Data = {
    line24: "/img/line-24-19.png",
    className: "group-7"
};
const frame974Data = {
    className: "frame-93",
    toggleProps: toggle86Data,
    group1021Props: group10276Data,
    group1022Props: group10277Data,
    group1023Props: group10278Data,
    group1024Props: group10279Data,
    group1025Props: group10280Data
};
const physicalModel2Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
    navItems2Props: navItems229Data,
    navItems3Props: navItems331Data,
    toggleProps: toggle84Data,
    frame92Props: frame921Data,
    frame11732Props: frame1173220Data,
    frame97Props: frame974Data
};
const navItems230Data = {
    className: "nav-items-2-29"
};
const frame1172241Data = {
    children: "Existing Case"
};
const frame1162242Data = {
    children: "Reference Cases"
};
const frame1132249Data = {
    className: ""
};
const navItems332Data = {
    className: "nav-items-3-32",
    frame1172Props: frame1172241Data,
    frame1162Props: frame1162242Data,
    frame1132Props: frame1132249Data
};
const buttonSecondary87Data = {
    children: "2/2",
    className: "button-secondary-35"
};
const toggle87Data = {
    className: "toggle-89",
    buttonSecondaryProps: buttonSecondary87Data
};
const buttonSecondary88Data = {
    children: "Strength of proposal and employee autonomy",
    className: "button-secondary-35"
};
const toggle88Data = {
    className: "toggle-15",
    buttonSecondaryProps: buttonSecondary88Data
};
const group10281Data = {
    line24: "/img/line-24-80.png",
    className: "group-8-1"
};
const group10282Data = {
    line24: "/img/line-24-81.png",
    className: "group-8-2"
};
const group10283Data = {
    line24: "/img/line-24-62.png",
    className: "group-8-3"
};
const group10284Data = {
    line24: "/img/line-24-83.png",
    className: "group-8-4"
};
const group10285Data = {
    line24: "/img/line-24-84.png",
    className: "group-8-5"
};
const frame922Data = {
    className: "frame-92-1",
    toggleProps: toggle88Data,
    group1021Props: group10281Data,
    group1022Props: group10282Data,
    group1023Props: group10283Data,
    group1024Props: group10284Data,
    group1025Props: group10285Data
};
const buttonSecondary89Data = {
    children: "Career evolution",
    className: "button-secondary-35"
};
const toggle89Data = {
    className: "toggle-15",
    buttonSecondaryProps: buttonSecondary89Data
};
const group10286Data = {
    line24: "/img/line-24-5.png",
    className: ""
};
const group10287Data = {
    line24: "/img/line-24-6.png",
    className: ""
};
const group10288Data = {
    line24: "/img/line-24-7.png",
    className: "group-8-6"
};
const group10289Data = {
    line24: "/img/line-24-18.png",
    className: "group-8-7"
};
const group10290Data = {
    line24: "/img/line-24-19.png",
    className: "group-8"
};
const frame931Data = {
    toggleProps: toggle89Data,
    group1021Props: group10286Data,
    group1022Props: group10287Data,
    group1023Props: group10288Data,
    group1024Props: group10289Data,
    group1025Props: group10290Data
};
const decisionalView3Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
    procesView: "Proces view",
    navItems2Props: navItems230Data,
    navItems3Props: navItems332Data,
    toggleProps: toggle87Data,
    frame92Props: frame922Data,
    frame93Props: frame931Data
};
const frame1172242Data = {
    children: "Existing Case"
};
const frame1162243Data = {
    children: "Reference Cases"
};
const frame1132250Data = {
    className: ""
};
const navItems333Data = {
    className: "nav-items-3-33",
    frame1172Props: frame1172242Data,
    frame1162Props: frame1162243Data,
    frame1132Props: frame1132250Data
};
const buttonSecondary90Data = {
    children: "Internal Audit 1",
    className: ""
};
const toggle90Data = {
    className: "toggle-29",
    buttonSecondaryProps: buttonSecondary90Data
};
const ouinon136Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-28-1"
};
const ouinon137Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-28-2"
};
const ouinon138Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-28-3"
};
const buttonSecondary91Data = {
    children: "Internal Audit 2",
    className: ""
};
const toggle91Data = {
    className: "toggle-29",
    buttonSecondaryProps: buttonSecondary91Data
};
const ouinon139Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-28-4"
};
const ouinon140Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-28-5"
};
const ouinon141Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-28"
};
const buttonSecondary92Data = {
    children: "5/7",
    className: "button-secondary-81"
};
const toggle92Data = {
    className: "toggle-90",
    buttonSecondaryProps: buttonSecondary92Data
};
const quality5Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    inputType1: "text",
    inputPlaceholder1: "Connaissez vous votre bilan carbone?",
    inputType2: "text",
    inputPlaceholder2: "Connaissez vous votre bilan carbone?",
    inputType3: "text",
    inputPlaceholder3: "Connaissez vous votre bilan carbone?",
    inputType4: "text",
    inputPlaceholder4: "Connaissez vous votre bilan carbone?",
    inputType5: "text",
    inputPlaceholder5: "Connaissez vous votre bilan carbone?",
    inputType6: "text",
    inputPlaceholder6: "Connaissez vous votre bilan carbone?",
    navItems3Props: navItems333Data,
    toggle1Props: toggle90Data,
    ouinon1Props: ouinon136Data,
    ouinon2Props: ouinon137Data,
    ouinon3Props: ouinon138Data,
    toggle2Props: toggle91Data,
    ouinon4Props: ouinon139Data,
    ouinon5Props: ouinon140Data,
    ouinon6Props: ouinon141Data,
    toggle3Props: toggle92Data
};
const navItems232Data = {
    className: "nav-items-2-31"
};
const frame1172243Data = {
    children: "Existing Case"
};
const frame1162244Data = {
    children: "Reference Cases"
};
const frame1132251Data = {
    className: ""
};
const navItems334Data = {
    className: "nav-items-3-34",
    frame1172Props: frame1172243Data,
    frame1162Props: frame1162244Data,
    frame1132Props: frame1132251Data
};
const buttonSecondary93Data = {
    children: "2/2",
    className: "button-secondary-36"
};
const toggle93Data = {
    className: "toggle-91",
    buttonSecondaryProps: buttonSecondary93Data
};
const buttonSecondary94Data = {
    children: "Strength of proposal and employee autonomy",
    className: "button-secondary-36"
};
const toggle94Data = {
    className: "toggle-16",
    buttonSecondaryProps: buttonSecondary94Data
};
const group10291Data = {
    line24: "/img/line-24-80.png",
    className: "group-10-1"
};
const group10292Data = {
    line24: "/img/line-24-81.png",
    className: "group-10-2"
};
const group10293Data = {
    line24: "/img/line-24-42.png",
    className: "group-10-3"
};
const group10294Data = {
    line24: "/img/line-24-83.png",
    className: "group-10-4"
};
const group10295Data = {
    line24: "/img/line-24-84.png",
    className: "group-10-5"
};
const frame923Data = {
    className: "frame-85",
    toggleProps: toggle94Data,
    group1021Props: group10291Data,
    group1022Props: group10292Data,
    group1023Props: group10293Data,
    group1024Props: group10294Data,
    group1025Props: group10295Data
};
const buttonSecondary95Data = {
    children: "Career evolution",
    className: "button-secondary-36"
};
const toggle95Data = {
    className: "toggle-16",
    buttonSecondaryProps: buttonSecondary95Data
};
const group10296Data = {
    line24: "/img/line-24-5.png",
    className: "group-10-6"
};
const group10297Data = {
    line24: "/img/line-24-6.png",
    className: "group-10-7"
};
const group10298Data = {
    line24: "/img/line-24-7.png",
    className: "group-10-8"
};
const group10299Data = {
    line24: "/img/line-24-18.png",
    className: "group-10-9"
};
const group102100Data = {
    line24: "/img/line-24-19.png",
    className: "group-10"
};
const frame932Data = {
    className: "frame-86",
    toggleProps: toggle95Data,
    group1021Props: group10296Data,
    group1022Props: group10297Data,
    group1023Props: group10298Data,
    group1024Props: group10299Data,
    group1025Props: group102100Data
};
const physicalModel3Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
    decisionalView: "Decisional View",
    navItems2Props: navItems232Data,
    navItems3Props: navItems334Data,
    toggleProps: toggle93Data,
    frame92Props: frame923Data,
    frame93Props: frame932Data
};
const navItems233Data = {
    className: "nav-items-2-32"
};
const frame1172244Data = {
    children: "Existing Case"
};
const frame1162245Data = {
    children: "Reference Cases"
};
const frame1132252Data = {
    className: ""
};
const navItems335Data = {
    className: "nav-items-3-35",
    frame1172Props: frame1172244Data,
    frame1162Props: frame1162245Data,
    frame1132Props: frame1132252Data
};
const buttonSecondary96Data = {
    children: "Strength of proposal and employee autonomy",
    className: "button-secondary-37"
};
const toggle96Data = {
    className: "toggle-17",
    buttonSecondaryProps: buttonSecondary96Data
};
const group102101Data = {
    line24: "/img/line-24-80.png",
    className: "group-11-1"
};
const group102102Data = {
    line24: "/img/line-24-81.png",
    className: "group-11-2"
};
const group102103Data = {
    line24: "/img/line-24-62.png",
    className: ""
};
const group102104Data = {
    line24: "/img/line-24-83.png",
    className: ""
};
const group102105Data = {
    line24: "/img/line-24-84.png",
    className: ""
};
const frame9222Data = {
    toggleProps: toggle96Data,
    group1021Props: group102101Data,
    group1022Props: group102102Data,
    group1023Props: group102103Data,
    group1024Props: group102104Data,
    group1025Props: group102105Data
};
const buttonSecondary97Data = {
    children: "Career evolution",
    className: "button-secondary-37"
};
const toggle97Data = {
    className: "toggle-17",
    buttonSecondaryProps: buttonSecondary97Data
};
const group102106Data = {
    line24: "/img/line-24-5.png",
    className: "group-11-3"
};
const group102107Data = {
    line24: "/img/line-24-6.png",
    className: "group-11-4"
};
const group102108Data = {
    line24: "/img/line-24-7.png",
    className: "group-11"
};
const group102109Data = {
    line24: "/img/line-24-18.png",
    className: ""
};
const group102110Data = {
    line24: "/img/line-24-19.png",
    className: ""
};
const frame933Data = {
    className: "frame-93-2",
    toggleProps: toggle97Data,
    group1021Props: group102106Data,
    group1022Props: group102107Data,
    group1023Props: group102108Data,
    group1024Props: group102109Data,
    group1025Props: group102110Data
};
const buttonSecondary98Data = {
    children: "1/3",
    className: "button-secondary-37"
};
const toggle98Data = {
    className: "toggle-92",
    buttonSecondaryProps: buttonSecondary98Data
};
const functionnalView2Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
    navItems2Props: navItems233Data,
    navItems3Props: navItems335Data,
    frame922Props: frame9222Data,
    frame93Props: frame933Data,
    toggleProps: toggle98Data
};
const navItems234Data = {
    className: "nav-items-2-33"
};
const frame1172245Data = {
    children: "Existing Case"
};
const frame1162246Data = {
    children: "Reference Cases"
};
const frame1132253Data = {
    className: ""
};
const navItems336Data = {
    className: "nav-items-3-36",
    frame1172Props: frame1172245Data,
    frame1162Props: frame1162246Data,
    frame1132Props: frame1132253Data
};
const buttonSecondary99Data = {
    children: "Strength of proposal and employee autonomy",
    className: "button-secondary-38"
};
const toggle99Data = {
    className: "toggle-18",
    buttonSecondaryProps: buttonSecondary99Data
};
const group102111Data = {
    line24: "/img/line-24-80.png",
    className: "group-12-1"
};
const group102112Data = {
    line24: "/img/line-24-81.png",
    className: "group-12-2"
};
const group102113Data = {
    line24: "/img/line-24-82.png",
    className: "group-12-3"
};
const group102114Data = {
    line24: "/img/line-24-83.png",
    className: "group-12-4"
};
const group102115Data = {
    line24: "/img/line-24-84.png",
    className: "group-12-5"
};
const frame9223Data = {
    className: "frame-85-1",
    toggleProps: toggle99Data,
    group1021Props: group102111Data,
    group1022Props: group102112Data,
    group1023Props: group102113Data,
    group1024Props: group102114Data,
    group1025Props: group102115Data
};
const buttonSecondary100Data = {
    children: "Career evolution",
    className: "button-secondary-38"
};
const toggle100Data = {
    className: "toggle-18",
    buttonSecondaryProps: buttonSecondary100Data
};
const group102116Data = {
    line24: "/img/line-24-5.png",
    className: "group-12-6"
};
const group102117Data = {
    line24: "/img/line-24-6.png",
    className: "group-12"
};
const group102118Data = {
    line24: "/img/line-24-7.png",
    className: ""
};
const group102119Data = {
    line24: "/img/line-24-18.png",
    className: ""
};
const group102120Data = {
    line24: "/img/line-24-19.png",
    className: ""
};
const frame934Data = {
    className: "frame-86-1",
    toggleProps: toggle100Data,
    group1021Props: group102116Data,
    group1022Props: group102117Data,
    group1023Props: group102118Data,
    group1024Props: group102119Data,
    group1025Props: group102120Data
};
const frame1173223Data = {
    className: "frame-113-56"
};
const buttonSecondary101Data = {
    children: "2/3",
    className: "button-secondary-38"
};
const toggle101Data = {
    className: "toggle-93",
    buttonSecondaryProps: buttonSecondary101Data
};
const functionnalView3Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
    navItems2Props: navItems234Data,
    navItems3Props: navItems336Data,
    frame922Props: frame9223Data,
    frame93Props: frame934Data,
    frame11732Props: frame1173223Data,
    toggleProps: toggle101Data
};
const frame1172246Data = {
    children: "Existing Case"
};
const frame1162247Data = {
    children: "Reference Cases"
};
const frame1132254Data = {
    className: ""
};
const navItems337Data = {
    className: "nav-items-3-37",
    frame1172Props: frame1172246Data,
    frame1162Props: frame1162247Data,
    frame1132Props: frame1132254Data
};
const buttonSecondary102Data = {
    children: "Recycling",
    className: "button-secondary-39"
};
const toggle102Data = {
    className: "toggle-94",
    buttonSecondaryProps: buttonSecondary102Data
};
const group102121Data = {
    line24: "/img/line-24-120.png",
    className: "group-13-1"
};
const group102122Data = {
    line24: "/img/line-24-121.png",
    className: "group-13"
};
const group102123Data = {
    line24: "/img/line-24-122.png"
};
const group102124Data = {
    line24: "/img/line-24-123.png"
};
const buttonSecondary103Data = {
    children: "3/3",
    className: "button-secondary-39"
};
const toggle103Data = {
    className: "toggle-95",
    buttonSecondaryProps: buttonSecondary103Data
};
const functionnalView4Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
    inputType1: "text",
    inputPlaceholder1: "Connaissez vous votre bilan carbone?",
    inputType2: "text",
    inputPlaceholder2: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType3: "text",
    inputPlaceholder3: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    inputType4: "text",
    inputPlaceholder4: "En moyenne dans quelle p\xe9rim\xe8tre vous approvisionnez vous?",
    physicalModel: "Physical Model",
    navItems3Props: navItems337Data,
    toggle1Props: toggle102Data,
    group1021Props: group102121Data,
    group1022Props: group102122Data,
    group1023Props: group102123Data,
    group1024Props: group102124Data,
    toggle2Props: toggle103Data
};
const frame1172247Data = {
    children: "Existing Case"
};
const frame1162248Data = {
    children: "Reference Cases"
};
const frame1132255Data = {
    className: ""
};
const navItems338Data = {
    className: "nav-items-3-38",
    frame1172Props: frame1172247Data,
    frame1162Props: frame1162248Data,
    frame1132Props: frame1132255Data
};
const frame1121Data = {
    children: "Click here"
};
const loadingPageData = {
    navItems3Props: navItems338Data,
    frame112Props: frame1121Data
};
const frame11811Data = {
    children: "Visual management",
    className: "frame-113-27"
};
const headerMenuDefault3Data = {
    children: "Requirements",
    className: "menu-item-default-1"
};
const headerMenuDefault4Data = {
    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "Define,",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "Prepare,",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "Document"
        ]
    }),
    className: "menu-item-default-2"
};
const headerMenuDefault5Data = {
    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "Measure, ",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "Compare"
        ]
    }),
    className: "menu-item-default-3"
};
const headerMenuDefault6Data = {
    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "Evaluate,",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "Correct"
        ]
    }),
    className: "menu-item-default-4"
};
const headerMenuDefault7Data = {
    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "Execute, ",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "Code"
        ]
    }),
    className: "menu-item-default-5"
};
const headerMenuDefault8Data = {
    children: "Satisfaction",
    className: "menu-item-default-6"
};
const kaizen1Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    overlapGroup11: "/img/arrow-1@2x.png",
    arrow9: "/img/arrow-1@2x.png",
    overlapGroup4: "/img/arrow-2@2x.png",
    arrow10: "/img/arrow-2@2x.png",
    line4: "/img/line-2@2x.png",
    line2: "/img/line-2@2x.png",
    label1: "Zoom",
    label2: "Zoom",
    overlapGroup8: "/img/text-format@2x.png",
    textFormat: "/img/text-format@2x.png",
    label3: "Text",
    label4: "Text",
    overlapGroup17: "/img/line-1.png",
    line1: "/img/line-1.png",
    place: "Back",
    clickOnModeling: "CLICK ON \xe2\u20AC\u0153MODELING\xe2\u20AC\x9d BUTTON TO CREATE YOUR DIAGRAM",
    inputType1: "text",
    inputPlaceholder1: "INPUT",
    arrow5: "/img/arrow-5-6@2x.png",
    arrow1: "/img/arrow-1-8@2x.png",
    inputType2: "text",
    inputPlaceholder2: "PLAN",
    arrow3: "/img/arrow-3-7@2x.png",
    arrow7: "/img/arrow-5-6@2x.png",
    inputType3: "text",
    inputPlaceholder3: "ACT",
    inputType4: "text",
    inputPlaceholder4: "DO",
    inputType5: "text",
    inputPlaceholder5: "CHECK",
    arrow4: "/img/arrow-4-7@2x.png",
    arrow6: "/img/arrow-5-6@2x.png",
    modeling: "Modeling",
    arrow2: "/img/arrow-2-8@2x.png",
    arrow8: "/img/arrow-5-6@2x.png",
    xcontinue: "Continue",
    inputType6: "text",
    inputPlaceholder6: "OUTPUT",
    frame118Props: frame11811Data,
    headerMenuDefault1Props: headerMenuDefault3Data,
    headerMenuDefault2Props: headerMenuDefault4Data,
    headerMenuDefault3Props: headerMenuDefault5Data,
    headerMenuDefault4Props: headerMenuDefault6Data,
    headerMenuDefault5Props: headerMenuDefault7Data,
    headerMenuDefault6Props: headerMenuDefault8Data
};
const frame1172248Data = {
    children: "Existing Case"
};
const frame1162249Data = {
    children: "Reference Cases"
};
const frame1132257Data = {
    className: ""
};
const navItems339Data = {
    className: "nav-items-3-39",
    frame1172Props: frame1172248Data,
    frame1162Props: frame1162249Data,
    frame1132Props: frame1132257Data
};
const buttonSecondary104Data = {
    children: "Functionnal View",
    className: "button-secondary-82"
};
const toggle104Data = {
    className: "toggle-96",
    buttonSecondaryProps: buttonSecondary104Data
};
const buttonSecondary105Data = {
    children: "3. Decisional View",
    className: "button-secondary-83"
};
const toggle105Data = {
    className: "toggle-97",
    buttonSecondaryProps: buttonSecondary105Data
};
const buttonSecondary106Data = {
    children: "2. Physical Model",
    className: "button-secondary-41"
};
const toggle106Data = {
    className: "toggle-31",
    buttonSecondaryProps: buttonSecondary106Data
};
const buttonSecondary107Data = {
    children: "4. Process view",
    className: "button-secondary-84"
};
const toggle107Data = {
    className: "toggle-98",
    buttonSecondaryProps: buttonSecondary107Data
};
const buttonSecondary108Data = {
    children: "5. Informational Model",
    className: "button-secondary-40"
};
const toggle108Data = {
    className: "toggle-99",
    buttonSecondaryProps: buttonSecondary108Data
};
const buttonSecondary109Data = {
    children: "Lean VSM",
    className: "button-secondary-40"
};
const toggle109Data = {
    className: "toggle-100",
    buttonSecondaryProps: buttonSecondary109Data
};
const buttonSecondary110Data = {
    children: "4. Kaizen",
    className: "button-secondary-40"
};
const toggle110Data = {
    className: "toggle-101",
    buttonSecondaryProps: buttonSecondary110Data
};
const buttonSecondary111Data = {
    children: "2. 5S",
    className: "button-secondary-40"
};
const toggle111Data = {
    className: "toggle-102",
    buttonSecondaryProps: buttonSecondary111Data
};
const buttonSecondary112Data = {
    children: "5. SMED",
    className: "button-secondary-40"
};
const toggle112Data = {
    className: "toggle-103",
    buttonSecondaryProps: buttonSecondary112Data
};
const buttonSecondary113Data = {
    children: "3. Kanban",
    className: "button-secondary-40"
};
const toggle113Data = {
    className: "toggle-104",
    buttonSecondaryProps: buttonSecondary113Data
};
const buttonSecondary114Data = {
    children: "6. Visual Management",
    className: "button-secondary-41"
};
const toggle114Data = {
    className: "toggle-31",
    buttonSecondaryProps: buttonSecondary114Data
};
const existingSystemsData = {
    ellipse116: "/img/polygon-3@2x.png",
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    existingSystems: "EXISTING SYSTEMS",
    graiMethodologyModels: "GRAI METHODOLOGY MODELS",
    x2SupplementaryModels: "2.   SUPPLEMENTARY MODELS",
    navItems3Props: navItems339Data,
    toggle1Props: toggle104Data,
    toggle2Props: toggle105Data,
    toggle3Props: toggle106Data,
    toggle4Props: toggle107Data,
    toggle5Props: toggle108Data,
    toggle6Props: toggle109Data,
    toggle7Props: toggle110Data,
    toggle8Props: toggle111Data,
    toggle9Props: toggle112Data,
    toggle10Props: toggle113Data,
    toggle11Props: toggle114Data
};
const frame11354Data = {
    className: "frame-113-54"
};
const frame11812Data = {
    children: "Visual management"
};
const kanban1Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    arrow9: "/img/arrow-1@2x.png",
    arrow10: "/img/arrow-2@2x.png",
    rectangle23: "/img/rectangle-23@2x.png",
    line2: "/img/line-2-14@2x.png",
    label1: "Zoom",
    textFormat: "/img/text-format-15@2x.png",
    label2: "Text",
    line22: "/img/line-22.png",
    place1: "Back",
    clickOnModeling: "CLICK ON \xe2\u20AC\u0153MODELING\xe2\u20AC\x9d BUTTON TO CREATE YOUR DIAGRAM",
    place2: "PLAN",
    arrow11: "/img/arrow-11-6.png",
    line4: "/img/line-4-4.png",
    inputType1: "text",
    inputPlaceholder1: "URGENCE",
    inputType2: "text",
    inputPlaceholder2: "A FAIRE",
    inputType3: "text",
    inputPlaceholder3: "TERMINE",
    inputType4: "text",
    inputPlaceholder4: "EN ATTENTE",
    inputType5: "text",
    inputPlaceholder5: "EN COURS",
    line3: "/img/line-3-5.png",
    modeling: "Modeling",
    xcontinue: "Continue",
    frame1135Props: frame11354Data,
    frame118Props: frame11812Data
};
const frame11813Data = {
    children: "Visual management",
    className: "frame-113-30"
};
const headerMenuDefault42Data = {
    children: "Analysis"
};
const headerMenuDefault43Data = {
    children: "VSM Futur",
    className: "menu-item-default-24"
};
const headerMenuDefault44Data = {
    children: "Action Plan",
    className: "menu-item-default-25"
};
const headerMenuDefault45Data = {
    children: "Current VSM",
    className: "menu-item-default-23"
};
const headerMenuDefault46Data = {
    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "Definition de",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            " la famille",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            " de produits"
        ]
    }),
    className: "menu-item-default-26"
};
const leanVSMData = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    design: "Design",
    leanVsm: "Lean VSM",
    arrow4: "/img/arrow-4-4@2x.png",
    arrow6: "/img/arrow-4-4@2x.png",
    arrow5: "/img/arrow-5-3@2x.png",
    rectangle7: "/img/rectangle-7-1@2x.png",
    xcontinue: "Continue",
    arrow1: "/img/arrow-1@2x.png",
    arrow2: "/img/arrow-2@2x.png",
    rectangle6: "/img/rectangle-7@2x.png",
    line2: "/img/line-2@2x.png",
    label1: "Zoom",
    textFormat: "/img/text-format@2x.png",
    label2: "Text",
    line1: "/img/line-1.png",
    place: "Back",
    arrow3: "/img/arrow-3-4@2x.png",
    modeling: "Modeling",
    clickOnModeling: "CLICK ON \xe2\u20AC\u0153MODELING\xe2\u20AC\x9d BUTTON TO CREATE YOUR DIAGRAM",
    frame118Props: frame11813Data,
    headerMenuDefault41Props: headerMenuDefault42Data,
    headerMenuDefault42Props: headerMenuDefault43Data,
    headerMenuDefault43Props: headerMenuDefault44Data,
    headerMenuDefault44Props: headerMenuDefault45Data,
    headerMenuDefault45Props: headerMenuDefault46Data
};
const frame11814Data = {
    children: "Visual management",
    className: "frame-113-31"
};
const sMED1Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    arrow9: "/img/arrow-1@2x.png",
    arrow10: "/img/arrow-2@2x.png",
    line2: "/img/line-2@2x.png",
    label1: "Zoom",
    textFormat: "/img/text-format@2x.png",
    label2: "Text",
    line1: "/img/line-1.png",
    place: "Back",
    clickOnModeling: "CLICK ON \xe2\u20AC\u0153MODELING\xe2\u20AC\x9d BUTTON TO CREATE YOUR DIAGRAM",
    label3: "FIN D\xe2\u20AC\u2122USINAGE SERIE A",
    arrow5: "/img/arrow-5-6@2x.png",
    label4: "DEBUT D\xe2\u20AC\u2122USINAGE SERIE B",
    arrow15: "/img/arrow-15-1@2x.png",
    arrow12: "/img/arrow-12-2@2x.png",
    arrow13: "/img/arrow-13-1@2x.png",
    dernierePieceBonneSerieA: "DERNIERE PIECE BONNE SERIE A",
    changementOutillage: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "CHANGEMENT",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            " OUTILLAGE"
        ]
    }),
    reglage: "REGLAGE",
    inputType1: "text",
    inputPlaceholder1: "NETTOYAGE",
    arrow18: "/img/arrow-18@2x.png",
    arrow17: "/img/arrow-17@2x.png",
    arrow16: "/img/arrow-16-1@2x.png",
    inputType2: "text",
    inputPlaceholder2: "PREMIERE PIECE BONNE SERIE B",
    arrow14: "/img/arrow-15-1@2x.png",
    arrow11: "/img/arrow-11-5@2x.png",
    modeling: "Modeling",
    xcontinue: "Continue",
    frame118Props: frame11814Data
};
const frame11815Data = {
    children: "Visual management",
    className: "frame-113-32"
};
const x5SData = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    design: "Design",
    leanVsm: "Lean VSM",
    arrow12: "/img/arrow-1@2x.png",
    arrow13: "/img/arrow-2@2x.png",
    line2: "/img/line-2-14@2x.png",
    label1: "Zoom",
    textFormat: "/img/text-format-15@2x.png",
    label2: "Text",
    line23: "/img/line-22.png",
    place: "Back",
    seiri: "SEIRI",
    arrow7: "/img/arrow-7-7@2x.png",
    disposal: "DISPOSAL",
    clickOnModeling: "CLICK ON \xe2\u20AC\u0153MODELING\xe2\u20AC\x9d BUTTON TO CREATE YOUR DIAGRAM",
    arrow3: "/img/arrow-3-4@2x.png",
    seiton: "SEITON",
    arrow8: "/img/arrow-8-8@2x.png",
    putAway: "PUT AWAY",
    modeling: "Modeling",
    arrow4: "/img/arrow-4-4@2x.png",
    seison: "SEISON",
    arrow9: "/img/arrow-7-7@2x.png",
    clean: "CLEAN",
    arrow6: "/img/arrow-4-4@2x.png",
    seiketsu: "SEIKETSU",
    shitsuke: "SHITSUKE",
    arrow10: "/img/arrow-8-8@2x.png",
    arrow11: "/img/arrow-8-8@2x.png",
    arrow5: "/img/arrow-5-3@2x.png",
    rectangle7: "/img/rectangle-7-1@2x.png",
    standardize: "STANDARDIZE",
    respect: "RESPECT",
    xcontinue: "Continue",
    frame118Props: frame11815Data
};
const frame1133217Data = {
    className: "frame-113-16"
};
const frame1132262Data = {
    className: "frame-113-70"
};
const frame11816Data = {
    children: "Visual management",
    className: "frame-113-33"
};
const frame81Data = {
    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "5",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "MISE EN ACTION DES CONTRE-MESURES"
        ]
    })
};
const frame821Data = {
    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "4",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "IDENTIFICATION DES CONTRE-MESURES"
        ]
    })
};
const frame91Data = {
    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "3",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "ETUDE DES CAUSES"
        ]
    })
};
const kaizen12Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    label1: "Design",
    leanVsm: "Lean VSM",
    label2: "CONTINUOUS IMPROVEMENT PROCESS",
    overlapGroup8: "/img/arrow-1@2x.png",
    arrow9: "/img/arrow-1@2x.png",
    overlapGroup5: "/img/arrow-2@2x.png",
    arrow10: "/img/arrow-2@2x.png",
    line4: "/img/line-2@2x.png",
    line2: "/img/line-2@2x.png",
    label3: "Zoom",
    label4: "Zoom",
    overlapGroup9: "/img/text-format@2x.png",
    textFormat: "/img/text-format@2x.png",
    label5: "Text",
    label6: "Text",
    overlapGroup4: "/img/line-1.png",
    line1: "/img/line-1.png",
    place: "Back",
    x1IdentificatonDuProblemeATraiter: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "1",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "IDENTIFICATON DU PROBLEME A TRAITER"
        ]
    }),
    x2EtudeDeLaSituation: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "2 ",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "ETUDE DE LA SITUATION"
        ]
    }),
    arrow6: "/img/arrow-6-11@2x.png",
    x6AuditDesContreMesures: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "6",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "AUDIT DES CONTRE-MESURES"
        ]
    }),
    arrow16: "/img/arrow-16-5@2x.png",
    arrow13: "/img/arrow-6-11@2x.png",
    arrow14: "/img/arrow-14-5@2x.png",
    arrow15: "/img/arrow-15-2@2x.png",
    arrow17: "/img/arrow-17-1@2x.png",
    x7StandardisationDesBonnesMesures: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "7",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "STANDARDISATION DES BONNES MESURES"
        ]
    }),
    modeling: "Modeling",
    xcontinue: "Continue",
    frame11332Props: frame1133217Data,
    frame11322Props: frame1132262Data,
    frame118Props: frame11816Data,
    frame8Props: frame81Data,
    frame82Props: frame821Data,
    frame9Props: frame91Data
};
const frame1172249Data = {
    children: "Existing Case"
};
const frame1162250Data = {
    children: "Reference Cases"
};
const frame1132263Data = {
    className: ""
};
const navItems340Data = {
    className: "nav-items-3-40",
    frame1172Props: frame1172249Data,
    frame1162Props: frame1162250Data,
    frame1132Props: frame1132263Data
};
const buttonSecondary115Data = {
    children: "Staff involvement 1",
    className: ""
};
const toggle115Data = {
    className: "toggle-105",
    buttonSecondaryProps: buttonSecondary115Data
};
const ouinon142Data = {
    yes: "Yes",
    place: "No"
};
const frame136117Data = {
    ouinonProps: ouinon142Data
};
const ouinon143Data = {
    yes: "Yes",
    place: "No"
};
const frame136118Data = {
    ouinonProps: ouinon143Data
};
const ouinon144Data = {
    yes: "Yes",
    place: "No"
};
const frame136119Data = {
    ouinonProps: ouinon144Data
};
const ouinon145Data = {
    yes: "Yes",
    place: "No"
};
const frame136120Data = {
    ouinonProps: ouinon145Data
};
const buttonSecondary116Data = {
    children: "Staff involvement 2",
    className: ""
};
const toggle116Data = {
    className: "toggle-106",
    buttonSecondaryProps: buttonSecondary116Data
};
const ouinon146Data = {
    yes: "Yes",
    place: "No"
};
const frame136121Data = {
    ouinonProps: ouinon146Data
};
const ouinon147Data = {
    yes: "Yes",
    place: "No"
};
const frame136122Data = {
    ouinonProps: ouinon147Data
};
const buttonSecondary117Data = {
    children: "4/7",
    className: "button-secondary-85"
};
const toggle117Data = {
    className: "toggle-107",
    buttonSecondaryProps: buttonSecondary117Data
};
const quality4Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    inputType1: "text",
    inputPlaceholder1: "Connaissez vous votre bilan carbone?",
    inputType2: "text",
    inputPlaceholder2: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType3: "text",
    inputPlaceholder3: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    inputType4: "text",
    inputPlaceholder4: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    inputType5: "text",
    inputPlaceholder5: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    inputType6: "text",
    inputPlaceholder6: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    navItems3Props: navItems340Data,
    toggle1Props: toggle115Data,
    frame1361Props: frame136117Data,
    frame1362Props: frame136118Data,
    frame1363Props: frame136119Data,
    frame1364Props: frame136120Data,
    toggle2Props: toggle116Data,
    frame1365Props: frame136121Data,
    frame1366Props: frame136122Data,
    toggle3Props: toggle117Data
};
const frame11817Data = {
    children: "Visual management",
    className: "frame-113-35"
};
const headerMenuDefault9Data = {
    children: "Requirements",
    className: "menu-item-default-7"
};
const headerMenuDefault10Data = {
    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "Define,",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "Prepare,",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "Document"
        ]
    }),
    className: "menu-item-default-8"
};
const headerMenuDefault11Data = {
    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "Evaluate,",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "Correct"
        ]
    }),
    className: "menu-item-default-9"
};
const headerMenuDefault12Data = {
    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "Execute, ",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "Code"
        ]
    }),
    className: "menu-item-default-10"
};
const headerMenuDefault13Data = {
    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "Measure, ",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "Compare"
        ]
    }),
    className: "menu-item-default-11"
};
const headerMenuDefault14Data = {
    children: "Satisfaction",
    className: "menu-item-default-12"
};
const kaizenData = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    design: "Design",
    leanVsm: "Lean VSM",
    arrow12: "/img/arrow-1@2x.png",
    arrow13: "/img/arrow-2@2x.png",
    line2: "/img/line-2-14@2x.png",
    label1: "Zoom",
    textFormat: "/img/text-format-15@2x.png",
    label2: "Text",
    line23: "/img/line-22.png",
    place1: "Back",
    input: "INPUT",
    clickOnModeling: "CLICK ON \xe2\u20AC\u0153MODELING\xe2\u20AC\x9d BUTTON TO CREATE YOUR DIAGRAM",
    arrow5: "/img/arrow-5-6@2x.png",
    arrow1: "/img/arrow-1-8@2x.png",
    place2: "PLAN",
    arrow3: "/img/arrow-3-7@2x.png",
    arrow7: "/img/arrow-5-6@2x.png",
    act: "ACT",
    xdo: "DO",
    arrow4: "/img/arrow-4-7@2x.png",
    arrow6: "/img/arrow-5-6@2x.png",
    check: "CHECK",
    arrow2: "/img/arrow-2-8@2x.png",
    arrow8: "/img/arrow-5-6@2x.png",
    modeling: "Modeling",
    xcontinue: "Continue",
    output: "OUTPUT",
    frame118Props: frame11817Data,
    headerMenuDefault1Props: headerMenuDefault9Data,
    headerMenuDefault2Props: headerMenuDefault10Data,
    headerMenuDefault3Props: headerMenuDefault11Data,
    headerMenuDefault4Props: headerMenuDefault12Data,
    headerMenuDefault5Props: headerMenuDefault13Data,
    headerMenuDefault6Props: headerMenuDefault14Data
};
const frame11818Data = {
    children: "Visual management",
    className: "frame-113-37"
};
const frame62Data = {
    className: "frame-6-11"
};
const sMEDData = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    design: "Design",
    leanVsm: "Lean VSM",
    arrow121: "/img/arrow-1@2x.png",
    arrow131: "/img/arrow-2@2x.png",
    line2: "/img/line-2-14@2x.png",
    label1: "Zoom",
    textFormat: "/img/text-format-15@2x.png",
    label2: "Text",
    line23: "/img/line-22.png",
    place: "Back",
    clickOnModeling: "CLICK ON \xe2\u20AC\u0153MODELING\xe2\u20AC\x9d BUTTON TO CREATE YOUR DIAGRAM",
    label3: "FIN D\xe2\u20AC\u2122USINAGE SERIE A",
    arrow5: "/img/arrow-5-6@2x.png",
    label4: "DEBUT D\xe2\u20AC\u2122USINAGE SERIE B",
    arrow15: "/img/arrow-15-3@2x.png",
    arrow122: "/img/arrow-12-4@2x.png",
    arrow132: "/img/arrow-13-3@2x.png",
    dernierePieceBonneSerieA: "DERNIERE PIECE BONNE SERIE A",
    changementOutillage: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "CHANGEMENT",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            " OUTILLAGE"
        ]
    }),
    reglage: "REGLAGE",
    nettoyage: "NETTOYAGE",
    arrow18: "/img/arrow-18@2x.png",
    arrow17: "/img/arrow-17@2x.png",
    arrow16: "/img/arrow-16-1@2x.png",
    premierePieceBonneSerieB: "PREMIERE PIECE BONNE SERIE B",
    arrow14: "/img/arrow-15-3@2x.png",
    modeling: "Modeling",
    arrow11: "/img/arrow-11-8@2x.png",
    xcontinue: "Continue",
    frame118Props: frame11818Data,
    frame6Props: frame62Data
};
const frame11364Data = {
    children: "Visual management",
    className: "frame-113-7"
};
const visualManagementData = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    design: "Design",
    leanVsm: "Lean VSM",
    arrow9: "/img/arrow-1@2x.png",
    arrow10: "/img/arrow-2@2x.png",
    line2: "/img/line-2@2x.png",
    label1: "Zoom",
    textFormat: "/img/text-format@2x.png",
    label2: "Text",
    line1: "/img/line-1.png",
    place: "Back",
    clickOnModeling: "CLICK ON \xe2\u20AC\u0153MODELING\xe2\u20AC\x9d BUTTON TO CREATE YOUR DIAGRAM",
    connaissancesCompetences: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "Connaissances",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "Competences"
        ]
    }),
    collaborateursEquipes: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "Collaborateurs",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "Equipes"
        ]
    }),
    strategiesProjets: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "Strategies",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "Projets"
        ]
    }),
    ideesInformations: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "Idees",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "Informations"
        ]
    }),
    tempsPriorites: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "Temps ",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "Priorites"
        ]
    }),
    arrow11: "/img/arrow-11-10@2x.png",
    arrow16: "/img/arrow-16-4@2x.png",
    arrow13: "/img/arrow-13@2x.png",
    arrow14: "/img/arrow-14@2x.png",
    mieuxManager: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "Mieux",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            " Manager"
        ]
    }),
    arrow12: "/img/arrow-12@2x.png",
    arrow15: "/img/arrow-15@2x.png",
    problemesDecision: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "Problemes",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "Decision"
        ]
    }),
    modeling: "Modeling",
    analyzeTheFuturPerformances: "Analyze the futur performances",
    frame1136Props: frame11364Data
};
const frame11819Data = {
    children: "Visual management",
    className: "frame-113-38"
};
const kanbanData = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    design: "Design",
    leanVsm: "Lean VSM",
    arrow9: "/img/arrow-1@2x.png",
    arrow10: "/img/arrow-2@2x.png",
    rectangle23: "/img/rectangle-23@2x.png",
    line2: "/img/line-2-14@2x.png",
    label1: "Zoom",
    textFormat: "/img/text-format-15@2x.png",
    label2: "Text",
    line22: "/img/line-22.png",
    place1: "Back",
    clickOnModeling: "CLICK ON \xe2\u20AC\u0153MODELING\xe2\u20AC\x9d BUTTON TO CREATE YOUR DIAGRAM",
    place2: "PLAN",
    arrow11: "/img/arrow-11-12.png",
    line4: "/img/line-4-4.png",
    urgence: "URGENCE",
    aFaire: "A FAIRE",
    termine: "TERMINE",
    enAttente: "EN ATTENTE",
    enCours: "EN COURS",
    line3: "/img/line-3-5.png",
    modeling: "Modeling",
    xcontinue: "Continue",
    frame118Props: frame11819Data
};
const navItems239Data = {
    className: "nav-items-2-38"
};
const frame1172250Data = {
    children: "Existing Case"
};
const frame1162251Data = {
    children: "Reference Cases"
};
const frame1132268Data = {
    className: ""
};
const navItems341Data = {
    className: "nav-items-3-41",
    frame1172Props: frame1172250Data,
    frame1162Props: frame1162251Data,
    frame1132Props: frame1132268Data
};
const buttonSecondary118Data = {
    children: "1/2",
    className: "button-secondary-42"
};
const toggle118Data = {
    className: "toggle-108",
    buttonSecondaryProps: buttonSecondary118Data
};
const buttonSecondary119Data = {
    children: "ISO 50001 Norm",
    className: "button-secondary-42"
};
const toggle119Data = {
    className: "toggle-19",
    buttonSecondaryProps: buttonSecondary119Data
};
const group102125Data = {
    line24: "/img/line-24.png",
    className: ""
};
const group102126Data = {
    line24: "/img/line-24-1.png",
    className: "group-14-2"
};
const group102127Data = {
    line24: "/img/line-24-32.png",
    className: "group-14-3"
};
const group102128Data = {
    line24: "/img/line-24-3.png",
    className: "group-14-4"
};
const group102129Data = {
    line24: "/img/line-24-4.png",
    className: "group-14-5"
};
const frame1015Data = {
    className: "frame-99",
    toggleProps: toggle119Data,
    group1021Props: group102125Data,
    group1022Props: group102126Data,
    group1023Props: group102127Data,
    group1024Props: group102128Data,
    group1025Props: group102129Data
};
const buttonSecondary120Data = {
    children: "ISO 14001 Norm",
    className: "button-secondary-42"
};
const toggle120Data = {
    className: "toggle-19",
    buttonSecondaryProps: buttonSecondary120Data
};
const group102130Data = {
    line24: "/img/line-24-5.png",
    className: ""
};
const group102131Data = {
    line24: "/img/line-24-6.png",
    className: "group-14-6"
};
const group102132Data = {
    line24: "/img/line-24-7.png",
    className: "group-14-7"
};
const group102133Data = {
    line24: "/img/line-24-18.png",
    className: "group-14-8"
};
const group102134Data = {
    line24: "/img/line-24-19.png",
    className: "group-14"
};
const frame1025Data = {
    className: "frame-100",
    toggleProps: toggle120Data,
    group1021Props: group102130Data,
    group1022Props: group102131Data,
    group1023Props: group102132Data,
    group1024Props: group102133Data,
    group1025Props: group102134Data
};
const frame1173225Data = {
    className: "frame-116-158"
};
const kaizen2Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
    navItems2Props: navItems239Data,
    navItems3Props: navItems341Data,
    toggleProps: toggle118Data,
    frame101Props: frame1015Data,
    frame102Props: frame1025Data,
    frame11732Props: frame1173225Data
};
const frame1172251Data = {
    children: "Existing Case"
};
const frame1162252Data = {
    children: "Reference Cases"
};
const frame1132269Data = {
    className: ""
};
const navItems342Data = {
    className: "nav-items-3-42",
    frame1172Props: frame1172251Data,
    frame1162Props: frame1162252Data,
    frame1132Props: frame1132269Data
};
const buttonSecondary121Data = {
    children: "ISO 50001 Norm",
    className: "button-secondary-43"
};
const toggle121Data = {
    className: "toggle-20",
    buttonSecondaryProps: buttonSecondary121Data
};
const group102135Data = {
    line24: "/img/line-24.png",
    className: "group-15-1"
};
const group102136Data = {
    line24: "/img/line-24-1.png",
    className: "group-15-2"
};
const group102137Data = {
    line24: "/img/line-24-2.png",
    className: "group-15-3"
};
const group102138Data = {
    line24: "/img/line-24-3.png",
    className: "group-15-4"
};
const group102139Data = {
    line24: "/img/line-24-4.png",
    className: "group-15-5"
};
const frame1016Data = {
    className: "frame-95-2",
    toggleProps: toggle121Data,
    group1021Props: group102135Data,
    group1022Props: group102136Data,
    group1023Props: group102137Data,
    group1024Props: group102138Data,
    group1025Props: group102139Data
};
const buttonSecondary122Data = {
    children: "ISO 14001 Norm",
    className: "button-secondary-43"
};
const toggle122Data = {
    className: "toggle-20",
    buttonSecondaryProps: buttonSecondary122Data
};
const group102140Data = {
    line24: "/img/line-24-5.png",
    className: "group-15-6"
};
const group102141Data = {
    line24: "/img/line-24-6.png",
    className: "group-15-7"
};
const group102142Data = {
    line24: "/img/line-24-7.png",
    className: "group-15-8"
};
const group102143Data = {
    line24: "/img/line-24-18.png",
    className: "group-15-9"
};
const group102144Data = {
    line24: "/img/line-24-19.png",
    className: "group-15"
};
const frame1026Data = {
    className: "frame-96",
    toggleProps: toggle122Data,
    group1021Props: group102140Data,
    group1022Props: group102141Data,
    group1023Props: group102142Data,
    group1024Props: group102143Data,
    group1025Props: group102144Data
};
const buttonSecondary123Data = {
    children: "2/2",
    className: "button-secondary-43"
};
const toggle123Data = {
    className: "toggle-109",
    buttonSecondaryProps: buttonSecondary123Data
};
const kanban3Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
    kaizen: "Kaizen",
    navItems3Props: navItems342Data,
    frame101Props: frame1016Data,
    frame102Props: frame1026Data,
    toggleProps: toggle123Data
};
const headerMenuDefault52Data = {
    children: "Acquisition"
};
const headerMenuDefault24Data = {
    children: "Modeling",
    className: "menu-item-default-21"
};
const headerMenuDefault25Data = {
    children: "Analysis",
    className: "menu-item-default-22"
};
const headerMenuDefault26Data = {
    children: "Results & Objectives",
    className: "menu-item-default-19-1"
};
const frame2323Data = {
    headerMenuDefault2Props: headerMenuDefault26Data
};
const pricing39Data = {
    cost: "Cost"
};
const pricing310Data = {
    cost: "Modernization",
    className: "pricing-8-2"
};
const pricing311Data = {
    cost: "Social",
    className: "pricing-5-2"
};
const pricing312Data = {
    cost: "Client/Consumer",
    className: "pricing-7-2"
};
const mesureDePerformancesFuturesData = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    design: "Design",
    label1: "Design",
    label2: "Future performances",
    notesAtteintesPourChaqueCritre: "NOTES ATTEINTES POUR CHAQUE CRIT\xe0\u02C6RE",
    place: "Quality",
    inputType1: "text",
    inputPlaceholder1: "      /25",
    line211: "/img/line-21@2x.png",
    leadTime: "Lead Time",
    inputType2: "text",
    inputPlaceholder2: "      /25",
    line212: "/img/line-21-5@2x.png",
    environment: "Environment",
    inputType3: "text",
    inputPlaceholder3: "      /25",
    line213: "/img/line-21-5@2x.png",
    xcontinue: "Continue",
    headerMenuDefault5Props: headerMenuDefault52Data,
    headerMenuDefault21Props: headerMenuDefault24Data,
    headerMenuDefault22Props: headerMenuDefault25Data,
    frame232Props: frame2323Data,
    pricing31Props: pricing39Data,
    pricing32Props: pricing310Data,
    pricing33Props: pricing311Data,
    pricing34Props: pricing312Data
};
const navItems241Data = {
    className: "nav-items-2-40"
};
const frame1172252Data = {
    children: "Existing Case"
};
const frame1162253Data = {
    children: "Reference Cases"
};
const frame1132271Data = {
    className: ""
};
const navItems343Data = {
    className: "nav-items-3-43",
    frame1172Props: frame1172252Data,
    frame1162Props: frame1162253Data,
    frame1132Props: frame1132271Data
};
const buttonSecondary124Data = {
    children: "1/2",
    className: "button-secondary-86"
};
const toggle124Data = {
    className: "toggle-110",
    buttonSecondaryProps: buttonSecondary124Data
};
const buttonSecondary125Data = {
    children: "ISO 50001 Norm",
    className: "button-secondary-44"
};
const toggle125Data = {
    className: "toggle-21",
    buttonSecondaryProps: buttonSecondary125Data
};
const group102145Data = {
    line24: "/img/line-24.png",
    className: "group-16-1"
};
const group102146Data = {
    line24: "/img/line-24-1.png",
    className: "group-16-2"
};
const group102147Data = {
    line24: "/img/line-24-32.png",
    className: "group-16-3"
};
const group102148Data = {
    line24: "/img/line-24-3.png",
    className: ""
};
const group102149Data = {
    line24: "/img/line-24-4.png",
    className: ""
};
const frame1017Data = {
    className: "frame-97-2",
    toggleProps: toggle125Data,
    group1021Props: group102145Data,
    group1022Props: group102146Data,
    group1023Props: group102147Data,
    group1024Props: group102148Data,
    group1025Props: group102149Data
};
const buttonSecondary126Data = {
    children: "ISO 14001 Norm",
    className: "button-secondary-44"
};
const toggle126Data = {
    className: "toggle-21",
    buttonSecondaryProps: buttonSecondary126Data
};
const group102150Data = {
    line24: "/img/line-24-5.png",
    className: "group-16-4"
};
const group102151Data = {
    line24: "/img/line-24-6.png",
    className: "group-16-5"
};
const group102152Data = {
    line24: "/img/line-24-7.png",
    className: "group-16"
};
const group102153Data = {
    line24: "/img/line-24-18.png",
    className: ""
};
const group102154Data = {
    line24: "/img/line-24-19.png",
    className: ""
};
const frame1027Data = {
    className: "frame-98-2",
    toggleProps: toggle126Data,
    group1021Props: group102150Data,
    group1022Props: group102151Data,
    group1023Props: group102152Data,
    group1024Props: group102153Data,
    group1025Props: group102154Data
};
const frame1173226Data = {
    className: "frame-116-159"
};
const x5s2Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
    navItems2Props: navItems241Data,
    navItems3Props: navItems343Data,
    toggleProps: toggle124Data,
    frame101Props: frame1017Data,
    frame102Props: frame1027Data,
    frame11732Props: frame1173226Data
};
const navItems242Data = {
    className: "nav-items-2-41"
};
const frame1172253Data = {
    children: "Existing Case"
};
const frame1162254Data = {
    children: "Reference Cases"
};
const frame1132272Data = {
    className: ""
};
const navItems344Data = {
    className: "nav-items-3-44",
    frame1172Props: frame1172253Data,
    frame1162Props: frame1162254Data,
    frame1132Props: frame1132272Data
};
const buttonSecondary127Data = {
    children: "1/2",
    className: "button-secondary-45"
};
const toggle127Data = {
    className: "toggle-111",
    buttonSecondaryProps: buttonSecondary127Data
};
const buttonSecondary128Data = {
    children: "ISO 50001 Norm",
    className: "button-secondary-45"
};
const toggle128Data = {
    className: "toggle-22",
    buttonSecondaryProps: buttonSecondary128Data
};
const group102155Data = {
    line24: "/img/line-24.png",
    className: "group-17-1"
};
const group102156Data = {
    line24: "/img/line-24-1.png",
    className: "group-17-2"
};
const group102157Data = {
    line24: "/img/line-24-2.png",
    className: "group-17-3"
};
const group102158Data = {
    line24: "/img/line-24-3.png",
    className: "group-17-4"
};
const group102159Data = {
    line24: "/img/line-24-4.png",
    className: "group-17-5"
};
const frame1018Data = {
    className: "frame-97-3",
    toggleProps: toggle128Data,
    group1021Props: group102155Data,
    group1022Props: group102156Data,
    group1023Props: group102157Data,
    group1024Props: group102158Data,
    group1025Props: group102159Data
};
const buttonSecondary129Data = {
    children: "ISO 14001 Norm",
    className: "button-secondary-45"
};
const toggle129Data = {
    className: "toggle-22",
    buttonSecondaryProps: buttonSecondary129Data
};
const group102160Data = {
    line24: "/img/line-24-5.png",
    className: "group-17-6"
};
const group102161Data = {
    line24: "/img/line-24-6.png",
    className: "group-17-7"
};
const group102162Data = {
    line24: "/img/line-24-7.png",
    className: "group-17-8"
};
const group102163Data = {
    line24: "/img/line-24-18.png",
    className: "group-17-9"
};
const group102164Data = {
    line24: "/img/line-24-19.png",
    className: "group-17"
};
const frame1028Data = {
    className: "frame-98-3",
    toggleProps: toggle129Data,
    group1021Props: group102160Data,
    group1022Props: group102161Data,
    group1023Props: group102162Data,
    group1024Props: group102163Data,
    group1025Props: group102164Data
};
const frame1173227Data = {
    className: "frame-116-160"
};
const kanban2Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
    navItems2Props: navItems242Data,
    navItems3Props: navItems344Data,
    toggleProps: toggle127Data,
    frame101Props: frame1018Data,
    frame102Props: frame1028Data,
    frame11732Props: frame1173227Data
};
const navItems243Data = {
    className: "nav-items-2-42"
};
const frame1172254Data = {
    children: "Existing Case"
};
const frame1162255Data = {
    children: "Reference Cases"
};
const frame1132273Data = {
    className: ""
};
const navItems345Data = {
    className: "nav-items-3-45",
    frame1172Props: frame1172254Data,
    frame1162Props: frame1162255Data,
    frame1132Props: frame1132273Data
};
const buttonSecondary130Data = {
    children: "2/2",
    className: "button-secondary-46"
};
const toggle130Data = {
    className: "toggle-112",
    buttonSecondaryProps: buttonSecondary130Data
};
const buttonSecondary131Data = {
    children: "ISO 50001 Norm",
    className: "button-secondary-46"
};
const toggle131Data = {
    className: "toggle-23",
    buttonSecondaryProps: buttonSecondary131Data
};
const group102165Data = {
    line24: "/img/line-24.png",
    className: "group-18-1"
};
const group102166Data = {
    line24: "/img/line-24-1.png",
    className: "group-18-2"
};
const group102167Data = {
    line24: "/img/line-24-32.png",
    className: "group-18-3"
};
const group102168Data = {
    line24: "/img/line-24-3.png",
    className: ""
};
const group102169Data = {
    line24: "/img/line-24-4.png",
    className: ""
};
const frame1019Data = {
    className: "frame-95-3",
    toggleProps: toggle131Data,
    group1021Props: group102165Data,
    group1022Props: group102166Data,
    group1023Props: group102167Data,
    group1024Props: group102168Data,
    group1025Props: group102169Data
};
const buttonSecondary132Data = {
    children: "ISO 14001 Norm",
    className: "button-secondary-46"
};
const toggle132Data = {
    className: "toggle-23",
    buttonSecondaryProps: buttonSecondary132Data
};
const group102170Data = {
    line24: "/img/line-24-5.png",
    className: "group-18-4"
};
const group102171Data = {
    line24: "/img/line-24-6.png",
    className: "group-18-5"
};
const group102172Data = {
    line24: "/img/line-24-7.png",
    className: "group-18"
};
const group102173Data = {
    line24: "/img/line-24-18.png",
    className: ""
};
const group102174Data = {
    line24: "/img/line-24-19.png",
    className: ""
};
const frame1029Data = {
    className: "frame-96-1",
    toggleProps: toggle132Data,
    group1021Props: group102170Data,
    group1022Props: group102171Data,
    group1023Props: group102172Data,
    group1024Props: group102173Data,
    group1025Props: group102174Data
};
const x5s3Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
    kanban: "Kanban",
    navItems2Props: navItems243Data,
    navItems3Props: navItems345Data,
    toggleProps: toggle130Data,
    frame101Props: frame1019Data,
    frame102Props: frame1029Data
};
const frame1172255Data = {
    children: "Existing Case"
};
const frame1162256Data = {
    children: "Reference Cases"
};
const frame1132274Data = {
    className: ""
};
const navItems346Data = {
    className: "nav-items-3-46",
    frame1172Props: frame1172255Data,
    frame1162Props: frame1162256Data,
    frame1132Props: frame1132274Data
};
const buttonSecondary133Data = {
    children: "ISO 50001 Norm",
    className: "button-secondary-47"
};
const toggle133Data = {
    className: "toggle-24",
    buttonSecondaryProps: buttonSecondary133Data
};
const group102175Data = {
    line24: "/img/line-24-80.png"
};
const group102176Data = {
    line24: "/img/line-24-81.png"
};
const group102177Data = {
    line24: "/img/line-24-82.png"
};
const group102178Data = {
    line24: "/img/line-24-83.png"
};
const group102179Data = {
    line24: "/img/line-24-84.png"
};
const buttonSecondary134Data = {
    children: "ISO 14001 Norm",
    className: "button-secondary-47"
};
const toggle134Data = {
    className: "toggle-24",
    buttonSecondaryProps: buttonSecondary134Data
};
const group102180Data = {
    line24: "/img/line-24-5.png"
};
const group102181Data = {
    line24: "/img/line-24-6.png"
};
const group102182Data = {
    line24: "/img/line-24-7.png"
};
const group102183Data = {
    line24: "/img/line-24-8.png"
};
const group102184Data = {
    line24: "/img/line-24-9.png"
};
const frame1173228Data = {
    className: "frame-116-161"
};
const buttonSecondary135Data = {
    children: "2/3",
    className: "button-secondary-47"
};
const toggle135Data = {
    className: "toggle-113",
    buttonSecondaryProps: buttonSecondary135Data
};
const leanVSM3Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
    inputType1: "text",
    inputPlaceholder1: "A quelle fr\xe9quence renouvelez vous votre stock?",
    inputType2: "text",
    inputPlaceholder2: "combien de temps en moyenne un article effectue dans votre magazin?",
    inputType3: "text",
    inputPlaceholder3: "Vous arrive-t-il d\xe2\u20AC\u2122avoir des ruptures de stock? Si oui, \xe0\xa0 quelle fr\xe9quence?",
    inputType4: "text",
    inputPlaceholder4: "Avez vous mis en place de mesures d\xe2\u20AC\u2122am\xe9lioration?",
    inputType5: "text",
    inputPlaceholder5: "*******************************************",
    inputType6: "text",
    inputPlaceholder6: "Dans quel rayon se situe vos clients?",
    inputType7: "text",
    inputPlaceholder7: "A quelle fr\xe9quence effectuez vous des livraisons?",
    inputType8: "text",
    inputPlaceholder8: "Quel est votre taux de service?",
    inputType9: "text",
    inputPlaceholder9: "Quel est votre taux de retard?",
    inputType10: "text",
    inputPlaceholder10: "*************************************",
    navItems3Props: navItems346Data,
    toggle1Props: toggle133Data,
    group1021Props: group102175Data,
    group1022Props: group102176Data,
    group1023Props: group102177Data,
    group1024Props: group102178Data,
    group1025Props: group102179Data,
    toggle2Props: toggle134Data,
    group1026Props: group102180Data,
    group1027Props: group102181Data,
    group1028Props: group102182Data,
    group1029Props: group102183Data,
    group10210Props: group102184Data,
    frame11732Props: frame1173228Data,
    toggle3Props: toggle135Data
};
const navItems245Data = {
    className: "nav-items-2-44"
};
const frame1172256Data = {
    children: "Existing Case"
};
const frame1162257Data = {
    children: "Reference Cases"
};
const frame1132275Data = {
    className: ""
};
const navItems347Data = {
    className: "nav-items-3-47",
    frame1172Props: frame1172256Data,
    frame1162Props: frame1162257Data,
    frame1132Props: frame1132275Data
};
const buttonSecondary136Data = {
    children: "Storage time",
    className: "button-secondary-48"
};
const toggle136Data = {
    className: "toggle-25",
    buttonSecondaryProps: buttonSecondary136Data
};
const group102185Data = {
    line24: "/img/line-24-80.png"
};
const group102186Data = {
    line24: "/img/line-24-81.png"
};
const group102187Data = {
    line24: "/img/line-24-82.png"
};
const group102188Data = {
    line24: "/img/line-24-83.png"
};
const group102189Data = {
    line24: "/img/line-24-84.png"
};
const buttonSecondary137Data = {
    children: "1/3",
    className: "button-secondary-48"
};
const toggle137Data = {
    className: "toggle-114",
    buttonSecondaryProps: buttonSecondary137Data
};
const buttonSecondary138Data = {
    children: "Delivery time",
    className: "button-secondary-48"
};
const toggle138Data = {
    className: "toggle-25",
    buttonSecondaryProps: buttonSecondary138Data
};
const group102190Data = {
    line24: "/img/line-24-5.png"
};
const group102191Data = {
    line24: "/img/line-24-6.png"
};
const group102192Data = {
    line24: "/img/line-24-7.png"
};
const group102193Data = {
    line24: "/img/line-24-8.png"
};
const group102194Data = {
    line24: "/img/line-24-9.png"
};
const frame1173229Data = {
    className: "frame-116-162"
};
const leanVSM2Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
    inputType1: "text",
    inputPlaceholder1: "A quelle fr\xe9quence renouvelez vous votre stock?",
    inputType2: "text",
    inputPlaceholder2: "combien de temps en moyenne un article effectue dans votre magazin?",
    inputType3: "text",
    inputPlaceholder3: "Vous arrive-t-il d\xe2\u20AC\u2122avoir des ruptures de stock? Si oui, \xe0\xa0 quelle fr\xe9quence?",
    inputType4: "text",
    inputPlaceholder4: "Avez vous mis en place de mesures d\xe2\u20AC\u2122am\xe9lioration?",
    inputType5: "text",
    inputPlaceholder5: "*******************************************",
    inputType6: "text",
    inputPlaceholder6: "Dans quel rayon se situe vos clients?",
    inputType7: "text",
    inputPlaceholder7: "A quelle fr\xe9quence effectuez vous des livraisons?",
    inputType8: "text",
    inputPlaceholder8: "Quel est votre taux de service?",
    inputType9: "text",
    inputPlaceholder9: "Quel est votre taux de retard?",
    inputType10: "text",
    inputPlaceholder10: "*************************************",
    navItems2Props: navItems245Data,
    navItems3Props: navItems347Data,
    toggle1Props: toggle136Data,
    group1021Props: group102185Data,
    group1022Props: group102186Data,
    group1023Props: group102187Data,
    group1024Props: group102188Data,
    group1025Props: group102189Data,
    toggle2Props: toggle137Data,
    toggle3Props: toggle138Data,
    group1026Props: group102190Data,
    group1027Props: group102191Data,
    group1028Props: group102192Data,
    group1029Props: group102193Data,
    group10210Props: group102194Data,
    frame11732Props: frame1173229Data
};
const frame1133223Data = {
    className: "frame-113-22"
};
const frame1132276Data = {
    className: "frame-113-84"
};
const frame11820Data = {
    children: "Visual management",
    className: "frame-113-39"
};
const frame83Data = {
    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "5",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "IMPLEMENTATION OF COUNTERMEASURES"
        ]
    })
};
const frame822Data = {
    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "4",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "IDENTIFICATION OF COUNTERMEASURES"
        ]
    })
};
const frame98Data = {
    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "3",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "STUDY OF THE CAUSES"
        ]
    })
};
const kaizen11Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    label1: "Design",
    overlapGroup11: "/img/arrow-1@2x.png",
    arrow9: "/img/arrow-1@2x.png",
    overlapGroup3: "/img/arrow-2@2x.png",
    arrow10: "/img/arrow-2@2x.png",
    line4: "/img/line-2@2x.png",
    line2: "/img/line-2@2x.png",
    label2: "Zoom",
    label3: "Zoom",
    overlapGroup2: "/img/text-format@2x.png",
    textFormat: "/img/text-format@2x.png",
    label4: "Text",
    label5: "Text",
    overlapGroup4: "/img/line-1.png",
    line1: "/img/line-1.png",
    place: "Back",
    label6: "CONTINUOUS IMPROVEMENT PROCESS",
    x1IdentificationOf: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "1",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "IDENTIFICATION OF THE PROBLEM TO BE TREATED"
        ]
    }),
    x2StudyOfTheSituation: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "2 ",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "STUDY OF THE SITUATION"
        ]
    }),
    arrow6: "/img/arrow-6-11@2x.png",
    x6AuditOfCountermeasures: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "6",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "AUDIT OF COUNTERMEASURES"
        ]
    }),
    arrow16: "/img/arrow-16-2@2x.png",
    arrow13: "/img/arrow-6-11@2x.png",
    arrow14: "/img/arrow-14-2@2x.png",
    arrow15: "/img/arrow-15-2@2x.png",
    arrow17: "/img/arrow-17-1@2x.png",
    x7StandardizationOfGoodMeasures: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "7",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "STANDARDIZATION OF GOOD MEASURES"
        ]
    }),
    modeling: "Modeling",
    xcontinue: "Continue",
    frame11332Props: frame1133223Data,
    frame11322Props: frame1132276Data,
    frame118Props: frame11820Data,
    frame8Props: frame83Data,
    frame82Props: frame822Data,
    frame9Props: frame98Data
};
const frame1172257Data = {
    children: "Existing Case"
};
const frame1162258Data = {
    children: "Reference Cases"
};
const frame1132277Data = {
    className: ""
};
const navItems348Data = {
    className: "nav-items-3-48",
    frame1172Props: frame1172257Data,
    frame1162Props: frame1162258Data,
    frame1132Props: frame1132277Data
};
const buttonSecondary139Data = {
    children: "Leadership 1",
    className: ""
};
const toggle139Data = {
    className: "toggle-115",
    buttonSecondaryProps: buttonSecondary139Data
};
const ouinon148Data = {
    yes: "Yes",
    place: "No"
};
const frame136123Data = {
    ouinonProps: ouinon148Data
};
const ouinon149Data = {
    yes: "Yes",
    place: "No"
};
const frame136124Data = {
    ouinonProps: ouinon149Data
};
const ouinon150Data = {
    yes: "Yes",
    place: "No"
};
const frame136125Data = {
    ouinonProps: ouinon150Data
};
const ouinon151Data = {
    yes: "Yes",
    place: "No"
};
const frame136126Data = {
    ouinonProps: ouinon151Data
};
const buttonSecondary140Data = {
    children: "Leadership 2",
    className: ""
};
const toggle140Data = {
    className: "toggle-116",
    buttonSecondaryProps: buttonSecondary140Data
};
const ouinon152Data = {
    yes: "Yes",
    place: "No"
};
const frame136127Data = {
    ouinonProps: ouinon152Data
};
const ouinon153Data = {
    yes: "Yes",
    place: "No"
};
const frame136128Data = {
    ouinonProps: ouinon153Data
};
const ouinon154Data = {
    yes: "Yes",
    place: "No"
};
const frame136129Data = {
    ouinonProps: ouinon154Data
};
const buttonSecondary141Data = {
    children: "3/7",
    className: "button-secondary-87"
};
const toggle141Data = {
    className: "toggle-117",
    buttonSecondaryProps: buttonSecondary141Data
};
const quality3Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    inputType1: "text",
    inputPlaceholder1: "Connaissez vous votre bilan carbone?",
    inputType2: "text",
    inputPlaceholder2: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType3: "text",
    inputPlaceholder3: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    inputType4: "text",
    inputPlaceholder4: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    inputType5: "text",
    inputPlaceholder5: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    inputType6: "text",
    inputPlaceholder6: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    inputType7: "text",
    inputPlaceholder7: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    next: "Next",
    navItems3Props: navItems348Data,
    toggle1Props: toggle139Data,
    frame1361Props: frame136123Data,
    frame1362Props: frame136124Data,
    frame1363Props: frame136125Data,
    frame1364Props: frame136126Data,
    toggle2Props: toggle140Data,
    frame1365Props: frame136127Data,
    frame1366Props: frame136128Data,
    frame1367Props: frame136129Data,
    toggle3Props: toggle141Data
};
const navItems247Data = {
    className: "nav-items-2-46"
};
const frame1172258Data = {
    children: "Existing Case"
};
const frame1162259Data = {
    children: "Reference Cases"
};
const frame1132278Data = {
    className: ""
};
const navItems349Data = {
    className: "nav-items-3-49",
    frame1172Props: frame1172258Data,
    frame1162Props: frame1162259Data,
    frame1132Props: frame1132278Data
};
const buttonSecondary142Data = {
    children: "3/3",
    className: "button-secondary-49"
};
const toggle142Data = {
    className: "toggle-118",
    buttonSecondaryProps: buttonSecondary142Data
};
const buttonSecondary143Data = {
    children: "ISO 50001 Norm",
    className: "button-secondary-49"
};
const toggle143Data = {
    className: "toggle-26",
    buttonSecondaryProps: buttonSecondary143Data
};
const group102195Data = {
    line24: "/img/line-24-80.png",
    className: "group-21-1"
};
const group102196Data = {
    line24: "/img/line-24-81.png",
    className: "group-21-2"
};
const group102197Data = {
    line24: "/img/line-24-82.png",
    className: "group-21-3"
};
const group102198Data = {
    line24: "/img/line-24-83.png",
    className: "group-21-4"
};
const group102199Data = {
    line24: "/img/line-24-84.png",
    className: "group-21"
};
const buttonSecondary144Data = {
    children: "ISO 14001 Norm",
    className: "button-secondary-49"
};
const toggle144Data = {
    className: "toggle-26",
    buttonSecondaryProps: buttonSecondary144Data
};
const group102200Data = {
    line24: "/img/line-24-5.png",
    className: ""
};
const group102201Data = {
    line24: "/img/line-24-6.png",
    className: ""
};
const group102202Data = {
    line24: "/img/line-24-7.png",
    className: ""
};
const group102203Data = {
    line24: "/img/line-24-8.png",
    className: ""
};
const group102204Data = {
    line24: "/img/line-24-9.png",
    className: ""
};
const frame10210Data = {
    className: "frame-96-2",
    toggleProps: toggle144Data,
    group1021Props: group102200Data,
    group1022Props: group102201Data,
    group1023Props: group102202Data,
    group1024Props: group102203Data,
    group1025Props: group102204Data
};
const leanVSM4Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
    inputType1: "text",
    inputPlaceholder1: "A quelle fr\xe9quence renouvelez vous votre stock?",
    inputType2: "text",
    inputPlaceholder2: "combien de temps en moyenne un article effectue dans votre magazin?",
    inputType3: "text",
    inputPlaceholder3: "Vous arrive-t-il d\xe2\u20AC\u2122avoir des ruptures de stock? Si oui, \xe0\xa0 quelle fr\xe9quence?",
    inputType4: "text",
    inputPlaceholder4: "Avez vous mis en place de mesures d\xe2\u20AC\u2122am\xe9lioration?",
    inputType5: "text",
    inputPlaceholder5: "*******************************************",
    x5S: "5S",
    navItems2Props: navItems247Data,
    navItems3Props: navItems349Data,
    toggle1Props: toggle142Data,
    toggle2Props: toggle143Data,
    group1021Props: group102195Data,
    group1022Props: group102196Data,
    group1023Props: group102197Data,
    group1024Props: group102198Data,
    group1025Props: group102199Data,
    frame102Props: frame10210Data
};
const headerMenuDefault53Data = {
    children: "Acquisition"
};
const headerMenuDefault54Data = {
    children: "Modeling",
    className: "menu-item-default-32"
};
const headerMenuDefault55Data = {
    children: "Analysis",
    className: "menu-item-default-33"
};
const headerMenuDefault27Data = {
    children: "Results & Objectives",
    className: "menu-item-default-19-1"
};
const frame2324Data = {
    headerMenuDefault2Props: headerMenuDefault27Data
};
const frame72Data = {
    className: "frame-7-10"
};
const mesureDePerformancesFutures1Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    design: "Design",
    label1: "Design",
    label2: "Future performances",
    finish: "Finish",
    headerMenuDefault51Props: headerMenuDefault53Data,
    headerMenuDefault52Props: headerMenuDefault54Data,
    headerMenuDefault53Props: headerMenuDefault55Data,
    frame232Props: frame2324Data,
    frame7Props: frame72Data
};
const frame1172259Data = {
    children: "Existing Case"
};
const frame1162260Data = {
    children: "Reference Cases"
};
const frame1132280Data = {
    className: ""
};
const navItems350Data = {
    className: "nav-items-3-50",
    frame1172Props: frame1172259Data,
    frame1162Props: frame1162260Data,
    frame1132Props: frame1132280Data
};
const frame1122Data = {
    children: "3. Kanban",
    className: "frame-114-112"
};
const existingSystems2Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    existingSystems: "EXISTING SYSTEMS",
    x2SupplementaryModels: "2.   SUPPLEMENTARY MODELS",
    leanVsm: "Lean VSM",
    x4Kaizen: "4. Kaizen",
    x25S: "2. 5S",
    x5Smed: "5. SMED",
    x6VisualManagement: "6. Visual Management",
    ellipse116: "/img/polygon-3@2x.png",
    navItems3Props: navItems350Data,
    frame112Props: frame1122Data
};
const frame1172260Data = {
    children: "Existing Case"
};
const frame1162261Data = {
    children: "Reference Cases"
};
const frame1132281Data = {
    className: ""
};
const navItems351Data = {
    className: "nav-items-3-51",
    frame1172Props: frame1172260Data,
    frame1162Props: frame1162261Data,
    frame1132Props: frame1132281Data
};
const buttonSecondary145Data = {
    children: "Changement Climamtique",
    className: ""
};
const toggle145Data = {
    className: "toggle-119",
    buttonSecondaryProps: buttonSecondary145Data
};
const ouinon155Data = {
    yes: "Yes",
    place: "No",
    className: "ouinon-32"
};
const ouinon156Data = {
    yes: "Yes",
    place: "No",
    className: "ouinon-33"
};
const buttonSecondary146Data = {
    children: "Autre nuisance",
    className: ""
};
const toggle146Data = {
    className: "toggle-120",
    buttonSecondaryProps: buttonSecondary146Data
};
const ouinon157Data = {
    yes: "Yes",
    place: "No",
    className: "ouinon-34"
};
const ouinon158Data = {
    yes: "Yes",
    place: "No",
    className: "ouinon-35"
};
const ouinon159Data = {
    yes: "Yes",
    place: "No",
    className: "ouinon-36"
};
const buttonSecondary147Data = {
    children: "5/5",
    className: "button-secondary-88"
};
const toggle147Data = {
    className: "toggle-121",
    buttonSecondaryProps: buttonSecondary147Data
};
const environmental5Data = {
    x1200PxLogo_Icam__20082: "/img/1200px-logo-icam---2008-1@2x.png",
    inputType1: "text",
    inputPlaceholder1: "Connaissez vous votre bilan carbone?",
    inputType2: "text",
    inputPlaceholder2: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType3: "text",
    inputPlaceholder3: "Connaissez vous votre bilan carbone?",
    inputType4: "text",
    inputPlaceholder4: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType5: "text",
    inputPlaceholder5: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    socialCriteria: "Social Criteria",
    navItems3Props: navItems351Data,
    toggle1Props: toggle145Data,
    ouinon1Props: ouinon155Data,
    ouinon2Props: ouinon156Data,
    toggle2Props: toggle146Data,
    ouinon3Props: ouinon157Data,
    ouinon4Props: ouinon158Data,
    ouinon5Props: ouinon159Data,
    toggle3Props: toggle147Data
};
const frame1172261Data = {
    children: "Existing Case"
};
const frame1162262Data = {
    children: "Reference Cases"
};
const frame1132282Data = {
    className: ""
};
const navItems352Data = {
    className: "nav-items-3-52",
    frame1172Props: frame1172261Data,
    frame1162Props: frame1162262Data,
    frame1132Props: frame1132282Data
};
const buttonSecondary148Data = {
    children: "Conditions de travail et qualit\xe9 de vie au travail 1",
    className: ""
};
const toggle148Data = {
    className: "toggle-4",
    buttonSecondaryProps: buttonSecondary148Data
};
const ouinon160Data = {
    yes: "Yes",
    place: "No",
    className: "ouinon-37"
};
const ouinon161Data = {
    yes: "Yes",
    place: "No",
    className: "ouinon-38"
};
const buttonSecondary149Data = {
    children: "Conditions de travail et qualit\xe9 de vie au travail 2",
    className: ""
};
const toggle149Data = {
    className: "toggle-4",
    buttonSecondaryProps: buttonSecondary149Data
};
const ouinon162Data = {
    yes: "Yes",
    place: "No"
};
const frame136130Data = {
    ouinonProps: ouinon162Data
};
const ouinon163Data = {
    yes: "Yes",
    place: "No"
};
const frame136131Data = {
    ouinonProps: ouinon163Data
};
const ouinon164Data = {
    yes: "Yes",
    place: "No"
};
const frame136132Data = {
    ouinonProps: ouinon164Data
};
const buttonSecondary150Data = {
    children: "3/6",
    className: "button-secondary-89"
};
const toggle150Data = {
    className: "toggle-122",
    buttonSecondaryProps: buttonSecondary150Data
};
const social3Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    inputType1: "text",
    inputPlaceholder1: "Connaissez vous votre bilan carbone?",
    inputType2: "text",
    inputPlaceholder2: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType3: "text",
    inputPlaceholder3: "Connaissez vous votre bilan carbone?",
    inputType4: "text",
    inputPlaceholder4: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType5: "text",
    inputPlaceholder5: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    navItems3Props: navItems352Data,
    toggle1Props: toggle148Data,
    ouinon1Props: ouinon160Data,
    ouinon2Props: ouinon161Data,
    toggle2Props: toggle149Data,
    frame1361Props: frame136130Data,
    frame1362Props: frame136131Data,
    frame1363Props: frame136132Data,
    toggle3Props: toggle150Data
};
const frame1172262Data = {
    children: "Existing Case"
};
const frame1162263Data = {
    children: "Reference Cases"
};
const frame1132283Data = {
    className: ""
};
const navItems353Data = {
    className: "nav-items-3-53",
    frame1172Props: frame1172262Data,
    frame1162Props: frame1162263Data,
    frame1132Props: frame1132283Data
};
const buttonSecondary151Data = {
    children: "Economie Circulaire 1",
    className: ""
};
const toggle151Data = {
    className: "toggle-123",
    buttonSecondaryProps: buttonSecondary151Data
};
const frame426Data = {
    className: ""
};
const frame436Data = {
    className: ""
};
const ouinon214Data = {
    className: "ouinon-50",
    frame42Props: frame426Data,
    frame43Props: frame436Data
};
const frame427Data = {
    className: ""
};
const frame437Data = {
    className: ""
};
const ouinon215Data = {
    className: "ouinon-51",
    frame42Props: frame427Data,
    frame43Props: frame437Data
};
const buttonSecondary152Data = {
    children: "Economie Circulaire 2",
    className: ""
};
const toggle152Data = {
    className: "toggle-124",
    buttonSecondaryProps: buttonSecondary152Data
};
const frame428Data = {
    className: "frame-4-55-1"
};
const frame438Data = {
    className: "frame-4-63-1"
};
const ouinon216Data = {
    className: "ouinon-52",
    frame42Props: frame428Data,
    frame43Props: frame438Data
};
const frame429Data = {
    className: "frame-4-55"
};
const frame439Data = {
    className: "frame-4-63"
};
const ouinon217Data = {
    className: "ouinon-53",
    frame42Props: frame429Data,
    frame43Props: frame439Data
};
const buttonSecondary153Data = {
    children: "Economie Circulaire 3",
    className: ""
};
const toggle153Data = {
    className: "toggle-125",
    buttonSecondaryProps: buttonSecondary153Data
};
const ouinon165Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-39"
};
const ouinon166Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-40"
};
const ouinon167Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-41"
};
const buttonSecondary154Data = {
    children: "4/5",
    className: "button-secondary-90"
};
const toggle154Data = {
    className: "toggle-126",
    buttonSecondaryProps: buttonSecondary154Data
};
const environmental4Data = {
    x1200PxLogo_Icam__20082: "/img/1200px-logo-icam---2008-1@2x.png",
    inputType1: "text",
    inputPlaceholder1: "Connaissez vous votre bilan carbone?",
    inputType2: "text",
    inputPlaceholder2: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType3: "text",
    inputPlaceholder3: "Connaissez vous votre bilan carbone?",
    inputType4: "text",
    inputPlaceholder4: "Connaissez vous votre bilan carbone?",
    inputType5: "text",
    inputPlaceholder5: "Connaissez vous votre bilan carbone?",
    inputType6: "text",
    inputPlaceholder6: "Connaissez vous votre bilan carbone?",
    inputType7: "text",
    inputPlaceholder7: "Connaissez vous votre bilan carbone?",
    navItems3Props: navItems353Data,
    toggle1Props: toggle151Data,
    ouinon21Props: ouinon214Data,
    ouinon22Props: ouinon215Data,
    toggle2Props: toggle152Data,
    ouinon23Props: ouinon216Data,
    ouinon24Props: ouinon217Data,
    toggle3Props: toggle153Data,
    ouinon1Props: ouinon165Data,
    ouinon2Props: ouinon166Data,
    ouinon3Props: ouinon167Data,
    toggle4Props: toggle154Data
};
const frame1172263Data = {
    children: "Existing Case"
};
const frame1162264Data = {
    children: "Reference Cases"
};
const frame1132284Data = {
    className: ""
};
const navItems354Data = {
    className: "nav-items-3-54",
    frame1172Props: frame1172263Data,
    frame1162Props: frame1162264Data,
    frame1132Props: frame1132284Data
};
const buttonSecondary155Data = {
    children: "Cyber-physical system (CPS) 1",
    className: ""
};
const toggle155Data = {
    className: "toggle-5",
    buttonSecondaryProps: buttonSecondary155Data
};
const ouinon168Data = {
    yes: "Yes",
    place: "No"
};
const frame136133Data = {
    ouinonProps: ouinon168Data
};
const ouinon169Data = {
    yes: "Yes",
    place: "No"
};
const frame136134Data = {
    ouinonProps: ouinon169Data
};
const buttonSecondary156Data = {
    children: "Cyber-physical system (CPS) 2",
    className: ""
};
const toggle156Data = {
    className: "toggle-5",
    buttonSecondaryProps: buttonSecondary156Data
};
const ouinon170Data = {
    yes: "Yes",
    place: "No"
};
const frame136135Data = {
    ouinonProps: ouinon170Data
};
const ouinon171Data = {
    yes: "Yes",
    place: "No"
};
const frame136136Data = {
    className: "frame-153-7",
    ouinonProps: ouinon171Data
};
const frame1339Data = {
    frame136Props: frame136136Data
};
const frame1448Data = {
    frame133Props: frame1339Data
};
const buttonSecondary157Data = {
    children: "3/4",
    className: "button-secondary-91"
};
const toggle157Data = {
    className: "toggle-127",
    buttonSecondaryProps: buttonSecondary157Data
};
const modernization3Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    inputType1: "text",
    inputPlaceholder1: "Connaissez vous votre bilan carbone?",
    inputType2: "text",
    inputPlaceholder2: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType3: "text",
    inputPlaceholder3: "Connaissez vous votre bilan carbone?",
    inputType4: "text",
    inputPlaceholder4: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    navItems3Props: navItems354Data,
    toggle1Props: toggle155Data,
    frame1361Props: frame136133Data,
    frame1362Props: frame136134Data,
    toggle2Props: toggle156Data,
    frame1363Props: frame136135Data,
    frame144Props: frame1448Data,
    toggle3Props: toggle157Data
};
const frame1172264Data = {
    children: "Existing Case"
};
const frame1162265Data = {
    children: "Reference Cases"
};
const frame1132285Data = {
    className: ""
};
const navItems355Data = {
    className: "nav-items-3-55",
    frame1172Props: frame1172264Data,
    frame1162Props: frame1162265Data,
    frame1132Props: frame1132285Data
};
const buttonSecondary158Data = {
    children: "Dialogue Social 1",
    className: ""
};
const toggle158Data = {
    className: "toggle-128",
    buttonSecondaryProps: buttonSecondary158Data
};
const frame4210Data = {
    className: ""
};
const frame4310Data = {
    className: ""
};
const ouinon218Data = {
    frame42Props: frame4210Data,
    frame43Props: frame4310Data
};
const frame4211Data = {
    className: ""
};
const frame4311Data = {
    className: ""
};
const ouinon219Data = {
    className: "ouinon-55",
    frame42Props: frame4211Data,
    frame43Props: frame4311Data
};
const frame4212Data = {
    className: ""
};
const frame4312Data = {
    className: ""
};
const ouinon220Data = {
    className: "ouinon-56",
    frame42Props: frame4212Data,
    frame43Props: frame4312Data
};
const buttonSecondary159Data = {
    children: "Dialogue Social 2",
    className: ""
};
const toggle159Data = {
    className: "toggle-129",
    buttonSecondaryProps: buttonSecondary159Data
};
const frame4213Data = {
    className: "frame-4-57-1"
};
const frame4313Data = {
    className: "frame-4-65-1"
};
const ouinon221Data = {
    className: "ouinon-47",
    frame42Props: frame4213Data,
    frame43Props: frame4313Data
};
const frame4214Data = {
    className: "frame-4-57"
};
const frame4314Data = {
    className: "frame-4-65"
};
const ouinon222Data = {
    className: "ouinon-47",
    frame42Props: frame4214Data,
    frame43Props: frame4314Data
};
const buttonSecondary160Data = {
    children: "Dialogue Social 3",
    className: ""
};
const toggle160Data = {
    className: "toggle-130",
    buttonSecondaryProps: buttonSecondary160Data
};
const ouinon172Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-23-1"
};
const ouinon173Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-23-2"
};
const ouinon174Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-23"
};
const buttonSecondary161Data = {
    children: "4/6",
    className: "button-secondary-92"
};
const toggle161Data = {
    className: "toggle-131",
    buttonSecondaryProps: buttonSecondary161Data
};
const social4Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    inputType1: "text",
    inputPlaceholder1: "Connaissez vous votre bilan carbone?",
    inputType2: "text",
    inputPlaceholder2: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType3: "text",
    inputPlaceholder3: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType4: "text",
    inputPlaceholder4: "Connaissez vous votre bilan carbone?",
    inputType5: "text",
    inputPlaceholder5: "Connaissez vous votre bilan carbone?",
    inputType6: "text",
    inputPlaceholder6: "Connaissez vous votre bilan carbone?",
    inputType7: "text",
    inputPlaceholder7: "Connaissez vous votre bilan carbone?",
    inputType8: "text",
    inputPlaceholder8: "Connaissez vous votre bilan carbone?",
    navItems3Props: navItems355Data,
    toggle1Props: toggle158Data,
    ouinon21Props: ouinon218Data,
    ouinon22Props: ouinon219Data,
    ouinon23Props: ouinon220Data,
    toggle2Props: toggle159Data,
    ouinon24Props: ouinon221Data,
    ouinon25Props: ouinon222Data,
    toggle3Props: toggle160Data,
    ouinon1Props: ouinon172Data,
    ouinon2Props: ouinon173Data,
    ouinon3Props: ouinon174Data,
    toggle4Props: toggle161Data
};
const frame1172265Data = {
    children: "Existing Case"
};
const frame1162266Data = {
    children: "Reference Cases"
};
const frame1132286Data = {
    className: ""
};
const navItems356Data = {
    className: "nav-items-3-56",
    frame1172Props: frame1172265Data,
    frame1162Props: frame1162266Data,
    frame1132Props: frame1132286Data
};
const buttonSecondary162Data = {
    children: "D\xe9veloppement du capital humain 1",
    className: ""
};
const toggle162Data = {
    className: "toggle-132",
    buttonSecondaryProps: buttonSecondary162Data
};
const frame4215Data = {
    className: "frame-4-59-1"
};
const frame4315Data = {
    className: "frame-4-67-1"
};
const ouinon223Data = {
    className: "ouinon-57",
    frame42Props: frame4215Data,
    frame43Props: frame4315Data
};
const frame4216Data = {
    className: "frame-4-59-2"
};
const frame4316Data = {
    className: "frame-4-67-2"
};
const ouinon224Data = {
    className: "ouinon-58",
    frame42Props: frame4216Data,
    frame43Props: frame4316Data
};
const frame4217Data = {
    className: "frame-4-59"
};
const frame4317Data = {
    className: "frame-4-67"
};
const ouinon225Data = {
    className: "ouinon-59",
    frame42Props: frame4217Data,
    frame43Props: frame4317Data
};
const buttonSecondary163Data = {
    children: "D\xe9veloppement du capital humain 2",
    className: ""
};
const toggle163Data = {
    className: "toggle-133",
    buttonSecondaryProps: buttonSecondary163Data
};
const ouinon175Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-25-1"
};
const ouinon176Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-25-2"
};
const ouinon177Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-25"
};
const buttonSecondary164Data = {
    children: "D\xe9veloppement du capital humain 3",
    className: ""
};
const toggle164Data = {
    className: "toggle-134",
    buttonSecondaryProps: buttonSecondary164Data
};
const ouinon178Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-42"
};
const buttonSecondary165Data = {
    children: "6/6",
    className: "button-secondary-93"
};
const toggle165Data = {
    className: "toggle-135",
    buttonSecondaryProps: buttonSecondary165Data
};
const social6Data = {
    x1200PxLogo_Icam__20081: "",
    inputType1: "text",
    inputPlaceholder1: "Connaissez vous votre bilan carbone?",
    inputType2: "text",
    inputPlaceholder2: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType3: "text",
    inputPlaceholder3: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType4: "text",
    inputPlaceholder4: "Connaissez vous votre bilan carbone?",
    inputType5: "text",
    inputPlaceholder5: "Connaissez vous votre bilan carbone?",
    inputType6: "text",
    inputPlaceholder6: "Connaissez vous votre bilan carbone?",
    inputType7: "text",
    inputPlaceholder7: "Connaissez vous votre bilan carbone?",
    modernizationCriteria: "Modernization criteria",
    navItems3Props: navItems356Data,
    toggle1Props: toggle162Data,
    ouinon21Props: ouinon223Data,
    ouinon22Props: ouinon224Data,
    ouinon23Props: ouinon225Data,
    toggle2Props: toggle163Data,
    ouinon1Props: ouinon175Data,
    ouinon2Props: ouinon176Data,
    ouinon3Props: ouinon177Data,
    toggle3Props: toggle164Data,
    ouinon4Props: ouinon178Data,
    toggle4Props: toggle165Data
};
const frame1172266Data = {
    children: "Existing Case"
};
const frame1162267Data = {
    children: "Reference Cases"
};
const frame1132287Data = {
    className: ""
};
const navItems357Data = {
    className: "nav-items-3-57",
    frame1172Props: frame1172266Data,
    frame1162Props: frame1162267Data,
    frame1132Props: frame1132287Data
};
const buttonSecondary166Data = {
    children: "Sant\xe9 et S\xe9curit\xe9 au travail 1",
    className: ""
};
const toggle166Data = {
    className: "toggle-136",
    buttonSecondaryProps: buttonSecondary166Data
};
const frame4218Data = {
    className: "frame-4-58-1"
};
const frame4318Data = {
    className: "frame-4-66-1"
};
const ouinon226Data = {
    className: "ouinon-60",
    frame42Props: frame4218Data,
    frame43Props: frame4318Data
};
const frame4219Data = {
    className: "frame-4-58-2"
};
const frame4319Data = {
    className: "frame-4-66-2"
};
const ouinon227Data = {
    className: "ouinon-61",
    frame42Props: frame4219Data,
    frame43Props: frame4319Data
};
const frame4220Data = {
    className: "frame-4-58-3"
};
const frame4320Data = {
    className: "frame-4-66-3"
};
const ouinon228Data = {
    className: "ouinon-62",
    frame42Props: frame4220Data,
    frame43Props: frame4320Data
};
const frame4221Data = {
    className: "frame-4-58"
};
const frame4321Data = {
    className: "frame-4-66"
};
const ouinon229Data = {
    className: "ouinon-63",
    frame42Props: frame4221Data,
    frame43Props: frame4321Data
};
const buttonSecondary167Data = {
    children: "Sant\xe9 et S\xe9curit\xe9 au travail 2",
    className: ""
};
const toggle167Data = {
    className: "toggle-137",
    buttonSecondaryProps: buttonSecondary167Data
};
const ouinon179Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-26-1"
};
const ouinon180Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-26-2"
};
const ouinon181Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-26"
};
const buttonSecondary168Data = {
    children: "Sant\xe9 et S\xe9curit\xe9 au travail 3",
    className: ""
};
const toggle168Data = {
    className: "toggle-138",
    buttonSecondaryProps: buttonSecondary168Data
};
const ouinon182Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-43"
};
const buttonSecondary169Data = {
    children: "5/6",
    className: "button-secondary-94"
};
const toggle169Data = {
    className: "toggle-139",
    buttonSecondaryProps: buttonSecondary169Data
};
const social5Data = {
    x1200PxLogo_Icam__20081: "",
    inputType1: "text",
    inputPlaceholder1: "Connaissez vous votre bilan carbone?",
    inputType2: "text",
    inputPlaceholder2: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType3: "text",
    inputPlaceholder3: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType4: "text",
    inputPlaceholder4: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType5: "text",
    inputPlaceholder5: "Connaissez vous votre bilan carbone?",
    inputType6: "text",
    inputPlaceholder6: "Connaissez vous votre bilan carbone?",
    inputType7: "text",
    inputPlaceholder7: "Connaissez vous votre bilan carbone?",
    inputType8: "text",
    inputPlaceholder8: "Connaissez vous votre bilan carbone?",
    navItems3Props: navItems357Data,
    toggle1Props: toggle166Data,
    ouinon21Props: ouinon226Data,
    ouinon22Props: ouinon227Data,
    ouinon23Props: ouinon228Data,
    ouinon24Props: ouinon229Data,
    toggle2Props: toggle167Data,
    ouinon1Props: ouinon179Data,
    ouinon2Props: ouinon180Data,
    ouinon3Props: ouinon181Data,
    toggle3Props: toggle168Data,
    ouinon4Props: ouinon182Data,
    toggle4Props: toggle169Data
};
const frame1172267Data = {
    children: "Existing Case"
};
const frame1162268Data = {
    children: "Reference Cases"
};
const frame1132288Data = {
    className: ""
};
const navItems358Data = {
    className: "nav-items-3-58",
    frame1172Props: frame1172267Data,
    frame1162Props: frame1162268Data,
    frame1132Props: frame1132288Data
};
const buttonSecondary170Data = {
    children: "Information and Communication Technoly (ICT)",
    className: ""
};
const toggle170Data = {
    className: "toggle-6",
    buttonSecondaryProps: buttonSecondary170Data
};
const ouinon183Data = {
    yes: "Yes",
    place: "No"
};
const frame136137Data = {
    ouinonProps: ouinon183Data
};
const ouinon184Data = {
    yes: "Yes",
    place: "No"
};
const frame136138Data = {
    ouinonProps: ouinon184Data
};
const ouinon185Data = {
    yes: "Yes",
    place: "No"
};
const frame136139Data = {
    ouinonProps: ouinon185Data
};
const ouinon186Data = {
    yes: "Yes",
    place: "No"
};
const frame136140Data = {
    ouinonProps: ouinon186Data
};
const ouinon187Data = {
    yes: "Yes",
    place: "No"
};
const frame136141Data = {
    ouinonProps: ouinon187Data
};
const ouinon188Data = {
    yes: "Yes",
    place: "No"
};
const frame136142Data = {
    ouinonProps: ouinon188Data
};
const ouinon189Data = {
    yes: "Yes",
    place: "No"
};
const frame136143Data = {
    ouinonProps: ouinon189Data
};
const buttonSecondary171Data = {
    children: "Human machine interaction (HMI)",
    className: ""
};
const toggle171Data = {
    className: "toggle-6",
    buttonSecondaryProps: buttonSecondary171Data
};
const ouinon190Data = {
    yes: "Yes",
    place: "No"
};
const frame136144Data = {
    ouinonProps: ouinon190Data
};
const buttonSecondary172Data = {
    children: "4/4",
    className: "button-secondary-95"
};
const toggle172Data = {
    className: "toggle-140",
    buttonSecondaryProps: buttonSecondary172Data
};
const modernization4Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    inputType1: "text",
    inputPlaceholder1: "Connaissez vous votre bilan carbone?",
    inputType2: "text",
    inputPlaceholder2: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType3: "text",
    inputPlaceholder3: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    inputType4: "text",
    inputPlaceholder4: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    inputType5: "text",
    inputPlaceholder5: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    inputType6: "text",
    inputPlaceholder6: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    inputType7: "text",
    inputPlaceholder7: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    inputType8: "text",
    inputPlaceholder8: "Connaissez vous votre bilan carbone?",
    leadTimeCriteria: "Lead time criteria",
    navItems3Props: navItems358Data,
    toggle1Props: toggle170Data,
    frame1361Props: frame136137Data,
    frame1362Props: frame136138Data,
    frame1363Props: frame136139Data,
    frame1364Props: frame136140Data,
    frame1365Props: frame136141Data,
    frame1366Props: frame136142Data,
    frame1367Props: frame136143Data,
    toggle2Props: toggle171Data,
    frame1368Props: frame136144Data,
    toggle3Props: toggle172Data
};
const frame1172268Data = {
    children: "Existing Case"
};
const frame1162269Data = {
    children: "Reference Cases"
};
const frame1132289Data = {
    className: ""
};
const navItems359Data = {
    className: "nav-items-3-59",
    frame1172Props: frame1172268Data,
    frame1162Props: frame1162269Data,
    frame1132Props: frame1132289Data
};
const buttonSecondary173Data = {
    children: "External Providers 1",
    className: ""
};
const toggle173Data = {
    className: "toggle-30",
    buttonSecondaryProps: buttonSecondary173Data
};
const ouinon191Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-27-1"
};
const ouinon192Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-27-2"
};
const ouinon193Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-27-3"
};
const buttonSecondary174Data = {
    children: "External Providers 2",
    className: ""
};
const toggle174Data = {
    className: "toggle-30",
    buttonSecondaryProps: buttonSecondary174Data
};
const ouinon194Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-27-4"
};
const ouinon195Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-44"
};
const buttonSecondary175Data = {
    children: "Process Approach",
    className: ""
};
const toggle175Data = {
    className: "toggle-141",
    buttonSecondaryProps: buttonSecondary175Data
};
const ouinon196Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-27-5"
};
const ouinon197Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-27-6"
};
const ouinon198Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-27-7"
};
const ouinon199Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-27"
};
const frame1112Data = {
    toggle1Props: toggle173Data,
    ouinon1Props: ouinon191Data,
    ouinon2Props: ouinon192Data,
    ouinon3Props: ouinon193Data,
    toggle2Props: toggle174Data,
    ouinon4Props: ouinon194Data,
    ouinon5Props: ouinon195Data,
    toggle3Props: toggle175Data,
    ouinon6Props: ouinon196Data,
    ouinon7Props: ouinon197Data,
    ouinon8Props: ouinon198Data,
    ouinon9Props: ouinon199Data
};
const buttonSecondary176Data = {
    children: "8/8",
    className: "button-secondary-96"
};
const toggle176Data = {
    className: "toggle-142",
    buttonSecondaryProps: buttonSecondary176Data
};
const navItems258Data = {
    className: "nav-items-2-57"
};
const frame1172269Data = {
    children: "Existing Case"
};
const frame1162270Data = {
    children: "Reference Cases"
};
const frame1132290Data = {
    className: ""
};
const navItems360Data = {
    className: "nav-items-3-60",
    frame1172Props: frame1172269Data,
    frame1162Props: frame1162270Data,
    frame1132Props: frame1132290Data
};
const buttonSecondary177Data = {
    children: "Customer Requirements 1",
    className: ""
};
const toggle177Data = {
    className: "toggle-143",
    buttonSecondaryProps: buttonSecondary177Data
};
const ouinon200Data = {
    yes: "Yes",
    place: "No"
};
const frame136145Data = {
    ouinonProps: ouinon200Data
};
const ouinon201Data = {
    yes: "Yes",
    place: "No"
};
const frame136146Data = {
    ouinonProps: ouinon201Data
};
const ouinon202Data = {
    yes: "Yes",
    place: "No"
};
const frame136147Data = {
    ouinonProps: ouinon202Data
};
const buttonSecondary178Data = {
    children: "Customer Requirements 2",
    className: ""
};
const toggle178Data = {
    className: "toggle-144",
    buttonSecondaryProps: buttonSecondary178Data
};
const ouinon203Data = {
    yes: "Yes",
    place: "No"
};
const frame136148Data = {
    ouinonProps: ouinon203Data
};
const ouinon204Data = {
    yes: "Yes",
    place: "No"
};
const frame136149Data = {
    ouinonProps: ouinon204Data
};
const ouinon205Data = {
    yes: "Yes",
    place: "No"
};
const frame136150Data = {
    ouinonProps: ouinon205Data
};
const buttonSecondary179Data = {
    children: "Customer Requirements 3",
    className: ""
};
const toggle179Data = {
    className: "toggle-145",
    buttonSecondaryProps: buttonSecondary179Data
};
const ouinon206Data = {
    yes: "Yes",
    place: "No"
};
const frame136151Data = {
    ouinonProps: ouinon206Data
};
const ouinon207Data = {
    yes: "Yes",
    place: "No"
};
const frame136152Data = {
    className: "frame-153-8",
    ouinonProps: ouinon207Data
};
const frame13310Data = {
    frame136Props: frame136152Data
};
const frame1449Data = {
    frame133Props: frame13310Data
};
const ouinon208Data = {
    yes: "Yes",
    place: "No"
};
const frame136153Data = {
    ouinonProps: ouinon208Data
};
const buttonSecondary180Data = {
    children: "1/8",
    className: "button-secondary-97"
};
const toggle180Data = {
    className: "toggle-146",
    buttonSecondaryProps: buttonSecondary180Data
};
const clientConsommateur3Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
    inputType1: "text",
    inputPlaceholder1: "Connaissez vous votre bilan carbone?",
    inputType2: "text",
    inputPlaceholder2: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType3: "text",
    inputPlaceholder3: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    inputType4: "text",
    inputPlaceholder4: "Connaissez vous votre bilan carbone?",
    inputType5: "text",
    inputPlaceholder5: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType6: "text",
    inputPlaceholder6: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    inputType7: "text",
    inputPlaceholder7: "Connaissez vous votre bilan carbone?",
    inputType8: "text",
    inputPlaceholder8: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType9: "text",
    inputPlaceholder9: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe0\xa2timents?",
    goOnToTheNextStep: "Go on to the next step",
    navItems2Props: navItems258Data,
    navItems3Props: navItems360Data,
    toggle1Props: toggle177Data,
    frame1361Props: frame136145Data,
    frame1362Props: frame136146Data,
    frame1363Props: frame136147Data,
    toggle2Props: toggle178Data,
    frame1364Props: frame136148Data,
    frame1365Props: frame136149Data,
    frame1366Props: frame136150Data,
    toggle3Props: toggle179Data,
    frame1367Props: frame136151Data,
    frame144Props: frame1449Data,
    frame1368Props: frame136153Data,
    toggle4Props: toggle180Data
};
const frame1133225Data = {
    className: "frame-113-24"
};
const frame11778Data = {
    className: "frame-117-142"
};
const frame114264Data = {
    className: "frame-114-152"
};
const frame1132291Data = {
    className: "frame-113-99"
};
const referencesData = {
    resultsPropositions: "Results & Propositions",
    label1: "Existing case",
    label2: "Reference case",
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    inputType1: "text",
    inputPlaceholder1: "      /25",
    tracbility: "Tracbility",
    place1: "Quality",
    vector371: "/img/vector-37@2x.png",
    vector372: "/img/vector-37-1@2x.png",
    vector38: "/img/vector-37-1@2x.png",
    product: "Product",
    validation: "Validation",
    iso9001Isf: "ISO 9001 (ISF)",
    vector373: "/img/vector-37-1@2x.png",
    processValidation: "Process Validation",
    line211: "/img/line-21@2x.png",
    cost: "Cost",
    inputType2: "text",
    inputPlaceholder2: "      /25",
    line212: "/img/line-21-1@2x.png",
    vector374: "/img/vector-37-3@2x.png",
    vector375: "/img/vector-37-4@2x.png",
    vector376: "/img/vector-37-5@2x.png",
    vector377: "/img/vector-37-6@2x.png",
    transportCost: "Transport cost",
    manufacturingCost: "Manufacturing cost",
    deliveryCost: "Delivery cost",
    exportCost: "Export cost",
    modernisation: "Modernisation",
    inputType3: "text",
    inputPlaceholder3: "      /25",
    line213: "/img/line-21-1@2x.png",
    vector378: "/img/vector-37-3@2x.png",
    vector379: "/img/vector-37-4@2x.png",
    vector3710: "/img/vector-37-5@2x.png",
    vector3711: "/img/vector-37-6@2x.png",
    supplyChain40: "Supply chain 4.0",
    informationSystem: "Information system",
    ergonomics: "Ergonomics",
    newTechnologiesAiRoboticsEtc: "New technologies (AI, robotics, etc.)",
    leadTime: "Lead Time",
    inputType4: "text",
    inputPlaceholder4: "      /25",
    line214: "/img/line-21-3@2x.png",
    vector3712: "/img/vector-37-11@2x.png",
    vector3713: "/img/vector-37-12@2x.png",
    vector3714: "/img/vector-37-13@2x.png",
    manufacturingTime: "Manufacturing time",
    deliveryTime: "Delivery time",
    storageTime: "Storage time",
    place2: "Back",
    propositions: "Propositions",
    frame11332Props: frame1133225Data,
    frame117Props: frame11778Data,
    frame1142Props: frame114264Data,
    frame11322Props: frame1132291Data
};
const frame1172270Data = {
    children: "Existing Case"
};
const frame1162271Data = {
    children: "Reference Cases"
};
const frame1132292Data = {
    className: ""
};
const navItems361Data = {
    className: "nav-items-3-61",
    frame1172Props: frame1172270Data,
    frame1162Props: frame1162271Data,
    frame1132Props: frame1132292Data
};
const frame1133226Data = {
    className: "frame-113-25"
};
const curPerformanceData = {
    navItems3Props: navItems361Data,
    frame11332Props: frame1133226Data
};
const headerMenuDefault62Data = {
    children: "New Case"
};
const headerMenuDefault56Data = {
    children: "Existing Case",
    className: "menu-item-default-27-1"
};
const headerMenuDefault57Data = {
    children: "Reference Case",
    className: "menu-item-default-27-2"
};
const headerMenuDefault15Data = {
    children: "Logout"
};
const headerMenuDefault58Data = {
    children: "Modeling",
    className: "menu-item-default-34"
};
const headerMenuDefault59Data = {
    children: "Analysis",
    className: "menu-item-default-27"
};
const headerMenuDefault63Data = {
    children: "Results & Objectives",
    className: "menu-item-default-38"
};
const buttonSecondary181Data = {
    children: "1/2",
    className: "button-secondary-50"
};
const toggle181Data = {
    className: "toggle-147",
    buttonSecondaryProps: buttonSecondary181Data
};
const buttonSecondary182Data = {
    children: "Next",
    className: "button-secondary-50"
};
const toggle182Data = {
    className: "toggle-148",
    buttonSecondaryProps: buttonSecondary182Data
};
const leadTimeData = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
    label1: "Home",
    label2: "Design",
    headerMenuDefault61Props: headerMenuDefault62Data,
    headerMenuDefault51Props: headerMenuDefault56Data,
    headerMenuDefault52Props: headerMenuDefault57Data,
    headerMenuDefaultProps: headerMenuDefault15Data,
    headerMenuDefault53Props: headerMenuDefault58Data,
    headerMenuDefault54Props: headerMenuDefault59Data,
    headerMenuDefault62Props: headerMenuDefault63Data,
    toggle1Props: toggle181Data,
    toggle2Props: toggle182Data
};
const headerMenuDefault64Data = {
    children: "New Case"
};
const headerMenuDefault510Data = {
    children: "Existing Case",
    className: "menu-item-default-28-1"
};
const headerMenuDefault511Data = {
    children: "Reference Case",
    className: "menu-item-default-28-2"
};
const headerMenuDefault16Data = {
    children: "Logout"
};
const headerMenuDefault512Data = {
    children: "Modeling",
    className: "menu-item-default-35"
};
const headerMenuDefault513Data = {
    children: "Analysis",
    className: "menu-item-default-28"
};
const headerMenuDefault65Data = {
    children: "Results & Objectives",
    className: "menu-item-default-40"
};
const buttonSecondary183Data = {
    children: "1/2",
    className: "button-secondary-98"
};
const toggle183Data = {
    className: "toggle-149",
    buttonSecondaryProps: buttonSecondary183Data
};
const buttonSecondary184Data = {
    children: "Next",
    className: "button-secondary-99"
};
const toggle184Data = {
    className: "toggle-150",
    buttonSecondaryProps: buttonSecondary184Data
};
const costData = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
    label1: "Home",
    label2: "Design",
    headerMenuDefault61Props: headerMenuDefault64Data,
    headerMenuDefault51Props: headerMenuDefault510Data,
    headerMenuDefault52Props: headerMenuDefault511Data,
    headerMenuDefaultProps: headerMenuDefault16Data,
    headerMenuDefault53Props: headerMenuDefault512Data,
    headerMenuDefault54Props: headerMenuDefault513Data,
    headerMenuDefault62Props: headerMenuDefault65Data,
    toggle1Props: toggle183Data,
    toggle2Props: toggle184Data
};
const avatarsData = {
    ellipse83: "/img/ellipse-83-3@2x.png",
    ellipse81: "/img/ellipse-81@2x.png"
};
const buttonSecondary185Data = {
    children: "2/2",
    className: "button-secondary-51"
};
const toggle185Data = {
    className: "toggle-151",
    buttonSecondaryProps: buttonSecondary185Data
};
const headerMenuDefault66Data = {
    children: "New Case"
};
const headerMenuDefault514Data = {
    children: "Existing Case",
    className: "menu-item-default-29-1"
};
const headerMenuDefault515Data = {
    children: "Reference Case",
    className: "menu-item-default-29-2"
};
const headerMenuDefault17Data = {
    children: "Logout"
};
const headerMenuDefault516Data = {
    children: "Modeling",
    className: "menu-item-default-36"
};
const headerMenuDefault517Data = {
    children: "Analysis",
    className: "menu-item-default-29"
};
const headerMenuDefault67Data = {
    children: "Results & Objectives",
    className: "menu-item-default-42"
};
const buttonSecondary186Data = {
    children: "Information System",
    className: "button-secondary-51"
};
const toggle186Data = {
    className: "toggle-27",
    buttonSecondaryProps: buttonSecondary186Data
};
const group102205Data = {
    line24: "/img/line-24-39.png"
};
const group102206Data = {
    line24: "/img/line-24-40.png"
};
const group102207Data = {
    line24: "/img/line-24-75.png"
};
const group102208Data = {
    line24: "/img/line-24-42.png"
};
const group102209Data = {
    line24: "/img/line-24-43.png"
};
const buttonSecondary187Data = {
    children: "New Technologies (IA, Robotics)",
    className: "button-secondary-51"
};
const toggle187Data = {
    className: "toggle-27",
    buttonSecondaryProps: buttonSecondary187Data
};
const group102210Data = {
    line24: "/img/line-24-10.png",
    className: "group-22-2"
};
const group102211Data = {
    line24: "/img/line-24-16.png",
    className: "group-22-3"
};
const group102212Data = {
    line24: "/img/line-24-17.png",
    className: "group-22-4"
};
const group102213Data = {
    line24: "/img/line-24-81.png",
    className: "group-22-5"
};
const group102214Data = {
    line24: "/img/line-24-48.png",
    className: "group-22"
};
const buttonSecondary188Data = {
    children: "Lead time criteria",
    className: "button-secondary-100"
};
const toggle188Data = {
    className: "toggle-152",
    buttonSecondaryProps: buttonSecondary188Data
};
const modernizationData = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    admin: "ADMIN",
    pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
    label1: "Home",
    label2: "Design",
    inputType1: "text",
    inputPlaceholder1: "Utilisez vous une ERP?",
    inputType2: "text",
    inputPlaceholder2: "Utilisez vous  cette ERP pour passer les commandes?",
    inputType3: "text",
    inputPlaceholder3: "Quel canal utilisez vous pour communiquer dans l\xe2\u20AC\u2122entreprise? ",
    inputType4: "text",
    inputPlaceholder4: "*******************************************",
    inputType5: "text",
    inputPlaceholder5: "*******************************************",
    inputType6: "text",
    inputPlaceholder6: "Utilisez vous des robots?",
    inputType7: "text",
    inputPlaceholder7: "utilisez des RPA?",
    inputType8: "text",
    inputPlaceholder8: "Mod\xe9lisez vous vos processus 3D pour une meilleure visibilit\xe9?",
    inputType9: "text",
    inputPlaceholder9: "***********************************************",
    inputType10: "text",
    inputPlaceholder10: "*************************************",
    avatarsProps: avatarsData,
    toggle1Props: toggle185Data,
    headerMenuDefault61Props: headerMenuDefault66Data,
    headerMenuDefault51Props: headerMenuDefault514Data,
    headerMenuDefault52Props: headerMenuDefault515Data,
    headerMenuDefaultProps: headerMenuDefault17Data,
    headerMenuDefault53Props: headerMenuDefault516Data,
    headerMenuDefault54Props: headerMenuDefault517Data,
    headerMenuDefault62Props: headerMenuDefault67Data,
    toggle2Props: toggle186Data,
    group1021Props: group102205Data,
    group1022Props: group102206Data,
    group1023Props: group102207Data,
    group1024Props: group102208Data,
    group1025Props: group102209Data,
    toggle3Props: toggle187Data,
    group1026Props: group102210Data,
    group1027Props: group102211Data,
    group1028Props: group102212Data,
    group1029Props: group102213Data,
    group10210Props: group102214Data,
    toggle4Props: toggle188Data
};

},{"react/jsx-runtime":"gonF6","./App.css":"eruV5","react":"bmhQu","./components/Navigation/HeaderProvider.css":"3EoGe","./components/LoadingScreen":"6oQWn","./components/CaseDetails":"hM129","./components/Conception":"6EIB0","./context/AuthContext":"5fsmo","./context/EnterpriseContext":"jRUQi","./components/Navigation":"aaKMz","react-router-dom":[["BrowserRouter","b9X5n"],["Redirect","ditZI"],["Route","ditZI"],["Switch","ditZI"]],"./components/Admin/Admin":"hsdzg","./components/Home":"8DAun","./components/FunctionalView1":"3zeVr","./components/Acquisition":"h8aqW","./components/PhysicalModel1":"gSchW","./components/ExistingCase":"7Tp7Q","./components/DecisionalModel1":"9qNYl","./components/ProcessView1":"bc8s9","./components/InformationalModel1":"gzd05","./components/Environmental1":"aCokB","./components/Environmental1_":"8ypM1","./components/MeasuringForm":"aKgLj","./components/MeasuringForm_":"kpXB8","./components/LeanVSM1":"6l9fD","./components/X5S1":"5Jnfl","./components/Analysis":"42miY","./components/AnalysisBeta":"fkaAq","./components/VisualManagement1":"2wBag","./components/Objectives":"4hPSM","./components/SMED2":"66Jb8","./components/SMED3":"6GSi3","./components/VisualManagement2":"gd4Xt","./components/Kaizen3":"bJ6py","./components/VisualManagement3":"2vPVJ","./components/Inscription":"ff5Hz","./components/ClientConsommateur2":"3OEIe","./components/ClientConsommateur2_":"eVcW8","./components/Social1":"838rz","./components/Social1_":"9IXzw","./components/Modernization1":"9pvUI","./components/Modernization1_":"kRVwW","./components/ClientConsommateur1":"erE99","./components/ClientConsommateur1_":"fhIrc","./components/LeadTime1":"jxVZX","./components/LeadTime1_":"eH8qo","./components/Cost1":"iIT4b","./components/Cost1_":"fIT9W","./components/Quality1":"gkdwu","./components/Quality1_":"dcV9a","./components/Environmental2":"2OiAJ","./components/Environmental2_":"4pDoS","./components/Environmental3":"aRvrz","./components/Environmental3_":"dhZsW","./components/Social2":"g4OlW","./components/Social2_":"ahoL9","./components/Modernization2":"kq01z","./components/Modernization2_":"ik8P8","./components/Cost2":"eoJTs","./components/Cost2_":"cEV7C","./components/LeadTime2":"5LCGo","./components/LeadTime2_":"2qrDc","./components/Quality6":"ebrQE","./components/Quality6_":"2MHU2","./components/InformationalModel3":"6o8sp","./components/InformationalModel2":"4oRpq","./components/ProcessView2":"c3pxU","./components/Quality2":"hWTAB","./components/Quality2_":"jEnvw","./components/ProcessView3":"jM7Tw","./components/DecisionalView2":"dToUM","./components/PhysicalModel2":"5osad","./components/DecisionalView3":"g4ujd","./components/Quality5":"5iZrh","./components/Quality5_":"82KlE","./components/PhysicalModel3":"3Qna7","./components/FunctionnalView2":"a8FJe","./components/FunctionnalView3":"dr1m3","./components/FunctionnalView4":"fNcXj","./components/LoadingPage":"674ZU","./components/Kaizen1":"hBp5q","./components/ExistingSystems":"fyYAC","./components/Kanban1":"aG5dh","./components/LeanVSM":"32u0v","./components/SMED1":"jhMfZ","./components/X5S":"dwI3H","./components/Kaizen12":"l6wcX","./components/Quality4":"iCqMu","./components/Quality4_":"jJhwl","./components/Kaizen":"e4lAZ","./components/SMED":"c78yP","./components/VisualManagement":"j6uQm","./components/Kanban":"9JHHR","./components/Kaizen2":"c7S5d","./components/Kanban3":"kRGAr","./components/MesureDePerformancesFutures":"773Hj","./components/X5s2":"i9LiC","./components/Kanban2":"4HgvK","./components/X5s3":"1XWTT","./components/LeanVSM3":"6CMW1","./components/LeanVSM2":"2YMz8","./components/Kaizen11":"k8iyX","./components/Quality3":"km669","./components/Quality3_":"ck4So","./components/LeanVSM4":"iYCdE","./components/MesureDePerformancesFutures1":"6sgVa","./components/ExistingSystems2":"3hjTg","./components/Environmental5":"leUWw","./components/Environmental5_":"98DT2","./components/Social3":"12PLV","./components/Social3_":"3xLfp","./components/Environmental4":"lXQfO","./components/Environmental4_":"gyJLd","./components/Modernization3":"lUkob","./components/Modernization3_":"f85ZL","./components/Social4":"haOmR","./components/Social4_":"faPBh","./components/Social6":"jqrFa","./components/Social6_":"4BDEv","./components/Social5":"iwvBq","./components/Social5_":"7gq3N","./components/Modernization4":"3hH0I","./components/Modernization4_":"hsKo8","./components/ClientConsommateur3":"7STBG","./components/ClientConsommateur3_":"5JrYP","./components/References":"9DdZc","./components/CurPerformance":"276Lb","./components/Curperformance_":"dfVjL","./components/LeadTime":"cCIyL","./components/Cost":"2lryw","./components/Modernization":"6Mffp","./components/Login/Login":"g8BbC","./components/Analysis1/Analysis":"1fPt4","./components/Implementation":"lTpbR","./components/PdfUploader":"dLwaS","./components/CompanyCases":"dIHLo","./components/SavingUploadPage":"9rv3R","./components/CompareCases":"dVawJ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eruV5":[function() {},{}],"3EoGe":[function() {},{}],"6oQWn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const LoadingScreen = ({ onLoadingComplete })=>{
    const [progress, setProgress] = (0, _react.useState)(0);
    const [loadingPhrase, setLoadingPhrase] = (0, _react.useState)('');
    // Phrases inspirantes pour l'écran de chargement
    const loadingPhrases = [
        "Processing your data...",
        "Getting things ready...",
        "Almost there...",
        "Preparing your experience...",
        "Building your interface..."
    ];
    (0, _react.useEffect)(()=>{
        // Sélectionner aléatoirement une phrase
        const randomPhrase = loadingPhrases[Math.floor(Math.random() * loadingPhrases.length)];
        setLoadingPhrase(randomPhrase);
        // Simuler la progression du chargement - intervalle augmenté à 300ms pour réduire la charge
        const interval = setInterval(()=>{
            setProgress((prevProgress)=>{
                if (prevProgress >= 100) {
                    clearInterval(interval);
                    // Appeler la fonction de callback lorsque le chargement est terminé
                    setTimeout(()=>{
                        if (onLoadingComplete) onLoadingComplete();
                    }, 500); // Petit délai pour montrer la barre complète
                    return 100;
                }
                // Augmenter la progression avec des incréments plus grands et plus stables
                const increment = 3 + Math.floor(Math.random() * 5); // 3-7% d'incrément au lieu de 1-10%
                return Math.min(prevProgress + increment, 100);
            });
        }, 300); // Intervalle augmenté de 200ms à 300ms
        return ()=>clearInterval(interval);
    }, [
        onLoadingComplete
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "loading-screen",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "loading-container",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "loading-icon",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                        width: "60",
                        height: "60",
                        viewBox: "0 0 60 60",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                cx: "30",
                                cy: "30",
                                r: "25",
                                fill: "none",
                                stroke: "#E8D8B8",
                                strokeWidth: "3"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                cx: "30",
                                cy: "30",
                                r: "25",
                                fill: "none",
                                stroke: "url(#gradient)",
                                strokeWidth: "5",
                                strokeDasharray: "157",
                                strokeDashoffset: 157 * (1 - progress / 100),
                                strokeLinecap: "round",
                                className: "progress-circle"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                    id: "gradient",
                                    x1: "0%",
                                    y1: "0%",
                                    x2: "100%",
                                    y2: "0%",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                            offset: "0%",
                                            stopColor: "#1E4549"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                            offset: "100%",
                                            stopColor: "#3A6D71"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                    children: loadingPhrase
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "progress-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "progress-bar-container",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "progress-background"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "progress-bar",
                                    style: {
                                        width: `${progress}%`
                                    },
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "progress-shine"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "progress-dots",
                                    children: [
                                        20,
                                        40,
                                        60,
                                        80
                                    ].map((point)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: `progress-dot ${progress >= point ? 'active' : ''}`,
                                            style: {
                                                left: `${point}%`
                                            }
                                        }, point))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "progress-text",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "progress-value",
                                    children: progress
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "percent",
                                    children: "%"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "progress-complete",
                                    children: progress === 100 ? ' Complete!' : ''
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("style", {
                    children: `
          .loading-icon {
            margin-bottom: 20px;
            animation: floatAnimation 3s ease-in-out infinite;
          }
          
          @keyframes floatAnimation {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(-8px); }
          }
          
          .progress-circle {
            transition: stroke-dashoffset 0.3s ease;
            transform-origin: center;
            transform: rotate(-90deg);
          }

          .progress-container {
            position: relative;
            width: 100%;
            margin-top: 10px;
          }
          
          .progress-bar-container {
            width: 100%;
            height: 12px;
            background: transparent;
            border-radius: 10px;
            position: relative;
            overflow: visible;
            margin: 15px 0;
          }
          
          .progress-background {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(240, 230, 210, 0.8);
            border-radius: 10px;
            overflow: hidden;
          }
          
          .progress-bar {
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 0%;
            border-radius: 10px;
            background: linear-gradient(90deg, #1E4549, #3A6D71);
            transition: width 0.3s ease-out;
            z-index: 2;
            overflow: hidden;
          }
          
          .progress-shine {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: linear-gradient(
              90deg,
              transparent,
              rgba(255, 255, 255, 0.3),
              transparent
            );
            animation: shine 2.5s infinite;
            z-index: 3;
          }
          
          @keyframes shine {
            0% { transform: translateX(-200%); }
            100% { transform: translateX(200%); }
          }
          
          .progress-dots {
            position: absolute;
            width: 100%;
            height: 100%;
            z-index: 4;
          }
          
          .progress-dot {
            position: absolute;
            width: 4px;
            height: 4px;
            top: 50%;
            transform: translate(-50%, -50%);
            background: rgba(240, 230, 210, 0.5);
            border-radius: 50%;
            transition: all 0.3s ease;
          }
          
          .progress-dot.active {
            background: #F0E6D2;
            width: 6px;
            height: 6px;
          }
          
          .progress-text {
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 18px;
            color: #1E4549;
            margin-top: 5px;
          }
          
          .percent {
            font-size: 14px;
            margin-left: 2px;
          }
          
          .progress-complete {
            margin-left: 5px;
            color: #4A7073;
            font-weight: 600;
          }
          
          .loading-screen {
            position: fixed;
            top: 0;
            left: 0;
            width: 100vw;
            height: 100vh;
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: #FFFFFF;
            z-index: 1000;
            will-change: transform; /* Optimisation pour le rendu */
          }
          
          .loading-container {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 40px;
            border-radius: 12px;
            background-color: #FFFFFF;
            box-shadow: 0 5px 15px rgba(30, 69, 73, 0.1);
            max-width: 400px;
            width: 80%;
          }
          
          .loading-container h2 {
            color: #1E4549;
            font-size: 20px;
            margin: 0 0 20px 0;
            text-align: center;
            font-weight: 500;
          }
        `
                })
            ]
        })
    });
};
exports.default = LoadingScreen;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"91HVb":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"hM129":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _stylesCss = require("./styles.css");
const API_URL = "/api";
const CaseDetails = ()=>{
    const [pdfFiles, setPdfFiles] = (0, _react.useState)([]);
    const { id } = (0, _reactRouterDom.useParams)();
    const [caseData, setCaseData] = (0, _react.useState)(null);
    const [caseResponses, setCaseResponses] = (0, _react.useState)(null);
    const [loading, setLoading] = (0, _react.useState)(true);
    const [error, setError] = (0, _react.useState)(null);
    const [showShareModal, setShowShareModal] = (0, _react.useState)(false);
    const [targetUsername, setTargetUsername] = (0, _react.useState)("");
    const [sharingStatus, setSharingStatus] = (0, _react.useState)(null);
    const [sharedWith, setSharedWith] = (0, _react.useState)([]);
    const [activeCategory, setActiveCategory] = (0, _react.useState)(null);
    // --------------------------
    // Utils
    // --------------------------
    const formatDate = (timestamp)=>{
        if (!timestamp) return "Unknown date";
        const date = new Date(timestamp);
        return date.toLocaleDateString("en-US", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit"
        });
    };
    const groupResponsesByCategory = (responses)=>{
        if (!responses || !responses.results) return {};
        const grouped = {};
        const normalizeMap = {
            environmental: "environmental",
            social: "social",
            modernization: "modernization",
            leadtime: "leadTime",
            "lead-time": "leadTime",
            lead_time: "leadTime",
            quality: "quality",
            cost: "cost",
            clientconsumer: "clientConsumer",
            "client-consumer": "clientConsumer",
            client_consumer: "clientConsumer"
        };
        responses.results.forEach((r)=>{
            if (!r) return;
            let cat = (r.category || "").toLowerCase();
            cat = normalizeMap[cat] || cat;
            const section = r.section || `${cat}-1`;
            if (!grouped[cat]) grouped[cat] = {};
            if (!grouped[cat][section]) grouped[cat][section] = [];
            grouped[cat][section].push(r);
        });
        return grouped;
    };
    // --------------------------
    // Fetch helpers
    // --------------------------
    const fetchAllResponseSources = async (enterpriseId)=>{
        const token = localStorage.getItem("token") || "";
        let resultsResponses = [];
        let evaluationResponses = [];
        // --- 1. RESULTS ------------------------
        const sources = [
            `/api/enterprise-results/${enterpriseId}`,
            `/api/all-results/${enterpriseId}`,
            `/api/direct-results/${enterpriseId}`
        ];
        for (const url of sources)try {
            const response = await fetch(`${API_URL}${url}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            if (response.ok) {
                const data = await response.json().catch(()=>[]);
                if (Array.isArray(data)) resultsResponses.push(...data);
            }
        } catch  {}
        // --- 1b. Lean results also count as RESULTS ---
        try {
            const storedCaseId = localStorage.getItem("caseId") || "";
            if (storedCaseId) {
                const response = await fetch(`${API_URL}/api/lean/results/${storedCaseId}`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                if (response.ok) {
                    const data = await response.json().catch(()=>null);
                    if (data?.results) for(const category in data.results){
                        const arr = data.results[category] || [];
                        resultsResponses.push(...arr.map((item)=>({
                                ...item,
                                category: category.toLowerCase(),
                                caseId: storedCaseId
                            })));
                    }
                }
            }
        } catch  {}
        // --- 2. EVALUATION (une seule fois) ------------------------
        try {
            const response = await fetch(`${API_URL}/api/evaluation-results/${enterpriseId}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            if (response.ok) {
                const data = await response.json().catch(()=>[]);
                if (Array.isArray(data)) evaluationResponses.push(...data);
            }
        } catch  {}
        // ---- REMOVE DUPLICATES IN RESULTS ----
        resultsResponses = resultsResponses.filter((item, index, self)=>index === self.findIndex((r)=>r.question === item.question && r.category === item.category && r.section === item.section));
        // ---- REMOVE DUPLICATES IN EVALUATION ----
        evaluationResponses = evaluationResponses.filter((item, index, self)=>index === self.findIndex((r)=>r.question === item.question && r.category === item.category && r.section === item.section));
        return {
            resultsResponses,
            evaluationResponses
        };
    };
    // --------------------------
    // 1) Fetch Case Details
    // --------------------------
    (0, _react.useEffect)(()=>{
        const fetchCaseDetails = async (caseIdParam)=>{
            const caseId = caseIdParam || id;
            setLoading(true);
            setError(null);
            try {
                const token = localStorage.getItem("token");
                if (!token) {
                    setError("Error 401: Not authenticated (no token found)");
                    setLoading(false);
                    return;
                }
                const response = await fetch(`${API_URL}/api/case-details/${caseId}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json"
                    }
                });
                if (!response.ok) {
                    const txt = await response.text().catch(()=>"");
                    setError(`Error ${response.status}: ${txt || response.statusText}`);
                    setLoading(false);
                    return;
                }
                const data = await response.json();
                if (data?.found && data?.case) {
                    const storedId = data.case._id; // âœ… dâ€™abord on définit
                    setCaseData(data.case);
                    setSharedWith(data.case.shared_with || []);
                    // âœ… active case (compat + standard)
                    localStorage.setItem("caseId", storedId);
                    localStorage.setItem("active_case_id", storedId);
                    // âœ… enterprise actif
                    if (data.case.enterpriseId) {
                        localStorage.setItem("active_enterprise_id", data.case.enterpriseId);
                        const responses = await fetchAllResponseSources(data.case.enterpriseId);
                        setCaseResponses({
                            found: true,
                            results: responses.resultsResponses,
                            evaluation: responses.evaluationResponses
                        });
                    } else setCaseResponses({
                        found: false,
                        results: [],
                        evaluation: []
                    });
                } else setError("Case not found or invalid data");
            } catch (err) {
                console.error("Error fetching case details:", err);
                setError(`Error: ${err?.message || String(err)}`);
            } finally{
                setLoading(false);
            }
        };
        if (!id) {
            const storedCaseId = localStorage.getItem("caseId");
            if (storedCaseId) fetchCaseDetails(storedCaseId);
            else setError("No case selected. Please open one from the list.");
        } else {
            // compat
            localStorage.setItem("caseId", id);
            localStorage.setItem("active_case_id", id);
            fetchCaseDetails(id);
        }
    }, [
        id
    ]);
    // --------------------------
    // 2) Default active tab
    // --------------------------
    (0, _react.useEffect)(()=>{
        if (caseResponses?.results?.length > 0) {
            const groupedData = groupResponsesByCategory(caseResponses);
            const categories = Object.keys(groupedData);
            if (categories.length > 0 && !activeCategory) setActiveCategory(categories[0]);
        }
    }, [
        caseResponses,
        activeCategory
    ]);
    // --------------------------
    // 3) Fetch PDFs linked to case
    // --------------------------
    (0, _react.useEffect)(()=>{
        const fetchCasePdfs = async ()=>{
            try {
                if (!id) return;
                const response = await fetch(`${API_URL}/api/case/${id}/pdfs`, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("token") || ""}`
                    }
                });
                const data = await response.json().catch(()=>null);
                if (data?.success && Array.isArray(data.pdfs)) setPdfFiles(data.pdfs);
                else setPdfFiles([]);
            } catch (err) {
                console.error("Error fetching PDFs:", err);
                setPdfFiles([]);
            }
        };
        fetchCasePdfs();
    }, [
        id
    ]);
    // --------------------------
    // Share / Unshare
    // --------------------------
    const handleShareCase = async (e)=>{
        e.preventDefault();
        if (!targetUsername.trim()) {
            setSharingStatus({
                success: false,
                message: "Please enter a valid username"
            });
            return;
        }
        try {
            const token = localStorage.getItem("token");
            const response = await fetch(`${API_URL}/api/share-case/${id}`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    username: targetUsername
                })
            });
            const data = await response.json().catch(()=>null);
            if (response.ok && data?.success) {
                setSharingStatus({
                    success: true,
                    message: data.message
                });
                setSharedWith([
                    ...sharedWith,
                    targetUsername
                ]);
                setTargetUsername("");
            } else setSharingStatus({
                success: false,
                message: data?.message || "Error sharing case"
            });
        } catch (err) {
            setSharingStatus({
                success: false,
                message: `Error sharing case: ${err?.message || err}`
            });
        }
    };
    const handleUnshareCase = async (username)=>{
        try {
            const token = localStorage.getItem("token");
            const response = await fetch(`${API_URL}/api/share-case/${id}/${username}`, {
                method: "DELETE",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            });
            const data = await response.json().catch(()=>null);
            if (response.ok && data?.success) {
                setSharedWith(sharedWith.filter((u)=>u !== username));
                setSharingStatus({
                    success: true,
                    message: data.message
                });
            } else setSharingStatus({
                success: false,
                message: data?.message || "Error removing share"
            });
        } catch (err) {
            setSharingStatus({
                success: false,
                message: `Error removing share: ${err?.message || err}`
            });
        }
    };
    // --------------------------
    // Export CSV
    // --------------------------
    const exportResponsesToCSV = ()=>{
        if (!caseResponses?.results?.length) {
            alert("No data to export");
            return;
        }
        let csvContent = "Category,Question,Answer,Date\n";
        caseResponses.results.forEach((r)=>{
            const category = r.category || "Uncategorized";
            const question = (r.question || "").replace(/,/g, ";");
            const answer = (r.answer || "").replace(/,/g, ";");
            const date = r.timestamp ? new Date(r.timestamp).toLocaleString() : "";
            csvContent += `"${category}","${question}","${answer}","${date}"\n`;
        });
        const blob = new Blob([
            csvContent
        ], {
            type: "text/csv;charset=utf-8;"
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `case_${id}_responses.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    // --------------------------
    // UI states
    // --------------------------
    if (loading) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "case-details-container loading",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "loader"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: "Loading case details..."
            })
        ]
    });
    if (error) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "case-details-container error",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                children: "Error"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: error
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                to: "/existing-case",
                className: "back-button",
                children: "Back to case list"
            })
        ]
    });
    if (!caseData) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "case-details-container error",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                children: "Case not found"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: "The details for this case are not available."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                to: "/existing-case",
                className: "back-button",
                children: "Back to case list"
            })
        ]
    });
    const groupedResponses = caseResponses ? groupResponsesByCategory(caseResponses) : {};
    const groupedEvaluation = caseResponses?.evaluation?.length > 0 ? groupResponsesByCategory({
        results: caseResponses.evaluation
    }) : {};
    const ShareModal = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "share-modal-overlay",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "share-modal",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "share-modal-header",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                children: "Share this Case"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: "close-button",
                                onClick: ()=>setShowShareModal(false),
                                children: "\xe0\u2014"
                            })
                        ]
                    }),
                    sharingStatus && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: `sharing-status ${sharingStatus.success ? "success" : "error"}`,
                        children: sharingStatus.message
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                        onSubmit: handleShareCase,
                        className: "share-form",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "form-group",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                        htmlFor: "target-username",
                                        children: "Username:"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                        type: "text",
                                        id: "target-username",
                                        value: targetUsername,
                                        onChange: (e)=>setTargetUsername(e.target.value),
                                        placeholder: "Enter username"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                type: "submit",
                                className: "share-button",
                                children: "Share"
                            })
                        ]
                    }),
                    sharedWith?.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "shared-with-list",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                children: "Shared with:"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
                                children: sharedWith.map((username, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                        className: "shared-user",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: username
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                className: "unshare-button",
                                                onClick: ()=>handleUnshareCase(username),
                                                children: "Remove"
                                            })
                                        ]
                                    }, index))
                            })
                        ]
                    })
                ]
            })
        });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "case-details-container",
        children: [
            showShareModal && /*#__PURE__*/ (0, _jsxRuntime.jsx)(ShareModal, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "case-details-header",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                        children: "Case Details"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "header-buttons",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: "share-button",
                                onClick: ()=>setShowShareModal(true),
                                children: "Share"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                to: "/existing-case",
                                className: "back-button",
                                children: "Back to case list"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "case-details-card",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                        children: caseData.company_name || "Unnamed Company"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "case-info-section",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                children: "General Information"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "info-grid",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "info-item",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                children: "Creation date:"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: formatDate(caseData.timestamp || caseData.date_created)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "info-item",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                children: "Activity sector:"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: caseData.activity_sector || "Not specified"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "info-item",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                children: "Company size:"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                children: [
                                                    caseData.company_size || "Not specified",
                                                    " employees"
                                                ]
                                            })
                                        ]
                                    }),
                                    caseData.enterpriseId && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "info-item",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                children: "Enterprise ID:"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: caseData.enterpriseId
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "case-info-section",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                children: "PDF Files Linked to This Case"
                            }),
                            pdfFiles.length > 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
                                style: {
                                    listStyle: "none",
                                    paddingLeft: 0
                                },
                                children: pdfFiles.map((pdf, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                        style: {
                                            marginBottom: "10px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                                href: `${API_URL}/api/pdf/${pdf._id}`,
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                style: {
                                                    color: "#0066cc",
                                                    textDecoration: "underline"
                                                },
                                                children: pdf.filename
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                style: {
                                                    marginLeft: "10px",
                                                    color: "#666",
                                                    fontSize: "0.9em"
                                                },
                                                children: pdf.uploaded_at ? new Date(pdf.uploaded_at).toLocaleString() : "Unknown date"
                                            })
                                        ]
                                    }, index))
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                style: {
                                    color: "#777"
                                },
                                children: "No PDF files imported for this case yet."
                            })
                        ]
                    }),
                    caseResponses?.found && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "case-responses-section",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "responses-header",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        children: "Acquisition Details"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        className: "export-button",
                                        onClick: exportResponsesToCSV,
                                        title: "Export responses as CSV",
                                        children: "Export CSV"
                                    })
                                ]
                            }),
                            Object.keys(groupedResponses).length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "no-responses",
                                children: "No responses available for this case"
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "categories-container",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "categories-tabs",
                                        children: [
                                            "environmental",
                                            "social",
                                            "modernization",
                                            "leadTime",
                                            "cost",
                                            "quality",
                                            "clientConsumer"
                                        ].map((category)=>{
                                            const hasResponses = groupedResponses[category] && Object.keys(groupedResponses[category]).length > 0;
                                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: `category-tab ${activeCategory === category ? "active" : ""} ${!hasResponses ? "disabled" : ""}`,
                                                onClick: ()=>hasResponses && setActiveCategory(category),
                                                children: [
                                                    category,
                                                    !hasResponses && " (empty)"
                                                ]
                                            }, category);
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "category-content",
                                        children: activeCategory && groupedResponses[activeCategory] && Object.entries(groupedResponses[activeCategory]).map(([section, responses])=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "section-container",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h5", {
                                                        className: "section-title",
                                                        children: section
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "responses-list",
                                                        children: responses.map((response, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "response-item",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "response-question",
                                                                        children: response.question
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: `response-answer ${response.answer === "Yes" ? "positive" : response.answer === "No" ? "negative" : "neutral"}`,
                                                                        children: response.answer
                                                                    })
                                                                ]
                                                            }, index))
                                                    })
                                                ]
                                            }, section))
                                    })
                                ]
                            })
                        ]
                    }),
                    caseResponses?.evaluation?.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "case-responses-section",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "responses-header",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                    children: "Evaluation Details"
                                })
                            }),
                            Object.keys(groupedEvaluation).length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "no-responses",
                                children: "No evaluation data available"
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "categories-container",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "categories-tabs",
                                        children: [
                                            "environmental",
                                            "social",
                                            "modernization",
                                            "leadTime",
                                            "cost",
                                            "quality",
                                            "clientConsumer"
                                        ].map((category)=>{
                                            const hasResponses = groupedEvaluation[category] && Object.keys(groupedEvaluation[category]).length > 0;
                                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: `category-tab ${activeCategory === category ? "active" : ""} ${!hasResponses ? "disabled" : ""}`,
                                                onClick: ()=>hasResponses && setActiveCategory(category),
                                                children: [
                                                    category,
                                                    !hasResponses && " (empty)"
                                                ]
                                            }, category);
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "category-content",
                                        children: activeCategory && groupedEvaluation[activeCategory] && Object.entries(groupedEvaluation[activeCategory]).map(([section, responses])=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "section-container",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h5", {
                                                        className: "section-title",
                                                        children: section
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "responses-list",
                                                        children: responses.map((response, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "response-item",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "response-question",
                                                                        children: response.question
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "response-answer neutral",
                                                                        children: response.answer
                                                                    })
                                                                ]
                                                            }, index))
                                                    })
                                                ]
                                            }, section))
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "case-actions",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: `/analysisbeta?caseId=${id}`,
                            className: "action-button",
                            children: "View full analysis"
                        })
                    })
                ]
            })
        ]
    });
};
exports.default = CaseDetails;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["Link","b9X5n"],["useParams","ditZI"]],"./styles.css":"c3jTc","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"b9X5n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MemoryRouter", ()=>(0, _reactRouter.MemoryRouter));
parcelHelpers.export(exports, "Prompt", ()=>(0, _reactRouter.Prompt));
parcelHelpers.export(exports, "Redirect", ()=>(0, _reactRouter.Redirect));
parcelHelpers.export(exports, "Route", ()=>(0, _reactRouter.Route));
parcelHelpers.export(exports, "Router", ()=>(0, _reactRouter.Router));
parcelHelpers.export(exports, "StaticRouter", ()=>(0, _reactRouter.StaticRouter));
parcelHelpers.export(exports, "Switch", ()=>(0, _reactRouter.Switch));
parcelHelpers.export(exports, "generatePath", ()=>(0, _reactRouter.generatePath));
parcelHelpers.export(exports, "matchPath", ()=>(0, _reactRouter.matchPath));
parcelHelpers.export(exports, "useHistory", ()=>(0, _reactRouter.useHistory));
parcelHelpers.export(exports, "useLocation", ()=>(0, _reactRouter.useLocation));
parcelHelpers.export(exports, "useParams", ()=>(0, _reactRouter.useParams));
parcelHelpers.export(exports, "useRouteMatch", ()=>(0, _reactRouter.useRouteMatch));
parcelHelpers.export(exports, "withRouter", ()=>(0, _reactRouter.withRouter));
parcelHelpers.export(exports, "BrowserRouter", ()=>BrowserRouter);
parcelHelpers.export(exports, "HashRouter", ()=>HashRouter);
parcelHelpers.export(exports, "Link", ()=>Link);
parcelHelpers.export(exports, "NavLink", ()=>NavLink);
var _reactRouter = require("react-router");
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _history = require("history");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _tinyWarning = require("tiny-warning");
var _tinyWarningDefault = parcelHelpers.interopDefault(_tinyWarning);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
/**
 * The public API for a <Router> that uses HTML5 history.
 */ var BrowserRouter = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, _history.createBrowserHistory)(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactRouter.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, _reactDefault.default).Component);
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var HashRouter = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, _history.createHashHistory)(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactRouter.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, _reactDefault.default).Component);
var resolveToLocation = function resolveToLocation(to, currentLocation) {
    return typeof to === "function" ? to(currentLocation) : to;
};
var normalizeToLocation = function normalizeToLocation(to, currentLocation) {
    return typeof to === "string" ? (0, _history.createLocation)(to, null, null, currentLocation) : to;
};
var forwardRefShim = function forwardRefShim(C) {
    return C;
};
var forwardRef = (0, _reactDefault.default).forwardRef;
if (typeof forwardRef === "undefined") forwardRef = forwardRefShim;
function isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var LinkAnchor = forwardRef(function(_ref, forwardedRef) {
    var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, [
        "innerRef",
        "navigate",
        "onClick"
    ]);
    var target = rest.target;
    var props = (0, _extendsDefault.default)({}, rest, {
        onClick: function onClick(event) {
            try {
                if (_onClick) _onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && (!target || target === "_self") && // let browser handle "target=_blank" etc.
            !isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                navigate();
            }
        }
    }); // React 15 compat
    if (forwardRefShim !== forwardRef) props.ref = forwardedRef || innerRef;
    else props.ref = innerRef;
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */ return /*#__PURE__*/ (0, _reactDefault.default).createElement("a", props);
});
/**
 * The public API for rendering a history-aware <a>.
 */ var Link = forwardRef(function(_ref2, forwardedRef) {
    var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = (0, _objectWithoutPropertiesLooseDefault.default)(_ref2, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactRouter.__RouterContext).Consumer, null, function(context) {
        !context && (0, _tinyInvariantDefault.default)(false);
        var history = context.history;
        var location = normalizeToLocation(resolveToLocation(to, context.location), context.location);
        var href = location ? history.createHref(location) : "";
        var props = (0, _extendsDefault.default)({}, rest, {
            href: href,
            navigate: function navigate() {
                var location = resolveToLocation(to, context.location);
                var isDuplicateNavigation = (0, _history.createPath)(context.location) === (0, _history.createPath)(normalizeToLocation(location));
                var method = replace || isDuplicateNavigation ? history.replace : history.push;
                method(location);
            }
        }); // React 15 compat
        if (forwardRefShim !== forwardRef) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(component, props);
    });
});
var toType, refType;
var forwardRefShim$1 = function forwardRefShim(C) {
    return C;
};
var forwardRef$1 = (0, _reactDefault.default).forwardRef;
if (typeof forwardRef$1 === "undefined") forwardRef$1 = forwardRefShim$1;
function joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var NavLink = forwardRef$1(function(_ref, forwardedRef) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, sensitive = _ref.sensitive, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactRouter.__RouterContext).Consumer, null, function(context) {
        !context && (0, _tinyInvariantDefault.default)(false);
        var currentLocation = locationProp || context.location;
        var toLocation = normalizeToLocation(resolveToLocation(to, currentLocation), currentLocation);
        var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
        var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
        var match = escapedPath ? (0, _reactRouter.matchPath)(currentLocation.pathname, {
            path: escapedPath,
            exact: exact,
            sensitive: sensitive,
            strict: strict
        }) : null;
        var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
        var className = typeof classNameProp === "function" ? classNameProp(isActive) : classNameProp;
        var style = typeof styleProp === "function" ? styleProp(isActive) : styleProp;
        if (isActive) {
            className = joinClassnames(className, activeClassName);
            style = (0, _extendsDefault.default)({}, style, activeStyle);
        }
        var props = (0, _extendsDefault.default)({
            "aria-current": isActive && ariaCurrent || null,
            className: className,
            style: style,
            to: toLocation
        }, rest); // React 15 compat
        if (forwardRefShim$1 !== forwardRef$1) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Link, props);
    });
});
var ariaCurrentType;

},{"react-router":"ditZI","@babel/runtime/helpers/esm/inheritsLoose":"hJ1FM","react":"bmhQu","history":"8rWTz","prop-types":"gLXGb","tiny-warning":"hu9ef","@babel/runtime/helpers/esm/extends":"85Hd3","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"ds1mq","tiny-invariant":"7cMkC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ditZI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MemoryRouter", ()=>MemoryRouter);
parcelHelpers.export(exports, "Prompt", ()=>Prompt);
parcelHelpers.export(exports, "Redirect", ()=>Redirect);
parcelHelpers.export(exports, "Route", ()=>Route);
parcelHelpers.export(exports, "Router", ()=>Router);
parcelHelpers.export(exports, "StaticRouter", ()=>StaticRouter);
parcelHelpers.export(exports, "Switch", ()=>Switch);
parcelHelpers.export(exports, "__HistoryContext", ()=>historyContext);
parcelHelpers.export(exports, "__RouterContext", ()=>context);
parcelHelpers.export(exports, "generatePath", ()=>generatePath);
parcelHelpers.export(exports, "matchPath", ()=>matchPath);
parcelHelpers.export(exports, "useHistory", ()=>useHistory);
parcelHelpers.export(exports, "useLocation", ()=>useLocation);
parcelHelpers.export(exports, "useParams", ()=>useParams);
parcelHelpers.export(exports, "useRouteMatch", ()=>useRouteMatch);
parcelHelpers.export(exports, "withRouter", ()=>withRouter);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _history = require("history");
var _tinyWarning = require("tiny-warning");
var _tinyWarningDefault = parcelHelpers.interopDefault(_tinyWarning);
var _miniCreateReactContext = require("mini-create-react-context");
var _miniCreateReactContextDefault = parcelHelpers.interopDefault(_miniCreateReactContext);
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _pathToRegexp = require("path-to-regexp");
var _pathToRegexpDefault = parcelHelpers.interopDefault(_pathToRegexp);
var _reactIs = require("react-is");
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _hoistNonReactStatics = require("hoist-non-react-statics");
var _hoistNonReactStaticsDefault = parcelHelpers.interopDefault(_hoistNonReactStatics);
// TODO: Replace with React.createContext once we can assume React 16+
var createNamedContext = function createNamedContext(name) {
    var context = (0, _miniCreateReactContextDefault.default)();
    context.displayName = name;
    return context;
};
var historyContext = /*#__PURE__*/ createNamedContext("Router-History");
var context = /*#__PURE__*/ createNamedContext("Router");
/**
 * The public API for putting history on context.
 */ var Router = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Router, _React$Component);
    Router.computeRootMatch = function computeRootMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    function Router(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            location: props.history.location
        }; // This is a bit of a hack. We have to start listening for location
        // changes here in the constructor in case there are any <Redirect>s
        // on the initial render. If there are, they will replace/push when
        // they mount and since cDM fires in children before parents, we may
        // get a new location before the <Router> is mounted.
        _this._isMounted = false;
        _this._pendingLocation = null;
        if (!props.staticContext) _this.unlisten = props.history.listen(function(location) {
            if (_this._isMounted) _this.setState({
                location: location
            });
            else _this._pendingLocation = location;
        });
        return _this;
    }
    var _proto = Router.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this._isMounted = true;
        if (this._pendingLocation) this.setState({
            location: this._pendingLocation
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.unlisten) {
            this.unlisten();
            this._isMounted = false;
            this._pendingLocation = null;
        }
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Provider, {
            value: {
                history: this.props.history,
                location: this.state.location,
                match: Router.computeRootMatch(this.state.location.pathname),
                staticContext: this.props.staticContext
            }
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(historyContext.Provider, {
            children: this.props.children || null,
            value: this.props.history
        }));
    };
    return Router;
}((0, _reactDefault.default).Component);
/**
 * The public API for a <Router> that stores location in memory.
 */ var MemoryRouter = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(MemoryRouter, _React$Component);
    function MemoryRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, _history.createMemoryHistory)(_this.props);
        return _this;
    }
    var _proto = MemoryRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Router, {
            history: this.history,
            children: this.props.children
        });
    };
    return MemoryRouter;
}((0, _reactDefault.default).Component);
var Lifecycle = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Lifecycle, _React$Component);
    function Lifecycle() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Lifecycle.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.props.onMount) this.props.onMount.call(this, this);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.props.onUnmount) this.props.onUnmount.call(this, this);
    };
    _proto.render = function render() {
        return null;
    };
    return Lifecycle;
}((0, _reactDefault.default).Component);
/**
 * The public API for prompting the user before navigating away from a screen.
 */ function Prompt(_ref) {
    var message = _ref.message, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Consumer, null, function(context) {
        !context && (0, _tinyInvariantDefault.default)(false);
        if (!when || context.staticContext) return null;
        var method = context.history.block;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Lifecycle, {
            onMount: function onMount(self) {
                self.release = method(message);
            },
            onUpdate: function onUpdate(self, prevProps) {
                if (prevProps.message !== message) {
                    self.release();
                    self.release = method(message);
                }
            },
            onUnmount: function onUnmount(self) {
                self.release();
            },
            message: message
        });
    });
}
var messageType;
var cache = {};
var cacheLimit = 10000;
var cacheCount = 0;
function compilePath(path) {
    if (cache[path]) return cache[path];
    var generator = (0, _pathToRegexpDefault.default).compile(path);
    if (cacheCount < cacheLimit) {
        cache[path] = generator;
        cacheCount++;
    }
    return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */ function generatePath(path, params) {
    if (path === void 0) path = "/";
    if (params === void 0) params = {};
    return path === "/" ? path : compilePath(path)(params, {
        pretty: true
    });
}
/**
 * The public API for navigating programmatically with a component.
 */ function Redirect(_ref) {
    var computedMatch = _ref.computedMatch, to = _ref.to, _ref$push = _ref.push, push = _ref$push === void 0 ? false : _ref$push;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Consumer, null, function(context) {
        !context && (0, _tinyInvariantDefault.default)(false);
        var history = context.history, staticContext = context.staticContext;
        var method = push ? history.push : history.replace;
        var location = (0, _history.createLocation)(computedMatch ? typeof to === "string" ? generatePath(to, computedMatch.params) : (0, _extendsDefault.default)({}, to, {
            pathname: generatePath(to.pathname, computedMatch.params)
        }) : to); // When rendering in a static context,
        // set the new location immediately.
        if (staticContext) {
            method(location);
            return null;
        }
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Lifecycle, {
            onMount: function onMount() {
                method(location);
            },
            onUpdate: function onUpdate(self, prevProps) {
                var prevLocation = (0, _history.createLocation)(prevProps.to);
                if (!(0, _history.locationsAreEqual)(prevLocation, (0, _extendsDefault.default)({}, location, {
                    key: prevLocation.key
                }))) method(location);
            },
            to: to
        });
    });
}
var cache$1 = {};
var cacheLimit$1 = 10000;
var cacheCount$1 = 0;
function compilePath$1(path, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var pathCache = cache$1[cacheKey] || (cache$1[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    var keys = [];
    var regexp = (0, _pathToRegexpDefault.default)(path, keys, options);
    var result = {
        regexp: regexp,
        keys: keys
    };
    if (cacheCount$1 < cacheLimit$1) {
        pathCache[path] = result;
        cacheCount$1++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */ function matchPath(pathname, options) {
    if (options === void 0) options = {};
    if (typeof options === "string" || Array.isArray(options)) options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === void 0 ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === void 0 ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
    var paths = [].concat(path);
    return paths.reduce(function(matched, path) {
        if (!path && path !== "") return null;
        if (matched) return matched;
        var _compilePath = compilePath$1(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        }), regexp = _compilePath.regexp, keys = _compilePath.keys;
        var match = regexp.exec(pathname);
        if (!match) return null;
        var url = match[0], values = match.slice(1);
        var isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === "/" && url === "" ? "/" : url,
            // the matched portion of the URL
            isExact: isExact,
            // whether or not we matched exactly
            params: keys.reduce(function(memo, key, index) {
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
function isEmptyChildren(children) {
    return (0, _reactDefault.default).Children.count(children) === 0;
}
function evalChildrenDev(children, props, path) {
    var value = children(props);
    return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */ var Route = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Route, _React$Component);
    function Route() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Route.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Consumer, null, function(context$1) {
            !context$1 && (0, _tinyInvariantDefault.default)(false);
            var location = _this.props.location || context$1.location;
            var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
             : _this.props.path ? matchPath(location.pathname, _this.props) : context$1.match;
            var props = (0, _extendsDefault.default)({}, context$1, {
                location: location,
                match: match
            });
            var _this$props = _this.props, children = _this$props.children, component = _this$props.component, render = _this$props.render; // Preact uses an empty array as children by
            // default, so use null if that's the case.
            if (Array.isArray(children) && isEmptyChildren(children)) children = null;
            return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Provider, {
                value: props
            }, props.match ? children ? typeof children === "function" ? children(props) : children : component ? /*#__PURE__*/ (0, _reactDefault.default).createElement(component, props) : render ? render(props) : null : typeof children === "function" ? children(props) : null);
        });
    };
    return Route;
}((0, _reactDefault.default).Component);
function addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function addBasename(basename, location) {
    if (!basename) return location;
    return (0, _extendsDefault.default)({}, location, {
        pathname: addLeadingSlash(basename) + location.pathname
    });
}
function stripBasename(basename, location) {
    if (!basename) return location;
    var base = addLeadingSlash(basename);
    if (location.pathname.indexOf(base) !== 0) return location;
    return (0, _extendsDefault.default)({}, location, {
        pathname: location.pathname.substr(base.length)
    });
}
function createURL(location) {
    return typeof location === "string" ? location : (0, _history.createPath)(location);
}
function staticHandler(methodName) {
    return function() {
        (0, _tinyInvariantDefault.default)(false);
    };
}
function noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */ var StaticRouter = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(StaticRouter, _React$Component);
    function StaticRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handlePush = function(location) {
            return _this.navigateTo(location, "PUSH");
        };
        _this.handleReplace = function(location) {
            return _this.navigateTo(location, "REPLACE");
        };
        _this.handleListen = function() {
            return noop;
        };
        _this.handleBlock = function() {
            return noop;
        };
        return _this;
    }
    var _proto = StaticRouter.prototype;
    _proto.navigateTo = function navigateTo(location, action) {
        var _this$props = this.props, _this$props$basename = _this$props.basename, basename = _this$props$basename === void 0 ? "" : _this$props$basename, _this$props$context = _this$props.context, context = _this$props$context === void 0 ? {} : _this$props$context;
        context.action = action;
        context.location = addBasename(basename, (0, _history.createLocation)(location));
        context.url = createURL(context.location);
    };
    _proto.render = function render() {
        var _this$props2 = this.props, _this$props2$basename = _this$props2.basename, basename = _this$props2$basename === void 0 ? "" : _this$props2$basename, _this$props2$context = _this$props2.context, context = _this$props2$context === void 0 ? {} : _this$props2$context, _this$props2$location = _this$props2.location, location = _this$props2$location === void 0 ? "/" : _this$props2$location, rest = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props2, [
            "basename",
            "context",
            "location"
        ]);
        var history = {
            createHref: function createHref(path) {
                return addLeadingSlash(basename + createURL(path));
            },
            action: "POP",
            location: stripBasename(basename, (0, _history.createLocation)(location)),
            push: this.handlePush,
            replace: this.handleReplace,
            go: staticHandler("go"),
            goBack: staticHandler("goBack"),
            goForward: staticHandler("goForward"),
            listen: this.handleListen,
            block: this.handleBlock
        };
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Router, (0, _extendsDefault.default)({}, rest, {
            history: history,
            staticContext: context
        }));
    };
    return StaticRouter;
}((0, _reactDefault.default).Component);
/**
 * The public API for rendering the first <Route> that matches.
 */ var Switch = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Switch, _React$Component);
    function Switch() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Switch.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Consumer, null, function(context) {
            !context && (0, _tinyInvariantDefault.default)(false);
            var location = _this.props.location || context.location;
            var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
            // here because toArray adds keys to all child elements and we do not want
            // to trigger an unmount/remount for two <Route>s that render the same
            // component at different URLs.
            (0, _reactDefault.default).Children.forEach(_this.props.children, function(child) {
                if (match == null && /*#__PURE__*/ (0, _reactDefault.default).isValidElement(child)) {
                    element = child;
                    var path = child.props.path || child.props.from;
                    match = path ? matchPath(location.pathname, (0, _extendsDefault.default)({}, child.props, {
                        path: path
                    })) : context.match;
                }
            });
            return match ? /*#__PURE__*/ (0, _reactDefault.default).cloneElement(element, {
                location: location,
                computedMatch: match
            }) : null;
        });
    };
    return Switch;
}((0, _reactDefault.default).Component);
/**
 * A public higher-order component to access the imperative API
 */ function withRouter(Component) {
    var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
    var C = function C(props) {
        var wrappedComponentRef = props.wrappedComponentRef, remainingProps = (0, _objectWithoutPropertiesLooseDefault.default)(props, [
            "wrappedComponentRef"
        ]);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Consumer, null, function(context) {
            !context && (0, _tinyInvariantDefault.default)(false);
            return /*#__PURE__*/ (0, _reactDefault.default).createElement(Component, (0, _extendsDefault.default)({}, remainingProps, context, {
                ref: wrappedComponentRef
            }));
        });
    };
    C.displayName = displayName;
    C.WrappedComponent = Component;
    return (0, _hoistNonReactStaticsDefault.default)(C, Component);
}
var useContext = (0, _reactDefault.default).useContext;
function useHistory() {
    return useContext(historyContext);
}
function useLocation() {
    return useContext(context).location;
}
function useParams() {
    var match = useContext(context).match;
    return match ? match.params : {};
}
function useRouteMatch(path) {
    var location = useLocation();
    var match = useContext(context).match;
    return path ? matchPath(location.pathname, path) : match;
}
var global, key, buildNames, initialBuildName, secondaryBuildName;

},{"@babel/runtime/helpers/esm/inheritsLoose":"hJ1FM","react":"bmhQu","prop-types":"gLXGb","history":"8rWTz","tiny-warning":"hu9ef","mini-create-react-context":"3vYKP","tiny-invariant":"7cMkC","@babel/runtime/helpers/esm/extends":"85Hd3","path-to-regexp":"h4pLf","react-is":"m2UGx","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"ds1mq","hoist-non-react-statics":"ldTzE","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hJ1FM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_inheritsLoose);
var _setPrototypeOfJs = require("./setPrototypeOf.js");
var _setPrototypeOfJsDefault = parcelHelpers.interopDefault(_setPrototypeOfJs);
function _inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, _setPrototypeOfJsDefault.default)(t, o);
}

},{"./setPrototypeOf.js":"9xLGZ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9xLGZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_setPrototypeOf);
function _setPrototypeOf(t, e) {
    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, _setPrototypeOf(t, e);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gLXGb":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var ReactIs, throwOnDirectAccess;
// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = require("e98516c5bab4526")();

},{"e98516c5bab4526":"cW0bY"}],"cW0bY":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var ReactPropTypesSecret = require("bf7f43a19ae1b960");
function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === ReactPropTypesSecret) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

},{"bf7f43a19ae1b960":"6JNoQ"}],"6JNoQ":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = ReactPropTypesSecret;

},{}],"8rWTz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createBrowserHistory", ()=>createBrowserHistory);
parcelHelpers.export(exports, "createHashHistory", ()=>createHashHistory);
parcelHelpers.export(exports, "createMemoryHistory", ()=>createMemoryHistory);
parcelHelpers.export(exports, "createLocation", ()=>createLocation);
parcelHelpers.export(exports, "locationsAreEqual", ()=>locationsAreEqual);
parcelHelpers.export(exports, "parsePath", ()=>parsePath);
parcelHelpers.export(exports, "createPath", ()=>createPath);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _resolvePathname = require("resolve-pathname");
var _resolvePathnameDefault = parcelHelpers.interopDefault(_resolvePathname);
var _valueEqual = require("value-equal");
var _valueEqualDefault = parcelHelpers.interopDefault(_valueEqual);
var _tinyWarning = require("tiny-warning");
var _tinyWarningDefault = parcelHelpers.interopDefault(_tinyWarning);
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
function addLeadingSlash(path) {
    return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
    return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function stripBasename(path, prefix) {
    return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
    var pathname = path || '/';
    var search = '';
    var hash = '';
    var hashIndex = pathname.indexOf('#');
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf('?');
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === '?' ? '' : search,
        hash: hash === '#' ? '' : hash
    };
}
function createPath(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || '/';
    if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
    if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
    return path;
}
function createLocation(path, state, key, currentLocation) {
    var location;
    if (typeof path === 'string') {
        // Two-arg form: push(path, state)
        location = parsePath(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, _extendsDefault.default)({}, path);
        if (location.pathname === undefined) location.pathname = '';
        if (location.search) {
            if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
        } else location.search = '';
        if (location.hash) {
            if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
        } else location.hash = '';
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== '/') location.pathname = (0, _resolvePathnameDefault.default)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = '/';
    return location;
}
function locationsAreEqual(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqualDefault.default)(a.state, b.state);
}
function createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
            if (typeof result === 'string') {
                if (typeof getUserConfirmation === 'function') getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
    return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}
var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';
function getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function createBrowserHistory(props) {
    if (props === void 0) props = {};
    !canUseDOM && (0, _tinyInvariantDefault.default)(false);
    var globalHistory = window.history;
    var canUseHistory = supportsHistory();
    var needsHashChangeListener = !supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = stripBasename(path, basename);
        return createLocation(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = createTransitionManager();
    function setState(nextState) {
        (0, _extendsDefault.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if (isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation(getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation(getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + createPath(location);
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = createLocation(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = createLocation(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener(PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener(PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === '!' ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: stripLeadingSlash,
        decodePath: addLeadingSlash
    },
    slash: {
        encodePath: addLeadingSlash,
        decodePath: addLeadingSlash
    }
};
function stripHash(url) {
    var hashIndex = url.indexOf('#');
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf('#');
    return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}
function pushHashPath(path) {
    window.location.hash = path;
}
function replaceHashPath(path) {
    window.location.replace(stripHash(window.location.href) + '#' + path);
}
function createHashHistory(props) {
    if (props === void 0) props = {};
    !canUseDOM && (0, _tinyInvariantDefault.default)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
    var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
    var _HashPathCoders$hashT = HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath(getHashPath());
        if (basename) path = stripBasename(path, basename);
        return createLocation(path);
    }
    var transitionManager = createTransitionManager();
    function setState(nextState) {
        (0, _extendsDefault.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf(createPath(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        createPath(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector('base');
        var href = '';
        if (baseTag && baseTag.getAttribute('href')) href = stripHash(window.location.href);
        return href + '#' + encodePath(basename + createPath(location));
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = createLocation(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = createPath(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf(createPath(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = createLocation(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = createPath(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf(createPath(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener(HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function createMemoryHistory(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        '/'
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = createTransitionManager();
    function setState(nextState) {
        (0, _extendsDefault.default)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = createPath;
    function push(path, state) {
        var action = 'PUSH';
        var location = createLocation(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = createLocation(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
        var action = 'POP';
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: 'POP',
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}

},{"@babel/runtime/helpers/esm/extends":"85Hd3","resolve-pathname":"4Rnhm","value-equal":"a3ABJ","tiny-warning":"hu9ef","tiny-invariant":"7cMkC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"85Hd3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_extends);
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4Rnhm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function isAbsolute(pathname) {
    return pathname.charAt(0) === '/';
}
// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function resolvePathname(to, from) {
    if (from === undefined) from = '';
    var toParts = to && to.split('/') || [];
    var fromParts = from && from.split('/') || [];
    var isToAbs = to && isAbsolute(to);
    var isFromAbs = from && isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return '/';
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === '.' || last === '..' || last === '';
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === '.') spliceOne(fromParts, i);
        else if (part === '..') {
            spliceOne(fromParts, i);
            up++;
        } else if (up) {
            spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift('..');
    if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');
    var result = fromParts.join('/');
    if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
    return result;
}
exports.default = resolvePathname;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"a3ABJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return valueEqual(item, b[index]);
    });
    if (typeof a === 'object' || typeof b === 'object') {
        var aValue = valueOf(a);
        var bValue = valueOf(b);
        if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return valueEqual(a[key], b[key]);
        });
    }
    return false;
}
exports.default = valueEqual;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hu9ef":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var isProduction = true;
function warning(condition, message) {
    if (!isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== 'undefined') console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
exports.default = warning;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7cMkC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>invariant);
var isProduction = true;
var prefix = 'Invariant failed';
function invariant(condition, message) {
    if (condition) return;
    if (isProduction) throw new Error(prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat(prefix, ": ").concat(provided) : prefix;
    throw new Error(value);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3vYKP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _tinyWarning = require("tiny-warning");
var _tinyWarningDefault = parcelHelpers.interopDefault(_tinyWarning);
var global = arguments[3];
var MAX_SIGNED_31_BIT_INT = 1073741823;
var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : {};
function getUniqueId() {
    var key = '__global_unique_id__';
    return commonjsGlobal[key] = (commonjsGlobal[key] || 0) + 1;
}
function objectIs(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue, changedBits) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value, changedBits);
            });
        }
    };
}
function onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
function createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = '__create-react-context-' + getUniqueId() + '__';
    var Provider = /*#__PURE__*/ function(_Component) {
        (0, _inheritsLooseDefault.default)(Provider, _Component);
        function Provider() {
            var _this;
            _this = _Component.apply(this, arguments) || this;
            _this.emitter = createEventEmitter(_this.props.value);
            return _this;
        }
        var _proto = Provider.prototype;
        _proto.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                var oldValue = this.props.value;
                var newValue = nextProps.value;
                var changedBits;
                if (objectIs(oldValue, newValue)) changedBits = 0;
                else {
                    changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
                    changedBits |= 0;
                    if (changedBits !== 0) this.emitter.set(nextProps.value, changedBits);
                }
            }
        };
        _proto.render = function render() {
            return this.props.children;
        };
        return Provider;
    }((0, _react.Component));
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = (0, _propTypesDefault.default).object.isRequired, _Provider$childContex);
    var Consumer = /*#__PURE__*/ function(_Component2) {
        (0, _inheritsLooseDefault.default)(Consumer, _Component2);
        function Consumer() {
            var _this2;
            _this2 = _Component2.apply(this, arguments) || this;
            _this2.state = {
                value: _this2.getValue()
            };
            _this2.onUpdate = function(newValue, changedBits) {
                var observedBits = _this2.observedBits | 0;
                if ((observedBits & changedBits) !== 0) _this2.setState({
                    value: _this2.getValue()
                });
            };
            return _this2;
        }
        var _proto2 = Consumer.prototype;
        _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var observedBits = nextProps.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
        };
        _proto2.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
            var observedBits = this.props.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
        };
        _proto2.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        _proto2.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        _proto2.render = function render() {
            return onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }((0, _react.Component));
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = (0, _propTypesDefault.default).object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
var index = (0, _reactDefault.default).createContext || createReactContext;
exports.default = index;

},{"react":"bmhQu","@babel/runtime/helpers/esm/inheritsLoose":"hJ1FM","prop-types":"gLXGb","tiny-warning":"hu9ef","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"h4pLf":[function(require,module,exports,__globalThis) {
var isarray = require("828472a1e168de2b");
/**
 * Expose `pathToRegexp`.
 */ module.exports = pathToRegexp;
module.exports.parse = parse;
module.exports.compile = compile;
module.exports.tokensToFunction = tokensToFunction;
module.exports.tokensToRegExp = tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    '(\\\\.)',
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = '';
    var defaultDelimiter = options && options.delimiter || '/';
    var res;
    while((res = PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = '';
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === '+' || modifier === '*';
        var optional = modifier === '?' || modifier === '*';
        var delimiter = prefix || defaultDelimiter;
        var pattern = capture || group;
        var prevText = prefix || (typeof tokens[tokens.length - 1] === 'string' ? tokens[tokens.length - 1] : '');
        tokens.push({
            name: name || key++,
            prefix: prefix || '',
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? escapeGroup(pattern) : asterisk ? '.*' : restrictBacktrack(delimiter, prevText)
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
function restrictBacktrack(delimiter, prevText) {
    if (!prevText || prevText.indexOf(delimiter) > -1) return '[^' + escapeString(delimiter) + ']+?';
    return escapeString(prevText) + '|(?:(?!' + escapeString(prevText) + ')[^' + escapeString(delimiter) + '])+?';
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function compile(str, options) {
    return tokensToFunction(parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === 'object') matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options));
    return function(obj, opts) {
        var path = '';
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === 'string') {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if (isarray(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`');
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`');
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1');
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, '\\$1');
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function flags(options) {
    return options && options.sensitive ? '' : 'i';
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push(pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));
    return attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function stringToRegexp(path, keys, options) {
    return tokensToRegExp(parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function tokensToRegExp(tokens, keys, options) {
    if (!isarray(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = '';
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === 'string') route += escapeString(token);
        else {
            var prefix = escapeString(token.prefix);
            var capture = '(?:' + token.pattern + ')';
            keys.push(token);
            if (token.repeat) capture += '(?:' + prefix + capture + ')*';
            if (token.optional) {
                if (!token.partial) capture = '(?:' + prefix + '(' + capture + '))?';
                else capture = prefix + '(' + capture + ')?';
            } else capture = prefix + '(' + capture + ')';
            route += capture;
        }
    }
    var delimiter = escapeString(options.delimiter || '/');
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
    if (end) route += '$';
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
    return attachKeys(new RegExp('^' + route, flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function pathToRegexp(path, keys, options) {
    if (!isarray(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return regexpToRegexp(path, /** @type {!Array} */ keys);
    if (isarray(path)) return arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}

},{"828472a1e168de2b":"jE8lV"}],"jE8lV":[function(require,module,exports,__globalThis) {
module.exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == '[object Array]';
};

},{}],"m2UGx":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("f93b3bf7385544f5");

},{"f93b3bf7385544f5":"aEfEd"}],"aEfEd":[function(require,module,exports,__globalThis) {
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var b = "function" === typeof Symbol && Symbol.for, c = b ? Symbol.for("react.element") : 60103, d = b ? Symbol.for("react.portal") : 60106, e = b ? Symbol.for("react.fragment") : 60107, f = b ? Symbol.for("react.strict_mode") : 60108, g = b ? Symbol.for("react.profiler") : 60114, h = b ? Symbol.for("react.provider") : 60109, k = b ? Symbol.for("react.context") : 60110, l = b ? Symbol.for("react.async_mode") : 60111, m = b ? Symbol.for("react.concurrent_mode") : 60111, n = b ? Symbol.for("react.forward_ref") : 60112, p = b ? Symbol.for("react.suspense") : 60113, q = b ? Symbol.for("react.suspense_list") : 60120, r = b ? Symbol.for("react.memo") : 60115, t = b ? Symbol.for("react.lazy") : 60116, v = b ? Symbol.for("react.block") : 60121, w = b ? Symbol.for("react.fundamental") : 60117, x = b ? Symbol.for("react.responder") : 60118, y = b ? Symbol.for("react.scope") : 60119;
function z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case c:
                switch(a = a.type, a){
                    case l:
                    case m:
                    case e:
                    case g:
                    case f:
                    case p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case k:
                            case n:
                            case t:
                            case r:
                            case h:
                                return a;
                            default:
                                return u;
                        }
                }
            case d:
                return u;
        }
    }
}
function A(a) {
    return z(a) === m;
}
exports.AsyncMode = l;
exports.ConcurrentMode = m;
exports.ContextConsumer = k;
exports.ContextProvider = h;
exports.Element = c;
exports.ForwardRef = n;
exports.Fragment = e;
exports.Lazy = t;
exports.Memo = r;
exports.Portal = d;
exports.Profiler = g;
exports.StrictMode = f;
exports.Suspense = p;
exports.isAsyncMode = function(a) {
    return A(a) || z(a) === l;
};
exports.isConcurrentMode = A;
exports.isContextConsumer = function(a) {
    return z(a) === k;
};
exports.isContextProvider = function(a) {
    return z(a) === h;
};
exports.isElement = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === c;
};
exports.isForwardRef = function(a) {
    return z(a) === n;
};
exports.isFragment = function(a) {
    return z(a) === e;
};
exports.isLazy = function(a) {
    return z(a) === t;
};
exports.isMemo = function(a) {
    return z(a) === r;
};
exports.isPortal = function(a) {
    return z(a) === d;
};
exports.isProfiler = function(a) {
    return z(a) === g;
};
exports.isStrictMode = function(a) {
    return z(a) === f;
};
exports.isSuspense = function(a) {
    return z(a) === p;
};
exports.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
};
exports.typeOf = z;

},{}],"ds1mq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_objectWithoutPropertiesLoose);
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ldTzE":[function(require,module,exports,__globalThis) {
'use strict';
var reactIs = require("c03b486d83967636");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
function getStatics(component) {
    // React v16.11 and below
    if (reactIs.isMemo(component)) return MEMO_STATICS;
     // React v16.12 and above
    return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}
var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = getOwnPropertyNames(sourceComponent);
        if (getOwnPropertySymbols) keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        var targetStatics = getStatics(targetComponent);
        var sourceStatics = getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = hoistNonReactStatics;

},{"c03b486d83967636":"m2UGx"}],"c3jTc":[function() {},{}],"6EIB0":[function(require,module,exports,__globalThis) {
// src/components/Conception/index.jsx
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Conception);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _modeler = require("bpmn-js/lib/Modeler");
var _modelerDefault = parcelHelpers.interopDefault(_modeler);
var _html2Canvas = require("html2canvas");
var _html2CanvasDefault = parcelHelpers.interopDefault(_html2Canvas);
var _jspdf = require("jspdf");
var _graieditorLite = require("../GRAIEditorLite");
var _graieditorLiteDefault = parcelHelpers.interopDefault(_graieditorLite);
// PDF uploader dependencies
var _pdfUploaderCss = require("../PdfUploader/PdfUploader.css");
var _diagramJsCss = require("bpmn-js/dist/assets/diagram-js.css");
var _bpmnCss = require("bpmn-js/dist/assets/bpmn-font/css/bpmn.css");
var _conceptionCss = require("./Conception.css");
const MemoGRAIEditorLite = /*#__PURE__*/ (0, _react.memo)((0, _graieditorLiteDefault.default));
function Conception() {
    const [activeEditor, setActiveEditor] = (0, _react.useState)("activity");
    // SAVING: PDF uploader states
    const [pdfFile, setPdfFile] = (0, _react.useState)(null);
    const [pdfUrl, setPdfUrl] = (0, _react.useState)(null);
    const [error, setError] = (0, _react.useState)("");
    const [uploading, setUploading] = (0, _react.useState)(false);
    const [message, setMessage] = (0, _react.useState)("");
    const [caseId, setCaseId] = (0, _react.useState)(null);
    const [caseData, setCaseData] = (0, _react.useState)(null);
    const fileInputRef = (0, _react.useRef)(null);
    // Refs
    const iframeRef = (0, _react.useRef)(null);
    const bpmnContainerRef = (0, _react.useRef)(null);
    const modelerRef = (0, _react.useRef)(null);
    const excalidrawRef = (0, _react.useRef)(null);
    const savingIframeRef = (0, _react.useRef)(null);
    /* -----------------------------------------
      VISUAL PARADIGM
  ------------------------------------------*/ const handleImport = ()=>alert("Import inside Visual Paradigm.");
    const handleExport = ()=>alert("Export inside Visual Paradigm.");
    const handleReset = ()=>iframeRef.current && (iframeRef.current.src = iframeRef.current.src);
    /* -----------------------------------------
      BPMN INITIALISATION (UNE SEULE FOIS)
  ------------------------------------------*/ (0, _react.useEffect)(()=>{
        if (!bpmnContainerRef.current) return;
        if (modelerRef.current) return; // â— empàªcher double initialisation
        modelerRef.current = new (0, _modelerDefault.default)({
            container: bpmnContainerRef.current
        });
        const initialDiagram = `
      <?xml version="1.0" encoding="UTF-8"?>
      <bpmn:definitions xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"
        xmlns:bpmn="http://www.omg.org/spec/BPMN/20100524/MODEL"
        xmlns:bpmndi="http://www.omg.org/spec/BPMN/20100524/DI"
        xmlns:dc="http://www.omg.org/spec/DD/20100524/DC"
        xmlns:di="http://www.omg.org/spec/DD/20100524/DI"
        targetNamespace="http://bpmn.io/schema/bpmn">
        <bpmn:process id="Process_1" isExecutable="false">
          <bpmn:startEvent id="StartEvent_1" />
        </bpmn:process>
        <bpmndi:BPMNDiagram id="BPMNDiagram_1">
          <bpmndi:BPMNPlane id="BPMNPlane_1" bpmnElement="Process_1">
            <bpmndi:BPMNShape id="StartEvent_1_di" bpmnElement="StartEvent_1">
              <dc:Bounds x="150" y="150" width="36" height="36"/>
            </bpmndi:BPMNShape>
          </bpmndi:BPMNPlane>
        </bpmndi:BPMNDiagram>
      </bpmn:definitions>
    `;
        modelerRef.current.importXML(initialDiagram).then(()=>{
            modelerRef.current.get("canvas").zoom("fit-viewport");
        });
    }, []);
    /* -----------------------------------------
      BPMN EXPORTS
  ------------------------------------------*/ const resetBPMN = async ()=>{
        if (!modelerRef.current) return;
        const { xml } = await modelerRef.current.saveXML({
            format: true
        });
        await modelerRef.current.importXML(xml);
        modelerRef.current.get("canvas").zoom("fit-viewport");
    };
    const exportBPMN = async ()=>{
        const { xml } = await modelerRef.current.saveXML({
            format: true
        });
        const blob = new Blob([
            xml
        ], {
            type: "text/xml"
        });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "diagram.bpmn";
        a.click();
        URL.revokeObjectURL(url);
    };
    const exportBPMNPDF = async ()=>{
        try {
            const element = document.querySelector(".bpmn-wrapper");
            const canvas = await (0, _html2CanvasDefault.default)(element, {
                scale: 3,
                backgroundColor: "#ffffff",
                useCORS: true
            });
            const imgData = canvas.toDataURL("image/png", 1.0);
            const pdf = new (0, _jspdf.jsPDF)("landscape", "mm", "a4");
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = canvas.height * pdfWidth / canvas.width;
            let position = 0;
            while(position < pdfHeight){
                pdf.addImage(imgData, "PNG", 0, -position, pdfWidth, pdfHeight);
                position += pdf.internal.pageSize.getHeight();
                if (position < pdfHeight) pdf.addPage();
            }
            pdf.save("bpmn-diagram.pdf");
        } catch (error) {
            alert("PDF export error.");
        }
    };
    /* -----------------------------------------
      SAVING - PDF UPLOADER LOGIC
------------------------------------------*/ // Load caseId
    (0, _react.useEffect)(()=>{
        const storedCaseId = localStorage.getItem("caseId");
        if (storedCaseId && storedCaseId !== "undefined" && storedCaseId !== "null") setCaseId(storedCaseId);
        else setError("No active case found.");
    }, []);
    // Load case details
    (0, _react.useEffect)(()=>{
        if (!caseId) return;
        const apiUrl = "/api";
        if (!apiUrl) {
            setError("API_URL not defined");
            return;
        }
        fetch(`${apiUrl}/api/case-details/${caseId}`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token") || ""}`
            }
        }).then((res)=>res.json()).then((data)=>setCaseData(data.case)).catch(()=>setError("\xe2\x9d\u0152 Cannot load case details"));
    }, [
        caseId
    ]);
    // Choose PDF
    const handleFileChange = (event)=>{
        const file = event.target.files[0];
        if (!file) return;
        if (file.type !== "application/pdf") {
            setError("Please select a real PDF file.");
            setPdfFile(null);
            setPdfUrl(null);
            return;
        }
        setError("");
        setPdfFile(file);
        setPdfUrl(URL.createObjectURL(file));
    };
    // Remove PDF
    const handleRemoveFile = ()=>{
        setPdfFile(null);
        setPdfUrl(null);
        setMessage("");
        setError("");
        if (fileInputRef.current) fileInputRef.current.value = null;
    };
    // Upload PDF
    const handleUpload = async ()=>{
        if (!pdfFile) return setError("No file selected!");
        if (!caseId) return setError("Missing case ID!");
        const apiUrl = "/api";
        if (!apiUrl) return setError("API_URL not defined");
        setUploading(true);
        setMessage("Uploading...");
        setError("");
        try {
            const formData = new FormData();
            formData.append("file", pdfFile);
            const response = await fetch(`${apiUrl}/api/case/${caseId}/upload-pdf`, {
                method: "POST",
                body: formData,
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token") || ""}`
                }
            });
            if (!response.ok) throw new Error("Upload failed");
            setMessage("\xe2\u0153\u2026 PDF successfully uploaded!");
        } catch (err) {
            setError("Upload failed!");
        } finally{
            setUploading(false);
        }
    };
    /* -----------------------------------------
      RETURN JSX
  ------------------------------------------*/ return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "conception-card",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                        className: "conception-title",
                        children: "Conception Models Hub"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "conception-subtitle",
                        children: "Centralized workspace to design and export all project models."
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "editor-tabs",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: ()=>setActiveEditor("activity"),
                        children: "Functional view"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: ()=>setActiveEditor("bpmn"),
                        children: "Process view"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: ()=>setActiveEditor("activity2"),
                        children: "Physical model"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: ()=>setActiveEditor("class"),
                        children: "Informational model"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: ()=>setActiveEditor("decisional"),
                        children: "Decisional model"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: ()=>setActiveEditor("excalidraw"),
                        children: "Management"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: ()=>setActiveEditor("saving"),
                        children: "Saving"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                style: {
                    display: activeEditor === "activity" ? "block" : "none"
                },
                className: "vp-container-conception",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "vp-toolbar",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                onClick: handleImport,
                                children: " Import"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                onClick: handleExport,
                                children: "Export"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                onClick: handleReset,
                                children: "Reset"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                        className: "bpmn-title",
                        children: "Activity Diagram - Functionalview"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("iframe", {
                        ref: iframeRef,
                        className: "vp-editor-frame",
                        src: "https://online.visual-paradigm.com/app/diagrams/#diagram:proj=0&type=ActivityDiagram",
                        allowFullScreen: true
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                style: {
                    display: activeEditor === "activity2" ? "block" : "none"
                },
                className: "vp-container-conception",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "vp-toolbar",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                onClick: handleImport,
                                children: " Import"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                onClick: handleExport,
                                children: "Export"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                onClick: handleReset,
                                children: "Reset"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                        className: "bpmn-title",
                        children: "Activity Diagram - PhysicalModel"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("iframe", {
                        ref: iframeRef,
                        className: "vp-editor-frame",
                        src: "https://online.visual-paradigm.com/app/diagrams/#diagram:proj=0&type=ActivityDiagram",
                        allowFullScreen: true
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                style: {
                    visibility: activeEditor === "bpmn" ? "visible" : "hidden",
                    position: activeEditor === "bpmn" ? "relative" : "absolute",
                    pointerEvents: activeEditor === "bpmn" ? "auto" : "none",
                    width: "100%"
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "bpmn-wrapper",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                className: "bpmn-title",
                                children: "BPMN.IO - Process View"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                ref: bpmnContainerRef,
                                className: "bpmn-container"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "toolbar",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                onClick: resetBPMN,
                                children: "Reset"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                onClick: exportBPMN,
                                children: "Export BPMN"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                onClick: exportBPMNPDF,
                                children: "Export PDF"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                style: {
                    display: activeEditor === "class" ? "block" : "none"
                },
                className: "vp-container-conception",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "vp-toolbar",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                onClick: handleImport,
                                children: "Import"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                onClick: handleExport,
                                children: "Export"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                onClick: handleReset,
                                children: "Reset"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                        className: "bpmn-title",
                        children: "Class Diagram - Informational Model"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("iframe", {
                        className: "vp-editor-frame",
                        src: "https://online.visual-paradigm.com/app/diagrams/#diagram:proj=0&type=ClassDiagram",
                        allowFullScreen: true
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                style: {
                    display: activeEditor === "decisional" ? "block" : "none",
                    padding: "20px"
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                        className: "bpmn-title",
                        children: "GRAI Lite - Decisional Model"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "grai-lite-wrapper",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(MemoGRAIEditorLite, {
                            instanceId: "grai_lite_conception",
                            storageKey: "graiLite_conception",
                            title: "Decisional Model - GRAI (Lite)"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                style: {
                    display: activeEditor === "excalidraw" ? "block" : "none"
                },
                className: "vp-container-conception",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "vp-toolbar",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                onClick: ()=>alert(" Import inside Excalidraw"),
                                children: "Import"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                onClick: ()=>alert("Export inside Excalidraw"),
                                children: "Export"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                onClick: ()=>{
                                    if (excalidrawRef.current) excalidrawRef.current.src = excalidrawRef.current.src;
                                },
                                children: "Reset"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                        className: "bpmn-title",
                        children: "Excalidraw - VSM / 5S / SMED / Kaizen / Visual Management"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("iframe", {
                        ref: excalidrawRef,
                        className: "vp-editor-frame",
                        src: "https://excalidraw.com/?theme=light&embed=1",
                        allowFullScreen: true
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "saving-section",
                style: {
                    display: activeEditor === "saving" ? "block" : "none"
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "pdf-uploader-container",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "pdf-uploader-card",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                className: "pdf-uploader-title",
                                children: "Upload Case PDF"
                            }),
                            caseData ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "analysis-header-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        className: "analysis-company-name",
                                        children: caseData.company_name || caseData.enterpriseName
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                        className: "analysis-info-line",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                children: "Sector:"
                                            }),
                                            " ",
                                            caseData.activity_sector,
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                style: {
                                                    margin: "0 6px"
                                                }
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                children: "Size:"
                                            }),
                                            " ",
                                            caseData.company_size,
                                            " employees"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                        className: "analysis-info-line",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                children: "Created:"
                                            }),
                                            " ",
                                            new Date(caseData.timestamp).toLocaleString()
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                style: {
                                    fontWeight: "bold"
                                },
                                children: "Loading..."
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                className: "pdf-button upload",
                                children: [
                                    "Select PDF",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                        ref: fileInputRef,
                                        type: "file",
                                        accept: "application/pdf",
                                        onChange: handleFileChange,
                                        style: {
                                            display: "none"
                                        }
                                    })
                                ]
                            }),
                            error && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                style: {
                                    color: "red"
                                },
                                children: error
                            }),
                            pdfFile && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        style: {
                                            marginTop: "15px"
                                        },
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                            children: pdfFile.name
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "pdf-buttons",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                className: "pdf-button upload",
                                                onClick: handleUpload,
                                                disabled: uploading,
                                                children: uploading ? "Uploading..." : "Upload"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                className: "pdf-button delete",
                                                onClick: handleRemoveFile,
                                                children: "Remove"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            message && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                style: {
                                    marginTop: "15px",
                                    color: "green",
                                    fontWeight: 500
                                },
                                children: message
                            }),
                            pdfUrl && /*#__PURE__*/ (0, _jsxRuntime.jsx)("iframe", {
                                src: pdfUrl,
                                className: "pdf-preview",
                                title: "PDF Preview"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "icam-navigation",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                        to: "/analysisbeta",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            className: "icam-nav-btn",
                            children: "Back to Analysis page"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                        to: "/implementation",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            className: "icam-nav-btn",
                            children: "Move to Evaluation"
                        })
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"b9X5n","bpmn-js/lib/Modeler":"5JFM2","html2canvas":"3eyQ5","jspdf":"hkJ4Q","../GRAIEditorLite":"dHEdA","../PdfUploader/PdfUploader.css":"gbRmf","bpmn-js/dist/assets/diagram-js.css":"55Ura","bpmn-js/dist/assets/bpmn-font/css/bpmn.css":"7eeEz","./Conception.css":"fdZ0G","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5JFM2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Modeler);
var _inheritsBrowser = require("inherits-browser");
var _inheritsBrowserDefault = parcelHelpers.interopDefault(_inheritsBrowser);
var _baseModeler = require("./BaseModeler");
var _baseModelerDefault = parcelHelpers.interopDefault(_baseModeler);
var _viewer = require("./Viewer");
var _viewerDefault = parcelHelpers.interopDefault(_viewer);
var _navigatedViewer = require("./NavigatedViewer");
var _navigatedViewerDefault = parcelHelpers.interopDefault(_navigatedViewer);
var _keyboardMove = require("diagram-js/lib/navigation/keyboard-move");
var _keyboardMoveDefault = parcelHelpers.interopDefault(_keyboardMove);
var _movecanvas = require("diagram-js/lib/navigation/movecanvas");
var _movecanvasDefault = parcelHelpers.interopDefault(_movecanvas);
var _touch = require("diagram-js/lib/navigation/touch");
var _touchDefault = parcelHelpers.interopDefault(_touch);
var _zoomscroll = require("diagram-js/lib/navigation/zoomscroll");
var _zoomscrollDefault = parcelHelpers.interopDefault(_zoomscroll);
var _alignElements = require("./features/align-elements");
var _alignElementsDefault = parcelHelpers.interopDefault(_alignElements);
var _autoPlace = require("./features/auto-place");
var _autoPlaceDefault = parcelHelpers.interopDefault(_autoPlace);
var _autoResize = require("./features/auto-resize");
var _autoResizeDefault = parcelHelpers.interopDefault(_autoResize);
var _autoScroll = require("diagram-js/lib/features/auto-scroll");
var _autoScrollDefault = parcelHelpers.interopDefault(_autoScroll);
var _bendpoints = require("diagram-js/lib/features/bendpoints");
var _bendpointsDefault = parcelHelpers.interopDefault(_bendpoints);
var _connect = require("diagram-js/lib/features/connect");
var _connectDefault = parcelHelpers.interopDefault(_connect);
var _connectionPreview = require("diagram-js/lib/features/connection-preview");
var _connectionPreviewDefault = parcelHelpers.interopDefault(_connectionPreview);
var _contextPad = require("./features/context-pad");
var _contextPadDefault = parcelHelpers.interopDefault(_contextPad);
var _copyPaste = require("./features/copy-paste");
var _copyPasteDefault = parcelHelpers.interopDefault(_copyPaste);
var _create = require("diagram-js/lib/features/create");
var _createDefault = parcelHelpers.interopDefault(_create);
var _createAppendAnything = require("./features/create-append-anything");
var _createAppendAnythingDefault = parcelHelpers.interopDefault(_createAppendAnything);
var _distributeElements = require("./features/distribute-elements");
var _distributeElementsDefault = parcelHelpers.interopDefault(_distributeElements);
var _editorActions = require("./features/editor-actions");
var _editorActionsDefault = parcelHelpers.interopDefault(_editorActions);
var _gridSnapping = require("./features/grid-snapping");
var _gridSnappingDefault = parcelHelpers.interopDefault(_gridSnapping);
var _interactionEvents = require("./features/interaction-events");
var _interactionEventsDefault = parcelHelpers.interopDefault(_interactionEvents);
var _keyboard = require("./features/keyboard");
var _keyboardDefault = parcelHelpers.interopDefault(_keyboard);
var _keyboardMoveSelection = require("diagram-js/lib/features/keyboard-move-selection");
var _keyboardMoveSelectionDefault = parcelHelpers.interopDefault(_keyboardMoveSelection);
var _labelEditing = require("./features/label-editing");
var _labelEditingDefault = parcelHelpers.interopDefault(_labelEditing);
var _modeling = require("./features/modeling");
var _modelingDefault = parcelHelpers.interopDefault(_modeling);
var _move = require("diagram-js/lib/features/move");
var _moveDefault = parcelHelpers.interopDefault(_move);
var _palette = require("./features/palette");
var _paletteDefault = parcelHelpers.interopDefault(_palette);
var _replacePreview = require("./features/replace-preview");
var _replacePreviewDefault = parcelHelpers.interopDefault(_replacePreview);
var _resize = require("diagram-js/lib/features/resize");
var _resizeDefault = parcelHelpers.interopDefault(_resize);
var _snapping = require("./features/snapping");
var _snappingDefault = parcelHelpers.interopDefault(_snapping);
var _search = require("./features/search");
var _searchDefault = parcelHelpers.interopDefault(_search);
var _compatibilityUtil = require("./util/CompatibilityUtil");
var initialDiagram = '<?xml version="1.0" encoding="UTF-8"?><bpmn:definitions xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:bpmn="http://www.omg.org/spec/BPMN/20100524/MODEL" xmlns:bpmndi="http://www.omg.org/spec/BPMN/20100524/DI" xmlns:dc="http://www.omg.org/spec/DD/20100524/DC" targetNamespace="http://bpmn.io/schema/bpmn" id="Definitions_1"><bpmn:process id="Process_1" isExecutable="false"><bpmn:startEvent id="StartEvent_1"/></bpmn:process><bpmndi:BPMNDiagram id="BPMNDiagram_1"><bpmndi:BPMNPlane id="BPMNPlane_1" bpmnElement="Process_1"><bpmndi:BPMNShape id="_BPMNShape_StartEvent_2" bpmnElement="StartEvent_1"><dc:Bounds height="36.0" width="36.0" x="173.0" y="102.0"/></bpmndi:BPMNShape></bpmndi:BPMNPlane></bpmndi:BPMNDiagram></bpmn:definitions>';
function Modeler(options) {
    (0, _baseModelerDefault.default).call(this, options);
}
(0, _inheritsBrowserDefault.default)(Modeler, (0, _baseModelerDefault.default));
Modeler.Viewer = (0, _viewerDefault.default);
Modeler.NavigatedViewer = (0, _navigatedViewerDefault.default);
/**
* The createDiagram result.
*
* @typedef {Object} CreateDiagramResult
*
* @property {Array<string>} warnings
*/ /**
* The createDiagram error.
*
* @typedef {Error} CreateDiagramError
*
* @property {Array<string>} warnings
*/ /**
 * Create a new diagram to start modeling.
 *
 * Returns {Promise<CreateDiagramResult, CreateDiagramError>}
 */ Modeler.prototype.createDiagram = (0, _compatibilityUtil.wrapForCompatibility)(function createDiagram() {
    return this.importXML(initialDiagram);
});
Modeler.prototype._interactionModules = [
    // non-modeling components
    (0, _keyboardMoveDefault.default),
    (0, _movecanvasDefault.default),
    (0, _touchDefault.default),
    (0, _zoomscrollDefault.default)
];
Modeler.prototype._modelingModules = [
    // modeling components
    (0, _alignElementsDefault.default),
    (0, _autoPlaceDefault.default),
    (0, _autoScrollDefault.default),
    (0, _autoResizeDefault.default),
    (0, _bendpointsDefault.default),
    (0, _connectDefault.default),
    (0, _connectionPreviewDefault.default),
    (0, _contextPadDefault.default),
    (0, _copyPasteDefault.default),
    (0, _createDefault.default),
    (0, _createAppendAnythingDefault.default),
    (0, _distributeElementsDefault.default),
    (0, _editorActionsDefault.default),
    (0, _gridSnappingDefault.default),
    (0, _interactionEventsDefault.default),
    (0, _keyboardDefault.default),
    (0, _keyboardMoveSelectionDefault.default),
    (0, _labelEditingDefault.default),
    (0, _modelingDefault.default),
    (0, _moveDefault.default),
    (0, _paletteDefault.default),
    (0, _replacePreviewDefault.default),
    (0, _resizeDefault.default),
    (0, _snappingDefault.default),
    (0, _searchDefault.default)
];
// modules the modeler is composed of
//
// - viewer modules
// - interaction modules
// - modeling modules
Modeler.prototype._modules = [].concat((0, _viewerDefault.default).prototype._modules, Modeler.prototype._interactionModules, Modeler.prototype._modelingModules);

},{"inherits-browser":"hymxq","./BaseModeler":"1Ql8e","./Viewer":"1SAoE","./NavigatedViewer":"lNTRk","diagram-js/lib/navigation/keyboard-move":"4pwXS","diagram-js/lib/navigation/movecanvas":"fUC2m","diagram-js/lib/navigation/touch":"bfg8c","diagram-js/lib/navigation/zoomscroll":"dRWcE","./features/align-elements":"ktdKa","./features/auto-place":"8yzvZ","./features/auto-resize":"iYR0b","diagram-js/lib/features/auto-scroll":"bmWrZ","diagram-js/lib/features/bendpoints":"agMLL","diagram-js/lib/features/connect":"jmgwG","diagram-js/lib/features/connection-preview":"7XZ5m","./features/context-pad":"kXnNk","./features/copy-paste":"wsGCk","diagram-js/lib/features/create":"kKw9I","./features/create-append-anything":"kSkj8","./features/distribute-elements":"4dQN8","./features/editor-actions":"aU1yp","./features/grid-snapping":"h0W2n","./features/interaction-events":"hZwfY","./features/keyboard":"gWFgF","diagram-js/lib/features/keyboard-move-selection":"b6S1l","./features/label-editing":"d9iP2","./features/modeling":"cXtIQ","diagram-js/lib/features/move":"43EOh","./features/palette":"kTZOk","./features/replace-preview":"fVkpb","diagram-js/lib/features/resize":"eKu3X","./features/snapping":"ffgrx","./features/search":"eBhd3","./util/CompatibilityUtil":"aYHXN","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hymxq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>e);
function e(e, t) {
    t && (e.super_ = t, e.prototype = Object.create(t.prototype, {
        constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
        }
    }));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1Ql8e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BaseModeler);
var _inheritsBrowser = require("inherits-browser");
var _inheritsBrowserDefault = parcelHelpers.interopDefault(_inheritsBrowser);
var _ids = require("ids");
var _idsDefault = parcelHelpers.interopDefault(_ids);
var _baseViewer = require("./BaseViewer");
var _baseViewerDefault = parcelHelpers.interopDefault(_baseViewer);
function BaseModeler(options) {
    (0, _baseViewerDefault.default).call(this, options);
    // hook ID collection into the modeler
    this.on('import.parse.complete', function(event) {
        if (!event.error) this._collectIds(event.definitions, event.elementsById);
    }, this);
    this.on('diagram.destroy', function() {
        this.get('moddle').ids.clear();
    }, this);
}
(0, _inheritsBrowserDefault.default)(BaseModeler, (0, _baseViewerDefault.default));
/**
 * Create a moddle instance, attaching ids to it.
 *
 * @param {Object} options
 */ BaseModeler.prototype._createModdle = function(options) {
    var moddle = (0, _baseViewerDefault.default).prototype._createModdle.call(this, options);
    // attach ids to moddle to be able to track
    // and validated ids in the BPMN 2.0 XML document
    // tree
    moddle.ids = new (0, _idsDefault.default)([
        32,
        36,
        1
    ]);
    return moddle;
};
/**
 * Collect ids processed during parsing of the
 * definitions object.
 *
 * @param {ModdleElement} definitions
 * @param {Context} context
 */ BaseModeler.prototype._collectIds = function(definitions, elementsById) {
    var moddle = definitions.$model, ids = moddle.ids, id;
    // remove references from previous import
    ids.clear();
    for(id in elementsById)ids.claim(id, elementsById[id]);
};

},{"inherits-browser":"hymxq","ids":"1I7q6","./BaseViewer":"aauW6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1I7q6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function createCommonjsModule(fn, module) {
    return module = {
        exports: {}
    }, fn(module, module.exports), module.exports;
}
var hat_1 = createCommonjsModule(function(module) {
    var hat = module.exports = function(bits, base) {
        if (!base) base = 16;
        if (bits === undefined) bits = 128;
        if (bits <= 0) return '0';
        var digits = Math.log(Math.pow(2, bits)) / Math.log(base);
        for(var i = 2; digits === Infinity; i *= 2)digits = Math.log(Math.pow(2, bits / i)) / Math.log(base) * i;
        var rem = digits - Math.floor(digits);
        var res = '';
        for(var i = 0; i < Math.floor(digits); i++){
            var x = Math.floor(Math.random() * base).toString(base);
            res = x + res;
        }
        if (rem) {
            var b = Math.pow(base, rem);
            var x = Math.floor(Math.random() * b).toString(base);
            res = x + res;
        }
        var parsed = parseInt(res, base);
        if (parsed !== Infinity && parsed >= Math.pow(2, bits)) return hat(bits, base);
        else return res;
    };
    hat.rack = function(bits, base, expandBy) {
        var fn = function(data) {
            var iters = 0;
            do {
                if (iters++ > 10) {
                    if (expandBy) bits += expandBy;
                    else throw new Error('too many ID collisions, use more bits');
                }
                var id = hat(bits, base);
            }while (Object.hasOwnProperty.call(hats, id));
            hats[id] = data;
            return id;
        };
        var hats = fn.hats = {};
        fn.get = function(id) {
            return fn.hats[id];
        };
        fn.set = function(id, value) {
            fn.hats[id] = value;
            return fn;
        };
        fn.bits = bits || 128;
        fn.base = base || 16;
        return fn;
    };
});
/**
 * Create a new id generator / cache instance.
 *
 * You may optionally provide a seed that is used internally.
 *
 * @param {Seed} seed
 */ function Ids(seed) {
    if (!(this instanceof Ids)) return new Ids(seed);
    seed = seed || [
        128,
        36,
        1
    ];
    this._seed = seed.length ? hat_1.rack(seed[0], seed[1], seed[2]) : seed;
}
/**
 * Generate a next id.
 *
 * @param {Object} [element] element to bind the id to
 *
 * @return {String} id
 */ Ids.prototype.next = function(element) {
    return this._seed(element || true);
};
/**
 * Generate a next id with a given prefix.
 *
 * @param {Object} [element] element to bind the id to
 *
 * @return {String} id
 */ Ids.prototype.nextPrefixed = function(prefix, element) {
    var id;
    do id = prefix + this.next(true);
    while (this.assigned(id));
    // claim {prefix}{random}
    this.claim(id, element);
    // return
    return id;
};
/**
 * Manually claim an existing id.
 *
 * @param {String} id
 * @param {String} [element] element the id is claimed by
 */ Ids.prototype.claim = function(id, element) {
    this._seed.set(id, element || true);
};
/**
 * Returns true if the given id has already been assigned.
 *
 * @param  {String} id
 * @return {Boolean}
 */ Ids.prototype.assigned = function(id) {
    return this._seed.get(id) || false;
};
/**
 * Unclaim an id.
 *
 * @param  {String} id the id to unclaim
 */ Ids.prototype.unclaim = function(id) {
    delete this._seed.hats[id];
};
/**
 * Clear all claimed ids.
 */ Ids.prototype.clear = function() {
    var hats = this._seed.hats, id;
    for(id in hats)this.unclaim(id);
};
exports.default = Ids;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aauW6":[function(require,module,exports,__globalThis) {
/**
 * The code in the <project-logo></project-logo> area
 * must not be changed.
 *
 * @see http://bpmn.io/license for more information.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BaseViewer);
var _minDash = require("min-dash");
var _minDom = require("min-dom");
var _tinySvg = require("tiny-svg");
var _diagramJs = require("diagram-js");
var _diagramJsDefault = parcelHelpers.interopDefault(_diagramJs);
var _bpmnModdle = require("bpmn-moddle");
var _bpmnModdleDefault = parcelHelpers.interopDefault(_bpmnModdle);
var _inheritsBrowser = require("inherits-browser");
var _inheritsBrowserDefault = parcelHelpers.interopDefault(_inheritsBrowser);
var _importer = require("./import/Importer");
var _compatibilityUtil = require("./util/CompatibilityUtil");
/* <project-logo> */ var _poweredByUtil = require("./util/PoweredByUtil");
function BaseViewer(options) {
    options = (0, _minDash.assign)({}, DEFAULT_OPTIONS, options);
    this._moddle = this._createModdle(options);
    this._container = this._createContainer(options);
    /* <project-logo> */ addProjectLogo(this._container);
    /* </project-logo> */ this._init(this._container, this._moddle, options);
}
(0, _inheritsBrowserDefault.default)(BaseViewer, (0, _diagramJsDefault.default));
/**
* The importXML result.
*
* @typedef {Object} ImportXMLResult
*
* @property {Array<string>} warnings
*/ /**
* The importXML error.
*
* @typedef {Error} ImportXMLError
*
* @property {Array<string>} warnings
*/ /**
 * Parse and render a BPMN 2.0 diagram.
 *
 * Once finished the viewer reports back the result to the
 * provided callback function with (err, warnings).
 *
 * ## Life-Cycle Events
 *
 * During import the viewer will fire life-cycle events:
 *
 *   * import.parse.start (about to read model from xml)
 *   * import.parse.complete (model read; may have worked or not)
 *   * import.render.start (graphical import start)
 *   * import.render.complete (graphical import finished)
 *   * import.done (everything done)
 *
 * You can use these events to hook into the life-cycle.
 *
 * @param {string} xml the BPMN 2.0 xml
 * @param {ModdleElement<BPMNDiagram>|string} [bpmnDiagram] BPMN diagram or id of diagram to render (if not provided, the first one will be rendered)
 *
 * Returns {Promise<ImportXMLResult, ImportXMLError>}
 */ BaseViewer.prototype.importXML = (0, _compatibilityUtil.wrapForCompatibility)(async function importXML(xml, bpmnDiagram) {
    const self = this;
    function ParseCompleteEvent(data) {
        const event = self.get('eventBus').createEvent(data);
        // TODO(nikku): remove with future bpmn-js version
        Object.defineProperty(event, 'context', {
            enumerable: true,
            get: function() {
                console.warn(new Error("import.parse.complete <context> is deprecated and will be removed in future library versions"));
                return {
                    warnings: data.warnings,
                    references: data.references,
                    elementsById: data.elementsById
                };
            }
        });
        return event;
    }
    let aggregatedWarnings = [];
    try {
        // hook in pre-parse listeners +
        // allow xml manipulation
        xml = this._emit('import.parse.start', {
            xml: xml
        }) || xml;
        let parseResult;
        try {
            parseResult = await this._moddle.fromXML(xml, 'bpmn:Definitions');
        } catch (error) {
            this._emit('import.parse.complete', {
                error
            });
            throw error;
        }
        let definitions = parseResult.rootElement;
        const references = parseResult.references;
        const parseWarnings = parseResult.warnings;
        const elementsById = parseResult.elementsById;
        aggregatedWarnings = aggregatedWarnings.concat(parseWarnings);
        // hook in post parse listeners +
        // allow definitions manipulation
        definitions = this._emit('import.parse.complete', ParseCompleteEvent({
            error: null,
            definitions: definitions,
            elementsById: elementsById,
            references: references,
            warnings: aggregatedWarnings
        })) || definitions;
        const importResult = await this.importDefinitions(definitions, bpmnDiagram);
        aggregatedWarnings = aggregatedWarnings.concat(importResult.warnings);
        this._emit('import.done', {
            error: null,
            warnings: aggregatedWarnings
        });
        return {
            warnings: aggregatedWarnings
        };
    } catch (err) {
        let error = err;
        aggregatedWarnings = aggregatedWarnings.concat(error.warnings || []);
        addWarningsToError(error, aggregatedWarnings);
        error = checkValidationError(error);
        this._emit('import.done', {
            error,
            warnings: error.warnings
        });
        throw error;
    }
});
/**
* The importDefinitions result.
*
* @typedef {Object} ImportDefinitionsResult
*
* @property {Array<string>} warnings
*/ /**
* The importDefinitions error.
*
* @typedef {Error} ImportDefinitionsError
*
* @property {Array<string>} warnings
*/ /**
 * Import parsed definitions and render a BPMN 2.0 diagram.
 *
 * Once finished the viewer reports back the result to the
 * provided callback function with (err, warnings).
 *
 * ## Life-Cycle Events
 *
 * During import the viewer will fire life-cycle events:
 *
 *   * import.render.start (graphical import start)
 *   * import.render.complete (graphical import finished)
 *
 * You can use these events to hook into the life-cycle.
 *
 * @param {ModdleElement<Definitions>} definitions parsed BPMN 2.0 definitions
 * @param {ModdleElement<BPMNDiagram>|string} [bpmnDiagram] BPMN diagram or id of diagram to render (if not provided, the first one will be rendered)
 *
 * Returns {Promise<ImportDefinitionsResult, ImportDefinitionsError>}
 */ BaseViewer.prototype.importDefinitions = (0, _compatibilityUtil.wrapForCompatibility)(async function importDefinitions(definitions, bpmnDiagram) {
    this._setDefinitions(definitions);
    const result = await this.open(bpmnDiagram);
    return {
        warnings: result.warnings
    };
});
/**
 * The open result.
 *
 * @typedef {Object} OpenResult
 *
 * @property {Array<string>} warnings
 */ /**
* The open error.
*
* @typedef {Error} OpenError
*
* @property {Array<string>} warnings
*/ /**
 * Open diagram of previously imported XML.
 *
 * Once finished the viewer reports back the result to the
 * provided callback function with (err, warnings).
 *
 * ## Life-Cycle Events
 *
 * During switch the viewer will fire life-cycle events:
 *
 *   * import.render.start (graphical import start)
 *   * import.render.complete (graphical import finished)
 *
 * You can use these events to hook into the life-cycle.
 *
 * @param {string|ModdleElement<BPMNDiagram>} [bpmnDiagramOrId] id or the diagram to open
 *
 * Returns {Promise<OpenResult, OpenError>}
 */ BaseViewer.prototype.open = (0, _compatibilityUtil.wrapForCompatibility)(async function open(bpmnDiagramOrId) {
    const definitions = this._definitions;
    let bpmnDiagram = bpmnDiagramOrId;
    if (!definitions) {
        const error = new Error('no XML imported');
        addWarningsToError(error, []);
        throw error;
    }
    if (typeof bpmnDiagramOrId === 'string') {
        bpmnDiagram = findBPMNDiagram(definitions, bpmnDiagramOrId);
        if (!bpmnDiagram) {
            const error = new Error('BPMNDiagram <' + bpmnDiagramOrId + '> not found');
            addWarningsToError(error, []);
            throw error;
        }
    }
    // clear existing rendered diagram
    // catch synchronous exceptions during #clear()
    try {
        this.clear();
    } catch (error) {
        addWarningsToError(error, []);
        throw error;
    }
    // perform graphical import
    const { warnings } = await (0, _importer.importBpmnDiagram)(this, definitions, bpmnDiagram);
    return {
        warnings
    };
});
/**
 * The saveXML result.
 *
 * @typedef {Object} SaveXMLResult
 *
 * @property {string} xml
 */ /**
 * Export the currently displayed BPMN 2.0 diagram as
 * a BPMN 2.0 XML document.
 *
 * ## Life-Cycle Events
 *
 * During XML saving the viewer will fire life-cycle events:
 *
 *   * saveXML.start (before serialization)
 *   * saveXML.serialized (after xml generation)
 *   * saveXML.done (everything done)
 *
 * You can use these events to hook into the life-cycle.
 *
 * @param {Object} [options] export options
 * @param {boolean} [options.format=false] output formatted XML
 * @param {boolean} [options.preamble=true] output preamble
 *
 * Returns {Promise<SaveXMLResult, Error>}
 */ BaseViewer.prototype.saveXML = (0, _compatibilityUtil.wrapForCompatibility)(async function saveXML(options) {
    options = options || {};
    let definitions = this._definitions, error, xml;
    try {
        if (!definitions) throw new Error('no definitions loaded');
        // allow to fiddle around with definitions
        definitions = this._emit('saveXML.start', {
            definitions
        }) || definitions;
        const result = await this._moddle.toXML(definitions, options);
        xml = result.xml;
        xml = this._emit('saveXML.serialized', {
            xml
        }) || xml;
    } catch (err) {
        error = err;
    }
    const result = error ? {
        error
    } : {
        xml
    };
    this._emit('saveXML.done', result);
    if (error) throw error;
    return result;
});
/**
 * The saveSVG result.
 *
 * @typedef {Object} SaveSVGResult
 *
 * @property {string} svg
 */ /**
 * Export the currently displayed BPMN 2.0 diagram as
 * an SVG image.
 *
 * ## Life-Cycle Events
 *
 * During SVG saving the viewer will fire life-cycle events:
 *
 *   * saveSVG.start (before serialization)
 *   * saveSVG.done (everything done)
 *
 * You can use these events to hook into the life-cycle.
 *
 * @param {Object} [options]
 *
 * Returns {Promise<SaveSVGResult, Error>}
 */ BaseViewer.prototype.saveSVG = (0, _compatibilityUtil.wrapForCompatibility)(async function saveSVG(options = {}) {
    this._emit('saveSVG.start');
    let svg, err;
    try {
        const canvas = this.get('canvas');
        const contentNode = canvas.getActiveLayer(), defsNode = (0, _minDom.query)('defs', canvas._svg);
        const contents = (0, _tinySvg.innerSVG)(contentNode), defs = defsNode ? '<defs>' + (0, _tinySvg.innerSVG)(defsNode) + '</defs>' : '';
        const bbox = contentNode.getBBox();
        svg = '<?xml version="1.0" encoding="utf-8"?>\n<!-- created with bpmn-js / http://bpmn.io -->\n<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">\n<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="' + bbox.width + '" height="' + bbox.height + '" ' + 'viewBox="' + bbox.x + ' ' + bbox.y + ' ' + bbox.width + ' ' + bbox.height + '" version="1.1">' + defs + contents + '</svg>';
    } catch (e) {
        err = e;
    }
    this._emit('saveSVG.done', {
        error: err,
        svg: svg
    });
    if (err) throw err;
    return {
        svg
    };
});
/**
 * Get a named diagram service.
 *
 * @example
 *
 * const elementRegistry = viewer.get('elementRegistry');
 * const startEventShape = elementRegistry.get('StartEvent_1');
 *
 * @param {string} name
 *
 * @return {Object} diagram service instance
 *
 * @method BaseViewer#get
 */ /**
 * Invoke a function in the context of this viewer.
 *
 * @example
 *
 * viewer.invoke(function(elementRegistry) {
 *   const startEventShape = elementRegistry.get('StartEvent_1');
 * });
 *
 * @param {Function} fn to be invoked
 *
 * @return {Object} the functions return value
 *
 * @method BaseViewer#invoke
 */ BaseViewer.prototype._setDefinitions = function(definitions) {
    this._definitions = definitions;
};
/**
 * Return modules to instantiate with.
 *
 * @param {any} options the instance got created with
 *
 * @return {Module[]}
 */ BaseViewer.prototype.getModules = function(options) {
    return this._modules;
};
/**
 * Remove all drawn elements from the viewer.
 *
 * After calling this method the viewer can still
 * be reused for opening another diagram.
 *
 * @method BaseViewer#clear
 */ BaseViewer.prototype.clear = function() {
    if (!this.getDefinitions()) // no diagram to clear
    return;
    // remove drawn elements
    (0, _diagramJsDefault.default).prototype.clear.call(this);
};
/**
 * Destroy the viewer instance and remove all its
 * remainders from the document tree.
 */ BaseViewer.prototype.destroy = function() {
    // diagram destroy
    (0, _diagramJsDefault.default).prototype.destroy.call(this);
    // dom detach
    (0, _minDom.remove)(this._container);
};
/**
 * Register an event listener
 *
 * Remove a previously added listener via {@link #off(event, callback)}.
 *
 * @param {string} event
 * @param {number} [priority]
 * @param {Function} callback
 * @param {Object} [that]
 */ BaseViewer.prototype.on = function(event, priority, callback, target) {
    return this.get('eventBus').on(event, priority, callback, target);
};
/**
 * De-register an event listener
 *
 * @param {string} event
 * @param {Function} callback
 */ BaseViewer.prototype.off = function(event, callback) {
    this.get('eventBus').off(event, callback);
};
BaseViewer.prototype.attachTo = function(parentNode) {
    if (!parentNode) throw new Error('parentNode required');
    // ensure we detach from the
    // previous, old parent
    this.detach();
    // unwrap jQuery if provided
    if (parentNode.get && parentNode.constructor.prototype.jquery) parentNode = parentNode.get(0);
    if (typeof parentNode === 'string') parentNode = (0, _minDom.query)(parentNode);
    parentNode.appendChild(this._container);
    this._emit('attach', {});
    this.get('canvas').resized();
};
BaseViewer.prototype.getDefinitions = function() {
    return this._definitions;
};
BaseViewer.prototype.detach = function() {
    const container = this._container, parentNode = container.parentNode;
    if (!parentNode) return;
    this._emit('detach', {});
    parentNode.removeChild(container);
};
BaseViewer.prototype._init = function(container, moddle, options) {
    const baseModules = options.modules || this.getModules(options), additionalModules = options.additionalModules || [], staticModules = [
        {
            bpmnjs: [
                'value',
                this
            ],
            moddle: [
                'value',
                moddle
            ]
        }
    ];
    const diagramModules = [].concat(staticModules, baseModules, additionalModules);
    const diagramOptions = (0, _minDash.assign)((0, _minDash.omit)(options, [
        'additionalModules'
    ]), {
        canvas: (0, _minDash.assign)({}, options.canvas, {
            container: container
        }),
        modules: diagramModules
    });
    // invoke diagram constructor
    (0, _diagramJsDefault.default).call(this, diagramOptions);
    if (options && options.container) this.attachTo(options.container);
};
/**
 * Emit an event on the underlying {@link EventBus}
 *
 * @param  {string} type
 * @param  {Object} event
 *
 * @return {Object} event processing result (if any)
 */ BaseViewer.prototype._emit = function(type, event) {
    return this.get('eventBus').fire(type, event);
};
BaseViewer.prototype._createContainer = function(options) {
    const container = (0, _minDom.domify)('<div class="bjs-container"></div>');
    (0, _minDom.assignStyle)(container, {
        width: ensureUnit(options.width),
        height: ensureUnit(options.height),
        position: options.position
    });
    return container;
};
BaseViewer.prototype._createModdle = function(options) {
    const moddleOptions = (0, _minDash.assign)({}, this._moddleExtensions, options.moddleExtensions);
    return new (0, _bpmnModdleDefault.default)(moddleOptions);
};
BaseViewer.prototype._modules = [];
// helpers ///////////////
function addWarningsToError(err, warningsAry) {
    err.warnings = warningsAry;
    return err;
}
function checkValidationError(err) {
    // check if we can help the user by indicating wrong BPMN 2.0 xml
    // (in case he or the exporting tool did not get that right)
    const pattern = /unparsable content <([^>]+)> detected([\s\S]*)$/;
    const match = pattern.exec(err.message);
    if (match) err.message = 'unparsable content <' + match[1] + '> detected; ' + 'this may indicate an invalid BPMN 2.0 diagram file' + match[2];
    return err;
}
const DEFAULT_OPTIONS = {
    width: '100%',
    height: '100%',
    position: 'relative'
};
/**
 * Ensure the passed argument is a proper unit (defaulting to px)
 */ function ensureUnit(val) {
    return val + ((0, _minDash.isNumber)(val) ? 'px' : '');
}
/**
 * Find BPMNDiagram in definitions by ID
 *
 * @param {ModdleElement<Definitions>} definitions
 * @param {string} diagramId
 *
 * @return {ModdleElement<BPMNDiagram>|null}
 */ function findBPMNDiagram(definitions, diagramId) {
    if (!diagramId) return null;
    return (0, _minDash.find)(definitions.diagrams, function(element) {
        return element.id === diagramId;
    }) || null;
}
/**
 * Adds the project logo to the diagram container as
 * required by the bpmn.io license.
 *
 * @see http://bpmn.io/license
 *
 * @param {Element} container
 */ function addProjectLogo(container) {
    const img = (0, _poweredByUtil.BPMNIO_IMG);
    const linkMarkup = '<a href="http://bpmn.io" target="_blank" class="bjs-powered-by" title="Powered by bpmn.io" >' + img + '</a>';
    const linkElement = (0, _minDom.domify)(linkMarkup);
    (0, _minDom.assignStyle)((0, _minDom.query)('svg', linkElement), (0, _poweredByUtil.LOGO_STYLES));
    (0, _minDom.assignStyle)(linkElement, (0, _poweredByUtil.LINK_STYLES), {
        position: 'absolute',
        bottom: '15px',
        right: '15px',
        zIndex: '100'
    });
    container.appendChild(linkElement);
    (0, _minDom.event).bind(linkElement, 'click', function(event) {
        (0, _poweredByUtil.open)();
        event.preventDefault();
    });
} /* </project-logo> */ 

},{"min-dash":"aEEla","min-dom":"e58GC","tiny-svg":"6ZtXA","diagram-js":"9r90s","bpmn-moddle":"b2IVW","inherits-browser":"hymxq","./import/Importer":"9f1dX","./util/CompatibilityUtil":"aYHXN","./util/PoweredByUtil":"g89GA","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aEEla":[function(require,module,exports,__globalThis) {
/**
 * Flatten array, one level deep.
 *
 * @template T
 *
 * @param {T[][] | T[] | null} [arr]
 *
 * @return {T[]}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "assign", ()=>assign);
parcelHelpers.export(exports, "bind", ()=>bind);
parcelHelpers.export(exports, "debounce", ()=>debounce);
parcelHelpers.export(exports, "ensureArray", ()=>ensureArray);
parcelHelpers.export(exports, "every", ()=>every);
parcelHelpers.export(exports, "filter", ()=>filter);
parcelHelpers.export(exports, "find", ()=>find);
parcelHelpers.export(exports, "findIndex", ()=>findIndex);
parcelHelpers.export(exports, "flatten", ()=>flatten);
parcelHelpers.export(exports, "forEach", ()=>forEach);
parcelHelpers.export(exports, "get", ()=>get);
parcelHelpers.export(exports, "groupBy", ()=>groupBy);
parcelHelpers.export(exports, "has", ()=>has);
parcelHelpers.export(exports, "isArray", ()=>isArray);
parcelHelpers.export(exports, "isDefined", ()=>isDefined);
parcelHelpers.export(exports, "isFunction", ()=>isFunction);
parcelHelpers.export(exports, "isNil", ()=>isNil);
parcelHelpers.export(exports, "isNumber", ()=>isNumber);
parcelHelpers.export(exports, "isObject", ()=>isObject);
parcelHelpers.export(exports, "isString", ()=>isString);
parcelHelpers.export(exports, "isUndefined", ()=>isUndefined);
parcelHelpers.export(exports, "keys", ()=>keys);
parcelHelpers.export(exports, "map", ()=>map);
parcelHelpers.export(exports, "matchPattern", ()=>matchPattern);
parcelHelpers.export(exports, "merge", ()=>merge);
parcelHelpers.export(exports, "omit", ()=>omit);
parcelHelpers.export(exports, "pick", ()=>pick);
parcelHelpers.export(exports, "reduce", ()=>reduce);
parcelHelpers.export(exports, "set", ()=>set);
parcelHelpers.export(exports, "size", ()=>size);
parcelHelpers.export(exports, "some", ()=>some);
parcelHelpers.export(exports, "sortBy", ()=>sortBy);
parcelHelpers.export(exports, "throttle", ()=>throttle);
parcelHelpers.export(exports, "unionBy", ()=>unionBy);
parcelHelpers.export(exports, "uniqueBy", ()=>uniqueBy);
parcelHelpers.export(exports, "values", ()=>values);
parcelHelpers.export(exports, "without", ()=>without);
function flatten(arr) {
    return Array.prototype.concat.apply([], arr);
}
const nativeToString = Object.prototype.toString;
const nativeHasOwnProperty = Object.prototype.hasOwnProperty;
function isUndefined(obj) {
    return obj === undefined;
}
function isDefined(obj) {
    return obj !== undefined;
}
function isNil(obj) {
    return obj == null;
}
function isArray(obj) {
    return nativeToString.call(obj) === '[object Array]';
}
function isObject(obj) {
    return nativeToString.call(obj) === '[object Object]';
}
function isNumber(obj) {
    return nativeToString.call(obj) === '[object Number]';
}
/**
 * @param {any} obj
 *
 * @return {boolean}
 */ function isFunction(obj) {
    const tag = nativeToString.call(obj);
    return tag === '[object Function]' || tag === '[object AsyncFunction]' || tag === '[object GeneratorFunction]' || tag === '[object AsyncGeneratorFunction]' || tag === '[object Proxy]';
}
function isString(obj) {
    return nativeToString.call(obj) === '[object String]';
}
/**
 * Ensure collection is an array.
 *
 * @param {Object} obj
 */ function ensureArray(obj) {
    if (isArray(obj)) return;
    throw new Error('must supply array');
}
/**
 * Return true, if target owns a property with the given key.
 *
 * @param {Object} target
 * @param {String} key
 *
 * @return {Boolean}
 */ function has(target, key) {
    return !isNil(target) && nativeHasOwnProperty.call(target, key);
}
/**
 * @template T
 * @typedef { (
 *   ((e: T) => boolean) |
 *   ((e: T, idx: number) => boolean) |
 *   ((e: T, key: string) => boolean) |
 *   string |
 *   number
 * ) } Matcher
 */ /**
 * @template T
 * @template U
 *
 * @typedef { (
 *   ((e: T) => U) | string | number
 * ) } Extractor
 */ /**
 * @template T
 * @typedef { (val: T, key: any) => boolean } MatchFn
 */ /**
 * @template T
 * @typedef { T[] } ArrayCollection
 */ /**
 * @template T
 * @typedef { { [key: string]: T } } StringKeyValueCollection
 */ /**
 * @template T
 * @typedef { { [key: number]: T } } NumberKeyValueCollection
 */ /**
 * @template T
 * @typedef { StringKeyValueCollection<T> | NumberKeyValueCollection<T> } KeyValueCollection
 */ /**
 * @template T
 * @typedef { KeyValueCollection<T> | ArrayCollection<T> } Collection
 */ /**
 * Find element in collection.
 *
 * @template T
 * @param {Collection<T>} collection
 * @param {Matcher<T>} matcher
 *
 * @return {Object}
 */ function find(collection, matcher) {
    const matchFn = toMatcher(matcher);
    let match;
    forEach(collection, function(val, key) {
        if (matchFn(val, key)) {
            match = val;
            return false;
        }
    });
    return match;
}
/**
 * Find element index in collection.
 *
 * @template T
 * @param {Collection<T>} collection
 * @param {Matcher<T>} matcher
 *
 * @return {number | string | undefined}
 */ function findIndex(collection, matcher) {
    const matchFn = toMatcher(matcher);
    let idx = isArray(collection) ? -1 : undefined;
    forEach(collection, function(val, key) {
        if (matchFn(val, key)) {
            idx = key;
            return false;
        }
    });
    return idx;
}
/**
 * Filter elements in collection.
 *
 * @template T
 * @param {Collection<T>} collection
 * @param {Matcher<T>} matcher
 *
 * @return {T[]} result
 */ function filter(collection, matcher) {
    const matchFn = toMatcher(matcher);
    let result = [];
    forEach(collection, function(val, key) {
        if (matchFn(val, key)) result.push(val);
    });
    return result;
}
/**
 * Iterate over collection; returning something
 * (non-undefined) will stop iteration.
 *
 * @template T
 * @param {Collection<T>} collection
 * @param { ((item: T, idx: number) => (boolean|void)) | ((item: T, key: string) => (boolean|void)) } iterator
 *
 * @return {T} return result that stopped the iteration
 */ function forEach(collection, iterator) {
    let val, result;
    if (isUndefined(collection)) return;
    const convertKey = isArray(collection) ? toNum : identity;
    for(let key in collection)if (has(collection, key)) {
        val = collection[key];
        result = iterator(val, convertKey(key));
        if (result === false) return val;
    }
}
/**
 * Return collection without element.
 *
 * @template T
 * @param {ArrayCollection<T>} arr
 * @param {Matcher<T>} matcher
 *
 * @return {T[]}
 */ function without(arr, matcher) {
    if (isUndefined(arr)) return [];
    ensureArray(arr);
    const matchFn = toMatcher(matcher);
    return arr.filter(function(el, idx) {
        return !matchFn(el, idx);
    });
}
/**
 * Reduce collection, returning a single result.
 *
 * @template T
 * @template V
 *
 * @param {Collection<T>} collection
 * @param {(result: V, entry: T, index: any) => V} iterator
 * @param {V} result
 *
 * @return {V} result returned from last iterator
 */ function reduce(collection, iterator, result) {
    forEach(collection, function(value, idx) {
        result = iterator(result, value, idx);
    });
    return result;
}
/**
 * Return true if every element in the collection
 * matches the criteria.
 *
 * @param  {Object|Array} collection
 * @param  {Function} matcher
 *
 * @return {Boolean}
 */ function every(collection, matcher) {
    return !!reduce(collection, function(matches, val, key) {
        return matches && matcher(val, key);
    }, true);
}
/**
 * Return true if some elements in the collection
 * match the criteria.
 *
 * @param  {Object|Array} collection
 * @param  {Function} matcher
 *
 * @return {Boolean}
 */ function some(collection, matcher) {
    return !!find(collection, matcher);
}
/**
 * Transform a collection into another collection
 * by piping each member through the given fn.
 *
 * @param  {Object|Array}   collection
 * @param  {Function} fn
 *
 * @return {Array} transformed collection
 */ function map(collection, fn) {
    let result = [];
    forEach(collection, function(val, key) {
        result.push(fn(val, key));
    });
    return result;
}
/**
 * Get the collections keys.
 *
 * @param  {Object|Array} collection
 *
 * @return {Array}
 */ function keys(collection) {
    return collection && Object.keys(collection) || [];
}
/**
 * Shorthand for `keys(o).length`.
 *
 * @param  {Object|Array} collection
 *
 * @return {Number}
 */ function size(collection) {
    return keys(collection).length;
}
/**
 * Get the values in the collection.
 *
 * @param  {Object|Array} collection
 *
 * @return {Array}
 */ function values(collection) {
    return map(collection, (val)=>val);
}
/**
 * Group collection members by attribute.
 *
 * @param {Object|Array} collection
 * @param {Extractor} extractor
 *
 * @return {Object} map with { attrValue => [ a, b, c ] }
 */ function groupBy(collection, extractor, grouped = {}) {
    extractor = toExtractor(extractor);
    forEach(collection, function(val) {
        let discriminator = extractor(val) || '_';
        let group = grouped[discriminator];
        if (!group) group = grouped[discriminator] = [];
        group.push(val);
    });
    return grouped;
}
function uniqueBy(extractor, ...collections) {
    extractor = toExtractor(extractor);
    let grouped = {};
    forEach(collections, (c)=>groupBy(c, extractor, grouped));
    let result = map(grouped, function(val, key) {
        return val[0];
    });
    return result;
}
const unionBy = uniqueBy;
/**
 * Sort collection by criteria.
 *
 * @template T
 *
 * @param {Collection<T>} collection
 * @param {Extractor<T, number | string>} extractor
 *
 * @return {Array}
 */ function sortBy(collection, extractor) {
    extractor = toExtractor(extractor);
    let sorted = [];
    forEach(collection, function(value, key) {
        let disc = extractor(value, key);
        let entry = {
            d: disc,
            v: value
        };
        for(var idx = 0; idx < sorted.length; idx++){
            let { d } = sorted[idx];
            if (disc < d) {
                sorted.splice(idx, 0, entry);
                return;
            }
        }
        // not inserted, append (!)
        sorted.push(entry);
    });
    return map(sorted, (e)=>e.v);
}
/**
 * Create an object pattern matcher.
 *
 * @example
 *
 * ```javascript
 * const matcher = matchPattern({ id: 1 });
 *
 * let element = find(elements, matcher);
 * ```
 *
 * @template T
 *
 * @param {T} pattern
 *
 * @return { (el: any) =>  boolean } matcherFn
 */ function matchPattern(pattern) {
    return function(el) {
        return every(pattern, function(val, key) {
            return el[key] === val;
        });
    };
}
/**
 * @param {string | ((e: any) => any) } extractor
 *
 * @return { (e: any) => any }
 */ function toExtractor(extractor) {
    /**
   * @satisfies { (e: any) => any }
   */ return isFunction(extractor) ? extractor : (e)=>{
        // @ts-ignore: just works
        return e[extractor];
    };
}
/**
 * @template T
 * @param {Matcher<T>} matcher
 *
 * @return {MatchFn<T>}
 */ function toMatcher(matcher) {
    return isFunction(matcher) ? matcher : (e)=>{
        return e === matcher;
    };
}
function identity(arg) {
    return arg;
}
function toNum(arg) {
    return Number(arg);
}
/* global setTimeout clearTimeout */ /**
 * @typedef { {
 *   (...args: any[]): any;
 *   flush: () => void;
 *   cancel: () => void;
 * } } DebouncedFunction
 */ /**
 * Debounce fn, calling it only once if the given time
 * elapsed between calls.
 *
 * Lodash-style the function exposes methods to `#clear`
 * and `#flush` to control internal behavior.
 *
 * @param  {Function} fn
 * @param  {Number} timeout
 *
 * @return {DebouncedFunction} debounced function
 */ function debounce(fn, timeout) {
    let timer;
    let lastArgs;
    let lastThis;
    let lastNow;
    function fire(force) {
        let now = Date.now();
        let scheduledDiff = force ? 0 : lastNow + timeout - now;
        if (scheduledDiff > 0) return schedule(scheduledDiff);
        fn.apply(lastThis, lastArgs);
        clear();
    }
    function schedule(timeout) {
        timer = setTimeout(fire, timeout);
    }
    function clear() {
        if (timer) clearTimeout(timer);
        timer = lastNow = lastArgs = lastThis = undefined;
    }
    function flush() {
        if (timer) fire(true);
        clear();
    }
    /**
   * @type { DebouncedFunction }
   */ function callback(...args) {
        lastNow = Date.now();
        lastArgs = args;
        lastThis = this;
        // ensure an execution is scheduled
        if (!timer) schedule(timeout);
    }
    callback.flush = flush;
    callback.cancel = clear;
    return callback;
}
/**
 * Throttle fn, calling at most once
 * in the given interval.
 *
 * @param  {Function} fn
 * @param  {Number} interval
 *
 * @return {Function} throttled function
 */ function throttle(fn, interval) {
    let throttling = false;
    return function(...args) {
        if (throttling) return;
        fn(...args);
        throttling = true;
        setTimeout(()=>{
            throttling = false;
        }, interval);
    };
}
/**
 * Bind function against target <this>.
 *
 * @param  {Function} fn
 * @param  {Object}   target
 *
 * @return {Function} bound function
 */ function bind(fn, target) {
    return fn.bind(target);
}
/**
 * Convenience wrapper for `Object.assign`.
 *
 * @param {Object} target
 * @param {...Object} others
 *
 * @return {Object} the target
 */ function assign(target, ...others) {
    return Object.assign(target, ...others);
}
/**
 * Sets a nested property of a given object to the specified value.
 *
 * This mutates the object and returns it.
 *
 * @template T
 *
 * @param {T} target The target of the set operation.
 * @param {(string|number)[]} path The path to the nested value.
 * @param {any} value The value to set.
 *
 * @return {T}
 */ function set(target, path, value) {
    let currentTarget = target;
    forEach(path, function(key, idx) {
        if (typeof key !== 'number' && typeof key !== 'string') throw new Error('illegal key type: ' + typeof key + '. Key should be of type number or string.');
        if (key === 'constructor') throw new Error('illegal key: constructor');
        if (key === '__proto__') throw new Error('illegal key: __proto__');
        let nextKey = path[idx + 1];
        let nextTarget = currentTarget[key];
        if (isDefined(nextKey) && isNil(nextTarget)) nextTarget = currentTarget[key] = isNaN(+nextKey) ? {} : [];
        if (isUndefined(nextKey)) {
            if (isUndefined(value)) delete currentTarget[key];
            else currentTarget[key] = value;
        } else currentTarget = nextTarget;
    });
    return target;
}
/**
 * Gets a nested property of a given object.
 *
 * @param {Object} target The target of the get operation.
 * @param {(string|number)[]} path The path to the nested value.
 * @param {any} [defaultValue] The value to return if no value exists.
 *
 * @return {any}
 */ function get(target, path, defaultValue) {
    let currentTarget = target;
    forEach(path, function(key) {
        // accessing nil property yields <undefined>
        if (isNil(currentTarget)) {
            currentTarget = undefined;
            return false;
        }
        currentTarget = currentTarget[key];
    });
    return isUndefined(currentTarget) ? defaultValue : currentTarget;
}
/**
 * Pick properties from the given target.
 *
 * @template T
 * @template {any[]} V
 *
 * @param {T} target
 * @param {V} properties
 *
 * @return Pick<T, V>
 */ function pick(target, properties) {
    let result = {};
    let obj = Object(target);
    forEach(properties, function(prop) {
        if (prop in obj) result[prop] = target[prop];
    });
    return result;
}
/**
 * Pick all target properties, excluding the given ones.
 *
 * @template T
 * @template {any[]} V
 *
 * @param {T} target
 * @param {V} properties
 *
 * @return {Omit<T, V>} target
 */ function omit(target, properties) {
    let result = {};
    let obj = Object(target);
    forEach(obj, function(prop, key) {
        if (properties.indexOf(key) === -1) result[key] = prop;
    });
    return result;
}
/**
 * Recursively merge `...sources` into given target.
 *
 * Does support merging objects; does not support merging arrays.
 *
 * @param {Object} target
 * @param {...Object} sources
 *
 * @return {Object} the target
 */ function merge(target, ...sources) {
    if (!sources.length) return target;
    forEach(sources, function(source) {
        // skip non-obj sources, i.e. null
        if (!source || !isObject(source)) return;
        forEach(source, function(sourceVal, key) {
            if (key === '__proto__') return;
            let targetVal = target[key];
            if (isObject(sourceVal)) {
                if (!isObject(targetVal)) // override target[key] with object
                targetVal = {};
                target[key] = merge(targetVal, sourceVal);
            } else target[key] = sourceVal;
        });
    });
    return target;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"e58GC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "assignStyle", ()=>assign);
parcelHelpers.export(exports, "attr", ()=>attr);
parcelHelpers.export(exports, "classes", ()=>classes);
parcelHelpers.export(exports, "clear", ()=>clear);
parcelHelpers.export(exports, "closest", ()=>closest);
parcelHelpers.export(exports, "delegate", ()=>delegate);
parcelHelpers.export(exports, "domify", ()=>domify$1);
parcelHelpers.export(exports, "event", ()=>event);
parcelHelpers.export(exports, "matches", ()=>matches);
parcelHelpers.export(exports, "query", ()=>query);
parcelHelpers.export(exports, "queryAll", ()=>all);
parcelHelpers.export(exports, "remove", ()=>remove);
function _mergeNamespaces(n, m) {
    m.forEach(function(e) {
        e && typeof e !== 'string' && !Array.isArray(e) && Object.keys(e).forEach(function(k) {
            if (k !== 'default' && !(k in n)) {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function() {
                        return e[k];
                    }
                });
            }
        });
    });
    return Object.freeze(n);
}
/**
 * Flatten array, one level deep.
 *
 * @template T
 *
 * @param {T[][] | T[] | null} [arr]
 *
 * @return {T[]}
 */ const nativeToString = Object.prototype.toString;
const nativeHasOwnProperty = Object.prototype.hasOwnProperty;
function isUndefined(obj) {
    return obj === undefined;
}
function isArray(obj) {
    return nativeToString.call(obj) === '[object Array]';
}
/**
 * Return true, if target owns a property with the given key.
 *
 * @param {Object} target
 * @param {String} key
 *
 * @return {Boolean}
 */ function has(target, key) {
    return nativeHasOwnProperty.call(target, key);
}
/**
 * Iterate over collection; returning something
 * (non-undefined) will stop iteration.
 *
 * @template T
 * @param {Collection<T>} collection
 * @param { ((item: T, idx: number) => (boolean|void)) | ((item: T, key: string) => (boolean|void)) } iterator
 *
 * @return {T} return result that stopped the iteration
 */ function forEach(collection, iterator) {
    let val, result;
    if (isUndefined(collection)) return;
    const convertKey = isArray(collection) ? toNum : identity;
    for(let key in collection)if (has(collection, key)) {
        val = collection[key];
        result = iterator(val, convertKey(key));
        if (result === false) return val;
    }
}
function identity(arg) {
    return arg;
}
function toNum(arg) {
    return Number(arg);
}
/**
 * Assigns style attributes in a style-src compliant way.
 *
 * @param {Element} element
 * @param {...Object} styleSources
 *
 * @return {Element} the element
 */ function assign(element, ...styleSources) {
    const target = element.style;
    forEach(styleSources, function(style) {
        if (!style) return;
        forEach(style, function(value, key) {
            target[key] = value;
        });
    });
    return element;
}
/**
 * Set attribute `name` to `val`, or get attr `name`.
 *
 * @param {Element} el
 * @param {String} name
 * @param {String} [val]
 * @api public
 */ function attr(el, name, val) {
    // get
    if (arguments.length == 2) return el.getAttribute(name);
    // remove
    if (val === null) return el.removeAttribute(name);
    // set
    el.setAttribute(name, val);
    return el;
}
/**
 * Taken from https://github.com/component/classes
 *
 * Without the component bits.
 */ /**
 * toString reference.
 */ const toString = Object.prototype.toString;
/**
 * Wrap `el` in a `ClassList`.
 *
 * @param {Element} el
 * @return {ClassList}
 * @api public
 */ function classes(el) {
    return new ClassList(el);
}
/**
 * Initialize a new ClassList for `el`.
 *
 * @param {Element} el
 * @api private
 */ function ClassList(el) {
    if (!el || !el.nodeType) throw new Error('A DOM element reference is required');
    this.el = el;
    this.list = el.classList;
}
/**
 * Add class `name` if not already present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */ ClassList.prototype.add = function(name) {
    this.list.add(name);
    return this;
};
/**
 * Remove class `name` when present, or
 * pass a regular expression to remove
 * any which match.
 *
 * @param {String|RegExp} name
 * @return {ClassList}
 * @api public
 */ ClassList.prototype.remove = function(name) {
    if ('[object RegExp]' == toString.call(name)) return this.removeMatching(name);
    this.list.remove(name);
    return this;
};
/**
 * Remove all classes matching `re`.
 *
 * @param {RegExp} re
 * @return {ClassList}
 * @api private
 */ ClassList.prototype.removeMatching = function(re) {
    const arr = this.array();
    for(let i = 0; i < arr.length; i++)if (re.test(arr[i])) this.remove(arr[i]);
    return this;
};
/**
 * Toggle class `name`, can force state via `force`.
 *
 * For browsers that support classList, but do not support `force` yet,
 * the mistake will be detected and corrected.
 *
 * @param {String} name
 * @param {Boolean} force
 * @return {ClassList}
 * @api public
 */ ClassList.prototype.toggle = function(name, force) {
    if ('undefined' !== typeof force) {
        if (force !== this.list.toggle(name, force)) this.list.toggle(name); // toggle again to correct
    } else this.list.toggle(name);
    return this;
};
/**
 * Return an array of classes.
 *
 * @return {Array}
 * @api public
 */ ClassList.prototype.array = function() {
    return Array.from(this.list);
};
/**
 * Check if class `name` is present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */ ClassList.prototype.has = ClassList.prototype.contains = function(name) {
    return this.list.contains(name);
};
/**
 * Clear utility
 */ /**
 * Removes all children from the given element
 *
 * @param {Element} element
 *
 * @return {Element} the element (for chaining)
 */ function clear(element) {
    var child;
    while(child = element.firstChild)element.removeChild(child);
    return element;
}
/**
 * Closest
 *
 * @param {Element} el
 * @param {string} selector
 * @param {boolean} checkYourSelf (optional)
 */ function closest(element, selector, checkYourSelf) {
    var actualElement = checkYourSelf ? element : element.parentNode;
    return actualElement && typeof actualElement.closest === 'function' && actualElement.closest(selector) || null;
}
var componentEvent = {};
var bind$1, unbind$1, prefix;
function detect() {
    bind$1 = window.addEventListener ? 'addEventListener' : 'attachEvent';
    unbind$1 = window.removeEventListener ? 'removeEventListener' : 'detachEvent';
    prefix = bind$1 !== 'addEventListener' ? 'on' : '';
}
/**
 * Bind `el` event `type` to `fn`.
 *
 * @param {Element} el
 * @param {String} type
 * @param {Function} fn
 * @param {Boolean} capture
 * @return {Function}
 * @api public
 */ var bind_1 = componentEvent.bind = function(el, type, fn, capture) {
    if (!bind$1) detect();
    el[bind$1](prefix + type, fn, capture || false);
    return fn;
};
/**
 * Unbind `el` event `type`'s callback `fn`.
 *
 * @param {Element} el
 * @param {String} type
 * @param {Function} fn
 * @param {Boolean} capture
 * @return {Function}
 * @api public
 */ var unbind_1 = componentEvent.unbind = function(el, type, fn, capture) {
    if (!unbind$1) detect();
    el[unbind$1](prefix + type, fn, capture || false);
    return fn;
};
var event = /*#__PURE__*/ _mergeNamespaces({
    __proto__: null,
    bind: bind_1,
    unbind: unbind_1,
    'default': componentEvent
}, [
    componentEvent
]);
/**
 * Module dependencies.
 */ /**
 * Delegate event `type` to `selector`
 * and invoke `fn(e)`. A callback function
 * is returned which may be passed to `.unbind()`.
 *
 * @param {Element} el
 * @param {String} selector
 * @param {String} type
 * @param {Function} fn
 * @param {Boolean} capture
 * @return {Function}
 * @api public
 */ // Some events don't bubble, so we want to bind to the capture phase instead
// when delegating.
var forceCaptureEvents = [
    'focus',
    'blur'
];
function bind(el, selector, type, fn, capture) {
    if (forceCaptureEvents.indexOf(type) !== -1) capture = true;
    return event.bind(el, type, function(e) {
        var target = e.target || e.srcElement;
        e.delegateTarget = closest(target, selector, true);
        if (e.delegateTarget) fn.call(el, e);
    }, capture);
}
/**
 * Unbind event `type`'s callback `fn`.
 *
 * @param {Element} el
 * @param {String} type
 * @param {Function} fn
 * @param {Boolean} capture
 * @api public
 */ function unbind(el, type, fn, capture) {
    if (forceCaptureEvents.indexOf(type) !== -1) capture = true;
    return event.unbind(el, type, fn, capture);
}
var delegate = {
    bind,
    unbind
};
/**
 * Expose `parse`.
 */ var domify = parse;
/**
 * Tests for browser support.
 */ var innerHTMLBug = false;
var bugTestDiv;
if (typeof document !== 'undefined') {
    bugTestDiv = document.createElement('div');
    // Setup
    bugTestDiv.innerHTML = '  <link/><table></table><a href="/a">a</a><input type="checkbox"/>';
    // Make sure that link elements get serialized correctly by innerHTML
    // This requires a wrapper element in IE
    innerHTMLBug = !bugTestDiv.getElementsByTagName('link').length;
    bugTestDiv = undefined;
}
/**
 * Wrap map from jquery.
 */ var map = {
    legend: [
        1,
        '<fieldset>',
        '</fieldset>'
    ],
    tr: [
        2,
        '<table><tbody>',
        '</tbody></table>'
    ],
    col: [
        2,
        '<table><tbody></tbody><colgroup>',
        '</colgroup></table>'
    ],
    // for script/link/style tags to work in IE6-8, you have to wrap
    // in a div with a non-whitespace character in front, ha!
    _default: innerHTMLBug ? [
        1,
        'X<div>',
        '</div>'
    ] : [
        0,
        '',
        ''
    ]
};
map.td = map.th = [
    3,
    '<table><tbody><tr>',
    '</tr></tbody></table>'
];
map.option = map.optgroup = [
    1,
    '<select multiple="multiple">',
    '</select>'
];
map.thead = map.tbody = map.colgroup = map.caption = map.tfoot = [
    1,
    '<table>',
    '</table>'
];
map.polyline = map.ellipse = map.polygon = map.circle = map.text = map.line = map.path = map.rect = map.g = [
    1,
    '<svg xmlns="http://www.w3.org/2000/svg" version="1.1">',
    '</svg>'
];
/**
 * Parse `html` and return a DOM Node instance, which could be a TextNode,
 * HTML DOM Node of some kind (<div> for example), or a DocumentFragment
 * instance, depending on the contents of the `html` string.
 *
 * @param {String} html - HTML string to "domify"
 * @param {Document} doc - The `document` instance to create the Node for
 * @return {DOMNode} the TextNode, DOM Node, or DocumentFragment instance
 * @api private
 */ function parse(html, doc) {
    if ('string' != typeof html) throw new TypeError('String expected');
    // default to the global `document` object
    if (!doc) doc = document;
    // tag name
    var m = /<([\w:]+)/.exec(html);
    if (!m) return doc.createTextNode(html);
    html = html.replace(/^\s+|\s+$/g, ''); // Remove leading/trailing whitespace
    var tag = m[1];
    // body support
    if (tag == 'body') {
        var el = doc.createElement('html');
        el.innerHTML = html;
        return el.removeChild(el.lastChild);
    }
    // wrap map
    var wrap = Object.prototype.hasOwnProperty.call(map, tag) ? map[tag] : map._default;
    var depth = wrap[0];
    var prefix = wrap[1];
    var suffix = wrap[2];
    var el = doc.createElement('div');
    el.innerHTML = prefix + html + suffix;
    while(depth--)el = el.lastChild;
    // one element
    if (el.firstChild == el.lastChild) return el.removeChild(el.firstChild);
    // several elements
    var fragment = doc.createDocumentFragment();
    while(el.firstChild)fragment.appendChild(el.removeChild(el.firstChild));
    return fragment;
}
var domify$1 = domify;
/**
 * @param { HTMLElement } element
 * @param { String } selector
 *
 * @return { boolean }
 */ function matches(element, selector) {
    return element && typeof element.matches === 'function' && element.matches(selector) || false;
}
function query(selector, el) {
    el = el || document;
    return el.querySelector(selector);
}
function all(selector, el) {
    el = el || document;
    return el.querySelectorAll(selector);
}
function remove(el) {
    el.parentNode && el.parentNode.removeChild(el);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6ZtXA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "append", ()=>append);
parcelHelpers.export(exports, "appendTo", ()=>appendTo);
parcelHelpers.export(exports, "attr", ()=>attr);
parcelHelpers.export(exports, "classes", ()=>classes);
parcelHelpers.export(exports, "clear", ()=>clear);
parcelHelpers.export(exports, "clone", ()=>clone);
parcelHelpers.export(exports, "create", ()=>create);
parcelHelpers.export(exports, "createMatrix", ()=>createMatrix);
parcelHelpers.export(exports, "createPoint", ()=>createPoint);
parcelHelpers.export(exports, "createTransform", ()=>createTransform);
parcelHelpers.export(exports, "innerSVG", ()=>innerSVG);
parcelHelpers.export(exports, "off", ()=>off);
parcelHelpers.export(exports, "on", ()=>on);
parcelHelpers.export(exports, "prepend", ()=>prepend);
parcelHelpers.export(exports, "prependTo", ()=>prependTo);
parcelHelpers.export(exports, "remove", ()=>remove);
parcelHelpers.export(exports, "replace", ()=>replace);
parcelHelpers.export(exports, "select", ()=>select);
parcelHelpers.export(exports, "selectAll", ()=>selectAll);
parcelHelpers.export(exports, "transform", ()=>transform);
function ensureImported(element, target) {
    if (element.ownerDocument !== target.ownerDocument) try {
        // may fail on webkit
        return target.ownerDocument.importNode(element, true);
    } catch (e) {
    // ignore
    }
    return element;
}
/**
 * appendTo utility
 */ /**
 * Append a node to a target element and return the appended node.
 *
 * @param  {SVGElement} element
 * @param  {SVGElement} target
 *
 * @return {SVGElement} the appended node
 */ function appendTo(element, target) {
    return target.appendChild(ensureImported(element, target));
}
/**
 * append utility
 */ /**
 * Append a node to an element
 *
 * @param  {SVGElement} element
 * @param  {SVGElement} node
 *
 * @return {SVGElement} the element
 */ function append(target, node) {
    appendTo(node, target);
    return target;
}
/**
 * attribute accessor utility
 */ var LENGTH_ATTR = 2;
var CSS_PROPERTIES = {
    'alignment-baseline': 1,
    'baseline-shift': 1,
    'clip': 1,
    'clip-path': 1,
    'clip-rule': 1,
    'color': 1,
    'color-interpolation': 1,
    'color-interpolation-filters': 1,
    'color-profile': 1,
    'color-rendering': 1,
    'cursor': 1,
    'direction': 1,
    'display': 1,
    'dominant-baseline': 1,
    'enable-background': 1,
    'fill': 1,
    'fill-opacity': 1,
    'fill-rule': 1,
    'filter': 1,
    'flood-color': 1,
    'flood-opacity': 1,
    'font': 1,
    'font-family': 1,
    'font-size': LENGTH_ATTR,
    'font-size-adjust': 1,
    'font-stretch': 1,
    'font-style': 1,
    'font-variant': 1,
    'font-weight': 1,
    'glyph-orientation-horizontal': 1,
    'glyph-orientation-vertical': 1,
    'image-rendering': 1,
    'kerning': 1,
    'letter-spacing': 1,
    'lighting-color': 1,
    'marker': 1,
    'marker-end': 1,
    'marker-mid': 1,
    'marker-start': 1,
    'mask': 1,
    'opacity': 1,
    'overflow': 1,
    'pointer-events': 1,
    'shape-rendering': 1,
    'stop-color': 1,
    'stop-opacity': 1,
    'stroke': 1,
    'stroke-dasharray': 1,
    'stroke-dashoffset': 1,
    'stroke-linecap': 1,
    'stroke-linejoin': 1,
    'stroke-miterlimit': 1,
    'stroke-opacity': 1,
    'stroke-width': LENGTH_ATTR,
    'text-anchor': 1,
    'text-decoration': 1,
    'text-rendering': 1,
    'unicode-bidi': 1,
    'visibility': 1,
    'word-spacing': 1,
    'writing-mode': 1
};
function getAttribute(node, name) {
    if (CSS_PROPERTIES[name]) return node.style[name];
    else return node.getAttributeNS(null, name);
}
function setAttribute(node, name, value) {
    var hyphenated = name.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
    var type = CSS_PROPERTIES[hyphenated];
    if (type) {
        // append pixel unit, unless present
        if (type === LENGTH_ATTR && typeof value === 'number') value = String(value) + 'px';
        node.style[hyphenated] = value;
    } else node.setAttributeNS(null, name, value);
}
function setAttributes(node, attrs) {
    var names = Object.keys(attrs), i, name;
    for(i = 0, name; name = names[i]; i++)setAttribute(node, name, attrs[name]);
}
/**
 * Gets or sets raw attributes on a node.
 *
 * @param  {SVGElement} node
 * @param  {Object} [attrs]
 * @param  {String} [name]
 * @param  {String} [value]
 *
 * @return {String}
 */ function attr(node, name, value) {
    if (typeof name === 'string') {
        if (value !== undefined) setAttribute(node, name, value);
        else return getAttribute(node, name);
    } else setAttributes(node, name);
    return node;
}
/**
 * Taken from https://github.com/component/classes
 *
 * Without the component bits.
 */ /**
 * toString reference.
 */ const toString = Object.prototype.toString;
/**
  * Wrap `el` in a `ClassList`.
  *
  * @param {Element} el
  * @return {ClassList}
  * @api public
  */ function classes(el) {
    return new ClassList(el);
}
function ClassList(el) {
    if (!el || !el.nodeType) throw new Error('A DOM element reference is required');
    this.el = el;
    this.list = el.classList;
}
/**
  * Add class `name` if not already present.
  *
  * @param {String} name
  * @return {ClassList}
  * @api public
  */ ClassList.prototype.add = function(name) {
    this.list.add(name);
    return this;
};
/**
  * Remove class `name` when present, or
  * pass a regular expression to remove
  * any which match.
  *
  * @param {String|RegExp} name
  * @return {ClassList}
  * @api public
  */ ClassList.prototype.remove = function(name) {
    if ('[object RegExp]' == toString.call(name)) return this.removeMatching(name);
    this.list.remove(name);
    return this;
};
/**
  * Remove all classes matching `re`.
  *
  * @param {RegExp} re
  * @return {ClassList}
  * @api private
  */ ClassList.prototype.removeMatching = function(re) {
    const arr = this.array();
    for(let i = 0; i < arr.length; i++)if (re.test(arr[i])) this.remove(arr[i]);
    return this;
};
/**
  * Toggle class `name`, can force state via `force`.
  *
  * For browsers that support classList, but do not support `force` yet,
  * the mistake will be detected and corrected.
  *
  * @param {String} name
  * @param {Boolean} force
  * @return {ClassList}
  * @api public
  */ ClassList.prototype.toggle = function(name, force) {
    if ('undefined' !== typeof force) {
        if (force !== this.list.toggle(name, force)) this.list.toggle(name); // toggle again to correct
    } else this.list.toggle(name);
    return this;
};
/**
  * Return an array of classes.
  *
  * @return {Array}
  * @api public
  */ ClassList.prototype.array = function() {
    return Array.from(this.list);
};
/**
  * Check if class `name` is present.
  *
  * @param {String} name
  * @return {ClassList}
  * @api public
  */ ClassList.prototype.has = ClassList.prototype.contains = function(name) {
    return this.list.contains(name);
};
/**
 * Clear utility
 */ /**
 * Removes all children from the given element
 *
 * @param  {SVGElement} element
 * @return {Element} the element (for chaining)
 */ function clear(element) {
    var child;
    while(child = element.firstChild)element.removeChild(child);
    return element;
}
function clone(element) {
    return element.cloneNode(true);
}
var ns = {
    svg: 'http://www.w3.org/2000/svg'
};
/**
 * DOM parsing utility
 */ var SVG_START = '<svg xmlns="' + ns.svg + '"';
function parse(svg) {
    var unwrap = false;
    // ensure we import a valid svg document
    if (svg.substring(0, 4) === '<svg') {
        if (svg.indexOf(ns.svg) === -1) svg = SVG_START + svg.substring(4);
    } else {
        // namespace svg
        svg = SVG_START + '>' + svg + '</svg>';
        unwrap = true;
    }
    var parsed = parseDocument(svg);
    if (!unwrap) return parsed;
    var fragment = document.createDocumentFragment();
    var parent = parsed.firstChild;
    while(parent.firstChild)fragment.appendChild(parent.firstChild);
    return fragment;
}
function parseDocument(svg) {
    var parser;
    // parse
    parser = new DOMParser();
    parser.async = false;
    return parser.parseFromString(svg, 'text/xml');
}
/**
 * Create utility for SVG elements
 */ /**
 * Create a specific type from name or SVG markup.
 *
 * @param {String} name the name or markup of the element
 * @param {Object} [attrs] attributes to set on the element
 *
 * @returns {SVGElement}
 */ function create(name, attrs) {
    var element;
    name = name.trim();
    if (name.charAt(0) === '<') {
        element = parse(name).firstChild;
        element = document.importNode(element, true);
    } else element = document.createElementNS(ns.svg, name);
    if (attrs) attr(element, attrs);
    return element;
}
/**
 * Events handling utility
 */ function on(node, event, listener, useCapture) {
    node.addEventListener(event, listener, useCapture);
}
function off(node, event, listener, useCapture) {
    node.removeEventListener(event, listener, useCapture);
}
/**
 * Geometry helpers
 */ // fake node used to instantiate svg geometry elements
var node = null;
function getNode() {
    if (node === null) node = create('svg');
    return node;
}
function extend(object, props) {
    var i, k, keys = Object.keys(props);
    for(i = 0; k = keys[i]; i++)object[k] = props[k];
    return object;
}
function createPoint(x, y) {
    var point = getNode().createSVGPoint();
    switch(arguments.length){
        case 0:
            return point;
        case 2:
            x = {
                x: x,
                y: y
            };
            break;
    }
    return extend(point, x);
}
/**
 * Create matrix via args.
 *
 * @example
 *
 * createMatrix({ a: 1, b: 1 });
 * createMatrix();
 * createMatrix(1, 2, 0, 0, 30, 20);
 *
 * @return {SVGMatrix}
 */ function createMatrix(a, b, c, d, e, f) {
    var matrix = getNode().createSVGMatrix();
    switch(arguments.length){
        case 0:
            return matrix;
        case 1:
            return extend(matrix, a);
        case 6:
            return extend(matrix, {
                a: a,
                b: b,
                c: c,
                d: d,
                e: e,
                f: f
            });
    }
}
function createTransform(matrix) {
    if (matrix) return getNode().createSVGTransformFromMatrix(matrix);
    else return getNode().createSVGTransform();
}
/**
 * Serialization util
 */ var TEXT_ENTITIES = /([&<>]{1})/g;
var ATTR_ENTITIES = /([&<>\n\r"]{1})/g;
var ENTITY_REPLACEMENT = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '\''
};
function escape(str, pattern) {
    function replaceFn(match, entity) {
        return ENTITY_REPLACEMENT[entity] || entity;
    }
    return str.replace(pattern, replaceFn);
}
function serialize(node, output) {
    var i, len, attrMap, attrNode, childNodes;
    switch(node.nodeType){
        // TEXT
        case 3:
            // replace special XML characters
            output.push(escape(node.textContent, TEXT_ENTITIES));
            break;
        // ELEMENT
        case 1:
            output.push('<', node.tagName);
            if (node.hasAttributes()) {
                attrMap = node.attributes;
                for(i = 0, len = attrMap.length; i < len; ++i){
                    attrNode = attrMap.item(i);
                    output.push(' ', attrNode.name, '="', escape(attrNode.value, ATTR_ENTITIES), '"');
                }
            }
            if (node.hasChildNodes()) {
                output.push('>');
                childNodes = node.childNodes;
                for(i = 0, len = childNodes.length; i < len; ++i)serialize(childNodes.item(i), output);
                output.push('</', node.tagName, '>');
            } else output.push('/>');
            break;
        // COMMENT
        case 8:
            output.push('<!--', escape(node.nodeValue, TEXT_ENTITIES), '-->');
            break;
        // CDATA
        case 4:
            output.push('<![CDATA[', node.nodeValue, ']]>');
            break;
        default:
            throw new Error('unable to handle node ' + node.nodeType);
    }
    return output;
}
/**
 * innerHTML like functionality for SVG elements.
 * based on innerSVG (https://code.google.com/p/innersvg)
 */ function set(element, svg) {
    var parsed = parse(svg);
    // clear element contents
    clear(element);
    if (!svg) return;
    if (!isFragment(parsed)) // extract <svg> from parsed document
    parsed = parsed.documentElement;
    var nodes = slice(parsed.childNodes);
    // import + append each node
    for(var i = 0; i < nodes.length; i++)appendTo(nodes[i], element);
}
function get(element) {
    var child = element.firstChild, output = [];
    while(child){
        serialize(child, output);
        child = child.nextSibling;
    }
    return output.join('');
}
function isFragment(node) {
    return node.nodeName === '#document-fragment';
}
function innerSVG(element, svg) {
    if (svg !== undefined) {
        try {
            set(element, svg);
        } catch (e) {
            throw new Error('error parsing SVG: ' + e.message);
        }
        return element;
    } else return get(element);
}
function slice(arr) {
    return Array.prototype.slice.call(arr);
}
/**
 * Selection utilities
 */ function select(node, selector) {
    return node.querySelector(selector);
}
function selectAll(node, selector) {
    var nodes = node.querySelectorAll(selector);
    return [].map.call(nodes, function(element) {
        return element;
    });
}
/**
 * prependTo utility
 */ /**
 * Prepend a node to a target element and return the prepended node.
 *
 * @param  {SVGElement} node
 * @param  {SVGElement} target
 *
 * @return {SVGElement} the prepended node
 */ function prependTo(node, target) {
    return target.insertBefore(ensureImported(node, target), target.firstChild || null);
}
/**
 * prepend utility
 */ /**
 * Prepend a node to a target element
 *
 * @param  {SVGElement} target
 * @param  {SVGElement} node
 *
 * @return {SVGElement} the target element
 */ function prepend(target, node) {
    prependTo(node, target);
    return target;
}
function remove(element) {
    var parent = element.parentNode;
    if (parent) parent.removeChild(element);
    return element;
}
/**
 * Replace utility
 */ function replace(element, replacement) {
    element.parentNode.replaceChild(ensureImported(replacement, element), element);
    return replacement;
}
/**
 * transform accessor utility
 */ function wrapMatrix(transformList, transform) {
    if (transform instanceof SVGMatrix) return transformList.createSVGTransformFromMatrix(transform);
    return transform;
}
function setTransforms(transformList, transforms) {
    var i, t;
    transformList.clear();
    for(i = 0; t = transforms[i]; i++)transformList.appendItem(wrapMatrix(transformList, t));
}
/**
 * Get or set the transforms on the given node.
 *
 * @param {SVGElement} node
 * @param  {SVGTransform|SVGMatrix|Array<SVGTransform|SVGMatrix>} [transforms]
 *
 * @return {SVGTransform} the consolidated transform
 */ function transform(node, transforms) {
    var transformList = node.transform.baseVal;
    if (transforms) {
        if (!Array.isArray(transforms)) transforms = [
            transforms
        ];
        setTransforms(transformList, transforms);
    }
    return transformList.consolidate();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9r90s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Diagram);
var _didi = require("didi");
var _core = require("./core");
var _coreDefault = parcelHelpers.interopDefault(_core);
/**
 * @typedef {import('didi').InjectionContext} InjectionContext
 * @typedef {import('didi').LocalsMap} LocalsMap
 * @typedef {import('didi').ModuleDeclaration} ModuleDeclaration
 *
 * @typedef {import('./Diagram').DiagramOptions} DiagramOptions
 */ /**
 * Bootstrap an injector from a list of modules, instantiating a number of default components
 *
 * @param {ModuleDeclaration[]} modules
 *
 * @return {Injector} a injector to use to access the components
 */ function bootstrap(modules) {
    var injector = new (0, _didi.Injector)(modules);
    injector.init();
    return injector;
}
/**
 * Creates an injector from passed options.
 *
 * @param {DiagramOptions} [options]
 *
 * @return {Injector}
 */ function createInjector(options) {
    options = options || {};
    var configModule = {
        'config': [
            'value',
            options
        ]
    };
    var modules = [
        configModule,
        (0, _coreDefault.default)
    ].concat(options.modules || []);
    return bootstrap(modules);
}
function Diagram(options, injector) {
    // create injector unless explicitly specified
    this.injector = injector = injector || createInjector(options);
    // API
    /**
   * Resolves a diagram service.
   *
   * @method Diagram#get
   *
   * @param {string} name The name of the service to get.
   * @param {boolean} [strict=true] If false, resolve missing services to null.
   */ this.get = injector.get;
    /**
   * Executes a function with its dependencies injected.
   *
   * @method Diagram#invoke
   *
   * @param {Function} fn The function to be executed.
   * @param {InjectionContext} [context] The context.
   * @param {LocalsMap} [locals] The locals.
   */ this.invoke = injector.invoke;
    // init
    // indicate via event
    /**
   * An event indicating that all plug-ins are loaded.
   *
   * Use this event to fire other events to interested plug-ins
   *
   * @memberOf Diagram
   *
   * @event diagram.init
   *
   * @example
   *
   * eventBus.on('diagram.init', function() {
   *   eventBus.fire('my-custom-event', { foo: 'BAR' });
   * });
   *
   * @type {Object}
   */ this.get('eventBus').fire('diagram.init');
}
/**
 * Destroys the diagram
 *
 * @method  Diagram#destroy
 */ Diagram.prototype.destroy = function() {
    this.get('eventBus').fire('diagram.destroy');
};
/**
 * Clear the diagram, removing all contents.
 */ Diagram.prototype.clear = function() {
    this.get('eventBus').fire('diagram.clear');
};

},{"didi":"2jp8N","./core":"jPmEh","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2jp8N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Injector", ()=>Injector);
parcelHelpers.export(exports, "annotate", ()=>annotate);
parcelHelpers.export(exports, "parseAnnotations", ()=>parseAnnotations);
const CLASS_PATTERN = /^class[ {]/;
/**
 * @param {function} fn
 *
 * @return {boolean}
 */ function isClass(fn) {
    return CLASS_PATTERN.test(fn.toString());
}
/**
 * @param {any} obj
 *
 * @return {boolean}
 */ function isArray(obj) {
    return Array.isArray(obj);
}
/**
 * @param {any} obj
 * @param {string} prop
 *
 * @return {boolean}
 */ function hasOwnProp(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
/**
 * @typedef {import('./index').InjectAnnotated } InjectAnnotated
 */ /**
 * @template T
 *
 * @params {[...string[], T] | ...string[], T} args
 *
 * @return {T & InjectAnnotated}
 */ function annotate(...args) {
    if (args.length === 1 && isArray(args[0])) args = args[0];
    args = [
        ...args
    ];
    const fn = args.pop();
    fn.$inject = args;
    return fn;
}
// Current limitations:
// - can't put into "function arg" comments
// function /* (no parenthesis like this) */ (){}
// function abc( /* xx (no parenthesis like this) */ a, b) {}
//
// Just put the comment before function or inside:
// /* (((this is fine))) */ function(a, b) {}
// function abc(a) { /* (((this is fine))) */}
//
// - can't reliably auto-annotate constructor; we'll match the
// first constructor(...) pattern found which may be the one
// of a nested class, too.
const CONSTRUCTOR_ARGS = /constructor\s*[^(]*\(\s*([^)]*)\)/m;
const FN_ARGS = /^(?:async\s+)?(?:function\s*[^(]*)?(?:\(\s*([^)]*)\)|(\w+))/m;
const FN_ARG = /\/\*([^*]*)\*\//m;
/**
 * @param {unknown} fn
 *
 * @return {string[]}
 */ function parseAnnotations(fn) {
    if (typeof fn !== 'function') throw new Error(`Cannot annotate "${fn}". Expected a function!`);
    const match = fn.toString().match(isClass(fn) ? CONSTRUCTOR_ARGS : FN_ARGS);
    // may parse class without constructor
    if (!match) return [];
    const args = match[1] || match[2];
    return args && args.split(',').map((arg)=>{
        const argMatch = arg.match(FN_ARG);
        return (argMatch && argMatch[1] || arg).trim();
    }) || [];
}
/**
 * @typedef { import('./index').ModuleDeclaration } ModuleDeclaration
 * @typedef { import('./index').ModuleDefinition } ModuleDefinition
 * @typedef { import('./index').InjectorContext } InjectorContext
 */ /**
 * Create a new injector with the given modules.
 *
 * @param {ModuleDefinition[]} modules
 * @param {InjectorContext} [parent]
 */ function Injector(modules, parent) {
    parent = parent || {
        get: function(name, strict) {
            currentlyResolving.push(name);
            if (strict === false) return null;
            else throw error(`No provider for "${name}"!`);
        }
    };
    const currentlyResolving = [];
    const providers = this._providers = Object.create(parent._providers || null);
    const instances = this._instances = Object.create(null);
    const self = instances.injector = this;
    const error = function(msg) {
        const stack = currentlyResolving.join(' -> ');
        currentlyResolving.length = 0;
        return new Error(stack ? `${msg} (Resolving: ${stack})` : msg);
    };
    /**
   * Return a named service.
   *
   * @param {string} name
   * @param {boolean} [strict=true] if false, resolve missing services to null
   *
   * @return {any}
   */ function get(name, strict) {
        if (!providers[name] && name.indexOf('.') !== -1) {
            const parts = name.split('.');
            let pivot = get(parts.shift());
            while(parts.length)pivot = pivot[parts.shift()];
            return pivot;
        }
        if (hasOwnProp(instances, name)) return instances[name];
        if (hasOwnProp(providers, name)) {
            if (currentlyResolving.indexOf(name) !== -1) {
                currentlyResolving.push(name);
                throw error('Cannot resolve circular dependency!');
            }
            currentlyResolving.push(name);
            instances[name] = providers[name][0](providers[name][1]);
            currentlyResolving.pop();
            return instances[name];
        }
        return parent.get(name, strict);
    }
    function fnDef(fn, locals) {
        if (typeof locals === 'undefined') locals = {};
        if (typeof fn !== 'function') {
            if (isArray(fn)) fn = annotate(fn.slice());
            else throw error(`Cannot invoke "${fn}". Expected a function!`);
        }
        const inject = fn.$inject || parseAnnotations(fn);
        const dependencies = inject.map((dep)=>{
            if (hasOwnProp(locals, dep)) return locals[dep];
            else return get(dep);
        });
        return {
            fn: fn,
            dependencies: dependencies
        };
    }
    function instantiate(Type) {
        const { fn, dependencies } = fnDef(Type);
        // instantiate var args constructor
        const Constructor = Function.prototype.bind.apply(fn, [
            null
        ].concat(dependencies));
        return new Constructor();
    }
    function invoke(func, context, locals) {
        const { fn, dependencies } = fnDef(func, locals);
        return fn.apply(context, dependencies);
    }
    /**
   * @param {Injector} childInjector
   *
   * @return {Function}
   */ function createPrivateInjectorFactory(childInjector) {
        return annotate((key)=>childInjector.get(key));
    }
    /**
   * @param {ModuleDefinition[]} modules
   * @param {string[]} [forceNewInstances]
   *
   * @return {Injector}
   */ function createChild(modules, forceNewInstances) {
        if (forceNewInstances && forceNewInstances.length) {
            const fromParentModule = Object.create(null);
            const matchedScopes = Object.create(null);
            const privateInjectorsCache = [];
            const privateChildInjectors = [];
            const privateChildFactories = [];
            let provider;
            let cacheIdx;
            let privateChildInjector;
            let privateChildInjectorFactory;
            for(let name in providers){
                provider = providers[name];
                if (forceNewInstances.indexOf(name) !== -1) {
                    if (provider[2] === 'private') {
                        cacheIdx = privateInjectorsCache.indexOf(provider[3]);
                        if (cacheIdx === -1) {
                            privateChildInjector = provider[3].createChild([], forceNewInstances);
                            privateChildInjectorFactory = createPrivateInjectorFactory(privateChildInjector);
                            privateInjectorsCache.push(provider[3]);
                            privateChildInjectors.push(privateChildInjector);
                            privateChildFactories.push(privateChildInjectorFactory);
                            fromParentModule[name] = [
                                privateChildInjectorFactory,
                                name,
                                'private',
                                privateChildInjector
                            ];
                        } else fromParentModule[name] = [
                            privateChildFactories[cacheIdx],
                            name,
                            'private',
                            privateChildInjectors[cacheIdx]
                        ];
                    } else fromParentModule[name] = [
                        provider[2],
                        provider[1]
                    ];
                    matchedScopes[name] = true;
                }
                if ((provider[2] === 'factory' || provider[2] === 'type') && provider[1].$scope) /* jshint -W083 */ forceNewInstances.forEach((scope)=>{
                    if (provider[1].$scope.indexOf(scope) !== -1) {
                        fromParentModule[name] = [
                            provider[2],
                            provider[1]
                        ];
                        matchedScopes[scope] = true;
                    }
                });
            }
            forceNewInstances.forEach((scope)=>{
                if (!matchedScopes[scope]) throw new Error('No provider for "' + scope + '". Cannot use provider from the parent!');
            });
            modules.unshift(fromParentModule);
        }
        return new Injector(modules, self);
    }
    const factoryMap = {
        factory: invoke,
        type: instantiate,
        value: function(value) {
            return value;
        }
    };
    /**
   * @param {ModuleDefinition} moduleDefinition
   * @param {Injector} injector
   */ function createInitializer(moduleDefinition, injector) {
        const initializers = moduleDefinition.__init__ || [];
        return function() {
            initializers.forEach((initializer)=>{
                // eagerly resolve component (fn or string)
                if (typeof initializer === 'string') injector.get(initializer);
                else injector.invoke(initializer);
            });
        };
    }
    /**
   * @param {ModuleDefinition} moduleDefinition
   */ function loadModule(moduleDefinition) {
        const moduleExports = moduleDefinition.__exports__;
        // private module
        if (moduleExports) {
            const nestedModules = moduleDefinition.__modules__;
            const clonedModule = Object.keys(moduleDefinition).reduce((clonedModule, key)=>{
                if (key !== '__exports__' && key !== '__modules__' && key !== '__init__' && key !== '__depends__') clonedModule[key] = moduleDefinition[key];
                return clonedModule;
            }, Object.create(null));
            const childModules = (nestedModules || []).concat(clonedModule);
            const privateInjector = createChild(childModules);
            const getFromPrivateInjector = annotate(function(key) {
                return privateInjector.get(key);
            });
            moduleExports.forEach(function(key) {
                providers[key] = [
                    getFromPrivateInjector,
                    key,
                    'private',
                    privateInjector
                ];
            });
            // ensure child injector initializes
            const initializers = (moduleDefinition.__init__ || []).slice();
            initializers.unshift(function() {
                privateInjector.init();
            });
            moduleDefinition = Object.assign({}, moduleDefinition, {
                __init__: initializers
            });
            return createInitializer(moduleDefinition, privateInjector);
        }
        // normal module
        Object.keys(moduleDefinition).forEach(function(key) {
            if (key === '__init__' || key === '__depends__') return;
            if (moduleDefinition[key][2] === 'private') {
                providers[key] = moduleDefinition[key];
                return;
            }
            const type = moduleDefinition[key][0];
            const value = moduleDefinition[key][1];
            providers[key] = [
                factoryMap[type],
                arrayUnwrap(type, value),
                type
            ];
        });
        return createInitializer(moduleDefinition, self);
    }
    /**
   * @param {ModuleDefinition[]} moduleDefinitions
   * @param {ModuleDefinition} moduleDefinition
   *
   * @return {ModuleDefinition[]}
   */ function resolveDependencies(moduleDefinitions, moduleDefinition) {
        if (moduleDefinitions.indexOf(moduleDefinition) !== -1) return moduleDefinitions;
        moduleDefinitions = (moduleDefinition.__depends__ || []).reduce(resolveDependencies, moduleDefinitions);
        if (moduleDefinitions.indexOf(moduleDefinition) !== -1) return moduleDefinitions;
        return moduleDefinitions.concat(moduleDefinition);
    }
    /**
   * @param {ModuleDefinition[]} moduleDefinitions
   *
   * @return { () => void } initializerFn
   */ function bootstrap(moduleDefinitions) {
        const initializers = moduleDefinitions.reduce(resolveDependencies, []).map(loadModule);
        let initialized = false;
        return function() {
            if (initialized) return;
            initialized = true;
            initializers.forEach((initializer)=>initializer());
        };
    }
    // public API
    this.get = get;
    this.invoke = invoke;
    this.instantiate = instantiate;
    this.createChild = createChild;
    // setup
    this.init = bootstrap(modules);
}
// helpers ///////////////
function arrayUnwrap(type, value) {
    if (type !== 'value' && isArray(value)) value = annotate(value.slice());
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jPmEh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _draw = require("../draw");
var _drawDefault = parcelHelpers.interopDefault(_draw);
var _canvas = require("./Canvas");
var _canvasDefault = parcelHelpers.interopDefault(_canvas);
var _elementRegistry = require("./ElementRegistry");
var _elementRegistryDefault = parcelHelpers.interopDefault(_elementRegistry);
var _elementFactory = require("./ElementFactory");
var _elementFactoryDefault = parcelHelpers.interopDefault(_elementFactory);
var _eventBus = require("./EventBus");
var _eventBusDefault = parcelHelpers.interopDefault(_eventBus);
var _graphicsFactory = require("./GraphicsFactory");
var _graphicsFactoryDefault = parcelHelpers.interopDefault(_graphicsFactory);
exports.default = {
    __depends__: [
        (0, _drawDefault.default)
    ],
    __init__: [
        'canvas'
    ],
    canvas: [
        'type',
        (0, _canvasDefault.default)
    ],
    elementRegistry: [
        'type',
        (0, _elementRegistryDefault.default)
    ],
    elementFactory: [
        'type',
        (0, _elementFactoryDefault.default)
    ],
    eventBus: [
        'type',
        (0, _eventBusDefault.default)
    ],
    graphicsFactory: [
        'type',
        (0, _graphicsFactoryDefault.default)
    ]
};

},{"../draw":"jg8Hc","./Canvas":"dp86J","./ElementRegistry":"42It9","./ElementFactory":"idaBX","./EventBus":"6zRvn","./GraphicsFactory":"8u1E7","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jg8Hc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defaultRenderer = require("./DefaultRenderer");
var _defaultRendererDefault = parcelHelpers.interopDefault(_defaultRenderer);
var _styles = require("./Styles");
var _stylesDefault = parcelHelpers.interopDefault(_styles);
exports.default = {
    __init__: [
        'defaultRenderer'
    ],
    defaultRenderer: [
        'type',
        (0, _defaultRendererDefault.default)
    ],
    styles: [
        'type',
        (0, _stylesDefault.default)
    ]
};

},{"./DefaultRenderer":"cJiTV","./Styles":"cQT9o","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cJiTV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DefaultRenderer);
var _inheritsBrowser = require("inherits-browser");
var _inheritsBrowserDefault = parcelHelpers.interopDefault(_inheritsBrowser);
var _baseRenderer = require("./BaseRenderer");
var _baseRendererDefault = parcelHelpers.interopDefault(_baseRenderer);
var _renderUtil = require("../util/RenderUtil");
var _tinySvg = require("tiny-svg");
var _minDash = require("min-dash");
var _elements = require("../util/Elements");
/**
 * @typedef {import('../core/EventBus').default} EventBus
 * @typedef {import('./Styles').default} Styles
 */ // apply default renderer with lowest possible priority
// so that it only kicks in if noone else could render
var DEFAULT_RENDER_PRIORITY = 1;
function DefaultRenderer(eventBus, styles) {
    //
    (0, _baseRendererDefault.default).call(this, eventBus, DEFAULT_RENDER_PRIORITY);
    this.CONNECTION_STYLE = styles.style([
        'no-fill'
    ], {
        strokeWidth: 5,
        stroke: 'fuchsia'
    });
    this.SHAPE_STYLE = styles.style({
        fill: 'white',
        stroke: 'fuchsia',
        strokeWidth: 2
    });
    this.FRAME_STYLE = styles.style([
        'no-fill'
    ], {
        stroke: 'fuchsia',
        strokeDasharray: 4,
        strokeWidth: 2
    });
}
(0, _inheritsBrowserDefault.default)(DefaultRenderer, (0, _baseRendererDefault.default));
DefaultRenderer.prototype.canRender = function() {
    return true;
};
DefaultRenderer.prototype.drawShape = function drawShape(visuals, element, attrs) {
    var rect = (0, _tinySvg.create)('rect');
    (0, _tinySvg.attr)(rect, {
        x: 0,
        y: 0,
        width: element.width || 0,
        height: element.height || 0
    });
    if ((0, _elements.isFrameElement)(element)) (0, _tinySvg.attr)(rect, (0, _minDash.assign)({}, this.FRAME_STYLE, attrs || {}));
    else (0, _tinySvg.attr)(rect, (0, _minDash.assign)({}, this.SHAPE_STYLE, attrs || {}));
    (0, _tinySvg.append)(visuals, rect);
    return rect;
};
DefaultRenderer.prototype.drawConnection = function drawConnection(visuals, connection, attrs) {
    var line = (0, _renderUtil.createLine)(connection.waypoints, (0, _minDash.assign)({}, this.CONNECTION_STYLE, attrs || {}));
    (0, _tinySvg.append)(visuals, line);
    return line;
};
DefaultRenderer.prototype.getShapePath = function getShapePath(shape) {
    var x = shape.x, y = shape.y, width = shape.width, height = shape.height;
    var shapePath = [
        [
            'M',
            x,
            y
        ],
        [
            'l',
            width,
            0
        ],
        [
            'l',
            0,
            height
        ],
        [
            'l',
            -width,
            0
        ],
        [
            'z'
        ]
    ];
    return (0, _renderUtil.componentsToPath)(shapePath);
};
DefaultRenderer.prototype.getConnectionPath = function getConnectionPath(connection) {
    var waypoints = connection.waypoints;
    var idx, point, connectionPath = [];
    for(idx = 0; point = waypoints[idx]; idx++){
        // take invisible docking into account
        // when creating the path
        point = point.original || point;
        connectionPath.push([
            idx === 0 ? 'M' : 'L',
            point.x,
            point.y
        ]);
    }
    return (0, _renderUtil.componentsToPath)(connectionPath);
};
DefaultRenderer.$inject = [
    'eventBus',
    'styles'
];

},{"inherits-browser":"hymxq","./BaseRenderer":"3CPtk","../util/RenderUtil":"iDpuc","tiny-svg":"6ZtXA","min-dash":"aEEla","../util/Elements":"6qdtl","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3CPtk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BaseRenderer);
var DEFAULT_RENDER_PRIORITY = 1000;
function BaseRenderer(eventBus, renderPriority) {
    var self = this;
    renderPriority = renderPriority || DEFAULT_RENDER_PRIORITY;
    eventBus.on([
        'render.shape',
        'render.connection'
    ], renderPriority, function(evt, context) {
        var type = evt.type, element = context.element, visuals = context.gfx, attrs = context.attrs;
        if (self.canRender(element)) {
            if (type === 'render.shape') return self.drawShape(visuals, element, attrs);
            else return self.drawConnection(visuals, element, attrs);
        }
    });
    eventBus.on([
        'render.getShapePath',
        'render.getConnectionPath'
    ], renderPriority, function(evt, element) {
        if (self.canRender(element)) {
            if (evt.type === 'render.getShapePath') return self.getShapePath(element);
            else return self.getConnectionPath(element);
        }
    });
}
/**
 * Checks whether an element can be rendered.
 *
 * @param {Base} element The element to be rendered.
 *
 * @returns {boolean} Whether the element can be rendered.
 */ BaseRenderer.prototype.canRender = function(element) {};
/**
 * Draws a shape.
 *
 * @param {SVGElement} visuals The SVG element to draw the shape into.
 * @param {Shape} shape The shape to be drawn.
 *
 * @returns {SVGElement} The SVG element of the shape drawn.
 */ BaseRenderer.prototype.drawShape = function(visuals, shape) {};
/**
 * Draws a connection.
 *
 * @param {SVGElement} visuals The SVG element to draw the connection into.
 * @param {Connection} connection The connection to be drawn.
 *
 * @returns {SVGElement} The SVG element of the connection drawn.
 */ BaseRenderer.prototype.drawConnection = function(visuals, connection) {};
/**
 * Gets the SVG path of the graphical representation of a shape.
 *
 * @param {Shape} shape The shape.
 *
 * @return {string} The SVG path of the shape.
 */ BaseRenderer.prototype.getShapePath = function(shape) {};
/**
 * Gets the SVG path of the graphical representation of a connection.
 *
 * @param {Connection} connection The connection.
 *
 * @return {string} The SVG path of the connection.
 */ BaseRenderer.prototype.getConnectionPath = function(connection) {};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iDpuc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @typedef {(string|number)[]} Component
 *
 * @typedef {import('../util/Types').Point} Point
 */ /**
 * @param {Component[]} elements
 *
 * @return {string}
 */ parcelHelpers.export(exports, "componentsToPath", ()=>componentsToPath);
parcelHelpers.export(exports, "toSVGPoints", ()=>toSVGPoints);
/**
 * @param {Point[]} points
 * @param {*} [attrs]
 * @param {number} [radius]
 *
 * @return {SVGElement}
 */ parcelHelpers.export(exports, "createLine", ()=>createLine);
/**
 * @param {SVGElement} gfx
 * @param {Point[]} points
 *
 * @return {SVGElement}
 */ parcelHelpers.export(exports, "updateLine", ()=>updateLine);
var _minDash = require("min-dash");
var _tinySvg = require("tiny-svg");
function componentsToPath(elements) {
    return elements.flat().join(',').replace(/,?([A-z]),?/g, '$1');
}
function toSVGPoints(points) {
    var result = '';
    for(var i = 0, p; p = points[i]; i++)result += p.x + ',' + p.y + ' ';
    return result;
}
function move(point) {
    return [
        'M',
        point.x,
        point.y
    ];
}
function lineTo(point) {
    return [
        'L',
        point.x,
        point.y
    ];
}
function curveTo(p1, p2, p3) {
    return [
        'C',
        p1.x,
        p1.y,
        p2.x,
        p2.y,
        p3.x,
        p3.y
    ];
}
function drawPath(waypoints, cornerRadius) {
    const pointCount = waypoints.length;
    const path = [
        move(waypoints[0])
    ];
    for(let i = 1; i < pointCount; i++){
        const pointBefore = waypoints[i - 1];
        const point = waypoints[i];
        const pointAfter = waypoints[i + 1];
        if (!pointAfter || !cornerRadius) {
            path.push(lineTo(point));
            continue;
        }
        const effectiveRadius = Math.min(cornerRadius, vectorLength(point.x - pointBefore.x, point.y - pointBefore.y), vectorLength(pointAfter.x - point.x, pointAfter.y - point.y));
        if (!effectiveRadius) {
            path.push(lineTo(point));
            continue;
        }
        const beforePoint = getPointAtLength(point, pointBefore, effectiveRadius);
        const beforePoint2 = getPointAtLength(point, pointBefore, effectiveRadius * .5);
        const afterPoint = getPointAtLength(point, pointAfter, effectiveRadius);
        const afterPoint2 = getPointAtLength(point, pointAfter, effectiveRadius * .5);
        path.push(lineTo(beforePoint));
        path.push(curveTo(beforePoint2, afterPoint2, afterPoint));
    }
    return path;
}
function getPointAtLength(start, end, length) {
    const deltaX = end.x - start.x;
    const deltaY = end.y - start.y;
    const totalLength = vectorLength(deltaX, deltaY);
    const percent = length / totalLength;
    return {
        x: start.x + deltaX * percent,
        y: start.y + deltaY * percent
    };
}
function vectorLength(x, y) {
    return Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));
}
function createLine(points, attrs, radius) {
    if ((0, _minDash.isNumber)(attrs)) {
        radius = attrs;
        attrs = null;
    }
    if (!attrs) attrs = {};
    const line = (0, _tinySvg.create)('path', attrs);
    if ((0, _minDash.isNumber)(radius)) line.dataset.cornerRadius = String(radius);
    return updateLine(line, points);
}
function updateLine(gfx, points) {
    const cornerRadius = parseInt(gfx.dataset.cornerRadius, 10) || 0;
    (0, _tinySvg.attr)(gfx, {
        d: componentsToPath(drawPath(points, cornerRadius))
    });
    return gfx;
}

},{"min-dash":"aEEla","tiny-svg":"6ZtXA","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6qdtl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @typedef {import('../../model').Base} Base
 * @typedef {import('../../model').Shape} Shape
 *
 * @typedef {import('../../type/Types').Rect} Rect
 */ /**
 * Get parent elements.
 *
 * @param {Base[]} elements
 *
 * @returns {Base[]}
 */ parcelHelpers.export(exports, "getParents", ()=>getParents);
/**
 * Adds an element to a collection and returns true if the
 * element was added.
 *
 * @param {Object[]} elements
 * @param {Object} e
 * @param {boolean} unique
 */ parcelHelpers.export(exports, "add", ()=>add);
/**
 * Iterate over each element in a collection, calling the iterator function `fn`
 * with (element, index, recursionDepth).
 *
 * Recurse into all elements that are returned by `fn`.
 *
 * @param {Object|Object[]} elements
 * @param {Function} fn iterator function called with (element, index, recursionDepth)
 * @param {number} [depth] maximum recursion depth
 */ parcelHelpers.export(exports, "eachElement", ()=>eachElement);
/**
 * Collects self + child elements up to a given depth from a list of elements.
 *
 * @param {Base|Base[]} elements the elements to select the children from
 * @param {boolean} unique whether to return a unique result set (no duplicates)
 * @param {number} maxDepth the depth to search through or -1 for infinite
 *
 * @return {Base[]} found elements
 */ parcelHelpers.export(exports, "selfAndChildren", ()=>selfAndChildren);
/**
 * Return self + direct children for a number of elements
 *
 * @param {Base[]} elements to query
 * @param {boolean} allowDuplicates to allow duplicates in the result set
 *
 * @return {Base[]} the collected elements
 */ parcelHelpers.export(exports, "selfAndDirectChildren", ()=>selfAndDirectChildren);
/**
 * Return self + ALL children for a number of elements
 *
 * @param {Base[]} elements to query
 * @param {boolean} allowDuplicates to allow duplicates in the result set
 *
 * @return {Base[]} the collected elements
 */ parcelHelpers.export(exports, "selfAndAllChildren", ()=>selfAndAllChildren);
/**
 * Gets the the closure for all selected elements,
 * their enclosed children and connections.
 *
 * @param {Base[]} elements
 * @param {boolean} [isTopLevel=true]
 * @param {Object} [existingClosure]
 *
 * @return {Object} newClosure
 */ parcelHelpers.export(exports, "getClosure", ()=>getClosure);
/**
 * Returns the surrounding bbox for all elements in
 * the array or the element primitive.
 *
 * @param {Base|Base[]} elements
 * @param {boolean} [stopRecursion=false]
 *
 * @return {Rect}
 */ parcelHelpers.export(exports, "getBBox", ()=>getBBox);
/**
 * Returns all elements that are enclosed from the bounding box.
 *
 *   * If bbox.(width|height) is not specified the method returns
 *     all elements with element.x/y > bbox.x/y
 *   * If only bbox.x or bbox.y is specified, method return all elements with
 *     e.x > bbox.x or e.y > bbox.y
 *
 * @param {Base[]} elements List of Elements to search through
 * @param {Rect} bbox the enclosing bbox.
 *
 * @return {Base[]} enclosed elements
 */ parcelHelpers.export(exports, "getEnclosedElements", ()=>getEnclosedElements);
parcelHelpers.export(exports, "getType", ()=>getType);
parcelHelpers.export(exports, "isFrameElement", ()=>isFrameElement);
var _minDash = require("min-dash");
function getParents(elements) {
    // find elements that are not children of any other elements
    return (0, _minDash.filter)(elements, function(element) {
        return !(0, _minDash.find)(elements, function(e) {
            return e !== element && getParent(element, e);
        });
    });
}
function getParent(element, parent) {
    if (!parent) return;
    if (element === parent) return parent;
    if (!element.parent) return;
    return getParent(element.parent, parent);
}
function add(elements, e, unique) {
    var canAdd = !unique || elements.indexOf(e) === -1;
    if (canAdd) elements.push(e);
    return canAdd;
}
function eachElement(elements, fn, depth) {
    depth = depth || 0;
    if (!(0, _minDash.isArray)(elements)) elements = [
        elements
    ];
    (0, _minDash.forEach)(elements, function(s, i) {
        var filter = fn(s, i, depth);
        if ((0, _minDash.isArray)(filter) && filter.length) eachElement(filter, fn, depth + 1);
    });
}
function selfAndChildren(elements, unique, maxDepth) {
    var result = [], processedChildren = [];
    eachElement(elements, function(element, i, depth) {
        add(result, element, unique);
        var children = element.children;
        // max traversal depth not reached yet
        if (maxDepth === -1 || depth < maxDepth) {
            // children exist && children not yet processed
            if (children && add(processedChildren, children, unique)) return children;
        }
    });
    return result;
}
function selfAndDirectChildren(elements, allowDuplicates) {
    return selfAndChildren(elements, !allowDuplicates, 1);
}
function selfAndAllChildren(elements, allowDuplicates) {
    return selfAndChildren(elements, !allowDuplicates, -1);
}
function getClosure(elements, isTopLevel, closure) {
    if ((0, _minDash.isUndefined)(isTopLevel)) isTopLevel = true;
    if ((0, _minDash.isObject)(isTopLevel)) {
        closure = isTopLevel;
        isTopLevel = true;
    }
    closure = closure || {};
    var allShapes = copyObject(closure.allShapes), allConnections = copyObject(closure.allConnections), enclosedElements = copyObject(closure.enclosedElements), enclosedConnections = copyObject(closure.enclosedConnections);
    var topLevel = copyObject(closure.topLevel, isTopLevel && (0, _minDash.groupBy)(elements, function(e) {
        return e.id;
    }));
    function handleConnection(c) {
        if (topLevel[c.source.id] && topLevel[c.target.id]) topLevel[c.id] = [
            c
        ];
        // not enclosed as a child, but maybe logically
        // (connecting two moved elements?)
        if (allShapes[c.source.id] && allShapes[c.target.id]) enclosedConnections[c.id] = enclosedElements[c.id] = c;
        allConnections[c.id] = c;
    }
    function handleElement(element) {
        enclosedElements[element.id] = element;
        if (element.waypoints) // remember connection
        enclosedConnections[element.id] = allConnections[element.id] = element;
        else {
            // remember shape
            allShapes[element.id] = element;
            // remember all connections
            (0, _minDash.forEach)(element.incoming, handleConnection);
            (0, _minDash.forEach)(element.outgoing, handleConnection);
            // recurse into children
            return element.children;
        }
    }
    eachElement(elements, handleElement);
    return {
        allShapes: allShapes,
        allConnections: allConnections,
        topLevel: topLevel,
        enclosedConnections: enclosedConnections,
        enclosedElements: enclosedElements
    };
}
function getBBox(elements, stopRecursion) {
    stopRecursion = !!stopRecursion;
    if (!(0, _minDash.isArray)(elements)) elements = [
        elements
    ];
    var minX, minY, maxX, maxY;
    (0, _minDash.forEach)(elements, function(element) {
        // If element is a connection the bbox must be computed first
        var bbox = element;
        if (element.waypoints && !stopRecursion) bbox = getBBox(element.waypoints, true);
        var x = bbox.x, y = bbox.y, height = bbox.height || 0, width = bbox.width || 0;
        if (x < minX || minX === undefined) minX = x;
        if (y < minY || minY === undefined) minY = y;
        if (x + width > maxX || maxX === undefined) maxX = x + width;
        if (y + height > maxY || maxY === undefined) maxY = y + height;
    });
    return {
        x: minX,
        y: minY,
        height: maxY - minY,
        width: maxX - minX
    };
}
function getEnclosedElements(elements, bbox) {
    var filteredElements = {};
    (0, _minDash.forEach)(elements, function(element) {
        var e = element;
        if (e.waypoints) e = getBBox(e);
        if (!(0, _minDash.isNumber)(bbox.y) && e.x > bbox.x) filteredElements[element.id] = element;
        if (!(0, _minDash.isNumber)(bbox.x) && e.y > bbox.y) filteredElements[element.id] = element;
        if (e.x > bbox.x && e.y > bbox.y) {
            if ((0, _minDash.isNumber)(bbox.width) && (0, _minDash.isNumber)(bbox.height) && e.width + e.x < bbox.width + bbox.x && e.height + e.y < bbox.height + bbox.y) filteredElements[element.id] = element;
            else if (!(0, _minDash.isNumber)(bbox.width) || !(0, _minDash.isNumber)(bbox.height)) filteredElements[element.id] = element;
        }
    });
    return filteredElements;
}
function getType(element) {
    if ('waypoints' in element) return 'connection';
    if ('x' in element) return 'shape';
    return 'root';
}
function isFrameElement(element) {
    return !!(element && element.isFrame);
}
// helpers ///////////////////////////////
function copyObject(src1, src2) {
    return (0, _minDash.assign)({}, src1 || {}, src2 || {});
}

},{"min-dash":"aEEla","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cQT9o":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Styles);
var _minDash = require("min-dash");
function Styles() {
    var defaultTraits = {
        'no-fill': {
            fill: 'none'
        },
        'no-border': {
            strokeOpacity: 0.0
        },
        'no-events': {
            pointerEvents: 'none'
        }
    };
    var self = this;
    /**
   * Builds a style definition from a className, a list of traits and an object of additional attributes.
   *
   * @param {string} className
   * @param {Array<string>} traits
   * @param {Object} additionalAttrs
   *
   * @return {Object} the style defintion
   */ this.cls = function(className, traits, additionalAttrs) {
        var attrs = this.style(traits, additionalAttrs);
        return (0, _minDash.assign)(attrs, {
            'class': className
        });
    };
    /**
   * Builds a style definition from a list of traits and an object of additional attributes.
   *
   * @param {Array<string>} traits
   * @param {Object} additionalAttrs
   *
   * @return {Object} the style defintion
   */ this.style = function(traits, additionalAttrs) {
        if (!(0, _minDash.isArray)(traits) && !additionalAttrs) {
            additionalAttrs = traits;
            traits = [];
        }
        var attrs = (0, _minDash.reduce)(traits, function(attrs, t) {
            return (0, _minDash.assign)(attrs, defaultTraits[t] || {});
        }, {});
        return additionalAttrs ? (0, _minDash.assign)(attrs, additionalAttrs) : attrs;
    };
    this.computeStyle = function(custom, traits, defaultStyles) {
        if (!(0, _minDash.isArray)(traits)) {
            defaultStyles = traits;
            traits = [];
        }
        return self.style(traits || [], (0, _minDash.assign)({}, defaultStyles, custom || {}));
    };
}

},{"min-dash":"aEEla","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dp86J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Canvas);
var _minDash = require("min-dash");
var _minDom = require("min-dom");
var _collections = require("../util/Collections");
var _elements = require("../util/Elements");
var _layoutUtil = require("../layout/LayoutUtil");
var _tinySvg = require("tiny-svg");
/**
 * @typedef {import('.').ConnectionLike} ConnectionLike
 * @typedef {import('.').RootLike} RootLike
 * @typedef {import('.').ShapeLike} ShapeLike
 *
 * @typedef {import('./Canvas').CanvasConfig} CanvasConfig
 * @typedef {import('./Canvas').CanvasLayer} CanvasLayer
 * @typedef {import('./Canvas').CanvasLayers} CanvasLayers
 * @typedef {import('./Canvas').CanvasPlane} CanvasPlane
 * @typedef {import('./Canvas').CanvasViewbox} CanvasViewbox
 *
 * @typedef {import('./ElementRegistry').default} ElementRegistry
 * @typedef {import('./EventBus').default} EventBus
 * @typedef {import('./GraphicsFactory').default} GraphicsFactory
 *
 * @typedef {import('../util/Types').Dimensions} Dimensions
 * @typedef {import('../util/Types').Point} Point
 * @typedef {import('../util/Types').Rect} Rect
 * @typedef {import('../util/Types').RectTRBL} RectTRBL
 */ function round(number, resolution) {
    return Math.round(number * resolution) / resolution;
}
function ensurePx(number) {
    return (0, _minDash.isNumber)(number) ? number + 'px' : number;
}
function findRoot(element) {
    while(element.parent)element = element.parent;
    return element;
}
/**
 * Creates a HTML container element for a SVG element with
 * the given configuration
 *
 * @param {CanvasConfig} options
 *
 * @return {HTMLElement} the container element
 */ function createContainer(options) {
    options = (0, _minDash.assign)({}, {
        width: '100%',
        height: '100%'
    }, options);
    const container = options.container || document.body;
    // create a <div> around the svg element with the respective size
    // this way we can always get the correct container size
    // (this is impossible for <svg> elements at the moment)
    const parent = document.createElement('div');
    parent.setAttribute('class', 'djs-container djs-parent');
    (0, _minDom.assignStyle)(parent, {
        position: 'relative',
        overflow: 'hidden',
        width: ensurePx(options.width),
        height: ensurePx(options.height)
    });
    container.appendChild(parent);
    return parent;
}
function createGroup(parent, cls, childIndex) {
    const group = (0, _tinySvg.create)('g');
    (0, _tinySvg.classes)(group).add(cls);
    const index = childIndex !== undefined ? childIndex : parent.childNodes.length - 1;
    // must ensure second argument is node or _null_
    // cf. https://developer.mozilla.org/en-US/docs/Web/API/Node/insertBefore
    parent.insertBefore(group, parent.childNodes[index] || null);
    return group;
}
const BASE_LAYER = 'base';
// render plane contents behind utility layers
const PLANE_LAYER_INDEX = 0;
const UTILITY_LAYER_INDEX = 1;
const REQUIRED_MODEL_ATTRS = {
    shape: [
        'x',
        'y',
        'width',
        'height'
    ],
    connection: [
        'waypoints'
    ]
};
function Canvas(config, eventBus, graphicsFactory, elementRegistry) {
    this._eventBus = eventBus;
    this._elementRegistry = elementRegistry;
    this._graphicsFactory = graphicsFactory;
    /**
   * @type {number}
   */ this._rootsIdx = 0;
    /**
   * @type {CanvasLayers}
   */ this._layers = {};
    /**
   * @type {CanvasPlane[]}
   */ this._planes = [];
    /**
   * @type {RootLike|null}
   */ this._rootElement = null;
    this._init(config || {});
}
Canvas.$inject = [
    'config.canvas',
    'eventBus',
    'graphicsFactory',
    'elementRegistry'
];
/**
 * Creates a <svg> element that is wrapped into a <div>.
 * This way we are always able to correctly figure out the size of the svg element
 * by querying the parent node.

 * (It is not possible to get the size of a svg element cross browser @ 2014-04-01)

 * <div class="djs-container" style="width: {desired-width}, height: {desired-height}">
 *   <svg width="100%" height="100%">
 *    ...
 *   </svg>
 * </div>
 *
 * @param {CanvasConfig} config
 */ Canvas.prototype._init = function(config) {
    const eventBus = this._eventBus;
    // html container
    const container = this._container = createContainer(config);
    const svg = this._svg = (0, _tinySvg.create)('svg');
    (0, _tinySvg.attr)(svg, {
        width: '100%',
        height: '100%'
    });
    (0, _tinySvg.append)(container, svg);
    const viewport = this._viewport = createGroup(svg, 'viewport');
    // debounce canvas.viewbox.changed events
    // for smoother diagram interaction
    if (config.deferUpdate !== false) this._viewboxChanged = (0, _minDash.debounce)((0, _minDash.bind)(this._viewboxChanged, this), 300);
    eventBus.on('diagram.init', ()=>{
        /**
     * An event indicating that the canvas is ready to be drawn on.
     *
     * @memberOf Canvas
     *
     * @event canvas.init
     *
     * @type {Object}
     * @property {SVGElement} svg the created svg element
     * @property {SVGElement} viewport the direct parent of diagram elements and shapes
     */ eventBus.fire('canvas.init', {
            svg: svg,
            viewport: viewport
        });
    });
    // reset viewbox on shape changes to
    // recompute the viewbox
    eventBus.on([
        'shape.added',
        'connection.added',
        'shape.removed',
        'connection.removed',
        'elements.changed',
        'root.set'
    ], ()=>{
        delete this._cachedViewbox;
    });
    eventBus.on('diagram.destroy', 500, this._destroy, this);
    eventBus.on('diagram.clear', 500, this._clear, this);
};
Canvas.prototype._destroy = function() {
    this._eventBus.fire('canvas.destroy', {
        svg: this._svg,
        viewport: this._viewport
    });
    const parent = this._container.parentNode;
    if (parent) parent.removeChild(this._container);
    delete this._svg;
    delete this._container;
    delete this._layers;
    delete this._planes;
    delete this._rootElement;
    delete this._viewport;
};
Canvas.prototype._clear = function() {
    const allElements = this._elementRegistry.getAll();
    // remove all elements
    allElements.forEach((element)=>{
        const type = (0, _elements.getType)(element);
        if (type === 'root') this.removeRootElement(element);
        else this._removeElement(element, type);
    });
    // remove all planes
    this._planes = [];
    this._rootElement = null;
    // force recomputation of view box
    delete this._cachedViewbox;
};
/**
 * Returns the default layer on which
 * all elements are drawn.
 *
 * @return {SVGElement}  The SVG element of the layer.
 */ Canvas.prototype.getDefaultLayer = function() {
    return this.getLayer(BASE_LAYER, PLANE_LAYER_INDEX);
};
/**
 * Returns a layer that is used to draw elements
 * or annotations on it.
 *
 * Non-existing layers retrieved through this method
 * will be created. During creation, the optional index
 * may be used to create layers below or above existing layers.
 * A layer with a certain index is always created above all
 * existing layers with the same index.
 *
 * @param {string} name The name of the layer.
 * @param {number} [index] The index of the layer.
 *
 * @return {SVGElement} The SVG element of the layer.
 */ Canvas.prototype.getLayer = function(name, index) {
    if (!name) throw new Error('must specify a name');
    let layer = this._layers[name];
    if (!layer) layer = this._layers[name] = this._createLayer(name, index);
    // throw an error if layer creation / retrival is
    // requested on different index
    if (typeof index !== 'undefined' && layer.index !== index) throw new Error('layer <' + name + '> already created at index <' + index + '>');
    return layer.group;
};
/**
 * For a given index, return the number of layers that have a higher index and
 * are visible.
 *
 * This is used to determine the node a layer should be inserted at.
 *
 * @param {number} index
 *
 * @return {number}
 */ Canvas.prototype._getChildIndex = function(index) {
    return (0, _minDash.reduce)(this._layers, function(childIndex, layer) {
        if (layer.visible && index >= layer.index) childIndex++;
        return childIndex;
    }, 0);
};
/**
 * Creates a given layer and returns it.
 *
 * @param {string} name
 * @param {number} [index=0]
 *
 * @return {CanvasLayer}
 */ Canvas.prototype._createLayer = function(name, index) {
    if (typeof index === 'undefined') index = UTILITY_LAYER_INDEX;
    const childIndex = this._getChildIndex(index);
    return {
        group: createGroup(this._viewport, 'layer-' + name, childIndex),
        index: index,
        visible: true
    };
};
/**
 * Shows a given layer.
 *
 * @param {string} layer The name of the layer.
 *
 * @return {SVGElement} The SVG element of the layer.
 */ Canvas.prototype.showLayer = function(name) {
    if (!name) throw new Error('must specify a name');
    const layer = this._layers[name];
    if (!layer) throw new Error('layer <' + name + '> does not exist');
    const viewport = this._viewport;
    const group = layer.group;
    const index = layer.index;
    if (layer.visible) return group;
    const childIndex = this._getChildIndex(index);
    viewport.insertBefore(group, viewport.childNodes[childIndex] || null);
    layer.visible = true;
    return group;
};
/**
 * Hides a given layer.
 *
 * @param {string} layer The name of the layer.
 *
 * @return {SVGElement} The SVG element of the layer.
 */ Canvas.prototype.hideLayer = function(name) {
    if (!name) throw new Error('must specify a name');
    const layer = this._layers[name];
    if (!layer) throw new Error('layer <' + name + '> does not exist');
    const group = layer.group;
    if (!layer.visible) return group;
    (0, _tinySvg.remove)(group);
    layer.visible = false;
    return group;
};
Canvas.prototype._removeLayer = function(name) {
    const layer = this._layers[name];
    if (layer) {
        delete this._layers[name];
        (0, _tinySvg.remove)(layer.group);
    }
};
/**
 * Returns the currently active layer. Can be null.
 *
 * @return {CanvasLayer|null} The active layer of `null`.
 */ Canvas.prototype.getActiveLayer = function() {
    const plane = this._findPlaneForRoot(this.getRootElement());
    if (!plane) return null;
    return plane.layer;
};
/**
 * Returns the plane which contains the given element.
 *
 * @param {ShapeLike|ConnectionLike|string} element The element or its ID.
 *
 * @return {RootLike|undefined} The root of the element.
 */ Canvas.prototype.findRoot = function(element) {
    if (typeof element === 'string') element = this._elementRegistry.get(element);
    if (!element) return;
    const plane = this._findPlaneForRoot(findRoot(element)) || {};
    return plane.rootElement;
};
/**
 * Return a list of all root elements on the diagram.
 *
 * @return {(RootLike)[]} The list of root elements.
 */ Canvas.prototype.getRootElements = function() {
    return this._planes.map(function(plane) {
        return plane.rootElement;
    });
};
Canvas.prototype._findPlaneForRoot = function(rootElement) {
    return (0, _minDash.find)(this._planes, function(plane) {
        return plane.rootElement === rootElement;
    });
};
/**
 * Returns the html element that encloses the
 * drawing canvas.
 *
 * @return {HTMLElement} The HTML element of the container.
 */ Canvas.prototype.getContainer = function() {
    return this._container;
};
// markers //////////////////////
Canvas.prototype._updateMarker = function(element, marker, add) {
    let container;
    if (!element.id) element = this._elementRegistry.get(element);
    // we need to access all
    container = this._elementRegistry._elements[element.id];
    if (!container) return;
    (0, _minDash.forEach)([
        container.gfx,
        container.secondaryGfx
    ], function(gfx) {
        if (gfx) {
            // invoke either addClass or removeClass based on mode
            if (add) (0, _tinySvg.classes)(gfx).add(marker);
            else (0, _tinySvg.classes)(gfx).remove(marker);
        }
    });
    /**
   * An event indicating that a marker has been updated for an element
   *
   * @event element.marker.update
   * @type {Object}
   * @property {Base} element the shape
   * @property {SVGElement} gfx the graphical representation of the shape
   * @property {string} marker
   * @property {boolean} add true if the marker was added, false if it got removed
   */ this._eventBus.fire('element.marker.update', {
        element: element,
        gfx: container.gfx,
        marker: marker,
        add: !!add
    });
};
/**
 * Adds a marker to an element (basically a css class).
 *
 * Fires the element.marker.update event, making it possible to
 * integrate extension into the marker life-cycle, too.
 *
 * @example
 *
 * canvas.addMarker('foo', 'some-marker');
 *
 * const fooGfx = canvas.getGraphics('foo');
 *
 * fooGfx; // <g class="... some-marker"> ... </g>
 *
 * @param {ShapeLike|ConnectionLike|string} element The element or its ID.
 * @param {string} marker The marker.
 */ Canvas.prototype.addMarker = function(element, marker) {
    this._updateMarker(element, marker, true);
};
/**
 * Remove a marker from an element.
 *
 * Fires the element.marker.update event, making it possible to
 * integrate extension into the marker life-cycle, too.
 *
 * @param {ShapeLike|ConnectionLike|string} element The element or its ID.
 * @param {string} marker The marker.
 */ Canvas.prototype.removeMarker = function(element, marker) {
    this._updateMarker(element, marker, false);
};
/**
 * Check whether an element has a given marker.
 *
 * @param {ShapeLike|ConnectionLike|string} element The element or its ID.
 * @param {string} marker The marker.
 */ Canvas.prototype.hasMarker = function(element, marker) {
    if (!element.id) element = this._elementRegistry.get(element);
    const gfx = this.getGraphics(element);
    return (0, _tinySvg.classes)(gfx).has(marker);
};
/**
 * Toggles a marker on an element.
 *
 * Fires the element.marker.update event, making it possible to
 * integrate extension into the marker life-cycle, too.
 *
 * @param {ShapeLike|ConnectionLike|string} element The element or its ID.
 * @param {string} marker The marker.
 */ Canvas.prototype.toggleMarker = function(element, marker) {
    if (this.hasMarker(element, marker)) this.removeMarker(element, marker);
    else this.addMarker(element, marker);
};
/**
 * Returns the current root element.
 *
 * Supports two different modes for handling root elements:
 *
 * 1. if no root element has been added before, an implicit root will be added
 * and returned. This is used in applications that don't require explicit
 * root elements.
 *
 * 2. when root elements have been added before calling `getRootElement`,
 * root elements can be null. This is used for applications that want to manage
 * root elements themselves.
 *
 * @return {RootLike} The current root element.
 */ Canvas.prototype.getRootElement = function() {
    const rootElement = this._rootElement;
    // can return null if root elements are present but none was set yet
    if (rootElement || this._planes.length) return rootElement;
    return this.setRootElement(this.addRootElement(null));
};
/**
 * Adds a given root element and returns it.
 *
 * @param {ShapeLike} [rootElement] The root element to be added.
 *
 * @return {RootLike} The added root element or an implicit root element.
 */ Canvas.prototype.addRootElement = function(rootElement) {
    const idx = this._rootsIdx++;
    if (!rootElement) rootElement = {
        id: '__implicitroot_' + idx,
        children: [],
        isImplicit: true
    };
    const layerName = rootElement.layer = 'root-' + idx;
    this._ensureValid('root', rootElement);
    const layer = this.getLayer(layerName, PLANE_LAYER_INDEX);
    this.hideLayer(layerName);
    this._addRoot(rootElement, layer);
    this._planes.push({
        rootElement: rootElement,
        layer: layer
    });
    return rootElement;
};
/**
 * Removes a given root element and returns it.
 *
 * @param {ShapeLike|string} rootElement The root element or its ID.
 *
 * @return {ShapeLike|undefined} The removed root element.
 */ Canvas.prototype.removeRootElement = function(rootElement) {
    if (typeof rootElement === 'string') rootElement = this._elementRegistry.get(rootElement);
    const plane = this._findPlaneForRoot(rootElement);
    if (!plane) return;
    // hook up life-cycle events
    this._removeRoot(rootElement);
    // clean up layer
    this._removeLayer(rootElement.layer);
    // clean up plane
    this._planes = this._planes.filter(function(plane) {
        return plane.rootElement !== rootElement;
    });
    // clean up active root
    if (this._rootElement === rootElement) this._rootElement = null;
    return rootElement;
};
/**
 * Sets a given element as the new root element for the canvas
 * and returns the new root element.
 *
 * @param {RootLike} rootElement The root element to be set.
 *
 * @return {RootLike} The set root element.
 */ Canvas.prototype.setRootElement = function(rootElement, override) {
    if ((0, _minDash.isDefined)(override)) throw new Error('override not supported');
    if (rootElement === this._rootElement) return;
    let plane;
    if (!rootElement) throw new Error('rootElement required');
    plane = this._findPlaneForRoot(rootElement);
    // give set add semantics for backwards compatibility
    if (!plane) rootElement = this.addRootElement(rootElement);
    this._setRoot(rootElement);
    return rootElement;
};
Canvas.prototype._removeRoot = function(element) {
    const elementRegistry = this._elementRegistry, eventBus = this._eventBus;
    // simulate element remove event sequence
    eventBus.fire('root.remove', {
        element: element
    });
    eventBus.fire('root.removed', {
        element: element
    });
    elementRegistry.remove(element);
};
Canvas.prototype._addRoot = function(element, gfx) {
    const elementRegistry = this._elementRegistry, eventBus = this._eventBus;
    // resemble element add event sequence
    eventBus.fire('root.add', {
        element: element
    });
    elementRegistry.add(element, gfx);
    eventBus.fire('root.added', {
        element: element,
        gfx: gfx
    });
};
Canvas.prototype._setRoot = function(rootElement, layer) {
    const currentRoot = this._rootElement;
    if (currentRoot) {
        // un-associate previous root element <svg>
        this._elementRegistry.updateGraphics(currentRoot, null, true);
        // hide previous layer
        this.hideLayer(currentRoot.layer);
    }
    if (rootElement) {
        if (!layer) layer = this._findPlaneForRoot(rootElement).layer;
        // associate element with <svg>
        this._elementRegistry.updateGraphics(rootElement, this._svg, true);
        // show root layer
        this.showLayer(rootElement.layer);
    }
    this._rootElement = rootElement;
    this._eventBus.fire('root.set', {
        element: rootElement
    });
};
Canvas.prototype._ensureValid = function(type, element) {
    if (!element.id) throw new Error('element must have an id');
    if (this._elementRegistry.get(element.id)) throw new Error('element <' + element.id + '> already exists');
    const requiredAttrs = REQUIRED_MODEL_ATTRS[type];
    const valid = (0, _minDash.every)(requiredAttrs, function(attr) {
        return typeof element[attr] !== 'undefined';
    });
    if (!valid) throw new Error('must supply { ' + requiredAttrs.join(', ') + ' } with ' + type);
};
Canvas.prototype._setParent = function(element, parent, parentIndex) {
    (0, _collections.add)(parent.children, element, parentIndex);
    element.parent = parent;
};
/**
 * Adds an element to the canvas.
 *
 * This wires the parent <-> child relationship between the element and
 * a explicitly specified parent or an implicit root element.
 *
 * During add it emits the events
 *
 *  * <{type}.add> (element, parent)
 *  * <{type}.added> (element, gfx)
 *
 * Extensions may hook into these events to perform their magic.
 *
 * @param {string} type
 * @param {ConnectionLike|ShapeLike} element
 * @param {ShapeLike} [parent]
 * @param {number} [parentIndex]
 *
 * @return {ConnectionLike|ShapeLike} The added element.
 */ Canvas.prototype._addElement = function(type, element, parent, parentIndex) {
    parent = parent || this.getRootElement();
    const eventBus = this._eventBus, graphicsFactory = this._graphicsFactory;
    this._ensureValid(type, element);
    eventBus.fire(type + '.add', {
        element: element,
        parent: parent
    });
    this._setParent(element, parent, parentIndex);
    // create graphics
    const gfx = graphicsFactory.create(type, element, parentIndex);
    this._elementRegistry.add(element, gfx);
    // update its visual
    graphicsFactory.update(type, element, gfx);
    eventBus.fire(type + '.added', {
        element: element,
        gfx: gfx
    });
    return element;
};
/**
 * Adds a shape to the canvas.
 *
 * @param {ShapeLike} shape The shape to be added
 * @param {ShapeLike} [parent] The shape's parent.
 * @param {number} [parentIndex] The index at which to add the shape to the parent's children.
 *
 * @return {ShapeLike} The added shape.
 */ Canvas.prototype.addShape = function(shape, parent, parentIndex) {
    return this._addElement('shape', shape, parent, parentIndex);
};
/**
 * Adds a connection to the canvas.
 *
 * @param {ConnectionLike} connection The connection to be added.
 * @param {ShapeLike} [parent] The connection's parent.
 * @param {number} [parentIndex] The index at which to add the connection to the parent's children.
 *
 * @return {ConnectionLike} The added connection.
 */ Canvas.prototype.addConnection = function(connection, parent, parentIndex) {
    return this._addElement('connection', connection, parent, parentIndex);
};
/**
 * Internal remove element
 */ Canvas.prototype._removeElement = function(element, type) {
    const elementRegistry = this._elementRegistry, graphicsFactory = this._graphicsFactory, eventBus = this._eventBus;
    element = elementRegistry.get(element.id || element);
    if (!element) // element was removed already
    return;
    eventBus.fire(type + '.remove', {
        element: element
    });
    graphicsFactory.remove(element);
    // unset parent <-> child relationship
    (0, _collections.remove)(element.parent && element.parent.children, element);
    element.parent = null;
    eventBus.fire(type + '.removed', {
        element: element
    });
    elementRegistry.remove(element);
    return element;
};
/**
 * Removes a shape from the canvas.
 *
 * @fires ShapeRemoveEvent
 * @fires ShapeRemovedEvent
 *
 * @param {ShapeLike|string} shape The shape or its ID.
 *
 * @return {ShapeLike} The removed shape.
 */ Canvas.prototype.removeShape = function(shape) {
    /**
   * An event indicating that a shape is about to be removed from the canvas.
   *
   * @memberOf Canvas
   *
   * @event ShapeRemoveEvent
   * @type {Object}
   * @property {ShapeLike} element The shape.
   * @property {SVGElement} gfx The graphical element.
   */ /**
   * An event indicating that a shape has been removed from the canvas.
   *
   * @memberOf Canvas
   *
   * @event ShapeRemoved
   * @type {Object}
   * @property {ShapeLike} element The shape.
   * @property {SVGElement} gfx The graphical element.
   */ return this._removeElement(shape, 'shape');
};
/**
 * Removes a connection from the canvas.
 *
 * @fires ConnectionRemoveEvent
 * @fires ConnectionRemovedEvent
 *
 * @param {ConnectionLike|string} connection The connection or its ID.
 *
 * @return {ConnectionLike} The removed connection.
 */ Canvas.prototype.removeConnection = function(connection) {
    /**
   * An event indicating that a connection is about to be removed from the canvas.
   *
   * @memberOf Canvas
   *
   * @event ConnectionRemoveEvent
   * @type {Object}
   * @property {ConnectionLike} element The connection.
   * @property {SVGElement} gfx The graphical element.
   */ /**
   * An event indicating that a connection has been removed from the canvas.
   *
   * @memberOf Canvas
   *
   * @event connection.removed
   * @type {Object}
   * @property {ConnectionLike} element The connection.
   * @property {SVGElement} gfx The graphical element.
   */ return this._removeElement(connection, 'connection');
};
/**
 * Returns the graphical element of an element.
 *
 * @param {ShapeLike|ConnectionLike|string} element The element or its ID.
 * @param {boolean} [secondary=false] Whether to return the secondary graphical element.
 *
 * @return {SVGElement} The graphical element.
 */ Canvas.prototype.getGraphics = function(element, secondary) {
    return this._elementRegistry.getGraphics(element, secondary);
};
/**
 * Perform a viewbox update via a given change function.
 *
 * @param {Function} changeFn
 */ Canvas.prototype._changeViewbox = function(changeFn) {
    // notify others of the upcoming viewbox change
    this._eventBus.fire('canvas.viewbox.changing');
    // perform actual change
    changeFn.apply(this);
    // reset the cached viewbox so that
    // a new get operation on viewbox or zoom
    // triggers a viewbox re-computation
    this._cachedViewbox = null;
    // notify others of the change; this step
    // may or may not be debounced
    this._viewboxChanged();
};
Canvas.prototype._viewboxChanged = function() {
    this._eventBus.fire('canvas.viewbox.changed', {
        viewbox: this.viewbox()
    });
};
/**
 * Gets or sets the view box of the canvas, i.e. the
 * area that is currently displayed.
 *
 * The getter may return a cached viewbox (if it is currently
 * changing). To force a recomputation, pass `false` as the first argument.
 *
 * @example
 *
 * canvas.viewbox({ x: 100, y: 100, width: 500, height: 500 })
 *
 * // sets the visible area of the diagram to (100|100) -> (600|100)
 * // and and scales it according to the diagram width
 *
 * const viewbox = canvas.viewbox(); // pass `false` to force recomputing the box.
 *
 * console.log(viewbox);
 * // {
 * //   inner: Dimensions,
 * //   outer: Dimensions,
 * //   scale,
 * //   x, y,
 * //   width, height
 * // }
 *
 * // if the current diagram is zoomed and scrolled, you may reset it to the
 * // default zoom via this method, too:
 *
 * const zoomedAndScrolledViewbox = canvas.viewbox();
 *
 * canvas.viewbox({
 *   x: 0,
 *   y: 0,
 *   width: zoomedAndScrolledViewbox.outer.width,
 *   height: zoomedAndScrolledViewbox.outer.height
 * });
 *
 * @param {Rect} [box] The viewbox to be set.
 *
 * @return {CanvasViewbox} The set viewbox.
 */ Canvas.prototype.viewbox = function(box) {
    if (box === undefined && this._cachedViewbox) return this._cachedViewbox;
    const viewport = this._viewport, outerBox = this.getSize();
    let innerBox, matrix, activeLayer, transform, scale, x, y;
    if (!box) {
        // compute the inner box based on the
        // diagrams active layer. This allows us to exclude
        // external components, such as overlays
        activeLayer = this._rootElement ? this.getActiveLayer() : null;
        innerBox = activeLayer && activeLayer.getBBox() || {};
        transform = (0, _tinySvg.transform)(viewport);
        matrix = transform ? transform.matrix : (0, _tinySvg.createMatrix)();
        scale = round(matrix.a, 1000);
        x = round(-matrix.e || 0, 1000);
        y = round(-matrix.f || 0, 1000);
        box = this._cachedViewbox = {
            x: x ? x / scale : 0,
            y: y ? y / scale : 0,
            width: outerBox.width / scale,
            height: outerBox.height / scale,
            scale: scale,
            inner: {
                width: innerBox.width || 0,
                height: innerBox.height || 0,
                x: innerBox.x || 0,
                y: innerBox.y || 0
            },
            outer: outerBox
        };
        return box;
    } else this._changeViewbox(function() {
        scale = Math.min(outerBox.width / box.width, outerBox.height / box.height);
        const matrix = this._svg.createSVGMatrix().scale(scale).translate(-box.x, -box.y);
        (0, _tinySvg.transform)(viewport, matrix);
    });
    return box;
};
/**
 * Gets or sets the scroll of the canvas.
 *
 * @param {Point} [delta] The scroll to be set.
 *
 * @return {Point}
 */ Canvas.prototype.scroll = function(delta) {
    const node = this._viewport;
    let matrix = node.getCTM();
    if (delta) this._changeViewbox(function() {
        delta = (0, _minDash.assign)({
            dx: 0,
            dy: 0
        }, delta || {});
        matrix = this._svg.createSVGMatrix().translate(delta.dx, delta.dy).multiply(matrix);
        setCTM(node, matrix);
    });
    return {
        x: matrix.e,
        y: matrix.f
    };
};
/**
 * Scrolls the viewbox to contain the given element.
 * Optionally specify a padding to be applied to the edges.
 *
 * @param {ShapeLike|ConnectionLike|string} element The element to scroll to or its ID.
 * @param {RectTRBL|number} [padding=100] The padding to be applied. Can also specify top, bottom, left and right.
 */ Canvas.prototype.scrollToElement = function(element, padding) {
    let defaultPadding = 100;
    if (typeof element === 'string') element = this._elementRegistry.get(element);
    // set to correct rootElement
    const rootElement = this.findRoot(element);
    if (rootElement !== this.getRootElement()) this.setRootElement(rootElement);
    if (!padding) padding = {};
    if (typeof padding === 'number') defaultPadding = padding;
    padding = {
        top: padding.top || defaultPadding,
        right: padding.right || defaultPadding,
        bottom: padding.bottom || defaultPadding,
        left: padding.left || defaultPadding
    };
    const elementBounds = (0, _elements.getBBox)(element), elementTrbl = (0, _layoutUtil.asTRBL)(elementBounds), viewboxBounds = this.viewbox(), zoom = this.zoom();
    let dx, dy;
    // shrink viewboxBounds with padding
    viewboxBounds.y += padding.top / zoom;
    viewboxBounds.x += padding.left / zoom;
    viewboxBounds.width -= (padding.right + padding.left) / zoom;
    viewboxBounds.height -= (padding.bottom + padding.top) / zoom;
    const viewboxTrbl = (0, _layoutUtil.asTRBL)(viewboxBounds);
    const canFit = elementBounds.width < viewboxBounds.width && elementBounds.height < viewboxBounds.height;
    if (!canFit) {
        // top-left when element can't fit
        dx = elementBounds.x - viewboxBounds.x;
        dy = elementBounds.y - viewboxBounds.y;
    } else {
        const dRight = Math.max(0, elementTrbl.right - viewboxTrbl.right), dLeft = Math.min(0, elementTrbl.left - viewboxTrbl.left), dBottom = Math.max(0, elementTrbl.bottom - viewboxTrbl.bottom), dTop = Math.min(0, elementTrbl.top - viewboxTrbl.top);
        dx = dRight || dLeft;
        dy = dBottom || dTop;
    }
    this.scroll({
        dx: -dx * zoom,
        dy: -dy * zoom
    });
};
/**
 * Gets or sets the current zoom of the canvas, optionally zooming to the
 * specified position.
 *
 * The getter may return a cached zoom level. Call it with `false` as the first
 * argument to force recomputation of the current level.
 *
 * @param {number|string} [newScale] The new zoom level, either a number,
 * i.e. 0.9, or `fit-viewport` to adjust the size to fit the current viewport.
 * @param {Point} [center] The reference point { x: ..., y: ...} to zoom to.
 *
 * @return {number} The set zoom level.
 */ Canvas.prototype.zoom = function(newScale, center) {
    if (!newScale) return this.viewbox(newScale).scale;
    if (newScale === 'fit-viewport') return this._fitViewport(center);
    let outer, matrix;
    this._changeViewbox(function() {
        if (typeof center !== 'object') {
            outer = this.viewbox().outer;
            center = {
                x: outer.width / 2,
                y: outer.height / 2
            };
        }
        matrix = this._setZoom(newScale, center);
    });
    return round(matrix.a, 1000);
};
function setCTM(node, m) {
    const mstr = 'matrix(' + m.a + ',' + m.b + ',' + m.c + ',' + m.d + ',' + m.e + ',' + m.f + ')';
    node.setAttribute('transform', mstr);
}
Canvas.prototype._fitViewport = function(center) {
    const vbox = this.viewbox(), outer = vbox.outer, inner = vbox.inner;
    let newScale, newViewbox;
    // display the complete diagram without zooming in.
    // instead of relying on internal zoom, we perform a
    // hard reset on the canvas viewbox to realize this
    //
    // if diagram does not need to be zoomed in, we focus it around
    // the diagram origin instead
    if (inner.x >= 0 && inner.y >= 0 && inner.x + inner.width <= outer.width && inner.y + inner.height <= outer.height && !center) newViewbox = {
        x: 0,
        y: 0,
        width: Math.max(inner.width + inner.x, outer.width),
        height: Math.max(inner.height + inner.y, outer.height)
    };
    else {
        newScale = Math.min(1, outer.width / inner.width, outer.height / inner.height);
        newViewbox = {
            x: inner.x + (center ? inner.width / 2 - outer.width / newScale / 2 : 0),
            y: inner.y + (center ? inner.height / 2 - outer.height / newScale / 2 : 0),
            width: outer.width / newScale,
            height: outer.height / newScale
        };
    }
    this.viewbox(newViewbox);
    return this.viewbox(false).scale;
};
Canvas.prototype._setZoom = function(scale, center) {
    const svg = this._svg, viewport = this._viewport;
    const matrix = svg.createSVGMatrix();
    const point = svg.createSVGPoint();
    let centerPoint, originalPoint, currentMatrix, scaleMatrix, newMatrix;
    currentMatrix = viewport.getCTM();
    const currentScale = currentMatrix.a;
    if (center) {
        centerPoint = (0, _minDash.assign)(point, center);
        // revert applied viewport transformations
        originalPoint = centerPoint.matrixTransform(currentMatrix.inverse());
        // create scale matrix
        scaleMatrix = matrix.translate(originalPoint.x, originalPoint.y).scale(1 / currentScale * scale).translate(-originalPoint.x, -originalPoint.y);
        newMatrix = currentMatrix.multiply(scaleMatrix);
    } else newMatrix = matrix.scale(scale);
    setCTM(this._viewport, newMatrix);
    return newMatrix;
};
/**
 * Returns the size of the canvas.
 *
 * @return {Dimensions} The size of the canvas.
 */ Canvas.prototype.getSize = function() {
    return {
        width: this._container.clientWidth,
        height: this._container.clientHeight
    };
};
/**
 * Returns the absolute bounding box of an element.
 *
 * The absolute bounding box may be used to display overlays in the callers
 * (browser) coordinate system rather than the zoomed in/out canvas coordinates.
 *
 * @param {ShapeLike|ConnectionLike} element The element.
 *
 * @return {Rect} The element's absolute bounding box.
 */ Canvas.prototype.getAbsoluteBBox = function(element) {
    const vbox = this.viewbox();
    let bbox;
    // connection
    // use svg bbox
    if (element.waypoints) {
        const gfx = this.getGraphics(element);
        bbox = gfx.getBBox();
    } else bbox = element;
    const x = bbox.x * vbox.scale - vbox.x * vbox.scale;
    const y = bbox.y * vbox.scale - vbox.y * vbox.scale;
    const width = bbox.width * vbox.scale;
    const height = bbox.height * vbox.scale;
    return {
        x: x,
        y: y,
        width: width,
        height: height
    };
};
/**
 * Fires an event so other modules can react to the canvas resizing.
 */ Canvas.prototype.resized = function() {
    // force recomputation of view box
    delete this._cachedViewbox;
    this._eventBus.fire('canvas.resized');
};

},{"min-dash":"aEEla","min-dom":"e58GC","../util/Collections":"kRUAD","../util/Elements":"6qdtl","../layout/LayoutUtil":"4CCrs","tiny-svg":"6ZtXA","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kRUAD":[function(require,module,exports,__globalThis) {
/**
 * Failsafe remove an element from a collection
 *
 * @param {Array<Object>} [collection]
 * @param {Object} [element]
 *
 * @return {number} the previous index of the element
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "remove", ()=>remove);
/**
 * Fail save add an element to the given connection, ensuring
 * it does not yet exist.
 *
 * @param {Array<Object>} collection
 * @param {Object} element
 * @param {number} idx
 */ parcelHelpers.export(exports, "add", ()=>add);
/**
 * Fail save get the index of an element in a collection.
 *
 * @param {Array<Object>} collection
 * @param {Object} element
 *
 * @return {number} the index or -1 if collection or element do
 *                  not exist or the element is not contained.
 */ parcelHelpers.export(exports, "indexOf", ()=>indexOf);
function remove(collection, element) {
    if (!collection || !element) return -1;
    var idx = collection.indexOf(element);
    if (idx !== -1) collection.splice(idx, 1);
    return idx;
}
function add(collection, element, idx) {
    if (!collection || !element) return;
    if (typeof idx !== 'number') idx = -1;
    var currentIdx = collection.indexOf(element);
    if (currentIdx !== -1) {
        if (currentIdx === idx) // nothing to do, position has not changed
        return;
        else {
            if (idx !== -1) // remove from current position
            collection.splice(currentIdx, 1);
            else // already exists in collection
            return;
        }
    }
    if (idx !== -1) // insert at specified position
    collection.splice(idx, 0, element);
    else // push to end
    collection.push(element);
}
function indexOf(collection, element) {
    if (!collection || !element) return -1;
    return collection.indexOf(element);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4CCrs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @typedef {import('../model').Connection} Connection
 *
 * @typedef {import('../util/Types').DirectionTRBL} DirectionTRBL
 * @typedef {import('../util/Types').Point} Point
 * @typedef {import('../util/Types').Rect} Rect
 * @typedef {import('../util/Types').RectTRBL} RectTRBL
 */ parcelHelpers.export(exports, "roundBounds", ()=>roundBounds);
parcelHelpers.export(exports, "roundPoint", ()=>roundPoint);
/**
 * Convert the given bounds to a { top, left, bottom, right } descriptor.
 *
 * @param {Point|Rect} bounds
 *
 * @return {RectTRBL}
 */ parcelHelpers.export(exports, "asTRBL", ()=>asTRBL);
/**
 * Convert a { top, left, bottom, right } to an objects bounds.
 *
 * @param {RectTRBL} trbl
 *
 * @return {Rect}
 */ parcelHelpers.export(exports, "asBounds", ()=>asBounds);
/**
 * Get the mid of the given bounds or point.
 *
 * @param {Point|Rect} bounds
 *
 * @return {Point}
 */ parcelHelpers.export(exports, "getBoundsMid", ()=>getBoundsMid);
/**
 * Get the mid of the given Connection.
 *
 * @param {Connection} connection
 *
 * @return {Point}
 */ parcelHelpers.export(exports, "getConnectionMid", ()=>getConnectionMid);
/**
 * Get the mid of the given Element.
 *
 * @param {Connection} connection
 *
 * @return {Point}
 */ parcelHelpers.export(exports, "getMid", ()=>getMid);
// orientation utils //////////////////////
/**
 * Get orientation of the given rectangle with respect to
 * the reference rectangle.
 *
 * A padding (positive or negative) may be passed to influence
 * horizontal / vertical orientation and intersection.
 *
 * @param {Rect} rect
 * @param {Rect} reference
 * @param {Point|number} padding
 *
 * @return {DirectionTRBL} the orientation; one of top, top-left, left, ..., bottom, right or intersect.
 */ parcelHelpers.export(exports, "getOrientation", ()=>getOrientation);
// intersection utils //////////////////////
/**
 * Get intersection between an element and a line path.
 *
 * @param {string} elementPath
 * @param {string} linePath
 * @param {boolean} cropStart Whether to crop start or end.
 *
 * @return {Point}
 */ parcelHelpers.export(exports, "getElementLineIntersection", ()=>getElementLineIntersection);
parcelHelpers.export(exports, "getIntersections", ()=>getIntersections);
parcelHelpers.export(exports, "filterRedundantWaypoints", ()=>filterRedundantWaypoints);
var _minDash = require("min-dash");
var _geometry = require("../util/Geometry");
var _pathIntersection = require("path-intersection");
var _pathIntersectionDefault = parcelHelpers.interopDefault(_pathIntersection);
function roundBounds(bounds) {
    return {
        x: Math.round(bounds.x),
        y: Math.round(bounds.y),
        width: Math.round(bounds.width),
        height: Math.round(bounds.height)
    };
}
function roundPoint(point) {
    return {
        x: Math.round(point.x),
        y: Math.round(point.y)
    };
}
function asTRBL(bounds) {
    return {
        top: bounds.y,
        right: bounds.x + (bounds.width || 0),
        bottom: bounds.y + (bounds.height || 0),
        left: bounds.x
    };
}
function asBounds(trbl) {
    return {
        x: trbl.left,
        y: trbl.top,
        width: trbl.right - trbl.left,
        height: trbl.bottom - trbl.top
    };
}
function getBoundsMid(bounds) {
    return roundPoint({
        x: bounds.x + (bounds.width || 0) / 2,
        y: bounds.y + (bounds.height || 0) / 2
    });
}
function getConnectionMid(connection) {
    var waypoints = connection.waypoints;
    // calculate total length and length of each segment
    var parts = waypoints.reduce(function(parts, point, index) {
        var lastPoint = waypoints[index - 1];
        if (lastPoint) {
            var lastPart = parts[parts.length - 1];
            var startLength = lastPart && lastPart.endLength || 0;
            var length = distance(lastPoint, point);
            parts.push({
                start: lastPoint,
                end: point,
                startLength: startLength,
                endLength: startLength + length,
                length: length
            });
        }
        return parts;
    }, []);
    var totalLength = parts.reduce(function(length, part) {
        return length + part.length;
    }, 0);
    // find which segement contains middle point
    var midLength = totalLength / 2;
    var i = 0;
    var midSegment = parts[i];
    while(midSegment.endLength < midLength)midSegment = parts[++i];
    // calculate relative position on mid segment
    var segmentProgress = (midLength - midSegment.startLength) / midSegment.length;
    var midPoint = {
        x: midSegment.start.x + (midSegment.end.x - midSegment.start.x) * segmentProgress,
        y: midSegment.start.y + (midSegment.end.y - midSegment.start.y) * segmentProgress
    };
    return midPoint;
}
function getMid(element) {
    if (isConnection(element)) return getConnectionMid(element);
    return getBoundsMid(element);
}
function getOrientation(rect, reference, padding) {
    padding = padding || 0;
    // make sure we can use an object, too
    // for individual { x, y } padding
    if (!(0, _minDash.isObject)(padding)) padding = {
        x: padding,
        y: padding
    };
    var rectOrientation = asTRBL(rect), referenceOrientation = asTRBL(reference);
    var top = rectOrientation.bottom + padding.y <= referenceOrientation.top, right = rectOrientation.left - padding.x >= referenceOrientation.right, bottom = rectOrientation.top - padding.y >= referenceOrientation.bottom, left = rectOrientation.right + padding.x <= referenceOrientation.left;
    var vertical = top ? 'top' : bottom ? 'bottom' : null, horizontal = left ? 'left' : right ? 'right' : null;
    if (horizontal && vertical) return vertical + '-' + horizontal;
    else return horizontal || vertical || 'intersect';
}
function getElementLineIntersection(elementPath, linePath, cropStart) {
    var intersections = getIntersections(elementPath, linePath);
    // recognize intersections
    // only one -> choose
    // two close together -> choose first
    // two or more distinct -> pull out appropriate one
    // none -> ok (fallback to point itself)
    if (intersections.length === 1) return roundPoint(intersections[0]);
    else if (intersections.length === 2 && (0, _geometry.pointDistance)(intersections[0], intersections[1]) < 1) return roundPoint(intersections[0]);
    else if (intersections.length > 1) {
        // sort by intersections based on connection segment +
        // distance from start
        intersections = (0, _minDash.sortBy)(intersections, function(i) {
            var distance = Math.floor(i.t2 * 100) || 1;
            distance = 100 - distance;
            distance = (distance < 10 ? '0' : '') + distance;
            // create a sort string that makes sure we sort
            // line segment ASC + line segment position DESC (for cropStart)
            // line segment ASC + line segment position ASC (for cropEnd)
            return i.segment2 + '#' + distance;
        });
        return roundPoint(intersections[cropStart ? 0 : intersections.length - 1]);
    }
    return null;
}
function getIntersections(a, b) {
    return (0, _pathIntersectionDefault.default)(a, b);
}
function filterRedundantWaypoints(waypoints) {
    // alter copy of waypoints, not original
    waypoints = waypoints.slice();
    var idx = 0, point, previousPoint, nextPoint;
    while(waypoints[idx]){
        point = waypoints[idx];
        previousPoint = waypoints[idx - 1];
        nextPoint = waypoints[idx + 1];
        if ((0, _geometry.pointDistance)(point, nextPoint) === 0 || (0, _geometry.pointsOnLine)(previousPoint, nextPoint, point)) // remove point, if overlapping with {nextPoint}
        // or on line with {previousPoint} -> {point} -> {nextPoint}
        waypoints.splice(idx, 1);
        else idx++;
    }
    return waypoints;
}
// helpers //////////////////////
function distance(a, b) {
    return Math.sqrt(Math.pow(a.x - b.x, 2) + Math.pow(a.y - b.y, 2));
}
function isConnection(element) {
    return !!element.waypoints;
}

},{"min-dash":"aEEla","../util/Geometry":"1zZUi","path-intersection":"cJEhf","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1zZUi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @typedef {import('../util/Types').Axis} Axis
 * @typedef {import('../util/Types').Point} Point
 * @typedef {import('../util/Types').Rect} Rect
 */ /**
 * Computes the distance between two points.
 *
 * @param {Point} p
 * @param {Point} q
 *
 * @return {number} The distance between the two points.
 */ parcelHelpers.export(exports, "pointDistance", ()=>pointDistance);
/**
 * Returns true if the point r is on the line between p and q.
 *
 * @param {Point} p
 * @param {Point} q
 * @param {Point} r
 * @param {number} [accuracy=5] The accuracy with which to check (lower is better).
 *
 * @return {boolean}
 */ parcelHelpers.export(exports, "pointsOnLine", ()=>pointsOnLine);
/**
 * Check whether two points are horizontally or vertically aligned.
 *
 * @param {Point[]|Point} a
 * @param {Point} [b]
 *
 * @return {string|boolean} If and how the two points are aligned ('h', 'v' or `false`).
 */ parcelHelpers.export(exports, "pointsAligned", ()=>pointsAligned);
/**
 * @param {Axis} axis
 * @param {Point[]} points
 *
 * @return {boolean}
 */ parcelHelpers.export(exports, "pointsAlignedOnAxis", ()=>pointsAlignedOnAxis);
/**
 * Returns true if the point p is inside the rectangle rect
 *
 * @param {Point} p
 * @param {Rect} rect
 * @param {number} tolerance
 *
 * @return {boolean}
 */ parcelHelpers.export(exports, "pointInRect", ()=>pointInRect);
/**
 * Returns a point in the middle of points p and q
 *
 * @param {Point} p
 * @param {Point} q
 *
 * @return {Point} The mid point between the two points.
 */ parcelHelpers.export(exports, "getMidPoint", ()=>getMidPoint);
var _minDash = require("min-dash");
function pointDistance(a, b) {
    if (!a || !b) return -1;
    return Math.sqrt(Math.pow(a.x - b.x, 2) + Math.pow(a.y - b.y, 2));
}
function pointsOnLine(p, q, r, accuracy) {
    if (typeof accuracy === 'undefined') accuracy = 5;
    if (!p || !q || !r) return false;
    var val = (q.x - p.x) * (r.y - p.y) - (q.y - p.y) * (r.x - p.x), dist = pointDistance(p, q);
    // @see http://stackoverflow.com/a/907491/412190
    return Math.abs(val / dist) <= accuracy;
}
var ALIGNED_THRESHOLD = 2;
function pointsAligned(a, b) {
    var points = Array.from(arguments).flat();
    const axisMap = {
        'x': 'v',
        'y': 'h'
    };
    for (const [axis, orientation] of Object.entries(axisMap)){
        if (pointsAlignedOnAxis(axis, points)) return orientation;
    }
    return false;
}
function pointsAlignedOnAxis(axis, points) {
    const referencePoint = points[0];
    return (0, _minDash.every)(points, function(point) {
        return Math.abs(referencePoint[axis] - point[axis]) <= ALIGNED_THRESHOLD;
    });
}
function pointInRect(p, rect, tolerance) {
    tolerance = tolerance || 0;
    return p.x > rect.x - tolerance && p.y > rect.y - tolerance && p.x < rect.x + rect.width + tolerance && p.y < rect.y + rect.height + tolerance;
}
function getMidPoint(p, q) {
    return {
        x: Math.round(p.x + (q.x - p.x) / 2.0),
        y: Math.round(p.y + (q.y - p.y) / 2.0)
    };
}

},{"min-dash":"aEEla","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cJEhf":[function(require,module,exports,__globalThis) {
'use strict';
/**
 * This file contains source code adapted from Snap.svg (licensed Apache-2.0).
 *
 * @see https://github.com/adobe-webplatform/Snap.svg/blob/master/src/path.js
 */ /* eslint no-fallthrough: "off" */ var p2s = /,?([a-z]),?/gi, toFloat = parseFloat, math = Math, PI = math.PI, mmin = math.min, mmax = math.max, pow = math.pow, abs = math.abs, pathCommand = /([a-z])[\s,]*((-?\d*\.?\d*(?:e[-+]?\d+)?[\s]*,?[\s]*)+)/ig, pathValues = /(-?\d*\.?\d*(?:e[-+]?\d+)?)[\s]*,?[\s]*/ig;
var isArray = Array.isArray || function(o) {
    return o instanceof Array;
};
function hasProperty(obj, property) {
    return Object.prototype.hasOwnProperty.call(obj, property);
}
function clone(obj) {
    if (typeof obj == 'function' || Object(obj) !== obj) return obj;
    var res = new obj.constructor;
    for(var key in obj)if (hasProperty(obj, key)) res[key] = clone(obj[key]);
    return res;
}
function repush(array, item) {
    for(var i = 0, ii = array.length; i < ii; i++)if (array[i] === item) return array.push(array.splice(i, 1)[0]);
}
function cacher(f) {
    function newf() {
        var arg = Array.prototype.slice.call(arguments, 0), args = arg.join('\u2400'), cache = newf.cache = newf.cache || {}, count = newf.count = newf.count || [];
        if (hasProperty(cache, args)) {
            repush(count, args);
            return cache[args];
        }
        count.length >= 1e3 && delete cache[count.shift()];
        count.push(args);
        cache[args] = f.apply(0, arg);
        return cache[args];
    }
    return newf;
}
function parsePathString(pathString) {
    if (!pathString) return null;
    var pth = paths(pathString);
    if (pth.arr) return clone(pth.arr);
    var paramCounts = {
        a: 7,
        c: 6,
        h: 1,
        l: 2,
        m: 2,
        q: 4,
        s: 4,
        t: 2,
        v: 1,
        z: 0
    }, data = [];
    if (isArray(pathString) && isArray(pathString[0])) data = clone(pathString);
    if (!data.length) String(pathString).replace(pathCommand, function(a, b, c) {
        var params = [], name = b.toLowerCase();
        c.replace(pathValues, function(a, b) {
            b && params.push(+b);
        });
        if (name == 'm' && params.length > 2) {
            data.push([
                b
            ].concat(params.splice(0, 2)));
            name = 'l';
            b = b == 'm' ? 'l' : 'L';
        }
        while(params.length >= paramCounts[name]){
            data.push([
                b
            ].concat(params.splice(0, paramCounts[name])));
            if (!paramCounts[name]) break;
        }
    });
    data.toString = paths.toString;
    pth.arr = clone(data);
    return data;
}
function paths(ps) {
    var p = paths.ps = paths.ps || {};
    if (p[ps]) p[ps].sleep = 100;
    else p[ps] = {
        sleep: 100
    };
    setTimeout(function() {
        for(var key in p)if (hasProperty(p, key) && key != ps) {
            p[key].sleep--;
            !p[key].sleep && delete p[key];
        }
    });
    return p[ps];
}
function rectBBox(x, y, width, height) {
    if (arguments.length === 1) {
        y = x.y;
        width = x.width;
        height = x.height;
        x = x.x;
    }
    return {
        x: x,
        y: y,
        width: width,
        height: height,
        x2: x + width,
        y2: y + height
    };
}
function pathToString() {
    return this.join(',').replace(p2s, '$1');
}
function pathClone(pathArray) {
    var res = clone(pathArray);
    res.toString = pathToString;
    return res;
}
function findDotsAtSegment(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, t) {
    var t1 = 1 - t, t13 = pow(t1, 3), t12 = pow(t1, 2), t2 = t * t, t3 = t2 * t, x = t13 * p1x + t12 * 3 * t * c1x + t1 * 3 * t * t * c2x + t3 * p2x, y = t13 * p1y + t12 * 3 * t * c1y + t1 * 3 * t * t * c2y + t3 * p2y;
    return {
        x: fixError(x),
        y: fixError(y)
    };
}
function bezierBBox(points) {
    var bbox = curveBBox.apply(null, points);
    return rectBBox(bbox.x0, bbox.y0, bbox.x1 - bbox.x0, bbox.y1 - bbox.y0);
}
function isPointInsideBBox(bbox, x, y) {
    return x >= bbox.x && x <= bbox.x + bbox.width && y >= bbox.y && y <= bbox.y + bbox.height;
}
function isBBoxIntersect(bbox1, bbox2) {
    bbox1 = rectBBox(bbox1);
    bbox2 = rectBBox(bbox2);
    return isPointInsideBBox(bbox2, bbox1.x, bbox1.y) || isPointInsideBBox(bbox2, bbox1.x2, bbox1.y) || isPointInsideBBox(bbox2, bbox1.x, bbox1.y2) || isPointInsideBBox(bbox2, bbox1.x2, bbox1.y2) || isPointInsideBBox(bbox1, bbox2.x, bbox2.y) || isPointInsideBBox(bbox1, bbox2.x2, bbox2.y) || isPointInsideBBox(bbox1, bbox2.x, bbox2.y2) || isPointInsideBBox(bbox1, bbox2.x2, bbox2.y2) || (bbox1.x < bbox2.x2 && bbox1.x > bbox2.x || bbox2.x < bbox1.x2 && bbox2.x > bbox1.x) && (bbox1.y < bbox2.y2 && bbox1.y > bbox2.y || bbox2.y < bbox1.y2 && bbox2.y > bbox1.y);
}
function base3(t, p1, p2, p3, p4) {
    var t1 = -3 * p1 + 9 * p2 - 9 * p3 + 3 * p4, t2 = t * t1 + 6 * p1 - 12 * p2 + 6 * p3;
    return t * t2 - 3 * p1 + 3 * p2;
}
function bezlen(x1, y1, x2, y2, x3, y3, x4, y4, z) {
    if (z == null) z = 1;
    z = z > 1 ? 1 : z < 0 ? 0 : z;
    var z2 = z / 2, n = 12, Tvalues = [
        -0.1252,
        .1252,
        -0.3678,
        .3678,
        -0.5873,
        .5873,
        -0.7699,
        .7699,
        -0.9041,
        .9041,
        -0.9816,
        .9816
    ], Cvalues = [
        0.2491,
        0.2491,
        0.2335,
        0.2335,
        0.2032,
        0.2032,
        0.1601,
        0.1601,
        0.1069,
        0.1069,
        0.0472,
        0.0472
    ], sum = 0;
    for(var i = 0; i < n; i++){
        var ct = z2 * Tvalues[i] + z2, xbase = base3(ct, x1, x2, x3, x4), ybase = base3(ct, y1, y2, y3, y4), comb = xbase * xbase + ybase * ybase;
        sum += Cvalues[i] * math.sqrt(comb);
    }
    return z2 * sum;
}
function intersectLines(x1, y1, x2, y2, x3, y3, x4, y4) {
    if (mmax(x1, x2) < mmin(x3, x4) || mmin(x1, x2) > mmax(x3, x4) || mmax(y1, y2) < mmin(y3, y4) || mmin(y1, y2) > mmax(y3, y4)) return;
    var nx = (x1 * y2 - y1 * x2) * (x3 - x4) - (x1 - x2) * (x3 * y4 - y3 * x4), ny = (x1 * y2 - y1 * x2) * (y3 - y4) - (y1 - y2) * (x3 * y4 - y3 * x4), denominator = (x1 - x2) * (y3 - y4) - (y1 - y2) * (x3 - x4);
    if (!denominator) return;
    var px = fixError(nx / denominator), py = fixError(ny / denominator), px2 = +px.toFixed(2), py2 = +py.toFixed(2);
    if (px2 < +mmin(x1, x2).toFixed(2) || px2 > +mmax(x1, x2).toFixed(2) || px2 < +mmin(x3, x4).toFixed(2) || px2 > +mmax(x3, x4).toFixed(2) || py2 < +mmin(y1, y2).toFixed(2) || py2 > +mmax(y1, y2).toFixed(2) || py2 < +mmin(y3, y4).toFixed(2) || py2 > +mmax(y3, y4).toFixed(2)) return;
    return {
        x: px,
        y: py
    };
}
function fixError(number) {
    return Math.round(number * 100000000000) / 100000000000;
}
function findBezierIntersections(bez1, bez2, justCount) {
    var bbox1 = bezierBBox(bez1), bbox2 = bezierBBox(bez2);
    if (!isBBoxIntersect(bbox1, bbox2)) return justCount ? 0 : [];
    // As an optimization, lines will have only 1 segment
    var l1 = bezlen.apply(0, bez1), l2 = bezlen.apply(0, bez2), n1 = isLine(bez1) ? 1 : ~~(l1 / 5) || 1, n2 = isLine(bez2) ? 1 : ~~(l2 / 5) || 1, dots1 = [], dots2 = [], xy = {}, res = justCount ? 0 : [];
    for(var i = 0; i < n1 + 1; i++){
        var p = findDotsAtSegment.apply(0, bez1.concat(i / n1));
        dots1.push({
            x: p.x,
            y: p.y,
            t: i / n1
        });
    }
    for(i = 0; i < n2 + 1; i++){
        p = findDotsAtSegment.apply(0, bez2.concat(i / n2));
        dots2.push({
            x: p.x,
            y: p.y,
            t: i / n2
        });
    }
    for(i = 0; i < n1; i++)for(var j = 0; j < n2; j++){
        var di = dots1[i], di1 = dots1[i + 1], dj = dots2[j], dj1 = dots2[j + 1], ci = abs(di1.x - di.x) < .01 ? 'y' : 'x', cj = abs(dj1.x - dj.x) < .01 ? 'y' : 'x', is = intersectLines(di.x, di.y, di1.x, di1.y, dj.x, dj.y, dj1.x, dj1.y), key;
        if (is) {
            key = is.x.toFixed(9) + '#' + is.y.toFixed(9);
            if (xy[key]) continue;
            xy[key] = true;
            var t1 = di.t + abs((is[ci] - di[ci]) / (di1[ci] - di[ci])) * (di1.t - di.t), t2 = dj.t + abs((is[cj] - dj[cj]) / (dj1[cj] - dj[cj])) * (dj1.t - dj.t);
            if (t1 >= 0 && t1 <= 1 && t2 >= 0 && t2 <= 1) {
                if (justCount) res++;
                else res.push({
                    x: is.x,
                    y: is.y,
                    t1: t1,
                    t2: t2
                });
            }
        }
    }
    return res;
}
/**
 * Find or counts the intersections between two SVG paths.
 *
 * Returns a number in counting mode and a list of intersections otherwise.
 *
 * A single intersection entry contains the intersection coordinates (x, y)
 * as well as additional information regarding the intersecting segments
 * on each path (segment1, segment2) and the relative location of the
 * intersection on these segments (t1, t2).
 *
 * The path may be an SVG path string or a list of path components
 * such as `[ [ 'M', 0, 10 ], [ 'L', 20, 0 ] ]`.
 *
 * @example
 *
 * var intersections = findPathIntersections(
 *   'M0,0L100,100',
 *   [ [ 'M', 0, 100 ], [ 'L', 100, 0 ] ]
 * );
 *
 * // intersections = [
 * //   { x: 50, y: 50, segment1: 1, segment2: 1, t1: 0.5, t2: 0.5 }
 * // ]
 *
 * @param {String|Array<PathDef>} path1
 * @param {String|Array<PathDef>} path2
 * @param {Boolean} [justCount=false]
 *
 * @return {Array<Intersection>|Number}
 */ function findPathIntersections(path1, path2, justCount) {
    path1 = pathToCurve(path1);
    path2 = pathToCurve(path2);
    var x1, y1, x2, y2, x1m, y1m, x2m, y2m, bez1, bez2, res = justCount ? 0 : [];
    for(var i = 0, ii = path1.length; i < ii; i++){
        var pi = path1[i];
        if (pi[0] == 'M') {
            x1 = x1m = pi[1];
            y1 = y1m = pi[2];
        } else {
            if (pi[0] == 'C') {
                bez1 = [
                    x1,
                    y1
                ].concat(pi.slice(1));
                x1 = bez1[6];
                y1 = bez1[7];
            } else {
                bez1 = [
                    x1,
                    y1,
                    x1,
                    y1,
                    x1m,
                    y1m,
                    x1m,
                    y1m
                ];
                x1 = x1m;
                y1 = y1m;
            }
            for(var j = 0, jj = path2.length; j < jj; j++){
                var pj = path2[j];
                if (pj[0] == 'M') {
                    x2 = x2m = pj[1];
                    y2 = y2m = pj[2];
                } else {
                    if (pj[0] == 'C') {
                        bez2 = [
                            x2,
                            y2
                        ].concat(pj.slice(1));
                        x2 = bez2[6];
                        y2 = bez2[7];
                    } else {
                        bez2 = [
                            x2,
                            y2,
                            x2,
                            y2,
                            x2m,
                            y2m,
                            x2m,
                            y2m
                        ];
                        x2 = x2m;
                        y2 = y2m;
                    }
                    var intr = findBezierIntersections(bez1, bez2, justCount);
                    if (justCount) res += intr;
                    else {
                        for(var k = 0, kk = intr.length; k < kk; k++){
                            intr[k].segment1 = i;
                            intr[k].segment2 = j;
                            intr[k].bez1 = bez1;
                            intr[k].bez2 = bez2;
                        }
                        res = res.concat(intr);
                    }
                }
            }
        }
    }
    return res;
}
function pathToAbsolute(pathArray) {
    var pth = paths(pathArray);
    if (pth.abs) return pathClone(pth.abs);
    if (!isArray(pathArray) || !isArray(pathArray && pathArray[0])) pathArray = parsePathString(pathArray);
    if (!pathArray || !pathArray.length) return [
        [
            'M',
            0,
            0
        ]
    ];
    var res = [], x = 0, y = 0, mx = 0, my = 0, start = 0, pa0;
    if (pathArray[0][0] == 'M') {
        x = +pathArray[0][1];
        y = +pathArray[0][2];
        mx = x;
        my = y;
        start++;
        res[0] = [
            'M',
            x,
            y
        ];
    }
    for(var r, pa, i = start, ii = pathArray.length; i < ii; i++){
        res.push(r = []);
        pa = pathArray[i];
        pa0 = pa[0];
        if (pa0 != pa0.toUpperCase()) {
            r[0] = pa0.toUpperCase();
            switch(r[0]){
                case 'A':
                    r[1] = pa[1];
                    r[2] = pa[2];
                    r[3] = pa[3];
                    r[4] = pa[4];
                    r[5] = pa[5];
                    r[6] = +pa[6] + x;
                    r[7] = +pa[7] + y;
                    break;
                case 'V':
                    r[1] = +pa[1] + y;
                    break;
                case 'H':
                    r[1] = +pa[1] + x;
                    break;
                case 'M':
                    mx = +pa[1] + x;
                    my = +pa[2] + y;
                default:
                    for(var j = 1, jj = pa.length; j < jj; j++)r[j] = +pa[j] + (j % 2 ? x : y);
            }
        } else for(var k = 0, kk = pa.length; k < kk; k++)r[k] = pa[k];
        pa0 = pa0.toUpperCase();
        switch(r[0]){
            case 'Z':
                x = +mx;
                y = +my;
                break;
            case 'H':
                x = r[1];
                break;
            case 'V':
                y = r[1];
                break;
            case 'M':
                mx = r[r.length - 2];
                my = r[r.length - 1];
            default:
                x = r[r.length - 2];
                y = r[r.length - 1];
        }
    }
    res.toString = pathToString;
    pth.abs = pathClone(res);
    return res;
}
function isLine(bez) {
    return bez[0] === bez[2] && bez[1] === bez[3] && bez[4] === bez[6] && bez[5] === bez[7];
}
function lineToCurve(x1, y1, x2, y2) {
    return [
        x1,
        y1,
        x2,
        y2,
        x2,
        y2
    ];
}
function qubicToCurve(x1, y1, ax, ay, x2, y2) {
    var _13 = 1 / 3, _23 = 2 / 3;
    return [
        _13 * x1 + _23 * ax,
        _13 * y1 + _23 * ay,
        _13 * x2 + _23 * ax,
        _13 * y2 + _23 * ay,
        x2,
        y2
    ];
}
function arcToCurve(x1, y1, rx, ry, angle, large_arc_flag, sweep_flag, x2, y2, recursive) {
    // for more information of where this math came from visit:
    // http://www.w3.org/TR/SVG11/implnote.html#ArcImplementationNotes
    var _120 = PI * 120 / 180, rad = PI / 180 * (+angle || 0), res = [], xy, rotate = cacher(function(x, y, rad) {
        var X = x * math.cos(rad) - y * math.sin(rad), Y = x * math.sin(rad) + y * math.cos(rad);
        return {
            x: X,
            y: Y
        };
    });
    if (!recursive) {
        xy = rotate(x1, y1, -rad);
        x1 = xy.x;
        y1 = xy.y;
        xy = rotate(x2, y2, -rad);
        x2 = xy.x;
        y2 = xy.y;
        var x = (x1 - x2) / 2, y = (y1 - y2) / 2;
        var h = x * x / (rx * rx) + y * y / (ry * ry);
        if (h > 1) {
            h = math.sqrt(h);
            rx = h * rx;
            ry = h * ry;
        }
        var rx2 = rx * rx, ry2 = ry * ry, k = (large_arc_flag == sweep_flag ? -1 : 1) * math.sqrt(abs((rx2 * ry2 - rx2 * y * y - ry2 * x * x) / (rx2 * y * y + ry2 * x * x))), cx = k * rx * y / ry + (x1 + x2) / 2, cy = k * -ry * x / rx + (y1 + y2) / 2, f1 = math.asin(((y1 - cy) / ry).toFixed(9)), f2 = math.asin(((y2 - cy) / ry).toFixed(9));
        f1 = x1 < cx ? PI - f1 : f1;
        f2 = x2 < cx ? PI - f2 : f2;
        f1 < 0 && (f1 = PI * 2 + f1);
        f2 < 0 && (f2 = PI * 2 + f2);
        if (sweep_flag && f1 > f2) f1 = f1 - PI * 2;
        if (!sweep_flag && f2 > f1) f2 = f2 - PI * 2;
    } else {
        f1 = recursive[0];
        f2 = recursive[1];
        cx = recursive[2];
        cy = recursive[3];
    }
    var df = f2 - f1;
    if (abs(df) > _120) {
        var f2old = f2, x2old = x2, y2old = y2;
        f2 = f1 + _120 * (sweep_flag && f2 > f1 ? 1 : -1);
        x2 = cx + rx * math.cos(f2);
        y2 = cy + ry * math.sin(f2);
        res = arcToCurve(x2, y2, rx, ry, angle, 0, sweep_flag, x2old, y2old, [
            f2,
            f2old,
            cx,
            cy
        ]);
    }
    df = f2 - f1;
    var c1 = math.cos(f1), s1 = math.sin(f1), c2 = math.cos(f2), s2 = math.sin(f2), t = math.tan(df / 4), hx = 4 / 3 * rx * t, hy = 4 / 3 * ry * t, m1 = [
        x1,
        y1
    ], m2 = [
        x1 + hx * s1,
        y1 - hy * c1
    ], m3 = [
        x2 + hx * s2,
        y2 - hy * c2
    ], m4 = [
        x2,
        y2
    ];
    m2[0] = 2 * m1[0] - m2[0];
    m2[1] = 2 * m1[1] - m2[1];
    if (recursive) return [
        m2,
        m3,
        m4
    ].concat(res);
    else {
        res = [
            m2,
            m3,
            m4
        ].concat(res).join().split(',');
        var newres = [];
        for(var i = 0, ii = res.length; i < ii; i++)newres[i] = i % 2 ? rotate(res[i - 1], res[i], rad).y : rotate(res[i], res[i + 1], rad).x;
        return newres;
    }
}
// Returns bounding box of cubic bezier curve.
// Source: http://blog.hackers-cafe.net/2009/06/how-to-calculate-bezier-curves-bounding.html
// Original version: NISHIO Hirokazu
// Modifications: https://github.com/timo22345
function curveBBox(x0, y0, x1, y1, x2, y2, x3, y3) {
    var tvalues = [], bounds = [
        [],
        []
    ], a, b, c, t, t1, t2, b2ac, sqrtb2ac;
    for(var i = 0; i < 2; ++i){
        if (i == 0) {
            b = 6 * x0 - 12 * x1 + 6 * x2;
            a = -3 * x0 + 9 * x1 - 9 * x2 + 3 * x3;
            c = 3 * x1 - 3 * x0;
        } else {
            b = 6 * y0 - 12 * y1 + 6 * y2;
            a = -3 * y0 + 9 * y1 - 9 * y2 + 3 * y3;
            c = 3 * y1 - 3 * y0;
        }
        if (abs(a) < 1e-12) {
            if (abs(b) < 1e-12) continue;
            t = -c / b;
            if (0 < t && t < 1) tvalues.push(t);
            continue;
        }
        b2ac = b * b - 4 * c * a;
        sqrtb2ac = math.sqrt(b2ac);
        if (b2ac < 0) continue;
        t1 = (-b + sqrtb2ac) / (2 * a);
        if (0 < t1 && t1 < 1) tvalues.push(t1);
        t2 = (-b - sqrtb2ac) / (2 * a);
        if (0 < t2 && t2 < 1) tvalues.push(t2);
    }
    var j = tvalues.length, jlen = j, mt;
    while(j--){
        t = tvalues[j];
        mt = 1 - t;
        bounds[0][j] = mt * mt * mt * x0 + 3 * mt * mt * t * x1 + 3 * mt * t * t * x2 + t * t * t * x3;
        bounds[1][j] = mt * mt * mt * y0 + 3 * mt * mt * t * y1 + 3 * mt * t * t * y2 + t * t * t * y3;
    }
    bounds[0][jlen] = x0;
    bounds[1][jlen] = y0;
    bounds[0][jlen + 1] = x3;
    bounds[1][jlen + 1] = y3;
    bounds[0].length = bounds[1].length = jlen + 2;
    return {
        x0: mmin.apply(0, bounds[0]),
        y0: mmin.apply(0, bounds[1]),
        x1: mmax.apply(0, bounds[0]),
        y1: mmax.apply(0, bounds[1])
    };
}
function pathToCurve(path) {
    var pth = paths(path);
    // return cached curve, if existing
    if (pth.curve) return pathClone(pth.curve);
    var curvedPath = pathToAbsolute(path), attrs = {
        x: 0,
        y: 0,
        bx: 0,
        by: 0,
        X: 0,
        Y: 0,
        qx: null,
        qy: null
    }, processPath = function(path, d, pathCommand) {
        var nx, ny;
        if (!path) return [
            'C',
            d.x,
            d.y,
            d.x,
            d.y,
            d.x,
            d.y
        ];
        !(path[0] in {
            T: 1,
            Q: 1
        }) && (d.qx = d.qy = null);
        switch(path[0]){
            case 'M':
                d.X = path[1];
                d.Y = path[2];
                break;
            case 'A':
                path = [
                    'C'
                ].concat(arcToCurve.apply(0, [
                    d.x,
                    d.y
                ].concat(path.slice(1))));
                break;
            case 'S':
                if (pathCommand == 'C' || pathCommand == 'S') {
                    // In 'S' case we have to take into account, if the previous command is C/S.
                    nx = d.x * 2 - d.bx;
                    // And reflect the previous
                    ny = d.y * 2 - d.by;
                // command's control point relative to the current point.
                } else {
                    // or some else or nothing
                    nx = d.x;
                    ny = d.y;
                }
                path = [
                    'C',
                    nx,
                    ny
                ].concat(path.slice(1));
                break;
            case 'T':
                if (pathCommand == 'Q' || pathCommand == 'T') {
                    // In 'T' case we have to take into account, if the previous command is Q/T.
                    d.qx = d.x * 2 - d.qx;
                    // And make a reflection similar
                    d.qy = d.y * 2 - d.qy;
                // to case 'S'.
                } else {
                    // or something else or nothing
                    d.qx = d.x;
                    d.qy = d.y;
                }
                path = [
                    'C'
                ].concat(qubicToCurve(d.x, d.y, d.qx, d.qy, path[1], path[2]));
                break;
            case 'Q':
                d.qx = path[1];
                d.qy = path[2];
                path = [
                    'C'
                ].concat(qubicToCurve(d.x, d.y, path[1], path[2], path[3], path[4]));
                break;
            case 'L':
                path = [
                    'C'
                ].concat(lineToCurve(d.x, d.y, path[1], path[2]));
                break;
            case 'H':
                path = [
                    'C'
                ].concat(lineToCurve(d.x, d.y, path[1], d.y));
                break;
            case 'V':
                path = [
                    'C'
                ].concat(lineToCurve(d.x, d.y, d.x, path[1]));
                break;
            case 'Z':
                path = [
                    'C'
                ].concat(lineToCurve(d.x, d.y, d.X, d.Y));
                break;
        }
        return path;
    }, fixArc = function(pp, i) {
        if (pp[i].length > 7) {
            pp[i].shift();
            var pi = pp[i];
            while(pi.length){
                pathCommands[i] = 'A'; // if created multiple C:s, their original seg is saved
                pp.splice(i++, 0, [
                    'C'
                ].concat(pi.splice(0, 6)));
            }
            pp.splice(i, 1);
            ii = curvedPath.length;
        }
    }, pathCommands = [], pfirst = '', pathCommand = ''; // holder for previous path command of original path
    for(var i = 0, ii = curvedPath.length; i < ii; i++){
        curvedPath[i] && (pfirst = curvedPath[i][0]); // save current path command
        if (pfirst != 'C') {
            pathCommands[i] = pfirst; // Save current path command
            i && (pathCommand = pathCommands[i - 1]); // Get previous path command pathCommand
        }
        curvedPath[i] = processPath(curvedPath[i], attrs, pathCommand); // Previous path command is inputted to processPath
        if (pathCommands[i] != 'A' && pfirst == 'C') pathCommands[i] = 'C'; // A is the only command
        // which may produce multiple C:s
        // so we have to make sure that C is also C in original path
        fixArc(curvedPath, i); // fixArc adds also the right amount of A:s to pathCommands
        var seg = curvedPath[i], seglen = seg.length;
        attrs.x = seg[seglen - 2];
        attrs.y = seg[seglen - 1];
        attrs.bx = toFloat(seg[seglen - 4]) || attrs.x;
        attrs.by = toFloat(seg[seglen - 3]) || attrs.y;
    }
    // cache curve
    pth.curve = pathClone(curvedPath);
    return curvedPath;
}
module.exports = findPathIntersections;

},{}],"42It9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ElementRegistry);
var _tinySvg = require("tiny-svg");
var ELEMENT_ID = 'data-element-id';
function ElementRegistry(eventBus) {
    this._elements = {};
    this._eventBus = eventBus;
}
ElementRegistry.$inject = [
    'eventBus'
];
/**
 * Add an element and its graphical representation(s) to the registry.
 *
 * @param {ElementLike} element The element to be added.
 * @param {SVGElement} gfx The primary graphical representation.
 * @param {SVGElement} [secondaryGfx] The secondary graphical representation.
 */ ElementRegistry.prototype.add = function(element, gfx, secondaryGfx) {
    var id = element.id;
    this._validateId(id);
    // associate dom node with element
    (0, _tinySvg.attr)(gfx, ELEMENT_ID, id);
    if (secondaryGfx) (0, _tinySvg.attr)(secondaryGfx, ELEMENT_ID, id);
    this._elements[id] = {
        element: element,
        gfx: gfx,
        secondaryGfx: secondaryGfx
    };
};
/**
 * Remove an element from the registry.
 *
 * @param {ElementLike|string} element
 */ ElementRegistry.prototype.remove = function(element) {
    var elements = this._elements, id = element.id || element, container = id && elements[id];
    if (container) {
        // unset element id on gfx
        (0, _tinySvg.attr)(container.gfx, ELEMENT_ID, '');
        if (container.secondaryGfx) (0, _tinySvg.attr)(container.secondaryGfx, ELEMENT_ID, '');
        delete elements[id];
    }
};
/**
 * Update an elements ID.
 *
 * @param {ElementLike|string} element The element or its ID.
 * @param {string} newId The new ID.
 */ ElementRegistry.prototype.updateId = function(element, newId) {
    this._validateId(newId);
    if (typeof element === 'string') element = this.get(element);
    this._eventBus.fire('element.updateId', {
        element: element,
        newId: newId
    });
    var gfx = this.getGraphics(element), secondaryGfx = this.getGraphics(element, true);
    this.remove(element);
    element.id = newId;
    this.add(element, gfx, secondaryGfx);
};
/**
 * Update the graphical representation of an element.
 *
 * @param {ElementLike|string} element The element or its ID.
 * @param {SVGElement} gfx The new graphical representation.
 * @param {boolean} [secondary=false] Whether to update the secondary graphical representation.
 */ ElementRegistry.prototype.updateGraphics = function(filter, gfx, secondary) {
    var id = filter.id || filter;
    var container = this._elements[id];
    if (secondary) container.secondaryGfx = gfx;
    else container.gfx = gfx;
    if (gfx) (0, _tinySvg.attr)(gfx, ELEMENT_ID, id);
    return gfx;
};
/**
 * Get the element with the given ID or graphical representation.
 *
 * @example
 *
 * elementRegistry.get('SomeElementId_1');
 *
 * elementRegistry.get(gfx);
 *
 * @param {string|SVGElement} filter The elements ID or graphical representation.
 *
 * @return {ElementLike|undefined} The element.
 */ ElementRegistry.prototype.get = function(filter) {
    var id;
    if (typeof filter === 'string') id = filter;
    else id = filter && (0, _tinySvg.attr)(filter, ELEMENT_ID);
    var container = this._elements[id];
    return container && container.element;
};
/**
 * Return all elements that match a given filter function.
 *
 * @param {ElementRegistryCallback} fn The filter function.
 *
 * @return {ElementLike[]} The matching elements.
 */ ElementRegistry.prototype.filter = function(fn) {
    var filtered = [];
    this.forEach(function(element, gfx) {
        if (fn(element, gfx)) filtered.push(element);
    });
    return filtered;
};
/**
 * Return the first element that matches the given filter function.
 *
 * @param {Function} fn The filter function.
 *
 * @return {ElementLike|undefined} The matching element.
 */ ElementRegistry.prototype.find = function(fn) {
    var map = this._elements, keys = Object.keys(map);
    for(var i = 0; i < keys.length; i++){
        var id = keys[i], container = map[id], element = container.element, gfx = container.gfx;
        if (fn(element, gfx)) return element;
    }
};
/**
 * Get all elements.
 *
 * @return {ElementLike[]} All elements.
 */ ElementRegistry.prototype.getAll = function() {
    return this.filter(function(e) {
        return e;
    });
};
/**
 * Execute a given function for each element.
 *
 * @param {Function} fn The function to execute.
 */ ElementRegistry.prototype.forEach = function(fn) {
    var map = this._elements;
    Object.keys(map).forEach(function(id) {
        var container = map[id], element = container.element, gfx = container.gfx;
        return fn(element, gfx);
    });
};
/**
 * Return the graphical representation of an element.
 *
 * @example
 *
 * elementRegistry.getGraphics('SomeElementId_1');
 *
 * elementRegistry.getGraphics(rootElement); // <g ...>
 *
 * elementRegistry.getGraphics(rootElement, true); // <svg ...>
 *
 * @param {ElementLike|string} filter The element or its ID.
 * @param {boolean} [secondary=false] Whether to return the secondary graphical representation.
 *
 * @return {SVGElement} The graphical representation.
 */ ElementRegistry.prototype.getGraphics = function(filter, secondary) {
    var id = filter.id || filter;
    var container = this._elements[id];
    return container && (secondary ? container.secondaryGfx : container.gfx);
};
/**
 * Validate an ID and throw an error if invalid.
 *
 * @param {string} id
 *
 * @throws {Error} Error indicating that the ID is invalid or already assigned.
 */ ElementRegistry.prototype._validateId = function(id) {
    if (!id) throw new Error('element must have an id');
    if (this._elements[id]) throw new Error('element with id ' + id + ' already added');
};

},{"tiny-svg":"6ZtXA","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"idaBX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ElementFactory);
var _model = require("../model");
var _minDash = require("min-dash");
function ElementFactory() {
    this._uid = 12;
}
/**
 * Create a root element.
 *
 * @param {ModelAttrsRoot} attrs The attributes of the root element to be created.
 *
 * @return {Root} The created root element.
 */ ElementFactory.prototype.createRoot = function(attrs) {
    return this.create('root', attrs);
};
/**
 * Create a label.
 *
 * @param {ModelAttrsLabel} attrs The attributes of the label to be created.
 *
 * @return {Label} The created label.
 */ ElementFactory.prototype.createLabel = function(attrs) {
    return this.create('label', attrs);
};
/**
 * Create a shape.
 *
 * @param {ModelAttrsShape} attrs The attributes of the shape to be created.
 *
 * @return {Shape} The created shape.
 */ ElementFactory.prototype.createShape = function(attrs) {
    return this.create('shape', attrs);
};
/**
 * Create a connection.
 *
 * @param {ModelAttrsConnection} attrs The attributes of the connection to be created.
 *
 * @return {Connection} The created connection.
 */ ElementFactory.prototype.createConnection = function(attrs) {
    return this.create('connection', attrs);
};
/**
 * Create a model element of the given type with the given attributes.
 *
 * @param {string} type The type of the model element.
 * @param {Object} attrs The attributes of the model element.
 *
 * @return {Connection|Label|Root|Shape} The created model element.
 */ ElementFactory.prototype.create = function(type, attrs) {
    attrs = (0, _minDash.assign)({}, attrs || {});
    if (!attrs.id) attrs.id = type + '_' + this._uid++;
    return (0, _model.create)(type, attrs);
};

},{"../model":"d9VZM","min-dash":"aEEla","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"d9VZM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The basic graphical representation
 *
 * @class
 *
 * @abstract
 */ parcelHelpers.export(exports, "Base", ()=>Base);
/**
 * A graphical object
 *
 * @class
 * @constructor
 *
 * @extends Base
 */ parcelHelpers.export(exports, "Shape", ()=>Shape);
/**
 * A root graphical object
 *
 * @class
 * @constructor
 *
 * @extends Shape
 */ parcelHelpers.export(exports, "Root", ()=>Root);
/**
 * A label for an element
 *
 * @class
 * @constructor
 *
 * @extends Shape
 */ parcelHelpers.export(exports, "Label", ()=>Label);
/**
 * A connection between two elements
 *
 * @class
 * @constructor
 *
 * @extends Base
 */ parcelHelpers.export(exports, "Connection", ()=>Connection);
/**
 * Creates a model element of the given type.
 *
 * @method create
 *
 * @example
 *
 * import * as Model from 'diagram-js/lib/model';
 *
 * const connection = Model.create('connection', {
 *   waypoints: [
 *     { x: 100, y: 100 },
 *     { x: 200, y: 100 }
 *   ]
 * });
 *
 * const label = Model.create('label', {
 *   x: 100,
 *   y: 100,
 *   width: 100,
 *   height: 100,
 *   labelTarget: shape
 * });
 *
 * const root = Model.create('root', {
 *   x: 100,
 *   y: 100,
 *   width: 100,
 *   height: 100
 * });
 *
 * const shape = Model.create('shape', {
 *   x: 100,
 *   y: 100,
 *   width: 100,
 *   height: 100
 * });
 *
 * @param {string} type The type of model element to be created.
 * @param {Object} attrs Attributes to create the model element with.
 *
 * @return {Connection|Label|Root|Shape} The created model element.
 */ parcelHelpers.export(exports, "create", ()=>create);
var _minDash = require("min-dash");
var _inheritsBrowser = require("inherits-browser");
var _inheritsBrowserDefault = parcelHelpers.interopDefault(_inheritsBrowser);
var _objectRefs = require("object-refs");
var _objectRefsDefault = parcelHelpers.interopDefault(_objectRefs);
var parentRefs = new (0, _objectRefsDefault.default)({
    name: 'children',
    enumerable: true,
    collection: true
}, {
    name: 'parent'
}), labelRefs = new (0, _objectRefsDefault.default)({
    name: 'labels',
    enumerable: true,
    collection: true
}, {
    name: 'labelTarget'
}), attacherRefs = new (0, _objectRefsDefault.default)({
    name: 'attachers',
    collection: true
}, {
    name: 'host'
}), outgoingRefs = new (0, _objectRefsDefault.default)({
    name: 'outgoing',
    collection: true
}, {
    name: 'source'
}), incomingRefs = new (0, _objectRefsDefault.default)({
    name: 'incoming',
    collection: true
}, {
    name: 'target'
});
function Base() {
    /**
   * The object that backs up the shape
   *
   * @name Base#businessObject
   * @type Object
   */ Object.defineProperty(this, 'businessObject', {
        writable: true
    });
    /**
   * Single label support, will mapped to multi label array
   *
   * @name Base#label
   * @type Object
   */ Object.defineProperty(this, 'label', {
        get: function() {
            return this.labels[0];
        },
        set: function(newLabel) {
            var label = this.label, labels = this.labels;
            if (!newLabel && label) labels.remove(label);
            else labels.add(newLabel, 0);
        }
    });
    /**
   * The parent shape
   *
   * @name Base#parent
   * @type Shape
   */ parentRefs.bind(this, 'parent');
    /**
   * The list of labels
   *
   * @name Base#labels
   * @type Label
   */ labelRefs.bind(this, 'labels');
    /**
   * The list of outgoing connections
   *
   * @name Base#outgoing
   * @type Array<Connection>
   */ outgoingRefs.bind(this, 'outgoing');
    /**
   * The list of incoming connections
   *
   * @name Base#incoming
   * @type Array<Connection>
   */ incomingRefs.bind(this, 'incoming');
}
function Shape() {
    Base.call(this);
    /**
   * Indicates frame shapes
   *
   * @name Shape#isFrame
   * @type boolean
   */ /**
   * The list of children
   *
   * @name Shape#children
   * @type Array<Base>
   */ parentRefs.bind(this, 'children');
    /**
   * @name Shape#host
   * @type Shape
   */ attacherRefs.bind(this, 'host');
    /**
   * @name Shape#attachers
   * @type Shape
   */ attacherRefs.bind(this, 'attachers');
}
(0, _inheritsBrowserDefault.default)(Shape, Base);
function Root() {
    Shape.call(this);
}
(0, _inheritsBrowserDefault.default)(Root, Shape);
function Label() {
    Shape.call(this);
    /**
   * The labeled element
   *
   * @name Label#labelTarget
   * @type Base
   */ labelRefs.bind(this, 'labelTarget');
}
(0, _inheritsBrowserDefault.default)(Label, Shape);
function Connection() {
    Base.call(this);
    /**
   * The element this connection originates from
   *
   * @name Connection#source
   * @type Base
   */ outgoingRefs.bind(this, 'source');
    /**
   * The element this connection points to
   *
   * @name Connection#target
   * @type Base
   */ incomingRefs.bind(this, 'target');
}
(0, _inheritsBrowserDefault.default)(Connection, Base);
var types = {
    connection: Connection,
    shape: Shape,
    label: Label,
    root: Root
};
function create(type, attrs) {
    var Type = types[type];
    if (!Type) throw new Error('unknown type: <' + type + '>');
    return (0, _minDash.assign)(new Type(), attrs);
}

},{"min-dash":"aEEla","inherits-browser":"hymxq","object-refs":"kw6UZ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kw6UZ":[function(require,module,exports,__globalThis) {
module.exports = require("1ab52b22ba49b583");
module.exports.Collection = require("3fda03d0cbc12d49");

},{"1ab52b22ba49b583":"aGNR5","3fda03d0cbc12d49":"h5JcJ"}],"aGNR5":[function(require,module,exports,__globalThis) {
'use strict';
var Collection = require("399920bc708a0ecd");
function hasOwnProperty(e, property) {
    return Object.prototype.hasOwnProperty.call(e, property.name || property);
}
function defineCollectionProperty(ref, property, target) {
    var collection = Collection.extend(target[property.name] || [], ref, property, target);
    Object.defineProperty(target, property.name, {
        enumerable: property.enumerable,
        value: collection
    });
    if (collection.length) collection.forEach(function(o) {
        ref.set(o, property.inverse, target);
    });
}
function defineProperty(ref, property, target) {
    var inverseProperty = property.inverse;
    var _value = target[property.name];
    Object.defineProperty(target, property.name, {
        configurable: property.configurable,
        enumerable: property.enumerable,
        get: function() {
            return _value;
        },
        set: function(value) {
            // return if we already performed all changes
            if (value === _value) return;
            var old = _value;
            // temporary set null
            _value = null;
            if (old) ref.unset(old, inverseProperty, target);
            // set new value
            _value = value;
            // set inverse value
            ref.set(_value, inverseProperty, target);
        }
    });
}
/**
 * Creates a new references object defining two inversly related
 * attribute descriptors a and b.
 *
 * <p>
 *   When bound to an object using {@link Refs#bind} the references
 *   get activated and ensure that add and remove operations are applied
 *   reversely, too.
 * </p>
 *
 * <p>
 *   For attributes represented as collections {@link Refs} provides the
 *   {@link RefsCollection#add}, {@link RefsCollection#remove} and {@link RefsCollection#contains} extensions
 *   that must be used to properly hook into the inverse change mechanism.
 * </p>
 *
 * @class Refs
 *
 * @classdesc A bi-directional reference between two attributes.
 *
 * @param {Refs.AttributeDescriptor} a property descriptor
 * @param {Refs.AttributeDescriptor} b property descriptor
 *
 * @example
 *
 * var refs = Refs({ name: 'wheels', collection: true, enumerable: true }, { name: 'car' });
 *
 * var car = { name: 'toyota' };
 * var wheels = [{ pos: 'front-left' }, { pos: 'front-right' }];
 *
 * refs.bind(car, 'wheels');
 *
 * car.wheels // []
 * car.wheels.add(wheels[0]);
 * car.wheels.add(wheels[1]);
 *
 * car.wheels // [{ pos: 'front-left' }, { pos: 'front-right' }]
 *
 * wheels[0].car // { name: 'toyota' };
 * car.wheels.remove(wheels[0]);
 *
 * wheels[0].car // undefined
 */ function Refs(a, b) {
    if (!(this instanceof Refs)) return new Refs(a, b);
    // link
    a.inverse = b;
    b.inverse = a;
    this.props = {};
    this.props[a.name] = a;
    this.props[b.name] = b;
}
/**
 * Binds one side of a bi-directional reference to a
 * target object.
 *
 * @memberOf Refs
 *
 * @param  {Object} target
 * @param  {String} property
 */ Refs.prototype.bind = function(target, property) {
    if (typeof property === 'string') {
        if (!this.props[property]) throw new Error('no property <' + property + '> in ref');
        property = this.props[property];
    }
    if (property.collection) defineCollectionProperty(this, property, target);
    else defineProperty(this, property, target);
};
Refs.prototype.ensureRefsCollection = function(target, property) {
    var collection = target[property.name];
    if (!Collection.isExtended(collection)) defineCollectionProperty(this, property, target);
    return collection;
};
Refs.prototype.ensureBound = function(target, property) {
    if (!hasOwnProperty(target, property)) this.bind(target, property);
};
Refs.prototype.unset = function(target, property, value) {
    if (target) {
        this.ensureBound(target, property);
        if (property.collection) this.ensureRefsCollection(target, property).remove(value);
        else target[property.name] = undefined;
    }
};
Refs.prototype.set = function(target, property, value) {
    if (target) {
        this.ensureBound(target, property);
        if (property.collection) this.ensureRefsCollection(target, property).add(value);
        else target[property.name] = value;
    }
};
module.exports = Refs; /**
 * An attribute descriptor to be used specify an attribute in a {@link Refs} instance
 *
 * @typedef {Object} Refs.AttributeDescriptor
 * @property {String} name
 * @property {boolean} [collection=false]
 * @property {boolean} [enumerable=false]
 */ 

},{"399920bc708a0ecd":"h5JcJ"}],"h5JcJ":[function(require,module,exports,__globalThis) {
'use strict';
/**
 * An empty collection stub. Use {@link RefsCollection.extend} to extend a
 * collection with ref semantics.
 *
 * @class RefsCollection
 */ /**
 * Extends a collection with {@link Refs} aware methods
 *
 * @memberof RefsCollection
 * @static
 *
 * @param  {Array<Object>} collection
 * @param  {Refs} refs instance
 * @param  {Object} property represented by the collection
 * @param  {Object} target object the collection is attached to
 *
 * @return {RefsCollection<Object>} the extended array
 */ function extend(collection, refs, property, target) {
    var inverseProperty = property.inverse;
    /**
   * Removes the given element from the array and returns it.
   *
   * @method RefsCollection#remove
   *
   * @param {Object} element the element to remove
   */ Object.defineProperty(collection, 'remove', {
        value: function(element) {
            var idx = this.indexOf(element);
            if (idx !== -1) {
                this.splice(idx, 1);
                // unset inverse
                refs.unset(element, inverseProperty, target);
            }
            return element;
        }
    });
    /**
   * Returns true if the collection contains the given element
   *
   * @method RefsCollection#contains
   *
   * @param {Object} element the element to check for
   */ Object.defineProperty(collection, 'contains', {
        value: function(element) {
            return this.indexOf(element) !== -1;
        }
    });
    /**
   * Adds an element to the array, unless it exists already (set semantics).
   *
   * @method RefsCollection#add
   *
   * @param {Object} element the element to add
   * @param {Number} optional index to add element to
   *                 (possibly moving other elements around)
   */ Object.defineProperty(collection, 'add', {
        value: function(element, idx) {
            var currentIdx = this.indexOf(element);
            if (typeof idx === 'undefined') {
                if (currentIdx !== -1) // element already in collection (!)
                return;
                // add to end of array, as no idx is specified
                idx = this.length;
            }
            // handle already in collection
            if (currentIdx !== -1) // remove element from currentIdx
            this.splice(currentIdx, 1);
            // add element at idx
            this.splice(idx, 0, element);
            if (currentIdx === -1) // set inverse, unless element was
            // in collection already
            refs.set(element, inverseProperty, target);
        }
    });
    // a simple marker, identifying this element
    // as being a refs collection
    Object.defineProperty(collection, '__refs_collection', {
        value: true
    });
    return collection;
}
function isExtended(collection) {
    return collection.__refs_collection === true;
}
module.exports.extend = extend;
module.exports.isExtended = isExtended;

},{}],"6zRvn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>EventBus);
var _minDash = require("min-dash");
var FN_REF = '__fn';
var DEFAULT_PRIORITY = 1000;
var slice = Array.prototype.slice;
function EventBus() {
    this._listeners = {};
    // cleanup on destroy on lowest priority to allow
    // message passing until the bitter end
    this.on('diagram.destroy', 1, this._destroy, this);
}
/**
 * Register an event listener for events with the given name.
 *
 * The callback will be invoked with `event, ...additionalArguments`
 * that have been passed to {@link EventBus#fire}.
 *
 * Returning false from a listener will prevent the events default action
 * (if any is specified). To stop an event from being processed further in
 * other listeners execute {@link Event#stopPropagation}.
 *
 * Returning anything but `undefined` from a listener will stop the listener propagation.
 *
 * @param {string|string[]} events The event(s) to listen to.
 * @param {number} [priority=1000] The priority with which to listen.
 * @param {EventCallback} callback The callback.
 * @param {*} [that] Value of `this` the callback will be called with.
 */ EventBus.prototype.on = function(events, priority, callback, that) {
    events = (0, _minDash.isArray)(events) ? events : [
        events
    ];
    if ((0, _minDash.isFunction)(priority)) {
        that = callback;
        callback = priority;
        priority = DEFAULT_PRIORITY;
    }
    if (!(0, _minDash.isNumber)(priority)) throw new Error('priority must be a number');
    var actualCallback = callback;
    if (that) {
        actualCallback = (0, _minDash.bind)(callback, that);
        // make sure we remember and are able to remove
        // bound callbacks via {@link #off} using the original
        // callback
        actualCallback[FN_REF] = callback[FN_REF] || callback;
    }
    var self = this;
    events.forEach(function(e) {
        self._addListener(e, {
            priority: priority,
            callback: actualCallback,
            next: null
        });
    });
};
/**
 * Register an event listener that is called only once.
 *
 * @param {string} event The event to listen to.
 * @param {number} [priority=1000] The priority with which to listen.
 * @param {EventCallback} callback The callback.
 * @param {*} [that] Value of `this` the callback will be called with.
 */ EventBus.prototype.once = function(event, priority, callback, that) {
    var self = this;
    if ((0, _minDash.isFunction)(priority)) {
        that = callback;
        callback = priority;
        priority = DEFAULT_PRIORITY;
    }
    if (!(0, _minDash.isNumber)(priority)) throw new Error('priority must be a number');
    function wrappedCallback() {
        wrappedCallback.__isTomb = true;
        var result = callback.apply(that, arguments);
        self.off(event, wrappedCallback);
        return result;
    }
    // make sure we remember and are able to remove
    // bound callbacks via {@link #off} using the original
    // callback
    wrappedCallback[FN_REF] = callback;
    this.on(event, priority, wrappedCallback);
};
/**
 * Removes event listeners by event and callback.
 *
 * If no callback is given, all listeners for a given event name are being removed.
 *
 * @param {string|string[]} events The events.
 * @param {EventCallback} [callback] The callback.
 */ EventBus.prototype.off = function(events, callback) {
    events = (0, _minDash.isArray)(events) ? events : [
        events
    ];
    var self = this;
    events.forEach(function(event) {
        self._removeListener(event, callback);
    });
};
/**
 * Create an event recognized be the event bus.
 *
 * @param {Object} data Event data.
 *
 * @return {Event} An event that will be recognized by the event bus.
 */ EventBus.prototype.createEvent = function(data) {
    var event = new InternalEvent();
    event.init(data);
    return event;
};
/**
 * Fires an event.
 *
 * @example
 *
 * // fire event by name
 * events.fire('foo');
 *
 * // fire event object with nested type
 * var event = { type: 'foo' };
 * events.fire(event);
 *
 * // fire event with explicit type
 * var event = { x: 10, y: 20 };
 * events.fire('element.moved', event);
 *
 * // pass additional arguments to the event
 * events.on('foo', function(event, bar) {
 *   alert(bar);
 * });
 *
 * events.fire({ type: 'foo' }, 'I am bar!');
 *
 * @param {string} [type] The event type.
 * @param {Object} [data] The event or event data.
 * @param {...*} additional Additional arguments the callback will be called with.
 *
 * @return {*} The return value. Will be set to `false` if the default was prevented.
 */ EventBus.prototype.fire = function(type, data) {
    var event, firstListener, returnValue, args;
    args = slice.call(arguments);
    if (typeof type === 'object') {
        data = type;
        type = data.type;
    }
    if (!type) throw new Error('no event type specified');
    firstListener = this._listeners[type];
    if (!firstListener) return;
    // we make sure we fire instances of our home made
    // events here. We wrap them only once, though
    if (data instanceof InternalEvent) // we are fine, we alread have an event
    event = data;
    else event = this.createEvent(data);
    // ensure we pass the event as the first parameter
    args[0] = event;
    // original event type (in case we delegate)
    var originalType = event.type;
    // update event type before delegation
    if (type !== originalType) event.type = type;
    try {
        returnValue = this._invokeListeners(event, args, firstListener);
    } finally{
        // reset event type after delegation
        if (type !== originalType) event.type = originalType;
    }
    // set the return value to false if the event default
    // got prevented and no other return value exists
    if (returnValue === undefined && event.defaultPrevented) returnValue = false;
    return returnValue;
};
/**
 * Handle an error by firing an event.
 *
 * @param {Error} error The error to be handled.
 *
 * @return {boolean} Whether the error was handled.
 */ EventBus.prototype.handleError = function(error) {
    return this.fire('error', {
        error: error
    }) === false;
};
EventBus.prototype._destroy = function() {
    this._listeners = {};
};
EventBus.prototype._invokeListeners = function(event, args, listener) {
    var returnValue;
    while(listener){
        // handle stopped propagation
        if (event.cancelBubble) break;
        returnValue = this._invokeListener(event, args, listener);
        listener = listener.next;
    }
    return returnValue;
};
EventBus.prototype._invokeListener = function(event, args, listener) {
    var returnValue;
    if (listener.callback.__isTomb) return returnValue;
    try {
        // returning false prevents the default action
        returnValue = invokeFunction(listener.callback, args);
        // stop propagation on return value
        if (returnValue !== undefined) {
            event.returnValue = returnValue;
            event.stopPropagation();
        }
        // prevent default on return false
        if (returnValue === false) event.preventDefault();
    } catch (error) {
        if (!this.handleError(error)) {
            console.error('unhandled error in event listener', error);
            throw error;
        }
    }
    return returnValue;
};
/**
 * Add new listener with a certain priority to the list
 * of listeners (for the given event).
 *
 * The semantics of listener registration / listener execution are
 * first register, first serve: New listeners will always be inserted
 * after existing listeners with the same priority.
 *
 * Example: Inserting two listeners with priority 1000 and 1300
 *
 *    * before: [ 1500, 1500, 1000, 1000 ]
 *    * after: [ 1500, 1500, (new=1300), 1000, 1000, (new=1000) ]
 *
 * @param {string} event
 * @param {EventListener} listener
 */ EventBus.prototype._addListener = function(event, newListener) {
    var listener = this._getListeners(event), previousListener;
    // no prior listeners
    if (!listener) {
        this._setListeners(event, newListener);
        return;
    }
    // ensure we order listeners by priority from
    // 0 (high) to n > 0 (low)
    while(listener){
        if (listener.priority < newListener.priority) {
            newListener.next = listener;
            if (previousListener) previousListener.next = newListener;
            else this._setListeners(event, newListener);
            return;
        }
        previousListener = listener;
        listener = listener.next;
    }
    // add new listener to back
    previousListener.next = newListener;
};
EventBus.prototype._getListeners = function(name) {
    return this._listeners[name];
};
EventBus.prototype._setListeners = function(name, listener) {
    this._listeners[name] = listener;
};
EventBus.prototype._removeListener = function(event, callback) {
    var listener = this._getListeners(event), nextListener, previousListener, listenerCallback;
    if (!callback) {
        // clear listeners
        this._setListeners(event, null);
        return;
    }
    while(listener){
        nextListener = listener.next;
        listenerCallback = listener.callback;
        if (listenerCallback === callback || listenerCallback[FN_REF] === callback) {
            if (previousListener) previousListener.next = nextListener;
            else // new first listener
            this._setListeners(event, nextListener);
        }
        previousListener = listener;
        listener = nextListener;
    }
};
/**
 * A event that is emitted via the event bus.
 */ function InternalEvent() {}
InternalEvent.prototype.stopPropagation = function() {
    this.cancelBubble = true;
};
InternalEvent.prototype.preventDefault = function() {
    this.defaultPrevented = true;
};
InternalEvent.prototype.init = function(data) {
    (0, _minDash.assign)(this, data || {});
};
/**
 * Invoke function. Be fast...
 *
 * @param {Function} fn
 * @param {*[]} args
 *
 * @return {*}
 */ function invokeFunction(fn, args) {
    return fn.apply(null, args);
}

},{"min-dash":"aEEla","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8u1E7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>GraphicsFactory);
var _minDash = require("min-dash");
var _graphicsUtil = require("../util/GraphicsUtil");
var _svgTransformUtil = require("../util/SvgTransformUtil");
var _minDom = require("min-dom");
var _tinySvg = require("tiny-svg");
var _elements = require("../util/Elements");
function GraphicsFactory(eventBus, elementRegistry) {
    this._eventBus = eventBus;
    this._elementRegistry = elementRegistry;
}
GraphicsFactory.$inject = [
    'eventBus',
    'elementRegistry'
];
GraphicsFactory.prototype._getChildrenContainer = function(element) {
    var gfx = this._elementRegistry.getGraphics(element);
    var childrenGfx;
    // root element
    if (!element.parent) childrenGfx = gfx;
    else {
        childrenGfx = (0, _graphicsUtil.getChildren)(gfx);
        if (!childrenGfx) {
            childrenGfx = (0, _tinySvg.create)('g');
            (0, _tinySvg.classes)(childrenGfx).add('djs-children');
            (0, _tinySvg.append)(gfx.parentNode, childrenGfx);
        }
    }
    return childrenGfx;
};
/**
 * Clears the graphical representation of the element and returns the
 * cleared visual (the <g class="djs-visual" /> element).
 */ GraphicsFactory.prototype._clear = function(gfx) {
    var visual = (0, _graphicsUtil.getVisual)(gfx);
    (0, _minDom.clear)(visual);
    return visual;
};
/**
 * Creates a gfx container for shapes and connections
 *
 * The layout is as follows:
 *
 * <g class="djs-group">
 *
 *   <!-- the gfx -->
 *   <g class="djs-element djs-(shape|connection|frame)">
 *     <g class="djs-visual">
 *       <!-- the renderer draws in here -->
 *     </g>
 *
 *     <!-- extensions (overlays, click box, ...) goes here
 *   </g>
 *
 *   <!-- the gfx child nodes -->
 *   <g class="djs-children"></g>
 * </g>
 *
 * @param {string} type the type of the element, i.e. shape | connection
 * @param {SVGElement} childrenGfx
 * @param {number} [parentIndex] position to create container in parent
 * @param {boolean} [isFrame] is frame element
 *
 * @return {SVGElement}
 */ GraphicsFactory.prototype._createContainer = function(type, childrenGfx, parentIndex, isFrame) {
    var outerGfx = (0, _tinySvg.create)('g');
    (0, _tinySvg.classes)(outerGfx).add('djs-group');
    // insert node at position
    if (typeof parentIndex !== 'undefined') prependTo(outerGfx, childrenGfx, childrenGfx.childNodes[parentIndex]);
    else (0, _tinySvg.append)(childrenGfx, outerGfx);
    var gfx = (0, _tinySvg.create)('g');
    (0, _tinySvg.classes)(gfx).add('djs-element');
    (0, _tinySvg.classes)(gfx).add('djs-' + type);
    if (isFrame) (0, _tinySvg.classes)(gfx).add('djs-frame');
    (0, _tinySvg.append)(outerGfx, gfx);
    // create visual
    var visual = (0, _tinySvg.create)('g');
    (0, _tinySvg.classes)(visual).add('djs-visual');
    (0, _tinySvg.append)(gfx, visual);
    return gfx;
};
/**
 * Create a graphical element.
 *
 * @param {ModelType} type The type of the element.
 * @param {ElementLike} element The element.
 * @param {number} [parentIndex] The index at which to add the graphical element to its parent's children.
 *
 * @return {SVGElement} The graphical element.
 */ GraphicsFactory.prototype.create = function(type, element, parentIndex) {
    var childrenGfx = this._getChildrenContainer(element.parent);
    return this._createContainer(type, childrenGfx, parentIndex, (0, _elements.isFrameElement)(element));
};
/**
 * Update the containments of the given elements.
 *
 * @param {ElementLike[]} elements The elements.
 */ GraphicsFactory.prototype.updateContainments = function(elements) {
    var self = this, elementRegistry = this._elementRegistry, parents;
    parents = (0, _minDash.reduce)(elements, function(map, e) {
        if (e.parent) map[e.parent.id] = e.parent;
        return map;
    }, {});
    // update all parents of changed and reorganized their children
    // in the correct order (as indicated in our model)
    (0, _minDash.forEach)(parents, function(parent) {
        var children = parent.children;
        if (!children) return;
        var childrenGfx = self._getChildrenContainer(parent);
        (0, _minDash.forEach)(children.slice().reverse(), function(child) {
            var childGfx = elementRegistry.getGraphics(child);
            prependTo(childGfx.parentNode, childrenGfx);
        });
    });
};
/**
 * Draw a shape.
 *
 * @param {SVGElement} visual The graphical element.
 * @param {ShapeLike} element The shape.
 */ GraphicsFactory.prototype.drawShape = function(visual, element) {
    var eventBus = this._eventBus;
    return eventBus.fire('render.shape', {
        gfx: visual,
        element: element
    });
};
/**
 * Get the path of a shape.
 *
 * @param {ShapeLike} element The shape.
 *
 * @return {string} The path of the shape.
 */ GraphicsFactory.prototype.getShapePath = function(element) {
    var eventBus = this._eventBus;
    return eventBus.fire('render.getShapePath', element);
};
/**
 * Draw a connection.
 *
 * @param {SVGElement} visual The graphical element.
 * @param {ConnectionLike} element The connection.
 */ GraphicsFactory.prototype.drawConnection = function(visual, element) {
    var eventBus = this._eventBus;
    return eventBus.fire('render.connection', {
        gfx: visual,
        element: element
    });
};
/**
 * Get the path of a connection.
 *
 * @param {ConnectionLike} element The connection.
 *
 * @return {string} The path of the connection.
 */ GraphicsFactory.prototype.getConnectionPath = function(connection) {
    var eventBus = this._eventBus;
    return eventBus.fire('render.getConnectionPath', connection);
};
/**
 * Update an elements graphical representation.
 *
 * @param {ModelTypeShape|ModelTypeConnection} type The type of the element.
 * @param {ElementLike} element The element.
 * @param {SVGElement} gfx The graphical representation.
 */ GraphicsFactory.prototype.update = function(type, element, gfx) {
    // do NOT update root element
    if (!element.parent) return;
    var visual = this._clear(gfx);
    // redraw
    if (type === 'shape') {
        this.drawShape(visual, element);
        // update positioning
        (0, _svgTransformUtil.translate)(gfx, element.x, element.y);
    } else if (type === 'connection') this.drawConnection(visual, element);
    else throw new Error('unknown type: ' + type);
    if (element.hidden) (0, _tinySvg.attr)(gfx, 'display', 'none');
    else (0, _tinySvg.attr)(gfx, 'display', 'block');
};
/**
 * Remove a graphical element.
 *
 * @param {ElementLike} element The element.
 */ GraphicsFactory.prototype.remove = function(element) {
    var gfx = this._elementRegistry.getGraphics(element);
    // remove
    (0, _tinySvg.remove)(gfx.parentNode);
};
// helpers //////////
function prependTo(newNode, parentNode, siblingNode) {
    var node = siblingNode || parentNode.firstChild;
    // do not prepend node to itself to prevent IE from crashing
    // https://github.com/bpmn-io/bpmn-js/issues/746
    if (newNode === node) return;
    parentNode.insertBefore(newNode, node);
}

},{"min-dash":"aEEla","../util/GraphicsUtil":"2ACCV","../util/SvgTransformUtil":"g4Nbc","min-dom":"e58GC","tiny-svg":"6ZtXA","../util/Elements":"6qdtl","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2ACCV":[function(require,module,exports,__globalThis) {
/**
 * SVGs for elements are generated by the {@link GraphicsFactory}.
 *
 * This utility gives quick access to the important semantic
 * parts of an element.
 */ /**
 * Returns the visual part of a diagram element.
 *
 * @param {SVGElement} gfx
 *
 * @return {SVGElement}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getVisual", ()=>getVisual);
/**
 * Returns the children for a given diagram element.
 *
 * @param {SVGElement} gfx
 * @return {SVGElement}
 */ parcelHelpers.export(exports, "getChildren", ()=>getChildren);
function getVisual(gfx) {
    return gfx.childNodes[0];
}
function getChildren(gfx) {
    return gfx.parentNode.childNodes[1];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"g4Nbc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @param {SVGElement} element
 * @param {number} x
 * @param {number} y
 * @param {number} angle
 * @param {number} amount
 */ parcelHelpers.export(exports, "transform", ()=>transform);
/**
 * @param {SVGElement} element
 * @param {number} x
 * @param {number} y
 */ parcelHelpers.export(exports, "translate", ()=>translate);
/**
 * @param {SVGElement} element
 * @param {number} angle
 */ parcelHelpers.export(exports, "rotate", ()=>rotate);
/**
 * @param {SVGElement} element
 * @param {number} amount
 */ parcelHelpers.export(exports, "scale", ()=>scale);
var _tinySvg = require("tiny-svg");
function transform(gfx, x, y, angle, amount) {
    var translate = (0, _tinySvg.createTransform)();
    translate.setTranslate(x, y);
    var rotate = (0, _tinySvg.createTransform)();
    rotate.setRotate(angle || 0, 0, 0);
    var scale = (0, _tinySvg.createTransform)();
    scale.setScale(amount || 1, amount || 1);
    (0, _tinySvg.transform)(gfx, [
        translate,
        rotate,
        scale
    ]);
}
function translate(gfx, x, y) {
    var translate = (0, _tinySvg.createTransform)();
    translate.setTranslate(x, y);
    (0, _tinySvg.transform)(gfx, translate);
}
function rotate(gfx, angle) {
    var rotate = (0, _tinySvg.createTransform)();
    rotate.setRotate(angle, 0, 0);
    (0, _tinySvg.transform)(gfx, rotate);
}
function scale(gfx, amount) {
    var scale = (0, _tinySvg.createTransform)();
    scale.setScale(amount, amount);
    (0, _tinySvg.transform)(gfx, scale);
}

},{"tiny-svg":"6ZtXA","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"b2IVW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>simple);
var _minDash = require("min-dash");
var _moddle = require("moddle");
var _moddleXml = require("moddle-xml");
/**
 * A sub class of {@link Moddle} with support for import and export of BPMN 2.0 xml files.
 *
 * @class BpmnModdle
 * @extends Moddle
 *
 * @param {Object|Array} packages to use for instantiating the model
 * @param {Object} [options] additional options to pass over
 */ function BpmnModdle(packages, options) {
    (0, _moddle.Moddle).call(this, packages, options);
}
BpmnModdle.prototype = Object.create((0, _moddle.Moddle).prototype);
/**
 * The fromXML result.
 *
 * @typedef {Object} ParseResult
 *
 * @property {ModdleElement} rootElement
 * @property {Array<Object>} references
 * @property {Array<Error>} warnings
 * @property {Object} elementsById - a mapping containing each ID -> ModdleElement
 */ /**
 * The fromXML error.
 *
 * @typedef {Error} ParseError
 *
 * @property {Array<Error>} warnings
 */ /**
 * Instantiates a BPMN model tree from a given xml string.
 *
 * @param {String}   xmlStr
 * @param {String}   [typeName='bpmn:Definitions'] name of the root element
 * @param {Object}   [options]  options to pass to the underlying reader
 *
 * @returns {Promise<ParseResult, ParseError>}
 */ BpmnModdle.prototype.fromXML = function(xmlStr, typeName, options) {
    if (!(0, _minDash.isString)(typeName)) {
        options = typeName;
        typeName = 'bpmn:Definitions';
    }
    var reader = new (0, _moddleXml.Reader)((0, _minDash.assign)({
        model: this,
        lax: true
    }, options));
    var rootHandler = reader.handler(typeName);
    return reader.fromXML(xmlStr, rootHandler);
};
/**
 * The toXML result.
 *
 * @typedef {Object} SerializationResult
 *
 * @property {String} xml
 */ /**
 * Serializes a BPMN 2.0 object tree to XML.
 *
 * @param {String}   element    the root element, typically an instance of `bpmn:Definitions`
 * @param {Object}   [options]  to pass to the underlying writer
 *
 * @returns {Promise<SerializationResult, Error>}
 */ BpmnModdle.prototype.toXML = function(element, options) {
    var writer = new (0, _moddleXml.Writer)(options);
    return new Promise(function(resolve, reject) {
        try {
            var result = writer.toXML(element);
            return resolve({
                xml: result
            });
        } catch (err) {
            return reject(err);
        }
    });
};
var name$5 = "BPMN20";
var uri$5 = "http://www.omg.org/spec/BPMN/20100524/MODEL";
var prefix$5 = "bpmn";
var associations$5 = [];
var types$5 = [
    {
        name: "Interface",
        superClass: [
            "RootElement"
        ],
        properties: [
            {
                name: "name",
                isAttr: true,
                type: "String"
            },
            {
                name: "operations",
                type: "Operation",
                isMany: true
            },
            {
                name: "implementationRef",
                isAttr: true,
                type: "String"
            }
        ]
    },
    {
        name: "Operation",
        superClass: [
            "BaseElement"
        ],
        properties: [
            {
                name: "name",
                isAttr: true,
                type: "String"
            },
            {
                name: "inMessageRef",
                type: "Message",
                isReference: true
            },
            {
                name: "outMessageRef",
                type: "Message",
                isReference: true
            },
            {
                name: "errorRef",
                type: "Error",
                isMany: true,
                isReference: true
            },
            {
                name: "implementationRef",
                isAttr: true,
                type: "String"
            }
        ]
    },
    {
        name: "EndPoint",
        superClass: [
            "RootElement"
        ]
    },
    {
        name: "Auditing",
        superClass: [
            "BaseElement"
        ]
    },
    {
        name: "GlobalTask",
        superClass: [
            "CallableElement"
        ],
        properties: [
            {
                name: "resources",
                type: "ResourceRole",
                isMany: true
            }
        ]
    },
    {
        name: "Monitoring",
        superClass: [
            "BaseElement"
        ]
    },
    {
        name: "Performer",
        superClass: [
            "ResourceRole"
        ]
    },
    {
        name: "Process",
        superClass: [
            "FlowElementsContainer",
            "CallableElement"
        ],
        properties: [
            {
                name: "processType",
                type: "ProcessType",
                isAttr: true
            },
            {
                name: "isClosed",
                isAttr: true,
                type: "Boolean"
            },
            {
                name: "auditing",
                type: "Auditing"
            },
            {
                name: "monitoring",
                type: "Monitoring"
            },
            {
                name: "properties",
                type: "Property",
                isMany: true
            },
            {
                name: "laneSets",
                isMany: true,
                replaces: "FlowElementsContainer#laneSets",
                type: "LaneSet"
            },
            {
                name: "flowElements",
                isMany: true,
                replaces: "FlowElementsContainer#flowElements",
                type: "FlowElement"
            },
            {
                name: "artifacts",
                type: "Artifact",
                isMany: true
            },
            {
                name: "resources",
                type: "ResourceRole",
                isMany: true
            },
            {
                name: "correlationSubscriptions",
                type: "CorrelationSubscription",
                isMany: true
            },
            {
                name: "supports",
                type: "Process",
                isMany: true,
                isReference: true
            },
            {
                name: "definitionalCollaborationRef",
                type: "Collaboration",
                isAttr: true,
                isReference: true
            },
            {
                name: "isExecutable",
                isAttr: true,
                type: "Boolean"
            }
        ]
    },
    {
        name: "LaneSet",
        superClass: [
            "BaseElement"
        ],
        properties: [
            {
                name: "lanes",
                type: "Lane",
                isMany: true
            },
            {
                name: "name",
                isAttr: true,
                type: "String"
            }
        ]
    },
    {
        name: "Lane",
        superClass: [
            "BaseElement"
        ],
        properties: [
            {
                name: "name",
                isAttr: true,
                type: "String"
            },
            {
                name: "partitionElementRef",
                type: "BaseElement",
                isAttr: true,
                isReference: true
            },
            {
                name: "partitionElement",
                type: "BaseElement"
            },
            {
                name: "flowNodeRef",
                type: "FlowNode",
                isMany: true,
                isReference: true
            },
            {
                name: "childLaneSet",
                type: "LaneSet",
                xml: {
                    serialize: "xsi:type"
                }
            }
        ]
    },
    {
        name: "GlobalManualTask",
        superClass: [
            "GlobalTask"
        ]
    },
    {
        name: "ManualTask",
        superClass: [
            "Task"
        ]
    },
    {
        name: "UserTask",
        superClass: [
            "Task"
        ],
        properties: [
            {
                name: "renderings",
                type: "Rendering",
                isMany: true
            },
            {
                name: "implementation",
                isAttr: true,
                type: "String"
            }
        ]
    },
    {
        name: "Rendering",
        superClass: [
            "BaseElement"
        ]
    },
    {
        name: "HumanPerformer",
        superClass: [
            "Performer"
        ]
    },
    {
        name: "PotentialOwner",
        superClass: [
            "HumanPerformer"
        ]
    },
    {
        name: "GlobalUserTask",
        superClass: [
            "GlobalTask"
        ],
        properties: [
            {
                name: "implementation",
                isAttr: true,
                type: "String"
            },
            {
                name: "renderings",
                type: "Rendering",
                isMany: true
            }
        ]
    },
    {
        name: "Gateway",
        isAbstract: true,
        superClass: [
            "FlowNode"
        ],
        properties: [
            {
                name: "gatewayDirection",
                type: "GatewayDirection",
                "default": "Unspecified",
                isAttr: true
            }
        ]
    },
    {
        name: "EventBasedGateway",
        superClass: [
            "Gateway"
        ],
        properties: [
            {
                name: "instantiate",
                "default": false,
                isAttr: true,
                type: "Boolean"
            },
            {
                name: "eventGatewayType",
                type: "EventBasedGatewayType",
                isAttr: true,
                "default": "Exclusive"
            }
        ]
    },
    {
        name: "ComplexGateway",
        superClass: [
            "Gateway"
        ],
        properties: [
            {
                name: "activationCondition",
                type: "Expression",
                xml: {
                    serialize: "xsi:type"
                }
            },
            {
                name: "default",
                type: "SequenceFlow",
                isAttr: true,
                isReference: true
            }
        ]
    },
    {
        name: "ExclusiveGateway",
        superClass: [
            "Gateway"
        ],
        properties: [
            {
                name: "default",
                type: "SequenceFlow",
                isAttr: true,
                isReference: true
            }
        ]
    },
    {
        name: "InclusiveGateway",
        superClass: [
            "Gateway"
        ],
        properties: [
            {
                name: "default",
                type: "SequenceFlow",
                isAttr: true,
                isReference: true
            }
        ]
    },
    {
        name: "ParallelGateway",
        superClass: [
            "Gateway"
        ]
    },
    {
        name: "RootElement",
        isAbstract: true,
        superClass: [
            "BaseElement"
        ]
    },
    {
        name: "Relationship",
        superClass: [
            "BaseElement"
        ],
        properties: [
            {
                name: "type",
                isAttr: true,
                type: "String"
            },
            {
                name: "direction",
                type: "RelationshipDirection",
                isAttr: true
            },
            {
                name: "source",
                isMany: true,
                isReference: true,
                type: "Element"
            },
            {
                name: "target",
                isMany: true,
                isReference: true,
                type: "Element"
            }
        ]
    },
    {
        name: "BaseElement",
        isAbstract: true,
        properties: [
            {
                name: "id",
                isAttr: true,
                type: "String",
                isId: true
            },
            {
                name: "documentation",
                type: "Documentation",
                isMany: true
            },
            {
                name: "extensionDefinitions",
                type: "ExtensionDefinition",
                isMany: true,
                isReference: true
            },
            {
                name: "extensionElements",
                type: "ExtensionElements"
            }
        ]
    },
    {
        name: "Extension",
        properties: [
            {
                name: "mustUnderstand",
                "default": false,
                isAttr: true,
                type: "Boolean"
            },
            {
                name: "definition",
                type: "ExtensionDefinition",
                isAttr: true,
                isReference: true
            }
        ]
    },
    {
        name: "ExtensionDefinition",
        properties: [
            {
                name: "name",
                isAttr: true,
                type: "String"
            },
            {
                name: "extensionAttributeDefinitions",
                type: "ExtensionAttributeDefinition",
                isMany: true
            }
        ]
    },
    {
        name: "ExtensionAttributeDefinition",
        properties: [
            {
                name: "name",
                isAttr: true,
                type: "String"
            },
            {
                name: "type",
                isAttr: true,
                type: "String"
            },
            {
                name: "isReference",
                "default": false,
                isAttr: true,
                type: "Boolean"
            },
            {
                name: "extensionDefinition",
                type: "ExtensionDefinition",
                isAttr: true,
                isReference: true
            }
        ]
    },
    {
        name: "ExtensionElements",
        properties: [
            {
                name: "valueRef",
                isAttr: true,
                isReference: true,
                type: "Element"
            },
            {
                name: "values",
                type: "Element",
                isMany: true
            },
            {
                name: "extensionAttributeDefinition",
                type: "ExtensionAttributeDefinition",
                isAttr: true,
                isReference: true
            }
        ]
    },
    {
        name: "Documentation",
        superClass: [
            "BaseElement"
        ],
        properties: [
            {
                name: "text",
                type: "String",
                isBody: true
            },
            {
                name: "textFormat",
                "default": "text/plain",
                isAttr: true,
                type: "String"
            }
        ]
    },
    {
        name: "Event",
        isAbstract: true,
        superClass: [
            "FlowNode",
            "InteractionNode"
        ],
        properties: [
            {
                name: "properties",
                type: "Property",
                isMany: true
            }
        ]
    },
    {
        name: "IntermediateCatchEvent",
        superClass: [
            "CatchEvent"
        ]
    },
    {
        name: "IntermediateThrowEvent",
        superClass: [
            "ThrowEvent"
        ]
    },
    {
        name: "EndEvent",
        superClass: [
            "ThrowEvent"
        ]
    },
    {
        name: "StartEvent",
        superClass: [
            "CatchEvent"
        ],
        properties: [
            {
                name: "isInterrupting",
                "default": true,
                isAttr: true,
                type: "Boolean"
            }
        ]
    },
    {
        name: "ThrowEvent",
        isAbstract: true,
        superClass: [
            "Event"
        ],
        properties: [
            {
                name: "dataInputs",
                type: "DataInput",
                isMany: true
            },
            {
                name: "dataInputAssociations",
                type: "DataInputAssociation",
                isMany: true
            },
            {
                name: "inputSet",
                type: "InputSet"
            },
            {
                name: "eventDefinitions",
                type: "EventDefinition",
                isMany: true
            },
            {
                name: "eventDefinitionRef",
                type: "EventDefinition",
                isMany: true,
                isReference: true
            }
        ]
    },
    {
        name: "CatchEvent",
        isAbstract: true,
        superClass: [
            "Event"
        ],
        properties: [
            {
                name: "parallelMultiple",
                isAttr: true,
                type: "Boolean",
                "default": false
            },
            {
                name: "dataOutputs",
                type: "DataOutput",
                isMany: true
            },
            {
                name: "dataOutputAssociations",
                type: "DataOutputAssociation",
                isMany: true
            },
            {
                name: "outputSet",
                type: "OutputSet"
            },
            {
                name: "eventDefinitions",
                type: "EventDefinition",
                isMany: true
            },
            {
                name: "eventDefinitionRef",
                type: "EventDefinition",
                isMany: true,
                isReference: true
            }
        ]
    },
    {
        name: "BoundaryEvent",
        superClass: [
            "CatchEvent"
        ],
        properties: [
            {
                name: "cancelActivity",
                "default": true,
                isAttr: true,
                type: "Boolean"
            },
            {
                name: "attachedToRef",
                type: "Activity",
                isAttr: true,
                isReference: true
            }
        ]
    },
    {
        name: "EventDefinition",
        isAbstract: true,
        superClass: [
            "RootElement"
        ]
    },
    {
        name: "CancelEventDefinition",
        superClass: [
            "EventDefinition"
        ]
    },
    {
        name: "ErrorEventDefinition",
        superClass: [
            "EventDefinition"
        ],
        properties: [
            {
                name: "errorRef",
                type: "Error",
                isAttr: true,
                isReference: true
            }
        ]
    },
    {
        name: "TerminateEventDefinition",
        superClass: [
            "EventDefinition"
        ]
    },
    {
        name: "EscalationEventDefinition",
        superClass: [
            "EventDefinition"
        ],
        properties: [
            {
                name: "escalationRef",
                type: "Escalation",
                isAttr: true,
                isReference: true
            }
        ]
    },
    {
        name: "Escalation",
        properties: [
            {
                name: "structureRef",
                type: "ItemDefinition",
                isAttr: true,
                isReference: true
            },
            {
                name: "name",
                isAttr: true,
                type: "String"
            },
            {
                name: "escalationCode",
                isAttr: true,
                type: "String"
            }
        ],
        superClass: [
            "RootElement"
        ]
    },
    {
        name: "CompensateEventDefinition",
        superClass: [
            "EventDefinition"
        ],
        properties: [
            {
                name: "waitForCompletion",
                isAttr: true,
                type: "Boolean",
                "default": true
            },
            {
                name: "activityRef",
                type: "Activity",
                isAttr: true,
                isReference: true
            }
        ]
    },
    {
        name: "TimerEventDefinition",
        superClass: [
            "EventDefinition"
        ],
        properties: [
            {
                name: "timeDate",
                type: "Expression",
                xml: {
                    serialize: "xsi:type"
                }
            },
            {
                name: "timeCycle",
                type: "Expression",
                xml: {
                    serialize: "xsi:type"
                }
            },
            {
                name: "timeDuration",
                type: "Expression",
                xml: {
                    serialize: "xsi:type"
                }
            }
        ]
    },
    {
        name: "LinkEventDefinition",
        superClass: [
            "EventDefinition"
        ],
        properties: [
            {
                name: "name",
                isAttr: true,
                type: "String"
            },
            {
                name: "target",
                type: "LinkEventDefinition",
                isReference: true
            },
            {
                name: "source",
                type: "LinkEventDefinition",
                isMany: true,
                isReference: true
            }
        ]
    },
    {
        name: "MessageEventDefinition",
        superClass: [
            "EventDefinition"
        ],
        properties: [
            {
                name: "messageRef",
                type: "Message",
                isAttr: true,
                isReference: true
            },
            {
                name: "operationRef",
                type: "Operation",
                isAttr: true,
                isReference: true
            }
        ]
    },
    {
        name: "ConditionalEventDefinition",
        superClass: [
            "EventDefinition"
        ],
        properties: [
            {
                name: "condition",
                type: "Expression",
                xml: {
                    serialize: "xsi:type"
                }
            }
        ]
    },
    {
        name: "SignalEventDefinition",
        superClass: [
            "EventDefinition"
        ],
        properties: [
            {
                name: "signalRef",
                type: "Signal",
                isAttr: true,
                isReference: true
            }
        ]
    },
    {
        name: "Signal",
        superClass: [
            "RootElement"
        ],
        properties: [
            {
                name: "structureRef",
                type: "ItemDefinition",
                isAttr: true,
                isReference: true
            },
            {
                name: "name",
                isAttr: true,
                type: "String"
            }
        ]
    },
    {
        name: "ImplicitThrowEvent",
        superClass: [
            "ThrowEvent"
        ]
    },
    {
        name: "DataState",
        superClass: [
            "BaseElement"
        ],
        properties: [
            {
                name: "name",
                isAttr: true,
                type: "String"
            }
        ]
    },
    {
        name: "ItemAwareElement",
        superClass: [
            "BaseElement"
        ],
        properties: [
            {
                name: "itemSubjectRef",
                type: "ItemDefinition",
                isAttr: true,
                isReference: true
            },
            {
                name: "dataState",
                type: "DataState"
            }
        ]
    },
    {
        name: "DataAssociation",
        superClass: [
            "BaseElement"
        ],
        properties: [
            {
                name: "sourceRef",
                type: "ItemAwareElement",
                isMany: true,
                isReference: true
            },
            {
                name: "targetRef",
                type: "ItemAwareElement",
                isReference: true
            },
            {
                name: "transformation",
                type: "FormalExpression",
                xml: {
                    serialize: "property"
                }
            },
            {
                name: "assignment",
                type: "Assignment",
                isMany: true
            }
        ]
    },
    {
        name: "DataInput",
        superClass: [
            "ItemAwareElement"
        ],
        properties: [
            {
                name: "name",
                isAttr: true,
                type: "String"
            },
            {
                name: "isCollection",
                "default": false,
                isAttr: true,
                type: "Boolean"
            },
            {
                name: "inputSetRef",
                type: "InputSet",
                isMany: true,
                isVirtual: true,
                isReference: true
            },
            {
                name: "inputSetWithOptional",
                type: "InputSet",
                isMany: true,
                isVirtual: true,
                isReference: true
            },
            {
                name: "inputSetWithWhileExecuting",
                type: "InputSet",
                isMany: true,
                isVirtual: true,
                isReference: true
            }
        ]
    },
    {
        name: "DataOutput",
        superClass: [
            "ItemAwareElement"
        ],
        properties: [
            {
                name: "name",
                isAttr: true,
                type: "String"
            },
            {
                name: "isCollection",
                "default": false,
                isAttr: true,
                type: "Boolean"
            },
            {
                name: "outputSetRef",
                type: "OutputSet",
                isMany: true,
                isVirtual: true,
                isReference: true
            },
            {
                name: "outputSetWithOptional",
                type: "OutputSet",
                isMany: true,
                isVirtual: true,
                isReference: true
            },
            {
                name: "outputSetWithWhileExecuting",
                type: "OutputSet",
                isMany: true,
                isVirtual: true,
                isReference: true
            }
        ]
    },
    {
        name: "InputSet",
        superClass: [
            "BaseElement"
        ],
        properties: [
            {
                name: "name",
                isAttr: true,
                type: "String"
            },
            {
                name: "dataInputRefs",
                type: "DataInput",
                isMany: true,
                isReference: true
            },
            {
                name: "optionalInputRefs",
                type: "DataInput",
                isMany: true,
                isReference: true
            },
            {
                name: "whileExecutingInputRefs",
                type: "DataInput",
                isMany: true,
                isReference: true
            },
            {
                name: "outputSetRefs",
                type: "OutputSet",
                isMany: true,
                isReference: true
            }
        ]
    },
    {
        name: "OutputSet",
        superClass: [
            "BaseElement"
        ],
        properties: [
            {
                name: "dataOutputRefs",
                type: "DataOutput",
                isMany: true,
                isReference: true
            },
            {
                name: "name",
                isAttr: true,
                type: "String"
            },
            {
                name: "inputSetRefs",
                type: "InputSet",
                isMany: true,
                isReference: true
            },
            {
                name: "optionalOutputRefs",
                type: "DataOutput",
                isMany: true,
                isReference: true
            },
            {
                name: "whileExecutingOutputRefs",
                type: "DataOutput",
                isMany: true,
                isReference: true
            }
        ]
    },
    {
        name: "Property",
        superClass: [
            "ItemAwareElement"
        ],
        properties: [
            {
                name: "name",
                isAttr: true,
                type: "String"
            }
        ]
    },
    {
        name: "DataInputAssociation",
        superClass: [
            "DataAssociation"
        ]
    },
    {
        name: "DataOutputAssociation",
        superClass: [
            "DataAssociation"
        ]
    },
    {
        name: "InputOutputSpecification",
        superClass: [
            "BaseElement"
        ],
        properties: [
            {
                name: "dataInputs",
                type: "DataInput",
                isMany: true
            },
            {
                name: "dataOutputs",
                type: "DataOutput",
                isMany: true
            },
            {
                name: "inputSets",
                type: "InputSet",
                isMany: true
            },
            {
                name: "outputSets",
                type: "OutputSet",
                isMany: true
            }
        ]
    },
    {
        name: "DataObject",
        superClass: [
            "FlowElement",
            "ItemAwareElement"
        ],
        properties: [
            {
                name: "isCollection",
                "default": false,
                isAttr: true,
                type: "Boolean"
            }
        ]
    },
    {
        name: "InputOutputBinding",
        properties: [
            {
                name: "inputDataRef",
                type: "InputSet",
                isAttr: true,
                isReference: true
            },
            {
                name: "outputDataRef",
                type: "OutputSet",
                isAttr: true,
                isReference: true
            },
            {
                name: "operationRef",
                type: "Operation",
                isAttr: true,
                isReference: true
            }
        ]
    },
    {
        name: "Assignment",
        superClass: [
            "BaseElement"
        ],
        properties: [
            {
                name: "from",
                type: "Expression",
                xml: {
                    serialize: "xsi:type"
                }
            },
            {
                name: "to",
                type: "Expression",
                xml: {
                    serialize: "xsi:type"
                }
            }
        ]
    },
    {
        name: "DataStore",
        superClass: [
            "RootElement",
            "ItemAwareElement"
        ],
        properties: [
            {
                name: "name",
                isAttr: true,
                type: "String"
            },
            {
                name: "capacity",
                isAttr: true,
                type: "Integer"
            },
            {
                name: "isUnlimited",
                "default": true,
                isAttr: true,
                type: "Boolean"
            }
        ]
    },
    {
        name: "DataStoreReference",
        superClass: [
            "ItemAwareElement",
            "FlowElement"
        ],
        properties: [
            {
                name: "dataStoreRef",
                type: "DataStore",
                isAttr: true,
                isReference: true
            }
        ]
    },
    {
        name: "DataObjectReference",
        superClass: [
            "ItemAwareElement",
            "FlowElement"
        ],
        properties: [
            {
                name: "dataObjectRef",
                type: "DataObject",
                isAttr: true,
                isReference: true
            }
        ]
    },
    {
        name: "ConversationLink",
        superClass: [
            "BaseElement"
        ],
        properties: [
            {
                name: "sourceRef",
                type: "InteractionNode",
                isAttr: true,
                isReference: true
            },
            {
                name: "targetRef",
                type: "InteractionNode",
                isAttr: true,
                isReference: true
            },
            {
                name: "name",
                isAttr: true,
                type: "String"
            }
        ]
    },
    {
        name: "ConversationAssociation",
        superClass: [
            "BaseElement"
        ],
        properties: [
            {
                name: "innerConversationNodeRef",
                type: "ConversationNode",
                isAttr: true,
                isReference: true
            },
            {
                name: "outerConversationNodeRef",
                type: "ConversationNode",
                isAttr: true,
                isReference: true
            }
        ]
    },
    {
        name: "CallConversation",
        superClass: [
            "ConversationNode"
        ],
        properties: [
            {
                name: "calledCollaborationRef",
                type: "Collaboration",
                isAttr: true,
                isReference: true
            },
            {
                name: "participantAssociations",
                type: "ParticipantAssociation",
                isMany: true
            }
        ]
    },
    {
        name: "Conversation",
        superClass: [
            "ConversationNode"
        ]
    },
    {
        name: "SubConversation",
        superClass: [
            "ConversationNode"
        ],
        properties: [
            {
                name: "conversationNodes",
                type: "ConversationNode",
                isMany: true
            }
        ]
    },
    {
        name: "ConversationNode",
        isAbstract: true,
        superClass: [
            "InteractionNode",
            "BaseElement"
        ],
        properties: [
            {
                name: "name",
                isAttr: true,
                type: "String"
            },
            {
                name: "participantRef",
                type: "Participant",
                isMany: true,
                isReference: true
            },
            {
                name: "messageFlowRefs",
                type: "MessageFlow",
                isMany: true,
                isReference: true
            },
            {
                name: "correlationKeys",
                type: "CorrelationKey",
                isMany: true
            }
        ]
    },
    {
        name: "GlobalConversation",
        superClass: [
            "Collaboration"
        ]
    },
    {
        name: "PartnerEntity",
        superClass: [
            "RootElement"
        ],
        properties: [
            {
                name: "name",
                isAttr: true,
                type: "String"
            },
            {
                name: "participantRef",
                type: "Participant",
                isMany: true,
                isReference: true
            }
        ]
    },
    {
        name: "PartnerRole",
        superClass: [
            "RootElement"
        ],
        properties: [
            {
                name: "name",
                isAttr: true,
                type: "String"
            },
            {
                name: "participantRef",
                type: "Participant",
                isMany: true,
                isReference: true
            }
        ]
    },
    {
        name: "CorrelationProperty",
        superClass: [
            "RootElement"
        ],
        properties: [
            {
                name: "correlationPropertyRetrievalExpression",
                type: "CorrelationPropertyRetrievalExpression",
                isMany: true
            },
            {
                name: "name",
                isAttr: true,
                type: "String"
            },
            {
                name: "type",
                type: "ItemDefinition",
                isAttr: true,
                isReference: true
            }
        ]
    },
    {
        name: "Error",
        superClass: [
            "RootElement"
        ],
        properties: [
            {
                name: "structureRef",
                type: "ItemDefinition",
                isAttr: true,
                isReference: true
            },
            {
                name: "name",
                isAttr: true,
                type: "String"
            },
            {
                name: "errorCode",
                isAttr: true,
                type: "String"
            }
        ]
    },
    {
        name: "CorrelationKey",
        superClass: [
            "BaseElement"
        ],
        properties: [
            {
                name: "correlationPropertyRef",
                type: "CorrelationProperty",
                isMany: true,
                isReference: true
            },
            {
                name: "name",
                isAttr: true,
                type: "String"
            }
        ]
    },
    {
        name: "Expression",
        superClass: [
            "BaseElement"
        ],
        isAbstract: false,
        properties: [
            {
                name: "body",
                isBody: true,
                type: "String"
            }
        ]
    },
    {
        name: "FormalExpression",
        superClass: [
            "Expression"
        ],
        properties: [
            {
                name: "language",
                isAttr: true,
                type: "String"
            },
            {
                name: "evaluatesToTypeRef",
                type: "ItemDefinition",
                isAttr: true,
                isReference: true
            }
        ]
    },
    {
        name: "Message",
        superClass: [
            "RootElement"
        ],
        properties: [
            {
                name: "name",
                isAttr: true,
                type: "String"
            },
            {
                name: "itemRef",
                type: "ItemDefinition",
                isAttr: true,
                isReference: true
            }
        ]
    },
    {
        name: "ItemDefinition",
        superClass: [
            "RootElement"
        ],
        properties: [
            {
                name: "itemKind",
                type: "ItemKind",
                isAttr: true
            },
            {
                name: "structureRef",
                isAttr: true,
                type: "String"
            },
            {
                name: "isCollection",
                "default": false,
                isAttr: true,
                type: "Boolean"
            },
            {
                name: "import",
                type: "Import",
                isAttr: true,
                isReference: true
            }
        ]
    },
    {
        name: "FlowElement",
        isAbstract: true,
        superClass: [
            "BaseElement"
        ],
        properties: [
            {
                name: "name",
                isAttr: true,
                type: "String"
            },
            {
                name: "auditing",
                type: "Auditing"
            },
            {
                name: "monitoring",
                type: "Monitoring"
            },
            {
                name: "categoryValueRef",
                type: "CategoryValue",
                isMany: true,
                isReference: true
            }
        ]
    },
    {
        name: "SequenceFlow",
        superClass: [
            "FlowElement"
        ],
        properties: [
            {
                name: "isImmediate",
                isAttr: true,
                type: "Boolean"
            },
            {
                name: "conditionExpression",
                type: "Expression",
                xml: {
                    serialize: "xsi:type"
                }
            },
            {
                name: "sourceRef",
                type: "FlowNode",
                isAttr: true,
                isReference: true
            },
            {
                name: "targetRef",
                type: "FlowNode",
                isAttr: true,
                isReference: true
            }
        ]
    },
    {
        name: "FlowElementsContainer",
        isAbstract: true,
        superClass: [
            "BaseElement"
        ],
        properties: [
            {
                name: "laneSets",
                type: "LaneSet",
                isMany: true
            },
            {
                name: "flowElements",
                type: "FlowElement",
                isMany: true
            }
        ]
    },
    {
        name: "CallableElement",
        isAbstract: true,
        superClass: [
            "RootElement"
        ],
        properties: [
            {
                name: "name",
                isAttr: true,
                type: "String"
            },
            {
                name: "ioSpecification",
                type: "InputOutputSpecification",
                xml: {
                    serialize: "property"
                }
            },
            {
                name: "supportedInterfaceRef",
                type: "Interface",
                isMany: true,
                isReference: true
            },
            {
                name: "ioBinding",
                type: "InputOutputBinding",
                isMany: true,
                xml: {
                    serialize: "property"
                }
            }
        ]
    },
    {
        name: "FlowNode",
        isAbstract: true,
        superClass: [
            "FlowElement"
        ],
        properties: [
            {
                name: "incoming",
                type: "SequenceFlow",
                isMany: true,
                isReference: true
            },
            {
                name: "outgoing",
                type: "SequenceFlow",
                isMany: true,
                isReference: true
            },
            {
                name: "lanes",
                type: "Lane",
                isMany: true,
                isVirtual: true,
                isReference: true
            }
        ]
    },
    {
        name: "CorrelationPropertyRetrievalExpression",
        superClass: [
            "BaseElement"
        ],
        properties: [
            {
                name: "messagePath",
                type: "FormalExpression"
            },
            {
                name: "messageRef",
                type: "Message",
                isAttr: true,
                isReference: true
            }
        ]
    },
    {
        name: "CorrelationPropertyBinding",
        superClass: [
            "BaseElement"
        ],
        properties: [
            {
                name: "dataPath",
                type: "FormalExpression"
            },
            {
                name: "correlationPropertyRef",
                type: "CorrelationProperty",
                isAttr: true,
                isReference: true
            }
        ]
    },
    {
        name: "Resource",
        superClass: [
            "RootElement"
        ],
        properties: [
            {
                name: "name",
                isAttr: true,
                type: "String"
            },
            {
                name: "resourceParameters",
                type: "ResourceParameter",
                isMany: true
            }
        ]
    },
    {
        name: "ResourceParameter",
        superClass: [
            "BaseElement"
        ],
        properties: [
            {
                name: "name",
                isAttr: true,
                type: "String"
            },
            {
                name: "isRequired",
                isAttr: true,
                type: "Boolean"
            },
            {
                name: "type",
                type: "ItemDefinition",
                isAttr: true,
                isReference: true
            }
        ]
    },
    {
        name: "CorrelationSubscription",
        superClass: [
            "BaseElement"
        ],
        properties: [
            {
                name: "correlationKeyRef",
                type: "CorrelationKey",
                isAttr: true,
                isReference: true
            },
            {
                name: "correlationPropertyBinding",
                type: "CorrelationPropertyBinding",
                isMany: true
            }
        ]
    },
    {
        name: "MessageFlow",
        superClass: [
            "BaseElement"
        ],
        properties: [
            {
                name: "name",
                isAttr: true,
                type: "String"
            },
            {
                name: "sourceRef",
                type: "InteractionNode",
                isAttr: true,
                isReference: true
            },
            {
                name: "targetRef",
                type: "InteractionNode",
                isAttr: true,
                isReference: true
            },
            {
                name: "messageRef",
                type: "Message",
                isAttr: true,
                isReference: true
            }
        ]
    },
    {
        name: "MessageFlowAssociation",
        superClass: [
            "BaseElement"
        ],
        properties: [
            {
                name: "innerMessageFlowRef",
                type: "MessageFlow",
                isAttr: true,
                isReference: true
            },
            {
                name: "outerMessageFlowRef",
                type: "MessageFlow",
                isAttr: true,
                isReference: true
            }
        ]
    },
    {
        name: "InteractionNode",
        isAbstract: true,
        properties: [
            {
                name: "incomingConversationLinks",
                type: "ConversationLink",
                isMany: true,
                isVirtual: true,
                isReference: true
            },
            {
                name: "outgoingConversationLinks",
                type: "ConversationLink",
                isMany: true,
                isVirtual: true,
                isReference: true
            }
        ]
    },
    {
        name: "Participant",
        superClass: [
            "InteractionNode",
            "BaseElement"
        ],
        properties: [
            {
                name: "name",
                isAttr: true,
                type: "String"
            },
            {
                name: "interfaceRef",
                type: "Interface",
                isMany: true,
                isReference: true
            },
            {
                name: "participantMultiplicity",
                type: "ParticipantMultiplicity"
            },
            {
                name: "endPointRefs",
                type: "EndPoint",
                isMany: true,
                isReference: true
            },
            {
                name: "processRef",
                type: "Process",
                isAttr: true,
                isReference: true
            }
        ]
    },
    {
        name: "ParticipantAssociation",
        superClass: [
            "BaseElement"
        ],
        properties: [
            {
                name: "innerParticipantRef",
                type: "Participant",
                isAttr: true,
                isReference: true
            },
            {
                name: "outerParticipantRef",
                type: "Participant",
                isAttr: true,
                isReference: true
            }
        ]
    },
    {
        name: "ParticipantMultiplicity",
        properties: [
            {
                name: "minimum",
                "default": 0,
                isAttr: true,
                type: "Integer"
            },
            {
                name: "maximum",
                "default": 1,
                isAttr: true,
                type: "Integer"
            }
        ],
        superClass: [
            "BaseElement"
        ]
    },
    {
        name: "Collaboration",
        superClass: [
            "RootElement"
        ],
        properties: [
            {
                name: "name",
                isAttr: true,
                type: "String"
            },
            {
                name: "isClosed",
                isAttr: true,
                type: "Boolean"
            },
            {
                name: "participants",
                type: "Participant",
                isMany: true
            },
            {
                name: "messageFlows",
                type: "MessageFlow",
                isMany: true
            },
            {
                name: "artifacts",
                type: "Artifact",
                isMany: true
            },
            {
                name: "conversations",
                type: "ConversationNode",
                isMany: true
            },
            {
                name: "conversationAssociations",
                type: "ConversationAssociation"
            },
            {
                name: "participantAssociations",
                type: "ParticipantAssociation",
                isMany: true
            },
            {
                name: "messageFlowAssociations",
                type: "MessageFlowAssociation",
                isMany: true
            },
            {
                name: "correlationKeys",
                type: "CorrelationKey",
                isMany: true
            },
            {
                name: "choreographyRef",
                type: "Choreography",
                isMany: true,
                isReference: true
            },
            {
                name: "conversationLinks",
                type: "ConversationLink",
                isMany: true
            }
        ]
    },
    {
        name: "ChoreographyActivity",
        isAbstract: true,
        superClass: [
            "FlowNode"
        ],
        properties: [
            {
                name: "participantRef",
                type: "Participant",
                isMany: true,
                isReference: true
            },
            {
                name: "initiatingParticipantRef",
                type: "Participant",
                isAttr: true,
                isReference: true
            },
            {
                name: "correlationKeys",
                type: "CorrelationKey",
                isMany: true
            },
            {
                name: "loopType",
                type: "ChoreographyLoopType",
                "default": "None",
                isAttr: true
            }
        ]
    },
    {
        name: "CallChoreography",
        superClass: [
            "ChoreographyActivity"
        ],
        properties: [
            {
                name: "calledChoreographyRef",
                type: "Choreography",
                isAttr: true,
                isReference: true
            },
            {
                name: "participantAssociations",
                type: "ParticipantAssociation",
                isMany: true
            }
        ]
    },
    {
        name: "SubChoreography",
        superClass: [
            "ChoreographyActivity",
            "FlowElementsContainer"
        ],
        properties: [
            {
                name: "artifacts",
                type: "Artifact",
                isMany: true
            }
        ]
    },
    {
        name: "ChoreographyTask",
        superClass: [
            "ChoreographyActivity"
        ],
        properties: [
            {
                name: "messageFlowRef",
                type: "MessageFlow",
                isMany: true,
                isReference: true
            }
        ]
    },
    {
        name: "Choreography",
        superClass: [
            "Collaboration",
            "FlowElementsContainer"
        ]
    },
    {
        name: "GlobalChoreographyTask",
        superClass: [
            "Choreography"
        ],
        properties: [
            {
                name: "initiatingParticipantRef",
                type: "Participant",
                isAttr: true,
                isReference: true
            }
        ]
    },
    {
        name: "TextAnnotation",
        superClass: [
            "Artifact"
        ],
        properties: [
            {
                name: "text",
                type: "String"
            },
            {
                name: "textFormat",
                "default": "text/plain",
                isAttr: true,
                type: "String"
            }
        ]
    },
    {
        name: "Group",
        superClass: [
            "Artifact"
        ],
        properties: [
            {
                name: "categoryValueRef",
                type: "CategoryValue",
                isAttr: true,
                isReference: true
            }
        ]
    },
    {
        name: "Association",
        superClass: [
            "Artifact"
        ],
        properties: [
            {
                name: "associationDirection",
                type: "AssociationDirection",
                isAttr: true
            },
            {
                name: "sourceRef",
                type: "BaseElement",
                isAttr: true,
                isReference: true
            },
            {
                name: "targetRef",
                type: "BaseElement",
                isAttr: true,
                isReference: true
            }
        ]
    },
    {
        name: "Category",
        superClass: [
            "RootElement"
        ],
        properties: [
            {
                name: "categoryValue",
                type: "CategoryValue",
                isMany: true
            },
            {
                name: "name",
                isAttr: true,
                type: "String"
            }
        ]
    },
    {
        name: "Artifact",
        isAbstract: true,
        superClass: [
            "BaseElement"
        ]
    },
    {
        name: "CategoryValue",
        superClass: [
            "BaseElement"
        ],
        properties: [
            {
                name: "categorizedFlowElements",
                type: "FlowElement",
                isMany: true,
                isVirtual: true,
                isReference: true
            },
            {
                name: "value",
                isAttr: true,
                type: "String"
            }
        ]
    },
    {
        name: "Activity",
        isAbstract: true,
        superClass: [
            "FlowNode"
        ],
        properties: [
            {
                name: "isForCompensation",
                "default": false,
                isAttr: true,
                type: "Boolean"
            },
            {
                name: "default",
                type: "SequenceFlow",
                isAttr: true,
                isReference: true
            },
            {
                name: "ioSpecification",
                type: "InputOutputSpecification",
                xml: {
                    serialize: "property"
                }
            },
            {
                name: "boundaryEventRefs",
                type: "BoundaryEvent",
                isMany: true,
                isReference: true
            },
            {
                name: "properties",
                type: "Property",
                isMany: true
            },
            {
                name: "dataInputAssociations",
                type: "DataInputAssociation",
                isMany: true
            },
            {
                name: "dataOutputAssociations",
                type: "DataOutputAssociation",
                isMany: true
            },
            {
                name: "startQuantity",
                "default": 1,
                isAttr: true,
                type: "Integer"
            },
            {
                name: "resources",
                type: "ResourceRole",
                isMany: true
            },
            {
                name: "completionQuantity",
                "default": 1,
                isAttr: true,
                type: "Integer"
            },
            {
                name: "loopCharacteristics",
                type: "LoopCharacteristics"
            }
        ]
    },
    {
        name: "ServiceTask",
        superClass: [
            "Task"
        ],
        properties: [
            {
                name: "implementation",
                isAttr: true,
                type: "String"
            },
            {
                name: "operationRef",
                type: "Operation",
                isAttr: true,
                isReference: true
            }
        ]
    },
    {
        name: "SubProcess",
        superClass: [
            "Activity",
            "FlowElementsContainer",
            "InteractionNode"
        ],
        properties: [
            {
                name: "triggeredByEvent",
                "default": false,
                isAttr: true,
                type: "Boolean"
            },
            {
                name: "artifacts",
                type: "Artifact",
                isMany: true
            }
        ]
    },
    {
        name: "LoopCharacteristics",
        isAbstract: true,
        superClass: [
            "BaseElement"
        ]
    },
    {
        name: "MultiInstanceLoopCharacteristics",
        superClass: [
            "LoopCharacteristics"
        ],
        properties: [
            {
                name: "isSequential",
                "default": false,
                isAttr: true,
                type: "Boolean"
            },
            {
                name: "behavior",
                type: "MultiInstanceBehavior",
                "default": "All",
                isAttr: true
            },
            {
                name: "loopCardinality",
                type: "Expression",
                xml: {
                    serialize: "xsi:type"
                }
            },
            {
                name: "loopDataInputRef",
                type: "ItemAwareElement",
                isReference: true
            },
            {
                name: "loopDataOutputRef",
                type: "ItemAwareElement",
                isReference: true
            },
            {
                name: "inputDataItem",
                type: "DataInput",
                xml: {
                    serialize: "property"
                }
            },
            {
                name: "outputDataItem",
                type: "DataOutput",
                xml: {
                    serialize: "property"
                }
            },
            {
                name: "complexBehaviorDefinition",
                type: "ComplexBehaviorDefinition",
                isMany: true
            },
            {
                name: "completionCondition",
                type: "Expression",
                xml: {
                    serialize: "xsi:type"
                }
            },
            {
                name: "oneBehaviorEventRef",
                type: "EventDefinition",
                isAttr: true,
                isReference: true
            },
            {
                name: "noneBehaviorEventRef",
                type: "EventDefinition",
                isAttr: true,
                isReference: true
            }
        ]
    },
    {
        name: "StandardLoopCharacteristics",
        superClass: [
            "LoopCharacteristics"
        ],
        properties: [
            {
                name: "testBefore",
                "default": false,
                isAttr: true,
                type: "Boolean"
            },
            {
                name: "loopCondition",
                type: "Expression",
                xml: {
                    serialize: "xsi:type"
                }
            },
            {
                name: "loopMaximum",
                type: "Integer",
                isAttr: true
            }
        ]
    },
    {
        name: "CallActivity",
        superClass: [
            "Activity",
            "InteractionNode"
        ],
        properties: [
            {
                name: "calledElement",
                type: "String",
                isAttr: true
            }
        ]
    },
    {
        name: "Task",
        superClass: [
            "Activity",
            "InteractionNode"
        ]
    },
    {
        name: "SendTask",
        superClass: [
            "Task"
        ],
        properties: [
            {
                name: "implementation",
                isAttr: true,
                type: "String"
            },
            {
                name: "operationRef",
                type: "Operation",
                isAttr: true,
                isReference: true
            },
            {
                name: "messageRef",
                type: "Message",
                isAttr: true,
                isReference: true
            }
        ]
    },
    {
        name: "ReceiveTask",
        superClass: [
            "Task"
        ],
        properties: [
            {
                name: "implementation",
                isAttr: true,
                type: "String"
            },
            {
                name: "instantiate",
                "default": false,
                isAttr: true,
                type: "Boolean"
            },
            {
                name: "operationRef",
                type: "Operation",
                isAttr: true,
                isReference: true
            },
            {
                name: "messageRef",
                type: "Message",
                isAttr: true,
                isReference: true
            }
        ]
    },
    {
        name: "ScriptTask",
        superClass: [
            "Task"
        ],
        properties: [
            {
                name: "scriptFormat",
                isAttr: true,
                type: "String"
            },
            {
                name: "script",
                type: "String"
            }
        ]
    },
    {
        name: "BusinessRuleTask",
        superClass: [
            "Task"
        ],
        properties: [
            {
                name: "implementation",
                isAttr: true,
                type: "String"
            }
        ]
    },
    {
        name: "AdHocSubProcess",
        superClass: [
            "SubProcess"
        ],
        properties: [
            {
                name: "completionCondition",
                type: "Expression",
                xml: {
                    serialize: "xsi:type"
                }
            },
            {
                name: "ordering",
                type: "AdHocOrdering",
                isAttr: true
            },
            {
                name: "cancelRemainingInstances",
                "default": true,
                isAttr: true,
                type: "Boolean"
            }
        ]
    },
    {
        name: "Transaction",
        superClass: [
            "SubProcess"
        ],
        properties: [
            {
                name: "protocol",
                isAttr: true,
                type: "String"
            },
            {
                name: "method",
                isAttr: true,
                type: "String"
            }
        ]
    },
    {
        name: "GlobalScriptTask",
        superClass: [
            "GlobalTask"
        ],
        properties: [
            {
                name: "scriptLanguage",
                isAttr: true,
                type: "String"
            },
            {
                name: "script",
                isAttr: true,
                type: "String"
            }
        ]
    },
    {
        name: "GlobalBusinessRuleTask",
        superClass: [
            "GlobalTask"
        ],
        properties: [
            {
                name: "implementation",
                isAttr: true,
                type: "String"
            }
        ]
    },
    {
        name: "ComplexBehaviorDefinition",
        superClass: [
            "BaseElement"
        ],
        properties: [
            {
                name: "condition",
                type: "FormalExpression"
            },
            {
                name: "event",
                type: "ImplicitThrowEvent"
            }
        ]
    },
    {
        name: "ResourceRole",
        superClass: [
            "BaseElement"
        ],
        properties: [
            {
                name: "resourceRef",
                type: "Resource",
                isReference: true
            },
            {
                name: "resourceParameterBindings",
                type: "ResourceParameterBinding",
                isMany: true
            },
            {
                name: "resourceAssignmentExpression",
                type: "ResourceAssignmentExpression"
            },
            {
                name: "name",
                isAttr: true,
                type: "String"
            }
        ]
    },
    {
        name: "ResourceParameterBinding",
        properties: [
            {
                name: "expression",
                type: "Expression",
                xml: {
                    serialize: "xsi:type"
                }
            },
            {
                name: "parameterRef",
                type: "ResourceParameter",
                isAttr: true,
                isReference: true
            }
        ],
        superClass: [
            "BaseElement"
        ]
    },
    {
        name: "ResourceAssignmentExpression",
        properties: [
            {
                name: "expression",
                type: "Expression",
                xml: {
                    serialize: "xsi:type"
                }
            }
        ],
        superClass: [
            "BaseElement"
        ]
    },
    {
        name: "Import",
        properties: [
            {
                name: "importType",
                isAttr: true,
                type: "String"
            },
            {
                name: "location",
                isAttr: true,
                type: "String"
            },
            {
                name: "namespace",
                isAttr: true,
                type: "String"
            }
        ]
    },
    {
        name: "Definitions",
        superClass: [
            "BaseElement"
        ],
        properties: [
            {
                name: "name",
                isAttr: true,
                type: "String"
            },
            {
                name: "targetNamespace",
                isAttr: true,
                type: "String"
            },
            {
                name: "expressionLanguage",
                "default": "http://www.w3.org/1999/XPath",
                isAttr: true,
                type: "String"
            },
            {
                name: "typeLanguage",
                "default": "http://www.w3.org/2001/XMLSchema",
                isAttr: true,
                type: "String"
            },
            {
                name: "imports",
                type: "Import",
                isMany: true
            },
            {
                name: "extensions",
                type: "Extension",
                isMany: true
            },
            {
                name: "rootElements",
                type: "RootElement",
                isMany: true
            },
            {
                name: "diagrams",
                isMany: true,
                type: "bpmndi:BPMNDiagram"
            },
            {
                name: "exporter",
                isAttr: true,
                type: "String"
            },
            {
                name: "relationships",
                type: "Relationship",
                isMany: true
            },
            {
                name: "exporterVersion",
                isAttr: true,
                type: "String"
            }
        ]
    }
];
var enumerations$3 = [
    {
        name: "ProcessType",
        literalValues: [
            {
                name: "None"
            },
            {
                name: "Public"
            },
            {
                name: "Private"
            }
        ]
    },
    {
        name: "GatewayDirection",
        literalValues: [
            {
                name: "Unspecified"
            },
            {
                name: "Converging"
            },
            {
                name: "Diverging"
            },
            {
                name: "Mixed"
            }
        ]
    },
    {
        name: "EventBasedGatewayType",
        literalValues: [
            {
                name: "Parallel"
            },
            {
                name: "Exclusive"
            }
        ]
    },
    {
        name: "RelationshipDirection",
        literalValues: [
            {
                name: "None"
            },
            {
                name: "Forward"
            },
            {
                name: "Backward"
            },
            {
                name: "Both"
            }
        ]
    },
    {
        name: "ItemKind",
        literalValues: [
            {
                name: "Physical"
            },
            {
                name: "Information"
            }
        ]
    },
    {
        name: "ChoreographyLoopType",
        literalValues: [
            {
                name: "None"
            },
            {
                name: "Standard"
            },
            {
                name: "MultiInstanceSequential"
            },
            {
                name: "MultiInstanceParallel"
            }
        ]
    },
    {
        name: "AssociationDirection",
        literalValues: [
            {
                name: "None"
            },
            {
                name: "One"
            },
            {
                name: "Both"
            }
        ]
    },
    {
        name: "MultiInstanceBehavior",
        literalValues: [
            {
                name: "None"
            },
            {
                name: "One"
            },
            {
                name: "All"
            },
            {
                name: "Complex"
            }
        ]
    },
    {
        name: "AdHocOrdering",
        literalValues: [
            {
                name: "Parallel"
            },
            {
                name: "Sequential"
            }
        ]
    }
];
var xml$1 = {
    tagAlias: "lowerCase",
    typePrefix: "t"
};
var BpmnPackage = {
    name: name$5,
    uri: uri$5,
    prefix: prefix$5,
    associations: associations$5,
    types: types$5,
    enumerations: enumerations$3,
    xml: xml$1
};
var name$4 = "BPMNDI";
var uri$4 = "http://www.omg.org/spec/BPMN/20100524/DI";
var prefix$4 = "bpmndi";
var types$4 = [
    {
        name: "BPMNDiagram",
        properties: [
            {
                name: "plane",
                type: "BPMNPlane",
                redefines: "di:Diagram#rootElement"
            },
            {
                name: "labelStyle",
                type: "BPMNLabelStyle",
                isMany: true
            }
        ],
        superClass: [
            "di:Diagram"
        ]
    },
    {
        name: "BPMNPlane",
        properties: [
            {
                name: "bpmnElement",
                isAttr: true,
                isReference: true,
                type: "bpmn:BaseElement",
                redefines: "di:DiagramElement#modelElement"
            }
        ],
        superClass: [
            "di:Plane"
        ]
    },
    {
        name: "BPMNShape",
        properties: [
            {
                name: "bpmnElement",
                isAttr: true,
                isReference: true,
                type: "bpmn:BaseElement",
                redefines: "di:DiagramElement#modelElement"
            },
            {
                name: "isHorizontal",
                isAttr: true,
                type: "Boolean"
            },
            {
                name: "isExpanded",
                isAttr: true,
                type: "Boolean"
            },
            {
                name: "isMarkerVisible",
                isAttr: true,
                type: "Boolean"
            },
            {
                name: "label",
                type: "BPMNLabel"
            },
            {
                name: "isMessageVisible",
                isAttr: true,
                type: "Boolean"
            },
            {
                name: "participantBandKind",
                type: "ParticipantBandKind",
                isAttr: true
            },
            {
                name: "choreographyActivityShape",
                type: "BPMNShape",
                isAttr: true,
                isReference: true
            }
        ],
        superClass: [
            "di:LabeledShape"
        ]
    },
    {
        name: "BPMNEdge",
        properties: [
            {
                name: "label",
                type: "BPMNLabel"
            },
            {
                name: "bpmnElement",
                isAttr: true,
                isReference: true,
                type: "bpmn:BaseElement",
                redefines: "di:DiagramElement#modelElement"
            },
            {
                name: "sourceElement",
                isAttr: true,
                isReference: true,
                type: "di:DiagramElement",
                redefines: "di:Edge#source"
            },
            {
                name: "targetElement",
                isAttr: true,
                isReference: true,
                type: "di:DiagramElement",
                redefines: "di:Edge#target"
            },
            {
                name: "messageVisibleKind",
                type: "MessageVisibleKind",
                isAttr: true,
                "default": "initiating"
            }
        ],
        superClass: [
            "di:LabeledEdge"
        ]
    },
    {
        name: "BPMNLabel",
        properties: [
            {
                name: "labelStyle",
                type: "BPMNLabelStyle",
                isAttr: true,
                isReference: true,
                redefines: "di:DiagramElement#style"
            }
        ],
        superClass: [
            "di:Label"
        ]
    },
    {
        name: "BPMNLabelStyle",
        properties: [
            {
                name: "font",
                type: "dc:Font"
            }
        ],
        superClass: [
            "di:Style"
        ]
    }
];
var enumerations$2 = [
    {
        name: "ParticipantBandKind",
        literalValues: [
            {
                name: "top_initiating"
            },
            {
                name: "middle_initiating"
            },
            {
                name: "bottom_initiating"
            },
            {
                name: "top_non_initiating"
            },
            {
                name: "middle_non_initiating"
            },
            {
                name: "bottom_non_initiating"
            }
        ]
    },
    {
        name: "MessageVisibleKind",
        literalValues: [
            {
                name: "initiating"
            },
            {
                name: "non_initiating"
            }
        ]
    }
];
var associations$4 = [];
var BpmnDiPackage = {
    name: name$4,
    uri: uri$4,
    prefix: prefix$4,
    types: types$4,
    enumerations: enumerations$2,
    associations: associations$4
};
var name$3 = "DC";
var uri$3 = "http://www.omg.org/spec/DD/20100524/DC";
var prefix$3 = "dc";
var types$3 = [
    {
        name: "Boolean"
    },
    {
        name: "Integer"
    },
    {
        name: "Real"
    },
    {
        name: "String"
    },
    {
        name: "Font",
        properties: [
            {
                name: "name",
                type: "String",
                isAttr: true
            },
            {
                name: "size",
                type: "Real",
                isAttr: true
            },
            {
                name: "isBold",
                type: "Boolean",
                isAttr: true
            },
            {
                name: "isItalic",
                type: "Boolean",
                isAttr: true
            },
            {
                name: "isUnderline",
                type: "Boolean",
                isAttr: true
            },
            {
                name: "isStrikeThrough",
                type: "Boolean",
                isAttr: true
            }
        ]
    },
    {
        name: "Point",
        properties: [
            {
                name: "x",
                type: "Real",
                "default": "0",
                isAttr: true
            },
            {
                name: "y",
                type: "Real",
                "default": "0",
                isAttr: true
            }
        ]
    },
    {
        name: "Bounds",
        properties: [
            {
                name: "x",
                type: "Real",
                "default": "0",
                isAttr: true
            },
            {
                name: "y",
                type: "Real",
                "default": "0",
                isAttr: true
            },
            {
                name: "width",
                type: "Real",
                isAttr: true
            },
            {
                name: "height",
                type: "Real",
                isAttr: true
            }
        ]
    }
];
var associations$3 = [];
var DcPackage = {
    name: name$3,
    uri: uri$3,
    prefix: prefix$3,
    types: types$3,
    associations: associations$3
};
var name$2 = "DI";
var uri$2 = "http://www.omg.org/spec/DD/20100524/DI";
var prefix$2 = "di";
var types$2 = [
    {
        name: "DiagramElement",
        isAbstract: true,
        properties: [
            {
                name: "id",
                isAttr: true,
                isId: true,
                type: "String"
            },
            {
                name: "extension",
                type: "Extension"
            },
            {
                name: "owningDiagram",
                type: "Diagram",
                isReadOnly: true,
                isVirtual: true,
                isReference: true
            },
            {
                name: "owningElement",
                type: "DiagramElement",
                isReadOnly: true,
                isVirtual: true,
                isReference: true
            },
            {
                name: "modelElement",
                isReadOnly: true,
                isVirtual: true,
                isReference: true,
                type: "Element"
            },
            {
                name: "style",
                type: "Style",
                isReadOnly: true,
                isVirtual: true,
                isReference: true
            },
            {
                name: "ownedElement",
                type: "DiagramElement",
                isReadOnly: true,
                isMany: true,
                isVirtual: true
            }
        ]
    },
    {
        name: "Node",
        isAbstract: true,
        superClass: [
            "DiagramElement"
        ]
    },
    {
        name: "Edge",
        isAbstract: true,
        superClass: [
            "DiagramElement"
        ],
        properties: [
            {
                name: "source",
                type: "DiagramElement",
                isReadOnly: true,
                isVirtual: true,
                isReference: true
            },
            {
                name: "target",
                type: "DiagramElement",
                isReadOnly: true,
                isVirtual: true,
                isReference: true
            },
            {
                name: "waypoint",
                isUnique: false,
                isMany: true,
                type: "dc:Point",
                xml: {
                    serialize: "xsi:type"
                }
            }
        ]
    },
    {
        name: "Diagram",
        isAbstract: true,
        properties: [
            {
                name: "id",
                isAttr: true,
                isId: true,
                type: "String"
            },
            {
                name: "rootElement",
                type: "DiagramElement",
                isReadOnly: true,
                isVirtual: true
            },
            {
                name: "name",
                isAttr: true,
                type: "String"
            },
            {
                name: "documentation",
                isAttr: true,
                type: "String"
            },
            {
                name: "resolution",
                isAttr: true,
                type: "Real"
            },
            {
                name: "ownedStyle",
                type: "Style",
                isReadOnly: true,
                isMany: true,
                isVirtual: true
            }
        ]
    },
    {
        name: "Shape",
        isAbstract: true,
        superClass: [
            "Node"
        ],
        properties: [
            {
                name: "bounds",
                type: "dc:Bounds"
            }
        ]
    },
    {
        name: "Plane",
        isAbstract: true,
        superClass: [
            "Node"
        ],
        properties: [
            {
                name: "planeElement",
                type: "DiagramElement",
                subsettedProperty: "DiagramElement-ownedElement",
                isMany: true
            }
        ]
    },
    {
        name: "LabeledEdge",
        isAbstract: true,
        superClass: [
            "Edge"
        ],
        properties: [
            {
                name: "ownedLabel",
                type: "Label",
                isReadOnly: true,
                subsettedProperty: "DiagramElement-ownedElement",
                isMany: true,
                isVirtual: true
            }
        ]
    },
    {
        name: "LabeledShape",
        isAbstract: true,
        superClass: [
            "Shape"
        ],
        properties: [
            {
                name: "ownedLabel",
                type: "Label",
                isReadOnly: true,
                subsettedProperty: "DiagramElement-ownedElement",
                isMany: true,
                isVirtual: true
            }
        ]
    },
    {
        name: "Label",
        isAbstract: true,
        superClass: [
            "Node"
        ],
        properties: [
            {
                name: "bounds",
                type: "dc:Bounds"
            }
        ]
    },
    {
        name: "Style",
        isAbstract: true,
        properties: [
            {
                name: "id",
                isAttr: true,
                isId: true,
                type: "String"
            }
        ]
    },
    {
        name: "Extension",
        properties: [
            {
                name: "values",
                isMany: true,
                type: "Element"
            }
        ]
    }
];
var associations$2 = [];
var xml = {
    tagAlias: "lowerCase"
};
var DiPackage = {
    name: name$2,
    uri: uri$2,
    prefix: prefix$2,
    types: types$2,
    associations: associations$2,
    xml: xml
};
var name$1 = "bpmn.io colors for BPMN";
var uri$1 = "http://bpmn.io/schema/bpmn/biocolor/1.0";
var prefix$1 = "bioc";
var types$1 = [
    {
        name: "ColoredShape",
        "extends": [
            "bpmndi:BPMNShape"
        ],
        properties: [
            {
                name: "stroke",
                isAttr: true,
                type: "String"
            },
            {
                name: "fill",
                isAttr: true,
                type: "String"
            }
        ]
    },
    {
        name: "ColoredEdge",
        "extends": [
            "bpmndi:BPMNEdge"
        ],
        properties: [
            {
                name: "stroke",
                isAttr: true,
                type: "String"
            },
            {
                name: "fill",
                isAttr: true,
                type: "String"
            }
        ]
    }
];
var enumerations$1 = [];
var associations$1 = [];
var BiocPackage = {
    name: name$1,
    uri: uri$1,
    prefix: prefix$1,
    types: types$1,
    enumerations: enumerations$1,
    associations: associations$1
};
var name = "BPMN in Color";
var uri = "http://www.omg.org/spec/BPMN/non-normative/color/1.0";
var prefix = "color";
var types = [
    {
        name: "ColoredLabel",
        "extends": [
            "bpmndi:BPMNLabel"
        ],
        properties: [
            {
                name: "color",
                isAttr: true,
                type: "String"
            }
        ]
    },
    {
        name: "ColoredShape",
        "extends": [
            "bpmndi:BPMNShape"
        ],
        properties: [
            {
                name: "background-color",
                isAttr: true,
                type: "String"
            },
            {
                name: "border-color",
                isAttr: true,
                type: "String"
            }
        ]
    },
    {
        name: "ColoredEdge",
        "extends": [
            "bpmndi:BPMNEdge"
        ],
        properties: [
            {
                name: "border-color",
                isAttr: true,
                type: "String"
            }
        ]
    }
];
var enumerations = [];
var associations = [];
var BpmnInColorPackage = {
    name: name,
    uri: uri,
    prefix: prefix,
    types: types,
    enumerations: enumerations,
    associations: associations
};
var packages = {
    bpmn: BpmnPackage,
    bpmndi: BpmnDiPackage,
    dc: DcPackage,
    di: DiPackage,
    bioc: BiocPackage,
    color: BpmnInColorPackage
};
function simple(additionalPackages, options) {
    var pks = (0, _minDash.assign)({}, packages, additionalPackages);
    return new BpmnModdle(pks, options);
}

},{"min-dash":"aEEla","moddle":"4ydsy","moddle-xml":"8pDtX","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4ydsy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Moddle", ()=>Moddle);
parcelHelpers.export(exports, "coerceType", ()=>coerceType);
parcelHelpers.export(exports, "isBuiltInType", ()=>isBuiltIn);
parcelHelpers.export(exports, "isSimpleType", ()=>isSimple);
parcelHelpers.export(exports, "parseNameNS", ()=>parseName);
var _minDash = require("min-dash");
/**
 * Moddle base element.
 */ function Base() {}
Base.prototype.get = function(name) {
    return this.$model.properties.get(this, name);
};
Base.prototype.set = function(name, value) {
    this.$model.properties.set(this, name, value);
};
/**
 * A model element factory.
 *
 * @param {Moddle} model
 * @param {Properties} properties
 */ function Factory(model, properties) {
    this.model = model;
    this.properties = properties;
}
Factory.prototype.createType = function(descriptor) {
    var model = this.model;
    var props = this.properties, prototype = Object.create(Base.prototype);
    // initialize default values
    (0, _minDash.forEach)(descriptor.properties, function(p) {
        if (!p.isMany && p.default !== undefined) prototype[p.name] = p.default;
    });
    props.defineModel(prototype, model);
    props.defineDescriptor(prototype, descriptor);
    var name = descriptor.ns.name;
    /**
   * The new type constructor
   */ function ModdleElement(attrs) {
        props.define(this, '$type', {
            value: name,
            enumerable: true
        });
        props.define(this, '$attrs', {
            value: {}
        });
        props.define(this, '$parent', {
            writable: true
        });
        (0, _minDash.forEach)(attrs, (0, _minDash.bind)(function(val, key) {
            this.set(key, val);
        }, this));
    }
    ModdleElement.prototype = prototype;
    ModdleElement.hasType = prototype.$instanceOf = this.model.hasType;
    // static links
    props.defineModel(ModdleElement, model);
    props.defineDescriptor(ModdleElement, descriptor);
    return ModdleElement;
};
/**
 * Built-in moddle types
 */ var BUILTINS = {
    String: true,
    Boolean: true,
    Integer: true,
    Real: true,
    Element: true
};
/**
 * Converters for built in types from string representations
 */ var TYPE_CONVERTERS = {
    String: function(s) {
        return s;
    },
    Boolean: function(s) {
        return s === 'true';
    },
    Integer: function(s) {
        return parseInt(s, 10);
    },
    Real: function(s) {
        return parseFloat(s);
    }
};
/**
 * Convert a type to its real representation
 */ function coerceType(type, value) {
    var converter = TYPE_CONVERTERS[type];
    if (converter) return converter(value);
    else return value;
}
/**
 * Return whether the given type is built-in
 */ function isBuiltIn(type) {
    return !!BUILTINS[type];
}
/**
 * Return whether the given type is simple
 */ function isSimple(type) {
    return !!TYPE_CONVERTERS[type];
}
/**
 * Parses a namespaced attribute name of the form (ns:)localName to an object,
 * given a default prefix to assume in case no explicit namespace is given.
 *
 * @param {String} name
 * @param {String} [defaultPrefix] the default prefix to take, if none is present.
 *
 * @return {Object} the parsed name
 */ function parseName(name, defaultPrefix) {
    var parts = name.split(/:/), localName, prefix;
    // no prefix (i.e. only local name)
    if (parts.length === 1) {
        localName = name;
        prefix = defaultPrefix;
    } else // prefix + local name
    if (parts.length === 2) {
        localName = parts[1];
        prefix = parts[0];
    } else throw new Error('expected <prefix:localName> or <localName>, got ' + name);
    name = (prefix ? prefix + ':' : '') + localName;
    return {
        name: name,
        prefix: prefix,
        localName: localName
    };
}
/**
 * A utility to build element descriptors.
 */ function DescriptorBuilder(nameNs) {
    this.ns = nameNs;
    this.name = nameNs.name;
    this.allTypes = [];
    this.allTypesByName = {};
    this.properties = [];
    this.propertiesByName = {};
}
DescriptorBuilder.prototype.build = function() {
    return (0, _minDash.pick)(this, [
        'ns',
        'name',
        'allTypes',
        'allTypesByName',
        'properties',
        'propertiesByName',
        'bodyProperty',
        'idProperty'
    ]);
};
/**
 * Add property at given index.
 *
 * @param {Object} p
 * @param {Number} [idx]
 * @param {Boolean} [validate=true]
 */ DescriptorBuilder.prototype.addProperty = function(p, idx, validate) {
    if (typeof idx === 'boolean') {
        validate = idx;
        idx = undefined;
    }
    this.addNamedProperty(p, validate !== false);
    var properties = this.properties;
    if (idx !== undefined) properties.splice(idx, 0, p);
    else properties.push(p);
};
DescriptorBuilder.prototype.replaceProperty = function(oldProperty, newProperty, replace) {
    var oldNameNs = oldProperty.ns;
    var props = this.properties, propertiesByName = this.propertiesByName, rename = oldProperty.name !== newProperty.name;
    if (oldProperty.isId) {
        if (!newProperty.isId) throw new Error('property <' + newProperty.ns.name + '> must be id property ' + 'to refine <' + oldProperty.ns.name + '>');
        this.setIdProperty(newProperty, false);
    }
    if (oldProperty.isBody) {
        if (!newProperty.isBody) throw new Error('property <' + newProperty.ns.name + '> must be body property ' + 'to refine <' + oldProperty.ns.name + '>');
        // TODO: Check compatibility
        this.setBodyProperty(newProperty, false);
    }
    // validate existence and get location of old property
    var idx = props.indexOf(oldProperty);
    if (idx === -1) throw new Error('property <' + oldNameNs.name + '> not found in property list');
    // remove old property
    props.splice(idx, 1);
    // replacing the named property is intentional
    //
    //  * validate only if this is a "rename" operation
    //  * add at specific index unless we "replace"
    //
    this.addProperty(newProperty, replace ? undefined : idx, rename);
    // make new property available under old name
    propertiesByName[oldNameNs.name] = propertiesByName[oldNameNs.localName] = newProperty;
};
DescriptorBuilder.prototype.redefineProperty = function(p, targetPropertyName, replace) {
    var nsPrefix = p.ns.prefix;
    var parts = targetPropertyName.split('#');
    var name = parseName(parts[0], nsPrefix);
    var attrName = parseName(parts[1], name.prefix).name;
    var redefinedProperty = this.propertiesByName[attrName];
    if (!redefinedProperty) throw new Error('refined property <' + attrName + '> not found');
    else this.replaceProperty(redefinedProperty, p, replace);
    delete p.redefines;
};
DescriptorBuilder.prototype.addNamedProperty = function(p, validate) {
    var ns = p.ns, propsByName = this.propertiesByName;
    if (validate) {
        this.assertNotDefined(p, ns.name);
        this.assertNotDefined(p, ns.localName);
    }
    propsByName[ns.name] = propsByName[ns.localName] = p;
};
DescriptorBuilder.prototype.removeNamedProperty = function(p) {
    var ns = p.ns, propsByName = this.propertiesByName;
    delete propsByName[ns.name];
    delete propsByName[ns.localName];
};
DescriptorBuilder.prototype.setBodyProperty = function(p, validate) {
    if (validate && this.bodyProperty) throw new Error("body property defined multiple times (<" + this.bodyProperty.ns.name + '>, <' + p.ns.name + '>)');
    this.bodyProperty = p;
};
DescriptorBuilder.prototype.setIdProperty = function(p, validate) {
    if (validate && this.idProperty) throw new Error("id property defined multiple times (<" + this.idProperty.ns.name + '>, <' + p.ns.name + '>)');
    this.idProperty = p;
};
DescriptorBuilder.prototype.assertNotTrait = function(typeDescriptor) {
    const _extends = typeDescriptor.extends || [];
    if (_extends.length) throw new Error(`cannot create <${typeDescriptor.name}> extending <${typeDescriptor.extends}>`);
};
DescriptorBuilder.prototype.assertNotDefined = function(p, name) {
    var propertyName = p.name, definedProperty = this.propertiesByName[propertyName];
    if (definedProperty) throw new Error('property <' + propertyName + '> already defined; ' + 'override of <' + definedProperty.definedBy.ns.name + '#' + definedProperty.ns.name + '> by ' + '<' + p.definedBy.ns.name + '#' + p.ns.name + '> not allowed without redefines');
};
DescriptorBuilder.prototype.hasProperty = function(name) {
    return this.propertiesByName[name];
};
DescriptorBuilder.prototype.addTrait = function(t, inherited) {
    if (inherited) this.assertNotTrait(t);
    var typesByName = this.allTypesByName, types = this.allTypes;
    var typeName = t.name;
    if (typeName in typesByName) return;
    (0, _minDash.forEach)(t.properties, (0, _minDash.bind)(function(p) {
        // clone property to allow extensions
        p = (0, _minDash.assign)({}, p, {
            name: p.ns.localName,
            inherited: inherited
        });
        Object.defineProperty(p, 'definedBy', {
            value: t
        });
        var replaces = p.replaces, redefines = p.redefines;
        // add replace/redefine support
        if (replaces || redefines) this.redefineProperty(p, replaces || redefines, replaces);
        else {
            if (p.isBody) this.setBodyProperty(p);
            if (p.isId) this.setIdProperty(p);
            this.addProperty(p);
        }
    }, this));
    types.push(t);
    typesByName[typeName] = t;
};
/**
 * A registry of Moddle packages.
 *
 * @param {Array<Package>} packages
 * @param {Properties} properties
 */ function Registry(packages, properties) {
    this.packageMap = {};
    this.typeMap = {};
    this.packages = [];
    this.properties = properties;
    (0, _minDash.forEach)(packages, (0, _minDash.bind)(this.registerPackage, this));
}
Registry.prototype.getPackage = function(uriOrPrefix) {
    return this.packageMap[uriOrPrefix];
};
Registry.prototype.getPackages = function() {
    return this.packages;
};
Registry.prototype.registerPackage = function(pkg) {
    // copy package
    pkg = (0, _minDash.assign)({}, pkg);
    var pkgMap = this.packageMap;
    ensureAvailable(pkgMap, pkg, 'prefix');
    ensureAvailable(pkgMap, pkg, 'uri');
    // register types
    (0, _minDash.forEach)(pkg.types, (0, _minDash.bind)(function(descriptor) {
        this.registerType(descriptor, pkg);
    }, this));
    pkgMap[pkg.uri] = pkgMap[pkg.prefix] = pkg;
    this.packages.push(pkg);
};
/**
 * Register a type from a specific package with us
 */ Registry.prototype.registerType = function(type, pkg) {
    type = (0, _minDash.assign)({}, type, {
        superClass: (type.superClass || []).slice(),
        extends: (type.extends || []).slice(),
        properties: (type.properties || []).slice(),
        meta: (0, _minDash.assign)(type.meta || {})
    });
    var ns = parseName(type.name, pkg.prefix), name = ns.name, propertiesByName = {};
    // parse properties
    (0, _minDash.forEach)(type.properties, (0, _minDash.bind)(function(p) {
        // namespace property names
        var propertyNs = parseName(p.name, ns.prefix), propertyName = propertyNs.name;
        // namespace property types
        if (!isBuiltIn(p.type)) p.type = parseName(p.type, propertyNs.prefix).name;
        (0, _minDash.assign)(p, {
            ns: propertyNs,
            name: propertyName
        });
        propertiesByName[propertyName] = p;
    }, this));
    // update ns + name
    (0, _minDash.assign)(type, {
        ns: ns,
        name: name,
        propertiesByName: propertiesByName
    });
    (0, _minDash.forEach)(type.extends, (0, _minDash.bind)(function(extendsName) {
        var extendsNameNs = parseName(extendsName, ns.prefix);
        var extended = this.typeMap[extendsNameNs.name];
        extended.traits = extended.traits || [];
        extended.traits.push(name);
    }, this));
    // link to package
    this.definePackage(type, pkg);
    // register
    this.typeMap[name] = type;
};
/**
 * Traverse the type hierarchy from bottom to top,
 * calling iterator with (type, inherited) for all elements in
 * the inheritance chain.
 *
 * @param {Object} nsName
 * @param {Function} iterator
 * @param {Boolean} [trait=false]
 */ Registry.prototype.mapTypes = function(nsName, iterator, trait) {
    var type = isBuiltIn(nsName.name) ? {
        name: nsName.name
    } : this.typeMap[nsName.name];
    var self = this;
    /**
   * Traverse the selected super type or trait
   *
   * @param {String} cls
   * @param {Boolean} [trait=false]
   */ function traverse(cls, trait) {
        var parentNs = parseName(cls, isBuiltIn(cls) ? '' : nsName.prefix);
        self.mapTypes(parentNs, iterator, trait);
    }
    /**
   * Traverse the selected trait.
   *
   * @param {String} cls
   */ function traverseTrait(cls) {
        return traverse(cls, true);
    }
    /**
   * Traverse the selected super type
   *
   * @param {String} cls
   */ function traverseSuper(cls) {
        return traverse(cls, false);
    }
    if (!type) throw new Error('unknown type <' + nsName.name + '>');
    (0, _minDash.forEach)(type.superClass, trait ? traverseTrait : traverseSuper);
    // call iterator with (type, inherited=!trait)
    iterator(type, !trait);
    (0, _minDash.forEach)(type.traits, traverseTrait);
};
/**
 * Returns the effective descriptor for a type.
 *
 * @param  {String} type the namespaced name (ns:localName) of the type
 *
 * @return {Descriptor} the resulting effective descriptor
 */ Registry.prototype.getEffectiveDescriptor = function(name) {
    var nsName = parseName(name);
    var builder = new DescriptorBuilder(nsName);
    this.mapTypes(nsName, function(type, inherited) {
        builder.addTrait(type, inherited);
    });
    var descriptor = builder.build();
    // define package link
    this.definePackage(descriptor, descriptor.allTypes[descriptor.allTypes.length - 1].$pkg);
    return descriptor;
};
Registry.prototype.definePackage = function(target, pkg) {
    this.properties.define(target, '$pkg', {
        value: pkg
    });
};
// helpers ////////////////////////////
function ensureAvailable(packageMap, pkg, identifierKey) {
    var value = pkg[identifierKey];
    if (value in packageMap) throw new Error('package with ' + identifierKey + ' <' + value + '> already defined');
}
/**
 * A utility that gets and sets properties of model elements.
 *
 * @param {Model} model
 */ function Properties(model) {
    this.model = model;
}
/**
 * Sets a named property on the target element.
 * If the value is undefined, the property gets deleted.
 *
 * @param {Object} target
 * @param {String} name
 * @param {Object} value
 */ Properties.prototype.set = function(target, name, value) {
    if (!(0, _minDash.isString)(name) || !name.length) throw new TypeError('property name must be a non-empty string');
    var property = this.getProperty(target, name);
    var propertyName = property && property.name;
    if (isUndefined(value)) {
        // unset the property, if the specified value is undefined;
        // delete from $attrs (for extensions) or the target itself
        if (property) delete target[propertyName];
        else delete target.$attrs[stripGlobal(name)];
    } else // set the property, defining well defined properties on the fly
    // or simply updating them in target.$attrs (for extensions)
    if (property) {
        if (propertyName in target) target[propertyName] = value;
        else defineProperty(target, property, value);
    } else target.$attrs[stripGlobal(name)] = value;
};
/**
 * Returns the named property of the given element
 *
 * @param  {Object} target
 * @param  {String} name
 *
 * @return {Object}
 */ Properties.prototype.get = function(target, name) {
    var property = this.getProperty(target, name);
    if (!property) return target.$attrs[stripGlobal(name)];
    var propertyName = property.name;
    // check if access to collection property and lazily initialize it
    if (!target[propertyName] && property.isMany) defineProperty(target, property, []);
    return target[propertyName];
};
/**
 * Define a property on the target element
 *
 * @param  {Object} target
 * @param  {String} name
 * @param  {Object} options
 */ Properties.prototype.define = function(target, name, options) {
    if (!options.writable) {
        var value = options.value;
        // use getters for read-only variables to support ES6 proxies
        // cf. https://github.com/bpmn-io/internal-docs/issues/386
        options = (0, _minDash.assign)({}, options, {
            get: function() {
                return value;
            }
        });
        delete options.value;
    }
    Object.defineProperty(target, name, options);
};
/**
 * Define the descriptor for an element
 */ Properties.prototype.defineDescriptor = function(target, descriptor) {
    this.define(target, '$descriptor', {
        value: descriptor
    });
};
/**
 * Define the model for an element
 */ Properties.prototype.defineModel = function(target, model) {
    this.define(target, '$model', {
        value: model
    });
};
/**
 * Return property with the given name on the element.
 *
 * @param {any} target
 * @param {string} name
 *
 * @return {object | null} property
 */ Properties.prototype.getProperty = function(target, name) {
    var model = this.model;
    var property = model.getPropertyDescriptor(target, name);
    if (property) return property;
    if (name.includes(':')) return null;
    const strict = model.config.strict;
    if (typeof strict !== 'undefined') {
        const error = new TypeError(`unknown property <${name}> on <${target.$type}>`);
        if (strict) throw error;
        else // eslint-disable-next-line no-undef
        typeof console !== 'undefined' && console.warn(error);
    }
    return null;
};
function isUndefined(val) {
    return typeof val === 'undefined';
}
function defineProperty(target, property, value) {
    Object.defineProperty(target, property.name, {
        enumerable: !property.isReference,
        writable: true,
        value: value,
        configurable: true
    });
}
function stripGlobal(name) {
    return name.replace(/^:/, '');
}
// Moddle implementation /////////////////////////////////////////////////
/**
 * @class Moddle
 *
 * A model that can be used to create elements of a specific type.
 *
 * @example
 *
 * var Moddle = require('moddle');
 *
 * var pkg = {
 *   name: 'mypackage',
 *   prefix: 'my',
 *   types: [
 *     { name: 'Root' }
 *   ]
 * };
 *
 * var moddle = new Moddle([pkg]);
 *
 * @param {Array<Package>} packages the packages to contain
 *
 * @param { { strict?: boolean } } [config] moddle configuration
 */ function Moddle(packages, config = {}) {
    this.properties = new Properties(this);
    this.factory = new Factory(this, this.properties);
    this.registry = new Registry(packages, this.properties);
    this.typeCache = {};
    this.config = config;
}
/**
 * Create an instance of the specified type.
 *
 * @method Moddle#create
 *
 * @example
 *
 * var foo = moddle.create('my:Foo');
 * var bar = moddle.create('my:Bar', { id: 'BAR_1' });
 *
 * @param  {String|Object} descriptor the type descriptor or name know to the model
 * @param  {Object} attrs   a number of attributes to initialize the model instance with
 * @return {Object}         model instance
 */ Moddle.prototype.create = function(descriptor, attrs) {
    var Type = this.getType(descriptor);
    if (!Type) throw new Error('unknown type <' + descriptor + '>');
    return new Type(attrs);
};
/**
 * Returns the type representing a given descriptor
 *
 * @method Moddle#getType
 *
 * @example
 *
 * var Foo = moddle.getType('my:Foo');
 * var foo = new Foo({ 'id' : 'FOO_1' });
 *
 * @param  {String|Object} descriptor the type descriptor or name know to the model
 * @return {Object}         the type representing the descriptor
 */ Moddle.prototype.getType = function(descriptor) {
    var cache = this.typeCache;
    var name = (0, _minDash.isString)(descriptor) ? descriptor : descriptor.ns.name;
    var type = cache[name];
    if (!type) {
        descriptor = this.registry.getEffectiveDescriptor(name);
        type = cache[name] = this.factory.createType(descriptor);
    }
    return type;
};
/**
 * Creates an any-element type to be used within model instances.
 *
 * This can be used to create custom elements that lie outside the meta-model.
 * The created element contains all the meta-data required to serialize it
 * as part of meta-model elements.
 *
 * @method Moddle#createAny
 *
 * @example
 *
 * var foo = moddle.createAny('vendor:Foo', 'http://vendor', {
 *   value: 'bar'
 * });
 *
 * var container = moddle.create('my:Container', 'http://my', {
 *   any: [ foo ]
 * });
 *
 * // go ahead and serialize the stuff
 *
 *
 * @param  {String} name  the name of the element
 * @param  {String} nsUri the namespace uri of the element
 * @param  {Object} [properties] a map of properties to initialize the instance with
 * @return {Object} the any type instance
 */ Moddle.prototype.createAny = function(name, nsUri, properties) {
    var nameNs = parseName(name);
    var element = {
        $type: name,
        $instanceOf: function(type) {
            return type === this.$type;
        },
        get: function(key) {
            return this[key];
        },
        set: function(key, value) {
            (0, _minDash.set)(this, [
                key
            ], value);
        }
    };
    var descriptor = {
        name: name,
        isGeneric: true,
        ns: {
            prefix: nameNs.prefix,
            localName: nameNs.localName,
            uri: nsUri
        }
    };
    this.properties.defineDescriptor(element, descriptor);
    this.properties.defineModel(element, this);
    this.properties.define(element, 'get', {
        enumerable: false,
        writable: true
    });
    this.properties.define(element, 'set', {
        enumerable: false,
        writable: true
    });
    this.properties.define(element, '$parent', {
        enumerable: false,
        writable: true
    });
    this.properties.define(element, '$instanceOf', {
        enumerable: false,
        writable: true
    });
    (0, _minDash.forEach)(properties, function(a, key) {
        if ((0, _minDash.isObject)(a) && a.value !== undefined) element[a.name] = a.value;
        else element[key] = a;
    });
    return element;
};
/**
 * Returns a registered package by uri or prefix
 *
 * @return {Object} the package
 */ Moddle.prototype.getPackage = function(uriOrPrefix) {
    return this.registry.getPackage(uriOrPrefix);
};
/**
 * Returns a snapshot of all known packages
 *
 * @return {Object} the package
 */ Moddle.prototype.getPackages = function() {
    return this.registry.getPackages();
};
/**
 * Returns the descriptor for an element
 */ Moddle.prototype.getElementDescriptor = function(element) {
    return element.$descriptor;
};
/**
 * Returns true if the given descriptor or instance
 * represents the given type.
 *
 * May be applied to this, if element is omitted.
 */ Moddle.prototype.hasType = function(element, type) {
    if (type === undefined) {
        type = element;
        element = this;
    }
    var descriptor = element.$model.getElementDescriptor(element);
    return type in descriptor.allTypesByName;
};
/**
 * Returns the descriptor of an elements named property
 */ Moddle.prototype.getPropertyDescriptor = function(element, property) {
    return this.getElementDescriptor(element).propertiesByName[property];
};
/**
 * Returns a mapped type's descriptor
 */ Moddle.prototype.getTypeDescriptor = function(type) {
    return this.registry.typeMap[type];
};

},{"min-dash":"aEEla","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8pDtX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Reader", ()=>Reader);
parcelHelpers.export(exports, "Writer", ()=>Writer);
var _minDash = require("min-dash");
var _saxen = require("saxen");
var _moddle = require("moddle");
function hasLowerCaseAlias(pkg) {
    return pkg.xml && pkg.xml.tagAlias === 'lowerCase';
}
var DEFAULT_NS_MAP = {
    'xsi': 'http://www.w3.org/2001/XMLSchema-instance',
    'xml': 'http://www.w3.org/XML/1998/namespace'
};
var XSI_TYPE = 'xsi:type';
function serializeFormat(element) {
    return element.xml && element.xml.serialize;
}
function serializeAsType(element) {
    return serializeFormat(element) === XSI_TYPE;
}
function serializeAsProperty(element) {
    return serializeFormat(element) === 'property';
}
function capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
function aliasToName(aliasNs, pkg) {
    if (!hasLowerCaseAlias(pkg)) return aliasNs.name;
    return aliasNs.prefix + ':' + capitalize(aliasNs.localName);
}
function prefixedToName(nameNs, pkg) {
    var name = nameNs.name, localName = nameNs.localName;
    var typePrefix = pkg.xml && pkg.xml.typePrefix;
    if (typePrefix && localName.indexOf(typePrefix) === 0) return nameNs.prefix + ':' + localName.slice(typePrefix.length);
    else return name;
}
function normalizeXsiTypeName(name, model) {
    var nameNs = (0, _moddle.parseNameNS)(name);
    var pkg = model.getPackage(nameNs.prefix);
    return prefixedToName(nameNs, pkg);
}
function error(message) {
    return new Error(message);
}
/**
 * Get the moddle descriptor for a given instance or type.
 *
 * @param  {ModdleElement|Function} element
 *
 * @return {Object} the moddle descriptor
 */ function getModdleDescriptor(element) {
    return element.$descriptor;
}
/**
 * A parse context.
 *
 * @class
 *
 * @param {Object} options
 * @param {ElementHandler} options.rootHandler the root handler for parsing a document
 * @param {boolean} [options.lax=false] whether or not to ignore invalid elements
 */ function Context(options) {
    /**
   * @property {ElementHandler} rootHandler
   */ /**
   * @property {Boolean} lax
   */ (0, _minDash.assign)(this, options);
    this.elementsById = {};
    this.references = [];
    this.warnings = [];
    /**
   * Add an unresolved reference.
   *
   * @param {Object} reference
   */ this.addReference = function(reference) {
        this.references.push(reference);
    };
    /**
   * Add a processed element.
   *
   * @param {ModdleElement} element
   */ this.addElement = function(element) {
        if (!element) throw error('expected element');
        var elementsById = this.elementsById;
        var descriptor = getModdleDescriptor(element);
        var idProperty = descriptor.idProperty, id;
        if (idProperty) {
            id = element.get(idProperty.name);
            if (id) {
                // for QName validation as per http://www.w3.org/TR/REC-xml/#NT-NameChar
                if (!/^([a-z][\w-.]*:)?[a-z_][\w-.]*$/i.test(id)) throw new Error('illegal ID <' + id + '>');
                if (elementsById[id]) throw error('duplicate ID <' + id + '>');
                elementsById[id] = element;
            }
        }
    };
    /**
   * Add an import warning.
   *
   * @param {Object} warning
   * @param {String} warning.message
   * @param {Error} [warning.error]
   */ this.addWarning = function(warning) {
        this.warnings.push(warning);
    };
}
function BaseHandler() {}
BaseHandler.prototype.handleEnd = function() {};
BaseHandler.prototype.handleText = function() {};
BaseHandler.prototype.handleNode = function() {};
/**
 * A simple pass through handler that does nothing except for
 * ignoring all input it receives.
 *
 * This is used to ignore unknown elements and
 * attributes.
 */ function NoopHandler() {}
NoopHandler.prototype = Object.create(BaseHandler.prototype);
NoopHandler.prototype.handleNode = function() {
    return this;
};
function BodyHandler() {}
BodyHandler.prototype = Object.create(BaseHandler.prototype);
BodyHandler.prototype.handleText = function(text) {
    this.body = (this.body || '') + text;
};
function ReferenceHandler(property, context) {
    this.property = property;
    this.context = context;
}
ReferenceHandler.prototype = Object.create(BodyHandler.prototype);
ReferenceHandler.prototype.handleNode = function(node) {
    if (this.element) throw error('expected no sub nodes');
    else this.element = this.createReference(node);
    return this;
};
ReferenceHandler.prototype.handleEnd = function() {
    this.element.id = this.body;
};
ReferenceHandler.prototype.createReference = function(node) {
    return {
        property: this.property.ns.name,
        id: ''
    };
};
function ValueHandler(propertyDesc, element) {
    this.element = element;
    this.propertyDesc = propertyDesc;
}
ValueHandler.prototype = Object.create(BodyHandler.prototype);
ValueHandler.prototype.handleEnd = function() {
    var value = this.body || '', element = this.element, propertyDesc = this.propertyDesc;
    value = (0, _moddle.coerceType)(propertyDesc.type, value);
    if (propertyDesc.isMany) element.get(propertyDesc.name).push(value);
    else element.set(propertyDesc.name, value);
};
function BaseElementHandler() {}
BaseElementHandler.prototype = Object.create(BodyHandler.prototype);
BaseElementHandler.prototype.handleNode = function(node) {
    var parser = this, element = this.element;
    if (!element) {
        element = this.element = this.createElement(node);
        this.context.addElement(element);
    } else parser = this.handleChild(node);
    return parser;
};
/**
 * @class Reader.ElementHandler
 *
 */ function ElementHandler(model, typeName, context) {
    this.model = model;
    this.type = model.getType(typeName);
    this.context = context;
}
ElementHandler.prototype = Object.create(BaseElementHandler.prototype);
ElementHandler.prototype.addReference = function(reference) {
    this.context.addReference(reference);
};
ElementHandler.prototype.handleText = function(text) {
    var element = this.element, descriptor = getModdleDescriptor(element), bodyProperty = descriptor.bodyProperty;
    if (!bodyProperty) throw error('unexpected body text <' + text + '>');
    BodyHandler.prototype.handleText.call(this, text);
};
ElementHandler.prototype.handleEnd = function() {
    var value = this.body, element = this.element, descriptor = getModdleDescriptor(element), bodyProperty = descriptor.bodyProperty;
    if (bodyProperty && value !== undefined) {
        value = (0, _moddle.coerceType)(bodyProperty.type, value);
        element.set(bodyProperty.name, value);
    }
};
/**
 * Create an instance of the model from the given node.
 *
 * @param  {Element} node the xml node
 */ ElementHandler.prototype.createElement = function(node) {
    var attributes = node.attributes, Type = this.type, descriptor = getModdleDescriptor(Type), context = this.context, instance = new Type({}), model = this.model, propNameNs;
    (0, _minDash.forEach)(attributes, function(value, name) {
        var prop = descriptor.propertiesByName[name], values;
        if (prop && prop.isReference) {
            if (!prop.isMany) context.addReference({
                element: instance,
                property: prop.ns.name,
                id: value
            });
            else {
                // IDREFS: parse references as whitespace-separated list
                values = value.split(' ');
                (0, _minDash.forEach)(values, function(v) {
                    context.addReference({
                        element: instance,
                        property: prop.ns.name,
                        id: v
                    });
                });
            }
        } else {
            if (prop) value = (0, _moddle.coerceType)(prop.type, value);
            else if (name !== 'xmlns') {
                propNameNs = (0, _moddle.parseNameNS)(name, descriptor.ns.prefix);
                // check whether attribute is defined in a well-known namespace
                // if that is the case we emit a warning to indicate potential misuse
                if (model.getPackage(propNameNs.prefix)) context.addWarning({
                    message: 'unknown attribute <' + name + '>',
                    element: instance,
                    property: name,
                    value: value
                });
            }
            instance.set(name, value);
        }
    });
    return instance;
};
ElementHandler.prototype.getPropertyForNode = function(node) {
    var name = node.name;
    var nameNs = (0, _moddle.parseNameNS)(name);
    var type = this.type, model = this.model, descriptor = getModdleDescriptor(type);
    var propertyName = nameNs.name, property = descriptor.propertiesByName[propertyName], elementTypeName, elementType;
    // search for properties by name first
    if (property && !property.isAttr) {
        if (serializeAsType(property)) {
            elementTypeName = node.attributes[XSI_TYPE];
            // xsi type is optional, if it does not exists the
            // default type is assumed
            if (elementTypeName) {
                // take possible type prefixes from XML
                // into account, i.e.: xsi:type="t{ActualType}"
                elementTypeName = normalizeXsiTypeName(elementTypeName, model);
                elementType = model.getType(elementTypeName);
                return (0, _minDash.assign)({}, property, {
                    effectiveType: getModdleDescriptor(elementType).name
                });
            }
        }
        // search for properties by name first
        return property;
    }
    var pkg = model.getPackage(nameNs.prefix);
    if (pkg) {
        elementTypeName = aliasToName(nameNs, pkg);
        elementType = model.getType(elementTypeName);
        // search for collection members later
        property = (0, _minDash.find)(descriptor.properties, function(p) {
            return !p.isVirtual && !p.isReference && !p.isAttribute && elementType.hasType(p.type);
        });
        if (property) return (0, _minDash.assign)({}, property, {
            effectiveType: getModdleDescriptor(elementType).name
        });
    } else {
        // parse unknown element (maybe extension)
        property = (0, _minDash.find)(descriptor.properties, function(p) {
            return !p.isReference && !p.isAttribute && p.type === 'Element';
        });
        if (property) return property;
    }
    throw error('unrecognized element <' + nameNs.name + '>');
};
ElementHandler.prototype.toString = function() {
    return 'ElementDescriptor[' + getModdleDescriptor(this.type).name + ']';
};
ElementHandler.prototype.valueHandler = function(propertyDesc, element) {
    return new ValueHandler(propertyDesc, element);
};
ElementHandler.prototype.referenceHandler = function(propertyDesc) {
    return new ReferenceHandler(propertyDesc, this.context);
};
ElementHandler.prototype.handler = function(type) {
    if (type === 'Element') return new GenericElementHandler(this.model, type, this.context);
    else return new ElementHandler(this.model, type, this.context);
};
/**
 * Handle the child element parsing
 *
 * @param  {Element} node the xml node
 */ ElementHandler.prototype.handleChild = function(node) {
    var propertyDesc, type, element, childHandler;
    propertyDesc = this.getPropertyForNode(node);
    element = this.element;
    type = propertyDesc.effectiveType || propertyDesc.type;
    if ((0, _moddle.isSimpleType)(type)) return this.valueHandler(propertyDesc, element);
    if (propertyDesc.isReference) childHandler = this.referenceHandler(propertyDesc).handleNode(node);
    else childHandler = this.handler(type).handleNode(node);
    var newElement = childHandler.element;
    // child handles may decide to skip elements
    // by not returning anything
    if (newElement !== undefined) {
        if (propertyDesc.isMany) element.get(propertyDesc.name).push(newElement);
        else element.set(propertyDesc.name, newElement);
        if (propertyDesc.isReference) {
            (0, _minDash.assign)(newElement, {
                element: element
            });
            this.context.addReference(newElement);
        } else // establish child -> parent relationship
        newElement.$parent = element;
    }
    return childHandler;
};
/**
 * An element handler that performs special validation
 * to ensure the node it gets initialized with matches
 * the handlers type (namespace wise).
 *
 * @param {Moddle} model
 * @param {String} typeName
 * @param {Context} context
 */ function RootElementHandler(model, typeName, context) {
    ElementHandler.call(this, model, typeName, context);
}
RootElementHandler.prototype = Object.create(ElementHandler.prototype);
RootElementHandler.prototype.createElement = function(node) {
    var name = node.name, nameNs = (0, _moddle.parseNameNS)(name), model = this.model, type = this.type, pkg = model.getPackage(nameNs.prefix), typeName = pkg && aliasToName(nameNs, pkg) || name;
    // verify the correct namespace if we parse
    // the first element in the handler tree
    //
    // this ensures we don't mistakenly import wrong namespace elements
    if (!type.hasType(typeName)) throw error('unexpected element <' + node.originalName + '>');
    return ElementHandler.prototype.createElement.call(this, node);
};
function GenericElementHandler(model, typeName, context) {
    this.model = model;
    this.context = context;
}
GenericElementHandler.prototype = Object.create(BaseElementHandler.prototype);
GenericElementHandler.prototype.createElement = function(node) {
    var name = node.name, ns = (0, _moddle.parseNameNS)(name), prefix = ns.prefix, uri = node.ns[prefix + '$uri'], attributes = node.attributes;
    return this.model.createAny(name, uri, attributes);
};
GenericElementHandler.prototype.handleChild = function(node) {
    var handler = new GenericElementHandler(this.model, 'Element', this.context).handleNode(node), element = this.element;
    var newElement = handler.element, children;
    if (newElement !== undefined) {
        children = element.$children = element.$children || [];
        children.push(newElement);
        // establish child -> parent relationship
        newElement.$parent = element;
    }
    return handler;
};
GenericElementHandler.prototype.handleEnd = function() {
    if (this.body) this.element.$body = this.body;
};
/**
 * A reader for a meta-model
 *
 * @param {Object} options
 * @param {Model} options.model used to read xml files
 * @param {Boolean} options.lax whether to make parse errors warnings
 */ function Reader(options) {
    if (options instanceof (0, _moddle.Moddle)) options = {
        model: options
    };
    (0, _minDash.assign)(this, {
        lax: false
    }, options);
}
/**
 * The fromXML result.
 *
 * @typedef {Object} ParseResult
 *
 * @property {ModdleElement} rootElement
 * @property {Array<Object>} references
 * @property {Array<Error>} warnings
 * @property {Object} elementsById - a mapping containing each ID -> ModdleElement
 */ /**
 * The fromXML result.
 *
 * @typedef {Error} ParseError
 *
 * @property {Array<Error>} warnings
 */ /**
 * Parse the given XML into a moddle document tree.
 *
 * @param {String} xml
 * @param {ElementHandler|Object} options or rootHandler
 *
 * @returns {Promise<ParseResult, ParseError>}
 */ Reader.prototype.fromXML = function(xml, options, done) {
    var rootHandler = options.rootHandler;
    if (options instanceof ElementHandler) {
        // root handler passed via (xml, { rootHandler: ElementHandler }, ...)
        rootHandler = options;
        options = {};
    } else {
        if (typeof options === 'string') {
            // rootHandler passed via (xml, 'someString', ...)
            rootHandler = this.handler(options);
            options = {};
        } else if (typeof rootHandler === 'string') // rootHandler passed via (xml, { rootHandler: 'someString' }, ...)
        rootHandler = this.handler(rootHandler);
    }
    var model = this.model, lax = this.lax;
    var context = new Context((0, _minDash.assign)({}, options, {
        rootHandler: rootHandler
    })), parser = new (0, _saxen.Parser)({
        proxy: true
    }), stack = createStack();
    rootHandler.context = context;
    // push root handler
    stack.push(rootHandler);
    /**
   * Handle error.
   *
   * @param  {Error} err
   * @param  {Function} getContext
   * @param  {boolean} lax
   *
   * @return {boolean} true if handled
   */ function handleError(err, getContext, lax) {
        var ctx = getContext();
        var line = ctx.line, column = ctx.column, data = ctx.data;
        // we receive the full context data here,
        // for elements trim down the information
        // to the tag name, only
        if (data.charAt(0) === '<' && data.indexOf(' ') !== -1) data = data.slice(0, data.indexOf(' ')) + '>';
        var message = 'unparsable content ' + (data ? data + ' ' : '') + 'detected\n\t' + 'line: ' + line + '\n\t' + 'column: ' + column + '\n\t' + 'nested error: ' + err.message;
        if (lax) {
            context.addWarning({
                message: message,
                error: err
            });
            return true;
        } else throw error(message);
    }
    function handleWarning(err, getContext) {
        // just like handling errors in <lax=true> mode
        return handleError(err, getContext, true);
    }
    /**
   * Resolve collected references on parse end.
   */ function resolveReferences() {
        var elementsById = context.elementsById;
        var references = context.references;
        var i, r;
        for(i = 0; r = references[i]; i++){
            var element = r.element;
            var reference = elementsById[r.id];
            var property = getModdleDescriptor(element).propertiesByName[r.property];
            if (!reference) context.addWarning({
                message: 'unresolved reference <' + r.id + '>',
                element: r.element,
                property: r.property,
                value: r.id
            });
            if (property.isMany) {
                var collection = element.get(property.name), idx = collection.indexOf(r);
                // we replace an existing place holder (idx != -1) or
                // append to the collection instead
                if (idx === -1) idx = collection.length;
                if (!reference) // remove unresolvable reference
                collection.splice(idx, 1);
                else // add or update reference in collection
                collection[idx] = reference;
            } else element.set(property.name, reference);
        }
    }
    function handleClose() {
        stack.pop().handleEnd();
    }
    var PREAMBLE_START_PATTERN = /^<\?xml /i;
    var ENCODING_PATTERN = / encoding="([^"]+)"/i;
    var UTF_8_PATTERN = /^utf-8$/i;
    function handleQuestion(question) {
        if (!PREAMBLE_START_PATTERN.test(question)) return;
        var match = ENCODING_PATTERN.exec(question);
        var encoding = match && match[1];
        if (!encoding || UTF_8_PATTERN.test(encoding)) return;
        context.addWarning({
            message: 'unsupported document encoding <' + encoding + '>, ' + 'falling back to UTF-8'
        });
    }
    function handleOpen(node, getContext) {
        var handler = stack.peek();
        try {
            stack.push(handler.handleNode(node));
        } catch (err) {
            if (handleError(err, getContext, lax)) stack.push(new NoopHandler());
        }
    }
    function handleCData(text, getContext) {
        try {
            stack.peek().handleText(text);
        } catch (err) {
            handleWarning(err, getContext);
        }
    }
    function handleText(text, getContext) {
        // strip whitespace only nodes, i.e. before
        // <!CDATA[ ... ]> sections and in between tags
        if (!text.trim()) return;
        handleCData(text, getContext);
    }
    var uriMap = model.getPackages().reduce(function(uriMap, p) {
        uriMap[p.uri] = p.prefix;
        return uriMap;
    }, {
        'http://www.w3.org/XML/1998/namespace': 'xml' // add default xml ns
    });
    parser.ns(uriMap).on('openTag', function(obj, decodeStr, selfClosing, getContext) {
        // gracefully handle unparsable attributes (attrs=false)
        var attrs = obj.attrs || {};
        var decodedAttrs = Object.keys(attrs).reduce(function(d, key) {
            var value = decodeStr(attrs[key]);
            d[key] = value;
            return d;
        }, {});
        var node = {
            name: obj.name,
            originalName: obj.originalName,
            attributes: decodedAttrs,
            ns: obj.ns
        };
        handleOpen(node, getContext);
    }).on('question', handleQuestion).on('closeTag', handleClose).on('cdata', handleCData).on('text', function(text, decodeEntities, getContext) {
        handleText(decodeEntities(text), getContext);
    }).on('error', handleError).on('warn', handleWarning);
    // async XML parsing to make sure the execution environment
    // (node or brower) is kept responsive and that certain optimization
    // strategies can kick in.
    return new Promise(function(resolve, reject) {
        var err;
        try {
            parser.parse(xml);
            resolveReferences();
        } catch (e) {
            err = e;
        }
        var rootElement = rootHandler.element;
        if (!err && !rootElement) err = error('failed to parse document as <' + rootHandler.type.$descriptor.name + '>');
        var warnings = context.warnings;
        var references = context.references;
        var elementsById = context.elementsById;
        if (err) {
            err.warnings = warnings;
            return reject(err);
        } else return resolve({
            rootElement: rootElement,
            elementsById: elementsById,
            references: references,
            warnings: warnings
        });
    });
};
Reader.prototype.handler = function(name) {
    return new RootElementHandler(this.model, name);
};
// helpers //////////////////////////
function createStack() {
    var stack = [];
    Object.defineProperty(stack, 'peek', {
        value: function() {
            return this[this.length - 1];
        }
    });
    return stack;
}
var XML_PREAMBLE = '<?xml version="1.0" encoding="UTF-8"?>\n';
var ESCAPE_ATTR_CHARS = /<|>|'|"|&|\n\r|\n/g;
var ESCAPE_CHARS = /<|>|&/g;
function Namespaces(parent) {
    var prefixMap = {};
    var uriMap = {};
    var used = {};
    var wellknown = [];
    var custom = [];
    // API
    this.byUri = function(uri) {
        return uriMap[uri] || parent && parent.byUri(uri);
    };
    this.add = function(ns, isWellknown) {
        uriMap[ns.uri] = ns;
        if (isWellknown) wellknown.push(ns);
        else custom.push(ns);
        this.mapPrefix(ns.prefix, ns.uri);
    };
    this.uriByPrefix = function(prefix) {
        return prefixMap[prefix || 'xmlns'];
    };
    this.mapPrefix = function(prefix, uri) {
        prefixMap[prefix || 'xmlns'] = uri;
    };
    this.getNSKey = function(ns) {
        return ns.prefix !== undefined ? ns.uri + '|' + ns.prefix : ns.uri;
    };
    this.logUsed = function(ns) {
        var uri = ns.uri;
        var nsKey = this.getNSKey(ns);
        used[nsKey] = this.byUri(uri);
        // Inform parent recursively about the usage of this NS
        if (parent) parent.logUsed(ns);
    };
    this.getUsed = function(ns) {
        function isUsed(ns) {
            var nsKey = self.getNSKey(ns);
            return used[nsKey];
        }
        var self = this;
        var allNs = [].concat(wellknown, custom);
        return allNs.filter(isUsed);
    };
}
function lower(string) {
    return string.charAt(0).toLowerCase() + string.slice(1);
}
function nameToAlias(name, pkg) {
    if (hasLowerCaseAlias(pkg)) return lower(name);
    else return name;
}
function inherits(ctor, superCtor) {
    ctor.super_ = superCtor;
    ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
            value: ctor,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
}
function nsName(ns) {
    if ((0, _minDash.isString)(ns)) return ns;
    else return (ns.prefix ? ns.prefix + ':' : '') + ns.localName;
}
function getNsAttrs(namespaces) {
    return namespaces.getUsed().filter(function(ns) {
        // do not serialize built in <xml> namespace
        return ns.prefix !== 'xml';
    }).map(function(ns) {
        var name = 'xmlns' + (ns.prefix ? ':' + ns.prefix : '');
        return {
            name: name,
            value: ns.uri
        };
    });
}
function getElementNs(ns, descriptor) {
    if (descriptor.isGeneric) return (0, _minDash.assign)({
        localName: descriptor.ns.localName
    }, ns);
    else return (0, _minDash.assign)({
        localName: nameToAlias(descriptor.ns.localName, descriptor.$pkg)
    }, ns);
}
function getPropertyNs(ns, descriptor) {
    return (0, _minDash.assign)({
        localName: descriptor.ns.localName
    }, ns);
}
function getSerializableProperties(element) {
    var descriptor = element.$descriptor;
    return (0, _minDash.filter)(descriptor.properties, function(p) {
        var name = p.name;
        if (p.isVirtual) return false;
        // do not serialize defaults
        if (!(0, _minDash.has)(element, name)) return false;
        var value = element[name];
        // do not serialize default equals
        if (value === p.default) return false;
        // do not serialize null properties
        if (value === null) return false;
        return p.isMany ? value.length : true;
    });
}
var ESCAPE_ATTR_MAP = {
    '\n': '#10',
    '\n\r': '#10',
    '"': '#34',
    '\'': '#39',
    '<': '#60',
    '>': '#62',
    '&': '#38'
};
var ESCAPE_MAP = {
    '<': 'lt',
    '>': 'gt',
    '&': 'amp'
};
function escape(str, charPattern, replaceMap) {
    // ensure we are handling strings here
    str = (0, _minDash.isString)(str) ? str : '' + str;
    return str.replace(charPattern, function(s) {
        return '&' + replaceMap[s] + ';';
    });
}
/**
 * Escape a string attribute to not contain any bad values (line breaks, '"', ...)
 *
 * @param {String} str the string to escape
 * @return {String} the escaped string
 */ function escapeAttr(str) {
    return escape(str, ESCAPE_ATTR_CHARS, ESCAPE_ATTR_MAP);
}
function escapeBody(str) {
    return escape(str, ESCAPE_CHARS, ESCAPE_MAP);
}
function filterAttributes(props) {
    return (0, _minDash.filter)(props, function(p) {
        return p.isAttr;
    });
}
function filterContained(props) {
    return (0, _minDash.filter)(props, function(p) {
        return !p.isAttr;
    });
}
function ReferenceSerializer(tagName) {
    this.tagName = tagName;
}
ReferenceSerializer.prototype.build = function(element) {
    this.element = element;
    return this;
};
ReferenceSerializer.prototype.serializeTo = function(writer) {
    writer.appendIndent().append('<' + this.tagName + '>' + this.element.id + '</' + this.tagName + '>').appendNewLine();
};
function BodySerializer() {}
BodySerializer.prototype.serializeValue = BodySerializer.prototype.serializeTo = function(writer) {
    writer.append(this.escape ? escapeBody(this.value) : this.value);
};
BodySerializer.prototype.build = function(prop, value) {
    this.value = value;
    if (prop.type === 'String' && value.search(ESCAPE_CHARS) !== -1) this.escape = true;
    return this;
};
function ValueSerializer(tagName) {
    this.tagName = tagName;
}
inherits(ValueSerializer, BodySerializer);
ValueSerializer.prototype.serializeTo = function(writer) {
    writer.appendIndent().append('<' + this.tagName + '>');
    this.serializeValue(writer);
    writer.append('</' + this.tagName + '>').appendNewLine();
};
function ElementSerializer(parent, propertyDescriptor) {
    this.body = [];
    this.attrs = [];
    this.parent = parent;
    this.propertyDescriptor = propertyDescriptor;
}
ElementSerializer.prototype.build = function(element) {
    this.element = element;
    var elementDescriptor = element.$descriptor, propertyDescriptor = this.propertyDescriptor;
    var otherAttrs, properties;
    var isGeneric = elementDescriptor.isGeneric;
    if (isGeneric) otherAttrs = this.parseGeneric(element);
    else otherAttrs = this.parseNsAttributes(element);
    if (propertyDescriptor) this.ns = this.nsPropertyTagName(propertyDescriptor);
    else this.ns = this.nsTagName(elementDescriptor);
    // compute tag name
    this.tagName = this.addTagName(this.ns);
    if (!isGeneric) {
        properties = getSerializableProperties(element);
        this.parseAttributes(filterAttributes(properties));
        this.parseContainments(filterContained(properties));
    }
    this.parseGenericAttributes(element, otherAttrs);
    return this;
};
ElementSerializer.prototype.nsTagName = function(descriptor) {
    var effectiveNs = this.logNamespaceUsed(descriptor.ns);
    return getElementNs(effectiveNs, descriptor);
};
ElementSerializer.prototype.nsPropertyTagName = function(descriptor) {
    var effectiveNs = this.logNamespaceUsed(descriptor.ns);
    return getPropertyNs(effectiveNs, descriptor);
};
ElementSerializer.prototype.isLocalNs = function(ns) {
    return ns.uri === this.ns.uri;
};
/**
 * Get the actual ns attribute name for the given element.
 *
 * @param {Object} element
 * @param {Boolean} [element.inherited=false]
 *
 * @return {Object} nsName
 */ ElementSerializer.prototype.nsAttributeName = function(element) {
    var ns;
    if ((0, _minDash.isString)(element)) ns = (0, _moddle.parseNameNS)(element);
    else ns = element.ns;
    // return just local name for inherited attributes
    if (element.inherited) return {
        localName: ns.localName
    };
    // parse + log effective ns
    var effectiveNs = this.logNamespaceUsed(ns);
    // LOG ACTUAL namespace use
    this.getNamespaces().logUsed(effectiveNs);
    // strip prefix if same namespace like parent
    if (this.isLocalNs(effectiveNs)) return {
        localName: ns.localName
    };
    else return (0, _minDash.assign)({
        localName: ns.localName
    }, effectiveNs);
};
ElementSerializer.prototype.parseGeneric = function(element) {
    var self = this, body = this.body;
    var attributes = [];
    (0, _minDash.forEach)(element, function(val, key) {
        var nonNsAttr;
        if (key === '$body') body.push(new BodySerializer().build({
            type: 'String'
        }, val));
        else if (key === '$children') (0, _minDash.forEach)(val, function(child) {
            body.push(new ElementSerializer(self).build(child));
        });
        else if (key.indexOf('$') !== 0) {
            nonNsAttr = self.parseNsAttribute(element, key, val);
            if (nonNsAttr) attributes.push({
                name: key,
                value: val
            });
        }
    });
    return attributes;
};
ElementSerializer.prototype.parseNsAttribute = function(element, name, value) {
    var model = element.$model;
    var nameNs = (0, _moddle.parseNameNS)(name);
    var ns;
    // parse xmlns:foo="http://foo.bar"
    if (nameNs.prefix === 'xmlns') ns = {
        prefix: nameNs.localName,
        uri: value
    };
    // parse xmlns="http://foo.bar"
    if (!nameNs.prefix && nameNs.localName === 'xmlns') ns = {
        uri: value
    };
    if (!ns) return {
        name: name,
        value: value
    };
    if (model && model.getPackage(value)) // register well known namespace
    this.logNamespace(ns, true, true);
    else {
        // log custom namespace directly as used
        var actualNs = this.logNamespaceUsed(ns, true);
        this.getNamespaces().logUsed(actualNs);
    }
};
/**
 * Parse namespaces and return a list of left over generic attributes
 *
 * @param  {Object} element
 * @return {Array<Object>}
 */ ElementSerializer.prototype.parseNsAttributes = function(element, attrs) {
    var self = this;
    var genericAttrs = element.$attrs;
    var attributes = [];
    // parse namespace attributes first
    // and log them. push non namespace attributes to a list
    // and process them later
    (0, _minDash.forEach)(genericAttrs, function(value, name) {
        var nonNsAttr = self.parseNsAttribute(element, name, value);
        if (nonNsAttr) attributes.push(nonNsAttr);
    });
    return attributes;
};
ElementSerializer.prototype.parseGenericAttributes = function(element, attributes) {
    var self = this;
    (0, _minDash.forEach)(attributes, function(attr) {
        // do not serialize xsi:type attribute
        // it is set manually based on the actual implementation type
        if (attr.name === XSI_TYPE) return;
        try {
            self.addAttribute(self.nsAttributeName(attr.name), attr.value);
        } catch (e) {
            /* global console */ console.warn('missing namespace information for ', attr.name, '=', attr.value, 'on', element, e);
        }
    });
};
ElementSerializer.prototype.parseContainments = function(properties) {
    var self = this, body = this.body, element = this.element;
    (0, _minDash.forEach)(properties, function(p) {
        var value = element.get(p.name), isReference = p.isReference, isMany = p.isMany;
        if (!isMany) value = [
            value
        ];
        if (p.isBody) body.push(new BodySerializer().build(p, value[0]));
        else if ((0, _moddle.isSimpleType)(p.type)) (0, _minDash.forEach)(value, function(v) {
            body.push(new ValueSerializer(self.addTagName(self.nsPropertyTagName(p))).build(p, v));
        });
        else if (isReference) (0, _minDash.forEach)(value, function(v) {
            body.push(new ReferenceSerializer(self.addTagName(self.nsPropertyTagName(p))).build(v));
        });
        else {
            // allow serialization via type
            // rather than element name
            var asType = serializeAsType(p), asProperty = serializeAsProperty(p);
            (0, _minDash.forEach)(value, function(v) {
                var serializer;
                if (asType) serializer = new TypeSerializer(self, p);
                else if (asProperty) serializer = new ElementSerializer(self, p);
                else serializer = new ElementSerializer(self);
                body.push(serializer.build(v));
            });
        }
    });
};
ElementSerializer.prototype.getNamespaces = function(local) {
    var namespaces = this.namespaces, parent = this.parent, parentNamespaces;
    if (!namespaces) {
        parentNamespaces = parent && parent.getNamespaces();
        if (local || !parentNamespaces) this.namespaces = namespaces = new Namespaces(parentNamespaces);
        else namespaces = parentNamespaces;
    }
    return namespaces;
};
ElementSerializer.prototype.logNamespace = function(ns, wellknown, local) {
    var namespaces = this.getNamespaces(local);
    var nsUri = ns.uri, nsPrefix = ns.prefix;
    var existing = namespaces.byUri(nsUri);
    if (!existing || local) namespaces.add(ns, wellknown);
    namespaces.mapPrefix(nsPrefix, nsUri);
    return ns;
};
ElementSerializer.prototype.logNamespaceUsed = function(ns, local) {
    var element = this.element, model = element.$model, namespaces = this.getNamespaces(local);
    // ns may be
    //
    //   * prefix only
    //   * prefix:uri
    //   * localName only
    var prefix = ns.prefix, uri = ns.uri, newPrefix, idx, wellknownUri;
    // handle anonymous namespaces (elementForm=unqualified), cf. #23
    if (!prefix && !uri) return {
        localName: ns.localName
    };
    wellknownUri = DEFAULT_NS_MAP[prefix] || model && (model.getPackage(prefix) || {}).uri;
    uri = uri || wellknownUri || namespaces.uriByPrefix(prefix);
    if (!uri) throw new Error('no namespace uri given for prefix <' + prefix + '>');
    ns = namespaces.byUri(uri);
    if (!ns) {
        newPrefix = prefix;
        idx = 1;
        // find a prefix that is not mapped yet
        while(namespaces.uriByPrefix(newPrefix))newPrefix = prefix + '_' + idx++;
        ns = this.logNamespace({
            prefix: newPrefix,
            uri: uri
        }, wellknownUri === uri);
    }
    if (prefix) namespaces.mapPrefix(prefix, uri);
    return ns;
};
ElementSerializer.prototype.parseAttributes = function(properties) {
    var self = this, element = this.element;
    (0, _minDash.forEach)(properties, function(p) {
        var value = element.get(p.name);
        if (p.isReference) {
            if (!p.isMany) value = value.id;
            else {
                var values = [];
                (0, _minDash.forEach)(value, function(v) {
                    values.push(v.id);
                });
                // IDREFS is a whitespace-separated list of references.
                value = values.join(' ');
            }
        }
        self.addAttribute(self.nsAttributeName(p), value);
    });
};
ElementSerializer.prototype.addTagName = function(nsTagName) {
    var actualNs = this.logNamespaceUsed(nsTagName);
    this.getNamespaces().logUsed(actualNs);
    return nsName(nsTagName);
};
ElementSerializer.prototype.addAttribute = function(name, value) {
    var attrs = this.attrs;
    if ((0, _minDash.isString)(value)) value = escapeAttr(value);
    // de-duplicate attributes
    // https://github.com/bpmn-io/moddle-xml/issues/66
    var idx = (0, _minDash.findIndex)(attrs, function(element) {
        return element.name.localName === name.localName && element.name.uri === name.uri && element.name.prefix === name.prefix;
    });
    var attr = {
        name: name,
        value: value
    };
    if (idx !== -1) attrs.splice(idx, 1, attr);
    else attrs.push(attr);
};
ElementSerializer.prototype.serializeAttributes = function(writer) {
    var attrs = this.attrs, namespaces = this.namespaces;
    if (namespaces) attrs = getNsAttrs(namespaces).concat(attrs);
    (0, _minDash.forEach)(attrs, function(a) {
        writer.append(' ').append(nsName(a.name)).append('="').append(a.value).append('"');
    });
};
ElementSerializer.prototype.serializeTo = function(writer) {
    var firstBody = this.body[0], indent = firstBody && firstBody.constructor !== BodySerializer;
    writer.appendIndent().append('<' + this.tagName);
    this.serializeAttributes(writer);
    writer.append(firstBody ? '>' : ' />');
    if (firstBody) {
        if (indent) writer.appendNewLine().indent();
        (0, _minDash.forEach)(this.body, function(b) {
            b.serializeTo(writer);
        });
        if (indent) writer.unindent().appendIndent();
        writer.append('</' + this.tagName + '>');
    }
    writer.appendNewLine();
};
/**
 * A serializer for types that handles serialization of data types
 */ function TypeSerializer(parent, propertyDescriptor) {
    ElementSerializer.call(this, parent, propertyDescriptor);
}
inherits(TypeSerializer, ElementSerializer);
TypeSerializer.prototype.parseNsAttributes = function(element) {
    // extracted attributes
    var attributes = ElementSerializer.prototype.parseNsAttributes.call(this, element);
    var descriptor = element.$descriptor;
    // only serialize xsi:type if necessary
    if (descriptor.name === this.propertyDescriptor.type) return attributes;
    var typeNs = this.typeNs = this.nsTagName(descriptor);
    this.getNamespaces().logUsed(this.typeNs);
    // add xsi:type attribute to represent the elements
    // actual type
    var pkg = element.$model.getPackage(typeNs.uri), typePrefix = pkg.xml && pkg.xml.typePrefix || '';
    this.addAttribute(this.nsAttributeName(XSI_TYPE), (typeNs.prefix ? typeNs.prefix + ':' : '') + typePrefix + descriptor.ns.localName);
    return attributes;
};
TypeSerializer.prototype.isLocalNs = function(ns) {
    return ns.uri === (this.typeNs || this.ns).uri;
};
function SavingWriter() {
    this.value = '';
    this.write = function(str) {
        this.value += str;
    };
}
function FormatingWriter(out, format) {
    var indent = [
        ''
    ];
    this.append = function(str) {
        out.write(str);
        return this;
    };
    this.appendNewLine = function() {
        if (format) out.write('\n');
        return this;
    };
    this.appendIndent = function() {
        if (format) out.write(indent.join('  '));
        return this;
    };
    this.indent = function() {
        indent.push('');
        return this;
    };
    this.unindent = function() {
        indent.pop();
        return this;
    };
}
/**
 * A writer for meta-model backed document trees
 *
 * @param {Object} options output options to pass into the writer
 */ function Writer(options) {
    options = (0, _minDash.assign)({
        format: false,
        preamble: true
    }, options || {});
    function toXML(tree, writer) {
        var internalWriter = writer || new SavingWriter();
        var formatingWriter = new FormatingWriter(internalWriter, options.format);
        if (options.preamble) formatingWriter.append(XML_PREAMBLE);
        new ElementSerializer().build(tree).serializeTo(formatingWriter);
        if (!writer) return internalWriter.value;
    }
    return {
        toXML: toXML
    };
}

},{"min-dash":"aEEla","saxen":"72Grn","moddle":"4ydsy","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"72Grn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Parser", ()=>Parser);
parcelHelpers.export(exports, "decode", ()=>decodeEntities);
var fromCharCode = String.fromCharCode;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var ENTITY_PATTERN = /&#(\d+);|&#x([0-9a-f]+);|&(\w+);/ig;
var ENTITY_MAPPING = {
    'amp': '&',
    'apos': '\'',
    'gt': '>',
    'lt': '<',
    'quot': '"'
};
// map UPPERCASE variants of supported special chars
Object.keys(ENTITY_MAPPING).forEach(function(k) {
    ENTITY_MAPPING[k.toUpperCase()] = ENTITY_MAPPING[k];
});
function replaceEntities(_, d, x, z) {
    // reserved names, i.e. &nbsp;
    if (z) {
        if (hasOwnProperty.call(ENTITY_MAPPING, z)) return ENTITY_MAPPING[z];
        else // fall back to original value
        return '&' + z + ';';
    }
    // decimal encoded char
    if (d) return fromCharCode(d);
    // hex encoded char
    return fromCharCode(parseInt(x, 16));
}
/**
 * A basic entity decoder that can decode a minimal
 * sub-set of reserved names (&amp;) as well as
 * hex (&#xaaf;) and decimal (&#1231;) encoded characters.
 *
 * @param {string} str
 *
 * @return {string} decoded string
 */ function decodeEntities(s) {
    if (s.length > 3 && s.indexOf('&') !== -1) return s.replace(ENTITY_PATTERN, replaceEntities);
    return s;
}
var XSI_URI = 'http://www.w3.org/2001/XMLSchema-instance';
var XSI_PREFIX = 'xsi';
var XSI_TYPE = 'xsi:type';
var NON_WHITESPACE_OUTSIDE_ROOT_NODE = 'non-whitespace outside of root node';
function error(msg) {
    return new Error(msg);
}
function missingNamespaceForPrefix(prefix) {
    return 'missing namespace for prefix <' + prefix + '>';
}
function getter(getFn) {
    return {
        'get': getFn,
        'enumerable': true
    };
}
function cloneNsMatrix(nsMatrix) {
    var clone = {}, key;
    for(key in nsMatrix)clone[key] = nsMatrix[key];
    return clone;
}
function uriPrefix(prefix) {
    return prefix + '$uri';
}
function buildNsMatrix(nsUriToPrefix) {
    var nsMatrix = {}, uri, prefix;
    for(uri in nsUriToPrefix){
        prefix = nsUriToPrefix[uri];
        nsMatrix[prefix] = prefix;
        nsMatrix[uriPrefix(prefix)] = uri;
    }
    return nsMatrix;
}
function noopGetContext() {
    return {
        'line': 0,
        'column': 0
    };
}
function throwFunc(err) {
    throw err;
}
/**
 * Creates a new parser with the given options.
 *
 * @constructor
 *
 * @param  {!Object<string, ?>=} options
 */ function Parser(options) {
    if (!this) return new Parser(options);
    var proxy = options && options['proxy'];
    var onText, onOpenTag, onCloseTag, onCDATA, onError = throwFunc, onWarning, onComment, onQuestion, onAttention;
    var getContext = noopGetContext;
    /**
   * Do we need to parse the current elements attributes for namespaces?
   *
   * @type {boolean}
   */ var maybeNS = false;
    /**
   * Do we process namespaces at all?
   *
   * @type {boolean}
   */ var isNamespace = false;
    /**
   * The caught error returned on parse end
   *
   * @type {Error}
   */ var returnError = null;
    /**
   * Should we stop parsing?
   *
   * @type {boolean}
   */ var parseStop = false;
    /**
   * A map of { uri: prefix } used by the parser.
   *
   * This map will ensure we can normalize prefixes during processing;
   * for each uri, only one prefix will be exposed to the handlers.
   *
   * @type {!Object<string, string>}}
   */ var nsUriToPrefix;
    /**
   * Handle parse error.
   *
   * @param  {string|Error} err
   */ function handleError(err) {
        if (!(err instanceof Error)) err = error(err);
        returnError = err;
        onError(err, getContext);
    }
    /**
   * Handle parse error.
   *
   * @param  {string|Error} err
   */ function handleWarning(err) {
        if (!onWarning) return;
        if (!(err instanceof Error)) err = error(err);
        onWarning(err, getContext);
    }
    /**
   * Register parse listener.
   *
   * @param  {string}   name
   * @param  {Function} cb
   *
   * @return {Parser}
   */ this['on'] = function(name, cb) {
        if (typeof cb !== 'function') throw error('required args <name, cb>');
        switch(name){
            case 'openTag':
                onOpenTag = cb;
                break;
            case 'text':
                onText = cb;
                break;
            case 'closeTag':
                onCloseTag = cb;
                break;
            case 'error':
                onError = cb;
                break;
            case 'warn':
                onWarning = cb;
                break;
            case 'cdata':
                onCDATA = cb;
                break;
            case 'attention':
                onAttention = cb;
                break; // <!XXXXX zzzz="eeee">
            case 'question':
                onQuestion = cb;
                break; // <? ....  ?>
            case 'comment':
                onComment = cb;
                break;
            default:
                throw error('unsupported event: ' + name);
        }
        return this;
    };
    /**
   * Set the namespace to prefix mapping.
   *
   * @example
   *
   * parser.ns({
   *   'http://foo': 'foo',
   *   'http://bar': 'bar'
   * });
   *
   * @param  {!Object<string, string>} nsMap
   *
   * @return {Parser}
   */ this['ns'] = function(nsMap) {
        if (typeof nsMap === 'undefined') nsMap = {};
        if (typeof nsMap !== 'object') throw error('required args <nsMap={}>');
        var _nsUriToPrefix = {}, k;
        for(k in nsMap)_nsUriToPrefix[k] = nsMap[k];
        // FORCE default mapping for schema instance
        _nsUriToPrefix[XSI_URI] = XSI_PREFIX;
        isNamespace = true;
        nsUriToPrefix = _nsUriToPrefix;
        return this;
    };
    /**
   * Parse xml string.
   *
   * @param  {string} xml
   *
   * @return {Error} returnError, if not thrown
   */ this['parse'] = function(xml) {
        if (typeof xml !== 'string') throw error('required args <xml=string>');
        returnError = null;
        parse(xml);
        getContext = noopGetContext;
        parseStop = false;
        return returnError;
    };
    /**
   * Stop parsing.
   */ this['stop'] = function() {
        parseStop = true;
    };
    /**
   * Parse string, invoking configured listeners on element.
   *
   * @param  {string} xml
   */ function parse(xml) {
        var nsMatrixStack = isNamespace ? [] : null, nsMatrix = isNamespace ? buildNsMatrix(nsUriToPrefix) : null, _nsMatrix, nodeStack = [], anonymousNsCount = 0, tagStart = false, tagEnd = false, i = 0, j = 0, x, y, q, w, v, xmlns, elementName, _elementName, elementProxy;
        var attrsString = '', attrsStart = 0, cachedAttrs // false = parsed with errors, null = needs parsing
        ;
        /**
     * Parse attributes on demand and returns the parsed attributes.
     *
     * Return semantics: (1) `false` on attribute parse error,
     * (2) object hash on extracted attrs.
     *
     * @return {boolean|Object}
     */ function getAttrs() {
            if (cachedAttrs !== null) return cachedAttrs;
            var nsUri, nsUriPrefix, nsName, defaultAlias = isNamespace && nsMatrix['xmlns'], attrList = isNamespace && maybeNS ? [] : null, i = attrsStart, s = attrsString, l = s.length, hasNewMatrix, newalias, value, alias, name, attrs = {}, seenAttrs = {}, skipAttr, w, j;
            parseAttr: for(; i < l; i++){
                skipAttr = false;
                w = s.charCodeAt(i);
                if (w === 32 || w < 14 && w > 8) continue;
                // wait for non whitespace character
                if (w < 65 || w > 122 || w > 90 && w < 97) {
                    if (w !== 95 && w !== 58) {
                        handleWarning('illegal first char attribute name');
                        skipAttr = true;
                    }
                }
                // parse attribute name
                for(j = i + 1; j < l; j++){
                    w = s.charCodeAt(j);
                    if (w > 96 && w < 123 || w > 64 && w < 91 || w > 47 && w < 59 || w === 46 || // '.'
                    w === 45 || // '-'
                    w === 95 // '_'
                    ) continue;
                    // unexpected whitespace
                    if (w === 32 || w < 14 && w > 8) {
                        handleWarning('missing attribute value');
                        i = j;
                        continue parseAttr;
                    }
                    // expected "="
                    if (w === 61) break;
                    handleWarning('illegal attribute name char');
                    skipAttr = true;
                }
                name = s.substring(i, j);
                if (name === 'xmlns:xmlns') {
                    handleWarning('illegal declaration of xmlns');
                    skipAttr = true;
                }
                w = s.charCodeAt(j + 1);
                if (w === 34) {
                    j = s.indexOf('"', i = j + 2);
                    if (j === -1) {
                        j = s.indexOf('\'', i);
                        if (j !== -1) {
                            handleWarning('attribute value quote missmatch');
                            skipAttr = true;
                        }
                    }
                } else if (w === 39) {
                    j = s.indexOf('\'', i = j + 2);
                    if (j === -1) {
                        j = s.indexOf('"', i);
                        if (j !== -1) {
                            handleWarning('attribute value quote missmatch');
                            skipAttr = true;
                        }
                    }
                } else {
                    handleWarning('missing attribute value quotes');
                    skipAttr = true;
                    // skip to next space
                    for(j = j + 1; j < l; j++){
                        w = s.charCodeAt(j + 1);
                        if (w === 32 || w < 14 && w > 8) break;
                    }
                }
                if (j === -1) {
                    handleWarning('missing closing quotes');
                    j = l;
                    skipAttr = true;
                }
                if (!skipAttr) value = s.substring(i, j);
                i = j;
                // ensure SPACE follows attribute
                // skip illegal content otherwise
                // example a="b"c
                for(; j + 1 < l; j++){
                    w = s.charCodeAt(j + 1);
                    if (w === 32 || w < 14 && w > 8) break;
                    // FIRST ILLEGAL CHAR
                    if (i === j) {
                        handleWarning('illegal character after attribute end');
                        skipAttr = true;
                    }
                }
                // advance cursor to next attribute
                i = j + 1;
                if (skipAttr) continue parseAttr;
                // check attribute re-declaration
                if (name in seenAttrs) {
                    handleWarning('attribute <' + name + '> already defined');
                    continue;
                }
                seenAttrs[name] = true;
                if (!isNamespace) {
                    attrs[name] = value;
                    continue;
                }
                // try to extract namespace information
                if (maybeNS) {
                    newalias = name === 'xmlns' ? 'xmlns' : name.charCodeAt(0) === 120 && name.substr(0, 6) === 'xmlns:' ? name.substr(6) : null;
                    // handle xmlns(:alias) assignment
                    if (newalias !== null) {
                        nsUri = decodeEntities(value);
                        nsUriPrefix = uriPrefix(newalias);
                        alias = nsUriToPrefix[nsUri];
                        if (!alias) {
                            // no prefix defined or prefix collision
                            if (newalias === 'xmlns' || nsUriPrefix in nsMatrix && nsMatrix[nsUriPrefix] !== nsUri) // alocate free ns prefix
                            do alias = 'ns' + anonymousNsCount++;
                            while (typeof nsMatrix[alias] !== 'undefined');
                            else alias = newalias;
                            nsUriToPrefix[nsUri] = alias;
                        }
                        if (nsMatrix[newalias] !== alias) {
                            if (!hasNewMatrix) {
                                nsMatrix = cloneNsMatrix(nsMatrix);
                                hasNewMatrix = true;
                            }
                            nsMatrix[newalias] = alias;
                            if (newalias === 'xmlns') {
                                nsMatrix[uriPrefix(alias)] = nsUri;
                                defaultAlias = alias;
                            }
                            nsMatrix[nsUriPrefix] = nsUri;
                        }
                        // expose xmlns(:asd)="..." in attributes
                        attrs[name] = value;
                        continue;
                    }
                    // collect attributes until all namespace
                    // declarations are processed
                    attrList.push(name, value);
                    continue;
                } /** end if (maybeNs) */ 
                // handle attributes on element without
                // namespace declarations
                w = name.indexOf(':');
                if (w === -1) {
                    attrs[name] = value;
                    continue;
                }
                // normalize ns attribute name
                if (!(nsName = nsMatrix[name.substring(0, w)])) {
                    handleWarning(missingNamespaceForPrefix(name.substring(0, w)));
                    continue;
                }
                name = defaultAlias === nsName ? name.substr(w + 1) : nsName + name.substr(w);
                // end: normalize ns attribute name
                // normalize xsi:type ns attribute value
                if (name === XSI_TYPE) {
                    w = value.indexOf(':');
                    if (w !== -1) {
                        nsName = value.substring(0, w);
                        // handle default prefixes, i.e. xs:String gracefully
                        nsName = nsMatrix[nsName] || nsName;
                        value = nsName + value.substring(w);
                    } else value = defaultAlias + ':' + value;
                }
                // end: normalize xsi:type ns attribute value
                attrs[name] = value;
            }
            // handle deferred, possibly namespaced attributes
            if (maybeNS) // normalize captured attributes
            for(i = 0, l = attrList.length; i < l; i++){
                name = attrList[i++];
                value = attrList[i];
                w = name.indexOf(':');
                if (w !== -1) {
                    // normalize ns attribute name
                    if (!(nsName = nsMatrix[name.substring(0, w)])) {
                        handleWarning(missingNamespaceForPrefix(name.substring(0, w)));
                        continue;
                    }
                    name = defaultAlias === nsName ? name.substr(w + 1) : nsName + name.substr(w);
                    // end: normalize ns attribute name
                    // normalize xsi:type ns attribute value
                    if (name === XSI_TYPE) {
                        w = value.indexOf(':');
                        if (w !== -1) {
                            nsName = value.substring(0, w);
                            // handle default prefixes, i.e. xs:String gracefully
                            nsName = nsMatrix[nsName] || nsName;
                            value = nsName + value.substring(w);
                        } else value = defaultAlias + ':' + value;
                    }
                // end: normalize xsi:type ns attribute value
                }
                attrs[name] = value;
            }
            return cachedAttrs = attrs;
        }
        /**
     * Extract the parse context { line, column, part }
     * from the current parser position.
     *
     * @return {Object} parse context
     */ function getParseContext() {
            var splitsRe = /(\r\n|\r|\n)/g;
            var line = 0;
            var column = 0;
            var startOfLine = 0;
            var endOfLine = j;
            var match;
            var data;
            while(i >= startOfLine){
                match = splitsRe.exec(xml);
                if (!match) break;
                // end of line = (break idx + break chars)
                endOfLine = match[0].length + match.index;
                if (endOfLine > i) break;
                // advance to next line
                line += 1;
                startOfLine = endOfLine;
            }
            // EOF errors
            if (i == -1) {
                column = endOfLine;
                data = xml.substring(j);
            } else // start errors
            if (j === 0) data = xml.substring(j, i);
            else {
                column = i - startOfLine;
                data = j == -1 ? xml.substring(i) : xml.substring(i, j + 1);
            }
            return {
                'data': data,
                'line': line,
                'column': column
            };
        }
        getContext = getParseContext;
        if (proxy) elementProxy = Object.create({}, {
            'name': getter(function() {
                return elementName;
            }),
            'originalName': getter(function() {
                return _elementName;
            }),
            'attrs': getter(getAttrs),
            'ns': getter(function() {
                return nsMatrix;
            })
        });
        // actual parse logic
        while(j !== -1){
            if (xml.charCodeAt(j) === 60) i = j;
            else i = xml.indexOf('<', j);
            // parse end
            if (i === -1) {
                if (nodeStack.length) return handleError('unexpected end of file');
                if (j === 0) return handleError('missing start tag');
                if (j < xml.length) {
                    if (xml.substring(j).trim()) handleWarning(NON_WHITESPACE_OUTSIDE_ROOT_NODE);
                }
                return;
            }
            // parse text
            if (j !== i) {
                if (nodeStack.length) {
                    if (onText) {
                        onText(xml.substring(j, i), decodeEntities, getContext);
                        if (parseStop) return;
                    }
                } else if (xml.substring(j, i).trim()) {
                    handleWarning(NON_WHITESPACE_OUTSIDE_ROOT_NODE);
                    if (parseStop) return;
                }
            }
            w = xml.charCodeAt(i + 1);
            // parse comments + CDATA
            if (w === 33) {
                q = xml.charCodeAt(i + 2);
                // CDATA section
                if (q === 91 && xml.substr(i + 3, 6) === 'CDATA[') {
                    j = xml.indexOf(']]>', i);
                    if (j === -1) return handleError('unclosed cdata');
                    if (onCDATA) {
                        onCDATA(xml.substring(i + 9, j), getContext);
                        if (parseStop) return;
                    }
                    j += 3;
                    continue;
                }
                // comment
                if (q === 45 && xml.charCodeAt(i + 3) === 45) {
                    j = xml.indexOf('-->', i);
                    if (j === -1) return handleError('unclosed comment');
                    if (onComment) {
                        onComment(xml.substring(i + 4, j), decodeEntities, getContext);
                        if (parseStop) return;
                    }
                    j += 3;
                    continue;
                }
            }
            // parse question <? ... ?>
            if (w === 63) {
                j = xml.indexOf('?>', i);
                if (j === -1) return handleError('unclosed question');
                if (onQuestion) {
                    onQuestion(xml.substring(i, j + 2), getContext);
                    if (parseStop) return;
                }
                j += 2;
                continue;
            }
            // find matching closing tag for attention or standard tags
            // for that we must skip through attribute values
            // (enclosed in single or double quotes)
            for(x = i + 1;; x++){
                v = xml.charCodeAt(x);
                if (isNaN(v)) {
                    j = -1;
                    return handleError('unclosed tag');
                }
                // [10] AttValue ::= '"' ([^<&"] | Reference)* '"' | "'" ([^<&'] | Reference)* "'"
                // skips the quoted string
                // (double quotes) does not appear in a literal enclosed by (double quotes)
                // (single quote) does not appear in a literal enclosed by (single quote)
                if (v === 34) {
                    q = xml.indexOf('"', x + 1);
                    x = q !== -1 ? q : x;
                } else if (v === 39) {
                    q = xml.indexOf("'", x + 1);
                    x = q !== -1 ? q : x;
                } else if (v === 62) {
                    j = x;
                    break;
                }
            }
            // parse attention <! ...>
            // previously comment and CDATA have already been parsed
            if (w === 33) {
                if (onAttention) {
                    onAttention(xml.substring(i, j + 1), decodeEntities, getContext);
                    if (parseStop) return;
                }
                j += 1;
                continue;
            }
            // don't process attributes;
            // there are none
            cachedAttrs = {};
            // if (xml.charCodeAt(i+1) === 47) { // </...
            if (w === 47) {
                tagStart = false;
                tagEnd = true;
                if (!nodeStack.length) return handleError('missing open tag');
                // verify open <-> close tag match
                x = elementName = nodeStack.pop();
                q = i + 2 + x.length;
                if (xml.substring(i + 2, q) !== x) return handleError('closing tag mismatch');
                // verify chars in close tag
                for(; q < j; q++){
                    w = xml.charCodeAt(q);
                    if (w === 32 || w > 8 && w < 14) continue;
                    return handleError('close tag');
                }
            } else {
                if (xml.charCodeAt(j - 1) === 47) {
                    x = elementName = xml.substring(i + 1, j - 1);
                    tagStart = true;
                    tagEnd = true;
                } else {
                    x = elementName = xml.substring(i + 1, j);
                    tagStart = true;
                    tagEnd = false;
                }
                if (!(w > 96 && w < 123 || w > 64 && w < 91 || w === 95 || w === 58)) return handleError('illegal first char nodeName');
                for(q = 1, y = x.length; q < y; q++){
                    w = x.charCodeAt(q);
                    if (w > 96 && w < 123 || w > 64 && w < 91 || w > 47 && w < 59 || w === 45 || w === 95 || w == 46) continue;
                    if (w === 32 || w < 14 && w > 8) {
                        elementName = x.substring(0, q);
                        // maybe there are attributes
                        cachedAttrs = null;
                        break;
                    }
                    return handleError('invalid nodeName');
                }
                if (!tagEnd) nodeStack.push(elementName);
            }
            if (isNamespace) {
                _nsMatrix = nsMatrix;
                if (tagStart) {
                    // remember old namespace
                    // unless we're self-closing
                    if (!tagEnd) nsMatrixStack.push(_nsMatrix);
                    if (cachedAttrs === null) // quick check, whether there may be namespace
                    // declarations on the node; if that is the case
                    // we need to eagerly parse the node attributes
                    {
                        if (maybeNS = x.indexOf('xmlns', q) !== -1) {
                            attrsStart = q;
                            attrsString = x;
                            getAttrs();
                            maybeNS = false;
                        }
                    }
                }
                _elementName = elementName;
                w = elementName.indexOf(':');
                if (w !== -1) {
                    xmlns = nsMatrix[elementName.substring(0, w)];
                    // prefix given; namespace must exist
                    if (!xmlns) return handleError('missing namespace on <' + _elementName + '>');
                    elementName = elementName.substr(w + 1);
                } else xmlns = nsMatrix['xmlns'];
                // adjust namespace prefixs as configured
                if (xmlns) elementName = xmlns + ':' + elementName;
            }
            if (tagStart) {
                attrsStart = q;
                attrsString = x;
                if (onOpenTag) {
                    if (proxy) onOpenTag(elementProxy, decodeEntities, tagEnd, getContext);
                    else onOpenTag(elementName, getAttrs, decodeEntities, tagEnd, getContext);
                    if (parseStop) return;
                }
            }
            if (tagEnd) {
                if (onCloseTag) {
                    onCloseTag(proxy ? elementProxy : elementName, decodeEntities, tagStart, getContext);
                    if (parseStop) return;
                }
                // restore old namespace
                if (isNamespace) {
                    if (!tagStart) nsMatrix = nsMatrixStack.pop();
                    else nsMatrix = _nsMatrix;
                }
            }
            j += 1;
        }
    } /** end parse */ 
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9f1dX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The importBpmnDiagram result.
 *
 * @typedef {Object} ImportBPMNDiagramResult
 *
 * @property {Array<string>} warnings
 */ /**
* The importBpmnDiagram error.
*
* @typedef {Error} ImportBPMNDiagramError
*
* @property {Array<string>} warnings
*/ /**
 * Import the definitions into a diagram.
 *
 * Errors and warnings are reported through the specified callback.
 *
 * @param  {djs.Diagram} diagram
 * @param  {ModdleElement<Definitions>} definitions
 * @param  {ModdleElement<BPMNDiagram>} [bpmnDiagram] the diagram to be rendered
 * (if not provided, the first one will be rendered)
 *
 * Returns {Promise<ImportBPMNDiagramResult, ImportBPMNDiagramError>}
 */ parcelHelpers.export(exports, "importBpmnDiagram", ()=>importBpmnDiagram);
var _minDash = require("min-dash");
var _bpmnTreeWalker = require("./BpmnTreeWalker");
var _bpmnTreeWalkerDefault = parcelHelpers.interopDefault(_bpmnTreeWalker);
var _modelUtil = require("../util/ModelUtil");
function importBpmnDiagram(diagram, definitions, bpmnDiagram) {
    var importer, eventBus, translate, canvas;
    var error, warnings = [];
    /**
   * Walk the diagram semantically, importing (=drawing)
   * all elements you encounter.
   *
   * @param {ModdleElement<Definitions>} definitions
   * @param {ModdleElement<BPMNDiagram>} bpmnDiagram
   */ function render(definitions, bpmnDiagram) {
        var visitor = {
            root: function(element, di) {
                return importer.add(element, di);
            },
            element: function(element, di, parentShape) {
                return importer.add(element, di, parentShape);
            },
            error: function(message, context) {
                warnings.push({
                    message: message,
                    context: context
                });
            }
        };
        var walker = new (0, _bpmnTreeWalkerDefault.default)(visitor, translate);
        bpmnDiagram = bpmnDiagram || definitions.diagrams && definitions.diagrams[0];
        var diagramsToImport = getDiagramsToImport(definitions, bpmnDiagram);
        if (!diagramsToImport) throw new Error(translate('no diagram to display'));
        // traverse BPMN 2.0 document model,
        // starting at definitions
        (0, _minDash.forEach)(diagramsToImport, function(diagram) {
            walker.handleDefinitions(definitions, diagram);
        });
        var rootId = bpmnDiagram.plane.bpmnElement.id;
        // we do need to account for different ways we create root elements
        // each nested imported <root> do have the `_plane` suffix, while
        // the root <root> is found under the business object ID
        canvas.setRootElement(canvas.findRoot(rootId + '_plane') || canvas.findRoot(rootId));
    }
    return new Promise(function(resolve, reject) {
        try {
            importer = diagram.get('bpmnImporter');
            eventBus = diagram.get('eventBus');
            translate = diagram.get('translate');
            canvas = diagram.get('canvas');
            eventBus.fire('import.render.start', {
                definitions: definitions
            });
            render(definitions, bpmnDiagram);
            eventBus.fire('import.render.complete', {
                error: error,
                warnings: warnings
            });
            return resolve({
                warnings: warnings
            });
        } catch (e) {
            e.warnings = warnings;
            return reject(e);
        }
    });
}
/**
 * Returns all diagrams in the same hierarchy as the requested diagram.
 * Includes all parent and sub process diagrams.
 *
 * @param {Array} definitions
 * @param {Object} bpmnDiagram
 *
 * @returns {Array<Object>}
 */ function getDiagramsToImport(definitions, bpmnDiagram) {
    if (!bpmnDiagram) return;
    var bpmnElement = bpmnDiagram.plane.bpmnElement, rootElement = bpmnElement;
    if (!(0, _modelUtil.is)(bpmnElement, 'bpmn:Process') && !(0, _modelUtil.is)(bpmnElement, 'bpmn:Collaboration')) rootElement = findRootProcess(bpmnElement);
    // in case the process is part of a collaboration, the plane references the
    // collaboration, not the process
    var collaboration;
    if ((0, _modelUtil.is)(rootElement, 'bpmn:Collaboration')) collaboration = rootElement;
    else collaboration = (0, _minDash.find)(definitions.rootElements, function(element) {
        if (!(0, _modelUtil.is)(element, 'bpmn:Collaboration')) return;
        return (0, _minDash.find)(element.participants, function(participant) {
            return participant.processRef === rootElement;
        });
    });
    var rootElements = [
        rootElement
    ];
    // all collaboration processes can contain sub-diagrams
    if (collaboration) {
        rootElements = (0, _minDash.map)(collaboration.participants, function(participant) {
            return participant.processRef;
        });
        rootElements.push(collaboration);
    }
    var allChildren = selfAndAllFlowElements(rootElements);
    // if we have multiple diagrams referencing the same element, we
    // use the first in the file
    var diagramsToImport = [
        bpmnDiagram
    ];
    var handledElements = [
        bpmnElement
    ];
    (0, _minDash.forEach)(definitions.diagrams, function(diagram) {
        var businessObject = diagram.plane.bpmnElement;
        if (allChildren.indexOf(businessObject) !== -1 && handledElements.indexOf(businessObject) === -1) {
            diagramsToImport.push(diagram);
            handledElements.push(businessObject);
        }
    });
    return diagramsToImport;
}
function selfAndAllFlowElements(elements) {
    var result = [];
    (0, _minDash.forEach)(elements, function(element) {
        if (!element) return;
        result.push(element);
        result = result.concat(selfAndAllFlowElements(element.flowElements));
    });
    return result;
}
function findRootProcess(element) {
    var parent = element;
    while(parent){
        if ((0, _modelUtil.is)(parent, 'bpmn:Process')) return parent;
        parent = parent.$parent;
    }
}

},{"min-dash":"aEEla","./BpmnTreeWalker":"93GJR","../util/ModelUtil":"klNYN","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"93GJR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BpmnTreeWalker);
var _minDash = require("min-dash");
var _util = require("./Util");
var _compatibilityUtil = require("../util/CompatibilityUtil");
/**
 * Returns true if an element has the given meta-model type
 *
 * @param  {ModdleElement}  element
 * @param  {string}         type
 *
 * @return {boolean}
 */ function is(element, type) {
    return element.$instanceOf(type);
}
/**
 * Find a suitable display candidate for definitions where the DI does not
 * correctly specify one.
 */ function findDisplayCandidate(definitions) {
    return (0, _minDash.find)(definitions.rootElements, function(e) {
        return is(e, 'bpmn:Process') || is(e, 'bpmn:Collaboration');
    });
}
function BpmnTreeWalker(handler, translate) {
    // list of containers already walked
    var handledElements = {};
    // list of elements to handle deferred to ensure
    // prerequisites are drawn
    var deferred = [];
    var diMap = {};
    // Helpers //////////////////////
    function contextual(fn, ctx) {
        return function(e) {
            fn(e, ctx);
        };
    }
    function handled(element) {
        handledElements[element.id] = element;
    }
    function isHandled(element) {
        return handledElements[element.id];
    }
    function visit(element, ctx) {
        var gfx = element.gfx;
        // avoid multiple rendering of elements
        if (gfx) throw new Error(translate('already rendered {element}', {
            element: (0, _util.elementToString)(element)
        }));
        // call handler
        return handler.element(element, diMap[element.id], ctx);
    }
    function visitRoot(element, diagram) {
        return handler.root(element, diMap[element.id], diagram);
    }
    function visitIfDi(element, ctx) {
        try {
            var gfx = diMap[element.id] && visit(element, ctx);
            handled(element);
            return gfx;
        } catch (e) {
            logError(e.message, {
                element: element,
                error: e
            });
            console.error(translate('failed to import {element}', {
                element: (0, _util.elementToString)(element)
            }));
            console.error(e);
        }
    }
    function logError(message, context) {
        handler.error(message, context);
    }
    // DI handling //////////////////////
    function registerDi(di) {
        var bpmnElement = di.bpmnElement;
        if (bpmnElement) {
            if (diMap[bpmnElement.id]) logError(translate('multiple DI elements defined for {element}', {
                element: (0, _util.elementToString)(bpmnElement)
            }), {
                element: bpmnElement
            });
            else {
                diMap[bpmnElement.id] = di;
                (0, _compatibilityUtil.ensureCompatDiRef)(bpmnElement);
            }
        } else logError(translate('no bpmnElement referenced in {element}', {
            element: (0, _util.elementToString)(di)
        }), {
            element: di
        });
    }
    function handleDiagram(diagram) {
        handlePlane(diagram.plane);
    }
    function handlePlane(plane) {
        registerDi(plane);
        (0, _minDash.forEach)(plane.planeElement, handlePlaneElement);
    }
    function handlePlaneElement(planeElement) {
        registerDi(planeElement);
    }
    // Semantic handling //////////////////////
    /**
   * Handle definitions and return the rendered diagram (if any)
   *
   * @param {ModdleElement} definitions to walk and import
   * @param {ModdleElement} [diagram] specific diagram to import and display
   *
   * @throws {Error} if no diagram to display could be found
   */ function handleDefinitions(definitions, diagram) {
        // make sure we walk the correct bpmnElement
        var diagrams = definitions.diagrams;
        if (diagram && diagrams.indexOf(diagram) === -1) throw new Error(translate('diagram not part of bpmn:Definitions'));
        if (!diagram && diagrams && diagrams.length) diagram = diagrams[0];
        // no diagram -> nothing to import
        if (!diagram) throw new Error(translate('no diagram to display'));
        // load DI from selected diagram only
        diMap = {};
        handleDiagram(diagram);
        var plane = diagram.plane;
        if (!plane) throw new Error(translate('no plane for {element}', {
            element: (0, _util.elementToString)(diagram)
        }));
        var rootElement = plane.bpmnElement;
        // ensure we default to a suitable display candidate (process or collaboration),
        // even if non is specified in DI
        if (!rootElement) {
            rootElement = findDisplayCandidate(definitions);
            if (!rootElement) throw new Error(translate('no process or collaboration to display'));
            else {
                logError(translate('correcting missing bpmnElement on {plane} to {rootElement}', {
                    plane: (0, _util.elementToString)(plane),
                    rootElement: (0, _util.elementToString)(rootElement)
                }));
                // correct DI on the fly
                plane.bpmnElement = rootElement;
                registerDi(plane);
            }
        }
        var ctx = visitRoot(rootElement, plane);
        if (is(rootElement, 'bpmn:Process') || is(rootElement, 'bpmn:SubProcess')) handleProcess(rootElement, ctx);
        else if (is(rootElement, 'bpmn:Collaboration')) {
            handleCollaboration(rootElement, ctx);
            // force drawing of everything not yet drawn that is part of the target DI
            handleUnhandledProcesses(definitions.rootElements, ctx);
        } else throw new Error(translate('unsupported bpmnElement for {plane}: {rootElement}', {
            plane: (0, _util.elementToString)(plane),
            rootElement: (0, _util.elementToString)(rootElement)
        }));
        // handle all deferred elements
        handleDeferred(deferred);
    }
    function handleDeferred() {
        var fn;
        // drain deferred until empty
        while(deferred.length){
            fn = deferred.shift();
            fn();
        }
    }
    function handleProcess(process, context) {
        handleFlowElementsContainer(process, context);
        handleIoSpecification(process.ioSpecification, context);
        handleArtifacts(process.artifacts, context);
        // log process handled
        handled(process);
    }
    function handleUnhandledProcesses(rootElements, ctx) {
        // walk through all processes that have not yet been drawn and draw them
        // if they contain lanes with DI information.
        // we do this to pass the free-floating lane test cases in the MIWG test suite
        var processes = (0, _minDash.filter)(rootElements, function(e) {
            return !isHandled(e) && is(e, 'bpmn:Process') && e.laneSets;
        });
        processes.forEach(contextual(handleProcess, ctx));
    }
    function handleMessageFlow(messageFlow, context) {
        visitIfDi(messageFlow, context);
    }
    function handleMessageFlows(messageFlows, context) {
        (0, _minDash.forEach)(messageFlows, contextual(handleMessageFlow, context));
    }
    function handleDataAssociation(association, context) {
        visitIfDi(association, context);
    }
    function handleDataInput(dataInput, context) {
        visitIfDi(dataInput, context);
    }
    function handleDataOutput(dataOutput, context) {
        visitIfDi(dataOutput, context);
    }
    function handleArtifact(artifact, context) {
        // bpmn:TextAnnotation
        // bpmn:Group
        // bpmn:Association
        visitIfDi(artifact, context);
    }
    function handleArtifacts(artifacts, context) {
        (0, _minDash.forEach)(artifacts, function(e) {
            if (is(e, 'bpmn:Association')) deferred.push(function() {
                handleArtifact(e, context);
            });
            else handleArtifact(e, context);
        });
    }
    function handleIoSpecification(ioSpecification, context) {
        if (!ioSpecification) return;
        (0, _minDash.forEach)(ioSpecification.dataInputs, contextual(handleDataInput, context));
        (0, _minDash.forEach)(ioSpecification.dataOutputs, contextual(handleDataOutput, context));
    }
    function handleSubProcess(subProcess, context) {
        handleFlowElementsContainer(subProcess, context);
        handleArtifacts(subProcess.artifacts, context);
    }
    function handleFlowNode(flowNode, context) {
        var childCtx = visitIfDi(flowNode, context);
        if (is(flowNode, 'bpmn:SubProcess')) handleSubProcess(flowNode, childCtx || context);
        if (is(flowNode, 'bpmn:Activity')) handleIoSpecification(flowNode.ioSpecification, context);
        // defer handling of associations
        // affected types:
        //
        //   * bpmn:Activity
        //   * bpmn:ThrowEvent
        //   * bpmn:CatchEvent
        //
        deferred.push(function() {
            (0, _minDash.forEach)(flowNode.dataInputAssociations, contextual(handleDataAssociation, context));
            (0, _minDash.forEach)(flowNode.dataOutputAssociations, contextual(handleDataAssociation, context));
        });
    }
    function handleSequenceFlow(sequenceFlow, context) {
        visitIfDi(sequenceFlow, context);
    }
    function handleDataElement(dataObject, context) {
        visitIfDi(dataObject, context);
    }
    function handleLane(lane, context) {
        deferred.push(function() {
            var newContext = visitIfDi(lane, context);
            if (lane.childLaneSet) handleLaneSet(lane.childLaneSet, newContext || context);
            wireFlowNodeRefs(lane);
        });
    }
    function handleLaneSet(laneSet, context) {
        (0, _minDash.forEach)(laneSet.lanes, contextual(handleLane, context));
    }
    function handleLaneSets(laneSets, context) {
        (0, _minDash.forEach)(laneSets, contextual(handleLaneSet, context));
    }
    function handleFlowElementsContainer(container, context) {
        handleFlowElements(container.flowElements, context);
        if (container.laneSets) handleLaneSets(container.laneSets, context);
    }
    function handleFlowElements(flowElements, context) {
        (0, _minDash.forEach)(flowElements, function(e) {
            if (is(e, 'bpmn:SequenceFlow')) deferred.push(function() {
                handleSequenceFlow(e, context);
            });
            else if (is(e, 'bpmn:BoundaryEvent')) deferred.unshift(function() {
                handleFlowNode(e, context);
            });
            else if (is(e, 'bpmn:FlowNode')) handleFlowNode(e, context);
            else if (is(e, 'bpmn:DataObject')) ;
            else if (is(e, 'bpmn:DataStoreReference')) handleDataElement(e, context);
            else if (is(e, 'bpmn:DataObjectReference')) handleDataElement(e, context);
            else logError(translate('unrecognized flowElement {element} in context {context}', {
                element: (0, _util.elementToString)(e),
                context: context ? (0, _util.elementToString)(context.businessObject) : 'null'
            }), {
                element: e,
                context: context
            });
        });
    }
    function handleParticipant(participant, context) {
        var newCtx = visitIfDi(participant, context);
        var process = participant.processRef;
        if (process) handleProcess(process, newCtx || context);
    }
    function handleCollaboration(collaboration, context) {
        (0, _minDash.forEach)(collaboration.participants, contextual(handleParticipant, context));
        handleArtifacts(collaboration.artifacts, context);
        // handle message flows latest in the process
        deferred.push(function() {
            handleMessageFlows(collaboration.messageFlows, context);
        });
    }
    function wireFlowNodeRefs(lane) {
        // wire the virtual flowNodeRefs <-> relationship
        (0, _minDash.forEach)(lane.flowNodeRef, function(flowNode) {
            var lanes = flowNode.get('lanes');
            if (lanes) lanes.push(lane);
        });
    }
    // API //////////////////////
    return {
        handleDeferred: handleDeferred,
        handleDefinitions: handleDefinitions,
        handleSubProcess: handleSubProcess,
        registerDi: registerDi
    };
}

},{"min-dash":"aEEla","./Util":"emVbk","../util/CompatibilityUtil":"aYHXN","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"emVbk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "elementToString", ()=>elementToString);
function elementToString(e) {
    if (!e) return '<null>';
    return '<' + e.$type + (e.id ? ' id="' + e.id : '') + '" />';
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aYHXN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// TODO(nikku): remove with future bpmn-js version
/**
 * Wraps APIs to check:
 *
 * 1) If a callback is passed -> Warn users about callback deprecation.
 * 2) If Promise class is implemented in current environment.
 *
 * @private
 */ parcelHelpers.export(exports, "wrapForCompatibility", ()=>wrapForCompatibility);
parcelHelpers.export(exports, "ensureCompatDiRef", ()=>ensureCompatDiRef);
var _minDash = require("min-dash");
function wrapForCompatibility(api) {
    return function() {
        if (!window.Promise) throw new Error('Promises is not supported in this environment. Please polyfill Promise.');
        var argLen = arguments.length;
        if (argLen >= 1 && (0, _minDash.isFunction)(arguments[argLen - 1])) {
            var callback = arguments[argLen - 1];
            console.warn(new Error('Passing callbacks to ' + api.name + ' is deprecated and will be removed in a future major release. ' + 'Please switch to promises: https://bpmn.io/l/moving-to-promises.html'));
            var argsWithoutCallback = Array.prototype.slice.call(arguments, 0, -1);
            api.apply(this, argsWithoutCallback).then(function(result) {
                var firstKey = Object.keys(result)[0];
                // The APIs we are wrapping all resolve a single item depending on the API.
                // For instance, importXML resolves { warnings } and saveXML returns { xml }.
                // That's why we can call the callback with the first item of result.
                return callback(null, result[firstKey]);
            // Passing a second paramter instead of catch because we don't want to
            // catch errors thrown by callback().
            }, function(err) {
                return callback(err, err.warnings);
            });
        } else return api.apply(this, arguments);
    };
}
// TODO(nikku): remove with future bpmn-js version
var DI_ERROR_MESSAGE = 'Tried to access di from the businessObject. The di is available through the diagram element only. For more information, see https://github.com/bpmn-io/bpmn-js/issues/1472';
function ensureCompatDiRef(businessObject) {
    // bpmnElement can have multiple independent DIs
    if (!(0, _minDash.has)(businessObject, 'di')) Object.defineProperty(businessObject, 'di', {
        enumerable: false,
        get: function() {
            throw new Error(DI_ERROR_MESSAGE);
        }
    });
}

},{"min-dash":"aEEla","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"klNYN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Is an element of the given BPMN type?
 *
 * @param  {djs.model.Base|ModdleElement} element
 * @param  {string} type
 *
 * @return {boolean}
 */ parcelHelpers.export(exports, "is", ()=>is);
/**
 * Return true if element has any of the given types.
 *
 * @param {djs.model.Base} element
 * @param {Array<string>} types
 *
 * @return {boolean}
 */ parcelHelpers.export(exports, "isAny", ()=>isAny);
/**
 * Return the business object for a given element.
 *
 * @param  {djs.model.Base|ModdleElement} element
 *
 * @return {ModdleElement}
 */ parcelHelpers.export(exports, "getBusinessObject", ()=>getBusinessObject);
/**
 * Return the di object for a given element.
 *
 * @param  {djs.model.Base} element
 *
 * @return {ModdleElement}
 */ parcelHelpers.export(exports, "getDi", ()=>getDi);
var _minDash = require("min-dash");
function is(element, type) {
    var bo = getBusinessObject(element);
    return bo && typeof bo.$instanceOf === 'function' && bo.$instanceOf(type);
}
function isAny(element, types) {
    return (0, _minDash.some)(types, function(t) {
        return is(element, t);
    });
}
function getBusinessObject(element) {
    return element && element.businessObject || element;
}
function getDi(element) {
    return element && element.di;
}

},{"min-dash":"aEEla","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"g89GA":[function(require,module,exports,__globalThis) {
/**
 * This file must not be changed or exchanged.
 *
 * @see http://bpmn.io/license for more information.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BPMNIO_IMG", ()=>BPMNIO_IMG);
parcelHelpers.export(exports, "LOGO_STYLES", ()=>LOGO_STYLES);
parcelHelpers.export(exports, "LINK_STYLES", ()=>LINK_STYLES);
parcelHelpers.export(exports, "open", ()=>open);
var _minDom = require("min-dom");
// inlined ../../resources/logo.svg
var BPMNIO_LOGO_SVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14.02 5.57" width="53" height="21"><path fill="currentColor" d="M1.88.92v.14c0 .41-.13.68-.4.8.33.14.46.44.46.86v.33c0 .61-.33.95-.95.95H0V0h.95c.65 0 .93.3.93.92zM.63.57v1.06h.24c.24 0 .38-.1.38-.43V.98c0-.28-.1-.4-.32-.4zm0 1.63v1.22h.36c.2 0 .32-.1.32-.39v-.35c0-.37-.12-.48-.4-.48H.63zM4.18.99v.52c0 .64-.31.98-.94.98h-.3V4h-.62V0h.92c.63 0 .94.35.94.99zM2.94.57v1.35h.3c.2 0 .3-.09.3-.37v-.6c0-.29-.1-.38-.3-.38h-.3zm2.89 2.27L6.25 0h.88v4h-.6V1.12L6.1 3.99h-.6l-.46-2.82v2.82h-.55V0h.87zM8.14 1.1V4h-.56V0h.79L9 2.4V0h.56v4h-.64zm2.49 2.29v.6h-.6v-.6zM12.12 1c0-.63.33-1 .95-1 .61 0 .95.37.95 1v2.04c0 .64-.34 1-.95 1-.62 0-.95-.37-.95-1zm.62 2.08c0 .28.13.39.33.39s.32-.1.32-.4V.98c0-.29-.12-.4-.32-.4s-.33.11-.33.4z"/><path fill="currentColor" d="M0 4.53h14.02v1.04H0zM11.08 0h.63v.62h-.63zm.63 4V1h-.63v2.98z"/></svg>';
var BPMNIO_IMG = BPMNIO_LOGO_SVG;
var LOGO_STYLES = {
    verticalAlign: 'middle'
};
var LINK_STYLES = {
    'color': '#404040'
};
var LIGHTBOX_STYLES = {
    'zIndex': '1001',
    'position': 'fixed',
    'top': '0',
    'left': '0',
    'right': '0',
    'bottom': '0'
};
var BACKDROP_STYLES = {
    'width': '100%',
    'height': '100%',
    'background': 'rgba(40,40,40,0.2)'
};
var NOTICE_STYLES = {
    'position': 'absolute',
    'left': '50%',
    'top': '40%',
    'transform': 'translate(-50%)',
    'width': '260px',
    'padding': '10px',
    'background': 'white',
    'boxShadow': '0 1px 4px rgba(0,0,0,0.3)',
    'fontFamily': 'Helvetica, Arial, sans-serif',
    'fontSize': '14px',
    'display': 'flex',
    'lineHeight': '1.3'
};
var LIGHTBOX_MARKUP = '<div class="bjs-powered-by-lightbox"><div class="backdrop"></div><div class="notice"><a href="https://bpmn.io" target="_blank" rel="noopener" class="link">' + BPMNIO_IMG + '</a>' + '<span>' + 'Web-based tooling for BPMN, DMN and CMMN diagrams ' + 'powered by <a href="https://bpmn.io" target="_blank" rel="noopener">bpmn.io</a>.' + '</span>' + '</div>' + '</div>';
var lightbox;
function createLightbox() {
    lightbox = (0, _minDom.domify)(LIGHTBOX_MARKUP);
    (0, _minDom.assignStyle)(lightbox, LIGHTBOX_STYLES);
    (0, _minDom.assignStyle)((0, _minDom.query)('svg', lightbox), LOGO_STYLES);
    (0, _minDom.assignStyle)((0, _minDom.query)('.backdrop', lightbox), BACKDROP_STYLES);
    (0, _minDom.assignStyle)((0, _minDom.query)('.notice', lightbox), NOTICE_STYLES);
    (0, _minDom.assignStyle)((0, _minDom.query)('.link', lightbox), LINK_STYLES, {
        'margin': '15px 20px 15px 10px',
        'alignSelf': 'center'
    });
}
function open() {
    if (!lightbox) {
        createLightbox();
        (0, _minDom.delegate).bind(lightbox, '.backdrop', 'click', function(event) {
            document.body.removeChild(lightbox);
        });
    }
    document.body.appendChild(lightbox);
}

},{"min-dom":"e58GC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1SAoE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Viewer);
var _inheritsBrowser = require("inherits-browser");
var _inheritsBrowserDefault = parcelHelpers.interopDefault(_inheritsBrowser);
var _core = require("./core");
var _coreDefault = parcelHelpers.interopDefault(_core);
var _translate = require("diagram-js/lib/i18n/translate");
var _translateDefault = parcelHelpers.interopDefault(_translate);
var _selection = require("diagram-js/lib/features/selection");
var _selectionDefault = parcelHelpers.interopDefault(_selection);
var _overlays = require("diagram-js/lib/features/overlays");
var _overlaysDefault = parcelHelpers.interopDefault(_overlays);
var _drilldown = require("./features/drilldown");
var _drilldownDefault = parcelHelpers.interopDefault(_drilldown);
var _baseViewer = require("./BaseViewer");
var _baseViewerDefault = parcelHelpers.interopDefault(_baseViewer);
function Viewer(options) {
    (0, _baseViewerDefault.default).call(this, options);
}
(0, _inheritsBrowserDefault.default)(Viewer, (0, _baseViewerDefault.default));
// modules the viewer is composed of
Viewer.prototype._modules = [
    (0, _coreDefault.default),
    (0, _translateDefault.default),
    (0, _selectionDefault.default),
    (0, _overlaysDefault.default),
    (0, _drilldownDefault.default)
];
// default moddle extensions the viewer is composed of
Viewer.prototype._moddleExtensions = {};

},{"inherits-browser":"hymxq","./core":"5XDfW","diagram-js/lib/i18n/translate":"lgOY2","diagram-js/lib/features/selection":"8Jf3R","diagram-js/lib/features/overlays":"cLFz9","./features/drilldown":"kXNiS","./BaseViewer":"aauW6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5XDfW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _draw = require("../draw");
var _drawDefault = parcelHelpers.interopDefault(_draw);
var _import = require("../import");
var _importDefault = parcelHelpers.interopDefault(_import);
exports.default = {
    __depends__: [
        (0, _drawDefault.default),
        (0, _importDefault.default)
    ]
};

},{"../draw":"9qrj9","../import":"iYx7I","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9qrj9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _bpmnRenderer = require("./BpmnRenderer");
var _bpmnRendererDefault = parcelHelpers.interopDefault(_bpmnRenderer);
var _textRenderer = require("./TextRenderer");
var _textRendererDefault = parcelHelpers.interopDefault(_textRenderer);
var _pathMap = require("./PathMap");
var _pathMapDefault = parcelHelpers.interopDefault(_pathMap);
exports.default = {
    __init__: [
        'bpmnRenderer'
    ],
    bpmnRenderer: [
        'type',
        (0, _bpmnRendererDefault.default)
    ],
    textRenderer: [
        'type',
        (0, _textRendererDefault.default)
    ],
    pathMap: [
        'type',
        (0, _pathMapDefault.default)
    ]
};

},{"./BpmnRenderer":"ahEbi","./TextRenderer":"4HzWz","./PathMap":"hG0J8","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ahEbi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BpmnRenderer);
var _inheritsBrowser = require("inherits-browser");
var _inheritsBrowserDefault = parcelHelpers.interopDefault(_inheritsBrowser);
var _minDash = require("min-dash");
var _baseRenderer = require("diagram-js/lib/draw/BaseRenderer");
var _baseRendererDefault = parcelHelpers.interopDefault(_baseRenderer);
var _diUtil = require("../util/DiUtil");
var _labelUtil = require("../features/label-editing/LabelUtil");
var _modelUtil = require("../util/ModelUtil");
var _renderUtil = require("diagram-js/lib/util/RenderUtil");
var _bpmnRenderUtil = require("./BpmnRenderUtil");
var _minDom = require("min-dom");
var _tinySvg = require("tiny-svg");
var _svgTransformUtil = require("diagram-js/lib/util/SvgTransformUtil");
var _ids = require("ids");
var _idsDefault = parcelHelpers.interopDefault(_ids);
var RENDERER_IDS = new (0, _idsDefault.default)();
var TASK_BORDER_RADIUS = 10;
var INNER_OUTER_DIST = 3;
var DEFAULT_FILL_OPACITY = .95, HIGH_FILL_OPACITY = .35;
var ELEMENT_LABEL_DISTANCE = 10;
function BpmnRenderer(config, eventBus, styles, pathMap, canvas, textRenderer, priority) {
    (0, _baseRendererDefault.default).call(this, eventBus, priority);
    var defaultFillColor = config && config.defaultFillColor, defaultStrokeColor = config && config.defaultStrokeColor, defaultLabelColor = config && config.defaultLabelColor;
    var rendererId = RENDERER_IDS.next();
    var markers = {};
    function shapeStyle(attrs) {
        return styles.computeStyle(attrs, {
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            stroke: (0, _bpmnRenderUtil.black),
            strokeWidth: 2,
            fill: 'white'
        });
    }
    function lineStyle(attrs) {
        return styles.computeStyle(attrs, [
            'no-fill'
        ], {
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            stroke: (0, _bpmnRenderUtil.black),
            strokeWidth: 2
        });
    }
    function addMarker(id, options) {
        var { ref = {
            x: 0,
            y: 0
        }, scale = 1, element } = options;
        var marker = (0, _tinySvg.create)('marker', {
            id: id,
            viewBox: '0 0 20 20',
            refX: ref.x,
            refY: ref.y,
            markerWidth: 20 * scale,
            markerHeight: 20 * scale,
            orient: 'auto'
        });
        (0, _tinySvg.append)(marker, element);
        var defs = (0, _minDom.query)('defs', canvas._svg);
        if (!defs) {
            defs = (0, _tinySvg.create)('defs');
            (0, _tinySvg.append)(canvas._svg, defs);
        }
        (0, _tinySvg.append)(defs, marker);
        markers[id] = marker;
    }
    function colorEscape(str) {
        // only allow characters and numbers
        return str.replace(/[^0-9a-zA-z]+/g, '_');
    }
    function marker(type, fill, stroke) {
        var id = type + '-' + colorEscape(fill) + '-' + colorEscape(stroke) + '-' + rendererId;
        if (!markers[id]) createMarker(id, type, fill, stroke);
        return 'url(#' + id + ')';
    }
    function createMarker(id, type, fill, stroke) {
        if (type === 'sequenceflow-end') {
            var sequenceflowEnd = (0, _tinySvg.create)('path', {
                d: 'M 1 5 L 11 10 L 1 15 Z',
                ...shapeStyle({
                    fill: stroke,
                    stroke: stroke,
                    strokeWidth: 1
                })
            });
            addMarker(id, {
                element: sequenceflowEnd,
                ref: {
                    x: 11,
                    y: 10
                },
                scale: 0.5
            });
        }
        if (type === 'messageflow-start') {
            var messageflowStart = (0, _tinySvg.create)('circle', {
                cx: 6,
                cy: 6,
                r: 3.5,
                ...shapeStyle({
                    fill: fill,
                    stroke: stroke,
                    strokeWidth: 1,
                    // fix for safari / chrome / firefox bug not correctly
                    // resetting stroke dash array
                    strokeDasharray: [
                        10000,
                        1
                    ]
                })
            });
            addMarker(id, {
                element: messageflowStart,
                ref: {
                    x: 6,
                    y: 6
                }
            });
        }
        if (type === 'messageflow-end') {
            var messageflowEnd = (0, _tinySvg.create)('path', {
                d: 'm 1 5 l 0 -3 l 7 3 l -7 3 z',
                ...shapeStyle({
                    fill: fill,
                    stroke: stroke,
                    strokeWidth: 1,
                    // fix for safari / chrome / firefox bug not correctly
                    // resetting stroke dash array
                    strokeDasharray: [
                        10000,
                        1
                    ]
                })
            });
            addMarker(id, {
                element: messageflowEnd,
                ref: {
                    x: 8.5,
                    y: 5
                }
            });
        }
        if (type === 'association-start') {
            var associationStart = (0, _tinySvg.create)('path', {
                d: 'M 11 5 L 1 10 L 11 15',
                ...lineStyle({
                    fill: 'none',
                    stroke: stroke,
                    strokeWidth: 1.5,
                    // fix for safari / chrome / firefox bug not correctly
                    // resetting stroke dash array
                    strokeDasharray: [
                        10000,
                        1
                    ]
                })
            });
            addMarker(id, {
                element: associationStart,
                ref: {
                    x: 1,
                    y: 10
                },
                scale: 0.5
            });
        }
        if (type === 'association-end') {
            var associationEnd = (0, _tinySvg.create)('path', {
                d: 'M 1 5 L 11 10 L 1 15',
                ...lineStyle({
                    fill: 'none',
                    stroke: stroke,
                    strokeWidth: 1.5,
                    // fix for safari / chrome / firefox bug not correctly
                    // resetting stroke dash array
                    strokeDasharray: [
                        10000,
                        1
                    ]
                })
            });
            addMarker(id, {
                element: associationEnd,
                ref: {
                    x: 11,
                    y: 10
                },
                scale: 0.5
            });
        }
        if (type === 'conditional-flow-marker') {
            var conditionalFlowMarker = (0, _tinySvg.create)('path', {
                d: 'M 0 10 L 8 6 L 16 10 L 8 14 Z',
                ...shapeStyle({
                    fill: fill,
                    stroke: stroke
                })
            });
            addMarker(id, {
                element: conditionalFlowMarker,
                ref: {
                    x: -1,
                    y: 10
                },
                scale: 0.5
            });
        }
        if (type === 'conditional-default-flow-marker') {
            var defaultFlowMarker = (0, _tinySvg.create)('path', {
                d: 'M 6 4 L 10 16',
                ...shapeStyle({
                    stroke: stroke
                })
            });
            addMarker(id, {
                element: defaultFlowMarker,
                ref: {
                    x: 0,
                    y: 10
                },
                scale: 0.5
            });
        }
    }
    function drawCircle(parentGfx, width, height, offset, attrs) {
        if ((0, _minDash.isObject)(offset)) {
            attrs = offset;
            offset = 0;
        }
        offset = offset || 0;
        attrs = shapeStyle(attrs);
        if (attrs.fill === 'none') delete attrs.fillOpacity;
        var cx = width / 2, cy = height / 2;
        var circle = (0, _tinySvg.create)('circle', {
            cx: cx,
            cy: cy,
            r: Math.round((width + height) / 4 - offset),
            ...attrs
        });
        (0, _tinySvg.append)(parentGfx, circle);
        return circle;
    }
    function drawRect(parentGfx, width, height, r, offset, attrs) {
        if ((0, _minDash.isObject)(offset)) {
            attrs = offset;
            offset = 0;
        }
        offset = offset || 0;
        attrs = shapeStyle(attrs);
        var rect = (0, _tinySvg.create)('rect', {
            x: offset,
            y: offset,
            width: width - offset * 2,
            height: height - offset * 2,
            rx: r,
            ry: r,
            ...attrs
        });
        (0, _tinySvg.append)(parentGfx, rect);
        return rect;
    }
    function drawDiamond(parentGfx, width, height, attrs) {
        var x_2 = width / 2;
        var y_2 = height / 2;
        var points = [
            {
                x: x_2,
                y: 0
            },
            {
                x: width,
                y: y_2
            },
            {
                x: x_2,
                y: height
            },
            {
                x: 0,
                y: y_2
            }
        ];
        var pointsString = points.map(function(point) {
            return point.x + ',' + point.y;
        }).join(' ');
        attrs = shapeStyle(attrs);
        var polygon = (0, _tinySvg.create)('polygon', {
            ...attrs,
            points: pointsString
        });
        (0, _tinySvg.append)(parentGfx, polygon);
        return polygon;
    }
    /**
   * @param {SVGElement} parentGfx
   * @param {Point[]} waypoints
   * @param {any} attrs
   * @param {number} [radius]
   *
   * @return {SVGElement}
   */ function drawLine(parentGfx, waypoints, attrs, radius) {
        attrs = lineStyle(attrs);
        var line = (0, _renderUtil.createLine)(waypoints, attrs, radius);
        (0, _tinySvg.append)(parentGfx, line);
        return line;
    }
    /**
   * @param {SVGElement} parentGfx
   * @param {Point[]} waypoints
   * @param {any} attrs
   *
   * @return {SVGElement}
   */ function drawConnectionSegments(parentGfx, waypoints, attrs) {
        return drawLine(parentGfx, waypoints, attrs, 5);
    }
    function drawPath(parentGfx, d, attrs) {
        attrs = lineStyle(attrs);
        var path = (0, _tinySvg.create)('path', {
            ...attrs,
            d
        });
        (0, _tinySvg.append)(parentGfx, path);
        return path;
    }
    function drawMarker(type, parentGfx, path, attrs) {
        return drawPath(parentGfx, path, (0, _minDash.assign)({
            'data-marker': type
        }, attrs));
    }
    function renderer(type) {
        return handlers[type];
    }
    function as(type) {
        return function(parentGfx, element) {
            return renderer(type)(parentGfx, element);
        };
    }
    function renderEventContent(element, parentGfx) {
        var event = (0, _bpmnRenderUtil.getSemantic)(element);
        var isThrowing = (0, _bpmnRenderUtil.isThrowEvent)(event);
        if (event.eventDefinitions && event.eventDefinitions.length > 1) {
            if (event.parallelMultiple) return renderer('bpmn:ParallelMultipleEventDefinition')(parentGfx, element, isThrowing);
            else return renderer('bpmn:MultipleEventDefinition')(parentGfx, element, isThrowing);
        }
        if ((0, _bpmnRenderUtil.isTypedEvent)(event, 'bpmn:MessageEventDefinition')) return renderer('bpmn:MessageEventDefinition')(parentGfx, element, isThrowing);
        if ((0, _bpmnRenderUtil.isTypedEvent)(event, 'bpmn:TimerEventDefinition')) return renderer('bpmn:TimerEventDefinition')(parentGfx, element, isThrowing);
        if ((0, _bpmnRenderUtil.isTypedEvent)(event, 'bpmn:ConditionalEventDefinition')) return renderer('bpmn:ConditionalEventDefinition')(parentGfx, element);
        if ((0, _bpmnRenderUtil.isTypedEvent)(event, 'bpmn:SignalEventDefinition')) return renderer('bpmn:SignalEventDefinition')(parentGfx, element, isThrowing);
        if ((0, _bpmnRenderUtil.isTypedEvent)(event, 'bpmn:EscalationEventDefinition')) return renderer('bpmn:EscalationEventDefinition')(parentGfx, element, isThrowing);
        if ((0, _bpmnRenderUtil.isTypedEvent)(event, 'bpmn:LinkEventDefinition')) return renderer('bpmn:LinkEventDefinition')(parentGfx, element, isThrowing);
        if ((0, _bpmnRenderUtil.isTypedEvent)(event, 'bpmn:ErrorEventDefinition')) return renderer('bpmn:ErrorEventDefinition')(parentGfx, element, isThrowing);
        if ((0, _bpmnRenderUtil.isTypedEvent)(event, 'bpmn:CancelEventDefinition')) return renderer('bpmn:CancelEventDefinition')(parentGfx, element, isThrowing);
        if ((0, _bpmnRenderUtil.isTypedEvent)(event, 'bpmn:CompensateEventDefinition')) return renderer('bpmn:CompensateEventDefinition')(parentGfx, element, isThrowing);
        if ((0, _bpmnRenderUtil.isTypedEvent)(event, 'bpmn:TerminateEventDefinition')) return renderer('bpmn:TerminateEventDefinition')(parentGfx, element, isThrowing);
        return null;
    }
    function renderLabel(parentGfx, label, options) {
        options = (0, _minDash.assign)({
            size: {
                width: 100
            }
        }, options);
        var text = textRenderer.createText(label || '', options);
        (0, _tinySvg.classes)(text).add('djs-label');
        (0, _tinySvg.append)(parentGfx, text);
        return text;
    }
    function renderEmbeddedLabel(parentGfx, element, align) {
        var semantic = (0, _bpmnRenderUtil.getSemantic)(element);
        return renderLabel(parentGfx, semantic.name, {
            box: element,
            align: align,
            padding: 7,
            style: {
                fill: (0, _bpmnRenderUtil.getLabelColor)(element, defaultLabelColor, defaultStrokeColor)
            }
        });
    }
    function renderExternalLabel(parentGfx, element) {
        var box = {
            width: 90,
            height: 30,
            x: element.width / 2 + element.x,
            y: element.height / 2 + element.y
        };
        return renderLabel(parentGfx, (0, _labelUtil.getLabel)(element), {
            box: box,
            fitBox: true,
            style: (0, _minDash.assign)({}, textRenderer.getExternalStyle(), {
                fill: (0, _bpmnRenderUtil.getLabelColor)(element, defaultLabelColor, defaultStrokeColor)
            })
        });
    }
    function renderLaneLabel(parentGfx, text, element) {
        var textBox = renderLabel(parentGfx, text, {
            box: {
                height: 30,
                width: element.height
            },
            align: 'center-middle',
            style: {
                fill: (0, _bpmnRenderUtil.getLabelColor)(element, defaultLabelColor, defaultStrokeColor)
            }
        });
        var top = -1 * element.height;
        (0, _svgTransformUtil.transform)(textBox, 0, -top, 270);
    }
    var handlers = this.handlers = {
        'bpmn:Event': function(parentGfx, element, attrs) {
            if (!('fillOpacity' in attrs)) attrs.fillOpacity = DEFAULT_FILL_OPACITY;
            return drawCircle(parentGfx, element.width, element.height, attrs);
        },
        'bpmn:StartEvent': function(parentGfx, element) {
            var attrs = {
                fill: (0, _bpmnRenderUtil.getFillColor)(element, defaultFillColor),
                stroke: (0, _bpmnRenderUtil.getStrokeColor)(element, defaultStrokeColor)
            };
            var semantic = (0, _bpmnRenderUtil.getSemantic)(element);
            if (!semantic.isInterrupting) attrs = {
                strokeDasharray: '6',
                fill: (0, _bpmnRenderUtil.getFillColor)(element, defaultFillColor),
                stroke: (0, _bpmnRenderUtil.getStrokeColor)(element, defaultStrokeColor)
            };
            var circle = renderer('bpmn:Event')(parentGfx, element, attrs);
            renderEventContent(element, parentGfx);
            return circle;
        },
        'bpmn:MessageEventDefinition': function(parentGfx, element, isThrowing) {
            var pathData = pathMap.getScaledPath('EVENT_MESSAGE', {
                xScaleFactor: 0.9,
                yScaleFactor: 0.9,
                containerWidth: element.width,
                containerHeight: element.height,
                position: {
                    mx: 0.235,
                    my: 0.315
                }
            });
            var fill = isThrowing ? (0, _bpmnRenderUtil.getStrokeColor)(element, defaultStrokeColor) : (0, _bpmnRenderUtil.getFillColor)(element, defaultFillColor);
            var stroke = isThrowing ? (0, _bpmnRenderUtil.getFillColor)(element, defaultFillColor) : (0, _bpmnRenderUtil.getStrokeColor)(element, defaultStrokeColor);
            var messagePath = drawPath(parentGfx, pathData, {
                strokeWidth: 1,
                fill: fill,
                stroke: stroke
            });
            return messagePath;
        },
        'bpmn:TimerEventDefinition': function(parentGfx, element) {
            var circle = drawCircle(parentGfx, element.width, element.height, 0.2 * element.height, {
                strokeWidth: 2,
                fill: (0, _bpmnRenderUtil.getFillColor)(element, defaultFillColor),
                stroke: (0, _bpmnRenderUtil.getStrokeColor)(element, defaultStrokeColor)
            });
            var pathData = pathMap.getScaledPath('EVENT_TIMER_WH', {
                xScaleFactor: 0.75,
                yScaleFactor: 0.75,
                containerWidth: element.width,
                containerHeight: element.height,
                position: {
                    mx: 0.5,
                    my: 0.5
                }
            });
            drawPath(parentGfx, pathData, {
                strokeWidth: 2,
                stroke: (0, _bpmnRenderUtil.getStrokeColor)(element, defaultStrokeColor)
            });
            for(var i = 0; i < 12; i++){
                var linePathData = pathMap.getScaledPath('EVENT_TIMER_LINE', {
                    xScaleFactor: 0.75,
                    yScaleFactor: 0.75,
                    containerWidth: element.width,
                    containerHeight: element.height,
                    position: {
                        mx: 0.5,
                        my: 0.5
                    }
                });
                var width = element.width / 2;
                var height = element.height / 2;
                drawPath(parentGfx, linePathData, {
                    strokeWidth: 1,
                    transform: 'rotate(' + i * 30 + ',' + height + ',' + width + ')',
                    stroke: (0, _bpmnRenderUtil.getStrokeColor)(element, defaultStrokeColor)
                });
            }
            return circle;
        },
        'bpmn:EscalationEventDefinition': function(parentGfx, event, isThrowing) {
            var pathData = pathMap.getScaledPath('EVENT_ESCALATION', {
                xScaleFactor: 1,
                yScaleFactor: 1,
                containerWidth: event.width,
                containerHeight: event.height,
                position: {
                    mx: 0.5,
                    my: 0.2
                }
            });
            var fill = isThrowing ? (0, _bpmnRenderUtil.getStrokeColor)(event, defaultStrokeColor) : 'none';
            return drawPath(parentGfx, pathData, {
                strokeWidth: 1,
                fill: fill,
                stroke: (0, _bpmnRenderUtil.getStrokeColor)(event, defaultStrokeColor)
            });
        },
        'bpmn:ConditionalEventDefinition': function(parentGfx, event) {
            var pathData = pathMap.getScaledPath('EVENT_CONDITIONAL', {
                xScaleFactor: 1,
                yScaleFactor: 1,
                containerWidth: event.width,
                containerHeight: event.height,
                position: {
                    mx: 0.5,
                    my: 0.222
                }
            });
            return drawPath(parentGfx, pathData, {
                strokeWidth: 1,
                stroke: (0, _bpmnRenderUtil.getStrokeColor)(event, defaultStrokeColor)
            });
        },
        'bpmn:LinkEventDefinition': function(parentGfx, event, isThrowing) {
            var pathData = pathMap.getScaledPath('EVENT_LINK', {
                xScaleFactor: 1,
                yScaleFactor: 1,
                containerWidth: event.width,
                containerHeight: event.height,
                position: {
                    mx: 0.57,
                    my: 0.263
                }
            });
            var fill = isThrowing ? (0, _bpmnRenderUtil.getStrokeColor)(event, defaultStrokeColor) : 'none';
            return drawPath(parentGfx, pathData, {
                strokeWidth: 1,
                fill: fill,
                stroke: (0, _bpmnRenderUtil.getStrokeColor)(event, defaultStrokeColor)
            });
        },
        'bpmn:ErrorEventDefinition': function(parentGfx, event, isThrowing) {
            var pathData = pathMap.getScaledPath('EVENT_ERROR', {
                xScaleFactor: 1.1,
                yScaleFactor: 1.1,
                containerWidth: event.width,
                containerHeight: event.height,
                position: {
                    mx: 0.2,
                    my: 0.722
                }
            });
            var fill = isThrowing ? (0, _bpmnRenderUtil.getStrokeColor)(event, defaultStrokeColor) : 'none';
            return drawPath(parentGfx, pathData, {
                strokeWidth: 1,
                fill: fill,
                stroke: (0, _bpmnRenderUtil.getStrokeColor)(event, defaultStrokeColor)
            });
        },
        'bpmn:CancelEventDefinition': function(parentGfx, event, isThrowing) {
            var pathData = pathMap.getScaledPath('EVENT_CANCEL_45', {
                xScaleFactor: 1.0,
                yScaleFactor: 1.0,
                containerWidth: event.width,
                containerHeight: event.height,
                position: {
                    mx: 0.638,
                    my: -0.055
                }
            });
            var fill = isThrowing ? (0, _bpmnRenderUtil.getStrokeColor)(event, defaultStrokeColor) : 'none';
            var path = drawPath(parentGfx, pathData, {
                strokeWidth: 1,
                fill: fill,
                stroke: (0, _bpmnRenderUtil.getStrokeColor)(event, defaultStrokeColor)
            });
            (0, _svgTransformUtil.rotate)(path, 45);
            return path;
        },
        'bpmn:CompensateEventDefinition': function(parentGfx, event, isThrowing) {
            var pathData = pathMap.getScaledPath('EVENT_COMPENSATION', {
                xScaleFactor: 1,
                yScaleFactor: 1,
                containerWidth: event.width,
                containerHeight: event.height,
                position: {
                    mx: 0.22,
                    my: 0.5
                }
            });
            var fill = isThrowing ? (0, _bpmnRenderUtil.getStrokeColor)(event, defaultStrokeColor) : 'none';
            return drawPath(parentGfx, pathData, {
                strokeWidth: 1,
                fill: fill,
                stroke: (0, _bpmnRenderUtil.getStrokeColor)(event, defaultStrokeColor)
            });
        },
        'bpmn:SignalEventDefinition': function(parentGfx, event, isThrowing) {
            var pathData = pathMap.getScaledPath('EVENT_SIGNAL', {
                xScaleFactor: 0.9,
                yScaleFactor: 0.9,
                containerWidth: event.width,
                containerHeight: event.height,
                position: {
                    mx: 0.5,
                    my: 0.2
                }
            });
            var fill = isThrowing ? (0, _bpmnRenderUtil.getStrokeColor)(event, defaultStrokeColor) : 'none';
            return drawPath(parentGfx, pathData, {
                strokeWidth: 1,
                fill: fill,
                stroke: (0, _bpmnRenderUtil.getStrokeColor)(event, defaultStrokeColor)
            });
        },
        'bpmn:MultipleEventDefinition': function(parentGfx, event, isThrowing) {
            var pathData = pathMap.getScaledPath('EVENT_MULTIPLE', {
                xScaleFactor: 1.1,
                yScaleFactor: 1.1,
                containerWidth: event.width,
                containerHeight: event.height,
                position: {
                    mx: 0.222,
                    my: 0.36
                }
            });
            var fill = isThrowing ? (0, _bpmnRenderUtil.getStrokeColor)(event, defaultStrokeColor) : 'none';
            return drawPath(parentGfx, pathData, {
                strokeWidth: 1,
                fill: fill
            });
        },
        'bpmn:ParallelMultipleEventDefinition': function(parentGfx, event) {
            var pathData = pathMap.getScaledPath('EVENT_PARALLEL_MULTIPLE', {
                xScaleFactor: 1.2,
                yScaleFactor: 1.2,
                containerWidth: event.width,
                containerHeight: event.height,
                position: {
                    mx: 0.458,
                    my: 0.194
                }
            });
            return drawPath(parentGfx, pathData, {
                strokeWidth: 1,
                fill: (0, _bpmnRenderUtil.getStrokeColor)(event, defaultStrokeColor),
                stroke: (0, _bpmnRenderUtil.getStrokeColor)(event, defaultStrokeColor)
            });
        },
        'bpmn:EndEvent': function(parentGfx, element) {
            var circle = renderer('bpmn:Event')(parentGfx, element, {
                strokeWidth: 4,
                fill: (0, _bpmnRenderUtil.getFillColor)(element, defaultFillColor),
                stroke: (0, _bpmnRenderUtil.getStrokeColor)(element, defaultStrokeColor)
            });
            renderEventContent(element, parentGfx, true);
            return circle;
        },
        'bpmn:TerminateEventDefinition': function(parentGfx, element) {
            var circle = drawCircle(parentGfx, element.width, element.height, 8, {
                strokeWidth: 4,
                fill: (0, _bpmnRenderUtil.getStrokeColor)(element, defaultStrokeColor),
                stroke: (0, _bpmnRenderUtil.getStrokeColor)(element, defaultStrokeColor)
            });
            return circle;
        },
        'bpmn:IntermediateEvent': function(parentGfx, element) {
            var outer = renderer('bpmn:Event')(parentGfx, element, {
                strokeWidth: 1.5,
                fill: (0, _bpmnRenderUtil.getFillColor)(element, defaultFillColor),
                stroke: (0, _bpmnRenderUtil.getStrokeColor)(element, defaultStrokeColor)
            });
            /* inner */ drawCircle(parentGfx, element.width, element.height, INNER_OUTER_DIST, {
                strokeWidth: 1.5,
                fill: (0, _bpmnRenderUtil.getFillColor)(element, 'none'),
                stroke: (0, _bpmnRenderUtil.getStrokeColor)(element, defaultStrokeColor)
            });
            renderEventContent(element, parentGfx);
            return outer;
        },
        'bpmn:IntermediateCatchEvent': as('bpmn:IntermediateEvent'),
        'bpmn:IntermediateThrowEvent': as('bpmn:IntermediateEvent'),
        'bpmn:Activity': function(parentGfx, element, attrs) {
            attrs = attrs || {};
            if (!('fillOpacity' in attrs)) attrs.fillOpacity = DEFAULT_FILL_OPACITY;
            return drawRect(parentGfx, element.width, element.height, TASK_BORDER_RADIUS, attrs);
        },
        'bpmn:Task': function(parentGfx, element) {
            var attrs = {
                fill: (0, _bpmnRenderUtil.getFillColor)(element, defaultFillColor),
                stroke: (0, _bpmnRenderUtil.getStrokeColor)(element, defaultStrokeColor)
            };
            var rect = renderer('bpmn:Activity')(parentGfx, element, attrs);
            renderEmbeddedLabel(parentGfx, element, 'center-middle');
            attachTaskMarkers(parentGfx, element);
            return rect;
        },
        'bpmn:ServiceTask': function(parentGfx, element) {
            var task = renderer('bpmn:Task')(parentGfx, element);
            var pathDataBG = pathMap.getScaledPath('TASK_TYPE_SERVICE', {
                abspos: {
                    x: 12,
                    y: 18
                }
            });
            /* service bg */ drawPath(parentGfx, pathDataBG, {
                strokeWidth: 1,
                fill: (0, _bpmnRenderUtil.getFillColor)(element, defaultFillColor),
                stroke: (0, _bpmnRenderUtil.getStrokeColor)(element, defaultStrokeColor)
            });
            var fillPathData = pathMap.getScaledPath('TASK_TYPE_SERVICE_FILL', {
                abspos: {
                    x: 17.2,
                    y: 18
                }
            });
            /* service fill */ drawPath(parentGfx, fillPathData, {
                strokeWidth: 0,
                fill: (0, _bpmnRenderUtil.getFillColor)(element, defaultFillColor)
            });
            var pathData = pathMap.getScaledPath('TASK_TYPE_SERVICE', {
                abspos: {
                    x: 17,
                    y: 22
                }
            });
            /* service */ drawPath(parentGfx, pathData, {
                strokeWidth: 1,
                fill: (0, _bpmnRenderUtil.getFillColor)(element, defaultFillColor),
                stroke: (0, _bpmnRenderUtil.getStrokeColor)(element, defaultStrokeColor)
            });
            return task;
        },
        'bpmn:UserTask': function(parentGfx, element) {
            var task = renderer('bpmn:Task')(parentGfx, element);
            var x = 15;
            var y = 12;
            var pathData = pathMap.getScaledPath('TASK_TYPE_USER_1', {
                abspos: {
                    x: x,
                    y: y
                }
            });
            /* user path */ drawPath(parentGfx, pathData, {
                strokeWidth: 0.5,
                fill: (0, _bpmnRenderUtil.getFillColor)(element, defaultFillColor),
                stroke: (0, _bpmnRenderUtil.getStrokeColor)(element, defaultStrokeColor)
            });
            var pathData2 = pathMap.getScaledPath('TASK_TYPE_USER_2', {
                abspos: {
                    x: x,
                    y: y
                }
            });
            /* user2 path */ drawPath(parentGfx, pathData2, {
                strokeWidth: 0.5,
                fill: (0, _bpmnRenderUtil.getFillColor)(element, defaultFillColor),
                stroke: (0, _bpmnRenderUtil.getStrokeColor)(element, defaultStrokeColor)
            });
            var pathData3 = pathMap.getScaledPath('TASK_TYPE_USER_3', {
                abspos: {
                    x: x,
                    y: y
                }
            });
            /* user3 path */ drawPath(parentGfx, pathData3, {
                strokeWidth: 0.5,
                fill: (0, _bpmnRenderUtil.getStrokeColor)(element, defaultStrokeColor),
                stroke: (0, _bpmnRenderUtil.getStrokeColor)(element, defaultStrokeColor)
            });
            return task;
        },
        'bpmn:ManualTask': function(parentGfx, element) {
            var task = renderer('bpmn:Task')(parentGfx, element);
            var pathData = pathMap.getScaledPath('TASK_TYPE_MANUAL', {
                abspos: {
                    x: 17,
                    y: 15
                }
            });
            /* manual path */ drawPath(parentGfx, pathData, {
                strokeWidth: 0.5,
                fill: (0, _bpmnRenderUtil.getFillColor)(element, defaultFillColor),
                stroke: (0, _bpmnRenderUtil.getStrokeColor)(element, defaultStrokeColor)
            });
            return task;
        },
        'bpmn:SendTask': function(parentGfx, element) {
            var task = renderer('bpmn:Task')(parentGfx, element);
            var pathData = pathMap.getScaledPath('TASK_TYPE_SEND', {
                xScaleFactor: 1,
                yScaleFactor: 1,
                containerWidth: 21,
                containerHeight: 14,
                position: {
                    mx: 0.285,
                    my: 0.357
                }
            });
            /* send path */ drawPath(parentGfx, pathData, {
                strokeWidth: 1,
                fill: (0, _bpmnRenderUtil.getStrokeColor)(element, defaultStrokeColor),
                stroke: (0, _bpmnRenderUtil.getFillColor)(element, defaultFillColor)
            });
            return task;
        },
        'bpmn:ReceiveTask': function(parentGfx, element) {
            var semantic = (0, _bpmnRenderUtil.getSemantic)(element);
            var task = renderer('bpmn:Task')(parentGfx, element);
            var pathData;
            if (semantic.instantiate) {
                drawCircle(parentGfx, 28, 28, 4.4, {
                    strokeWidth: 1
                });
                pathData = pathMap.getScaledPath('TASK_TYPE_INSTANTIATING_SEND', {
                    abspos: {
                        x: 7.77,
                        y: 9.52
                    }
                });
            } else pathData = pathMap.getScaledPath('TASK_TYPE_SEND', {
                xScaleFactor: 0.9,
                yScaleFactor: 0.9,
                containerWidth: 21,
                containerHeight: 14,
                position: {
                    mx: 0.3,
                    my: 0.4
                }
            });
            /* receive path */ drawPath(parentGfx, pathData, {
                strokeWidth: 1,
                fill: (0, _bpmnRenderUtil.getFillColor)(element, defaultFillColor),
                stroke: (0, _bpmnRenderUtil.getStrokeColor)(element, defaultStrokeColor)
            });
            return task;
        },
        'bpmn:ScriptTask': function(parentGfx, element) {
            var task = renderer('bpmn:Task')(parentGfx, element);
            var pathData = pathMap.getScaledPath('TASK_TYPE_SCRIPT', {
                abspos: {
                    x: 15,
                    y: 20
                }
            });
            /* script path */ drawPath(parentGfx, pathData, {
                strokeWidth: 1,
                stroke: (0, _bpmnRenderUtil.getStrokeColor)(element, defaultStrokeColor)
            });
            return task;
        },
        'bpmn:BusinessRuleTask': function(parentGfx, element) {
            var task = renderer('bpmn:Task')(parentGfx, element);
            var headerPathData = pathMap.getScaledPath('TASK_TYPE_BUSINESS_RULE_HEADER', {
                abspos: {
                    x: 8,
                    y: 8
                }
            });
            var businessHeaderPath = drawPath(parentGfx, headerPathData);
            (0, _tinySvg.attr)(businessHeaderPath, {
                strokeWidth: 1,
                fill: (0, _bpmnRenderUtil.getFillColor)(element, '#aaaaaa'),
                stroke: (0, _bpmnRenderUtil.getStrokeColor)(element, defaultStrokeColor)
            });
            var headerData = pathMap.getScaledPath('TASK_TYPE_BUSINESS_RULE_MAIN', {
                abspos: {
                    x: 8,
                    y: 8
                }
            });
            var businessPath = drawPath(parentGfx, headerData);
            (0, _tinySvg.attr)(businessPath, {
                strokeWidth: 1,
                stroke: (0, _bpmnRenderUtil.getStrokeColor)(element, defaultStrokeColor)
            });
            return task;
        },
        'bpmn:SubProcess': function(parentGfx, element, attrs) {
            attrs = {
                fill: (0, _bpmnRenderUtil.getFillColor)(element, defaultFillColor),
                stroke: (0, _bpmnRenderUtil.getStrokeColor)(element, defaultStrokeColor),
                ...attrs
            };
            var rect = renderer('bpmn:Activity')(parentGfx, element, attrs);
            var expanded = (0, _diUtil.isExpanded)(element);
            if ((0, _diUtil.isEventSubProcess)(element)) (0, _tinySvg.attr)(rect, {
                strokeDasharray: '0, 5.5',
                strokeWidth: 2.5
            });
            renderEmbeddedLabel(parentGfx, element, expanded ? 'center-top' : 'center-middle');
            if (expanded) attachTaskMarkers(parentGfx, element);
            else attachTaskMarkers(parentGfx, element, [
                'SubProcessMarker'
            ]);
            return rect;
        },
        'bpmn:AdHocSubProcess': function(parentGfx, element) {
            return renderer('bpmn:SubProcess')(parentGfx, element);
        },
        'bpmn:Transaction': function(parentGfx, element) {
            var outer = renderer('bpmn:SubProcess')(parentGfx, element, {
                strokeWidth: 1.5
            });
            var innerAttrs = styles.style([
                'no-fill',
                'no-events'
            ], {
                stroke: (0, _bpmnRenderUtil.getStrokeColor)(element, defaultStrokeColor),
                strokeWidth: 1.5
            });
            /* inner path */ drawRect(parentGfx, element.width, element.height, TASK_BORDER_RADIUS - 3, INNER_OUTER_DIST, innerAttrs);
            return outer;
        },
        'bpmn:CallActivity': function(parentGfx, element) {
            return renderer('bpmn:SubProcess')(parentGfx, element, {
                strokeWidth: 5
            });
        },
        'bpmn:Participant': function(parentGfx, element) {
            var strokeWidth = 1.5;
            var attrs = {
                fillOpacity: DEFAULT_FILL_OPACITY,
                fill: (0, _bpmnRenderUtil.getFillColor)(element, defaultFillColor),
                stroke: (0, _bpmnRenderUtil.getStrokeColor)(element, defaultStrokeColor),
                strokeWidth
            };
            var lane = renderer('bpmn:Lane')(parentGfx, element, attrs);
            var expandedPool = (0, _diUtil.isExpanded)(element);
            if (expandedPool) {
                drawLine(parentGfx, [
                    {
                        x: 30,
                        y: 0
                    },
                    {
                        x: 30,
                        y: element.height
                    }
                ], {
                    stroke: (0, _bpmnRenderUtil.getStrokeColor)(element, defaultStrokeColor),
                    strokeWidth
                });
                var text = (0, _bpmnRenderUtil.getSemantic)(element).name;
                renderLaneLabel(parentGfx, text, element);
            } else {
                // collapsed pool draw text inline
                var text2 = (0, _bpmnRenderUtil.getSemantic)(element).name;
                renderLabel(parentGfx, text2, {
                    box: element,
                    align: 'center-middle',
                    style: {
                        fill: (0, _bpmnRenderUtil.getLabelColor)(element, defaultLabelColor, defaultStrokeColor)
                    }
                });
            }
            var participantMultiplicity = !!(0, _bpmnRenderUtil.getSemantic)(element).participantMultiplicity;
            if (participantMultiplicity) renderer('ParticipantMultiplicityMarker')(parentGfx, element);
            return lane;
        },
        'bpmn:Lane': function(parentGfx, element, attrs) {
            var rect = drawRect(parentGfx, element.width, element.height, 0, {
                fill: (0, _bpmnRenderUtil.getFillColor)(element, defaultFillColor),
                fillOpacity: HIGH_FILL_OPACITY,
                stroke: (0, _bpmnRenderUtil.getStrokeColor)(element, defaultStrokeColor),
                strokeWidth: 1.5,
                ...attrs
            });
            var semantic = (0, _bpmnRenderUtil.getSemantic)(element);
            if (semantic.$type === 'bpmn:Lane') {
                var text = semantic.name;
                renderLaneLabel(parentGfx, text, element);
            }
            return rect;
        },
        'bpmn:InclusiveGateway': function(parentGfx, element) {
            var diamond = renderer('bpmn:Gateway')(parentGfx, element);
            /* circle path */ drawCircle(parentGfx, element.width, element.height, element.height * 0.24, {
                strokeWidth: 2.5,
                fill: (0, _bpmnRenderUtil.getFillColor)(element, defaultFillColor),
                stroke: (0, _bpmnRenderUtil.getStrokeColor)(element, defaultStrokeColor)
            });
            return diamond;
        },
        'bpmn:ExclusiveGateway': function(parentGfx, element) {
            var diamond = renderer('bpmn:Gateway')(parentGfx, element);
            var pathData = pathMap.getScaledPath('GATEWAY_EXCLUSIVE', {
                xScaleFactor: 0.4,
                yScaleFactor: 0.4,
                containerWidth: element.width,
                containerHeight: element.height,
                position: {
                    mx: 0.32,
                    my: 0.3
                }
            });
            if ((0, _bpmnRenderUtil.getDi)(element).isMarkerVisible) drawPath(parentGfx, pathData, {
                strokeWidth: 1,
                fill: (0, _bpmnRenderUtil.getStrokeColor)(element, defaultStrokeColor),
                stroke: (0, _bpmnRenderUtil.getStrokeColor)(element, defaultStrokeColor)
            });
            return diamond;
        },
        'bpmn:ComplexGateway': function(parentGfx, element) {
            var diamond = renderer('bpmn:Gateway')(parentGfx, element);
            var pathData = pathMap.getScaledPath('GATEWAY_COMPLEX', {
                xScaleFactor: 0.5,
                yScaleFactor: 0.5,
                containerWidth: element.width,
                containerHeight: element.height,
                position: {
                    mx: 0.46,
                    my: 0.26
                }
            });
            /* complex path */ drawPath(parentGfx, pathData, {
                strokeWidth: 1,
                fill: (0, _bpmnRenderUtil.getStrokeColor)(element, defaultStrokeColor),
                stroke: (0, _bpmnRenderUtil.getStrokeColor)(element, defaultStrokeColor)
            });
            return diamond;
        },
        'bpmn:ParallelGateway': function(parentGfx, element) {
            var diamond = renderer('bpmn:Gateway')(parentGfx, element);
            var pathData = pathMap.getScaledPath('GATEWAY_PARALLEL', {
                xScaleFactor: 0.6,
                yScaleFactor: 0.6,
                containerWidth: element.width,
                containerHeight: element.height,
                position: {
                    mx: 0.46,
                    my: 0.2
                }
            });
            /* parallel path */ drawPath(parentGfx, pathData, {
                strokeWidth: 1,
                fill: (0, _bpmnRenderUtil.getStrokeColor)(element, defaultStrokeColor),
                stroke: (0, _bpmnRenderUtil.getStrokeColor)(element, defaultStrokeColor)
            });
            return diamond;
        },
        'bpmn:EventBasedGateway': function(parentGfx, element) {
            var semantic = (0, _bpmnRenderUtil.getSemantic)(element);
            var diamond = renderer('bpmn:Gateway')(parentGfx, element);
            /* outer circle path */ drawCircle(parentGfx, element.width, element.height, element.height * 0.20, {
                strokeWidth: 1,
                fill: 'none',
                stroke: (0, _bpmnRenderUtil.getStrokeColor)(element, defaultStrokeColor)
            });
            var type = semantic.eventGatewayType;
            var instantiate = !!semantic.instantiate;
            function drawEvent() {
                var pathData = pathMap.getScaledPath('GATEWAY_EVENT_BASED', {
                    xScaleFactor: 0.18,
                    yScaleFactor: 0.18,
                    containerWidth: element.width,
                    containerHeight: element.height,
                    position: {
                        mx: 0.36,
                        my: 0.44
                    }
                });
                /* event path */ drawPath(parentGfx, pathData, {
                    strokeWidth: 2,
                    fill: (0, _bpmnRenderUtil.getFillColor)(element, 'none'),
                    stroke: (0, _bpmnRenderUtil.getStrokeColor)(element, defaultStrokeColor)
                });
            }
            if (type === 'Parallel') {
                var pathData = pathMap.getScaledPath('GATEWAY_PARALLEL', {
                    xScaleFactor: 0.4,
                    yScaleFactor: 0.4,
                    containerWidth: element.width,
                    containerHeight: element.height,
                    position: {
                        mx: 0.474,
                        my: 0.296
                    }
                });
                drawPath(parentGfx, pathData, {
                    strokeWidth: 1,
                    fill: 'none'
                });
            } else if (type === 'Exclusive') {
                if (!instantiate) drawCircle(parentGfx, element.width, element.height, element.height * 0.26, {
                    strokeWidth: 1,
                    fill: 'none',
                    stroke: (0, _bpmnRenderUtil.getStrokeColor)(element, defaultStrokeColor)
                });
                drawEvent();
            }
            return diamond;
        },
        'bpmn:Gateway': function(parentGfx, element) {
            return drawDiamond(parentGfx, element.width, element.height, {
                fill: (0, _bpmnRenderUtil.getFillColor)(element, defaultFillColor),
                fillOpacity: DEFAULT_FILL_OPACITY,
                stroke: (0, _bpmnRenderUtil.getStrokeColor)(element, defaultStrokeColor)
            });
        },
        'bpmn:SequenceFlow': function(parentGfx, element) {
            var fill = (0, _bpmnRenderUtil.getFillColor)(element, defaultFillColor), stroke = (0, _bpmnRenderUtil.getStrokeColor)(element, defaultStrokeColor);
            var path = drawConnectionSegments(parentGfx, element.waypoints, {
                markerEnd: marker('sequenceflow-end', fill, stroke),
                stroke: (0, _bpmnRenderUtil.getStrokeColor)(element, defaultStrokeColor)
            });
            var sequenceFlow = (0, _bpmnRenderUtil.getSemantic)(element);
            var source;
            if (element.source) {
                source = element.source.businessObject;
                // conditional flow marker
                if (sequenceFlow.conditionExpression && source.$instanceOf('bpmn:Activity')) (0, _tinySvg.attr)(path, {
                    markerStart: marker('conditional-flow-marker', fill, stroke)
                });
                // default marker
                if (source.default && (source.$instanceOf('bpmn:Gateway') || source.$instanceOf('bpmn:Activity')) && source.default === sequenceFlow) (0, _tinySvg.attr)(path, {
                    markerStart: marker('conditional-default-flow-marker', fill, stroke)
                });
            }
            return path;
        },
        'bpmn:Association': function(parentGfx, element, attrs) {
            var semantic = (0, _bpmnRenderUtil.getSemantic)(element);
            var fill = (0, _bpmnRenderUtil.getFillColor)(element, defaultFillColor), stroke = (0, _bpmnRenderUtil.getStrokeColor)(element, defaultStrokeColor);
            attrs = {
                strokeDasharray: '0, 5',
                stroke: (0, _bpmnRenderUtil.getStrokeColor)(element, defaultStrokeColor),
                ...attrs
            };
            if (semantic.associationDirection === 'One' || semantic.associationDirection === 'Both') attrs.markerEnd = marker('association-end', fill, stroke);
            if (semantic.associationDirection === 'Both') attrs.markerStart = marker('association-start', fill, stroke);
            return drawConnectionSegments(parentGfx, element.waypoints, attrs);
        },
        'bpmn:DataInputAssociation': function(parentGfx, element) {
            var fill = (0, _bpmnRenderUtil.getFillColor)(element, defaultFillColor), stroke = (0, _bpmnRenderUtil.getStrokeColor)(element, defaultStrokeColor);
            return renderer('bpmn:Association')(parentGfx, element, {
                markerEnd: marker('association-end', fill, stroke)
            });
        },
        'bpmn:DataOutputAssociation': function(parentGfx, element) {
            var fill = (0, _bpmnRenderUtil.getFillColor)(element, defaultFillColor), stroke = (0, _bpmnRenderUtil.getStrokeColor)(element, defaultStrokeColor);
            return renderer('bpmn:Association')(parentGfx, element, {
                markerEnd: marker('association-end', fill, stroke)
            });
        },
        'bpmn:MessageFlow': function(parentGfx, element) {
            var semantic = (0, _bpmnRenderUtil.getSemantic)(element), di = (0, _bpmnRenderUtil.getDi)(element);
            var fill = (0, _bpmnRenderUtil.getFillColor)(element, defaultFillColor), stroke = (0, _bpmnRenderUtil.getStrokeColor)(element, defaultStrokeColor);
            var path = drawConnectionSegments(parentGfx, element.waypoints, {
                markerEnd: marker('messageflow-end', fill, stroke),
                markerStart: marker('messageflow-start', fill, stroke),
                strokeDasharray: '10, 11',
                strokeWidth: 1.5,
                stroke: (0, _bpmnRenderUtil.getStrokeColor)(element, defaultStrokeColor)
            });
            if (semantic.messageRef) {
                var midPoint = path.getPointAtLength(path.getTotalLength() / 2);
                var markerPathData = pathMap.getScaledPath('MESSAGE_FLOW_MARKER', {
                    abspos: {
                        x: midPoint.x,
                        y: midPoint.y
                    }
                });
                var messageAttrs = {
                    strokeWidth: 1
                };
                if (di.messageVisibleKind === 'initiating') {
                    messageAttrs.fill = 'white';
                    messageAttrs.stroke = (0, _bpmnRenderUtil.black);
                } else {
                    messageAttrs.fill = '#888';
                    messageAttrs.stroke = 'white';
                }
                var message = drawPath(parentGfx, markerPathData, messageAttrs);
                var labelText = semantic.messageRef.name;
                var label = renderLabel(parentGfx, labelText, {
                    align: 'center-top',
                    fitBox: true,
                    style: {
                        fill: (0, _bpmnRenderUtil.getStrokeColor)(element, defaultLabelColor, defaultStrokeColor)
                    }
                });
                var messageBounds = message.getBBox(), labelBounds = label.getBBox();
                var translateX = midPoint.x - labelBounds.width / 2, translateY = midPoint.y + messageBounds.height / 2 + ELEMENT_LABEL_DISTANCE;
                (0, _svgTransformUtil.transform)(label, translateX, translateY, 0);
            }
            return path;
        },
        'bpmn:DataObject': function(parentGfx, element) {
            var pathData = pathMap.getScaledPath('DATA_OBJECT_PATH', {
                xScaleFactor: 1,
                yScaleFactor: 1,
                containerWidth: element.width,
                containerHeight: element.height,
                position: {
                    mx: 0.474,
                    my: 0.296
                }
            });
            var elementObject = drawPath(parentGfx, pathData, {
                fill: (0, _bpmnRenderUtil.getFillColor)(element, defaultFillColor),
                fillOpacity: DEFAULT_FILL_OPACITY,
                stroke: (0, _bpmnRenderUtil.getStrokeColor)(element, defaultStrokeColor)
            });
            var semantic = (0, _bpmnRenderUtil.getSemantic)(element);
            if ((0, _bpmnRenderUtil.isCollection)(semantic)) renderDataItemCollection(parentGfx, element);
            return elementObject;
        },
        'bpmn:DataObjectReference': as('bpmn:DataObject'),
        'bpmn:DataInput': function(parentGfx, element) {
            var arrowPathData = pathMap.getRawPath('DATA_ARROW');
            // page
            var elementObject = renderer('bpmn:DataObject')(parentGfx, element);
            /* input arrow path */ drawPath(parentGfx, arrowPathData, {
                strokeWidth: 1
            });
            return elementObject;
        },
        'bpmn:DataOutput': function(parentGfx, element) {
            var arrowPathData = pathMap.getRawPath('DATA_ARROW');
            // page
            var elementObject = renderer('bpmn:DataObject')(parentGfx, element);
            /* output arrow path */ drawPath(parentGfx, arrowPathData, {
                strokeWidth: 1,
                fill: (0, _bpmnRenderUtil.black)
            });
            return elementObject;
        },
        'bpmn:DataStoreReference': function(parentGfx, element) {
            var DATA_STORE_PATH = pathMap.getScaledPath('DATA_STORE', {
                xScaleFactor: 1,
                yScaleFactor: 1,
                containerWidth: element.width,
                containerHeight: element.height,
                position: {
                    mx: 0,
                    my: 0.133
                }
            });
            var elementStore = drawPath(parentGfx, DATA_STORE_PATH, {
                strokeWidth: 2,
                fill: (0, _bpmnRenderUtil.getFillColor)(element, defaultFillColor),
                fillOpacity: DEFAULT_FILL_OPACITY,
                stroke: (0, _bpmnRenderUtil.getStrokeColor)(element, defaultStrokeColor)
            });
            return elementStore;
        },
        'bpmn:BoundaryEvent': function(parentGfx, element) {
            var semantic = (0, _bpmnRenderUtil.getSemantic)(element), cancel = semantic.cancelActivity;
            var attrs = {
                strokeWidth: 1.5,
                fill: (0, _bpmnRenderUtil.getFillColor)(element, defaultFillColor),
                stroke: (0, _bpmnRenderUtil.getStrokeColor)(element, defaultStrokeColor)
            };
            if (!cancel) attrs.strokeDasharray = '6';
            // apply fillOpacity
            var outerAttrs = {
                ...attrs,
                fillOpacity: 1
            };
            // apply no-fill
            var innerAttrs = {
                ...attrs,
                fill: 'none'
            };
            var outer = renderer('bpmn:Event')(parentGfx, element, outerAttrs);
            /* inner path */ drawCircle(parentGfx, element.width, element.height, INNER_OUTER_DIST, innerAttrs);
            renderEventContent(element, parentGfx);
            return outer;
        },
        'bpmn:Group': function(parentGfx, element) {
            return drawRect(parentGfx, element.width, element.height, TASK_BORDER_RADIUS, {
                stroke: (0, _bpmnRenderUtil.getStrokeColor)(element, defaultStrokeColor),
                strokeWidth: 1.5,
                strokeDasharray: '10,6,0,6',
                fill: 'none',
                pointerEvents: 'none'
            });
        },
        'label': function(parentGfx, element) {
            return renderExternalLabel(parentGfx, element);
        },
        'bpmn:TextAnnotation': function(parentGfx, element) {
            var textElement = drawRect(parentGfx, element.width, element.height, 0, 0, {
                'fill': 'none',
                'stroke': 'none'
            });
            var textPathData = pathMap.getScaledPath('TEXT_ANNOTATION', {
                xScaleFactor: 1,
                yScaleFactor: 1,
                containerWidth: element.width,
                containerHeight: element.height,
                position: {
                    mx: 0.0,
                    my: 0.0
                }
            });
            drawPath(parentGfx, textPathData, {
                stroke: (0, _bpmnRenderUtil.getStrokeColor)(element, defaultStrokeColor)
            });
            var text = (0, _bpmnRenderUtil.getSemantic)(element).text || '';
            renderLabel(parentGfx, text, {
                box: element,
                align: 'left-top',
                padding: 7,
                style: {
                    fill: (0, _bpmnRenderUtil.getLabelColor)(element, defaultLabelColor, defaultStrokeColor)
                }
            });
            return textElement;
        },
        'ParticipantMultiplicityMarker': function(parentGfx, element) {
            var markerPath = pathMap.getScaledPath('MARKER_PARALLEL', {
                xScaleFactor: 1,
                yScaleFactor: 1,
                containerWidth: element.width,
                containerHeight: element.height,
                position: {
                    mx: element.width / 2 / element.width,
                    my: (element.height - 15) / element.height
                }
            });
            drawMarker('participant-multiplicity', parentGfx, markerPath, {
                strokeWidth: 2,
                fill: (0, _bpmnRenderUtil.getFillColor)(element, defaultFillColor),
                stroke: (0, _bpmnRenderUtil.getStrokeColor)(element, defaultStrokeColor)
            });
        },
        'SubProcessMarker': function(parentGfx, element) {
            var markerRect = drawRect(parentGfx, 14, 14, 0, {
                strokeWidth: 1,
                fill: (0, _bpmnRenderUtil.getFillColor)(element, defaultFillColor),
                stroke: (0, _bpmnRenderUtil.getStrokeColor)(element, defaultStrokeColor)
            });
            // Process marker is placed in the middle of the box
            // therefore fixed values can be used here
            (0, _svgTransformUtil.translate)(markerRect, element.width / 2 - 7.5, element.height - 20);
            var markerPath = pathMap.getScaledPath('MARKER_SUB_PROCESS', {
                xScaleFactor: 1.5,
                yScaleFactor: 1.5,
                containerWidth: element.width,
                containerHeight: element.height,
                position: {
                    mx: (element.width / 2 - 7.5) / element.width,
                    my: (element.height - 20) / element.height
                }
            });
            drawMarker('sub-process', parentGfx, markerPath, {
                fill: (0, _bpmnRenderUtil.getFillColor)(element, defaultFillColor),
                stroke: (0, _bpmnRenderUtil.getStrokeColor)(element, defaultStrokeColor)
            });
        },
        'ParallelMarker': function(parentGfx, element, position) {
            var markerPath = pathMap.getScaledPath('MARKER_PARALLEL', {
                xScaleFactor: 1,
                yScaleFactor: 1,
                containerWidth: element.width,
                containerHeight: element.height,
                position: {
                    mx: (element.width / 2 + position.parallel) / element.width,
                    my: (element.height - 20) / element.height
                }
            });
            drawMarker('parallel', parentGfx, markerPath, {
                fill: (0, _bpmnRenderUtil.getFillColor)(element, defaultFillColor),
                stroke: (0, _bpmnRenderUtil.getStrokeColor)(element, defaultStrokeColor)
            });
        },
        'SequentialMarker': function(parentGfx, element, position) {
            var markerPath = pathMap.getScaledPath('MARKER_SEQUENTIAL', {
                xScaleFactor: 1,
                yScaleFactor: 1,
                containerWidth: element.width,
                containerHeight: element.height,
                position: {
                    mx: (element.width / 2 + position.seq) / element.width,
                    my: (element.height - 19) / element.height
                }
            });
            drawMarker('sequential', parentGfx, markerPath, {
                fill: (0, _bpmnRenderUtil.getFillColor)(element, defaultFillColor),
                stroke: (0, _bpmnRenderUtil.getStrokeColor)(element, defaultStrokeColor)
            });
        },
        'CompensationMarker': function(parentGfx, element, position) {
            var markerMath = pathMap.getScaledPath('MARKER_COMPENSATION', {
                xScaleFactor: 1,
                yScaleFactor: 1,
                containerWidth: element.width,
                containerHeight: element.height,
                position: {
                    mx: (element.width / 2 + position.compensation) / element.width,
                    my: (element.height - 13) / element.height
                }
            });
            drawMarker('compensation', parentGfx, markerMath, {
                strokeWidth: 1,
                fill: (0, _bpmnRenderUtil.getFillColor)(element, defaultFillColor),
                stroke: (0, _bpmnRenderUtil.getStrokeColor)(element, defaultStrokeColor)
            });
        },
        'LoopMarker': function(parentGfx, element, position) {
            var markerPath = pathMap.getScaledPath('MARKER_LOOP', {
                xScaleFactor: 1,
                yScaleFactor: 1,
                containerWidth: element.width,
                containerHeight: element.height,
                position: {
                    mx: (element.width / 2 + position.loop) / element.width,
                    my: (element.height - 7) / element.height
                }
            });
            drawMarker('loop', parentGfx, markerPath, {
                strokeWidth: 1.5,
                fill: (0, _bpmnRenderUtil.getFillColor)(element, defaultFillColor),
                stroke: (0, _bpmnRenderUtil.getStrokeColor)(element, defaultStrokeColor),
                strokeMiterlimit: 0.5
            });
        },
        'AdhocMarker': function(parentGfx, element, position) {
            var markerPath = pathMap.getScaledPath('MARKER_ADHOC', {
                xScaleFactor: 1,
                yScaleFactor: 1,
                containerWidth: element.width,
                containerHeight: element.height,
                position: {
                    mx: (element.width / 2 + position.adhoc) / element.width,
                    my: (element.height - 15) / element.height
                }
            });
            drawMarker('adhoc', parentGfx, markerPath, {
                strokeWidth: 1,
                fill: (0, _bpmnRenderUtil.getStrokeColor)(element, defaultStrokeColor),
                stroke: (0, _bpmnRenderUtil.getStrokeColor)(element, defaultStrokeColor)
            });
        }
    };
    function attachTaskMarkers(parentGfx, element, taskMarkers) {
        var obj = (0, _bpmnRenderUtil.getSemantic)(element);
        var subprocess = taskMarkers && taskMarkers.indexOf('SubProcessMarker') !== -1;
        var position;
        if (subprocess) position = {
            seq: -21,
            parallel: -22,
            compensation: -42,
            loop: -18,
            adhoc: 10
        };
        else position = {
            seq: -3,
            parallel: -6,
            compensation: -27,
            loop: 0,
            adhoc: 10
        };
        (0, _minDash.forEach)(taskMarkers, function(marker) {
            renderer(marker)(parentGfx, element, position);
        });
        if (obj.isForCompensation) renderer('CompensationMarker')(parentGfx, element, position);
        if (obj.$type === 'bpmn:AdHocSubProcess') renderer('AdhocMarker')(parentGfx, element, position);
        var loopCharacteristics = obj.loopCharacteristics, isSequential = loopCharacteristics && loopCharacteristics.isSequential;
        if (loopCharacteristics) {
            if (isSequential === undefined) renderer('LoopMarker')(parentGfx, element, position);
            if (isSequential === false) renderer('ParallelMarker')(parentGfx, element, position);
            if (isSequential === true) renderer('SequentialMarker')(parentGfx, element, position);
        }
    }
    function renderDataItemCollection(parentGfx, element) {
        var yPosition = (element.height - 18) / element.height;
        var pathData = pathMap.getScaledPath('DATA_OBJECT_COLLECTION_PATH', {
            xScaleFactor: 1,
            yScaleFactor: 1,
            containerWidth: element.width,
            containerHeight: element.height,
            position: {
                mx: 0.33,
                my: yPosition
            }
        });
        /* collection path */ drawPath(parentGfx, pathData, {
            strokeWidth: 2
        });
    }
    // extension API, use at your own risk
    this._drawPath = drawPath;
    this._renderer = renderer;
}
(0, _inheritsBrowserDefault.default)(BpmnRenderer, (0, _baseRendererDefault.default));
BpmnRenderer.$inject = [
    'config.bpmnRenderer',
    'eventBus',
    'styles',
    'pathMap',
    'canvas',
    'textRenderer'
];
BpmnRenderer.prototype.canRender = function(element) {
    return (0, _modelUtil.is)(element, 'bpmn:BaseElement');
};
BpmnRenderer.prototype.drawShape = function(parentGfx, element) {
    var type = element.type;
    var h = this._renderer(type);
    /* jshint -W040 */ return h(parentGfx, element);
};
BpmnRenderer.prototype.drawConnection = function(parentGfx, element) {
    var type = element.type;
    var h = this._renderer(type);
    /* jshint -W040 */ return h(parentGfx, element);
};
BpmnRenderer.prototype.getShapePath = function(element) {
    if ((0, _modelUtil.is)(element, 'bpmn:Event')) return (0, _bpmnRenderUtil.getCirclePath)(element);
    if ((0, _modelUtil.is)(element, 'bpmn:Activity')) return (0, _bpmnRenderUtil.getRoundRectPath)(element, TASK_BORDER_RADIUS);
    if ((0, _modelUtil.is)(element, 'bpmn:Gateway')) return (0, _bpmnRenderUtil.getDiamondPath)(element);
    return (0, _bpmnRenderUtil.getRectPath)(element);
};

},{"inherits-browser":"hymxq","min-dash":"aEEla","diagram-js/lib/draw/BaseRenderer":"3CPtk","../util/DiUtil":"krDFz","../features/label-editing/LabelUtil":"gHqpR","../util/ModelUtil":"klNYN","diagram-js/lib/util/RenderUtil":"iDpuc","./BpmnRenderUtil":"iaOai","min-dom":"e58GC","tiny-svg":"6ZtXA","diagram-js/lib/util/SvgTransformUtil":"g4Nbc","ids":"1I7q6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"krDFz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isExpanded", ()=>isExpanded);
parcelHelpers.export(exports, "isInterrupting", ()=>isInterrupting);
parcelHelpers.export(exports, "isEventSubProcess", ()=>isEventSubProcess);
parcelHelpers.export(exports, "hasEventDefinition", ()=>hasEventDefinition);
parcelHelpers.export(exports, "hasErrorEventDefinition", ()=>hasErrorEventDefinition);
parcelHelpers.export(exports, "hasEscalationEventDefinition", ()=>hasEscalationEventDefinition);
parcelHelpers.export(exports, "hasCompensateEventDefinition", ()=>hasCompensateEventDefinition);
var _modelUtil = require("./ModelUtil");
var _minDash = require("min-dash");
function isExpanded(element, di) {
    if ((0, _modelUtil.is)(element, 'bpmn:CallActivity')) return false;
    if ((0, _modelUtil.is)(element, 'bpmn:SubProcess')) {
        di = di || (0, _modelUtil.getDi)(element);
        if (di && (0, _modelUtil.is)(di, 'bpmndi:BPMNPlane')) return true;
        return di && !!di.isExpanded;
    }
    if ((0, _modelUtil.is)(element, 'bpmn:Participant')) return !!(0, _modelUtil.getBusinessObject)(element).processRef;
    return true;
}
function isInterrupting(element) {
    return element && (0, _modelUtil.getBusinessObject)(element).isInterrupting !== false;
}
function isEventSubProcess(element) {
    return element && !!(0, _modelUtil.getBusinessObject)(element).triggeredByEvent;
}
function hasEventDefinition(element, eventType) {
    var bo = (0, _modelUtil.getBusinessObject)(element), hasEventDefinition = false;
    if (bo.eventDefinitions) (0, _minDash.forEach)(bo.eventDefinitions, function(event) {
        if ((0, _modelUtil.is)(event, eventType)) hasEventDefinition = true;
    });
    return hasEventDefinition;
}
function hasErrorEventDefinition(element) {
    return hasEventDefinition(element, 'bpmn:ErrorEventDefinition');
}
function hasEscalationEventDefinition(element) {
    return hasEventDefinition(element, 'bpmn:EscalationEventDefinition');
}
function hasCompensateEventDefinition(element) {
    return hasEventDefinition(element, 'bpmn:CompensateEventDefinition');
}

},{"./ModelUtil":"klNYN","min-dash":"aEEla","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gHqpR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getLabel", ()=>getLabel);
parcelHelpers.export(exports, "setLabel", ()=>setLabel);
var _modelUtil = require("../../util/ModelUtil");
function getLabelAttr(semantic) {
    if ((0, _modelUtil.is)(semantic, 'bpmn:FlowElement') || (0, _modelUtil.is)(semantic, 'bpmn:Participant') || (0, _modelUtil.is)(semantic, 'bpmn:Lane') || (0, _modelUtil.is)(semantic, 'bpmn:SequenceFlow') || (0, _modelUtil.is)(semantic, 'bpmn:MessageFlow') || (0, _modelUtil.is)(semantic, 'bpmn:DataInput') || (0, _modelUtil.is)(semantic, 'bpmn:DataOutput')) return 'name';
    if ((0, _modelUtil.is)(semantic, 'bpmn:TextAnnotation')) return 'text';
    if ((0, _modelUtil.is)(semantic, 'bpmn:Group')) return 'categoryValueRef';
}
function getCategoryValue(semantic) {
    var categoryValueRef = semantic['categoryValueRef'];
    if (!categoryValueRef) return '';
    return categoryValueRef.value || '';
}
function getLabel(element) {
    var semantic = element.businessObject, attr = getLabelAttr(semantic);
    if (attr) {
        if (attr === 'categoryValueRef') return getCategoryValue(semantic);
        return semantic[attr] || '';
    }
}
function setLabel(element, text, isExternal) {
    var semantic = element.businessObject, attr = getLabelAttr(semantic);
    if (attr) {
        if (attr === 'categoryValueRef') semantic['categoryValueRef'].value = text;
        else semantic[attr] = text;
    }
    return element;
}

},{"../../util/ModelUtil":"klNYN","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iaOai":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// re-export getDi for compatibility
parcelHelpers.export(exports, "getDi", ()=>(0, _modelUtil.getDi));
parcelHelpers.export(exports, "black", ()=>black);
// element utils //////////////////////
/**
 * Checks if eventDefinition of the given element matches with semantic type.
 *
 * @return {boolean} true if element is of the given semantic type
 */ parcelHelpers.export(exports, "isTypedEvent", ()=>isTypedEvent);
parcelHelpers.export(exports, "isThrowEvent", ()=>isThrowEvent);
parcelHelpers.export(exports, "isCollection", ()=>isCollection);
parcelHelpers.export(exports, "getSemantic", ()=>getSemantic);
// color access //////////////////////
parcelHelpers.export(exports, "getFillColor", ()=>getFillColor);
parcelHelpers.export(exports, "getStrokeColor", ()=>getStrokeColor);
parcelHelpers.export(exports, "getLabelColor", ()=>getLabelColor);
// cropping path customizations //////////////////////
parcelHelpers.export(exports, "getCirclePath", ()=>getCirclePath);
parcelHelpers.export(exports, "getRoundRectPath", ()=>getRoundRectPath);
parcelHelpers.export(exports, "getDiamondPath", ()=>getDiamondPath);
parcelHelpers.export(exports, "getRectPath", ()=>getRectPath);
var _minDash = require("min-dash");
var _modelUtil = require("../util/ModelUtil");
var _renderUtil = require("diagram-js/lib/util/RenderUtil");
var black = 'hsl(225, 10%, 15%)';
function isTypedEvent(event, eventDefinitionType, filter) {
    function matches(definition, filter) {
        return (0, _minDash.every)(filter, function(val, key) {
            // we want a == conversion here, to be able to catch
            // undefined == false and friends
            /* jshint -W116 */ return definition[key] == val;
        });
    }
    return (0, _minDash.some)(event.eventDefinitions, function(definition) {
        return definition.$type === eventDefinitionType && matches(event, filter);
    });
}
function isThrowEvent(event) {
    return event.$type === 'bpmn:IntermediateThrowEvent' || event.$type === 'bpmn:EndEvent';
}
function isCollection(element) {
    var dataObject = element.dataObjectRef;
    return element.isCollection || dataObject && dataObject.isCollection;
}
function getSemantic(element) {
    return element.businessObject;
}
function getFillColor(element, defaultColor) {
    var di = (0, _modelUtil.getDi)(element);
    return di.get('color:background-color') || di.get('bioc:fill') || defaultColor || 'white';
}
function getStrokeColor(element, defaultColor) {
    var di = (0, _modelUtil.getDi)(element);
    return di.get('color:border-color') || di.get('bioc:stroke') || defaultColor || black;
}
function getLabelColor(element, defaultColor, defaultStrokeColor) {
    var di = (0, _modelUtil.getDi)(element), label = di.get('label');
    return label && label.get('color:color') || defaultColor || getStrokeColor(element, defaultStrokeColor);
}
function getCirclePath(shape) {
    var cx = shape.x + shape.width / 2, cy = shape.y + shape.height / 2, radius = shape.width / 2;
    var circlePath = [
        [
            'M',
            cx,
            cy
        ],
        [
            'm',
            0,
            -radius
        ],
        [
            'a',
            radius,
            radius,
            0,
            1,
            1,
            0,
            2 * radius
        ],
        [
            'a',
            radius,
            radius,
            0,
            1,
            1,
            0,
            -2 * radius
        ],
        [
            'z'
        ]
    ];
    return (0, _renderUtil.componentsToPath)(circlePath);
}
function getRoundRectPath(shape, borderRadius) {
    var x = shape.x, y = shape.y, width = shape.width, height = shape.height;
    var roundRectPath = [
        [
            'M',
            x + borderRadius,
            y
        ],
        [
            'l',
            width - borderRadius * 2,
            0
        ],
        [
            'a',
            borderRadius,
            borderRadius,
            0,
            0,
            1,
            borderRadius,
            borderRadius
        ],
        [
            'l',
            0,
            height - borderRadius * 2
        ],
        [
            'a',
            borderRadius,
            borderRadius,
            0,
            0,
            1,
            -borderRadius,
            borderRadius
        ],
        [
            'l',
            borderRadius * 2 - width,
            0
        ],
        [
            'a',
            borderRadius,
            borderRadius,
            0,
            0,
            1,
            -borderRadius,
            -borderRadius
        ],
        [
            'l',
            0,
            borderRadius * 2 - height
        ],
        [
            'a',
            borderRadius,
            borderRadius,
            0,
            0,
            1,
            borderRadius,
            -borderRadius
        ],
        [
            'z'
        ]
    ];
    return (0, _renderUtil.componentsToPath)(roundRectPath);
}
function getDiamondPath(shape) {
    var width = shape.width, height = shape.height, x = shape.x, y = shape.y, halfWidth = width / 2, halfHeight = height / 2;
    var diamondPath = [
        [
            'M',
            x + halfWidth,
            y
        ],
        [
            'l',
            halfWidth,
            halfHeight
        ],
        [
            'l',
            -halfWidth,
            halfHeight
        ],
        [
            'l',
            -halfWidth,
            -halfHeight
        ],
        [
            'z'
        ]
    ];
    return (0, _renderUtil.componentsToPath)(diamondPath);
}
function getRectPath(shape) {
    var x = shape.x, y = shape.y, width = shape.width, height = shape.height;
    var rectPath = [
        [
            'M',
            x,
            y
        ],
        [
            'l',
            width,
            0
        ],
        [
            'l',
            0,
            height
        ],
        [
            'l',
            -width,
            0
        ],
        [
            'z'
        ]
    ];
    return (0, _renderUtil.componentsToPath)(rectPath);
}

},{"min-dash":"aEEla","../util/ModelUtil":"klNYN","diagram-js/lib/util/RenderUtil":"iDpuc","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4HzWz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>TextRenderer);
var _minDash = require("min-dash");
var _text = require("diagram-js/lib/util/Text");
var _textDefault = parcelHelpers.interopDefault(_text);
var DEFAULT_FONT_SIZE = 12;
var LINE_HEIGHT_RATIO = 1.2;
var MIN_TEXT_ANNOTATION_HEIGHT = 30;
function TextRenderer(config) {
    var defaultStyle = (0, _minDash.assign)({
        fontFamily: 'Arial, sans-serif',
        fontSize: DEFAULT_FONT_SIZE,
        fontWeight: 'normal',
        lineHeight: LINE_HEIGHT_RATIO
    }, config && config.defaultStyle || {});
    var fontSize = parseInt(defaultStyle.fontSize, 10) - 1;
    var externalStyle = (0, _minDash.assign)({}, defaultStyle, {
        fontSize: fontSize
    }, config && config.externalStyle || {});
    var textUtil = new (0, _textDefault.default)({
        style: defaultStyle
    });
    /**
   * Get the new bounds of an externally rendered,
   * layouted label.
   *
   * @param  {Bounds} bounds
   * @param  {string} text
   *
   * @return {Bounds}
   */ this.getExternalLabelBounds = function(bounds, text) {
        var layoutedDimensions = textUtil.getDimensions(text, {
            box: {
                width: 90,
                height: 30,
                x: bounds.width / 2 + bounds.x,
                y: bounds.height / 2 + bounds.y
            },
            style: externalStyle
        });
        // resize label shape to fit label text
        return {
            x: Math.round(bounds.x + bounds.width / 2 - layoutedDimensions.width / 2),
            y: Math.round(bounds.y),
            width: Math.ceil(layoutedDimensions.width),
            height: Math.ceil(layoutedDimensions.height)
        };
    };
    /**
   * Get the new bounds of text annotation.
   *
   * @param  {Bounds} bounds
   * @param  {string} text
   *
   * @return {Bounds}
   */ this.getTextAnnotationBounds = function(bounds, text) {
        var layoutedDimensions = textUtil.getDimensions(text, {
            box: bounds,
            style: defaultStyle,
            align: 'left-top',
            padding: 5
        });
        return {
            x: bounds.x,
            y: bounds.y,
            width: bounds.width,
            height: Math.max(MIN_TEXT_ANNOTATION_HEIGHT, Math.round(layoutedDimensions.height))
        };
    };
    /**
   * Create a layouted text element.
   *
   * @param {string} text
   * @param {Object} [options]
   *
   * @return {SVGElement} rendered text
   */ this.createText = function(text, options) {
        return textUtil.createText(text, options || {});
    };
    /**
   * Get default text style.
   */ this.getDefaultStyle = function() {
        return defaultStyle;
    };
    /**
   * Get the external text style.
   */ this.getExternalStyle = function() {
        return externalStyle;
    };
}
TextRenderer.$inject = [
    'config.textRenderer'
];

},{"min-dash":"aEEla","diagram-js/lib/util/Text":"4RE3b","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4RE3b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Text);
var _minDash = require("min-dash");
var _tinySvg = require("tiny-svg");
var _minDom = require("min-dom");
/**
 * @typedef {import('../util/Types').Dimensions} Dimensions
 */ var DEFAULT_BOX_PADDING = 0;
var DEFAULT_LABEL_SIZE = {
    width: 150,
    height: 50
};
function parseAlign(align) {
    var parts = align.split('-');
    return {
        horizontal: parts[0] || 'center',
        vertical: parts[1] || 'top'
    };
}
function parsePadding(padding) {
    if ((0, _minDash.isObject)(padding)) return (0, _minDash.assign)({
        top: 0,
        left: 0,
        right: 0,
        bottom: 0
    }, padding);
    else return {
        top: padding,
        left: padding,
        right: padding,
        bottom: padding
    };
}
function getTextBBox(text, fakeText) {
    fakeText.textContent = text;
    var textBBox;
    try {
        var bbox, emptyLine = text === '';
        // add dummy text, when line is empty to
        // determine correct height
        fakeText.textContent = emptyLine ? 'dummy' : text;
        textBBox = fakeText.getBBox();
        // take text rendering related horizontal
        // padding into account
        bbox = {
            width: textBBox.width + textBBox.x * 2,
            height: textBBox.height
        };
        if (emptyLine) // correct width
        bbox.width = 0;
        return bbox;
    } catch (e) {
        return {
            width: 0,
            height: 0
        };
    }
}
/**
 * Layout the next line and return the layouted element.
 *
 * Alters the lines passed.
 *
 * @param {string[]} lines
 *
 * @return {Object} the line descriptor, an object { width, height, text }
 */ function layoutNext(lines, maxWidth, fakeText) {
    var originalLine = lines.shift(), fitLine = originalLine;
    var textBBox;
    for(;;){
        textBBox = getTextBBox(fitLine, fakeText);
        textBBox.width = fitLine ? textBBox.width : 0;
        // try to fit
        if (fitLine === ' ' || fitLine === '' || textBBox.width < Math.round(maxWidth) || fitLine.length < 2) return fit(lines, fitLine, originalLine, textBBox);
        fitLine = shortenLine(fitLine, textBBox.width, maxWidth);
    }
}
function fit(lines, fitLine, originalLine, textBBox) {
    if (fitLine.length < originalLine.length) {
        var remainder = originalLine.slice(fitLine.length).trim();
        lines.unshift(remainder);
    }
    return {
        width: textBBox.width,
        height: textBBox.height,
        text: fitLine
    };
}
var SOFT_BREAK = '\u00AD';
/**
 * Shortens a line based on spacing and hyphens.
 * Returns the shortened result on success.
 *
 * @param {string} line
 * @param {number} maxLength the maximum characters of the string
 *
 * @return {string} the shortened string
 */ function semanticShorten(line, maxLength) {
    var parts = line.split(/(\s|-|\u00AD)/g), part, shortenedParts = [], length = 0;
    // try to shorten via break chars
    if (parts.length > 1) {
        while(part = parts.shift())if (part.length + length < maxLength) {
            shortenedParts.push(part);
            length += part.length;
        } else {
            // remove previous part, too if hyphen does not fit anymore
            if (part === '-' || part === SOFT_BREAK) shortenedParts.pop();
            break;
        }
    }
    var last = shortenedParts[shortenedParts.length - 1];
    // translate trailing soft break to actual hyphen
    if (last && last === SOFT_BREAK) shortenedParts[shortenedParts.length - 1] = '-';
    return shortenedParts.join('');
}
function shortenLine(line, width, maxWidth) {
    var length = Math.max(line.length * (maxWidth / width), 1);
    // try to shorten semantically (i.e. based on spaces and hyphens)
    var shortenedLine = semanticShorten(line, length);
    if (!shortenedLine) // force shorten by cutting the long word
    shortenedLine = line.slice(0, Math.max(Math.round(length - 1), 1));
    return shortenedLine;
}
function getHelperSvg() {
    var helperSvg = document.getElementById('helper-svg');
    if (!helperSvg) {
        helperSvg = (0, _tinySvg.create)('svg');
        (0, _tinySvg.attr)(helperSvg, {
            id: 'helper-svg'
        });
        (0, _minDom.assignStyle)(helperSvg, {
            visibility: 'hidden',
            position: 'fixed',
            width: 0,
            height: 0
        });
        document.body.appendChild(helperSvg);
    }
    return helperSvg;
}
function Text(config) {
    this._config = (0, _minDash.assign)({}, {
        size: DEFAULT_LABEL_SIZE,
        padding: DEFAULT_BOX_PADDING,
        style: {},
        align: 'center-top'
    }, config || {});
}
/**
 * Returns the layouted text as an SVG element.
 *
 * @param {string} text
 * @param {Object} options
 *
 * @return {SVGElement}
 */ Text.prototype.createText = function(text, options) {
    return this.layoutText(text, options).element;
};
/**
 * Returns a labels layouted dimensions.
 *
 * @param {string} text to layout
 * @param {Object} options
 *
 * @return {Dimensions}
 */ Text.prototype.getDimensions = function(text, options) {
    return this.layoutText(text, options).dimensions;
};
/**
 * Creates and returns a label and its bounding box.
 *
 * @method Text#createText
 *
 * @param {string} text the text to render on the label
 * @param {Object} options
 * @param {string} options.align how to align in the bounding box.
 *                               Any of { 'center-middle', 'center-top' },
 *                               defaults to 'center-top'.
 * @param {string} options.style style to be applied to the text
 * @param {boolean} options.fitBox indicates if box will be recalculated to
 *                                 fit text
 *
 * @return {Object} { element, dimensions }
 */ Text.prototype.layoutText = function(text, options) {
    var box = (0, _minDash.assign)({}, this._config.size, options.box), style = (0, _minDash.assign)({}, this._config.style, options.style), align = parseAlign(options.align || this._config.align), padding = parsePadding(options.padding !== undefined ? options.padding : this._config.padding), fitBox = options.fitBox || false;
    var lineHeight = getLineHeight(style);
    // we split text by lines and normalize
    // {soft break} + {line break} => { line break }
    var lines = text.split(/\u00AD?\r?\n/), layouted = [];
    var maxWidth = box.width - padding.left - padding.right;
    // ensure correct rendering by attaching helper text node to invisible SVG
    var helperText = (0, _tinySvg.create)('text');
    (0, _tinySvg.attr)(helperText, {
        x: 0,
        y: 0
    });
    (0, _tinySvg.attr)(helperText, style);
    var helperSvg = getHelperSvg();
    (0, _tinySvg.append)(helperSvg, helperText);
    while(lines.length)layouted.push(layoutNext(lines, maxWidth, helperText));
    if (align.vertical === 'middle') padding.top = padding.bottom = 0;
    var totalHeight = (0, _minDash.reduce)(layouted, function(sum, line, idx) {
        return sum + (lineHeight || line.height);
    }, 0) + padding.top + padding.bottom;
    var maxLineWidth = (0, _minDash.reduce)(layouted, function(sum, line, idx) {
        return line.width > sum ? line.width : sum;
    }, 0);
    // the y position of the next line
    var y = padding.top;
    if (align.vertical === 'middle') y += (box.height - totalHeight) / 2;
    // magic number initial offset
    y -= (lineHeight || layouted[0].height) / 4;
    var textElement = (0, _tinySvg.create)('text');
    (0, _tinySvg.attr)(textElement, style);
    // layout each line taking into account that parent
    // shape might resize to fit text size
    (0, _minDash.forEach)(layouted, function(line) {
        var x;
        y += lineHeight || line.height;
        switch(align.horizontal){
            case 'left':
                x = padding.left;
                break;
            case 'right':
                x = (fitBox ? maxLineWidth : maxWidth) - padding.right - line.width;
                break;
            default:
                // aka center
                x = Math.max(((fitBox ? maxLineWidth : maxWidth) - line.width) / 2 + padding.left, 0);
        }
        var tspan = (0, _tinySvg.create)('tspan');
        (0, _tinySvg.attr)(tspan, {
            x: x,
            y: y
        });
        tspan.textContent = line.text;
        (0, _tinySvg.append)(textElement, tspan);
    });
    (0, _tinySvg.remove)(helperText);
    var dimensions = {
        width: maxLineWidth,
        height: totalHeight
    };
    return {
        dimensions: dimensions,
        element: textElement
    };
};
function getLineHeight(style) {
    if ('fontSize' in style && 'lineHeight' in style) return style.lineHeight * parseInt(style.fontSize, 10);
}

},{"min-dash":"aEEla","tiny-svg":"6ZtXA","min-dom":"e58GC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hG0J8":[function(require,module,exports,__globalThis) {
/**
 * Map containing SVG paths needed by BpmnRenderer.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PathMap);
function PathMap() {
    /**
   * Contains a map of path elements
   *
   * <h1>Path definition</h1>
   * A parameterized path is defined like this:
   * <pre>
   * 'GATEWAY_PARALLEL': {
   *   d: 'm {mx},{my} {e.x0},0 0,{e.x1} {e.x1},0 0,{e.y0} -{e.x1},0 0,{e.y1} ' +
          '-{e.x0},0 0,-{e.y1} -{e.x1},0 0,-{e.y0} {e.x1},0 z',
   *   height: 17.5,
   *   width:  17.5,
   *   heightElements: [2.5, 7.5],
   *   widthElements: [2.5, 7.5]
   * }
   * </pre>
   * <p>It's important to specify a correct <b>height and width</b> for the path as the scaling
   * is based on the ratio between the specified height and width in this object and the
   * height and width that is set as scale target (Note x,y coordinates will be scaled with
   * individual ratios).</p>
   * <p>The '<b>heightElements</b>' and '<b>widthElements</b>' array must contain the values that will be scaled.
   * The scaling is based on the computed ratios.
   * Coordinates on the y axis should be in the <b>heightElement</b>'s array, they will be scaled using
   * the computed ratio coefficient.
   * In the parameterized path the scaled values can be accessed through the 'e' object in {} brackets.
   *   <ul>
   *    <li>The values for the y axis can be accessed in the path string using {e.y0}, {e.y1}, ....</li>
   *    <li>The values for the x axis can be accessed in the path string using {e.x0}, {e.x1}, ....</li>
   *   </ul>
   *   The numbers x0, x1 respectively y0, y1, ... map to the corresponding array index.
   * </p>
   */ this.pathMap = {
        'EVENT_MESSAGE': {
            d: 'm {mx},{my} l 0,{e.y1} l {e.x1},0 l 0,-{e.y1} z l {e.x0},{e.y0} l {e.x0},-{e.y0}',
            height: 36,
            width: 36,
            heightElements: [
                6,
                14
            ],
            widthElements: [
                10.5,
                21
            ]
        },
        'EVENT_SIGNAL': {
            d: 'M {mx},{my} l {e.x0},{e.y0} l -{e.x1},0 Z',
            height: 36,
            width: 36,
            heightElements: [
                18
            ],
            widthElements: [
                10,
                20
            ]
        },
        'EVENT_ESCALATION': {
            d: 'M {mx},{my} l {e.x0},{e.y0} l -{e.x0},-{e.y1} l -{e.x0},{e.y1} Z',
            height: 36,
            width: 36,
            heightElements: [
                20,
                7
            ],
            widthElements: [
                8
            ]
        },
        'EVENT_CONDITIONAL': {
            d: "M {e.x0},{e.y0} l {e.x1},0 l 0,{e.y2} l -{e.x1},0 Z M {e.x2},{e.y3} l {e.x0},0 M {e.x2},{e.y4} l {e.x0},0 M {e.x2},{e.y5} l {e.x0},0 M {e.x2},{e.y6} l {e.x0},0 M {e.x2},{e.y7} l {e.x0},0 M {e.x2},{e.y8} l {e.x0},0 ",
            height: 36,
            width: 36,
            heightElements: [
                8.5,
                14.5,
                18,
                11.5,
                14.5,
                17.5,
                20.5,
                23.5,
                26.5
            ],
            widthElements: [
                10.5,
                14.5,
                12.5
            ]
        },
        'EVENT_LINK': {
            d: 'm {mx},{my} 0,{e.y0} -{e.x1},0 0,{e.y1} {e.x1},0 0,{e.y0} {e.x0},-{e.y2} -{e.x0},-{e.y2} z',
            height: 36,
            width: 36,
            heightElements: [
                4.4375,
                6.75,
                7.8125
            ],
            widthElements: [
                9.84375,
                13.5
            ]
        },
        'EVENT_ERROR': {
            d: 'm {mx},{my} {e.x0},-{e.y0} {e.x1},-{e.y1} {e.x2},{e.y2} {e.x3},-{e.y3} -{e.x4},{e.y4} -{e.x5},-{e.y5} z',
            height: 36,
            width: 36,
            heightElements: [
                0.023,
                8.737,
                8.151,
                16.564,
                10.591,
                8.714
            ],
            widthElements: [
                0.085,
                6.672,
                6.97,
                4.273,
                5.337,
                6.636
            ]
        },
        'EVENT_CANCEL_45': {
            d: "m {mx},{my} -{e.x1},0 0,{e.x0} {e.x1},0 0,{e.y1} {e.x0},0 0,-{e.y1} {e.x1},0 0,-{e.y0} -{e.x1},0 0,-{e.y1} -{e.x0},0 z",
            height: 36,
            width: 36,
            heightElements: [
                4.75,
                8.5
            ],
            widthElements: [
                4.75,
                8.5
            ]
        },
        'EVENT_COMPENSATION': {
            d: 'm {mx},{my} {e.x0},-{e.y0} 0,{e.y1} z m {e.x1},-{e.y2} {e.x2},-{e.y3} 0,{e.y1} -{e.x2},-{e.y3} z',
            height: 36,
            width: 36,
            heightElements: [
                6.5,
                13,
                0.4,
                6.1
            ],
            widthElements: [
                9,
                9.3,
                8.7
            ]
        },
        'EVENT_TIMER_WH': {
            d: 'M {mx},{my} l {e.x0},-{e.y0} m -{e.x0},{e.y0} l {e.x1},{e.y1} ',
            height: 36,
            width: 36,
            heightElements: [
                10,
                2
            ],
            widthElements: [
                3,
                7
            ]
        },
        'EVENT_TIMER_LINE': {
            d: "M {mx},{my} m {e.x0},{e.y0} l -{e.x1},{e.y1} ",
            height: 36,
            width: 36,
            heightElements: [
                10,
                3
            ],
            widthElements: [
                0,
                0
            ]
        },
        'EVENT_MULTIPLE': {
            d: 'm {mx},{my} {e.x1},-{e.y0} {e.x1},{e.y0} -{e.x0},{e.y1} -{e.x2},0 z',
            height: 36,
            width: 36,
            heightElements: [
                6.28099,
                12.56199
            ],
            widthElements: [
                3.1405,
                9.42149,
                12.56198
            ]
        },
        'EVENT_PARALLEL_MULTIPLE': {
            d: "m {mx},{my} {e.x0},0 0,{e.y1} {e.x1},0 0,{e.y0} -{e.x1},0 0,{e.y1} -{e.x0},0 0,-{e.y1} -{e.x1},0 0,-{e.y0} {e.x1},0 z",
            height: 36,
            width: 36,
            heightElements: [
                2.56228,
                7.68683
            ],
            widthElements: [
                2.56228,
                7.68683
            ]
        },
        'GATEWAY_EXCLUSIVE': {
            d: "m {mx},{my} {e.x0},{e.y0} {e.x1},{e.y0} {e.x2},0 {e.x4},{e.y2} {e.x4},{e.y1} {e.x2},0 {e.x1},{e.y3} {e.x0},{e.y3} {e.x3},0 {e.x5},{e.y1} {e.x5},{e.y2} {e.x3},0 z",
            height: 17.5,
            width: 17.5,
            heightElements: [
                8.5,
                6.5312,
                -6.5312,
                -8.5
            ],
            widthElements: [
                6.5,
                -6.5,
                3,
                -3,
                5,
                -5
            ]
        },
        'GATEWAY_PARALLEL': {
            d: "m {mx},{my} 0,{e.y1} -{e.x1},0 0,{e.y0} {e.x1},0 0,{e.y1} {e.x0},0 0,-{e.y1} {e.x1},0 0,-{e.y0} -{e.x1},0 0,-{e.y1} -{e.x0},0 z",
            height: 30,
            width: 30,
            heightElements: [
                5,
                12.5
            ],
            widthElements: [
                5,
                12.5
            ]
        },
        'GATEWAY_EVENT_BASED': {
            d: 'm {mx},{my} {e.x0},{e.y0} {e.x0},{e.y1} {e.x1},{e.y2} {e.x2},0 z',
            height: 11,
            width: 11,
            heightElements: [
                -6,
                6,
                12,
                -12
            ],
            widthElements: [
                9,
                -3,
                -12
            ]
        },
        'GATEWAY_COMPLEX': {
            d: "m {mx},{my} 0,{e.y0} -{e.x0},-{e.y1} -{e.x1},{e.y2} {e.x0},{e.y1} -{e.x2},0 0,{e.y3} {e.x2},0  -{e.x0},{e.y1} l {e.x1},{e.y2} {e.x0},-{e.y1} 0,{e.y0} {e.x3},0 0,-{e.y0} {e.x0},{e.y1} {e.x1},-{e.y2} -{e.x0},-{e.y1} {e.x2},0 0,-{e.y3} -{e.x2},0 {e.x0},-{e.y1} -{e.x1},-{e.y2} -{e.x0},{e.y1} 0,-{e.y0} -{e.x3},0 z",
            height: 17.125,
            width: 17.125,
            heightElements: [
                4.875,
                3.4375,
                2.125,
                3
            ],
            widthElements: [
                3.4375,
                2.125,
                4.875,
                3
            ]
        },
        'DATA_OBJECT_PATH': {
            d: 'm 0,0 {e.x1},0 {e.x0},{e.y0} 0,{e.y1} -{e.x2},0 0,-{e.y2} {e.x1},0 0,{e.y0} {e.x0},0',
            height: 61,
            width: 51,
            heightElements: [
                10,
                50,
                60
            ],
            widthElements: [
                10,
                40,
                50,
                60
            ]
        },
        'DATA_OBJECT_COLLECTION_PATH': {
            d: 'm{mx},{my} m 3,2 l 0,10 m 3,-10 l 0,10 m 3,-10 l 0,10',
            height: 10,
            width: 10,
            heightElements: [],
            widthElements: []
        },
        'DATA_ARROW': {
            d: 'm 5,9 9,0 0,-3 5,5 -5,5 0,-3 -9,0 z',
            height: 61,
            width: 51,
            heightElements: [],
            widthElements: []
        },
        'DATA_STORE': {
            d: "m  {mx},{my} l  0,{e.y2} c  {e.x0},{e.y1} {e.x1},{e.y1}  {e.x2},0 l  0,-{e.y2} c -{e.x0},-{e.y1} -{e.x1},-{e.y1} -{e.x2},0c  {e.x0},{e.y1} {e.x1},{e.y1}  {e.x2},0 m  -{e.x2},{e.y0}c  {e.x0},{e.y1} {e.x1},{e.y1} {e.x2},0m  -{e.x2},{e.y0}c  {e.x0},{e.y1} {e.x1},{e.y1}  {e.x2},0",
            height: 61,
            width: 61,
            heightElements: [
                7,
                10,
                45
            ],
            widthElements: [
                2,
                58,
                60
            ]
        },
        'TEXT_ANNOTATION': {
            d: 'm {mx}, {my} m 10,0 l -10,0 l 0,{e.y0} l 10,0',
            height: 30,
            width: 10,
            heightElements: [
                30
            ],
            widthElements: [
                10
            ]
        },
        'MARKER_SUB_PROCESS': {
            d: 'm{mx},{my} m 7,2 l 0,10 m -5,-5 l 10,0',
            height: 10,
            width: 10,
            heightElements: [],
            widthElements: []
        },
        'MARKER_PARALLEL': {
            d: 'm{mx},{my} m 3,2 l 0,10 m 3,-10 l 0,10 m 3,-10 l 0,10',
            height: 10,
            width: 10,
            heightElements: [],
            widthElements: []
        },
        'MARKER_SEQUENTIAL': {
            d: 'm{mx},{my} m 0,3 l 10,0 m -10,3 l 10,0 m -10,3 l 10,0',
            height: 10,
            width: 10,
            heightElements: [],
            widthElements: []
        },
        'MARKER_COMPENSATION': {
            d: 'm {mx},{my} 7,-5 0,10 z m 7.1,-0.3 6.9,-4.7 0,10 -6.9,-4.7 z',
            height: 10,
            width: 21,
            heightElements: [],
            widthElements: []
        },
        'MARKER_LOOP': {
            d: "m {mx},{my} c 3.526979,0 6.386161,-2.829858 6.386161,-6.320661 0,-3.490806 -2.859182,-6.320661 -6.386161,-6.320661 -3.526978,0 -6.38616,2.829855 -6.38616,6.320661 0,1.745402 0.714797,3.325567 1.870463,4.469381 0.577834,0.571908 1.265885,1.034728 2.029916,1.35457 l -0.718163,-3.909793 m 0.718163,3.909793 -3.885211,0.802902",
            height: 13.9,
            width: 13.7,
            heightElements: [],
            widthElements: []
        },
        'MARKER_ADHOC': {
            d: "m {mx},{my} m 0.84461,2.64411 c 1.05533,-1.23780996 2.64337,-2.07882 4.29653,-1.97997996 2.05163,0.0805 3.85579,1.15803 5.76082,1.79107 1.06385,0.34139996 2.24454,0.1438 3.18759,-0.43767 0.61743,-0.33642 1.2775,-0.64078 1.7542,-1.17511 0,0.56023 0,1.12046 0,1.6807 -0.98706,0.96237996 -2.29792,1.62393996 -3.6918,1.66181996 -1.24459,0.0927 -2.46671,-0.2491 -3.59505,-0.74812 -1.35789,-0.55965 -2.75133,-1.33436996 -4.27027,-1.18121996 -1.37741,0.14601 -2.41842,1.13685996 -3.44288,1.96782996 z",
            height: 4,
            width: 15,
            heightElements: [],
            widthElements: []
        },
        'TASK_TYPE_SEND': {
            d: 'm {mx},{my} l 0,{e.y1} l {e.x1},0 l 0,-{e.y1} z l {e.x0},{e.y0} l {e.x0},-{e.y0}',
            height: 14,
            width: 21,
            heightElements: [
                6,
                14
            ],
            widthElements: [
                10.5,
                21
            ]
        },
        'TASK_TYPE_SCRIPT': {
            d: "m {mx},{my} c 9.966553,-6.27276 -8.000926,-7.91932 2.968968,-14.938 l -8.802728,0 c -10.969894,7.01868 6.997585,8.66524 -2.968967,14.938 z m -7,-12 l 5,0 m -4.5,3 l 4.5,0 m -3,3 l 5,0m -4,3 l 5,0",
            height: 15,
            width: 12.6,
            heightElements: [
                6,
                14
            ],
            widthElements: [
                10.5,
                21
            ]
        },
        'TASK_TYPE_USER_1': {
            d: "m {mx},{my} c 0.909,-0.845 1.594,-2.049 1.594,-3.385 0,-2.554 -1.805,-4.62199999 -4.357,-4.62199999 -2.55199998,0 -4.28799998,2.06799999 -4.28799998,4.62199999 0,1.348 0.974,2.562 1.89599998,3.405 -0.52899998,0.187 -5.669,2.097 -5.794,4.7560005 v 6.718 h 17 v -6.718 c 0,-2.2980005 -5.5279996,-4.5950005 -6.0509996,-4.7760005 zm -8,6 l 0,5.5 m 11,0 l 0,-5"
        },
        'TASK_TYPE_USER_2': {
            d: "m {mx},{my} m 2.162,1.009 c 0,2.4470005 -2.158,4.4310005 -4.821,4.4310005 -2.66499998,0 -4.822,-1.981 -4.822,-4.4310005 "
        },
        'TASK_TYPE_USER_3': {
            d: "m {mx},{my} m -6.9,-3.80 c 0,0 2.25099998,-2.358 4.27399998,-1.177 2.024,1.181 4.221,1.537 4.124,0.965 -0.098,-0.57 -0.117,-3.79099999 -4.191,-4.13599999 -3.57499998,0.001 -4.20799998,3.36699999 -4.20699998,4.34799999 z"
        },
        'TASK_TYPE_MANUAL': {
            d: "m {mx},{my} c 0.234,-0.01 5.604,0.008 8.029,0.004 0.808,0 1.271,-0.172 1.417,-0.752 0.227,-0.898 -0.334,-1.314 -1.338,-1.316 -2.467,-0.01 -7.886,-0.004 -8.108,-0.004 -0.014,-0.079 0.016,-0.533 0,-0.61 0.195,-0.042 8.507,0.006 9.616,0.002 0.877,-0.007 1.35,-0.438 1.353,-1.208 0.003,-0.768 -0.479,-1.09 -1.35,-1.091 -2.968,-0.002 -9.619,-0.013 -9.619,-0.013 v -0.591 c 0,0 5.052,-0.016 7.225,-0.016 0.888,-0.002 1.354,-0.416 1.351,-1.193 -0.006,-0.761 -0.492,-1.196 -1.361,-1.196 -3.473,-0.005 -10.86,-0.003 -11.0829995,-0.003 -0.022,-0.047 -0.045,-0.094 -0.069,-0.139 0.3939995,-0.319 2.0409995,-1.626 2.4149995,-2.017 0.469,-0.4870005 0.519,-1.1650005 0.162,-1.6040005 -0.414,-0.511 -0.973,-0.5 -1.48,-0.236 -1.4609995,0.764 -6.5999995,3.6430005 -7.7329995,4.2710005 -0.9,0.499 -1.516,1.253 -1.882,2.19 -0.37000002,0.95 -0.17,2.01 -0.166,2.979 0.004,0.718 -0.27300002,1.345 -0.055,2.063 0.629,2.087 2.425,3.312 4.859,3.318 4.6179995,0.014 9.2379995,-0.139 13.8569995,-0.158 0.755,-0.004 1.171,-0.301 1.182,-1.033 0.012,-0.754 -0.423,-0.969 -1.183,-0.973 -1.778,-0.01 -5.824,-0.004 -6.04,-0.004 10e-4,-0.084 0.003,-0.586 10e-4,-0.67 z"
        },
        'TASK_TYPE_INSTANTIATING_SEND': {
            d: 'm {mx},{my} l 0,8.4 l 12.6,0 l 0,-8.4 z l 6.3,3.6 l 6.3,-3.6'
        },
        'TASK_TYPE_SERVICE': {
            d: "m {mx},{my} v -1.71335 c 0.352326,-0.0705 0.703932,-0.17838 1.047628,-0.32133 0.344416,-0.14465 0.665822,-0.32133 0.966377,-0.52145 l 1.19431,1.18005 1.567487,-1.57688 -1.195028,-1.18014 c 0.403376,-0.61394 0.683079,-1.29908 0.825447,-2.01824 l 1.622133,-0.01 v -2.2196 l -1.636514,0.01 c -0.07333,-0.35153 -0.178319,-0.70024 -0.323564,-1.04372 -0.145244,-0.34406 -0.321407,-0.6644 -0.522735,-0.96217 l 1.131035,-1.13631 -1.583305,-1.56293 -1.129598,1.13589 c -0.614052,-0.40108 -1.302883,-0.68093 -2.022633,-0.82247 l 0.0093,-1.61852 h -2.241173 l 0.0042,1.63124 c -0.353763,0.0736 -0.705369,0.17977 -1.049785,0.32371 -0.344415,0.14437 -0.665102,0.32092 -0.9635006,0.52046 l -1.1698628,-1.15823 -1.5667691,1.5792 1.1684265,1.15669 c -0.4026573,0.61283 -0.68308,1.29797 -0.8247287,2.01713 l -1.6588041,0.003 v 2.22174 l 1.6724648,-0.006 c 0.073327,0.35077 0.1797598,0.70243 0.3242851,1.04472 0.1452428,0.34448 0.3214064,0.6644 0.5227339,0.96066 l -1.1993431,1.19723 1.5840256,1.56011 1.1964668,-1.19348 c 0.6140517,0.40346 1.3028827,0.68232 2.0233517,0.82331 l 7.19e-4,1.69892 h 2.226848 z m 0.221462,-3.9957 c -1.788948,0.7502 -3.8576,-0.0928 -4.6097055,-1.87438 -0.7521065,-1.78321 0.090598,-3.84627 1.8802645,-4.59604 1.78823,-0.74936 3.856881,0.0929 4.608987,1.87437 0.752106,1.78165 -0.0906,3.84612 -1.879546,4.59605 z"
        },
        'TASK_TYPE_SERVICE_FILL': {
            d: "m {mx},{my} c -1.788948,0.7502 -3.8576,-0.0928 -4.6097055,-1.87438 -0.7521065,-1.78321 0.090598,-3.84627 1.8802645,-4.59604 1.78823,-0.74936 3.856881,0.0929 4.608987,1.87437 0.752106,1.78165 -0.0906,3.84612 -1.879546,4.59605 z"
        },
        'TASK_TYPE_BUSINESS_RULE_HEADER': {
            d: 'm {mx},{my} 0,4 20,0 0,-4 z'
        },
        'TASK_TYPE_BUSINESS_RULE_MAIN': {
            d: "m {mx},{my} 0,12 20,0 0,-12 zm 0,8 l 20,0 m -13,-4 l 0,8"
        },
        'MESSAGE_FLOW_MARKER': {
            d: 'm {mx},{my} m -10.5 ,-7 l 0,14 l 21,0 l 0,-14 z l 10.5,6 l 10.5,-6'
        }
    };
    this.getRawPath = function getRawPath(pathId) {
        return this.pathMap[pathId].d;
    };
    /**
   * Scales the path to the given height and width.
   * <h1>Use case</h1>
   * <p>Use case is to scale the content of elements (event, gateways) based
   * on the element bounding box's size.
   * </p>
   * <h1>Why not transform</h1>
   * <p>Scaling a path with transform() will also scale the stroke and IE does not support
   * the option 'non-scaling-stroke' to prevent this.
   * Also there are use cases where only some parts of a path should be
   * scaled.</p>
   *
   * @param {string} pathId The ID of the path.
   * @param {Object} param <p>
   *   Example param object scales the path to 60% size of the container (data.width, data.height).
   *   <pre>
   *   {
   *     xScaleFactor: 0.6,
   *     yScaleFactor:0.6,
   *     containerWidth: data.width,
   *     containerHeight: data.height,
   *     position: {
   *       mx: 0.46,
   *       my: 0.2,
   *     }
   *   }
   *   </pre>
   *   <ul>
   *    <li>targetpathwidth = xScaleFactor * containerWidth</li>
   *    <li>targetpathheight = yScaleFactor * containerHeight</li>
   *    <li>Position is used to set the starting coordinate of the path. M is computed:
    *    <ul>
    *      <li>position.x * containerWidth</li>
    *      <li>position.y * containerHeight</li>
    *    </ul>
    *    Center of the container <pre> position: {
   *       mx: 0.5,
   *       my: 0.5,
   *     }</pre>
   *     Upper left corner of the container
   *     <pre> position: {
   *       mx: 0.0,
   *       my: 0.0,
   *     }</pre>
   *    </li>
   *   </ul>
   * </p>
   *
   */ this.getScaledPath = function getScaledPath(pathId, param) {
        var rawPath = this.pathMap[pathId];
        // positioning
        // compute the start point of the path
        var mx, my;
        if (param.abspos) {
            mx = param.abspos.x;
            my = param.abspos.y;
        } else {
            mx = param.containerWidth * param.position.mx;
            my = param.containerHeight * param.position.my;
        }
        var coordinates = {}; // map for the scaled coordinates
        if (param.position) {
            // path
            var heightRatio = param.containerHeight / rawPath.height * param.yScaleFactor;
            var widthRatio = param.containerWidth / rawPath.width * param.xScaleFactor;
            // Apply height ratio
            for(var heightIndex = 0; heightIndex < rawPath.heightElements.length; heightIndex++)coordinates['y' + heightIndex] = rawPath.heightElements[heightIndex] * heightRatio;
            // Apply width ratio
            for(var widthIndex = 0; widthIndex < rawPath.widthElements.length; widthIndex++)coordinates['x' + widthIndex] = rawPath.widthElements[widthIndex] * widthRatio;
        }
        // Apply value to raw path
        var path = format(rawPath.d, {
            mx: mx,
            my: my,
            e: coordinates
        });
        return path;
    };
}
// helpers //////////////////////
// copied and adjusted from https://github.com/adobe-webplatform/Snap.svg/blob/master/src/svg.js
var tokenRegex = /\{([^{}]+)\}/g, objNotationRegex = /(?:(?:^|\.)(.+?)(?=\[|\.|$|\()|\[('|")(.+?)\2\])(\(\))?/g; // matches .xxxxx or ["xxxxx"] to run over object properties
function replacer(all, key, obj) {
    var res = obj;
    key.replace(objNotationRegex, function(all, name, quote, quotedName, isFunc) {
        name = name || quotedName;
        if (res) {
            if (name in res) res = res[name];
            typeof res == 'function' && isFunc && (res = res());
        }
    });
    res = (res == null || res == obj ? all : res) + '';
    return res;
}
function format(str, obj) {
    return String(str).replace(tokenRegex, function(all, key) {
        return replacer(all, key, obj);
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iYx7I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _translate = require("diagram-js/lib/i18n/translate");
var _translateDefault = parcelHelpers.interopDefault(_translate);
var _bpmnImporter = require("./BpmnImporter");
var _bpmnImporterDefault = parcelHelpers.interopDefault(_bpmnImporter);
exports.default = {
    __depends__: [
        (0, _translateDefault.default)
    ],
    bpmnImporter: [
        'type',
        (0, _bpmnImporterDefault.default)
    ]
};

},{"diagram-js/lib/i18n/translate":"lgOY2","./BpmnImporter":"2y0sD","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lgOY2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _translate = require("./translate");
var _translateDefault = parcelHelpers.interopDefault(_translate);
exports.default = {
    translate: [
        'value',
        (0, _translateDefault.default)
    ]
};

},{"./translate":"cdzpW","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cdzpW":[function(require,module,exports,__globalThis) {
/**
 * @typedef {import('./').Replacements} Replacements
 */ /**
 * A simple translation stub to be used for multi-language support
 * in diagrams. Can be easily replaced with a more sophisticated
 * solution.
 *
 * @example
 *
 * // use it inside any diagram component by injecting `translate`.
 *
 * function MyService(translate) {
 *   alert(translate('HELLO {you}', { you: 'You!' }));
 * }
 *
 * @param {string} template to interpolate
 * @param {Replacements} [replacements] a map with substitutes
 *
 * @return {string} the translated string
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>translate);
function translate(template, replacements) {
    replacements = replacements || {};
    return template.replace(/{([^}]+)}/g, function(_, key) {
        return replacements[key] || '{' + key + '}';
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2y0sD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BpmnImporter);
var _minDash = require("min-dash");
var _modelUtil = require("../util/ModelUtil");
var _labelUtil = require("../util/LabelUtil");
var _layoutUtil = require("diagram-js/lib/layout/LayoutUtil");
var _diUtil = require("../util/DiUtil");
var _labelUtil1 = require("../features/label-editing/LabelUtil");
var _util = require("./Util");
/**
 * @param {ModdleElement} semantic
 * @param {ModdleElement} di
 * @param {Object} [attrs=null]
 *
 * @return {Object}
 */ function elementData(semantic, di, attrs) {
    return (0, _minDash.assign)({
        id: semantic.id,
        type: semantic.$type,
        businessObject: semantic,
        di: di
    }, attrs);
}
function getWaypoints(di, source, target) {
    var waypoints = di.waypoint;
    if (!waypoints || waypoints.length < 2) return [
        (0, _layoutUtil.getMid)(source),
        (0, _layoutUtil.getMid)(target)
    ];
    return waypoints.map(function(p) {
        return {
            x: p.x,
            y: p.y
        };
    });
}
function notYetDrawn(translate, semantic, refSemantic, property) {
    return new Error(translate('element {element} referenced by {referenced}#{property} not yet drawn', {
        element: (0, _util.elementToString)(refSemantic),
        referenced: (0, _util.elementToString)(semantic),
        property: property
    }));
}
function BpmnImporter(eventBus, canvas, elementFactory, elementRegistry, translate, textRenderer) {
    this._eventBus = eventBus;
    this._canvas = canvas;
    this._elementFactory = elementFactory;
    this._elementRegistry = elementRegistry;
    this._translate = translate;
    this._textRenderer = textRenderer;
}
BpmnImporter.$inject = [
    'eventBus',
    'canvas',
    'elementFactory',
    'elementRegistry',
    'translate',
    'textRenderer'
];
/**
 * Add bpmn element (semantic) to the canvas onto the
 * specified parent shape.
 */ BpmnImporter.prototype.add = function(semantic, di, parentElement) {
    var element, translate = this._translate, hidden;
    var parentIndex;
    // ROOT ELEMENT
    // handle the special case that we deal with a
    // invisible root element (process, subprocess or collaboration)
    if ((0, _modelUtil.is)(di, 'bpmndi:BPMNPlane')) {
        var attrs = (0, _modelUtil.is)(semantic, 'bpmn:SubProcess') ? {
            id: semantic.id + '_plane'
        } : {};
        // add a virtual element (not being drawn)
        element = this._elementFactory.createRoot(elementData(semantic, di, attrs));
        this._canvas.addRootElement(element);
    } else if ((0, _modelUtil.is)(di, 'bpmndi:BPMNShape')) {
        var collapsed = !(0, _diUtil.isExpanded)(semantic, di), isFrame = isFrameElement(semantic);
        hidden = parentElement && (parentElement.hidden || parentElement.collapsed);
        var bounds = di.bounds;
        element = this._elementFactory.createShape(elementData(semantic, di, {
            collapsed: collapsed,
            hidden: hidden,
            x: Math.round(bounds.x),
            y: Math.round(bounds.y),
            width: Math.round(bounds.width),
            height: Math.round(bounds.height),
            isFrame: isFrame
        }));
        if ((0, _modelUtil.is)(semantic, 'bpmn:BoundaryEvent')) this._attachBoundary(semantic, element);
        // insert lanes behind other flow nodes (cf. #727)
        if ((0, _modelUtil.is)(semantic, 'bpmn:Lane')) parentIndex = 0;
        if ((0, _modelUtil.is)(semantic, 'bpmn:DataStoreReference')) // check whether data store is inside our outside of its semantic parent
        {
            if (!isPointInsideBBox(parentElement, (0, _layoutUtil.getMid)(bounds))) parentElement = this._canvas.findRoot(parentElement);
        }
        this._canvas.addShape(element, parentElement, parentIndex);
    } else if ((0, _modelUtil.is)(di, 'bpmndi:BPMNEdge')) {
        var source = this._getSource(semantic), target = this._getTarget(semantic);
        hidden = parentElement && (parentElement.hidden || parentElement.collapsed);
        element = this._elementFactory.createConnection(elementData(semantic, di, {
            hidden: hidden,
            source: source,
            target: target,
            waypoints: getWaypoints(di, source, target)
        }));
        if ((0, _modelUtil.is)(semantic, 'bpmn:DataAssociation')) // render always on top; this ensures DataAssociations
        // are rendered correctly across different "hacks" people
        // love to model such as cross participant / sub process
        // associations
        parentElement = this._canvas.findRoot(parentElement);
        this._canvas.addConnection(element, parentElement, parentIndex);
    } else throw new Error(translate('unknown di {di} for element {semantic}', {
        di: (0, _util.elementToString)(di),
        semantic: (0, _util.elementToString)(semantic)
    }));
    // (optional) LABEL
    if ((0, _labelUtil.isLabelExternal)(semantic) && (0, _labelUtil1.getLabel)(element)) this.addLabel(semantic, di, element);
    this._eventBus.fire('bpmnElement.added', {
        element: element
    });
    return element;
};
/**
 * Attach the boundary element to the given host
 *
 * @param {ModdleElement} boundarySemantic
 * @param {djs.model.Base} boundaryElement
 */ BpmnImporter.prototype._attachBoundary = function(boundarySemantic, boundaryElement) {
    var translate = this._translate;
    var hostSemantic = boundarySemantic.attachedToRef;
    if (!hostSemantic) throw new Error(translate('missing {semantic}#attachedToRef', {
        semantic: (0, _util.elementToString)(boundarySemantic)
    }));
    var host = this._elementRegistry.get(hostSemantic.id), attachers = host && host.attachers;
    if (!host) throw notYetDrawn(translate, boundarySemantic, hostSemantic, 'attachedToRef');
    // wire element.host <> host.attachers
    boundaryElement.host = host;
    if (!attachers) host.attachers = attachers = [];
    if (attachers.indexOf(boundaryElement) === -1) attachers.push(boundaryElement);
};
/**
 * add label for an element
 */ BpmnImporter.prototype.addLabel = function(semantic, di, element) {
    var bounds, text, label;
    bounds = (0, _labelUtil.getExternalLabelBounds)(di, element);
    text = (0, _labelUtil1.getLabel)(element);
    if (text) // get corrected bounds from actual layouted text
    bounds = this._textRenderer.getExternalLabelBounds(bounds, text);
    label = this._elementFactory.createLabel(elementData(semantic, di, {
        id: semantic.id + '_label',
        labelTarget: element,
        type: 'label',
        hidden: element.hidden || !(0, _labelUtil1.getLabel)(element),
        x: Math.round(bounds.x),
        y: Math.round(bounds.y),
        width: Math.round(bounds.width),
        height: Math.round(bounds.height)
    }));
    return this._canvas.addShape(label, element.parent);
};
/**
 * Return the drawn connection end based on the given side.
 *
 * @throws {Error} if the end is not yet drawn
 */ BpmnImporter.prototype._getEnd = function(semantic, side) {
    var element, refSemantic, type = semantic.$type, translate = this._translate;
    refSemantic = semantic[side + 'Ref'];
    // handle mysterious isMany DataAssociation#sourceRef
    if (side === 'source' && type === 'bpmn:DataInputAssociation') refSemantic = refSemantic && refSemantic[0];
    // fix source / target for DataInputAssociation / DataOutputAssociation
    if (side === 'source' && type === 'bpmn:DataOutputAssociation' || side === 'target' && type === 'bpmn:DataInputAssociation') refSemantic = semantic.$parent;
    element = refSemantic && this._getElement(refSemantic);
    if (element) return element;
    if (refSemantic) throw notYetDrawn(translate, semantic, refSemantic, side + 'Ref');
    else throw new Error(translate('{semantic}#{side} Ref not specified', {
        semantic: (0, _util.elementToString)(semantic),
        side: side
    }));
};
BpmnImporter.prototype._getSource = function(semantic) {
    return this._getEnd(semantic, 'source');
};
BpmnImporter.prototype._getTarget = function(semantic) {
    return this._getEnd(semantic, 'target');
};
BpmnImporter.prototype._getElement = function(semantic) {
    return this._elementRegistry.get(semantic.id);
};
// helpers ////////////////////
function isPointInsideBBox(bbox, point) {
    var x = point.x, y = point.y;
    return x >= bbox.x && x <= bbox.x + bbox.width && y >= bbox.y && y <= bbox.y + bbox.height;
}
function isFrameElement(semantic) {
    return (0, _modelUtil.is)(semantic, 'bpmn:Group');
}

},{"min-dash":"aEEla","../util/ModelUtil":"klNYN","../util/LabelUtil":"fAd5x","diagram-js/lib/layout/LayoutUtil":"4CCrs","../util/DiUtil":"krDFz","../features/label-editing/LabelUtil":"gHqpR","./Util":"emVbk","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fAd5x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_LABEL_SIZE", ()=>DEFAULT_LABEL_SIZE);
parcelHelpers.export(exports, "FLOW_LABEL_INDENT", ()=>FLOW_LABEL_INDENT);
/**
 * Returns true if the given semantic has an external label
 *
 * @param {BpmnElement} semantic
 * @return {boolean} true if has label
 */ parcelHelpers.export(exports, "isLabelExternal", ()=>isLabelExternal);
/**
 * Returns true if the given element has an external label
 *
 * @param {djs.model.shape} element
 * @return {boolean} true if has label
 */ parcelHelpers.export(exports, "hasExternalLabel", ()=>hasExternalLabel);
/**
 * Get the position for sequence flow labels
 *
 * @param  {Array<Point>} waypoints
 * @return {Point} the label position
 */ parcelHelpers.export(exports, "getFlowLabelPosition", ()=>getFlowLabelPosition);
/**
 * Get the middle of a number of waypoints
 *
 * @param  {Array<Point>} waypoints
 * @return {Point} the mid point
 */ parcelHelpers.export(exports, "getWaypointsMid", ()=>getWaypointsMid);
parcelHelpers.export(exports, "getExternalLabelMid", ()=>getExternalLabelMid);
/**
 * Returns the bounds of an elements label, parsed from the elements DI or
 * generated from its bounds.
 *
 * @param {BpmndDi} di
 * @param {djs.model.Base} element
 */ parcelHelpers.export(exports, "getExternalLabelBounds", ()=>getExternalLabelBounds);
parcelHelpers.export(exports, "isLabel", ()=>isLabel);
var _minDash = require("min-dash");
var _modelUtil = require("./ModelUtil");
var DEFAULT_LABEL_SIZE = {
    width: 90,
    height: 20
};
var FLOW_LABEL_INDENT = 15;
function isLabelExternal(semantic) {
    return (0, _modelUtil.is)(semantic, 'bpmn:Event') || (0, _modelUtil.is)(semantic, 'bpmn:Gateway') || (0, _modelUtil.is)(semantic, 'bpmn:DataStoreReference') || (0, _modelUtil.is)(semantic, 'bpmn:DataObjectReference') || (0, _modelUtil.is)(semantic, 'bpmn:DataInput') || (0, _modelUtil.is)(semantic, 'bpmn:DataOutput') || (0, _modelUtil.is)(semantic, 'bpmn:SequenceFlow') || (0, _modelUtil.is)(semantic, 'bpmn:MessageFlow') || (0, _modelUtil.is)(semantic, 'bpmn:Group');
}
function hasExternalLabel(element) {
    return isLabel(element.label);
}
function getFlowLabelPosition(waypoints) {
    // get the waypoints mid
    var mid = waypoints.length / 2 - 1;
    var first = waypoints[Math.floor(mid)];
    var second = waypoints[Math.ceil(mid + 0.01)];
    // get position
    var position = getWaypointsMid(waypoints);
    // calculate angle
    var angle = Math.atan((second.y - first.y) / (second.x - first.x));
    var x = position.x, y = position.y;
    if (Math.abs(angle) < Math.PI / 2) y -= FLOW_LABEL_INDENT;
    else x += FLOW_LABEL_INDENT;
    return {
        x: x,
        y: y
    };
}
function getWaypointsMid(waypoints) {
    var mid = waypoints.length / 2 - 1;
    var first = waypoints[Math.floor(mid)];
    var second = waypoints[Math.ceil(mid + 0.01)];
    return {
        x: first.x + (second.x - first.x) / 2,
        y: first.y + (second.y - first.y) / 2
    };
}
function getExternalLabelMid(element) {
    if (element.waypoints) return getFlowLabelPosition(element.waypoints);
    else if ((0, _modelUtil.is)(element, 'bpmn:Group')) return {
        x: element.x + element.width / 2,
        y: element.y + DEFAULT_LABEL_SIZE.height / 2
    };
    else return {
        x: element.x + element.width / 2,
        y: element.y + element.height + DEFAULT_LABEL_SIZE.height / 2
    };
}
function getExternalLabelBounds(di, element) {
    var mid, size, bounds, label = di.label;
    if (label && label.bounds) {
        bounds = label.bounds;
        size = {
            width: Math.max(DEFAULT_LABEL_SIZE.width, bounds.width),
            height: bounds.height
        };
        mid = {
            x: bounds.x + bounds.width / 2,
            y: bounds.y + bounds.height / 2
        };
    } else {
        mid = getExternalLabelMid(element);
        size = DEFAULT_LABEL_SIZE;
    }
    return (0, _minDash.assign)({
        x: mid.x - size.width / 2,
        y: mid.y - size.height / 2
    }, size);
}
function isLabel(element) {
    return element && !!element.labelTarget;
}

},{"min-dash":"aEEla","./ModelUtil":"klNYN","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8Jf3R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _interactionEvents = require("../interaction-events");
var _interactionEventsDefault = parcelHelpers.interopDefault(_interactionEvents);
var _outline = require("../outline");
var _outlineDefault = parcelHelpers.interopDefault(_outline);
var _selection = require("./Selection");
var _selectionDefault = parcelHelpers.interopDefault(_selection);
var _selectionVisuals = require("./SelectionVisuals");
var _selectionVisualsDefault = parcelHelpers.interopDefault(_selectionVisuals);
var _selectionBehavior = require("./SelectionBehavior");
var _selectionBehaviorDefault = parcelHelpers.interopDefault(_selectionBehavior);
exports.default = {
    __init__: [
        'selectionVisuals',
        'selectionBehavior'
    ],
    __depends__: [
        (0, _interactionEventsDefault.default),
        (0, _outlineDefault.default)
    ],
    selection: [
        'type',
        (0, _selectionDefault.default)
    ],
    selectionVisuals: [
        'type',
        (0, _selectionVisualsDefault.default)
    ],
    selectionBehavior: [
        'type',
        (0, _selectionBehaviorDefault.default)
    ]
};

},{"../interaction-events":"4qbdP","../outline":"2Z6Dm","./Selection":"37kpR","./SelectionVisuals":"d0Hyj","./SelectionBehavior":"gWQGO","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4qbdP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _interactionEvents = require("./InteractionEvents");
var _interactionEventsDefault = parcelHelpers.interopDefault(_interactionEvents);
exports.default = {
    __init__: [
        'interactionEvents'
    ],
    interactionEvents: [
        'type',
        (0, _interactionEventsDefault.default)
    ]
};

},{"./InteractionEvents":"kUa5d","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kUa5d":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>InteractionEvents);
var _minDash = require("min-dash");
var _minDom = require("min-dom");
var _mouse = require("../../util/Mouse");
var _tinySvg = require("tiny-svg");
var _renderUtil = require("../../util/RenderUtil");
/**
 * @typedef {import('../../model').Base} Base
 *
 * @typedef {import('../../core/ElementRegistry').default} ElementRegistry
 * @typedef {import('../../core/EventBus').default} EventBus
 * @typedef {import('../../draw/Styles').default} Styles
 */ function allowAll(event) {
    return true;
}
function allowPrimaryAndAuxiliary(event) {
    return (0, _mouse.isPrimaryButton)(event) || (0, _mouse.isAuxiliaryButton)(event);
}
var LOW_PRIORITY = 500;
function InteractionEvents(eventBus, elementRegistry, styles) {
    var self = this;
    /**
   * Fire an interaction event.
   *
   * @param {string} type local event name, e.g. element.click.
   * @param {MouseEvent|TouchEvent} event native event
   * @param {Base} [element] the diagram element to emit the event on;
   *                                   defaults to the event target
   */ function fire(type, event, element) {
        if (isIgnored(type, event)) return;
        var target, gfx, returnValue;
        if (!element) {
            target = event.delegateTarget || event.target;
            if (target) {
                gfx = target;
                element = elementRegistry.get(gfx);
            }
        } else gfx = elementRegistry.getGraphics(element);
        if (!gfx || !element) return;
        returnValue = eventBus.fire(type, {
            element: element,
            gfx: gfx,
            originalEvent: event
        });
        if (returnValue === false) {
            event.stopPropagation();
            event.preventDefault();
        }
    }
    // TODO(nikku): document this
    var handlers = {};
    function mouseHandler(localEventName) {
        return handlers[localEventName];
    }
    function isIgnored(localEventName, event) {
        var filter = ignoredFilters[localEventName] || (0, _mouse.isPrimaryButton);
        // only react on left mouse button interactions
        // except for interaction events that are enabled
        // for secundary mouse button
        return !filter(event);
    }
    var bindings = {
        click: 'element.click',
        contextmenu: 'element.contextmenu',
        dblclick: 'element.dblclick',
        mousedown: 'element.mousedown',
        mousemove: 'element.mousemove',
        mouseover: 'element.hover',
        mouseout: 'element.out',
        mouseup: 'element.mouseup'
    };
    var ignoredFilters = {
        'element.contextmenu': allowAll,
        'element.mousedown': allowPrimaryAndAuxiliary,
        'element.mouseup': allowPrimaryAndAuxiliary,
        'element.click': allowPrimaryAndAuxiliary,
        'element.dblclick': allowPrimaryAndAuxiliary
    };
    // manual event trigger //////////
    /**
   * Trigger an interaction event (based on a native dom event)
   * on the target shape or connection.
   *
   * @param {string} eventName the name of the triggered DOM event
   * @param {MouseEvent|TouchEvent} event
   * @param {Base} targetElement
   */ function triggerMouseEvent(eventName, event, targetElement) {
        // i.e. element.mousedown...
        var localEventName = bindings[eventName];
        if (!localEventName) throw new Error('unmapped DOM event name <' + eventName + '>');
        return fire(localEventName, event, targetElement);
    }
    var ELEMENT_SELECTOR = 'svg, .djs-element';
    // event handling ///////
    function registerEvent(node, event, localEvent, ignoredFilter) {
        var handler = handlers[localEvent] = function(event) {
            fire(localEvent, event);
        };
        if (ignoredFilter) ignoredFilters[localEvent] = ignoredFilter;
        handler.$delegate = (0, _minDom.delegate).bind(node, ELEMENT_SELECTOR, event, handler);
    }
    function unregisterEvent(node, event, localEvent) {
        var handler = mouseHandler(localEvent);
        if (!handler) return;
        (0, _minDom.delegate).unbind(node, event, handler.$delegate);
    }
    function registerEvents(svg) {
        (0, _minDash.forEach)(bindings, function(val, key) {
            registerEvent(svg, key, val);
        });
    }
    function unregisterEvents(svg) {
        (0, _minDash.forEach)(bindings, function(val, key) {
            unregisterEvent(svg, key, val);
        });
    }
    eventBus.on('canvas.destroy', function(event) {
        unregisterEvents(event.svg);
    });
    eventBus.on('canvas.init', function(event) {
        registerEvents(event.svg);
    });
    // hit box updating ////////////////
    eventBus.on([
        'shape.added',
        'connection.added'
    ], function(event) {
        var element = event.element, gfx = event.gfx;
        eventBus.fire('interactionEvents.createHit', {
            element: element,
            gfx: gfx
        });
    });
    // Update djs-hit on change.
    // A low priortity is necessary, because djs-hit of labels has to be updated
    // after the label bounds have been updated in the renderer.
    eventBus.on([
        'shape.changed',
        'connection.changed'
    ], LOW_PRIORITY, function(event) {
        var element = event.element, gfx = event.gfx;
        eventBus.fire('interactionEvents.updateHit', {
            element: element,
            gfx: gfx
        });
    });
    eventBus.on('interactionEvents.createHit', LOW_PRIORITY, function(event) {
        var element = event.element, gfx = event.gfx;
        self.createDefaultHit(element, gfx);
    });
    eventBus.on('interactionEvents.updateHit', function(event) {
        var element = event.element, gfx = event.gfx;
        self.updateDefaultHit(element, gfx);
    });
    // hit styles ////////////
    var STROKE_HIT_STYLE = createHitStyle('djs-hit djs-hit-stroke');
    var CLICK_STROKE_HIT_STYLE = createHitStyle('djs-hit djs-hit-click-stroke');
    var ALL_HIT_STYLE = createHitStyle('djs-hit djs-hit-all');
    var NO_MOVE_HIT_STYLE = createHitStyle('djs-hit djs-hit-no-move');
    var HIT_TYPES = {
        'all': ALL_HIT_STYLE,
        'click-stroke': CLICK_STROKE_HIT_STYLE,
        'stroke': STROKE_HIT_STYLE,
        'no-move': NO_MOVE_HIT_STYLE
    };
    function createHitStyle(classNames, attrs) {
        attrs = (0, _minDash.assign)({
            stroke: 'white',
            strokeWidth: 15
        }, attrs || {});
        return styles.cls(classNames, [
            'no-fill',
            'no-border'
        ], attrs);
    }
    // style helpers ///////////////
    function applyStyle(hit, type) {
        var attrs = HIT_TYPES[type];
        if (!attrs) throw new Error('invalid hit type <' + type + '>');
        (0, _tinySvg.attr)(hit, attrs);
        return hit;
    }
    function appendHit(gfx, hit) {
        (0, _tinySvg.append)(gfx, hit);
    }
    // API
    /**
   * Remove hints on the given graphics.
   *
   * @param {SVGElement} gfx
   */ this.removeHits = function(gfx) {
        var hits = (0, _minDom.queryAll)('.djs-hit', gfx);
        (0, _minDash.forEach)(hits, (0, _tinySvg.remove));
    };
    /**
   * Create default hit for the given element.
   *
   * @param {Base} element
   * @param {SVGElement} gfx
   *
   * @return {SVGElement} created hit
   */ this.createDefaultHit = function(element, gfx) {
        var waypoints = element.waypoints, isFrame = element.isFrame, boxType;
        if (waypoints) return this.createWaypointsHit(gfx, waypoints);
        else {
            boxType = isFrame ? 'stroke' : 'all';
            return this.createBoxHit(gfx, boxType, {
                width: element.width,
                height: element.height
            });
        }
    };
    /**
   * Create hits for the given waypoints.
   *
   * @param {SVGElement} gfx
   * @param {Array<Point>} waypoints
   *
   * @return {SVGElement}
   */ this.createWaypointsHit = function(gfx, waypoints) {
        var hit = (0, _renderUtil.createLine)(waypoints);
        applyStyle(hit, 'stroke');
        appendHit(gfx, hit);
        return hit;
    };
    /**
   * Create hits for a box.
   *
   * @param {SVGElement} gfx
   * @param {string} hitType
   * @param {Object} attrs
   *
   * @return {SVGElement}
   */ this.createBoxHit = function(gfx, type, attrs) {
        attrs = (0, _minDash.assign)({
            x: 0,
            y: 0
        }, attrs);
        var hit = (0, _tinySvg.create)('rect');
        applyStyle(hit, type);
        (0, _tinySvg.attr)(hit, attrs);
        appendHit(gfx, hit);
        return hit;
    };
    /**
   * Update default hit of the element.
   *
   * @param {Base} element
   * @param {SVGElement} gfx
   *
   * @return {SVGElement} updated hit
   */ this.updateDefaultHit = function(element, gfx) {
        var hit = (0, _minDom.query)('.djs-hit', gfx);
        if (!hit) return;
        if (element.waypoints) (0, _renderUtil.updateLine)(hit, element.waypoints);
        else (0, _tinySvg.attr)(hit, {
            width: element.width,
            height: element.height
        });
        return hit;
    };
    this.fire = fire;
    this.triggerMouseEvent = triggerMouseEvent;
    this.mouseHandler = mouseHandler;
    this.registerEvent = registerEvent;
    this.unregisterEvent = unregisterEvent;
}
InteractionEvents.$inject = [
    'eventBus',
    'elementRegistry',
    'styles'
]; /**
 * An event indicating that the mouse hovered over an element
 *
 * @event element.hover
 *
 * @type {Object}
 * @property {Base} element
 * @property {SVGElement} gfx
 * @property {Event} originalEvent
 */  /**
 * An event indicating that the mouse has left an element
 *
 * @event element.out
 *
 * @type {Object}
 * @property {Base} element
 * @property {SVGElement} gfx
 * @property {Event} originalEvent
 */  /**
 * An event indicating that the mouse has clicked an element
 *
 * @event element.click
 *
 * @type {Object}
 * @property {Base} element
 * @property {SVGElement} gfx
 * @property {Event} originalEvent
 */  /**
 * An event indicating that the mouse has double clicked an element
 *
 * @event element.dblclick
 *
 * @type {Object}
 * @property {Base} element
 * @property {SVGElement} gfx
 * @property {Event} originalEvent
 */  /**
 * An event indicating that the mouse has gone down on an element.
 *
 * @event element.mousedown
 *
 * @type {Object}
 * @property {Base} element
 * @property {SVGElement} gfx
 * @property {Event} originalEvent
 */  /**
 * An event indicating that the mouse has gone up on an element.
 *
 * @event element.mouseup
 *
 * @type {Object}
 * @property {Base} element
 * @property {SVGElement} gfx
 * @property {Event} originalEvent
 */  /**
 * An event indicating that the context menu action is triggered
 * via mouse or touch controls.
 *
 * @event element.contextmenu
 *
 * @type {Object}
 * @property {Base} element
 * @property {SVGElement} gfx
 * @property {Event} originalEvent
 */ 

},{"min-dash":"aEEla","min-dom":"e58GC","../../util/Mouse":"9MyMy","tiny-svg":"6ZtXA","../../util/RenderUtil":"iDpuc","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9MyMy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isMac", ()=>(0, _platform.isMac));
parcelHelpers.export(exports, "isButton", ()=>isButton);
parcelHelpers.export(exports, "isPrimaryButton", ()=>isPrimaryButton);
parcelHelpers.export(exports, "isAuxiliaryButton", ()=>isAuxiliaryButton);
parcelHelpers.export(exports, "isSecondaryButton", ()=>isSecondaryButton);
parcelHelpers.export(exports, "hasPrimaryModifier", ()=>hasPrimaryModifier);
parcelHelpers.export(exports, "hasSecondaryModifier", ()=>hasSecondaryModifier);
var _event = require("./Event");
var _platform = require("./Platform");
function isButton(event, button) {
    return ((0, _event.getOriginal)(event) || event).button === button;
}
function isPrimaryButton(event) {
    // button === 0 -> left áka primary mouse button
    return isButton(event, 0);
}
function isAuxiliaryButton(event) {
    // button === 1 -> auxiliary áka wheel button
    return isButton(event, 1);
}
function isSecondaryButton(event) {
    // button === 2 -> right áka secondary button
    return isButton(event, 2);
}
function hasPrimaryModifier(event) {
    var originalEvent = (0, _event.getOriginal)(event) || event;
    if (!isPrimaryButton(event)) return false;
    // Use cmd as primary modifier key for mac OS
    if ((0, _platform.isMac)()) return originalEvent.metaKey;
    else return originalEvent.ctrlKey;
}
function hasSecondaryModifier(event) {
    var originalEvent = (0, _event.getOriginal)(event) || event;
    return isPrimaryButton(event) && originalEvent.shiftKey;
}

},{"./Event":"a3pF2","./Platform":"dpQ0E","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"a3pF2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getOriginal", ()=>getOriginal);
parcelHelpers.export(exports, "stopPropagation", ()=>stopPropagation);
parcelHelpers.export(exports, "toPoint", ()=>toPoint);
function __stopPropagation(event) {
    if (!event || typeof event.stopPropagation !== 'function') return;
    event.stopPropagation();
}
function getOriginal(event) {
    return event.originalEvent || event.srcEvent;
}
function stopPropagation(event, immediate) {
    __stopPropagation(event, immediate);
    __stopPropagation(getOriginal(event), immediate);
}
function toPoint(event) {
    if (event.pointers && event.pointers.length) event = event.pointers[0];
    if (event.touches && event.touches.length) event = event.touches[0];
    return event ? {
        x: event.clientX,
        y: event.clientY
    } : null;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dpQ0E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isMac", ()=>isMac);
function isMac() {
    return /mac/i.test(navigator.platform);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2Z6Dm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _outline = require("./Outline");
var _outlineDefault = parcelHelpers.interopDefault(_outline);
exports.default = {
    __init__: [
        'outline'
    ],
    outline: [
        'type',
        (0, _outlineDefault.default)
    ]
};

},{"./Outline":"9K0qh","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9K0qh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Outline);
var _elements = require("../../util/Elements");
var _tinySvg = require("tiny-svg");
var _minDom = require("min-dom");
var _minDash = require("min-dash");
var LOW_PRIORITY = 500;
function Outline(eventBus, styles) {
    this.offset = 6;
    var OUTLINE_STYLE = styles.cls('djs-outline', [
        'no-fill'
    ]);
    var self = this;
    function createOutline(gfx, bounds) {
        var outline = (0, _tinySvg.create)('rect');
        (0, _tinySvg.attr)(outline, (0, _minDash.assign)({
            x: 10,
            y: 10,
            rx: 4,
            width: 100,
            height: 100
        }, OUTLINE_STYLE));
        (0, _tinySvg.append)(gfx, outline);
        return outline;
    }
    // A low priortity is necessary, because outlines of labels have to be updated
    // after the label bounds have been updated in the renderer.
    eventBus.on([
        'shape.added',
        'shape.changed'
    ], LOW_PRIORITY, function(event) {
        var element = event.element, gfx = event.gfx;
        var outline = (0, _minDom.query)('.djs-outline', gfx);
        if (!outline) outline = createOutline(gfx, element);
        self.updateShapeOutline(outline, element);
    });
    eventBus.on([
        'connection.added',
        'connection.changed'
    ], function(event) {
        var element = event.element, gfx = event.gfx;
        var outline = (0, _minDom.query)('.djs-outline', gfx);
        if (!outline) outline = createOutline(gfx, element);
        self.updateConnectionOutline(outline, element);
    });
}
/**
 * Updates the outline of a shape respecting the dimension of the
 * element and an outline offset.
 *
 * @param {SVGElement} outline
 * @param {Base} element
 */ Outline.prototype.updateShapeOutline = function(outline, element) {
    (0, _tinySvg.attr)(outline, {
        x: -this.offset,
        y: -this.offset,
        width: element.width + this.offset * 2,
        height: element.height + this.offset * 2
    });
};
/**
 * Updates the outline of a connection respecting the bounding box of
 * the connection and an outline offset.
 *
 * @param {SVGElement} outline
 * @param {Base} element
 */ Outline.prototype.updateConnectionOutline = function(outline, connection) {
    var bbox = (0, _elements.getBBox)(connection);
    (0, _tinySvg.attr)(outline, {
        x: bbox.x - this.offset,
        y: bbox.y - this.offset,
        width: bbox.width + this.offset * 2,
        height: bbox.height + this.offset * 2
    });
};
Outline.$inject = [
    'eventBus',
    'styles',
    'elementRegistry'
];

},{"../../util/Elements":"6qdtl","tiny-svg":"6ZtXA","min-dom":"e58GC","min-dash":"aEEla","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"37kpR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Selection);
var _minDash = require("min-dash");
function Selection(eventBus, canvas) {
    this._eventBus = eventBus;
    this._canvas = canvas;
    this._selectedElements = [];
    var self = this;
    eventBus.on([
        'shape.remove',
        'connection.remove'
    ], function(e) {
        var element = e.element;
        self.deselect(element);
    });
    eventBus.on([
        'diagram.clear',
        'root.set'
    ], function(e) {
        self.select(null);
    });
}
Selection.$inject = [
    'eventBus',
    'canvas'
];
Selection.prototype.deselect = function(element) {
    var selectedElements = this._selectedElements;
    var idx = selectedElements.indexOf(element);
    if (idx !== -1) {
        var oldSelection = selectedElements.slice();
        selectedElements.splice(idx, 1);
        this._eventBus.fire('selection.changed', {
            oldSelection: oldSelection,
            newSelection: selectedElements
        });
    }
};
Selection.prototype.get = function() {
    return this._selectedElements;
};
Selection.prototype.isSelected = function(element) {
    return this._selectedElements.indexOf(element) !== -1;
};
/**
 * This method selects one or more elements on the diagram.
 *
 * By passing an additional add parameter you can decide whether or not the element(s)
 * should be added to the already existing selection or not.
 *
 * @method Selection#select
 *
 * @param {Object|Object[]} elements element or array of elements to be selected
 * @param {boolean} [add] whether the element(s) should be appended to the current selection, defaults to false
 */ Selection.prototype.select = function(elements, add) {
    var selectedElements = this._selectedElements, oldSelection = selectedElements.slice();
    if (!(0, _minDash.isArray)(elements)) elements = elements ? [
        elements
    ] : [];
    var canvas = this._canvas;
    var rootElement = canvas.getRootElement();
    elements = elements.filter(function(element) {
        var elementRoot = canvas.findRoot(element);
        return rootElement === elementRoot;
    });
    // selection may be cleared by passing an empty array or null
    // to the method
    if (add) (0, _minDash.forEach)(elements, function(element) {
        if (selectedElements.indexOf(element) !== -1) // already selected
        return;
        else selectedElements.push(element);
    });
    else this._selectedElements = selectedElements = elements.slice();
    this._eventBus.fire('selection.changed', {
        oldSelection: oldSelection,
        newSelection: selectedElements
    });
};

},{"min-dash":"aEEla","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"d0Hyj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SelectionVisuals);
var _minDash = require("min-dash");
var _tinySvg = require("tiny-svg");
var _elements = require("../../util/Elements");
/**
 * @typedef {import('../../core/Canvas').default} Canvas
 * @typedef {import('../../core/EventBus').default} EventBus
 * @typedef {import('./Selection').default} Selection
 */ var MARKER_HOVER = 'hover', MARKER_SELECTED = 'selected';
var SELECTION_OUTLINE_PADDING = 6;
function SelectionVisuals(canvas, eventBus, selection) {
    this._canvas = canvas;
    var self = this;
    this._multiSelectionBox = null;
    function addMarker(e, cls) {
        canvas.addMarker(e, cls);
    }
    function removeMarker(e, cls) {
        canvas.removeMarker(e, cls);
    }
    eventBus.on('element.hover', function(event) {
        addMarker(event.element, MARKER_HOVER);
    });
    eventBus.on('element.out', function(event) {
        removeMarker(event.element, MARKER_HOVER);
    });
    eventBus.on('selection.changed', function(event) {
        function deselect(s) {
            removeMarker(s, MARKER_SELECTED);
        }
        function select(s) {
            addMarker(s, MARKER_SELECTED);
        }
        var oldSelection = event.oldSelection, newSelection = event.newSelection;
        (0, _minDash.forEach)(oldSelection, function(e) {
            if (newSelection.indexOf(e) === -1) deselect(e);
        });
        (0, _minDash.forEach)(newSelection, function(e) {
            if (oldSelection.indexOf(e) === -1) select(e);
        });
        self._updateSelectionOutline(newSelection);
    });
    eventBus.on('element.changed', function(event) {
        if (selection.isSelected(event.element)) self._updateSelectionOutline(selection.get());
    });
}
SelectionVisuals.$inject = [
    'canvas',
    'eventBus',
    'selection'
];
SelectionVisuals.prototype._updateSelectionOutline = function(selection) {
    var layer = this._canvas.getLayer('selectionOutline');
    (0, _tinySvg.clear)(layer);
    var enabled = selection.length > 1;
    var container = this._canvas.getContainer();
    (0, _tinySvg.classes)(container)[enabled ? 'add' : 'remove']('djs-multi-select');
    if (!enabled) return;
    var bBox = addSelectionOutlinePadding((0, _elements.getBBox)(selection));
    var rect = (0, _tinySvg.create)('rect');
    (0, _tinySvg.attr)(rect, (0, _minDash.assign)({
        rx: 3
    }, bBox));
    (0, _tinySvg.classes)(rect).add('djs-selection-outline');
    (0, _tinySvg.append)(layer, rect);
};
// helpers //////////
function addSelectionOutlinePadding(bBox) {
    return {
        x: bBox.x - SELECTION_OUTLINE_PADDING,
        y: bBox.y - SELECTION_OUTLINE_PADDING,
        width: bBox.width + SELECTION_OUTLINE_PADDING * 2,
        height: bBox.height + SELECTION_OUTLINE_PADDING * 2
    };
}

},{"min-dash":"aEEla","tiny-svg":"6ZtXA","../../util/Elements":"6qdtl","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gWQGO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SelectionBehavior);
var _mouse = require("../../util/Mouse");
var _minDash = require("min-dash");
function SelectionBehavior(eventBus, selection, canvas, elementRegistry) {
    // Select elements on create
    eventBus.on('create.end', 500, function(event) {
        var context = event.context, canExecute = context.canExecute, elements = context.elements, hints = context.hints || {}, autoSelect = hints.autoSelect;
        if (canExecute) {
            if (autoSelect === false) // Select no elements
            return;
            if ((0, _minDash.isArray)(autoSelect)) selection.select(autoSelect);
            else // Select all elements by default
            selection.select(elements.filter(isShown));
        }
    });
    // Select connection targets on connect
    eventBus.on('connect.end', 500, function(event) {
        var context = event.context, connection = context.connection;
        if (connection) selection.select(connection);
    });
    // Select shapes on move
    eventBus.on('shape.move.end', 500, function(event) {
        var previousSelection = event.previousSelection || [];
        var shape = elementRegistry.get(event.context.shape.id);
        // Always select main shape on move
        var isSelected = (0, _minDash.find)(previousSelection, function(selectedShape) {
            return shape.id === selectedShape.id;
        });
        if (!isSelected) selection.select(shape);
    });
    // Select elements on click
    eventBus.on('element.click', function(event) {
        if (!(0, _mouse.isPrimaryButton)(event)) return;
        var element = event.element;
        if (element === canvas.getRootElement()) element = null;
        var isSelected = selection.isSelected(element), isMultiSelect = selection.get().length > 1;
        // Add to selection if CTRL or SHIFT pressed
        var add = (0, _mouse.hasPrimaryModifier)(event) || (0, _mouse.hasSecondaryModifier)(event);
        if (isSelected && isMultiSelect) {
            if (add) // Deselect element
            return selection.deselect(element);
            else // Select element only
            return selection.select(element);
        } else if (!isSelected) // Select element
        selection.select(element, add);
        else // Deselect element
        selection.deselect(element);
    });
}
SelectionBehavior.$inject = [
    'eventBus',
    'selection',
    'canvas',
    'elementRegistry'
];
function isShown(element) {
    return !element.hidden;
}

},{"../../util/Mouse":"9MyMy","min-dash":"aEEla","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cLFz9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _overlays = require("./Overlays");
var _overlaysDefault = parcelHelpers.interopDefault(_overlays);
exports.default = {
    __init__: [
        'overlays'
    ],
    overlays: [
        'type',
        (0, _overlaysDefault.default)
    ]
};

},{"./Overlays":"gSF1h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gSF1h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Overlays);
var _minDash = require("min-dash");
var _minDom = require("min-dom");
var _elements = require("../../util/Elements");
var _idGenerator = require("../../util/IdGenerator");
var _idGeneratorDefault = parcelHelpers.interopDefault(_idGenerator);
// document wide unique overlay ids
var ids = new (0, _idGeneratorDefault.default)('ov');
var LOW_PRIORITY = 500;
function Overlays(config, eventBus, canvas, elementRegistry) {
    this._eventBus = eventBus;
    this._canvas = canvas;
    this._elementRegistry = elementRegistry;
    this._ids = ids;
    /**
   * @type {OverlaysConfigDefault}
   */ this._overlayDefaults = (0, _minDash.assign)({
        // no show constraints
        show: null,
        // always scale
        scale: true
    }, config && config.defaults);
    /**
   * @type {Map<string, Overlay>}
   */ this._overlays = {};
    /**
   * @type {OverlayContainer[]}
   */ this._overlayContainers = [];
    /**
   * @type {HTMLElement}
   */ this._overlayRoot = createRoot(canvas.getContainer());
    this._init();
}
Overlays.$inject = [
    'config.overlays',
    'eventBus',
    'canvas',
    'elementRegistry'
];
/**
 * Returns the overlay with the specified ID or a list of overlays
 * for an element with a given type.
 *
 * @example
 *
 * // return the single overlay with the given ID
 * overlays.get('some-id');
 *
 * // return all overlays for the shape
 * overlays.get({ element: someShape });
 *
 * // return all overlays on shape with type 'badge'
 * overlays.get({ element: someShape, type: 'badge' });
 *
 * // shape can also be specified as ID
 * overlays.get({ element: 'element-id', type: 'badge' });
 *
 * @param {OverlaysFilter} search The filter to be used to find the overlay(s).
 *
 * @return {Overlay|Overlay[]} The overlay(s).
 */ Overlays.prototype.get = function(search) {
    if ((0, _minDash.isString)(search)) search = {
        id: search
    };
    if ((0, _minDash.isString)(search.element)) search.element = this._elementRegistry.get(search.element);
    if (search.element) {
        var container = this._getOverlayContainer(search.element, true);
        // return a list of overlays when searching by element (+type)
        if (container) return search.type ? (0, _minDash.filter)(container.overlays, (0, _minDash.matchPattern)({
            type: search.type
        })) : container.overlays.slice();
        else return [];
    } else if (search.type) return (0, _minDash.filter)(this._overlays, (0, _minDash.matchPattern)({
        type: search.type
    }));
    else // return single element when searching by id
    return search.id ? this._overlays[search.id] : null;
};
/**
 * Adds an HTML overlay to an element.
 *
 * @param {Base|string} element The element to add the overlay to.
 * @param {string} [type] An optional type that can be used to filter.
 * @param {OverlayAttrs} overlay The overlay.
 *
 * @return {string} The overlay's ID that can be used to get or remove it.
 */ Overlays.prototype.add = function(element, type, overlay) {
    if ((0, _minDash.isObject)(type)) {
        overlay = type;
        type = null;
    }
    if (!element.id) element = this._elementRegistry.get(element);
    if (!overlay.position) throw new Error('must specifiy overlay position');
    if (!overlay.html) throw new Error('must specifiy overlay html');
    if (!element) throw new Error('invalid element specified');
    var id = this._ids.next();
    overlay = (0, _minDash.assign)({}, this._overlayDefaults, overlay, {
        id: id,
        type: type,
        element: element,
        html: overlay.html
    });
    this._addOverlay(overlay);
    return id;
};
/**
 * Remove an overlay with the given ID or all overlays matching the given filter.
 *
 * @see Overlays#get for filter options.
 *
 * @param {OverlaysFilter} filter The filter to be used to find the overlay.
 */ Overlays.prototype.remove = function(filter) {
    var overlays = this.get(filter) || [];
    if (!(0, _minDash.isArray)(overlays)) overlays = [
        overlays
    ];
    var self = this;
    (0, _minDash.forEach)(overlays, function(overlay) {
        var container = self._getOverlayContainer(overlay.element, true);
        if (overlay) {
            (0, _minDom.remove)(overlay.html);
            (0, _minDom.remove)(overlay.htmlContainer);
            delete overlay.htmlContainer;
            delete overlay.element;
            delete self._overlays[overlay.id];
        }
        if (container) {
            var idx = container.overlays.indexOf(overlay);
            if (idx !== -1) container.overlays.splice(idx, 1);
        }
    });
};
/**
 * Checks whether overlays are shown.
 *
 * @returns {boolean} Whether overlays are shown.
 */ Overlays.prototype.isShown = function() {
    return this._overlayRoot.style.display !== 'none';
};
/**
 * Show all overlays.
 */ Overlays.prototype.show = function() {
    setVisible(this._overlayRoot);
};
/**
 * Hide all overlays.
 */ Overlays.prototype.hide = function() {
    setVisible(this._overlayRoot, false);
};
/**
 * Remove all overlays and their container.
 */ Overlays.prototype.clear = function() {
    this._overlays = {};
    this._overlayContainers = [];
    (0, _minDom.clear)(this._overlayRoot);
};
Overlays.prototype._updateOverlayContainer = function(container) {
    var element = container.element, html = container.html;
    // update container left,top according to the elements x,y coordinates
    // this ensures we can attach child elements relative to this container
    var x = element.x, y = element.y;
    if (element.waypoints) {
        var bbox = (0, _elements.getBBox)(element);
        x = bbox.x;
        y = bbox.y;
    }
    setPosition(html, x, y);
    (0, _minDom.attr)(container.html, 'data-container-id', element.id);
};
Overlays.prototype._updateOverlay = function(overlay) {
    var position = overlay.position, htmlContainer = overlay.htmlContainer, element = overlay.element;
    // update overlay html relative to shape because
    // it is already positioned on the element
    // update relative
    var left = position.left, top = position.top;
    if (position.right !== undefined) {
        var width;
        if (element.waypoints) width = (0, _elements.getBBox)(element).width;
        else width = element.width;
        left = position.right * -1 + width;
    }
    if (position.bottom !== undefined) {
        var height;
        if (element.waypoints) height = (0, _elements.getBBox)(element).height;
        else height = element.height;
        top = position.bottom * -1 + height;
    }
    setPosition(htmlContainer, left || 0, top || 0);
    this._updateOverlayVisibilty(overlay, this._canvas.viewbox());
};
Overlays.prototype._createOverlayContainer = function(element) {
    var html = (0, _minDom.domify)('<div class="djs-overlays" />');
    (0, _minDom.assignStyle)(html, {
        position: 'absolute'
    });
    this._overlayRoot.appendChild(html);
    var container = {
        html: html,
        element: element,
        overlays: []
    };
    this._updateOverlayContainer(container);
    this._overlayContainers.push(container);
    return container;
};
Overlays.prototype._updateRoot = function(viewbox) {
    var scale = viewbox.scale || 1;
    var matrix = 'matrix(' + [
        scale,
        0,
        0,
        scale,
        -1 * viewbox.x * scale,
        -1 * viewbox.y * scale
    ].join(',') + ')';
    setTransform(this._overlayRoot, matrix);
};
Overlays.prototype._getOverlayContainer = function(element, raw) {
    var container = (0, _minDash.find)(this._overlayContainers, function(c) {
        return c.element === element;
    });
    if (!container && !raw) return this._createOverlayContainer(element);
    return container;
};
Overlays.prototype._addOverlay = function(overlay) {
    var id = overlay.id, element = overlay.element, html = overlay.html, htmlContainer, overlayContainer;
    // unwrap jquery (for those who need it)
    if (html.get && html.constructor.prototype.jquery) html = html.get(0);
    // create proper html elements from
    // overlay HTML strings
    if ((0, _minDash.isString)(html)) html = (0, _minDom.domify)(html);
    overlayContainer = this._getOverlayContainer(element);
    htmlContainer = (0, _minDom.domify)('<div class="djs-overlay" data-overlay-id="' + id + '">');
    (0, _minDom.assignStyle)(htmlContainer, {
        position: 'absolute'
    });
    htmlContainer.appendChild(html);
    if (overlay.type) (0, _minDom.classes)(htmlContainer).add('djs-overlay-' + overlay.type);
    var elementRoot = this._canvas.findRoot(element);
    var activeRoot = this._canvas.getRootElement();
    setVisible(htmlContainer, elementRoot === activeRoot);
    overlay.htmlContainer = htmlContainer;
    overlayContainer.overlays.push(overlay);
    overlayContainer.html.appendChild(htmlContainer);
    this._overlays[id] = overlay;
    this._updateOverlay(overlay);
    this._updateOverlayVisibilty(overlay, this._canvas.viewbox());
};
Overlays.prototype._updateOverlayVisibilty = function(overlay, viewbox) {
    var show = overlay.show, rootElement = this._canvas.findRoot(overlay.element), minZoom = show && show.minZoom, maxZoom = show && show.maxZoom, htmlContainer = overlay.htmlContainer, activeRootElement = this._canvas.getRootElement(), visible = true;
    if (rootElement !== activeRootElement) visible = false;
    else if (show) {
        if ((0, _minDash.isDefined)(minZoom) && minZoom > viewbox.scale || (0, _minDash.isDefined)(maxZoom) && maxZoom < viewbox.scale) visible = false;
    }
    setVisible(htmlContainer, visible);
    this._updateOverlayScale(overlay, viewbox);
};
Overlays.prototype._updateOverlayScale = function(overlay, viewbox) {
    var shouldScale = overlay.scale, minScale, maxScale, htmlContainer = overlay.htmlContainer;
    var scale, transform = '';
    if (shouldScale !== true) {
        if (shouldScale === false) {
            minScale = 1;
            maxScale = 1;
        } else {
            minScale = shouldScale.min;
            maxScale = shouldScale.max;
        }
        if ((0, _minDash.isDefined)(minScale) && viewbox.scale < minScale) scale = (1 / viewbox.scale || 1) * minScale;
        if ((0, _minDash.isDefined)(maxScale) && viewbox.scale > maxScale) scale = (1 / viewbox.scale || 1) * maxScale;
    }
    if ((0, _minDash.isDefined)(scale)) transform = 'scale(' + scale + ',' + scale + ')';
    setTransform(htmlContainer, transform);
};
Overlays.prototype._updateOverlaysVisibilty = function(viewbox) {
    var self = this;
    (0, _minDash.forEach)(this._overlays, function(overlay) {
        self._updateOverlayVisibilty(overlay, viewbox);
    });
};
Overlays.prototype._init = function() {
    var eventBus = this._eventBus;
    var self = this;
    // scroll/zoom integration
    function updateViewbox(viewbox) {
        self._updateRoot(viewbox);
        self._updateOverlaysVisibilty(viewbox);
        self.show();
    }
    eventBus.on('canvas.viewbox.changing', function(event) {
        self.hide();
    });
    eventBus.on('canvas.viewbox.changed', function(event) {
        updateViewbox(event.viewbox);
    });
    // remove integration
    eventBus.on([
        'shape.remove',
        'connection.remove'
    ], function(e) {
        var element = e.element;
        var overlays = self.get({
            element: element
        });
        (0, _minDash.forEach)(overlays, function(o) {
            self.remove(o.id);
        });
        var container = self._getOverlayContainer(element);
        if (container) {
            (0, _minDom.remove)(container.html);
            var i = self._overlayContainers.indexOf(container);
            if (i !== -1) self._overlayContainers.splice(i, 1);
        }
    });
    // move integration
    eventBus.on('element.changed', LOW_PRIORITY, function(e) {
        var element = e.element;
        var container = self._getOverlayContainer(element, true);
        if (container) {
            (0, _minDash.forEach)(container.overlays, function(overlay) {
                self._updateOverlay(overlay);
            });
            self._updateOverlayContainer(container);
        }
    });
    // marker integration, simply add them on the overlays as classes, too.
    eventBus.on('element.marker.update', function(e) {
        var container = self._getOverlayContainer(e.element, true);
        if (container) (0, _minDom.classes)(container.html)[e.add ? 'add' : 'remove'](e.marker);
    });
    eventBus.on('root.set', function() {
        self._updateOverlaysVisibilty(self._canvas.viewbox());
    });
    // clear overlays with diagram
    eventBus.on('diagram.clear', this.clear, this);
};
// helpers /////////////////////////////
function createRoot(parentNode) {
    var root = (0, _minDom.domify)('<div class="djs-overlay-container" />');
    (0, _minDom.assignStyle)(root, {
        position: 'absolute',
        width: 0,
        height: 0
    });
    parentNode.insertBefore(root, parentNode.firstChild);
    return root;
}
function setPosition(el, x, y) {
    (0, _minDom.assignStyle)(el, {
        left: x + 'px',
        top: y + 'px'
    });
}
/**
 * Set element visible
 *
 * @param {DOMElement} el
 * @param {boolean} [visible=true]
 */ function setVisible(el, visible) {
    el.style.display = visible === false ? 'none' : '';
}
function setTransform(el, transform) {
    el.style['transform-origin'] = 'top left';
    [
        '',
        '-ms-',
        '-webkit-'
    ].forEach(function(prefix) {
        el.style[prefix + 'transform'] = transform;
    });
}

},{"min-dash":"aEEla","min-dom":"e58GC","../../util/Elements":"6qdtl","../../util/IdGenerator":"bN4m6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bN4m6":[function(require,module,exports,__globalThis) {
/**
 * Util that provides unique IDs.
 *
 * @class
 * @constructor
 *
 * The ids can be customized via a given prefix and contain a random value to avoid collisions.
 *
 * @param {string} prefix a prefix to prepend to generated ids (for better readability)
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>IdGenerator);
function IdGenerator(prefix) {
    this._counter = 0;
    this._prefix = (prefix ? prefix + '-' : '') + Math.floor(Math.random() * 1000000000) + '-';
}
/**
 * Returns a next unique ID.
 *
 * @returns {string} the id
 */ IdGenerator.prototype.next = function() {
    return this._prefix + ++this._counter;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kXNiS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _overlays = require("diagram-js/lib/features/overlays");
var _overlaysDefault = parcelHelpers.interopDefault(_overlays);
var _changeSupport = require("diagram-js/lib/features/change-support");
var _changeSupportDefault = parcelHelpers.interopDefault(_changeSupport);
var _rootElements = require("diagram-js/lib/features/root-elements");
var _rootElementsDefault = parcelHelpers.interopDefault(_rootElements);
var _drilldownBreadcrumbs = require("./DrilldownBreadcrumbs");
var _drilldownBreadcrumbsDefault = parcelHelpers.interopDefault(_drilldownBreadcrumbs);
var _drilldownCentering = require("./DrilldownCentering");
var _drilldownCenteringDefault = parcelHelpers.interopDefault(_drilldownCentering);
var _subprocessCompatibility = require("./SubprocessCompatibility");
var _subprocessCompatibilityDefault = parcelHelpers.interopDefault(_subprocessCompatibility);
var _drilldownOverlayBehavior = require("./DrilldownOverlayBehavior");
var _drilldownOverlayBehaviorDefault = parcelHelpers.interopDefault(_drilldownOverlayBehavior);
exports.default = {
    __depends__: [
        (0, _overlaysDefault.default),
        (0, _changeSupportDefault.default),
        (0, _rootElementsDefault.default)
    ],
    __init__: [
        'drilldownBreadcrumbs',
        'drilldownOverlayBehavior',
        'drilldownCentering',
        'subprocessCompatibility'
    ],
    drilldownBreadcrumbs: [
        'type',
        (0, _drilldownBreadcrumbsDefault.default)
    ],
    drilldownCentering: [
        'type',
        (0, _drilldownCenteringDefault.default)
    ],
    drilldownOverlayBehavior: [
        'type',
        (0, _drilldownOverlayBehaviorDefault.default)
    ],
    subprocessCompatibility: [
        'type',
        (0, _subprocessCompatibilityDefault.default)
    ]
};

},{"diagram-js/lib/features/overlays":"cLFz9","diagram-js/lib/features/change-support":"jBptz","diagram-js/lib/features/root-elements":"bU4jM","./DrilldownBreadcrumbs":"2bWIF","./DrilldownCentering":"dGh3l","./SubprocessCompatibility":"kfjRf","./DrilldownOverlayBehavior":"3ZlZA","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jBptz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _changeSupport = require("./ChangeSupport");
var _changeSupportDefault = parcelHelpers.interopDefault(_changeSupport);
exports.default = {
    __init__: [
        'changeSupport'
    ],
    changeSupport: [
        'type',
        (0, _changeSupportDefault.default)
    ]
};

},{"./ChangeSupport":"3izPD","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3izPD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ChangeSupport);
var _elements = require("../../util/Elements");
function ChangeSupport(eventBus, canvas, elementRegistry, graphicsFactory) {
    // redraw shapes / connections on change
    eventBus.on('element.changed', function(event) {
        var element = event.element;
        // element might have been deleted and replaced by new element with same ID
        // thus check for parent of element except for root element
        if (element.parent || element === canvas.getRootElement()) event.gfx = elementRegistry.getGraphics(element);
        // shape + gfx may have been deleted
        if (!event.gfx) return;
        eventBus.fire((0, _elements.getType)(element) + '.changed', event);
    });
    eventBus.on('elements.changed', function(event) {
        var elements = event.elements;
        elements.forEach(function(e) {
            eventBus.fire('element.changed', {
                element: e
            });
        });
        graphicsFactory.updateContainments(elements);
    });
    eventBus.on('shape.changed', function(event) {
        graphicsFactory.update('shape', event.element, event.gfx);
    });
    eventBus.on('connection.changed', function(event) {
        graphicsFactory.update('connection', event.element, event.gfx);
    });
}
ChangeSupport.$inject = [
    'eventBus',
    'canvas',
    'elementRegistry',
    'graphicsFactory'
];

},{"../../util/Elements":"6qdtl","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bU4jM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rootElementsBehavior = require("./RootElementsBehavior");
var _rootElementsBehaviorDefault = parcelHelpers.interopDefault(_rootElementsBehavior);
exports.default = {
    __init__: [
        'rootElementsBehavior'
    ],
    rootElementsBehavior: [
        'type',
        (0, _rootElementsBehaviorDefault.default)
    ]
};

},{"./RootElementsBehavior":"ftV8X","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ftV8X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>RootElementsBehavior);
var _inheritsBrowser = require("inherits-browser");
var _inheritsBrowserDefault = parcelHelpers.interopDefault(_inheritsBrowser);
var _commandInterceptor = require("../../command/CommandInterceptor");
var _commandInterceptorDefault = parcelHelpers.interopDefault(_commandInterceptor);
function RootElementsBehavior(canvas, injector) {
    injector.invoke((0, _commandInterceptorDefault.default), this);
    this.executed(function(event) {
        var context = event.context;
        if (context.rootElement) canvas.setRootElement(context.rootElement);
        else context.rootElement = canvas.getRootElement();
    });
    this.revert(function(event) {
        var context = event.context;
        if (context.rootElement) canvas.setRootElement(context.rootElement);
    });
}
(0, _inheritsBrowserDefault.default)(RootElementsBehavior, (0, _commandInterceptorDefault.default));
RootElementsBehavior.$inject = [
    'canvas',
    'injector'
];

},{"inherits-browser":"hymxq","../../command/CommandInterceptor":"1K1IQ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1K1IQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CommandInterceptor);
var _minDash = require("min-dash");
/**
 * @typedef {import('../core/EventBus').default} EventBus
 * @typedef {import(./CommandInterceptor).HandlerFunction} HandlerFunction
 * @typedef {import(./CommandInterceptor).ComposeHandlerFunction} ComposeHandlerFunction
 */ var DEFAULT_PRIORITY = 1000;
function CommandInterceptor(eventBus) {
    /**
   * @type {EventBus}
   */ this._eventBus = eventBus;
}
CommandInterceptor.$inject = [
    'eventBus'
];
function unwrapEvent(fn, that) {
    return function(event) {
        return fn.call(that || null, event.context, event.command, event);
    };
}
/**
   * Intercept a command during one of the phases.
   *
   * @param {string|string[]} [events] One or more commands to intercept.
   * @param {string} [hook] Phase during which to intercept command.
   * @param {number} [priority] Priority with which command will be intercepted.
   * @param {ComposeHandlerFunction|HandlerFunction} handlerFn Callback.
   * @param {boolean} [unwrap] Whether the event should be unwrapped.
   * @param {*} [that] `this` value the callback will be called with.
   */ CommandInterceptor.prototype.on = function(events, hook, priority, handlerFn, unwrap, that) {
    if ((0, _minDash.isFunction)(hook) || (0, _minDash.isNumber)(hook)) {
        that = unwrap;
        unwrap = handlerFn;
        handlerFn = priority;
        priority = hook;
        hook = null;
    }
    if ((0, _minDash.isFunction)(priority)) {
        that = unwrap;
        unwrap = handlerFn;
        handlerFn = priority;
        priority = DEFAULT_PRIORITY;
    }
    if ((0, _minDash.isObject)(unwrap)) {
        that = unwrap;
        unwrap = false;
    }
    if (!(0, _minDash.isFunction)(handlerFn)) throw new Error('handlerFn must be a function');
    if (!(0, _minDash.isArray)(events)) events = [
        events
    ];
    var eventBus = this._eventBus;
    (0, _minDash.forEach)(events, function(event) {
        // concat commandStack(.event)?(.hook)?
        var fullEvent = [
            'commandStack',
            event,
            hook
        ].filter(function(e) {
            return e;
        }).join('.');
        eventBus.on(fullEvent, priority, unwrap ? unwrapEvent(handlerFn, that) : handlerFn, that);
    });
};
var hooks = [
    'canExecute',
    'preExecute',
    'preExecuted',
    'execute',
    'executed',
    'postExecute',
    'postExecuted',
    'revert',
    'reverted'
];
/*
 * Add prototype methods for each phase of command execution (e.g. execute,
 * revert).
 */ (0, _minDash.forEach)(hooks, function(hook) {
    /**
   * Add prototype method for a specific phase of command execution.
   *
   * @param {string|string[]} [events] One or more commands to intercept.
   * @param {number} [priority] Priority with which command will be intercepted.
   * @param {ComposeHandlerFunction|HandlerFunction} handlerFn Callback.
   * @param {boolean} [unwrap] Whether the event should be unwrapped.
   * @param {*} [that] `this` value the callback will be called with.
   */ CommandInterceptor.prototype[hook] = function(events, priority, handlerFn, unwrap, that) {
        if ((0, _minDash.isFunction)(events) || (0, _minDash.isNumber)(events)) {
            that = unwrap;
            unwrap = handlerFn;
            handlerFn = priority;
            priority = events;
            events = null;
        }
        this.on(events, hook, priority, handlerFn, unwrap, that);
    };
});

},{"min-dash":"aEEla","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2bWIF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DrilldownBreadcrumbs);
var _minDom = require("min-dom");
var _minDash = require("min-dash");
var _escapeUtil = require("diagram-js/lib/util/EscapeUtil");
var _modelUtil = require("../../util/ModelUtil");
var _drilldownUtil = require("../../util/DrilldownUtil");
var OPEN_CLASS = 'bjs-breadcrumbs-shown';
function DrilldownBreadcrumbs(eventBus, elementRegistry, overlays, canvas) {
    var breadcrumbs = (0, _minDom.domify)('<ul class="bjs-breadcrumbs"></ul>');
    var container = canvas.getContainer();
    var containerClasses = (0, _minDom.classes)(container);
    container.appendChild(breadcrumbs);
    var boParents = [];
    // update breadcrumbs if name or ID of the primary shape changes
    eventBus.on('element.changed', function(e) {
        var shape = e.element, bo = (0, _modelUtil.getBusinessObject)(shape);
        var isPresent = (0, _minDash.find)(boParents, function(el) {
            return el === bo;
        });
        if (!isPresent) return;
        updateBreadcrumbs();
    });
    /**
   * Updates the displayed breadcrumbs. If no element is provided, only the
   * labels are updated.
   *
   * @param {djs.model.Base} [element]
   */ function updateBreadcrumbs(element) {
        if (element) boParents = getBoParentChain(element);
        var path = boParents.map(function(parent) {
            var title = (0, _escapeUtil.escapeHTML)(parent.name || parent.id);
            var link = (0, _minDom.domify)('<li><span class="bjs-crumb"><a title="' + title + '">' + title + '</a></span></li>');
            var parentPlane = canvas.findRoot((0, _drilldownUtil.getPlaneIdFromShape)(parent)) || canvas.findRoot(parent.id);
            // when the root is a collaboration, the process does not have a corresponding
            // element in the elementRegisty. Instead, we search for the corresponding participant
            if (!parentPlane && (0, _modelUtil.is)(parent, 'bpmn:Process')) {
                var participant = elementRegistry.find(function(element) {
                    var bo = (0, _modelUtil.getBusinessObject)(element);
                    return bo && bo.processRef && bo.processRef === parent;
                });
                parentPlane = canvas.findRoot(participant.id);
            }
            link.addEventListener('click', function() {
                canvas.setRootElement(parentPlane);
            });
            return link;
        });
        breadcrumbs.innerHTML = '';
        // show breadcrumbs and expose state to .djs-container
        var visible = path.length > 1;
        containerClasses.toggle(OPEN_CLASS, visible);
        path.forEach(function(el) {
            breadcrumbs.appendChild(el);
        });
    }
    eventBus.on('root.set', function(event) {
        updateBreadcrumbs(event.element);
    });
}
DrilldownBreadcrumbs.$inject = [
    'eventBus',
    'elementRegistry',
    'overlays',
    'canvas'
];
// helpers //////////
/**
 * Returns the parents for the element using the business object chain,
 * starting with the root element.
 *
 * @param {djs.model.Shape} child
 *
 * @returns {Array<djs.model.Shape>} parents
 */ function getBoParentChain(child) {
    var bo = (0, _modelUtil.getBusinessObject)(child);
    var parents = [];
    for(var element = bo; element; element = element.$parent)if ((0, _modelUtil.is)(element, 'bpmn:SubProcess') || (0, _modelUtil.is)(element, 'bpmn:Process')) parents.push(element);
    return parents.reverse();
}

},{"min-dom":"e58GC","min-dash":"aEEla","diagram-js/lib/util/EscapeUtil":"kAkPb","../../util/ModelUtil":"klNYN","../../util/DrilldownUtil":"aMFv0","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kAkPb":[function(require,module,exports,__globalThis) {
/**
 * @param {string} str
 * @returns {string}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "escapeCSS", ()=>escapeCSS);
parcelHelpers.export(exports, "escapeHTML", ()=>escapeHTML);
function escapeCSS(str) {
    return CSS.escape(str);
}
var HTML_ESCAPE_MAP = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    '\'': '&#39;'
};
function escapeHTML(str) {
    str = '' + str;
    return str && str.replace(/[&<>"']/g, function(match) {
        return HTML_ESCAPE_MAP[match];
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aMFv0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "planeSuffix", ()=>planeSuffix);
/**
 * Get primary shape ID for a plane.
 *
 * @param  {djs.model.Base|ModdleElement} element
 *
 * @returns {String}
 */ parcelHelpers.export(exports, "getShapeIdFromPlane", ()=>getShapeIdFromPlane);
/**
 * Get plane ID for a primary shape.
 *
 * @param  {djs.model.Base|ModdleElement} element
 *
 * @returns {String}
 */ parcelHelpers.export(exports, "getPlaneIdFromShape", ()=>getPlaneIdFromShape);
/**
 * Get plane ID for primary shape ID.
 *
 * @param {String} id
 *
 * @returns {String}
 */ parcelHelpers.export(exports, "toPlaneId", ()=>toPlaneId);
/**
 * Check wether element is plane.
 *
 * @param  {djs.model.Base|ModdleElement} element
 *
 * @returns {Boolean}
 */ parcelHelpers.export(exports, "isPlane", ()=>isPlane);
var _modelUtil = require("./ModelUtil");
var planeSuffix = '_plane';
function getShapeIdFromPlane(element) {
    var id = element.id;
    return removePlaneSuffix(id);
}
function getPlaneIdFromShape(element) {
    var id = element.id;
    if ((0, _modelUtil.is)(element, 'bpmn:SubProcess')) return addPlaneSuffix(id);
    return id;
}
function toPlaneId(id) {
    return addPlaneSuffix(id);
}
function isPlane(element) {
    var di = (0, _modelUtil.getDi)(element);
    return (0, _modelUtil.is)(di, 'bpmndi:BPMNPlane');
}
function addPlaneSuffix(id) {
    return id + planeSuffix;
}
function removePlaneSuffix(id) {
    return id.replace(new RegExp(planeSuffix + '$'), '');
}

},{"./ModelUtil":"klNYN","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dGh3l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DrilldownCentering);
var _modelUtil = require("../../util/ModelUtil");
function DrilldownCentering(eventBus, canvas) {
    var currentRoot = null;
    var positionMap = new Map();
    eventBus.on('root.set', function(event) {
        var newRoot = event.element;
        var currentViewbox = canvas.viewbox();
        var storedViewbox = positionMap.get(newRoot);
        positionMap.set(currentRoot, {
            x: currentViewbox.x,
            y: currentViewbox.y,
            zoom: currentViewbox.scale
        });
        currentRoot = newRoot;
        // current root was replaced with a collaboration, we don't update the viewbox
        if ((0, _modelUtil.is)(newRoot, 'bpmn:Collaboration') && !storedViewbox) return;
        storedViewbox = storedViewbox || {
            x: 0,
            y: 0,
            zoom: 1
        };
        var dx = (currentViewbox.x - storedViewbox.x) * currentViewbox.scale, dy = (currentViewbox.y - storedViewbox.y) * currentViewbox.scale;
        if (dx !== 0 || dy !== 0) canvas.scroll({
            dx: dx,
            dy: dy
        });
        if (storedViewbox.zoom !== currentViewbox.scale) canvas.zoom(storedViewbox.zoom, {
            x: 0,
            y: 0
        });
    });
    eventBus.on('diagram.clear', function() {
        positionMap.clear();
        currentRoot = null;
    });
}
DrilldownCentering.$inject = [
    'eventBus',
    'canvas'
];
/**
 * ES5 Map implementation. Works.
 */ function Map() {
    this._entries = [];
    this.set = function(key, value) {
        var found = false;
        for(var k in this._entries)if (this._entries[k][0] === key) {
            this._entries[k][1] = value;
            found = true;
            break;
        }
        if (!found) this._entries.push([
            key,
            value
        ]);
    };
    this.get = function(key) {
        for(var k in this._entries){
            if (this._entries[k][0] === key) return this._entries[k][1];
        }
        return null;
    };
    this.clear = function() {
        this._entries.length = 0;
    };
    this.remove = function(key) {
        var idx = -1;
        for(var k in this._entries)if (this._entries[k][0] === key) {
            idx = k;
            break;
        }
        if (idx !== -1) this._entries.splice(idx, 1);
    };
}

},{"../../util/ModelUtil":"klNYN","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kfjRf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SubprocessCompatibility);
var _layoutUtil = require("diagram-js/lib/layout/LayoutUtil");
var _modelUtil = require("../../util/ModelUtil");
var DEFAULT_POSITION = {
    x: 180,
    y: 160
};
function SubprocessCompatibility(eventBus, moddle) {
    this._eventBus = eventBus;
    this._moddle = moddle;
    var self = this;
    eventBus.on('import.render.start', 1500, function(e, context) {
        self.handleImport(context.definitions);
    });
}
SubprocessCompatibility.prototype.handleImport = function(definitions) {
    if (!definitions.diagrams) return;
    var self = this;
    this._definitions = definitions;
    this._processToDiagramMap = {};
    definitions.diagrams.forEach(function(diagram) {
        if (!diagram.plane || !diagram.plane.bpmnElement) return;
        self._processToDiagramMap[diagram.plane.bpmnElement.id] = diagram;
    });
    var newDiagrams = [];
    definitions.diagrams.forEach(function(diagram) {
        var createdDiagrams = self.createNewDiagrams(diagram.plane);
        Array.prototype.push.apply(newDiagrams, createdDiagrams);
    });
    newDiagrams.forEach(function(diagram) {
        self.movePlaneElementsToOrigin(diagram.plane);
    });
};
/**
 * Moves all DI elements from collapsed subprocesses to a new plane.
 *
 * @param {Object} plane
 * @return {Array} new diagrams created for the collapsed subprocesses
 */ SubprocessCompatibility.prototype.createNewDiagrams = function(plane) {
    var self = this;
    var collapsedElements = [];
    var elementsToMove = [];
    plane.get('planeElement').forEach(function(diElement) {
        var bo = diElement.bpmnElement;
        if (!bo) return;
        var parent = bo.$parent;
        if ((0, _modelUtil.is)(bo, 'bpmn:SubProcess') && !diElement.isExpanded) collapsedElements.push(bo);
        if (shouldMoveToPlane(bo, plane)) // don't change the array while we iterate over it
        elementsToMove.push({
            diElement: diElement,
            parent: parent
        });
    });
    var newDiagrams = [];
    // create new planes for all collapsed subprocesses, even when they are empty
    collapsedElements.forEach(function(element) {
        if (!self._processToDiagramMap[element.id]) {
            var diagram = self.createDiagram(element);
            self._processToDiagramMap[element.id] = diagram;
            newDiagrams.push(diagram);
        }
    });
    elementsToMove.forEach(function(element) {
        var diElement = element.diElement;
        var parent = element.parent;
        // parent is expanded, get nearest collapsed parent
        while(parent && collapsedElements.indexOf(parent) === -1)parent = parent.$parent;
        // false positive, all parents are expanded
        if (!parent) return;
        var diagram = self._processToDiagramMap[parent.id];
        self.moveToDiPlane(diElement, diagram.plane);
    });
    return newDiagrams;
};
SubprocessCompatibility.prototype.movePlaneElementsToOrigin = function(plane) {
    var elements = plane.get('planeElement');
    // get bounding box of all elements
    var planeBounds = getPlaneBounds(plane);
    var offset = {
        x: planeBounds.x - DEFAULT_POSITION.x,
        y: planeBounds.y - DEFAULT_POSITION.y
    };
    elements.forEach(function(diElement) {
        if (diElement.waypoint) diElement.waypoint.forEach(function(waypoint) {
            waypoint.x = waypoint.x - offset.x;
            waypoint.y = waypoint.y - offset.y;
        });
        else if (diElement.bounds) {
            diElement.bounds.x = diElement.bounds.x - offset.x;
            diElement.bounds.y = diElement.bounds.y - offset.y;
        }
    });
};
SubprocessCompatibility.prototype.moveToDiPlane = function(diElement, newPlane) {
    var containingDiagram = findRootDiagram(diElement);
    // remove DI from old Plane and add it to the new one
    var parentPlaneElement = containingDiagram.plane.get('planeElement');
    parentPlaneElement.splice(parentPlaneElement.indexOf(diElement), 1);
    newPlane.get('planeElement').push(diElement);
};
SubprocessCompatibility.prototype.createDiagram = function(bo) {
    var plane = this._moddle.create('bpmndi:BPMNPlane', {
        bpmnElement: bo
    });
    var diagram = this._moddle.create('bpmndi:BPMNDiagram', {
        plane: plane
    });
    plane.$parent = diagram;
    plane.bpmnElement = bo;
    diagram.$parent = this._definitions;
    this._definitions.diagrams.push(diagram);
    return diagram;
};
SubprocessCompatibility.$inject = [
    'eventBus',
    'moddle'
];
// helpers //////////////////////////
function findRootDiagram(element) {
    if ((0, _modelUtil.is)(element, 'bpmndi:BPMNDiagram')) return element;
    else return findRootDiagram(element.$parent);
}
function getPlaneBounds(plane) {
    var planeTrbl = {
        top: Infinity,
        right: -Infinity,
        bottom: -Infinity,
        left: Infinity
    };
    plane.planeElement.forEach(function(element) {
        if (!element.bounds) return;
        var trbl = (0, _layoutUtil.asTRBL)(element.bounds);
        planeTrbl.top = Math.min(trbl.top, planeTrbl.top);
        planeTrbl.left = Math.min(trbl.left, planeTrbl.left);
    });
    return (0, _layoutUtil.asBounds)(planeTrbl);
}
function shouldMoveToPlane(bo, plane) {
    var parent = bo.$parent;
    // don't move elements that are already on the plane
    if (!(0, _modelUtil.is)(parent, 'bpmn:SubProcess') || parent === plane.bpmnElement) return false;
    // dataAssociations are children of the subprocess but rendered on process level
    // cf. https://github.com/bpmn-io/bpmn-js/issues/1619
    if ((0, _modelUtil.isAny)(bo, [
        'bpmn:DataInputAssociation',
        'bpmn:DataOutputAssociation'
    ])) return false;
    return true;
}

},{"diagram-js/lib/layout/LayoutUtil":"4CCrs","../../util/ModelUtil":"klNYN","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3ZlZA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DrilldownOverlayBehavior);
var _inheritsBrowser = require("inherits-browser");
var _inheritsBrowserDefault = parcelHelpers.interopDefault(_inheritsBrowser);
var _commandInterceptor = require("diagram-js/lib/command/CommandInterceptor");
var _commandInterceptorDefault = parcelHelpers.interopDefault(_commandInterceptor);
var _modelUtil = require("../../util/ModelUtil");
var _minDom = require("min-dom");
var _drilldownUtil = require("../../util/DrilldownUtil");
var LOW_PRIORITY = 250;
var ARROW_DOWN_SVG = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M4.81801948,3.50735931 L10.4996894,9.1896894 L10.5,4 L12,4 L12,12 L4,12 L4,10.5 L9.6896894,10.4996894 L3.75735931,4.56801948 C3.46446609,4.27512627 3.46446609,3.80025253 3.75735931,3.50735931 C4.05025253,3.21446609 4.52512627,3.21446609 4.81801948,3.50735931 Z"/></svg>';
var EMPTY_MARKER = 'bjs-drilldown-empty';
function DrilldownOverlayBehavior(canvas, eventBus, elementRegistry, overlays) {
    (0, _commandInterceptorDefault.default).call(this, eventBus);
    this._canvas = canvas;
    this._eventBus = eventBus;
    this._elementRegistry = elementRegistry;
    this._overlays = overlays;
    var self = this;
    this.executed('shape.toggleCollapse', LOW_PRIORITY, function(context) {
        var shape = context.shape;
        // Add overlay to the collapsed shape
        if (self.canDrillDown(shape)) self.addOverlay(shape);
        else self.removeOverlay(shape);
    }, true);
    this.reverted('shape.toggleCollapse', LOW_PRIORITY, function(context) {
        var shape = context.shape;
        // Add overlay to the collapsed shape
        if (self.canDrillDown(shape)) self.addOverlay(shape);
        else self.removeOverlay(shape);
    }, true);
    this.executed([
        'shape.create',
        'shape.move',
        'shape.delete'
    ], LOW_PRIORITY, function(context) {
        var oldParent = context.oldParent, newParent = context.newParent || context.parent, shape = context.shape;
        // Add overlay to the collapsed shape
        if (self.canDrillDown(shape)) self.addOverlay(shape);
        self.updateDrilldownOverlay(oldParent);
        self.updateDrilldownOverlay(newParent);
        self.updateDrilldownOverlay(shape);
    }, true);
    this.reverted([
        'shape.create',
        'shape.move',
        'shape.delete'
    ], LOW_PRIORITY, function(context) {
        var oldParent = context.oldParent, newParent = context.newParent || context.parent, shape = context.shape;
        // Add overlay to the collapsed shape
        if (self.canDrillDown(shape)) self.addOverlay(shape);
        self.updateDrilldownOverlay(oldParent);
        self.updateDrilldownOverlay(newParent);
        self.updateDrilldownOverlay(shape);
    }, true);
    eventBus.on('import.render.complete', function() {
        elementRegistry.filter(function(e) {
            return self.canDrillDown(e);
        }).map(function(el) {
            self.addOverlay(el);
        });
    });
}
(0, _inheritsBrowserDefault.default)(DrilldownOverlayBehavior, (0, _commandInterceptorDefault.default));
DrilldownOverlayBehavior.prototype.updateDrilldownOverlay = function(shape) {
    var canvas = this._canvas;
    if (!shape) return;
    var root = canvas.findRoot(shape);
    if (root) this.updateOverlayVisibility(root);
};
DrilldownOverlayBehavior.prototype.canDrillDown = function(element) {
    var canvas = this._canvas;
    return (0, _modelUtil.is)(element, 'bpmn:SubProcess') && canvas.findRoot((0, _drilldownUtil.getPlaneIdFromShape)(element));
};
/**
 * Updates visibility of the drilldown overlay. If the plane has no elements,
 * the drilldown will be only shown when the element is selected.
 *
 * @param {djs.model.Shape|djs.model.Root} element collapsed shape or root element
 */ DrilldownOverlayBehavior.prototype.updateOverlayVisibility = function(element) {
    var overlays = this._overlays;
    var bo = element.businessObject;
    var overlay = overlays.get({
        element: bo.id,
        type: 'drilldown'
    })[0];
    if (!overlay) return;
    var hasContent = bo && bo.flowElements && bo.flowElements.length;
    (0, _minDom.classes)(overlay.html).toggle(EMPTY_MARKER, !hasContent);
};
/**
 * Attaches a drilldown button to the given element. We assume that the plane has
 * the same id as the element.
 *
 * @param {djs.model.Shape} element collapsed shape
 */ DrilldownOverlayBehavior.prototype.addOverlay = function(element) {
    var canvas = this._canvas;
    var overlays = this._overlays;
    var existingOverlays = overlays.get({
        element: element,
        type: 'drilldown'
    });
    if (existingOverlays.length) this.removeOverlay(element);
    var button = (0, _minDom.domify)('<button class="bjs-drilldown">' + ARROW_DOWN_SVG + '</button>');
    button.addEventListener('click', function() {
        canvas.setRootElement(canvas.findRoot((0, _drilldownUtil.getPlaneIdFromShape)(element)));
    });
    overlays.add(element, 'drilldown', {
        position: {
            bottom: -7,
            right: -8
        },
        html: button
    });
    this.updateOverlayVisibility(element);
};
DrilldownOverlayBehavior.prototype.removeOverlay = function(element) {
    var overlays = this._overlays;
    overlays.remove({
        element: element,
        type: 'drilldown'
    });
};
DrilldownOverlayBehavior.$inject = [
    'canvas',
    'eventBus',
    'elementRegistry',
    'overlays'
];

},{"inherits-browser":"hymxq","diagram-js/lib/command/CommandInterceptor":"1K1IQ","../../util/ModelUtil":"klNYN","min-dom":"e58GC","../../util/DrilldownUtil":"aMFv0","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lNTRk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>NavigatedViewer);
var _inheritsBrowser = require("inherits-browser");
var _inheritsBrowserDefault = parcelHelpers.interopDefault(_inheritsBrowser);
var _viewer = require("./Viewer");
var _viewerDefault = parcelHelpers.interopDefault(_viewer);
var _keyboardMove = require("diagram-js/lib/navigation/keyboard-move");
var _keyboardMoveDefault = parcelHelpers.interopDefault(_keyboardMove);
var _movecanvas = require("diagram-js/lib/navigation/movecanvas");
var _movecanvasDefault = parcelHelpers.interopDefault(_movecanvas);
var _zoomscroll = require("diagram-js/lib/navigation/zoomscroll");
var _zoomscrollDefault = parcelHelpers.interopDefault(_zoomscroll);
function NavigatedViewer(options) {
    (0, _viewerDefault.default).call(this, options);
}
(0, _inheritsBrowserDefault.default)(NavigatedViewer, (0, _viewerDefault.default));
NavigatedViewer.prototype._navigationModules = [
    (0, _keyboardMoveDefault.default),
    (0, _movecanvasDefault.default),
    (0, _zoomscrollDefault.default)
];
NavigatedViewer.prototype._modules = [].concat((0, _viewerDefault.default).prototype._modules, NavigatedViewer.prototype._navigationModules);

},{"inherits-browser":"hymxq","./Viewer":"1SAoE","diagram-js/lib/navigation/keyboard-move":"4pwXS","diagram-js/lib/navigation/movecanvas":"fUC2m","diagram-js/lib/navigation/zoomscroll":"dRWcE","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4pwXS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _keyboard = require("../../features/keyboard");
var _keyboardDefault = parcelHelpers.interopDefault(_keyboard);
var _keyboardMove = require("./KeyboardMove");
var _keyboardMoveDefault = parcelHelpers.interopDefault(_keyboardMove);
exports.default = {
    __depends__: [
        (0, _keyboardDefault.default)
    ],
    __init__: [
        'keyboardMove'
    ],
    keyboardMove: [
        'type',
        (0, _keyboardMoveDefault.default)
    ]
};

},{"../../features/keyboard":"gKt0S","./KeyboardMove":"7jDRS","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gKt0S":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _keyboard = require("./Keyboard");
var _keyboardDefault = parcelHelpers.interopDefault(_keyboard);
var _keyboardBindings = require("./KeyboardBindings");
var _keyboardBindingsDefault = parcelHelpers.interopDefault(_keyboardBindings);
exports.default = {
    __init__: [
        'keyboard',
        'keyboardBindings'
    ],
    keyboard: [
        'type',
        (0, _keyboardDefault.default)
    ],
    keyboardBindings: [
        'type',
        (0, _keyboardBindingsDefault.default)
    ]
};

},{"./Keyboard":"2bwgP","./KeyboardBindings":"8kcRe","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2bwgP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Keyboard);
var _minDash = require("min-dash");
var _minDom = require("min-dom");
var _keyboardUtil = require("./KeyboardUtil");
/**
 * @typedef {import('../../core/EventBus').default} EventBus
 */ var KEYDOWN_EVENT = 'keyboard.keydown', KEYUP_EVENT = 'keyboard.keyup';
var HANDLE_MODIFIER_ATTRIBUTE = 'input-handle-modified-keys';
var DEFAULT_PRIORITY = 1000;
function Keyboard(config, eventBus) {
    var self = this;
    this._config = config || {};
    this._eventBus = eventBus;
    this._keydownHandler = this._keydownHandler.bind(this);
    this._keyupHandler = this._keyupHandler.bind(this);
    // properly clean dom registrations
    eventBus.on('diagram.destroy', function() {
        self._fire('destroy');
        self.unbind();
    });
    eventBus.on('diagram.init', function() {
        self._fire('init');
    });
    eventBus.on('attach', function() {
        if (config && config.bindTo) self.bind(config.bindTo);
    });
    eventBus.on('detach', function() {
        self.unbind();
    });
}
Keyboard.$inject = [
    'config.keyboard',
    'eventBus'
];
Keyboard.prototype._keydownHandler = function(event) {
    this._keyHandler(event, KEYDOWN_EVENT);
};
Keyboard.prototype._keyupHandler = function(event) {
    this._keyHandler(event, KEYUP_EVENT);
};
Keyboard.prototype._keyHandler = function(event, type) {
    var eventBusResult;
    if (this._isEventIgnored(event)) return;
    var context = {
        keyEvent: event
    };
    eventBusResult = this._eventBus.fire(type || KEYDOWN_EVENT, context);
    if (eventBusResult) event.preventDefault();
};
Keyboard.prototype._isEventIgnored = function(event) {
    if (event.defaultPrevented) return true;
    return isInput(event.target) && this._isModifiedKeyIgnored(event);
};
Keyboard.prototype._isModifiedKeyIgnored = function(event) {
    if (!(0, _keyboardUtil.isCmd)(event)) return true;
    var allowedModifiers = this._getAllowedModifiers(event.target);
    return allowedModifiers.indexOf(event.key) === -1;
};
Keyboard.prototype._getAllowedModifiers = function(element) {
    var modifierContainer = (0, _minDom.closest)(element, '[' + HANDLE_MODIFIER_ATTRIBUTE + ']', true);
    if (!modifierContainer || this._node && !this._node.contains(modifierContainer)) return [];
    return modifierContainer.getAttribute(HANDLE_MODIFIER_ATTRIBUTE).split(',');
};
Keyboard.prototype.bind = function(node) {
    // make sure that the keyboard is only bound once to the DOM
    this.unbind();
    this._node = node;
    // bind key events
    (0, _minDom.event).bind(node, 'keydown', this._keydownHandler);
    (0, _minDom.event).bind(node, 'keyup', this._keyupHandler);
    this._fire('bind');
};
Keyboard.prototype.getBinding = function() {
    return this._node;
};
Keyboard.prototype.unbind = function() {
    var node = this._node;
    if (node) {
        this._fire('unbind');
        // unbind key events
        (0, _minDom.event).unbind(node, 'keydown', this._keydownHandler);
        (0, _minDom.event).unbind(node, 'keyup', this._keyupHandler);
    }
    this._node = null;
};
Keyboard.prototype._fire = function(event) {
    this._eventBus.fire('keyboard.' + event, {
        node: this._node
    });
};
/**
 * Add a listener function that is notified with `KeyboardEvent` whenever
 * the keyboard is bound and the user presses a key. If no priority is
 * provided, the default value of 1000 is used.
 *
 * @param {number} [priority]
 * @param {Function} listener
 * @param {string} type
 */ Keyboard.prototype.addListener = function(priority, listener, type) {
    if ((0, _minDash.isFunction)(priority)) {
        type = listener;
        listener = priority;
        priority = DEFAULT_PRIORITY;
    }
    this._eventBus.on(type || KEYDOWN_EVENT, priority, listener);
};
Keyboard.prototype.removeListener = function(listener, type) {
    this._eventBus.off(type || KEYDOWN_EVENT, listener);
};
Keyboard.prototype.hasModifier = (0, _keyboardUtil.hasModifier);
Keyboard.prototype.isCmd = (0, _keyboardUtil.isCmd);
Keyboard.prototype.isShift = (0, _keyboardUtil.isShift);
Keyboard.prototype.isKey = (0, _keyboardUtil.isKey);
// helpers ///////
function isInput(target) {
    return target && ((0, _minDom.matches)(target, 'input, textarea') || target.contentEditable === 'true');
}

},{"min-dash":"aEEla","min-dom":"e58GC","./KeyboardUtil":"2Asg4","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2Asg4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "KEYS_COPY", ()=>KEYS_COPY);
parcelHelpers.export(exports, "KEYS_PASTE", ()=>KEYS_PASTE);
parcelHelpers.export(exports, "KEYS_REDO", ()=>KEYS_REDO);
parcelHelpers.export(exports, "KEYS_UNDO", ()=>KEYS_UNDO);
/**
 * Returns true if event was triggered with any modifier
 * @param {KeyboardEvent} event
 */ parcelHelpers.export(exports, "hasModifier", ()=>hasModifier);
/**
 * @param {KeyboardEvent} event
 */ parcelHelpers.export(exports, "isCmd", ()=>isCmd);
/**
 * Checks if key pressed is one of provided keys.
 *
 * @param {string|Array<string>} keys
 * @param {KeyboardEvent} event
 */ parcelHelpers.export(exports, "isKey", ()=>isKey);
/**
 * @param {KeyboardEvent} event
 */ parcelHelpers.export(exports, "isShift", ()=>isShift);
parcelHelpers.export(exports, "isCopy", ()=>isCopy);
parcelHelpers.export(exports, "isPaste", ()=>isPaste);
parcelHelpers.export(exports, "isUndo", ()=>isUndo);
parcelHelpers.export(exports, "isRedo", ()=>isRedo);
var _minDash = require("min-dash");
var KEYS_COPY = [
    'c',
    'C'
];
var KEYS_PASTE = [
    'v',
    'V'
];
var KEYS_REDO = [
    'y',
    'Y'
];
var KEYS_UNDO = [
    'z',
    'Z'
];
function hasModifier(event) {
    return event.ctrlKey || event.metaKey || event.shiftKey || event.altKey;
}
function isCmd(event) {
    // ensure we don't react to AltGr
    // (mapped to CTRL + ALT)
    if (event.altKey) return false;
    return event.ctrlKey || event.metaKey;
}
function isKey(keys, event) {
    keys = (0, _minDash.isArray)(keys) ? keys : [
        keys
    ];
    return keys.indexOf(event.key) !== -1 || keys.indexOf(event.code) !== -1;
}
function isShift(event) {
    return event.shiftKey;
}
function isCopy(event) {
    return isCmd(event) && isKey(KEYS_COPY, event);
}
function isPaste(event) {
    return isCmd(event) && isKey(KEYS_PASTE, event);
}
function isUndo(event) {
    return isCmd(event) && !isShift(event) && isKey(KEYS_UNDO, event);
}
function isRedo(event) {
    return isCmd(event) && (isKey(KEYS_REDO, event) || isKey(KEYS_UNDO, event) && isShift(event));
}

},{"min-dash":"aEEla","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8kcRe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @typedef {import('../../core/EventBus').default} EventBus
 * @typedef {import('./Keyboard').default} Keyboard
 */ parcelHelpers.export(exports, "KEYS_COPY", ()=>(0, _keyboardUtil.KEYS_COPY));
parcelHelpers.export(exports, "KEYS_PASTE", ()=>(0, _keyboardUtil.KEYS_PASTE));
parcelHelpers.export(exports, "KEYS_UNDO", ()=>(0, _keyboardUtil.KEYS_UNDO));
parcelHelpers.export(exports, "KEYS_REDO", ()=>(0, _keyboardUtil.KEYS_REDO));
parcelHelpers.export(exports, "default", ()=>KeyboardBindings);
var _keyboardUtil = require("./KeyboardUtil");
var LOW_PRIORITY = 500;
function KeyboardBindings(eventBus, keyboard) {
    var self = this;
    eventBus.on('editorActions.init', LOW_PRIORITY, function(event) {
        var editorActions = event.editorActions;
        self.registerBindings(keyboard, editorActions);
    });
}
KeyboardBindings.$inject = [
    'eventBus',
    'keyboard'
];
/**
 * Register available keyboard bindings.
 *
 * @param {Keyboard} keyboard
 * @param {EditorActions} editorActions
 */ KeyboardBindings.prototype.registerBindings = function(keyboard, editorActions) {
    /**
   * Add keyboard binding if respective editor action
   * is registered.
   *
   * @param {string} action name
   * @param {Function} fn that implements the key binding
   */ function addListener(action, fn) {
        if (editorActions.isRegistered(action)) keyboard.addListener(fn);
    }
    // undo
    // (CTRL|CMD) + Z
    addListener('undo', function(context) {
        var event = context.keyEvent;
        if ((0, _keyboardUtil.isUndo)(event)) {
            editorActions.trigger('undo');
            return true;
        }
    });
    // redo
    // CTRL + Y
    // CMD + SHIFT + Z
    addListener('redo', function(context) {
        var event = context.keyEvent;
        if ((0, _keyboardUtil.isRedo)(event)) {
            editorActions.trigger('redo');
            return true;
        }
    });
    // copy
    // CTRL/CMD + C
    addListener('copy', function(context) {
        var event = context.keyEvent;
        if ((0, _keyboardUtil.isCopy)(event)) {
            editorActions.trigger('copy');
            return true;
        }
    });
    // paste
    // CTRL/CMD + V
    addListener('paste', function(context) {
        var event = context.keyEvent;
        if ((0, _keyboardUtil.isPaste)(event)) {
            editorActions.trigger('paste');
            return true;
        }
    });
    // zoom in one step
    // CTRL/CMD + +
    addListener('stepZoom', function(context) {
        var event = context.keyEvent;
        // quirk: it has to be triggered by `=` as well to work on international keyboard layout
        // cf: https://github.com/bpmn-io/bpmn-js/issues/1362#issuecomment-722989754
        if ((0, _keyboardUtil.isKey)([
            '+',
            'Add',
            '='
        ], event) && (0, _keyboardUtil.isCmd)(event)) {
            editorActions.trigger('stepZoom', {
                value: 1
            });
            return true;
        }
    });
    // zoom out one step
    // CTRL + -
    addListener('stepZoom', function(context) {
        var event = context.keyEvent;
        if ((0, _keyboardUtil.isKey)([
            '-',
            'Subtract'
        ], event) && (0, _keyboardUtil.isCmd)(event)) {
            editorActions.trigger('stepZoom', {
                value: -1
            });
            return true;
        }
    });
    // zoom to the default level
    // CTRL + 0
    addListener('zoom', function(context) {
        var event = context.keyEvent;
        if ((0, _keyboardUtil.isKey)('0', event) && (0, _keyboardUtil.isCmd)(event)) {
            editorActions.trigger('zoom', {
                value: 1
            });
            return true;
        }
    });
    // delete selected element
    // DEL
    addListener('removeSelection', function(context) {
        var event = context.keyEvent;
        if ((0, _keyboardUtil.isKey)([
            'Backspace',
            'Delete',
            'Del'
        ], event)) {
            editorActions.trigger('removeSelection');
            return true;
        }
    });
};

},{"./KeyboardUtil":"2Asg4","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7jDRS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>KeyboardMove);
var _minDash = require("min-dash");
/**
 * @typedef {import('../../core/Canvas').default} Canvas
 * @typedef {import('../../features/keyboard/Keyboard').default} Keyboard
 */ var DEFAULT_CONFIG = {
    moveSpeed: 50,
    moveSpeedAccelerated: 200
};
function KeyboardMove(config, keyboard, canvas) {
    var self = this;
    this._config = (0, _minDash.assign)({}, DEFAULT_CONFIG, config || {});
    keyboard.addListener(arrowsListener);
    function arrowsListener(context) {
        var event = context.keyEvent, config = self._config;
        if (!keyboard.isCmd(event)) return;
        if (keyboard.isKey([
            'ArrowLeft',
            'Left',
            'ArrowUp',
            'Up',
            'ArrowDown',
            'Down',
            'ArrowRight',
            'Right'
        ], event)) {
            var speed = keyboard.isShift(event) ? config.moveSpeedAccelerated : config.moveSpeed;
            var direction;
            switch(event.key){
                case 'ArrowLeft':
                case 'Left':
                    direction = 'left';
                    break;
                case 'ArrowUp':
                case 'Up':
                    direction = 'up';
                    break;
                case 'ArrowRight':
                case 'Right':
                    direction = 'right';
                    break;
                case 'ArrowDown':
                case 'Down':
                    direction = 'down';
                    break;
            }
            self.moveCanvas({
                speed: speed,
                direction: direction
            });
            return true;
        }
    }
    this.moveCanvas = function(opts) {
        var dx = 0, dy = 0, speed = opts.speed;
        var actualSpeed = speed / Math.min(Math.sqrt(canvas.viewbox().scale), 1);
        switch(opts.direction){
            case 'left':
                dx = actualSpeed;
                break;
            case 'up':
                dy = actualSpeed;
                break;
            case 'right':
                dx = -actualSpeed;
                break;
            case 'down':
                dy = -actualSpeed;
                break;
        }
        canvas.scroll({
            dx: dx,
            dy: dy
        });
    };
}
KeyboardMove.$inject = [
    'config.keyboardMove',
    'keyboard',
    'canvas'
];

},{"min-dash":"aEEla","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fUC2m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _moveCanvas = require("./MoveCanvas");
var _moveCanvasDefault = parcelHelpers.interopDefault(_moveCanvas);
exports.default = {
    __init__: [
        'moveCanvas'
    ],
    moveCanvas: [
        'type',
        (0, _moveCanvasDefault.default)
    ]
};

},{"./MoveCanvas":"l3OVi","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"l3OVi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>MoveCanvas);
var _cursor = require("../../util/Cursor");
var _clickTrap = require("../../util/ClickTrap");
var _positionUtil = require("../../util/PositionUtil");
var _minDom = require("min-dom");
var _event = require("../../util/Event");
/**
 * @typedef {import('../../core/Canvas').default} Canvas
 * @typedef {import('../../core/EventBus').default} EventBus
 */ var THRESHOLD = 15;
function MoveCanvas(eventBus, canvas) {
    var context;
    // listen for move on element mouse down;
    // allow others to hook into the event before us though
    // (dragging / element moving will do this)
    eventBus.on('element.mousedown', 500, function(e) {
        return handleStart(e.originalEvent);
    });
    function handleMove(event) {
        var start = context.start, button = context.button, position = (0, _event.toPoint)(event), delta = (0, _positionUtil.delta)(position, start);
        if (!context.dragging && length(delta) > THRESHOLD) {
            context.dragging = true;
            if (button === 0) (0, _clickTrap.install)(eventBus);
            (0, _cursor.set)('grab');
        }
        if (context.dragging) {
            var lastPosition = context.last || context.start;
            delta = (0, _positionUtil.delta)(position, lastPosition);
            canvas.scroll({
                dx: delta.x,
                dy: delta.y
            });
            context.last = position;
        }
        // prevent select
        event.preventDefault();
    }
    function handleEnd(event) {
        (0, _minDom.event).unbind(document, 'mousemove', handleMove);
        (0, _minDom.event).unbind(document, 'mouseup', handleEnd);
        context = null;
        (0, _cursor.unset)();
    }
    function handleStart(event) {
        // event is already handled by '.djs-draggable'
        if ((0, _minDom.closest)(event.target, '.djs-draggable')) return;
        var button = event.button;
        // reject right mouse button or modifier key
        if (button >= 2 || event.ctrlKey || event.shiftKey || event.altKey) return;
        context = {
            button: button,
            start: (0, _event.toPoint)(event)
        };
        (0, _minDom.event).bind(document, 'mousemove', handleMove);
        (0, _minDom.event).bind(document, 'mouseup', handleEnd);
        // we've handled the event
        return true;
    }
    this.isActive = function() {
        return !!context;
    };
}
MoveCanvas.$inject = [
    'eventBus',
    'canvas'
];
// helpers ///////
function length(point) {
    return Math.sqrt(Math.pow(point.x, 2) + Math.pow(point.y, 2));
}

},{"../../util/Cursor":"258yd","../../util/ClickTrap":"2dyvI","../../util/PositionUtil":"flrPc","min-dom":"e58GC","../../util/Event":"a3pF2","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"258yd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "set", ()=>set);
parcelHelpers.export(exports, "unset", ()=>unset);
parcelHelpers.export(exports, "has", ()=>has);
var _minDom = require("min-dom");
var CURSOR_CLS_PATTERN = /^djs-cursor-.*$/;
function set(mode) {
    var classes = (0, _minDom.classes)(document.body);
    classes.removeMatching(CURSOR_CLS_PATTERN);
    if (mode) classes.add('djs-cursor-' + mode);
}
function unset() {
    set(null);
}
function has(mode) {
    var classes = (0, _minDom.classes)(document.body);
    return classes.has('djs-cursor-' + mode);
}

},{"min-dom":"e58GC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2dyvI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Installs a click trap that prevents a ghost click following a dragging operation.
 *
 * @return {Function} a function to immediately remove the installed trap.
 */ parcelHelpers.export(exports, "install", ()=>install);
var TRAP_PRIORITY = 5000;
function install(eventBus, eventName) {
    eventName = eventName || 'element.click';
    function trap() {
        return false;
    }
    eventBus.once(eventName, TRAP_PRIORITY, trap);
    return function() {
        eventBus.off(eventName, trap);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"flrPc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "center", ()=>center);
parcelHelpers.export(exports, "delta", ()=>delta);
function center(bounds) {
    return {
        x: bounds.x + bounds.width / 2,
        y: bounds.y + bounds.height / 2
    };
}
function delta(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dRWcE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _zoomScroll = require("./ZoomScroll");
var _zoomScrollDefault = parcelHelpers.interopDefault(_zoomScroll);
exports.default = {
    __init__: [
        'zoomScroll'
    ],
    zoomScroll: [
        'type',
        (0, _zoomScrollDefault.default)
    ]
};

},{"./ZoomScroll":"ff1pN","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ff1pN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ZoomScroll);
var _minDom = require("min-dom");
var _zoomUtil = require("./ZoomUtil");
var _math = require("../../util/Math");
var _minDash = require("min-dash");
/**
 * @typedef {import('../../core/Canvas').default} Canvas
 * @typedef {import('../../core/EventBus').default} EventBus
 */ var sign = Math.sign || function(n) {
    return n >= 0 ? 1 : -1;
};
var RANGE = {
    min: 0.2,
    max: 4
}, NUM_STEPS = 10;
var DELTA_THRESHOLD = 0.1;
var DEFAULT_SCALE = 0.75;
function ZoomScroll(config, eventBus, canvas) {
    config = config || {};
    this._enabled = false;
    this._canvas = canvas;
    this._container = canvas._container;
    this._handleWheel = (0, _minDash.bind)(this._handleWheel, this);
    this._totalDelta = 0;
    this._scale = config.scale || DEFAULT_SCALE;
    var self = this;
    eventBus.on('canvas.init', function(e) {
        self._init(config.enabled !== false);
    });
}
ZoomScroll.$inject = [
    'config.zoomScroll',
    'eventBus',
    'canvas'
];
ZoomScroll.prototype.scroll = function scroll(delta) {
    this._canvas.scroll(delta);
};
ZoomScroll.prototype.reset = function reset() {
    this._canvas.zoom('fit-viewport');
};
/**
 * Zoom depending on delta.
 *
 * @param {number} delta
 * @param {Object} position
 */ ZoomScroll.prototype.zoom = function zoom(delta, position) {
    // zoom with half the step size of stepZoom
    var stepSize = (0, _zoomUtil.getStepSize)(RANGE, NUM_STEPS * 2);
    // add until threshold reached
    this._totalDelta += delta;
    if (Math.abs(this._totalDelta) > DELTA_THRESHOLD) {
        this._zoom(delta, position, stepSize);
        // reset
        this._totalDelta = 0;
    }
};
ZoomScroll.prototype._handleWheel = function handleWheel(event) {
    // event is already handled by '.djs-scrollable'
    if ((0, _minDom.closest)(event.target, '.djs-scrollable', true)) return;
    var element = this._container;
    event.preventDefault();
    // pinch to zoom is mapped to wheel + ctrlKey = true
    // in modern browsers (!)
    var isZoom = event.ctrlKey;
    var isHorizontalScroll = event.shiftKey;
    var factor = -1 * this._scale, delta;
    if (isZoom) factor *= event.deltaMode === 0 ? 0.020 : 0.32;
    else factor *= event.deltaMode === 0 ? 1.0 : 16.0;
    if (isZoom) {
        var elementRect = element.getBoundingClientRect();
        var offset = {
            x: event.clientX - elementRect.left,
            y: event.clientY - elementRect.top
        };
        delta = Math.sqrt(Math.pow(event.deltaY, 2) + Math.pow(event.deltaX, 2)) * sign(event.deltaY) * factor;
        // zoom in relative to diagram {x,y} coordinates
        this.zoom(delta, offset);
    } else {
        if (isHorizontalScroll) delta = {
            dx: factor * event.deltaY,
            dy: 0
        };
        else delta = {
            dx: factor * event.deltaX,
            dy: factor * event.deltaY
        };
        this.scroll(delta);
    }
};
/**
 * Zoom with fixed step size.
 *
 * @param {number} delta - Zoom delta (1 for zooming in, -1 for out).
 * @param {Object} position
 */ ZoomScroll.prototype.stepZoom = function stepZoom(delta, position) {
    var stepSize = (0, _zoomUtil.getStepSize)(RANGE, NUM_STEPS);
    this._zoom(delta, position, stepSize);
};
/**
 * Zoom in/out given a step size.
 *
 * @param {number} delta
 * @param {Object} position
 * @param {number} stepSize
 */ ZoomScroll.prototype._zoom = function(delta, position, stepSize) {
    var canvas = this._canvas;
    var direction = delta > 0 ? 1 : -1;
    var currentLinearZoomLevel = (0, _math.log10)(canvas.zoom());
    // snap to a proximate zoom step
    var newLinearZoomLevel = Math.round(currentLinearZoomLevel / stepSize) * stepSize;
    // increase or decrease one zoom step in the given direction
    newLinearZoomLevel += stepSize * direction;
    // calculate the absolute logarithmic zoom level based on the linear zoom level
    // (e.g. 2 for an absolute x2 zoom)
    var newLogZoomLevel = Math.pow(10, newLinearZoomLevel);
    canvas.zoom((0, _zoomUtil.cap)(RANGE, newLogZoomLevel), position);
};
/**
 * Toggle the zoom scroll ability via mouse wheel.
 *
 * @param {boolean} [newEnabled] new enabled state
 */ ZoomScroll.prototype.toggle = function toggle(newEnabled) {
    var element = this._container;
    var handleWheel = this._handleWheel;
    var oldEnabled = this._enabled;
    if (typeof newEnabled === 'undefined') newEnabled = !oldEnabled;
    // only react on actual changes
    if (oldEnabled !== newEnabled) // add or remove wheel listener based on
    // changed enabled state
    (0, _minDom.event)[newEnabled ? 'bind' : 'unbind'](element, 'wheel', handleWheel, false);
    this._enabled = newEnabled;
    return newEnabled;
};
ZoomScroll.prototype._init = function(newEnabled) {
    this.toggle(newEnabled);
};

},{"min-dom":"e58GC","./ZoomUtil":"cUCkR","../../util/Math":"8nv8V","min-dash":"aEEla","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cUCkR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Get step size for given range and number of steps.
 *
 * @param {Object} range
 * @param {number} range.min
 * @param {number} range.max
 */ parcelHelpers.export(exports, "getStepSize", ()=>getStepSize);
parcelHelpers.export(exports, "cap", ()=>cap);
var _math = require("../../util/Math");
function getStepSize(range, steps) {
    var minLinearRange = (0, _math.log10)(range.min), maxLinearRange = (0, _math.log10)(range.max);
    var absoluteLinearRange = Math.abs(minLinearRange) + Math.abs(maxLinearRange);
    return absoluteLinearRange / steps;
}
function cap(range, scale) {
    return Math.max(range.min, Math.min(range.max, scale));
}

},{"../../util/Math":"8nv8V","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8nv8V":[function(require,module,exports,__globalThis) {
/**
 * Get the logarithm of x with base 10.
 *
 * @param {number} x
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "substract", ()=>(0, _positionUtil.delta));
parcelHelpers.export(exports, "log10", ()=>log10);
var _positionUtil = require("./PositionUtil");
function log10(x) {
    return Math.log(x) / Math.log(10);
}

},{"./PositionUtil":"flrPc","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bfg8c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _touch = require("../../features/touch");
var _touchDefault = parcelHelpers.interopDefault(_touch);
exports.default = {
    __depends__: [
        (0, _touchDefault.default)
    ]
};

},{"../../features/touch":"5YAdH","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5YAdH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _interactionEvents = require("../interaction-events");
var _interactionEventsDefault = parcelHelpers.interopDefault(_interactionEvents);
var _touchInteractionEvents = require("./TouchInteractionEvents");
var _touchInteractionEventsDefault = parcelHelpers.interopDefault(_touchInteractionEvents);
var _touchFix = require("./TouchFix");
var _touchFixDefault = parcelHelpers.interopDefault(_touchFix);
exports.default = {
    __depends__: [
        (0, _interactionEventsDefault.default)
    ],
    __init__: [
        'touchInteractionEvents'
    ],
    touchInteractionEvents: [
        'type',
        (0, _touchInteractionEventsDefault.default)
    ],
    touchFix: [
        'type',
        (0, _touchFixDefault.default)
    ]
};

},{"../interaction-events":"4qbdP","./TouchInteractionEvents":"iXnkr","./TouchFix":"1hjlO","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iXnkr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>TouchInteractionEvents);
var _minDash = require("min-dash");
var _minDom = require("min-dom");
var _hammerjs = require("hammerjs");
var _hammerjsDefault = parcelHelpers.interopDefault(_hammerjs);
var _event = require("../../util/Event");
/**
 * @typedef {import('didi').Injector} Injector
 *
 * @typedef {import('../../core/Canvas').default} Canvas
 * @typedef {import('../../core/ElementRegistry').default} ElementRegistry
 * @typedef {import('../../core/EventBus').default} EventBus
 * @typedef {import('../interaction-events/InteractionEvents').default} InteractionEvents
 */ var MIN_ZOOM = 0.2, MAX_ZOOM = 4;
var mouseEvents = [
    'mousedown',
    'mouseup',
    'mouseover',
    'mouseout',
    'click',
    'dblclick'
];
function log() {
// console.log.apply(console, arguments);
}
function get(service, injector) {
    return injector.get(service, false);
}
function stopEvent(event) {
    event.preventDefault();
    if (typeof event.stopPropagation === 'function') event.stopPropagation();
    else if (event.srcEvent && typeof event.srcEvent.stopPropagation === 'function') // iPhone & iPad
    event.srcEvent.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
}
function createTouchRecognizer(node) {
    function stopMouse(event) {
        (0, _minDash.forEach)(mouseEvents, function(e) {
            (0, _minDom.event).bind(node, e, stopEvent, true);
        });
    }
    function allowMouse(event) {
        setTimeout(function() {
            (0, _minDash.forEach)(mouseEvents, function(e) {
                (0, _minDom.event).unbind(node, e, stopEvent, true);
            });
        }, 500);
    }
    (0, _minDom.event).bind(node, 'touchstart', stopMouse, true);
    (0, _minDom.event).bind(node, 'touchend', allowMouse, true);
    (0, _minDom.event).bind(node, 'touchcancel', allowMouse, true);
    // A touch event recognizer that handles
    // touch events only (we know, we can already handle
    // mouse events out of the box)
    var recognizer = new (0, _hammerjsDefault.default).Manager(node, {
        inputClass: (0, _hammerjsDefault.default).TouchInput,
        recognizers: [],
        domEvents: true
    });
    var tap = new (0, _hammerjsDefault.default).Tap();
    var pan = new (0, _hammerjsDefault.default).Pan({
        threshold: 10
    });
    var press = new (0, _hammerjsDefault.default).Press();
    var pinch = new (0, _hammerjsDefault.default).Pinch();
    var doubleTap = new (0, _hammerjsDefault.default).Tap({
        event: 'doubletap',
        taps: 2
    });
    pinch.requireFailure(pan);
    pinch.requireFailure(press);
    recognizer.add([
        pan,
        press,
        pinch,
        doubleTap,
        tap
    ]);
    recognizer.reset = function(force) {
        var recognizers = this.recognizers, session = this.session;
        if (session.stopped) return;
        log('recognizer', 'stop');
        recognizer.stop(force);
        setTimeout(function() {
            var i, r;
            log('recognizer', 'reset');
            for(i = 0; r = recognizers[i]; i++){
                r.reset();
                r.state = 8; // FAILED STATE
            }
            session.curRecognizer = null;
        }, 0);
    };
    recognizer.on('hammer.input', function(event) {
        if (event.srcEvent.defaultPrevented) recognizer.reset(true);
    });
    return recognizer;
}
function TouchInteractionEvents(injector, canvas, eventBus, elementRegistry, interactionEvents) {
    // optional integrations
    var dragging = get('dragging', injector), move = get('move', injector), contextPad = get('contextPad', injector), palette = get('palette', injector);
    // the touch recognizer
    var recognizer;
    function handler(type, buttonType) {
        return function(event) {
            log('element', type, event);
            var gfx = getGfx(event.target), element = gfx && elementRegistry.get(gfx);
            // translate into an actual mouse click event
            if (buttonType) event.srcEvent.button = buttonType;
            return interactionEvents.fire(type, event, element);
        };
    }
    function getGfx(target) {
        var node = (0, _minDom.closest)(target, 'svg, .djs-element', true);
        return node;
    }
    function initEvents(svg) {
        // touch recognizer
        recognizer = createTouchRecognizer(svg);
        function startGrabCanvas(event) {
            log('canvas', 'grab start');
            var lx = 0, ly = 0;
            function update(e) {
                var dx = e.deltaX - lx, dy = e.deltaY - ly;
                canvas.scroll({
                    dx: dx,
                    dy: dy
                });
                lx = e.deltaX;
                ly = e.deltaY;
            }
            function end(e) {
                recognizer.off('panmove', update);
                recognizer.off('panend', end);
                recognizer.off('pancancel', end);
                log('canvas', 'grab end');
            }
            recognizer.on('panmove', update);
            recognizer.on('panend', end);
            recognizer.on('pancancel', end);
        }
        function startGrab(event) {
            var gfx = getGfx(event.target), element = gfx && elementRegistry.get(gfx);
            // recognizer
            if (move && canvas.getRootElement() !== element) {
                log('element', 'move start', element, event, true);
                return move.start(event, element, true);
            } else startGrabCanvas(event);
        }
        function startZoom(e) {
            log('canvas', 'zoom start');
            var zoom = canvas.zoom(), mid = e.center;
            function update(e) {
                var ratio = 1 - (1 - e.scale) / 1.50, newZoom = Math.max(MIN_ZOOM, Math.min(MAX_ZOOM, ratio * zoom));
                canvas.zoom(newZoom, mid);
                stopEvent(e);
            }
            function end(e) {
                recognizer.off('pinchmove', update);
                recognizer.off('pinchend', end);
                recognizer.off('pinchcancel', end);
                recognizer.reset(true);
                log('canvas', 'zoom end');
            }
            recognizer.on('pinchmove', update);
            recognizer.on('pinchend', end);
            recognizer.on('pinchcancel', end);
        }
        recognizer.on('tap', handler('element.click'));
        recognizer.on('doubletap', handler('element.dblclick', 1));
        recognizer.on('panstart', startGrab);
        recognizer.on('press', startGrab);
        recognizer.on('pinchstart', startZoom);
    }
    if (dragging) // simulate hover during dragging
    eventBus.on('drag.move', function(event) {
        var originalEvent = event.originalEvent;
        if (!originalEvent || originalEvent instanceof MouseEvent) return;
        var position = (0, _event.toPoint)(originalEvent);
        // this gets really expensive ...
        var node = document.elementFromPoint(position.x, position.y), gfx = getGfx(node), element = gfx && elementRegistry.get(gfx);
        if (element !== event.hover) {
            if (event.hover) dragging.out(event);
            if (element) {
                dragging.hover({
                    element: element,
                    gfx: gfx
                });
                event.hover = element;
                event.hoverGfx = gfx;
            }
        }
    });
    if (contextPad) eventBus.on('contextPad.create', function(event) {
        var node = event.pad.html;
        // touch recognizer
        var padRecognizer = createTouchRecognizer(node);
        padRecognizer.on('panstart', function(event) {
            log('context-pad', 'panstart', event);
            contextPad.trigger('dragstart', event, true);
        });
        padRecognizer.on('press', function(event) {
            log('context-pad', 'press', event);
            contextPad.trigger('dragstart', event, true);
        });
        padRecognizer.on('tap', function(event) {
            log('context-pad', 'tap', event);
            contextPad.trigger('click', event);
        });
    });
    if (palette) eventBus.on('palette.create', function(event) {
        var node = event.container;
        // touch recognizer
        var padRecognizer = createTouchRecognizer(node);
        padRecognizer.on('panstart', function(event) {
            log('palette', 'panstart', event);
            palette.trigger('dragstart', event, true);
        });
        padRecognizer.on('press', function(event) {
            log('palette', 'press', event);
            palette.trigger('dragstart', event, true);
        });
        padRecognizer.on('tap', function(event) {
            log('palette', 'tap', event);
            palette.trigger('click', event);
        });
    });
    eventBus.on('canvas.init', function(event) {
        initEvents(event.svg);
    });
}
TouchInteractionEvents.$inject = [
    'injector',
    'canvas',
    'eventBus',
    'elementRegistry',
    'interactionEvents',
    'touchFix'
];

},{"min-dash":"aEEla","min-dom":"e58GC","hammerjs":"jPgEb","../../util/Event":"a3pF2","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jPgEb":[function(require,module,exports,__globalThis) {
/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */ (function(window1, document1, exportName, undefined) {
    'use strict';
    var VENDOR_PREFIXES = [
        '',
        'webkit',
        'Moz',
        'MS',
        'ms',
        'o'
    ];
    var TEST_ELEMENT = document1.createElement('div');
    var TYPE_FUNCTION = 'function';
    var round = Math.round;
    var abs = Math.abs;
    var now = Date.now;
    /**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */ function setTimeoutContext(fn, timeout, context) {
        return setTimeout(bindFn(fn, context), timeout);
    }
    /**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */ function invokeArrayArg(arg, fn, context) {
        if (Array.isArray(arg)) {
            each(arg, context[fn], context);
            return true;
        }
        return false;
    }
    /**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */ function each(obj, iterator, context) {
        var i;
        if (!obj) return;
        if (obj.forEach) obj.forEach(iterator, context);
        else if (obj.length !== undefined) {
            i = 0;
            while(i < obj.length){
                iterator.call(context, obj[i], i, obj);
                i++;
            }
        } else for(i in obj)obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
    }
    /**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */ function deprecate(method, name, message) {
        var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
        return function() {
            var e = new Error('get-stack-trace');
            var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '').replace(/^\s+at\s+/gm, '').replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';
            var log = window1.console && (window1.console.warn || window1.console.log);
            if (log) log.call(window1.console, deprecationMessage, stack);
            return method.apply(this, arguments);
        };
    }
    /**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */ var assign;
    if (typeof Object.assign !== 'function') assign = function assign(target) {
        if (target === undefined || target === null) throw new TypeError('Cannot convert undefined or null to object');
        var output = Object(target);
        for(var index = 1; index < arguments.length; index++){
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for(var nextKey in source)if (source.hasOwnProperty(nextKey)) output[nextKey] = source[nextKey];
            }
        }
        return output;
    };
    else assign = Object.assign;
    /**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */ var extend = deprecate(function extend(dest, src, merge) {
        var keys = Object.keys(src);
        var i = 0;
        while(i < keys.length){
            if (!merge || merge && dest[keys[i]] === undefined) dest[keys[i]] = src[keys[i]];
            i++;
        }
        return dest;
    }, 'extend', 'Use `assign`.');
    /**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */ var merge = deprecate(function merge(dest, src) {
        return extend(dest, src, true);
    }, 'merge', 'Use `assign`.');
    /**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */ function inherit(child, base, properties) {
        var baseP = base.prototype, childP;
        childP = child.prototype = Object.create(baseP);
        childP.constructor = child;
        childP._super = baseP;
        if (properties) assign(childP, properties);
    }
    /**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */ function bindFn(fn, context) {
        return function boundFn() {
            return fn.apply(context, arguments);
        };
    }
    /**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */ function boolOrFn(val, args) {
        if (typeof val == TYPE_FUNCTION) return val.apply(args ? args[0] || undefined : undefined, args);
        return val;
    }
    /**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */ function ifUndefined(val1, val2) {
        return val1 === undefined ? val2 : val1;
    }
    /**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */ function addEventListeners(target, types, handler) {
        each(splitStr(types), function(type) {
            target.addEventListener(type, handler, false);
        });
    }
    /**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */ function removeEventListeners(target, types, handler) {
        each(splitStr(types), function(type) {
            target.removeEventListener(type, handler, false);
        });
    }
    /**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */ function hasParent(node, parent) {
        while(node){
            if (node == parent) return true;
            node = node.parentNode;
        }
        return false;
    }
    /**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */ function inStr(str, find) {
        return str.indexOf(find) > -1;
    }
    /**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */ function splitStr(str) {
        return str.trim().split(/\s+/g);
    }
    /**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */ function inArray(src, find, findByKey) {
        if (src.indexOf && !findByKey) return src.indexOf(find);
        else {
            var i = 0;
            while(i < src.length){
                if (findByKey && src[i][findByKey] == find || !findByKey && src[i] === find) return i;
                i++;
            }
            return -1;
        }
    }
    /**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */ function toArray(obj) {
        return Array.prototype.slice.call(obj, 0);
    }
    /**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */ function uniqueArray(src, key, sort) {
        var results = [];
        var values = [];
        var i = 0;
        while(i < src.length){
            var val = key ? src[i][key] : src[i];
            if (inArray(values, val) < 0) results.push(src[i]);
            values[i] = val;
            i++;
        }
        if (sort) {
            if (!key) results = results.sort();
            else results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
        return results;
    }
    /**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */ function prefixed(obj, property) {
        var prefix, prop;
        var camelProp = property[0].toUpperCase() + property.slice(1);
        var i = 0;
        while(i < VENDOR_PREFIXES.length){
            prefix = VENDOR_PREFIXES[i];
            prop = prefix ? prefix + camelProp : property;
            if (prop in obj) return prop;
            i++;
        }
        return undefined;
    }
    /**
 * get a unique id
 * @returns {number} uniqueId
 */ var _uniqueId = 1;
    function uniqueId() {
        return _uniqueId++;
    }
    /**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */ function getWindowForElement(element) {
        var doc = element.ownerDocument || element;
        return doc.defaultView || doc.parentWindow || window1;
    }
    var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;
    var SUPPORT_TOUCH = 'ontouchstart' in window1;
    var SUPPORT_POINTER_EVENTS = prefixed(window1, 'PointerEvent') !== undefined;
    var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);
    var INPUT_TYPE_TOUCH = 'touch';
    var INPUT_TYPE_PEN = 'pen';
    var INPUT_TYPE_MOUSE = 'mouse';
    var INPUT_TYPE_KINECT = 'kinect';
    var COMPUTE_INTERVAL = 25;
    var INPUT_START = 1;
    var INPUT_MOVE = 2;
    var INPUT_END = 4;
    var INPUT_CANCEL = 8;
    var DIRECTION_NONE = 1;
    var DIRECTION_LEFT = 2;
    var DIRECTION_RIGHT = 4;
    var DIRECTION_UP = 8;
    var DIRECTION_DOWN = 16;
    var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
    var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
    var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;
    var PROPS_XY = [
        'x',
        'y'
    ];
    var PROPS_CLIENT_XY = [
        'clientX',
        'clientY'
    ];
    /**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */ function Input(manager, callback) {
        var self1 = this;
        this.manager = manager;
        this.callback = callback;
        this.element = manager.element;
        this.target = manager.options.inputTarget;
        // smaller wrapper around the handler, for the scope and the enabled state of the manager,
        // so when disabled the input events are completely bypassed.
        this.domHandler = function(ev) {
            if (boolOrFn(manager.options.enable, [
                manager
            ])) self1.handler(ev);
        };
        this.init();
    }
    Input.prototype = {
        /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */ handler: function() {},
        /**
     * bind the events
     */ init: function() {
            this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
            this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
            this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
        },
        /**
     * unbind the events
     */ destroy: function() {
            this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
            this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
            this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
        }
    };
    /**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */ function createInputInstance(manager) {
        var Type;
        var inputClass = manager.options.inputClass;
        if (inputClass) Type = inputClass;
        else if (SUPPORT_POINTER_EVENTS) Type = PointerEventInput;
        else if (SUPPORT_ONLY_TOUCH) Type = TouchInput;
        else if (!SUPPORT_TOUCH) Type = MouseInput;
        else Type = TouchMouseInput;
        return new Type(manager, inputHandler);
    }
    /**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */ function inputHandler(manager, eventType, input) {
        var pointersLen = input.pointers.length;
        var changedPointersLen = input.changedPointers.length;
        var isFirst = eventType & INPUT_START && pointersLen - changedPointersLen === 0;
        var isFinal = eventType & (INPUT_END | INPUT_CANCEL) && pointersLen - changedPointersLen === 0;
        input.isFirst = !!isFirst;
        input.isFinal = !!isFinal;
        if (isFirst) manager.session = {};
        // source event is the normalized value of the domEvents
        // like 'touchstart, mouseup, pointerdown'
        input.eventType = eventType;
        // compute scale, rotation etc
        computeInputData(manager, input);
        // emit secret event
        manager.emit('hammer.input', input);
        manager.recognize(input);
        manager.session.prevInput = input;
    }
    /**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */ function computeInputData(manager, input) {
        var session = manager.session;
        var pointers = input.pointers;
        var pointersLength = pointers.length;
        // store the first input to calculate the distance and direction
        if (!session.firstInput) session.firstInput = simpleCloneInputData(input);
        // to compute scale and rotation we need to store the multiple touches
        if (pointersLength > 1 && !session.firstMultiple) session.firstMultiple = simpleCloneInputData(input);
        else if (pointersLength === 1) session.firstMultiple = false;
        var firstInput = session.firstInput;
        var firstMultiple = session.firstMultiple;
        var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;
        var center = input.center = getCenter(pointers);
        input.timeStamp = now();
        input.deltaTime = input.timeStamp - firstInput.timeStamp;
        input.angle = getAngle(offsetCenter, center);
        input.distance = getDistance(offsetCenter, center);
        computeDeltaXY(session, input);
        input.offsetDirection = getDirection(input.deltaX, input.deltaY);
        var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
        input.overallVelocityX = overallVelocity.x;
        input.overallVelocityY = overallVelocity.y;
        input.overallVelocity = abs(overallVelocity.x) > abs(overallVelocity.y) ? overallVelocity.x : overallVelocity.y;
        input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
        input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;
        input.maxPointers = !session.prevInput ? input.pointers.length : input.pointers.length > session.prevInput.maxPointers ? input.pointers.length : session.prevInput.maxPointers;
        computeIntervalInputData(session, input);
        // find the correct target
        var target = manager.element;
        if (hasParent(input.srcEvent.target, target)) target = input.srcEvent.target;
        input.target = target;
    }
    function computeDeltaXY(session, input) {
        var center = input.center;
        var offset = session.offsetDelta || {};
        var prevDelta = session.prevDelta || {};
        var prevInput = session.prevInput || {};
        if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
            prevDelta = session.prevDelta = {
                x: prevInput.deltaX || 0,
                y: prevInput.deltaY || 0
            };
            offset = session.offsetDelta = {
                x: center.x,
                y: center.y
            };
        }
        input.deltaX = prevDelta.x + (center.x - offset.x);
        input.deltaY = prevDelta.y + (center.y - offset.y);
    }
    /**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */ function computeIntervalInputData(session, input) {
        var last = session.lastInterval || input, deltaTime = input.timeStamp - last.timeStamp, velocity, velocityX, velocityY, direction;
        if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
            var deltaX = input.deltaX - last.deltaX;
            var deltaY = input.deltaY - last.deltaY;
            var v = getVelocity(deltaTime, deltaX, deltaY);
            velocityX = v.x;
            velocityY = v.y;
            velocity = abs(v.x) > abs(v.y) ? v.x : v.y;
            direction = getDirection(deltaX, deltaY);
            session.lastInterval = input;
        } else {
            // use latest velocity info if it doesn't overtake a minimum period
            velocity = last.velocity;
            velocityX = last.velocityX;
            velocityY = last.velocityY;
            direction = last.direction;
        }
        input.velocity = velocity;
        input.velocityX = velocityX;
        input.velocityY = velocityY;
        input.direction = direction;
    }
    /**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */ function simpleCloneInputData(input) {
        // make a simple copy of the pointers because we will get a reference if we don't
        // we only need clientXY for the calculations
        var pointers = [];
        var i = 0;
        while(i < input.pointers.length){
            pointers[i] = {
                clientX: round(input.pointers[i].clientX),
                clientY: round(input.pointers[i].clientY)
            };
            i++;
        }
        return {
            timeStamp: now(),
            pointers: pointers,
            center: getCenter(pointers),
            deltaX: input.deltaX,
            deltaY: input.deltaY
        };
    }
    /**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */ function getCenter(pointers) {
        var pointersLength = pointers.length;
        // no need to loop when only one touch
        if (pointersLength === 1) return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
        var x = 0, y = 0, i = 0;
        while(i < pointersLength){
            x += pointers[i].clientX;
            y += pointers[i].clientY;
            i++;
        }
        return {
            x: round(x / pointersLength),
            y: round(y / pointersLength)
        };
    }
    /**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */ function getVelocity(deltaTime, x, y) {
        return {
            x: x / deltaTime || 0,
            y: y / deltaTime || 0
        };
    }
    /**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */ function getDirection(x, y) {
        if (x === y) return DIRECTION_NONE;
        if (abs(x) >= abs(y)) return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
        return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
    }
    /**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */ function getDistance(p1, p2, props) {
        if (!props) props = PROPS_XY;
        var x = p2[props[0]] - p1[props[0]], y = p2[props[1]] - p1[props[1]];
        return Math.sqrt(x * x + y * y);
    }
    /**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */ function getAngle(p1, p2, props) {
        if (!props) props = PROPS_XY;
        var x = p2[props[0]] - p1[props[0]], y = p2[props[1]] - p1[props[1]];
        return Math.atan2(y, x) * 180 / Math.PI;
    }
    /**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */ function getRotation(start, end) {
        return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
    }
    /**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */ function getScale(start, end) {
        return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
    }
    var MOUSE_INPUT_MAP = {
        mousedown: INPUT_START,
        mousemove: INPUT_MOVE,
        mouseup: INPUT_END
    };
    var MOUSE_ELEMENT_EVENTS = 'mousedown';
    var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';
    /**
 * Mouse events input
 * @constructor
 * @extends Input
 */ function MouseInput() {
        this.evEl = MOUSE_ELEMENT_EVENTS;
        this.evWin = MOUSE_WINDOW_EVENTS;
        this.pressed = false; // mousedown state
        Input.apply(this, arguments);
    }
    inherit(MouseInput, Input, {
        /**
     * handle mouse events
     * @param {Object} ev
     */ handler: function MEhandler(ev) {
            var eventType = MOUSE_INPUT_MAP[ev.type];
            // on start we want to have the left mouse button down
            if (eventType & INPUT_START && ev.button === 0) this.pressed = true;
            if (eventType & INPUT_MOVE && ev.which !== 1) eventType = INPUT_END;
            // mouse must be down
            if (!this.pressed) return;
            if (eventType & INPUT_END) this.pressed = false;
            this.callback(this.manager, eventType, {
                pointers: [
                    ev
                ],
                changedPointers: [
                    ev
                ],
                pointerType: INPUT_TYPE_MOUSE,
                srcEvent: ev
            });
        }
    });
    var POINTER_INPUT_MAP = {
        pointerdown: INPUT_START,
        pointermove: INPUT_MOVE,
        pointerup: INPUT_END,
        pointercancel: INPUT_CANCEL,
        pointerout: INPUT_CANCEL
    };
    // in IE10 the pointer types is defined as an enum
    var IE10_POINTER_TYPE_ENUM = {
        2: INPUT_TYPE_TOUCH,
        3: INPUT_TYPE_PEN,
        4: INPUT_TYPE_MOUSE,
        5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
    };
    var POINTER_ELEMENT_EVENTS = 'pointerdown';
    var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';
    // IE10 has prefixed support, and case-sensitive
    if (window1.MSPointerEvent && !window1.PointerEvent) {
        POINTER_ELEMENT_EVENTS = 'MSPointerDown';
        POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
    }
    /**
 * Pointer events input
 * @constructor
 * @extends Input
 */ function PointerEventInput() {
        this.evEl = POINTER_ELEMENT_EVENTS;
        this.evWin = POINTER_WINDOW_EVENTS;
        Input.apply(this, arguments);
        this.store = this.manager.session.pointerEvents = [];
    }
    inherit(PointerEventInput, Input, {
        /**
     * handle mouse events
     * @param {Object} ev
     */ handler: function PEhandler(ev) {
            var store = this.store;
            var removePointer = false;
            var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
            var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
            var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;
            var isTouch = pointerType == INPUT_TYPE_TOUCH;
            // get index of the event in the store
            var storeIndex = inArray(store, ev.pointerId, 'pointerId');
            // start and mouse must be down
            if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
                if (storeIndex < 0) {
                    store.push(ev);
                    storeIndex = store.length - 1;
                }
            } else if (eventType & (INPUT_END | INPUT_CANCEL)) removePointer = true;
            // it not found, so the pointer hasn't been down (so it's probably a hover)
            if (storeIndex < 0) return;
            // update the event in the store
            store[storeIndex] = ev;
            this.callback(this.manager, eventType, {
                pointers: store,
                changedPointers: [
                    ev
                ],
                pointerType: pointerType,
                srcEvent: ev
            });
            if (removePointer) // remove from the store
            store.splice(storeIndex, 1);
        }
    });
    var SINGLE_TOUCH_INPUT_MAP = {
        touchstart: INPUT_START,
        touchmove: INPUT_MOVE,
        touchend: INPUT_END,
        touchcancel: INPUT_CANCEL
    };
    var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
    var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';
    /**
 * Touch events input
 * @constructor
 * @extends Input
 */ function SingleTouchInput() {
        this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
        this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
        this.started = false;
        Input.apply(this, arguments);
    }
    inherit(SingleTouchInput, Input, {
        handler: function TEhandler(ev) {
            var type = SINGLE_TOUCH_INPUT_MAP[ev.type];
            // should we handle the touch events?
            if (type === INPUT_START) this.started = true;
            if (!this.started) return;
            var touches = normalizeSingleTouches.call(this, ev, type);
            // when done, reset the started state
            if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) this.started = false;
            this.callback(this.manager, type, {
                pointers: touches[0],
                changedPointers: touches[1],
                pointerType: INPUT_TYPE_TOUCH,
                srcEvent: ev
            });
        }
    });
    /**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */ function normalizeSingleTouches(ev, type) {
        var all = toArray(ev.touches);
        var changed = toArray(ev.changedTouches);
        if (type & (INPUT_END | INPUT_CANCEL)) all = uniqueArray(all.concat(changed), 'identifier', true);
        return [
            all,
            changed
        ];
    }
    var TOUCH_INPUT_MAP = {
        touchstart: INPUT_START,
        touchmove: INPUT_MOVE,
        touchend: INPUT_END,
        touchcancel: INPUT_CANCEL
    };
    var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';
    /**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */ function TouchInput() {
        this.evTarget = TOUCH_TARGET_EVENTS;
        this.targetIds = {};
        Input.apply(this, arguments);
    }
    inherit(TouchInput, Input, {
        handler: function MTEhandler(ev) {
            var type = TOUCH_INPUT_MAP[ev.type];
            var touches = getTouches.call(this, ev, type);
            if (!touches) return;
            this.callback(this.manager, type, {
                pointers: touches[0],
                changedPointers: touches[1],
                pointerType: INPUT_TYPE_TOUCH,
                srcEvent: ev
            });
        }
    });
    /**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */ function getTouches(ev, type) {
        var allTouches = toArray(ev.touches);
        var targetIds = this.targetIds;
        // when there is only one touch, the process can be simplified
        if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
            targetIds[allTouches[0].identifier] = true;
            return [
                allTouches,
                allTouches
            ];
        }
        var i, targetTouches, changedTouches = toArray(ev.changedTouches), changedTargetTouches = [], target = this.target;
        // get target touches from touches
        targetTouches = allTouches.filter(function(touch) {
            return hasParent(touch.target, target);
        });
        // collect touches
        if (type === INPUT_START) {
            i = 0;
            while(i < targetTouches.length){
                targetIds[targetTouches[i].identifier] = true;
                i++;
            }
        }
        // filter changed touches to only contain touches that exist in the collected target ids
        i = 0;
        while(i < changedTouches.length){
            if (targetIds[changedTouches[i].identifier]) changedTargetTouches.push(changedTouches[i]);
            // cleanup removed touches
            if (type & (INPUT_END | INPUT_CANCEL)) delete targetIds[changedTouches[i].identifier];
            i++;
        }
        if (!changedTargetTouches.length) return;
        return [
            // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
            uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
            changedTargetTouches
        ];
    }
    /**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */ var DEDUP_TIMEOUT = 2500;
    var DEDUP_DISTANCE = 25;
    function TouchMouseInput() {
        Input.apply(this, arguments);
        var handler = bindFn(this.handler, this);
        this.touch = new TouchInput(this.manager, handler);
        this.mouse = new MouseInput(this.manager, handler);
        this.primaryTouch = null;
        this.lastTouches = [];
    }
    inherit(TouchMouseInput, Input, {
        /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */ handler: function TMEhandler(manager, inputEvent, inputData) {
            var isTouch = inputData.pointerType == INPUT_TYPE_TOUCH, isMouse = inputData.pointerType == INPUT_TYPE_MOUSE;
            if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) return;
            // when we're in a touch event, record touches to  de-dupe synthetic mouse event
            if (isTouch) recordTouches.call(this, inputEvent, inputData);
            else if (isMouse && isSyntheticEvent.call(this, inputData)) return;
            this.callback(manager, inputEvent, inputData);
        },
        /**
     * remove the event listeners
     */ destroy: function destroy() {
            this.touch.destroy();
            this.mouse.destroy();
        }
    });
    function recordTouches(eventType, eventData) {
        if (eventType & INPUT_START) {
            this.primaryTouch = eventData.changedPointers[0].identifier;
            setLastTouch.call(this, eventData);
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) setLastTouch.call(this, eventData);
    }
    function setLastTouch(eventData) {
        var touch = eventData.changedPointers[0];
        if (touch.identifier === this.primaryTouch) {
            var lastTouch = {
                x: touch.clientX,
                y: touch.clientY
            };
            this.lastTouches.push(lastTouch);
            var lts = this.lastTouches;
            var removeLastTouch = function() {
                var i = lts.indexOf(lastTouch);
                if (i > -1) lts.splice(i, 1);
            };
            setTimeout(removeLastTouch, DEDUP_TIMEOUT);
        }
    }
    function isSyntheticEvent(eventData) {
        var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
        for(var i = 0; i < this.lastTouches.length; i++){
            var t = this.lastTouches[i];
            var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
            if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) return true;
        }
        return false;
    }
    var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
    var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;
    // magical touchAction value
    var TOUCH_ACTION_COMPUTE = 'compute';
    var TOUCH_ACTION_AUTO = 'auto';
    var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
    var TOUCH_ACTION_NONE = 'none';
    var TOUCH_ACTION_PAN_X = 'pan-x';
    var TOUCH_ACTION_PAN_Y = 'pan-y';
    var TOUCH_ACTION_MAP = getTouchActionProps();
    /**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */ function TouchAction(manager, value) {
        this.manager = manager;
        this.set(value);
    }
    TouchAction.prototype = {
        /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */ set: function(value) {
            // find out the touch-action by the event handlers
            if (value == TOUCH_ACTION_COMPUTE) value = this.compute();
            if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
            this.actions = value.toLowerCase().trim();
        },
        /**
     * just re-set the touchAction value
     */ update: function() {
            this.set(this.manager.options.touchAction);
        },
        /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */ compute: function() {
            var actions = [];
            each(this.manager.recognizers, function(recognizer) {
                if (boolOrFn(recognizer.options.enable, [
                    recognizer
                ])) actions = actions.concat(recognizer.getTouchAction());
            });
            return cleanTouchActions(actions.join(' '));
        },
        /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */ preventDefaults: function(input) {
            var srcEvent = input.srcEvent;
            var direction = input.offsetDirection;
            // if the touch action did prevented once this session
            if (this.manager.session.prevented) {
                srcEvent.preventDefault();
                return;
            }
            var actions = this.actions;
            var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
            var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
            var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];
            if (hasNone) {
                //do not prevent defaults if this is a tap gesture
                var isTapPointer = input.pointers.length === 1;
                var isTapMovement = input.distance < 2;
                var isTapTouchTime = input.deltaTime < 250;
                if (isTapPointer && isTapMovement && isTapTouchTime) return;
            }
            if (hasPanX && hasPanY) // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
            if (hasNone || hasPanY && direction & DIRECTION_HORIZONTAL || hasPanX && direction & DIRECTION_VERTICAL) return this.preventSrc(srcEvent);
        },
        /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */ preventSrc: function(srcEvent) {
            this.manager.session.prevented = true;
            srcEvent.preventDefault();
        }
    };
    /**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */ function cleanTouchActions(actions) {
        // none
        if (inStr(actions, TOUCH_ACTION_NONE)) return TOUCH_ACTION_NONE;
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);
        // if both pan-x and pan-y are set (different recognizers
        // for different directions, e.g. horizontal pan but vertical swipe?)
        // we need none (as otherwise with pan-x pan-y combined none of these
        // recognizers will work, since the browser would handle all panning
        if (hasPanX && hasPanY) return TOUCH_ACTION_NONE;
        // pan-x OR pan-y
        if (hasPanX || hasPanY) return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
        // manipulation
        if (inStr(actions, TOUCH_ACTION_MANIPULATION)) return TOUCH_ACTION_MANIPULATION;
        return TOUCH_ACTION_AUTO;
    }
    function getTouchActionProps() {
        if (!NATIVE_TOUCH_ACTION) return false;
        var touchMap = {};
        var cssSupports = window1.CSS && window1.CSS.supports;
        [
            'auto',
            'manipulation',
            'pan-y',
            'pan-x',
            'pan-x pan-y',
            'none'
        ].forEach(function(val) {
            // If css.supports is not supported but there is native touch-action assume it supports
            // all values. This is the case for IE 10 and 11.
            touchMap[val] = cssSupports ? window1.CSS.supports('touch-action', val) : true;
        });
        return touchMap;
    }
    /**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */ var STATE_POSSIBLE = 1;
    var STATE_BEGAN = 2;
    var STATE_CHANGED = 4;
    var STATE_ENDED = 8;
    var STATE_RECOGNIZED = STATE_ENDED;
    var STATE_CANCELLED = 16;
    var STATE_FAILED = 32;
    /**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */ function Recognizer(options) {
        this.options = assign({}, this.defaults, options || {});
        this.id = uniqueId();
        this.manager = null;
        // default is enable true
        this.options.enable = ifUndefined(this.options.enable, true);
        this.state = STATE_POSSIBLE;
        this.simultaneous = {};
        this.requireFail = [];
    }
    Recognizer.prototype = {
        /**
     * @virtual
     * @type {Object}
     */ defaults: {},
        /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */ set: function(options) {
            assign(this.options, options);
            // also update the touchAction, in case something changed about the directions/enabled state
            this.manager && this.manager.touchAction.update();
            return this;
        },
        /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */ recognizeWith: function(otherRecognizer) {
            if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) return this;
            var simultaneous = this.simultaneous;
            otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
            if (!simultaneous[otherRecognizer.id]) {
                simultaneous[otherRecognizer.id] = otherRecognizer;
                otherRecognizer.recognizeWith(this);
            }
            return this;
        },
        /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */ dropRecognizeWith: function(otherRecognizer) {
            if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) return this;
            otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
            delete this.simultaneous[otherRecognizer.id];
            return this;
        },
        /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */ requireFailure: function(otherRecognizer) {
            if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) return this;
            var requireFail = this.requireFail;
            otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
            if (inArray(requireFail, otherRecognizer) === -1) {
                requireFail.push(otherRecognizer);
                otherRecognizer.requireFailure(this);
            }
            return this;
        },
        /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */ dropRequireFailure: function(otherRecognizer) {
            if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) return this;
            otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
            var index = inArray(this.requireFail, otherRecognizer);
            if (index > -1) this.requireFail.splice(index, 1);
            return this;
        },
        /**
     * has require failures boolean
     * @returns {boolean}
     */ hasRequireFailures: function() {
            return this.requireFail.length > 0;
        },
        /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */ canRecognizeWith: function(otherRecognizer) {
            return !!this.simultaneous[otherRecognizer.id];
        },
        /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */ emit: function(input) {
            var self1 = this;
            var state = this.state;
            function emit(event) {
                self1.manager.emit(event, input);
            }
            // 'panstart' and 'panmove'
            if (state < STATE_ENDED) emit(self1.options.event + stateStr(state));
            emit(self1.options.event); // simple 'eventName' events
            if (input.additionalEvent) emit(input.additionalEvent);
            // panend and pancancel
            if (state >= STATE_ENDED) emit(self1.options.event + stateStr(state));
        },
        /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */ tryEmit: function(input) {
            if (this.canEmit()) return this.emit(input);
            // it's failing anyway
            this.state = STATE_FAILED;
        },
        /**
     * can we emit?
     * @returns {boolean}
     */ canEmit: function() {
            var i = 0;
            while(i < this.requireFail.length){
                if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) return false;
                i++;
            }
            return true;
        },
        /**
     * update the recognizer
     * @param {Object} inputData
     */ recognize: function(inputData) {
            // make a new copy of the inputData
            // so we can change the inputData without messing up the other recognizers
            var inputDataClone = assign({}, inputData);
            // is is enabled and allow recognizing?
            if (!boolOrFn(this.options.enable, [
                this,
                inputDataClone
            ])) {
                this.reset();
                this.state = STATE_FAILED;
                return;
            }
            // reset when we've reached the end
            if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) this.state = STATE_POSSIBLE;
            this.state = this.process(inputDataClone);
            // the recognizer has recognized a gesture
            // so trigger an event
            if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) this.tryEmit(inputDataClone);
        },
        /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */ process: function(inputData) {},
        /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */ getTouchAction: function() {},
        /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */ reset: function() {}
    };
    /**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */ function stateStr(state) {
        if (state & STATE_CANCELLED) return 'cancel';
        else if (state & STATE_ENDED) return 'end';
        else if (state & STATE_CHANGED) return 'move';
        else if (state & STATE_BEGAN) return 'start';
        return '';
    }
    /**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */ function directionStr(direction) {
        if (direction == DIRECTION_DOWN) return 'down';
        else if (direction == DIRECTION_UP) return 'up';
        else if (direction == DIRECTION_LEFT) return 'left';
        else if (direction == DIRECTION_RIGHT) return 'right';
        return '';
    }
    /**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */ function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
        var manager = recognizer.manager;
        if (manager) return manager.get(otherRecognizer);
        return otherRecognizer;
    }
    /**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */ function AttrRecognizer() {
        Recognizer.apply(this, arguments);
    }
    inherit(AttrRecognizer, Recognizer, {
        /**
     * @namespace
     * @memberof AttrRecognizer
     */ defaults: {
            /**
         * @type {Number}
         * @default 1
         */ pointers: 1
        },
        /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */ attrTest: function(input) {
            var optionPointers = this.options.pointers;
            return optionPointers === 0 || input.pointers.length === optionPointers;
        },
        /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */ process: function(input) {
            var state = this.state;
            var eventType = input.eventType;
            var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
            var isValid = this.attrTest(input);
            // on cancel input and we've recognized before, return STATE_CANCELLED
            if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) return state | STATE_CANCELLED;
            else if (isRecognized || isValid) {
                if (eventType & INPUT_END) return state | STATE_ENDED;
                else if (!(state & STATE_BEGAN)) return STATE_BEGAN;
                return state | STATE_CHANGED;
            }
            return STATE_FAILED;
        }
    });
    /**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */ function PanRecognizer() {
        AttrRecognizer.apply(this, arguments);
        this.pX = null;
        this.pY = null;
    }
    inherit(PanRecognizer, AttrRecognizer, {
        /**
     * @namespace
     * @memberof PanRecognizer
     */ defaults: {
            event: 'pan',
            threshold: 10,
            pointers: 1,
            direction: DIRECTION_ALL
        },
        getTouchAction: function() {
            var direction = this.options.direction;
            var actions = [];
            if (direction & DIRECTION_HORIZONTAL) actions.push(TOUCH_ACTION_PAN_Y);
            if (direction & DIRECTION_VERTICAL) actions.push(TOUCH_ACTION_PAN_X);
            return actions;
        },
        directionTest: function(input) {
            var options = this.options;
            var hasMoved = true;
            var distance = input.distance;
            var direction = input.direction;
            var x = input.deltaX;
            var y = input.deltaY;
            // lock to axis?
            if (!(direction & options.direction)) {
                if (options.direction & DIRECTION_HORIZONTAL) {
                    direction = x === 0 ? DIRECTION_NONE : x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
                    hasMoved = x != this.pX;
                    distance = Math.abs(input.deltaX);
                } else {
                    direction = y === 0 ? DIRECTION_NONE : y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
                    hasMoved = y != this.pY;
                    distance = Math.abs(input.deltaY);
                }
            }
            input.direction = direction;
            return hasMoved && distance > options.threshold && direction & options.direction;
        },
        attrTest: function(input) {
            return AttrRecognizer.prototype.attrTest.call(this, input) && (this.state & STATE_BEGAN || !(this.state & STATE_BEGAN) && this.directionTest(input));
        },
        emit: function(input) {
            this.pX = input.deltaX;
            this.pY = input.deltaY;
            var direction = directionStr(input.direction);
            if (direction) input.additionalEvent = this.options.event + direction;
            this._super.emit.call(this, input);
        }
    });
    /**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */ function PinchRecognizer() {
        AttrRecognizer.apply(this, arguments);
    }
    inherit(PinchRecognizer, AttrRecognizer, {
        /**
     * @namespace
     * @memberof PinchRecognizer
     */ defaults: {
            event: 'pinch',
            threshold: 0,
            pointers: 2
        },
        getTouchAction: function() {
            return [
                TOUCH_ACTION_NONE
            ];
        },
        attrTest: function(input) {
            return this._super.attrTest.call(this, input) && (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
        },
        emit: function(input) {
            if (input.scale !== 1) {
                var inOut = input.scale < 1 ? 'in' : 'out';
                input.additionalEvent = this.options.event + inOut;
            }
            this._super.emit.call(this, input);
        }
    });
    /**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */ function PressRecognizer() {
        Recognizer.apply(this, arguments);
        this._timer = null;
        this._input = null;
    }
    inherit(PressRecognizer, Recognizer, {
        /**
     * @namespace
     * @memberof PressRecognizer
     */ defaults: {
            event: 'press',
            pointers: 1,
            time: 251,
            threshold: 9 // a minimal movement is ok, but keep it low
        },
        getTouchAction: function() {
            return [
                TOUCH_ACTION_AUTO
            ];
        },
        process: function(input) {
            var options = this.options;
            var validPointers = input.pointers.length === options.pointers;
            var validMovement = input.distance < options.threshold;
            var validTime = input.deltaTime > options.time;
            this._input = input;
            // we only allow little movement
            // and we've reached an end event, so a tap is possible
            if (!validMovement || !validPointers || input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime) this.reset();
            else if (input.eventType & INPUT_START) {
                this.reset();
                this._timer = setTimeoutContext(function() {
                    this.state = STATE_RECOGNIZED;
                    this.tryEmit();
                }, options.time, this);
            } else if (input.eventType & INPUT_END) return STATE_RECOGNIZED;
            return STATE_FAILED;
        },
        reset: function() {
            clearTimeout(this._timer);
        },
        emit: function(input) {
            if (this.state !== STATE_RECOGNIZED) return;
            if (input && input.eventType & INPUT_END) this.manager.emit(this.options.event + 'up', input);
            else {
                this._input.timeStamp = now();
                this.manager.emit(this.options.event, this._input);
            }
        }
    });
    /**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */ function RotateRecognizer() {
        AttrRecognizer.apply(this, arguments);
    }
    inherit(RotateRecognizer, AttrRecognizer, {
        /**
     * @namespace
     * @memberof RotateRecognizer
     */ defaults: {
            event: 'rotate',
            threshold: 0,
            pointers: 2
        },
        getTouchAction: function() {
            return [
                TOUCH_ACTION_NONE
            ];
        },
        attrTest: function(input) {
            return this._super.attrTest.call(this, input) && (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
        }
    });
    /**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */ function SwipeRecognizer() {
        AttrRecognizer.apply(this, arguments);
    }
    inherit(SwipeRecognizer, AttrRecognizer, {
        /**
     * @namespace
     * @memberof SwipeRecognizer
     */ defaults: {
            event: 'swipe',
            threshold: 10,
            velocity: 0.3,
            direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
            pointers: 1
        },
        getTouchAction: function() {
            return PanRecognizer.prototype.getTouchAction.call(this);
        },
        attrTest: function(input) {
            var direction = this.options.direction;
            var velocity;
            if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) velocity = input.overallVelocity;
            else if (direction & DIRECTION_HORIZONTAL) velocity = input.overallVelocityX;
            else if (direction & DIRECTION_VERTICAL) velocity = input.overallVelocityY;
            return this._super.attrTest.call(this, input) && direction & input.offsetDirection && input.distance > this.options.threshold && input.maxPointers == this.options.pointers && abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
        },
        emit: function(input) {
            var direction = directionStr(input.offsetDirection);
            if (direction) this.manager.emit(this.options.event + direction, input);
            this.manager.emit(this.options.event, input);
        }
    });
    /**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */ function TapRecognizer() {
        Recognizer.apply(this, arguments);
        // previous time and center,
        // used for tap counting
        this.pTime = false;
        this.pCenter = false;
        this._timer = null;
        this._input = null;
        this.count = 0;
    }
    inherit(TapRecognizer, Recognizer, {
        /**
     * @namespace
     * @memberof PinchRecognizer
     */ defaults: {
            event: 'tap',
            pointers: 1,
            taps: 1,
            interval: 300,
            time: 250,
            threshold: 9,
            posThreshold: 10 // a multi-tap can be a bit off the initial position
        },
        getTouchAction: function() {
            return [
                TOUCH_ACTION_MANIPULATION
            ];
        },
        process: function(input) {
            var options = this.options;
            var validPointers = input.pointers.length === options.pointers;
            var validMovement = input.distance < options.threshold;
            var validTouchTime = input.deltaTime < options.time;
            this.reset();
            if (input.eventType & INPUT_START && this.count === 0) return this.failTimeout();
            // we only allow little movement
            // and we've reached an end event, so a tap is possible
            if (validMovement && validTouchTime && validPointers) {
                if (input.eventType != INPUT_END) return this.failTimeout();
                var validInterval = this.pTime ? input.timeStamp - this.pTime < options.interval : true;
                var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;
                this.pTime = input.timeStamp;
                this.pCenter = input.center;
                if (!validMultiTap || !validInterval) this.count = 1;
                else this.count += 1;
                this._input = input;
                // if tap count matches we have recognized it,
                // else it has began recognizing...
                var tapCount = this.count % options.taps;
                if (tapCount === 0) {
                    // no failing requirements, immediately trigger the tap event
                    // or wait as long as the multitap interval to trigger
                    if (!this.hasRequireFailures()) return STATE_RECOGNIZED;
                    else {
                        this._timer = setTimeoutContext(function() {
                            this.state = STATE_RECOGNIZED;
                            this.tryEmit();
                        }, options.interval, this);
                        return STATE_BEGAN;
                    }
                }
            }
            return STATE_FAILED;
        },
        failTimeout: function() {
            this._timer = setTimeoutContext(function() {
                this.state = STATE_FAILED;
            }, this.options.interval, this);
            return STATE_FAILED;
        },
        reset: function() {
            clearTimeout(this._timer);
        },
        emit: function() {
            if (this.state == STATE_RECOGNIZED) {
                this._input.tapCount = this.count;
                this.manager.emit(this.options.event, this._input);
            }
        }
    });
    /**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */ function Hammer(element, options) {
        options = options || {};
        options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
        return new Manager(element, options);
    }
    /**
 * @const {string}
 */ Hammer.VERSION = '2.0.7';
    /**
 * default settings
 * @namespace
 */ Hammer.defaults = {
        /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */ domEvents: false,
        /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */ touchAction: TOUCH_ACTION_COMPUTE,
        /**
     * @type {Boolean}
     * @default true
     */ enable: true,
        /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */ inputTarget: null,
        /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */ inputClass: null,
        /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */ preset: [
            // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
            [
                RotateRecognizer,
                {
                    enable: false
                }
            ],
            [
                PinchRecognizer,
                {
                    enable: false
                },
                [
                    'rotate'
                ]
            ],
            [
                SwipeRecognizer,
                {
                    direction: DIRECTION_HORIZONTAL
                }
            ],
            [
                PanRecognizer,
                {
                    direction: DIRECTION_HORIZONTAL
                },
                [
                    'swipe'
                ]
            ],
            [
                TapRecognizer
            ],
            [
                TapRecognizer,
                {
                    event: 'doubletap',
                    taps: 2
                },
                [
                    'tap'
                ]
            ],
            [
                PressRecognizer
            ]
        ],
        /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */ cssProps: {
            /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */ userSelect: 'none',
            /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */ touchSelect: 'none',
            /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */ touchCallout: 'none',
            /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */ contentZooming: 'none',
            /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */ userDrag: 'none',
            /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */ tapHighlightColor: 'rgba(0,0,0,0)'
        }
    };
    var STOP = 1;
    var FORCED_STOP = 2;
    /**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */ function Manager(element, options) {
        this.options = assign({}, Hammer.defaults, options || {});
        this.options.inputTarget = this.options.inputTarget || element;
        this.handlers = {};
        this.session = {};
        this.recognizers = [];
        this.oldCssProps = {};
        this.element = element;
        this.input = createInputInstance(this);
        this.touchAction = new TouchAction(this, this.options.touchAction);
        toggleCssProps(this, true);
        each(this.options.recognizers, function(item) {
            var recognizer = this.add(new item[0](item[1]));
            item[2] && recognizer.recognizeWith(item[2]);
            item[3] && recognizer.requireFailure(item[3]);
        }, this);
    }
    Manager.prototype = {
        /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */ set: function(options) {
            assign(this.options, options);
            // Options that need a little more setup
            if (options.touchAction) this.touchAction.update();
            if (options.inputTarget) {
                // Clean up existing event listeners and reinitialize
                this.input.destroy();
                this.input.target = options.inputTarget;
                this.input.init();
            }
            return this;
        },
        /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */ stop: function(force) {
            this.session.stopped = force ? FORCED_STOP : STOP;
        },
        /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */ recognize: function(inputData) {
            var session = this.session;
            if (session.stopped) return;
            // run the touch-action polyfill
            this.touchAction.preventDefaults(inputData);
            var recognizer;
            var recognizers = this.recognizers;
            // this holds the recognizer that is being recognized.
            // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
            // if no recognizer is detecting a thing, it is set to `null`
            var curRecognizer = session.curRecognizer;
            // reset when the last recognizer is recognized
            // or when we're in a new session
            if (!curRecognizer || curRecognizer && curRecognizer.state & STATE_RECOGNIZED) curRecognizer = session.curRecognizer = null;
            var i = 0;
            while(i < recognizers.length){
                recognizer = recognizers[i];
                // find out if we are allowed try to recognize the input for this one.
                // 1.   allow if the session is NOT forced stopped (see the .stop() method)
                // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
                //      that is being recognized.
                // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
                //      this can be setup with the `recognizeWith()` method on the recognizer.
                if (session.stopped !== FORCED_STOP && (!curRecognizer || recognizer == curRecognizer || // 2
                recognizer.canRecognizeWith(curRecognizer))) recognizer.recognize(inputData);
                else recognizer.reset();
                // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
                // current active recognizer. but only if we don't already have an active recognizer
                if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) curRecognizer = session.curRecognizer = recognizer;
                i++;
            }
        },
        /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */ get: function(recognizer) {
            if (recognizer instanceof Recognizer) return recognizer;
            var recognizers = this.recognizers;
            for(var i = 0; i < recognizers.length; i++){
                if (recognizers[i].options.event == recognizer) return recognizers[i];
            }
            return null;
        },
        /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */ add: function(recognizer) {
            if (invokeArrayArg(recognizer, 'add', this)) return this;
            // remove existing
            var existing = this.get(recognizer.options.event);
            if (existing) this.remove(existing);
            this.recognizers.push(recognizer);
            recognizer.manager = this;
            this.touchAction.update();
            return recognizer;
        },
        /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */ remove: function(recognizer) {
            if (invokeArrayArg(recognizer, 'remove', this)) return this;
            recognizer = this.get(recognizer);
            // let's make sure this recognizer exists
            if (recognizer) {
                var recognizers = this.recognizers;
                var index = inArray(recognizers, recognizer);
                if (index !== -1) {
                    recognizers.splice(index, 1);
                    this.touchAction.update();
                }
            }
            return this;
        },
        /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */ on: function(events, handler) {
            if (events === undefined) return;
            if (handler === undefined) return;
            var handlers = this.handlers;
            each(splitStr(events), function(event) {
                handlers[event] = handlers[event] || [];
                handlers[event].push(handler);
            });
            return this;
        },
        /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */ off: function(events, handler) {
            if (events === undefined) return;
            var handlers = this.handlers;
            each(splitStr(events), function(event) {
                if (!handler) delete handlers[event];
                else handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            });
            return this;
        },
        /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */ emit: function(event, data) {
            // we also want to trigger dom events
            if (this.options.domEvents) triggerDomEvent(event, data);
            // no handlers, so skip it all
            var handlers = this.handlers[event] && this.handlers[event].slice();
            if (!handlers || !handlers.length) return;
            data.type = event;
            data.preventDefault = function() {
                data.srcEvent.preventDefault();
            };
            var i = 0;
            while(i < handlers.length){
                handlers[i](data);
                i++;
            }
        },
        /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */ destroy: function() {
            this.element && toggleCssProps(this, false);
            this.handlers = {};
            this.session = {};
            this.input.destroy();
            this.element = null;
        }
    };
    /**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */ function toggleCssProps(manager, add) {
        var element = manager.element;
        if (!element.style) return;
        var prop;
        each(manager.options.cssProps, function(value, name) {
            prop = prefixed(element.style, name);
            if (add) {
                manager.oldCssProps[prop] = element.style[prop];
                element.style[prop] = value;
            } else element.style[prop] = manager.oldCssProps[prop] || '';
        });
        if (!add) manager.oldCssProps = {};
    }
    /**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */ function triggerDomEvent(event, data) {
        var gestureEvent = document1.createEvent('Event');
        gestureEvent.initEvent(event, true, true);
        gestureEvent.gesture = data;
        data.target.dispatchEvent(gestureEvent);
    }
    assign(Hammer, {
        INPUT_START: INPUT_START,
        INPUT_MOVE: INPUT_MOVE,
        INPUT_END: INPUT_END,
        INPUT_CANCEL: INPUT_CANCEL,
        STATE_POSSIBLE: STATE_POSSIBLE,
        STATE_BEGAN: STATE_BEGAN,
        STATE_CHANGED: STATE_CHANGED,
        STATE_ENDED: STATE_ENDED,
        STATE_RECOGNIZED: STATE_RECOGNIZED,
        STATE_CANCELLED: STATE_CANCELLED,
        STATE_FAILED: STATE_FAILED,
        DIRECTION_NONE: DIRECTION_NONE,
        DIRECTION_LEFT: DIRECTION_LEFT,
        DIRECTION_RIGHT: DIRECTION_RIGHT,
        DIRECTION_UP: DIRECTION_UP,
        DIRECTION_DOWN: DIRECTION_DOWN,
        DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
        DIRECTION_VERTICAL: DIRECTION_VERTICAL,
        DIRECTION_ALL: DIRECTION_ALL,
        Manager: Manager,
        Input: Input,
        TouchAction: TouchAction,
        TouchInput: TouchInput,
        MouseInput: MouseInput,
        PointerEventInput: PointerEventInput,
        TouchMouseInput: TouchMouseInput,
        SingleTouchInput: SingleTouchInput,
        Recognizer: Recognizer,
        AttrRecognizer: AttrRecognizer,
        Tap: TapRecognizer,
        Pan: PanRecognizer,
        Swipe: SwipeRecognizer,
        Pinch: PinchRecognizer,
        Rotate: RotateRecognizer,
        Press: PressRecognizer,
        on: addEventListeners,
        off: removeEventListeners,
        each: each,
        merge: merge,
        extend: extend,
        assign: assign,
        inherit: inherit,
        bindFn: bindFn,
        prefixed: prefixed
    });
    // this prevents errors when Hammer is loaded in the presence of an AMD
    //  style loader but by script tag, not by the loader.
    var freeGlobal = typeof window1 !== 'undefined' ? window1 : typeof self !== 'undefined' ? self : {}; // jshint ignore:line
    freeGlobal.Hammer = Hammer;
    if (typeof define === 'function' && define.amd) define(function() {
        return Hammer;
    });
    else if (module.exports) module.exports = Hammer;
    else window1[exportName] = Hammer;
})(window, document, 'Hammer');

},{}],"1hjlO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>TouchFix);
var _tinySvg = require("tiny-svg");
function TouchFix(eventBus) {
    var self = this;
    eventBus.on('canvas.init', function(e) {
        self.addBBoxMarker(e.svg);
    });
}
TouchFix.$inject = [
    'eventBus'
];
/**
 * Safari mobile (iOS 7) does not fire touchstart event in <SVG> element
 * if there is no shape between 0,0 and viewport elements origin.
 *
 * So touchstart event is only fired when the <g class="viewport"> element was hit.
 * Putting an element over and below the 'viewport' fixes that behavior.
 */ TouchFix.prototype.addBBoxMarker = function(svg) {
    var markerStyle = {
        fill: 'none',
        class: 'outer-bound-marker'
    };
    var rect1 = (0, _tinySvg.create)('rect');
    (0, _tinySvg.attr)(rect1, {
        x: -10000,
        y: 10000,
        width: 10,
        height: 10
    });
    (0, _tinySvg.attr)(rect1, markerStyle);
    (0, _tinySvg.append)(svg, rect1);
    var rect2 = (0, _tinySvg.create)('rect');
    (0, _tinySvg.attr)(rect2, {
        x: 10000,
        y: 10000,
        width: 10,
        height: 10
    });
    (0, _tinySvg.attr)(rect2, markerStyle);
    (0, _tinySvg.append)(svg, rect2);
};

},{"tiny-svg":"6ZtXA","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ktdKa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _alignElements = require("diagram-js/lib/features/align-elements");
var _alignElementsDefault = parcelHelpers.interopDefault(_alignElements);
var _contextPad = require("diagram-js/lib/features/context-pad");
var _contextPadDefault = parcelHelpers.interopDefault(_contextPad);
var _popupMenu = require("diagram-js/lib/features/popup-menu");
var _popupMenuDefault = parcelHelpers.interopDefault(_popupMenu);
var _alignElementsContextPadProvider = require("./AlignElementsContextPadProvider");
var _alignElementsContextPadProviderDefault = parcelHelpers.interopDefault(_alignElementsContextPadProvider);
var _alignElementsMenuProvider = require("./AlignElementsMenuProvider");
var _alignElementsMenuProviderDefault = parcelHelpers.interopDefault(_alignElementsMenuProvider);
var _bpmnAlignElements = require("./BpmnAlignElements");
var _bpmnAlignElementsDefault = parcelHelpers.interopDefault(_bpmnAlignElements);
exports.default = {
    __depends__: [
        (0, _alignElementsDefault.default),
        (0, _contextPadDefault.default),
        (0, _popupMenuDefault.default)
    ],
    __init__: [
        'alignElementsContextPadProvider',
        'alignElementsMenuProvider',
        'bpmnAlignElements'
    ],
    alignElementsContextPadProvider: [
        'type',
        (0, _alignElementsContextPadProviderDefault.default)
    ],
    alignElementsMenuProvider: [
        'type',
        (0, _alignElementsMenuProviderDefault.default)
    ],
    bpmnAlignElements: [
        'type',
        (0, _bpmnAlignElementsDefault.default)
    ]
};

},{"diagram-js/lib/features/align-elements":"44wAU","diagram-js/lib/features/context-pad":"ktSXO","diagram-js/lib/features/popup-menu":"iRpNh","./AlignElementsContextPadProvider":"9fvuH","./AlignElementsMenuProvider":"guogf","./BpmnAlignElements":"9pgN2","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"44wAU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _alignElements = require("./AlignElements");
var _alignElementsDefault = parcelHelpers.interopDefault(_alignElements);
exports.default = {
    __init__: [
        'alignElements'
    ],
    alignElements: [
        'type',
        (0, _alignElementsDefault.default)
    ]
};

},{"./AlignElements":"diENI","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"diENI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AlignElements);
var _minDash = require("min-dash");
/**
 * @typedef {import('../modeling/Modeling').default} Modeling
 * @typedef {import('../rules/Rules').default} Rules
 */ function last(arr) {
    return arr && arr[arr.length - 1];
}
function sortTopOrMiddle(element) {
    return element.y;
}
function sortLeftOrCenter(element) {
    return element.x;
}
/**
 * Sorting functions for different types of alignment
 *
 * @type {Object}
 *
 * @return {Function}
 */ var ALIGNMENT_SORTING = {
    left: sortLeftOrCenter,
    center: sortLeftOrCenter,
    right: function(element) {
        return element.x + element.width;
    },
    top: sortTopOrMiddle,
    middle: sortTopOrMiddle,
    bottom: function(element) {
        return element.y + element.height;
    }
};
function AlignElements(modeling, rules) {
    this._modeling = modeling;
    this._rules = rules;
}
AlignElements.$inject = [
    'modeling',
    'rules'
];
/**
 * Get the relevant "axis" and "dimension" related to the current type of alignment
 *
 * @param {string} type left|right|center|top|bottom|middle
 *
 * @return {Object} { axis, dimension }
 */ AlignElements.prototype._getOrientationDetails = function(type) {
    var vertical = [
        'top',
        'bottom',
        'middle'
    ], axis = 'x', dimension = 'width';
    if (vertical.indexOf(type) !== -1) {
        axis = 'y';
        dimension = 'height';
    }
    return {
        axis: axis,
        dimension: dimension
    };
};
AlignElements.prototype._isType = function(type, types) {
    return types.indexOf(type) !== -1;
};
/**
 * Get a point on the relevant axis where elements should align to
 *
 * @param {string} type left|right|center|top|bottom|middle
 * @param {Array} sortedElements
 *
 * @return {Object}
 */ AlignElements.prototype._alignmentPosition = function(type, sortedElements) {
    var orientation = this._getOrientationDetails(type), axis = orientation.axis, dimension = orientation.dimension, alignment = {}, centers = {}, hasSharedCenters = false, centeredElements, firstElement, lastElement;
    function getMiddleOrTop(first, last) {
        return Math.round((first[axis] + last[axis] + last[dimension]) / 2);
    }
    if (this._isType(type, [
        'left',
        'top'
    ])) alignment[type] = sortedElements[0][axis];
    else if (this._isType(type, [
        'right',
        'bottom'
    ])) {
        lastElement = last(sortedElements);
        alignment[type] = lastElement[axis] + lastElement[dimension];
    } else if (this._isType(type, [
        'center',
        'middle'
    ])) {
        // check if there is a center shared by more than one shape
        // if not, just take the middle of the range
        (0, _minDash.forEach)(sortedElements, function(element) {
            var center = element[axis] + Math.round(element[dimension] / 2);
            if (centers[center]) centers[center].elements.push(element);
            else centers[center] = {
                elements: [
                    element
                ],
                center: center
            };
        });
        centeredElements = (0, _minDash.sortBy)(centers, function(center) {
            if (center.elements.length > 1) hasSharedCenters = true;
            return center.elements.length;
        });
        if (hasSharedCenters) {
            alignment[type] = last(centeredElements).center;
            return alignment;
        }
        firstElement = sortedElements[0];
        sortedElements = (0, _minDash.sortBy)(sortedElements, function(element) {
            return element[axis] + element[dimension];
        });
        lastElement = last(sortedElements);
        alignment[type] = getMiddleOrTop(firstElement, lastElement);
    }
    return alignment;
};
/**
 * Executes the alignment of a selection of elements
 *
 * @param {Array} elements
 * @param {string} type left|right|center|top|bottom|middle
 */ AlignElements.prototype.trigger = function(elements, type) {
    var modeling = this._modeling, allowed;
    // filter out elements which cannot be aligned
    var filteredElements = (0, _minDash.filter)(elements, function(element) {
        return !(element.waypoints || element.host || element.labelTarget);
    });
    // filter out elements via rules
    allowed = this._rules.allowed('elements.align', {
        elements: filteredElements
    });
    if ((0, _minDash.isArray)(allowed)) filteredElements = allowed;
    if (filteredElements.length < 2 || !allowed) return;
    var sortFn = ALIGNMENT_SORTING[type];
    var sortedElements = (0, _minDash.sortBy)(filteredElements, sortFn);
    var alignment = this._alignmentPosition(type, sortedElements);
    modeling.alignElements(sortedElements, alignment);
};

},{"min-dash":"aEEla","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ktSXO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _interactionEvents = require("../interaction-events");
var _interactionEventsDefault = parcelHelpers.interopDefault(_interactionEvents);
var _overlays = require("../overlays");
var _overlaysDefault = parcelHelpers.interopDefault(_overlays);
var _contextPad = require("./ContextPad");
var _contextPadDefault = parcelHelpers.interopDefault(_contextPad);
exports.default = {
    __depends__: [
        (0, _interactionEventsDefault.default),
        (0, _overlaysDefault.default)
    ],
    contextPad: [
        'type',
        (0, _contextPadDefault.default)
    ]
};

},{"../interaction-events":"4qbdP","../overlays":"cLFz9","./ContextPad":"izcGX","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"izcGX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ContextPad);
var _minDash = require("min-dash");
var _minDom = require("min-dom");
var _elements = require("../../util/Elements");
var _escapeUtil = require("../../util/EscapeUtil");
/**
 * @typedef {import('../../model').Base} Base
 *
 * @typedef {import('../../util/Types').Rect} Rect
 */ var entrySelector = '.entry';
var DEFAULT_PRIORITY = 1000;
var CONTEXT_PAD_PADDING = 12;
function ContextPad(canvas, config, eventBus, overlays) {
    this._canvas = canvas;
    this._eventBus = eventBus;
    this._overlays = overlays;
    var scale = (0, _minDash.isDefined)(config && config.scale) ? config.scale : {
        min: 1,
        max: 1.5
    };
    this._overlaysConfig = {
        scale: scale
    };
    this._current = null;
    this._init();
}
ContextPad.$inject = [
    'canvas',
    'config.contextPad',
    'eventBus',
    'overlays'
];
/**
 * Registers events needed for interaction with other components.
 */ ContextPad.prototype._init = function() {
    var self = this;
    this._eventBus.on('selection.changed', function(event) {
        var selection = event.newSelection;
        var target = selection.length ? selection.length === 1 ? selection[0] : selection : null;
        if (target) self.open(target, true);
        else self.close();
    });
    this._eventBus.on('elements.changed', function(event) {
        var elements = event.elements, current = self._current;
        if (!current) return;
        var currentTarget = current.target;
        var currentChanged = (0, _minDash.some)((0, _minDash.isArray)(currentTarget) ? currentTarget : [
            currentTarget
        ], function(element) {
            return includes(elements, element);
        });
        // re-open if elements in current selection changed
        if (currentChanged) self.open(currentTarget, true);
    });
};
/**
 * Register context pad provider.
 *
 * @param {number} [priority=1000]
 * @param {ContextPadProvider} provider
 *
 * @example
 * const contextPadProvider = {
 *   getContextPadEntries: function(element) {
 *     return function(entries) {
 *       return {
 *         ...entries,
 *         'entry-1': {
 *           label: 'My Entry',
 *           action: function() { alert("I have been clicked!"); }
 *         }
 *       };
 *     }
 *   },
 *
 *   getMultiElementContextPadEntries: function(elements) {
 *     // ...
 *   }
 * };
 *
 * contextPad.registerProvider(800, contextPadProvider);
 */ ContextPad.prototype.registerProvider = function(priority, provider) {
    if (!provider) {
        provider = priority;
        priority = DEFAULT_PRIORITY;
    }
    this._eventBus.on('contextPad.getProviders', priority, function(event) {
        event.providers.push(provider);
    });
};
/**
 * Get context pad entries for given elements.
 *
 * @param {ContextPadTarget} target
 *
 * @return {ContextPadEntryDescriptor[]} list of entries
 */ ContextPad.prototype.getEntries = function(target) {
    var providers = this._getProviders();
    var provideFn = (0, _minDash.isArray)(target) ? 'getMultiElementContextPadEntries' : 'getContextPadEntries';
    var entries = {};
    // loop through all providers and their entries.
    // group entries by id so that overriding an entry is possible
    (0, _minDash.forEach)(providers, function(provider) {
        if (!(0, _minDash.isFunction)(provider[provideFn])) return;
        var entriesOrUpdater = provider[provideFn](target);
        if ((0, _minDash.isFunction)(entriesOrUpdater)) entries = entriesOrUpdater(entries);
        else (0, _minDash.forEach)(entriesOrUpdater, function(entry, id) {
            entries[id] = entry;
        });
    });
    return entries;
};
/**
 * Trigger context pad via DOM event.
 *
 * The entry to trigger is determined by the target element.
 *
 * @param {string} action
 * @param {Event} event
 * @param {boolean} [autoActivate=false]
 */ ContextPad.prototype.trigger = function(action, event, autoActivate) {
    var entry, originalEvent, button = event.delegateTarget || event.target;
    if (!button) return event.preventDefault();
    entry = (0, _minDom.attr)(button, 'data-action');
    originalEvent = event.originalEvent || event;
    return this.triggerEntry(entry, action, originalEvent, autoActivate);
};
/**
 * Trigger context pad entry entry.
 *
 * @param {string} entryId
 * @param {string} action
 * @param {Event} event
 * @param {boolean} [autoActivate=false]
 */ ContextPad.prototype.triggerEntry = function(entryId, action, event, autoActivate) {
    if (!this.isShown()) return;
    var target = this._current.target, entries = this._current.entries;
    var entry = entries[entryId];
    if (!entry) return;
    var handler = entry.action;
    if (this._eventBus.fire('contextPad.trigger', {
        entry,
        event
    }) === false) return;
    // simple action (via callback function)
    if ((0, _minDash.isFunction)(handler)) {
        if (action === 'click') return handler(event, target, autoActivate);
    } else {
        if (handler[action]) return handler[action](event, target, autoActivate);
    }
    // silence other actions
    event.preventDefault();
};
/**
 * Open the context pad for given elements.
 *
 * @param {ContextPadTarget} target
 * @param {boolean} [force=false] - Force re-opening context pad.
 */ ContextPad.prototype.open = function(target, force) {
    if (!force && this.isOpen(target)) return;
    this.close();
    this._updateAndOpen(target);
};
ContextPad.prototype._getProviders = function() {
    var event = this._eventBus.createEvent({
        type: 'contextPad.getProviders',
        providers: []
    });
    this._eventBus.fire(event);
    return event.providers;
};
/**
 * @param {ContextPadTarget} target
 */ ContextPad.prototype._updateAndOpen = function(target) {
    var entries = this.getEntries(target), pad = this.getPad(target), html = pad.html, image;
    (0, _minDash.forEach)(entries, function(entry, id) {
        var grouping = entry.group || 'default', control = (0, _minDom.domify)(entry.html || '<div class="entry" draggable="true"></div>'), container;
        (0, _minDom.attr)(control, 'data-action', id);
        container = (0, _minDom.query)('[data-group=' + (0, _escapeUtil.escapeCSS)(grouping) + ']', html);
        if (!container) {
            container = (0, _minDom.domify)('<div class="group"></div>');
            (0, _minDom.attr)(container, 'data-group', grouping);
            html.appendChild(container);
        }
        container.appendChild(control);
        if (entry.className) addClasses(control, entry.className);
        if (entry.title) (0, _minDom.attr)(control, 'title', entry.title);
        if (entry.imageUrl) {
            image = (0, _minDom.domify)('<img>');
            (0, _minDom.attr)(image, 'src', entry.imageUrl);
            image.style.width = '100%';
            image.style.height = '100%';
            control.appendChild(image);
        }
    });
    (0, _minDom.classes)(html).add('open');
    this._current = {
        target: target,
        entries: entries,
        pad: pad
    };
    this._eventBus.fire('contextPad.open', {
        current: this._current
    });
};
/**
 * @param {ContextPadTarget} target
 *
 * @return {Overlay}
 */ ContextPad.prototype.getPad = function(target) {
    if (this.isOpen()) return this._current.pad;
    var self = this;
    var overlays = this._overlays;
    var html = (0, _minDom.domify)('<div class="djs-context-pad"></div>');
    var position = this._getPosition(target);
    var overlaysConfig = (0, _minDash.assign)({
        html: html
    }, this._overlaysConfig, position);
    (0, _minDom.delegate).bind(html, entrySelector, 'click', function(event) {
        self.trigger('click', event);
    });
    (0, _minDom.delegate).bind(html, entrySelector, 'dragstart', function(event) {
        self.trigger('dragstart', event);
    });
    // stop propagation of mouse events
    (0, _minDom.event).bind(html, 'mousedown', function(event) {
        event.stopPropagation();
    });
    var activeRootElement = this._canvas.getRootElement();
    this._overlayId = overlays.add(activeRootElement, 'context-pad', overlaysConfig);
    var pad = overlays.get(this._overlayId);
    this._eventBus.fire('contextPad.create', {
        target: target,
        pad: pad
    });
    return pad;
};
/**
 * Close the context pad
 */ ContextPad.prototype.close = function() {
    if (!this.isOpen()) return;
    this._overlays.remove(this._overlayId);
    this._overlayId = null;
    this._eventBus.fire('contextPad.close', {
        current: this._current
    });
    this._current = null;
};
/**
 * Check if pad is open.
 *
 * If target is provided, check if it is opened
 * for the given target (single or multiple elements).
 *
 * @param {ContextPadTarget} [target]
 * @return {boolean}
 */ ContextPad.prototype.isOpen = function(target) {
    var current = this._current;
    if (!current) return false;
    // basic no-args is open check
    if (!target) return true;
    var currentTarget = current.target;
    // strict handling of single vs. multi-selection
    if ((0, _minDash.isArray)(target) !== (0, _minDash.isArray)(currentTarget)) return false;
    if ((0, _minDash.isArray)(target)) return target.length === currentTarget.length && (0, _minDash.every)(target, function(element) {
        return includes(currentTarget, element);
    });
    else return currentTarget === target;
};
/**
 * Check if pad is open and not hidden.
 *
 * @return {boolean}
 */ ContextPad.prototype.isShown = function() {
    return this.isOpen() && this._overlays.isShown();
};
/**
 * Get contex pad position.
 *
 * @param {ContextPadTarget} target
 *
 * @return {Rect}
 */ ContextPad.prototype._getPosition = function(target) {
    var elements = (0, _minDash.isArray)(target) ? target : [
        target
    ];
    var bBox = (0, _elements.getBBox)(elements);
    return {
        position: {
            left: bBox.x + bBox.width + CONTEXT_PAD_PADDING,
            top: bBox.y - CONTEXT_PAD_PADDING / 2
        }
    };
};
// helpers //////////
function addClasses(element, classNames) {
    var classes = (0, _minDom.classes)(element);
    classNames = (0, _minDash.isArray)(classNames) ? classNames : classNames.split(/\s+/g);
    classNames.forEach(function(cls) {
        classes.add(cls);
    });
}
/**
 * @param {*[]} array
 * @param {*} item
 *
 * @return {boolean}
 */ function includes(array, item) {
    return array.indexOf(item) !== -1;
}

},{"min-dash":"aEEla","min-dom":"e58GC","../../util/Elements":"6qdtl","../../util/EscapeUtil":"kAkPb","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iRpNh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _popupMenu = require("./PopupMenu");
var _popupMenuDefault = parcelHelpers.interopDefault(_popupMenu);
exports.default = {
    __init__: [
        'popupMenu'
    ],
    popupMenu: [
        'type',
        (0, _popupMenuDefault.default)
    ]
};

},{"./PopupMenu":"lyPbv","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lyPbv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PopupMenu);
var _ui = require("../../ui");
var _minDom = require("min-dom");
var _minDash = require("min-dash");
var _popupMenuComponent = require("./PopupMenuComponent");
var _popupMenuComponentDefault = parcelHelpers.interopDefault(_popupMenuComponent);
/**
 * @typedef {import('../../core/Canvas').default} Canvas
 * @typedef {import('../../core/EventBus').default} EventBus
 */ var DATA_REF = 'data-id';
var CLOSE_EVENTS = [
    'contextPad.close',
    'canvas.viewbox.changing',
    'commandStack.changed'
];
var DEFAULT_PRIORITY = 1000;
function PopupMenu(config, eventBus, canvas) {
    this._eventBus = eventBus;
    this._canvas = canvas;
    this._current = null;
    var scale = (0, _minDash.isDefined)(config && config.scale) ? config.scale : {
        min: 1,
        max: 1.5
    };
    this._config = {
        scale: scale
    };
    eventBus.on('diagram.destroy', ()=>{
        this.close();
    });
    eventBus.on('element.changed', (event)=>{
        const element = this.isOpen() && this._current.element;
        if (event.element === element) this._render();
    });
}
PopupMenu.$inject = [
    'config.popupMenu',
    'eventBus',
    'canvas'
];
PopupMenu.prototype._render = function() {
    const { position: _position, className, entries, headerEntries, options } = this._current;
    const entriesArray = Object.entries(entries).map(([key, value])=>({
            id: key,
            ...value
        }));
    const headerEntriesArray = Object.entries(headerEntries).map(([key, value])=>({
            id: key,
            ...value
        }));
    const position = _position && ((container)=>this._ensureVisible(container, _position));
    const scale = this._updateScale(this._current.container);
    const onClose = (result)=>this.close(result);
    const onSelect = (event, entry, action)=>this.trigger(event, entry, action);
    (0, _ui.render)((0, _ui.html)`
      <${(0, _popupMenuComponentDefault.default)}
        onClose=${onClose}
        onSelect=${onSelect}
        position=${position}
        className=${className}
        entries=${entriesArray}
        headerEntries=${headerEntriesArray}
        scale=${scale}
        onOpened=${this._onOpened.bind(this)}
        onClosed=${this._onClosed.bind(this)}
        ...${{
        ...options
    }}
      />
    `, this._current.container);
};
/**
 * Create entries and open popup menu at given position
 *
 * @param {Object} element
 * @param {string} id provider id
 * @param {Object} position
 *
 * @return {Object} popup menu instance
 */ PopupMenu.prototype.open = function(element, providerId, position, options) {
    if (!element) throw new Error('Element is missing');
    if (!providerId) throw new Error('No registered providers for: ' + providerId);
    if (!position) throw new Error('the position argument is missing');
    if (this.isOpen()) this.close();
    const { entries, headerEntries } = this._getContext(element, providerId);
    this._current = {
        position,
        className: providerId,
        element,
        entries,
        headerEntries,
        container: this._createContainer({
            provider: providerId
        }),
        options
    };
    this._emit('open');
    this._bindAutoClose();
    this._render();
};
PopupMenu.prototype._getContext = function(element, provider) {
    const providers = this._getProviders(provider);
    if (!providers || !providers.length) throw new Error('No registered providers for: ' + provider);
    const entries = this._getEntries(element, providers);
    const headerEntries = this._getHeaderEntries(element, providers);
    return {
        entries,
        headerEntries,
        empty: !(Object.keys(entries).length || Object.keys(headerEntries).length)
    };
};
PopupMenu.prototype.close = function() {
    if (!this.isOpen()) return;
    this._emit('close');
    this.reset();
    this._current = null;
};
PopupMenu.prototype.reset = function() {
    const container = this._current.container;
    (0, _ui.render)(null, container);
    (0, _minDom.remove)(container);
};
PopupMenu.prototype._emit = function(event, payload) {
    this._eventBus.fire(`popupMenu.${event}`, payload);
};
PopupMenu.prototype._onOpened = function() {
    this._emit('opened');
};
PopupMenu.prototype._onClosed = function() {
    this._emit('closed');
};
PopupMenu.prototype._createContainer = function(config) {
    var canvas = this._canvas, parent = canvas.getContainer();
    const container = (0, _minDom.domify)(`<div class="djs-popup-parent djs-scrollable" data-popup=${config.provider}></div>`);
    parent.appendChild(container);
    return container;
};
/**
 * Set up listener to close popup automatically on certain events.
 */ PopupMenu.prototype._bindAutoClose = function() {
    this._eventBus.once(CLOSE_EVENTS, this.close, this);
};
/**
 * Remove the auto-closing listener.
*/ PopupMenu.prototype._unbindAutoClose = function() {
    this._eventBus.off(CLOSE_EVENTS, this.close, this);
};
/**
 * Updates popup style.transform with respect to the config and zoom level.
 *
 * @param {Object} container
 */ PopupMenu.prototype._updateScale = function(container) {
    var zoom = this._canvas.zoom();
    var scaleConfig = this._config.scale, minScale, maxScale, scale = zoom;
    if (scaleConfig !== true) {
        if (scaleConfig === false) {
            minScale = 1;
            maxScale = 1;
        } else {
            minScale = scaleConfig.min;
            maxScale = scaleConfig.max;
        }
        if ((0, _minDash.isDefined)(minScale) && zoom < minScale) scale = minScale;
        if ((0, _minDash.isDefined)(maxScale) && zoom > maxScale) scale = maxScale;
    }
    return scale;
};
PopupMenu.prototype._ensureVisible = function(container, position) {
    var documentBounds = document.documentElement.getBoundingClientRect();
    var containerBounds = container.getBoundingClientRect();
    var overAxis = {}, left = position.x, top = position.y;
    if (position.x + containerBounds.width > documentBounds.width) overAxis.x = true;
    if (position.y + containerBounds.height > documentBounds.height) overAxis.y = true;
    if (overAxis.x && overAxis.y) {
        left = position.x - containerBounds.width;
        top = position.y - containerBounds.height;
    } else if (overAxis.x) {
        left = position.x - containerBounds.width;
        top = position.y;
    } else if (overAxis.y && position.y < containerBounds.height) {
        left = position.x;
        top = 10;
    } else if (overAxis.y) {
        left = position.x;
        top = position.y - containerBounds.height;
    }
    return {
        x: left,
        y: top
    };
};
PopupMenu.prototype.isEmpty = function(element, providerId) {
    if (!element) throw new Error('element parameter is missing');
    if (!providerId) throw new Error('providerId parameter is missing');
    const providers = this._getProviders(providerId);
    if (!providers || !providers.length) return true;
    return this._getContext(element, providerId).empty;
};
/**
 * Registers a popup menu provider
 *
 * @param {string} id
 * @param {number} [priority=1000]
 * @param {Object} provider
 *
 * @example
 * const popupMenuProvider = {
 *   getPopupMenuEntries(element) {
 *     return {
 *       'entry-1': {
 *         label: 'My Entry',
 *         action: function() { alert("I have been clicked!"); }
 *       }
 *     }
 *   }
 * };
 *
 * popupMenu.registerProvider('myMenuID', popupMenuProvider);
 *
 * @example
 * const replacingPopupMenuProvider = {
 *   getPopupMenuEntries(element) {
 *     return (entries) => {
 *       const {
 *         someEntry,
 *         ...remainingEntries
 *       } = entries;
 *
 *       return remainingEntries;
 *     };
 *   }
 * };
 *
 * popupMenu.registerProvider('myMenuID', replacingPopupMenuProvider);
 */ PopupMenu.prototype.registerProvider = function(id, priority, provider) {
    if (!provider) {
        provider = priority;
        priority = DEFAULT_PRIORITY;
    }
    this._eventBus.on('popupMenu.getProviders.' + id, priority, function(event) {
        event.providers.push(provider);
    });
};
PopupMenu.prototype._getProviders = function(id) {
    var event = this._eventBus.createEvent({
        type: 'popupMenu.getProviders.' + id,
        providers: []
    });
    this._eventBus.fire(event);
    return event.providers;
};
PopupMenu.prototype._getEntries = function(element, providers) {
    var entries = {};
    (0, _minDash.forEach)(providers, function(provider) {
        // handle legacy method
        if (!provider.getPopupMenuEntries) {
            (0, _minDash.forEach)(provider.getEntries(element), function(entry) {
                var id = entry.id;
                if (!id) throw new Error('every entry must have the id property set');
                entries[id] = (0, _minDash.omit)(entry, [
                    'id'
                ]);
            });
            return;
        }
        var entriesOrUpdater = provider.getPopupMenuEntries(element);
        if ((0, _minDash.isFunction)(entriesOrUpdater)) entries = entriesOrUpdater(entries);
        else (0, _minDash.forEach)(entriesOrUpdater, function(entry, id) {
            entries[id] = entry;
        });
    });
    return entries;
};
PopupMenu.prototype._getHeaderEntries = function(element, providers) {
    var entries = {};
    (0, _minDash.forEach)(providers, function(provider) {
        // handle legacy method
        if (!provider.getPopupMenuHeaderEntries) {
            if (!provider.getHeaderEntries) return;
            (0, _minDash.forEach)(provider.getHeaderEntries(element), function(entry) {
                var id = entry.id;
                if (!id) throw new Error('every entry must have the id property set');
                entries[id] = (0, _minDash.omit)(entry, [
                    'id'
                ]);
            });
            return;
        }
        var entriesOrUpdater = provider.getPopupMenuHeaderEntries(element);
        if ((0, _minDash.isFunction)(entriesOrUpdater)) entries = entriesOrUpdater(entries);
        else (0, _minDash.forEach)(entriesOrUpdater, function(entry, id) {
            entries[id] = entry;
        });
    });
    return entries;
};
/**
 * Determine if an open popup menu exist.
 *
 * @return {boolean} true if open
 */ PopupMenu.prototype.isOpen = function() {
    return !!this._current;
};
/**
 * Trigger an action associated with an entry.
 *
 * @param {Object} event
 * @param {Object} entry
 * @param {string} [action='click'] the action to trigger
 *
 * @return the result of the action callback, if any
 */ PopupMenu.prototype.trigger = function(event, entry, action = 'click') {
    // silence other actions
    event.preventDefault();
    if (!entry) {
        let element = (0, _minDom.closest)(event.delegateTarget || event.target, '.entry', true);
        let entryId = (0, _minDom.attr)(element, DATA_REF);
        entry = this._getEntry(entryId);
    }
    const handler = entry.action;
    if (this._emit('trigger', {
        entry,
        event
    }) === false) return;
    if ((0, _minDash.isFunction)(handler)) {
        if (action === 'click') return handler(event, entry);
    } else {
        if (handler[action]) return handler[action](event, entry);
    }
};
/**
 * Gets an entry instance (either entry or headerEntry) by id.
 *
 * @param {string} entryId
 *
 * @return {Object} entry instance
 */ PopupMenu.prototype._getEntry = function(entryId) {
    var entry = this._current.entries[entryId] || this._current.headerEntries[entryId];
    if (!entry) throw new Error('entry not found');
    return entry;
};

},{"../../ui":[["html","5yBUc"],["render","iq90b"]],"min-dom":"e58GC","min-dash":"aEEla","./PopupMenuComponent":"2h6MA","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5yBUc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "h", ()=>(0, _preact.h));
parcelHelpers.export(exports, "render", ()=>(0, _preact.render));
parcelHelpers.export(exports, "Component", ()=>(0, _preact.Component));
parcelHelpers.export(exports, "html", ()=>m);
var _preact = require("preact");
var _htm = require("htm");
var _htmDefault = parcelHelpers.interopDefault(_htm);
var m = (0, _htmDefault.default).bind((0, _preact.h));

},{"preact":"iq90b","htm":"7FC19","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iq90b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Component", ()=>x);
parcelHelpers.export(exports, "Fragment", ()=>k);
parcelHelpers.export(exports, "cloneElement", ()=>K);
parcelHelpers.export(exports, "createContext", ()=>Q);
parcelHelpers.export(exports, "createElement", ()=>_);
parcelHelpers.export(exports, "createRef", ()=>b);
parcelHelpers.export(exports, "h", ()=>_);
parcelHelpers.export(exports, "hydrate", ()=>J);
parcelHelpers.export(exports, "isValidElement", ()=>t);
parcelHelpers.export(exports, "options", ()=>l);
parcelHelpers.export(exports, "render", ()=>G);
parcelHelpers.export(exports, "toChildArray", ()=>H);
var n, l, u, t, i, r, o, e, f, c, s, a, h, p = {}, v = [], y = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, w = Array.isArray;
function d(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function g(n) {
    n && n.parentNode && n.parentNode.removeChild(n);
}
function _(l, u, t) {
    var i, r, o, e = {};
    for(o in u)"key" == o ? i = u[o] : "ref" == o ? r = u[o] : e[o] = u[o];
    if (arguments.length > 2 && (e.children = arguments.length > 3 ? n.call(arguments, 2) : t), "function" == typeof l && null != l.defaultProps) for(o in l.defaultProps)void 0 === e[o] && (e[o] = l.defaultProps[o]);
    return m(l, e, i, r, null);
}
function m(n, t, i, r, o) {
    var e = {
        type: n,
        props: t,
        key: i,
        ref: r,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __c: null,
        constructor: void 0,
        __v: null == o ? ++u : o,
        __i: -1,
        __u: 0
    };
    return null == o && null != l.vnode && l.vnode(e), e;
}
function b() {
    return {
        current: null
    };
}
function k(n) {
    return n.children;
}
function x(n, l) {
    this.props = n, this.context = l;
}
function S(n, l) {
    if (null == l) return n.__ ? S(n.__, n.__i + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? S(n) : null;
}
function C(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return C(n);
    }
}
function M(n) {
    (!n.__d && (n.__d = !0) && i.push(n) && !$.__r++ || r != l.debounceRendering) && ((r = l.debounceRendering) || o)($);
}
function $() {
    for(var n, u, t, r, o, f, c, s = 1; i.length;)i.length > s && i.sort(e), n = i.shift(), s = i.length, n.__d && (t = void 0, r = void 0, o = (r = (u = n).__v).__e, f = [], c = [], u.__P && ((t = d({}, r)).__v = r.__v + 1, l.vnode && l.vnode(t), O(u.__P, t, r, u.__n, u.__P.namespaceURI, 32 & r.__u ? [
        o
    ] : null, f, null == o ? S(r) : o, !!(32 & r.__u), c), t.__v = r.__v, t.__.__k[t.__i] = t, N(f, t, c), r.__e = r.__ = null, t.__e != o && C(t)));
    $.__r = 0;
}
function I(n, l, u, t, i, r, o, e, f, c, s) {
    var a, h, y, w, d, g, _, m = t && t.__k || v, b = l.length;
    for(f = P(u, l, m, f, b), a = 0; a < b; a++)null != (y = u.__k[a]) && (h = -1 == y.__i ? p : m[y.__i] || p, y.__i = a, g = O(n, y, h, i, r, o, e, f, c, s), w = y.__e, y.ref && h.ref != y.ref && (h.ref && B(h.ref, null, y), s.push(y.ref, y.__c || w, y)), null == d && null != w && (d = w), (_ = !!(4 & y.__u)) || h.__k === y.__k ? f = A(y, f, n, _) : "function" == typeof y.type && void 0 !== g ? f = g : w && (f = w.nextSibling), y.__u &= -7);
    return u.__e = d, f;
}
function P(n, l, u, t, i) {
    var r, o, e, f, c, s = u.length, a = s, h = 0;
    for(n.__k = new Array(i), r = 0; r < i; r++)null != (o = l[r]) && "boolean" != typeof o && "function" != typeof o ? (f = r + h, (o = n.__k[r] = "string" == typeof o || "number" == typeof o || "bigint" == typeof o || o.constructor == String ? m(null, o, null, null, null) : w(o) ? m(k, {
        children: o
    }, null, null, null) : null == o.constructor && o.__b > 0 ? m(o.type, o.props, o.key, o.ref ? o.ref : null, o.__v) : o).__ = n, o.__b = n.__b + 1, e = null, -1 != (c = o.__i = L(o, u, f, a)) && (a--, (e = u[c]) && (e.__u |= 2)), null == e || null == e.__v ? (-1 == c && (i > s ? h-- : i < s && h++), "function" != typeof o.type && (o.__u |= 4)) : c != f && (c == f - 1 ? h-- : c == f + 1 ? h++ : (c > f ? h-- : h++, o.__u |= 4))) : n.__k[r] = null;
    if (a) for(r = 0; r < s; r++)null != (e = u[r]) && 0 == (2 & e.__u) && (e.__e == t && (t = S(e)), D(e, e));
    return t;
}
function A(n, l, u, t) {
    var i, r;
    if ("function" == typeof n.type) {
        for(i = n.__k, r = 0; i && r < i.length; r++)i[r] && (i[r].__ = n, l = A(i[r], l, u, t));
        return l;
    }
    n.__e != l && (t && (l && n.type && !l.parentNode && (l = S(n)), u.insertBefore(n.__e, l || null)), l = n.__e);
    do l = l && l.nextSibling;
    while (null != l && 8 == l.nodeType);
    return l;
}
function H(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || (w(n) ? n.some(function(n) {
        H(n, l);
    }) : l.push(n)), l;
}
function L(n, l, u, t) {
    var i, r, o, e = n.key, f = n.type, c = l[u], s = null != c && 0 == (2 & c.__u);
    if (null === c && null == n.key || s && e == c.key && f == c.type) return u;
    if (t > (s ? 1 : 0)) {
        for(i = u - 1, r = u + 1; i >= 0 || r < l.length;)if (null != (c = l[o = i >= 0 ? i-- : r++]) && 0 == (2 & c.__u) && e == c.key && f == c.type) return o;
    }
    return -1;
}
function T(n, l, u) {
    "-" == l[0] ? n.setProperty(l, null == u ? "" : u) : n[l] = null == u ? "" : "number" != typeof u || y.test(l) ? u : u + "px";
}
function j(n, l, u, t, i) {
    var r, o;
    n: if ("style" == l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof t && (n.style.cssText = t = ""), t) for(l in t)u && l in u || T(n.style, l, "");
            if (u) for(l in u)t && u[l] == t[l] || T(n.style, l, u[l]);
        }
    } else if ("o" == l[0] && "n" == l[1]) r = l != (l = l.replace(f, "$1")), o = l.toLowerCase(), l = o in n || "onFocusOut" == l || "onFocusIn" == l ? o.slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + r] = u, u ? t ? u.u = t.u : (u.u = c, n.addEventListener(l, r ? a : s, r)) : n.removeEventListener(l, r ? a : s, r);
    else {
        if ("http://www.w3.org/2000/svg" == i) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" != l && "height" != l && "href" != l && "list" != l && "form" != l && "tabIndex" != l && "download" != l && "rowSpan" != l && "colSpan" != l && "role" != l && "popover" != l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null == u || !1 === u && "-" != l[4] ? n.removeAttribute(l) : n.setAttribute(l, "popover" == l && 1 == u ? "" : u));
    }
}
function F(n) {
    return function(u) {
        if (this.l) {
            var t = this.l[u.type + n];
            if (null == u.t) u.t = c++;
            else if (u.t < t.u) return;
            return t(l.event ? l.event(u) : u);
        }
    };
}
function O(n, u, t, i, r, o, e, f, c, s) {
    var a, h, p, v, y, _, m, b, S, C, M, $, P, A, H, L, T, j = u.type;
    if (null != u.constructor) return null;
    128 & t.__u && (c = !!(32 & t.__u), o = [
        f = u.__e = t.__e
    ]), (a = l.__b) && a(u);
    n: if ("function" == typeof j) try {
        if (b = u.props, S = "prototype" in j && j.prototype.render, C = (a = j.contextType) && i[a.__c], M = a ? C ? C.props.value : a.__ : i, t.__c ? m = (h = u.__c = t.__c).__ = h.__E : (S ? u.__c = h = new j(b, M) : (u.__c = h = new x(b, M), h.constructor = j, h.render = E), C && C.sub(h), h.props = b, h.state || (h.state = {}), h.context = M, h.__n = i, p = h.__d = !0, h.__h = [], h._sb = []), S && null == h.__s && (h.__s = h.state), S && null != j.getDerivedStateFromProps && (h.__s == h.state && (h.__s = d({}, h.__s)), d(h.__s, j.getDerivedStateFromProps(b, h.__s))), v = h.props, y = h.state, h.__v = u, p) S && null == j.getDerivedStateFromProps && null != h.componentWillMount && h.componentWillMount(), S && null != h.componentDidMount && h.__h.push(h.componentDidMount);
        else {
            if (S && null == j.getDerivedStateFromProps && b !== v && null != h.componentWillReceiveProps && h.componentWillReceiveProps(b, M), !h.__e && null != h.shouldComponentUpdate && !1 === h.shouldComponentUpdate(b, h.__s, M) || u.__v == t.__v) {
                for(u.__v != t.__v && (h.props = b, h.state = h.__s, h.__d = !1), u.__e = t.__e, u.__k = t.__k, u.__k.some(function(n) {
                    n && (n.__ = u);
                }), $ = 0; $ < h._sb.length; $++)h.__h.push(h._sb[$]);
                h._sb = [], h.__h.length && e.push(h);
                break n;
            }
            null != h.componentWillUpdate && h.componentWillUpdate(b, h.__s, M), S && null != h.componentDidUpdate && h.__h.push(function() {
                h.componentDidUpdate(v, y, _);
            });
        }
        if (h.context = M, h.props = b, h.__P = n, h.__e = !1, P = l.__r, A = 0, S) {
            for(h.state = h.__s, h.__d = !1, P && P(u), a = h.render(h.props, h.state, h.context), H = 0; H < h._sb.length; H++)h.__h.push(h._sb[H]);
            h._sb = [];
        } else do h.__d = !1, P && P(u), a = h.render(h.props, h.state, h.context), h.state = h.__s;
        while (h.__d && ++A < 25);
        h.state = h.__s, null != h.getChildContext && (i = d(d({}, i), h.getChildContext())), S && !p && null != h.getSnapshotBeforeUpdate && (_ = h.getSnapshotBeforeUpdate(v, y)), L = a, null != a && a.type === k && null == a.key && (L = V(a.props.children)), f = I(n, w(L) ? L : [
            L
        ], u, t, i, r, o, e, f, c, s), h.base = u.__e, u.__u &= -161, h.__h.length && e.push(h), m && (h.__E = h.__ = null);
    } catch (n) {
        if (u.__v = null, c || null != o) {
            if (n.then) {
                for(u.__u |= c ? 160 : 128; f && 8 == f.nodeType && f.nextSibling;)f = f.nextSibling;
                o[o.indexOf(f)] = null, u.__e = f;
            } else {
                for(T = o.length; T--;)g(o[T]);
                z(u);
            }
        } else u.__e = t.__e, u.__k = t.__k, n.then || z(u);
        l.__e(n, u, t);
    }
    else null == o && u.__v == t.__v ? (u.__k = t.__k, u.__e = t.__e) : f = u.__e = q(t.__e, u, t, i, r, o, e, c, s);
    return (a = l.diffed) && a(u), 128 & u.__u ? void 0 : f;
}
function z(n) {
    n && n.__c && (n.__c.__e = !0), n && n.__k && n.__k.forEach(z);
}
function N(n, u, t) {
    for(var i = 0; i < t.length; i++)B(t[i], t[++i], t[++i]);
    l.__c && l.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            l.__e(n, u.__v);
        }
    });
}
function V(n) {
    return "object" != typeof n || null == n || n.__b && n.__b > 0 ? n : w(n) ? n.map(V) : d({}, n);
}
function q(u, t, i, r, o, e, f, c, s) {
    var a, h, v, y, d, _, m, b = i.props, k = t.props, x = t.type;
    if ("svg" == x ? o = "http://www.w3.org/2000/svg" : "math" == x ? o = "http://www.w3.org/1998/Math/MathML" : o || (o = "http://www.w3.org/1999/xhtml"), null != e) {
        for(a = 0; a < e.length; a++)if ((d = e[a]) && "setAttribute" in d == !!x && (x ? d.localName == x : 3 == d.nodeType)) {
            u = d, e[a] = null;
            break;
        }
    }
    if (null == u) {
        if (null == x) return document.createTextNode(k);
        u = document.createElementNS(o, x, k.is && k), c && (l.__m && l.__m(t, e), c = !1), e = null;
    }
    if (null == x) b === k || c && u.data == k || (u.data = k);
    else {
        if (e = e && n.call(u.childNodes), b = i.props || p, !c && null != e) for(b = {}, a = 0; a < u.attributes.length; a++)b[(d = u.attributes[a]).name] = d.value;
        for(a in b)if (d = b[a], "children" == a) ;
        else if ("dangerouslySetInnerHTML" == a) v = d;
        else if (!(a in k)) {
            if ("value" == a && "defaultValue" in k || "checked" == a && "defaultChecked" in k) continue;
            j(u, a, null, d, o);
        }
        for(a in k)d = k[a], "children" == a ? y = d : "dangerouslySetInnerHTML" == a ? h = d : "value" == a ? _ = d : "checked" == a ? m = d : c && "function" != typeof d || b[a] === d || j(u, a, d, b[a], o);
        if (h) c || v && (h.__html == v.__html || h.__html == u.innerHTML) || (u.innerHTML = h.__html), t.__k = [];
        else if (v && (u.innerHTML = ""), I("template" == t.type ? u.content : u, w(y) ? y : [
            y
        ], t, i, r, "foreignObject" == x ? "http://www.w3.org/1999/xhtml" : o, e, f, e ? e[0] : i.__k && S(i, 0), c, s), null != e) for(a = e.length; a--;)g(e[a]);
        c || (a = "value", "progress" == x && null == _ ? u.removeAttribute("value") : null != _ && (_ !== u[a] || "progress" == x && !_ || "option" == x && _ != b[a]) && j(u, a, _, b[a], o), a = "checked", null != m && m != u[a] && j(u, a, m, b[a], o));
    }
    return u;
}
function B(n, u, t) {
    try {
        if ("function" == typeof n) {
            var i = "function" == typeof n.__u;
            i && n.__u(), i && null == u || (n.__u = n(u));
        } else n.current = u;
    } catch (n) {
        l.__e(n, t);
    }
}
function D(n, u, t) {
    var i, r;
    if (l.unmount && l.unmount(n), (i = n.ref) && (i.current && i.current != n.__e || B(i, null, u)), null != (i = n.__c)) {
        if (i.componentWillUnmount) try {
            i.componentWillUnmount();
        } catch (n) {
            l.__e(n, u);
        }
        i.base = i.__P = null;
    }
    if (i = n.__k) for(r = 0; r < i.length; r++)i[r] && D(i[r], u, t || "function" != typeof n.type);
    t || g(n.__e), n.__c = n.__ = n.__e = void 0;
}
function E(n, l, u) {
    return this.constructor(n, u);
}
function G(u, t, i) {
    var r, o, e, f;
    t == document && (t = document.documentElement), l.__ && l.__(u, t), o = (r = "function" == typeof i) ? null : i && i.__k || t.__k, e = [], f = [], O(t, u = (!r && i || t).__k = _(k, null, [
        u
    ]), o || p, p, t.namespaceURI, !r && i ? [
        i
    ] : o ? null : t.firstChild ? n.call(t.childNodes) : null, e, !r && i ? i : o ? o.__e : t.firstChild, r, f), N(e, u, f);
}
function J(n, l) {
    G(n, l, J);
}
function K(l, u, t) {
    var i, r, o, e, f = d({}, l.props);
    for(o in l.type && l.type.defaultProps && (e = l.type.defaultProps), u)"key" == o ? i = u[o] : "ref" == o ? r = u[o] : f[o] = void 0 === u[o] && null != e ? e[o] : u[o];
    return arguments.length > 2 && (f.children = arguments.length > 3 ? n.call(arguments, 2) : t), m(l.type, f, i || l.key, r || l.ref, null);
}
function Q(n) {
    function l(n) {
        var u, t;
        return this.getChildContext || (u = new Set, (t = {})[l.__c] = this, this.getChildContext = function() {
            return t;
        }, this.componentWillUnmount = function() {
            u = null;
        }, this.shouldComponentUpdate = function(n) {
            this.props.value != n.value && u.forEach(function(n) {
                n.__e = !0, M(n);
            });
        }, this.sub = function(n) {
            u.add(n);
            var l = n.componentWillUnmount;
            n.componentWillUnmount = function() {
                u && u.delete(n), l && l.call(n);
            };
        }), n.children;
    }
    return l.__c = "__cC" + h++, l.__ = n, l.Provider = l.__l = (l.Consumer = function(n, l) {
        return n.children(l);
    }).contextType = l, l;
}
n = v.slice, l = {
    __e: function(n, l, u, t) {
        for(var i, r, o; l = l.__;)if ((i = l.__c) && !i.__) try {
            if ((r = i.constructor) && null != r.getDerivedStateFromError && (i.setState(r.getDerivedStateFromError(n)), o = i.__d), null != i.componentDidCatch && (i.componentDidCatch(n, t || {}), o = i.__d), o) return i.__E = i;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, u = 0, t = function(n) {
    return null != n && null == n.constructor;
}, x.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s != this.state ? this.__s : this.__s = d({}, this.state), "function" == typeof n && (n = n(d({}, u), this.props)), n && d(u, n), null != n && this.__v && (l && this._sb.push(l), M(this));
}, x.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), M(this));
}, x.prototype.render = k, i = [], o = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, e = function(n, l) {
    return n.__v.__b - l.__v.__b;
}, $.__r = 0, f = /(PointerCapture)$|Capture$/i, c = 0, s = F(!1), a = F(!0), h = 0;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7FC19":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(s) {
        var r = t.get(this);
        return r || (r = new Map, t.set(this, r)), (r = n(this, r.get(s) || (r.set(s, r = function(n) {
            for(var t, s, r = 1, e = "", u = "", h = [
                0
            ], p = function(n) {
                1 === r && (n || (e = e.replace(/^\s*\n\s*|\s*\n\s*$/g, ""))) ? h.push(0, n, e) : 3 === r && (n || e) ? (h.push(3, n, e), r = 2) : 2 === r && "..." === e && n ? h.push(4, n, 0) : 2 === r && e && !n ? h.push(5, 0, !0, e) : r >= 5 && ((e || !n && 5 === r) && (h.push(r, 0, e, s), r = 6), n && (h.push(r, n, 0, s), r = 6)), e = "";
            }, a = 0; a < n.length; a++){
                a && (1 === r && p(), p(a));
                for(var l = 0; l < n[a].length; l++)t = n[a][l], 1 === r ? "<" === t ? (p(), h = [
                    h
                ], r = 3) : e += t : 4 === r ? "--" === e && ">" === t ? (r = 1, e = "") : e = t + e[0] : u ? t === u ? u = "" : e += t : '"' === t || "'" === t ? u = t : ">" === t ? (p(), r = 1) : r && ("=" === t ? (r = 5, s = e, e = "") : "/" === t && (r < 5 || ">" === n[a][l + 1]) ? (p(), 3 === r && (h = h[0]), r = h, (h = h[0]).push(2, 0, r), r = 0) : " " === t || "\t" === t || "\n" === t || "\r" === t ? (p(), r = 2) : e += t), 3 === r && "!--" === e && (r = 4, h = h[0]);
            }
            return p(), h;
        }(s)), r), arguments, [])).length > 1 ? r : r[0];
    });
var n = function(t, s, r, e) {
    var u;
    s[0] = 0;
    for(var h = 1; h < s.length; h++){
        var p = s[h++], a = s[h] ? (s[0] |= p ? 1 : 2, r[s[h++]]) : s[++h];
        3 === p ? e[0] = a : 4 === p ? e[1] = Object.assign(e[1] || {}, a) : 5 === p ? (e[1] = e[1] || {})[s[++h]] = a : 6 === p ? e[1][s[++h]] += a + "" : p ? (u = t.apply(a, n(t, a, r, [
            "",
            null
        ])), e.push(u), a[0] ? s[0] |= 2 : (s[h - 2] = 0, s[h] = u)) : e.push(a);
    }
    return e;
}, t = new Map;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2h6MA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PopupMenuComponent);
var _ui = require("../../ui");
var _minDom = require("min-dom");
var _popupMenuList = require("./PopupMenuList");
var _popupMenuListDefault = parcelHelpers.interopDefault(_popupMenuList);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _minDash = require("min-dash");
function PopupMenuComponent(props) {
    const { onClose, onSelect, className, headerEntries, position, title, width, scale, search, entries: originalEntries, onOpened, onClosed } = props;
    const searchable = (0, _ui.useMemo)(()=>{
        if (!(0, _minDash.isDefined)(search)) return false;
        return originalEntries.length > 5;
    }, [
        search,
        originalEntries
    ]);
    const inputRef = (0, _ui.useRef)();
    const [value, setValue] = (0, _ui.useState)('');
    const filterEntries = (0, _ui.useCallback)((originalEntries, value)=>{
        if (!searchable) return originalEntries;
        const filter = (entry)=>{
            if (!value) return (entry.rank || 0) >= 0;
            const search = [
                entry.description || '',
                entry.label || '',
                entry.search || ''
            ].join('---').toLowerCase();
            return value.toLowerCase().split(/\s/g).every((term)=>search.includes(term));
        };
        return originalEntries.filter(filter);
    }, [
        searchable
    ]);
    const [entries, setEntries] = (0, _ui.useState)(filterEntries(originalEntries, value));
    const [selectedEntry, setSelectedEntry] = (0, _ui.useState)(entries[0]);
    const updateEntries = (0, _ui.useCallback)((newEntries)=>{
        // select first entry if non is selected
        if (!selectedEntry || !newEntries.includes(selectedEntry)) setSelectedEntry(newEntries[0]);
        setEntries(newEntries);
    }, [
        selectedEntry,
        setEntries,
        setSelectedEntry
    ]);
    // filter entries on value change
    (0, _ui.useEffect)(()=>{
        updateEntries(filterEntries(originalEntries, value));
    }, [
        value,
        originalEntries
    ]);
    // register global <Escape> handler
    (0, _ui.useEffect)(()=>{
        const handleKeyDown = (event)=>{
            if (event.key === 'Escape') {
                event.preventDefault();
                return onClose();
            }
        };
        document.documentElement.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.documentElement.removeEventListener('keydown', handleKeyDown);
        };
    }, []);
    // focus input on initial mount
    (0, _ui.useLayoutEffect)(()=>{
        inputRef.current && inputRef.current.focus();
    }, []);
    // handle keyboard seleciton
    const keyboardSelect = (0, _ui.useCallback)((direction)=>{
        const idx = entries.indexOf(selectedEntry);
        let nextIdx = idx + direction;
        if (nextIdx < 0) nextIdx = entries.length - 1;
        if (nextIdx >= entries.length) nextIdx = 0;
        setSelectedEntry(entries[nextIdx]);
    }, [
        entries,
        selectedEntry,
        setSelectedEntry
    ]);
    const handleKeyDown = (0, _ui.useCallback)((event)=>{
        if (event.key === 'Enter' && selectedEntry) return onSelect(event, selectedEntry);
        // ARROW_UP or SHIFT + TAB navigation
        if (event.key === 'ArrowUp' || event.key === 'Tab' && event.shiftKey) {
            keyboardSelect(-1);
            return event.preventDefault();
        }
        // ARROW_DOWN or TAB navigation
        if (event.key === 'ArrowDown' || event.key === 'Tab') {
            keyboardSelect(1);
            return event.preventDefault();
        }
    }, [
        onSelect,
        onClose,
        selectedEntry,
        keyboardSelect
    ]);
    const handleKey = (0, _ui.useCallback)((event)=>{
        if ((0, _minDom.matches)(event.target, 'input')) setValue(()=>event.target.value);
    }, [
        setValue
    ]);
    (0, _ui.useEffect)(()=>{
        onOpened();
        return ()=>{
            onClosed();
        };
    }, []);
    const displayHeader = (0, _ui.useMemo)(()=>title || headerEntries.length > 0, [
        title,
        headerEntries
    ]);
    return (0, _ui.html)`
    <${PopupMenuWrapper}
      onClose=${onClose}
      onKeyup=${handleKey}
      onKeydown=${handleKeyDown}
      className=${className}
      position=${position}
      width=${width}
      scale=${scale}
    >
      ${displayHeader && (0, _ui.html)`
        <div class="djs-popup-header">
          <h3 class="djs-popup-title" title=${title}>${title}</h3>
          ${headerEntries.map((entry)=>(0, _ui.html)`
            <span
              class=${getHeaderClasses(entry, entry === selectedEntry)}
              onClick=${(event)=>onSelect(event, entry)}
              title=${entry.title || entry.label}
              data-id=${entry.id}
              onMouseEnter=${()=>setSelectedEntry(entry)}
              onMouseLeave=${()=>setSelectedEntry(null)}
            >
              ${entry.imageUrl ? (0, _ui.html)`
                <img class="djs-popup-entry-icon" src=${entry.imageUrl} alt="" />
              ` : null}

              ${entry.label ? (0, _ui.html)`
                <span class="djs-popup-label">${entry.label}</span>
              ` : null}
            </span>
          `)}
        </div>
      `}
      ${originalEntries.length > 0 && (0, _ui.html)`
        <div class="djs-popup-body">

          ${searchable && (0, _ui.html)`
          <div class="djs-popup-search">
            <svg class="djs-popup-search-icon" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M9.0325 8.5H9.625L13.3675 12.25L12.25 13.3675L8.5 9.625V9.0325L8.2975 8.8225C7.4425 9.5575 6.3325 10 5.125 10C2.4325 10 0.25 7.8175 0.25 5.125C0.25 2.4325 2.4325 0.25 5.125 0.25C7.8175 0.25 10 2.4325 10 5.125C10 6.3325 9.5575 7.4425 8.8225 8.2975L9.0325 8.5ZM1.75 5.125C1.75 6.9925 3.2575 8.5 5.125 8.5C6.9925 8.5 8.5 6.9925 8.5 5.125C8.5 3.2575 6.9925 1.75 5.125 1.75C3.2575 1.75 1.75 3.2575 1.75 5.125Z" fill="#22242A"/>
            </svg>
            <input
                ref=${inputRef}
                type="text"
              />
          </div>
          `}

          <${0, _popupMenuListDefault.default}
            entries=${entries}
            selectedEntry=${selectedEntry}
            setSelectedEntry=${setSelectedEntry}
            onAction=${onSelect}
          />
        </div>
        ${entries.length === 0 && (0, _ui.html)`
          <div class="djs-popup-no-results">No matching entries found.</div>
        `}
      `}
    </${PopupMenuWrapper}>
  `;
}
/**
 * A component that wraps the popup menu.
 *
 * @param {*} props
 */ function PopupMenuWrapper(props) {
    const { onClose, onKeydown, onKeyup, className, children, position: positionGetter } = props;
    const popupRef = (0, _ui.useRef)();
    const checkClose = (0, _ui.useCallback)((event)=>{
        const popup = (0, _minDom.closest)(event.target, '.djs-popup', true);
        if (popup) return;
        onClose();
    }, [
        onClose
    ]);
    (0, _ui.useLayoutEffect)(()=>{
        if (typeof positionGetter !== 'function') return;
        const popupEl = popupRef.current;
        const position = positionGetter(popupEl);
        popupEl.style.left = `${position.x}px`;
        popupEl.style.top = `${position.y}px`;
    }, [
        popupRef.current,
        positionGetter
    ]);
    // focus popup initially, on mount
    (0, _ui.useLayoutEffect)(()=>{
        popupRef.current && popupRef.current.focus();
    }, []);
    return (0, _ui.html)`
    <div
      class="djs-popup-backdrop"
      onClick=${checkClose}
    >
      <div
        class=${(0, _clsxDefault.default)('djs-popup', className)}
        style=${getPopupStyle(props)}
        onKeydown=${onKeydown}
        onKeyup=${onKeyup}
        ref=${popupRef}
        tabIndex="-1"
      >
        ${children}
      </div>
    </div>
  `;
}
// helpers //////////////////////
function getPopupStyle(props) {
    return {
        transform: `scale(${props.scale})`,
        width: `${props.width}px`
    };
}
function getHeaderClasses(entry, selected) {
    return (0, _clsxDefault.default)('entry', entry.className, entry.active ? 'active' : '', entry.disabled ? 'disabled' : '', selected ? 'selected' : '');
}

},{"../../ui":[["html","5yBUc"],["useCallback","b4BYL"],["useEffect","b4BYL"],["useLayoutEffect","b4BYL"],["useMemo","b4BYL"],["useRef","b4BYL"],["useState","b4BYL"]],"min-dom":"e58GC","./PopupMenuList":"j79hW","clsx":"7LqNr","min-dash":"aEEla","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"b4BYL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useCallback", ()=>q);
parcelHelpers.export(exports, "useContext", ()=>x);
parcelHelpers.export(exports, "useDebugValue", ()=>P);
parcelHelpers.export(exports, "useEffect", ()=>y);
parcelHelpers.export(exports, "useErrorBoundary", ()=>b);
parcelHelpers.export(exports, "useId", ()=>g);
parcelHelpers.export(exports, "useImperativeHandle", ()=>F);
parcelHelpers.export(exports, "useLayoutEffect", ()=>_);
parcelHelpers.export(exports, "useMemo", ()=>T);
parcelHelpers.export(exports, "useReducer", ()=>h);
parcelHelpers.export(exports, "useRef", ()=>A);
parcelHelpers.export(exports, "useState", ()=>d);
var _preact = require("preact");
var t, r, u, i, o = 0, f = [], c = (0, _preact.options), e = c.__b, a = c.__r, v = c.diffed, l = c.__c, m = c.unmount, s = c.__;
function p(n, t) {
    c.__h && c.__h(r, n, o || t), o = 0;
    var u = r.__H || (r.__H = {
        __: [],
        __h: []
    });
    return n >= u.__.length && u.__.push({}), u.__[n];
}
function d(n) {
    return o = 1, h(D, n);
}
function h(n, u, i) {
    var o = p(t++, 2);
    if (o.t = n, !o.__c && (o.__ = [
        i ? i(u) : D(void 0, u),
        function(n) {
            var t = o.__N ? o.__N[0] : o.__[0], r = o.t(t, n);
            t !== r && (o.__N = [
                r,
                o.__[1]
            ], o.__c.setState({}));
        }
    ], o.__c = r, !r.__f)) {
        var f = function(n, t, r) {
            if (!o.__c.__H) return !0;
            var u = o.__c.__H.__.filter(function(n) {
                return !!n.__c;
            });
            if (u.every(function(n) {
                return !n.__N;
            })) return !c || c.call(this, n, t, r);
            var i = o.__c.props !== n;
            return u.forEach(function(n) {
                if (n.__N) {
                    var t = n.__[0];
                    n.__ = n.__N, n.__N = void 0, t !== n.__[0] && (i = !0);
                }
            }), c && c.call(this, n, t, r) || i;
        };
        r.__f = !0;
        var c = r.shouldComponentUpdate, e = r.componentWillUpdate;
        r.componentWillUpdate = function(n, t, r) {
            if (this.__e) {
                var u = c;
                c = void 0, f(n, t, r), c = u;
            }
            e && e.call(this, n, t, r);
        }, r.shouldComponentUpdate = f;
    }
    return o.__N || o.__;
}
function y(n, u) {
    var i = p(t++, 3);
    !c.__s && C(i.__H, u) && (i.__ = n, i.u = u, r.__H.__h.push(i));
}
function _(n, u) {
    var i = p(t++, 4);
    !c.__s && C(i.__H, u) && (i.__ = n, i.u = u, r.__h.push(i));
}
function A(n) {
    return o = 5, T(function() {
        return {
            current: n
        };
    }, []);
}
function F(n, t, r) {
    o = 6, _(function() {
        if ("function" == typeof n) {
            var r = n(t());
            return function() {
                n(null), r && "function" == typeof r && r();
            };
        }
        if (n) return n.current = t(), function() {
            return n.current = null;
        };
    }, null == r ? r : r.concat(n));
}
function T(n, r) {
    var u = p(t++, 7);
    return C(u.__H, r) && (u.__ = n(), u.__H = r, u.__h = n), u.__;
}
function q(n, t) {
    return o = 8, T(function() {
        return n;
    }, t);
}
function x(n) {
    var u = r.context[n.__c], i = p(t++, 9);
    return i.c = n, u ? (null == i.__ && (i.__ = !0, u.sub(r)), u.props.value) : n.__;
}
function P(n, t) {
    c.useDebugValue && c.useDebugValue(t ? t(n) : n);
}
function b(n) {
    var u = p(t++, 10), i = d();
    return u.__ = n, r.componentDidCatch || (r.componentDidCatch = function(n, t) {
        u.__ && u.__(n, t), i[1](n);
    }), [
        i[0],
        function() {
            i[1](void 0);
        }
    ];
}
function g() {
    var n = p(t++, 11);
    if (!n.__) {
        for(var u = r.__v; null !== u && !u.__m && null !== u.__;)u = u.__;
        var i = u.__m || (u.__m = [
            0,
            0
        ]);
        n.__ = "P" + i[0] + "-" + i[1]++;
    }
    return n.__;
}
function j() {
    for(var n; n = f.shift();)if (n.__P && n.__H) try {
        n.__H.__h.forEach(z), n.__H.__h.forEach(B), n.__H.__h = [];
    } catch (t) {
        n.__H.__h = [], c.__e(t, n.__v);
    }
}
c.__b = function(n) {
    r = null, e && e(n);
}, c.__ = function(n, t) {
    n && t.__k && t.__k.__m && (n.__m = t.__k.__m), s && s(n, t);
}, c.__r = function(n) {
    a && a(n), t = 0;
    var i = (r = n.__c).__H;
    i && (u === r ? (i.__h = [], r.__h = [], i.__.forEach(function(n) {
        n.__N && (n.__ = n.__N), n.u = n.__N = void 0;
    })) : (i.__h.forEach(z), i.__h.forEach(B), i.__h = [], t = 0)), u = r;
}, c.diffed = function(n) {
    v && v(n);
    var t = n.__c;
    t && t.__H && (t.__H.__h.length && (1 !== f.push(t) && i === c.requestAnimationFrame || ((i = c.requestAnimationFrame) || w)(j)), t.__H.__.forEach(function(n) {
        n.u && (n.__H = n.u), n.u = void 0;
    })), u = r = null;
}, c.__c = function(n, t) {
    t.some(function(n) {
        try {
            n.__h.forEach(z), n.__h = n.__h.filter(function(n) {
                return !n.__ || B(n);
            });
        } catch (r) {
            t.some(function(n) {
                n.__h && (n.__h = []);
            }), t = [], c.__e(r, n.__v);
        }
    }), l && l(n, t);
}, c.unmount = function(n) {
    m && m(n);
    var t, r = n.__c;
    r && r.__H && (r.__H.__.forEach(function(n) {
        try {
            z(n);
        } catch (n) {
            t = n;
        }
    }), r.__H = void 0, t && c.__e(t, r.__v));
};
var k = "function" == typeof requestAnimationFrame;
function w(n) {
    var t, r = function() {
        clearTimeout(u), k && cancelAnimationFrame(t), setTimeout(n);
    }, u = setTimeout(r, 35);
    k && (t = requestAnimationFrame(r));
}
function z(n) {
    var t = r, u = n.__c;
    "function" == typeof u && (n.__c = void 0, u()), r = t;
}
function B(n) {
    var t = r;
    n.__c = n.__(), r = t;
}
function C(n, t) {
    return !n || n.length !== t.length || t.some(function(t, r) {
        return t !== n[r];
    });
}
function D(n, t) {
    return "function" == typeof t ? t(n) : t;
}

},{"preact":"iq90b","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"j79hW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PopupMenuList);
var _ui = require("../../ui");
var _popupMenuItem = require("./PopupMenuItem");
var _popupMenuItemDefault = parcelHelpers.interopDefault(_popupMenuItem);
function PopupMenuList(props) {
    const { selectedEntry, setSelectedEntry, entries, ...restProps } = props;
    const resultsRef = (0, _ui.useRef)();
    const groups = (0, _ui.useMemo)(()=>groupEntries(entries), [
        entries
    ]);
    // scroll to selected result
    (0, _ui.useLayoutEffect)(()=>{
        const containerEl = resultsRef.current;
        if (!containerEl) return;
        const selectedEl = containerEl.querySelector('.selected');
        if (selectedEl) scrollIntoView(selectedEl);
    }, [
        selectedEntry
    ]);
    return (0, _ui.html)`
    <div class="djs-popup-results" ref=${resultsRef}>
      ${groups.map((group)=>(0, _ui.html)`
        ${group.name && (0, _ui.html)`
          <div key=${group.id} class="entry-header" title=${group.name}>
            ${group.name}
          </div>
        `}
        <ul class="djs-popup-group" data-group=${group.id}>
          ${group.entries.map((entry)=>(0, _ui.html)`
            <${0, _popupMenuItemDefault.default}
              key=${entry.id}
              entry=${entry}
              selected=${entry === selectedEntry}
              onMouseEnter=${()=>setSelectedEntry(entry)}
              onMouseLeave=${()=>setSelectedEntry(null)}
              ...${restProps}
            />
          `)}
        </ul>
      `)}
    </div>
  `;
}
// helpers
function groupEntries(entries) {
    const groups = [];
    const getGroup = (group)=>groups.find((elem)=>group.id === elem.id);
    const containsGroup = (group)=>!!getGroup(group);
    // legacy support for provider built for the old popUp menu
    const formatGroup = (group)=>typeof group === 'string' ? {
            id: group
        } : group;
    entries.forEach((entry)=>{
        // assume a default group when none is provided
        const group = entry.group ? formatGroup(entry.group) : {
            id: 'default'
        };
        if (!containsGroup(group)) groups.push({
            ...group,
            entries: [
                entry
            ]
        });
        else getGroup(group).entries.push(entry);
    });
    return groups;
}
// helpers ////////////////
function scrollIntoView(el) {
    if (typeof el.scrollIntoViewIfNeeded === 'function') el.scrollIntoViewIfNeeded();
    else el.scrollIntoView({
        scrollMode: 'if-needed',
        block: 'nearest'
    });
}

},{"../../ui":[["html","5yBUc"],["useLayoutEffect","b4BYL"],["useMemo","b4BYL"],["useRef","b4BYL"]],"./PopupMenuItem":"bXLR6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bXLR6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PopupMenuItem);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _ui = require("../../ui");
function PopupMenuItem(props) {
    const { entry, selected, onMouseEnter, onMouseLeave, onAction } = props;
    return (0, _ui.html)`
    <li
      class=${(0, _clsxDefault.default)('entry', {
        selected
    })}
      data-id=${entry.id}
      title=${entry.title || entry.label}
      onClick=${onAction}
      onMouseEnter=${onMouseEnter}
      onMouseLeave=${onMouseLeave}
      onDragStart=${(event)=>onAction(event, entry, 'dragstart')}
      draggable=${true}
    >
      <div class="djs-popup-entry-content">
        <span
          class=${(0, _clsxDefault.default)('djs-popup-entry-name', entry.className)}
        >
          ${entry.imageUrl ? (0, _ui.html)`
            <img class="djs-popup-entry-icon" src=${entry.imageUrl} alt="" />
          ` : null}

          ${entry.label ? (0, _ui.html)`
            <span class="djs-popup-label">
              ${entry.label}
            </span>
          ` : null}
        </span>
        ${entry.description && (0, _ui.html)`
          <span
            class="djs-popup-entry-description"
            title=${entry.description}
          >
            ${entry.description}
          </span>
        `}
      </div>
      ${entry.documentationRef && (0, _ui.html)`
        <div class="djs-popup-entry-docs">
          <a
            href="${entry.documentationRef}"
            onClick=${(event)=>event.stopPropagation()}
            title="Open element documentation"
            target="_blank"
            rel="noopener"
          >
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M10.6368 10.6375V5.91761H11.9995V10.6382C11.9995 10.9973 11.8623 11.3141 11.5878 11.5885C11.3134 11.863 10.9966 12.0002 10.6375 12.0002H1.36266C0.982345 12.0002 0.660159 11.8681 0.396102 11.6041C0.132044 11.34 1.52588e-05 11.0178 1.52588e-05 10.6375V1.36267C1.52588e-05 0.98236 0.132044 0.660173 0.396102 0.396116C0.660159 0.132058 0.982345 2.95639e-05 1.36266 2.95639e-05H5.91624V1.36267H1.36266V10.6375H10.6368ZM12 0H7.2794L7.27873 1.36197H9.68701L3.06507 7.98391L4.01541 8.93425L10.6373 2.31231V4.72059H12V0Z" fill="#818798"/>
            </svg>
          </a>
        </div>
      `}
    </li>
  `;
}

},{"clsx":"7LqNr","../../ui":"5yBUc","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7LqNr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clsx", ()=>clsx);
function r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function clsx() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = r(e)) && (n && (n += " "), n += t);
    return n;
}
exports.default = clsx;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9fvuH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AlignElementsContextPadProvider);
var _minDash = require("min-dash");
var _alignElementsIcons = require("./AlignElementsIcons");
var _alignElementsIconsDefault = parcelHelpers.interopDefault(_alignElementsIcons);
var LOW_PRIORITY = 900;
function AlignElementsContextPadProvider(contextPad, popupMenu, translate, canvas) {
    contextPad.registerProvider(LOW_PRIORITY, this);
    this._contextPad = contextPad;
    this._popupMenu = popupMenu;
    this._translate = translate;
    this._canvas = canvas;
}
AlignElementsContextPadProvider.$inject = [
    'contextPad',
    'popupMenu',
    'translate',
    'canvas'
];
AlignElementsContextPadProvider.prototype.getMultiElementContextPadEntries = function(elements) {
    var actions = {};
    if (this._isAllowed(elements)) (0, _minDash.assign)(actions, this._getEntries(elements));
    return actions;
};
AlignElementsContextPadProvider.prototype._isAllowed = function(elements) {
    return !this._popupMenu.isEmpty(elements, 'align-elements');
};
AlignElementsContextPadProvider.prototype._getEntries = function(elements) {
    var self = this;
    return {
        'align-elements': {
            group: 'align-elements',
            title: self._translate('Align elements'),
            imageUrl: (0, _alignElementsIconsDefault.default)['align'],
            action: {
                click: function(event, elements) {
                    var position = self._getMenuPosition(elements);
                    (0, _minDash.assign)(position, {
                        cursor: {
                            x: event.x,
                            y: event.y
                        }
                    });
                    self._popupMenu.open(elements, 'align-elements', position);
                }
            }
        }
    };
};
AlignElementsContextPadProvider.prototype._getMenuPosition = function(elements) {
    var Y_OFFSET = 5;
    var pad = this._contextPad.getPad(elements).html;
    var padRect = pad.getBoundingClientRect();
    var pos = {
        x: padRect.left,
        y: padRect.bottom + Y_OFFSET
    };
    return pos;
};

},{"min-dash":"aEEla","./AlignElementsIcons":"eV7Uq","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eV7Uq":[function(require,module,exports,__globalThis) {
/**
 * To change the icons, modify the SVGs in `./resources`, execute `npx svgo -f resources --datauri enc -o dist`,
 * and then replace respective icons with the optimized data URIs in `./dist`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var icons = {
    align: 'data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%202000%202000%22%3E%3Cpath%20style%3D%22stroke%3AcurrentColor%3Bstroke-width%3A100%3Bstroke-linecap%3Around%22%20d%3D%22M200%20150v1700%22%2F%3E%3Crect%20x%3D%22500%22%20y%3D%22150%22%20width%3D%221300%22%20height%3D%22700%22%20rx%3D%221%22%20style%3D%22fill%3Anone%3Bstroke%3AcurrentColor%3Bstroke-width%3A100%22%2F%3E%3Crect%20x%3D%22500%22%20y%3D%221150%22%20width%3D%22700%22%20height%3D%22700%22%20rx%3D%221%22%20style%3D%22fill%3AcurrentColor%3Bstroke%3AcurrentColor%3Bstroke-width%3A100%3Bopacity%3A.5%22%2F%3E%3C%2Fsvg%3E',
    bottom: 'data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%201800%201800%22%3E%3Cpath%20style%3D%22stroke%3AcurrentColor%3Bstroke-width%3A100%3Bstroke-linecap%3Around%22%20d%3D%22M150%201650h1500%22%2F%3E%3Crect%20x%3D%22150%22%20y%3D%22350%22%20width%3D%22600%22%20height%3D%221300%22%20rx%3D%221%22%20style%3D%22fill%3Anone%3Bstroke%3AcurrentColor%3Bstroke-width%3A100%22%2F%3E%3Crect%20x%3D%221050%22%20y%3D%22850%22%20width%3D%22600%22%20height%3D%22800%22%20rx%3D%221%22%20style%3D%22fill%3AcurrentColor%3Bstroke%3AcurrentColor%3Bstroke-width%3A100%3Bopacity%3A.5%22%2F%3E%3C%2Fsvg%3E',
    center: 'data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%201800%201800%22%3E%3Cpath%20style%3D%22stroke%3AcurrentColor%3Bstroke-width%3A100%3Bstroke-linecap%3Around%22%20d%3D%22M900%20150v1500%22%2F%3E%3Crect%20x%3D%22250%22%20y%3D%22150%22%20width%3D%221300%22%20height%3D%22600%22%20rx%3D%221%22%20style%3D%22fill%3Anone%3Bstroke%3AcurrentColor%3Bstroke-width%3A100%22%2F%3E%3Crect%20x%3D%22500%22%20y%3D%221050%22%20width%3D%22800%22%20height%3D%22600%22%20rx%3D%221%22%20style%3D%22fill%3AcurrentColor%3Bstroke%3AcurrentColor%3Bstroke-width%3A100%3Bopacity%3A.5%22%2F%3E%3C%2Fsvg%3E',
    left: 'data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%201800%201800%22%3E%3Cpath%20style%3D%22stroke%3AcurrentColor%3Bstroke-width%3A100%3Bstroke-linecap%3Around%22%20d%3D%22M100%20150v1500%22%2F%3E%3Crect%20x%3D%22100%22%20y%3D%22150%22%20width%3D%221300%22%20height%3D%22600%22%20rx%3D%221%22%20style%3D%22fill%3Anone%3Bstroke%3AcurrentColor%3Bstroke-width%3A100%22%2F%3E%3Crect%20x%3D%22100%22%20y%3D%221050%22%20width%3D%22800%22%20height%3D%22600%22%20rx%3D%221%22%20style%3D%22fill%3AcurrentColor%3Bstroke%3AcurrentColor%3Bstroke-width%3A100%3Bopacity%3A.5%22%2F%3E%3C%2Fsvg%3E',
    right: 'data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%201800%201800%22%3E%3Cpath%20style%3D%22stroke%3AcurrentColor%3Bstroke-width%3A100%3Bstroke-linecap%3Around%22%20d%3D%22M1650%20150v1500%22%2F%3E%3Crect%20x%3D%22350%22%20y%3D%22150%22%20width%3D%221300%22%20height%3D%22600%22%20rx%3D%221%22%20style%3D%22fill%3Anone%3Bstroke%3AcurrentColor%3Bstroke-width%3A100%22%2F%3E%3Crect%20x%3D%22850%22%20y%3D%221050%22%20width%3D%22800%22%20height%3D%22600%22%20rx%3D%221%22%20style%3D%22fill%3AcurrentColor%3Bstroke%3AcurrentColor%3Bstroke-width%3A100%3Bopacity%3A.5%22%2F%3E%3C%2Fsvg%3E',
    top: 'data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%201800%201800%22%3E%3Cpath%20style%3D%22stroke%3AcurrentColor%3Bstroke-width%3A100%3Bstroke-linecap%3Around%22%20d%3D%22M150%20150h1500%22%2F%3E%3Crect%20x%3D%22150%22%20y%3D%22150%22%20width%3D%22600%22%20height%3D%221300%22%20rx%3D%221%22%20style%3D%22fill%3Anone%3Bstroke%3AcurrentColor%3Bstroke-width%3A100%22%2F%3E%3Crect%20x%3D%221050%22%20y%3D%22150%22%20width%3D%22600%22%20height%3D%22800%22%20rx%3D%221%22%20style%3D%22fill%3AcurrentColor%3Bstroke%3AcurrentColor%3Bstroke-width%3A100%3Bopacity%3A.5%22%2F%3E%3C%2Fsvg%3E',
    middle: 'data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%201800%201800%22%3E%3Cpath%20style%3D%22stroke%3AcurrentColor%3Bstroke-width%3A100%3Bstroke-linecap%3Around%22%20d%3D%22M150%20900h1500%22%2F%3E%3Crect%20x%3D%22150%22%20y%3D%22250%22%20width%3D%22600%22%20height%3D%221300%22%20rx%3D%221%22%20style%3D%22fill%3Anone%3Bstroke%3AcurrentColor%3Bstroke-width%3A100%22%2F%3E%3Crect%20x%3D%221050%22%20y%3D%22500%22%20width%3D%22600%22%20height%3D%22800%22%20rx%3D%221%22%20style%3D%22fill%3AcurrentColor%3Bstroke%3AcurrentColor%3Bstroke-width%3A100%3Bopacity%3A.5%22%2F%3E%3C%2Fsvg%3E'
};
exports.default = icons;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"guogf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AlignElementsMenuProvider);
var _alignElementsIcons = require("./AlignElementsIcons");
var _alignElementsIconsDefault = parcelHelpers.interopDefault(_alignElementsIcons);
var _minDash = require("min-dash");
var ALIGNMENT_OPTIONS = [
    'left',
    'center',
    'right',
    'top',
    'middle',
    'bottom'
];
function AlignElementsMenuProvider(popupMenu, alignElements, translate, rules) {
    this._alignElements = alignElements;
    this._translate = translate;
    this._popupMenu = popupMenu;
    this._rules = rules;
    popupMenu.registerProvider('align-elements', this);
}
AlignElementsMenuProvider.$inject = [
    'popupMenu',
    'alignElements',
    'translate',
    'rules'
];
AlignElementsMenuProvider.prototype.getPopupMenuEntries = function(elements) {
    var entries = {};
    if (this._isAllowed(elements)) (0, _minDash.assign)(entries, this._getEntries(elements));
    return entries;
};
AlignElementsMenuProvider.prototype._isAllowed = function(elements) {
    return this._rules.allowed('elements.align', {
        elements: elements
    });
};
AlignElementsMenuProvider.prototype._getEntries = function(elements) {
    var alignElements = this._alignElements, translate = this._translate, popupMenu = this._popupMenu;
    var entries = {};
    (0, _minDash.forEach)(ALIGNMENT_OPTIONS, function(alignment) {
        entries['align-elements-' + alignment] = {
            group: 'align',
            title: translate('Align elements ' + alignment),
            className: 'bjs-align-elements-menu-entry',
            imageUrl: (0, _alignElementsIconsDefault.default)[alignment],
            action: function(event, entry) {
                alignElements.trigger(elements, alignment);
                popupMenu.close();
            }
        };
    });
    return entries;
};

},{"./AlignElementsIcons":"eV7Uq","min-dash":"aEEla","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9pgN2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BpmnAlignElements);
var _inheritsBrowser = require("inherits-browser");
var _inheritsBrowserDefault = parcelHelpers.interopDefault(_inheritsBrowser);
var _ruleProvider = require("diagram-js/lib/features/rules/RuleProvider");
var _ruleProviderDefault = parcelHelpers.interopDefault(_ruleProvider);
var _elements = require("diagram-js/lib/util/Elements");
var _minDash = require("min-dash");
function BpmnAlignElements(eventBus) {
    (0, _ruleProviderDefault.default).call(this, eventBus);
}
BpmnAlignElements.$inject = [
    'eventBus'
];
(0, _inheritsBrowserDefault.default)(BpmnAlignElements, (0, _ruleProviderDefault.default));
BpmnAlignElements.prototype.init = function() {
    this.addRule('elements.align', function(context) {
        var elements = context.elements;
        // filter out elements which cannot be aligned
        var filteredElements = (0, _minDash.filter)(elements, function(element) {
            return !(element.waypoints || element.host || element.labelTarget);
        });
        // filter out elements which are children of any of the selected elements
        filteredElements = (0, _elements.getParents)(filteredElements);
        if (filteredElements.length < 2) return false;
        return filteredElements;
    });
};

},{"inherits-browser":"hymxq","diagram-js/lib/features/rules/RuleProvider":"5VfYt","diagram-js/lib/util/Elements":"6qdtl","min-dash":"aEEla","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5VfYt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>RuleProvider);
var _inheritsBrowser = require("inherits-browser");
var _inheritsBrowserDefault = parcelHelpers.interopDefault(_inheritsBrowser);
var _commandInterceptor = require("../../command/CommandInterceptor");
var _commandInterceptorDefault = parcelHelpers.interopDefault(_commandInterceptor);
function RuleProvider(eventBus) {
    (0, _commandInterceptorDefault.default).call(this, eventBus);
    this.init();
}
RuleProvider.$inject = [
    'eventBus'
];
(0, _inheritsBrowserDefault.default)(RuleProvider, (0, _commandInterceptorDefault.default));
/**
 * Adds a modeling rule for the given action, implemented through
 * a callback function.
 *
 * The function will receive the modeling specific action context
 * to perform its check. It must return `false` to disallow the
 * action from happening or `true` to allow the action.
 *
 * A rule provider may pass over the evaluation to lower priority
 * rules by returning return nothing (or <code>undefined</code>).
 *
 * @example
 *
 * ResizableRules.prototype.init = function() {
 *
 *   \/**
 *    * Return `true`, `false` or nothing to denote
 *    * _allowed_, _not allowed_ and _continue evaluating_.
 *    *\/
 *   this.addRule('shape.resize', function(context) {
 *
 *     var shape = context.shape;
 *
 *     if (!context.newBounds) {
 *       // check general resizability
 *       if (!shape.resizable) {
 *         return false;
 *       }
 *
 *       // not returning anything (read: undefined)
 *       // will continue the evaluation of other rules
 *       // (with lower priority)
 *       return;
 *     } else {
 *       // element must have minimum size of 10*10 points
 *       return context.newBounds.width > 10 && context.newBounds.height > 10;
 *     }
 *   });
 * };
 *
 * @param {string|Array<string>} actions the identifier for the modeling action to check
 * @param {number} [priority] the priority at which this rule is being applied
 * @param {Function} fn the callback function that performs the actual check
 */ RuleProvider.prototype.addRule = function(actions, priority, fn) {
    var self = this;
    if (typeof actions === 'string') actions = [
        actions
    ];
    actions.forEach(function(action) {
        self.canExecute(action, priority, function(context, action, event) {
            return fn(context);
        }, true);
    });
};
/**
 * Implement this method to add new rules during provider initialization.
 */ RuleProvider.prototype.init = function() {};

},{"inherits-browser":"hymxq","../../command/CommandInterceptor":"1K1IQ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8yzvZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _autoPlace = require("diagram-js/lib/features/auto-place");
var _autoPlaceDefault = parcelHelpers.interopDefault(_autoPlace);
var _bpmnAutoPlace = require("./BpmnAutoPlace");
var _bpmnAutoPlaceDefault = parcelHelpers.interopDefault(_bpmnAutoPlace);
exports.default = {
    __depends__: [
        (0, _autoPlaceDefault.default)
    ],
    __init__: [
        'bpmnAutoPlace'
    ],
    bpmnAutoPlace: [
        'type',
        (0, _bpmnAutoPlaceDefault.default)
    ]
};

},{"diagram-js/lib/features/auto-place":"6jJG3","./BpmnAutoPlace":"74q87","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6jJG3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _autoPlace = require("./AutoPlace");
var _autoPlaceDefault = parcelHelpers.interopDefault(_autoPlace);
var _autoPlaceSelectionBehavior = require("./AutoPlaceSelectionBehavior");
var _autoPlaceSelectionBehaviorDefault = parcelHelpers.interopDefault(_autoPlaceSelectionBehavior);
exports.default = {
    __init__: [
        'autoPlaceSelectionBehavior'
    ],
    autoPlace: [
        'type',
        (0, _autoPlaceDefault.default)
    ],
    autoPlaceSelectionBehavior: [
        'type',
        (0, _autoPlaceSelectionBehaviorDefault.default)
    ]
};

},{"./AutoPlace":"adfrs","./AutoPlaceSelectionBehavior":"9I7lN","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"adfrs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AutoPlace);
var _layoutUtil = require("../../layout/LayoutUtil");
var _autoPlaceUtil = require("./AutoPlaceUtil");
/**
 * @typedef {import('../../model').Shape} Shape
 *
 * @typedef {import('../../util/Types').Point} Point
 *
 * @typedef {import('../../core/Canvas').default} Canvas
 * @typedef {import('../../core/EventBus').default} EventBus
 * @typedef {import('../modeling/Modeling').default} Modeling
 */ var LOW_PRIORITY = 100;
function AutoPlace(eventBus, modeling, canvas) {
    eventBus.on('autoPlace', LOW_PRIORITY, function(context) {
        var shape = context.shape, source = context.source;
        return getNewShapePosition(source, shape);
    });
    eventBus.on('autoPlace.end', function(event) {
        canvas.scrollToElement(event.shape);
    });
    /**
   * Append shape to source at appropriate position.
   *
   * @param {Shape} source
   * @param {Shape} shape
   *
   * @return {Shape} appended shape
   */ this.append = function(source, shape, hints) {
        eventBus.fire('autoPlace.start', {
            source: source,
            shape: shape
        });
        // allow others to provide the position
        var position = eventBus.fire('autoPlace', {
            source: source,
            shape: shape
        });
        var newShape = modeling.appendShape(source, shape, position, source.parent, hints);
        eventBus.fire('autoPlace.end', {
            source: source,
            shape: newShape
        });
        return newShape;
    };
}
AutoPlace.$inject = [
    'eventBus',
    'modeling',
    'canvas'
];
// helpers //////////
/**
 * Find the new position for the target element to
 * connect to source.
 *
 * @param {Shape} source
 * @param {Shape} element
 * @param {Object} [hints]
 * @param {Object} [hints.defaultDistance]
 *
 * @returns {Point}
 */ function getNewShapePosition(source, element, hints) {
    if (!hints) hints = {};
    var distance = hints.defaultDistance || (0, _autoPlaceUtil.DEFAULT_DISTANCE);
    var sourceMid = (0, _layoutUtil.getMid)(source), sourceTrbl = (0, _layoutUtil.asTRBL)(source);
    // simply put element right next to source
    return {
        x: sourceTrbl.right + distance + element.width / 2,
        y: sourceMid.y
    };
}

},{"../../layout/LayoutUtil":"4CCrs","./AutoPlaceUtil":"4XER9","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4XER9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_DISTANCE", ()=>DEFAULT_DISTANCE);
/**
 * Get free position starting from given position.
 *
 * @param {Shape} source
 * @param {Shape} element
 * @param {Point} position
 * @param {Function} getNextPosition
 *
 * @return {Point}
 */ parcelHelpers.export(exports, "findFreePosition", ()=>findFreePosition);
/**
 * Returns function that returns next position.
 *
 * @param {Object} nextPositionDirection
 * @param {Object} [nextPositionDirection.x]
 * @param {Object} [nextPositionDirection.y]
 *
 * @returns {Function}
 */ parcelHelpers.export(exports, "generateGetNextPosition", ()=>generateGetNextPosition);
/**
 * Return target at given position, if defined.
 *
 * This takes connected elements from host and attachers
 * into account, too.
 */ parcelHelpers.export(exports, "getConnectedAtPosition", ()=>getConnectedAtPosition);
/**
* Compute optimal distance between source and target based on existing connections to and from source.
* Assumes left-to-right and top-to-down modeling.
*
* @param {Shape} source
* @param {Object} [hints]
* @param {number} [hints.defaultDistance]
* @param {string} [hints.direction]
* @param {Function} [hints.filter]
* @param {Function} [hints.getWeight]
* @param {number} [hints.maxDistance]
* @param {string} [hints.reference]
*
* @return {number}
*/ parcelHelpers.export(exports, "getConnectedDistance", ()=>getConnectedDistance);
var _layoutUtil = require("../../layout/LayoutUtil");
var _minDash = require("min-dash");
/**
 * @typedef {import('../../model').Shape} Shape
 *
 * @typedef {import('../../util/Types').Point} Point
 */ // padding to detect element placement
var PLACEMENT_DETECTION_PAD = 10;
var DEFAULT_DISTANCE = 50;
var DEFAULT_MAX_DISTANCE = 250;
function findFreePosition(source, element, position, getNextPosition) {
    var connectedAtPosition;
    while(connectedAtPosition = getConnectedAtPosition(source, position, element))position = getNextPosition(element, position, connectedAtPosition);
    return position;
}
function generateGetNextPosition(nextPositionDirection) {
    return function(element, previousPosition, connectedAtPosition) {
        var nextPosition = {
            x: previousPosition.x,
            y: previousPosition.y
        };
        [
            'x',
            'y'
        ].forEach(function(axis) {
            var nextPositionDirectionForAxis = nextPositionDirection[axis];
            if (!nextPositionDirectionForAxis) return;
            var dimension = axis === 'x' ? 'width' : 'height';
            var margin = nextPositionDirectionForAxis.margin, minDistance = nextPositionDirectionForAxis.minDistance;
            if (margin < 0) nextPosition[axis] = Math.min(connectedAtPosition[axis] + margin - element[dimension] / 2, previousPosition[axis] - minDistance + margin);
            else nextPosition[axis] = Math.max(connectedAtPosition[axis] + connectedAtPosition[dimension] + margin + element[dimension] / 2, previousPosition[axis] + minDistance + margin);
        });
        return nextPosition;
    };
}
function getConnectedAtPosition(source, position, element) {
    var bounds = {
        x: position.x - element.width / 2,
        y: position.y - element.height / 2,
        width: element.width,
        height: element.height
    };
    var closure = getAutoPlaceClosure(source, element);
    return (0, _minDash.find)(closure, function(target) {
        if (target === element) return false;
        var orientation = (0, _layoutUtil.getOrientation)(target, bounds, PLACEMENT_DETECTION_PAD);
        return orientation === 'intersect';
    });
}
function getConnectedDistance(source, hints) {
    if (!hints) hints = {};
    // targets > sources by default
    function getDefaultWeight(connection) {
        return connection.source === source ? 1 : -1;
    }
    var defaultDistance = hints.defaultDistance || DEFAULT_DISTANCE, direction = hints.direction || 'e', filter = hints.filter, getWeight = hints.getWeight || getDefaultWeight, maxDistance = hints.maxDistance || DEFAULT_MAX_DISTANCE, reference = hints.reference || 'start';
    if (!filter) filter = noneFilter;
    function getDistance(a, b) {
        if (direction === 'n') {
            if (reference === 'start') return (0, _layoutUtil.asTRBL)(a).top - (0, _layoutUtil.asTRBL)(b).bottom;
            else if (reference === 'center') return (0, _layoutUtil.asTRBL)(a).top - (0, _layoutUtil.getMid)(b).y;
            else return (0, _layoutUtil.asTRBL)(a).top - (0, _layoutUtil.asTRBL)(b).top;
        } else if (direction === 'w') {
            if (reference === 'start') return (0, _layoutUtil.asTRBL)(a).left - (0, _layoutUtil.asTRBL)(b).right;
            else if (reference === 'center') return (0, _layoutUtil.asTRBL)(a).left - (0, _layoutUtil.getMid)(b).x;
            else return (0, _layoutUtil.asTRBL)(a).left - (0, _layoutUtil.asTRBL)(b).left;
        } else if (direction === 's') {
            if (reference === 'start') return (0, _layoutUtil.asTRBL)(b).top - (0, _layoutUtil.asTRBL)(a).bottom;
            else if (reference === 'center') return (0, _layoutUtil.getMid)(b).y - (0, _layoutUtil.asTRBL)(a).bottom;
            else return (0, _layoutUtil.asTRBL)(b).bottom - (0, _layoutUtil.asTRBL)(a).bottom;
        } else {
            if (reference === 'start') return (0, _layoutUtil.asTRBL)(b).left - (0, _layoutUtil.asTRBL)(a).right;
            else if (reference === 'center') return (0, _layoutUtil.getMid)(b).x - (0, _layoutUtil.asTRBL)(a).right;
            else return (0, _layoutUtil.asTRBL)(b).right - (0, _layoutUtil.asTRBL)(a).right;
        }
    }
    var sourcesDistances = source.incoming.filter(filter).map(function(connection) {
        var weight = getWeight(connection);
        var distance = weight < 0 ? getDistance(connection.source, source) : getDistance(source, connection.source);
        return {
            id: connection.source.id,
            distance: distance,
            weight: weight
        };
    });
    var targetsDistances = source.outgoing.filter(filter).map(function(connection) {
        var weight = getWeight(connection);
        var distance = weight > 0 ? getDistance(source, connection.target) : getDistance(connection.target, source);
        return {
            id: connection.target.id,
            distance: distance,
            weight: weight
        };
    });
    var distances = sourcesDistances.concat(targetsDistances).reduce(function(accumulator, currentValue) {
        accumulator[currentValue.id + '__weight_' + currentValue.weight] = currentValue;
        return accumulator;
    }, {});
    var distancesGrouped = (0, _minDash.reduce)(distances, function(accumulator, currentValue) {
        var distance = currentValue.distance, weight = currentValue.weight;
        if (distance < 0 || distance > maxDistance) return accumulator;
        if (!accumulator[String(distance)]) accumulator[String(distance)] = 0;
        accumulator[String(distance)] += 1 * weight;
        if (!accumulator.distance || accumulator[accumulator.distance] < accumulator[String(distance)]) accumulator.distance = distance;
        return accumulator;
    }, {});
    return distancesGrouped.distance || defaultDistance;
}
/**
 * Returns all connected elements around the given source.
 *
 * This includes:
 *
 *   - connected elements
 *   - host connected elements
 *   - attachers connected elements
 *
 * @param {Shape} source
 *
 * @return {Array<Shape>}
 */ function getAutoPlaceClosure(source) {
    var allConnected = getConnected(source);
    if (source.host) allConnected = allConnected.concat(getConnected(source.host));
    if (source.attachers) allConnected = allConnected.concat(source.attachers.reduce(function(shapes, attacher) {
        return shapes.concat(getConnected(attacher));
    }, []));
    return allConnected;
}
function getConnected(element) {
    return getTargets(element).concat(getSources(element));
}
function getSources(shape) {
    return shape.incoming.map(function(connection) {
        return connection.source;
    });
}
function getTargets(shape) {
    return shape.outgoing.map(function(connection) {
        return connection.target;
    });
}
function noneFilter() {
    return true;
}

},{"../../layout/LayoutUtil":"4CCrs","min-dash":"aEEla","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9I7lN":[function(require,module,exports,__globalThis) {
/**
 * @typedef {import('../../core/EventBus').default} EventBus
 * @typedef {import('../selection/Selection').default} Selection
 */ /**
 * Select element after auto placement.
 *
 * @param {EventBus} eventBus
 * @param {Selection} selection
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AutoPlaceSelectionBehavior);
function AutoPlaceSelectionBehavior(eventBus, selection) {
    eventBus.on('autoPlace.end', 500, function(e) {
        selection.select(e.shape);
    });
}
AutoPlaceSelectionBehavior.$inject = [
    'eventBus',
    'selection'
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"74q87":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AutoPlace);
var _bpmnAutoPlaceUtil = require("./BpmnAutoPlaceUtil");
function AutoPlace(eventBus) {
    eventBus.on('autoPlace', function(context) {
        var shape = context.shape, source = context.source;
        return (0, _bpmnAutoPlaceUtil.getNewShapePosition)(source, shape);
    });
}
AutoPlace.$inject = [
    'eventBus'
];

},{"./BpmnAutoPlaceUtil":"gZem1","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gZem1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Find the new position for the target element to
 * connect to source.
 *
 * @param  {djs.model.Shape} source
 * @param  {djs.model.Shape} element
 *
 * @return {Point}
 */ parcelHelpers.export(exports, "getNewShapePosition", ()=>getNewShapePosition);
/**
 * Always try to place element right of source;
 * compute actual distance from previous nodes in flow.
 */ parcelHelpers.export(exports, "getFlowNodePosition", ()=>getFlowNodePosition);
/**
 * Always try to place text annotations top right of source.
 */ parcelHelpers.export(exports, "getTextAnnotationPosition", ()=>getTextAnnotationPosition);
/**
 * Always put element bottom right of source.
 */ parcelHelpers.export(exports, "getDataElementPosition", ()=>getDataElementPosition);
var _modelUtil = require("../../util/ModelUtil");
var _modelingUtil = require("../modeling/util/ModelingUtil");
var _layoutUtil = require("diagram-js/lib/layout/LayoutUtil");
var _autoPlaceUtil = require("diagram-js/lib/features/auto-place/AutoPlaceUtil");
function getNewShapePosition(source, element) {
    if ((0, _modelUtil.is)(element, 'bpmn:TextAnnotation')) return getTextAnnotationPosition(source, element);
    if ((0, _modelingUtil.isAny)(element, [
        'bpmn:DataObjectReference',
        'bpmn:DataStoreReference'
    ])) return getDataElementPosition(source, element);
    if ((0, _modelUtil.is)(element, 'bpmn:FlowNode')) return getFlowNodePosition(source, element);
}
function getFlowNodePosition(source, element) {
    var sourceTrbl = (0, _layoutUtil.asTRBL)(source);
    var sourceMid = (0, _layoutUtil.getMid)(source);
    var horizontalDistance = (0, _autoPlaceUtil.getConnectedDistance)(source, {
        filter: function(connection) {
            return (0, _modelUtil.is)(connection, 'bpmn:SequenceFlow');
        }
    });
    var margin = 30, minDistance = 80, orientation = 'left';
    if ((0, _modelUtil.is)(source, 'bpmn:BoundaryEvent')) {
        orientation = (0, _layoutUtil.getOrientation)(source, source.host, -25);
        if (orientation.indexOf('top') !== -1) margin *= -1;
    }
    var position = {
        x: sourceTrbl.right + horizontalDistance + element.width / 2,
        y: sourceMid.y + getVerticalDistance(orientation, minDistance)
    };
    var nextPositionDirection = {
        y: {
            margin: margin,
            minDistance: minDistance
        }
    };
    return (0, _autoPlaceUtil.findFreePosition)(source, element, position, (0, _autoPlaceUtil.generateGetNextPosition)(nextPositionDirection));
}
function getVerticalDistance(orientation, minDistance) {
    if (orientation.indexOf('top') != -1) return -1 * minDistance;
    else if (orientation.indexOf('bottom') != -1) return minDistance;
    else return 0;
}
function getTextAnnotationPosition(source, element) {
    var sourceTrbl = (0, _layoutUtil.asTRBL)(source);
    var position = {
        x: sourceTrbl.right + element.width / 2,
        y: sourceTrbl.top - 50 - element.height / 2
    };
    if (isConnection(source)) {
        position = (0, _layoutUtil.getMid)(source);
        position.x += 100;
        position.y -= 50;
    }
    var nextPositionDirection = {
        y: {
            margin: -30,
            minDistance: 20
        }
    };
    return (0, _autoPlaceUtil.findFreePosition)(source, element, position, (0, _autoPlaceUtil.generateGetNextPosition)(nextPositionDirection));
}
function getDataElementPosition(source, element) {
    var sourceTrbl = (0, _layoutUtil.asTRBL)(source);
    var position = {
        x: sourceTrbl.right - 10 + element.width / 2,
        y: sourceTrbl.bottom + 40 + element.width / 2
    };
    var nextPositionDirection = {
        x: {
            margin: 30,
            minDistance: 30
        }
    };
    return (0, _autoPlaceUtil.findFreePosition)(source, element, position, (0, _autoPlaceUtil.generateGetNextPosition)(nextPositionDirection));
}
function isConnection(element) {
    return !!element.waypoints;
}

},{"../../util/ModelUtil":"klNYN","../modeling/util/ModelingUtil":"4DR1e","diagram-js/lib/layout/LayoutUtil":"4CCrs","diagram-js/lib/features/auto-place/AutoPlaceUtil":"4XER9","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4DR1e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "is", ()=>(0, _modelUtil.is));
parcelHelpers.export(exports, "isAny", ()=>(0, _modelUtil.isAny));
/**
 * Return the parent of the element with any of the given types.
 *
 * @param {djs.model.Base} element
 * @param {string|Array<string>} anyType
 *
 * @return {djs.model.Base}
 */ parcelHelpers.export(exports, "getParent", ()=>getParent);
var _modelUtil = require("../../../util/ModelUtil");
function getParent(element, anyType) {
    if (typeof anyType === 'string') anyType = [
        anyType
    ];
    while(element = element.parent){
        if ((0, _modelUtil.isAny)(element, anyType)) return element;
    }
    return null;
}

},{"../../../util/ModelUtil":"klNYN","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iYR0b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _bpmnAutoResize = require("./BpmnAutoResize");
var _bpmnAutoResizeDefault = parcelHelpers.interopDefault(_bpmnAutoResize);
var _bpmnAutoResizeProvider = require("./BpmnAutoResizeProvider");
var _bpmnAutoResizeProviderDefault = parcelHelpers.interopDefault(_bpmnAutoResizeProvider);
exports.default = {
    __init__: [
        'bpmnAutoResize',
        'bpmnAutoResizeProvider'
    ],
    bpmnAutoResize: [
        'type',
        (0, _bpmnAutoResizeDefault.default)
    ],
    bpmnAutoResizeProvider: [
        'type',
        (0, _bpmnAutoResizeProviderDefault.default)
    ]
};

},{"./BpmnAutoResize":"8rbzZ","./BpmnAutoResizeProvider":"k2i2L","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8rbzZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BpmnAutoResize);
var _autoResize = require("diagram-js/lib/features/auto-resize/AutoResize");
var _autoResizeDefault = parcelHelpers.interopDefault(_autoResize);
var _inheritsBrowser = require("inherits-browser");
var _inheritsBrowserDefault = parcelHelpers.interopDefault(_inheritsBrowser);
var _modelUtil = require("../../util/ModelUtil");
function BpmnAutoResize(injector) {
    injector.invoke((0, _autoResizeDefault.default), this);
}
BpmnAutoResize.$inject = [
    'injector'
];
(0, _inheritsBrowserDefault.default)(BpmnAutoResize, (0, _autoResizeDefault.default));
/**
 * Resize shapes and lanes.
 *
 * @param {djs.model.Shape} target
 * @param {Bounds} newBounds
 * @param {Object} hints
 */ BpmnAutoResize.prototype.resize = function(target, newBounds, hints) {
    if ((0, _modelUtil.is)(target, 'bpmn:Participant')) this._modeling.resizeLane(target, newBounds, null, hints);
    else this._modeling.resizeShape(target, newBounds, null, hints);
};

},{"diagram-js/lib/features/auto-resize/AutoResize":"lYBJK","inherits-browser":"hymxq","../../util/ModelUtil":"klNYN","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lYBJK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AutoResize);
var _inheritsBrowser = require("inherits-browser");
var _inheritsBrowserDefault = parcelHelpers.interopDefault(_inheritsBrowser);
var _elements = require("../../util/Elements");
var _layoutUtil = require("../../layout/LayoutUtil");
var _minDash = require("min-dash");
var _commandInterceptor = require("../../command/CommandInterceptor");
var _commandInterceptorDefault = parcelHelpers.interopDefault(_commandInterceptor);
function AutoResize(eventBus, elementRegistry, modeling, rules) {
    (0, _commandInterceptorDefault.default).call(this, eventBus);
    this._elementRegistry = elementRegistry;
    this._modeling = modeling;
    this._rules = rules;
    var self = this;
    this.postExecuted([
        'shape.create'
    ], function(event) {
        var context = event.context, hints = context.hints || {}, shape = context.shape, parent = context.parent || context.newParent;
        if (hints.autoResize === false) return;
        self._expand([
            shape
        ], parent);
    });
    this.postExecuted([
        'elements.move'
    ], function(event) {
        var context = event.context, elements = (0, _minDash.flatten)((0, _minDash.values)(context.closure.topLevel)), hints = context.hints;
        var autoResize = hints ? hints.autoResize : true;
        if (autoResize === false) return;
        var expandings = (0, _minDash.groupBy)(elements, function(element) {
            return element.parent.id;
        });
        (0, _minDash.forEach)(expandings, function(elements, parentId) {
            // optionally filter elements to be considered when resizing
            if ((0, _minDash.isArray)(autoResize)) elements = elements.filter(function(element) {
                return (0, _minDash.find)(autoResize, (0, _minDash.matchPattern)({
                    id: element.id
                }));
            });
            self._expand(elements, parentId);
        });
    });
    this.postExecuted([
        'shape.toggleCollapse'
    ], function(event) {
        var context = event.context, hints = context.hints, shape = context.shape;
        if (hints && hints.autoResize === false) return;
        if (shape.collapsed) return;
        self._expand(shape.children || [], shape);
    });
    this.postExecuted([
        'shape.resize'
    ], function(event) {
        var context = event.context, hints = context.hints, shape = context.shape, parent = shape.parent;
        if (hints && hints.autoResize === false) return;
        if (parent) self._expand([
            shape
        ], parent);
    });
}
AutoResize.$inject = [
    'eventBus',
    'elementRegistry',
    'modeling',
    'rules'
];
(0, _inheritsBrowserDefault.default)(AutoResize, (0, _commandInterceptorDefault.default));
/**
 * Calculate the new bounds of the target shape, given
 * a number of elements have been moved or added into the parent.
 *
 * This method considers the current size, the added elements as well as
 * the provided padding for the new bounds.
 *
 * @param {Shape[]} elements
 * @param {Shape} target
 */ AutoResize.prototype._getOptimalBounds = function(elements, target) {
    var offset = this.getOffset(target), padding = this.getPadding(target);
    var elementsTrbl = (0, _layoutUtil.asTRBL)((0, _elements.getBBox)(elements)), targetTrbl = (0, _layoutUtil.asTRBL)(target);
    var newTrbl = {};
    if (elementsTrbl.top - targetTrbl.top < padding.top) newTrbl.top = elementsTrbl.top - offset.top;
    if (elementsTrbl.left - targetTrbl.left < padding.left) newTrbl.left = elementsTrbl.left - offset.left;
    if (targetTrbl.right - elementsTrbl.right < padding.right) newTrbl.right = elementsTrbl.right + offset.right;
    if (targetTrbl.bottom - elementsTrbl.bottom < padding.bottom) newTrbl.bottom = elementsTrbl.bottom + offset.bottom;
    return (0, _layoutUtil.asBounds)((0, _minDash.assign)({}, targetTrbl, newTrbl));
};
/**
 * Expand the target shape respecting rules, offset and padding
 *
 * @param {Shape[]} elements
 * @param {Shape|string} target The target or its ID.
 */ AutoResize.prototype._expand = function(elements, target) {
    if (typeof target === 'string') target = this._elementRegistry.get(target);
    var allowed = this._rules.allowed('element.autoResize', {
        elements: elements,
        target: target
    });
    if (!allowed) return;
    // calculate the new bounds
    var newBounds = this._getOptimalBounds(elements, target);
    if (!boundsChanged(newBounds, target)) return;
    var resizeDirections = getResizeDirections((0, _minDash.pick)(target, [
        'x',
        'y',
        'width',
        'height'
    ]), newBounds);
    // resize the parent shape
    this.resize(target, newBounds, {
        autoResize: resizeDirections
    });
    var parent = target.parent;
    // recursively expand parent elements
    if (parent) this._expand([
        target
    ], parent);
};
/**
 * Get the amount to expand the given shape in each direction.
 *
 * @param {Shape} shape
 *
 * @return {RectTRBL}
 */ AutoResize.prototype.getOffset = function(shape) {
    return {
        top: 60,
        bottom: 60,
        left: 100,
        right: 100
    };
};
/**
 * Get the activation threshold for each side for which
 * resize triggers.
 *
 * @param {Shape} shape
 *
 * @return {RectTRBL}
 */ AutoResize.prototype.getPadding = function(shape) {
    return {
        top: 2,
        bottom: 2,
        left: 15,
        right: 15
    };
};
/**
 * Perform the actual resize operation.
 *
 * @param {Shape} shape
 * @param {Rect} newBounds
 * @param {Object} [hints]
 * @param {string} [hints.autoResize]
 */ AutoResize.prototype.resize = function(shape, newBounds, hints) {
    this._modeling.resizeShape(shape, newBounds, null, hints);
};
function boundsChanged(newBounds, oldBounds) {
    return newBounds.x !== oldBounds.x || newBounds.y !== oldBounds.y || newBounds.width !== oldBounds.width || newBounds.height !== oldBounds.height;
}
/**
 * Get directions of resize as {n|w|s|e} e.g. "nw".
 *
 * @param {Rect} oldBounds
 * @param {Rect} newBounds
 *
 * @returns {Direction} Resize directions as {n|w|s|e}.
 */ function getResizeDirections(oldBounds, newBounds) {
    var directions = '';
    oldBounds = (0, _layoutUtil.asTRBL)(oldBounds);
    newBounds = (0, _layoutUtil.asTRBL)(newBounds);
    if (oldBounds.top > newBounds.top) directions = directions.concat('n');
    if (oldBounds.right < newBounds.right) directions = directions.concat('w');
    if (oldBounds.bottom < newBounds.bottom) directions = directions.concat('s');
    if (oldBounds.left > newBounds.left) directions = directions.concat('e');
    return directions;
}

},{"inherits-browser":"hymxq","../../util/Elements":"6qdtl","../../layout/LayoutUtil":"4CCrs","min-dash":"aEEla","../../command/CommandInterceptor":"1K1IQ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"k2i2L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BpmnAutoResizeProvider);
var _modelUtil = require("../../util/ModelUtil");
var _inheritsBrowser = require("inherits-browser");
var _inheritsBrowserDefault = parcelHelpers.interopDefault(_inheritsBrowser);
var _minDash = require("min-dash");
var _autoResizeProvider = require("diagram-js/lib/features/auto-resize/AutoResizeProvider");
var _autoResizeProviderDefault = parcelHelpers.interopDefault(_autoResizeProvider);
function BpmnAutoResizeProvider(eventBus, modeling) {
    (0, _autoResizeProviderDefault.default).call(this, eventBus);
    this._modeling = modeling;
}
(0, _inheritsBrowserDefault.default)(BpmnAutoResizeProvider, (0, _autoResizeProviderDefault.default));
BpmnAutoResizeProvider.$inject = [
    'eventBus',
    'modeling'
];
/**
 * Check if the given target can be expanded
 *
 * @param  {djs.model.Shape} target
 *
 * @return {boolean}
 */ BpmnAutoResizeProvider.prototype.canResize = function(elements, target) {
    // do not resize plane elements:
    // root elements, collapsed sub-processes
    if ((0, _modelUtil.is)(target.di, 'bpmndi:BPMNPlane')) return false;
    if (!(0, _modelUtil.is)(target, 'bpmn:Participant') && !(0, _modelUtil.is)(target, 'bpmn:Lane') && !(0, _modelUtil.is)(target, 'bpmn:SubProcess')) return false;
    var canResize = true;
    (0, _minDash.forEach)(elements, function(element) {
        if ((0, _modelUtil.is)(element, 'bpmn:Lane') || element.labelTarget) {
            canResize = false;
            return;
        }
    });
    return canResize;
};

},{"../../util/ModelUtil":"klNYN","inherits-browser":"hymxq","min-dash":"aEEla","diagram-js/lib/features/auto-resize/AutoResizeProvider":"85xse","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"85xse":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AutoResizeProvider);
var _ruleProvider = require("../rules/RuleProvider");
var _ruleProviderDefault = parcelHelpers.interopDefault(_ruleProvider);
var _inheritsBrowser = require("inherits-browser");
var _inheritsBrowserDefault = parcelHelpers.interopDefault(_inheritsBrowser);
function AutoResizeProvider(eventBus) {
    (0, _ruleProviderDefault.default).call(this, eventBus);
    var self = this;
    this.addRule('element.autoResize', function(context) {
        return self.canResize(context.elements, context.target);
    });
}
AutoResizeProvider.$inject = [
    'eventBus'
];
(0, _inheritsBrowserDefault.default)(AutoResizeProvider, (0, _ruleProviderDefault.default));
/**
 * Needs to be implemented by sub classes to allow actual auto resize
 *
 * @param {Shape[]} elements
 * @param {Shape} target
 *
 * @return {boolean}
 */ AutoResizeProvider.prototype.canResize = function(elements, target) {
    return false;
};

},{"../rules/RuleProvider":"5VfYt","inherits-browser":"hymxq","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bmWrZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _dragging = require("../dragging");
var _draggingDefault = parcelHelpers.interopDefault(_dragging);
var _autoScroll = require("./AutoScroll");
var _autoScrollDefault = parcelHelpers.interopDefault(_autoScroll);
exports.default = {
    __depends__: [
        (0, _draggingDefault.default)
    ],
    __init__: [
        'autoScroll'
    ],
    autoScroll: [
        'type',
        (0, _autoScrollDefault.default)
    ]
};

},{"../dragging":"2U3QS","./AutoScroll":"7tkqJ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2U3QS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _hoverFix = require("../hover-fix");
var _hoverFixDefault = parcelHelpers.interopDefault(_hoverFix);
var _selection = require("../selection");
var _selectionDefault = parcelHelpers.interopDefault(_selection);
var _dragging = require("./Dragging");
var _draggingDefault = parcelHelpers.interopDefault(_dragging);
exports.default = {
    __depends__: [
        (0, _hoverFixDefault.default),
        (0, _selectionDefault.default)
    ],
    dragging: [
        'type',
        (0, _draggingDefault.default)
    ]
};

},{"../hover-fix":"gaSxU","../selection":"8Jf3R","./Dragging":"7yqqM","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gaSxU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _hoverFix = require("./HoverFix");
var _hoverFixDefault = parcelHelpers.interopDefault(_hoverFix);
exports.default = {
    __init__: [
        'hoverFix'
    ],
    hoverFix: [
        'type',
        (0, _hoverFixDefault.default)
    ]
};

},{"./HoverFix":"9i20s","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9i20s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>HoverFix);
var _minDom = require("min-dom");
var _event = require("../../util/Event");
/**
 * @typedef {import('didi').Injector} Injector
 *
 * @typedef {import('../../core/ElementRegistry').default} ElementRegistry
 * @typedef {import('../../core/EventBus').default} EventBus
 */ var HIGH_PRIORITY = 1500;
function HoverFix(elementRegistry, eventBus, injector) {
    var self = this;
    var dragging = injector.get('dragging', false);
    /**
   * Make sure we are god damn hovering!
   *
   * @param {Event} dragging event
   */ function ensureHover(event) {
        if (event.hover) return;
        var originalEvent = event.originalEvent;
        var gfx = self._findTargetGfx(originalEvent);
        var element = gfx && elementRegistry.get(gfx);
        if (gfx && element) {
            // 1) cancel current mousemove
            event.stopPropagation();
            // 2) emit fake hover for new target
            dragging.hover({
                element: element,
                gfx: gfx
            });
            // 3) re-trigger move event
            dragging.move(originalEvent);
        }
    }
    if (dragging) /**
     * We wait for a specific sequence of events before
     * emitting a fake drag.hover event.
     *
     * Event Sequence:
     *
     * drag.start
     * drag.move >> ensure we are hovering
     */ eventBus.on('drag.start', function(event) {
        eventBus.once('drag.move', HIGH_PRIORITY, function(event) {
            ensureHover(event);
        });
    });
    /**
   * We make sure that element.out is always fired, even if the
   * browser swallows an element.out event.
   *
   * Event sequence:
   *
   * element.hover
   * (element.out >> sometimes swallowed)
   * element.hover >> ensure we fired element.out
   */ (function() {
        var hoverGfx;
        var hover;
        eventBus.on('element.hover', function(event) {
            // (1) remember current hover element
            hoverGfx = event.gfx;
            hover = event.element;
        });
        eventBus.on('element.hover', HIGH_PRIORITY, function(event) {
            // (3) am I on an element still?
            if (hover) // (4) that is a problem, gotta "simulate the out"
            eventBus.fire('element.out', {
                element: hover,
                gfx: hoverGfx
            });
        });
        eventBus.on('element.out', function() {
            // (2) unset hover state if we correctly outed us *GG*
            hoverGfx = null;
            hover = null;
        });
    })();
    this._findTargetGfx = function(event) {
        var position, target;
        if (!(event instanceof MouseEvent)) return;
        position = (0, _event.toPoint)(event);
        // damn expensive operation, ouch!
        target = document.elementFromPoint(position.x, position.y);
        return getGfx(target);
    };
}
HoverFix.$inject = [
    'elementRegistry',
    'eventBus',
    'injector'
];
// helpers /////////////////////
function getGfx(target) {
    return (0, _minDom.closest)(target, 'svg, .djs-element', true);
}

},{"min-dom":"e58GC","../../util/Event":"a3pF2","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7yqqM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Dragging);
var _minDash = require("min-dash");
var _minDom = require("min-dom");
var _event = require("../../util/Event");
var _cursor = require("../../util/Cursor");
var _clickTrap = require("../../util/ClickTrap");
var _positionUtil = require("../../util/PositionUtil");
var _keyboardUtil = require("../keyboard/KeyboardUtil");
var round = Math.round;
/**
 * @typedef {import('../../util/Types').Point} Point
 *
 * @typedef {import('../../core/Canvas').default} Canvas
 * @typedef {import('../../core/ElementRegistry').default} ElementRegistry
 * @typedef {import('../../core/EventBus').default} EventBus
 * @typedef {import('../selection/Selection').default} Selection
 */ var DRAG_ACTIVE_CLS = 'djs-drag-active';
function preventDefault(event) {
    event.preventDefault();
}
function isTouchEvent(event) {
    // check for TouchEvent being available first
    // (i.e. not available on desktop Firefox)
    return typeof TouchEvent !== 'undefined' && event instanceof TouchEvent;
}
function getLength(point) {
    return Math.sqrt(Math.pow(point.x, 2) + Math.pow(point.y, 2));
}
function Dragging(eventBus, canvas, selection, elementRegistry) {
    var defaultOptions = {
        threshold: 5,
        trapClick: true
    };
    // the currently active drag operation
    // dragging is active as soon as this context exists.
    //
    // it is visually _active_ only when a context.active flag is set to true.
    var context;
    /* convert a global event into local coordinates */ function toLocalPoint(globalPosition) {
        var viewbox = canvas.viewbox();
        var clientRect = canvas._container.getBoundingClientRect();
        return {
            x: viewbox.x + (globalPosition.x - clientRect.left) / viewbox.scale,
            y: viewbox.y + (globalPosition.y - clientRect.top) / viewbox.scale
        };
    }
    // helpers
    function fire(type, dragContext) {
        dragContext = dragContext || context;
        var event = eventBus.createEvent((0, _minDash.assign)({}, dragContext.payload, dragContext.data, {
            isTouch: dragContext.isTouch
        }));
        // default integration
        if (eventBus.fire('drag.' + type, event) === false) return false;
        return eventBus.fire(dragContext.prefix + '.' + type, event);
    }
    function restoreSelection(previousSelection) {
        var existingSelection = previousSelection.filter(function(element) {
            return elementRegistry.get(element.id);
        });
        existingSelection.length && selection.select(existingSelection);
    }
    // event listeners
    function move(event, activate) {
        var payload = context.payload, displacement = context.displacement;
        var globalStart = context.globalStart, globalCurrent = (0, _event.toPoint)(event), globalDelta = (0, _positionUtil.delta)(globalCurrent, globalStart);
        var localStart = context.localStart, localCurrent = toLocalPoint(globalCurrent), localDelta = (0, _positionUtil.delta)(localCurrent, localStart);
        // activate context explicitly or once threshold is reached
        if (!context.active && (activate || getLength(globalDelta) > context.threshold)) {
            // fire start event with original
            // starting coordinates
            (0, _minDash.assign)(payload, {
                x: round(localStart.x + displacement.x),
                y: round(localStart.y + displacement.y),
                dx: 0,
                dy: 0
            }, {
                originalEvent: event
            });
            if (false === fire('start')) return cancel();
            context.active = true;
            // unset selection and remember old selection
            // the previous (old) selection will always passed
            // with the event via the event.previousSelection property
            if (!context.keepSelection) {
                payload.previousSelection = selection.get();
                selection.select(null);
            }
            // allow custom cursor
            if (context.cursor) (0, _cursor.set)(context.cursor);
            // indicate dragging via marker on root element
            canvas.addMarker(canvas.getRootElement(), DRAG_ACTIVE_CLS);
        }
        (0, _event.stopPropagation)(event);
        if (context.active) {
            // update payload with actual coordinates
            (0, _minDash.assign)(payload, {
                x: round(localCurrent.x + displacement.x),
                y: round(localCurrent.y + displacement.y),
                dx: round(localDelta.x),
                dy: round(localDelta.y)
            }, {
                originalEvent: event
            });
            // emit move event
            fire('move');
        }
    }
    function end(event) {
        var previousContext, returnValue = true;
        if (context.active) {
            if (event) {
                context.payload.originalEvent = event;
                // suppress original event (click, ...)
                // because we just ended a drag operation
                (0, _event.stopPropagation)(event);
            }
            // implementations may stop restoring the
            // original state (selections, ...) by preventing the
            // end events default action
            returnValue = fire('end');
        }
        if (returnValue === false) fire('rejected');
        previousContext = cleanup(returnValue !== true);
        // last event to be fired when all drag operations are done
        // at this point in time no drag operation is in progress anymore
        fire('ended', previousContext);
    }
    // cancel active drag operation if the user presses
    // the ESC key on the keyboard
    function checkCancel(event) {
        if ((0, _keyboardUtil.isKey)('Escape', event)) {
            preventDefault(event);
            cancel();
        }
    }
    // prevent ghost click that might occur after a finished
    // drag and drop session
    function trapClickAndEnd(event) {
        var untrap;
        // trap the click in case we are part of an active
        // drag operation. This will effectively prevent
        // the ghost click that cannot be canceled otherwise.
        if (context.active) {
            untrap = (0, _clickTrap.install)(eventBus);
            // remove trap after minimal delay
            setTimeout(untrap, 400);
            // prevent default action (click)
            preventDefault(event);
        }
        end(event);
    }
    function trapTouch(event) {
        move(event);
    }
    // update the drag events model element (`hover`) and graphical element (`hoverGfx`)
    // properties during hover and out and fire {prefix}.hover and {prefix}.out properties
    // respectively
    function hover(event) {
        var payload = context.payload;
        payload.hoverGfx = event.gfx;
        payload.hover = event.element;
        fire('hover');
    }
    function out(event) {
        fire('out');
        var payload = context.payload;
        payload.hoverGfx = null;
        payload.hover = null;
    }
    // life-cycle methods
    function cancel(restore) {
        var previousContext;
        if (!context) return;
        var wasActive = context.active;
        if (wasActive) fire('cancel');
        previousContext = cleanup(restore);
        if (wasActive) // last event to be fired when all drag operations are done
        // at this point in time no drag operation is in progress anymore
        fire('canceled', previousContext);
    }
    function cleanup(restore) {
        var previousContext, endDrag;
        fire('cleanup');
        // reset cursor
        (0, _cursor.unset)();
        if (context.trapClick) endDrag = trapClickAndEnd;
        else endDrag = end;
        // reset dom listeners
        (0, _minDom.event).unbind(document, 'mousemove', move);
        (0, _minDom.event).unbind(document, 'dragstart', preventDefault);
        (0, _minDom.event).unbind(document, 'selectstart', preventDefault);
        (0, _minDom.event).unbind(document, 'mousedown', endDrag, true);
        (0, _minDom.event).unbind(document, 'mouseup', endDrag, true);
        (0, _minDom.event).unbind(document, 'keyup', checkCancel);
        (0, _minDom.event).unbind(document, 'touchstart', trapTouch, true);
        (0, _minDom.event).unbind(document, 'touchcancel', cancel, true);
        (0, _minDom.event).unbind(document, 'touchmove', move, true);
        (0, _minDom.event).unbind(document, 'touchend', end, true);
        eventBus.off('element.hover', hover);
        eventBus.off('element.out', out);
        // remove drag marker on root element
        canvas.removeMarker(canvas.getRootElement(), DRAG_ACTIVE_CLS);
        // restore selection, unless it has changed
        var previousSelection = context.payload.previousSelection;
        if (restore !== false && previousSelection && !selection.get().length) restoreSelection(previousSelection);
        previousContext = context;
        context = null;
        return previousContext;
    }
    /**
   * Initialize a drag operation.
   *
   * If `localPosition` is given, drag events will be emitted
   * relative to it.
   *
   * @param {MouseEvent|TouchEvent} [event]
   * @param {Point} [localPosition] actual diagram local position this drag operation should start at
   * @param {string} prefix
   * @param {Object} [options]
   */ function init(event, relativeTo, prefix, options) {
        // only one drag operation may be active, at a time
        if (context) cancel(false);
        if (typeof relativeTo === 'string') {
            options = prefix;
            prefix = relativeTo;
            relativeTo = null;
        }
        options = (0, _minDash.assign)({}, defaultOptions, options || {});
        var data = options.data || {}, originalEvent, globalStart, localStart, endDrag, isTouch;
        if (options.trapClick) endDrag = trapClickAndEnd;
        else endDrag = end;
        if (event) {
            originalEvent = (0, _event.getOriginal)(event) || event;
            globalStart = (0, _event.toPoint)(event);
            (0, _event.stopPropagation)(event);
            // prevent default browser dragging behavior
            if (originalEvent.type === 'dragstart') preventDefault(originalEvent);
        } else {
            originalEvent = null;
            globalStart = {
                x: 0,
                y: 0
            };
        }
        localStart = toLocalPoint(globalStart);
        if (!relativeTo) relativeTo = localStart;
        isTouch = isTouchEvent(originalEvent);
        context = (0, _minDash.assign)({
            prefix: prefix,
            data: data,
            payload: {},
            globalStart: globalStart,
            displacement: (0, _positionUtil.delta)(relativeTo, localStart),
            localStart: localStart,
            isTouch: isTouch
        }, options);
        // skip dom registration if trigger
        // is set to manual (during testing)
        if (!options.manual) {
            // add dom listeners
            if (isTouch) {
                (0, _minDom.event).bind(document, 'touchstart', trapTouch, true);
                (0, _minDom.event).bind(document, 'touchcancel', cancel, true);
                (0, _minDom.event).bind(document, 'touchmove', move, true);
                (0, _minDom.event).bind(document, 'touchend', end, true);
            } else {
                // assume we use the mouse to interact per default
                (0, _minDom.event).bind(document, 'mousemove', move);
                // prevent default browser drag and text selection behavior
                (0, _minDom.event).bind(document, 'dragstart', preventDefault);
                (0, _minDom.event).bind(document, 'selectstart', preventDefault);
                (0, _minDom.event).bind(document, 'mousedown', endDrag, true);
                (0, _minDom.event).bind(document, 'mouseup', endDrag, true);
            }
            (0, _minDom.event).bind(document, 'keyup', checkCancel);
            eventBus.on('element.hover', hover);
            eventBus.on('element.out', out);
        }
        fire('init');
        if (options.autoActivate) move(event, true);
    }
    // cancel on diagram destruction
    eventBus.on('diagram.destroy', cancel);
    // API
    this.init = init;
    this.move = move;
    this.hover = hover;
    this.out = out;
    this.end = end;
    this.cancel = cancel;
    // for introspection
    this.context = function() {
        return context;
    };
    this.setOptions = function(options) {
        (0, _minDash.assign)(defaultOptions, options);
    };
}
Dragging.$inject = [
    'eventBus',
    'canvas',
    'selection',
    'elementRegistry'
];

},{"min-dash":"aEEla","min-dom":"e58GC","../../util/Event":"a3pF2","../../util/Cursor":"258yd","../../util/ClickTrap":"2dyvI","../../util/PositionUtil":"flrPc","../keyboard/KeyboardUtil":"2Asg4","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7tkqJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AutoScroll);
var _minDash = require("min-dash");
var _event = require("../../util/Event");
function AutoScroll(config, eventBus, canvas) {
    this._canvas = canvas;
    this._opts = (0, _minDash.assign)({
        scrollThresholdIn: [
            20,
            20,
            20,
            20
        ],
        scrollThresholdOut: [
            0,
            0,
            0,
            0
        ],
        scrollRepeatTimeout: 15,
        scrollStep: 10
    }, config);
    var self = this;
    eventBus.on('drag.move', function(e) {
        var point = self._toBorderPoint(e);
        self.startScroll(point);
    });
    eventBus.on([
        'drag.cleanup'
    ], function() {
        self.stopScroll();
    });
}
AutoScroll.$inject = [
    'config.autoScroll',
    'eventBus',
    'canvas'
];
/**
 * Starts scrolling loop.
 * Point is given in global scale in canvas container box plane.
 *
 * @param {Point}
 */ AutoScroll.prototype.startScroll = function(point) {
    var canvas = this._canvas;
    var opts = this._opts;
    var self = this;
    var clientRect = canvas.getContainer().getBoundingClientRect();
    var diff = [
        point.x,
        point.y,
        clientRect.width - point.x,
        clientRect.height - point.y
    ];
    this.stopScroll();
    var dx = 0, dy = 0;
    for(var i = 0; i < 4; i++)if (between(diff[i], opts.scrollThresholdOut[i], opts.scrollThresholdIn[i])) {
        if (i === 0) dx = opts.scrollStep;
        else if (i == 1) dy = opts.scrollStep;
        else if (i == 2) dx = -opts.scrollStep;
        else if (i == 3) dy = -opts.scrollStep;
    }
    if (dx !== 0 || dy !== 0) {
        canvas.scroll({
            dx: dx,
            dy: dy
        });
        this._scrolling = setTimeout(function() {
            self.startScroll(point);
        }, opts.scrollRepeatTimeout);
    }
};
function between(val, start, end) {
    if (start < val && val < end) return true;
    return false;
}
/**
 * Stops scrolling loop.
 */ AutoScroll.prototype.stopScroll = function() {
    clearTimeout(this._scrolling);
};
/**
 * Overrides defaults options.
 *
 * @param {Object} options
 */ AutoScroll.prototype.setOptions = function(options) {
    this._opts = (0, _minDash.assign)({}, this._opts, options);
};
/**
 * Converts event to a point in canvas container plane in global scale.
 *
 * @param {Event} event
 * @return {Point}
 */ AutoScroll.prototype._toBorderPoint = function(event) {
    var clientRect = this._canvas._container.getBoundingClientRect();
    var globalPosition = (0, _event.toPoint)(event.originalEvent);
    return {
        x: globalPosition.x - clientRect.left,
        y: globalPosition.y - clientRect.top
    };
};

},{"min-dash":"aEEla","../../util/Event":"a3pF2","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"agMLL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _dragging = require("../dragging");
var _draggingDefault = parcelHelpers.interopDefault(_dragging);
var _rules = require("../rules");
var _rulesDefault = parcelHelpers.interopDefault(_rules);
var _bendpoints = require("./Bendpoints");
var _bendpointsDefault = parcelHelpers.interopDefault(_bendpoints);
var _bendpointMove = require("./BendpointMove");
var _bendpointMoveDefault = parcelHelpers.interopDefault(_bendpointMove);
var _bendpointMovePreview = require("./BendpointMovePreview");
var _bendpointMovePreviewDefault = parcelHelpers.interopDefault(_bendpointMovePreview);
var _connectionSegmentMove = require("./ConnectionSegmentMove");
var _connectionSegmentMoveDefault = parcelHelpers.interopDefault(_connectionSegmentMove);
var _bendpointSnapping = require("./BendpointSnapping");
var _bendpointSnappingDefault = parcelHelpers.interopDefault(_bendpointSnapping);
exports.default = {
    __depends__: [
        (0, _draggingDefault.default),
        (0, _rulesDefault.default)
    ],
    __init__: [
        'bendpoints',
        'bendpointSnapping',
        'bendpointMovePreview'
    ],
    bendpoints: [
        'type',
        (0, _bendpointsDefault.default)
    ],
    bendpointMove: [
        'type',
        (0, _bendpointMoveDefault.default)
    ],
    bendpointMovePreview: [
        'type',
        (0, _bendpointMovePreviewDefault.default)
    ],
    connectionSegmentMove: [
        'type',
        (0, _connectionSegmentMoveDefault.default)
    ],
    bendpointSnapping: [
        'type',
        (0, _bendpointSnappingDefault.default)
    ]
};

},{"../dragging":"2U3QS","../rules":"5xj5a","./Bendpoints":"bZqSe","./BendpointMove":"aRlTY","./BendpointMovePreview":"hIRFI","./ConnectionSegmentMove":"gOQgy","./BendpointSnapping":"654wJ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5xj5a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rules = require("./Rules");
var _rulesDefault = parcelHelpers.interopDefault(_rules);
exports.default = {
    __init__: [
        'rules'
    ],
    rules: [
        'type',
        (0, _rulesDefault.default)
    ]
};

},{"./Rules":"eXvrK","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eXvrK":[function(require,module,exports,__globalThis) {
/**
 * @typedef {import('didi').Injector} Injector
 */ /**
 * A service that provides rules for certain diagram actions.
 *
 * The default implementation will hook into the {@link CommandStack}
 * to perform the actual rule evaluation. Make sure to provide the
 * `commandStack` service with this module if you plan to use it.
 *
 * Together with this implementation you may use the {@link RuleProvider}
 * to implement your own rule checkers.
 *
 * This module is ment to be easily replaced, thus the tiny foot print.
 *
 * @param {Injector} injector
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Rules);
function Rules(injector) {
    this._commandStack = injector.get('commandStack', false);
}
Rules.$inject = [
    'injector'
];
/**
 * Returns whether or not a given modeling action can be executed
 * in the specified context.
 *
 * This implementation will respond with allow unless anyone
 * objects.
 *
 * @param {string} action the action to be checked
 * @param {Object} [context] the context to check the action in
 *
 * @return {boolean} returns true, false or null depending on whether the
 *                   operation is allowed, not allowed or should be ignored.
 */ Rules.prototype.allowed = function(action, context) {
    var allowed = true;
    var commandStack = this._commandStack;
    if (commandStack) allowed = commandStack.canExecute(action, context);
    // map undefined to true, i.e. no rules
    return allowed === undefined ? true : allowed;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bZqSe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Bendpoints);
var _minDash = require("min-dash");
var _minDom = require("min-dom");
var _bendpointUtil = require("./BendpointUtil");
var _escapeUtil = require("../../util/EscapeUtil");
var _geometry = require("../../util/Geometry");
var _mouse = require("../../util/Mouse");
var _tinySvg = require("tiny-svg");
var _svgTransformUtil = require("../../util/SvgTransformUtil");
function Bendpoints(eventBus, canvas, interactionEvents, bendpointMove, connectionSegmentMove) {
    /**
   * Returns true if intersection point is inside middle region of segment, adjusted by
   * optional threshold
   */ function isIntersectionMiddle(intersection, waypoints, treshold) {
        var idx = intersection.index, p = intersection.point, p0, p1, mid, aligned, xDelta, yDelta;
        if (idx <= 0 || intersection.bendpoint) return false;
        p0 = waypoints[idx - 1];
        p1 = waypoints[idx];
        mid = (0, _geometry.getMidPoint)(p0, p1), aligned = (0, _geometry.pointsAligned)(p0, p1);
        xDelta = Math.abs(p.x - mid.x);
        yDelta = Math.abs(p.y - mid.y);
        return aligned && xDelta <= treshold && yDelta <= treshold;
    }
    /**
   * Calculates the threshold from a connection's middle which fits the two-third-region
   */ function calculateIntersectionThreshold(connection, intersection) {
        var waypoints = connection.waypoints, relevantSegment, alignment, segmentLength, threshold;
        if (intersection.index <= 0 || intersection.bendpoint) return null;
        // segment relative to connection intersection
        relevantSegment = {
            start: waypoints[intersection.index - 1],
            end: waypoints[intersection.index]
        };
        alignment = (0, _geometry.pointsAligned)(relevantSegment.start, relevantSegment.end);
        if (!alignment) return null;
        if (alignment === 'h') segmentLength = relevantSegment.end.x - relevantSegment.start.x;
        else segmentLength = relevantSegment.end.y - relevantSegment.start.y;
        // calculate threshold relative to 2/3 of segment length
        threshold = (0, _bendpointUtil.calculateSegmentMoveRegion)(segmentLength) / 2;
        return threshold;
    }
    function activateBendpointMove(event, connection) {
        var waypoints = connection.waypoints, intersection = (0, _bendpointUtil.getConnectionIntersection)(canvas, waypoints, event), threshold;
        if (!intersection) return;
        threshold = calculateIntersectionThreshold(connection, intersection);
        if (isIntersectionMiddle(intersection, waypoints, threshold)) connectionSegmentMove.start(event, connection, intersection.index);
        else bendpointMove.start(event, connection, intersection.index, !intersection.bendpoint);
        // we've handled the event
        return true;
    }
    function bindInteractionEvents(node, eventName, element) {
        (0, _minDom.event).bind(node, eventName, function(event) {
            interactionEvents.triggerMouseEvent(eventName, event, element);
            event.stopPropagation();
        });
    }
    function getBendpointsContainer(element, create) {
        var layer = canvas.getLayer('overlays'), gfx = (0, _minDom.query)('.djs-bendpoints[data-element-id="' + (0, _escapeUtil.escapeCSS)(element.id) + '"]', layer);
        if (!gfx && create) {
            gfx = (0, _tinySvg.create)('g');
            (0, _tinySvg.attr)(gfx, {
                'data-element-id': element.id
            });
            (0, _tinySvg.classes)(gfx).add('djs-bendpoints');
            (0, _tinySvg.append)(layer, gfx);
            bindInteractionEvents(gfx, 'mousedown', element);
            bindInteractionEvents(gfx, 'click', element);
            bindInteractionEvents(gfx, 'dblclick', element);
        }
        return gfx;
    }
    function getSegmentDragger(idx, parentGfx) {
        return (0, _minDom.query)('.djs-segment-dragger[data-segment-idx="' + idx + '"]', parentGfx);
    }
    function createBendpoints(gfx, connection) {
        connection.waypoints.forEach(function(p, idx) {
            var bendpoint = (0, _bendpointUtil.addBendpoint)(gfx);
            (0, _tinySvg.append)(gfx, bendpoint);
            (0, _svgTransformUtil.translate)(bendpoint, p.x, p.y);
        });
        // add floating bendpoint
        (0, _bendpointUtil.addBendpoint)(gfx, 'floating');
    }
    function createSegmentDraggers(gfx, connection) {
        var waypoints = connection.waypoints;
        var segmentStart, segmentEnd, segmentDraggerGfx;
        for(var i = 1; i < waypoints.length; i++){
            segmentStart = waypoints[i - 1];
            segmentEnd = waypoints[i];
            if ((0, _geometry.pointsAligned)(segmentStart, segmentEnd)) {
                segmentDraggerGfx = (0, _bendpointUtil.addSegmentDragger)(gfx, segmentStart, segmentEnd);
                (0, _tinySvg.attr)(segmentDraggerGfx, {
                    'data-segment-idx': i
                });
                bindInteractionEvents(segmentDraggerGfx, 'mousemove', connection);
            }
        }
    }
    function clearBendpoints(gfx) {
        (0, _minDash.forEach)((0, _minDom.queryAll)('.' + (0, _bendpointUtil.BENDPOINT_CLS), gfx), function(node) {
            (0, _tinySvg.remove)(node);
        });
    }
    function clearSegmentDraggers(gfx) {
        (0, _minDash.forEach)((0, _minDom.queryAll)('.' + (0, _bendpointUtil.SEGMENT_DRAGGER_CLS), gfx), function(node) {
            (0, _tinySvg.remove)(node);
        });
    }
    function addHandles(connection) {
        var gfx = getBendpointsContainer(connection);
        if (!gfx) {
            gfx = getBendpointsContainer(connection, true);
            createBendpoints(gfx, connection);
            createSegmentDraggers(gfx, connection);
        }
        return gfx;
    }
    function updateHandles(connection) {
        var gfx = getBendpointsContainer(connection);
        if (gfx) {
            clearSegmentDraggers(gfx);
            clearBendpoints(gfx);
            createSegmentDraggers(gfx, connection);
            createBendpoints(gfx, connection);
        }
    }
    function updateFloatingBendpointPosition(parentGfx, intersection) {
        var floating = (0, _minDom.query)('.floating', parentGfx), point = intersection.point;
        if (!floating) return;
        (0, _svgTransformUtil.translate)(floating, point.x, point.y);
    }
    function updateSegmentDraggerPosition(parentGfx, intersection, waypoints) {
        var draggerGfx = getSegmentDragger(intersection.index, parentGfx), segmentStart = waypoints[intersection.index - 1], segmentEnd = waypoints[intersection.index], point = intersection.point, mid = (0, _geometry.getMidPoint)(segmentStart, segmentEnd), alignment = (0, _geometry.pointsAligned)(segmentStart, segmentEnd), draggerVisual, relativePosition;
        if (!draggerGfx) return;
        draggerVisual = getDraggerVisual(draggerGfx);
        relativePosition = {
            x: point.x - mid.x,
            y: point.y - mid.y
        };
        if (alignment === 'v') // rotate position
        relativePosition = {
            x: relativePosition.y,
            y: relativePosition.x
        };
        (0, _svgTransformUtil.translate)(draggerVisual, relativePosition.x, relativePosition.y);
    }
    eventBus.on('connection.changed', function(event) {
        updateHandles(event.element);
    });
    eventBus.on('connection.remove', function(event) {
        var gfx = getBendpointsContainer(event.element);
        if (gfx) (0, _tinySvg.remove)(gfx);
    });
    eventBus.on('element.marker.update', function(event) {
        var element = event.element, bendpointsGfx;
        if (!element.waypoints) return;
        bendpointsGfx = addHandles(element);
        if (event.add) (0, _tinySvg.classes)(bendpointsGfx).add(event.marker);
        else (0, _tinySvg.classes)(bendpointsGfx).remove(event.marker);
    });
    eventBus.on('element.mousemove', function(event) {
        var element = event.element, waypoints = element.waypoints, bendpointsGfx, intersection;
        if (waypoints) {
            bendpointsGfx = getBendpointsContainer(element, true);
            intersection = (0, _bendpointUtil.getConnectionIntersection)(canvas, waypoints, event.originalEvent);
            if (!intersection) return;
            updateFloatingBendpointPosition(bendpointsGfx, intersection);
            if (!intersection.bendpoint) updateSegmentDraggerPosition(bendpointsGfx, intersection, waypoints);
        }
    });
    eventBus.on('element.mousedown', function(event) {
        if (!(0, _mouse.isPrimaryButton)(event)) return;
        var originalEvent = event.originalEvent, element = event.element;
        if (!element.waypoints) return;
        return activateBendpointMove(originalEvent, element);
    });
    eventBus.on('selection.changed', function(event) {
        var newSelection = event.newSelection, primary = newSelection[0];
        if (primary && primary.waypoints) addHandles(primary);
    });
    eventBus.on('element.hover', function(event) {
        var element = event.element;
        if (element.waypoints) {
            addHandles(element);
            interactionEvents.registerEvent(event.gfx, 'mousemove', 'element.mousemove');
        }
    });
    eventBus.on('element.out', function(event) {
        interactionEvents.unregisterEvent(event.gfx, 'mousemove', 'element.mousemove');
    });
    // update bendpoint container data attribute on element ID change
    eventBus.on('element.updateId', function(context) {
        var element = context.element, newId = context.newId;
        if (element.waypoints) {
            var bendpointContainer = getBendpointsContainer(element);
            if (bendpointContainer) (0, _tinySvg.attr)(bendpointContainer, {
                'data-element-id': newId
            });
        }
    });
    // API
    this.addHandles = addHandles;
    this.updateHandles = updateHandles;
    this.getBendpointsContainer = getBendpointsContainer;
    this.getSegmentDragger = getSegmentDragger;
}
Bendpoints.$inject = [
    'eventBus',
    'canvas',
    'interactionEvents',
    'bendpointMove',
    'connectionSegmentMove'
];
// helper /////////////
function getDraggerVisual(draggerGfx) {
    return (0, _minDom.query)('.djs-visual', draggerGfx);
}

},{"min-dash":"aEEla","min-dom":"e58GC","./BendpointUtil":"gvtkZ","../../util/EscapeUtil":"kAkPb","../../util/Geometry":"1zZUi","../../util/Mouse":"9MyMy","tiny-svg":"6ZtXA","../../util/SvgTransformUtil":"g4Nbc","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gvtkZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BENDPOINT_CLS", ()=>BENDPOINT_CLS);
parcelHelpers.export(exports, "SEGMENT_DRAGGER_CLS", ()=>SEGMENT_DRAGGER_CLS);
parcelHelpers.export(exports, "toCanvasCoordinates", ()=>toCanvasCoordinates);
parcelHelpers.export(exports, "getConnectionIntersection", ()=>getConnectionIntersection);
parcelHelpers.export(exports, "addBendpoint", ()=>addBendpoint);
parcelHelpers.export(exports, "addSegmentDragger", ()=>addSegmentDragger);
/**
 * Calculates region for segment move which is 2/3 of the full segment length
 * @param {number} segmentLength
 *
 * @return {number}
 */ parcelHelpers.export(exports, "calculateSegmentMoveRegion", ()=>calculateSegmentMoveRegion);
/**
 * Returns the point with the closest distance that is on the connection path.
 *
 * @param {Point} position
 * @param {Connection} connection
 * @returns {Point}
 */ parcelHelpers.export(exports, "getClosestPointOnConnection", ()=>getClosestPointOnConnection);
var _event = require("../../util/Event");
var _geometry = require("../../util/Geometry");
var _tinySvg = require("tiny-svg");
var _svgTransformUtil = require("../../util/SvgTransformUtil");
var _lineIntersection = require("../../util/LineIntersection");
var _geometricUtil = require("./GeometricUtil");
var BENDPOINT_CLS = 'djs-bendpoint';
var SEGMENT_DRAGGER_CLS = 'djs-segment-dragger';
function toCanvasCoordinates(canvas, event) {
    var position = (0, _event.toPoint)(event), clientRect = canvas._container.getBoundingClientRect(), offset;
    // canvas relative position
    offset = {
        x: clientRect.left,
        y: clientRect.top
    };
    // update actual event payload with canvas relative measures
    var viewbox = canvas.viewbox();
    return {
        x: viewbox.x + (position.x - offset.x) / viewbox.scale,
        y: viewbox.y + (position.y - offset.y) / viewbox.scale
    };
}
function getConnectionIntersection(canvas, waypoints, event) {
    var localPosition = toCanvasCoordinates(canvas, event), intersection = (0, _lineIntersection.getApproxIntersection)(waypoints, localPosition);
    return intersection;
}
function addBendpoint(parentGfx, cls) {
    var groupGfx = (0, _tinySvg.create)('g');
    (0, _tinySvg.classes)(groupGfx).add(BENDPOINT_CLS);
    (0, _tinySvg.append)(parentGfx, groupGfx);
    var visual = (0, _tinySvg.create)('circle');
    (0, _tinySvg.attr)(visual, {
        cx: 0,
        cy: 0,
        r: 4
    });
    (0, _tinySvg.classes)(visual).add('djs-visual');
    (0, _tinySvg.append)(groupGfx, visual);
    var hit = (0, _tinySvg.create)('circle');
    (0, _tinySvg.attr)(hit, {
        cx: 0,
        cy: 0,
        r: 10
    });
    (0, _tinySvg.classes)(hit).add('djs-hit');
    (0, _tinySvg.append)(groupGfx, hit);
    if (cls) (0, _tinySvg.classes)(groupGfx).add(cls);
    return groupGfx;
}
function createParallelDragger(parentGfx, segmentStart, segmentEnd, alignment) {
    var draggerGfx = (0, _tinySvg.create)('g');
    (0, _tinySvg.append)(parentGfx, draggerGfx);
    var width = 18, height = 6, padding = 11, hitWidth = calculateHitWidth(segmentStart, segmentEnd, alignment), hitHeight = height + padding;
    var visual = (0, _tinySvg.create)('rect');
    (0, _tinySvg.attr)(visual, {
        x: -width / 2,
        y: -height / 2,
        width: width,
        height: height
    });
    (0, _tinySvg.classes)(visual).add('djs-visual');
    (0, _tinySvg.append)(draggerGfx, visual);
    var hit = (0, _tinySvg.create)('rect');
    (0, _tinySvg.attr)(hit, {
        x: -hitWidth / 2,
        y: -hitHeight / 2,
        width: hitWidth,
        height: hitHeight
    });
    (0, _tinySvg.classes)(hit).add('djs-hit');
    (0, _tinySvg.append)(draggerGfx, hit);
    (0, _svgTransformUtil.rotate)(draggerGfx, alignment === 'v' ? 90 : 0, 0, 0);
    return draggerGfx;
}
function addSegmentDragger(parentGfx, segmentStart, segmentEnd) {
    var groupGfx = (0, _tinySvg.create)('g'), mid = (0, _geometry.getMidPoint)(segmentStart, segmentEnd), alignment = (0, _geometry.pointsAligned)(segmentStart, segmentEnd);
    (0, _tinySvg.append)(parentGfx, groupGfx);
    createParallelDragger(groupGfx, segmentStart, segmentEnd, alignment);
    (0, _tinySvg.classes)(groupGfx).add(SEGMENT_DRAGGER_CLS);
    (0, _tinySvg.classes)(groupGfx).add(alignment === 'h' ? 'horizontal' : 'vertical');
    (0, _svgTransformUtil.translate)(groupGfx, mid.x, mid.y);
    return groupGfx;
}
function calculateSegmentMoveRegion(segmentLength) {
    return Math.abs(Math.round(segmentLength * 2 / 3));
}
function getClosestPointOnConnection(position, connection) {
    var segment = getClosestSegment(position, connection);
    return (0, _geometricUtil.perpendicularFoot)(position, segment);
}
// helper //////////
function calculateHitWidth(segmentStart, segmentEnd, alignment) {
    var segmentLengthXAxis = segmentEnd.x - segmentStart.x, segmentLengthYAxis = segmentEnd.y - segmentStart.y;
    return alignment === 'h' ? calculateSegmentMoveRegion(segmentLengthXAxis) : calculateSegmentMoveRegion(segmentLengthYAxis);
}
function getClosestSegment(position, connection) {
    var waypoints = connection.waypoints;
    var minDistance = Infinity, segmentIndex;
    for(var i = 0; i < waypoints.length - 1; i++){
        var start = waypoints[i], end = waypoints[i + 1], distance = (0, _geometricUtil.getDistancePointLine)(position, [
            start,
            end
        ]);
        if (distance < minDistance) {
            minDistance = distance;
            segmentIndex = i;
        }
    }
    return [
        waypoints[segmentIndex],
        waypoints[segmentIndex + 1]
    ];
}

},{"../../util/Event":"a3pF2","../../util/Geometry":"1zZUi","tiny-svg":"6ZtXA","../../util/SvgTransformUtil":"g4Nbc","../../util/LineIntersection":"6KlXN","./GeometricUtil":"39B1V","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6KlXN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns the closest point on the connection towards a given reference point.
 *
 * @param {Point[]} waypoints
 * @param {Point} reference
 *
 * @return {Object} intersection data (segment, point)
 */ parcelHelpers.export(exports, "getApproxIntersection", ()=>getApproxIntersection);
var _geometry = require("./Geometry");
var _pathIntersection = require("path-intersection");
var _pathIntersectionDefault = parcelHelpers.interopDefault(_pathIntersection);
/**
 * @typedef {import('../util/Types').Point} Point
 */ var round = Math.round, max = Math.max;
function circlePath(center, r) {
    var x = center.x, y = center.y;
    return [
        [
            'M',
            x,
            y
        ],
        [
            'm',
            0,
            -r
        ],
        [
            'a',
            r,
            r,
            0,
            1,
            1,
            0,
            2 * r
        ],
        [
            'a',
            r,
            r,
            0,
            1,
            1,
            0,
            -2 * r
        ],
        [
            'z'
        ]
    ];
}
function linePath(points) {
    var segments = [];
    points.forEach(function(p, idx) {
        segments.push([
            idx === 0 ? 'M' : 'L',
            p.x,
            p.y
        ]);
    });
    return segments;
}
var INTERSECTION_THRESHOLD = 10;
function getBendpointIntersection(waypoints, reference) {
    var i, w;
    for(i = 0; w = waypoints[i]; i++){
        if ((0, _geometry.pointDistance)(w, reference) <= INTERSECTION_THRESHOLD) return {
            point: waypoints[i],
            bendpoint: true,
            index: i
        };
    }
    return null;
}
function getPathIntersection(waypoints, reference) {
    var intersections = (0, _pathIntersectionDefault.default)(circlePath(reference, INTERSECTION_THRESHOLD), linePath(waypoints));
    var a = intersections[0], b = intersections[intersections.length - 1], idx;
    if (!a) // no intersection
    return null;
    if (a !== b) {
        if (a.segment2 !== b.segment2) {
            // we use the bendpoint in between both segments
            // as the intersection point
            idx = max(a.segment2, b.segment2) - 1;
            return {
                point: waypoints[idx],
                bendpoint: true,
                index: idx
            };
        }
        return {
            point: {
                x: round(a.x + b.x) / 2,
                y: round(a.y + b.y) / 2
            },
            index: a.segment2
        };
    }
    return {
        point: {
            x: round(a.x),
            y: round(a.y)
        },
        index: a.segment2
    };
}
function getApproxIntersection(waypoints, reference) {
    return getBendpointIntersection(waypoints, reference) || getPathIntersection(waypoints, reference);
}

},{"./Geometry":"1zZUi","path-intersection":"cJEhf","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"39B1V":[function(require,module,exports,__globalThis) {
/**
 * @typedef {import('../../util/Types').Point} Point
 * @typedef {import('../../util/Types').Vector} Vector
 */ /**
 * Returns the length of a vector.
 *
 * @param {Vector} vector
 *
 * @return {number}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "vectorLength", ()=>vectorLength);
/**
 * Calculates the angle between a line a the Y axis.
 *
 * @param {Point[]} line
 *
 * @return {number}
 */ parcelHelpers.export(exports, "getAngle", ()=>getAngle);
/**
 * Rotates a vector by a given angle.
 *
 * @param {Vector} vector
 * @param {number} angle The angle in radians.
 *
 * @return {Vector}
 */ parcelHelpers.export(exports, "rotateVector", ()=>rotateVector);
/**
 * Calculates the position of the perpendicular foot.
 *
 * @param {Point} point
 * @param {Point[]} line
 *
 * @return {Point}
 */ parcelHelpers.export(exports, "perpendicularFoot", ()=>perpendicularFoot);
/**
 * Calculates the distance between a point and a line.
 *
 * @param {Point}
 * @param {Point[]} line
 *
 * @return {number}
 */ parcelHelpers.export(exports, "getDistancePointLine", ()=>getDistancePointLine);
/**
 * Calculates the distance between two points.
 *
 * @param {Point}
 * @param {Point}
 *
 * @return {number}
 */ parcelHelpers.export(exports, "getDistancePointPoint", ()=>getDistancePointPoint);
function vectorLength(vector) {
    return Math.sqrt(Math.pow(vector.x, 2) + Math.pow(vector.y, 2));
}
function getAngle(line) {
    // return value is between 0, 180 and -180, -0
    // @janstuemmel: maybe replace return a/b with b/a
    return Math.atan((line[1].y - line[0].y) / (line[1].x - line[0].x));
}
function rotateVector(vector, angle) {
    return !angle ? vector : {
        x: Math.cos(angle) * vector.x - Math.sin(angle) * vector.y,
        y: Math.sin(angle) * vector.x + Math.cos(angle) * vector.y
    };
}
/**
 * Solves a 2D equation system
 * a + r*b = c, where a,b,c are 2D vectors
 *
 * @param {Vector} a
 * @param {Vector} b
 * @param {Vector} c
 *
 * @return {number}
 */ function solveLambaSystem(a, b, c) {
    // the 2d system
    var system = [
        {
            n: a[0] - c[0],
            lambda: b[0]
        },
        {
            n: a[1] - c[1],
            lambda: b[1]
        }
    ];
    // solve
    var n = system[0].n * b[0] + system[1].n * b[1], l = system[0].lambda * b[0] + system[1].lambda * b[1];
    return -n / l;
}
function perpendicularFoot(point, line) {
    var a = line[0], b = line[1];
    // relative position of b from a
    var bd = {
        x: b.x - a.x,
        y: b.y - a.y
    };
    // solve equation system to the parametrized vectors param real value
    var r = solveLambaSystem([
        a.x,
        a.y
    ], [
        bd.x,
        bd.y
    ], [
        point.x,
        point.y
    ]);
    return {
        x: a.x + r * bd.x,
        y: a.y + r * bd.y
    };
}
function getDistancePointLine(point, line) {
    var pfPoint = perpendicularFoot(point, line);
    // distance vector
    var connectionVector = {
        x: pfPoint.x - point.x,
        y: pfPoint.y - point.y
    };
    return vectorLength(connectionVector);
}
function getDistancePointPoint(point1, point2) {
    return vectorLength({
        x: point1.x - point2.x,
        y: point1.y - point2.y
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aRlTY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BendpointMove);
// helpers //////////
parcelHelpers.export(exports, "isReverse", ()=>isReverse);
var _layoutUtil = require("../../layout/LayoutUtil");
/**
 * @typedef {import('didi').Injector} Injector
 *
 * @typedef {import('../../core/Canvas').default} Canvas
 * @typedef {import('../dragging/Dragging').default} Dragging
 * @typedef {import('../../core/EventBus').default} EventBus
 * @typedef {import('../modeling/Modeling').default} Modeling
 * @typedef {import('../rules/Rules').default} Rules
 */ var round = Math.round;
var RECONNECT_START = 'reconnectStart', RECONNECT_END = 'reconnectEnd', UPDATE_WAYPOINTS = 'updateWaypoints';
function BendpointMove(injector, eventBus, canvas, dragging, rules, modeling) {
    this._injector = injector;
    this.start = function(event, connection, bendpointIndex, insert) {
        var gfx = canvas.getGraphics(connection), source = connection.source, target = connection.target, waypoints = connection.waypoints, type;
        if (!insert && bendpointIndex === 0) type = RECONNECT_START;
        else if (!insert && bendpointIndex === waypoints.length - 1) type = RECONNECT_END;
        else type = UPDATE_WAYPOINTS;
        var command = type === UPDATE_WAYPOINTS ? 'connection.updateWaypoints' : 'connection.reconnect';
        var allowed = rules.allowed(command, {
            connection: connection,
            source: source,
            target: target
        });
        if (allowed === false) allowed = rules.allowed(command, {
            connection: connection,
            source: target,
            target: source
        });
        if (allowed === false) return;
        dragging.init(event, 'bendpoint.move', {
            data: {
                connection: connection,
                connectionGfx: gfx,
                context: {
                    allowed: allowed,
                    bendpointIndex: bendpointIndex,
                    connection: connection,
                    source: source,
                    target: target,
                    insert: insert,
                    type: type
                }
            }
        });
    };
    eventBus.on('bendpoint.move.hover', function(event) {
        var context = event.context, connection = context.connection, source = connection.source, target = connection.target, hover = event.hover, type = context.type;
        // cache hover state
        context.hover = hover;
        var allowed;
        if (!hover) return;
        var command = type === UPDATE_WAYPOINTS ? 'connection.updateWaypoints' : 'connection.reconnect';
        allowed = context.allowed = rules.allowed(command, {
            connection: connection,
            source: type === RECONNECT_START ? hover : source,
            target: type === RECONNECT_END ? hover : target
        });
        if (allowed) {
            context.source = type === RECONNECT_START ? hover : source;
            context.target = type === RECONNECT_END ? hover : target;
            return;
        }
        if (allowed === false) allowed = context.allowed = rules.allowed(command, {
            connection: connection,
            source: type === RECONNECT_END ? hover : target,
            target: type === RECONNECT_START ? hover : source
        });
        if (allowed) {
            context.source = type === RECONNECT_END ? hover : target;
            context.target = type === RECONNECT_START ? hover : source;
        }
    });
    eventBus.on([
        'bendpoint.move.out',
        'bendpoint.move.cleanup'
    ], function(event) {
        var context = event.context, type = context.type;
        context.hover = null;
        context.source = null;
        context.target = null;
        if (type !== UPDATE_WAYPOINTS) context.allowed = false;
    });
    eventBus.on('bendpoint.move.end', function(event) {
        var context = event.context, allowed = context.allowed, bendpointIndex = context.bendpointIndex, connection = context.connection, insert = context.insert, newWaypoints = connection.waypoints.slice(), source = context.source, target = context.target, type = context.type, hints = context.hints || {};
        // ensure integer values (important if zoom level was > 1 during move)
        var docking = {
            x: round(event.x),
            y: round(event.y)
        };
        if (!allowed) return false;
        if (type === UPDATE_WAYPOINTS) {
            if (insert) // insert new bendpoint
            newWaypoints.splice(bendpointIndex, 0, docking);
            else // swap previous waypoint with moved one
            newWaypoints[bendpointIndex] = docking;
            // pass hints about actual moved bendpoint
            // useful for connection/label layout
            hints.bendpointMove = {
                insert: insert,
                bendpointIndex: bendpointIndex
            };
            newWaypoints = this.cropWaypoints(connection, newWaypoints);
            modeling.updateWaypoints(connection, (0, _layoutUtil.filterRedundantWaypoints)(newWaypoints), hints);
        } else {
            if (type === RECONNECT_START) {
                hints.docking = 'source';
                if (isReverse(context)) {
                    hints.docking = 'target';
                    hints.newWaypoints = newWaypoints.reverse();
                }
            } else if (type === RECONNECT_END) {
                hints.docking = 'target';
                if (isReverse(context)) {
                    hints.docking = 'source';
                    hints.newWaypoints = newWaypoints.reverse();
                }
            }
            modeling.reconnect(connection, source, target, docking, hints);
        }
    }, this);
}
BendpointMove.$inject = [
    'injector',
    'eventBus',
    'canvas',
    'dragging',
    'rules',
    'modeling'
];
BendpointMove.prototype.cropWaypoints = function(connection, newWaypoints) {
    var connectionDocking = this._injector.get('connectionDocking', false);
    if (!connectionDocking) return newWaypoints;
    var waypoints = connection.waypoints;
    connection.waypoints = newWaypoints;
    connection.waypoints = connectionDocking.getCroppedWaypoints(connection);
    newWaypoints = connection.waypoints;
    connection.waypoints = waypoints;
    return newWaypoints;
};
function isReverse(context) {
    var hover = context.hover, source = context.source, target = context.target, type = context.type;
    if (type === RECONNECT_START) return hover && target && hover === target && source !== target;
    if (type === RECONNECT_END) return hover && source && hover === source && source !== target;
}

},{"../../layout/LayoutUtil":"4CCrs","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hIRFI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BendpointMovePreview);
var _tinySvg = require("tiny-svg");
var _bendpointUtil = require("./BendpointUtil");
var _svgTransformUtil = require("../../util/SvgTransformUtil");
var _bendpointMove = require("./BendpointMove");
/**
 * @typedef {import('didi').Injector} Injector
 *
 * @typedef {import('../bendpoints/BendpointMove').default} BendpointMove
 * @typedef {import('../../core/Canvas').default} Canvas
 * @typedef {import('../../core/EventBus').default} EventBus
 */ var RECONNECT_START = 'reconnectStart', RECONNECT_END = 'reconnectEnd', UPDATE_WAYPOINTS = 'updateWaypoints';
var MARKER_OK = 'connect-ok', MARKER_NOT_OK = 'connect-not-ok', MARKER_CONNECT_HOVER = 'connect-hover', MARKER_CONNECT_UPDATING = 'djs-updating', MARKER_ELEMENT_HIDDEN = 'djs-element-hidden';
var HIGH_PRIORITY = 1100;
function BendpointMovePreview(bendpointMove, injector, eventBus, canvas) {
    this._injector = injector;
    var connectionPreview = injector.get('connectionPreview', false);
    eventBus.on('bendpoint.move.start', function(event) {
        var context = event.context, bendpointIndex = context.bendpointIndex, connection = context.connection, insert = context.insert, waypoints = connection.waypoints, newWaypoints = waypoints.slice();
        context.waypoints = waypoints;
        if (insert) // insert placeholder for new bendpoint
        newWaypoints.splice(bendpointIndex, 0, {
            x: event.x,
            y: event.y
        });
        connection.waypoints = newWaypoints;
        // add dragger gfx
        var draggerGfx = context.draggerGfx = (0, _bendpointUtil.addBendpoint)(canvas.getLayer('overlays'));
        (0, _tinySvg.classes)(draggerGfx).add('djs-dragging');
        canvas.addMarker(connection, MARKER_ELEMENT_HIDDEN);
        canvas.addMarker(connection, MARKER_CONNECT_UPDATING);
    });
    eventBus.on('bendpoint.move.hover', function(event) {
        var context = event.context, allowed = context.allowed, hover = context.hover, type = context.type;
        if (hover) {
            canvas.addMarker(hover, MARKER_CONNECT_HOVER);
            if (type === UPDATE_WAYPOINTS) return;
            if (allowed) {
                canvas.removeMarker(hover, MARKER_NOT_OK);
                canvas.addMarker(hover, MARKER_OK);
            } else if (allowed === false) {
                canvas.removeMarker(hover, MARKER_OK);
                canvas.addMarker(hover, MARKER_NOT_OK);
            }
        }
    });
    eventBus.on([
        'bendpoint.move.out',
        'bendpoint.move.cleanup'
    ], HIGH_PRIORITY, function(event) {
        var context = event.context, hover = context.hover, target = context.target;
        if (hover) {
            canvas.removeMarker(hover, MARKER_CONNECT_HOVER);
            canvas.removeMarker(hover, target ? MARKER_OK : MARKER_NOT_OK);
        }
    });
    eventBus.on('bendpoint.move.move', function(event) {
        var context = event.context, allowed = context.allowed, bendpointIndex = context.bendpointIndex, draggerGfx = context.draggerGfx, hover = context.hover, type = context.type, connection = context.connection, source = connection.source, target = connection.target, newWaypoints = connection.waypoints.slice(), bendpoint = {
            x: event.x,
            y: event.y
        }, hints = context.hints || {}, drawPreviewHints = {};
        if (connectionPreview) {
            if (hints.connectionStart) drawPreviewHints.connectionStart = hints.connectionStart;
            if (hints.connectionEnd) drawPreviewHints.connectionEnd = hints.connectionEnd;
            if (type === RECONNECT_START) {
                if ((0, _bendpointMove.isReverse)(context)) {
                    drawPreviewHints.connectionEnd = drawPreviewHints.connectionEnd || bendpoint;
                    drawPreviewHints.source = target;
                    drawPreviewHints.target = hover || source;
                    newWaypoints = newWaypoints.reverse();
                } else {
                    drawPreviewHints.connectionStart = drawPreviewHints.connectionStart || bendpoint;
                    drawPreviewHints.source = hover || source;
                    drawPreviewHints.target = target;
                }
            } else if (type === RECONNECT_END) {
                if ((0, _bendpointMove.isReverse)(context)) {
                    drawPreviewHints.connectionStart = drawPreviewHints.connectionStart || bendpoint;
                    drawPreviewHints.source = hover || target;
                    drawPreviewHints.target = source;
                    newWaypoints = newWaypoints.reverse();
                } else {
                    drawPreviewHints.connectionEnd = drawPreviewHints.connectionEnd || bendpoint;
                    drawPreviewHints.source = source;
                    drawPreviewHints.target = hover || target;
                }
            } else {
                drawPreviewHints.noCropping = true;
                drawPreviewHints.noLayout = true;
                newWaypoints[bendpointIndex] = bendpoint;
            }
            if (type === UPDATE_WAYPOINTS) newWaypoints = bendpointMove.cropWaypoints(connection, newWaypoints);
            drawPreviewHints.waypoints = newWaypoints;
            connectionPreview.drawPreview(context, allowed, drawPreviewHints);
        }
        (0, _svgTransformUtil.translate)(draggerGfx, event.x, event.y);
    }, this);
    eventBus.on([
        'bendpoint.move.end',
        'bendpoint.move.cancel'
    ], HIGH_PRIORITY, function(event) {
        var context = event.context, connection = context.connection, draggerGfx = context.draggerGfx, hover = context.hover, target = context.target, waypoints = context.waypoints;
        connection.waypoints = waypoints;
        // remove dragger gfx
        (0, _tinySvg.remove)(draggerGfx);
        canvas.removeMarker(connection, MARKER_CONNECT_UPDATING);
        canvas.removeMarker(connection, MARKER_ELEMENT_HIDDEN);
        if (hover) {
            canvas.removeMarker(hover, MARKER_OK);
            canvas.removeMarker(hover, target ? MARKER_OK : MARKER_NOT_OK);
        }
        if (connectionPreview) connectionPreview.cleanUp(context);
    });
}
BendpointMovePreview.$inject = [
    'bendpointMove',
    'injector',
    'eventBus',
    'canvas'
];

},{"tiny-svg":"6ZtXA","./BendpointUtil":"gvtkZ","../../util/SvgTransformUtil":"g4Nbc","./BendpointMove":"aRlTY","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gOQgy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ConnectionSegmentMove);
var _geometry = require("../../util/Geometry");
var _bendpointUtil = require("./BendpointUtil");
var _layoutUtil = require("../../layout/LayoutUtil");
var _tinySvg = require("tiny-svg");
var _svgTransformUtil = require("../../util/SvgTransformUtil");
var MARKER_CONNECT_HOVER = 'connect-hover', MARKER_CONNECT_UPDATING = 'djs-updating';
/**
 * @typedef {import('../../model').Shape} Shape
 *
 * @typedef {import('../../util/Types').Axis} Axis
 * @typedef {import('../../util/Types').Point} Point
 *
 * @typedef {import('didi').Injector} Injector
 *
 * @typedef {import('../../core/Canvas').default} Canvas
 * @typedef {import('../dragging/Dragging').default} Dragging
 * @typedef {import('../../core/EventBus').default} EventBus
 * @typedef {import('../../core/GraphicsFactory').default} GraphicsFactory
 * @typedef {import('../modeling/Modeling').default} Modeling
 */ function axisAdd(point, axis, delta) {
    return axisSet(point, axis, point[axis] + delta);
}
function axisSet(point, axis, value) {
    return {
        x: axis === 'x' ? value : point.x,
        y: axis === 'y' ? value : point.y
    };
}
function axisFenced(position, segmentStart, segmentEnd, axis) {
    var maxValue = Math.max(segmentStart[axis], segmentEnd[axis]), minValue = Math.min(segmentStart[axis], segmentEnd[axis]);
    var padding = 20;
    var fencedValue = Math.min(Math.max(minValue + padding, position[axis]), maxValue - padding);
    return axisSet(segmentStart, axis, fencedValue);
}
function flipAxis(axis) {
    return axis === 'x' ? 'y' : 'x';
}
/**
 * Get the docking point on the given element.
 *
 * Compute a reasonable docking, if non exists.
 *
 * @param {Point} point
 * @param {Shape} referenceElement
 * @param {Axis} moveAxis
 *
 * @return {Point}
 */ function getDocking(point, referenceElement, moveAxis) {
    var referenceMid, inverseAxis;
    if (point.original) return point.original;
    else {
        referenceMid = (0, _layoutUtil.getMid)(referenceElement);
        inverseAxis = flipAxis(moveAxis);
        return axisSet(point, inverseAxis, referenceMid[inverseAxis]);
    }
}
function ConnectionSegmentMove(injector, eventBus, canvas, dragging, graphicsFactory, modeling) {
    // optional connection docking integration
    var connectionDocking = injector.get('connectionDocking', false);
    // API
    this.start = function(event, connection, idx) {
        var context, gfx = canvas.getGraphics(connection), segmentStartIndex = idx - 1, segmentEndIndex = idx, waypoints = connection.waypoints, segmentStart = waypoints[segmentStartIndex], segmentEnd = waypoints[segmentEndIndex], intersection = (0, _bendpointUtil.getConnectionIntersection)(canvas, waypoints, event), direction, axis, dragPosition;
        direction = (0, _geometry.pointsAligned)(segmentStart, segmentEnd);
        // do not move diagonal connection
        if (!direction) return;
        // the axis where we are going to move things
        axis = direction === 'v' ? 'x' : 'y';
        if (segmentStartIndex === 0) segmentStart = getDocking(segmentStart, connection.source, axis);
        if (segmentEndIndex === waypoints.length - 1) segmentEnd = getDocking(segmentEnd, connection.target, axis);
        if (intersection) dragPosition = intersection.point;
        else // set to segment center as default
        dragPosition = {
            x: (segmentStart.x + segmentEnd.x) / 2,
            y: (segmentStart.y + segmentEnd.y) / 2
        };
        context = {
            connection: connection,
            segmentStartIndex: segmentStartIndex,
            segmentEndIndex: segmentEndIndex,
            segmentStart: segmentStart,
            segmentEnd: segmentEnd,
            axis: axis,
            dragPosition: dragPosition
        };
        dragging.init(event, dragPosition, 'connectionSegment.move', {
            cursor: axis === 'x' ? 'resize-ew' : 'resize-ns',
            data: {
                connection: connection,
                connectionGfx: gfx,
                context: context
            }
        });
    };
    /**
   * Crop connection if connection cropping is provided.
   *
   * @param {Connection} connection
   * @param {Array<Point>} newWaypoints
   *
   * @return {Array<Point>} cropped connection waypoints
   */ function cropConnection(connection, newWaypoints) {
        // crop connection, if docking service is provided only
        if (!connectionDocking) return newWaypoints;
        var oldWaypoints = connection.waypoints, croppedWaypoints;
        // temporary set new waypoints
        connection.waypoints = newWaypoints;
        croppedWaypoints = connectionDocking.getCroppedWaypoints(connection);
        // restore old waypoints
        connection.waypoints = oldWaypoints;
        return croppedWaypoints;
    }
    // DRAGGING IMPLEMENTATION
    function redrawConnection(data) {
        graphicsFactory.update('connection', data.connection, data.connectionGfx);
    }
    function updateDragger(context, segmentOffset, event) {
        var newWaypoints = context.newWaypoints, segmentStartIndex = context.segmentStartIndex + segmentOffset, segmentStart = newWaypoints[segmentStartIndex], segmentEndIndex = context.segmentEndIndex + segmentOffset, segmentEnd = newWaypoints[segmentEndIndex], axis = flipAxis(context.axis);
        // make sure the dragger does not move
        // outside the connection
        var draggerPosition = axisFenced(event, segmentStart, segmentEnd, axis);
        // update dragger
        (0, _svgTransformUtil.translate)(context.draggerGfx, draggerPosition.x, draggerPosition.y);
    }
    /**
   * Filter waypoints for redundant ones (i.e. on the same axis).
   * Returns the filtered waypoints and the offset related to the segment move.
   *
   * @param {Array<Point>} waypoints
   * @param {Integer} segmentStartIndex of moved segment start
   *
   * @return {Object} { filteredWaypoints, segmentOffset }
   */ function filterRedundantWaypoints(waypoints, segmentStartIndex) {
        var segmentOffset = 0;
        var filteredWaypoints = waypoints.filter(function(r, idx) {
            if ((0, _geometry.pointsOnLine)(waypoints[idx - 1], waypoints[idx + 1], r)) {
                // remove point and increment offset
                segmentOffset = idx <= segmentStartIndex ? segmentOffset - 1 : segmentOffset;
                return false;
            }
            // dont remove point
            return true;
        });
        return {
            waypoints: filteredWaypoints,
            segmentOffset: segmentOffset
        };
    }
    eventBus.on('connectionSegment.move.start', function(event) {
        var context = event.context, connection = event.connection, layer = canvas.getLayer('overlays');
        context.originalWaypoints = connection.waypoints.slice();
        // add dragger gfx
        context.draggerGfx = (0, _bendpointUtil.addSegmentDragger)(layer, context.segmentStart, context.segmentEnd);
        (0, _tinySvg.classes)(context.draggerGfx).add('djs-dragging');
        canvas.addMarker(connection, MARKER_CONNECT_UPDATING);
    });
    eventBus.on('connectionSegment.move.move', function(event) {
        var context = event.context, connection = context.connection, segmentStartIndex = context.segmentStartIndex, segmentEndIndex = context.segmentEndIndex, segmentStart = context.segmentStart, segmentEnd = context.segmentEnd, axis = context.axis;
        var newWaypoints = context.originalWaypoints.slice(), newSegmentStart = axisAdd(segmentStart, axis, event['d' + axis]), newSegmentEnd = axisAdd(segmentEnd, axis, event['d' + axis]);
        // original waypoint count and added / removed
        // from start waypoint delta. We use the later
        // to retrieve the updated segmentStartIndex / segmentEndIndex
        var waypointCount = newWaypoints.length, segmentOffset = 0;
        // move segment start / end by axis delta
        newWaypoints[segmentStartIndex] = newSegmentStart;
        newWaypoints[segmentEndIndex] = newSegmentEnd;
        var sourceToSegmentOrientation, targetToSegmentOrientation;
        // handle first segment
        if (segmentStartIndex < 2) {
            sourceToSegmentOrientation = (0, _layoutUtil.getOrientation)(connection.source, newSegmentStart);
            // first bendpoint, remove first segment if intersecting
            if (segmentStartIndex === 1) {
                if (sourceToSegmentOrientation === 'intersect') {
                    newWaypoints.shift();
                    newWaypoints[0] = newSegmentStart;
                    segmentOffset--;
                }
            } else if (sourceToSegmentOrientation !== 'intersect') {
                newWaypoints.unshift(segmentStart);
                segmentOffset++;
            }
        }
        // handle last segment
        if (segmentEndIndex > waypointCount - 3) {
            targetToSegmentOrientation = (0, _layoutUtil.getOrientation)(connection.target, newSegmentEnd);
            // last bendpoint, remove last segment if intersecting
            if (segmentEndIndex === waypointCount - 2) {
                if (targetToSegmentOrientation === 'intersect') {
                    newWaypoints.pop();
                    newWaypoints[newWaypoints.length - 1] = newSegmentEnd;
                }
            } else if (targetToSegmentOrientation !== 'intersect') newWaypoints.push(segmentEnd);
        }
        // update connection waypoints
        context.newWaypoints = connection.waypoints = cropConnection(connection, newWaypoints);
        // update dragger position
        updateDragger(context, segmentOffset, event);
        // save segmentOffset in context
        context.newSegmentStartIndex = segmentStartIndex + segmentOffset;
        // redraw connection
        redrawConnection(event);
    });
    eventBus.on('connectionSegment.move.hover', function(event) {
        event.context.hover = event.hover;
        canvas.addMarker(event.hover, MARKER_CONNECT_HOVER);
    });
    eventBus.on([
        'connectionSegment.move.out',
        'connectionSegment.move.cleanup'
    ], function(event) {
        // remove connect marker
        // if it was added
        var hover = event.context.hover;
        if (hover) canvas.removeMarker(hover, MARKER_CONNECT_HOVER);
    });
    eventBus.on('connectionSegment.move.cleanup', function(event) {
        var context = event.context, connection = context.connection;
        // remove dragger gfx
        if (context.draggerGfx) (0, _tinySvg.remove)(context.draggerGfx);
        canvas.removeMarker(connection, MARKER_CONNECT_UPDATING);
    });
    eventBus.on([
        'connectionSegment.move.cancel',
        'connectionSegment.move.end'
    ], function(event) {
        var context = event.context, connection = context.connection;
        connection.waypoints = context.originalWaypoints;
        redrawConnection(event);
    });
    eventBus.on('connectionSegment.move.end', function(event) {
        var context = event.context, connection = context.connection, newWaypoints = context.newWaypoints, newSegmentStartIndex = context.newSegmentStartIndex;
        // ensure we have actual pixel values bendpoint
        // coordinates (important when zoom level was > 1 during move)
        newWaypoints = newWaypoints.map(function(p) {
            return {
                original: p.original,
                x: Math.round(p.x),
                y: Math.round(p.y)
            };
        });
        // apply filter redunant waypoints
        var filtered = filterRedundantWaypoints(newWaypoints, newSegmentStartIndex);
        // get filtered waypoints
        var filteredWaypoints = filtered.waypoints, croppedWaypoints = cropConnection(connection, filteredWaypoints), segmentOffset = filtered.segmentOffset;
        var hints = {
            segmentMove: {
                segmentStartIndex: context.segmentStartIndex,
                newSegmentStartIndex: newSegmentStartIndex + segmentOffset
            }
        };
        modeling.updateWaypoints(connection, croppedWaypoints, hints);
    });
}
ConnectionSegmentMove.$inject = [
    'injector',
    'eventBus',
    'canvas',
    'dragging',
    'graphicsFactory',
    'modeling'
];

},{"../../util/Geometry":"1zZUi","./BendpointUtil":"gvtkZ","../../layout/LayoutUtil":"4CCrs","tiny-svg":"6ZtXA","../../util/SvgTransformUtil":"g4Nbc","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"654wJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BendpointSnapping);
var _minDash = require("min-dash");
var _snapUtil = require("../snapping/SnapUtil");
var _bendpointUtil = require("./BendpointUtil");
/**
 * @typedef {import('../../core/EventBus').default} EventBus
 */ var abs = Math.abs, round = Math.round;
var TOLERANCE = 10;
function BendpointSnapping(eventBus) {
    function snapTo(values, value) {
        if ((0, _minDash.isArray)(values)) {
            var i = values.length;
            while(i--)if (abs(values[i] - value) <= TOLERANCE) return values[i];
        } else {
            values = +values;
            var rem = value % values;
            if (rem < TOLERANCE) return value - rem;
            if (rem > values - TOLERANCE) return value - rem + values;
        }
        return value;
    }
    function getSnapPoint(element, event) {
        if (element.waypoints) return (0, _bendpointUtil.getClosestPointOnConnection)(event, element);
        if (element.width) return {
            x: round(element.width / 2 + element.x),
            y: round(element.height / 2 + element.y)
        };
    }
    // connection segment snapping //////////////////////
    function getConnectionSegmentSnaps(event) {
        var context = event.context, snapPoints = context.snapPoints, connection = context.connection, waypoints = connection.waypoints, segmentStart = context.segmentStart, segmentStartIndex = context.segmentStartIndex, segmentEnd = context.segmentEnd, segmentEndIndex = context.segmentEndIndex, axis = context.axis;
        if (snapPoints) return snapPoints;
        var referenceWaypoints = [
            waypoints[segmentStartIndex - 1],
            segmentStart,
            segmentEnd,
            waypoints[segmentEndIndex + 1]
        ];
        if (segmentStartIndex < 2) referenceWaypoints.unshift(getSnapPoint(connection.source, event));
        if (segmentEndIndex > waypoints.length - 3) referenceWaypoints.unshift(getSnapPoint(connection.target, event));
        context.snapPoints = snapPoints = {
            horizontal: [],
            vertical: []
        };
        (0, _minDash.forEach)(referenceWaypoints, function(p) {
            // we snap on existing bendpoints only,
            // not placeholders that are inserted during add
            if (p) {
                p = p.original || p;
                if (axis === 'y') snapPoints.horizontal.push(p.y);
                if (axis === 'x') snapPoints.vertical.push(p.x);
            }
        });
        return snapPoints;
    }
    eventBus.on('connectionSegment.move.move', 1500, function(event) {
        var snapPoints = getConnectionSegmentSnaps(event), x = event.x, y = event.y, sx, sy;
        if (!snapPoints) return;
        // snap
        sx = snapTo(snapPoints.vertical, x);
        sy = snapTo(snapPoints.horizontal, y);
        // correction x/y
        var cx = x - sx, cy = y - sy;
        // update delta
        (0, _minDash.assign)(event, {
            dx: event.dx - cx,
            dy: event.dy - cy,
            x: sx,
            y: sy
        });
        // only set snapped if actually snapped
        if (cx || snapPoints.vertical.indexOf(x) !== -1) (0, _snapUtil.setSnapped)(event, 'x', sx);
        if (cy || snapPoints.horizontal.indexOf(y) !== -1) (0, _snapUtil.setSnapped)(event, 'y', sy);
    });
    // bendpoint snapping //////////////////////
    function getBendpointSnaps(context) {
        var snapPoints = context.snapPoints, waypoints = context.connection.waypoints, bendpointIndex = context.bendpointIndex;
        if (snapPoints) return snapPoints;
        var referenceWaypoints = [
            waypoints[bendpointIndex - 1],
            waypoints[bendpointIndex + 1]
        ];
        context.snapPoints = snapPoints = {
            horizontal: [],
            vertical: []
        };
        (0, _minDash.forEach)(referenceWaypoints, function(p) {
            // we snap on existing bendpoints only,
            // not placeholders that are inserted during add
            if (p) {
                p = p.original || p;
                snapPoints.horizontal.push(p.y);
                snapPoints.vertical.push(p.x);
            }
        });
        return snapPoints;
    }
    // Snap Endpoint of new connection
    eventBus.on([
        'connect.hover',
        'connect.move',
        'connect.end'
    ], 1500, function(event) {
        var context = event.context, hover = context.hover, hoverMid = hover && getSnapPoint(hover, event);
        // only snap on connections, elements can have multiple connect endpoints
        if (!isConnection(hover) || !hoverMid || !hoverMid.x || !hoverMid.y) return;
        (0, _snapUtil.setSnapped)(event, 'x', hoverMid.x);
        (0, _snapUtil.setSnapped)(event, 'y', hoverMid.y);
    });
    eventBus.on([
        'bendpoint.move.move',
        'bendpoint.move.end'
    ], 1500, function(event) {
        var context = event.context, snapPoints = getBendpointSnaps(context), hover = context.hover, hoverMid = hover && getSnapPoint(hover, event), x = event.x, y = event.y, sx, sy;
        if (!snapPoints) return;
        // snap to hover mid
        sx = snapTo(hoverMid ? snapPoints.vertical.concat([
            hoverMid.x
        ]) : snapPoints.vertical, x);
        sy = snapTo(hoverMid ? snapPoints.horizontal.concat([
            hoverMid.y
        ]) : snapPoints.horizontal, y);
        // correction x/y
        var cx = x - sx, cy = y - sy;
        // update delta
        (0, _minDash.assign)(event, {
            dx: event.dx - cx,
            dy: event.dy - cy,
            x: event.x - cx,
            y: event.y - cy
        });
        // only set snapped if actually snapped
        if (cx || snapPoints.vertical.indexOf(x) !== -1) (0, _snapUtil.setSnapped)(event, 'x', sx);
        if (cy || snapPoints.horizontal.indexOf(y) !== -1) (0, _snapUtil.setSnapped)(event, 'y', sy);
    });
}
BendpointSnapping.$inject = [
    'eventBus'
];
// helpers //////////////////////
function isConnection(element) {
    return element && !!element.waypoints;
}

},{"min-dash":"aEEla","../snapping/SnapUtil":"fu3Zv","./BendpointUtil":"gvtkZ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fu3Zv":[function(require,module,exports,__globalThis) {
/**
 * @typedef {import('../../model').Connection} Connection
 * @typedef {import('../../model').Shape} Shape
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Snap value to a collection of reference values.
 *
 * @param {number} value
 * @param {Array<number>} values
 * @param {number} [tolerance=10]
 *
 * @return {number} the value we snapped to or null, if none snapped
 */ parcelHelpers.export(exports, "snapTo", ()=>snapTo);
parcelHelpers.export(exports, "topLeft", ()=>topLeft);
parcelHelpers.export(exports, "topRight", ()=>topRight);
parcelHelpers.export(exports, "bottomLeft", ()=>bottomLeft);
parcelHelpers.export(exports, "bottomRight", ()=>bottomRight);
parcelHelpers.export(exports, "mid", ()=>mid);
/**
 * Retrieve the snap state of the given event.
 *
 * @param {Event} event
 * @param {string} axis
 *
 * @return {boolean} the snapped state
 *
 */ parcelHelpers.export(exports, "isSnapped", ()=>isSnapped);
/**
 * Set the given event as snapped.
 *
 * This method may change the x and/or y position of the shape
 * from the given event!
 *
 * @param {Event} event
 * @param {string} axis
 * @param {number|boolean} value
 *
 * @return {number} old value
 */ parcelHelpers.export(exports, "setSnapped", ()=>setSnapped);
/**
 * Get children of a shape.
 *
 * @param {Shape} parent
 *
 * @returns {Array<Shape|Connection>}
 */ parcelHelpers.export(exports, "getChildren", ()=>getChildren);
var abs = Math.abs, round = Math.round;
function snapTo(value, values, tolerance) {
    tolerance = tolerance === undefined ? 10 : tolerance;
    var idx, snapValue;
    for(idx = 0; idx < values.length; idx++){
        snapValue = values[idx];
        if (abs(snapValue - value) <= tolerance) return snapValue;
    }
}
function topLeft(bounds) {
    return {
        x: bounds.x,
        y: bounds.y
    };
}
function topRight(bounds) {
    return {
        x: bounds.x + bounds.width,
        y: bounds.y
    };
}
function bottomLeft(bounds) {
    return {
        x: bounds.x,
        y: bounds.y + bounds.height
    };
}
function bottomRight(bounds) {
    return {
        x: bounds.x + bounds.width,
        y: bounds.y + bounds.height
    };
}
function mid(bounds, defaultValue) {
    if (!bounds || isNaN(bounds.x) || isNaN(bounds.y)) return defaultValue;
    return {
        x: round(bounds.x + bounds.width / 2),
        y: round(bounds.y + bounds.height / 2)
    };
}
function isSnapped(event, axis) {
    var snapped = event.snapped;
    if (!snapped) return false;
    if (typeof axis === 'string') return snapped[axis];
    return snapped.x && snapped.y;
}
function setSnapped(event, axis, value) {
    if (typeof axis !== 'string') throw new Error('axis must be in [x, y]');
    if (typeof value !== 'number' && value !== false) throw new Error('value must be Number or false');
    var delta, previousValue = event[axis];
    var snapped = event.snapped = event.snapped || {};
    if (value === false) snapped[axis] = false;
    else {
        snapped[axis] = true;
        delta = value - previousValue;
        event[axis] += delta;
        event['d' + axis] += delta;
    }
    return previousValue;
}
function getChildren(parent) {
    return parent.children || [];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jmgwG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _selection = require("../selection");
var _selectionDefault = parcelHelpers.interopDefault(_selection);
var _rules = require("../rules");
var _rulesDefault = parcelHelpers.interopDefault(_rules);
var _dragging = require("../dragging");
var _draggingDefault = parcelHelpers.interopDefault(_dragging);
var _connect = require("./Connect");
var _connectDefault = parcelHelpers.interopDefault(_connect);
var _connectPreview = require("./ConnectPreview");
var _connectPreviewDefault = parcelHelpers.interopDefault(_connectPreview);
exports.default = {
    __depends__: [
        (0, _selectionDefault.default),
        (0, _rulesDefault.default),
        (0, _draggingDefault.default)
    ],
    __init__: [
        'connectPreview'
    ],
    connect: [
        'type',
        (0, _connectDefault.default)
    ],
    connectPreview: [
        'type',
        (0, _connectPreviewDefault.default)
    ]
};

},{"../selection":"8Jf3R","../rules":"5xj5a","../dragging":"2U3QS","./Connect":"a55wU","./ConnectPreview":"32bWs","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"a55wU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Connect);
// helpers //////////
parcelHelpers.export(exports, "isReverse", ()=>isReverse);
var _layoutUtil = require("../../layout/LayoutUtil");
var _minDash = require("min-dash");
function Connect(eventBus, dragging, modeling, rules) {
    // rules
    function canConnect(source, target) {
        return rules.allowed('connection.create', {
            source: source,
            target: target
        });
    }
    function canConnectReverse(source, target) {
        return canConnect(target, source);
    }
    // event handlers
    eventBus.on('connect.hover', function(event) {
        var context = event.context, start = context.start, hover = event.hover, canExecute;
        // cache hover state
        context.hover = hover;
        canExecute = context.canExecute = canConnect(start, hover);
        // ignore hover
        if ((0, _minDash.isNil)(canExecute)) return;
        if (canExecute !== false) {
            context.source = start;
            context.target = hover;
            return;
        }
        canExecute = context.canExecute = canConnectReverse(start, hover);
        // ignore hover
        if ((0, _minDash.isNil)(canExecute)) return;
        if (canExecute !== false) {
            context.source = hover;
            context.target = start;
        }
    });
    eventBus.on([
        'connect.out',
        'connect.cleanup'
    ], function(event) {
        var context = event.context;
        context.hover = null;
        context.source = null;
        context.target = null;
        context.canExecute = false;
    });
    eventBus.on('connect.end', function(event) {
        var context = event.context, canExecute = context.canExecute, connectionStart = context.connectionStart, connectionEnd = {
            x: event.x,
            y: event.y
        }, source = context.source, target = context.target;
        if (!canExecute) return false;
        var attrs = null, hints = {
            connectionStart: isReverse(context) ? connectionEnd : connectionStart,
            connectionEnd: isReverse(context) ? connectionStart : connectionEnd
        };
        if ((0, _minDash.isObject)(canExecute)) attrs = canExecute;
        context.connection = modeling.connect(source, target, attrs, hints);
    });
    // API
    /**
   * Start connect operation.
   *
   * @param {MouseEvent|TouchEvent} event
   * @param {Base} start
   * @param {Point} [connectionStart]
   * @param {boolean} [autoActivate=false]
   */ this.start = function(event, start, connectionStart, autoActivate) {
        if (!(0, _minDash.isObject)(connectionStart)) {
            autoActivate = connectionStart;
            connectionStart = (0, _layoutUtil.getMid)(start);
        }
        dragging.init(event, 'connect', {
            autoActivate: autoActivate,
            data: {
                shape: start,
                context: {
                    start: start,
                    connectionStart: connectionStart
                }
            }
        });
    };
}
Connect.$inject = [
    'eventBus',
    'dragging',
    'modeling',
    'rules'
];
function isReverse(context) {
    var hover = context.hover, source = context.source, target = context.target;
    return hover && source && hover === source && source !== target;
}

},{"../../layout/LayoutUtil":"4CCrs","min-dash":"aEEla","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"32bWs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ConnectPreview);
var _connect = require("./Connect");
/**
 * @typedef {import('didi').Injector} Injector
 *
 * @typedef {import('../../core/Canvas').default} Canvas
 * @typedef {import('../../core/EventBus').default} EventBus
 */ var HIGH_PRIORITY = 1100, LOW_PRIORITY = 900;
var MARKER_OK = 'connect-ok', MARKER_NOT_OK = 'connect-not-ok';
function ConnectPreview(injector, eventBus, canvas) {
    var connectionPreview = injector.get('connectionPreview', false);
    connectionPreview && eventBus.on('connect.move', function(event) {
        var context = event.context, canConnect = context.canExecute, hover = context.hover, source = context.source, start = context.start, startPosition = context.startPosition, target = context.target, connectionStart = context.connectionStart || startPosition, connectionEnd = context.connectionEnd || {
            x: event.x,
            y: event.y
        }, previewStart = connectionStart, previewEnd = connectionEnd;
        if ((0, _connect.isReverse)(context)) {
            previewStart = connectionEnd;
            previewEnd = connectionStart;
        }
        connectionPreview.drawPreview(context, canConnect, {
            source: source || start,
            target: target || hover,
            connectionStart: previewStart,
            connectionEnd: previewEnd
        });
    });
    eventBus.on('connect.hover', LOW_PRIORITY, function(event) {
        var context = event.context, hover = event.hover, canExecute = context.canExecute;
        // ignore hover
        if (canExecute === null) return;
        canvas.addMarker(hover, canExecute ? MARKER_OK : MARKER_NOT_OK);
    });
    eventBus.on([
        'connect.out',
        'connect.cleanup'
    ], HIGH_PRIORITY, function(event) {
        var hover = event.hover;
        if (hover) {
            canvas.removeMarker(hover, MARKER_OK);
            canvas.removeMarker(hover, MARKER_NOT_OK);
        }
    });
    connectionPreview && eventBus.on('connect.cleanup', function(event) {
        connectionPreview.cleanUp(event.context);
    });
}
ConnectPreview.$inject = [
    'injector',
    'eventBus',
    'canvas'
];

},{"./Connect":"a55wU","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7XZ5m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _connectionPreview = require("./ConnectionPreview");
var _connectionPreviewDefault = parcelHelpers.interopDefault(_connectionPreview);
exports.default = {
    __init__: [
        'connectionPreview'
    ],
    connectionPreview: [
        'type',
        (0, _connectionPreviewDefault.default)
    ]
};

},{"./ConnectionPreview":"h1SiE","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"h1SiE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ConnectionPreview);
var _tinySvg = require("tiny-svg");
var _minDash = require("min-dash");
var _layoutUtil = require("../../layout/LayoutUtil");
var _renderUtil = require("../../util/RenderUtil");
/**
 * @typedef {import('../../model').Base} Base
 * @typedef {import('../../model').Connection} Connection
 * @typedef {import('../../model').Shape} Shape
 *
 * @typedef {import('../../util/Types').Point} Point
 *
 * @typedef {import('didi').Injector} Injector
 *
 * @typedef {import('../../core/Canvas').default} Canvas
 * @typedef {import('../../core/ElementFactory').default} ElementFactory
 * @typedef {import('../../core/GraphicsFactory').default} GraphicsFactory
 */ var MARKER_CONNECTION_PREVIEW = 'djs-connection-preview';
function ConnectionPreview(injector, canvas, graphicsFactory, elementFactory) {
    this._canvas = canvas;
    this._graphicsFactory = graphicsFactory;
    this._elementFactory = elementFactory;
    // optional components
    this._connectionDocking = injector.get('connectionDocking', false);
    this._layouter = injector.get('layouter', false);
}
ConnectionPreview.$inject = [
    'injector',
    'canvas',
    'graphicsFactory',
    'elementFactory'
];
/**
 * Draw connection preview.
 *
 * Provide at least one of <source, connectionStart> and <target, connectionEnd> to create a preview.
 * In the clean up stage, call `connectionPreview#cleanUp` with the context to remove preview.
 *
 * @param {Object} context
 * @param {Object|boolean} canConnect
 * @param {Object} hints
 * @param {Base} [hints.source] source element
 * @param {Base} [hints.target] target element
 * @param {Point} [hints.connectionStart] connection preview start
 * @param {Point} [hints.connectionEnd] connection preview end
 * @param {Point[]} [hints.waypoints] provided waypoints for preview
 * @param {boolean} [hints.noLayout] true if preview should not be laid out
 * @param {boolean} [hints.noCropping] true if preview should not be cropped
 * @param {boolean} [hints.noNoop] true if simple connection should not be drawn
 */ ConnectionPreview.prototype.drawPreview = function(context, canConnect, hints) {
    hints = hints || {};
    var connectionPreviewGfx = context.connectionPreviewGfx, getConnection = context.getConnection, source = hints.source, target = hints.target, waypoints = hints.waypoints, connectionStart = hints.connectionStart, connectionEnd = hints.connectionEnd, noLayout = hints.noLayout, noCropping = hints.noCropping, noNoop = hints.noNoop, connection;
    var self = this;
    if (!connectionPreviewGfx) connectionPreviewGfx = context.connectionPreviewGfx = this.createConnectionPreviewGfx();
    (0, _tinySvg.clear)(connectionPreviewGfx);
    if (!getConnection) getConnection = context.getConnection = cacheReturnValues(function(canConnect, source, target) {
        return self.getConnection(canConnect, source, target);
    });
    if (canConnect) connection = getConnection(canConnect, source, target);
    if (!connection) {
        !noNoop && this.drawNoopPreview(connectionPreviewGfx, hints);
        return;
    }
    connection.waypoints = waypoints || [];
    // optional layout
    if (this._layouter && !noLayout) connection.waypoints = this._layouter.layoutConnection(connection, {
        source: source,
        target: target,
        connectionStart: connectionStart,
        connectionEnd: connectionEnd,
        waypoints: hints.waypoints || connection.waypoints
    });
    // fallback if no waypoints were provided nor created with layouter
    if (!connection.waypoints || !connection.waypoints.length) connection.waypoints = [
        source ? (0, _layoutUtil.getMid)(source) : connectionStart,
        target ? (0, _layoutUtil.getMid)(target) : connectionEnd
    ];
    // optional cropping
    if (this._connectionDocking && (source || target) && !noCropping) connection.waypoints = this._connectionDocking.getCroppedWaypoints(connection, source, target);
    this._graphicsFactory.drawConnection(connectionPreviewGfx, connection);
};
/**
 * Draw simple connection between source and target or provided points.
 *
 * @param {SVGElement} connectionPreviewGfx container for the connection
 * @param {Object} hints
 * @param {Base} [hints.source] source element
 * @param {Base} [hints.target] target element
 * @param {Point} [hints.connectionStart] required if source is not provided
 * @param {Point} [hints.connectionEnd] required if target is not provided
 */ ConnectionPreview.prototype.drawNoopPreview = function(connectionPreviewGfx, hints) {
    var source = hints.source, target = hints.target, start = hints.connectionStart || (0, _layoutUtil.getMid)(source), end = hints.connectionEnd || (0, _layoutUtil.getMid)(target);
    var waypoints = this.cropWaypoints(start, end, source, target);
    var connection = this.createNoopConnection(waypoints[0], waypoints[1]);
    (0, _tinySvg.append)(connectionPreviewGfx, connection);
};
/**
 * Return cropped waypoints.
 *
 * @param {Point} start
 * @param {Point} end
 * @param {Base} source
 * @param {Base} target
 *
 * @returns {Point[]}
 */ ConnectionPreview.prototype.cropWaypoints = function(start, end, source, target) {
    var graphicsFactory = this._graphicsFactory, sourcePath = source && graphicsFactory.getShapePath(source), targetPath = target && graphicsFactory.getShapePath(target), connectionPath = graphicsFactory.getConnectionPath({
        waypoints: [
            start,
            end
        ]
    });
    start = source && (0, _layoutUtil.getElementLineIntersection)(sourcePath, connectionPath, true) || start;
    end = target && (0, _layoutUtil.getElementLineIntersection)(targetPath, connectionPath, false) || end;
    return [
        start,
        end
    ];
};
/**
 * Remove connection preview container if it exists.
 *
 * @param {Object} [context]
 * @param {SVGElement} [context.connectionPreviewGfx] preview container
 */ ConnectionPreview.prototype.cleanUp = function(context) {
    if (context && context.connectionPreviewGfx) (0, _tinySvg.remove)(context.connectionPreviewGfx);
};
/**
 * Get connection that connects source and target.
 *
 * @param {Object|boolean} canConnect
 *
 * @returns {Connection}
 */ ConnectionPreview.prototype.getConnection = function(canConnect) {
    var attrs = ensureConnectionAttrs(canConnect);
    return this._elementFactory.createConnection(attrs);
};
/**
 * Add and return preview graphics.
 *
 * @returns {SVGElement}
 */ ConnectionPreview.prototype.createConnectionPreviewGfx = function() {
    var gfx = (0, _tinySvg.create)('g');
    (0, _tinySvg.attr)(gfx, {
        pointerEvents: 'none'
    });
    (0, _tinySvg.classes)(gfx).add(MARKER_CONNECTION_PREVIEW);
    (0, _tinySvg.append)(this._canvas.getActiveLayer(), gfx);
    return gfx;
};
/**
 * Create and return simple connection.
 *
 * @param {Point} start
 * @param {Point} end
 *
 * @returns {SVGElement}
 */ ConnectionPreview.prototype.createNoopConnection = function(start, end) {
    return (0, _renderUtil.createLine)([
        start,
        end
    ], {
        'stroke': '#333',
        'strokeDasharray': [
            1
        ],
        'strokeWidth': 2,
        'pointer-events': 'none'
    });
};
// helpers //////////
/**
 * Returns function that returns cached return values referenced by stringified first argument.
 *
 * @param {Function} fn
 *
 * @return {Function}
 */ function cacheReturnValues(fn) {
    var returnValues = {};
    /**
   * Return cached return value referenced by stringified first argument.
   *
   * @returns {*}
   */ return function(firstArgument) {
        var key = JSON.stringify(firstArgument);
        var returnValue = returnValues[key];
        if (!returnValue) returnValue = returnValues[key] = fn.apply(null, arguments);
        return returnValue;
    };
}
/**
 * Ensure connection attributes is object.
 *
 * @param {Object|boolean} canConnect
 *
 * @returns {Object}
 */ function ensureConnectionAttrs(canConnect) {
    if ((0, _minDash.isObject)(canConnect)) return canConnect;
    else return {};
}

},{"tiny-svg":"6ZtXA","min-dash":"aEEla","../../layout/LayoutUtil":"4CCrs","../../util/RenderUtil":"iDpuc","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kXnNk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _diagramJsDirectEditing = require("diagram-js-direct-editing");
var _diagramJsDirectEditingDefault = parcelHelpers.interopDefault(_diagramJsDirectEditing);
var _contextPad = require("diagram-js/lib/features/context-pad");
var _contextPadDefault = parcelHelpers.interopDefault(_contextPad);
var _selection = require("diagram-js/lib/features/selection");
var _selectionDefault = parcelHelpers.interopDefault(_selection);
var _connect = require("diagram-js/lib/features/connect");
var _connectDefault = parcelHelpers.interopDefault(_connect);
var _create = require("diagram-js/lib/features/create");
var _createDefault = parcelHelpers.interopDefault(_create);
var _popupMenu = require("../popup-menu");
var _popupMenuDefault = parcelHelpers.interopDefault(_popupMenu);
var _contextPadProvider = require("./ContextPadProvider");
var _contextPadProviderDefault = parcelHelpers.interopDefault(_contextPadProvider);
exports.default = {
    __depends__: [
        (0, _diagramJsDirectEditingDefault.default),
        (0, _contextPadDefault.default),
        (0, _selectionDefault.default),
        (0, _connectDefault.default),
        (0, _createDefault.default),
        (0, _popupMenuDefault.default)
    ],
    __init__: [
        'contextPadProvider'
    ],
    contextPadProvider: [
        'type',
        (0, _contextPadProviderDefault.default)
    ]
};

},{"diagram-js-direct-editing":"bPVrN","diagram-js/lib/features/context-pad":"ktSXO","diagram-js/lib/features/selection":"8Jf3R","diagram-js/lib/features/connect":"jmgwG","diagram-js/lib/features/create":"kKw9I","../popup-menu":"f5IvJ","./ContextPadProvider":"fSx3A","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bPVrN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _interactionEvents = require("diagram-js/lib/features/interaction-events");
var _interactionEventsDefault = parcelHelpers.interopDefault(_interactionEvents);
var _directEditingJs = require("./DirectEditing.js");
var _directEditingJsDefault = parcelHelpers.interopDefault(_directEditingJs);
exports.default = {
    __depends__: [
        (0, _interactionEventsDefault.default)
    ],
    __init__: [
        'directEditing'
    ],
    directEditing: [
        'type',
        (0, _directEditingJsDefault.default)
    ]
};

},{"diagram-js/lib/features/interaction-events":"4qbdP","./DirectEditing.js":"hovq4","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hovq4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DirectEditing);
var _minDash = require("min-dash");
var _textBoxJs = require("./TextBox.js");
var _textBoxJsDefault = parcelHelpers.interopDefault(_textBoxJs);
function DirectEditing(eventBus, canvas) {
    this._eventBus = eventBus;
    this._providers = [];
    this._textbox = new (0, _textBoxJsDefault.default)({
        container: canvas.getContainer(),
        keyHandler: (0, _minDash.bind)(this._handleKey, this),
        resizeHandler: (0, _minDash.bind)(this._handleResize, this)
    });
}
DirectEditing.$inject = [
    'eventBus',
    'canvas'
];
/**
 * Register a direct editing provider

 * @param {Object} provider the provider, must expose an #activate(element) method that returns
 *                          an activation context ({ bounds: {x, y, width, height }, text }) if
 *                          direct editing is available for the given element.
 *                          Additionally the provider must expose a #update(element, value) method
 *                          to receive direct editing updates.
 */ DirectEditing.prototype.registerProvider = function(provider) {
    this._providers.push(provider);
};
/**
 * Returns true if direct editing is currently active
 *
 * @param {djs.model.Base} [element]
 *
 * @return {boolean}
 */ DirectEditing.prototype.isActive = function(element) {
    return !!(this._active && (!element || this._active.element === element));
};
/**
 * Cancel direct editing, if it is currently active
 */ DirectEditing.prototype.cancel = function() {
    if (!this._active) return;
    this._fire('cancel');
    this.close();
};
DirectEditing.prototype._fire = function(event, context) {
    this._eventBus.fire('directEditing.' + event, context || {
        active: this._active
    });
};
DirectEditing.prototype.close = function() {
    this._textbox.destroy();
    this._fire('deactivate');
    this._active = null;
    this.resizable = undefined;
};
DirectEditing.prototype.complete = function() {
    var active = this._active;
    if (!active) return;
    var containerBounds, previousBounds = active.context.bounds, newBounds = this.$textbox.getBoundingClientRect(), newText = this.getValue(), previousText = active.context.text;
    if (newText !== previousText || newBounds.height !== previousBounds.height || newBounds.width !== previousBounds.width) {
        containerBounds = this._textbox.container.getBoundingClientRect();
        active.provider.update(active.element, newText, active.context.text, {
            x: newBounds.left - containerBounds.left,
            y: newBounds.top - containerBounds.top,
            width: newBounds.width,
            height: newBounds.height
        });
    }
    this._fire('complete');
    this.close();
};
DirectEditing.prototype.getValue = function() {
    return this._textbox.getValue();
};
DirectEditing.prototype._handleKey = function(e) {
    // stop bubble
    e.stopPropagation();
    var key = e.keyCode || e.charCode;
    // ESC
    if (key === 27) {
        e.preventDefault();
        return this.cancel();
    }
    // Enter
    if (key === 13 && !e.shiftKey) {
        e.preventDefault();
        return this.complete();
    }
};
DirectEditing.prototype._handleResize = function(event) {
    this._fire('resize', event);
};
/**
 * Activate direct editing on the given element
 *
 * @param {Object} ElementDescriptor the descriptor for a shape or connection
 * @return {Boolean} true if the activation was possible
 */ DirectEditing.prototype.activate = function(element) {
    if (this.isActive()) this.cancel();
    // the direct editing context
    var context;
    var provider = (0, _minDash.find)(this._providers, function(p) {
        return (context = p.activate(element)) ? p : null;
    });
    // check if activation took place
    if (context) {
        this.$textbox = this._textbox.create(context.bounds, context.style, context.text, context.options);
        this._active = {
            element: element,
            context: context,
            provider: provider
        };
        if (context.options && context.options.resizable) this.resizable = true;
        this._fire('activate');
    }
    return !!context;
};

},{"min-dash":"aEEla","./TextBox.js":"bPsAk","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bPsAk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>TextBox);
var _minDash = require("min-dash");
var _minDom = require("min-dom");
var min = Math.min, max = Math.max;
function preventDefault(e) {
    e.preventDefault();
}
function stopPropagation(e) {
    e.stopPropagation();
}
function isTextNode(node) {
    return node.nodeType === Node.TEXT_NODE;
}
function toArray(nodeList) {
    return [].slice.call(nodeList);
}
function TextBox(options) {
    this.container = options.container;
    this.parent = (0, _minDom.domify)('<div class="djs-direct-editing-parent"><div class="djs-direct-editing-content" contenteditable="true"></div></div>');
    this.content = (0, _minDom.query)('[contenteditable]', this.parent);
    this.keyHandler = options.keyHandler || function() {};
    this.resizeHandler = options.resizeHandler || function() {};
    this.autoResize = (0, _minDash.bind)(this.autoResize, this);
    this.handlePaste = (0, _minDash.bind)(this.handlePaste, this);
}
/**
 * Create a text box with the given position, size, style and text content
 *
 * @param {Object} bounds
 * @param {Number} bounds.x absolute x position
 * @param {Number} bounds.y absolute y position
 * @param {Number} [bounds.width] fixed width value
 * @param {Number} [bounds.height] fixed height value
 * @param {Number} [bounds.maxWidth] maximum width value
 * @param {Number} [bounds.maxHeight] maximum height value
 * @param {Number} [bounds.minWidth] minimum width value
 * @param {Number} [bounds.minHeight] minimum height value
 * @param {Object} [style]
 * @param {String} value text content
 *
 * @return {DOMElement} The created content DOM element
 */ TextBox.prototype.create = function(bounds, style, value, options) {
    var self1 = this;
    var parent = this.parent, content = this.content, container = this.container;
    options = this.options = options || {};
    style = this.style = style || {};
    var parentStyle = (0, _minDash.pick)(style, [
        'width',
        'height',
        'maxWidth',
        'maxHeight',
        'minWidth',
        'minHeight',
        'left',
        'top',
        'backgroundColor',
        'position',
        'overflow',
        'border',
        'wordWrap',
        'textAlign',
        'outline',
        'transform'
    ]);
    (0, _minDash.assign)(parent.style, {
        width: bounds.width + 'px',
        height: bounds.height + 'px',
        maxWidth: bounds.maxWidth + 'px',
        maxHeight: bounds.maxHeight + 'px',
        minWidth: bounds.minWidth + 'px',
        minHeight: bounds.minHeight + 'px',
        left: bounds.x + 'px',
        top: bounds.y + 'px',
        backgroundColor: '#ffffff',
        position: 'absolute',
        overflow: 'visible',
        border: '1px solid #ccc',
        boxSizing: 'border-box',
        wordWrap: 'normal',
        textAlign: 'center',
        outline: 'none'
    }, parentStyle);
    var contentStyle = (0, _minDash.pick)(style, [
        'fontFamily',
        'fontSize',
        'fontWeight',
        'lineHeight',
        'padding',
        'paddingTop',
        'paddingRight',
        'paddingBottom',
        'paddingLeft'
    ]);
    (0, _minDash.assign)(content.style, {
        boxSizing: 'border-box',
        width: '100%',
        outline: 'none',
        wordWrap: 'break-word'
    }, contentStyle);
    if (options.centerVertically) (0, _minDash.assign)(content.style, {
        position: 'absolute',
        top: '50%',
        transform: 'translate(0, -50%)'
    }, contentStyle);
    content.innerText = value;
    (0, _minDom.event).bind(content, 'keydown', this.keyHandler);
    (0, _minDom.event).bind(content, 'mousedown', stopPropagation);
    (0, _minDom.event).bind(content, 'paste', self1.handlePaste);
    if (options.autoResize) (0, _minDom.event).bind(content, 'input', this.autoResize);
    if (options.resizable) this.resizable(style);
    container.appendChild(parent);
    // set selection to end of text
    this.setSelection(content.lastChild, content.lastChild && content.lastChild.length);
    return parent;
};
/**
 * Intercept paste events to remove formatting from pasted text.
 */ TextBox.prototype.handlePaste = function(e) {
    var options = this.options, style = this.style;
    e.preventDefault();
    var text;
    if (e.clipboardData) // Chrome, Firefox, Safari
    text = e.clipboardData.getData('text/plain');
    else // Internet Explorer
    text = window.clipboardData.getData('Text');
    this.insertText(text);
    if (options.autoResize) {
        var hasResized = this.autoResize(style);
        if (hasResized) this.resizeHandler(hasResized);
    }
};
TextBox.prototype.insertText = function(text) {
    text = normalizeEndOfLineSequences(text);
    // insertText command not supported by Internet Explorer
    var success = document.execCommand('insertText', false, text);
    if (success) return;
    this._insertTextIE(text);
};
TextBox.prototype._insertTextIE = function(text) {
    // Internet Explorer
    var range = this.getSelection(), startContainer = range.startContainer, endContainer = range.endContainer, startOffset = range.startOffset, endOffset = range.endOffset, commonAncestorContainer = range.commonAncestorContainer;
    var childNodesArray = toArray(commonAncestorContainer.childNodes);
    var container, offset;
    if (isTextNode(commonAncestorContainer)) {
        var containerTextContent = startContainer.textContent;
        startContainer.textContent = containerTextContent.substring(0, startOffset) + text + containerTextContent.substring(endOffset);
        container = startContainer;
        offset = startOffset + text.length;
    } else if (startContainer === this.content && endContainer === this.content) {
        var textNode = document.createTextNode(text);
        this.content.insertBefore(textNode, childNodesArray[startOffset]);
        container = textNode;
        offset = textNode.textContent.length;
    } else {
        var startContainerChildIndex = childNodesArray.indexOf(startContainer), endContainerChildIndex = childNodesArray.indexOf(endContainer);
        childNodesArray.forEach(function(childNode, index) {
            if (index === startContainerChildIndex) childNode.textContent = startContainer.textContent.substring(0, startOffset) + text + endContainer.textContent.substring(endOffset);
            else if (index > startContainerChildIndex && index <= endContainerChildIndex) (0, _minDom.remove)(childNode);
        });
        container = startContainer;
        offset = startOffset + text.length;
    }
    if (container && offset !== undefined) // is necessary in Internet Explorer
    setTimeout(function() {
        self.setSelection(container, offset);
    });
};
/**
 * Automatically resize element vertically to fit its content.
 */ TextBox.prototype.autoResize = function() {
    var parent = this.parent, content = this.content;
    var fontSize = parseInt(this.style.fontSize) || 12;
    if (content.scrollHeight > parent.offsetHeight || content.scrollHeight < parent.offsetHeight - fontSize) {
        var bounds = parent.getBoundingClientRect();
        var height = content.scrollHeight;
        parent.style.height = height + 'px';
        this.resizeHandler({
            width: bounds.width,
            height: bounds.height,
            dx: 0,
            dy: height - bounds.height
        });
    }
};
/**
 * Make an element resizable by adding a resize handle.
 */ TextBox.prototype.resizable = function() {
    var self1 = this;
    var parent = this.parent, resizeHandle = this.resizeHandle;
    var minWidth = parseInt(this.style.minWidth) || 0, minHeight = parseInt(this.style.minHeight) || 0, maxWidth = parseInt(this.style.maxWidth) || Infinity, maxHeight = parseInt(this.style.maxHeight) || Infinity;
    if (!resizeHandle) {
        resizeHandle = this.resizeHandle = (0, _minDom.domify)('<div class="djs-direct-editing-resize-handle"></div>');
        var startX, startY, startWidth, startHeight;
        var onMouseDown = function(e) {
            preventDefault(e);
            stopPropagation(e);
            startX = e.clientX;
            startY = e.clientY;
            var bounds = parent.getBoundingClientRect();
            startWidth = bounds.width;
            startHeight = bounds.height;
            (0, _minDom.event).bind(document, 'mousemove', onMouseMove);
            (0, _minDom.event).bind(document, 'mouseup', onMouseUp);
        };
        var onMouseMove = function(e) {
            preventDefault(e);
            stopPropagation(e);
            var newWidth = min(max(startWidth + e.clientX - startX, minWidth), maxWidth);
            var newHeight = min(max(startHeight + e.clientY - startY, minHeight), maxHeight);
            parent.style.width = newWidth + 'px';
            parent.style.height = newHeight + 'px';
            self1.resizeHandler({
                width: startWidth,
                height: startHeight,
                dx: e.clientX - startX,
                dy: e.clientY - startY
            });
        };
        var onMouseUp = function(e) {
            preventDefault(e);
            stopPropagation(e);
            (0, _minDom.event).unbind(document, 'mousemove', onMouseMove, false);
            (0, _minDom.event).unbind(document, 'mouseup', onMouseUp, false);
        };
        (0, _minDom.event).bind(resizeHandle, 'mousedown', onMouseDown);
    }
    (0, _minDash.assign)(resizeHandle.style, {
        position: 'absolute',
        bottom: '0px',
        right: '0px',
        cursor: 'nwse-resize',
        width: '0',
        height: '0',
        borderTop: (parseInt(this.style.fontSize) / 4 || 3) + 'px solid transparent',
        borderRight: (parseInt(this.style.fontSize) / 4 || 3) + 'px solid #ccc',
        borderBottom: (parseInt(this.style.fontSize) / 4 || 3) + 'px solid #ccc',
        borderLeft: (parseInt(this.style.fontSize) / 4 || 3) + 'px solid transparent'
    });
    parent.appendChild(resizeHandle);
};
/**
 * Clear content and style of the textbox, unbind listeners and
 * reset CSS style.
 */ TextBox.prototype.destroy = function() {
    var parent = this.parent, content = this.content, resizeHandle = this.resizeHandle;
    // clear content
    content.innerText = '';
    // clear styles
    parent.removeAttribute('style');
    content.removeAttribute('style');
    (0, _minDom.event).unbind(content, 'keydown', this.keyHandler);
    (0, _minDom.event).unbind(content, 'mousedown', stopPropagation);
    (0, _minDom.event).unbind(content, 'input', this.autoResize);
    (0, _minDom.event).unbind(content, 'paste', this.handlePaste);
    if (resizeHandle) {
        resizeHandle.removeAttribute('style');
        (0, _minDom.remove)(resizeHandle);
    }
    (0, _minDom.remove)(parent);
};
TextBox.prototype.getValue = function() {
    return this.content.innerText.trim();
};
TextBox.prototype.getSelection = function() {
    var selection = window.getSelection(), range = selection.getRangeAt(0);
    return range;
};
TextBox.prototype.setSelection = function(container, offset) {
    var range = document.createRange();
    if (container === null) range.selectNodeContents(this.content);
    else {
        range.setStart(container, offset);
        range.setEnd(container, offset);
    }
    var selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
};
// helpers //////////
function normalizeEndOfLineSequences(string) {
    return string.replace(/\r\n|\r|\n/g, '\n');
}

},{"min-dash":"aEEla","min-dom":"e58GC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kKw9I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _dragging = require("../dragging");
var _draggingDefault = parcelHelpers.interopDefault(_dragging);
var _previewSupport = require("../preview-support");
var _previewSupportDefault = parcelHelpers.interopDefault(_previewSupport);
var _rules = require("../rules");
var _rulesDefault = parcelHelpers.interopDefault(_rules);
var _selection = require("../selection");
var _selectionDefault = parcelHelpers.interopDefault(_selection);
var _create = require("./Create");
var _createDefault = parcelHelpers.interopDefault(_create);
var _createPreview = require("./CreatePreview");
var _createPreviewDefault = parcelHelpers.interopDefault(_createPreview);
exports.default = {
    __depends__: [
        (0, _draggingDefault.default),
        (0, _previewSupportDefault.default),
        (0, _rulesDefault.default),
        (0, _selectionDefault.default)
    ],
    __init__: [
        'create',
        'createPreview'
    ],
    create: [
        'type',
        (0, _createDefault.default)
    ],
    createPreview: [
        'type',
        (0, _createPreviewDefault.default)
    ]
};

},{"../dragging":"2U3QS","../preview-support":"fEfos","../rules":"5xj5a","../selection":"8Jf3R","./Create":"3dbhc","./CreatePreview":"9Zbyx","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fEfos":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _previewSupport = require("./PreviewSupport");
var _previewSupportDefault = parcelHelpers.interopDefault(_previewSupport);
exports.default = {
    __init__: [
        'previewSupport'
    ],
    previewSupport: [
        'type',
        (0, _previewSupportDefault.default)
    ]
};

},{"./PreviewSupport":"WqTlx","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"WqTlx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PreviewSupport);
var _minDash = require("min-dash");
var _tinySvg = require("tiny-svg");
var _minDom = require("min-dom");
var _graphicsUtil = require("../../util/GraphicsUtil");
/**
 * @typedef {import('../../model').Base} Base
 *
 * @typedef {import('../../core/Canvas').default} Canvas
 * @typedef {import('../../core/ElementRegistry').default} ElementRegistry
 * @typedef {import('../../core/EventBus').default} EventBus
 * @typedef {import('../../draw/Styles').default} Styles
 */ var MARKER_TYPES = [
    'marker-start',
    'marker-mid',
    'marker-end'
];
var NODES_CAN_HAVE_MARKER = [
    'circle',
    'ellipse',
    'line',
    'path',
    'polygon',
    'polyline',
    'path',
    'rect'
];
function PreviewSupport(elementRegistry, eventBus, canvas, styles) {
    this._elementRegistry = elementRegistry;
    this._canvas = canvas;
    this._styles = styles;
    this._clonedMarkers = {};
    var self = this;
    eventBus.on('drag.cleanup', function() {
        (0, _minDash.forEach)(self._clonedMarkers, function(clonedMarker) {
            (0, _tinySvg.remove)(clonedMarker);
        });
        self._clonedMarkers = {};
    });
}
PreviewSupport.$inject = [
    'elementRegistry',
    'eventBus',
    'canvas',
    'styles'
];
/**
 * Returns graphics of an element.
 *
 * @param {Base} element
 *
 * @return {SVGElement}
 */ PreviewSupport.prototype.getGfx = function(element) {
    return this._elementRegistry.getGraphics(element);
};
/**
 * Adds a move preview of a given shape to a given svg group.
 *
 * @param {Base} element
 * @param {SVGElement} group
 * @param {SVGElement} [gfx]
 *
 * @return {SVGElement} dragger
 */ PreviewSupport.prototype.addDragger = function(element, group, gfx) {
    gfx = gfx || this.getGfx(element);
    var dragger = (0, _tinySvg.clone)(gfx);
    var bbox = gfx.getBoundingClientRect();
    this._cloneMarkers((0, _graphicsUtil.getVisual)(dragger));
    (0, _tinySvg.attr)(dragger, this._styles.cls('djs-dragger', [], {
        x: bbox.top,
        y: bbox.left
    }));
    (0, _tinySvg.append)(group, dragger);
    return dragger;
};
/**
 * Adds a resize preview of a given shape to a given svg group.
 *
 * @param {Base} element
 * @param {SVGElement} group
 *
 * @return {SVGElement} frame
 */ PreviewSupport.prototype.addFrame = function(shape, group) {
    var frame = (0, _tinySvg.create)('rect', {
        class: 'djs-resize-overlay',
        width: shape.width,
        height: shape.height,
        x: shape.x,
        y: shape.y
    });
    (0, _tinySvg.append)(group, frame);
    return frame;
};
/**
 * Clone all markers referenced by a node and its child nodes.
 *
 * @param {SVGElement} gfx
 */ PreviewSupport.prototype._cloneMarkers = function(gfx) {
    var self = this;
    if (gfx.childNodes) // TODO: use forEach once we drop PhantomJS
    for(var i = 0; i < gfx.childNodes.length; i++)// recursively clone markers of child nodes
    self._cloneMarkers(gfx.childNodes[i]);
    if (!canHaveMarker(gfx)) return;
    MARKER_TYPES.forEach(function(markerType) {
        if ((0, _tinySvg.attr)(gfx, markerType)) {
            var marker = getMarker(gfx, markerType, self._canvas.getContainer());
            self._cloneMarker(gfx, marker, markerType);
        }
    });
};
/**
 * Clone marker referenced by an element.
 *
 * @param {SVGElement} gfx
 * @param {SVGElement} marker
 * @param {string} markerType
 */ PreviewSupport.prototype._cloneMarker = function(gfx, marker, markerType) {
    var markerId = marker.id;
    var clonedMarker = this._clonedMarkers[markerId];
    if (!clonedMarker) {
        clonedMarker = (0, _tinySvg.clone)(marker);
        var clonedMarkerId = markerId + '-clone';
        clonedMarker.id = clonedMarkerId;
        (0, _tinySvg.classes)(clonedMarker).add('djs-dragger').add('djs-dragger-marker');
        this._clonedMarkers[markerId] = clonedMarker;
        var defs = (0, _minDom.query)('defs', this._canvas._svg);
        if (!defs) {
            defs = (0, _tinySvg.create)('defs');
            (0, _tinySvg.append)(this._canvas._svg, defs);
        }
        (0, _tinySvg.append)(defs, clonedMarker);
    }
    var reference = idToReference(this._clonedMarkers[markerId].id);
    (0, _tinySvg.attr)(gfx, markerType, reference);
};
// helpers //////////
/**
 * Get marker of given type referenced by node.
 *
 * @param {Node} node
 * @param {string} markerType
 * @param {Node} [parentNode]
 *
 * @param {Node}
 */ function getMarker(node, markerType, parentNode) {
    var id = referenceToId((0, _tinySvg.attr)(node, markerType));
    return (0, _minDom.query)('marker#' + id, parentNode || document);
}
/**
 * Get ID of fragment within current document from its functional IRI reference.
 * References may use single or double quotes.
 *
 * @param {string} reference
 *
 * @returns {string}
 */ function referenceToId(reference) {
    return reference.match(/url\(['"]?#([^'"]*)['"]?\)/)[1];
}
/**
 * Get functional IRI reference for given ID of fragment within current document.
 *
 * @param {string} id
 *
 * @returns {string}
 */ function idToReference(id) {
    return 'url(#' + id + ')';
}
/**
 * Check wether node type can have marker attributes.
 *
 * @param {Node} node
 *
 * @returns {boolean}
 */ function canHaveMarker(node) {
    return NODES_CAN_HAVE_MARKER.indexOf(node.nodeName) !== -1;
}

},{"min-dash":"aEEla","tiny-svg":"6ZtXA","min-dom":"e58GC","../../util/GraphicsUtil":"2ACCV","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3dbhc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Create);
var _minDash = require("min-dash");
var _elements = require("../../util/Elements");
var MARKER_OK = 'drop-ok', MARKER_NOT_OK = 'drop-not-ok', MARKER_ATTACH = 'attach-ok', MARKER_NEW_PARENT = 'new-parent';
/**
 * @typedef {import('../../model').Base} Base
 * @typedef {import('../../model').Shape} Shape
 *
 * @typedef {import('../../util/Types').Point} Point
 *
 * @typedef {import('../../core/Canvas').default} Canvas
 * @typedef {import('../dragging/Dragging').default} Dragging
 * @typedef {import('../../core/EventBus').default} EventBus
 * @typedef {import('../modeling/Modeling').default} Modeling
 * @typedef {import('../rules/Rules').default} Rules
 */ var PREFIX = 'create';
var HIGH_PRIORITY = 2000;
function Create(canvas, dragging, eventBus, modeling, rules) {
    // rules //////////
    /**
   * Check wether elements can be created.
   *
   * @param {Base[]} elements
   * @param {Shape} target
   * @param {Point} position
   * @param {Base} [source]
   *
   * @returns {boolean|null|Object}
   */ function canCreate(elements, target, position, source, hints) {
        if (!target) return false;
        // ignore child elements and external labels
        elements = (0, _minDash.filter)(elements, function(element) {
            var labelTarget = element.labelTarget;
            return !element.parent && !(isLabel(element) && elements.indexOf(labelTarget) !== -1);
        });
        var shape = (0, _minDash.find)(elements, function(element) {
            return !isConnection(element);
        });
        var attach = false, connect = false, create = false;
        // (1) attaching single shapes
        if (isSingleShape(elements)) attach = rules.allowed('shape.attach', {
            position: position,
            shape: shape,
            target: target
        });
        if (!attach) {
            // (2) creating elements
            if (isSingleShape(elements)) create = rules.allowed('shape.create', {
                position: position,
                shape: shape,
                source: source,
                target: target
            });
            else create = rules.allowed('elements.create', {
                elements: elements,
                position: position,
                target: target
            });
        }
        var connectionTarget = hints.connectionTarget;
        // (3) appending single shapes
        if (create || attach) {
            if (shape && source) connect = rules.allowed('connection.create', {
                source: connectionTarget === source ? shape : source,
                target: connectionTarget === source ? source : shape,
                hints: {
                    targetParent: target,
                    targetAttach: attach
                }
            });
            return {
                attach: attach,
                connect: connect
            };
        }
        // ignore wether or not elements can be created
        if (create === null || attach === null) return null;
        return false;
    }
    function setMarker(element, marker) {
        [
            MARKER_ATTACH,
            MARKER_OK,
            MARKER_NOT_OK,
            MARKER_NEW_PARENT
        ].forEach(function(m) {
            if (m === marker) canvas.addMarker(element, m);
            else canvas.removeMarker(element, m);
        });
    }
    // event handling //////////
    eventBus.on([
        'create.move',
        'create.hover'
    ], function(event) {
        var context = event.context, elements = context.elements, hover = event.hover, source = context.source, hints = context.hints || {};
        if (!hover) {
            context.canExecute = false;
            context.target = null;
            return;
        }
        ensureConstraints(event);
        var position = {
            x: event.x,
            y: event.y
        };
        var canExecute = context.canExecute = hover && canCreate(elements, hover, position, source, hints);
        if (hover && canExecute !== null) {
            context.target = hover;
            if (canExecute && canExecute.attach) setMarker(hover, MARKER_ATTACH);
            else setMarker(hover, canExecute ? MARKER_NEW_PARENT : MARKER_NOT_OK);
        }
    });
    eventBus.on([
        'create.end',
        'create.out',
        'create.cleanup'
    ], function(event) {
        var hover = event.hover;
        if (hover) setMarker(hover, null);
    });
    eventBus.on('create.end', function(event) {
        var context = event.context, source = context.source, shape = context.shape, elements = context.elements, target = context.target, canExecute = context.canExecute, attach = canExecute && canExecute.attach, connect = canExecute && canExecute.connect, hints = context.hints || {};
        if (canExecute === false || !target) return false;
        ensureConstraints(event);
        var position = {
            x: event.x,
            y: event.y
        };
        if (connect) shape = modeling.appendShape(source, shape, position, target, {
            attach: attach,
            connection: connect === true ? {} : connect,
            connectionTarget: hints.connectionTarget
        });
        else {
            elements = modeling.createElements(elements, position, target, (0, _minDash.assign)({}, hints, {
                attach: attach
            }));
            // update shape
            shape = (0, _minDash.find)(elements, function(element) {
                return !isConnection(element);
            });
        }
        // update elements and shape
        (0, _minDash.assign)(context, {
            elements: elements,
            shape: shape
        });
        (0, _minDash.assign)(event, {
            elements: elements,
            shape: shape
        });
    });
    function cancel() {
        var context = dragging.context();
        if (context && context.prefix === PREFIX) dragging.cancel();
    }
    // cancel on <elements.changed> that is not result of <drag.end>
    eventBus.on('create.init', function() {
        eventBus.on('elements.changed', cancel);
        eventBus.once([
            'create.cancel',
            'create.end'
        ], HIGH_PRIORITY, function() {
            eventBus.off('elements.changed', cancel);
        });
    });
    // API //////////
    this.start = function(event, elements, context) {
        if (!(0, _minDash.isArray)(elements)) elements = [
            elements
        ];
        var shape = (0, _minDash.find)(elements, function(element) {
            return !isConnection(element);
        });
        if (!shape) // at least one shape is required
        return;
        context = (0, _minDash.assign)({
            elements: elements,
            hints: {},
            shape: shape
        }, context || {});
        // make sure each element has x and y
        (0, _minDash.forEach)(elements, function(element) {
            if (!(0, _minDash.isNumber)(element.x)) element.x = 0;
            if (!(0, _minDash.isNumber)(element.y)) element.y = 0;
        });
        var visibleElements = (0, _minDash.filter)(elements, function(element) {
            return !element.hidden;
        });
        var bbox = (0, _elements.getBBox)(visibleElements);
        // center elements around cursor
        (0, _minDash.forEach)(elements, function(element) {
            if (isConnection(element)) element.waypoints = (0, _minDash.map)(element.waypoints, function(waypoint) {
                return {
                    x: waypoint.x - bbox.x - bbox.width / 2,
                    y: waypoint.y - bbox.y - bbox.height / 2
                };
            });
            (0, _minDash.assign)(element, {
                x: element.x - bbox.x - bbox.width / 2,
                y: element.y - bbox.y - bbox.height / 2
            });
        });
        dragging.init(event, PREFIX, {
            cursor: 'grabbing',
            autoActivate: true,
            data: {
                shape: shape,
                elements: elements,
                context: context
            }
        });
    };
}
Create.$inject = [
    'canvas',
    'dragging',
    'eventBus',
    'modeling',
    'rules'
];
// helpers //////////
function ensureConstraints(event) {
    var context = event.context, createConstraints = context.createConstraints;
    if (!createConstraints) return;
    if (createConstraints.left) event.x = Math.max(event.x, createConstraints.left);
    if (createConstraints.right) event.x = Math.min(event.x, createConstraints.right);
    if (createConstraints.top) event.y = Math.max(event.y, createConstraints.top);
    if (createConstraints.bottom) event.y = Math.min(event.y, createConstraints.bottom);
}
function isConnection(element) {
    return !!element.waypoints;
}
function isSingleShape(elements) {
    return elements && elements.length === 1 && !isConnection(elements[0]);
}
function isLabel(element) {
    return !!element.labelTarget;
}

},{"min-dash":"aEEla","../../util/Elements":"6qdtl","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9Zbyx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CreatePreview);
var _svgTransformUtil = require("../../util/SvgTransformUtil");
var _graphicsUtil = require("../../util/GraphicsUtil");
var _tinySvg = require("tiny-svg");
/**
 * @typedef {import('../../core/Canvas').default} Canvas
 * @typedef {import('../../core/EventBus').default} EventBus
 * @typedef {import('../../core/GraphicsFactory').default} GraphicsFactory
 * @typedef {import('../preview-support/PreviewSupport').default} PreviewSupport
 * @typedef {import('../../draw/Styles').default} Styles
 */ var LOW_PRIORITY = 750;
function CreatePreview(canvas, eventBus, graphicsFactory, previewSupport, styles) {
    function createDragGroup(elements) {
        var dragGroup = (0, _tinySvg.create)('g');
        (0, _tinySvg.attr)(dragGroup, styles.cls('djs-drag-group', [
            'no-events'
        ]));
        var childrenGfx = (0, _tinySvg.create)('g');
        elements.forEach(function(element) {
            // create graphics
            var gfx;
            if (element.hidden) return;
            if (element.waypoints) {
                gfx = graphicsFactory._createContainer('connection', childrenGfx);
                graphicsFactory.drawConnection((0, _graphicsUtil.getVisual)(gfx), element);
            } else {
                gfx = graphicsFactory._createContainer('shape', childrenGfx);
                graphicsFactory.drawShape((0, _graphicsUtil.getVisual)(gfx), element);
                (0, _svgTransformUtil.translate)(gfx, element.x, element.y);
            }
            // add preview
            previewSupport.addDragger(element, dragGroup, gfx);
        });
        return dragGroup;
    }
    eventBus.on('create.move', LOW_PRIORITY, function(event) {
        var hover = event.hover, context = event.context, elements = context.elements, dragGroup = context.dragGroup;
        // lazily create previews
        if (!dragGroup) dragGroup = context.dragGroup = createDragGroup(elements);
        var activeLayer;
        if (hover) {
            if (!dragGroup.parentNode) {
                activeLayer = canvas.getActiveLayer();
                (0, _tinySvg.append)(activeLayer, dragGroup);
            }
            (0, _svgTransformUtil.translate)(dragGroup, event.x, event.y);
        } else (0, _tinySvg.remove)(dragGroup);
    });
    eventBus.on('create.cleanup', function(event) {
        var context = event.context, dragGroup = context.dragGroup;
        if (dragGroup) (0, _tinySvg.remove)(dragGroup);
    });
}
CreatePreview.$inject = [
    'canvas',
    'eventBus',
    'graphicsFactory',
    'previewSupport',
    'styles'
];

},{"../../util/SvgTransformUtil":"g4Nbc","../../util/GraphicsUtil":"2ACCV","tiny-svg":"6ZtXA","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"f5IvJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _popupMenu = require("diagram-js/lib/features/popup-menu");
var _popupMenuDefault = parcelHelpers.interopDefault(_popupMenu);
var _replace = require("../replace");
var _replaceDefault = parcelHelpers.interopDefault(_replace);
var _replaceMenuProvider = require("./ReplaceMenuProvider");
var _replaceMenuProviderDefault = parcelHelpers.interopDefault(_replaceMenuProvider);
var _autoPlace = require("../auto-place");
var _autoPlaceDefault = parcelHelpers.interopDefault(_autoPlace);
exports.default = {
    __depends__: [
        (0, _popupMenuDefault.default),
        (0, _replaceDefault.default),
        (0, _autoPlaceDefault.default)
    ],
    __init__: [
        'replaceMenuProvider'
    ],
    replaceMenuProvider: [
        'type',
        (0, _replaceMenuProviderDefault.default)
    ]
};

},{"diagram-js/lib/features/popup-menu":"iRpNh","../replace":"8KY8q","./ReplaceMenuProvider":"eFjQf","../auto-place":"8yzvZ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8KY8q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _copyPaste = require("../copy-paste");
var _copyPasteDefault = parcelHelpers.interopDefault(_copyPaste);
var _replace = require("diagram-js/lib/features/replace");
var _replaceDefault = parcelHelpers.interopDefault(_replace);
var _selection = require("diagram-js/lib/features/selection");
var _selectionDefault = parcelHelpers.interopDefault(_selection);
var _bpmnReplace = require("./BpmnReplace");
var _bpmnReplaceDefault = parcelHelpers.interopDefault(_bpmnReplace);
exports.default = {
    __depends__: [
        (0, _copyPasteDefault.default),
        (0, _replaceDefault.default),
        (0, _selectionDefault.default)
    ],
    bpmnReplace: [
        'type',
        (0, _bpmnReplaceDefault.default)
    ]
};

},{"../copy-paste":"wsGCk","diagram-js/lib/features/replace":"fe10q","diagram-js/lib/features/selection":"8Jf3R","./BpmnReplace":"4ngQp","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"wsGCk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _copyPaste = require("diagram-js/lib/features/copy-paste");
var _copyPasteDefault = parcelHelpers.interopDefault(_copyPaste);
var _bpmnCopyPaste = require("./BpmnCopyPaste");
var _bpmnCopyPasteDefault = parcelHelpers.interopDefault(_bpmnCopyPaste);
var _moddleCopy = require("./ModdleCopy");
var _moddleCopyDefault = parcelHelpers.interopDefault(_moddleCopy);
exports.default = {
    __depends__: [
        (0, _copyPasteDefault.default)
    ],
    __init__: [
        'bpmnCopyPaste',
        'moddleCopy'
    ],
    bpmnCopyPaste: [
        'type',
        (0, _bpmnCopyPasteDefault.default)
    ],
    moddleCopy: [
        'type',
        (0, _moddleCopyDefault.default)
    ]
};

},{"diagram-js/lib/features/copy-paste":"bSBtj","./BpmnCopyPaste":"hBTIo","./ModdleCopy":"eiSLV","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bSBtj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _clipboard = require("../clipboard");
var _clipboardDefault = parcelHelpers.interopDefault(_clipboard);
var _create = require("../create");
var _createDefault = parcelHelpers.interopDefault(_create);
var _mouse = require("../mouse");
var _mouseDefault = parcelHelpers.interopDefault(_mouse);
var _rules = require("../rules");
var _rulesDefault = parcelHelpers.interopDefault(_rules);
var _copyPaste = require("./CopyPaste");
var _copyPasteDefault = parcelHelpers.interopDefault(_copyPaste);
exports.default = {
    __depends__: [
        (0, _clipboardDefault.default),
        (0, _createDefault.default),
        (0, _mouseDefault.default),
        (0, _rulesDefault.default)
    ],
    __init__: [
        'copyPaste'
    ],
    copyPaste: [
        'type',
        (0, _copyPasteDefault.default)
    ]
};

},{"../clipboard":"bEvd6","../create":"kKw9I","../mouse":"ajwMh","../rules":"5xj5a","./CopyPaste":"eA0Xk","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bEvd6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _clipboard = require("./Clipboard");
var _clipboardDefault = parcelHelpers.interopDefault(_clipboard);
exports.default = {
    clipboard: [
        'type',
        (0, _clipboardDefault.default)
    ]
};

},{"./Clipboard":"7HHVo","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7HHVo":[function(require,module,exports,__globalThis) {
/**
 * A clip board stub
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Clipboard);
function Clipboard() {}
Clipboard.prototype.get = function() {
    return this._data;
};
Clipboard.prototype.set = function(data) {
    this._data = data;
};
Clipboard.prototype.clear = function() {
    var data = this._data;
    delete this._data;
    return data;
};
Clipboard.prototype.isEmpty = function() {
    return !this._data;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ajwMh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mouse = require("./Mouse");
var _mouseDefault = parcelHelpers.interopDefault(_mouse);
exports.default = {
    __init__: [
        'mouse'
    ],
    mouse: [
        'type',
        (0, _mouseDefault.default)
    ]
};

},{"./Mouse":"4S73u","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4S73u":[function(require,module,exports,__globalThis) {
/**
 * @typedef {import('../../core/EventBus').default} EventBus
 */ /**
 * @param {EventBus} eventBus
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Mouse);
// helpers //////////
parcelHelpers.export(exports, "createMoveEvent", ()=>createMoveEvent);
function Mouse(eventBus) {
    var self = this;
    this._lastMoveEvent = null;
    function setLastMoveEvent(mousemoveEvent) {
        self._lastMoveEvent = mousemoveEvent;
    }
    eventBus.on('canvas.init', function(context) {
        var svg = self._svg = context.svg;
        svg.addEventListener('mousemove', setLastMoveEvent);
    });
    eventBus.on('canvas.destroy', function() {
        self._lastMouseEvent = null;
        self._svg.removeEventListener('mousemove', setLastMoveEvent);
    });
}
Mouse.$inject = [
    'eventBus'
];
Mouse.prototype.getLastMoveEvent = function() {
    return this._lastMoveEvent || createMoveEvent(0, 0);
};
function createMoveEvent(x, y) {
    var event = document.createEvent('MouseEvent');
    var screenX = x, screenY = y, clientX = x, clientY = y;
    if (event.initMouseEvent) event.initMouseEvent('mousemove', true, true, window, 0, screenX, screenY, clientX, clientY, false, false, false, false, 0, null);
    return event;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eA0Xk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CopyPaste);
var _minDash = require("min-dash");
var _elements = require("../../util/Elements");
function CopyPaste(canvas, create, clipboard, elementFactory, eventBus, modeling, mouse, rules) {
    this._canvas = canvas;
    this._create = create;
    this._clipboard = clipboard;
    this._elementFactory = elementFactory;
    this._eventBus = eventBus;
    this._modeling = modeling;
    this._mouse = mouse;
    this._rules = rules;
    eventBus.on('copyPaste.copyElement', function(context) {
        var descriptor = context.descriptor, element = context.element, elements = context.elements;
        // default priority (priority = 1)
        descriptor.priority = 1;
        descriptor.id = element.id;
        var parentCopied = (0, _minDash.find)(elements, function(e) {
            return e === element.parent;
        });
        // do NOT reference parent if parent wasn't copied
        if (parentCopied) descriptor.parent = element.parent.id;
        // attachers (priority = 2)
        if (isAttacher(element)) {
            descriptor.priority = 2;
            descriptor.host = element.host.id;
        }
        // connections (priority = 3)
        if (isConnection(element)) {
            descriptor.priority = 3;
            descriptor.source = element.source.id;
            descriptor.target = element.target.id;
            descriptor.waypoints = copyWaypoints(element);
        }
        // labels (priority = 4)
        if (isLabel(element)) {
            descriptor.priority = 4;
            descriptor.labelTarget = element.labelTarget.id;
        }
        (0, _minDash.forEach)([
            'x',
            'y',
            'width',
            'height'
        ], function(property) {
            if ((0, _minDash.isNumber)(element[property])) descriptor[property] = element[property];
        });
        descriptor.hidden = element.hidden;
        descriptor.collapsed = element.collapsed;
    });
    eventBus.on('copyPaste.pasteElements', function(context) {
        var hints = context.hints;
        (0, _minDash.assign)(hints, {
            createElementsBehavior: false
        });
    });
}
CopyPaste.$inject = [
    'canvas',
    'create',
    'clipboard',
    'elementFactory',
    'eventBus',
    'modeling',
    'mouse',
    'rules'
];
/**
 * Copy elements.
 *
 * @param {Base[]} elements
 *
 * @returns {Object}
 */ CopyPaste.prototype.copy = function(elements) {
    var allowed, tree;
    if (!(0, _minDash.isArray)(elements)) elements = elements ? [
        elements
    ] : [];
    allowed = this._eventBus.fire('copyPaste.canCopyElements', {
        elements: elements
    });
    if (allowed === false) tree = {};
    else tree = this.createTree((0, _minDash.isArray)(allowed) ? allowed : elements);
    // we set an empty tree, selection of elements
    // to copy was empty.
    this._clipboard.set(tree);
    this._eventBus.fire('copyPaste.elementsCopied', {
        elements: elements,
        tree: tree
    });
    return tree;
};
/**
 * Paste elements.
 *
 * @param {Object} [context]
 * @param {Shape} [context.element] The optional parent.
 * @param {Point} [context.point] The optional osition.
 * @param {Object} [context.hints] The optional hints.
 */ CopyPaste.prototype.paste = function(context) {
    var tree = this._clipboard.get();
    if (this._clipboard.isEmpty()) return;
    var hints = context && context.hints || {};
    this._eventBus.fire('copyPaste.pasteElements', {
        hints: hints
    });
    var elements = this._createElements(tree);
    // paste directly
    if (context && context.element && context.point) return this._paste(elements, context.element, context.point, hints);
    this._create.start(this._mouse.getLastMoveEvent(), elements, {
        hints: hints || {}
    });
};
/**
 * Paste elements directly.
 *
 * @param {Base[]} elements
 * @param {Shape} target
 * @param {Point} position
 * @param {Object} [hints]
 */ CopyPaste.prototype._paste = function(elements, target, position, hints) {
    // make sure each element has x and y
    (0, _minDash.forEach)(elements, function(element) {
        if (!(0, _minDash.isNumber)(element.x)) element.x = 0;
        if (!(0, _minDash.isNumber)(element.y)) element.y = 0;
    });
    var bbox = (0, _elements.getBBox)(elements);
    // center elements around cursor
    (0, _minDash.forEach)(elements, function(element) {
        if (isConnection(element)) element.waypoints = (0, _minDash.map)(element.waypoints, function(waypoint) {
            return {
                x: waypoint.x - bbox.x - bbox.width / 2,
                y: waypoint.y - bbox.y - bbox.height / 2
            };
        });
        (0, _minDash.assign)(element, {
            x: element.x - bbox.x - bbox.width / 2,
            y: element.y - bbox.y - bbox.height / 2
        });
    });
    return this._modeling.createElements(elements, position, target, (0, _minDash.assign)({}, hints));
};
/**
 * Create elements from tree.
 */ CopyPaste.prototype._createElements = function(tree) {
    var self = this;
    var eventBus = this._eventBus;
    var cache = {};
    var elements = [];
    (0, _minDash.forEach)(tree, function(branch, depth) {
        depth = parseInt(depth, 10);
        // sort by priority
        branch = (0, _minDash.sortBy)(branch, 'priority');
        (0, _minDash.forEach)(branch, function(descriptor) {
            // remove priority
            var attrs = (0, _minDash.assign)({}, (0, _minDash.omit)(descriptor, [
                'priority'
            ]));
            if (cache[descriptor.parent]) attrs.parent = cache[descriptor.parent];
            else delete attrs.parent;
            eventBus.fire('copyPaste.pasteElement', {
                cache: cache,
                descriptor: attrs
            });
            var element;
            if (isConnection(attrs)) {
                attrs.source = cache[descriptor.source];
                attrs.target = cache[descriptor.target];
                element = cache[descriptor.id] = self.createConnection(attrs);
                elements.push(element);
                return;
            }
            if (isLabel(attrs)) {
                attrs.labelTarget = cache[attrs.labelTarget];
                element = cache[descriptor.id] = self.createLabel(attrs);
                elements.push(element);
                return;
            }
            if (attrs.host) attrs.host = cache[attrs.host];
            element = cache[descriptor.id] = self.createShape(attrs);
            elements.push(element);
        });
    });
    return elements;
};
CopyPaste.prototype.createConnection = function(attrs) {
    var connection = this._elementFactory.createConnection((0, _minDash.omit)(attrs, [
        'id'
    ]));
    return connection;
};
CopyPaste.prototype.createLabel = function(attrs) {
    var label = this._elementFactory.createLabel((0, _minDash.omit)(attrs, [
        'id'
    ]));
    return label;
};
CopyPaste.prototype.createShape = function(attrs) {
    var shape = this._elementFactory.createShape((0, _minDash.omit)(attrs, [
        'id'
    ]));
    return shape;
};
/**
 * Check wether element has relations to other elements e.g. attachers, labels and connections.
 *
 * @param {Object} element
 * @param {Base[]} elements
 *
 * @returns {boolean}
 */ CopyPaste.prototype.hasRelations = function(element, elements) {
    var labelTarget, source, target;
    if (isConnection(element)) {
        source = (0, _minDash.find)(elements, (0, _minDash.matchPattern)({
            id: element.source.id
        }));
        target = (0, _minDash.find)(elements, (0, _minDash.matchPattern)({
            id: element.target.id
        }));
        if (!source || !target) return false;
    }
    if (isLabel(element)) {
        labelTarget = (0, _minDash.find)(elements, (0, _minDash.matchPattern)({
            id: element.labelTarget.id
        }));
        if (!labelTarget) return false;
    }
    return true;
};
/**
 * Create a tree-like structure from elements.
 *
 * @example
 * tree: {
  *  0: [
  *    { id: 'Shape_1', priority: 1, ... },
  *    { id: 'Shape_2', priority: 1, ... },
  *    { id: 'Connection_1', source: 'Shape_1', target: 'Shape_2', priority: 3, ... },
  *    ...
  *  ],
  *  1: [
  *    { id: 'Shape_3', parent: 'Shape1', priority: 1, ... },
  *    ...
  *  ]
  * };
  *
  * @param {Base[]} elements
  *
  * @return {Object}
  */ CopyPaste.prototype.createTree = function(elements) {
    var rules = this._rules, self = this;
    var tree = {}, elementsData = [];
    var parents = (0, _elements.getParents)(elements);
    function canCopy(element, elements) {
        return rules.allowed('element.copy', {
            element: element,
            elements: elements
        });
    }
    function addElementData(element, depth) {
        // (1) check wether element has already been added
        var foundElementData = (0, _minDash.find)(elementsData, function(elementsData) {
            return element === elementsData.element;
        });
        // (2) add element if not already added
        if (!foundElementData) {
            elementsData.push({
                element: element,
                depth: depth
            });
            return;
        }
        // (3) update depth
        if (foundElementData.depth < depth) {
            elementsData = removeElementData(foundElementData, elementsData);
            elementsData.push({
                element: foundElementData.element,
                depth: depth
            });
        }
    }
    function removeElementData(elementData, elementsData) {
        var index = elementsData.indexOf(elementData);
        if (index !== -1) elementsData.splice(index, 1);
        return elementsData;
    }
    // (1) add elements
    (0, _elements.eachElement)(parents, function(element, _index, depth) {
        // do NOT add external labels directly
        if (isLabel(element)) return;
        // always copy external labels
        (0, _minDash.forEach)(element.labels, function(label) {
            addElementData(label, depth);
        });
        function addRelatedElements(elements) {
            elements && elements.length && (0, _minDash.forEach)(elements, function(element) {
                // add external labels
                (0, _minDash.forEach)(element.labels, function(label) {
                    addElementData(label, depth);
                });
                addElementData(element, depth);
            });
        }
        (0, _minDash.forEach)([
            element.attachers,
            element.incoming,
            element.outgoing
        ], addRelatedElements);
        addElementData(element, depth);
        var children = [];
        if (element.children) children = element.children.slice();
        // allow others to add children to tree
        self._eventBus.fire('copyPaste.createTree', {
            element: element,
            children: children
        });
        return children;
    });
    elements = (0, _minDash.map)(elementsData, function(elementData) {
        return elementData.element;
    });
    // (2) copy elements
    elementsData = (0, _minDash.map)(elementsData, function(elementData) {
        elementData.descriptor = {};
        self._eventBus.fire('copyPaste.copyElement', {
            descriptor: elementData.descriptor,
            element: elementData.element,
            elements: elements
        });
        return elementData;
    });
    // (3) sort elements by priority
    elementsData = (0, _minDash.sortBy)(elementsData, function(elementData) {
        return elementData.descriptor.priority;
    });
    elements = (0, _minDash.map)(elementsData, function(elementData) {
        return elementData.element;
    });
    // (4) create tree
    (0, _minDash.forEach)(elementsData, function(elementData) {
        var depth = elementData.depth;
        if (!self.hasRelations(elementData.element, elements)) {
            removeElement(elementData.element, elements);
            return;
        }
        if (!canCopy(elementData.element, elements)) {
            removeElement(elementData.element, elements);
            return;
        }
        if (!tree[depth]) tree[depth] = [];
        tree[depth].push(elementData.descriptor);
    });
    return tree;
};
// helpers //////////
function isAttacher(element) {
    return !!element.host;
}
function isConnection(element) {
    return !!element.waypoints;
}
function isLabel(element) {
    return !!element.labelTarget;
}
function copyWaypoints(element) {
    return (0, _minDash.map)(element.waypoints, function(waypoint) {
        waypoint = copyWaypoint(waypoint);
        if (waypoint.original) waypoint.original = copyWaypoint(waypoint.original);
        return waypoint;
    });
}
function copyWaypoint(waypoint) {
    return (0, _minDash.assign)({}, waypoint);
}
function removeElement(element, elements) {
    var index = elements.indexOf(element);
    if (index === -1) return elements;
    return elements.splice(index, 1);
}

},{"min-dash":"aEEla","../../util/Elements":"6qdtl","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hBTIo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BpmnCopyPaste);
var _modelUtil = require("../../util/ModelUtil");
var _minDash = require("min-dash");
function copyProperties(source, target, properties) {
    if (!(0, _minDash.isArray)(properties)) properties = [
        properties
    ];
    (0, _minDash.forEach)(properties, function(property) {
        if (!(0, _minDash.isUndefined)(source[property])) target[property] = source[property];
    });
}
var LOW_PRIORITY = 750;
function BpmnCopyPaste(bpmnFactory, eventBus, moddleCopy) {
    function copy(bo, clone) {
        var targetBo = bpmnFactory.create(bo.$type);
        return moddleCopy.copyElement(bo, targetBo, null, clone);
    }
    eventBus.on('copyPaste.copyElement', LOW_PRIORITY, function(context) {
        var descriptor = context.descriptor, element = context.element, businessObject = (0, _modelUtil.getBusinessObject)(element);
        // do not copy business object + di for labels;
        // will be pulled from the referenced label target
        if (isLabel(element)) return descriptor;
        var businessObjectCopy = descriptor.businessObject = copy(businessObject, true);
        var diCopy = descriptor.di = copy((0, _modelUtil.getDi)(element), true);
        diCopy.bpmnElement = businessObjectCopy;
        copyProperties(businessObjectCopy, descriptor, 'name');
        copyProperties(diCopy, descriptor, 'isExpanded');
        // default sequence flow
        if (businessObject.default) descriptor.default = businessObject.default.id;
    });
    var referencesKey = '-bpmn-js-refs';
    function getReferences(cache) {
        return cache[referencesKey] = cache[referencesKey] || {};
    }
    function setReferences(cache, references) {
        cache[referencesKey] = references;
    }
    function resolveReferences(descriptor, cache, references) {
        var businessObject = (0, _modelUtil.getBusinessObject)(descriptor);
        // default sequence flows
        if (descriptor.default) // relationship cannot be resolved immediately
        references[descriptor.default] = {
            element: businessObject,
            property: 'default'
        };
        // boundary events
        if (descriptor.host) // relationship can be resolved immediately
        (0, _modelUtil.getBusinessObject)(descriptor).attachedToRef = (0, _modelUtil.getBusinessObject)(cache[descriptor.host]);
        return (0, _minDash.omit)(references, (0, _minDash.reduce)(references, function(array, reference, key) {
            var element = reference.element, property = reference.property;
            if (key === descriptor.id) {
                element[property] = businessObject;
                array.push(descriptor.id);
            }
            return array;
        }, []));
    }
    eventBus.on('copyPaste.pasteElement', function(context) {
        var cache = context.cache, descriptor = context.descriptor, businessObject = descriptor.businessObject, di = descriptor.di;
        // wire existing di + businessObject for external label
        if (isLabel(descriptor)) {
            descriptor.businessObject = (0, _modelUtil.getBusinessObject)(cache[descriptor.labelTarget]);
            descriptor.di = (0, _modelUtil.getDi)(cache[descriptor.labelTarget]);
            return;
        }
        businessObject = descriptor.businessObject = copy(businessObject);
        di = descriptor.di = copy(di);
        di.bpmnElement = businessObject;
        copyProperties(descriptor, businessObject, [
            'isExpanded',
            'name'
        ]);
        descriptor.type = businessObject.$type;
    });
    // copy + paste processRef with participant
    eventBus.on('copyPaste.copyElement', LOW_PRIORITY, function(context) {
        var descriptor = context.descriptor, element = context.element;
        if (!(0, _modelUtil.is)(element, 'bpmn:Participant')) return;
        var participantBo = (0, _modelUtil.getBusinessObject)(element);
        if (participantBo.processRef) descriptor.processRef = copy(participantBo.processRef, true);
    });
    eventBus.on('copyPaste.pasteElement', function(context) {
        var descriptor = context.descriptor, processRef = descriptor.processRef;
        if (processRef) descriptor.processRef = copy(processRef);
    });
    // resolve references
    eventBus.on('copyPaste.pasteElement', LOW_PRIORITY, function(context) {
        var cache = context.cache, descriptor = context.descriptor;
        // resolve references e.g. default sequence flow
        setReferences(cache, resolveReferences(descriptor, cache, getReferences(cache)));
    });
}
BpmnCopyPaste.$inject = [
    'bpmnFactory',
    'eventBus',
    'moddleCopy'
];
// helpers //////////
function isLabel(element) {
    return !!element.labelTarget;
}

},{"../../util/ModelUtil":"klNYN","min-dash":"aEEla","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eiSLV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ModdleCopy);
// helpers //////////
parcelHelpers.export(exports, "getPropertyNames", ()=>getPropertyNames);
var _minDash = require("min-dash");
var DISALLOWED_PROPERTIES = [
    'artifacts',
    'dataInputAssociations',
    'dataOutputAssociations',
    'default',
    'flowElements',
    'lanes',
    'incoming',
    'outgoing',
    'categoryValue'
];
function ModdleCopy(eventBus, bpmnFactory, moddle) {
    this._bpmnFactory = bpmnFactory;
    this._eventBus = eventBus;
    this._moddle = moddle;
    // copy extension elements last
    eventBus.on('moddleCopy.canCopyProperties', function(context) {
        var propertyNames = context.propertyNames;
        if (!propertyNames || !propertyNames.length) return;
        return (0, _minDash.sortBy)(propertyNames, function(propertyName) {
            return propertyName === 'extensionElements';
        });
    });
    // default check whether property can be copied
    eventBus.on('moddleCopy.canCopyProperty', function(context) {
        var parent = context.parent, parentDescriptor = (0, _minDash.isObject)(parent) && parent.$descriptor, propertyName = context.propertyName;
        if (propertyName && DISALLOWED_PROPERTIES.indexOf(propertyName) !== -1) // disallow copying property
        return false;
        if (propertyName && parentDescriptor && !(0, _minDash.find)(parentDescriptor.properties, (0, _minDash.matchPattern)({
            name: propertyName
        }))) // disallow copying property
        return false;
    });
    // do NOT allow to copy empty extension elements
    eventBus.on('moddleCopy.canSetCopiedProperty', function(context) {
        var property = context.property;
        if (is(property, 'bpmn:ExtensionElements') && (!property.values || !property.values.length)) // disallow setting copied property
        return false;
    });
}
ModdleCopy.$inject = [
    'eventBus',
    'bpmnFactory',
    'moddle'
];
/**
 * Copy model properties of source element to target element.
 *
 * @param {ModdleElement} sourceElement
 * @param {ModdleElement} targetElement
 * @param {Array<string>} [propertyNames]
 * @param {boolean} clone
 *
 * @param {ModdleElement}
 */ ModdleCopy.prototype.copyElement = function(sourceElement, targetElement, propertyNames, clone) {
    var self = this;
    if (propertyNames && !(0, _minDash.isArray)(propertyNames)) propertyNames = [
        propertyNames
    ];
    propertyNames = propertyNames || getPropertyNames(sourceElement.$descriptor);
    var canCopyProperties = this._eventBus.fire('moddleCopy.canCopyProperties', {
        propertyNames: propertyNames,
        sourceElement: sourceElement,
        targetElement: targetElement,
        clone: clone
    });
    if (canCopyProperties === false) return targetElement;
    if ((0, _minDash.isArray)(canCopyProperties)) propertyNames = canCopyProperties;
    // copy properties
    (0, _minDash.forEach)(propertyNames, function(propertyName) {
        var sourceProperty;
        if ((0, _minDash.has)(sourceElement, propertyName)) sourceProperty = sourceElement.get(propertyName);
        var copiedProperty = self.copyProperty(sourceProperty, targetElement, propertyName, clone);
        if (!(0, _minDash.isDefined)(copiedProperty)) return;
        var canSetProperty = self._eventBus.fire('moddleCopy.canSetCopiedProperty', {
            parent: targetElement,
            property: copiedProperty,
            propertyName: propertyName
        });
        if (canSetProperty === false) return;
        // TODO(nikku): unclaim old IDs if ID property is copied over
        // this._moddle.getPropertyDescriptor(parent, propertyName)
        targetElement.set(propertyName, copiedProperty);
    });
    return targetElement;
};
/**
 * Copy model property.
 *
 * @param {*} property
 * @param {ModdleElement} parent
 * @param {string} propertyName
 * @param {boolean} clone
 *
 * @returns {*}
 */ ModdleCopy.prototype.copyProperty = function(property, parent, propertyName, clone) {
    var self = this;
    // allow others to copy property
    var copiedProperty = this._eventBus.fire('moddleCopy.canCopyProperty', {
        parent: parent,
        property: property,
        propertyName: propertyName,
        clone: clone
    });
    // return if copying is NOT allowed
    if (copiedProperty === false) return;
    if (copiedProperty) {
        if ((0, _minDash.isObject)(copiedProperty) && copiedProperty.$type && !copiedProperty.$parent) copiedProperty.$parent = parent;
        return copiedProperty;
    }
    var propertyDescriptor = this._moddle.getPropertyDescriptor(parent, propertyName);
    // do NOT copy references
    if (propertyDescriptor.isReference) return;
    // copy id
    if (propertyDescriptor.isId) return property && this._copyId(property, parent, clone);
    // copy arrays
    if ((0, _minDash.isArray)(property)) return (0, _minDash.reduce)(property, function(childProperties, childProperty) {
        // recursion
        copiedProperty = self.copyProperty(childProperty, parent, propertyName, clone);
        // copying might NOT be allowed
        if (copiedProperty) return childProperties.concat(copiedProperty);
        return childProperties;
    }, []);
    // copy model elements
    if ((0, _minDash.isObject)(property) && property.$type) {
        if (this._moddle.getElementDescriptor(property).isGeneric) return;
        copiedProperty = self._bpmnFactory.create(property.$type);
        copiedProperty.$parent = parent;
        // recursion
        copiedProperty = self.copyElement(property, copiedProperty, null, clone);
        return copiedProperty;
    }
    // copy primitive properties
    return property;
};
ModdleCopy.prototype._copyId = function(id, element, clone) {
    if (clone) return id;
    // disallow if already taken
    if (this._moddle.ids.assigned(id)) return;
    else {
        this._moddle.ids.claim(id, element);
        return id;
    }
};
function getPropertyNames(descriptor, keepDefaultProperties) {
    return (0, _minDash.reduce)(descriptor.properties, function(properties, property) {
        if (keepDefaultProperties && property.default) return properties;
        return properties.concat(property.name);
    }, []);
}
function is(element, type) {
    return element && typeof element.$instanceOf === 'function' && element.$instanceOf(type);
}

},{"min-dash":"aEEla","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fe10q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _replace = require("./Replace");
var _replaceDefault = parcelHelpers.interopDefault(_replace);
var _replaceSelectionBehavior = require("./ReplaceSelectionBehavior");
var _replaceSelectionBehaviorDefault = parcelHelpers.interopDefault(_replaceSelectionBehavior);
exports.default = {
    __init__: [
        'replace',
        'replaceSelectionBehavior'
    ],
    replaceSelectionBehavior: [
        'type',
        (0, _replaceSelectionBehaviorDefault.default)
    ],
    replace: [
        'type',
        (0, _replaceDefault.default)
    ]
};

},{"./Replace":"86vDu","./ReplaceSelectionBehavior":"lR2Sh","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"86vDu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Replace);
var _minDash = require("min-dash");
/**
 * @typedef {import('../modeling/Modeling').default} Modeling
 */ var round = Math.round;
function Replace(modeling, eventBus) {
    this._modeling = modeling;
    this._eventBus = eventBus;
}
Replace.$inject = [
    'modeling',
    'eventBus'
];
/**
 * @param {Element} oldElement - Element to be replaced
 * @param {Object}  attrs - Containing information about the new element,
 *                                   for example the new bounds and type.
 * @param {Object}  hints -   Custom hints that will be attached to the context. It can be used to inject data
 *                            that is needed in the command chain. For example it could be used in
 *                            eventbus.on('commandStack.shape.replace.postExecute') to change shape attributes after
 *                            shape creation.
 */ Replace.prototype.replaceElement = function(oldElement, attrs, hints) {
    if (oldElement.waypoints) // TODO(nikku): we do not replace connections, yet
    return null;
    var modeling = this._modeling;
    var eventBus = this._eventBus;
    eventBus.fire('replace.start', {
        element: oldElement,
        attrs,
        hints
    });
    var width = attrs.width || oldElement.width, height = attrs.height || oldElement.height, x = attrs.x || oldElement.x, y = attrs.y || oldElement.y, centerX = round(x + width / 2), centerY = round(y + height / 2);
    // modeling API requires center coordinates,
    // account for that when handling shape bounds
    var newElement = modeling.replaceShape(oldElement, (0, _minDash.assign)({}, attrs, {
        x: centerX,
        y: centerY,
        width: width,
        height: height
    }), hints);
    eventBus.fire('replace.end', {
        element: oldElement,
        newElement,
        hints
    });
    return newElement;
};

},{"min-dash":"aEEla","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lR2Sh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ReplaceSelectionBehavior);
function ReplaceSelectionBehavior(selection, eventBus) {
    eventBus.on('replace.end', 500, function(event) {
        const { newElement, hints = {} } = event;
        if (hints.select === false) return;
        selection.select(newElement);
    });
}
ReplaceSelectionBehavior.$inject = [
    'selection',
    'eventBus'
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4ngQp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BpmnReplace);
var _minDash = require("min-dash");
var _modelUtil = require("../../util/ModelUtil");
var _modelingUtil = require("../modeling/util/ModelingUtil");
var _diUtil = require("../../util/DiUtil");
var _moddleCopy = require("../copy-paste/ModdleCopy");
function copyProperties(source, target, properties) {
    if (!(0, _minDash.isArray)(properties)) properties = [
        properties
    ];
    (0, _minDash.forEach)(properties, function(property) {
        if (!(0, _minDash.isUndefined)(source[property])) target[property] = source[property];
    });
}
var CUSTOM_PROPERTIES = [
    'cancelActivity',
    'instantiate',
    'eventGatewayType',
    'triggeredByEvent',
    'isInterrupting'
];
/**
 * Check if element should be collapsed or expanded.
 */ function shouldToggleCollapsed(element, targetElement) {
    var oldCollapsed = element && (0, _minDash.has)(element, 'collapsed') ? element.collapsed : !(0, _diUtil.isExpanded)(element);
    var targetCollapsed;
    if (targetElement && ((0, _minDash.has)(targetElement, 'collapsed') || (0, _minDash.has)(targetElement, 'isExpanded'))) // property is explicitly set so use it
    targetCollapsed = (0, _minDash.has)(targetElement, 'collapsed') ? targetElement.collapsed : !targetElement.isExpanded;
    else // keep old state
    targetCollapsed = oldCollapsed;
    if (oldCollapsed !== targetCollapsed) return true;
    return false;
}
function BpmnReplace(bpmnFactory, elementFactory, moddleCopy, modeling, replace, rules, selection) {
    /**
   * Prepares a new business object for the replacement element
   * and triggers the replace operation.
   *
   * @param  {djs.model.Base} element
   * @param  {Object} target
   * @param  {Object} [hints]
   *
   * @return {djs.model.Base} the newly created element
   */ function replaceElement(element, target, hints) {
        hints = hints || {};
        var type = target.type, oldBusinessObject = element.businessObject;
        if (isSubProcess(oldBusinessObject) && type === 'bpmn:SubProcess') {
            if (shouldToggleCollapsed(element, target)) {
                // expanding or collapsing process
                modeling.toggleCollapse(element);
                return element;
            }
        }
        var newBusinessObject = bpmnFactory.create(type);
        var newElement = {
            type: type,
            businessObject: newBusinessObject
        };
        newElement.di = {};
        // colors will be set to DI
        copyProperties(element.di, newElement.di, [
            'fill',
            'stroke',
            'background-color',
            'border-color',
            'color'
        ]);
        var elementProps = (0, _moddleCopy.getPropertyNames)(oldBusinessObject.$descriptor), newElementProps = (0, _moddleCopy.getPropertyNames)(newBusinessObject.$descriptor, true), copyProps = intersection(elementProps, newElementProps);
        // initialize special properties defined in target definition
        (0, _minDash.assign)(newBusinessObject, (0, _minDash.pick)(target, CUSTOM_PROPERTIES));
        var properties = (0, _minDash.filter)(copyProps, function(propertyName) {
            // copying event definitions, unless we replace
            if (propertyName === 'eventDefinitions') return hasEventDefinition(element, target.eventDefinitionType);
            // retain loop characteristics if the target element
            // is not an event sub process
            if (propertyName === 'loopCharacteristics') return !(0, _diUtil.isEventSubProcess)(newBusinessObject);
            // so the applied properties from 'target' don't get lost
            if ((0, _minDash.has)(newBusinessObject, propertyName)) return false;
            if (propertyName === 'processRef' && target.isExpanded === false) return false;
            if (propertyName === 'triggeredByEvent') return false;
            return true;
        });
        newBusinessObject = moddleCopy.copyElement(oldBusinessObject, newBusinessObject, properties);
        // initialize custom BPMN extensions
        if (target.eventDefinitionType) // only initialize with new eventDefinition
        // if we did not set an event definition yet,
        // i.e. because we copied it
        {
            if (!hasEventDefinition(newBusinessObject, target.eventDefinitionType)) {
                newElement.eventDefinitionType = target.eventDefinitionType;
                newElement.eventDefinitionAttrs = target.eventDefinitionAttrs;
            }
        }
        if ((0, _modelUtil.is)(oldBusinessObject, 'bpmn:Activity')) {
            if (isSubProcess(oldBusinessObject)) // no toggeling, so keep old state
            newElement.isExpanded = (0, _diUtil.isExpanded)(element);
            else if (target && (0, _minDash.has)(target, 'isExpanded')) {
                newElement.isExpanded = target.isExpanded;
                // assign default size of new expanded element
                var defaultSize = elementFactory.getDefaultSize(newBusinessObject, {
                    isExpanded: newElement.isExpanded
                });
                newElement.width = defaultSize.width;
                newElement.height = defaultSize.height;
                // keep element centered
                newElement.x = element.x - (newElement.width - element.width) / 2;
                newElement.y = element.y - (newElement.height - element.height) / 2;
            }
            // TODO: need also to respect min/max Size
            // copy size, from an expanded subprocess to an expanded alternative subprocess
            // except bpmn:Task, because Task is always expanded
            if ((0, _diUtil.isExpanded)(element) && !(0, _modelUtil.is)(oldBusinessObject, 'bpmn:Task') && newElement.isExpanded) {
                newElement.width = element.width;
                newElement.height = element.height;
            }
        }
        // remove children if not expanding sub process
        if (isSubProcess(oldBusinessObject) && !isSubProcess(newBusinessObject)) hints.moveChildren = false;
        // transform collapsed/expanded pools
        if ((0, _modelUtil.is)(oldBusinessObject, 'bpmn:Participant')) {
            // create expanded pool
            if (target.isExpanded === true) newBusinessObject.processRef = bpmnFactory.create('bpmn:Process');
            else // remove children when transforming to collapsed pool
            hints.moveChildren = false;
            // apply same width and default height
            newElement.width = element.width;
            newElement.height = elementFactory.getDefaultSize(newElement).height;
        }
        if (!rules.allowed('shape.resize', {
            shape: newBusinessObject
        })) {
            newElement.height = elementFactory.getDefaultSize(newElement).height;
            newElement.width = elementFactory.getDefaultSize(newElement).width;
        }
        newBusinessObject.name = oldBusinessObject.name;
        // retain default flow's reference between inclusive <-> exclusive gateways and activities
        if ((0, _modelingUtil.isAny)(oldBusinessObject, [
            'bpmn:ExclusiveGateway',
            'bpmn:InclusiveGateway',
            'bpmn:Activity'
        ]) && (0, _modelingUtil.isAny)(newBusinessObject, [
            'bpmn:ExclusiveGateway',
            'bpmn:InclusiveGateway',
            'bpmn:Activity'
        ])) newBusinessObject.default = oldBusinessObject.default;
        if (target.host && !(0, _modelUtil.is)(oldBusinessObject, 'bpmn:BoundaryEvent') && (0, _modelUtil.is)(newBusinessObject, 'bpmn:BoundaryEvent')) newElement.host = target.host;
        // The DataStoreReference element is 14px wider than the DataObjectReference element
        // This ensures that they stay centered on the x axis when replaced
        if (newElement.type === 'bpmn:DataStoreReference' || newElement.type === 'bpmn:DataObjectReference') newElement.x = element.x + (element.width - newElement.width) / 2;
        newElement = replace.replaceElement(element, newElement, hints);
        if (hints.select !== false) selection.select(newElement);
        return newElement;
    }
    this.replaceElement = replaceElement;
}
BpmnReplace.$inject = [
    'bpmnFactory',
    'elementFactory',
    'moddleCopy',
    'modeling',
    'replace',
    'rules',
    'selection'
];
function isSubProcess(bo) {
    return (0, _modelUtil.is)(bo, 'bpmn:SubProcess');
}
function hasEventDefinition(element, type) {
    var bo = (0, _modelUtil.getBusinessObject)(element);
    return type && bo.get('eventDefinitions').some(function(definition) {
        return (0, _modelUtil.is)(definition, type);
    });
}
/**
 * Compute intersection between two arrays.
 */ function intersection(a1, a2) {
    return a1.filter(function(el) {
        return a2.indexOf(el) !== -1;
    });
}

},{"min-dash":"aEEla","../../util/ModelUtil":"klNYN","../modeling/util/ModelingUtil":"4DR1e","../../util/DiUtil":"krDFz","../copy-paste/ModdleCopy":"eiSLV","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eFjQf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ReplaceMenuProvider);
var _modelUtil = require("../../util/ModelUtil");
var _diUtil = require("../../util/DiUtil");
var _typeUtil = require("./util/TypeUtil");
var _minDash = require("min-dash");
var _replaceOptions = require("../replace/ReplaceOptions");
function ReplaceMenuProvider(bpmnFactory, popupMenu, modeling, moddle, bpmnReplace, rules, translate) {
    this._bpmnFactory = bpmnFactory;
    this._popupMenu = popupMenu;
    this._modeling = modeling;
    this._moddle = moddle;
    this._bpmnReplace = bpmnReplace;
    this._rules = rules;
    this._translate = translate;
    this.register();
}
ReplaceMenuProvider.$inject = [
    'bpmnFactory',
    'popupMenu',
    'modeling',
    'moddle',
    'bpmnReplace',
    'rules',
    'translate'
];
/**
 * Register replace menu provider in the popup menu
 */ ReplaceMenuProvider.prototype.register = function() {
    this._popupMenu.registerProvider('bpmn-replace', this);
};
/**
 * Get all entries from replaceOptions for the given element and apply filters
 * on them. Get for example only elements, which are different from the current one.
 *
 * @param {djs.model.Base} element
 *
 * @return {Array<Object>} a list of menu entry items
 */ ReplaceMenuProvider.prototype.getEntries = function(element) {
    var businessObject = element.businessObject;
    var rules = this._rules;
    var entries;
    if (!rules.allowed('shape.replace', {
        element: element
    })) return [];
    var differentType = (0, _typeUtil.isDifferentType)(element);
    if ((0, _modelUtil.is)(businessObject, 'bpmn:DataObjectReference')) return this._createEntries(element, _replaceOptions.DATA_OBJECT_REFERENCE);
    if ((0, _modelUtil.is)(businessObject, 'bpmn:DataStoreReference') && !(0, _modelUtil.is)(element.parent, 'bpmn:Collaboration')) return this._createEntries(element, _replaceOptions.DATA_STORE_REFERENCE);
    // start events outside sub processes
    if ((0, _modelUtil.is)(businessObject, 'bpmn:StartEvent') && !(0, _modelUtil.is)(businessObject.$parent, 'bpmn:SubProcess')) {
        entries = (0, _minDash.filter)(_replaceOptions.START_EVENT, differentType);
        return this._createEntries(element, entries);
    }
    // expanded/collapsed pools
    if ((0, _modelUtil.is)(businessObject, 'bpmn:Participant')) {
        entries = (0, _minDash.filter)(_replaceOptions.PARTICIPANT, function(entry) {
            return (0, _diUtil.isExpanded)(element) !== entry.target.isExpanded;
        });
        return this._createEntries(element, entries);
    }
    // start events inside event sub processes
    if ((0, _modelUtil.is)(businessObject, 'bpmn:StartEvent') && (0, _diUtil.isEventSubProcess)(businessObject.$parent)) {
        entries = (0, _minDash.filter)(_replaceOptions.EVENT_SUB_PROCESS_START_EVENT, function(entry) {
            var target = entry.target;
            var isInterrupting = target.isInterrupting !== false;
            var isInterruptingEqual = (0, _modelUtil.getBusinessObject)(element).isInterrupting === isInterrupting;
            // filters elements which types and event definition are equal but have have different interrupting types
            return differentType(entry) || !differentType(entry) && !isInterruptingEqual;
        });
        return this._createEntries(element, entries);
    }
    // start events inside sub processes
    if ((0, _modelUtil.is)(businessObject, 'bpmn:StartEvent') && !(0, _diUtil.isEventSubProcess)(businessObject.$parent) && (0, _modelUtil.is)(businessObject.$parent, 'bpmn:SubProcess')) {
        entries = (0, _minDash.filter)(_replaceOptions.START_EVENT_SUB_PROCESS, differentType);
        return this._createEntries(element, entries);
    }
    // end events
    if ((0, _modelUtil.is)(businessObject, 'bpmn:EndEvent')) {
        entries = (0, _minDash.filter)(_replaceOptions.END_EVENT, function(entry) {
            var target = entry.target;
            // hide cancel end events outside transactions
            if (target.eventDefinitionType == 'bpmn:CancelEventDefinition' && !(0, _modelUtil.is)(businessObject.$parent, 'bpmn:Transaction')) return false;
            return differentType(entry);
        });
        return this._createEntries(element, entries);
    }
    // boundary events
    if ((0, _modelUtil.is)(businessObject, 'bpmn:BoundaryEvent')) {
        entries = (0, _minDash.filter)(_replaceOptions.BOUNDARY_EVENT, function(entry) {
            var target = entry.target;
            if (target.eventDefinitionType == 'bpmn:CancelEventDefinition' && !(0, _modelUtil.is)(businessObject.attachedToRef, 'bpmn:Transaction')) return false;
            var cancelActivity = target.cancelActivity !== false;
            var isCancelActivityEqual = businessObject.cancelActivity == cancelActivity;
            return differentType(entry) || !differentType(entry) && !isCancelActivityEqual;
        });
        return this._createEntries(element, entries);
    }
    // intermediate events
    if ((0, _modelUtil.is)(businessObject, 'bpmn:IntermediateCatchEvent') || (0, _modelUtil.is)(businessObject, 'bpmn:IntermediateThrowEvent')) {
        entries = (0, _minDash.filter)(_replaceOptions.INTERMEDIATE_EVENT, differentType);
        return this._createEntries(element, entries);
    }
    // gateways
    if ((0, _modelUtil.is)(businessObject, 'bpmn:Gateway')) {
        entries = (0, _minDash.filter)(_replaceOptions.GATEWAY, differentType);
        return this._createEntries(element, entries);
    }
    // transactions
    if ((0, _modelUtil.is)(businessObject, 'bpmn:Transaction')) {
        entries = (0, _minDash.filter)(_replaceOptions.TRANSACTION, differentType);
        return this._createEntries(element, entries);
    }
    // expanded event sub processes
    if ((0, _diUtil.isEventSubProcess)(businessObject) && (0, _diUtil.isExpanded)(element)) {
        entries = (0, _minDash.filter)(_replaceOptions.EVENT_SUB_PROCESS, differentType);
        return this._createEntries(element, entries);
    }
    // expanded sub processes
    if ((0, _modelUtil.is)(businessObject, 'bpmn:SubProcess') && (0, _diUtil.isExpanded)(element)) {
        entries = (0, _minDash.filter)(_replaceOptions.SUBPROCESS_EXPANDED, differentType);
        return this._createEntries(element, entries);
    }
    // collapsed ad hoc sub processes
    if ((0, _modelUtil.is)(businessObject, 'bpmn:AdHocSubProcess') && !(0, _diUtil.isExpanded)(element)) {
        entries = (0, _minDash.filter)(_replaceOptions.TASK, function(entry) {
            var target = entry.target;
            var isTargetSubProcess = target.type === 'bpmn:SubProcess';
            var isTargetExpanded = target.isExpanded === true;
            return (0, _typeUtil.isDifferentType)(element, target) && (!isTargetSubProcess || isTargetExpanded);
        });
        return this._createEntries(element, entries);
    }
    // sequence flows
    if ((0, _modelUtil.is)(businessObject, 'bpmn:SequenceFlow')) return this._createSequenceFlowEntries(element, _replaceOptions.SEQUENCE_FLOW);
    // flow nodes
    if ((0, _modelUtil.is)(businessObject, 'bpmn:FlowNode')) {
        entries = (0, _minDash.filter)(_replaceOptions.TASK, differentType);
        // collapsed SubProcess can not be replaced with itself
        if ((0, _modelUtil.is)(businessObject, 'bpmn:SubProcess') && !(0, _diUtil.isExpanded)(element)) entries = (0, _minDash.filter)(entries, function(entry) {
            return entry.label !== 'Sub Process (collapsed)';
        });
        return this._createEntries(element, entries);
    }
    return [];
};
/**
 * Get a list of header items for the given element. This includes buttons
 * for multi instance markers and for the ad hoc marker.
 *
 * @param {djs.model.Base} element
 *
 * @return {Array<Object>} a list of menu entry items
 */ ReplaceMenuProvider.prototype.getHeaderEntries = function(element) {
    var headerEntries = [];
    if ((0, _modelUtil.is)(element, 'bpmn:Activity') && !(0, _diUtil.isEventSubProcess)(element)) headerEntries = headerEntries.concat(this._getLoopEntries(element));
    if ((0, _modelUtil.is)(element, 'bpmn:DataObjectReference')) headerEntries = headerEntries.concat(this._getDataObjectIsCollection(element));
    if ((0, _modelUtil.is)(element, 'bpmn:Participant')) headerEntries = headerEntries.concat(this._getParticipantMultiplicity(element));
    if ((0, _modelUtil.is)(element, 'bpmn:SubProcess') && !(0, _modelUtil.is)(element, 'bpmn:Transaction') && !(0, _diUtil.isEventSubProcess)(element)) headerEntries.push(this._getAdHocEntry(element));
    return headerEntries;
};
/**
 * Creates an array of menu entry objects for a given element and filters the replaceOptions
 * according to a filter function.
 *
 * @param  {djs.model.Base} element
 * @param  {Object} replaceOptions
 *
 * @return {Array<Object>} a list of menu items
 */ ReplaceMenuProvider.prototype._createEntries = function(element, replaceOptions) {
    var menuEntries = [];
    var self = this;
    (0, _minDash.forEach)(replaceOptions, function(definition) {
        var entry = self._createMenuEntry(definition, element);
        menuEntries.push(entry);
    });
    return menuEntries;
};
/**
 * Creates an array of menu entry objects for a given sequence flow.
 *
 * @param  {djs.model.Base} element
 * @param  {Object} replaceOptions

 * @return {Array<Object>} a list of menu items
 */ ReplaceMenuProvider.prototype._createSequenceFlowEntries = function(element, replaceOptions) {
    var businessObject = (0, _modelUtil.getBusinessObject)(element);
    var menuEntries = [];
    var modeling = this._modeling, moddle = this._moddle;
    var self = this;
    (0, _minDash.forEach)(replaceOptions, function(entry) {
        switch(entry.actionName){
            case 'replace-with-default-flow':
                if (businessObject.sourceRef.default !== businessObject && ((0, _modelUtil.is)(businessObject.sourceRef, 'bpmn:ExclusiveGateway') || (0, _modelUtil.is)(businessObject.sourceRef, 'bpmn:InclusiveGateway') || (0, _modelUtil.is)(businessObject.sourceRef, 'bpmn:ComplexGateway') || (0, _modelUtil.is)(businessObject.sourceRef, 'bpmn:Activity'))) menuEntries.push(self._createMenuEntry(entry, element, function() {
                    modeling.updateProperties(element.source, {
                        default: businessObject
                    });
                }));
                break;
            case 'replace-with-conditional-flow':
                if (!businessObject.conditionExpression && (0, _modelUtil.is)(businessObject.sourceRef, 'bpmn:Activity')) menuEntries.push(self._createMenuEntry(entry, element, function() {
                    var conditionExpression = moddle.create('bpmn:FormalExpression', {
                        body: ''
                    });
                    modeling.updateProperties(element, {
                        conditionExpression: conditionExpression
                    });
                }));
                break;
            default:
                // default flows
                if ((0, _modelUtil.is)(businessObject.sourceRef, 'bpmn:Activity') && businessObject.conditionExpression) return menuEntries.push(self._createMenuEntry(entry, element, function() {
                    modeling.updateProperties(element, {
                        conditionExpression: undefined
                    });
                }));
                // conditional flows
                if (((0, _modelUtil.is)(businessObject.sourceRef, 'bpmn:ExclusiveGateway') || (0, _modelUtil.is)(businessObject.sourceRef, 'bpmn:InclusiveGateway') || (0, _modelUtil.is)(businessObject.sourceRef, 'bpmn:ComplexGateway') || (0, _modelUtil.is)(businessObject.sourceRef, 'bpmn:Activity')) && businessObject.sourceRef.default === businessObject) return menuEntries.push(self._createMenuEntry(entry, element, function() {
                    modeling.updateProperties(element.source, {
                        default: undefined
                    });
                }));
        }
    });
    return menuEntries;
};
/**
 * Creates and returns a single menu entry item.
 *
 * @param  {Object} definition a single replace options definition object
 * @param  {djs.model.Base} element
 * @param  {Function} [action] an action callback function which gets called when
 *                             the menu entry is being triggered.
 *
 * @return {Object} menu entry item
 */ ReplaceMenuProvider.prototype._createMenuEntry = function(definition, element, action) {
    var translate = this._translate;
    var replaceElement = this._bpmnReplace.replaceElement;
    var replaceAction = function() {
        return replaceElement(element, definition.target);
    };
    var label = definition.label;
    if (label && typeof label === 'function') label = label(element);
    action = action || replaceAction;
    var menuEntry = {
        label: translate(label),
        className: definition.className,
        id: definition.actionName,
        action: action
    };
    return menuEntry;
};
/**
 * Get a list of menu items containing buttons for multi instance markers
 *
 * @param  {djs.model.Base} element
 *
 * @return {Array<Object>} a list of menu items
 */ ReplaceMenuProvider.prototype._getLoopEntries = function(element) {
    var self = this;
    var translate = this._translate;
    function toggleLoopEntry(event, entry) {
        var newLoopCharacteristics = (0, _modelUtil.getBusinessObject)(element).loopCharacteristics;
        if (entry.active) newLoopCharacteristics = undefined;
        else {
            if ((0, _minDash.isUndefined)(entry.options.isSequential) || !newLoopCharacteristics || !(0, _modelUtil.is)(newLoopCharacteristics, entry.options.loopCharacteristics)) newLoopCharacteristics = self._moddle.create(entry.options.loopCharacteristics);
            newLoopCharacteristics.isSequential = entry.options.isSequential;
        }
        self._modeling.updateProperties(element, {
            loopCharacteristics: newLoopCharacteristics
        });
    }
    var businessObject = (0, _modelUtil.getBusinessObject)(element), loopCharacteristics = businessObject.loopCharacteristics;
    var isSequential, isLoop, isParallel;
    if (loopCharacteristics) {
        isSequential = loopCharacteristics.isSequential;
        isLoop = loopCharacteristics.isSequential === undefined;
        isParallel = loopCharacteristics.isSequential !== undefined && !loopCharacteristics.isSequential;
    }
    var loopEntries = [
        {
            id: 'toggle-parallel-mi',
            className: 'bpmn-icon-parallel-mi-marker',
            title: translate('Parallel Multi Instance'),
            active: isParallel,
            action: toggleLoopEntry,
            options: {
                loopCharacteristics: 'bpmn:MultiInstanceLoopCharacteristics',
                isSequential: false
            }
        },
        {
            id: 'toggle-sequential-mi',
            className: 'bpmn-icon-sequential-mi-marker',
            title: translate('Sequential Multi Instance'),
            active: isSequential,
            action: toggleLoopEntry,
            options: {
                loopCharacteristics: 'bpmn:MultiInstanceLoopCharacteristics',
                isSequential: true
            }
        },
        {
            id: 'toggle-loop',
            className: 'bpmn-icon-loop-marker',
            title: translate('Loop'),
            active: isLoop,
            action: toggleLoopEntry,
            options: {
                loopCharacteristics: 'bpmn:StandardLoopCharacteristics'
            }
        }
    ];
    return loopEntries;
};
/**
 * Get a list of menu items containing a button for the collection marker
 *
 * @param  {djs.model.Base} element
 *
 * @return {Array<Object>} a list of menu items
 */ ReplaceMenuProvider.prototype._getDataObjectIsCollection = function(element) {
    var self = this;
    var translate = this._translate;
    var dataObject = element.businessObject.dataObjectRef;
    if (!dataObject) return [];
    function toggleIsCollection(event, entry) {
        self._modeling.updateModdleProperties(element, dataObject, {
            isCollection: !entry.active
        });
    }
    var isCollection = dataObject.isCollection;
    var dataObjectEntries = [
        {
            id: 'toggle-is-collection',
            className: 'bpmn-icon-parallel-mi-marker',
            title: translate('Collection'),
            active: isCollection,
            action: toggleIsCollection
        }
    ];
    return dataObjectEntries;
};
/**
 * Get a list of menu items containing a button for the participant multiplicity marker
 *
 * @param  {djs.model.Base} element
 *
 * @return {Array<Object>} a list of menu items
 */ ReplaceMenuProvider.prototype._getParticipantMultiplicity = function(element) {
    var self = this;
    var bpmnFactory = this._bpmnFactory;
    var translate = this._translate;
    function toggleParticipantMultiplicity(event, entry) {
        var isActive = entry.active;
        var participantMultiplicity;
        if (!isActive) participantMultiplicity = bpmnFactory.create('bpmn:ParticipantMultiplicity');
        self._modeling.updateProperties(element, {
            participantMultiplicity: participantMultiplicity
        });
    }
    var participantMultiplicity = element.businessObject.participantMultiplicity;
    var participantEntries = [
        {
            id: 'toggle-participant-multiplicity',
            className: 'bpmn-icon-parallel-mi-marker',
            title: translate('Participant Multiplicity'),
            active: !!participantMultiplicity,
            action: toggleParticipantMultiplicity
        }
    ];
    return participantEntries;
};
/**
 * Get the menu items containing a button for the ad hoc marker
 *
 * @param  {djs.model.Base} element
 *
 * @return {Object} a menu item
 */ ReplaceMenuProvider.prototype._getAdHocEntry = function(element) {
    var translate = this._translate;
    var businessObject = (0, _modelUtil.getBusinessObject)(element);
    var isAdHoc = (0, _modelUtil.is)(businessObject, 'bpmn:AdHocSubProcess');
    var replaceElement = this._bpmnReplace.replaceElement;
    var adHocEntry = {
        id: 'toggle-adhoc',
        className: 'bpmn-icon-ad-hoc-marker',
        title: translate('Ad-hoc'),
        active: isAdHoc,
        action: function(event, entry) {
            if (isAdHoc) return replaceElement(element, {
                type: 'bpmn:SubProcess'
            }, {
                autoResize: false,
                layoutConnection: false
            });
            else return replaceElement(element, {
                type: 'bpmn:AdHocSubProcess'
            }, {
                autoResize: false,
                layoutConnection: false
            });
        }
    };
    return adHocEntry;
};

},{"../../util/ModelUtil":"klNYN","../../util/DiUtil":"krDFz","./util/TypeUtil":"1udZr","min-dash":"aEEla","../replace/ReplaceOptions":"74rVf","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1udZr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns true, if an element is from a different type
 * than a target definition. Takes into account the type,
 * event definition type and triggeredByEvent property.
 *
 * @param {djs.model.Base} element
 *
 * @return {boolean}
 */ parcelHelpers.export(exports, "isDifferentType", ()=>isDifferentType);
var _modelUtil = require("../../../util/ModelUtil");
var _diUtil = require("../../../util/DiUtil");
function isDifferentType(element) {
    return function(entry) {
        var target = entry.target;
        var businessObject = (0, _modelUtil.getBusinessObject)(element), eventDefinition = businessObject.eventDefinitions && businessObject.eventDefinitions[0];
        var isTypeEqual = businessObject.$type === target.type;
        var isEventDefinitionEqual = (eventDefinition && eventDefinition.$type) === target.eventDefinitionType;
        var isTriggeredByEventEqual = // coherse to <false>
        !!target.triggeredByEvent === !!businessObject.triggeredByEvent;
        var isExpandedEqual = target.isExpanded === undefined || target.isExpanded === (0, _diUtil.isExpanded)(element);
        return !isTypeEqual || !isEventDefinitionEqual || !isTriggeredByEventEqual || !isExpandedEqual;
    };
}

},{"../../../util/ModelUtil":"klNYN","../../../util/DiUtil":"krDFz","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"74rVf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "START_EVENT", ()=>START_EVENT);
parcelHelpers.export(exports, "START_EVENT_SUB_PROCESS", ()=>START_EVENT_SUB_PROCESS);
parcelHelpers.export(exports, "INTERMEDIATE_EVENT", ()=>INTERMEDIATE_EVENT);
parcelHelpers.export(exports, "END_EVENT", ()=>END_EVENT);
parcelHelpers.export(exports, "GATEWAY", ()=>GATEWAY);
parcelHelpers.export(exports, "SUBPROCESS_EXPANDED", ()=>SUBPROCESS_EXPANDED);
parcelHelpers.export(exports, "TRANSACTION", ()=>TRANSACTION);
parcelHelpers.export(exports, "EVENT_SUB_PROCESS", ()=>EVENT_SUB_PROCESS);
parcelHelpers.export(exports, "TASK", ()=>TASK);
parcelHelpers.export(exports, "DATA_OBJECT_REFERENCE", ()=>DATA_OBJECT_REFERENCE);
parcelHelpers.export(exports, "DATA_STORE_REFERENCE", ()=>DATA_STORE_REFERENCE);
parcelHelpers.export(exports, "BOUNDARY_EVENT", ()=>BOUNDARY_EVENT);
parcelHelpers.export(exports, "EVENT_SUB_PROCESS_START_EVENT", ()=>EVENT_SUB_PROCESS_START_EVENT);
parcelHelpers.export(exports, "SEQUENCE_FLOW", ()=>SEQUENCE_FLOW);
parcelHelpers.export(exports, "PARTICIPANT", ()=>PARTICIPANT);
var START_EVENT = [
    {
        label: 'Start Event',
        actionName: 'replace-with-none-start',
        className: 'bpmn-icon-start-event-none',
        target: {
            type: 'bpmn:StartEvent'
        }
    },
    {
        label: 'Intermediate Throw Event',
        actionName: 'replace-with-none-intermediate-throwing',
        className: 'bpmn-icon-intermediate-event-none',
        target: {
            type: 'bpmn:IntermediateThrowEvent'
        }
    },
    {
        label: 'End Event',
        actionName: 'replace-with-none-end',
        className: 'bpmn-icon-end-event-none',
        target: {
            type: 'bpmn:EndEvent'
        }
    },
    {
        label: 'Message Start Event',
        actionName: 'replace-with-message-start',
        className: 'bpmn-icon-start-event-message',
        target: {
            type: 'bpmn:StartEvent',
            eventDefinitionType: 'bpmn:MessageEventDefinition'
        }
    },
    {
        label: 'Timer Start Event',
        actionName: 'replace-with-timer-start',
        className: 'bpmn-icon-start-event-timer',
        target: {
            type: 'bpmn:StartEvent',
            eventDefinitionType: 'bpmn:TimerEventDefinition'
        }
    },
    {
        label: 'Conditional Start Event',
        actionName: 'replace-with-conditional-start',
        className: 'bpmn-icon-start-event-condition',
        target: {
            type: 'bpmn:StartEvent',
            eventDefinitionType: 'bpmn:ConditionalEventDefinition'
        }
    },
    {
        label: 'Signal Start Event',
        actionName: 'replace-with-signal-start',
        className: 'bpmn-icon-start-event-signal',
        target: {
            type: 'bpmn:StartEvent',
            eventDefinitionType: 'bpmn:SignalEventDefinition'
        }
    }
];
var START_EVENT_SUB_PROCESS = [
    {
        label: 'Start Event',
        actionName: 'replace-with-none-start',
        className: 'bpmn-icon-start-event-none',
        target: {
            type: 'bpmn:StartEvent'
        }
    },
    {
        label: 'Intermediate Throw Event',
        actionName: 'replace-with-none-intermediate-throwing',
        className: 'bpmn-icon-intermediate-event-none',
        target: {
            type: 'bpmn:IntermediateThrowEvent'
        }
    },
    {
        label: 'End Event',
        actionName: 'replace-with-none-end',
        className: 'bpmn-icon-end-event-none',
        target: {
            type: 'bpmn:EndEvent'
        }
    }
];
var INTERMEDIATE_EVENT = [
    {
        label: 'Start Event',
        actionName: 'replace-with-none-start',
        className: 'bpmn-icon-start-event-none',
        target: {
            type: 'bpmn:StartEvent'
        }
    },
    {
        label: 'Intermediate Throw Event',
        actionName: 'replace-with-none-intermediate-throw',
        className: 'bpmn-icon-intermediate-event-none',
        target: {
            type: 'bpmn:IntermediateThrowEvent'
        }
    },
    {
        label: 'End Event',
        actionName: 'replace-with-none-end',
        className: 'bpmn-icon-end-event-none',
        target: {
            type: 'bpmn:EndEvent'
        }
    },
    {
        label: 'Message Intermediate Catch Event',
        actionName: 'replace-with-message-intermediate-catch',
        className: 'bpmn-icon-intermediate-event-catch-message',
        target: {
            type: 'bpmn:IntermediateCatchEvent',
            eventDefinitionType: 'bpmn:MessageEventDefinition'
        }
    },
    {
        label: 'Message Intermediate Throw Event',
        actionName: 'replace-with-message-intermediate-throw',
        className: 'bpmn-icon-intermediate-event-throw-message',
        target: {
            type: 'bpmn:IntermediateThrowEvent',
            eventDefinitionType: 'bpmn:MessageEventDefinition'
        }
    },
    {
        label: 'Timer Intermediate Catch Event',
        actionName: 'replace-with-timer-intermediate-catch',
        className: 'bpmn-icon-intermediate-event-catch-timer',
        target: {
            type: 'bpmn:IntermediateCatchEvent',
            eventDefinitionType: 'bpmn:TimerEventDefinition'
        }
    },
    {
        label: 'Escalation Intermediate Throw Event',
        actionName: 'replace-with-escalation-intermediate-throw',
        className: 'bpmn-icon-intermediate-event-throw-escalation',
        target: {
            type: 'bpmn:IntermediateThrowEvent',
            eventDefinitionType: 'bpmn:EscalationEventDefinition'
        }
    },
    {
        label: 'Conditional Intermediate Catch Event',
        actionName: 'replace-with-conditional-intermediate-catch',
        className: 'bpmn-icon-intermediate-event-catch-condition',
        target: {
            type: 'bpmn:IntermediateCatchEvent',
            eventDefinitionType: 'bpmn:ConditionalEventDefinition'
        }
    },
    {
        label: 'Link Intermediate Catch Event',
        actionName: 'replace-with-link-intermediate-catch',
        className: 'bpmn-icon-intermediate-event-catch-link',
        target: {
            type: 'bpmn:IntermediateCatchEvent',
            eventDefinitionType: 'bpmn:LinkEventDefinition',
            eventDefinitionAttrs: {
                name: ''
            }
        }
    },
    {
        label: 'Link Intermediate Throw Event',
        actionName: 'replace-with-link-intermediate-throw',
        className: 'bpmn-icon-intermediate-event-throw-link',
        target: {
            type: 'bpmn:IntermediateThrowEvent',
            eventDefinitionType: 'bpmn:LinkEventDefinition',
            eventDefinitionAttrs: {
                name: ''
            }
        }
    },
    {
        label: 'Compensation Intermediate Throw Event',
        actionName: 'replace-with-compensation-intermediate-throw',
        className: 'bpmn-icon-intermediate-event-throw-compensation',
        target: {
            type: 'bpmn:IntermediateThrowEvent',
            eventDefinitionType: 'bpmn:CompensateEventDefinition'
        }
    },
    {
        label: 'Signal Intermediate Catch Event',
        actionName: 'replace-with-signal-intermediate-catch',
        className: 'bpmn-icon-intermediate-event-catch-signal',
        target: {
            type: 'bpmn:IntermediateCatchEvent',
            eventDefinitionType: 'bpmn:SignalEventDefinition'
        }
    },
    {
        label: 'Signal Intermediate Throw Event',
        actionName: 'replace-with-signal-intermediate-throw',
        className: 'bpmn-icon-intermediate-event-throw-signal',
        target: {
            type: 'bpmn:IntermediateThrowEvent',
            eventDefinitionType: 'bpmn:SignalEventDefinition'
        }
    }
];
var END_EVENT = [
    {
        label: 'Start Event',
        actionName: 'replace-with-none-start',
        className: 'bpmn-icon-start-event-none',
        target: {
            type: 'bpmn:StartEvent'
        }
    },
    {
        label: 'Intermediate Throw Event',
        actionName: 'replace-with-none-intermediate-throw',
        className: 'bpmn-icon-intermediate-event-none',
        target: {
            type: 'bpmn:IntermediateThrowEvent'
        }
    },
    {
        label: 'End Event',
        actionName: 'replace-with-none-end',
        className: 'bpmn-icon-end-event-none',
        target: {
            type: 'bpmn:EndEvent'
        }
    },
    {
        label: 'Message End Event',
        actionName: 'replace-with-message-end',
        className: 'bpmn-icon-end-event-message',
        target: {
            type: 'bpmn:EndEvent',
            eventDefinitionType: 'bpmn:MessageEventDefinition'
        }
    },
    {
        label: 'Escalation End Event',
        actionName: 'replace-with-escalation-end',
        className: 'bpmn-icon-end-event-escalation',
        target: {
            type: 'bpmn:EndEvent',
            eventDefinitionType: 'bpmn:EscalationEventDefinition'
        }
    },
    {
        label: 'Error End Event',
        actionName: 'replace-with-error-end',
        className: 'bpmn-icon-end-event-error',
        target: {
            type: 'bpmn:EndEvent',
            eventDefinitionType: 'bpmn:ErrorEventDefinition'
        }
    },
    {
        label: 'Cancel End Event',
        actionName: 'replace-with-cancel-end',
        className: 'bpmn-icon-end-event-cancel',
        target: {
            type: 'bpmn:EndEvent',
            eventDefinitionType: 'bpmn:CancelEventDefinition'
        }
    },
    {
        label: 'Compensation End Event',
        actionName: 'replace-with-compensation-end',
        className: 'bpmn-icon-end-event-compensation',
        target: {
            type: 'bpmn:EndEvent',
            eventDefinitionType: 'bpmn:CompensateEventDefinition'
        }
    },
    {
        label: 'Signal End Event',
        actionName: 'replace-with-signal-end',
        className: 'bpmn-icon-end-event-signal',
        target: {
            type: 'bpmn:EndEvent',
            eventDefinitionType: 'bpmn:SignalEventDefinition'
        }
    },
    {
        label: 'Terminate End Event',
        actionName: 'replace-with-terminate-end',
        className: 'bpmn-icon-end-event-terminate',
        target: {
            type: 'bpmn:EndEvent',
            eventDefinitionType: 'bpmn:TerminateEventDefinition'
        }
    }
];
var GATEWAY = [
    {
        label: 'Exclusive Gateway',
        actionName: 'replace-with-exclusive-gateway',
        className: 'bpmn-icon-gateway-xor',
        target: {
            type: 'bpmn:ExclusiveGateway'
        }
    },
    {
        label: 'Parallel Gateway',
        actionName: 'replace-with-parallel-gateway',
        className: 'bpmn-icon-gateway-parallel',
        target: {
            type: 'bpmn:ParallelGateway'
        }
    },
    {
        label: 'Inclusive Gateway',
        actionName: 'replace-with-inclusive-gateway',
        className: 'bpmn-icon-gateway-or',
        target: {
            type: 'bpmn:InclusiveGateway'
        }
    },
    {
        label: 'Complex Gateway',
        actionName: 'replace-with-complex-gateway',
        className: 'bpmn-icon-gateway-complex',
        target: {
            type: 'bpmn:ComplexGateway'
        }
    },
    {
        label: 'Event based Gateway',
        actionName: 'replace-with-event-based-gateway',
        className: 'bpmn-icon-gateway-eventbased',
        target: {
            type: 'bpmn:EventBasedGateway',
            instantiate: false,
            eventGatewayType: 'Exclusive'
        }
    }
];
var SUBPROCESS_EXPANDED = [
    {
        label: 'Transaction',
        actionName: 'replace-with-transaction',
        className: 'bpmn-icon-transaction',
        target: {
            type: 'bpmn:Transaction',
            isExpanded: true
        }
    },
    {
        label: 'Event Sub Process',
        actionName: 'replace-with-event-subprocess',
        className: 'bpmn-icon-event-subprocess-expanded',
        target: {
            type: 'bpmn:SubProcess',
            triggeredByEvent: true,
            isExpanded: true
        }
    },
    {
        label: 'Sub Process (collapsed)',
        actionName: 'replace-with-collapsed-subprocess',
        className: 'bpmn-icon-subprocess-collapsed',
        target: {
            type: 'bpmn:SubProcess',
            isExpanded: false
        }
    }
];
var TRANSACTION = [
    {
        label: 'Transaction',
        actionName: 'replace-with-transaction',
        className: 'bpmn-icon-transaction',
        target: {
            type: 'bpmn:Transaction',
            isExpanded: true
        }
    },
    {
        label: 'Sub Process',
        actionName: 'replace-with-subprocess',
        className: 'bpmn-icon-subprocess-expanded',
        target: {
            type: 'bpmn:SubProcess',
            isExpanded: true
        }
    },
    {
        label: 'Event Sub Process',
        actionName: 'replace-with-event-subprocess',
        className: 'bpmn-icon-event-subprocess-expanded',
        target: {
            type: 'bpmn:SubProcess',
            triggeredByEvent: true,
            isExpanded: true
        }
    }
];
var EVENT_SUB_PROCESS = TRANSACTION;
var TASK = [
    {
        label: 'Task',
        actionName: 'replace-with-task',
        className: 'bpmn-icon-task',
        target: {
            type: 'bpmn:Task'
        }
    },
    {
        label: 'User Task',
        actionName: 'replace-with-user-task',
        className: 'bpmn-icon-user',
        target: {
            type: 'bpmn:UserTask'
        }
    },
    {
        label: 'Service Task',
        actionName: 'replace-with-service-task',
        className: 'bpmn-icon-service',
        target: {
            type: 'bpmn:ServiceTask'
        }
    },
    {
        label: 'Send Task',
        actionName: 'replace-with-send-task',
        className: 'bpmn-icon-send',
        target: {
            type: 'bpmn:SendTask'
        }
    },
    {
        label: 'Receive Task',
        actionName: 'replace-with-receive-task',
        className: 'bpmn-icon-receive',
        target: {
            type: 'bpmn:ReceiveTask'
        }
    },
    {
        label: 'Manual Task',
        actionName: 'replace-with-manual-task',
        className: 'bpmn-icon-manual',
        target: {
            type: 'bpmn:ManualTask'
        }
    },
    {
        label: 'Business Rule Task',
        actionName: 'replace-with-rule-task',
        className: 'bpmn-icon-business-rule',
        target: {
            type: 'bpmn:BusinessRuleTask'
        }
    },
    {
        label: 'Script Task',
        actionName: 'replace-with-script-task',
        className: 'bpmn-icon-script',
        target: {
            type: 'bpmn:ScriptTask'
        }
    },
    {
        label: 'Call Activity',
        actionName: 'replace-with-call-activity',
        className: 'bpmn-icon-call-activity',
        target: {
            type: 'bpmn:CallActivity'
        }
    },
    {
        label: 'Sub Process (collapsed)',
        actionName: 'replace-with-collapsed-subprocess',
        className: 'bpmn-icon-subprocess-collapsed',
        target: {
            type: 'bpmn:SubProcess',
            isExpanded: false
        }
    },
    {
        label: 'Sub Process (expanded)',
        actionName: 'replace-with-expanded-subprocess',
        className: 'bpmn-icon-subprocess-expanded',
        target: {
            type: 'bpmn:SubProcess',
            isExpanded: true
        }
    }
];
var DATA_OBJECT_REFERENCE = [
    {
        label: 'Data Store Reference',
        actionName: 'replace-with-data-store-reference',
        className: 'bpmn-icon-data-store',
        target: {
            type: 'bpmn:DataStoreReference'
        }
    }
];
var DATA_STORE_REFERENCE = [
    {
        label: 'Data Object Reference',
        actionName: 'replace-with-data-object-reference',
        className: 'bpmn-icon-data-object',
        target: {
            type: 'bpmn:DataObjectReference'
        }
    }
];
var BOUNDARY_EVENT = [
    {
        label: 'Message Boundary Event',
        actionName: 'replace-with-message-boundary',
        className: 'bpmn-icon-intermediate-event-catch-message',
        target: {
            type: 'bpmn:BoundaryEvent',
            eventDefinitionType: 'bpmn:MessageEventDefinition'
        }
    },
    {
        label: 'Timer Boundary Event',
        actionName: 'replace-with-timer-boundary',
        className: 'bpmn-icon-intermediate-event-catch-timer',
        target: {
            type: 'bpmn:BoundaryEvent',
            eventDefinitionType: 'bpmn:TimerEventDefinition'
        }
    },
    {
        label: 'Escalation Boundary Event',
        actionName: 'replace-with-escalation-boundary',
        className: 'bpmn-icon-intermediate-event-catch-escalation',
        target: {
            type: 'bpmn:BoundaryEvent',
            eventDefinitionType: 'bpmn:EscalationEventDefinition'
        }
    },
    {
        label: 'Conditional Boundary Event',
        actionName: 'replace-with-conditional-boundary',
        className: 'bpmn-icon-intermediate-event-catch-condition',
        target: {
            type: 'bpmn:BoundaryEvent',
            eventDefinitionType: 'bpmn:ConditionalEventDefinition'
        }
    },
    {
        label: 'Error Boundary Event',
        actionName: 'replace-with-error-boundary',
        className: 'bpmn-icon-intermediate-event-catch-error',
        target: {
            type: 'bpmn:BoundaryEvent',
            eventDefinitionType: 'bpmn:ErrorEventDefinition'
        }
    },
    {
        label: 'Cancel Boundary Event',
        actionName: 'replace-with-cancel-boundary',
        className: 'bpmn-icon-intermediate-event-catch-cancel',
        target: {
            type: 'bpmn:BoundaryEvent',
            eventDefinitionType: 'bpmn:CancelEventDefinition'
        }
    },
    {
        label: 'Signal Boundary Event',
        actionName: 'replace-with-signal-boundary',
        className: 'bpmn-icon-intermediate-event-catch-signal',
        target: {
            type: 'bpmn:BoundaryEvent',
            eventDefinitionType: 'bpmn:SignalEventDefinition'
        }
    },
    {
        label: 'Compensation Boundary Event',
        actionName: 'replace-with-compensation-boundary',
        className: 'bpmn-icon-intermediate-event-catch-compensation',
        target: {
            type: 'bpmn:BoundaryEvent',
            eventDefinitionType: 'bpmn:CompensateEventDefinition'
        }
    },
    {
        label: 'Message Boundary Event (non-interrupting)',
        actionName: 'replace-with-non-interrupting-message-boundary',
        className: 'bpmn-icon-intermediate-event-catch-non-interrupting-message',
        target: {
            type: 'bpmn:BoundaryEvent',
            eventDefinitionType: 'bpmn:MessageEventDefinition',
            cancelActivity: false
        }
    },
    {
        label: 'Timer Boundary Event (non-interrupting)',
        actionName: 'replace-with-non-interrupting-timer-boundary',
        className: 'bpmn-icon-intermediate-event-catch-non-interrupting-timer',
        target: {
            type: 'bpmn:BoundaryEvent',
            eventDefinitionType: 'bpmn:TimerEventDefinition',
            cancelActivity: false
        }
    },
    {
        label: 'Escalation Boundary Event (non-interrupting)',
        actionName: 'replace-with-non-interrupting-escalation-boundary',
        className: 'bpmn-icon-intermediate-event-catch-non-interrupting-escalation',
        target: {
            type: 'bpmn:BoundaryEvent',
            eventDefinitionType: 'bpmn:EscalationEventDefinition',
            cancelActivity: false
        }
    },
    {
        label: 'Conditional Boundary Event (non-interrupting)',
        actionName: 'replace-with-non-interrupting-conditional-boundary',
        className: 'bpmn-icon-intermediate-event-catch-non-interrupting-condition',
        target: {
            type: 'bpmn:BoundaryEvent',
            eventDefinitionType: 'bpmn:ConditionalEventDefinition',
            cancelActivity: false
        }
    },
    {
        label: 'Signal Boundary Event (non-interrupting)',
        actionName: 'replace-with-non-interrupting-signal-boundary',
        className: 'bpmn-icon-intermediate-event-catch-non-interrupting-signal',
        target: {
            type: 'bpmn:BoundaryEvent',
            eventDefinitionType: 'bpmn:SignalEventDefinition',
            cancelActivity: false
        }
    }
];
var EVENT_SUB_PROCESS_START_EVENT = [
    {
        label: 'Message Start Event',
        actionName: 'replace-with-message-start',
        className: 'bpmn-icon-start-event-message',
        target: {
            type: 'bpmn:StartEvent',
            eventDefinitionType: 'bpmn:MessageEventDefinition'
        }
    },
    {
        label: 'Timer Start Event',
        actionName: 'replace-with-timer-start',
        className: 'bpmn-icon-start-event-timer',
        target: {
            type: 'bpmn:StartEvent',
            eventDefinitionType: 'bpmn:TimerEventDefinition'
        }
    },
    {
        label: 'Conditional Start Event',
        actionName: 'replace-with-conditional-start',
        className: 'bpmn-icon-start-event-condition',
        target: {
            type: 'bpmn:StartEvent',
            eventDefinitionType: 'bpmn:ConditionalEventDefinition'
        }
    },
    {
        label: 'Signal Start Event',
        actionName: 'replace-with-signal-start',
        className: 'bpmn-icon-start-event-signal',
        target: {
            type: 'bpmn:StartEvent',
            eventDefinitionType: 'bpmn:SignalEventDefinition'
        }
    },
    {
        label: 'Error Start Event',
        actionName: 'replace-with-error-start',
        className: 'bpmn-icon-start-event-error',
        target: {
            type: 'bpmn:StartEvent',
            eventDefinitionType: 'bpmn:ErrorEventDefinition'
        }
    },
    {
        label: 'Escalation Start Event',
        actionName: 'replace-with-escalation-start',
        className: 'bpmn-icon-start-event-escalation',
        target: {
            type: 'bpmn:StartEvent',
            eventDefinitionType: 'bpmn:EscalationEventDefinition'
        }
    },
    {
        label: 'Compensation Start Event',
        actionName: 'replace-with-compensation-start',
        className: 'bpmn-icon-start-event-compensation',
        target: {
            type: 'bpmn:StartEvent',
            eventDefinitionType: 'bpmn:CompensateEventDefinition'
        }
    },
    {
        label: 'Message Start Event (non-interrupting)',
        actionName: 'replace-with-non-interrupting-message-start',
        className: 'bpmn-icon-start-event-non-interrupting-message',
        target: {
            type: 'bpmn:StartEvent',
            eventDefinitionType: 'bpmn:MessageEventDefinition',
            isInterrupting: false
        }
    },
    {
        label: 'Timer Start Event (non-interrupting)',
        actionName: 'replace-with-non-interrupting-timer-start',
        className: 'bpmn-icon-start-event-non-interrupting-timer',
        target: {
            type: 'bpmn:StartEvent',
            eventDefinitionType: 'bpmn:TimerEventDefinition',
            isInterrupting: false
        }
    },
    {
        label: 'Conditional Start Event (non-interrupting)',
        actionName: 'replace-with-non-interrupting-conditional-start',
        className: 'bpmn-icon-start-event-non-interrupting-condition',
        target: {
            type: 'bpmn:StartEvent',
            eventDefinitionType: 'bpmn:ConditionalEventDefinition',
            isInterrupting: false
        }
    },
    {
        label: 'Signal Start Event (non-interrupting)',
        actionName: 'replace-with-non-interrupting-signal-start',
        className: 'bpmn-icon-start-event-non-interrupting-signal',
        target: {
            type: 'bpmn:StartEvent',
            eventDefinitionType: 'bpmn:SignalEventDefinition',
            isInterrupting: false
        }
    },
    {
        label: 'Escalation Start Event (non-interrupting)',
        actionName: 'replace-with-non-interrupting-escalation-start',
        className: 'bpmn-icon-start-event-non-interrupting-escalation',
        target: {
            type: 'bpmn:StartEvent',
            eventDefinitionType: 'bpmn:EscalationEventDefinition',
            isInterrupting: false
        }
    }
];
var SEQUENCE_FLOW = [
    {
        label: 'Sequence Flow',
        actionName: 'replace-with-sequence-flow',
        className: 'bpmn-icon-connection'
    },
    {
        label: 'Default Flow',
        actionName: 'replace-with-default-flow',
        className: 'bpmn-icon-default-flow'
    },
    {
        label: 'Conditional Flow',
        actionName: 'replace-with-conditional-flow',
        className: 'bpmn-icon-conditional-flow'
    }
];
var PARTICIPANT = [
    {
        label: 'Expanded Pool',
        actionName: 'replace-with-expanded-pool',
        className: 'bpmn-icon-participant',
        target: {
            type: 'bpmn:Participant',
            isExpanded: true
        }
    },
    {
        label: function(element) {
            var label = 'Empty Pool';
            if (element.children && element.children.length) label += ' (removes content)';
            return label;
        },
        actionName: 'replace-with-collapsed-pool',
        // TODO(@janstuemmel): maybe design new icon
        className: 'bpmn-icon-lane',
        target: {
            type: 'bpmn:Participant',
            isExpanded: false
        }
    }
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fSx3A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ContextPadProvider);
var _minDash = require("min-dash");
var _modelUtil = require("../../util/ModelUtil");
var _diUtil = require("../../util/DiUtil");
var _modelingUtil = require("../modeling/util/ModelingUtil");
var _laneUtil = require("../modeling/util/LaneUtil");
var _mouse = require("diagram-js/lib/util/Mouse");
function ContextPadProvider(config, injector, eventBus, contextPad, modeling, elementFactory, connect, create, popupMenu, canvas, rules, translate) {
    config = config || {};
    contextPad.registerProvider(this);
    this._contextPad = contextPad;
    this._modeling = modeling;
    this._elementFactory = elementFactory;
    this._connect = connect;
    this._create = create;
    this._popupMenu = popupMenu;
    this._canvas = canvas;
    this._rules = rules;
    this._translate = translate;
    if (config.autoPlace !== false) this._autoPlace = injector.get('autoPlace', false);
    eventBus.on('create.end', 250, function(event) {
        var context = event.context, shape = context.shape;
        if (!(0, _mouse.hasPrimaryModifier)(event) || !contextPad.isOpen(shape)) return;
        var entries = contextPad.getEntries(shape);
        if (entries.replace) entries.replace.action.click(event, shape);
    });
}
ContextPadProvider.$inject = [
    'config.contextPad',
    'injector',
    'eventBus',
    'contextPad',
    'modeling',
    'elementFactory',
    'connect',
    'create',
    'popupMenu',
    'canvas',
    'rules',
    'translate'
];
ContextPadProvider.prototype.getMultiElementContextPadEntries = function(elements) {
    var modeling = this._modeling;
    var actions = {};
    if (this._isDeleteAllowed(elements)) (0, _minDash.assign)(actions, {
        'delete': {
            group: 'edit',
            className: 'bpmn-icon-trash',
            title: this._translate('Remove'),
            action: {
                click: function(event, elements) {
                    modeling.removeElements(elements.slice());
                }
            }
        }
    });
    return actions;
};
/**
 * @param {djs.model.Base[]} elements
 * @return {boolean}
 */ ContextPadProvider.prototype._isDeleteAllowed = function(elements) {
    var baseAllowed = this._rules.allowed('elements.delete', {
        elements: elements
    });
    if ((0, _minDash.isArray)(baseAllowed)) return (0, _minDash.every)(baseAllowed, function(element) {
        return includes(baseAllowed, element);
    });
    return baseAllowed;
};
ContextPadProvider.prototype.getContextPadEntries = function(element) {
    var contextPad = this._contextPad, modeling = this._modeling, elementFactory = this._elementFactory, connect = this._connect, create = this._create, popupMenu = this._popupMenu, rules = this._rules, autoPlace = this._autoPlace, translate = this._translate;
    var actions = {};
    if (element.type === 'label') return actions;
    var businessObject = element.businessObject;
    function startConnect(event, element) {
        connect.start(event, element);
    }
    function removeElement(e, element) {
        modeling.removeElements([
            element
        ]);
    }
    function getReplaceMenuPosition(element) {
        var Y_OFFSET = 5;
        var pad = contextPad.getPad(element).html;
        var padRect = pad.getBoundingClientRect();
        var pos = {
            x: padRect.left,
            y: padRect.bottom + Y_OFFSET
        };
        return pos;
    }
    /**
   * Create an append action
   *
   * @param {string} type
   * @param {string} className
   * @param {string} [title]
   * @param {Object} [options]
   *
   * @return {Object} descriptor
   */ function appendAction(type, className, title, options) {
        if (typeof title !== 'string') {
            options = title;
            title = translate('Append {type}', {
                type: type.replace(/^bpmn:/, '')
            });
        }
        function appendStart(event, element) {
            var shape = elementFactory.createShape((0, _minDash.assign)({
                type: type
            }, options));
            create.start(event, shape, {
                source: element
            });
        }
        var append = autoPlace ? function(event, element) {
            var shape = elementFactory.createShape((0, _minDash.assign)({
                type: type
            }, options));
            autoPlace.append(element, shape);
        } : appendStart;
        return {
            group: 'model',
            className: className,
            title: title,
            action: {
                dragstart: appendStart,
                click: append
            }
        };
    }
    function splitLaneHandler(count) {
        return function(event, element) {
            // actual split
            modeling.splitLane(element, count);
            // refresh context pad after split to
            // get rid of split icons
            contextPad.open(element, true);
        };
    }
    if ((0, _modelingUtil.isAny)(businessObject, [
        'bpmn:Lane',
        'bpmn:Participant'
    ]) && (0, _diUtil.isExpanded)(element)) {
        var childLanes = (0, _laneUtil.getChildLanes)(element);
        (0, _minDash.assign)(actions, {
            'lane-insert-above': {
                group: 'lane-insert-above',
                className: 'bpmn-icon-lane-insert-above',
                title: translate('Add Lane above'),
                action: {
                    click: function(event, element) {
                        modeling.addLane(element, 'top');
                    }
                }
            }
        });
        if (childLanes.length < 2) {
            if (element.height >= 120) (0, _minDash.assign)(actions, {
                'lane-divide-two': {
                    group: 'lane-divide',
                    className: 'bpmn-icon-lane-divide-two',
                    title: translate('Divide into two Lanes'),
                    action: {
                        click: splitLaneHandler(2)
                    }
                }
            });
            if (element.height >= 180) (0, _minDash.assign)(actions, {
                'lane-divide-three': {
                    group: 'lane-divide',
                    className: 'bpmn-icon-lane-divide-three',
                    title: translate('Divide into three Lanes'),
                    action: {
                        click: splitLaneHandler(3)
                    }
                }
            });
        }
        (0, _minDash.assign)(actions, {
            'lane-insert-below': {
                group: 'lane-insert-below',
                className: 'bpmn-icon-lane-insert-below',
                title: translate('Add Lane below'),
                action: {
                    click: function(event, element) {
                        modeling.addLane(element, 'bottom');
                    }
                }
            }
        });
    }
    if ((0, _modelUtil.is)(businessObject, 'bpmn:FlowNode')) {
        if ((0, _modelUtil.is)(businessObject, 'bpmn:EventBasedGateway')) (0, _minDash.assign)(actions, {
            'append.receive-task': appendAction('bpmn:ReceiveTask', 'bpmn-icon-receive-task', translate('Append ReceiveTask')),
            'append.message-intermediate-event': appendAction('bpmn:IntermediateCatchEvent', 'bpmn-icon-intermediate-event-catch-message', translate('Append MessageIntermediateCatchEvent'), {
                eventDefinitionType: 'bpmn:MessageEventDefinition'
            }),
            'append.timer-intermediate-event': appendAction('bpmn:IntermediateCatchEvent', 'bpmn-icon-intermediate-event-catch-timer', translate('Append TimerIntermediateCatchEvent'), {
                eventDefinitionType: 'bpmn:TimerEventDefinition'
            }),
            'append.condition-intermediate-event': appendAction('bpmn:IntermediateCatchEvent', 'bpmn-icon-intermediate-event-catch-condition', translate('Append ConditionIntermediateCatchEvent'), {
                eventDefinitionType: 'bpmn:ConditionalEventDefinition'
            }),
            'append.signal-intermediate-event': appendAction('bpmn:IntermediateCatchEvent', 'bpmn-icon-intermediate-event-catch-signal', translate('Append SignalIntermediateCatchEvent'), {
                eventDefinitionType: 'bpmn:SignalEventDefinition'
            })
        });
        else if (isEventType(businessObject, 'bpmn:BoundaryEvent', 'bpmn:CompensateEventDefinition')) (0, _minDash.assign)(actions, {
            'append.compensation-activity': appendAction('bpmn:Task', 'bpmn-icon-task', translate('Append compensation activity'), {
                isForCompensation: true
            })
        });
        else if (!(0, _modelUtil.is)(businessObject, 'bpmn:EndEvent') && !businessObject.isForCompensation && !isEventType(businessObject, 'bpmn:IntermediateThrowEvent', 'bpmn:LinkEventDefinition') && !(0, _diUtil.isEventSubProcess)(businessObject)) (0, _minDash.assign)(actions, {
            'append.end-event': appendAction('bpmn:EndEvent', 'bpmn-icon-end-event-none', translate('Append EndEvent')),
            'append.gateway': appendAction('bpmn:ExclusiveGateway', 'bpmn-icon-gateway-none', translate('Append Gateway')),
            'append.append-task': appendAction('bpmn:Task', 'bpmn-icon-task', translate('Append Task')),
            'append.intermediate-event': appendAction('bpmn:IntermediateThrowEvent', 'bpmn-icon-intermediate-event-none', translate('Append Intermediate/Boundary Event'))
        });
    }
    if (!popupMenu.isEmpty(element, 'bpmn-replace')) // Replace menu entry
    (0, _minDash.assign)(actions, {
        'replace': {
            group: 'edit',
            className: 'bpmn-icon-screw-wrench',
            title: translate('Change type'),
            action: {
                click: function(event, element) {
                    var position = (0, _minDash.assign)(getReplaceMenuPosition(element), {
                        cursor: {
                            x: event.x,
                            y: event.y
                        }
                    });
                    popupMenu.open(element, 'bpmn-replace', position, {
                        title: translate('Change element'),
                        width: 300,
                        search: true
                    });
                }
            }
        }
    });
    if ((0, _modelUtil.is)(businessObject, 'bpmn:SequenceFlow')) (0, _minDash.assign)(actions, {
        'append.text-annotation': appendAction('bpmn:TextAnnotation', 'bpmn-icon-text-annotation')
    });
    if ((0, _modelingUtil.isAny)(businessObject, [
        'bpmn:FlowNode',
        'bpmn:InteractionNode',
        'bpmn:DataObjectReference',
        'bpmn:DataStoreReference'
    ])) (0, _minDash.assign)(actions, {
        'append.text-annotation': appendAction('bpmn:TextAnnotation', 'bpmn-icon-text-annotation'),
        'connect': {
            group: 'connect',
            className: 'bpmn-icon-connection-multi',
            title: translate('Connect using ' + (businessObject.isForCompensation ? '' : 'Sequence/MessageFlow or ') + 'Association'),
            action: {
                click: startConnect,
                dragstart: startConnect
            }
        }
    });
    if ((0, _modelUtil.is)(businessObject, 'bpmn:TextAnnotation')) (0, _minDash.assign)(actions, {
        'connect': {
            group: 'connect',
            className: 'bpmn-icon-connection-multi',
            title: translate('Connect using Association'),
            action: {
                click: startConnect,
                dragstart: startConnect
            }
        }
    });
    if ((0, _modelingUtil.isAny)(businessObject, [
        'bpmn:DataObjectReference',
        'bpmn:DataStoreReference'
    ])) (0, _minDash.assign)(actions, {
        'connect': {
            group: 'connect',
            className: 'bpmn-icon-connection-multi',
            title: translate('Connect using DataInputAssociation'),
            action: {
                click: startConnect,
                dragstart: startConnect
            }
        }
    });
    if ((0, _modelUtil.is)(businessObject, 'bpmn:Group')) (0, _minDash.assign)(actions, {
        'append.text-annotation': appendAction('bpmn:TextAnnotation', 'bpmn-icon-text-annotation')
    });
    // delete element entry, only show if allowed by rules
    var deleteAllowed = rules.allowed('elements.delete', {
        elements: [
            element
        ]
    });
    if ((0, _minDash.isArray)(deleteAllowed)) // was the element returned as a deletion candidate?
    deleteAllowed = deleteAllowed[0] === element;
    if (deleteAllowed) (0, _minDash.assign)(actions, {
        'delete': {
            group: 'edit',
            className: 'bpmn-icon-trash',
            title: translate('Remove'),
            action: {
                click: removeElement
            }
        }
    });
    return actions;
};
// helpers /////////
function isEventType(eventBo, type, definition) {
    var isType = eventBo.$instanceOf(type);
    var isDefinition = false;
    var definitions = eventBo.eventDefinitions || [];
    (0, _minDash.forEach)(definitions, function(def) {
        if (def.$type === definition) isDefinition = true;
    });
    return isType && isDefinition;
}
function includes(array, item) {
    return array.indexOf(item) !== -1;
}

},{"min-dash":"aEEla","../../util/ModelUtil":"klNYN","../../util/DiUtil":"krDFz","../modeling/util/ModelingUtil":"4DR1e","../modeling/util/LaneUtil":"fECqQ","diagram-js/lib/util/Mouse":"9MyMy","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fECqQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LANE_INDENTATION", ()=>LANE_INDENTATION);
/**
 * Collect all lane shapes in the given paren
 *
 * @param  {djs.model.Shape} shape
 * @param  {Array<djs.model.Base>} [collectedShapes]
 *
 * @return {Array<djs.model.Base>}
 */ parcelHelpers.export(exports, "collectLanes", ()=>collectLanes);
/**
 * Return the lane children of the given element.
 *
 * @param {djs.model.Shape} shape
 *
 * @return {Array<djs.model.Shape>}
 */ parcelHelpers.export(exports, "getChildLanes", ()=>getChildLanes);
/**
 * Return the root element containing the given lane shape
 *
 * @param {djs.model.Shape} shape
 *
 * @return {djs.model.Shape}
 */ parcelHelpers.export(exports, "getLanesRoot", ()=>getLanesRoot);
/**
 * Compute the required resize operations for lanes
 * adjacent to the given shape, assuming it will be
 * resized to the given new bounds.
 *
 * @param {djs.model.Shape} shape
 * @param {Bounds} newBounds
 *
 * @return {Array<Object>}
 */ parcelHelpers.export(exports, "computeLanesResize", ()=>computeLanesResize);
var _modelUtil = require("../../../util/ModelUtil");
var _modelingUtil = require("./ModelingUtil");
var _layoutUtil = require("diagram-js/lib/layout/LayoutUtil");
var _resizeUtil = require("diagram-js/lib/features/resize/ResizeUtil");
var abs = Math.abs;
function getTRBLResize(oldBounds, newBounds) {
    return (0, _resizeUtil.substractTRBL)((0, _layoutUtil.asTRBL)(newBounds), (0, _layoutUtil.asTRBL)(oldBounds));
}
var LANE_PARENTS = [
    'bpmn:Participant',
    'bpmn:Process',
    'bpmn:SubProcess'
];
var LANE_INDENTATION = 30;
function collectLanes(shape, collectedShapes) {
    collectedShapes = collectedShapes || [];
    shape.children.filter(function(s) {
        if ((0, _modelUtil.is)(s, 'bpmn:Lane')) {
            collectLanes(s, collectedShapes);
            collectedShapes.push(s);
        }
    });
    return collectedShapes;
}
function getChildLanes(shape) {
    return shape.children.filter(function(c) {
        return (0, _modelUtil.is)(c, 'bpmn:Lane');
    });
}
function getLanesRoot(shape) {
    return (0, _modelingUtil.getParent)(shape, LANE_PARENTS) || shape;
}
function computeLanesResize(shape, newBounds) {
    var rootElement = getLanesRoot(shape);
    var initialShapes = (0, _modelUtil.is)(rootElement, 'bpmn:Process') ? [] : [
        rootElement
    ];
    var allLanes = collectLanes(rootElement, initialShapes), shapeTrbl = (0, _layoutUtil.asTRBL)(shape), shapeNewTrbl = (0, _layoutUtil.asTRBL)(newBounds), trblResize = getTRBLResize(shape, newBounds), resizeNeeded = [];
    allLanes.forEach(function(other) {
        if (other === shape) return;
        var topResize = 0, rightResize = trblResize.right, bottomResize = 0, leftResize = trblResize.left;
        var otherTrbl = (0, _layoutUtil.asTRBL)(other);
        if (trblResize.top) {
            if (abs(otherTrbl.bottom - shapeTrbl.top) < 10) bottomResize = shapeNewTrbl.top - otherTrbl.bottom;
            if (abs(otherTrbl.top - shapeTrbl.top) < 5) topResize = shapeNewTrbl.top - otherTrbl.top;
        }
        if (trblResize.bottom) {
            if (abs(otherTrbl.top - shapeTrbl.bottom) < 10) topResize = shapeNewTrbl.bottom - otherTrbl.top;
            if (abs(otherTrbl.bottom - shapeTrbl.bottom) < 5) bottomResize = shapeNewTrbl.bottom - otherTrbl.bottom;
        }
        if (topResize || rightResize || bottomResize || leftResize) resizeNeeded.push({
            shape: other,
            newBounds: (0, _resizeUtil.resizeTRBL)(other, {
                top: topResize,
                right: rightResize,
                bottom: bottomResize,
                left: leftResize
            })
        });
    });
    return resizeNeeded;
}

},{"../../../util/ModelUtil":"klNYN","./ModelingUtil":"4DR1e","diagram-js/lib/layout/LayoutUtil":"4CCrs","diagram-js/lib/features/resize/ResizeUtil":"gKMgs","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gKMgs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @typedef {import('../../model').Base} Base
 * @typedef {import('../../model').Shape} Shape
 *
 * @typedef {import('../../util/Types').Direction} Direction
 * @typedef {import('../../util/Types').Rect} Rect
 * @typedef {import('../../util/Types').RectTRBL} RectTRBL
 */ /**
 * Substract a TRBL from another
 *
 * @param {RectTRBL} trblA
 * @param {RectTRBL} trblB
 *
 * @return {RectTRBL}
 */ parcelHelpers.export(exports, "substractTRBL", ()=>substractTRBL);
/**
 * Resize the given bounds by the specified delta from a given anchor point.
 *
 * @param {Rect} bounds the bounding box that should be resized
 * @param {Direction} direction in which the element is resized (nw, ne, se, sw)
 * @param {Point} delta of the resize operation
 *
 * @return {Rect} resized bounding box
 */ parcelHelpers.export(exports, "resizeBounds", ()=>resizeBounds);
/**
 * Resize the given bounds by applying the passed
 * { top, right, bottom, left } delta.
 *
 * @param {Rect} bounds
 * @param {RectTRBL} trblResize
 *
 * @return {Rect}
 */ parcelHelpers.export(exports, "resizeTRBL", ()=>resizeTRBL);
parcelHelpers.export(exports, "reattachPoint", ()=>reattachPoint);
parcelHelpers.export(exports, "ensureConstraints", ()=>ensureConstraints);
parcelHelpers.export(exports, "getMinResizeBounds", ()=>getMinResizeBounds);
parcelHelpers.export(exports, "addPadding", ()=>addPadding);
/**
 * Return children bounding computed from a shapes children
 * or a list of prefiltered children.
 *
 * @param {Shape|Shape[]} shapeOrChildren
 * @param {RectTRBL|number} padding
 *
 * @return {Rect}
 */ parcelHelpers.export(exports, "computeChildrenBBox", ()=>computeChildrenBBox);
var _minDash = require("min-dash");
var _elements = require("../../util/Elements");
var _layoutUtil = require("../../layout/LayoutUtil");
var max = Math.max, min = Math.min;
var DEFAULT_CHILD_BOX_PADDING = 20;
function substractTRBL(trblA, trblB) {
    return {
        top: trblA.top - trblB.top,
        right: trblA.right - trblB.right,
        bottom: trblA.bottom - trblB.bottom,
        left: trblA.left - trblB.left
    };
}
function resizeBounds(bounds, direction, delta) {
    var dx = delta.x, dy = delta.y;
    var newBounds = {
        x: bounds.x,
        y: bounds.y,
        width: bounds.width,
        height: bounds.height
    };
    if (direction.indexOf('n') !== -1) {
        newBounds.y = bounds.y + dy;
        newBounds.height = bounds.height - dy;
    } else if (direction.indexOf('s') !== -1) newBounds.height = bounds.height + dy;
    if (direction.indexOf('e') !== -1) newBounds.width = bounds.width + dx;
    else if (direction.indexOf('w') !== -1) {
        newBounds.x = bounds.x + dx;
        newBounds.width = bounds.width - dx;
    }
    return newBounds;
}
function resizeTRBL(bounds, resize) {
    return {
        x: bounds.x + (resize.left || 0),
        y: bounds.y + (resize.top || 0),
        width: bounds.width - (resize.left || 0) + (resize.right || 0),
        height: bounds.height - (resize.top || 0) + (resize.bottom || 0)
    };
}
function reattachPoint(bounds, newBounds, point) {
    var sx = bounds.width / newBounds.width, sy = bounds.height / newBounds.height;
    return {
        x: Math.round(newBounds.x + newBounds.width / 2) - Math.floor((bounds.x + bounds.width / 2 - point.x) / sx),
        y: Math.round(newBounds.y + newBounds.height / 2) - Math.floor((bounds.y + bounds.height / 2 - point.y) / sy)
    };
}
function applyConstraints(attr, trbl, resizeConstraints) {
    var value = trbl[attr], minValue = resizeConstraints.min && resizeConstraints.min[attr], maxValue = resizeConstraints.max && resizeConstraints.max[attr];
    if ((0, _minDash.isNumber)(minValue)) value = (/top|left/.test(attr) ? min : max)(value, minValue);
    if ((0, _minDash.isNumber)(maxValue)) value = (/top|left/.test(attr) ? max : min)(value, maxValue);
    return value;
}
function ensureConstraints(currentBounds, resizeConstraints) {
    if (!resizeConstraints) return currentBounds;
    var currentTrbl = (0, _layoutUtil.asTRBL)(currentBounds);
    return (0, _layoutUtil.asBounds)({
        top: applyConstraints('top', currentTrbl, resizeConstraints),
        right: applyConstraints('right', currentTrbl, resizeConstraints),
        bottom: applyConstraints('bottom', currentTrbl, resizeConstraints),
        left: applyConstraints('left', currentTrbl, resizeConstraints)
    });
}
function getMinResizeBounds(direction, currentBounds, minDimensions, childrenBounds) {
    var currentBox = (0, _layoutUtil.asTRBL)(currentBounds);
    var minBox = {
        top: /n/.test(direction) ? currentBox.bottom - minDimensions.height : currentBox.top,
        left: /w/.test(direction) ? currentBox.right - minDimensions.width : currentBox.left,
        bottom: /s/.test(direction) ? currentBox.top + minDimensions.height : currentBox.bottom,
        right: /e/.test(direction) ? currentBox.left + minDimensions.width : currentBox.right
    };
    var childrenBox = childrenBounds ? (0, _layoutUtil.asTRBL)(childrenBounds) : minBox;
    var combinedBox = {
        top: min(minBox.top, childrenBox.top),
        left: min(minBox.left, childrenBox.left),
        bottom: max(minBox.bottom, childrenBox.bottom),
        right: max(minBox.right, childrenBox.right)
    };
    return (0, _layoutUtil.asBounds)(combinedBox);
}
function asPadding(mayBePadding, defaultValue) {
    if (typeof mayBePadding !== 'undefined') return mayBePadding;
    else return DEFAULT_CHILD_BOX_PADDING;
}
function addPadding(bbox, padding) {
    var left, right, top, bottom;
    if (typeof padding === 'object') {
        left = asPadding(padding.left);
        right = asPadding(padding.right);
        top = asPadding(padding.top);
        bottom = asPadding(padding.bottom);
    } else left = right = top = bottom = asPadding(padding);
    return {
        x: bbox.x - left,
        y: bbox.y - top,
        width: bbox.width + left + right,
        height: bbox.height + top + bottom
    };
}
/**
 * Is the given element part of the resize
 * targets min boundary box?
 *
 * This is the default implementation which excludes
 * connections and labels.
 *
 * @param {Base} element
 */ function isBBoxChild(element) {
    // exclude connections
    if (element.waypoints) return false;
    // exclude labels
    if (element.type === 'label') return false;
    return true;
}
function computeChildrenBBox(shapeOrChildren, padding) {
    var elements;
    // compute based on shape
    if (shapeOrChildren.length === undefined) // grab all the children that are part of the
    // parents children box
    elements = (0, _minDash.filter)(shapeOrChildren.children, isBBoxChild);
    else elements = shapeOrChildren;
    if (elements.length) return addPadding((0, _elements.getBBox)(elements), padding);
}

},{"min-dash":"aEEla","../../util/Elements":"6qdtl","../../layout/LayoutUtil":"4CCrs","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kSkj8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _popupMenu = require("diagram-js/lib/features/popup-menu");
var _popupMenuDefault = parcelHelpers.interopDefault(_popupMenu);
var _palette = require("diagram-js/lib/features/palette");
var _paletteDefault = parcelHelpers.interopDefault(_palette);
var _autoPlace = require("diagram-js/lib/features/auto-place");
var _autoPlaceDefault = parcelHelpers.interopDefault(_autoPlace);
var _contextPad = require("diagram-js/lib/features/context-pad");
var _contextPadDefault = parcelHelpers.interopDefault(_contextPad);
var _createMenuProvider = require("./CreateMenuProvider");
var _createMenuProviderDefault = parcelHelpers.interopDefault(_createMenuProvider);
var _createPaletteProvider = require("./CreatePaletteProvider");
var _createPaletteProviderDefault = parcelHelpers.interopDefault(_createPaletteProvider);
var _createAppendEditorActions = require("./CreateAppendEditorActions");
var _createAppendEditorActionsDefault = parcelHelpers.interopDefault(_createAppendEditorActions);
var _createAppendKeyboardBindings = require("./CreateAppendKeyboardBindings");
var _createAppendKeyboardBindingsDefault = parcelHelpers.interopDefault(_createAppendKeyboardBindings);
var _appendMenuProvider = require("./AppendMenuProvider");
var _appendMenuProviderDefault = parcelHelpers.interopDefault(_appendMenuProvider);
var _appendContextPadProvider = require("./AppendContextPadProvider");
var _appendContextPadProviderDefault = parcelHelpers.interopDefault(_appendContextPadProvider);
var _appendRules = require("./AppendRules");
var _appendRulesDefault = parcelHelpers.interopDefault(_appendRules);
exports.default = {
    __depends__: [
        (0, _paletteDefault.default),
        (0, _popupMenuDefault.default),
        (0, _autoPlaceDefault.default),
        (0, _contextPadDefault.default)
    ],
    __init__: [
        'createMenuProvider',
        'createPaletteProvider',
        'createAppendEditorActions',
        'createAppendKeyboardBindings',
        'appendMenuProvider',
        'appendContextPadProvider',
        'appendRules'
    ],
    createMenuProvider: [
        'type',
        (0, _createMenuProviderDefault.default)
    ],
    createPaletteProvider: [
        'type',
        (0, _createPaletteProviderDefault.default)
    ],
    createAppendEditorActions: [
        'type',
        (0, _createAppendEditorActionsDefault.default)
    ],
    createAppendKeyboardBindings: [
        'type',
        (0, _createAppendKeyboardBindingsDefault.default)
    ],
    appendMenuProvider: [
        'type',
        (0, _appendMenuProviderDefault.default)
    ],
    appendContextPadProvider: [
        'type',
        (0, _appendContextPadProviderDefault.default)
    ],
    appendRules: [
        'type',
        (0, _appendRulesDefault.default)
    ]
};

},{"diagram-js/lib/features/popup-menu":"iRpNh","diagram-js/lib/features/palette":"e4Zt0","diagram-js/lib/features/auto-place":"6jJG3","diagram-js/lib/features/context-pad":"ktSXO","./CreateMenuProvider":"aNGhX","./CreatePaletteProvider":"ctehy","./CreateAppendEditorActions":"xDC7G","./CreateAppendKeyboardBindings":"1YoYr","./AppendMenuProvider":"VOOxR","./AppendContextPadProvider":"41ILd","./AppendRules":"bWzHf","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"e4Zt0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _palette = require("./Palette");
var _paletteDefault = parcelHelpers.interopDefault(_palette);
exports.default = {
    __init__: [
        'palette'
    ],
    palette: [
        'type',
        (0, _paletteDefault.default)
    ]
};

},{"./Palette":"c9lnl","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"c9lnl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Palette);
var _minDash = require("min-dash");
var _minDom = require("min-dom");
var _escapeUtil = require("../../util/EscapeUtil");
/**
 * @typedef {import('../../core/Canvas').default} Canvas
 * @typedef {import('../../core/EventBus').default} EventBus
 */ var TOGGLE_SELECTOR = '.djs-palette-toggle', ENTRY_SELECTOR = '.entry', ELEMENT_SELECTOR = TOGGLE_SELECTOR + ', ' + ENTRY_SELECTOR;
var PALETTE_PREFIX = 'djs-palette-', PALETTE_SHOWN_CLS = 'shown', PALETTE_OPEN_CLS = 'open', PALETTE_TWO_COLUMN_CLS = 'two-column';
var DEFAULT_PRIORITY = 1000;
function Palette(eventBus, canvas) {
    this._eventBus = eventBus;
    this._canvas = canvas;
    var self = this;
    eventBus.on('tool-manager.update', function(event) {
        var tool = event.tool;
        self.updateToolHighlight(tool);
    });
    eventBus.on('i18n.changed', function() {
        self._update();
    });
    eventBus.on('diagram.init', function() {
        self._diagramInitialized = true;
        self._rebuild();
    });
}
Palette.$inject = [
    'eventBus',
    'canvas'
];
/**
 * Register a provider with the palette
 *
 * @param {number} [priority=1000]
 * @param {PaletteProvider} provider
 *
 * @example
 * const paletteProvider = {
 *   getPaletteEntries: function() {
 *     return function(entries) {
 *       return {
 *         ...entries,
 *         'entry-1': {
 *           label: 'My Entry',
 *           action: function() { alert("I have been clicked!"); }
 *         }
 *       };
 *     }
 *   }
 * };
 *
 * palette.registerProvider(800, paletteProvider);
 */ Palette.prototype.registerProvider = function(priority, provider) {
    if (!provider) {
        provider = priority;
        priority = DEFAULT_PRIORITY;
    }
    this._eventBus.on('palette.getProviders', priority, function(event) {
        event.providers.push(provider);
    });
    this._rebuild();
};
/**
 * Returns the palette entries
 *
 * @return {Object<string, PaletteEntryDescriptor>} map of entries
 */ Palette.prototype.getEntries = function() {
    var providers = this._getProviders();
    return providers.reduce(addPaletteEntries, {});
};
Palette.prototype._rebuild = function() {
    if (!this._diagramInitialized) return;
    var providers = this._getProviders();
    if (!providers.length) return;
    if (!this._container) this._init();
    this._update();
};
/**
 * Initialize
 */ Palette.prototype._init = function() {
    var self = this;
    var eventBus = this._eventBus;
    var parentContainer = this._getParentContainer();
    var container = this._container = (0, _minDom.domify)(Palette.HTML_MARKUP);
    parentContainer.appendChild(container);
    (0, _minDom.classes)(parentContainer).add(PALETTE_PREFIX + PALETTE_SHOWN_CLS);
    (0, _minDom.delegate).bind(container, ELEMENT_SELECTOR, 'click', function(event) {
        var target = event.delegateTarget;
        if ((0, _minDom.matches)(target, TOGGLE_SELECTOR)) return self.toggle();
        self.trigger('click', event);
    });
    // prevent drag propagation
    (0, _minDom.event).bind(container, 'mousedown', function(event) {
        event.stopPropagation();
    });
    // prevent drag propagation
    (0, _minDom.delegate).bind(container, ENTRY_SELECTOR, 'dragstart', function(event) {
        self.trigger('dragstart', event);
    });
    eventBus.on('canvas.resized', this._layoutChanged, this);
    eventBus.fire('palette.create', {
        container: container
    });
};
Palette.prototype._getProviders = function(id) {
    var event = this._eventBus.createEvent({
        type: 'palette.getProviders',
        providers: []
    });
    this._eventBus.fire(event);
    return event.providers;
};
/**
 * Update palette state.
 *
 * @param {Object} [state] { open, twoColumn }
 */ Palette.prototype._toggleState = function(state) {
    state = state || {};
    var parent = this._getParentContainer(), container = this._container;
    var eventBus = this._eventBus;
    var twoColumn;
    var cls = (0, _minDom.classes)(container), parentCls = (0, _minDom.classes)(parent);
    if ('twoColumn' in state) twoColumn = state.twoColumn;
    else twoColumn = this._needsCollapse(parent.clientHeight, this._entries || {});
    // always update two column
    cls.toggle(PALETTE_TWO_COLUMN_CLS, twoColumn);
    parentCls.toggle(PALETTE_PREFIX + PALETTE_TWO_COLUMN_CLS, twoColumn);
    if ('open' in state) {
        cls.toggle(PALETTE_OPEN_CLS, state.open);
        parentCls.toggle(PALETTE_PREFIX + PALETTE_OPEN_CLS, state.open);
    }
    eventBus.fire('palette.changed', {
        twoColumn: twoColumn,
        open: this.isOpen()
    });
};
Palette.prototype._update = function() {
    var entriesContainer = (0, _minDom.query)('.djs-palette-entries', this._container), entries = this._entries = this.getEntries();
    (0, _minDom.clear)(entriesContainer);
    (0, _minDash.forEach)(entries, function(entry, id) {
        var grouping = entry.group || 'default';
        var container = (0, _minDom.query)('[data-group=' + (0, _escapeUtil.escapeCSS)(grouping) + ']', entriesContainer);
        if (!container) {
            container = (0, _minDom.domify)('<div class="group"></div>');
            (0, _minDom.attr)(container, 'data-group', grouping);
            entriesContainer.appendChild(container);
        }
        var html = entry.html || (entry.separator ? '<hr class="separator" />' : '<div class="entry" draggable="true"></div>');
        var control = (0, _minDom.domify)(html);
        container.appendChild(control);
        if (!entry.separator) {
            (0, _minDom.attr)(control, 'data-action', id);
            if (entry.title) (0, _minDom.attr)(control, 'title', entry.title);
            if (entry.className) addClasses(control, entry.className);
            if (entry.imageUrl) {
                var image = (0, _minDom.domify)('<img>');
                (0, _minDom.attr)(image, 'src', entry.imageUrl);
                control.appendChild(image);
            }
        }
    });
    // open after update
    this.open();
};
/**
 * Trigger an action available on the palette
 *
 * @param {string} action
 * @param {Event} event
 */ Palette.prototype.trigger = function(action, event, autoActivate) {
    var entry, originalEvent, button = event.delegateTarget || event.target;
    if (!button) return event.preventDefault();
    entry = (0, _minDom.attr)(button, 'data-action');
    originalEvent = event.originalEvent || event;
    return this.triggerEntry(entry, action, originalEvent, autoActivate);
};
Palette.prototype.triggerEntry = function(entryId, action, event, autoActivate) {
    var entries = this._entries, entry, handler;
    entry = entries[entryId];
    // when user clicks on the palette and not on an action
    if (!entry) return;
    handler = entry.action;
    if (this._eventBus.fire('palette.trigger', {
        entry,
        event
    }) === false) return;
    // simple action (via callback function)
    if ((0, _minDash.isFunction)(handler)) {
        if (action === 'click') return handler(event, autoActivate);
    } else {
        if (handler[action]) return handler[action](event, autoActivate);
    }
    // silence other actions
    event.preventDefault();
};
Palette.prototype._layoutChanged = function() {
    this._toggleState({});
};
/**
 * Do we need to collapse to two columns?
 *
 * @param {number} availableHeight
 * @param {Object} entries
 *
 * @return {boolean}
 */ Palette.prototype._needsCollapse = function(availableHeight, entries) {
    // top margin + bottom toggle + bottom margin
    // implementors must override this method if they
    // change the palette styles
    var margin = 50;
    var entriesHeight = Object.keys(entries).length * 46;
    return availableHeight < entriesHeight + margin;
};
/**
 * Close the palette
 */ Palette.prototype.close = function() {
    this._toggleState({
        open: false,
        twoColumn: false
    });
};
/**
 * Open the palette
 */ Palette.prototype.open = function() {
    this._toggleState({
        open: true
    });
};
Palette.prototype.toggle = function(open) {
    if (this.isOpen()) this.close();
    else this.open();
};
Palette.prototype.isActiveTool = function(tool) {
    return tool && this._activeTool === tool;
};
Palette.prototype.updateToolHighlight = function(name) {
    var entriesContainer, toolsContainer;
    if (!this._toolsContainer) {
        entriesContainer = (0, _minDom.query)('.djs-palette-entries', this._container);
        this._toolsContainer = (0, _minDom.query)('[data-group=tools]', entriesContainer);
    }
    toolsContainer = this._toolsContainer;
    (0, _minDash.forEach)(toolsContainer.children, function(tool) {
        var actionName = tool.getAttribute('data-action');
        if (!actionName) return;
        var toolClasses = (0, _minDom.classes)(tool);
        actionName = actionName.replace('-tool', '');
        if (toolClasses.contains('entry') && actionName === name) toolClasses.add('highlighted-entry');
        else toolClasses.remove('highlighted-entry');
    });
};
/**
 * Return true if the palette is opened.
 *
 * @example
 *
 * palette.open();
 *
 * if (palette.isOpen()) {
 *   // yes, we are open
 * }
 *
 * @return {boolean} true if palette is opened
 */ Palette.prototype.isOpen = function() {
    return (0, _minDom.classes)(this._container).has(PALETTE_OPEN_CLS);
};
/**
 * Get container the palette lives in.
 *
 * @return {Element}
 */ Palette.prototype._getParentContainer = function() {
    return this._canvas.getContainer();
};
/* markup definition */ Palette.HTML_MARKUP = '<div class="djs-palette"><div class="djs-palette-entries"></div><div class="djs-palette-toggle"></div></div>';
// helpers //////////////////////
function addClasses(element, classNames) {
    var classes = (0, _minDom.classes)(element);
    var actualClassNames = (0, _minDash.isArray)(classNames) ? classNames : classNames.split(/\s+/g);
    actualClassNames.forEach(function(cls) {
        classes.add(cls);
    });
}
function addPaletteEntries(entries, provider) {
    var entriesOrUpdater = provider.getPaletteEntries();
    if ((0, _minDash.isFunction)(entriesOrUpdater)) return entriesOrUpdater(entries);
    (0, _minDash.forEach)(entriesOrUpdater, function(entry, id) {
        entries[id] = entry;
    });
    return entries;
}

},{"min-dash":"aEEla","min-dom":"e58GC","../../util/EscapeUtil":"kAkPb","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aNGhX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CreateMenuProvider);
var _optionsUtil = require("./util/OptionsUtil");
function CreateMenuProvider(elementFactory, popupMenu, create, autoPlace, mouse, translate) {
    this._elementFactory = elementFactory;
    this._popupMenu = popupMenu;
    this._create = create;
    this._autoPlace = autoPlace;
    this._mouse = mouse;
    this._translate = translate;
    this.register();
}
CreateMenuProvider.$inject = [
    'elementFactory',
    'popupMenu',
    'create',
    'autoPlace',
    'mouse',
    'translate'
];
/**
 * Register create menu provider in the popup menu
 */ CreateMenuProvider.prototype.register = function() {
    this._popupMenu.registerProvider('bpmn-create', this);
};
/**
 * Get all entries
 *
 * @param {djs.model.Base} element
 *
 * @return {Array<Object>} a list of menu entry items
 */ CreateMenuProvider.prototype.getPopupMenuEntries = function() {
    const entries = {};
    // map options to menu entries
    (0, _optionsUtil.CREATE_OPTIONS).forEach((option)=>{
        const { actionName, className, label, target, description, group, search, rank } = option;
        const targetAction = this._createEntryAction(target);
        entries[`create-${actionName}`] = {
            label: label && this._translate(label),
            className,
            description,
            group: group && {
                ...group,
                name: this._translate(group.name)
            },
            search,
            rank,
            action: {
                click: targetAction,
                dragstart: targetAction
            }
        };
    });
    return entries;
};
/**
 * Create an action for a given target
 *
 * @param {Object} target
 * @returns {Object}
 */ CreateMenuProvider.prototype._createEntryAction = function(target) {
    const create = this._create;
    const mouse = this._mouse;
    const popupMenu = this._popupMenu;
    const elementFactory = this._elementFactory;
    let newElement;
    return (event)=>{
        popupMenu.close();
        // create the new element
        if (target.type === 'bpmn:Participant') newElement = elementFactory.createParticipantShape(target);
        else newElement = elementFactory.create('shape', target);
        // use last mouse event if triggered via keyboard
        if (event instanceof KeyboardEvent) event = mouse.getLastMoveEvent();
        return create.start(event, newElement);
    };
};

},{"./util/OptionsUtil":"hsRDR","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hsRDR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EVENT_GROUP", ()=>EVENT_GROUP);
parcelHelpers.export(exports, "TASK_GROUP", ()=>TASK_GROUP);
parcelHelpers.export(exports, "DATA_GROUP", ()=>DATA_GROUP);
parcelHelpers.export(exports, "PARTICIPANT_GROUP", ()=>PARTICIPANT_GROUP);
parcelHelpers.export(exports, "SUBPROCESS_GROUP", ()=>SUBPROCESS_GROUP);
parcelHelpers.export(exports, "GATEWAY_GROUP", ()=>GATEWAY_GROUP);
parcelHelpers.export(exports, "NONE_EVENTS", ()=>NONE_EVENTS);
parcelHelpers.export(exports, "TYPED_START_EVENTS", ()=>TYPED_START_EVENTS);
parcelHelpers.export(exports, "TYPED_INTERMEDIATE_EVENT", ()=>TYPED_INTERMEDIATE_EVENT);
parcelHelpers.export(exports, "TYPED_BOUNDARY_EVENT", ()=>TYPED_BOUNDARY_EVENT);
parcelHelpers.export(exports, "TYPED_END_EVENT", ()=>TYPED_END_EVENT);
parcelHelpers.export(exports, "GATEWAY", ()=>GATEWAY);
parcelHelpers.export(exports, "SUBPROCESS", ()=>SUBPROCESS);
parcelHelpers.export(exports, "TASK", ()=>TASK);
parcelHelpers.export(exports, "DATA_OBJECTS", ()=>DATA_OBJECTS);
parcelHelpers.export(exports, "PARTICIPANT", ()=>PARTICIPANT);
parcelHelpers.export(exports, "CREATE_OPTIONS", ()=>CREATE_OPTIONS);
var EVENT_GROUP = {
    id: 'events',
    name: 'Events'
};
var TASK_GROUP = {
    id: 'tasks',
    name: 'Tasks'
};
var DATA_GROUP = {
    id: 'data',
    name: 'Data'
};
var PARTICIPANT_GROUP = {
    id: 'participants',
    name: 'Participants'
};
var SUBPROCESS_GROUP = {
    id: 'subprocess',
    name: 'Sub Processes'
};
var GATEWAY_GROUP = {
    id: 'gateways',
    name: 'Gateways'
};
var NONE_EVENTS = [
    {
        label: 'Start Event',
        actionName: 'none-start-event',
        className: 'bpmn-icon-start-event-none',
        target: {
            type: 'bpmn:StartEvent'
        }
    },
    {
        label: 'Intermediate Throw Event',
        actionName: 'none-intermediate-throwing',
        className: 'bpmn-icon-intermediate-event-none',
        target: {
            type: 'bpmn:IntermediateThrowEvent'
        }
    },
    {
        label: 'Boundary Event',
        actionName: 'none-boundary-event',
        className: 'bpmn-icon-intermediate-event-none',
        target: {
            type: 'bpmn:BoundaryEvent'
        }
    },
    {
        label: 'End Event',
        actionName: 'none-end-event',
        className: 'bpmn-icon-end-event-none',
        target: {
            type: 'bpmn:EndEvent'
        }
    }
].map((option)=>({
        ...option,
        group: EVENT_GROUP
    }));
var TYPED_START_EVENTS = [
    {
        label: 'Message Start Event',
        actionName: 'message-start',
        className: 'bpmn-icon-start-event-message',
        target: {
            type: 'bpmn:StartEvent',
            eventDefinitionType: 'bpmn:MessageEventDefinition'
        }
    },
    {
        label: 'Timer Start Event',
        actionName: 'timer-start',
        className: 'bpmn-icon-start-event-timer',
        target: {
            type: 'bpmn:StartEvent',
            eventDefinitionType: 'bpmn:TimerEventDefinition'
        }
    },
    {
        label: 'Conditional Start Event',
        actionName: 'conditional-start',
        className: 'bpmn-icon-start-event-condition',
        target: {
            type: 'bpmn:StartEvent',
            eventDefinitionType: 'bpmn:ConditionalEventDefinition'
        }
    },
    {
        label: 'Signal Start Event',
        actionName: 'signal-start',
        className: 'bpmn-icon-start-event-signal',
        target: {
            type: 'bpmn:StartEvent',
            eventDefinitionType: 'bpmn:SignalEventDefinition'
        }
    }
].map((option)=>({
        ...option,
        group: EVENT_GROUP
    }));
var TYPED_INTERMEDIATE_EVENT = [
    {
        label: 'Message Intermediate Catch Event',
        actionName: 'message-intermediate-catch',
        className: 'bpmn-icon-intermediate-event-catch-message',
        target: {
            type: 'bpmn:IntermediateCatchEvent',
            eventDefinitionType: 'bpmn:MessageEventDefinition'
        }
    },
    {
        label: 'Message Intermediate Throw Event',
        actionName: 'message-intermediate-throw',
        className: 'bpmn-icon-intermediate-event-throw-message',
        target: {
            type: 'bpmn:IntermediateThrowEvent',
            eventDefinitionType: 'bpmn:MessageEventDefinition'
        }
    },
    {
        label: 'Timer Intermediate Catch Event',
        actionName: 'timer-intermediate-catch',
        className: 'bpmn-icon-intermediate-event-catch-timer',
        target: {
            type: 'bpmn:IntermediateCatchEvent',
            eventDefinitionType: 'bpmn:TimerEventDefinition'
        }
    },
    {
        label: 'Escalation Intermediate Throw Event',
        actionName: 'escalation-intermediate-throw',
        className: 'bpmn-icon-intermediate-event-throw-escalation',
        target: {
            type: 'bpmn:IntermediateThrowEvent',
            eventDefinitionType: 'bpmn:EscalationEventDefinition'
        }
    },
    {
        label: 'Conditional Intermediate Catch Event',
        actionName: 'conditional-intermediate-catch',
        className: 'bpmn-icon-intermediate-event-catch-condition',
        target: {
            type: 'bpmn:IntermediateCatchEvent',
            eventDefinitionType: 'bpmn:ConditionalEventDefinition'
        }
    },
    {
        label: 'Link Intermediate Catch Event',
        actionName: 'link-intermediate-catch',
        className: 'bpmn-icon-intermediate-event-catch-link',
        target: {
            type: 'bpmn:IntermediateCatchEvent',
            eventDefinitionType: 'bpmn:LinkEventDefinition',
            eventDefinitionAttrs: {
                name: ''
            }
        }
    },
    {
        label: 'Link Intermediate Throw Event',
        actionName: 'link-intermediate-throw',
        className: 'bpmn-icon-intermediate-event-throw-link',
        target: {
            type: 'bpmn:IntermediateThrowEvent',
            eventDefinitionType: 'bpmn:LinkEventDefinition',
            eventDefinitionAttrs: {
                name: ''
            }
        }
    },
    {
        label: 'Compensation Intermediate Throw Event',
        actionName: 'compensation-intermediate-throw',
        className: 'bpmn-icon-intermediate-event-throw-compensation',
        target: {
            type: 'bpmn:IntermediateThrowEvent',
            eventDefinitionType: 'bpmn:CompensateEventDefinition'
        }
    },
    {
        label: 'Signal Intermediate Catch Event',
        actionName: 'signal-intermediate-catch',
        className: 'bpmn-icon-intermediate-event-catch-signal',
        target: {
            type: 'bpmn:IntermediateCatchEvent',
            eventDefinitionType: 'bpmn:SignalEventDefinition'
        }
    },
    {
        label: 'Signal Intermediate Throw Event',
        actionName: 'signal-intermediate-throw',
        className: 'bpmn-icon-intermediate-event-throw-signal',
        target: {
            type: 'bpmn:IntermediateThrowEvent',
            eventDefinitionType: 'bpmn:SignalEventDefinition'
        }
    }
].map((option)=>({
        ...option,
        group: EVENT_GROUP
    }));
var TYPED_BOUNDARY_EVENT = [
    {
        label: 'Message Boundary Event',
        actionName: 'message-boundary',
        className: 'bpmn-icon-intermediate-event-catch-message',
        target: {
            type: 'bpmn:BoundaryEvent',
            eventDefinitionType: 'bpmn:MessageEventDefinition'
        }
    },
    {
        label: 'Timer Boundary Event',
        actionName: 'timer-boundary',
        className: 'bpmn-icon-intermediate-event-catch-timer',
        target: {
            type: 'bpmn:BoundaryEvent',
            eventDefinitionType: 'bpmn:TimerEventDefinition'
        }
    },
    {
        label: 'Escalation Boundary Event',
        actionName: 'escalation-boundary',
        className: 'bpmn-icon-intermediate-event-catch-escalation',
        target: {
            type: 'bpmn:BoundaryEvent',
            eventDefinitionType: 'bpmn:EscalationEventDefinition'
        }
    },
    {
        label: 'Conditional Boundary Event',
        actionName: 'conditional-boundary',
        className: 'bpmn-icon-intermediate-event-catch-condition',
        target: {
            type: 'bpmn:BoundaryEvent',
            eventDefinitionType: 'bpmn:ConditionalEventDefinition'
        }
    },
    {
        label: 'Error Boundary Event',
        actionName: 'error-boundary',
        className: 'bpmn-icon-intermediate-event-catch-error',
        target: {
            type: 'bpmn:BoundaryEvent',
            eventDefinitionType: 'bpmn:ErrorEventDefinition'
        }
    },
    {
        label: 'Cancel Boundary Event',
        actionName: 'cancel-boundary',
        className: 'bpmn-icon-intermediate-event-catch-cancel',
        target: {
            type: 'bpmn:BoundaryEvent',
            eventDefinitionType: 'bpmn:CancelEventDefinition'
        }
    },
    {
        label: 'Signal Boundary Event',
        actionName: 'signal-boundary',
        className: 'bpmn-icon-intermediate-event-catch-signal',
        target: {
            type: 'bpmn:BoundaryEvent',
            eventDefinitionType: 'bpmn:SignalEventDefinition'
        }
    },
    {
        label: 'Compensation Boundary Event',
        actionName: 'compensation-boundary',
        className: 'bpmn-icon-intermediate-event-catch-compensation',
        target: {
            type: 'bpmn:BoundaryEvent',
            eventDefinitionType: 'bpmn:CompensateEventDefinition'
        }
    },
    {
        label: 'Message Boundary Event (non-interrupting)',
        actionName: 'non-interrupting-message-boundary',
        className: 'bpmn-icon-intermediate-event-catch-non-interrupting-message',
        target: {
            type: 'bpmn:BoundaryEvent',
            eventDefinitionType: 'bpmn:MessageEventDefinition',
            cancelActivity: false
        }
    },
    {
        label: 'Timer Boundary Event (non-interrupting)',
        actionName: 'non-interrupting-timer-boundary',
        className: 'bpmn-icon-intermediate-event-catch-non-interrupting-timer',
        target: {
            type: 'bpmn:BoundaryEvent',
            eventDefinitionType: 'bpmn:TimerEventDefinition',
            cancelActivity: false
        }
    },
    {
        label: 'Escalation Boundary Event (non-interrupting)',
        actionName: 'non-interrupting-escalation-boundary',
        className: 'bpmn-icon-intermediate-event-catch-non-interrupting-escalation',
        target: {
            type: 'bpmn:BoundaryEvent',
            eventDefinitionType: 'bpmn:EscalationEventDefinition',
            cancelActivity: false
        }
    },
    {
        label: 'Conditional Boundary Event (non-interrupting)',
        actionName: 'non-interrupting-conditional-boundary',
        className: 'bpmn-icon-intermediate-event-catch-non-interrupting-condition',
        target: {
            type: 'bpmn:BoundaryEvent',
            eventDefinitionType: 'bpmn:ConditionalEventDefinition',
            cancelActivity: false
        }
    },
    {
        label: 'Signal Boundary Event (non-interrupting)',
        actionName: 'non-interrupting-signal-boundary',
        className: 'bpmn-icon-intermediate-event-catch-non-interrupting-signal',
        target: {
            type: 'bpmn:BoundaryEvent',
            eventDefinitionType: 'bpmn:SignalEventDefinition',
            cancelActivity: false
        }
    }
].map((option)=>({
        ...option,
        group: EVENT_GROUP
    }));
var TYPED_END_EVENT = [
    {
        label: 'Message End Event',
        actionName: 'message-end',
        className: 'bpmn-icon-end-event-message',
        target: {
            type: 'bpmn:EndEvent',
            eventDefinitionType: 'bpmn:MessageEventDefinition'
        }
    },
    {
        label: 'Escalation End Event',
        actionName: 'escalation-end',
        className: 'bpmn-icon-end-event-escalation',
        target: {
            type: 'bpmn:EndEvent',
            eventDefinitionType: 'bpmn:EscalationEventDefinition'
        }
    },
    {
        label: 'Error End Event',
        actionName: 'error-end',
        className: 'bpmn-icon-end-event-error',
        target: {
            type: 'bpmn:EndEvent',
            eventDefinitionType: 'bpmn:ErrorEventDefinition'
        }
    },
    {
        label: 'Cancel End Event',
        actionName: 'cancel-end',
        className: 'bpmn-icon-end-event-cancel',
        target: {
            type: 'bpmn:EndEvent',
            eventDefinitionType: 'bpmn:CancelEventDefinition'
        }
    },
    {
        label: 'Compensation End Event',
        actionName: 'compensation-end',
        className: 'bpmn-icon-end-event-compensation',
        target: {
            type: 'bpmn:EndEvent',
            eventDefinitionType: 'bpmn:CompensateEventDefinition'
        }
    },
    {
        label: 'Signal End Event',
        actionName: 'signal-end',
        className: 'bpmn-icon-end-event-signal',
        target: {
            type: 'bpmn:EndEvent',
            eventDefinitionType: 'bpmn:SignalEventDefinition'
        }
    },
    {
        label: 'Terminate End Event',
        actionName: 'terminate-end',
        className: 'bpmn-icon-end-event-terminate',
        target: {
            type: 'bpmn:EndEvent',
            eventDefinitionType: 'bpmn:TerminateEventDefinition'
        }
    }
].map((option)=>({
        ...option,
        group: EVENT_GROUP
    }));
var GATEWAY = [
    {
        label: 'Exclusive Gateway',
        actionName: 'exclusive-gateway',
        className: 'bpmn-icon-gateway-xor',
        target: {
            type: 'bpmn:ExclusiveGateway'
        }
    },
    {
        label: 'Parallel Gateway',
        actionName: 'parallel-gateway',
        className: 'bpmn-icon-gateway-parallel',
        target: {
            type: 'bpmn:ParallelGateway'
        }
    },
    {
        label: 'Inclusive Gateway',
        search: 'or',
        actionName: 'inclusive-gateway',
        className: 'bpmn-icon-gateway-or',
        target: {
            type: 'bpmn:InclusiveGateway'
        },
        rank: -1
    },
    {
        label: 'Complex Gateway',
        actionName: 'complex-gateway',
        className: 'bpmn-icon-gateway-complex',
        target: {
            type: 'bpmn:ComplexGateway'
        },
        rank: -1
    },
    {
        label: 'Event based Gateway',
        actionName: 'event-based-gateway',
        className: 'bpmn-icon-gateway-eventbased',
        target: {
            type: 'bpmn:EventBasedGateway',
            instantiate: false,
            eventGatewayType: 'Exclusive'
        }
    }
].map((option)=>({
        ...option,
        group: GATEWAY_GROUP
    }));
var SUBPROCESS = [
    {
        label: 'Transaction',
        actionName: 'transaction',
        className: 'bpmn-icon-transaction',
        target: {
            type: 'bpmn:Transaction',
            isExpanded: true
        }
    },
    {
        label: 'Event Sub Process',
        search: 'subprocess',
        actionName: 'event-subprocess',
        className: 'bpmn-icon-event-subprocess-expanded',
        target: {
            type: 'bpmn:SubProcess',
            triggeredByEvent: true,
            isExpanded: true
        }
    },
    {
        label: 'Sub Process (collapsed)',
        search: 'subprocess',
        actionName: 'collapsed-subprocess',
        className: 'bpmn-icon-subprocess-collapsed',
        target: {
            type: 'bpmn:SubProcess',
            isExpanded: false
        }
    },
    {
        label: 'Sub Process (expanded)',
        search: 'subprocess',
        actionName: 'expanded-subprocess',
        className: 'bpmn-icon-subprocess-collapsed',
        target: {
            type: 'bpmn:SubProcess',
            isExpanded: true
        }
    }
].map((option)=>({
        ...option,
        group: SUBPROCESS_GROUP
    }));
var TASK = [
    {
        label: 'Task',
        actionName: 'task',
        className: 'bpmn-icon-task',
        target: {
            type: 'bpmn:Task'
        }
    },
    {
        label: 'User Task',
        actionName: 'user-task',
        className: 'bpmn-icon-user',
        target: {
            type: 'bpmn:UserTask'
        }
    },
    {
        label: 'Service Task',
        actionName: 'service-task',
        className: 'bpmn-icon-service',
        target: {
            type: 'bpmn:ServiceTask'
        }
    },
    {
        label: 'Send Task',
        actionName: 'send-task',
        className: 'bpmn-icon-send',
        target: {
            type: 'bpmn:SendTask'
        },
        rank: -1
    },
    {
        label: 'Receive Task',
        actionName: 'receive-task',
        className: 'bpmn-icon-receive',
        target: {
            type: 'bpmn:ReceiveTask'
        },
        rank: -1
    },
    {
        label: 'Manual Task',
        actionName: 'manual-task',
        className: 'bpmn-icon-manual',
        target: {
            type: 'bpmn:ManualTask'
        },
        rank: -1
    },
    {
        label: 'Business Rule Task',
        actionName: 'rule-task',
        className: 'bpmn-icon-business-rule',
        target: {
            type: 'bpmn:BusinessRuleTask'
        }
    },
    {
        label: 'Script Task',
        actionName: 'script-task',
        className: 'bpmn-icon-script',
        target: {
            type: 'bpmn:ScriptTask'
        }
    },
    {
        label: 'Call Activity',
        actionName: 'call-activity',
        className: 'bpmn-icon-call-activity',
        target: {
            type: 'bpmn:CallActivity'
        }
    }
].map((option)=>({
        ...option,
        group: TASK_GROUP
    }));
var DATA_OBJECTS = [
    {
        label: 'Data Store Reference',
        actionName: 'data-store-reference',
        className: 'bpmn-icon-data-store',
        target: {
            type: 'bpmn:DataStoreReference'
        }
    },
    {
        label: 'Data Object Reference',
        actionName: 'data-object-reference',
        className: 'bpmn-icon-data-object',
        target: {
            type: 'bpmn:DataObjectReference'
        }
    }
].map((option)=>({
        ...option,
        group: DATA_GROUP
    }));
var PARTICIPANT = [
    {
        label: 'Expanded Pool',
        search: 'Participant',
        actionName: 'expanded-pool',
        className: 'bpmn-icon-participant',
        target: {
            type: 'bpmn:Participant',
            isExpanded: true
        }
    },
    {
        label: 'Empty Pool',
        search: 'Collapsed Participant',
        actionName: 'collapsed-pool',
        className: 'bpmn-icon-lane',
        target: {
            type: 'bpmn:Participant',
            isExpanded: false
        }
    }
].map((option)=>({
        ...option,
        group: PARTICIPANT_GROUP
    }));
var CREATE_OPTIONS = [
    ...GATEWAY,
    ...TASK,
    ...SUBPROCESS,
    ...NONE_EVENTS,
    ...TYPED_START_EVENTS,
    ...TYPED_INTERMEDIATE_EVENT,
    ...TYPED_END_EVENT,
    ...TYPED_BOUNDARY_EVENT,
    ...DATA_OBJECTS,
    ...PARTICIPANT
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ctehy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CreatePaletteProvider);
var _icons = require("../../icons/Icons");
var _minDom = require("min-dom");
function CreatePaletteProvider(palette, translate, popupMenu, canvas, mouse) {
    this._translate = translate;
    this._popupMenu = popupMenu;
    this._canvas = canvas;
    this._mouse = mouse;
    palette.registerProvider(800, this);
}
CreatePaletteProvider.$inject = [
    'palette',
    'translate',
    'popupMenu',
    'canvas',
    'mouse'
];
CreatePaletteProvider.prototype.getPaletteEntries = function(element) {
    const translate = this._translate, popupMenu = this._popupMenu, canvas = this._canvas, mouse = this._mouse;
    const getPosition = (event)=>{
        const X_OFFSET = 35;
        const Y_OFFSET = 10;
        if (event instanceof KeyboardEvent) {
            event = mouse.getLastMoveEvent();
            return {
                x: event.x,
                y: event.y
            };
        }
        const target = event && event.target || (0, _minDom.query)('.djs-palette [data-action="create"]');
        const targetPosition = target.getBoundingClientRect();
        return target && {
            x: targetPosition.left + targetPosition.width / 2 + X_OFFSET,
            y: targetPosition.top + targetPosition.height / 2 + Y_OFFSET
        };
    };
    return {
        'create': {
            group: 'create',
            imageUrl: (0, _icons.createIcon),
            title: translate('Create element'),
            action: {
                click: function(event) {
                    const position = getPosition(event);
                    const element = canvas.getRootElement();
                    popupMenu.open(element, 'bpmn-create', position, {
                        title: translate('Create element'),
                        width: 300,
                        search: true
                    });
                }
            }
        }
    };
};

},{"../../icons/Icons":"h3aIY","min-dom":"e58GC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"h3aIY":[function(require,module,exports,__globalThis) {
/**
 * To change the icons, modify the SVGs in `./resources`, execute `npx svgo -f resources --datauri enc -o dist`,
 * and then replace respective icons with the optimized data URIs in `./dist`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "appendIcon", ()=>appendIcon);
parcelHelpers.export(exports, "createIcon", ()=>createIcon);
const appendIcon = 'data:image/svg+xml,%3Csvg%20width%3D%2222%22%20height%3D%2222%22%20viewBox%3D%220%200%205.82%205.82%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%20%20%3Cpath%20d%3D%22M1.3%203.4c.3%200%20.5-.2.5-.5s-.2-.4-.5-.4c-.2%200-.4.1-.4.4%200%20.3.2.5.4.5zM3%203.4c.2%200%20.4-.2.4-.5s-.2-.4-.4-.4c-.3%200-.5.1-.5.4%200%20.3.2.5.5.5zM4.6%203.4c.2%200%20.4-.2.4-.5s-.2-.4-.4-.4c-.3%200-.5.1-.5.4%200%20.3.2.5.5.5z%22%2F%3E%0A%3C%2Fsvg%3E';
const createIcon = 'data:image/svg+xml,%3Csvg%20width%3D%2246%22%20height%3D%2246%22%20viewBox%3D%22-2%20-2%209.82%209.82%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cpath%20d%3D%22M1.3%203.4c.3%200%20.5-.2.5-.5s-.2-.4-.5-.4c-.2%200-.4.1-.4.4%200%20.3.2.5.4.5zM3%203.4c.2%200%20.4-.2.4-.5s-.2-.4-.4-.4c-.3%200-.5.1-.5.4%200%20.3.2.5.5.5zM4.6%203.4c.2%200%20.4-.2.4-.5s-.2-.4-.4-.4c-.3%200-.5.1-.5.4%200%20.3.2.5.5.5z%22%2F%3E%0A%3C%2Fsvg%3E';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"xDC7G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CreateAppendEditorActions);
var _minDash = require("min-dash");
function CreateAppendEditorActions(injector) {
    this._injector = injector;
    this.registerActions();
}
CreateAppendEditorActions.$inject = [
    'injector'
];
/**
 * Register actions.
 *
 * @param {Injector} injector
 */ CreateAppendEditorActions.prototype.registerActions = function() {
    var editorActions = this._injector.get('editorActions', false);
    var selection = this._injector.get('selection', false);
    var contextPad = this._injector.get('contextPad', false);
    var palette = this._injector.get('palette', false);
    var popupMenu = this._injector.get('popupMenu', false);
    const actions = {};
    // append
    if (selection && contextPad && palette && popupMenu && palette) (0, _minDash.assign)(actions, {
        'appendElement': function(event) {
            const selected = selection && selection.get();
            if (selected.length == 1 && !popupMenu.isEmpty(selected[0], 'bpmn-append')) contextPad.triggerEntry('append', 'click', event);
            else palette.triggerEntry('create', 'click', event);
        }
    });
    // create
    if (palette) (0, _minDash.assign)(actions, {
        'createElement': function(event) {
            palette.triggerEntry('create', 'click', event);
        }
    });
    editorActions && editorActions.register(actions);
};

},{"min-dash":"aEEla","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1YoYr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CreateAppendKeyboardBindings);
var _inheritsBrowser = require("inherits-browser");
var _inheritsBrowserDefault = parcelHelpers.interopDefault(_inheritsBrowser);
var _keyboardBindings = require("diagram-js/lib/features/keyboard/KeyboardBindings");
var _keyboardBindingsDefault = parcelHelpers.interopDefault(_keyboardBindings);
function CreateAppendKeyboardBindings(injector) {
    this._injector = injector;
    this._keyboard = this._injector.get('keyboard', false);
    this._editorActions = this._injector.get('editorActions', false);
    if (this._keyboard) this._injector.invoke((0, _keyboardBindingsDefault.default), this);
}
(0, _inheritsBrowserDefault.default)(CreateAppendKeyboardBindings, (0, _keyboardBindingsDefault.default));
CreateAppendKeyboardBindings.$inject = [
    'injector'
];
/**
 * Register available keyboard bindings.
 *
 * @param {Keyboard} keyboard
 * @param {EditorActions} editorActions
 */ CreateAppendKeyboardBindings.prototype.registerBindings = function() {
    var keyboard = this._keyboard;
    var editorActions = this._editorActions;
    // inherit default bindings
    (0, _keyboardBindingsDefault.default).prototype.registerBindings.call(this, keyboard, editorActions);
    /**
   * Add keyboard binding if respective editor action
   * is registered.
   *
   * @param {string} action name
   * @param {Function} fn that implements the key binding
   */ function addListener(action, fn) {
        if (editorActions && editorActions.isRegistered(action)) keyboard && keyboard.addListener(fn);
    }
    // activate append/create element
    // A
    addListener('appendElement', function(context) {
        var event = context.keyEvent;
        if (keyboard && keyboard.hasModifier(event)) return;
        if (keyboard && keyboard.isKey([
            'a',
            'A'
        ], event)) {
            editorActions && editorActions.trigger('appendElement', event);
            return true;
        }
    });
    // N
    addListener('createElement', function(context) {
        var event = context.keyEvent;
        if (keyboard && keyboard.hasModifier(event)) return;
        if (keyboard && keyboard.isKey([
            'n',
            'N'
        ], event)) {
            editorActions && editorActions.trigger('createElement', event);
            return true;
        }
    });
};

},{"inherits-browser":"hymxq","diagram-js/lib/features/keyboard/KeyboardBindings":"8kcRe","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"VOOxR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AppendMenuProvider);
var _minDash = require("min-dash");
var _optionsUtil = require("./util/OptionsUtil");
function AppendMenuProvider(elementFactory, popupMenu, create, autoPlace, rules, mouse, translate) {
    this._elementFactory = elementFactory;
    this._popupMenu = popupMenu;
    this._create = create;
    this._autoPlace = autoPlace;
    this._rules = rules;
    this._create = create;
    this._mouse = mouse;
    this._translate = translate;
    this.register();
}
AppendMenuProvider.$inject = [
    'elementFactory',
    'popupMenu',
    'create',
    'autoPlace',
    'rules',
    'mouse',
    'translate'
];
/**
 * Register append menu provider in the popup menu
 */ AppendMenuProvider.prototype.register = function() {
    this._popupMenu.registerProvider('bpmn-append', this);
};
/**
 * Get all entries from createOptions for the given element.
 *
 * @param {djs.model.Base} element
 *
 * @return {Array<Object>} a list of menu entry items
 */ AppendMenuProvider.prototype.getPopupMenuEntries = function(element) {
    const rules = this._rules;
    const translate = this._translate;
    const entries = {};
    if (!rules.allowed('shape.append', {
        element: element
    })) return [];
    // filter out elements with no incoming connections
    const appendOptions = this._filterEntries((0, _optionsUtil.CREATE_OPTIONS));
    // map options to menu entries
    appendOptions.forEach((option)=>{
        const { actionName, className, label, target, description, group, search, rank } = option;
        entries[`append-${actionName}`] = {
            label: label && translate(label),
            className,
            description,
            group: group && {
                ...group,
                name: translate(group.name)
            },
            search,
            rank,
            action: this._createEntryAction(element, target)
        };
    });
    return entries;
};
/**
 * Filter out entries from the options.
 *
 * @param {Array<Object>} entries
 *
 * @return {Array<Object>} filtered entries
 */ AppendMenuProvider.prototype._filterEntries = function(entries) {
    return entries.filter((option)=>{
        const target = option.target;
        const { type, eventDefinitionType } = target;
        if ([
            'bpmn:StartEvent',
            'bpmn:Participant'
        ].includes(type)) return false;
        if (type === 'bpmn:BoundaryEvent' && (0, _minDash.isUndefined)(eventDefinitionType)) return false;
        return true;
    });
};
/**
 * Create an action for a given target.
 *
 * @param {djs.model.Base} element
 * @param {Object} target
 *
 * @return {Object}
 */ AppendMenuProvider.prototype._createEntryAction = function(element, target) {
    const elementFactory = this._elementFactory;
    const autoPlace = this._autoPlace;
    const create = this._create;
    const mouse = this._mouse;
    const autoPlaceElement = ()=>{
        const newElement = elementFactory.create('shape', target);
        autoPlace.append(element, newElement);
    };
    const manualPlaceElement = (event)=>{
        const newElement = elementFactory.create('shape', target);
        if (event instanceof KeyboardEvent) event = mouse.getLastMoveEvent();
        return create.start(event, newElement, {
            source: element
        });
    };
    return {
        click: this._canAutoPlaceElement(target) ? autoPlaceElement : manualPlaceElement,
        dragstart: manualPlaceElement
    };
};
/**
 * Check if the element should be auto placed.
 *
 * @param {Object} target
 *
 * @return {Boolean}
 */ AppendMenuProvider.prototype._canAutoPlaceElement = (target)=>{
    const { type } = target;
    if (type === 'bpmn:BoundaryEvent') return false;
    if (type === 'bpmn:SubProcess' && target.triggeredByEvent) return false;
    if (type === 'bpmn:IntermediateCatchEvent' && target.eventDefinitionType === 'bpmn:LinkEventDefinition') return false;
    return true;
};

},{"min-dash":"aEEla","./util/OptionsUtil":"hsRDR","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"41ILd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AppendContextPadProvider);
var _minDash = require("min-dash");
var _icons = require("../../icons/Icons");
var LOW_PRIORITY = 900;
function AppendContextPadProvider(contextPad, popupMenu, translate, canvas) {
    contextPad.registerProvider(LOW_PRIORITY, this);
    this._contextPad = contextPad;
    this._popupMenu = popupMenu;
    this._translate = translate;
    this._canvas = canvas;
}
AppendContextPadProvider.$inject = [
    'contextPad',
    'popupMenu',
    'translate',
    'canvas'
];
AppendContextPadProvider.prototype.getContextPadEntries = function(element) {
    const popupMenu = this._popupMenu;
    const translate = this._translate;
    const getAppendMenuPosition = this._getAppendMenuPosition.bind(this);
    if (!popupMenu.isEmpty(element, 'bpmn-append')) // append menu entry
    return {
        'append': {
            group: 'model',
            imageUrl: (0, _icons.appendIcon),
            title: translate('Append element'),
            action: {
                click: function(event, element) {
                    var position = (0, _minDash.assign)(getAppendMenuPosition(element), {
                        cursor: {
                            x: event.x,
                            y: event.y
                        }
                    });
                    popupMenu.open(element, 'bpmn-append', position, {
                        title: translate('Append element'),
                        width: 300,
                        search: true
                    });
                }
            }
        }
    };
};
AppendContextPadProvider.prototype._getAppendMenuPosition = function(element) {
    const contextPad = this._contextPad;
    const X_OFFSET = 5;
    const pad = contextPad.getPad(element).html;
    const padRect = pad.getBoundingClientRect();
    const pos = {
        x: padRect.right + X_OFFSET,
        y: padRect.top
    };
    return pos;
};

},{"min-dash":"aEEla","../../icons/Icons":"h3aIY","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bWzHf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AppendRules);
var _minDash = require("min-dash");
var _inheritsBrowser = require("inherits-browser");
var _inheritsBrowserDefault = parcelHelpers.interopDefault(_inheritsBrowser);
var _modelUtil = require("../../util/ModelUtil");
var _labelUtil = require("../../util/LabelUtil");
var _ruleProvider = require("diagram-js/lib/features/rules/RuleProvider");
var _ruleProviderDefault = parcelHelpers.interopDefault(_ruleProvider);
function AppendRules(eventBus) {
    (0, _ruleProviderDefault.default).call(this, eventBus);
}
(0, _inheritsBrowserDefault.default)(AppendRules, (0, _ruleProviderDefault.default));
AppendRules.$inject = [
    'eventBus'
];
AppendRules.prototype.init = function() {
    this.addRule('shape.append', function(context) {
        var source = context.element;
        const businessObject = (0, _modelUtil.getBusinessObject)(source);
        if ((0, _labelUtil.isLabel)(source)) return false;
        if ((0, _modelUtil.isAny)(source, [
            'bpmn:EndEvent',
            'bpmn:Group',
            'bpmn:TextAnnotation',
            'bpmn:Lane',
            'bpmn:Participant',
            'bpmn:DataStoreReference',
            'bpmn:DataObjectReference'
        ])) return false;
        if (isConnection(source)) return false;
        if ((0, _modelUtil.is)(source, 'bpmn:IntermediateThrowEvent') && hasEventDefinition(source, 'bpmn:LinkEventDefinition')) return false;
        if ((0, _modelUtil.is)(source, 'bpmn:SubProcess') && businessObject.triggeredByEvent) return false;
    });
};
// helpers //////////////
function hasEventDefinition(element, eventDefinition) {
    var bo = (0, _modelUtil.getBusinessObject)(element);
    return !!(0, _minDash.find)(bo.eventDefinitions || [], function(definition) {
        return (0, _modelUtil.is)(definition, eventDefinition);
    });
}
function isConnection(element) {
    return element.waypoints;
}

},{"min-dash":"aEEla","inherits-browser":"hymxq","../../util/ModelUtil":"klNYN","../../util/LabelUtil":"fAd5x","diagram-js/lib/features/rules/RuleProvider":"5VfYt","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4dQN8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _distributeElements = require("diagram-js/lib/features/distribute-elements");
var _distributeElementsDefault = parcelHelpers.interopDefault(_distributeElements);
var _popupMenu = require("diagram-js/lib/features/popup-menu");
var _popupMenuDefault = parcelHelpers.interopDefault(_popupMenu);
var _bpmnDistributeElements = require("./BpmnDistributeElements");
var _bpmnDistributeElementsDefault = parcelHelpers.interopDefault(_bpmnDistributeElements);
var _distributeElementsMenuProvider = require("./DistributeElementsMenuProvider");
var _distributeElementsMenuProviderDefault = parcelHelpers.interopDefault(_distributeElementsMenuProvider);
exports.default = {
    __depends__: [
        (0, _popupMenuDefault.default),
        (0, _distributeElementsDefault.default)
    ],
    __init__: [
        'bpmnDistributeElements',
        'distributeElementsMenuProvider'
    ],
    bpmnDistributeElements: [
        'type',
        (0, _bpmnDistributeElementsDefault.default)
    ],
    distributeElementsMenuProvider: [
        'type',
        (0, _distributeElementsMenuProviderDefault.default)
    ]
};

},{"diagram-js/lib/features/distribute-elements":"lpnGa","diagram-js/lib/features/popup-menu":"iRpNh","./BpmnDistributeElements":"12iro","./DistributeElementsMenuProvider":"88tYq","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lpnGa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _distributeElements = require("./DistributeElements");
var _distributeElementsDefault = parcelHelpers.interopDefault(_distributeElements);
exports.default = {
    __init__: [
        'distributeElements'
    ],
    distributeElements: [
        'type',
        (0, _distributeElementsDefault.default)
    ]
};

},{"./DistributeElements":"1McEq","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1McEq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DistributeElements);
var _minDash = require("min-dash");
/**
 * @typedef {Object} Range
 * @property {number} min
 * @property {number} max
 */ /**
 * @typedef {import('../../util/Types').Axis} Axis
 * @typedef {import('../../util/Types').Dimension} Dimension
 * @typedef {import('../../util/Types').Rect} Rect
 *
 * @typedef {import('../modeling/Modeling').default} Modeling
 * @typedef {import('../rules/Rules').default} Rules
 */ var AXIS_DIMENSIONS = {
    horizontal: [
        'x',
        'width'
    ],
    vertical: [
        'y',
        'height'
    ]
};
var THRESHOLD = 5;
function DistributeElements(modeling, rules) {
    this._modeling = modeling;
    this._filters = [];
    this.registerFilter(function(elements) {
        var allowed = rules.allowed('elements.distribute', {
            elements: elements
        });
        if ((0, _minDash.isArray)(allowed)) return allowed;
        return allowed ? elements : [];
    });
}
DistributeElements.$inject = [
    'modeling',
    'rules'
];
/**
 * Registers filter functions that allow external parties to filter
 * out certain elements.
 *
 * @param {Function} filterFn
 */ DistributeElements.prototype.registerFilter = function(filterFn) {
    if (typeof filterFn !== 'function') throw new Error('the filter has to be a function');
    this._filters.push(filterFn);
};
/**
 * Distributes the elements with a given orientation
 *
 * @param {Array} elements
 * @param {string} orientation
 */ DistributeElements.prototype.trigger = function(elements, orientation) {
    var modeling = this._modeling;
    var groups, distributableElements;
    if (elements.length < 3) return;
    this._setOrientation(orientation);
    distributableElements = this._filterElements(elements);
    groups = this._createGroups(distributableElements);
    // nothing to distribute
    if (groups.length <= 2) return;
    modeling.distributeElements(groups, this._axis, this._dimension);
    return groups;
};
/**
 * Filters the elements with provided filters by external parties
 *
 * @param {Array[Elements]} elements
 *
 * @return {Array[Elements]}
 */ DistributeElements.prototype._filterElements = function(elements) {
    var filters = this._filters, axis = this._axis, dimension = this._dimension, distributableElements = [].concat(elements);
    if (!filters.length) return elements;
    (0, _minDash.forEach)(filters, function(filterFn) {
        distributableElements = filterFn(distributableElements, axis, dimension);
    });
    return distributableElements;
};
/**
 * Create range (min, max) groups. Also tries to group elements
 * together that share the same range.
 *
 * @example
 * 	var distributableElements = [
 * 		{
 * 			range: {
 * 				min: 100,
 * 				max: 200
 * 			},
 * 			elements: [ { id: 'shape1', .. }]
 * 		}
 * 	]
 *
 * @param {Array} elements
 *
 * @return {Array[Objects]}
 */ DistributeElements.prototype._createGroups = function(elements) {
    var rangeGroups = [], self = this, axis = this._axis, dimension = this._dimension;
    if (!axis) throw new Error('must have a defined "axis" and "dimension"');
    // sort by 'left->right' or 'top->bottom'
    var sortedElements = (0, _minDash.sortBy)(elements, axis);
    (0, _minDash.forEach)(sortedElements, function(element, idx) {
        var elementRange = self._findRange(element, axis, dimension), range;
        var previous = rangeGroups[rangeGroups.length - 1];
        if (previous && self._hasIntersection(previous.range, elementRange)) rangeGroups[rangeGroups.length - 1].elements.push(element);
        else {
            range = {
                range: elementRange,
                elements: [
                    element
                ]
            };
            rangeGroups.push(range);
        }
    });
    return rangeGroups;
};
/**
 * Maps a direction to the according axis and dimension
 *
 * @param {string} direction 'horizontal' or 'vertical'
 */ DistributeElements.prototype._setOrientation = function(direction) {
    var orientation = AXIS_DIMENSIONS[direction];
    this._axis = orientation[0];
    this._dimension = orientation[1];
};
/**
 * Checks if the two ranges intercept each other
 *
 * @param {Object} rangeA {min, max}
 * @param {Object} rangeB {min, max}
 *
 * @return {boolean}
 */ DistributeElements.prototype._hasIntersection = function(rangeA, rangeB) {
    return Math.max(rangeA.min, rangeA.max) >= Math.min(rangeB.min, rangeB.max) && Math.min(rangeA.min, rangeA.max) <= Math.max(rangeB.min, rangeB.max);
};
/**
 * Returns the min and max values for an element
 *
 * @param {Rect} element
 * @param {Axis} axis
 * @param {Dimension} dimension
 *
 * @return {Range}
 */ DistributeElements.prototype._findRange = function(element) {
    var axis = element[this._axis], dimension = element[this._dimension];
    return {
        min: axis + THRESHOLD,
        max: axis + dimension - THRESHOLD
    };
};

},{"min-dash":"aEEla","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"12iro":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BpmnDistributeElements);
var _inheritsBrowser = require("inherits-browser");
var _inheritsBrowserDefault = parcelHelpers.interopDefault(_inheritsBrowser);
var _ruleProvider = require("diagram-js/lib/features/rules/RuleProvider");
var _ruleProviderDefault = parcelHelpers.interopDefault(_ruleProvider);
var _elements = require("diagram-js/lib/util/Elements");
var _minDash = require("min-dash");
var _modelingUtil = require("../modeling/util/ModelingUtil");
function BpmnDistributeElements(distributeElements, eventBus, rules) {
    (0, _ruleProviderDefault.default).call(this, eventBus);
}
BpmnDistributeElements.$inject = [
    'distributeElements',
    'eventBus',
    'rules'
];
(0, _inheritsBrowserDefault.default)(BpmnDistributeElements, (0, _ruleProviderDefault.default));
BpmnDistributeElements.prototype.init = function() {
    this.addRule('elements.distribute', function(context) {
        var elements = context.elements;
        elements = (0, _minDash.filter)(elements, function(element) {
            var cannotDistribute = (0, _modelingUtil.isAny)(element, [
                'bpmn:Association',
                'bpmn:BoundaryEvent',
                'bpmn:DataInputAssociation',
                'bpmn:DataOutputAssociation',
                'bpmn:Lane',
                'bpmn:MessageFlow',
                'bpmn:SequenceFlow',
                'bpmn:TextAnnotation'
            ]);
            return !(element.labelTarget || cannotDistribute);
        });
        // filter out elements which are children of any of the selected elements
        elements = (0, _elements.getParents)(elements);
        if (elements.length < 3) return false;
        return elements;
    });
};

},{"inherits-browser":"hymxq","diagram-js/lib/features/rules/RuleProvider":"5VfYt","diagram-js/lib/util/Elements":"6qdtl","min-dash":"aEEla","../modeling/util/ModelingUtil":"4DR1e","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"88tYq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DistributeElementsMenuProvider);
var _distributeElementsIcons = require("./DistributeElementsIcons");
var _distributeElementsIconsDefault = parcelHelpers.interopDefault(_distributeElementsIcons);
var _minDash = require("min-dash");
var LOW_PRIORITY = 900;
function DistributeElementsMenuProvider(popupMenu, distributeElements, translate, rules) {
    this._distributeElements = distributeElements;
    this._translate = translate;
    this._popupMenu = popupMenu;
    this._rules = rules;
    popupMenu.registerProvider('align-elements', LOW_PRIORITY, this);
}
DistributeElementsMenuProvider.$inject = [
    'popupMenu',
    'distributeElements',
    'translate',
    'rules'
];
DistributeElementsMenuProvider.prototype.getPopupMenuEntries = function(elements) {
    var entries = {};
    if (this._isAllowed(elements)) (0, _minDash.assign)(entries, this._getEntries(elements));
    return entries;
};
DistributeElementsMenuProvider.prototype._isAllowed = function(elements) {
    return this._rules.allowed('elements.distribute', {
        elements: elements
    });
};
DistributeElementsMenuProvider.prototype._getEntries = function(elements) {
    var distributeElements = this._distributeElements, translate = this._translate, popupMenu = this._popupMenu;
    var entries = {
        'distribute-elements-horizontal': {
            group: 'distribute',
            title: translate('Distribute elements horizontally'),
            className: 'bjs-align-elements-menu-entry',
            imageUrl: (0, _distributeElementsIconsDefault.default)['horizontal'],
            action: function(event, entry) {
                distributeElements.trigger(elements, 'horizontal');
                popupMenu.close();
            }
        },
        'distribute-elements-vertical': {
            group: 'distribute',
            title: translate('Distribute elements vertically'),
            imageUrl: (0, _distributeElementsIconsDefault.default)['vertical'],
            action: function(event, entry) {
                distributeElements.trigger(elements, 'vertical');
                popupMenu.close();
            }
        }
    };
    return entries;
};

},{"./DistributeElementsIcons":"kzVoF","min-dash":"aEEla","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kzVoF":[function(require,module,exports,__globalThis) {
/**
 * To change the icons, modify the SVGs in `./resources`, execute `npx svgo -f resources --datauri enc -o dist`,
 * and then replace respective icons with the optimized data URIs in `./dist`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var icons = {
    horizontal: 'data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%201800%201800%22%3E%3Cpath%20style%3D%22fill%3Anone%3Bstroke%3AcurrentColor%3Bstroke-width%3A100%3Bstroke-linejoin%3Around%22%20d%3D%22M450%20400V150h900v250%22%2F%3E%3Crect%20x%3D%22150%22%20y%3D%22450%22%20width%3D%22600%22%20height%3D%221200%22%20rx%3D%221%22%20style%3D%22fill%3Anone%3Bstroke%3AcurrentColor%3Bstroke-width%3A100%22%2F%3E%3Crect%20x%3D%221050%22%20y%3D%22450%22%20width%3D%22600%22%20height%3D%22800%22%20rx%3D%221%22%20style%3D%22fill%3AcurrentColor%3Bstroke%3AcurrentColor%3Bstroke-width%3A100%3Bopacity%3A.5%22%2F%3E%3C%2Fsvg%3E',
    vertical: 'data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%201800%201800%22%3E%3Cpath%20style%3D%22fill%3Anone%3Bstroke%3AcurrentColor%3Bstroke-width%3A100%3Bstroke-linejoin%3Around%22%20d%3D%22M400%201350H150V450h250%22%2F%3E%3Crect%20x%3D%22450%22%20y%3D%22150%22%20width%3D%221200%22%20height%3D%22600%22%20rx%3D%221%22%20style%3D%22fill%3Anone%3Bstroke%3AcurrentColor%3Bstroke-width%3A100%22%2F%3E%3Crect%20x%3D%22450%22%20y%3D%221050%22%20width%3D%22800%22%20height%3D%22600%22%20rx%3D%221%22%20style%3D%22fill%3AcurrentColor%3Bstroke%3AcurrentColor%3Bstroke-width%3A100%3Bopacity%3A.5%22%2F%3E%3C%2Fsvg%3E'
};
exports.default = icons;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aU1yp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _editorActions = require("diagram-js/lib/features/editor-actions");
var _editorActionsDefault = parcelHelpers.interopDefault(_editorActions);
var _bpmnEditorActions = require("./BpmnEditorActions");
var _bpmnEditorActionsDefault = parcelHelpers.interopDefault(_bpmnEditorActions);
exports.default = {
    __depends__: [
        (0, _editorActionsDefault.default)
    ],
    editorActions: [
        'type',
        (0, _bpmnEditorActionsDefault.default)
    ]
};

},{"diagram-js/lib/features/editor-actions":"80Xm3","./BpmnEditorActions":"aLOFI","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"80Xm3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _editorActions = require("./EditorActions");
var _editorActionsDefault = parcelHelpers.interopDefault(_editorActions);
exports.default = {
    __init__: [
        'editorActions'
    ],
    editorActions: [
        'type',
        (0, _editorActionsDefault.default)
    ]
};

},{"./EditorActions":"k6wAu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"k6wAu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>EditorActions);
var _minDash = require("min-dash");
/**
 * @typedef {import('didi').Injector} Injector
 *
 * @typedef {import('../../core/EventBus').default} EventBus
 */ var NOT_REGISTERED_ERROR = 'is not a registered action', IS_REGISTERED_ERROR = 'is already registered';
function EditorActions(eventBus, injector) {
    // initialize actions
    this._actions = {};
    var self = this;
    eventBus.on('diagram.init', function() {
        // all diagram modules got loaded; check which ones
        // are available and register the respective default actions
        self._registerDefaultActions(injector);
        // ask interested parties to register available editor
        // actions on diagram initialization
        eventBus.fire('editorActions.init', {
            editorActions: self
        });
    });
}
EditorActions.$inject = [
    'eventBus',
    'injector'
];
/**
 * Register default actions.
 *
 * @param {Injector} injector
 */ EditorActions.prototype._registerDefaultActions = function(injector) {
    // (1) retrieve optional components to integrate with
    var commandStack = injector.get('commandStack', false);
    var modeling = injector.get('modeling', false);
    var selection = injector.get('selection', false);
    var zoomScroll = injector.get('zoomScroll', false);
    var copyPaste = injector.get('copyPaste', false);
    var canvas = injector.get('canvas', false);
    var rules = injector.get('rules', false);
    var keyboardMove = injector.get('keyboardMove', false);
    var keyboardMoveSelection = injector.get('keyboardMoveSelection', false);
    // (2) check components and register actions
    if (commandStack) {
        this.register('undo', function() {
            commandStack.undo();
        });
        this.register('redo', function() {
            commandStack.redo();
        });
    }
    if (copyPaste && selection) this.register('copy', function() {
        var selectedElements = selection.get();
        if (selectedElements.length) return copyPaste.copy(selectedElements);
    });
    if (copyPaste) this.register('paste', function() {
        copyPaste.paste();
    });
    if (zoomScroll) this.register('stepZoom', function(opts) {
        zoomScroll.stepZoom(opts.value);
    });
    if (canvas) this.register('zoom', function(opts) {
        canvas.zoom(opts.value);
    });
    if (modeling && selection && rules) this.register('removeSelection', function() {
        var selectedElements = selection.get();
        if (!selectedElements.length) return;
        var allowed = rules.allowed('elements.delete', {
            elements: selectedElements
        }), removableElements;
        if (allowed === false) return;
        else if ((0, _minDash.isArray)(allowed)) removableElements = allowed;
        else removableElements = selectedElements;
        if (removableElements.length) modeling.removeElements(removableElements.slice());
    });
    if (keyboardMove) this.register('moveCanvas', function(opts) {
        keyboardMove.moveCanvas(opts);
    });
    if (keyboardMoveSelection) this.register('moveSelection', function(opts) {
        keyboardMoveSelection.moveSelection(opts.direction, opts.accelerated);
    });
};
/**
 * Triggers a registered action
 *
 * @param {string} action
 * @param {Object} opts
 *
 * @return {Unknown} Returns what the registered listener returns
 */ EditorActions.prototype.trigger = function(action, opts) {
    if (!this._actions[action]) throw error(action, NOT_REGISTERED_ERROR);
    return this._actions[action](opts);
};
/**
 * Registers a collections of actions.
 * The key of the object will be the name of the action.
 *
 * @example
 * ´´´
 * var actions = {
 *   spaceTool: function() {
 *     spaceTool.activateSelection();
 *   },
 *   lassoTool: function() {
 *     lassoTool.activateSelection();
 *   }
 * ];
 *
 * editorActions.register(actions);
 *
 * editorActions.isRegistered('spaceTool'); // true
 * ´´´
 *
 * @param {Object} actions
 */ EditorActions.prototype.register = function(actions, listener) {
    var self = this;
    if (typeof actions === 'string') return this._registerAction(actions, listener);
    (0, _minDash.forEach)(actions, function(listener, action) {
        self._registerAction(action, listener);
    });
};
/**
 * Registers a listener to an action key
 *
 * @param {string} action
 * @param {Function} listener
 */ EditorActions.prototype._registerAction = function(action, listener) {
    if (this.isRegistered(action)) throw error(action, IS_REGISTERED_ERROR);
    this._actions[action] = listener;
};
/**
 * Unregister an existing action
 *
 * @param {string} action
 */ EditorActions.prototype.unregister = function(action) {
    if (!this.isRegistered(action)) throw error(action, NOT_REGISTERED_ERROR);
    this._actions[action] = undefined;
};
/**
 * Returns the number of actions that are currently registered
 *
 * @return {number}
 */ EditorActions.prototype.getActions = function() {
    return Object.keys(this._actions);
};
/**
 * Checks wether the given action is registered
 *
 * @param {string} action
 *
 * @return {boolean}
 */ EditorActions.prototype.isRegistered = function(action) {
    return !!this._actions[action];
};
function error(action, message) {
    return new Error(action + ' ' + message);
}

},{"min-dash":"aEEla","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aLOFI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BpmnEditorActions);
var _inheritsBrowser = require("inherits-browser");
var _inheritsBrowserDefault = parcelHelpers.interopDefault(_inheritsBrowser);
var _editorActions = require("diagram-js/lib/features/editor-actions/EditorActions");
var _editorActionsDefault = parcelHelpers.interopDefault(_editorActions);
var _minDash = require("min-dash");
var _modelUtil = require("../../util/ModelUtil");
var _elements = require("diagram-js/lib/util/Elements");
function BpmnEditorActions(injector) {
    injector.invoke((0, _editorActionsDefault.default), this);
}
(0, _inheritsBrowserDefault.default)(BpmnEditorActions, (0, _editorActionsDefault.default));
BpmnEditorActions.$inject = [
    'injector'
];
/**
 * Register default actions.
 *
 * @param {Injector} injector
 */ BpmnEditorActions.prototype._registerDefaultActions = function(injector) {
    // (0) invoke super method
    (0, _editorActionsDefault.default).prototype._registerDefaultActions.call(this, injector);
    // (1) retrieve optional components to integrate with
    var canvas = injector.get('canvas', false);
    var elementRegistry = injector.get('elementRegistry', false);
    var selection = injector.get('selection', false);
    var spaceTool = injector.get('spaceTool', false);
    var lassoTool = injector.get('lassoTool', false);
    var handTool = injector.get('handTool', false);
    var globalConnect = injector.get('globalConnect', false);
    var distributeElements = injector.get('distributeElements', false);
    var alignElements = injector.get('alignElements', false);
    var directEditing = injector.get('directEditing', false);
    var searchPad = injector.get('searchPad', false);
    var modeling = injector.get('modeling', false);
    var contextPad = injector.get('contextPad', false);
    // (2) check components and register actions
    if (canvas && elementRegistry && selection) this._registerAction('selectElements', function() {
        // select all elements except for the invisible
        // root element
        var rootElement = canvas.getRootElement();
        var elements = elementRegistry.filter(function(element) {
            return element !== rootElement;
        });
        selection.select(elements);
        return elements;
    });
    if (spaceTool) this._registerAction('spaceTool', function() {
        spaceTool.toggle();
    });
    if (lassoTool) this._registerAction('lassoTool', function() {
        lassoTool.toggle();
    });
    if (handTool) this._registerAction('handTool', function() {
        handTool.toggle();
    });
    if (globalConnect) this._registerAction('globalConnectTool', function() {
        globalConnect.toggle();
    });
    if (selection && distributeElements) this._registerAction('distributeElements', function(opts) {
        var currentSelection = selection.get(), type = opts.type;
        if (currentSelection.length) distributeElements.trigger(currentSelection, type);
    });
    if (selection && alignElements) this._registerAction('alignElements', function(opts) {
        var currentSelection = selection.get(), aligneableElements = [], type = opts.type;
        if (currentSelection.length) {
            aligneableElements = (0, _minDash.filter)(currentSelection, function(element) {
                return !(0, _modelUtil.is)(element, 'bpmn:Lane');
            });
            alignElements.trigger(aligneableElements, type);
        }
    });
    if (selection && modeling) this._registerAction('setColor', function(opts) {
        var currentSelection = selection.get();
        if (currentSelection.length) modeling.setColor(currentSelection, opts);
    });
    if (selection && directEditing) this._registerAction('directEditing', function() {
        var currentSelection = selection.get();
        if (currentSelection.length) directEditing.activate(currentSelection[0]);
    });
    if (searchPad) this._registerAction('find', function() {
        searchPad.toggle();
    });
    if (canvas && modeling) this._registerAction('moveToOrigin', function() {
        var rootElement = canvas.getRootElement(), boundingBox, elements;
        if ((0, _modelUtil.is)(rootElement, 'bpmn:Collaboration')) elements = elementRegistry.filter(function(element) {
            return (0, _modelUtil.is)(element.parent, 'bpmn:Collaboration');
        });
        else elements = elementRegistry.filter(function(element) {
            return element !== rootElement && !(0, _modelUtil.is)(element.parent, 'bpmn:SubProcess');
        });
        boundingBox = (0, _elements.getBBox)(elements);
        modeling.moveElements(elements, {
            x: -boundingBox.x,
            y: -boundingBox.y
        }, rootElement);
    });
    if (selection && contextPad) this._registerAction('replaceElement', function(event) {
        contextPad.triggerEntry('replace', 'click', event);
    });
};

},{"inherits-browser":"hymxq","diagram-js/lib/features/editor-actions/EditorActions":"k6wAu","min-dash":"aEEla","../../util/ModelUtil":"klNYN","diagram-js/lib/util/Elements":"6qdtl","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"h0W2n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _bpmnGridSnapping = require("./BpmnGridSnapping");
var _bpmnGridSnappingDefault = parcelHelpers.interopDefault(_bpmnGridSnapping);
var _gridSnapping = require("diagram-js/lib/features/grid-snapping");
var _gridSnappingDefault = parcelHelpers.interopDefault(_gridSnapping);
var _behavior = require("./behavior");
var _behaviorDefault = parcelHelpers.interopDefault(_behavior);
exports.default = {
    __depends__: [
        (0, _gridSnappingDefault.default),
        (0, _behaviorDefault.default)
    ],
    __init__: [
        'bpmnGridSnapping'
    ],
    bpmnGridSnapping: [
        'type',
        (0, _bpmnGridSnappingDefault.default)
    ]
};

},{"./BpmnGridSnapping":"4HmJt","diagram-js/lib/features/grid-snapping":"4wtsX","./behavior":"ind8m","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4HmJt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BpmnGridSnapping);
var _modelingUtil = require("../modeling/util/ModelingUtil");
function BpmnGridSnapping(eventBus) {
    eventBus.on([
        'create.init',
        'shape.move.init'
    ], function(event) {
        var context = event.context, shape = event.shape;
        if ((0, _modelingUtil.isAny)(shape, [
            'bpmn:Participant',
            'bpmn:SubProcess',
            'bpmn:TextAnnotation'
        ])) {
            if (!context.gridSnappingContext) context.gridSnappingContext = {};
            context.gridSnappingContext.snapLocation = 'top-left';
        }
    });
}
BpmnGridSnapping.$inject = [
    'eventBus'
];

},{"../modeling/util/ModelingUtil":"4DR1e","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4wtsX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _gridSnapping = require("./GridSnapping");
var _gridSnappingDefault = parcelHelpers.interopDefault(_gridSnapping);
var _behavior = require("./behavior");
var _behaviorDefault = parcelHelpers.interopDefault(_behavior);
exports.default = {
    __depends__: [
        (0, _behaviorDefault.default)
    ],
    __init__: [
        'gridSnapping'
    ],
    gridSnapping: [
        'type',
        (0, _gridSnappingDefault.default)
    ]
};

},{"./GridSnapping":"aNAbJ","./behavior":"2zlm0","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aNAbJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>GridSnapping);
var _snapUtil = require("../snapping/SnapUtil");
var _keyboardUtil = require("../keyboard/KeyboardUtil");
var _minDash = require("min-dash");
var _gridUtil = require("./GridUtil");
/**
 * @typedef {import('../../core/ElementRegistry').default} ElementRegistry
 * @typedef {import('../../core/EventBus').default} EventBus
 */ var LOWER_PRIORITY = 1200;
var LOW_PRIORITY = 800;
function GridSnapping(elementRegistry, eventBus, config) {
    var active = !config || config.active !== false;
    this._eventBus = eventBus;
    var self = this;
    eventBus.on('diagram.init', LOW_PRIORITY, function() {
        self.setActive(active);
    });
    eventBus.on([
        'create.move',
        'create.end',
        'bendpoint.move.move',
        'bendpoint.move.end',
        'connect.move',
        'connect.end',
        'connectionSegment.move.move',
        'connectionSegment.move.end',
        'resize.move',
        'resize.end',
        'shape.move.move',
        'shape.move.end'
    ], LOWER_PRIORITY, function(event) {
        var originalEvent = event.originalEvent;
        if (!self.active || originalEvent && (0, _keyboardUtil.isCmd)(originalEvent)) return;
        var context = event.context, gridSnappingContext = context.gridSnappingContext;
        if (!gridSnappingContext) gridSnappingContext = context.gridSnappingContext = {};
        [
            'x',
            'y'
        ].forEach(function(axis) {
            var options = {};
            // allow snapping with offset
            var snapOffset = getSnapOffset(event, axis, elementRegistry);
            if (snapOffset) options.offset = snapOffset;
            // allow snapping with min and max
            var snapConstraints = getSnapConstraints(event, axis);
            if (snapConstraints) (0, _minDash.assign)(options, snapConstraints);
            if (!(0, _snapUtil.isSnapped)(event, axis)) self.snapEvent(event, axis, options);
        });
    });
}
/**
 * Snap an events x or y with optional min, max and offset.
 *
 * @param {Object} event
 * @param {string} axis
 * @param {number} [options.min]
 * @param {number} [options.max]
 * @param {number} [options.offset]
 */ GridSnapping.prototype.snapEvent = function(event, axis, options) {
    var snappedValue = this.snapValue(event[axis], options);
    (0, _snapUtil.setSnapped)(event, axis, snappedValue);
};
/**
 * Expose grid spacing for third parties (i.e. extensions).
 *
 * @return {number} spacing of grid dots
 */ GridSnapping.prototype.getGridSpacing = function() {
    return 0, _gridUtil.SPACING;
};
/**
 * Snap value with optional min, max and offset.
 *
 * @param {number} value
 * @param {Object} options
 * @param {number} [options.min]
 * @param {number} [options.max]
 * @param {number} [options.offset]
 */ GridSnapping.prototype.snapValue = function(value, options) {
    var offset = 0;
    if (options && options.offset) offset = options.offset;
    value += offset;
    value = (0, _gridUtil.quantize)(value, (0, _gridUtil.SPACING));
    var min, max;
    if (options && options.min) {
        min = options.min;
        if ((0, _minDash.isNumber)(min)) {
            min = (0, _gridUtil.quantize)(min + offset, (0, _gridUtil.SPACING), 'ceil');
            value = Math.max(value, min);
        }
    }
    if (options && options.max) {
        max = options.max;
        if ((0, _minDash.isNumber)(max)) {
            max = (0, _gridUtil.quantize)(max + offset, (0, _gridUtil.SPACING), 'floor');
            value = Math.min(value, max);
        }
    }
    value -= offset;
    return value;
};
GridSnapping.prototype.isActive = function() {
    return this.active;
};
GridSnapping.prototype.setActive = function(active) {
    this.active = active;
    this._eventBus.fire('gridSnapping.toggle', {
        active: active
    });
};
GridSnapping.prototype.toggleActive = function() {
    this.setActive(!this.active);
};
GridSnapping.$inject = [
    'elementRegistry',
    'eventBus',
    'config.gridSnapping'
];
// helpers //////////
/**
 * Get minimum and maximum snap constraints.
 * Constraints are cached.
 *
 * @param {Object} event
 * @param {Object} event.context
 * @param {string} axis
 *
 * @returns {boolean|Object}
 */ function getSnapConstraints(event, axis) {
    var context = event.context, createConstraints = context.createConstraints, resizeConstraints = context.resizeConstraints || {}, gridSnappingContext = context.gridSnappingContext, snapConstraints = gridSnappingContext.snapConstraints;
    // cache snap constraints
    if (snapConstraints && snapConstraints[axis]) return snapConstraints[axis];
    if (!snapConstraints) snapConstraints = gridSnappingContext.snapConstraints = {};
    if (!snapConstraints[axis]) snapConstraints[axis] = {};
    var direction = context.direction;
    // create
    if (createConstraints) {
        if (isHorizontal(axis)) {
            snapConstraints.x.min = createConstraints.left;
            snapConstraints.x.max = createConstraints.right;
        } else {
            snapConstraints.y.min = createConstraints.top;
            snapConstraints.y.max = createConstraints.bottom;
        }
    }
    // resize
    var minResizeConstraints = resizeConstraints.min, maxResizeConstraints = resizeConstraints.max;
    if (minResizeConstraints) {
        if (isHorizontal(axis)) {
            if (isWest(direction)) snapConstraints.x.max = minResizeConstraints.left;
            else snapConstraints.x.min = minResizeConstraints.right;
        } else if (isNorth(direction)) snapConstraints.y.max = minResizeConstraints.top;
        else snapConstraints.y.min = minResizeConstraints.bottom;
    }
    if (maxResizeConstraints) {
        if (isHorizontal(axis)) {
            if (isWest(direction)) snapConstraints.x.min = maxResizeConstraints.left;
            else snapConstraints.x.max = maxResizeConstraints.right;
        } else if (isNorth(direction)) snapConstraints.y.min = maxResizeConstraints.top;
        else snapConstraints.y.max = maxResizeConstraints.bottom;
    }
    return snapConstraints[axis];
}
/**
 * Get snap offset.
 * Offset is cached.
 *
 * @param {Object} event
 * @param {string} axis
 * @param {ElementRegistry} elementRegistry
 *
 * @returns {number}
 */ function getSnapOffset(event, axis, elementRegistry) {
    var context = event.context, shape = event.shape, gridSnappingContext = context.gridSnappingContext, snapLocation = gridSnappingContext.snapLocation, snapOffset = gridSnappingContext.snapOffset;
    // cache snap offset
    if (snapOffset && (0, _minDash.isNumber)(snapOffset[axis])) return snapOffset[axis];
    if (!snapOffset) snapOffset = gridSnappingContext.snapOffset = {};
    if (!(0, _minDash.isNumber)(snapOffset[axis])) snapOffset[axis] = 0;
    if (!shape) return snapOffset[axis];
    if (!elementRegistry.get(shape.id)) {
        if (isHorizontal(axis)) snapOffset[axis] += shape[axis] + shape.width / 2;
        else snapOffset[axis] += shape[axis] + shape.height / 2;
    }
    if (!snapLocation) return snapOffset[axis];
    if (axis === 'x') {
        if (/left/.test(snapLocation)) snapOffset[axis] -= shape.width / 2;
        else if (/right/.test(snapLocation)) snapOffset[axis] += shape.width / 2;
    } else {
        if (/top/.test(snapLocation)) snapOffset[axis] -= shape.height / 2;
        else if (/bottom/.test(snapLocation)) snapOffset[axis] += shape.height / 2;
    }
    return snapOffset[axis];
}
function isHorizontal(axis) {
    return axis === 'x';
}
function isNorth(direction) {
    return direction.indexOf('n') !== -1;
}
function isWest(direction) {
    return direction.indexOf('w') !== -1;
}

},{"../snapping/SnapUtil":"fu3Zv","../keyboard/KeyboardUtil":"2Asg4","min-dash":"aEEla","./GridUtil":"8Kp2B","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8Kp2B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SPACING", ()=>SPACING);
parcelHelpers.export(exports, "quantize", ()=>quantize);
var SPACING = 10;
function quantize(value, quantum, fn) {
    if (!fn) fn = 'round';
    return Math[fn](value / quantum) * quantum;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2zlm0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _resizeBehavior = require("./ResizeBehavior");
var _resizeBehaviorDefault = parcelHelpers.interopDefault(_resizeBehavior);
var _spaceToolBehavior = require("./SpaceToolBehavior");
var _spaceToolBehaviorDefault = parcelHelpers.interopDefault(_spaceToolBehavior);
exports.default = {
    __init__: [
        'gridSnappingResizeBehavior',
        'gridSnappingSpaceToolBehavior'
    ],
    gridSnappingResizeBehavior: [
        'type',
        (0, _resizeBehaviorDefault.default)
    ],
    gridSnappingSpaceToolBehavior: [
        'type',
        (0, _spaceToolBehaviorDefault.default)
    ]
};

},{"./ResizeBehavior":"dpWXT","./SpaceToolBehavior":"5E1Rn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dpWXT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ResizeBehavior);
var _inheritsBrowser = require("inherits-browser");
var _inheritsBrowserDefault = parcelHelpers.interopDefault(_inheritsBrowser);
var _commandInterceptor = require("../../../command/CommandInterceptor");
var _commandInterceptorDefault = parcelHelpers.interopDefault(_commandInterceptor);
var _minDash = require("min-dash");
function ResizeBehavior(eventBus, gridSnapping) {
    (0, _commandInterceptorDefault.default).call(this, eventBus);
    this._gridSnapping = gridSnapping;
    var self = this;
    this.preExecute('shape.resize', function(event) {
        var context = event.context, hints = context.hints || {}, autoResize = hints.autoResize;
        if (!autoResize) return;
        var shape = context.shape, newBounds = context.newBounds;
        if ((0, _minDash.isString)(autoResize)) context.newBounds = self.snapComplex(newBounds, autoResize);
        else context.newBounds = self.snapSimple(shape, newBounds);
    });
}
ResizeBehavior.$inject = [
    'eventBus',
    'gridSnapping',
    'modeling'
];
(0, _inheritsBrowserDefault.default)(ResizeBehavior, (0, _commandInterceptorDefault.default));
/**
 * Snap width and height in relation to center.
 *
 * @param {Shape} shape
 * @param {Rect} newBounds
 *
 * @returns {Rect} Snapped bounds.
 */ ResizeBehavior.prototype.snapSimple = function(shape, newBounds) {
    var gridSnapping = this._gridSnapping;
    newBounds.width = gridSnapping.snapValue(newBounds.width, {
        min: newBounds.width
    });
    newBounds.height = gridSnapping.snapValue(newBounds.height, {
        min: newBounds.height
    });
    newBounds.x = shape.x + shape.width / 2 - newBounds.width / 2;
    newBounds.y = shape.y + shape.height / 2 - newBounds.height / 2;
    return newBounds;
};
/**
 * Snap x, y, width and height according to given directions.
 *
 * @param {Rect} newBounds
 * @param {string} directions - Directions as {n|w|s|e}.
 *
 * @returns {Rect} Snapped bounds.
 */ ResizeBehavior.prototype.snapComplex = function(newBounds, directions) {
    if (/w|e/.test(directions)) newBounds = this.snapHorizontally(newBounds, directions);
    if (/n|s/.test(directions)) newBounds = this.snapVertically(newBounds, directions);
    return newBounds;
};
/**
 * Snap in one or both directions horizontally.
 *
 * @param {Rect} newBounds
 * @param {string} directions - Directions as {n|w|s|e}.
 *
 * @returns {Rect} Snapped bounds.
 */ ResizeBehavior.prototype.snapHorizontally = function(newBounds, directions) {
    var gridSnapping = this._gridSnapping, west = /w/.test(directions), east = /e/.test(directions);
    var snappedNewBounds = {};
    snappedNewBounds.width = gridSnapping.snapValue(newBounds.width, {
        min: newBounds.width
    });
    if (east) {
        // handle <we>
        if (west) {
            snappedNewBounds.x = gridSnapping.snapValue(newBounds.x, {
                max: newBounds.x
            });
            snappedNewBounds.width += gridSnapping.snapValue(newBounds.x - snappedNewBounds.x, {
                min: newBounds.x - snappedNewBounds.x
            });
        } else newBounds.x = newBounds.x + newBounds.width - snappedNewBounds.width;
    }
    // assign snapped x and width
    (0, _minDash.assign)(newBounds, snappedNewBounds);
    return newBounds;
};
/**
 * Snap in one or both directions vertically.
 *
 * @param {Rect} newBounds
 * @param {string} directions - Directions as {n|w|s|e}.
 *
 * @returns {Rect} Snapped bounds.
 */ ResizeBehavior.prototype.snapVertically = function(newBounds, directions) {
    var gridSnapping = this._gridSnapping, north = /n/.test(directions), south = /s/.test(directions);
    var snappedNewBounds = {};
    snappedNewBounds.height = gridSnapping.snapValue(newBounds.height, {
        min: newBounds.height
    });
    if (north) {
        // handle <ns>
        if (south) {
            snappedNewBounds.y = gridSnapping.snapValue(newBounds.y, {
                max: newBounds.y
            });
            snappedNewBounds.height += gridSnapping.snapValue(newBounds.y - snappedNewBounds.y, {
                min: newBounds.y - snappedNewBounds.y
            });
        } else newBounds.y = newBounds.y + newBounds.height - snappedNewBounds.height;
    }
    // assign snapped y and height
    (0, _minDash.assign)(newBounds, snappedNewBounds);
    return newBounds;
};

},{"inherits-browser":"hymxq","../../../command/CommandInterceptor":"1K1IQ","min-dash":"aEEla","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5E1Rn":[function(require,module,exports,__globalThis) {
/**
 * @typedef {import('../../../core/EventBus').default} EventBus
 * @typedef {import('../../grid-snapping/GridSnapping').default} GridSnapping
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SpaceToolBehavior);
var HIGH_PRIORITY = 2000;
function SpaceToolBehavior(eventBus, gridSnapping) {
    eventBus.on([
        'spaceTool.move',
        'spaceTool.end'
    ], HIGH_PRIORITY, function(event) {
        var context = event.context;
        if (!context.initialized) return;
        var axis = context.axis;
        var snapped;
        if (axis === 'x') {
            // snap delta x to multiple of 10
            snapped = gridSnapping.snapValue(event.dx);
            event.x = event.x + snapped - event.dx;
            event.dx = snapped;
        } else {
            // snap delta y to multiple of 10
            snapped = gridSnapping.snapValue(event.dy);
            event.y = event.y + snapped - event.dy;
            event.dy = snapped;
        }
    });
}
SpaceToolBehavior.$inject = [
    'eventBus',
    'gridSnapping'
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ind8m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _gridSnappingAutoPlaceBehavior = require("./GridSnappingAutoPlaceBehavior");
var _gridSnappingAutoPlaceBehaviorDefault = parcelHelpers.interopDefault(_gridSnappingAutoPlaceBehavior);
var _gridSnappingParticipantBehavior = require("./GridSnappingParticipantBehavior");
var _gridSnappingParticipantBehaviorDefault = parcelHelpers.interopDefault(_gridSnappingParticipantBehavior);
var _gridSnappingLayoutConnectionBehavior = require("./GridSnappingLayoutConnectionBehavior");
var _gridSnappingLayoutConnectionBehaviorDefault = parcelHelpers.interopDefault(_gridSnappingLayoutConnectionBehavior);
exports.default = {
    __init__: [
        'gridSnappingAutoPlaceBehavior',
        'gridSnappingParticipantBehavior',
        'gridSnappingLayoutConnectionBehavior'
    ],
    gridSnappingAutoPlaceBehavior: [
        'type',
        (0, _gridSnappingAutoPlaceBehaviorDefault.default)
    ],
    gridSnappingParticipantBehavior: [
        'type',
        (0, _gridSnappingParticipantBehaviorDefault.default)
    ],
    gridSnappingLayoutConnectionBehavior: [
        'type',
        (0, _gridSnappingLayoutConnectionBehaviorDefault.default)
    ]
};

},{"./GridSnappingAutoPlaceBehavior":"aDLpq","./GridSnappingParticipantBehavior":"16UF5","./GridSnappingLayoutConnectionBehavior":"arkYu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aDLpq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>GridSnappingAutoPlaceBehavior);
var _bpmnAutoPlaceUtil = require("../../auto-place/BpmnAutoPlaceUtil");
var _layoutUtil = require("diagram-js/lib/layout/LayoutUtil");
var _modelUtil = require("../../../util/ModelUtil");
var HIGH_PRIORITY = 2000;
function GridSnappingAutoPlaceBehavior(eventBus, gridSnapping) {
    eventBus.on('autoPlace', HIGH_PRIORITY, function(context) {
        var source = context.source, sourceMid = (0, _layoutUtil.getMid)(source), shape = context.shape;
        var position = (0, _bpmnAutoPlaceUtil.getNewShapePosition)(source, shape);
        [
            'x',
            'y'
        ].forEach(function(axis) {
            var options = {};
            // do not snap if x/y equal
            if (position[axis] === sourceMid[axis]) return;
            if (position[axis] > sourceMid[axis]) options.min = position[axis];
            else options.max = position[axis];
            if ((0, _modelUtil.is)(shape, 'bpmn:TextAnnotation')) {
                if (isHorizontal(axis)) options.offset = -shape.width / 2;
                else options.offset = -shape.height / 2;
            }
            position[axis] = gridSnapping.snapValue(position[axis], options);
        });
        // must be returned to be considered by auto place
        return position;
    });
}
GridSnappingAutoPlaceBehavior.$inject = [
    'eventBus',
    'gridSnapping'
];
// helpers //////////
function isHorizontal(axis) {
    return axis === 'x';
}

},{"../../auto-place/BpmnAutoPlaceUtil":"gZem1","diagram-js/lib/layout/LayoutUtil":"4CCrs","../../../util/ModelUtil":"klNYN","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"16UF5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>GridSnappingParticipantBehavior);
var _modelUtil = require("../../../util/ModelUtil");
var HIGHER_PRIORITY = 1750;
function GridSnappingParticipantBehavior(canvas, eventBus, gridSnapping) {
    eventBus.on([
        'create.start',
        'shape.move.start'
    ], HIGHER_PRIORITY, function(event) {
        var context = event.context, shape = context.shape, rootElement = canvas.getRootElement();
        if (!(0, _modelUtil.is)(shape, 'bpmn:Participant') || !(0, _modelUtil.is)(rootElement, 'bpmn:Process') || !rootElement.children.length) return;
        var createConstraints = context.createConstraints;
        if (!createConstraints) return;
        shape.width = gridSnapping.snapValue(shape.width, {
            min: shape.width
        });
        shape.height = gridSnapping.snapValue(shape.height, {
            min: shape.height
        });
    });
}
GridSnappingParticipantBehavior.$inject = [
    'canvas',
    'eventBus',
    'gridSnapping'
];

},{"../../../util/ModelUtil":"klNYN","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"arkYu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>GridSnappingLayoutConnectionBehavior);
var _inheritsBrowser = require("inherits-browser");
var _inheritsBrowserDefault = parcelHelpers.interopDefault(_inheritsBrowser);
var _commandInterceptor = require("diagram-js/lib/command/CommandInterceptor");
var _commandInterceptorDefault = parcelHelpers.interopDefault(_commandInterceptor);
var _geometry = require("diagram-js/lib/util/Geometry");
var _minDash = require("min-dash");
var HIGH_PRIORITY = 3000;
function GridSnappingLayoutConnectionBehavior(eventBus, gridSnapping, modeling) {
    (0, _commandInterceptorDefault.default).call(this, eventBus);
    this._gridSnapping = gridSnapping;
    var self = this;
    this.postExecuted([
        'connection.create',
        'connection.layout'
    ], HIGH_PRIORITY, function(event) {
        var context = event.context, connection = context.connection, hints = context.hints || {}, waypoints = connection.waypoints;
        if (hints.connectionStart || hints.connectionEnd || hints.createElementsBehavior === false) return;
        if (!hasMiddleSegments(waypoints)) return;
        modeling.updateWaypoints(connection, self.snapMiddleSegments(waypoints));
    });
}
GridSnappingLayoutConnectionBehavior.$inject = [
    'eventBus',
    'gridSnapping',
    'modeling'
];
(0, _inheritsBrowserDefault.default)(GridSnappingLayoutConnectionBehavior, (0, _commandInterceptorDefault.default));
/**
 * Snap middle segments of a given connection.
 *
 * @param {Array<Point>} waypoints
 *
 * @returns {Array<Point>}
 */ GridSnappingLayoutConnectionBehavior.prototype.snapMiddleSegments = function(waypoints) {
    var gridSnapping = this._gridSnapping, snapped;
    waypoints = waypoints.slice();
    for(var i = 1; i < waypoints.length - 2; i++){
        snapped = snapSegment(gridSnapping, waypoints[i], waypoints[i + 1]);
        waypoints[i] = snapped[0];
        waypoints[i + 1] = snapped[1];
    }
    return waypoints;
};
// helpers //////////
/**
 * Check whether a connection has a middle segments.
 *
 * @param {Array} waypoints
 *
 * @returns {boolean}
 */ function hasMiddleSegments(waypoints) {
    return waypoints.length > 3;
}
/**
 * Check whether an alignment is horizontal.
 *
 * @param {string} aligned
 *
 * @returns {boolean}
 */ function horizontallyAligned(aligned) {
    return aligned === 'h';
}
/**
 * Check whether an alignment is vertical.
 *
 * @param {string} aligned
 *
 * @returns {boolean}
 */ function verticallyAligned(aligned) {
    return aligned === 'v';
}
/**
 * Get middle segments from a given connection.
 *
 * @param {Array} waypoints
 *
 * @returns {Array}
 */ function snapSegment(gridSnapping, segmentStart, segmentEnd) {
    var aligned = (0, _geometry.pointsAligned)(segmentStart, segmentEnd);
    var snapped = {};
    if (horizontallyAligned(aligned)) // snap horizontally
    snapped.y = gridSnapping.snapValue(segmentStart.y);
    if (verticallyAligned(aligned)) // snap vertically
    snapped.x = gridSnapping.snapValue(segmentStart.x);
    if ('x' in snapped || 'y' in snapped) {
        segmentStart = (0, _minDash.assign)({}, segmentStart, snapped);
        segmentEnd = (0, _minDash.assign)({}, segmentEnd, snapped);
    }
    return [
        segmentStart,
        segmentEnd
    ];
}

},{"inherits-browser":"hymxq","diagram-js/lib/command/CommandInterceptor":"1K1IQ","diagram-js/lib/util/Geometry":"1zZUi","min-dash":"aEEla","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hZwfY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _bpmnInteractionEvents = require("./BpmnInteractionEvents");
var _bpmnInteractionEventsDefault = parcelHelpers.interopDefault(_bpmnInteractionEvents);
exports.default = {
    __init__: [
        'bpmnInteractionEvents'
    ],
    bpmnInteractionEvents: [
        'type',
        (0, _bpmnInteractionEventsDefault.default)
    ]
};

},{"./BpmnInteractionEvents":"edmY1","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"edmY1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BpmnInteractionEvents);
var _modelUtil = require("../../util/ModelUtil");
var _diUtil = require("../../util/DiUtil");
var LABEL_WIDTH = 30, LABEL_HEIGHT = 30;
function BpmnInteractionEvents(eventBus, interactionEvents) {
    this._interactionEvents = interactionEvents;
    var self = this;
    eventBus.on([
        'interactionEvents.createHit',
        'interactionEvents.updateHit'
    ], function(context) {
        var element = context.element, gfx = context.gfx;
        if ((0, _modelUtil.is)(element, 'bpmn:Lane')) return self.createParticipantHit(element, gfx);
        else if ((0, _modelUtil.is)(element, 'bpmn:Participant')) {
            if ((0, _diUtil.isExpanded)(element)) return self.createParticipantHit(element, gfx);
            else return self.createDefaultHit(element, gfx);
        } else if ((0, _modelUtil.is)(element, 'bpmn:SubProcess')) {
            if ((0, _diUtil.isExpanded)(element)) return self.createSubProcessHit(element, gfx);
            else return self.createDefaultHit(element, gfx);
        }
    });
}
BpmnInteractionEvents.$inject = [
    'eventBus',
    'interactionEvents'
];
BpmnInteractionEvents.prototype.createDefaultHit = function(element, gfx) {
    this._interactionEvents.removeHits(gfx);
    this._interactionEvents.createDefaultHit(element, gfx);
    // indicate that we created a hit
    return true;
};
BpmnInteractionEvents.prototype.createParticipantHit = function(element, gfx) {
    // remove existing hits
    this._interactionEvents.removeHits(gfx);
    // add body hit
    this._interactionEvents.createBoxHit(gfx, 'no-move', {
        width: element.width,
        height: element.height
    });
    // add outline hit
    this._interactionEvents.createBoxHit(gfx, 'click-stroke', {
        width: element.width,
        height: element.height
    });
    // add label hit
    this._interactionEvents.createBoxHit(gfx, 'all', {
        width: LABEL_WIDTH,
        height: element.height
    });
    // indicate that we created a hit
    return true;
};
BpmnInteractionEvents.prototype.createSubProcessHit = function(element, gfx) {
    // remove existing hits
    this._interactionEvents.removeHits(gfx);
    // add body hit
    this._interactionEvents.createBoxHit(gfx, 'no-move', {
        width: element.width,
        height: element.height
    });
    // add outline hit
    this._interactionEvents.createBoxHit(gfx, 'click-stroke', {
        width: element.width,
        height: element.height
    });
    // add label hit
    this._interactionEvents.createBoxHit(gfx, 'all', {
        width: element.width,
        height: LABEL_HEIGHT
    });
    // indicate that we created a hit
    return true;
};

},{"../../util/ModelUtil":"klNYN","../../util/DiUtil":"krDFz","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gWFgF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _keyboard = require("diagram-js/lib/features/keyboard");
var _keyboardDefault = parcelHelpers.interopDefault(_keyboard);
var _bpmnKeyboardBindings = require("./BpmnKeyboardBindings");
var _bpmnKeyboardBindingsDefault = parcelHelpers.interopDefault(_bpmnKeyboardBindings);
exports.default = {
    __depends__: [
        (0, _keyboardDefault.default)
    ],
    __init__: [
        'keyboardBindings'
    ],
    keyboardBindings: [
        'type',
        (0, _bpmnKeyboardBindingsDefault.default)
    ]
};

},{"diagram-js/lib/features/keyboard":"gKt0S","./BpmnKeyboardBindings":"7JjEt","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7JjEt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BpmnKeyboardBindings);
var _inheritsBrowser = require("inherits-browser");
var _inheritsBrowserDefault = parcelHelpers.interopDefault(_inheritsBrowser);
var _keyboardBindings = require("diagram-js/lib/features/keyboard/KeyboardBindings");
var _keyboardBindingsDefault = parcelHelpers.interopDefault(_keyboardBindings);
function BpmnKeyboardBindings(injector) {
    injector.invoke((0, _keyboardBindingsDefault.default), this);
}
(0, _inheritsBrowserDefault.default)(BpmnKeyboardBindings, (0, _keyboardBindingsDefault.default));
BpmnKeyboardBindings.$inject = [
    'injector'
];
/**
 * Register available keyboard bindings.
 *
 * @param {Keyboard} keyboard
 * @param {EditorActions} editorActions
 */ BpmnKeyboardBindings.prototype.registerBindings = function(keyboard, editorActions) {
    // inherit default bindings
    (0, _keyboardBindingsDefault.default).prototype.registerBindings.call(this, keyboard, editorActions);
    /**
   * Add keyboard binding if respective editor action
   * is registered.
   *
   * @param {string} action name
   * @param {Function} fn that implements the key binding
   */ function addListener(action, fn) {
        if (editorActions.isRegistered(action)) keyboard.addListener(fn);
    }
    // select all elements
    // CTRL + A
    addListener('selectElements', function(context) {
        var event = context.keyEvent;
        if (keyboard.isKey([
            'a',
            'A'
        ], event) && keyboard.isCmd(event)) {
            editorActions.trigger('selectElements');
            return true;
        }
    });
    // search labels
    // CTRL + F
    addListener('find', function(context) {
        var event = context.keyEvent;
        if (keyboard.isKey([
            'f',
            'F'
        ], event) && keyboard.isCmd(event)) {
            editorActions.trigger('find');
            return true;
        }
    });
    // activate space tool
    // S
    addListener('spaceTool', function(context) {
        var event = context.keyEvent;
        if (keyboard.hasModifier(event)) return;
        if (keyboard.isKey([
            's',
            'S'
        ], event)) {
            editorActions.trigger('spaceTool');
            return true;
        }
    });
    // activate lasso tool
    // L
    addListener('lassoTool', function(context) {
        var event = context.keyEvent;
        if (keyboard.hasModifier(event)) return;
        if (keyboard.isKey([
            'l',
            'L'
        ], event)) {
            editorActions.trigger('lassoTool');
            return true;
        }
    });
    // activate hand tool
    // H
    addListener('handTool', function(context) {
        var event = context.keyEvent;
        if (keyboard.hasModifier(event)) return;
        if (keyboard.isKey([
            'h',
            'H'
        ], event)) {
            editorActions.trigger('handTool');
            return true;
        }
    });
    // activate global connect tool
    // C
    addListener('globalConnectTool', function(context) {
        var event = context.keyEvent;
        if (keyboard.hasModifier(event)) return;
        if (keyboard.isKey([
            'c',
            'C'
        ], event)) {
            editorActions.trigger('globalConnectTool');
            return true;
        }
    });
    // activate direct editing
    // E
    addListener('directEditing', function(context) {
        var event = context.keyEvent;
        if (keyboard.hasModifier(event)) return;
        if (keyboard.isKey([
            'e',
            'E'
        ], event)) {
            editorActions.trigger('directEditing');
            return true;
        }
    });
    // activate replace element
    // R
    addListener('replaceElement', function(context) {
        var event = context.keyEvent;
        if (keyboard.hasModifier(event)) return;
        if (keyboard.isKey([
            'r',
            'R'
        ], event)) {
            editorActions.trigger('replaceElement', event);
            return true;
        }
    });
};

},{"inherits-browser":"hymxq","diagram-js/lib/features/keyboard/KeyboardBindings":"8kcRe","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"b6S1l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _keyboard = require("../keyboard");
var _keyboardDefault = parcelHelpers.interopDefault(_keyboard);
var _selection = require("../selection");
var _selectionDefault = parcelHelpers.interopDefault(_selection);
var _keyboardMoveSelection = require("./KeyboardMoveSelection");
var _keyboardMoveSelectionDefault = parcelHelpers.interopDefault(_keyboardMoveSelection);
exports.default = {
    __depends__: [
        (0, _keyboardDefault.default),
        (0, _selectionDefault.default)
    ],
    __init__: [
        'keyboardMoveSelection'
    ],
    keyboardMoveSelection: [
        'type',
        (0, _keyboardMoveSelectionDefault.default)
    ]
};

},{"../keyboard":"gKt0S","../selection":"8Jf3R","./KeyboardMoveSelection":"flSm2","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"flSm2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>KeyboardMoveSelection);
var _minDash = require("min-dash");
/**
 * @typedef {import('../keyboard/Keyboard').default} Keyboard
 * @typedef {import('../modeling/Modeling').default} Modeling
 * @typedef {import('../rules/Rules').default} Rules
 * @typedef {import('../selection/Selection').default} Selection
 */ var DEFAULT_CONFIG = {
    moveSpeed: 1,
    moveSpeedAccelerated: 10
};
var HIGHER_PRIORITY = 1500;
var LEFT = 'left';
var UP = 'up';
var RIGHT = 'right';
var DOWN = 'down';
var KEY_TO_DIRECTION = {
    ArrowLeft: LEFT,
    Left: LEFT,
    ArrowUp: UP,
    Up: UP,
    ArrowRight: RIGHT,
    Right: RIGHT,
    ArrowDown: DOWN,
    Down: DOWN
};
var DIRECTIONS_DELTA = {
    left: function(speed) {
        return {
            x: -speed,
            y: 0
        };
    },
    up: function(speed) {
        return {
            x: 0,
            y: -speed
        };
    },
    right: function(speed) {
        return {
            x: speed,
            y: 0
        };
    },
    down: function(speed) {
        return {
            x: 0,
            y: speed
        };
    }
};
function KeyboardMoveSelection(config, keyboard, modeling, rules, selection) {
    var self = this;
    this._config = (0, _minDash.assign)({}, DEFAULT_CONFIG, config || {});
    keyboard.addListener(HIGHER_PRIORITY, function(event) {
        var keyEvent = event.keyEvent;
        var direction = KEY_TO_DIRECTION[keyEvent.key];
        if (!direction) return;
        if (keyboard.isCmd(keyEvent)) return;
        var accelerated = keyboard.isShift(keyEvent);
        self.moveSelection(direction, accelerated);
        return true;
    });
    /**
   * Move selected elements in the given direction,
   * optionally specifying accelerated movement.
   *
   * @param {string} direction
   * @param {boolean} [accelerated=false]
   */ this.moveSelection = function(direction, accelerated) {
        var selectedElements = selection.get();
        if (!selectedElements.length) return;
        var speed = this._config[accelerated ? 'moveSpeedAccelerated' : 'moveSpeed'];
        var delta = DIRECTIONS_DELTA[direction](speed);
        var canMove = rules.allowed('elements.move', {
            shapes: selectedElements
        });
        if (canMove) modeling.moveElements(selectedElements, delta);
    };
}
KeyboardMoveSelection.$inject = [
    'config.keyboardMoveSelection',
    'keyboard',
    'modeling',
    'rules',
    'selection'
];

},{"min-dash":"aEEla","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"d9iP2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _changeSupport = require("diagram-js/lib/features/change-support");
var _changeSupportDefault = parcelHelpers.interopDefault(_changeSupport);
var _resize = require("diagram-js/lib/features/resize");
var _resizeDefault = parcelHelpers.interopDefault(_resize);
var _diagramJsDirectEditing = require("diagram-js-direct-editing");
var _diagramJsDirectEditingDefault = parcelHelpers.interopDefault(_diagramJsDirectEditing);
var _labelEditingProvider = require("./LabelEditingProvider");
var _labelEditingProviderDefault = parcelHelpers.interopDefault(_labelEditingProvider);
var _labelEditingPreview = require("./LabelEditingPreview");
var _labelEditingPreviewDefault = parcelHelpers.interopDefault(_labelEditingPreview);
exports.default = {
    __depends__: [
        (0, _changeSupportDefault.default),
        (0, _resizeDefault.default),
        (0, _diagramJsDirectEditingDefault.default)
    ],
    __init__: [
        'labelEditingProvider',
        'labelEditingPreview'
    ],
    labelEditingProvider: [
        'type',
        (0, _labelEditingProviderDefault.default)
    ],
    labelEditingPreview: [
        'type',
        (0, _labelEditingPreviewDefault.default)
    ]
};

},{"diagram-js/lib/features/change-support":"jBptz","diagram-js/lib/features/resize":"eKu3X","diagram-js-direct-editing":"bPVrN","./LabelEditingProvider":"cFCAw","./LabelEditingPreview":"dmdFd","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eKu3X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rules = require("../rules");
var _rulesDefault = parcelHelpers.interopDefault(_rules);
var _dragging = require("../dragging");
var _draggingDefault = parcelHelpers.interopDefault(_dragging);
var _previewSupport = require("../preview-support");
var _previewSupportDefault = parcelHelpers.interopDefault(_previewSupport);
var _resize = require("./Resize");
var _resizeDefault = parcelHelpers.interopDefault(_resize);
var _resizePreview = require("./ResizePreview");
var _resizePreviewDefault = parcelHelpers.interopDefault(_resizePreview);
var _resizeHandles = require("./ResizeHandles");
var _resizeHandlesDefault = parcelHelpers.interopDefault(_resizeHandles);
exports.default = {
    __depends__: [
        (0, _rulesDefault.default),
        (0, _draggingDefault.default),
        (0, _previewSupportDefault.default)
    ],
    __init__: [
        'resize',
        'resizePreview',
        'resizeHandles'
    ],
    resize: [
        'type',
        (0, _resizeDefault.default)
    ],
    resizePreview: [
        'type',
        (0, _resizePreviewDefault.default)
    ],
    resizeHandles: [
        'type',
        (0, _resizeHandlesDefault.default)
    ]
};

},{"../rules":"5xj5a","../dragging":"2U3QS","../preview-support":"fEfos","./Resize":"kNXpH","./ResizePreview":"bMcyW","./ResizeHandles":"jdcn2","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kNXpH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Resize);
parcelHelpers.export(exports, "getReferencePoint", ()=>getReferencePoint);
var _minDash = require("min-dash");
var _resizeUtil = require("./ResizeUtil");
var _layoutUtil = require("../../layout/LayoutUtil");
/**
 * @typedef {import('../../model').Shape} Shape
 *
 * @typedef {import('../../util/Types').Direction} Direction
 * @typedef {import('../../util/Types').Point} Point
 *
 * @typedef {import('../../core/EventBus').default} EventBus
 * @typedef {import('../dragging/Dragging').default} Dragging
 * @typedef {import('../modeling/Modeling').default} Modeling
 * @typedef {import('../rules/Rules').default} Rules
 */ var DEFAULT_MIN_WIDTH = 10;
function Resize(eventBus, rules, modeling, dragging) {
    this._dragging = dragging;
    this._rules = rules;
    var self = this;
    /**
   * Handle resize move by specified delta.
   *
   * @param {Object} context
   * @param {Point} delta
   */ function handleMove(context, delta) {
        var shape = context.shape, direction = context.direction, resizeConstraints = context.resizeConstraints, newBounds;
        context.delta = delta;
        newBounds = (0, _resizeUtil.resizeBounds)(shape, direction, delta);
        // ensure constraints during resize
        context.newBounds = (0, _resizeUtil.ensureConstraints)(newBounds, resizeConstraints);
        // update + cache executable state
        context.canExecute = self.canResize(context);
    }
    /**
   * Handle resize start.
   *
   * @param {Object} context
   */ function handleStart(context) {
        var resizeConstraints = context.resizeConstraints, // evaluate minBounds for backwards compatibility
        minBounds = context.minBounds;
        if (resizeConstraints !== undefined) return;
        if (minBounds === undefined) minBounds = self.computeMinResizeBox(context);
        context.resizeConstraints = {
            min: (0, _layoutUtil.asTRBL)(minBounds)
        };
    }
    /**
   * Handle resize end.
   *
   * @param {Object} context
   */ function handleEnd(context) {
        var shape = context.shape, canExecute = context.canExecute, newBounds = context.newBounds;
        if (canExecute) {
            // ensure we have actual pixel values for new bounds
            // (important when zoom level was > 1 during move)
            newBounds = (0, _layoutUtil.roundBounds)(newBounds);
            if (!boundsChanged(shape, newBounds)) // no resize necessary
            return;
            // perform the actual resize
            modeling.resizeShape(shape, newBounds);
        }
    }
    eventBus.on('resize.start', function(event) {
        handleStart(event.context);
    });
    eventBus.on('resize.move', function(event) {
        var delta = {
            x: event.dx,
            y: event.dy
        };
        handleMove(event.context, delta);
    });
    eventBus.on('resize.end', function(event) {
        handleEnd(event.context);
    });
}
Resize.prototype.canResize = function(context) {
    var rules = this._rules;
    var ctx = (0, _minDash.pick)(context, [
        'newBounds',
        'shape',
        'delta',
        'direction'
    ]);
    return rules.allowed('shape.resize', ctx);
};
/**
 * Activate a resize operation.
 *
 * You may specify additional contextual information and must specify a
 * resize direction during activation of the resize event.
 *
 * @param {MouseEvent|TouchEvent} event
 * @param {Shape} shape
 * @param {Object|Direction} contextOrDirection
 */ Resize.prototype.activate = function(event, shape, contextOrDirection) {
    var dragging = this._dragging, context, direction;
    if (typeof contextOrDirection === 'string') contextOrDirection = {
        direction: contextOrDirection
    };
    context = (0, _minDash.assign)({
        shape: shape
    }, contextOrDirection);
    direction = context.direction;
    if (!direction) throw new Error('must provide a direction (n|w|s|e|nw|se|ne|sw)');
    dragging.init(event, getReferencePoint(shape, direction), 'resize', {
        autoActivate: true,
        cursor: getCursor(direction),
        data: {
            shape: shape,
            context: context
        }
    });
};
Resize.prototype.computeMinResizeBox = function(context) {
    var shape = context.shape, direction = context.direction, minDimensions, childrenBounds;
    minDimensions = context.minDimensions || {
        width: DEFAULT_MIN_WIDTH,
        height: DEFAULT_MIN_WIDTH
    };
    // get children bounds
    childrenBounds = (0, _resizeUtil.computeChildrenBBox)(shape, context.childrenBoxPadding);
    // get correct minimum bounds from given resize direction
    // basically ensures that the minBounds is max(childrenBounds, minDimensions)
    return (0, _resizeUtil.getMinResizeBounds)(direction, shape, minDimensions, childrenBounds);
};
Resize.$inject = [
    'eventBus',
    'rules',
    'modeling',
    'dragging'
];
// helpers //////////
function boundsChanged(shape, newBounds) {
    return shape.x !== newBounds.x || shape.y !== newBounds.y || shape.width !== newBounds.width || shape.height !== newBounds.height;
}
function getReferencePoint(shape, direction) {
    var mid = (0, _layoutUtil.getMid)(shape), trbl = (0, _layoutUtil.asTRBL)(shape);
    var referencePoint = {
        x: mid.x,
        y: mid.y
    };
    if (direction.indexOf('n') !== -1) referencePoint.y = trbl.top;
    else if (direction.indexOf('s') !== -1) referencePoint.y = trbl.bottom;
    if (direction.indexOf('e') !== -1) referencePoint.x = trbl.right;
    else if (direction.indexOf('w') !== -1) referencePoint.x = trbl.left;
    return referencePoint;
}
function getCursor(direction) {
    var prefix = 'resize-';
    if (direction === 'n' || direction === 's') return prefix + 'ns';
    else if (direction === 'e' || direction === 'w') return prefix + 'ew';
    else if (direction === 'nw' || direction === 'se') return prefix + 'nwse';
    else return prefix + 'nesw';
}

},{"min-dash":"aEEla","./ResizeUtil":"gKMgs","../../layout/LayoutUtil":"4CCrs","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bMcyW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ResizePreview);
var _tinySvg = require("tiny-svg");
var MARKER_RESIZING = 'djs-resizing', MARKER_RESIZE_NOT_OK = 'resize-not-ok';
var LOW_PRIORITY = 500;
function ResizePreview(eventBus, canvas, previewSupport) {
    /**
   * Update resizer frame.
   *
   * @param {Object} context
   */ function updateFrame(context) {
        var shape = context.shape, bounds = context.newBounds, frame = context.frame;
        if (!frame) {
            frame = context.frame = previewSupport.addFrame(shape, canvas.getActiveLayer());
            canvas.addMarker(shape, MARKER_RESIZING);
        }
        if (bounds.width > 5) (0, _tinySvg.attr)(frame, {
            x: bounds.x,
            width: bounds.width
        });
        if (bounds.height > 5) (0, _tinySvg.attr)(frame, {
            y: bounds.y,
            height: bounds.height
        });
        if (context.canExecute) (0, _tinySvg.classes)(frame).remove(MARKER_RESIZE_NOT_OK);
        else (0, _tinySvg.classes)(frame).add(MARKER_RESIZE_NOT_OK);
    }
    /**
   * Remove resizer frame.
   *
   * @param {Object} context
   */ function removeFrame(context) {
        var shape = context.shape, frame = context.frame;
        if (frame) (0, _tinySvg.remove)(context.frame);
        canvas.removeMarker(shape, MARKER_RESIZING);
    }
    // add and update previews
    eventBus.on('resize.move', LOW_PRIORITY, function(event) {
        updateFrame(event.context);
    });
    // remove previews
    eventBus.on('resize.cleanup', function(event) {
        removeFrame(event.context);
    });
}
ResizePreview.$inject = [
    'eventBus',
    'canvas',
    'previewSupport'
];

},{"tiny-svg":"6ZtXA","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jdcn2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ResizeHandles);
var _minDash = require("min-dash");
var _tinySvg = require("tiny-svg");
var _minDom = require("min-dom");
var _mouse = require("../../util/Mouse");
var _svgTransformUtil = require("../../util/SvgTransformUtil");
var _resize = require("./Resize");
/**
 * @typedef {import('../../model').Base} Base
 *
 * @typedef {import('../../core/Canvas').default} Canvas
 * @typedef {import('../../core/EventBus').default} EventBus
 * @typedef {import('../resize/Resize').default} Resize
 * @typedef {import('../selection/Selection').default} Selection
 */ var HANDLE_OFFSET = -6, HANDLE_SIZE = 8, HANDLE_HIT_SIZE = 20;
var CLS_RESIZER = 'djs-resizer';
var directions = [
    'n',
    'w',
    's',
    'e',
    'nw',
    'ne',
    'se',
    'sw'
];
function ResizeHandles(eventBus, canvas, selection, resize) {
    this._resize = resize;
    this._canvas = canvas;
    var self = this;
    eventBus.on('selection.changed', function(e) {
        var newSelection = e.newSelection;
        // remove old selection markers
        self.removeResizers();
        // add new selection markers ONLY if single selection
        if (newSelection.length === 1) (0, _minDash.forEach)(newSelection, (0, _minDash.bind)(self.addResizer, self));
    });
    eventBus.on('shape.changed', function(e) {
        var shape = e.element;
        if (selection.isSelected(shape)) {
            self.removeResizers();
            self.addResizer(shape);
        }
    });
}
ResizeHandles.prototype.makeDraggable = function(element, gfx, direction) {
    var resize = this._resize;
    function startResize(event) {
        // only trigger on left mouse button
        if ((0, _mouse.isPrimaryButton)(event)) resize.activate(event, element, direction);
    }
    (0, _minDom.event).bind(gfx, 'mousedown', startResize);
    (0, _minDom.event).bind(gfx, 'touchstart', startResize);
};
ResizeHandles.prototype._createResizer = function(element, x, y, direction) {
    var resizersParent = this._getResizersParent();
    var offset = getHandleOffset(direction);
    var group = (0, _tinySvg.create)('g');
    (0, _tinySvg.classes)(group).add(CLS_RESIZER);
    (0, _tinySvg.classes)(group).add(CLS_RESIZER + '-' + element.id);
    (0, _tinySvg.classes)(group).add(CLS_RESIZER + '-' + direction);
    (0, _tinySvg.append)(resizersParent, group);
    var visual = (0, _tinySvg.create)('rect');
    (0, _tinySvg.attr)(visual, {
        x: -HANDLE_SIZE / 2 + offset.x,
        y: -HANDLE_SIZE / 2 + offset.y,
        width: HANDLE_SIZE,
        height: HANDLE_SIZE
    });
    (0, _tinySvg.classes)(visual).add(CLS_RESIZER + '-visual');
    (0, _tinySvg.append)(group, visual);
    var hit = (0, _tinySvg.create)('rect');
    (0, _tinySvg.attr)(hit, {
        x: -HANDLE_HIT_SIZE / 2 + offset.x,
        y: -HANDLE_HIT_SIZE / 2 + offset.y,
        width: HANDLE_HIT_SIZE,
        height: HANDLE_HIT_SIZE
    });
    (0, _tinySvg.classes)(hit).add(CLS_RESIZER + '-hit');
    (0, _tinySvg.append)(group, hit);
    (0, _svgTransformUtil.transform)(group, x, y);
    return group;
};
ResizeHandles.prototype.createResizer = function(element, direction) {
    var point = (0, _resize.getReferencePoint)(element, direction);
    var resizer = this._createResizer(element, point.x, point.y, direction);
    this.makeDraggable(element, resizer, direction);
};
// resize handles implementation ///////////////////////////////
/**
 * Add resizers for a given element.
 *
 * @param {Base} element
 */ ResizeHandles.prototype.addResizer = function(element) {
    var self = this;
    if (isConnection(element) || !this._resize.canResize({
        shape: element
    })) return;
    (0, _minDash.forEach)(directions, function(direction) {
        self.createResizer(element, direction);
    });
};
/**
 * Remove all resizers
 */ ResizeHandles.prototype.removeResizers = function() {
    var resizersParent = this._getResizersParent();
    (0, _tinySvg.clear)(resizersParent);
};
ResizeHandles.prototype._getResizersParent = function() {
    return this._canvas.getLayer('resizers');
};
ResizeHandles.$inject = [
    'eventBus',
    'canvas',
    'selection',
    'resize'
];
// helpers //////////
function getHandleOffset(direction) {
    var offset = {
        x: 0,
        y: 0
    };
    if (direction.indexOf('e') !== -1) offset.x = -HANDLE_OFFSET;
    else if (direction.indexOf('w') !== -1) offset.x = HANDLE_OFFSET;
    if (direction.indexOf('s') !== -1) offset.y = -HANDLE_OFFSET;
    else if (direction.indexOf('n') !== -1) offset.y = HANDLE_OFFSET;
    return offset;
}
function isConnection(element) {
    return !!element.waypoints;
}

},{"min-dash":"aEEla","tiny-svg":"6ZtXA","min-dom":"e58GC","../../util/Mouse":"9MyMy","../../util/SvgTransformUtil":"g4Nbc","./Resize":"kNXpH","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cFCAw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>LabelEditingProvider);
var _minDash = require("min-dash");
var _labelUtil = require("./LabelUtil");
var _modelUtil = require("../../util/ModelUtil");
var _modelingUtil = require("../modeling/util/ModelingUtil");
var _diUtil = require("../../util/DiUtil");
var _labelUtil1 = require("../../util/LabelUtil");
var HIGH_PRIORITY = 2000;
function LabelEditingProvider(eventBus, bpmnFactory, canvas, directEditing, modeling, resizeHandles, textRenderer) {
    this._bpmnFactory = bpmnFactory;
    this._canvas = canvas;
    this._modeling = modeling;
    this._textRenderer = textRenderer;
    directEditing.registerProvider(this);
    // listen to dblclick on non-root elements
    eventBus.on('element.dblclick', function(event) {
        activateDirectEdit(event.element, true);
    });
    // complete on followup canvas operation
    eventBus.on([
        'autoPlace.start',
        'canvas.viewbox.changing',
        'drag.init',
        'element.mousedown',
        'popupMenu.open',
        'root.set',
        'selection.changed'
    ], function(event) {
        if (directEditing.isActive()) directEditing.complete();
    });
    eventBus.on([
        'shape.remove',
        'connection.remove'
    ], HIGH_PRIORITY, function(event) {
        if (directEditing.isActive(event.element)) directEditing.cancel();
    });
    // cancel on command stack changes
    eventBus.on([
        'commandStack.changed'
    ], function(e) {
        if (directEditing.isActive()) directEditing.cancel();
    });
    eventBus.on('directEditing.activate', function(event) {
        resizeHandles.removeResizers();
    });
    eventBus.on('create.end', 500, function(event) {
        var context = event.context, element = context.shape, canExecute = event.context.canExecute, isTouch = event.isTouch;
        // TODO(nikku): we need to find a way to support the
        // direct editing on mobile devices; right now this will
        // break for desworkflowediting on mobile devices
        // as it breaks the user interaction workflow
        // TODO(nre): we should temporarily focus the edited element
        // here and release the focused viewport after the direct edit
        // operation is finished
        if (isTouch) return;
        if (!canExecute) return;
        if (context.hints && context.hints.createElementsBehavior === false) return;
        activateDirectEdit(element);
    });
    eventBus.on('autoPlace.end', 500, function(event) {
        activateDirectEdit(event.shape);
    });
    function activateDirectEdit(element, force) {
        if (force || (0, _modelingUtil.isAny)(element, [
            'bpmn:Task',
            'bpmn:TextAnnotation',
            'bpmn:Participant'
        ]) || isCollapsedSubProcess(element)) directEditing.activate(element);
    }
}
LabelEditingProvider.$inject = [
    'eventBus',
    'bpmnFactory',
    'canvas',
    'directEditing',
    'modeling',
    'resizeHandles',
    'textRenderer'
];
/**
 * Activate direct editing for activities and text annotations.
 *
 * @param  {djs.model.Base} element
 *
 * @return {Object} an object with properties bounds (position and size), text and options
 */ LabelEditingProvider.prototype.activate = function(element) {
    // text
    var text = (0, _labelUtil.getLabel)(element);
    if (text === undefined) return;
    var context = {
        text: text
    };
    // bounds
    var bounds = this.getEditingBBox(element);
    (0, _minDash.assign)(context, bounds);
    var options = {};
    // tasks
    if ((0, _modelingUtil.isAny)(element, [
        'bpmn:Task',
        'bpmn:Participant',
        'bpmn:Lane',
        'bpmn:CallActivity'
    ]) || isCollapsedSubProcess(element)) (0, _minDash.assign)(options, {
        centerVertically: true
    });
    // external labels
    if ((0, _labelUtil1.isLabelExternal)(element)) (0, _minDash.assign)(options, {
        autoResize: true
    });
    // text annotations
    if ((0, _modelUtil.is)(element, 'bpmn:TextAnnotation')) (0, _minDash.assign)(options, {
        resizable: true,
        autoResize: true
    });
    (0, _minDash.assign)(context, {
        options: options
    });
    return context;
};
/**
 * Get the editing bounding box based on the element's size and position
 *
 * @param  {djs.model.Base} element
 *
 * @return {Object} an object containing information about position
 *                  and size (fixed or minimum and/or maximum)
 */ LabelEditingProvider.prototype.getEditingBBox = function(element) {
    var canvas = this._canvas;
    var target = element.label || element;
    var bbox = canvas.getAbsoluteBBox(target);
    var mid = {
        x: bbox.x + bbox.width / 2,
        y: bbox.y + bbox.height / 2
    };
    // default position
    var bounds = {
        x: bbox.x,
        y: bbox.y
    };
    var zoom = canvas.zoom();
    var defaultStyle = this._textRenderer.getDefaultStyle(), externalStyle = this._textRenderer.getExternalStyle();
    // take zoom into account
    var externalFontSize = externalStyle.fontSize * zoom, externalLineHeight = externalStyle.lineHeight, defaultFontSize = defaultStyle.fontSize * zoom, defaultLineHeight = defaultStyle.lineHeight;
    var style = {
        fontFamily: this._textRenderer.getDefaultStyle().fontFamily,
        fontWeight: this._textRenderer.getDefaultStyle().fontWeight
    };
    // adjust for expanded pools AND lanes
    if ((0, _modelUtil.is)(element, 'bpmn:Lane') || isExpandedPool(element)) {
        (0, _minDash.assign)(bounds, {
            width: bbox.height,
            height: 30 * zoom,
            x: bbox.x - bbox.height / 2 + 15 * zoom,
            y: mid.y - 30 * zoom / 2
        });
        (0, _minDash.assign)(style, {
            fontSize: defaultFontSize + 'px',
            lineHeight: defaultLineHeight,
            paddingTop: 7 * zoom + 'px',
            paddingBottom: 7 * zoom + 'px',
            paddingLeft: 5 * zoom + 'px',
            paddingRight: 5 * zoom + 'px',
            transform: 'rotate(-90deg)'
        });
    }
    // internal labels for tasks and collapsed call activities,
    // sub processes and participants
    if ((0, _modelingUtil.isAny)(element, [
        'bpmn:Task',
        'bpmn:CallActivity'
    ]) || isCollapsedPool(element) || isCollapsedSubProcess(element)) {
        (0, _minDash.assign)(bounds, {
            width: bbox.width,
            height: bbox.height
        });
        (0, _minDash.assign)(style, {
            fontSize: defaultFontSize + 'px',
            lineHeight: defaultLineHeight,
            paddingTop: 7 * zoom + 'px',
            paddingBottom: 7 * zoom + 'px',
            paddingLeft: 5 * zoom + 'px',
            paddingRight: 5 * zoom + 'px'
        });
    }
    // internal labels for expanded sub processes
    if (isExpandedSubProcess(element)) {
        (0, _minDash.assign)(bounds, {
            width: bbox.width,
            x: bbox.x
        });
        (0, _minDash.assign)(style, {
            fontSize: defaultFontSize + 'px',
            lineHeight: defaultLineHeight,
            paddingTop: 7 * zoom + 'px',
            paddingBottom: 7 * zoom + 'px',
            paddingLeft: 5 * zoom + 'px',
            paddingRight: 5 * zoom + 'px'
        });
    }
    var width = 90 * zoom, paddingTop = 7 * zoom, paddingBottom = 4 * zoom;
    // external labels for events, data elements, gateways, groups and connections
    if (target.labelTarget) {
        (0, _minDash.assign)(bounds, {
            width: width,
            height: bbox.height + paddingTop + paddingBottom,
            x: mid.x - width / 2,
            y: bbox.y - paddingTop
        });
        (0, _minDash.assign)(style, {
            fontSize: externalFontSize + 'px',
            lineHeight: externalLineHeight,
            paddingTop: paddingTop + 'px',
            paddingBottom: paddingBottom + 'px'
        });
    }
    // external label not yet created
    if ((0, _labelUtil1.isLabelExternal)(target) && !(0, _labelUtil1.hasExternalLabel)(target) && !(0, _labelUtil1.isLabel)(target)) {
        var externalLabelMid = (0, _labelUtil1.getExternalLabelMid)(element);
        var absoluteBBox = canvas.getAbsoluteBBox({
            x: externalLabelMid.x,
            y: externalLabelMid.y,
            width: 0,
            height: 0
        });
        var height = externalFontSize + paddingTop + paddingBottom;
        (0, _minDash.assign)(bounds, {
            width: width,
            height: height,
            x: absoluteBBox.x - width / 2,
            y: absoluteBBox.y - height / 2
        });
        (0, _minDash.assign)(style, {
            fontSize: externalFontSize + 'px',
            lineHeight: externalLineHeight,
            paddingTop: paddingTop + 'px',
            paddingBottom: paddingBottom + 'px'
        });
    }
    // text annotations
    if ((0, _modelUtil.is)(element, 'bpmn:TextAnnotation')) {
        (0, _minDash.assign)(bounds, {
            width: bbox.width,
            height: bbox.height,
            minWidth: 30 * zoom,
            minHeight: 10 * zoom
        });
        (0, _minDash.assign)(style, {
            textAlign: 'left',
            paddingTop: 5 * zoom + 'px',
            paddingBottom: 7 * zoom + 'px',
            paddingLeft: 7 * zoom + 'px',
            paddingRight: 5 * zoom + 'px',
            fontSize: defaultFontSize + 'px',
            lineHeight: defaultLineHeight
        });
    }
    return {
        bounds: bounds,
        style: style
    };
};
LabelEditingProvider.prototype.update = function(element, newLabel, activeContextText, bounds) {
    var newBounds, bbox;
    if ((0, _modelUtil.is)(element, 'bpmn:TextAnnotation')) {
        bbox = this._canvas.getAbsoluteBBox(element);
        newBounds = {
            x: element.x,
            y: element.y,
            width: element.width / bbox.width * bounds.width,
            height: element.height / bbox.height * bounds.height
        };
    }
    if (isEmptyText(newLabel)) newLabel = null;
    this._modeling.updateLabel(element, newLabel, newBounds);
};
// helpers //////////////////////
function isCollapsedSubProcess(element) {
    return (0, _modelUtil.is)(element, 'bpmn:SubProcess') && !(0, _diUtil.isExpanded)(element);
}
function isExpandedSubProcess(element) {
    return (0, _modelUtil.is)(element, 'bpmn:SubProcess') && (0, _diUtil.isExpanded)(element);
}
function isCollapsedPool(element) {
    return (0, _modelUtil.is)(element, 'bpmn:Participant') && !(0, _diUtil.isExpanded)(element);
}
function isExpandedPool(element) {
    return (0, _modelUtil.is)(element, 'bpmn:Participant') && (0, _diUtil.isExpanded)(element);
}
function isEmptyText(label) {
    return !label || !label.trim();
}

},{"min-dash":"aEEla","./LabelUtil":"gHqpR","../../util/ModelUtil":"klNYN","../modeling/util/ModelingUtil":"4DR1e","../../util/DiUtil":"krDFz","../../util/LabelUtil":"fAd5x","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dmdFd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>LabelEditingPreview);
var _tinySvg = require("tiny-svg");
var _modelUtil = require("../../util/ModelUtil");
var _svgTransformUtil = require("diagram-js/lib/util/SvgTransformUtil");
var MARKER_HIDDEN = 'djs-element-hidden', MARKER_LABEL_HIDDEN = 'djs-label-hidden';
function LabelEditingPreview(eventBus, canvas, elementRegistry, pathMap) {
    var self = this;
    var defaultLayer = canvas.getDefaultLayer();
    var element, absoluteElementBBox, gfx;
    eventBus.on('directEditing.activate', function(context) {
        var activeProvider = context.active;
        element = activeProvider.element.label || activeProvider.element;
        // text annotation
        if ((0, _modelUtil.is)(element, 'bpmn:TextAnnotation')) {
            absoluteElementBBox = canvas.getAbsoluteBBox(element);
            gfx = (0, _tinySvg.create)('g');
            var textPathData = pathMap.getScaledPath('TEXT_ANNOTATION', {
                xScaleFactor: 1,
                yScaleFactor: 1,
                containerWidth: element.width,
                containerHeight: element.height,
                position: {
                    mx: 0.0,
                    my: 0.0
                }
            });
            var path = self.path = (0, _tinySvg.create)('path');
            (0, _tinySvg.attr)(path, {
                d: textPathData,
                strokeWidth: 2,
                stroke: getStrokeColor(element)
            });
            (0, _tinySvg.append)(gfx, path);
            (0, _tinySvg.append)(defaultLayer, gfx);
            (0, _svgTransformUtil.translate)(gfx, element.x, element.y);
        }
        if ((0, _modelUtil.is)(element, 'bpmn:TextAnnotation') || element.labelTarget) canvas.addMarker(element, MARKER_HIDDEN);
        else if ((0, _modelUtil.is)(element, 'bpmn:Task') || (0, _modelUtil.is)(element, 'bpmn:CallActivity') || (0, _modelUtil.is)(element, 'bpmn:SubProcess') || (0, _modelUtil.is)(element, 'bpmn:Participant')) canvas.addMarker(element, MARKER_LABEL_HIDDEN);
    });
    eventBus.on('directEditing.resize', function(context) {
        // text annotation
        if ((0, _modelUtil.is)(element, 'bpmn:TextAnnotation')) {
            var height = context.height, dy = context.dy;
            var newElementHeight = Math.max(element.height / absoluteElementBBox.height * (height + dy), 0);
            var textPathData = pathMap.getScaledPath('TEXT_ANNOTATION', {
                xScaleFactor: 1,
                yScaleFactor: 1,
                containerWidth: element.width,
                containerHeight: newElementHeight,
                position: {
                    mx: 0.0,
                    my: 0.0
                }
            });
            (0, _tinySvg.attr)(self.path, {
                d: textPathData
            });
        }
    });
    eventBus.on([
        'directEditing.complete',
        'directEditing.cancel'
    ], function(context) {
        var activeProvider = context.active;
        if (activeProvider) {
            canvas.removeMarker(activeProvider.element.label || activeProvider.element, MARKER_HIDDEN);
            canvas.removeMarker(element, MARKER_LABEL_HIDDEN);
        }
        element = undefined;
        absoluteElementBBox = undefined;
        if (gfx) {
            (0, _tinySvg.remove)(gfx);
            gfx = undefined;
        }
    });
}
LabelEditingPreview.$inject = [
    'eventBus',
    'canvas',
    'elementRegistry',
    'pathMap'
];
// helpers ///////////////////
function getStrokeColor(element, defaultColor) {
    var di = (0, _modelUtil.getDi)(element);
    return di.get('stroke') || defaultColor || 'black';
}

},{"tiny-svg":"6ZtXA","../../util/ModelUtil":"klNYN","diagram-js/lib/util/SvgTransformUtil":"g4Nbc","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cXtIQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _behavior = require("./behavior");
var _behaviorDefault = parcelHelpers.interopDefault(_behavior);
var _rules = require("../rules");
var _rulesDefault = parcelHelpers.interopDefault(_rules);
var _diOrdering = require("../di-ordering");
var _diOrderingDefault = parcelHelpers.interopDefault(_diOrdering);
var _ordering = require("../ordering");
var _orderingDefault = parcelHelpers.interopDefault(_ordering);
var _replace = require("../replace");
var _replaceDefault = parcelHelpers.interopDefault(_replace);
var _spaceTool = require("../space-tool");
var _spaceToolDefault = parcelHelpers.interopDefault(_spaceTool);
var _command = require("diagram-js/lib/command");
var _commandDefault = parcelHelpers.interopDefault(_command);
var _tooltips = require("diagram-js/lib/features/tooltips");
var _tooltipsDefault = parcelHelpers.interopDefault(_tooltips);
var _labelSupport = require("diagram-js/lib/features/label-support");
var _labelSupportDefault = parcelHelpers.interopDefault(_labelSupport);
var _attachSupport = require("diagram-js/lib/features/attach-support");
var _attachSupportDefault = parcelHelpers.interopDefault(_attachSupport);
var _selection = require("diagram-js/lib/features/selection");
var _selectionDefault = parcelHelpers.interopDefault(_selection);
var _changeSupport = require("diagram-js/lib/features/change-support");
var _changeSupportDefault = parcelHelpers.interopDefault(_changeSupport);
var _bpmnFactory = require("./BpmnFactory");
var _bpmnFactoryDefault = parcelHelpers.interopDefault(_bpmnFactory);
var _bpmnUpdater = require("./BpmnUpdater");
var _bpmnUpdaterDefault = parcelHelpers.interopDefault(_bpmnUpdater);
var _elementFactory = require("./ElementFactory");
var _elementFactoryDefault = parcelHelpers.interopDefault(_elementFactory);
var _modeling = require("./Modeling");
var _modelingDefault = parcelHelpers.interopDefault(_modeling);
var _bpmnLayouter = require("./BpmnLayouter");
var _bpmnLayouterDefault = parcelHelpers.interopDefault(_bpmnLayouter);
var _croppingConnectionDocking = require("diagram-js/lib/layout/CroppingConnectionDocking");
var _croppingConnectionDockingDefault = parcelHelpers.interopDefault(_croppingConnectionDocking);
exports.default = {
    __init__: [
        'modeling',
        'bpmnUpdater'
    ],
    __depends__: [
        (0, _behaviorDefault.default),
        (0, _rulesDefault.default),
        (0, _diOrderingDefault.default),
        (0, _orderingDefault.default),
        (0, _replaceDefault.default),
        (0, _commandDefault.default),
        (0, _tooltipsDefault.default),
        (0, _labelSupportDefault.default),
        (0, _attachSupportDefault.default),
        (0, _selectionDefault.default),
        (0, _changeSupportDefault.default),
        (0, _spaceToolDefault.default)
    ],
    bpmnFactory: [
        'type',
        (0, _bpmnFactoryDefault.default)
    ],
    bpmnUpdater: [
        'type',
        (0, _bpmnUpdaterDefault.default)
    ],
    elementFactory: [
        'type',
        (0, _elementFactoryDefault.default)
    ],
    modeling: [
        'type',
        (0, _modelingDefault.default)
    ],
    layouter: [
        'type',
        (0, _bpmnLayouterDefault.default)
    ],
    connectionDocking: [
        'type',
        (0, _croppingConnectionDockingDefault.default)
    ]
};

},{"./behavior":"jFMia","../rules":"8tpa6","../di-ordering":"unIbF","../ordering":"lRVIb","../replace":"8KY8q","../space-tool":"lQ7gB","diagram-js/lib/command":"hbqQl","diagram-js/lib/features/tooltips":"l4pQY","diagram-js/lib/features/label-support":"joyGg","diagram-js/lib/features/attach-support":"fT3Dr","diagram-js/lib/features/selection":"8Jf3R","diagram-js/lib/features/change-support":"jBptz","./BpmnFactory":"92D0d","./BpmnUpdater":"iPF9H","./ElementFactory":"6IdXN","./Modeling":"khLRv","./BpmnLayouter":"aLiFP","diagram-js/lib/layout/CroppingConnectionDocking":"43G8V","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jFMia":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _adaptiveLabelPositioningBehavior = require("./AdaptiveLabelPositioningBehavior");
var _adaptiveLabelPositioningBehaviorDefault = parcelHelpers.interopDefault(_adaptiveLabelPositioningBehavior);
var _appendBehavior = require("./AppendBehavior");
var _appendBehaviorDefault = parcelHelpers.interopDefault(_appendBehavior);
var _associationBehavior = require("./AssociationBehavior");
var _associationBehaviorDefault = parcelHelpers.interopDefault(_associationBehavior);
var _attachEventBehavior = require("./AttachEventBehavior");
var _attachEventBehaviorDefault = parcelHelpers.interopDefault(_attachEventBehavior);
var _boundaryEventBehavior = require("./BoundaryEventBehavior");
var _boundaryEventBehaviorDefault = parcelHelpers.interopDefault(_boundaryEventBehavior);
var _createBehavior = require("./CreateBehavior");
var _createBehaviorDefault = parcelHelpers.interopDefault(_createBehavior);
var _createDataObjectBehavior = require("./CreateDataObjectBehavior");
var _createDataObjectBehaviorDefault = parcelHelpers.interopDefault(_createDataObjectBehavior);
var _createParticipantBehavior = require("./CreateParticipantBehavior");
var _createParticipantBehaviorDefault = parcelHelpers.interopDefault(_createParticipantBehavior);
var _dataInputAssociationBehavior = require("./DataInputAssociationBehavior");
var _dataInputAssociationBehaviorDefault = parcelHelpers.interopDefault(_dataInputAssociationBehavior);
var _dataStoreBehavior = require("./DataStoreBehavior");
var _dataStoreBehaviorDefault = parcelHelpers.interopDefault(_dataStoreBehavior);
var _deleteLaneBehavior = require("./DeleteLaneBehavior");
var _deleteLaneBehaviorDefault = parcelHelpers.interopDefault(_deleteLaneBehavior);
var _detachEventBehavior = require("./DetachEventBehavior");
var _detachEventBehaviorDefault = parcelHelpers.interopDefault(_detachEventBehavior);
var _dropOnFlowBehavior = require("./DropOnFlowBehavior");
var _dropOnFlowBehaviorDefault = parcelHelpers.interopDefault(_dropOnFlowBehavior);
var _eventBasedGatewayBehavior = require("./EventBasedGatewayBehavior");
var _eventBasedGatewayBehaviorDefault = parcelHelpers.interopDefault(_eventBasedGatewayBehavior);
var _fixHoverBehavior = require("./FixHoverBehavior");
var _fixHoverBehaviorDefault = parcelHelpers.interopDefault(_fixHoverBehavior);
var _groupBehavior = require("./GroupBehavior");
var _groupBehaviorDefault = parcelHelpers.interopDefault(_groupBehavior);
var _importDockingFix = require("./ImportDockingFix");
var _importDockingFixDefault = parcelHelpers.interopDefault(_importDockingFix);
var _isHorizontalFix = require("./IsHorizontalFix");
var _isHorizontalFixDefault = parcelHelpers.interopDefault(_isHorizontalFix);
var _labelBehavior = require("./LabelBehavior");
var _labelBehaviorDefault = parcelHelpers.interopDefault(_labelBehavior);
var _layoutConnectionBehavior = require("./LayoutConnectionBehavior");
var _layoutConnectionBehaviorDefault = parcelHelpers.interopDefault(_layoutConnectionBehavior);
var _messageFlowBehavior = require("./MessageFlowBehavior");
var _messageFlowBehaviorDefault = parcelHelpers.interopDefault(_messageFlowBehavior);
var _modelingFeedback = require("./ModelingFeedback");
var _modelingFeedbackDefault = parcelHelpers.interopDefault(_modelingFeedback);
var _removeEmbeddedLabelBoundsBehavior = require("./RemoveEmbeddedLabelBoundsBehavior");
var _removeEmbeddedLabelBoundsBehaviorDefault = parcelHelpers.interopDefault(_removeEmbeddedLabelBoundsBehavior);
var _removeElementBehavior = require("./RemoveElementBehavior");
var _removeElementBehaviorDefault = parcelHelpers.interopDefault(_removeElementBehavior);
var _removeParticipantBehavior = require("./RemoveParticipantBehavior");
var _removeParticipantBehaviorDefault = parcelHelpers.interopDefault(_removeParticipantBehavior);
var _replaceConnectionBehavior = require("./ReplaceConnectionBehavior");
var _replaceConnectionBehaviorDefault = parcelHelpers.interopDefault(_replaceConnectionBehavior);
var _replaceElementBehaviour = require("./ReplaceElementBehaviour");
var _replaceElementBehaviourDefault = parcelHelpers.interopDefault(_replaceElementBehaviour);
var _resizeBehavior = require("./ResizeBehavior");
var _resizeBehaviorDefault = parcelHelpers.interopDefault(_resizeBehavior);
var _resizeLaneBehavior = require("./ResizeLaneBehavior");
var _resizeLaneBehaviorDefault = parcelHelpers.interopDefault(_resizeLaneBehavior);
var _rootElementReferenceBehavior = require("./RootElementReferenceBehavior");
var _rootElementReferenceBehaviorDefault = parcelHelpers.interopDefault(_rootElementReferenceBehavior);
var _spaceToolBehavior = require("./SpaceToolBehavior");
var _spaceToolBehaviorDefault = parcelHelpers.interopDefault(_spaceToolBehavior);
var _subProcessPlaneBehavior = require("./SubProcessPlaneBehavior");
var _subProcessPlaneBehaviorDefault = parcelHelpers.interopDefault(_subProcessPlaneBehavior);
var _subProcessStartEventBehavior = require("./SubProcessStartEventBehavior");
var _subProcessStartEventBehaviorDefault = parcelHelpers.interopDefault(_subProcessStartEventBehavior);
var _toggleCollapseConnectionBehaviour = require("./ToggleCollapseConnectionBehaviour");
var _toggleCollapseConnectionBehaviourDefault = parcelHelpers.interopDefault(_toggleCollapseConnectionBehaviour);
var _toggleElementCollapseBehaviour = require("./ToggleElementCollapseBehaviour");
var _toggleElementCollapseBehaviourDefault = parcelHelpers.interopDefault(_toggleElementCollapseBehaviour);
var _unclaimIdBehavior = require("./UnclaimIdBehavior");
var _unclaimIdBehaviorDefault = parcelHelpers.interopDefault(_unclaimIdBehavior);
var _unsetDefaultFlowBehavior = require("./UnsetDefaultFlowBehavior");
var _unsetDefaultFlowBehaviorDefault = parcelHelpers.interopDefault(_unsetDefaultFlowBehavior);
var _updateFlowNodeRefsBehavior = require("./UpdateFlowNodeRefsBehavior");
var _updateFlowNodeRefsBehaviorDefault = parcelHelpers.interopDefault(_updateFlowNodeRefsBehavior);
exports.default = {
    __init__: [
        'adaptiveLabelPositioningBehavior',
        'appendBehavior',
        'associationBehavior',
        'attachEventBehavior',
        'boundaryEventBehavior',
        'createBehavior',
        'createDataObjectBehavior',
        'createParticipantBehavior',
        'dataInputAssociationBehavior',
        'dataStoreBehavior',
        'deleteLaneBehavior',
        'detachEventBehavior',
        'dropOnFlowBehavior',
        'eventBasedGatewayBehavior',
        'fixHoverBehavior',
        'groupBehavior',
        'importDockingFix',
        'isHorizontalFix',
        'labelBehavior',
        'layoutConnectionBehavior',
        'messageFlowBehavior',
        'modelingFeedback',
        'removeElementBehavior',
        'removeEmbeddedLabelBoundsBehavior',
        'removeParticipantBehavior',
        'replaceConnectionBehavior',
        'replaceElementBehaviour',
        'resizeBehavior',
        'resizeLaneBehavior',
        'rootElementReferenceBehavior',
        'spaceToolBehavior',
        'subProcessPlaneBehavior',
        'subProcessStartEventBehavior',
        'toggleCollapseConnectionBehaviour',
        'toggleElementCollapseBehaviour',
        'unclaimIdBehavior',
        'updateFlowNodeRefsBehavior',
        'unsetDefaultFlowBehavior'
    ],
    adaptiveLabelPositioningBehavior: [
        'type',
        (0, _adaptiveLabelPositioningBehaviorDefault.default)
    ],
    appendBehavior: [
        'type',
        (0, _appendBehaviorDefault.default)
    ],
    associationBehavior: [
        'type',
        (0, _associationBehaviorDefault.default)
    ],
    attachEventBehavior: [
        'type',
        (0, _attachEventBehaviorDefault.default)
    ],
    boundaryEventBehavior: [
        'type',
        (0, _boundaryEventBehaviorDefault.default)
    ],
    createBehavior: [
        'type',
        (0, _createBehaviorDefault.default)
    ],
    createDataObjectBehavior: [
        'type',
        (0, _createDataObjectBehaviorDefault.default)
    ],
    createParticipantBehavior: [
        'type',
        (0, _createParticipantBehaviorDefault.default)
    ],
    dataInputAssociationBehavior: [
        'type',
        (0, _dataInputAssociationBehaviorDefault.default)
    ],
    dataStoreBehavior: [
        'type',
        (0, _dataStoreBehaviorDefault.default)
    ],
    deleteLaneBehavior: [
        'type',
        (0, _deleteLaneBehaviorDefault.default)
    ],
    detachEventBehavior: [
        'type',
        (0, _detachEventBehaviorDefault.default)
    ],
    dropOnFlowBehavior: [
        'type',
        (0, _dropOnFlowBehaviorDefault.default)
    ],
    eventBasedGatewayBehavior: [
        'type',
        (0, _eventBasedGatewayBehaviorDefault.default)
    ],
    fixHoverBehavior: [
        'type',
        (0, _fixHoverBehaviorDefault.default)
    ],
    groupBehavior: [
        'type',
        (0, _groupBehaviorDefault.default)
    ],
    importDockingFix: [
        'type',
        (0, _importDockingFixDefault.default)
    ],
    isHorizontalFix: [
        'type',
        (0, _isHorizontalFixDefault.default)
    ],
    labelBehavior: [
        'type',
        (0, _labelBehaviorDefault.default)
    ],
    layoutConnectionBehavior: [
        'type',
        (0, _layoutConnectionBehaviorDefault.default)
    ],
    messageFlowBehavior: [
        'type',
        (0, _messageFlowBehaviorDefault.default)
    ],
    modelingFeedback: [
        'type',
        (0, _modelingFeedbackDefault.default)
    ],
    removeElementBehavior: [
        'type',
        (0, _removeElementBehaviorDefault.default)
    ],
    removeEmbeddedLabelBoundsBehavior: [
        'type',
        (0, _removeEmbeddedLabelBoundsBehaviorDefault.default)
    ],
    removeParticipantBehavior: [
        'type',
        (0, _removeParticipantBehaviorDefault.default)
    ],
    replaceConnectionBehavior: [
        'type',
        (0, _replaceConnectionBehaviorDefault.default)
    ],
    replaceElementBehaviour: [
        'type',
        (0, _replaceElementBehaviourDefault.default)
    ],
    resizeBehavior: [
        'type',
        (0, _resizeBehaviorDefault.default)
    ],
    resizeLaneBehavior: [
        'type',
        (0, _resizeLaneBehaviorDefault.default)
    ],
    rootElementReferenceBehavior: [
        'type',
        (0, _rootElementReferenceBehaviorDefault.default)
    ],
    spaceToolBehavior: [
        'type',
        (0, _spaceToolBehaviorDefault.default)
    ],
    subProcessPlaneBehavior: [
        'type',
        (0, _subProcessPlaneBehaviorDefault.default)
    ],
    subProcessStartEventBehavior: [
        'type',
        (0, _subProcessStartEventBehaviorDefault.default)
    ],
    toggleCollapseConnectionBehaviour: [
        'type',
        (0, _toggleCollapseConnectionBehaviourDefault.default)
    ],
    toggleElementCollapseBehaviour: [
        'type',
        (0, _toggleElementCollapseBehaviourDefault.default)
    ],
    unclaimIdBehavior: [
        'type',
        (0, _unclaimIdBehaviorDefault.default)
    ],
    unsetDefaultFlowBehavior: [
        'type',
        (0, _unsetDefaultFlowBehaviorDefault.default)
    ],
    updateFlowNodeRefsBehavior: [
        'type',
        (0, _updateFlowNodeRefsBehaviorDefault.default)
    ]
};

},{"./AdaptiveLabelPositioningBehavior":"bnHQy","./AppendBehavior":"hTKXz","./AssociationBehavior":"5lkn9","./AttachEventBehavior":"51GZO","./BoundaryEventBehavior":"6bdNf","./CreateBehavior":"13Qqo","./CreateDataObjectBehavior":"1bBLv","./CreateParticipantBehavior":"azdT8","./DataInputAssociationBehavior":"lmzWr","./DataStoreBehavior":"68YZ4","./DeleteLaneBehavior":"6rsij","./DetachEventBehavior":"jMvjY","./DropOnFlowBehavior":"8hjEk","./EventBasedGatewayBehavior":"7uTE2","./FixHoverBehavior":"2peYV","./GroupBehavior":"jHN9O","./ImportDockingFix":"i4MCl","./IsHorizontalFix":"1nKWP","./LabelBehavior":"5T1aT","./LayoutConnectionBehavior":"6FXCb","./MessageFlowBehavior":"16j3e","./ModelingFeedback":"iZFKQ","./RemoveEmbeddedLabelBoundsBehavior":"714X4","./RemoveElementBehavior":"1UuSl","./RemoveParticipantBehavior":"gJmUP","./ReplaceConnectionBehavior":"c6u0L","./ReplaceElementBehaviour":"7XdSJ","./ResizeBehavior":"7Xl4y","./ResizeLaneBehavior":"gZKqu","./RootElementReferenceBehavior":"dguTE","./SpaceToolBehavior":"gAEJQ","./SubProcessPlaneBehavior":"1W8ek","./SubProcessStartEventBehavior":"daF3l","./ToggleCollapseConnectionBehaviour":"1zROk","./ToggleElementCollapseBehaviour":"gmtTu","./UnclaimIdBehavior":"fHB5H","./UnsetDefaultFlowBehavior":"9SvVp","./UpdateFlowNodeRefsBehavior":"2kKcR","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bnHQy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AdaptiveLabelPositioningBehavior);
var _inheritsBrowser = require("inherits-browser");
var _inheritsBrowserDefault = parcelHelpers.interopDefault(_inheritsBrowser);
var _layoutUtil = require("diagram-js/lib/layout/LayoutUtil");
var _math = require("diagram-js/lib/util/Math");
var _labelUtil = require("../../../util/LabelUtil");
var _commandInterceptor = require("diagram-js/lib/command/CommandInterceptor");
var _commandInterceptorDefault = parcelHelpers.interopDefault(_commandInterceptor);
var ALIGNMENTS = [
    'top',
    'bottom',
    'left',
    'right'
];
var ELEMENT_LABEL_DISTANCE = 10;
function AdaptiveLabelPositioningBehavior(eventBus, modeling) {
    (0, _commandInterceptorDefault.default).call(this, eventBus);
    this.postExecuted([
        'connection.create',
        'connection.layout',
        'connection.updateWaypoints'
    ], function(event) {
        var context = event.context, connection = context.connection, source = connection.source, target = connection.target, hints = context.hints || {};
        if (hints.createElementsBehavior !== false) {
            checkLabelAdjustment(source);
            checkLabelAdjustment(target);
        }
    });
    this.postExecuted([
        'label.create'
    ], function(event) {
        var context = event.context, shape = context.shape, hints = context.hints || {};
        if (hints.createElementsBehavior !== false) checkLabelAdjustment(shape.labelTarget);
    });
    this.postExecuted([
        'elements.create'
    ], function(event) {
        var context = event.context, elements = context.elements, hints = context.hints || {};
        if (hints.createElementsBehavior !== false) elements.forEach(function(element) {
            checkLabelAdjustment(element);
        });
    });
    function checkLabelAdjustment(element) {
        // skip non-existing labels
        if (!(0, _labelUtil.hasExternalLabel)(element)) return;
        var optimalPosition = getOptimalPosition(element);
        // no optimal position found
        if (!optimalPosition) return;
        adjustLabelPosition(element, optimalPosition);
    }
    function adjustLabelPosition(element, orientation) {
        var elementMid = (0, _layoutUtil.getMid)(element), label = element.label, labelMid = (0, _layoutUtil.getMid)(label);
        // ignore labels that are being created
        if (!label.parent) return;
        var elementTrbl = (0, _layoutUtil.asTRBL)(element);
        var newLabelMid;
        switch(orientation){
            case 'top':
                newLabelMid = {
                    x: elementMid.x,
                    y: elementTrbl.top - ELEMENT_LABEL_DISTANCE - label.height / 2
                };
                break;
            case 'left':
                newLabelMid = {
                    x: elementTrbl.left - ELEMENT_LABEL_DISTANCE - label.width / 2,
                    y: elementMid.y
                };
                break;
            case 'bottom':
                newLabelMid = {
                    x: elementMid.x,
                    y: elementTrbl.bottom + ELEMENT_LABEL_DISTANCE + label.height / 2
                };
                break;
            case 'right':
                newLabelMid = {
                    x: elementTrbl.right + ELEMENT_LABEL_DISTANCE + label.width / 2,
                    y: elementMid.y
                };
                break;
        }
        var delta = (0, _math.substract)(newLabelMid, labelMid);
        modeling.moveShape(label, delta);
    }
}
(0, _inheritsBrowserDefault.default)(AdaptiveLabelPositioningBehavior, (0, _commandInterceptorDefault.default));
AdaptiveLabelPositioningBehavior.$inject = [
    'eventBus',
    'modeling'
];
// helpers //////////////////////
/**
 * Return alignments which are taken by a boundary's host element
 *
 * @param {Shape} element
 *
 * @return {Array<string>}
 */ function getTakenHostAlignments(element) {
    var hostElement = element.host, elementMid = (0, _layoutUtil.getMid)(element), hostOrientation = (0, _layoutUtil.getOrientation)(elementMid, hostElement);
    var freeAlignments;
    // check whether there is a multi-orientation, e.g. 'top-left'
    if (hostOrientation.indexOf('-') >= 0) freeAlignments = hostOrientation.split('-');
    else freeAlignments = [
        hostOrientation
    ];
    var takenAlignments = ALIGNMENTS.filter(function(alignment) {
        return freeAlignments.indexOf(alignment) === -1;
    });
    return takenAlignments;
}
/**
 * Return alignments which are taken by related connections
 *
 * @param {Shape} element
 *
 * @return {Array<string>}
 */ function getTakenConnectionAlignments(element) {
    var elementMid = (0, _layoutUtil.getMid)(element);
    var takenAlignments = [].concat(element.incoming.map(function(c) {
        return c.waypoints[c.waypoints.length - 2];
    }), element.outgoing.map(function(c) {
        return c.waypoints[1];
    })).map(function(point) {
        return getApproximateOrientation(elementMid, point);
    });
    return takenAlignments;
}
/**
 * Return the optimal label position around an element
 * or _undefined_, if none was found.
 *
 * @param  {Shape} element
 *
 * @return {string} positioning identifier
 */ function getOptimalPosition(element) {
    var labelMid = (0, _layoutUtil.getMid)(element.label);
    var elementMid = (0, _layoutUtil.getMid)(element);
    var labelOrientation = getApproximateOrientation(elementMid, labelMid);
    if (!isAligned(labelOrientation)) return;
    var takenAlignments = getTakenConnectionAlignments(element);
    if (element.host) {
        var takenHostAlignments = getTakenHostAlignments(element);
        takenAlignments = takenAlignments.concat(takenHostAlignments);
    }
    var freeAlignments = ALIGNMENTS.filter(function(alignment) {
        return takenAlignments.indexOf(alignment) === -1;
    });
    // NOTHING TO DO; label already aligned a.O.K.
    if (freeAlignments.indexOf(labelOrientation) !== -1) return;
    return freeAlignments[0];
}
function getApproximateOrientation(p0, p1) {
    return (0, _layoutUtil.getOrientation)(p1, p0, 5);
}
function isAligned(orientation) {
    return ALIGNMENTS.indexOf(orientation) !== -1;
}

},{"inherits-browser":"hymxq","diagram-js/lib/layout/LayoutUtil":"4CCrs","diagram-js/lib/util/Math":[["substract","flrPc","delta"]],"../../../util/LabelUtil":"fAd5x","diagram-js/lib/command/CommandInterceptor":"1K1IQ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hTKXz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AppendBehavior);
var _inheritsBrowser = require("inherits-browser");
var _inheritsBrowserDefault = parcelHelpers.interopDefault(_inheritsBrowser);
var _modelUtil = require("../../../util/ModelUtil");
var _commandInterceptor = require("diagram-js/lib/command/CommandInterceptor");
var _commandInterceptorDefault = parcelHelpers.interopDefault(_commandInterceptor);
function AppendBehavior(eventBus, elementFactory, bpmnRules) {
    (0, _commandInterceptorDefault.default).call(this, eventBus);
    // assign correct shape position unless already set
    this.preExecute('shape.append', function(context) {
        var source = context.source, shape = context.shape;
        if (!context.position) {
            if ((0, _modelUtil.is)(shape, 'bpmn:TextAnnotation')) context.position = {
                x: source.x + source.width / 2 + 75,
                y: source.y - 50 - shape.height / 2
            };
            else context.position = {
                x: source.x + source.width + 80 + shape.width / 2,
                y: source.y + source.height / 2
            };
        }
    }, true);
}
(0, _inheritsBrowserDefault.default)(AppendBehavior, (0, _commandInterceptorDefault.default));
AppendBehavior.$inject = [
    'eventBus',
    'elementFactory',
    'bpmnRules'
];

},{"inherits-browser":"hymxq","../../../util/ModelUtil":"klNYN","diagram-js/lib/command/CommandInterceptor":"1K1IQ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5lkn9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AssociationBehavior);
var _inheritsBrowser = require("inherits-browser");
var _inheritsBrowserDefault = parcelHelpers.interopDefault(_inheritsBrowser);
var _modelUtil = require("../../../util/ModelUtil");
var _commandInterceptor = require("diagram-js/lib/command/CommandInterceptor");
var _commandInterceptorDefault = parcelHelpers.interopDefault(_commandInterceptor);
var _minDash = require("min-dash");
function AssociationBehavior(injector, modeling) {
    injector.invoke((0, _commandInterceptorDefault.default), this);
    this.postExecute('shape.move', function(context) {
        var newParent = context.newParent, shape = context.shape;
        var associations = (0, _minDash.filter)(shape.incoming.concat(shape.outgoing), function(connection) {
            return (0, _modelUtil.is)(connection, 'bpmn:Association');
        });
        (0, _minDash.forEach)(associations, function(association) {
            modeling.moveConnection(association, {
                x: 0,
                y: 0
            }, newParent);
        });
    }, true);
}
(0, _inheritsBrowserDefault.default)(AssociationBehavior, (0, _commandInterceptorDefault.default));
AssociationBehavior.$inject = [
    'injector',
    'modeling'
];

},{"inherits-browser":"hymxq","../../../util/ModelUtil":"klNYN","diagram-js/lib/command/CommandInterceptor":"1K1IQ","min-dash":"aEEla","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"51GZO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AttachEventBehavior);
var _inheritsBrowser = require("inherits-browser");
var _inheritsBrowserDefault = parcelHelpers.interopDefault(_inheritsBrowser);
var _commandInterceptor = require("diagram-js/lib/command/CommandInterceptor");
var _commandInterceptorDefault = parcelHelpers.interopDefault(_commandInterceptor);
var _modelUtil = require("../../../util/ModelUtil");
var _modelingUtil = require("../util/ModelingUtil");
var _labelUtil = require("../../../util/LabelUtil");
var LOW_PRIORITY = 500;
function AttachEventBehavior(bpmnReplace, injector) {
    injector.invoke((0, _commandInterceptorDefault.default), this);
    this._bpmnReplace = bpmnReplace;
    var self = this;
    this.postExecuted('elements.create', LOW_PRIORITY, function(context) {
        var elements = context.elements;
        elements = elements.filter(function(shape) {
            var host = shape.host;
            return shouldReplace(shape, host);
        });
        if (elements.length !== 1) return;
        elements.map(function(element) {
            return elements.indexOf(element);
        }).forEach(function(index) {
            var host = elements[index];
            context.elements[index] = self.replaceShape(elements[index], host);
        });
    }, true);
    this.preExecute('elements.move', LOW_PRIORITY, function(context) {
        var shapes = context.shapes, host = context.newHost;
        if (shapes.length !== 1) return;
        var shape = shapes[0];
        if (shouldReplace(shape, host)) context.shapes = [
            self.replaceShape(shape, host)
        ];
    }, true);
}
AttachEventBehavior.$inject = [
    'bpmnReplace',
    'injector'
];
(0, _inheritsBrowserDefault.default)(AttachEventBehavior, (0, _commandInterceptorDefault.default));
AttachEventBehavior.prototype.replaceShape = function(shape, host) {
    var eventDefinition = getEventDefinition(shape);
    var boundaryEvent = {
        type: 'bpmn:BoundaryEvent',
        host: host
    };
    if (eventDefinition) boundaryEvent.eventDefinitionType = eventDefinition.$type;
    return this._bpmnReplace.replaceElement(shape, boundaryEvent, {
        layoutConnection: false
    });
};
// helpers //////////
function getEventDefinition(element) {
    var businessObject = (0, _modelUtil.getBusinessObject)(element), eventDefinitions = businessObject.eventDefinitions;
    return eventDefinitions && eventDefinitions[0];
}
function shouldReplace(shape, host) {
    return !(0, _labelUtil.isLabel)(shape) && (0, _modelingUtil.isAny)(shape, [
        'bpmn:IntermediateThrowEvent',
        'bpmn:IntermediateCatchEvent'
    ]) && !!host;
}

},{"inherits-browser":"hymxq","diagram-js/lib/command/CommandInterceptor":"1K1IQ","../../../util/ModelUtil":"klNYN","../util/ModelingUtil":"4DR1e","../../../util/LabelUtil":"fAd5x","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6bdNf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BoundaryEventBehavior);
var _inheritsBrowser = require("inherits-browser");
var _inheritsBrowserDefault = parcelHelpers.interopDefault(_inheritsBrowser);
var _commandInterceptor = require("diagram-js/lib/command/CommandInterceptor");
var _commandInterceptorDefault = parcelHelpers.interopDefault(_commandInterceptor);
var _modelUtil = require("../../../util/ModelUtil");
var _minDash = require("min-dash");
function BoundaryEventBehavior(eventBus, modeling) {
    (0, _commandInterceptorDefault.default).call(this, eventBus);
    function getBoundaryEvents(element) {
        return (0, _minDash.filter)(element.attachers, function(attacher) {
            return (0, _modelUtil.is)(attacher, 'bpmn:BoundaryEvent');
        });
    }
    // remove after connecting to event-based gateway
    this.postExecute('connection.create', function(event) {
        var source = event.context.source, target = event.context.target, boundaryEvents = getBoundaryEvents(target);
        if ((0, _modelUtil.is)(source, 'bpmn:EventBasedGateway') && (0, _modelUtil.is)(target, 'bpmn:ReceiveTask') && boundaryEvents.length > 0) modeling.removeElements(boundaryEvents);
    });
    // remove after replacing connected gateway with event-based gateway
    this.postExecute('connection.reconnect', function(event) {
        var oldSource = event.context.oldSource, newSource = event.context.newSource;
        if ((0, _modelUtil.is)(oldSource, 'bpmn:Gateway') && (0, _modelUtil.is)(newSource, 'bpmn:EventBasedGateway')) (0, _minDash.forEach)(newSource.outgoing, function(connection) {
            var target = connection.target, attachedboundaryEvents = getBoundaryEvents(target);
            if ((0, _modelUtil.is)(target, 'bpmn:ReceiveTask') && attachedboundaryEvents.length > 0) modeling.removeElements(attachedboundaryEvents);
        });
    });
}
BoundaryEventBehavior.$inject = [
    'eventBus',
    'modeling'
];
(0, _inheritsBrowserDefault.default)(BoundaryEventBehavior, (0, _commandInterceptorDefault.default));

},{"inherits-browser":"hymxq","diagram-js/lib/command/CommandInterceptor":"1K1IQ","../../../util/ModelUtil":"klNYN","min-dash":"aEEla","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"13Qqo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CreateBehavior);
var _inheritsBrowser = require("inherits-browser");
var _inheritsBrowserDefault = parcelHelpers.interopDefault(_inheritsBrowser);
var _modelUtil = require("../../../util/ModelUtil");
var _commandInterceptor = require("diagram-js/lib/command/CommandInterceptor");
var _commandInterceptorDefault = parcelHelpers.interopDefault(_commandInterceptor);
var _modelingUtil = require("../util/ModelingUtil");
function CreateBehavior(injector) {
    injector.invoke((0, _commandInterceptorDefault.default), this);
    this.preExecute('shape.create', 1500, function(event) {
        var context = event.context, parent = context.parent, shape = context.shape;
        if ((0, _modelUtil.is)(parent, 'bpmn:Lane') && !(0, _modelUtil.is)(shape, 'bpmn:Lane')) context.parent = (0, _modelingUtil.getParent)(parent, 'bpmn:Participant');
    });
}
CreateBehavior.$inject = [
    'injector'
];
(0, _inheritsBrowserDefault.default)(CreateBehavior, (0, _commandInterceptorDefault.default));

},{"inherits-browser":"hymxq","../../../util/ModelUtil":"klNYN","diagram-js/lib/command/CommandInterceptor":"1K1IQ","../util/ModelingUtil":"4DR1e","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1bBLv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CreateDataObjectBehavior);
var _inheritsBrowser = require("inherits-browser");
var _inheritsBrowserDefault = parcelHelpers.interopDefault(_inheritsBrowser);
var _commandInterceptor = require("diagram-js/lib/command/CommandInterceptor");
var _commandInterceptorDefault = parcelHelpers.interopDefault(_commandInterceptor);
var _modelUtil = require("../../../util/ModelUtil");
function CreateDataObjectBehavior(eventBus, bpmnFactory, moddle) {
    (0, _commandInterceptorDefault.default).call(this, eventBus);
    this.preExecute('shape.create', function(event) {
        var context = event.context, shape = context.shape;
        if ((0, _modelUtil.is)(shape, 'bpmn:DataObjectReference') && shape.type !== 'label') {
            // create a DataObject every time a DataObjectReference is created
            var dataObject = bpmnFactory.create('bpmn:DataObject');
            // set the reference to the DataObject
            shape.businessObject.dataObjectRef = dataObject;
        }
    });
}
CreateDataObjectBehavior.$inject = [
    'eventBus',
    'bpmnFactory',
    'moddle'
];
(0, _inheritsBrowserDefault.default)(CreateDataObjectBehavior, (0, _commandInterceptorDefault.default));

},{"inherits-browser":"hymxq","diagram-js/lib/command/CommandInterceptor":"1K1IQ","../../../util/ModelUtil":"klNYN","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"azdT8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PARTICIPANT_BORDER_WIDTH", ()=>PARTICIPANT_BORDER_WIDTH);
parcelHelpers.export(exports, "default", ()=>CreateParticipantBehavior);
var _inheritsBrowser = require("inherits-browser");
var _inheritsBrowserDefault = parcelHelpers.interopDefault(_inheritsBrowser);
var _commandInterceptor = require("diagram-js/lib/command/CommandInterceptor");
var _commandInterceptorDefault = parcelHelpers.interopDefault(_commandInterceptor);
var _modelUtil = require("../../../util/ModelUtil");
var _labelUtil = require("../../../util/LabelUtil");
var _elements = require("diagram-js/lib/util/Elements");
var _minDash = require("min-dash");
var _layoutUtil = require("diagram-js/lib/layout/LayoutUtil");
var HORIZONTAL_PARTICIPANT_PADDING = 20, VERTICAL_PARTICIPANT_PADDING = 20;
var PARTICIPANT_BORDER_WIDTH = 30;
var HIGH_PRIORITY = 2000;
function CreateParticipantBehavior(canvas, eventBus, modeling) {
    (0, _commandInterceptorDefault.default).call(this, eventBus);
    // fit participant
    eventBus.on([
        'create.start',
        'shape.move.start'
    ], HIGH_PRIORITY, function(event) {
        var context = event.context, shape = context.shape, rootElement = canvas.getRootElement();
        if (!(0, _modelUtil.is)(shape, 'bpmn:Participant') || !(0, _modelUtil.is)(rootElement, 'bpmn:Process') || !rootElement.children.length) return;
        // ignore connections, groups and labels
        var children = rootElement.children.filter(function(element) {
            return !(0, _modelUtil.is)(element, 'bpmn:Group') && !(0, _labelUtil.isLabel)(element) && !isConnection(element);
        });
        // ensure for available children to calculate bounds
        if (!children.length) return;
        var childrenBBox = (0, _elements.getBBox)(children);
        var participantBounds = getParticipantBounds(shape, childrenBBox);
        // assign width and height
        (0, _minDash.assign)(shape, participantBounds);
        // assign create constraints
        context.createConstraints = getParticipantCreateConstraints(shape, childrenBBox);
    });
    // force hovering process when creating first participant
    eventBus.on('create.start', HIGH_PRIORITY, function(event) {
        var context = event.context, shape = context.shape, rootElement = canvas.getRootElement(), rootElementGfx = canvas.getGraphics(rootElement);
        function ensureHoveringProcess(event) {
            event.element = rootElement;
            event.gfx = rootElementGfx;
        }
        if ((0, _modelUtil.is)(shape, 'bpmn:Participant') && (0, _modelUtil.is)(rootElement, 'bpmn:Process')) {
            eventBus.on('element.hover', HIGH_PRIORITY, ensureHoveringProcess);
            eventBus.once('create.cleanup', function() {
                eventBus.off('element.hover', ensureHoveringProcess);
            });
        }
    });
    // turn process into collaboration when creating first participant
    function getOrCreateCollaboration() {
        var rootElement = canvas.getRootElement();
        if ((0, _modelUtil.is)(rootElement, 'bpmn:Collaboration')) return rootElement;
        return modeling.makeCollaboration();
    }
    // when creating mutliple elements through `elements.create` parent must be set to collaboration
    // and passed to `shape.create` as hint
    this.preExecute('elements.create', HIGH_PRIORITY, function(context) {
        var elements = context.elements, parent = context.parent, participant = findParticipant(elements), hints;
        if (participant && (0, _modelUtil.is)(parent, 'bpmn:Process')) {
            context.parent = getOrCreateCollaboration();
            hints = context.hints = context.hints || {};
            hints.participant = participant;
            hints.process = parent;
            hints.processRef = (0, _modelUtil.getBusinessObject)(participant).get('processRef');
        }
    }, true);
    // when creating single shape through `shape.create` parent must be set to collaboration
    // unless it was already set through `elements.create`
    this.preExecute('shape.create', function(context) {
        var parent = context.parent, shape = context.shape;
        if ((0, _modelUtil.is)(shape, 'bpmn:Participant') && (0, _modelUtil.is)(parent, 'bpmn:Process')) {
            context.parent = getOrCreateCollaboration();
            context.process = parent;
            context.processRef = (0, _modelUtil.getBusinessObject)(shape).get('processRef');
        }
    }, true);
    // #execute necessary because #preExecute not called on CommandStack#redo
    this.execute('shape.create', function(context) {
        var hints = context.hints || {}, process = context.process || hints.process, shape = context.shape, participant = hints.participant;
        // both shape.create and elements.create must be handled
        if (process && (!participant || shape === participant)) // monkey-patch process ref
        (0, _modelUtil.getBusinessObject)(shape).set('processRef', (0, _modelUtil.getBusinessObject)(process));
    }, true);
    this.revert('shape.create', function(context) {
        var hints = context.hints || {}, process = context.process || hints.process, processRef = context.processRef || hints.processRef, shape = context.shape, participant = hints.participant;
        // both shape.create and elements.create must be handled
        if (process && (!participant || shape === participant)) // monkey-patch process ref
        (0, _modelUtil.getBusinessObject)(shape).set('processRef', processRef);
    }, true);
    this.postExecute('shape.create', function(context) {
        var hints = context.hints || {}, process = context.process || context.hints.process, shape = context.shape, participant = hints.participant;
        if (process) {
            var children = process.children.slice();
            // both shape.create and elements.create must be handled
            if (!participant) modeling.moveElements(children, {
                x: 0,
                y: 0
            }, shape);
            else if (shape === participant) modeling.moveElements(children, {
                x: 0,
                y: 0
            }, participant);
        }
    }, true);
}
CreateParticipantBehavior.$inject = [
    'canvas',
    'eventBus',
    'modeling'
];
(0, _inheritsBrowserDefault.default)(CreateParticipantBehavior, (0, _commandInterceptorDefault.default));
// helpers //////////
function getParticipantBounds(shape, childrenBBox) {
    childrenBBox = {
        width: childrenBBox.width + HORIZONTAL_PARTICIPANT_PADDING * 2 + PARTICIPANT_BORDER_WIDTH,
        height: childrenBBox.height + VERTICAL_PARTICIPANT_PADDING * 2
    };
    var width = Math.max(shape.width, childrenBBox.width), height = Math.max(shape.height, childrenBBox.height);
    return {
        x: -width / 2,
        y: -height / 2,
        width: width,
        height: height
    };
}
function getParticipantCreateConstraints(shape, childrenBBox) {
    childrenBBox = (0, _layoutUtil.asTRBL)(childrenBBox);
    return {
        bottom: childrenBBox.top + shape.height / 2 - VERTICAL_PARTICIPANT_PADDING,
        left: childrenBBox.right - shape.width / 2 + HORIZONTAL_PARTICIPANT_PADDING,
        top: childrenBBox.bottom - shape.height / 2 + VERTICAL_PARTICIPANT_PADDING,
        right: childrenBBox.left + shape.width / 2 - HORIZONTAL_PARTICIPANT_PADDING - PARTICIPANT_BORDER_WIDTH
    };
}
function isConnection(element) {
    return !!element.waypoints;
}
function findParticipant(elements) {
    return (0, _minDash.find)(elements, function(element) {
        return (0, _modelUtil.is)(element, 'bpmn:Participant');
    });
}

},{"inherits-browser":"hymxq","diagram-js/lib/command/CommandInterceptor":"1K1IQ","../../../util/ModelUtil":"klNYN","../../../util/LabelUtil":"fAd5x","diagram-js/lib/util/Elements":"6qdtl","min-dash":"aEEla","diagram-js/lib/layout/LayoutUtil":"4CCrs","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lmzWr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DataInputAssociationBehavior);
var _inheritsBrowser = require("inherits-browser");
var _inheritsBrowserDefault = parcelHelpers.interopDefault(_inheritsBrowser);
var _commandInterceptor = require("diagram-js/lib/command/CommandInterceptor");
var _commandInterceptorDefault = parcelHelpers.interopDefault(_commandInterceptor);
var _collections = require("diagram-js/lib/util/Collections");
var _minDash = require("min-dash");
var _modelUtil = require("../../../util/ModelUtil");
var TARGET_REF_PLACEHOLDER_NAME = '__targetRef_placeholder';
function DataInputAssociationBehavior(eventBus, bpmnFactory) {
    (0, _commandInterceptorDefault.default).call(this, eventBus);
    this.executed([
        'connection.create',
        'connection.delete',
        'connection.move',
        'connection.reconnect'
    ], ifDataInputAssociation(fixTargetRef));
    this.reverted([
        'connection.create',
        'connection.delete',
        'connection.move',
        'connection.reconnect'
    ], ifDataInputAssociation(fixTargetRef));
    function usesTargetRef(element, targetRef, removedConnection) {
        var inputAssociations = element.get('dataInputAssociations');
        return (0, _minDash.find)(inputAssociations, function(association) {
            return association !== removedConnection && association.targetRef === targetRef;
        });
    }
    function getTargetRef(element, create) {
        var properties = element.get('properties');
        var targetRefProp = (0, _minDash.find)(properties, function(p) {
            return p.name === TARGET_REF_PLACEHOLDER_NAME;
        });
        if (!targetRefProp && create) {
            targetRefProp = bpmnFactory.create('bpmn:Property', {
                name: TARGET_REF_PLACEHOLDER_NAME
            });
            (0, _collections.add)(properties, targetRefProp);
        }
        return targetRefProp;
    }
    function cleanupTargetRef(element, connection) {
        var targetRefProp = getTargetRef(element);
        if (!targetRefProp) return;
        if (!usesTargetRef(element, targetRefProp, connection)) (0, _collections.remove)(element.get('properties'), targetRefProp);
    }
    /**
   * Make sure targetRef is set to a valid property or
   * `null` if the connection is detached.
   *
   * @param {Event} event
   */ function fixTargetRef(event) {
        var context = event.context, connection = context.connection, connectionBo = connection.businessObject, target = connection.target, targetBo = target && target.businessObject, newTarget = context.newTarget, newTargetBo = newTarget && newTarget.businessObject, oldTarget = context.oldTarget || context.target, oldTargetBo = oldTarget && oldTarget.businessObject;
        var dataAssociation = connection.businessObject, targetRefProp;
        if (oldTargetBo && oldTargetBo !== targetBo) cleanupTargetRef(oldTargetBo, connectionBo);
        if (newTargetBo && newTargetBo !== targetBo) cleanupTargetRef(newTargetBo, connectionBo);
        if (targetBo) {
            targetRefProp = getTargetRef(targetBo, true);
            dataAssociation.targetRef = targetRefProp;
        } else dataAssociation.targetRef = null;
    }
}
DataInputAssociationBehavior.$inject = [
    'eventBus',
    'bpmnFactory'
];
(0, _inheritsBrowserDefault.default)(DataInputAssociationBehavior, (0, _commandInterceptorDefault.default));
/**
 * Only call the given function when the event
 * touches a bpmn:DataInputAssociation.
 *
 * @param {Function} fn
 * @return {Function}
 */ function ifDataInputAssociation(fn) {
    return function(event) {
        var context = event.context, connection = context.connection;
        if ((0, _modelUtil.is)(connection, 'bpmn:DataInputAssociation')) return fn(event);
    };
}

},{"inherits-browser":"hymxq","diagram-js/lib/command/CommandInterceptor":"1K1IQ","diagram-js/lib/util/Collections":"kRUAD","min-dash":"aEEla","../../../util/ModelUtil":"klNYN","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"68YZ4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DataStoreBehavior);
var _inheritsBrowser = require("inherits-browser");
var _inheritsBrowserDefault = parcelHelpers.interopDefault(_inheritsBrowser);
var _commandInterceptor = require("diagram-js/lib/command/CommandInterceptor");
var _commandInterceptorDefault = parcelHelpers.interopDefault(_commandInterceptor);
var _modelUtil = require("../../../util/ModelUtil");
var _modelingUtil = require("../util/ModelingUtil");
var _updateSemanticParentHandler = require("../cmd/UpdateSemanticParentHandler");
var _updateSemanticParentHandlerDefault = parcelHelpers.interopDefault(_updateSemanticParentHandler);
function DataStoreBehavior(canvas, commandStack, elementRegistry, eventBus) {
    (0, _commandInterceptorDefault.default).call(this, eventBus);
    commandStack.registerHandler('dataStore.updateContainment', (0, _updateSemanticParentHandlerDefault.default));
    function getFirstParticipantWithProcessRef() {
        return elementRegistry.filter(function(element) {
            return (0, _modelUtil.is)(element, 'bpmn:Participant') && (0, _modelUtil.getBusinessObject)(element).processRef;
        })[0];
    }
    function getDataStores(element) {
        return element.children.filter(function(child) {
            return (0, _modelUtil.is)(child, 'bpmn:DataStoreReference') && !child.labelTarget;
        });
    }
    function updateDataStoreParent(dataStore, newDataStoreParent) {
        var dataStoreBo = dataStore.businessObject || dataStore;
        newDataStoreParent = newDataStoreParent || getFirstParticipantWithProcessRef();
        if (newDataStoreParent) {
            var newDataStoreParentBo = newDataStoreParent.businessObject || newDataStoreParent;
            commandStack.execute('dataStore.updateContainment', {
                dataStoreBo: dataStoreBo,
                dataStoreDi: (0, _modelUtil.getDi)(dataStore),
                newSemanticParent: newDataStoreParentBo.processRef || newDataStoreParentBo,
                newDiParent: (0, _modelUtil.getDi)(newDataStoreParent)
            });
        }
    }
    // disable auto-resize for data stores
    this.preExecute('shape.create', function(event) {
        var context = event.context, shape = context.shape;
        if ((0, _modelUtil.is)(shape, 'bpmn:DataStoreReference') && shape.type !== 'label') {
            if (!context.hints) context.hints = {};
            // prevent auto resizing
            context.hints.autoResize = false;
        }
    });
    // disable auto-resize for data stores
    this.preExecute('elements.move', function(event) {
        var context = event.context, shapes = context.shapes;
        var dataStoreReferences = shapes.filter(function(shape) {
            return (0, _modelUtil.is)(shape, 'bpmn:DataStoreReference');
        });
        if (dataStoreReferences.length) {
            if (!context.hints) context.hints = {};
            // prevent auto resizing for data store references
            context.hints.autoResize = shapes.filter(function(shape) {
                return !(0, _modelUtil.is)(shape, 'bpmn:DataStoreReference');
            });
        }
    });
    // update parent on data store created
    this.postExecute('shape.create', function(event) {
        var context = event.context, shape = context.shape, parent = shape.parent;
        if ((0, _modelUtil.is)(shape, 'bpmn:DataStoreReference') && shape.type !== 'label' && (0, _modelUtil.is)(parent, 'bpmn:Collaboration')) updateDataStoreParent(shape);
    });
    // update parent on data store moved
    this.postExecute('shape.move', function(event) {
        var context = event.context, shape = context.shape, oldParent = context.oldParent, parent = shape.parent;
        if ((0, _modelUtil.is)(oldParent, 'bpmn:Collaboration')) // do nothing if not necessary
        return;
        if ((0, _modelUtil.is)(shape, 'bpmn:DataStoreReference') && shape.type !== 'label' && (0, _modelUtil.is)(parent, 'bpmn:Collaboration')) {
            var participant = (0, _modelUtil.is)(oldParent, 'bpmn:Participant') ? oldParent : getAncestor(oldParent, 'bpmn:Participant');
            updateDataStoreParent(shape, participant);
        }
    });
    // update data store parents on participant or subprocess deleted
    this.postExecute('shape.delete', function(event) {
        var context = event.context, shape = context.shape, rootElement = canvas.getRootElement();
        if ((0, _modelingUtil.isAny)(shape, [
            'bpmn:Participant',
            'bpmn:SubProcess'
        ]) && (0, _modelUtil.is)(rootElement, 'bpmn:Collaboration')) getDataStores(rootElement).filter(function(dataStore) {
            return isDescendant(dataStore, shape);
        }).forEach(function(dataStore) {
            updateDataStoreParent(dataStore);
        });
    });
    // update data store parents on collaboration -> process
    this.postExecute('canvas.updateRoot', function(event) {
        var context = event.context, oldRoot = context.oldRoot, newRoot = context.newRoot;
        var dataStores = getDataStores(oldRoot);
        dataStores.forEach(function(dataStore) {
            if ((0, _modelUtil.is)(newRoot, 'bpmn:Process')) updateDataStoreParent(dataStore, newRoot);
        });
    });
}
DataStoreBehavior.$inject = [
    'canvas',
    'commandStack',
    'elementRegistry',
    'eventBus'
];
(0, _inheritsBrowserDefault.default)(DataStoreBehavior, (0, _commandInterceptorDefault.default));
// helpers //////////
function isDescendant(descendant, ancestor) {
    var descendantBo = descendant.businessObject || descendant, ancestorBo = ancestor.businessObject || ancestor;
    while(descendantBo.$parent){
        if (descendantBo.$parent === ancestorBo.processRef || ancestorBo) return true;
        descendantBo = descendantBo.$parent;
    }
    return false;
}
function getAncestor(element, type) {
    while(element.parent){
        if ((0, _modelUtil.is)(element.parent, type)) return element.parent;
        element = element.parent;
    }
}

},{"inherits-browser":"hymxq","diagram-js/lib/command/CommandInterceptor":"1K1IQ","../../../util/ModelUtil":"klNYN","../util/ModelingUtil":"4DR1e","../cmd/UpdateSemanticParentHandler":"5s6Bg","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5s6Bg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>UpdateSemanticParentHandler);
function UpdateSemanticParentHandler(bpmnUpdater) {
    this._bpmnUpdater = bpmnUpdater;
}
UpdateSemanticParentHandler.$inject = [
    'bpmnUpdater'
];
UpdateSemanticParentHandler.prototype.execute = function(context) {
    var dataStoreBo = context.dataStoreBo, dataStoreDi = context.dataStoreDi, newSemanticParent = context.newSemanticParent, newDiParent = context.newDiParent;
    context.oldSemanticParent = dataStoreBo.$parent;
    context.oldDiParent = dataStoreDi.$parent;
    // update semantic parent
    this._bpmnUpdater.updateSemanticParent(dataStoreBo, newSemanticParent);
    // update DI parent
    this._bpmnUpdater.updateDiParent(dataStoreDi, newDiParent);
};
UpdateSemanticParentHandler.prototype.revert = function(context) {
    var dataStoreBo = context.dataStoreBo, dataStoreDi = context.dataStoreDi, oldSemanticParent = context.oldSemanticParent, oldDiParent = context.oldDiParent;
    // update semantic parent
    this._bpmnUpdater.updateSemanticParent(dataStoreBo, oldSemanticParent);
    // update DI parent
    this._bpmnUpdater.updateDiParent(dataStoreDi, oldDiParent);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6rsij":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DeleteLaneBehavior);
var _inheritsBrowser = require("inherits-browser");
var _inheritsBrowserDefault = parcelHelpers.interopDefault(_inheritsBrowser);
var _commandInterceptor = require("diagram-js/lib/command/CommandInterceptor");
var _commandInterceptorDefault = parcelHelpers.interopDefault(_commandInterceptor);
var _modelUtil = require("../../../util/ModelUtil");
var _laneUtil = require("../util/LaneUtil");
var _elements = require("diagram-js/lib/util/Elements");
var LOW_PRIORITY = 500;
function DeleteLaneBehavior(eventBus, modeling, spaceTool) {
    (0, _commandInterceptorDefault.default).call(this, eventBus);
    function compensateLaneDelete(shape, oldParent) {
        var siblings = (0, _laneUtil.getChildLanes)(oldParent);
        var topAffected = [];
        var bottomAffected = [];
        (0, _elements.eachElement)(siblings, function(element) {
            if (element.y > shape.y) bottomAffected.push(element);
            else topAffected.push(element);
            return element.children;
        });
        if (!siblings.length) return;
        var offset;
        if (bottomAffected.length && topAffected.length) offset = shape.height / 2;
        else offset = shape.height;
        var topAdjustments, bottomAdjustments;
        if (topAffected.length) {
            topAdjustments = spaceTool.calculateAdjustments(topAffected, 'y', offset, shape.y - 10);
            spaceTool.makeSpace(topAdjustments.movingShapes, topAdjustments.resizingShapes, {
                x: 0,
                y: offset
            }, 's');
        }
        if (bottomAffected.length) {
            bottomAdjustments = spaceTool.calculateAdjustments(bottomAffected, 'y', -offset, shape.y + shape.height + 10);
            spaceTool.makeSpace(bottomAdjustments.movingShapes, bottomAdjustments.resizingShapes, {
                x: 0,
                y: -offset
            }, 'n');
        }
    }
    /**
   * Adjust sizes of other lanes after lane deletion
   */ this.postExecuted('shape.delete', LOW_PRIORITY, function(event) {
        var context = event.context, hints = context.hints, shape = context.shape, oldParent = context.oldParent;
        // only compensate lane deletes
        if (!(0, _modelUtil.is)(shape, 'bpmn:Lane')) return;
        // compensate root deletes only
        if (hints && hints.nested) return;
        compensateLaneDelete(shape, oldParent);
    });
}
DeleteLaneBehavior.$inject = [
    'eventBus',
    'modeling',
    'spaceTool'
];
(0, _inheritsBrowserDefault.default)(DeleteLaneBehavior, (0, _commandInterceptorDefault.default));

},{"inherits-browser":"hymxq","diagram-js/lib/command/CommandInterceptor":"1K1IQ","../../../util/ModelUtil":"klNYN","../util/LaneUtil":"fECqQ","diagram-js/lib/util/Elements":"6qdtl","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jMvjY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DetachEventBehavior);
var _inheritsBrowser = require("inherits-browser");
var _inheritsBrowserDefault = parcelHelpers.interopDefault(_inheritsBrowser);
var _commandInterceptor = require("diagram-js/lib/command/CommandInterceptor");
var _commandInterceptorDefault = parcelHelpers.interopDefault(_commandInterceptor);
var _modelUtil = require("../../../util/ModelUtil");
var _labelUtil = require("../../../util/LabelUtil");
var LOW_PRIORITY = 500;
function DetachEventBehavior(bpmnReplace, injector) {
    injector.invoke((0, _commandInterceptorDefault.default), this);
    this._bpmnReplace = bpmnReplace;
    var self = this;
    this.postExecuted('elements.create', LOW_PRIORITY, function(context) {
        var elements = context.elements;
        elements.filter(function(shape) {
            var host = shape.host;
            return shouldReplace(shape, host);
        }).map(function(shape) {
            return elements.indexOf(shape);
        }).forEach(function(index) {
            context.elements[index] = self.replaceShape(elements[index]);
        });
    }, true);
    this.preExecute('elements.move', LOW_PRIORITY, function(context) {
        var shapes = context.shapes, newHost = context.newHost;
        shapes.forEach(function(shape, index) {
            var host = shape.host;
            if (shouldReplace(shape, includes(shapes, host) ? host : newHost)) shapes[index] = self.replaceShape(shape);
        });
    }, true);
}
DetachEventBehavior.$inject = [
    'bpmnReplace',
    'injector'
];
(0, _inheritsBrowserDefault.default)(DetachEventBehavior, (0, _commandInterceptorDefault.default));
DetachEventBehavior.prototype.replaceShape = function(shape) {
    var eventDefinition = getEventDefinition(shape), intermediateEvent;
    if (eventDefinition) intermediateEvent = {
        type: 'bpmn:IntermediateCatchEvent',
        eventDefinitionType: eventDefinition.$type
    };
    else intermediateEvent = {
        type: 'bpmn:IntermediateThrowEvent'
    };
    return this._bpmnReplace.replaceElement(shape, intermediateEvent, {
        layoutConnection: false
    });
};
// helpers //////////
function getEventDefinition(element) {
    var businessObject = (0, _modelUtil.getBusinessObject)(element), eventDefinitions = businessObject.eventDefinitions;
    return eventDefinitions && eventDefinitions[0];
}
function shouldReplace(shape, host) {
    return !(0, _labelUtil.isLabel)(shape) && (0, _modelUtil.is)(shape, 'bpmn:BoundaryEvent') && !host;
}
function includes(array, item) {
    return array.indexOf(item) !== -1;
}

},{"inherits-browser":"hymxq","diagram-js/lib/command/CommandInterceptor":"1K1IQ","../../../util/ModelUtil":"klNYN","../../../util/LabelUtil":"fAd5x","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8hjEk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DropOnFlowBehavior);
var _inheritsBrowser = require("inherits-browser");
var _inheritsBrowserDefault = parcelHelpers.interopDefault(_inheritsBrowser);
var _minDash = require("min-dash");
var _layoutUtil = require("diagram-js/lib/layout/LayoutUtil");
var _commandInterceptor = require("diagram-js/lib/command/CommandInterceptor");
var _commandInterceptorDefault = parcelHelpers.interopDefault(_commandInterceptor);
var _lineIntersection = require("diagram-js/lib/util/LineIntersection");
function DropOnFlowBehavior(eventBus, bpmnRules, modeling) {
    (0, _commandInterceptorDefault.default).call(this, eventBus);
    /**
   * Reconnect start / end of a connection after
   * dropping an element on a flow.
   */ function insertShape(shape, targetFlow, positionOrBounds) {
        var waypoints = targetFlow.waypoints, waypointsBefore, waypointsAfter, dockingPoint, source, target, incomingConnection, outgoingConnection, oldOutgoing = shape.outgoing.slice(), oldIncoming = shape.incoming.slice();
        var mid;
        if ((0, _minDash.isNumber)(positionOrBounds.width)) mid = (0, _layoutUtil.getMid)(positionOrBounds);
        else mid = positionOrBounds;
        var intersection = (0, _lineIntersection.getApproxIntersection)(waypoints, mid);
        if (intersection) {
            waypointsBefore = waypoints.slice(0, intersection.index);
            waypointsAfter = waypoints.slice(intersection.index + (intersection.bendpoint ? 1 : 0));
            // due to inaccuracy intersection might have been found
            if (!waypointsBefore.length || !waypointsAfter.length) return;
            dockingPoint = intersection.bendpoint ? waypoints[intersection.index] : mid;
            // if last waypointBefore is inside shape's bounds, ignore docking point
            if (waypointsBefore.length === 1 || !isPointInsideBBox(shape, waypointsBefore[waypointsBefore.length - 1])) waypointsBefore.push(copy(dockingPoint));
            // if first waypointAfter is inside shape's bounds, ignore docking point
            if (waypointsAfter.length === 1 || !isPointInsideBBox(shape, waypointsAfter[0])) waypointsAfter.unshift(copy(dockingPoint));
        }
        source = targetFlow.source;
        target = targetFlow.target;
        if (bpmnRules.canConnect(source, shape, targetFlow)) {
            // reconnect source -> inserted shape
            modeling.reconnectEnd(targetFlow, shape, waypointsBefore || mid);
            incomingConnection = targetFlow;
        }
        if (bpmnRules.canConnect(shape, target, targetFlow)) {
            if (!incomingConnection) {
                // reconnect inserted shape -> end
                modeling.reconnectStart(targetFlow, shape, waypointsAfter || mid);
                outgoingConnection = targetFlow;
            } else outgoingConnection = modeling.connect(shape, target, {
                type: targetFlow.type,
                waypoints: waypointsAfter
            });
        }
        var duplicateConnections = [].concat(incomingConnection && (0, _minDash.filter)(oldIncoming, function(connection) {
            return connection.source === incomingConnection.source;
        }) || [], outgoingConnection && (0, _minDash.filter)(oldOutgoing, function(connection) {
            return connection.target === outgoingConnection.target;
        }) || []);
        if (duplicateConnections.length) modeling.removeElements(duplicateConnections);
    }
    this.preExecute('elements.move', function(context) {
        var newParent = context.newParent, shapes = context.shapes, delta = context.delta, shape = shapes[0];
        if (!shape || !newParent) return;
        // if the new parent is a connection,
        // change it to the new parent's parent
        if (newParent && newParent.waypoints) context.newParent = newParent = newParent.parent;
        var shapeMid = (0, _layoutUtil.getMid)(shape);
        var newShapeMid = {
            x: shapeMid.x + delta.x,
            y: shapeMid.y + delta.y
        };
        // find a connection which intersects with the
        // element's mid point
        var connection = (0, _minDash.find)(newParent.children, function(element) {
            var canInsert = bpmnRules.canInsert(shapes, element);
            return canInsert && (0, _lineIntersection.getApproxIntersection)(element.waypoints, newShapeMid);
        });
        if (connection) {
            context.targetFlow = connection;
            context.position = newShapeMid;
        }
    }, true);
    this.postExecuted('elements.move', function(context) {
        var shapes = context.shapes, targetFlow = context.targetFlow, position = context.position;
        if (targetFlow) insertShape(shapes[0], targetFlow, position);
    }, true);
    this.preExecute('shape.create', function(context) {
        var parent = context.parent, shape = context.shape;
        if (bpmnRules.canInsert(shape, parent)) {
            context.targetFlow = parent;
            context.parent = parent.parent;
        }
    }, true);
    this.postExecuted('shape.create', function(context) {
        var shape = context.shape, targetFlow = context.targetFlow, positionOrBounds = context.position;
        if (targetFlow) insertShape(shape, targetFlow, positionOrBounds);
    }, true);
}
(0, _inheritsBrowserDefault.default)(DropOnFlowBehavior, (0, _commandInterceptorDefault.default));
DropOnFlowBehavior.$inject = [
    'eventBus',
    'bpmnRules',
    'modeling'
];
// helpers /////////////////////
function isPointInsideBBox(bbox, point) {
    var x = point.x, y = point.y;
    return x >= bbox.x && x <= bbox.x + bbox.width && y >= bbox.y && y <= bbox.y + bbox.height;
}
function copy(obj) {
    return (0, _minDash.assign)({}, obj);
}

},{"inherits-browser":"hymxq","min-dash":"aEEla","diagram-js/lib/layout/LayoutUtil":"4CCrs","diagram-js/lib/command/CommandInterceptor":"1K1IQ","diagram-js/lib/util/LineIntersection":"6KlXN","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7uTE2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>EventBasedGatewayBehavior);
var _inheritsBrowser = require("inherits-browser");
var _inheritsBrowserDefault = parcelHelpers.interopDefault(_inheritsBrowser);
var _commandInterceptor = require("diagram-js/lib/command/CommandInterceptor");
var _commandInterceptorDefault = parcelHelpers.interopDefault(_commandInterceptor);
var _modelUtil = require("../../../util/ModelUtil");
function EventBasedGatewayBehavior(eventBus, modeling) {
    (0, _commandInterceptorDefault.default).call(this, eventBus);
    /**
   * Remove incoming sequence flows of event-based target when creating
   * sequence flow.
   *
   * 1. If source is event-based gateway remove all incoming sequence flows
   * 2. If source is not event-based gateway remove all incoming sequence flows
   * whose source is event-based gateway
   */ this.preExecuted('connection.create', function(event) {
        var context = event.context, connection = context.connection, source = context.source, target = context.target, hints = context.hints;
        if (hints && hints.createElementsBehavior === false) return;
        if (!isSequenceFlow(connection)) return;
        var sequenceFlows = [];
        if ((0, _modelUtil.is)(source, 'bpmn:EventBasedGateway')) sequenceFlows = target.incoming.filter(isSequenceFlow);
        else sequenceFlows = target.incoming.filter(function(connection) {
            return isSequenceFlow(connection) && (0, _modelUtil.is)(connection.source, 'bpmn:EventBasedGateway');
        });
        sequenceFlows.forEach(function(sequenceFlow) {
            modeling.removeConnection(sequenceFlow);
        });
    });
    /**
   * Remove incoming sequence flows of event-based targets when replacing source
   * with event-based gateway.
   */ this.preExecuted('shape.replace', function(event) {
        var context = event.context, newShape = context.newShape;
        if (!(0, _modelUtil.is)(newShape, 'bpmn:EventBasedGateway')) return;
        var targets = newShape.outgoing.filter(isSequenceFlow).reduce(function(targets, sequenceFlow) {
            if (!targets.includes(sequenceFlow.target)) return targets.concat(sequenceFlow.target);
            return targets;
        }, []);
        targets.forEach(function(target) {
            target.incoming.filter(isSequenceFlow).forEach(function(sequenceFlow) {
                const sequenceFlowsFromNewShape = target.incoming.filter(isSequenceFlow).filter(function(sequenceFlow) {
                    return sequenceFlow.source === newShape;
                });
                if (sequenceFlow.source !== newShape || sequenceFlowsFromNewShape.length > 1) modeling.removeConnection(sequenceFlow);
            });
        });
    });
}
EventBasedGatewayBehavior.$inject = [
    'eventBus',
    'modeling'
];
(0, _inheritsBrowserDefault.default)(EventBasedGatewayBehavior, (0, _commandInterceptorDefault.default));
// helpers //////////
function isSequenceFlow(connection) {
    return (0, _modelUtil.is)(connection, 'bpmn:SequenceFlow');
}

},{"inherits-browser":"hymxq","diagram-js/lib/command/CommandInterceptor":"1K1IQ","../../../util/ModelUtil":"klNYN","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2peYV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FixHoverBehavior);
var _laneUtil = require("../util/LaneUtil");
var _modelUtil = require("../../../util/ModelUtil");
var _modelingUtil = require("../util/ModelingUtil");
var HIGH_PRIORITY = 1500;
var HIGHEST_PRIORITY = 2000;
function FixHoverBehavior(elementRegistry, eventBus, canvas) {
    eventBus.on([
        'create.hover',
        'create.move',
        'create.out',
        'create.end',
        'shape.move.hover',
        'shape.move.move',
        'shape.move.out',
        'shape.move.end'
    ], HIGH_PRIORITY, function(event) {
        var context = event.context, shape = context.shape || event.shape, hover = event.hover;
        // ensure elements are not dropped onto a bpmn:Lane but onto
        // the underlying bpmn:Participant
        if ((0, _modelUtil.is)(hover, 'bpmn:Lane') && !(0, _modelingUtil.isAny)(shape, [
            'bpmn:Lane',
            'bpmn:Participant'
        ])) {
            event.hover = (0, _laneUtil.getLanesRoot)(hover);
            event.hoverGfx = elementRegistry.getGraphics(event.hover);
        }
        var rootElement = canvas.getRootElement();
        // ensure bpmn:Group and label elements are dropped
        // always onto the root
        if (hover !== rootElement && (shape.labelTarget || (0, _modelUtil.is)(shape, 'bpmn:Group'))) {
            event.hover = rootElement;
            event.hoverGfx = elementRegistry.getGraphics(event.hover);
        }
    });
    eventBus.on([
        'connect.hover',
        'connect.out',
        'connect.end',
        'connect.cleanup',
        'global-connect.hover',
        'global-connect.out',
        'global-connect.end',
        'global-connect.cleanup'
    ], HIGH_PRIORITY, function(event) {
        var hover = event.hover;
        // ensure connections start/end on bpmn:Participant,
        // not the underlying bpmn:Lane
        if ((0, _modelUtil.is)(hover, 'bpmn:Lane')) {
            event.hover = (0, _laneUtil.getLanesRoot)(hover) || hover;
            event.hoverGfx = elementRegistry.getGraphics(event.hover);
        }
    });
    eventBus.on([
        'bendpoint.move.hover'
    ], HIGH_PRIORITY, function(event) {
        var context = event.context, hover = event.hover, type = context.type;
        // ensure reconnect start/end on bpmn:Participant,
        // not the underlying bpmn:Lane
        if ((0, _modelUtil.is)(hover, 'bpmn:Lane') && /reconnect/.test(type)) {
            event.hover = (0, _laneUtil.getLanesRoot)(hover) || hover;
            event.hoverGfx = elementRegistry.getGraphics(event.hover);
        }
    });
    eventBus.on([
        'connect.start'
    ], HIGH_PRIORITY, function(event) {
        var context = event.context, start = context.start;
        // ensure connect start on bpmn:Participant,
        // not the underlying bpmn:Lane
        if ((0, _modelUtil.is)(start, 'bpmn:Lane')) context.start = (0, _laneUtil.getLanesRoot)(start) || start;
    });
    // allow movement of participants from lanes
    eventBus.on('shape.move.start', HIGHEST_PRIORITY, function(event) {
        var shape = event.shape;
        if ((0, _modelUtil.is)(shape, 'bpmn:Lane')) event.shape = (0, _laneUtil.getLanesRoot)(shape) || shape;
    });
}
FixHoverBehavior.$inject = [
    'elementRegistry',
    'eventBus',
    'canvas'
];

},{"../util/LaneUtil":"fECqQ","../../../util/ModelUtil":"klNYN","../util/ModelingUtil":"4DR1e","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jHN9O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>GroupBehavior);
var _inheritsBrowser = require("inherits-browser");
var _inheritsBrowserDefault = parcelHelpers.interopDefault(_inheritsBrowser);
var _commandInterceptor = require("diagram-js/lib/command/CommandInterceptor");
var _commandInterceptorDefault = parcelHelpers.interopDefault(_commandInterceptor);
var _modelUtil = require("../../../util/ModelUtil");
var _categoryUtil = require("./util/CategoryUtil");
var LOWER_PRIORITY = 770;
function GroupBehavior(bpmnFactory, bpmnjs, elementRegistry, eventBus, injector, moddleCopy) {
    injector.invoke((0, _commandInterceptorDefault.default), this);
    /**
   * Returns all group element in the current registry
   *
   * @return {Array<djs.model.shape>} a list of group shapes
   */ function getGroupElements() {
        return elementRegistry.filter(function(e) {
            return (0, _modelUtil.is)(e, 'bpmn:Group');
        });
    }
    /**
   * Returns true if given category is referenced in one of the given elements
   *
   * @param { djs.model.Element[] } elements
   * @param { ModdleElement } category
   *
   * @return { boolean }
   */ function isReferencedCategory(elements, category) {
        return elements.some(function(element) {
            var businessObject = (0, _modelUtil.getBusinessObject)(element);
            var _category = businessObject.categoryValueRef && businessObject.categoryValueRef.$parent;
            return _category === category;
        });
    }
    /**
   * Returns true if given categoryValue is referenced in one of the given elements
   *
   * @param { djs.model.Element[] } elements
   * @param { ModdleElement } categoryValue
   *
   * @return { boolean }
   */ function isReferencedCategoryValue(elements, categoryValue) {
        return elements.some(function(element) {
            var businessObject = (0, _modelUtil.getBusinessObject)(element);
            return businessObject.categoryValueRef === categoryValue;
        });
    }
    /**
   * Remove category value unless it is still referenced
   *
   * @param {ModdleElement} categoryValue
   * @param {ModdleElement} category
   * @param {ModdleElement} businessObject
   */ function removeCategoryValue(categoryValue, category, businessObject) {
        var groups = getGroupElements().filter(function(element) {
            return element.businessObject !== businessObject;
        });
        if (category && !isReferencedCategory(groups, category)) (0, _categoryUtil.unlinkCategory)(category);
        if (categoryValue && !isReferencedCategoryValue(groups, categoryValue)) (0, _categoryUtil.unlinkCategoryValue)(categoryValue);
    }
    /**
   * Add category value
   *
   * @param {ModdleElement} categoryValue
   * @param {ModdleElement} category
   */ function addCategoryValue(categoryValue, category) {
        return (0, _categoryUtil.linkCategoryValue)(categoryValue, category, bpmnjs.getDefinitions());
    }
    function setCategoryValue(element, context) {
        var businessObject = (0, _modelUtil.getBusinessObject)(element), categoryValue = businessObject.categoryValueRef;
        if (!categoryValue) categoryValue = businessObject.categoryValueRef = context.categoryValue = context.categoryValue || (0, _categoryUtil.createCategoryValue)(bpmnFactory);
        var category = categoryValue.$parent;
        if (!category) category = categoryValue.$parent = context.category = context.category || (0, _categoryUtil.createCategory)(bpmnFactory);
        addCategoryValue(categoryValue, category, bpmnjs.getDefinitions());
    }
    function unsetCategoryValue(element, context) {
        var category = context.category, categoryValue = context.categoryValue, businessObject = (0, _modelUtil.getBusinessObject)(element);
        if (categoryValue) {
            businessObject.categoryValueRef = null;
            removeCategoryValue(categoryValue, category, businessObject);
        } else removeCategoryValue(null, businessObject.categoryValueRef.$parent, businessObject);
    }
    // ensure category + value exist before label editing
    this.execute('label.create', function(event) {
        var context = event.context, labelTarget = context.labelTarget;
        if (!(0, _modelUtil.is)(labelTarget, 'bpmn:Group')) return;
        setCategoryValue(labelTarget, context);
    });
    this.revert('label.create', function(event) {
        var context = event.context, labelTarget = context.labelTarget;
        if (!(0, _modelUtil.is)(labelTarget, 'bpmn:Group')) return;
        unsetCategoryValue(labelTarget, context);
    });
    // remove referenced category + value when group was deleted
    this.execute('shape.delete', function(event) {
        var context = event.context, shape = context.shape, businessObject = (0, _modelUtil.getBusinessObject)(shape);
        if (!(0, _modelUtil.is)(shape, 'bpmn:Group') || shape.labelTarget) return;
        var categoryValue = context.categoryValue = businessObject.categoryValueRef, category;
        if (categoryValue) {
            category = context.category = categoryValue.$parent;
            removeCategoryValue(categoryValue, category, businessObject);
            businessObject.categoryValueRef = null;
        }
    });
    this.reverted('shape.delete', function(event) {
        var context = event.context, shape = context.shape;
        if (!(0, _modelUtil.is)(shape, 'bpmn:Group') || shape.labelTarget) return;
        var category = context.category, categoryValue = context.categoryValue, businessObject = (0, _modelUtil.getBusinessObject)(shape);
        if (categoryValue) {
            businessObject.categoryValueRef = categoryValue;
            addCategoryValue(categoryValue, category);
        }
    });
    // create new category + value when group was created
    this.execute('shape.create', function(event) {
        var context = event.context, shape = context.shape;
        if (!(0, _modelUtil.is)(shape, 'bpmn:Group') || shape.labelTarget) return;
        if ((0, _modelUtil.getBusinessObject)(shape).categoryValueRef) setCategoryValue(shape, context);
    });
    this.reverted('shape.create', function(event) {
        var context = event.context, shape = context.shape;
        if (!(0, _modelUtil.is)(shape, 'bpmn:Group') || shape.labelTarget) return;
        if ((0, _modelUtil.getBusinessObject)(shape).categoryValueRef) unsetCategoryValue(shape, context);
    });
    // copy + paste categoryValueRef with group
    function copy(bo, clone) {
        var targetBo = bpmnFactory.create(bo.$type);
        return moddleCopy.copyElement(bo, targetBo, null, clone);
    }
    eventBus.on('copyPaste.copyElement', LOWER_PRIORITY, function(context) {
        var descriptor = context.descriptor, element = context.element;
        if (!(0, _modelUtil.is)(element, 'bpmn:Group') || element.labelTarget) return;
        var groupBo = (0, _modelUtil.getBusinessObject)(element);
        if (groupBo.categoryValueRef) {
            var categoryValue = groupBo.categoryValueRef;
            descriptor.categoryValue = copy(categoryValue, true);
            if (categoryValue.$parent) descriptor.category = copy(categoryValue.$parent, true);
        }
    });
    eventBus.on('copyPaste.pasteElement', LOWER_PRIORITY, function(context) {
        var descriptor = context.descriptor, businessObject = descriptor.businessObject, categoryValue = descriptor.categoryValue, category = descriptor.category;
        if (categoryValue) categoryValue = businessObject.categoryValueRef = copy(categoryValue);
        if (category) categoryValue.$parent = copy(category);
        delete descriptor.category;
        delete descriptor.categoryValue;
    });
}
GroupBehavior.$inject = [
    'bpmnFactory',
    'bpmnjs',
    'elementRegistry',
    'eventBus',
    'injector',
    'moddleCopy'
];
(0, _inheritsBrowserDefault.default)(GroupBehavior, (0, _commandInterceptorDefault.default));

},{"inherits-browser":"hymxq","diagram-js/lib/command/CommandInterceptor":"1K1IQ","../../../util/ModelUtil":"klNYN","./util/CategoryUtil":"6XLPr","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6XLPr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Creates a new bpmn:CategoryValue inside a new bpmn:Category
 *
 * @param {BpmnFactory} bpmnFactory
 *
 * @return {ModdleElement} categoryValue.
 */ parcelHelpers.export(exports, "createCategory", ()=>createCategory);
/**
 * Creates a new bpmn:CategoryValue inside a new bpmn:Category
 *
 * @param {BpmnFactory} bpmnFactory
 *
 * @return {ModdleElement} categoryValue.
 */ parcelHelpers.export(exports, "createCategoryValue", ()=>createCategoryValue);
/**
 * Adds category value to definitions
 *
 * @param {ModdleElement} categoryValue
 * @param {ModdleElement} category
 * @param {ModdleElement} definitions
 *
 * @return {ModdleElement} categoryValue
 */ parcelHelpers.export(exports, "linkCategoryValue", ()=>linkCategoryValue);
/**
 * Unlink category value from parent
 *
 * @param {ModdleElement} categoryValue
 *
 * @return {ModdleElement} categoryValue
 */ parcelHelpers.export(exports, "unlinkCategoryValue", ()=>unlinkCategoryValue);
/**
 * Unlink category from parent
 *
 * @param {ModdleElement} category
 * @param {ModdleElement} definitions
 *
 * @return {ModdleElement} categoryValue
 */ parcelHelpers.export(exports, "unlinkCategory", ()=>unlinkCategory);
var _collections = require("diagram-js/lib/util/Collections");
function createCategory(bpmnFactory) {
    return bpmnFactory.create('bpmn:Category');
}
function createCategoryValue(bpmnFactory) {
    return bpmnFactory.create('bpmn:CategoryValue');
}
function linkCategoryValue(categoryValue, category, definitions) {
    (0, _collections.add)(category.get('categoryValue'), categoryValue);
    categoryValue.$parent = category;
    (0, _collections.add)(definitions.get('rootElements'), category);
    category.$parent = definitions;
    return categoryValue;
}
function unlinkCategoryValue(categoryValue) {
    var category = categoryValue.$parent;
    if (category) {
        (0, _collections.remove)(category.get('categoryValue'), categoryValue);
        categoryValue.$parent = null;
    }
    return categoryValue;
}
function unlinkCategory(category) {
    var definitions = category.$parent;
    if (definitions) {
        (0, _collections.remove)(definitions.get('rootElements'), category);
        category.$parent = null;
    }
    return category;
}

},{"diagram-js/lib/util/Collections":"kRUAD","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"i4MCl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ImportDockingFix);
var _layoutUtil = require("diagram-js/lib/layout/LayoutUtil");
var _lineIntersect = require("./util/LineIntersect");
var _lineIntersectDefault = parcelHelpers.interopDefault(_lineIntersect);
function ImportDockingFix(eventBus) {
    function adjustDocking(startPoint, nextPoint, elementMid) {
        var elementTop = {
            x: elementMid.x,
            y: elementMid.y - 50
        };
        var elementLeft = {
            x: elementMid.x - 50,
            y: elementMid.y
        };
        var verticalIntersect = (0, _lineIntersectDefault.default)(startPoint, nextPoint, elementMid, elementTop), horizontalIntersect = (0, _lineIntersectDefault.default)(startPoint, nextPoint, elementMid, elementLeft);
        // original is horizontal or vertical center cross intersection
        var centerIntersect;
        if (verticalIntersect && horizontalIntersect) {
            if (getDistance(verticalIntersect, elementMid) > getDistance(horizontalIntersect, elementMid)) centerIntersect = horizontalIntersect;
            else centerIntersect = verticalIntersect;
        } else centerIntersect = verticalIntersect || horizontalIntersect;
        startPoint.original = centerIntersect;
    }
    function fixDockings(connection) {
        var waypoints = connection.waypoints;
        adjustDocking(waypoints[0], waypoints[1], (0, _layoutUtil.getMid)(connection.source));
        adjustDocking(waypoints[waypoints.length - 1], waypoints[waypoints.length - 2], (0, _layoutUtil.getMid)(connection.target));
    }
    eventBus.on('bpmnElement.added', function(e) {
        var element = e.element;
        if (element.waypoints) fixDockings(element);
    });
}
ImportDockingFix.$inject = [
    'eventBus'
];
// helpers //////////////////////
function getDistance(p1, p2) {
    return Math.sqrt(Math.pow(p1.x - p2.x, 2) + Math.pow(p1.y - p2.y, 2));
}

},{"diagram-js/lib/layout/LayoutUtil":"4CCrs","./util/LineIntersect":"lQdNJ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lQdNJ":[function(require,module,exports,__globalThis) {
/**
 * Returns the intersection between two line segments a and b.
 *
 * @param {Point} l1s
 * @param {Point} l1e
 * @param {Point} l2s
 * @param {Point} l2e
 *
 * @return {Point}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>lineIntersect);
function lineIntersect(l1s, l1e, l2s, l2e) {
    // if the lines intersect, the result contains the x and y of the
    // intersection (treating the lines as infinite) and booleans for
    // whether line segment 1 or line segment 2 contain the point
    var denominator, a, b, c, numerator;
    denominator = (l2e.y - l2s.y) * (l1e.x - l1s.x) - (l2e.x - l2s.x) * (l1e.y - l1s.y);
    if (denominator == 0) return null;
    a = l1s.y - l2s.y;
    b = l1s.x - l2s.x;
    numerator = (l2e.x - l2s.x) * a - (l2e.y - l2s.y) * b;
    c = numerator / denominator;
    // if we cast these lines infinitely in
    // both directions, they intersect here
    return {
        x: Math.round(l1s.x + c * (l1e.x - l1s.x)),
        y: Math.round(l1s.y + c * (l1e.y - l1s.y))
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1nKWP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>IsHorizontalFix);
var _inheritsBrowser = require("inherits-browser");
var _inheritsBrowserDefault = parcelHelpers.interopDefault(_inheritsBrowser);
var _commandInterceptor = require("diagram-js/lib/command/CommandInterceptor");
var _commandInterceptorDefault = parcelHelpers.interopDefault(_commandInterceptor);
var _modelUtil = require("../../../util/ModelUtil");
var _modelingUtil = require("../util/ModelingUtil");
function IsHorizontalFix(eventBus) {
    (0, _commandInterceptorDefault.default).call(this, eventBus);
    var elementTypesToUpdate = [
        'bpmn:Participant',
        'bpmn:Lane'
    ];
    this.executed([
        'shape.move',
        'shape.create',
        'shape.resize'
    ], function(event) {
        var shape = event.context.shape, bo = (0, _modelUtil.getBusinessObject)(shape), di = (0, _modelUtil.getDi)(shape);
        if ((0, _modelingUtil.isAny)(bo, elementTypesToUpdate) && !di.get('isHorizontal')) // set attribute directly to avoid modeling#updateProperty side effects
        di.set('isHorizontal', true);
    });
}
IsHorizontalFix.$inject = [
    'eventBus'
];
(0, _inheritsBrowserDefault.default)(IsHorizontalFix, (0, _commandInterceptorDefault.default));

},{"inherits-browser":"hymxq","diagram-js/lib/command/CommandInterceptor":"1K1IQ","../../../util/ModelUtil":"klNYN","../util/ModelingUtil":"4DR1e","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5T1aT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>LabelBehavior);
// helpers //////////////////////
/**
 * Calculates a reference point delta relative to a new position
 * of a certain element's bounds
 *
 * @param {Point} point
 * @param {Bounds} oldBounds
 * @param {Bounds} newBounds
 *
 * @return {Delta} delta
 */ parcelHelpers.export(exports, "getReferencePointDelta", ()=>getReferencePointDelta);
/**
 * Generates the nearest point (reference point) for a given point
 * onto given set of lines
 *
 * @param {Array<Point, Point>} lines
 * @param {Point} point
 *
 * @param {Point}
 */ parcelHelpers.export(exports, "getReferencePoint", ()=>getReferencePoint);
/**
 * Convert the given bounds to a lines array containing all edges
 *
 * @param {Bounds|Point} bounds
 *
 * @return Array<Point>
 */ parcelHelpers.export(exports, "asEdges", ()=>asEdges);
var _minDash = require("min-dash");
var _inheritsBrowser = require("inherits-browser");
var _inheritsBrowserDefault = parcelHelpers.interopDefault(_inheritsBrowser);
var _modelUtil = require("../../../util/ModelUtil");
var _labelUtil = require("../../../util/LabelUtil");
var _labelUtil1 = require("../../label-editing/LabelUtil");
var _labelLayoutUtil = require("./util/LabelLayoutUtil");
var _commandInterceptor = require("diagram-js/lib/command/CommandInterceptor");
var _commandInterceptorDefault = parcelHelpers.interopDefault(_commandInterceptor);
var _attachUtil = require("diagram-js/lib/util/AttachUtil");
var _layoutUtil = require("diagram-js/lib/layout/LayoutUtil");
var _positionUtil = require("diagram-js/lib/util/PositionUtil");
var _geometricUtil = require("./util/GeometricUtil");
var DEFAULT_LABEL_DIMENSIONS = {
    width: 90,
    height: 20
};
var NAME_PROPERTY = 'name';
var TEXT_PROPERTY = 'text';
function LabelBehavior(eventBus, modeling, bpmnFactory, textRenderer) {
    (0, _commandInterceptorDefault.default).call(this, eventBus);
    // update label if name property was updated
    this.postExecute('element.updateProperties', function(e) {
        var context = e.context, element = context.element, properties = context.properties;
        if (NAME_PROPERTY in properties) modeling.updateLabel(element, properties[NAME_PROPERTY]);
        if (TEXT_PROPERTY in properties && (0, _modelUtil.is)(element, 'bpmn:TextAnnotation')) {
            var newBounds = textRenderer.getTextAnnotationBounds({
                x: element.x,
                y: element.y,
                width: element.width,
                height: element.height
            }, properties[TEXT_PROPERTY] || '');
            modeling.updateLabel(element, properties.text, newBounds);
        }
    });
    // create label shape after shape/connection was created
    this.postExecute([
        'shape.create',
        'connection.create'
    ], function(e) {
        var context = e.context, hints = context.hints || {};
        if (hints.createElementsBehavior === false) return;
        var element = context.shape || context.connection, businessObject = element.businessObject;
        if ((0, _labelUtil.isLabel)(element) || !(0, _labelUtil.isLabelExternal)(element)) return;
        // only create label if attribute available
        if (!(0, _labelUtil1.getLabel)(element)) return;
        var labelCenter = (0, _labelUtil.getExternalLabelMid)(element);
        // we don't care about x and y
        var labelDimensions = textRenderer.getExternalLabelBounds(DEFAULT_LABEL_DIMENSIONS, (0, _labelUtil1.getLabel)(element));
        modeling.createLabel(element, labelCenter, {
            id: businessObject.id + '_label',
            businessObject: businessObject,
            width: labelDimensions.width,
            height: labelDimensions.height
        });
    });
    // update label after label shape was deleted
    this.postExecute('shape.delete', function(event) {
        var context = event.context, labelTarget = context.labelTarget, hints = context.hints || {};
        // check if label
        if (labelTarget && hints.unsetLabel !== false) modeling.updateLabel(labelTarget, null, null, {
            removeShape: false
        });
    });
    // update di information on label creation
    this.postExecute([
        'label.create'
    ], function(event) {
        var context = event.context, element = context.shape, labelTarget = context.labelTarget, di;
        // we want to trigger on real labels only
        if (!labelTarget) return;
        // we want to trigger on BPMN elements only
        if (!(0, _modelUtil.is)(labelTarget, 'bpmn:BaseElement')) return;
        di = (0, _modelUtil.getDi)(labelTarget);
        if (!di.label) {
            di.label = bpmnFactory.create('bpmndi:BPMNLabel', {
                bounds: bpmnFactory.create('dc:Bounds')
            });
            element.di = di;
        }
        (0, _minDash.assign)(di.label.bounds, {
            x: element.x,
            y: element.y,
            width: element.width,
            height: element.height
        });
    });
    function getVisibleLabelAdjustment(event) {
        var context = event.context, connection = context.connection, label = connection.label, hints = (0, _minDash.assign)({}, context.hints), newWaypoints = context.newWaypoints || connection.waypoints, oldWaypoints = context.oldWaypoints;
        if (typeof hints.startChanged === 'undefined') hints.startChanged = !!hints.connectionStart;
        if (typeof hints.endChanged === 'undefined') hints.endChanged = !!hints.connectionEnd;
        return (0, _labelLayoutUtil.getLabelAdjustment)(label, newWaypoints, oldWaypoints, hints);
    }
    this.postExecute([
        'connection.layout',
        'connection.updateWaypoints'
    ], function(event) {
        var context = event.context, hints = context.hints || {};
        if (hints.labelBehavior === false) return;
        var connection = context.connection, label = connection.label, labelAdjustment;
        // handle missing label as well as the case
        // that the label parent does not exist (yet),
        // because it is being pasted / created via multi element create
        //
        // Cf. https://github.com/bpmn-io/bpmn-js/pull/1227
        if (!label || !label.parent) return;
        labelAdjustment = getVisibleLabelAdjustment(event);
        modeling.moveShape(label, labelAdjustment);
    });
    // keep label position on shape replace
    this.postExecute([
        'shape.replace'
    ], function(event) {
        var context = event.context, newShape = context.newShape, oldShape = context.oldShape;
        var businessObject = (0, _modelUtil.getBusinessObject)(newShape);
        if (businessObject && (0, _labelUtil.isLabelExternal)(businessObject) && oldShape.label && newShape.label) {
            newShape.label.x = oldShape.label.x;
            newShape.label.y = oldShape.label.y;
        }
    });
    // move external label after resizing
    this.postExecute('shape.resize', function(event) {
        var context = event.context, shape = context.shape, newBounds = context.newBounds, oldBounds = context.oldBounds;
        if ((0, _labelUtil.hasExternalLabel)(shape)) {
            var label = shape.label, labelMid = (0, _layoutUtil.getMid)(label), edges = asEdges(oldBounds);
            // get nearest border point to label as reference point
            var referencePoint = getReferencePoint(labelMid, edges);
            var delta = getReferencePointDelta(referencePoint, oldBounds, newBounds);
            modeling.moveShape(label, delta);
        }
    });
}
(0, _inheritsBrowserDefault.default)(LabelBehavior, (0, _commandInterceptorDefault.default));
LabelBehavior.$inject = [
    'eventBus',
    'modeling',
    'bpmnFactory',
    'textRenderer'
];
function getReferencePointDelta(referencePoint, oldBounds, newBounds) {
    var newReferencePoint = (0, _attachUtil.getNewAttachPoint)(referencePoint, oldBounds, newBounds);
    return (0, _layoutUtil.roundPoint)((0, _positionUtil.delta)(newReferencePoint, referencePoint));
}
function getReferencePoint(point, lines) {
    if (!lines.length) return;
    var nearestLine = getNearestLine(point, lines);
    return (0, _geometricUtil.perpendicularFoot)(point, nearestLine);
}
function asEdges(bounds) {
    return [
        [
            {
                x: bounds.x,
                y: bounds.y
            },
            {
                x: bounds.x + (bounds.width || 0),
                y: bounds.y
            }
        ],
        [
            {
                x: bounds.x + (bounds.width || 0),
                y: bounds.y
            },
            {
                x: bounds.x + (bounds.width || 0),
                y: bounds.y + (bounds.height || 0)
            }
        ],
        [
            {
                x: bounds.x,
                y: bounds.y + (bounds.height || 0)
            },
            {
                x: bounds.x + (bounds.width || 0),
                y: bounds.y + (bounds.height || 0)
            }
        ],
        [
            {
                x: bounds.x,
                y: bounds.y
            },
            {
                x: bounds.x,
                y: bounds.y + (bounds.height || 0)
            }
        ]
    ];
}
/**
 * Returns the nearest line for a given point by distance
 * @param {Point} point
 * @param Array<Point> lines
 *
 * @return Array<Point>
 */ function getNearestLine(point, lines) {
    var distances = lines.map(function(l) {
        return {
            line: l,
            distance: (0, _geometricUtil.getDistancePointLine)(point, l)
        };
    });
    var sorted = (0, _minDash.sortBy)(distances, 'distance');
    return sorted[0].line;
}

},{"min-dash":"aEEla","inherits-browser":"hymxq","../../../util/ModelUtil":"klNYN","../../../util/LabelUtil":"fAd5x","../../label-editing/LabelUtil":"gHqpR","./util/LabelLayoutUtil":"lST5K","diagram-js/lib/command/CommandInterceptor":"1K1IQ","diagram-js/lib/util/AttachUtil":"IwjBN","diagram-js/lib/layout/LayoutUtil":"4CCrs","diagram-js/lib/util/PositionUtil":"flrPc","./util/GeometricUtil":"39B1V","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lST5K":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "findNewLabelLineStartIndex", ()=>findNewLabelLineStartIndex);
/**
 * Calculate the required adjustment (move delta) for the given label
 * after the connection waypoints got updated.
 *
 * @param {djs.model.Label} label
 * @param {Array<Point>} newWaypoints
 * @param {Array<Point>} oldWaypoints
 * @param {Object} hints
 *
 * @return {Point} delta
 */ parcelHelpers.export(exports, "getLabelAdjustment", ()=>getLabelAdjustment);
var _layoutUtil = require("./LayoutUtil");
function findNewLabelLineStartIndex(oldWaypoints, newWaypoints, attachment, hints) {
    return (0, _layoutUtil.findNewLineStartIndex)(oldWaypoints, newWaypoints, attachment, hints);
}
function getLabelAdjustment(label, newWaypoints, oldWaypoints, hints) {
    var labelPosition = getLabelMid(label);
    return (0, _layoutUtil.getAnchorPointAdjustment)(labelPosition, newWaypoints, oldWaypoints, hints).delta;
}
// HELPERS //////////////////////
function getLabelMid(label) {
    return {
        x: label.x + label.width / 2,
        y: label.y + label.height / 2
    };
}

},{"./LayoutUtil":"2HDKR","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2HDKR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "findNewLineStartIndex", ()=>findNewLineStartIndex);
/**
 * Calculate the required adjustment (move delta) for the given point
 * after the connection waypoints got updated.
 *
 * @param {Point} position
 * @param {Array<Point>} newWaypoints
 * @param {Array<Point>} oldWaypoints
 * @param {Object} hints
 *
 * @return {Object} result
 * @return {Point} result.point
 * @return {Point} result.delta
 */ parcelHelpers.export(exports, "getAnchorPointAdjustment", ()=>getAnchorPointAdjustment);
var _geometricUtil = require("./GeometricUtil");
var _lineAttachmentUtil = require("./LineAttachmentUtil");
var _layoutUtil = require("diagram-js/lib/layout/LayoutUtil");
function findNewLineStartIndex(oldWaypoints, newWaypoints, attachment, hints) {
    var index = attachment.segmentIndex;
    var offset = newWaypoints.length - oldWaypoints.length;
    // segmentMove happened
    if (hints.segmentMove) {
        var oldSegmentStartIndex = hints.segmentMove.segmentStartIndex, newSegmentStartIndex = hints.segmentMove.newSegmentStartIndex;
        // if point was on moved segment return new segment index
        if (index === oldSegmentStartIndex) return newSegmentStartIndex;
        // point is after new segment index
        if (index >= newSegmentStartIndex) return index + offset < newSegmentStartIndex ? newSegmentStartIndex : index + offset;
        // if point is before new segment index
        return index;
    }
    // bendpointMove happened
    if (hints.bendpointMove) {
        var insert = hints.bendpointMove.insert, bendpointIndex = hints.bendpointMove.bendpointIndex, newIndex;
        // waypoints length didnt change
        if (offset === 0) return index;
        // point behind new/removed bendpoint
        if (index >= bendpointIndex) newIndex = insert ? index + 1 : index - 1;
        // point before new/removed bendpoint
        if (index < bendpointIndex) {
            newIndex = index;
            // decide point should take right or left segment
            if (insert && attachment.type !== 'bendpoint' && bendpointIndex - 1 === index) {
                var rel = relativePositionMidWaypoint(newWaypoints, bendpointIndex);
                if (rel < attachment.relativeLocation) newIndex++;
            }
        }
        return newIndex;
    }
    // start/end changed
    if (offset === 0) return index;
    if (hints.connectionStart && index === 0) return 0;
    if (hints.connectionEnd && index === oldWaypoints.length - 2) return newWaypoints.length - 2;
    // if nothing fits, take the middle segment
    return Math.floor((newWaypoints.length - 2) / 2);
}
function getAnchorPointAdjustment(position, newWaypoints, oldWaypoints, hints) {
    var dx = 0, dy = 0;
    var oldPosition = {
        point: position,
        delta: {
            x: 0,
            y: 0
        }
    };
    // get closest attachment
    var attachment = (0, _lineAttachmentUtil.getAttachment)(position, oldWaypoints), oldLabelLineIndex = attachment.segmentIndex, newLabelLineIndex = findNewLineStartIndex(oldWaypoints, newWaypoints, attachment, hints);
    // should never happen
    // TODO(@janstuemmel): throw an error here when connectionSegmentMove is refactored
    if (newLabelLineIndex < 0 || newLabelLineIndex > newWaypoints.length - 2 || newLabelLineIndex === null) return oldPosition;
    var oldLabelLine = getLine(oldWaypoints, oldLabelLineIndex), newLabelLine = getLine(newWaypoints, newLabelLineIndex), oldFoot = attachment.position;
    var relativeFootPosition = getRelativeFootPosition(oldLabelLine, oldFoot), angleDelta = getAngleDelta(oldLabelLine, newLabelLine);
    // special rule if label on bendpoint
    if (attachment.type === 'bendpoint') {
        var offset = newWaypoints.length - oldWaypoints.length, oldBendpointIndex = attachment.bendpointIndex, oldBendpoint = oldWaypoints[oldBendpointIndex];
        // bendpoint position hasn't changed, return same position
        if (newWaypoints.indexOf(oldBendpoint) !== -1) return oldPosition;
        // new bendpoint and old bendpoint have same index, then just return the offset
        if (offset === 0) {
            var newBendpoint = newWaypoints[oldBendpointIndex];
            dx = newBendpoint.x - attachment.position.x, dy = newBendpoint.y - attachment.position.y;
            return {
                delta: {
                    x: dx,
                    y: dy
                },
                point: {
                    x: position.x + dx,
                    y: position.y + dy
                }
            };
        }
        // if bendpoints get removed
        if (offset < 0 && oldBendpointIndex !== 0 && oldBendpointIndex < oldWaypoints.length - 1) relativeFootPosition = relativePositionMidWaypoint(oldWaypoints, oldBendpointIndex);
    }
    var newFoot = {
        x: (newLabelLine[1].x - newLabelLine[0].x) * relativeFootPosition + newLabelLine[0].x,
        y: (newLabelLine[1].y - newLabelLine[0].y) * relativeFootPosition + newLabelLine[0].y
    };
    // the rotated vector to label
    var newLabelVector = (0, _geometricUtil.rotateVector)({
        x: position.x - oldFoot.x,
        y: position.y - oldFoot.y
    }, angleDelta);
    // the new relative position
    dx = newFoot.x + newLabelVector.x - position.x;
    dy = newFoot.y + newLabelVector.y - position.y;
    return {
        point: (0, _layoutUtil.roundPoint)(newFoot),
        delta: (0, _layoutUtil.roundPoint)({
            x: dx,
            y: dy
        })
    };
}
// HELPERS //////////////////////
function relativePositionMidWaypoint(waypoints, idx) {
    var distanceSegment1 = (0, _geometricUtil.getDistancePointPoint)(waypoints[idx - 1], waypoints[idx]), distanceSegment2 = (0, _geometricUtil.getDistancePointPoint)(waypoints[idx], waypoints[idx + 1]);
    var relativePosition = distanceSegment1 / (distanceSegment1 + distanceSegment2);
    return relativePosition;
}
function getAngleDelta(l1, l2) {
    var a1 = (0, _geometricUtil.getAngle)(l1), a2 = (0, _geometricUtil.getAngle)(l2);
    return a2 - a1;
}
function getLine(waypoints, idx) {
    return [
        waypoints[idx],
        waypoints[idx + 1]
    ];
}
function getRelativeFootPosition(line, foot) {
    var length = (0, _geometricUtil.getDistancePointPoint)(line[0], line[1]), lengthToFoot = (0, _geometricUtil.getDistancePointPoint)(line[0], foot);
    return length === 0 ? 0 : lengthToFoot / length;
}

},{"./GeometricUtil":"39B1V","./LineAttachmentUtil":"lCMmX","diagram-js/lib/layout/LayoutUtil":"4CCrs","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lCMmX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Return the attachment of the given point on the specified line.
 *
 * The attachment is either a bendpoint (attached to the given point)
 * or segment (attached to a location on a line segment) attachment:
 *
 * ```javascript
 * var pointAttachment = {
 *   type: 'bendpoint',
 *   bendpointIndex: 3,
 *   position: { x: 10, y: 10 } // the attach point on the line
 * };
 *
 * var segmentAttachment = {
 *   type: 'segment',
 *   segmentIndex: 2,
 *   relativeLocation: 0.31, // attach point location between 0 (at start) and 1 (at end)
 *   position: { x: 10, y: 10 } // the attach point on the line
 * };
 * ```
 *
 * @param {Point} point
 * @param {Array<Point>} line
 *
 * @return {Object} attachment
 */ parcelHelpers.export(exports, "getAttachment", ()=>getAttachment);
var sqrt = Math.sqrt, min = Math.min, max = Math.max, abs = Math.abs;
/**
 * Calculate the square (power to two) of a number.
 *
 * @param {number} n
 *
 * @return {number}
 */ function sq(n) {
    return Math.pow(n, 2);
}
/**
 * Get distance between two points.
 *
 * @param {Point} p1
 * @param {Point} p2
 *
 * @return {number}
 */ function getDistance(p1, p2) {
    return sqrt(sq(p1.x - p2.x) + sq(p1.y - p2.y));
}
function getAttachment(point, line) {
    var idx = 0, segmentStart, segmentEnd, segmentStartDistance, segmentEndDistance, attachmentPosition, minDistance, intersections, attachment, attachmentDistance, closestAttachmentDistance, closestAttachment;
    for(idx = 0; idx < line.length - 1; idx++){
        segmentStart = line[idx];
        segmentEnd = line[idx + 1];
        if (pointsEqual(segmentStart, segmentEnd)) intersections = [
            segmentStart
        ];
        else {
            segmentStartDistance = getDistance(point, segmentStart);
            segmentEndDistance = getDistance(point, segmentEnd);
            minDistance = min(segmentStartDistance, segmentEndDistance);
            intersections = getCircleSegmentIntersections(segmentStart, segmentEnd, point, minDistance);
        }
        if (intersections.length < 1) throw new Error('expected between [1, 2] circle -> line intersections');
        // one intersection -> bendpoint attachment
        if (intersections.length === 1) attachment = {
            type: 'bendpoint',
            position: intersections[0],
            segmentIndex: idx,
            bendpointIndex: pointsEqual(segmentStart, intersections[0]) ? idx : idx + 1
        };
        // two intersections -> segment attachment
        if (intersections.length === 2) {
            attachmentPosition = mid(intersections[0], intersections[1]);
            attachment = {
                type: 'segment',
                position: attachmentPosition,
                segmentIndex: idx,
                relativeLocation: getDistance(segmentStart, attachmentPosition) / getDistance(segmentStart, segmentEnd)
            };
        }
        attachmentDistance = getDistance(attachment.position, point);
        if (!closestAttachment || closestAttachmentDistance > attachmentDistance) {
            closestAttachment = attachment;
            closestAttachmentDistance = attachmentDistance;
        }
    }
    return closestAttachment;
}
/**
 * Gets the intersection between a circle and a line segment.
 *
 * @param {Point} s1 segment start
 * @param {Point} s2 segment end
 * @param {Point} cc circle center
 * @param {number} cr circle radius
 *
 * @return {Array<Point>} intersections
 */ function getCircleSegmentIntersections(s1, s2, cc, cr) {
    var baX = s2.x - s1.x;
    var baY = s2.y - s1.y;
    var caX = cc.x - s1.x;
    var caY = cc.y - s1.y;
    var a = baX * baX + baY * baY;
    var bBy2 = baX * caX + baY * caY;
    var c = caX * caX + caY * caY - cr * cr;
    var pBy2 = bBy2 / a;
    var q = c / a;
    var disc = pBy2 * pBy2 - q;
    // check against negative value to work around
    // negative, very close to zero results (-4e-15)
    // being produced in some environments
    if (disc < 0 && disc > -0.000001) disc = 0;
    if (disc < 0) return [];
    // if disc == 0 ... dealt with later
    var tmpSqrt = sqrt(disc);
    var abScalingFactor1 = -pBy2 + tmpSqrt;
    var abScalingFactor2 = -pBy2 - tmpSqrt;
    var i1 = {
        x: s1.x - baX * abScalingFactor1,
        y: s1.y - baY * abScalingFactor1
    };
    if (disc === 0) return [
        i1
    ];
    var i2 = {
        x: s1.x - baX * abScalingFactor2,
        y: s1.y - baY * abScalingFactor2
    };
    // return only points on line segment
    return [
        i1,
        i2
    ].filter(function(p) {
        return isPointInSegment(p, s1, s2);
    });
}
function isPointInSegment(p, segmentStart, segmentEnd) {
    return fenced(p.x, segmentStart.x, segmentEnd.x) && fenced(p.y, segmentStart.y, segmentEnd.y);
}
function fenced(n, rangeStart, rangeEnd) {
    // use matching threshold to work around
    // precision errors in intersection computation
    return n >= min(rangeStart, rangeEnd) - EQUAL_THRESHOLD && n <= max(rangeStart, rangeEnd) + EQUAL_THRESHOLD;
}
/**
 * Calculate mid of two points.
 *
 * @param {Point} p1
 * @param {Point} p2
 *
 * @return {Point}
 */ function mid(p1, p2) {
    return {
        x: (p1.x + p2.x) / 2,
        y: (p1.y + p2.y) / 2
    };
}
var EQUAL_THRESHOLD = 0.1;
function pointsEqual(p1, p2) {
    return abs(p1.x - p2.x) <= EQUAL_THRESHOLD && abs(p1.y - p2.y) <= EQUAL_THRESHOLD;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"IwjBN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @typedef {import('../model').Shape} Shape
 *
 * @typedef {import('../util/Types').Point} Point
 * @typedef {import('../util/Types').Rect} Rect
 */ /**
 * Calculates the absolute point relative to the new element's position.
 *
 * @param {Point} point [absolute]
 * @param {Rect} oldBounds
 * @param {Rect} newBounds
 *
 * @return {Point} point [absolute]
 */ parcelHelpers.export(exports, "getNewAttachPoint", ()=>getNewAttachPoint);
/**
 * Calculates the shape's delta relative to a new position
 * of a certain element's bounds.
 *
 * @param {Shape} point [absolute]
 * @param {Rect} oldBounds
 * @param {Rect} newBounds
 *
 * @return {Point} delta
 */ parcelHelpers.export(exports, "getNewAttachShapeDelta", ()=>getNewAttachShapeDelta);
var _layoutUtil = require("../layout/LayoutUtil");
var _positionUtil = require("./PositionUtil");
function getNewAttachPoint(point, oldBounds, newBounds) {
    var oldCenter = (0, _positionUtil.center)(oldBounds), newCenter = (0, _positionUtil.center)(newBounds), oldDelta = (0, _positionUtil.delta)(point, oldCenter);
    var newDelta = {
        x: oldDelta.x * (newBounds.width / oldBounds.width),
        y: oldDelta.y * (newBounds.height / oldBounds.height)
    };
    return (0, _layoutUtil.roundPoint)({
        x: newCenter.x + newDelta.x,
        y: newCenter.y + newDelta.y
    });
}
function getNewAttachShapeDelta(shape, oldBounds, newBounds) {
    var shapeCenter = (0, _positionUtil.center)(shape), oldCenter = (0, _positionUtil.center)(oldBounds), newCenter = (0, _positionUtil.center)(newBounds), shapeDelta = (0, _positionUtil.delta)(shape, shapeCenter), oldCenterDelta = (0, _positionUtil.delta)(shapeCenter, oldCenter), stickyPositionDelta = getStickyPositionDelta(shapeCenter, oldBounds, newBounds);
    if (stickyPositionDelta) return stickyPositionDelta;
    var newCenterDelta = {
        x: oldCenterDelta.x * (newBounds.width / oldBounds.width),
        y: oldCenterDelta.y * (newBounds.height / oldBounds.height)
    };
    var newShapeCenter = {
        x: newCenter.x + newCenterDelta.x,
        y: newCenter.y + newCenterDelta.y
    };
    return (0, _layoutUtil.roundPoint)({
        x: newShapeCenter.x + shapeDelta.x - shape.x,
        y: newShapeCenter.y + shapeDelta.y - shape.y
    });
}
function getStickyPositionDelta(oldShapeCenter, oldBounds, newBounds) {
    var oldTRBL = (0, _layoutUtil.asTRBL)(oldBounds), newTRBL = (0, _layoutUtil.asTRBL)(newBounds);
    if (isMoved(oldTRBL, newTRBL)) return null;
    var oldOrientation = (0, _layoutUtil.getOrientation)(oldBounds, oldShapeCenter), stickyPositionDelta, newShapeCenter, newOrientation;
    if (oldOrientation === 'top') stickyPositionDelta = {
        x: 0,
        y: newTRBL.bottom - oldTRBL.bottom
    };
    else if (oldOrientation === 'bottom') stickyPositionDelta = {
        x: 0,
        y: newTRBL.top - oldTRBL.top
    };
    else if (oldOrientation === 'right') stickyPositionDelta = {
        x: newTRBL.left - oldTRBL.left,
        y: 0
    };
    else if (oldOrientation === 'left') stickyPositionDelta = {
        x: newTRBL.right - oldTRBL.right,
        y: 0
    };
    else // fallback to proportional movement for corner-placed attachments
    return null;
    newShapeCenter = {
        x: oldShapeCenter.x + stickyPositionDelta.x,
        y: oldShapeCenter.y + stickyPositionDelta.y
    };
    newOrientation = (0, _layoutUtil.getOrientation)(newBounds, newShapeCenter);
    if (newOrientation !== oldOrientation) // fallback to proportional movement if orientation would otherwise change
    return null;
    return stickyPositionDelta;
}
function isMoved(oldTRBL, newTRBL) {
    return isHorizontallyMoved(oldTRBL, newTRBL) || isVerticallyMoved(oldTRBL, newTRBL);
}
function isHorizontallyMoved(oldTRBL, newTRBL) {
    return oldTRBL.right !== newTRBL.right && oldTRBL.left !== newTRBL.left;
}
function isVerticallyMoved(oldTRBL, newTRBL) {
    return oldTRBL.top !== newTRBL.top && oldTRBL.bottom !== newTRBL.bottom;
}

},{"../layout/LayoutUtil":"4CCrs","./PositionUtil":"flrPc","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6FXCb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>LayoutConnectionBehavior);
var _minDash = require("min-dash");
var _inheritsBrowser = require("inherits-browser");
var _inheritsBrowserDefault = parcelHelpers.interopDefault(_inheritsBrowser);
var _commandInterceptor = require("diagram-js/lib/command/CommandInterceptor");
var _commandInterceptorDefault = parcelHelpers.interopDefault(_commandInterceptor);
var _connectionLayoutUtil = require("./util/ConnectionLayoutUtil");
function LayoutConnectionBehavior(eventBus, modeling) {
    (0, _commandInterceptorDefault.default).call(this, eventBus);
    function getnewAnchorPoint(event, point) {
        var context = event.context, connection = context.connection, hints = (0, _minDash.assign)({}, context.hints), newWaypoints = context.newWaypoints || connection.waypoints, oldWaypoints = context.oldWaypoints;
        if (typeof hints.startChanged === 'undefined') hints.startChanged = !!hints.connectionStart;
        if (typeof hints.endChanged === 'undefined') hints.endChanged = !!hints.connectionEnd;
        return (0, _connectionLayoutUtil.getConnectionAdjustment)(point, newWaypoints, oldWaypoints, hints);
    }
    this.postExecute([
        'connection.layout',
        'connection.updateWaypoints'
    ], function(event) {
        var context = event.context;
        var connection = context.connection, outgoing = connection.outgoing, incoming = connection.incoming;
        incoming.forEach(function(connection) {
            var endPoint = connection.waypoints[connection.waypoints.length - 1];
            var newEndpoint = getnewAnchorPoint(event, endPoint);
            var newWaypoints = [].concat(connection.waypoints.slice(0, -1), [
                newEndpoint
            ]);
            modeling.updateWaypoints(connection, newWaypoints);
        });
        outgoing.forEach(function(connection) {
            var startpoint = connection.waypoints[0];
            var newStartpoint = getnewAnchorPoint(event, startpoint);
            var newWaypoints = [].concat([
                newStartpoint
            ], connection.waypoints.slice(1));
            modeling.updateWaypoints(connection, newWaypoints);
        });
    });
    this.postExecute([
        'connection.move'
    ], function(event) {
        var context = event.context;
        var connection = context.connection, outgoing = connection.outgoing, incoming = connection.incoming, delta = context.delta;
        incoming.forEach(function(connection) {
            var endPoint = connection.waypoints[connection.waypoints.length - 1];
            var newEndpoint = {
                x: endPoint.x + delta.x,
                y: endPoint.y + delta.y
            };
            var newWaypoints = [].concat(connection.waypoints.slice(0, -1), [
                newEndpoint
            ]);
            modeling.updateWaypoints(connection, newWaypoints);
        });
        outgoing.forEach(function(connection) {
            var startpoint = connection.waypoints[0];
            var newStartpoint = {
                x: startpoint.x + delta.x,
                y: startpoint.y + delta.y
            };
            var newWaypoints = [].concat([
                newStartpoint
            ], connection.waypoints.slice(1));
            modeling.updateWaypoints(connection, newWaypoints);
        });
    });
}
(0, _inheritsBrowserDefault.default)(LayoutConnectionBehavior, (0, _commandInterceptorDefault.default));
LayoutConnectionBehavior.$inject = [
    'eventBus',
    'modeling'
];

},{"min-dash":"aEEla","inherits-browser":"hymxq","diagram-js/lib/command/CommandInterceptor":"1K1IQ","./util/ConnectionLayoutUtil":"kWOcX","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kWOcX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Calculate the new point after the connection waypoints got updated.
 *
 * @param {djs.model.Label} label
 * @param {Array<Point>} newWaypoints
 * @param {Array<Point>} oldWaypoints
 * @param {Object} hints
 *
 * @return {Point} point
 */ parcelHelpers.export(exports, "getConnectionAdjustment", ()=>getConnectionAdjustment);
var _layoutUtil = require("./LayoutUtil");
function getConnectionAdjustment(position, newWaypoints, oldWaypoints, hints) {
    return (0, _layoutUtil.getAnchorPointAdjustment)(position, newWaypoints, oldWaypoints, hints).point;
}

},{"./LayoutUtil":"2HDKR","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"16j3e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>MessageFlowBehavior);
var _inheritsBrowser = require("inherits-browser");
var _inheritsBrowserDefault = parcelHelpers.interopDefault(_inheritsBrowser);
var _commandInterceptor = require("diagram-js/lib/command/CommandInterceptor");
var _commandInterceptorDefault = parcelHelpers.interopDefault(_commandInterceptor);
var _modelUtil = require("../../../util/ModelUtil");
var _diUtil = require("../../../util/DiUtil");
var _elements = require("diagram-js/lib/util/Elements");
var _anchorsHelper = require("diagram-js/lib/features/modeling/cmd/helper/AnchorsHelper");
function MessageFlowBehavior(eventBus, modeling) {
    (0, _commandInterceptorDefault.default).call(this, eventBus);
    this.postExecute('shape.replace', function(context) {
        var oldShape = context.oldShape, newShape = context.newShape;
        if (!isParticipantCollapse(oldShape, newShape)) return;
        var messageFlows = getMessageFlows(oldShape);
        messageFlows.incoming.forEach(function(incoming) {
            var anchor = (0, _anchorsHelper.getResizedTargetAnchor)(incoming, newShape, oldShape);
            modeling.reconnectEnd(incoming, newShape, anchor);
        });
        messageFlows.outgoing.forEach(function(outgoing) {
            var anchor = (0, _anchorsHelper.getResizedSourceAnchor)(outgoing, newShape, oldShape);
            modeling.reconnectStart(outgoing, newShape, anchor);
        });
    }, true);
}
MessageFlowBehavior.$inject = [
    'eventBus',
    'modeling'
];
(0, _inheritsBrowserDefault.default)(MessageFlowBehavior, (0, _commandInterceptorDefault.default));
// helpers //////////
function isParticipantCollapse(oldShape, newShape) {
    return (0, _modelUtil.is)(oldShape, 'bpmn:Participant') && (0, _diUtil.isExpanded)(oldShape) && (0, _modelUtil.is)(newShape, 'bpmn:Participant') && !(0, _diUtil.isExpanded)(newShape);
}
function getMessageFlows(parent) {
    var elements = (0, _elements.selfAndAllChildren)([
        parent
    ], false);
    var incoming = [], outgoing = [];
    elements.forEach(function(element) {
        if (element === parent) return;
        element.incoming.forEach(function(connection) {
            if ((0, _modelUtil.is)(connection, 'bpmn:MessageFlow')) incoming.push(connection);
        });
        element.outgoing.forEach(function(connection) {
            if ((0, _modelUtil.is)(connection, 'bpmn:MessageFlow')) outgoing.push(connection);
        });
    }, []);
    return {
        incoming: incoming,
        outgoing: outgoing
    };
}

},{"inherits-browser":"hymxq","diagram-js/lib/command/CommandInterceptor":"1K1IQ","../../../util/ModelUtil":"klNYN","../../../util/DiUtil":"krDFz","diagram-js/lib/util/Elements":"6qdtl","diagram-js/lib/features/modeling/cmd/helper/AnchorsHelper":"1OucE","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1OucE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @typedef {import('../../../../model').Connection} Connection
 *
 * @typedef {import('../../../../util/Types').Point} Point
 * @typedef {import('../../../../util/Types').Rect} Rect
 */ parcelHelpers.export(exports, "getResizedSourceAnchor", ()=>getResizedSourceAnchor);
parcelHelpers.export(exports, "getResizedTargetAnchor", ()=>getResizedTargetAnchor);
parcelHelpers.export(exports, "getMovedSourceAnchor", ()=>getMovedSourceAnchor);
parcelHelpers.export(exports, "getMovedTargetAnchor", ()=>getMovedTargetAnchor);
var _attachUtil = require("../../../../util/AttachUtil");
var _layoutUtil = require("../../../../layout/LayoutUtil");
var _minDash = require("min-dash");
function getResizedSourceAnchor(connection, shape, oldBounds) {
    var waypoints = safeGetWaypoints(connection), waypointsInsideNewBounds = getWaypointsInsideBounds(waypoints, shape), oldAnchor = waypoints[0];
    // new anchor is the last waypoint enclosed be resized source
    if (waypointsInsideNewBounds.length) return waypointsInsideNewBounds[waypointsInsideNewBounds.length - 1];
    return (0, _attachUtil.getNewAttachPoint)(oldAnchor.original || oldAnchor, oldBounds, shape);
}
function getResizedTargetAnchor(connection, shape, oldBounds) {
    var waypoints = safeGetWaypoints(connection), waypointsInsideNewBounds = getWaypointsInsideBounds(waypoints, shape), oldAnchor = waypoints[waypoints.length - 1];
    // new anchor is the first waypoint enclosed be resized target
    if (waypointsInsideNewBounds.length) return waypointsInsideNewBounds[0];
    return (0, _attachUtil.getNewAttachPoint)(oldAnchor.original || oldAnchor, oldBounds, shape);
}
function getMovedSourceAnchor(connection, source, moveDelta) {
    var waypoints = safeGetWaypoints(connection), oldBounds = subtract(source, moveDelta), oldAnchor = waypoints[0];
    return (0, _attachUtil.getNewAttachPoint)(oldAnchor.original || oldAnchor, oldBounds, source);
}
function getMovedTargetAnchor(connection, target, moveDelta) {
    var waypoints = safeGetWaypoints(connection), oldBounds = subtract(target, moveDelta), oldAnchor = waypoints[waypoints.length - 1];
    return (0, _attachUtil.getNewAttachPoint)(oldAnchor.original || oldAnchor, oldBounds, target);
}
// helpers //////////////////////
function subtract(bounds, delta) {
    return {
        x: bounds.x - delta.x,
        y: bounds.y - delta.y,
        width: bounds.width,
        height: bounds.height
    };
}
/**
 * Return waypoints of given connection; throw if non exists (should not happen!!).
 *
 * @param {Connection} connection
 *
 * @return {Point[]}
 */ function safeGetWaypoints(connection) {
    var waypoints = connection.waypoints;
    if (!waypoints.length) throw new Error('connection#' + connection.id + ': no waypoints');
    return waypoints;
}
function getWaypointsInsideBounds(waypoints, bounds) {
    var originalWaypoints = (0, _minDash.map)(waypoints, getOriginal);
    return (0, _minDash.filter)(originalWaypoints, function(waypoint) {
        return isInsideBounds(waypoint, bounds);
    });
}
/**
 * Checks if point is inside bounds, incl. edges.
 *
 * @param {Point} point
 * @param {Rect} bounds
 */ function isInsideBounds(point, bounds) {
    return (0, _layoutUtil.getOrientation)(bounds, point, 1) === 'intersect';
}
function getOriginal(point) {
    return point.original || point;
}

},{"../../../../util/AttachUtil":"IwjBN","../../../../layout/LayoutUtil":"4CCrs","min-dash":"aEEla","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iZFKQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ModelingFeedback);
var _modelUtil = require("../../../util/ModelUtil");
var COLLAB_ERR_MSG = 'flow elements must be children of pools/participants';
function ModelingFeedback(eventBus, tooltips, translate) {
    function showError(position, message, timeout) {
        tooltips.add({
            position: {
                x: position.x + 5,
                y: position.y + 5
            },
            type: 'error',
            timeout: timeout || 2000,
            html: '<div>' + message + '</div>'
        });
    }
    eventBus.on([
        'shape.move.rejected',
        'create.rejected'
    ], function(event) {
        var context = event.context, shape = context.shape, target = context.target;
        if ((0, _modelUtil.is)(target, 'bpmn:Collaboration') && (0, _modelUtil.is)(shape, 'bpmn:FlowNode')) showError(event, translate(COLLAB_ERR_MSG));
    });
}
ModelingFeedback.$inject = [
    'eventBus',
    'tooltips',
    'translate'
];

},{"../../../util/ModelUtil":"klNYN","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"714X4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>RemoveEmbeddedLabelBoundsBehavior);
var _inheritsBrowser = require("inherits-browser");
var _inheritsBrowserDefault = parcelHelpers.interopDefault(_inheritsBrowser);
var _commandInterceptor = require("diagram-js/lib/command/CommandInterceptor");
var _commandInterceptorDefault = parcelHelpers.interopDefault(_commandInterceptor);
var _modelUtil = require("../../../util/ModelUtil");
function RemoveEmbeddedLabelBoundsBehavior(eventBus, modeling) {
    (0, _commandInterceptorDefault.default).call(this, eventBus);
    this.preExecute('shape.resize', function(context) {
        var shape = context.shape;
        var di = (0, _modelUtil.getDi)(shape), label = di && di.get('label'), bounds = label && label.get('bounds');
        if (bounds) modeling.updateModdleProperties(shape, label, {
            bounds: undefined
        });
    }, true);
}
(0, _inheritsBrowserDefault.default)(RemoveEmbeddedLabelBoundsBehavior, (0, _commandInterceptorDefault.default));
RemoveEmbeddedLabelBoundsBehavior.$inject = [
    'eventBus',
    'modeling'
];

},{"inherits-browser":"hymxq","diagram-js/lib/command/CommandInterceptor":"1K1IQ","../../../util/ModelUtil":"klNYN","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1UuSl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>RemoveElementBehavior);
var _inheritsBrowser = require("inherits-browser");
var _inheritsBrowserDefault = parcelHelpers.interopDefault(_inheritsBrowser);
var _modelUtil = require("../../../util/ModelUtil");
var _commandInterceptor = require("diagram-js/lib/command/CommandInterceptor");
var _commandInterceptorDefault = parcelHelpers.interopDefault(_commandInterceptor);
var _lineIntersect = require("./util/LineIntersect");
var _lineIntersectDefault = parcelHelpers.interopDefault(_lineIntersect);
function RemoveElementBehavior(eventBus, bpmnRules, modeling) {
    (0, _commandInterceptorDefault.default).call(this, eventBus);
    /**
   * Combine sequence flows when deleting an element
   * if there is one incoming and one outgoing
   * sequence flow
   */ this.preExecute('shape.delete', function(e) {
        var shape = e.context.shape;
        // only handle [a] -> [shape] -> [b] patterns
        if (shape.incoming.length !== 1 || shape.outgoing.length !== 1) return;
        var inConnection = shape.incoming[0], outConnection = shape.outgoing[0];
        // only handle sequence flows
        if (!(0, _modelUtil.is)(inConnection, 'bpmn:SequenceFlow') || !(0, _modelUtil.is)(outConnection, 'bpmn:SequenceFlow')) return;
        if (bpmnRules.canConnect(inConnection.source, outConnection.target, inConnection)) {
            // compute new, combined waypoints
            var newWaypoints = getNewWaypoints(inConnection.waypoints, outConnection.waypoints);
            modeling.reconnectEnd(inConnection, outConnection.target, newWaypoints);
        }
    });
}
(0, _inheritsBrowserDefault.default)(RemoveElementBehavior, (0, _commandInterceptorDefault.default));
RemoveElementBehavior.$inject = [
    'eventBus',
    'bpmnRules',
    'modeling'
];
// helpers //////////////////////
function getDocking(point) {
    return point.original || point;
}
function getNewWaypoints(inWaypoints, outWaypoints) {
    var intersection = (0, _lineIntersectDefault.default)(getDocking(inWaypoints[inWaypoints.length - 2]), getDocking(inWaypoints[inWaypoints.length - 1]), getDocking(outWaypoints[1]), getDocking(outWaypoints[0]));
    if (intersection) return [].concat(inWaypoints.slice(0, inWaypoints.length - 1), [
        intersection
    ], outWaypoints.slice(1));
    else return [
        getDocking(inWaypoints[0]),
        getDocking(outWaypoints[outWaypoints.length - 1])
    ];
}

},{"inherits-browser":"hymxq","../../../util/ModelUtil":"klNYN","diagram-js/lib/command/CommandInterceptor":"1K1IQ","./util/LineIntersect":"lQdNJ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gJmUP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>RemoveParticipantBehavior);
var _inheritsBrowser = require("inherits-browser");
var _inheritsBrowserDefault = parcelHelpers.interopDefault(_inheritsBrowser);
var _commandInterceptor = require("diagram-js/lib/command/CommandInterceptor");
var _commandInterceptorDefault = parcelHelpers.interopDefault(_commandInterceptor);
var _modelUtil = require("../../../util/ModelUtil");
function RemoveParticipantBehavior(eventBus, modeling) {
    (0, _commandInterceptorDefault.default).call(this, eventBus);
    /**
   * morph collaboration diagram into process diagram
   * after the last participant has been removed
   */ this.preExecute('shape.delete', function(context) {
        var shape = context.shape, parent = shape.parent;
        // activate the behavior if the shape to be removed
        // is a participant
        if ((0, _modelUtil.is)(shape, 'bpmn:Participant')) context.collaborationRoot = parent;
    }, true);
    this.postExecute('shape.delete', function(context) {
        var collaborationRoot = context.collaborationRoot;
        if (collaborationRoot && !collaborationRoot.businessObject.participants.length) // replace empty collaboration with process diagram
        modeling.makeProcess();
    }, true);
}
RemoveParticipantBehavior.$inject = [
    'eventBus',
    'modeling'
];
(0, _inheritsBrowserDefault.default)(RemoveParticipantBehavior, (0, _commandInterceptorDefault.default));

},{"inherits-browser":"hymxq","diagram-js/lib/command/CommandInterceptor":"1K1IQ","../../../util/ModelUtil":"klNYN","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"c6u0L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ReplaceConnectionBehavior);
var _minDash = require("min-dash");
var _inheritsBrowser = require("inherits-browser");
var _inheritsBrowserDefault = parcelHelpers.interopDefault(_inheritsBrowser);
var _commandInterceptor = require("diagram-js/lib/command/CommandInterceptor");
var _commandInterceptorDefault = parcelHelpers.interopDefault(_commandInterceptor);
var _modelUtil = require("../../../util/ModelUtil");
function ReplaceConnectionBehavior(eventBus, modeling, bpmnRules, injector) {
    (0, _commandInterceptorDefault.default).call(this, eventBus);
    var dragging = injector.get('dragging', false);
    function fixConnection(connection) {
        var source = connection.source, target = connection.target, parent = connection.parent;
        // do not do anything if connection
        // is already deleted (may happen due to other
        // behaviors plugged-in before)
        if (!parent) return;
        var replacementType, remove;
        /**
     * Check if incoming or outgoing connections
     * can stay or could be substituted with an
     * appropriate replacement.
     *
     * This holds true for SequenceFlow <> MessageFlow.
     */ if ((0, _modelUtil.is)(connection, 'bpmn:SequenceFlow')) {
            if (!bpmnRules.canConnectSequenceFlow(source, target)) remove = true;
            if (bpmnRules.canConnectMessageFlow(source, target)) replacementType = 'bpmn:MessageFlow';
        }
        // transform message flows into sequence flows, if possible
        if ((0, _modelUtil.is)(connection, 'bpmn:MessageFlow')) {
            if (!bpmnRules.canConnectMessageFlow(source, target)) remove = true;
            if (bpmnRules.canConnectSequenceFlow(source, target)) replacementType = 'bpmn:SequenceFlow';
        }
        if ((0, _modelUtil.is)(connection, 'bpmn:Association') && !bpmnRules.canConnectAssociation(source, target)) remove = true;
        // remove invalid connection,
        // unless it has been removed already
        if (remove) modeling.removeConnection(connection);
        // replace SequenceFlow <> MessageFlow
        if (replacementType) modeling.connect(source, target, {
            type: replacementType,
            waypoints: connection.waypoints.slice()
        });
    }
    function replaceReconnectedConnection(event) {
        var context = event.context, connection = context.connection, source = context.newSource || connection.source, target = context.newTarget || connection.target, allowed, replacement;
        allowed = bpmnRules.canConnect(source, target);
        if (!allowed || allowed.type === connection.type) return;
        replacement = modeling.connect(source, target, {
            type: allowed.type,
            waypoints: connection.waypoints.slice()
        });
        // remove old connection
        modeling.removeConnection(connection);
        // replace connection in context to reconnect end/start
        context.connection = replacement;
        if (dragging) cleanDraggingSelection(connection, replacement);
    }
    // monkey-patch selection saved in dragging in order to re-select it when operation is finished
    function cleanDraggingSelection(oldConnection, newConnection) {
        var context = dragging.context(), previousSelection = context && context.payload.previousSelection, index;
        // do nothing if not dragging or no selection was present
        if (!previousSelection || !previousSelection.length) return;
        index = previousSelection.indexOf(oldConnection);
        if (index === -1) return;
        previousSelection.splice(index, 1, newConnection);
    }
    // lifecycle hooks
    this.postExecuted('elements.move', function(context) {
        var closure = context.closure, allConnections = closure.allConnections;
        (0, _minDash.forEach)(allConnections, fixConnection);
    }, true);
    this.preExecute('connection.reconnect', replaceReconnectedConnection);
    this.postExecuted('element.updateProperties', function(event) {
        var context = event.context, properties = context.properties, element = context.element, businessObject = element.businessObject, connection;
        // remove condition on change to default
        if (properties.default) {
            connection = (0, _minDash.find)(element.outgoing, (0, _minDash.matchPattern)({
                id: element.businessObject.default.id
            }));
            if (connection) modeling.updateProperties(connection, {
                conditionExpression: undefined
            });
        }
        // remove default from source on change to conditional
        if (properties.conditionExpression && businessObject.sourceRef.default === businessObject) modeling.updateProperties(element.source, {
            default: undefined
        });
    });
}
(0, _inheritsBrowserDefault.default)(ReplaceConnectionBehavior, (0, _commandInterceptorDefault.default));
ReplaceConnectionBehavior.$inject = [
    'eventBus',
    'modeling',
    'bpmnRules',
    'injector'
];

},{"min-dash":"aEEla","inherits-browser":"hymxq","diagram-js/lib/command/CommandInterceptor":"1K1IQ","../../../util/ModelUtil":"klNYN","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7XdSJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ReplaceElementBehaviour);
var _inheritsBrowser = require("inherits-browser");
var _inheritsBrowserDefault = parcelHelpers.interopDefault(_inheritsBrowser);
var _minDash = require("min-dash");
var _commandInterceptor = require("diagram-js/lib/command/CommandInterceptor");
var _commandInterceptorDefault = parcelHelpers.interopDefault(_commandInterceptor);
var _diUtil = require("../../../util/DiUtil");
function ReplaceElementBehaviour(bpmnReplace, bpmnRules, elementRegistry, injector, modeling, selection) {
    injector.invoke((0, _commandInterceptorDefault.default), this);
    this._bpmnReplace = bpmnReplace;
    this._elementRegistry = elementRegistry;
    this._selection = selection;
    // replace elements on create, e.g. during copy-paste
    this.postExecuted([
        'elements.create'
    ], 500, function(event) {
        var context = event.context, target = context.parent, elements = context.elements;
        var elementReplacements = (0, _minDash.reduce)(elements, function(replacements, element) {
            var canReplace = bpmnRules.canReplace([
                element
            ], element.host || element.parent || target);
            return canReplace ? replacements.concat(canReplace.replacements) : replacements;
        }, []);
        if (elementReplacements.length) this.replaceElements(elements, elementReplacements);
    }, this);
    // replace elements on move
    this.postExecuted([
        'elements.move'
    ], 500, function(event) {
        var context = event.context, target = context.newParent, newHost = context.newHost, elements = [];
        (0, _minDash.forEach)(context.closure.topLevel, function(topLevelElements) {
            if ((0, _diUtil.isEventSubProcess)(topLevelElements)) elements = elements.concat(topLevelElements.children);
            else elements = elements.concat(topLevelElements);
        });
        // set target to host if attaching
        if (elements.length === 1 && newHost) target = newHost;
        var canReplace = bpmnRules.canReplace(elements, target);
        if (canReplace) this.replaceElements(elements, canReplace.replacements, newHost);
    }, this);
    // update attachments on host replace
    this.postExecute([
        'shape.replace'
    ], 1500, function(e) {
        var context = e.context, oldShape = context.oldShape, newShape = context.newShape, attachers = oldShape.attachers, canReplace;
        if (attachers && attachers.length) {
            canReplace = bpmnRules.canReplace(attachers, newShape);
            this.replaceElements(attachers, canReplace.replacements);
        }
    }, this);
    // keep ID on shape replace
    this.postExecuted([
        'shape.replace'
    ], 1500, function(e) {
        var context = e.context, oldShape = context.oldShape, newShape = context.newShape;
        modeling.unclaimId(oldShape.businessObject.id, oldShape.businessObject);
        modeling.updateProperties(newShape, {
            id: oldShape.id
        });
    });
}
(0, _inheritsBrowserDefault.default)(ReplaceElementBehaviour, (0, _commandInterceptorDefault.default));
ReplaceElementBehaviour.prototype.replaceElements = function(elements, newElements) {
    var elementRegistry = this._elementRegistry, bpmnReplace = this._bpmnReplace, selection = this._selection;
    (0, _minDash.forEach)(newElements, function(replacement) {
        var newElement = {
            type: replacement.newElementType
        };
        var oldElement = elementRegistry.get(replacement.oldElementId);
        var idx = elements.indexOf(oldElement);
        elements[idx] = bpmnReplace.replaceElement(oldElement, newElement, {
            select: false
        });
    });
    if (newElements) selection.select(elements);
};
ReplaceElementBehaviour.$inject = [
    'bpmnReplace',
    'bpmnRules',
    'elementRegistry',
    'injector',
    'modeling',
    'selection'
];

},{"inherits-browser":"hymxq","min-dash":"aEEla","diagram-js/lib/command/CommandInterceptor":"1K1IQ","../../../util/DiUtil":"krDFz","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7Xl4y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GROUP_MIN_DIMENSIONS", ()=>GROUP_MIN_DIMENSIONS);
parcelHelpers.export(exports, "LANE_MIN_DIMENSIONS", ()=>LANE_MIN_DIMENSIONS);
parcelHelpers.export(exports, "PARTICIPANT_MIN_DIMENSIONS", ()=>PARTICIPANT_MIN_DIMENSIONS);
parcelHelpers.export(exports, "SUB_PROCESS_MIN_DIMENSIONS", ()=>SUB_PROCESS_MIN_DIMENSIONS);
parcelHelpers.export(exports, "TEXT_ANNOTATION_MIN_DIMENSIONS", ()=>TEXT_ANNOTATION_MIN_DIMENSIONS);
parcelHelpers.export(exports, "default", ()=>ResizeBehavior);
parcelHelpers.export(exports, "getParticipantResizeConstraints", ()=>getParticipantResizeConstraints);
var _modelUtil = require("../../../util/ModelUtil");
var _diUtil = require("../../../util/DiUtil");
var _layoutUtil = require("diagram-js/lib/layout/LayoutUtil");
var _laneUtil = require("../util/LaneUtil");
var HIGH_PRIORITY = 1500;
var GROUP_MIN_DIMENSIONS = {
    width: 140,
    height: 120
};
var LANE_MIN_DIMENSIONS = {
    width: 300,
    height: 60
};
var PARTICIPANT_MIN_DIMENSIONS = {
    width: 300,
    height: 150
};
var SUB_PROCESS_MIN_DIMENSIONS = {
    width: 140,
    height: 120
};
var TEXT_ANNOTATION_MIN_DIMENSIONS = {
    width: 50,
    height: 30
};
function ResizeBehavior(eventBus) {
    eventBus.on('resize.start', HIGH_PRIORITY, function(event) {
        var context = event.context, shape = context.shape, direction = context.direction, balanced = context.balanced;
        if ((0, _modelUtil.is)(shape, 'bpmn:Lane') || (0, _modelUtil.is)(shape, 'bpmn:Participant')) context.resizeConstraints = getParticipantResizeConstraints(shape, direction, balanced);
        if ((0, _modelUtil.is)(shape, 'bpmn:Participant')) context.minDimensions = PARTICIPANT_MIN_DIMENSIONS;
        if ((0, _modelUtil.is)(shape, 'bpmn:SubProcess') && (0, _diUtil.isExpanded)(shape)) context.minDimensions = SUB_PROCESS_MIN_DIMENSIONS;
        if ((0, _modelUtil.is)(shape, 'bpmn:TextAnnotation')) context.minDimensions = TEXT_ANNOTATION_MIN_DIMENSIONS;
    });
}
ResizeBehavior.$inject = [
    'eventBus'
];
var abs = Math.abs, min = Math.min, max = Math.max;
function addToTrbl(trbl, attr, value, choice) {
    var current = trbl[attr];
    // make sure to set the value if it does not exist
    // or apply the correct value by comparing against
    // choice(value, currentValue)
    trbl[attr] = current === undefined ? value : choice(value, current);
}
function addMin(trbl, attr, value) {
    return addToTrbl(trbl, attr, value, min);
}
function addMax(trbl, attr, value) {
    return addToTrbl(trbl, attr, value, max);
}
var LANE_RIGHT_PADDING = 20, LANE_LEFT_PADDING = 50, LANE_TOP_PADDING = 20, LANE_BOTTOM_PADDING = 20;
function getParticipantResizeConstraints(laneShape, resizeDirection, balanced) {
    var lanesRoot = (0, _laneUtil.getLanesRoot)(laneShape);
    var isFirst = true, isLast = true;
    // max top/bottom size for lanes
    var allLanes = (0, _laneUtil.collectLanes)(lanesRoot, [
        lanesRoot
    ]);
    var laneTrbl = (0, _layoutUtil.asTRBL)(laneShape);
    var maxTrbl = {}, minTrbl = {};
    if (/e/.test(resizeDirection)) minTrbl.right = laneTrbl.left + LANE_MIN_DIMENSIONS.width;
    else if (/w/.test(resizeDirection)) minTrbl.left = laneTrbl.right - LANE_MIN_DIMENSIONS.width;
    allLanes.forEach(function(other) {
        var otherTrbl = (0, _layoutUtil.asTRBL)(other);
        if (/n/.test(resizeDirection)) {
            if (otherTrbl.top < laneTrbl.top - 10) isFirst = false;
            // max top size (based on next element)
            if (balanced && abs(laneTrbl.top - otherTrbl.bottom) < 10) addMax(maxTrbl, 'top', otherTrbl.top + LANE_MIN_DIMENSIONS.height);
            // min top size (based on self or nested element)
            if (abs(laneTrbl.top - otherTrbl.top) < 5) addMin(minTrbl, 'top', otherTrbl.bottom - LANE_MIN_DIMENSIONS.height);
        }
        if (/s/.test(resizeDirection)) {
            if (otherTrbl.bottom > laneTrbl.bottom + 10) isLast = false;
            // max bottom size (based on previous element)
            if (balanced && abs(laneTrbl.bottom - otherTrbl.top) < 10) addMin(maxTrbl, 'bottom', otherTrbl.bottom - LANE_MIN_DIMENSIONS.height);
            // min bottom size (based on self or nested element)
            if (abs(laneTrbl.bottom - otherTrbl.bottom) < 5) addMax(minTrbl, 'bottom', otherTrbl.top + LANE_MIN_DIMENSIONS.height);
        }
    });
    // max top/bottom/left/right size based on flow nodes
    var flowElements = lanesRoot.children.filter(function(s) {
        return !s.hidden && !s.waypoints && ((0, _modelUtil.is)(s, 'bpmn:FlowElement') || (0, _modelUtil.is)(s, 'bpmn:Artifact'));
    });
    flowElements.forEach(function(flowElement) {
        var flowElementTrbl = (0, _layoutUtil.asTRBL)(flowElement);
        if (isFirst && /n/.test(resizeDirection)) addMin(minTrbl, 'top', flowElementTrbl.top - LANE_TOP_PADDING);
        if (/e/.test(resizeDirection)) addMax(minTrbl, 'right', flowElementTrbl.right + LANE_RIGHT_PADDING);
        if (isLast && /s/.test(resizeDirection)) addMax(minTrbl, 'bottom', flowElementTrbl.bottom + LANE_BOTTOM_PADDING);
        if (/w/.test(resizeDirection)) addMin(minTrbl, 'left', flowElementTrbl.left - LANE_LEFT_PADDING);
    });
    return {
        min: minTrbl,
        max: maxTrbl
    };
}

},{"../../../util/ModelUtil":"klNYN","../../../util/DiUtil":"krDFz","diagram-js/lib/layout/LayoutUtil":"4CCrs","../util/LaneUtil":"fECqQ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gZKqu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ResizeLaneBehavior);
var _modelUtil = require("../../../util/ModelUtil");
var _layoutUtil = require("diagram-js/lib/layout/LayoutUtil");
var _mouse = require("diagram-js/lib/util/Mouse");
var SLIGHTLY_HIGHER_PRIORITY = 1001;
function ResizeLaneBehavior(eventBus, modeling) {
    eventBus.on('resize.start', SLIGHTLY_HIGHER_PRIORITY + 500, function(event) {
        var context = event.context, shape = context.shape;
        if ((0, _modelUtil.is)(shape, 'bpmn:Lane') || (0, _modelUtil.is)(shape, 'bpmn:Participant')) // should we resize the opposite lane(s) in
        // order to compensate for the resize operation?
        context.balanced = !(0, _mouse.hasPrimaryModifier)(event);
    });
    /**
   * Intercept resize end and call resize lane function instead.
   */ eventBus.on('resize.end', SLIGHTLY_HIGHER_PRIORITY, function(event) {
        var context = event.context, shape = context.shape, canExecute = context.canExecute, newBounds = context.newBounds;
        if ((0, _modelUtil.is)(shape, 'bpmn:Lane') || (0, _modelUtil.is)(shape, 'bpmn:Participant')) {
            if (canExecute) {
                // ensure we have actual pixel values for new bounds
                // (important when zoom level was > 1 during move)
                newBounds = (0, _layoutUtil.roundBounds)(newBounds);
                // perform the actual resize
                modeling.resizeLane(shape, newBounds, context.balanced);
            }
            // stop propagation
            return false;
        }
    });
}
ResizeLaneBehavior.$inject = [
    'eventBus',
    'modeling'
];

},{"../../../util/ModelUtil":"klNYN","diagram-js/lib/layout/LayoutUtil":"4CCrs","diagram-js/lib/util/Mouse":"9MyMy","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dguTE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>RootElementReferenceBehavior);
var _inheritsBrowser = require("inherits-browser");
var _inheritsBrowserDefault = parcelHelpers.interopDefault(_inheritsBrowser);
var _minDash = require("min-dash");
var _commandInterceptor = require("diagram-js/lib/command/CommandInterceptor");
var _commandInterceptorDefault = parcelHelpers.interopDefault(_commandInterceptor);
var _collections = require("diagram-js/lib/util/Collections");
var _modelUtil = require("../../../util/ModelUtil");
var _modelingUtil = require("../util/ModelingUtil");
var _diUtil = require("../../../util/DiUtil");
var LOW_PRIORITY = 500;
function RootElementReferenceBehavior(bpmnjs, eventBus, injector, moddleCopy, bpmnFactory) {
    injector.invoke((0, _commandInterceptorDefault.default), this);
    function canHaveRootElementReference(element) {
        return (0, _modelingUtil.isAny)(element, [
            'bpmn:ReceiveTask',
            'bpmn:SendTask'
        ]) || hasAnyEventDefinition(element, [
            'bpmn:ErrorEventDefinition',
            'bpmn:EscalationEventDefinition',
            'bpmn:MessageEventDefinition',
            'bpmn:SignalEventDefinition'
        ]);
    }
    function hasRootElement(rootElement) {
        var definitions = bpmnjs.getDefinitions(), rootElements = definitions.get('rootElements');
        return !!(0, _minDash.find)(rootElements, (0, _minDash.matchPattern)({
            id: rootElement.id
        }));
    }
    function getRootElementReferencePropertyName(eventDefinition) {
        if ((0, _modelUtil.is)(eventDefinition, 'bpmn:ErrorEventDefinition')) return 'errorRef';
        else if ((0, _modelUtil.is)(eventDefinition, 'bpmn:EscalationEventDefinition')) return 'escalationRef';
        else if ((0, _modelUtil.is)(eventDefinition, 'bpmn:MessageEventDefinition')) return 'messageRef';
        else if ((0, _modelUtil.is)(eventDefinition, 'bpmn:SignalEventDefinition')) return 'signalRef';
    }
    function getRootElement(businessObject) {
        if ((0, _modelingUtil.isAny)(businessObject, [
            'bpmn:ReceiveTask',
            'bpmn:SendTask'
        ])) return businessObject.get('messageRef');
        var eventDefinitions = businessObject.get('eventDefinitions'), eventDefinition = eventDefinitions[0];
        return eventDefinition.get(getRootElementReferencePropertyName(eventDefinition));
    }
    function setRootElement(businessObject, rootElement) {
        if ((0, _modelingUtil.isAny)(businessObject, [
            'bpmn:ReceiveTask',
            'bpmn:SendTask'
        ])) return businessObject.set('messageRef', rootElement);
        var eventDefinitions = businessObject.get('eventDefinitions'), eventDefinition = eventDefinitions[0];
        return eventDefinition.set(getRootElementReferencePropertyName(eventDefinition), rootElement);
    }
    // create shape
    this.executed([
        'shape.create',
        'element.updateProperties',
        'element.updateModdleProperties'
    ], function(context) {
        var shape = context.shape || context.element;
        if (!canHaveRootElementReference(shape)) return;
        var businessObject = (0, _modelUtil.getBusinessObject)(shape), rootElement = getRootElement(businessObject), rootElements;
        if (rootElement && !hasRootElement(rootElement)) {
            rootElements = bpmnjs.getDefinitions().get('rootElements');
            // add root element
            (0, _collections.add)(rootElements, rootElement);
            context.addedRootElement = rootElement;
        }
    }, true);
    this.reverted([
        'shape.create',
        'element.updateProperties',
        'element.updateModdleProperties'
    ], function(context) {
        var addedRootElement = context.addedRootElement;
        if (!addedRootElement) return;
        var rootElements = bpmnjs.getDefinitions().get('rootElements');
        // remove root element
        (0, _collections.remove)(rootElements, addedRootElement);
    }, true);
    eventBus.on('copyPaste.copyElement', function(context) {
        var descriptor = context.descriptor, element = context.element;
        if (element.labelTarget || !canHaveRootElementReference(element)) return;
        var businessObject = (0, _modelUtil.getBusinessObject)(element), rootElement = getRootElement(businessObject);
        if (rootElement) // TODO(nikku): clone on copy
        descriptor.referencedRootElement = rootElement;
    });
    eventBus.on('copyPaste.pasteElement', LOW_PRIORITY, function(context) {
        var descriptor = context.descriptor, businessObject = descriptor.businessObject, referencedRootElement = descriptor.referencedRootElement;
        if (!referencedRootElement) return;
        if (!hasRootElement(referencedRootElement)) referencedRootElement = moddleCopy.copyElement(referencedRootElement, bpmnFactory.create(referencedRootElement.$type));
        setRootElement(businessObject, referencedRootElement);
        delete descriptor.referencedRootElement;
    });
}
RootElementReferenceBehavior.$inject = [
    'bpmnjs',
    'eventBus',
    'injector',
    'moddleCopy',
    'bpmnFactory'
];
(0, _inheritsBrowserDefault.default)(RootElementReferenceBehavior, (0, _commandInterceptorDefault.default));
// helpers //////////
function hasAnyEventDefinition(element, types) {
    if (!(0, _minDash.isArray)(types)) types = [
        types
    ];
    return (0, _minDash.some)(types, function(type) {
        return (0, _diUtil.hasEventDefinition)(element, type);
    });
}

},{"inherits-browser":"hymxq","min-dash":"aEEla","diagram-js/lib/command/CommandInterceptor":"1K1IQ","diagram-js/lib/util/Collections":"kRUAD","../../../util/ModelUtil":"klNYN","../util/ModelingUtil":"4DR1e","../../../util/DiUtil":"krDFz","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gAEJQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SpaceToolBehavior);
var _minDash = require("min-dash");
var _modelUtil = require("../../../util/ModelUtil");
var _diUtil = require("../../../util/DiUtil");
var _resizeBehavior = require("./ResizeBehavior");
var _laneUtil = require("../util/LaneUtil");
var max = Math.max;
function SpaceToolBehavior(eventBus) {
    eventBus.on('spaceTool.getMinDimensions', function(context) {
        var shapes = context.shapes, axis = context.axis, start = context.start, minDimensions = {};
        (0, _minDash.forEach)(shapes, function(shape) {
            var id = shape.id;
            if ((0, _modelUtil.is)(shape, 'bpmn:Participant')) {
                if (isHorizontal(axis)) minDimensions[id] = (0, _resizeBehavior.PARTICIPANT_MIN_DIMENSIONS);
                else minDimensions[id] = {
                    width: (0, _resizeBehavior.PARTICIPANT_MIN_DIMENSIONS).width,
                    height: getParticipantMinHeight(shape, start)
                };
            }
            if ((0, _modelUtil.is)(shape, 'bpmn:SubProcess') && (0, _diUtil.isExpanded)(shape)) minDimensions[id] = (0, _resizeBehavior.SUB_PROCESS_MIN_DIMENSIONS);
            if ((0, _modelUtil.is)(shape, 'bpmn:TextAnnotation')) minDimensions[id] = (0, _resizeBehavior.TEXT_ANNOTATION_MIN_DIMENSIONS);
            if ((0, _modelUtil.is)(shape, 'bpmn:Group')) minDimensions[id] = (0, _resizeBehavior.GROUP_MIN_DIMENSIONS);
        });
        return minDimensions;
    });
}
SpaceToolBehavior.$inject = [
    'eventBus'
];
// helpers //////////
function isHorizontal(axis) {
    return axis === 'x';
}
/**
 * Get minimum height for participant taking lanes into account.
 *
 * @param {<djs.model.Shape>} participant
 * @param {number} start
 *
 * @returns {Object}
 */ function getParticipantMinHeight(participant, start) {
    var lanesMinHeight;
    if (!hasChildLanes(participant)) return (0, _resizeBehavior.PARTICIPANT_MIN_DIMENSIONS).height;
    lanesMinHeight = getLanesMinHeight(participant, start);
    return max((0, _resizeBehavior.PARTICIPANT_MIN_DIMENSIONS).height, lanesMinHeight);
}
function hasChildLanes(element) {
    return !!(0, _laneUtil.getChildLanes)(element).length;
}
function getLanesMinHeight(participant, resizeStart) {
    var lanes = (0, _laneUtil.getChildLanes)(participant), resizedLane;
    // find the nested lane which is currently resized
    resizedLane = findResizedLane(lanes, resizeStart);
    // resized lane cannot shrink below the minimum height
    // but remaining lanes' dimensions are kept intact
    return participant.height - resizedLane.height + (0, _resizeBehavior.LANE_MIN_DIMENSIONS).height;
}
/**
 * Find nested lane which is currently resized.
 *
 * @param {Array<djs.model.Shape>} lanes
 * @param {number} resizeStart
 */ function findResizedLane(lanes, resizeStart) {
    var i, lane, childLanes;
    for(i = 0; i < lanes.length; i++){
        lane = lanes[i];
        // resizing current lane or a lane nested
        if (resizeStart >= lane.y && resizeStart <= lane.y + lane.height) {
            childLanes = (0, _laneUtil.getChildLanes)(lane);
            // a nested lane is resized
            if (childLanes.length) return findResizedLane(childLanes, resizeStart);
            // current lane is the resized one
            return lane;
        }
    }
}

},{"min-dash":"aEEla","../../../util/ModelUtil":"klNYN","../../../util/DiUtil":"krDFz","./ResizeBehavior":"7Xl4y","../util/LaneUtil":"fECqQ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1W8ek":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SubProcessPlaneBehavior);
var _inheritsBrowser = require("inherits-browser");
var _inheritsBrowserDefault = parcelHelpers.interopDefault(_inheritsBrowser);
var _commandInterceptor = require("diagram-js/lib/command/CommandInterceptor");
var _commandInterceptorDefault = parcelHelpers.interopDefault(_commandInterceptor);
var _minDash = require("min-dash");
var _diUtil = require("../../../util/DiUtil");
var _modelUtil = require("../../../util/ModelUtil");
var _layoutUtil = require("diagram-js/lib/layout/LayoutUtil");
var _elements = require("diagram-js/lib/util/Elements");
var _drilldownUtil = require("../../../util/DrilldownUtil");
var LOW_PRIORITY = 400;
var HIGH_PRIORITY = 600;
var DEFAULT_POSITION = {
    x: 180,
    y: 160
};
function SubProcessPlaneBehavior(canvas, eventBus, modeling, elementFactory, bpmnFactory, bpmnjs, elementRegistry) {
    (0, _commandInterceptorDefault.default).call(this, eventBus);
    this._canvas = canvas;
    this._eventBus = eventBus;
    this._modeling = modeling;
    this._elementFactory = elementFactory;
    this._bpmnFactory = bpmnFactory;
    this._bpmnjs = bpmnjs;
    this._elementRegistry = elementRegistry;
    var self = this;
    function isCollapsedSubProcess(element) {
        return (0, _modelUtil.is)(element, 'bpmn:SubProcess') && !(0, _diUtil.isExpanded)(element);
    }
    function createRoot(context) {
        var shape = context.shape, rootElement = context.newRootElement;
        var businessObject = (0, _modelUtil.getBusinessObject)(shape);
        rootElement = self._addDiagram(rootElement || businessObject);
        context.newRootElement = canvas.addRootElement(rootElement);
    }
    function removeRoot(context) {
        var shape = context.shape;
        var businessObject = (0, _modelUtil.getBusinessObject)(shape);
        self._removeDiagram(businessObject);
        var rootElement = context.newRootElement = elementRegistry.get((0, _drilldownUtil.getPlaneIdFromShape)(businessObject));
        canvas.removeRootElement(rootElement);
    }
    // add plane elements for newly created sub-processes
    // this ensures we can actually drill down into the element
    this.executed('shape.create', function(context) {
        var shape = context.shape;
        if (!isCollapsedSubProcess(shape)) return;
        createRoot(context);
    }, true);
    this.postExecuted('shape.create', function(context) {
        var shape = context.shape, rootElement = context.newRootElement;
        if (!rootElement || !shape.children) return;
        self._showRecursively(shape.children);
        self._moveChildrenToShape(shape, rootElement);
    }, true);
    this.reverted('shape.create', function(context) {
        var shape = context.shape;
        if (!isCollapsedSubProcess(shape)) return;
        removeRoot(context);
    }, true);
    this.preExecuted('shape.delete', function(context) {
        var shape = context.shape;
        if (!isCollapsedSubProcess(shape)) return;
        var attachedRoot = elementRegistry.get((0, _drilldownUtil.getPlaneIdFromShape)(shape));
        if (!attachedRoot) return;
        modeling.removeElements(attachedRoot.children.slice());
    }, true);
    this.executed('shape.delete', function(context) {
        var shape = context.shape;
        if (!isCollapsedSubProcess(shape)) return;
        removeRoot(context);
    }, true);
    this.reverted('shape.delete', function(context) {
        var shape = context.shape;
        if (!isCollapsedSubProcess(shape)) return;
        createRoot(context);
    }, true);
    this.preExecuted('shape.replace', function(context) {
        var oldShape = context.oldShape;
        var newShape = context.newShape;
        if (!isCollapsedSubProcess(oldShape) || !isCollapsedSubProcess(newShape)) return;
        // old plane could have content,
        // we remove it so it is not recursively deleted from 'shape.delete'
        context.oldRoot = canvas.removeRootElement((0, _drilldownUtil.getPlaneIdFromShape)(oldShape));
    }, true);
    this.postExecuted('shape.replace', function(context) {
        var newShape = context.newShape, source = context.oldRoot, target = canvas.findRoot((0, _drilldownUtil.getPlaneIdFromShape)(newShape));
        if (!source || !target) return;
        var elements = source.children;
        modeling.moveElements(elements, {
            x: 0,
            y: 0
        }, target);
    }, true);
    // rename primary elements when the secondary element changes
    // this ensures rootElement.id = element.id + '_plane'
    this.executed('element.updateProperties', function(context) {
        var shape = context.element;
        if (!(0, _modelUtil.is)(shape, 'bpmn:SubProcess')) return;
        var properties = context.properties;
        var oldProperties = context.oldProperties;
        var oldId = oldProperties.id, newId = properties.id;
        if (oldId === newId) return;
        if ((0, _drilldownUtil.isPlane)(shape)) {
            elementRegistry.updateId(shape, (0, _drilldownUtil.toPlaneId)(newId));
            elementRegistry.updateId(oldId, newId);
            return;
        }
        var planeElement = elementRegistry.get((0, _drilldownUtil.toPlaneId)(oldId));
        if (!planeElement) return;
        elementRegistry.updateId((0, _drilldownUtil.toPlaneId)(oldId), (0, _drilldownUtil.toPlaneId)(newId));
    }, true);
    this.reverted('element.updateProperties', function(context) {
        var shape = context.element;
        if (!(0, _modelUtil.is)(shape, 'bpmn:SubProcess')) return;
        var properties = context.properties;
        var oldProperties = context.oldProperties;
        var oldId = oldProperties.id, newId = properties.id;
        if (oldId === newId) return;
        if ((0, _drilldownUtil.isPlane)(shape)) {
            elementRegistry.updateId(shape, (0, _drilldownUtil.toPlaneId)(oldId));
            elementRegistry.updateId(newId, oldId);
            return;
        }
        var planeElement = elementRegistry.get((0, _drilldownUtil.toPlaneId)(newId));
        if (!planeElement) return;
        elementRegistry.updateId(planeElement, (0, _drilldownUtil.toPlaneId)(oldId));
    }, true);
    // re-throw element.changed to re-render primary shape if associated plane has
    // changed (e.g. bpmn:name property has changed)
    eventBus.on('element.changed', function(context) {
        var element = context.element;
        if (!(0, _drilldownUtil.isPlane)(element)) return;
        var plane = element;
        var primaryShape = elementRegistry.get((0, _drilldownUtil.getShapeIdFromPlane)(plane));
        // do not re-throw if no associated primary shape (e.g. bpmn:Process)
        if (!primaryShape || primaryShape === plane) return;
        eventBus.fire('element.changed', {
            element: primaryShape
        });
    });
    // create/remove plane for the subprocess
    this.executed('shape.toggleCollapse', LOW_PRIORITY, function(context) {
        var shape = context.shape;
        if (!(0, _modelUtil.is)(shape, 'bpmn:SubProcess')) return;
        if (!(0, _diUtil.isExpanded)(shape)) {
            createRoot(context);
            self._showRecursively(shape.children);
        } else removeRoot(context);
    }, true);
    // create/remove plane for the subprocess
    this.reverted('shape.toggleCollapse', LOW_PRIORITY, function(context) {
        var shape = context.shape;
        if (!(0, _modelUtil.is)(shape, 'bpmn:SubProcess')) return;
        if (!(0, _diUtil.isExpanded)(shape)) {
            createRoot(context);
            self._showRecursively(shape.children);
        } else removeRoot(context);
    }, true);
    // move elements between planes
    this.postExecuted('shape.toggleCollapse', HIGH_PRIORITY, function(context) {
        var shape = context.shape;
        if (!(0, _modelUtil.is)(shape, 'bpmn:SubProcess')) return;
        var rootElement = context.newRootElement;
        if (!rootElement) return;
        if (!(0, _diUtil.isExpanded)(shape)) // collapsed
        self._moveChildrenToShape(shape, rootElement);
        else self._moveChildrenToShape(rootElement, shape);
    }, true);
    // copy-paste ///////////
    // add elements in plane to tree
    eventBus.on('copyPaste.createTree', function(context) {
        var element = context.element, children = context.children;
        if (!isCollapsedSubProcess(element)) return;
        var id = (0, _drilldownUtil.getPlaneIdFromShape)(element);
        var parent = elementRegistry.get(id);
        if (parent) // do not copy invisible root element
        children.push.apply(children, parent.children);
    });
    // set plane children as direct children of collapsed shape
    eventBus.on('copyPaste.copyElement', function(context) {
        var descriptor = context.descriptor, element = context.element, elements = context.elements;
        var parent = element.parent;
        var isPlane = (0, _modelUtil.is)((0, _modelUtil.getDi)(parent), 'bpmndi:BPMNPlane');
        if (!isPlane) return;
        var parentId = (0, _drilldownUtil.getShapeIdFromPlane)(parent);
        var referencedShape = (0, _minDash.find)(elements, function(element) {
            return element.id === parentId;
        });
        if (!referencedShape) return;
        descriptor.parent = referencedShape.id;
    });
    // hide children during pasting
    eventBus.on('copyPaste.pasteElement', function(context) {
        var descriptor = context.descriptor;
        if (!descriptor.parent) return;
        if (isCollapsedSubProcess(descriptor.parent) || descriptor.parent.hidden) descriptor.hidden = true;
    });
}
(0, _inheritsBrowserDefault.default)(SubProcessPlaneBehavior, (0, _commandInterceptorDefault.default));
/**
 * Moves the child elements from source to target.
 *
 * If the target is a plane, the children are moved to the top left corner.
 * Otherwise, the center of the target is used.
 *
 * @param {Object|djs.model.Base} source
 * @param {Object|djs.model.Base} target
 */ SubProcessPlaneBehavior.prototype._moveChildrenToShape = function(source, target) {
    var modeling = this._modeling;
    var children = source.children;
    var offset;
    if (!children) return;
    // add external labels that weren't children of sub process
    children = children.concat(children.reduce(function(labels, child) {
        if (child.label && child.label.parent !== source) return labels.concat(child.label);
        return labels;
    }, []));
    // only change plane if there are no visible children, but don't move them
    var visibleChildren = children.filter(function(child) {
        return !child.hidden;
    });
    if (!visibleChildren.length) {
        modeling.moveElements(children, {
            x: 0,
            y: 0
        }, target, {
            autoResize: false
        });
        return;
    }
    var childrenBounds = (0, _elements.getBBox)(visibleChildren);
    // target is a plane
    if (!target.x) offset = {
        x: DEFAULT_POSITION.x - childrenBounds.x,
        y: DEFAULT_POSITION.y - childrenBounds.y
    };
    else {
        // move relative to the center of the shape
        var targetMid = (0, _layoutUtil.getMid)(target);
        var childrenMid = (0, _layoutUtil.getMid)(childrenBounds);
        offset = {
            x: targetMid.x - childrenMid.x,
            y: targetMid.y - childrenMid.y
        };
    }
    modeling.moveElements(children, offset, target, {
        autoResize: false
    });
};
/**
 * Sets `hidden` property on all children of the given shape.
 *
 * @param {Array} elements
 * @param {Boolean} [hidden]
 * @returns {Array} all child elements
 */ SubProcessPlaneBehavior.prototype._showRecursively = function(elements, hidden) {
    var self = this;
    var result = [];
    elements.forEach(function(element) {
        element.hidden = !!hidden;
        result = result.concat(element);
        if (element.children) result = result.concat(self._showRecursively(element.children, element.collapsed || hidden));
    });
    return result;
};
/**
* Adds a given rootElement to the bpmnDi diagrams.
*
* @param {Object} rootElement
* @returns {Object} planeElement
*/ SubProcessPlaneBehavior.prototype._addDiagram = function(planeElement) {
    var bpmnjs = this._bpmnjs;
    var diagrams = bpmnjs.getDefinitions().diagrams;
    if (!planeElement.businessObject) planeElement = this._createNewDiagram(planeElement);
    diagrams.push(planeElement.di.$parent);
    return planeElement;
};
/**
* Creates a new plane element for the given sub process.
*
* @param {Object} bpmnElement
*
* @return {Object} new diagram element
*/ SubProcessPlaneBehavior.prototype._createNewDiagram = function(bpmnElement) {
    var bpmnFactory = this._bpmnFactory;
    var elementFactory = this._elementFactory;
    var diPlane = bpmnFactory.create('bpmndi:BPMNPlane', {
        bpmnElement: bpmnElement
    });
    var diDiagram = bpmnFactory.create('bpmndi:BPMNDiagram', {
        plane: diPlane
    });
    diPlane.$parent = diDiagram;
    // add a virtual element (not being drawn),
    // a copy cat of our BpmnImporter code
    var planeElement = elementFactory.createRoot({
        id: (0, _drilldownUtil.getPlaneIdFromShape)(bpmnElement),
        type: bpmnElement.$type,
        di: diPlane,
        businessObject: bpmnElement,
        collapsed: true
    });
    return planeElement;
};
/**
 * Removes the diagram for a given root element
 *
 * @param {Object} rootElement
 * @returns {Object} removed bpmndi:BPMNDiagram
 */ SubProcessPlaneBehavior.prototype._removeDiagram = function(rootElement) {
    var bpmnjs = this._bpmnjs;
    var diagrams = bpmnjs.getDefinitions().diagrams;
    var removedDiagram = (0, _minDash.find)(diagrams, function(diagram) {
        return diagram.plane.bpmnElement.id === rootElement.id;
    });
    diagrams.splice(diagrams.indexOf(removedDiagram), 1);
    return removedDiagram;
};
SubProcessPlaneBehavior.$inject = [
    'canvas',
    'eventBus',
    'modeling',
    'elementFactory',
    'bpmnFactory',
    'bpmnjs',
    'elementRegistry'
];

},{"inherits-browser":"hymxq","diagram-js/lib/command/CommandInterceptor":"1K1IQ","min-dash":"aEEla","../../../util/DiUtil":"krDFz","../../../util/ModelUtil":"klNYN","diagram-js/lib/layout/LayoutUtil":"4CCrs","diagram-js/lib/util/Elements":"6qdtl","../../../util/DrilldownUtil":"aMFv0","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"daF3l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SubProcessStartEventBehavior);
var _inheritsBrowser = require("inherits-browser");
var _inheritsBrowserDefault = parcelHelpers.interopDefault(_inheritsBrowser);
var _commandInterceptor = require("diagram-js/lib/command/CommandInterceptor");
var _commandInterceptorDefault = parcelHelpers.interopDefault(_commandInterceptor);
var _modelUtil = require("../../../util/ModelUtil");
var _diUtilJs = require("../../../util/DiUtil.js");
function SubProcessStartEventBehavior(injector, modeling) {
    injector.invoke((0, _commandInterceptorDefault.default), this);
    this.postExecuted('shape.replace', function(event) {
        var oldShape = event.context.oldShape, newShape = event.context.newShape;
        if (!(0, _modelUtil.is)(newShape, 'bpmn:SubProcess') || !((0, _modelUtil.is)(oldShape, 'bpmn:Task') || (0, _modelUtil.is)(oldShape, 'bpmn:CallActivity')) || !(0, _diUtilJs.isExpanded)(newShape)) return;
        var position = getStartEventPosition(newShape);
        modeling.createShape({
            type: 'bpmn:StartEvent'
        }, position, newShape);
    });
}
SubProcessStartEventBehavior.$inject = [
    'injector',
    'modeling'
];
(0, _inheritsBrowserDefault.default)(SubProcessStartEventBehavior, (0, _commandInterceptorDefault.default));
// helpers //////////
function getStartEventPosition(shape) {
    return {
        x: shape.x + shape.width / 6,
        y: shape.y + shape.height / 2
    };
}

},{"inherits-browser":"hymxq","diagram-js/lib/command/CommandInterceptor":"1K1IQ","../../../util/ModelUtil":"klNYN","../../../util/DiUtil.js":"krDFz","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1zROk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ToggleCollapseConnectionBehaviour);
var _inheritsBrowser = require("inherits-browser");
var _inheritsBrowserDefault = parcelHelpers.interopDefault(_inheritsBrowser);
var _commandInterceptor = require("diagram-js/lib/command/CommandInterceptor");
var _commandInterceptorDefault = parcelHelpers.interopDefault(_commandInterceptor);
var _minDash = require("min-dash");
var _layoutUtil = require("diagram-js/lib/layout/LayoutUtil");
var _elements = require("diagram-js/lib/util/Elements");
var _diUtil = require("../../../util/DiUtil");
function ToggleCollapseConnectionBehaviour(eventBus, modeling) {
    (0, _commandInterceptorDefault.default).call(this, eventBus);
    this.postExecuted('shape.toggleCollapse', 1500, function(context) {
        // var shape = context.shape;
        var shape = context.shape;
        // only change connections when collapsing
        if ((0, _diUtil.isExpanded)(shape)) return;
        var allChildren = (0, _elements.selfAndAllChildren)(shape);
        allChildren.forEach(function(child) {
            // Ensure that the connection array is not modified during iteration
            var incomingConnections = child.incoming.slice(), outgoingConnections = child.outgoing.slice();
            (0, _minDash.forEach)(incomingConnections, function(c) {
                handleConnection(c, true);
            });
            (0, _minDash.forEach)(outgoingConnections, function(c) {
                handleConnection(c, false);
            });
        });
        function handleConnection(c, incoming) {
            if (allChildren.indexOf(c.source) !== -1 && allChildren.indexOf(c.target) !== -1) return;
            if (incoming) modeling.reconnectEnd(c, shape, (0, _layoutUtil.getMid)(shape));
            else modeling.reconnectStart(c, shape, (0, _layoutUtil.getMid)(shape));
        }
    }, true);
}
(0, _inheritsBrowserDefault.default)(ToggleCollapseConnectionBehaviour, (0, _commandInterceptorDefault.default));
ToggleCollapseConnectionBehaviour.$inject = [
    'eventBus',
    'modeling'
];

},{"inherits-browser":"hymxq","diagram-js/lib/command/CommandInterceptor":"1K1IQ","min-dash":"aEEla","diagram-js/lib/layout/LayoutUtil":"4CCrs","diagram-js/lib/util/Elements":"6qdtl","../../../util/DiUtil":"krDFz","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gmtTu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ToggleElementCollapseBehaviour);
var _inheritsBrowser = require("inherits-browser");
var _inheritsBrowserDefault = parcelHelpers.interopDefault(_inheritsBrowser);
var _commandInterceptor = require("diagram-js/lib/command/CommandInterceptor");
var _commandInterceptorDefault = parcelHelpers.interopDefault(_commandInterceptor);
var _modelUtil = require("../../../util/ModelUtil");
var _resizeUtil = require("diagram-js/lib/features/resize/ResizeUtil");
var LOW_PRIORITY = 500;
function ToggleElementCollapseBehaviour(eventBus, elementFactory, modeling, resize) {
    (0, _commandInterceptorDefault.default).call(this, eventBus);
    function hideEmptyLabels(children) {
        if (children.length) children.forEach(function(child) {
            if (child.type === 'label' && !child.businessObject.name) child.hidden = true;
        });
    }
    function expandedBounds(shape, defaultSize) {
        var children = shape.children, newBounds = defaultSize, visibleElements, visibleBBox;
        visibleElements = filterVisible(children).concat([
            shape
        ]);
        visibleBBox = (0, _resizeUtil.computeChildrenBBox)(visibleElements);
        if (visibleBBox) {
            // center to visibleBBox with max(defaultSize, childrenBounds)
            newBounds.width = Math.max(visibleBBox.width, newBounds.width);
            newBounds.height = Math.max(visibleBBox.height, newBounds.height);
            newBounds.x = visibleBBox.x + (visibleBBox.width - newBounds.width) / 2;
            newBounds.y = visibleBBox.y + (visibleBBox.height - newBounds.height) / 2;
        } else {
            // center to collapsed shape with defaultSize
            newBounds.x = shape.x + (shape.width - newBounds.width) / 2;
            newBounds.y = shape.y + (shape.height - newBounds.height) / 2;
        }
        return newBounds;
    }
    function collapsedBounds(shape, defaultSize) {
        return {
            x: shape.x + (shape.width - defaultSize.width) / 2,
            y: shape.y + (shape.height - defaultSize.height) / 2,
            width: defaultSize.width,
            height: defaultSize.height
        };
    }
    this.executed([
        'shape.toggleCollapse'
    ], LOW_PRIORITY, function(e) {
        var context = e.context, shape = context.shape;
        if (!(0, _modelUtil.is)(shape, 'bpmn:SubProcess')) return;
        if (!shape.collapsed) {
            // all children got made visible through djs, hide empty labels
            hideEmptyLabels(shape.children);
            // remove collapsed marker
            (0, _modelUtil.getDi)(shape).isExpanded = true;
        } else // place collapsed marker
        (0, _modelUtil.getDi)(shape).isExpanded = false;
    });
    this.reverted([
        'shape.toggleCollapse'
    ], LOW_PRIORITY, function(e) {
        var context = e.context;
        var shape = context.shape;
        // revert removing/placing collapsed marker
        if (!shape.collapsed) (0, _modelUtil.getDi)(shape).isExpanded = true;
        else (0, _modelUtil.getDi)(shape).isExpanded = false;
    });
    this.postExecuted([
        'shape.toggleCollapse'
    ], LOW_PRIORITY, function(e) {
        var shape = e.context.shape, defaultSize = elementFactory.getDefaultSize(shape), newBounds;
        if (shape.collapsed) // resize to default size of collapsed shapes
        newBounds = collapsedBounds(shape, defaultSize);
        else // resize to bounds of max(visible children, defaultSize)
        newBounds = expandedBounds(shape, defaultSize);
        modeling.resizeShape(shape, newBounds, null, {
            autoResize: shape.collapsed ? false : 'nwse'
        });
    });
}
(0, _inheritsBrowserDefault.default)(ToggleElementCollapseBehaviour, (0, _commandInterceptorDefault.default));
ToggleElementCollapseBehaviour.$inject = [
    'eventBus',
    'elementFactory',
    'modeling'
];
// helpers //////////////////////
function filterVisible(elements) {
    return elements.filter(function(e) {
        return !e.hidden;
    });
}

},{"inherits-browser":"hymxq","diagram-js/lib/command/CommandInterceptor":"1K1IQ","../../../util/ModelUtil":"klNYN","diagram-js/lib/features/resize/ResizeUtil":"gKMgs","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fHB5H":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>UnclaimIdBehavior);
var _inheritsBrowser = require("inherits-browser");
var _inheritsBrowserDefault = parcelHelpers.interopDefault(_inheritsBrowser);
var _commandInterceptor = require("diagram-js/lib/command/CommandInterceptor");
var _commandInterceptorDefault = parcelHelpers.interopDefault(_commandInterceptor);
var _modelUtil = require("../../../util/ModelUtil");
var _diUtil = require("../../../util/DiUtil");
var _labelUtil = require("../../../util/LabelUtil");
function UnclaimIdBehavior(canvas, injector, moddle, modeling) {
    injector.invoke((0, _commandInterceptorDefault.default), this);
    this.preExecute('shape.delete', function(event) {
        var context = event.context, shape = context.shape, shapeBo = shape.businessObject;
        if ((0, _labelUtil.isLabel)(shape)) return;
        if ((0, _modelUtil.is)(shape, 'bpmn:Participant') && (0, _diUtil.isExpanded)(shape)) moddle.ids.unclaim(shapeBo.processRef.id);
        modeling.unclaimId(shapeBo.id, shapeBo);
    });
    this.preExecute('connection.delete', function(event) {
        var context = event.context, connection = context.connection, connectionBo = connection.businessObject;
        modeling.unclaimId(connectionBo.id, connectionBo);
    });
    this.preExecute('canvas.updateRoot', function() {
        var rootElement = canvas.getRootElement(), rootElementBo = rootElement.businessObject;
        if ((0, _modelUtil.is)(rootElement, 'bpmn:Collaboration')) moddle.ids.unclaim(rootElementBo.id);
    });
}
(0, _inheritsBrowserDefault.default)(UnclaimIdBehavior, (0, _commandInterceptorDefault.default));
UnclaimIdBehavior.$inject = [
    'canvas',
    'injector',
    'moddle',
    'modeling'
];

},{"inherits-browser":"hymxq","diagram-js/lib/command/CommandInterceptor":"1K1IQ","../../../util/ModelUtil":"klNYN","../../../util/DiUtil":"krDFz","../../../util/LabelUtil":"fAd5x","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9SvVp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DeleteSequenceFlowBehavior);
var _inheritsBrowser = require("inherits-browser");
var _inheritsBrowserDefault = parcelHelpers.interopDefault(_inheritsBrowser);
var _commandInterceptor = require("diagram-js/lib/command/CommandInterceptor");
var _commandInterceptorDefault = parcelHelpers.interopDefault(_commandInterceptor);
var _modelUtil = require("../../../util/ModelUtil");
function DeleteSequenceFlowBehavior(eventBus, modeling) {
    (0, _commandInterceptorDefault.default).call(this, eventBus);
    this.preExecute('connection.delete', function(event) {
        var context = event.context, connection = context.connection, source = connection.source;
        if (isDefaultFlow(connection, source)) modeling.updateProperties(source, {
            'default': null
        });
    });
}
(0, _inheritsBrowserDefault.default)(DeleteSequenceFlowBehavior, (0, _commandInterceptorDefault.default));
DeleteSequenceFlowBehavior.$inject = [
    'eventBus',
    'modeling'
];
// helpers //////////////////////
function isDefaultFlow(connection, source) {
    if (!(0, _modelUtil.is)(connection, 'bpmn:SequenceFlow')) return false;
    var sourceBo = (0, _modelUtil.getBusinessObject)(source), sequenceFlow = (0, _modelUtil.getBusinessObject)(connection);
    return sourceBo.get('default') === sequenceFlow;
}

},{"inherits-browser":"hymxq","diagram-js/lib/command/CommandInterceptor":"1K1IQ","../../../util/ModelUtil":"klNYN","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2kKcR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>UpdateFlowNodeRefsBehavior);
var _inheritsBrowser = require("inherits-browser");
var _inheritsBrowserDefault = parcelHelpers.interopDefault(_inheritsBrowser);
var _commandInterceptor = require("diagram-js/lib/command/CommandInterceptor");
var _commandInterceptorDefault = parcelHelpers.interopDefault(_commandInterceptor);
var _modelUtil = require("../../../util/ModelUtil");
var LOW_PRIORITY = 500, HIGH_PRIORITY = 5000;
function UpdateFlowNodeRefsBehavior(eventBus, modeling, translate) {
    (0, _commandInterceptorDefault.default).call(this, eventBus);
    /**
   * Ok, this is it:
   *
   * We have to update the Lane#flowNodeRefs _and_
   * FlowNode#lanes with every FlowNode move/resize and
   * Lane move/resize.
   *
   * We want to group that stuff to recompute containments
   * as efficient as possible.
   *
   * Yea!
   */ // the update context
    var context;
    function initContext() {
        context = context || new UpdateContext();
        context.enter();
        return context;
    }
    function getContext() {
        if (!context) throw new Error(translate('out of bounds release'));
        return context;
    }
    function releaseContext() {
        if (!context) throw new Error(translate('out of bounds release'));
        var triggerUpdate = context.leave();
        if (triggerUpdate) {
            modeling.updateLaneRefs(context.flowNodes, context.lanes);
            context = null;
        }
        return triggerUpdate;
    }
    var laneRefUpdateEvents = [
        'spaceTool',
        'lane.add',
        'lane.resize',
        'lane.split',
        'elements.create',
        'elements.delete',
        'elements.move',
        'shape.create',
        'shape.delete',
        'shape.move',
        'shape.resize'
    ];
    // listen to a lot of stuff to group lane updates
    this.preExecute(laneRefUpdateEvents, HIGH_PRIORITY, function(event) {
        initContext();
    });
    this.postExecuted(laneRefUpdateEvents, LOW_PRIORITY, function(event) {
        releaseContext();
    });
    // Mark flow nodes + lanes that need an update
    this.preExecute([
        'shape.create',
        'shape.move',
        'shape.delete',
        'shape.resize'
    ], function(event) {
        var context = event.context, shape = context.shape;
        var updateContext = getContext();
        // no need to update labels
        if (shape.labelTarget) return;
        if ((0, _modelUtil.is)(shape, 'bpmn:Lane')) updateContext.addLane(shape);
        if ((0, _modelUtil.is)(shape, 'bpmn:FlowNode')) updateContext.addFlowNode(shape);
    });
}
UpdateFlowNodeRefsBehavior.$inject = [
    'eventBus',
    'modeling',
    'translate'
];
(0, _inheritsBrowserDefault.default)(UpdateFlowNodeRefsBehavior, (0, _commandInterceptorDefault.default));
function UpdateContext() {
    this.flowNodes = [];
    this.lanes = [];
    this.counter = 0;
    this.addLane = function(lane) {
        this.lanes.push(lane);
    };
    this.addFlowNode = function(flowNode) {
        this.flowNodes.push(flowNode);
    };
    this.enter = function() {
        this.counter++;
    };
    this.leave = function() {
        this.counter--;
        return !this.counter;
    };
}

},{"inherits-browser":"hymxq","diagram-js/lib/command/CommandInterceptor":"1K1IQ","../../../util/ModelUtil":"klNYN","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8tpa6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rules = require("diagram-js/lib/features/rules");
var _rulesDefault = parcelHelpers.interopDefault(_rules);
var _bpmnRules = require("./BpmnRules");
var _bpmnRulesDefault = parcelHelpers.interopDefault(_bpmnRules);
exports.default = {
    __depends__: [
        (0, _rulesDefault.default)
    ],
    __init__: [
        'bpmnRules'
    ],
    bpmnRules: [
        'type',
        (0, _bpmnRulesDefault.default)
    ]
};

},{"diagram-js/lib/features/rules":"5xj5a","./BpmnRules":"JWJr9","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"JWJr9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BpmnRules);
var _minDash = require("min-dash");
var _inheritsBrowser = require("inherits-browser");
var _inheritsBrowserDefault = parcelHelpers.interopDefault(_inheritsBrowser);
var _modelUtil = require("../../util/ModelUtil");
var _modelingUtil = require("../modeling/util/ModelingUtil");
var _labelUtil = require("../../util/LabelUtil");
var _diUtil = require("../../util/DiUtil");
var _ruleProvider = require("diagram-js/lib/features/rules/RuleProvider");
var _ruleProviderDefault = parcelHelpers.interopDefault(_ruleProvider);
var _bpmnSnappingUtil = require("../snapping/BpmnSnappingUtil");
function BpmnRules(eventBus) {
    (0, _ruleProviderDefault.default).call(this, eventBus);
}
(0, _inheritsBrowserDefault.default)(BpmnRules, (0, _ruleProviderDefault.default));
BpmnRules.$inject = [
    'eventBus'
];
BpmnRules.prototype.init = function() {
    this.addRule('connection.start', function(context) {
        var source = context.source;
        return canStartConnection(source);
    });
    this.addRule('connection.create', function(context) {
        var source = context.source, target = context.target, hints = context.hints || {}, targetParent = hints.targetParent, targetAttach = hints.targetAttach;
        // don't allow incoming connections on
        // newly created boundary events
        // to boundary events
        if (targetAttach) return false;
        // temporarily set target parent for scoping
        // checks to work
        if (targetParent) target.parent = targetParent;
        try {
            return canConnect(source, target);
        } finally{
            // unset temporary target parent
            if (targetParent) target.parent = null;
        }
    });
    this.addRule('connection.reconnect', function(context) {
        var connection = context.connection, source = context.source, target = context.target;
        return canConnect(source, target, connection);
    });
    this.addRule('connection.updateWaypoints', function(context) {
        return {
            type: context.connection.type
        };
    });
    this.addRule('shape.resize', function(context) {
        var shape = context.shape, newBounds = context.newBounds;
        return canResize(shape, newBounds);
    });
    this.addRule('elements.create', function(context) {
        var elements = context.elements, position = context.position, target = context.target;
        if (isConnection(target) && !canInsert(elements, target, position)) return false;
        return (0, _minDash.every)(elements, function(element) {
            if (isConnection(element)) return canConnect(element.source, element.target, element);
            if (element.host) return canAttach(element, element.host, null, position);
            return canCreate(element, target, null, position);
        });
    });
    this.addRule('elements.move', function(context) {
        var target = context.target, shapes = context.shapes, position = context.position;
        return canAttach(shapes, target, null, position) || canReplace(shapes, target, position) || canMove(shapes, target, position) || canInsert(shapes, target, position);
    });
    this.addRule('shape.create', function(context) {
        return canCreate(context.shape, context.target, context.source, context.position);
    });
    this.addRule('shape.attach', function(context) {
        return canAttach(context.shape, context.target, null, context.position);
    });
    this.addRule('element.copy', function(context) {
        var element = context.element, elements = context.elements;
        return canCopy(elements, element);
    });
};
BpmnRules.prototype.canConnectMessageFlow = canConnectMessageFlow;
BpmnRules.prototype.canConnectSequenceFlow = canConnectSequenceFlow;
BpmnRules.prototype.canConnectDataAssociation = canConnectDataAssociation;
BpmnRules.prototype.canConnectAssociation = canConnectAssociation;
BpmnRules.prototype.canMove = canMove;
BpmnRules.prototype.canAttach = canAttach;
BpmnRules.prototype.canReplace = canReplace;
BpmnRules.prototype.canDrop = canDrop;
BpmnRules.prototype.canInsert = canInsert;
BpmnRules.prototype.canCreate = canCreate;
BpmnRules.prototype.canConnect = canConnect;
BpmnRules.prototype.canResize = canResize;
BpmnRules.prototype.canCopy = canCopy;
/**
 * Utility functions for rule checking
 */ /**
 * Checks if given element can be used for starting connection.
 *
 * @param  {Element} source
 * @return {boolean}
 */ function canStartConnection(element) {
    if (nonExistingOrLabel(element)) return null;
    return (0, _modelingUtil.isAny)(element, [
        'bpmn:FlowNode',
        'bpmn:InteractionNode',
        'bpmn:DataObjectReference',
        'bpmn:DataStoreReference',
        'bpmn:Group',
        'bpmn:TextAnnotation'
    ]);
}
function nonExistingOrLabel(element) {
    return !element || (0, _labelUtil.isLabel)(element);
}
function isSame(a, b) {
    return a === b;
}
function getOrganizationalParent(element) {
    do {
        if ((0, _modelUtil.is)(element, 'bpmn:Process')) return (0, _modelUtil.getBusinessObject)(element);
        if ((0, _modelUtil.is)(element, 'bpmn:Participant')) return (0, _modelUtil.getBusinessObject)(element).processRef || (0, _modelUtil.getBusinessObject)(element);
    }while (element = element.parent);
}
function isTextAnnotation(element) {
    return (0, _modelUtil.is)(element, 'bpmn:TextAnnotation');
}
function isGroup(element) {
    return (0, _modelUtil.is)(element, 'bpmn:Group') && !element.labelTarget;
}
function isCompensationBoundary(element) {
    return (0, _modelUtil.is)(element, 'bpmn:BoundaryEvent') && hasEventDefinition(element, 'bpmn:CompensateEventDefinition');
}
function isForCompensation(e) {
    return (0, _modelUtil.getBusinessObject)(e).isForCompensation;
}
function isSameOrganization(a, b) {
    var parentA = getOrganizationalParent(a), parentB = getOrganizationalParent(b);
    return parentA === parentB;
}
function isMessageFlowSource(element) {
    return (0, _modelUtil.is)(element, 'bpmn:InteractionNode') && !(0, _modelUtil.is)(element, 'bpmn:BoundaryEvent') && (!(0, _modelUtil.is)(element, 'bpmn:Event') || (0, _modelUtil.is)(element, 'bpmn:ThrowEvent') && hasEventDefinitionOrNone(element, 'bpmn:MessageEventDefinition'));
}
function isMessageFlowTarget(element) {
    return (0, _modelUtil.is)(element, 'bpmn:InteractionNode') && !isForCompensation(element) && (!(0, _modelUtil.is)(element, 'bpmn:Event') || (0, _modelUtil.is)(element, 'bpmn:CatchEvent') && hasEventDefinitionOrNone(element, 'bpmn:MessageEventDefinition')) && !((0, _modelUtil.is)(element, 'bpmn:BoundaryEvent') && !hasEventDefinition(element, 'bpmn:MessageEventDefinition'));
}
function getScopeParent(element) {
    var parent = element;
    while(parent = parent.parent){
        if ((0, _modelUtil.is)(parent, 'bpmn:FlowElementsContainer')) return (0, _modelUtil.getBusinessObject)(parent);
        if ((0, _modelUtil.is)(parent, 'bpmn:Participant')) return (0, _modelUtil.getBusinessObject)(parent).processRef;
    }
    return null;
}
function isSameScope(a, b) {
    var scopeParentA = getScopeParent(a), scopeParentB = getScopeParent(b);
    return scopeParentA === scopeParentB;
}
function hasEventDefinition(element, eventDefinition) {
    var bo = (0, _modelUtil.getBusinessObject)(element);
    return !!(0, _minDash.find)(bo.eventDefinitions || [], function(definition) {
        return (0, _modelUtil.is)(definition, eventDefinition);
    });
}
function hasEventDefinitionOrNone(element, eventDefinition) {
    var bo = (0, _modelUtil.getBusinessObject)(element);
    return (bo.eventDefinitions || []).every(function(definition) {
        return (0, _modelUtil.is)(definition, eventDefinition);
    });
}
function isSequenceFlowSource(element) {
    return (0, _modelUtil.is)(element, 'bpmn:FlowNode') && !(0, _modelUtil.is)(element, 'bpmn:EndEvent') && !(0, _diUtil.isEventSubProcess)(element) && !((0, _modelUtil.is)(element, 'bpmn:IntermediateThrowEvent') && hasEventDefinition(element, 'bpmn:LinkEventDefinition')) && !isCompensationBoundary(element) && !isForCompensation(element);
}
function isSequenceFlowTarget(element) {
    return (0, _modelUtil.is)(element, 'bpmn:FlowNode') && !(0, _modelUtil.is)(element, 'bpmn:StartEvent') && !(0, _modelUtil.is)(element, 'bpmn:BoundaryEvent') && !(0, _diUtil.isEventSubProcess)(element) && !((0, _modelUtil.is)(element, 'bpmn:IntermediateCatchEvent') && hasEventDefinition(element, 'bpmn:LinkEventDefinition')) && !isForCompensation(element);
}
function isEventBasedTarget(element) {
    return (0, _modelUtil.is)(element, 'bpmn:ReceiveTask') || (0, _modelUtil.is)(element, 'bpmn:IntermediateCatchEvent') && (hasEventDefinition(element, 'bpmn:MessageEventDefinition') || hasEventDefinition(element, 'bpmn:TimerEventDefinition') || hasEventDefinition(element, 'bpmn:ConditionalEventDefinition') || hasEventDefinition(element, 'bpmn:SignalEventDefinition'));
}
function isConnection(element) {
    return element.waypoints;
}
function getParents(element) {
    var parents = [];
    while(element){
        element = element.parent;
        if (element) parents.push(element);
    }
    return parents;
}
function isParent(possibleParent, element) {
    var allParents = getParents(element);
    return allParents.indexOf(possibleParent) !== -1;
}
function canConnect(source, target, connection) {
    if (nonExistingOrLabel(source) || nonExistingOrLabel(target)) return null;
    if (!(0, _modelUtil.is)(connection, 'bpmn:DataAssociation')) {
        if (canConnectMessageFlow(source, target)) return {
            type: 'bpmn:MessageFlow'
        };
        if (canConnectSequenceFlow(source, target)) return {
            type: 'bpmn:SequenceFlow'
        };
    }
    var connectDataAssociation = canConnectDataAssociation(source, target);
    if (connectDataAssociation) return connectDataAssociation;
    if (isCompensationBoundary(source) && isForCompensation(target)) return {
        type: 'bpmn:Association',
        associationDirection: 'One'
    };
    if (canConnectAssociation(source, target)) return {
        type: 'bpmn:Association'
    };
    return false;
}
/**
 * Can an element be dropped into the target element
 *
 * @return {boolean}
 */ function canDrop(element, target, position) {
    // can move labels and groups everywhere
    if ((0, _labelUtil.isLabel)(element) || isGroup(element)) return true;
    // disallow to create elements on collapsed pools
    if ((0, _modelUtil.is)(target, 'bpmn:Participant') && !(0, _diUtil.isExpanded)(target)) return false;
    // allow to create new participants on
    // existing collaboration and process diagrams
    if ((0, _modelUtil.is)(element, 'bpmn:Participant')) return (0, _modelUtil.is)(target, 'bpmn:Process') || (0, _modelUtil.is)(target, 'bpmn:Collaboration');
    // allow moving DataInput / DataOutput within its original container only
    if ((0, _modelingUtil.isAny)(element, [
        'bpmn:DataInput',
        'bpmn:DataOutput'
    ])) {
        if (element.parent) return target === element.parent;
    }
    // allow creating lanes on participants and other lanes only
    if ((0, _modelUtil.is)(element, 'bpmn:Lane')) return (0, _modelUtil.is)(target, 'bpmn:Participant') || (0, _modelUtil.is)(target, 'bpmn:Lane');
    // disallow dropping boundary events which cannot replace with intermediate event
    if ((0, _modelUtil.is)(element, 'bpmn:BoundaryEvent') && !isDroppableBoundaryEvent(element)) return false;
    // drop flow elements onto flow element containers
    // and participants
    if ((0, _modelUtil.is)(element, 'bpmn:FlowElement') && !(0, _modelUtil.is)(element, 'bpmn:DataStoreReference')) {
        if ((0, _modelUtil.is)(target, 'bpmn:FlowElementsContainer')) return (0, _diUtil.isExpanded)(target);
        return (0, _modelingUtil.isAny)(target, [
            'bpmn:Participant',
            'bpmn:Lane'
        ]);
    }
    // disallow dropping data store reference if there is no process to append to
    if ((0, _modelUtil.is)(element, 'bpmn:DataStoreReference') && (0, _modelUtil.is)(target, 'bpmn:Collaboration')) return (0, _minDash.some)((0, _modelUtil.getBusinessObject)(target).get('participants'), function(participant) {
        return !!participant.get('processRef');
    });
    // account for the fact that data associations are always
    // rendered and moved to top (Process or Collaboration level)
    //
    // artifacts may be placed wherever, too
    if ((0, _modelingUtil.isAny)(element, [
        'bpmn:Artifact',
        'bpmn:DataAssociation',
        'bpmn:DataStoreReference'
    ])) return (0, _modelingUtil.isAny)(target, [
        'bpmn:Collaboration',
        'bpmn:Lane',
        'bpmn:Participant',
        'bpmn:Process',
        'bpmn:SubProcess'
    ]);
    if ((0, _modelUtil.is)(element, 'bpmn:MessageFlow')) return (0, _modelUtil.is)(target, 'bpmn:Collaboration') || element.source.parent == target || element.target.parent == target;
    return false;
}
function isDroppableBoundaryEvent(event) {
    return (0, _modelUtil.getBusinessObject)(event).cancelActivity && (hasNoEventDefinition(event) || hasCommonBoundaryIntermediateEventDefinition(event));
}
function isBoundaryEvent(element) {
    return !(0, _labelUtil.isLabel)(element) && (0, _modelUtil.is)(element, 'bpmn:BoundaryEvent');
}
function isLane(element) {
    return (0, _modelUtil.is)(element, 'bpmn:Lane');
}
/**
 * We treat IntermediateThrowEvents as boundary events during create,
 * this must be reflected in the rules.
 */ function isBoundaryCandidate(element) {
    if (isBoundaryEvent(element)) return true;
    if ((0, _modelUtil.is)(element, 'bpmn:IntermediateThrowEvent') && hasNoEventDefinition(element)) return true;
    return (0, _modelUtil.is)(element, 'bpmn:IntermediateCatchEvent') && hasCommonBoundaryIntermediateEventDefinition(element);
}
function hasNoEventDefinition(element) {
    var bo = (0, _modelUtil.getBusinessObject)(element);
    return bo && !(bo.eventDefinitions && bo.eventDefinitions.length);
}
function hasCommonBoundaryIntermediateEventDefinition(element) {
    return hasOneOfEventDefinitions(element, [
        'bpmn:MessageEventDefinition',
        'bpmn:TimerEventDefinition',
        'bpmn:SignalEventDefinition',
        'bpmn:ConditionalEventDefinition'
    ]);
}
function hasOneOfEventDefinitions(element, eventDefinitions) {
    return eventDefinitions.some(function(definition) {
        return hasEventDefinition(element, definition);
    });
}
function isReceiveTaskAfterEventBasedGateway(element) {
    return (0, _modelUtil.is)(element, 'bpmn:ReceiveTask') && (0, _minDash.find)(element.incoming, function(incoming) {
        return (0, _modelUtil.is)(incoming.source, 'bpmn:EventBasedGateway');
    });
}
function canAttach(elements, target, source, position) {
    if (!Array.isArray(elements)) elements = [
        elements
    ];
    // only (re-)attach one element at a time
    if (elements.length !== 1) return false;
    var element = elements[0];
    // do not attach labels
    if ((0, _labelUtil.isLabel)(element)) return false;
    // only handle boundary events
    if (!isBoundaryCandidate(element)) return false;
    // disallow drop on event sub processes
    if ((0, _diUtil.isEventSubProcess)(target)) return false;
    // only allow drop on non compensation activities
    if (!(0, _modelUtil.is)(target, 'bpmn:Activity') || isForCompensation(target)) return false;
    // only attach to subprocess border
    if (position && !(0, _bpmnSnappingUtil.getBoundaryAttachment)(position, target)) return false;
    // do not attach on receive tasks after event based gateways
    if (isReceiveTaskAfterEventBasedGateway(target)) return false;
    return 'attach';
}
/**
 * Defines how to replace elements for a given target.
 *
 * Returns an array containing all elements which will be replaced.
 *
 * @example
 *
 *  [{ id: 'IntermediateEvent_2',
 *     type: 'bpmn:StartEvent'
 *   },
 *   { id: 'IntermediateEvent_5',
 *     type: 'bpmn:EndEvent'
 *   }]
 *
 * @param  {Array} elements
 * @param  {Object} target
 *
 * @return {Object} an object containing all elements which have to be replaced
 */ function canReplace(elements, target, position) {
    if (!target) return false;
    var canExecute = {
        replacements: []
    };
    (0, _minDash.forEach)(elements, function(element) {
        if (!(0, _diUtil.isEventSubProcess)(target)) {
            if ((0, _modelUtil.is)(element, 'bpmn:StartEvent') && element.type !== 'label' && canDrop(element, target)) {
                // replace a non-interrupting start event by a blank interrupting start event
                // when the target is not an event sub process
                if (!(0, _diUtil.isInterrupting)(element)) canExecute.replacements.push({
                    oldElementId: element.id,
                    newElementType: 'bpmn:StartEvent'
                });
                // replace an error/escalation/compensate start event by a blank interrupting start event
                // when the target is not an event sub process
                if ((0, _diUtil.hasErrorEventDefinition)(element) || (0, _diUtil.hasEscalationEventDefinition)(element) || (0, _diUtil.hasCompensateEventDefinition)(element)) canExecute.replacements.push({
                    oldElementId: element.id,
                    newElementType: 'bpmn:StartEvent'
                });
                // replace a typed start event by a blank interrupting start event
                // when the target is a sub process but not an event sub process
                if (hasOneOfEventDefinitions(element, [
                    'bpmn:MessageEventDefinition',
                    'bpmn:TimerEventDefinition',
                    'bpmn:SignalEventDefinition',
                    'bpmn:ConditionalEventDefinition'
                ]) && (0, _modelUtil.is)(target, 'bpmn:SubProcess')) canExecute.replacements.push({
                    oldElementId: element.id,
                    newElementType: 'bpmn:StartEvent'
                });
            }
        }
        if (!(0, _modelUtil.is)(target, 'bpmn:Transaction')) {
            if (hasEventDefinition(element, 'bpmn:CancelEventDefinition') && element.type !== 'label') {
                if ((0, _modelUtil.is)(element, 'bpmn:EndEvent') && canDrop(element, target)) canExecute.replacements.push({
                    oldElementId: element.id,
                    newElementType: 'bpmn:EndEvent'
                });
                if ((0, _modelUtil.is)(element, 'bpmn:BoundaryEvent') && canAttach(element, target, null, position)) canExecute.replacements.push({
                    oldElementId: element.id,
                    newElementType: 'bpmn:BoundaryEvent'
                });
            }
        }
    });
    return canExecute.replacements.length ? canExecute : false;
}
function canMove(elements, target) {
    // do not move selection containing lanes
    if ((0, _minDash.some)(elements, isLane)) return false;
    // allow default move check to start move operation
    if (!target) return true;
    return elements.every(function(element) {
        return canDrop(element, target);
    });
}
function canCreate(shape, target, source, position) {
    if (!target) return false;
    if ((0, _labelUtil.isLabel)(shape) || isGroup(shape)) return true;
    if (isSame(source, target)) return false;
    // ensure we do not drop the element
    // into source
    if (source && isParent(source, target)) return false;
    return canDrop(shape, target, position) || canInsert(shape, target, position);
}
function canResize(shape, newBounds) {
    if ((0, _modelUtil.is)(shape, 'bpmn:SubProcess')) return (0, _diUtil.isExpanded)(shape) && (!newBounds || newBounds.width >= 100 && newBounds.height >= 80);
    if ((0, _modelUtil.is)(shape, 'bpmn:Lane')) return !newBounds || newBounds.width >= 130 && newBounds.height >= 60;
    if ((0, _modelUtil.is)(shape, 'bpmn:Participant')) return !newBounds || newBounds.width >= 250 && newBounds.height >= 50;
    if (isTextAnnotation(shape)) return true;
    if (isGroup(shape)) return true;
    return false;
}
/**
 * Check, whether one side of the relationship
 * is a text annotation.
 */ function isOneTextAnnotation(source, target) {
    var sourceTextAnnotation = isTextAnnotation(source), targetTextAnnotation = isTextAnnotation(target);
    return (sourceTextAnnotation || targetTextAnnotation) && sourceTextAnnotation !== targetTextAnnotation;
}
function canConnectAssociation(source, target) {
    // compensation boundary events are exception
    if (isCompensationBoundary(source) && isForCompensation(target)) return true;
    // don't connect parent <-> child
    if (isParent(target, source) || isParent(source, target)) return false;
    // allow connection of associations between <!TextAnnotation> and <TextAnnotation>
    if (isOneTextAnnotation(source, target)) return true;
    // can connect associations where we can connect
    // data associations, too (!)
    return !!canConnectDataAssociation(source, target);
}
function canConnectMessageFlow(source, target) {
    // during connect user might move mouse out of canvas
    // https://github.com/bpmn-io/bpmn-js/issues/1033
    if (getRootElement(source) && !getRootElement(target)) return false;
    return isMessageFlowSource(source) && isMessageFlowTarget(target) && !isSameOrganization(source, target);
}
function canConnectSequenceFlow(source, target) {
    return isSequenceFlowSource(source) && isSequenceFlowTarget(target) && isSameScope(source, target) && !((0, _modelUtil.is)(source, 'bpmn:EventBasedGateway') && !isEventBasedTarget(target));
}
function canConnectDataAssociation(source, target) {
    if ((0, _modelingUtil.isAny)(source, [
        'bpmn:DataObjectReference',
        'bpmn:DataStoreReference'
    ]) && (0, _modelingUtil.isAny)(target, [
        'bpmn:Activity',
        'bpmn:ThrowEvent'
    ])) return {
        type: 'bpmn:DataInputAssociation'
    };
    if ((0, _modelingUtil.isAny)(target, [
        'bpmn:DataObjectReference',
        'bpmn:DataStoreReference'
    ]) && (0, _modelingUtil.isAny)(source, [
        'bpmn:Activity',
        'bpmn:CatchEvent'
    ])) return {
        type: 'bpmn:DataOutputAssociation'
    };
    return false;
}
function canInsert(shape, flow, position) {
    if (!flow) return false;
    if (Array.isArray(shape)) {
        if (shape.length !== 1) return false;
        shape = shape[0];
    }
    if (flow.source === shape || flow.target === shape) return false;
    // return true if we can drop on the
    // underlying flow parent
    //
    // at this point we are not really able to talk
    // about connection rules (yet)
    return (0, _modelingUtil.isAny)(flow, [
        'bpmn:SequenceFlow',
        'bpmn:MessageFlow'
    ]) && !(0, _labelUtil.isLabel)(flow) && (0, _modelUtil.is)(shape, 'bpmn:FlowNode') && !(0, _modelUtil.is)(shape, 'bpmn:BoundaryEvent') && canDrop(shape, flow.parent, position);
}
function includes(elements, element) {
    return elements && element && elements.indexOf(element) !== -1;
}
function canCopy(elements, element) {
    if ((0, _labelUtil.isLabel)(element)) return true;
    if ((0, _modelUtil.is)(element, 'bpmn:Lane') && !includes(elements, element.parent)) return false;
    return true;
}
function getRootElement(element) {
    return (0, _modelingUtil.getParent)(element, 'bpmn:Process') || (0, _modelingUtil.getParent)(element, 'bpmn:Collaboration');
}

},{"min-dash":"aEEla","inherits-browser":"hymxq","../../util/ModelUtil":"klNYN","../modeling/util/ModelingUtil":"4DR1e","../../util/LabelUtil":"fAd5x","../../util/DiUtil":"krDFz","diagram-js/lib/features/rules/RuleProvider":"5VfYt","../snapping/BpmnSnappingUtil":"hDtSZ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hDtSZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getBoundaryAttachment", ()=>getBoundaryAttachment);
var _layoutUtil = require("diagram-js/lib/layout/LayoutUtil");
function getBoundaryAttachment(position, targetBounds) {
    var orientation = (0, _layoutUtil.getOrientation)(position, targetBounds, -15);
    if (orientation !== 'intersect') return orientation;
    else return null;
}

},{"diagram-js/lib/layout/LayoutUtil":"4CCrs","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"unIbF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _bpmnDiOrdering = require("../di-ordering/BpmnDiOrdering");
var _bpmnDiOrderingDefault = parcelHelpers.interopDefault(_bpmnDiOrdering);
exports.default = {
    __init__: [
        'bpmnDiOrdering'
    ],
    bpmnDiOrdering: [
        'type',
        (0, _bpmnDiOrderingDefault.default)
    ]
};

},{"../di-ordering/BpmnDiOrdering":"6EMGV","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6EMGV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BpmnDiOrdering);
var _modelUtil = require("../../util/ModelUtil");
var _minDash = require("min-dash");
var _elements = require("diagram-js/lib/util/Elements");
var HIGH_PRIORITY = 2000;
function BpmnDiOrdering(eventBus, canvas) {
    eventBus.on('saveXML.start', HIGH_PRIORITY, orderDi);
    function orderDi() {
        var rootElements = canvas.getRootElements();
        (0, _minDash.forEach)(rootElements, function(root) {
            var rootDi = (0, _modelUtil.getDi)(root), elements, diElements;
            elements = (0, _elements.selfAndAllChildren)([
                root
            ], false);
            // only bpmndi:Shape and bpmndi:Edge can be direct children of bpmndi:Plane
            elements = (0, _minDash.filter)(elements, function(element) {
                return element !== root && !element.labelTarget;
            });
            diElements = (0, _minDash.map)(elements, (0, _modelUtil.getDi));
            rootDi.set('planeElement', diElements);
        });
    }
}
BpmnDiOrdering.$inject = [
    'eventBus',
    'canvas'
];

},{"../../util/ModelUtil":"klNYN","min-dash":"aEEla","diagram-js/lib/util/Elements":"6qdtl","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lRVIb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _translate = require("diagram-js/lib/i18n/translate");
var _translateDefault = parcelHelpers.interopDefault(_translate);
var _bpmnOrderingProvider = require("./BpmnOrderingProvider");
var _bpmnOrderingProviderDefault = parcelHelpers.interopDefault(_bpmnOrderingProvider);
exports.default = {
    __depends__: [
        (0, _translateDefault.default)
    ],
    __init__: [
        'bpmnOrderingProvider'
    ],
    bpmnOrderingProvider: [
        'type',
        (0, _bpmnOrderingProviderDefault.default)
    ]
};

},{"diagram-js/lib/i18n/translate":"lgOY2","./BpmnOrderingProvider":"eL5uX","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eL5uX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BpmnOrderingProvider);
var _inheritsBrowser = require("inherits-browser");
var _inheritsBrowserDefault = parcelHelpers.interopDefault(_inheritsBrowser);
var _orderingProvider = require("diagram-js/lib/features/ordering/OrderingProvider");
var _orderingProviderDefault = parcelHelpers.interopDefault(_orderingProvider);
var _modelingUtil = require("../modeling/util/ModelingUtil");
var _minDash = require("min-dash");
function BpmnOrderingProvider(eventBus, canvas, translate) {
    (0, _orderingProviderDefault.default).call(this, eventBus);
    var orders = [
        {
            type: 'bpmn:SubProcess',
            order: {
                level: 6
            }
        },
        // handle SequenceFlow(s) like message flows and render them always on top
        {
            type: 'bpmn:SequenceFlow',
            order: {
                level: 9,
                containers: [
                    'bpmn:Participant',
                    'bpmn:FlowElementsContainer'
                ]
            }
        },
        // handle DataAssociation(s) like message flows and render them always on top
        {
            type: 'bpmn:DataAssociation',
            order: {
                level: 9,
                containers: [
                    'bpmn:Collaboration',
                    'bpmn:FlowElementsContainer'
                ]
            }
        },
        {
            type: 'bpmn:MessageFlow',
            order: {
                level: 9,
                containers: [
                    'bpmn:Collaboration'
                ]
            }
        },
        {
            type: 'bpmn:Association',
            order: {
                level: 6,
                containers: [
                    'bpmn:Participant',
                    'bpmn:FlowElementsContainer',
                    'bpmn:Collaboration'
                ]
            }
        },
        {
            type: 'bpmn:BoundaryEvent',
            order: {
                level: 8
            }
        },
        {
            type: 'bpmn:Group',
            order: {
                level: 10,
                containers: [
                    'bpmn:Collaboration',
                    'bpmn:FlowElementsContainer'
                ]
            }
        },
        {
            type: 'bpmn:FlowElement',
            order: {
                level: 5
            }
        },
        {
            type: 'bpmn:Participant',
            order: {
                level: -2
            }
        },
        {
            type: 'bpmn:Lane',
            order: {
                level: -1
            }
        }
    ];
    function computeOrder(element) {
        if (element.labelTarget) return {
            level: 10
        };
        var entry = (0, _minDash.find)(orders, function(o) {
            return (0, _modelingUtil.isAny)(element, [
                o.type
            ]);
        });
        return entry && entry.order || {
            level: 1
        };
    }
    function getOrder(element) {
        var order = element.order;
        if (!order) element.order = order = computeOrder(element);
        if (!order) throw new Error('no order for <' + element.id + '>');
        return order;
    }
    function findActualParent(element, newParent, containers) {
        var actualParent = newParent;
        while(actualParent){
            if ((0, _modelingUtil.isAny)(actualParent, containers)) break;
            actualParent = actualParent.parent;
        }
        if (!actualParent) throw new Error('no parent for <' + element.id + '> in <' + (newParent && newParent.id) + '>');
        return actualParent;
    }
    this.getOrdering = function(element, newParent) {
        // render labels always on top
        if (element.labelTarget) return {
            parent: canvas.findRoot(newParent) || canvas.getRootElement(),
            index: -1
        };
        var elementOrder = getOrder(element);
        if (elementOrder.containers) newParent = findActualParent(element, newParent, elementOrder.containers);
        var currentIndex = newParent.children.indexOf(element);
        var insertIndex = (0, _minDash.findIndex)(newParent.children, function(child) {
            // do not compare with labels, they are created
            // in the wrong order (right after elements) during import and
            // mess up the positioning.
            if (!element.labelTarget && child.labelTarget) return false;
            return elementOrder.level < getOrder(child).level;
        });
        // if the element is already in the child list at
        // a smaller index, we need to adjust the insert index.
        // this takes into account that the element is being removed
        // before being re-inserted
        if (insertIndex !== -1) {
            if (currentIndex !== -1 && currentIndex < insertIndex) insertIndex -= 1;
        }
        return {
            index: insertIndex,
            parent: newParent
        };
    };
}
BpmnOrderingProvider.$inject = [
    'eventBus',
    'canvas',
    'translate'
];
(0, _inheritsBrowserDefault.default)(BpmnOrderingProvider, (0, _orderingProviderDefault.default));

},{"inherits-browser":"hymxq","diagram-js/lib/features/ordering/OrderingProvider":"dcAML","../modeling/util/ModelingUtil":"4DR1e","min-dash":"aEEla","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dcAML":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>OrderingProvider);
var _inheritsBrowser = require("inherits-browser");
var _inheritsBrowserDefault = parcelHelpers.interopDefault(_inheritsBrowser);
var _commandInterceptor = require("../../command/CommandInterceptor");
var _commandInterceptorDefault = parcelHelpers.interopDefault(_commandInterceptor);
function OrderingProvider(eventBus) {
    (0, _commandInterceptorDefault.default).call(this, eventBus);
    var self = this;
    this.preExecute([
        'shape.create',
        'connection.create'
    ], function(event) {
        var context = event.context, element = context.shape || context.connection, parent = context.parent;
        var ordering = self.getOrdering(element, parent);
        if (ordering) {
            if (ordering.parent !== undefined) context.parent = ordering.parent;
            context.parentIndex = ordering.index;
        }
    });
    this.preExecute([
        'shape.move',
        'connection.move'
    ], function(event) {
        var context = event.context, element = context.shape || context.connection, parent = context.newParent || element.parent;
        var ordering = self.getOrdering(element, parent);
        if (ordering) {
            if (ordering.parent !== undefined) context.newParent = ordering.parent;
            context.newParentIndex = ordering.index;
        }
    });
}
/**
 * Return a custom ordering of the element, both in terms
 * of parent element and index in the new parent.
 *
 * Implementors of this method must return an object with
 * `parent` _and_ `index` in it.
 *
 * @param {Base} element
 * @param {Shape} newParent
 *
 * @return {Object} ordering descriptor
 */ OrderingProvider.prototype.getOrdering = function(element, newParent) {
    return null;
};
(0, _inheritsBrowserDefault.default)(OrderingProvider, (0, _commandInterceptorDefault.default));

},{"inherits-browser":"hymxq","../../command/CommandInterceptor":"1K1IQ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lQ7gB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _spaceTool = require("diagram-js/lib/features/space-tool");
var _spaceToolDefault = parcelHelpers.interopDefault(_spaceTool);
var _bpmnSpaceTool = require("./BpmnSpaceTool");
var _bpmnSpaceToolDefault = parcelHelpers.interopDefault(_bpmnSpaceTool);
exports.default = {
    __depends__: [
        (0, _spaceToolDefault.default)
    ],
    spaceTool: [
        'type',
        (0, _bpmnSpaceToolDefault.default)
    ]
};

},{"diagram-js/lib/features/space-tool":"5n6b5","./BpmnSpaceTool":"7w8Gh","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5n6b5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _dragging = require("../dragging");
var _draggingDefault = parcelHelpers.interopDefault(_dragging);
var _rules = require("../rules");
var _rulesDefault = parcelHelpers.interopDefault(_rules);
var _toolManager = require("../tool-manager");
var _toolManagerDefault = parcelHelpers.interopDefault(_toolManager);
var _previewSupport = require("../preview-support");
var _previewSupportDefault = parcelHelpers.interopDefault(_previewSupport);
var _mouse = require("../mouse");
var _mouseDefault = parcelHelpers.interopDefault(_mouse);
var _spaceTool = require("./SpaceTool");
var _spaceToolDefault = parcelHelpers.interopDefault(_spaceTool);
var _spaceToolPreview = require("./SpaceToolPreview");
var _spaceToolPreviewDefault = parcelHelpers.interopDefault(_spaceToolPreview);
exports.default = {
    __init__: [
        'spaceToolPreview'
    ],
    __depends__: [
        (0, _draggingDefault.default),
        (0, _rulesDefault.default),
        (0, _toolManagerDefault.default),
        (0, _previewSupportDefault.default),
        (0, _mouseDefault.default)
    ],
    spaceTool: [
        'type',
        (0, _spaceToolDefault.default)
    ],
    spaceToolPreview: [
        'type',
        (0, _spaceToolPreviewDefault.default)
    ]
};

},{"../dragging":"2U3QS","../rules":"5xj5a","../tool-manager":"i6JA7","../preview-support":"fEfos","../mouse":"ajwMh","./SpaceTool":"iltcx","./SpaceToolPreview":"2Pcuz","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"i6JA7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _dragging = require("../dragging");
var _draggingDefault = parcelHelpers.interopDefault(_dragging);
var _toolManager = require("./ToolManager");
var _toolManagerDefault = parcelHelpers.interopDefault(_toolManager);
exports.default = {
    __depends__: [
        (0, _draggingDefault.default)
    ],
    __init__: [
        'toolManager'
    ],
    toolManager: [
        'type',
        (0, _toolManagerDefault.default)
    ]
};

},{"../dragging":"2U3QS","./ToolManager":"8Zms8","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8Zms8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ToolManager);
var _minDash = require("min-dash");
var _minDom = require("min-dom");
/**
 * @typedef {import('../dragging/Dragging').default} Dragging
 * @typedef {import('../../core/EventBus').default} EventBus
 */ var LOW_PRIORITY = 250;
function ToolManager(eventBus, dragging) {
    this._eventBus = eventBus;
    this._dragging = dragging;
    this._tools = [];
    this._active = null;
}
ToolManager.$inject = [
    'eventBus',
    'dragging'
];
ToolManager.prototype.registerTool = function(name, events) {
    var tools = this._tools;
    if (!events) throw new Error('A tool has to be registered with it\'s "events"');
    tools.push(name);
    this.bindEvents(name, events);
};
ToolManager.prototype.isActive = function(tool) {
    return tool && this._active === tool;
};
ToolManager.prototype.length = function(tool) {
    return this._tools.length;
};
ToolManager.prototype.setActive = function(tool) {
    var eventBus = this._eventBus;
    if (this._active !== tool) {
        this._active = tool;
        eventBus.fire('tool-manager.update', {
            tool: tool
        });
    }
};
ToolManager.prototype.bindEvents = function(name, events) {
    var eventBus = this._eventBus, dragging = this._dragging;
    var eventsToRegister = [];
    eventBus.on(events.tool + '.init', function(event) {
        var context = event.context;
        // Active tools that want to reactivate themselves must do this explicitly
        if (!context.reactivate && this.isActive(name)) {
            this.setActive(null);
            dragging.cancel();
            return;
        }
        this.setActive(name);
    }, this);
    // Todo[ricardo]: add test cases
    (0, _minDash.forEach)(events, function(event) {
        eventsToRegister.push(event + '.ended');
        eventsToRegister.push(event + '.canceled');
    });
    eventBus.on(eventsToRegister, LOW_PRIORITY, function(event) {
        // We defer the de-activation of the tool to the .activate phase,
        // so we're able to check if we want to toggle off the current
        // active tool or switch to a new one
        if (!this._active) return;
        if (isPaletteClick(event)) return;
        this.setActive(null);
    }, this);
};
// helpers ///////////////
/**
 * Check if a given event is a palette click event.
 *
 * @param {EventBus.Event} event
 *
 * @return {boolean}
 */ function isPaletteClick(event) {
    var target = event.originalEvent && event.originalEvent.target;
    return target && (0, _minDom.closest)(target, '.group[data-group="tools"]');
}

},{"min-dash":"aEEla","min-dom":"e58GC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iltcx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SpaceTool);
var _minDash = require("min-dash");
var _layoutUtil = require("../../layout/LayoutUtil");
var _elements = require("../../util/Elements");
var _spaceUtil = require("./SpaceUtil");
var _mouse = require("../../util/Mouse");
var _cursor = require("../../util/Cursor");
/**
 * @typedef {import('../../model').Shape} Shape
 *
 * @typedef {import('../../core/Canvas').default} Canvas
 * @typedef {import('../dragging/Dragging').default} Dragging
 * @typedef {import('../../core/EventBus').default} EventBus
 * @typedef {import('../modeling/Modeling').default} Modeling
 * @typedef {import('../mouse/Mouse').default} Mouse
 * @typedef {import('../rules/Rules').default} Rules
 * @typedef {import('../tool-manager/ToolManager').default} ToolManager
 */ var abs = Math.abs, round = Math.round;
var AXIS_TO_DIMENSION = {
    x: 'width',
    y: 'height'
};
var CURSOR_CROSSHAIR = 'crosshair';
var DIRECTION_TO_TRBL = {
    n: 'top',
    w: 'left',
    s: 'bottom',
    e: 'right'
};
var HIGH_PRIORITY = 1500;
var DIRECTION_TO_OPPOSITE = {
    n: 's',
    w: 'e',
    s: 'n',
    e: 'w'
};
var PADDING = 20;
function SpaceTool(canvas, dragging, eventBus, modeling, rules, toolManager, mouse) {
    this._canvas = canvas;
    this._dragging = dragging;
    this._eventBus = eventBus;
    this._modeling = modeling;
    this._rules = rules;
    this._toolManager = toolManager;
    this._mouse = mouse;
    var self = this;
    toolManager.registerTool('space', {
        tool: 'spaceTool.selection',
        dragging: 'spaceTool'
    });
    eventBus.on('spaceTool.selection.end', function(event) {
        eventBus.once('spaceTool.selection.ended', function() {
            self.activateMakeSpace(event.originalEvent);
        });
    });
    eventBus.on('spaceTool.move', HIGH_PRIORITY, function(event) {
        var context = event.context, initialized = context.initialized;
        if (!initialized) initialized = context.initialized = self.init(event, context);
        if (initialized) ensureConstraints(event);
    });
    eventBus.on('spaceTool.end', function(event) {
        var context = event.context, axis = context.axis, direction = context.direction, movingShapes = context.movingShapes, resizingShapes = context.resizingShapes, start = context.start;
        if (!context.initialized) return;
        ensureConstraints(event);
        var delta = {
            x: 0,
            y: 0
        };
        delta[axis] = round(event['d' + axis]);
        self.makeSpace(movingShapes, resizingShapes, delta, direction, start);
        eventBus.once('spaceTool.ended', function(event) {
            // activate space tool selection after make space
            self.activateSelection(event.originalEvent, true, true);
        });
    });
}
SpaceTool.$inject = [
    'canvas',
    'dragging',
    'eventBus',
    'modeling',
    'rules',
    'toolManager',
    'mouse'
];
/**
 * Activate space tool selection.
 *
 * @param {Object} event
 * @param {boolean} autoActivate
 */ SpaceTool.prototype.activateSelection = function(event, autoActivate, reactivate) {
    this._dragging.init(event, 'spaceTool.selection', {
        autoActivate: autoActivate,
        cursor: CURSOR_CROSSHAIR,
        data: {
            context: {
                reactivate: reactivate
            }
        },
        trapClick: false
    });
};
/**
 * Activate space tool make space.
 *
 * @param {MouseEvent|TouchEvent} event
 */ SpaceTool.prototype.activateMakeSpace = function(event) {
    this._dragging.init(event, 'spaceTool', {
        autoActivate: true,
        cursor: CURSOR_CROSSHAIR,
        data: {
            context: {}
        }
    });
};
/**
 * Make space.
 *
 * @param {Array<Shape>} movingShapes
 * @param {Array<Shape>} resizingShapes
 * @param {Object} delta
 * @param {number} delta.x
 * @param {number} delta.y
 * @param {string} direction
 * @param {number} start
 */ SpaceTool.prototype.makeSpace = function(movingShapes, resizingShapes, delta, direction, start) {
    return this._modeling.createSpace(movingShapes, resizingShapes, delta, direction, start);
};
/**
 * Initialize make space and return true if that was successful.
 *
 * @param {Object} event
 * @param {Object} context
 *
 * @return {boolean}
 */ SpaceTool.prototype.init = function(event, context) {
    var axis = abs(event.dx) > abs(event.dy) ? 'x' : 'y', delta = event['d' + axis], start = event[axis] - delta;
    if (abs(delta) < 5) return false;
    // invert delta to remove space when moving left
    if (delta < 0) delta *= -1;
    // invert delta to add/remove space when removing/adding space if modifier key is pressed
    if ((0, _mouse.hasPrimaryModifier)(event)) delta *= -1;
    var direction = (0, _spaceUtil.getDirection)(axis, delta);
    var root = this._canvas.getRootElement();
    var children = (0, _elements.selfAndAllChildren)(root, true);
    var elements = this.calculateAdjustments(children, axis, delta, start);
    var minDimensions = this._eventBus.fire('spaceTool.getMinDimensions', {
        axis: axis,
        direction: direction,
        shapes: elements.resizingShapes,
        start: start
    });
    var spaceToolConstraints = getSpaceToolConstraints(elements, axis, direction, start, minDimensions);
    (0, _minDash.assign)(context, elements, {
        axis: axis,
        direction: direction,
        spaceToolConstraints: spaceToolConstraints,
        start: start
    });
    (0, _cursor.set)('resize-' + (axis === 'x' ? 'ew' : 'ns'));
    return true;
};
/**
 * Get elements to be moved and resized.
 *
 * @param {Array<Shape>} elements
 * @param {string} axis
 * @param {number} delta
 * @param {number} start
 *
 * @return {Object}
 */ SpaceTool.prototype.calculateAdjustments = function(elements, axis, delta, start) {
    var rules = this._rules;
    var movingShapes = [], resizingShapes = [];
    var attachers = [], connections = [];
    function moveShape(shape) {
        if (!movingShapes.includes(shape)) movingShapes.push(shape);
        var label = shape.label;
        // move external label if its label target is moving
        if (label && !movingShapes.includes(label)) movingShapes.push(label);
    }
    function resizeShape(shape) {
        if (!resizingShapes.includes(shape)) resizingShapes.push(shape);
    }
    (0, _minDash.forEach)(elements, function(element) {
        if (!element.parent || isLabel(element)) return;
        // handle connections separately
        if (isConnection(element)) {
            connections.push(element);
            return;
        }
        var shapeStart = element[axis], shapeEnd = shapeStart + element[AXIS_TO_DIMENSION[axis]];
        // handle attachers separately
        if (isAttacher(element) && (delta > 0 && (0, _layoutUtil.getMid)(element)[axis] > start || delta < 0 && (0, _layoutUtil.getMid)(element)[axis] < start)) {
            attachers.push(element);
            return;
        }
        // move shape if its start is after space tool
        if (delta > 0 && shapeStart > start || delta < 0 && shapeEnd < start) {
            moveShape(element);
            return;
        }
        // resize shape if it's resizable and its start is before and its end is after space tool
        if (shapeStart < start && shapeEnd > start && rules.allowed('shape.resize', {
            shape: element
        })) {
            resizeShape(element);
            return;
        }
    });
    // move attacher if its host is moving
    (0, _minDash.forEach)(movingShapes, function(shape) {
        var attachers = shape.attachers;
        if (attachers) (0, _minDash.forEach)(attachers, function(attacher) {
            moveShape(attacher);
        });
    });
    var allShapes = movingShapes.concat(resizingShapes);
    // move attacher if its mid is after space tool and its host is moving or resizing
    (0, _minDash.forEach)(attachers, function(attacher) {
        var host = attacher.host;
        if (includes(allShapes, host)) moveShape(attacher);
    });
    allShapes = movingShapes.concat(resizingShapes);
    // move external label if its label target's (connection) source and target are moving
    (0, _minDash.forEach)(connections, function(connection) {
        var source = connection.source, target = connection.target, label = connection.label;
        if (includes(allShapes, source) && includes(allShapes, target) && label) moveShape(label);
    });
    return {
        movingShapes: movingShapes,
        resizingShapes: resizingShapes
    };
};
SpaceTool.prototype.toggle = function() {
    if (this.isActive()) return this._dragging.cancel();
    var mouseEvent = this._mouse.getLastMoveEvent();
    this.activateSelection(mouseEvent, !!mouseEvent);
};
SpaceTool.prototype.isActive = function() {
    var context = this._dragging.context();
    if (context) return /^spaceTool/.test(context.prefix);
    return false;
};
// helpers //////////
function addPadding(trbl) {
    return {
        top: trbl.top - PADDING,
        right: trbl.right + PADDING,
        bottom: trbl.bottom + PADDING,
        left: trbl.left - PADDING
    };
}
function ensureConstraints(event) {
    var context = event.context, spaceToolConstraints = context.spaceToolConstraints;
    if (!spaceToolConstraints) return;
    var x, y;
    if ((0, _minDash.isNumber)(spaceToolConstraints.left)) {
        x = Math.max(event.x, spaceToolConstraints.left);
        event.dx = event.dx + x - event.x;
        event.x = x;
    }
    if ((0, _minDash.isNumber)(spaceToolConstraints.right)) {
        x = Math.min(event.x, spaceToolConstraints.right);
        event.dx = event.dx + x - event.x;
        event.x = x;
    }
    if ((0, _minDash.isNumber)(spaceToolConstraints.top)) {
        y = Math.max(event.y, spaceToolConstraints.top);
        event.dy = event.dy + y - event.y;
        event.y = y;
    }
    if ((0, _minDash.isNumber)(spaceToolConstraints.bottom)) {
        y = Math.min(event.y, spaceToolConstraints.bottom);
        event.dy = event.dy + y - event.y;
        event.y = y;
    }
}
function getSpaceToolConstraints(elements, axis, direction, start, minDimensions) {
    var movingShapes = elements.movingShapes, resizingShapes = elements.resizingShapes;
    if (!resizingShapes.length) return;
    var spaceToolConstraints = {}, min, max;
    (0, _minDash.forEach)(resizingShapes, function(resizingShape) {
        var attachers = resizingShape.attachers, children = resizingShape.children;
        var resizingShapeBBox = (0, _layoutUtil.asTRBL)(resizingShape);
        // find children that are not moving or resizing
        var nonMovingResizingChildren = (0, _minDash.filter)(children, function(child) {
            return !isConnection(child) && !isLabel(child) && !includes(movingShapes, child) && !includes(resizingShapes, child);
        });
        // find children that are moving
        var movingChildren = (0, _minDash.filter)(children, function(child) {
            return !isConnection(child) && !isLabel(child) && includes(movingShapes, child);
        });
        var minOrMax, nonMovingResizingChildrenBBox, movingChildrenBBox, movingAttachers = [], nonMovingAttachers = [], movingAttachersBBox, movingAttachersConstraint, nonMovingAttachersBBox, nonMovingAttachersConstraint;
        if (nonMovingResizingChildren.length) {
            nonMovingResizingChildrenBBox = addPadding((0, _layoutUtil.asTRBL)((0, _elements.getBBox)(nonMovingResizingChildren)));
            minOrMax = start - resizingShapeBBox[DIRECTION_TO_TRBL[direction]] + nonMovingResizingChildrenBBox[DIRECTION_TO_TRBL[direction]];
            if (direction === 'n') spaceToolConstraints.bottom = max = (0, _minDash.isNumber)(max) ? Math.min(max, minOrMax) : minOrMax;
            else if (direction === 'w') spaceToolConstraints.right = max = (0, _minDash.isNumber)(max) ? Math.min(max, minOrMax) : minOrMax;
            else if (direction === 's') spaceToolConstraints.top = min = (0, _minDash.isNumber)(min) ? Math.max(min, minOrMax) : minOrMax;
            else if (direction === 'e') spaceToolConstraints.left = min = (0, _minDash.isNumber)(min) ? Math.max(min, minOrMax) : minOrMax;
        }
        if (movingChildren.length) {
            movingChildrenBBox = addPadding((0, _layoutUtil.asTRBL)((0, _elements.getBBox)(movingChildren)));
            minOrMax = start - movingChildrenBBox[DIRECTION_TO_TRBL[DIRECTION_TO_OPPOSITE[direction]]] + resizingShapeBBox[DIRECTION_TO_TRBL[DIRECTION_TO_OPPOSITE[direction]]];
            if (direction === 'n') spaceToolConstraints.bottom = max = (0, _minDash.isNumber)(max) ? Math.min(max, minOrMax) : minOrMax;
            else if (direction === 'w') spaceToolConstraints.right = max = (0, _minDash.isNumber)(max) ? Math.min(max, minOrMax) : minOrMax;
            else if (direction === 's') spaceToolConstraints.top = min = (0, _minDash.isNumber)(min) ? Math.max(min, minOrMax) : minOrMax;
            else if (direction === 'e') spaceToolConstraints.left = min = (0, _minDash.isNumber)(min) ? Math.max(min, minOrMax) : minOrMax;
        }
        if (attachers && attachers.length) {
            attachers.forEach(function(attacher) {
                if (includes(movingShapes, attacher)) movingAttachers.push(attacher);
                else nonMovingAttachers.push(attacher);
            });
            if (movingAttachers.length) {
                movingAttachersBBox = (0, _layoutUtil.asTRBL)((0, _elements.getBBox)(movingAttachers.map((0, _layoutUtil.getMid))));
                movingAttachersConstraint = resizingShapeBBox[DIRECTION_TO_TRBL[DIRECTION_TO_OPPOSITE[direction]]] - (movingAttachersBBox[DIRECTION_TO_TRBL[DIRECTION_TO_OPPOSITE[direction]]] - start);
            }
            if (nonMovingAttachers.length) {
                nonMovingAttachersBBox = (0, _layoutUtil.asTRBL)((0, _elements.getBBox)(nonMovingAttachers.map((0, _layoutUtil.getMid))));
                nonMovingAttachersConstraint = nonMovingAttachersBBox[DIRECTION_TO_TRBL[direction]] - (resizingShapeBBox[DIRECTION_TO_TRBL[direction]] - start);
            }
            if (direction === 'n') {
                minOrMax = Math.min(movingAttachersConstraint || Infinity, nonMovingAttachersConstraint || Infinity);
                spaceToolConstraints.bottom = max = (0, _minDash.isNumber)(max) ? Math.min(max, minOrMax) : minOrMax;
            } else if (direction === 'w') {
                minOrMax = Math.min(movingAttachersConstraint || Infinity, nonMovingAttachersConstraint || Infinity);
                spaceToolConstraints.right = max = (0, _minDash.isNumber)(max) ? Math.min(max, minOrMax) : minOrMax;
            } else if (direction === 's') {
                minOrMax = Math.max(movingAttachersConstraint || -Infinity, nonMovingAttachersConstraint || -Infinity);
                spaceToolConstraints.top = min = (0, _minDash.isNumber)(min) ? Math.max(min, minOrMax) : minOrMax;
            } else if (direction === 'e') {
                minOrMax = Math.max(movingAttachersConstraint || -Infinity, nonMovingAttachersConstraint || -Infinity);
                spaceToolConstraints.left = min = (0, _minDash.isNumber)(min) ? Math.max(min, minOrMax) : minOrMax;
            }
        }
        var resizingShapeMinDimensions = minDimensions && minDimensions[resizingShape.id];
        if (resizingShapeMinDimensions) {
            if (direction === 'n') {
                minOrMax = start + resizingShape[AXIS_TO_DIMENSION[axis]] - resizingShapeMinDimensions[AXIS_TO_DIMENSION[axis]];
                spaceToolConstraints.bottom = max = (0, _minDash.isNumber)(max) ? Math.min(max, minOrMax) : minOrMax;
            } else if (direction === 'w') {
                minOrMax = start + resizingShape[AXIS_TO_DIMENSION[axis]] - resizingShapeMinDimensions[AXIS_TO_DIMENSION[axis]];
                spaceToolConstraints.right = max = (0, _minDash.isNumber)(max) ? Math.min(max, minOrMax) : minOrMax;
            } else if (direction === 's') {
                minOrMax = start - resizingShape[AXIS_TO_DIMENSION[axis]] + resizingShapeMinDimensions[AXIS_TO_DIMENSION[axis]];
                spaceToolConstraints.top = min = (0, _minDash.isNumber)(min) ? Math.max(min, minOrMax) : minOrMax;
            } else if (direction === 'e') {
                minOrMax = start - resizingShape[AXIS_TO_DIMENSION[axis]] + resizingShapeMinDimensions[AXIS_TO_DIMENSION[axis]];
                spaceToolConstraints.left = min = (0, _minDash.isNumber)(min) ? Math.max(min, minOrMax) : minOrMax;
            }
        }
    });
    return spaceToolConstraints;
}
function includes(array, item) {
    return array.indexOf(item) !== -1;
}
function isAttacher(element) {
    return !!element.host;
}
function isConnection(element) {
    return !!element.waypoints;
}
function isLabel(element) {
    return !!element.labelTarget;
}

},{"min-dash":"aEEla","../../layout/LayoutUtil":"4CCrs","../../util/Elements":"6qdtl","./SpaceUtil":"c2aHY","../../util/Mouse":"9MyMy","../../util/Cursor":"258yd","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"c2aHY":[function(require,module,exports,__globalThis) {
/**
 * @typedef {import('../../model').Connection} Connection
 * @typedef {import('../../model').Shape} Shape
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Return direction given axis and delta.
 *
 * @param {string} axis
 * @param {number} delta
 *
 * @return {string}
 */ parcelHelpers.export(exports, "getDirection", ()=>getDirection);
/**
 * Returns connections whose waypoints are to be updated. Waypoints are to be updated if start
 * or end is to be moved or resized.
 *
 * @param {Array<Shape} movingShapes
 * @param {Array<Shape} resizingShapes
 *
 * @returns {Array<Connection>}
 */ parcelHelpers.export(exports, "getWaypointsUpdatingConnections", ()=>getWaypointsUpdatingConnections);
/**
 * Resize bounds.
 *
 * @param {Object} bounds
 * @param {number} bounds.x
 * @param {number} bounds.y
 * @param {number} bounds.width
 * @param {number} bounds.height
 * @param {string} direction
 * @param {Object} delta
 * @param {number} delta.x
 * @param {number} delta.y
 *
 * @return {Object}
 */ parcelHelpers.export(exports, "resizeBounds", ()=>resizeBounds);
var _minDash = require("min-dash");
function getDirection(axis, delta) {
    if (axis === 'x') {
        if (delta > 0) return 'e';
        if (delta < 0) return 'w';
    }
    if (axis === 'y') {
        if (delta > 0) return 's';
        if (delta < 0) return 'n';
    }
    return null;
}
function getWaypointsUpdatingConnections(movingShapes, resizingShapes) {
    var waypointsUpdatingConnections = [];
    (0, _minDash.forEach)(movingShapes.concat(resizingShapes), function(shape) {
        var incoming = shape.incoming, outgoing = shape.outgoing;
        (0, _minDash.forEach)(incoming.concat(outgoing), function(connection) {
            var source = connection.source, target = connection.target;
            if (includes(movingShapes, source) || includes(movingShapes, target) || includes(resizingShapes, source) || includes(resizingShapes, target)) {
                if (!includes(waypointsUpdatingConnections, connection)) waypointsUpdatingConnections.push(connection);
            }
        });
    });
    return waypointsUpdatingConnections;
}
function includes(array, item) {
    return array.indexOf(item) !== -1;
}
function resizeBounds(bounds, direction, delta) {
    var x = bounds.x, y = bounds.y, width = bounds.width, height = bounds.height, dx = delta.x, dy = delta.y;
    switch(direction){
        case 'n':
            return {
                x: x,
                y: y + dy,
                width: width,
                height: height - dy
            };
        case 's':
            return {
                x: x,
                y: y,
                width: width,
                height: height + dy
            };
        case 'w':
            return {
                x: x + dx,
                y: y,
                width: width - dx,
                height: height
            };
        case 'e':
            return {
                x: x,
                y: y,
                width: width + dx,
                height: height
            };
        default:
            throw new Error('unknown direction: ' + direction);
    }
}

},{"min-dash":"aEEla","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2Pcuz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SpaceToolPreview);
var _minDash = require("min-dash");
var _tinySvg = require("tiny-svg");
var _svgTransformUtil = require("../../util/SvgTransformUtil");
var MARKER_DRAGGING = 'djs-dragging', MARKER_RESIZING = 'djs-resizing';
var LOW_PRIORITY = 250;
/**
 * @typedef {import('../../core/Canvas').default} Canvas
 * @typedef {import('../../core/ElementRegistry').default} ElementRegistry
 * @typedef {import('../../core/EventBus').default} EventBus
 * @typedef {import('../../draw/Styles').default} Styles
 */ var max = Math.max;
function SpaceToolPreview(eventBus, elementRegistry, canvas, styles, previewSupport) {
    function addPreviewGfx(collection, dragGroup) {
        (0, _minDash.forEach)(collection, function(element) {
            previewSupport.addDragger(element, dragGroup);
            canvas.addMarker(element, MARKER_DRAGGING);
        });
    }
    // add crosshair
    eventBus.on('spaceTool.selection.start', function(event) {
        var space = canvas.getLayer('space'), context = event.context;
        var orientation = {
            x: 'M 0,-10000 L 0,10000',
            y: 'M -10000,0 L 10000,0'
        };
        var crosshairGroup = (0, _tinySvg.create)('g');
        (0, _tinySvg.attr)(crosshairGroup, styles.cls('djs-crosshair-group', [
            'no-events'
        ]));
        (0, _tinySvg.append)(space, crosshairGroup);
        // horizontal path
        var pathX = (0, _tinySvg.create)('path');
        (0, _tinySvg.attr)(pathX, 'd', orientation.x);
        (0, _tinySvg.classes)(pathX).add('djs-crosshair');
        (0, _tinySvg.append)(crosshairGroup, pathX);
        // vertical path
        var pathY = (0, _tinySvg.create)('path');
        (0, _tinySvg.attr)(pathY, 'd', orientation.y);
        (0, _tinySvg.classes)(pathY).add('djs-crosshair');
        (0, _tinySvg.append)(crosshairGroup, pathY);
        context.crosshairGroup = crosshairGroup;
    });
    // update crosshair
    eventBus.on('spaceTool.selection.move', function(event) {
        var crosshairGroup = event.context.crosshairGroup;
        (0, _svgTransformUtil.translate)(crosshairGroup, event.x, event.y);
    });
    // remove crosshair
    eventBus.on('spaceTool.selection.cleanup', function(event) {
        var context = event.context, crosshairGroup = context.crosshairGroup;
        if (crosshairGroup) (0, _tinySvg.remove)(crosshairGroup);
    });
    // add and update move/resize previews
    eventBus.on('spaceTool.move', LOW_PRIORITY, function(event) {
        var context = event.context, line = context.line, axis = context.axis, movingShapes = context.movingShapes, resizingShapes = context.resizingShapes;
        if (!context.initialized) return;
        if (!context.dragGroup) {
            var spaceLayer = canvas.getLayer('space');
            line = (0, _tinySvg.create)('path');
            (0, _tinySvg.attr)(line, 'd', 'M0,0 L0,0');
            (0, _tinySvg.classes)(line).add('djs-crosshair');
            (0, _tinySvg.append)(spaceLayer, line);
            context.line = line;
            var dragGroup = (0, _tinySvg.create)('g');
            (0, _tinySvg.attr)(dragGroup, styles.cls('djs-drag-group', [
                'no-events'
            ]));
            (0, _tinySvg.append)(canvas.getActiveLayer(), dragGroup);
            // shapes
            addPreviewGfx(movingShapes, dragGroup);
            // connections
            var movingConnections = context.movingConnections = elementRegistry.filter(function(element) {
                var sourceIsMoving = false;
                (0, _minDash.forEach)(movingShapes, function(shape) {
                    (0, _minDash.forEach)(shape.outgoing, function(connection) {
                        if (element === connection) sourceIsMoving = true;
                    });
                });
                var targetIsMoving = false;
                (0, _minDash.forEach)(movingShapes, function(shape) {
                    (0, _minDash.forEach)(shape.incoming, function(connection) {
                        if (element === connection) targetIsMoving = true;
                    });
                });
                var sourceIsResizing = false;
                (0, _minDash.forEach)(resizingShapes, function(shape) {
                    (0, _minDash.forEach)(shape.outgoing, function(connection) {
                        if (element === connection) sourceIsResizing = true;
                    });
                });
                var targetIsResizing = false;
                (0, _minDash.forEach)(resizingShapes, function(shape) {
                    (0, _minDash.forEach)(shape.incoming, function(connection) {
                        if (element === connection) targetIsResizing = true;
                    });
                });
                return isConnection(element) && (sourceIsMoving || sourceIsResizing) && (targetIsMoving || targetIsResizing);
            });
            addPreviewGfx(movingConnections, dragGroup);
            context.dragGroup = dragGroup;
        }
        if (!context.frameGroup) {
            var frameGroup = (0, _tinySvg.create)('g');
            (0, _tinySvg.attr)(frameGroup, styles.cls('djs-frame-group', [
                'no-events'
            ]));
            (0, _tinySvg.append)(canvas.getActiveLayer(), frameGroup);
            var frames = [];
            (0, _minDash.forEach)(resizingShapes, function(shape) {
                var frame = previewSupport.addFrame(shape, frameGroup);
                var initialBounds = frame.getBBox();
                frames.push({
                    element: frame,
                    initialBounds: initialBounds
                });
                canvas.addMarker(shape, MARKER_RESIZING);
            });
            context.frameGroup = frameGroup;
            context.frames = frames;
        }
        var orientation = {
            x: 'M' + event.x + ', -10000 L' + event.x + ', 10000',
            y: 'M -10000, ' + event.y + ' L 10000, ' + event.y
        };
        (0, _tinySvg.attr)(line, {
            d: orientation[axis]
        });
        var opposite = {
            x: 'y',
            y: 'x'
        };
        var delta = {
            x: event.dx,
            y: event.dy
        };
        delta[opposite[context.axis]] = 0;
        // update move previews
        (0, _svgTransformUtil.translate)(context.dragGroup, delta.x, delta.y);
        // update resize previews
        (0, _minDash.forEach)(context.frames, function(frame) {
            var element = frame.element, initialBounds = frame.initialBounds, width, height;
            if (context.direction === 'e') (0, _tinySvg.attr)(element, {
                width: max(initialBounds.width + delta.x, 5)
            });
            else {
                width = max(initialBounds.width - delta.x, 5);
                (0, _tinySvg.attr)(element, {
                    width: width,
                    x: initialBounds.x + initialBounds.width - width
                });
            }
            if (context.direction === 's') (0, _tinySvg.attr)(element, {
                height: max(initialBounds.height + delta.y, 5)
            });
            else {
                height = max(initialBounds.height - delta.y, 5);
                (0, _tinySvg.attr)(element, {
                    height: height,
                    y: initialBounds.y + initialBounds.height - height
                });
            }
        });
    });
    // remove move/resize previews
    eventBus.on('spaceTool.cleanup', function(event) {
        var context = event.context, movingShapes = context.movingShapes, movingConnections = context.movingConnections, resizingShapes = context.resizingShapes, line = context.line, dragGroup = context.dragGroup, frameGroup = context.frameGroup;
        // moving shapes
        (0, _minDash.forEach)(movingShapes, function(shape) {
            canvas.removeMarker(shape, MARKER_DRAGGING);
        });
        // moving connections
        (0, _minDash.forEach)(movingConnections, function(connection) {
            canvas.removeMarker(connection, MARKER_DRAGGING);
        });
        if (dragGroup) {
            (0, _tinySvg.remove)(line);
            (0, _tinySvg.remove)(dragGroup);
        }
        (0, _minDash.forEach)(resizingShapes, function(shape) {
            canvas.removeMarker(shape, MARKER_RESIZING);
        });
        if (frameGroup) (0, _tinySvg.remove)(frameGroup);
    });
}
SpaceToolPreview.$inject = [
    'eventBus',
    'elementRegistry',
    'canvas',
    'styles',
    'previewSupport'
];
// helpers //////////////////////
/**
 * Checks if an element is a connection.
 */ function isConnection(element) {
    return element.waypoints;
}

},{"min-dash":"aEEla","tiny-svg":"6ZtXA","../../util/SvgTransformUtil":"g4Nbc","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7w8Gh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BpmnSpaceTool);
var _inheritsBrowser = require("inherits-browser");
var _inheritsBrowserDefault = parcelHelpers.interopDefault(_inheritsBrowser);
var _spaceTool = require("diagram-js/lib/features/space-tool/SpaceTool");
var _spaceToolDefault = parcelHelpers.interopDefault(_spaceTool);
var _modelUtil = require("../../util/ModelUtil");
function BpmnSpaceTool(injector) {
    injector.invoke((0, _spaceToolDefault.default), this);
}
BpmnSpaceTool.$inject = [
    'injector'
];
(0, _inheritsBrowserDefault.default)(BpmnSpaceTool, (0, _spaceToolDefault.default));
BpmnSpaceTool.prototype.calculateAdjustments = function(elements, axis, delta, start) {
    var adjustments = (0, _spaceToolDefault.default).prototype.calculateAdjustments.call(this, elements, axis, delta, start);
    // do not resize text annotations
    adjustments.resizingShapes = adjustments.resizingShapes.filter(function(shape) {
        return !(0, _modelUtil.is)(shape, 'bpmn:TextAnnotation');
    });
    return adjustments;
};

},{"inherits-browser":"hymxq","diagram-js/lib/features/space-tool/SpaceTool":"iltcx","../../util/ModelUtil":"klNYN","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hbqQl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _commandStack = require("./CommandStack");
var _commandStackDefault = parcelHelpers.interopDefault(_commandStack);
exports.default = {
    commandStack: [
        'type',
        (0, _commandStackDefault.default)
    ]
};

},{"./CommandStack":"exMiN","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"exMiN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CommandStack);
var _minDash = require("min-dash");
function CommandStack(eventBus, injector) {
    /**
   * A map of all registered command handlers.
   *
   * @type {CommandHandlerMap}
   */ this._handlerMap = {};
    /**
   * A stack containing all re/undoable actions on the diagram
   *
   * @type {CommandStackAction[]}
   */ this._stack = [];
    /**
   * The current index on the stack
   *
   * @type {number}
   */ this._stackIdx = -1;
    /**
   * Current active commandStack execution
   *
   * @type {CurrentExecution}
   */ this._currentExecution = {
        actions: [],
        dirty: [],
        trigger: null
    };
    /**
   * @type {Injector}
   */ this._injector = injector;
    /**
   * @type EventBus
   */ this._eventBus = eventBus;
    /**
   * @type { number }
   */ this._uid = 1;
    eventBus.on([
        'diagram.destroy',
        'diagram.clear'
    ], function() {
        this.clear(false);
    }, this);
}
CommandStack.$inject = [
    'eventBus',
    'injector'
];
/**
 * Execute a command.
 *
 * @param {string} command The command to execute.
 * @param {CommandContext} context The context with which to execute the command.
 */ CommandStack.prototype.execute = function(command, context) {
    if (!command) throw new Error('command required');
    this._currentExecution.trigger = 'execute';
    const action = {
        command: command,
        context: context
    };
    this._pushAction(action);
    this._internalExecute(action);
    this._popAction(action);
};
/**
 * Check whether a command can be executed.
 *
 * Implementors may hook into the mechanism on two ways:
 *
 *   * in event listeners:
 *
 *     Users may prevent the execution via an event listener.
 *     It must prevent the default action for `commandStack.(<command>.)canExecute` events.
 *
 *   * in command handlers:
 *
 *     If the method {@link CommandHandler#canExecute} is implemented in a handler
 *     it will be called to figure out whether the execution is allowed.
 *
 * @param {string} command The command to execute.
 * @param {CommandContext} context The context with which to execute the command.
 *
 * @return {boolean} Whether the command can be executed with the given context.
 */ CommandStack.prototype.canExecute = function(command, context) {
    const action = {
        command: command,
        context: context
    };
    const handler = this._getHandler(command);
    let result = this._fire(command, 'canExecute', action);
    // handler#canExecute will only be called if no listener
    // decided on a result already
    if (result === undefined) {
        if (!handler) return false;
        if (handler.canExecute) result = handler.canExecute(context);
    }
    return result;
};
/**
 * Clear the command stack, erasing all undo / redo history.
 *
 * @param {boolean} [emit=true] Whether to fire an event. Defaults to `true`.
 */ CommandStack.prototype.clear = function(emit) {
    this._stack.length = 0;
    this._stackIdx = -1;
    if (emit !== false) this._fire('changed', {
        trigger: 'clear'
    });
};
/**
 * Undo last command(s)
 */ CommandStack.prototype.undo = function() {
    let action = this._getUndoAction(), next;
    if (action) {
        this._currentExecution.trigger = 'undo';
        this._pushAction(action);
        while(action){
            this._internalUndo(action);
            next = this._getUndoAction();
            if (!next || next.id !== action.id) break;
            action = next;
        }
        this._popAction();
    }
};
/**
 * Redo last command(s)
 */ CommandStack.prototype.redo = function() {
    let action = this._getRedoAction(), next;
    if (action) {
        this._currentExecution.trigger = 'redo';
        this._pushAction(action);
        while(action){
            this._internalExecute(action, true);
            next = this._getRedoAction();
            if (!next || next.id !== action.id) break;
            action = next;
        }
        this._popAction();
    }
};
/**
 * Register a handler instance with the command stack.
 *
 * @param {string} command Command to be executed.
 * @param {CommandHandler} handler Handler to execute the command.
 */ CommandStack.prototype.register = function(command, handler) {
    this._setHandler(command, handler);
};
/**
 * Register a handler type with the command stack  by instantiating it and
 * injecting its dependencies.
 *
 * @param {string} command Command to be executed.
 * @param {CommandHandlerConstructor} handlerCls Constructor to instantiate a {@link CommandHandler}.
 */ CommandStack.prototype.registerHandler = function(command, handlerCls) {
    if (!command || !handlerCls) throw new Error('command and handlerCls must be defined');
    const handler = this._injector.instantiate(handlerCls);
    this.register(command, handler);
};
/**
 * @return {boolean}
 */ CommandStack.prototype.canUndo = function() {
    return !!this._getUndoAction();
};
/**
 * @return {boolean}
 */ CommandStack.prototype.canRedo = function() {
    return !!this._getRedoAction();
};
// stack access  //////////////////////
CommandStack.prototype._getRedoAction = function() {
    return this._stack[this._stackIdx + 1];
};
CommandStack.prototype._getUndoAction = function() {
    return this._stack[this._stackIdx];
};
// internal functionality //////////////////////
CommandStack.prototype._internalUndo = function(action) {
    const command = action.command, context = action.context;
    const handler = this._getHandler(command);
    // guard against illegal nested command stack invocations
    this._atomicDo(()=>{
        this._fire(command, 'revert', action);
        if (handler.revert) this._markDirty(handler.revert(context));
        this._revertedAction(action);
        this._fire(command, 'reverted', action);
    });
};
CommandStack.prototype._fire = function(command, qualifier, event) {
    if (arguments.length < 3) {
        event = qualifier;
        qualifier = null;
    }
    const names = qualifier ? [
        command + '.' + qualifier,
        qualifier
    ] : [
        command
    ];
    let result;
    event = this._eventBus.createEvent(event);
    for (const name of names){
        result = this._eventBus.fire('commandStack.' + name, event);
        if (event.cancelBubble) break;
    }
    return result;
};
CommandStack.prototype._createId = function() {
    return this._uid++;
};
CommandStack.prototype._atomicDo = function(fn) {
    const execution = this._currentExecution;
    execution.atomic = true;
    try {
        fn();
    } finally{
        execution.atomic = false;
    }
};
CommandStack.prototype._internalExecute = function(action, redo) {
    const command = action.command, context = action.context;
    const handler = this._getHandler(command);
    if (!handler) throw new Error('no command handler registered for <' + command + '>');
    this._pushAction(action);
    if (!redo) {
        this._fire(command, 'preExecute', action);
        if (handler.preExecute) handler.preExecute(context);
        this._fire(command, 'preExecuted', action);
    }
    // guard against illegal nested command stack invocations
    this._atomicDo(()=>{
        this._fire(command, 'execute', action);
        if (handler.execute) // actual execute + mark return results as dirty
        this._markDirty(handler.execute(context));
        // log to stack
        this._executedAction(action, redo);
        this._fire(command, 'executed', action);
    });
    if (!redo) {
        this._fire(command, 'postExecute', action);
        if (handler.postExecute) handler.postExecute(context);
        this._fire(command, 'postExecuted', action);
    }
    this._popAction(action);
};
CommandStack.prototype._pushAction = function(action) {
    const execution = this._currentExecution, actions = execution.actions;
    const baseAction = actions[0];
    if (execution.atomic) throw new Error('illegal invocation in <execute> or <revert> phase (action: ' + action.command + ')');
    if (!action.id) action.id = baseAction && baseAction.id || this._createId();
    actions.push(action);
};
CommandStack.prototype._popAction = function() {
    const execution = this._currentExecution, trigger = execution.trigger, actions = execution.actions, dirty = execution.dirty;
    actions.pop();
    if (!actions.length) {
        this._eventBus.fire('elements.changed', {
            elements: (0, _minDash.uniqueBy)('id', dirty.reverse())
        });
        dirty.length = 0;
        this._fire('changed', {
            trigger: trigger
        });
        execution.trigger = null;
    }
};
CommandStack.prototype._markDirty = function(elements) {
    const execution = this._currentExecution;
    if (!elements) return;
    elements = (0, _minDash.isArray)(elements) ? elements : [
        elements
    ];
    execution.dirty = execution.dirty.concat(elements);
};
CommandStack.prototype._executedAction = function(action, redo) {
    const stackIdx = ++this._stackIdx;
    if (!redo) this._stack.splice(stackIdx, this._stack.length, action);
};
CommandStack.prototype._revertedAction = function(action) {
    this._stackIdx--;
};
CommandStack.prototype._getHandler = function(command) {
    return this._handlerMap[command];
};
CommandStack.prototype._setHandler = function(command, handler) {
    if (!command || !handler) throw new Error('command and handler required');
    if (this._handlerMap[command]) throw new Error('overriding handler for command <' + command + '>');
    this._handlerMap[command] = handler;
};

},{"min-dash":"aEEla","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"l4pQY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tooltips = require("./Tooltips");
var _tooltipsDefault = parcelHelpers.interopDefault(_tooltips);
exports.default = {
    __init__: [
        'tooltips'
    ],
    tooltips: [
        'type',
        (0, _tooltipsDefault.default)
    ]
};

},{"./Tooltips":"28ZIS","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"28ZIS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Tooltips);
var _minDash = require("min-dash");
var _minDom = require("min-dom");
var _idGenerator = require("../../util/IdGenerator");
var _idGeneratorDefault = parcelHelpers.interopDefault(_idGenerator);
/**
 * @typedef {import('../../core/Canvas').default} Canvas
 * @typedef {import('../../core/EventBus').default} EventBus
 */ // document wide unique tooltip ids
var ids = new (0, _idGeneratorDefault.default)('tt');
function createRoot(parentNode) {
    var root = (0, _minDom.domify)('<div class="djs-tooltip-container" />');
    (0, _minDom.assignStyle)(root, {
        position: 'absolute',
        width: '0',
        height: '0'
    });
    parentNode.insertBefore(root, parentNode.firstChild);
    return root;
}
function setPosition(el, x, y) {
    (0, _minDom.assignStyle)(el, {
        left: x + 'px',
        top: y + 'px'
    });
}
function setVisible(el, visible) {
    el.style.display = visible === false ? 'none' : '';
}
var tooltipClass = 'djs-tooltip', tooltipSelector = '.' + tooltipClass;
function Tooltips(eventBus, canvas) {
    this._eventBus = eventBus;
    this._canvas = canvas;
    this._ids = ids;
    this._tooltipDefaults = {
        show: {
            minZoom: 0.7,
            maxZoom: 5.0
        }
    };
    /**
   * Mapping tooltipId -> tooltip
   */ this._tooltips = {};
    // root html element for all tooltips
    this._tooltipRoot = createRoot(canvas.getContainer());
    var self = this;
    (0, _minDom.delegate).bind(this._tooltipRoot, tooltipSelector, 'mousedown', function(event) {
        event.stopPropagation();
    });
    (0, _minDom.delegate).bind(this._tooltipRoot, tooltipSelector, 'mouseover', function(event) {
        self.trigger('mouseover', event);
    });
    (0, _minDom.delegate).bind(this._tooltipRoot, tooltipSelector, 'mouseout', function(event) {
        self.trigger('mouseout', event);
    });
    this._init();
}
Tooltips.$inject = [
    'eventBus',
    'canvas'
];
/**
 * Adds a HTML tooltip to the diagram
 *
 * @param {Object}               tooltip   the tooltip configuration
 *
 * @param {string|DOMElement}    tooltip.html                 html element to use as an tooltip
 * @param {Object}               [tooltip.show]               show configuration
 * @param {number}               [tooltip.show.minZoom]       minimal zoom level to show the tooltip
 * @param {number}               [tooltip.show.maxZoom]       maximum zoom level to show the tooltip
 * @param {Object}               tooltip.position             where to attach the tooltip
 * @param {number}               [tooltip.position.left]      relative to element bbox left attachment
 * @param {number}               [tooltip.position.top]       relative to element bbox top attachment
 * @param {number}               [tooltip.position.bottom]    relative to element bbox bottom attachment
 * @param {number}               [tooltip.position.right]     relative to element bbox right attachment
 * @param {number}               [tooltip.timeout=-1]
 *
 * @return {string}              id that may be used to reference the tooltip for update or removal
 */ Tooltips.prototype.add = function(tooltip) {
    if (!tooltip.position) throw new Error('must specifiy tooltip position');
    if (!tooltip.html) throw new Error('must specifiy tooltip html');
    var id = this._ids.next();
    tooltip = (0, _minDash.assign)({}, this._tooltipDefaults, tooltip, {
        id: id
    });
    this._addTooltip(tooltip);
    if (tooltip.timeout) this.setTimeout(tooltip);
    return id;
};
Tooltips.prototype.trigger = function(action, event) {
    var node = event.delegateTarget || event.target;
    var tooltip = this.get((0, _minDom.attr)(node, 'data-tooltip-id'));
    if (!tooltip) return;
    if (action === 'mouseover' && tooltip.timeout) this.clearTimeout(tooltip);
    if (action === 'mouseout' && tooltip.timeout) {
        // cut timeout after mouse out
        tooltip.timeout = 1000;
        this.setTimeout(tooltip);
    }
};
/**
 * Get a tooltip with the given id
 *
 * @param {string} id
 */ Tooltips.prototype.get = function(id) {
    if (typeof id !== 'string') id = id.id;
    return this._tooltips[id];
};
Tooltips.prototype.clearTimeout = function(tooltip) {
    tooltip = this.get(tooltip);
    if (!tooltip) return;
    var removeTimer = tooltip.removeTimer;
    if (removeTimer) {
        clearTimeout(removeTimer);
        tooltip.removeTimer = null;
    }
};
Tooltips.prototype.setTimeout = function(tooltip) {
    tooltip = this.get(tooltip);
    if (!tooltip) return;
    this.clearTimeout(tooltip);
    var self = this;
    tooltip.removeTimer = setTimeout(function() {
        self.remove(tooltip);
    }, tooltip.timeout);
};
/**
 * Remove an tooltip with the given id
 *
 * @param {string} id
 */ Tooltips.prototype.remove = function(id) {
    var tooltip = this.get(id);
    if (tooltip) {
        (0, _minDom.remove)(tooltip.html);
        (0, _minDom.remove)(tooltip.htmlContainer);
        delete tooltip.htmlContainer;
        delete this._tooltips[tooltip.id];
    }
};
Tooltips.prototype.show = function() {
    setVisible(this._tooltipRoot);
};
Tooltips.prototype.hide = function() {
    setVisible(this._tooltipRoot, false);
};
Tooltips.prototype._updateRoot = function(viewbox) {
    var a = viewbox.scale || 1;
    var d = viewbox.scale || 1;
    var matrix = 'matrix(' + a + ',0,0,' + d + ',' + -1 * viewbox.x * a + ',' + -1 * viewbox.y * d + ')';
    this._tooltipRoot.style.transform = matrix;
    this._tooltipRoot.style['-ms-transform'] = matrix;
};
Tooltips.prototype._addTooltip = function(tooltip) {
    var id = tooltip.id, html = tooltip.html, htmlContainer, tooltipRoot = this._tooltipRoot;
    // unwrap jquery (for those who need it)
    if (html.get && html.constructor.prototype.jquery) html = html.get(0);
    // create proper html elements from
    // tooltip HTML strings
    if ((0, _minDash.isString)(html)) html = (0, _minDom.domify)(html);
    htmlContainer = (0, _minDom.domify)('<div data-tooltip-id="' + id + '" class="' + tooltipClass + '">');
    (0, _minDom.assignStyle)(htmlContainer, {
        position: 'absolute'
    });
    htmlContainer.appendChild(html);
    if (tooltip.type) (0, _minDom.classes)(htmlContainer).add('djs-tooltip-' + tooltip.type);
    if (tooltip.className) (0, _minDom.classes)(htmlContainer).add(tooltip.className);
    tooltip.htmlContainer = htmlContainer;
    tooltipRoot.appendChild(htmlContainer);
    this._tooltips[id] = tooltip;
    this._updateTooltip(tooltip);
};
Tooltips.prototype._updateTooltip = function(tooltip) {
    var position = tooltip.position, htmlContainer = tooltip.htmlContainer;
    // update overlay html based on tooltip x, y
    setPosition(htmlContainer, position.x, position.y);
};
Tooltips.prototype._updateTooltipVisibilty = function(viewbox) {
    (0, _minDash.forEach)(this._tooltips, function(tooltip) {
        var show = tooltip.show, htmlContainer = tooltip.htmlContainer, visible = true;
        if (show) {
            if (show.minZoom > viewbox.scale || show.maxZoom < viewbox.scale) visible = false;
            setVisible(htmlContainer, visible);
        }
    });
};
Tooltips.prototype._init = function() {
    var self = this;
    // scroll/zoom integration
    function updateViewbox(viewbox) {
        self._updateRoot(viewbox);
        self._updateTooltipVisibilty(viewbox);
        self.show();
    }
    this._eventBus.on('canvas.viewbox.changing', function(event) {
        self.hide();
    });
    this._eventBus.on('canvas.viewbox.changed', function(event) {
        updateViewbox(event.viewbox);
    });
};

},{"min-dash":"aEEla","min-dom":"e58GC","../../util/IdGenerator":"bN4m6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"joyGg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _labelSupport = require("./LabelSupport");
var _labelSupportDefault = parcelHelpers.interopDefault(_labelSupport);
exports.default = {
    __init__: [
        'labelSupport'
    ],
    labelSupport: [
        'type',
        (0, _labelSupportDefault.default)
    ]
};

},{"./LabelSupport":"Rl93A","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"Rl93A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>LabelSupport);
var _minDash = require("min-dash");
var _inheritsBrowser = require("inherits-browser");
var _inheritsBrowserDefault = parcelHelpers.interopDefault(_inheritsBrowser);
var _collections = require("../../util/Collections");
var _removal = require("../../util/Removal");
var _commandInterceptor = require("../../command/CommandInterceptor");
var _commandInterceptorDefault = parcelHelpers.interopDefault(_commandInterceptor);
var LOW_PRIORITY = 250, HIGH_PRIORITY = 1400;
function LabelSupport(injector, eventBus, modeling) {
    (0, _commandInterceptorDefault.default).call(this, eventBus);
    var movePreview = injector.get('movePreview', false);
    // remove labels from the collection that are being
    // moved with other elements anyway
    eventBus.on('shape.move.start', HIGH_PRIORITY, function(e) {
        var context = e.context, shapes = context.shapes, validatedShapes = context.validatedShapes;
        context.shapes = removeLabels(shapes);
        context.validatedShapes = removeLabels(validatedShapes);
    });
    // add labels to visual's group
    movePreview && eventBus.on('shape.move.start', LOW_PRIORITY, function(e) {
        var context = e.context, shapes = context.shapes;
        var labels = [];
        (0, _minDash.forEach)(shapes, function(element) {
            (0, _minDash.forEach)(element.labels, function(label) {
                if (!label.hidden && context.shapes.indexOf(label) === -1) labels.push(label);
                if (element.labelTarget) labels.push(element);
            });
        });
        (0, _minDash.forEach)(labels, function(label) {
            movePreview.makeDraggable(context, label, true);
        });
    });
    // add all labels to move closure
    this.preExecuted('elements.move', HIGH_PRIORITY, function(e) {
        var context = e.context, closure = context.closure, enclosedElements = closure.enclosedElements;
        var enclosedLabels = [];
        // find labels that are not part of
        // move closure yet and add them
        (0, _minDash.forEach)(enclosedElements, function(element) {
            (0, _minDash.forEach)(element.labels, function(label) {
                if (!enclosedElements[label.id]) enclosedLabels.push(label);
            });
        });
        closure.addAll(enclosedLabels);
    });
    this.preExecute([
        'connection.delete',
        'shape.delete'
    ], function(e) {
        var context = e.context, element = context.connection || context.shape;
        (0, _removal.saveClear)(element.labels, function(label) {
            modeling.removeShape(label, {
                nested: true
            });
        });
    });
    this.execute('shape.delete', function(e) {
        var context = e.context, shape = context.shape, labelTarget = shape.labelTarget;
        // unset labelTarget
        if (labelTarget) {
            context.labelTargetIndex = (0, _collections.indexOf)(labelTarget.labels, shape);
            context.labelTarget = labelTarget;
            shape.labelTarget = null;
        }
    });
    this.revert('shape.delete', function(e) {
        var context = e.context, shape = context.shape, labelTarget = context.labelTarget, labelTargetIndex = context.labelTargetIndex;
        // restore labelTarget
        if (labelTarget) {
            (0, _collections.add)(labelTarget.labels, shape, labelTargetIndex);
            shape.labelTarget = labelTarget;
        }
    });
}
(0, _inheritsBrowserDefault.default)(LabelSupport, (0, _commandInterceptorDefault.default));
LabelSupport.$inject = [
    'injector',
    'eventBus',
    'modeling'
];
/**
 * Return a filtered list of elements that do not
 * contain attached elements with hosts being part
 * of the selection.
 *
 * @param {Array<Base>} elements
 *
 * @return {Array<Base>} filtered
 */ function removeLabels(elements) {
    return (0, _minDash.filter)(elements, function(element) {
        // filter out labels that are move together
        // with their label targets
        return elements.indexOf(element.labelTarget) === -1;
    });
}

},{"min-dash":"aEEla","inherits-browser":"hymxq","../../util/Collections":"kRUAD","../../util/Removal":"8An0B","../../command/CommandInterceptor":"1K1IQ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8An0B":[function(require,module,exports,__globalThis) {
/**
 * Remove from the beginning of a collection until it is empty.
 *
 * This is a null-safe operation that ensures elements
 * are being removed from the given collection until the
 * collection is empty.
 *
 * The implementation deals with the fact that a remove operation
 * may touch, i.e. remove multiple elements in the collection
 * at a time.
 *
 * @param {Object[]} [collection]
 * @param {Function} removeFn
 *
 * @return {Object[]} the cleared collection
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "saveClear", ()=>saveClear);
function saveClear(collection, removeFn) {
    if (typeof removeFn !== 'function') throw new Error('removeFn iterator must be a function');
    if (!collection) return;
    var e;
    while(e = collection[0])removeFn(e);
    return collection;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fT3Dr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rules = require("../rules");
var _rulesDefault = parcelHelpers.interopDefault(_rules);
var _attachSupport = require("./AttachSupport");
var _attachSupportDefault = parcelHelpers.interopDefault(_attachSupport);
exports.default = {
    __depends__: [
        (0, _rulesDefault.default)
    ],
    __init__: [
        'attachSupport'
    ],
    attachSupport: [
        'type',
        (0, _attachSupportDefault.default)
    ]
};

},{"../rules":"5xj5a","./AttachSupport":"4kq5n","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4kq5n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AttachSupport);
var _minDash = require("min-dash");
var _removal = require("../../util/Removal");
var _attachUtil = require("../../util/AttachUtil");
var _inheritsBrowser = require("inherits-browser");
var _inheritsBrowserDefault = parcelHelpers.interopDefault(_inheritsBrowser);
var _commandInterceptor = require("../../command/CommandInterceptor");
var _commandInterceptorDefault = parcelHelpers.interopDefault(_commandInterceptor);
/**
 * @typedef {import('didi').Injector} Injector
 *
 * @typedef {import('../../model').Base} Base
 *
 * @typedef {import('../../core/Canvas').default} Canvas
 * @typedef {import('../../core/EventBus').default} EventBus
 * @typedef {import('../rules/Rules').default} Rules
 * @typedef {import('../modeling/Modeling').default} Modeling
 */ var LOW_PRIORITY = 251, HIGH_PRIORITY = 1401;
var MARKER_ATTACH = 'attach-ok';
function AttachSupport(injector, eventBus, canvas, rules, modeling) {
    (0, _commandInterceptorDefault.default).call(this, eventBus);
    var movePreview = injector.get('movePreview', false);
    // remove all the attached elements from the shapes to be validated
    // add all the attached shapes to the overall list of moved shapes
    eventBus.on('shape.move.start', HIGH_PRIORITY, function(e) {
        var context = e.context, shapes = context.shapes, validatedShapes = context.validatedShapes;
        context.shapes = addAttached(shapes);
        context.validatedShapes = removeAttached(validatedShapes);
    });
    // add attachers to the visual's group
    movePreview && eventBus.on('shape.move.start', LOW_PRIORITY, function(e) {
        var context = e.context, shapes = context.shapes, attachers = getAttachers(shapes);
        (0, _minDash.forEach)(attachers, function(attacher) {
            movePreview.makeDraggable(context, attacher, true);
            (0, _minDash.forEach)(attacher.labels, function(label) {
                movePreview.makeDraggable(context, label, true);
            });
        });
    });
    // add attach-ok marker to current host
    movePreview && eventBus.on('shape.move.start', function(event) {
        var context = event.context, shapes = context.shapes;
        if (shapes.length !== 1) return;
        var shape = shapes[0];
        var host = shape.host;
        if (host) {
            canvas.addMarker(host, MARKER_ATTACH);
            eventBus.once([
                'shape.move.out',
                'shape.move.cleanup'
            ], function() {
                canvas.removeMarker(host, MARKER_ATTACH);
            });
        }
    });
    // add all attachers to move closure
    this.preExecuted('elements.move', HIGH_PRIORITY, function(e) {
        var context = e.context, closure = context.closure, shapes = context.shapes, attachers = getAttachers(shapes);
        (0, _minDash.forEach)(attachers, function(attacher) {
            closure.add(attacher, closure.topLevel[attacher.host.id]);
        });
    });
    // perform the attaching after shapes are done moving
    this.postExecuted('elements.move', function(e) {
        var context = e.context, shapes = context.shapes, newHost = context.newHost, attachers;
        // only single elements can be attached
        // multiply elements can be detached
        if (newHost && shapes.length !== 1) return;
        if (newHost) attachers = shapes;
        else // find attachers moved without host
        attachers = (0, _minDash.filter)(shapes, function(shape) {
            var host = shape.host;
            return isAttacher(shape) && !includes(shapes, host);
        });
        (0, _minDash.forEach)(attachers, function(attacher) {
            modeling.updateAttachment(attacher, newHost);
        });
    });
    // ensure invalid attachment connections are removed
    this.postExecuted('elements.move', function(e) {
        var shapes = e.context.shapes;
        (0, _minDash.forEach)(shapes, function(shape) {
            (0, _minDash.forEach)(shape.attachers, function(attacher) {
                // remove invalid outgoing connections
                (0, _minDash.forEach)(attacher.outgoing.slice(), function(connection) {
                    var allowed = rules.allowed('connection.reconnect', {
                        connection: connection,
                        source: connection.source,
                        target: connection.target
                    });
                    if (!allowed) modeling.removeConnection(connection);
                });
                // remove invalid incoming connections
                (0, _minDash.forEach)(attacher.incoming.slice(), function(connection) {
                    var allowed = rules.allowed('connection.reconnect', {
                        connection: connection,
                        source: connection.source,
                        target: connection.target
                    });
                    if (!allowed) modeling.removeConnection(connection);
                });
            });
        });
    });
    this.postExecute('shape.create', function(e) {
        var context = e.context, shape = context.shape, host = context.host;
        if (host) modeling.updateAttachment(shape, host);
    });
    // update attachments if the host is replaced
    this.postExecute('shape.replace', function(e) {
        var context = e.context, oldShape = context.oldShape, newShape = context.newShape;
        // move the attachers to the new host
        (0, _removal.saveClear)(oldShape.attachers, function(attacher) {
            var allowed = rules.allowed('elements.move', {
                target: newShape,
                shapes: [
                    attacher
                ]
            });
            if (allowed === 'attach') modeling.updateAttachment(attacher, newShape);
            else modeling.removeShape(attacher);
        });
        // move attachers if new host has different size
        if (newShape.attachers.length) (0, _minDash.forEach)(newShape.attachers, function(attacher) {
            var delta = (0, _attachUtil.getNewAttachShapeDelta)(attacher, oldShape, newShape);
            modeling.moveShape(attacher, delta, attacher.parent);
        });
    });
    // move shape on host resize
    this.postExecute('shape.resize', function(event) {
        var context = event.context, shape = context.shape, oldBounds = context.oldBounds, newBounds = context.newBounds, attachers = shape.attachers, hints = context.hints || {};
        if (hints.attachSupport === false) return;
        (0, _minDash.forEach)(attachers, function(attacher) {
            var delta = (0, _attachUtil.getNewAttachShapeDelta)(attacher, oldBounds, newBounds);
            modeling.moveShape(attacher, delta, attacher.parent);
            (0, _minDash.forEach)(attacher.labels, function(label) {
                modeling.moveShape(label, delta, label.parent);
            });
        });
    });
    // remove attachments
    this.preExecute('shape.delete', function(event) {
        var shape = event.context.shape;
        (0, _removal.saveClear)(shape.attachers, function(attacher) {
            modeling.removeShape(attacher);
        });
        if (shape.host) modeling.updateAttachment(shape, null);
    });
}
(0, _inheritsBrowserDefault.default)(AttachSupport, (0, _commandInterceptorDefault.default));
AttachSupport.$inject = [
    'injector',
    'eventBus',
    'canvas',
    'rules',
    'modeling'
];
/**
 * Return attachers of the given shapes
 *
 * @param {Array<Base>} shapes
 * @return {Array<Base>}
 */ function getAttachers(shapes) {
    return (0, _minDash.flatten)((0, _minDash.map)(shapes, function(s) {
        return s.attachers || [];
    }));
}
/**
 * Return a combined list of elements and
 * attachers.
 *
 * @param {Array<Base>} elements
 * @return {Array<Base>} filtered
 */ function addAttached(elements) {
    var attachers = getAttachers(elements);
    return (0, _minDash.unionBy)('id', elements, attachers);
}
/**
 * Return a filtered list of elements that do not
 * contain attached elements with hosts being part
 * of the selection.
 *
 * @param {Array<Base>} elements
 *
 * @return {Array<Base>} filtered
 */ function removeAttached(elements) {
    var ids = (0, _minDash.groupBy)(elements, 'id');
    return (0, _minDash.filter)(elements, function(element) {
        while(element){
            // host in selection
            if (element.host && ids[element.host.id]) return false;
            element = element.parent;
        }
        return true;
    });
}
function isAttacher(shape) {
    return !!shape.host;
}
function includes(array, item) {
    return array.indexOf(item) !== -1;
}

},{"min-dash":"aEEla","../../util/Removal":"8An0B","../../util/AttachUtil":"IwjBN","inherits-browser":"hymxq","../../command/CommandInterceptor":"1K1IQ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"92D0d":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BpmnFactory);
var _minDash = require("min-dash");
var _modelingUtil = require("./util/ModelingUtil");
var _modelUtil = require("../../util/ModelUtil");
function BpmnFactory(moddle) {
    this._model = moddle;
}
BpmnFactory.$inject = [
    'moddle'
];
BpmnFactory.prototype._needsId = function(element) {
    return (0, _modelingUtil.isAny)(element, [
        'bpmn:RootElement',
        'bpmn:FlowElement',
        'bpmn:MessageFlow',
        'bpmn:DataAssociation',
        'bpmn:Artifact',
        'bpmn:Participant',
        'bpmn:Lane',
        'bpmn:LaneSet',
        'bpmn:Process',
        'bpmn:Collaboration',
        'bpmndi:BPMNShape',
        'bpmndi:BPMNEdge',
        'bpmndi:BPMNDiagram',
        'bpmndi:BPMNPlane',
        'bpmn:Property',
        'bpmn:CategoryValue'
    ]);
};
BpmnFactory.prototype._ensureId = function(element) {
    if (element.id) {
        this._model.ids.claim(element.id, element);
        return;
    }
    // generate semantic ids for elements
    // bpmn:SequenceFlow -> SequenceFlow_ID
    var prefix;
    if ((0, _modelUtil.is)(element, 'bpmn:Activity')) prefix = 'Activity';
    else if ((0, _modelUtil.is)(element, 'bpmn:Event')) prefix = 'Event';
    else if ((0, _modelUtil.is)(element, 'bpmn:Gateway')) prefix = 'Gateway';
    else if ((0, _modelingUtil.isAny)(element, [
        'bpmn:SequenceFlow',
        'bpmn:MessageFlow'
    ])) prefix = 'Flow';
    else prefix = (element.$type || '').replace(/^[^:]*:/g, '');
    prefix += '_';
    if (!element.id && this._needsId(element)) element.id = this._model.ids.nextPrefixed(prefix, element);
};
BpmnFactory.prototype.create = function(type, attrs) {
    var element = this._model.create(type, attrs || {});
    this._ensureId(element);
    return element;
};
BpmnFactory.prototype.createDiLabel = function() {
    return this.create('bpmndi:BPMNLabel', {
        bounds: this.createDiBounds()
    });
};
BpmnFactory.prototype.createDiShape = function(semantic, attrs) {
    return this.create('bpmndi:BPMNShape', (0, _minDash.assign)({
        bpmnElement: semantic,
        bounds: this.createDiBounds()
    }, attrs));
};
BpmnFactory.prototype.createDiBounds = function(bounds) {
    return this.create('dc:Bounds', bounds);
};
BpmnFactory.prototype.createDiWaypoints = function(waypoints) {
    var self = this;
    return (0, _minDash.map)(waypoints, function(pos) {
        return self.createDiWaypoint(pos);
    });
};
BpmnFactory.prototype.createDiWaypoint = function(point) {
    return this.create('dc:Point', (0, _minDash.pick)(point, [
        'x',
        'y'
    ]));
};
BpmnFactory.prototype.createDiEdge = function(semantic, attrs) {
    return this.create('bpmndi:BPMNEdge', (0, _minDash.assign)({
        bpmnElement: semantic,
        waypoint: this.createDiWaypoints([])
    }, attrs));
};
BpmnFactory.prototype.createDiPlane = function(semantic, attrs) {
    return this.create('bpmndi:BPMNPlane', (0, _minDash.assign)({
        bpmnElement: semantic
    }, attrs));
};

},{"min-dash":"aEEla","./util/ModelingUtil":"4DR1e","../../util/ModelUtil":"klNYN","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iPF9H":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BpmnUpdater);
var _minDash = require("min-dash");
var _inheritsBrowser = require("inherits-browser");
var _inheritsBrowserDefault = parcelHelpers.interopDefault(_inheritsBrowser);
var _collections = require("diagram-js/lib/util/Collections");
var _model = require("diagram-js/lib/model");
var _modelUtil = require("../../util/ModelUtil");
var _modelingUtil = require("./util/ModelingUtil");
var _positionUtil = require("diagram-js/lib/util/PositionUtil");
var _commandInterceptor = require("diagram-js/lib/command/CommandInterceptor");
var _commandInterceptorDefault = parcelHelpers.interopDefault(_commandInterceptor);
function BpmnUpdater(eventBus, bpmnFactory, connectionDocking, translate) {
    (0, _commandInterceptorDefault.default).call(this, eventBus);
    this._bpmnFactory = bpmnFactory;
    this._translate = translate;
    var self = this;
    // connection cropping //////////////////////
    // crop connection ends during create/update
    function cropConnection(e) {
        var context = e.context, hints = context.hints || {}, connection;
        if (!context.cropped && hints.createElementsBehavior !== false) {
            connection = context.connection;
            connection.waypoints = connectionDocking.getCroppedWaypoints(connection);
            context.cropped = true;
        }
    }
    this.executed([
        'connection.layout',
        'connection.create'
    ], cropConnection);
    this.reverted([
        'connection.layout'
    ], function(e) {
        delete e.context.cropped;
    });
    // BPMN + DI update //////////////////////
    // update parent
    function updateParent(e) {
        var context = e.context;
        self.updateParent(context.shape || context.connection, context.oldParent);
    }
    function reverseUpdateParent(e) {
        var context = e.context;
        var element = context.shape || context.connection, // oldParent is the (old) new parent, because we are undoing
        oldParent = context.parent || context.newParent;
        self.updateParent(element, oldParent);
    }
    this.executed([
        'shape.move',
        'shape.create',
        'shape.delete',
        'connection.create',
        'connection.move',
        'connection.delete'
    ], ifBpmn(updateParent));
    this.reverted([
        'shape.move',
        'shape.create',
        'shape.delete',
        'connection.create',
        'connection.move',
        'connection.delete'
    ], ifBpmn(reverseUpdateParent));
    /*
   * ## Updating Parent
   *
   * When morphing a Process into a Collaboration or vice-versa,
   * make sure that both the *semantic* and *di* parent of each element
   * is updated.
   *
   */ function updateRoot(event) {
        var context = event.context, oldRoot = context.oldRoot, children = oldRoot.children;
        (0, _minDash.forEach)(children, function(child) {
            if ((0, _modelUtil.is)(child, 'bpmn:BaseElement')) self.updateParent(child);
        });
    }
    this.executed([
        'canvas.updateRoot'
    ], updateRoot);
    this.reverted([
        'canvas.updateRoot'
    ], updateRoot);
    // update bounds
    function updateBounds(e) {
        var shape = e.context.shape;
        if (!(0, _modelUtil.is)(shape, 'bpmn:BaseElement')) return;
        self.updateBounds(shape);
    }
    this.executed([
        'shape.move',
        'shape.create',
        'shape.resize'
    ], ifBpmn(function(event) {
        // exclude labels because they're handled separately during shape.changed
        if (event.context.shape.type === 'label') return;
        updateBounds(event);
    }));
    this.reverted([
        'shape.move',
        'shape.create',
        'shape.resize'
    ], ifBpmn(function(event) {
        // exclude labels because they're handled separately during shape.changed
        if (event.context.shape.type === 'label') return;
        updateBounds(event);
    }));
    // Handle labels separately. This is necessary, because the label bounds have to be updated
    // every time its shape changes, not only on move, create and resize.
    eventBus.on('shape.changed', function(event) {
        if (event.element.type === 'label') updateBounds({
            context: {
                shape: event.element
            }
        });
    });
    // attach / detach connection
    function updateConnection(e) {
        self.updateConnection(e.context);
    }
    this.executed([
        'connection.create',
        'connection.move',
        'connection.delete',
        'connection.reconnect'
    ], ifBpmn(updateConnection));
    this.reverted([
        'connection.create',
        'connection.move',
        'connection.delete',
        'connection.reconnect'
    ], ifBpmn(updateConnection));
    // update waypoints
    function updateConnectionWaypoints(e) {
        self.updateConnectionWaypoints(e.context.connection);
    }
    this.executed([
        'connection.layout',
        'connection.move',
        'connection.updateWaypoints'
    ], ifBpmn(updateConnectionWaypoints));
    this.reverted([
        'connection.layout',
        'connection.move',
        'connection.updateWaypoints'
    ], ifBpmn(updateConnectionWaypoints));
    // update conditional/default flows
    this.executed('connection.reconnect', ifBpmn(function(event) {
        var context = event.context, connection = context.connection, oldSource = context.oldSource, newSource = context.newSource, connectionBo = (0, _modelUtil.getBusinessObject)(connection), oldSourceBo = (0, _modelUtil.getBusinessObject)(oldSource), newSourceBo = (0, _modelUtil.getBusinessObject)(newSource);
        // remove condition from connection on reconnect to new source
        // if new source can NOT have condional sequence flow
        if (connectionBo.conditionExpression && !(0, _modelingUtil.isAny)(newSourceBo, [
            'bpmn:Activity',
            'bpmn:ExclusiveGateway',
            'bpmn:InclusiveGateway'
        ])) {
            context.oldConditionExpression = connectionBo.conditionExpression;
            delete connectionBo.conditionExpression;
        }
        // remove default from old source flow on reconnect to new source
        // if source changed
        if (oldSource !== newSource && oldSourceBo.default === connectionBo) {
            context.oldDefault = oldSourceBo.default;
            delete oldSourceBo.default;
        }
    }));
    this.reverted('connection.reconnect', ifBpmn(function(event) {
        var context = event.context, connection = context.connection, oldSource = context.oldSource, newSource = context.newSource, connectionBo = (0, _modelUtil.getBusinessObject)(connection), oldSourceBo = (0, _modelUtil.getBusinessObject)(oldSource), newSourceBo = (0, _modelUtil.getBusinessObject)(newSource);
        // add condition to connection on revert reconnect to new source
        if (context.oldConditionExpression) connectionBo.conditionExpression = context.oldConditionExpression;
        // add default to old source on revert reconnect to new source
        if (context.oldDefault) {
            oldSourceBo.default = context.oldDefault;
            delete newSourceBo.default;
        }
    }));
    // update attachments
    function updateAttachment(e) {
        self.updateAttachment(e.context);
    }
    this.executed([
        'element.updateAttachment'
    ], ifBpmn(updateAttachment));
    this.reverted([
        'element.updateAttachment'
    ], ifBpmn(updateAttachment));
}
(0, _inheritsBrowserDefault.default)(BpmnUpdater, (0, _commandInterceptorDefault.default));
BpmnUpdater.$inject = [
    'eventBus',
    'bpmnFactory',
    'connectionDocking',
    'translate'
];
// implementation //////////////////////
BpmnUpdater.prototype.updateAttachment = function(context) {
    var shape = context.shape, businessObject = shape.businessObject, host = shape.host;
    businessObject.attachedToRef = host && host.businessObject;
};
BpmnUpdater.prototype.updateParent = function(element, oldParent) {
    // do not update BPMN 2.0 label parent
    if (element instanceof (0, _model.Label)) return;
    // data stores in collaborations are handled separately by DataStoreBehavior
    if ((0, _modelUtil.is)(element, 'bpmn:DataStoreReference') && element.parent && (0, _modelUtil.is)(element.parent, 'bpmn:Collaboration')) return;
    var parentShape = element.parent;
    var businessObject = element.businessObject, di = (0, _modelUtil.getDi)(element), parentBusinessObject = parentShape && parentShape.businessObject, parentDi = (0, _modelUtil.getDi)(parentShape);
    if ((0, _modelUtil.is)(element, 'bpmn:FlowNode')) this.updateFlowNodeRefs(businessObject, parentBusinessObject, oldParent && oldParent.businessObject);
    if ((0, _modelUtil.is)(element, 'bpmn:DataOutputAssociation')) {
        if (element.source) parentBusinessObject = element.source.businessObject;
        else parentBusinessObject = null;
    }
    if ((0, _modelUtil.is)(element, 'bpmn:DataInputAssociation')) {
        if (element.target) parentBusinessObject = element.target.businessObject;
        else parentBusinessObject = null;
    }
    this.updateSemanticParent(businessObject, parentBusinessObject);
    if ((0, _modelUtil.is)(element, 'bpmn:DataObjectReference') && businessObject.dataObjectRef) this.updateSemanticParent(businessObject.dataObjectRef, parentBusinessObject);
    this.updateDiParent(di, parentDi);
};
BpmnUpdater.prototype.updateBounds = function(shape) {
    var di = (0, _modelUtil.getDi)(shape), embeddedLabelBounds = getEmbeddedLabelBounds(shape);
    // update embedded label bounds if possible
    if (embeddedLabelBounds) {
        var embeddedLabelBoundsDelta = (0, _positionUtil.delta)(embeddedLabelBounds, di.get('bounds'));
        (0, _minDash.assign)(embeddedLabelBounds, {
            x: shape.x + embeddedLabelBoundsDelta.x,
            y: shape.y + embeddedLabelBoundsDelta.y
        });
    }
    var target = shape instanceof (0, _model.Label) ? this._getLabel(di) : di;
    var bounds = target.bounds;
    if (!bounds) {
        bounds = this._bpmnFactory.createDiBounds();
        target.set('bounds', bounds);
    }
    (0, _minDash.assign)(bounds, {
        x: shape.x,
        y: shape.y,
        width: shape.width,
        height: shape.height
    });
};
BpmnUpdater.prototype.updateFlowNodeRefs = function(businessObject, newContainment, oldContainment) {
    if (oldContainment === newContainment) return;
    var oldRefs, newRefs;
    if ((0, _modelUtil.is)(oldContainment, 'bpmn:Lane')) {
        oldRefs = oldContainment.get('flowNodeRef');
        (0, _collections.remove)(oldRefs, businessObject);
    }
    if ((0, _modelUtil.is)(newContainment, 'bpmn:Lane')) {
        newRefs = newContainment.get('flowNodeRef');
        (0, _collections.add)(newRefs, businessObject);
    }
};
// update existing sourceElement and targetElement di information
BpmnUpdater.prototype.updateDiConnection = function(connection, newSource, newTarget) {
    var connectionDi = (0, _modelUtil.getDi)(connection), newSourceDi = (0, _modelUtil.getDi)(newSource), newTargetDi = (0, _modelUtil.getDi)(newTarget);
    if (connectionDi.sourceElement && connectionDi.sourceElement.bpmnElement !== (0, _modelUtil.getBusinessObject)(newSource)) connectionDi.sourceElement = newSource && newSourceDi;
    if (connectionDi.targetElement && connectionDi.targetElement.bpmnElement !== (0, _modelUtil.getBusinessObject)(newTarget)) connectionDi.targetElement = newTarget && newTargetDi;
};
BpmnUpdater.prototype.updateDiParent = function(di, parentDi) {
    if (parentDi && !(0, _modelUtil.is)(parentDi, 'bpmndi:BPMNPlane')) parentDi = parentDi.$parent;
    if (di.$parent === parentDi) return;
    var planeElements = (parentDi || di.$parent).get('planeElement');
    if (parentDi) {
        planeElements.push(di);
        di.$parent = parentDi;
    } else {
        (0, _collections.remove)(planeElements, di);
        di.$parent = null;
    }
};
function getDefinitions(element) {
    while(element && !(0, _modelUtil.is)(element, 'bpmn:Definitions'))element = element.$parent;
    return element;
}
BpmnUpdater.prototype.getLaneSet = function(container) {
    var laneSet, laneSets;
    // bpmn:Lane
    if ((0, _modelUtil.is)(container, 'bpmn:Lane')) {
        laneSet = container.childLaneSet;
        if (!laneSet) {
            laneSet = this._bpmnFactory.create('bpmn:LaneSet');
            container.childLaneSet = laneSet;
            laneSet.$parent = container;
        }
        return laneSet;
    }
    // bpmn:Participant
    if ((0, _modelUtil.is)(container, 'bpmn:Participant')) container = container.processRef;
    // bpmn:FlowElementsContainer
    laneSets = container.get('laneSets');
    laneSet = laneSets[0];
    if (!laneSet) {
        laneSet = this._bpmnFactory.create('bpmn:LaneSet');
        laneSet.$parent = container;
        laneSets.push(laneSet);
    }
    return laneSet;
};
BpmnUpdater.prototype.updateSemanticParent = function(businessObject, newParent, visualParent) {
    var containment, translate = this._translate;
    if (businessObject.$parent === newParent) return;
    if ((0, _modelUtil.is)(businessObject, 'bpmn:DataInput') || (0, _modelUtil.is)(businessObject, 'bpmn:DataOutput')) {
        if ((0, _modelUtil.is)(newParent, 'bpmn:Participant') && 'processRef' in newParent) newParent = newParent.processRef;
        // already in correct ioSpecification
        if ('ioSpecification' in newParent && newParent.ioSpecification === businessObject.$parent) return;
    }
    if ((0, _modelUtil.is)(businessObject, 'bpmn:Lane')) {
        if (newParent) newParent = this.getLaneSet(newParent);
        containment = 'lanes';
    } else if ((0, _modelUtil.is)(businessObject, 'bpmn:FlowElement')) {
        if (newParent) {
            if ((0, _modelUtil.is)(newParent, 'bpmn:Participant')) newParent = newParent.processRef;
            else if ((0, _modelUtil.is)(newParent, 'bpmn:Lane')) do // unwrap Lane -> LaneSet -> (Lane | FlowElementsContainer)
            newParent = newParent.$parent.$parent;
            while ((0, _modelUtil.is)(newParent, 'bpmn:Lane'));
        }
        containment = 'flowElements';
    } else if ((0, _modelUtil.is)(businessObject, 'bpmn:Artifact')) {
        while(newParent && !(0, _modelUtil.is)(newParent, 'bpmn:Process') && !(0, _modelUtil.is)(newParent, 'bpmn:SubProcess') && !(0, _modelUtil.is)(newParent, 'bpmn:Collaboration'))if ((0, _modelUtil.is)(newParent, 'bpmn:Participant')) {
            newParent = newParent.processRef;
            break;
        } else newParent = newParent.$parent;
        containment = 'artifacts';
    } else if ((0, _modelUtil.is)(businessObject, 'bpmn:MessageFlow')) containment = 'messageFlows';
    else if ((0, _modelUtil.is)(businessObject, 'bpmn:Participant')) {
        containment = 'participants';
        // make sure the participants process is properly attached / detached
        // from the XML document
        var process = businessObject.processRef, definitions;
        if (process) {
            definitions = getDefinitions(businessObject.$parent || newParent);
            if (businessObject.$parent) {
                (0, _collections.remove)(definitions.get('rootElements'), process);
                process.$parent = null;
            }
            if (newParent) {
                (0, _collections.add)(definitions.get('rootElements'), process);
                process.$parent = definitions;
            }
        }
    } else if ((0, _modelUtil.is)(businessObject, 'bpmn:DataOutputAssociation')) containment = 'dataOutputAssociations';
    else if ((0, _modelUtil.is)(businessObject, 'bpmn:DataInputAssociation')) containment = 'dataInputAssociations';
    if (!containment) throw new Error(translate('no parent for {element} in {parent}', {
        element: businessObject.id,
        parent: newParent.id
    }));
    var children;
    if (businessObject.$parent) {
        // remove from old parent
        children = businessObject.$parent.get(containment);
        (0, _collections.remove)(children, businessObject);
    }
    if (!newParent) businessObject.$parent = null;
    else {
        // add to new parent
        children = newParent.get(containment);
        children.push(businessObject);
        businessObject.$parent = newParent;
    }
    if (visualParent) {
        var diChildren = visualParent.get(containment);
        (0, _collections.remove)(children, businessObject);
        if (newParent) {
            if (!diChildren) {
                diChildren = [];
                newParent.set(containment, diChildren);
            }
            diChildren.push(businessObject);
        }
    }
};
BpmnUpdater.prototype.updateConnectionWaypoints = function(connection) {
    var di = (0, _modelUtil.getDi)(connection);
    di.set('waypoint', this._bpmnFactory.createDiWaypoints(connection.waypoints));
};
BpmnUpdater.prototype.updateConnection = function(context) {
    var connection = context.connection, businessObject = (0, _modelUtil.getBusinessObject)(connection), newSource = connection.source, newSourceBo = (0, _modelUtil.getBusinessObject)(newSource), newTarget = connection.target, newTargetBo = (0, _modelUtil.getBusinessObject)(connection.target), visualParent;
    if (!(0, _modelUtil.is)(businessObject, 'bpmn:DataAssociation')) {
        var inverseSet = (0, _modelUtil.is)(businessObject, 'bpmn:SequenceFlow');
        if (businessObject.sourceRef !== newSourceBo) {
            if (inverseSet) {
                (0, _collections.remove)(businessObject.sourceRef && businessObject.sourceRef.get('outgoing'), businessObject);
                if (newSourceBo && newSourceBo.get('outgoing')) newSourceBo.get('outgoing').push(businessObject);
            }
            businessObject.sourceRef = newSourceBo;
        }
        if (businessObject.targetRef !== newTargetBo) {
            if (inverseSet) {
                (0, _collections.remove)(businessObject.targetRef && businessObject.targetRef.get('incoming'), businessObject);
                if (newTargetBo && newTargetBo.get('incoming')) newTargetBo.get('incoming').push(businessObject);
            }
            businessObject.targetRef = newTargetBo;
        }
    } else if ((0, _modelUtil.is)(businessObject, 'bpmn:DataInputAssociation')) {
        // handle obnoxious isMsome sourceRef
        businessObject.get('sourceRef')[0] = newSourceBo;
        visualParent = context.parent || context.newParent || newTargetBo;
        this.updateSemanticParent(businessObject, newTargetBo, visualParent);
    } else if ((0, _modelUtil.is)(businessObject, 'bpmn:DataOutputAssociation')) {
        visualParent = context.parent || context.newParent || newSourceBo;
        this.updateSemanticParent(businessObject, newSourceBo, visualParent);
        // targetRef = new target
        businessObject.targetRef = newTargetBo;
    }
    this.updateConnectionWaypoints(connection);
    this.updateDiConnection(connection, newSource, newTarget);
};
// helpers //////////////////////
BpmnUpdater.prototype._getLabel = function(di) {
    if (!di.label) di.label = this._bpmnFactory.createDiLabel();
    return di.label;
};
/**
 * Make sure the event listener is only called
 * if the touched element is a BPMN element.
 *
 * @param  {Function} fn
 * @return {Function} guarded function
 */ function ifBpmn(fn) {
    return function(event) {
        var context = event.context, element = context.shape || context.connection;
        if ((0, _modelUtil.is)(element, 'bpmn:BaseElement')) fn(event);
    };
}
/**
 * Return dc:Bounds of bpmndi:BPMNLabel if exists.
 *
 * @param {djs.model.shape} shape
 *
 * @returns {Object|undefined}
 */ function getEmbeddedLabelBounds(shape) {
    if (!(0, _modelUtil.is)(shape, 'bpmn:Activity')) return;
    var di = (0, _modelUtil.getDi)(shape);
    if (!di) return;
    var label = di.get('label');
    if (!label) return;
    return label.get('bounds');
}

},{"min-dash":"aEEla","inherits-browser":"hymxq","diagram-js/lib/util/Collections":"kRUAD","diagram-js/lib/model":"d9VZM","../../util/ModelUtil":"klNYN","./util/ModelingUtil":"4DR1e","diagram-js/lib/util/PositionUtil":"flrPc","diagram-js/lib/command/CommandInterceptor":"1K1IQ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6IdXN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ElementFactory);
var _minDash = require("min-dash");
var _inheritsBrowser = require("inherits-browser");
var _inheritsBrowserDefault = parcelHelpers.interopDefault(_inheritsBrowser);
var _modelUtil = require("../../util/ModelUtil");
var _modelingUtil = require("../modeling/util/ModelingUtil");
var _diUtil = require("../../util/DiUtil");
var _elementFactory = require("diagram-js/lib/core/ElementFactory");
var _elementFactoryDefault = parcelHelpers.interopDefault(_elementFactory);
var _labelUtil = require("../../util/LabelUtil");
var _compatibilityUtil = require("../../util/CompatibilityUtil");
function ElementFactory(bpmnFactory, moddle, translate) {
    (0, _elementFactoryDefault.default).call(this);
    this._bpmnFactory = bpmnFactory;
    this._moddle = moddle;
    this._translate = translate;
}
(0, _inheritsBrowserDefault.default)(ElementFactory, (0, _elementFactoryDefault.default));
ElementFactory.$inject = [
    'bpmnFactory',
    'moddle',
    'translate'
];
ElementFactory.prototype.baseCreate = (0, _elementFactoryDefault.default).prototype.create;
ElementFactory.prototype.create = function(elementType, attrs) {
    // no special magic for labels,
    // we assume their businessObjects have already been created
    // and wired via attrs
    if (elementType === 'label') {
        var di = attrs.di || this._bpmnFactory.createDiLabel();
        return this.baseCreate(elementType, (0, _minDash.assign)({
            type: 'label',
            di: di
        }, (0, _labelUtil.DEFAULT_LABEL_SIZE), attrs));
    }
    return this.createBpmnElement(elementType, attrs);
};
ElementFactory.prototype.createBpmnElement = function(elementType, attrs) {
    var size, translate = this._translate;
    attrs = (0, _minDash.assign)({}, attrs || {});
    var businessObject = attrs.businessObject, di = attrs.di;
    if (!businessObject) {
        if (!attrs.type) throw new Error(translate('no shape type specified'));
        businessObject = this._bpmnFactory.create(attrs.type);
        (0, _compatibilityUtil.ensureCompatDiRef)(businessObject);
    }
    if (!isModdleDi(di)) {
        var diAttrs = (0, _minDash.assign)({}, di || {}, {
            id: businessObject.id + '_di'
        });
        if (elementType === 'root') di = this._bpmnFactory.createDiPlane(businessObject, diAttrs);
        else if (elementType === 'connection') di = this._bpmnFactory.createDiEdge(businessObject, diAttrs);
        else di = this._bpmnFactory.createDiShape(businessObject, diAttrs);
    }
    if ((0, _modelUtil.is)(businessObject, 'bpmn:Group')) attrs = (0, _minDash.assign)({
        isFrame: true
    }, attrs);
    attrs = applyAttributes(businessObject, attrs, [
        'processRef',
        'isInterrupting',
        'associationDirection',
        'isForCompensation'
    ]);
    if (attrs.isExpanded) attrs = applyAttribute(di, attrs, 'isExpanded');
    if ((0, _modelUtil.is)(businessObject, 'bpmn:SubProcess')) attrs.collapsed = !(0, _diUtil.isExpanded)(businessObject, di);
    if ((0, _modelUtil.is)(businessObject, 'bpmn:ExclusiveGateway')) di.isMarkerVisible = true;
    if ((0, _minDash.isDefined)(attrs.triggeredByEvent)) {
        businessObject.triggeredByEvent = attrs.triggeredByEvent;
        delete attrs.triggeredByEvent;
    }
    if ((0, _minDash.isDefined)(attrs.cancelActivity)) {
        businessObject.cancelActivity = attrs.cancelActivity;
        delete attrs.cancelActivity;
    }
    var eventDefinitions, newEventDefinition;
    if (attrs.eventDefinitionType) {
        eventDefinitions = businessObject.get('eventDefinitions') || [];
        newEventDefinition = this._bpmnFactory.create(attrs.eventDefinitionType, attrs.eventDefinitionAttrs);
        if (attrs.eventDefinitionType === 'bpmn:ConditionalEventDefinition') newEventDefinition.condition = this._bpmnFactory.create('bpmn:FormalExpression');
        eventDefinitions.push(newEventDefinition);
        newEventDefinition.$parent = businessObject;
        businessObject.eventDefinitions = eventDefinitions;
        delete attrs.eventDefinitionType;
    }
    size = this.getDefaultSize(businessObject, di);
    attrs = (0, _minDash.assign)({
        id: businessObject.id
    }, size, attrs, {
        businessObject: businessObject,
        di: di
    });
    return this.baseCreate(elementType, attrs);
};
ElementFactory.prototype.getDefaultSize = function(element, di) {
    var bo = (0, _modelUtil.getBusinessObject)(element);
    di = di || (0, _modelUtil.getDi)(element);
    if ((0, _modelUtil.is)(bo, 'bpmn:SubProcess')) {
        if ((0, _diUtil.isExpanded)(bo, di)) return {
            width: 350,
            height: 200
        };
        else return {
            width: 100,
            height: 80
        };
    }
    if ((0, _modelUtil.is)(bo, 'bpmn:Task')) return {
        width: 100,
        height: 80
    };
    if ((0, _modelUtil.is)(bo, 'bpmn:Gateway')) return {
        width: 50,
        height: 50
    };
    if ((0, _modelUtil.is)(bo, 'bpmn:Event')) return {
        width: 36,
        height: 36
    };
    if ((0, _modelUtil.is)(bo, 'bpmn:Participant')) {
        if ((0, _diUtil.isExpanded)(bo, di)) return {
            width: 600,
            height: 250
        };
        else return {
            width: 400,
            height: 60
        };
    }
    if ((0, _modelUtil.is)(bo, 'bpmn:Lane')) return {
        width: 400,
        height: 100
    };
    if ((0, _modelUtil.is)(bo, 'bpmn:DataObjectReference')) return {
        width: 36,
        height: 50
    };
    if ((0, _modelUtil.is)(bo, 'bpmn:DataStoreReference')) return {
        width: 50,
        height: 50
    };
    if ((0, _modelUtil.is)(bo, 'bpmn:TextAnnotation')) return {
        width: 100,
        height: 30
    };
    if ((0, _modelUtil.is)(bo, 'bpmn:Group')) return {
        width: 300,
        height: 300
    };
    return {
        width: 100,
        height: 80
    };
};
/**
 * Create participant.
 *
 * @param {boolean|Object} [attrs] attrs
 *
 * @returns {djs.model.Shape}
 */ ElementFactory.prototype.createParticipantShape = function(attrs) {
    if (!(0, _minDash.isObject)(attrs)) attrs = {
        isExpanded: attrs
    };
    attrs = (0, _minDash.assign)({
        type: 'bpmn:Participant'
    }, attrs || {});
    // participants are expanded by default
    if (attrs.isExpanded !== false) attrs.processRef = this._bpmnFactory.create('bpmn:Process');
    return this.createShape(attrs);
};
// helpers //////////////////////
/**
 * Apply attributes from a map to the given element,
 * remove attribute from the map on application.
 *
 * @param {Base} element
 * @param {Object} attrs (in/out map of attributes)
 * @param {Array<string>} attributeNames name of attributes to apply
 *
 * @return {Object} changed attrs
 */ function applyAttributes(element, attrs, attributeNames) {
    (0, _minDash.forEach)(attributeNames, function(property) {
        attrs = applyAttribute(element, attrs, property);
    });
    return attrs;
}
/**
 * Apply named property to element and drain it from the attrs
 * collection.
 *
 * @param {Base} element
 * @param {Object} attrs (in/out map of attributes)
 * @param {string} attributeName to apply
 *
 * @return {Object} changed attrs
 */ function applyAttribute(element, attrs, attributeName) {
    if (attrs[attributeName] === undefined) return attrs;
    element[attributeName] = attrs[attributeName];
    return (0, _minDash.omit)(attrs, [
        attributeName
    ]);
}
function isModdleDi(element) {
    return (0, _modelingUtil.isAny)(element, [
        'bpmndi:BPMNShape',
        'bpmndi:BPMNEdge',
        'bpmndi:BPMNDiagram',
        'bpmndi:BPMNPlane'
    ]);
}

},{"min-dash":"aEEla","inherits-browser":"hymxq","../../util/ModelUtil":"klNYN","../modeling/util/ModelingUtil":"4DR1e","../../util/DiUtil":"krDFz","diagram-js/lib/core/ElementFactory":"idaBX","../../util/LabelUtil":"fAd5x","../../util/CompatibilityUtil":"aYHXN","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"khLRv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Modeling);
var _inheritsBrowser = require("inherits-browser");
var _inheritsBrowserDefault = parcelHelpers.interopDefault(_inheritsBrowser);
var _modeling = require("diagram-js/lib/features/modeling/Modeling");
var _modelingDefault = parcelHelpers.interopDefault(_modeling);
var _updateModdlePropertiesHandler = require("./cmd/UpdateModdlePropertiesHandler");
var _updateModdlePropertiesHandlerDefault = parcelHelpers.interopDefault(_updateModdlePropertiesHandler);
var _updatePropertiesHandler = require("./cmd/UpdatePropertiesHandler");
var _updatePropertiesHandlerDefault = parcelHelpers.interopDefault(_updatePropertiesHandler);
var _updateCanvasRootHandler = require("./cmd/UpdateCanvasRootHandler");
var _updateCanvasRootHandlerDefault = parcelHelpers.interopDefault(_updateCanvasRootHandler);
var _addLaneHandler = require("./cmd/AddLaneHandler");
var _addLaneHandlerDefault = parcelHelpers.interopDefault(_addLaneHandler);
var _splitLaneHandler = require("./cmd/SplitLaneHandler");
var _splitLaneHandlerDefault = parcelHelpers.interopDefault(_splitLaneHandler);
var _resizeLaneHandler = require("./cmd/ResizeLaneHandler");
var _resizeLaneHandlerDefault = parcelHelpers.interopDefault(_resizeLaneHandler);
var _updateFlowNodeRefsHandler = require("./cmd/UpdateFlowNodeRefsHandler");
var _updateFlowNodeRefsHandlerDefault = parcelHelpers.interopDefault(_updateFlowNodeRefsHandler);
var _idClaimHandler = require("./cmd/IdClaimHandler");
var _idClaimHandlerDefault = parcelHelpers.interopDefault(_idClaimHandler);
var _setColorHandler = require("./cmd/SetColorHandler");
var _setColorHandlerDefault = parcelHelpers.interopDefault(_setColorHandler);
var _updateLabelHandler = require("../label-editing/cmd/UpdateLabelHandler");
var _updateLabelHandlerDefault = parcelHelpers.interopDefault(_updateLabelHandler);
function Modeling(eventBus, elementFactory, commandStack, bpmnRules) {
    (0, _modelingDefault.default).call(this, eventBus, elementFactory, commandStack);
    this._bpmnRules = bpmnRules;
}
(0, _inheritsBrowserDefault.default)(Modeling, (0, _modelingDefault.default));
Modeling.$inject = [
    'eventBus',
    'elementFactory',
    'commandStack',
    'bpmnRules'
];
Modeling.prototype.getHandlers = function() {
    var handlers = (0, _modelingDefault.default).prototype.getHandlers.call(this);
    handlers['element.updateModdleProperties'] = (0, _updateModdlePropertiesHandlerDefault.default);
    handlers['element.updateProperties'] = (0, _updatePropertiesHandlerDefault.default);
    handlers['canvas.updateRoot'] = (0, _updateCanvasRootHandlerDefault.default);
    handlers['lane.add'] = (0, _addLaneHandlerDefault.default);
    handlers['lane.resize'] = (0, _resizeLaneHandlerDefault.default);
    handlers['lane.split'] = (0, _splitLaneHandlerDefault.default);
    handlers['lane.updateRefs'] = (0, _updateFlowNodeRefsHandlerDefault.default);
    handlers['id.updateClaim'] = (0, _idClaimHandlerDefault.default);
    handlers['element.setColor'] = (0, _setColorHandlerDefault.default);
    handlers['element.updateLabel'] = (0, _updateLabelHandlerDefault.default);
    return handlers;
};
Modeling.prototype.updateLabel = function(element, newLabel, newBounds, hints) {
    this._commandStack.execute('element.updateLabel', {
        element: element,
        newLabel: newLabel,
        newBounds: newBounds,
        hints: hints || {}
    });
};
Modeling.prototype.connect = function(source, target, attrs, hints) {
    var bpmnRules = this._bpmnRules;
    if (!attrs) attrs = bpmnRules.canConnect(source, target);
    if (!attrs) return;
    return this.createConnection(source, target, attrs, source.parent, hints);
};
Modeling.prototype.updateModdleProperties = function(element, moddleElement, properties) {
    this._commandStack.execute('element.updateModdleProperties', {
        element: element,
        moddleElement: moddleElement,
        properties: properties
    });
};
Modeling.prototype.updateProperties = function(element, properties) {
    this._commandStack.execute('element.updateProperties', {
        element: element,
        properties: properties
    });
};
Modeling.prototype.resizeLane = function(laneShape, newBounds, balanced) {
    this._commandStack.execute('lane.resize', {
        shape: laneShape,
        newBounds: newBounds,
        balanced: balanced
    });
};
Modeling.prototype.addLane = function(targetLaneShape, location) {
    var context = {
        shape: targetLaneShape,
        location: location
    };
    this._commandStack.execute('lane.add', context);
    return context.newLane;
};
Modeling.prototype.splitLane = function(targetLane, count) {
    this._commandStack.execute('lane.split', {
        shape: targetLane,
        count: count
    });
};
/**
 * Transform the current diagram into a collaboration.
 *
 * @return {djs.model.Root} the new root element
 */ Modeling.prototype.makeCollaboration = function() {
    var collaborationElement = this._create('root', {
        type: 'bpmn:Collaboration'
    });
    var context = {
        newRoot: collaborationElement
    };
    this._commandStack.execute('canvas.updateRoot', context);
    return collaborationElement;
};
Modeling.prototype.updateLaneRefs = function(flowNodeShapes, laneShapes) {
    this._commandStack.execute('lane.updateRefs', {
        flowNodeShapes: flowNodeShapes,
        laneShapes: laneShapes
    });
};
/**
 * Transform the current diagram into a process.
 *
 * @return {djs.model.Root} the new root element
 */ Modeling.prototype.makeProcess = function() {
    var processElement = this._create('root', {
        type: 'bpmn:Process'
    });
    var context = {
        newRoot: processElement
    };
    this._commandStack.execute('canvas.updateRoot', context);
};
Modeling.prototype.claimId = function(id, moddleElement) {
    this._commandStack.execute('id.updateClaim', {
        id: id,
        element: moddleElement,
        claiming: true
    });
};
Modeling.prototype.unclaimId = function(id, moddleElement) {
    this._commandStack.execute('id.updateClaim', {
        id: id,
        element: moddleElement
    });
};
Modeling.prototype.setColor = function(elements, colors) {
    if (!elements.length) elements = [
        elements
    ];
    this._commandStack.execute('element.setColor', {
        elements: elements,
        colors: colors
    });
};

},{"inherits-browser":"hymxq","diagram-js/lib/features/modeling/Modeling":"eHwbj","./cmd/UpdateModdlePropertiesHandler":"1EE4N","./cmd/UpdatePropertiesHandler":"h4dL9","./cmd/UpdateCanvasRootHandler":"1UKAk","./cmd/AddLaneHandler":"dij4j","./cmd/SplitLaneHandler":"9l2S4","./cmd/ResizeLaneHandler":"bdmKd","./cmd/UpdateFlowNodeRefsHandler":"hUsBB","./cmd/IdClaimHandler":"7btlt","./cmd/SetColorHandler":"3Ieon","../label-editing/cmd/UpdateLabelHandler":"5R8Ij","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eHwbj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Modeling);
var _minDash = require("min-dash");
var _model = require("../../model");
var _alignElementsHandler = require("./cmd/AlignElementsHandler");
var _alignElementsHandlerDefault = parcelHelpers.interopDefault(_alignElementsHandler);
var _appendShapeHandler = require("./cmd/AppendShapeHandler");
var _appendShapeHandlerDefault = parcelHelpers.interopDefault(_appendShapeHandler);
var _createConnectionHandler = require("./cmd/CreateConnectionHandler");
var _createConnectionHandlerDefault = parcelHelpers.interopDefault(_createConnectionHandler);
var _createElementsHandler = require("./cmd/CreateElementsHandler");
var _createElementsHandlerDefault = parcelHelpers.interopDefault(_createElementsHandler);
var _createLabelHandler = require("./cmd/CreateLabelHandler");
var _createLabelHandlerDefault = parcelHelpers.interopDefault(_createLabelHandler);
var _createShapeHandler = require("./cmd/CreateShapeHandler");
var _createShapeHandlerDefault = parcelHelpers.interopDefault(_createShapeHandler);
var _deleteConnectionHandler = require("./cmd/DeleteConnectionHandler");
var _deleteConnectionHandlerDefault = parcelHelpers.interopDefault(_deleteConnectionHandler);
var _deleteElementsHandler = require("./cmd/DeleteElementsHandler");
var _deleteElementsHandlerDefault = parcelHelpers.interopDefault(_deleteElementsHandler);
var _deleteShapeHandler = require("./cmd/DeleteShapeHandler");
var _deleteShapeHandlerDefault = parcelHelpers.interopDefault(_deleteShapeHandler);
var _distributeElementsHandler = require("./cmd/DistributeElementsHandler");
var _distributeElementsHandlerDefault = parcelHelpers.interopDefault(_distributeElementsHandler);
var _layoutConnectionHandler = require("./cmd/LayoutConnectionHandler");
var _layoutConnectionHandlerDefault = parcelHelpers.interopDefault(_layoutConnectionHandler);
var _moveConnectionHandler = require("./cmd/MoveConnectionHandler");
var _moveConnectionHandlerDefault = parcelHelpers.interopDefault(_moveConnectionHandler);
var _moveElementsHandler = require("./cmd/MoveElementsHandler");
var _moveElementsHandlerDefault = parcelHelpers.interopDefault(_moveElementsHandler);
var _moveShapeHandler = require("./cmd/MoveShapeHandler");
var _moveShapeHandlerDefault = parcelHelpers.interopDefault(_moveShapeHandler);
var _reconnectConnectionHandler = require("./cmd/ReconnectConnectionHandler");
var _reconnectConnectionHandlerDefault = parcelHelpers.interopDefault(_reconnectConnectionHandler);
var _replaceShapeHandler = require("./cmd/ReplaceShapeHandler");
var _replaceShapeHandlerDefault = parcelHelpers.interopDefault(_replaceShapeHandler);
var _resizeShapeHandler = require("./cmd/ResizeShapeHandler");
var _resizeShapeHandlerDefault = parcelHelpers.interopDefault(_resizeShapeHandler);
var _spaceToolHandler = require("./cmd/SpaceToolHandler");
var _spaceToolHandlerDefault = parcelHelpers.interopDefault(_spaceToolHandler);
var _toggleShapeCollapseHandler = require("./cmd/ToggleShapeCollapseHandler");
var _toggleShapeCollapseHandlerDefault = parcelHelpers.interopDefault(_toggleShapeCollapseHandler);
var _updateAttachmentHandler = require("./cmd/UpdateAttachmentHandler");
var _updateAttachmentHandlerDefault = parcelHelpers.interopDefault(_updateAttachmentHandler);
var _updateWaypointsHandler = require("./cmd/UpdateWaypointsHandler");
var _updateWaypointsHandlerDefault = parcelHelpers.interopDefault(_updateWaypointsHandler);
function Modeling(eventBus, elementFactory, commandStack) {
    this._eventBus = eventBus;
    this._elementFactory = elementFactory;
    this._commandStack = commandStack;
    var self = this;
    eventBus.on('diagram.init', function() {
        // register modeling handlers
        self.registerHandlers(commandStack);
    });
}
Modeling.$inject = [
    'eventBus',
    'elementFactory',
    'commandStack'
];
/**
 * Get a map of all command handlers.
 *
 * @returns {Map<string, CommandHandlerConstructor>} Map of all command handlers.
 */ Modeling.prototype.getHandlers = function() {
    return {
        'shape.append': (0, _appendShapeHandlerDefault.default),
        'shape.create': (0, _createShapeHandlerDefault.default),
        'shape.delete': (0, _deleteShapeHandlerDefault.default),
        'shape.move': (0, _moveShapeHandlerDefault.default),
        'shape.resize': (0, _resizeShapeHandlerDefault.default),
        'shape.replace': (0, _replaceShapeHandlerDefault.default),
        'shape.toggleCollapse': (0, _toggleShapeCollapseHandlerDefault.default),
        'spaceTool': (0, _spaceToolHandlerDefault.default),
        'label.create': (0, _createLabelHandlerDefault.default),
        'connection.create': (0, _createConnectionHandlerDefault.default),
        'connection.delete': (0, _deleteConnectionHandlerDefault.default),
        'connection.move': (0, _moveConnectionHandlerDefault.default),
        'connection.layout': (0, _layoutConnectionHandlerDefault.default),
        'connection.updateWaypoints': (0, _updateWaypointsHandlerDefault.default),
        'connection.reconnect': (0, _reconnectConnectionHandlerDefault.default),
        'elements.create': (0, _createElementsHandlerDefault.default),
        'elements.move': (0, _moveElementsHandlerDefault.default),
        'elements.delete': (0, _deleteElementsHandlerDefault.default),
        'elements.distribute': (0, _distributeElementsHandlerDefault.default),
        'elements.align': (0, _alignElementsHandlerDefault.default),
        'element.updateAttachment': (0, _updateAttachmentHandlerDefault.default)
    };
};
/**
 * Register handlers with the command stack
 *
 * @param {CommandStack} commandStack
 */ Modeling.prototype.registerHandlers = function(commandStack) {
    (0, _minDash.forEach)(this.getHandlers(), function(handler, id) {
        commandStack.registerHandler(id, handler);
    });
};
/**
 * Move a shape by the given delta and optionally to a new parent.
 *
 * @param {Shape} shape The shape to be moved.
 * @param {Point} delta The delta by which to move the shape.
 * @param {Parent} [newParent] The optional new parent.
 * @param {number} [newParentIndex] The optional index at which to add the shape
 * to the new parent's children.
 * @param {ModelingHints} [hints] The optional hints.
 */ Modeling.prototype.moveShape = function(shape, delta, newParent, newParentIndex, hints) {
    if (typeof newParentIndex === 'object') {
        hints = newParentIndex;
        newParentIndex = null;
    }
    var context = {
        shape: shape,
        delta: delta,
        newParent: newParent,
        newParentIndex: newParentIndex,
        hints: hints || {}
    };
    this._commandStack.execute('shape.move', context);
};
/**
 * Update the attachment of a shape.
 *
 * @param {Shape} shape The shape.
 * @param {Shape} [newHost=undefined] The new host.
 */ Modeling.prototype.updateAttachment = function(shape, newHost) {
    var context = {
        shape: shape,
        newHost: newHost
    };
    this._commandStack.execute('element.updateAttachment', context);
};
/**
 * Move elements by a given delta and optionally to a new parent.
 *
 * @param {Base[]} shapes
 * @param {Point} delta
 * @param {Parent} [target]
 * @param {ModelingMoveElementsHints} [hints]
 */ Modeling.prototype.moveElements = function(shapes, delta, target, hints) {
    hints = hints || {};
    var attach = hints.attach;
    var newParent = target, newHost;
    if (attach === true) {
        newHost = target;
        newParent = target.parent;
    } else if (attach === false) newHost = null;
    var context = {
        shapes: shapes,
        delta: delta,
        newParent: newParent,
        newHost: newHost,
        hints: hints
    };
    this._commandStack.execute('elements.move', context);
};
/**
 * Move a shape by the given delta and optionally to a new parent.
 *
 * @param {Connection} shape The connection to be moved.
 * @param {Point} delta The delta by which to move the connection.
 * @param {Parent} [newParent] The optional new parent.
 * @param {number} [newParentIndex] The optional index at which to add the
 * connection to the new parent's children.
 * @param {ModelingHints} [hints] The optional hints.
 */ Modeling.prototype.moveConnection = function(connection, delta, newParent, newParentIndex, hints) {
    if (typeof newParentIndex === 'object') {
        hints = newParentIndex;
        newParentIndex = undefined;
    }
    var context = {
        connection: connection,
        delta: delta,
        newParent: newParent,
        newParentIndex: newParentIndex,
        hints: hints || {}
    };
    this._commandStack.execute('connection.move', context);
};
/**
 * Lay out a connection.
 *
 * @param {Connection} connection The connection to be laid out.
 * @param {ModelingHints} [hints] The optional hints.
 */ Modeling.prototype.layoutConnection = function(connection, hints) {
    var context = {
        connection: connection,
        hints: hints || {}
    };
    this._commandStack.execute('connection.layout', context);
};
/**
 * Create a connection.
 *
 * @param {Base} source The source of the connection.
 * @param {Base} target The target of the connection.
 * @param {number} [parentIndex] The optional index at which to add the
 * connection to its parent's children.
 * @param {Connection|ModelAttrsConnection} connection The connection to be
 * created or its attributes.
 * @param {Parent} parent The parent of the connection.
 * @param {ModelingHints} [hints] The optional hints.
 *
 * @return {Connection} The created connection.
 */ Modeling.prototype.createConnection = function(source, target, parentIndex, connection, parent, hints) {
    if (typeof parentIndex === 'object') {
        hints = parent;
        parent = connection;
        connection = parentIndex;
        parentIndex = undefined;
    }
    connection = this._create('connection', connection);
    var context = {
        source: source,
        target: target,
        parent: parent,
        parentIndex: parentIndex,
        connection: connection,
        hints: hints
    };
    this._commandStack.execute('connection.create', context);
    return context.connection;
};
/**
 * Create a shape.
 *
 * @param {Shape|ModelAttrsShape} shape The shape to be created or its
 * attributes.
 * @param {Point} position The position at which to create the shape.
 * @param {Parent} target The parent of the shape.
 * @param {number} [parentIndex] The optional index at which to add the shape to
 * its parent's children.
 * @param {ModelingCreateShapeHints} [hints] The optional hints.
 *
 * @return {Shape} The created shape.
 */ Modeling.prototype.createShape = function(shape, position, target, parentIndex, hints) {
    if (typeof parentIndex !== 'number') {
        hints = parentIndex;
        parentIndex = undefined;
    }
    hints = hints || {};
    var attach = hints.attach, parent, host;
    shape = this._create('shape', shape);
    if (attach) {
        parent = target.parent;
        host = target;
    } else parent = target;
    var context = {
        position: position,
        shape: shape,
        parent: parent,
        parentIndex: parentIndex,
        host: host,
        hints: hints
    };
    this._commandStack.execute('shape.create', context);
    return context.shape;
};
/**
 * Create elements.
 *
 * @param {(Base|ModelAttrs)[]} elements The elements to be created or their
 * attributes.
 * @param {Point} position The position at which to create the elements.
 * @param {Parent} parent The parent of the elements.
 * @param {number} [parentIndex] The optional index at which to add the elements
 * to their parent's children.
 * @param {ModelingHints} [hints] The optional hints.
 *
 * @return {Base[]} The created elements.
 */ Modeling.prototype.createElements = function(elements, position, parent, parentIndex, hints) {
    if (!(0, _minDash.isArray)(elements)) elements = [
        elements
    ];
    if (typeof parentIndex !== 'number') {
        hints = parentIndex;
        parentIndex = undefined;
    }
    hints = hints || {};
    var context = {
        position: position,
        elements: elements,
        parent: parent,
        parentIndex: parentIndex,
        hints: hints
    };
    this._commandStack.execute('elements.create', context);
    return context.elements;
};
/**
 * Create a label.
 *
 * @param {Base} labelTarget The labels target.
 * @param {Point} position The position at which to create the label.
 * @param {Label|ModelAttrsLabel} label The label to be created or its
 * attributes.
 * @param {Parent} [parent] The parent of the label.
 *
 * @return {Label} The created label.
 */ Modeling.prototype.createLabel = function(labelTarget, position, label, parent) {
    label = this._create('label', label);
    var context = {
        labelTarget: labelTarget,
        position: position,
        parent: parent || labelTarget.parent,
        shape: label
    };
    this._commandStack.execute('label.create', context);
    return context.shape;
};
/**
 * Create and append a shape to a source by connecting it.
 *
 * @param {Base} source The source to append the shape to.
 * @param {Shape|ModelAttrsShape} shape The shape to be created or its
 * attributes.
 * @param {Point} position The position at which to create the shape.
 * @param {Parent} target The parent of the shape.
 * @param {ModelingHints} [hints] The optional hints.
 *
 * @return {Shape} The created and appended shape.
 */ Modeling.prototype.appendShape = function(source, shape, position, target, hints) {
    hints = hints || {};
    shape = this._create('shape', shape);
    var context = {
        source: source,
        position: position,
        target: target,
        shape: shape,
        connection: hints.connection,
        connectionParent: hints.connectionParent,
        hints: hints
    };
    this._commandStack.execute('shape.append', context);
    return context.shape;
};
/**
 * Remove elements.
 *
 * @param {Base[]} elements The elements to be removed.
 */ Modeling.prototype.removeElements = function(elements) {
    var context = {
        elements: elements
    };
    this._commandStack.execute('elements.delete', context);
};
/**
 * Distribute elements along a given axis.
 *
 * @param {ModelingDistributeGroup[]} groups The groups of elements to be
 * distributed.
 * @param {ModelingDistributeAxis} axis The axis to distribute the elements
 * along.
 * @param {ModelingDistributeDimension} dimension The dimension to be used
 * according to the axis.
 */ Modeling.prototype.distributeElements = function(groups, axis, dimension) {
    var context = {
        groups: groups,
        axis: axis,
        dimension: dimension
    };
    this._commandStack.execute('elements.distribute', context);
};
/**
 * Remove a shape.
 *
 * @param {Shape} shape The shape to be removed.
 * @param {ModelingHints} [hints] The optional hints.
 */ Modeling.prototype.removeShape = function(shape, hints) {
    var context = {
        shape: shape,
        hints: hints || {}
    };
    this._commandStack.execute('shape.delete', context);
};
/**
 * Remove a connection.
 *
 * @param {Connection} connection The connection to be removed.
 * @param {ModelingHints} [hints] The optional hints.
 */ Modeling.prototype.removeConnection = function(connection, hints) {
    var context = {
        connection: connection,
        hints: hints || {}
    };
    this._commandStack.execute('connection.delete', context);
};
/**
 * Replace a shape.
 *
 * @param {Shape} oldShape The shape to be replaced.
 * @param {Shape|ModelAttrsShape} newShape The shape to replace with or its
 * attributes.
 * @param {ModelingHints} [hints] The optional hints.
 *
 * @return {Shape} The replaced shape.
 */ Modeling.prototype.replaceShape = function(oldShape, newShape, hints) {
    var context = {
        oldShape: oldShape,
        newData: newShape,
        hints: hints || {}
    };
    this._commandStack.execute('shape.replace', context);
    return context.newShape;
};
/**
 * Align elements.
 *
 * @param {Base[]} elements The elements to be aligned.
 * @param {ModelingAlignAlignment} alignment The alignment.
 */ Modeling.prototype.alignElements = function(elements, alignment) {
    var context = {
        elements: elements,
        alignment: alignment
    };
    this._commandStack.execute('elements.align', context);
};
/**
 * Resize a shape.
 *
 * @param {Shape} shape The shape to be resized.
 * @param {Rect} newBounds The bounds to resize the shape to.
 * @param {Dimensions} minBounds The minimum bounds to resize the shape to.
 * @param {ModelingHints} [hints] The optional hints.
 */ Modeling.prototype.resizeShape = function(shape, newBounds, minBounds, hints) {
    var context = {
        shape: shape,
        newBounds: newBounds,
        minBounds: minBounds,
        hints: hints
    };
    this._commandStack.execute('shape.resize', context);
};
/**
 * Create space along an horizontally or vertically.
 *
 * @param {Shape[]} movingShapes The shapes to be moved.
 * @param {Shape[]} resizingShapes The shapes to be resized.
 * @param {Point} delta The delta.
 * @param {Direction} direction The direction in which to create space.
 * @param {number} start Where to start creating space in the given direction.
 */ Modeling.prototype.createSpace = function(movingShapes, resizingShapes, delta, direction, start) {
    var context = {
        delta: delta,
        direction: direction,
        movingShapes: movingShapes,
        resizingShapes: resizingShapes,
        start: start
    };
    this._commandStack.execute('spaceTool', context);
};
/**
 * Update a connetions waypoints.
 *
 * @param {Connection} connection The connection of which to update the
 * waypoints.
 * @param {Point[]} newWaypoints The updated waypoints.
 * @param {ModelingHints} [hints] The optional hints.
 */ Modeling.prototype.updateWaypoints = function(connection, newWaypoints, hints) {
    var context = {
        connection: connection,
        newWaypoints: newWaypoints,
        hints: hints || {}
    };
    this._commandStack.execute('connection.updateWaypoints', context);
};
/**
 * Reconnect a connections source and/or target.
 *
 * @param {Connection} connection The connection to be reconnected.
 * @param {Base} source The source to connect to.
 * @param {Base} target The target to connect to.
 * @param {Point|Point[]} dockingOrPoints The point to connect to or the
 * waypoints.
 * @param {ModelingHints} [hints] The optional hints.
 */ Modeling.prototype.reconnect = function(connection, source, target, dockingOrPoints, hints) {
    var context = {
        connection: connection,
        newSource: source,
        newTarget: target,
        dockingOrPoints: dockingOrPoints,
        hints: hints || {}
    };
    this._commandStack.execute('connection.reconnect', context);
};
/**
 * Reconnect a connections source.
 *
 * @param {Connection} connection The connection to be reconnected.
 * @param {Base} newSource The source to connect to.
 * @param {Point|Point[]} dockingOrPoints The point to connect to or the
 * waypoints.
 * @param {ModelingHints} [hints] The optional hints.
 */ Modeling.prototype.reconnectStart = function(connection, newSource, dockingOrPoints, hints) {
    if (!hints) hints = {};
    this.reconnect(connection, newSource, connection.target, dockingOrPoints, (0, _minDash.assign)(hints, {
        docking: 'source'
    }));
};
/**
 * Reconnect a connections target.
 *
 * @param {Connection} connection The connection to be reconnected.
 * @param {Base} newTarget The target to connect to.
 * @param {Point|Point[]} dockingOrPoints The point to connect to or the
 * waypoints.
 * @param {ModelingHints} [hints] The optional hints.
 */ Modeling.prototype.reconnectEnd = function(connection, newTarget, dockingOrPoints, hints) {
    if (!hints) hints = {};
    this.reconnect(connection, connection.source, newTarget, dockingOrPoints, (0, _minDash.assign)(hints, {
        docking: 'target'
    }));
};
/**
 * Connect two elements.
 *
 * @param {Base} source The source of the connection.
 * @param {Base} target The target of the connection.
 * @param {Connection|ModelAttrsConnection} attrs The connection to be
 * created or its attributes.
 * @param {ModelingHints} [hints] The optional hints.
 *
 * @return {Connection} The created connection.
 */ Modeling.prototype.connect = function(source, target, attrs, hints) {
    return this.createConnection(source, target, attrs || {}, source.parent, hints);
};
Modeling.prototype._create = function(type, attrs) {
    if (attrs instanceof (0, _model.Base)) return attrs;
    else return this._elementFactory.create(type, attrs);
};
/**
 * Collapse or expand a shape.
 *
 * @param {Shape} shape The shape to be expanded or collapsed.
 * @param {ModelingHints} [hints] The optional hints.
 */ Modeling.prototype.toggleCollapse = function(shape, hints) {
    var context = {
        shape: shape,
        hints: hints || {}
    };
    this._commandStack.execute('shape.toggleCollapse', context);
};

},{"min-dash":"aEEla","../../model":"d9VZM","./cmd/AlignElementsHandler":"gZTWZ","./cmd/AppendShapeHandler":"8JOAB","./cmd/CreateConnectionHandler":"201jk","./cmd/CreateElementsHandler":"h8MoD","./cmd/CreateLabelHandler":"bWHxK","./cmd/CreateShapeHandler":"cGnLc","./cmd/DeleteConnectionHandler":"jAGCH","./cmd/DeleteElementsHandler":"gts1j","./cmd/DeleteShapeHandler":"6LHQc","./cmd/DistributeElementsHandler":"cPBEX","./cmd/LayoutConnectionHandler":"8wuNR","./cmd/MoveConnectionHandler":"8yfwx","./cmd/MoveElementsHandler":"044bl","./cmd/MoveShapeHandler":"9VSh3","./cmd/ReconnectConnectionHandler":"3bkhl","./cmd/ReplaceShapeHandler":"8JPbG","./cmd/ResizeShapeHandler":"EaDUl","./cmd/SpaceToolHandler":"9evJX","./cmd/ToggleShapeCollapseHandler":"2rzPb","./cmd/UpdateAttachmentHandler":"2xlJx","./cmd/UpdateWaypointsHandler":"aFPAm","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gZTWZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AlignElements);
var _minDash = require("min-dash");
function AlignElements(modeling, canvas) {
    this._modeling = modeling;
    this._canvas = canvas;
}
AlignElements.$inject = [
    'modeling',
    'canvas'
];
AlignElements.prototype.preExecute = function(context) {
    var modeling = this._modeling;
    var elements = context.elements, alignment = context.alignment;
    (0, _minDash.forEach)(elements, function(element) {
        var delta = {
            x: 0,
            y: 0
        };
        if ((0, _minDash.isDefined)(alignment.left)) delta.x = alignment.left - element.x;
        else if ((0, _minDash.isDefined)(alignment.right)) delta.x = alignment.right - element.width - element.x;
        else if ((0, _minDash.isDefined)(alignment.center)) delta.x = alignment.center - Math.round(element.width / 2) - element.x;
        else if ((0, _minDash.isDefined)(alignment.top)) delta.y = alignment.top - element.y;
        else if ((0, _minDash.isDefined)(alignment.bottom)) delta.y = alignment.bottom - element.height - element.y;
        else if ((0, _minDash.isDefined)(alignment.middle)) delta.y = alignment.middle - Math.round(element.height / 2) - element.y;
        modeling.moveElements([
            element
        ], delta, element.parent);
    });
};
AlignElements.prototype.postExecute = function(context) {};

},{"min-dash":"aEEla","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8JOAB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AppendShapeHandler);
var _minDash = require("min-dash");
function AppendShapeHandler(modeling) {
    this._modeling = modeling;
}
AppendShapeHandler.$inject = [
    'modeling'
];
// api //////////////////////
/**
 * Creates a new shape.
 *
 * @param {Object} context
 * @param {ModelAttrsShape|Shape} context.shape The new shape.
 * @param {Base} context.source The element to which to append the new shape to.
 * @param {Parent} context.parent The parent.
 * @param {Point} context.position The position at which to create the new shape.
 */ AppendShapeHandler.prototype.preExecute = function(context) {
    var source = context.source;
    if (!source) throw new Error('source required');
    var target = context.target || source.parent, shape = context.shape, hints = context.hints || {};
    shape = context.shape = this._modeling.createShape(shape, context.position, target, {
        attach: hints.attach
    });
    context.shape = shape;
};
AppendShapeHandler.prototype.postExecute = function(context) {
    var hints = context.hints || {};
    if (!existsConnection(context.source, context.shape)) {
        // create connection
        if (hints.connectionTarget === context.source) this._modeling.connect(context.shape, context.source, context.connection);
        else this._modeling.connect(context.source, context.shape, context.connection);
    }
};
function existsConnection(source, target) {
    return (0, _minDash.some)(source.outgoing, function(c) {
        return c.target === target;
    });
}

},{"min-dash":"aEEla","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"201jk":[function(require,module,exports,__globalThis) {
/**
 * @typedef {import('../../../model').Base} Base
 *
 * @typedef {import('../../../util/Types').Point} Point
 *
 * @typedef {import('../Modeling').ModelingCreateConnectionHints} ModelingCreateConnectionHints
 *
 * @typedef {import('../../../core/Canvas').default} Canvas
 * @typedef {import('../../../layout/BaseLayouter').default} Layouter
 */ /**
 * @param {Canvas} canvas
 * @param {Layouter} layouter
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CreateConnectionHandler);
function CreateConnectionHandler(canvas, layouter) {
    this._canvas = canvas;
    this._layouter = layouter;
}
CreateConnectionHandler.$inject = [
    'canvas',
    'layouter'
];
// api //////////////////////
/**
 * Creates a new connection between two elements.
 *
 * @param {Object} context
 * @param {Base} context.source The source.
 * @param {Base} context.target The target.
 * @param {Shape} context.parent The parent.
 * @param {number} [context.parentIndex] The optional index at which to add the
 * connection to the parent's children.
 * @param {ModelingCreateConnectionHints} [context.hints] The optional hints.
 */ CreateConnectionHandler.prototype.execute = function(context) {
    var connection = context.connection, source = context.source, target = context.target, parent = context.parent, parentIndex = context.parentIndex, hints = context.hints;
    if (!source || !target) throw new Error('source and target required');
    if (!parent) throw new Error('parent required');
    connection.source = source;
    connection.target = target;
    if (!connection.waypoints) connection.waypoints = this._layouter.layoutConnection(connection, hints);
    // add connection
    this._canvas.addConnection(connection, parent, parentIndex);
    return connection;
};
CreateConnectionHandler.prototype.revert = function(context) {
    var connection = context.connection;
    this._canvas.removeConnection(connection);
    connection.source = null;
    connection.target = null;
    return connection;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"h8MoD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CreateElementsHandler);
var _minDash = require("min-dash");
var _elements = require("../../../util/Elements");
/**
 * @typedef {import('../Modeling').default} Modeling
 */ var round = Math.round;
function CreateElementsHandler(modeling) {
    this._modeling = modeling;
}
CreateElementsHandler.$inject = [
    'modeling'
];
CreateElementsHandler.prototype.preExecute = function(context) {
    var elements = context.elements, parent = context.parent, parentIndex = context.parentIndex, position = context.position, hints = context.hints;
    var modeling = this._modeling;
    // make sure each element has x and y
    (0, _minDash.forEach)(elements, function(element) {
        if (!(0, _minDash.isNumber)(element.x)) element.x = 0;
        if (!(0, _minDash.isNumber)(element.y)) element.y = 0;
    });
    var visibleElements = (0, _minDash.filter)(elements, function(element) {
        return !element.hidden;
    });
    var bbox = (0, _elements.getBBox)(visibleElements);
    // center elements around position
    (0, _minDash.forEach)(elements, function(element) {
        if (isConnection(element)) element.waypoints = (0, _minDash.map)(element.waypoints, function(waypoint) {
            return {
                x: round(waypoint.x - bbox.x - bbox.width / 2 + position.x),
                y: round(waypoint.y - bbox.y - bbox.height / 2 + position.y)
            };
        });
        (0, _minDash.assign)(element, {
            x: round(element.x - bbox.x - bbox.width / 2 + position.x),
            y: round(element.y - bbox.y - bbox.height / 2 + position.y)
        });
    });
    var parents = (0, _elements.getParents)(elements);
    var cache = {};
    (0, _minDash.forEach)(elements, function(element) {
        if (isConnection(element)) {
            cache[element.id] = (0, _minDash.isNumber)(parentIndex) ? modeling.createConnection(cache[element.source.id], cache[element.target.id], parentIndex, element, element.parent || parent, hints) : modeling.createConnection(cache[element.source.id], cache[element.target.id], element, element.parent || parent, hints);
            return;
        }
        var createShapeHints = (0, _minDash.assign)({}, hints);
        if (parents.indexOf(element) === -1) createShapeHints.autoResize = false;
        cache[element.id] = (0, _minDash.isNumber)(parentIndex) ? modeling.createShape(element, (0, _minDash.pick)(element, [
            'x',
            'y',
            'width',
            'height'
        ]), element.parent || parent, parentIndex, createShapeHints) : modeling.createShape(element, (0, _minDash.pick)(element, [
            'x',
            'y',
            'width',
            'height'
        ]), element.parent || parent, createShapeHints);
    });
    context.elements = (0, _minDash.values)(cache);
};
// helpers //////////
function isConnection(element) {
    return !!element.waypoints;
}

},{"min-dash":"aEEla","../../../util/Elements":"6qdtl","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bWHxK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CreateLabelHandler);
var _inheritsBrowser = require("inherits-browser");
var _inheritsBrowserDefault = parcelHelpers.interopDefault(_inheritsBrowser);
var _createShapeHandler = require("./CreateShapeHandler");
var _createShapeHandlerDefault = parcelHelpers.interopDefault(_createShapeHandler);
function CreateLabelHandler(canvas) {
    (0, _createShapeHandlerDefault.default).call(this, canvas);
}
(0, _inheritsBrowserDefault.default)(CreateLabelHandler, (0, _createShapeHandlerDefault.default));
CreateLabelHandler.$inject = [
    'canvas'
];
// api //////////////////////
var originalExecute = (0, _createShapeHandlerDefault.default).prototype.execute;
/**
 * Appends a label to a target shape.
 *
 * @method CreateLabelHandler#execute
 *
 * @param {Object} context
 * @param {ElementDescriptor} context.target the element the label is attached to
 * @param {ElementDescriptor} context.parent the parent object
 * @param {Point} context.position position of the new element
 */ CreateLabelHandler.prototype.execute = function(context) {
    var label = context.shape;
    ensureValidDimensions(label);
    label.labelTarget = context.labelTarget;
    return originalExecute.call(this, context);
};
var originalRevert = (0, _createShapeHandlerDefault.default).prototype.revert;
/**
 * Undo append by removing the shape
 */ CreateLabelHandler.prototype.revert = function(context) {
    context.shape.labelTarget = null;
    return originalRevert.call(this, context);
};
// helpers //////////////////////
function ensureValidDimensions(label) {
    // make sure a label has valid { width, height } dimensions
    [
        'width',
        'height'
    ].forEach(function(prop) {
        if (typeof label[prop] === 'undefined') label[prop] = 0;
    });
}

},{"inherits-browser":"hymxq","./CreateShapeHandler":"cGnLc","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cGnLc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CreateShapeHandler);
var _minDash = require("min-dash");
/**
 * @typedef {import('../../../model').Base} Base
 *
 * @typedef {import('../../../util/Types').Point} Point
 *
 * @typedef {import('../../../core/Canvas').default} Canvas
 */ var round = Math.round;
function CreateShapeHandler(canvas) {
    this._canvas = canvas;
}
CreateShapeHandler.$inject = [
    'canvas'
];
// api //////////////////////
/**
 * Appends a shape to a target shape
 *
 * @param {Object} context
 * @param {Base} context.parent The parent.
 * @param {Point} context.position The position at which to create the new shape.
 * @param {number} [context.parentIndex] The optional index at which to add the
 * shape to the parent's children.
 */ CreateShapeHandler.prototype.execute = function(context) {
    var shape = context.shape, positionOrBounds = context.position, parent = context.parent, parentIndex = context.parentIndex;
    if (!parent) throw new Error('parent required');
    if (!positionOrBounds) throw new Error('position required');
    // (1) add at event center position _or_ at given bounds
    if (positionOrBounds.width !== undefined) (0, _minDash.assign)(shape, positionOrBounds);
    else (0, _minDash.assign)(shape, {
        x: positionOrBounds.x - round(shape.width / 2),
        y: positionOrBounds.y - round(shape.height / 2)
    });
    // (2) add to canvas
    this._canvas.addShape(shape, parent, parentIndex);
    return shape;
};
/**
 * Undo append by removing the shape
 */ CreateShapeHandler.prototype.revert = function(context) {
    var shape = context.shape;
    // (3) remove form canvas
    this._canvas.removeShape(shape);
    return shape;
};

},{"min-dash":"aEEla","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jAGCH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DeleteConnectionHandler);
var _collections = require("../../../util/Collections");
var _removal = require("../../../util/Removal");
function DeleteConnectionHandler(canvas, modeling) {
    this._canvas = canvas;
    this._modeling = modeling;
}
DeleteConnectionHandler.$inject = [
    'canvas',
    'modeling'
];
/**
 * - Remove connections
 */ DeleteConnectionHandler.prototype.preExecute = function(context) {
    var modeling = this._modeling;
    var connection = context.connection;
    // remove connections
    (0, _removal.saveClear)(connection.incoming, function(connection) {
        // To make sure that the connection isn't removed twice
        // For example if a container is removed
        modeling.removeConnection(connection, {
            nested: true
        });
    });
    (0, _removal.saveClear)(connection.outgoing, function(connection) {
        modeling.removeConnection(connection, {
            nested: true
        });
    });
};
DeleteConnectionHandler.prototype.execute = function(context) {
    var connection = context.connection, parent = connection.parent;
    context.parent = parent;
    // remember containment
    context.parentIndex = (0, _collections.indexOf)(parent.children, connection);
    context.source = connection.source;
    context.target = connection.target;
    this._canvas.removeConnection(connection);
    connection.source = null;
    connection.target = null;
    return connection;
};
/**
 * Command revert implementation.
 */ DeleteConnectionHandler.prototype.revert = function(context) {
    var connection = context.connection, parent = context.parent, parentIndex = context.parentIndex;
    connection.source = context.source;
    connection.target = context.target;
    // restore containment
    (0, _collections.add)(parent.children, connection, parentIndex);
    this._canvas.addConnection(connection, parent);
    return connection;
};

},{"../../../util/Collections":"kRUAD","../../../util/Removal":"8An0B","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gts1j":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DeleteElementsHandler);
var _minDash = require("min-dash");
function DeleteElementsHandler(modeling, elementRegistry) {
    this._modeling = modeling;
    this._elementRegistry = elementRegistry;
}
DeleteElementsHandler.$inject = [
    'modeling',
    'elementRegistry'
];
DeleteElementsHandler.prototype.postExecute = function(context) {
    var modeling = this._modeling, elementRegistry = this._elementRegistry, elements = context.elements;
    (0, _minDash.forEach)(elements, function(element) {
        // element may have been removed with previous
        // remove operations already (e.g. in case of nesting)
        if (!elementRegistry.get(element.id)) return;
        if (element.waypoints) modeling.removeConnection(element);
        else modeling.removeShape(element);
    });
};

},{"min-dash":"aEEla","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6LHQc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DeleteShapeHandler);
var _collections = require("../../../util/Collections");
var _removal = require("../../../util/Removal");
function DeleteShapeHandler(canvas, modeling) {
    this._canvas = canvas;
    this._modeling = modeling;
}
DeleteShapeHandler.$inject = [
    'canvas',
    'modeling'
];
/**
 * - Remove connections
 * - Remove all direct children
 */ DeleteShapeHandler.prototype.preExecute = function(context) {
    var modeling = this._modeling;
    var shape = context.shape;
    // remove connections
    (0, _removal.saveClear)(shape.incoming, function(connection) {
        // To make sure that the connection isn't removed twice
        // For example if a container is removed
        modeling.removeConnection(connection, {
            nested: true
        });
    });
    (0, _removal.saveClear)(shape.outgoing, function(connection) {
        modeling.removeConnection(connection, {
            nested: true
        });
    });
    // remove child shapes and connections
    (0, _removal.saveClear)(shape.children, function(child) {
        if (isConnection(child)) modeling.removeConnection(child, {
            nested: true
        });
        else modeling.removeShape(child, {
            nested: true
        });
    });
};
/**
 * Remove shape and remember the parent
 */ DeleteShapeHandler.prototype.execute = function(context) {
    var canvas = this._canvas;
    var shape = context.shape, oldParent = shape.parent;
    context.oldParent = oldParent;
    // remove containment
    context.oldParentIndex = (0, _collections.indexOf)(oldParent.children, shape);
    // remove shape
    canvas.removeShape(shape);
    return shape;
};
/**
 * Command revert implementation
 */ DeleteShapeHandler.prototype.revert = function(context) {
    var canvas = this._canvas;
    var shape = context.shape, oldParent = context.oldParent, oldParentIndex = context.oldParentIndex;
    // restore containment
    (0, _collections.add)(oldParent.children, shape, oldParentIndex);
    canvas.addShape(shape, oldParent);
    return shape;
};
function isConnection(element) {
    return element.waypoints;
}

},{"../../../util/Collections":"kRUAD","../../../util/Removal":"8An0B","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cPBEX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DistributeElements);
var _minDash = require("min-dash");
function DistributeElements(modeling) {
    this._modeling = modeling;
}
DistributeElements.$inject = [
    'modeling'
];
var OFF_AXIS = {
    x: 'y',
    y: 'x'
};
DistributeElements.prototype.preExecute = function(context) {
    var modeling = this._modeling;
    var groups = context.groups, axis = context.axis, dimension = context.dimension;
    function updateRange(group, element) {
        group.range.min = Math.min(element[axis], group.range.min);
        group.range.max = Math.max(element[axis] + element[dimension], group.range.max);
    }
    function center(element) {
        return element[axis] + element[dimension] / 2;
    }
    function lastIdx(arr) {
        return arr.length - 1;
    }
    function rangeDiff(range) {
        return range.max - range.min;
    }
    function centerElement(refCenter, element) {
        var delta = {
            y: 0
        };
        delta[axis] = refCenter - center(element);
        if (delta[axis]) {
            delta[OFF_AXIS[axis]] = 0;
            modeling.moveElements([
                element
            ], delta, element.parent);
        }
    }
    var firstGroup = groups[0], lastGroupIdx = lastIdx(groups), lastGroup = groups[lastGroupIdx];
    var margin, spaceInBetween, groupsSize = 0; // the size of each range
    (0, _minDash.forEach)(groups, function(group, idx) {
        var sortedElements, refElem, refCenter;
        if (group.elements.length < 2) {
            if (idx && idx !== groups.length - 1) {
                updateRange(group, group.elements[0]);
                groupsSize += rangeDiff(group.range);
            }
            return;
        }
        sortedElements = (0, _minDash.sortBy)(group.elements, axis);
        refElem = sortedElements[0];
        if (idx === lastGroupIdx) refElem = sortedElements[lastIdx(sortedElements)];
        refCenter = center(refElem);
        // wanna update the ranges after the shapes have been centered
        group.range = null;
        (0, _minDash.forEach)(sortedElements, function(element) {
            centerElement(refCenter, element);
            if (group.range === null) {
                group.range = {
                    min: element[axis],
                    max: element[axis] + element[dimension]
                };
                return;
            }
            // update group's range after centering the range elements
            updateRange(group, element);
        });
        if (idx && idx !== groups.length - 1) groupsSize += rangeDiff(group.range);
    });
    spaceInBetween = Math.abs(lastGroup.range.min - firstGroup.range.max);
    margin = Math.round((spaceInBetween - groupsSize) / (groups.length - 1));
    if (margin < groups.length - 1) return;
    (0, _minDash.forEach)(groups, function(group, groupIdx) {
        var delta = {}, prevGroup;
        if (group === firstGroup || group === lastGroup) return;
        prevGroup = groups[groupIdx - 1];
        group.range.max = 0;
        (0, _minDash.forEach)(group.elements, function(element, idx) {
            delta[OFF_AXIS[axis]] = 0;
            delta[axis] = prevGroup.range.max - element[axis] + margin;
            if (group.range.min !== element[axis]) delta[axis] += element[axis] - group.range.min;
            if (delta[axis]) modeling.moveElements([
                element
            ], delta, element.parent);
            group.range.max = Math.max(element[axis] + element[dimension], idx ? group.range.max : 0);
        });
    });
};
DistributeElements.prototype.postExecute = function(context) {};

},{"min-dash":"aEEla","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8wuNR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>LayoutConnectionHandler);
var _minDash = require("min-dash");
function LayoutConnectionHandler(layouter, canvas) {
    this._layouter = layouter;
    this._canvas = canvas;
}
LayoutConnectionHandler.$inject = [
    'layouter',
    'canvas'
];
LayoutConnectionHandler.prototype.execute = function(context) {
    var connection = context.connection;
    var oldWaypoints = connection.waypoints;
    (0, _minDash.assign)(context, {
        oldWaypoints: oldWaypoints
    });
    connection.waypoints = this._layouter.layoutConnection(connection, context.hints);
    return connection;
};
LayoutConnectionHandler.prototype.revert = function(context) {
    var connection = context.connection;
    connection.waypoints = context.oldWaypoints;
    return connection;
};

},{"min-dash":"aEEla","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8yfwx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>MoveConnectionHandler);
var _minDash = require("min-dash");
var _collections = require("../../../util/Collections");
function MoveConnectionHandler() {}
MoveConnectionHandler.prototype.execute = function(context) {
    var connection = context.connection, delta = context.delta;
    var newParent = context.newParent || connection.parent, newParentIndex = context.newParentIndex, oldParent = connection.parent;
    // save old parent in context
    context.oldParent = oldParent;
    context.oldParentIndex = (0, _collections.remove)(oldParent.children, connection);
    // add to new parent at position
    (0, _collections.add)(newParent.children, connection, newParentIndex);
    // update parent
    connection.parent = newParent;
    // update waypoint positions
    (0, _minDash.forEach)(connection.waypoints, function(p) {
        p.x += delta.x;
        p.y += delta.y;
        if (p.original) {
            p.original.x += delta.x;
            p.original.y += delta.y;
        }
    });
    return connection;
};
MoveConnectionHandler.prototype.revert = function(context) {
    var connection = context.connection, newParent = connection.parent, oldParent = context.oldParent, oldParentIndex = context.oldParentIndex, delta = context.delta;
    // remove from newParent
    (0, _collections.remove)(newParent.children, connection);
    // restore previous location in old parent
    (0, _collections.add)(oldParent.children, connection, oldParentIndex);
    // restore parent
    connection.parent = oldParent;
    // revert to old waypoint positions
    (0, _minDash.forEach)(connection.waypoints, function(p) {
        p.x -= delta.x;
        p.y -= delta.y;
        if (p.original) {
            p.original.x -= delta.x;
            p.original.y -= delta.y;
        }
    });
    return connection;
};

},{"min-dash":"aEEla","../../../util/Collections":"kRUAD","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"044bl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>MoveElementsHandler);
var _moveHelper = require("./helper/MoveHelper");
var _moveHelperDefault = parcelHelpers.interopDefault(_moveHelper);
function MoveElementsHandler(modeling) {
    this._helper = new (0, _moveHelperDefault.default)(modeling);
}
MoveElementsHandler.$inject = [
    'modeling'
];
MoveElementsHandler.prototype.preExecute = function(context) {
    context.closure = this._helper.getClosure(context.shapes);
};
MoveElementsHandler.prototype.postExecute = function(context) {
    var hints = context.hints, primaryShape;
    if (hints && hints.primaryShape) {
        primaryShape = hints.primaryShape;
        hints.oldParent = primaryShape.parent;
    }
    this._helper.moveClosure(context.closure, context.delta, context.newParent, context.newHost, primaryShape);
};

},{"./helper/MoveHelper":"gE7ir","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gE7ir":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>MoveHelper);
var _minDash = require("min-dash");
var _anchorsHelper = require("./AnchorsHelper");
var _moveClosure = require("./MoveClosure");
var _moveClosureDefault = parcelHelpers.interopDefault(_moveClosure);
function MoveHelper(modeling) {
    this._modeling = modeling;
}
/**
 * Move the specified elements and all children by the given delta.
 *
 * This moves all enclosed connections, too and layouts all affected
 * external connections.
 *
 * @param {Base[]} elements
 * @param {Point} delta
 * @param {Shape} newParent The new parent of all elements that are not nested.
 *
 * @return {Base[]}
 */ MoveHelper.prototype.moveRecursive = function(elements, delta, newParent) {
    if (!elements) return [];
    else return this.moveClosure(this.getClosure(elements), delta, newParent);
};
/**
 * Move the given closure of elmements.
 *
 * @param {Object} closure
 * @param {Point} delta
 * @param {Shape} [newParent]
 * @param {Shape} [newHost]
 */ MoveHelper.prototype.moveClosure = function(closure, delta, newParent, newHost, primaryShape) {
    var modeling = this._modeling;
    var allShapes = closure.allShapes, allConnections = closure.allConnections, enclosedConnections = closure.enclosedConnections, topLevel = closure.topLevel, keepParent = false;
    if (primaryShape && primaryShape.parent === newParent) keepParent = true;
    // move all shapes
    (0, _minDash.forEach)(allShapes, function(shape) {
        // move the element according to the given delta
        modeling.moveShape(shape, delta, topLevel[shape.id] && !keepParent && newParent, {
            recurse: false,
            layout: false
        });
    });
    // move all child connections / layout external connections
    (0, _minDash.forEach)(allConnections, function(c) {
        var sourceMoved = !!allShapes[c.source.id], targetMoved = !!allShapes[c.target.id];
        if (enclosedConnections[c.id] && sourceMoved && targetMoved) modeling.moveConnection(c, delta, topLevel[c.id] && !keepParent && newParent);
        else modeling.layoutConnection(c, {
            connectionStart: sourceMoved && (0, _anchorsHelper.getMovedSourceAnchor)(c, c.source, delta),
            connectionEnd: targetMoved && (0, _anchorsHelper.getMovedTargetAnchor)(c, c.target, delta)
        });
    });
};
/**
 * Returns the closure for the selected elements
 *
 * @param {Base[]} elements
 *
 * @return {MoveClosure}
 */ MoveHelper.prototype.getClosure = function(elements) {
    return new (0, _moveClosureDefault.default)().addAll(elements, true);
};

},{"min-dash":"aEEla","./AnchorsHelper":"1OucE","./MoveClosure":"ea59Q","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ea59Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>MoveClosure);
var _minDash = require("min-dash");
var _elements = require("../../../../util/Elements");
function MoveClosure() {
    this.allShapes = {};
    this.allConnections = {};
    this.enclosedElements = {};
    this.enclosedConnections = {};
    this.topLevel = {};
}
MoveClosure.prototype.add = function(element, isTopLevel) {
    return this.addAll([
        element
    ], isTopLevel);
};
MoveClosure.prototype.addAll = function(elements, isTopLevel) {
    var newClosure = (0, _elements.getClosure)(elements, !!isTopLevel, this);
    (0, _minDash.assign)(this, newClosure);
    return this;
};

},{"min-dash":"aEEla","../../../../util/Elements":"6qdtl","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9VSh3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>MoveShapeHandler);
var _minDash = require("min-dash");
var _moveHelper = require("./helper/MoveHelper");
var _moveHelperDefault = parcelHelpers.interopDefault(_moveHelper);
var _collections = require("../../../util/Collections");
var _anchorsHelper = require("./helper/AnchorsHelper");
function MoveShapeHandler(modeling) {
    this._modeling = modeling;
    this._helper = new (0, _moveHelperDefault.default)(modeling);
}
MoveShapeHandler.$inject = [
    'modeling'
];
MoveShapeHandler.prototype.execute = function(context) {
    var shape = context.shape, delta = context.delta, newParent = context.newParent || shape.parent, newParentIndex = context.newParentIndex, oldParent = shape.parent;
    context.oldBounds = (0, _minDash.pick)(shape, [
        'x',
        'y',
        'width',
        'height'
    ]);
    // save old parent in context
    context.oldParent = oldParent;
    context.oldParentIndex = (0, _collections.remove)(oldParent.children, shape);
    // add to new parent at position
    (0, _collections.add)(newParent.children, shape, newParentIndex);
    // update shape parent + position
    (0, _minDash.assign)(shape, {
        parent: newParent,
        x: shape.x + delta.x,
        y: shape.y + delta.y
    });
    return shape;
};
MoveShapeHandler.prototype.postExecute = function(context) {
    var shape = context.shape, delta = context.delta, hints = context.hints;
    var modeling = this._modeling;
    if (hints.layout !== false) {
        (0, _minDash.forEach)(shape.incoming, function(c) {
            modeling.layoutConnection(c, {
                connectionEnd: (0, _anchorsHelper.getMovedTargetAnchor)(c, shape, delta)
            });
        });
        (0, _minDash.forEach)(shape.outgoing, function(c) {
            modeling.layoutConnection(c, {
                connectionStart: (0, _anchorsHelper.getMovedSourceAnchor)(c, shape, delta)
            });
        });
    }
    if (hints.recurse !== false) this.moveChildren(context);
};
MoveShapeHandler.prototype.revert = function(context) {
    var shape = context.shape, oldParent = context.oldParent, oldParentIndex = context.oldParentIndex, delta = context.delta;
    // restore previous location in old parent
    (0, _collections.add)(oldParent.children, shape, oldParentIndex);
    // revert to old position and parent
    (0, _minDash.assign)(shape, {
        parent: oldParent,
        x: shape.x - delta.x,
        y: shape.y - delta.y
    });
    return shape;
};
MoveShapeHandler.prototype.moveChildren = function(context) {
    var delta = context.delta, shape = context.shape;
    this._helper.moveRecursive(shape.children, delta, null);
};
MoveShapeHandler.prototype.getNewParent = function(context) {
    return context.newParent || context.shape.parent;
};

},{"min-dash":"aEEla","./helper/MoveHelper":"gE7ir","../../../util/Collections":"kRUAD","./helper/AnchorsHelper":"1OucE","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3bkhl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ReconnectConnectionHandler);
var _minDash = require("min-dash");
function ReconnectConnectionHandler(modeling) {
    this._modeling = modeling;
}
ReconnectConnectionHandler.$inject = [
    'modeling'
];
ReconnectConnectionHandler.prototype.execute = function(context) {
    var newSource = context.newSource, newTarget = context.newTarget, connection = context.connection, dockingOrPoints = context.dockingOrPoints;
    if (!newSource && !newTarget) throw new Error('newSource or newTarget required');
    if ((0, _minDash.isArray)(dockingOrPoints)) {
        context.oldWaypoints = connection.waypoints;
        connection.waypoints = dockingOrPoints;
    }
    if (newSource) {
        context.oldSource = connection.source;
        connection.source = newSource;
    }
    if (newTarget) {
        context.oldTarget = connection.target;
        connection.target = newTarget;
    }
    return connection;
};
ReconnectConnectionHandler.prototype.postExecute = function(context) {
    var connection = context.connection, newSource = context.newSource, newTarget = context.newTarget, dockingOrPoints = context.dockingOrPoints, hints = context.hints || {};
    var layoutConnectionHints = {};
    if (hints.connectionStart) layoutConnectionHints.connectionStart = hints.connectionStart;
    if (hints.connectionEnd) layoutConnectionHints.connectionEnd = hints.connectionEnd;
    if (hints.layoutConnection === false) return;
    if (newSource && (!newTarget || hints.docking === 'source')) layoutConnectionHints.connectionStart = layoutConnectionHints.connectionStart || getDocking((0, _minDash.isArray)(dockingOrPoints) ? dockingOrPoints[0] : dockingOrPoints);
    if (newTarget && (!newSource || hints.docking === 'target')) layoutConnectionHints.connectionEnd = layoutConnectionHints.connectionEnd || getDocking((0, _minDash.isArray)(dockingOrPoints) ? dockingOrPoints[dockingOrPoints.length - 1] : dockingOrPoints);
    if (hints.newWaypoints) layoutConnectionHints.waypoints = hints.newWaypoints;
    this._modeling.layoutConnection(connection, layoutConnectionHints);
};
ReconnectConnectionHandler.prototype.revert = function(context) {
    var oldSource = context.oldSource, oldTarget = context.oldTarget, oldWaypoints = context.oldWaypoints, connection = context.connection;
    if (oldSource) connection.source = oldSource;
    if (oldTarget) connection.target = oldTarget;
    if (oldWaypoints) connection.waypoints = oldWaypoints;
    return connection;
};
// helpers //////////
function getDocking(point) {
    return point.original || point;
}

},{"min-dash":"aEEla","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8JPbG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ReplaceShapeHandler);
var _minDash = require("min-dash");
var _anchorsHelper = require("./helper/AnchorsHelper");
function ReplaceShapeHandler(modeling, rules) {
    this._modeling = modeling;
    this._rules = rules;
}
ReplaceShapeHandler.$inject = [
    'modeling',
    'rules'
];
/**
 * Add new shape.
 *
 * @param {Object} context
 * @param {Shape} context.oldShape
 * @param {Object} context.newData
 * @param {string} context.newData.type
 * @param {number} context.newData.x
 * @param {number} context.newData.y
 * @param {Object} [hints]
 */ ReplaceShapeHandler.prototype.preExecute = function(context) {
    var self = this, modeling = this._modeling, rules = this._rules;
    var oldShape = context.oldShape, newData = context.newData, hints = context.hints || {}, newShape;
    function canReconnect(source, target, connection) {
        return rules.allowed('connection.reconnect', {
            connection: connection,
            source: source,
            target: target
        });
    }
    // (1) add new shape at given position
    var position = {
        x: newData.x,
        y: newData.y
    };
    var oldBounds = {
        x: oldShape.x,
        y: oldShape.y,
        width: oldShape.width,
        height: oldShape.height
    };
    newShape = context.newShape = context.newShape || self.createShape(newData, position, oldShape.parent, hints);
    // (2) update host
    if (oldShape.host) modeling.updateAttachment(newShape, oldShape.host);
    // (3) adopt all children from old shape
    var children;
    if (hints.moveChildren !== false) {
        children = oldShape.children.slice();
        modeling.moveElements(children, {
            x: 0,
            y: 0
        }, newShape, hints);
    }
    // (4) reconnect connections to new shape if possible
    var incoming = oldShape.incoming.slice(), outgoing = oldShape.outgoing.slice();
    (0, _minDash.forEach)(incoming, function(connection) {
        var source = connection.source, allowed = canReconnect(source, newShape, connection);
        if (allowed) self.reconnectEnd(connection, newShape, (0, _anchorsHelper.getResizedTargetAnchor)(connection, newShape, oldBounds), hints);
    });
    (0, _minDash.forEach)(outgoing, function(connection) {
        var target = connection.target, allowed = canReconnect(newShape, target, connection);
        if (allowed) self.reconnectStart(connection, newShape, (0, _anchorsHelper.getResizedSourceAnchor)(connection, newShape, oldBounds), hints);
    });
};
/**
 * Remove old shape.
 */ ReplaceShapeHandler.prototype.postExecute = function(context) {
    var oldShape = context.oldShape;
    this._modeling.removeShape(oldShape);
};
ReplaceShapeHandler.prototype.execute = function(context) {};
ReplaceShapeHandler.prototype.revert = function(context) {};
ReplaceShapeHandler.prototype.createShape = function(shape, position, target, hints) {
    return this._modeling.createShape(shape, position, target, hints);
};
ReplaceShapeHandler.prototype.reconnectStart = function(connection, newSource, dockingPoint, hints) {
    this._modeling.reconnectStart(connection, newSource, dockingPoint, hints);
};
ReplaceShapeHandler.prototype.reconnectEnd = function(connection, newTarget, dockingPoint, hints) {
    this._modeling.reconnectEnd(connection, newTarget, dockingPoint, hints);
};

},{"min-dash":"aEEla","./helper/AnchorsHelper":"1OucE","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"EaDUl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ResizeShapeHandler);
var _minDash = require("min-dash");
var _anchorsHelper = require("./helper/AnchorsHelper");
function ResizeShapeHandler(modeling) {
    this._modeling = modeling;
}
ResizeShapeHandler.$inject = [
    'modeling'
];
/**
 * {
 *   shape: {....}
 *   newBounds: {
 *     width:  20,
 *     height: 40,
 *     x:       5,
 *     y:      10
 *   }
 *
 * }
 */ ResizeShapeHandler.prototype.execute = function(context) {
    var shape = context.shape, newBounds = context.newBounds, minBounds = context.minBounds;
    if (newBounds.x === undefined || newBounds.y === undefined || newBounds.width === undefined || newBounds.height === undefined) throw new Error('newBounds must have {x, y, width, height} properties');
    if (minBounds && (newBounds.width < minBounds.width || newBounds.height < minBounds.height)) throw new Error('width and height cannot be less than minimum height and width');
    else if (!minBounds && newBounds.width < 10 || newBounds.height < 10) throw new Error('width and height cannot be less than 10px');
    // save old bbox in context
    context.oldBounds = {
        width: shape.width,
        height: shape.height,
        x: shape.x,
        y: shape.y
    };
    // update shape
    (0, _minDash.assign)(shape, {
        width: newBounds.width,
        height: newBounds.height,
        x: newBounds.x,
        y: newBounds.y
    });
    return shape;
};
ResizeShapeHandler.prototype.postExecute = function(context) {
    var modeling = this._modeling;
    var shape = context.shape, oldBounds = context.oldBounds, hints = context.hints || {};
    if (hints.layout === false) return;
    (0, _minDash.forEach)(shape.incoming, function(c) {
        modeling.layoutConnection(c, {
            connectionEnd: (0, _anchorsHelper.getResizedTargetAnchor)(c, shape, oldBounds)
        });
    });
    (0, _minDash.forEach)(shape.outgoing, function(c) {
        modeling.layoutConnection(c, {
            connectionStart: (0, _anchorsHelper.getResizedSourceAnchor)(c, shape, oldBounds)
        });
    });
};
ResizeShapeHandler.prototype.revert = function(context) {
    var shape = context.shape, oldBounds = context.oldBounds;
    // restore previous bbox
    (0, _minDash.assign)(shape, {
        width: oldBounds.width,
        height: oldBounds.height,
        x: oldBounds.x,
        y: oldBounds.y
    });
    return shape;
};

},{"min-dash":"aEEla","./helper/AnchorsHelper":"1OucE","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9evJX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SpaceToolHandler);
var _minDash = require("min-dash");
var _spaceUtil = require("../../space-tool/SpaceUtil");
var _anchorsHelper = require("./helper/AnchorsHelper");
function SpaceToolHandler(modeling) {
    this._modeling = modeling;
}
SpaceToolHandler.$inject = [
    'modeling'
];
SpaceToolHandler.prototype.preExecute = function(context) {
    var delta = context.delta, direction = context.direction, movingShapes = context.movingShapes, resizingShapes = context.resizingShapes, start = context.start, oldBounds = {};
    // (1) move shapes
    this.moveShapes(movingShapes, delta);
    // (2a) save old bounds of resized shapes
    (0, _minDash.forEach)(resizingShapes, function(shape) {
        oldBounds[shape.id] = getBounds(shape);
    });
    // (2b) resize shapes
    this.resizeShapes(resizingShapes, delta, direction);
    // (3) update connection waypoints
    this.updateConnectionWaypoints((0, _spaceUtil.getWaypointsUpdatingConnections)(movingShapes, resizingShapes), delta, direction, start, movingShapes, resizingShapes, oldBounds);
};
SpaceToolHandler.prototype.execute = function() {};
SpaceToolHandler.prototype.revert = function() {};
SpaceToolHandler.prototype.moveShapes = function(shapes, delta) {
    var self = this;
    (0, _minDash.forEach)(shapes, function(element) {
        self._modeling.moveShape(element, delta, null, {
            autoResize: false,
            layout: false,
            recurse: false
        });
    });
};
SpaceToolHandler.prototype.resizeShapes = function(shapes, delta, direction) {
    var self = this;
    (0, _minDash.forEach)(shapes, function(shape) {
        var newBounds = (0, _spaceUtil.resizeBounds)(shape, direction, delta);
        self._modeling.resizeShape(shape, newBounds, null, {
            attachSupport: false,
            autoResize: false,
            layout: false
        });
    });
};
/**
 * Update connections waypoints according to the rules:
 *   1. Both source and target are moved/resized => move waypoints by the delta
 *   2. Only one of source and target is moved/resized => re-layout connection with moved start/end
 */ SpaceToolHandler.prototype.updateConnectionWaypoints = function(connections, delta, direction, start, movingShapes, resizingShapes, oldBounds) {
    var self = this, affectedShapes = movingShapes.concat(resizingShapes);
    (0, _minDash.forEach)(connections, function(connection) {
        var source = connection.source, target = connection.target, waypoints = copyWaypoints(connection), axis = getAxisFromDirection(direction), layoutHints = {};
        if (includes(affectedShapes, source) && includes(affectedShapes, target)) {
            // move waypoints
            waypoints = (0, _minDash.map)(waypoints, function(waypoint) {
                if (shouldMoveWaypoint(waypoint, start, direction)) // move waypoint
                waypoint[axis] = waypoint[axis] + delta[axis];
                if (waypoint.original && shouldMoveWaypoint(waypoint.original, start, direction)) // move waypoint original
                waypoint.original[axis] = waypoint.original[axis] + delta[axis];
                return waypoint;
            });
            self._modeling.updateWaypoints(connection, waypoints, {
                labelBehavior: false
            });
        } else if (includes(affectedShapes, source) || includes(affectedShapes, target)) {
            // re-layout connection with moved start/end
            if (includes(movingShapes, source)) layoutHints.connectionStart = (0, _anchorsHelper.getMovedSourceAnchor)(connection, source, delta);
            else if (includes(movingShapes, target)) layoutHints.connectionEnd = (0, _anchorsHelper.getMovedTargetAnchor)(connection, target, delta);
            else if (includes(resizingShapes, source)) layoutHints.connectionStart = (0, _anchorsHelper.getResizedSourceAnchor)(connection, source, oldBounds[source.id]);
            else if (includes(resizingShapes, target)) layoutHints.connectionEnd = (0, _anchorsHelper.getResizedTargetAnchor)(connection, target, oldBounds[target.id]);
            self._modeling.layoutConnection(connection, layoutHints);
        }
    });
};
// helpers //////////
function copyWaypoint(waypoint) {
    return (0, _minDash.assign)({}, waypoint);
}
function copyWaypoints(connection) {
    return (0, _minDash.map)(connection.waypoints, function(waypoint) {
        waypoint = copyWaypoint(waypoint);
        if (waypoint.original) waypoint.original = copyWaypoint(waypoint.original);
        return waypoint;
    });
}
function getAxisFromDirection(direction) {
    switch(direction){
        case 'n':
            return 'y';
        case 'w':
            return 'x';
        case 's':
            return 'y';
        case 'e':
            return 'x';
    }
}
function shouldMoveWaypoint(waypoint, start, direction) {
    var relevantAxis = getAxisFromDirection(direction);
    if (/e|s/.test(direction)) return waypoint[relevantAxis] > start;
    else if (/n|w/.test(direction)) return waypoint[relevantAxis] < start;
}
function includes(array, item) {
    return array.indexOf(item) !== -1;
}
function getBounds(shape) {
    return {
        x: shape.x,
        y: shape.y,
        height: shape.height,
        width: shape.width
    };
}

},{"min-dash":"aEEla","../../space-tool/SpaceUtil":"c2aHY","./helper/AnchorsHelper":"1OucE","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2rzPb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ToggleShapeCollapseHandler);
var _minDash = require("min-dash");
function ToggleShapeCollapseHandler(modeling) {
    this._modeling = modeling;
}
ToggleShapeCollapseHandler.$inject = [
    'modeling'
];
ToggleShapeCollapseHandler.prototype.execute = function(context) {
    var shape = context.shape, children = shape.children;
    // recursively remember previous visibility of children
    context.oldChildrenVisibility = getElementsVisibilityRecursive(children);
    // toggle state
    shape.collapsed = !shape.collapsed;
    // recursively hide/show children
    var result = setHiddenRecursive(children, shape.collapsed);
    return [
        shape
    ].concat(result);
};
ToggleShapeCollapseHandler.prototype.revert = function(context) {
    var shape = context.shape, oldChildrenVisibility = context.oldChildrenVisibility;
    var children = shape.children;
    // recursively set old visability of children
    var result = restoreVisibilityRecursive(children, oldChildrenVisibility);
    // retoggle state
    shape.collapsed = !shape.collapsed;
    return [
        shape
    ].concat(result);
};
// helpers //////////////////////
/**
 * Return a map { elementId -> hiddenState}.
 *
 * @param {Array<Shape>} elements
 *
 * @return {Object}
 */ function getElementsVisibilityRecursive(elements) {
    var result = {};
    (0, _minDash.forEach)(elements, function(element) {
        result[element.id] = element.hidden;
        if (element.children) result = (0, _minDash.assign)({}, result, getElementsVisibilityRecursive(element.children));
    });
    return result;
}
function setHiddenRecursive(elements, newHidden) {
    var result = [];
    (0, _minDash.forEach)(elements, function(element) {
        element.hidden = newHidden;
        result = result.concat(element);
        if (element.children) result = result.concat(setHiddenRecursive(element.children, element.collapsed || newHidden));
    });
    return result;
}
function restoreVisibilityRecursive(elements, lastState) {
    var result = [];
    (0, _minDash.forEach)(elements, function(element) {
        element.hidden = lastState[element.id];
        result = result.concat(element);
        if (element.children) result = result.concat(restoreVisibilityRecursive(element.children, lastState));
    });
    return result;
}

},{"min-dash":"aEEla","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2xlJx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>UpdateAttachmentHandler);
var _collections = require("../../../util/Collections");
function UpdateAttachmentHandler(modeling) {
    this._modeling = modeling;
}
UpdateAttachmentHandler.$inject = [
    'modeling'
];
UpdateAttachmentHandler.prototype.execute = function(context) {
    var shape = context.shape, newHost = context.newHost, oldHost = shape.host;
    // (0) detach from old host
    context.oldHost = oldHost;
    context.attacherIdx = removeAttacher(oldHost, shape);
    // (1) attach to new host
    addAttacher(newHost, shape);
    // (2) update host
    shape.host = newHost;
    return shape;
};
UpdateAttachmentHandler.prototype.revert = function(context) {
    var shape = context.shape, newHost = context.newHost, oldHost = context.oldHost, attacherIdx = context.attacherIdx;
    // (2) update host
    shape.host = oldHost;
    // (1) attach to new host
    removeAttacher(newHost, shape);
    // (0) detach from old host
    addAttacher(oldHost, shape, attacherIdx);
    return shape;
};
function removeAttacher(host, attacher) {
    // remove attacher from host
    return (0, _collections.remove)(host && host.attachers, attacher);
}
function addAttacher(host, attacher, idx) {
    if (!host) return;
    var attachers = host.attachers;
    if (!attachers) host.attachers = attachers = [];
    (0, _collections.add)(attachers, attacher, idx);
}

},{"../../../util/Collections":"kRUAD","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aFPAm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>UpdateWaypointsHandler);
function UpdateWaypointsHandler() {}
UpdateWaypointsHandler.prototype.execute = function(context) {
    var connection = context.connection, newWaypoints = context.newWaypoints;
    context.oldWaypoints = connection.waypoints;
    connection.waypoints = newWaypoints;
    return connection;
};
UpdateWaypointsHandler.prototype.revert = function(context) {
    var connection = context.connection, oldWaypoints = context.oldWaypoints;
    connection.waypoints = oldWaypoints;
    return connection;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1EE4N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>UpdateModdlePropertiesHandler);
var _minDash = require("min-dash");
var _modelUtil = require("../../../util/ModelUtil");
function UpdateModdlePropertiesHandler(elementRegistry) {
    this._elementRegistry = elementRegistry;
}
UpdateModdlePropertiesHandler.$inject = [
    'elementRegistry'
];
UpdateModdlePropertiesHandler.prototype.execute = function(context) {
    var element = context.element, moddleElement = context.moddleElement, properties = context.properties;
    if (!moddleElement) throw new Error('<moddleElement> required');
    // TODO(nikku): we need to ensure that ID properties
    // are properly registered / unregistered via
    // this._moddle.ids.assigned(id)
    var changed = context.changed || this.getVisualReferences(moddleElement).concat(element);
    var oldProperties = context.oldProperties || getModdleProperties(moddleElement, (0, _minDash.keys)(properties));
    setModdleProperties(moddleElement, properties);
    context.oldProperties = oldProperties;
    context.changed = changed;
    return changed;
};
UpdateModdlePropertiesHandler.prototype.revert = function(context) {
    var oldProperties = context.oldProperties, moddleElement = context.moddleElement, changed = context.changed;
    setModdleProperties(moddleElement, oldProperties);
    return changed;
};
/**
 * Return visual references of given moddle element within the diagram.
 *
 * @param {ModdleElement} moddleElement
 *
 * @return {Array<djs.model.Element>}
 */ UpdateModdlePropertiesHandler.prototype.getVisualReferences = function(moddleElement) {
    var elementRegistry = this._elementRegistry;
    if ((0, _modelUtil.is)(moddleElement, 'bpmn:DataObject')) return getAllDataObjectReferences(moddleElement, elementRegistry);
    return [];
};
// helpers /////////////////
function getModdleProperties(moddleElement, propertyNames) {
    return (0, _minDash.reduce)(propertyNames, function(result, key) {
        result[key] = moddleElement.get(key);
        return result;
    }, {});
}
function setModdleProperties(moddleElement, properties) {
    (0, _minDash.forEach)(properties, function(value, key) {
        moddleElement.set(key, value);
    });
}
function getAllDataObjectReferences(dataObject, elementRegistry) {
    return elementRegistry.filter(function(element) {
        return (0, _modelUtil.is)(element, 'bpmn:DataObjectReference') && (0, _modelUtil.getBusinessObject)(element).dataObjectRef === dataObject;
    });
}

},{"min-dash":"aEEla","../../../util/ModelUtil":"klNYN","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"h4dL9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>UpdatePropertiesHandler);
var _minDash = require("min-dash");
var _modelUtil = require("../../../util/ModelUtil");
var DEFAULT_FLOW = 'default', ID = 'id', DI = 'di';
var NULL_DIMENSIONS = {
    width: 0,
    height: 0
};
function UpdatePropertiesHandler(elementRegistry, moddle, translate, modeling, textRenderer) {
    this._elementRegistry = elementRegistry;
    this._moddle = moddle;
    this._translate = translate;
    this._modeling = modeling;
    this._textRenderer = textRenderer;
}
UpdatePropertiesHandler.$inject = [
    'elementRegistry',
    'moddle',
    'translate',
    'modeling',
    'textRenderer'
];
// api //////////////////////
/**
 * Updates a BPMN element with a list of new properties
 *
 * @param {Object} context
 * @param {djs.model.Base} context.element the element to update
 * @param {Object} context.properties a list of properties to set on the element's
 *                                    businessObject (the BPMN model element)
 *
 * @return {Array<djs.model.Base>} the updated element
 */ UpdatePropertiesHandler.prototype.execute = function(context) {
    var element = context.element, changed = [
        element
    ], translate = this._translate;
    if (!element) throw new Error(translate('element required'));
    var elementRegistry = this._elementRegistry, ids = this._moddle.ids;
    var businessObject = element.businessObject, properties = unwrapBusinessObjects(context.properties), oldProperties = context.oldProperties || getProperties(element, properties);
    if (isIdChange(properties, businessObject)) {
        ids.unclaim(businessObject[ID]);
        elementRegistry.updateId(element, properties[ID]);
        ids.claim(properties[ID], businessObject);
    }
    // correctly indicate visual changes on default flow updates
    if (DEFAULT_FLOW in properties) {
        if (properties[DEFAULT_FLOW]) changed.push(elementRegistry.get(properties[DEFAULT_FLOW].id));
        if (businessObject[DEFAULT_FLOW]) changed.push(elementRegistry.get(businessObject[DEFAULT_FLOW].id));
    }
    // update properties
    setProperties(element, properties);
    // store old values
    context.oldProperties = oldProperties;
    context.changed = changed;
    // indicate changed on objects affected by the update
    return changed;
};
UpdatePropertiesHandler.prototype.postExecute = function(context) {
    var element = context.element, label = element.label;
    var text = label && (0, _modelUtil.getBusinessObject)(label).name;
    if (!text) return;
    // get layouted text bounds and resize external
    // external label accordingly
    var newLabelBounds = this._textRenderer.getExternalLabelBounds(label, text);
    this._modeling.resizeShape(label, newLabelBounds, NULL_DIMENSIONS);
};
/**
 * Reverts the update on a BPMN elements properties.
 *
 * @param  {Object} context
 *
 * @return {djs.model.Base} the updated element
 */ UpdatePropertiesHandler.prototype.revert = function(context) {
    var element = context.element, properties = context.properties, oldProperties = context.oldProperties, businessObject = element.businessObject, elementRegistry = this._elementRegistry, ids = this._moddle.ids;
    // update properties
    setProperties(element, oldProperties);
    if (isIdChange(properties, businessObject)) {
        ids.unclaim(properties[ID]);
        elementRegistry.updateId(element, oldProperties[ID]);
        ids.claim(oldProperties[ID], businessObject);
    }
    return context.changed;
};
function isIdChange(properties, businessObject) {
    return ID in properties && properties[ID] !== businessObject[ID];
}
function getProperties(element, properties) {
    var propertyNames = (0, _minDash.keys)(properties), businessObject = element.businessObject, di = (0, _modelUtil.getDi)(element);
    return (0, _minDash.reduce)(propertyNames, function(result, key) {
        // handle DI separately
        if (key !== DI) result[key] = businessObject.get(key);
        else result[key] = getDiProperties(di, (0, _minDash.keys)(properties.di));
        return result;
    }, {});
}
function getDiProperties(di, propertyNames) {
    return (0, _minDash.reduce)(propertyNames, function(result, key) {
        result[key] = di && di.get(key);
        return result;
    }, {});
}
function setProperties(element, properties) {
    var businessObject = element.businessObject, di = (0, _modelUtil.getDi)(element);
    (0, _minDash.forEach)(properties, function(value, key) {
        if (key !== DI) businessObject.set(key, value);
        else // only update, if di exists
        if (di) setDiProperties(di, value);
    });
}
function setDiProperties(di, properties) {
    (0, _minDash.forEach)(properties, function(value, key) {
        di.set(key, value);
    });
}
var referencePropertyNames = [
    'default'
];
/**
 * Make sure we unwrap the actual business object
 * behind diagram element that may have been
 * passed as arguments.
 *
 * @param  {Object} properties
 *
 * @return {Object} unwrappedProps
 */ function unwrapBusinessObjects(properties) {
    var unwrappedProps = (0, _minDash.assign)({}, properties);
    referencePropertyNames.forEach(function(name) {
        if (name in properties) unwrappedProps[name] = (0, _modelUtil.getBusinessObject)(unwrappedProps[name]);
    });
    return unwrappedProps;
}

},{"min-dash":"aEEla","../../../util/ModelUtil":"klNYN","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1UKAk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>UpdateCanvasRootHandler);
var _collections = require("diagram-js/lib/util/Collections");
var _modelUtil = require("../../../util/ModelUtil");
function UpdateCanvasRootHandler(canvas, modeling) {
    this._canvas = canvas;
    this._modeling = modeling;
}
UpdateCanvasRootHandler.$inject = [
    'canvas',
    'modeling'
];
UpdateCanvasRootHandler.prototype.execute = function(context) {
    var canvas = this._canvas;
    var newRoot = context.newRoot, newRootBusinessObject = newRoot.businessObject, oldRoot = canvas.getRootElement(), oldRootBusinessObject = oldRoot.businessObject, bpmnDefinitions = oldRootBusinessObject.$parent, diPlane = (0, _modelUtil.getDi)(oldRoot);
    // (1) replace process old <> new root
    canvas.setRootElement(newRoot);
    canvas.removeRootElement(oldRoot);
    // (2) update root elements
    (0, _collections.add)(bpmnDefinitions.rootElements, newRootBusinessObject);
    newRootBusinessObject.$parent = bpmnDefinitions;
    (0, _collections.remove)(bpmnDefinitions.rootElements, oldRootBusinessObject);
    oldRootBusinessObject.$parent = null;
    // (3) wire di
    oldRoot.di = null;
    diPlane.bpmnElement = newRootBusinessObject;
    newRoot.di = diPlane;
    context.oldRoot = oldRoot;
// TODO(nikku): return changed elements?
// return [ newRoot, oldRoot ];
};
UpdateCanvasRootHandler.prototype.revert = function(context) {
    var canvas = this._canvas;
    var newRoot = context.newRoot, newRootBusinessObject = newRoot.businessObject, oldRoot = context.oldRoot, oldRootBusinessObject = oldRoot.businessObject, bpmnDefinitions = newRootBusinessObject.$parent, diPlane = (0, _modelUtil.getDi)(newRoot);
    // (1) replace process old <> new root
    canvas.setRootElement(oldRoot);
    canvas.removeRootElement(newRoot);
    // (2) update root elements
    (0, _collections.remove)(bpmnDefinitions.rootElements, newRootBusinessObject);
    newRootBusinessObject.$parent = null;
    (0, _collections.add)(bpmnDefinitions.rootElements, oldRootBusinessObject);
    oldRootBusinessObject.$parent = bpmnDefinitions;
    // (3) wire di
    newRoot.di = null;
    diPlane.bpmnElement = oldRootBusinessObject;
    oldRoot.di = diPlane;
// TODO(nikku): return changed elements?
// return [ newRoot, oldRoot ];
};

},{"diagram-js/lib/util/Collections":"kRUAD","../../../util/ModelUtil":"klNYN","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dij4j":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AddLaneHandler);
var _minDash = require("min-dash");
var _elements = require("diagram-js/lib/util/Elements");
var _laneUtil = require("../util/LaneUtil");
function AddLaneHandler(modeling, spaceTool) {
    this._modeling = modeling;
    this._spaceTool = spaceTool;
}
AddLaneHandler.$inject = [
    'modeling',
    'spaceTool'
];
AddLaneHandler.prototype.preExecute = function(context) {
    var spaceTool = this._spaceTool, modeling = this._modeling;
    var shape = context.shape, location = context.location;
    var lanesRoot = (0, _laneUtil.getLanesRoot)(shape);
    var isRoot = lanesRoot === shape, laneParent = isRoot ? shape : shape.parent;
    var existingChildLanes = (0, _laneUtil.getChildLanes)(laneParent);
    // (0) add a lane if we currently got none and are adding to root
    if (!existingChildLanes.length) modeling.createShape({
        type: 'bpmn:Lane'
    }, {
        x: shape.x + (0, _laneUtil.LANE_INDENTATION),
        y: shape.y,
        width: shape.width - (0, _laneUtil.LANE_INDENTATION),
        height: shape.height
    }, laneParent);
    // (1) collect affected elements to create necessary space
    var allAffected = [];
    (0, _elements.eachElement)(lanesRoot, function(element) {
        allAffected.push(element);
        // handle element labels in the diagram root
        if (element.label) allAffected.push(element.label);
        if (element === shape) return [];
        return (0, _minDash.filter)(element.children, function(c) {
            return c !== shape;
        });
    });
    var offset = location === 'top' ? -120 : 120, lanePosition = location === 'top' ? shape.y : shape.y + shape.height, spacePos = lanePosition + (location === 'top' ? 10 : -10), direction = location === 'top' ? 'n' : 's';
    var adjustments = spaceTool.calculateAdjustments(allAffected, 'y', offset, spacePos);
    spaceTool.makeSpace(adjustments.movingShapes, adjustments.resizingShapes, {
        x: 0,
        y: offset
    }, direction, spacePos);
    // (2) create new lane at open space
    context.newLane = modeling.createShape({
        type: 'bpmn:Lane'
    }, {
        x: shape.x + (isRoot ? (0, _laneUtil.LANE_INDENTATION) : 0),
        y: lanePosition - (location === 'top' ? 120 : 0),
        width: shape.width - (isRoot ? (0, _laneUtil.LANE_INDENTATION) : 0),
        height: 120
    }, laneParent);
};

},{"min-dash":"aEEla","diagram-js/lib/util/Elements":"6qdtl","../util/LaneUtil":"fECqQ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9l2S4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SplitLaneHandler);
var _laneUtil = require("../util/LaneUtil");
function SplitLaneHandler(modeling, translate) {
    this._modeling = modeling;
    this._translate = translate;
}
SplitLaneHandler.$inject = [
    'modeling',
    'translate'
];
SplitLaneHandler.prototype.preExecute = function(context) {
    var modeling = this._modeling, translate = this._translate;
    var shape = context.shape, newLanesCount = context.count;
    var childLanes = (0, _laneUtil.getChildLanes)(shape), existingLanesCount = childLanes.length;
    if (existingLanesCount > newLanesCount) throw new Error(translate('more than {count} child lanes', {
        count: newLanesCount
    }));
    var newLanesHeight = Math.round(shape.height / newLanesCount);
    // Iterate from top to bottom in child lane order,
    // resizing existing lanes and creating new ones
    // so that they split the parent proportionally.
    //
    // Due to rounding related errors, the bottom lane
    // needs to take up all the remaining space.
    var laneY, laneHeight, laneBounds, newLaneAttrs, idx;
    for(idx = 0; idx < newLanesCount; idx++){
        laneY = shape.y + idx * newLanesHeight;
        // if bottom lane
        if (idx === newLanesCount - 1) laneHeight = shape.height - newLanesHeight * idx;
        else laneHeight = newLanesHeight;
        laneBounds = {
            x: shape.x + (0, _laneUtil.LANE_INDENTATION),
            y: laneY,
            width: shape.width - (0, _laneUtil.LANE_INDENTATION),
            height: laneHeight
        };
        if (idx < existingLanesCount) // resize existing lane
        modeling.resizeShape(childLanes[idx], laneBounds);
        else {
            // create a new lane at position
            newLaneAttrs = {
                type: 'bpmn:Lane'
            };
            modeling.createShape(newLaneAttrs, laneBounds, shape);
        }
    }
};

},{"../util/LaneUtil":"fECqQ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bdmKd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ResizeLaneHandler);
var _modelUtil = require("../../../util/ModelUtil");
var _laneUtil = require("../util/LaneUtil");
var _elements = require("diagram-js/lib/util/Elements");
var _layoutUtil = require("diagram-js/lib/layout/LayoutUtil");
var _resizeUtil = require("diagram-js/lib/features/resize/ResizeUtil");
function ResizeLaneHandler(modeling, spaceTool) {
    this._modeling = modeling;
    this._spaceTool = spaceTool;
}
ResizeLaneHandler.$inject = [
    'modeling',
    'spaceTool'
];
ResizeLaneHandler.prototype.preExecute = function(context) {
    var shape = context.shape, newBounds = context.newBounds, balanced = context.balanced;
    if (balanced !== false) this.resizeBalanced(shape, newBounds);
    else this.resizeSpace(shape, newBounds);
};
/**
 * Resize balanced, adjusting next / previous lane sizes.
 *
 * @param {djs.model.Shape} shape
 * @param {Bounds} newBounds
 */ ResizeLaneHandler.prototype.resizeBalanced = function(shape, newBounds) {
    var modeling = this._modeling;
    var resizeNeeded = (0, _laneUtil.computeLanesResize)(shape, newBounds);
    // resize the lane
    modeling.resizeShape(shape, newBounds);
    // resize other lanes as needed
    resizeNeeded.forEach(function(r) {
        modeling.resizeShape(r.shape, r.newBounds);
    });
};
/**
 * Resize, making actual space and moving below / above elements.
 *
 * @param {djs.model.Shape} shape
 * @param {Bounds} newBounds
 */ ResizeLaneHandler.prototype.resizeSpace = function(shape, newBounds) {
    var spaceTool = this._spaceTool;
    var shapeTrbl = (0, _layoutUtil.asTRBL)(shape), newTrbl = (0, _layoutUtil.asTRBL)(newBounds);
    var trblDiff = (0, _resizeUtil.substractTRBL)(newTrbl, shapeTrbl);
    var lanesRoot = (0, _laneUtil.getLanesRoot)(shape);
    var allAffected = [], allLanes = [];
    (0, _elements.eachElement)(lanesRoot, function(element) {
        allAffected.push(element);
        if ((0, _modelUtil.is)(element, 'bpmn:Lane') || (0, _modelUtil.is)(element, 'bpmn:Participant')) allLanes.push(element);
        return element.children;
    });
    var change, spacePos, direction, offset, adjustments;
    if (trblDiff.bottom || trblDiff.top) {
        change = trblDiff.bottom || trblDiff.top;
        spacePos = shape.y + (trblDiff.bottom ? shape.height : 0) + (trblDiff.bottom ? -10 : 10);
        direction = trblDiff.bottom ? 's' : 'n';
        offset = trblDiff.top > 0 || trblDiff.bottom < 0 ? -change : change;
        adjustments = spaceTool.calculateAdjustments(allAffected, 'y', offset, spacePos);
        spaceTool.makeSpace(adjustments.movingShapes, adjustments.resizingShapes, {
            x: 0,
            y: change
        }, direction);
    }
    if (trblDiff.left || trblDiff.right) {
        change = trblDiff.right || trblDiff.left;
        spacePos = shape.x + (trblDiff.right ? shape.width : 0) + (trblDiff.right ? -10 : 100);
        direction = trblDiff.right ? 'e' : 'w';
        offset = trblDiff.left > 0 || trblDiff.right < 0 ? -change : change;
        adjustments = spaceTool.calculateAdjustments(allLanes, 'x', offset, spacePos);
        spaceTool.makeSpace(adjustments.movingShapes, adjustments.resizingShapes, {
            x: change,
            y: 0
        }, direction);
    }
};

},{"../../../util/ModelUtil":"klNYN","../util/LaneUtil":"fECqQ","diagram-js/lib/util/Elements":"6qdtl","diagram-js/lib/layout/LayoutUtil":"4CCrs","diagram-js/lib/features/resize/ResizeUtil":"gKMgs","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hUsBB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>UpdateFlowNodeRefsHandler);
var _laneUtil = require("../util/LaneUtil");
var _modelUtil = require("../../../util/ModelUtil");
var _collections = require("diagram-js/lib/util/Collections");
var _layoutUtil = require("diagram-js/lib/layout/LayoutUtil");
var FLOW_NODE_REFS_ATTR = 'flowNodeRef', LANES_ATTR = 'lanes';
function UpdateFlowNodeRefsHandler(elementRegistry) {
    this._elementRegistry = elementRegistry;
}
UpdateFlowNodeRefsHandler.$inject = [
    'elementRegistry'
];
UpdateFlowNodeRefsHandler.prototype.computeUpdates = function(flowNodeShapes, laneShapes) {
    var handledNodes = [];
    var updates = [];
    var participantCache = {};
    var allFlowNodeShapes = [];
    function isInLaneShape(element, laneShape) {
        var laneTrbl = (0, _layoutUtil.asTRBL)(laneShape);
        var elementMid = {
            x: element.x + element.width / 2,
            y: element.y + element.height / 2
        };
        return elementMid.x > laneTrbl.left && elementMid.x < laneTrbl.right && elementMid.y > laneTrbl.top && elementMid.y < laneTrbl.bottom;
    }
    function addFlowNodeShape(flowNodeShape) {
        if (handledNodes.indexOf(flowNodeShape) === -1) {
            allFlowNodeShapes.push(flowNodeShape);
            handledNodes.push(flowNodeShape);
        }
    }
    function getAllLaneShapes(flowNodeShape) {
        var root = (0, _laneUtil.getLanesRoot)(flowNodeShape);
        if (!participantCache[root.id]) participantCache[root.id] = (0, _laneUtil.collectLanes)(root);
        return participantCache[root.id];
    }
    function getNewLanes(flowNodeShape) {
        if (!flowNodeShape.parent) return [];
        var allLaneShapes = getAllLaneShapes(flowNodeShape);
        return allLaneShapes.filter(function(l) {
            return isInLaneShape(flowNodeShape, l);
        }).map(function(shape) {
            return shape.businessObject;
        });
    }
    laneShapes.forEach(function(laneShape) {
        var root = (0, _laneUtil.getLanesRoot)(laneShape);
        if (!root || handledNodes.indexOf(root) !== -1) return;
        var children = root.children.filter(function(c) {
            return (0, _modelUtil.is)(c, 'bpmn:FlowNode');
        });
        children.forEach(addFlowNodeShape);
        handledNodes.push(root);
    });
    flowNodeShapes.forEach(addFlowNodeShape);
    allFlowNodeShapes.forEach(function(flowNodeShape) {
        var flowNode = flowNodeShape.businessObject;
        var lanes = flowNode.get(LANES_ATTR), remove = lanes.slice(), add = getNewLanes(flowNodeShape);
        updates.push({
            flowNode: flowNode,
            remove: remove,
            add: add
        });
    });
    laneShapes.forEach(function(laneShape) {
        var lane = laneShape.businessObject;
        // lane got removed XX-)
        if (!laneShape.parent) lane.get(FLOW_NODE_REFS_ATTR).forEach(function(flowNode) {
            updates.push({
                flowNode: flowNode,
                remove: [
                    lane
                ],
                add: []
            });
        });
    });
    return updates;
};
UpdateFlowNodeRefsHandler.prototype.execute = function(context) {
    var updates = context.updates;
    if (!updates) updates = context.updates = this.computeUpdates(context.flowNodeShapes, context.laneShapes);
    updates.forEach(function(update) {
        var flowNode = update.flowNode, lanes = flowNode.get(LANES_ATTR);
        // unwire old
        update.remove.forEach(function(oldLane) {
            (0, _collections.remove)(lanes, oldLane);
            (0, _collections.remove)(oldLane.get(FLOW_NODE_REFS_ATTR), flowNode);
        });
        // wire new
        update.add.forEach(function(newLane) {
            (0, _collections.add)(lanes, newLane);
            (0, _collections.add)(newLane.get(FLOW_NODE_REFS_ATTR), flowNode);
        });
    });
// TODO(nikku): return changed elements
// return [ ... ];
};
UpdateFlowNodeRefsHandler.prototype.revert = function(context) {
    var updates = context.updates;
    updates.forEach(function(update) {
        var flowNode = update.flowNode, lanes = flowNode.get(LANES_ATTR);
        // unwire new
        update.add.forEach(function(newLane) {
            (0, _collections.remove)(lanes, newLane);
            (0, _collections.remove)(newLane.get(FLOW_NODE_REFS_ATTR), flowNode);
        });
        // wire old
        update.remove.forEach(function(oldLane) {
            (0, _collections.add)(lanes, oldLane);
            (0, _collections.add)(oldLane.get(FLOW_NODE_REFS_ATTR), flowNode);
        });
    });
// TODO(nikku): return changed elements
// return [ ... ];
};

},{"../util/LaneUtil":"fECqQ","../../../util/ModelUtil":"klNYN","diagram-js/lib/util/Collections":"kRUAD","diagram-js/lib/layout/LayoutUtil":"4CCrs","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7btlt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>IdClaimHandler);
function IdClaimHandler(moddle) {
    this._moddle = moddle;
}
IdClaimHandler.$inject = [
    'moddle'
];
IdClaimHandler.prototype.execute = function(context) {
    var ids = this._moddle.ids, id = context.id, element = context.element, claiming = context.claiming;
    if (claiming) ids.claim(id, element);
    else ids.unclaim(id);
};
/**
 * Command revert implementation.
 */ IdClaimHandler.prototype.revert = function(context) {
    var ids = this._moddle.ids, id = context.id, element = context.element, claiming = context.claiming;
    if (claiming) ids.unclaim(id);
    else ids.claim(id, element);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3Ieon":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SetColorHandler);
var _minDash = require("min-dash");
var _modelUtil = require("../../../util/ModelUtil");
var _labelUtil = require("../../../util/LabelUtil");
var DEFAULT_COLORS = {
    fill: undefined,
    stroke: undefined
};
function SetColorHandler(commandStack) {
    this._commandStack = commandStack;
    this._normalizeColor = function(color) {
        // Remove color for falsy values.
        if (!color) return undefined;
        if ((0, _minDash.isString)(color)) {
            var hexColor = colorToHex(color);
            if (hexColor) return hexColor;
        }
        throw new Error('invalid color value: ' + color);
    };
}
SetColorHandler.$inject = [
    'commandStack'
];
SetColorHandler.prototype.postExecute = function(context) {
    var elements = context.elements, colors = context.colors || DEFAULT_COLORS;
    var self = this;
    var di = {};
    if ('fill' in colors) (0, _minDash.assign)(di, {
        'background-color': this._normalizeColor(colors.fill)
    });
    if ('stroke' in colors) (0, _minDash.assign)(di, {
        'border-color': this._normalizeColor(colors.stroke)
    });
    (0, _minDash.forEach)(elements, function(element) {
        var assignedDi = isConnection(element) ? (0, _minDash.pick)(di, [
            'border-color'
        ]) : di, elementDi = (0, _modelUtil.getDi)(element);
        // TODO @barmac: remove once we drop bpmn.io properties
        ensureLegacySupport(assignedDi);
        if ((0, _labelUtil.isLabel)(element)) // set label colors as bpmndi:BPMNLabel#color
        self._commandStack.execute('element.updateModdleProperties', {
            element: element,
            moddleElement: elementDi.label,
            properties: {
                color: di['border-color']
            }
        });
        else {
            // ignore non-compliant di
            if (!(0, _modelUtil.isAny)(elementDi, [
                'bpmndi:BPMNEdge',
                'bpmndi:BPMNShape'
            ])) return;
            // set colors bpmndi:BPMNEdge or bpmndi:BPMNShape
            self._commandStack.execute('element.updateProperties', {
                element: element,
                properties: {
                    di: assignedDi
                }
            });
        }
    });
};
/**
 * Convert color from rgb(a)/hsl to hex. Returns `null` for unknown color names and for colors
 * with alpha less than 1.0. This depends on `<canvas>` serialization of the `context.fillStyle`.
 * Cf. https://html.spec.whatwg.org/multipage/canvas.html#dom-context-2d-fillstyle
 *
 * @example
 * ```js
 * var color = 'fuchsia';
 * console.log(colorToHex(color));
 * // "#ff00ff"
 * color = 'rgba(1,2,3,0.4)';
 * console.log(colorToHex(color));
 * // null
 * ```
 *
 * @param {string} color
 * @returns {string|null}
 */ function colorToHex(color) {
    var context = document.createElement('canvas').getContext('2d');
    // (0) Start with transparent to account for browser default values.
    context.fillStyle = 'transparent';
    // (1) Assign color so that it's serialized.
    context.fillStyle = color;
    // (2) Return null for non-hex serialization result.
    return /^#[0-9a-fA-F]{6}$/.test(context.fillStyle) ? context.fillStyle : null;
}
function isConnection(element) {
    return !!element.waypoints;
}
/**
 * Add legacy properties if required.
 * @param {{ 'border-color': string?, 'background-color': string? }} di
 */ function ensureLegacySupport(di) {
    if ('border-color' in di) di.stroke = di['border-color'];
    if ('background-color' in di) di.fill = di['background-color'];
}

},{"min-dash":"aEEla","../../../util/ModelUtil":"klNYN","../../../util/LabelUtil":"fAd5x","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5R8Ij":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>UpdateLabelHandler);
var _labelUtil = require("../LabelUtil");
var _labelUtil1 = require("../../../util/LabelUtil");
var _modelUtil = require("../../../util/ModelUtil");
var NULL_DIMENSIONS = {
    width: 0,
    height: 0
};
function UpdateLabelHandler(modeling, textRenderer, bpmnFactory) {
    /**
   * Creates an empty `diLabel` attribute for embedded labels.
   *
   * @param {djs.model.Base} element
   * @param {string} text
   */ function ensureInternalLabelDi(element, text) {
        if ((0, _labelUtil1.isLabelExternal)(element)) return;
        var di = (0, _modelUtil.getDi)(element);
        if (text && !di.label) di.label = bpmnFactory.create('bpmndi:BPMNLabel');
        if (!text && di.label) delete di.label;
    }
    /**
   * Set the label and return the changed elements.
   *
   * Element parameter can be label itself or connection (i.e. sequence flow).
   *
   * @param {djs.model.Base} element
   * @param {string} text
   */ function setText(element, text) {
        // external label if present
        var label = element.label || element;
        var labelTarget = element.labelTarget || element;
        (0, _labelUtil.setLabel)(label, text, labelTarget !== label);
        ensureInternalLabelDi(element, text);
        return [
            label,
            labelTarget
        ];
    }
    function preExecute(ctx) {
        var element = ctx.element, businessObject = element.businessObject, newLabel = ctx.newLabel;
        if (!(0, _labelUtil1.isLabel)(element) && (0, _labelUtil1.isLabelExternal)(element) && !(0, _labelUtil1.hasExternalLabel)(element) && !isEmptyText(newLabel)) {
            // create label
            var paddingTop = 7;
            var labelCenter = (0, _labelUtil1.getExternalLabelMid)(element);
            labelCenter = {
                x: labelCenter.x,
                y: labelCenter.y + paddingTop
            };
            modeling.createLabel(element, labelCenter, {
                id: businessObject.id + '_label',
                businessObject: businessObject,
                di: element.di
            });
        }
    }
    function execute(ctx) {
        ctx.oldLabel = (0, _labelUtil.getLabel)(ctx.element);
        return setText(ctx.element, ctx.newLabel);
    }
    function revert(ctx) {
        return setText(ctx.element, ctx.oldLabel);
    }
    function postExecute(ctx) {
        var element = ctx.element, label = element.label || element, newLabel = ctx.newLabel, newBounds = ctx.newBounds, hints = ctx.hints || {};
        // ignore internal labels for elements except text annotations
        if (!(0, _labelUtil1.isLabel)(label) && !(0, _modelUtil.is)(label, 'bpmn:TextAnnotation')) return;
        if ((0, _labelUtil1.isLabel)(label) && isEmptyText(newLabel)) {
            if (hints.removeShape !== false) modeling.removeShape(label, {
                unsetLabel: false
            });
            return;
        }
        var text = (0, _labelUtil.getLabel)(label);
        // resize element based on label _or_ pre-defined bounds
        if (typeof newBounds === 'undefined') newBounds = textRenderer.getExternalLabelBounds(label, text);
        // setting newBounds to false or _null_ will
        // disable the postExecute resize operation
        if (newBounds) modeling.resizeShape(label, newBounds, NULL_DIMENSIONS);
    }
    // API
    this.preExecute = preExecute;
    this.execute = execute;
    this.revert = revert;
    this.postExecute = postExecute;
}
UpdateLabelHandler.$inject = [
    'modeling',
    'textRenderer',
    'bpmnFactory'
];
// helpers ///////////////////////
function isEmptyText(label) {
    return !label || !label.trim();
}

},{"../LabelUtil":"gHqpR","../../../util/LabelUtil":"fAd5x","../../../util/ModelUtil":"klNYN","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aLiFP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BpmnLayouter);
var _inheritsBrowser = require("inherits-browser");
var _inheritsBrowserDefault = parcelHelpers.interopDefault(_inheritsBrowser);
var _minDash = require("min-dash");
var _baseLayouter = require("diagram-js/lib/layout/BaseLayouter");
var _baseLayouterDefault = parcelHelpers.interopDefault(_baseLayouter);
var _manhattanLayout = require("diagram-js/lib/layout/ManhattanLayout");
var _layoutUtil = require("diagram-js/lib/layout/LayoutUtil");
var _diUtil = require("../../util/DiUtil");
var _modelUtil = require("../../util/ModelUtil");
var ATTACH_ORIENTATION_PADDING = -10, BOUNDARY_TO_HOST_THRESHOLD = 40;
var oppositeOrientationMapping = {
    'top': 'bottom',
    'top-right': 'bottom-left',
    'top-left': 'bottom-right',
    'right': 'left',
    'bottom': 'top',
    'bottom-right': 'top-left',
    'bottom-left': 'top-right',
    'left': 'right'
};
var orientationDirectionMapping = {
    top: 't',
    right: 'r',
    bottom: 'b',
    left: 'l'
};
function BpmnLayouter() {}
(0, _inheritsBrowserDefault.default)(BpmnLayouter, (0, _baseLayouterDefault.default));
BpmnLayouter.prototype.layoutConnection = function(connection, hints) {
    if (!hints) hints = {};
    var source = hints.source || connection.source, target = hints.target || connection.target, waypoints = hints.waypoints || connection.waypoints, connectionStart = hints.connectionStart, connectionEnd = hints.connectionEnd;
    var manhattanOptions, updatedWaypoints;
    if (!connectionStart) connectionStart = getConnectionDocking(waypoints && waypoints[0], source);
    if (!connectionEnd) connectionEnd = getConnectionDocking(waypoints && waypoints[waypoints.length - 1], target);
    // TODO(nikku): support vertical modeling
    // and invert preferredLayouts accordingly
    if ((0, _modelUtil.is)(connection, 'bpmn:Association') || (0, _modelUtil.is)(connection, 'bpmn:DataAssociation')) {
        if (waypoints && !isCompensationAssociation(source, target)) return [].concat([
            connectionStart
        ], waypoints.slice(1, -1), [
            connectionEnd
        ]);
    }
    if ((0, _modelUtil.is)(connection, 'bpmn:MessageFlow')) manhattanOptions = getMessageFlowManhattanOptions(source, target);
    else if ((0, _modelUtil.is)(connection, 'bpmn:SequenceFlow') || isCompensationAssociation(source, target)) {
        // layout all connection between flow elements h:h, except for
        // (1) outgoing of boundary events -> layout based on attach orientation and target orientation
        // (2) incoming/outgoing of gateways -> v:h for outgoing, h:v for incoming
        // (3) loops
        if (source === target) manhattanOptions = {
            preferredLayouts: getLoopPreferredLayout(source, connection)
        };
        else if ((0, _modelUtil.is)(source, 'bpmn:BoundaryEvent')) manhattanOptions = {
            preferredLayouts: getBoundaryEventPreferredLayouts(source, target, connectionEnd)
        };
        else if (isExpandedSubProcess(source) || isExpandedSubProcess(target)) manhattanOptions = getSubProcessManhattanOptions(source);
        else if ((0, _modelUtil.is)(source, 'bpmn:Gateway')) manhattanOptions = {
            preferredLayouts: [
                'v:h'
            ]
        };
        else if ((0, _modelUtil.is)(target, 'bpmn:Gateway')) manhattanOptions = {
            preferredLayouts: [
                'h:v'
            ]
        };
        else manhattanOptions = {
            preferredLayouts: [
                'h:h'
            ]
        };
    }
    if (manhattanOptions) {
        manhattanOptions = (0, _minDash.assign)(manhattanOptions, hints);
        updatedWaypoints = (0, _manhattanLayout.withoutRedundantPoints)((0, _manhattanLayout.repairConnection)(source, target, connectionStart, connectionEnd, waypoints, manhattanOptions));
    }
    return updatedWaypoints || [
        connectionStart,
        connectionEnd
    ];
};
// helpers //////////
function getAttachOrientation(attachedElement) {
    var hostElement = attachedElement.host;
    return (0, _layoutUtil.getOrientation)((0, _layoutUtil.getMid)(attachedElement), hostElement, ATTACH_ORIENTATION_PADDING);
}
function getMessageFlowManhattanOptions(source, target) {
    return {
        preferredLayouts: [
            'straight',
            'v:v'
        ],
        preserveDocking: getMessageFlowPreserveDocking(source, target)
    };
}
function getMessageFlowPreserveDocking(source, target) {
    // (1) docking element connected to participant has precedence
    if ((0, _modelUtil.is)(target, 'bpmn:Participant')) return 'source';
    if ((0, _modelUtil.is)(source, 'bpmn:Participant')) return 'target';
    // (2) docking element connected to expanded sub-process has precedence
    if (isExpandedSubProcess(target)) return 'source';
    if (isExpandedSubProcess(source)) return 'target';
    // (3) docking event has precedence
    if ((0, _modelUtil.is)(target, 'bpmn:Event')) return 'target';
    if ((0, _modelUtil.is)(source, 'bpmn:Event')) return 'source';
    return null;
}
function getSubProcessManhattanOptions(source) {
    return {
        preferredLayouts: [
            'straight',
            'h:h'
        ],
        preserveDocking: getSubProcessPreserveDocking(source)
    };
}
function getSubProcessPreserveDocking(source) {
    return isExpandedSubProcess(source) ? 'target' : 'source';
}
function getConnectionDocking(point, shape) {
    return point ? point.original || point : (0, _layoutUtil.getMid)(shape);
}
function isCompensationAssociation(source, target) {
    return (0, _modelUtil.is)(target, 'bpmn:Activity') && (0, _modelUtil.is)(source, 'bpmn:BoundaryEvent') && target.businessObject.isForCompensation;
}
function isExpandedSubProcess(element) {
    return (0, _modelUtil.is)(element, 'bpmn:SubProcess') && (0, _diUtil.isExpanded)(element);
}
function isSame(a, b) {
    return a === b;
}
function isAnyOrientation(orientation, orientations) {
    return orientations.indexOf(orientation) !== -1;
}
function getHorizontalOrientation(orientation) {
    var matches = /right|left/.exec(orientation);
    return matches && matches[0];
}
function getVerticalOrientation(orientation) {
    var matches = /top|bottom/.exec(orientation);
    return matches && matches[0];
}
function isOppositeOrientation(a, b) {
    return oppositeOrientationMapping[a] === b;
}
function isOppositeHorizontalOrientation(a, b) {
    var horizontalOrientation = getHorizontalOrientation(a);
    var oppositeHorizontalOrientation = oppositeOrientationMapping[horizontalOrientation];
    return b.indexOf(oppositeHorizontalOrientation) !== -1;
}
function isOppositeVerticalOrientation(a, b) {
    var verticalOrientation = getVerticalOrientation(a);
    var oppositeVerticalOrientation = oppositeOrientationMapping[verticalOrientation];
    return b.indexOf(oppositeVerticalOrientation) !== -1;
}
function isHorizontalOrientation(orientation) {
    return orientation === 'right' || orientation === 'left';
}
function getLoopPreferredLayout(source, connection) {
    var waypoints = connection.waypoints;
    var orientation = waypoints && waypoints.length && (0, _layoutUtil.getOrientation)(waypoints[0], source);
    if (orientation === 'top') return [
        't:r'
    ];
    else if (orientation === 'right') return [
        'r:b'
    ];
    else if (orientation === 'left') return [
        'l:t'
    ];
    return [
        'b:l'
    ];
}
function getBoundaryEventPreferredLayouts(source, target, end) {
    var sourceMid = (0, _layoutUtil.getMid)(source), targetMid = (0, _layoutUtil.getMid)(target), attachOrientation = getAttachOrientation(source), sourceLayout, targetLayout;
    var isLoop = isSame(source.host, target);
    var attachedToSide = isAnyOrientation(attachOrientation, [
        'top',
        'right',
        'bottom',
        'left'
    ]);
    var targetOrientation = (0, _layoutUtil.getOrientation)(targetMid, sourceMid, {
        x: source.width / 2 + target.width / 2,
        y: source.height / 2 + target.height / 2
    });
    if (isLoop) return getBoundaryEventLoopLayout(attachOrientation, attachedToSide, source, target, end);
    // source layout
    sourceLayout = getBoundaryEventSourceLayout(attachOrientation, targetOrientation, attachedToSide);
    // target layout
    targetLayout = getBoundaryEventTargetLayout(attachOrientation, targetOrientation, attachedToSide);
    return [
        sourceLayout + ':' + targetLayout
    ];
}
function getBoundaryEventLoopLayout(attachOrientation, attachedToSide, source, target, end) {
    var orientation = attachedToSide ? attachOrientation : getVerticalOrientation(attachOrientation), sourceLayout = orientationDirectionMapping[orientation], targetLayout;
    if (attachedToSide) {
        if (isHorizontalOrientation(attachOrientation)) targetLayout = shouldConnectToSameSide('y', source, target, end) ? 'h' : 'b';
        else targetLayout = shouldConnectToSameSide('x', source, target, end) ? 'v' : 'l';
    } else targetLayout = 'v';
    return [
        sourceLayout + ':' + targetLayout
    ];
}
function shouldConnectToSameSide(axis, source, target, end) {
    var threshold = BOUNDARY_TO_HOST_THRESHOLD;
    return !(areCloseOnAxis(axis, end, target, threshold) || areCloseOnAxis(axis, end, {
        x: target.x + target.width,
        y: target.y + target.height
    }, threshold) || areCloseOnAxis(axis, end, (0, _layoutUtil.getMid)(source), threshold));
}
function areCloseOnAxis(axis, a, b, threshold) {
    return Math.abs(a[axis] - b[axis]) < threshold;
}
function getBoundaryEventSourceLayout(attachOrientation, targetOrientation, attachedToSide) {
    // attached to either top, right, bottom or left side
    if (attachedToSide) return orientationDirectionMapping[attachOrientation];
    // attached to either top-right, top-left, bottom-right or bottom-left corner
    // same vertical or opposite horizontal orientation
    if (isSame(getVerticalOrientation(attachOrientation), getVerticalOrientation(targetOrientation)) || isOppositeOrientation(getHorizontalOrientation(attachOrientation), getHorizontalOrientation(targetOrientation))) return orientationDirectionMapping[getVerticalOrientation(attachOrientation)];
    // fallback
    return orientationDirectionMapping[getHorizontalOrientation(attachOrientation)];
}
function getBoundaryEventTargetLayout(attachOrientation, targetOrientation, attachedToSide) {
    // attached to either top, right, bottom or left side
    if (attachedToSide) {
        if (isHorizontalOrientation(attachOrientation)) {
            // orientation is right or left
            // opposite horizontal orientation or same orientation
            if (isOppositeHorizontalOrientation(attachOrientation, targetOrientation) || isSame(attachOrientation, targetOrientation)) return 'h';
            // fallback
            return 'v';
        } else {
            // orientation is top or bottom
            // opposite vertical orientation or same orientation
            if (isOppositeVerticalOrientation(attachOrientation, targetOrientation) || isSame(attachOrientation, targetOrientation)) return 'v';
            // fallback
            return 'h';
        }
    }
    // attached to either top-right, top-left, bottom-right or bottom-left corner
    // orientation is right, left
    // or same vertical orientation but also right or left
    if (isHorizontalOrientation(targetOrientation) || isSame(getVerticalOrientation(attachOrientation), getVerticalOrientation(targetOrientation)) && getHorizontalOrientation(targetOrientation)) return 'h';
    else return 'v';
}

},{"inherits-browser":"hymxq","min-dash":"aEEla","diagram-js/lib/layout/BaseLayouter":"ft12K","diagram-js/lib/layout/ManhattanLayout":"h13l9","diagram-js/lib/layout/LayoutUtil":"4CCrs","../../util/DiUtil":"krDFz","../../util/ModelUtil":"klNYN","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ft12K":[function(require,module,exports,__globalThis) {
/**
 * @typedef {import('../model').Base} Base
 * @typedef {import('../model').Connection} Connection
 *
 * @typedef {import('../util').Point} Point
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BaseLayouter);
var _layoutUtil = require("./LayoutUtil");
function BaseLayouter() {}
/**
 * Return the new layouted waypoints for the given connection.
 *
 * The connection passed is still unchanged; you may figure out about
 * the new connection start / end via the layout hints provided.
 *
 * @param {Connection} connection
 * @param {Object} [hints]
 * @param {Point} [hints.connectionStart]
 * @param {Point} [hints.connectionEnd]
 * @param {Base} [hints.source]
 * @param {Base} [hints.target]
 *
 * @return {Point[]} The waypoints of the laid out connection.
 */ BaseLayouter.prototype.layoutConnection = function(connection, hints) {
    hints = hints || {};
    return [
        hints.connectionStart || (0, _layoutUtil.getMid)(hints.source || connection.source),
        hints.connectionEnd || (0, _layoutUtil.getMid)(hints.target || connection.target)
    ];
};

},{"./LayoutUtil":"4CCrs","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"h13l9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Create a connection between the two points according
 * to the manhattan layout (only horizontal and vertical) edges.
 *
 * @param {Point} a
 * @param {Point} b
 * @param {string} [directions='h:h'] Specifies manhattan directions for each
 * point as {direction}:{direction}. A direction for a point is either
 * `h` (horizontal) or `v` (vertical).
 *
 * @return {Point[]}
 */ parcelHelpers.export(exports, "connectPoints", ()=>connectPoints);
/**
 * Connect two rectangles using a manhattan layouted connection.
 *
 * @param {Rect} source source rectangle
 * @param {Rect} target target rectangle
 * @param {Point} [start] source docking
 * @param {Point} [end] target docking
 *
 * @param {Object} [hints]
 * @param {string} [hints.preserveDocking=source] preserve docking on selected side
 * @param {string[]} [hints.preferredLayouts]
 * @param {Point|boolean} [hints.connectionStart] whether the start changed
 * @param {Point|boolean} [hints.connectionEnd] whether the end changed
 *
 * @return {Point[]} connection points
 */ parcelHelpers.export(exports, "connectRectangles", ()=>connectRectangles);
/**
 * Repair the connection between two rectangles, of which one has been updated.
 *
 * @param {Rect} source
 * @param {Rect} target
 * @param {Point} [start]
 * @param {Point} [end]
 * @param {Point[]} [waypoints]
 * @param {Object} [hints]
 * @param {string[]} [hints.preferredLayouts] The list of preferred layouts.
 * @param {boolean} [hints.connectionStart]
 * @param {boolean} [hints.connectionEnd]
 *
 * @return {Point[]} The waypoints of the repaired connection.
 */ parcelHelpers.export(exports, "repairConnection", ()=>repairConnection);
/**
 * Lay out a straight connection.
 *
 * @param {Rect} source
 * @param {Rect} target
 * @param {Point} start
 * @param {Point} end
 * @param {Object} [hints]
 *
 * @return {Point[]|null} The waypoints or null if layout isn't possible.
 */ parcelHelpers.export(exports, "tryLayoutStraight", ()=>tryLayoutStraight);
/**
 * Return list of waypoints with redundant ones filtered out.
 *
 * @example
 *
 * Original points:
 *
 *   [x] ----- [x] ------ [x]
 *                         |
 *                        [x] ----- [x] - [x]
 *
 * Filtered:
 *
 *   [x] ---------------- [x]
 *                         |
 *                        [x] ----------- [x]
 *
 * @param {Point[]} waypoints
 *
 * @return {Point[]}
 */ parcelHelpers.export(exports, "withoutRedundantPoints", ()=>withoutRedundantPoints);
var _minDash = require("min-dash");
var _layoutUtil = require("./LayoutUtil");
var _geometry = require("../util/Geometry");
/**
 * @typedef {import('../util/Types').Point} Point
 * @typedef {import('../util/Types').Rect} Rect
 */ var MIN_SEGMENT_LENGTH = 20, POINT_ORIENTATION_PADDING = 5;
var round = Math.round;
var INTERSECTION_THRESHOLD = 20, ORIENTATION_THRESHOLD = {
    'h:h': 20,
    'v:v': 20,
    'h:v': -10,
    'v:h': -10
};
function needsTurn(orientation, startDirection) {
    return !({
        t: /top/,
        r: /right/,
        b: /bottom/,
        l: /left/,
        h: /./,
        v: /./
    })[startDirection].test(orientation);
}
function canLayoutStraight(direction, targetOrientation) {
    return ({
        t: /top/,
        r: /right/,
        b: /bottom/,
        l: /left/,
        h: /left|right/,
        v: /top|bottom/
    })[direction].test(targetOrientation);
}
function getSegmentBendpoints(a, b, directions) {
    var orientation = (0, _layoutUtil.getOrientation)(b, a, POINT_ORIENTATION_PADDING);
    var startDirection = directions.split(':')[0];
    var xmid = round((b.x - a.x) / 2 + a.x), ymid = round((b.y - a.y) / 2 + a.y);
    var segmentEnd, segmentDirections;
    var layoutStraight = canLayoutStraight(startDirection, orientation), layoutHorizontal = /h|r|l/.test(startDirection), layoutTurn = false;
    var turnNextDirections = false;
    if (layoutStraight) {
        segmentEnd = layoutHorizontal ? {
            x: xmid,
            y: a.y
        } : {
            x: a.x,
            y: ymid
        };
        segmentDirections = layoutHorizontal ? 'h:h' : 'v:v';
    } else {
        layoutTurn = needsTurn(orientation, startDirection);
        segmentDirections = layoutHorizontal ? 'h:v' : 'v:h';
        if (layoutTurn) {
            if (layoutHorizontal) {
                turnNextDirections = ymid === a.y;
                segmentEnd = {
                    x: a.x + MIN_SEGMENT_LENGTH * (/l/.test(startDirection) ? -1 : 1),
                    y: turnNextDirections ? ymid + MIN_SEGMENT_LENGTH : ymid
                };
            } else {
                turnNextDirections = xmid === a.x;
                segmentEnd = {
                    x: turnNextDirections ? xmid + MIN_SEGMENT_LENGTH : xmid,
                    y: a.y + MIN_SEGMENT_LENGTH * (/t/.test(startDirection) ? -1 : 1)
                };
            }
        } else segmentEnd = {
            x: xmid,
            y: ymid
        };
    }
    return {
        waypoints: getBendpoints(a, segmentEnd, segmentDirections).concat(segmentEnd),
        directions: segmentDirections,
        turnNextDirections: turnNextDirections
    };
}
function getStartSegment(a, b, directions) {
    return getSegmentBendpoints(a, b, directions);
}
function getEndSegment(a, b, directions) {
    var invertedSegment = getSegmentBendpoints(b, a, invertDirections(directions));
    return {
        waypoints: invertedSegment.waypoints.slice().reverse(),
        directions: invertDirections(invertedSegment.directions),
        turnNextDirections: invertedSegment.turnNextDirections
    };
}
function getMidSegment(startSegment, endSegment) {
    var startDirection = startSegment.directions.split(':')[1], endDirection = endSegment.directions.split(':')[0];
    if (startSegment.turnNextDirections) startDirection = startDirection == 'h' ? 'v' : 'h';
    if (endSegment.turnNextDirections) endDirection = endDirection == 'h' ? 'v' : 'h';
    var directions = startDirection + ':' + endDirection;
    var bendpoints = getBendpoints(startSegment.waypoints[startSegment.waypoints.length - 1], endSegment.waypoints[0], directions);
    return {
        waypoints: bendpoints,
        directions: directions
    };
}
function invertDirections(directions) {
    return directions.split(':').reverse().join(':');
}
/**
 * Handle simple layouts with maximum two bendpoints.
 */ function getSimpleBendpoints(a, b, directions) {
    var xmid = round((b.x - a.x) / 2 + a.x), ymid = round((b.y - a.y) / 2 + a.y);
    // one point, right or left from a
    if (directions === 'h:v') return [
        {
            x: b.x,
            y: a.y
        }
    ];
    // one point, above or below a
    if (directions === 'v:h') return [
        {
            x: a.x,
            y: b.y
        }
    ];
    // vertical segment between a and b
    if (directions === 'h:h') return [
        {
            x: xmid,
            y: a.y
        },
        {
            x: xmid,
            y: b.y
        }
    ];
    // horizontal segment between a and b
    if (directions === 'v:v') return [
        {
            x: a.x,
            y: ymid
        },
        {
            x: b.x,
            y: ymid
        }
    ];
    throw new Error('invalid directions: can only handle varians of [hv]:[hv]');
}
/**
 * Returns the mid points for a manhattan connection between two points.
 *
 * @example h:h (horizontal:horizontal)
 *
 * [a]----[x]
 *         |
 *        [x]----[b]
 *
 * @example h:v (horizontal:vertical)
 *
 * [a]----[x]
 *         |
 *        [b]
 *
 * @example h:r (horizontal:right)
 *
 * [a]----[x]
 *         |
 *    [b]-[x]
 *
 * @param {Point} a
 * @param {Point} b
 * @param {string} directions
 *
 * @return {Point[]}
 */ function getBendpoints(a, b, directions) {
    directions = directions || 'h:h';
    if (!isValidDirections(directions)) throw new Error('unknown directions: <' + directions + '>: ' + 'must be specified as <start>:<end> ' + 'with start/end in { h,v,t,r,b,l }');
    // compute explicit directions, involving trbl dockings
    // using a three segmented layouting algorithm
    if (isExplicitDirections(directions)) {
        var startSegment = getStartSegment(a, b, directions), endSegment = getEndSegment(a, b, directions), midSegment = getMidSegment(startSegment, endSegment);
        return [].concat(startSegment.waypoints, midSegment.waypoints, endSegment.waypoints);
    }
    // handle simple [hv]:[hv] cases that can be easily computed
    return getSimpleBendpoints(a, b, directions);
}
function connectPoints(a, b, directions) {
    var points = getBendpoints(a, b, directions);
    points.unshift(a);
    points.push(b);
    return withoutRedundantPoints(points);
}
function connectRectangles(source, target, start, end, hints) {
    var preferredLayouts = hints && hints.preferredLayouts || [];
    var preferredLayout = (0, _minDash.without)(preferredLayouts, 'straight')[0] || 'h:h';
    var threshold = ORIENTATION_THRESHOLD[preferredLayout] || 0;
    var orientation = (0, _layoutUtil.getOrientation)(source, target, threshold);
    var directions = getDirections(orientation, preferredLayout);
    start = start || (0, _layoutUtil.getMid)(source);
    end = end || (0, _layoutUtil.getMid)(target);
    var directionSplit = directions.split(':');
    // compute actual docking points for start / end
    // this ensures we properly layout only parts of the
    // connection that lies in between the two rectangles
    var startDocking = getDockingPoint(start, source, directionSplit[0], invertOrientation(orientation)), endDocking = getDockingPoint(end, target, directionSplit[1], orientation);
    return connectPoints(startDocking, endDocking, directions);
}
function repairConnection(source, target, start, end, waypoints, hints) {
    if ((0, _minDash.isArray)(start)) {
        waypoints = start;
        hints = end;
        start = (0, _layoutUtil.getMid)(source);
        end = (0, _layoutUtil.getMid)(target);
    }
    hints = (0, _minDash.assign)({
        preferredLayouts: []
    }, hints);
    waypoints = waypoints || [];
    var preferredLayouts = hints.preferredLayouts, preferStraight = preferredLayouts.indexOf('straight') !== -1, repairedWaypoints;
    // just layout non-existing or simple connections
    // attempt to render straight lines, if required
    // attempt to layout a straight line
    repairedWaypoints = preferStraight && tryLayoutStraight(source, target, start, end, hints);
    if (repairedWaypoints) return repairedWaypoints;
    // try to layout from end
    repairedWaypoints = hints.connectionEnd && tryRepairConnectionEnd(target, source, end, waypoints);
    if (repairedWaypoints) return repairedWaypoints;
    // try to layout from start
    repairedWaypoints = hints.connectionStart && tryRepairConnectionStart(source, target, start, waypoints);
    if (repairedWaypoints) return repairedWaypoints;
    // or whether nothing seems to have changed
    if (!hints.connectionStart && !hints.connectionEnd && waypoints && waypoints.length) return waypoints;
    // simply reconnect if nothing else worked
    return connectRectangles(source, target, start, end, hints);
}
function inRange(a, start, end) {
    return a >= start && a <= end;
}
function isInRange(axis, a, b) {
    var size = {
        x: 'width',
        y: 'height'
    };
    return inRange(a[axis], b[axis], b[axis] + b[size[axis]]);
}
function tryLayoutStraight(source, target, start, end, hints) {
    var axis = {}, primaryAxis, orientation;
    orientation = (0, _layoutUtil.getOrientation)(source, target);
    // only layout a straight connection if shapes are
    // horizontally or vertically aligned
    if (!/^(top|bottom|left|right)$/.test(orientation)) return null;
    if (/top|bottom/.test(orientation)) primaryAxis = 'x';
    if (/left|right/.test(orientation)) primaryAxis = 'y';
    if (hints.preserveDocking === 'target') {
        if (!isInRange(primaryAxis, end, source)) return null;
        axis[primaryAxis] = end[primaryAxis];
        return [
            {
                x: axis.x !== undefined ? axis.x : start.x,
                y: axis.y !== undefined ? axis.y : start.y,
                original: {
                    x: axis.x !== undefined ? axis.x : start.x,
                    y: axis.y !== undefined ? axis.y : start.y
                }
            },
            {
                x: end.x,
                y: end.y
            }
        ];
    } else {
        if (!isInRange(primaryAxis, start, target)) return null;
        axis[primaryAxis] = start[primaryAxis];
        return [
            {
                x: start.x,
                y: start.y
            },
            {
                x: axis.x !== undefined ? axis.x : end.x,
                y: axis.y !== undefined ? axis.y : end.y,
                original: {
                    x: axis.x !== undefined ? axis.x : end.x,
                    y: axis.y !== undefined ? axis.y : end.y
                }
            }
        ];
    }
}
/**
 * Repair a connection from start.
 *
 * @param {Rect} moved
 * @param {Rect} other
 * @param {Point} newDocking
 * @param {Point[]} points originalPoints from moved to other
 *
 * @return {Point[]|null} The waypoints of the repaired connection.
 */ function tryRepairConnectionStart(moved, other, newDocking, points) {
    return _tryRepairConnectionSide(moved, other, newDocking, points);
}
/**
 * Repair a connection from end.
 *
 * @param {Rect} moved
 * @param {Rect} other
 * @param {Point} newDocking
 * @param {Point[]} points originalPoints from moved to other
 *
 * @return {Point[]|null} The waypoints of the repaired connection.
 */ function tryRepairConnectionEnd(moved, other, newDocking, points) {
    var waypoints = points.slice().reverse();
    waypoints = _tryRepairConnectionSide(moved, other, newDocking, waypoints);
    return waypoints ? waypoints.reverse() : null;
}
/**
 * Repair a connection from one side that moved.
 *
 * @param {Rect} moved
 * @param {Rect} other
 * @param {Point} newDocking
 * @param {Point[]} points originalPoints from moved to other
 *
 * @return {Point[]} The waypoints of the repaired connection.
 */ function _tryRepairConnectionSide(moved, other, newDocking, points) {
    function needsRelayout(points) {
        if (points.length < 3) return true;
        if (points.length > 4) return false;
        // relayout if two points overlap
        // this is most likely due to
        return !!(0, _minDash.find)(points, function(p, idx) {
            var q = points[idx - 1];
            return q && (0, _geometry.pointDistance)(p, q) < 3;
        });
    }
    function repairBendpoint(candidate, oldPeer, newPeer) {
        var alignment = (0, _geometry.pointsAligned)(oldPeer, candidate);
        switch(alignment){
            case 'v':
                // repair horizontal alignment
                return {
                    x: newPeer.x,
                    y: candidate.y
                };
            case 'h':
                // repair vertical alignment
                return {
                    x: candidate.x,
                    y: newPeer.y
                };
        }
        return {
            x: candidate.x,
            y: candidate.y
        };
    }
    function removeOverlapping(points, a, b) {
        var i;
        for(i = points.length - 2; i !== 0; i--){
            // intersects (?) break, remove all bendpoints up to this one and relayout
            if ((0, _geometry.pointInRect)(points[i], a, INTERSECTION_THRESHOLD) || (0, _geometry.pointInRect)(points[i], b, INTERSECTION_THRESHOLD)) // return sliced old connection
            return points.slice(i);
        }
        return points;
    }
    // (0) only repair what has layoutable bendpoints
    // (1) if only one bendpoint and on shape moved onto other shapes axis
    //     (horizontally / vertically), relayout
    if (needsRelayout(points)) return null;
    var oldDocking = points[0], newPoints = points.slice(), slicedPoints;
    // (2) repair only last line segment and only if it was layouted before
    newPoints[0] = newDocking;
    newPoints[1] = repairBendpoint(newPoints[1], oldDocking, newDocking);
    // (3) if shape intersects with any bendpoint after repair,
    //     remove all segments up to this bendpoint and repair from there
    slicedPoints = removeOverlapping(newPoints, moved, other);
    if (slicedPoints !== newPoints) newPoints = _tryRepairConnectionSide(moved, other, newDocking, slicedPoints);
    // (4) do NOT repair if repaired bendpoints are aligned
    if (newPoints && (0, _geometry.pointsAligned)(newPoints)) return null;
    return newPoints;
}
/**
 * Returns the manhattan directions connecting two rectangles
 * with the given orientation.
 *
 * Will always return the default layout, if it is specific
 * regarding sides already (trbl).
 *
 * @example
 *
 * getDirections('top'); // -> 'v:v'
 * getDirections('intersect'); // -> 't:t'
 *
 * getDirections('top-right', 'v:h'); // -> 'v:h'
 * getDirections('top-right', 'h:h'); // -> 'h:h'
 *
 *
 * @param {string} orientation
 * @param {string} defaultLayout
 *
 * @return {string}
 */ function getDirections(orientation, defaultLayout) {
    // don't override specific trbl directions
    if (isExplicitDirections(defaultLayout)) return defaultLayout;
    switch(orientation){
        case 'intersect':
            return 't:t';
        case 'top':
        case 'bottom':
            return 'v:v';
        case 'left':
        case 'right':
            return 'h:h';
        // 'top-left'
        // 'top-right'
        // 'bottom-left'
        // 'bottom-right'
        default:
            return defaultLayout;
    }
}
function isValidDirections(directions) {
    return directions && /^h|v|t|r|b|l:h|v|t|r|b|l$/.test(directions);
}
function isExplicitDirections(directions) {
    return directions && /t|r|b|l/.test(directions);
}
function invertOrientation(orientation) {
    return ({
        'top': 'bottom',
        'bottom': 'top',
        'left': 'right',
        'right': 'left',
        'top-left': 'bottom-right',
        'bottom-right': 'top-left',
        'top-right': 'bottom-left',
        'bottom-left': 'top-right'
    })[orientation];
}
function getDockingPoint(point, rectangle, dockingDirection, targetOrientation) {
    // ensure we end up with a specific docking direction
    // based on the targetOrientation, if <h|v> is being passed
    if (dockingDirection === 'h') dockingDirection = /left/.test(targetOrientation) ? 'l' : 'r';
    if (dockingDirection === 'v') dockingDirection = /top/.test(targetOrientation) ? 't' : 'b';
    if (dockingDirection === 't') return {
        original: point,
        x: point.x,
        y: rectangle.y
    };
    if (dockingDirection === 'r') return {
        original: point,
        x: rectangle.x + rectangle.width,
        y: point.y
    };
    if (dockingDirection === 'b') return {
        original: point,
        x: point.x,
        y: rectangle.y + rectangle.height
    };
    if (dockingDirection === 'l') return {
        original: point,
        x: rectangle.x,
        y: point.y
    };
    throw new Error('unexpected dockingDirection: <' + dockingDirection + '>');
}
function withoutRedundantPoints(waypoints) {
    return waypoints.reduce(function(points, p, idx) {
        var previous = points[points.length - 1], next = waypoints[idx + 1];
        if (!(0, _geometry.pointsOnLine)(previous, next, p, 0)) points.push(p);
        return points;
    }, []);
}

},{"min-dash":"aEEla","./LayoutUtil":"4CCrs","../util/Geometry":"1zZUi","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"43G8V":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CroppingConnectionDocking);
var _minDash = require("min-dash");
var _layoutUtil = require("./LayoutUtil");
/**
 * @typedef {import('../core/ElementRegistry').default} ElementRegistry
 * @typedef {import('../core/GraphicsFactory').default} GraphicsFactory
 */ function dockingToPoint(docking) {
    // use the dockings actual point and
    // retain the original docking
    return (0, _minDash.assign)({
        original: docking.point.original || docking.point
    }, docking.actual);
}
function CroppingConnectionDocking(elementRegistry, graphicsFactory) {
    this._elementRegistry = elementRegistry;
    this._graphicsFactory = graphicsFactory;
}
CroppingConnectionDocking.$inject = [
    'elementRegistry',
    'graphicsFactory'
];
/**
 * @inheritDoc ConnectionDocking#getCroppedWaypoints
 */ CroppingConnectionDocking.prototype.getCroppedWaypoints = function(connection, source, target) {
    source = source || connection.source;
    target = target || connection.target;
    var sourceDocking = this.getDockingPoint(connection, source, true), targetDocking = this.getDockingPoint(connection, target);
    var croppedWaypoints = connection.waypoints.slice(sourceDocking.idx + 1, targetDocking.idx);
    croppedWaypoints.unshift(dockingToPoint(sourceDocking));
    croppedWaypoints.push(dockingToPoint(targetDocking));
    return croppedWaypoints;
};
/**
 * Return the connection docking point on the specified shape
 *
 * @inheritDoc ConnectionDocking#getDockingPoint
 */ CroppingConnectionDocking.prototype.getDockingPoint = function(connection, shape, dockStart) {
    var waypoints = connection.waypoints, dockingIdx, dockingPoint, croppedPoint;
    dockingIdx = dockStart ? 0 : waypoints.length - 1;
    dockingPoint = waypoints[dockingIdx];
    croppedPoint = this._getIntersection(shape, connection, dockStart);
    return {
        point: dockingPoint,
        actual: croppedPoint || dockingPoint,
        idx: dockingIdx
    };
};
// helpers //////////////////////
CroppingConnectionDocking.prototype._getIntersection = function(shape, connection, takeFirst) {
    var shapePath = this._getShapePath(shape), connectionPath = this._getConnectionPath(connection);
    return (0, _layoutUtil.getElementLineIntersection)(shapePath, connectionPath, takeFirst);
};
CroppingConnectionDocking.prototype._getConnectionPath = function(connection) {
    return this._graphicsFactory.getConnectionPath(connection);
};
CroppingConnectionDocking.prototype._getShapePath = function(shape) {
    return this._graphicsFactory.getShapePath(shape);
};
CroppingConnectionDocking.prototype._getGfx = function(element) {
    return this._elementRegistry.getGraphics(element);
};

},{"min-dash":"aEEla","./LayoutUtil":"4CCrs","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"43EOh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _interactionEvents = require("../interaction-events");
var _interactionEventsDefault = parcelHelpers.interopDefault(_interactionEvents);
var _selection = require("../selection");
var _selectionDefault = parcelHelpers.interopDefault(_selection);
var _outline = require("../outline");
var _outlineDefault = parcelHelpers.interopDefault(_outline);
var _rules = require("../rules");
var _rulesDefault = parcelHelpers.interopDefault(_rules);
var _dragging = require("../dragging");
var _draggingDefault = parcelHelpers.interopDefault(_dragging);
var _previewSupport = require("../preview-support");
var _previewSupportDefault = parcelHelpers.interopDefault(_previewSupport);
var _move = require("./Move");
var _moveDefault = parcelHelpers.interopDefault(_move);
var _movePreview = require("./MovePreview");
var _movePreviewDefault = parcelHelpers.interopDefault(_movePreview);
exports.default = {
    __depends__: [
        (0, _interactionEventsDefault.default),
        (0, _selectionDefault.default),
        (0, _outlineDefault.default),
        (0, _rulesDefault.default),
        (0, _draggingDefault.default),
        (0, _previewSupportDefault.default)
    ],
    __init__: [
        'move',
        'movePreview'
    ],
    move: [
        'type',
        (0, _moveDefault.default)
    ],
    movePreview: [
        'type',
        (0, _movePreviewDefault.default)
    ]
};

},{"../interaction-events":"4qbdP","../selection":"8Jf3R","../outline":"2Z6Dm","../rules":"5xj5a","../dragging":"2U3QS","../preview-support":"fEfos","./Move":"34XaO","./MovePreview":"2BNBU","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"34XaO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>MoveEvents);
var _minDash = require("min-dash");
var _tinySvg = require("tiny-svg");
var _event = require("../../util/Event");
var _mouse = require("../../util/Mouse");
/**
 * @typedef {import('../../model').Base} Base
 * @typedef {import('../../model').Shape} Shape
 *
 * @typedef {import('../dragging/Dragging').default} Dragging
 * @typedef {import('../../core/EventBus').default} EventBus
 * @typedef {import('../modeling/Modeling').default} Modeling
 * @typedef {import('../rules/Rules').default} Rules
 * @typedef {import('../selection/Selection').default} Selection
 */ var LOW_PRIORITY = 500, MEDIUM_PRIORITY = 1250, HIGH_PRIORITY = 1500;
var round = Math.round;
function mid(element) {
    return {
        x: element.x + round(element.width / 2),
        y: element.y + round(element.height / 2)
    };
}
function MoveEvents(eventBus, dragging, modeling, selection, rules) {
    // rules
    function canMove(shapes, delta, position, target) {
        return rules.allowed('elements.move', {
            shapes: shapes,
            delta: delta,
            position: position,
            target: target
        });
    }
    // move events
    // assign a high priority to this handler to setup the environment
    // others may hook up later, e.g. at default priority and modify
    // the move environment.
    //
    // This sets up the context with
    //
    // * shape: the primary shape being moved
    // * shapes: a list of shapes to be moved
    // * validatedShapes: a list of shapes that are being checked
    //                    against the rules before and during move
    //
    eventBus.on('shape.move.start', HIGH_PRIORITY, function(event) {
        var context = event.context, shape = event.shape, shapes = selection.get().slice();
        // move only single shape if the dragged element
        // is not part of the current selection
        if (shapes.indexOf(shape) === -1) shapes = [
            shape
        ];
        // ensure we remove nested elements in the collection
        // and add attachers for a proper dragger
        shapes = removeNested(shapes);
        // attach shapes to drag context
        (0, _minDash.assign)(context, {
            shapes: shapes,
            validatedShapes: shapes,
            shape: shape
        });
    });
    // assign a high priority to this handler to setup the environment
    // others may hook up later, e.g. at default priority and modify
    // the move environment
    //
    eventBus.on('shape.move.start', MEDIUM_PRIORITY, function(event) {
        var context = event.context, validatedShapes = context.validatedShapes, canExecute;
        canExecute = context.canExecute = canMove(validatedShapes);
        // check if we can move the elements
        if (!canExecute) return false;
    });
    // assign a low priority to this handler
    // to let others modify the move event before we update
    // the context
    //
    eventBus.on('shape.move.move', LOW_PRIORITY, function(event) {
        var context = event.context, validatedShapes = context.validatedShapes, hover = event.hover, delta = {
            x: event.dx,
            y: event.dy
        }, position = {
            x: event.x,
            y: event.y
        }, canExecute;
        // check if we can move the elements
        canExecute = canMove(validatedShapes, delta, position, hover);
        context.delta = delta;
        context.canExecute = canExecute;
        // simply ignore move over
        if (canExecute === null) {
            context.target = null;
            return;
        }
        context.target = hover;
    });
    eventBus.on('shape.move.end', function(event) {
        var context = event.context;
        var delta = context.delta, canExecute = context.canExecute, isAttach = canExecute === 'attach', shapes = context.shapes;
        if (canExecute === false) return false;
        // ensure we have actual pixel values deltas
        // (important when zoom level was > 1 during move)
        delta.x = round(delta.x);
        delta.y = round(delta.y);
        if (delta.x === 0 && delta.y === 0) // didn't move
        return;
        modeling.moveElements(shapes, delta, context.target, {
            primaryShape: context.shape,
            attach: isAttach
        });
    });
    // move activation
    eventBus.on('element.mousedown', function(event) {
        if (!(0, _mouse.isPrimaryButton)(event)) return;
        var originalEvent = (0, _event.getOriginal)(event);
        if (!originalEvent) throw new Error('must supply DOM mousedown event');
        return start(originalEvent, event.element);
    });
    /**
   * Start move.
   *
   * @param {MouseEvent|TouchEvent} event
   * @param {Shape} shape
   * @param {boolean} [activate]
   * @param {Object} [context]
   */ function start(event, element, activate, context) {
        if ((0, _minDash.isObject)(activate)) {
            context = activate;
            activate = false;
        }
        // do not move connections or the root element
        if (element.waypoints || !element.parent) return;
        // ignore non-draggable hits
        if ((0, _tinySvg.classes)(event.target).has('djs-hit-no-move')) return;
        var referencePoint = mid(element);
        dragging.init(event, referencePoint, 'shape.move', {
            cursor: 'grabbing',
            autoActivate: activate,
            data: {
                shape: element,
                context: context || {}
            }
        });
        // we've handled the event
        return true;
    }
    // API
    this.start = start;
}
MoveEvents.$inject = [
    'eventBus',
    'dragging',
    'modeling',
    'selection',
    'rules'
];
/**
 * Return a filtered list of elements that do not contain
 * those nested into others.
 *
 * @param {Array<Base>} elements
 *
 * @return {Array<Base>} filtered
 */ function removeNested(elements) {
    var ids = (0, _minDash.groupBy)(elements, 'id');
    return (0, _minDash.filter)(elements, function(element) {
        while(element = element.parent){
            // parent in selection
            if (ids[element.id]) return false;
        }
        return true;
    });
}

},{"min-dash":"aEEla","tiny-svg":"6ZtXA","../../util/Event":"a3pF2","../../util/Mouse":"9MyMy","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2BNBU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>MovePreview);
var _minDash = require("min-dash");
var _elements = require("../../util/Elements");
var _tinySvg = require("tiny-svg");
var _svgTransformUtil = require("../../util/SvgTransformUtil");
/**
 * @typedef {import('../../model').Base} Base
 *
 * @typedef {import('../../core/Canvas').default} Canvas
 * @typedef {import('../../core/EventBus').default} EventBus
 * @typedef {import('../preview-support/PreviewSupport').default} PreviewSupport
 * @typedef {import('../../draw/Styles').default} Styles
 */ var LOW_PRIORITY = 499;
var MARKER_DRAGGING = 'djs-dragging', MARKER_OK = 'drop-ok', MARKER_NOT_OK = 'drop-not-ok', MARKER_NEW_PARENT = 'new-parent', MARKER_ATTACH = 'attach-ok';
function MovePreview(eventBus, canvas, styles, previewSupport) {
    function getVisualDragShapes(shapes) {
        var elements = getAllDraggedElements(shapes);
        var filteredElements = removeEdges(elements);
        return filteredElements;
    }
    function getAllDraggedElements(shapes) {
        var allShapes = (0, _elements.selfAndAllChildren)(shapes, true);
        var allConnections = (0, _minDash.map)(allShapes, function(shape) {
            return (shape.incoming || []).concat(shape.outgoing || []);
        });
        return (0, _minDash.flatten)(allShapes.concat(allConnections));
    }
    /**
   * Sets drop marker on an element.
   */ function setMarker(element, marker) {
        [
            MARKER_ATTACH,
            MARKER_OK,
            MARKER_NOT_OK,
            MARKER_NEW_PARENT
        ].forEach(function(m) {
            if (m === marker) canvas.addMarker(element, m);
            else canvas.removeMarker(element, m);
        });
    }
    /**
   * Make an element draggable.
   *
   * @param {Object} context
   * @param {Base} element
   * @param {boolean} addMarker
   */ function makeDraggable(context, element, addMarker) {
        previewSupport.addDragger(element, context.dragGroup);
        if (addMarker) canvas.addMarker(element, MARKER_DRAGGING);
        if (context.allDraggedElements) context.allDraggedElements.push(element);
        else context.allDraggedElements = [
            element
        ];
    }
    // assign a low priority to this handler
    // to let others modify the move context before
    // we draw things
    eventBus.on('shape.move.start', LOW_PRIORITY, function(event) {
        var context = event.context, dragShapes = context.shapes, allDraggedElements = context.allDraggedElements;
        var visuallyDraggedShapes = getVisualDragShapes(dragShapes);
        if (!context.dragGroup) {
            var dragGroup = (0, _tinySvg.create)('g');
            (0, _tinySvg.attr)(dragGroup, styles.cls('djs-drag-group', [
                'no-events'
            ]));
            var activeLayer = canvas.getActiveLayer();
            (0, _tinySvg.append)(activeLayer, dragGroup);
            context.dragGroup = dragGroup;
        }
        // add previews
        visuallyDraggedShapes.forEach(function(shape) {
            previewSupport.addDragger(shape, context.dragGroup);
        });
        // cache all dragged elements / gfx
        // so that we can quickly undo their state changes later
        if (!allDraggedElements) allDraggedElements = getAllDraggedElements(dragShapes);
        else allDraggedElements = (0, _minDash.flatten)([
            allDraggedElements,
            getAllDraggedElements(dragShapes)
        ]);
        // add dragging marker
        (0, _minDash.forEach)(allDraggedElements, function(e) {
            canvas.addMarker(e, MARKER_DRAGGING);
        });
        context.allDraggedElements = allDraggedElements;
        // determine, if any of the dragged elements have different parents
        context.differentParents = haveDifferentParents(dragShapes);
    });
    // update previews
    eventBus.on('shape.move.move', LOW_PRIORITY, function(event) {
        var context = event.context, dragGroup = context.dragGroup, target = context.target, parent = context.shape.parent, canExecute = context.canExecute;
        if (target) {
            if (canExecute === 'attach') setMarker(target, MARKER_ATTACH);
            else if (context.canExecute && target && target.id !== parent.id) setMarker(target, MARKER_NEW_PARENT);
            else setMarker(target, context.canExecute ? MARKER_OK : MARKER_NOT_OK);
        }
        (0, _svgTransformUtil.translate)(dragGroup, event.dx, event.dy);
    });
    eventBus.on([
        'shape.move.out',
        'shape.move.cleanup'
    ], function(event) {
        var context = event.context, target = context.target;
        if (target) setMarker(target, null);
    });
    // remove previews
    eventBus.on('shape.move.cleanup', function(event) {
        var context = event.context, allDraggedElements = context.allDraggedElements, dragGroup = context.dragGroup;
        // remove dragging marker
        (0, _minDash.forEach)(allDraggedElements, function(e) {
            canvas.removeMarker(e, MARKER_DRAGGING);
        });
        if (dragGroup) (0, _tinySvg.remove)(dragGroup);
    });
    // API //////////////////////
    /**
   * Make an element draggable.
   *
   * @param {Object} context
   * @param {Base} element
   * @param {boolean} addMarker
   */ this.makeDraggable = makeDraggable;
}
MovePreview.$inject = [
    'eventBus',
    'canvas',
    'styles',
    'previewSupport'
];
// helpers //////////////////////
/**
 * returns elements minus all connections
 * where source or target is not elements
 */ function removeEdges(elements) {
    var filteredElements = (0, _minDash.filter)(elements, function(element) {
        if (!isConnection(element)) return true;
        else return (0, _minDash.find)(elements, (0, _minDash.matchPattern)({
            id: element.source.id
        })) && (0, _minDash.find)(elements, (0, _minDash.matchPattern)({
            id: element.target.id
        }));
    });
    return filteredElements;
}
function haveDifferentParents(elements) {
    return (0, _minDash.size)((0, _minDash.groupBy)(elements, function(e) {
        return e.parent && e.parent.id;
    })) !== 1;
}
/**
 * Checks if an element is a connection.
 */ function isConnection(element) {
    return element.waypoints;
}

},{"min-dash":"aEEla","../../util/Elements":"6qdtl","tiny-svg":"6ZtXA","../../util/SvgTransformUtil":"g4Nbc","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kTZOk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _palette = require("diagram-js/lib/features/palette");
var _paletteDefault = parcelHelpers.interopDefault(_palette);
var _create = require("diagram-js/lib/features/create");
var _createDefault = parcelHelpers.interopDefault(_create);
var _spaceTool = require("../space-tool");
var _spaceToolDefault = parcelHelpers.interopDefault(_spaceTool);
var _lassoTool = require("diagram-js/lib/features/lasso-tool");
var _lassoToolDefault = parcelHelpers.interopDefault(_lassoTool);
var _handTool = require("diagram-js/lib/features/hand-tool");
var _handToolDefault = parcelHelpers.interopDefault(_handTool);
var _globalConnect = require("diagram-js/lib/features/global-connect");
var _globalConnectDefault = parcelHelpers.interopDefault(_globalConnect);
var _translate = require("diagram-js/lib/i18n/translate");
var _translateDefault = parcelHelpers.interopDefault(_translate);
var _paletteProvider = require("./PaletteProvider");
var _paletteProviderDefault = parcelHelpers.interopDefault(_paletteProvider);
exports.default = {
    __depends__: [
        (0, _paletteDefault.default),
        (0, _createDefault.default),
        (0, _spaceToolDefault.default),
        (0, _lassoToolDefault.default),
        (0, _handToolDefault.default),
        (0, _globalConnectDefault.default),
        (0, _translateDefault.default)
    ],
    __init__: [
        'paletteProvider'
    ],
    paletteProvider: [
        'type',
        (0, _paletteProviderDefault.default)
    ]
};

},{"diagram-js/lib/features/palette":"e4Zt0","diagram-js/lib/features/create":"kKw9I","../space-tool":"lQ7gB","diagram-js/lib/features/lasso-tool":"jLrPF","diagram-js/lib/features/hand-tool":"OPcPX","diagram-js/lib/features/global-connect":"euMEP","diagram-js/lib/i18n/translate":"lgOY2","./PaletteProvider":"ffzhx","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jLrPF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _toolManager = require("../tool-manager");
var _toolManagerDefault = parcelHelpers.interopDefault(_toolManager);
var _mouse = require("../mouse");
var _mouseDefault = parcelHelpers.interopDefault(_mouse);
var _lassoTool = require("./LassoTool");
var _lassoToolDefault = parcelHelpers.interopDefault(_lassoTool);
exports.default = {
    __depends__: [
        (0, _toolManagerDefault.default),
        (0, _mouseDefault.default)
    ],
    __init__: [
        'lassoTool'
    ],
    lassoTool: [
        'type',
        (0, _lassoToolDefault.default)
    ]
};

},{"../tool-manager":"i6JA7","../mouse":"ajwMh","./LassoTool":"5J8YS","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5J8YS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>LassoTool);
var _minDash = require("min-dash");
var _elements = require("../../util/Elements");
var _mouse = require("../../util/Mouse");
var _tinySvg = require("tiny-svg");
/**
 * @typedef {import('../../core/Canvas').default} Canvas
 * @typedef {import('../dragging/Dragging').default} Dragging
 * @typedef {import('../../core/ElementRegistry').default} ElementRegistry
 * @typedef {import('../../core/EventBus').default} EventBus
 * @typedef {import('../mouse/Mouse').default} Mouse
 * @typedef {import('../selection/Selection').default} Selection
 * @typedef {import('../tool-manager/ToolManager').default} ToolManager
 */ var LASSO_TOOL_CURSOR = 'crosshair';
function LassoTool(eventBus, canvas, dragging, elementRegistry, selection, toolManager, mouse) {
    this._selection = selection;
    this._dragging = dragging;
    this._mouse = mouse;
    var self = this;
    // lasso visuals implementation
    /**
  * A helper that realizes the selection box visual
  */ var visuals = {
        create: function(context) {
            var container = canvas.getActiveLayer(), frame;
            frame = context.frame = (0, _tinySvg.create)('rect');
            (0, _tinySvg.attr)(frame, {
                class: 'djs-lasso-overlay',
                width: 1,
                height: 1,
                x: 0,
                y: 0
            });
            (0, _tinySvg.append)(container, frame);
        },
        update: function(context) {
            var frame = context.frame, bbox = context.bbox;
            (0, _tinySvg.attr)(frame, {
                x: bbox.x,
                y: bbox.y,
                width: bbox.width,
                height: bbox.height
            });
        },
        remove: function(context) {
            if (context.frame) (0, _tinySvg.remove)(context.frame);
        }
    };
    toolManager.registerTool('lasso', {
        tool: 'lasso.selection',
        dragging: 'lasso'
    });
    eventBus.on('lasso.selection.end', function(event) {
        var target = event.originalEvent.target;
        // only reactive on diagram click
        // on some occasions, event.hover is not set and we have to check if the target is an svg
        if (!event.hover && !(target instanceof SVGElement)) return;
        eventBus.once('lasso.selection.ended', function() {
            self.activateLasso(event.originalEvent, true);
        });
    });
    // lasso interaction implementation
    eventBus.on('lasso.end', function(event) {
        var bbox = toBBox(event);
        var elements = elementRegistry.filter(function(element) {
            return element;
        });
        self.select(elements, bbox);
    });
    eventBus.on('lasso.start', function(event) {
        var context = event.context;
        context.bbox = toBBox(event);
        visuals.create(context);
    });
    eventBus.on('lasso.move', function(event) {
        var context = event.context;
        context.bbox = toBBox(event);
        visuals.update(context);
    });
    eventBus.on('lasso.cleanup', function(event) {
        var context = event.context;
        visuals.remove(context);
    });
    // event integration
    eventBus.on('element.mousedown', 1500, function(event) {
        if (!(0, _mouse.hasSecondaryModifier)(event)) return;
        self.activateLasso(event.originalEvent);
        // we've handled the event
        return true;
    });
}
LassoTool.$inject = [
    'eventBus',
    'canvas',
    'dragging',
    'elementRegistry',
    'selection',
    'toolManager',
    'mouse'
];
LassoTool.prototype.activateLasso = function(event, autoActivate) {
    this._dragging.init(event, 'lasso', {
        autoActivate: autoActivate,
        cursor: LASSO_TOOL_CURSOR,
        data: {
            context: {}
        }
    });
};
LassoTool.prototype.activateSelection = function(event, autoActivate) {
    this._dragging.init(event, 'lasso.selection', {
        trapClick: false,
        autoActivate: autoActivate,
        cursor: LASSO_TOOL_CURSOR,
        data: {
            context: {}
        }
    });
};
LassoTool.prototype.select = function(elements, bbox) {
    var selectedElements = (0, _elements.getEnclosedElements)(elements, bbox);
    this._selection.select((0, _minDash.values)(selectedElements));
};
LassoTool.prototype.toggle = function() {
    if (this.isActive()) return this._dragging.cancel();
    var mouseEvent = this._mouse.getLastMoveEvent();
    this.activateSelection(mouseEvent, !!mouseEvent);
};
LassoTool.prototype.isActive = function() {
    var context = this._dragging.context();
    return context && /^lasso/.test(context.prefix);
};
function toBBox(event) {
    var start = {
        x: event.x - event.dx,
        y: event.y - event.dy
    };
    var end = {
        x: event.x,
        y: event.y
    };
    var bbox;
    if (start.x <= end.x && start.y < end.y || start.x < end.x && start.y <= end.y) bbox = {
        x: start.x,
        y: start.y,
        width: end.x - start.x,
        height: end.y - start.y
    };
    else if (start.x >= end.x && start.y < end.y || start.x > end.x && start.y <= end.y) bbox = {
        x: end.x,
        y: start.y,
        width: start.x - end.x,
        height: end.y - start.y
    };
    else if (start.x <= end.x && start.y > end.y || start.x < end.x && start.y >= end.y) bbox = {
        x: start.x,
        y: end.y,
        width: end.x - start.x,
        height: start.y - end.y
    };
    else if (start.x >= end.x && start.y > end.y || start.x > end.x && start.y >= end.y) bbox = {
        x: end.x,
        y: end.y,
        width: start.x - end.x,
        height: start.y - end.y
    };
    else bbox = {
        x: end.x,
        y: end.y,
        width: 0,
        height: 0
    };
    return bbox;
}

},{"min-dash":"aEEla","../../util/Elements":"6qdtl","../../util/Mouse":"9MyMy","tiny-svg":"6ZtXA","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"OPcPX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _toolManager = require("../tool-manager");
var _toolManagerDefault = parcelHelpers.interopDefault(_toolManager);
var _mouse = require("../mouse");
var _mouseDefault = parcelHelpers.interopDefault(_mouse);
var _handTool = require("./HandTool");
var _handToolDefault = parcelHelpers.interopDefault(_handTool);
exports.default = {
    __depends__: [
        (0, _toolManagerDefault.default),
        (0, _mouseDefault.default)
    ],
    __init__: [
        'handTool'
    ],
    handTool: [
        'type',
        (0, _handToolDefault.default)
    ]
};

},{"../tool-manager":"i6JA7","../mouse":"ajwMh","./HandTool":"bOlVg","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bOlVg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>HandTool);
var _mouse = require("../../util/Mouse");
var _keyboardUtil = require("../../features/keyboard/KeyboardUtil");
/**
 * @typedef {import('didi').Injector} Injector
 *
 * @typedef {import('../../core/Canvas').default} Canvas
 * @typedef {import('../dragging/Dragging').default} Dragging
 * @typedef {import('../../core/EventBus').default} EventBus
 * @typedef {import('../mouse/Mouse').default} Mouse
 * @typedef {import('../tool-manager/ToolManager').default} ToolManager
 */ var HIGH_PRIORITY = 1500;
var HAND_CURSOR = 'grab';
function HandTool(eventBus, canvas, dragging, injector, toolManager, mouse) {
    this._dragging = dragging;
    this._mouse = mouse;
    var self = this, keyboard = injector.get('keyboard', false);
    toolManager.registerTool('hand', {
        tool: 'hand',
        dragging: 'hand.move'
    });
    eventBus.on('element.mousedown', HIGH_PRIORITY, function(event) {
        if (!(0, _mouse.hasPrimaryModifier)(event)) return;
        self.activateMove(event.originalEvent, true);
        return false;
    });
    keyboard && keyboard.addListener(HIGH_PRIORITY, function(e) {
        if (!isSpace(e.keyEvent) || self.isActive()) return;
        var mouseEvent = self._mouse.getLastMoveEvent();
        self.activateMove(mouseEvent, !!mouseEvent);
    }, 'keyboard.keydown');
    keyboard && keyboard.addListener(HIGH_PRIORITY, function(e) {
        if (!isSpace(e.keyEvent) || !self.isActive()) return;
        self.toggle();
    }, 'keyboard.keyup');
    eventBus.on('hand.end', function(event) {
        var target = event.originalEvent.target;
        // only reactive on diagram click
        // on some occasions, event.hover is not set and we have to check if the target is an svg
        if (!event.hover && !(target instanceof SVGElement)) return false;
        eventBus.once('hand.ended', function() {
            self.activateMove(event.originalEvent, {
                reactivate: true
            });
        });
    });
    eventBus.on('hand.move.move', function(event) {
        var scale = canvas.viewbox().scale;
        canvas.scroll({
            dx: event.dx * scale,
            dy: event.dy * scale
        });
    });
    eventBus.on('hand.move.end', function(event) {
        var context = event.context, reactivate = context.reactivate;
        // Don't reactivate if the user is using the keyboard keybinding
        if (!(0, _mouse.hasPrimaryModifier)(event) && reactivate) eventBus.once('hand.move.ended', function(event) {
            self.activateHand(event.originalEvent, true, true);
        });
        return false;
    });
}
HandTool.$inject = [
    'eventBus',
    'canvas',
    'dragging',
    'injector',
    'toolManager',
    'mouse'
];
HandTool.prototype.activateMove = function(event, autoActivate, context) {
    if (typeof autoActivate === 'object') {
        context = autoActivate;
        autoActivate = false;
    }
    this._dragging.init(event, 'hand.move', {
        autoActivate: autoActivate,
        cursor: HAND_CURSOR,
        data: {
            context: context || {}
        }
    });
};
HandTool.prototype.activateHand = function(event, autoActivate, reactivate) {
    this._dragging.init(event, 'hand', {
        trapClick: false,
        autoActivate: autoActivate,
        cursor: HAND_CURSOR,
        data: {
            context: {
                reactivate: reactivate
            }
        }
    });
};
HandTool.prototype.toggle = function() {
    if (this.isActive()) return this._dragging.cancel();
    var mouseEvent = this._mouse.getLastMoveEvent();
    this.activateHand(mouseEvent, !!mouseEvent);
};
HandTool.prototype.isActive = function() {
    var context = this._dragging.context();
    if (context) return /^(hand|hand\.move)$/.test(context.prefix);
    return false;
};
// helpers //////////
function isSpace(keyEvent) {
    return (0, _keyboardUtil.isKey)('Space', keyEvent);
}

},{"../../util/Mouse":"9MyMy","../../features/keyboard/KeyboardUtil":"2Asg4","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"euMEP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _connect = require("../connect");
var _connectDefault = parcelHelpers.interopDefault(_connect);
var _rules = require("../rules");
var _rulesDefault = parcelHelpers.interopDefault(_rules);
var _dragging = require("../dragging");
var _draggingDefault = parcelHelpers.interopDefault(_dragging);
var _toolManager = require("../tool-manager");
var _toolManagerDefault = parcelHelpers.interopDefault(_toolManager);
var _mouse = require("../mouse");
var _mouseDefault = parcelHelpers.interopDefault(_mouse);
var _globalConnect = require("./GlobalConnect");
var _globalConnectDefault = parcelHelpers.interopDefault(_globalConnect);
exports.default = {
    __depends__: [
        (0, _connectDefault.default),
        (0, _rulesDefault.default),
        (0, _draggingDefault.default),
        (0, _toolManagerDefault.default),
        (0, _mouseDefault.default)
    ],
    globalConnect: [
        'type',
        (0, _globalConnectDefault.default)
    ]
};

},{"../connect":"jmgwG","../rules":"5xj5a","../dragging":"2U3QS","../tool-manager":"i6JA7","../mouse":"ajwMh","./GlobalConnect":"3Olad","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3Olad":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>GlobalConnect);
var MARKER_OK = 'connect-ok', MARKER_NOT_OK = 'connect-not-ok';
function GlobalConnect(eventBus, dragging, connect, canvas, toolManager, rules, mouse) {
    var self = this;
    this._dragging = dragging;
    this._rules = rules;
    this._mouse = mouse;
    toolManager.registerTool('global-connect', {
        tool: 'global-connect',
        dragging: 'global-connect.drag'
    });
    eventBus.on('global-connect.hover', function(event) {
        var context = event.context, startTarget = event.hover;
        var canStartConnect = context.canStartConnect = self.canStartConnect(startTarget);
        // simply ignore hover
        if (canStartConnect === null) return;
        context.startTarget = startTarget;
        canvas.addMarker(startTarget, canStartConnect ? MARKER_OK : MARKER_NOT_OK);
    });
    eventBus.on([
        'global-connect.out',
        'global-connect.cleanup'
    ], function(event) {
        var startTarget = event.context.startTarget, canStartConnect = event.context.canStartConnect;
        if (startTarget) canvas.removeMarker(startTarget, canStartConnect ? MARKER_OK : MARKER_NOT_OK);
    });
    eventBus.on([
        'global-connect.ended'
    ], function(event) {
        var context = event.context, startTarget = context.startTarget, startPosition = {
            x: event.x,
            y: event.y
        };
        var canStartConnect = self.canStartConnect(startTarget);
        if (!canStartConnect) return;
        eventBus.once('element.out', function() {
            eventBus.once([
                'connect.ended',
                'connect.canceled'
            ], function() {
                eventBus.fire('global-connect.drag.ended');
            });
            connect.start(null, startTarget, startPosition);
        });
        return false;
    });
}
GlobalConnect.$inject = [
    'eventBus',
    'dragging',
    'connect',
    'canvas',
    'toolManager',
    'rules',
    'mouse'
];
/**
 * Initiates tool activity.
 */ GlobalConnect.prototype.start = function(event, autoActivate) {
    this._dragging.init(event, 'global-connect', {
        autoActivate: autoActivate,
        trapClick: false,
        data: {
            context: {}
        }
    });
};
GlobalConnect.prototype.toggle = function() {
    if (this.isActive()) return this._dragging.cancel();
    var mouseEvent = this._mouse.getLastMoveEvent();
    return this.start(mouseEvent, !!mouseEvent);
};
GlobalConnect.prototype.isActive = function() {
    var context = this._dragging.context();
    return context && /^global-connect/.test(context.prefix);
};
/**
 * Check if source shape can initiate connection.
 *
 * @param {Shape} startTarget
 * @return {boolean}
 */ GlobalConnect.prototype.canStartConnect = function(startTarget) {
    return this._rules.allowed('connection.start', {
        source: startTarget
    });
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ffzhx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PaletteProvider);
var _minDash = require("min-dash");
var _modelUtil = require("../../util/ModelUtil");
function PaletteProvider(palette, create, elementFactory, spaceTool, lassoTool, handTool, globalConnect, translate) {
    this._palette = palette;
    this._create = create;
    this._elementFactory = elementFactory;
    this._spaceTool = spaceTool;
    this._lassoTool = lassoTool;
    this._handTool = handTool;
    this._globalConnect = globalConnect;
    this._translate = translate;
    palette.registerProvider(this);
}
PaletteProvider.$inject = [
    'palette',
    'create',
    'elementFactory',
    'spaceTool',
    'lassoTool',
    'handTool',
    'globalConnect',
    'translate'
];
PaletteProvider.prototype.getPaletteEntries = function(element) {
    var actions = {}, create = this._create, elementFactory = this._elementFactory, spaceTool = this._spaceTool, lassoTool = this._lassoTool, handTool = this._handTool, globalConnect = this._globalConnect, translate = this._translate;
    function createAction(type, group, className, title, options) {
        function createListener(event) {
            var shape = elementFactory.createShape((0, _minDash.assign)({
                type: type
            }, options));
            if (options) {
                var di = (0, _modelUtil.getDi)(shape);
                di.isExpanded = options.isExpanded;
            }
            create.start(event, shape);
        }
        var shortType = type.replace(/^bpmn:/, '');
        return {
            group: group,
            className: className,
            title: title || translate('Create {type}', {
                type: shortType
            }),
            action: {
                dragstart: createListener,
                click: createListener
            }
        };
    }
    function createSubprocess(event) {
        var subProcess = elementFactory.createShape({
            type: 'bpmn:SubProcess',
            x: 0,
            y: 0,
            isExpanded: true
        });
        var startEvent = elementFactory.createShape({
            type: 'bpmn:StartEvent',
            x: 40,
            y: 82,
            parent: subProcess
        });
        create.start(event, [
            subProcess,
            startEvent
        ], {
            hints: {
                autoSelect: [
                    subProcess
                ]
            }
        });
    }
    function createParticipant(event) {
        create.start(event, elementFactory.createParticipantShape());
    }
    (0, _minDash.assign)(actions, {
        'hand-tool': {
            group: 'tools',
            className: 'bpmn-icon-hand-tool',
            title: translate('Activate the hand tool'),
            action: {
                click: function(event) {
                    handTool.activateHand(event);
                }
            }
        },
        'lasso-tool': {
            group: 'tools',
            className: 'bpmn-icon-lasso-tool',
            title: translate('Activate the lasso tool'),
            action: {
                click: function(event) {
                    lassoTool.activateSelection(event);
                }
            }
        },
        'space-tool': {
            group: 'tools',
            className: 'bpmn-icon-space-tool',
            title: translate('Activate the create/remove space tool'),
            action: {
                click: function(event) {
                    spaceTool.activateSelection(event);
                }
            }
        },
        'global-connect-tool': {
            group: 'tools',
            className: 'bpmn-icon-connection-multi',
            title: translate('Activate the global connect tool'),
            action: {
                click: function(event) {
                    globalConnect.start(event);
                }
            }
        },
        'tool-separator': {
            group: 'tools',
            separator: true
        },
        'create.start-event': createAction('bpmn:StartEvent', 'event', 'bpmn-icon-start-event-none', translate('Create StartEvent')),
        'create.intermediate-event': createAction('bpmn:IntermediateThrowEvent', 'event', 'bpmn-icon-intermediate-event-none', translate('Create Intermediate/Boundary Event')),
        'create.end-event': createAction('bpmn:EndEvent', 'event', 'bpmn-icon-end-event-none', translate('Create EndEvent')),
        'create.exclusive-gateway': createAction('bpmn:ExclusiveGateway', 'gateway', 'bpmn-icon-gateway-none', translate('Create Gateway')),
        'create.task': createAction('bpmn:Task', 'activity', 'bpmn-icon-task', translate('Create Task')),
        'create.data-object': createAction('bpmn:DataObjectReference', 'data-object', 'bpmn-icon-data-object', translate('Create DataObjectReference')),
        'create.data-store': createAction('bpmn:DataStoreReference', 'data-store', 'bpmn-icon-data-store', translate('Create DataStoreReference')),
        'create.subprocess-expanded': {
            group: 'activity',
            className: 'bpmn-icon-subprocess-expanded',
            title: translate('Create expanded SubProcess'),
            action: {
                dragstart: createSubprocess,
                click: createSubprocess
            }
        },
        'create.participant-expanded': {
            group: 'collaboration',
            className: 'bpmn-icon-participant',
            title: translate('Create Pool/Participant'),
            action: {
                dragstart: createParticipant,
                click: createParticipant
            }
        },
        'create.group': createAction('bpmn:Group', 'artifact', 'bpmn-icon-group', translate('Create Group'))
    });
    return actions;
};

},{"min-dash":"aEEla","../../util/ModelUtil":"klNYN","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fVkpb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _previewSupport = require("diagram-js/lib/features/preview-support");
var _previewSupportDefault = parcelHelpers.interopDefault(_previewSupport);
var _bpmnReplacePreview = require("./BpmnReplacePreview");
var _bpmnReplacePreviewDefault = parcelHelpers.interopDefault(_bpmnReplacePreview);
exports.default = {
    __depends__: [
        (0, _previewSupportDefault.default)
    ],
    __init__: [
        'bpmnReplacePreview'
    ],
    bpmnReplacePreview: [
        'type',
        (0, _bpmnReplacePreviewDefault.default)
    ]
};

},{"diagram-js/lib/features/preview-support":"fEfos","./BpmnReplacePreview":"18kIm","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"18kIm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BpmnReplacePreview);
var _commandInterceptor = require("diagram-js/lib/command/CommandInterceptor");
var _commandInterceptorDefault = parcelHelpers.interopDefault(_commandInterceptor);
var _inheritsBrowser = require("inherits-browser");
var _inheritsBrowserDefault = parcelHelpers.interopDefault(_inheritsBrowser);
var _escapeUtil = require("diagram-js/lib/util/EscapeUtil");
var _minDash = require("min-dash");
var _minDom = require("min-dom");
var _tinySvg = require("tiny-svg");
var LOW_PRIORITY = 250;
function BpmnReplacePreview(eventBus, elementRegistry, elementFactory, canvas, previewSupport) {
    (0, _commandInterceptorDefault.default).call(this, eventBus);
    /**
   * Replace the visuals of all elements in the context which can be replaced
   *
   * @param  {Object} context
   */ function replaceVisual(context) {
        var replacements = context.canExecute.replacements;
        (0, _minDash.forEach)(replacements, function(replacement) {
            var id = replacement.oldElementId;
            var newElement = {
                type: replacement.newElementType
            };
            // if the visual of the element is already replaced
            if (context.visualReplacements[id]) return;
            var element = elementRegistry.get(id);
            (0, _minDash.assign)(newElement, {
                x: element.x,
                y: element.y
            });
            // create a temporary shape
            var tempShape = elementFactory.createShape(newElement);
            canvas.addShape(tempShape, element.parent);
            // select the original SVG element related to the element and hide it
            var gfx = (0, _minDom.query)('[data-element-id="' + (0, _escapeUtil.escapeCSS)(element.id) + '"]', context.dragGroup);
            if (gfx) (0, _tinySvg.attr)(gfx, {
                display: 'none'
            });
            // clone the gfx of the temporary shape and add it to the drag group
            var dragger = previewSupport.addDragger(tempShape, context.dragGroup);
            context.visualReplacements[id] = dragger;
            canvas.removeShape(tempShape);
        });
    }
    /**
   * Restore the original visuals of the previously replaced elements
   *
   * @param  {Object} context
   */ function restoreVisual(context) {
        var visualReplacements = context.visualReplacements;
        (0, _minDash.forEach)(visualReplacements, function(dragger, id) {
            var originalGfx = (0, _minDom.query)('[data-element-id="' + (0, _escapeUtil.escapeCSS)(id) + '"]', context.dragGroup);
            if (originalGfx) (0, _tinySvg.attr)(originalGfx, {
                display: 'inline'
            });
            dragger.remove();
            if (visualReplacements[id]) delete visualReplacements[id];
        });
    }
    eventBus.on('shape.move.move', LOW_PRIORITY, function(event) {
        var context = event.context, canExecute = context.canExecute;
        if (!context.visualReplacements) context.visualReplacements = {};
        if (canExecute && canExecute.replacements) replaceVisual(context);
        else restoreVisual(context);
    });
}
BpmnReplacePreview.$inject = [
    'eventBus',
    'elementRegistry',
    'elementFactory',
    'canvas',
    'previewSupport'
];
(0, _inheritsBrowserDefault.default)(BpmnReplacePreview, (0, _commandInterceptorDefault.default));

},{"diagram-js/lib/command/CommandInterceptor":"1K1IQ","inherits-browser":"hymxq","diagram-js/lib/util/EscapeUtil":"kAkPb","min-dash":"aEEla","min-dom":"e58GC","tiny-svg":"6ZtXA","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ffgrx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _bpmnConnectSnapping = require("./BpmnConnectSnapping");
var _bpmnConnectSnappingDefault = parcelHelpers.interopDefault(_bpmnConnectSnapping);
var _bpmnCreateMoveSnapping = require("./BpmnCreateMoveSnapping");
var _bpmnCreateMoveSnappingDefault = parcelHelpers.interopDefault(_bpmnCreateMoveSnapping);
var _snapping = require("diagram-js/lib/features/snapping");
var _snappingDefault = parcelHelpers.interopDefault(_snapping);
exports.default = {
    __depends__: [
        (0, _snappingDefault.default)
    ],
    __init__: [
        'connectSnapping',
        'createMoveSnapping'
    ],
    connectSnapping: [
        'type',
        (0, _bpmnConnectSnappingDefault.default)
    ],
    createMoveSnapping: [
        'type',
        (0, _bpmnCreateMoveSnappingDefault.default)
    ]
};

},{"./BpmnConnectSnapping":"7eqhu","./BpmnCreateMoveSnapping":"j6AEU","diagram-js/lib/features/snapping":"i8lgi","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7eqhu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BpmnConnectSnapping);
var _snapUtil = require("diagram-js/lib/features/snapping/SnapUtil");
var _keyboardUtil = require("diagram-js/lib/features/keyboard/KeyboardUtil");
var _layoutUtil = require("diagram-js/lib/layout/LayoutUtil");
var _modelUtil = require("../../util/ModelUtil");
var _modelingUtil = require("../modeling/util/ModelingUtil");
var _minDash = require("min-dash");
var HIGHER_PRIORITY = 1250;
var BOUNDARY_TO_HOST_THRESHOLD = 40;
var TARGET_BOUNDS_PADDING = 20, TASK_BOUNDS_PADDING = 10;
var TARGET_CENTER_PADDING = 20;
var AXES = [
    'x',
    'y'
];
var abs = Math.abs;
function BpmnConnectSnapping(eventBus) {
    eventBus.on([
        'connect.hover',
        'connect.move',
        'connect.end'
    ], HIGHER_PRIORITY, function(event) {
        var context = event.context, canExecute = context.canExecute, start = context.start, hover = context.hover, source = context.source, target = context.target;
        // do NOT snap on CMD
        if (event.originalEvent && (0, _keyboardUtil.isCmd)(event.originalEvent)) return;
        if (!context.initialConnectionStart) context.initialConnectionStart = context.connectionStart;
        // snap hover
        if (canExecute && hover) snapToShape(event, hover, getTargetBoundsPadding(hover));
        if (hover && isAnyType(canExecute, [
            'bpmn:Association',
            'bpmn:DataInputAssociation',
            'bpmn:DataOutputAssociation',
            'bpmn:SequenceFlow'
        ])) {
            context.connectionStart = (0, _snapUtil.mid)(start);
            // snap hover
            if ((0, _modelingUtil.isAny)(hover, [
                'bpmn:Event',
                'bpmn:Gateway'
            ])) snapToPosition(event, (0, _snapUtil.mid)(hover));
            // snap hover
            if ((0, _modelingUtil.isAny)(hover, [
                'bpmn:Task',
                'bpmn:SubProcess'
            ])) snapToTargetMid(event, hover);
            // snap source and target
            if ((0, _modelUtil.is)(source, 'bpmn:BoundaryEvent') && target === source.host) snapBoundaryEventLoop(event);
        } else if (isType(canExecute, 'bpmn:MessageFlow')) {
            if ((0, _modelUtil.is)(start, 'bpmn:Event')) // snap start
            context.connectionStart = (0, _snapUtil.mid)(start);
            if ((0, _modelUtil.is)(hover, 'bpmn:Event')) // snap hover
            snapToPosition(event, (0, _snapUtil.mid)(hover));
        } else // un-snap source
        context.connectionStart = context.initialConnectionStart;
    });
}
BpmnConnectSnapping.$inject = [
    'eventBus'
];
// helpers //////////
// snap to target if event in target
function snapToShape(event, target, padding) {
    AXES.forEach(function(axis) {
        var dimensionForAxis = getDimensionForAxis(axis, target);
        if (event[axis] < target[axis] + padding) (0, _snapUtil.setSnapped)(event, axis, target[axis] + padding);
        else if (event[axis] > target[axis] + dimensionForAxis - padding) (0, _snapUtil.setSnapped)(event, axis, target[axis] + dimensionForAxis - padding);
    });
}
// snap to target mid if event in target mid
function snapToTargetMid(event, target) {
    var targetMid = (0, _snapUtil.mid)(target);
    AXES.forEach(function(axis) {
        if (isMid(event, target, axis)) (0, _snapUtil.setSnapped)(event, axis, targetMid[axis]);
    });
}
// snap to prevent loop overlapping boundary event
function snapBoundaryEventLoop(event) {
    var context = event.context, source = context.source, target = context.target;
    if (isReverse(context)) return;
    var sourceMid = (0, _snapUtil.mid)(source), orientation = (0, _layoutUtil.getOrientation)(sourceMid, target, -10), axes = [];
    if (/top|bottom/.test(orientation)) axes.push('x');
    if (/left|right/.test(orientation)) axes.push('y');
    axes.forEach(function(axis) {
        var coordinate = event[axis], newCoordinate;
        if (abs(coordinate - sourceMid[axis]) < BOUNDARY_TO_HOST_THRESHOLD) {
            if (coordinate > sourceMid[axis]) newCoordinate = sourceMid[axis] + BOUNDARY_TO_HOST_THRESHOLD;
            else newCoordinate = sourceMid[axis] - BOUNDARY_TO_HOST_THRESHOLD;
            (0, _snapUtil.setSnapped)(event, axis, newCoordinate);
        }
    });
}
function snapToPosition(event, position) {
    (0, _snapUtil.setSnapped)(event, 'x', position.x);
    (0, _snapUtil.setSnapped)(event, 'y', position.y);
}
function isType(attrs, type) {
    return attrs && attrs.type === type;
}
function isAnyType(attrs, types) {
    return (0, _minDash.some)(types, function(type) {
        return isType(attrs, type);
    });
}
function getDimensionForAxis(axis, element) {
    return axis === 'x' ? element.width : element.height;
}
function getTargetBoundsPadding(target) {
    if ((0, _modelUtil.is)(target, 'bpmn:Task')) return TASK_BOUNDS_PADDING;
    else return TARGET_BOUNDS_PADDING;
}
function isMid(event, target, axis) {
    return event[axis] > target[axis] + TARGET_CENTER_PADDING && event[axis] < target[axis] + getDimensionForAxis(axis, target) - TARGET_CENTER_PADDING;
}
function isReverse(context) {
    var hover = context.hover, source = context.source;
    return hover && source && hover === source;
}

},{"diagram-js/lib/features/snapping/SnapUtil":"fu3Zv","diagram-js/lib/features/keyboard/KeyboardUtil":"2Asg4","diagram-js/lib/layout/LayoutUtil":"4CCrs","../../util/ModelUtil":"klNYN","../modeling/util/ModelingUtil":"4DR1e","min-dash":"aEEla","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"j6AEU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BpmnCreateMoveSnapping);
var _inheritsBrowser = require("inherits-browser");
var _inheritsBrowserDefault = parcelHelpers.interopDefault(_inheritsBrowser);
var _createMoveSnapping = require("diagram-js/lib/features/snapping/CreateMoveSnapping");
var _createMoveSnappingDefault = parcelHelpers.interopDefault(_createMoveSnapping);
var _snapUtil = require("diagram-js/lib/features/snapping/SnapUtil");
var _diUtil = require("../../util/DiUtil");
var _modelUtil = require("../../util/ModelUtil");
var _layoutUtil = require("diagram-js/lib/layout/LayoutUtil");
var _bpmnSnappingUtil = require("./BpmnSnappingUtil");
var _minDash = require("min-dash");
var HIGH_PRIORITY = 1500;
function BpmnCreateMoveSnapping(eventBus, injector) {
    injector.invoke((0, _createMoveSnappingDefault.default), this);
    // creating first participant
    eventBus.on([
        'create.move',
        'create.end'
    ], HIGH_PRIORITY, setSnappedIfConstrained);
    // snap boundary events
    eventBus.on([
        'create.move',
        'create.end',
        'shape.move.move',
        'shape.move.end'
    ], HIGH_PRIORITY, function(event) {
        var context = event.context, canExecute = context.canExecute, target = context.target;
        var canAttach = canExecute && (canExecute === 'attach' || canExecute.attach);
        if (canAttach && !(0, _snapUtil.isSnapped)(event)) snapBoundaryEvent(event, target);
    });
}
(0, _inheritsBrowserDefault.default)(BpmnCreateMoveSnapping, (0, _createMoveSnappingDefault.default));
BpmnCreateMoveSnapping.$inject = [
    'eventBus',
    'injector'
];
BpmnCreateMoveSnapping.prototype.initSnap = function(event) {
    var snapContext = (0, _createMoveSnappingDefault.default).prototype.initSnap.call(this, event);
    var shape = event.shape;
    var isMove = !!this._elementRegistry.get(shape.id);
    // snap to docking points
    (0, _minDash.forEach)(shape.outgoing, function(connection) {
        var docking = connection.waypoints[0];
        docking = docking.original || docking;
        snapContext.setSnapOrigin(connection.id + '-docking', getDockingSnapOrigin(docking, isMove, event));
    });
    (0, _minDash.forEach)(shape.incoming, function(connection) {
        var docking = connection.waypoints[connection.waypoints.length - 1];
        docking = docking.original || docking;
        snapContext.setSnapOrigin(connection.id + '-docking', getDockingSnapOrigin(docking, isMove, event));
    });
    if ((0, _modelUtil.is)(shape, 'bpmn:Participant')) // snap to borders with higher priority
    snapContext.setSnapLocations([
        'top-left',
        'bottom-right',
        'mid'
    ]);
    return snapContext;
};
BpmnCreateMoveSnapping.prototype.addSnapTargetPoints = function(snapPoints, shape, target) {
    (0, _createMoveSnappingDefault.default).prototype.addSnapTargetPoints.call(this, snapPoints, shape, target);
    var snapTargets = this.getSnapTargets(shape, target);
    (0, _minDash.forEach)(snapTargets, function(snapTarget) {
        // handle TRBL alignment
        //
        // * with container elements
        // * with text annotations
        if (isContainer(snapTarget) || areAll([
            shape,
            snapTarget
        ], 'bpmn:TextAnnotation')) {
            snapPoints.add('top-left', (0, _snapUtil.topLeft)(snapTarget));
            snapPoints.add('bottom-right', (0, _snapUtil.bottomRight)(snapTarget));
        }
    });
    var elementRegistry = this._elementRegistry;
    // snap to docking points if not create mode
    (0, _minDash.forEach)(shape.incoming, function(connection) {
        if (elementRegistry.get(shape.id)) {
            if (!includes(snapTargets, connection.source)) snapPoints.add('mid', (0, _layoutUtil.getMid)(connection.source));
            var docking = connection.waypoints[0];
            snapPoints.add(connection.id + '-docking', docking.original || docking);
        }
    });
    (0, _minDash.forEach)(shape.outgoing, function(connection) {
        if (elementRegistry.get(shape.id)) {
            if (!includes(snapTargets, connection.target)) snapPoints.add('mid', (0, _layoutUtil.getMid)(connection.target));
            var docking = connection.waypoints[connection.waypoints.length - 1];
            snapPoints.add(connection.id + '-docking', docking.original || docking);
        }
    });
    // add sequence flow parents as snap targets
    if ((0, _modelUtil.is)(target, 'bpmn:SequenceFlow')) snapPoints = this.addSnapTargetPoints(snapPoints, shape, target.parent);
    return snapPoints;
};
BpmnCreateMoveSnapping.prototype.getSnapTargets = function(shape, target) {
    return (0, _createMoveSnappingDefault.default).prototype.getSnapTargets.call(this, shape, target).filter(function(snapTarget) {
        // do not snap to lanes
        return !(0, _modelUtil.is)(snapTarget, 'bpmn:Lane');
    });
};
// helpers //////////
function snapBoundaryEvent(event, target) {
    var targetTRBL = (0, _layoutUtil.asTRBL)(target);
    var direction = (0, _bpmnSnappingUtil.getBoundaryAttachment)(event, target);
    var context = event.context, shape = context.shape;
    var offset;
    if (shape.parent) offset = {
        x: 0,
        y: 0
    };
    else offset = (0, _layoutUtil.getMid)(shape);
    if (/top/.test(direction)) (0, _snapUtil.setSnapped)(event, 'y', targetTRBL.top - offset.y);
    else if (/bottom/.test(direction)) (0, _snapUtil.setSnapped)(event, 'y', targetTRBL.bottom - offset.y);
    if (/left/.test(direction)) (0, _snapUtil.setSnapped)(event, 'x', targetTRBL.left - offset.x);
    else if (/right/.test(direction)) (0, _snapUtil.setSnapped)(event, 'x', targetTRBL.right - offset.x);
}
function areAll(elements, type) {
    return elements.every(function(el) {
        return (0, _modelUtil.is)(el, type);
    });
}
function isContainer(element) {
    if ((0, _modelUtil.is)(element, 'bpmn:SubProcess') && (0, _diUtil.isExpanded)(element)) return true;
    return (0, _modelUtil.is)(element, 'bpmn:Participant');
}
function setSnappedIfConstrained(event) {
    var context = event.context, createConstraints = context.createConstraints;
    if (!createConstraints) return;
    var top = createConstraints.top, right = createConstraints.right, bottom = createConstraints.bottom, left = createConstraints.left;
    if (left && left >= event.x || right && right <= event.x) (0, _snapUtil.setSnapped)(event, 'x', event.x);
    if (top && top >= event.y || bottom && bottom <= event.y) (0, _snapUtil.setSnapped)(event, 'y', event.y);
}
function includes(array, value) {
    return array.indexOf(value) !== -1;
}
function getDockingSnapOrigin(docking, isMove, event) {
    return isMove ? {
        x: docking.x - event.x,
        y: docking.y - event.y
    } : {
        x: docking.x,
        y: docking.y
    };
}

},{"inherits-browser":"hymxq","diagram-js/lib/features/snapping/CreateMoveSnapping":"5F922","diagram-js/lib/features/snapping/SnapUtil":"fu3Zv","../../util/DiUtil":"krDFz","../../util/ModelUtil":"klNYN","diagram-js/lib/layout/LayoutUtil":"4CCrs","./BpmnSnappingUtil":"hDtSZ","min-dash":"aEEla","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5F922":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CreateMoveSnapping);
var _snapContext = require("./SnapContext");
var _snapContextDefault = parcelHelpers.interopDefault(_snapContext);
var _snapUtil = require("./SnapUtil");
var _keyboardUtil = require("../keyboard/KeyboardUtil");
var _minDash = require("min-dash");
/**
 * @typedef {import('../../core/ElementRegistry').default} ElementRegistry
 * @typedef {import('../../core/EventBus').default} EventBus
 * @typedef {import('./Snapping').default} Snapping
 */ var HIGHER_PRIORITY = 1250;
function CreateMoveSnapping(elementRegistry, eventBus, snapping) {
    var self = this;
    this._elementRegistry = elementRegistry;
    eventBus.on([
        'create.start',
        'shape.move.start'
    ], function(event) {
        self.initSnap(event);
    });
    eventBus.on([
        'create.move',
        'create.end',
        'shape.move.move',
        'shape.move.end'
    ], HIGHER_PRIORITY, function(event) {
        var context = event.context, shape = context.shape, snapContext = context.snapContext, target = context.target;
        if (event.originalEvent && (0, _keyboardUtil.isCmd)(event.originalEvent)) return;
        if ((0, _snapUtil.isSnapped)(event) || !target) return;
        var snapPoints = snapContext.pointsForTarget(target);
        if (!snapPoints.initialized) {
            snapPoints = self.addSnapTargetPoints(snapPoints, shape, target);
            snapPoints.initialized = true;
        }
        snapping.snap(event, snapPoints);
    });
    eventBus.on([
        'create.cleanup',
        'shape.move.cleanup'
    ], function() {
        snapping.hide();
    });
}
CreateMoveSnapping.$inject = [
    'elementRegistry',
    'eventBus',
    'snapping'
];
CreateMoveSnapping.prototype.initSnap = function(event) {
    var elementRegistry = this._elementRegistry;
    var context = event.context, shape = context.shape, snapContext = context.snapContext;
    if (!snapContext) snapContext = context.snapContext = new (0, _snapContextDefault.default)();
    var shapeMid;
    if (elementRegistry.get(shape.id)) // move
    shapeMid = (0, _snapUtil.mid)(shape, event);
    else // create
    shapeMid = {
        x: event.x + (0, _snapUtil.mid)(shape).x,
        y: event.y + (0, _snapUtil.mid)(shape).y
    };
    var shapeTopLeft = {
        x: shapeMid.x - shape.width / 2,
        y: shapeMid.y - shape.height / 2
    }, shapeBottomRight = {
        x: shapeMid.x + shape.width / 2,
        y: shapeMid.y + shape.height / 2
    };
    snapContext.setSnapOrigin('mid', {
        x: shapeMid.x - event.x,
        y: shapeMid.y - event.y
    });
    // snap labels to mid only
    if (isLabel(shape)) return snapContext;
    snapContext.setSnapOrigin('top-left', {
        x: shapeTopLeft.x - event.x,
        y: shapeTopLeft.y - event.y
    });
    snapContext.setSnapOrigin('bottom-right', {
        x: shapeBottomRight.x - event.x,
        y: shapeBottomRight.y - event.y
    });
    return snapContext;
};
CreateMoveSnapping.prototype.addSnapTargetPoints = function(snapPoints, shape, target) {
    var snapTargets = this.getSnapTargets(shape, target);
    (0, _minDash.forEach)(snapTargets, function(snapTarget) {
        // handle labels
        if (isLabel(snapTarget)) {
            if (isLabel(shape)) snapPoints.add('mid', (0, _snapUtil.mid)(snapTarget));
            return;
        }
        // handle connections
        if (isConnection(snapTarget)) {
            // ignore single segment connections
            if (snapTarget.waypoints.length < 3) return;
            // ignore first and last waypoint
            var waypoints = snapTarget.waypoints.slice(1, -1);
            (0, _minDash.forEach)(waypoints, function(waypoint) {
                snapPoints.add('mid', waypoint);
            });
            return;
        }
        // handle shapes
        snapPoints.add('mid', (0, _snapUtil.mid)(snapTarget));
    });
    if (!(0, _minDash.isNumber)(shape.x) || !(0, _minDash.isNumber)(shape.y)) return snapPoints;
    // snap to original position when moving
    if (this._elementRegistry.get(shape.id)) snapPoints.add('mid', (0, _snapUtil.mid)(shape));
    return snapPoints;
};
CreateMoveSnapping.prototype.getSnapTargets = function(shape, target) {
    return (0, _snapUtil.getChildren)(target).filter(function(child) {
        return !isHidden(child);
    });
};
// helpers //////////
function isConnection(element) {
    return !!element.waypoints;
}
function isHidden(element) {
    return !!element.hidden;
}
function isLabel(element) {
    return !!element.labelTarget;
}

},{"./SnapContext":"cEwCm","./SnapUtil":"fu3Zv","../keyboard/KeyboardUtil":"2Asg4","min-dash":"aEEla","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cEwCm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SnapContext);
/**
 * Creates the snap points and initializes them with the
 * given default values.
 *
 * @param {Object<string, Array<Point>>} [defaultPoints]
 */ parcelHelpers.export(exports, "SnapPoints", ()=>SnapPoints);
var _minDash = require("min-dash");
var _snapUtil = require("./SnapUtil");
function SnapContext() {
    /**
   * Map<String, SnapPoints> mapping drop targets to
   * a list of possible snappings.
   *
   * @type {Object}
   */ this._targets = {};
    /**
   * Map<String, Point> initial positioning of element
   * regarding various snap directions.
   *
   * @type {Object}
   */ this._snapOrigins = {};
    /**
   * List of snap locations
   *
   * @type {Array<string>}
   */ this._snapLocations = [];
    /**
   * Map<String, Array<Point>> of default snapping locations
   *
   * @type {Object}
   */ this._defaultSnaps = {};
}
SnapContext.prototype.getSnapOrigin = function(snapLocation) {
    return this._snapOrigins[snapLocation];
};
SnapContext.prototype.setSnapOrigin = function(snapLocation, initialValue) {
    this._snapOrigins[snapLocation] = initialValue;
    if (this._snapLocations.indexOf(snapLocation) === -1) this._snapLocations.push(snapLocation);
};
SnapContext.prototype.addDefaultSnap = function(type, point) {
    var snapValues = this._defaultSnaps[type];
    if (!snapValues) snapValues = this._defaultSnaps[type] = [];
    snapValues.push(point);
};
/**
 * Return a number of initialized snaps, i.e. snap locations such as
 * top-left, mid, bottom-right and so forth.
 *
 * @return {Array<string>} snapLocations
 */ SnapContext.prototype.getSnapLocations = function() {
    return this._snapLocations;
};
/**
 * Set the snap locations for this context.
 *
 * The order of locations determines precedence.
 *
 * @param {Array<string>} snapLocations
 */ SnapContext.prototype.setSnapLocations = function(snapLocations) {
    this._snapLocations = snapLocations;
};
/**
 * Get snap points for a given target
 *
 * @param {Element|string} target
 */ SnapContext.prototype.pointsForTarget = function(target) {
    var targetId = target.id || target;
    var snapPoints = this._targets[targetId];
    if (!snapPoints) {
        snapPoints = this._targets[targetId] = new SnapPoints();
        snapPoints.initDefaults(this._defaultSnaps);
    }
    return snapPoints;
};
function SnapPoints(defaultSnaps) {
    /**
   * Map<String, Map<(x|y), Array<number>>> mapping snap locations,
   * i.e. top-left, bottom-right, center to actual snap values.
   *
   * @type {Object}
   */ this._snapValues = {};
}
SnapPoints.prototype.add = function(snapLocation, point) {
    var snapValues = this._snapValues[snapLocation];
    if (!snapValues) snapValues = this._snapValues[snapLocation] = {
        x: [],
        y: []
    };
    if (snapValues.x.indexOf(point.x) === -1) snapValues.x.push(point.x);
    if (snapValues.y.indexOf(point.y) === -1) snapValues.y.push(point.y);
};
SnapPoints.prototype.snap = function(point, snapLocation, axis, tolerance) {
    var snappingValues = this._snapValues[snapLocation];
    return snappingValues && (0, _snapUtil.snapTo)(point[axis], snappingValues[axis], tolerance);
};
/**
 * Initialize a number of default snapping points.
 *
 * @param {Object} defaultSnaps
 */ SnapPoints.prototype.initDefaults = function(defaultSnaps) {
    var self = this;
    (0, _minDash.forEach)(defaultSnaps || {}, function(snapPoints, snapLocation) {
        (0, _minDash.forEach)(snapPoints, function(point) {
            self.add(snapLocation, point);
        });
    });
};

},{"min-dash":"aEEla","./SnapUtil":"fu3Zv","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"i8lgi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _createMoveSnapping = require("./CreateMoveSnapping");
var _createMoveSnappingDefault = parcelHelpers.interopDefault(_createMoveSnapping);
var _resizeSnapping = require("./ResizeSnapping");
var _resizeSnappingDefault = parcelHelpers.interopDefault(_resizeSnapping);
var _snapping = require("./Snapping");
var _snappingDefault = parcelHelpers.interopDefault(_snapping);
exports.default = {
    __init__: [
        'createMoveSnapping',
        'resizeSnapping',
        'snapping'
    ],
    createMoveSnapping: [
        'type',
        (0, _createMoveSnappingDefault.default)
    ],
    resizeSnapping: [
        'type',
        (0, _resizeSnappingDefault.default)
    ],
    snapping: [
        'type',
        (0, _snappingDefault.default)
    ]
};

},{"./CreateMoveSnapping":"5F922","./ResizeSnapping":"9y8Y9","./Snapping":"6WOTK","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9y8Y9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ResizeSnapping);
var _snapContext = require("./SnapContext");
var _snapContextDefault = parcelHelpers.interopDefault(_snapContext);
var _snapUtil = require("./SnapUtil");
var _keyboardUtil = require("../keyboard/KeyboardUtil");
var _layoutUtil = require("../../layout/LayoutUtil");
var _minDash = require("min-dash");
/**
 * @typedef {import('../../core/EventBus').default} EventBus
 * @typedef {import('./Snapping').default} Snapping
 */ var HIGHER_PRIORITY = 1250;
function ResizeSnapping(eventBus, snapping) {
    var self = this;
    eventBus.on([
        'resize.start'
    ], function(event) {
        self.initSnap(event);
    });
    eventBus.on([
        'resize.move',
        'resize.end'
    ], HIGHER_PRIORITY, function(event) {
        var context = event.context, shape = context.shape, parent = shape.parent, direction = context.direction, snapContext = context.snapContext;
        if (event.originalEvent && (0, _keyboardUtil.isCmd)(event.originalEvent)) return;
        if ((0, _snapUtil.isSnapped)(event)) return;
        var snapPoints = snapContext.pointsForTarget(parent);
        if (!snapPoints.initialized) {
            snapPoints = self.addSnapTargetPoints(snapPoints, shape, parent, direction);
            snapPoints.initialized = true;
        }
        if (isHorizontal(direction)) (0, _snapUtil.setSnapped)(event, 'x', event.x);
        if (isVertical(direction)) (0, _snapUtil.setSnapped)(event, 'y', event.y);
        snapping.snap(event, snapPoints);
    });
    eventBus.on([
        'resize.cleanup'
    ], function() {
        snapping.hide();
    });
}
ResizeSnapping.prototype.initSnap = function(event) {
    var context = event.context, shape = context.shape, direction = context.direction, snapContext = context.snapContext;
    if (!snapContext) snapContext = context.snapContext = new (0, _snapContextDefault.default)();
    var snapOrigin = getSnapOrigin(shape, direction);
    snapContext.setSnapOrigin('corner', {
        x: snapOrigin.x - event.x,
        y: snapOrigin.y - event.y
    });
    return snapContext;
};
ResizeSnapping.prototype.addSnapTargetPoints = function(snapPoints, shape, target, direction) {
    var snapTargets = this.getSnapTargets(shape, target);
    (0, _minDash.forEach)(snapTargets, function(snapTarget) {
        snapPoints.add('corner', (0, _snapUtil.bottomRight)(snapTarget));
        snapPoints.add('corner', (0, _snapUtil.topLeft)(snapTarget));
    });
    snapPoints.add('corner', getSnapOrigin(shape, direction));
    return snapPoints;
};
ResizeSnapping.$inject = [
    'eventBus',
    'snapping'
];
ResizeSnapping.prototype.getSnapTargets = function(shape, target) {
    return (0, _snapUtil.getChildren)(target).filter(function(child) {
        return !isAttached(child, shape) && !isConnection(child) && !isHidden(child) && !isLabel(child);
    });
};
// helpers //////////
function getSnapOrigin(shape, direction) {
    var mid = (0, _layoutUtil.getMid)(shape), trbl = (0, _layoutUtil.asTRBL)(shape);
    var snapOrigin = {
        x: mid.x,
        y: mid.y
    };
    if (direction.indexOf('n') !== -1) snapOrigin.y = trbl.top;
    else if (direction.indexOf('s') !== -1) snapOrigin.y = trbl.bottom;
    if (direction.indexOf('e') !== -1) snapOrigin.x = trbl.right;
    else if (direction.indexOf('w') !== -1) snapOrigin.x = trbl.left;
    return snapOrigin;
}
function isAttached(element, host) {
    return element.host === host;
}
function isConnection(element) {
    return !!element.waypoints;
}
function isHidden(element) {
    return !!element.hidden;
}
function isLabel(element) {
    return !!element.labelTarget;
}
function isHorizontal(direction) {
    return direction === 'n' || direction === 's';
}
function isVertical(direction) {
    return direction === 'e' || direction === 'w';
}

},{"./SnapContext":"cEwCm","./SnapUtil":"fu3Zv","../keyboard/KeyboardUtil":"2Asg4","../../layout/LayoutUtil":"4CCrs","min-dash":"aEEla","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6WOTK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SNAP_LINE_HIDE_DELAY", ()=>SNAP_LINE_HIDE_DELAY);
parcelHelpers.export(exports, "default", ()=>Snapping);
var _minDash = require("min-dash");
var _snapUtil = require("./SnapUtil");
var _tinySvg = require("tiny-svg");
/**
 * @typedef {import('../../core/Canvas').default} Canvas
 */ var SNAP_TOLERANCE = 7;
var SNAP_LINE_HIDE_DELAY = 1000;
function Snapping(canvas) {
    this._canvas = canvas;
    // delay hide by 1000 seconds since last snap
    this._asyncHide = (0, _minDash.debounce)((0, _minDash.bind)(this.hide, this), SNAP_LINE_HIDE_DELAY);
}
Snapping.$inject = [
    'canvas'
];
/**
 * Snap an event to given snap points.
 *
 * @param {Event} event
 * @param {SnapPoints} snapPoints
 */ Snapping.prototype.snap = function(event, snapPoints) {
    var context = event.context, snapContext = context.snapContext, snapLocations = snapContext.getSnapLocations();
    var snapping = {
        x: (0, _snapUtil.isSnapped)(event, 'x'),
        y: (0, _snapUtil.isSnapped)(event, 'y')
    };
    (0, _minDash.forEach)(snapLocations, function(location) {
        var snapOrigin = snapContext.getSnapOrigin(location);
        var snapCurrent = {
            x: event.x + snapOrigin.x,
            y: event.y + snapOrigin.y
        };
        // snap both axis if not snapped already
        (0, _minDash.forEach)([
            'x',
            'y'
        ], function(axis) {
            var locationSnapping;
            if (!snapping[axis]) {
                locationSnapping = snapPoints.snap(snapCurrent, location, axis, SNAP_TOLERANCE);
                if (locationSnapping !== undefined) snapping[axis] = {
                    value: locationSnapping,
                    originValue: locationSnapping - snapOrigin[axis]
                };
            }
        });
        // no need to continue snapping
        if (snapping.x && snapping.y) return false;
    });
    // show snap lines
    this.showSnapLine('vertical', snapping.x && snapping.x.value);
    this.showSnapLine('horizontal', snapping.y && snapping.y.value);
    // snap event
    (0, _minDash.forEach)([
        'x',
        'y'
    ], function(axis) {
        var axisSnapping = snapping[axis];
        if ((0, _minDash.isObject)(axisSnapping)) (0, _snapUtil.setSnapped)(event, axis, axisSnapping.originValue);
    });
};
Snapping.prototype._createLine = function(orientation) {
    var root = this._canvas.getLayer('snap');
    var line = (0, _tinySvg.create)('path');
    (0, _tinySvg.attr)(line, {
        d: 'M0,0 L0,0'
    });
    (0, _tinySvg.classes)(line).add('djs-snap-line');
    (0, _tinySvg.append)(root, line);
    return {
        update: function(position) {
            if (!(0, _minDash.isNumber)(position)) (0, _tinySvg.attr)(line, {
                display: 'none'
            });
            else if (orientation === 'horizontal') (0, _tinySvg.attr)(line, {
                d: 'M-100000,' + position + ' L+100000,' + position,
                display: ''
            });
            else (0, _tinySvg.attr)(line, {
                d: 'M ' + position + ',-100000 L ' + position + ', +100000',
                display: ''
            });
        }
    };
};
Snapping.prototype._createSnapLines = function() {
    this._snapLines = {
        horizontal: this._createLine('horizontal'),
        vertical: this._createLine('vertical')
    };
};
Snapping.prototype.showSnapLine = function(orientation, position) {
    var line = this.getSnapLine(orientation);
    if (line) line.update(position);
    this._asyncHide();
};
Snapping.prototype.getSnapLine = function(orientation) {
    if (!this._snapLines) this._createSnapLines();
    return this._snapLines[orientation];
};
Snapping.prototype.hide = function() {
    (0, _minDash.forEach)(this._snapLines, function(snapLine) {
        snapLine.update();
    });
};

},{"min-dash":"aEEla","./SnapUtil":"fu3Zv","tiny-svg":"6ZtXA","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eBhd3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _searchPad = require("diagram-js/lib/features/search-pad");
var _searchPadDefault = parcelHelpers.interopDefault(_searchPad);
var _bpmnSearchProvider = require("./BpmnSearchProvider");
var _bpmnSearchProviderDefault = parcelHelpers.interopDefault(_bpmnSearchProvider);
exports.default = {
    __depends__: [
        (0, _searchPadDefault.default)
    ],
    __init__: [
        'bpmnSearch'
    ],
    bpmnSearch: [
        'type',
        (0, _bpmnSearchProviderDefault.default)
    ]
};

},{"diagram-js/lib/features/search-pad":"jNu1N","./BpmnSearchProvider":"2Wmnj","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jNu1N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _overlays = require("../overlays");
var _overlaysDefault = parcelHelpers.interopDefault(_overlays);
var _selection = require("../selection");
var _selectionDefault = parcelHelpers.interopDefault(_selection);
var _searchPad = require("./SearchPad");
var _searchPadDefault = parcelHelpers.interopDefault(_searchPad);
exports.default = {
    __depends__: [
        (0, _overlaysDefault.default),
        (0, _selectionDefault.default)
    ],
    searchPad: [
        'type',
        (0, _searchPadDefault.default)
    ]
};

},{"../overlays":"cLFz9","../selection":"8Jf3R","./SearchPad":"eieGo","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eieGo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SearchPad);
var _minDom = require("min-dom");
var _elements = require("../../util/Elements");
var _escapeUtil = require("../../util/EscapeUtil");
var _keyboardUtil = require("../keyboard/KeyboardUtil");
function SearchPad(canvas, eventBus, overlays, selection) {
    this._open = false;
    this._results = [];
    this._eventMaps = [];
    this._canvas = canvas;
    this._eventBus = eventBus;
    this._overlays = overlays;
    this._selection = selection;
    // setup elements
    this._container = (0, _minDom.domify)(SearchPad.BOX_HTML);
    this._searchInput = (0, _minDom.query)(SearchPad.INPUT_SELECTOR, this._container);
    this._resultsContainer = (0, _minDom.query)(SearchPad.RESULTS_CONTAINER_SELECTOR, this._container);
    // attach search pad
    this._canvas.getContainer().appendChild(this._container);
    // cleanup on destroy
    eventBus.on([
        'canvas.destroy',
        'diagram.destroy'
    ], this.close, this);
}
SearchPad.$inject = [
    'canvas',
    'eventBus',
    'overlays',
    'selection'
];
/**
 * Binds and keeps track of all event listereners
 */ SearchPad.prototype._bindEvents = function() {
    var self = this;
    function listen(el, selector, type, fn) {
        self._eventMaps.push({
            el: el,
            type: type,
            listener: (0, _minDom.delegate).bind(el, selector, type, fn)
        });
    }
    // close search on clicking anywhere outside
    listen(document, 'html', 'click', function(e) {
        self.close();
    });
    // stop event from propagating and closing search
    // focus on input
    listen(this._container, SearchPad.INPUT_SELECTOR, 'click', function(e) {
        e.stopPropagation();
        e.delegateTarget.focus();
    });
    // preselect result on hover
    listen(this._container, SearchPad.RESULT_SELECTOR, 'mouseover', function(e) {
        e.stopPropagation();
        self._scrollToNode(e.delegateTarget);
        self._preselect(e.delegateTarget);
    });
    // selects desired result on mouse click
    listen(this._container, SearchPad.RESULT_SELECTOR, 'click', function(e) {
        e.stopPropagation();
        self._select(e.delegateTarget);
    });
    // prevent cursor in input from going left and right when using up/down to
    // navigate results
    listen(this._container, SearchPad.INPUT_SELECTOR, 'keydown', function(e) {
        if ((0, _keyboardUtil.isKey)('ArrowUp', e)) e.preventDefault();
        if ((0, _keyboardUtil.isKey)('ArrowDown', e)) e.preventDefault();
    });
    // handle keyboard input
    listen(this._container, SearchPad.INPUT_SELECTOR, 'keyup', function(e) {
        if ((0, _keyboardUtil.isKey)('Escape', e)) return self.close();
        if ((0, _keyboardUtil.isKey)('Enter', e)) {
            var selected = self._getCurrentResult();
            return selected ? self._select(selected) : self.close();
        }
        if ((0, _keyboardUtil.isKey)('ArrowUp', e)) return self._scrollToDirection(true);
        if ((0, _keyboardUtil.isKey)('ArrowDown', e)) return self._scrollToDirection();
        // do not search while navigating text input
        if ((0, _keyboardUtil.isKey)([
            'ArrowLeft',
            'ArrowRight'
        ], e)) return;
        // anything else
        self._search(e.delegateTarget.value);
    });
};
/**
 * Unbinds all previously established listeners
 */ SearchPad.prototype._unbindEvents = function() {
    this._eventMaps.forEach(function(m) {
        (0, _minDom.delegate).unbind(m.el, m.type, m.listener);
    });
};
/**
 * Performs a search for the given pattern.
 *
 * @param {string} pattern
 */ SearchPad.prototype._search = function(pattern) {
    var self = this;
    this._clearResults();
    // do not search on empty query
    if (!pattern || pattern === '') return;
    var searchResults = this._searchProvider.find(pattern);
    if (!searchResults.length) return;
    // append new results
    searchResults.forEach(function(result) {
        var id = result.element.id;
        var node = self._createResultNode(result, id);
        self._results[id] = {
            element: result.element,
            node: node
        };
    });
    // preselect first result
    var node = (0, _minDom.query)(SearchPad.RESULT_SELECTOR, this._resultsContainer);
    this._scrollToNode(node);
    this._preselect(node);
};
/**
 * Navigate to the previous/next result. Defaults to next result.
 * @param {boolean} previous
 */ SearchPad.prototype._scrollToDirection = function(previous) {
    var selected = this._getCurrentResult();
    if (!selected) return;
    var node = previous ? selected.previousElementSibling : selected.nextElementSibling;
    if (node) {
        this._scrollToNode(node);
        this._preselect(node);
    }
};
/**
 * Scroll to the node if it is not visible.
 *
 * @param {Element} node
 */ SearchPad.prototype._scrollToNode = function(node) {
    if (!node || node === this._getCurrentResult()) return;
    var nodeOffset = node.offsetTop;
    var containerScroll = this._resultsContainer.scrollTop;
    var bottomScroll = nodeOffset - this._resultsContainer.clientHeight + node.clientHeight;
    if (nodeOffset < containerScroll) this._resultsContainer.scrollTop = nodeOffset;
    else if (containerScroll < bottomScroll) this._resultsContainer.scrollTop = bottomScroll;
};
/**
 * Clears all results data.
 */ SearchPad.prototype._clearResults = function() {
    (0, _minDom.clear)(this._resultsContainer);
    this._results = [];
    this._resetOverlay();
    this._eventBus.fire('searchPad.cleared');
};
/**
 * Get currently selected result.
 *
 * @return {Element}
 */ SearchPad.prototype._getCurrentResult = function() {
    return (0, _minDom.query)(SearchPad.RESULT_SELECTED_SELECTOR, this._resultsContainer);
};
/**
 * Create result DOM element within results container
 * that corresponds to a search result.
 *
 * 'result' : one of the elements returned by SearchProvider
 * 'id' : id attribute value to assign to the new DOM node
 * return : created DOM element
 *
 * @param {SearchResult} result
 * @param {string} id
 * @return {Element}
 */ SearchPad.prototype._createResultNode = function(result, id) {
    var node = (0, _minDom.domify)(SearchPad.RESULT_HTML);
    // create only if available
    if (result.primaryTokens.length > 0) createInnerTextNode(node, result.primaryTokens, SearchPad.RESULT_PRIMARY_HTML);
    // secondary tokens (represent element ID) are allways available
    createInnerTextNode(node, result.secondaryTokens, SearchPad.RESULT_SECONDARY_HTML);
    (0, _minDom.attr)(node, SearchPad.RESULT_ID_ATTRIBUTE, id);
    this._resultsContainer.appendChild(node);
    return node;
};
/**
 * Register search element provider.
 *
 * SearchProvider.find - provides search function over own elements
 *  (pattern) => [{ text: <String>, element: <Element>}, ...]
 *
 * @param {SearchProvider} provider
 */ SearchPad.prototype.registerProvider = function(provider) {
    this._searchProvider = provider;
};
/**
 * Open search pad.
 */ SearchPad.prototype.open = function() {
    if (!this._searchProvider) throw new Error('no search provider registered');
    if (this.isOpen()) return;
    this._bindEvents();
    this._open = true;
    (0, _minDom.classes)(this._container).add('open');
    this._searchInput.focus();
    this._eventBus.fire('searchPad.opened');
};
/**
 * Close search pad.
 */ SearchPad.prototype.close = function() {
    if (!this.isOpen()) return;
    this._unbindEvents();
    this._open = false;
    (0, _minDom.classes)(this._container).remove('open');
    this._clearResults();
    this._searchInput.value = '';
    this._searchInput.blur();
    this._resetOverlay();
    this._eventBus.fire('searchPad.closed');
};
/**
 * Toggles search pad on/off.
 */ SearchPad.prototype.toggle = function() {
    this.isOpen() ? this.close() : this.open();
};
/**
 * Report state of search pad.
 */ SearchPad.prototype.isOpen = function() {
    return this._open;
};
/**
 * Preselect result entry.
 *
 * @param {Element} element
 */ SearchPad.prototype._preselect = function(node) {
    var selectedNode = this._getCurrentResult();
    // already selected
    if (node === selectedNode) return;
    // removing preselection from current node
    if (selectedNode) (0, _minDom.classes)(selectedNode).remove(SearchPad.RESULT_SELECTED_CLASS);
    var id = (0, _minDom.attr)(node, SearchPad.RESULT_ID_ATTRIBUTE);
    var element = this._results[id].element;
    (0, _minDom.classes)(node).add(SearchPad.RESULT_SELECTED_CLASS);
    this._resetOverlay(element);
    this._canvas.scrollToElement(element, {
        top: 400
    });
    this._selection.select(element);
    this._eventBus.fire('searchPad.preselected', element);
};
/**
 * Select result node.
 *
 * @param {Element} element
 */ SearchPad.prototype._select = function(node) {
    var id = (0, _minDom.attr)(node, SearchPad.RESULT_ID_ATTRIBUTE);
    var element = this._results[id].element;
    this.close();
    this._resetOverlay();
    this._canvas.scrollToElement(element, {
        top: 400
    });
    this._selection.select(element);
    this._eventBus.fire('searchPad.selected', element);
};
/**
 * Reset overlay removes and, optionally, set
 * overlay to a new element.
 *
 * @param {Element} element
 */ SearchPad.prototype._resetOverlay = function(element) {
    if (this._overlayId) this._overlays.remove(this._overlayId);
    if (element) {
        var box = (0, _elements.getBBox)(element);
        var overlay = constructOverlay(box);
        this._overlayId = this._overlays.add(element, overlay);
    }
};
/**
 * Construct overlay object for the given bounding box.
 *
 * @param {BoundingBox} box
 * @return {Object}
 */ function constructOverlay(box) {
    var offset = 6;
    var w = box.width + offset * 2;
    var h = box.height + offset * 2;
    var styles = {
        width: w + 'px',
        height: h + 'px'
    };
    var html = (0, _minDom.domify)('<div class="' + SearchPad.OVERLAY_CLASS + '"></div>');
    (0, _minDom.assignStyle)(html, styles);
    return {
        position: {
            bottom: h - offset,
            right: w - offset
        },
        show: true,
        html: html
    };
}
/**
 * Creates and appends child node from result tokens and HTML template.
 *
 * @param {Element} node
 * @param {Array<Object>} tokens
 * @param {string} template
 */ function createInnerTextNode(parentNode, tokens, template) {
    var text = createHtmlText(tokens);
    var childNode = (0, _minDom.domify)(template);
    childNode.innerHTML = text;
    parentNode.appendChild(childNode);
}
/**
 * Create internal HTML markup from result tokens.
 * Caters for highlighting pattern matched tokens.
 *
 * @param {Array<Object>} tokens
 * @return {string}
 */ function createHtmlText(tokens) {
    var htmlText = '';
    tokens.forEach(function(t) {
        if (t.matched) htmlText += '<strong class="' + SearchPad.RESULT_HIGHLIGHT_CLASS + '">' + (0, _escapeUtil.escapeHTML)(t.matched) + '</strong>';
        else htmlText += (0, _escapeUtil.escapeHTML)(t.normal);
    });
    return htmlText !== '' ? htmlText : null;
}
/**
 * CONSTANTS
 */ SearchPad.CONTAINER_SELECTOR = '.djs-search-container';
SearchPad.INPUT_SELECTOR = '.djs-search-input input';
SearchPad.RESULTS_CONTAINER_SELECTOR = '.djs-search-results';
SearchPad.RESULT_SELECTOR = '.djs-search-result';
SearchPad.RESULT_SELECTED_CLASS = 'djs-search-result-selected';
SearchPad.RESULT_SELECTED_SELECTOR = '.' + SearchPad.RESULT_SELECTED_CLASS;
SearchPad.RESULT_ID_ATTRIBUTE = 'data-result-id';
SearchPad.RESULT_HIGHLIGHT_CLASS = 'djs-search-highlight';
SearchPad.OVERLAY_CLASS = 'djs-search-overlay';
SearchPad.BOX_HTML = '<div class="djs-search-container djs-draggable djs-scrollable"><div class="djs-search-input"><input type="text"/></div><div class="djs-search-results"></div></div>';
SearchPad.RESULT_HTML = '<div class="djs-search-result"></div>';
SearchPad.RESULT_PRIMARY_HTML = '<div class="djs-search-result-primary"></div>';
SearchPad.RESULT_SECONDARY_HTML = '<p class="djs-search-result-secondary"></p>';

},{"min-dom":"e58GC","../../util/Elements":"6qdtl","../../util/EscapeUtil":"kAkPb","../keyboard/KeyboardUtil":"2Asg4","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2Wmnj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BpmnSearchProvider);
var _minDash = require("min-dash");
var _labelUtil = require("../label-editing/LabelUtil");
function BpmnSearchProvider(elementRegistry, searchPad, canvas) {
    this._elementRegistry = elementRegistry;
    this._canvas = canvas;
    searchPad.registerProvider(this);
}
BpmnSearchProvider.$inject = [
    'elementRegistry',
    'searchPad',
    'canvas'
];
/**
 * Finds all elements that match given pattern
 *
 * <Result> :
 *  {
 *    primaryTokens: <Array<Token>>,
 *    secondaryTokens: <Array<Token>>,
 *    element: <Element>
 *  }
 *
 * <Token> :
 *  {
 *    normal|matched: <string>
 *  }
 *
 * @param  {string} pattern
 * @return {Array<Result>}
 */ BpmnSearchProvider.prototype.find = function(pattern) {
    var rootElement = this._canvas.getRootElement();
    var elements = this._elementRegistry.filter(function(element) {
        if (element.labelTarget) return false;
        return true;
    });
    // do not include root element
    elements = (0, _minDash.filter)(elements, function(element) {
        return element !== rootElement;
    });
    elements = (0, _minDash.map)(elements, function(element) {
        return {
            primaryTokens: matchAndSplit((0, _labelUtil.getLabel)(element), pattern),
            secondaryTokens: matchAndSplit(element.id, pattern),
            element: element
        };
    });
    // exclude non-matched elements
    elements = (0, _minDash.filter)(elements, function(element) {
        return hasMatched(element.primaryTokens) || hasMatched(element.secondaryTokens);
    });
    elements = (0, _minDash.sortBy)(elements, function(element) {
        return (0, _labelUtil.getLabel)(element.element) + element.element.id;
    });
    return elements;
};
function hasMatched(tokens) {
    var matched = (0, _minDash.filter)(tokens, function(t) {
        return !!t.matched;
    });
    return matched.length > 0;
}
function matchAndSplit(text, pattern) {
    var tokens = [], originalText = text;
    if (!text) return tokens;
    text = text.toLowerCase();
    pattern = pattern.toLowerCase();
    var i = text.indexOf(pattern);
    if (i > -1) {
        if (i !== 0) tokens.push({
            normal: originalText.substr(0, i)
        });
        tokens.push({
            matched: originalText.substr(i, pattern.length)
        });
        if (pattern.length + i < text.length) tokens.push({
            normal: originalText.substr(pattern.length + i, text.length)
        });
    } else tokens.push({
        normal: originalText
    });
    return tokens;
}

},{"min-dash":"aEEla","../label-editing/LabelUtil":"gHqpR","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3eyQ5":[function(require,module,exports,__globalThis) {
/*!
 * html2canvas 1.4.1 <https://html2canvas.hertzen.com>
 * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */ (function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */ /* global Reflect, Promise */ var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    function __extends(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }
    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for(var s, i = 1, n = arguments.length; i < n; i++){
                s = arguments[i];
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };
    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P ? value : new P(function(resolve) {
                resolve(value);
            });
        }
        return new (P || (P = Promise))(function(resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator["throw"](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }
    function __generator(thisArg, body) {
        var _ = {
            label: 0,
            sent: function() {
                if (t[0] & 1) throw t[1];
                return t[1];
            },
            trys: [],
            ops: []
        }, f, y, t, g;
        return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
        }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
            return this;
        }), g;
        function verb(n) {
            return function(v) {
                return step([
                    n,
                    v
                ]);
            };
        }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while(_)try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [
                    op[0] & 2,
                    t.value
                ];
                switch(op[0]){
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return {
                            value: op[1],
                            done: false
                        };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [
                            0
                        ];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [
                    6,
                    e
                ];
                y = 0;
            } finally{
                f = t = 0;
            }
            if (op[0] & 5) throw op[1];
            return {
                value: op[0] ? op[1] : void 0,
                done: true
            };
        }
    }
    function __spreadArray(to, from, pack) {
        if (pack || arguments.length === 2) {
            for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
        return to.concat(ar || from);
    }
    var Bounds = /** @class */ function() {
        function Bounds(left, top, width, height) {
            this.left = left;
            this.top = top;
            this.width = width;
            this.height = height;
        }
        Bounds.prototype.add = function(x, y, w, h) {
            return new Bounds(this.left + x, this.top + y, this.width + w, this.height + h);
        };
        Bounds.fromClientRect = function(context, clientRect) {
            return new Bounds(clientRect.left + context.windowBounds.left, clientRect.top + context.windowBounds.top, clientRect.width, clientRect.height);
        };
        Bounds.fromDOMRectList = function(context, domRectList) {
            var domRect = Array.from(domRectList).find(function(rect) {
                return rect.width !== 0;
            });
            return domRect ? new Bounds(domRect.left + context.windowBounds.left, domRect.top + context.windowBounds.top, domRect.width, domRect.height) : Bounds.EMPTY;
        };
        Bounds.EMPTY = new Bounds(0, 0, 0, 0);
        return Bounds;
    }();
    var parseBounds = function(context, node) {
        return Bounds.fromClientRect(context, node.getBoundingClientRect());
    };
    var parseDocumentSize = function(document1) {
        var body = document1.body;
        var documentElement = document1.documentElement;
        if (!body || !documentElement) throw new Error("Unable to get document size");
        var width = Math.max(Math.max(body.scrollWidth, documentElement.scrollWidth), Math.max(body.offsetWidth, documentElement.offsetWidth), Math.max(body.clientWidth, documentElement.clientWidth));
        var height = Math.max(Math.max(body.scrollHeight, documentElement.scrollHeight), Math.max(body.offsetHeight, documentElement.offsetHeight), Math.max(body.clientHeight, documentElement.clientHeight));
        return new Bounds(0, 0, width, height);
    };
    /*
     * css-line-break 2.1.0 <https://github.com/niklasvh/css-line-break#readme>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var toCodePoints$1 = function(str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while(i < length){
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                else {
                    codePoints.push(value);
                    i--;
                }
            } else codePoints.push(value);
        }
        return codePoints;
    };
    var fromCodePoint$1 = function() {
        var codePoints = [];
        for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
        if (String.fromCodePoint) return String.fromCodePoint.apply(String, codePoints);
        var length = codePoints.length;
        if (!length) return '';
        var codeUnits = [];
        var index = -1;
        var result = '';
        while(++index < length){
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) codeUnits.push(codePoint);
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var chars$2 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$2 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$2 = 0; i$2 < chars$2.length; i$2++)lookup$2[chars$2.charCodeAt(i$2)] = i$2;
    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$1$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$1$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$1$1 = 0; i$1$1 < chars$1$1.length; i$1$1++)lookup$1$1[chars$1$1.charCodeAt(i$1$1)] = i$1$1;
    var decode$1 = function(base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') bufferLength--;
        }
        var buffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && typeof Uint8Array.prototype.slice !== 'undefined' ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for(i = 0; i < len; i += 4){
            encoded1 = lookup$1$1[base64.charCodeAt(i)];
            encoded2 = lookup$1$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1$1[base64.charCodeAt(i + 3)];
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return buffer;
    };
    var polyUint16Array$1 = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 2)bytes.push(buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    var polyUint32Array$1 = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 4)bytes.push(buffer[i + 3] << 24 | buffer[i + 2] << 16 | buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    /** Shift size for getting the index-2 table offset. */ var UTRIE2_SHIFT_2$1 = 5;
    /** Shift size for getting the index-1 table offset. */ var UTRIE2_SHIFT_1$1 = 11;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */ var UTRIE2_INDEX_SHIFT$1 = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */ var UTRIE2_SHIFT_1_2$1 = UTRIE2_SHIFT_1$1 - UTRIE2_SHIFT_2$1;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */ var UTRIE2_LSCP_INDEX_2_OFFSET$1 = 0x10000 >> UTRIE2_SHIFT_2$1;
    /** Number of entries in a data block. 32=0x20 */ var UTRIE2_DATA_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_2$1;
    /** Mask for getting the lower bits for the in-data-block offset. */ var UTRIE2_DATA_MASK$1 = UTRIE2_DATA_BLOCK_LENGTH$1 - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH$1 = 0x400 >> UTRIE2_SHIFT_2$1;
    /** Count the lengths of both BMP pieces. 2080=0x820 */ var UTRIE2_INDEX_2_BMP_LENGTH$1 = UTRIE2_LSCP_INDEX_2_OFFSET$1 + UTRIE2_LSCP_INDEX_2_LENGTH$1;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */ var UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 = UTRIE2_INDEX_2_BMP_LENGTH$1;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH$1 = 32; /* U+0800 is the first code point after 2-byte UTF-8 */ 
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */ var UTRIE2_INDEX_1_OFFSET$1 = UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 + UTRIE2_UTF8_2B_INDEX_2_LENGTH$1;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */ var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 = 0x10000 >> UTRIE2_SHIFT_1$1;
    /** Number of entries in an index-2 block. 64=0x40 */ var UTRIE2_INDEX_2_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_1_2$1;
    /** Mask for getting the lower bits for the in-index-2-block offset. */ var UTRIE2_INDEX_2_MASK$1 = UTRIE2_INDEX_2_BLOCK_LENGTH$1 - 1;
    var slice16$1 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32$1 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64$1 = function(base64, _byteLength) {
        var buffer = decode$1(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array$1(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array$1(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16$1(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2 ? slice16$1(view16, (headerLength + view32[4]) / 2) : slice32$1(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie$1(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie$1 = /** @class */ function() {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */ Trie.prototype.get = function(codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2$1];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET$1 + (codePoint - 0xd800 >> UTRIE2_SHIFT_2$1)];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET$1 - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 + (codePoint >> UTRIE2_SHIFT_1$1);
                    ix = this.index[ix];
                    ix += codePoint >> UTRIE2_SHIFT_2$1 & UTRIE2_INDEX_2_MASK$1;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) return this.data[this.highValueIndex];
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }();
    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$3 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$3 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$3 = 0; i$3 < chars$3.length; i$3++)lookup$3[chars$3.charCodeAt(i$3)] = i$3;
    var base64$1 = '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';
    var LETTER_NUMBER_MODIFIER = 50;
    // Non-tailorable Line Breaking Classes
    var BK = 1; //  Cause a line break (after)
    var CR$1 = 2; //  Cause a line break (after), except between CR and LF
    var LF$1 = 3; //  Cause a line break (after)
    var CM = 4; //  Prohibit a line break between the character and the preceding character
    var NL = 5; //  Cause a line break (after)
    var WJ = 7; //  Prohibit line breaks before and after
    var ZW = 8; //  Provide a break opportunity
    var GL = 9; //  Prohibit line breaks before and after
    var SP = 10; // Enable indirect line breaks
    var ZWJ$1 = 11; // Prohibit line breaks within joiner sequences
    // Break Opportunities
    var B2 = 12; //  Provide a line break opportunity before and after the character
    var BA = 13; //  Generally provide a line break opportunity after the character
    var BB = 14; //  Generally provide a line break opportunity before the character
    var HY = 15; //  Provide a line break opportunity after the character, except in numeric context
    var CB = 16; //   Provide a line break opportunity contingent on additional information
    // Characters Prohibiting Certain Breaks
    var CL = 17; //  Prohibit line breaks before
    var CP = 18; //  Prohibit line breaks before
    var EX = 19; //  Prohibit line breaks before
    var IN = 20; //  Allow only indirect line breaks between pairs
    var NS = 21; //  Allow only indirect line breaks before
    var OP = 22; //  Prohibit line breaks after
    var QU = 23; //  Act like they are both opening and closing
    // Numeric Context
    var IS = 24; //  Prevent breaks after any and before numeric
    var NU = 25; //  Form numeric expressions for line breaking purposes
    var PO = 26; //  Do not break following a numeric expression
    var PR = 27; //  Do not break in front of a numeric expression
    var SY = 28; //  Prevent a break before; and allow a break after
    // Other Characters
    var AI = 29; //  Act like AL when the resolvedEAW is N; otherwise; act as ID
    var AL = 30; //  Are alphabetic characters or symbols that are used with alphabetic characters
    var CJ = 31; //  Treat as NS or ID for strict or normal breaking.
    var EB = 32; //  Do not break from following Emoji Modifier
    var EM = 33; //  Do not break from preceding Emoji Base
    var H2 = 34; //  Form Korean syllable blocks
    var H3 = 35; //  Form Korean syllable blocks
    var HL = 36; //  Do not break around a following hyphen; otherwise act as Alphabetic
    var ID = 37; //  Break before or after; except in some numeric context
    var JL = 38; //  Form Korean syllable blocks
    var JV = 39; //  Form Korean syllable blocks
    var JT = 40; //  Form Korean syllable blocks
    var RI$1 = 41; //  Keep pairs together. For pairs; break before and after other classes
    var SA = 42; //  Provide a line break opportunity contingent on additional, language-specific context analysis
    var XX = 43; //  Have as yet unknown line breaking behavior or unassigned code positions
    var ea_OP = [
        0x2329,
        0xff08
    ];
    var BREAK_MANDATORY = '!';
    var BREAK_NOT_ALLOWED$1 = "\xd7";
    var BREAK_ALLOWED$1 = "\xf7";
    var UnicodeTrie$1 = createTrieFromBase64$1(base64$1);
    var ALPHABETICS = [
        AL,
        HL
    ];
    var HARD_LINE_BREAKS = [
        BK,
        CR$1,
        LF$1,
        NL
    ];
    var SPACE$1 = [
        SP,
        ZW
    ];
    var PREFIX_POSTFIX = [
        PR,
        PO
    ];
    var LINE_BREAKS = HARD_LINE_BREAKS.concat(SPACE$1);
    var KOREAN_SYLLABLE_BLOCK = [
        JL,
        JV,
        JT,
        H2,
        H3
    ];
    var HYPHEN = [
        HY,
        BA
    ];
    var codePointsToCharacterClasses = function(codePoints, lineBreak) {
        if (lineBreak === void 0) lineBreak = 'strict';
        var types = [];
        var indices = [];
        var categories = [];
        codePoints.forEach(function(codePoint, index) {
            var classType = UnicodeTrie$1.get(codePoint);
            if (classType > LETTER_NUMBER_MODIFIER) {
                categories.push(true);
                classType -= LETTER_NUMBER_MODIFIER;
            } else categories.push(false);
            if ([
                'normal',
                'auto',
                'loose'
            ].indexOf(lineBreak) !== -1) // U+2010, – U+2013, 〜 U+301C, ゠ U+30A0
            {
                if ([
                    0x2010,
                    0x2013,
                    0x301c,
                    0x30a0
                ].indexOf(codePoint) !== -1) {
                    indices.push(index);
                    return types.push(CB);
                }
            }
            if (classType === CM || classType === ZWJ$1) {
                // LB10 Treat any remaining combining mark or ZWJ as AL.
                if (index === 0) {
                    indices.push(index);
                    return types.push(AL);
                }
                // LB9 Do not break a combining character sequence; treat it as if it has the line breaking class of
                // the base character in all of the following rules. Treat ZWJ as if it were CM.
                var prev = types[index - 1];
                if (LINE_BREAKS.indexOf(prev) === -1) {
                    indices.push(indices[index - 1]);
                    return types.push(prev);
                }
                indices.push(index);
                return types.push(AL);
            }
            indices.push(index);
            if (classType === CJ) return types.push(lineBreak === 'strict' ? NS : ID);
            if (classType === SA) return types.push(AL);
            if (classType === AI) return types.push(AL);
            // For supplementary characters, a useful default is to treat characters in the range 10000..1FFFD as AL
            // and characters in the ranges 20000..2FFFD and 30000..3FFFD as ID, until the implementation can be revised
            // to take into account the actual line breaking properties for these characters.
            if (classType === XX) {
                if (codePoint >= 0x20000 && codePoint <= 0x2fffd || codePoint >= 0x30000 && codePoint <= 0x3fffd) return types.push(ID);
                else return types.push(AL);
            }
            types.push(classType);
        });
        return [
            indices,
            types,
            categories
        ];
    };
    var isAdjacentWithSpaceIgnored = function(a, b, currentIndex, classTypes) {
        var current = classTypes[currentIndex];
        if (Array.isArray(a) ? a.indexOf(current) !== -1 : a === current) {
            var i = currentIndex;
            while(i <= classTypes.length){
                i++;
                var next = classTypes[i];
                if (next === b) return true;
                if (next !== SP) break;
            }
        }
        if (current === SP) {
            var i = currentIndex;
            while(i > 0){
                i--;
                var prev = classTypes[i];
                if (Array.isArray(a) ? a.indexOf(prev) !== -1 : a === prev) {
                    var n = currentIndex;
                    while(n <= classTypes.length){
                        n++;
                        var next = classTypes[n];
                        if (next === b) return true;
                        if (next !== SP) break;
                    }
                }
                if (prev !== SP) break;
            }
        }
        return false;
    };
    var previousNonSpaceClassType = function(currentIndex, classTypes) {
        var i = currentIndex;
        while(i >= 0){
            var type = classTypes[i];
            if (type === SP) i--;
            else return type;
        }
        return 0;
    };
    var _lineBreakAtIndex = function(codePoints, classTypes, indicies, index, forbiddenBreaks) {
        if (indicies[index] === 0) return BREAK_NOT_ALLOWED$1;
        var currentIndex = index - 1;
        if (Array.isArray(forbiddenBreaks) && forbiddenBreaks[currentIndex] === true) return BREAK_NOT_ALLOWED$1;
        var beforeIndex = currentIndex - 1;
        var afterIndex = currentIndex + 1;
        var current = classTypes[currentIndex];
        // LB4 Always break after hard line breaks.
        // LB5 Treat CR followed by LF, as well as CR, LF, and NL as hard line breaks.
        var before = beforeIndex >= 0 ? classTypes[beforeIndex] : 0;
        var next = classTypes[afterIndex];
        if (current === CR$1 && next === LF$1) return BREAK_NOT_ALLOWED$1;
        if (HARD_LINE_BREAKS.indexOf(current) !== -1) return BREAK_MANDATORY;
        // LB6 Do not break before hard line breaks.
        if (HARD_LINE_BREAKS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB7 Do not break before spaces or zero width space.
        if (SPACE$1.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB8 Break before any character following a zero-width space, even if one or more spaces intervene.
        if (previousNonSpaceClassType(currentIndex, classTypes) === ZW) return BREAK_ALLOWED$1;
        // LB8a Do not break after a zero width joiner.
        if (UnicodeTrie$1.get(codePoints[currentIndex]) === ZWJ$1) return BREAK_NOT_ALLOWED$1;
        // zwj emojis
        if ((current === EB || current === EM) && UnicodeTrie$1.get(codePoints[afterIndex]) === ZWJ$1) return BREAK_NOT_ALLOWED$1;
        // LB11 Do not break before or after Word joiner and related characters.
        if (current === WJ || next === WJ) return BREAK_NOT_ALLOWED$1;
        // LB12 Do not break after NBSP and related characters.
        if (current === GL) return BREAK_NOT_ALLOWED$1;
        // LB12a Do not break before NBSP and related characters, except after spaces and hyphens.
        if ([
            SP,
            BA,
            HY
        ].indexOf(current) === -1 && next === GL) return BREAK_NOT_ALLOWED$1;
        // LB13 Do not break before ‘]’ or ‘!’ or ‘;’ or ‘/’, even after spaces.
        if ([
            CL,
            CP,
            EX,
            IS,
            SY
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB14 Do not break after ‘[’, even after spaces.
        if (previousNonSpaceClassType(currentIndex, classTypes) === OP) return BREAK_NOT_ALLOWED$1;
        // LB15 Do not break within ‘”[’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(QU, OP, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB16 Do not break between closing punctuation and a nonstarter (lb=NS), even with intervening spaces.
        if (isAdjacentWithSpaceIgnored([
            CL,
            CP
        ], NS, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB17 Do not break within ‘——’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(B2, B2, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB18 Break after spaces.
        if (current === SP) return BREAK_ALLOWED$1;
        // LB19 Do not break before or after quotation marks, such as ‘ ” ’.
        if (current === QU || next === QU) return BREAK_NOT_ALLOWED$1;
        // LB20 Break before and after unresolved CB.
        if (next === CB || current === CB) return BREAK_ALLOWED$1;
        // LB21 Do not break before hyphen-minus, other hyphens, fixed-width spaces, small kana, and other non-starters, or after acute accents.
        if ([
            BA,
            HY,
            NS
        ].indexOf(next) !== -1 || current === BB) return BREAK_NOT_ALLOWED$1;
        // LB21a Don't break after Hebrew + Hyphen.
        if (before === HL && HYPHEN.indexOf(current) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB21b Don’t break between Solidus and Hebrew letters.
        if (current === SY && next === HL) return BREAK_NOT_ALLOWED$1;
        // LB22 Do not break before ellipsis.
        if (next === IN) return BREAK_NOT_ALLOWED$1;
        // LB23 Do not break between digits and letters.
        if (ALPHABETICS.indexOf(next) !== -1 && current === NU || ALPHABETICS.indexOf(current) !== -1 && next === NU) return BREAK_NOT_ALLOWED$1;
        // LB23a Do not break between numeric prefixes and ideographs, or between ideographs and numeric postfixes.
        if (current === PR && [
            ID,
            EB,
            EM
        ].indexOf(next) !== -1 || [
            ID,
            EB,
            EM
        ].indexOf(current) !== -1 && next === PO) return BREAK_NOT_ALLOWED$1;
        // LB24 Do not break between numeric prefix/postfix and letters, or between letters and prefix/postfix.
        if (ALPHABETICS.indexOf(current) !== -1 && PREFIX_POSTFIX.indexOf(next) !== -1 || PREFIX_POSTFIX.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB25 Do not break between the following pairs of classes relevant to numbers:
        if (// (PR | PO) × ( OP | HY )? NU
        [
            PR,
            PO
        ].indexOf(current) !== -1 && (next === NU || [
            OP,
            HY
        ].indexOf(next) !== -1 && classTypes[afterIndex + 1] === NU) || // ( OP | HY ) × NU
        [
            OP,
            HY
        ].indexOf(current) !== -1 && next === NU || // NU ×	(NU | SY | IS)
        current === NU && [
            NU,
            SY,
            IS
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // NU (NU | SY | IS)* × (NU | SY | IS | CL | CP)
        if ([
            NU,
            SY,
            IS,
            CL,
            CP
        ].indexOf(next) !== -1) {
            var prevIndex = currentIndex;
            while(prevIndex >= 0){
                var type = classTypes[prevIndex];
                if (type === NU) return BREAK_NOT_ALLOWED$1;
                else if ([
                    SY,
                    IS
                ].indexOf(type) !== -1) prevIndex--;
                else break;
            }
        }
        // NU (NU | SY | IS)* (CL | CP)? × (PO | PR))
        if ([
            PR,
            PO
        ].indexOf(next) !== -1) {
            var prevIndex = [
                CL,
                CP
            ].indexOf(current) !== -1 ? beforeIndex : currentIndex;
            while(prevIndex >= 0){
                var type = classTypes[prevIndex];
                if (type === NU) return BREAK_NOT_ALLOWED$1;
                else if ([
                    SY,
                    IS
                ].indexOf(type) !== -1) prevIndex--;
                else break;
            }
        }
        // LB26 Do not break a Korean syllable.
        if (JL === current && [
            JL,
            JV,
            H2,
            H3
        ].indexOf(next) !== -1 || [
            JV,
            H2
        ].indexOf(current) !== -1 && [
            JV,
            JT
        ].indexOf(next) !== -1 || [
            JT,
            H3
        ].indexOf(current) !== -1 && next === JT) return BREAK_NOT_ALLOWED$1;
        // LB27 Treat a Korean Syllable Block the same as ID.
        if (KOREAN_SYLLABLE_BLOCK.indexOf(current) !== -1 && [
            IN,
            PO
        ].indexOf(next) !== -1 || KOREAN_SYLLABLE_BLOCK.indexOf(next) !== -1 && current === PR) return BREAK_NOT_ALLOWED$1;
        // LB28 Do not break between alphabetics (“at”).
        if (ALPHABETICS.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB29 Do not break between numeric punctuation and alphabetics (“e.g.”).
        if (current === IS && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB30 Do not break between letters, numbers, or ordinary symbols and opening or closing parentheses.
        if (ALPHABETICS.concat(NU).indexOf(current) !== -1 && next === OP && ea_OP.indexOf(codePoints[afterIndex]) === -1 || ALPHABETICS.concat(NU).indexOf(next) !== -1 && current === CP) return BREAK_NOT_ALLOWED$1;
        // LB30a Break between two regional indicator symbols if and only if there are an even number of regional
        // indicators preceding the position of the break.
        if (current === RI$1 && next === RI$1) {
            var i = indicies[currentIndex];
            var count = 1;
            while(i > 0){
                i--;
                if (classTypes[i] === RI$1) count++;
                else break;
            }
            if (count % 2 !== 0) return BREAK_NOT_ALLOWED$1;
        }
        // LB30b Do not break between an emoji base and an emoji modifier.
        if (current === EB && next === EM) return BREAK_NOT_ALLOWED$1;
        return BREAK_ALLOWED$1;
    };
    var cssFormattedClasses = function(codePoints, options) {
        if (!options) options = {
            lineBreak: 'normal',
            wordBreak: 'normal'
        };
        var _a = codePointsToCharacterClasses(codePoints, options.lineBreak), indicies = _a[0], classTypes = _a[1], isLetterNumber = _a[2];
        if (options.wordBreak === 'break-all' || options.wordBreak === 'break-word') classTypes = classTypes.map(function(type) {
            return [
                NU,
                AL,
                SA
            ].indexOf(type) !== -1 ? ID : type;
        });
        var forbiddenBreakpoints = options.wordBreak === 'keep-all' ? isLetterNumber.map(function(letterNumber, i) {
            return letterNumber && codePoints[i] >= 0x4e00 && codePoints[i] <= 0x9fff;
        }) : undefined;
        return [
            indicies,
            classTypes,
            forbiddenBreakpoints
        ];
    };
    var Break = /** @class */ function() {
        function Break(codePoints, lineBreak, start, end) {
            this.codePoints = codePoints;
            this.required = lineBreak === BREAK_MANDATORY;
            this.start = start;
            this.end = end;
        }
        Break.prototype.slice = function() {
            return fromCodePoint$1.apply(void 0, this.codePoints.slice(this.start, this.end));
        };
        return Break;
    }();
    var LineBreaker = function(str, options) {
        var codePoints = toCodePoints$1(str);
        var _a = cssFormattedClasses(codePoints, options), indicies = _a[0], classTypes = _a[1], forbiddenBreakpoints = _a[2];
        var length = codePoints.length;
        var lastEnd = 0;
        var nextIndex = 0;
        return {
            next: function() {
                if (nextIndex >= length) return {
                    done: true,
                    value: null
                };
                var lineBreak = BREAK_NOT_ALLOWED$1;
                while(nextIndex < length && (lineBreak = _lineBreakAtIndex(codePoints, classTypes, indicies, ++nextIndex, forbiddenBreakpoints)) === BREAK_NOT_ALLOWED$1);
                if (lineBreak !== BREAK_NOT_ALLOWED$1 || nextIndex === length) {
                    var value = new Break(codePoints, lineBreak, lastEnd, nextIndex);
                    lastEnd = nextIndex;
                    return {
                        value: value,
                        done: false
                    };
                }
                return {
                    done: true,
                    value: null
                };
            }
        };
    };
    // https://www.w3.org/TR/css-syntax-3
    var FLAG_UNRESTRICTED = 1;
    var FLAG_ID = 2;
    var FLAG_INTEGER = 4;
    var FLAG_NUMBER = 8;
    var LINE_FEED = 0x000a;
    var SOLIDUS = 0x002f;
    var REVERSE_SOLIDUS = 0x005c;
    var CHARACTER_TABULATION = 0x0009;
    var SPACE = 0x0020;
    var QUOTATION_MARK = 0x0022;
    var EQUALS_SIGN = 0x003d;
    var NUMBER_SIGN = 0x0023;
    var DOLLAR_SIGN = 0x0024;
    var PERCENTAGE_SIGN = 0x0025;
    var APOSTROPHE = 0x0027;
    var LEFT_PARENTHESIS = 0x0028;
    var RIGHT_PARENTHESIS = 0x0029;
    var LOW_LINE = 0x005f;
    var HYPHEN_MINUS = 0x002d;
    var EXCLAMATION_MARK = 0x0021;
    var LESS_THAN_SIGN = 0x003c;
    var GREATER_THAN_SIGN = 0x003e;
    var COMMERCIAL_AT = 0x0040;
    var LEFT_SQUARE_BRACKET = 0x005b;
    var RIGHT_SQUARE_BRACKET = 0x005d;
    var CIRCUMFLEX_ACCENT = 0x003d;
    var LEFT_CURLY_BRACKET = 0x007b;
    var QUESTION_MARK = 0x003f;
    var RIGHT_CURLY_BRACKET = 0x007d;
    var VERTICAL_LINE = 0x007c;
    var TILDE = 0x007e;
    var CONTROL = 0x0080;
    var REPLACEMENT_CHARACTER = 0xfffd;
    var ASTERISK = 0x002a;
    var PLUS_SIGN = 0x002b;
    var COMMA = 0x002c;
    var COLON = 0x003a;
    var SEMICOLON = 0x003b;
    var FULL_STOP = 0x002e;
    var NULL = 0x0000;
    var BACKSPACE = 0x0008;
    var LINE_TABULATION = 0x000b;
    var SHIFT_OUT = 0x000e;
    var INFORMATION_SEPARATOR_ONE = 0x001f;
    var DELETE = 0x007f;
    var EOF = -1;
    var ZERO = 0x0030;
    var a = 0x0061;
    var e = 0x0065;
    var f = 0x0066;
    var u = 0x0075;
    var z = 0x007a;
    var A = 0x0041;
    var E = 0x0045;
    var F = 0x0046;
    var U = 0x0055;
    var Z = 0x005a;
    var isDigit = function(codePoint) {
        return codePoint >= ZERO && codePoint <= 0x0039;
    };
    var isSurrogateCodePoint = function(codePoint) {
        return codePoint >= 0xd800 && codePoint <= 0xdfff;
    };
    var isHex = function(codePoint) {
        return isDigit(codePoint) || codePoint >= A && codePoint <= F || codePoint >= a && codePoint <= f;
    };
    var isLowerCaseLetter = function(codePoint) {
        return codePoint >= a && codePoint <= z;
    };
    var isUpperCaseLetter = function(codePoint) {
        return codePoint >= A && codePoint <= Z;
    };
    var isLetter = function(codePoint) {
        return isLowerCaseLetter(codePoint) || isUpperCaseLetter(codePoint);
    };
    var isNonASCIICodePoint = function(codePoint) {
        return codePoint >= CONTROL;
    };
    var isWhiteSpace = function(codePoint) {
        return codePoint === LINE_FEED || codePoint === CHARACTER_TABULATION || codePoint === SPACE;
    };
    var isNameStartCodePoint = function(codePoint) {
        return isLetter(codePoint) || isNonASCIICodePoint(codePoint) || codePoint === LOW_LINE;
    };
    var isNameCodePoint = function(codePoint) {
        return isNameStartCodePoint(codePoint) || isDigit(codePoint) || codePoint === HYPHEN_MINUS;
    };
    var isNonPrintableCodePoint = function(codePoint) {
        return codePoint >= NULL && codePoint <= BACKSPACE || codePoint === LINE_TABULATION || codePoint >= SHIFT_OUT && codePoint <= INFORMATION_SEPARATOR_ONE || codePoint === DELETE;
    };
    var isValidEscape = function(c1, c2) {
        if (c1 !== REVERSE_SOLIDUS) return false;
        return c2 !== LINE_FEED;
    };
    var isIdentifierStart = function(c1, c2, c3) {
        if (c1 === HYPHEN_MINUS) return isNameStartCodePoint(c2) || isValidEscape(c2, c3);
        else if (isNameStartCodePoint(c1)) return true;
        else if (c1 === REVERSE_SOLIDUS && isValidEscape(c1, c2)) return true;
        return false;
    };
    var isNumberStart = function(c1, c2, c3) {
        if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
            if (isDigit(c2)) return true;
            return c2 === FULL_STOP && isDigit(c3);
        }
        if (c1 === FULL_STOP) return isDigit(c2);
        return isDigit(c1);
    };
    var stringToNumber = function(codePoints) {
        var c = 0;
        var sign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) sign = -1;
            c++;
        }
        var integers = [];
        while(isDigit(codePoints[c]))integers.push(codePoints[c++]);
        var int = integers.length ? parseInt(fromCodePoint$1.apply(void 0, integers), 10) : 0;
        if (codePoints[c] === FULL_STOP) c++;
        var fraction = [];
        while(isDigit(codePoints[c]))fraction.push(codePoints[c++]);
        var fracd = fraction.length;
        var frac = fracd ? parseInt(fromCodePoint$1.apply(void 0, fraction), 10) : 0;
        if (codePoints[c] === E || codePoints[c] === e) c++;
        var expsign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) expsign = -1;
            c++;
        }
        var exponent = [];
        while(isDigit(codePoints[c]))exponent.push(codePoints[c++]);
        var exp = exponent.length ? parseInt(fromCodePoint$1.apply(void 0, exponent), 10) : 0;
        return sign * (int + frac * Math.pow(10, -fracd)) * Math.pow(10, expsign * exp);
    };
    var LEFT_PARENTHESIS_TOKEN = {
        type: 2 /* LEFT_PARENTHESIS_TOKEN */ 
    };
    var RIGHT_PARENTHESIS_TOKEN = {
        type: 3 /* RIGHT_PARENTHESIS_TOKEN */ 
    };
    var COMMA_TOKEN = {
        type: 4 /* COMMA_TOKEN */ 
    };
    var SUFFIX_MATCH_TOKEN = {
        type: 13 /* SUFFIX_MATCH_TOKEN */ 
    };
    var PREFIX_MATCH_TOKEN = {
        type: 8 /* PREFIX_MATCH_TOKEN */ 
    };
    var COLUMN_TOKEN = {
        type: 21 /* COLUMN_TOKEN */ 
    };
    var DASH_MATCH_TOKEN = {
        type: 9 /* DASH_MATCH_TOKEN */ 
    };
    var INCLUDE_MATCH_TOKEN = {
        type: 10 /* INCLUDE_MATCH_TOKEN */ 
    };
    var LEFT_CURLY_BRACKET_TOKEN = {
        type: 11 /* LEFT_CURLY_BRACKET_TOKEN */ 
    };
    var RIGHT_CURLY_BRACKET_TOKEN = {
        type: 12 /* RIGHT_CURLY_BRACKET_TOKEN */ 
    };
    var SUBSTRING_MATCH_TOKEN = {
        type: 14 /* SUBSTRING_MATCH_TOKEN */ 
    };
    var BAD_URL_TOKEN = {
        type: 23 /* BAD_URL_TOKEN */ 
    };
    var BAD_STRING_TOKEN = {
        type: 1 /* BAD_STRING_TOKEN */ 
    };
    var CDO_TOKEN = {
        type: 25 /* CDO_TOKEN */ 
    };
    var CDC_TOKEN = {
        type: 24 /* CDC_TOKEN */ 
    };
    var COLON_TOKEN = {
        type: 26 /* COLON_TOKEN */ 
    };
    var SEMICOLON_TOKEN = {
        type: 27 /* SEMICOLON_TOKEN */ 
    };
    var LEFT_SQUARE_BRACKET_TOKEN = {
        type: 28 /* LEFT_SQUARE_BRACKET_TOKEN */ 
    };
    var RIGHT_SQUARE_BRACKET_TOKEN = {
        type: 29 /* RIGHT_SQUARE_BRACKET_TOKEN */ 
    };
    var WHITESPACE_TOKEN = {
        type: 31 /* WHITESPACE_TOKEN */ 
    };
    var EOF_TOKEN = {
        type: 32 /* EOF_TOKEN */ 
    };
    var Tokenizer = /** @class */ function() {
        function Tokenizer() {
            this._value = [];
        }
        Tokenizer.prototype.write = function(chunk) {
            this._value = this._value.concat(toCodePoints$1(chunk));
        };
        Tokenizer.prototype.read = function() {
            var tokens = [];
            var token = this.consumeToken();
            while(token !== EOF_TOKEN){
                tokens.push(token);
                token = this.consumeToken();
            }
            return tokens;
        };
        Tokenizer.prototype.consumeToken = function() {
            var codePoint = this.consumeCodePoint();
            switch(codePoint){
                case QUOTATION_MARK:
                    return this.consumeStringToken(QUOTATION_MARK);
                case NUMBER_SIGN:
                    var c1 = this.peekCodePoint(0);
                    var c2 = this.peekCodePoint(1);
                    var c3 = this.peekCodePoint(2);
                    if (isNameCodePoint(c1) || isValidEscape(c2, c3)) {
                        var flags = isIdentifierStart(c1, c2, c3) ? FLAG_ID : FLAG_UNRESTRICTED;
                        var value = this.consumeName();
                        return {
                            type: 5 /* HASH_TOKEN */ ,
                            value: value,
                            flags: flags
                        };
                    }
                    break;
                case DOLLAR_SIGN:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUFFIX_MATCH_TOKEN;
                    }
                    break;
                case APOSTROPHE:
                    return this.consumeStringToken(APOSTROPHE);
                case LEFT_PARENTHESIS:
                    return LEFT_PARENTHESIS_TOKEN;
                case RIGHT_PARENTHESIS:
                    return RIGHT_PARENTHESIS_TOKEN;
                case ASTERISK:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUBSTRING_MATCH_TOKEN;
                    }
                    break;
                case PLUS_SIGN:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case COMMA:
                    return COMMA_TOKEN;
                case HYPHEN_MINUS:
                    var e1 = codePoint;
                    var e2 = this.peekCodePoint(0);
                    var e3 = this.peekCodePoint(1);
                    if (isNumberStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    if (isIdentifierStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    if (e2 === HYPHEN_MINUS && e3 === GREATER_THAN_SIGN) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDC_TOKEN;
                    }
                    break;
                case FULL_STOP:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case SOLIDUS:
                    if (this.peekCodePoint(0) === ASTERISK) {
                        this.consumeCodePoint();
                        while(true){
                            var c = this.consumeCodePoint();
                            if (c === ASTERISK) {
                                c = this.consumeCodePoint();
                                if (c === SOLIDUS) return this.consumeToken();
                            }
                            if (c === EOF) return this.consumeToken();
                        }
                    }
                    break;
                case COLON:
                    return COLON_TOKEN;
                case SEMICOLON:
                    return SEMICOLON_TOKEN;
                case LESS_THAN_SIGN:
                    if (this.peekCodePoint(0) === EXCLAMATION_MARK && this.peekCodePoint(1) === HYPHEN_MINUS && this.peekCodePoint(2) === HYPHEN_MINUS) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDO_TOKEN;
                    }
                    break;
                case COMMERCIAL_AT:
                    var a1 = this.peekCodePoint(0);
                    var a2 = this.peekCodePoint(1);
                    var a3 = this.peekCodePoint(2);
                    if (isIdentifierStart(a1, a2, a3)) {
                        var value = this.consumeName();
                        return {
                            type: 7 /* AT_KEYWORD_TOKEN */ ,
                            value: value
                        };
                    }
                    break;
                case LEFT_SQUARE_BRACKET:
                    return LEFT_SQUARE_BRACKET_TOKEN;
                case REVERSE_SOLIDUS:
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    break;
                case RIGHT_SQUARE_BRACKET:
                    return RIGHT_SQUARE_BRACKET_TOKEN;
                case CIRCUMFLEX_ACCENT:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return PREFIX_MATCH_TOKEN;
                    }
                    break;
                case LEFT_CURLY_BRACKET:
                    return LEFT_CURLY_BRACKET_TOKEN;
                case RIGHT_CURLY_BRACKET:
                    return RIGHT_CURLY_BRACKET_TOKEN;
                case u:
                case U:
                    var u1 = this.peekCodePoint(0);
                    var u2 = this.peekCodePoint(1);
                    if (u1 === PLUS_SIGN && (isHex(u2) || u2 === QUESTION_MARK)) {
                        this.consumeCodePoint();
                        this.consumeUnicodeRangeToken();
                    }
                    this.reconsumeCodePoint(codePoint);
                    return this.consumeIdentLikeToken();
                case VERTICAL_LINE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return DASH_MATCH_TOKEN;
                    }
                    if (this.peekCodePoint(0) === VERTICAL_LINE) {
                        this.consumeCodePoint();
                        return COLUMN_TOKEN;
                    }
                    break;
                case TILDE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return INCLUDE_MATCH_TOKEN;
                    }
                    break;
                case EOF:
                    return EOF_TOKEN;
            }
            if (isWhiteSpace(codePoint)) {
                this.consumeWhiteSpace();
                return WHITESPACE_TOKEN;
            }
            if (isDigit(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeNumericToken();
            }
            if (isNameStartCodePoint(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeIdentLikeToken();
            }
            return {
                type: 6 /* DELIM_TOKEN */ ,
                value: fromCodePoint$1(codePoint)
            };
        };
        Tokenizer.prototype.consumeCodePoint = function() {
            var value = this._value.shift();
            return typeof value === 'undefined' ? -1 : value;
        };
        Tokenizer.prototype.reconsumeCodePoint = function(codePoint) {
            this._value.unshift(codePoint);
        };
        Tokenizer.prototype.peekCodePoint = function(delta) {
            if (delta >= this._value.length) return -1;
            return this._value[delta];
        };
        Tokenizer.prototype.consumeUnicodeRangeToken = function() {
            var digits = [];
            var codePoint = this.consumeCodePoint();
            while(isHex(codePoint) && digits.length < 6){
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
            }
            var questionMarks = false;
            while(codePoint === QUESTION_MARK && digits.length < 6){
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
                questionMarks = true;
            }
            if (questionMarks) {
                var start_1 = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
                    return digit === QUESTION_MARK ? ZERO : digit;
                })), 16);
                var end = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
                    return digit === QUESTION_MARK ? F : digit;
                })), 16);
                return {
                    type: 30 /* UNICODE_RANGE_TOKEN */ ,
                    start: start_1,
                    end: end
                };
            }
            var start = parseInt(fromCodePoint$1.apply(void 0, digits), 16);
            if (this.peekCodePoint(0) === HYPHEN_MINUS && isHex(this.peekCodePoint(1))) {
                this.consumeCodePoint();
                codePoint = this.consumeCodePoint();
                var endDigits = [];
                while(isHex(codePoint) && endDigits.length < 6){
                    endDigits.push(codePoint);
                    codePoint = this.consumeCodePoint();
                }
                var end = parseInt(fromCodePoint$1.apply(void 0, endDigits), 16);
                return {
                    type: 30 /* UNICODE_RANGE_TOKEN */ ,
                    start: start,
                    end: end
                };
            } else return {
                type: 30 /* UNICODE_RANGE_TOKEN */ ,
                start: start,
                end: start
            };
        };
        Tokenizer.prototype.consumeIdentLikeToken = function() {
            var value = this.consumeName();
            if (value.toLowerCase() === 'url' && this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return this.consumeUrlToken();
            } else if (this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return {
                    type: 19 /* FUNCTION_TOKEN */ ,
                    value: value
                };
            }
            return {
                type: 20 /* IDENT_TOKEN */ ,
                value: value
            };
        };
        Tokenizer.prototype.consumeUrlToken = function() {
            var value = [];
            this.consumeWhiteSpace();
            if (this.peekCodePoint(0) === EOF) return {
                type: 22 /* URL_TOKEN */ ,
                value: ''
            };
            var next = this.peekCodePoint(0);
            if (next === APOSTROPHE || next === QUOTATION_MARK) {
                var stringToken = this.consumeStringToken(this.consumeCodePoint());
                if (stringToken.type === 0 /* STRING_TOKEN */ ) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return {
                            type: 22 /* URL_TOKEN */ ,
                            value: stringToken.value
                        };
                    }
                }
                this.consumeBadUrlRemnants();
                return BAD_URL_TOKEN;
            }
            while(true){
                var codePoint = this.consumeCodePoint();
                if (codePoint === EOF || codePoint === RIGHT_PARENTHESIS) return {
                    type: 22 /* URL_TOKEN */ ,
                    value: fromCodePoint$1.apply(void 0, value)
                };
                else if (isWhiteSpace(codePoint)) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return {
                            type: 22 /* URL_TOKEN */ ,
                            value: fromCodePoint$1.apply(void 0, value)
                        };
                    }
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                } else if (codePoint === QUOTATION_MARK || codePoint === APOSTROPHE || codePoint === LEFT_PARENTHESIS || isNonPrintableCodePoint(codePoint)) {
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                } else if (codePoint === REVERSE_SOLIDUS) {
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) value.push(this.consumeEscapedCodePoint());
                    else {
                        this.consumeBadUrlRemnants();
                        return BAD_URL_TOKEN;
                    }
                } else value.push(codePoint);
            }
        };
        Tokenizer.prototype.consumeWhiteSpace = function() {
            while(isWhiteSpace(this.peekCodePoint(0)))this.consumeCodePoint();
        };
        Tokenizer.prototype.consumeBadUrlRemnants = function() {
            while(true){
                var codePoint = this.consumeCodePoint();
                if (codePoint === RIGHT_PARENTHESIS || codePoint === EOF) return;
                if (isValidEscape(codePoint, this.peekCodePoint(0))) this.consumeEscapedCodePoint();
            }
        };
        Tokenizer.prototype.consumeStringSlice = function(count) {
            var SLICE_STACK_SIZE = 50000;
            var value = '';
            while(count > 0){
                var amount = Math.min(SLICE_STACK_SIZE, count);
                value += fromCodePoint$1.apply(void 0, this._value.splice(0, amount));
                count -= amount;
            }
            this._value.shift();
            return value;
        };
        Tokenizer.prototype.consumeStringToken = function(endingCodePoint) {
            var value = '';
            var i = 0;
            do {
                var codePoint = this._value[i];
                if (codePoint === EOF || codePoint === undefined || codePoint === endingCodePoint) {
                    value += this.consumeStringSlice(i);
                    return {
                        type: 0 /* STRING_TOKEN */ ,
                        value: value
                    };
                }
                if (codePoint === LINE_FEED) {
                    this._value.splice(0, i);
                    return BAD_STRING_TOKEN;
                }
                if (codePoint === REVERSE_SOLIDUS) {
                    var next = this._value[i + 1];
                    if (next !== EOF && next !== undefined) {
                        if (next === LINE_FEED) {
                            value += this.consumeStringSlice(i);
                            i = -1;
                            this._value.shift();
                        } else if (isValidEscape(codePoint, next)) {
                            value += this.consumeStringSlice(i);
                            value += fromCodePoint$1(this.consumeEscapedCodePoint());
                            i = -1;
                        }
                    }
                }
                i++;
            }while (true);
        };
        Tokenizer.prototype.consumeNumber = function() {
            var repr = [];
            var type = FLAG_INTEGER;
            var c1 = this.peekCodePoint(0);
            if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) repr.push(this.consumeCodePoint());
            while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            if (c1 === FULL_STOP && isDigit(c2)) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            }
            c1 = this.peekCodePoint(0);
            c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if ((c1 === E || c1 === e) && ((c2 === PLUS_SIGN || c2 === HYPHEN_MINUS) && isDigit(c3) || isDigit(c2))) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            }
            return [
                stringToNumber(repr),
                type
            ];
        };
        Tokenizer.prototype.consumeNumericToken = function() {
            var _a = this.consumeNumber(), number = _a[0], flags = _a[1];
            var c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if (isIdentifierStart(c1, c2, c3)) {
                var unit = this.consumeName();
                return {
                    type: 15 /* DIMENSION_TOKEN */ ,
                    number: number,
                    flags: flags,
                    unit: unit
                };
            }
            if (c1 === PERCENTAGE_SIGN) {
                this.consumeCodePoint();
                return {
                    type: 16 /* PERCENTAGE_TOKEN */ ,
                    number: number,
                    flags: flags
                };
            }
            return {
                type: 17 /* NUMBER_TOKEN */ ,
                number: number,
                flags: flags
            };
        };
        Tokenizer.prototype.consumeEscapedCodePoint = function() {
            var codePoint = this.consumeCodePoint();
            if (isHex(codePoint)) {
                var hex = fromCodePoint$1(codePoint);
                while(isHex(this.peekCodePoint(0)) && hex.length < 6)hex += fromCodePoint$1(this.consumeCodePoint());
                if (isWhiteSpace(this.peekCodePoint(0))) this.consumeCodePoint();
                var hexCodePoint = parseInt(hex, 16);
                if (hexCodePoint === 0 || isSurrogateCodePoint(hexCodePoint) || hexCodePoint > 0x10ffff) return REPLACEMENT_CHARACTER;
                return hexCodePoint;
            }
            if (codePoint === EOF) return REPLACEMENT_CHARACTER;
            return codePoint;
        };
        Tokenizer.prototype.consumeName = function() {
            var result = '';
            while(true){
                var codePoint = this.consumeCodePoint();
                if (isNameCodePoint(codePoint)) result += fromCodePoint$1(codePoint);
                else if (isValidEscape(codePoint, this.peekCodePoint(0))) result += fromCodePoint$1(this.consumeEscapedCodePoint());
                else {
                    this.reconsumeCodePoint(codePoint);
                    return result;
                }
            }
        };
        return Tokenizer;
    }();
    var Parser = /** @class */ function() {
        function Parser(tokens) {
            this._tokens = tokens;
        }
        Parser.create = function(value) {
            var tokenizer = new Tokenizer();
            tokenizer.write(value);
            return new Parser(tokenizer.read());
        };
        Parser.parseValue = function(value) {
            return Parser.create(value).parseComponentValue();
        };
        Parser.parseValues = function(value) {
            return Parser.create(value).parseComponentValues();
        };
        Parser.prototype.parseComponentValue = function() {
            var token = this.consumeToken();
            while(token.type === 31 /* WHITESPACE_TOKEN */ )token = this.consumeToken();
            if (token.type === 32 /* EOF_TOKEN */ ) throw new SyntaxError("Error parsing CSS component value, unexpected EOF");
            this.reconsumeToken(token);
            var value = this.consumeComponentValue();
            do token = this.consumeToken();
            while (token.type === 31 /* WHITESPACE_TOKEN */ );
            if (token.type === 32 /* EOF_TOKEN */ ) return value;
            throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
        };
        Parser.prototype.parseComponentValues = function() {
            var values = [];
            while(true){
                var value = this.consumeComponentValue();
                if (value.type === 32 /* EOF_TOKEN */ ) return values;
                values.push(value);
                values.push();
            }
        };
        Parser.prototype.consumeComponentValue = function() {
            var token = this.consumeToken();
            switch(token.type){
                case 11 /* LEFT_CURLY_BRACKET_TOKEN */ :
                case 28 /* LEFT_SQUARE_BRACKET_TOKEN */ :
                case 2 /* LEFT_PARENTHESIS_TOKEN */ :
                    return this.consumeSimpleBlock(token.type);
                case 19 /* FUNCTION_TOKEN */ :
                    return this.consumeFunction(token);
            }
            return token;
        };
        Parser.prototype.consumeSimpleBlock = function(type) {
            var block = {
                type: type,
                values: []
            };
            var token = this.consumeToken();
            while(true){
                if (token.type === 32 /* EOF_TOKEN */  || isEndingTokenFor(token, type)) return block;
                this.reconsumeToken(token);
                block.values.push(this.consumeComponentValue());
                token = this.consumeToken();
            }
        };
        Parser.prototype.consumeFunction = function(functionToken) {
            var cssFunction = {
                name: functionToken.value,
                values: [],
                type: 18 /* FUNCTION */ 
            };
            while(true){
                var token = this.consumeToken();
                if (token.type === 32 /* EOF_TOKEN */  || token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */ ) return cssFunction;
                this.reconsumeToken(token);
                cssFunction.values.push(this.consumeComponentValue());
            }
        };
        Parser.prototype.consumeToken = function() {
            var token = this._tokens.shift();
            return typeof token === 'undefined' ? EOF_TOKEN : token;
        };
        Parser.prototype.reconsumeToken = function(token) {
            this._tokens.unshift(token);
        };
        return Parser;
    }();
    var isDimensionToken = function(token) {
        return token.type === 15 /* DIMENSION_TOKEN */ ;
    };
    var isNumberToken = function(token) {
        return token.type === 17 /* NUMBER_TOKEN */ ;
    };
    var isIdentToken = function(token) {
        return token.type === 20 /* IDENT_TOKEN */ ;
    };
    var isStringToken = function(token) {
        return token.type === 0 /* STRING_TOKEN */ ;
    };
    var isIdentWithValue = function(token, value) {
        return isIdentToken(token) && token.value === value;
    };
    var nonWhiteSpace = function(token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */ ;
    };
    var nonFunctionArgSeparator = function(token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */  && token.type !== 4 /* COMMA_TOKEN */ ;
    };
    var parseFunctionArgs = function(tokens) {
        var args = [];
        var arg = [];
        tokens.forEach(function(token) {
            if (token.type === 4 /* COMMA_TOKEN */ ) {
                if (arg.length === 0) throw new Error("Error parsing function args, zero tokens for arg");
                args.push(arg);
                arg = [];
                return;
            }
            if (token.type !== 31 /* WHITESPACE_TOKEN */ ) arg.push(token);
        });
        if (arg.length) args.push(arg);
        return args;
    };
    var isEndingTokenFor = function(token, type) {
        if (type === 11 /* LEFT_CURLY_BRACKET_TOKEN */  && token.type === 12 /* RIGHT_CURLY_BRACKET_TOKEN */ ) return true;
        if (type === 28 /* LEFT_SQUARE_BRACKET_TOKEN */  && token.type === 29 /* RIGHT_SQUARE_BRACKET_TOKEN */ ) return true;
        return type === 2 /* LEFT_PARENTHESIS_TOKEN */  && token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */ ;
    };
    var isLength = function(token) {
        return token.type === 17 /* NUMBER_TOKEN */  || token.type === 15 /* DIMENSION_TOKEN */ ;
    };
    var isLengthPercentage = function(token) {
        return token.type === 16 /* PERCENTAGE_TOKEN */  || isLength(token);
    };
    var parseLengthPercentageTuple = function(tokens) {
        return tokens.length > 1 ? [
            tokens[0],
            tokens[1]
        ] : [
            tokens[0]
        ];
    };
    var ZERO_LENGTH = {
        type: 17 /* NUMBER_TOKEN */ ,
        number: 0,
        flags: FLAG_INTEGER
    };
    var FIFTY_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 50,
        flags: FLAG_INTEGER
    };
    var HUNDRED_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 100,
        flags: FLAG_INTEGER
    };
    var getAbsoluteValueForTuple = function(tuple, width, height) {
        var x = tuple[0], y = tuple[1];
        return [
            getAbsoluteValue(x, width),
            getAbsoluteValue(typeof y !== 'undefined' ? y : x, height)
        ];
    };
    var getAbsoluteValue = function(token, parent) {
        if (token.type === 16 /* PERCENTAGE_TOKEN */ ) return token.number / 100 * parent;
        if (isDimensionToken(token)) switch(token.unit){
            case 'rem':
            case 'em':
                return 16 * token.number; // TODO use correct font-size
            case 'px':
            default:
                return token.number;
        }
        return token.number;
    };
    var DEG = 'deg';
    var GRAD = 'grad';
    var RAD = 'rad';
    var TURN = 'turn';
    var angle = {
        name: 'angle',
        parse: function(_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */ ) switch(value.unit){
                case DEG:
                    return Math.PI * value.number / 180;
                case GRAD:
                    return Math.PI / 200 * value.number;
                case RAD:
                    return value.number;
                case TURN:
                    return Math.PI * 2 * value.number;
            }
            throw new Error("Unsupported angle type");
        }
    };
    var isAngle = function(value) {
        if (value.type === 15 /* DIMENSION_TOKEN */ ) {
            if (value.unit === DEG || value.unit === GRAD || value.unit === RAD || value.unit === TURN) return true;
        }
        return false;
    };
    var parseNamedSide = function(tokens) {
        var sideOrCorner = tokens.filter(isIdentToken).map(function(ident) {
            return ident.value;
        }).join(' ');
        switch(sideOrCorner){
            case 'to bottom right':
            case 'to right bottom':
            case 'left top':
            case 'top left':
                return [
                    ZERO_LENGTH,
                    ZERO_LENGTH
                ];
            case 'to top':
            case 'bottom':
                return deg(0);
            case 'to bottom left':
            case 'to left bottom':
            case 'right top':
            case 'top right':
                return [
                    ZERO_LENGTH,
                    HUNDRED_PERCENT
                ];
            case 'to right':
            case 'left':
                return deg(90);
            case 'to top left':
            case 'to left top':
            case 'right bottom':
            case 'bottom right':
                return [
                    HUNDRED_PERCENT,
                    HUNDRED_PERCENT
                ];
            case 'to bottom':
            case 'top':
                return deg(180);
            case 'to top right':
            case 'to right top':
            case 'left bottom':
            case 'bottom left':
                return [
                    HUNDRED_PERCENT,
                    ZERO_LENGTH
                ];
            case 'to left':
            case 'right':
                return deg(270);
        }
        return 0;
    };
    var deg = function(deg) {
        return Math.PI * deg / 180;
    };
    var color$1 = {
        name: 'color',
        parse: function(context, value) {
            if (value.type === 18 /* FUNCTION */ ) {
                var colorFunction = SUPPORTED_COLOR_FUNCTIONS[value.name];
                if (typeof colorFunction === 'undefined') throw new Error("Attempting to parse an unsupported color function \"" + value.name + "\"");
                return colorFunction(context, value.values);
            }
            if (value.type === 5 /* HASH_TOKEN */ ) {
                if (value.value.length === 3) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), 1);
                }
                if (value.value.length === 4) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    var a = value.value.substring(3, 4);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), parseInt(a + a, 16) / 255);
                }
                if (value.value.length === 6) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), 1);
                }
                if (value.value.length === 8) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    var a = value.value.substring(6, 8);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), parseInt(a, 16) / 255);
                }
            }
            if (value.type === 20 /* IDENT_TOKEN */ ) {
                var namedColor = COLORS[value.value.toUpperCase()];
                if (typeof namedColor !== 'undefined') return namedColor;
            }
            return COLORS.TRANSPARENT;
        }
    };
    var isTransparent = function(color) {
        return (0xff & color) === 0;
    };
    var asString = function(color) {
        var alpha = 0xff & color;
        var blue = 0xff & color >> 8;
        var green = 0xff & color >> 16;
        var red = 0xff & color >> 24;
        return alpha < 255 ? "rgba(" + red + "," + green + "," + blue + "," + alpha / 255 + ")" : "rgb(" + red + "," + green + "," + blue + ")";
    };
    var pack = function(r, g, b, a) {
        return (r << 24 | g << 16 | b << 8 | Math.round(a * 255) << 0) >>> 0;
    };
    var getTokenColorValue = function(token, i) {
        if (token.type === 17 /* NUMBER_TOKEN */ ) return token.number;
        if (token.type === 16 /* PERCENTAGE_TOKEN */ ) {
            var max = i === 3 ? 1 : 255;
            return i === 3 ? token.number / 100 * max : Math.round(token.number / 100 * max);
        }
        return 0;
    };
    var rgb = function(_context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        if (tokens.length === 3) {
            var _a = tokens.map(getTokenColorValue), r = _a[0], g = _a[1], b = _a[2];
            return pack(r, g, b, 1);
        }
        if (tokens.length === 4) {
            var _b = tokens.map(getTokenColorValue), r = _b[0], g = _b[1], b = _b[2], a = _b[3];
            return pack(r, g, b, a);
        }
        return 0;
    };
    function hue2rgb(t1, t2, hue) {
        if (hue < 0) hue += 1;
        if (hue >= 1) hue -= 1;
        if (hue < 1 / 6) return (t2 - t1) * hue * 6 + t1;
        else if (hue < 0.5) return t2;
        else if (hue < 2 / 3) return (t2 - t1) * 6 * (2 / 3 - hue) + t1;
        else return t1;
    }
    var hsl = function(context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        var hue = tokens[0], saturation = tokens[1], lightness = tokens[2], alpha = tokens[3];
        var h = (hue.type === 17 /* NUMBER_TOKEN */  ? deg(hue.number) : angle.parse(context, hue)) / (Math.PI * 2);
        var s = isLengthPercentage(saturation) ? saturation.number / 100 : 0;
        var l = isLengthPercentage(lightness) ? lightness.number / 100 : 0;
        var a = typeof alpha !== 'undefined' && isLengthPercentage(alpha) ? getAbsoluteValue(alpha, 1) : 1;
        if (s === 0) return pack(l * 255, l * 255, l * 255, 1);
        var t2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
        var t1 = l * 2 - t2;
        var r = hue2rgb(t1, t2, h + 1 / 3);
        var g = hue2rgb(t1, t2, h);
        var b = hue2rgb(t1, t2, h - 1 / 3);
        return pack(r * 255, g * 255, b * 255, a);
    };
    var SUPPORTED_COLOR_FUNCTIONS = {
        hsl: hsl,
        hsla: hsl,
        rgb: rgb,
        rgba: rgb
    };
    var parseColor = function(context, value) {
        return color$1.parse(context, Parser.create(value).parseComponentValue());
    };
    var COLORS = {
        ALICEBLUE: 0xf0f8ffff,
        ANTIQUEWHITE: 0xfaebd7ff,
        AQUA: 0x00ffffff,
        AQUAMARINE: 0x7fffd4ff,
        AZURE: 0xf0ffffff,
        BEIGE: 0xf5f5dcff,
        BISQUE: 0xffe4c4ff,
        BLACK: 0x000000ff,
        BLANCHEDALMOND: 0xffebcdff,
        BLUE: 0x0000ffff,
        BLUEVIOLET: 0x8a2be2ff,
        BROWN: 0xa52a2aff,
        BURLYWOOD: 0xdeb887ff,
        CADETBLUE: 0x5f9ea0ff,
        CHARTREUSE: 0x7fff00ff,
        CHOCOLATE: 0xd2691eff,
        CORAL: 0xff7f50ff,
        CORNFLOWERBLUE: 0x6495edff,
        CORNSILK: 0xfff8dcff,
        CRIMSON: 0xdc143cff,
        CYAN: 0x00ffffff,
        DARKBLUE: 0x00008bff,
        DARKCYAN: 0x008b8bff,
        DARKGOLDENROD: 0xb886bbff,
        DARKGRAY: 0xa9a9a9ff,
        DARKGREEN: 0x006400ff,
        DARKGREY: 0xa9a9a9ff,
        DARKKHAKI: 0xbdb76bff,
        DARKMAGENTA: 0x8b008bff,
        DARKOLIVEGREEN: 0x556b2fff,
        DARKORANGE: 0xff8c00ff,
        DARKORCHID: 0x9932ccff,
        DARKRED: 0x8b0000ff,
        DARKSALMON: 0xe9967aff,
        DARKSEAGREEN: 0x8fbc8fff,
        DARKSLATEBLUE: 0x483d8bff,
        DARKSLATEGRAY: 0x2f4f4fff,
        DARKSLATEGREY: 0x2f4f4fff,
        DARKTURQUOISE: 0x00ced1ff,
        DARKVIOLET: 0x9400d3ff,
        DEEPPINK: 0xff1493ff,
        DEEPSKYBLUE: 0x00bfffff,
        DIMGRAY: 0x696969ff,
        DIMGREY: 0x696969ff,
        DODGERBLUE: 0x1e90ffff,
        FIREBRICK: 0xb22222ff,
        FLORALWHITE: 0xfffaf0ff,
        FORESTGREEN: 0x228b22ff,
        FUCHSIA: 0xff00ffff,
        GAINSBORO: 0xdcdcdcff,
        GHOSTWHITE: 0xf8f8ffff,
        GOLD: 0xffd700ff,
        GOLDENROD: 0xdaa520ff,
        GRAY: 0x808080ff,
        GREEN: 0x008000ff,
        GREENYELLOW: 0xadff2fff,
        GREY: 0x808080ff,
        HONEYDEW: 0xf0fff0ff,
        HOTPINK: 0xff69b4ff,
        INDIANRED: 0xcd5c5cff,
        INDIGO: 0x4b0082ff,
        IVORY: 0xfffff0ff,
        KHAKI: 0xf0e68cff,
        LAVENDER: 0xe6e6faff,
        LAVENDERBLUSH: 0xfff0f5ff,
        LAWNGREEN: 0x7cfc00ff,
        LEMONCHIFFON: 0xfffacdff,
        LIGHTBLUE: 0xadd8e6ff,
        LIGHTCORAL: 0xf08080ff,
        LIGHTCYAN: 0xe0ffffff,
        LIGHTGOLDENRODYELLOW: 0xfafad2ff,
        LIGHTGRAY: 0xd3d3d3ff,
        LIGHTGREEN: 0x90ee90ff,
        LIGHTGREY: 0xd3d3d3ff,
        LIGHTPINK: 0xffb6c1ff,
        LIGHTSALMON: 0xffa07aff,
        LIGHTSEAGREEN: 0x20b2aaff,
        LIGHTSKYBLUE: 0x87cefaff,
        LIGHTSLATEGRAY: 0x778899ff,
        LIGHTSLATEGREY: 0x778899ff,
        LIGHTSTEELBLUE: 0xb0c4deff,
        LIGHTYELLOW: 0xffffe0ff,
        LIME: 0x00ff00ff,
        LIMEGREEN: 0x32cd32ff,
        LINEN: 0xfaf0e6ff,
        MAGENTA: 0xff00ffff,
        MAROON: 0x800000ff,
        MEDIUMAQUAMARINE: 0x66cdaaff,
        MEDIUMBLUE: 0x0000cdff,
        MEDIUMORCHID: 0xba55d3ff,
        MEDIUMPURPLE: 0x9370dbff,
        MEDIUMSEAGREEN: 0x3cb371ff,
        MEDIUMSLATEBLUE: 0x7b68eeff,
        MEDIUMSPRINGGREEN: 0x00fa9aff,
        MEDIUMTURQUOISE: 0x48d1ccff,
        MEDIUMVIOLETRED: 0xc71585ff,
        MIDNIGHTBLUE: 0x191970ff,
        MINTCREAM: 0xf5fffaff,
        MISTYROSE: 0xffe4e1ff,
        MOCCASIN: 0xffe4b5ff,
        NAVAJOWHITE: 0xffdeadff,
        NAVY: 0x000080ff,
        OLDLACE: 0xfdf5e6ff,
        OLIVE: 0x808000ff,
        OLIVEDRAB: 0x6b8e23ff,
        ORANGE: 0xffa500ff,
        ORANGERED: 0xff4500ff,
        ORCHID: 0xda70d6ff,
        PALEGOLDENROD: 0xeee8aaff,
        PALEGREEN: 0x98fb98ff,
        PALETURQUOISE: 0xafeeeeff,
        PALEVIOLETRED: 0xdb7093ff,
        PAPAYAWHIP: 0xffefd5ff,
        PEACHPUFF: 0xffdab9ff,
        PERU: 0xcd853fff,
        PINK: 0xffc0cbff,
        PLUM: 0xdda0ddff,
        POWDERBLUE: 0xb0e0e6ff,
        PURPLE: 0x800080ff,
        REBECCAPURPLE: 0x663399ff,
        RED: 0xff0000ff,
        ROSYBROWN: 0xbc8f8fff,
        ROYALBLUE: 0x4169e1ff,
        SADDLEBROWN: 0x8b4513ff,
        SALMON: 0xfa8072ff,
        SANDYBROWN: 0xf4a460ff,
        SEAGREEN: 0x2e8b57ff,
        SEASHELL: 0xfff5eeff,
        SIENNA: 0xa0522dff,
        SILVER: 0xc0c0c0ff,
        SKYBLUE: 0x87ceebff,
        SLATEBLUE: 0x6a5acdff,
        SLATEGRAY: 0x708090ff,
        SLATEGREY: 0x708090ff,
        SNOW: 0xfffafaff,
        SPRINGGREEN: 0x00ff7fff,
        STEELBLUE: 0x4682b4ff,
        TAN: 0xd2b48cff,
        TEAL: 0x008080ff,
        THISTLE: 0xd8bfd8ff,
        TOMATO: 0xff6347ff,
        TRANSPARENT: 0x00000000,
        TURQUOISE: 0x40e0d0ff,
        VIOLET: 0xee82eeff,
        WHEAT: 0xf5deb3ff,
        WHITE: 0xffffffff,
        WHITESMOKE: 0xf5f5f5ff,
        YELLOW: 0xffff00ff,
        YELLOWGREEN: 0x9acd32ff
    };
    var backgroundClip = {
        name: 'background-clip',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.map(function(token) {
                if (isIdentToken(token)) switch(token.value){
                    case 'padding-box':
                        return 1 /* PADDING_BOX */ ;
                    case 'content-box':
                        return 2 /* CONTENT_BOX */ ;
                }
                return 0 /* BORDER_BOX */ ;
            });
        }
    };
    var backgroundColor = {
        name: "background-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var parseColorStop = function(context, args) {
        var color = color$1.parse(context, args[0]);
        var stop = args[1];
        return stop && isLengthPercentage(stop) ? {
            color: color,
            stop: stop
        } : {
            color: color,
            stop: null
        };
    };
    var processColorStops = function(stops, lineLength) {
        var first = stops[0];
        var last = stops[stops.length - 1];
        if (first.stop === null) first.stop = ZERO_LENGTH;
        if (last.stop === null) last.stop = HUNDRED_PERCENT;
        var processStops = [];
        var previous = 0;
        for(var i = 0; i < stops.length; i++){
            var stop_1 = stops[i].stop;
            if (stop_1 !== null) {
                var absoluteValue = getAbsoluteValue(stop_1, lineLength);
                if (absoluteValue > previous) processStops.push(absoluteValue);
                else processStops.push(previous);
                previous = absoluteValue;
            } else processStops.push(null);
        }
        var gapBegin = null;
        for(var i = 0; i < processStops.length; i++){
            var stop_2 = processStops[i];
            if (stop_2 === null) {
                if (gapBegin === null) gapBegin = i;
            } else if (gapBegin !== null) {
                var gapLength = i - gapBegin;
                var beforeGap = processStops[gapBegin - 1];
                var gapValue = (stop_2 - beforeGap) / (gapLength + 1);
                for(var g = 1; g <= gapLength; g++)processStops[gapBegin + g - 1] = gapValue * g;
                gapBegin = null;
            }
        }
        return stops.map(function(_a, i) {
            var color = _a.color;
            return {
                color: color,
                stop: Math.max(Math.min(1, processStops[i] / lineLength), 0)
            };
        });
    };
    var getAngleFromCorner = function(corner, width, height) {
        var centerX = width / 2;
        var centerY = height / 2;
        var x = getAbsoluteValue(corner[0], width) - centerX;
        var y = centerY - getAbsoluteValue(corner[1], height);
        return (Math.atan2(y, x) + Math.PI * 2) % (Math.PI * 2);
    };
    var calculateGradientDirection = function(angle, width, height) {
        var radian = typeof angle === 'number' ? angle : getAngleFromCorner(angle, width, height);
        var lineLength = Math.abs(width * Math.sin(radian)) + Math.abs(height * Math.cos(radian));
        var halfWidth = width / 2;
        var halfHeight = height / 2;
        var halfLineLength = lineLength / 2;
        var yDiff = Math.sin(radian - Math.PI / 2) * halfLineLength;
        var xDiff = Math.cos(radian - Math.PI / 2) * halfLineLength;
        return [
            lineLength,
            halfWidth - xDiff,
            halfWidth + xDiff,
            halfHeight - yDiff,
            halfHeight + yDiff
        ];
    };
    var distance = function(a, b) {
        return Math.sqrt(a * a + b * b);
    };
    var findCorner = function(width, height, x, y, closest) {
        var corners = [
            [
                0,
                0
            ],
            [
                0,
                height
            ],
            [
                width,
                0
            ],
            [
                width,
                height
            ]
        ];
        return corners.reduce(function(stat, corner) {
            var cx = corner[0], cy = corner[1];
            var d = distance(x - cx, y - cy);
            if (closest ? d < stat.optimumDistance : d > stat.optimumDistance) return {
                optimumCorner: corner,
                optimumDistance: d
            };
            return stat;
        }, {
            optimumDistance: closest ? Infinity : -Infinity,
            optimumCorner: null
        }).optimumCorner;
    };
    var calculateRadius = function(gradient, x, y, width, height) {
        var rx = 0;
        var ry = 0;
        switch(gradient.size){
            case 0 /* CLOSEST_SIDE */ :
                // The ending shape is sized so that that it exactly meets the side of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, it exactly meets the closest side in each dimension.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.min(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    rx = Math.min(Math.abs(x), Math.abs(x - width));
                    ry = Math.min(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 2 /* CLOSEST_CORNER */ :
                // The ending shape is sized so that that it passes through the corner of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, the ending shape is given the same aspect-ratio it would have if closest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.min(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    // Compute the ratio ry/rx (which is to be the same as for "closest-side")
                    var c = Math.min(Math.abs(y), Math.abs(y - height)) / Math.min(Math.abs(x), Math.abs(x - width));
                    var _a = findCorner(width, height, x, y, true), cx = _a[0], cy = _a[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
            case 1 /* FARTHEST_SIDE */ :
                // Same as closest-side, except the ending shape is sized based on the farthest side(s)
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.max(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    rx = Math.max(Math.abs(x), Math.abs(x - width));
                    ry = Math.max(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 3 /* FARTHEST_CORNER */ :
                // Same as closest-corner, except the ending shape is sized based on the farthest corner.
                // If the shape is an ellipse, the ending shape is given the same aspect ratio it would have if farthest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.max(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    // Compute the ratio ry/rx (which is to be the same as for "farthest-side")
                    var c = Math.max(Math.abs(y), Math.abs(y - height)) / Math.max(Math.abs(x), Math.abs(x - width));
                    var _b = findCorner(width, height, x, y, false), cx = _b[0], cy = _b[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
        }
        if (Array.isArray(gradient.size)) {
            rx = getAbsoluteValue(gradient.size[0], width);
            ry = gradient.size.length === 2 ? getAbsoluteValue(gradient.size[1], height) : rx;
        }
        return [
            rx,
            ry
        ];
    };
    var linearGradient = function(context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */  && firstToken.value === 'to') {
                    angle$1 = parseNamedSide(arg);
                    return;
                } else if (isAngle(firstToken)) {
                    angle$1 = angle.parse(context, firstToken);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */ 
        };
    };
    var prefixLinearGradient = function(context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */  && [
                    'top',
                    'left',
                    'right',
                    'bottom'
                ].indexOf(firstToken.value) !== -1) {
                    angle$1 = parseNamedSide(arg);
                    return;
                } else if (isAngle(firstToken)) {
                    angle$1 = (angle.parse(context, firstToken) + deg(270)) % deg(360);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */ 
        };
    };
    var webkitGradient = function(context, tokens) {
        var angle = deg(180);
        var stops = [];
        var type = 1 /* LINEAR_GRADIENT */ ;
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var firstToken = arg[0];
            if (i === 0) {
                if (isIdentToken(firstToken) && firstToken.value === 'linear') {
                    type = 1 /* LINEAR_GRADIENT */ ;
                    return;
                } else if (isIdentToken(firstToken) && firstToken.value === 'radial') {
                    type = 2 /* RADIAL_GRADIENT */ ;
                    return;
                }
            }
            if (firstToken.type === 18 /* FUNCTION */ ) {
                if (firstToken.name === 'from') {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({
                        stop: ZERO_LENGTH,
                        color: color
                    });
                } else if (firstToken.name === 'to') {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({
                        stop: HUNDRED_PERCENT,
                        color: color
                    });
                } else if (firstToken.name === 'color-stop') {
                    var values = firstToken.values.filter(nonFunctionArgSeparator);
                    if (values.length === 2) {
                        var color = color$1.parse(context, values[1]);
                        var stop_1 = values[0];
                        if (isNumberToken(stop_1)) stops.push({
                            stop: {
                                type: 16 /* PERCENTAGE_TOKEN */ ,
                                number: stop_1.number * 100,
                                flags: stop_1.flags
                            },
                            color: color
                        });
                    }
                }
            }
        });
        return type === 1 /* LINEAR_GRADIENT */  ? {
            angle: (angle + deg(180)) % deg(360),
            stops: stops,
            type: type
        } : {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: type
        };
    };
    var CLOSEST_SIDE = 'closest-side';
    var FARTHEST_SIDE = 'farthest-side';
    var CLOSEST_CORNER = 'closest-corner';
    var FARTHEST_CORNER = 'farthest-corner';
    var CIRCLE = 'circle';
    var ELLIPSE = 'ellipse';
    var COVER = 'cover';
    var CONTAIN = 'contain';
    var radialGradient = function(context, tokens) {
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var isColorStop = true;
            if (i === 0) {
                var isAtPosition_1 = false;
                isColorStop = arg.reduce(function(acc, token) {
                    if (isAtPosition_1) {
                        if (isIdentToken(token)) switch(token.value){
                            case 'center':
                                position.push(FIFTY_PERCENT);
                                return acc;
                            case 'top':
                            case 'left':
                                position.push(ZERO_LENGTH);
                                return acc;
                            case 'right':
                            case 'bottom':
                                position.push(HUNDRED_PERCENT);
                                return acc;
                        }
                        else if (isLengthPercentage(token) || isLength(token)) position.push(token);
                    } else if (isIdentToken(token)) switch(token.value){
                        case CIRCLE:
                            shape = 0 /* CIRCLE */ ;
                            return false;
                        case ELLIPSE:
                            shape = 1 /* ELLIPSE */ ;
                            return false;
                        case 'at':
                            isAtPosition_1 = true;
                            return false;
                        case CLOSEST_SIDE:
                            size = 0 /* CLOSEST_SIDE */ ;
                            return false;
                        case COVER:
                        case FARTHEST_SIDE:
                            size = 1 /* FARTHEST_SIDE */ ;
                            return false;
                        case CONTAIN:
                        case CLOSEST_CORNER:
                            size = 2 /* CLOSEST_CORNER */ ;
                            return false;
                        case FARTHEST_CORNER:
                            size = 3 /* FARTHEST_CORNER */ ;
                            return false;
                    }
                    else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) size = [];
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: 2 /* RADIAL_GRADIENT */ 
        };
    };
    var prefixRadialGradient = function(context, tokens) {
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var isColorStop = true;
            if (i === 0) isColorStop = arg.reduce(function(acc, token) {
                if (isIdentToken(token)) switch(token.value){
                    case 'center':
                        position.push(FIFTY_PERCENT);
                        return false;
                    case 'top':
                    case 'left':
                        position.push(ZERO_LENGTH);
                        return false;
                    case 'right':
                    case 'bottom':
                        position.push(HUNDRED_PERCENT);
                        return false;
                }
                else if (isLengthPercentage(token) || isLength(token)) {
                    position.push(token);
                    return false;
                }
                return acc;
            }, isColorStop);
            else if (i === 1) isColorStop = arg.reduce(function(acc, token) {
                if (isIdentToken(token)) switch(token.value){
                    case CIRCLE:
                        shape = 0 /* CIRCLE */ ;
                        return false;
                    case ELLIPSE:
                        shape = 1 /* ELLIPSE */ ;
                        return false;
                    case CONTAIN:
                    case CLOSEST_SIDE:
                        size = 0 /* CLOSEST_SIDE */ ;
                        return false;
                    case FARTHEST_SIDE:
                        size = 1 /* FARTHEST_SIDE */ ;
                        return false;
                    case CLOSEST_CORNER:
                        size = 2 /* CLOSEST_CORNER */ ;
                        return false;
                    case COVER:
                    case FARTHEST_CORNER:
                        size = 3 /* FARTHEST_CORNER */ ;
                        return false;
                }
                else if (isLength(token) || isLengthPercentage(token)) {
                    if (!Array.isArray(size)) size = [];
                    size.push(token);
                    return false;
                }
                return acc;
            }, isColorStop);
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: 2 /* RADIAL_GRADIENT */ 
        };
    };
    var isLinearGradient = function(background) {
        return background.type === 1 /* LINEAR_GRADIENT */ ;
    };
    var isRadialGradient = function(background) {
        return background.type === 2 /* RADIAL_GRADIENT */ ;
    };
    var image = {
        name: 'image',
        parse: function(context, value) {
            if (value.type === 22 /* URL_TOKEN */ ) {
                var image_1 = {
                    url: value.value,
                    type: 0 /* URL */ 
                };
                context.cache.addImage(value.value);
                return image_1;
            }
            if (value.type === 18 /* FUNCTION */ ) {
                var imageFunction = SUPPORTED_IMAGE_FUNCTIONS[value.name];
                if (typeof imageFunction === 'undefined') throw new Error("Attempting to parse an unsupported image function \"" + value.name + "\"");
                return imageFunction(context, value.values);
            }
            throw new Error("Unsupported image type " + value.type);
        }
    };
    function isSupportedImage(value) {
        return !(value.type === 20 /* IDENT_TOKEN */  && value.value === 'none') && (value.type !== 18 /* FUNCTION */  || !!SUPPORTED_IMAGE_FUNCTIONS[value.name]);
    }
    var SUPPORTED_IMAGE_FUNCTIONS = {
        'linear-gradient': linearGradient,
        '-moz-linear-gradient': prefixLinearGradient,
        '-ms-linear-gradient': prefixLinearGradient,
        '-o-linear-gradient': prefixLinearGradient,
        '-webkit-linear-gradient': prefixLinearGradient,
        'radial-gradient': radialGradient,
        '-moz-radial-gradient': prefixRadialGradient,
        '-ms-radial-gradient': prefixRadialGradient,
        '-o-radial-gradient': prefixRadialGradient,
        '-webkit-radial-gradient': prefixRadialGradient,
        '-webkit-gradient': webkitGradient
    };
    var backgroundImage = {
        name: 'background-image',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 0) return [];
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return [];
            return tokens.filter(function(value) {
                return nonFunctionArgSeparator(value) && isSupportedImage(value);
            }).map(function(value) {
                return image.parse(context, value);
            });
        }
    };
    var backgroundOrigin = {
        name: 'background-origin',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.map(function(token) {
                if (isIdentToken(token)) switch(token.value){
                    case 'padding-box':
                        return 1 /* PADDING_BOX */ ;
                    case 'content-box':
                        return 2 /* CONTENT_BOX */ ;
                }
                return 0 /* BORDER_BOX */ ;
            });
        }
    };
    var backgroundPosition = {
        name: 'background-position',
        initialValue: '0% 0%',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isLengthPercentage);
            }).map(parseLengthPercentageTuple);
        }
    };
    var backgroundRepeat = {
        name: 'background-repeat',
        initialValue: 'repeat',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isIdentToken).map(function(token) {
                    return token.value;
                }).join(' ');
            }).map(parseBackgroundRepeat);
        }
    };
    var parseBackgroundRepeat = function(value) {
        switch(value){
            case 'no-repeat':
                return 1 /* NO_REPEAT */ ;
            case 'repeat-x':
            case 'repeat no-repeat':
                return 2 /* REPEAT_X */ ;
            case 'repeat-y':
            case 'no-repeat repeat':
                return 3 /* REPEAT_Y */ ;
            case 'repeat':
            default:
                return 0 /* REPEAT */ ;
        }
    };
    var BACKGROUND_SIZE;
    (function(BACKGROUND_SIZE) {
        BACKGROUND_SIZE["AUTO"] = "auto";
        BACKGROUND_SIZE["CONTAIN"] = "contain";
        BACKGROUND_SIZE["COVER"] = "cover";
    })(BACKGROUND_SIZE || (BACKGROUND_SIZE = {}));
    var backgroundSize = {
        name: 'background-size',
        initialValue: '0',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isBackgroundSizeInfoToken);
            });
        }
    };
    var isBackgroundSizeInfoToken = function(value) {
        return isIdentToken(value) || isLengthPercentage(value);
    };
    var borderColorForSide = function(side) {
        return {
            name: "border-" + side + "-color",
            initialValue: 'transparent',
            prefix: false,
            type: 3 /* TYPE_VALUE */ ,
            format: 'color'
        };
    };
    var borderTopColor = borderColorForSide('top');
    var borderRightColor = borderColorForSide('right');
    var borderBottomColor = borderColorForSide('bottom');
    var borderLeftColor = borderColorForSide('left');
    var borderRadiusForSide = function(side) {
        return {
            name: "border-radius-" + side,
            initialValue: '0 0',
            prefix: false,
            type: 1 /* LIST */ ,
            parse: function(_context, tokens) {
                return parseLengthPercentageTuple(tokens.filter(isLengthPercentage));
            }
        };
    };
    var borderTopLeftRadius = borderRadiusForSide('top-left');
    var borderTopRightRadius = borderRadiusForSide('top-right');
    var borderBottomRightRadius = borderRadiusForSide('bottom-right');
    var borderBottomLeftRadius = borderRadiusForSide('bottom-left');
    var borderStyleForSide = function(side) {
        return {
            name: "border-" + side + "-style",
            initialValue: 'solid',
            prefix: false,
            type: 2 /* IDENT_VALUE */ ,
            parse: function(_context, style) {
                switch(style){
                    case 'none':
                        return 0 /* NONE */ ;
                    case 'dashed':
                        return 2 /* DASHED */ ;
                    case 'dotted':
                        return 3 /* DOTTED */ ;
                    case 'double':
                        return 4 /* DOUBLE */ ;
                }
                return 1 /* SOLID */ ;
            }
        };
    };
    var borderTopStyle = borderStyleForSide('top');
    var borderRightStyle = borderStyleForSide('right');
    var borderBottomStyle = borderStyleForSide('bottom');
    var borderLeftStyle = borderStyleForSide('left');
    var borderWidthForSide = function(side) {
        return {
            name: "border-" + side + "-width",
            initialValue: '0',
            type: 0 /* VALUE */ ,
            prefix: false,
            parse: function(_context, token) {
                if (isDimensionToken(token)) return token.number;
                return 0;
            }
        };
    };
    var borderTopWidth = borderWidthForSide('top');
    var borderRightWidth = borderWidthForSide('right');
    var borderBottomWidth = borderWidthForSide('bottom');
    var borderLeftWidth = borderWidthForSide('left');
    var color = {
        name: "color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var direction = {
        name: 'direction',
        initialValue: 'ltr',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, direction) {
            switch(direction){
                case 'rtl':
                    return 1 /* RTL */ ;
                case 'ltr':
                default:
                    return 0 /* LTR */ ;
            }
        }
    };
    var display = {
        name: 'display',
        initialValue: 'inline-block',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).reduce(function(bit, token) {
                return bit | parseDisplayValue(token.value);
            }, 0 /* NONE */ );
        }
    };
    var parseDisplayValue = function(display) {
        switch(display){
            case 'block':
            case '-webkit-box':
                return 2 /* BLOCK */ ;
            case 'inline':
                return 4 /* INLINE */ ;
            case 'run-in':
                return 8 /* RUN_IN */ ;
            case 'flow':
                return 16 /* FLOW */ ;
            case 'flow-root':
                return 32 /* FLOW_ROOT */ ;
            case 'table':
                return 64 /* TABLE */ ;
            case 'flex':
            case '-webkit-flex':
                return 128 /* FLEX */ ;
            case 'grid':
            case '-ms-grid':
                return 256 /* GRID */ ;
            case 'ruby':
                return 512 /* RUBY */ ;
            case 'subgrid':
                return 1024 /* SUBGRID */ ;
            case 'list-item':
                return 2048 /* LIST_ITEM */ ;
            case 'table-row-group':
                return 4096 /* TABLE_ROW_GROUP */ ;
            case 'table-header-group':
                return 8192 /* TABLE_HEADER_GROUP */ ;
            case 'table-footer-group':
                return 16384 /* TABLE_FOOTER_GROUP */ ;
            case 'table-row':
                return 32768 /* TABLE_ROW */ ;
            case 'table-cell':
                return 65536 /* TABLE_CELL */ ;
            case 'table-column-group':
                return 131072 /* TABLE_COLUMN_GROUP */ ;
            case 'table-column':
                return 262144 /* TABLE_COLUMN */ ;
            case 'table-caption':
                return 524288 /* TABLE_CAPTION */ ;
            case 'ruby-base':
                return 1048576 /* RUBY_BASE */ ;
            case 'ruby-text':
                return 2097152 /* RUBY_TEXT */ ;
            case 'ruby-base-container':
                return 4194304 /* RUBY_BASE_CONTAINER */ ;
            case 'ruby-text-container':
                return 8388608 /* RUBY_TEXT_CONTAINER */ ;
            case 'contents':
                return 16777216 /* CONTENTS */ ;
            case 'inline-block':
                return 33554432 /* INLINE_BLOCK */ ;
            case 'inline-list-item':
                return 67108864 /* INLINE_LIST_ITEM */ ;
            case 'inline-table':
                return 134217728 /* INLINE_TABLE */ ;
            case 'inline-flex':
                return 268435456 /* INLINE_FLEX */ ;
            case 'inline-grid':
                return 536870912 /* INLINE_GRID */ ;
        }
        return 0 /* NONE */ ;
    };
    var float = {
        name: 'float',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, float) {
            switch(float){
                case 'left':
                    return 1 /* LEFT */ ;
                case 'right':
                    return 2 /* RIGHT */ ;
                case 'inline-start':
                    return 3 /* INLINE_START */ ;
                case 'inline-end':
                    return 4 /* INLINE_END */ ;
            }
            return 0 /* NONE */ ;
        }
    };
    var letterSpacing = {
        name: 'letter-spacing',
        initialValue: '0',
        prefix: false,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === 'normal') return 0;
            if (token.type === 17 /* NUMBER_TOKEN */ ) return token.number;
            if (token.type === 15 /* DIMENSION_TOKEN */ ) return token.number;
            return 0;
        }
    };
    var LINE_BREAK;
    (function(LINE_BREAK) {
        LINE_BREAK["NORMAL"] = "normal";
        LINE_BREAK["STRICT"] = "strict";
    })(LINE_BREAK || (LINE_BREAK = {}));
    var lineBreak = {
        name: 'line-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, lineBreak) {
            switch(lineBreak){
                case 'strict':
                    return LINE_BREAK.STRICT;
                case 'normal':
                default:
                    return LINE_BREAK.NORMAL;
            }
        }
    };
    var lineHeight = {
        name: 'line-height',
        initialValue: 'normal',
        prefix: false,
        type: 4 /* TOKEN_VALUE */ 
    };
    var computeLineHeight = function(token, fontSize) {
        if (isIdentToken(token) && token.value === 'normal') return 1.2 * fontSize;
        else if (token.type === 17 /* NUMBER_TOKEN */ ) return fontSize * token.number;
        else if (isLengthPercentage(token)) return getAbsoluteValue(token, fontSize);
        return fontSize;
    };
    var listStyleImage = {
        name: 'list-style-image',
        initialValue: 'none',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === 'none') return null;
            return image.parse(context, token);
        }
    };
    var listStylePosition = {
        name: 'list-style-position',
        initialValue: 'outside',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, position) {
            switch(position){
                case 'inside':
                    return 0 /* INSIDE */ ;
                case 'outside':
                default:
                    return 1 /* OUTSIDE */ ;
            }
        }
    };
    var listStyleType = {
        name: 'list-style-type',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, type) {
            switch(type){
                case 'disc':
                    return 0 /* DISC */ ;
                case 'circle':
                    return 1 /* CIRCLE */ ;
                case 'square':
                    return 2 /* SQUARE */ ;
                case 'decimal':
                    return 3 /* DECIMAL */ ;
                case 'cjk-decimal':
                    return 4 /* CJK_DECIMAL */ ;
                case 'decimal-leading-zero':
                    return 5 /* DECIMAL_LEADING_ZERO */ ;
                case 'lower-roman':
                    return 6 /* LOWER_ROMAN */ ;
                case 'upper-roman':
                    return 7 /* UPPER_ROMAN */ ;
                case 'lower-greek':
                    return 8 /* LOWER_GREEK */ ;
                case 'lower-alpha':
                    return 9 /* LOWER_ALPHA */ ;
                case 'upper-alpha':
                    return 10 /* UPPER_ALPHA */ ;
                case 'arabic-indic':
                    return 11 /* ARABIC_INDIC */ ;
                case 'armenian':
                    return 12 /* ARMENIAN */ ;
                case 'bengali':
                    return 13 /* BENGALI */ ;
                case 'cambodian':
                    return 14 /* CAMBODIAN */ ;
                case 'cjk-earthly-branch':
                    return 15 /* CJK_EARTHLY_BRANCH */ ;
                case 'cjk-heavenly-stem':
                    return 16 /* CJK_HEAVENLY_STEM */ ;
                case 'cjk-ideographic':
                    return 17 /* CJK_IDEOGRAPHIC */ ;
                case 'devanagari':
                    return 18 /* DEVANAGARI */ ;
                case 'ethiopic-numeric':
                    return 19 /* ETHIOPIC_NUMERIC */ ;
                case 'georgian':
                    return 20 /* GEORGIAN */ ;
                case 'gujarati':
                    return 21 /* GUJARATI */ ;
                case 'gurmukhi':
                    return 22 /* GURMUKHI */ ;
                case 'hebrew':
                    return 22 /* HEBREW */ ;
                case 'hiragana':
                    return 23 /* HIRAGANA */ ;
                case 'hiragana-iroha':
                    return 24 /* HIRAGANA_IROHA */ ;
                case 'japanese-formal':
                    return 25 /* JAPANESE_FORMAL */ ;
                case 'japanese-informal':
                    return 26 /* JAPANESE_INFORMAL */ ;
                case 'kannada':
                    return 27 /* KANNADA */ ;
                case 'katakana':
                    return 28 /* KATAKANA */ ;
                case 'katakana-iroha':
                    return 29 /* KATAKANA_IROHA */ ;
                case 'khmer':
                    return 30 /* KHMER */ ;
                case 'korean-hangul-formal':
                    return 31 /* KOREAN_HANGUL_FORMAL */ ;
                case 'korean-hanja-formal':
                    return 32 /* KOREAN_HANJA_FORMAL */ ;
                case 'korean-hanja-informal':
                    return 33 /* KOREAN_HANJA_INFORMAL */ ;
                case 'lao':
                    return 34 /* LAO */ ;
                case 'lower-armenian':
                    return 35 /* LOWER_ARMENIAN */ ;
                case 'malayalam':
                    return 36 /* MALAYALAM */ ;
                case 'mongolian':
                    return 37 /* MONGOLIAN */ ;
                case 'myanmar':
                    return 38 /* MYANMAR */ ;
                case 'oriya':
                    return 39 /* ORIYA */ ;
                case 'persian':
                    return 40 /* PERSIAN */ ;
                case 'simp-chinese-formal':
                    return 41 /* SIMP_CHINESE_FORMAL */ ;
                case 'simp-chinese-informal':
                    return 42 /* SIMP_CHINESE_INFORMAL */ ;
                case 'tamil':
                    return 43 /* TAMIL */ ;
                case 'telugu':
                    return 44 /* TELUGU */ ;
                case 'thai':
                    return 45 /* THAI */ ;
                case 'tibetan':
                    return 46 /* TIBETAN */ ;
                case 'trad-chinese-formal':
                    return 47 /* TRAD_CHINESE_FORMAL */ ;
                case 'trad-chinese-informal':
                    return 48 /* TRAD_CHINESE_INFORMAL */ ;
                case 'upper-armenian':
                    return 49 /* UPPER_ARMENIAN */ ;
                case 'disclosure-open':
                    return 50 /* DISCLOSURE_OPEN */ ;
                case 'disclosure-closed':
                    return 51 /* DISCLOSURE_CLOSED */ ;
                case 'none':
                default:
                    return -1 /* NONE */ ;
            }
        }
    };
    var marginForSide = function(side) {
        return {
            name: "margin-" + side,
            initialValue: '0',
            prefix: false,
            type: 4 /* TOKEN_VALUE */ 
        };
    };
    var marginTop = marginForSide('top');
    var marginRight = marginForSide('right');
    var marginBottom = marginForSide('bottom');
    var marginLeft = marginForSide('left');
    var overflow = {
        name: 'overflow',
        initialValue: 'visible',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(overflow) {
                switch(overflow.value){
                    case 'hidden':
                        return 1 /* HIDDEN */ ;
                    case 'scroll':
                        return 2 /* SCROLL */ ;
                    case 'clip':
                        return 3 /* CLIP */ ;
                    case 'auto':
                        return 4 /* AUTO */ ;
                    case 'visible':
                    default:
                        return 0 /* VISIBLE */ ;
                }
            });
        }
    };
    var overflowWrap = {
        name: 'overflow-wrap',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, overflow) {
            switch(overflow){
                case 'break-word':
                    return "break-word" /* BREAK_WORD */ ;
                case 'normal':
                default:
                    return "normal" /* NORMAL */ ;
            }
        }
    };
    var paddingForSide = function(side) {
        return {
            name: "padding-" + side,
            initialValue: '0',
            prefix: false,
            type: 3 /* TYPE_VALUE */ ,
            format: 'length-percentage'
        };
    };
    var paddingTop = paddingForSide('top');
    var paddingRight = paddingForSide('right');
    var paddingBottom = paddingForSide('bottom');
    var paddingLeft = paddingForSide('left');
    var textAlign = {
        name: 'text-align',
        initialValue: 'left',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, textAlign) {
            switch(textAlign){
                case 'right':
                    return 2 /* RIGHT */ ;
                case 'center':
                case 'justify':
                    return 1 /* CENTER */ ;
                case 'left':
                default:
                    return 0 /* LEFT */ ;
            }
        }
    };
    var position = {
        name: 'position',
        initialValue: 'static',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, position) {
            switch(position){
                case 'relative':
                    return 1 /* RELATIVE */ ;
                case 'absolute':
                    return 2 /* ABSOLUTE */ ;
                case 'fixed':
                    return 3 /* FIXED */ ;
                case 'sticky':
                    return 4 /* STICKY */ ;
            }
            return 0 /* STATIC */ ;
        }
    };
    var textShadow = {
        name: 'text-shadow',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) return [];
            return parseFunctionArgs(tokens).map(function(values) {
                var shadow = {
                    color: COLORS.TRANSPARENT,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH
                };
                var c = 0;
                for(var i = 0; i < values.length; i++){
                    var token = values[i];
                    if (isLength(token)) {
                        if (c === 0) shadow.offsetX = token;
                        else if (c === 1) shadow.offsetY = token;
                        else shadow.blur = token;
                        c++;
                    } else shadow.color = color$1.parse(context, token);
                }
                return shadow;
            });
        }
    };
    var textTransform = {
        name: 'text-transform',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, textTransform) {
            switch(textTransform){
                case 'uppercase':
                    return 2 /* UPPERCASE */ ;
                case 'lowercase':
                    return 1 /* LOWERCASE */ ;
                case 'capitalize':
                    return 3 /* CAPITALIZE */ ;
            }
            return 0 /* NONE */ ;
        }
    };
    var transform$1 = {
        name: 'transform',
        initialValue: 'none',
        prefix: true,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === 'none') return null;
            if (token.type === 18 /* FUNCTION */ ) {
                var transformFunction = SUPPORTED_TRANSFORM_FUNCTIONS[token.name];
                if (typeof transformFunction === 'undefined') throw new Error("Attempting to parse an unsupported transform function \"" + token.name + "\"");
                return transformFunction(token.values);
            }
            return null;
        }
    };
    var matrix = function(args) {
        var values = args.filter(function(arg) {
            return arg.type === 17 /* NUMBER_TOKEN */ ;
        }).map(function(arg) {
            return arg.number;
        });
        return values.length === 6 ? values : null;
    };
    // doesn't support 3D transforms at the moment
    var matrix3d = function(args) {
        var values = args.filter(function(arg) {
            return arg.type === 17 /* NUMBER_TOKEN */ ;
        }).map(function(arg) {
            return arg.number;
        });
        var a1 = values[0], b1 = values[1];
        values[2];
        values[3];
        var a2 = values[4], b2 = values[5];
        values[6];
        values[7];
        values[8];
        values[9];
        values[10];
        values[11];
        var a4 = values[12], b4 = values[13];
        values[14];
        values[15];
        return values.length === 16 ? [
            a1,
            b1,
            a2,
            b2,
            a4,
            b4
        ] : null;
    };
    var SUPPORTED_TRANSFORM_FUNCTIONS = {
        matrix: matrix,
        matrix3d: matrix3d
    };
    var DEFAULT_VALUE = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 50,
        flags: FLAG_INTEGER
    };
    var DEFAULT = [
        DEFAULT_VALUE,
        DEFAULT_VALUE
    ];
    var transformOrigin = {
        name: 'transform-origin',
        initialValue: '50% 50%',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var origins = tokens.filter(isLengthPercentage);
            if (origins.length !== 2) return DEFAULT;
            return [
                origins[0],
                origins[1]
            ];
        }
    };
    var visibility = {
        name: 'visible',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, visibility) {
            switch(visibility){
                case 'hidden':
                    return 1 /* HIDDEN */ ;
                case 'collapse':
                    return 2 /* COLLAPSE */ ;
                case 'visible':
                default:
                    return 0 /* VISIBLE */ ;
            }
        }
    };
    var WORD_BREAK;
    (function(WORD_BREAK) {
        WORD_BREAK["NORMAL"] = "normal";
        WORD_BREAK["BREAK_ALL"] = "break-all";
        WORD_BREAK["KEEP_ALL"] = "keep-all";
    })(WORD_BREAK || (WORD_BREAK = {}));
    var wordBreak = {
        name: 'word-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, wordBreak) {
            switch(wordBreak){
                case 'break-all':
                    return WORD_BREAK.BREAK_ALL;
                case 'keep-all':
                    return WORD_BREAK.KEEP_ALL;
                case 'normal':
                default:
                    return WORD_BREAK.NORMAL;
            }
        }
    };
    var zIndex = {
        name: 'z-index',
        initialValue: 'auto',
        prefix: false,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ ) return {
                auto: true,
                order: 0
            };
            if (isNumberToken(token)) return {
                auto: false,
                order: token.number
            };
            throw new Error("Invalid z-index number parsed");
        }
    };
    var time = {
        name: 'time',
        parse: function(_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */ ) switch(value.unit.toLowerCase()){
                case 's':
                    return 1000 * value.number;
                case 'ms':
                    return value.number;
            }
            throw new Error("Unsupported time type");
        }
    };
    var opacity = {
        name: 'opacity',
        initialValue: '1',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isNumberToken(token)) return token.number;
            return 1;
        }
    };
    var textDecorationColor = {
        name: "text-decoration-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var textDecorationLine = {
        name: 'text-decoration-line',
        initialValue: 'none',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(token) {
                switch(token.value){
                    case 'underline':
                        return 1 /* UNDERLINE */ ;
                    case 'overline':
                        return 2 /* OVERLINE */ ;
                    case 'line-through':
                        return 3 /* LINE_THROUGH */ ;
                    case 'none':
                        return 4 /* BLINK */ ;
                }
                return 0 /* NONE */ ;
            }).filter(function(line) {
                return line !== 0 /* NONE */ ;
            });
        }
    };
    var fontFamily = {
        name: "font-family",
        initialValue: '',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var accumulator = [];
            var results = [];
            tokens.forEach(function(token) {
                switch(token.type){
                    case 20 /* IDENT_TOKEN */ :
                    case 0 /* STRING_TOKEN */ :
                        accumulator.push(token.value);
                        break;
                    case 17 /* NUMBER_TOKEN */ :
                        accumulator.push(token.number.toString());
                        break;
                    case 4 /* COMMA_TOKEN */ :
                        results.push(accumulator.join(' '));
                        accumulator.length = 0;
                        break;
                }
            });
            if (accumulator.length) results.push(accumulator.join(' '));
            return results.map(function(result) {
                return result.indexOf(' ') === -1 ? result : "'" + result + "'";
            });
        }
    };
    var fontSize = {
        name: "font-size",
        initialValue: '0',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'length'
    };
    var fontWeight = {
        name: 'font-weight',
        initialValue: 'normal',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isNumberToken(token)) return token.number;
            if (isIdentToken(token)) switch(token.value){
                case 'bold':
                    return 700;
                case 'normal':
                default:
                    return 400;
            }
            return 400;
        }
    };
    var fontVariant = {
        name: 'font-variant',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(token) {
                return token.value;
            });
        }
    };
    var fontStyle = {
        name: 'font-style',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, overflow) {
            switch(overflow){
                case 'oblique':
                    return "oblique" /* OBLIQUE */ ;
                case 'italic':
                    return "italic" /* ITALIC */ ;
                case 'normal':
                default:
                    return "normal" /* NORMAL */ ;
            }
        }
    };
    var contains = function(bit, value) {
        return (bit & value) !== 0;
    };
    var content = {
        name: 'content',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return [];
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return [];
            return tokens;
        }
    };
    var counterIncrement = {
        name: 'counter-increment',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return null;
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return null;
            var increments = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for(var i = 0; i < filtered.length; i++){
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (counter.type === 20 /* IDENT_TOKEN */ ) {
                    var increment = next && isNumberToken(next) ? next.number : 1;
                    increments.push({
                        counter: counter.value,
                        increment: increment
                    });
                }
            }
            return increments;
        }
    };
    var counterReset = {
        name: 'counter-reset',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return [];
            var resets = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for(var i = 0; i < filtered.length; i++){
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (isIdentToken(counter) && counter.value !== 'none') {
                    var reset = next && isNumberToken(next) ? next.number : 0;
                    resets.push({
                        counter: counter.value,
                        reset: reset
                    });
                }
            }
            return resets;
        }
    };
    var duration = {
        name: 'duration',
        initialValue: '0s',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(context, tokens) {
            return tokens.filter(isDimensionToken).map(function(token) {
                return time.parse(context, token);
            });
        }
    };
    var quotes = {
        name: 'quotes',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return null;
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return null;
            var quotes = [];
            var filtered = tokens.filter(isStringToken);
            if (filtered.length % 2 !== 0) return null;
            for(var i = 0; i < filtered.length; i += 2){
                var open_1 = filtered[i].value;
                var close_1 = filtered[i + 1].value;
                quotes.push({
                    open: open_1,
                    close: close_1
                });
            }
            return quotes;
        }
    };
    var getQuote = function(quotes, depth, open) {
        if (!quotes) return '';
        var quote = quotes[Math.min(depth, quotes.length - 1)];
        if (!quote) return '';
        return open ? quote.open : quote.close;
    };
    var boxShadow = {
        name: 'box-shadow',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) return [];
            return parseFunctionArgs(tokens).map(function(values) {
                var shadow = {
                    color: 0x000000ff,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH,
                    spread: ZERO_LENGTH,
                    inset: false
                };
                var c = 0;
                for(var i = 0; i < values.length; i++){
                    var token = values[i];
                    if (isIdentWithValue(token, 'inset')) shadow.inset = true;
                    else if (isLength(token)) {
                        if (c === 0) shadow.offsetX = token;
                        else if (c === 1) shadow.offsetY = token;
                        else if (c === 2) shadow.blur = token;
                        else shadow.spread = token;
                        c++;
                    } else shadow.color = color$1.parse(context, token);
                }
                return shadow;
            });
        }
    };
    var paintOrder = {
        name: 'paint-order',
        initialValue: 'normal',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var DEFAULT_VALUE = [
                0 /* FILL */ ,
                1 /* STROKE */ ,
                2 /* MARKERS */ 
            ];
            var layers = [];
            tokens.filter(isIdentToken).forEach(function(token) {
                switch(token.value){
                    case 'stroke':
                        layers.push(1 /* STROKE */ );
                        break;
                    case 'fill':
                        layers.push(0 /* FILL */ );
                        break;
                    case 'markers':
                        layers.push(2 /* MARKERS */ );
                        break;
                }
            });
            DEFAULT_VALUE.forEach(function(value) {
                if (layers.indexOf(value) === -1) layers.push(value);
            });
            return layers;
        }
    };
    var webkitTextStrokeColor = {
        name: "-webkit-text-stroke-color",
        initialValue: 'currentcolor',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var webkitTextStrokeWidth = {
        name: "-webkit-text-stroke-width",
        initialValue: '0',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isDimensionToken(token)) return token.number;
            return 0;
        }
    };
    var CSSParsedDeclaration = /** @class */ function() {
        function CSSParsedDeclaration(context, declaration) {
            var _a, _b;
            this.animationDuration = parse(context, duration, declaration.animationDuration);
            this.backgroundClip = parse(context, backgroundClip, declaration.backgroundClip);
            this.backgroundColor = parse(context, backgroundColor, declaration.backgroundColor);
            this.backgroundImage = parse(context, backgroundImage, declaration.backgroundImage);
            this.backgroundOrigin = parse(context, backgroundOrigin, declaration.backgroundOrigin);
            this.backgroundPosition = parse(context, backgroundPosition, declaration.backgroundPosition);
            this.backgroundRepeat = parse(context, backgroundRepeat, declaration.backgroundRepeat);
            this.backgroundSize = parse(context, backgroundSize, declaration.backgroundSize);
            this.borderTopColor = parse(context, borderTopColor, declaration.borderTopColor);
            this.borderRightColor = parse(context, borderRightColor, declaration.borderRightColor);
            this.borderBottomColor = parse(context, borderBottomColor, declaration.borderBottomColor);
            this.borderLeftColor = parse(context, borderLeftColor, declaration.borderLeftColor);
            this.borderTopLeftRadius = parse(context, borderTopLeftRadius, declaration.borderTopLeftRadius);
            this.borderTopRightRadius = parse(context, borderTopRightRadius, declaration.borderTopRightRadius);
            this.borderBottomRightRadius = parse(context, borderBottomRightRadius, declaration.borderBottomRightRadius);
            this.borderBottomLeftRadius = parse(context, borderBottomLeftRadius, declaration.borderBottomLeftRadius);
            this.borderTopStyle = parse(context, borderTopStyle, declaration.borderTopStyle);
            this.borderRightStyle = parse(context, borderRightStyle, declaration.borderRightStyle);
            this.borderBottomStyle = parse(context, borderBottomStyle, declaration.borderBottomStyle);
            this.borderLeftStyle = parse(context, borderLeftStyle, declaration.borderLeftStyle);
            this.borderTopWidth = parse(context, borderTopWidth, declaration.borderTopWidth);
            this.borderRightWidth = parse(context, borderRightWidth, declaration.borderRightWidth);
            this.borderBottomWidth = parse(context, borderBottomWidth, declaration.borderBottomWidth);
            this.borderLeftWidth = parse(context, borderLeftWidth, declaration.borderLeftWidth);
            this.boxShadow = parse(context, boxShadow, declaration.boxShadow);
            this.color = parse(context, color, declaration.color);
            this.direction = parse(context, direction, declaration.direction);
            this.display = parse(context, display, declaration.display);
            this.float = parse(context, float, declaration.cssFloat);
            this.fontFamily = parse(context, fontFamily, declaration.fontFamily);
            this.fontSize = parse(context, fontSize, declaration.fontSize);
            this.fontStyle = parse(context, fontStyle, declaration.fontStyle);
            this.fontVariant = parse(context, fontVariant, declaration.fontVariant);
            this.fontWeight = parse(context, fontWeight, declaration.fontWeight);
            this.letterSpacing = parse(context, letterSpacing, declaration.letterSpacing);
            this.lineBreak = parse(context, lineBreak, declaration.lineBreak);
            this.lineHeight = parse(context, lineHeight, declaration.lineHeight);
            this.listStyleImage = parse(context, listStyleImage, declaration.listStyleImage);
            this.listStylePosition = parse(context, listStylePosition, declaration.listStylePosition);
            this.listStyleType = parse(context, listStyleType, declaration.listStyleType);
            this.marginTop = parse(context, marginTop, declaration.marginTop);
            this.marginRight = parse(context, marginRight, declaration.marginRight);
            this.marginBottom = parse(context, marginBottom, declaration.marginBottom);
            this.marginLeft = parse(context, marginLeft, declaration.marginLeft);
            this.opacity = parse(context, opacity, declaration.opacity);
            var overflowTuple = parse(context, overflow, declaration.overflow);
            this.overflowX = overflowTuple[0];
            this.overflowY = overflowTuple[overflowTuple.length > 1 ? 1 : 0];
            this.overflowWrap = parse(context, overflowWrap, declaration.overflowWrap);
            this.paddingTop = parse(context, paddingTop, declaration.paddingTop);
            this.paddingRight = parse(context, paddingRight, declaration.paddingRight);
            this.paddingBottom = parse(context, paddingBottom, declaration.paddingBottom);
            this.paddingLeft = parse(context, paddingLeft, declaration.paddingLeft);
            this.paintOrder = parse(context, paintOrder, declaration.paintOrder);
            this.position = parse(context, position, declaration.position);
            this.textAlign = parse(context, textAlign, declaration.textAlign);
            this.textDecorationColor = parse(context, textDecorationColor, (_a = declaration.textDecorationColor) !== null && _a !== void 0 ? _a : declaration.color);
            this.textDecorationLine = parse(context, textDecorationLine, (_b = declaration.textDecorationLine) !== null && _b !== void 0 ? _b : declaration.textDecoration);
            this.textShadow = parse(context, textShadow, declaration.textShadow);
            this.textTransform = parse(context, textTransform, declaration.textTransform);
            this.transform = parse(context, transform$1, declaration.transform);
            this.transformOrigin = parse(context, transformOrigin, declaration.transformOrigin);
            this.visibility = parse(context, visibility, declaration.visibility);
            this.webkitTextStrokeColor = parse(context, webkitTextStrokeColor, declaration.webkitTextStrokeColor);
            this.webkitTextStrokeWidth = parse(context, webkitTextStrokeWidth, declaration.webkitTextStrokeWidth);
            this.wordBreak = parse(context, wordBreak, declaration.wordBreak);
            this.zIndex = parse(context, zIndex, declaration.zIndex);
        }
        CSSParsedDeclaration.prototype.isVisible = function() {
            return this.display > 0 && this.opacity > 0 && this.visibility === 0 /* VISIBLE */ ;
        };
        CSSParsedDeclaration.prototype.isTransparent = function() {
            return isTransparent(this.backgroundColor);
        };
        CSSParsedDeclaration.prototype.isTransformed = function() {
            return this.transform !== null;
        };
        CSSParsedDeclaration.prototype.isPositioned = function() {
            return this.position !== 0 /* STATIC */ ;
        };
        CSSParsedDeclaration.prototype.isPositionedWithZIndex = function() {
            return this.isPositioned() && !this.zIndex.auto;
        };
        CSSParsedDeclaration.prototype.isFloating = function() {
            return this.float !== 0 /* NONE */ ;
        };
        CSSParsedDeclaration.prototype.isInlineLevel = function() {
            return contains(this.display, 4 /* INLINE */ ) || contains(this.display, 33554432 /* INLINE_BLOCK */ ) || contains(this.display, 268435456 /* INLINE_FLEX */ ) || contains(this.display, 536870912 /* INLINE_GRID */ ) || contains(this.display, 67108864 /* INLINE_LIST_ITEM */ ) || contains(this.display, 134217728 /* INLINE_TABLE */ );
        };
        return CSSParsedDeclaration;
    }();
    var CSSParsedPseudoDeclaration = /** @class */ function() {
        function CSSParsedPseudoDeclaration(context, declaration) {
            this.content = parse(context, content, declaration.content);
            this.quotes = parse(context, quotes, declaration.quotes);
        }
        return CSSParsedPseudoDeclaration;
    }();
    var CSSParsedCounterDeclaration = /** @class */ function() {
        function CSSParsedCounterDeclaration(context, declaration) {
            this.counterIncrement = parse(context, counterIncrement, declaration.counterIncrement);
            this.counterReset = parse(context, counterReset, declaration.counterReset);
        }
        return CSSParsedCounterDeclaration;
    }();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var parse = function(context, descriptor, style) {
        var tokenizer = new Tokenizer();
        var value = style !== null && typeof style !== 'undefined' ? style.toString() : descriptor.initialValue;
        tokenizer.write(value);
        var parser = new Parser(tokenizer.read());
        switch(descriptor.type){
            case 2 /* IDENT_VALUE */ :
                var token = parser.parseComponentValue();
                return descriptor.parse(context, isIdentToken(token) ? token.value : descriptor.initialValue);
            case 0 /* VALUE */ :
                return descriptor.parse(context, parser.parseComponentValue());
            case 1 /* LIST */ :
                return descriptor.parse(context, parser.parseComponentValues());
            case 4 /* TOKEN_VALUE */ :
                return parser.parseComponentValue();
            case 3 /* TYPE_VALUE */ :
                switch(descriptor.format){
                    case 'angle':
                        return angle.parse(context, parser.parseComponentValue());
                    case 'color':
                        return color$1.parse(context, parser.parseComponentValue());
                    case 'image':
                        return image.parse(context, parser.parseComponentValue());
                    case 'length':
                        var length_1 = parser.parseComponentValue();
                        return isLength(length_1) ? length_1 : ZERO_LENGTH;
                    case 'length-percentage':
                        var value_1 = parser.parseComponentValue();
                        return isLengthPercentage(value_1) ? value_1 : ZERO_LENGTH;
                    case 'time':
                        return time.parse(context, parser.parseComponentValue());
                }
                break;
        }
    };
    var elementDebuggerAttribute = 'data-html2canvas-debug';
    var getElementDebugType = function(element) {
        var attribute = element.getAttribute(elementDebuggerAttribute);
        switch(attribute){
            case 'all':
                return 1 /* ALL */ ;
            case 'clone':
                return 2 /* CLONE */ ;
            case 'parse':
                return 3 /* PARSE */ ;
            case 'render':
                return 4 /* RENDER */ ;
            default:
                return 0 /* NONE */ ;
        }
    };
    var isDebugging = function(element, type) {
        var elementType = getElementDebugType(element);
        return elementType === 1 /* ALL */  || type === elementType;
    };
    var ElementContainer = /** @class */ function() {
        function ElementContainer(context, element) {
            this.context = context;
            this.textNodes = [];
            this.elements = [];
            this.flags = 0;
            if (isDebugging(element, 3 /* PARSE */ )) debugger;
            this.styles = new CSSParsedDeclaration(context, window.getComputedStyle(element, null));
            if (isHTMLElementNode(element)) {
                if (this.styles.animationDuration.some(function(duration) {
                    return duration > 0;
                })) element.style.animationDuration = '0s';
                if (this.styles.transform !== null) // getBoundingClientRect takes transforms into account
                element.style.transform = 'none';
            }
            this.bounds = parseBounds(this.context, element);
            if (isDebugging(element, 4 /* RENDER */ )) this.flags |= 16 /* DEBUG_RENDER */ ;
        }
        return ElementContainer;
    }();
    /*
     * text-segmentation 1.0.3 <https://github.com/niklasvh/text-segmentation>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var base64 = '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';
    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$1 = 0; i$1 < chars$1.length; i$1++)lookup$1[chars$1.charCodeAt(i$1)] = i$1;
    var decode = function(base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') bufferLength--;
        }
        var buffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && typeof Uint8Array.prototype.slice !== 'undefined' ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for(i = 0; i < len; i += 4){
            encoded1 = lookup$1[base64.charCodeAt(i)];
            encoded2 = lookup$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1[base64.charCodeAt(i + 3)];
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return buffer;
    };
    var polyUint16Array = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 2)bytes.push(buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    var polyUint32Array = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 4)bytes.push(buffer[i + 3] << 24 | buffer[i + 2] << 16 | buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    /** Shift size for getting the index-2 table offset. */ var UTRIE2_SHIFT_2 = 5;
    /** Shift size for getting the index-1 table offset. */ var UTRIE2_SHIFT_1 = 11;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */ var UTRIE2_INDEX_SHIFT = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */ var UTRIE2_SHIFT_1_2 = UTRIE2_SHIFT_1 - UTRIE2_SHIFT_2;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */ var UTRIE2_LSCP_INDEX_2_OFFSET = 0x10000 >> UTRIE2_SHIFT_2;
    /** Number of entries in a data block. 32=0x20 */ var UTRIE2_DATA_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_2;
    /** Mask for getting the lower bits for the in-data-block offset. */ var UTRIE2_DATA_MASK = UTRIE2_DATA_BLOCK_LENGTH - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH = 0x400 >> UTRIE2_SHIFT_2;
    /** Count the lengths of both BMP pieces. 2080=0x820 */ var UTRIE2_INDEX_2_BMP_LENGTH = UTRIE2_LSCP_INDEX_2_OFFSET + UTRIE2_LSCP_INDEX_2_LENGTH;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */ var UTRIE2_UTF8_2B_INDEX_2_OFFSET = UTRIE2_INDEX_2_BMP_LENGTH;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH = 32; /* U+0800 is the first code point after 2-byte UTF-8 */ 
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */ var UTRIE2_INDEX_1_OFFSET = UTRIE2_UTF8_2B_INDEX_2_OFFSET + UTRIE2_UTF8_2B_INDEX_2_LENGTH;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */ var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> UTRIE2_SHIFT_1;
    /** Number of entries in an index-2 block. 64=0x40 */ var UTRIE2_INDEX_2_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_1_2;
    /** Mask for getting the lower bits for the in-index-2-block offset. */ var UTRIE2_INDEX_2_MASK = UTRIE2_INDEX_2_BLOCK_LENGTH - 1;
    var slice16 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64 = function(base64, _byteLength) {
        var buffer = decode(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2 ? slice16(view16, (headerLength + view32[4]) / 2) : slice32(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie = /** @class */ function() {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */ Trie.prototype.get = function(codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET + (codePoint - 0xd800 >> UTRIE2_SHIFT_2)];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> UTRIE2_SHIFT_1);
                    ix = this.index[ix];
                    ix += codePoint >> UTRIE2_SHIFT_2 & UTRIE2_INDEX_2_MASK;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) return this.data[this.highValueIndex];
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }();
    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i = 0; i < chars.length; i++)lookup[chars.charCodeAt(i)] = i;
    var Prepend = 1;
    var CR = 2;
    var LF = 3;
    var Control = 4;
    var Extend = 5;
    var SpacingMark = 7;
    var L = 8;
    var V = 9;
    var T = 10;
    var LV = 11;
    var LVT = 12;
    var ZWJ = 13;
    var Extended_Pictographic = 14;
    var RI = 15;
    var toCodePoints = function(str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while(i < length){
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                else {
                    codePoints.push(value);
                    i--;
                }
            } else codePoints.push(value);
        }
        return codePoints;
    };
    var fromCodePoint = function() {
        var codePoints = [];
        for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
        if (String.fromCodePoint) return String.fromCodePoint.apply(String, codePoints);
        var length = codePoints.length;
        if (!length) return '';
        var codeUnits = [];
        var index = -1;
        var result = '';
        while(++index < length){
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) codeUnits.push(codePoint);
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var UnicodeTrie = createTrieFromBase64(base64);
    var BREAK_NOT_ALLOWED = "\xd7";
    var BREAK_ALLOWED = "\xf7";
    var codePointToClass = function(codePoint) {
        return UnicodeTrie.get(codePoint);
    };
    var _graphemeBreakAtIndex = function(_codePoints, classTypes, index) {
        var prevIndex = index - 2;
        var prev = classTypes[prevIndex];
        var current = classTypes[index - 1];
        var next = classTypes[index];
        // GB3 Do not break between a CR and LF
        if (current === CR && next === LF) return BREAK_NOT_ALLOWED;
        // GB4 Otherwise, break before and after controls.
        if (current === CR || current === LF || current === Control) return BREAK_ALLOWED;
        // GB5
        if (next === CR || next === LF || next === Control) return BREAK_ALLOWED;
        // Do not break Hangul syllable sequences.
        // GB6
        if (current === L && [
            L,
            V,
            LV,
            LVT
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED;
        // GB7
        if ((current === LV || current === V) && (next === V || next === T)) return BREAK_NOT_ALLOWED;
        // GB8
        if ((current === LVT || current === T) && next === T) return BREAK_NOT_ALLOWED;
        // GB9 Do not break before extending characters or ZWJ.
        if (next === ZWJ || next === Extend) return BREAK_NOT_ALLOWED;
        // Do not break before SpacingMarks, or after Prepend characters.
        // GB9a
        if (next === SpacingMark) return BREAK_NOT_ALLOWED;
        // GB9a
        if (current === Prepend) return BREAK_NOT_ALLOWED;
        // GB11 Do not break within emoji modifier sequences or emoji zwj sequences.
        if (current === ZWJ && next === Extended_Pictographic) {
            while(prev === Extend)prev = classTypes[--prevIndex];
            if (prev === Extended_Pictographic) return BREAK_NOT_ALLOWED;
        }
        // GB12 Do not break within emoji flag sequences.
        // That is, do not break between regional indicator (RI) symbols
        // if there is an odd number of RI characters before the break point.
        if (current === RI && next === RI) {
            var countRI = 0;
            while(prev === RI){
                countRI++;
                prev = classTypes[--prevIndex];
            }
            if (countRI % 2 === 0) return BREAK_NOT_ALLOWED;
        }
        return BREAK_ALLOWED;
    };
    var GraphemeBreaker = function(str) {
        var codePoints = toCodePoints(str);
        var length = codePoints.length;
        var index = 0;
        var lastEnd = 0;
        var classTypes = codePoints.map(codePointToClass);
        return {
            next: function() {
                if (index >= length) return {
                    done: true,
                    value: null
                };
                var graphemeBreak = BREAK_NOT_ALLOWED;
                while(index < length && (graphemeBreak = _graphemeBreakAtIndex(codePoints, classTypes, ++index)) === BREAK_NOT_ALLOWED);
                if (graphemeBreak !== BREAK_NOT_ALLOWED || index === length) {
                    var value = fromCodePoint.apply(null, codePoints.slice(lastEnd, index));
                    lastEnd = index;
                    return {
                        value: value,
                        done: false
                    };
                }
                return {
                    done: true,
                    value: null
                };
            }
        };
    };
    var splitGraphemes = function(str) {
        var breaker = GraphemeBreaker(str);
        var graphemes = [];
        var bk;
        while(!(bk = breaker.next()).done)if (bk.value) graphemes.push(bk.value.slice());
        return graphemes;
    };
    var testRangeBounds = function(document1) {
        var TEST_HEIGHT = 123;
        if (document1.createRange) {
            var range = document1.createRange();
            if (range.getBoundingClientRect) {
                var testElement = document1.createElement('boundtest');
                testElement.style.height = TEST_HEIGHT + "px";
                testElement.style.display = 'block';
                document1.body.appendChild(testElement);
                range.selectNode(testElement);
                var rangeBounds = range.getBoundingClientRect();
                var rangeHeight = Math.round(rangeBounds.height);
                document1.body.removeChild(testElement);
                if (rangeHeight === TEST_HEIGHT) return true;
            }
        }
        return false;
    };
    var testIOSLineBreak = function(document1) {
        var testElement = document1.createElement('boundtest');
        testElement.style.width = '50px';
        testElement.style.display = 'block';
        testElement.style.fontSize = '12px';
        testElement.style.letterSpacing = '0px';
        testElement.style.wordSpacing = '0px';
        document1.body.appendChild(testElement);
        var range = document1.createRange();
        testElement.innerHTML = typeof ''.repeat === 'function' ? '&#128104;'.repeat(10) : '';
        var node = testElement.firstChild;
        var textList = toCodePoints$1(node.data).map(function(i) {
            return fromCodePoint$1(i);
        });
        var offset = 0;
        var prev = {};
        // ios 13 does not handle range getBoundingClientRect line changes correctly #2177
        var supports = textList.every(function(text, i) {
            range.setStart(node, offset);
            range.setEnd(node, offset + text.length);
            var rect = range.getBoundingClientRect();
            offset += text.length;
            var boundAhead = rect.x > prev.x || rect.y > prev.y;
            prev = rect;
            if (i === 0) return true;
            return boundAhead;
        });
        document1.body.removeChild(testElement);
        return supports;
    };
    var testCORS = function() {
        return typeof new Image().crossOrigin !== 'undefined';
    };
    var testResponseType = function() {
        return typeof new XMLHttpRequest().responseType === 'string';
    };
    var testSVG = function(document1) {
        var img = new Image();
        var canvas = document1.createElement('canvas');
        var ctx = canvas.getContext('2d');
        if (!ctx) return false;
        img.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
        try {
            ctx.drawImage(img, 0, 0);
            canvas.toDataURL();
        } catch (e) {
            return false;
        }
        return true;
    };
    var isGreenPixel = function(data) {
        return data[0] === 0 && data[1] === 255 && data[2] === 0 && data[3] === 255;
    };
    var testForeignObject = function(document1) {
        var canvas = document1.createElement('canvas');
        var size = 100;
        canvas.width = size;
        canvas.height = size;
        var ctx = canvas.getContext('2d');
        if (!ctx) return Promise.reject(false);
        ctx.fillStyle = 'rgb(0, 255, 0)';
        ctx.fillRect(0, 0, size, size);
        var img = new Image();
        var greenImageSrc = canvas.toDataURL();
        img.src = greenImageSrc;
        var svg = createForeignObjectSVG(size, size, 0, 0, img);
        ctx.fillStyle = 'red';
        ctx.fillRect(0, 0, size, size);
        return loadSerializedSVG$1(svg).then(function(img) {
            ctx.drawImage(img, 0, 0);
            var data = ctx.getImageData(0, 0, size, size).data;
            ctx.fillStyle = 'red';
            ctx.fillRect(0, 0, size, size);
            var node = document1.createElement('div');
            node.style.backgroundImage = "url(" + greenImageSrc + ")";
            node.style.height = size + "px";
            // Firefox 55 does not render inline <img /> tags
            return isGreenPixel(data) ? loadSerializedSVG$1(createForeignObjectSVG(size, size, 0, 0, node)) : Promise.reject(false);
        }).then(function(img) {
            ctx.drawImage(img, 0, 0);
            // Edge does not render background-images
            return isGreenPixel(ctx.getImageData(0, 0, size, size).data);
        }).catch(function() {
            return false;
        });
    };
    var createForeignObjectSVG = function(width, height, x, y, node) {
        var xmlns = 'http://www.w3.org/2000/svg';
        var svg = document.createElementNS(xmlns, 'svg');
        var foreignObject = document.createElementNS(xmlns, 'foreignObject');
        svg.setAttributeNS(null, 'width', width.toString());
        svg.setAttributeNS(null, 'height', height.toString());
        foreignObject.setAttributeNS(null, 'width', '100%');
        foreignObject.setAttributeNS(null, 'height', '100%');
        foreignObject.setAttributeNS(null, 'x', x.toString());
        foreignObject.setAttributeNS(null, 'y', y.toString());
        foreignObject.setAttributeNS(null, 'externalResourcesRequired', 'true');
        svg.appendChild(foreignObject);
        foreignObject.appendChild(node);
        return svg;
    };
    var loadSerializedSVG$1 = function(svg) {
        return new Promise(function(resolve, reject) {
            var img = new Image();
            img.onload = function() {
                return resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var FEATURES = {
        get SUPPORT_RANGE_BOUNDS () {
            var value = testRangeBounds(document);
            Object.defineProperty(FEATURES, 'SUPPORT_RANGE_BOUNDS', {
                value: value
            });
            return value;
        },
        get SUPPORT_WORD_BREAKING () {
            var value1 = FEATURES.SUPPORT_RANGE_BOUNDS && testIOSLineBreak(document);
            Object.defineProperty(FEATURES, 'SUPPORT_WORD_BREAKING', {
                value: value1
            });
            return value1;
        },
        get SUPPORT_SVG_DRAWING () {
            var value2 = testSVG(document);
            Object.defineProperty(FEATURES, 'SUPPORT_SVG_DRAWING', {
                value: value2
            });
            return value2;
        },
        get SUPPORT_FOREIGNOBJECT_DRAWING () {
            var value3 = typeof Array.from === 'function' && typeof window.fetch === 'function' ? testForeignObject(document) : Promise.resolve(false);
            Object.defineProperty(FEATURES, 'SUPPORT_FOREIGNOBJECT_DRAWING', {
                value: value3
            });
            return value3;
        },
        get SUPPORT_CORS_IMAGES () {
            var value4 = testCORS();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_IMAGES', {
                value: value4
            });
            return value4;
        },
        get SUPPORT_RESPONSE_TYPE () {
            var value5 = testResponseType();
            Object.defineProperty(FEATURES, 'SUPPORT_RESPONSE_TYPE', {
                value: value5
            });
            return value5;
        },
        get SUPPORT_CORS_XHR () {
            var value6 = 'withCredentials' in new XMLHttpRequest();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_XHR', {
                value: value6
            });
            return value6;
        },
        get SUPPORT_NATIVE_TEXT_SEGMENTATION () {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var value7 = !!(typeof Intl !== 'undefined' && Intl.Segmenter);
            Object.defineProperty(FEATURES, 'SUPPORT_NATIVE_TEXT_SEGMENTATION', {
                value: value7
            });
            return value7;
        }
    };
    var TextBounds = /** @class */ function() {
        function TextBounds(text, bounds) {
            this.text = text;
            this.bounds = bounds;
        }
        return TextBounds;
    }();
    var parseTextBounds = function(context, value, styles, node) {
        var textList = breakText(value, styles);
        var textBounds = [];
        var offset = 0;
        textList.forEach(function(text) {
            if (styles.textDecorationLine.length || text.trim().length > 0) {
                if (FEATURES.SUPPORT_RANGE_BOUNDS) {
                    var clientRects = createRange(node, offset, text.length).getClientRects();
                    if (clientRects.length > 1) {
                        var subSegments = segmentGraphemes(text);
                        var subOffset_1 = 0;
                        subSegments.forEach(function(subSegment) {
                            textBounds.push(new TextBounds(subSegment, Bounds.fromDOMRectList(context, createRange(node, subOffset_1 + offset, subSegment.length).getClientRects())));
                            subOffset_1 += subSegment.length;
                        });
                    } else textBounds.push(new TextBounds(text, Bounds.fromDOMRectList(context, clientRects)));
                } else {
                    var replacementNode = node.splitText(text.length);
                    textBounds.push(new TextBounds(text, getWrapperBounds(context, node)));
                    node = replacementNode;
                }
            } else if (!FEATURES.SUPPORT_RANGE_BOUNDS) node = node.splitText(text.length);
            offset += text.length;
        });
        return textBounds;
    };
    var getWrapperBounds = function(context, node) {
        var ownerDocument = node.ownerDocument;
        if (ownerDocument) {
            var wrapper = ownerDocument.createElement('html2canvaswrapper');
            wrapper.appendChild(node.cloneNode(true));
            var parentNode = node.parentNode;
            if (parentNode) {
                parentNode.replaceChild(wrapper, node);
                var bounds = parseBounds(context, wrapper);
                if (wrapper.firstChild) parentNode.replaceChild(wrapper.firstChild, wrapper);
                return bounds;
            }
        }
        return Bounds.EMPTY;
    };
    var createRange = function(node, offset, length) {
        var ownerDocument = node.ownerDocument;
        if (!ownerDocument) throw new Error('Node has no owner document');
        var range = ownerDocument.createRange();
        range.setStart(node, offset);
        range.setEnd(node, offset + length);
        return range;
    };
    var segmentGraphemes = function(value) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: 'grapheme'
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function(segment) {
                return segment.segment;
            });
        }
        return splitGraphemes(value);
    };
    var segmentWords = function(value, styles) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: 'word'
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function(segment) {
                return segment.segment;
            });
        }
        return breakWords(value, styles);
    };
    var breakText = function(value, styles) {
        return styles.letterSpacing !== 0 ? segmentGraphemes(value) : segmentWords(value, styles);
    };
    // https://drafts.csswg.org/css-text/#word-separator
    var wordSeparators = [
        0x0020,
        0x00a0,
        0x1361,
        0x10100,
        0x10101,
        0x1039,
        0x1091
    ];
    var breakWords = function(str, styles) {
        var breaker = LineBreaker(str, {
            lineBreak: styles.lineBreak,
            wordBreak: styles.overflowWrap === "break-word" /* BREAK_WORD */  ? 'break-word' : styles.wordBreak
        });
        var words = [];
        var bk;
        var _loop_1 = function() {
            if (bk.value) {
                var value = bk.value.slice();
                var codePoints = toCodePoints$1(value);
                var word_1 = '';
                codePoints.forEach(function(codePoint) {
                    if (wordSeparators.indexOf(codePoint) === -1) word_1 += fromCodePoint$1(codePoint);
                    else {
                        if (word_1.length) words.push(word_1);
                        words.push(fromCodePoint$1(codePoint));
                        word_1 = '';
                    }
                });
                if (word_1.length) words.push(word_1);
            }
        };
        while(!(bk = breaker.next()).done)_loop_1();
        return words;
    };
    var TextContainer = /** @class */ function() {
        function TextContainer(context, node, styles) {
            this.text = transform(node.data, styles.textTransform);
            this.textBounds = parseTextBounds(context, this.text, styles, node);
        }
        return TextContainer;
    }();
    var transform = function(text, transform) {
        switch(transform){
            case 1 /* LOWERCASE */ :
                return text.toLowerCase();
            case 3 /* CAPITALIZE */ :
                return text.replace(CAPITALIZE, capitalize);
            case 2 /* UPPERCASE */ :
                return text.toUpperCase();
            default:
                return text;
        }
    };
    var CAPITALIZE = /(^|\s|:|-|\(|\))([a-z])/g;
    var capitalize = function(m, p1, p2) {
        if (m.length > 0) return p1 + p2.toUpperCase();
        return m;
    };
    var ImageElementContainer = /** @class */ function(_super) {
        __extends(ImageElementContainer, _super);
        function ImageElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            _this.src = img.currentSrc || img.src;
            _this.intrinsicWidth = img.naturalWidth;
            _this.intrinsicHeight = img.naturalHeight;
            _this.context.cache.addImage(_this.src);
            return _this;
        }
        return ImageElementContainer;
    }(ElementContainer);
    var CanvasElementContainer = /** @class */ function(_super) {
        __extends(CanvasElementContainer, _super);
        function CanvasElementContainer(context, canvas) {
            var _this = _super.call(this, context, canvas) || this;
            _this.canvas = canvas;
            _this.intrinsicWidth = canvas.width;
            _this.intrinsicHeight = canvas.height;
            return _this;
        }
        return CanvasElementContainer;
    }(ElementContainer);
    var SVGElementContainer = /** @class */ function(_super) {
        __extends(SVGElementContainer, _super);
        function SVGElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            var s = new XMLSerializer();
            var bounds = parseBounds(context, img);
            img.setAttribute('width', bounds.width + "px");
            img.setAttribute('height', bounds.height + "px");
            _this.svg = "data:image/svg+xml," + encodeURIComponent(s.serializeToString(img));
            _this.intrinsicWidth = img.width.baseVal.value;
            _this.intrinsicHeight = img.height.baseVal.value;
            _this.context.cache.addImage(_this.svg);
            return _this;
        }
        return SVGElementContainer;
    }(ElementContainer);
    var LIElementContainer = /** @class */ function(_super) {
        __extends(LIElementContainer, _super);
        function LIElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return LIElementContainer;
    }(ElementContainer);
    var OLElementContainer = /** @class */ function(_super) {
        __extends(OLElementContainer, _super);
        function OLElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.start = element.start;
            _this.reversed = typeof element.reversed === 'boolean' && element.reversed === true;
            return _this;
        }
        return OLElementContainer;
    }(ElementContainer);
    var CHECKBOX_BORDER_RADIUS = [
        {
            type: 15 /* DIMENSION_TOKEN */ ,
            flags: 0,
            unit: 'px',
            number: 3
        }
    ];
    var RADIO_BORDER_RADIUS = [
        {
            type: 16 /* PERCENTAGE_TOKEN */ ,
            flags: 0,
            number: 50
        }
    ];
    var reformatInputBounds = function(bounds) {
        if (bounds.width > bounds.height) return new Bounds(bounds.left + (bounds.width - bounds.height) / 2, bounds.top, bounds.height, bounds.height);
        else if (bounds.width < bounds.height) return new Bounds(bounds.left, bounds.top + (bounds.height - bounds.width) / 2, bounds.width, bounds.width);
        return bounds;
    };
    var getInputValue = function(node) {
        var value = node.type === PASSWORD ? new Array(node.value.length + 1).join('\u2022') : node.value;
        return value.length === 0 ? node.placeholder || '' : value;
    };
    var CHECKBOX = 'checkbox';
    var RADIO = 'radio';
    var PASSWORD = 'password';
    var INPUT_COLOR = 0x2a2a2aff;
    var InputElementContainer = /** @class */ function(_super) {
        __extends(InputElementContainer, _super);
        function InputElementContainer(context, input) {
            var _this = _super.call(this, context, input) || this;
            _this.type = input.type.toLowerCase();
            _this.checked = input.checked;
            _this.value = getInputValue(input);
            if (_this.type === CHECKBOX || _this.type === RADIO) {
                _this.styles.backgroundColor = 0xdededeff;
                _this.styles.borderTopColor = _this.styles.borderRightColor = _this.styles.borderBottomColor = _this.styles.borderLeftColor = 0xa5a5a5ff;
                _this.styles.borderTopWidth = _this.styles.borderRightWidth = _this.styles.borderBottomWidth = _this.styles.borderLeftWidth = 1;
                _this.styles.borderTopStyle = _this.styles.borderRightStyle = _this.styles.borderBottomStyle = _this.styles.borderLeftStyle = 1 /* SOLID */ ;
                _this.styles.backgroundClip = [
                    0 /* BORDER_BOX */ 
                ];
                _this.styles.backgroundOrigin = [
                    0 /* BORDER_BOX */ 
                ];
                _this.bounds = reformatInputBounds(_this.bounds);
            }
            switch(_this.type){
                case CHECKBOX:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = CHECKBOX_BORDER_RADIUS;
                    break;
                case RADIO:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = RADIO_BORDER_RADIUS;
                    break;
            }
            return _this;
        }
        return InputElementContainer;
    }(ElementContainer);
    var SelectElementContainer = /** @class */ function(_super) {
        __extends(SelectElementContainer, _super);
        function SelectElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            var option = element.options[element.selectedIndex || 0];
            _this.value = option ? option.text || '' : '';
            return _this;
        }
        return SelectElementContainer;
    }(ElementContainer);
    var TextareaElementContainer = /** @class */ function(_super) {
        __extends(TextareaElementContainer, _super);
        function TextareaElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return TextareaElementContainer;
    }(ElementContainer);
    var IFrameElementContainer = /** @class */ function(_super) {
        __extends(IFrameElementContainer, _super);
        function IFrameElementContainer(context, iframe) {
            var _this = _super.call(this, context, iframe) || this;
            _this.src = iframe.src;
            _this.width = parseInt(iframe.width, 10) || 0;
            _this.height = parseInt(iframe.height, 10) || 0;
            _this.backgroundColor = _this.styles.backgroundColor;
            try {
                if (iframe.contentWindow && iframe.contentWindow.document && iframe.contentWindow.document.documentElement) {
                    _this.tree = parseTree(context, iframe.contentWindow.document.documentElement);
                    // http://www.w3.org/TR/css3-background/#special-backgrounds
                    var documentBackgroundColor = iframe.contentWindow.document.documentElement ? parseColor(context, getComputedStyle(iframe.contentWindow.document.documentElement).backgroundColor) : COLORS.TRANSPARENT;
                    var bodyBackgroundColor = iframe.contentWindow.document.body ? parseColor(context, getComputedStyle(iframe.contentWindow.document.body).backgroundColor) : COLORS.TRANSPARENT;
                    _this.backgroundColor = isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? _this.styles.backgroundColor : bodyBackgroundColor : documentBackgroundColor;
                }
            } catch (e) {}
            return _this;
        }
        return IFrameElementContainer;
    }(ElementContainer);
    var LIST_OWNERS = [
        'OL',
        'UL',
        'MENU'
    ];
    var parseNodeTree = function(context, node, parent, root) {
        for(var childNode = node.firstChild, nextNode = void 0; childNode; childNode = nextNode){
            nextNode = childNode.nextSibling;
            if (isTextNode(childNode) && childNode.data.trim().length > 0) parent.textNodes.push(new TextContainer(context, childNode, parent.styles));
            else if (isElementNode(childNode)) {
                if (isSlotElement(childNode) && childNode.assignedNodes) childNode.assignedNodes().forEach(function(childNode) {
                    return parseNodeTree(context, childNode, parent, root);
                });
                else {
                    var container = createContainer(context, childNode);
                    if (container.styles.isVisible()) {
                        if (createsRealStackingContext(childNode, container, root)) container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */ ;
                        else if (createsStackingContext(container.styles)) container.flags |= 2 /* CREATES_STACKING_CONTEXT */ ;
                        if (LIST_OWNERS.indexOf(childNode.tagName) !== -1) container.flags |= 8 /* IS_LIST_OWNER */ ;
                        parent.elements.push(container);
                        childNode.slot;
                        if (childNode.shadowRoot) parseNodeTree(context, childNode.shadowRoot, container, root);
                        else if (!isTextareaElement(childNode) && !isSVGElement(childNode) && !isSelectElement(childNode)) parseNodeTree(context, childNode, container, root);
                    }
                }
            }
        }
    };
    var createContainer = function(context, element) {
        if (isImageElement(element)) return new ImageElementContainer(context, element);
        if (isCanvasElement(element)) return new CanvasElementContainer(context, element);
        if (isSVGElement(element)) return new SVGElementContainer(context, element);
        if (isLIElement(element)) return new LIElementContainer(context, element);
        if (isOLElement(element)) return new OLElementContainer(context, element);
        if (isInputElement(element)) return new InputElementContainer(context, element);
        if (isSelectElement(element)) return new SelectElementContainer(context, element);
        if (isTextareaElement(element)) return new TextareaElementContainer(context, element);
        if (isIFrameElement(element)) return new IFrameElementContainer(context, element);
        return new ElementContainer(context, element);
    };
    var parseTree = function(context, element) {
        var container = createContainer(context, element);
        container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */ ;
        parseNodeTree(context, element, container, container);
        return container;
    };
    var createsRealStackingContext = function(node, container, root) {
        return container.styles.isPositionedWithZIndex() || container.styles.opacity < 1 || container.styles.isTransformed() || isBodyElement(node) && root.styles.isTransparent();
    };
    var createsStackingContext = function(styles) {
        return styles.isPositioned() || styles.isFloating();
    };
    var isTextNode = function(node) {
        return node.nodeType === Node.TEXT_NODE;
    };
    var isElementNode = function(node) {
        return node.nodeType === Node.ELEMENT_NODE;
    };
    var isHTMLElementNode = function(node) {
        return isElementNode(node) && typeof node.style !== 'undefined' && !isSVGElementNode(node);
    };
    var isSVGElementNode = function(element) {
        return typeof element.className === 'object';
    };
    var isLIElement = function(node) {
        return node.tagName === 'LI';
    };
    var isOLElement = function(node) {
        return node.tagName === 'OL';
    };
    var isInputElement = function(node) {
        return node.tagName === 'INPUT';
    };
    var isHTMLElement = function(node) {
        return node.tagName === 'HTML';
    };
    var isSVGElement = function(node) {
        return node.tagName === 'svg';
    };
    var isBodyElement = function(node) {
        return node.tagName === 'BODY';
    };
    var isCanvasElement = function(node) {
        return node.tagName === 'CANVAS';
    };
    var isVideoElement = function(node) {
        return node.tagName === 'VIDEO';
    };
    var isImageElement = function(node) {
        return node.tagName === 'IMG';
    };
    var isIFrameElement = function(node) {
        return node.tagName === 'IFRAME';
    };
    var isStyleElement = function(node) {
        return node.tagName === 'STYLE';
    };
    var isScriptElement = function(node) {
        return node.tagName === 'SCRIPT';
    };
    var isTextareaElement = function(node) {
        return node.tagName === 'TEXTAREA';
    };
    var isSelectElement = function(node) {
        return node.tagName === 'SELECT';
    };
    var isSlotElement = function(node) {
        return node.tagName === 'SLOT';
    };
    // https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
    var isCustomElement = function(node) {
        return node.tagName.indexOf('-') > 0;
    };
    var CounterState = /** @class */ function() {
        function CounterState() {
            this.counters = {};
        }
        CounterState.prototype.getCounterValue = function(name) {
            var counter = this.counters[name];
            if (counter && counter.length) return counter[counter.length - 1];
            return 1;
        };
        CounterState.prototype.getCounterValues = function(name) {
            var counter = this.counters[name];
            return counter ? counter : [];
        };
        CounterState.prototype.pop = function(counters) {
            var _this = this;
            counters.forEach(function(counter) {
                return _this.counters[counter].pop();
            });
        };
        CounterState.prototype.parse = function(style) {
            var _this = this;
            var counterIncrement = style.counterIncrement;
            var counterReset = style.counterReset;
            var canReset = true;
            if (counterIncrement !== null) counterIncrement.forEach(function(entry) {
                var counter = _this.counters[entry.counter];
                if (counter && entry.increment !== 0) {
                    canReset = false;
                    if (!counter.length) counter.push(1);
                    counter[Math.max(0, counter.length - 1)] += entry.increment;
                }
            });
            var counterNames = [];
            if (canReset) counterReset.forEach(function(entry) {
                var counter = _this.counters[entry.counter];
                counterNames.push(entry.counter);
                if (!counter) counter = _this.counters[entry.counter] = [];
                counter.push(entry.reset);
            });
            return counterNames;
        };
        return CounterState;
    }();
    var ROMAN_UPPER = {
        integers: [
            1000,
            900,
            500,
            400,
            100,
            90,
            50,
            40,
            10,
            9,
            5,
            4,
            1
        ],
        values: [
            'M',
            'CM',
            'D',
            'CD',
            'C',
            'XC',
            'L',
            'XL',
            'X',
            'IX',
            'V',
            'IV',
            'I'
        ]
    };
    var ARMENIAN = {
        integers: [
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u0554",
            "\u0553",
            "\u0552",
            "\u0551",
            "\u0550",
            "\u054F",
            "\u054E",
            "\u054D",
            "\u054C",
            "\u054B",
            "\u054A",
            "\u0549",
            "\u0548",
            "\u0547",
            "\u0546",
            "\u0545",
            "\u0544",
            "\u0543",
            "\u0542",
            "\u0541",
            "\u0540",
            "\u053F",
            "\u053E",
            "\u053D",
            "\u053C",
            "\u053B",
            "\u053A",
            "\u0539",
            "\u0538",
            "\u0537",
            "\u0536",
            "\u0535",
            "\u0534",
            "\u0533",
            "\u0532",
            "\u0531"
        ]
    };
    var HEBREW = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            19,
            18,
            17,
            16,
            15,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u05D9\u05F3",
            "\u05D8\u05F3",
            "\u05D7\u05F3",
            "\u05D6\u05F3",
            "\u05D5\u05F3",
            "\u05D4\u05F3",
            "\u05D3\u05F3",
            "\u05D2\u05F3",
            "\u05D1\u05F3",
            "\u05D0\u05F3",
            "\u05EA",
            "\u05E9",
            "\u05E8",
            "\u05E7",
            "\u05E6",
            "\u05E4",
            "\u05E2",
            "\u05E1",
            "\u05E0",
            "\u05DE",
            "\u05DC",
            "\u05DB",
            "\u05D9\u05D8",
            "\u05D9\u05D7",
            "\u05D9\u05D6",
            "\u05D8\u05D6",
            "\u05D8\u05D5",
            "\u05D9",
            "\u05D8",
            "\u05D7",
            "\u05D6",
            "\u05D5",
            "\u05D4",
            "\u05D3",
            "\u05D2",
            "\u05D1",
            "\u05D0"
        ]
    };
    var GEORGIAN = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u10F5",
            "\u10F0",
            "\u10EF",
            "\u10F4",
            "\u10EE",
            "\u10ED",
            "\u10EC",
            "\u10EB",
            "\u10EA",
            "\u10E9",
            "\u10E8",
            "\u10E7",
            "\u10E6",
            "\u10E5",
            "\u10E4",
            "\u10F3",
            "\u10E2",
            "\u10E1",
            "\u10E0",
            "\u10DF",
            "\u10DE",
            "\u10DD",
            "\u10F2",
            "\u10DC",
            "\u10DB",
            "\u10DA",
            "\u10D9",
            "\u10D8",
            "\u10D7",
            "\u10F1",
            "\u10D6",
            "\u10D5",
            "\u10D4",
            "\u10D3",
            "\u10D2",
            "\u10D1",
            "\u10D0"
        ]
    };
    var createAdditiveCounter = function(value, min, max, symbols, fallback, suffix) {
        if (value < min || value > max) return createCounterText(value, fallback, suffix.length > 0);
        return symbols.integers.reduce(function(string, integer, index) {
            while(value >= integer){
                value -= integer;
                string += symbols.values[index];
            }
            return string;
        }, '') + suffix;
    };
    var createCounterStyleWithSymbolResolver = function(value, codePointRangeLength, isNumeric, resolver) {
        var string = '';
        do {
            if (!isNumeric) value--;
            string = resolver(value) + string;
            value /= codePointRangeLength;
        }while (value * codePointRangeLength >= codePointRangeLength);
        return string;
    };
    var createCounterStyleFromRange = function(value, codePointRangeStart, codePointRangeEnd, isNumeric, suffix) {
        var codePointRangeLength = codePointRangeEnd - codePointRangeStart + 1;
        return (value < 0 ? '-' : '') + (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, isNumeric, function(codePoint) {
            return fromCodePoint$1(Math.floor(codePoint % codePointRangeLength) + codePointRangeStart);
        }) + suffix);
    };
    var createCounterStyleFromSymbols = function(value, symbols, suffix) {
        if (suffix === void 0) suffix = '. ';
        var codePointRangeLength = symbols.length;
        return createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, false, function(codePoint) {
            return symbols[Math.floor(codePoint % codePointRangeLength)];
        }) + suffix;
    };
    var CJK_ZEROS = 1;
    var CJK_TEN_COEFFICIENTS = 2;
    var CJK_TEN_HIGH_COEFFICIENTS = 4;
    var CJK_HUNDRED_COEFFICIENTS = 8;
    var createCJKCounter = function(value, numbers, multipliers, negativeSign, suffix, flags) {
        if (value < -9999 || value > 9999) return createCounterText(value, 4 /* CJK_DECIMAL */ , suffix.length > 0);
        var tmp = Math.abs(value);
        var string = suffix;
        if (tmp === 0) return numbers[0] + string;
        for(var digit = 0; tmp > 0 && digit <= 4; digit++){
            var coefficient = tmp % 10;
            if (coefficient === 0 && contains(flags, CJK_ZEROS) && string !== '') string = numbers[coefficient] + string;
            else if (coefficient > 1 || coefficient === 1 && digit === 0 || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_COEFFICIENTS) || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_HIGH_COEFFICIENTS) && value > 100 || coefficient === 1 && digit > 1 && contains(flags, CJK_HUNDRED_COEFFICIENTS)) string = numbers[coefficient] + (digit > 0 ? multipliers[digit - 1] : '') + string;
            else if (coefficient === 1 && digit > 0) string = multipliers[digit - 1] + string;
            tmp = Math.floor(tmp / 10);
        }
        return (value < 0 ? negativeSign : '') + string;
    };
    var CHINESE_INFORMAL_MULTIPLIERS = "\u5341\u767E\u5343\u842C";
    var CHINESE_FORMAL_MULTIPLIERS = "\u62FE\u4F70\u4EDF\u842C";
    var JAPANESE_NEGATIVE = "\u30DE\u30A4\u30CA\u30B9";
    var KOREAN_NEGATIVE = "\uB9C8\uC774\uB108\uC2A4";
    var createCounterText = function(value, type, appendSuffix) {
        var defaultSuffix = appendSuffix ? '. ' : '';
        var cjkSuffix = appendSuffix ? "\u3001" : '';
        var koreanSuffix = appendSuffix ? ', ' : '';
        var spaceSuffix = appendSuffix ? ' ' : '';
        switch(type){
            case 0 /* DISC */ :
                return "\u2022" + spaceSuffix;
            case 1 /* CIRCLE */ :
                return "\u25E6" + spaceSuffix;
            case 2 /* SQUARE */ :
                return "\u25FE" + spaceSuffix;
            case 5 /* DECIMAL_LEADING_ZERO */ :
                var string = createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
                return string.length < 4 ? "0" + string : string;
            case 4 /* CJK_DECIMAL */ :
                return createCounterStyleFromSymbols(value, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", cjkSuffix);
            case 6 /* LOWER_ROMAN */ :
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */ , defaultSuffix).toLowerCase();
            case 7 /* UPPER_ROMAN */ :
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */ , defaultSuffix);
            case 8 /* LOWER_GREEK */ :
                return createCounterStyleFromRange(value, 945, 969, false, defaultSuffix);
            case 9 /* LOWER_ALPHA */ :
                return createCounterStyleFromRange(value, 97, 122, false, defaultSuffix);
            case 10 /* UPPER_ALPHA */ :
                return createCounterStyleFromRange(value, 65, 90, false, defaultSuffix);
            case 11 /* ARABIC_INDIC */ :
                return createCounterStyleFromRange(value, 1632, 1641, true, defaultSuffix);
            case 12 /* ARMENIAN */ :
            case 49 /* UPPER_ARMENIAN */ :
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */ , defaultSuffix);
            case 35 /* LOWER_ARMENIAN */ :
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */ , defaultSuffix).toLowerCase();
            case 13 /* BENGALI */ :
                return createCounterStyleFromRange(value, 2534, 2543, true, defaultSuffix);
            case 14 /* CAMBODIAN */ :
            case 30 /* KHMER */ :
                return createCounterStyleFromRange(value, 6112, 6121, true, defaultSuffix);
            case 15 /* CJK_EARTHLY_BRANCH */ :
                return createCounterStyleFromSymbols(value, "\u5B50\u4E11\u5BC5\u536F\u8FB0\u5DF3\u5348\u672A\u7533\u9149\u620C\u4EA5", cjkSuffix);
            case 16 /* CJK_HEAVENLY_STEM */ :
                return createCounterStyleFromSymbols(value, "\u7532\u4E59\u4E19\u4E01\u620A\u5DF1\u5E9A\u8F9B\u58EC\u7678", cjkSuffix);
            case 17 /* CJK_IDEOGRAPHIC */ :
            case 48 /* TRAD_CHINESE_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", CHINESE_INFORMAL_MULTIPLIERS, "\u8CA0", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 47 /* TRAD_CHINESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8CB3\u53C3\u8086\u4F0D\u9678\u67D2\u634C\u7396", CHINESE_FORMAL_MULTIPLIERS, "\u8CA0", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 42 /* SIMP_CHINESE_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", CHINESE_INFORMAL_MULTIPLIERS, "\u8D1F", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 41 /* SIMP_CHINESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8D30\u53C1\u8086\u4F0D\u9646\u67D2\u634C\u7396", CHINESE_FORMAL_MULTIPLIERS, "\u8D1F", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 26 /* JAPANESE_INFORMAL */ :
                return createCJKCounter(value, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u4E07", JAPANESE_NEGATIVE, cjkSuffix, 0);
            case 25 /* JAPANESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F1\u5F10\u53C2\u56DB\u4F0D\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343\u4E07", JAPANESE_NEGATIVE, cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 31 /* KOREAN_HANGUL_FORMAL */ :
                return createCJKCounter(value, "\uC601\uC77C\uC774\uC0BC\uC0AC\uC624\uC721\uCE60\uD314\uAD6C", "\uC2ED\uBC31\uCC9C\uB9CC", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 33 /* KOREAN_HANJA_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u842C", KOREAN_NEGATIVE, koreanSuffix, 0);
            case 32 /* KOREAN_HANJA_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8CB3\u53C3\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 18 /* DEVANAGARI */ :
                return createCounterStyleFromRange(value, 0x966, 0x96f, true, defaultSuffix);
            case 20 /* GEORGIAN */ :
                return createAdditiveCounter(value, 1, 19999, GEORGIAN, 3 /* DECIMAL */ , defaultSuffix);
            case 21 /* GUJARATI */ :
                return createCounterStyleFromRange(value, 0xae6, 0xaef, true, defaultSuffix);
            case 22 /* GURMUKHI */ :
                return createCounterStyleFromRange(value, 0xa66, 0xa6f, true, defaultSuffix);
            case 22 /* HEBREW */ :
                return createAdditiveCounter(value, 1, 10999, HEBREW, 3 /* DECIMAL */ , defaultSuffix);
            case 23 /* HIRAGANA */ :
                return createCounterStyleFromSymbols(value, "\u3042\u3044\u3046\u3048\u304A\u304B\u304D\u304F\u3051\u3053\u3055\u3057\u3059\u305B\u305D\u305F\u3061\u3064\u3066\u3068\u306A\u306B\u306C\u306D\u306E\u306F\u3072\u3075\u3078\u307B\u307E\u307F\u3080\u3081\u3082\u3084\u3086\u3088\u3089\u308A\u308B\u308C\u308D\u308F\u3090\u3091\u3092\u3093");
            case 24 /* HIRAGANA_IROHA */ :
                return createCounterStyleFromSymbols(value, "\u3044\u308D\u306F\u306B\u307B\u3078\u3068\u3061\u308A\u306C\u308B\u3092\u308F\u304B\u3088\u305F\u308C\u305D\u3064\u306D\u306A\u3089\u3080\u3046\u3090\u306E\u304A\u304F\u3084\u307E\u3051\u3075\u3053\u3048\u3066\u3042\u3055\u304D\u3086\u3081\u307F\u3057\u3091\u3072\u3082\u305B\u3059");
            case 27 /* KANNADA */ :
                return createCounterStyleFromRange(value, 0xce6, 0xcef, true, defaultSuffix);
            case 28 /* KATAKANA */ :
                return createCounterStyleFromSymbols(value, "\u30A2\u30A4\u30A6\u30A8\u30AA\u30AB\u30AD\u30AF\u30B1\u30B3\u30B5\u30B7\u30B9\u30BB\u30BD\u30BF\u30C1\u30C4\u30C6\u30C8\u30CA\u30CB\u30CC\u30CD\u30CE\u30CF\u30D2\u30D5\u30D8\u30DB\u30DE\u30DF\u30E0\u30E1\u30E2\u30E4\u30E6\u30E8\u30E9\u30EA\u30EB\u30EC\u30ED\u30EF\u30F0\u30F1\u30F2\u30F3", cjkSuffix);
            case 29 /* KATAKANA_IROHA */ :
                return createCounterStyleFromSymbols(value, "\u30A4\u30ED\u30CF\u30CB\u30DB\u30D8\u30C8\u30C1\u30EA\u30CC\u30EB\u30F2\u30EF\u30AB\u30E8\u30BF\u30EC\u30BD\u30C4\u30CD\u30CA\u30E9\u30E0\u30A6\u30F0\u30CE\u30AA\u30AF\u30E4\u30DE\u30B1\u30D5\u30B3\u30A8\u30C6\u30A2\u30B5\u30AD\u30E6\u30E1\u30DF\u30B7\u30F1\u30D2\u30E2\u30BB\u30B9", cjkSuffix);
            case 34 /* LAO */ :
                return createCounterStyleFromRange(value, 0xed0, 0xed9, true, defaultSuffix);
            case 37 /* MONGOLIAN */ :
                return createCounterStyleFromRange(value, 0x1810, 0x1819, true, defaultSuffix);
            case 38 /* MYANMAR */ :
                return createCounterStyleFromRange(value, 0x1040, 0x1049, true, defaultSuffix);
            case 39 /* ORIYA */ :
                return createCounterStyleFromRange(value, 0xb66, 0xb6f, true, defaultSuffix);
            case 40 /* PERSIAN */ :
                return createCounterStyleFromRange(value, 0x6f0, 0x6f9, true, defaultSuffix);
            case 43 /* TAMIL */ :
                return createCounterStyleFromRange(value, 0xbe6, 0xbef, true, defaultSuffix);
            case 44 /* TELUGU */ :
                return createCounterStyleFromRange(value, 0xc66, 0xc6f, true, defaultSuffix);
            case 45 /* THAI */ :
                return createCounterStyleFromRange(value, 0xe50, 0xe59, true, defaultSuffix);
            case 46 /* TIBETAN */ :
                return createCounterStyleFromRange(value, 0xf20, 0xf29, true, defaultSuffix);
            case 3 /* DECIMAL */ :
            default:
                return createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
        }
    };
    var IGNORE_ATTRIBUTE = 'data-html2canvas-ignore';
    var DocumentCloner = /** @class */ function() {
        function DocumentCloner(context, element, options) {
            this.context = context;
            this.options = options;
            this.scrolledElements = [];
            this.referenceElement = element;
            this.counters = new CounterState();
            this.quoteDepth = 0;
            if (!element.ownerDocument) throw new Error('Cloned element does not have an owner document');
            this.documentElement = this.cloneNode(element.ownerDocument.documentElement, false);
        }
        DocumentCloner.prototype.toIFrame = function(ownerDocument, windowSize) {
            var _this = this;
            var iframe = createIFrameContainer(ownerDocument, windowSize);
            if (!iframe.contentWindow) return Promise.reject("Unable to find iframe window");
            var scrollX = ownerDocument.defaultView.pageXOffset;
            var scrollY = ownerDocument.defaultView.pageYOffset;
            var cloneWindow = iframe.contentWindow;
            var documentClone = cloneWindow.document;
            /* Chrome doesn't detect relative background-images assigned in inline <style> sheets when fetched through getComputedStyle
             if window url is about:blank, we can assign the url to current by writing onto the document
             */ var iframeLoad = iframeLoader(iframe).then(function() {
                return __awaiter(_this, void 0, void 0, function() {
                    var onclone, referenceElement;
                    return __generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                this.scrolledElements.forEach(restoreNodeScroll);
                                if (cloneWindow) {
                                    cloneWindow.scrollTo(windowSize.left, windowSize.top);
                                    if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent) && (cloneWindow.scrollY !== windowSize.top || cloneWindow.scrollX !== windowSize.left)) {
                                        this.context.logger.warn('Unable to restore scroll position for cloned document');
                                        this.context.windowBounds = this.context.windowBounds.add(cloneWindow.scrollX - windowSize.left, cloneWindow.scrollY - windowSize.top, 0, 0);
                                    }
                                }
                                onclone = this.options.onclone;
                                referenceElement = this.clonedReferenceElement;
                                if (typeof referenceElement === 'undefined') return [
                                    2 /*return*/ ,
                                    Promise.reject("Error finding the " + this.referenceElement.nodeName + " in the cloned document")
                                ];
                                if (!(documentClone.fonts && documentClone.fonts.ready)) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                return [
                                    4 /*yield*/ ,
                                    documentClone.fonts.ready
                                ];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2:
                                if (!/(AppleWebKit)/g.test(navigator.userAgent)) return [
                                    3 /*break*/ ,
                                    4
                                ];
                                return [
                                    4 /*yield*/ ,
                                    imagesReady(documentClone)
                                ];
                            case 3:
                                _a.sent();
                                _a.label = 4;
                            case 4:
                                if (typeof onclone === 'function') return [
                                    2 /*return*/ ,
                                    Promise.resolve().then(function() {
                                        return onclone(documentClone, referenceElement);
                                    }).then(function() {
                                        return iframe;
                                    })
                                ];
                                return [
                                    2 /*return*/ ,
                                    iframe
                                ];
                        }
                    });
                });
            });
            documentClone.open();
            documentClone.write(serializeDoctype(document.doctype) + "<html></html>");
            // Chrome scrolls the parent document for some reason after the write to the cloned window???
            restoreOwnerScroll(this.referenceElement.ownerDocument, scrollX, scrollY);
            documentClone.replaceChild(documentClone.adoptNode(this.documentElement), documentClone.documentElement);
            documentClone.close();
            return iframeLoad;
        };
        DocumentCloner.prototype.createElementClone = function(node) {
            if (isDebugging(node, 2 /* CLONE */ )) debugger;
            if (isCanvasElement(node)) return this.createCanvasClone(node);
            if (isVideoElement(node)) return this.createVideoClone(node);
            if (isStyleElement(node)) return this.createStyleClone(node);
            var clone = node.cloneNode(false);
            if (isImageElement(clone)) {
                if (isImageElement(node) && node.currentSrc && node.currentSrc !== node.src) {
                    clone.src = node.currentSrc;
                    clone.srcset = '';
                }
                if (clone.loading === 'lazy') clone.loading = 'eager';
            }
            if (isCustomElement(clone)) return this.createCustomElementClone(clone);
            return clone;
        };
        DocumentCloner.prototype.createCustomElementClone = function(node) {
            var clone = document.createElement('html2canvascustomelement');
            copyCSSStyles(node.style, clone);
            return clone;
        };
        DocumentCloner.prototype.createStyleClone = function(node) {
            try {
                var sheet = node.sheet;
                if (sheet && sheet.cssRules) {
                    var css = [].slice.call(sheet.cssRules, 0).reduce(function(css, rule) {
                        if (rule && typeof rule.cssText === 'string') return css + rule.cssText;
                        return css;
                    }, '');
                    var style = node.cloneNode(false);
                    style.textContent = css;
                    return style;
                }
            } catch (e) {
                // accessing node.sheet.cssRules throws a DOMException
                this.context.logger.error('Unable to access cssRules property', e);
                if (e.name !== 'SecurityError') throw e;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.createCanvasClone = function(canvas) {
            var _a;
            if (this.options.inlineImages && canvas.ownerDocument) {
                var img = canvas.ownerDocument.createElement('img');
                try {
                    img.src = canvas.toDataURL();
                    return img;
                } catch (e) {
                    this.context.logger.info("Unable to inline canvas contents, canvas is tainted", canvas);
                }
            }
            var clonedCanvas = canvas.cloneNode(false);
            try {
                clonedCanvas.width = canvas.width;
                clonedCanvas.height = canvas.height;
                var ctx = canvas.getContext('2d');
                var clonedCtx = clonedCanvas.getContext('2d');
                if (clonedCtx) {
                    if (!this.options.allowTaint && ctx) clonedCtx.putImageData(ctx.getImageData(0, 0, canvas.width, canvas.height), 0, 0);
                    else {
                        var gl = (_a = canvas.getContext('webgl2')) !== null && _a !== void 0 ? _a : canvas.getContext('webgl');
                        if (gl) {
                            var attribs = gl.getContextAttributes();
                            if ((attribs === null || attribs === void 0 ? void 0 : attribs.preserveDrawingBuffer) === false) this.context.logger.warn('Unable to clone WebGL context as it has preserveDrawingBuffer=false', canvas);
                        }
                        clonedCtx.drawImage(canvas, 0, 0);
                    }
                }
                return clonedCanvas;
            } catch (e) {
                this.context.logger.info("Unable to clone canvas as it is tainted", canvas);
            }
            return clonedCanvas;
        };
        DocumentCloner.prototype.createVideoClone = function(video) {
            var canvas = video.ownerDocument.createElement('canvas');
            canvas.width = video.offsetWidth;
            canvas.height = video.offsetHeight;
            var ctx = canvas.getContext('2d');
            try {
                if (ctx) {
                    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                    if (!this.options.allowTaint) ctx.getImageData(0, 0, canvas.width, canvas.height);
                }
                return canvas;
            } catch (e) {
                this.context.logger.info("Unable to clone video as it is tainted", video);
            }
            var blankCanvas = video.ownerDocument.createElement('canvas');
            blankCanvas.width = video.offsetWidth;
            blankCanvas.height = video.offsetHeight;
            return blankCanvas;
        };
        DocumentCloner.prototype.appendChildNode = function(clone, child, copyStyles) {
            if (!isElementNode(child) || !isScriptElement(child) && !child.hasAttribute(IGNORE_ATTRIBUTE) && (typeof this.options.ignoreElements !== 'function' || !this.options.ignoreElements(child))) {
                if (!this.options.copyStyles || !isElementNode(child) || !isStyleElement(child)) clone.appendChild(this.cloneNode(child, copyStyles));
            }
        };
        DocumentCloner.prototype.cloneChildNodes = function(node, clone, copyStyles) {
            var _this = this;
            for(var child = node.shadowRoot ? node.shadowRoot.firstChild : node.firstChild; child; child = child.nextSibling)if (isElementNode(child) && isSlotElement(child) && typeof child.assignedNodes === 'function') {
                var assignedNodes = child.assignedNodes();
                if (assignedNodes.length) assignedNodes.forEach(function(assignedNode) {
                    return _this.appendChildNode(clone, assignedNode, copyStyles);
                });
            } else this.appendChildNode(clone, child, copyStyles);
        };
        DocumentCloner.prototype.cloneNode = function(node, copyStyles) {
            if (isTextNode(node)) return document.createTextNode(node.data);
            if (!node.ownerDocument) return node.cloneNode(false);
            var window1 = node.ownerDocument.defaultView;
            if (window1 && isElementNode(node) && (isHTMLElementNode(node) || isSVGElementNode(node))) {
                var clone = this.createElementClone(node);
                clone.style.transitionProperty = 'none';
                var style = window1.getComputedStyle(node);
                var styleBefore = window1.getComputedStyle(node, ':before');
                var styleAfter = window1.getComputedStyle(node, ':after');
                if (this.referenceElement === node && isHTMLElementNode(clone)) this.clonedReferenceElement = clone;
                if (isBodyElement(clone)) createPseudoHideStyles(clone);
                var counters = this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
                var before = this.resolvePseudoContent(node, clone, styleBefore, PseudoElementType.BEFORE);
                if (isCustomElement(node)) copyStyles = true;
                if (!isVideoElement(node)) this.cloneChildNodes(node, clone, copyStyles);
                if (before) clone.insertBefore(before, clone.firstChild);
                var after = this.resolvePseudoContent(node, clone, styleAfter, PseudoElementType.AFTER);
                if (after) clone.appendChild(after);
                this.counters.pop(counters);
                if (style && (this.options.copyStyles || isSVGElementNode(node)) && !isIFrameElement(node) || copyStyles) copyCSSStyles(style, clone);
                if (node.scrollTop !== 0 || node.scrollLeft !== 0) this.scrolledElements.push([
                    clone,
                    node.scrollLeft,
                    node.scrollTop
                ]);
                if ((isTextareaElement(node) || isSelectElement(node)) && (isTextareaElement(clone) || isSelectElement(clone))) clone.value = node.value;
                return clone;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.resolvePseudoContent = function(node, clone, style, pseudoElt) {
            var _this = this;
            if (!style) return;
            var value = style.content;
            var document1 = clone.ownerDocument;
            if (!document1 || !value || value === 'none' || value === '-moz-alt-content' || style.display === 'none') return;
            this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
            var declaration = new CSSParsedPseudoDeclaration(this.context, style);
            var anonymousReplacedElement = document1.createElement('html2canvaspseudoelement');
            copyCSSStyles(style, anonymousReplacedElement);
            declaration.content.forEach(function(token) {
                if (token.type === 0 /* STRING_TOKEN */ ) anonymousReplacedElement.appendChild(document1.createTextNode(token.value));
                else if (token.type === 22 /* URL_TOKEN */ ) {
                    var img = document1.createElement('img');
                    img.src = token.value;
                    img.style.opacity = '1';
                    anonymousReplacedElement.appendChild(img);
                } else if (token.type === 18 /* FUNCTION */ ) {
                    if (token.name === 'attr') {
                        var attr = token.values.filter(isIdentToken);
                        if (attr.length) anonymousReplacedElement.appendChild(document1.createTextNode(node.getAttribute(attr[0].value) || ''));
                    } else if (token.name === 'counter') {
                        var _a = token.values.filter(nonFunctionArgSeparator), counter = _a[0], counterStyle = _a[1];
                        if (counter && isIdentToken(counter)) {
                            var counterState = _this.counters.getCounterValue(counter.value);
                            var counterType = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : 3 /* DECIMAL */ ;
                            anonymousReplacedElement.appendChild(document1.createTextNode(createCounterText(counterState, counterType, false)));
                        }
                    } else if (token.name === 'counters') {
                        var _b = token.values.filter(nonFunctionArgSeparator), counter = _b[0], delim = _b[1], counterStyle = _b[2];
                        if (counter && isIdentToken(counter)) {
                            var counterStates = _this.counters.getCounterValues(counter.value);
                            var counterType_1 = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : 3 /* DECIMAL */ ;
                            var separator = delim && delim.type === 0 /* STRING_TOKEN */  ? delim.value : '';
                            var text = counterStates.map(function(value) {
                                return createCounterText(value, counterType_1, false);
                            }).join(separator);
                            anonymousReplacedElement.appendChild(document1.createTextNode(text));
                        }
                    }
                } else if (token.type === 20 /* IDENT_TOKEN */ ) switch(token.value){
                    case 'open-quote':
                        anonymousReplacedElement.appendChild(document1.createTextNode(getQuote(declaration.quotes, _this.quoteDepth++, true)));
                        break;
                    case 'close-quote':
                        anonymousReplacedElement.appendChild(document1.createTextNode(getQuote(declaration.quotes, --_this.quoteDepth, false)));
                        break;
                    default:
                        // safari doesn't parse string tokens correctly because of lack of quotes
                        anonymousReplacedElement.appendChild(document1.createTextNode(token.value));
                }
            });
            anonymousReplacedElement.className = PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            var newClassName = pseudoElt === PseudoElementType.BEFORE ? " " + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE : " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            if (isSVGElementNode(clone)) clone.className.baseValue += newClassName;
            else clone.className += newClassName;
            return anonymousReplacedElement;
        };
        DocumentCloner.destroy = function(container) {
            if (container.parentNode) {
                container.parentNode.removeChild(container);
                return true;
            }
            return false;
        };
        return DocumentCloner;
    }();
    var PseudoElementType;
    (function(PseudoElementType) {
        PseudoElementType[PseudoElementType["BEFORE"] = 0] = "BEFORE";
        PseudoElementType[PseudoElementType["AFTER"] = 1] = "AFTER";
    })(PseudoElementType || (PseudoElementType = {}));
    var createIFrameContainer = function(ownerDocument, bounds) {
        var cloneIframeContainer = ownerDocument.createElement('iframe');
        cloneIframeContainer.className = 'html2canvas-container';
        cloneIframeContainer.style.visibility = 'hidden';
        cloneIframeContainer.style.position = 'fixed';
        cloneIframeContainer.style.left = '-10000px';
        cloneIframeContainer.style.top = '0px';
        cloneIframeContainer.style.border = '0';
        cloneIframeContainer.width = bounds.width.toString();
        cloneIframeContainer.height = bounds.height.toString();
        cloneIframeContainer.scrolling = 'no'; // ios won't scroll without it
        cloneIframeContainer.setAttribute(IGNORE_ATTRIBUTE, 'true');
        ownerDocument.body.appendChild(cloneIframeContainer);
        return cloneIframeContainer;
    };
    var imageReady = function(img) {
        return new Promise(function(resolve) {
            if (img.complete) {
                resolve();
                return;
            }
            if (!img.src) {
                resolve();
                return;
            }
            img.onload = resolve;
            img.onerror = resolve;
        });
    };
    var imagesReady = function(document1) {
        return Promise.all([].slice.call(document1.images, 0).map(imageReady));
    };
    var iframeLoader = function(iframe) {
        return new Promise(function(resolve, reject) {
            var cloneWindow = iframe.contentWindow;
            if (!cloneWindow) return reject("No window assigned for iframe");
            var documentClone = cloneWindow.document;
            cloneWindow.onload = iframe.onload = function() {
                cloneWindow.onload = iframe.onload = null;
                var interval = setInterval(function() {
                    if (documentClone.body.childNodes.length > 0 && documentClone.readyState === 'complete') {
                        clearInterval(interval);
                        resolve(iframe);
                    }
                }, 50);
            };
        });
    };
    var ignoredStyleProperties = [
        'all',
        'd',
        'content' // Safari shows pseudoelements if content is set
    ];
    var copyCSSStyles = function(style, target) {
        // Edge does not provide value for cssText
        for(var i = style.length - 1; i >= 0; i--){
            var property = style.item(i);
            if (ignoredStyleProperties.indexOf(property) === -1) target.style.setProperty(property, style.getPropertyValue(property));
        }
        return target;
    };
    var serializeDoctype = function(doctype) {
        var str = '';
        if (doctype) {
            str += '<!DOCTYPE ';
            if (doctype.name) str += doctype.name;
            if (doctype.internalSubset) str += doctype.internalSubset;
            if (doctype.publicId) str += "\"" + doctype.publicId + "\"";
            if (doctype.systemId) str += "\"" + doctype.systemId + "\"";
            str += '>';
        }
        return str;
    };
    var restoreOwnerScroll = function(ownerDocument, x, y) {
        if (ownerDocument && ownerDocument.defaultView && (x !== ownerDocument.defaultView.pageXOffset || y !== ownerDocument.defaultView.pageYOffset)) ownerDocument.defaultView.scrollTo(x, y);
    };
    var restoreNodeScroll = function(_a) {
        var element = _a[0], x = _a[1], y = _a[2];
        element.scrollLeft = x;
        element.scrollTop = y;
    };
    var PSEUDO_BEFORE = ':before';
    var PSEUDO_AFTER = ':after';
    var PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = '___html2canvas___pseudoelement_before';
    var PSEUDO_HIDE_ELEMENT_CLASS_AFTER = '___html2canvas___pseudoelement_after';
    var PSEUDO_HIDE_ELEMENT_STYLE = "{\n    content: \"\" !important;\n    display: none !important;\n}";
    var createPseudoHideStyles = function(body) {
        createStyles(body, "." + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + PSEUDO_BEFORE + PSEUDO_HIDE_ELEMENT_STYLE + "\n         ." + PSEUDO_HIDE_ELEMENT_CLASS_AFTER + PSEUDO_AFTER + PSEUDO_HIDE_ELEMENT_STYLE);
    };
    var createStyles = function(body, styles) {
        var document1 = body.ownerDocument;
        if (document1) {
            var style = document1.createElement('style');
            style.textContent = styles;
            body.appendChild(style);
        }
    };
    var CacheStorage = /** @class */ function() {
        function CacheStorage() {}
        CacheStorage.getOrigin = function(url) {
            var link = CacheStorage._link;
            if (!link) return 'about:blank';
            link.href = url;
            link.href = link.href; // IE9, LOL! - http://jsfiddle.net/niklasvh/2e48b/
            return link.protocol + link.hostname + link.port;
        };
        CacheStorage.isSameOrigin = function(src) {
            return CacheStorage.getOrigin(src) === CacheStorage._origin;
        };
        CacheStorage.setContext = function(window1) {
            CacheStorage._link = window1.document.createElement('a');
            CacheStorage._origin = CacheStorage.getOrigin(window1.location.href);
        };
        CacheStorage._origin = 'about:blank';
        return CacheStorage;
    }();
    var Cache = /** @class */ function() {
        function Cache(context, _options) {
            this.context = context;
            this._options = _options;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this._cache = {};
        }
        Cache.prototype.addImage = function(src) {
            var result = Promise.resolve();
            if (this.has(src)) return result;
            if (isBlobImage(src) || isRenderable(src)) {
                (this._cache[src] = this.loadImage(src)).catch(function() {
                // prevent unhandled rejection
                });
                return result;
            }
            return result;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Cache.prototype.match = function(src) {
            return this._cache[src];
        };
        Cache.prototype.loadImage = function(key) {
            return __awaiter(this, void 0, void 0, function() {
                var isSameOrigin, useCORS, useProxy, src;
                var _this = this;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            isSameOrigin = CacheStorage.isSameOrigin(key);
                            useCORS = !isInlineImage(key) && this._options.useCORS === true && FEATURES.SUPPORT_CORS_IMAGES && !isSameOrigin;
                            useProxy = !isInlineImage(key) && !isSameOrigin && !isBlobImage(key) && typeof this._options.proxy === 'string' && FEATURES.SUPPORT_CORS_XHR && !useCORS;
                            if (!isSameOrigin && this._options.allowTaint === false && !isInlineImage(key) && !isBlobImage(key) && !useProxy && !useCORS) return [
                                2 /*return*/ 
                            ];
                            src = key;
                            if (!useProxy) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.proxy(src)
                            ];
                        case 1:
                            src = _a.sent();
                            _a.label = 2;
                        case 2:
                            this.context.logger.debug("Added image " + key.substring(0, 256));
                            return [
                                4 /*yield*/ ,
                                new Promise(function(resolve, reject) {
                                    var img = new Image();
                                    img.onload = function() {
                                        return resolve(img);
                                    };
                                    img.onerror = reject;
                                    //ios safari 10.3 taints canvas with data urls unless crossOrigin is set to anonymous
                                    if (isInlineBase64Image(src) || useCORS) img.crossOrigin = 'anonymous';
                                    img.src = src;
                                    if (img.complete === true) // Inline XML images may fail to parse, throwing an Error later on
                                    setTimeout(function() {
                                        return resolve(img);
                                    }, 500);
                                    if (_this._options.imageTimeout > 0) setTimeout(function() {
                                        return reject("Timed out (" + _this._options.imageTimeout + "ms) loading image");
                                    }, _this._options.imageTimeout);
                                })
                            ];
                        case 3:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Cache.prototype.has = function(key) {
            return typeof this._cache[key] !== 'undefined';
        };
        Cache.prototype.keys = function() {
            return Promise.resolve(Object.keys(this._cache));
        };
        Cache.prototype.proxy = function(src) {
            var _this = this;
            var proxy = this._options.proxy;
            if (!proxy) throw new Error('No proxy defined');
            var key = src.substring(0, 256);
            return new Promise(function(resolve, reject) {
                var responseType = FEATURES.SUPPORT_RESPONSE_TYPE ? 'blob' : 'text';
                var xhr = new XMLHttpRequest();
                xhr.onload = function() {
                    if (xhr.status === 200) {
                        if (responseType === 'text') resolve(xhr.response);
                        else {
                            var reader_1 = new FileReader();
                            reader_1.addEventListener('load', function() {
                                return resolve(reader_1.result);
                            }, false);
                            reader_1.addEventListener('error', function(e) {
                                return reject(e);
                            }, false);
                            reader_1.readAsDataURL(xhr.response);
                        }
                    } else reject("Failed to proxy resource " + key + " with status code " + xhr.status);
                };
                xhr.onerror = reject;
                var queryString = proxy.indexOf('?') > -1 ? '&' : '?';
                xhr.open('GET', "" + proxy + queryString + "url=" + encodeURIComponent(src) + "&responseType=" + responseType);
                if (responseType !== 'text' && xhr instanceof XMLHttpRequest) xhr.responseType = responseType;
                if (_this._options.imageTimeout) {
                    var timeout_1 = _this._options.imageTimeout;
                    xhr.timeout = timeout_1;
                    xhr.ontimeout = function() {
                        return reject("Timed out (" + timeout_1 + "ms) proxying " + key);
                    };
                }
                xhr.send();
            });
        };
        return Cache;
    }();
    var INLINE_SVG = /^data:image\/svg\+xml/i;
    var INLINE_BASE64 = /^data:image\/.*;base64,/i;
    var INLINE_IMG = /^data:image\/.*/i;
    var isRenderable = function(src) {
        return FEATURES.SUPPORT_SVG_DRAWING || !isSVG(src);
    };
    var isInlineImage = function(src) {
        return INLINE_IMG.test(src);
    };
    var isInlineBase64Image = function(src) {
        return INLINE_BASE64.test(src);
    };
    var isBlobImage = function(src) {
        return src.substr(0, 4) === 'blob';
    };
    var isSVG = function(src) {
        return src.substr(-3).toLowerCase() === 'svg' || INLINE_SVG.test(src);
    };
    var Vector = /** @class */ function() {
        function Vector(x, y) {
            this.type = 0 /* VECTOR */ ;
            this.x = x;
            this.y = y;
        }
        Vector.prototype.add = function(deltaX, deltaY) {
            return new Vector(this.x + deltaX, this.y + deltaY);
        };
        return Vector;
    }();
    var lerp = function(a, b, t) {
        return new Vector(a.x + (b.x - a.x) * t, a.y + (b.y - a.y) * t);
    };
    var BezierCurve = /** @class */ function() {
        function BezierCurve(start, startControl, endControl, end) {
            this.type = 1 /* BEZIER_CURVE */ ;
            this.start = start;
            this.startControl = startControl;
            this.endControl = endControl;
            this.end = end;
        }
        BezierCurve.prototype.subdivide = function(t, firstHalf) {
            var ab = lerp(this.start, this.startControl, t);
            var bc = lerp(this.startControl, this.endControl, t);
            var cd = lerp(this.endControl, this.end, t);
            var abbc = lerp(ab, bc, t);
            var bccd = lerp(bc, cd, t);
            var dest = lerp(abbc, bccd, t);
            return firstHalf ? new BezierCurve(this.start, ab, abbc, dest) : new BezierCurve(dest, bccd, cd, this.end);
        };
        BezierCurve.prototype.add = function(deltaX, deltaY) {
            return new BezierCurve(this.start.add(deltaX, deltaY), this.startControl.add(deltaX, deltaY), this.endControl.add(deltaX, deltaY), this.end.add(deltaX, deltaY));
        };
        BezierCurve.prototype.reverse = function() {
            return new BezierCurve(this.end, this.endControl, this.startControl, this.start);
        };
        return BezierCurve;
    }();
    var isBezierCurve = function(path) {
        return path.type === 1 /* BEZIER_CURVE */ ;
    };
    var BoundCurves = /** @class */ function() {
        function BoundCurves(element) {
            var styles = element.styles;
            var bounds = element.bounds;
            var _a = getAbsoluteValueForTuple(styles.borderTopLeftRadius, bounds.width, bounds.height), tlh = _a[0], tlv = _a[1];
            var _b = getAbsoluteValueForTuple(styles.borderTopRightRadius, bounds.width, bounds.height), trh = _b[0], trv = _b[1];
            var _c = getAbsoluteValueForTuple(styles.borderBottomRightRadius, bounds.width, bounds.height), brh = _c[0], brv = _c[1];
            var _d = getAbsoluteValueForTuple(styles.borderBottomLeftRadius, bounds.width, bounds.height), blh = _d[0], blv = _d[1];
            var factors = [];
            factors.push((tlh + trh) / bounds.width);
            factors.push((blh + brh) / bounds.width);
            factors.push((tlv + blv) / bounds.height);
            factors.push((trv + brv) / bounds.height);
            var maxFactor = Math.max.apply(Math, factors);
            if (maxFactor > 1) {
                tlh /= maxFactor;
                tlv /= maxFactor;
                trh /= maxFactor;
                trv /= maxFactor;
                brh /= maxFactor;
                brv /= maxFactor;
                blh /= maxFactor;
                blv /= maxFactor;
            }
            var topWidth = bounds.width - trh;
            var rightHeight = bounds.height - brv;
            var bottomWidth = bounds.width - brh;
            var leftHeight = bounds.height - blv;
            var borderTopWidth = styles.borderTopWidth;
            var borderRightWidth = styles.borderRightWidth;
            var borderBottomWidth = styles.borderBottomWidth;
            var borderLeftWidth = styles.borderLeftWidth;
            var paddingTop = getAbsoluteValue(styles.paddingTop, element.bounds.width);
            var paddingRight = getAbsoluteValue(styles.paddingRight, element.bounds.width);
            var paddingBottom = getAbsoluteValue(styles.paddingBottom, element.bounds.width);
            var paddingLeft = getAbsoluteValue(styles.paddingLeft, element.bounds.width);
            this.topLeftBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3, tlh - borderLeftWidth / 3, tlv - borderTopWidth / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3);
            this.topRightBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 3, trh - borderRightWidth / 3, trv - borderTopWidth / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + borderTopWidth / 3);
            this.bottomRightBorderDoubleOuterBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 3, brv - borderBottomWidth / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.bottomLeftBorderDoubleOuterBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + leftHeight, blh - borderLeftWidth / 3, blv - borderBottomWidth / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.topLeftBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3, tlh - borderLeftWidth * 2 / 3, tlv - borderTopWidth * 2 / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3);
            this.topRightBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth * 2 / 3, trh - borderRightWidth * 2 / 3, trv - borderTopWidth * 2 / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3);
            this.bottomRightBorderDoubleInnerBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth * 2 / 3, brv - borderBottomWidth * 2 / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth * 2 / 3, bounds.top + bounds.height - borderBottomWidth * 2 / 3);
            this.bottomLeftBorderDoubleInnerBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth * 2 / 3, bounds.top + leftHeight, blh - borderLeftWidth * 2 / 3, blv - borderBottomWidth * 2 / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth * 2 / 3, bounds.top + bounds.height - borderBottomWidth * 2 / 3);
            this.topLeftBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2, tlh - borderLeftWidth / 2, tlv - borderTopWidth / 2, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2);
            this.topRightBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 2, trh - borderRightWidth / 2, trv - borderTopWidth / 2, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + borderTopWidth / 2);
            this.bottomRightBorderStroke = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 2, brv - borderBottomWidth / 2, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.bottomLeftBorderStroke = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + leftHeight, blh - borderLeftWidth / 2, blv - borderBottomWidth / 2, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.topLeftBorderBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left, bounds.top, tlh, tlv, CORNER.TOP_LEFT) : new Vector(bounds.left, bounds.top);
            this.topRightBorderBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top, trh, trv, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top);
            this.bottomRightBorderBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh, brv, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top + bounds.height);
            this.bottomLeftBorderBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left, bounds.top + leftHeight, blh, blv, CORNER.BOTTOM_LEFT) : new Vector(bounds.left, bounds.top + bounds.height);
            this.topLeftPaddingBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + borderTopWidth, Math.max(0, tlh - borderLeftWidth), Math.max(0, tlv - borderTopWidth), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth, bounds.top + borderTopWidth);
            this.topRightPaddingBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width - borderRightWidth), bounds.top + borderTopWidth, topWidth > bounds.width + borderRightWidth ? 0 : Math.max(0, trh - borderRightWidth), Math.max(0, trv - borderTopWidth), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + borderTopWidth);
            this.bottomRightPaddingBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - borderLeftWidth), bounds.top + Math.min(rightHeight, bounds.height - borderBottomWidth), Math.max(0, brh - borderRightWidth), Math.max(0, brv - borderBottomWidth), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + bounds.height - borderBottomWidth);
            this.bottomLeftPaddingBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + Math.min(leftHeight, bounds.height - borderBottomWidth), Math.max(0, blh - borderLeftWidth), Math.max(0, blv - borderBottomWidth), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth, bounds.top + bounds.height - borderBottomWidth);
            this.topLeftContentBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop, Math.max(0, tlh - (borderLeftWidth + paddingLeft)), Math.max(0, tlv - (borderTopWidth + paddingTop)), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop);
            this.topRightContentBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width + borderLeftWidth + paddingLeft), bounds.top + borderTopWidth + paddingTop, topWidth > bounds.width + borderLeftWidth + paddingLeft ? 0 : trh - borderLeftWidth + paddingLeft, trv - (borderTopWidth + paddingTop), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + borderTopWidth + paddingTop);
            this.bottomRightContentBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - (borderLeftWidth + paddingLeft)), bounds.top + Math.min(rightHeight, bounds.height + borderTopWidth + paddingTop), Math.max(0, brh - (borderRightWidth + paddingRight)), brv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
            this.bottomLeftContentBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + leftHeight, Math.max(0, blh - (borderLeftWidth + paddingLeft)), blv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
        }
        return BoundCurves;
    }();
    var CORNER;
    (function(CORNER) {
        CORNER[CORNER["TOP_LEFT"] = 0] = "TOP_LEFT";
        CORNER[CORNER["TOP_RIGHT"] = 1] = "TOP_RIGHT";
        CORNER[CORNER["BOTTOM_RIGHT"] = 2] = "BOTTOM_RIGHT";
        CORNER[CORNER["BOTTOM_LEFT"] = 3] = "BOTTOM_LEFT";
    })(CORNER || (CORNER = {}));
    var getCurvePoints = function(x, y, r1, r2, position) {
        var kappa = 4 * ((Math.sqrt(2) - 1) / 3);
        var ox = r1 * kappa; // control point offset horizontal
        var oy = r2 * kappa; // control point offset vertical
        var xm = x + r1; // x-middle
        var ym = y + r2; // y-middle
        switch(position){
            case CORNER.TOP_LEFT:
                return new BezierCurve(new Vector(x, ym), new Vector(x, ym - oy), new Vector(xm - ox, y), new Vector(xm, y));
            case CORNER.TOP_RIGHT:
                return new BezierCurve(new Vector(x, y), new Vector(x + ox, y), new Vector(xm, ym - oy), new Vector(xm, ym));
            case CORNER.BOTTOM_RIGHT:
                return new BezierCurve(new Vector(xm, y), new Vector(xm, y + oy), new Vector(x + ox, ym), new Vector(x, ym));
            case CORNER.BOTTOM_LEFT:
            default:
                return new BezierCurve(new Vector(xm, ym), new Vector(xm - ox, ym), new Vector(x, y + oy), new Vector(x, y));
        }
    };
    var calculateBorderBoxPath = function(curves) {
        return [
            curves.topLeftBorderBox,
            curves.topRightBorderBox,
            curves.bottomRightBorderBox,
            curves.bottomLeftBorderBox
        ];
    };
    var calculateContentBoxPath = function(curves) {
        return [
            curves.topLeftContentBox,
            curves.topRightContentBox,
            curves.bottomRightContentBox,
            curves.bottomLeftContentBox
        ];
    };
    var calculatePaddingBoxPath = function(curves) {
        return [
            curves.topLeftPaddingBox,
            curves.topRightPaddingBox,
            curves.bottomRightPaddingBox,
            curves.bottomLeftPaddingBox
        ];
    };
    var TransformEffect = /** @class */ function() {
        function TransformEffect(offsetX, offsetY, matrix) {
            this.offsetX = offsetX;
            this.offsetY = offsetY;
            this.matrix = matrix;
            this.type = 0 /* TRANSFORM */ ;
            this.target = 6 /* CONTENT */ ;
        }
        return TransformEffect;
    }();
    var ClipEffect = /** @class */ function() {
        function ClipEffect(path, target) {
            this.path = path;
            this.target = target;
            this.type = 1 /* CLIP */ ;
        }
        return ClipEffect;
    }();
    var OpacityEffect = /** @class */ function() {
        function OpacityEffect(opacity) {
            this.opacity = opacity;
            this.type = 2 /* OPACITY */ ;
            this.target = 6 /* CONTENT */ ;
        }
        return OpacityEffect;
    }();
    var isTransformEffect = function(effect) {
        return effect.type === 0 /* TRANSFORM */ ;
    };
    var isClipEffect = function(effect) {
        return effect.type === 1 /* CLIP */ ;
    };
    var isOpacityEffect = function(effect) {
        return effect.type === 2 /* OPACITY */ ;
    };
    var equalPath = function(a, b) {
        if (a.length === b.length) return a.some(function(v, i) {
            return v === b[i];
        });
        return false;
    };
    var transformPath = function(path, deltaX, deltaY, deltaW, deltaH) {
        return path.map(function(point, index) {
            switch(index){
                case 0:
                    return point.add(deltaX, deltaY);
                case 1:
                    return point.add(deltaX + deltaW, deltaY);
                case 2:
                    return point.add(deltaX + deltaW, deltaY + deltaH);
                case 3:
                    return point.add(deltaX, deltaY + deltaH);
            }
            return point;
        });
    };
    var StackingContext = /** @class */ function() {
        function StackingContext(container) {
            this.element = container;
            this.inlineLevel = [];
            this.nonInlineLevel = [];
            this.negativeZIndex = [];
            this.zeroOrAutoZIndexOrTransformedOrOpacity = [];
            this.positiveZIndex = [];
            this.nonPositionedFloats = [];
            this.nonPositionedInlineLevel = [];
        }
        return StackingContext;
    }();
    var ElementPaint = /** @class */ function() {
        function ElementPaint(container, parent) {
            this.container = container;
            this.parent = parent;
            this.effects = [];
            this.curves = new BoundCurves(this.container);
            if (this.container.styles.opacity < 1) this.effects.push(new OpacityEffect(this.container.styles.opacity));
            if (this.container.styles.transform !== null) {
                var offsetX = this.container.bounds.left + this.container.styles.transformOrigin[0].number;
                var offsetY = this.container.bounds.top + this.container.styles.transformOrigin[1].number;
                var matrix = this.container.styles.transform;
                this.effects.push(new TransformEffect(offsetX, offsetY, matrix));
            }
            if (this.container.styles.overflowX !== 0 /* VISIBLE */ ) {
                var borderBox = calculateBorderBoxPath(this.curves);
                var paddingBox = calculatePaddingBoxPath(this.curves);
                if (equalPath(borderBox, paddingBox)) this.effects.push(new ClipEffect(borderBox, 6 /* CONTENT */ ));
                else {
                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */ ));
                    this.effects.push(new ClipEffect(paddingBox, 4 /* CONTENT */ ));
                }
            }
        }
        ElementPaint.prototype.getEffects = function(target) {
            var inFlow = [
                2 /* ABSOLUTE */ ,
                3 /* FIXED */ 
            ].indexOf(this.container.styles.position) === -1;
            var parent = this.parent;
            var effects = this.effects.slice(0);
            while(parent){
                var croplessEffects = parent.effects.filter(function(effect) {
                    return !isClipEffect(effect);
                });
                if (inFlow || parent.container.styles.position !== 0 /* STATIC */  || !parent.parent) {
                    effects.unshift.apply(effects, croplessEffects);
                    inFlow = [
                        2 /* ABSOLUTE */ ,
                        3 /* FIXED */ 
                    ].indexOf(parent.container.styles.position) === -1;
                    if (parent.container.styles.overflowX !== 0 /* VISIBLE */ ) {
                        var borderBox = calculateBorderBoxPath(parent.curves);
                        var paddingBox = calculatePaddingBoxPath(parent.curves);
                        if (!equalPath(borderBox, paddingBox)) effects.unshift(new ClipEffect(paddingBox, 6 /* CONTENT */ ));
                    }
                } else effects.unshift.apply(effects, croplessEffects);
                parent = parent.parent;
            }
            return effects.filter(function(effect) {
                return contains(effect.target, target);
            });
        };
        return ElementPaint;
    }();
    var parseStackTree = function(parent, stackingContext, realStackingContext, listItems) {
        parent.container.elements.forEach(function(child) {
            var treatAsRealStackingContext = contains(child.flags, 4 /* CREATES_REAL_STACKING_CONTEXT */ );
            var createsStackingContext = contains(child.flags, 2 /* CREATES_STACKING_CONTEXT */ );
            var paintContainer = new ElementPaint(child, parent);
            if (contains(child.styles.display, 2048 /* LIST_ITEM */ )) listItems.push(paintContainer);
            var listOwnerItems = contains(child.flags, 8 /* IS_LIST_OWNER */ ) ? [] : listItems;
            if (treatAsRealStackingContext || createsStackingContext) {
                var parentStack = treatAsRealStackingContext || child.styles.isPositioned() ? realStackingContext : stackingContext;
                var stack = new StackingContext(paintContainer);
                if (child.styles.isPositioned() || child.styles.opacity < 1 || child.styles.isTransformed()) {
                    var order_1 = child.styles.zIndex.order;
                    if (order_1 < 0) {
                        var index_1 = 0;
                        parentStack.negativeZIndex.some(function(current, i) {
                            if (order_1 > current.element.container.styles.zIndex.order) {
                                index_1 = i;
                                return false;
                            } else if (index_1 > 0) return true;
                            return false;
                        });
                        parentStack.negativeZIndex.splice(index_1, 0, stack);
                    } else if (order_1 > 0) {
                        var index_2 = 0;
                        parentStack.positiveZIndex.some(function(current, i) {
                            if (order_1 >= current.element.container.styles.zIndex.order) {
                                index_2 = i + 1;
                                return false;
                            } else if (index_2 > 0) return true;
                            return false;
                        });
                        parentStack.positiveZIndex.splice(index_2, 0, stack);
                    } else parentStack.zeroOrAutoZIndexOrTransformedOrOpacity.push(stack);
                } else if (child.styles.isFloating()) parentStack.nonPositionedFloats.push(stack);
                else parentStack.nonPositionedInlineLevel.push(stack);
                parseStackTree(paintContainer, stack, treatAsRealStackingContext ? stack : realStackingContext, listOwnerItems);
            } else {
                if (child.styles.isInlineLevel()) stackingContext.inlineLevel.push(paintContainer);
                else stackingContext.nonInlineLevel.push(paintContainer);
                parseStackTree(paintContainer, stackingContext, realStackingContext, listOwnerItems);
            }
            if (contains(child.flags, 8 /* IS_LIST_OWNER */ )) processListItems(child, listOwnerItems);
        });
    };
    var processListItems = function(owner, elements) {
        var numbering = owner instanceof OLElementContainer ? owner.start : 1;
        var reversed = owner instanceof OLElementContainer ? owner.reversed : false;
        for(var i = 0; i < elements.length; i++){
            var item = elements[i];
            if (item.container instanceof LIElementContainer && typeof item.container.value === 'number' && item.container.value !== 0) numbering = item.container.value;
            item.listValue = createCounterText(numbering, item.container.styles.listStyleType, true);
            numbering += reversed ? -1 : 1;
        }
    };
    var parseStackingContexts = function(container) {
        var paintContainer = new ElementPaint(container, null);
        var root = new StackingContext(paintContainer);
        var listItems = [];
        parseStackTree(paintContainer, root, root, listItems);
        processListItems(paintContainer.container, listItems);
        return root;
    };
    var parsePathForBorder = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftPaddingBox, curves.topRightBorderBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightPaddingBox, curves.bottomRightBorderBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox, curves.topLeftBorderBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderDoubleOuter = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox, curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox, curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox, curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox, curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox);
        }
    };
    var parsePathForBorderDoubleInner = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox, curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox, curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox, curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderStroke = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createStrokePathFromCurves(curves.topLeftBorderStroke, curves.topRightBorderStroke);
            case 1:
                return createStrokePathFromCurves(curves.topRightBorderStroke, curves.bottomRightBorderStroke);
            case 2:
                return createStrokePathFromCurves(curves.bottomRightBorderStroke, curves.bottomLeftBorderStroke);
            case 3:
            default:
                return createStrokePathFromCurves(curves.bottomLeftBorderStroke, curves.topLeftBorderStroke);
        }
    };
    var createStrokePathFromCurves = function(outer1, outer2) {
        var path = [];
        if (isBezierCurve(outer1)) path.push(outer1.subdivide(0.5, false));
        else path.push(outer1);
        if (isBezierCurve(outer2)) path.push(outer2.subdivide(0.5, true));
        else path.push(outer2);
        return path;
    };
    var createPathFromCurves = function(outer1, inner1, outer2, inner2) {
        var path = [];
        if (isBezierCurve(outer1)) path.push(outer1.subdivide(0.5, false));
        else path.push(outer1);
        if (isBezierCurve(outer2)) path.push(outer2.subdivide(0.5, true));
        else path.push(outer2);
        if (isBezierCurve(inner2)) path.push(inner2.subdivide(0.5, true).reverse());
        else path.push(inner2);
        if (isBezierCurve(inner1)) path.push(inner1.subdivide(0.5, false).reverse());
        else path.push(inner1);
        return path;
    };
    var paddingBox = function(element) {
        var bounds = element.bounds;
        var styles = element.styles;
        return bounds.add(styles.borderLeftWidth, styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth), -(styles.borderTopWidth + styles.borderBottomWidth));
    };
    var contentBox = function(element) {
        var styles = element.styles;
        var bounds = element.bounds;
        var paddingLeft = getAbsoluteValue(styles.paddingLeft, bounds.width);
        var paddingRight = getAbsoluteValue(styles.paddingRight, bounds.width);
        var paddingTop = getAbsoluteValue(styles.paddingTop, bounds.width);
        var paddingBottom = getAbsoluteValue(styles.paddingBottom, bounds.width);
        return bounds.add(paddingLeft + styles.borderLeftWidth, paddingTop + styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth + paddingLeft + paddingRight), -(styles.borderTopWidth + styles.borderBottomWidth + paddingTop + paddingBottom));
    };
    var calculateBackgroundPositioningArea = function(backgroundOrigin, element) {
        if (backgroundOrigin === 0 /* BORDER_BOX */ ) return element.bounds;
        if (backgroundOrigin === 2 /* CONTENT_BOX */ ) return contentBox(element);
        return paddingBox(element);
    };
    var calculateBackgroundPaintingArea = function(backgroundClip, element) {
        if (backgroundClip === 0 /* BORDER_BOX */ ) return element.bounds;
        if (backgroundClip === 2 /* CONTENT_BOX */ ) return contentBox(element);
        return paddingBox(element);
    };
    var calculateBackgroundRendering = function(container, index, intrinsicSize) {
        var backgroundPositioningArea = calculateBackgroundPositioningArea(getBackgroundValueForIndex(container.styles.backgroundOrigin, index), container);
        var backgroundPaintingArea = calculateBackgroundPaintingArea(getBackgroundValueForIndex(container.styles.backgroundClip, index), container);
        var backgroundImageSize = calculateBackgroundSize(getBackgroundValueForIndex(container.styles.backgroundSize, index), intrinsicSize, backgroundPositioningArea);
        var sizeWidth = backgroundImageSize[0], sizeHeight = backgroundImageSize[1];
        var position = getAbsoluteValueForTuple(getBackgroundValueForIndex(container.styles.backgroundPosition, index), backgroundPositioningArea.width - sizeWidth, backgroundPositioningArea.height - sizeHeight);
        var path = calculateBackgroundRepeatPath(getBackgroundValueForIndex(container.styles.backgroundRepeat, index), position, backgroundImageSize, backgroundPositioningArea, backgroundPaintingArea);
        var offsetX = Math.round(backgroundPositioningArea.left + position[0]);
        var offsetY = Math.round(backgroundPositioningArea.top + position[1]);
        return [
            path,
            offsetX,
            offsetY,
            sizeWidth,
            sizeHeight
        ];
    };
    var isAuto = function(token) {
        return isIdentToken(token) && token.value === BACKGROUND_SIZE.AUTO;
    };
    var hasIntrinsicValue = function(value) {
        return typeof value === 'number';
    };
    var calculateBackgroundSize = function(size, _a, bounds) {
        var intrinsicWidth = _a[0], intrinsicHeight = _a[1], intrinsicProportion = _a[2];
        var first = size[0], second = size[1];
        if (!first) return [
            0,
            0
        ];
        if (isLengthPercentage(first) && second && isLengthPercentage(second)) return [
            getAbsoluteValue(first, bounds.width),
            getAbsoluteValue(second, bounds.height)
        ];
        var hasIntrinsicProportion = hasIntrinsicValue(intrinsicProportion);
        if (isIdentToken(first) && (first.value === BACKGROUND_SIZE.CONTAIN || first.value === BACKGROUND_SIZE.COVER)) {
            if (hasIntrinsicValue(intrinsicProportion)) {
                var targetRatio = bounds.width / bounds.height;
                return targetRatio < intrinsicProportion !== (first.value === BACKGROUND_SIZE.COVER) ? [
                    bounds.width,
                    bounds.width / intrinsicProportion
                ] : [
                    bounds.height * intrinsicProportion,
                    bounds.height
                ];
            }
            return [
                bounds.width,
                bounds.height
            ];
        }
        var hasIntrinsicWidth = hasIntrinsicValue(intrinsicWidth);
        var hasIntrinsicHeight = hasIntrinsicValue(intrinsicHeight);
        var hasIntrinsicDimensions = hasIntrinsicWidth || hasIntrinsicHeight;
        // If the background-size is auto or auto auto:
        if (isAuto(first) && (!second || isAuto(second))) {
            // If the image has both horizontal and vertical intrinsic dimensions, it's rendered at that size.
            if (hasIntrinsicWidth && hasIntrinsicHeight) return [
                intrinsicWidth,
                intrinsicHeight
            ];
            // If the image has no intrinsic dimensions and has no intrinsic proportions,
            // it's rendered at the size of the background positioning area.
            if (!hasIntrinsicProportion && !hasIntrinsicDimensions) return [
                bounds.width,
                bounds.height
            ];
            // TODO If the image has no intrinsic dimensions but has intrinsic proportions, it's rendered as if contain had been specified instead.
            // If the image has only one intrinsic dimension and has intrinsic proportions, it's rendered at the size corresponding to that one dimension.
            // The other dimension is computed using the specified dimension and the intrinsic proportions.
            if (hasIntrinsicDimensions && hasIntrinsicProportion) {
                var width_1 = hasIntrinsicWidth ? intrinsicWidth : intrinsicHeight * intrinsicProportion;
                var height_1 = hasIntrinsicHeight ? intrinsicHeight : intrinsicWidth / intrinsicProportion;
                return [
                    width_1,
                    height_1
                ];
            }
            // If the image has only one intrinsic dimension but has no intrinsic proportions,
            // it's rendered using the specified dimension and the other dimension of the background positioning area.
            var width_2 = hasIntrinsicWidth ? intrinsicWidth : bounds.width;
            var height_2 = hasIntrinsicHeight ? intrinsicHeight : bounds.height;
            return [
                width_2,
                height_2
            ];
        }
        // If the image has intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the specified dimension and the intrinsic proportions.
        if (hasIntrinsicProportion) {
            var width_3 = 0;
            var height_3 = 0;
            if (isLengthPercentage(first)) width_3 = getAbsoluteValue(first, bounds.width);
            else if (isLengthPercentage(second)) height_3 = getAbsoluteValue(second, bounds.height);
            if (isAuto(first)) width_3 = height_3 * intrinsicProportion;
            else if (!second || isAuto(second)) height_3 = width_3 / intrinsicProportion;
            return [
                width_3,
                height_3
            ];
        }
        // If the image has no intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the image's corresponding intrinsic dimension,
        // if there is one. If there is no such intrinsic dimension,
        // it becomes the corresponding dimension of the background positioning area.
        var width = null;
        var height = null;
        if (isLengthPercentage(first)) width = getAbsoluteValue(first, bounds.width);
        else if (second && isLengthPercentage(second)) height = getAbsoluteValue(second, bounds.height);
        if (width !== null && (!second || isAuto(second))) height = hasIntrinsicWidth && hasIntrinsicHeight ? width / intrinsicWidth * intrinsicHeight : bounds.height;
        if (height !== null && isAuto(first)) width = hasIntrinsicWidth && hasIntrinsicHeight ? height / intrinsicHeight * intrinsicWidth : bounds.width;
        if (width !== null && height !== null) return [
            width,
            height
        ];
        throw new Error("Unable to calculate background-size for element");
    };
    var getBackgroundValueForIndex = function(values, index) {
        var value = values[index];
        if (typeof value === 'undefined') return values[0];
        return value;
    };
    var calculateBackgroundRepeatPath = function(repeat, _a, _b, backgroundPositioningArea, backgroundPaintingArea) {
        var x = _a[0], y = _a[1];
        var width = _b[0], height = _b[1];
        switch(repeat){
            case 2 /* REPEAT_X */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(height + backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(height + backgroundPositioningArea.top + y))
                ];
            case 3 /* REPEAT_Y */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top))
                ];
            case 1 /* NO_REPEAT */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y + height)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y + height))
                ];
            default:
                return [
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top))
                ];
        }
    };
    var SMALL_IMAGE = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
    var SAMPLE_TEXT = 'Hidden Text';
    var FontMetrics = /** @class */ function() {
        function FontMetrics(document1) {
            this._data = {};
            this._document = document1;
        }
        FontMetrics.prototype.parseMetrics = function(fontFamily, fontSize) {
            var container = this._document.createElement('div');
            var img = this._document.createElement('img');
            var span = this._document.createElement('span');
            var body = this._document.body;
            container.style.visibility = 'hidden';
            container.style.fontFamily = fontFamily;
            container.style.fontSize = fontSize;
            container.style.margin = '0';
            container.style.padding = '0';
            container.style.whiteSpace = 'nowrap';
            body.appendChild(container);
            img.src = SMALL_IMAGE;
            img.width = 1;
            img.height = 1;
            img.style.margin = '0';
            img.style.padding = '0';
            img.style.verticalAlign = 'baseline';
            span.style.fontFamily = fontFamily;
            span.style.fontSize = fontSize;
            span.style.margin = '0';
            span.style.padding = '0';
            span.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.appendChild(span);
            container.appendChild(img);
            var baseline = img.offsetTop - span.offsetTop + 2;
            container.removeChild(span);
            container.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.style.lineHeight = 'normal';
            img.style.verticalAlign = 'super';
            var middle = img.offsetTop - container.offsetTop + 2;
            body.removeChild(container);
            return {
                baseline: baseline,
                middle: middle
            };
        };
        FontMetrics.prototype.getMetrics = function(fontFamily, fontSize) {
            var key = fontFamily + " " + fontSize;
            if (typeof this._data[key] === 'undefined') this._data[key] = this.parseMetrics(fontFamily, fontSize);
            return this._data[key];
        };
        return FontMetrics;
    }();
    var Renderer = /** @class */ function() {
        function Renderer(context, options) {
            this.context = context;
            this.options = options;
        }
        return Renderer;
    }();
    var MASK_OFFSET = 10000;
    var CanvasRenderer = /** @class */ function(_super) {
        __extends(CanvasRenderer, _super);
        function CanvasRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this._activeEffects = [];
            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            _this.ctx = _this.canvas.getContext('2d');
            if (!options.canvas) {
                _this.canvas.width = Math.floor(options.width * options.scale);
                _this.canvas.height = Math.floor(options.height * options.scale);
                _this.canvas.style.width = options.width + "px";
                _this.canvas.style.height = options.height + "px";
            }
            _this.fontMetrics = new FontMetrics(document);
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.ctx.textBaseline = 'bottom';
            _this._activeEffects = [];
            _this.context.logger.debug("Canvas renderer initialized (" + options.width + "x" + options.height + ") with scale " + options.scale);
            return _this;
        }
        CanvasRenderer.prototype.applyEffects = function(effects) {
            var _this = this;
            while(this._activeEffects.length)this.popEffect();
            effects.forEach(function(effect) {
                return _this.applyEffect(effect);
            });
        };
        CanvasRenderer.prototype.applyEffect = function(effect) {
            this.ctx.save();
            if (isOpacityEffect(effect)) this.ctx.globalAlpha = effect.opacity;
            if (isTransformEffect(effect)) {
                this.ctx.translate(effect.offsetX, effect.offsetY);
                this.ctx.transform(effect.matrix[0], effect.matrix[1], effect.matrix[2], effect.matrix[3], effect.matrix[4], effect.matrix[5]);
                this.ctx.translate(-effect.offsetX, -effect.offsetY);
            }
            if (isClipEffect(effect)) {
                this.path(effect.path);
                this.ctx.clip();
            }
            this._activeEffects.push(effect);
        };
        CanvasRenderer.prototype.popEffect = function() {
            this._activeEffects.pop();
            this.ctx.restore();
        };
        CanvasRenderer.prototype.renderStack = function(stack) {
            return __awaiter(this, void 0, void 0, function() {
                var styles;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            styles = stack.element.container.styles;
                            if (!styles.isVisible()) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderStackContent(stack)
                            ];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNode = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (contains(paint.container.flags, 16 /* DEBUG_RENDER */ )) debugger;
                            if (!paint.container.styles.isVisible()) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderNodeBackgroundAndBorders(paint)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                4 /*yield*/ ,
                                this.renderNodeContent(paint)
                            ];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderTextWithLetterSpacing = function(text, letterSpacing, baseline) {
            var _this = this;
            if (letterSpacing === 0) this.ctx.fillText(text.text, text.bounds.left, text.bounds.top + baseline);
            else {
                var letters = segmentGraphemes(text.text);
                letters.reduce(function(left, letter) {
                    _this.ctx.fillText(letter, left, text.bounds.top + baseline);
                    return left + _this.ctx.measureText(letter).width;
                }, text.bounds.left);
            }
        };
        CanvasRenderer.prototype.createFontStyle = function(styles) {
            var fontVariant = styles.fontVariant.filter(function(variant) {
                return variant === 'normal' || variant === 'small-caps';
            }).join('');
            var fontFamily = fixIOSSystemFonts(styles.fontFamily).join(', ');
            var fontSize = isDimensionToken(styles.fontSize) ? "" + styles.fontSize.number + styles.fontSize.unit : styles.fontSize.number + "px";
            return [
                [
                    styles.fontStyle,
                    fontVariant,
                    styles.fontWeight,
                    fontSize,
                    fontFamily
                ].join(' '),
                fontFamily,
                fontSize
            ];
        };
        CanvasRenderer.prototype.renderTextNode = function(text, styles) {
            return __awaiter(this, void 0, void 0, function() {
                var _a, font, fontFamily, fontSize, _b, baseline, middle, paintOrder;
                var _this = this;
                return __generator(this, function(_c) {
                    _a = this.createFontStyle(styles), font = _a[0], fontFamily = _a[1], fontSize = _a[2];
                    this.ctx.font = font;
                    this.ctx.direction = styles.direction === 1 /* RTL */  ? 'rtl' : 'ltr';
                    this.ctx.textAlign = 'left';
                    this.ctx.textBaseline = 'alphabetic';
                    _b = this.fontMetrics.getMetrics(fontFamily, fontSize), baseline = _b.baseline, middle = _b.middle;
                    paintOrder = styles.paintOrder;
                    text.textBounds.forEach(function(text) {
                        paintOrder.forEach(function(paintOrderLayer) {
                            switch(paintOrderLayer){
                                case 0 /* FILL */ :
                                    _this.ctx.fillStyle = asString(styles.color);
                                    _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                    var textShadows = styles.textShadow;
                                    if (textShadows.length && text.text.trim().length) {
                                        textShadows.slice(0).reverse().forEach(function(textShadow) {
                                            _this.ctx.shadowColor = asString(textShadow.color);
                                            _this.ctx.shadowOffsetX = textShadow.offsetX.number * _this.options.scale;
                                            _this.ctx.shadowOffsetY = textShadow.offsetY.number * _this.options.scale;
                                            _this.ctx.shadowBlur = textShadow.blur.number;
                                            _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                        });
                                        _this.ctx.shadowColor = '';
                                        _this.ctx.shadowOffsetX = 0;
                                        _this.ctx.shadowOffsetY = 0;
                                        _this.ctx.shadowBlur = 0;
                                    }
                                    if (styles.textDecorationLine.length) {
                                        _this.ctx.fillStyle = asString(styles.textDecorationColor || styles.color);
                                        styles.textDecorationLine.forEach(function(textDecorationLine) {
                                            switch(textDecorationLine){
                                                case 1 /* UNDERLINE */ :
                                                    // Draws a line at the baseline of the font
                                                    // TODO As some browsers display the line as more than 1px if the font-size is big,
                                                    // need to take that into account both in position and size
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top + baseline), text.bounds.width, 1);
                                                    break;
                                                case 2 /* OVERLINE */ :
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top), text.bounds.width, 1);
                                                    break;
                                                case 3 /* LINE_THROUGH */ :
                                                    // TODO try and find exact position for line-through
                                                    _this.ctx.fillRect(text.bounds.left, Math.ceil(text.bounds.top + middle), text.bounds.width, 1);
                                                    break;
                                            }
                                        });
                                    }
                                    break;
                                case 1 /* STROKE */ :
                                    if (styles.webkitTextStrokeWidth && text.text.trim().length) {
                                        _this.ctx.strokeStyle = asString(styles.webkitTextStrokeColor);
                                        _this.ctx.lineWidth = styles.webkitTextStrokeWidth;
                                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                        _this.ctx.lineJoin = !!window.chrome ? 'miter' : 'round';
                                        _this.ctx.strokeText(text.text, text.bounds.left, text.bounds.top + baseline);
                                    }
                                    _this.ctx.strokeStyle = '';
                                    _this.ctx.lineWidth = 0;
                                    _this.ctx.lineJoin = 'miter';
                                    break;
                            }
                        });
                    });
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.renderReplacedElement = function(container, curves, image) {
            if (image && container.intrinsicWidth > 0 && container.intrinsicHeight > 0) {
                var box = contentBox(container);
                var path = calculatePaddingBoxPath(curves);
                this.path(path);
                this.ctx.save();
                this.ctx.clip();
                this.ctx.drawImage(image, 0, 0, container.intrinsicWidth, container.intrinsicHeight, box.left, box.top, box.width, box.height);
                this.ctx.restore();
            }
        };
        CanvasRenderer.prototype.renderNodeContent = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                var container, curves, styles, _i, _a, child, image, image, iframeRenderer, canvas, size, _b, fontFamily, fontSize, baseline, bounds, x, textBounds, img, image, url, fontFamily, bounds;
                return __generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            this.applyEffects(paint.getEffects(4 /* CONTENT */ ));
                            container = paint.container;
                            curves = paint.curves;
                            styles = container.styles;
                            _i = 0, _a = container.textNodes;
                            _c.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                4
                            ];
                            child = _a[_i];
                            return [
                                4 /*yield*/ ,
                                this.renderTextNode(child, styles)
                            ];
                        case 2:
                            _c.sent();
                            _c.label = 3;
                        case 3:
                            _i++;
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 4:
                            if (!(container instanceof ImageElementContainer)) return [
                                3 /*break*/ ,
                                8
                            ];
                            _c.label = 5;
                        case 5:
                            _c.trys.push([
                                5,
                                7,
                                ,
                                8
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(container.src)
                            ];
                        case 6:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 7:
                            _c.sent();
                            this.context.logger.error("Error loading image " + container.src);
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 8:
                            if (container instanceof CanvasElementContainer) this.renderReplacedElement(container, curves, container.canvas);
                            if (!(container instanceof SVGElementContainer)) return [
                                3 /*break*/ ,
                                12
                            ];
                            _c.label = 9;
                        case 9:
                            _c.trys.push([
                                9,
                                11,
                                ,
                                12
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(container.svg)
                            ];
                        case 10:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 11:
                            _c.sent();
                            this.context.logger.error("Error loading svg " + container.svg.substring(0, 255));
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 12:
                            if (!(container instanceof IFrameElementContainer && container.tree)) return [
                                3 /*break*/ ,
                                14
                            ];
                            iframeRenderer = new CanvasRenderer(this.context, {
                                scale: this.options.scale,
                                backgroundColor: container.backgroundColor,
                                x: 0,
                                y: 0,
                                width: container.width,
                                height: container.height
                            });
                            return [
                                4 /*yield*/ ,
                                iframeRenderer.render(container.tree)
                            ];
                        case 13:
                            canvas = _c.sent();
                            if (container.width && container.height) this.ctx.drawImage(canvas, 0, 0, container.width, container.height, container.bounds.left, container.bounds.top, container.bounds.width, container.bounds.height);
                            _c.label = 14;
                        case 14:
                            if (container instanceof InputElementContainer) {
                                size = Math.min(container.bounds.width, container.bounds.height);
                                if (container.type === CHECKBOX) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.path([
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79),
                                            new Vector(container.bounds.left + size * 0.16, container.bounds.top + size * 0.5549),
                                            new Vector(container.bounds.left + size * 0.27347, container.bounds.top + size * 0.44071),
                                            new Vector(container.bounds.left + size * 0.39694, container.bounds.top + size * 0.5649),
                                            new Vector(container.bounds.left + size * 0.72983, container.bounds.top + size * 0.23),
                                            new Vector(container.bounds.left + size * 0.84, container.bounds.top + size * 0.34085),
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79)
                                        ]);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                } else if (container.type === RADIO) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.ctx.beginPath();
                                        this.ctx.arc(container.bounds.left + size / 2, container.bounds.top + size / 2, size / 4, 0, Math.PI * 2, true);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                }
                            }
                            if (isTextInputElement(container) && container.value.length) {
                                _b = this.createFontStyle(styles), fontFamily = _b[0], fontSize = _b[1];
                                baseline = this.fontMetrics.getMetrics(fontFamily, fontSize).baseline;
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = canvasTextAlign(container.styles.textAlign);
                                bounds = contentBox(container);
                                x = 0;
                                switch(container.styles.textAlign){
                                    case 1 /* CENTER */ :
                                        x += bounds.width / 2;
                                        break;
                                    case 2 /* RIGHT */ :
                                        x += bounds.width;
                                        break;
                                }
                                textBounds = bounds.add(x, 0, 0, -bounds.height / 2 + 1);
                                this.ctx.save();
                                this.path([
                                    new Vector(bounds.left, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top + bounds.height),
                                    new Vector(bounds.left, bounds.top + bounds.height)
                                ]);
                                this.ctx.clip();
                                this.renderTextWithLetterSpacing(new TextBounds(container.value, textBounds), styles.letterSpacing, baseline);
                                this.ctx.restore();
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = 'left';
                            }
                            if (!contains(container.styles.display, 2048 /* LIST_ITEM */ )) return [
                                3 /*break*/ ,
                                20
                            ];
                            if (!(container.styles.listStyleImage !== null)) return [
                                3 /*break*/ ,
                                19
                            ];
                            img = container.styles.listStyleImage;
                            if (!(img.type === 0 /* URL */ )) return [
                                3 /*break*/ ,
                                18
                            ];
                            image = void 0;
                            url = img.url;
                            _c.label = 15;
                        case 15:
                            _c.trys.push([
                                15,
                                17,
                                ,
                                18
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(url)
                            ];
                        case 16:
                            image = _c.sent();
                            this.ctx.drawImage(image, container.bounds.left - (image.width + 10), container.bounds.top);
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case 17:
                            _c.sent();
                            this.context.logger.error("Error loading list-style-image " + url);
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case 18:
                            return [
                                3 /*break*/ ,
                                20
                            ];
                        case 19:
                            if (paint.listValue && container.styles.listStyleType !== -1 /* NONE */ ) {
                                fontFamily = this.createFontStyle(styles)[0];
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'middle';
                                this.ctx.textAlign = 'right';
                                bounds = new Bounds(container.bounds.left, container.bounds.top + getAbsoluteValue(container.styles.paddingTop, container.bounds.width), container.bounds.width, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 1);
                                this.renderTextWithLetterSpacing(new TextBounds(paint.listValue, bounds), styles.letterSpacing, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 2);
                                this.ctx.textBaseline = 'bottom';
                                this.ctx.textAlign = 'left';
                            }
                            _c.label = 20;
                        case 20:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderStackContent = function(stack) {
            return __awaiter(this, void 0, void 0, function() {
                var _i, _a, child, _b, _c, child, _d, _e, child, _f, _g, child, _h, _j, child, _k, _l, child, _m, _o, child;
                return __generator(this, function(_p) {
                    switch(_p.label){
                        case 0:
                            if (contains(stack.element.container.flags, 16 /* DEBUG_RENDER */ )) debugger;
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            return [
                                4 /*yield*/ ,
                                this.renderNodeBackgroundAndBorders(stack.element)
                            ];
                        case 1:
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            _p.sent();
                            _i = 0, _a = stack.negativeZIndex;
                            _p.label = 2;
                        case 2:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                5
                            ];
                            child = _a[_i];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 3:
                            _p.sent();
                            _p.label = 4;
                        case 4:
                            _i++;
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case 5:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            return [
                                4 /*yield*/ ,
                                this.renderNodeContent(stack.element)
                            ];
                        case 6:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            _p.sent();
                            _b = 0, _c = stack.nonInlineLevel;
                            _p.label = 7;
                        case 7:
                            if (!(_b < _c.length)) return [
                                3 /*break*/ ,
                                10
                            ];
                            child = _c[_b];
                            return [
                                4 /*yield*/ ,
                                this.renderNode(child)
                            ];
                        case 8:
                            _p.sent();
                            _p.label = 9;
                        case 9:
                            _b++;
                            return [
                                3 /*break*/ ,
                                7
                            ];
                        case 10:
                            _d = 0, _e = stack.nonPositionedFloats;
                            _p.label = 11;
                        case 11:
                            if (!(_d < _e.length)) return [
                                3 /*break*/ ,
                                14
                            ];
                            child = _e[_d];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 12:
                            _p.sent();
                            _p.label = 13;
                        case 13:
                            _d++;
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 14:
                            _f = 0, _g = stack.nonPositionedInlineLevel;
                            _p.label = 15;
                        case 15:
                            if (!(_f < _g.length)) return [
                                3 /*break*/ ,
                                18
                            ];
                            child = _g[_f];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 16:
                            _p.sent();
                            _p.label = 17;
                        case 17:
                            _f++;
                            return [
                                3 /*break*/ ,
                                15
                            ];
                        case 18:
                            _h = 0, _j = stack.inlineLevel;
                            _p.label = 19;
                        case 19:
                            if (!(_h < _j.length)) return [
                                3 /*break*/ ,
                                22
                            ];
                            child = _j[_h];
                            return [
                                4 /*yield*/ ,
                                this.renderNode(child)
                            ];
                        case 20:
                            _p.sent();
                            _p.label = 21;
                        case 21:
                            _h++;
                            return [
                                3 /*break*/ ,
                                19
                            ];
                        case 22:
                            _k = 0, _l = stack.zeroOrAutoZIndexOrTransformedOrOpacity;
                            _p.label = 23;
                        case 23:
                            if (!(_k < _l.length)) return [
                                3 /*break*/ ,
                                26
                            ];
                            child = _l[_k];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 24:
                            _p.sent();
                            _p.label = 25;
                        case 25:
                            _k++;
                            return [
                                3 /*break*/ ,
                                23
                            ];
                        case 26:
                            _m = 0, _o = stack.positiveZIndex;
                            _p.label = 27;
                        case 27:
                            if (!(_m < _o.length)) return [
                                3 /*break*/ ,
                                30
                            ];
                            child = _o[_m];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 28:
                            _p.sent();
                            _p.label = 29;
                        case 29:
                            _m++;
                            return [
                                3 /*break*/ ,
                                27
                            ];
                        case 30:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.mask = function(paths) {
            this.ctx.beginPath();
            this.ctx.moveTo(0, 0);
            this.ctx.lineTo(this.canvas.width, 0);
            this.ctx.lineTo(this.canvas.width, this.canvas.height);
            this.ctx.lineTo(0, this.canvas.height);
            this.ctx.lineTo(0, 0);
            this.formatPath(paths.slice(0).reverse());
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.path = function(paths) {
            this.ctx.beginPath();
            this.formatPath(paths);
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.formatPath = function(paths) {
            var _this = this;
            paths.forEach(function(point, index) {
                var start = isBezierCurve(point) ? point.start : point;
                if (index === 0) _this.ctx.moveTo(start.x, start.y);
                else _this.ctx.lineTo(start.x, start.y);
                if (isBezierCurve(point)) _this.ctx.bezierCurveTo(point.startControl.x, point.startControl.y, point.endControl.x, point.endControl.y, point.end.x, point.end.y);
            });
        };
        CanvasRenderer.prototype.renderRepeat = function(path, pattern, offsetX, offsetY) {
            this.path(path);
            this.ctx.fillStyle = pattern;
            this.ctx.translate(offsetX, offsetY);
            this.ctx.fill();
            this.ctx.translate(-offsetX, -offsetY);
        };
        CanvasRenderer.prototype.resizeImage = function(image, width, height) {
            var _a;
            if (image.width === width && image.height === height) return image;
            var ownerDocument = (_a = this.canvas.ownerDocument) !== null && _a !== void 0 ? _a : document;
            var canvas = ownerDocument.createElement('canvas');
            canvas.width = Math.max(1, width);
            canvas.height = Math.max(1, height);
            var ctx = canvas.getContext('2d');
            ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height);
            return canvas;
        };
        CanvasRenderer.prototype.renderBackgroundImage = function(container) {
            return __awaiter(this, void 0, void 0, function() {
                var index, _loop_1, this_1, _i, _a, backgroundImage;
                return __generator(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            index = container.styles.backgroundImage.length - 1;
                            _loop_1 = function(backgroundImage) {
                                var image, url, _c, path, x, y, width, height, pattern, _d, path, x, y, width, height, _e, lineLength, x0, x1, y0, y1, canvas, ctx, gradient_1, pattern, _f, path, left, top_1, width, height, position, x, y, _g, rx, ry, radialGradient_1, midX, midY, f, invF;
                                return __generator(this, function(_h) {
                                    switch(_h.label){
                                        case 0:
                                            if (!(backgroundImage.type === 0 /* URL */ )) return [
                                                3 /*break*/ ,
                                                5
                                            ];
                                            image = void 0;
                                            url = backgroundImage.url;
                                            _h.label = 1;
                                        case 1:
                                            _h.trys.push([
                                                1,
                                                3,
                                                ,
                                                4
                                            ]);
                                            return [
                                                4 /*yield*/ ,
                                                this_1.context.cache.match(url)
                                            ];
                                        case 2:
                                            image = _h.sent();
                                            return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 3:
                                            _h.sent();
                                            this_1.context.logger.error("Error loading background-image " + url);
                                            return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 4:
                                            if (image) {
                                                _c = calculateBackgroundRendering(container, index, [
                                                    image.width,
                                                    image.height,
                                                    image.width / image.height
                                                ]), path = _c[0], x = _c[1], y = _c[2], width = _c[3], height = _c[4];
                                                pattern = this_1.ctx.createPattern(this_1.resizeImage(image, width, height), 'repeat');
                                                this_1.renderRepeat(path, pattern, x, y);
                                            }
                                            return [
                                                3 /*break*/ ,
                                                6
                                            ];
                                        case 5:
                                            if (isLinearGradient(backgroundImage)) {
                                                _d = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _d[0], x = _d[1], y = _d[2], width = _d[3], height = _d[4];
                                                _e = calculateGradientDirection(backgroundImage.angle, width, height), lineLength = _e[0], x0 = _e[1], x1 = _e[2], y0 = _e[3], y1 = _e[4];
                                                canvas = document.createElement('canvas');
                                                canvas.width = width;
                                                canvas.height = height;
                                                ctx = canvas.getContext('2d');
                                                gradient_1 = ctx.createLinearGradient(x0, y0, x1, y1);
                                                processColorStops(backgroundImage.stops, lineLength).forEach(function(colorStop) {
                                                    return gradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                });
                                                ctx.fillStyle = gradient_1;
                                                ctx.fillRect(0, 0, width, height);
                                                if (width > 0 && height > 0) {
                                                    pattern = this_1.ctx.createPattern(canvas, 'repeat');
                                                    this_1.renderRepeat(path, pattern, x, y);
                                                }
                                            } else if (isRadialGradient(backgroundImage)) {
                                                _f = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _f[0], left = _f[1], top_1 = _f[2], width = _f[3], height = _f[4];
                                                position = backgroundImage.position.length === 0 ? [
                                                    FIFTY_PERCENT
                                                ] : backgroundImage.position;
                                                x = getAbsoluteValue(position[0], width);
                                                y = getAbsoluteValue(position[position.length - 1], height);
                                                _g = calculateRadius(backgroundImage, x, y, width, height), rx = _g[0], ry = _g[1];
                                                if (rx > 0 && ry > 0) {
                                                    radialGradient_1 = this_1.ctx.createRadialGradient(left + x, top_1 + y, 0, left + x, top_1 + y, rx);
                                                    processColorStops(backgroundImage.stops, rx * 2).forEach(function(colorStop) {
                                                        return radialGradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                    });
                                                    this_1.path(path);
                                                    this_1.ctx.fillStyle = radialGradient_1;
                                                    if (rx !== ry) {
                                                        midX = container.bounds.left + 0.5 * container.bounds.width;
                                                        midY = container.bounds.top + 0.5 * container.bounds.height;
                                                        f = ry / rx;
                                                        invF = 1 / f;
                                                        this_1.ctx.save();
                                                        this_1.ctx.translate(midX, midY);
                                                        this_1.ctx.transform(1, 0, 0, f, 0, 0);
                                                        this_1.ctx.translate(-midX, -midY);
                                                        this_1.ctx.fillRect(left, invF * (top_1 - midY) + midY, width, height * invF);
                                                        this_1.ctx.restore();
                                                    } else this_1.ctx.fill();
                                                }
                                            }
                                            _h.label = 6;
                                        case 6:
                                            index--;
                                            return [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            };
                            this_1 = this;
                            _i = 0, _a = container.styles.backgroundImage.slice(0).reverse();
                            _b.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                4
                            ];
                            backgroundImage = _a[_i];
                            return [
                                5 /*yield**/ ,
                                _loop_1(backgroundImage)
                            ];
                        case 2:
                            _b.sent();
                            _b.label = 3;
                        case 3:
                            _i++;
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderSolidBorder = function(color, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    this.path(parsePathForBorder(curvePoints, side));
                    this.ctx.fillStyle = asString(color);
                    this.ctx.fill();
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.renderDoubleBorder = function(color, width, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function() {
                var outerPaths, innerPaths;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!(width < 3)) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderSolidBorder(color, side, curvePoints)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                2 /*return*/ 
                            ];
                        case 2:
                            outerPaths = parsePathForBorderDoubleOuter(curvePoints, side);
                            this.path(outerPaths);
                            this.ctx.fillStyle = asString(color);
                            this.ctx.fill();
                            innerPaths = parsePathForBorderDoubleInner(curvePoints, side);
                            this.path(innerPaths);
                            this.ctx.fill();
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNodeBackgroundAndBorders = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                var styles, hasBackground, borders, backgroundPaintingArea, side, _i, borders_1, border;
                var _this = this;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            this.applyEffects(paint.getEffects(2 /* BACKGROUND_BORDERS */ ));
                            styles = paint.container.styles;
                            hasBackground = !isTransparent(styles.backgroundColor) || styles.backgroundImage.length;
                            borders = [
                                {
                                    style: styles.borderTopStyle,
                                    color: styles.borderTopColor,
                                    width: styles.borderTopWidth
                                },
                                {
                                    style: styles.borderRightStyle,
                                    color: styles.borderRightColor,
                                    width: styles.borderRightWidth
                                },
                                {
                                    style: styles.borderBottomStyle,
                                    color: styles.borderBottomColor,
                                    width: styles.borderBottomWidth
                                },
                                {
                                    style: styles.borderLeftStyle,
                                    color: styles.borderLeftColor,
                                    width: styles.borderLeftWidth
                                }
                            ];
                            backgroundPaintingArea = calculateBackgroundCurvedPaintingArea(getBackgroundValueForIndex(styles.backgroundClip, 0), paint.curves);
                            if (!(hasBackground || styles.boxShadow.length)) return [
                                3 /*break*/ ,
                                2
                            ];
                            this.ctx.save();
                            this.path(backgroundPaintingArea);
                            this.ctx.clip();
                            if (!isTransparent(styles.backgroundColor)) {
                                this.ctx.fillStyle = asString(styles.backgroundColor);
                                this.ctx.fill();
                            }
                            return [
                                4 /*yield*/ ,
                                this.renderBackgroundImage(paint.container)
                            ];
                        case 1:
                            _a.sent();
                            this.ctx.restore();
                            styles.boxShadow.slice(0).reverse().forEach(function(shadow) {
                                _this.ctx.save();
                                var borderBoxArea = calculateBorderBoxPath(paint.curves);
                                var maskOffset = shadow.inset ? 0 : MASK_OFFSET;
                                var shadowPaintingArea = transformPath(borderBoxArea, -maskOffset + (shadow.inset ? 1 : -1) * shadow.spread.number, (shadow.inset ? 1 : -1) * shadow.spread.number, shadow.spread.number * (shadow.inset ? -2 : 2), shadow.spread.number * (shadow.inset ? -2 : 2));
                                if (shadow.inset) {
                                    _this.path(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.mask(shadowPaintingArea);
                                } else {
                                    _this.mask(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.path(shadowPaintingArea);
                                }
                                _this.ctx.shadowOffsetX = shadow.offsetX.number + maskOffset;
                                _this.ctx.shadowOffsetY = shadow.offsetY.number;
                                _this.ctx.shadowColor = asString(shadow.color);
                                _this.ctx.shadowBlur = shadow.blur.number;
                                _this.ctx.fillStyle = shadow.inset ? asString(shadow.color) : 'rgba(0,0,0,1)';
                                _this.ctx.fill();
                                _this.ctx.restore();
                            });
                            _a.label = 2;
                        case 2:
                            side = 0;
                            _i = 0, borders_1 = borders;
                            _a.label = 3;
                        case 3:
                            if (!(_i < borders_1.length)) return [
                                3 /*break*/ ,
                                13
                            ];
                            border = borders_1[_i];
                            if (!(border.style !== 0 /* NONE */  && !isTransparent(border.color) && border.width > 0)) return [
                                3 /*break*/ ,
                                11
                            ];
                            if (!(border.style === 2 /* DASHED */ )) return [
                                3 /*break*/ ,
                                5
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 2 /* DASHED */ )
                            ];
                        case 4:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 5:
                            if (!(border.style === 3 /* DOTTED */ )) return [
                                3 /*break*/ ,
                                7
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 3 /* DOTTED */ )
                            ];
                        case 6:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 7:
                            if (!(border.style === 4 /* DOUBLE */ )) return [
                                3 /*break*/ ,
                                9
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDoubleBorder(border.color, border.width, side, paint.curves)
                            ];
                        case 8:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 9:
                            return [
                                4 /*yield*/ ,
                                this.renderSolidBorder(border.color, side, paint.curves)
                            ];
                        case 10:
                            _a.sent();
                            _a.label = 11;
                        case 11:
                            side++;
                            _a.label = 12;
                        case 12:
                            _i++;
                            return [
                                3 /*break*/ ,
                                3
                            ];
                        case 13:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderDashedDottedBorder = function(color, width, side, curvePoints, style) {
            return __awaiter(this, void 0, void 0, function() {
                var strokePaths, boxPaths, startX, startY, endX, endY, length, dashLength, spaceLength, useLineDash, multiplier, numberOfDashes, minSpace, maxSpace, path1, path2, path1, path2;
                return __generator(this, function(_a) {
                    this.ctx.save();
                    strokePaths = parsePathForBorderStroke(curvePoints, side);
                    boxPaths = parsePathForBorder(curvePoints, side);
                    if (style === 2 /* DASHED */ ) {
                        this.path(boxPaths);
                        this.ctx.clip();
                    }
                    if (isBezierCurve(boxPaths[0])) {
                        startX = boxPaths[0].start.x;
                        startY = boxPaths[0].start.y;
                    } else {
                        startX = boxPaths[0].x;
                        startY = boxPaths[0].y;
                    }
                    if (isBezierCurve(boxPaths[1])) {
                        endX = boxPaths[1].end.x;
                        endY = boxPaths[1].end.y;
                    } else {
                        endX = boxPaths[1].x;
                        endY = boxPaths[1].y;
                    }
                    if (side === 0 || side === 2) length = Math.abs(startX - endX);
                    else length = Math.abs(startY - endY);
                    this.ctx.beginPath();
                    if (style === 3 /* DOTTED */ ) this.formatPath(strokePaths);
                    else this.formatPath(boxPaths.slice(0, 2));
                    dashLength = width < 3 ? width * 3 : width * 2;
                    spaceLength = width < 3 ? width * 2 : width;
                    if (style === 3 /* DOTTED */ ) {
                        dashLength = width;
                        spaceLength = width;
                    }
                    useLineDash = true;
                    if (length <= dashLength * 2) useLineDash = false;
                    else if (length <= dashLength * 2 + spaceLength) {
                        multiplier = length / (2 * dashLength + spaceLength);
                        dashLength *= multiplier;
                        spaceLength *= multiplier;
                    } else {
                        numberOfDashes = Math.floor((length + spaceLength) / (dashLength + spaceLength));
                        minSpace = (length - numberOfDashes * dashLength) / (numberOfDashes - 1);
                        maxSpace = (length - (numberOfDashes + 1) * dashLength) / numberOfDashes;
                        spaceLength = maxSpace <= 0 || Math.abs(spaceLength - minSpace) < Math.abs(spaceLength - maxSpace) ? minSpace : maxSpace;
                    }
                    if (useLineDash) {
                        if (style === 3 /* DOTTED */ ) this.ctx.setLineDash([
                            0,
                            dashLength + spaceLength
                        ]);
                        else this.ctx.setLineDash([
                            dashLength,
                            spaceLength
                        ]);
                    }
                    if (style === 3 /* DOTTED */ ) {
                        this.ctx.lineCap = 'round';
                        this.ctx.lineWidth = width;
                    } else this.ctx.lineWidth = width * 2 + 1.1;
                    this.ctx.strokeStyle = asString(color);
                    this.ctx.stroke();
                    this.ctx.setLineDash([]);
                    // dashed round edge gap
                    if (style === 2 /* DASHED */ ) {
                        if (isBezierCurve(boxPaths[0])) {
                            path1 = boxPaths[3];
                            path2 = boxPaths[0];
                            this.ctx.beginPath();
                            this.formatPath([
                                new Vector(path1.end.x, path1.end.y),
                                new Vector(path2.start.x, path2.start.y)
                            ]);
                            this.ctx.stroke();
                        }
                        if (isBezierCurve(boxPaths[1])) {
                            path1 = boxPaths[1];
                            path2 = boxPaths[2];
                            this.ctx.beginPath();
                            this.formatPath([
                                new Vector(path1.end.x, path1.end.y),
                                new Vector(path2.start.x, path2.start.y)
                            ]);
                            this.ctx.stroke();
                        }
                    }
                    this.ctx.restore();
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.render = function(element) {
            return __awaiter(this, void 0, void 0, function() {
                var stack;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(this.options.x, this.options.y, this.options.width, this.options.height);
                            }
                            stack = parseStackingContexts(element);
                            return [
                                4 /*yield*/ ,
                                this.renderStack(stack)
                            ];
                        case 1:
                            _a.sent();
                            this.applyEffects([]);
                            return [
                                2 /*return*/ ,
                                this.canvas
                            ];
                    }
                });
            });
        };
        return CanvasRenderer;
    }(Renderer);
    var isTextInputElement = function(container) {
        if (container instanceof TextareaElementContainer) return true;
        else if (container instanceof SelectElementContainer) return true;
        else if (container instanceof InputElementContainer && container.type !== RADIO && container.type !== CHECKBOX) return true;
        return false;
    };
    var calculateBackgroundCurvedPaintingArea = function(clip, curves) {
        switch(clip){
            case 0 /* BORDER_BOX */ :
                return calculateBorderBoxPath(curves);
            case 2 /* CONTENT_BOX */ :
                return calculateContentBoxPath(curves);
            case 1 /* PADDING_BOX */ :
            default:
                return calculatePaddingBoxPath(curves);
        }
    };
    var canvasTextAlign = function(textAlign) {
        switch(textAlign){
            case 1 /* CENTER */ :
                return 'center';
            case 2 /* RIGHT */ :
                return 'right';
            case 0 /* LEFT */ :
            default:
                return 'left';
        }
    };
    // see https://github.com/niklasvh/html2canvas/pull/2645
    var iOSBrokenFonts = [
        '-apple-system',
        'system-ui'
    ];
    var fixIOSSystemFonts = function(fontFamilies) {
        return /iPhone OS 15_(0|1)/.test(window.navigator.userAgent) ? fontFamilies.filter(function(fontFamily) {
            return iOSBrokenFonts.indexOf(fontFamily) === -1;
        }) : fontFamilies;
    };
    var ForeignObjectRenderer = /** @class */ function(_super) {
        __extends(ForeignObjectRenderer, _super);
        function ForeignObjectRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            _this.ctx = _this.canvas.getContext('2d');
            _this.options = options;
            _this.canvas.width = Math.floor(options.width * options.scale);
            _this.canvas.height = Math.floor(options.height * options.scale);
            _this.canvas.style.width = options.width + "px";
            _this.canvas.style.height = options.height + "px";
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.context.logger.debug("EXPERIMENTAL ForeignObject renderer initialized (" + options.width + "x" + options.height + " at " + options.x + "," + options.y + ") with scale " + options.scale);
            return _this;
        }
        ForeignObjectRenderer.prototype.render = function(element) {
            return __awaiter(this, void 0, void 0, function() {
                var svg, img;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            svg = createForeignObjectSVG(this.options.width * this.options.scale, this.options.height * this.options.scale, this.options.scale, this.options.scale, element);
                            return [
                                4 /*yield*/ ,
                                loadSerializedSVG(svg)
                            ];
                        case 1:
                            img = _a.sent();
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale);
                            }
                            this.ctx.drawImage(img, -this.options.x * this.options.scale, -this.options.y * this.options.scale);
                            return [
                                2 /*return*/ ,
                                this.canvas
                            ];
                    }
                });
            });
        };
        return ForeignObjectRenderer;
    }(Renderer);
    var loadSerializedSVG = function(svg) {
        return new Promise(function(resolve, reject) {
            var img = new Image();
            img.onload = function() {
                resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var Logger = /** @class */ function() {
        function Logger(_a) {
            var id = _a.id, enabled = _a.enabled;
            this.id = id;
            this.enabled = enabled;
            this.start = Date.now();
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.debug = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.debug === 'function') // eslint-disable-next-line no-console
                console.debug.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        Logger.prototype.getTime = function() {
            return Date.now() - this.start;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.info = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) // eslint-disable-next-line no-console
            {
                if (typeof window !== 'undefined' && window.console && typeof console.info === 'function') // eslint-disable-next-line no-console
                console.info.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.warn = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.warn === 'function') // eslint-disable-next-line no-console
                console.warn.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.error = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.error === 'function') // eslint-disable-next-line no-console
                console.error.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        Logger.instances = {};
        return Logger;
    }();
    var Context = /** @class */ function() {
        function Context(options, windowBounds) {
            var _a;
            this.windowBounds = windowBounds;
            this.instanceName = "#" + Context.instanceCount++;
            this.logger = new Logger({
                id: this.instanceName,
                enabled: options.logging
            });
            this.cache = (_a = options.cache) !== null && _a !== void 0 ? _a : new Cache(this, options);
        }
        Context.instanceCount = 1;
        return Context;
    }();
    var html2canvas = function(element, options) {
        if (options === void 0) options = {};
        return renderElement(element, options);
    };
    if (typeof window !== 'undefined') CacheStorage.setContext(window);
    var renderElement = function(element, opts) {
        return __awaiter(void 0, void 0, void 0, function() {
            var ownerDocument, defaultView, resourceOptions, contextOptions, windowOptions, windowBounds, context, foreignObjectRendering, cloneOptions, documentCloner, clonedElement, container, _a, width, height, left, top, backgroundColor, renderOptions, canvas, renderer, root, renderer;
            var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
            return __generator(this, function(_u) {
                switch(_u.label){
                    case 0:
                        if (!element || typeof element !== 'object') return [
                            2 /*return*/ ,
                            Promise.reject('Invalid element provided as first argument')
                        ];
                        ownerDocument = element.ownerDocument;
                        if (!ownerDocument) throw new Error("Element is not attached to a Document");
                        defaultView = ownerDocument.defaultView;
                        if (!defaultView) throw new Error("Document is not attached to a Window");
                        resourceOptions = {
                            allowTaint: (_b = opts.allowTaint) !== null && _b !== void 0 ? _b : false,
                            imageTimeout: (_c = opts.imageTimeout) !== null && _c !== void 0 ? _c : 15000,
                            proxy: opts.proxy,
                            useCORS: (_d = opts.useCORS) !== null && _d !== void 0 ? _d : false
                        };
                        contextOptions = __assign({
                            logging: (_e = opts.logging) !== null && _e !== void 0 ? _e : true,
                            cache: opts.cache
                        }, resourceOptions);
                        windowOptions = {
                            windowWidth: (_f = opts.windowWidth) !== null && _f !== void 0 ? _f : defaultView.innerWidth,
                            windowHeight: (_g = opts.windowHeight) !== null && _g !== void 0 ? _g : defaultView.innerHeight,
                            scrollX: (_h = opts.scrollX) !== null && _h !== void 0 ? _h : defaultView.pageXOffset,
                            scrollY: (_j = opts.scrollY) !== null && _j !== void 0 ? _j : defaultView.pageYOffset
                        };
                        windowBounds = new Bounds(windowOptions.scrollX, windowOptions.scrollY, windowOptions.windowWidth, windowOptions.windowHeight);
                        context = new Context(contextOptions, windowBounds);
                        foreignObjectRendering = (_k = opts.foreignObjectRendering) !== null && _k !== void 0 ? _k : false;
                        cloneOptions = {
                            allowTaint: (_l = opts.allowTaint) !== null && _l !== void 0 ? _l : false,
                            onclone: opts.onclone,
                            ignoreElements: opts.ignoreElements,
                            inlineImages: foreignObjectRendering,
                            copyStyles: foreignObjectRendering
                        };
                        context.logger.debug("Starting document clone with size " + windowBounds.width + "x" + windowBounds.height + " scrolled to " + -windowBounds.left + "," + -windowBounds.top);
                        documentCloner = new DocumentCloner(context, element, cloneOptions);
                        clonedElement = documentCloner.clonedReferenceElement;
                        if (!clonedElement) return [
                            2 /*return*/ ,
                            Promise.reject("Unable to find element in cloned iframe")
                        ];
                        return [
                            4 /*yield*/ ,
                            documentCloner.toIFrame(ownerDocument, windowBounds)
                        ];
                    case 1:
                        container = _u.sent();
                        _a = isBodyElement(clonedElement) || isHTMLElement(clonedElement) ? parseDocumentSize(clonedElement.ownerDocument) : parseBounds(context, clonedElement), width = _a.width, height = _a.height, left = _a.left, top = _a.top;
                        backgroundColor = parseBackgroundColor(context, clonedElement, opts.backgroundColor);
                        renderOptions = {
                            canvas: opts.canvas,
                            backgroundColor: backgroundColor,
                            scale: (_o = (_m = opts.scale) !== null && _m !== void 0 ? _m : defaultView.devicePixelRatio) !== null && _o !== void 0 ? _o : 1,
                            x: ((_p = opts.x) !== null && _p !== void 0 ? _p : 0) + left,
                            y: ((_q = opts.y) !== null && _q !== void 0 ? _q : 0) + top,
                            width: (_r = opts.width) !== null && _r !== void 0 ? _r : Math.ceil(width),
                            height: (_s = opts.height) !== null && _s !== void 0 ? _s : Math.ceil(height)
                        };
                        if (!foreignObjectRendering) return [
                            3 /*break*/ ,
                            3
                        ];
                        context.logger.debug("Document cloned, using foreign object rendering");
                        renderer = new ForeignObjectRenderer(context, renderOptions);
                        return [
                            4 /*yield*/ ,
                            renderer.render(clonedElement)
                        ];
                    case 2:
                        canvas = _u.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        context.logger.debug("Document cloned, element located at " + left + "," + top + " with size " + width + "x" + height + " using computed rendering");
                        context.logger.debug("Starting DOM parsing");
                        root = parseTree(context, clonedElement);
                        if (backgroundColor === root.styles.backgroundColor) root.styles.backgroundColor = COLORS.TRANSPARENT;
                        context.logger.debug("Starting renderer for element at " + renderOptions.x + "," + renderOptions.y + " with size " + renderOptions.width + "x" + renderOptions.height);
                        renderer = new CanvasRenderer(context, renderOptions);
                        return [
                            4 /*yield*/ ,
                            renderer.render(root)
                        ];
                    case 4:
                        canvas = _u.sent();
                        _u.label = 5;
                    case 5:
                        if ((_t = opts.removeContainer) !== null && _t !== void 0 ? _t : true) {
                            if (!DocumentCloner.destroy(container)) context.logger.error("Cannot detach cloned iframe as it is not in the DOM anymore");
                        }
                        context.logger.debug("Finished rendering");
                        return [
                            2 /*return*/ ,
                            canvas
                        ];
                }
            });
        });
    };
    var parseBackgroundColor = function(context, element, backgroundColorOverride) {
        var ownerDocument = element.ownerDocument;
        // http://www.w3.org/TR/css3-background/#special-backgrounds
        var documentBackgroundColor = ownerDocument.documentElement ? parseColor(context, getComputedStyle(ownerDocument.documentElement).backgroundColor) : COLORS.TRANSPARENT;
        var bodyBackgroundColor = ownerDocument.body ? parseColor(context, getComputedStyle(ownerDocument.body).backgroundColor) : COLORS.TRANSPARENT;
        var defaultBackgroundColor = typeof backgroundColorOverride === 'string' ? parseColor(context, backgroundColorOverride) : backgroundColorOverride === null ? COLORS.TRANSPARENT : 0xffffffff;
        return element === ownerDocument.documentElement ? isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? defaultBackgroundColor : bodyBackgroundColor : documentBackgroundColor : defaultBackgroundColor;
    };
    return html2canvas;
});

},{}],"hkJ4Q":[function(require,module,exports,__globalThis) {
/** @license
 *
 * jsPDF - PDF Document creation from JavaScript
 * Version 3.0.3 Built on 2025-09-18T08:03:54.261Z
 *                      CommitID 00000000
 *
 * Copyright (c) 2010-2025 James Hall <james@parall.ax>, https://github.com/MrRio/jsPDF
 *               2015-2025 yWorks GmbH, http://www.yworks.com
 *               2015-2025 Lukas Holländer <lukas.hollaender@yworks.com>, https://github.com/HackbrettXXX
 *               2016-2018 Aras Abbasi <aras.abbasi@gmail.com>
 *               2010 Aaron Spike, https://github.com/acspike
 *               2012 Willow Systems Corporation, https://github.com/willowsystems
 *               2012 Pablo Hess, https://github.com/pablohess
 *               2012 Florian Jenett, https://github.com/fjenett
 *               2013 Warren Weckesser, https://github.com/warrenweckesser
 *               2013 Youssef Beddad, https://github.com/lifof
 *               2013 Lee Driscoll, https://github.com/lsdriscoll
 *               2013 Stefan Slonevskiy, https://github.com/stefslon
 *               2013 Jeremy Morel, https://github.com/jmorel
 *               2013 Christoph Hartmann, https://github.com/chris-rock
 *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
 *               2014 James Makes, https://github.com/dollaruw
 *               2014 Diego Casorran, https://github.com/diegocr
 *               2014 Steven Spungin, https://github.com/Flamenco
 *               2014 Kenneth Glassey, https://github.com/Gavvers
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 * Contributor(s):
 *    siefkenj, ahwolf, rickygu, Midnith, saintclair, eaparango,
 *    kim3er, mfo, alnorth, Flamenco
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AcroForm", ()=>St);
parcelHelpers.export(exports, "AcroFormAppearance", ()=>xt);
parcelHelpers.export(exports, "AcroFormButton", ()=>mt);
parcelHelpers.export(exports, "AcroFormCheckBox", ()=>wt);
parcelHelpers.export(exports, "AcroFormChoiceField", ()=>ft);
parcelHelpers.export(exports, "AcroFormComboBox", ()=>pt);
parcelHelpers.export(exports, "AcroFormEditBox", ()=>gt);
parcelHelpers.export(exports, "AcroFormListBox", ()=>dt);
parcelHelpers.export(exports, "AcroFormPasswordField", ()=>Lt);
parcelHelpers.export(exports, "AcroFormPushButton", ()=>vt);
parcelHelpers.export(exports, "AcroFormRadioButton", ()=>bt);
parcelHelpers.export(exports, "AcroFormTextField", ()=>Nt);
parcelHelpers.export(exports, "GState", ()=>O);
parcelHelpers.export(exports, "ShadingPattern", ()=>M);
parcelHelpers.export(exports, "TilingPattern", ()=>q);
parcelHelpers.export(exports, "default", ()=>E);
parcelHelpers.export(exports, "jsPDF", ()=>E);
var _typeof = require("@babel/runtime/helpers/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _fflate = require("fflate");
var _slicedToArray = require("@babel/runtime/helpers/slicedToArray");
var _slicedToArrayDefault = parcelHelpers.interopDefault(_slicedToArray);
var _fastPng = require("fast-png");
var global = arguments[3];
var i = function() {
    return "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : this;
}();
function a() {
    i.console && "function" == typeof i.console.log && i.console.log.apply(i.console, arguments);
}
var o = {
    log: a,
    warn: function(t) {
        i.console && ("function" == typeof i.console.warn ? i.console.warn.apply(i.console, arguments) : a.call(null, arguments));
    },
    error: function(t) {
        i.console && ("function" == typeof i.console.error ? i.console.error.apply(i.console, arguments) : a(t));
    }
};
function s(t, e, n) {
    var r = new XMLHttpRequest;
    r.open("GET", t), r.responseType = "blob", r.onload = function() {
        l(r.response, e, n);
    }, r.onerror = function() {
        o.error("could not download file");
    }, r.send();
}
function u(t) {
    var e = new XMLHttpRequest;
    e.open("HEAD", t, !1);
    try {
        e.send();
    } catch (n) {}
    return e.status >= 200 && e.status <= 299;
}
function c(t) {
    try {
        t.dispatchEvent(new MouseEvent("click"));
    } catch (n) {
        var e = document.createEvent("MouseEvents");
        e.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), t.dispatchEvent(e);
    }
}
var l = i.saveAs || ("object" !== ("undefined" == typeof window ? "undefined" : (0, _typeofDefault.default)(window)) || window !== i ? function() {} : "undefined" != typeof HTMLAnchorElement && "download" in HTMLAnchorElement.prototype ? function(t, e, n) {
    var r = i.URL || i.webkitURL, a = document.createElement("a");
    e = e || t.name || "download", a.download = e, a.rel = "noopener", "string" == typeof t ? (a.href = t, a.origin !== location.origin ? u(a.href) ? s(t, e, n) : c(a, a.target = "_blank") : c(a)) : (a.href = r.createObjectURL(t), setTimeout(function() {
        r.revokeObjectURL(a.href);
    }, 4e4), setTimeout(function() {
        c(a);
    }, 0));
} : "msSaveOrOpenBlob" in navigator ? function(e, n, r) {
    if (n = n || e.name || "download", "string" == typeof e) {
        if (u(e)) s(e, n, r);
        else {
            var i = document.createElement("a");
            i.href = e, i.target = "_blank", setTimeout(function() {
                c(i);
            });
        }
    } else navigator.msSaveOrOpenBlob(function(e, n) {
        return void 0 === n ? n = {
            autoBom: !1
        } : "object" !== (0, _typeofDefault.default)(n) && (o.warn("Deprecated: Expected third argument to be a object"), n = {
            autoBom: !n
        }), n.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(e.type) ? new Blob([
            String.fromCharCode(65279),
            e
        ], {
            type: e.type
        }) : e;
    }(e, r), n);
} : function(e, n, r, a) {
    if ((a = a || open("", "_blank")) && (a.document.title = a.document.body.innerText = "downloading..."), "string" == typeof e) return s(e, n, r);
    var o = "application/octet-stream" === e.type, u = /constructor/i.test(i.HTMLElement) || i.safari, c = /CriOS\/[\d]+/.test(navigator.userAgent);
    if ((c || o && u) && "object" === ("undefined" == typeof FileReader ? "undefined" : (0, _typeofDefault.default)(FileReader))) {
        var l = new FileReader;
        l.onloadend = function() {
            var t = l.result;
            t = c ? t : t.replace(/^data:[^;]*;/, "data:attachment/file;"), a ? a.location.href = t : location = t, a = null;
        }, l.readAsDataURL(e);
    } else {
        var h = i.URL || i.webkitURL, f = h.createObjectURL(e);
        a ? a.location = f : location.href = f, a = null, setTimeout(function() {
            h.revokeObjectURL(f);
        }, 4e4);
    }
});
/**
 * A class to parse color values
 * @author Stoyan Stefanov <sstoo@gmail.com>
 * {@link   http://www.phpied.com/rgb-color-parser-in-javascript/}
 * @license Use it if you like it
 */ function h(t) {
    var e;
    t = t || "", this.ok = !1, "#" == t.charAt(0) && (t = t.substr(1, 6)), t = ({
        aliceblue: "f0f8ff",
        antiquewhite: "faebd7",
        aqua: "00ffff",
        aquamarine: "7fffd4",
        azure: "f0ffff",
        beige: "f5f5dc",
        bisque: "ffe4c4",
        black: "000000",
        blanchedalmond: "ffebcd",
        blue: "0000ff",
        blueviolet: "8a2be2",
        brown: "a52a2a",
        burlywood: "deb887",
        cadetblue: "5f9ea0",
        chartreuse: "7fff00",
        chocolate: "d2691e",
        coral: "ff7f50",
        cornflowerblue: "6495ed",
        cornsilk: "fff8dc",
        crimson: "dc143c",
        cyan: "00ffff",
        darkblue: "00008b",
        darkcyan: "008b8b",
        darkgoldenrod: "b8860b",
        darkgray: "a9a9a9",
        darkgreen: "006400",
        darkkhaki: "bdb76b",
        darkmagenta: "8b008b",
        darkolivegreen: "556b2f",
        darkorange: "ff8c00",
        darkorchid: "9932cc",
        darkred: "8b0000",
        darksalmon: "e9967a",
        darkseagreen: "8fbc8f",
        darkslateblue: "483d8b",
        darkslategray: "2f4f4f",
        darkturquoise: "00ced1",
        darkviolet: "9400d3",
        deeppink: "ff1493",
        deepskyblue: "00bfff",
        dimgray: "696969",
        dodgerblue: "1e90ff",
        feldspar: "d19275",
        firebrick: "b22222",
        floralwhite: "fffaf0",
        forestgreen: "228b22",
        fuchsia: "ff00ff",
        gainsboro: "dcdcdc",
        ghostwhite: "f8f8ff",
        gold: "ffd700",
        goldenrod: "daa520",
        gray: "808080",
        green: "008000",
        greenyellow: "adff2f",
        honeydew: "f0fff0",
        hotpink: "ff69b4",
        indianred: "cd5c5c",
        indigo: "4b0082",
        ivory: "fffff0",
        khaki: "f0e68c",
        lavender: "e6e6fa",
        lavenderblush: "fff0f5",
        lawngreen: "7cfc00",
        lemonchiffon: "fffacd",
        lightblue: "add8e6",
        lightcoral: "f08080",
        lightcyan: "e0ffff",
        lightgoldenrodyellow: "fafad2",
        lightgrey: "d3d3d3",
        lightgreen: "90ee90",
        lightpink: "ffb6c1",
        lightsalmon: "ffa07a",
        lightseagreen: "20b2aa",
        lightskyblue: "87cefa",
        lightslateblue: "8470ff",
        lightslategray: "778899",
        lightsteelblue: "b0c4de",
        lightyellow: "ffffe0",
        lime: "00ff00",
        limegreen: "32cd32",
        linen: "faf0e6",
        magenta: "ff00ff",
        maroon: "800000",
        mediumaquamarine: "66cdaa",
        mediumblue: "0000cd",
        mediumorchid: "ba55d3",
        mediumpurple: "9370d8",
        mediumseagreen: "3cb371",
        mediumslateblue: "7b68ee",
        mediumspringgreen: "00fa9a",
        mediumturquoise: "48d1cc",
        mediumvioletred: "c71585",
        midnightblue: "191970",
        mintcream: "f5fffa",
        mistyrose: "ffe4e1",
        moccasin: "ffe4b5",
        navajowhite: "ffdead",
        navy: "000080",
        oldlace: "fdf5e6",
        olive: "808000",
        olivedrab: "6b8e23",
        orange: "ffa500",
        orangered: "ff4500",
        orchid: "da70d6",
        palegoldenrod: "eee8aa",
        palegreen: "98fb98",
        paleturquoise: "afeeee",
        palevioletred: "d87093",
        papayawhip: "ffefd5",
        peachpuff: "ffdab9",
        peru: "cd853f",
        pink: "ffc0cb",
        plum: "dda0dd",
        powderblue: "b0e0e6",
        purple: "800080",
        red: "ff0000",
        rosybrown: "bc8f8f",
        royalblue: "4169e1",
        saddlebrown: "8b4513",
        salmon: "fa8072",
        sandybrown: "f4a460",
        seagreen: "2e8b57",
        seashell: "fff5ee",
        sienna: "a0522d",
        silver: "c0c0c0",
        skyblue: "87ceeb",
        slateblue: "6a5acd",
        slategray: "708090",
        snow: "fffafa",
        springgreen: "00ff7f",
        steelblue: "4682b4",
        tan: "d2b48c",
        teal: "008080",
        thistle: "d8bfd8",
        tomato: "ff6347",
        turquoise: "40e0d0",
        violet: "ee82ee",
        violetred: "d02090",
        wheat: "f5deb3",
        white: "ffffff",
        whitesmoke: "f5f5f5",
        yellow: "ffff00",
        yellowgreen: "9acd32"
    })[t = (t = t.replace(/ /g, "")).toLowerCase()] || t;
    for(var n = [
        {
            re: /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,
            example: [
                "rgb(123, 234, 45)",
                "rgb(255,234,245)"
            ],
            process: function(t) {
                return [
                    parseInt(t[1]),
                    parseInt(t[2]),
                    parseInt(t[3])
                ];
            }
        },
        {
            re: /^(\w{2})(\w{2})(\w{2})$/,
            example: [
                "#00ff00",
                "336699"
            ],
            process: function(t) {
                return [
                    parseInt(t[1], 16),
                    parseInt(t[2], 16),
                    parseInt(t[3], 16)
                ];
            }
        },
        {
            re: /^(\w{1})(\w{1})(\w{1})$/,
            example: [
                "#fb0",
                "f0f"
            ],
            process: function(t) {
                return [
                    parseInt(t[1] + t[1], 16),
                    parseInt(t[2] + t[2], 16),
                    parseInt(t[3] + t[3], 16)
                ];
            }
        }
    ], r = 0; r < n.length; r++){
        var i = n[r].re, a = n[r].process, o = i.exec(t);
        o && (e = a(o), this.r = e[0], this.g = e[1], this.b = e[2], this.ok = !0);
    }
    this.r = this.r < 0 || isNaN(this.r) ? 0 : this.r > 255 ? 255 : this.r, this.g = this.g < 0 || isNaN(this.g) ? 0 : this.g > 255 ? 255 : this.g, this.b = this.b < 0 || isNaN(this.b) ? 0 : this.b > 255 ? 255 : this.b, this.toRGB = function() {
        return "rgb(" + this.r + ", " + this.g + ", " + this.b + ")";
    }, this.toHex = function() {
        var t = this.r.toString(16), e = this.g.toString(16), n = this.b.toString(16);
        return 1 == t.length && (t = "0" + t), 1 == e.length && (e = "0" + e), 1 == n.length && (n = "0" + n), "#" + t + e + n;
    };
}
var f = i.atob.bind(i), d = i.btoa.bind(i);
/**
 * @license
 * Joseph Myers does not specify a particular license for his work.
 *
 * Author: Joseph Myers
 * Accessed from: http://www.myersdaily.org/joseph/javascript/md5.js
 *
 * Modified by: Owen Leong
 */ function p(t, e) {
    var n = t[0], r = t[1], i = t[2], a = t[3];
    n = m(n, r, i, a, e[0], 7, -680876936), a = m(a, n, r, i, e[1], 12, -389564586), i = m(i, a, n, r, e[2], 17, 606105819), r = m(r, i, a, n, e[3], 22, -1044525330), n = m(n, r, i, a, e[4], 7, -176418897), a = m(a, n, r, i, e[5], 12, 1200080426), i = m(i, a, n, r, e[6], 17, -1473231341), r = m(r, i, a, n, e[7], 22, -45705983), n = m(n, r, i, a, e[8], 7, 1770035416), a = m(a, n, r, i, e[9], 12, -1958414417), i = m(i, a, n, r, e[10], 17, -42063), r = m(r, i, a, n, e[11], 22, -1990404162), n = m(n, r, i, a, e[12], 7, 1804603682), a = m(a, n, r, i, e[13], 12, -40341101), i = m(i, a, n, r, e[14], 17, -1502002290), n = v(n, r = m(r, i, a, n, e[15], 22, 1236535329), i, a, e[1], 5, -165796510), a = v(a, n, r, i, e[6], 9, -1069501632), i = v(i, a, n, r, e[11], 14, 643717713), r = v(r, i, a, n, e[0], 20, -373897302), n = v(n, r, i, a, e[5], 5, -701558691), a = v(a, n, r, i, e[10], 9, 38016083), i = v(i, a, n, r, e[15], 14, -660478335), r = v(r, i, a, n, e[4], 20, -405537848), n = v(n, r, i, a, e[9], 5, 568446438), a = v(a, n, r, i, e[14], 9, -1019803690), i = v(i, a, n, r, e[3], 14, -187363961), r = v(r, i, a, n, e[8], 20, 1163531501), n = v(n, r, i, a, e[13], 5, -1444681467), a = v(a, n, r, i, e[2], 9, -51403784), i = v(i, a, n, r, e[7], 14, 1735328473), n = b(n, r = v(r, i, a, n, e[12], 20, -1926607734), i, a, e[5], 4, -378558), a = b(a, n, r, i, e[8], 11, -2022574463), i = b(i, a, n, r, e[11], 16, 1839030562), r = b(r, i, a, n, e[14], 23, -35309556), n = b(n, r, i, a, e[1], 4, -1530992060), a = b(a, n, r, i, e[4], 11, 1272893353), i = b(i, a, n, r, e[7], 16, -155497632), r = b(r, i, a, n, e[10], 23, -1094730640), n = b(n, r, i, a, e[13], 4, 681279174), a = b(a, n, r, i, e[0], 11, -358537222), i = b(i, a, n, r, e[3], 16, -722521979), r = b(r, i, a, n, e[6], 23, 76029189), n = b(n, r, i, a, e[9], 4, -640364487), a = b(a, n, r, i, e[12], 11, -421815835), i = b(i, a, n, r, e[15], 16, 530742520), n = y(n, r = b(r, i, a, n, e[2], 23, -995338651), i, a, e[0], 6, -198630844), a = y(a, n, r, i, e[7], 10, 1126891415), i = y(i, a, n, r, e[14], 15, -1416354905), r = y(r, i, a, n, e[5], 21, -57434055), n = y(n, r, i, a, e[12], 6, 1700485571), a = y(a, n, r, i, e[3], 10, -1894986606), i = y(i, a, n, r, e[10], 15, -1051523), r = y(r, i, a, n, e[1], 21, -2054922799), n = y(n, r, i, a, e[8], 6, 1873313359), a = y(a, n, r, i, e[15], 10, -30611744), i = y(i, a, n, r, e[6], 15, -1560198380), r = y(r, i, a, n, e[13], 21, 1309151649), n = y(n, r, i, a, e[4], 6, -145523070), a = y(a, n, r, i, e[11], 10, -1120210379), i = y(i, a, n, r, e[2], 15, 718787259), r = y(r, i, a, n, e[9], 21, -343485551), t[0] = P(n, t[0]), t[1] = P(r, t[1]), t[2] = P(i, t[2]), t[3] = P(a, t[3]);
}
function g(t, e, n, r, i, a) {
    return e = P(P(e, t), P(r, a)), P(e << i | e >>> 32 - i, n);
}
function m(t, e, n, r, i, a, o) {
    return g(e & n | ~e & r, t, e, i, a, o);
}
function v(t, e, n, r, i, a, o) {
    return g(e & r | n & ~r, t, e, i, a, o);
}
function b(t, e, n, r, i, a, o) {
    return g(e ^ n ^ r, t, e, i, a, o);
}
function y(t, e, n, r, i, a, o) {
    return g(n ^ (e | ~r), t, e, i, a, o);
}
function w(t) {
    var e, n = t.length, r = [
        1732584193,
        -271733879,
        -1732584194,
        271733878
    ];
    for(e = 64; e <= t.length; e += 64)p(r, N(t.substring(e - 64, e)));
    t = t.substring(e - 64);
    var i = [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ];
    for(e = 0; e < t.length; e++)i[e >> 2] |= t.charCodeAt(e) << (e % 4 << 3);
    if (i[e >> 2] |= 128 << (e % 4 << 3), e > 55) for(p(r, i), e = 0; e < 16; e++)i[e] = 0;
    return i[14] = 8 * n, p(r, i), r;
}
function N(t) {
    var e, n = [];
    for(e = 0; e < 64; e += 4)n[e >> 2] = t.charCodeAt(e) + (t.charCodeAt(e + 1) << 8) + (t.charCodeAt(e + 2) << 16) + (t.charCodeAt(e + 3) << 24);
    return n;
}
var L = "0123456789abcdef".split("");
function x(t) {
    for(var e = "", n = 0; n < 4; n++)e += L[t >> 8 * n + 4 & 15] + L[t >> 8 * n & 15];
    return e;
}
function A(t) {
    return String.fromCharCode(255 & t, (65280 & t) >> 8, (16711680 & t) >> 16, (4278190080 & t) >> 24);
}
function S(t) {
    return w(t).map(A).join("");
}
var _ = "5d41402abc4b2a76b9719d911017c592" != function(t) {
    for(var e = 0; e < t.length; e++)t[e] = x(t[e]);
    return t.join("");
}(w("hello"));
function P(t, e) {
    if (_) {
        var n = (65535 & t) + (65535 & e);
        return (t >> 16) + (e >> 16) + (n >> 16) << 16 | 65535 & n;
    }
    return t + e & 4294967295;
}
/**
 * @license
 * FPDF is released under a permissive license: there is no usage restriction.
 * You may embed it freely in your application (commercial or not), with or
 * without modifications.
 *
 * Reference: http://www.fpdf.org/en/script/script37.php
 */ function k(t, e) {
    var n, r, i, a;
    if (t !== n) {
        for(var o = (i = t, a = 1 + (256 / t.length | 0), new Array(a + 1).join(i)), s = [], u = 0; u < 256; u++)s[u] = u;
        var c = 0;
        for(u = 0; u < 256; u++){
            var l = s[u];
            c = (c + l + o.charCodeAt(u)) % 256, s[u] = s[c], s[c] = l;
        }
        n = t, r = s;
    } else s = r;
    var h = e.length, f = 0, d = 0, p = "";
    for(u = 0; u < h; u++)d = (d + (l = s[f = (f + 1) % 256])) % 256, s[f] = s[d], s[d] = l, o = s[(s[f] + s[d]) % 256], p += String.fromCharCode(e.charCodeAt(u) ^ o);
    return p;
}
/**
 * @license
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 * Author: Owen Leong (@owenl131)
 * Date: 15 Oct 2020
 * References:
 * https://www.cs.cmu.edu/~dst/Adobe/Gallery/anon21jul01-pdf-encryption.txt
 * https://github.com/foliojs/pdfkit/blob/master/lib/security.js
 * http://www.fpdf.org/en/script/script37.php
 */ var F = {
    print: 4,
    modify: 8,
    copy: 16,
    "annot-forms": 32
};
function I(t, e, n, r) {
    this.v = 1, this.r = 2;
    var i = 192;
    t.forEach(function(t) {
        if (void 0 !== F.perm) throw new Error("Invalid permission: " + t);
        i += F[t];
    }), this.padding = "(\xbfN^Nu\x8aAd\0NV\xff\xfa\x01\b..\0\xb6\xd0h>\x80/\f\xa9\xfedSiz";
    var a = (e + this.padding).substr(0, 32), o = (n + this.padding).substr(0, 32);
    this.O = this.processOwnerPassword(a, o), this.P = -(1 + (255 ^ i)), this.encryptionKey = S(a + this.O + this.lsbFirstWord(this.P) + this.hexToBytes(r)).substr(0, 5), this.U = k(this.encryptionKey, this.padding);
}
function j(t) {
    if (/[^\u0000-\u00ff]/.test(t)) throw new Error("Invalid PDF Name Object: " + t + ", Only accept ASCII characters.");
    for(var e = "", n = t.length, r = 0; r < n; r++){
        var i = t.charCodeAt(r);
        e += i < 33 || 35 === i || 37 === i || 40 === i || 41 === i || 47 === i || 60 === i || 62 === i || 91 === i || 93 === i || 123 === i || 125 === i || i > 126 ? "#" + ("0" + i.toString(16)).slice(-2) : t[r];
    }
    return e;
}
function C(e) {
    if ("object" !== (0, _typeofDefault.default)(e)) throw new Error("Invalid Context passed to initialize PubSub (jsPDF-module)");
    var n = {};
    this.subscribe = function(t, e, r) {
        if (r = r || !1, "string" != typeof t || "function" != typeof e || "boolean" != typeof r) throw new Error("Invalid arguments passed to PubSub.subscribe (jsPDF-module)");
        n.hasOwnProperty(t) || (n[t] = {});
        var i = Math.random().toString(35);
        return n[t][i] = [
            e,
            !!r
        ], i;
    }, this.unsubscribe = function(t) {
        for(var e in n)if (n[e][t]) return delete n[e][t], 0 === Object.keys(n[e]).length && delete n[e], !0;
        return !1;
    }, this.publish = function(t) {
        if (n.hasOwnProperty(t)) {
            var r = Array.prototype.slice.call(arguments, 1), a = [];
            for(var s in n[t]){
                var u = n[t][s];
                try {
                    u[0].apply(e, r);
                } catch (c) {
                    i.console && o.error("jsPDF PubSub Error", c.message, c);
                }
                u[1] && a.push(s);
            }
            a.length && a.forEach(this.unsubscribe);
        }
    }, this.getTopics = function() {
        return n;
    };
}
function O(t) {
    if (!(this instanceof O)) return new O(t);
    var e = "opacity,stroke-opacity".split(",");
    for(var n in t)t.hasOwnProperty(n) && e.indexOf(n) >= 0 && (this[n] = t[n]);
    this.id = "", this.objectNumber = -1;
}
function B(t, e) {
    this.gState = t, this.matrix = e, this.id = "", this.objectNumber = -1;
}
function M(t, e, n, r, i) {
    if (!(this instanceof M)) return new M(t, e, n, r, i);
    this.type = "axial" === t ? 2 : 3, this.coords = e, this.colors = n, B.call(this, r, i);
}
function q(t, e, n, r, i) {
    if (!(this instanceof q)) return new q(t, e, n, r, i);
    this.boundingBox = t, this.xStep = e, this.yStep = n, this.stream = "", this.cloneIndex = 0, B.call(this, r, i);
}
function E(e) {
    var n, r = "string" == typeof arguments[0] ? arguments[0] : "p", a = arguments[1], s = arguments[2], u = arguments[3], c = [], f = 1, p = 16, g = "S", m = null;
    "object" === (0, _typeofDefault.default)(e = e || {}) && (r = e.orientation, a = e.unit || a, s = e.format || s, u = e.compress || e.compressPdf || u, null !== (m = e.encryption || null) && (m.userPassword = m.userPassword || "", m.ownerPassword = m.ownerPassword || "", m.userPermissions = m.userPermissions || []), f = "number" == typeof e.userUnit ? Math.abs(e.userUnit) : 1, void 0 !== e.precision && (n = e.precision), void 0 !== e.floatPrecision && (p = e.floatPrecision), g = e.defaultPathOperation || "S"), c = e.filters || (!0 === u ? [
        "FlateEncode"
    ] : c), a = a || "mm", r = ("" + (r || "P")).toLowerCase();
    var v = e.putOnlyUsedFonts || !1, b = {}, y = {
        internal: {},
        __private__: {}
    };
    y.__private__.PubSub = C;
    var w = "1.3", N = y.__private__.getPdfVersion = function() {
        return w;
    };
    y.__private__.setPdfVersion = function(t) {
        w = t;
    };
    var L = {
        a0: [
            2383.94,
            3370.39
        ],
        a1: [
            1683.78,
            2383.94
        ],
        a2: [
            1190.55,
            1683.78
        ],
        a3: [
            841.89,
            1190.55
        ],
        a4: [
            595.28,
            841.89
        ],
        a5: [
            419.53,
            595.28
        ],
        a6: [
            297.64,
            419.53
        ],
        a7: [
            209.76,
            297.64
        ],
        a8: [
            147.4,
            209.76
        ],
        a9: [
            104.88,
            147.4
        ],
        a10: [
            73.7,
            104.88
        ],
        b0: [
            2834.65,
            4008.19
        ],
        b1: [
            2004.09,
            2834.65
        ],
        b2: [
            1417.32,
            2004.09
        ],
        b3: [
            1000.63,
            1417.32
        ],
        b4: [
            708.66,
            1000.63
        ],
        b5: [
            498.9,
            708.66
        ],
        b6: [
            354.33,
            498.9
        ],
        b7: [
            249.45,
            354.33
        ],
        b8: [
            175.75,
            249.45
        ],
        b9: [
            124.72,
            175.75
        ],
        b10: [
            87.87,
            124.72
        ],
        c0: [
            2599.37,
            3676.54
        ],
        c1: [
            1836.85,
            2599.37
        ],
        c2: [
            1298.27,
            1836.85
        ],
        c3: [
            918.43,
            1298.27
        ],
        c4: [
            649.13,
            918.43
        ],
        c5: [
            459.21,
            649.13
        ],
        c6: [
            323.15,
            459.21
        ],
        c7: [
            229.61,
            323.15
        ],
        c8: [
            161.57,
            229.61
        ],
        c9: [
            113.39,
            161.57
        ],
        c10: [
            79.37,
            113.39
        ],
        dl: [
            311.81,
            623.62
        ],
        letter: [
            612,
            792
        ],
        "government-letter": [
            576,
            756
        ],
        legal: [
            612,
            1008
        ],
        "junior-legal": [
            576,
            360
        ],
        ledger: [
            1224,
            792
        ],
        tabloid: [
            792,
            1224
        ],
        "credit-card": [
            153,
            243
        ]
    };
    y.__private__.getPageFormats = function() {
        return L;
    };
    var x = y.__private__.getPageFormat = function(t) {
        return L[t];
    };
    s = s || "a4";
    var A = "compat", S = "advanced", _ = A;
    function P() {
        this.saveGraphicsState(), lt(new Wt(St, 0, 0, -St, 0, _n() * St).toString() + " cm"), this.setFontSize(this.getFontSize() / St), g = "n", _ = S;
    }
    function k() {
        this.restoreGraphicsState(), g = "S", _ = A;
    }
    var F = y.__private__.combineFontStyleAndFontWeight = function(t, e) {
        if ("bold" == t && "normal" == e || "bold" == t && 400 == e || "normal" == t && "italic" == e || "bold" == t && "italic" == e) throw new Error("Invalid Combination of fontweight and fontstyle");
        return e && (t = 400 == e || "normal" === e ? "italic" === t ? "italic" : "normal" : 700 != e && "bold" !== e || "normal" !== t ? (700 == e ? "bold" : e) + "" + t : "bold"), t;
    };
    y.advancedAPI = function(t) {
        var e = _ === A;
        return e && P.call(this), "function" != typeof t || (t(this), e && k.call(this)), this;
    }, y.compatAPI = function(t) {
        var e = _ === S;
        return e && k.call(this), "function" != typeof t || (t(this), e && P.call(this)), this;
    }, y.isAdvancedAPI = function() {
        return _ === S;
    };
    var B, R = function(t) {
        if (_ !== S) throw new Error(t + " is only available in 'advanced' API mode. You need to call advancedAPI() first.");
    }, D = y.roundToPrecision = y.__private__.roundToPrecision = function(t, e) {
        var r = n || e;
        if (isNaN(t) || isNaN(r)) throw new Error("Invalid argument passed to jsPDF.roundToPrecision");
        return t.toFixed(r).replace(/0+$/, "");
    };
    B = y.hpf = y.__private__.hpf = "number" == typeof p ? function(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.hpf");
        return D(t, p);
    } : "smart" === p ? function(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.hpf");
        return D(t, t > -1 && t < 1 ? 16 : 5);
    } : function(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.hpf");
        return D(t, 16);
    };
    var T = y.f2 = y.__private__.f2 = function(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.f2");
        return D(t, 2);
    }, z = y.__private__.f3 = function(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.f3");
        return D(t, 3);
    }, U = y.scale = y.__private__.scale = function(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.scale");
        return _ === A ? t * St : _ === S ? t : void 0;
    }, H = function(t) {
        return U(function(t) {
            return _ === A ? _n() - t : _ === S ? t : void 0;
        }(t));
    };
    y.__private__.setPrecision = y.setPrecision = function(t) {
        "number" == typeof parseInt(t, 10) && (n = parseInt(t, 10));
    };
    var W, V = "00000000000000000000000000000000", G = y.__private__.getFileId = function() {
        return V;
    }, Y = y.__private__.setFileId = function(t) {
        return V = void 0 !== t && /^[a-fA-F0-9]{32}$/.test(t) ? t.toUpperCase() : V.split("").map(function() {
            return "ABCDEF0123456789".charAt(Math.floor(16 * Math.random()));
        }).join(""), null !== m && (je = new I(m.userPermissions, m.userPassword, m.ownerPassword, V)), V;
    };
    y.setFileId = function(t) {
        return Y(t), this;
    }, y.getFileId = function() {
        return G();
    };
    var J = y.__private__.convertDateToPDFDate = function(t) {
        var e = t.getTimezoneOffset(), n = e < 0 ? "+" : "-", r = Math.floor(Math.abs(e / 60)), i = Math.abs(e % 60), a = [
            n,
            Q(r),
            "'",
            Q(i),
            "'"
        ].join("");
        return [
            "D:",
            t.getFullYear(),
            Q(t.getMonth() + 1),
            Q(t.getDate()),
            Q(t.getHours()),
            Q(t.getMinutes()),
            Q(t.getSeconds()),
            a
        ].join("");
    }, X = y.__private__.convertPDFDateToDate = function(t) {
        var e = parseInt(t.substr(2, 4), 10), n = parseInt(t.substr(6, 2), 10) - 1, r = parseInt(t.substr(8, 2), 10), i = parseInt(t.substr(10, 2), 10), a = parseInt(t.substr(12, 2), 10), o = parseInt(t.substr(14, 2), 10);
        return new Date(e, n, r, i, a, o, 0);
    }, K = y.__private__.setCreationDate = function(t) {
        var e;
        if (void 0 === t && (t = new Date), t instanceof Date) e = J(t);
        else {
            if (!/^D:(20[0-2][0-9]|203[0-7]|19[7-9][0-9])(0[0-9]|1[0-2])([0-2][0-9]|3[0-1])(0[0-9]|1[0-9]|2[0-3])(0[0-9]|[1-5][0-9])(0[0-9]|[1-5][0-9])(\+0[0-9]|\+1[0-4]|-0[0-9]|-1[0-1])'(0[0-9]|[1-5][0-9])'?$/.test(t)) throw new Error("Invalid argument passed to jsPDF.setCreationDate");
            e = t;
        }
        return W = e;
    }, Z = y.__private__.getCreationDate = function(t) {
        var e = W;
        return "jsDate" === t && (e = X(W)), e;
    };
    y.setCreationDate = function(t) {
        return K(t), this;
    }, y.getCreationDate = function(t) {
        return Z(t);
    };
    var $, Q = y.__private__.padd2 = function(t) {
        return ("0" + parseInt(t)).slice(-2);
    }, tt = y.__private__.padd2Hex = function(t) {
        return ("00" + (t = t.toString())).substr(t.length);
    }, et = 0, nt = [], rt = [], it = 0, at = [], ot = [], st = !1, ut = rt;
    y.__private__.setCustomOutputDestination = function(t) {
        st = !0, ut = t;
    };
    var ct = function(t) {
        st || (ut = t);
    };
    y.__private__.resetCustomOutputDestination = function() {
        st = !1, ut = rt;
    };
    var lt = y.__private__.out = function(t) {
        return t = t.toString(), it += t.length + 1, ut.push(t), ut;
    }, ht = y.__private__.write = function(t) {
        return lt(1 === arguments.length ? t.toString() : Array.prototype.join.call(arguments, " "));
    }, ft = y.__private__.getArrayBuffer = function(t) {
        for(var e = t.length, n = new ArrayBuffer(e), r = new Uint8Array(n); e--;)r[e] = t.charCodeAt(e);
        return n;
    }, dt = [
        [
            "Helvetica",
            "helvetica",
            "normal",
            "WinAnsiEncoding"
        ],
        [
            "Helvetica-Bold",
            "helvetica",
            "bold",
            "WinAnsiEncoding"
        ],
        [
            "Helvetica-Oblique",
            "helvetica",
            "italic",
            "WinAnsiEncoding"
        ],
        [
            "Helvetica-BoldOblique",
            "helvetica",
            "bolditalic",
            "WinAnsiEncoding"
        ],
        [
            "Courier",
            "courier",
            "normal",
            "WinAnsiEncoding"
        ],
        [
            "Courier-Bold",
            "courier",
            "bold",
            "WinAnsiEncoding"
        ],
        [
            "Courier-Oblique",
            "courier",
            "italic",
            "WinAnsiEncoding"
        ],
        [
            "Courier-BoldOblique",
            "courier",
            "bolditalic",
            "WinAnsiEncoding"
        ],
        [
            "Times-Roman",
            "times",
            "normal",
            "WinAnsiEncoding"
        ],
        [
            "Times-Bold",
            "times",
            "bold",
            "WinAnsiEncoding"
        ],
        [
            "Times-Italic",
            "times",
            "italic",
            "WinAnsiEncoding"
        ],
        [
            "Times-BoldItalic",
            "times",
            "bolditalic",
            "WinAnsiEncoding"
        ],
        [
            "ZapfDingbats",
            "zapfdingbats",
            "normal",
            null
        ],
        [
            "Symbol",
            "symbol",
            "normal",
            null
        ]
    ];
    y.__private__.getStandardFonts = function() {
        return dt;
    };
    var pt = e.fontSize || 16;
    y.__private__.setFontSize = y.setFontSize = function(t) {
        return pt = _ === S ? t / St : t, this;
    };
    var gt, mt = y.__private__.getFontSize = y.getFontSize = function() {
        return _ === A ? pt : pt * St;
    }, vt = e.R2L || !1;
    y.__private__.setR2L = y.setR2L = function(t) {
        return vt = t, this;
    }, y.__private__.getR2L = y.getR2L = function() {
        return vt;
    };
    var bt, yt = y.__private__.setZoomMode = function(t) {
        if (/^(?:\d+\.\d*|\d*\.\d+|\d+)%$/.test(t)) gt = t;
        else if (isNaN(t)) {
            if (-1 === [
                void 0,
                null,
                "fullwidth",
                "fullheight",
                "fullpage",
                "original"
            ].indexOf(t)) throw new Error('zoom must be Integer (e.g. 2), a percentage Value (e.g. 300%) or fullwidth, fullheight, fullpage, original. "' + t + '" is not recognized.');
            gt = t;
        } else gt = parseInt(t, 10);
    };
    y.__private__.getZoomMode = function() {
        return gt;
    };
    var wt, Nt = y.__private__.setPageMode = function(t) {
        if (-1 == [
            void 0,
            null,
            "UseNone",
            "UseOutlines",
            "UseThumbs",
            "FullScreen"
        ].indexOf(t)) throw new Error('Page mode must be one of UseNone, UseOutlines, UseThumbs, or FullScreen. "' + t + '" is not recognized.');
        bt = t;
    };
    y.__private__.getPageMode = function() {
        return bt;
    };
    var Lt = y.__private__.setLayoutMode = function(t) {
        if (-1 == [
            void 0,
            null,
            "continuous",
            "single",
            "twoleft",
            "tworight",
            "two"
        ].indexOf(t)) throw new Error('Layout mode must be one of continuous, single, twoleft, tworight. "' + t + '" is not recognized.');
        wt = t;
    };
    y.__private__.getLayoutMode = function() {
        return wt;
    }, y.__private__.setDisplayMode = y.setDisplayMode = function(t, e, n) {
        return yt(t), Lt(e), Nt(n), this;
    };
    var xt = {
        title: "",
        subject: "",
        author: "",
        keywords: "",
        creator: ""
    };
    y.__private__.getDocumentProperty = function(t) {
        if (-1 === Object.keys(xt).indexOf(t)) throw new Error("Invalid argument passed to jsPDF.getDocumentProperty");
        return xt[t];
    }, y.__private__.getDocumentProperties = function() {
        return xt;
    }, y.__private__.setDocumentProperties = y.setProperties = y.setDocumentProperties = function(t) {
        for(var e in xt)xt.hasOwnProperty(e) && t[e] && (xt[e] = t[e]);
        return this;
    }, y.__private__.setDocumentProperty = function(t, e) {
        if (-1 === Object.keys(xt).indexOf(t)) throw new Error("Invalid arguments passed to jsPDF.setDocumentProperty");
        return xt[t] = e;
    };
    var At, St, _t, Pt, kt, Ft = {}, It = {}, jt = [], Ct = {}, Ot = {}, Bt = {}, Mt = {}, qt = null, Et = 0, Rt = [], Dt = new C(y), Tt = e.hotfixes || [], zt = {}, Ut = {}, Ht = [], Wt = function t(e, n, r, i, a, o) {
        if (!(this instanceof t)) return new t(e, n, r, i, a, o);
        isNaN(e) && (e = 1), isNaN(n) && (n = 0), isNaN(r) && (r = 0), isNaN(i) && (i = 1), isNaN(a) && (a = 0), isNaN(o) && (o = 0), this._matrix = [
            e,
            n,
            r,
            i,
            a,
            o
        ];
    };
    Object.defineProperty(Wt.prototype, "sx", {
        get: function() {
            return this._matrix[0];
        },
        set: function(t) {
            this._matrix[0] = t;
        }
    }), Object.defineProperty(Wt.prototype, "shy", {
        get: function() {
            return this._matrix[1];
        },
        set: function(t) {
            this._matrix[1] = t;
        }
    }), Object.defineProperty(Wt.prototype, "shx", {
        get: function() {
            return this._matrix[2];
        },
        set: function(t) {
            this._matrix[2] = t;
        }
    }), Object.defineProperty(Wt.prototype, "sy", {
        get: function() {
            return this._matrix[3];
        },
        set: function(t) {
            this._matrix[3] = t;
        }
    }), Object.defineProperty(Wt.prototype, "tx", {
        get: function() {
            return this._matrix[4];
        },
        set: function(t) {
            this._matrix[4] = t;
        }
    }), Object.defineProperty(Wt.prototype, "ty", {
        get: function() {
            return this._matrix[5];
        },
        set: function(t) {
            this._matrix[5] = t;
        }
    }), Object.defineProperty(Wt.prototype, "a", {
        get: function() {
            return this._matrix[0];
        },
        set: function(t) {
            this._matrix[0] = t;
        }
    }), Object.defineProperty(Wt.prototype, "b", {
        get: function() {
            return this._matrix[1];
        },
        set: function(t) {
            this._matrix[1] = t;
        }
    }), Object.defineProperty(Wt.prototype, "c", {
        get: function() {
            return this._matrix[2];
        },
        set: function(t) {
            this._matrix[2] = t;
        }
    }), Object.defineProperty(Wt.prototype, "d", {
        get: function() {
            return this._matrix[3];
        },
        set: function(t) {
            this._matrix[3] = t;
        }
    }), Object.defineProperty(Wt.prototype, "e", {
        get: function() {
            return this._matrix[4];
        },
        set: function(t) {
            this._matrix[4] = t;
        }
    }), Object.defineProperty(Wt.prototype, "f", {
        get: function() {
            return this._matrix[5];
        },
        set: function(t) {
            this._matrix[5] = t;
        }
    }), Object.defineProperty(Wt.prototype, "rotation", {
        get: function() {
            return Math.atan2(this.shx, this.sx);
        }
    }), Object.defineProperty(Wt.prototype, "scaleX", {
        get: function() {
            return this.decompose().scale.sx;
        }
    }), Object.defineProperty(Wt.prototype, "scaleY", {
        get: function() {
            return this.decompose().scale.sy;
        }
    }), Object.defineProperty(Wt.prototype, "isIdentity", {
        get: function() {
            return 1 === this.sx && 0 === this.shy && 0 === this.shx && 1 === this.sy && 0 === this.tx && 0 === this.ty;
        }
    }), Wt.prototype.join = function(t) {
        return [
            this.sx,
            this.shy,
            this.shx,
            this.sy,
            this.tx,
            this.ty
        ].map(B).join(t);
    }, Wt.prototype.multiply = function(t) {
        var e = t.sx * this.sx + t.shy * this.shx, n = t.sx * this.shy + t.shy * this.sy, r = t.shx * this.sx + t.sy * this.shx, i = t.shx * this.shy + t.sy * this.sy, a = t.tx * this.sx + t.ty * this.shx + this.tx, o = t.tx * this.shy + t.ty * this.sy + this.ty;
        return new Wt(e, n, r, i, a, o);
    }, Wt.prototype.decompose = function() {
        var t = this.sx, e = this.shy, n = this.shx, r = this.sy, i = this.tx, a = this.ty, o = Math.sqrt(t * t + e * e), s = (t /= o) * n + (e /= o) * r;
        n -= t * s, r -= e * s;
        var u = Math.sqrt(n * n + r * r);
        return s /= u, t * (r /= u) < e * (n /= u) && (t = -t, e = -e, s = -s, o = -o), {
            scale: new Wt(o, 0, 0, u, 0, 0),
            translate: new Wt(1, 0, 0, 1, i, a),
            rotate: new Wt(t, e, -e, t, 0, 0),
            skew: new Wt(1, 0, s, 1, 0, 0)
        };
    }, Wt.prototype.toString = function(t) {
        return this.join(" ");
    }, Wt.prototype.inversed = function() {
        var t = this.sx, e = this.shy, n = this.shx, r = this.sy, i = this.tx, a = this.ty, o = 1 / (t * r - e * n), s = r * o, u = -e * o, c = -n * o, l = t * o;
        return new Wt(s, u, c, l, -s * i - c * a, -u * i - l * a);
    }, Wt.prototype.applyToPoint = function(t) {
        var e = t.x * this.sx + t.y * this.shx + this.tx, n = t.x * this.shy + t.y * this.sy + this.ty;
        return new gn(e, n);
    }, Wt.prototype.applyToRectangle = function(t) {
        var e = this.applyToPoint(t), n = this.applyToPoint(new gn(t.x + t.w, t.y + t.h));
        return new mn(e.x, e.y, n.x - e.x, n.y - e.y);
    }, Wt.prototype.clone = function() {
        var t = this.sx, e = this.shy, n = this.shx, r = this.sy, i = this.tx, a = this.ty;
        return new Wt(t, e, n, r, i, a);
    }, y.Matrix = Wt;
    var Vt = y.matrixMult = function(t, e) {
        return e.multiply(t);
    }, Gt = new Wt(1, 0, 0, 1, 0, 0);
    y.unitMatrix = y.identityMatrix = Gt;
    var Yt = function(t, e) {
        if (!Ot[t]) {
            var n = (e instanceof M ? "Sh" : "P") + (Object.keys(Ct).length + 1).toString(10);
            e.id = n, Ot[t] = n, Ct[n] = e, Dt.publish("addPattern", e);
        }
    };
    y.ShadingPattern = M, y.TilingPattern = q, y.addShadingPattern = function(t, e) {
        return R("addShadingPattern()"), Yt(t, e), this;
    }, y.beginTilingPattern = function(t) {
        R("beginTilingPattern()"), bn(t.boundingBox[0], t.boundingBox[1], t.boundingBox[2] - t.boundingBox[0], t.boundingBox[3] - t.boundingBox[1], t.matrix);
    }, y.endTilingPattern = function(t, e) {
        R("endTilingPattern()"), e.stream = ot[$].join("\n"), Yt(t, e), Dt.publish("endTilingPattern", e), Ht.pop().restore();
    };
    var Jt, Xt = y.__private__.newObject = function() {
        var t = Kt();
        return Zt(t, !0), t;
    }, Kt = y.__private__.newObjectDeferred = function() {
        return et++, nt[et] = function() {
            return it;
        }, et;
    }, Zt = function(t, e) {
        return e = "boolean" == typeof e && e, nt[t] = it, e && lt(t + " 0 obj"), t;
    }, $t = y.__private__.newAdditionalObject = function() {
        var t = {
            objId: Kt(),
            content: ""
        };
        return at.push(t), t;
    }, Qt = Kt(), te = Kt(), ee = y.__private__.decodeColorString = function(t) {
        var e = t.split(" ");
        if (2 !== e.length || "g" !== e[1] && "G" !== e[1]) 5 !== e.length || "k" !== e[4] && "K" !== e[4] || (e = [
            (1 - e[0]) * (1 - e[3]),
            (1 - e[1]) * (1 - e[3]),
            (1 - e[2]) * (1 - e[3]),
            "r"
        ]);
        else {
            var n = parseFloat(e[0]);
            e = [
                n,
                n,
                n,
                "r"
            ];
        }
        for(var r = "#", i = 0; i < 3; i++)r += ("0" + Math.floor(255 * parseFloat(e[i])).toString(16)).slice(-2);
        return r;
    }, ne = y.__private__.encodeColorString = function(e) {
        var n;
        "string" == typeof e && (e = {
            ch1: e
        });
        var r = e.ch1, i = e.ch2, a = e.ch3, o = e.ch4, s = "draw" === e.pdfColorType ? [
            "G",
            "RG",
            "K"
        ] : [
            "g",
            "rg",
            "k"
        ];
        if ("string" == typeof r && "#" !== r.charAt(0)) {
            var u = new h(r);
            if (u.ok) r = u.toHex();
            else if (!/^\d*\.?\d*$/.test(r)) throw new Error('Invalid color "' + r + '" passed to jsPDF.encodeColorString.');
        }
        if ("string" == typeof r && /^#[0-9A-Fa-f]{3}$/.test(r) && (r = "#" + r[1] + r[1] + r[2] + r[2] + r[3] + r[3]), "string" == typeof r && /^#[0-9A-Fa-f]{6}$/.test(r)) {
            var c = parseInt(r.substr(1), 16);
            r = c >> 16 & 255, i = c >> 8 & 255, a = 255 & c;
        }
        if (void 0 === i || void 0 === o && r === i && i === a) n = "string" == typeof r ? r + " " + s[0] : 2 === e.precision ? T(r / 255) + " " + s[0] : z(r / 255) + " " + s[0];
        else if (void 0 === o || "object" === (0, _typeofDefault.default)(o)) {
            if (o && !isNaN(o.a) && 0 === o.a) return [
                "1.",
                "1.",
                "1.",
                s[1]
            ].join(" ");
            n = "string" == typeof r ? [
                r,
                i,
                a,
                s[1]
            ].join(" ") : 2 === e.precision ? [
                T(r / 255),
                T(i / 255),
                T(a / 255),
                s[1]
            ].join(" ") : [
                z(r / 255),
                z(i / 255),
                z(a / 255),
                s[1]
            ].join(" ");
        } else n = "string" == typeof r ? [
            r,
            i,
            a,
            o,
            s[2]
        ].join(" ") : 2 === e.precision ? [
            T(r),
            T(i),
            T(a),
            T(o),
            s[2]
        ].join(" ") : [
            z(r),
            z(i),
            z(a),
            z(o),
            s[2]
        ].join(" ");
        return n;
    }, re = y.__private__.getFilters = function() {
        return c;
    }, ie = y.__private__.putStream = function(t) {
        var e = (t = t || {}).data || "", n = t.filters || re(), r = t.alreadyAppliedFilters || [], i = t.addLength1 || !1, a = e.length, o = t.objectId, s = function(t) {
            return t;
        };
        if (null !== m && void 0 === o) throw new Error("ObjectId must be passed to putStream for file encryption");
        null !== m && (s = je.encryptor(o, 0));
        var u = {};
        !0 === n && (n = [
            "FlateEncode"
        ]);
        var c = t.additionalKeyValues || [], l = (u = void 0 !== E.API.processDataByFilters ? E.API.processDataByFilters(e, n) : {
            data: e,
            reverseChain: []
        }).reverseChain + (Array.isArray(r) ? r.join(" ") : r.toString());
        if (0 !== u.data.length && (c.push({
            key: "Length",
            value: u.data.length
        }), !0 === i && c.push({
            key: "Length1",
            value: a
        })), 0 != l.length) {
            if (l.split("/").length - 1 == 1) c.push({
                key: "Filter",
                value: l
            });
            else {
                c.push({
                    key: "Filter",
                    value: "[" + l + "]"
                });
                for(var h = 0; h < c.length; h += 1)if ("DecodeParms" === c[h].key) {
                    for(var f = [], d = 0; d < u.reverseChain.split("/").length - 1; d += 1)f.push("null");
                    f.push(c[h].value), c[h].value = "[" + f.join(" ") + "]";
                }
            }
        }
        lt("<<");
        for(var p = 0; p < c.length; p++)lt("/" + c[p].key + " " + c[p].value);
        lt(">>"), 0 !== u.data.length && (lt("stream"), lt(s(u.data)), lt("endstream"));
    }, ae = y.__private__.putPage = function(t) {
        var e = t.number, n = t.data, r = t.objId, i = t.contentsObjId;
        Zt(r, !0), lt("<</Type /Page"), lt("/Parent " + t.rootDictionaryObjId + " 0 R"), lt("/Resources " + t.resourceDictionaryObjId + " 0 R"), lt("/MediaBox [" + parseFloat(B(t.mediaBox.bottomLeftX)) + " " + parseFloat(B(t.mediaBox.bottomLeftY)) + " " + B(t.mediaBox.topRightX) + " " + B(t.mediaBox.topRightY) + "]"), null !== t.cropBox && lt("/CropBox [" + B(t.cropBox.bottomLeftX) + " " + B(t.cropBox.bottomLeftY) + " " + B(t.cropBox.topRightX) + " " + B(t.cropBox.topRightY) + "]"), null !== t.bleedBox && lt("/BleedBox [" + B(t.bleedBox.bottomLeftX) + " " + B(t.bleedBox.bottomLeftY) + " " + B(t.bleedBox.topRightX) + " " + B(t.bleedBox.topRightY) + "]"), null !== t.trimBox && lt("/TrimBox [" + B(t.trimBox.bottomLeftX) + " " + B(t.trimBox.bottomLeftY) + " " + B(t.trimBox.topRightX) + " " + B(t.trimBox.topRightY) + "]"), null !== t.artBox && lt("/ArtBox [" + B(t.artBox.bottomLeftX) + " " + B(t.artBox.bottomLeftY) + " " + B(t.artBox.topRightX) + " " + B(t.artBox.topRightY) + "]"), "number" == typeof t.userUnit && 1 !== t.userUnit && lt("/UserUnit " + t.userUnit), Dt.publish("putPage", {
            objId: r,
            pageContext: Rt[e],
            pageNumber: e,
            page: n
        }), lt("/Contents " + i + " 0 R"), lt(">>"), lt("endobj");
        var a = n.join("\n");
        return _ === S && (a += "\nQ"), Zt(i, !0), ie({
            data: a,
            filters: re(),
            objectId: i
        }), lt("endobj"), r;
    }, oe = y.__private__.putPages = function() {
        var t, e, n = [];
        for(t = 1; t <= Et; t++)Rt[t].objId = Kt(), Rt[t].contentsObjId = Kt();
        for(t = 1; t <= Et; t++)n.push(ae({
            number: t,
            data: ot[t],
            objId: Rt[t].objId,
            contentsObjId: Rt[t].contentsObjId,
            mediaBox: Rt[t].mediaBox,
            cropBox: Rt[t].cropBox,
            bleedBox: Rt[t].bleedBox,
            trimBox: Rt[t].trimBox,
            artBox: Rt[t].artBox,
            userUnit: Rt[t].userUnit,
            rootDictionaryObjId: Qt,
            resourceDictionaryObjId: te
        }));
        Zt(Qt, !0), lt("<</Type /Pages");
        var r = "/Kids [";
        for(e = 0; e < Et; e++)r += n[e] + " 0 R ";
        lt(r + "]"), lt("/Count " + Et), lt(">>"), lt("endobj"), Dt.publish("postPutPages");
    }, se = function(t) {
        Dt.publish("putFont", {
            font: t,
            out: lt,
            newObject: Xt,
            putStream: ie
        }), !0 !== t.isAlreadyPutted && (t.objectNumber = Xt(), lt("<<"), lt("/Type /Font"), lt("/BaseFont /" + j(t.postScriptName)), lt("/Subtype /Type1"), "string" == typeof t.encoding && lt("/Encoding /" + t.encoding), lt("/FirstChar 32"), lt("/LastChar 255"), lt(">>"), lt("endobj"));
    }, ue = function(t) {
        t.objectNumber = Xt();
        var e = [];
        e.push({
            key: "Type",
            value: "/XObject"
        }), e.push({
            key: "Subtype",
            value: "/Form"
        }), e.push({
            key: "BBox",
            value: "[" + [
                B(t.x),
                B(t.y),
                B(t.x + t.width),
                B(t.y + t.height)
            ].join(" ") + "]"
        }), e.push({
            key: "Matrix",
            value: "[" + t.matrix.toString() + "]"
        });
        var n = t.pages[1].join("\n");
        ie({
            data: n,
            additionalKeyValues: e,
            objectId: t.objectNumber
        }), lt("endobj");
    }, ce = function(t, e) {
        e || (e = 21);
        var n = Xt(), r = function(t, e) {
            var n, r = [], i = 1 / (e - 1);
            for(n = 0; n < 1; n += i)r.push(n);
            if (r.push(1), 0 != t[0].offset) {
                var a = {
                    offset: 0,
                    color: t[0].color
                };
                t.unshift(a);
            }
            if (1 != t[t.length - 1].offset) {
                var o = {
                    offset: 1,
                    color: t[t.length - 1].color
                };
                t.push(o);
            }
            for(var s = "", u = 0, c = 0; c < r.length; c++){
                for(n = r[c]; n > t[u + 1].offset;)u++;
                var l = t[u].offset, h = (n - l) / (t[u + 1].offset - l), f = t[u].color, d = t[u + 1].color;
                s += tt(Math.round((1 - h) * f[0] + h * d[0]).toString(16)) + tt(Math.round((1 - h) * f[1] + h * d[1]).toString(16)) + tt(Math.round((1 - h) * f[2] + h * d[2]).toString(16));
            }
            return s.trim();
        }(t.colors, e), i = [];
        i.push({
            key: "FunctionType",
            value: "0"
        }), i.push({
            key: "Domain",
            value: "[0.0 1.0]"
        }), i.push({
            key: "Size",
            value: "[" + e + "]"
        }), i.push({
            key: "BitsPerSample",
            value: "8"
        }), i.push({
            key: "Range",
            value: "[0.0 1.0 0.0 1.0 0.0 1.0]"
        }), i.push({
            key: "Decode",
            value: "[0.0 1.0 0.0 1.0 0.0 1.0]"
        }), ie({
            data: r,
            additionalKeyValues: i,
            alreadyAppliedFilters: [
                "/ASCIIHexDecode"
            ],
            objectId: n
        }), lt("endobj"), t.objectNumber = Xt(), lt("<< /ShadingType " + t.type), lt("/ColorSpace /DeviceRGB");
        var a = "/Coords [" + B(parseFloat(t.coords[0])) + " " + B(parseFloat(t.coords[1])) + " ";
        2 === t.type ? a += B(parseFloat(t.coords[2])) + " " + B(parseFloat(t.coords[3])) : a += B(parseFloat(t.coords[2])) + " " + B(parseFloat(t.coords[3])) + " " + B(parseFloat(t.coords[4])) + " " + B(parseFloat(t.coords[5])), lt(a += "]"), t.matrix && lt("/Matrix [" + t.matrix.toString() + "]"), lt("/Function " + n + " 0 R"), lt("/Extend [true true]"), lt(">>"), lt("endobj");
    }, le = function(t, e) {
        var n = Kt(), r = Xt();
        e.push({
            resourcesOid: n,
            objectOid: r
        }), t.objectNumber = r;
        var i = [];
        i.push({
            key: "Type",
            value: "/Pattern"
        }), i.push({
            key: "PatternType",
            value: "1"
        }), i.push({
            key: "PaintType",
            value: "1"
        }), i.push({
            key: "TilingType",
            value: "1"
        }), i.push({
            key: "BBox",
            value: "[" + t.boundingBox.map(B).join(" ") + "]"
        }), i.push({
            key: "XStep",
            value: B(t.xStep)
        }), i.push({
            key: "YStep",
            value: B(t.yStep)
        }), i.push({
            key: "Resources",
            value: n + " 0 R"
        }), t.matrix && i.push({
            key: "Matrix",
            value: "[" + t.matrix.toString() + "]"
        }), ie({
            data: t.stream,
            additionalKeyValues: i,
            objectId: t.objectNumber
        }), lt("endobj");
    }, he = function(t) {
        for(var e in t.objectNumber = Xt(), lt("<<"), t)switch(e){
            case "opacity":
                lt("/ca " + T(t[e]));
                break;
            case "stroke-opacity":
                lt("/CA " + T(t[e]));
        }
        lt(">>"), lt("endobj");
    }, fe = function(t) {
        Zt(t.resourcesOid, !0), lt("<<"), lt("/ProcSet [/PDF /Text /ImageB /ImageC /ImageI]"), function() {
            for(var t in lt("/Font <<"), Ft)Ft.hasOwnProperty(t) && (!1 === v || !0 === v && b.hasOwnProperty(t)) && lt("/" + t + " " + Ft[t].objectNumber + " 0 R");
            lt(">>");
        }(), function() {
            if (Object.keys(Ct).length > 0) {
                for(var t in lt("/Shading <<"), Ct)Ct.hasOwnProperty(t) && Ct[t] instanceof M && Ct[t].objectNumber >= 0 && lt("/" + t + " " + Ct[t].objectNumber + " 0 R");
                Dt.publish("putShadingPatternDict"), lt(">>");
            }
        }(), function(t) {
            if (Object.keys(Ct).length > 0) {
                for(var e in lt("/Pattern <<"), Ct)Ct.hasOwnProperty(e) && Ct[e] instanceof y.TilingPattern && Ct[e].objectNumber >= 0 && Ct[e].objectNumber < t && lt("/" + e + " " + Ct[e].objectNumber + " 0 R");
                Dt.publish("putTilingPatternDict"), lt(">>");
            }
        }(t.objectOid), function() {
            if (Object.keys(Bt).length > 0) {
                var t;
                for(t in lt("/ExtGState <<"), Bt)Bt.hasOwnProperty(t) && Bt[t].objectNumber >= 0 && lt("/" + t + " " + Bt[t].objectNumber + " 0 R");
                Dt.publish("putGStateDict"), lt(">>");
            }
        }(), function() {
            for(var t in lt("/XObject <<"), zt)zt.hasOwnProperty(t) && zt[t].objectNumber >= 0 && lt("/" + t + " " + zt[t].objectNumber + " 0 R");
            Dt.publish("putXobjectDict"), lt(">>");
        }(), lt(">>"), lt("endobj");
    }, de = function(t) {
        It[t.fontName] = It[t.fontName] || {}, It[t.fontName][t.fontStyle] = t.id;
    }, pe = function(t, e, n, r, i) {
        var a = {
            id: "F" + (Object.keys(Ft).length + 1).toString(10),
            postScriptName: t,
            fontName: e,
            fontStyle: n,
            encoding: r,
            isStandardFont: i || !1,
            metadata: {}
        };
        return Dt.publish("addFont", {
            font: a,
            instance: this
        }), Ft[a.id] = a, de(a), a.id;
    }, ge = y.__private__.pdfEscape = y.pdfEscape = function(t, e) {
        return (function(t, e) {
            var n, r, i, a, o, s, u, c, l;
            if (i = (e = e || {}).sourceEncoding || "Unicode", o = e.outputEncoding, (e.autoencode || o) && Ft[At].metadata && Ft[At].metadata[i] && Ft[At].metadata[i].encoding && (a = Ft[At].metadata[i].encoding, !o && Ft[At].encoding && (o = Ft[At].encoding), !o && a.codePages && (o = a.codePages[0]), "string" == typeof o && (o = a[o]), o)) {
                for(u = !1, s = [], n = 0, r = t.length; n < r; n++)(c = o[t.charCodeAt(n)]) ? s.push(String.fromCharCode(c)) : s.push(t[n]), s[n].charCodeAt(0) >> 8 && (u = !0);
                t = s.join("");
            }
            for(n = t.length; void 0 === u && 0 !== n;)t.charCodeAt(n - 1) >> 8 && (u = !0), n--;
            if (!u) return t;
            for(s = e.noBOM ? [] : [
                254,
                255
            ], n = 0, r = t.length; n < r; n++){
                if ((l = (c = t.charCodeAt(n)) >> 8) >> 8) throw new Error("Character at position " + n + " of string '" + t + "' exceeds 16bits. Cannot be encoded into UCS-2 BE");
                s.push(l), s.push(c - (l << 8));
            }
            return String.fromCharCode.apply(void 0, s);
        })(t, e).replace(/\\/g, "\\\\").replace(/\(/g, "\\(").replace(/\)/g, "\\)");
    }, me = y.__private__.beginPage = function(t) {
        ot[++Et] = [], Rt[Et] = {
            objId: 0,
            contentsObjId: 0,
            userUnit: Number(f),
            artBox: null,
            bleedBox: null,
            cropBox: null,
            trimBox: null,
            mediaBox: {
                bottomLeftX: 0,
                bottomLeftY: 0,
                topRightX: Number(t[0]),
                topRightY: Number(t[1])
            }
        }, ye(Et), ct(ot[$]);
    }, ve = function(t, e) {
        var n, i, a;
        switch(r = e || r, "string" == typeof t && (n = x(t.toLowerCase()), Array.isArray(n) && (i = n[0], a = n[1])), Array.isArray(t) && (i = t[0] * St, a = t[1] * St), isNaN(i) && (i = s[0], a = s[1]), (i > 14400 || a > 14400) && (o.warn("A page in a PDF can not be wider or taller than 14400 userUnit. jsPDF limits the width/height to 14400"), i = Math.min(14400, i), a = Math.min(14400, a)), s = [
            i,
            a
        ], r.substr(0, 1)){
            case "l":
                a > i && (s = [
                    a,
                    i
                ]);
                break;
            case "p":
                i > a && (s = [
                    a,
                    i
                ]);
        }
        me(s), Ze(Xe), lt(on), 0 !== fn && lt(fn + " J"), 0 !== dn && lt(dn + " j"), Dt.publish("addPage", {
            pageNumber: Et
        });
    }, be = function(t) {
        t > 0 && t <= Et && (ot.splice(t, 1), Rt.splice(t, 1), Et--, $ > Et && ($ = Et), this.setPage($));
    }, ye = function(t) {
        t > 0 && t <= Et && ($ = t);
    }, we = y.__private__.getNumberOfPages = y.getNumberOfPages = function() {
        return ot.length - 1;
    }, Ne = function(t, e, n) {
        var r, i = void 0;
        return n = n || {}, t = void 0 !== t ? t : Ft[At].fontName, e = void 0 !== e ? e : Ft[At].fontStyle, r = t.toLowerCase(), void 0 !== It[r] && void 0 !== It[r][e] ? i = It[r][e] : void 0 !== It[t] && void 0 !== It[t][e] ? i = It[t][e] : !1 === n.disableWarning && o.warn("Unable to look up font label for font '" + t + "', '" + e + "'. Refer to getFontList() for available fonts."), i || n.noFallback || null == (i = It.times[e]) && (i = It.times.normal), i;
    }, Le = y.__private__.putInfo = function() {
        var t = Xt(), e = function(t) {
            return t;
        };
        for(var n in null !== m && (e = je.encryptor(t, 0)), lt("<<"), lt("/Producer (" + ge(e("jsPDF " + E.version)) + ")"), xt)xt.hasOwnProperty(n) && xt[n] && lt("/" + n.substr(0, 1).toUpperCase() + n.substr(1) + " (" + ge(e(xt[n])) + ")");
        lt("/CreationDate (" + ge(e(W)) + ")"), lt(">>"), lt("endobj");
    }, xe = y.__private__.putCatalog = function(t) {
        var e = (t = t || {}).rootDictionaryObjId || Qt;
        switch(Xt(), lt("<<"), lt("/Type /Catalog"), lt("/Pages " + e + " 0 R"), gt || (gt = "fullwidth"), gt){
            case "fullwidth":
                lt("/OpenAction [3 0 R /FitH null]");
                break;
            case "fullheight":
                lt("/OpenAction [3 0 R /FitV null]");
                break;
            case "fullpage":
                lt("/OpenAction [3 0 R /Fit]");
                break;
            case "original":
                lt("/OpenAction [3 0 R /XYZ null null 1]");
                break;
            default:
                var n = "" + gt;
                "%" === n.substr(n.length - 1) && (gt = parseInt(gt) / 100), "number" == typeof gt && lt("/OpenAction [3 0 R /XYZ null null " + T(gt) + "]");
        }
        switch(wt || (wt = "continuous"), wt){
            case "continuous":
                lt("/PageLayout /OneColumn");
                break;
            case "single":
                lt("/PageLayout /SinglePage");
                break;
            case "two":
            case "twoleft":
                lt("/PageLayout /TwoColumnLeft");
                break;
            case "tworight":
                lt("/PageLayout /TwoColumnRight");
        }
        bt && lt("/PageMode /" + bt), Dt.publish("putCatalog"), lt(">>"), lt("endobj");
    }, Ae = y.__private__.putTrailer = function() {
        lt("trailer"), lt("<<"), lt("/Size " + (et + 1)), lt("/Root " + et + " 0 R"), lt("/Info " + (et - 1) + " 0 R"), null !== m && lt("/Encrypt " + je.oid + " 0 R"), lt("/ID [ <" + V + "> <" + V + "> ]"), lt(">>");
    }, Se = y.__private__.putHeader = function() {
        lt("%PDF-" + w), lt("%\xba\xdf\xac\xe0");
    }, _e = y.__private__.putXRef = function() {
        var t = "0000000000";
        lt("xref"), lt("0 " + (et + 1)), lt("0000000000 65535 f ");
        for(var e = 1; e <= et; e++)"function" == typeof nt[e] ? lt((t + nt[e]()).slice(-10) + " 00000 n ") : void 0 !== nt[e] ? lt((t + nt[e]).slice(-10) + " 00000 n ") : lt("0000000000 00000 n ");
    }, Pe = y.__private__.buildDocument = function() {
        var t;
        et = 0, it = 0, rt = [], nt = [], at = [], Qt = Kt(), te = Kt(), ct(rt), Dt.publish("buildDocument"), Se(), oe(), function() {
            Dt.publish("putAdditionalObjects");
            for(var t = 0; t < at.length; t++){
                var e = at[t];
                Zt(e.objId, !0), lt(e.content), lt("endobj");
            }
            Dt.publish("postPutAdditionalObjects");
        }(), t = [], function() {
            for(var t in Ft)Ft.hasOwnProperty(t) && (!1 === v || !0 === v && b.hasOwnProperty(t)) && se(Ft[t]);
        }(), function() {
            var t;
            for(t in Bt)Bt.hasOwnProperty(t) && he(Bt[t]);
        }(), function() {
            for(var t in zt)zt.hasOwnProperty(t) && ue(zt[t]);
        }(), function(t) {
            var e;
            for(e in Ct)Ct.hasOwnProperty(e) && (Ct[e] instanceof M ? ce(Ct[e]) : Ct[e] instanceof q && le(Ct[e], t));
        }(t), Dt.publish("putResources"), t.forEach(fe), fe({
            resourcesOid: te,
            objectOid: Number.MAX_SAFE_INTEGER
        }), Dt.publish("postPutResources"), null !== m && (je.oid = Xt(), lt("<<"), lt("/Filter /Standard"), lt("/V " + je.v), lt("/R " + je.r), lt("/U <" + je.toHexString(je.U) + ">"), lt("/O <" + je.toHexString(je.O) + ">"), lt("/P " + je.P), lt(">>"), lt("endobj")), Le(), xe();
        var e = it;
        return _e(), Ae(), lt("startxref"), lt("" + e), lt("%%EOF"), ct(ot[$]), rt.join("\n");
    }, ke = y.__private__.getBlob = function(t) {
        return new Blob([
            ft(t)
        ], {
            type: "application/pdf"
        });
    }, Fe = y.output = y.__private__.output = (Jt = function(t, e) {
        switch("string" == typeof (e = e || {}) ? e = {
            filename: e
        } : e.filename = e.filename || "generated.pdf", t){
            case void 0:
                return Pe();
            case "save":
                y.save(e.filename);
                break;
            case "arraybuffer":
                return ft(Pe());
            case "blob":
                return ke(Pe());
            case "bloburi":
            case "bloburl":
                if (void 0 !== i.URL && "function" == typeof i.URL.createObjectURL) return i.URL && i.URL.createObjectURL(ke(Pe())) || void 0;
                o.warn("bloburl is not supported by your system, because URL.createObjectURL is not supported by your browser.");
                break;
            case "datauristring":
            case "dataurlstring":
                var n = "", r = Pe();
                try {
                    n = d(r);
                } catch (m) {
                    n = d(unescape(encodeURIComponent(r)));
                }
                return "data:application/pdf;filename=" + e.filename + ";base64," + n;
            case "pdfobjectnewwindow":
                if ("[object Window]" === Object.prototype.toString.call(i)) {
                    var a = "https://cdnjs.cloudflare.com/ajax/libs/pdfobject/2.1.1/pdfobject.min.js", s = ' integrity="sha512-4ze/a9/4jqu+tX9dfOqJYSvyYd5M6qum/3HpCLr+/Jqf0whc37VUbkpNGHR7/8pSnCFw47T1fmIpwBV7UySh3g==" crossorigin="anonymous"';
                    e.pdfObjectUrl && (a = e.pdfObjectUrl, s = "");
                    var u = '<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><script src="' + a + '"' + s + '><\/script><script >PDFObject.embed("' + this.output("dataurlstring") + '", ' + JSON.stringify(e) + ");<\/script></body></html>", c = i.open();
                    return null !== c && c.document.write(u), c;
                }
                throw new Error("The option pdfobjectnewwindow just works in a browser-environment.");
            case "pdfjsnewwindow":
                if ("[object Window]" === Object.prototype.toString.call(i)) {
                    var l = '<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><iframe id="pdfViewer" src="' + (e.pdfJsUrl || "examples/PDF.js/web/viewer.html") + "?file=&downloadName=" + e.filename + '" width="500px" height="400px" /></body></html>', h = i.open();
                    if (null !== h) {
                        h.document.write(l);
                        var f = this;
                        h.document.documentElement.querySelector("#pdfViewer").onload = function() {
                            h.document.title = e.filename, h.document.documentElement.querySelector("#pdfViewer").contentWindow.PDFViewerApplication.open(f.output("bloburl"));
                        };
                    }
                    return h;
                }
                throw new Error("The option pdfjsnewwindow just works in a browser-environment.");
            case "dataurlnewwindow":
                if ("[object Window]" !== Object.prototype.toString.call(i)) throw new Error("The option dataurlnewwindow just works in a browser-environment.");
                var p = '<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><iframe src="' + this.output("datauristring", e) + '"></iframe></body></html>', g = i.open();
                if (null !== g && (g.document.write(p), g.document.title = e.filename), g || "undefined" == typeof safari) return g;
                break;
            case "datauri":
            case "dataurl":
                return i.document.location.href = this.output("datauristring", e);
            default:
                return null;
        }
    }, Jt.foo = function() {
        try {
            return Jt.apply(this, arguments);
        } catch (n) {
            var t = n.stack || "";
            ~t.indexOf(" at ") && (t = t.split(" at ")[1]);
            var e = "Error in function " + t.split("\n")[0].split("<")[0] + ": " + n.message;
            if (!i.console) throw new Error(e);
            i.console.error(e, n), i.alert && alert(e);
        }
    }, Jt.foo.bar = Jt, Jt.foo), Ie = function(t) {
        return !0 === Array.isArray(Tt) && Tt.indexOf(t) > -1;
    };
    switch(a){
        case "pt":
            St = 1;
            break;
        case "mm":
            St = 72 / 25.4;
            break;
        case "cm":
            St = 72 / 2.54;
            break;
        case "in":
            St = 72;
            break;
        case "px":
            St = 1 == Ie("px_scaling") ? .75 : 96 / 72;
            break;
        case "pc":
        case "em":
            St = 12;
            break;
        case "ex":
            St = 6;
            break;
        default:
            if ("number" != typeof a) throw new Error("Invalid unit: " + a);
            St = a;
    }
    var je = null;
    K(), Y();
    var Ce = y.__private__.getPageInfo = y.getPageInfo = function(t) {
        if (isNaN(t) || t % 1 != 0) throw new Error("Invalid argument passed to jsPDF.getPageInfo");
        return {
            objId: Rt[t].objId,
            pageNumber: t,
            pageContext: Rt[t]
        };
    }, Oe = y.__private__.getPageInfoByObjId = function(t) {
        if (isNaN(t) || t % 1 != 0) throw new Error("Invalid argument passed to jsPDF.getPageInfoByObjId");
        for(var e in Rt)if (Rt[e].objId === t) break;
        return Ce(e);
    }, Be = y.__private__.getCurrentPageInfo = y.getCurrentPageInfo = function() {
        return {
            objId: Rt[$].objId,
            pageNumber: $,
            pageContext: Rt[$]
        };
    };
    y.addPage = function() {
        return ve.apply(this, arguments), this;
    }, y.setPage = function() {
        return ye.apply(this, arguments), ct.call(this, ot[$]), this;
    }, y.insertPage = function(t) {
        return this.addPage(), this.movePage($, t), this;
    }, y.movePage = function(t, e) {
        var n, r;
        if (t > e) {
            n = ot[t], r = Rt[t];
            for(var i = t; i > e; i--)ot[i] = ot[i - 1], Rt[i] = Rt[i - 1];
            ot[e] = n, Rt[e] = r, this.setPage(e);
        } else if (t < e) {
            n = ot[t], r = Rt[t];
            for(var a = t; a < e; a++)ot[a] = ot[a + 1], Rt[a] = Rt[a + 1];
            ot[e] = n, Rt[e] = r, this.setPage(e);
        }
        return this;
    }, y.deletePage = function() {
        return be.apply(this, arguments), this;
    }, y.__private__.text = y.text = function(e, n, r, i, a) {
        var o, s, u, c, l, h, f, d, p, g = (i = i || {}).scope || this;
        if ("number" == typeof e && "number" == typeof n && ("string" == typeof r || Array.isArray(r))) {
            var m = r;
            r = n, n = e, e = m;
        }
        if (arguments[3] instanceof Wt == 0 ? (u = arguments[4], c = arguments[5], "object" === (0, _typeofDefault.default)(f = arguments[3]) && null !== f || ("string" == typeof u && (c = u, u = null), "string" == typeof f && (c = f, f = null), "number" == typeof f && (u = f, f = null), i = {
            flags: f,
            angle: u,
            align: c
        })) : (R("The transform parameter of text() with a Matrix value"), p = a), isNaN(n) || isNaN(r) || null == e) throw new Error("Invalid arguments passed to jsPDF.text");
        if (0 === e.length) return g;
        var v, y = "", w = "number" == typeof i.lineHeightFactor ? i.lineHeightFactor : Je, N = g.internal.scaleFactor;
        function L(t) {
            return t = t.split("\t").join(Array(i.TabLen || 9).join(" ")), ge(t, f);
        }
        function x(t) {
            for(var e, n = t.concat(), r = [], i = n.length; i--;)"string" == typeof (e = n.shift()) ? r.push(e) : Array.isArray(t) && (1 === e.length || void 0 === e[1] && void 0 === e[2]) ? r.push(e[0]) : r.push([
                e[0],
                e[1],
                e[2]
            ]);
            return r;
        }
        function A(t, e) {
            var n;
            if ("string" == typeof t) n = e(t)[0];
            else if (Array.isArray(t)) {
                for(var r, i, a = t.concat(), o = [], s = a.length; s--;)"string" == typeof (r = a.shift()) ? o.push(e(r)[0]) : Array.isArray(r) && "string" == typeof r[0] && (i = e(r[0], r[1], r[2]), o.push([
                    i[0],
                    i[1],
                    i[2]
                ]));
                n = o;
            }
            return n;
        }
        var P = !1, k = !0;
        if ("string" == typeof e) P = !0;
        else if (Array.isArray(e)) {
            var F = e.concat();
            s = [];
            for(var I, j = F.length; j--;)("string" != typeof (I = F.shift()) || Array.isArray(I) && "string" != typeof I[0]) && (k = !1);
            P = k;
        }
        if (!1 === P) throw new Error('Type of text must be string or Array. "' + e + '" is not recognized.');
        "string" == typeof e && (e = e.match(/[\r?\n]/) ? e.split(/\r\n|\r|\n/g) : [
            e
        ]);
        var C = pt / g.internal.scaleFactor, O = C * (w - 1);
        switch(i.baseline){
            case "bottom":
                r -= O;
                break;
            case "top":
                r += C - O;
                break;
            case "hanging":
                r += C - 2 * O;
                break;
            case "middle":
                r += C / 2 - O;
        }
        if ((h = i.maxWidth || 0) > 0 && ("string" == typeof e ? e = g.splitTextToSize(e, h) : "[object Array]" === Object.prototype.toString.call(e) && (e = e.reduce(function(t, e) {
            return t.concat(g.splitTextToSize(e, h));
        }, []))), o = {
            text: e,
            x: n,
            y: r,
            options: i,
            mutex: {
                pdfEscape: ge,
                activeFontKey: At,
                fonts: Ft,
                activeFontSize: pt
            }
        }, Dt.publish("preProcessText", o), e = o.text, u = (i = o.options).angle, p instanceof Wt == 0 && u && "number" == typeof u) {
            u *= Math.PI / 180, 0 === i.rotationDirection && (u = -u), _ === S && (u = -u);
            var M = Math.cos(u), q = Math.sin(u);
            p = new Wt(M, q, -q, M, 0, 0);
        } else u && u instanceof Wt && (p = u);
        _ !== S || p || (p = Gt), void 0 !== (l = i.charSpace || ln) && (y += B(U(l)) + " Tc\n", this.setCharSpace(this.getCharSpace() || 0)), void 0 !== (d = i.horizontalScale) && (y += B(100 * d) + " Tz\n"), i.lang;
        var E = -1, D = void 0 !== i.renderingMode ? i.renderingMode : i.stroke, T = g.internal.getCurrentPageInfo().pageContext;
        switch(D){
            case 0:
            case !1:
            case "fill":
                E = 0;
                break;
            case 1:
            case !0:
            case "stroke":
                E = 1;
                break;
            case 2:
            case "fillThenStroke":
                E = 2;
                break;
            case 3:
            case "invisible":
                E = 3;
                break;
            case 4:
            case "fillAndAddForClipping":
                E = 4;
                break;
            case 5:
            case "strokeAndAddPathForClipping":
                E = 5;
                break;
            case 6:
            case "fillThenStrokeAndAddToPathForClipping":
                E = 6;
                break;
            case 7:
            case "addToPathForClipping":
                E = 7;
        }
        var z = void 0 !== T.usedRenderingMode ? T.usedRenderingMode : -1;
        -1 !== E ? y += E + " Tr\n" : -1 !== z && (y += "0 Tr\n"), -1 !== E && (T.usedRenderingMode = E), c = i.align || "left";
        var H, W = pt * w, V = g.internal.pageSize.getWidth(), G = Ft[At];
        l = i.charSpace || ln, h = i.maxWidth || 0, f = Object.assign({
            autoencode: !0,
            noBOM: !0
        }, i.flags);
        var Y = [], J = function(t) {
            return g.getStringUnitWidth(t, {
                font: G,
                charSpace: l,
                fontSize: pt,
                doKerning: !1
            }) * pt / N;
        };
        if ("[object Array]" === Object.prototype.toString.call(e)) {
            var X;
            s = x(e), "left" !== c && (H = s.map(J));
            var K, Z = 0;
            if ("right" === c) {
                n -= H[0], e = [], j = s.length;
                for(var $ = 0; $ < j; $++)0 === $ ? (K = en(n), X = nn(r)) : (K = U(Z - H[$]), X = -W), e.push([
                    s[$],
                    K,
                    X
                ]), Z = H[$];
            } else if ("center" === c) {
                n -= H[0] / 2, e = [], j = s.length;
                for(var Q = 0; Q < j; Q++)0 === Q ? (K = en(n), X = nn(r)) : (K = U((Z - H[Q]) / 2), X = -W), e.push([
                    s[Q],
                    K,
                    X
                ]), Z = H[Q];
            } else if ("left" === c) {
                e = [], j = s.length;
                for(var tt = 0; tt < j; tt++)e.push(s[tt]);
            } else if ("justify" === c && "Identity-H" === G.encoding) {
                e = [], j = s.length, h = 0 !== h ? h : V;
                for(var et = 0, nt = 0; nt < j; nt++)if (X = 0 === nt ? nn(r) : -W, K = 0 === nt ? en(n) : et, nt < j - 1) {
                    var rt = U((h - H[nt]) / (s[nt].split(" ").length - 1)), it = s[nt].split(" ");
                    e.push([
                        it[0] + " ",
                        K,
                        X
                    ]), et = 0;
                    for(var at = 1; at < it.length; at++){
                        var ot = (J(it[at - 1] + " " + it[at]) - J(it[at])) * N + rt;
                        at == it.length - 1 ? e.push([
                            it[at],
                            ot,
                            0
                        ]) : e.push([
                            it[at] + " ",
                            ot,
                            0
                        ]), et -= ot;
                    }
                } else e.push([
                    s[nt],
                    K,
                    X
                ]);
                e.push([
                    "",
                    et,
                    0
                ]);
            } else {
                if ("justify" !== c) throw new Error('Unrecognized alignment option, use "left", "center", "right" or "justify".');
                for(e = [], j = s.length, h = 0 !== h ? h : V, nt = 0; nt < j; nt++){
                    X = 0 === nt ? nn(r) : -W, K = 0 === nt ? en(n) : 0;
                    var st = s[nt].split(" ").length - 1, ut = st > 0 ? (h - H[nt]) / st : 0;
                    nt < j - 1 ? Y.push(B(U(ut))) : Y.push(0), e.push([
                        s[nt],
                        K,
                        X
                    ]);
                }
            }
        }
        !0 === ("boolean" == typeof i.R2L ? i.R2L : vt) && (e = A(e, function(t, e, n) {
            return [
                t.split("").reverse().join(""),
                e,
                n
            ];
        })), o = {
            text: e,
            x: n,
            y: r,
            options: i,
            mutex: {
                pdfEscape: ge,
                activeFontKey: At,
                fonts: Ft,
                activeFontSize: pt
            }
        }, Dt.publish("postProcessText", o), e = o.text, v = o.mutex.isHex || !1;
        var ct = Ft[At].encoding;
        "WinAnsiEncoding" !== ct && "StandardEncoding" !== ct || (e = A(e, function(t, e, n) {
            return [
                L(t),
                e,
                n
            ];
        })), s = x(e), e = [];
        for(var ht, ft, dt, gt = Array.isArray(s[0]) ? 1 : 0, mt = "", bt = function(t, e, n) {
            var r = "";
            return n instanceof Wt ? (n = "number" == typeof i.angle ? Vt(n, new Wt(1, 0, 0, 1, t, e)) : Vt(new Wt(1, 0, 0, 1, t, e), n), _ === S && (n = Vt(new Wt(1, 0, 0, -1, 0, 0), n)), r = n.join(" ") + " Tm\n") : r = B(t) + " " + B(e) + " Td\n", r;
        }, yt = 0; yt < s.length; yt++){
            switch(mt = "", gt){
                case 1:
                    dt = (v ? "<" : "(") + s[yt][0] + (v ? ">" : ")"), ht = parseFloat(s[yt][1]), ft = parseFloat(s[yt][2]);
                    break;
                case 0:
                    dt = (v ? "<" : "(") + s[yt] + (v ? ">" : ")"), ht = en(n), ft = nn(r);
            }
            void 0 !== Y && void 0 !== Y[yt] && (mt = Y[yt] + " Tw\n"), 0 === yt ? e.push(mt + bt(ht, ft, p) + dt) : 0 === gt ? e.push(mt + dt) : 1 === gt && e.push(mt + bt(ht, ft, p) + dt);
        }
        e = 0 === gt ? e.join(" Tj\nT* ") : e.join(" Tj\n"), e += " Tj\n";
        var wt = "BT\n/";
        return wt += At + " " + pt + " Tf\n", wt += B(pt * w) + " TL\n", wt += un + "\n", wt += y, wt += e, lt(wt += "ET"), b[At] = !0, g;
    };
    var Me = y.__private__.clip = y.clip = function(t) {
        return lt("evenodd" === t ? "W*" : "W"), this;
    };
    y.clipEvenOdd = function() {
        return Me("evenodd");
    }, y.__private__.discardPath = y.discardPath = function() {
        return lt("n"), this;
    };
    var qe = y.__private__.isValidStyle = function(t) {
        var e = !1;
        return -1 !== [
            void 0,
            null,
            "S",
            "D",
            "F",
            "DF",
            "FD",
            "f",
            "f*",
            "B",
            "B*",
            "n"
        ].indexOf(t) && (e = !0), e;
    };
    y.__private__.setDefaultPathOperation = y.setDefaultPathOperation = function(t) {
        return qe(t) && (g = t), this;
    };
    var Ee = y.__private__.getStyle = y.getStyle = function(t) {
        var e = g;
        switch(t){
            case "D":
            case "S":
                e = "S";
                break;
            case "F":
                e = "f";
                break;
            case "FD":
            case "DF":
                e = "B";
                break;
            case "f":
            case "f*":
            case "B":
            case "B*":
                e = t;
        }
        return e;
    }, Re = y.close = function() {
        return lt("h"), this;
    };
    y.stroke = function() {
        return lt("S"), this;
    }, y.fill = function(t) {
        return De("f", t), this;
    }, y.fillEvenOdd = function(t) {
        return De("f*", t), this;
    }, y.fillStroke = function(t) {
        return De("B", t), this;
    }, y.fillStrokeEvenOdd = function(t) {
        return De("B*", t), this;
    };
    var De = function(e, n) {
        "object" === (0, _typeofDefault.default)(n) ? Ue(n, e) : lt(e);
    }, Te = function(t) {
        null === t || _ === S && void 0 === t || (t = Ee(t), lt(t));
    };
    function ze(t, e, n, r, i) {
        var a = new q(e || this.boundingBox, n || this.xStep, r || this.yStep, this.gState, i || this.matrix);
        a.stream = this.stream;
        var o = t + "$$" + this.cloneIndex++ + "$$";
        return Yt(o, a), a;
    }
    var Ue = function(t, e) {
        var n = Ot[t.key], r = Ct[n];
        if (r instanceof M) lt("q"), lt(He(e)), r.gState && y.setGState(r.gState), lt(t.matrix.toString() + " cm"), lt("/" + n + " sh"), lt("Q");
        else if (r instanceof q) {
            var i = new Wt(1, 0, 0, -1, 0, _n());
            t.matrix && (i = i.multiply(t.matrix || Gt), n = ze.call(r, t.key, t.boundingBox, t.xStep, t.yStep, i).id), lt("q"), lt("/Pattern cs"), lt("/" + n + " scn"), r.gState && y.setGState(r.gState), lt(e), lt("Q");
        }
    }, He = function(t) {
        switch(t){
            case "f":
            case "F":
            case "n":
                return "W n";
            case "f*":
                return "W* n";
            case "B":
            case "S":
                return "W S";
            case "B*":
                return "W* S";
        }
    }, We = y.moveTo = function(t, e) {
        return lt(B(U(t)) + " " + B(H(e)) + " m"), this;
    }, Ve = y.lineTo = function(t, e) {
        return lt(B(U(t)) + " " + B(H(e)) + " l"), this;
    }, Ge = y.curveTo = function(t, e, n, r, i, a) {
        return lt([
            B(U(t)),
            B(H(e)),
            B(U(n)),
            B(H(r)),
            B(U(i)),
            B(H(a)),
            "c"
        ].join(" ")), this;
    };
    y.__private__.line = y.line = function(t, e, n, r, i) {
        if (isNaN(t) || isNaN(e) || isNaN(n) || isNaN(r) || !qe(i)) throw new Error("Invalid arguments passed to jsPDF.line");
        return _ === A ? this.lines([
            [
                n - t,
                r - e
            ]
        ], t, e, [
            1,
            1
        ], i || "S") : this.lines([
            [
                n - t,
                r - e
            ]
        ], t, e, [
            1,
            1
        ]).stroke();
    }, y.__private__.lines = y.lines = function(t, e, n, r, i, a) {
        var o, s, u, c, l, h, f, d, p, g, m, v;
        if ("number" == typeof t && (v = n, n = e, e = t, t = v), r = r || [
            1,
            1
        ], a = a || !1, isNaN(e) || isNaN(n) || !Array.isArray(t) || !Array.isArray(r) || !qe(i) || "boolean" != typeof a) throw new Error("Invalid arguments passed to jsPDF.lines");
        for(We(e, n), o = r[0], s = r[1], c = t.length, g = e, m = n, u = 0; u < c; u++)2 === (l = t[u]).length ? (g = l[0] * o + g, m = l[1] * s + m, Ve(g, m)) : (h = l[0] * o + g, f = l[1] * s + m, d = l[2] * o + g, p = l[3] * s + m, g = l[4] * o + g, m = l[5] * s + m, Ge(h, f, d, p, g, m));
        return a && Re(), Te(i), this;
    }, y.path = function(t) {
        for(var e = 0; e < t.length; e++){
            var n = t[e], r = n.c;
            switch(n.op){
                case "m":
                    We(r[0], r[1]);
                    break;
                case "l":
                    Ve(r[0], r[1]);
                    break;
                case "c":
                    Ge.apply(this, r);
                    break;
                case "h":
                    Re();
            }
        }
        return this;
    }, y.__private__.rect = y.rect = function(t, e, n, r, i) {
        if (isNaN(t) || isNaN(e) || isNaN(n) || isNaN(r) || !qe(i)) throw new Error("Invalid arguments passed to jsPDF.rect");
        return _ === A && (r = -r), lt([
            B(U(t)),
            B(H(e)),
            B(U(n)),
            B(U(r)),
            "re"
        ].join(" ")), Te(i), this;
    }, y.__private__.triangle = y.triangle = function(t, e, n, r, i, a, o) {
        if (isNaN(t) || isNaN(e) || isNaN(n) || isNaN(r) || isNaN(i) || isNaN(a) || !qe(o)) throw new Error("Invalid arguments passed to jsPDF.triangle");
        return this.lines([
            [
                n - t,
                r - e
            ],
            [
                i - n,
                a - r
            ],
            [
                t - i,
                e - a
            ]
        ], t, e, [
            1,
            1
        ], o, !0), this;
    }, y.__private__.roundedRect = y.roundedRect = function(t, e, n, r, i, a, o) {
        if (isNaN(t) || isNaN(e) || isNaN(n) || isNaN(r) || isNaN(i) || isNaN(a) || !qe(o)) throw new Error("Invalid arguments passed to jsPDF.roundedRect");
        var s = 4 / 3 * (Math.SQRT2 - 1);
        return i = Math.min(i, .5 * n), a = Math.min(a, .5 * r), this.lines([
            [
                n - 2 * i,
                0
            ],
            [
                i * s,
                0,
                i,
                a - a * s,
                i,
                a
            ],
            [
                0,
                r - 2 * a
            ],
            [
                0,
                a * s,
                -i * s,
                a,
                -i,
                a
            ],
            [
                2 * i - n,
                0
            ],
            [
                -i * s,
                0,
                -i,
                -a * s,
                -i,
                -a
            ],
            [
                0,
                2 * a - r
            ],
            [
                0,
                -a * s,
                i * s,
                -a,
                i,
                -a
            ]
        ], t + i, e, [
            1,
            1
        ], o, !0), this;
    }, y.__private__.ellipse = y.ellipse = function(t, e, n, r, i) {
        if (isNaN(t) || isNaN(e) || isNaN(n) || isNaN(r) || !qe(i)) throw new Error("Invalid arguments passed to jsPDF.ellipse");
        var a = 4 / 3 * (Math.SQRT2 - 1) * n, o = 4 / 3 * (Math.SQRT2 - 1) * r;
        return We(t + n, e), Ge(t + n, e - o, t + a, e - r, t, e - r), Ge(t - a, e - r, t - n, e - o, t - n, e), Ge(t - n, e + o, t - a, e + r, t, e + r), Ge(t + a, e + r, t + n, e + o, t + n, e), Te(i), this;
    }, y.__private__.circle = y.circle = function(t, e, n, r) {
        if (isNaN(t) || isNaN(e) || isNaN(n) || !qe(r)) throw new Error("Invalid arguments passed to jsPDF.circle");
        return this.ellipse(t, e, n, n, r);
    }, y.setFont = function(t, e, n) {
        return n && (e = F(e, n)), At = Ne(t, e, {
            disableWarning: !1
        }), this;
    };
    var Ye = y.__private__.getFont = y.getFont = function() {
        return Ft[Ne.apply(y, arguments)];
    };
    y.__private__.getFontList = y.getFontList = function() {
        var t, e, n = {};
        for(t in It)if (It.hasOwnProperty(t)) for(e in n[t] = [], It[t])It[t].hasOwnProperty(e) && n[t].push(e);
        return n;
    }, y.addFont = function(t, e, n, r, i) {
        var a = [
            "StandardEncoding",
            "MacRomanEncoding",
            "Identity-H",
            "WinAnsiEncoding"
        ];
        return arguments[3] && -1 !== a.indexOf(arguments[3]) ? i = arguments[3] : arguments[3] && -1 == a.indexOf(arguments[3]) && (n = F(n, r)), pe.call(this, t, e, n, i = i || "Identity-H");
    };
    var Je, Xe = e.lineWidth || .200025, Ke = y.__private__.getLineWidth = y.getLineWidth = function() {
        return Xe;
    }, Ze = y.__private__.setLineWidth = y.setLineWidth = function(t) {
        return Xe = t, lt(B(U(t)) + " w"), this;
    };
    y.__private__.setLineDash = E.API.setLineDash = E.API.setLineDashPattern = function(t, e) {
        if (t = t || [], e = e || 0, isNaN(e) || !Array.isArray(t)) throw new Error("Invalid arguments passed to jsPDF.setLineDash");
        return t = t.map(function(t) {
            return B(U(t));
        }).join(" "), e = B(U(e)), lt("[" + t + "] " + e + " d"), this;
    };
    var $e = y.__private__.getLineHeight = y.getLineHeight = function() {
        return pt * Je;
    };
    y.__private__.getLineHeight = y.getLineHeight = function() {
        return pt * Je;
    };
    var Qe = y.__private__.setLineHeightFactor = y.setLineHeightFactor = function(t) {
        return "number" == typeof (t = t || 1.15) && (Je = t), this;
    }, tn = y.__private__.getLineHeightFactor = y.getLineHeightFactor = function() {
        return Je;
    };
    Qe(e.lineHeight);
    var en = y.__private__.getHorizontalCoordinate = function(t) {
        return U(t);
    }, nn = y.__private__.getVerticalCoordinate = function(t) {
        return _ === S ? t : Rt[$].mediaBox.topRightY - Rt[$].mediaBox.bottomLeftY - U(t);
    }, rn = y.__private__.getHorizontalCoordinateString = y.getHorizontalCoordinateString = function(t) {
        return B(en(t));
    }, an = y.__private__.getVerticalCoordinateString = y.getVerticalCoordinateString = function(t) {
        return B(nn(t));
    }, on = e.strokeColor || "0 G";
    y.__private__.getStrokeColor = y.getDrawColor = function() {
        return ee(on);
    }, y.__private__.setStrokeColor = y.setDrawColor = function(t, e, n, r) {
        return on = ne({
            ch1: t,
            ch2: e,
            ch3: n,
            ch4: r,
            pdfColorType: "draw",
            precision: 2
        }), lt(on), this;
    };
    var sn = e.fillColor || "0 g";
    y.__private__.getFillColor = y.getFillColor = function() {
        return ee(sn);
    }, y.__private__.setFillColor = y.setFillColor = function(t, e, n, r) {
        return sn = ne({
            ch1: t,
            ch2: e,
            ch3: n,
            ch4: r,
            pdfColorType: "fill",
            precision: 2
        }), lt(sn), this;
    };
    var un = e.textColor || "0 g", cn = y.__private__.getTextColor = y.getTextColor = function() {
        return ee(un);
    };
    y.__private__.setTextColor = y.setTextColor = function(t, e, n, r) {
        return un = ne({
            ch1: t,
            ch2: e,
            ch3: n,
            ch4: r,
            pdfColorType: "text",
            precision: 3
        }), this;
    };
    var ln = e.charSpace, hn = y.__private__.getCharSpace = y.getCharSpace = function() {
        return parseFloat(ln || 0);
    };
    y.__private__.setCharSpace = y.setCharSpace = function(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.setCharSpace");
        return ln = t, this;
    };
    var fn = 0;
    y.CapJoinStyles = {
        0: 0,
        butt: 0,
        but: 0,
        miter: 0,
        1: 1,
        round: 1,
        rounded: 1,
        circle: 1,
        2: 2,
        projecting: 2,
        project: 2,
        square: 2,
        bevel: 2
    }, y.__private__.setLineCap = y.setLineCap = function(t) {
        var e = y.CapJoinStyles[t];
        if (void 0 === e) throw new Error("Line cap style of '" + t + "' is not recognized. See or extend .CapJoinStyles property for valid styles");
        return fn = e, lt(e + " J"), this;
    };
    var dn = 0;
    y.__private__.setLineJoin = y.setLineJoin = function(t) {
        var e = y.CapJoinStyles[t];
        if (void 0 === e) throw new Error("Line join style of '" + t + "' is not recognized. See or extend .CapJoinStyles property for valid styles");
        return dn = e, lt(e + " j"), this;
    }, y.__private__.setLineMiterLimit = y.__private__.setMiterLimit = y.setLineMiterLimit = y.setMiterLimit = function(t) {
        if (t = t || 0, isNaN(t)) throw new Error("Invalid argument passed to jsPDF.setLineMiterLimit");
        return lt(B(U(t)) + " M"), this;
    }, y.GState = O, y.setGState = function(t) {
        (t = "string" == typeof t ? Bt[Mt[t]] : pn(null, t)).equals(qt) || (lt("/" + t.id + " gs"), qt = t);
    };
    var pn = function(t, e) {
        if (!t || !Mt[t]) {
            var n = !1;
            for(var r in Bt)if (Bt.hasOwnProperty(r) && Bt[r].equals(e)) {
                n = !0;
                break;
            }
            if (n) e = Bt[r];
            else {
                var i = "GS" + (Object.keys(Bt).length + 1).toString(10);
                Bt[i] = e, e.id = i;
            }
            return t && (Mt[t] = e.id), Dt.publish("addGState", e), e;
        }
    };
    y.addGState = function(t, e) {
        return pn(t, e), this;
    }, y.saveGraphicsState = function() {
        return lt("q"), jt.push({
            key: At,
            size: pt,
            color: un
        }), this;
    }, y.restoreGraphicsState = function() {
        lt("Q");
        var t = jt.pop();
        return At = t.key, pt = t.size, un = t.color, qt = null, this;
    }, y.setCurrentTransformationMatrix = function(t) {
        return lt(t.toString() + " cm"), this;
    }, y.comment = function(t) {
        return lt("#" + t), this;
    };
    var gn = function(t, e) {
        var n = t || 0;
        Object.defineProperty(this, "x", {
            enumerable: !0,
            get: function() {
                return n;
            },
            set: function(t) {
                isNaN(t) || (n = parseFloat(t));
            }
        });
        var r = e || 0;
        Object.defineProperty(this, "y", {
            enumerable: !0,
            get: function() {
                return r;
            },
            set: function(t) {
                isNaN(t) || (r = parseFloat(t));
            }
        });
        var i = "pt";
        return Object.defineProperty(this, "type", {
            enumerable: !0,
            get: function() {
                return i;
            },
            set: function(t) {
                i = t.toString();
            }
        }), this;
    }, mn = function(t, e, n, r) {
        gn.call(this, t, e), this.type = "rect";
        var i = n || 0;
        Object.defineProperty(this, "w", {
            enumerable: !0,
            get: function() {
                return i;
            },
            set: function(t) {
                isNaN(t) || (i = parseFloat(t));
            }
        });
        var a = r || 0;
        return Object.defineProperty(this, "h", {
            enumerable: !0,
            get: function() {
                return a;
            },
            set: function(t) {
                isNaN(t) || (a = parseFloat(t));
            }
        }), this;
    }, vn = function() {
        this.page = Et, this.currentPage = $, this.pages = ot.slice(0), this.pagesContext = Rt.slice(0), this.x = _t, this.y = Pt, this.matrix = kt, this.width = wn($), this.height = Ln($), this.outputDestination = ut, this.id = "", this.objectNumber = -1;
    };
    vn.prototype.restore = function() {
        Et = this.page, $ = this.currentPage, Rt = this.pagesContext, ot = this.pages, _t = this.x, Pt = this.y, kt = this.matrix, Nn($, this.width), xn($, this.height), ut = this.outputDestination;
    };
    var bn = function(t, e, n, r, i) {
        Ht.push(new vn), Et = $ = 0, ot = [], _t = t, Pt = e, kt = i, me([
            n,
            r
        ]);
    };
    for(var yn in y.beginFormObject = function(t, e, n, r, i) {
        return bn(t, e, n, r, i), this;
    }, y.endFormObject = function(t) {
        return function(t) {
            if (Ut[t]) Ht.pop().restore();
            else {
                var e = new vn, n = "Xo" + (Object.keys(zt).length + 1).toString(10);
                e.id = n, Ut[t] = n, zt[n] = e, Dt.publish("addFormObject", e), Ht.pop().restore();
            }
        }(t), this;
    }, y.doFormObject = function(t, e) {
        var n = zt[Ut[t]];
        return lt("q"), lt(e.toString() + " cm"), lt("/" + n.id + " Do"), lt("Q"), this;
    }, y.getFormObject = function(t) {
        var e = zt[Ut[t]];
        return {
            x: e.x,
            y: e.y,
            width: e.width,
            height: e.height,
            matrix: e.matrix
        };
    }, y.save = function(t, e) {
        return t = t || "generated.pdf", (e = e || {}).returnPromise = e.returnPromise || !1, !1 === e.returnPromise ? (l(ke(Pe()), t), "function" == typeof l.unload && i.setTimeout && setTimeout(l.unload, 911), this) : new Promise(function(e, n) {
            try {
                var r = l(ke(Pe()), t);
                "function" == typeof l.unload && i.setTimeout && setTimeout(l.unload, 911), e(r);
            } catch (a) {
                n(a.message);
            }
        });
    }, E.API)E.API.hasOwnProperty(yn) && ("events" === yn && E.API.events.length ? function(t, e) {
        var n, r, i;
        for(i = e.length - 1; -1 !== i; i--)n = e[i][0], r = e[i][1], t.subscribe.apply(t, [
            n
        ].concat("function" == typeof r ? [
            r
        ] : r));
    }(Dt, E.API.events) : y[yn] = E.API[yn]);
    function wn(t) {
        return Rt[t].mediaBox.topRightX - Rt[t].mediaBox.bottomLeftX;
    }
    function Nn(t, e) {
        Rt[t].mediaBox.topRightX = e + Rt[t].mediaBox.bottomLeftX;
    }
    function Ln(t) {
        return Rt[t].mediaBox.topRightY - Rt[t].mediaBox.bottomLeftY;
    }
    function xn(t, e) {
        Rt[t].mediaBox.topRightY = e + Rt[t].mediaBox.bottomLeftY;
    }
    var An = y.getPageWidth = function(t) {
        return wn(t = t || $) / St;
    }, Sn = y.setPageWidth = function(t, e) {
        Nn(t, e * St);
    }, _n = y.getPageHeight = function(t) {
        return Ln(t = t || $) / St;
    }, Pn = y.setPageHeight = function(t, e) {
        xn(t, e * St);
    };
    return y.internal = {
        pdfEscape: ge,
        getStyle: Ee,
        getFont: Ye,
        getFontSize: mt,
        getCharSpace: hn,
        getTextColor: cn,
        getLineHeight: $e,
        getLineHeightFactor: tn,
        getLineWidth: Ke,
        write: ht,
        getHorizontalCoordinate: en,
        getVerticalCoordinate: nn,
        getCoordinateString: rn,
        getVerticalCoordinateString: an,
        collections: {},
        newObject: Xt,
        newAdditionalObject: $t,
        newObjectDeferred: Kt,
        newObjectDeferredBegin: Zt,
        getFilters: re,
        putStream: ie,
        events: Dt,
        scaleFactor: St,
        pageSize: {
            getWidth: function() {
                return An($);
            },
            setWidth: function(t) {
                Sn($, t);
            },
            getHeight: function() {
                return _n($);
            },
            setHeight: function(t) {
                Pn($, t);
            }
        },
        encryptionOptions: m,
        encryption: je,
        getEncryptor: function(t) {
            return null !== m ? je.encryptor(t, 0) : function(t) {
                return t;
            };
        },
        output: Fe,
        getNumberOfPages: we,
        pages: ot,
        out: lt,
        f2: T,
        f3: z,
        getPageInfo: Ce,
        getPageInfoByObjId: Oe,
        getCurrentPageInfo: Be,
        getPDFVersion: N,
        Point: gn,
        Rectangle: mn,
        Matrix: Wt,
        hasHotfix: Ie
    }, Object.defineProperty(y.internal.pageSize, "width", {
        get: function() {
            return An($);
        },
        set: function(t) {
            Sn($, t);
        },
        enumerable: !0,
        configurable: !0
    }), Object.defineProperty(y.internal.pageSize, "height", {
        get: function() {
            return _n($);
        },
        set: function(t) {
            Pn($, t);
        },
        enumerable: !0,
        configurable: !0
    }), (function(t) {
        for(var e = 0, n = dt.length; e < n; e++){
            var r = pe.call(this, t[e][0], t[e][1], t[e][2], dt[e][3], !0);
            !1 === v && (b[r] = !0);
            var i = t[e][0].split("-");
            de({
                id: r,
                fontName: i[0],
                fontStyle: i[1] || ""
            });
        }
        Dt.publish("addFonts", {
            fonts: Ft,
            dictionary: It
        });
    }).call(y, dt), At = "F1", ve(s, r), Dt.publish("initialized"), y;
}
I.prototype.lsbFirstWord = function(t) {
    return String.fromCharCode(255 & t, t >> 8 & 255, t >> 16 & 255, t >> 24 & 255);
}, I.prototype.toHexString = function(t) {
    return t.split("").map(function(t) {
        return ("0" + (255 & t.charCodeAt(0)).toString(16)).slice(-2);
    }).join("");
}, I.prototype.hexToBytes = function(t) {
    for(var e = [], n = 0; n < t.length; n += 2)e.push(String.fromCharCode(parseInt(t.substr(n, 2), 16)));
    return e.join("");
}, I.prototype.processOwnerPassword = function(t, e) {
    return k(S(e).substr(0, 5), t);
}, I.prototype.encryptor = function(t, e) {
    var n = S(this.encryptionKey + String.fromCharCode(255 & t, t >> 8 & 255, t >> 16 & 255, 255 & e, e >> 8 & 255)).substr(0, 10);
    return function(t) {
        return k(n, t);
    };
}, O.prototype.equals = function(e) {
    var n, r = "id,objectNumber,equals";
    if (!e || (0, _typeofDefault.default)(e) !== (0, _typeofDefault.default)(this)) return !1;
    var i = 0;
    for(n in this)if (!(r.indexOf(n) >= 0)) {
        if (this.hasOwnProperty(n) && !e.hasOwnProperty(n)) return !1;
        if (this[n] !== e[n]) return !1;
        i++;
    }
    for(n in e)e.hasOwnProperty(n) && r.indexOf(n) < 0 && i--;
    return 0 === i;
}, E.API = {
    events: []
}, E.version = "3.0.3";
var R = E.API, D = 1, T = function(t) {
    return t.replace(/\\/g, "\\\\").replace(/\(/g, "\\(").replace(/\)/g, "\\)");
}, z = function(t) {
    return t.replace(/\\\\/g, "\\").replace(/\\\(/g, "(").replace(/\\\)/g, ")");
}, U = function(t) {
    return t.toFixed(2);
}, H = function(t) {
    return t.toFixed(5);
};
R.__acroform__ = {};
var W = function(t, e) {
    t.prototype = Object.create(e.prototype), t.prototype.constructor = t;
}, V = function(t) {
    return t * D;
}, G = function(t) {
    var e = new ct, n = xt.internal.getHeight(t) || 0, r = xt.internal.getWidth(t) || 0;
    return e.BBox = [
        0,
        0,
        Number(U(r)),
        Number(U(n))
    ], e;
}, Y = R.__acroform__.setBit = function(t, e) {
    if (t = t || 0, e = e || 0, isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBit");
    return t | 1 << e;
}, J = R.__acroform__.clearBit = function(t, e) {
    if (t = t || 0, e = e || 0, isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBit");
    return t & ~(1 << e);
}, X = R.__acroform__.getBit = function(t, e) {
    if (isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBit");
    return t & 1 << e ? 1 : 0;
}, K = R.__acroform__.getBitForPdf = function(t, e) {
    if (isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBitForPdf");
    return X(t, e - 1);
}, Z = R.__acroform__.setBitForPdf = function(t, e) {
    if (isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBitForPdf");
    return Y(t, e - 1);
}, $ = R.__acroform__.clearBitForPdf = function(t, e) {
    if (isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBitForPdf");
    return J(t, e - 1);
}, Q = R.__acroform__.calculateCoordinates = function(t, e) {
    var n = e.internal.getHorizontalCoordinate, r = e.internal.getVerticalCoordinate, i = t[0], a = t[1], o = t[2], s = t[3], u = {};
    return u.lowerLeft_X = n(i) || 0, u.lowerLeft_Y = r(a + s) || 0, u.upperRight_X = n(i + o) || 0, u.upperRight_Y = r(a) || 0, [
        Number(U(u.lowerLeft_X)),
        Number(U(u.lowerLeft_Y)),
        Number(U(u.upperRight_X)),
        Number(U(u.upperRight_Y))
    ];
}, tt = function(t) {
    if (t.appearanceStreamContent) return t.appearanceStreamContent;
    if (t.V || t.DV) {
        var e = [], n = t._V || t.DV, r = et(t, n), i = t.scope.internal.getFont(t.fontName, t.fontStyle).id;
        e.push("/Tx BMC"), e.push("q"), e.push("BT"), e.push(t.scope.__private__.encodeColorString(t.color)), e.push("/" + i + " " + U(r.fontSize) + " Tf"), e.push("1 0 0 1 0 0 Tm"), e.push(r.text), e.push("ET"), e.push("Q"), e.push("EMC");
        var a = G(t);
        return a.scope = t.scope, a.stream = e.join("\n"), a;
    }
}, et = function(t, e) {
    var n = 0 === t.fontSize ? t.maxFontSize : t.fontSize, r = {
        text: "",
        fontSize: ""
    }, i = (e = ")" == (e = "(" == e.substr(0, 1) ? e.substr(1) : e).substr(e.length - 1) ? e.substr(0, e.length - 1) : e).split(" ");
    i = t.multiline ? i.map(function(t) {
        return t.split("\n");
    }) : i.map(function(t) {
        return [
            t
        ];
    });
    var a = n, o = xt.internal.getHeight(t) || 0;
    o = o < 0 ? -o : o;
    var s = xt.internal.getWidth(t) || 0;
    s = s < 0 ? -s : s;
    var u = function(e, n, r) {
        if (e + 1 < i.length) {
            var a = n + " " + i[e + 1][0];
            return nt(a, t, r).width <= s - 4;
        }
        return !1;
    };
    a++;
    t: for(; a > 0;){
        e = "", a--;
        var c, l, h = nt("3", t, a).height, f = t.multiline ? o - a : (o - h) / 2, d = f += 2, p = 0, g = 0, m = 0;
        if (a <= 0) {
            e = "(...) Tj\n", e += "% Width of Text: " + nt(e, t, a = 12).width + ", FieldWidth:" + s + "\n";
            break;
        }
        for(var v = "", b = 0, y = 0; y < i.length; y++)if (i.hasOwnProperty(y)) {
            var w = !1;
            if (1 !== i[y].length && m !== i[y].length - 1) {
                if ((h + 2) * (b + 2) + 2 > o) continue t;
                v += i[y][m], w = !0, g = y, y--;
            } else {
                v = " " == (v += i[y][m] + " ").substr(v.length - 1) ? v.substr(0, v.length - 1) : v;
                var N = parseInt(y), L = u(N, v, a), x = y >= i.length - 1;
                if (L && !x) {
                    v += " ", m = 0;
                    continue;
                }
                if (L || x) {
                    if (x) g = N;
                    else if (t.multiline && (h + 2) * (b + 2) + 2 > o) continue t;
                } else {
                    if (!t.multiline) continue t;
                    if ((h + 2) * (b + 2) + 2 > o) continue t;
                    g = N;
                }
            }
            for(var A = "", S = p; S <= g; S++){
                var _ = i[S];
                if (t.multiline) {
                    if (S === g) {
                        A += _[m] + " ", m = (m + 1) % _.length;
                        continue;
                    }
                    if (S === p) {
                        A += _[_.length - 1] + " ";
                        continue;
                    }
                }
                A += _[0] + " ";
            }
            switch(A = " " == A.substr(A.length - 1) ? A.substr(0, A.length - 1) : A, l = nt(A, t, a).width, t.textAlign){
                case "right":
                    c = s - l - 2;
                    break;
                case "center":
                    c = (s - l) / 2;
                    break;
                default:
                    c = 2;
            }
            e += U(c) + " " + U(d) + " Td\n", e += "(" + T(A) + ") Tj\n", e += -U(c) + " 0 Td\n", d = -(a + 2), l = 0, p = w ? g : g + 1, b++, v = "";
        }
        break;
    }
    return r.text = e, r.fontSize = a, r;
}, nt = function(t, e, n) {
    var r = e.scope.internal.getFont(e.fontName, e.fontStyle), i = e.scope.getStringUnitWidth(t, {
        font: r,
        fontSize: parseFloat(n),
        charSpace: 0
    }) * parseFloat(n);
    return {
        height: e.scope.getStringUnitWidth("3", {
            font: r,
            fontSize: parseFloat(n),
            charSpace: 0
        }) * parseFloat(n) * 1.5,
        width: i
    };
}, rt = {
    fields: [],
    xForms: [],
    acroFormDictionaryRoot: null,
    printedOut: !1,
    internal: null,
    isInitialized: !1
}, it = function(t, e) {
    var n = {
        type: "reference",
        object: t
    };
    void 0 === e.internal.getPageInfo(t.page).pageContext.annotations.find(function(t) {
        return t.type === n.type && t.object === n.object;
    }) && e.internal.getPageInfo(t.page).pageContext.annotations.push(n);
}, at = function(e, n) {
    if (n.scope = e, void 0 !== e.internal && (void 0 === e.internal.acroformPlugin || !1 === e.internal.acroformPlugin.isInitialized)) {
        if (ht.FieldNum = 0, e.internal.acroformPlugin = JSON.parse(JSON.stringify(rt)), e.internal.acroformPlugin.acroFormDictionaryRoot) throw new Error("Exception while creating AcroformDictionary");
        D = e.internal.scaleFactor, e.internal.acroformPlugin.acroFormDictionaryRoot = new lt, e.internal.acroformPlugin.acroFormDictionaryRoot.scope = e, e.internal.acroformPlugin.acroFormDictionaryRoot._eventID = e.internal.events.subscribe("postPutResources", function() {
            !function(t) {
                t.internal.events.unsubscribe(t.internal.acroformPlugin.acroFormDictionaryRoot._eventID), delete t.internal.acroformPlugin.acroFormDictionaryRoot._eventID, t.internal.acroformPlugin.printedOut = !0;
            }(e);
        }), e.internal.events.subscribe("buildDocument", function() {
            !function(t) {
                t.internal.acroformPlugin.acroFormDictionaryRoot.objId = void 0;
                var e = t.internal.acroformPlugin.acroFormDictionaryRoot.Fields;
                for(var n in e)if (e.hasOwnProperty(n)) {
                    var r = e[n];
                    r.objId = void 0, r.hasAnnotation && it(r, t);
                }
            }(e);
        }), e.internal.events.subscribe("putCatalog", function() {
            !function(t) {
                if (void 0 === t.internal.acroformPlugin.acroFormDictionaryRoot) throw new Error("putCatalogCallback: Root missing.");
                t.internal.write("/AcroForm " + t.internal.acroformPlugin.acroFormDictionaryRoot.objId + " 0 R");
            }(e);
        }), e.internal.events.subscribe("postPutPages", function(n) {
            !function(e, n) {
                var r = !e;
                for(var i in e || (n.internal.newObjectDeferredBegin(n.internal.acroformPlugin.acroFormDictionaryRoot.objId, !0), n.internal.acroformPlugin.acroFormDictionaryRoot.putStream()), e = e || n.internal.acroformPlugin.acroFormDictionaryRoot.Kids)if (e.hasOwnProperty(i)) {
                    var a = e[i], o = [], s = a.Rect;
                    if (a.Rect && (a.Rect = Q(a.Rect, n)), n.internal.newObjectDeferredBegin(a.objId, !0), a.DA = xt.createDefaultAppearanceStream(a), "object" === (0, _typeofDefault.default)(a) && "function" == typeof a.getKeyValueListForStream && (o = a.getKeyValueListForStream()), a.Rect = s, a.hasAppearanceStream && !a.appearanceStreamContent) {
                        var u = tt(a);
                        o.push({
                            key: "AP",
                            value: "<</N " + u + ">>"
                        }), n.internal.acroformPlugin.xForms.push(u);
                    }
                    if (a.appearanceStreamContent) {
                        var c = "";
                        for(var l in a.appearanceStreamContent)if (a.appearanceStreamContent.hasOwnProperty(l)) {
                            var h = a.appearanceStreamContent[l];
                            if (c += "/" + l + " ", c += "<<", Object.keys(h).length >= 1 || Array.isArray(h)) {
                                for(var i in h)if (h.hasOwnProperty(i)) {
                                    var f = h[i];
                                    "function" == typeof f && (f = f.call(n, a)), c += "/" + i + " " + f + " ", n.internal.acroformPlugin.xForms.indexOf(f) >= 0 || n.internal.acroformPlugin.xForms.push(f);
                                }
                            } else "function" == typeof (f = h) && (f = f.call(n, a)), c += "/" + i + " " + f, n.internal.acroformPlugin.xForms.indexOf(f) >= 0 || n.internal.acroformPlugin.xForms.push(f);
                            c += ">>";
                        }
                        o.push({
                            key: "AP",
                            value: "<<\n" + c + ">>"
                        });
                    }
                    n.internal.putStream({
                        additionalKeyValues: o,
                        objectId: a.objId
                    }), n.internal.out("endobj");
                }
                r && function(e, n) {
                    for(var r in e)if (e.hasOwnProperty(r)) {
                        var i = r, a = e[r];
                        n.internal.newObjectDeferredBegin(a.objId, !0), "object" === (0, _typeofDefault.default)(a) && "function" == typeof a.putStream && a.putStream(), delete e[i];
                    }
                }(n.internal.acroformPlugin.xForms, n);
            }(n, e);
        }), e.internal.acroformPlugin.isInitialized = !0;
    }
}, ot = R.__acroform__.arrayToPdfArray = function(e, n, r) {
    var i = function(t) {
        return t;
    };
    if (Array.isArray(e)) {
        for(var a = "[", o = 0; o < e.length; o++)switch(0 !== o && (a += " "), (0, _typeofDefault.default)(e[o])){
            case "boolean":
            case "number":
            case "object":
                a += e[o].toString();
                break;
            case "string":
                "/" !== e[o].substr(0, 1) ? (void 0 !== n && r && (i = r.internal.getEncryptor(n)), a += "(" + T(i(e[o].toString())) + ")") : a += e[o].toString();
        }
        return a + "]";
    }
    throw new Error("Invalid argument passed to jsPDF.__acroform__.arrayToPdfArray");
}, st = function(t, e, n) {
    var r = function(t) {
        return t;
    };
    return void 0 !== e && n && (r = n.internal.getEncryptor(e)), (t = t || "").toString(), "(" + T(r(t)) + ")";
}, ut = function() {
    this._objId = void 0, this._scope = void 0, Object.defineProperty(this, "objId", {
        get: function() {
            if (void 0 === this._objId) {
                if (void 0 === this.scope) return;
                this._objId = this.scope.internal.newObjectDeferred();
            }
            return this._objId;
        },
        set: function(t) {
            this._objId = t;
        }
    }), Object.defineProperty(this, "scope", {
        value: this._scope,
        writable: !0
    });
};
ut.prototype.toString = function() {
    return this.objId + " 0 R";
}, ut.prototype.putStream = function() {
    var t = this.getKeyValueListForStream();
    this.scope.internal.putStream({
        data: this.stream,
        additionalKeyValues: t,
        objectId: this.objId
    }), this.scope.internal.out("endobj");
}, ut.prototype.getKeyValueListForStream = function() {
    var t = [], e = Object.getOwnPropertyNames(this).filter(function(t) {
        return "content" != t && "appearanceStreamContent" != t && "scope" != t && "objId" != t && "_" != t.substring(0, 1);
    });
    for(var n in e)if (!1 === Object.getOwnPropertyDescriptor(this, e[n]).configurable) {
        var r = e[n], i = this[r];
        i && (Array.isArray(i) ? t.push({
            key: r,
            value: ot(i, this.objId, this.scope)
        }) : i instanceof ut ? (i.scope = this.scope, t.push({
            key: r,
            value: i.objId + " 0 R"
        })) : "function" != typeof i && t.push({
            key: r,
            value: i
        }));
    }
    return t;
};
var ct = function() {
    ut.call(this), Object.defineProperty(this, "Type", {
        value: "/XObject",
        configurable: !1,
        writable: !0
    }), Object.defineProperty(this, "Subtype", {
        value: "/Form",
        configurable: !1,
        writable: !0
    }), Object.defineProperty(this, "FormType", {
        value: 1,
        configurable: !1,
        writable: !0
    });
    var t, e = [];
    Object.defineProperty(this, "BBox", {
        configurable: !1,
        get: function() {
            return e;
        },
        set: function(t) {
            e = t;
        }
    }), Object.defineProperty(this, "Resources", {
        value: "2 0 R",
        configurable: !1,
        writable: !0
    }), Object.defineProperty(this, "stream", {
        enumerable: !1,
        configurable: !0,
        set: function(e) {
            t = e.trim();
        },
        get: function() {
            return t || null;
        }
    });
};
W(ct, ut);
var lt = function() {
    ut.call(this);
    var t, e = [];
    Object.defineProperty(this, "Kids", {
        enumerable: !1,
        configurable: !0,
        get: function() {
            return e.length > 0 ? e : void 0;
        }
    }), Object.defineProperty(this, "Fields", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            return e;
        }
    }), Object.defineProperty(this, "DA", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            if (t) {
                var e = function(t) {
                    return t;
                };
                return this.scope && (e = this.scope.internal.getEncryptor(this.objId)), "(" + T(e(t)) + ")";
            }
        },
        set: function(e) {
            t = e;
        }
    });
};
W(lt, ut);
var ht = function t() {
    ut.call(this);
    var e = 4;
    Object.defineProperty(this, "F", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            return e;
        },
        set: function(t) {
            if (isNaN(t)) throw new Error('Invalid value "' + t + '" for attribute F supplied.');
            e = t;
        }
    }), Object.defineProperty(this, "showWhenPrinted", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean(K(e, 3));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.F = Z(e, 3) : this.F = $(e, 3);
        }
    });
    var n = 0;
    Object.defineProperty(this, "Ff", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            return n;
        },
        set: function(t) {
            if (isNaN(t)) throw new Error('Invalid value "' + t + '" for attribute Ff supplied.');
            n = t;
        }
    });
    var r = [];
    Object.defineProperty(this, "Rect", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            if (0 !== r.length) return r;
        },
        set: function(t) {
            r = void 0 !== t ? t : [];
        }
    }), Object.defineProperty(this, "x", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return !r || isNaN(r[0]) ? 0 : r[0];
        },
        set: function(t) {
            r[0] = t;
        }
    }), Object.defineProperty(this, "y", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return !r || isNaN(r[1]) ? 0 : r[1];
        },
        set: function(t) {
            r[1] = t;
        }
    }), Object.defineProperty(this, "width", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return !r || isNaN(r[2]) ? 0 : r[2];
        },
        set: function(t) {
            r[2] = t;
        }
    }), Object.defineProperty(this, "height", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return !r || isNaN(r[3]) ? 0 : r[3];
        },
        set: function(t) {
            r[3] = t;
        }
    });
    var i = "";
    Object.defineProperty(this, "FT", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            return i;
        },
        set: function(t) {
            switch(t){
                case "/Btn":
                case "/Tx":
                case "/Ch":
                case "/Sig":
                    i = t;
                    break;
                default:
                    throw new Error('Invalid value "' + t + '" for attribute FT supplied.');
            }
        }
    });
    var a = null;
    Object.defineProperty(this, "T", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            if (!a || a.length < 1) {
                if (this instanceof yt) return;
                a = "FieldObject" + t.FieldNum++;
            }
            var e = function(t) {
                return t;
            };
            return this.scope && (e = this.scope.internal.getEncryptor(this.objId)), "(" + T(e(a)) + ")";
        },
        set: function(t) {
            a = t.toString();
        }
    }), Object.defineProperty(this, "fieldName", {
        configurable: !0,
        enumerable: !0,
        get: function() {
            return a;
        },
        set: function(t) {
            a = t;
        }
    });
    var o = "helvetica";
    Object.defineProperty(this, "fontName", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return o;
        },
        set: function(t) {
            o = t;
        }
    });
    var s = "normal";
    Object.defineProperty(this, "fontStyle", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return s;
        },
        set: function(t) {
            s = t;
        }
    });
    var u = 0;
    Object.defineProperty(this, "fontSize", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return u;
        },
        set: function(t) {
            u = t;
        }
    });
    var c = void 0;
    Object.defineProperty(this, "maxFontSize", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return void 0 === c ? 50 / D : c;
        },
        set: function(t) {
            c = t;
        }
    });
    var l = "black";
    Object.defineProperty(this, "color", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return l;
        },
        set: function(t) {
            l = t;
        }
    });
    var h = "/F1 0 Tf 0 g";
    Object.defineProperty(this, "DA", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            if (!(!h || this instanceof yt || this instanceof Nt)) return st(h, this.objId, this.scope);
        },
        set: function(t) {
            t = t.toString(), h = t;
        }
    });
    var f = null;
    Object.defineProperty(this, "DV", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            if (f) return this instanceof mt == 0 ? st(f, this.objId, this.scope) : f;
        },
        set: function(t) {
            t = t.toString(), f = this instanceof mt == 0 ? "(" === t.substr(0, 1) ? z(t.substr(1, t.length - 2)) : z(t) : t;
        }
    }), Object.defineProperty(this, "defaultValue", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return this instanceof mt == 1 ? z(f.substr(1, f.length - 1)) : f;
        },
        set: function(t) {
            t = t.toString(), f = this instanceof mt == 1 ? "/" + t : t;
        }
    });
    var d = null;
    Object.defineProperty(this, "_V", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            if (d) return d;
        },
        set: function(t) {
            this.V = t;
        }
    }), Object.defineProperty(this, "V", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            if (d) return this instanceof mt == 0 ? st(d, this.objId, this.scope) : d;
        },
        set: function(t) {
            t = t.toString(), d = this instanceof mt == 0 ? "(" === t.substr(0, 1) ? z(t.substr(1, t.length - 2)) : z(t) : t;
        }
    }), Object.defineProperty(this, "value", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return this instanceof mt == 1 ? z(d.substr(1, d.length - 1)) : d;
        },
        set: function(t) {
            t = t.toString(), d = this instanceof mt == 1 ? "/" + t : t;
        }
    }), Object.defineProperty(this, "hasAnnotation", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return this.Rect;
        }
    }), Object.defineProperty(this, "Type", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            return this.hasAnnotation ? "/Annot" : null;
        }
    }), Object.defineProperty(this, "Subtype", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            return this.hasAnnotation ? "/Widget" : null;
        }
    });
    var p, g = !1;
    Object.defineProperty(this, "hasAppearanceStream", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return g;
        },
        set: function(t) {
            t = Boolean(t), g = t;
        }
    }), Object.defineProperty(this, "page", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            if (p) return p;
        },
        set: function(t) {
            p = t;
        }
    }), Object.defineProperty(this, "readOnly", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean(K(this.Ff, 1));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = Z(this.Ff, 1) : this.Ff = $(this.Ff, 1);
        }
    }), Object.defineProperty(this, "required", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean(K(this.Ff, 2));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = Z(this.Ff, 2) : this.Ff = $(this.Ff, 2);
        }
    }), Object.defineProperty(this, "noExport", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean(K(this.Ff, 3));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = Z(this.Ff, 3) : this.Ff = $(this.Ff, 3);
        }
    });
    var m = null;
    Object.defineProperty(this, "Q", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            if (null !== m) return m;
        },
        set: function(t) {
            if (-1 === [
                0,
                1,
                2
            ].indexOf(t)) throw new Error('Invalid value "' + t + '" for attribute Q supplied.');
            m = t;
        }
    }), Object.defineProperty(this, "textAlign", {
        get: function() {
            var t;
            switch(m){
                case 0:
                default:
                    t = "left";
                    break;
                case 1:
                    t = "center";
                    break;
                case 2:
                    t = "right";
            }
            return t;
        },
        configurable: !0,
        enumerable: !0,
        set: function(t) {
            switch(t){
                case "right":
                case 2:
                    m = 2;
                    break;
                case "center":
                case 1:
                    m = 1;
                    break;
                default:
                    m = 0;
            }
        }
    });
};
W(ht, ut);
var ft = function() {
    ht.call(this), this.FT = "/Ch", this.V = "()", this.fontName = "zapfdingbats";
    var t = 0;
    Object.defineProperty(this, "TI", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            return t;
        },
        set: function(e) {
            t = e;
        }
    }), Object.defineProperty(this, "topIndex", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return t;
        },
        set: function(e) {
            t = e;
        }
    });
    var e = [];
    Object.defineProperty(this, "Opt", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            return ot(e, this.objId, this.scope);
        },
        set: function(t) {
            var n, r;
            r = [], "string" == typeof (n = t) && (r = function(t, e, n) {
                n || (n = 1);
                for(var r, i = []; r = e.exec(t);)i.push(r[n]);
                return i;
            }(n, /\((.*?)\)/g)), e = r;
        }
    }), this.getOptions = function() {
        return e;
    }, this.setOptions = function(t) {
        e = t, this.sort && e.sort();
    }, this.addOption = function(t) {
        t = (t = t || "").toString(), e.push(t), this.sort && e.sort();
    }, this.removeOption = function(t, n) {
        for(n = n || !1, t = (t = t || "").toString(); -1 !== e.indexOf(t) && (e.splice(e.indexOf(t), 1), !1 !== n););
    }, Object.defineProperty(this, "combo", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean(K(this.Ff, 18));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = Z(this.Ff, 18) : this.Ff = $(this.Ff, 18);
        }
    }), Object.defineProperty(this, "edit", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean(K(this.Ff, 19));
        },
        set: function(t) {
            !0 === this.combo && (!0 === Boolean(t) ? this.Ff = Z(this.Ff, 19) : this.Ff = $(this.Ff, 19));
        }
    }), Object.defineProperty(this, "sort", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean(K(this.Ff, 20));
        },
        set: function(t) {
            !0 === Boolean(t) ? (this.Ff = Z(this.Ff, 20), e.sort()) : this.Ff = $(this.Ff, 20);
        }
    }), Object.defineProperty(this, "multiSelect", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean(K(this.Ff, 22));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = Z(this.Ff, 22) : this.Ff = $(this.Ff, 22);
        }
    }), Object.defineProperty(this, "doNotSpellCheck", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean(K(this.Ff, 23));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = Z(this.Ff, 23) : this.Ff = $(this.Ff, 23);
        }
    }), Object.defineProperty(this, "commitOnSelChange", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean(K(this.Ff, 27));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = Z(this.Ff, 27) : this.Ff = $(this.Ff, 27);
        }
    }), this.hasAppearanceStream = !1;
};
W(ft, ht);
var dt = function() {
    ft.call(this), this.fontName = "helvetica", this.combo = !1;
};
W(dt, ft);
var pt = function() {
    dt.call(this), this.combo = !0;
};
W(pt, dt);
var gt = function() {
    pt.call(this), this.edit = !0;
};
W(gt, pt);
var mt = function() {
    ht.call(this), this.FT = "/Btn", Object.defineProperty(this, "noToggleToOff", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean(K(this.Ff, 15));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = Z(this.Ff, 15) : this.Ff = $(this.Ff, 15);
        }
    }), Object.defineProperty(this, "radio", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean(K(this.Ff, 16));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = Z(this.Ff, 16) : this.Ff = $(this.Ff, 16);
        }
    }), Object.defineProperty(this, "pushButton", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean(K(this.Ff, 17));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = Z(this.Ff, 17) : this.Ff = $(this.Ff, 17);
        }
    }), Object.defineProperty(this, "radioIsUnison", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean(K(this.Ff, 26));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = Z(this.Ff, 26) : this.Ff = $(this.Ff, 26);
        }
    });
    var e, n = {};
    Object.defineProperty(this, "MK", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            var t = function(t) {
                return t;
            };
            if (this.scope && (t = this.scope.internal.getEncryptor(this.objId)), 0 !== Object.keys(n).length) {
                var e, r = [];
                for(e in r.push("<<"), n)r.push("/" + e + " (" + T(t(n[e])) + ")");
                return r.push(">>"), r.join("\n");
            }
        },
        set: function(e) {
            "object" === (0, _typeofDefault.default)(e) && (n = e);
        }
    }), Object.defineProperty(this, "caption", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return n.CA || "";
        },
        set: function(t) {
            "string" == typeof t && (n.CA = t);
        }
    }), Object.defineProperty(this, "AS", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            return e;
        },
        set: function(t) {
            e = t;
        }
    }), Object.defineProperty(this, "appearanceState", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return e.substr(1, e.length - 1);
        },
        set: function(t) {
            e = "/" + t;
        }
    });
};
W(mt, ht);
var vt = function() {
    mt.call(this), this.pushButton = !0;
};
W(vt, mt);
var bt = function() {
    mt.call(this), this.radio = !0, this.pushButton = !1;
    var t = [];
    Object.defineProperty(this, "Kids", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            return t;
        },
        set: function(e) {
            t = void 0 !== e ? e : [];
        }
    });
};
W(bt, mt);
var yt = function() {
    var e, n;
    ht.call(this), Object.defineProperty(this, "Parent", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            return e;
        },
        set: function(t) {
            e = t;
        }
    }), Object.defineProperty(this, "optionName", {
        enumerable: !1,
        configurable: !0,
        get: function() {
            return n;
        },
        set: function(t) {
            n = t;
        }
    });
    var r, i = {};
    Object.defineProperty(this, "MK", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            var t = function(t) {
                return t;
            };
            this.scope && (t = this.scope.internal.getEncryptor(this.objId));
            var e, n = [];
            for(e in n.push("<<"), i)n.push("/" + e + " (" + T(t(i[e])) + ")");
            return n.push(">>"), n.join("\n");
        },
        set: function(e) {
            "object" === (0, _typeofDefault.default)(e) && (i = e);
        }
    }), Object.defineProperty(this, "caption", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return i.CA || "";
        },
        set: function(t) {
            "string" == typeof t && (i.CA = t);
        }
    }), Object.defineProperty(this, "AS", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            return r;
        },
        set: function(t) {
            r = t;
        }
    }), Object.defineProperty(this, "appearanceState", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return r.substr(1, r.length - 1);
        },
        set: function(t) {
            r = "/" + t;
        }
    }), this.caption = "l", this.appearanceState = "Off", this._AppearanceType = xt.RadioButton.Circle, this.appearanceStreamContent = this._AppearanceType.createAppearanceStream(this.optionName);
};
W(yt, ht), bt.prototype.setAppearance = function(t) {
    if (!("createAppearanceStream" in t) || !("getCA" in t)) throw new Error("Couldn't assign Appearance to RadioButton. Appearance was Invalid!");
    for(var e in this.Kids)if (this.Kids.hasOwnProperty(e)) {
        var n = this.Kids[e];
        n.appearanceStreamContent = t.createAppearanceStream(n.optionName), n.caption = t.getCA();
    }
}, bt.prototype.createOption = function(t) {
    var e = new yt;
    return e.Parent = this, e.optionName = t, this.Kids.push(e), At.call(this.scope, e), e;
};
var wt = function() {
    mt.call(this), this.fontName = "zapfdingbats", this.caption = "3", this.appearanceState = "On", this.value = "On", this.textAlign = "center", this.appearanceStreamContent = xt.CheckBox.createAppearanceStream();
};
W(wt, mt);
var Nt = function() {
    ht.call(this), this.FT = "/Tx", Object.defineProperty(this, "multiline", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean(K(this.Ff, 13));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = Z(this.Ff, 13) : this.Ff = $(this.Ff, 13);
        }
    }), Object.defineProperty(this, "fileSelect", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean(K(this.Ff, 21));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = Z(this.Ff, 21) : this.Ff = $(this.Ff, 21);
        }
    }), Object.defineProperty(this, "doNotSpellCheck", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean(K(this.Ff, 23));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = Z(this.Ff, 23) : this.Ff = $(this.Ff, 23);
        }
    }), Object.defineProperty(this, "doNotScroll", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean(K(this.Ff, 24));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = Z(this.Ff, 24) : this.Ff = $(this.Ff, 24);
        }
    }), Object.defineProperty(this, "comb", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean(K(this.Ff, 25));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = Z(this.Ff, 25) : this.Ff = $(this.Ff, 25);
        }
    }), Object.defineProperty(this, "richText", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean(K(this.Ff, 26));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = Z(this.Ff, 26) : this.Ff = $(this.Ff, 26);
        }
    });
    var t = null;
    Object.defineProperty(this, "MaxLen", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            return t;
        },
        set: function(e) {
            t = e;
        }
    }), Object.defineProperty(this, "maxLength", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return t;
        },
        set: function(e) {
            Number.isInteger(e) && (t = e);
        }
    }), Object.defineProperty(this, "hasAppearanceStream", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return this.V || this.DV;
        }
    });
};
W(Nt, ht);
var Lt = function() {
    Nt.call(this), Object.defineProperty(this, "password", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean(K(this.Ff, 14));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = Z(this.Ff, 14) : this.Ff = $(this.Ff, 14);
        }
    }), this.password = !0;
};
W(Lt, Nt);
var xt = {
    CheckBox: {
        createAppearanceStream: function() {
            return {
                N: {
                    On: xt.CheckBox.YesNormal
                },
                D: {
                    On: xt.CheckBox.YesPushDown,
                    Off: xt.CheckBox.OffPushDown
                }
            };
        },
        YesPushDown: function(t) {
            var e = G(t);
            e.scope = t.scope;
            var n = [], r = t.scope.internal.getFont(t.fontName, t.fontStyle).id, i = t.scope.__private__.encodeColorString(t.color), a = et(t, t.caption);
            return n.push("0.749023 g"), n.push("0 0 " + U(xt.internal.getWidth(t)) + " " + U(xt.internal.getHeight(t)) + " re"), n.push("f"), n.push("BMC"), n.push("q"), n.push("0 0 1 rg"), n.push("/" + r + " " + U(a.fontSize) + " Tf " + i), n.push("BT"), n.push(a.text), n.push("ET"), n.push("Q"), n.push("EMC"), e.stream = n.join("\n"), e;
        },
        YesNormal: function(t) {
            var e = G(t);
            e.scope = t.scope;
            var n = t.scope.internal.getFont(t.fontName, t.fontStyle).id, r = t.scope.__private__.encodeColorString(t.color), i = [], a = xt.internal.getHeight(t), o = xt.internal.getWidth(t), s = et(t, t.caption);
            return i.push("1 g"), i.push("0 0 " + U(o) + " " + U(a) + " re"), i.push("f"), i.push("q"), i.push("0 0 1 rg"), i.push("0 0 " + U(o - 1) + " " + U(a - 1) + " re"), i.push("W"), i.push("n"), i.push("0 g"), i.push("BT"), i.push("/" + n + " " + U(s.fontSize) + " Tf " + r), i.push(s.text), i.push("ET"), i.push("Q"), e.stream = i.join("\n"), e;
        },
        OffPushDown: function(t) {
            var e = G(t);
            e.scope = t.scope;
            var n = [];
            return n.push("0.749023 g"), n.push("0 0 " + U(xt.internal.getWidth(t)) + " " + U(xt.internal.getHeight(t)) + " re"), n.push("f"), e.stream = n.join("\n"), e;
        }
    },
    RadioButton: {
        Circle: {
            createAppearanceStream: function(t) {
                var e = {
                    D: {
                        Off: xt.RadioButton.Circle.OffPushDown
                    },
                    N: {}
                };
                return e.N[t] = xt.RadioButton.Circle.YesNormal, e.D[t] = xt.RadioButton.Circle.YesPushDown, e;
            },
            getCA: function() {
                return "l";
            },
            YesNormal: function(t) {
                var e = G(t);
                e.scope = t.scope;
                var n = [], r = xt.internal.getWidth(t) <= xt.internal.getHeight(t) ? xt.internal.getWidth(t) / 4 : xt.internal.getHeight(t) / 4;
                r = Number((.9 * r).toFixed(5));
                var i = xt.internal.Bezier_C, a = Number((r * i).toFixed(5));
                return n.push("q"), n.push("1 0 0 1 " + H(xt.internal.getWidth(t) / 2) + " " + H(xt.internal.getHeight(t) / 2) + " cm"), n.push(r + " 0 m"), n.push(r + " " + a + " " + a + " " + r + " 0 " + r + " c"), n.push("-" + a + " " + r + " -" + r + " " + a + " -" + r + " 0 c"), n.push("-" + r + " -" + a + " -" + a + " -" + r + " 0 -" + r + " c"), n.push(a + " -" + r + " " + r + " -" + a + " " + r + " 0 c"), n.push("f"), n.push("Q"), e.stream = n.join("\n"), e;
            },
            YesPushDown: function(t) {
                var e = G(t);
                e.scope = t.scope;
                var n = [], r = xt.internal.getWidth(t) <= xt.internal.getHeight(t) ? xt.internal.getWidth(t) / 4 : xt.internal.getHeight(t) / 4;
                r = Number((.9 * r).toFixed(5));
                var i = Number((2 * r).toFixed(5)), a = Number((i * xt.internal.Bezier_C).toFixed(5)), o = Number((r * xt.internal.Bezier_C).toFixed(5));
                return n.push("0.749023 g"), n.push("q"), n.push("1 0 0 1 " + H(xt.internal.getWidth(t) / 2) + " " + H(xt.internal.getHeight(t) / 2) + " cm"), n.push(i + " 0 m"), n.push(i + " " + a + " " + a + " " + i + " 0 " + i + " c"), n.push("-" + a + " " + i + " -" + i + " " + a + " -" + i + " 0 c"), n.push("-" + i + " -" + a + " -" + a + " -" + i + " 0 -" + i + " c"), n.push(a + " -" + i + " " + i + " -" + a + " " + i + " 0 c"), n.push("f"), n.push("Q"), n.push("0 g"), n.push("q"), n.push("1 0 0 1 " + H(xt.internal.getWidth(t) / 2) + " " + H(xt.internal.getHeight(t) / 2) + " cm"), n.push(r + " 0 m"), n.push(r + " " + o + " " + o + " " + r + " 0 " + r + " c"), n.push("-" + o + " " + r + " -" + r + " " + o + " -" + r + " 0 c"), n.push("-" + r + " -" + o + " -" + o + " -" + r + " 0 -" + r + " c"), n.push(o + " -" + r + " " + r + " -" + o + " " + r + " 0 c"), n.push("f"), n.push("Q"), e.stream = n.join("\n"), e;
            },
            OffPushDown: function(t) {
                var e = G(t);
                e.scope = t.scope;
                var n = [], r = xt.internal.getWidth(t) <= xt.internal.getHeight(t) ? xt.internal.getWidth(t) / 4 : xt.internal.getHeight(t) / 4;
                r = Number((.9 * r).toFixed(5));
                var i = Number((2 * r).toFixed(5)), a = Number((i * xt.internal.Bezier_C).toFixed(5));
                return n.push("0.749023 g"), n.push("q"), n.push("1 0 0 1 " + H(xt.internal.getWidth(t) / 2) + " " + H(xt.internal.getHeight(t) / 2) + " cm"), n.push(i + " 0 m"), n.push(i + " " + a + " " + a + " " + i + " 0 " + i + " c"), n.push("-" + a + " " + i + " -" + i + " " + a + " -" + i + " 0 c"), n.push("-" + i + " -" + a + " -" + a + " -" + i + " 0 -" + i + " c"), n.push(a + " -" + i + " " + i + " -" + a + " " + i + " 0 c"), n.push("f"), n.push("Q"), e.stream = n.join("\n"), e;
            }
        },
        Cross: {
            createAppearanceStream: function(t) {
                var e = {
                    D: {
                        Off: xt.RadioButton.Cross.OffPushDown
                    },
                    N: {}
                };
                return e.N[t] = xt.RadioButton.Cross.YesNormal, e.D[t] = xt.RadioButton.Cross.YesPushDown, e;
            },
            getCA: function() {
                return "8";
            },
            YesNormal: function(t) {
                var e = G(t);
                e.scope = t.scope;
                var n = [], r = xt.internal.calculateCross(t);
                return n.push("q"), n.push("1 1 " + U(xt.internal.getWidth(t) - 2) + " " + U(xt.internal.getHeight(t) - 2) + " re"), n.push("W"), n.push("n"), n.push(U(r.x1.x) + " " + U(r.x1.y) + " m"), n.push(U(r.x2.x) + " " + U(r.x2.y) + " l"), n.push(U(r.x4.x) + " " + U(r.x4.y) + " m"), n.push(U(r.x3.x) + " " + U(r.x3.y) + " l"), n.push("s"), n.push("Q"), e.stream = n.join("\n"), e;
            },
            YesPushDown: function(t) {
                var e = G(t);
                e.scope = t.scope;
                var n = xt.internal.calculateCross(t), r = [];
                return r.push("0.749023 g"), r.push("0 0 " + U(xt.internal.getWidth(t)) + " " + U(xt.internal.getHeight(t)) + " re"), r.push("f"), r.push("q"), r.push("1 1 " + U(xt.internal.getWidth(t) - 2) + " " + U(xt.internal.getHeight(t) - 2) + " re"), r.push("W"), r.push("n"), r.push(U(n.x1.x) + " " + U(n.x1.y) + " m"), r.push(U(n.x2.x) + " " + U(n.x2.y) + " l"), r.push(U(n.x4.x) + " " + U(n.x4.y) + " m"), r.push(U(n.x3.x) + " " + U(n.x3.y) + " l"), r.push("s"), r.push("Q"), e.stream = r.join("\n"), e;
            },
            OffPushDown: function(t) {
                var e = G(t);
                e.scope = t.scope;
                var n = [];
                return n.push("0.749023 g"), n.push("0 0 " + U(xt.internal.getWidth(t)) + " " + U(xt.internal.getHeight(t)) + " re"), n.push("f"), e.stream = n.join("\n"), e;
            }
        }
    },
    createDefaultAppearanceStream: function(t) {
        var e = t.scope.internal.getFont(t.fontName, t.fontStyle).id, n = t.scope.__private__.encodeColorString(t.color);
        return "/" + e + " " + t.fontSize + " Tf " + n;
    }
};
xt.internal = {
    Bezier_C: .551915024494,
    calculateCross: function(t) {
        var e = xt.internal.getWidth(t), n = xt.internal.getHeight(t), r = Math.min(e, n);
        return {
            x1: {
                x: (e - r) / 2,
                y: (n - r) / 2 + r
            },
            x2: {
                x: (e - r) / 2 + r,
                y: (n - r) / 2
            },
            x3: {
                x: (e - r) / 2,
                y: (n - r) / 2
            },
            x4: {
                x: (e - r) / 2 + r,
                y: (n - r) / 2 + r
            }
        };
    }
}, xt.internal.getWidth = function(e) {
    var n = 0;
    return "object" === (0, _typeofDefault.default)(e) && (n = V(e.Rect[2])), n;
}, xt.internal.getHeight = function(e) {
    var n = 0;
    return "object" === (0, _typeofDefault.default)(e) && (n = V(e.Rect[3])), n;
};
var At = R.addField = function(t) {
    if (at(this, t), !(t instanceof ht)) throw new Error("Invalid argument passed to jsPDF.addField.");
    var e;
    return (e = t).scope.internal.acroformPlugin.printedOut && (e.scope.internal.acroformPlugin.printedOut = !1, e.scope.internal.acroformPlugin.acroFormDictionaryRoot = null), e.scope.internal.acroformPlugin.acroFormDictionaryRoot.Fields.push(e), t.page = t.scope.internal.getCurrentPageInfo().pageNumber, this;
};
R.AcroFormChoiceField = ft, R.AcroFormListBox = dt, R.AcroFormComboBox = pt, R.AcroFormEditBox = gt, R.AcroFormButton = mt, R.AcroFormPushButton = vt, R.AcroFormRadioButton = bt, R.AcroFormCheckBox = wt, R.AcroFormTextField = Nt, R.AcroFormPasswordField = Lt, R.AcroFormAppearance = xt, R.AcroForm = {
    ChoiceField: ft,
    ListBox: dt,
    ComboBox: pt,
    EditBox: gt,
    Button: mt,
    PushButton: vt,
    RadioButton: bt,
    CheckBox: wt,
    TextField: Nt,
    PasswordField: Lt,
    Appearance: xt
}, E.AcroForm = {
    ChoiceField: ft,
    ListBox: dt,
    ComboBox: pt,
    EditBox: gt,
    Button: mt,
    PushButton: vt,
    RadioButton: bt,
    CheckBox: wt,
    TextField: Nt,
    PasswordField: Lt,
    Appearance: xt
};
var St = E.AcroForm;
function _t(t) {
    return t.reduce(function(t, e, n) {
        return t[e] = n, t;
    }, {});
}
!function(e) {
    var n = "addImage_";
    e.__addimage__ = {};
    var r = "UNKNOWN", i = {
        PNG: [
            [
                137,
                80,
                78,
                71
            ]
        ],
        TIFF: [
            [
                77,
                77,
                0,
                42
            ],
            [
                73,
                73,
                42,
                0
            ]
        ],
        JPEG: [
            [
                255,
                216,
                255,
                224,
                void 0,
                void 0,
                74,
                70,
                73,
                70,
                0
            ],
            [
                255,
                216,
                255,
                225,
                void 0,
                void 0,
                69,
                120,
                105,
                102,
                0,
                0
            ],
            [
                255,
                216,
                255,
                219
            ],
            [
                255,
                216,
                255,
                238
            ]
        ],
        JPEG2000: [
            [
                0,
                0,
                0,
                12,
                106,
                80,
                32,
                32
            ]
        ],
        GIF87a: [
            [
                71,
                73,
                70,
                56,
                55,
                97
            ]
        ],
        GIF89a: [
            [
                71,
                73,
                70,
                56,
                57,
                97
            ]
        ],
        WEBP: [
            [
                82,
                73,
                70,
                70,
                void 0,
                void 0,
                void 0,
                void 0,
                87,
                69,
                66,
                80
            ]
        ],
        BMP: [
            [
                66,
                77
            ],
            [
                66,
                65
            ],
            [
                67,
                73
            ],
            [
                67,
                80
            ],
            [
                73,
                67
            ],
            [
                80,
                84
            ]
        ]
    }, a = e.__addimage__.getImageFileTypeByImageData = function(t, e) {
        var n, a, o, s, u, c = r;
        if ("RGBA" === (e = e || r) || void 0 !== t.data && t.data instanceof Uint8ClampedArray && "height" in t && "width" in t) return "RGBA";
        if (A(t)) for(u in i)for(o = i[u], n = 0; n < o.length; n += 1){
            for(s = !0, a = 0; a < o[n].length; a += 1)if (void 0 !== o[n][a] && o[n][a] !== t[a]) {
                s = !1;
                break;
            }
            if (!0 === s) {
                c = u;
                break;
            }
        }
        else for(u in i)for(o = i[u], n = 0; n < o.length; n += 1){
            for(s = !0, a = 0; a < o[n].length; a += 1)if (void 0 !== o[n][a] && o[n][a] !== t.charCodeAt(a)) {
                s = !1;
                break;
            }
            if (!0 === s) {
                c = u;
                break;
            }
        }
        return c === r && e !== r && (c = e), c;
    }, o = function t(e) {
        for(var n = this.internal.write, r = this.internal.putStream, i = (0, this.internal.getFilters)(); -1 !== i.indexOf("FlateEncode");)i.splice(i.indexOf("FlateEncode"), 1);
        e.objectId = this.internal.newObject();
        var a = [];
        if (a.push({
            key: "Type",
            value: "/XObject"
        }), a.push({
            key: "Subtype",
            value: "/Image"
        }), a.push({
            key: "Width",
            value: e.width
        }), a.push({
            key: "Height",
            value: e.height
        }), e.colorSpace === y.INDEXED ? a.push({
            key: "ColorSpace",
            value: "[/Indexed /DeviceRGB " + (e.palette.length / 3 - 1) + " " + ("sMask" in e && void 0 !== e.sMask ? e.objectId + 2 : e.objectId + 1) + " 0 R]"
        }) : (a.push({
            key: "ColorSpace",
            value: "/" + e.colorSpace
        }), e.colorSpace === y.DEVICE_CMYK && a.push({
            key: "Decode",
            value: "[1 0 1 0 1 0 1 0]"
        })), a.push({
            key: "BitsPerComponent",
            value: e.bitsPerComponent
        }), "decodeParameters" in e && void 0 !== e.decodeParameters && a.push({
            key: "DecodeParms",
            value: "<<" + e.decodeParameters + ">>"
        }), "transparency" in e && Array.isArray(e.transparency) && e.transparency.length > 0) {
            for(var o = "", s = 0, u = e.transparency.length; s < u; s++)o += e.transparency[s] + " " + e.transparency[s] + " ";
            a.push({
                key: "Mask",
                value: "[" + o + "]"
            });
        }
        void 0 !== e.sMask && a.push({
            key: "SMask",
            value: e.objectId + 1 + " 0 R"
        });
        var c = void 0 !== e.filter ? [
            "/" + e.filter
        ] : void 0;
        if (r({
            data: e.data,
            additionalKeyValues: a,
            alreadyAppliedFilters: c,
            objectId: e.objectId
        }), n("endobj"), "sMask" in e && void 0 !== e.sMask) {
            var l, h = null !== (l = e.sMaskBitsPerComponent) && void 0 !== l ? l : e.bitsPerComponent, f = {
                width: e.width,
                height: e.height,
                colorSpace: "DeviceGray",
                bitsPerComponent: h,
                data: e.sMask
            };
            "filter" in e && (f.decodeParameters = "/Predictor ".concat(e.predictor, " /Colors 1 /BitsPerComponent ").concat(h, " /Columns ").concat(e.width), f.filter = e.filter), t.call(this, f);
        }
        if (e.colorSpace === y.INDEXED) {
            var d = this.internal.newObject();
            r({
                data: _(new Uint8Array(e.palette)),
                objectId: d
            }), n("endobj");
        }
    }, s = function() {
        var t = this.internal.collections[n + "images"];
        for(var e in t)o.call(this, t[e]);
    }, u = function() {
        var t, e = this.internal.collections[n + "images"], r = this.internal.write;
        for(var i in e)r("/I" + (t = e[i]).index, t.objectId, "0", "R");
    }, c = function() {
        this.internal.collections[n + "images"] || (this.internal.collections[n + "images"] = {}, this.internal.events.subscribe("putResources", s), this.internal.events.subscribe("putXobjectDict", u));
    }, l = function() {
        var t = this.internal.collections[n + "images"];
        return c.call(this), t;
    }, h = function() {
        return Object.keys(this.internal.collections[n + "images"]).length;
    }, d = function(t) {
        return "function" == typeof e["process" + t.toUpperCase()];
    }, p = function(e) {
        return "object" === (0, _typeofDefault.default)(e) && 1 === e.nodeType;
    }, g = function(t, n) {
        if ("IMG" === t.nodeName && t.hasAttribute("src")) {
            var r = "" + t.getAttribute("src");
            if (0 === r.indexOf("data:image/")) return f(unescape(r).split("base64,").pop());
            var i = e.loadFile(r, !0);
            if (void 0 !== i) return i;
        }
        if ("CANVAS" === t.nodeName) {
            if (0 === t.width || 0 === t.height) throw new Error("Given canvas must have data. Canvas width: " + t.width + ", height: " + t.height);
            var a;
            switch(n){
                case "PNG":
                    a = "image/png";
                    break;
                case "WEBP":
                    a = "image/webp";
                    break;
                default:
                    a = "image/jpeg";
            }
            return f(t.toDataURL(a, 1).split("base64,").pop());
        }
    }, m = function(t) {
        var e = this.internal.collections[n + "images"];
        if (e) {
            for(var r in e)if (t === e[r].alias) return e[r];
        }
    }, v = function(t, e, n) {
        return t || e || (t = -96, e = -96), t < 0 && (t = -1 * n.width * 72 / t / this.internal.scaleFactor), e < 0 && (e = -1 * n.height * 72 / e / this.internal.scaleFactor), 0 === t && (t = e * n.width / n.height), 0 === e && (e = t * n.height / n.width), [
            t,
            e
        ];
    }, b = function(t, e, n, r, i, a) {
        var o = v.call(this, n, r, i), s = this.internal.getCoordinateString, u = this.internal.getVerticalCoordinateString, c = l.call(this);
        if (n = o[0], r = o[1], c[i.index] = i, a) {
            a *= Math.PI / 180;
            var h = Math.cos(a), f = Math.sin(a), d = function(t) {
                return t.toFixed(4);
            }, p = [
                d(h),
                d(f),
                d(-1 * f),
                d(h),
                0,
                0,
                "cm"
            ];
        }
        this.internal.write("q"), a ? (this.internal.write([
            1,
            "0",
            "0",
            1,
            s(t),
            u(e + r),
            "cm"
        ].join(" ")), this.internal.write(p.join(" ")), this.internal.write([
            s(n),
            "0",
            "0",
            s(r),
            "0",
            "0",
            "cm"
        ].join(" "))) : this.internal.write([
            s(n),
            "0",
            "0",
            s(r),
            s(t),
            u(e + r),
            "cm"
        ].join(" ")), this.isAdvancedAPI() && this.internal.write([
            1,
            0,
            0,
            -1,
            0,
            0,
            "cm"
        ].join(" ")), this.internal.write("/I" + i.index + " Do"), this.internal.write("Q");
    }, y = e.color_spaces = {
        DEVICE_RGB: "DeviceRGB",
        DEVICE_GRAY: "DeviceGray",
        DEVICE_CMYK: "DeviceCMYK",
        CAL_GREY: "CalGray",
        CAL_RGB: "CalRGB",
        LAB: "Lab",
        ICC_BASED: "ICCBased",
        INDEXED: "Indexed",
        PATTERN: "Pattern",
        SEPARATION: "Separation",
        DEVICE_N: "DeviceN"
    };
    e.decode = {
        DCT_DECODE: "DCTDecode",
        FLATE_DECODE: "FlateDecode",
        LZW_DECODE: "LZWDecode",
        JPX_DECODE: "JPXDecode",
        JBIG2_DECODE: "JBIG2Decode",
        ASCII85_DECODE: "ASCII85Decode",
        ASCII_HEX_DECODE: "ASCIIHexDecode",
        RUN_LENGTH_DECODE: "RunLengthDecode",
        CCITT_FAX_DECODE: "CCITTFaxDecode"
    };
    var w = e.image_compression = {
        NONE: "NONE",
        FAST: "FAST",
        MEDIUM: "MEDIUM",
        SLOW: "SLOW"
    }, N = e.__addimage__.sHashCode = function(t) {
        var e, n, r = 0;
        if ("string" == typeof t) for(n = t.length, e = 0; e < n; e++)r = (r << 5) - r + t.charCodeAt(e), r |= 0;
        else if (A(t)) for(n = t.byteLength / 2, e = 0; e < n; e++)r = (r << 5) - r + t[e], r |= 0;
        return r;
    }, L = e.__addimage__.validateStringAsBase64 = function(t) {
        (t = t || "").toString().trim();
        var e = !0;
        return 0 === t.length && (e = !1), t.length % 4 != 0 && (e = !1), !1 === /^[A-Za-z0-9+/]+$/.test(t.substr(0, t.length - 2)) && (e = !1), !1 === /^[A-Za-z0-9/][A-Za-z0-9+/]|[A-Za-z0-9+/]=|==$/.test(t.substr(-2)) && (e = !1), e;
    }, x = e.__addimage__.extractImageFromDataUrl = function(t) {
        if (null == t) return null;
        if (!(t = t.trim()).startsWith("data:")) return null;
        var e = t.indexOf(",");
        return e < 0 ? null : t.substring(0, e).trim().endsWith("base64") ? t.substring(e + 1) : null;
    };
    e.__addimage__.isArrayBuffer = function(t) {
        return t instanceof ArrayBuffer;
    };
    var A = e.__addimage__.isArrayBufferView = function(t) {
        return t instanceof Int8Array || t instanceof Uint8Array || t instanceof Uint8ClampedArray || t instanceof Int16Array || t instanceof Uint16Array || t instanceof Int32Array || t instanceof Uint32Array || t instanceof Float32Array || t instanceof Float64Array;
    }, S = e.__addimage__.binaryStringToUint8Array = function(t) {
        for(var e = t.length, n = new Uint8Array(e), r = 0; r < e; r++)n[r] = t.charCodeAt(r);
        return n;
    }, _ = e.__addimage__.arrayBufferToBinaryString = function(t) {
        for(var e = "", n = A(t) ? t : new Uint8Array(t), r = 0; r < n.length; r += 8192)e += String.fromCharCode.apply(null, n.subarray(r, r + 8192));
        return e;
    };
    e.addImage = function() {
        var e, n, i, a, o, s, u, l, h;
        if ("number" == typeof arguments[1] ? (n = r, i = arguments[1], a = arguments[2], o = arguments[3], s = arguments[4], u = arguments[5], l = arguments[6], h = arguments[7]) : (n = arguments[1], i = arguments[2], a = arguments[3], o = arguments[4], s = arguments[5], u = arguments[6], l = arguments[7], h = arguments[8]), "object" === (0, _typeofDefault.default)(e = arguments[0]) && !p(e) && "imageData" in e) {
            var f = e;
            e = f.imageData, n = f.format || n || r, i = f.x || i || 0, a = f.y || a || 0, o = f.w || f.width || o, s = f.h || f.height || s, u = f.alias || u, l = f.compression || l, h = f.rotation || f.angle || h;
        }
        var d = this.internal.getFilters();
        if (void 0 === l && -1 !== d.indexOf("FlateEncode") && (l = "SLOW"), isNaN(i) || isNaN(a)) throw new Error("Invalid coordinates passed to jsPDF.addImage");
        c.call(this);
        var g = P.call(this, e, n, u, l);
        return b.call(this, i, a, o, s, g, h), this;
    };
    var P = function(t, n, i, o) {
        var s, u, c;
        if ("string" == typeof t && a(t) === r) {
            t = unescape(t);
            var l = k(t, !1);
            ("" !== l || void 0 !== (l = e.loadFile(t, !0))) && (t = l);
        }
        if (p(t) && (t = g(t, n)), n = a(t, n), !d(n)) throw new Error("addImage does not support files of type '" + n + "', please ensure that a plugin for '" + n + "' support is added.");
        if ((null == (c = i) || 0 === c.length) && (i = function(t) {
            return "string" == typeof t || A(t) ? N(t) : A(t.data) ? N(t.data) : null;
        }(t)), (s = m.call(this, i)) || (t instanceof Uint8Array || "RGBA" === n || (u = t, t = S(t)), s = this["process" + n.toUpperCase()](t, h.call(this), i, function(t) {
            return t && "string" == typeof t && (t = t.toUpperCase()), t in e.image_compression ? t : w.NONE;
        }(o), u)), !s) throw new Error("An unknown error occurred whilst processing the image.");
        return s;
    }, k = e.__addimage__.convertBase64ToBinaryString = function(t, e) {
        e = "boolean" != typeof e || e;
        var n, r = "";
        if ("string" == typeof t) {
            var i;
            n = null !== (i = x(t)) && void 0 !== i ? i : t;
            try {
                r = f(n);
            } catch (a) {
                if (e) throw L(n) ? new Error("atob-Error in jsPDF.convertBase64ToBinaryString " + a.message) : new Error("Supplied Data is not a valid base64-String jsPDF.convertBase64ToBinaryString ");
            }
        }
        return r;
    };
    e.getImageProperties = function(t) {
        var n, i, o = "";
        if (p(t) && (t = g(t)), "string" == typeof t && a(t) === r && ("" === (o = k(t, !1)) && (o = e.loadFile(t) || ""), t = o), i = a(t), !d(i)) throw new Error("addImage does not support files of type '" + i + "', please ensure that a plugin for '" + i + "' support is added.");
        if (t instanceof Uint8Array || (t = S(t)), !(n = this["process" + i.toUpperCase()](t))) throw new Error("An unknown error occurred whilst processing the image");
        return n.fileType = i, n;
    };
}(E.API), /**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e = function(t) {
        if (void 0 !== t && "" != t) return !0;
    };
    E.API.events.push([
        "addPage",
        function(t) {
            this.internal.getPageInfo(t.pageNumber).pageContext.annotations = [];
        }
    ]), t.events.push([
        "putPage",
        function(t) {
            for(var n, r, i, a = this.internal.getCoordinateString, o = this.internal.getVerticalCoordinateString, s = this.internal.getPageInfoByObjId(t.objId), u = t.pageContext.annotations, c = !1, l = 0; l < u.length && !c; l++)switch((n = u[l]).type){
                case "link":
                    (e(n.options.url) || e(n.options.pageNumber)) && (c = !0);
                    break;
                case "reference":
                case "text":
                case "freetext":
                    c = !0;
            }
            if (0 != c) {
                this.internal.write("/Annots [");
                for(var h = 0; h < u.length; h++){
                    n = u[h];
                    var f = this.internal.pdfEscape, d = this.internal.getEncryptor(t.objId);
                    switch(n.type){
                        case "reference":
                            this.internal.write(" " + n.object.objId + " 0 R ");
                            break;
                        case "text":
                            var p = this.internal.newAdditionalObject(), g = this.internal.newAdditionalObject(), m = this.internal.getEncryptor(p.objId), v = n.title || "Note";
                            i = "<</Type /Annot /Subtype /Text " + (r = "/Rect [" + a(n.bounds.x) + " " + o(n.bounds.y + n.bounds.h) + " " + a(n.bounds.x + n.bounds.w) + " " + o(n.bounds.y) + "] ") + "/Contents (" + f(m(n.contents)) + ")", i += " /Popup " + g.objId + " 0 R", i += " /P " + s.objId + " 0 R", i += " /T (" + f(m(v)) + ") >>", p.content = i;
                            var b = p.objId + " 0 R";
                            i = "<</Type /Annot /Subtype /Popup " + (r = "/Rect [" + a(n.bounds.x + 30) + " " + o(n.bounds.y + n.bounds.h) + " " + a(n.bounds.x + n.bounds.w + 30) + " " + o(n.bounds.y) + "] ") + " /Parent " + b, n.open && (i += " /Open true"), i += " >>", g.content = i, this.internal.write(p.objId, "0 R", g.objId, "0 R");
                            break;
                        case "freetext":
                            r = "/Rect [" + a(n.bounds.x) + " " + o(n.bounds.y) + " " + a(n.bounds.x + n.bounds.w) + " " + o(n.bounds.y + n.bounds.h) + "] ";
                            var y = n.color || "#000000";
                            i = "<</Type /Annot /Subtype /FreeText " + r + "/Contents (" + f(d(n.contents)) + ")", i += " /DS(font: Helvetica,sans-serif 12.0pt; text-align:left; color:#" + y + ")", i += " /Border [0 0 0]", i += " >>", this.internal.write(i);
                            break;
                        case "link":
                            if (n.options.name) {
                                var w = this.annotations._nameMap[n.options.name];
                                n.options.pageNumber = w.page, n.options.top = w.y;
                            } else n.options.top || (n.options.top = 0);
                            if (r = "/Rect [" + n.finalBounds.x + " " + n.finalBounds.y + " " + n.finalBounds.w + " " + n.finalBounds.h + "] ", i = "", n.options.url) i = "<</Type /Annot /Subtype /Link " + r + "/Border [0 0 0] /A <</S /URI /URI (" + f(d(n.options.url)) + ") >>";
                            else if (n.options.pageNumber) switch(i = "<</Type /Annot /Subtype /Link " + r + "/Border [0 0 0] /Dest [" + this.internal.getPageInfo(n.options.pageNumber).objId + " 0 R", n.options.magFactor = n.options.magFactor || "XYZ", n.options.magFactor){
                                case "Fit":
                                    i += " /Fit]";
                                    break;
                                case "FitH":
                                    i += " /FitH " + n.options.top + "]";
                                    break;
                                case "FitV":
                                    n.options.left = n.options.left || 0, i += " /FitV " + n.options.left + "]";
                                    break;
                                default:
                                    var N = o(n.options.top);
                                    n.options.left = n.options.left || 0, void 0 === n.options.zoom && (n.options.zoom = 0), i += " /XYZ " + n.options.left + " " + N + " " + n.options.zoom + "]";
                            }
                            "" != i && (i += " >>", this.internal.write(i));
                    }
                }
                this.internal.write("]");
            }
        }
    ]), t.createAnnotation = function(t) {
        var e = this.internal.getCurrentPageInfo();
        switch(t.type){
            case "link":
                this.link(t.bounds.x, t.bounds.y, t.bounds.w, t.bounds.h, t);
                break;
            case "text":
            case "freetext":
                e.pageContext.annotations.push(t);
        }
    }, t.link = function(t, e, n, r, i) {
        var a = this.internal.getCurrentPageInfo(), o = this.internal.getCoordinateString, s = this.internal.getVerticalCoordinateString;
        a.pageContext.annotations.push({
            finalBounds: {
                x: o(t),
                y: s(e),
                w: o(t + n),
                h: s(e + r)
            },
            options: i,
            type: "link"
        });
    }, t.textWithLink = function(t, e, n, r) {
        var i, a, o = this.getTextWidth(t), s = this.internal.getLineHeight() / this.internal.scaleFactor;
        if (void 0 !== r.maxWidth) {
            a = r.maxWidth;
            var u = this.splitTextToSize(t, a).length;
            i = Math.ceil(s * u);
        } else a = o, i = s;
        return this.text(t, e, n, r), n += .2 * s, "center" === r.align && (e -= o / 2), "right" === r.align && (e -= o), this.link(e, n - s, a, i, r), o;
    }, t.getTextWidth = function(t) {
        var e = this.internal.getFontSize();
        return this.getStringUnitWidth(t) * e / this.internal.scaleFactor;
    };
}(E.API), /**
 * @license
 * Copyright (c) 2017 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e = {
        1569: [
            65152
        ],
        1570: [
            65153,
            65154
        ],
        1571: [
            65155,
            65156
        ],
        1572: [
            65157,
            65158
        ],
        1573: [
            65159,
            65160
        ],
        1574: [
            65161,
            65162,
            65163,
            65164
        ],
        1575: [
            65165,
            65166
        ],
        1576: [
            65167,
            65168,
            65169,
            65170
        ],
        1577: [
            65171,
            65172
        ],
        1578: [
            65173,
            65174,
            65175,
            65176
        ],
        1579: [
            65177,
            65178,
            65179,
            65180
        ],
        1580: [
            65181,
            65182,
            65183,
            65184
        ],
        1581: [
            65185,
            65186,
            65187,
            65188
        ],
        1582: [
            65189,
            65190,
            65191,
            65192
        ],
        1583: [
            65193,
            65194
        ],
        1584: [
            65195,
            65196
        ],
        1585: [
            65197,
            65198
        ],
        1586: [
            65199,
            65200
        ],
        1587: [
            65201,
            65202,
            65203,
            65204
        ],
        1588: [
            65205,
            65206,
            65207,
            65208
        ],
        1589: [
            65209,
            65210,
            65211,
            65212
        ],
        1590: [
            65213,
            65214,
            65215,
            65216
        ],
        1591: [
            65217,
            65218,
            65219,
            65220
        ],
        1592: [
            65221,
            65222,
            65223,
            65224
        ],
        1593: [
            65225,
            65226,
            65227,
            65228
        ],
        1594: [
            65229,
            65230,
            65231,
            65232
        ],
        1601: [
            65233,
            65234,
            65235,
            65236
        ],
        1602: [
            65237,
            65238,
            65239,
            65240
        ],
        1603: [
            65241,
            65242,
            65243,
            65244
        ],
        1604: [
            65245,
            65246,
            65247,
            65248
        ],
        1605: [
            65249,
            65250,
            65251,
            65252
        ],
        1606: [
            65253,
            65254,
            65255,
            65256
        ],
        1607: [
            65257,
            65258,
            65259,
            65260
        ],
        1608: [
            65261,
            65262
        ],
        1609: [
            65263,
            65264,
            64488,
            64489
        ],
        1610: [
            65265,
            65266,
            65267,
            65268
        ],
        1649: [
            64336,
            64337
        ],
        1655: [
            64477
        ],
        1657: [
            64358,
            64359,
            64360,
            64361
        ],
        1658: [
            64350,
            64351,
            64352,
            64353
        ],
        1659: [
            64338,
            64339,
            64340,
            64341
        ],
        1662: [
            64342,
            64343,
            64344,
            64345
        ],
        1663: [
            64354,
            64355,
            64356,
            64357
        ],
        1664: [
            64346,
            64347,
            64348,
            64349
        ],
        1667: [
            64374,
            64375,
            64376,
            64377
        ],
        1668: [
            64370,
            64371,
            64372,
            64373
        ],
        1670: [
            64378,
            64379,
            64380,
            64381
        ],
        1671: [
            64382,
            64383,
            64384,
            64385
        ],
        1672: [
            64392,
            64393
        ],
        1676: [
            64388,
            64389
        ],
        1677: [
            64386,
            64387
        ],
        1678: [
            64390,
            64391
        ],
        1681: [
            64396,
            64397
        ],
        1688: [
            64394,
            64395
        ],
        1700: [
            64362,
            64363,
            64364,
            64365
        ],
        1702: [
            64366,
            64367,
            64368,
            64369
        ],
        1705: [
            64398,
            64399,
            64400,
            64401
        ],
        1709: [
            64467,
            64468,
            64469,
            64470
        ],
        1711: [
            64402,
            64403,
            64404,
            64405
        ],
        1713: [
            64410,
            64411,
            64412,
            64413
        ],
        1715: [
            64406,
            64407,
            64408,
            64409
        ],
        1722: [
            64414,
            64415
        ],
        1723: [
            64416,
            64417,
            64418,
            64419
        ],
        1726: [
            64426,
            64427,
            64428,
            64429
        ],
        1728: [
            64420,
            64421
        ],
        1729: [
            64422,
            64423,
            64424,
            64425
        ],
        1733: [
            64480,
            64481
        ],
        1734: [
            64473,
            64474
        ],
        1735: [
            64471,
            64472
        ],
        1736: [
            64475,
            64476
        ],
        1737: [
            64482,
            64483
        ],
        1739: [
            64478,
            64479
        ],
        1740: [
            64508,
            64509,
            64510,
            64511
        ],
        1744: [
            64484,
            64485,
            64486,
            64487
        ],
        1746: [
            64430,
            64431
        ],
        1747: [
            64432,
            64433
        ]
    }, n = {
        65247: {
            65154: 65269,
            65156: 65271,
            65160: 65273,
            65166: 65275
        },
        65248: {
            65154: 65270,
            65156: 65272,
            65160: 65274,
            65166: 65276
        },
        65165: {
            65247: {
                65248: {
                    65258: 65010
                }
            }
        },
        1617: {
            1612: 64606,
            1613: 64607,
            1614: 64608,
            1615: 64609,
            1616: 64610
        }
    }, r = {
        1612: 64606,
        1613: 64607,
        1614: 64608,
        1615: 64609,
        1616: 64610
    }, i = [
        1570,
        1571,
        1573,
        1575
    ];
    t.__arabicParser__ = {};
    var a = t.__arabicParser__.isInArabicSubstitutionA = function(t) {
        return void 0 !== e[t.charCodeAt(0)];
    }, o = t.__arabicParser__.isArabicLetter = function(t) {
        return "string" == typeof t && /^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]+$/.test(t);
    }, s = t.__arabicParser__.isArabicEndLetter = function(t) {
        return o(t) && a(t) && e[t.charCodeAt(0)].length <= 2;
    }, u = t.__arabicParser__.isArabicAlfLetter = function(t) {
        return o(t) && i.indexOf(t.charCodeAt(0)) >= 0;
    };
    t.__arabicParser__.arabicLetterHasIsolatedForm = function(t) {
        return o(t) && a(t) && e[t.charCodeAt(0)].length >= 1;
    };
    var c = t.__arabicParser__.arabicLetterHasFinalForm = function(t) {
        return o(t) && a(t) && e[t.charCodeAt(0)].length >= 2;
    };
    t.__arabicParser__.arabicLetterHasInitialForm = function(t) {
        return o(t) && a(t) && e[t.charCodeAt(0)].length >= 3;
    };
    var l = t.__arabicParser__.arabicLetterHasMedialForm = function(t) {
        return o(t) && a(t) && 4 == e[t.charCodeAt(0)].length;
    }, h = t.__arabicParser__.resolveLigatures = function(t) {
        var e = 0, r = n, i = "", a = 0;
        for(e = 0; e < t.length; e += 1)void 0 !== r[t.charCodeAt(e)] ? (a++, "number" == typeof (r = r[t.charCodeAt(e)]) && (i += String.fromCharCode(r), r = n, a = 0), e === t.length - 1 && (r = n, i += t.charAt(e - (a - 1)), e -= a - 1, a = 0)) : (r = n, i += t.charAt(e - a), e -= a, a = 0);
        return i;
    };
    t.__arabicParser__.isArabicDiacritic = function(t) {
        return void 0 !== t && void 0 !== r[t.charCodeAt(0)];
    };
    var f = t.__arabicParser__.getCorrectForm = function(t, e, n) {
        return o(t) ? !1 === a(t) ? -1 : !c(t) || !o(e) && !o(n) || !o(n) && s(e) || s(t) && !o(e) || s(t) && u(e) || s(t) && s(e) ? 0 : l(t) && o(e) && !s(e) && o(n) && c(n) ? 3 : s(t) || !o(n) ? 1 : 2 : -1;
    }, d = function(t) {
        var n = 0, r = 0, i = 0, a = "", s = "", u = "", c = (t = t || "").split("\\s+"), l = [];
        for(n = 0; n < c.length; n += 1){
            for(l.push(""), r = 0; r < c[n].length; r += 1)a = c[n][r], s = c[n][r - 1], u = c[n][r + 1], o(a) ? (i = f(a, s, u), l[n] += -1 !== i ? String.fromCharCode(e[a.charCodeAt(0)][i]) : a) : l[n] += a;
            l[n] = h(l[n]);
        }
        return l.join(" ");
    }, p = t.__arabicParser__.processArabic = t.processArabic = function() {
        var t, e = "string" == typeof arguments[0] ? arguments[0] : arguments[0].text, n = [];
        if (Array.isArray(e)) {
            var r = 0;
            for(n = [], r = 0; r < e.length; r += 1)Array.isArray(e[r]) ? n.push([
                d(e[r][0]),
                e[r][1],
                e[r][2]
            ]) : n.push([
                d(e[r])
            ]);
            t = n;
        } else t = d(e);
        return "string" == typeof arguments[0] ? t : (arguments[0].text = t, arguments[0]);
    };
    t.events.push([
        "preProcessText",
        p
    ]);
}(E.API), E.API.autoPrint = function(t) {
    var e;
    return (t = t || {}).variant = t.variant || "non-conform", "javascript" === t.variant ? this.addJS("print({});") : (this.internal.events.subscribe("postPutResources", function() {
        e = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/S /Named"), this.internal.out("/Type /Action"), this.internal.out("/N /Print"), this.internal.out(">>"), this.internal.out("endobj");
    }), this.internal.events.subscribe("putCatalog", function() {
        this.internal.out("/OpenAction " + e + " 0 R");
    })), this;
}, /**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e = function() {
        var t = void 0;
        Object.defineProperty(this, "pdf", {
            get: function() {
                return t;
            },
            set: function(e) {
                t = e;
            }
        });
        var e = 150;
        Object.defineProperty(this, "width", {
            get: function() {
                return e;
            },
            set: function(t) {
                e = isNaN(t) || !1 === Number.isInteger(t) || t < 0 ? 150 : t, this.getContext("2d").pageWrapXEnabled && (this.getContext("2d").pageWrapX = e + 1);
            }
        });
        var n = 300;
        Object.defineProperty(this, "height", {
            get: function() {
                return n;
            },
            set: function(t) {
                n = isNaN(t) || !1 === Number.isInteger(t) || t < 0 ? 300 : t, this.getContext("2d").pageWrapYEnabled && (this.getContext("2d").pageWrapY = n + 1);
            }
        });
        var r = [];
        Object.defineProperty(this, "childNodes", {
            get: function() {
                return r;
            },
            set: function(t) {
                r = t;
            }
        });
        var i = {};
        Object.defineProperty(this, "style", {
            get: function() {
                return i;
            },
            set: function(t) {
                i = t;
            }
        }), Object.defineProperty(this, "parentNode", {});
    };
    e.prototype.getContext = function(t, e) {
        var n;
        if ("2d" !== (t = t || "2d")) return null;
        for(n in e)this.pdf.context2d.hasOwnProperty(n) && (this.pdf.context2d[n] = e[n]);
        return this.pdf.context2d._canvas = this, this.pdf.context2d;
    }, e.prototype.toDataURL = function() {
        throw new Error("toDataURL is not implemented.");
    }, t.events.push([
        "initialized",
        function() {
            this.canvas = new e, this.canvas.pdf = this;
        }
    ]);
}(E.API), function(e) {
    var n = {
        left: 0,
        top: 0,
        bottom: 0,
        right: 0
    }, r = !1, i = function() {
        void 0 === this.internal.__cell__ && (this.internal.__cell__ = {}, this.internal.__cell__.padding = 3, this.internal.__cell__.headerFunction = void 0, this.internal.__cell__.margins = Object.assign({}, n), this.internal.__cell__.margins.width = this.getPageWidth(), a.call(this));
    }, a = function() {
        this.internal.__cell__.lastCell = new o, this.internal.__cell__.pages = 1;
    }, o = function() {
        var t = arguments[0];
        Object.defineProperty(this, "x", {
            enumerable: !0,
            get: function() {
                return t;
            },
            set: function(e) {
                t = e;
            }
        });
        var e = arguments[1];
        Object.defineProperty(this, "y", {
            enumerable: !0,
            get: function() {
                return e;
            },
            set: function(t) {
                e = t;
            }
        });
        var n = arguments[2];
        Object.defineProperty(this, "width", {
            enumerable: !0,
            get: function() {
                return n;
            },
            set: function(t) {
                n = t;
            }
        });
        var r = arguments[3];
        Object.defineProperty(this, "height", {
            enumerable: !0,
            get: function() {
                return r;
            },
            set: function(t) {
                r = t;
            }
        });
        var i = arguments[4];
        Object.defineProperty(this, "text", {
            enumerable: !0,
            get: function() {
                return i;
            },
            set: function(t) {
                i = t;
            }
        });
        var a = arguments[5];
        Object.defineProperty(this, "lineNumber", {
            enumerable: !0,
            get: function() {
                return a;
            },
            set: function(t) {
                a = t;
            }
        });
        var o = arguments[6];
        return Object.defineProperty(this, "align", {
            enumerable: !0,
            get: function() {
                return o;
            },
            set: function(t) {
                o = t;
            }
        }), this;
    };
    o.prototype.clone = function() {
        return new o(this.x, this.y, this.width, this.height, this.text, this.lineNumber, this.align);
    }, o.prototype.toArray = function() {
        return [
            this.x,
            this.y,
            this.width,
            this.height,
            this.text,
            this.lineNumber,
            this.align
        ];
    }, e.setHeaderFunction = function(t) {
        return i.call(this), this.internal.__cell__.headerFunction = "function" == typeof t ? t : void 0, this;
    }, e.getTextDimensions = function(t, e) {
        i.call(this);
        var n = (e = e || {}).fontSize || this.getFontSize(), r = e.font || this.getFont(), a = e.scaleFactor || this.internal.scaleFactor, o = 0, s = 0, u = 0, c = this;
        if (!Array.isArray(t) && "string" != typeof t) {
            if ("number" != typeof t) throw new Error("getTextDimensions expects text-parameter to be of type String or type Number or an Array of Strings.");
            t = String(t);
        }
        var l = e.maxWidth;
        l > 0 ? "string" == typeof t ? t = this.splitTextToSize(t, l) : "[object Array]" === Object.prototype.toString.call(t) && (t = t.reduce(function(t, e) {
            return t.concat(c.splitTextToSize(e, l));
        }, [])) : t = Array.isArray(t) ? t : [
            t
        ];
        for(var h = 0; h < t.length; h++)o < (u = this.getStringUnitWidth(t[h], {
            font: r
        }) * n) && (o = u);
        return 0 !== o && (s = t.length), {
            w: o /= a,
            h: Math.max((s * n * this.getLineHeightFactor() - n * (this.getLineHeightFactor() - 1)) / a, 0)
        };
    }, e.cellAddPage = function() {
        i.call(this), this.addPage();
        var t = this.internal.__cell__.margins || n;
        return this.internal.__cell__.lastCell = new o(t.left, t.top, void 0, void 0), this.internal.__cell__.pages += 1, this;
    };
    var s = e.cell = function() {
        var t;
        t = arguments[0] instanceof o ? arguments[0] : new o(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]), i.call(this);
        var e = this.internal.__cell__.lastCell, a = this.internal.__cell__.padding, s = this.internal.__cell__.margins || n, u = this.internal.__cell__.tableHeaderRow, c = this.internal.__cell__.printHeaders;
        return void 0 !== e.lineNumber && (e.lineNumber === t.lineNumber ? (t.x = (e.x || 0) + (e.width || 0), t.y = e.y || 0) : e.y + e.height + t.height + s.bottom > this.getPageHeight() ? (this.cellAddPage(), t.y = s.top, c && u && (this.printHeaderRow(t.lineNumber, !0), t.y += u[0].height)) : t.y = e.y + e.height || t.y), void 0 !== t.text[0] && (this.rect(t.x, t.y, t.width, t.height, !0 === r ? "FD" : void 0), "right" === t.align ? this.text(t.text, t.x + t.width - a, t.y + a, {
            align: "right",
            baseline: "top"
        }) : "center" === t.align ? this.text(t.text, t.x + t.width / 2, t.y + a, {
            align: "center",
            baseline: "top",
            maxWidth: t.width - a - a
        }) : this.text(t.text, t.x + a, t.y + a, {
            align: "left",
            baseline: "top",
            maxWidth: t.width - a - a
        })), this.internal.__cell__.lastCell = t, this;
    };
    e.table = function(e, r, c, l, h) {
        if (i.call(this), !c) throw new Error("No data for PDF table.");
        var f, d, p, g, m = [], v = [], b = [], y = {}, w = {}, N = [], L = [], x = (h = h || {}).autoSize || !1, A = !1 !== h.printHeaders, S = h.css && void 0 !== h.css["font-size"] ? 16 * h.css["font-size"] : h.fontSize || 12, _ = h.margins || Object.assign({
            width: this.getPageWidth()
        }, n), P = "number" == typeof h.padding ? h.padding : 3, k = h.headerBackgroundColor || "#c8c8c8", F = h.headerTextColor || "#000";
        if (a.call(this), this.internal.__cell__.printHeaders = A, this.internal.__cell__.margins = _, this.internal.__cell__.table_font_size = S, this.internal.__cell__.padding = P, this.internal.__cell__.headerBackgroundColor = k, this.internal.__cell__.headerTextColor = F, this.setFontSize(S), null == l) v = m = Object.keys(c[0]), b = m.map(function() {
            return "left";
        });
        else if (Array.isArray(l) && "object" === (0, _typeofDefault.default)(l[0])) for(m = l.map(function(t) {
            return t.name;
        }), v = l.map(function(t) {
            return t.prompt || t.name || "";
        }), b = l.map(function(t) {
            return t.align || "left";
        }), f = 0; f < l.length; f += 1)w[l[f].name] = .7499990551181103 * l[f].width;
        else Array.isArray(l) && "string" == typeof l[0] && (v = m = l, b = m.map(function() {
            return "left";
        }));
        if (x || Array.isArray(l) && "string" == typeof l[0]) for(f = 0; f < m.length; f += 1){
            for(y[g = m[f]] = c.map(function(t) {
                return t[g];
            }), this.setFont(void 0, "bold"), N.push(this.getTextDimensions(v[f], {
                fontSize: this.internal.__cell__.table_font_size,
                scaleFactor: this.internal.scaleFactor
            }).w), d = y[g], this.setFont(void 0, "normal"), p = 0; p < d.length; p += 1)N.push(this.getTextDimensions(d[p], {
                fontSize: this.internal.__cell__.table_font_size,
                scaleFactor: this.internal.scaleFactor
            }).w);
            w[g] = Math.max.apply(null, N) + P + P, N = [];
        }
        if (A) {
            var I = {};
            for(f = 0; f < m.length; f += 1)I[m[f]] = {}, I[m[f]].text = v[f], I[m[f]].align = b[f];
            var j = u.call(this, I, w);
            L = m.map(function(t) {
                return new o(e, r, w[t], j, I[t].text, void 0, I[t].align);
            }), this.setTableHeaderRow(L), this.printHeaderRow(1, !1);
        }
        var C = l.reduce(function(t, e) {
            return t[e.name] = e.align, t;
        }, {});
        for(f = 0; f < c.length; f += 1){
            "rowStart" in h && h.rowStart instanceof Function && h.rowStart({
                row: f,
                data: c[f]
            }, this);
            var O = u.call(this, c[f], w);
            for(p = 0; p < m.length; p += 1){
                var B = c[f][m[p]];
                "cellStart" in h && h.cellStart instanceof Function && h.cellStart({
                    row: f,
                    col: p,
                    data: B
                }, this), s.call(this, new o(e, r, w[m[p]], O, B, f + 2, C[m[p]]));
            }
        }
        return this.internal.__cell__.table_x = e, this.internal.__cell__.table_y = r, this;
    };
    var u = function(t, e) {
        var n = this.internal.__cell__.padding, r = this.internal.__cell__.table_font_size, i = this.internal.scaleFactor;
        return Object.keys(t).map(function(r) {
            var i = t[r];
            return this.splitTextToSize(i.hasOwnProperty("text") ? i.text : i, e[r] - n - n);
        }, this).map(function(t) {
            return this.getLineHeightFactor() * t.length * r / i + n + n;
        }, this).reduce(function(t, e) {
            return Math.max(t, e);
        }, 0);
    };
    e.setTableHeaderRow = function(t) {
        i.call(this), this.internal.__cell__.tableHeaderRow = t;
    }, e.printHeaderRow = function(t, e) {
        if (i.call(this), !this.internal.__cell__.tableHeaderRow) throw new Error("Property tableHeaderRow does not exist.");
        var n;
        if (r = !0, "function" == typeof this.internal.__cell__.headerFunction) {
            var a = this.internal.__cell__.headerFunction(this, this.internal.__cell__.pages);
            this.internal.__cell__.lastCell = new o(a[0], a[1], a[2], a[3], void 0, -1);
        }
        this.setFont(void 0, "bold");
        for(var u = [], c = 0; c < this.internal.__cell__.tableHeaderRow.length; c += 1){
            n = this.internal.__cell__.tableHeaderRow[c].clone(), e && (n.y = this.internal.__cell__.margins.top || 0, u.push(n)), n.lineNumber = t;
            var l = this.getTextColor();
            this.setTextColor(this.internal.__cell__.headerTextColor), this.setFillColor(this.internal.__cell__.headerBackgroundColor), s.call(this, n), this.setTextColor(l);
        }
        u.length > 0 && this.setTableHeaderRow(u), this.setFont(void 0, "normal"), r = !1;
    };
}(E.API);
var Pt = {
    italic: [
        "italic",
        "oblique",
        "normal"
    ],
    oblique: [
        "oblique",
        "italic",
        "normal"
    ],
    normal: [
        "normal",
        "oblique",
        "italic"
    ]
}, kt = [
    "ultra-condensed",
    "extra-condensed",
    "condensed",
    "semi-condensed",
    "normal",
    "semi-expanded",
    "expanded",
    "extra-expanded",
    "ultra-expanded"
], Ft = _t(kt), It = [
    100,
    200,
    300,
    400,
    500,
    600,
    700,
    800,
    900
], jt = _t(It);
function Ct(t) {
    var e = t.family.replace(/"|'/g, "").toLowerCase(), n = function(t) {
        return Pt[t = t || "normal"] ? t : "normal";
    }(t.style), r = function(t) {
        return t ? "number" == typeof t ? t >= 100 && t <= 900 && t % 100 == 0 ? t : 400 : /^\d00$/.test(t) ? parseInt(t) : "bold" === t ? 700 : 400 : 400;
    }(t.weight), i = function(t) {
        return "number" == typeof Ft[t = t || "normal"] ? t : "normal";
    }(t.stretch);
    return {
        family: e,
        style: n,
        weight: r,
        stretch: i,
        src: t.src || [],
        ref: t.ref || {
            name: e,
            style: [
                i,
                n,
                r
            ].join(" ")
        }
    };
}
function Ot(t, e, n, r) {
    var i;
    for(i = n; i >= 0 && i < e.length; i += r)if (t[e[i]]) return t[e[i]];
    for(i = n; i >= 0 && i < e.length; i -= r)if (t[e[i]]) return t[e[i]];
}
var Bt = {
    "sans-serif": "helvetica",
    fixed: "courier",
    monospace: "courier",
    terminal: "courier",
    cursive: "times",
    fantasy: "times",
    serif: "times"
}, Mt = {
    caption: "times",
    icon: "times",
    menu: "times",
    "message-box": "times",
    "small-caption": "times",
    "status-bar": "times"
};
function qt(t) {
    return [
        t.stretch,
        t.style,
        t.weight,
        t.family
    ].join(" ");
}
function Et(t) {
    return t.trimLeft();
}
function Rt(t, e) {
    for(var n = 0; n < t.length;){
        if (t.charAt(n) === e) return [
            t.substring(0, n),
            t.substring(n + 1)
        ];
        n += 1;
    }
    return null;
}
function Dt(t) {
    var e = t.match(/^(-[a-z_]|[a-z_])[a-z0-9_-]*/i);
    return null === e ? null : [
        e[0],
        t.substring(e[0].length)
    ];
}
var Tt, zt, Ut, Ht, Wt, Vt, Gt, Yt, Jt = [
    "times"
];
function Xt(t, n, r, i, a) {
    var o = 4, s = $t;
    switch(a){
        case E.API.image_compression.FAST:
            o = 1, s = Zt;
            break;
        case E.API.image_compression.MEDIUM:
            o = 6, s = Qt;
            break;
        case E.API.image_compression.SLOW:
            o = 9, s = te;
    }
    t = function(t, e, n, r) {
        for(var i, a = t.length / e, o = new Uint8Array(t.length + a), s = [
            Kt,
            Zt,
            $t,
            Qt,
            te
        ], u = 0; u < a; u += 1){
            var c = u * e, l = t.subarray(c, c + e);
            if (r) o.set(r(l, n, i), c + u);
            else {
                for(var h = s.length, f = [], d = 0; d < h; d += 1)f[d] = s[d](l, n, i);
                var p = ne(f.concat());
                o.set(f[p], c + u);
            }
            i = l;
        }
        return o;
    }(t, n, Math.ceil(r * i / 8), s);
    var u = (0, _fflate.zlibSync)(t, {
        level: o
    });
    return E.API.__addimage__.arrayBufferToBinaryString(u);
}
function Kt(t) {
    var e = Array.apply([], t);
    return e.unshift(0), e;
}
function Zt(t, e) {
    var n = t.length, r = [];
    r[0] = 1;
    for(var i = 0; i < n; i += 1){
        var a = t[i - e] || 0;
        r[i + 1] = t[i] - a + 256 & 255;
    }
    return r;
}
function $t(t, e, n) {
    var r = t.length, i = [];
    i[0] = 2;
    for(var a = 0; a < r; a += 1){
        var o = n && n[a] || 0;
        i[a + 1] = t[a] - o + 256 & 255;
    }
    return i;
}
function Qt(t, e, n) {
    var r = t.length, i = [];
    i[0] = 3;
    for(var a = 0; a < r; a += 1){
        var o = t[a - e] || 0, s = n && n[a] || 0;
        i[a + 1] = t[a] + 256 - (o + s >>> 1) & 255;
    }
    return i;
}
function te(t, e, n) {
    var r = t.length, i = [];
    i[0] = 4;
    for(var a = 0; a < r; a += 1){
        var o = ee(t[a - e] || 0, n && n[a] || 0, n && n[a - e] || 0);
        i[a + 1] = t[a] - o + 256 & 255;
    }
    return i;
}
function ee(t, e, n) {
    if (t === e && e === n) return t;
    var r = Math.abs(e - n), i = Math.abs(t - n), a = Math.abs(t + e - n - n);
    return r <= i && r <= a ? t : i <= a ? e : n;
}
function ne(t) {
    var e = t.map(function(t) {
        return t.reduce(function(t, e) {
            return t + Math.abs(e);
        }, 0);
    });
    return e.indexOf(Math.min.apply(null, e));
}
function re(t, e, n) {
    var r = e * n, i = Math.floor(r / 8), a = 16 - (r - 8 * i + n), o = (1 << n) - 1;
    return ae(t, i) >> a & o;
}
function ie(t, e, n, r) {
    var i = n * r, a = Math.floor(i / 8), o = 16 - (i - 8 * a + r), s = (1 << r) - 1, u = (e & s) << o;
    !function(t, e, n) {
        if (e + 1 < t.byteLength) t.setUint16(e, n, !1);
        else {
            var r = n >> 8 & 255;
            t.setUint8(e, r);
        }
    }(t, a, ae(t, a) & ~(s << o) & 65535 | u);
}
function ae(t, e) {
    return e + 1 < t.byteLength ? t.getUint16(e, !1) : t.getUint8(e) << 8;
}
function oe(t) {
    var e = 0;
    if (71 !== t[e++] || 73 !== t[e++] || 70 !== t[e++] || 56 !== t[e++] || 56 != (t[e++] + 1 & 253) || 97 !== t[e++]) throw new Error("Invalid GIF 87a/89a header.");
    var n = t[e++] | t[e++] << 8, r = t[e++] | t[e++] << 8, i = t[e++], a = i >> 7, o = 1 << 1 + (7 & i);
    t[e++], t[e++];
    var s = null, u = null;
    a && (s = e, u = o, e += 3 * o);
    var c = !0, l = [], h = 0, f = null, d = 0, p = null;
    for(this.width = n, this.height = r; c && e < t.length;)switch(t[e++]){
        case 33:
            switch(t[e++]){
                case 255:
                    if (11 !== t[e] || 78 == t[e + 1] && 69 == t[e + 2] && 84 == t[e + 3] && 83 == t[e + 4] && 67 == t[e + 5] && 65 == t[e + 6] && 80 == t[e + 7] && 69 == t[e + 8] && 50 == t[e + 9] && 46 == t[e + 10] && 48 == t[e + 11] && 3 == t[e + 12] && 1 == t[e + 13] && 0 == t[e + 16]) e += 14, p = t[e++] | t[e++] << 8, e++;
                    else for(e += 12;;){
                        if (!((P = t[e++]) >= 0)) throw Error("Invalid block size");
                        if (0 === P) break;
                        e += P;
                    }
                    break;
                case 249:
                    if (4 !== t[e++] || 0 !== t[e + 4]) throw new Error("Invalid graphics extension block.");
                    var g = t[e++];
                    h = t[e++] | t[e++] << 8, f = t[e++], 1 & g || (f = null), d = g >> 2 & 7, e++;
                    break;
                case 254:
                    for(;;){
                        if (!((P = t[e++]) >= 0)) throw Error("Invalid block size");
                        if (0 === P) break;
                        e += P;
                    }
                    break;
                default:
                    throw new Error("Unknown graphic control label: 0x" + t[e - 1].toString(16));
            }
            break;
        case 44:
            var m = t[e++] | t[e++] << 8, v = t[e++] | t[e++] << 8, b = t[e++] | t[e++] << 8, y = t[e++] | t[e++] << 8, w = t[e++], N = w >> 6 & 1, L = 1 << 1 + (7 & w), x = s, A = u, S = !1;
            w >> 7 && (S = !0, x = e, A = L, e += 3 * L);
            var _ = e;
            for(e++;;){
                var P;
                if (!((P = t[e++]) >= 0)) throw Error("Invalid block size");
                if (0 === P) break;
                e += P;
            }
            l.push({
                x: m,
                y: v,
                width: b,
                height: y,
                has_local_palette: S,
                palette_offset: x,
                palette_size: A,
                data_offset: _,
                data_length: e - _,
                transparent_index: f,
                interlaced: !!N,
                delay: h,
                disposal: d
            });
            break;
        case 59:
            c = !1;
            break;
        default:
            throw new Error("Unknown gif block: 0x" + t[e - 1].toString(16));
    }
    this.numFrames = function() {
        return l.length;
    }, this.loopCount = function() {
        return p;
    }, this.frameInfo = function(t) {
        if (t < 0 || t >= l.length) throw new Error("Frame index out of range.");
        return l[t];
    }, this.decodeAndBlitFrameBGRA = function(e, r) {
        var i = this.frameInfo(e), a = i.width * i.height, o = new Uint8Array(a);
        se(t, i.data_offset, o, a);
        var s = i.palette_offset, u = i.transparent_index;
        null === u && (u = 256);
        var c = i.width, l = n - c, h = c, f = 4 * (i.y * n + i.x), d = 4 * ((i.y + i.height) * n + i.x), p = f, g = 4 * l;
        !0 === i.interlaced && (g += 4 * n * 7);
        for(var m = 8, v = 0, b = o.length; v < b; ++v){
            var y = o[v];
            if (0 === h && (h = c, (p += g) >= d && (g = 4 * l + 4 * n * (m - 1), p = f + (c + l) * (m << 1), m >>= 1)), y === u) p += 4;
            else {
                var w = t[s + 3 * y], N = t[s + 3 * y + 1], L = t[s + 3 * y + 2];
                r[p++] = L, r[p++] = N, r[p++] = w, r[p++] = 255;
            }
            --h;
        }
    }, this.decodeAndBlitFrameRGBA = function(e, r) {
        var i = this.frameInfo(e), a = i.width * i.height, o = new Uint8Array(a);
        se(t, i.data_offset, o, a);
        var s = i.palette_offset, u = i.transparent_index;
        null === u && (u = 256);
        var c = i.width, l = n - c, h = c, f = 4 * (i.y * n + i.x), d = 4 * ((i.y + i.height) * n + i.x), p = f, g = 4 * l;
        !0 === i.interlaced && (g += 4 * n * 7);
        for(var m = 8, v = 0, b = o.length; v < b; ++v){
            var y = o[v];
            if (0 === h && (h = c, (p += g) >= d && (g = 4 * l + 4 * n * (m - 1), p = f + (c + l) * (m << 1), m >>= 1)), y === u) p += 4;
            else {
                var w = t[s + 3 * y], N = t[s + 3 * y + 1], L = t[s + 3 * y + 2];
                r[p++] = w, r[p++] = N, r[p++] = L, r[p++] = 255;
            }
            --h;
        }
    };
}
function se(t, e, n, r) {
    for(var i = t[e++], a = 1 << i, s = a + 1, u = s + 1, c = i + 1, l = (1 << c) - 1, h = 0, f = 0, d = 0, p = t[e++], g = new Int32Array(4096), m = null;;){
        for(; h < 16 && 0 !== p;)f |= t[e++] << h, h += 8, 1 === p ? p = t[e++] : --p;
        if (h < c) break;
        var v = f & l;
        if (f >>= c, h -= c, v !== a) {
            if (v === s) break;
            for(var b = v < u ? v : m, y = 0, w = b; w > a;)w = g[w] >> 8, ++y;
            var N = w;
            if (d + y + (b !== v ? 1 : 0) > r) return void o.log("Warning, gif stream longer than expected.");
            n[d++] = N;
            var L = d += y;
            for(b !== v && (n[d++] = N), w = b; y--;)w = g[w], n[--L] = 255 & w, w >>= 8;
            null !== m && u < 4096 && (g[u++] = m << 8 | N, u >= l + 1 && c < 12 && (++c, l = l << 1 | 1)), m = v;
        } else u = s + 1, l = (1 << (c = i + 1)) - 1, m = null;
    }
    return d !== r && o.log("Warning, gif stream shorter than expected."), n;
}
/**
 * @license
  Copyright (c) 2008, Adobe Systems Incorporated
  All rights reserved.

  Redistribution and use in source and binary forms, with or without 
  modification, are permitted provided that the following conditions are
  met:

  * Redistributions of source code must retain the above copyright notice, 
    this list of conditions and the following disclaimer.
  
  * Redistributions in binary form must reproduce the above copyright
    notice, this list of conditions and the following disclaimer in the 
    documentation and/or other materials provided with the distribution.
  
  * Neither the name of Adobe Systems Incorporated nor the names of its 
    contributors may be used to endorse or promote products derived from 
    this software without specific prior written permission.

  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS
  IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
  THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
  PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR 
  CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
  EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
  PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
  LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
  NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
  SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/ function ue(t) {
    var e, n, r, i, a, o = Math.floor, s = new Array(64), u = new Array(64), c = new Array(64), l = new Array(64), h = new Array(65535), f = new Array(65535), d = new Array(64), p = new Array(64), g = [], m = 0, v = 7, b = new Array(64), y = new Array(64), w = new Array(64), N = new Array(256), L = new Array(2048), x = [
        0,
        1,
        5,
        6,
        14,
        15,
        27,
        28,
        2,
        4,
        7,
        13,
        16,
        26,
        29,
        42,
        3,
        8,
        12,
        17,
        25,
        30,
        41,
        43,
        9,
        11,
        18,
        24,
        31,
        40,
        44,
        53,
        10,
        19,
        23,
        32,
        39,
        45,
        52,
        54,
        20,
        22,
        33,
        38,
        46,
        51,
        55,
        60,
        21,
        34,
        37,
        47,
        50,
        56,
        59,
        61,
        35,
        36,
        48,
        49,
        57,
        58,
        62,
        63
    ], A = [
        0,
        0,
        1,
        5,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ], S = [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11
    ], _ = [
        0,
        0,
        2,
        1,
        3,
        3,
        2,
        4,
        3,
        5,
        5,
        4,
        4,
        0,
        0,
        1,
        125
    ], P = [
        1,
        2,
        3,
        0,
        4,
        17,
        5,
        18,
        33,
        49,
        65,
        6,
        19,
        81,
        97,
        7,
        34,
        113,
        20,
        50,
        129,
        145,
        161,
        8,
        35,
        66,
        177,
        193,
        21,
        82,
        209,
        240,
        36,
        51,
        98,
        114,
        130,
        9,
        10,
        22,
        23,
        24,
        25,
        26,
        37,
        38,
        39,
        40,
        41,
        42,
        52,
        53,
        54,
        55,
        56,
        57,
        58,
        67,
        68,
        69,
        70,
        71,
        72,
        73,
        74,
        83,
        84,
        85,
        86,
        87,
        88,
        89,
        90,
        99,
        100,
        101,
        102,
        103,
        104,
        105,
        106,
        115,
        116,
        117,
        118,
        119,
        120,
        121,
        122,
        131,
        132,
        133,
        134,
        135,
        136,
        137,
        138,
        146,
        147,
        148,
        149,
        150,
        151,
        152,
        153,
        154,
        162,
        163,
        164,
        165,
        166,
        167,
        168,
        169,
        170,
        178,
        179,
        180,
        181,
        182,
        183,
        184,
        185,
        186,
        194,
        195,
        196,
        197,
        198,
        199,
        200,
        201,
        202,
        210,
        211,
        212,
        213,
        214,
        215,
        216,
        217,
        218,
        225,
        226,
        227,
        228,
        229,
        230,
        231,
        232,
        233,
        234,
        241,
        242,
        243,
        244,
        245,
        246,
        247,
        248,
        249,
        250
    ], k = [
        0,
        0,
        3,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0
    ], F = [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11
    ], I = [
        0,
        0,
        2,
        1,
        2,
        4,
        4,
        3,
        4,
        7,
        5,
        4,
        4,
        0,
        1,
        2,
        119
    ], j = [
        0,
        1,
        2,
        3,
        17,
        4,
        5,
        33,
        49,
        6,
        18,
        65,
        81,
        7,
        97,
        113,
        19,
        34,
        50,
        129,
        8,
        20,
        66,
        145,
        161,
        177,
        193,
        9,
        35,
        51,
        82,
        240,
        21,
        98,
        114,
        209,
        10,
        22,
        36,
        52,
        225,
        37,
        241,
        23,
        24,
        25,
        26,
        38,
        39,
        40,
        41,
        42,
        53,
        54,
        55,
        56,
        57,
        58,
        67,
        68,
        69,
        70,
        71,
        72,
        73,
        74,
        83,
        84,
        85,
        86,
        87,
        88,
        89,
        90,
        99,
        100,
        101,
        102,
        103,
        104,
        105,
        106,
        115,
        116,
        117,
        118,
        119,
        120,
        121,
        122,
        130,
        131,
        132,
        133,
        134,
        135,
        136,
        137,
        138,
        146,
        147,
        148,
        149,
        150,
        151,
        152,
        153,
        154,
        162,
        163,
        164,
        165,
        166,
        167,
        168,
        169,
        170,
        178,
        179,
        180,
        181,
        182,
        183,
        184,
        185,
        186,
        194,
        195,
        196,
        197,
        198,
        199,
        200,
        201,
        202,
        210,
        211,
        212,
        213,
        214,
        215,
        216,
        217,
        218,
        226,
        227,
        228,
        229,
        230,
        231,
        232,
        233,
        234,
        242,
        243,
        244,
        245,
        246,
        247,
        248,
        249,
        250
    ];
    function C(t, e) {
        for(var n = 0, r = 0, i = new Array, a = 1; a <= 16; a++){
            for(var o = 1; o <= t[a]; o++)i[e[r]] = [], i[e[r]][0] = n, i[e[r]][1] = a, r++, n++;
            n *= 2;
        }
        return i;
    }
    function O(t) {
        for(var e = t[0], n = t[1] - 1; n >= 0;)e & 1 << n && (m |= 1 << v), n--, --v < 0 && (255 == m ? (B(255), B(0)) : B(m), v = 7, m = 0);
    }
    function B(t) {
        g.push(t);
    }
    function M(t) {
        B(t >> 8 & 255), B(255 & t);
    }
    function q(t, e, n, r, i) {
        for(var a, o = i[0], s = i[240], u = function(t, e) {
            var n, r, i, a, o, s, u, c, l, h, f = 0;
            for(l = 0; l < 8; ++l){
                n = t[f], r = t[f + 1], i = t[f + 2], a = t[f + 3], o = t[f + 4], s = t[f + 5], u = t[f + 6];
                var p = n + (c = t[f + 7]), g = n - c, m = r + u, v = r - u, b = i + s, y = i - s, w = a + o, N = a - o, L = p + w, x = p - w, A = m + b, S = m - b;
                t[f] = L + A, t[f + 4] = L - A;
                var _ = .707106781 * (S + x);
                t[f + 2] = x + _, t[f + 6] = x - _;
                var P = .382683433 * ((L = N + y) - (S = v + g)), k = .5411961 * L + P, F = 1.306562965 * S + P, I = .707106781 * (A = y + v), j = g + I, C = g - I;
                t[f + 5] = C + k, t[f + 3] = C - k, t[f + 1] = j + F, t[f + 7] = j - F, f += 8;
            }
            for(f = 0, l = 0; l < 8; ++l){
                n = t[f], r = t[f + 8], i = t[f + 16], a = t[f + 24], o = t[f + 32], s = t[f + 40], u = t[f + 48];
                var O = n + (c = t[f + 56]), B = n - c, M = r + u, q = r - u, E = i + s, R = i - s, D = a + o, T = a - o, z = O + D, U = O - D, H = M + E, W = M - E;
                t[f] = z + H, t[f + 32] = z - H;
                var V = .707106781 * (W + U);
                t[f + 16] = U + V, t[f + 48] = U - V;
                var G = .382683433 * ((z = T + R) - (W = q + B)), Y = .5411961 * z + G, J = 1.306562965 * W + G, X = .707106781 * (H = R + q), K = B + X, Z = B - X;
                t[f + 40] = Z + Y, t[f + 24] = Z - Y, t[f + 8] = K + J, t[f + 56] = K - J, f++;
            }
            for(l = 0; l < 64; ++l)h = t[l] * e[l], d[l] = h > 0 ? h + .5 | 0 : h - .5 | 0;
            return d;
        }(t, e), c = 0; c < 64; ++c)p[x[c]] = u[c];
        var l = p[0] - n;
        n = p[0], 0 == l ? O(r[0]) : (O(r[f[a = 32767 + l]]), O(h[a]));
        for(var g = 63; g > 0 && 0 == p[g];)g--;
        if (0 == g) return O(o), n;
        for(var m, v = 1; v <= g;){
            for(var b = v; 0 == p[v] && v <= g;)++v;
            var y = v - b;
            if (y >= 16) {
                m = y >> 4;
                for(var w = 1; w <= m; ++w)O(s);
                y &= 15;
            }
            a = 32767 + p[v], O(i[(y << 4) + f[a]]), O(h[a]), v++;
        }
        return 63 != g && O(o), n;
    }
    function E(t) {
        t = Math.min(Math.max(t, 1), 100), a != t && (function(t) {
            for(var e = [
                16,
                11,
                10,
                16,
                24,
                40,
                51,
                61,
                12,
                12,
                14,
                19,
                26,
                58,
                60,
                55,
                14,
                13,
                16,
                24,
                40,
                57,
                69,
                56,
                14,
                17,
                22,
                29,
                51,
                87,
                80,
                62,
                18,
                22,
                37,
                56,
                68,
                109,
                103,
                77,
                24,
                35,
                55,
                64,
                81,
                104,
                113,
                92,
                49,
                64,
                78,
                87,
                103,
                121,
                120,
                101,
                72,
                92,
                95,
                98,
                112,
                100,
                103,
                99
            ], n = 0; n < 64; n++){
                var r = o((e[n] * t + 50) / 100);
                r = Math.min(Math.max(r, 1), 255), s[x[n]] = r;
            }
            for(var i = [
                17,
                18,
                24,
                47,
                99,
                99,
                99,
                99,
                18,
                21,
                26,
                66,
                99,
                99,
                99,
                99,
                24,
                26,
                56,
                99,
                99,
                99,
                99,
                99,
                47,
                66,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99
            ], a = 0; a < 64; a++){
                var h = o((i[a] * t + 50) / 100);
                h = Math.min(Math.max(h, 1), 255), u[x[a]] = h;
            }
            for(var f = [
                1,
                1.387039845,
                1.306562965,
                1.175875602,
                1,
                .785694958,
                .5411961,
                .275899379
            ], d = 0, p = 0; p < 8; p++)for(var g = 0; g < 8; g++)c[d] = 1 / (s[x[d]] * f[p] * f[g] * 8), l[d] = 1 / (u[x[d]] * f[p] * f[g] * 8), d++;
        }(t < 50 ? Math.floor(5e3 / t) : Math.floor(200 - 2 * t)), a = t);
    }
    this.encode = function(t, a) {
        a && E(a), g = new Array, m = 0, v = 7, M(65496), M(65504), M(16), B(74), B(70), B(73), B(70), B(0), B(1), B(1), B(0), M(1), M(1), B(0), B(0), function() {
            M(65499), M(132), B(0);
            for(var t = 0; t < 64; t++)B(s[t]);
            B(1);
            for(var e = 0; e < 64; e++)B(u[e]);
        }(), function(t, e) {
            M(65472), M(17), B(8), M(e), M(t), B(3), B(1), B(17), B(0), B(2), B(17), B(1), B(3), B(17), B(1);
        }(t.width, t.height), function() {
            M(65476), M(418), B(0);
            for(var t = 0; t < 16; t++)B(A[t + 1]);
            for(var e = 0; e <= 11; e++)B(S[e]);
            B(16);
            for(var n = 0; n < 16; n++)B(_[n + 1]);
            for(var r = 0; r <= 161; r++)B(P[r]);
            B(1);
            for(var i = 0; i < 16; i++)B(k[i + 1]);
            for(var a = 0; a <= 11; a++)B(F[a]);
            B(17);
            for(var o = 0; o < 16; o++)B(I[o + 1]);
            for(var s = 0; s <= 161; s++)B(j[s]);
        }(), M(65498), M(12), B(3), B(1), B(0), B(2), B(17), B(3), B(17), B(0), B(63), B(0);
        var o = 0, h = 0, f = 0;
        m = 0, v = 7, this.encode.displayName = "_encode_";
        for(var d, p, N, x, C, R, D, T, z, U = t.data, H = t.width, W = t.height, V = 4 * H, G = 0; G < W;){
            for(d = 0; d < V;){
                for(C = V * G + d, D = -1, T = 0, z = 0; z < 64; z++)R = C + (T = z >> 3) * V + (D = 4 * (7 & z)), G + T >= W && (R -= V * (G + 1 + T - W)), d + D >= V && (R -= d + D - V + 4), p = U[R++], N = U[R++], x = U[R++], b[z] = (L[p] + L[N + 256 | 0] + L[x + 512 | 0] >> 16) - 128, y[z] = (L[p + 768 | 0] + L[N + 1024 | 0] + L[x + 1280 | 0] >> 16) - 128, w[z] = (L[p + 1280 | 0] + L[N + 1536 | 0] + L[x + 1792 | 0] >> 16) - 128;
                o = q(b, c, o, e, r), h = q(y, l, h, n, i), f = q(w, l, f, n, i), d += 32;
            }
            G += 8;
        }
        if (v >= 0) {
            var Y = [];
            Y[1] = v + 1, Y[0] = (1 << v + 1) - 1, O(Y);
        }
        return M(65497), new Uint8Array(g);
    }, t = t || 50, function() {
        for(var t = String.fromCharCode, e = 0; e < 256; e++)N[e] = t(e);
    }(), e = C(A, S), n = C(k, F), r = C(_, P), i = C(I, j), function() {
        for(var t = 1, e = 2, n = 1; n <= 15; n++){
            for(var r = t; r < e; r++)f[32767 + r] = n, h[32767 + r] = [], h[32767 + r][1] = n, h[32767 + r][0] = r;
            for(var i = -(e - 1); i <= -t; i++)f[32767 + i] = n, h[32767 + i] = [], h[32767 + i][1] = n, h[32767 + i][0] = e - 1 + i;
            t <<= 1, e <<= 1;
        }
    }(), function() {
        for(var t = 0; t < 256; t++)L[t] = 19595 * t, L[t + 256 | 0] = 38470 * t, L[t + 512 | 0] = 7471 * t + 32768, L[t + 768 | 0] = -11059 * t, L[t + 1024 | 0] = -21709 * t, L[t + 1280 | 0] = 32768 * t + 8421375, L[t + 1536 | 0] = -27439 * t, L[t + 1792 | 0] = -5329 * t;
    }(), E(t);
}
/**
 * @license
 * Copyright (c) 2017 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function ce(t, e) {
    if (this.pos = 0, this.buffer = t, this.datav = new DataView(t.buffer), this.is_with_alpha = !!e, this.bottom_up = !0, this.flag = String.fromCharCode(this.buffer[0]) + String.fromCharCode(this.buffer[1]), this.pos += 2, -1 === [
        "BM",
        "BA",
        "CI",
        "CP",
        "IC",
        "PT"
    ].indexOf(this.flag)) throw new Error("Invalid BMP File");
    this.parseHeader(), this.parseBGR();
}
function le(t) {
    function e(t) {
        if (!t) throw Error("assert :P");
    }
    function n(t, e, n) {
        for(var r = 0; 4 > r; r++)if (t[e + r] != n.charCodeAt(r)) return !0;
        return !1;
    }
    function r(t, e, n, r, i) {
        for(var a = 0; a < i; a++)t[e + a] = n[r + a];
    }
    function i(t, e, n, r) {
        for(var i = 0; i < r; i++)t[e + i] = n;
    }
    function a(t) {
        return new Int32Array(t);
    }
    function o(t, e) {
        for(var n = [], r = 0; r < t; r++)n.push(new e);
        return n;
    }
    function s(t, e) {
        var n = [];
        return function t(n, r, i) {
            for(var a = i[r], o = 0; o < a && (n.push(i.length > r + 1 ? [] : new e), !(i.length < r + 1)); o++)t(n[o], r + 1, i);
        }(n, 0, t), n;
    }
    var u = function() {
        var t = this;
        function u(t, e) {
            for(var n = 1 << e - 1 >>> 0; t & n;)n >>>= 1;
            return n ? (t & n - 1) + n : t;
        }
        function c(t, n, r, i, a) {
            e(!(i % r));
            do t[n + (i -= r)] = a;
            while (0 < i);
        }
        function l(t, n, r, i, o) {
            if (e(2328 >= o), 512 >= o) var s = a(512);
            else if (null == (s = a(o))) return 0;
            return function(t, n, r, i, o, s) {
                var l, f, d = n, p = 1 << r, g = a(16), m = a(16);
                for(e(0 != o), e(null != i), e(null != t), e(0 < r), f = 0; f < o; ++f){
                    if (15 < i[f]) return 0;
                    ++g[i[f]];
                }
                if (g[0] == o) return 0;
                for(m[1] = 0, l = 1; 15 > l; ++l){
                    if (g[l] > 1 << l) return 0;
                    m[l + 1] = m[l] + g[l];
                }
                for(f = 0; f < o; ++f)l = i[f], 0 < i[f] && (s[m[l]++] = f);
                if (1 == m[15]) return (i = new h).g = 0, i.value = s[0], c(t, d, 1, p, i), p;
                var v, b = -1, y = p - 1, w = 0, N = 1, L = 1, x = 1 << r;
                for(f = 0, l = 1, o = 2; l <= r; ++l, o <<= 1){
                    if (N += L <<= 1, 0 > (L -= g[l])) return 0;
                    for(; 0 < g[l]; --g[l])(i = new h).g = l, i.value = s[f++], c(t, d + w, o, x, i), w = u(w, l);
                }
                for(l = r + 1, o = 2; 15 >= l; ++l, o <<= 1){
                    if (N += L <<= 1, 0 > (L -= g[l])) return 0;
                    for(; 0 < g[l]; --g[l]){
                        if (i = new h, (w & y) != b) {
                            for(d += x, v = 1 << (b = l) - r; 15 > b && !(0 >= (v -= g[b]));)++b, v <<= 1;
                            p += x = 1 << (v = b - r), t[n + (b = w & y)].g = v + r, t[n + b].value = d - n - b;
                        }
                        i.g = l - r, i.value = s[f++], c(t, d + (w >> r), o, x, i), w = u(w, l);
                    }
                }
                return N != 2 * m[15] - 1 ? 0 : p;
            }(t, n, r, i, o, s);
        }
        function h() {
            this.value = this.g = 0;
        }
        function f() {
            this.value = this.g = 0;
        }
        function d() {
            this.G = o(5, h), this.H = a(5), this.jc = this.Qb = this.qb = this.nd = 0, this.pd = o(Rn, f);
        }
        function p(t, n, r, i) {
            e(null != t), e(null != n), e(2147483648 > i), t.Ca = 254, t.I = 0, t.b = -8, t.Ka = 0, t.oa = n, t.pa = r, t.Jd = n, t.Yc = r + i, t.Zc = 4 <= i ? r + i - 4 + 1 : r, _(t);
        }
        function g(t, e) {
            for(var n = 0; 0 < e--;)n |= k(t, 128) << e;
            return n;
        }
        function m(t, e) {
            var n = g(t, e);
            return P(t) ? -n : n;
        }
        function v(t, n, r, i) {
            var a, o = 0;
            for(e(null != t), e(null != n), e(4294967288 > i), t.Sb = i, t.Ra = 0, t.u = 0, t.h = 0, 4 < i && (i = 4), a = 0; a < i; ++a)o += n[r + a] << 8 * a;
            t.Ra = o, t.bb = i, t.oa = n, t.pa = r;
        }
        function b(t) {
            for(; 8 <= t.u && t.bb < t.Sb;)t.Ra >>>= 8, t.Ra += t.oa[t.pa + t.bb] << zn - 8 >>> 0, ++t.bb, t.u -= 8;
            x(t) && (t.h = 1, t.u = 0);
        }
        function y(t, n) {
            if (e(0 <= n), !t.h && n <= Tn) {
                var r = L(t) & Dn[n];
                return t.u += n, b(t), r;
            }
            return t.h = 1, t.u = 0;
        }
        function w() {
            this.b = this.Ca = this.I = 0, this.oa = [], this.pa = 0, this.Jd = [], this.Yc = 0, this.Zc = [], this.Ka = 0;
        }
        function N() {
            this.Ra = 0, this.oa = [], this.h = this.u = this.bb = this.Sb = this.pa = 0;
        }
        function L(t) {
            return t.Ra >>> (t.u & zn - 1) >>> 0;
        }
        function x(t) {
            return e(t.bb <= t.Sb), t.h || t.bb == t.Sb && t.u > zn;
        }
        function A(t, e) {
            t.u = e, t.h = x(t);
        }
        function S(t) {
            t.u >= Un && (e(t.u >= Un), b(t));
        }
        function _(t) {
            e(null != t && null != t.oa), t.pa < t.Zc ? (t.I = (t.oa[t.pa++] | t.I << 8) >>> 0, t.b += 8) : (e(null != t && null != t.oa), t.pa < t.Yc ? (t.b += 8, t.I = t.oa[t.pa++] | t.I << 8) : t.Ka ? t.b = 0 : (t.I <<= 8, t.b += 8, t.Ka = 1));
        }
        function P(t) {
            return g(t, 1);
        }
        function k(t, e) {
            var n = t.Ca;
            0 > t.b && _(t);
            var r = t.b, i = n * e >>> 8, a = (t.I >>> r > i) + 0;
            for(a ? (n -= i, t.I -= i + 1 << r >>> 0) : n = i + 1, r = n, i = 0; 256 <= r;)i += 8, r >>= 8;
            return r = 7 ^ i + Hn[r], t.b -= r, t.Ca = (n << r) - 1, a;
        }
        function F(t, e, n) {
            t[e + 0] = n >> 24 & 255, t[e + 1] = n >> 16 & 255, t[e + 2] = n >> 8 & 255, t[e + 3] = 255 & n;
        }
        function I(t, e) {
            return t[e + 0] | t[e + 1] << 8;
        }
        function j(t, e) {
            return I(t, e) | t[e + 2] << 16;
        }
        function C(t, e) {
            return I(t, e) | I(t, e + 2) << 16;
        }
        function O(t, n) {
            var r = 1 << n;
            return e(null != t), e(0 < n), t.X = a(r), null == t.X ? 0 : (t.Mb = 32 - n, t.Xa = n, 1);
        }
        function B(t, n) {
            e(null != t), e(null != n), e(t.Xa == n.Xa), r(n.X, 0, t.X, 0, 1 << n.Xa);
        }
        function M() {
            this.X = [], this.Xa = this.Mb = 0;
        }
        function q(t, n, r, i) {
            e(null != r), e(null != i);
            var a = r[0], o = i[0];
            return 0 == a && (a = (t * o + n / 2) / n), 0 == o && (o = (n * a + t / 2) / t), 0 >= a || 0 >= o ? 0 : (r[0] = a, i[0] = o, 1);
        }
        function E(t, e) {
            return t + (1 << e) - 1 >>> e;
        }
        function R(t, e) {
            return ((4278255360 & t) + (4278255360 & e) >>> 0 & 4278255360) + ((16711935 & t) + (16711935 & e) >>> 0 & 16711935) >>> 0;
        }
        function D(e, n) {
            t[n] = function(n, r, i, a, o, s, u) {
                var c;
                for(c = 0; c < o; ++c){
                    var l = t[e](s[u + c - 1], i, a + c);
                    s[u + c] = R(n[r + c], l);
                }
            };
        }
        function T() {
            this.ud = this.hd = this.jd = 0;
        }
        function z(t, e) {
            return ((4278124286 & (t ^ e)) >>> 1) + (t & e) >>> 0;
        }
        function U(t) {
            return 0 <= t && 256 > t ? t : 0 > t ? 0 : 255 < t ? 255 : void 0;
        }
        function H(t, e) {
            return U(t + (t - e + .5 >> 1));
        }
        function W(t, e, n) {
            return Math.abs(e - n) - Math.abs(t - n);
        }
        function V(t, e, n, r, i, a, o) {
            for(r = a[o - 1], n = 0; n < i; ++n)a[o + n] = r = R(t[e + n], r);
        }
        function G(t, e, n, r, i) {
            var a;
            for(a = 0; a < n; ++a){
                var o = t[e + a], s = o >> 8 & 255, u = 16711935 & (u = (u = 16711935 & o) + ((s << 16) + s));
                r[i + a] = (4278255360 & o) + u >>> 0;
            }
        }
        function Y(t, e) {
            e.jd = 255 & t, e.hd = t >> 8 & 255, e.ud = t >> 16 & 255;
        }
        function J(t, e, n, r, i, a) {
            var o;
            for(o = 0; o < r; ++o){
                var s = e[n + o], u = s >>> 8, c = s, l = 255 & (l = (l = s >>> 16) + ((t.jd << 24 >> 24) * (u << 24 >> 24) >>> 5));
                c = 255 & (c = (c += (t.hd << 24 >> 24) * (u << 24 >> 24) >>> 5) + ((t.ud << 24 >> 24) * (l << 24 >> 24) >>> 5)), i[a + o] = (4278255360 & s) + (l << 16) + c;
            }
        }
        function X(e, n, r, i, a) {
            t[n] = function(t, e, n, r, o, s, u, c, l) {
                for(r = u; r < c; ++r)for(u = 0; u < l; ++u)o[s++] = a(n[i(t[e++])]);
            }, t[e] = function(e, n, o, s, u, c, l) {
                var h = 8 >> e.b, f = e.Ea, d = e.K[0], p = e.w;
                if (8 > h) for(e = (1 << e.b) - 1, p = (1 << h) - 1; n < o; ++n){
                    var g, m = 0;
                    for(g = 0; g < f; ++g)g & e || (m = i(s[u++])), c[l++] = a(d[m & p]), m >>= h;
                }
                else t["VP8LMapColor" + r](s, u, d, p, c, l, n, o, f);
            };
        }
        function K(t, e, n, r, i) {
            for(n = e + n; e < n;){
                var a = t[e++];
                r[i++] = a >> 16 & 255, r[i++] = a >> 8 & 255, r[i++] = 255 & a;
            }
        }
        function Z(t, e, n, r, i) {
            for(n = e + n; e < n;){
                var a = t[e++];
                r[i++] = a >> 16 & 255, r[i++] = a >> 8 & 255, r[i++] = 255 & a, r[i++] = a >> 24 & 255;
            }
        }
        function $(t, e, n, r, i) {
            for(n = e + n; e < n;){
                var a = (o = t[e++]) >> 16 & 240 | o >> 12 & 15, o = 240 & o | o >> 28 & 15;
                r[i++] = a, r[i++] = o;
            }
        }
        function Q(t, e, n, r, i) {
            for(n = e + n; e < n;){
                var a = (o = t[e++]) >> 16 & 248 | o >> 13 & 7, o = o >> 5 & 224 | o >> 3 & 31;
                r[i++] = a, r[i++] = o;
            }
        }
        function tt(t, e, n, r, i) {
            for(n = e + n; e < n;){
                var a = t[e++];
                r[i++] = 255 & a, r[i++] = a >> 8 & 255, r[i++] = a >> 16 & 255;
            }
        }
        function et(t, e, n, i, a, o) {
            if (0 == o) for(n = e + n; e < n;)F(i, ((o = t[e++])[0] >> 24 | o[1] >> 8 & 65280 | o[2] << 8 & 16711680 | o[3] << 24) >>> 0), a += 32;
            else r(i, a, t, e, n);
        }
        function nt(e, n) {
            t[n][0] = t[e + "0"], t[n][1] = t[e + "1"], t[n][2] = t[e + "2"], t[n][3] = t[e + "3"], t[n][4] = t[e + "4"], t[n][5] = t[e + "5"], t[n][6] = t[e + "6"], t[n][7] = t[e + "7"], t[n][8] = t[e + "8"], t[n][9] = t[e + "9"], t[n][10] = t[e + "10"], t[n][11] = t[e + "11"], t[n][12] = t[e + "12"], t[n][13] = t[e + "13"], t[n][14] = t[e + "0"], t[n][15] = t[e + "0"];
        }
        function rt(t) {
            return t == Ur || t == Hr || t == Wr || t == Vr;
        }
        function it() {
            this.eb = [], this.size = this.A = this.fb = 0;
        }
        function at() {
            this.y = [], this.f = [], this.ea = [], this.F = [], this.Tc = this.Ed = this.Cd = this.Fd = this.lb = this.Db = this.Ab = this.fa = this.J = this.W = this.N = this.O = 0;
        }
        function ot() {
            this.Rd = this.height = this.width = this.S = 0, this.f = {}, this.f.RGBA = new it, this.f.kb = new at, this.sd = null;
        }
        function st() {
            this.width = [
                0
            ], this.height = [
                0
            ], this.Pd = [
                0
            ], this.Qd = [
                0
            ], this.format = [
                0
            ];
        }
        function ut() {
            this.Id = this.fd = this.Md = this.hb = this.ib = this.da = this.bd = this.cd = this.j = this.v = this.Da = this.Sd = this.ob = 0;
        }
        function ct(t) {
            return alert("todo:WebPSamplerProcessPlane"), t.T;
        }
        function lt(t, e) {
            var n = t.T, i = e.ba.f.RGBA, a = i.eb, o = i.fb + t.ka * i.A, s = mi[e.ba.S], u = t.y, c = t.O, l = t.f, h = t.N, f = t.ea, d = t.W, p = e.cc, g = e.dc, m = e.Mc, v = e.Nc, b = t.ka, y = t.ka + t.T, w = t.U, N = w + 1 >> 1;
            for(0 == b ? s(u, c, null, null, l, h, f, d, l, h, f, d, a, o, null, null, w) : (s(e.ec, e.fc, u, c, p, g, m, v, l, h, f, d, a, o - i.A, a, o, w), ++n); b + 2 < y; b += 2)p = l, g = h, m = f, v = d, h += t.Rc, d += t.Rc, o += 2 * i.A, s(u, (c += 2 * t.fa) - t.fa, u, c, p, g, m, v, l, h, f, d, a, o - i.A, a, o, w);
            return c += t.fa, t.j + y < t.o ? (r(e.ec, e.fc, u, c, w), r(e.cc, e.dc, l, h, N), r(e.Mc, e.Nc, f, d, N), n--) : 1 & y || s(u, c, null, null, l, h, f, d, l, h, f, d, a, o + i.A, null, null, w), n;
        }
        function ht(t, n, r) {
            var i = t.F, a = [
                t.J
            ];
            if (null != i) {
                var o = t.U, s = n.ba.S, u = s == Dr || s == Wr;
                n = n.ba.f.RGBA;
                var c = [
                    0
                ], l = t.ka;
                c[0] = t.T, t.Kb && (0 == l ? --c[0] : (--l, a[0] -= t.width), t.j + t.ka + t.T == t.o && (c[0] = t.o - t.j - l));
                var h = n.eb;
                l = n.fb + l * n.A, t = Ar(i, a[0], t.width, o, c, h, l + (u ? 0 : 3), n.A), e(r == c), t && rt(s) && Lr(h, l, u, o, c, n.A);
            }
            return 0;
        }
        function ft(t) {
            var e = t.ma, n = e.ba.S, r = 11 > n, i = n == qr || n == Rr || n == Dr || n == Tr || 12 == n || rt(n);
            if (e.memory = null, e.Ib = null, e.Jb = null, e.Nd = null, !Mn(e.Oa, t, i ? 11 : 12)) return 0;
            if (i && rt(n) && bn(), t.da) alert("todo:use_scaling");
            else {
                if (r) {
                    if (e.Ib = ct, t.Kb) {
                        if (n = t.U + 1 >> 1, e.memory = a(t.U + 2 * n), null == e.memory) return 0;
                        e.ec = e.memory, e.fc = 0, e.cc = e.ec, e.dc = e.fc + t.U, e.Mc = e.cc, e.Nc = e.dc + n, e.Ib = lt, bn();
                    }
                } else alert("todo:EmitYUV");
                i && (e.Jb = ht, r && mn());
            }
            if (r && !Ii) {
                for(t = 0; 256 > t; ++t)ji[t] = 89858 * (t - 128) + Si >> Ai, Bi[t] = -22014 * (t - 128) + Si, Oi[t] = -45773 * (t - 128), Ci[t] = 113618 * (t - 128) + Si >> Ai;
                for(t = _i; t < Pi; ++t)e = 76283 * (t - 16) + Si >> Ai, Mi[t - _i] = Vt(e, 255), qi[t - _i] = Vt(e + 8 >> 4, 15);
                Ii = 1;
            }
            return 1;
        }
        function dt(t) {
            var n = t.ma, r = t.U, i = t.T;
            return e(!(1 & t.ka)), 0 >= r || 0 >= i ? 0 : (r = n.Ib(t, n), null != n.Jb && n.Jb(t, n, r), n.Dc += r, 1);
        }
        function pt(t) {
            t.ma.memory = null;
        }
        function gt(t, e, n, r) {
            return 47 != y(t, 8) ? 0 : (e[0] = y(t, 14) + 1, n[0] = y(t, 14) + 1, r[0] = y(t, 1), 0 != y(t, 3) ? 0 : !t.h);
        }
        function mt(t, e) {
            if (4 > t) return t + 1;
            var n = t - 2 >> 1;
            return (2 + (1 & t) << n) + y(e, n) + 1;
        }
        function vt(t, e) {
            var n;
            return 120 < e ? e - 120 : 1 <= (n = ((n = Zr[e - 1]) >> 4) * t + (8 - (15 & n))) ? n : 1;
        }
        function bt(t, e, n) {
            var r = L(n), i = t[e += 255 & r].g - 8;
            return 0 < i && (A(n, n.u + 8), r = L(n), e += t[e].value, e += r & (1 << i) - 1), A(n, n.u + t[e].g), t[e].value;
        }
        function yt(t, n, r) {
            return r.g += t.g, r.value += t.value << n >>> 0, e(8 >= r.g), t.g;
        }
        function wt(t, n, r) {
            var i = t.xc;
            return e((n = 0 == i ? 0 : t.vc[t.md * (r >> i) + (n >> i)]) < t.Wb), t.Ya[n];
        }
        function Nt(t, n, i, a) {
            var o = t.ab, s = t.c * n, u = t.C;
            n = u + n;
            var c = i, l = a;
            for(a = t.Ta, i = t.Ua; 0 < o--;){
                var h = t.gc[o], f = u, d = n, p = c, g = l, m = (l = a, c = i, h.Ea);
                switch(e(f < d), e(d <= h.nc), h.hc){
                    case 2:
                        Gn(p, g, (d - f) * m, l, c);
                        break;
                    case 0:
                        var v = f, b = d, y = l, w = c, N = (_ = h).Ea;
                        0 == v && (Wn(p, g, null, null, 1, y, w), V(p, g + 1, 0, 0, N - 1, y, w + 1), g += N, w += N, ++v);
                        for(var L = 1 << _.b, x = L - 1, A = E(N, _.b), S = _.K, _ = _.w + (v >> _.b) * A; v < b;){
                            var P = S, k = _, F = 1;
                            for(Vn(p, g, y, w - N, 1, y, w); F < N;){
                                var I = (F & ~x) + L;
                                I > N && (I = N), (0, Zn[P[k++] >> 8 & 15])(p, g + +F, y, w + F - N, I - F, y, w + F), F = I;
                            }
                            g += N, w += N, ++v & x || (_ += A);
                        }
                        d != h.nc && r(l, c - m, l, c + (d - f - 1) * m, m);
                        break;
                    case 1:
                        for(m = p, b = g, N = (p = h.Ea) - (w = p & ~(y = (g = 1 << h.b) - 1)), v = E(p, h.b), L = h.K, h = h.w + (f >> h.b) * v; f < d;){
                            for(x = L, A = h, S = new T, _ = b + w, P = b + p; b < _;)Y(x[A++], S), $n(S, m, b, g, l, c), b += g, c += g;
                            b < P && (Y(x[A++], S), $n(S, m, b, N, l, c), b += N, c += N), ++f & y || (h += v);
                        }
                        break;
                    case 3:
                        if (p == l && g == c && 0 < h.b) {
                            for(b = l, p = m = c + (d - f) * m - (w = (d - f) * E(h.Ea, h.b)), g = l, y = c, v = [], w = (N = w) - 1; 0 <= w; --w)v[w] = g[y + w];
                            for(w = N - 1; 0 <= w; --w)b[p + w] = v[w];
                            Yn(h, f, d, l, m, l, c);
                        } else Yn(h, f, d, p, g, l, c);
                }
                c = a, l = i;
            }
            l != i && r(a, i, c, l, s);
        }
        function Lt(t, n) {
            var r = t.V, i = t.Ba + t.c * t.C, a = n - t.C;
            if (e(n <= t.l.o), e(16 >= a), 0 < a) {
                var o = t.l, s = t.Ta, u = t.Ua, c = o.width;
                if (Nt(t, a, r, i), a = u = [
                    u
                ], e((r = t.C) < (i = n)), e(o.v < o.va), i > o.o && (i = o.o), r < o.j) {
                    var l = o.j - r;
                    r = o.j, a[0] += l * c;
                }
                if (r >= i ? r = 0 : (a[0] += 4 * o.v, o.ka = r - o.j, o.U = o.va - o.v, o.T = i - r, r = 1), r) {
                    if (u = u[0], 11 > (r = t.ca).S) {
                        var h = r.f.RGBA, f = (i = r.S, a = o.U, o = o.T, l = h.eb, h.A), d = o;
                        for(h = h.fb + t.Ma * h.A; 0 < d--;){
                            var p = s, g = u, m = a, v = l, b = h;
                            switch(i){
                                case Mr:
                                    Qn(p, g, m, v, b);
                                    break;
                                case qr:
                                    tr(p, g, m, v, b);
                                    break;
                                case Ur:
                                    tr(p, g, m, v, b), Lr(v, b, 0, m, 1, 0);
                                    break;
                                case Er:
                                    rr(p, g, m, v, b);
                                    break;
                                case Rr:
                                    et(p, g, m, v, b, 1);
                                    break;
                                case Hr:
                                    et(p, g, m, v, b, 1), Lr(v, b, 0, m, 1, 0);
                                    break;
                                case Dr:
                                    et(p, g, m, v, b, 0);
                                    break;
                                case Wr:
                                    et(p, g, m, v, b, 0), Lr(v, b, 1, m, 1, 0);
                                    break;
                                case Tr:
                                    er(p, g, m, v, b);
                                    break;
                                case Vr:
                                    er(p, g, m, v, b), xr(v, b, m, 1, 0);
                                    break;
                                case zr:
                                    nr(p, g, m, v, b);
                                    break;
                                default:
                                    e(0);
                            }
                            u += c, h += f;
                        }
                        t.Ma += o;
                    } else alert("todo:EmitRescaledRowsYUVA");
                    e(t.Ma <= r.height);
                }
            }
            t.C = n, e(t.C <= t.i);
        }
        function xt(t) {
            var e;
            if (0 < t.ua) return 0;
            for(e = 0; e < t.Wb; ++e){
                var n = t.Ya[e].G, r = t.Ya[e].H;
                if (0 < n[1][r[1] + 0].g || 0 < n[2][r[2] + 0].g || 0 < n[3][r[3] + 0].g) return 0;
            }
            return 1;
        }
        function At(t, n, r, i, a, o) {
            if (0 != t.Z) {
                var s = t.qd, u = t.rd;
                for(e(null != gi[t.Z]); n < r; ++n)gi[t.Z](s, u, i, a, i, a, o), s = i, u = a, a += o;
                t.qd = s, t.rd = u;
            }
        }
        function St(t, n) {
            var r = t.l.ma, i = 0 == r.Z || 1 == r.Z ? t.l.j : t.C;
            if (i = t.C < i ? i : t.C, e(n <= t.l.o), n > i) {
                var a = t.l.width, o = r.ca, s = r.tb + a * i, u = t.V, c = t.Ba + t.c * i, l = t.gc;
                e(1 == t.ab), e(3 == l[0].hc), Xn(l[0], i, n, u, c, o, s), At(r, i, n, o, s, a);
            }
            t.C = t.Ma = n;
        }
        function _t(t, n, r, i, a, o, s) {
            var u = t.$ / i, c = t.$ % i, l = t.m, h = t.s, f = r + t.$, d = f;
            a = r + i * a;
            var p = r + i * o, g = 280 + h.ua, m = t.Pb ? u : 16777216, v = 0 < h.ua ? h.Wa : null, b = h.wc, y = f < p ? wt(h, c, u) : null;
            e(t.C < o), e(p <= a);
            var w = !1;
            t: for(;;){
                for(; w || f < p;){
                    var N = 0;
                    if (u >= m) {
                        var _ = f - r;
                        e((m = t).Pb), m.wd = m.m, m.xd = _, 0 < m.s.ua && B(m.s.Wa, m.s.vb), m = u + Qr;
                    }
                    if (c & b || (y = wt(h, c, u)), e(null != y), y.Qb && (n[f] = y.qb, w = !0), !w) {
                        if (S(l), y.jc) {
                            N = l, _ = n;
                            var P = f, k = y.pd[L(N) & Rn - 1];
                            e(y.jc), 256 > k.g ? (A(N, N.u + k.g), _[P] = k.value, N = 0) : (A(N, N.u + k.g - 256), e(256 <= k.value), N = k.value), 0 == N && (w = !0);
                        } else N = bt(y.G[0], y.H[0], l);
                    }
                    if (l.h) break;
                    if (w || 256 > N) {
                        if (!w) {
                            if (y.nd) n[f] = (y.qb | N << 8) >>> 0;
                            else {
                                if (S(l), w = bt(y.G[1], y.H[1], l), S(l), _ = bt(y.G[2], y.H[2], l), P = bt(y.G[3], y.H[3], l), l.h) break;
                                n[f] = (P << 24 | w << 16 | N << 8 | _) >>> 0;
                            }
                        }
                        if (w = !1, ++f, ++c >= i && (c = 0, ++u, null != s && u <= o && !(u % 16) && s(t, u), null != v)) for(; d < f;)N = n[d++], v.X[(506832829 * N & 4294967295) >>> v.Mb] = N;
                    } else if (280 > N) {
                        if (N = mt(N - 256, l), _ = bt(y.G[4], y.H[4], l), S(l), _ = vt(i, _ = mt(_, l)), l.h) break;
                        if (f - r < _ || a - f < N) break t;
                        for(P = 0; P < N; ++P)n[f + P] = n[f + P - _];
                        for(f += N, c += N; c >= i;)c -= i, ++u, null != s && u <= o && !(u % 16) && s(t, u);
                        if (e(f <= a), c & b && (y = wt(h, c, u)), null != v) for(; d < f;)N = n[d++], v.X[(506832829 * N & 4294967295) >>> v.Mb] = N;
                    } else {
                        if (!(N < g)) break t;
                        for(w = N - 280, e(null != v); d < f;)N = n[d++], v.X[(506832829 * N & 4294967295) >>> v.Mb] = N;
                        N = f, e(!(w >>> (_ = v).Xa)), n[N] = _.X[w], w = !0;
                    }
                    w || e(l.h == x(l));
                }
                if (t.Pb && l.h && f < a) e(t.m.h), t.a = 5, t.m = t.wd, t.$ = t.xd, 0 < t.s.ua && B(t.s.vb, t.s.Wa);
                else {
                    if (l.h) break t;
                    null != s && s(t, u > o ? o : u), t.a = 0, t.$ = f - r;
                }
                return 1;
            }
            return t.a = 3, 0;
        }
        function Pt(t) {
            e(null != t), t.vc = null, t.yc = null, t.Ya = null;
            var n = t.Wa;
            null != n && (n.X = null), t.vb = null, e(null != t);
        }
        function kt() {
            var e = new on;
            return null == e ? null : (e.a = 0, e.xb = pi, nt("Predictor", "VP8LPredictors"), nt("Predictor", "VP8LPredictors_C"), nt("PredictorAdd", "VP8LPredictorsAdd"), nt("PredictorAdd", "VP8LPredictorsAdd_C"), Gn = G, $n = J, Qn = K, tr = Z, er = $, nr = Q, rr = tt, t.VP8LMapColor32b = Jn, t.VP8LMapColor8b = Kn, e);
        }
        function Ft(t, n, r, s, u) {
            var c = 1, f = [
                t
            ], p = [
                n
            ], g = s.m, m = s.s, v = null, b = 0;
            t: for(;;){
                if (r) for(; c && y(g, 1);){
                    var w = f, N = p, x = s, _ = 1, P = x.m, k = x.gc[x.ab], F = y(P, 2);
                    if (x.Oc & 1 << F) c = 0;
                    else {
                        switch(x.Oc |= 1 << F, k.hc = F, k.Ea = w[0], k.nc = N[0], k.K = [
                            null
                        ], ++x.ab, e(4 >= x.ab), F){
                            case 0:
                            case 1:
                                k.b = y(P, 3) + 2, _ = Ft(E(k.Ea, k.b), E(k.nc, k.b), 0, x, k.K), k.K = k.K[0];
                                break;
                            case 3:
                                var I, j = y(P, 8) + 1, C = 16 < j ? 0 : 4 < j ? 1 : 2 < j ? 2 : 3;
                                if (w[0] = E(k.Ea, C), k.b = C, I = _ = Ft(j, 1, 0, x, k.K)) {
                                    var B, M = j, q = k, D = 1 << (8 >> q.b), T = a(D);
                                    if (null == T) I = 0;
                                    else {
                                        var z = q.K[0], U = q.w;
                                        for(T[0] = q.K[0][0], B = 1; B < 1 * M; ++B)T[B] = R(z[U + B], T[B - 1]);
                                        for(; B < 4 * D; ++B)T[B] = 0;
                                        q.K[0] = null, q.K[0] = T, I = 1;
                                    }
                                }
                                _ = I;
                                break;
                            case 2:
                                break;
                            default:
                                e(0);
                        }
                        c = _;
                    }
                }
                if (f = f[0], p = p[0], c && y(g, 1) && !(c = 1 <= (b = y(g, 4)) && 11 >= b)) {
                    s.a = 3;
                    break t;
                }
                var H;
                if (H = c) e: {
                    var W, V, G, Y = s, J = f, X = p, K = b, Z = r, $ = Y.m, Q = Y.s, tt = [
                        null
                    ], et = 1, nt = 0, rt = $r[K];
                    n: for(;;){
                        if (Z && y($, 1)) {
                            var it = y($, 3) + 2, at = E(J, it), ot = E(X, it), st = at * ot;
                            if (!Ft(at, ot, 0, Y, tt)) break n;
                            for(tt = tt[0], Q.xc = it, W = 0; W < st; ++W){
                                var ut = tt[W] >> 8 & 65535;
                                tt[W] = ut, ut >= et && (et = ut + 1);
                            }
                        }
                        if ($.h) break n;
                        for(V = 0; 5 > V; ++V){
                            var ct = Jr[V];
                            !V && 0 < K && (ct += 1 << K), nt < ct && (nt = ct);
                        }
                        var lt = o(et * rt, h), ht = et, ft = o(ht, d);
                        if (null == ft) var dt = null;
                        else e(65536 >= ht), dt = ft;
                        var pt = a(nt);
                        if (null == dt || null == pt || null == lt) {
                            Y.a = 1;
                            break n;
                        }
                        var gt = lt;
                        for(W = G = 0; W < et; ++W){
                            var mt = dt[W], vt = mt.G, bt = mt.H, wt = 0, Nt = 1, Lt = 0;
                            for(V = 0; 5 > V; ++V){
                                ct = Jr[V], vt[V] = gt, bt[V] = G, !V && 0 < K && (ct += 1 << K);
                                r: {
                                    var xt, At = ct, St = Y, kt = pt, It = gt, jt = G, Ct = 0, Ot = St.m, Bt = y(Ot, 1);
                                    if (i(kt, 0, 0, At), Bt) {
                                        var Mt = y(Ot, 1) + 1, qt = y(Ot, 1), Et = y(Ot, 0 == qt ? 1 : 8);
                                        kt[Et] = 1, 2 == Mt && (kt[Et = y(Ot, 8)] = 1);
                                        var Rt = 1;
                                    } else {
                                        var Dt = a(19), Tt = y(Ot, 4) + 4;
                                        if (19 < Tt) {
                                            St.a = 3;
                                            var zt = 0;
                                            break r;
                                        }
                                        for(xt = 0; xt < Tt; ++xt)Dt[Kr[xt]] = y(Ot, 3);
                                        var Ut = void 0, Ht = void 0, Wt = St, Vt = Dt, Gt = At, Yt = kt, Jt = 0, Xt = Wt.m, Kt = 8, Zt = o(128, h);
                                        i: for(; l(Zt, 0, 7, Vt, 19);){
                                            if (y(Xt, 1)) {
                                                var $t = 2 + 2 * y(Xt, 3);
                                                if ((Ut = 2 + y(Xt, $t)) > Gt) break i;
                                            } else Ut = Gt;
                                            for(Ht = 0; Ht < Gt && Ut--;){
                                                S(Xt);
                                                var Qt = Zt[0 + (127 & L(Xt))];
                                                A(Xt, Xt.u + Qt.g);
                                                var te = Qt.value;
                                                if (16 > te) Yt[Ht++] = te, 0 != te && (Kt = te);
                                                else {
                                                    var ee = 16 == te, ne = te - 16, re = Yr[ne], ie = y(Xt, Gr[ne]) + re;
                                                    if (Ht + ie > Gt) break i;
                                                    for(var ae = ee ? Kt : 0; 0 < ie--;)Yt[Ht++] = ae;
                                                }
                                            }
                                            Jt = 1;
                                            break i;
                                        }
                                        Jt || (Wt.a = 3), Rt = Jt;
                                    }
                                    (Rt = Rt && !Ot.h) && (Ct = l(It, jt, 8, kt, At)), Rt && 0 != Ct ? zt = Ct : (St.a = 3, zt = 0);
                                }
                                if (0 == zt) break n;
                                if (Nt && 1 == Xr[V] && (Nt = 0 == gt[G].g), wt += gt[G].g, G += zt, 3 >= V) {
                                    var oe, se = pt[0];
                                    for(oe = 1; oe < ct; ++oe)pt[oe] > se && (se = pt[oe]);
                                    Lt += se;
                                }
                            }
                            if (mt.nd = Nt, mt.Qb = 0, Nt && (mt.qb = (vt[3][bt[3] + 0].value << 24 | vt[1][bt[1] + 0].value << 16 | vt[2][bt[2] + 0].value) >>> 0, 0 == wt && 256 > vt[0][bt[0] + 0].value && (mt.Qb = 1, mt.qb += vt[0][bt[0] + 0].value << 8)), mt.jc = !mt.Qb && 6 > Lt, mt.jc) {
                                var ue, ce = mt;
                                for(ue = 0; ue < Rn; ++ue){
                                    var le = ue, he = ce.pd[le], fe = ce.G[0][ce.H[0] + le];
                                    256 <= fe.value ? (he.g = fe.g + 256, he.value = fe.value) : (he.g = 0, he.value = 0, le >>= yt(fe, 8, he), le >>= yt(ce.G[1][ce.H[1] + le], 16, he), le >>= yt(ce.G[2][ce.H[2] + le], 0, he), yt(ce.G[3][ce.H[3] + le], 24, he));
                                }
                            }
                        }
                        Q.vc = tt, Q.Wb = et, Q.Ya = dt, Q.yc = lt, H = 1;
                        break e;
                    }
                    H = 0;
                }
                if (!(c = H)) {
                    s.a = 3;
                    break t;
                }
                if (0 < b) {
                    if (m.ua = 1 << b, !O(m.Wa, b)) {
                        s.a = 1, c = 0;
                        break t;
                    }
                } else m.ua = 0;
                var de = s, pe = f, ge = p, me = de.s, ve = me.xc;
                if (de.c = pe, de.i = ge, me.md = E(pe, ve), me.wc = 0 == ve ? -1 : (1 << ve) - 1, r) {
                    s.xb = di;
                    break t;
                }
                if (null == (v = a(f * p))) {
                    s.a = 1, c = 0;
                    break t;
                }
                c = (c = _t(s, v, 0, f, p, p, null)) && !g.h;
                break t;
            }
            return c ? (null != u ? u[0] = v : (e(null == v), e(r)), s.$ = 0, r || Pt(m)) : Pt(m), c;
        }
        function It(t, n) {
            var r = t.c * t.i, i = r + n + 16 * n;
            return e(t.c <= n), t.V = a(i), null == t.V ? (t.Ta = null, t.Ua = 0, t.a = 1, 0) : (t.Ta = t.V, t.Ua = t.Ba + r + n, 1);
        }
        function jt(t, n) {
            var r = t.C, i = n - r, a = t.V, o = t.Ba + t.c * r;
            for(e(n <= t.l.o); 0 < i;){
                var s = 16 < i ? 16 : i, u = t.l.ma, c = t.l.width, l = c * s, h = u.ca, f = u.tb + c * r, d = t.Ta, p = t.Ua;
                Nt(t, s, a, o), Sr(d, p, h, f, l), At(u, r, r + s, h, f, c), i -= s, a += s * t.c, r += s;
            }
            e(r == n), t.C = t.Ma = n;
        }
        function Ct() {
            this.ub = this.yd = this.td = this.Rb = 0;
        }
        function Ot() {
            this.Kd = this.Ld = this.Ud = this.Td = this.i = this.c = 0;
        }
        function Bt() {
            this.Fb = this.Bb = this.Cb = 0, this.Zb = a(4), this.Lb = a(4);
        }
        function Mt() {
            this.Yb = function() {
                var t = [];
                return function t(e, n, r) {
                    for(var i = r[n], a = 0; a < i && (e.push(r.length > n + 1 ? [] : 0), !(r.length < n + 1)); a++)t(e[a], n + 1, r);
                }(t, 0, [
                    3,
                    11
                ]), t;
            }();
        }
        function qt() {
            this.jb = a(3), this.Wc = s([
                4,
                8
            ], Mt), this.Xc = s([
                4,
                17
            ], Mt);
        }
        function Et() {
            this.Pc = this.wb = this.Tb = this.zd = 0, this.vd = new a(4), this.od = new a(4);
        }
        function Rt() {
            this.ld = this.La = this.dd = this.tc = 0;
        }
        function Dt() {
            this.Na = this.la = 0;
        }
        function Tt() {
            this.Sc = [
                0,
                0
            ], this.Eb = [
                0,
                0
            ], this.Qc = [
                0,
                0
            ], this.ia = this.lc = 0;
        }
        function zt() {
            this.ad = a(384), this.Za = 0, this.Ob = a(16), this.$b = this.Ad = this.ia = this.Gc = this.Hc = this.Dd = 0;
        }
        function Ut() {
            this.uc = this.M = this.Nb = 0, this.wa = Array(new Rt), this.Y = 0, this.ya = Array(new zt), this.aa = 0, this.l = new Gt;
        }
        function Ht() {
            this.y = a(16), this.f = a(8), this.ea = a(8);
        }
        function Wt() {
            this.cb = this.a = 0, this.sc = "", this.m = new w, this.Od = new Ct, this.Kc = new Ot, this.ed = new Et, this.Qa = new Bt, this.Ic = this.$c = this.Aa = 0, this.D = new Ut, this.Xb = this.Va = this.Hb = this.zb = this.yb = this.Ub = this.za = 0, this.Jc = o(8, w), this.ia = 0, this.pb = o(4, Tt), this.Pa = new qt, this.Bd = this.kc = 0, this.Ac = [], this.Bc = 0, this.zc = [
                0,
                0,
                0,
                0
            ], this.Gd = Array(new Ht), this.Hd = 0, this.rb = Array(new Dt), this.sb = 0, this.wa = Array(new Rt), this.Y = 0, this.oc = [], this.pc = 0, this.sa = [], this.ta = 0, this.qa = [], this.ra = 0, this.Ha = [], this.B = this.R = this.Ia = 0, this.Ec = [], this.M = this.ja = this.Vb = this.Fc = 0, this.ya = Array(new zt), this.L = this.aa = 0, this.gd = s([
                4,
                2
            ], Rt), this.ga = null, this.Fa = [], this.Cc = this.qc = this.P = 0, this.Gb = [], this.Uc = 0, this.mb = [], this.nb = 0, this.rc = [], this.Ga = this.Vc = 0;
        }
        function Vt(t, e) {
            return 0 > t ? 0 : t > e ? e : t;
        }
        function Gt() {
            this.T = this.U = this.ka = this.height = this.width = 0, this.y = [], this.f = [], this.ea = [], this.Rc = this.fa = this.W = this.N = this.O = 0, this.ma = "void", this.put = "VP8IoPutHook", this.ac = "VP8IoSetupHook", this.bc = "VP8IoTeardownHook", this.ha = this.Kb = 0, this.data = [], this.hb = this.ib = this.da = this.o = this.j = this.va = this.v = this.Da = this.ob = this.w = 0, this.F = [], this.J = 0;
        }
        function Yt() {
            var t = new Wt;
            return null != t && (t.a = 0, t.sc = "OK", t.cb = 0, t.Xb = 0, ni || (ni = Zt)), t;
        }
        function Jt(t, e, n) {
            return 0 == t.a && (t.a = e, t.sc = n, t.cb = 0), 0;
        }
        function Xt(t, e, n) {
            return 3 <= n && 157 == t[e + 0] && 1 == t[e + 1] && 42 == t[e + 2];
        }
        function Kt(t, n) {
            if (null == t) return 0;
            if (t.a = 0, t.sc = "OK", null == n) return Jt(t, 2, "null VP8Io passed to VP8GetHeaders()");
            var r = n.data, a = n.w, o = n.ha;
            if (4 > o) return Jt(t, 7, "Truncated header.");
            var s = r[a + 0] | r[a + 1] << 8 | r[a + 2] << 16, u = t.Od;
            if (u.Rb = !(1 & s), u.td = s >> 1 & 7, u.yd = s >> 4 & 1, u.ub = s >> 5, 3 < u.td) return Jt(t, 3, "Incorrect keyframe parameters.");
            if (!u.yd) return Jt(t, 4, "Frame not displayable.");
            a += 3, o -= 3;
            var c = t.Kc;
            if (u.Rb) {
                if (7 > o) return Jt(t, 7, "cannot parse picture header");
                if (!Xt(r, a, o)) return Jt(t, 3, "Bad code word");
                c.c = 16383 & (r[a + 4] << 8 | r[a + 3]), c.Td = r[a + 4] >> 6, c.i = 16383 & (r[a + 6] << 8 | r[a + 5]), c.Ud = r[a + 6] >> 6, a += 7, o -= 7, t.za = c.c + 15 >> 4, t.Ub = c.i + 15 >> 4, n.width = c.c, n.height = c.i, n.Da = 0, n.j = 0, n.v = 0, n.va = n.width, n.o = n.height, n.da = 0, n.ib = n.width, n.hb = n.height, n.U = n.width, n.T = n.height, i((s = t.Pa).jb, 0, 255, s.jb.length), e(null != (s = t.Qa)), s.Cb = 0, s.Bb = 0, s.Fb = 1, i(s.Zb, 0, 0, s.Zb.length), i(s.Lb, 0, 0, s.Lb);
            }
            if (u.ub > o) return Jt(t, 7, "bad partition length");
            p(s = t.m, r, a, u.ub), a += u.ub, o -= u.ub, u.Rb && (c.Ld = P(s), c.Kd = P(s)), c = t.Qa;
            var l, h = t.Pa;
            if (e(null != s), e(null != c), c.Cb = P(s), c.Cb) {
                if (c.Bb = P(s), P(s)) {
                    for(c.Fb = P(s), l = 0; 4 > l; ++l)c.Zb[l] = P(s) ? m(s, 7) : 0;
                    for(l = 0; 4 > l; ++l)c.Lb[l] = P(s) ? m(s, 6) : 0;
                }
                if (c.Bb) for(l = 0; 3 > l; ++l)h.jb[l] = P(s) ? g(s, 8) : 255;
            } else c.Bb = 0;
            if (s.Ka) return Jt(t, 3, "cannot parse segment header");
            if ((c = t.ed).zd = P(s), c.Tb = g(s, 6), c.wb = g(s, 3), c.Pc = P(s), c.Pc && P(s)) {
                for(h = 0; 4 > h; ++h)P(s) && (c.vd[h] = m(s, 6));
                for(h = 0; 4 > h; ++h)P(s) && (c.od[h] = m(s, 6));
            }
            if (t.L = 0 == c.Tb ? 0 : c.zd ? 1 : 2, s.Ka) return Jt(t, 3, "cannot parse filter header");
            var f = o;
            if (o = l = a, a = l + f, c = f, t.Xb = (1 << g(t.m, 2)) - 1, f < 3 * (h = t.Xb)) r = 7;
            else {
                for(l += 3 * h, c -= 3 * h, f = 0; f < h; ++f){
                    var d = r[o + 0] | r[o + 1] << 8 | r[o + 2] << 16;
                    d > c && (d = c), p(t.Jc[+f], r, l, d), l += d, c -= d, o += 3;
                }
                p(t.Jc[+h], r, l, c), r = l < a ? 0 : 5;
            }
            if (0 != r) return Jt(t, r, "cannot parse partitions");
            for(r = g(l = t.m, 7), o = P(l) ? m(l, 4) : 0, a = P(l) ? m(l, 4) : 0, c = P(l) ? m(l, 4) : 0, h = P(l) ? m(l, 4) : 0, l = P(l) ? m(l, 4) : 0, f = t.Qa, d = 0; 4 > d; ++d){
                if (f.Cb) {
                    var v = f.Zb[d];
                    f.Fb || (v += r);
                } else {
                    if (0 < d) {
                        t.pb[d] = t.pb[0];
                        continue;
                    }
                    v = r;
                }
                var b = t.pb[d];
                b.Sc[0] = ti[Vt(v + o, 127)], b.Sc[1] = ei[Vt(v + 0, 127)], b.Eb[0] = 2 * ti[Vt(v + a, 127)], b.Eb[1] = 101581 * ei[Vt(v + c, 127)] >> 16, 8 > b.Eb[1] && (b.Eb[1] = 8), b.Qc[0] = ti[Vt(v + h, 117)], b.Qc[1] = ei[Vt(v + l, 127)], b.lc = v + l;
            }
            if (!u.Rb) return Jt(t, 4, "Not a key frame.");
            for(P(s), u = t.Pa, r = 0; 4 > r; ++r){
                for(o = 0; 8 > o; ++o)for(a = 0; 3 > a; ++a)for(c = 0; 11 > c; ++c)h = k(s, ui[r][o][a][c]) ? g(s, 8) : oi[r][o][a][c], u.Wc[r][o].Yb[a][c] = h;
                for(o = 0; 17 > o; ++o)u.Xc[r][o] = u.Wc[r][ci[o]];
            }
            return t.kc = P(s), t.kc && (t.Bd = g(s, 8)), t.cb = 1;
        }
        function Zt(t, e, n, r, i, a, o) {
            var s = e[i].Yb[n];
            for(n = 0; 16 > i; ++i){
                if (!k(t, s[n + 0])) return i;
                for(; !k(t, s[n + 1]);)if (s = e[++i].Yb[0], n = 0, 16 == i) return 16;
                var u = e[i + 1].Yb;
                if (k(t, s[n + 2])) {
                    var c = t, l = 0;
                    if (k(c, (f = s)[(h = n) + 3])) {
                        if (k(c, f[h + 6])) {
                            for(s = 0, h = 2 * (l = k(c, f[h + 8])) + (f = k(c, f[h + 9 + l])), l = 0, f = ri[h]; f[s]; ++s)l += l + k(c, f[s]);
                            l += 3 + (8 << h);
                        } else k(c, f[h + 7]) ? (l = 7 + 2 * k(c, 165), l += k(c, 145)) : l = 5 + k(c, 159);
                    } else l = k(c, f[h + 4]) ? 3 + k(c, f[h + 5]) : 2;
                    s = u[2];
                } else l = 1, s = u[1];
                u = o + ii[i], 0 > (c = t).b && _(c);
                var h, f = c.b, d = (h = c.Ca >> 1) - (c.I >> f) >> 31;
                --c.b, c.Ca += d, c.Ca |= 1, c.I -= (h + 1 & d) << f, a[u] = ((l ^ d) - d) * r[(0 < i) + 0];
            }
            return 16;
        }
        function $t(t) {
            var e = t.rb[t.sb - 1];
            e.la = 0, e.Na = 0, i(t.zc, 0, 0, t.zc.length), t.ja = 0;
        }
        function Qt(t, e, n, r, i) {
            i = t[e + n + 32 * r] + (i >> 3), t[e + n + 32 * r] = -256 & i ? 0 > i ? 0 : 255 : i;
        }
        function te(t, e, n, r, i, a) {
            Qt(t, e, 0, n, r + i), Qt(t, e, 1, n, r + a), Qt(t, e, 2, n, r - a), Qt(t, e, 3, n, r - i);
        }
        function ee(t) {
            return (20091 * t >> 16) + t;
        }
        function ne(t, e, n, r) {
            var i, o = 0, s = a(16);
            for(i = 0; 4 > i; ++i){
                var u = t[e + 0] + t[e + 8], c = t[e + 0] - t[e + 8], l = (35468 * t[e + 4] >> 16) - ee(t[e + 12]), h = ee(t[e + 4]) + (35468 * t[e + 12] >> 16);
                s[o + 0] = u + h, s[o + 1] = c + l, s[o + 2] = c - l, s[o + 3] = u - h, o += 4, e++;
            }
            for(i = o = 0; 4 > i; ++i)u = (t = s[o + 0] + 4) + s[o + 8], c = t - s[o + 8], l = (35468 * s[o + 4] >> 16) - ee(s[o + 12]), Qt(n, r, 0, 0, u + (h = ee(s[o + 4]) + (35468 * s[o + 12] >> 16))), Qt(n, r, 1, 0, c + l), Qt(n, r, 2, 0, c - l), Qt(n, r, 3, 0, u - h), o++, r += 32;
        }
        function re(t, e, n, r) {
            var i = t[e + 0] + 4, a = 35468 * t[e + 4] >> 16, o = ee(t[e + 4]), s = 35468 * t[e + 1] >> 16;
            te(n, r, 0, i + o, t = ee(t[e + 1]), s), te(n, r, 1, i + a, t, s), te(n, r, 2, i - a, t, s), te(n, r, 3, i - o, t, s);
        }
        function ie(t, e, n, r, i) {
            ne(t, e, n, r), i && ne(t, e + 16, n, r + 4);
        }
        function ae(t, e, n, r) {
            ar(t, e + 0, n, r, 1), ar(t, e + 32, n, r + 128, 1);
        }
        function oe(t, e, n, r) {
            var i;
            for(t = t[e + 0] + 4, i = 0; 4 > i; ++i)for(e = 0; 4 > e; ++e)Qt(n, r, e, i, t);
        }
        function se(t, e, n, r) {
            t[e + 0] && ur(t, e + 0, n, r), t[e + 16] && ur(t, e + 16, n, r + 4), t[e + 32] && ur(t, e + 32, n, r + 128), t[e + 48] && ur(t, e + 48, n, r + 128 + 4);
        }
        function ue(t, e, n, r) {
            var i, o = a(16);
            for(i = 0; 4 > i; ++i){
                var s = t[e + 0 + i] + t[e + 12 + i], u = t[e + 4 + i] + t[e + 8 + i], c = t[e + 4 + i] - t[e + 8 + i], l = t[e + 0 + i] - t[e + 12 + i];
                o[0 + i] = s + u, o[8 + i] = s - u, o[4 + i] = l + c, o[12 + i] = l - c;
            }
            for(i = 0; 4 > i; ++i)s = (t = o[0 + 4 * i] + 3) + o[3 + 4 * i], u = o[1 + 4 * i] + o[2 + 4 * i], c = o[1 + 4 * i] - o[2 + 4 * i], l = t - o[3 + 4 * i], n[r + 0] = s + u >> 3, n[r + 16] = l + c >> 3, n[r + 32] = s - u >> 3, n[r + 48] = l - c >> 3, r += 64;
        }
        function ce(t, e, n) {
            var r, i = e - 32, a = Or, o = 255 - t[i - 1];
            for(r = 0; r < n; ++r){
                var s, u = a, c = o + t[e - 1];
                for(s = 0; s < n; ++s)t[e + s] = u[c + t[i + s]];
                e += 32;
            }
        }
        function le(t, e) {
            ce(t, e, 4);
        }
        function he(t, e) {
            ce(t, e, 8);
        }
        function fe(t, e) {
            ce(t, e, 16);
        }
        function de(t, e) {
            var n;
            for(n = 0; 16 > n; ++n)r(t, e + 32 * n, t, e - 32, 16);
        }
        function pe(t, e) {
            var n;
            for(n = 16; 0 < n; --n)i(t, e, t[e - 1], 16), e += 32;
        }
        function ge(t, e, n) {
            var r;
            for(r = 0; 16 > r; ++r)i(e, n + 32 * r, t, 16);
        }
        function me(t, e) {
            var n, r = 16;
            for(n = 0; 16 > n; ++n)r += t[e - 1 + 32 * n] + t[e + n - 32];
            ge(r >> 5, t, e);
        }
        function ve(t, e) {
            var n, r = 8;
            for(n = 0; 16 > n; ++n)r += t[e - 1 + 32 * n];
            ge(r >> 4, t, e);
        }
        function be(t, e) {
            var n, r = 8;
            for(n = 0; 16 > n; ++n)r += t[e + n - 32];
            ge(r >> 4, t, e);
        }
        function ye(t, e) {
            ge(128, t, e);
        }
        function we(t, e, n) {
            return t + 2 * e + n + 2 >> 2;
        }
        function Ne(t, e) {
            var n, i = e - 32;
            for(i = new Uint8Array([
                we(t[i - 1], t[i + 0], t[i + 1]),
                we(t[i + 0], t[i + 1], t[i + 2]),
                we(t[i + 1], t[i + 2], t[i + 3]),
                we(t[i + 2], t[i + 3], t[i + 4])
            ]), n = 0; 4 > n; ++n)r(t, e + 32 * n, i, 0, i.length);
        }
        function Le(t, e) {
            var n = t[e - 1], r = t[e - 1 + 32], i = t[e - 1 + 64], a = t[e - 1 + 96];
            F(t, e + 0, 16843009 * we(t[e - 1 - 32], n, r)), F(t, e + 32, 16843009 * we(n, r, i)), F(t, e + 64, 16843009 * we(r, i, a)), F(t, e + 96, 16843009 * we(i, a, a));
        }
        function xe(t, e) {
            var n, r = 4;
            for(n = 0; 4 > n; ++n)r += t[e + n - 32] + t[e - 1 + 32 * n];
            for(r >>= 3, n = 0; 4 > n; ++n)i(t, e + 32 * n, r, 4);
        }
        function Ae(t, e) {
            var n = t[e - 1 + 0], r = t[e - 1 + 32], i = t[e - 1 + 64], a = t[e - 1 - 32], o = t[e + 0 - 32], s = t[e + 1 - 32], u = t[e + 2 - 32], c = t[e + 3 - 32];
            t[e + 0 + 96] = we(r, i, t[e - 1 + 96]), t[e + 1 + 96] = t[e + 0 + 64] = we(n, r, i), t[e + 2 + 96] = t[e + 1 + 64] = t[e + 0 + 32] = we(a, n, r), t[e + 3 + 96] = t[e + 2 + 64] = t[e + 1 + 32] = t[e + 0 + 0] = we(o, a, n), t[e + 3 + 64] = t[e + 2 + 32] = t[e + 1 + 0] = we(s, o, a), t[e + 3 + 32] = t[e + 2 + 0] = we(u, s, o), t[e + 3 + 0] = we(c, u, s);
        }
        function Se(t, e) {
            var n = t[e + 1 - 32], r = t[e + 2 - 32], i = t[e + 3 - 32], a = t[e + 4 - 32], o = t[e + 5 - 32], s = t[e + 6 - 32], u = t[e + 7 - 32];
            t[e + 0 + 0] = we(t[e + 0 - 32], n, r), t[e + 1 + 0] = t[e + 0 + 32] = we(n, r, i), t[e + 2 + 0] = t[e + 1 + 32] = t[e + 0 + 64] = we(r, i, a), t[e + 3 + 0] = t[e + 2 + 32] = t[e + 1 + 64] = t[e + 0 + 96] = we(i, a, o), t[e + 3 + 32] = t[e + 2 + 64] = t[e + 1 + 96] = we(a, o, s), t[e + 3 + 64] = t[e + 2 + 96] = we(o, s, u), t[e + 3 + 96] = we(s, u, u);
        }
        function _e(t, e) {
            var n = t[e - 1 + 0], r = t[e - 1 + 32], i = t[e - 1 + 64], a = t[e - 1 - 32], o = t[e + 0 - 32], s = t[e + 1 - 32], u = t[e + 2 - 32], c = t[e + 3 - 32];
            t[e + 0 + 0] = t[e + 1 + 64] = a + o + 1 >> 1, t[e + 1 + 0] = t[e + 2 + 64] = o + s + 1 >> 1, t[e + 2 + 0] = t[e + 3 + 64] = s + u + 1 >> 1, t[e + 3 + 0] = u + c + 1 >> 1, t[e + 0 + 96] = we(i, r, n), t[e + 0 + 64] = we(r, n, a), t[e + 0 + 32] = t[e + 1 + 96] = we(n, a, o), t[e + 1 + 32] = t[e + 2 + 96] = we(a, o, s), t[e + 2 + 32] = t[e + 3 + 96] = we(o, s, u), t[e + 3 + 32] = we(s, u, c);
        }
        function Pe(t, e) {
            var n = t[e + 0 - 32], r = t[e + 1 - 32], i = t[e + 2 - 32], a = t[e + 3 - 32], o = t[e + 4 - 32], s = t[e + 5 - 32], u = t[e + 6 - 32], c = t[e + 7 - 32];
            t[e + 0 + 0] = n + r + 1 >> 1, t[e + 1 + 0] = t[e + 0 + 64] = r + i + 1 >> 1, t[e + 2 + 0] = t[e + 1 + 64] = i + a + 1 >> 1, t[e + 3 + 0] = t[e + 2 + 64] = a + o + 1 >> 1, t[e + 0 + 32] = we(n, r, i), t[e + 1 + 32] = t[e + 0 + 96] = we(r, i, a), t[e + 2 + 32] = t[e + 1 + 96] = we(i, a, o), t[e + 3 + 32] = t[e + 2 + 96] = we(a, o, s), t[e + 3 + 64] = we(o, s, u), t[e + 3 + 96] = we(s, u, c);
        }
        function ke(t, e) {
            var n = t[e - 1 + 0], r = t[e - 1 + 32], i = t[e - 1 + 64], a = t[e - 1 + 96];
            t[e + 0 + 0] = n + r + 1 >> 1, t[e + 2 + 0] = t[e + 0 + 32] = r + i + 1 >> 1, t[e + 2 + 32] = t[e + 0 + 64] = i + a + 1 >> 1, t[e + 1 + 0] = we(n, r, i), t[e + 3 + 0] = t[e + 1 + 32] = we(r, i, a), t[e + 3 + 32] = t[e + 1 + 64] = we(i, a, a), t[e + 3 + 64] = t[e + 2 + 64] = t[e + 0 + 96] = t[e + 1 + 96] = t[e + 2 + 96] = t[e + 3 + 96] = a;
        }
        function Fe(t, e) {
            var n = t[e - 1 + 0], r = t[e - 1 + 32], i = t[e - 1 + 64], a = t[e - 1 + 96], o = t[e - 1 - 32], s = t[e + 0 - 32], u = t[e + 1 - 32], c = t[e + 2 - 32];
            t[e + 0 + 0] = t[e + 2 + 32] = n + o + 1 >> 1, t[e + 0 + 32] = t[e + 2 + 64] = r + n + 1 >> 1, t[e + 0 + 64] = t[e + 2 + 96] = i + r + 1 >> 1, t[e + 0 + 96] = a + i + 1 >> 1, t[e + 3 + 0] = we(s, u, c), t[e + 2 + 0] = we(o, s, u), t[e + 1 + 0] = t[e + 3 + 32] = we(n, o, s), t[e + 1 + 32] = t[e + 3 + 64] = we(r, n, o), t[e + 1 + 64] = t[e + 3 + 96] = we(i, r, n), t[e + 1 + 96] = we(a, i, r);
        }
        function Ie(t, e) {
            var n;
            for(n = 0; 8 > n; ++n)r(t, e + 32 * n, t, e - 32, 8);
        }
        function je(t, e) {
            var n;
            for(n = 0; 8 > n; ++n)i(t, e, t[e - 1], 8), e += 32;
        }
        function Ce(t, e, n) {
            var r;
            for(r = 0; 8 > r; ++r)i(e, n + 32 * r, t, 8);
        }
        function Oe(t, e) {
            var n, r = 8;
            for(n = 0; 8 > n; ++n)r += t[e + n - 32] + t[e - 1 + 32 * n];
            Ce(r >> 4, t, e);
        }
        function Be(t, e) {
            var n, r = 4;
            for(n = 0; 8 > n; ++n)r += t[e + n - 32];
            Ce(r >> 3, t, e);
        }
        function Me(t, e) {
            var n, r = 4;
            for(n = 0; 8 > n; ++n)r += t[e - 1 + 32 * n];
            Ce(r >> 3, t, e);
        }
        function qe(t, e) {
            Ce(128, t, e);
        }
        function Ee(t, e, n) {
            var r = t[e - n], i = t[e + 0], a = 3 * (i - r) + jr[1020 + t[e - 2 * n] - t[e + n]], o = Cr[112 + (a + 4 >> 3)];
            t[e - n] = Or[255 + r + Cr[112 + (a + 3 >> 3)]], t[e + 0] = Or[255 + i - o];
        }
        function Re(t, e, n, r) {
            var i = t[e + 0], a = t[e + n];
            return Br[255 + t[e - 2 * n] - t[e - n]] > r || Br[255 + a - i] > r;
        }
        function De(t, e, n, r) {
            return 4 * Br[255 + t[e - n] - t[e + 0]] + Br[255 + t[e - 2 * n] - t[e + n]] <= r;
        }
        function Te(t, e, n, r, i) {
            var a = t[e - 3 * n], o = t[e - 2 * n], s = t[e - n], u = t[e + 0], c = t[e + n], l = t[e + 2 * n], h = t[e + 3 * n];
            return 4 * Br[255 + s - u] + Br[255 + o - c] > r ? 0 : Br[255 + t[e - 4 * n] - a] <= i && Br[255 + a - o] <= i && Br[255 + o - s] <= i && Br[255 + h - l] <= i && Br[255 + l - c] <= i && Br[255 + c - u] <= i;
        }
        function ze(t, e, n, r) {
            var i = 2 * r + 1;
            for(r = 0; 16 > r; ++r)De(t, e + r, n, i) && Ee(t, e + r, n);
        }
        function Ue(t, e, n, r) {
            var i = 2 * r + 1;
            for(r = 0; 16 > r; ++r)De(t, e + r * n, 1, i) && Ee(t, e + r * n, 1);
        }
        function He(t, e, n, r) {
            var i;
            for(i = 3; 0 < i; --i)ze(t, e += 4 * n, n, r);
        }
        function We(t, e, n, r) {
            var i;
            for(i = 3; 0 < i; --i)Ue(t, e += 4, n, r);
        }
        function Ve(t, e, n, r, i, a, o, s) {
            for(a = 2 * a + 1; 0 < i--;){
                if (Te(t, e, n, a, o)) {
                    if (Re(t, e, n, s)) Ee(t, e, n);
                    else {
                        var u = t, c = e, l = n, h = u[c - 2 * l], f = u[c - l], d = u[c + 0], p = u[c + l], g = u[c + 2 * l], m = 27 * (b = jr[1020 + 3 * (d - f) + jr[1020 + h - p]]) + 63 >> 7, v = 18 * b + 63 >> 7, b = 9 * b + 63 >> 7;
                        u[c - 3 * l] = Or[255 + u[c - 3 * l] + b], u[c - 2 * l] = Or[255 + h + v], u[c - l] = Or[255 + f + m], u[c + 0] = Or[255 + d - m], u[c + l] = Or[255 + p - v], u[c + 2 * l] = Or[255 + g - b];
                    }
                }
                e += r;
            }
        }
        function Ge(t, e, n, r, i, a, o, s) {
            for(a = 2 * a + 1; 0 < i--;){
                if (Te(t, e, n, a, o)) {
                    if (Re(t, e, n, s)) Ee(t, e, n);
                    else {
                        var u = t, c = e, l = n, h = u[c - l], f = u[c + 0], d = u[c + l], p = Cr[112 + (4 + (g = 3 * (f - h)) >> 3)], g = Cr[112 + (g + 3 >> 3)], m = p + 1 >> 1;
                        u[c - 2 * l] = Or[255 + u[c - 2 * l] + m], u[c - l] = Or[255 + h + g], u[c + 0] = Or[255 + f - p], u[c + l] = Or[255 + d - m];
                    }
                }
                e += r;
            }
        }
        function Ye(t, e, n, r, i, a) {
            Ve(t, e, n, 1, 16, r, i, a);
        }
        function Je(t, e, n, r, i, a) {
            Ve(t, e, 1, n, 16, r, i, a);
        }
        function Xe(t, e, n, r, i, a) {
            var o;
            for(o = 3; 0 < o; --o)Ge(t, e += 4 * n, n, 1, 16, r, i, a);
        }
        function Ke(t, e, n, r, i, a) {
            var o;
            for(o = 3; 0 < o; --o)Ge(t, e += 4, 1, n, 16, r, i, a);
        }
        function Ze(t, e, n, r, i, a, o, s) {
            Ve(t, e, i, 1, 8, a, o, s), Ve(n, r, i, 1, 8, a, o, s);
        }
        function $e(t, e, n, r, i, a, o, s) {
            Ve(t, e, 1, i, 8, a, o, s), Ve(n, r, 1, i, 8, a, o, s);
        }
        function Qe(t, e, n, r, i, a, o, s) {
            Ge(t, e + 4 * i, i, 1, 8, a, o, s), Ge(n, r + 4 * i, i, 1, 8, a, o, s);
        }
        function tn(t, e, n, r, i, a, o, s) {
            Ge(t, e + 4, 1, i, 8, a, o, s), Ge(n, r + 4, 1, i, 8, a, o, s);
        }
        function en() {
            this.ba = new ot, this.ec = [], this.cc = [], this.Mc = [], this.Dc = this.Nc = this.dc = this.fc = 0, this.Oa = new ut, this.memory = 0, this.Ib = "OutputFunc", this.Jb = "OutputAlphaFunc", this.Nd = "OutputRowFunc";
        }
        function nn() {
            this.data = [], this.offset = this.kd = this.ha = this.w = 0, this.na = [], this.xa = this.gb = this.Ja = this.Sa = this.P = 0;
        }
        function rn() {
            this.nc = this.Ea = this.b = this.hc = 0, this.K = [], this.w = 0;
        }
        function an() {
            this.ua = 0, this.Wa = new M, this.vb = new M, this.md = this.xc = this.wc = 0, this.vc = [], this.Wb = 0, this.Ya = new d, this.yc = new h;
        }
        function on() {
            this.xb = this.a = 0, this.l = new Gt, this.ca = new ot, this.V = [], this.Ba = 0, this.Ta = [], this.Ua = 0, this.m = new N, this.Pb = 0, this.wd = new N, this.Ma = this.$ = this.C = this.i = this.c = this.xd = 0, this.s = new an, this.ab = 0, this.gc = o(4, rn), this.Oc = 0;
        }
        function sn() {
            this.Lc = this.Z = this.$a = this.i = this.c = 0, this.l = new Gt, this.ic = 0, this.ca = [], this.tb = 0, this.qd = null, this.rd = 0;
        }
        function un(t, e, n, r, i, a, o) {
            for(t = null == t ? 0 : t[e + 0], e = 0; e < o; ++e)i[a + e] = t + n[r + e] & 255, t = i[a + e];
        }
        function cn(t, e, n, r, i, a, o) {
            var s;
            if (null == t) un(null, null, n, r, i, a, o);
            else for(s = 0; s < o; ++s)i[a + s] = t[e + s] + n[r + s] & 255;
        }
        function ln(t, e, n, r, i, a, o) {
            if (null == t) un(null, null, n, r, i, a, o);
            else {
                var s, u = t[e + 0], c = u, l = u;
                for(s = 0; s < o; ++s)c = l + (u = t[e + s]) - c, l = n[r + s] + (-256 & c ? 0 > c ? 0 : 255 : c) & 255, c = u, i[a + s] = l;
            }
        }
        function hn(t, n, i, o) {
            var s = n.width, u = n.o;
            if (e(null != t && null != n), 0 > i || 0 >= o || i + o > u) return null;
            if (!t.Cc) {
                if (null == t.ga) {
                    var c;
                    if (t.ga = new sn, (c = null == t.ga) || (c = n.width * n.o, e(0 == t.Gb.length), t.Gb = a(c), t.Uc = 0, null == t.Gb ? c = 0 : (t.mb = t.Gb, t.nb = t.Uc, t.rc = null, c = 1), c = !c), !c) {
                        c = t.ga;
                        var l = t.Fa, h = t.P, f = t.qc, d = t.mb, p = t.nb, g = h + 1, m = f - 1, b = c.l;
                        if (e(null != l && null != d && null != n), gi[0] = null, gi[1] = un, gi[2] = cn, gi[3] = ln, c.ca = d, c.tb = p, c.c = n.width, c.i = n.height, e(0 < c.c && 0 < c.i), 1 >= f) n = 0;
                        else if (c.$a = 3 & l[h + 0], c.Z = l[h + 0] >> 2 & 3, c.Lc = l[h + 0] >> 4 & 3, h = l[h + 0] >> 6 & 3, 0 > c.$a || 1 < c.$a || 4 <= c.Z || 1 < c.Lc || h) n = 0;
                        else if (b.put = dt, b.ac = ft, b.bc = pt, b.ma = c, b.width = n.width, b.height = n.height, b.Da = n.Da, b.v = n.v, b.va = n.va, b.j = n.j, b.o = n.o, c.$a) t: {
                            e(1 == c.$a), n = kt();
                            e: for(;;){
                                if (null == n) {
                                    n = 0;
                                    break t;
                                }
                                if (e(null != c), c.mc = n, n.c = c.c, n.i = c.i, n.l = c.l, n.l.ma = c, n.l.width = c.c, n.l.height = c.i, n.a = 0, v(n.m, l, g, m), !Ft(c.c, c.i, 1, n, null)) break e;
                                if (1 == n.ab && 3 == n.gc[0].hc && xt(n.s) ? (c.ic = 1, l = n.c * n.i, n.Ta = null, n.Ua = 0, n.V = a(l), n.Ba = 0, null == n.V ? (n.a = 1, n = 0) : n = 1) : (c.ic = 0, n = It(n, c.c)), !n) break e;
                                n = 1;
                                break t;
                            }
                            c.mc = null, n = 0;
                        }
                        else n = m >= c.c * c.i;
                        c = !n;
                    }
                    if (c) return null;
                    1 != t.ga.Lc ? t.Ga = 0 : o = u - i;
                }
                e(null != t.ga), e(i + o <= u);
                t: {
                    if (n = (l = t.ga).c, u = l.l.o, 0 == l.$a) {
                        if (g = t.rc, m = t.Vc, b = t.Fa, h = t.P + 1 + i * n, f = t.mb, d = t.nb + i * n, e(h <= t.P + t.qc), 0 != l.Z) for(e(null != gi[l.Z]), c = 0; c < o; ++c)gi[l.Z](g, m, b, h, f, d, n), g = f, m = d, d += n, h += n;
                        else for(c = 0; c < o; ++c)r(f, d, b, h, n), g = f, m = d, d += n, h += n;
                        t.rc = g, t.Vc = m;
                    } else {
                        if (e(null != l.mc), n = i + o, e(null != (c = l.mc)), e(n <= c.i), c.C >= n) n = 1;
                        else if (l.ic || mn(), l.ic) {
                            l = c.V, g = c.Ba, m = c.c;
                            var y = c.i, w = (b = 1, h = c.$ / m, f = c.$ % m, d = c.m, p = c.s, c.$), N = m * y, L = m * n, A = p.wc, _ = w < L ? wt(p, f, h) : null;
                            e(w <= N), e(n <= y), e(xt(p));
                            e: for(;;){
                                for(; !d.h && w < L;){
                                    if (f & A || (_ = wt(p, f, h)), e(null != _), S(d), 256 > (y = bt(_.G[0], _.H[0], d))) l[g + w] = y, ++w, ++f >= m && (f = 0, ++h <= n && !(h % 16) && St(c, h));
                                    else {
                                        if (!(280 > y)) {
                                            b = 0;
                                            break e;
                                        }
                                        y = mt(y - 256, d);
                                        var P, k = bt(_.G[4], _.H[4], d);
                                        if (S(d), !(w >= (k = vt(m, k = mt(k, d))) && N - w >= y)) {
                                            b = 0;
                                            break e;
                                        }
                                        for(P = 0; P < y; ++P)l[g + w + P] = l[g + w + P - k];
                                        for(w += y, f += y; f >= m;)f -= m, ++h <= n && !(h % 16) && St(c, h);
                                        w < L && f & A && (_ = wt(p, f, h));
                                    }
                                    e(d.h == x(d));
                                }
                                St(c, h > n ? n : h);
                                break e;
                            }
                            !b || d.h && w < N ? (b = 0, c.a = d.h ? 5 : 3) : c.$ = w, n = b;
                        } else n = _t(c, c.V, c.Ba, c.c, c.i, n, jt);
                        if (!n) {
                            o = 0;
                            break t;
                        }
                    }
                    i + o >= u && (t.Cc = 1), o = 1;
                }
                if (!o) return null;
                if (t.Cc && (null != (o = t.ga) && (o.mc = null), t.ga = null, 0 < t.Ga)) return alert("todo:WebPDequantizeLevels"), null;
            }
            return t.nb + i * s;
        }
        function fn(t, e, n, r, i, a) {
            for(; 0 < i--;){
                var o, s = t, u = e + (n ? 1 : 0), c = t, l = e + (n ? 0 : 3);
                for(o = 0; o < r; ++o){
                    var h = c[l + 4 * o];
                    255 != h && (h *= 32897, s[u + 4 * o + 0] = s[u + 4 * o + 0] * h >> 23, s[u + 4 * o + 1] = s[u + 4 * o + 1] * h >> 23, s[u + 4 * o + 2] = s[u + 4 * o + 2] * h >> 23);
                }
                e += a;
            }
        }
        function dn(t, e, n, r, i) {
            for(; 0 < r--;){
                var a;
                for(a = 0; a < n; ++a){
                    var o = t[e + 2 * a + 0], s = 15 & (c = t[e + 2 * a + 1]), u = 4369 * s, c = (240 & c | c >> 4) * u >> 16;
                    t[e + 2 * a + 0] = (240 & o | o >> 4) * u >> 16 & 240 | (15 & o | o << 4) * u >> 16 >> 4 & 15, t[e + 2 * a + 1] = 240 & c | s;
                }
                e += i;
            }
        }
        function pn(t, e, n, r, i, a, o, s) {
            var u, c, l = 255;
            for(c = 0; c < i; ++c){
                for(u = 0; u < r; ++u){
                    var h = t[e + u];
                    a[o + 4 * u] = h, l &= h;
                }
                e += n, o += s;
            }
            return 255 != l;
        }
        function gn(t, e, n, r, i) {
            var a;
            for(a = 0; a < i; ++a)n[r + a] = t[e + a] >> 8;
        }
        function mn() {
            Lr = fn, xr = dn, Ar = pn, Sr = gn;
        }
        function vn(n, r, i) {
            t[n] = function(t, n, a, o, s, u, c, l, h, f, d, p, g, m, v, b, y) {
                var w, N = y - 1 >> 1, L = s[u + 0] | c[l + 0] << 16, x = h[f + 0] | d[p + 0] << 16;
                e(null != t);
                var A = 3 * L + x + 131074 >> 2;
                for(r(t[n + 0], 255 & A, A >> 16, g, m), null != a && (A = 3 * x + L + 131074 >> 2, r(a[o + 0], 255 & A, A >> 16, v, b)), w = 1; w <= N; ++w){
                    var S = s[u + w] | c[l + w] << 16, _ = h[f + w] | d[p + w] << 16, P = L + S + x + _ + 524296, k = P + 2 * (S + x) >> 3;
                    A = k + L >> 1, L = (P = P + 2 * (L + _) >> 3) + S >> 1, r(t[n + 2 * w - 1], 255 & A, A >> 16, g, m + (2 * w - 1) * i), r(t[n + 2 * w - 0], 255 & L, L >> 16, g, m + (2 * w - 0) * i), null != a && (A = P + x >> 1, L = k + _ >> 1, r(a[o + 2 * w - 1], 255 & A, A >> 16, v, b + (2 * w - 1) * i), r(a[o + 2 * w + 0], 255 & L, L >> 16, v, b + (2 * w + 0) * i)), L = S, x = _;
                }
                1 & y || (A = 3 * L + x + 131074 >> 2, r(t[n + y - 1], 255 & A, A >> 16, g, m + (y - 1) * i), null != a && (A = 3 * x + L + 131074 >> 2, r(a[o + y - 1], 255 & A, A >> 16, v, b + (y - 1) * i)));
            };
        }
        function bn() {
            mi[Mr] = vi, mi[qr] = yi, mi[Er] = bi, mi[Rr] = wi, mi[Dr] = Ni, mi[Tr] = Li, mi[zr] = xi, mi[Ur] = yi, mi[Hr] = wi, mi[Wr] = Ni, mi[Vr] = Li;
        }
        function yn(t) {
            return t & ~Fi ? 0 > t ? 0 : 255 : t >> ki;
        }
        function wn(t, e) {
            return yn((19077 * t >> 8) + (26149 * e >> 8) - 14234);
        }
        function Nn(t, e, n) {
            return yn((19077 * t >> 8) - (6419 * e >> 8) - (13320 * n >> 8) + 8708);
        }
        function Ln(t, e) {
            return yn((19077 * t >> 8) + (33050 * e >> 8) - 17685);
        }
        function xn(t, e, n, r, i) {
            r[i + 0] = wn(t, n), r[i + 1] = Nn(t, e, n), r[i + 2] = Ln(t, e);
        }
        function An(t, e, n, r, i) {
            r[i + 0] = Ln(t, e), r[i + 1] = Nn(t, e, n), r[i + 2] = wn(t, n);
        }
        function Sn(t, e, n, r, i) {
            var a = Nn(t, e, n);
            e = a << 3 & 224 | Ln(t, e) >> 3, r[i + 0] = 248 & wn(t, n) | a >> 5, r[i + 1] = e;
        }
        function _n(t, e, n, r, i) {
            var a = 240 & Ln(t, e) | 15;
            r[i + 0] = 240 & wn(t, n) | Nn(t, e, n) >> 4, r[i + 1] = a;
        }
        function Pn(t, e, n, r, i) {
            r[i + 0] = 255, xn(t, e, n, r, i + 1);
        }
        function kn(t, e, n, r, i) {
            An(t, e, n, r, i), r[i + 3] = 255;
        }
        function Fn(t, e, n, r, i) {
            xn(t, e, n, r, i), r[i + 3] = 255;
        }
        function Vt(t, e) {
            return 0 > t ? 0 : t > e ? e : t;
        }
        function In(e, n, r) {
            t[e] = function(t, e, i, a, o, s, u, c, l) {
                for(var h = c + (-2 & l) * r; c != h;)n(t[e + 0], i[a + 0], o[s + 0], u, c), n(t[e + 1], i[a + 0], o[s + 0], u, c + r), e += 2, ++a, ++s, c += 2 * r;
                1 & l && n(t[e + 0], i[a + 0], o[s + 0], u, c);
            };
        }
        function jn(t, e, n) {
            return 0 == n ? 0 == t ? 0 == e ? 6 : 5 : 0 == e ? 4 : 0 : n;
        }
        function Cn(t, e, n, r, i) {
            switch(t >>> 30){
                case 3:
                    ar(e, n, r, i, 0);
                    break;
                case 2:
                    or(e, n, r, i);
                    break;
                case 1:
                    ur(e, n, r, i);
            }
        }
        function On(t, e) {
            var n, a, o = e.M, s = e.Nb, u = t.oc, c = t.pc + 40, l = t.oc, h = t.pc + 584, f = t.oc, d = t.pc + 600;
            for(n = 0; 16 > n; ++n)u[c + 32 * n - 1] = 129;
            for(n = 0; 8 > n; ++n)l[h + 32 * n - 1] = 129, f[d + 32 * n - 1] = 129;
            for(0 < o ? u[c - 1 - 32] = l[h - 1 - 32] = f[d - 1 - 32] = 129 : (i(u, c - 32 - 1, 127, 21), i(l, h - 32 - 1, 127, 9), i(f, d - 32 - 1, 127, 9)), a = 0; a < t.za; ++a){
                var p = e.ya[e.aa + a];
                if (0 < a) {
                    for(n = -1; 16 > n; ++n)r(u, c + 32 * n - 4, u, c + 32 * n + 12, 4);
                    for(n = -1; 8 > n; ++n)r(l, h + 32 * n - 4, l, h + 32 * n + 4, 4), r(f, d + 32 * n - 4, f, d + 32 * n + 4, 4);
                }
                var g = t.Gd, m = t.Hd + a, v = p.ad, b = p.Hc;
                if (0 < o && (r(u, c - 32, g[m].y, 0, 16), r(l, h - 32, g[m].f, 0, 8), r(f, d - 32, g[m].ea, 0, 8)), p.Za) {
                    var y = u, w = c - 32 + 16;
                    for(0 < o && (a >= t.za - 1 ? i(y, w, g[m].y[15], 4) : r(y, w, g[m + 1].y, 0, 4)), n = 0; 4 > n; n++)y[w + 128 + n] = y[w + 256 + n] = y[w + 384 + n] = y[w + 0 + n];
                    for(n = 0; 16 > n; ++n, b <<= 2)y = u, w = c + Ei[n], hi[p.Ob[n]](y, w), Cn(b, v, 16 * +n, y, w);
                } else if (y = jn(a, o, p.Ob[0]), li[y](u, c), 0 != b) for(n = 0; 16 > n; ++n, b <<= 2)Cn(b, v, 16 * +n, u, c + Ei[n]);
                for(n = p.Gc, y = jn(a, o, p.Dd), fi[y](l, h), fi[y](f, d), b = v, y = l, w = h, 255 & (p = 0 | n) && (170 & p ? sr(b, 256, y, w) : cr(b, 256, y, w)), p = f, b = d, 255 & (n >>= 8) && (170 & n ? sr(v, 320, p, b) : cr(v, 320, p, b)), o < t.Ub - 1 && (r(g[m].y, 0, u, c + 480, 16), r(g[m].f, 0, l, h + 224, 8), r(g[m].ea, 0, f, d + 224, 8)), n = 8 * s * t.B, g = t.sa, m = t.ta + 16 * a + 16 * s * t.R, v = t.qa, p = t.ra + 8 * a + n, b = t.Ha, y = t.Ia + 8 * a + n, n = 0; 16 > n; ++n)r(g, m + n * t.R, u, c + 32 * n, 16);
                for(n = 0; 8 > n; ++n)r(v, p + n * t.B, l, h + 32 * n, 8), r(b, y + n * t.B, f, d + 32 * n, 8);
            }
        }
        function Bn(t, r, i, a, o, s, u, c, l) {
            var h = [
                0
            ], f = [
                0
            ], d = 0, p = null != l ? l.kd : 0, g = null != l ? l : new nn;
            if (null == t || 12 > i) return 7;
            g.data = t, g.w = r, g.ha = i, r = [
                r
            ], i = [
                i
            ], g.gb = [
                g.gb
            ];
            t: {
                var m = r, b = i, y = g.gb;
                if (e(null != t), e(null != b), e(null != y), y[0] = 0, 12 <= b[0] && !n(t, m[0], "RIFF")) {
                    if (n(t, m[0] + 8, "WEBP")) {
                        y = 3;
                        break t;
                    }
                    var w = C(t, m[0] + 4);
                    if (12 > w || 4294967286 < w) {
                        y = 3;
                        break t;
                    }
                    if (p && w > b[0] - 8) {
                        y = 7;
                        break t;
                    }
                    y[0] = w, m[0] += 12, b[0] -= 12;
                }
                y = 0;
            }
            if (0 != y) return y;
            for(w = 0 < g.gb[0], i = i[0];;){
                t: {
                    var L = t;
                    b = r, y = i;
                    var x = h, A = f, S = m = [
                        0
                    ];
                    if ((k = d = [
                        d
                    ])[0] = 0, 8 > y[0]) y = 7;
                    else {
                        if (!n(L, b[0], "VP8X")) {
                            if (10 != C(L, b[0] + 4)) {
                                y = 3;
                                break t;
                            }
                            if (18 > y[0]) {
                                y = 7;
                                break t;
                            }
                            var _ = C(L, b[0] + 8), P = 1 + j(L, b[0] + 12);
                            if (2147483648 <= P * (L = 1 + j(L, b[0] + 15))) {
                                y = 3;
                                break t;
                            }
                            null != S && (S[0] = _), null != x && (x[0] = P), null != A && (A[0] = L), b[0] += 18, y[0] -= 18, k[0] = 1;
                        }
                        y = 0;
                    }
                }
                if (d = d[0], m = m[0], 0 != y) return y;
                if (b = !!(2 & m), !w && d) return 3;
                if (null != s && (s[0] = !!(16 & m)), null != u && (u[0] = b), null != c && (c[0] = 0), u = h[0], m = f[0], d && b && null == l) {
                    y = 0;
                    break;
                }
                if (4 > i) {
                    y = 7;
                    break;
                }
                if (w && d || !w && !d && !n(t, r[0], "ALPH")) {
                    i = [
                        i
                    ], g.na = [
                        g.na
                    ], g.P = [
                        g.P
                    ], g.Sa = [
                        g.Sa
                    ];
                    t: {
                        _ = t, y = r, w = i;
                        var k = g.gb;
                        x = g.na, A = g.P, S = g.Sa, P = 22, e(null != _), e(null != w), L = y[0];
                        var F = w[0];
                        for(e(null != x), e(null != S), x[0] = null, A[0] = null, S[0] = 0;;){
                            if (y[0] = L, w[0] = F, 8 > F) {
                                y = 7;
                                break t;
                            }
                            var I = C(_, L + 4);
                            if (4294967286 < I) {
                                y = 3;
                                break t;
                            }
                            var O = 8 + I + 1 & -2;
                            if (P += O, 0 < k && P > k) {
                                y = 3;
                                break t;
                            }
                            if (!n(_, L, "VP8 ") || !n(_, L, "VP8L")) {
                                y = 0;
                                break t;
                            }
                            if (F[0] < O) {
                                y = 7;
                                break t;
                            }
                            n(_, L, "ALPH") || (x[0] = _, A[0] = L + 8, S[0] = I), L += O, F -= O;
                        }
                    }
                    if (i = i[0], g.na = g.na[0], g.P = g.P[0], g.Sa = g.Sa[0], 0 != y) break;
                }
                i = [
                    i
                ], g.Ja = [
                    g.Ja
                ], g.xa = [
                    g.xa
                ];
                t: if (k = t, y = r, w = i, x = g.gb[0], A = g.Ja, S = g.xa, _ = y[0], L = !n(k, _, "VP8 "), P = !n(k, _, "VP8L"), e(null != k), e(null != w), e(null != A), e(null != S), 8 > w[0]) y = 7;
                else {
                    if (L || P) {
                        if (k = C(k, _ + 4), 12 <= x && k > x - 12) {
                            y = 3;
                            break t;
                        }
                        if (p && k > w[0] - 8) {
                            y = 7;
                            break t;
                        }
                        A[0] = k, y[0] += 8, w[0] -= 8, S[0] = P;
                    } else S[0] = 5 <= w[0] && 47 == k[_ + 0] && !(k[_ + 4] >> 5), A[0] = w[0];
                    y = 0;
                }
                if (i = i[0], g.Ja = g.Ja[0], g.xa = g.xa[0], r = r[0], 0 != y) break;
                if (4294967286 < g.Ja) return 3;
                if (null == c || b || (c[0] = g.xa ? 2 : 1), u = [
                    u
                ], m = [
                    m
                ], g.xa) {
                    if (5 > i) {
                        y = 7;
                        break;
                    }
                    c = u, p = m, b = s, null == t || 5 > i ? t = 0 : 5 <= i && 47 == t[r + 0] && !(t[r + 4] >> 5) ? (w = [
                        0
                    ], k = [
                        0
                    ], x = [
                        0
                    ], v(A = new N, t, r, i), gt(A, w, k, x) ? (null != c && (c[0] = w[0]), null != p && (p[0] = k[0]), null != b && (b[0] = x[0]), t = 1) : t = 0) : t = 0;
                } else {
                    if (10 > i) {
                        y = 7;
                        break;
                    }
                    c = m, null == t || 10 > i || !Xt(t, r + 3, i - 3) ? t = 0 : (p = t[r + 0] | t[r + 1] << 8 | t[r + 2] << 16, b = 16383 & (t[r + 7] << 8 | t[r + 6]), t = 16383 & (t[r + 9] << 8 | t[r + 8]), 1 & p || 3 < (p >> 1 & 7) || !(p >> 4 & 1) || p >> 5 >= g.Ja || !b || !t ? t = 0 : (u && (u[0] = b), c && (c[0] = t), t = 1));
                }
                if (!t) return 3;
                if (u = u[0], m = m[0], d && (h[0] != u || f[0] != m)) return 3;
                null != l && (l[0] = g, l.offset = r - l.w, e(4294967286 > r - l.w), e(l.offset == l.ha - i));
                break;
            }
            return 0 == y || 7 == y && d && null == l ? (null != s && (s[0] |= null != g.na && 0 < g.na.length), null != a && (a[0] = u), null != o && (o[0] = m), 0) : y;
        }
        function Mn(t, e, n) {
            var r = e.width, i = e.height, a = 0, o = 0, s = r, u = i;
            if (e.Da = null != t && 0 < t.Da, e.Da && (s = t.cd, u = t.bd, a = t.v, o = t.j, 11 > n || (a &= -2, o &= -2), 0 > a || 0 > o || 0 >= s || 0 >= u || a + s > r || o + u > i)) return 0;
            if (e.v = a, e.j = o, e.va = a + s, e.o = o + u, e.U = s, e.T = u, e.da = null != t && 0 < t.da, e.da) {
                if (!q(s, u, n = [
                    t.ib
                ], a = [
                    t.hb
                ])) return 0;
                e.ib = n[0], e.hb = a[0];
            }
            return e.ob = null != t && t.ob, e.Kb = null == t || !t.Sd, e.da && (e.ob = e.ib < 3 * r / 4 && e.hb < 3 * i / 4, e.Kb = 0), 1;
        }
        function qn(t) {
            if (null == t) return 2;
            if (11 > t.S) {
                var e = t.f.RGBA;
                e.fb += (t.height - 1) * e.A, e.A = -e.A;
            } else e = t.f.kb, t = t.height, e.O += (t - 1) * e.fa, e.fa = -e.fa, e.N += (t - 1 >> 1) * e.Ab, e.Ab = -e.Ab, e.W += (t - 1 >> 1) * e.Db, e.Db = -e.Db, null != e.F && (e.J += (t - 1) * e.lb, e.lb = -e.lb);
            return 0;
        }
        function En(t, e, n, r) {
            if (null == r || 0 >= t || 0 >= e) return 2;
            if (null != n) {
                if (n.Da) {
                    var i = n.cd, o = n.bd, s = -2 & n.v, u = -2 & n.j;
                    if (0 > s || 0 > u || 0 >= i || 0 >= o || s + i > t || u + o > e) return 2;
                    t = i, e = o;
                }
                if (n.da) {
                    if (!q(t, e, i = [
                        n.ib
                    ], o = [
                        n.hb
                    ])) return 2;
                    t = i[0], e = o[0];
                }
            }
            r.width = t, r.height = e;
            t: {
                var c = r.width, l = r.height;
                if (t = r.S, 0 >= c || 0 >= l || !(t >= Mr && 13 > t)) t = 2;
                else {
                    if (0 >= r.Rd && null == r.sd) {
                        s = o = i = e = 0;
                        var h = (u = c * zi[t]) * l;
                        if (11 > t || (o = (l + 1) / 2 * (e = (c + 1) / 2), 12 == t && (s = (i = c) * l)), null == (l = a(h + 2 * o + s))) {
                            t = 1;
                            break t;
                        }
                        r.sd = l, 11 > t ? ((c = r.f.RGBA).eb = l, c.fb = 0, c.A = u, c.size = h) : ((c = r.f.kb).y = l, c.O = 0, c.fa = u, c.Fd = h, c.f = l, c.N = 0 + h, c.Ab = e, c.Cd = o, c.ea = l, c.W = 0 + h + o, c.Db = e, c.Ed = o, 12 == t && (c.F = l, c.J = 0 + h + 2 * o), c.Tc = s, c.lb = i);
                    }
                    if (e = 1, i = r.S, o = r.width, s = r.height, i >= Mr && 13 > i) {
                        if (11 > i) t = r.f.RGBA, e &= (u = Math.abs(t.A)) * (s - 1) + o <= t.size, e &= u >= o * zi[i], e &= null != t.eb;
                        else {
                            t = r.f.kb, u = (o + 1) / 2, h = (s + 1) / 2, c = Math.abs(t.fa), l = Math.abs(t.Ab);
                            var f = Math.abs(t.Db), d = Math.abs(t.lb), p = d * (s - 1) + o;
                            e &= c * (s - 1) + o <= t.Fd, e &= l * (h - 1) + u <= t.Cd, e = (e &= f * (h - 1) + u <= t.Ed) & c >= o & l >= u & f >= u, e &= null != t.y, e &= null != t.f, e &= null != t.ea, 12 == i && (e &= d >= o, e &= p <= t.Tc, e &= null != t.F);
                        }
                    } else e = 0;
                    t = e ? 0 : 2;
                }
            }
            return 0 != t || null != n && n.fd && (t = qn(r)), t;
        }
        var Rn = 64, Dn = [
            0,
            1,
            3,
            7,
            15,
            31,
            63,
            127,
            255,
            511,
            1023,
            2047,
            4095,
            8191,
            16383,
            32767,
            65535,
            131071,
            262143,
            524287,
            1048575,
            2097151,
            4194303,
            8388607,
            16777215
        ], Tn = 24, zn = 32, Un = 8, Hn = [
            0,
            0,
            1,
            1,
            2,
            2,
            2,
            2,
            3,
            3,
            3,
            3,
            3,
            3,
            3,
            3,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7
        ];
        D("Predictor0", "PredictorAdd0"), t.Predictor0 = function() {
            return 4278190080;
        }, t.Predictor1 = function(t) {
            return t;
        }, t.Predictor2 = function(t, e, n) {
            return e[n + 0];
        }, t.Predictor3 = function(t, e, n) {
            return e[n + 1];
        }, t.Predictor4 = function(t, e, n) {
            return e[n - 1];
        }, t.Predictor5 = function(t, e, n) {
            return z(z(t, e[n + 1]), e[n + 0]);
        }, t.Predictor6 = function(t, e, n) {
            return z(t, e[n - 1]);
        }, t.Predictor7 = function(t, e, n) {
            return z(t, e[n + 0]);
        }, t.Predictor8 = function(t, e, n) {
            return z(e[n - 1], e[n + 0]);
        }, t.Predictor9 = function(t, e, n) {
            return z(e[n + 0], e[n + 1]);
        }, t.Predictor10 = function(t, e, n) {
            return z(z(t, e[n - 1]), z(e[n + 0], e[n + 1]));
        }, t.Predictor11 = function(t, e, n) {
            var r = e[n + 0];
            return 0 >= W(r >> 24 & 255, t >> 24 & 255, (e = e[n - 1]) >> 24 & 255) + W(r >> 16 & 255, t >> 16 & 255, e >> 16 & 255) + W(r >> 8 & 255, t >> 8 & 255, e >> 8 & 255) + W(255 & r, 255 & t, 255 & e) ? r : t;
        }, t.Predictor12 = function(t, e, n) {
            var r = e[n + 0];
            return (U((t >> 24 & 255) + (r >> 24 & 255) - ((e = e[n - 1]) >> 24 & 255)) << 24 | U((t >> 16 & 255) + (r >> 16 & 255) - (e >> 16 & 255)) << 16 | U((t >> 8 & 255) + (r >> 8 & 255) - (e >> 8 & 255)) << 8 | U((255 & t) + (255 & r) - (255 & e))) >>> 0;
        }, t.Predictor13 = function(t, e, n) {
            var r = e[n - 1];
            return (H((t = z(t, e[n + 0])) >> 24 & 255, r >> 24 & 255) << 24 | H(t >> 16 & 255, r >> 16 & 255) << 16 | H(t >> 8 & 255, r >> 8 & 255) << 8 | H(255 & t, 255 & r)) >>> 0;
        };
        var Wn = t.PredictorAdd0;
        t.PredictorAdd1 = V, D("Predictor2", "PredictorAdd2"), D("Predictor3", "PredictorAdd3"), D("Predictor4", "PredictorAdd4"), D("Predictor5", "PredictorAdd5"), D("Predictor6", "PredictorAdd6"), D("Predictor7", "PredictorAdd7"), D("Predictor8", "PredictorAdd8"), D("Predictor9", "PredictorAdd9"), D("Predictor10", "PredictorAdd10"), D("Predictor11", "PredictorAdd11"), D("Predictor12", "PredictorAdd12"), D("Predictor13", "PredictorAdd13");
        var Vn = t.PredictorAdd2;
        X("ColorIndexInverseTransform", "MapARGB", "32b", function(t) {
            return t >> 8 & 255;
        }, function(t) {
            return t;
        }), X("VP8LColorIndexInverseTransformAlpha", "MapAlpha", "8b", function(t) {
            return t;
        }, function(t) {
            return t >> 8 & 255;
        });
        var Gn, Yn = t.ColorIndexInverseTransform, Jn = t.MapARGB, Xn = t.VP8LColorIndexInverseTransformAlpha, Kn = t.MapAlpha, Zn = t.VP8LPredictorsAdd = [];
        Zn.length = 16, (t.VP8LPredictors = []).length = 16, (t.VP8LPredictorsAdd_C = []).length = 16, (t.VP8LPredictors_C = []).length = 16;
        var $n, Qn, tr, er, nr, rr, ir, ar, or, sr, ur, cr, lr, hr, fr, dr, pr, gr, mr, vr, br, yr, wr, Nr, Lr, xr, Ar, Sr, _r = a(511), Pr = a(2041), kr = a(225), Fr = a(767), Ir = 0, jr = Pr, Cr = kr, Or = Fr, Br = _r, Mr = 0, qr = 1, Er = 2, Rr = 3, Dr = 4, Tr = 5, zr = 6, Ur = 7, Hr = 8, Wr = 9, Vr = 10, Gr = [
            2,
            3,
            7
        ], Yr = [
            3,
            3,
            11
        ], Jr = [
            280,
            256,
            256,
            256,
            40
        ], Xr = [
            0,
            1,
            1,
            1,
            0
        ], Kr = [
            17,
            18,
            0,
            1,
            2,
            3,
            4,
            5,
            16,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15
        ], Zr = [
            24,
            7,
            23,
            25,
            40,
            6,
            39,
            41,
            22,
            26,
            38,
            42,
            56,
            5,
            55,
            57,
            21,
            27,
            54,
            58,
            37,
            43,
            72,
            4,
            71,
            73,
            20,
            28,
            53,
            59,
            70,
            74,
            36,
            44,
            88,
            69,
            75,
            52,
            60,
            3,
            87,
            89,
            19,
            29,
            86,
            90,
            35,
            45,
            68,
            76,
            85,
            91,
            51,
            61,
            104,
            2,
            103,
            105,
            18,
            30,
            102,
            106,
            34,
            46,
            84,
            92,
            67,
            77,
            101,
            107,
            50,
            62,
            120,
            1,
            119,
            121,
            83,
            93,
            17,
            31,
            100,
            108,
            66,
            78,
            118,
            122,
            33,
            47,
            117,
            123,
            49,
            63,
            99,
            109,
            82,
            94,
            0,
            116,
            124,
            65,
            79,
            16,
            32,
            98,
            110,
            48,
            115,
            125,
            81,
            95,
            64,
            114,
            126,
            97,
            111,
            80,
            113,
            127,
            96,
            112
        ], $r = [
            2954,
            2956,
            2958,
            2962,
            2970,
            2986,
            3018,
            3082,
            3212,
            3468,
            3980,
            5004
        ], Qr = 8, ti = [
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            10,
            11,
            12,
            13,
            14,
            15,
            16,
            17,
            17,
            18,
            19,
            20,
            20,
            21,
            21,
            22,
            22,
            23,
            23,
            24,
            25,
            25,
            26,
            27,
            28,
            29,
            30,
            31,
            32,
            33,
            34,
            35,
            36,
            37,
            37,
            38,
            39,
            40,
            41,
            42,
            43,
            44,
            45,
            46,
            46,
            47,
            48,
            49,
            50,
            51,
            52,
            53,
            54,
            55,
            56,
            57,
            58,
            59,
            60,
            61,
            62,
            63,
            64,
            65,
            66,
            67,
            68,
            69,
            70,
            71,
            72,
            73,
            74,
            75,
            76,
            76,
            77,
            78,
            79,
            80,
            81,
            82,
            83,
            84,
            85,
            86,
            87,
            88,
            89,
            91,
            93,
            95,
            96,
            98,
            100,
            101,
            102,
            104,
            106,
            108,
            110,
            112,
            114,
            116,
            118,
            122,
            124,
            126,
            128,
            130,
            132,
            134,
            136,
            138,
            140,
            143,
            145,
            148,
            151,
            154,
            157
        ], ei = [
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            16,
            17,
            18,
            19,
            20,
            21,
            22,
            23,
            24,
            25,
            26,
            27,
            28,
            29,
            30,
            31,
            32,
            33,
            34,
            35,
            36,
            37,
            38,
            39,
            40,
            41,
            42,
            43,
            44,
            45,
            46,
            47,
            48,
            49,
            50,
            51,
            52,
            53,
            54,
            55,
            56,
            57,
            58,
            60,
            62,
            64,
            66,
            68,
            70,
            72,
            74,
            76,
            78,
            80,
            82,
            84,
            86,
            88,
            90,
            92,
            94,
            96,
            98,
            100,
            102,
            104,
            106,
            108,
            110,
            112,
            114,
            116,
            119,
            122,
            125,
            128,
            131,
            134,
            137,
            140,
            143,
            146,
            149,
            152,
            155,
            158,
            161,
            164,
            167,
            170,
            173,
            177,
            181,
            185,
            189,
            193,
            197,
            201,
            205,
            209,
            213,
            217,
            221,
            225,
            229,
            234,
            239,
            245,
            249,
            254,
            259,
            264,
            269,
            274,
            279,
            284
        ], ni = null, ri = [
            [
                173,
                148,
                140,
                0
            ],
            [
                176,
                155,
                140,
                135,
                0
            ],
            [
                180,
                157,
                141,
                134,
                130,
                0
            ],
            [
                254,
                254,
                243,
                230,
                196,
                177,
                153,
                140,
                133,
                130,
                129,
                0
            ]
        ], ii = [
            0,
            1,
            4,
            8,
            5,
            2,
            3,
            6,
            9,
            12,
            13,
            10,
            7,
            11,
            14,
            15
        ], ai = [
            -0,
            1,
            -1,
            2,
            -2,
            3,
            4,
            6,
            -3,
            5,
            -4,
            -5,
            -6,
            7,
            -7,
            8,
            -8,
            -9
        ], oi = [
            [
                [
                    [
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        253,
                        136,
                        254,
                        255,
                        228,
                        219,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        189,
                        129,
                        242,
                        255,
                        227,
                        213,
                        255,
                        219,
                        128,
                        128,
                        128
                    ],
                    [
                        106,
                        126,
                        227,
                        252,
                        214,
                        209,
                        255,
                        255,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        98,
                        248,
                        255,
                        236,
                        226,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        181,
                        133,
                        238,
                        254,
                        221,
                        234,
                        255,
                        154,
                        128,
                        128,
                        128
                    ],
                    [
                        78,
                        134,
                        202,
                        247,
                        198,
                        180,
                        255,
                        219,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        185,
                        249,
                        255,
                        243,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        184,
                        150,
                        247,
                        255,
                        236,
                        224,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        77,
                        110,
                        216,
                        255,
                        236,
                        230,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        101,
                        251,
                        255,
                        241,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        170,
                        139,
                        241,
                        252,
                        236,
                        209,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        37,
                        116,
                        196,
                        243,
                        228,
                        255,
                        255,
                        255,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        204,
                        254,
                        255,
                        245,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        207,
                        160,
                        250,
                        255,
                        238,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        102,
                        103,
                        231,
                        255,
                        211,
                        171,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        152,
                        252,
                        255,
                        240,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        177,
                        135,
                        243,
                        255,
                        234,
                        225,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        80,
                        129,
                        211,
                        255,
                        194,
                        224,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        1,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        246,
                        1,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ]
            ],
            [
                [
                    [
                        198,
                        35,
                        237,
                        223,
                        193,
                        187,
                        162,
                        160,
                        145,
                        155,
                        62
                    ],
                    [
                        131,
                        45,
                        198,
                        221,
                        172,
                        176,
                        220,
                        157,
                        252,
                        221,
                        1
                    ],
                    [
                        68,
                        47,
                        146,
                        208,
                        149,
                        167,
                        221,
                        162,
                        255,
                        223,
                        128
                    ]
                ],
                [
                    [
                        1,
                        149,
                        241,
                        255,
                        221,
                        224,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        184,
                        141,
                        234,
                        253,
                        222,
                        220,
                        255,
                        199,
                        128,
                        128,
                        128
                    ],
                    [
                        81,
                        99,
                        181,
                        242,
                        176,
                        190,
                        249,
                        202,
                        255,
                        255,
                        128
                    ]
                ],
                [
                    [
                        1,
                        129,
                        232,
                        253,
                        214,
                        197,
                        242,
                        196,
                        255,
                        255,
                        128
                    ],
                    [
                        99,
                        121,
                        210,
                        250,
                        201,
                        198,
                        255,
                        202,
                        128,
                        128,
                        128
                    ],
                    [
                        23,
                        91,
                        163,
                        242,
                        170,
                        187,
                        247,
                        210,
                        255,
                        255,
                        128
                    ]
                ],
                [
                    [
                        1,
                        200,
                        246,
                        255,
                        234,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        109,
                        178,
                        241,
                        255,
                        231,
                        245,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        44,
                        130,
                        201,
                        253,
                        205,
                        192,
                        255,
                        255,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        132,
                        239,
                        251,
                        219,
                        209,
                        255,
                        165,
                        128,
                        128,
                        128
                    ],
                    [
                        94,
                        136,
                        225,
                        251,
                        218,
                        190,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        22,
                        100,
                        174,
                        245,
                        186,
                        161,
                        255,
                        199,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        182,
                        249,
                        255,
                        232,
                        235,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        124,
                        143,
                        241,
                        255,
                        227,
                        234,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        35,
                        77,
                        181,
                        251,
                        193,
                        211,
                        255,
                        205,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        157,
                        247,
                        255,
                        236,
                        231,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        121,
                        141,
                        235,
                        255,
                        225,
                        227,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        45,
                        99,
                        188,
                        251,
                        195,
                        217,
                        255,
                        224,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        1,
                        251,
                        255,
                        213,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        203,
                        1,
                        248,
                        255,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        137,
                        1,
                        177,
                        255,
                        224,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ]
            ],
            [
                [
                    [
                        253,
                        9,
                        248,
                        251,
                        207,
                        208,
                        255,
                        192,
                        128,
                        128,
                        128
                    ],
                    [
                        175,
                        13,
                        224,
                        243,
                        193,
                        185,
                        249,
                        198,
                        255,
                        255,
                        128
                    ],
                    [
                        73,
                        17,
                        171,
                        221,
                        161,
                        179,
                        236,
                        167,
                        255,
                        234,
                        128
                    ]
                ],
                [
                    [
                        1,
                        95,
                        247,
                        253,
                        212,
                        183,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        239,
                        90,
                        244,
                        250,
                        211,
                        209,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        155,
                        77,
                        195,
                        248,
                        188,
                        195,
                        255,
                        255,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        24,
                        239,
                        251,
                        218,
                        219,
                        255,
                        205,
                        128,
                        128,
                        128
                    ],
                    [
                        201,
                        51,
                        219,
                        255,
                        196,
                        186,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        69,
                        46,
                        190,
                        239,
                        201,
                        218,
                        255,
                        228,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        191,
                        251,
                        255,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        223,
                        165,
                        249,
                        255,
                        213,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        141,
                        124,
                        248,
                        255,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        16,
                        248,
                        255,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        190,
                        36,
                        230,
                        255,
                        236,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        149,
                        1,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        226,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        247,
                        192,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        240,
                        128,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        134,
                        252,
                        255,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        213,
                        62,
                        250,
                        255,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        55,
                        93,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ]
            ],
            [
                [
                    [
                        202,
                        24,
                        213,
                        235,
                        186,
                        191,
                        220,
                        160,
                        240,
                        175,
                        255
                    ],
                    [
                        126,
                        38,
                        182,
                        232,
                        169,
                        184,
                        228,
                        174,
                        255,
                        187,
                        128
                    ],
                    [
                        61,
                        46,
                        138,
                        219,
                        151,
                        178,
                        240,
                        170,
                        255,
                        216,
                        128
                    ]
                ],
                [
                    [
                        1,
                        112,
                        230,
                        250,
                        199,
                        191,
                        247,
                        159,
                        255,
                        255,
                        128
                    ],
                    [
                        166,
                        109,
                        228,
                        252,
                        211,
                        215,
                        255,
                        174,
                        128,
                        128,
                        128
                    ],
                    [
                        39,
                        77,
                        162,
                        232,
                        172,
                        180,
                        245,
                        178,
                        255,
                        255,
                        128
                    ]
                ],
                [
                    [
                        1,
                        52,
                        220,
                        246,
                        198,
                        199,
                        249,
                        220,
                        255,
                        255,
                        128
                    ],
                    [
                        124,
                        74,
                        191,
                        243,
                        183,
                        193,
                        250,
                        221,
                        255,
                        255,
                        128
                    ],
                    [
                        24,
                        71,
                        130,
                        219,
                        154,
                        170,
                        243,
                        182,
                        255,
                        255,
                        128
                    ]
                ],
                [
                    [
                        1,
                        182,
                        225,
                        249,
                        219,
                        240,
                        255,
                        224,
                        128,
                        128,
                        128
                    ],
                    [
                        149,
                        150,
                        226,
                        252,
                        216,
                        205,
                        255,
                        171,
                        128,
                        128,
                        128
                    ],
                    [
                        28,
                        108,
                        170,
                        242,
                        183,
                        194,
                        254,
                        223,
                        255,
                        255,
                        128
                    ]
                ],
                [
                    [
                        1,
                        81,
                        230,
                        252,
                        204,
                        203,
                        255,
                        192,
                        128,
                        128,
                        128
                    ],
                    [
                        123,
                        102,
                        209,
                        247,
                        188,
                        196,
                        255,
                        233,
                        128,
                        128,
                        128
                    ],
                    [
                        20,
                        95,
                        153,
                        243,
                        164,
                        173,
                        255,
                        203,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        222,
                        248,
                        255,
                        216,
                        213,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        168,
                        175,
                        246,
                        252,
                        235,
                        205,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        47,
                        116,
                        215,
                        255,
                        211,
                        212,
                        255,
                        255,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        121,
                        236,
                        253,
                        212,
                        214,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        141,
                        84,
                        213,
                        252,
                        201,
                        202,
                        255,
                        219,
                        128,
                        128,
                        128
                    ],
                    [
                        42,
                        80,
                        160,
                        240,
                        162,
                        185,
                        255,
                        205,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        1,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        244,
                        1,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        238,
                        1,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ]
            ]
        ], si = [
            [
                [
                    231,
                    120,
                    48,
                    89,
                    115,
                    113,
                    120,
                    152,
                    112
                ],
                [
                    152,
                    179,
                    64,
                    126,
                    170,
                    118,
                    46,
                    70,
                    95
                ],
                [
                    175,
                    69,
                    143,
                    80,
                    85,
                    82,
                    72,
                    155,
                    103
                ],
                [
                    56,
                    58,
                    10,
                    171,
                    218,
                    189,
                    17,
                    13,
                    152
                ],
                [
                    114,
                    26,
                    17,
                    163,
                    44,
                    195,
                    21,
                    10,
                    173
                ],
                [
                    121,
                    24,
                    80,
                    195,
                    26,
                    62,
                    44,
                    64,
                    85
                ],
                [
                    144,
                    71,
                    10,
                    38,
                    171,
                    213,
                    144,
                    34,
                    26
                ],
                [
                    170,
                    46,
                    55,
                    19,
                    136,
                    160,
                    33,
                    206,
                    71
                ],
                [
                    63,
                    20,
                    8,
                    114,
                    114,
                    208,
                    12,
                    9,
                    226
                ],
                [
                    81,
                    40,
                    11,
                    96,
                    182,
                    84,
                    29,
                    16,
                    36
                ]
            ],
            [
                [
                    134,
                    183,
                    89,
                    137,
                    98,
                    101,
                    106,
                    165,
                    148
                ],
                [
                    72,
                    187,
                    100,
                    130,
                    157,
                    111,
                    32,
                    75,
                    80
                ],
                [
                    66,
                    102,
                    167,
                    99,
                    74,
                    62,
                    40,
                    234,
                    128
                ],
                [
                    41,
                    53,
                    9,
                    178,
                    241,
                    141,
                    26,
                    8,
                    107
                ],
                [
                    74,
                    43,
                    26,
                    146,
                    73,
                    166,
                    49,
                    23,
                    157
                ],
                [
                    65,
                    38,
                    105,
                    160,
                    51,
                    52,
                    31,
                    115,
                    128
                ],
                [
                    104,
                    79,
                    12,
                    27,
                    217,
                    255,
                    87,
                    17,
                    7
                ],
                [
                    87,
                    68,
                    71,
                    44,
                    114,
                    51,
                    15,
                    186,
                    23
                ],
                [
                    47,
                    41,
                    14,
                    110,
                    182,
                    183,
                    21,
                    17,
                    194
                ],
                [
                    66,
                    45,
                    25,
                    102,
                    197,
                    189,
                    23,
                    18,
                    22
                ]
            ],
            [
                [
                    88,
                    88,
                    147,
                    150,
                    42,
                    46,
                    45,
                    196,
                    205
                ],
                [
                    43,
                    97,
                    183,
                    117,
                    85,
                    38,
                    35,
                    179,
                    61
                ],
                [
                    39,
                    53,
                    200,
                    87,
                    26,
                    21,
                    43,
                    232,
                    171
                ],
                [
                    56,
                    34,
                    51,
                    104,
                    114,
                    102,
                    29,
                    93,
                    77
                ],
                [
                    39,
                    28,
                    85,
                    171,
                    58,
                    165,
                    90,
                    98,
                    64
                ],
                [
                    34,
                    22,
                    116,
                    206,
                    23,
                    34,
                    43,
                    166,
                    73
                ],
                [
                    107,
                    54,
                    32,
                    26,
                    51,
                    1,
                    81,
                    43,
                    31
                ],
                [
                    68,
                    25,
                    106,
                    22,
                    64,
                    171,
                    36,
                    225,
                    114
                ],
                [
                    34,
                    19,
                    21,
                    102,
                    132,
                    188,
                    16,
                    76,
                    124
                ],
                [
                    62,
                    18,
                    78,
                    95,
                    85,
                    57,
                    50,
                    48,
                    51
                ]
            ],
            [
                [
                    193,
                    101,
                    35,
                    159,
                    215,
                    111,
                    89,
                    46,
                    111
                ],
                [
                    60,
                    148,
                    31,
                    172,
                    219,
                    228,
                    21,
                    18,
                    111
                ],
                [
                    112,
                    113,
                    77,
                    85,
                    179,
                    255,
                    38,
                    120,
                    114
                ],
                [
                    40,
                    42,
                    1,
                    196,
                    245,
                    209,
                    10,
                    25,
                    109
                ],
                [
                    88,
                    43,
                    29,
                    140,
                    166,
                    213,
                    37,
                    43,
                    154
                ],
                [
                    61,
                    63,
                    30,
                    155,
                    67,
                    45,
                    68,
                    1,
                    209
                ],
                [
                    100,
                    80,
                    8,
                    43,
                    154,
                    1,
                    51,
                    26,
                    71
                ],
                [
                    142,
                    78,
                    78,
                    16,
                    255,
                    128,
                    34,
                    197,
                    171
                ],
                [
                    41,
                    40,
                    5,
                    102,
                    211,
                    183,
                    4,
                    1,
                    221
                ],
                [
                    51,
                    50,
                    17,
                    168,
                    209,
                    192,
                    23,
                    25,
                    82
                ]
            ],
            [
                [
                    138,
                    31,
                    36,
                    171,
                    27,
                    166,
                    38,
                    44,
                    229
                ],
                [
                    67,
                    87,
                    58,
                    169,
                    82,
                    115,
                    26,
                    59,
                    179
                ],
                [
                    63,
                    59,
                    90,
                    180,
                    59,
                    166,
                    93,
                    73,
                    154
                ],
                [
                    40,
                    40,
                    21,
                    116,
                    143,
                    209,
                    34,
                    39,
                    175
                ],
                [
                    47,
                    15,
                    16,
                    183,
                    34,
                    223,
                    49,
                    45,
                    183
                ],
                [
                    46,
                    17,
                    33,
                    183,
                    6,
                    98,
                    15,
                    32,
                    183
                ],
                [
                    57,
                    46,
                    22,
                    24,
                    128,
                    1,
                    54,
                    17,
                    37
                ],
                [
                    65,
                    32,
                    73,
                    115,
                    28,
                    128,
                    23,
                    128,
                    205
                ],
                [
                    40,
                    3,
                    9,
                    115,
                    51,
                    192,
                    18,
                    6,
                    223
                ],
                [
                    87,
                    37,
                    9,
                    115,
                    59,
                    77,
                    64,
                    21,
                    47
                ]
            ],
            [
                [
                    104,
                    55,
                    44,
                    218,
                    9,
                    54,
                    53,
                    130,
                    226
                ],
                [
                    64,
                    90,
                    70,
                    205,
                    40,
                    41,
                    23,
                    26,
                    57
                ],
                [
                    54,
                    57,
                    112,
                    184,
                    5,
                    41,
                    38,
                    166,
                    213
                ],
                [
                    30,
                    34,
                    26,
                    133,
                    152,
                    116,
                    10,
                    32,
                    134
                ],
                [
                    39,
                    19,
                    53,
                    221,
                    26,
                    114,
                    32,
                    73,
                    255
                ],
                [
                    31,
                    9,
                    65,
                    234,
                    2,
                    15,
                    1,
                    118,
                    73
                ],
                [
                    75,
                    32,
                    12,
                    51,
                    192,
                    255,
                    160,
                    43,
                    51
                ],
                [
                    88,
                    31,
                    35,
                    67,
                    102,
                    85,
                    55,
                    186,
                    85
                ],
                [
                    56,
                    21,
                    23,
                    111,
                    59,
                    205,
                    45,
                    37,
                    192
                ],
                [
                    55,
                    38,
                    70,
                    124,
                    73,
                    102,
                    1,
                    34,
                    98
                ]
            ],
            [
                [
                    125,
                    98,
                    42,
                    88,
                    104,
                    85,
                    117,
                    175,
                    82
                ],
                [
                    95,
                    84,
                    53,
                    89,
                    128,
                    100,
                    113,
                    101,
                    45
                ],
                [
                    75,
                    79,
                    123,
                    47,
                    51,
                    128,
                    81,
                    171,
                    1
                ],
                [
                    57,
                    17,
                    5,
                    71,
                    102,
                    57,
                    53,
                    41,
                    49
                ],
                [
                    38,
                    33,
                    13,
                    121,
                    57,
                    73,
                    26,
                    1,
                    85
                ],
                [
                    41,
                    10,
                    67,
                    138,
                    77,
                    110,
                    90,
                    47,
                    114
                ],
                [
                    115,
                    21,
                    2,
                    10,
                    102,
                    255,
                    166,
                    23,
                    6
                ],
                [
                    101,
                    29,
                    16,
                    10,
                    85,
                    128,
                    101,
                    196,
                    26
                ],
                [
                    57,
                    18,
                    10,
                    102,
                    102,
                    213,
                    34,
                    20,
                    43
                ],
                [
                    117,
                    20,
                    15,
                    36,
                    163,
                    128,
                    68,
                    1,
                    26
                ]
            ],
            [
                [
                    102,
                    61,
                    71,
                    37,
                    34,
                    53,
                    31,
                    243,
                    192
                ],
                [
                    69,
                    60,
                    71,
                    38,
                    73,
                    119,
                    28,
                    222,
                    37
                ],
                [
                    68,
                    45,
                    128,
                    34,
                    1,
                    47,
                    11,
                    245,
                    171
                ],
                [
                    62,
                    17,
                    19,
                    70,
                    146,
                    85,
                    55,
                    62,
                    70
                ],
                [
                    37,
                    43,
                    37,
                    154,
                    100,
                    163,
                    85,
                    160,
                    1
                ],
                [
                    63,
                    9,
                    92,
                    136,
                    28,
                    64,
                    32,
                    201,
                    85
                ],
                [
                    75,
                    15,
                    9,
                    9,
                    64,
                    255,
                    184,
                    119,
                    16
                ],
                [
                    86,
                    6,
                    28,
                    5,
                    64,
                    255,
                    25,
                    248,
                    1
                ],
                [
                    56,
                    8,
                    17,
                    132,
                    137,
                    255,
                    55,
                    116,
                    128
                ],
                [
                    58,
                    15,
                    20,
                    82,
                    135,
                    57,
                    26,
                    121,
                    40
                ]
            ],
            [
                [
                    164,
                    50,
                    31,
                    137,
                    154,
                    133,
                    25,
                    35,
                    218
                ],
                [
                    51,
                    103,
                    44,
                    131,
                    131,
                    123,
                    31,
                    6,
                    158
                ],
                [
                    86,
                    40,
                    64,
                    135,
                    148,
                    224,
                    45,
                    183,
                    128
                ],
                [
                    22,
                    26,
                    17,
                    131,
                    240,
                    154,
                    14,
                    1,
                    209
                ],
                [
                    45,
                    16,
                    21,
                    91,
                    64,
                    222,
                    7,
                    1,
                    197
                ],
                [
                    56,
                    21,
                    39,
                    155,
                    60,
                    138,
                    23,
                    102,
                    213
                ],
                [
                    83,
                    12,
                    13,
                    54,
                    192,
                    255,
                    68,
                    47,
                    28
                ],
                [
                    85,
                    26,
                    85,
                    85,
                    128,
                    128,
                    32,
                    146,
                    171
                ],
                [
                    18,
                    11,
                    7,
                    63,
                    144,
                    171,
                    4,
                    4,
                    246
                ],
                [
                    35,
                    27,
                    10,
                    146,
                    174,
                    171,
                    12,
                    26,
                    128
                ]
            ],
            [
                [
                    190,
                    80,
                    35,
                    99,
                    180,
                    80,
                    126,
                    54,
                    45
                ],
                [
                    85,
                    126,
                    47,
                    87,
                    176,
                    51,
                    41,
                    20,
                    32
                ],
                [
                    101,
                    75,
                    128,
                    139,
                    118,
                    146,
                    116,
                    128,
                    85
                ],
                [
                    56,
                    41,
                    15,
                    176,
                    236,
                    85,
                    37,
                    9,
                    62
                ],
                [
                    71,
                    30,
                    17,
                    119,
                    118,
                    255,
                    17,
                    18,
                    138
                ],
                [
                    101,
                    38,
                    60,
                    138,
                    55,
                    70,
                    43,
                    26,
                    142
                ],
                [
                    146,
                    36,
                    19,
                    30,
                    171,
                    255,
                    97,
                    27,
                    20
                ],
                [
                    138,
                    45,
                    61,
                    62,
                    219,
                    1,
                    81,
                    188,
                    64
                ],
                [
                    32,
                    41,
                    20,
                    117,
                    151,
                    142,
                    20,
                    21,
                    163
                ],
                [
                    112,
                    19,
                    12,
                    61,
                    195,
                    128,
                    48,
                    4,
                    24
                ]
            ]
        ], ui = [
            [
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        176,
                        246,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        223,
                        241,
                        252,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        249,
                        253,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        244,
                        252,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        234,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        246,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        239,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        248,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        251,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        251,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        253,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        250,
                        255,
                        254,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ]
            ],
            [
                [
                    [
                        217,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        225,
                        252,
                        241,
                        253,
                        255,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        234,
                        250,
                        241,
                        250,
                        253,
                        255,
                        253,
                        254,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        223,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        238,
                        253,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        248,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        249,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        247,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        252,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        250,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ]
            ],
            [
                [
                    [
                        186,
                        251,
                        250,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        234,
                        251,
                        244,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        251,
                        251,
                        243,
                        253,
                        254,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        236,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        251,
                        253,
                        253,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ]
            ],
            [
                [
                    [
                        248,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        250,
                        254,
                        252,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        248,
                        254,
                        249,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        253,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        246,
                        253,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        252,
                        254,
                        251,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        252,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        248,
                        254,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        253,
                        255,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        251,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        245,
                        251,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        253,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        251,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        252,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        252,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        249,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        250,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ]
            ]
        ], ci = [
            0,
            1,
            2,
            3,
            6,
            4,
            5,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            7,
            0
        ], li = [], hi = [], fi = [], di = 1, pi = 2, gi = [], mi = [];
        vn("UpsampleRgbLinePair", xn, 3), vn("UpsampleBgrLinePair", An, 3), vn("UpsampleRgbaLinePair", Fn, 4), vn("UpsampleBgraLinePair", kn, 4), vn("UpsampleArgbLinePair", Pn, 4), vn("UpsampleRgba4444LinePair", _n, 2), vn("UpsampleRgb565LinePair", Sn, 2);
        var vi = t.UpsampleRgbLinePair, bi = t.UpsampleBgrLinePair, yi = t.UpsampleRgbaLinePair, wi = t.UpsampleBgraLinePair, Ni = t.UpsampleArgbLinePair, Li = t.UpsampleRgba4444LinePair, xi = t.UpsampleRgb565LinePair, Ai = 16, Si = 1 << Ai - 1, _i = -227, Pi = 482, ki = 6, Fi = (256 << ki) - 1, Ii = 0, ji = a(256), Ci = a(256), Oi = a(256), Bi = a(256), Mi = a(Pi - _i), qi = a(Pi - _i);
        In("YuvToRgbRow", xn, 3), In("YuvToBgrRow", An, 3), In("YuvToRgbaRow", Fn, 4), In("YuvToBgraRow", kn, 4), In("YuvToArgbRow", Pn, 4), In("YuvToRgba4444Row", _n, 2), In("YuvToRgb565Row", Sn, 2);
        var Ei = [
            0,
            4,
            8,
            12,
            128,
            132,
            136,
            140,
            256,
            260,
            264,
            268,
            384,
            388,
            392,
            396
        ], Ri = [
            0,
            2,
            8
        ], Di = [
            8,
            7,
            6,
            4,
            4,
            2,
            2,
            2,
            1,
            1,
            1,
            1
        ], Ti = 1;
        this.WebPDecodeRGBA = function(t, n, s, u, c) {
            var l = qr, h = new en, f = new ot;
            h.ba = f, f.S = l, f.width = [
                f.width
            ], f.height = [
                f.height
            ];
            var d = f.width, p = f.height, g = new st;
            if (null == g || null == t) var m = 2;
            else e(null != g), m = Bn(t, n, s, g.width, g.height, g.Pd, g.Qd, g.format, null);
            if (0 != m ? d = 0 : (null != d && (d[0] = g.width[0]), null != p && (p[0] = g.height[0]), d = 1), d) {
                f.width = f.width[0], f.height = f.height[0], null != u && (u[0] = f.width), null != c && (c[0] = f.height);
                t: {
                    if (u = new Gt, (c = new nn).data = t, c.w = n, c.ha = s, c.kd = 1, n = [
                        0
                    ], e(null != c), (0 == (t = Bn(c.data, c.w, c.ha, null, null, null, n, null, c)) || 7 == t) && n[0] && (t = 4), 0 == (n = t)) {
                        if (e(null != h), u.data = c.data, u.w = c.w + c.offset, u.ha = c.ha - c.offset, u.put = dt, u.ac = ft, u.bc = pt, u.ma = h, c.xa) {
                            if (null == (t = kt())) {
                                h = 1;
                                break t;
                            }
                            if (function(t, n) {
                                var r = [
                                    0
                                ], i = [
                                    0
                                ], a = [
                                    0
                                ];
                                e: for(;;){
                                    if (null == t) return 0;
                                    if (null == n) return t.a = 2, 0;
                                    if (t.l = n, t.a = 0, v(t.m, n.data, n.w, n.ha), !gt(t.m, r, i, a)) {
                                        t.a = 3;
                                        break e;
                                    }
                                    if (t.xb = pi, n.width = r[0], n.height = i[0], !Ft(r[0], i[0], 1, t, null)) break e;
                                    return 1;
                                }
                                return e(0 != t.a), 0;
                            }(t, u)) {
                                if (u = 0 == (n = En(u.width, u.height, h.Oa, h.ba))) {
                                    e: {
                                        u = t;
                                        n: for(;;){
                                            if (null == u) {
                                                u = 0;
                                                break e;
                                            }
                                            if (e(null != u.s.yc), e(null != u.s.Ya), e(0 < u.s.Wb), e(null != (s = u.l)), e(null != (c = s.ma)), 0 != u.xb) {
                                                if (u.ca = c.ba, u.tb = c.tb, e(null != u.ca), !Mn(c.Oa, s, Rr)) {
                                                    u.a = 2;
                                                    break n;
                                                }
                                                if (!It(u, s.width)) break n;
                                                if (s.da) break n;
                                                if ((s.da || rt(u.ca.S)) && mn(), 11 > u.ca.S || (alert("todo:WebPInitConvertARGBToYUV"), null != u.ca.f.kb.F && mn()), u.Pb && 0 < u.s.ua && null == u.s.vb.X && !O(u.s.vb, u.s.Wa.Xa)) {
                                                    u.a = 1;
                                                    break n;
                                                }
                                                u.xb = 0;
                                            }
                                            if (!_t(u, u.V, u.Ba, u.c, u.i, s.o, Lt)) break n;
                                            c.Dc = u.Ma, u = 1;
                                            break e;
                                        }
                                        e(0 != u.a), u = 0;
                                    }
                                    u = !u;
                                }
                                u && (n = t.a);
                            } else n = t.a;
                        } else {
                            t = new Yt;
                            if (t.Fa = c.na, t.P = c.P, t.qc = c.Sa, Kt(t, u)) {
                                if (0 == (n = En(u.width, u.height, h.Oa, h.ba))) {
                                    if (t.Aa = 0, s = h.Oa, e(null != (c = t)), null != s) {
                                        if (0 < (d = 0 > (d = s.Md) ? 0 : 100 < d ? 255 : 255 * d / 100)) {
                                            for(p = g = 0; 4 > p; ++p)12 > (m = c.pb[p]).lc && (m.ia = d * Di[0 > m.lc ? 0 : m.lc] >> 3), g |= m.ia;
                                            g && (alert("todo:VP8InitRandom"), c.ia = 1);
                                        }
                                        c.Ga = s.Id, 100 < c.Ga ? c.Ga = 100 : 0 > c.Ga && (c.Ga = 0);
                                    }
                                    (function(t, n) {
                                        if (null == t) return 0;
                                        if (null == n) return Jt(t, 2, "NULL VP8Io parameter in VP8Decode().");
                                        if (!t.cb && !Kt(t, n)) return 0;
                                        if (e(t.cb), null == n.ac || n.ac(n)) {
                                            n.ob && (t.L = 0);
                                            var s = Ri[t.L];
                                            if (2 == t.L ? (t.yb = 0, t.zb = 0) : (t.yb = n.v - s >> 4, t.zb = n.j - s >> 4, 0 > t.yb && (t.yb = 0), 0 > t.zb && (t.zb = 0)), t.Va = n.o + 15 + s >> 4, t.Hb = n.va + 15 + s >> 4, t.Hb > t.za && (t.Hb = t.za), t.Va > t.Ub && (t.Va = t.Ub), 0 < t.L) {
                                                var u = t.ed;
                                                for(s = 0; 4 > s; ++s){
                                                    var c;
                                                    if (t.Qa.Cb) {
                                                        var l = t.Qa.Lb[s];
                                                        t.Qa.Fb || (l += u.Tb);
                                                    } else l = u.Tb;
                                                    for(c = 0; 1 >= c; ++c){
                                                        var h = t.gd[s][c], f = l;
                                                        if (u.Pc && (f += u.vd[0], c && (f += u.od[0])), 0 < (f = 0 > f ? 0 : 63 < f ? 63 : f)) {
                                                            var d = f;
                                                            0 < u.wb && (d = 4 < u.wb ? d >> 2 : d >> 1) > 9 - u.wb && (d = 9 - u.wb), 1 > d && (d = 1), h.dd = d, h.tc = 2 * f + d, h.ld = 40 <= f ? 2 : 15 <= f ? 1 : 0;
                                                        } else h.tc = 0;
                                                        h.La = c;
                                                    }
                                                }
                                            }
                                            s = 0;
                                        } else Jt(t, 6, "Frame setup failed"), s = t.a;
                                        if (s = 0 == s) {
                                            if (s) {
                                                t.$c = 0, 0 < t.Aa || (t.Ic = Ti);
                                                e: {
                                                    s = t.Ic, u = 4 * (d = t.za);
                                                    var p = 32 * d, g = d + 1, m = 0 < t.L ? d * (0 < t.Aa ? 2 : 1) : 0, v = (2 == t.Aa ? 2 : 1) * d;
                                                    if ((h = u + 832 + (c = 3 * (16 * s + Ri[t.L]) / 2 * p) + (l = null != t.Fa && 0 < t.Fa.length ? t.Kc.c * t.Kc.i : 0)) != h) s = 0;
                                                    else {
                                                        if (h > t.Vb) {
                                                            if (t.Vb = 0, t.Ec = a(h), t.Fc = 0, null == t.Ec) {
                                                                s = Jt(t, 1, "no memory during frame initialization.");
                                                                break e;
                                                            }
                                                            t.Vb = h;
                                                        }
                                                        h = t.Ec, f = t.Fc, t.Ac = h, t.Bc = f, f += u, t.Gd = o(p, Ht), t.Hd = 0, t.rb = o(g + 1, Dt), t.sb = 1, t.wa = m ? o(m, Rt) : null, t.Y = 0, t.D.Nb = 0, t.D.wa = t.wa, t.D.Y = t.Y, 0 < t.Aa && (t.D.Y += d), e(!0), t.oc = h, t.pc = f, f += 832, t.ya = o(v, zt), t.aa = 0, t.D.ya = t.ya, t.D.aa = t.aa, 2 == t.Aa && (t.D.aa += d), t.R = 16 * d, t.B = 8 * d, d = (p = Ri[t.L]) * t.R, p = p / 2 * t.B, t.sa = h, t.ta = f + d, t.qa = t.sa, t.ra = t.ta + 16 * s * t.R + p, t.Ha = t.qa, t.Ia = t.ra + 8 * s * t.B + p, t.$c = 0, f += c, t.mb = l ? h : null, t.nb = l ? f : null, e(f + l <= t.Fc + t.Vb), $t(t), i(t.Ac, t.Bc, 0, u), s = 1;
                                                    }
                                                }
                                                if (s) {
                                                    if (n.ka = 0, n.y = t.sa, n.O = t.ta, n.f = t.qa, n.N = t.ra, n.ea = t.Ha, n.Vd = t.Ia, n.fa = t.R, n.Rc = t.B, n.F = null, n.J = 0, !Ir) {
                                                        for(s = -255; 255 >= s; ++s)_r[255 + s] = 0 > s ? -s : s;
                                                        for(s = -1020; 1020 >= s; ++s)Pr[1020 + s] = -128 > s ? -128 : 127 < s ? 127 : s;
                                                        for(s = -112; 112 >= s; ++s)kr[112 + s] = -16 > s ? -16 : 15 < s ? 15 : s;
                                                        for(s = -255; 510 >= s; ++s)Fr[255 + s] = 0 > s ? 0 : 255 < s ? 255 : s;
                                                        Ir = 1;
                                                    }
                                                    ir = ue, ar = ie, sr = ae, ur = oe, cr = se, or = re, lr = Ye, hr = Je, fr = Ze, dr = $e, pr = Xe, gr = Ke, mr = Qe, vr = tn, br = ze, yr = Ue, wr = He, Nr = We, hi[0] = xe, hi[1] = le, hi[2] = Ne, hi[3] = Le, hi[4] = Ae, hi[5] = _e, hi[6] = Se, hi[7] = Pe, hi[8] = Fe, hi[9] = ke, li[0] = me, li[1] = fe, li[2] = de, li[3] = pe, li[4] = ve, li[5] = be, li[6] = ye, fi[0] = Oe, fi[1] = he, fi[2] = Ie, fi[3] = je, fi[4] = Me, fi[5] = Be, fi[6] = qe, s = 1;
                                                } else s = 0;
                                            }
                                            s && (s = function(t, n) {
                                                for(t.M = 0; t.M < t.Va; ++t.M){
                                                    var o, s = t.Jc[t.M & t.Xb], u = t.m, c = t;
                                                    for(o = 0; o < c.za; ++o){
                                                        var l = u, h = c, f = h.Ac, d = h.Bc + 4 * o, p = h.zc, g = h.ya[h.aa + o];
                                                        if (h.Qa.Bb ? g.$b = k(l, h.Pa.jb[0]) ? 2 + k(l, h.Pa.jb[2]) : k(l, h.Pa.jb[1]) : g.$b = 0, h.kc && (g.Ad = k(l, h.Bd)), g.Za = !k(l, 145) + 0, g.Za) {
                                                            var m = g.Ob, v = 0;
                                                            for(h = 0; 4 > h; ++h){
                                                                var b, y = p[0 + h];
                                                                for(b = 0; 4 > b; ++b){
                                                                    y = si[f[d + b]][y];
                                                                    for(var w = ai[k(l, y[0])]; 0 < w;)w = ai[2 * w + k(l, y[w])];
                                                                    y = -w, f[d + b] = y;
                                                                }
                                                                r(m, v, f, d, 4), v += 4, p[0 + h] = y;
                                                            }
                                                        } else y = k(l, 156) ? k(l, 128) ? 1 : 3 : k(l, 163) ? 2 : 0, g.Ob[0] = y, i(f, d, y, 4), i(p, 0, y, 4);
                                                        g.Dd = k(l, 142) ? k(l, 114) ? k(l, 183) ? 1 : 3 : 2 : 0;
                                                    }
                                                    if (c.m.Ka) return Jt(t, 7, "Premature end-of-partition0 encountered.");
                                                    for(; t.ja < t.za; ++t.ja){
                                                        if (c = s, l = (u = t).rb[u.sb - 1], f = u.rb[u.sb + u.ja], o = u.ya[u.aa + u.ja], d = u.kc ? o.Ad : 0) l.la = f.la = 0, o.Za || (l.Na = f.Na = 0), o.Hc = 0, o.Gc = 0, o.ia = 0;
                                                        else {
                                                            var N, L;
                                                            if (l = f, f = c, d = u.Pa.Xc, p = u.ya[u.aa + u.ja], g = u.pb[p.$b], h = p.ad, m = 0, v = u.rb[u.sb - 1], y = b = 0, i(h, m, 0, 384), p.Za) var x = 0, A = d[3];
                                                            else {
                                                                w = a(16);
                                                                var S = l.Na + v.Na;
                                                                if (S = ni(f, d[1], S, g.Eb, 0, w, 0), l.Na = v.Na = (0 < S) + 0, 1 < S) ir(w, 0, h, m);
                                                                else {
                                                                    var _ = w[0] + 3 >> 3;
                                                                    for(w = 0; 256 > w; w += 16)h[m + w] = _;
                                                                }
                                                                x = 1, A = d[0];
                                                            }
                                                            var P = 15 & l.la, F = 15 & v.la;
                                                            for(w = 0; 4 > w; ++w){
                                                                var I = 1 & F;
                                                                for(_ = L = 0; 4 > _; ++_)P = P >> 1 | (I = (S = ni(f, A, S = I + (1 & P), g.Sc, x, h, m)) > x) << 7, L = L << 2 | (3 < S ? 3 : 1 < S ? 2 : 0 != h[m + 0]), m += 16;
                                                                P >>= 4, F = F >> 1 | I << 7, b = (b << 8 | L) >>> 0;
                                                            }
                                                            for(A = P, x = F >> 4, N = 0; 4 > N; N += 2){
                                                                for(L = 0, P = l.la >> 4 + N, F = v.la >> 4 + N, w = 0; 2 > w; ++w){
                                                                    for(I = 1 & F, _ = 0; 2 > _; ++_)S = I + (1 & P), P = P >> 1 | (I = 0 < (S = ni(f, d[2], S, g.Qc, 0, h, m))) << 3, L = L << 2 | (3 < S ? 3 : 1 < S ? 2 : 0 != h[m + 0]), m += 16;
                                                                    P >>= 2, F = F >> 1 | I << 5;
                                                                }
                                                                y |= L << 4 * N, A |= P << 4 << N, x |= (240 & F) << N;
                                                            }
                                                            l.la = A, v.la = x, p.Hc = b, p.Gc = y, p.ia = 43690 & y ? 0 : g.ia, d = !(b | y);
                                                        }
                                                        if (0 < u.L && (u.wa[u.Y + u.ja] = u.gd[o.$b][o.Za], u.wa[u.Y + u.ja].La |= !d), c.Ka) return Jt(t, 7, "Premature end-of-file encountered.");
                                                    }
                                                    if ($t(t), u = n, c = 1, o = (s = t).D, l = 0 < s.L && s.M >= s.zb && s.M <= s.Va, 0 == s.Aa) e: {
                                                        if (o.M = s.M, o.uc = l, On(s, o), c = 1, o = (L = s.D).Nb, l = (y = Ri[s.L]) * s.R, f = y / 2 * s.B, w = 16 * o * s.R, _ = 8 * o * s.B, d = s.sa, p = s.ta - l + w, g = s.qa, h = s.ra - f + _, m = s.Ha, v = s.Ia - f + _, F = 0 == (P = L.M), b = P >= s.Va - 1, 2 == s.Aa && On(s, L), L.uc) for(I = (S = s).D.M, e(S.D.uc), L = S.yb; L < S.Hb; ++L){
                                                            x = L, A = I;
                                                            var j = (C = (z = S).D).Nb;
                                                            N = z.R;
                                                            var C = C.wa[C.Y + x], O = z.sa, B = z.ta + 16 * j * N + 16 * x, M = C.dd, q = C.tc;
                                                            if (0 != q) {
                                                                if (e(3 <= q), 1 == z.L) 0 < x && yr(O, B, N, q + 4), C.La && Nr(O, B, N, q), 0 < A && br(O, B, N, q + 4), C.La && wr(O, B, N, q);
                                                                else {
                                                                    var E = z.B, R = z.qa, D = z.ra + 8 * j * E + 8 * x, T = z.Ha, z = z.Ia + 8 * j * E + 8 * x;
                                                                    j = C.ld, 0 < x && (hr(O, B, N, q + 4, M, j), dr(R, D, T, z, E, q + 4, M, j)), C.La && (gr(O, B, N, q, M, j), vr(R, D, T, z, E, q, M, j)), 0 < A && (lr(O, B, N, q + 4, M, j), fr(R, D, T, z, E, q + 4, M, j)), C.La && (pr(O, B, N, q, M, j), mr(R, D, T, z, E, q, M, j));
                                                                }
                                                            }
                                                        }
                                                        if (s.ia && alert("todo:DitherRow"), null != u.put) {
                                                            if (L = 16 * P, P = 16 * (P + 1), F ? (u.y = s.sa, u.O = s.ta + w, u.f = s.qa, u.N = s.ra + _, u.ea = s.Ha, u.W = s.Ia + _) : (L -= y, u.y = d, u.O = p, u.f = g, u.N = h, u.ea = m, u.W = v), b || (P -= y), P > u.o && (P = u.o), u.F = null, u.J = null, null != s.Fa && 0 < s.Fa.length && L < P && (u.J = hn(s, u, L, P - L), u.F = s.mb, null == u.F && 0 == u.F.length)) {
                                                                c = Jt(s, 3, "Could not decode alpha data.");
                                                                break e;
                                                            }
                                                            L < u.j && (y = u.j - L, L = u.j, e(!(1 & y)), u.O += s.R * y, u.N += s.B * (y >> 1), u.W += s.B * (y >> 1), null != u.F && (u.J += u.width * y)), L < P && (u.O += u.v, u.N += u.v >> 1, u.W += u.v >> 1, null != u.F && (u.J += u.v), u.ka = L - u.j, u.U = u.va - u.v, u.T = P - L, c = u.put(u));
                                                        }
                                                        o + 1 != s.Ic || b || (r(s.sa, s.ta - l, d, p + 16 * s.R, l), r(s.qa, s.ra - f, g, h + 8 * s.B, f), r(s.Ha, s.Ia - f, m, v + 8 * s.B, f));
                                                    }
                                                    if (!c) return Jt(t, 6, "Output aborted.");
                                                }
                                                return 1;
                                            }(t, n)), null != n.bc && n.bc(n), s &= 1;
                                        }
                                        return s ? (t.cb = 0, s) : 0;
                                    })(t, u) || (n = t.a);
                                }
                            } else n = t.a;
                        }
                        0 == n && null != h.Oa && h.Oa.fd && (n = qn(h.ba));
                    }
                    h = n;
                }
                l = 0 != h ? null : 11 > l ? f.f.RGBA.eb : f.f.kb.y;
            } else l = null;
            return l;
        };
        var zi = [
            3,
            4,
            3,
            4,
            4,
            2,
            2,
            4,
            4,
            4,
            2,
            1,
            1
        ];
    };
    function c(t, e) {
        for(var n = "", r = 0; r < 4; r++)n += String.fromCharCode(t[e++]);
        return n;
    }
    function l(t, e) {
        return t[e + 0] | t[e + 1] << 8;
    }
    function h(t, e) {
        return (t[e + 0] | t[e + 1] << 8 | t[e + 2] << 16) >>> 0;
    }
    function f(t, e) {
        return (t[e + 0] | t[e + 1] << 8 | t[e + 2] << 16 | t[e + 3] << 24) >>> 0;
    }
    new u;
    var d = [
        0
    ], p = [
        0
    ], g = [], m = new u, v = t, b = function(t, e) {
        var n = {}, r = 0, i = !1, a = 0, o = 0;
        if (n.frames = [], !/** @license
   * Copyright (c) 2017 Dominik Homberger
  Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
  The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
  https://webpjs.appspot.com
  WebPRiffParser dominikhlbg@gmail.com
  */ function(t, e) {
            for(var n = 0; n < 4; n++)if (t[e + n] != "RIFF".charCodeAt(n)) return !0;
            return !1;
        }(t, e)) {
            for(f(t, e += 4), e += 8; e < t.length;){
                var s = c(t, e), u = f(t, e += 4);
                e += 4;
                var d = u + (1 & u);
                switch(s){
                    case "VP8 ":
                    case "VP8L":
                        void 0 === n.frames[r] && (n.frames[r] = {}), (m = n.frames[r]).src_off = i ? o : e - 8, m.src_size = a + u + 8, r++, i && (i = !1, a = 0, o = 0);
                        break;
                    case "VP8X":
                        (m = n.header = {}).feature_flags = t[e];
                        var p = e + 4;
                        m.canvas_width = 1 + h(t, p), p += 3, m.canvas_height = 1 + h(t, p), p += 3;
                        break;
                    case "ALPH":
                        i = !0, a = d + 8, o = e - 8;
                        break;
                    case "ANIM":
                        (m = n.header).bgcolor = f(t, e), p = e + 4, m.loop_count = l(t, p), p += 2;
                        break;
                    case "ANMF":
                        var g, m;
                        (m = n.frames[r] = {}).offset_x = 2 * h(t, e), e += 3, m.offset_y = 2 * h(t, e), e += 3, m.width = 1 + h(t, e), e += 3, m.height = 1 + h(t, e), e += 3, m.duration = h(t, e), e += 3, g = t[e++], m.dispose = 1 & g, m.blend = g >> 1 & 1;
                }
                "ANMF" != s && (e += d);
            }
            return n;
        }
    }(v, 0);
    b.response = v, b.rgbaoutput = !0, b.dataurl = !1;
    var y = b.header ? b.header : null, w = b.frames ? b.frames : null;
    if (y) {
        y.loop_counter = y.loop_count, d = [
            y.canvas_height
        ], p = [
            y.canvas_width
        ];
        for(var N = 0; N < w.length && 0 != w[N].blend; N++);
    }
    var L = w[0], x = m.WebPDecodeRGBA(v, L.src_off, L.src_size, p, d);
    L.rgba = x, L.imgwidth = p[0], L.imgheight = d[0];
    for(var A = 0; A < p[0] * d[0] * 4; A++)g[A] = x[A];
    return this.width = p, this.height = d, this.data = g, this;
}
!function(e) {
    var n, r, i, a, s, u, c, l, f, d = function(t) {
        return t = t || {}, this.isStrokeTransparent = t.isStrokeTransparent || !1, this.strokeOpacity = t.strokeOpacity || 1, this.strokeStyle = t.strokeStyle || "#000000", this.fillStyle = t.fillStyle || "#000000", this.isFillTransparent = t.isFillTransparent || !1, this.fillOpacity = t.fillOpacity || 1, this.font = t.font || "10px sans-serif", this.textBaseline = t.textBaseline || "alphabetic", this.textAlign = t.textAlign || "left", this.lineWidth = t.lineWidth || 1, this.lineJoin = t.lineJoin || "miter", this.lineCap = t.lineCap || "butt", this.path = t.path || [], this.transform = void 0 !== t.transform ? t.transform.clone() : new l, this.globalCompositeOperation = t.globalCompositeOperation || "normal", this.globalAlpha = t.globalAlpha || 1, this.clip_path = t.clip_path || [], this.currentPoint = t.currentPoint || new u, this.miterLimit = t.miterLimit || 10, this.lastPoint = t.lastPoint || new u, this.lineDashOffset = t.lineDashOffset || 0, this.lineDash = t.lineDash || [], this.margin = t.margin || [
            0,
            0,
            0,
            0
        ], this.prevPageLastElemOffset = t.prevPageLastElemOffset || 0, this.ignoreClearRect = "boolean" != typeof t.ignoreClearRect || t.ignoreClearRect, this;
    };
    e.events.push([
        "initialized",
        function() {
            this.context2d = new p(this), n = this.internal.f2, r = this.internal.getCoordinateString, i = this.internal.getVerticalCoordinateString, a = this.internal.getHorizontalCoordinate, s = this.internal.getVerticalCoordinate, u = this.internal.Point, c = this.internal.Rectangle, l = this.internal.Matrix, f = new d;
        }
    ]);
    var p = function(t) {
        Object.defineProperty(this, "canvas", {
            get: function() {
                return {
                    parentNode: !1,
                    style: !1
                };
            }
        });
        var e = t;
        Object.defineProperty(this, "pdf", {
            get: function() {
                return e;
            }
        });
        var n = !1;
        Object.defineProperty(this, "pageWrapXEnabled", {
            get: function() {
                return n;
            },
            set: function(t) {
                n = Boolean(t);
            }
        });
        var r = !1;
        Object.defineProperty(this, "pageWrapYEnabled", {
            get: function() {
                return r;
            },
            set: function(t) {
                r = Boolean(t);
            }
        });
        var i = 0;
        Object.defineProperty(this, "posX", {
            get: function() {
                return i;
            },
            set: function(t) {
                isNaN(t) || (i = t);
            }
        });
        var a = 0;
        Object.defineProperty(this, "posY", {
            get: function() {
                return a;
            },
            set: function(t) {
                isNaN(t) || (a = t);
            }
        }), Object.defineProperty(this, "margin", {
            get: function() {
                return f.margin;
            },
            set: function(t) {
                var e;
                "number" == typeof t ? e = [
                    t,
                    t,
                    t,
                    t
                ] : ((e = new Array(4))[0] = t[0], e[1] = t.length >= 2 ? t[1] : e[0], e[2] = t.length >= 3 ? t[2] : e[0], e[3] = t.length >= 4 ? t[3] : e[1]), f.margin = e;
            }
        });
        var o = !1;
        Object.defineProperty(this, "autoPaging", {
            get: function() {
                return o;
            },
            set: function(t) {
                o = t;
            }
        });
        var s = 0;
        Object.defineProperty(this, "lastBreak", {
            get: function() {
                return s;
            },
            set: function(t) {
                s = t;
            }
        });
        var u = [];
        Object.defineProperty(this, "pageBreaks", {
            get: function() {
                return u;
            },
            set: function(t) {
                u = t;
            }
        }), Object.defineProperty(this, "ctx", {
            get: function() {
                return f;
            },
            set: function(t) {
                t instanceof d && (f = t);
            }
        }), Object.defineProperty(this, "path", {
            get: function() {
                return f.path;
            },
            set: function(t) {
                f.path = t;
            }
        });
        var c = [];
        Object.defineProperty(this, "ctxStack", {
            get: function() {
                return c;
            },
            set: function(t) {
                c = t;
            }
        }), Object.defineProperty(this, "fillStyle", {
            get: function() {
                return this.ctx.fillStyle;
            },
            set: function(t) {
                var e;
                e = g(t), this.ctx.fillStyle = e.style, this.ctx.isFillTransparent = 0 === e.a, this.ctx.fillOpacity = e.a, this.pdf.setFillColor(e.r, e.g, e.b, {
                    a: e.a
                }), this.pdf.setTextColor(e.r, e.g, e.b, {
                    a: e.a
                });
            }
        }), Object.defineProperty(this, "strokeStyle", {
            get: function() {
                return this.ctx.strokeStyle;
            },
            set: function(t) {
                var e = g(t);
                this.ctx.strokeStyle = e.style, this.ctx.isStrokeTransparent = 0 === e.a, this.ctx.strokeOpacity = e.a, 0 === e.a ? this.pdf.setDrawColor(255, 255, 255) : (e.a, this.pdf.setDrawColor(e.r, e.g, e.b));
            }
        }), Object.defineProperty(this, "lineCap", {
            get: function() {
                return this.ctx.lineCap;
            },
            set: function(t) {
                -1 !== [
                    "butt",
                    "round",
                    "square"
                ].indexOf(t) && (this.ctx.lineCap = t, this.pdf.setLineCap(t));
            }
        }), Object.defineProperty(this, "lineWidth", {
            get: function() {
                return this.ctx.lineWidth;
            },
            set: function(t) {
                isNaN(t) || (this.ctx.lineWidth = t, this.pdf.setLineWidth(t));
            }
        }), Object.defineProperty(this, "lineJoin", {
            get: function() {
                return this.ctx.lineJoin;
            },
            set: function(t) {
                -1 !== [
                    "bevel",
                    "round",
                    "miter"
                ].indexOf(t) && (this.ctx.lineJoin = t, this.pdf.setLineJoin(t));
            }
        }), Object.defineProperty(this, "miterLimit", {
            get: function() {
                return this.ctx.miterLimit;
            },
            set: function(t) {
                isNaN(t) || (this.ctx.miterLimit = t, this.pdf.setMiterLimit(t));
            }
        }), Object.defineProperty(this, "textBaseline", {
            get: function() {
                return this.ctx.textBaseline;
            },
            set: function(t) {
                this.ctx.textBaseline = t;
            }
        }), Object.defineProperty(this, "textAlign", {
            get: function() {
                return this.ctx.textAlign;
            },
            set: function(t) {
                -1 !== [
                    "right",
                    "end",
                    "center",
                    "left",
                    "start"
                ].indexOf(t) && (this.ctx.textAlign = t);
            }
        });
        var l = null;
        var h = null;
        Object.defineProperty(this, "fontFaces", {
            get: function() {
                return h;
            },
            set: function(t) {
                l = null, h = t;
            }
        }), Object.defineProperty(this, "font", {
            get: function() {
                return this.ctx.font;
            },
            set: function(t) {
                var e;
                if (this.ctx.font = t, null !== (e = /^\s*(?=(?:(?:[-a-z]+\s*){0,2}(italic|oblique))?)(?=(?:(?:[-a-z]+\s*){0,2}(small-caps))?)(?=(?:(?:[-a-z]+\s*){0,2}(bold(?:er)?|lighter|[1-9]00))?)(?:(?:normal|\1|\2|\3)\s*){0,3}((?:xx?-)?(?:small|large)|medium|smaller|larger|[.\d]+(?:\%|in|[cem]m|ex|p[ctx]))(?:\s*\/\s*(normal|[.\d]+(?:\%|in|[cem]m|ex|p[ctx])))?\s*([-_,\"\'\sa-z]+?)\s*$/i.exec(t))) {
                    var n = e[1];
                    e[2];
                    var r = e[3], i = e[4];
                    e[5];
                    var a = e[6], o = /^([.\d]+)((?:%|in|[cem]m|ex|p[ctx]))$/i.exec(i)[2];
                    i = "px" === o ? Math.floor(parseFloat(i) * this.pdf.internal.scaleFactor) : "em" === o ? Math.floor(parseFloat(i) * this.pdf.getFontSize()) : Math.floor(parseFloat(i) * this.pdf.internal.scaleFactor), this.pdf.setFontSize(i);
                    var s = function(t) {
                        var e, n, r = [], i = t.trim();
                        if ("" === i) return Jt;
                        if (i in Mt) return [
                            Mt[i]
                        ];
                        for(; "" !== i;){
                            switch(n = null, e = (i = Et(i)).charAt(0)){
                                case '"':
                                case "'":
                                    n = Rt(i.substring(1), e);
                                    break;
                                default:
                                    n = Dt(i);
                            }
                            if (null === n) return Jt;
                            if (r.push(n[0]), "" !== (i = Et(n[1])) && "," !== i.charAt(0)) return Jt;
                            i = i.replace(/^,/, "");
                        }
                        return r;
                    }(a);
                    if (this.fontFaces) {
                        var u = function(t, e) {
                            if (null === l) {
                                var n = function(t) {
                                    var e = [];
                                    return Object.keys(t).forEach(function(n) {
                                        t[n].forEach(function(t) {
                                            var r = null;
                                            switch(t){
                                                case "bold":
                                                    r = {
                                                        family: n,
                                                        weight: "bold"
                                                    };
                                                    break;
                                                case "italic":
                                                    r = {
                                                        family: n,
                                                        style: "italic"
                                                    };
                                                    break;
                                                case "bolditalic":
                                                    r = {
                                                        family: n,
                                                        weight: "bold",
                                                        style: "italic"
                                                    };
                                                    break;
                                                case "":
                                                case "normal":
                                                    r = {
                                                        family: n
                                                    };
                                            }
                                            null !== r && (r.ref = {
                                                name: n,
                                                style: t
                                            }, e.push(r));
                                        });
                                    }), e;
                                }(t.getFontList());
                                l = function(t) {
                                    for(var e = {}, n = 0; n < t.length; ++n){
                                        var r = Ct(t[n]), i = r.family, a = r.stretch, o = r.style, s = r.weight;
                                        e[i] = e[i] || {}, e[i][a] = e[i][a] || {}, e[i][a][o] = e[i][a][o] || {}, e[i][a][o][s] = r;
                                    }
                                    return e;
                                }(n.concat(e));
                            }
                            return l;
                        }(this.pdf, this.fontFaces), c = s.map(function(t) {
                            return {
                                family: t,
                                stretch: "normal",
                                weight: r,
                                style: n
                            };
                        }), h = function(t, e, n) {
                            for(var r = (n = n || {}).defaultFontFamily || "times", i = Object.assign({}, Bt, n.genericFontFamilies || {}), a = null, o = null, s = 0; s < e.length; ++s)if (i[(a = Ct(e[s])).family] && (a.family = i[a.family]), t.hasOwnProperty(a.family)) {
                                o = t[a.family];
                                break;
                            }
                            if (!(o = o || t[r])) throw new Error("Could not find a font-family for the rule '" + qt(a) + "' and default family '" + r + "'.");
                            if (o = function(t, e) {
                                if (e[t]) return e[t];
                                var n = Ft[t], r = n <= Ft.normal ? -1 : 1, i = Ot(e, kt, n, r);
                                if (!i) throw new Error("Could not find a matching font-stretch value for " + t);
                                return i;
                            }(a.stretch, o), o = function(t, e) {
                                if (e[t]) return e[t];
                                for(var n = Pt[t], r = 0; r < n.length; ++r)if (e[n[r]]) return e[n[r]];
                                throw new Error("Could not find a matching font-style for " + t);
                            }(a.style, o), !(o = function(t, e) {
                                if (e[t]) return e[t];
                                if (400 === t && e[500]) return e[500];
                                if (500 === t && e[400]) return e[400];
                                var n = jt[t], r = Ot(e, It, n, t < 400 ? -1 : 1);
                                if (!r) throw new Error("Could not find a matching font-weight for value " + t);
                                return r;
                            }(a.weight, o))) throw new Error("Failed to resolve a font for the rule '" + qt(a) + "'.");
                            return o;
                        }(u, c);
                        this.pdf.setFont(h.ref.name, h.ref.style);
                    } else {
                        var f = "";
                        ("bold" === r || parseInt(r, 10) >= 700 || "bold" === n) && (f = "bold"), "italic" === n && (f += "italic"), 0 === f.length && (f = "normal");
                        for(var d = "", p = {
                            arial: "Helvetica",
                            Arial: "Helvetica",
                            verdana: "Helvetica",
                            Verdana: "Helvetica",
                            helvetica: "Helvetica",
                            Helvetica: "Helvetica",
                            "sans-serif": "Helvetica",
                            fixed: "Courier",
                            monospace: "Courier",
                            terminal: "Courier",
                            cursive: "Times",
                            fantasy: "Times",
                            serif: "Times"
                        }, g = 0; g < s.length; g++){
                            if (void 0 !== this.pdf.internal.getFont(s[g], f, {
                                noFallback: !0,
                                disableWarning: !0
                            })) {
                                d = s[g];
                                break;
                            }
                            if ("bolditalic" === f && void 0 !== this.pdf.internal.getFont(s[g], "bold", {
                                noFallback: !0,
                                disableWarning: !0
                            })) d = s[g], f = "bold";
                            else if (void 0 !== this.pdf.internal.getFont(s[g], "normal", {
                                noFallback: !0,
                                disableWarning: !0
                            })) {
                                d = s[g], f = "normal";
                                break;
                            }
                        }
                        if ("" === d) {
                            for(var m = 0; m < s.length; m++)if (p[s[m]]) {
                                d = p[s[m]];
                                break;
                            }
                        }
                        d = "" === d ? "Times" : d, this.pdf.setFont(d, f);
                    }
                }
            }
        }), Object.defineProperty(this, "globalCompositeOperation", {
            get: function() {
                return this.ctx.globalCompositeOperation;
            },
            set: function(t) {
                this.ctx.globalCompositeOperation = t;
            }
        }), Object.defineProperty(this, "globalAlpha", {
            get: function() {
                return this.ctx.globalAlpha;
            },
            set: function(t) {
                this.ctx.globalAlpha = t;
            }
        }), Object.defineProperty(this, "lineDashOffset", {
            get: function() {
                return this.ctx.lineDashOffset;
            },
            set: function(t) {
                this.ctx.lineDashOffset = t, T.call(this);
            }
        }), Object.defineProperty(this, "lineDash", {
            get: function() {
                return this.ctx.lineDash;
            },
            set: function(t) {
                this.ctx.lineDash = t, T.call(this);
            }
        }), Object.defineProperty(this, "ignoreClearRect", {
            get: function() {
                return this.ctx.ignoreClearRect;
            },
            set: function(t) {
                this.ctx.ignoreClearRect = Boolean(t);
            }
        });
    };
    p.prototype.setLineDash = function(t) {
        this.lineDash = t;
    }, p.prototype.getLineDash = function() {
        return this.lineDash.length % 2 ? this.lineDash.concat(this.lineDash) : this.lineDash.slice();
    }, p.prototype.fill = function() {
        x.call(this, "fill", !1);
    }, p.prototype.stroke = function() {
        x.call(this, "stroke", !1);
    }, p.prototype.beginPath = function() {
        this.path = [
            {
                type: "begin"
            }
        ];
    }, p.prototype.moveTo = function(t, e) {
        if (isNaN(t) || isNaN(e)) throw o.error("jsPDF.context2d.moveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.moveTo");
        var n = this.ctx.transform.applyToPoint(new u(t, e));
        this.path.push({
            type: "mt",
            x: n.x,
            y: n.y
        }), this.ctx.lastPoint = new u(t, e);
    }, p.prototype.closePath = function() {
        var e = new u(0, 0), n = 0;
        for(n = this.path.length - 1; -1 !== n; n--)if ("begin" === this.path[n].type && "object" === (0, _typeofDefault.default)(this.path[n + 1]) && "number" == typeof this.path[n + 1].x) {
            e = new u(this.path[n + 1].x, this.path[n + 1].y);
            break;
        }
        this.path.push({
            type: "close"
        }), this.ctx.lastPoint = new u(e.x, e.y);
    }, p.prototype.lineTo = function(t, e) {
        if (isNaN(t) || isNaN(e)) throw o.error("jsPDF.context2d.lineTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.lineTo");
        var n = this.ctx.transform.applyToPoint(new u(t, e));
        this.path.push({
            type: "lt",
            x: n.x,
            y: n.y
        }), this.ctx.lastPoint = new u(n.x, n.y);
    }, p.prototype.clip = function() {
        this.ctx.clip_path = JSON.parse(JSON.stringify(this.path)), x.call(this, null, !0);
    }, p.prototype.quadraticCurveTo = function(t, e, n, r) {
        if (isNaN(n) || isNaN(r) || isNaN(t) || isNaN(e)) throw o.error("jsPDF.context2d.quadraticCurveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.quadraticCurveTo");
        var i = this.ctx.transform.applyToPoint(new u(n, r)), a = this.ctx.transform.applyToPoint(new u(t, e));
        this.path.push({
            type: "qct",
            x1: a.x,
            y1: a.y,
            x: i.x,
            y: i.y
        }), this.ctx.lastPoint = new u(i.x, i.y);
    }, p.prototype.bezierCurveTo = function(t, e, n, r, i, a) {
        if (isNaN(i) || isNaN(a) || isNaN(t) || isNaN(e) || isNaN(n) || isNaN(r)) throw o.error("jsPDF.context2d.bezierCurveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.bezierCurveTo");
        var s = this.ctx.transform.applyToPoint(new u(i, a)), c = this.ctx.transform.applyToPoint(new u(t, e)), l = this.ctx.transform.applyToPoint(new u(n, r));
        this.path.push({
            type: "bct",
            x1: c.x,
            y1: c.y,
            x2: l.x,
            y2: l.y,
            x: s.x,
            y: s.y
        }), this.ctx.lastPoint = new u(s.x, s.y);
    }, p.prototype.arc = function(t, e, n, r, i, a) {
        if (isNaN(t) || isNaN(e) || isNaN(n) || isNaN(r) || isNaN(i)) throw o.error("jsPDF.context2d.arc: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.arc");
        if (a = Boolean(a), !this.ctx.transform.isIdentity) {
            var s = this.ctx.transform.applyToPoint(new u(t, e));
            t = s.x, e = s.y;
            var c = this.ctx.transform.applyToPoint(new u(0, n)), l = this.ctx.transform.applyToPoint(new u(0, 0));
            n = Math.sqrt(Math.pow(c.x - l.x, 2) + Math.pow(c.y - l.y, 2));
        }
        Math.abs(i - r) >= 2 * Math.PI && (r = 0, i = 2 * Math.PI), this.path.push({
            type: "arc",
            x: t,
            y: e,
            radius: n,
            startAngle: r,
            endAngle: i,
            counterclockwise: a
        });
    }, p.prototype.arcTo = function(t, e, n, r, i) {
        throw new Error("arcTo not implemented.");
    }, p.prototype.rect = function(t, e, n, r) {
        if (isNaN(t) || isNaN(e) || isNaN(n) || isNaN(r)) throw o.error("jsPDF.context2d.rect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.rect");
        this.moveTo(t, e), this.lineTo(t + n, e), this.lineTo(t + n, e + r), this.lineTo(t, e + r), this.lineTo(t, e), this.lineTo(t + n, e), this.lineTo(t, e);
    }, p.prototype.fillRect = function(t, e, n, r) {
        if (isNaN(t) || isNaN(e) || isNaN(n) || isNaN(r)) throw o.error("jsPDF.context2d.fillRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.fillRect");
        if (!m.call(this)) {
            var i = {};
            "butt" !== this.lineCap && (i.lineCap = this.lineCap, this.lineCap = "butt"), "miter" !== this.lineJoin && (i.lineJoin = this.lineJoin, this.lineJoin = "miter"), this.beginPath(), this.rect(t, e, n, r), this.fill(), i.hasOwnProperty("lineCap") && (this.lineCap = i.lineCap), i.hasOwnProperty("lineJoin") && (this.lineJoin = i.lineJoin);
        }
    }, p.prototype.strokeRect = function(t, e, n, r) {
        if (isNaN(t) || isNaN(e) || isNaN(n) || isNaN(r)) throw o.error("jsPDF.context2d.strokeRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.strokeRect");
        v.call(this) || (this.beginPath(), this.rect(t, e, n, r), this.stroke());
    }, p.prototype.clearRect = function(t, e, n, r) {
        if (isNaN(t) || isNaN(e) || isNaN(n) || isNaN(r)) throw o.error("jsPDF.context2d.clearRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.clearRect");
        this.ignoreClearRect || (this.fillStyle = "#ffffff", this.fillRect(t, e, n, r));
    }, p.prototype.save = function(t) {
        t = "boolean" != typeof t || t;
        for(var e = this.pdf.internal.getCurrentPageInfo().pageNumber, n = 0; n < this.pdf.internal.getNumberOfPages(); n++)this.pdf.setPage(n + 1), this.pdf.internal.out("q");
        if (this.pdf.setPage(e), t) {
            this.ctx.fontSize = this.pdf.internal.getFontSize();
            var r = new d(this.ctx);
            this.ctxStack.push(this.ctx), this.ctx = r;
        }
    }, p.prototype.restore = function(t) {
        t = "boolean" != typeof t || t;
        for(var e = this.pdf.internal.getCurrentPageInfo().pageNumber, n = 0; n < this.pdf.internal.getNumberOfPages(); n++)this.pdf.setPage(n + 1), this.pdf.internal.out("Q");
        this.pdf.setPage(e), t && 0 !== this.ctxStack.length && (this.ctx = this.ctxStack.pop(), this.fillStyle = this.ctx.fillStyle, this.strokeStyle = this.ctx.strokeStyle, this.font = this.ctx.font, this.lineCap = this.ctx.lineCap, this.lineWidth = this.ctx.lineWidth, this.lineJoin = this.ctx.lineJoin, this.lineDash = this.ctx.lineDash, this.lineDashOffset = this.ctx.lineDashOffset);
    }, p.prototype.toDataURL = function() {
        throw new Error("toDataUrl not implemented.");
    };
    var g = function(t) {
        var e, n, r, i;
        if (!0 === t.isCanvasGradient && (t = t.getColor()), !t) return {
            r: 0,
            g: 0,
            b: 0,
            a: 0,
            style: t
        };
        if (/transparent|rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*0+\s*\)/.test(t)) e = 0, n = 0, r = 0, i = 0;
        else {
            var a = /rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/.exec(t);
            if (null !== a) e = parseInt(a[1]), n = parseInt(a[2]), r = parseInt(a[3]), i = 1;
            else if (null !== (a = /rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([\d.]+)\s*\)/.exec(t))) e = parseInt(a[1]), n = parseInt(a[2]), r = parseInt(a[3]), i = parseFloat(a[4]);
            else {
                if (i = 1, "string" == typeof t && "#" !== t.charAt(0)) {
                    var o = new h(t);
                    t = o.ok ? o.toHex() : "#000000";
                }
                4 === t.length ? (e = t.substring(1, 2), e += e, n = t.substring(2, 3), n += n, r = t.substring(3, 4), r += r) : (e = t.substring(1, 3), n = t.substring(3, 5), r = t.substring(5, 7)), e = parseInt(e, 16), n = parseInt(n, 16), r = parseInt(r, 16);
            }
        }
        return {
            r: e,
            g: n,
            b: r,
            a: i,
            style: t
        };
    }, m = function() {
        return this.ctx.isFillTransparent || 0 == this.globalAlpha;
    }, v = function() {
        return Boolean(this.ctx.isStrokeTransparent || 0 == this.globalAlpha);
    };
    p.prototype.fillText = function(t, e, n, r) {
        if (isNaN(e) || isNaN(n) || "string" != typeof t) throw o.error("jsPDF.context2d.fillText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.fillText");
        if (r = isNaN(r) ? void 0 : r, !m.call(this)) {
            var i = E(this.ctx.transform.rotation), a = this.ctx.transform.scaleX;
            j.call(this, {
                text: t,
                x: e,
                y: n,
                scale: a,
                angle: i,
                align: this.textAlign,
                maxWidth: r
            });
        }
    }, p.prototype.strokeText = function(t, e, n, r) {
        if (isNaN(e) || isNaN(n) || "string" != typeof t) throw o.error("jsPDF.context2d.strokeText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.strokeText");
        if (!v.call(this)) {
            r = isNaN(r) ? void 0 : r;
            var i = E(this.ctx.transform.rotation), a = this.ctx.transform.scaleX;
            j.call(this, {
                text: t,
                x: e,
                y: n,
                scale: a,
                renderingMode: "stroke",
                angle: i,
                align: this.textAlign,
                maxWidth: r
            });
        }
    }, p.prototype.measureText = function(t) {
        if ("string" != typeof t) throw o.error("jsPDF.context2d.measureText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.measureText");
        var e = this.pdf, n = this.pdf.internal.scaleFactor, r = e.internal.getFontSize(), i = e.getStringUnitWidth(t) * r / e.internal.scaleFactor;
        return new function(t) {
            var e = (t = t || {}).width || 0;
            return Object.defineProperty(this, "width", {
                get: function() {
                    return e;
                }
            }), this;
        }({
            width: i *= Math.round(96 * n / 72 * 1e4) / 1e4
        });
    }, p.prototype.scale = function(t, e) {
        if (isNaN(t) || isNaN(e)) throw o.error("jsPDF.context2d.scale: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.scale");
        var n = new l(t, 0, 0, e, 0, 0);
        this.ctx.transform = this.ctx.transform.multiply(n);
    }, p.prototype.rotate = function(t) {
        if (isNaN(t)) throw o.error("jsPDF.context2d.rotate: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.rotate");
        var e = new l(Math.cos(t), Math.sin(t), -Math.sin(t), Math.cos(t), 0, 0);
        this.ctx.transform = this.ctx.transform.multiply(e);
    }, p.prototype.translate = function(t, e) {
        if (isNaN(t) || isNaN(e)) throw o.error("jsPDF.context2d.translate: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.translate");
        var n = new l(1, 0, 0, 1, t, e);
        this.ctx.transform = this.ctx.transform.multiply(n);
    }, p.prototype.transform = function(t, e, n, r, i, a) {
        if (isNaN(t) || isNaN(e) || isNaN(n) || isNaN(r) || isNaN(i) || isNaN(a)) throw o.error("jsPDF.context2d.transform: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.transform");
        var s = new l(t, e, n, r, i, a);
        this.ctx.transform = this.ctx.transform.multiply(s);
    }, p.prototype.setTransform = function(t, e, n, r, i, a) {
        t = isNaN(t) ? 1 : t, e = isNaN(e) ? 0 : e, n = isNaN(n) ? 0 : n, r = isNaN(r) ? 1 : r, i = isNaN(i) ? 0 : i, a = isNaN(a) ? 0 : a, this.ctx.transform = new l(t, e, n, r, i, a);
    };
    var b = function() {
        return this.margin[0] > 0 || this.margin[1] > 0 || this.margin[2] > 0 || this.margin[3] > 0;
    };
    p.prototype.drawImage = function(t, e, n, r, i, a, o, s, u) {
        var h = this.pdf.getImageProperties(t), f = 1, d = 1, p = 1, g = 1;
        void 0 !== r && void 0 !== s && (p = s / r, g = u / i, f = h.width / r * s / r, d = h.height / i * u / i), void 0 === a && (a = e, o = n, e = 0, n = 0), void 0 !== r && void 0 === s && (s = r, u = i), void 0 === r && void 0 === s && (s = h.width, u = h.height);
        for(var m, v = this.ctx.transform.decompose(), w = E(v.rotate.shx), x = new l, S = (x = (x = (x = x.multiply(v.translate)).multiply(v.skew)).multiply(v.scale)).applyToRectangle(new c(a - e * p, o - n * g, r * f, i * d)), _ = y.call(this, S), P = [], k = 0; k < _.length; k += 1)-1 === P.indexOf(_[k]) && P.push(_[k]);
        if (L(P), this.autoPaging) for(var F = P[0], I = P[P.length - 1], j = F; j < I + 1; j++){
            this.pdf.setPage(j);
            var C = this.pdf.internal.pageSize.width - this.margin[3] - this.margin[1], O = 1 === j ? this.posY + this.margin[0] : this.margin[0], B = this.pdf.internal.pageSize.height - this.posY - this.margin[0] - this.margin[2], M = this.pdf.internal.pageSize.height - this.margin[0] - this.margin[2], q = 1 === j ? 0 : B + (j - 2) * M;
            if (0 !== this.ctx.clip_path.length) {
                var R = this.path;
                m = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = N(m, this.posX + this.margin[3], -q + O + this.ctx.prevPageLastElemOffset), A.call(this, "fill", !0), this.path = R;
            }
            var D = JSON.parse(JSON.stringify(S));
            D = N([
                D
            ], this.posX + this.margin[3], -q + O + this.ctx.prevPageLastElemOffset)[0];
            var T = (j > F || j < I) && b.call(this);
            T && (this.pdf.saveGraphicsState(), this.pdf.rect(this.margin[3], this.margin[0], C, M, null).clip().discardPath()), this.pdf.addImage(t, "JPEG", D.x, D.y, D.w, D.h, null, null, w), T && this.pdf.restoreGraphicsState();
        }
        else this.pdf.addImage(t, "JPEG", S.x, S.y, S.w, S.h, null, null, w);
    };
    var y = function(t, e, n) {
        var r = [];
        e = e || this.pdf.internal.pageSize.width, n = n || this.pdf.internal.pageSize.height - this.margin[0] - this.margin[2];
        var i = this.posY + this.ctx.prevPageLastElemOffset;
        switch(t.type){
            default:
            case "mt":
            case "lt":
                r.push(Math.floor((t.y + i) / n) + 1);
                break;
            case "arc":
                r.push(Math.floor((t.y + i - t.radius) / n) + 1), r.push(Math.floor((t.y + i + t.radius) / n) + 1);
                break;
            case "qct":
                var a = R(this.ctx.lastPoint.x, this.ctx.lastPoint.y, t.x1, t.y1, t.x, t.y);
                r.push(Math.floor((a.y + i) / n) + 1), r.push(Math.floor((a.y + a.h + i) / n) + 1);
                break;
            case "bct":
                var o = D(this.ctx.lastPoint.x, this.ctx.lastPoint.y, t.x1, t.y1, t.x2, t.y2, t.x, t.y);
                r.push(Math.floor((o.y + i) / n) + 1), r.push(Math.floor((o.y + o.h + i) / n) + 1);
                break;
            case "rect":
                r.push(Math.floor((t.y + i) / n) + 1), r.push(Math.floor((t.y + t.h + i) / n) + 1);
        }
        for(var s = 0; s < r.length; s += 1)for(; this.pdf.internal.getNumberOfPages() < r[s];)w.call(this);
        return r;
    }, w = function() {
        var t = this.fillStyle, e = this.strokeStyle, n = this.font, r = this.lineCap, i = this.lineWidth, a = this.lineJoin;
        this.pdf.addPage(), this.fillStyle = t, this.strokeStyle = e, this.font = n, this.lineCap = r, this.lineWidth = i, this.lineJoin = a;
    }, N = function(t, e, n) {
        for(var r = 0; r < t.length; r++)switch(t[r].type){
            case "bct":
                t[r].x2 += e, t[r].y2 += n;
            case "qct":
                t[r].x1 += e, t[r].y1 += n;
            default:
                t[r].x += e, t[r].y += n;
        }
        return t;
    }, L = function(t) {
        return t.sort(function(t, e) {
            return t - e;
        });
    }, x = function(t, e) {
        for(var n, r, i = this.fillStyle, a = this.strokeStyle, o = this.lineCap, s = this.lineWidth, u = Math.abs(s * this.ctx.transform.scaleX), c = this.lineJoin, l = JSON.parse(JSON.stringify(this.path)), h = JSON.parse(JSON.stringify(this.path)), f = [], d = 0; d < h.length; d++)if (void 0 !== h[d].x) for(var p = y.call(this, h[d]), g = 0; g < p.length; g += 1)-1 === f.indexOf(p[g]) && f.push(p[g]);
        for(var m = 0; m < f.length; m++)for(; this.pdf.internal.getNumberOfPages() < f[m];)w.call(this);
        if (L(f), this.autoPaging) for(var v = f[0], x = f[f.length - 1], S = v; S < x + 1; S++){
            this.pdf.setPage(S), this.fillStyle = i, this.strokeStyle = a, this.lineCap = o, this.lineWidth = u, this.lineJoin = c;
            var _ = this.pdf.internal.pageSize.width - this.margin[3] - this.margin[1], P = 1 === S ? this.posY + this.margin[0] : this.margin[0], k = this.pdf.internal.pageSize.height - this.posY - this.margin[0] - this.margin[2], F = this.pdf.internal.pageSize.height - this.margin[0] - this.margin[2], I = 1 === S ? 0 : k + (S - 2) * F;
            if (0 !== this.ctx.clip_path.length) {
                var j = this.path;
                n = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = N(n, this.posX + this.margin[3], -I + P + this.ctx.prevPageLastElemOffset), A.call(this, t, !0), this.path = j;
            }
            if (r = JSON.parse(JSON.stringify(l)), this.path = N(r, this.posX + this.margin[3], -I + P + this.ctx.prevPageLastElemOffset), !1 === e || 0 === S) {
                var C = (S > v || S < x) && b.call(this);
                C && (this.pdf.saveGraphicsState(), this.pdf.rect(this.margin[3], this.margin[0], _, F, null).clip().discardPath()), A.call(this, t, e), C && this.pdf.restoreGraphicsState();
            }
            this.lineWidth = s;
        }
        else this.lineWidth = u, A.call(this, t, e), this.lineWidth = s;
        this.path = l;
    }, A = function(t, e) {
        if (("stroke" !== t || e || !v.call(this)) && ("stroke" === t || e || !m.call(this))) {
            for(var n, r, i = [], a = this.path, o = 0; o < a.length; o++){
                var s = a[o];
                switch(s.type){
                    case "begin":
                        i.push({
                            begin: !0
                        });
                        break;
                    case "close":
                        i.push({
                            close: !0
                        });
                        break;
                    case "mt":
                        i.push({
                            start: s,
                            deltas: [],
                            abs: []
                        });
                        break;
                    case "lt":
                        var u = i.length;
                        if (a[o - 1] && !isNaN(a[o - 1].x) && (n = [
                            s.x - a[o - 1].x,
                            s.y - a[o - 1].y
                        ], u > 0)) {
                            for(; u >= 0; u--)if (!0 !== i[u - 1].close && !0 !== i[u - 1].begin) {
                                i[u - 1].deltas.push(n), i[u - 1].abs.push(s);
                                break;
                            }
                        }
                        break;
                    case "bct":
                        n = [
                            s.x1 - a[o - 1].x,
                            s.y1 - a[o - 1].y,
                            s.x2 - a[o - 1].x,
                            s.y2 - a[o - 1].y,
                            s.x - a[o - 1].x,
                            s.y - a[o - 1].y
                        ], i[i.length - 1].deltas.push(n);
                        break;
                    case "qct":
                        var c = a[o - 1].x + 2 / 3 * (s.x1 - a[o - 1].x), l = a[o - 1].y + 2 / 3 * (s.y1 - a[o - 1].y), h = s.x + 2 / 3 * (s.x1 - s.x), f = s.y + 2 / 3 * (s.y1 - s.y), d = s.x, p = s.y;
                        n = [
                            c - a[o - 1].x,
                            l - a[o - 1].y,
                            h - a[o - 1].x,
                            f - a[o - 1].y,
                            d - a[o - 1].x,
                            p - a[o - 1].y
                        ], i[i.length - 1].deltas.push(n);
                        break;
                    case "arc":
                        i.push({
                            deltas: [],
                            abs: [],
                            arc: !0
                        }), Array.isArray(i[i.length - 1].abs) && i[i.length - 1].abs.push(s);
                }
            }
            r = e ? null : "stroke" === t ? "stroke" : "fill";
            for(var g = !1, b = 0; b < i.length; b++)if (i[b].arc) for(var y = i[b].abs, w = 0; w < y.length; w++){
                var N = y[w];
                "arc" === N.type ? P.call(this, N.x, N.y, N.radius, N.startAngle, N.endAngle, N.counterclockwise, void 0, e, !g) : C.call(this, N.x, N.y), g = !0;
            }
            else if (!0 === i[b].close) this.pdf.internal.out("h"), g = !1;
            else if (!0 !== i[b].begin) {
                var L = i[b].start.x, x = i[b].start.y;
                O.call(this, i[b].deltas, L, x), g = !0;
            }
            r && k.call(this, r), e && F.call(this);
        }
    }, S = function(t) {
        var e = this.pdf.internal.getFontSize() / this.pdf.internal.scaleFactor, n = e * (this.pdf.internal.getLineHeightFactor() - 1);
        switch(this.ctx.textBaseline){
            case "bottom":
                return t - n;
            case "top":
                return t + e - n;
            case "hanging":
                return t + e - 2 * n;
            case "middle":
                return t + e / 2 - n;
            default:
                return t;
        }
    }, _ = function(t) {
        return t + this.pdf.internal.getFontSize() / this.pdf.internal.scaleFactor * (this.pdf.internal.getLineHeightFactor() - 1);
    };
    p.prototype.createLinearGradient = function() {
        var t = function() {};
        return t.colorStops = [], t.addColorStop = function(t, e) {
            this.colorStops.push([
                t,
                e
            ]);
        }, t.getColor = function() {
            return 0 === this.colorStops.length ? "#000000" : this.colorStops[0][1];
        }, t.isCanvasGradient = !0, t;
    }, p.prototype.createPattern = function() {
        return this.createLinearGradient();
    }, p.prototype.createRadialGradient = function() {
        return this.createLinearGradient();
    };
    var P = function(t, e, n, r, i, a, o, s, u) {
        for(var c = M.call(this, n, r, i, a), l = 0; l < c.length; l++){
            var h = c[l];
            0 === l && (u ? I.call(this, h.x1 + t, h.y1 + e) : C.call(this, h.x1 + t, h.y1 + e)), B.call(this, t, e, h.x2, h.y2, h.x3, h.y3, h.x4, h.y4);
        }
        s ? F.call(this) : k.call(this, o);
    }, k = function(t) {
        switch(t){
            case "stroke":
                this.pdf.internal.out("S");
                break;
            case "fill":
                this.pdf.internal.out("f");
        }
    }, F = function() {
        this.pdf.clip(), this.pdf.discardPath();
    }, I = function(t, e) {
        this.pdf.internal.out(r(t) + " " + i(e) + " m");
    }, j = function(t) {
        var e;
        switch(t.align){
            case "right":
            case "end":
                e = "right";
                break;
            case "center":
                e = "center";
                break;
            default:
                e = "left";
        }
        var n = this.pdf.getTextDimensions(t.text), r = S.call(this, t.y), i = _.call(this, r) - n.h, a = this.ctx.transform.applyToPoint(new u(t.x, r)), o = this.ctx.transform.decompose(), s = new l;
        s = (s = (s = s.multiply(o.translate)).multiply(o.skew)).multiply(o.scale);
        for(var h, f, d, p = this.ctx.transform.applyToRectangle(new c(t.x, r, n.w, n.h)), g = s.applyToRectangle(new c(t.x, i, n.w, n.h)), m = y.call(this, g), v = [], w = 0; w < m.length; w += 1)-1 === v.indexOf(m[w]) && v.push(m[w]);
        if (L(v), this.autoPaging) for(var x = v[0], P = v[v.length - 1], k = x; k < P + 1; k++){
            this.pdf.setPage(k);
            var F = 1 === k ? this.posY + this.margin[0] : this.margin[0], I = this.pdf.internal.pageSize.height - this.posY - this.margin[0] - this.margin[2], j = this.pdf.internal.pageSize.height - this.margin[2], C = j - this.margin[0], O = this.pdf.internal.pageSize.width - this.margin[1], B = O - this.margin[3], M = 1 === k ? 0 : I + (k - 2) * C;
            if (0 !== this.ctx.clip_path.length) {
                var q = this.path;
                h = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = N(h, this.posX + this.margin[3], -1 * M + F), A.call(this, "fill", !0), this.path = q;
            }
            var E = N([
                JSON.parse(JSON.stringify(g))
            ], this.posX + this.margin[3], -M + F + this.ctx.prevPageLastElemOffset)[0];
            t.scale >= .01 && (f = this.pdf.internal.getFontSize(), this.pdf.setFontSize(f * t.scale), d = this.lineWidth, this.lineWidth = d * t.scale);
            var R = "text" !== this.autoPaging;
            if (R || E.y + E.h <= j) {
                if (R || E.y >= F && E.x <= O) {
                    var D = R ? t.text : this.pdf.splitTextToSize(t.text, t.maxWidth || O - E.x)[0], T = N([
                        JSON.parse(JSON.stringify(p))
                    ], this.posX + this.margin[3], -M + F + this.ctx.prevPageLastElemOffset)[0], z = R && (k > x || k < P) && b.call(this);
                    z && (this.pdf.saveGraphicsState(), this.pdf.rect(this.margin[3], this.margin[0], B, C, null).clip().discardPath()), this.pdf.text(D, T.x, T.y, {
                        angle: t.angle,
                        align: e,
                        renderingMode: t.renderingMode
                    }), z && this.pdf.restoreGraphicsState();
                }
            } else E.y < j && (this.ctx.prevPageLastElemOffset += j - E.y);
            t.scale >= .01 && (this.pdf.setFontSize(f), this.lineWidth = d);
        }
        else t.scale >= .01 && (f = this.pdf.internal.getFontSize(), this.pdf.setFontSize(f * t.scale), d = this.lineWidth, this.lineWidth = d * t.scale), this.pdf.text(t.text, a.x + this.posX, a.y + this.posY, {
            angle: t.angle,
            align: e,
            renderingMode: t.renderingMode,
            maxWidth: t.maxWidth
        }), t.scale >= .01 && (this.pdf.setFontSize(f), this.lineWidth = d);
    }, C = function(t, e, n, a) {
        n = n || 0, a = a || 0, this.pdf.internal.out(r(t + n) + " " + i(e + a) + " l");
    }, O = function(t, e, n) {
        return this.pdf.lines(t, e, n, null, null);
    }, B = function(t, e, r, i, o, u, c, l) {
        this.pdf.internal.out([
            n(a(r + t)),
            n(s(i + e)),
            n(a(o + t)),
            n(s(u + e)),
            n(a(c + t)),
            n(s(l + e)),
            "c"
        ].join(" "));
    }, M = function(t, e, n, r) {
        for(var i = 2 * Math.PI, a = Math.PI / 2; e > n;)e -= i;
        var o = Math.abs(n - e);
        o < i && r && (o = i - o);
        for(var s = [], u = r ? -1 : 1, c = e; o > 1e-5;){
            var l = c + u * Math.min(o, a);
            s.push(q.call(this, t, c, l)), o -= Math.abs(l - c), c = l;
        }
        return s;
    }, q = function(t, e, n) {
        var r = (n - e) / 2, i = t * Math.cos(r), a = t * Math.sin(r), o = i, s = -a, u = o * o + s * s, c = u + o * i + s * a, l = 4 / 3 * (Math.sqrt(2 * u * c) - c) / (o * a - s * i), h = o - l * s, f = s + l * o, d = h, p = -f, g = r + e, m = Math.cos(g), v = Math.sin(g);
        return {
            x1: t * Math.cos(e),
            y1: t * Math.sin(e),
            x2: h * m - f * v,
            y2: h * v + f * m,
            x3: d * m - p * v,
            y3: d * v + p * m,
            x4: t * Math.cos(n),
            y4: t * Math.sin(n)
        };
    }, E = function(t) {
        return 180 * t / Math.PI;
    }, R = function(t, e, n, r, i, a) {
        var o = t + .5 * (n - t), s = e + .5 * (r - e), u = i + .5 * (n - i), l = a + .5 * (r - a), h = Math.min(t, i, o, u), f = Math.max(t, i, o, u), d = Math.min(e, a, s, l), p = Math.max(e, a, s, l);
        return new c(h, d, f - h, p - d);
    }, D = function(t, e, n, r, i, a, o, s) {
        var u, l, h, f, d, p, g, m, v, b, y, w, N, L, x = n - t, A = r - e, S = i - n, _ = a - r, P = o - i, k = s - a;
        for(l = 0; l < 41; l++)v = (g = (h = t + (u = l / 40) * x) + u * ((d = n + u * S) - h)) + u * (d + u * (i + u * P - d) - g), b = (m = (f = e + u * A) + u * ((p = r + u * _) - f)) + u * (p + u * (a + u * k - p) - m), 0 == l ? (y = v, w = b, N = v, L = b) : (y = Math.min(y, v), w = Math.min(w, b), N = Math.max(N, v), L = Math.max(L, b));
        return new c(Math.round(y), Math.round(w), Math.round(N - y), Math.round(L - w));
    }, T = function() {
        if (this.prevLineDash || this.ctx.lineDash.length || this.ctx.lineDashOffset) {
            var t, e, n = (t = this.ctx.lineDash, e = this.ctx.lineDashOffset, JSON.stringify({
                lineDash: t,
                lineDashOffset: e
            }));
            this.prevLineDash !== n && (this.pdf.setLineDash(this.ctx.lineDash, this.ctx.lineDashOffset), this.prevLineDash = n);
        }
    };
}(E.API), /**
 * @license
 * jsPDF filters PlugIn
 * Copyright (c) 2014 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var n = function(t) {
        var e, n, r, i, a, o, s, u, c, l;
        for(/[^\x00-\xFF]/.test(t), n = [], r = 0, i = (t += e = "\0\0\0\0".slice(t.length % 4 || 4)).length; i > r; r += 4)0 !== (a = (t.charCodeAt(r) << 24) + (t.charCodeAt(r + 1) << 16) + (t.charCodeAt(r + 2) << 8) + t.charCodeAt(r + 3)) ? (o = (a = ((a = ((a = ((a = (a - (l = a % 85)) / 85) - (c = a % 85)) / 85) - (u = a % 85)) / 85) - (s = a % 85)) / 85) % 85, n.push(o + 33, s + 33, u + 33, c + 33, l + 33)) : n.push(122);
        return function(t, e) {
            for(var n = e; n > 0; n--)t.pop();
        }(n, e.length), String.fromCharCode.apply(String, n) + "~>";
    }, r = function(t) {
        var e, n, r, i, a, o = String, s = "length", u = 255, c = "charCodeAt", l = "slice", h = "replace";
        for(t[l](-2), t = t[l](0, -2)[h](/\s/g, "")[h]("z", "!!!!!"), r = [], i = 0, a = (t += e = "uuuuu"[l](t[s] % 5 || 5))[s]; a > i; i += 5)n = 52200625 * (t[c](i) - 33) + 614125 * (t[c](i + 1) - 33) + 7225 * (t[c](i + 2) - 33) + 85 * (t[c](i + 3) - 33) + (t[c](i + 4) - 33), r.push(u & n >> 24, u & n >> 16, u & n >> 8, u & n);
        return function(t, e) {
            for(var n = e; n > 0; n--)t.pop();
        }(r, e[s]), o.fromCharCode.apply(o, r);
    }, i = function(t) {
        return t.split("").map(function(t) {
            return ("0" + t.charCodeAt().toString(16)).slice(-2);
        }).join("") + ">";
    }, a = function(t) {
        var e = new RegExp(/^([0-9A-Fa-f]{2})+$/);
        if (-1 !== (t = t.replace(/\s/g, "")).indexOf(">") && (t = t.substr(0, t.indexOf(">"))), t.length % 2 && (t += "0"), !1 === e.test(t)) return "";
        for(var n = "", r = 0; r < t.length; r += 2)n += String.fromCharCode("0x" + (t[r] + t[r + 1]));
        return n;
    }, o = function(t) {
        for(var n = new Uint8Array(t.length), r = t.length; r--;)n[r] = t.charCodeAt(r);
        return (n = (0, _fflate.zlibSync)(n)).reduce(function(t, e) {
            return t + String.fromCharCode(e);
        }, "");
    };
    t.processDataByFilters = function(t, e) {
        var s = 0, u = t || "", c = [];
        for("string" == typeof (e = e || []) && (e = [
            e
        ]), s = 0; s < e.length; s += 1)switch(e[s]){
            case "ASCII85Decode":
            case "/ASCII85Decode":
                u = r(u), c.push("/ASCII85Encode");
                break;
            case "ASCII85Encode":
            case "/ASCII85Encode":
                u = n(u), c.push("/ASCII85Decode");
                break;
            case "ASCIIHexDecode":
            case "/ASCIIHexDecode":
                u = a(u), c.push("/ASCIIHexEncode");
                break;
            case "ASCIIHexEncode":
            case "/ASCIIHexEncode":
                u = i(u), c.push("/ASCIIHexDecode");
                break;
            case "FlateEncode":
            case "/FlateEncode":
                u = o(u), c.push("/FlateDecode");
                break;
            default:
                throw new Error('The filter: "' + e[s] + '" is not implemented');
        }
        return {
            data: u,
            reverseChain: c.reverse().join(" ")
        };
    };
}(E.API), /**
 * @license
 * jsPDF fileloading PlugIn
 * Copyright (c) 2018 Aras Abbasi (aras.abbasi@gmail.com)
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    t.loadFile = function(t, e, n) {
        return function(t, e, n) {
            e = !1 !== e, n = "function" == typeof n ? n : function() {};
            var r = void 0;
            try {
                r = function(t, e, n) {
                    var r = new XMLHttpRequest, i = 0, a = function(t) {
                        var e = t.length, n = [], r = String.fromCharCode;
                        for(i = 0; i < e; i += 1)n.push(r(255 & t.charCodeAt(i)));
                        return n.join("");
                    };
                    if (r.open("GET", t, !e), r.overrideMimeType("text/plain; charset=x-user-defined"), !1 === e && (r.onload = function() {
                        200 === r.status ? n(a(this.responseText)) : n(void 0);
                    }), r.send(null), e && 200 === r.status) return a(r.responseText);
                }(t, e, n);
            } catch (i) {}
            return r;
        }(t, e, n);
    }, t.loadImageFile = t.loadFile;
}(E.API), function(e) {
    function n() {
        return (i.html2canvas ? Promise.resolve(i.html2canvas) : require("e35ed7d1af132742")).catch(function(t) {
            return Promise.reject(new Error("Could not load html2canvas: " + t));
        }).then(function(t) {
            return t.default ? t.default : t;
        });
    }
    function r() {
        return (i.DOMPurify ? Promise.resolve(i.DOMPurify) : require("fd4d839f94e36dff")).catch(function(t) {
            return Promise.reject(new Error("Could not load dompurify: " + t));
        }).then(function(t) {
            return t.default ? t.default : t;
        });
    }
    var a = function(e) {
        var n = (0, _typeofDefault.default)(e);
        return "undefined" === n ? "undefined" : "string" === n || e instanceof String ? "string" : "number" === n || e instanceof Number ? "number" : "function" === n || e instanceof Function ? "function" : e && e.constructor === Array ? "array" : e && 1 === e.nodeType ? "element" : "object" === n ? "object" : "unknown";
    }, o = function(t, e) {
        var n = document.createElement(t);
        for(var r in e.className && (n.className = e.className), e.innerHTML && e.dompurify && (n.innerHTML = e.dompurify.sanitize(e.innerHTML)), e.style)n.style[r] = e.style[r];
        return n;
    }, s = function t(e, n) {
        for(var r = 3 === e.nodeType ? document.createTextNode(e.nodeValue) : e.cloneNode(!1), i = e.firstChild; i; i = i.nextSibling)!0 !== n && 1 === i.nodeType && "SCRIPT" === i.nodeName || r.appendChild(t(i, n));
        return 1 === e.nodeType && ("CANVAS" === e.nodeName ? (r.width = e.width, r.height = e.height, r.getContext("2d").drawImage(e, 0, 0)) : "TEXTAREA" !== e.nodeName && "SELECT" !== e.nodeName || (r.value = e.value), r.addEventListener("load", function() {
            r.scrollTop = e.scrollTop, r.scrollLeft = e.scrollLeft;
        }, !0)), r;
    }, u = function t(e) {
        var n = Object.assign(t.convert(Promise.resolve()), JSON.parse(JSON.stringify(t.template))), r = t.convert(Promise.resolve(), n);
        return (r = r.setProgress(1, t, 1, [
            t
        ])).set(e);
    };
    (u.prototype = Object.create(Promise.prototype)).constructor = u, u.convert = function(t, e) {
        return t.__proto__ = e || u.prototype, t;
    }, u.template = {
        prop: {
            src: null,
            container: null,
            overlay: null,
            canvas: null,
            img: null,
            pdf: null,
            pageSize: null,
            callback: function() {}
        },
        progress: {
            val: 0,
            state: null,
            n: 0,
            stack: []
        },
        opt: {
            filename: "file.pdf",
            margin: [
                0,
                0,
                0,
                0
            ],
            enableLinks: !0,
            x: 0,
            y: 0,
            html2canvas: {},
            jsPDF: {},
            backgroundColor: "transparent"
        }
    }, u.prototype.from = function(t, e) {
        return this.then(function() {
            switch(e = e || function(t) {
                switch(a(t)){
                    case "string":
                        return "string";
                    case "element":
                        return "canvas" === t.nodeName.toLowerCase() ? "canvas" : "element";
                    default:
                        return "unknown";
                }
            }(t), e){
                case "string":
                    return this.then(r).then(function(e) {
                        return this.set({
                            src: o("div", {
                                innerHTML: t,
                                dompurify: e
                            })
                        });
                    });
                case "element":
                    return this.set({
                        src: t
                    });
                case "canvas":
                    return this.set({
                        canvas: t
                    });
                case "img":
                    return this.set({
                        img: t
                    });
                default:
                    return this.error("Unknown source type.");
            }
        });
    }, u.prototype.to = function(t) {
        switch(t){
            case "container":
                return this.toContainer();
            case "canvas":
                return this.toCanvas();
            case "img":
                return this.toImg();
            case "pdf":
                return this.toPdf();
            default:
                return this.error("Invalid target.");
        }
    }, u.prototype.toContainer = function() {
        return this.thenList([
            function() {
                return this.prop.src || this.error("Cannot duplicate - no source HTML.");
            },
            function() {
                return this.prop.pageSize || this.setPageSize();
            }
        ]).then(function() {
            var t = {
                position: "relative",
                display: "inline-block",
                width: ("number" != typeof this.opt.width || isNaN(this.opt.width) || "number" != typeof this.opt.windowWidth || isNaN(this.opt.windowWidth) ? Math.max(this.prop.src.clientWidth, this.prop.src.scrollWidth, this.prop.src.offsetWidth) : this.opt.windowWidth) + "px",
                left: 0,
                right: 0,
                top: 0,
                margin: "auto",
                backgroundColor: this.opt.backgroundColor
            }, e = s(this.prop.src, this.opt.html2canvas.javascriptEnabled);
            "BODY" === e.tagName && (t.height = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight) + "px"), this.prop.overlay = o("div", {
                className: "html2pdf__overlay",
                style: {
                    position: "fixed",
                    overflow: "hidden",
                    zIndex: 1e3,
                    left: "-100000px",
                    right: 0,
                    bottom: 0,
                    top: 0
                }
            }), this.prop.container = o("div", {
                className: "html2pdf__container",
                style: t
            }), this.prop.container.appendChild(e), this.prop.container.firstChild.appendChild(o("div", {
                style: {
                    clear: "both",
                    border: "0 none transparent",
                    margin: 0,
                    padding: 0,
                    height: 0
                }
            })), this.prop.container.style.float = "none", this.prop.overlay.appendChild(this.prop.container), document.body.appendChild(this.prop.overlay), this.prop.container.firstChild.style.position = "relative", this.prop.container.height = Math.max(this.prop.container.firstChild.clientHeight, this.prop.container.firstChild.scrollHeight, this.prop.container.firstChild.offsetHeight) + "px";
        });
    }, u.prototype.toCanvas = function() {
        var t = [
            function() {
                return document.body.contains(this.prop.container) || this.toContainer();
            }
        ];
        return this.thenList(t).then(n).then(function(t) {
            var e = Object.assign({}, this.opt.html2canvas);
            return delete e.onrendered, t(this.prop.container, e);
        }).then(function(t) {
            (this.opt.html2canvas.onrendered || function() {})(t), this.prop.canvas = t, document.body.removeChild(this.prop.overlay);
        });
    }, u.prototype.toContext2d = function() {
        var t = [
            function() {
                return document.body.contains(this.prop.container) || this.toContainer();
            }
        ];
        return this.thenList(t).then(n).then(function(t) {
            var e = this.opt.jsPDF, n = this.opt.fontFaces, r = "number" != typeof this.opt.width || isNaN(this.opt.width) || "number" != typeof this.opt.windowWidth || isNaN(this.opt.windowWidth) ? 1 : this.opt.width / this.opt.windowWidth, i = Object.assign({
                async: !0,
                allowTaint: !0,
                scale: r,
                scrollX: this.opt.scrollX || 0,
                scrollY: this.opt.scrollY || 0,
                backgroundColor: "#ffffff",
                imageTimeout: 15e3,
                logging: !0,
                proxy: null,
                removeContainer: !0,
                foreignObjectRendering: !1,
                useCORS: !1
            }, this.opt.html2canvas);
            if (delete i.onrendered, e.context2d.autoPaging = void 0 === this.opt.autoPaging || this.opt.autoPaging, e.context2d.posX = this.opt.x, e.context2d.posY = this.opt.y, e.context2d.margin = this.opt.margin, e.context2d.fontFaces = n, n) for(var a = 0; a < n.length; ++a){
                var o = n[a], s = o.src.find(function(t) {
                    return "truetype" === t.format;
                });
                s && e.addFont(s.url, o.ref.name, o.ref.style);
            }
            return i.windowHeight = i.windowHeight || 0, i.windowHeight = 0 == i.windowHeight ? Math.max(this.prop.container.clientHeight, this.prop.container.scrollHeight, this.prop.container.offsetHeight) : i.windowHeight, e.context2d.save(!0), t(this.prop.container, i);
        }).then(function(t) {
            this.opt.jsPDF.context2d.restore(!0), (this.opt.html2canvas.onrendered || function() {})(t), this.prop.canvas = t, document.body.removeChild(this.prop.overlay);
        });
    }, u.prototype.toImg = function() {
        return this.thenList([
            function() {
                return this.prop.canvas || this.toCanvas();
            }
        ]).then(function() {
            var t = this.prop.canvas.toDataURL("image/" + this.opt.image.type, this.opt.image.quality);
            this.prop.img = document.createElement("img"), this.prop.img.src = t;
        });
    }, u.prototype.toPdf = function() {
        return this.thenList([
            function() {
                return this.toContext2d();
            }
        ]).then(function() {
            this.prop.pdf = this.prop.pdf || this.opt.jsPDF;
        });
    }, u.prototype.output = function(t, e, n) {
        return "img" === (n = n || "pdf").toLowerCase() || "image" === n.toLowerCase() ? this.outputImg(t, e) : this.outputPdf(t, e);
    }, u.prototype.outputPdf = function(t, e) {
        return this.thenList([
            function() {
                return this.prop.pdf || this.toPdf();
            }
        ]).then(function() {
            return this.prop.pdf.output(t, e);
        });
    }, u.prototype.outputImg = function(t) {
        return this.thenList([
            function() {
                return this.prop.img || this.toImg();
            }
        ]).then(function() {
            switch(t){
                case void 0:
                case "img":
                    return this.prop.img;
                case "datauristring":
                case "dataurlstring":
                    return this.prop.img.src;
                case "datauri":
                case "dataurl":
                    return document.location.href = this.prop.img.src;
                default:
                    throw 'Image output type "' + t + '" is not supported.';
            }
        });
    }, u.prototype.save = function(t) {
        return this.thenList([
            function() {
                return this.prop.pdf || this.toPdf();
            }
        ]).set(t ? {
            filename: t
        } : null).then(function() {
            this.prop.pdf.save(this.opt.filename);
        });
    }, u.prototype.doCallback = function() {
        return this.thenList([
            function() {
                return this.prop.pdf || this.toPdf();
            }
        ]).then(function() {
            this.prop.callback(this.prop.pdf);
        });
    }, u.prototype.set = function(t) {
        if ("object" !== a(t)) return this;
        var e = Object.keys(t || {}).map(function(e) {
            if (e in u.template.prop) return function() {
                this.prop[e] = t[e];
            };
            switch(e){
                case "margin":
                    return this.setMargin.bind(this, t.margin);
                case "jsPDF":
                    return function() {
                        return this.opt.jsPDF = t.jsPDF, this.setPageSize();
                    };
                case "pageSize":
                    return this.setPageSize.bind(this, t.pageSize);
                default:
                    return function() {
                        this.opt[e] = t[e];
                    };
            }
        }, this);
        return this.then(function() {
            return this.thenList(e);
        });
    }, u.prototype.get = function(t, e) {
        return this.then(function() {
            var n = t in u.template.prop ? this.prop[t] : this.opt[t];
            return e ? e(n) : n;
        });
    }, u.prototype.setMargin = function(t) {
        return this.then(function() {
            switch(a(t)){
                case "number":
                    t = [
                        t,
                        t,
                        t,
                        t
                    ];
                case "array":
                    if (2 === t.length && (t = [
                        t[0],
                        t[1],
                        t[0],
                        t[1]
                    ]), 4 === t.length) break;
                default:
                    return this.error("Invalid margin array.");
            }
            this.opt.margin = t;
        }).then(this.setPageSize);
    }, u.prototype.setPageSize = function(t) {
        function e(t, e) {
            return Math.floor(t * e / 72 * 96);
        }
        return this.then(function() {
            (t = t || E.getPageSize(this.opt.jsPDF)).hasOwnProperty("inner") || (t.inner = {
                width: t.width - this.opt.margin[1] - this.opt.margin[3],
                height: t.height - this.opt.margin[0] - this.opt.margin[2]
            }, t.inner.px = {
                width: e(t.inner.width, t.k),
                height: e(t.inner.height, t.k)
            }, t.inner.ratio = t.inner.height / t.inner.width), this.prop.pageSize = t;
        });
    }, u.prototype.setProgress = function(t, e, n, r) {
        return null != t && (this.progress.val = t), null != e && (this.progress.state = e), null != n && (this.progress.n = n), null != r && (this.progress.stack = r), this.progress.ratio = this.progress.val / this.progress.state, this;
    }, u.prototype.updateProgress = function(t, e, n, r) {
        return this.setProgress(t ? this.progress.val + t : null, e || null, n ? this.progress.n + n : null, r ? this.progress.stack.concat(r) : null);
    }, u.prototype.then = function(t, e) {
        var n = this;
        return this.thenCore(t, e, function(t, e) {
            return n.updateProgress(null, null, 1, [
                t
            ]), Promise.prototype.then.call(this, function(e) {
                return n.updateProgress(null, t), e;
            }).then(t, e).then(function(t) {
                return n.updateProgress(1), t;
            });
        });
    }, u.prototype.thenCore = function(t, e, n) {
        n = n || Promise.prototype.then;
        var r = this;
        t && (t = t.bind(r)), e && (e = e.bind(r));
        var i = -1 !== Promise.toString().indexOf("[native code]") && "Promise" === Promise.name ? r : u.convert(Object.assign({}, r), Promise.prototype), a = n.call(i, t, e);
        return u.convert(a, r.__proto__);
    }, u.prototype.thenExternal = function(t, e) {
        return Promise.prototype.then.call(this, t, e);
    }, u.prototype.thenList = function(t) {
        var e = this;
        return t.forEach(function(t) {
            e = e.thenCore(t);
        }), e;
    }, u.prototype.catch = function(t) {
        t && (t = t.bind(this));
        var e = Promise.prototype.catch.call(this, t);
        return u.convert(e, this);
    }, u.prototype.catchExternal = function(t) {
        return Promise.prototype.catch.call(this, t);
    }, u.prototype.error = function(t) {
        return this.then(function() {
            throw new Error(t);
        });
    }, u.prototype.using = u.prototype.set, u.prototype.saveAs = u.prototype.save, u.prototype.export = u.prototype.output, u.prototype.run = u.prototype.then, E.getPageSize = function(e, n, r) {
        if ("object" === (0, _typeofDefault.default)(e)) {
            var i = e;
            e = i.orientation, n = i.unit || n, r = i.format || r;
        }
        n = n || "mm", r = r || "a4", e = ("" + (e || "P")).toLowerCase();
        var a, o = ("" + r).toLowerCase(), s = {
            a0: [
                2383.94,
                3370.39
            ],
            a1: [
                1683.78,
                2383.94
            ],
            a2: [
                1190.55,
                1683.78
            ],
            a3: [
                841.89,
                1190.55
            ],
            a4: [
                595.28,
                841.89
            ],
            a5: [
                419.53,
                595.28
            ],
            a6: [
                297.64,
                419.53
            ],
            a7: [
                209.76,
                297.64
            ],
            a8: [
                147.4,
                209.76
            ],
            a9: [
                104.88,
                147.4
            ],
            a10: [
                73.7,
                104.88
            ],
            b0: [
                2834.65,
                4008.19
            ],
            b1: [
                2004.09,
                2834.65
            ],
            b2: [
                1417.32,
                2004.09
            ],
            b3: [
                1000.63,
                1417.32
            ],
            b4: [
                708.66,
                1000.63
            ],
            b5: [
                498.9,
                708.66
            ],
            b6: [
                354.33,
                498.9
            ],
            b7: [
                249.45,
                354.33
            ],
            b8: [
                175.75,
                249.45
            ],
            b9: [
                124.72,
                175.75
            ],
            b10: [
                87.87,
                124.72
            ],
            c0: [
                2599.37,
                3676.54
            ],
            c1: [
                1836.85,
                2599.37
            ],
            c2: [
                1298.27,
                1836.85
            ],
            c3: [
                918.43,
                1298.27
            ],
            c4: [
                649.13,
                918.43
            ],
            c5: [
                459.21,
                649.13
            ],
            c6: [
                323.15,
                459.21
            ],
            c7: [
                229.61,
                323.15
            ],
            c8: [
                161.57,
                229.61
            ],
            c9: [
                113.39,
                161.57
            ],
            c10: [
                79.37,
                113.39
            ],
            dl: [
                311.81,
                623.62
            ],
            letter: [
                612,
                792
            ],
            "government-letter": [
                576,
                756
            ],
            legal: [
                612,
                1008
            ],
            "junior-legal": [
                576,
                360
            ],
            ledger: [
                1224,
                792
            ],
            tabloid: [
                792,
                1224
            ],
            "credit-card": [
                153,
                243
            ]
        };
        switch(n){
            case "pt":
                a = 1;
                break;
            case "mm":
                a = 72 / 25.4;
                break;
            case "cm":
                a = 72 / 2.54;
                break;
            case "in":
                a = 72;
                break;
            case "px":
                a = .75;
                break;
            case "pc":
            case "em":
                a = 12;
                break;
            case "ex":
                a = 6;
                break;
            default:
                throw "Invalid unit: " + n;
        }
        var u, c = 0, l = 0;
        if (s.hasOwnProperty(o)) c = s[o][1] / a, l = s[o][0] / a;
        else try {
            c = r[1], l = r[0];
        } catch (h) {
            throw new Error("Invalid format: " + r);
        }
        if ("p" === e || "portrait" === e) e = "p", l > c && (u = l, l = c, c = u);
        else {
            if ("l" !== e && "landscape" !== e) throw "Invalid orientation: " + e;
            e = "l", c > l && (u = l, l = c, c = u);
        }
        return {
            width: l,
            height: c,
            unit: n,
            k: a,
            orientation: e
        };
    }, e.html = function(t, e) {
        (e = e || {}).callback = e.callback || function() {}, e.html2canvas = e.html2canvas || {}, e.html2canvas.canvas = e.html2canvas.canvas || this.canvas, e.jsPDF = e.jsPDF || this, e.fontFaces = e.fontFaces ? e.fontFaces.map(Ct) : null;
        var n = new u(e);
        return e.worker ? n : n.from(t).doCallback();
    };
}(E.API), E.API.addJS = function(t) {
    return Ut = t, this.internal.events.subscribe("postPutResources", function() {
        Tt = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/Names [(EmbeddedJS) " + (Tt + 1) + " 0 R]"), this.internal.out(">>"), this.internal.out("endobj"), zt = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/S /JavaScript"), this.internal.out("/JS (" + Ut + ")"), this.internal.out(">>"), this.internal.out("endobj");
    }), this.internal.events.subscribe("putCatalog", function() {
        void 0 !== Tt && void 0 !== zt && this.internal.out("/Names <</JavaScript " + Tt + " 0 R>>");
    }), this;
}, /**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e;
    t.events.push([
        "postPutResources",
        function() {
            var t = this, n = /^(\d+) 0 obj$/;
            if (this.outline.root.children.length > 0) for(var r = t.outline.render().split(/\r\n/), i = 0; i < r.length; i++){
                var a = r[i], o = n.exec(a);
                if (null != o) {
                    var s = o[1];
                    t.internal.newObjectDeferredBegin(s, !1);
                }
                t.internal.write(a);
            }
            if (this.outline.createNamedDestinations) {
                var u = this.internal.pages.length, c = [];
                for(i = 0; i < u; i++){
                    var l = t.internal.newObject();
                    c.push(l);
                    var h = t.internal.getPageInfo(i + 1);
                    t.internal.write("<< /D[" + h.objId + " 0 R /XYZ null null null]>> endobj");
                }
                var f = t.internal.newObject();
                for(t.internal.write("<< /Names [ "), i = 0; i < c.length; i++)t.internal.write("(page_" + (i + 1) + ")" + c[i] + " 0 R");
                t.internal.write(" ] >>", "endobj"), e = t.internal.newObject(), t.internal.write("<< /Dests " + f + " 0 R"), t.internal.write(">>", "endobj");
            }
        }
    ]), t.events.push([
        "putCatalog",
        function() {
            var t = this;
            t.outline.root.children.length > 0 && (t.internal.write("/Outlines", this.outline.makeRef(this.outline.root)), this.outline.createNamedDestinations && t.internal.write("/Names " + e + " 0 R"));
        }
    ]), t.events.push([
        "initialized",
        function() {
            var t = this;
            t.outline = {
                createNamedDestinations: !1,
                root: {
                    children: []
                }
            }, t.outline.add = function(t, e, n) {
                var r = {
                    title: e,
                    options: n,
                    children: []
                };
                return null == t && (t = this.root), t.children.push(r), r;
            }, t.outline.render = function() {
                return this.ctx = {}, this.ctx.val = "", this.ctx.pdf = t, this.genIds_r(this.root), this.renderRoot(this.root), this.renderItems(this.root), this.ctx.val;
            }, t.outline.genIds_r = function(e) {
                e.id = t.internal.newObjectDeferred();
                for(var n = 0; n < e.children.length; n++)this.genIds_r(e.children[n]);
            }, t.outline.renderRoot = function(t) {
                this.objStart(t), this.line("/Type /Outlines"), t.children.length > 0 && (this.line("/First " + this.makeRef(t.children[0])), this.line("/Last " + this.makeRef(t.children[t.children.length - 1]))), this.line("/Count " + this.count_r({
                    count: 0
                }, t)), this.objEnd();
            }, t.outline.renderItems = function(e) {
                for(var n = this.ctx.pdf.internal.getVerticalCoordinateString, r = 0; r < e.children.length; r++){
                    var i = e.children[r];
                    this.objStart(i), this.line("/Title " + this.makeString(i.title)), this.line("/Parent " + this.makeRef(e)), r > 0 && this.line("/Prev " + this.makeRef(e.children[r - 1])), r < e.children.length - 1 && this.line("/Next " + this.makeRef(e.children[r + 1])), i.children.length > 0 && (this.line("/First " + this.makeRef(i.children[0])), this.line("/Last " + this.makeRef(i.children[i.children.length - 1])));
                    var a = this.count = this.count_r({
                        count: 0
                    }, i);
                    if (a > 0 && this.line("/Count " + a), i.options && i.options.pageNumber) {
                        var o = t.internal.getPageInfo(i.options.pageNumber);
                        this.line("/Dest [" + o.objId + " 0 R /XYZ 0 " + n(0) + " 0]");
                    }
                    this.objEnd();
                }
                for(var s = 0; s < e.children.length; s++)this.renderItems(e.children[s]);
            }, t.outline.line = function(t) {
                this.ctx.val += t + "\r\n";
            }, t.outline.makeRef = function(t) {
                return t.id + " 0 R";
            }, t.outline.makeString = function(e) {
                return "(" + t.internal.pdfEscape(e) + ")";
            }, t.outline.objStart = function(t) {
                this.ctx.val += "\r\n" + t.id + " 0 obj\r\n<<\r\n";
            }, t.outline.objEnd = function() {
                this.ctx.val += ">> \r\nendobj\r\n";
            }, t.outline.count_r = function(t, e) {
                for(var n = 0; n < e.children.length; n++)t.count++, this.count_r(t, e.children[n]);
                return t.count;
            };
        }
    ]);
}(E.API), /**
 * @license
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e = [
        192,
        193,
        194,
        195,
        196,
        197,
        198,
        199
    ];
    t.processJPEG = function(t, n, r, i, a, o) {
        var s, u = this.decode.DCT_DECODE, c = null;
        if ("string" == typeof t || this.__addimage__.isArrayBuffer(t) || this.__addimage__.isArrayBufferView(t)) {
            switch(t = a || t, t = this.__addimage__.isArrayBuffer(t) ? new Uint8Array(t) : t, s = function(t) {
                for(var n, r = 256 * t.charCodeAt(4) + t.charCodeAt(5), i = t.length, a = {
                    width: 0,
                    height: 0,
                    numcomponents: 1
                }, o = 4; o < i; o += 2){
                    if (o += r, -1 !== e.indexOf(t.charCodeAt(o + 1))) {
                        n = 256 * t.charCodeAt(o + 5) + t.charCodeAt(o + 6), a = {
                            width: 256 * t.charCodeAt(o + 7) + t.charCodeAt(o + 8),
                            height: n,
                            numcomponents: t.charCodeAt(o + 9)
                        };
                        break;
                    }
                    r = 256 * t.charCodeAt(o + 2) + t.charCodeAt(o + 3);
                }
                return a;
            }(t = this.__addimage__.isArrayBufferView(t) ? this.__addimage__.arrayBufferToBinaryString(t) : t), s.numcomponents){
                case 1:
                    o = this.color_spaces.DEVICE_GRAY;
                    break;
                case 4:
                    o = this.color_spaces.DEVICE_CMYK;
                    break;
                case 3:
                    o = this.color_spaces.DEVICE_RGB;
            }
            c = {
                data: t,
                width: s.width,
                height: s.height,
                colorSpace: o,
                bitsPerComponent: 8,
                filter: u,
                index: n,
                alias: r
            };
        }
        return c;
    };
}(E.API), E.API.processPNG = function(t, i, a, o) {
    if (this.__addimage__.isArrayBuffer(t) && (t = new Uint8Array(t)), this.__addimage__.isArrayBufferView(t)) {
        var s, u = (0, _fastPng.decode)(t, {
            checkCrc: !0
        }), c = u.width, l = u.height, h = u.channels, f = u.palette, d = u.depth;
        s = f && 1 === h ? function(t) {
            for(var e = t.width, r = t.height, i = t.data, a = t.palette, o = t.depth, s = !1, u = [], c = [], l = void 0, h = !1, f = 0, d = 0; d < a.length; d++){
                var p = (0, _slicedToArrayDefault.default)(a[d], 4), g = p[0], m = p[1], v = p[2], b = p[3];
                u.push(g, m, v), null != b && (0 === b ? (f++, c.length < 1 && c.push(d)) : b < 255 && (h = !0));
            }
            if (h || f > 1) {
                s = !0, c = void 0;
                var y = e * r;
                l = new Uint8Array(y);
                for(var w = new DataView(i.buffer), N = 0; N < y; N++){
                    var L = re(w, N, o), x = (0, _slicedToArrayDefault.default)(a[L], 4)[3];
                    l[N] = x;
                }
            } else 0 === f && (c = void 0);
            return {
                colorSpace: "Indexed",
                colorsPerPixel: 1,
                sMaskBitsPerComponent: s ? 8 : void 0,
                colorBytes: i,
                alphaBytes: l,
                needSMask: s,
                palette: u,
                mask: c
            };
        }(u) : 2 === h || 4 === h ? function(t) {
            for(var e = t.data, n = t.width, r = t.height, i = t.channels, a = t.depth, o = 2 === i ? "DeviceGray" : "DeviceRGB", s = i - 1, u = n * r, c = s, l = u * c, h = 1 * u, f = Math.ceil(l * a / 8), d = Math.ceil(h * a / 8), p = new Uint8Array(f), g = new Uint8Array(d), m = new DataView(e.buffer), v = new DataView(p.buffer), b = new DataView(g.buffer), y = !1, w = 0; w < u; w++){
                for(var N = w * i, L = 0; L < c; L++)ie(v, re(m, N + L, a), w * c + L, a);
                var x = re(m, N + c, a);
                x < (1 << a) - 1 && (y = !0), ie(b, x, 1 * w, a);
            }
            return {
                colorSpace: o,
                colorsPerPixel: s,
                sMaskBitsPerComponent: y ? a : void 0,
                colorBytes: p,
                alphaBytes: g,
                needSMask: y
            };
        }(u) : function(t) {
            var e = t.data, n = 1 === t.channels ? "DeviceGray" : "DeviceRGB";
            return {
                colorSpace: n,
                colorsPerPixel: "DeviceGray" === n ? 1 : 3,
                colorBytes: e instanceof Uint16Array ? function(t) {
                    for(var e = t.length, n = new Uint8Array(2 * e), r = new DataView(n.buffer, n.byteOffset, n.byteLength), i = 0; i < e; i++)r.setUint16(2 * i, t[i], !1);
                    return n;
                }(e) : e,
                needSMask: !1
            };
        }(u);
        var p, g, m, v = s, b = v.colorSpace, y = v.colorsPerPixel, w = v.sMaskBitsPerComponent, N = v.colorBytes, L = v.alphaBytes, x = v.needSMask, A = v.palette, S = v.mask, _ = null;
        return o !== E.API.image_compression.NONE && "function" == typeof (0, _fflate.zlibSync) ? (_ = function(t) {
            var e;
            switch(t){
                case E.API.image_compression.FAST:
                    e = 11;
                    break;
                case E.API.image_compression.MEDIUM:
                    e = 13;
                    break;
                case E.API.image_compression.SLOW:
                    e = 14;
                    break;
                default:
                    e = 12;
            }
            return e;
        }(o), p = this.decode.FLATE_DECODE, g = "/Predictor ".concat(_, " /Colors ").concat(y, " /BitsPerComponent ").concat(d, " /Columns ").concat(c), t = Xt(N, Math.ceil(c * y * d / 8), y, d, o), x && (m = Xt(L, Math.ceil(c * w / 8), 1, w, o))) : (p = void 0, g = void 0, t = N, x && (m = L)), (this.__addimage__.isArrayBuffer(t) || this.__addimage__.isArrayBufferView(t)) && (t = this.__addimage__.arrayBufferToBinaryString(t)), (m && this.__addimage__.isArrayBuffer(m) || this.__addimage__.isArrayBufferView(m)) && (m = this.__addimage__.arrayBufferToBinaryString(m)), {
            alias: a,
            data: t,
            index: i,
            filter: p,
            decodeParameters: g,
            transparency: S,
            palette: A,
            sMask: m,
            predictor: _,
            width: c,
            height: l,
            bitsPerComponent: d,
            sMaskBitsPerComponent: w,
            colorSpace: b
        };
    }
}, function(t) {
    t.processGIF89A = function(e, n, r, i) {
        var a = new oe(e), o = a.width, s = a.height, u = [];
        a.decodeAndBlitFrameRGBA(0, u);
        var c = {
            data: u,
            width: o,
            height: s
        }, l = new ue(100).encode(c, 100);
        return t.processJPEG.call(this, l, n, r, i);
    }, t.processGIF87A = t.processGIF89A;
}(E.API), ce.prototype.parseHeader = function() {
    if (this.fileSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.reserved = this.datav.getUint32(this.pos, !0), this.pos += 4, this.offset = this.datav.getUint32(this.pos, !0), this.pos += 4, this.headerSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.width = this.datav.getUint32(this.pos, !0), this.pos += 4, this.height = this.datav.getInt32(this.pos, !0), this.pos += 4, this.planes = this.datav.getUint16(this.pos, !0), this.pos += 2, this.bitPP = this.datav.getUint16(this.pos, !0), this.pos += 2, this.compress = this.datav.getUint32(this.pos, !0), this.pos += 4, this.rawSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.hr = this.datav.getUint32(this.pos, !0), this.pos += 4, this.vr = this.datav.getUint32(this.pos, !0), this.pos += 4, this.colors = this.datav.getUint32(this.pos, !0), this.pos += 4, this.importantColors = this.datav.getUint32(this.pos, !0), this.pos += 4, 16 === this.bitPP && this.is_with_alpha && (this.bitPP = 15), this.bitPP < 15) {
        var t = 0 === this.colors ? 1 << this.bitPP : this.colors;
        this.palette = new Array(t);
        for(var e = 0; e < t; e++){
            var n = this.datav.getUint8(this.pos++, !0), r = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0), a = this.datav.getUint8(this.pos++, !0);
            this.palette[e] = {
                red: i,
                green: r,
                blue: n,
                quad: a
            };
        }
    }
    this.height < 0 && (this.height *= -1, this.bottom_up = !1);
}, ce.prototype.parseBGR = function() {
    this.pos = this.offset;
    try {
        var t = "bit" + this.bitPP, e = this.width * this.height * 4;
        this.data = new Uint8Array(e), this[t]();
    } catch (n) {
        o.log("bit decode error:" + n);
    }
}, ce.prototype.bit1 = function() {
    var t, e = Math.ceil(this.width / 8), n = e % 4;
    for(t = this.height - 1; t >= 0; t--){
        for(var r = this.bottom_up ? t : this.height - 1 - t, i = 0; i < e; i++)for(var a = this.datav.getUint8(this.pos++, !0), o = r * this.width * 4 + 8 * i * 4, s = 0; s < 8 && 8 * i + s < this.width; s++){
            var u = this.palette[a >> 7 - s & 1];
            this.data[o + 4 * s] = u.blue, this.data[o + 4 * s + 1] = u.green, this.data[o + 4 * s + 2] = u.red, this.data[o + 4 * s + 3] = 255;
        }
        0 !== n && (this.pos += 4 - n);
    }
}, ce.prototype.bit4 = function() {
    for(var t = Math.ceil(this.width / 2), e = t % 4, n = this.height - 1; n >= 0; n--){
        for(var r = this.bottom_up ? n : this.height - 1 - n, i = 0; i < t; i++){
            var a = this.datav.getUint8(this.pos++, !0), o = r * this.width * 4 + 2 * i * 4, s = a >> 4, u = 15 & a, c = this.palette[s];
            if (this.data[o] = c.blue, this.data[o + 1] = c.green, this.data[o + 2] = c.red, this.data[o + 3] = 255, 2 * i + 1 >= this.width) break;
            c = this.palette[u], this.data[o + 4] = c.blue, this.data[o + 4 + 1] = c.green, this.data[o + 4 + 2] = c.red, this.data[o + 4 + 3] = 255;
        }
        0 !== e && (this.pos += 4 - e);
    }
}, ce.prototype.bit8 = function() {
    for(var t = this.width % 4, e = this.height - 1; e >= 0; e--){
        for(var n = this.bottom_up ? e : this.height - 1 - e, r = 0; r < this.width; r++){
            var i = this.datav.getUint8(this.pos++, !0), a = n * this.width * 4 + 4 * r;
            if (i < this.palette.length) {
                var o = this.palette[i];
                this.data[a] = o.red, this.data[a + 1] = o.green, this.data[a + 2] = o.blue, this.data[a + 3] = 255;
            } else this.data[a] = 255, this.data[a + 1] = 255, this.data[a + 2] = 255, this.data[a + 3] = 255;
        }
        0 !== t && (this.pos += 4 - t);
    }
}, ce.prototype.bit15 = function() {
    for(var t = this.width % 3, e = parseInt("11111", 2), n = this.height - 1; n >= 0; n--){
        for(var r = this.bottom_up ? n : this.height - 1 - n, i = 0; i < this.width; i++){
            var a = this.datav.getUint16(this.pos, !0);
            this.pos += 2;
            var o = (a & e) / e * 255 | 0, s = (a >> 5 & e) / e * 255 | 0, u = (a >> 10 & e) / e * 255 | 0, c = a >> 15 ? 255 : 0, l = r * this.width * 4 + 4 * i;
            this.data[l] = u, this.data[l + 1] = s, this.data[l + 2] = o, this.data[l + 3] = c;
        }
        this.pos += t;
    }
}, ce.prototype.bit16 = function() {
    for(var t = this.width % 3, e = parseInt("11111", 2), n = parseInt("111111", 2), r = this.height - 1; r >= 0; r--){
        for(var i = this.bottom_up ? r : this.height - 1 - r, a = 0; a < this.width; a++){
            var o = this.datav.getUint16(this.pos, !0);
            this.pos += 2;
            var s = (o & e) / e * 255 | 0, u = (o >> 5 & n) / n * 255 | 0, c = (o >> 11) / e * 255 | 0, l = i * this.width * 4 + 4 * a;
            this.data[l] = c, this.data[l + 1] = u, this.data[l + 2] = s, this.data[l + 3] = 255;
        }
        this.pos += t;
    }
}, ce.prototype.bit24 = function() {
    for(var t = this.height - 1; t >= 0; t--){
        for(var e = this.bottom_up ? t : this.height - 1 - t, n = 0; n < this.width; n++){
            var r = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0), a = this.datav.getUint8(this.pos++, !0), o = e * this.width * 4 + 4 * n;
            this.data[o] = a, this.data[o + 1] = i, this.data[o + 2] = r, this.data[o + 3] = 255;
        }
        this.pos += this.width % 4;
    }
}, ce.prototype.bit32 = function() {
    for(var t = this.height - 1; t >= 0; t--)for(var e = this.bottom_up ? t : this.height - 1 - t, n = 0; n < this.width; n++){
        var r = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0), a = this.datav.getUint8(this.pos++, !0), o = this.datav.getUint8(this.pos++, !0), s = e * this.width * 4 + 4 * n;
        this.data[s] = a, this.data[s + 1] = i, this.data[s + 2] = r, this.data[s + 3] = o;
    }
}, ce.prototype.getData = function() {
    return this.data;
}, /**
 * @license
 * Copyright (c) 2018 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    t.processBMP = function(e, n, r, i) {
        var a = new ce(e, !1), o = a.width, s = a.height, u = {
            data: a.getData(),
            width: o,
            height: s
        }, c = new ue(100).encode(u, 100);
        return t.processJPEG.call(this, c, n, r, i);
    };
}(E.API), le.prototype.getData = function() {
    return this.data;
}, /**
 * @license
 * Copyright (c) 2019 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    t.processWEBP = function(e, n, r, i) {
        var a = new le(e), o = a.width, s = a.height, u = {
            data: a.getData(),
            width: o,
            height: s
        }, c = new ue(100).encode(u, 100);
        return t.processJPEG.call(this, c, n, r, i);
    };
}(E.API), E.API.processRGBA = function(t, e, n) {
    for(var r = t.data, i = r.length, a = new Uint8Array(i / 4 * 3), o = new Uint8Array(i / 4), s = 0, u = 0, c = 0; c < i; c += 4){
        var l = r[c], h = r[c + 1], f = r[c + 2], d = r[c + 3];
        a[s++] = l, a[s++] = h, a[s++] = f, o[u++] = d;
    }
    var p = this.__addimage__.arrayBufferToBinaryString(a);
    return {
        alpha: this.__addimage__.arrayBufferToBinaryString(o),
        data: p,
        index: e,
        alias: n,
        colorSpace: "DeviceRGB",
        bitsPerComponent: 8,
        width: t.width,
        height: t.height
    };
}, E.API.setLanguage = function(t) {
    return void 0 === this.internal.languageSettings && (this.internal.languageSettings = {}, this.internal.languageSettings.isSubscribed = !1), void 0 !== ({
        af: "Afrikaans",
        sq: "Albanian",
        ar: "Arabic (Standard)",
        "ar-DZ": "Arabic (Algeria)",
        "ar-BH": "Arabic (Bahrain)",
        "ar-EG": "Arabic (Egypt)",
        "ar-IQ": "Arabic (Iraq)",
        "ar-JO": "Arabic (Jordan)",
        "ar-KW": "Arabic (Kuwait)",
        "ar-LB": "Arabic (Lebanon)",
        "ar-LY": "Arabic (Libya)",
        "ar-MA": "Arabic (Morocco)",
        "ar-OM": "Arabic (Oman)",
        "ar-QA": "Arabic (Qatar)",
        "ar-SA": "Arabic (Saudi Arabia)",
        "ar-SY": "Arabic (Syria)",
        "ar-TN": "Arabic (Tunisia)",
        "ar-AE": "Arabic (U.A.E.)",
        "ar-YE": "Arabic (Yemen)",
        an: "Aragonese",
        hy: "Armenian",
        as: "Assamese",
        ast: "Asturian",
        az: "Azerbaijani",
        eu: "Basque",
        be: "Belarusian",
        bn: "Bengali",
        bs: "Bosnian",
        br: "Breton",
        bg: "Bulgarian",
        my: "Burmese",
        ca: "Catalan",
        ch: "Chamorro",
        ce: "Chechen",
        zh: "Chinese",
        "zh-HK": "Chinese (Hong Kong)",
        "zh-CN": "Chinese (PRC)",
        "zh-SG": "Chinese (Singapore)",
        "zh-TW": "Chinese (Taiwan)",
        cv: "Chuvash",
        co: "Corsican",
        cr: "Cree",
        hr: "Croatian",
        cs: "Czech",
        da: "Danish",
        nl: "Dutch (Standard)",
        "nl-BE": "Dutch (Belgian)",
        en: "English",
        "en-AU": "English (Australia)",
        "en-BZ": "English (Belize)",
        "en-CA": "English (Canada)",
        "en-IE": "English (Ireland)",
        "en-JM": "English (Jamaica)",
        "en-NZ": "English (New Zealand)",
        "en-PH": "English (Philippines)",
        "en-ZA": "English (South Africa)",
        "en-TT": "English (Trinidad & Tobago)",
        "en-GB": "English (United Kingdom)",
        "en-US": "English (United States)",
        "en-ZW": "English (Zimbabwe)",
        eo: "Esperanto",
        et: "Estonian",
        fo: "Faeroese",
        fj: "Fijian",
        fi: "Finnish",
        fr: "French (Standard)",
        "fr-BE": "French (Belgium)",
        "fr-CA": "French (Canada)",
        "fr-FR": "French (France)",
        "fr-LU": "French (Luxembourg)",
        "fr-MC": "French (Monaco)",
        "fr-CH": "French (Switzerland)",
        fy: "Frisian",
        fur: "Friulian",
        gd: "Gaelic (Scots)",
        "gd-IE": "Gaelic (Irish)",
        gl: "Galacian",
        ka: "Georgian",
        de: "German (Standard)",
        "de-AT": "German (Austria)",
        "de-DE": "German (Germany)",
        "de-LI": "German (Liechtenstein)",
        "de-LU": "German (Luxembourg)",
        "de-CH": "German (Switzerland)",
        el: "Greek",
        gu: "Gujurati",
        ht: "Haitian",
        he: "Hebrew",
        hi: "Hindi",
        hu: "Hungarian",
        is: "Icelandic",
        id: "Indonesian",
        iu: "Inuktitut",
        ga: "Irish",
        it: "Italian (Standard)",
        "it-CH": "Italian (Switzerland)",
        ja: "Japanese",
        kn: "Kannada",
        ks: "Kashmiri",
        kk: "Kazakh",
        km: "Khmer",
        ky: "Kirghiz",
        tlh: "Klingon",
        ko: "Korean",
        "ko-KP": "Korean (North Korea)",
        "ko-KR": "Korean (South Korea)",
        la: "Latin",
        lv: "Latvian",
        lt: "Lithuanian",
        lb: "Luxembourgish",
        mk: "North Macedonia",
        ms: "Malay",
        ml: "Malayalam",
        mt: "Maltese",
        mi: "Maori",
        mr: "Marathi",
        mo: "Moldavian",
        nv: "Navajo",
        ng: "Ndonga",
        ne: "Nepali",
        no: "Norwegian",
        nb: "Norwegian (Bokmal)",
        nn: "Norwegian (Nynorsk)",
        oc: "Occitan",
        or: "Oriya",
        om: "Oromo",
        fa: "Persian",
        "fa-IR": "Persian/Iran",
        pl: "Polish",
        pt: "Portuguese",
        "pt-BR": "Portuguese (Brazil)",
        pa: "Punjabi",
        "pa-IN": "Punjabi (India)",
        "pa-PK": "Punjabi (Pakistan)",
        qu: "Quechua",
        rm: "Rhaeto-Romanic",
        ro: "Romanian",
        "ro-MO": "Romanian (Moldavia)",
        ru: "Russian",
        "ru-MO": "Russian (Moldavia)",
        sz: "Sami (Lappish)",
        sg: "Sango",
        sa: "Sanskrit",
        sc: "Sardinian",
        sd: "Sindhi",
        si: "Singhalese",
        sr: "Serbian",
        sk: "Slovak",
        sl: "Slovenian",
        so: "Somani",
        sb: "Sorbian",
        es: "Spanish",
        "es-AR": "Spanish (Argentina)",
        "es-BO": "Spanish (Bolivia)",
        "es-CL": "Spanish (Chile)",
        "es-CO": "Spanish (Colombia)",
        "es-CR": "Spanish (Costa Rica)",
        "es-DO": "Spanish (Dominican Republic)",
        "es-EC": "Spanish (Ecuador)",
        "es-SV": "Spanish (El Salvador)",
        "es-GT": "Spanish (Guatemala)",
        "es-HN": "Spanish (Honduras)",
        "es-MX": "Spanish (Mexico)",
        "es-NI": "Spanish (Nicaragua)",
        "es-PA": "Spanish (Panama)",
        "es-PY": "Spanish (Paraguay)",
        "es-PE": "Spanish (Peru)",
        "es-PR": "Spanish (Puerto Rico)",
        "es-ES": "Spanish (Spain)",
        "es-UY": "Spanish (Uruguay)",
        "es-VE": "Spanish (Venezuela)",
        sx: "Sutu",
        sw: "Swahili",
        sv: "Swedish",
        "sv-FI": "Swedish (Finland)",
        "sv-SV": "Swedish (Sweden)",
        ta: "Tamil",
        tt: "Tatar",
        te: "Teluga",
        th: "Thai",
        tig: "Tigre",
        ts: "Tsonga",
        tn: "Tswana",
        tr: "Turkish",
        tk: "Turkmen",
        uk: "Ukrainian",
        hsb: "Upper Sorbian",
        ur: "Urdu",
        ve: "Venda",
        vi: "Vietnamese",
        vo: "Volapuk",
        wa: "Walloon",
        cy: "Welsh",
        xh: "Xhosa",
        ji: "Yiddish",
        zu: "Zulu"
    })[t] && (this.internal.languageSettings.languageCode = t, !1 === this.internal.languageSettings.isSubscribed && (this.internal.events.subscribe("putCatalog", function() {
        this.internal.write("/Lang (" + this.internal.languageSettings.languageCode + ")");
    }), this.internal.languageSettings.isSubscribed = !0)), this;
}, Ht = E.API, Wt = Ht.getCharWidthsArray = function(e, n) {
    var r, i, a = (n = n || {}).font || this.internal.getFont(), o = n.fontSize || this.internal.getFontSize(), s = n.charSpace || this.internal.getCharSpace(), u = n.widths ? n.widths : a.metadata.Unicode.widths, c = u.fof ? u.fof : 1, l = n.kerning ? n.kerning : a.metadata.Unicode.kerning, h = l.fof ? l.fof : 1, f = !1 !== n.doKerning, d = 0, p = e.length, g = 0, m = u[0] || c, v = [];
    for(r = 0; r < p; r++)i = e.charCodeAt(r), "function" == typeof a.metadata.widthOfString ? v.push((a.metadata.widthOfGlyph(a.metadata.characterToGlyph(i)) + s * (1e3 / o) || 0) / 1e3) : (d = f && "object" === (0, _typeofDefault.default)(l[i]) && !isNaN(parseInt(l[i][g], 10)) ? l[i][g] / h : 0, v.push((u[i] || m) / c + d)), g = i;
    return v;
}, Vt = Ht.getStringUnitWidth = function(t, e) {
    var n = (e = e || {}).fontSize || this.internal.getFontSize(), r = e.font || this.internal.getFont(), i = e.charSpace || this.internal.getCharSpace();
    return Ht.processArabic && (t = Ht.processArabic(t)), "function" == typeof r.metadata.widthOfString ? r.metadata.widthOfString(t, n, i) / n : Wt.apply(this, arguments).reduce(function(t, e) {
        return t + e;
    }, 0);
}, Gt = function(t, e, n, r) {
    for(var i = [], a = 0, o = t.length, s = 0; a !== o && s + e[a] < n;)s += e[a], a++;
    i.push(t.slice(0, a));
    var u = a;
    for(s = 0; a !== o;)s + e[a] > r && (i.push(t.slice(u, a)), s = 0, u = a), s += e[a], a++;
    return u !== a && i.push(t.slice(u, a)), i;
}, Yt = function(t, e, n) {
    n || (n = {});
    var r, i, a, o, s, u, c, l = [], h = [
        l
    ], f = n.textIndent || 0, d = 0, p = 0, g = t.split(" "), m = Wt.apply(this, [
        " ",
        n
    ])[0];
    if (u = -1 === n.lineIndent ? g[0].length + 2 : n.lineIndent || 0) {
        var v = Array(u).join(" "), b = [];
        g.map(function(t) {
            (t = t.split(/\s*\n/)).length > 1 ? b = b.concat(t.map(function(t, e) {
                return (e && t.length ? "\n" : "") + t;
            })) : b.push(t[0]);
        }), g = b, u = Vt.apply(this, [
            v,
            n
        ]);
    }
    for(a = 0, o = g.length; a < o; a++){
        var y = 0;
        if (r = g[a], u && "\n" == r[0] && (r = r.substr(1), y = 1), f + d + (p = (i = Wt.apply(this, [
            r,
            n
        ])).reduce(function(t, e) {
            return t + e;
        }, 0)) > e || y) {
            if (p > e) {
                for(s = Gt.apply(this, [
                    r,
                    i,
                    e - (f + d),
                    e
                ]), l.push(s.shift()), l = [
                    s.pop()
                ]; s.length;)h.push([
                    s.shift()
                ]);
                p = i.slice(r.length - (l[0] ? l[0].length : 0)).reduce(function(t, e) {
                    return t + e;
                }, 0);
            } else l = [
                r
            ];
            h.push(l), f = p + u, d = m;
        } else l.push(r), f += d + p, d = m;
    }
    return c = u ? function(t, e) {
        return (e ? v : "") + t.join(" ");
    } : function(t) {
        return t.join(" ");
    }, h.map(c);
}, Ht.splitTextToSize = function(t, e, n) {
    var r, i = (n = n || {}).fontSize || this.internal.getFontSize(), a = (function(t) {
        if (t.widths && t.kerning) return {
            widths: t.widths,
            kerning: t.kerning
        };
        var e = this.internal.getFont(t.fontName, t.fontStyle), n = "Unicode";
        return e.metadata[n] ? {
            widths: e.metadata[n].widths || {
                0: 1
            },
            kerning: e.metadata[n].kerning || {}
        } : {
            font: e.metadata,
            fontSize: this.internal.getFontSize(),
            charSpace: this.internal.getCharSpace()
        };
    }).call(this, n);
    r = Array.isArray(t) ? t : String(t).split(/\r?\n/);
    var o = 1 * this.internal.scaleFactor * e / i;
    a.textIndent = n.textIndent ? 1 * n.textIndent * this.internal.scaleFactor / i : 0, a.lineIndent = n.lineIndent;
    var s, u, c = [];
    for(s = 0, u = r.length; s < u; s++)c = c.concat(Yt.apply(this, [
        r[s],
        o,
        a
    ]));
    return c;
}, function(e) {
    e.__fontmetrics__ = e.__fontmetrics__ || {};
    for(var n = "0123456789abcdef", r = "klmnopqrstuvwxyz", i = {}, a = {}, o = 0; o < 16; o++)i[r[o]] = n[o], a[n[o]] = r[o];
    var s = function(t) {
        return "0x" + parseInt(t, 10).toString(16);
    }, u = e.__fontmetrics__.compress = function(e) {
        var n, r, i, o, c = [
            "{"
        ];
        for(var l in e){
            if (n = e[l], isNaN(parseInt(l, 10)) ? r = "'" + l + "'" : (l = parseInt(l, 10), r = (r = s(l).slice(2)).slice(0, -1) + a[r.slice(-1)]), "number" == typeof n) n < 0 ? (i = s(n).slice(3), o = "-") : (i = s(n).slice(2), o = ""), i = o + i.slice(0, -1) + a[i.slice(-1)];
            else {
                if ("object" !== (0, _typeofDefault.default)(n)) throw new Error("Don't know what to do with value type " + (0, _typeofDefault.default)(n) + ".");
                i = u(n);
            }
            c.push(r + i);
        }
        return c.push("}"), c.join("");
    }, c = e.__fontmetrics__.uncompress = function(t) {
        if ("string" != typeof t) throw new Error("Invalid argument passed to uncompress.");
        for(var e, n, r, a, o = {}, s = 1, u = o, c = [], l = "", h = "", f = t.length - 1, d = 1; d < f; d += 1)"'" == (a = t[d]) ? e ? (r = e.join(""), e = void 0) : e = [] : e ? e.push(a) : "{" == a ? (c.push([
            u,
            r
        ]), u = {}, r = void 0) : "}" == a ? ((n = c.pop())[0][n[1]] = u, r = void 0, u = n[0]) : "-" == a ? s = -1 : void 0 === r ? i.hasOwnProperty(a) ? (l += i[a], r = parseInt(l, 16) * s, s = 1, l = "") : l += a : i.hasOwnProperty(a) ? (h += i[a], u[r] = parseInt(h, 16) * s, s = 1, r = void 0, h = "") : h += a;
        return o;
    }, l = {
        codePages: [
            "WinAnsiEncoding"
        ],
        WinAnsiEncoding: c("{19m8n201n9q201o9r201s9l201t9m201u8m201w9n201x9o201y8o202k8q202l8r202m9p202q8p20aw8k203k8t203t8v203u9v2cq8s212m9t15m8w15n9w2dw9s16k8u16l9u17s9z17x8y17y9y}")
    }, h = {
        Unicode: {
            Courier: l,
            "Courier-Bold": l,
            "Courier-BoldOblique": l,
            "Courier-Oblique": l,
            Helvetica: l,
            "Helvetica-Bold": l,
            "Helvetica-BoldOblique": l,
            "Helvetica-Oblique": l,
            "Times-Roman": l,
            "Times-Bold": l,
            "Times-BoldItalic": l,
            "Times-Italic": l
        }
    }, f = {
        Unicode: {
            "Courier-Oblique": c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
            "Times-BoldItalic": c("{'widths'{k3o2q4ycx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2r202m2n2n3m2o3m2p5n202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5n4l4m4m4m4n4m4o4s4p4m4q4m4r4s4s4y4t2r4u3m4v4m4w3x4x5t4y4s4z4s5k3x5l4s5m4m5n3r5o3x5p4s5q4m5r5t5s4m5t3x5u3x5v2l5w1w5x2l5y3t5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q2l6r3m6s3r6t1w6u1w6v3m6w1w6x4y6y3r6z3m7k3m7l3m7m2r7n2r7o1w7p3r7q2w7r4m7s3m7t2w7u2r7v2n7w1q7x2n7y3t202l3mcl4mal2ram3man3mao3map3mar3mas2lat4uau1uav3maw3way4uaz2lbk2sbl3t'fof'6obo2lbp3tbq3mbr1tbs2lbu1ybv3mbz3mck4m202k3mcm4mcn4mco4mcp4mcq5ycr4mcs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz2w203k6o212m6o2dw2l2cq2l3t3m3u2l17s3x19m3m}'kerning'{cl{4qu5kt5qt5rs17ss5ts}201s{201ss}201t{cks4lscmscnscoscpscls2wu2yu201ts}201x{2wu2yu}2k{201ts}2w{4qx5kx5ou5qx5rs17su5tu}2x{17su5tu5ou}2y{4qx5kx5ou5qx5rs17ss5ts}'fof'-6ofn{17sw5tw5ou5qw5rs}7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qs}3v{17su5tu5os5qs}7p{17su5tu}ck{4qu5kt5qt5rs17ss5ts}4l{4qu5kt5qt5rs17ss5ts}cm{4qu5kt5qt5rs17ss5ts}cn{4qu5kt5qt5rs17ss5ts}co{4qu5kt5qt5rs17ss5ts}cp{4qu5kt5qt5rs17ss5ts}6l{4qu5ou5qw5rt17su5tu}5q{ckuclucmucnucoucpu4lu}5r{ckuclucmucnucoucpu4lu}7q{cksclscmscnscoscps4ls}6p{4qu5ou5qw5rt17sw5tw}ek{4qu5ou5qw5rt17su5tu}el{4qu5ou5qw5rt17su5tu}em{4qu5ou5qw5rt17su5tu}en{4qu5ou5qw5rt17su5tu}eo{4qu5ou5qw5rt17su5tu}ep{4qu5ou5qw5rt17su5tu}es{17ss5ts5qs4qu}et{4qu5ou5qw5rt17sw5tw}eu{4qu5ou5qw5rt17ss5ts}ev{17ss5ts5qs4qu}6z{17sw5tw5ou5qw5rs}fm{17sw5tw5ou5qw5rs}7n{201ts}fo{17sw5tw5ou5qw5rs}fp{17sw5tw5ou5qw5rs}fq{17sw5tw5ou5qw5rs}7r{cksclscmscnscoscps4ls}fs{17sw5tw5ou5qw5rs}ft{17su5tu}fu{17su5tu}fv{17su5tu}fw{17su5tu}fz{cksclscmscnscoscps4ls}}}"),
            "Helvetica-Bold": c("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),
            Courier: c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
            "Courier-BoldOblique": c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
            "Times-Bold": c("{'widths'{k3q2q5ncx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2l202m2n2n3m2o3m2p6o202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5x4l4s4m4m4n4s4o4s4p4m4q3x4r4y4s4y4t2r4u3m4v4y4w4m4x5y4y4s4z4y5k3x5l4y5m4s5n3r5o4m5p4s5q4s5r6o5s4s5t4s5u4m5v2l5w1w5x2l5y3u5z3m6k2l6l3m6m3r6n2w6o3r6p2w6q2l6r3m6s3r6t1w6u2l6v3r6w1w6x5n6y3r6z3m7k3r7l3r7m2w7n2r7o2l7p3r7q3m7r4s7s3m7t3m7u2w7v2r7w1q7x2r7y3o202l3mcl4sal2lam3man3mao3map3mar3mas2lat4uau1yav3maw3tay4uaz2lbk2sbl3t'fof'6obo2lbp3rbr1tbs2lbu2lbv3mbz3mck4s202k3mcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3rek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3m3u2l17s4s19m3m}'kerning'{cl{4qt5ks5ot5qy5rw17sv5tv}201t{cks4lscmscnscoscpscls4wv}2k{201ts}2w{4qu5ku7mu5os5qx5ru17su5tu}2x{17su5tu5ou5qs}2y{4qv5kv7mu5ot5qz5ru17su5tu}'fof'-6o7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qu}3v{17su5tu5os5qu}fu{17su5tu5ou5qu}7p{17su5tu5ou5qu}ck{4qt5ks5ot5qy5rw17sv5tv}4l{4qt5ks5ot5qy5rw17sv5tv}cm{4qt5ks5ot5qy5rw17sv5tv}cn{4qt5ks5ot5qy5rw17sv5tv}co{4qt5ks5ot5qy5rw17sv5tv}cp{4qt5ks5ot5qy5rw17sv5tv}6l{17st5tt5ou5qu}17s{ckuclucmucnucoucpu4lu4wu}5o{ckuclucmucnucoucpu4lu4wu}5q{ckzclzcmzcnzcozcpz4lz4wu}5r{ckxclxcmxcnxcoxcpx4lx4wu}5t{ckuclucmucnucoucpu4lu4wu}7q{ckuclucmucnucoucpu4lu}6p{17sw5tw5ou5qu}ek{17st5tt5qu}el{17st5tt5ou5qu}em{17st5tt5qu}en{17st5tt5qu}eo{17st5tt5qu}ep{17st5tt5ou5qu}es{17ss5ts5qu}et{17sw5tw5ou5qu}eu{17sw5tw5ou5qu}ev{17ss5ts5qu}6z{17sw5tw5ou5qu5rs}fm{17sw5tw5ou5qu5rs}fn{17sw5tw5ou5qu5rs}fo{17sw5tw5ou5qu5rs}fp{17sw5tw5ou5qu5rs}fq{17sw5tw5ou5qu5rs}7r{cktcltcmtcntcotcpt4lt5os}fs{17sw5tw5ou5qu5rs}ft{17su5tu5ou5qu}7m{5os}fv{17su5tu5ou5qu}fw{17su5tu5ou5qu}fz{cksclscmscnscoscps4ls}}}"),
            Symbol: c("{'widths'{k3uaw4r19m3m2k1t2l2l202m2y2n3m2p5n202q6o3k3m2s2l2t2l2v3r2w1t3m3m2y1t2z1wbk2sbl3r'fof'6o3n3m3o3m3p3m3q3m3r3m3s3m3t3m3u1w3v1w3w3r3x3r3y3r3z2wbp3t3l3m5v2l5x2l5z3m2q4yfr3r7v3k7w1o7x3k}'kerning'{'fof'-6o}}"),
            Helvetica: c("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}"),
            "Helvetica-BoldOblique": c("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),
            ZapfDingbats: c("{'widths'{k4u2k1w'fof'6o}'kerning'{'fof'-6o}}"),
            "Courier-Bold": c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
            "Times-Italic": c("{'widths'{k3n2q4ycx2l201n3m201o5t201s2l201t2l201u2l201w3r201x3r201y3r2k1t2l2l202m2n2n3m2o3m2p5n202q5t2r1p2s2l2t2l2u3m2v4n2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w4n3x4n3y4n3z3m4k5w4l3x4m3x4n4m4o4s4p3x4q3x4r4s4s4s4t2l4u2w4v4m4w3r4x5n4y4m4z4s5k3x5l4s5m3x5n3m5o3r5p4s5q3x5r5n5s3x5t3r5u3r5v2r5w1w5x2r5y2u5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q1w6r3m6s3m6t1w6u1w6v2w6w1w6x4s6y3m6z3m7k3m7l3m7m2r7n2r7o1w7p3m7q2w7r4m7s2w7t2w7u2r7v2s7w1v7x2s7y3q202l3mcl3xal2ram3man3mao3map3mar3mas2lat4wau1vav3maw4nay4waz2lbk2sbl4n'fof'6obo2lbp3mbq3obr1tbs2lbu1zbv3mbz3mck3x202k3mcm3xcn3xco3xcp3xcq5tcr4mcs3xct3xcu3xcv3xcw2l2m2ucy2lcz2ldl4mdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr4nfs3mft3mfu3mfv3mfw3mfz2w203k6o212m6m2dw2l2cq2l3t3m3u2l17s3r19m3m}'kerning'{cl{5kt4qw}201s{201sw}201t{201tw2wy2yy6q-t}201x{2wy2yy}2k{201tw}2w{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}2x{17ss5ts5os}2y{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}'fof'-6o6t{17ss5ts5qs}7t{5os}3v{5qs}7p{17su5tu5qs}ck{5kt4qw}4l{5kt4qw}cm{5kt4qw}cn{5kt4qw}co{5kt4qw}cp{5kt4qw}6l{4qs5ks5ou5qw5ru17su5tu}17s{2ks}5q{ckvclvcmvcnvcovcpv4lv}5r{ckuclucmucnucoucpu4lu}5t{2ks}6p{4qs5ks5ou5qw5ru17su5tu}ek{4qs5ks5ou5qw5ru17su5tu}el{4qs5ks5ou5qw5ru17su5tu}em{4qs5ks5ou5qw5ru17su5tu}en{4qs5ks5ou5qw5ru17su5tu}eo{4qs5ks5ou5qw5ru17su5tu}ep{4qs5ks5ou5qw5ru17su5tu}es{5ks5qs4qs}et{4qs5ks5ou5qw5ru17su5tu}eu{4qs5ks5qw5ru17su5tu}ev{5ks5qs4qs}ex{17ss5ts5qs}6z{4qv5ks5ou5qw5ru17su5tu}fm{4qv5ks5ou5qw5ru17su5tu}fn{4qv5ks5ou5qw5ru17su5tu}fo{4qv5ks5ou5qw5ru17su5tu}fp{4qv5ks5ou5qw5ru17su5tu}fq{4qv5ks5ou5qw5ru17su5tu}7r{5os}fs{4qv5ks5ou5qw5ru17su5tu}ft{17su5tu5qs}fu{17su5tu5qs}fv{17su5tu5qs}fw{17su5tu5qs}}}"),
            "Times-Roman": c("{'widths'{k3n2q4ycx2l201n3m201o6o201s2l201t2l201u2l201w2w201x2w201y2w2k1t2l2l202m2n2n3m2o3m2p5n202q6o2r1m2s2l2t2l2u3m2v3s2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v1w3w3s3x3s3y3s3z2w4k5w4l4s4m4m4n4m4o4s4p3x4q3r4r4s4s4s4t2l4u2r4v4s4w3x4x5t4y4s4z4s5k3r5l4s5m4m5n3r5o3x5p4s5q4s5r5y5s4s5t4s5u3x5v2l5w1w5x2l5y2z5z3m6k2l6l2w6m3m6n2w6o3m6p2w6q2l6r3m6s3m6t1w6u1w6v3m6w1w6x4y6y3m6z3m7k3m7l3m7m2l7n2r7o1w7p3m7q3m7r4s7s3m7t3m7u2w7v3k7w1o7x3k7y3q202l3mcl4sal2lam3man3mao3map3mar3mas2lat4wau1vav3maw3say4waz2lbk2sbl3s'fof'6obo2lbp3mbq2xbr1tbs2lbu1zbv3mbz2wck4s202k3mcm4scn4sco4scp4scq5tcr4mcs3xct3xcu3xcv3xcw2l2m2tcy2lcz2ldl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek2wel2wem2wen2weo2wep2weq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr3sfs3mft3mfu3mfv3mfw3mfz3m203k6o212m6m2dw2l2cq2l3t3m3u1w17s4s19m3m}'kerning'{cl{4qs5ku17sw5ou5qy5rw201ss5tw201ws}201s{201ss}201t{ckw4lwcmwcnwcowcpwclw4wu201ts}2k{201ts}2w{4qs5kw5os5qx5ru17sx5tx}2x{17sw5tw5ou5qu}2y{4qs5kw5os5qx5ru17sx5tx}'fof'-6o7t{ckuclucmucnucoucpu4lu5os5rs}3u{17su5tu5qs}3v{17su5tu5qs}7p{17sw5tw5qs}ck{4qs5ku17sw5ou5qy5rw201ss5tw201ws}4l{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cm{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cn{4qs5ku17sw5ou5qy5rw201ss5tw201ws}co{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cp{4qs5ku17sw5ou5qy5rw201ss5tw201ws}6l{17su5tu5os5qw5rs}17s{2ktclvcmvcnvcovcpv4lv4wuckv}5o{ckwclwcmwcnwcowcpw4lw4wu}5q{ckyclycmycnycoycpy4ly4wu5ms}5r{cktcltcmtcntcotcpt4lt4ws}5t{2ktclvcmvcnvcovcpv4lv4wuckv}7q{cksclscmscnscoscps4ls}6p{17su5tu5qw5rs}ek{5qs5rs}el{17su5tu5os5qw5rs}em{17su5tu5os5qs5rs}en{17su5qs5rs}eo{5qs5rs}ep{17su5tu5os5qw5rs}es{5qs}et{17su5tu5qw5rs}eu{17su5tu5qs5rs}ev{5qs}6z{17sv5tv5os5qx5rs}fm{5os5qt5rs}fn{17sv5tv5os5qx5rs}fo{17sv5tv5os5qx5rs}fp{5os5qt5rs}fq{5os5qt5rs}7r{ckuclucmucnucoucpu4lu5os}fs{17sv5tv5os5qx5rs}ft{17ss5ts5qs}fu{17sw5tw5qs}fv{17sw5tw5qs}fw{17ss5ts5qs}fz{ckuclucmucnucoucpu4lu5os5rs}}}"),
            "Helvetica-Oblique": c("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}")
        }
    };
    e.events.push([
        "addFont",
        function(t) {
            var e = t.font, n = f.Unicode[e.postScriptName];
            n && (e.metadata.Unicode = {}, e.metadata.Unicode.widths = n.widths, e.metadata.Unicode.kerning = n.kerning);
            var r = h.Unicode[e.postScriptName];
            r && (e.metadata.Unicode.encoding = r, e.encoding = r.codePages[0]);
        }
    ]);
}(E.API), /**
 * @license
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e = function(t) {
        for(var e = t.length, n = new Uint8Array(e), r = 0; r < e; r++)n[r] = t.charCodeAt(r);
        return n;
    };
    t.API.events.push([
        "addFont",
        function(n) {
            var r = void 0, i = n.font, a = n.instance;
            if (!i.isStandardFont) {
                if (void 0 === a) throw new Error("Font does not exist in vFS, import fonts or remove declaration doc.addFont('" + i.postScriptName + "').");
                if ("string" != typeof (r = !1 === a.existsFileInVFS(i.postScriptName) ? a.loadFile(i.postScriptName) : a.getFileFromVFS(i.postScriptName))) throw new Error("Font is not stored as string-data in vFS, import fonts or remove declaration doc.addFont('" + i.postScriptName + "').");
                !function(n, r) {
                    r = /^\x00\x01\x00\x00/.test(r) ? e(r) : e(f(r)), n.metadata = t.API.TTFFont.open(r), n.metadata.Unicode = n.metadata.Unicode || {
                        encoding: {},
                        kerning: {},
                        widths: []
                    }, n.metadata.glyIdsUsed = [
                        0
                    ];
                }(i, r);
            }
        }
    ]);
}(E), E.API.addSvgAsImage = function(t, e, n, r, a, s, u, c) {
    if (isNaN(e) || isNaN(n)) throw o.error("jsPDF.addSvgAsImage: Invalid coordinates", arguments), new Error("Invalid coordinates passed to jsPDF.addSvgAsImage");
    if (isNaN(r) || isNaN(a)) throw o.error("jsPDF.addSvgAsImage: Invalid measurements", arguments), new Error("Invalid measurements (width and/or height) passed to jsPDF.addSvgAsImage");
    var l = document.createElement("canvas");
    l.width = r, l.height = a;
    var h = l.getContext("2d");
    h.fillStyle = "#fff", h.fillRect(0, 0, l.width, l.height);
    var f = {
        ignoreMouse: !0,
        ignoreAnimation: !0,
        ignoreDimensions: !0
    }, d = this;
    return (i.canvg ? Promise.resolve(i.canvg) : require("7ec43201f0dbcdb8")).catch(function(t) {
        return Promise.reject(new Error("Could not load canvg: " + t));
    }).then(function(t) {
        return t.default ? t.default : t;
    }).then(function(e) {
        return e.fromString(h, t, f);
    }, function() {
        return Promise.reject(new Error("Could not load canvg."));
    }).then(function(t) {
        return t.render(f);
    }).then(function() {
        d.addImage(l.toDataURL("image/jpeg", 1), e, n, r, a, u, c);
    });
}, E.API.putTotalPages = function(t) {
    var e, n = 0;
    parseInt(this.internal.getFont().id.substr(1), 10) < 15 ? (e = new RegExp(t, "g"), n = this.internal.getNumberOfPages()) : (e = new RegExp(this.pdfEscape16(t, this.internal.getFont()), "g"), n = this.pdfEscape16(this.internal.getNumberOfPages() + "", this.internal.getFont()));
    for(var r = 1; r <= this.internal.getNumberOfPages(); r++)for(var i = 0; i < this.internal.pages[r].length; i++)this.internal.pages[r][i] = this.internal.pages[r][i].replace(e, n);
    return this;
}, E.API.viewerPreferences = function(e, n) {
    var r;
    e = e || {}, n = n || !1;
    var i, a, o, s = {
        HideToolbar: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.3
        },
        HideMenubar: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.3
        },
        HideWindowUI: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.3
        },
        FitWindow: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.3
        },
        CenterWindow: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.3
        },
        DisplayDocTitle: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.4
        },
        NonFullScreenPageMode: {
            defaultValue: "UseNone",
            value: "UseNone",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "UseNone",
                "UseOutlines",
                "UseThumbs",
                "UseOC"
            ],
            pdfVersion: 1.3
        },
        Direction: {
            defaultValue: "L2R",
            value: "L2R",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "L2R",
                "R2L"
            ],
            pdfVersion: 1.3
        },
        ViewArea: {
            defaultValue: "CropBox",
            value: "CropBox",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "MediaBox",
                "CropBox",
                "TrimBox",
                "BleedBox",
                "ArtBox"
            ],
            pdfVersion: 1.4
        },
        ViewClip: {
            defaultValue: "CropBox",
            value: "CropBox",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "MediaBox",
                "CropBox",
                "TrimBox",
                "BleedBox",
                "ArtBox"
            ],
            pdfVersion: 1.4
        },
        PrintArea: {
            defaultValue: "CropBox",
            value: "CropBox",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "MediaBox",
                "CropBox",
                "TrimBox",
                "BleedBox",
                "ArtBox"
            ],
            pdfVersion: 1.4
        },
        PrintClip: {
            defaultValue: "CropBox",
            value: "CropBox",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "MediaBox",
                "CropBox",
                "TrimBox",
                "BleedBox",
                "ArtBox"
            ],
            pdfVersion: 1.4
        },
        PrintScaling: {
            defaultValue: "AppDefault",
            value: "AppDefault",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "AppDefault",
                "None"
            ],
            pdfVersion: 1.6
        },
        Duplex: {
            defaultValue: "",
            value: "none",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "Simplex",
                "DuplexFlipShortEdge",
                "DuplexFlipLongEdge",
                "none"
            ],
            pdfVersion: 1.7
        },
        PickTrayByPDFSize: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.7
        },
        PrintPageRange: {
            defaultValue: "",
            value: "",
            type: "array",
            explicitSet: !1,
            valueSet: null,
            pdfVersion: 1.7
        },
        NumCopies: {
            defaultValue: 1,
            value: 1,
            type: "integer",
            explicitSet: !1,
            valueSet: null,
            pdfVersion: 1.7
        }
    }, u = Object.keys(s), c = [], l = 0, h = 0, f = 0;
    function d(t, e) {
        var n, r = !1;
        for(n = 0; n < t.length; n += 1)t[n] === e && (r = !0);
        return r;
    }
    if (void 0 === this.internal.viewerpreferences && (this.internal.viewerpreferences = {}, this.internal.viewerpreferences.configuration = JSON.parse(JSON.stringify(s)), this.internal.viewerpreferences.isSubscribed = !1), r = this.internal.viewerpreferences.configuration, "reset" === e || !0 === n) {
        var p = u.length;
        for(f = 0; f < p; f += 1)r[u[f]].value = r[u[f]].defaultValue, r[u[f]].explicitSet = !1;
    }
    if ("object" === (0, _typeofDefault.default)(e)) {
        for(a in e)if (o = e[a], d(u, a) && void 0 !== o) {
            if ("boolean" === r[a].type && "boolean" == typeof o) r[a].value = o;
            else if ("name" === r[a].type && d(r[a].valueSet, o)) r[a].value = o;
            else if ("integer" === r[a].type && Number.isInteger(o)) r[a].value = o;
            else if ("array" === r[a].type) {
                for(l = 0; l < o.length; l += 1)if (i = !0, 1 === o[l].length && "number" == typeof o[l][0]) c.push(String(o[l] - 1));
                else if (o[l].length > 1) {
                    for(h = 0; h < o[l].length; h += 1)"number" != typeof o[l][h] && (i = !1);
                    !0 === i && c.push([
                        o[l][0] - 1,
                        o[l][1] - 1
                    ].join(" "));
                }
                r[a].value = "[" + c.join(" ") + "]";
            } else r[a].value = r[a].defaultValue;
            r[a].explicitSet = !0;
        }
    }
    return !1 === this.internal.viewerpreferences.isSubscribed && (this.internal.events.subscribe("putCatalog", function() {
        var t, e = [];
        for(t in r)!0 === r[t].explicitSet && ("name" === r[t].type ? e.push("/" + t + " /" + r[t].value) : e.push("/" + t + " " + r[t].value));
        0 !== e.length && this.internal.write("/ViewerPreferences\n<<\n" + e.join("\n") + "\n>>");
    }), this.internal.viewerpreferences.isSubscribed = !0), this.internal.viewerpreferences.configuration = r, this;
}, /** ====================================================================
 * @license
 * jsPDF XMP metadata plugin
 * Copyright (c) 2016 Jussi Utunen, u-jussi@suomi24.fi
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 * ====================================================================
 */ function(t) {
    var e = function() {
        var t = '<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"><rdf:Description rdf:about="" xmlns:jspdf="' + this.internal.__metadata__.namespaceuri + '"><jspdf:metadata>', e = unescape(encodeURIComponent('<x:xmpmeta xmlns:x="adobe:ns:meta/">')), n = unescape(encodeURIComponent(t)), r = unescape(encodeURIComponent(this.internal.__metadata__.metadata)), i = unescape(encodeURIComponent("</jspdf:metadata></rdf:Description></rdf:RDF>")), a = unescape(encodeURIComponent("</x:xmpmeta>")), o = n.length + r.length + i.length + e.length + a.length;
        this.internal.__metadata__.metadata_object_number = this.internal.newObject(), this.internal.write("<< /Type /Metadata /Subtype /XML /Length " + o + " >>"), this.internal.write("stream"), this.internal.write(e + n + r + i + a), this.internal.write("endstream"), this.internal.write("endobj");
    }, n = function() {
        this.internal.__metadata__.metadata_object_number && this.internal.write("/Metadata " + this.internal.__metadata__.metadata_object_number + " 0 R");
    };
    t.addMetadata = function(t, r) {
        return void 0 === this.internal.__metadata__ && (this.internal.__metadata__ = {
            metadata: t,
            namespaceuri: r || "http://jspdf.default.namespaceuri/"
        }, this.internal.events.subscribe("putCatalog", n), this.internal.events.subscribe("postPutResources", e)), this;
    };
}(E.API), function(t) {
    var e = t.API, n = e.pdfEscape16 = function(t, e) {
        for(var n, r = e.metadata.Unicode.widths, i = [
            "",
            "0",
            "00",
            "000",
            "0000"
        ], a = [
            ""
        ], o = 0, s = t.length; o < s; ++o){
            if (n = e.metadata.characterToGlyph(t.charCodeAt(o)), e.metadata.glyIdsUsed.push(n), e.metadata.toUnicode[n] = t.charCodeAt(o), -1 == r.indexOf(n) && (r.push(n), r.push([
                parseInt(e.metadata.widthOfGlyph(n), 10)
            ])), "0" == n) return a.join("");
            n = n.toString(16), a.push(i[4 - n.length], n);
        }
        return a.join("");
    }, r = function(t) {
        var e, n, r, i, a, o, s;
        for(a = "/CIDInit /ProcSet findresource begin\n12 dict begin\nbegincmap\n/CIDSystemInfo <<\n  /Registry (Adobe)\n  /Ordering (UCS)\n  /Supplement 0\n>> def\n/CMapName /Adobe-Identity-UCS def\n/CMapType 2 def\n1 begincodespacerange\n<0000><ffff>\nendcodespacerange", r = [], o = 0, s = (n = Object.keys(t).sort(function(t, e) {
            return t - e;
        })).length; o < s; o++)e = n[o], r.length >= 100 && (a += "\n" + r.length + " beginbfchar\n" + r.join("\n") + "\nendbfchar", r = []), void 0 !== t[e] && null !== t[e] && "function" == typeof t[e].toString && (i = ("0000" + t[e].toString(16)).slice(-4), e = ("0000" + (+e).toString(16)).slice(-4), r.push("<" + e + "><" + i + ">"));
        return r.length && (a += "\n" + r.length + " beginbfchar\n" + r.join("\n") + "\nendbfchar\n"), a + "endcmap\nCMapName currentdict /CMap defineresource pop\nend\nend";
    };
    e.events.push([
        "putFont",
        function(e) {
            !function(e) {
                var n = e.font, i = e.out, a = e.newObject, o = e.putStream;
                if (n.metadata instanceof t.API.TTFFont && "Identity-H" === n.encoding) {
                    for(var s = n.metadata.Unicode.widths, u = n.metadata.subset.encode(n.metadata.glyIdsUsed, 1), c = "", l = 0; l < u.length; l++)c += String.fromCharCode(u[l]);
                    var h = a();
                    o({
                        data: c,
                        addLength1: !0,
                        objectId: h
                    }), i("endobj");
                    var f = a();
                    o({
                        data: r(n.metadata.toUnicode),
                        addLength1: !0,
                        objectId: f
                    }), i("endobj");
                    var d = a();
                    i("<<"), i("/Type /FontDescriptor"), i("/FontName /" + j(n.fontName)), i("/FontFile2 " + h + " 0 R"), i("/FontBBox " + t.API.PDFObject.convert(n.metadata.bbox)), i("/Flags " + n.metadata.flags), i("/StemV " + n.metadata.stemV), i("/ItalicAngle " + n.metadata.italicAngle), i("/Ascent " + n.metadata.ascender), i("/Descent " + n.metadata.decender), i("/CapHeight " + n.metadata.capHeight), i(">>"), i("endobj");
                    var p = a();
                    i("<<"), i("/Type /Font"), i("/BaseFont /" + j(n.fontName)), i("/FontDescriptor " + d + " 0 R"), i("/W " + t.API.PDFObject.convert(s)), i("/CIDToGIDMap /Identity"), i("/DW 1000"), i("/Subtype /CIDFontType2"), i("/CIDSystemInfo"), i("<<"), i("/Supplement 0"), i("/Registry (Adobe)"), i("/Ordering (" + n.encoding + ")"), i(">>"), i(">>"), i("endobj"), n.objectNumber = a(), i("<<"), i("/Type /Font"), i("/Subtype /Type0"), i("/ToUnicode " + f + " 0 R"), i("/BaseFont /" + j(n.fontName)), i("/Encoding /" + n.encoding), i("/DescendantFonts [" + p + " 0 R]"), i(">>"), i("endobj"), n.isAlreadyPutted = !0;
                }
            }(e);
        }
    ]), e.events.push([
        "putFont",
        function(e) {
            !function(e) {
                var n = e.font, i = e.out, a = e.newObject, o = e.putStream;
                if (n.metadata instanceof t.API.TTFFont && "WinAnsiEncoding" === n.encoding) {
                    for(var s = n.metadata.rawData, u = "", c = 0; c < s.length; c++)u += String.fromCharCode(s[c]);
                    var l = a();
                    o({
                        data: u,
                        addLength1: !0,
                        objectId: l
                    }), i("endobj");
                    var h = a();
                    o({
                        data: r(n.metadata.toUnicode),
                        addLength1: !0,
                        objectId: h
                    }), i("endobj");
                    var f = a();
                    i("<<"), i("/Descent " + n.metadata.decender), i("/CapHeight " + n.metadata.capHeight), i("/StemV " + n.metadata.stemV), i("/Type /FontDescriptor"), i("/FontFile2 " + l + " 0 R"), i("/Flags 96"), i("/FontBBox " + t.API.PDFObject.convert(n.metadata.bbox)), i("/FontName /" + j(n.fontName)), i("/ItalicAngle " + n.metadata.italicAngle), i("/Ascent " + n.metadata.ascender), i(">>"), i("endobj"), n.objectNumber = a();
                    for(var d = 0; d < n.metadata.hmtx.widths.length; d++)n.metadata.hmtx.widths[d] = parseInt(n.metadata.hmtx.widths[d] * (1e3 / n.metadata.head.unitsPerEm));
                    i("<</Subtype/TrueType/Type/Font/ToUnicode " + h + " 0 R/BaseFont/" + j(n.fontName) + "/FontDescriptor " + f + " 0 R/Encoding/" + n.encoding + " /FirstChar 29 /LastChar 255 /Widths " + t.API.PDFObject.convert(n.metadata.hmtx.widths) + ">>"), i("endobj"), n.isAlreadyPutted = !0;
                }
            }(e);
        }
    ]);
    var i = function(t) {
        var e, r = t.text || "", i = t.x, a = t.y, o = t.options || {}, s = t.mutex || {}, u = s.pdfEscape, c = s.activeFontKey, l = s.fonts, h = c, f = "", d = 0, p = "", g = l[h].encoding;
        if ("Identity-H" !== l[h].encoding) return {
            text: r,
            x: i,
            y: a,
            options: o,
            mutex: s
        };
        for(p = r, h = c, Array.isArray(r) && (p = r[0]), d = 0; d < p.length; d += 1)l[h].metadata.hasOwnProperty("cmap") && (e = l[h].metadata.cmap.unicode.codeMap[p[d].charCodeAt(0)]), e || p[d].charCodeAt(0) < 256 && l[h].metadata.hasOwnProperty("Unicode") ? f += p[d] : f += "";
        var m = "";
        return parseInt(h.slice(1)) < 14 || "WinAnsiEncoding" === g ? m = u(f, h).split("").map(function(t) {
            return t.charCodeAt(0).toString(16);
        }).join("") : "Identity-H" === g && (m = n(f, l[h])), s.isHex = !0, {
            text: m,
            x: i,
            y: a,
            options: o,
            mutex: s
        };
    };
    e.events.push([
        "postProcessText",
        function(t) {
            var e = t.text || "", n = [], r = {
                text: e,
                x: t.x,
                y: t.y,
                options: t.options,
                mutex: t.mutex
            };
            if (Array.isArray(e)) {
                var a = 0;
                for(a = 0; a < e.length; a += 1)Array.isArray(e[a]) && 3 === e[a].length ? n.push([
                    i(Object.assign({}, r, {
                        text: e[a][0]
                    })).text,
                    e[a][1],
                    e[a][2]
                ]) : n.push(i(Object.assign({}, r, {
                    text: e[a]
                })).text);
                t.text = n;
            } else t.text = i(Object.assign({}, r, {
                text: e
            })).text;
        }
    ]);
}(E), /**
 * @license
 * jsPDF virtual FileSystem functionality
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e = function() {
        return void 0 === this.internal.vFS && (this.internal.vFS = {}), !0;
    };
    t.existsFileInVFS = function(t) {
        return e.call(this), void 0 !== this.internal.vFS[t];
    }, t.addFileToVFS = function(t, n) {
        return e.call(this), this.internal.vFS[t] = n, this;
    }, t.getFileFromVFS = function(t) {
        return e.call(this), void 0 !== this.internal.vFS[t] ? this.internal.vFS[t] : null;
    };
}(E.API), /**
 * @license
 * Unicode Bidi Engine based on the work of Alex Shensis (@asthensis)
 * MIT License
 */ function(t) {
    t.__bidiEngine__ = t.prototype.__bidiEngine__ = function(t) {
        var n, r, i, a, o, s, u, c = e, l = [
            [
                0,
                3,
                0,
                1,
                0,
                0,
                0
            ],
            [
                0,
                3,
                0,
                1,
                2,
                2,
                0
            ],
            [
                0,
                3,
                0,
                17,
                2,
                0,
                1
            ],
            [
                0,
                3,
                5,
                5,
                4,
                1,
                0
            ],
            [
                0,
                3,
                21,
                21,
                4,
                0,
                1
            ],
            [
                0,
                3,
                5,
                5,
                4,
                2,
                0
            ]
        ], h = [
            [
                2,
                0,
                1,
                1,
                0,
                1,
                0
            ],
            [
                2,
                0,
                1,
                1,
                0,
                2,
                0
            ],
            [
                2,
                0,
                2,
                1,
                3,
                2,
                0
            ],
            [
                2,
                0,
                2,
                33,
                3,
                1,
                1
            ]
        ], f = {
            L: 0,
            R: 1,
            EN: 2,
            AN: 3,
            N: 4,
            B: 5,
            S: 6
        }, d = {
            0: 0,
            5: 1,
            6: 2,
            7: 3,
            32: 4,
            251: 5,
            254: 6,
            255: 7
        }, p = [
            "(",
            ")",
            "(",
            "<",
            ">",
            "<",
            "[",
            "]",
            "[",
            "{",
            "}",
            "{",
            "\xab",
            "\xbb",
            "\xab",
            "\u2039",
            "\u203A",
            "\u2039",
            "\u2045",
            "\u2046",
            "\u2045",
            "\u207D",
            "\u207E",
            "\u207D",
            "\u208D",
            "\u208E",
            "\u208D",
            "\u2264",
            "\u2265",
            "\u2264",
            "\u2329",
            "\u232A",
            "\u2329",
            "\uFE59",
            "\uFE5A",
            "\uFE59",
            "\uFE5B",
            "\uFE5C",
            "\uFE5B",
            "\uFE5D",
            "\uFE5E",
            "\uFE5D",
            "\uFE64",
            "\uFE65",
            "\uFE64"
        ], g = new RegExp(/^([1-4|9]|1[0-9]|2[0-9]|3[0168]|4[04589]|5[012]|7[78]|159|16[0-9]|17[0-2]|21[569]|22[03489]|250)$/), m = !1, v = 0;
        this.__bidiEngine__ = {};
        var b = function(t) {
            var e = t.charCodeAt(), n = e >> 8, r = d[n];
            return void 0 !== r ? c[256 * r + (255 & e)] : 252 === n || 253 === n ? "AL" : g.test(n) ? "L" : 8 === n ? "R" : "N";
        }, y = function(t) {
            for(var e, n = 0; n < t.length; n++){
                if ("L" === (e = b(t.charAt(n)))) return !1;
                if ("R" === e) return !0;
            }
            return !1;
        }, w = function(t, e, o, s) {
            var u, c, l, h, f = e[s];
            switch(f){
                case "L":
                case "R":
                case "LRE":
                case "RLE":
                case "LRO":
                case "RLO":
                case "PDF":
                    m = !1;
                    break;
                case "N":
                case "AN":
                    break;
                case "EN":
                    m && (f = "AN");
                    break;
                case "AL":
                    m = !0, f = "R";
                    break;
                case "WS":
                case "BN":
                    f = "N";
                    break;
                case "CS":
                    s < 1 || s + 1 >= e.length || "EN" !== (u = o[s - 1]) && "AN" !== u || "EN" !== (c = e[s + 1]) && "AN" !== c ? f = "N" : m && (c = "AN"), f = c === u ? c : "N";
                    break;
                case "ES":
                    f = "EN" === (u = s > 0 ? o[s - 1] : "B") && s + 1 < e.length && "EN" === e[s + 1] ? "EN" : "N";
                    break;
                case "ET":
                    if (s > 0 && "EN" === o[s - 1]) {
                        f = "EN";
                        break;
                    }
                    if (m) {
                        f = "N";
                        break;
                    }
                    for(l = s + 1, h = e.length; l < h && "ET" === e[l];)l++;
                    f = l < h && "EN" === e[l] ? "EN" : "N";
                    break;
                case "NSM":
                    if (i && !a) {
                        for(h = e.length, l = s + 1; l < h && "NSM" === e[l];)l++;
                        if (l < h) {
                            var d = t[s], p = d >= 1425 && d <= 2303 || 64286 === d;
                            if (u = e[l], p && ("R" === u || "AL" === u)) {
                                f = "R";
                                break;
                            }
                        }
                    }
                    f = s < 1 || "B" === (u = e[s - 1]) ? "N" : o[s - 1];
                    break;
                case "B":
                    m = !1, n = !0, f = v;
                    break;
                case "S":
                    r = !0, f = "N";
            }
            return f;
        }, N = function(t, e, n) {
            var r = t.split("");
            return n && L(r, n, {
                hiLevel: v
            }), r.reverse(), e && e.reverse(), r.join("");
        }, L = function(t, e, i) {
            var a, o, s, u, c, d = -1, p = t.length, g = 0, y = [], N = v ? h : l, L = [];
            for(m = !1, n = !1, r = !1, o = 0; o < p; o++)L[o] = b(t[o]);
            for(s = 0; s < p; s++){
                if (c = g, y[s] = w(t, L, y, s), a = 240 & (g = N[c][f[y[s]]]), g &= 15, e[s] = u = N[g][5], a > 0) {
                    if (16 === a) {
                        for(o = d; o < s; o++)e[o] = 1;
                        d = -1;
                    } else d = -1;
                }
                if (N[g][6]) -1 === d && (d = s);
                else if (d > -1) {
                    for(o = d; o < s; o++)e[o] = u;
                    d = -1;
                }
                "B" === L[s] && (e[s] = 0), i.hiLevel |= u;
            }
            r && function(t, e, n) {
                for(var r = 0; r < n; r++)if ("S" === t[r]) {
                    e[r] = v;
                    for(var i = r - 1; i >= 0 && "WS" === t[i]; i--)e[i] = v;
                }
            }(L, e, p);
        }, x = function(t, e, r, i, a) {
            if (!(a.hiLevel < t)) {
                if (1 === t && 1 === v && !n) return e.reverse(), void (r && r.reverse());
                for(var o, s, u, c, l = e.length, h = 0; h < l;){
                    if (i[h] >= t) {
                        for(u = h + 1; u < l && i[u] >= t;)u++;
                        for(c = h, s = u - 1; c < s; c++, s--)o = e[c], e[c] = e[s], e[s] = o, r && (o = r[c], r[c] = r[s], r[s] = o);
                        h = u;
                    }
                    h++;
                }
            }
        }, A = function(t, e, n) {
            var r = t.split(""), i = {
                hiLevel: v
            };
            return n || (n = []), L(r, n, i), function(t, e, n) {
                if (0 !== n.hiLevel && u) for(var r, i = 0; i < t.length; i++)1 === e[i] && (r = p.indexOf(t[i])) >= 0 && (t[i] = p[r + 1]);
            }(r, n, i), x(2, r, e, n, i), x(1, r, e, n, i), r.join("");
        };
        return this.__bidiEngine__.doBidiReorder = function(t, e, n) {
            if (function(t, e) {
                if (e) for(var n = 0; n < t.length; n++)e[n] = n;
                void 0 === a && (a = y(t)), void 0 === s && (s = y(t));
            }(t, e), i || !o || s) {
                if (i && o && a ^ s) v = a ? 1 : 0, t = N(t, e, n);
                else if (!i && o && s) v = a ? 1 : 0, t = A(t, e, n), t = N(t, e);
                else if (!i || a || o || s) {
                    if (i && !o && a ^ s) t = N(t, e), a ? (v = 0, t = A(t, e, n)) : (v = 1, t = A(t, e, n), t = N(t, e));
                    else if (i && a && !o && s) v = 1, t = A(t, e, n), t = N(t, e);
                    else if (!i && !o && a ^ s) {
                        var r = u;
                        a ? (v = 1, t = A(t, e, n), v = 0, u = !1, t = A(t, e, n), u = r) : (v = 0, t = A(t, e, n), t = N(t, e), v = 1, u = !1, t = A(t, e, n), u = r, t = N(t, e));
                    }
                } else v = 0, t = A(t, e, n);
            } else v = a ? 1 : 0, t = A(t, e, n);
            return t;
        }, this.__bidiEngine__.setOptions = function(t) {
            t && (i = t.isInputVisual, o = t.isOutputVisual, a = t.isInputRtl, s = t.isOutputRtl, u = t.isSymmetricSwapping);
        }, this.__bidiEngine__.setOptions(t), this.__bidiEngine__;
    };
    var e = [
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "S",
        "B",
        "S",
        "WS",
        "B",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "B",
        "B",
        "B",
        "S",
        "WS",
        "N",
        "N",
        "ET",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "N",
        "ES",
        "CS",
        "ES",
        "CS",
        "CS",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "CS",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "N",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "B",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "CS",
        "N",
        "ET",
        "ET",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "L",
        "N",
        "N",
        "BN",
        "N",
        "N",
        "ET",
        "ET",
        "EN",
        "EN",
        "N",
        "L",
        "N",
        "N",
        "N",
        "EN",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "ET",
        "N",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "R",
        "NSM",
        "R",
        "NSM",
        "NSM",
        "R",
        "NSM",
        "NSM",
        "R",
        "NSM",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "N",
        "N",
        "N",
        "N",
        "N",
        "R",
        "R",
        "R",
        "R",
        "R",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "N",
        "N",
        "AL",
        "ET",
        "ET",
        "AL",
        "CS",
        "AL",
        "N",
        "N",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "AL",
        "AL",
        "N",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "ET",
        "AN",
        "AN",
        "AL",
        "AL",
        "AL",
        "NSM",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "AN",
        "N",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "AL",
        "AL",
        "NSM",
        "NSM",
        "N",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "AL",
        "AL",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "N",
        "AL",
        "AL",
        "NSM",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "N",
        "N",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "AL",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "R",
        "R",
        "N",
        "N",
        "N",
        "N",
        "R",
        "N",
        "N",
        "N",
        "N",
        "N",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "BN",
        "BN",
        "BN",
        "L",
        "R",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "WS",
        "B",
        "LRE",
        "RLE",
        "PDF",
        "LRO",
        "RLO",
        "CS",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "CS",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "WS",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "N",
        "LRI",
        "RLI",
        "FSI",
        "PDI",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "EN",
        "L",
        "N",
        "N",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "ES",
        "ES",
        "N",
        "N",
        "N",
        "L",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "ES",
        "ES",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "R",
        "NSM",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "ES",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "N",
        "R",
        "R",
        "R",
        "R",
        "R",
        "N",
        "R",
        "N",
        "R",
        "R",
        "N",
        "R",
        "R",
        "N",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "CS",
        "N",
        "CS",
        "N",
        "N",
        "CS",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "ET",
        "N",
        "N",
        "ES",
        "ES",
        "N",
        "N",
        "N",
        "N",
        "N",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "N",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "N",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "N",
        "N",
        "BN",
        "N",
        "N",
        "N",
        "ET",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "N",
        "ES",
        "CS",
        "ES",
        "CS",
        "CS",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "CS",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N"
    ], n = new t.__bidiEngine__({
        isInputVisual: !0
    });
    t.API.events.push([
        "postProcessText",
        function(t) {
            var e = t.text;
            t.x, t.y;
            var r = t.options || {};
            t.mutex, r.lang;
            var i = [];
            if (r.isInputVisual = "boolean" != typeof r.isInputVisual || r.isInputVisual, n.setOptions(r), "[object Array]" === Object.prototype.toString.call(e)) {
                var a = 0;
                for(i = [], a = 0; a < e.length; a += 1)"[object Array]" === Object.prototype.toString.call(e[a]) ? i.push([
                    n.doBidiReorder(e[a][0]),
                    e[a][1],
                    e[a][2]
                ]) : i.push([
                    n.doBidiReorder(e[a])
                ]);
                t.text = i;
            } else t.text = n.doBidiReorder(e);
            n.setOptions({
                isInputVisual: !0
            });
        }
    ]);
}(E), E.API.TTFFont = function() {
    function t(t) {
        var e;
        if (this.rawData = t, e = this.contents = new fe(t), this.contents.pos = 4, "ttcf" === e.readString(4)) throw new Error("TTCF not supported.");
        e.pos = 0, this.parse(), this.subset = new je(this), this.registerTTF();
    }
    return t.open = function(e) {
        return new t(e);
    }, t.prototype.parse = function() {
        return this.directory = new de(this.contents), this.head = new me(this), this.name = new xe(this), this.cmap = new be(this), this.toUnicode = {}, this.hhea = new ye(this), this.maxp = new Ae(this), this.hmtx = new Se(this), this.post = new Ne(this), this.os2 = new we(this), this.loca = new Ie(this), this.glyf = new Pe(this), this.ascender = this.os2.exists && this.os2.ascender || this.hhea.ascender, this.decender = this.os2.exists && this.os2.decender || this.hhea.decender, this.lineGap = this.os2.exists && this.os2.lineGap || this.hhea.lineGap, this.bbox = [
            this.head.xMin,
            this.head.yMin,
            this.head.xMax,
            this.head.yMax
        ];
    }, t.prototype.registerTTF = function() {
        var t, e, n, r, i;
        if (this.scaleFactor = 1e3 / this.head.unitsPerEm, this.bbox = (function() {
            var e, n, r, i;
            for(i = [], e = 0, n = (r = this.bbox).length; e < n; e++)t = r[e], i.push(Math.round(t * this.scaleFactor));
            return i;
        }).call(this), this.stemV = 0, this.post.exists ? (n = 255 & (r = this.post.italic_angle), 32768 & (e = r >> 16) && (e = -(1 + (65535 ^ e))), this.italicAngle = +(e + "." + n)) : this.italicAngle = 0, this.ascender = Math.round(this.ascender * this.scaleFactor), this.decender = Math.round(this.decender * this.scaleFactor), this.lineGap = Math.round(this.lineGap * this.scaleFactor), this.capHeight = this.os2.exists && this.os2.capHeight || this.ascender, this.xHeight = this.os2.exists && this.os2.xHeight || 0, this.familyClass = (this.os2.exists && this.os2.familyClass || 0) >> 8, this.isSerif = 1 === (i = this.familyClass) || 2 === i || 3 === i || 4 === i || 5 === i || 7 === i, this.isScript = 10 === this.familyClass, this.flags = 0, this.post.isFixedPitch && (this.flags |= 1), this.isSerif && (this.flags |= 2), this.isScript && (this.flags |= 8), 0 !== this.italicAngle && (this.flags |= 64), this.flags |= 32, !this.cmap.unicode) throw new Error("No unicode cmap for font");
    }, t.prototype.characterToGlyph = function(t) {
        var e;
        return (null != (e = this.cmap.unicode) ? e.codeMap[t] : void 0) || 0;
    }, t.prototype.widthOfGlyph = function(t) {
        var e;
        return e = 1e3 / this.head.unitsPerEm, this.hmtx.forGlyph(t).advance * e;
    }, t.prototype.widthOfString = function(t, e, n) {
        var r, i, a, o;
        for(a = 0, i = 0, o = (t = "" + t).length; 0 <= o ? i < o : i > o; i = 0 <= o ? ++i : --i)r = t.charCodeAt(i), a += this.widthOfGlyph(this.characterToGlyph(r)) + n * (1e3 / e) || 0;
        return a * (e / 1e3);
    }, t.prototype.lineHeight = function(t, e) {
        var n;
        return null == e && (e = !1), n = e ? this.lineGap : 0, (this.ascender + n - this.decender) / 1e3 * t;
    }, t;
}();
var he, fe = function() {
    function t(t) {
        this.data = null != t ? t : [], this.pos = 0, this.length = this.data.length;
    }
    return t.prototype.readByte = function() {
        return this.data[this.pos++];
    }, t.prototype.writeByte = function(t) {
        return this.data[this.pos++] = t;
    }, t.prototype.readUInt32 = function() {
        return 16777216 * this.readByte() + (this.readByte() << 16) + (this.readByte() << 8) + this.readByte();
    }, t.prototype.writeUInt32 = function(t) {
        return this.writeByte(t >>> 24 & 255), this.writeByte(t >> 16 & 255), this.writeByte(t >> 8 & 255), this.writeByte(255 & t);
    }, t.prototype.readInt32 = function() {
        var t;
        return (t = this.readUInt32()) >= 2147483648 ? t - 4294967296 : t;
    }, t.prototype.writeInt32 = function(t) {
        return t < 0 && (t += 4294967296), this.writeUInt32(t);
    }, t.prototype.readUInt16 = function() {
        return this.readByte() << 8 | this.readByte();
    }, t.prototype.writeUInt16 = function(t) {
        return this.writeByte(t >> 8 & 255), this.writeByte(255 & t);
    }, t.prototype.readInt16 = function() {
        var t;
        return (t = this.readUInt16()) >= 32768 ? t - 65536 : t;
    }, t.prototype.writeInt16 = function(t) {
        return t < 0 && (t += 65536), this.writeUInt16(t);
    }, t.prototype.readString = function(t) {
        var e, n;
        for(n = [], e = 0; 0 <= t ? e < t : e > t; e = 0 <= t ? ++e : --e)n[e] = String.fromCharCode(this.readByte());
        return n.join("");
    }, t.prototype.writeString = function(t) {
        var e, n, r;
        for(r = [], e = 0, n = t.length; 0 <= n ? e < n : e > n; e = 0 <= n ? ++e : --e)r.push(this.writeByte(t.charCodeAt(e)));
        return r;
    }, t.prototype.readShort = function() {
        return this.readInt16();
    }, t.prototype.writeShort = function(t) {
        return this.writeInt16(t);
    }, t.prototype.readLongLong = function() {
        var t, e, n, r, i, a, o, s;
        return t = this.readByte(), e = this.readByte(), n = this.readByte(), r = this.readByte(), i = this.readByte(), a = this.readByte(), o = this.readByte(), s = this.readByte(), 128 & t ? -1 * (72057594037927940 * (255 ^ t) + 281474976710656 * (255 ^ e) + 1099511627776 * (255 ^ n) + 4294967296 * (255 ^ r) + 16777216 * (255 ^ i) + 65536 * (255 ^ a) + 256 * (255 ^ o) + (255 ^ s) + 1) : 72057594037927940 * t + 281474976710656 * e + 1099511627776 * n + 4294967296 * r + 16777216 * i + 65536 * a + 256 * o + s;
    }, t.prototype.writeLongLong = function(t) {
        var e, n;
        return e = Math.floor(t / 4294967296), n = 4294967295 & t, this.writeByte(e >> 24 & 255), this.writeByte(e >> 16 & 255), this.writeByte(e >> 8 & 255), this.writeByte(255 & e), this.writeByte(n >> 24 & 255), this.writeByte(n >> 16 & 255), this.writeByte(n >> 8 & 255), this.writeByte(255 & n);
    }, t.prototype.readInt = function() {
        return this.readInt32();
    }, t.prototype.writeInt = function(t) {
        return this.writeInt32(t);
    }, t.prototype.read = function(t) {
        var e, n;
        for(e = [], n = 0; 0 <= t ? n < t : n > t; n = 0 <= t ? ++n : --n)e.push(this.readByte());
        return e;
    }, t.prototype.write = function(t) {
        var e, n, r, i;
        for(i = [], n = 0, r = t.length; n < r; n++)e = t[n], i.push(this.writeByte(e));
        return i;
    }, t;
}(), de = function() {
    var t;
    function e(t) {
        var e, n, r;
        for(this.scalarType = t.readInt(), this.tableCount = t.readShort(), this.searchRange = t.readShort(), this.entrySelector = t.readShort(), this.rangeShift = t.readShort(), this.tables = {}, n = 0, r = this.tableCount; 0 <= r ? n < r : n > r; n = 0 <= r ? ++n : --n)e = {
            tag: t.readString(4),
            checksum: t.readInt(),
            offset: t.readInt(),
            length: t.readInt()
        }, this.tables[e.tag] = e;
    }
    return e.prototype.encode = function(e) {
        var n, r, i, a, o, s, u, c, l, h, f, d, p;
        for(p in f = Object.keys(e).length, s = Math.log(2), l = 16 * Math.floor(Math.log(f) / s), a = Math.floor(l / s), c = 16 * f - l, (r = new fe).writeInt(this.scalarType), r.writeShort(f), r.writeShort(l), r.writeShort(a), r.writeShort(c), i = 16 * f, u = r.pos + i, o = null, d = [], e)for(h = e[p], r.writeString(p), r.writeInt(t(h)), r.writeInt(u), r.writeInt(h.length), d = d.concat(h), "head" === p && (o = u), u += h.length; u % 4;)d.push(0), u++;
        return r.write(d), n = 2981146554 - t(r.data), r.pos = o + 8, r.writeUInt32(n), r.data;
    }, t = function(t) {
        var e, n, r, i;
        for(t = _e.call(t); t.length % 4;)t.push(0);
        for(r = new fe(t), n = 0, e = 0, i = t.length; e < i; e = e += 4)n += r.readUInt32();
        return 4294967295 & n;
    }, e;
}(), pe = {}.hasOwnProperty, ge = function(t, e) {
    for(var n in e)pe.call(e, n) && (t[n] = e[n]);
    function r() {
        this.constructor = t;
    }
    return r.prototype = e.prototype, t.prototype = new r, t.__super__ = e.prototype, t;
};
he = function() {
    function t(t) {
        var e;
        this.file = t, e = this.file.directory.tables[this.tag], this.exists = !!e, e && (this.offset = e.offset, this.length = e.length, this.parse(this.file.contents));
    }
    return t.prototype.parse = function() {}, t.prototype.encode = function() {}, t.prototype.raw = function() {
        return this.exists ? (this.file.contents.pos = this.offset, this.file.contents.read(this.length)) : null;
    }, t;
}();
var me = function() {
    function t() {
        return t.__super__.constructor.apply(this, arguments);
    }
    return ge(t, he), t.prototype.tag = "head", t.prototype.parse = function(t) {
        return t.pos = this.offset, this.version = t.readInt(), this.revision = t.readInt(), this.checkSumAdjustment = t.readInt(), this.magicNumber = t.readInt(), this.flags = t.readShort(), this.unitsPerEm = t.readShort(), this.created = t.readLongLong(), this.modified = t.readLongLong(), this.xMin = t.readShort(), this.yMin = t.readShort(), this.xMax = t.readShort(), this.yMax = t.readShort(), this.macStyle = t.readShort(), this.lowestRecPPEM = t.readShort(), this.fontDirectionHint = t.readShort(), this.indexToLocFormat = t.readShort(), this.glyphDataFormat = t.readShort();
    }, t.prototype.encode = function(t) {
        var e;
        return (e = new fe).writeInt(this.version), e.writeInt(this.revision), e.writeInt(this.checkSumAdjustment), e.writeInt(this.magicNumber), e.writeShort(this.flags), e.writeShort(this.unitsPerEm), e.writeLongLong(this.created), e.writeLongLong(this.modified), e.writeShort(this.xMin), e.writeShort(this.yMin), e.writeShort(this.xMax), e.writeShort(this.yMax), e.writeShort(this.macStyle), e.writeShort(this.lowestRecPPEM), e.writeShort(this.fontDirectionHint), e.writeShort(t), e.writeShort(this.glyphDataFormat), e.data;
    }, t;
}(), ve = function() {
    function t(t, e) {
        var n, r, i, a, o, s, u, c, l, h, f, d, p, g, m, v, b;
        switch(this.platformID = t.readUInt16(), this.encodingID = t.readShort(), this.offset = e + t.readInt(), l = t.pos, t.pos = this.offset, this.format = t.readUInt16(), this.length = t.readUInt16(), this.language = t.readUInt16(), this.isUnicode = 3 === this.platformID && 1 === this.encodingID && 4 === this.format || 0 === this.platformID && 4 === this.format, this.codeMap = {}, this.format){
            case 0:
                for(s = 0; s < 256; ++s)this.codeMap[s] = t.readByte();
                break;
            case 4:
                for(f = t.readUInt16(), h = f / 2, t.pos += 6, i = function() {
                    var e, n;
                    for(n = [], s = e = 0; 0 <= h ? e < h : e > h; s = 0 <= h ? ++e : --e)n.push(t.readUInt16());
                    return n;
                }(), t.pos += 2, p = function() {
                    var e, n;
                    for(n = [], s = e = 0; 0 <= h ? e < h : e > h; s = 0 <= h ? ++e : --e)n.push(t.readUInt16());
                    return n;
                }(), u = function() {
                    var e, n;
                    for(n = [], s = e = 0; 0 <= h ? e < h : e > h; s = 0 <= h ? ++e : --e)n.push(t.readUInt16());
                    return n;
                }(), c = function() {
                    var e, n;
                    for(n = [], s = e = 0; 0 <= h ? e < h : e > h; s = 0 <= h ? ++e : --e)n.push(t.readUInt16());
                    return n;
                }(), r = (this.length - t.pos + this.offset) / 2, o = function() {
                    var e, n;
                    for(n = [], s = e = 0; 0 <= r ? e < r : e > r; s = 0 <= r ? ++e : --e)n.push(t.readUInt16());
                    return n;
                }(), s = m = 0, b = i.length; m < b; s = ++m)for(g = i[s], n = v = d = p[s]; d <= g ? v <= g : v >= g; n = d <= g ? ++v : --v)0 === c[s] ? a = n + u[s] : 0 !== (a = o[c[s] / 2 + (n - d) - (h - s)] || 0) && (a += u[s]), this.codeMap[n] = 65535 & a;
        }
        t.pos = l;
    }
    return t.encode = function(t, e) {
        var n, r, i, a, o, s, u, c, l, h, f, d, p, g, m, v, b, y, w, N, L, x, A, S, _, P, k, F, I, j, C, O, B, M, q, E, R, D, T, z, U, H, W, V, G, Y;
        switch(F = new fe, a = Object.keys(t).sort(function(t, e) {
            return t - e;
        }), e){
            case "macroman":
                for(p = 0, g = function() {
                    var t = [];
                    for(d = 0; d < 256; ++d)t.push(0);
                    return t;
                }(), v = {
                    0: 0
                }, i = {}, I = 0, B = a.length; I < B; I++)null == v[W = t[r = a[I]]] && (v[W] = ++p), i[r] = {
                    old: t[r],
                    new: v[t[r]]
                }, g[r] = v[t[r]];
                return F.writeUInt16(1), F.writeUInt16(0), F.writeUInt32(12), F.writeUInt16(0), F.writeUInt16(262), F.writeUInt16(0), F.write(g), {
                    charMap: i,
                    subtable: F.data,
                    maxGlyphID: p + 1
                };
            case "unicode":
                for(P = [], l = [], b = 0, v = {}, n = {}, m = u = null, j = 0, M = a.length; j < M; j++)null == v[w = t[r = a[j]]] && (v[w] = ++b), n[r] = {
                    old: w,
                    new: v[w]
                }, o = v[w] - r, null != m && o === u || (m && l.push(m), P.push(r), u = o), m = r;
                for(m && l.push(m), l.push(65535), P.push(65535), S = 2 * (A = P.length), x = 2 * Math.pow(Math.log(A) / Math.LN2, 2), h = Math.log(x / 2) / Math.LN2, L = 2 * A - x, s = [], N = [], f = [], d = C = 0, q = P.length; C < q; d = ++C){
                    if (_ = P[d], c = l[d], 65535 === _) {
                        s.push(0), N.push(0);
                        break;
                    }
                    if (_ - (k = n[_].new) >= 32768) for(s.push(0), N.push(2 * (f.length + A - d)), r = O = _; _ <= c ? O <= c : O >= c; r = _ <= c ? ++O : --O)f.push(n[r].new);
                    else s.push(k - _), N.push(0);
                }
                for(F.writeUInt16(3), F.writeUInt16(1), F.writeUInt32(12), F.writeUInt16(4), F.writeUInt16(16 + 8 * A + 2 * f.length), F.writeUInt16(0), F.writeUInt16(S), F.writeUInt16(x), F.writeUInt16(h), F.writeUInt16(L), U = 0, E = l.length; U < E; U++)r = l[U], F.writeUInt16(r);
                for(F.writeUInt16(0), H = 0, R = P.length; H < R; H++)r = P[H], F.writeUInt16(r);
                for(V = 0, D = s.length; V < D; V++)o = s[V], F.writeUInt16(o);
                for(G = 0, T = N.length; G < T; G++)y = N[G], F.writeUInt16(y);
                for(Y = 0, z = f.length; Y < z; Y++)p = f[Y], F.writeUInt16(p);
                return {
                    charMap: n,
                    subtable: F.data,
                    maxGlyphID: b + 1
                };
        }
    }, t;
}(), be = function() {
    function t() {
        return t.__super__.constructor.apply(this, arguments);
    }
    return ge(t, he), t.prototype.tag = "cmap", t.prototype.parse = function(t) {
        var e, n, r;
        for(t.pos = this.offset, this.version = t.readUInt16(), r = t.readUInt16(), this.tables = [], this.unicode = null, n = 0; 0 <= r ? n < r : n > r; n = 0 <= r ? ++n : --n)e = new ve(t, this.offset), this.tables.push(e), e.isUnicode && null == this.unicode && (this.unicode = e);
        return !0;
    }, t.encode = function(t, e) {
        var n, r;
        return null == e && (e = "macroman"), n = ve.encode(t, e), (r = new fe).writeUInt16(0), r.writeUInt16(1), n.table = r.data.concat(n.subtable), n;
    }, t;
}(), ye = function() {
    function t() {
        return t.__super__.constructor.apply(this, arguments);
    }
    return ge(t, he), t.prototype.tag = "hhea", t.prototype.parse = function(t) {
        return t.pos = this.offset, this.version = t.readInt(), this.ascender = t.readShort(), this.decender = t.readShort(), this.lineGap = t.readShort(), this.advanceWidthMax = t.readShort(), this.minLeftSideBearing = t.readShort(), this.minRightSideBearing = t.readShort(), this.xMaxExtent = t.readShort(), this.caretSlopeRise = t.readShort(), this.caretSlopeRun = t.readShort(), this.caretOffset = t.readShort(), t.pos += 8, this.metricDataFormat = t.readShort(), this.numberOfMetrics = t.readUInt16();
    }, t;
}(), we = function() {
    function t() {
        return t.__super__.constructor.apply(this, arguments);
    }
    return ge(t, he), t.prototype.tag = "OS/2", t.prototype.parse = function(t) {
        if (t.pos = this.offset, this.version = t.readUInt16(), this.averageCharWidth = t.readShort(), this.weightClass = t.readUInt16(), this.widthClass = t.readUInt16(), this.type = t.readShort(), this.ySubscriptXSize = t.readShort(), this.ySubscriptYSize = t.readShort(), this.ySubscriptXOffset = t.readShort(), this.ySubscriptYOffset = t.readShort(), this.ySuperscriptXSize = t.readShort(), this.ySuperscriptYSize = t.readShort(), this.ySuperscriptXOffset = t.readShort(), this.ySuperscriptYOffset = t.readShort(), this.yStrikeoutSize = t.readShort(), this.yStrikeoutPosition = t.readShort(), this.familyClass = t.readShort(), this.panose = function() {
            var e, n;
            for(n = [], e = 0; e < 10; ++e)n.push(t.readByte());
            return n;
        }(), this.charRange = function() {
            var e, n;
            for(n = [], e = 0; e < 4; ++e)n.push(t.readInt());
            return n;
        }(), this.vendorID = t.readString(4), this.selection = t.readShort(), this.firstCharIndex = t.readShort(), this.lastCharIndex = t.readShort(), this.version > 0 && (this.ascent = t.readShort(), this.descent = t.readShort(), this.lineGap = t.readShort(), this.winAscent = t.readShort(), this.winDescent = t.readShort(), this.codePageRange = function() {
            var e, n;
            for(n = [], e = 0; e < 2; e = ++e)n.push(t.readInt());
            return n;
        }(), this.version > 1)) return this.xHeight = t.readShort(), this.capHeight = t.readShort(), this.defaultChar = t.readShort(), this.breakChar = t.readShort(), this.maxContext = t.readShort();
    }, t;
}(), Ne = function() {
    function t() {
        return t.__super__.constructor.apply(this, arguments);
    }
    return ge(t, he), t.prototype.tag = "post", t.prototype.parse = function(t) {
        var e, n, r;
        switch(t.pos = this.offset, this.format = t.readInt(), this.italicAngle = t.readInt(), this.underlinePosition = t.readShort(), this.underlineThickness = t.readShort(), this.isFixedPitch = t.readInt(), this.minMemType42 = t.readInt(), this.maxMemType42 = t.readInt(), this.minMemType1 = t.readInt(), this.maxMemType1 = t.readInt(), this.format){
            case 65536:
            case 196608:
                break;
            case 131072:
                var i;
                for(n = t.readUInt16(), this.glyphNameIndex = [], i = 0; 0 <= n ? i < n : i > n; i = 0 <= n ? ++i : --i)this.glyphNameIndex.push(t.readUInt16());
                for(this.names = [], r = []; t.pos < this.offset + this.length;)e = t.readByte(), r.push(this.names.push(t.readString(e)));
                return r;
            case 151552:
                return n = t.readUInt16(), this.offsets = t.read(n);
            case 262144:
                return this.map = (function() {
                    var e, n, r;
                    for(r = [], i = e = 0, n = this.file.maxp.numGlyphs; 0 <= n ? e < n : e > n; i = 0 <= n ? ++e : --e)r.push(t.readUInt32());
                    return r;
                }).call(this);
        }
    }, t;
}(), Le = function(t, e) {
    this.raw = t, this.length = t.length, this.platformID = e.platformID, this.encodingID = e.encodingID, this.languageID = e.languageID;
}, xe = function() {
    function t() {
        return t.__super__.constructor.apply(this, arguments);
    }
    return ge(t, he), t.prototype.tag = "name", t.prototype.parse = function(t) {
        var e, n, r, i, a, o, s, u, c, l, h;
        for(t.pos = this.offset, t.readShort(), e = t.readShort(), o = t.readShort(), n = [], i = 0; 0 <= e ? i < e : i > e; i = 0 <= e ? ++i : --i)n.push({
            platformID: t.readShort(),
            encodingID: t.readShort(),
            languageID: t.readShort(),
            nameID: t.readShort(),
            length: t.readShort(),
            offset: this.offset + o + t.readShort()
        });
        for(s = {}, i = c = 0, l = n.length; c < l; i = ++c)r = n[i], t.pos = r.offset, u = t.readString(r.length), a = new Le(u, r), null == s[h = r.nameID] && (s[h] = []), s[r.nameID].push(a);
        this.strings = s, this.copyright = s[0], this.fontFamily = s[1], this.fontSubfamily = s[2], this.uniqueSubfamily = s[3], this.fontName = s[4], this.version = s[5];
        try {
            this.postscriptName = s[6][0].raw.replace(/[\x00-\x19\x80-\xff]/g, "");
        } catch (f) {
            this.postscriptName = s[4][0].raw.replace(/[\x00-\x19\x80-\xff]/g, "");
        }
        return this.trademark = s[7], this.manufacturer = s[8], this.designer = s[9], this.description = s[10], this.vendorUrl = s[11], this.designerUrl = s[12], this.license = s[13], this.licenseUrl = s[14], this.preferredFamily = s[15], this.preferredSubfamily = s[17], this.compatibleFull = s[18], this.sampleText = s[19];
    }, t;
}(), Ae = function() {
    function t() {
        return t.__super__.constructor.apply(this, arguments);
    }
    return ge(t, he), t.prototype.tag = "maxp", t.prototype.parse = function(t) {
        return t.pos = this.offset, this.version = t.readInt(), this.numGlyphs = t.readUInt16(), this.maxPoints = t.readUInt16(), this.maxContours = t.readUInt16(), this.maxCompositePoints = t.readUInt16(), this.maxComponentContours = t.readUInt16(), this.maxZones = t.readUInt16(), this.maxTwilightPoints = t.readUInt16(), this.maxStorage = t.readUInt16(), this.maxFunctionDefs = t.readUInt16(), this.maxInstructionDefs = t.readUInt16(), this.maxStackElements = t.readUInt16(), this.maxSizeOfInstructions = t.readUInt16(), this.maxComponentElements = t.readUInt16(), this.maxComponentDepth = t.readUInt16();
    }, t;
}(), Se = function() {
    function t() {
        return t.__super__.constructor.apply(this, arguments);
    }
    return ge(t, he), t.prototype.tag = "hmtx", t.prototype.parse = function(t) {
        var e, n, r, i, a, o, s;
        for(t.pos = this.offset, this.metrics = [], e = 0, o = this.file.hhea.numberOfMetrics; 0 <= o ? e < o : e > o; e = 0 <= o ? ++e : --e)this.metrics.push({
            advance: t.readUInt16(),
            lsb: t.readInt16()
        });
        for(r = this.file.maxp.numGlyphs - this.file.hhea.numberOfMetrics, this.leftSideBearings = function() {
            var n, i;
            for(i = [], e = n = 0; 0 <= r ? n < r : n > r; e = 0 <= r ? ++n : --n)i.push(t.readInt16());
            return i;
        }(), this.widths = (function() {
            var t, e, n, r;
            for(r = [], t = 0, e = (n = this.metrics).length; t < e; t++)i = n[t], r.push(i.advance);
            return r;
        }).call(this), n = this.widths[this.widths.length - 1], s = [], e = a = 0; 0 <= r ? a < r : a > r; e = 0 <= r ? ++a : --a)s.push(this.widths.push(n));
        return s;
    }, t.prototype.forGlyph = function(t) {
        return t in this.metrics ? this.metrics[t] : {
            advance: this.metrics[this.metrics.length - 1].advance,
            lsb: this.leftSideBearings[t - this.metrics.length]
        };
    }, t;
}(), _e = [].slice, Pe = function() {
    function t() {
        return t.__super__.constructor.apply(this, arguments);
    }
    return ge(t, he), t.prototype.tag = "glyf", t.prototype.parse = function() {
        return this.cache = {};
    }, t.prototype.glyphFor = function(t) {
        var e, n, r, i, a, o, s, u, c, l;
        return t in this.cache ? this.cache[t] : (i = this.file.loca, e = this.file.contents, n = i.indexOf(t), 0 === (r = i.lengthOf(t)) ? this.cache[t] = null : (e.pos = this.offset + n, a = (o = new fe(e.read(r))).readShort(), u = o.readShort(), l = o.readShort(), s = o.readShort(), c = o.readShort(), this.cache[t] = -1 === a ? new Fe(o, u, l, s, c) : new ke(o, a, u, l, s, c), this.cache[t]));
    }, t.prototype.encode = function(t, e, n) {
        var r, i, a, o, s;
        for(a = [], i = [], o = 0, s = e.length; o < s; o++)r = t[e[o]], i.push(a.length), r && (a = a.concat(r.encode(n)));
        return i.push(a.length), {
            table: a,
            offsets: i
        };
    }, t;
}(), ke = function() {
    function t(t, e, n, r, i, a) {
        this.raw = t, this.numberOfContours = e, this.xMin = n, this.yMin = r, this.xMax = i, this.yMax = a, this.compound = !1;
    }
    return t.prototype.encode = function() {
        return this.raw.data;
    }, t;
}(), Fe = function() {
    function t(t, e, n, r, i) {
        var a, o;
        for(this.raw = t, this.xMin = e, this.yMin = n, this.xMax = r, this.yMax = i, this.compound = !0, this.glyphIDs = [], this.glyphOffsets = [], a = this.raw; o = a.readShort(), this.glyphOffsets.push(a.pos), this.glyphIDs.push(a.readUInt16()), 32 & o;)a.pos += 1 & o ? 4 : 2, 128 & o ? a.pos += 8 : 64 & o ? a.pos += 4 : 8 & o && (a.pos += 2);
    }
    return t.prototype.encode = function() {
        var t, e, n;
        for(e = new fe(_e.call(this.raw.data)), t = 0, n = this.glyphIDs.length; t < n; ++t)e.pos = this.glyphOffsets[t];
        return e.data;
    }, t;
}(), Ie = function() {
    function t() {
        return t.__super__.constructor.apply(this, arguments);
    }
    return ge(t, he), t.prototype.tag = "loca", t.prototype.parse = function(t) {
        var e, n;
        return t.pos = this.offset, e = this.file.head.indexToLocFormat, this.offsets = 0 === e ? (function() {
            var e, r;
            for(r = [], n = 0, e = this.length; n < e; n += 2)r.push(2 * t.readUInt16());
            return r;
        }).call(this) : (function() {
            var e, r;
            for(r = [], n = 0, e = this.length; n < e; n += 4)r.push(t.readUInt32());
            return r;
        }).call(this);
    }, t.prototype.indexOf = function(t) {
        return this.offsets[t];
    }, t.prototype.lengthOf = function(t) {
        return this.offsets[t + 1] - this.offsets[t];
    }, t.prototype.encode = function(t, e) {
        for(var n = new Uint32Array(this.offsets.length), r = 0, i = 0, a = 0; a < n.length; ++a)if (n[a] = r, i < e.length && e[i] == a) {
            ++i, n[a] = r;
            var o = this.offsets[a], s = this.offsets[a + 1] - o;
            s > 0 && (r += s);
        }
        for(var u = new Array(4 * n.length), c = 0; c < n.length; ++c)u[4 * c + 3] = 255 & n[c], u[4 * c + 2] = (65280 & n[c]) >> 8, u[4 * c + 1] = (16711680 & n[c]) >> 16, u[4 * c] = (4278190080 & n[c]) >> 24;
        return u;
    }, t;
}(), je = function() {
    function t(t) {
        this.font = t, this.subset = {}, this.unicodes = {}, this.next = 33;
    }
    return t.prototype.generateCmap = function() {
        var t, e, n, r, i;
        for(e in r = this.font.cmap.tables[0].codeMap, t = {}, i = this.subset)n = i[e], t[e] = r[n];
        return t;
    }, t.prototype.glyphsFor = function(t) {
        var e, n, r, i, a, o, s;
        for(r = {}, a = 0, o = t.length; a < o; a++)r[i = t[a]] = this.font.glyf.glyphFor(i);
        for(i in e = [], r)(null != (n = r[i]) ? n.compound : void 0) && e.push.apply(e, n.glyphIDs);
        if (e.length > 0) for(i in s = this.glyphsFor(e))n = s[i], r[i] = n;
        return r;
    }, t.prototype.encode = function(t, e) {
        var n, r, i, a, o, s, u, c, l, h, f, d, p, g, m;
        for(r in n = be.encode(this.generateCmap(), "unicode"), a = this.glyphsFor(t), f = {
            0: 0
        }, m = n.charMap)f[(s = m[r]).old] = s.new;
        for(d in h = n.maxGlyphID, a)d in f || (f[d] = h++);
        return c = function(t) {
            var e, n;
            for(e in n = {}, t)n[t[e]] = e;
            return n;
        }(f), l = Object.keys(c).sort(function(t, e) {
            return t - e;
        }), p = function() {
            var t, e, n;
            for(n = [], t = 0, e = l.length; t < e; t++)o = l[t], n.push(c[o]);
            return n;
        }(), i = this.font.glyf.encode(a, p, f), u = this.font.loca.encode(i.offsets, p), g = {
            cmap: this.font.cmap.raw(),
            glyf: i.table,
            loca: u,
            hmtx: this.font.hmtx.raw(),
            hhea: this.font.hhea.raw(),
            maxp: this.font.maxp.raw(),
            post: this.font.post.raw(),
            name: this.font.name.raw(),
            head: this.font.head.encode(e)
        }, this.font.os2.exists && (g["OS/2"] = this.font.os2.raw()), this.font.directory.encode(g);
    }, t;
}();
E.API.PDFObject = function() {
    var t;
    function e() {}
    return t = function(t, e) {
        return (Array(e + 1).join("0") + t).slice(-e);
    }, e.convert = function(n) {
        var r, i, a, o;
        if (Array.isArray(n)) return "[" + (function() {
            var t, i, a;
            for(a = [], t = 0, i = n.length; t < i; t++)r = n[t], a.push(e.convert(r));
            return a;
        })().join(" ") + "]";
        if ("string" == typeof n) return "/" + n;
        if (null != n ? n.isString : void 0) return "(" + n + ")";
        if (n instanceof Date) return "(D:" + t(n.getUTCFullYear(), 4) + t(n.getUTCMonth(), 2) + t(n.getUTCDate(), 2) + t(n.getUTCHours(), 2) + t(n.getUTCMinutes(), 2) + t(n.getUTCSeconds(), 2) + "Z)";
        if ("[object Object]" === ({}).toString.call(n)) {
            for(i in a = [
                "<<"
            ], n)o = n[i], a.push("/" + i + " " + e.convert(o));
            return a.push(">>"), a.join("\n");
        }
        return "" + n;
    }, e;
}();

},{"@babel/runtime/helpers/typeof":"8tyFm","fflate":"f8Ckt","@babel/runtime/helpers/slicedToArray":"7LO4p","fast-png":"j79NK","e35ed7d1af132742":"cLPCq","fd4d839f94e36dff":"451Vz","7ec43201f0dbcdb8":"jDKvb","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8tyFm":[function(require,module,exports,__globalThis) {
function _typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"f8Ckt":[function(require,module,exports,__globalThis) {
// DEFLATE is a complex format; to read this code, you should probably check the RFC first:
// https://tools.ietf.org/html/rfc1951
// You may also wish to take a look at the guide I made about this program:
// https://gist.github.com/101arrowz/253f31eb5abc3d9275ab943003ffecad
// Some of the following code is similar to that of UZIP.js:
// https://github.com/photopea/UZIP.js
// However, the vast majority of the codebase has diverged from UZIP.js to increase performance and reduce bundle size.
// Sometimes 0 will appear where -1 would be more appropriate. This is because using a uint
// is better for memory in most engines (I *think*).
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FlateErrorCode", ()=>FlateErrorCode);
parcelHelpers.export(exports, "Deflate", ()=>Deflate);
parcelHelpers.export(exports, "AsyncDeflate", ()=>AsyncDeflate);
parcelHelpers.export(exports, "deflate", ()=>deflate);
/**
 * Compresses data with DEFLATE without any wrapper
 * @param data The data to compress
 * @param opts The compression options
 * @returns The deflated version of the data
 */ parcelHelpers.export(exports, "deflateSync", ()=>deflateSync);
parcelHelpers.export(exports, "Inflate", ()=>Inflate);
parcelHelpers.export(exports, "AsyncInflate", ()=>AsyncInflate);
parcelHelpers.export(exports, "inflate", ()=>inflate);
/**
 * Expands DEFLATE data with no wrapper
 * @param data The data to decompress
 * @param opts The decompression options
 * @returns The decompressed version of the data
 */ parcelHelpers.export(exports, "inflateSync", ()=>inflateSync);
parcelHelpers.export(exports, "Gzip", ()=>Gzip);
parcelHelpers.export(exports, "AsyncGzip", ()=>AsyncGzip);
parcelHelpers.export(exports, "gzip", ()=>gzip);
/**
 * Compresses data with GZIP
 * @param data The data to compress
 * @param opts The compression options
 * @returns The gzipped version of the data
 */ parcelHelpers.export(exports, "gzipSync", ()=>gzipSync);
parcelHelpers.export(exports, "Gunzip", ()=>Gunzip);
parcelHelpers.export(exports, "AsyncGunzip", ()=>AsyncGunzip);
parcelHelpers.export(exports, "gunzip", ()=>gunzip);
/**
 * Expands GZIP data
 * @param data The data to decompress
 * @param opts The decompression options
 * @returns The decompressed version of the data
 */ parcelHelpers.export(exports, "gunzipSync", ()=>gunzipSync);
parcelHelpers.export(exports, "Zlib", ()=>Zlib);
parcelHelpers.export(exports, "AsyncZlib", ()=>AsyncZlib);
parcelHelpers.export(exports, "zlib", ()=>zlib);
/**
 * Compress data with Zlib
 * @param data The data to compress
 * @param opts The compression options
 * @returns The zlib-compressed version of the data
 */ parcelHelpers.export(exports, "zlibSync", ()=>zlibSync);
parcelHelpers.export(exports, "Unzlib", ()=>Unzlib);
parcelHelpers.export(exports, "AsyncUnzlib", ()=>AsyncUnzlib);
parcelHelpers.export(exports, "unzlib", ()=>unzlib);
/**
 * Expands Zlib data
 * @param data The data to decompress
 * @param opts The decompression options
 * @returns The decompressed version of the data
 */ parcelHelpers.export(exports, "unzlibSync", ()=>unzlibSync);
// Default algorithm for compression (used because having a known output size allows faster decompression)
parcelHelpers.export(exports, "compress", ()=>gzip);
parcelHelpers.export(exports, "AsyncCompress", ()=>AsyncGzip);
parcelHelpers.export(exports, "compressSync", ()=>gzipSync);
parcelHelpers.export(exports, "Compress", ()=>Gzip);
parcelHelpers.export(exports, "Decompress", ()=>Decompress);
parcelHelpers.export(exports, "AsyncDecompress", ()=>AsyncDecompress);
parcelHelpers.export(exports, "decompress", ()=>decompress);
/**
 * Expands compressed GZIP, Zlib, or raw DEFLATE data, automatically detecting the format
 * @param data The data to decompress
 * @param opts The decompression options
 * @returns The decompressed version of the data
 */ parcelHelpers.export(exports, "decompressSync", ()=>decompressSync);
parcelHelpers.export(exports, "DecodeUTF8", ()=>DecodeUTF8);
parcelHelpers.export(exports, "EncodeUTF8", ()=>EncodeUTF8);
/**
 * Converts a string into a Uint8Array for use with compression/decompression methods
 * @param str The string to encode
 * @param latin1 Whether or not to interpret the data as Latin-1. This should
 *               not need to be true unless decoding a binary string.
 * @returns The string encoded in UTF-8/Latin-1 binary
 */ parcelHelpers.export(exports, "strToU8", ()=>strToU8);
/**
 * Converts a Uint8Array to a string
 * @param dat The data to decode to string
 * @param latin1 Whether or not to interpret the data as Latin-1. This should
 *               not need to be true unless encoding to binary string.
 * @returns The original UTF-8/Latin-1 string
 */ parcelHelpers.export(exports, "strFromU8", ()=>strFromU8);
parcelHelpers.export(exports, "ZipPassThrough", ()=>ZipPassThrough);
parcelHelpers.export(exports, "ZipDeflate", ()=>ZipDeflate);
parcelHelpers.export(exports, "AsyncZipDeflate", ()=>AsyncZipDeflate);
parcelHelpers.export(exports, "Zip", ()=>Zip);
parcelHelpers.export(exports, "zip", ()=>zip);
/**
 * Synchronously creates a ZIP file. Prefer using `zip` for better performance
 * with more than one file.
 * @param data The directory structure for the ZIP archive
 * @param opts The main options, merged with per-file options
 * @returns The generated ZIP archive
 */ parcelHelpers.export(exports, "zipSync", ()=>zipSync);
parcelHelpers.export(exports, "UnzipPassThrough", ()=>UnzipPassThrough);
parcelHelpers.export(exports, "UnzipInflate", ()=>UnzipInflate);
parcelHelpers.export(exports, "AsyncUnzipInflate", ()=>AsyncUnzipInflate);
parcelHelpers.export(exports, "Unzip", ()=>Unzip);
parcelHelpers.export(exports, "unzip", ()=>unzip);
/**
 * Synchronously decompresses a ZIP archive. Prefer using `unzip` for better
 * performance with more than one file.
 * @param data The raw compressed ZIP file
 * @param opts The ZIP extraction options
 * @returns The decompressed files
 */ parcelHelpers.export(exports, "unzipSync", ()=>unzipSync);
var ch2 = {};
var wk = function(c, id, msg, transfer, cb) {
    var w = new Worker(ch2[id] || (ch2[id] = URL.createObjectURL(new Blob([
        c + ';addEventListener("error",function(e){e=e.error;postMessage({$e$:[e.message,e.code,e.stack]})})'
    ], {
        type: 'text/javascript'
    }))));
    w.onmessage = function(e) {
        var d = e.data, ed = d.$e$;
        if (ed) {
            var err = new Error(ed[0]);
            err['code'] = ed[1];
            err.stack = ed[2];
            cb(err, null);
        } else cb(null, d);
    };
    w.postMessage(msg, transfer);
    return w;
};
// aliases for shorter compressed code (most minifers don't do this)
var u8 = Uint8Array, u16 = Uint16Array, i32 = Int32Array;
// fixed length extra bits
var fleb = new u8([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    /* unused */ 0,
    0,
    /* impossible */ 0
]);
// fixed distance extra bits
var fdeb = new u8([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    /* unused */ 0,
    0
]);
// code length index map
var clim = new u8([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
// get base, reverse index map from extra bits
var freb = function(eb, start) {
    var b = new u16(31);
    for(var i = 0; i < 31; ++i)b[i] = start += 1 << eb[i - 1];
    // numbers here are at max 18 bits
    var r = new i32(b[30]);
    for(var i = 1; i < 30; ++i)for(var j = b[i]; j < b[i + 1]; ++j)r[j] = j - b[i] << 5 | i;
    return {
        b: b,
        r: r
    };
};
var _a = freb(fleb, 2), fl = _a.b, revfl = _a.r;
// we can ignore the fact that the other numbers are wrong; they never happen anyway
fl[28] = 258, revfl[258] = 28;
var _b = freb(fdeb, 0), fd = _b.b, revfd = _b.r;
// map of value to reverse (assuming 16 bits)
var rev = new u16(32768);
for(var i = 0; i < 32768; ++i){
    // reverse table algorithm from SO
    var x = (i & 0xAAAA) >> 1 | (i & 0x5555) << 1;
    x = (x & 0xCCCC) >> 2 | (x & 0x3333) << 2;
    x = (x & 0xF0F0) >> 4 | (x & 0x0F0F) << 4;
    rev[i] = ((x & 0xFF00) >> 8 | (x & 0x00FF) << 8) >> 1;
}
// create huffman tree from u8 "map": index -> code length for code index
// mb (max bits) must be at most 15
// TODO: optimize/split up?
var hMap = function(cd, mb, r) {
    var s = cd.length;
    // index
    var i = 0;
    // u16 "map": index -> # of codes with bit length = index
    var l = new u16(mb);
    // length of cd must be 288 (total # of codes)
    for(; i < s; ++i)if (cd[i]) ++l[cd[i] - 1];
    // u16 "map": index -> minimum code for bit length = index
    var le = new u16(mb);
    for(i = 1; i < mb; ++i)le[i] = le[i - 1] + l[i - 1] << 1;
    var co;
    if (r) {
        // u16 "map": index -> number of actual bits, symbol for code
        co = new u16(1 << mb);
        // bits to remove for reverser
        var rvb = 15 - mb;
        for(i = 0; i < s; ++i)// ignore 0 lengths
        if (cd[i]) {
            // num encoding both symbol and bits read
            var sv = i << 4 | cd[i];
            // free bits
            var r_1 = mb - cd[i];
            // start value
            var v = le[cd[i] - 1]++ << r_1;
            // m is end value
            for(var m = v | (1 << r_1) - 1; v <= m; ++v)// every 16 bit value starting with the code yields the same result
            co[rev[v] >> rvb] = sv;
        }
    } else {
        co = new u16(s);
        for(i = 0; i < s; ++i)if (cd[i]) co[i] = rev[le[cd[i] - 1]++] >> 15 - cd[i];
    }
    return co;
};
// fixed length tree
var flt = new u8(288);
for(var i = 0; i < 144; ++i)flt[i] = 8;
for(var i = 144; i < 256; ++i)flt[i] = 9;
for(var i = 256; i < 280; ++i)flt[i] = 7;
for(var i = 280; i < 288; ++i)flt[i] = 8;
// fixed distance tree
var fdt = new u8(32);
for(var i = 0; i < 32; ++i)fdt[i] = 5;
// fixed length map
var flm = /*#__PURE__*/ hMap(flt, 9, 0), flrm = /*#__PURE__*/ hMap(flt, 9, 1);
// fixed distance map
var fdm = /*#__PURE__*/ hMap(fdt, 5, 0), fdrm = /*#__PURE__*/ hMap(fdt, 5, 1);
// find max of array
var max = function(a) {
    var m = a[0];
    for(var i = 1; i < a.length; ++i)if (a[i] > m) m = a[i];
    return m;
};
// read d, starting at bit p and mask with m
var bits = function(d, p, m) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8) >> (p & 7) & m;
};
// read d, starting at bit p continuing for at least 16 bits
var bits16 = function(d, p) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8 | d[o + 2] << 16) >> (p & 7);
};
// get end of byte
var shft = function(p) {
    return (p + 7) / 8 | 0;
};
// typed array slice - allows garbage collector to free original reference,
// while being more compatible than .slice
var slc = function(v, s, e) {
    if (s == null || s < 0) s = 0;
    if (e == null || e > v.length) e = v.length;
    // can't use .constructor in case user-supplied
    return new u8(v.subarray(s, e));
};
var FlateErrorCode = {
    UnexpectedEOF: 0,
    InvalidBlockType: 1,
    InvalidLengthLiteral: 2,
    InvalidDistance: 3,
    StreamFinished: 4,
    NoStreamHandler: 5,
    InvalidHeader: 6,
    NoCallback: 7,
    InvalidUTF8: 8,
    ExtraFieldTooLong: 9,
    InvalidDate: 10,
    FilenameTooLong: 11,
    StreamFinishing: 12,
    InvalidZipData: 13,
    UnknownCompressionMethod: 14
};
// error codes
var ec = [
    'unexpected EOF',
    'invalid block type',
    'invalid length/literal',
    'invalid distance',
    'stream finished',
    'no stream handler',
    ,
    'no callback',
    'invalid UTF-8 data',
    'extra field too long',
    'date not in range 1980-2099',
    'filename too long',
    'stream finishing',
    'invalid zip data'
];
var err = function(ind, msg, nt) {
    var e = new Error(msg || ec[ind]);
    e.code = ind;
    if (Error.captureStackTrace) Error.captureStackTrace(e, err);
    if (!nt) throw e;
    return e;
};
// expands raw DEFLATE data
var inflt = function(dat, st, buf, dict) {
    // source length       dict length
    var sl = dat.length, dl = dict ? dict.length : 0;
    if (!sl || st.f && !st.l) return buf || new u8(0);
    var noBuf = !buf;
    // have to estimate size
    var resize = noBuf || st.i != 2;
    // no state
    var noSt = st.i;
    // Assumes roughly 33% compression ratio average
    if (noBuf) buf = new u8(sl * 3);
    // ensure buffer can fit at least l elements
    var cbuf = function(l) {
        var bl = buf.length;
        // need to increase size to fit
        if (l > bl) {
            // Double or set to necessary, whichever is greater
            var nbuf = new u8(Math.max(bl * 2, l));
            nbuf.set(buf);
            buf = nbuf;
        }
    };
    //  last chunk         bitpos           bytes
    var final = st.f || 0, pos = st.p || 0, bt = st.b || 0, lm = st.l, dm = st.d, lbt = st.m, dbt = st.n;
    // total bits
    var tbts = sl * 8;
    do {
        if (!lm) {
            // BFINAL - this is only 1 when last chunk is next
            final = bits(dat, pos, 1);
            // type: 0 = no compression, 1 = fixed huffman, 2 = dynamic huffman
            var type = bits(dat, pos + 1, 3);
            pos += 3;
            if (!type) {
                // go to end of byte boundary
                var s = shft(pos) + 4, l = dat[s - 4] | dat[s - 3] << 8, t = s + l;
                if (t > sl) {
                    if (noSt) err(0);
                    break;
                }
                // ensure size
                if (resize) cbuf(bt + l);
                // Copy over uncompressed data
                buf.set(dat.subarray(s, t), bt);
                // Get new bitpos, update byte count
                st.b = bt += l, st.p = pos = t * 8, st.f = final;
                continue;
            } else if (type == 1) lm = flrm, dm = fdrm, lbt = 9, dbt = 5;
            else if (type == 2) {
                //  literal                            lengths
                var hLit = bits(dat, pos, 31) + 257, hcLen = bits(dat, pos + 10, 15) + 4;
                var tl = hLit + bits(dat, pos + 5, 31) + 1;
                pos += 14;
                // length+distance tree
                var ldt = new u8(tl);
                // code length tree
                var clt = new u8(19);
                for(var i = 0; i < hcLen; ++i)// use index map to get real code
                clt[clim[i]] = bits(dat, pos + i * 3, 7);
                pos += hcLen * 3;
                // code lengths bits
                var clb = max(clt), clbmsk = (1 << clb) - 1;
                // code lengths map
                var clm = hMap(clt, clb, 1);
                for(var i = 0; i < tl;){
                    var r = clm[bits(dat, pos, clbmsk)];
                    // bits read
                    pos += r & 15;
                    // symbol
                    var s = r >> 4;
                    // code length to copy
                    if (s < 16) ldt[i++] = s;
                    else {
                        //  copy   count
                        var c = 0, n = 0;
                        if (s == 16) n = 3 + bits(dat, pos, 3), pos += 2, c = ldt[i - 1];
                        else if (s == 17) n = 3 + bits(dat, pos, 7), pos += 3;
                        else if (s == 18) n = 11 + bits(dat, pos, 127), pos += 7;
                        while(n--)ldt[i++] = c;
                    }
                }
                //    length tree                 distance tree
                var lt = ldt.subarray(0, hLit), dt = ldt.subarray(hLit);
                // max length bits
                lbt = max(lt);
                // max dist bits
                dbt = max(dt);
                lm = hMap(lt, lbt, 1);
                dm = hMap(dt, dbt, 1);
            } else err(1);
            if (pos > tbts) {
                if (noSt) err(0);
                break;
            }
        }
        // Make sure the buffer can hold this + the largest possible addition
        // Maximum chunk size (practically, theoretically infinite) is 2^17
        if (resize) cbuf(bt + 131072);
        var lms = (1 << lbt) - 1, dms = (1 << dbt) - 1;
        var lpos = pos;
        for(;; lpos = pos){
            // bits read, code
            var c = lm[bits16(dat, pos) & lms], sym = c >> 4;
            pos += c & 15;
            if (pos > tbts) {
                if (noSt) err(0);
                break;
            }
            if (!c) err(2);
            if (sym < 256) buf[bt++] = sym;
            else if (sym == 256) {
                lpos = pos, lm = null;
                break;
            } else {
                var add = sym - 254;
                // no extra bits needed if less
                if (sym > 264) {
                    // index
                    var i = sym - 257, b = fleb[i];
                    add = bits(dat, pos, (1 << b) - 1) + fl[i];
                    pos += b;
                }
                // dist
                var d = dm[bits16(dat, pos) & dms], dsym = d >> 4;
                if (!d) err(3);
                pos += d & 15;
                var dt = fd[dsym];
                if (dsym > 3) {
                    var b = fdeb[dsym];
                    dt += bits16(dat, pos) & (1 << b) - 1, pos += b;
                }
                if (pos > tbts) {
                    if (noSt) err(0);
                    break;
                }
                if (resize) cbuf(bt + 131072);
                var end = bt + add;
                if (bt < dt) {
                    var shift = dl - dt, dend = Math.min(dt, end);
                    if (shift + bt < 0) err(3);
                    for(; bt < dend; ++bt)buf[bt] = dict[shift + bt];
                }
                for(; bt < end; ++bt)buf[bt] = buf[bt - dt];
            }
        }
        st.l = lm, st.p = lpos, st.b = bt, st.f = final;
        if (lm) final = 1, st.m = lbt, st.d = dm, st.n = dbt;
    }while (!final);
    // don't reallocate for streams or user buffers
    return bt != buf.length && noBuf ? slc(buf, 0, bt) : buf.subarray(0, bt);
};
// starting at p, write the minimum number of bits that can hold v to d
var wbits = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >> 8;
};
// starting at p, write the minimum number of bits (>8) that can hold v to d
var wbits16 = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >> 8;
    d[o + 2] |= v >> 16;
};
// creates code lengths from a frequency table
var hTree = function(d, mb) {
    // Need extra info to make a tree
    var t = [];
    for(var i = 0; i < d.length; ++i)if (d[i]) t.push({
        s: i,
        f: d[i]
    });
    var s = t.length;
    var t2 = t.slice();
    if (!s) return {
        t: et,
        l: 0
    };
    if (s == 1) {
        var v = new u8(t[0].s + 1);
        v[t[0].s] = 1;
        return {
            t: v,
            l: 1
        };
    }
    t.sort(function(a, b) {
        return a.f - b.f;
    });
    // after i2 reaches last ind, will be stopped
    // freq must be greater than largest possible number of symbols
    t.push({
        s: -1,
        f: 25001
    });
    var l = t[0], r = t[1], i0 = 0, i1 = 1, i2 = 2;
    t[0] = {
        s: -1,
        f: l.f + r.f,
        l: l,
        r: r
    };
    // efficient algorithm from UZIP.js
    // i0 is lookbehind, i2 is lookahead - after processing two low-freq
    // symbols that combined have high freq, will start processing i2 (high-freq,
    // non-composite) symbols instead
    // see https://reddit.com/r/photopea/comments/ikekht/uzipjs_questions/
    while(i1 != s - 1){
        l = t[t[i0].f < t[i2].f ? i0++ : i2++];
        r = t[i0 != i1 && t[i0].f < t[i2].f ? i0++ : i2++];
        t[i1++] = {
            s: -1,
            f: l.f + r.f,
            l: l,
            r: r
        };
    }
    var maxSym = t2[0].s;
    for(var i = 1; i < s; ++i)if (t2[i].s > maxSym) maxSym = t2[i].s;
    // code lengths
    var tr = new u16(maxSym + 1);
    // max bits in tree
    var mbt = ln(t[i1 - 1], tr, 0);
    if (mbt > mb) {
        // more algorithms from UZIP.js
        // TODO: find out how this code works (debt)
        //  ind    debt
        var i = 0, dt = 0;
        //    left            cost
        var lft = mbt - mb, cst = 1 << lft;
        t2.sort(function(a, b) {
            return tr[b.s] - tr[a.s] || a.f - b.f;
        });
        for(; i < s; ++i){
            var i2_1 = t2[i].s;
            if (tr[i2_1] > mb) {
                dt += cst - (1 << mbt - tr[i2_1]);
                tr[i2_1] = mb;
            } else break;
        }
        dt >>= lft;
        while(dt > 0){
            var i2_2 = t2[i].s;
            if (tr[i2_2] < mb) dt -= 1 << mb - tr[i2_2]++ - 1;
            else ++i;
        }
        for(; i >= 0 && dt; --i){
            var i2_3 = t2[i].s;
            if (tr[i2_3] == mb) {
                --tr[i2_3];
                ++dt;
            }
        }
        mbt = mb;
    }
    return {
        t: new u8(tr),
        l: mbt
    };
};
// get the max length and assign length codes
var ln = function(n, l, d) {
    return n.s == -1 ? Math.max(ln(n.l, l, d + 1), ln(n.r, l, d + 1)) : l[n.s] = d;
};
// length codes generation
var lc = function(c) {
    var s = c.length;
    // Note that the semicolon was intentional
    while(s && !c[--s]);
    var cl = new u16(++s);
    //  ind      num         streak
    var cli = 0, cln = c[0], cls = 1;
    var w = function(v) {
        cl[cli++] = v;
    };
    for(var i = 1; i <= s; ++i)if (c[i] == cln && i != s) ++cls;
    else {
        if (!cln && cls > 2) {
            for(; cls > 138; cls -= 138)w(32754);
            if (cls > 2) {
                w(cls > 10 ? cls - 11 << 5 | 28690 : cls - 3 << 5 | 12305);
                cls = 0;
            }
        } else if (cls > 3) {
            w(cln), --cls;
            for(; cls > 6; cls -= 6)w(8304);
            if (cls > 2) w(cls - 3 << 5 | 8208), cls = 0;
        }
        while(cls--)w(cln);
        cls = 1;
        cln = c[i];
    }
    return {
        c: cl.subarray(0, cli),
        n: s
    };
};
// calculate the length of output from tree, code lengths
var clen = function(cf, cl) {
    var l = 0;
    for(var i = 0; i < cl.length; ++i)l += cf[i] * cl[i];
    return l;
};
// writes a fixed block
// returns the new bit pos
var wfblk = function(out, pos, dat) {
    // no need to write 00 as type: TypedArray defaults to 0
    var s = dat.length;
    var o = shft(pos + 2);
    out[o] = s & 255;
    out[o + 1] = s >> 8;
    out[o + 2] = out[o] ^ 255;
    out[o + 3] = out[o + 1] ^ 255;
    for(var i = 0; i < s; ++i)out[o + i + 4] = dat[i];
    return (o + 4 + s) * 8;
};
// writes a block
var wblk = function(dat, out, final, syms, lf, df, eb, li, bs, bl, p) {
    wbits(out, p++, final);
    ++lf[256];
    var _a = hTree(lf, 15), dlt = _a.t, mlb = _a.l;
    var _b = hTree(df, 15), ddt = _b.t, mdb = _b.l;
    var _c = lc(dlt), lclt = _c.c, nlc = _c.n;
    var _d = lc(ddt), lcdt = _d.c, ndc = _d.n;
    var lcfreq = new u16(19);
    for(var i = 0; i < lclt.length; ++i)++lcfreq[lclt[i] & 31];
    for(var i = 0; i < lcdt.length; ++i)++lcfreq[lcdt[i] & 31];
    var _e = hTree(lcfreq, 7), lct = _e.t, mlcb = _e.l;
    var nlcc = 19;
    for(; nlcc > 4 && !lct[clim[nlcc - 1]]; --nlcc);
    var flen = bl + 5 << 3;
    var ftlen = clen(lf, flt) + clen(df, fdt) + eb;
    var dtlen = clen(lf, dlt) + clen(df, ddt) + eb + 14 + 3 * nlcc + clen(lcfreq, lct) + 2 * lcfreq[16] + 3 * lcfreq[17] + 7 * lcfreq[18];
    if (bs >= 0 && flen <= ftlen && flen <= dtlen) return wfblk(out, p, dat.subarray(bs, bs + bl));
    var lm, ll, dm, dl;
    wbits(out, p, 1 + (dtlen < ftlen)), p += 2;
    if (dtlen < ftlen) {
        lm = hMap(dlt, mlb, 0), ll = dlt, dm = hMap(ddt, mdb, 0), dl = ddt;
        var llm = hMap(lct, mlcb, 0);
        wbits(out, p, nlc - 257);
        wbits(out, p + 5, ndc - 1);
        wbits(out, p + 10, nlcc - 4);
        p += 14;
        for(var i = 0; i < nlcc; ++i)wbits(out, p + 3 * i, lct[clim[i]]);
        p += 3 * nlcc;
        var lcts = [
            lclt,
            lcdt
        ];
        for(var it = 0; it < 2; ++it){
            var clct = lcts[it];
            for(var i = 0; i < clct.length; ++i){
                var len = clct[i] & 31;
                wbits(out, p, llm[len]), p += lct[len];
                if (len > 15) wbits(out, p, clct[i] >> 5 & 127), p += clct[i] >> 12;
            }
        }
    } else lm = flm, ll = flt, dm = fdm, dl = fdt;
    for(var i = 0; i < li; ++i){
        var sym = syms[i];
        if (sym > 255) {
            var len = sym >> 18 & 31;
            wbits16(out, p, lm[len + 257]), p += ll[len + 257];
            if (len > 7) wbits(out, p, sym >> 23 & 31), p += fleb[len];
            var dst = sym & 31;
            wbits16(out, p, dm[dst]), p += dl[dst];
            if (dst > 3) wbits16(out, p, sym >> 5 & 8191), p += fdeb[dst];
        } else wbits16(out, p, lm[sym]), p += ll[sym];
    }
    wbits16(out, p, lm[256]);
    return p + ll[256];
};
// deflate options (nice << 13) | chain
var deo = /*#__PURE__*/ new i32([
    65540,
    131080,
    131088,
    131104,
    262176,
    1048704,
    1048832,
    2114560,
    2117632
]);
// empty
var et = /*#__PURE__*/ new u8(0);
// compresses data into a raw DEFLATE buffer
var dflt = function(dat, lvl, plvl, pre, post, st) {
    var s = st.z || dat.length;
    var o = new u8(pre + s + 5 * (1 + Math.ceil(s / 7000)) + post);
    // writing to this writes to the output buffer
    var w = o.subarray(pre, o.length - post);
    var lst = st.l;
    var pos = (st.r || 0) & 7;
    if (lvl) {
        if (pos) w[0] = st.r >> 3;
        var opt = deo[lvl - 1];
        var n = opt >> 13, c = opt & 8191;
        var msk_1 = (1 << plvl) - 1;
        //    prev 2-byte val map    curr 2-byte val map
        var prev = st.p || new u16(32768), head = st.h || new u16(msk_1 + 1);
        var bs1_1 = Math.ceil(plvl / 3), bs2_1 = 2 * bs1_1;
        var hsh = function(i) {
            return (dat[i] ^ dat[i + 1] << bs1_1 ^ dat[i + 2] << bs2_1) & msk_1;
        };
        // 24576 is an arbitrary number of maximum symbols per block
        // 424 buffer for last block
        var syms = new i32(25000);
        // length/literal freq   distance freq
        var lf = new u16(288), df = new u16(32);
        //  l/lcnt  exbits  index          l/lind  waitdx          blkpos
        var lc_1 = 0, eb = 0, i = st.i || 0, li = 0, wi = st.w || 0, bs = 0;
        for(; i + 2 < s; ++i){
            // hash value
            var hv = hsh(i);
            // index mod 32768    previous index mod
            var imod = i & 32767, pimod = head[hv];
            prev[imod] = pimod;
            head[hv] = imod;
            // We always should modify head and prev, but only add symbols if
            // this data is not yet processed ("wait" for wait index)
            if (wi <= i) {
                // bytes remaining
                var rem = s - i;
                if ((lc_1 > 7000 || li > 24576) && (rem > 423 || !lst)) {
                    pos = wblk(dat, w, 0, syms, lf, df, eb, li, bs, i - bs, pos);
                    li = lc_1 = eb = 0, bs = i;
                    for(var j = 0; j < 286; ++j)lf[j] = 0;
                    for(var j = 0; j < 30; ++j)df[j] = 0;
                }
                //  len    dist   chain
                var l = 2, d = 0, ch_1 = c, dif = imod - pimod & 32767;
                if (rem > 2 && hv == hsh(i - dif)) {
                    var maxn = Math.min(n, rem) - 1;
                    var maxd = Math.min(32767, i);
                    // max possible length
                    // not capped at dif because decompressors implement "rolling" index population
                    var ml = Math.min(258, rem);
                    while(dif <= maxd && --ch_1 && imod != pimod){
                        if (dat[i + l] == dat[i + l - dif]) {
                            var nl = 0;
                            for(; nl < ml && dat[i + nl] == dat[i + nl - dif]; ++nl);
                            if (nl > l) {
                                l = nl, d = dif;
                                // break out early when we reach "nice" (we are satisfied enough)
                                if (nl > maxn) break;
                                // now, find the rarest 2-byte sequence within this
                                // length of literals and search for that instead.
                                // Much faster than just using the start
                                var mmd = Math.min(dif, nl - 2);
                                var md = 0;
                                for(var j = 0; j < mmd; ++j){
                                    var ti = i - dif + j & 32767;
                                    var pti = prev[ti];
                                    var cd = ti - pti & 32767;
                                    if (cd > md) md = cd, pimod = ti;
                                }
                            }
                        }
                        // check the previous match
                        imod = pimod, pimod = prev[imod];
                        dif += imod - pimod & 32767;
                    }
                }
                // d will be nonzero only when a match was found
                if (d) {
                    // store both dist and len data in one int32
                    // Make sure this is recognized as a len/dist with 28th bit (2^28)
                    syms[li++] = 268435456 | revfl[l] << 18 | revfd[d];
                    var lin = revfl[l] & 31, din = revfd[d] & 31;
                    eb += fleb[lin] + fdeb[din];
                    ++lf[257 + lin];
                    ++df[din];
                    wi = i + l;
                    ++lc_1;
                } else {
                    syms[li++] = dat[i];
                    ++lf[dat[i]];
                }
            }
        }
        for(i = Math.max(i, wi); i < s; ++i){
            syms[li++] = dat[i];
            ++lf[dat[i]];
        }
        pos = wblk(dat, w, lst, syms, lf, df, eb, li, bs, i - bs, pos);
        if (!lst) {
            st.r = pos & 7 | w[pos / 8 | 0] << 3;
            // shft(pos) now 1 less if pos & 7 != 0
            pos -= 7;
            st.h = head, st.p = prev, st.i = i, st.w = wi;
        }
    } else {
        for(var i = st.w || 0; i < s + lst; i += 65535){
            // end
            var e = i + 65535;
            if (e >= s) {
                // write final block
                w[pos / 8 | 0] = lst;
                e = s;
            }
            pos = wfblk(w, pos + 1, dat.subarray(i, e));
        }
        st.i = s;
    }
    return slc(o, 0, pre + shft(pos) + post);
};
// CRC32 table
var crct = /*#__PURE__*/ function() {
    var t = new Int32Array(256);
    for(var i = 0; i < 256; ++i){
        var c = i, k = 9;
        while(--k)c = (c & 1 && -306674912) ^ c >>> 1;
        t[i] = c;
    }
    return t;
}();
// CRC32
var crc = function() {
    var c = -1;
    return {
        p: function(d) {
            // closures have awful performance
            var cr = c;
            for(var i = 0; i < d.length; ++i)cr = crct[cr & 255 ^ d[i]] ^ cr >>> 8;
            c = cr;
        },
        d: function() {
            return ~c;
        }
    };
};
// Adler32
var adler = function() {
    var a = 1, b = 0;
    return {
        p: function(d) {
            // closures have awful performance
            var n = a, m = b;
            var l = d.length | 0;
            for(var i = 0; i != l;){
                var e = Math.min(i + 2655, l);
                for(; i < e; ++i)m += n += d[i];
                n = (n & 65535) + 15 * (n >> 16), m = (m & 65535) + 15 * (m >> 16);
            }
            a = n, b = m;
        },
        d: function() {
            a %= 65521, b %= 65521;
            return (a & 255) << 24 | (a & 0xFF00) << 8 | (b & 255) << 8 | b >> 8;
        }
    };
};
// deflate with opts
var dopt = function(dat, opt, pre, post, st) {
    if (!st) {
        st = {
            l: 1
        };
        if (opt.dictionary) {
            var dict = opt.dictionary.subarray(-32768);
            var newDat = new u8(dict.length + dat.length);
            newDat.set(dict);
            newDat.set(dat, dict.length);
            dat = newDat;
            st.w = dict.length;
        }
    }
    return dflt(dat, opt.level == null ? 6 : opt.level, opt.mem == null ? st.l ? Math.ceil(Math.max(8, Math.min(13, Math.log(dat.length))) * 1.5) : 20 : 12 + opt.mem, pre, post, st);
};
// Walmart object spread
var mrg = function(a, b) {
    var o = {};
    for(var k in a)o[k] = a[k];
    for(var k in b)o[k] = b[k];
    return o;
};
// worker clone
// This is possibly the craziest part of the entire codebase, despite how simple it may seem.
// The only parameter to this function is a closure that returns an array of variables outside of the function scope.
// We're going to try to figure out the variable names used in the closure as strings because that is crucial for workerization.
// We will return an object mapping of true variable name to value (basically, the current scope as a JS object).
// The reason we can't just use the original variable names is minifiers mangling the toplevel scope.
// This took me three weeks to figure out how to do.
var wcln = function(fn, fnStr, td) {
    var dt = fn();
    var st = fn.toString();
    var ks = st.slice(st.indexOf('[') + 1, st.lastIndexOf(']')).replace(/\s+/g, '').split(',');
    for(var i = 0; i < dt.length; ++i){
        var v = dt[i], k = ks[i];
        if (typeof v == 'function') {
            fnStr += ';' + k + '=';
            var st_1 = v.toString();
            if (v.prototype) {
                // for global objects
                if (st_1.indexOf('[native code]') != -1) {
                    var spInd = st_1.indexOf(' ', 8) + 1;
                    fnStr += st_1.slice(spInd, st_1.indexOf('(', spInd));
                } else {
                    fnStr += st_1;
                    for(var t in v.prototype)fnStr += ';' + k + '.prototype.' + t + '=' + v.prototype[t].toString();
                }
            } else fnStr += st_1;
        } else td[k] = v;
    }
    return fnStr;
};
var ch = [];
// clone bufs
var cbfs = function(v) {
    var tl = [];
    for(var k in v)if (v[k].buffer) tl.push((v[k] = new v[k].constructor(v[k])).buffer);
    return tl;
};
// use a worker to execute code
var wrkr = function(fns, init, id, cb) {
    if (!ch[id]) {
        var fnStr = '', td_1 = {}, m = fns.length - 1;
        for(var i = 0; i < m; ++i)fnStr = wcln(fns[i], fnStr, td_1);
        ch[id] = {
            c: wcln(fns[m], fnStr, td_1),
            e: td_1
        };
    }
    var td = mrg({}, ch[id].e);
    return wk(ch[id].c + ';onmessage=function(e){for(var k in e.data)self[k]=e.data[k];onmessage=' + init.toString() + '}', id, td, cbfs(td), cb);
};
// base async inflate fn
var bInflt = function() {
    return [
        u8,
        u16,
        i32,
        fleb,
        fdeb,
        clim,
        fl,
        fd,
        flrm,
        fdrm,
        rev,
        ec,
        hMap,
        max,
        bits,
        bits16,
        shft,
        slc,
        err,
        inflt,
        inflateSync,
        pbf,
        gopt
    ];
};
var bDflt = function() {
    return [
        u8,
        u16,
        i32,
        fleb,
        fdeb,
        clim,
        revfl,
        revfd,
        flm,
        flt,
        fdm,
        fdt,
        rev,
        deo,
        et,
        hMap,
        wbits,
        wbits16,
        hTree,
        ln,
        lc,
        clen,
        wfblk,
        wblk,
        shft,
        slc,
        dflt,
        dopt,
        deflateSync,
        pbf
    ];
};
// gzip extra
var gze = function() {
    return [
        gzh,
        gzhl,
        wbytes,
        crc,
        crct
    ];
};
// gunzip extra
var guze = function() {
    return [
        gzs,
        gzl
    ];
};
// zlib extra
var zle = function() {
    return [
        zlh,
        wbytes,
        adler
    ];
};
// unzlib extra
var zule = function() {
    return [
        zls
    ];
};
// post buf
var pbf = function(msg) {
    return postMessage(msg, [
        msg.buffer
    ]);
};
// get opts
var gopt = function(o) {
    return o && {
        out: o.size && new u8(o.size),
        dictionary: o.dictionary
    };
};
// async helper
var cbify = function(dat, opts, fns, init, id, cb) {
    var w = wrkr(fns, init, id, function(err, dat) {
        w.terminate();
        cb(err, dat);
    });
    w.postMessage([
        dat,
        opts
    ], opts.consume ? [
        dat.buffer
    ] : []);
    return function() {
        w.terminate();
    };
};
// auto stream
var astrm = function(strm) {
    strm.ondata = function(dat, final) {
        return postMessage([
            dat,
            final
        ], [
            dat.buffer
        ]);
    };
    return function(ev) {
        if (ev.data.length) {
            strm.push(ev.data[0], ev.data[1]);
            postMessage([
                ev.data[0].length
            ]);
        } else strm.flush();
    };
};
// async stream attach
var astrmify = function(fns, strm, opts, init, id, flush, ext) {
    var t;
    var w = wrkr(fns, init, id, function(err, dat) {
        if (err) w.terminate(), strm.ondata.call(strm, err);
        else if (!Array.isArray(dat)) ext(dat);
        else if (dat.length == 1) {
            strm.queuedSize -= dat[0];
            if (strm.ondrain) strm.ondrain(dat[0]);
        } else {
            if (dat[1]) w.terminate();
            strm.ondata.call(strm, err, dat[0], dat[1]);
        }
    });
    w.postMessage(opts);
    strm.queuedSize = 0;
    strm.push = function(d, f) {
        if (!strm.ondata) err(5);
        if (t) strm.ondata(err(4, 0, 1), null, !!f);
        strm.queuedSize += d.length;
        w.postMessage([
            d,
            t = f
        ], [
            d.buffer
        ]);
    };
    strm.terminate = function() {
        w.terminate();
    };
    if (flush) strm.flush = function() {
        w.postMessage([]);
    };
};
// read 2 bytes
var b2 = function(d, b) {
    return d[b] | d[b + 1] << 8;
};
// read 4 bytes
var b4 = function(d, b) {
    return (d[b] | d[b + 1] << 8 | d[b + 2] << 16 | d[b + 3] << 24) >>> 0;
};
var b8 = function(d, b) {
    return b4(d, b) + b4(d, b + 4) * 4294967296;
};
// write bytes
var wbytes = function(d, b, v) {
    for(; v; ++b)d[b] = v, v >>>= 8;
};
// gzip header
var gzh = function(c, o) {
    var fn = o.filename;
    c[0] = 31, c[1] = 139, c[2] = 8, c[8] = o.level < 2 ? 4 : o.level == 9 ? 2 : 0, c[9] = 3; // assume Unix
    if (o.mtime != 0) wbytes(c, 4, Math.floor(new Date(o.mtime || Date.now()) / 1000));
    if (fn) {
        c[3] = 8;
        for(var i = 0; i <= fn.length; ++i)c[i + 10] = fn.charCodeAt(i);
    }
};
// gzip footer: -8 to -4 = CRC, -4 to -0 is length
// gzip start
var gzs = function(d) {
    if (d[0] != 31 || d[1] != 139 || d[2] != 8) err(6, 'invalid gzip data');
    var flg = d[3];
    var st = 10;
    if (flg & 4) st += (d[10] | d[11] << 8) + 2;
    for(var zs = (flg >> 3 & 1) + (flg >> 4 & 1); zs > 0; zs -= !d[st++]);
    return st + (flg & 2);
};
// gzip length
var gzl = function(d) {
    var l = d.length;
    return (d[l - 4] | d[l - 3] << 8 | d[l - 2] << 16 | d[l - 1] << 24) >>> 0;
};
// gzip header length
var gzhl = function(o) {
    return 10 + (o.filename ? o.filename.length + 1 : 0);
};
// zlib header
var zlh = function(c, o) {
    var lv = o.level, fl = lv == 0 ? 0 : lv < 6 ? 1 : lv == 9 ? 3 : 2;
    c[0] = 120, c[1] = fl << 6 | (o.dictionary && 32);
    c[1] |= 31 - (c[0] << 8 | c[1]) % 31;
    if (o.dictionary) {
        var h = adler();
        h.p(o.dictionary);
        wbytes(c, 2, h.d());
    }
};
// zlib start
var zls = function(d, dict) {
    if ((d[0] & 15) != 8 || d[0] >> 4 > 7 || (d[0] << 8 | d[1]) % 31) err(6, 'invalid zlib data');
    if ((d[1] >> 5 & 1) == +!dict) err(6, 'invalid zlib data: ' + (d[1] & 32 ? 'need' : 'unexpected') + ' dictionary');
    return (d[1] >> 3 & 4) + 2;
};
function StrmOpt(opts, cb) {
    if (typeof opts == 'function') cb = opts, opts = {};
    this.ondata = cb;
    return opts;
}
/**
 * Streaming DEFLATE compression
 */ var Deflate = /*#__PURE__*/ function() {
    function Deflate(opts, cb) {
        if (typeof opts == 'function') cb = opts, opts = {};
        this.ondata = cb;
        this.o = opts || {};
        this.s = {
            l: 0,
            i: 32768,
            w: 32768,
            z: 32768
        };
        // Buffer length must always be 0 mod 32768 for index calculations to be correct when modifying head and prev
        // 98304 = 32768 (lookback) + 65536 (common chunk size)
        this.b = new u8(98304);
        if (this.o.dictionary) {
            var dict = this.o.dictionary.subarray(-32768);
            this.b.set(dict, 32768 - dict.length);
            this.s.i = 32768 - dict.length;
        }
    }
    Deflate.prototype.p = function(c, f) {
        this.ondata(dopt(c, this.o, 0, 0, this.s), f);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Deflate.prototype.push = function(chunk, final) {
        if (!this.ondata) err(5);
        if (this.s.l) err(4);
        var endLen = chunk.length + this.s.z;
        if (endLen > this.b.length) {
            if (endLen > 2 * this.b.length - 32768) {
                var newBuf = new u8(endLen & -32768);
                newBuf.set(this.b.subarray(0, this.s.z));
                this.b = newBuf;
            }
            var split = this.b.length - this.s.z;
            this.b.set(chunk.subarray(0, split), this.s.z);
            this.s.z = this.b.length;
            this.p(this.b, false);
            this.b.set(this.b.subarray(-32768));
            this.b.set(chunk.subarray(split), 32768);
            this.s.z = chunk.length - split + 32768;
            this.s.i = 32766, this.s.w = 32768;
        } else {
            this.b.set(chunk, this.s.z);
            this.s.z += chunk.length;
        }
        this.s.l = final & 1;
        if (this.s.z > this.s.w + 8191 || final) {
            this.p(this.b, final || false);
            this.s.w = this.s.i, this.s.i -= 2;
        }
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * deflated output for small inputs.
     */ Deflate.prototype.flush = function() {
        if (!this.ondata) err(5);
        if (this.s.l) err(4);
        this.p(this.b, false);
        this.s.w = this.s.i, this.s.i -= 2;
    };
    return Deflate;
}();
/**
 * Asynchronous streaming DEFLATE compression
 */ var AsyncDeflate = /*#__PURE__*/ function() {
    function AsyncDeflate(opts, cb) {
        astrmify([
            bDflt,
            function() {
                return [
                    astrm,
                    Deflate
                ];
            }
        ], this, StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new Deflate(ev.data);
            onmessage = astrm(strm);
        }, 6, 1);
    }
    return AsyncDeflate;
}();
function deflate(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') err(7);
    return cbify(data, opts, [
        bDflt
    ], function(ev) {
        return pbf(deflateSync(ev.data[0], ev.data[1]));
    }, 0, cb);
}
function deflateSync(data, opts) {
    return dopt(data, opts || {}, 0, 0);
}
/**
 * Streaming DEFLATE decompression
 */ var Inflate = /*#__PURE__*/ function() {
    function Inflate(opts, cb) {
        // no StrmOpt here to avoid adding to workerizer
        if (typeof opts == 'function') cb = opts, opts = {};
        this.ondata = cb;
        var dict = opts && opts.dictionary && opts.dictionary.subarray(-32768);
        this.s = {
            i: 0,
            b: dict ? dict.length : 0
        };
        this.o = new u8(32768);
        this.p = new u8(0);
        if (dict) this.o.set(dict);
    }
    Inflate.prototype.e = function(c) {
        if (!this.ondata) err(5);
        if (this.d) err(4);
        if (!this.p.length) this.p = c;
        else if (c.length) {
            var n = new u8(this.p.length + c.length);
            n.set(this.p), n.set(c, this.p.length), this.p = n;
        }
    };
    Inflate.prototype.c = function(final) {
        this.s.i = +(this.d = final || false);
        var bts = this.s.b;
        var dt = inflt(this.p, this.s, this.o);
        this.ondata(slc(dt, bts, this.s.b), this.d);
        this.o = slc(dt, this.s.b - 32768), this.s.b = this.o.length;
        this.p = slc(this.p, this.s.p / 8 | 0), this.s.p &= 7;
    };
    /**
     * Pushes a chunk to be inflated
     * @param chunk The chunk to push
     * @param final Whether this is the final chunk
     */ Inflate.prototype.push = function(chunk, final) {
        this.e(chunk), this.c(final);
    };
    return Inflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression
 */ var AsyncInflate = /*#__PURE__*/ function() {
    function AsyncInflate(opts, cb) {
        astrmify([
            bInflt,
            function() {
                return [
                    astrm,
                    Inflate
                ];
            }
        ], this, StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new Inflate(ev.data);
            onmessage = astrm(strm);
        }, 7, 0);
    }
    return AsyncInflate;
}();
function inflate(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') err(7);
    return cbify(data, opts, [
        bInflt
    ], function(ev) {
        return pbf(inflateSync(ev.data[0], gopt(ev.data[1])));
    }, 1, cb);
}
function inflateSync(data, opts) {
    return inflt(data, {
        i: 2
    }, opts && opts.out, opts && opts.dictionary);
}
// before you yell at me for not just using extends, my reason is that TS inheritance is hard to workerize.
/**
 * Streaming GZIP compression
 */ var Gzip = /*#__PURE__*/ function() {
    function Gzip(opts, cb) {
        this.c = crc();
        this.l = 0;
        this.v = 1;
        Deflate.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gzip.prototype.push = function(chunk, final) {
        this.c.p(chunk);
        this.l += chunk.length;
        Deflate.prototype.push.call(this, chunk, final);
    };
    Gzip.prototype.p = function(c, f) {
        var raw = dopt(c, this.o, this.v && gzhl(this.o), f && 8, this.s);
        if (this.v) gzh(raw, this.o), this.v = 0;
        if (f) wbytes(raw, raw.length - 8, this.c.d()), wbytes(raw, raw.length - 4, this.l);
        this.ondata(raw, f);
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * GZIPped output for small inputs.
     */ Gzip.prototype.flush = function() {
        Deflate.prototype.flush.call(this);
    };
    return Gzip;
}();
/**
 * Asynchronous streaming GZIP compression
 */ var AsyncGzip = /*#__PURE__*/ function() {
    function AsyncGzip(opts, cb) {
        astrmify([
            bDflt,
            gze,
            function() {
                return [
                    astrm,
                    Deflate,
                    Gzip
                ];
            }
        ], this, StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new Gzip(ev.data);
            onmessage = astrm(strm);
        }, 8, 1);
    }
    return AsyncGzip;
}();
function gzip(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') err(7);
    return cbify(data, opts, [
        bDflt,
        gze,
        function() {
            return [
                gzipSync
            ];
        }
    ], function(ev) {
        return pbf(gzipSync(ev.data[0], ev.data[1]));
    }, 2, cb);
}
function gzipSync(data, opts) {
    if (!opts) opts = {};
    var c = crc(), l = data.length;
    c.p(data);
    var d = dopt(data, opts, gzhl(opts), 8), s = d.length;
    return gzh(d, opts), wbytes(d, s - 8, c.d()), wbytes(d, s - 4, l), d;
}
/**
 * Streaming single or multi-member GZIP decompression
 */ var Gunzip = /*#__PURE__*/ function() {
    function Gunzip(opts, cb) {
        this.v = 1;
        this.r = 0;
        Inflate.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GUNZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gunzip.prototype.push = function(chunk, final) {
        Inflate.prototype.e.call(this, chunk);
        this.r += chunk.length;
        if (this.v) {
            var p = this.p.subarray(this.v - 1);
            var s = p.length > 3 ? gzs(p) : 4;
            if (s > p.length) {
                if (!final) return;
            } else if (this.v > 1 && this.onmember) this.onmember(this.r - p.length);
            this.p = p.subarray(s), this.v = 0;
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        Inflate.prototype.c.call(this, final);
        // process concatenated GZIP
        if (this.s.f && !this.s.l && !final) {
            this.v = shft(this.s.p) + 9;
            this.s = {
                i: 0
            };
            this.o = new u8(0);
            this.push(new u8(0), final);
        }
    };
    return Gunzip;
}();
/**
 * Asynchronous streaming single or multi-member GZIP decompression
 */ var AsyncGunzip = /*#__PURE__*/ function() {
    function AsyncGunzip(opts, cb) {
        var _this = this;
        astrmify([
            bInflt,
            guze,
            function() {
                return [
                    astrm,
                    Inflate,
                    Gunzip
                ];
            }
        ], this, StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new Gunzip(ev.data);
            strm.onmember = function(offset) {
                return postMessage(offset);
            };
            onmessage = astrm(strm);
        }, 9, 0, function(offset) {
            return _this.onmember && _this.onmember(offset);
        });
    }
    return AsyncGunzip;
}();
function gunzip(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') err(7);
    return cbify(data, opts, [
        bInflt,
        guze,
        function() {
            return [
                gunzipSync
            ];
        }
    ], function(ev) {
        return pbf(gunzipSync(ev.data[0], ev.data[1]));
    }, 3, cb);
}
function gunzipSync(data, opts) {
    var st = gzs(data);
    if (st + 8 > data.length) err(6, 'invalid gzip data');
    return inflt(data.subarray(st, -8), {
        i: 2
    }, opts && opts.out || new u8(gzl(data)), opts && opts.dictionary);
}
/**
 * Streaming Zlib compression
 */ var Zlib = /*#__PURE__*/ function() {
    function Zlib(opts, cb) {
        this.c = adler();
        this.v = 1;
        Deflate.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be zlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Zlib.prototype.push = function(chunk, final) {
        this.c.p(chunk);
        Deflate.prototype.push.call(this, chunk, final);
    };
    Zlib.prototype.p = function(c, f) {
        var raw = dopt(c, this.o, this.v && (this.o.dictionary ? 6 : 2), f && 4, this.s);
        if (this.v) zlh(raw, this.o), this.v = 0;
        if (f) wbytes(raw, raw.length - 4, this.c.d());
        this.ondata(raw, f);
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * zlibbed output for small inputs.
     */ Zlib.prototype.flush = function() {
        Deflate.prototype.flush.call(this);
    };
    return Zlib;
}();
/**
 * Asynchronous streaming Zlib compression
 */ var AsyncZlib = /*#__PURE__*/ function() {
    function AsyncZlib(opts, cb) {
        astrmify([
            bDflt,
            zle,
            function() {
                return [
                    astrm,
                    Deflate,
                    Zlib
                ];
            }
        ], this, StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new Zlib(ev.data);
            onmessage = astrm(strm);
        }, 10, 1);
    }
    return AsyncZlib;
}();
function zlib(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') err(7);
    return cbify(data, opts, [
        bDflt,
        zle,
        function() {
            return [
                zlibSync
            ];
        }
    ], function(ev) {
        return pbf(zlibSync(ev.data[0], ev.data[1]));
    }, 4, cb);
}
function zlibSync(data, opts) {
    if (!opts) opts = {};
    var a = adler();
    a.p(data);
    var d = dopt(data, opts, opts.dictionary ? 6 : 2, 4);
    return zlh(d, opts), wbytes(d, d.length - 4, a.d()), d;
}
/**
 * Streaming Zlib decompression
 */ var Unzlib = /*#__PURE__*/ function() {
    function Unzlib(opts, cb) {
        Inflate.call(this, opts, cb);
        this.v = opts && opts.dictionary ? 2 : 1;
    }
    /**
     * Pushes a chunk to be unzlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzlib.prototype.push = function(chunk, final) {
        Inflate.prototype.e.call(this, chunk);
        if (this.v) {
            if (this.p.length < 6 && !final) return;
            this.p = this.p.subarray(zls(this.p, this.v - 1)), this.v = 0;
        }
        if (final) {
            if (this.p.length < 4) err(6, 'invalid zlib data');
            this.p = this.p.subarray(0, -4);
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        Inflate.prototype.c.call(this, final);
    };
    return Unzlib;
}();
/**
 * Asynchronous streaming Zlib decompression
 */ var AsyncUnzlib = /*#__PURE__*/ function() {
    function AsyncUnzlib(opts, cb) {
        astrmify([
            bInflt,
            zule,
            function() {
                return [
                    astrm,
                    Inflate,
                    Unzlib
                ];
            }
        ], this, StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new Unzlib(ev.data);
            onmessage = astrm(strm);
        }, 11, 0);
    }
    return AsyncUnzlib;
}();
function unzlib(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') err(7);
    return cbify(data, opts, [
        bInflt,
        zule,
        function() {
            return [
                unzlibSync
            ];
        }
    ], function(ev) {
        return pbf(unzlibSync(ev.data[0], gopt(ev.data[1])));
    }, 5, cb);
}
function unzlibSync(data, opts) {
    return inflt(data.subarray(zls(data, opts && opts.dictionary), -4), {
        i: 2
    }, opts && opts.out, opts && opts.dictionary);
}
/**
 * Streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var Decompress = /*#__PURE__*/ function() {
    function Decompress(opts, cb) {
        this.o = StrmOpt.call(this, opts, cb) || {};
        this.G = Gunzip;
        this.I = Inflate;
        this.Z = Unzlib;
    }
    // init substream
    // overriden by AsyncDecompress
    Decompress.prototype.i = function() {
        var _this = this;
        this.s.ondata = function(dat, final) {
            _this.ondata(dat, final);
        };
    };
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Decompress.prototype.push = function(chunk, final) {
        if (!this.ondata) err(5);
        if (!this.s) {
            if (this.p && this.p.length) {
                var n = new u8(this.p.length + chunk.length);
                n.set(this.p), n.set(chunk, this.p.length);
            } else this.p = chunk;
            if (this.p.length > 2) {
                this.s = this.p[0] == 31 && this.p[1] == 139 && this.p[2] == 8 ? new this.G(this.o) : (this.p[0] & 15) != 8 || this.p[0] >> 4 > 7 || (this.p[0] << 8 | this.p[1]) % 31 ? new this.I(this.o) : new this.Z(this.o);
                this.i();
                this.s.push(this.p, final);
                this.p = null;
            }
        } else this.s.push(chunk, final);
    };
    return Decompress;
}();
/**
 * Asynchronous streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var AsyncDecompress = /*#__PURE__*/ function() {
    function AsyncDecompress(opts, cb) {
        Decompress.call(this, opts, cb);
        this.queuedSize = 0;
        this.G = AsyncGunzip;
        this.I = AsyncInflate;
        this.Z = AsyncUnzlib;
    }
    AsyncDecompress.prototype.i = function() {
        var _this = this;
        this.s.ondata = function(err, dat, final) {
            _this.ondata(err, dat, final);
        };
        this.s.ondrain = function(size) {
            _this.queuedSize -= size;
            if (_this.ondrain) _this.ondrain(size);
        };
    };
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncDecompress.prototype.push = function(chunk, final) {
        this.queuedSize += chunk.length;
        Decompress.prototype.push.call(this, chunk, final);
    };
    return AsyncDecompress;
}();
function decompress(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') err(7);
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? gunzip(data, opts, cb) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? inflate(data, opts, cb) : unzlib(data, opts, cb);
}
function decompressSync(data, opts) {
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? gunzipSync(data, opts) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? inflateSync(data, opts) : unzlibSync(data, opts);
}
// flatten a directory structure
var fltn = function(d, p, t, o) {
    for(var k in d){
        var val = d[k], n = p + k, op = o;
        if (Array.isArray(val)) op = mrg(o, val[1]), val = val[0];
        if (val instanceof u8) t[n] = [
            val,
            op
        ];
        else {
            t[n += '/'] = [
                new u8(0),
                op
            ];
            fltn(val, n, t, o);
        }
    }
};
// text encoder
var te = typeof TextEncoder != 'undefined' && /*#__PURE__*/ new TextEncoder();
// text decoder
var td = typeof TextDecoder != 'undefined' && /*#__PURE__*/ new TextDecoder();
// text decoder stream
var tds = 0;
try {
    td.decode(et, {
        stream: true
    });
    tds = 1;
} catch (e) {}
// decode UTF8
var dutf8 = function(d) {
    for(var r = '', i = 0;;){
        var c = d[i++];
        var eb = (c > 127) + (c > 223) + (c > 239);
        if (i + eb > d.length) return {
            s: r,
            r: slc(d, i - 1)
        };
        if (!eb) r += String.fromCharCode(c);
        else if (eb == 3) c = ((c & 15) << 18 | (d[i++] & 63) << 12 | (d[i++] & 63) << 6 | d[i++] & 63) - 65536, r += String.fromCharCode(55296 | c >> 10, 56320 | c & 1023);
        else if (eb & 1) r += String.fromCharCode((c & 31) << 6 | d[i++] & 63);
        else r += String.fromCharCode((c & 15) << 12 | (d[i++] & 63) << 6 | d[i++] & 63);
    }
};
/**
 * Streaming UTF-8 decoding
 */ var DecodeUTF8 = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is decoded
     */ function DecodeUTF8(cb) {
        this.ondata = cb;
        if (tds) this.t = new TextDecoder();
        else this.p = et;
    }
    /**
     * Pushes a chunk to be decoded from UTF-8 binary
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ DecodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) err(5);
        final = !!final;
        if (this.t) {
            this.ondata(this.t.decode(chunk, {
                stream: true
            }), final);
            if (final) {
                if (this.t.decode().length) err(8);
                this.t = null;
            }
            return;
        }
        if (!this.p) err(4);
        var dat = new u8(this.p.length + chunk.length);
        dat.set(this.p);
        dat.set(chunk, this.p.length);
        var _a = dutf8(dat), s = _a.s, r = _a.r;
        if (final) {
            if (r.length) err(8);
            this.p = null;
        } else this.p = r;
        this.ondata(s, final);
    };
    return DecodeUTF8;
}();
/**
 * Streaming UTF-8 encoding
 */ var EncodeUTF8 = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is encoded
     */ function EncodeUTF8(cb) {
        this.ondata = cb;
    }
    /**
     * Pushes a chunk to be encoded to UTF-8
     * @param chunk The string data to push
     * @param final Whether this is the last chunk
     */ EncodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) err(5);
        if (this.d) err(4);
        this.ondata(strToU8(chunk), this.d = final || false);
    };
    return EncodeUTF8;
}();
function strToU8(str, latin1) {
    if (latin1) {
        var ar_1 = new u8(str.length);
        for(var i = 0; i < str.length; ++i)ar_1[i] = str.charCodeAt(i);
        return ar_1;
    }
    if (te) return te.encode(str);
    var l = str.length;
    var ar = new u8(str.length + (str.length >> 1));
    var ai = 0;
    var w = function(v) {
        ar[ai++] = v;
    };
    for(var i = 0; i < l; ++i){
        if (ai + 5 > ar.length) {
            var n = new u8(ai + 8 + (l - i << 1));
            n.set(ar);
            ar = n;
        }
        var c = str.charCodeAt(i);
        if (c < 128 || latin1) w(c);
        else if (c < 2048) w(192 | c >> 6), w(128 | c & 63);
        else if (c > 55295 && c < 57344) c = 65536 + (c & 1047552) | str.charCodeAt(++i) & 1023, w(240 | c >> 18), w(128 | c >> 12 & 63), w(128 | c >> 6 & 63), w(128 | c & 63);
        else w(224 | c >> 12), w(128 | c >> 6 & 63), w(128 | c & 63);
    }
    return slc(ar, 0, ai);
}
function strFromU8(dat, latin1) {
    if (latin1) {
        var r = '';
        for(var i = 0; i < dat.length; i += 16384)r += String.fromCharCode.apply(null, dat.subarray(i, i + 16384));
        return r;
    } else if (td) return td.decode(dat);
    else {
        var _a = dutf8(dat), s = _a.s, r = _a.r;
        if (r.length) err(8);
        return s;
    }
}
// deflate bit flag
var dbf = function(l) {
    return l == 1 ? 3 : l < 6 ? 2 : l == 9 ? 1 : 0;
};
// skip local zip header
var slzh = function(d, b) {
    return b + 30 + b2(d, b + 26) + b2(d, b + 28);
};
// read zip header
var zh = function(d, b, z) {
    var fnl = b2(d, b + 28), fn = strFromU8(d.subarray(b + 46, b + 46 + fnl), !(b2(d, b + 8) & 2048)), es = b + 46 + fnl, bs = b4(d, b + 20);
    var _a = z && bs == 4294967295 ? z64e(d, es) : [
        bs,
        b4(d, b + 24),
        b4(d, b + 42)
    ], sc = _a[0], su = _a[1], off = _a[2];
    return [
        b2(d, b + 10),
        sc,
        su,
        fn,
        es + b2(d, b + 30) + b2(d, b + 32),
        off
    ];
};
// read zip64 extra field
var z64e = function(d, b) {
    for(; b2(d, b) != 1; b += 4 + b2(d, b + 2));
    return [
        b8(d, b + 12),
        b8(d, b + 4),
        b8(d, b + 20)
    ];
};
// extra field length
var exfl = function(ex) {
    var le = 0;
    if (ex) for(var k in ex){
        var l = ex[k].length;
        if (l > 65535) err(9);
        le += l + 4;
    }
    return le;
};
// write zip header
var wzh = function(d, b, f, fn, u, c, ce, co) {
    var fl = fn.length, ex = f.extra, col = co && co.length;
    var exl = exfl(ex);
    wbytes(d, b, ce != null ? 0x2014B50 : 0x4034B50), b += 4;
    if (ce != null) d[b++] = 20, d[b++] = f.os;
    d[b] = 20, b += 2; // spec compliance? what's that?
    d[b++] = f.flag << 1 | (c < 0 && 8), d[b++] = u && 8;
    d[b++] = f.compression & 255, d[b++] = f.compression >> 8;
    var dt = new Date(f.mtime == null ? Date.now() : f.mtime), y = dt.getFullYear() - 1980;
    if (y < 0 || y > 119) err(10);
    wbytes(d, b, y << 25 | dt.getMonth() + 1 << 21 | dt.getDate() << 16 | dt.getHours() << 11 | dt.getMinutes() << 5 | dt.getSeconds() >> 1), b += 4;
    if (c != -1) {
        wbytes(d, b, f.crc);
        wbytes(d, b + 4, c < 0 ? -c - 2 : c);
        wbytes(d, b + 8, f.size);
    }
    wbytes(d, b + 12, fl);
    wbytes(d, b + 14, exl), b += 16;
    if (ce != null) {
        wbytes(d, b, col);
        wbytes(d, b + 6, f.attrs);
        wbytes(d, b + 10, ce), b += 14;
    }
    d.set(fn, b);
    b += fl;
    if (exl) for(var k in ex){
        var exf = ex[k], l = exf.length;
        wbytes(d, b, +k);
        wbytes(d, b + 2, l);
        d.set(exf, b + 4), b += 4 + l;
    }
    if (col) d.set(co, b), b += col;
    return b;
};
// write zip footer (end of central directory)
var wzf = function(o, b, c, d, e) {
    wbytes(o, b, 0x6054B50); // skip disk
    wbytes(o, b + 8, c);
    wbytes(o, b + 10, c);
    wbytes(o, b + 12, d);
    wbytes(o, b + 16, e);
};
/**
 * A pass-through stream to keep data uncompressed in a ZIP archive.
 */ var ZipPassThrough = /*#__PURE__*/ function() {
    /**
     * Creates a pass-through stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     */ function ZipPassThrough(filename) {
        this.filename = filename;
        this.c = crc();
        this.size = 0;
        this.compression = 0;
    }
    /**
     * Processes a chunk and pushes to the output stream. You can override this
     * method in a subclass for custom behavior, but by default this passes
     * the data through. You must call this.ondata(err, chunk, final) at some
     * point in this method.
     * @param chunk The chunk to process
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.process = function(chunk, final) {
        this.ondata(null, chunk, final);
    };
    /**
     * Pushes a chunk to be added. If you are subclassing this with a custom
     * compression algorithm, note that you must push data from the source
     * file only, pre-compression.
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.push = function(chunk, final) {
        if (!this.ondata) err(5);
        this.c.p(chunk);
        this.size += chunk.length;
        if (final) this.crc = this.c.d();
        this.process(chunk, final || false);
    };
    return ZipPassThrough;
}();
// I don't extend because TypeScript extension adds 1kB of runtime bloat
/**
 * Streaming DEFLATE compression for ZIP archives. Prefer using AsyncZipDeflate
 * for better performance
 */ var ZipDeflate = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function ZipDeflate(filename, opts) {
        var _this = this;
        if (!opts) opts = {};
        ZipPassThrough.call(this, filename);
        this.d = new Deflate(opts, function(dat, final) {
            _this.ondata(null, dat, final);
        });
        this.compression = 8;
        this.flag = dbf(opts.level);
    }
    ZipDeflate.prototype.process = function(chunk, final) {
        try {
            this.d.push(chunk, final);
        } catch (e) {
            this.ondata(e, null, final);
        }
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipDeflate.prototype.push = function(chunk, final) {
        ZipPassThrough.prototype.push.call(this, chunk, final);
    };
    return ZipDeflate;
}();
/**
 * Asynchronous streaming DEFLATE compression for ZIP archives
 */ var AsyncZipDeflate = /*#__PURE__*/ function() {
    /**
     * Creates an asynchronous DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function AsyncZipDeflate(filename, opts) {
        var _this = this;
        if (!opts) opts = {};
        ZipPassThrough.call(this, filename);
        this.d = new AsyncDeflate(opts, function(err, dat, final) {
            _this.ondata(err, dat, final);
        });
        this.compression = 8;
        this.flag = dbf(opts.level);
        this.terminate = this.d.terminate;
    }
    AsyncZipDeflate.prototype.process = function(chunk, final) {
        this.d.push(chunk, final);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncZipDeflate.prototype.push = function(chunk, final) {
        ZipPassThrough.prototype.push.call(this, chunk, final);
    };
    return AsyncZipDeflate;
}();
// TODO: Better tree shaking
/**
 * A zippable archive to which files can incrementally be added
 */ var Zip = /*#__PURE__*/ function() {
    /**
     * Creates an empty ZIP archive to which files can be added
     * @param cb The callback to call whenever data for the generated ZIP archive
     *           is available
     */ function Zip(cb) {
        this.ondata = cb;
        this.u = [];
        this.d = 1;
    }
    /**
     * Adds a file to the ZIP archive
     * @param file The file stream to add
     */ Zip.prototype.add = function(file) {
        var _this = this;
        if (!this.ondata) err(5);
        // finishing or finished
        if (this.d & 2) this.ondata(err(4 + (this.d & 1) * 8, 0, 1), null, false);
        else {
            var f = strToU8(file.filename), fl_1 = f.length;
            var com = file.comment, o = com && strToU8(com);
            var u = fl_1 != file.filename.length || o && com.length != o.length;
            var hl_1 = fl_1 + exfl(file.extra) + 30;
            if (fl_1 > 65535) this.ondata(err(11, 0, 1), null, false);
            var header = new u8(hl_1);
            wzh(header, 0, file, f, u, -1);
            var chks_1 = [
                header
            ];
            var pAll_1 = function() {
                for(var _i = 0, chks_2 = chks_1; _i < chks_2.length; _i++){
                    var chk = chks_2[_i];
                    _this.ondata(null, chk, false);
                }
                chks_1 = [];
            };
            var tr_1 = this.d;
            this.d = 0;
            var ind_1 = this.u.length;
            var uf_1 = mrg(file, {
                f: f,
                u: u,
                o: o,
                t: function() {
                    if (file.terminate) file.terminate();
                },
                r: function() {
                    pAll_1();
                    if (tr_1) {
                        var nxt = _this.u[ind_1 + 1];
                        if (nxt) nxt.r();
                        else _this.d = 1;
                    }
                    tr_1 = 1;
                }
            });
            var cl_1 = 0;
            file.ondata = function(err, dat, final) {
                if (err) {
                    _this.ondata(err, dat, final);
                    _this.terminate();
                } else {
                    cl_1 += dat.length;
                    chks_1.push(dat);
                    if (final) {
                        var dd = new u8(16);
                        wbytes(dd, 0, 0x8074B50);
                        wbytes(dd, 4, file.crc);
                        wbytes(dd, 8, cl_1);
                        wbytes(dd, 12, file.size);
                        chks_1.push(dd);
                        uf_1.c = cl_1, uf_1.b = hl_1 + cl_1 + 16, uf_1.crc = file.crc, uf_1.size = file.size;
                        if (tr_1) uf_1.r();
                        tr_1 = 1;
                    } else if (tr_1) pAll_1();
                }
            };
            this.u.push(uf_1);
        }
    };
    /**
     * Ends the process of adding files and prepares to emit the final chunks.
     * This *must* be called after adding all desired files for the resulting
     * ZIP file to work properly.
     */ Zip.prototype.end = function() {
        var _this = this;
        if (this.d & 2) {
            this.ondata(err(4 + (this.d & 1) * 8, 0, 1), null, true);
            return;
        }
        if (this.d) this.e();
        else this.u.push({
            r: function() {
                if (!(_this.d & 1)) return;
                _this.u.splice(-1, 1);
                _this.e();
            },
            t: function() {}
        });
        this.d = 3;
    };
    Zip.prototype.e = function() {
        var bt = 0, l = 0, tl = 0;
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            tl += 46 + f.f.length + exfl(f.extra) + (f.o ? f.o.length : 0);
        }
        var out = new u8(tl + 22);
        for(var _b = 0, _c = this.u; _b < _c.length; _b++){
            var f = _c[_b];
            wzh(out, bt, f, f.f, f.u, -f.c - 2, l, f.o);
            bt += 46 + f.f.length + exfl(f.extra) + (f.o ? f.o.length : 0), l += f.b;
        }
        wzf(out, bt, this.u.length, tl, l);
        this.ondata(null, out, true);
        this.d = 2;
    };
    /**
     * A method to terminate any internal workers used by the stream. Subsequent
     * calls to add() will fail.
     */ Zip.prototype.terminate = function() {
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            f.t();
        }
        this.d = 2;
    };
    return Zip;
}();
function zip(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') err(7);
    var r = {};
    fltn(data, '', r, opts);
    var k = Object.keys(r);
    var lft = k.length, o = 0, tot = 0;
    var slft = lft, files = new Array(lft);
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var cbd = function(a, b) {
        mt(function() {
            cb(a, b);
        });
    };
    mt(function() {
        cbd = cb;
    });
    var cbf = function() {
        var out = new u8(tot + 22), oe = o, cdl = tot - o;
        tot = 0;
        for(var i = 0; i < slft; ++i){
            var f = files[i];
            try {
                var l = f.c.length;
                wzh(out, tot, f, f.f, f.u, l);
                var badd = 30 + f.f.length + exfl(f.extra);
                var loc = tot + badd;
                out.set(f.c, loc);
                wzh(out, o, f, f.f, f.u, l, tot, f.m), o += 16 + badd + (f.m ? f.m.length : 0), tot = loc + l;
            } catch (e) {
                return cbd(e, null);
            }
        }
        wzf(out, o, files.length, cdl, oe);
        cbd(null, out);
    };
    if (!lft) cbf();
    var _loop_1 = function(i) {
        var fn = k[i];
        var _a = r[fn], file = _a[0], p = _a[1];
        var c = crc(), size = file.length;
        c.p(file);
        var f = strToU8(fn), s = f.length;
        var com = p.comment, m = com && strToU8(com), ms = m && m.length;
        var exl = exfl(p.extra);
        var compression = p.level == 0 ? 0 : 8;
        var cbl = function(e, d) {
            if (e) {
                tAll();
                cbd(e, null);
            } else {
                var l = d.length;
                files[i] = mrg(p, {
                    size: size,
                    crc: c.d(),
                    c: d,
                    f: f,
                    m: m,
                    u: s != fn.length || m && com.length != ms,
                    compression: compression
                });
                o += 30 + s + exl + l;
                tot += 76 + 2 * (s + exl) + (ms || 0) + l;
                if (!--lft) cbf();
            }
        };
        if (s > 65535) cbl(err(11, 0, 1), null);
        if (!compression) cbl(null, file);
        else if (size < 160000) try {
            cbl(null, deflateSync(file, p));
        } catch (e) {
            cbl(e, null);
        }
        else term.push(deflate(file, p, cbl));
    };
    // Cannot use lft because it can decrease
    for(var i = 0; i < slft; ++i)_loop_1(i);
    return tAll;
}
function zipSync(data, opts) {
    if (!opts) opts = {};
    var r = {};
    var files = [];
    fltn(data, '', r, opts);
    var o = 0;
    var tot = 0;
    for(var fn in r){
        var _a = r[fn], file = _a[0], p = _a[1];
        var compression = p.level == 0 ? 0 : 8;
        var f = strToU8(fn), s = f.length;
        var com = p.comment, m = com && strToU8(com), ms = m && m.length;
        var exl = exfl(p.extra);
        if (s > 65535) err(11);
        var d = compression ? deflateSync(file, p) : file, l = d.length;
        var c = crc();
        c.p(file);
        files.push(mrg(p, {
            size: file.length,
            crc: c.d(),
            c: d,
            f: f,
            m: m,
            u: s != fn.length || m && com.length != ms,
            o: o,
            compression: compression
        }));
        o += 30 + s + exl + l;
        tot += 76 + 2 * (s + exl) + (ms || 0) + l;
    }
    var out = new u8(tot + 22), oe = o, cdl = tot - o;
    for(var i = 0; i < files.length; ++i){
        var f = files[i];
        wzh(out, f.o, f, f.f, f.u, f.c.length);
        var badd = 30 + f.f.length + exfl(f.extra);
        out.set(f.c, f.o + badd);
        wzh(out, o, f, f.f, f.u, f.c.length, f.o, f.m), o += 16 + badd + (f.m ? f.m.length : 0);
    }
    wzf(out, o, files.length, cdl, oe);
    return out;
}
/**
 * Streaming pass-through decompression for ZIP archives
 */ var UnzipPassThrough = /*#__PURE__*/ function() {
    function UnzipPassThrough() {}
    UnzipPassThrough.prototype.push = function(data, final) {
        this.ondata(null, data, final);
    };
    UnzipPassThrough.compression = 0;
    return UnzipPassThrough;
}();
/**
 * Streaming DEFLATE decompression for ZIP archives. Prefer AsyncZipInflate for
 * better performance.
 */ var UnzipInflate = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function UnzipInflate() {
        var _this = this;
        this.i = new Inflate(function(dat, final) {
            _this.ondata(null, dat, final);
        });
    }
    UnzipInflate.prototype.push = function(data, final) {
        try {
            this.i.push(data, final);
        } catch (e) {
            this.ondata(e, null, final);
        }
    };
    UnzipInflate.compression = 8;
    return UnzipInflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression for ZIP archives
 */ var AsyncUnzipInflate = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function AsyncUnzipInflate(_, sz) {
        var _this = this;
        if (sz < 320000) this.i = new Inflate(function(dat, final) {
            _this.ondata(null, dat, final);
        });
        else {
            this.i = new AsyncInflate(function(err, dat, final) {
                _this.ondata(err, dat, final);
            });
            this.terminate = this.i.terminate;
        }
    }
    AsyncUnzipInflate.prototype.push = function(data, final) {
        if (this.i.terminate) data = slc(data, 0);
        this.i.push(data, final);
    };
    AsyncUnzipInflate.compression = 8;
    return AsyncUnzipInflate;
}();
/**
 * A ZIP archive decompression stream that emits files as they are discovered
 */ var Unzip = /*#__PURE__*/ function() {
    /**
     * Creates a ZIP decompression stream
     * @param cb The callback to call whenever a file in the ZIP archive is found
     */ function Unzip(cb) {
        this.onfile = cb;
        this.k = [];
        this.o = {
            0: UnzipPassThrough
        };
        this.p = et;
    }
    /**
     * Pushes a chunk to be unzipped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzip.prototype.push = function(chunk, final) {
        var _this = this;
        if (!this.onfile) err(5);
        if (!this.p) err(4);
        if (this.c > 0) {
            var len = Math.min(this.c, chunk.length);
            var toAdd = chunk.subarray(0, len);
            this.c -= len;
            if (this.d) this.d.push(toAdd, !this.c);
            else this.k[0].push(toAdd);
            chunk = chunk.subarray(len);
            if (chunk.length) return this.push(chunk, final);
        } else {
            var f = 0, i = 0, is = void 0, buf = void 0;
            if (!this.p.length) buf = chunk;
            else if (!chunk.length) buf = this.p;
            else {
                buf = new u8(this.p.length + chunk.length);
                buf.set(this.p), buf.set(chunk, this.p.length);
            }
            var l = buf.length, oc = this.c, add = oc && this.d;
            var _loop_2 = function() {
                var _a;
                var sig = b4(buf, i);
                if (sig == 0x4034B50) {
                    f = 1, is = i;
                    this_1.d = null;
                    this_1.c = 0;
                    var bf = b2(buf, i + 6), cmp_1 = b2(buf, i + 8), u = bf & 2048, dd = bf & 8, fnl = b2(buf, i + 26), es = b2(buf, i + 28);
                    if (l > i + 30 + fnl + es) {
                        var chks_3 = [];
                        this_1.k.unshift(chks_3);
                        f = 2;
                        var sc_1 = b4(buf, i + 18), su_1 = b4(buf, i + 22);
                        var fn_1 = strFromU8(buf.subarray(i + 30, i += 30 + fnl), !u);
                        if (sc_1 == 4294967295) _a = dd ? [
                            -2
                        ] : z64e(buf, i), sc_1 = _a[0], su_1 = _a[1];
                        else if (dd) sc_1 = -1;
                        i += es;
                        this_1.c = sc_1;
                        var d_1;
                        var file_1 = {
                            name: fn_1,
                            compression: cmp_1,
                            start: function() {
                                if (!file_1.ondata) err(5);
                                if (!sc_1) file_1.ondata(null, et, true);
                                else {
                                    var ctr = _this.o[cmp_1];
                                    if (!ctr) file_1.ondata(err(14, 'unknown compression type ' + cmp_1, 1), null, false);
                                    d_1 = sc_1 < 0 ? new ctr(fn_1) : new ctr(fn_1, sc_1, su_1);
                                    d_1.ondata = function(err, dat, final) {
                                        file_1.ondata(err, dat, final);
                                    };
                                    for(var _i = 0, chks_4 = chks_3; _i < chks_4.length; _i++){
                                        var dat = chks_4[_i];
                                        d_1.push(dat, false);
                                    }
                                    if (_this.k[0] == chks_3 && _this.c) _this.d = d_1;
                                    else d_1.push(et, true);
                                }
                            },
                            terminate: function() {
                                if (d_1 && d_1.terminate) d_1.terminate();
                            }
                        };
                        if (sc_1 >= 0) file_1.size = sc_1, file_1.originalSize = su_1;
                        this_1.onfile(file_1);
                    }
                    return "break";
                } else if (oc) {
                    if (sig == 0x8074B50) {
                        is = i += 12 + (oc == -2 && 8), f = 3, this_1.c = 0;
                        return "break";
                    } else if (sig == 0x2014B50) {
                        is = i -= 4, f = 3, this_1.c = 0;
                        return "break";
                    }
                }
            };
            var this_1 = this;
            for(; i < l - 4; ++i){
                var state_1 = _loop_2();
                if (state_1 === "break") break;
            }
            this.p = et;
            if (oc < 0) {
                var dat = f ? buf.subarray(0, is - 12 - (oc == -2 && 8) - (b4(buf, is - 16) == 0x8074B50 && 4)) : buf.subarray(0, i);
                if (add) add.push(dat, !!f);
                else this.k[+(f == 2)].push(dat);
            }
            if (f & 2) return this.push(buf.subarray(i), final);
            this.p = buf.subarray(i);
        }
        if (final) {
            if (this.c) err(13);
            this.p = null;
        }
    };
    /**
     * Registers a decoder with the stream, allowing for files compressed with
     * the compression type provided to be expanded correctly
     * @param decoder The decoder constructor
     */ Unzip.prototype.register = function(decoder) {
        this.o[decoder.compression] = decoder;
    };
    return Unzip;
}();
var mt = typeof queueMicrotask == 'function' ? queueMicrotask : typeof setTimeout == 'function' ? setTimeout : function(fn) {
    fn();
};
function unzip(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') err(7);
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var files = {};
    var cbd = function(a, b) {
        mt(function() {
            cb(a, b);
        });
    };
    mt(function() {
        cbd = cb;
    });
    var e = data.length - 22;
    for(; b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) {
        cbd(err(13, 0, 1), null);
        return tAll;
    }
    var lft = b2(data, e + 8);
    if (lft) {
        var c = lft;
        var o = b4(data, e + 16);
        var z = o == 4294967295 || c == 65535;
        if (z) {
            var ze = b4(data, e - 12);
            z = b4(data, ze) == 0x6064B50;
            if (z) {
                c = lft = b4(data, ze + 32);
                o = b4(data, ze + 48);
            }
        }
        var fltr = opts && opts.filter;
        var _loop_3 = function(i) {
            var _a = zh(data, o, z), c_1 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = slzh(data, off);
            o = no;
            var cbl = function(e, d) {
                if (e) {
                    tAll();
                    cbd(e, null);
                } else {
                    if (d) files[fn] = d;
                    if (!--lft) cbd(null, files);
                }
            };
            if (!fltr || fltr({
                name: fn,
                size: sc,
                originalSize: su,
                compression: c_1
            })) {
                if (!c_1) cbl(null, slc(data, b, b + sc));
                else if (c_1 == 8) {
                    var infl = data.subarray(b, b + sc);
                    // Synchronously decompress under 512KB, or barely-compressed data
                    if (su < 524288 || sc > 0.8 * su) try {
                        cbl(null, inflateSync(infl, {
                            out: new u8(su)
                        }));
                    } catch (e) {
                        cbl(e, null);
                    }
                    else term.push(inflate(infl, {
                        size: su
                    }, cbl));
                } else cbl(err(14, 'unknown compression type ' + c_1, 1), null);
            } else cbl(null, null);
        };
        for(var i = 0; i < c; ++i)_loop_3(i);
    } else cbd(null, {});
    return tAll;
}
function unzipSync(data, opts) {
    var files = {};
    var e = data.length - 22;
    for(; b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) err(13);
    var c = b2(data, e + 8);
    if (!c) return {};
    var o = b4(data, e + 16);
    var z = o == 4294967295 || c == 65535;
    if (z) {
        var ze = b4(data, e - 12);
        z = b4(data, ze) == 0x6064B50;
        if (z) {
            c = b4(data, ze + 32);
            o = b4(data, ze + 48);
        }
    }
    var fltr = opts && opts.filter;
    for(var i = 0; i < c; ++i){
        var _a = zh(data, o, z), c_2 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = slzh(data, off);
        o = no;
        if (!fltr || fltr({
            name: fn,
            size: sc,
            originalSize: su,
            compression: c_2
        })) {
            if (!c_2) files[fn] = slc(data, b, b + sc);
            else if (c_2 == 8) files[fn] = inflateSync(data.subarray(b, b + sc), {
                out: new u8(su)
            });
            else err(14, 'unknown compression type ' + c_2);
        }
    }
    return files;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7LO4p":[function(require,module,exports,__globalThis) {
var arrayWithHoles = require("a3af206dbd14b1b5");
var iterableToArrayLimit = require("c109e0e3b1a7ef05");
var unsupportedIterableToArray = require("6782568c4383bd49");
var nonIterableRest = require("1e06d43f4bd6e532");
function _slicedToArray(r, e) {
    return arrayWithHoles(r) || iterableToArrayLimit(r, e) || unsupportedIterableToArray(r, e) || nonIterableRest();
}
module.exports = _slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"a3af206dbd14b1b5":"6znqW","c109e0e3b1a7ef05":"gQFXy","6782568c4383bd49":"5B0sg","1e06d43f4bd6e532":"hOEhy"}],"6znqW":[function(require,module,exports,__globalThis) {
function _arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = _arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"gQFXy":[function(require,module,exports,__globalThis) {
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = _iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"5B0sg":[function(require,module,exports,__globalThis) {
var arrayLikeToArray = require("f8ccc0353f5f3746");
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? arrayLikeToArray(r, a) : void 0;
    }
}
module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"f8ccc0353f5f3746":"6pEMp"}],"6pEMp":[function(require,module,exports,__globalThis) {
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"hOEhy":[function(require,module,exports,__globalThis) {
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"j79NK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasPngSignature", ()=>(0, _signature.hasPngSignature));
parcelHelpers.export(exports, "convertIndexedToRgb", ()=>(0, _convertIndexedToRgb.convertIndexedToRgb));
parcelHelpers.export(exports, "decode", ()=>decodePng);
parcelHelpers.export(exports, "encode", ()=>encodePng);
parcelHelpers.export(exports, "decodeApng", ()=>decodeApng);
var _pngDecoder = require("./PngDecoder");
var _pngDecoderDefault = parcelHelpers.interopDefault(_pngDecoder);
var _pngEncoder = require("./PngEncoder");
var _pngEncoderDefault = parcelHelpers.interopDefault(_pngEncoder);
var _signature = require("./helpers/signature");
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);
var _convertIndexedToRgb = require("./convertIndexedToRgb");
function decodePng(data, options) {
    const decoder = new (0, _pngDecoderDefault.default)(data, options);
    return decoder.decode();
}
function encodePng(png, options) {
    const encoder = new (0, _pngEncoderDefault.default)(png, options);
    return encoder.encode();
}
function decodeApng(data, options) {
    const decoder = new (0, _pngDecoderDefault.default)(data, options);
    return decoder.decodeApng();
}

},{"./PngDecoder":"dPk4I","./PngEncoder":"iBYpz","./helpers/signature":"8dCHg","./types":"jqyHk","./convertIndexedToRgb":"g07w4","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dPk4I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _iobuffer = require("iobuffer");
var _pako = require("pako");
var _crc = require("./helpers/crc");
var _decodeInterlaceAdam7 = require("./helpers/decodeInterlaceAdam7");
var _decodeInterlaceNull = require("./helpers/decodeInterlaceNull");
var _signature = require("./helpers/signature");
var _text = require("./helpers/text");
var _internalTypes = require("./internalTypes");
class PngDecoder extends (0, _iobuffer.IOBuffer) {
    _checkCrc;
    _inflator;
    _png;
    _apng;
    _end;
    _hasPalette;
    _palette;
    _hasTransparency;
    _transparency;
    _compressionMethod;
    _filterMethod;
    _interlaceMethod;
    _colorType;
    _isAnimated;
    _numberOfFrames;
    _numberOfPlays;
    _frames;
    _writingDataChunks;
    constructor(data, options = {}){
        super(data);
        const { checkCrc = false } = options;
        this._checkCrc = checkCrc;
        this._inflator = new (0, _pako.Inflate)();
        this._png = {
            width: -1,
            height: -1,
            channels: -1,
            data: new Uint8Array(0),
            depth: 1,
            text: {}
        };
        this._apng = {
            width: -1,
            height: -1,
            channels: -1,
            depth: 1,
            numberOfFrames: 1,
            numberOfPlays: 0,
            text: {},
            frames: []
        };
        this._end = false;
        this._hasPalette = false;
        this._palette = [];
        this._hasTransparency = false;
        this._transparency = new Uint16Array(0);
        this._compressionMethod = (0, _internalTypes.CompressionMethod).UNKNOWN;
        this._filterMethod = (0, _internalTypes.FilterMethod).UNKNOWN;
        this._interlaceMethod = (0, _internalTypes.InterlaceMethod).UNKNOWN;
        this._colorType = (0, _internalTypes.ColorType).UNKNOWN;
        this._isAnimated = false;
        this._numberOfFrames = 1;
        this._numberOfPlays = 0;
        this._frames = [];
        this._writingDataChunks = false;
        // PNG is always big endian
        // https://www.w3.org/TR/PNG/#7Integers-and-byte-order
        this.setBigEndian();
    }
    decode() {
        (0, _signature.checkSignature)(this);
        while(!this._end){
            const length = this.readUint32();
            const type = this.readChars(4);
            this.decodeChunk(length, type);
        }
        this.decodeImage();
        return this._png;
    }
    decodeApng() {
        (0, _signature.checkSignature)(this);
        while(!this._end){
            const length = this.readUint32();
            const type = this.readChars(4);
            this.decodeApngChunk(length, type);
        }
        this.decodeApngImage();
        return this._apng;
    }
    // https://www.w3.org/TR/PNG/#5Chunk-layout
    decodeChunk(length, type) {
        const offset = this.offset;
        switch(type){
            // 11.2 Critical chunks
            case 'IHDR':
                this.decodeIHDR();
                break;
            case 'PLTE':
                this.decodePLTE(length);
                break;
            case 'IDAT':
                this.decodeIDAT(length);
                break;
            case 'IEND':
                this._end = true;
                break;
            // 11.3 Ancillary chunks
            case 'tRNS':
                this.decodetRNS(length);
                break;
            case 'iCCP':
                this.decodeiCCP(length);
                break;
            case 0, _text.textChunkName:
                (0, _text.decodetEXt)(this._png.text, this, length);
                break;
            case 'pHYs':
                this.decodepHYs();
                break;
            default:
                this.skip(length);
                break;
        }
        if (this.offset - offset !== length) throw new Error(`Length mismatch while decoding chunk ${type}`);
        if (this._checkCrc) (0, _crc.checkCrc)(this, length + 4, type);
        else this.skip(4);
    }
    decodeApngChunk(length, type) {
        const offset = this.offset;
        if (type !== 'fdAT' && type !== 'IDAT' && this._writingDataChunks) this.pushDataToFrame();
        switch(type){
            case 'acTL':
                this.decodeACTL();
                break;
            case 'fcTL':
                this.decodeFCTL();
                break;
            case 'fdAT':
                this.decodeFDAT(length);
                break;
            default:
                this.decodeChunk(length, type);
                this.offset = offset + length;
                break;
        }
        if (this.offset - offset !== length) throw new Error(`Length mismatch while decoding chunk ${type}`);
        if (this._checkCrc) (0, _crc.checkCrc)(this, length + 4, type);
        else this.skip(4);
    }
    // https://www.w3.org/TR/PNG/#11IHDR
    decodeIHDR() {
        const image = this._png;
        image.width = this.readUint32();
        image.height = this.readUint32();
        image.depth = checkBitDepth(this.readUint8());
        const colorType = this.readUint8();
        this._colorType = colorType;
        let channels;
        switch(colorType){
            case (0, _internalTypes.ColorType).GREYSCALE:
                channels = 1;
                break;
            case (0, _internalTypes.ColorType).TRUECOLOUR:
                channels = 3;
                break;
            case (0, _internalTypes.ColorType).INDEXED_COLOUR:
                channels = 1;
                break;
            case (0, _internalTypes.ColorType).GREYSCALE_ALPHA:
                channels = 2;
                break;
            case (0, _internalTypes.ColorType).TRUECOLOUR_ALPHA:
                channels = 4;
                break;
            // Kept for exhaustiveness.
            // eslint-disable-next-line unicorn/no-useless-switch-case
            case (0, _internalTypes.ColorType).UNKNOWN:
            default:
                throw new Error(`Unknown color type: ${colorType}`);
        }
        this._png.channels = channels;
        this._compressionMethod = this.readUint8();
        if (this._compressionMethod !== (0, _internalTypes.CompressionMethod).DEFLATE) throw new Error(`Unsupported compression method: ${this._compressionMethod}`);
        this._filterMethod = this.readUint8();
        this._interlaceMethod = this.readUint8();
    }
    decodeACTL() {
        this._numberOfFrames = this.readUint32();
        this._numberOfPlays = this.readUint32();
        this._isAnimated = true;
    }
    decodeFCTL() {
        const image = {
            sequenceNumber: this.readUint32(),
            width: this.readUint32(),
            height: this.readUint32(),
            xOffset: this.readUint32(),
            yOffset: this.readUint32(),
            delayNumber: this.readUint16(),
            delayDenominator: this.readUint16(),
            disposeOp: this.readUint8(),
            blendOp: this.readUint8(),
            data: new Uint8Array(0)
        };
        this._frames.push(image);
    }
    // https://www.w3.org/TR/PNG/#11PLTE
    decodePLTE(length) {
        if (length % 3 !== 0) throw new RangeError(`PLTE field length must be a multiple of 3. Got ${length}`);
        const l = length / 3;
        this._hasPalette = true;
        const palette = [];
        this._palette = palette;
        for(let i = 0; i < l; i++)palette.push([
            this.readUint8(),
            this.readUint8(),
            this.readUint8()
        ]);
    }
    // https://www.w3.org/TR/PNG/#11IDAT
    decodeIDAT(length) {
        this._writingDataChunks = true;
        const dataLength = length;
        const dataOffset = this.offset + this.byteOffset;
        this._inflator.push(new Uint8Array(this.buffer, dataOffset, dataLength));
        if (this._inflator.err) throw new Error(`Error while decompressing the data: ${this._inflator.err}`);
        this.skip(length);
    }
    decodeFDAT(length) {
        this._writingDataChunks = true;
        let dataLength = length;
        let dataOffset = this.offset + this.byteOffset;
        dataOffset += 4;
        dataLength -= 4;
        this._inflator.push(new Uint8Array(this.buffer, dataOffset, dataLength));
        if (this._inflator.err) throw new Error(`Error while decompressing the data: ${this._inflator.err}`);
        this.skip(length);
    }
    // https://www.w3.org/TR/PNG/#11tRNS
    decodetRNS(length) {
        switch(this._colorType){
            case (0, _internalTypes.ColorType).GREYSCALE:
            case (0, _internalTypes.ColorType).TRUECOLOUR:
                if (length % 2 !== 0) throw new RangeError(`tRNS chunk length must be a multiple of 2. Got ${length}`);
                if (length / 2 > this._png.width * this._png.height) throw new Error(`tRNS chunk contains more alpha values than there are pixels (${length / 2} vs ${this._png.width * this._png.height})`);
                this._hasTransparency = true;
                this._transparency = new Uint16Array(length / 2);
                for(let i = 0; i < length / 2; i++)this._transparency[i] = this.readUint16();
                break;
            case (0, _internalTypes.ColorType).INDEXED_COLOUR:
                {
                    if (length > this._palette.length) throw new Error(`tRNS chunk contains more alpha values than there are palette colors (${length} vs ${this._palette.length})`);
                    let i = 0;
                    for(; i < length; i++){
                        const alpha = this.readByte();
                        this._palette[i].push(alpha);
                    }
                    for(; i < this._palette.length; i++)this._palette[i].push(255);
                    break;
                }
            // Kept for exhaustiveness.
            /* eslint-disable unicorn/no-useless-switch-case */ case (0, _internalTypes.ColorType).UNKNOWN:
            case (0, _internalTypes.ColorType).GREYSCALE_ALPHA:
            case (0, _internalTypes.ColorType).TRUECOLOUR_ALPHA:
            default:
                throw new Error(`tRNS chunk is not supported for color type ${this._colorType}`);
        }
    }
    // https://www.w3.org/TR/PNG/#11iCCP
    decodeiCCP(length) {
        const name = (0, _text.readKeyword)(this);
        const compressionMethod = this.readUint8();
        if (compressionMethod !== (0, _internalTypes.CompressionMethod).DEFLATE) throw new Error(`Unsupported iCCP compression method: ${compressionMethod}`);
        const compressedProfile = this.readBytes(length - name.length - 2);
        this._png.iccEmbeddedProfile = {
            name,
            profile: (0, _pako.inflate)(compressedProfile)
        };
    }
    // https://www.w3.org/TR/PNG/#11pHYs
    decodepHYs() {
        const ppuX = this.readUint32();
        const ppuY = this.readUint32();
        const unitSpecifier = this.readByte();
        this._png.resolution = {
            x: ppuX,
            y: ppuY,
            unit: unitSpecifier
        };
    }
    decodeApngImage() {
        this._apng.width = this._png.width;
        this._apng.height = this._png.height;
        this._apng.channels = this._png.channels;
        this._apng.depth = this._png.depth;
        this._apng.numberOfFrames = this._numberOfFrames;
        this._apng.numberOfPlays = this._numberOfPlays;
        this._apng.text = this._png.text;
        this._apng.resolution = this._png.resolution;
        for(let i = 0; i < this._numberOfFrames; i++){
            const newFrame = {
                sequenceNumber: this._frames[i].sequenceNumber,
                delayNumber: this._frames[i].delayNumber,
                delayDenominator: this._frames[i].delayDenominator,
                data: this._apng.depth === 8 ? new Uint8Array(this._apng.width * this._apng.height * this._apng.channels) : new Uint16Array(this._apng.width * this._apng.height * this._apng.channels)
            };
            const frame = this._frames.at(i);
            if (frame) {
                frame.data = (0, _decodeInterlaceNull.decodeInterlaceNull)({
                    data: frame.data,
                    width: frame.width,
                    height: frame.height,
                    channels: this._apng.channels,
                    depth: this._apng.depth
                });
                if (this._hasPalette) this._apng.palette = this._palette;
                if (this._hasTransparency) this._apng.transparency = this._transparency;
                if (i === 0 || frame.xOffset === 0 && frame.yOffset === 0 && frame.width === this._png.width && frame.height === this._png.height) newFrame.data = frame.data;
                else {
                    const prevFrame = this._apng.frames.at(i - 1);
                    this.disposeFrame(frame, prevFrame, newFrame);
                    this.addFrameDataToCanvas(newFrame, frame);
                }
                this._apng.frames.push(newFrame);
            }
        }
        return this._apng;
    }
    disposeFrame(frame, prevFrame, imageFrame) {
        switch(frame.disposeOp){
            case (0, _internalTypes.DisposeOpType).NONE:
                break;
            case (0, _internalTypes.DisposeOpType).BACKGROUND:
                for(let row = 0; row < this._png.height; row++)for(let col = 0; col < this._png.width; col++){
                    const index = (row * frame.width + col) * this._png.channels;
                    for(let channel = 0; channel < this._png.channels; channel++)imageFrame.data[index + channel] = 0;
                }
                break;
            case (0, _internalTypes.DisposeOpType).PREVIOUS:
                imageFrame.data.set(prevFrame.data);
                break;
            default:
                throw new Error('Unknown disposeOp');
        }
    }
    addFrameDataToCanvas(imageFrame, frame) {
        const maxValue = 1 << this._png.depth;
        const calculatePixelIndices = (row, col)=>{
            const index = ((row + frame.yOffset) * this._png.width + frame.xOffset + col) * this._png.channels;
            const frameIndex = (row * frame.width + col) * this._png.channels;
            return {
                index,
                frameIndex
            };
        };
        switch(frame.blendOp){
            case (0, _internalTypes.BlendOpType).SOURCE:
                for(let row = 0; row < frame.height; row++)for(let col = 0; col < frame.width; col++){
                    const { index, frameIndex } = calculatePixelIndices(row, col);
                    for(let channel = 0; channel < this._png.channels; channel++)imageFrame.data[index + channel] = frame.data[frameIndex + channel];
                }
                break;
            // https://www.w3.org/TR/png-3/#13Alpha-channel-processing
            case (0, _internalTypes.BlendOpType).OVER:
                for(let row = 0; row < frame.height; row++)for(let col = 0; col < frame.width; col++){
                    const { index, frameIndex } = calculatePixelIndices(row, col);
                    for(let channel = 0; channel < this._png.channels; channel++){
                        const sourceAlpha = frame.data[frameIndex + this._png.channels - 1] / maxValue;
                        const foregroundValue = channel % (this._png.channels - 1) === 0 ? 1 : frame.data[frameIndex + channel];
                        const value = Math.floor(sourceAlpha * foregroundValue + (1 - sourceAlpha) * imageFrame.data[index + channel]);
                        imageFrame.data[index + channel] += value;
                    }
                }
                break;
            default:
                throw new Error('Unknown blendOp');
        }
    }
    decodeImage() {
        if (this._inflator.err) throw new Error(`Error while decompressing the data: ${this._inflator.err}`);
        const data = this._isAnimated ? (this._frames?.at(0)).data : this._inflator.result;
        if (this._filterMethod !== (0, _internalTypes.FilterMethod).ADAPTIVE) throw new Error(`Filter method ${this._filterMethod} not supported`);
        if (this._interlaceMethod === (0, _internalTypes.InterlaceMethod).NO_INTERLACE) this._png.data = (0, _decodeInterlaceNull.decodeInterlaceNull)({
            data: data,
            width: this._png.width,
            height: this._png.height,
            channels: this._png.channels,
            depth: this._png.depth
        });
        else if (this._interlaceMethod === (0, _internalTypes.InterlaceMethod).ADAM7) this._png.data = (0, _decodeInterlaceAdam7.decodeInterlaceAdam7)({
            data: data,
            width: this._png.width,
            height: this._png.height,
            channels: this._png.channels,
            depth: this._png.depth
        });
        else throw new Error(`Interlace method ${this._interlaceMethod} not supported`);
        if (this._hasPalette) this._png.palette = this._palette;
        if (this._hasTransparency) this._png.transparency = this._transparency;
    }
    pushDataToFrame() {
        const result = this._inflator.result;
        const lastFrame = this._frames.at(-1);
        if (lastFrame) lastFrame.data = result;
        else this._frames.push({
            sequenceNumber: 0,
            width: this._png.width,
            height: this._png.height,
            xOffset: 0,
            yOffset: 0,
            delayNumber: 0,
            delayDenominator: 0,
            disposeOp: (0, _internalTypes.DisposeOpType).NONE,
            blendOp: (0, _internalTypes.BlendOpType).SOURCE,
            data: result
        });
        this._inflator = new (0, _pako.Inflate)();
        this._writingDataChunks = false;
    }
}
exports.default = PngDecoder;
function checkBitDepth(value) {
    if (value !== 1 && value !== 2 && value !== 4 && value !== 8 && value !== 16) throw new Error(`invalid bit depth: ${value}`);
    return value;
}

},{"iobuffer":"eCbjH","pako":"8ETxB","./helpers/crc":"lMHUJ","./helpers/decodeInterlaceAdam7":"ieqRH","./helpers/decodeInterlaceNull":"3cgMk","./helpers/signature":"8dCHg","./helpers/text":"g232d","./internalTypes":"i8ZBt","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eCbjH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IOBuffer", ()=>IOBuffer);
var _text = require("./text");
const defaultByteLength = 8192;
const hostBigEndian = (()=>{
    const array = new Uint8Array(4);
    const view = new Uint32Array(array.buffer);
    return !((view[0] = 1) & array[0]);
})();
const typedArrays = {
    int8: globalThis.Int8Array,
    uint8: globalThis.Uint8Array,
    int16: globalThis.Int16Array,
    uint16: globalThis.Uint16Array,
    int32: globalThis.Int32Array,
    uint32: globalThis.Uint32Array,
    uint64: globalThis.BigUint64Array,
    int64: globalThis.BigInt64Array,
    float32: globalThis.Float32Array,
    float64: globalThis.Float64Array
};
class IOBuffer {
    /**
     * Reference to the internal ArrayBuffer object.
     */ buffer;
    /**
     * Byte length of the internal ArrayBuffer.
     */ byteLength;
    /**
     * Byte offset of the internal ArrayBuffer.
     */ byteOffset;
    /**
     * Byte length of the internal ArrayBuffer.
     */ length;
    /**
     * The current offset of the buffer's pointer.
     */ offset;
    lastWrittenByte;
    littleEndian;
    _data;
    _mark;
    _marks;
    /**
     * Create a new IOBuffer.
     * @param data - The data to construct the IOBuffer with.
     * If data is a number, it will be the new buffer's length<br>
     * If data is `undefined`, the buffer will be initialized with a default length of 8Kb<br>
     * If data is an ArrayBuffer, SharedArrayBuffer, an ArrayBufferView (Typed Array), an IOBuffer instance,
     * or a Node.js Buffer, a view will be created over the underlying ArrayBuffer.
     * @param options - An object for the options.
     * @returns A new IOBuffer instance.
     */ constructor(data = defaultByteLength, options = {}){
        let dataIsGiven = false;
        if (typeof data === 'number') data = new ArrayBuffer(data);
        else {
            dataIsGiven = true;
            this.lastWrittenByte = data.byteLength;
        }
        const offset = options.offset ? options.offset >>> 0 : 0;
        const byteLength = data.byteLength - offset;
        let dvOffset = offset;
        if (ArrayBuffer.isView(data) || data instanceof IOBuffer) {
            if (data.byteLength !== data.buffer.byteLength) dvOffset = data.byteOffset + offset;
            data = data.buffer;
        }
        if (dataIsGiven) this.lastWrittenByte = byteLength;
        else this.lastWrittenByte = 0;
        this.buffer = data;
        this.length = byteLength;
        this.byteLength = byteLength;
        this.byteOffset = dvOffset;
        this.offset = 0;
        this.littleEndian = true;
        this._data = new DataView(this.buffer, dvOffset, byteLength);
        this._mark = 0;
        this._marks = [];
    }
    /**
     * Checks if the memory allocated to the buffer is sufficient to store more
     * bytes after the offset.
     * @param byteLength - The needed memory in bytes.
     * @returns `true` if there is sufficient space and `false` otherwise.
     */ available(byteLength = 1) {
        return this.offset + byteLength <= this.length;
    }
    /**
     * Check if little-endian mode is used for reading and writing multi-byte
     * values.
     * @returns `true` if little-endian mode is used, `false` otherwise.
     */ isLittleEndian() {
        return this.littleEndian;
    }
    /**
     * Set little-endian mode for reading and writing multi-byte values.
     * @returns This.
     */ setLittleEndian() {
        this.littleEndian = true;
        return this;
    }
    /**
     * Check if big-endian mode is used for reading and writing multi-byte values.
     * @returns `true` if big-endian mode is used, `false` otherwise.
     */ isBigEndian() {
        return !this.littleEndian;
    }
    /**
     * Switches to big-endian mode for reading and writing multi-byte values.
     * @returns This.
     */ setBigEndian() {
        this.littleEndian = false;
        return this;
    }
    /**
     * Move the pointer n bytes forward.
     * @param n - Number of bytes to skip.
     * @returns This.
     */ skip(n = 1) {
        this.offset += n;
        return this;
    }
    /**
     * Move the pointer n bytes backward.
     * @param n - Number of bytes to move back.
     * @returns This.
     */ back(n = 1) {
        this.offset -= n;
        return this;
    }
    /**
     * Move the pointer to the given offset.
     * @param offset - The offset to move to.
     * @returns This.
     */ seek(offset) {
        this.offset = offset;
        return this;
    }
    /**
     * Store the current pointer offset.
     * @see {@link IOBuffer#reset}
     * @returns This.
     */ mark() {
        this._mark = this.offset;
        return this;
    }
    /**
     * Move the pointer back to the last pointer offset set by mark.
     * @see {@link IOBuffer#mark}
     * @returns This.
     */ reset() {
        this.offset = this._mark;
        return this;
    }
    /**
     * Push the current pointer offset to the mark stack.
     * @see {@link IOBuffer#popMark}
     * @returns This.
     */ pushMark() {
        this._marks.push(this.offset);
        return this;
    }
    /**
     * Pop the last pointer offset from the mark stack, and set the current
     * pointer offset to the popped value.
     * @see {@link IOBuffer#pushMark}
     * @returns This.
     */ popMark() {
        const offset = this._marks.pop();
        if (offset === undefined) throw new Error('Mark stack empty');
        this.seek(offset);
        return this;
    }
    /**
     * Move the pointer offset back to 0.
     * @returns This.
     */ rewind() {
        this.offset = 0;
        return this;
    }
    /**
     * Make sure the buffer has sufficient memory to write a given byteLength at
     * the current pointer offset.
     * If the buffer's memory is insufficient, this method will create a new
     * buffer (a copy) with a length that is twice (byteLength + current offset).
     * @param byteLength - The needed memory in bytes.
     * @returns This.
     */ ensureAvailable(byteLength = 1) {
        if (!this.available(byteLength)) {
            const lengthNeeded = this.offset + byteLength;
            const newLength = lengthNeeded * 2;
            const newArray = new Uint8Array(newLength);
            newArray.set(new Uint8Array(this.buffer));
            this.buffer = newArray.buffer;
            this.length = newLength;
            this.byteLength = newLength;
            this._data = new DataView(this.buffer);
        }
        return this;
    }
    /**
     * Read a byte and return false if the byte's value is 0, or true otherwise.
     * Moves pointer forward by one byte.
     * @returns The read boolean.
     */ readBoolean() {
        return this.readUint8() !== 0;
    }
    /**
     * Read a signed 8-bit integer and move pointer forward by 1 byte.
     * @returns The read byte.
     */ readInt8() {
        return this._data.getInt8(this.offset++);
    }
    /**
     * Read an unsigned 8-bit integer and move pointer forward by 1 byte.
     * @returns The read byte.
     */ readUint8() {
        return this._data.getUint8(this.offset++);
    }
    /**
     * Alias for {@link IOBuffer#readUint8}.
     * @returns The read byte.
     */ readByte() {
        return this.readUint8();
    }
    /**
     * Read `n` bytes and move pointer forward by `n` bytes.
     * @param n - Number of bytes to read.
     * @returns The read bytes.
     */ readBytes(n = 1) {
        return this.readArray(n, 'uint8');
    }
    /**
     * Creates an array of corresponding to the type `type` and size `size`.
     * For example type `uint8` will create a `Uint8Array`.
     * @param size - size of the resulting array
     * @param type - number type of elements to read
     * @returns The read array.
     */ readArray(size, type) {
        const bytes = typedArrays[type].BYTES_PER_ELEMENT * size;
        const offset = this.byteOffset + this.offset;
        const slice = this.buffer.slice(offset, offset + bytes);
        if (this.littleEndian === hostBigEndian && type !== 'uint8' && type !== 'int8') {
            const slice = new Uint8Array(this.buffer.slice(offset, offset + bytes));
            slice.reverse();
            const returnArray = new typedArrays[type](slice.buffer);
            this.offset += bytes;
            returnArray.reverse();
            return returnArray;
        }
        const returnArray = new typedArrays[type](slice);
        this.offset += bytes;
        return returnArray;
    }
    /**
     * Read a 16-bit signed integer and move pointer forward by 2 bytes.
     * @returns The read value.
     */ readInt16() {
        const value = this._data.getInt16(this.offset, this.littleEndian);
        this.offset += 2;
        return value;
    }
    /**
     * Read a 16-bit unsigned integer and move pointer forward by 2 bytes.
     * @returns The read value.
     */ readUint16() {
        const value = this._data.getUint16(this.offset, this.littleEndian);
        this.offset += 2;
        return value;
    }
    /**
     * Read a 32-bit signed integer and move pointer forward by 4 bytes.
     * @returns The read value.
     */ readInt32() {
        const value = this._data.getInt32(this.offset, this.littleEndian);
        this.offset += 4;
        return value;
    }
    /**
     * Read a 32-bit unsigned integer and move pointer forward by 4 bytes.
     * @returns The read value.
     */ readUint32() {
        const value = this._data.getUint32(this.offset, this.littleEndian);
        this.offset += 4;
        return value;
    }
    /**
     * Read a 32-bit floating number and move pointer forward by 4 bytes.
     * @returns The read value.
     */ readFloat32() {
        const value = this._data.getFloat32(this.offset, this.littleEndian);
        this.offset += 4;
        return value;
    }
    /**
     * Read a 64-bit floating number and move pointer forward by 8 bytes.
     * @returns The read value.
     */ readFloat64() {
        const value = this._data.getFloat64(this.offset, this.littleEndian);
        this.offset += 8;
        return value;
    }
    /**
     * Read a 64-bit signed integer number and move pointer forward by 8 bytes.
     * @returns The read value.
     */ readBigInt64() {
        const value = this._data.getBigInt64(this.offset, this.littleEndian);
        this.offset += 8;
        return value;
    }
    /**
     * Read a 64-bit unsigned integer number and move pointer forward by 8 bytes.
     * @returns The read value.
     */ readBigUint64() {
        const value = this._data.getBigUint64(this.offset, this.littleEndian);
        this.offset += 8;
        return value;
    }
    /**
     * Read a 1-byte ASCII character and move pointer forward by 1 byte.
     * @returns The read character.
     */ readChar() {
        // eslint-disable-next-line unicorn/prefer-code-point
        return String.fromCharCode(this.readInt8());
    }
    /**
     * Read `n` 1-byte ASCII characters and move pointer forward by `n` bytes.
     * @param n - Number of characters to read.
     * @returns The read characters.
     */ readChars(n = 1) {
        let result = '';
        for(let i = 0; i < n; i++)result += this.readChar();
        return result;
    }
    /**
     * Read the next `n` bytes, return a UTF-8 decoded string and move pointer
     * forward by `n` bytes.
     * @param n - Number of bytes to read.
     * @returns The decoded string.
     */ readUtf8(n = 1) {
        return (0, _text.decode)(this.readBytes(n));
    }
    /**
     * Read the next `n` bytes, return a string decoded with `encoding` and move pointer
     * forward by `n` bytes.
     * If no encoding is passed, the function is equivalent to @see {@link IOBuffer#readUtf8}
     * @param n - Number of bytes to read.
     * @param encoding - The encoding to use. Default is 'utf8'.
     * @returns The decoded string.
     */ decodeText(n = 1, encoding = 'utf8') {
        return (0, _text.decode)(this.readBytes(n), encoding);
    }
    /**
     * Write 0xff if the passed value is truthy, 0x00 otherwise and move pointer
     * forward by 1 byte.
     * @param value - The value to write.
     * @returns This.
     */ writeBoolean(value) {
        this.writeUint8(value ? 0xff : 0x00);
        return this;
    }
    /**
     * Write `value` as an 8-bit signed integer and move pointer forward by 1 byte.
     * @param value - The value to write.
     * @returns This.
     */ writeInt8(value) {
        this.ensureAvailable(1);
        this._data.setInt8(this.offset++, value);
        this._updateLastWrittenByte();
        return this;
    }
    /**
     * Write `value` as an 8-bit unsigned integer and move pointer forward by 1
     * byte.
     * @param value - The value to write.
     * @returns This.
     */ writeUint8(value) {
        this.ensureAvailable(1);
        this._data.setUint8(this.offset++, value);
        this._updateLastWrittenByte();
        return this;
    }
    /**
     * An alias for {@link IOBuffer#writeUint8}.
     * @param value - The value to write.
     * @returns This.
     */ writeByte(value) {
        return this.writeUint8(value);
    }
    /**
     * Write all elements of `bytes` as uint8 values and move pointer forward by
     * `bytes.length` bytes.
     * @param bytes - The array of bytes to write.
     * @returns This.
     */ writeBytes(bytes) {
        this.ensureAvailable(bytes.length);
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(let i = 0; i < bytes.length; i++)this._data.setUint8(this.offset++, bytes[i]);
        this._updateLastWrittenByte();
        return this;
    }
    /**
     * Write `value` as a 16-bit signed integer and move pointer forward by 2
     * bytes.
     * @param value - The value to write.
     * @returns This.
     */ writeInt16(value) {
        this.ensureAvailable(2);
        this._data.setInt16(this.offset, value, this.littleEndian);
        this.offset += 2;
        this._updateLastWrittenByte();
        return this;
    }
    /**
     * Write `value` as a 16-bit unsigned integer and move pointer forward by 2
     * bytes.
     * @param value - The value to write.
     * @returns This.
     */ writeUint16(value) {
        this.ensureAvailable(2);
        this._data.setUint16(this.offset, value, this.littleEndian);
        this.offset += 2;
        this._updateLastWrittenByte();
        return this;
    }
    /**
     * Write `value` as a 32-bit signed integer and move pointer forward by 4
     * bytes.
     * @param value - The value to write.
     * @returns This.
     */ writeInt32(value) {
        this.ensureAvailable(4);
        this._data.setInt32(this.offset, value, this.littleEndian);
        this.offset += 4;
        this._updateLastWrittenByte();
        return this;
    }
    /**
     * Write `value` as a 32-bit unsigned integer and move pointer forward by 4
     * bytes.
     * @param value - The value to write.
     * @returns This.
     */ writeUint32(value) {
        this.ensureAvailable(4);
        this._data.setUint32(this.offset, value, this.littleEndian);
        this.offset += 4;
        this._updateLastWrittenByte();
        return this;
    }
    /**
     * Write `value` as a 32-bit floating number and move pointer forward by 4
     * bytes.
     * @param value - The value to write.
     * @returns This.
     */ writeFloat32(value) {
        this.ensureAvailable(4);
        this._data.setFloat32(this.offset, value, this.littleEndian);
        this.offset += 4;
        this._updateLastWrittenByte();
        return this;
    }
    /**
     * Write `value` as a 64-bit floating number and move pointer forward by 8
     * bytes.
     * @param value - The value to write.
     * @returns This.
     */ writeFloat64(value) {
        this.ensureAvailable(8);
        this._data.setFloat64(this.offset, value, this.littleEndian);
        this.offset += 8;
        this._updateLastWrittenByte();
        return this;
    }
    /**
     * Write `value` as a 64-bit signed bigint and move pointer forward by 8
     * bytes.
     * @param value - The value to write.
     * @returns This.
     */ writeBigInt64(value) {
        this.ensureAvailable(8);
        this._data.setBigInt64(this.offset, value, this.littleEndian);
        this.offset += 8;
        this._updateLastWrittenByte();
        return this;
    }
    /**
     * Write `value` as a 64-bit unsigned bigint and move pointer forward by 8
     * bytes.
     * @param value - The value to write.
     * @returns This.
     */ writeBigUint64(value) {
        this.ensureAvailable(8);
        this._data.setBigUint64(this.offset, value, this.littleEndian);
        this.offset += 8;
        this._updateLastWrittenByte();
        return this;
    }
    /**
     * Write the charCode of `str`'s first character as an 8-bit unsigned integer
     * and move pointer forward by 1 byte.
     * @param str - The character to write.
     * @returns This.
     */ writeChar(str) {
        // eslint-disable-next-line unicorn/prefer-code-point
        return this.writeUint8(str.charCodeAt(0));
    }
    /**
     * Write the charCodes of all `str`'s characters as 8-bit unsigned integers
     * and move pointer forward by `str.length` bytes.
     * @param str - The characters to write.
     * @returns This.
     */ writeChars(str) {
        for(let i = 0; i < str.length; i++)// eslint-disable-next-line unicorn/prefer-code-point
        this.writeUint8(str.charCodeAt(i));
        return this;
    }
    /**
     * UTF-8 encode and write `str` to the current pointer offset and move pointer
     * forward according to the encoded length.
     * @param str - The string to write.
     * @returns This.
     */ writeUtf8(str) {
        return this.writeBytes((0, _text.encode)(str));
    }
    /**
     * Export a Uint8Array view of the internal buffer.
     * The view starts at the byte offset and its length
     * is calculated to stop at the last written byte or the original length.
     * @returns A new Uint8Array view.
     */ toArray() {
        return new Uint8Array(this.buffer, this.byteOffset, this.lastWrittenByte);
    }
    /**
     *  Get the total number of bytes written so far, regardless of the current offset.
     * @returns - Total number of bytes.
     */ getWrittenByteLength() {
        return this.lastWrittenByte - this.byteOffset;
    }
    /**
     * Update the last written byte offset
     * @private
     */ _updateLastWrittenByte() {
        if (this.offset > this.lastWrittenByte) this.lastWrittenByte = this.offset;
    }
}

},{"./text":"42XV7","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"42XV7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "decode", ()=>decode);
parcelHelpers.export(exports, "encode", ()=>encode);
function decode(bytes, encoding = 'utf8') {
    const decoder = new TextDecoder(encoding);
    return decoder.decode(bytes);
}
const encoder = new TextEncoder();
function encode(str) {
    return encoder.encode(str);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8ETxB":[function(require,module,exports,__globalThis) {
/*! pako 2.1.0 https://github.com/nodeca/pako @license (MIT AND Zlib) */ // (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
/* eslint-disable space-unary-ops */ /* Public constants ==========================================================*/ /* ===========================================================================*/ //const Z_FILTERED          = 1;
//const Z_HUFFMAN_ONLY      = 2;
//const Z_RLE               = 3;
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Deflate", ()=>Deflate_1);
parcelHelpers.export(exports, "Inflate", ()=>Inflate_1);
parcelHelpers.export(exports, "constants", ()=>constants_1);
parcelHelpers.export(exports, "default", ()=>pako);
parcelHelpers.export(exports, "deflate", ()=>deflate_1);
parcelHelpers.export(exports, "deflateRaw", ()=>deflateRaw_1);
parcelHelpers.export(exports, "gzip", ()=>gzip_1);
parcelHelpers.export(exports, "inflate", ()=>inflate_1);
parcelHelpers.export(exports, "inflateRaw", ()=>inflateRaw_1);
parcelHelpers.export(exports, "ungzip", ()=>ungzip_1);
const Z_FIXED$1 = 4;
//const Z_DEFAULT_STRATEGY  = 0;
/* Possible values of the data_type field (though see inflate()) */ const Z_BINARY = 0;
const Z_TEXT = 1;
//const Z_ASCII             = 1; // = Z_TEXT
const Z_UNKNOWN$1 = 2;
/*============================================================================*/ function zero$1(buf) {
    let len = buf.length;
    while(--len >= 0)buf[len] = 0;
}
// From zutil.h
const STORED_BLOCK = 0;
const STATIC_TREES = 1;
const DYN_TREES = 2;
/* The three kinds of block type */ const MIN_MATCH$1 = 3;
const MAX_MATCH$1 = 258;
/* The minimum and maximum match lengths */ // From deflate.h
/* ===========================================================================
 * Internal compression state.
 */ const LENGTH_CODES$1 = 29;
/* number of length codes, not counting the special END_BLOCK code */ const LITERALS$1 = 256;
/* number of literal bytes 0..255 */ const L_CODES$1 = LITERALS$1 + 1 + LENGTH_CODES$1;
/* number of Literal or Length codes, including the END_BLOCK code */ const D_CODES$1 = 30;
/* number of distance codes */ const BL_CODES$1 = 19;
/* number of codes used to transfer the bit lengths */ const HEAP_SIZE$1 = 2 * L_CODES$1 + 1;
/* maximum heap size */ const MAX_BITS$1 = 15;
/* All codes must not exceed MAX_BITS bits */ const Buf_size = 16;
/* size of bit buffer in bi_buf */ /* ===========================================================================
 * Constants
 */ const MAX_BL_BITS = 7;
/* Bit length codes must not exceed MAX_BL_BITS bits */ const END_BLOCK = 256;
/* end of block literal code */ const REP_3_6 = 16;
/* repeat previous bit length 3-6 times (2 bits of repeat count) */ const REPZ_3_10 = 17;
/* repeat a zero length 3-10 times  (3 bits of repeat count) */ const REPZ_11_138 = 18;
/* repeat a zero length 11-138 times  (7 bits of repeat count) */ /* eslint-disable comma-spacing,array-bracket-spacing */ const extra_lbits = /* extra bits for each length code */ new Uint8Array([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0
]);
const extra_dbits = /* extra bits for each distance code */ new Uint8Array([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13
]);
const extra_blbits = /* extra bits for each bit length code */ new Uint8Array([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    7
]);
const bl_order = new Uint8Array([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
/* eslint-enable comma-spacing,array-bracket-spacing */ /* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */ /* ===========================================================================
 * Local data. These are initialized only once.
 */ // We pre-fill arrays with 0 to avoid uninitialized gaps
const DIST_CODE_LEN = 512; /* see definition of array dist_code below */ 
// !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
const static_ltree = new Array((L_CODES$1 + 2) * 2);
zero$1(static_ltree);
/* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */ const static_dtree = new Array(D_CODES$1 * 2);
zero$1(static_dtree);
/* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */ const _dist_code = new Array(DIST_CODE_LEN);
zero$1(_dist_code);
/* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */ const _length_code = new Array(MAX_MATCH$1 - MIN_MATCH$1 + 1);
zero$1(_length_code);
/* length code for each normalized match length (0 == MIN_MATCH) */ const base_length = new Array(LENGTH_CODES$1);
zero$1(base_length);
/* First normalized length for each code (0 = MIN_MATCH) */ const base_dist = new Array(D_CODES$1);
zero$1(base_dist);
/* First normalized distance for each code (0 = distance of 1) */ function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
    this.static_tree = static_tree; /* static tree or NULL */ 
    this.extra_bits = extra_bits; /* extra bits for each code or NULL */ 
    this.extra_base = extra_base; /* base index for extra_bits */ 
    this.elems = elems; /* max number of elements in the tree */ 
    this.max_length = max_length; /* max bit length for the codes */ 
    // show if `static_tree` has data or dummy - needed for monomorphic objects
    this.has_stree = static_tree && static_tree.length;
}
let static_l_desc;
let static_d_desc;
let static_bl_desc;
function TreeDesc(dyn_tree, stat_desc) {
    this.dyn_tree = dyn_tree; /* the dynamic tree */ 
    this.max_code = 0; /* largest code with non zero frequency */ 
    this.stat_desc = stat_desc; /* the corresponding static tree */ 
}
const d_code = (dist)=>{
    return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
};
/* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */ const put_short = (s, w)=>{
    //    put_byte(s, (uch)((w) & 0xff));
    //    put_byte(s, (uch)((ush)(w) >> 8));
    s.pending_buf[s.pending++] = w & 0xff;
    s.pending_buf[s.pending++] = w >>> 8 & 0xff;
};
/* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */ const send_bits = (s, value, length)=>{
    if (s.bi_valid > Buf_size - length) {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        put_short(s, s.bi_buf);
        s.bi_buf = value >> Buf_size - s.bi_valid;
        s.bi_valid += length - Buf_size;
    } else {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        s.bi_valid += length;
    }
};
const send_code = (s, c, tree)=>{
    send_bits(s, tree[c * 2], tree[c * 2 + 1]);
};
/* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */ const bi_reverse = (code, len)=>{
    let res = 0;
    do {
        res |= code & 1;
        code >>>= 1;
        res <<= 1;
    }while (--len > 0);
    return res >>> 1;
};
/* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */ const bi_flush = (s)=>{
    if (s.bi_valid === 16) {
        put_short(s, s.bi_buf);
        s.bi_buf = 0;
        s.bi_valid = 0;
    } else if (s.bi_valid >= 8) {
        s.pending_buf[s.pending++] = s.bi_buf & 0xff;
        s.bi_buf >>= 8;
        s.bi_valid -= 8;
    }
};
/* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */ const gen_bitlen = (s, desc)=>{
    //    deflate_state *s;
    //    tree_desc *desc;    /* the tree descriptor */
    const tree = desc.dyn_tree;
    const max_code = desc.max_code;
    const stree = desc.stat_desc.static_tree;
    const has_stree = desc.stat_desc.has_stree;
    const extra = desc.stat_desc.extra_bits;
    const base = desc.stat_desc.extra_base;
    const max_length = desc.stat_desc.max_length;
    let h; /* heap index */ 
    let n, m; /* iterate over the tree elements */ 
    let bits; /* bit length */ 
    let xbits; /* extra bits */ 
    let f; /* frequency */ 
    let overflow = 0; /* number of elements with bit length too large */ 
    for(bits = 0; bits <= MAX_BITS$1; bits++)s.bl_count[bits] = 0;
    /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */ tree[s.heap[s.heap_max] * 2 + 1] = 0; /* root of the heap */ 
    for(h = s.heap_max + 1; h < HEAP_SIZE$1; h++){
        n = s.heap[h];
        bits = tree[tree[n * 2 + 1] * 2 + 1] + 1;
        if (bits > max_length) {
            bits = max_length;
            overflow++;
        }
        tree[n * 2 + 1] = bits;
        /* We overwrite tree[n].Dad which is no longer needed */ if (n > max_code) continue;
         /* not a leaf node */ 
        s.bl_count[bits]++;
        xbits = 0;
        if (n >= base) xbits = extra[n - base];
        f = tree[n * 2] /*.Freq*/ ;
        s.opt_len += f * (bits + xbits);
        if (has_stree) s.static_len += f * (stree[n * 2 + 1] + xbits);
    }
    if (overflow === 0) return;
    // Tracev((stderr,"\nbit length overflow\n"));
    /* This happens for example on obj2 and pic of the Calgary corpus */ /* Find the first bit length which could increase: */ do {
        bits = max_length - 1;
        while(s.bl_count[bits] === 0)bits--;
        s.bl_count[bits]--; /* move one leaf down the tree */ 
        s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */ 
        s.bl_count[max_length]--;
        /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */ overflow -= 2;
    }while (overflow > 0);
    /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */ for(bits = max_length; bits !== 0; bits--){
        n = s.bl_count[bits];
        while(n !== 0){
            m = s.heap[--h];
            if (m > max_code) continue;
            if (tree[m * 2 + 1] !== bits) {
                // Tracev((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
                s.opt_len += (bits - tree[m * 2 + 1]) * tree[m * 2] /*.Freq*/ ;
                tree[m * 2 + 1] = bits;
            }
            n--;
        }
    }
};
/* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */ const gen_codes = (tree, max_code, bl_count)=>{
    //    ct_data *tree;             /* the tree to decorate */
    //    int max_code;              /* largest code with non zero frequency */
    //    ushf *bl_count;            /* number of codes at each bit length */
    const next_code = new Array(MAX_BITS$1 + 1); /* next code value for each bit length */ 
    let code = 0; /* running code value */ 
    let bits; /* bit index */ 
    let n; /* code index */ 
    /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */ for(bits = 1; bits <= MAX_BITS$1; bits++){
        code = code + bl_count[bits - 1] << 1;
        next_code[bits] = code;
    }
    /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */ //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
    //        "inconsistent bit counts");
    //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
    for(n = 0; n <= max_code; n++){
        let len = tree[n * 2 + 1] /*.Len*/ ;
        if (len === 0) continue;
        /* Now reverse the bits */ tree[n * 2] = bi_reverse(next_code[len]++, len);
    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
    }
};
/* ===========================================================================
 * Initialize the various 'constant' tables.
 */ const tr_static_init = ()=>{
    let n; /* iterates over tree elements */ 
    let bits; /* bit counter */ 
    let length; /* length value */ 
    let code; /* code value */ 
    let dist; /* distance index */ 
    const bl_count = new Array(MAX_BITS$1 + 1);
    /* number of codes at each bit length for an optimal tree */ // do check in _tr_init()
    //if (static_init_done) return;
    /* For some embedded targets, global variables are not initialized: */ /*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/ /* Initialize the mapping length (0..255) -> length code (0..28) */ length = 0;
    for(code = 0; code < LENGTH_CODES$1 - 1; code++){
        base_length[code] = length;
        for(n = 0; n < 1 << extra_lbits[code]; n++)_length_code[length++] = code;
    }
    //Assert (length == 256, "tr_static_init: length != 256");
    /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */ _length_code[length - 1] = code;
    /* Initialize the mapping dist (0..32K) -> dist code (0..29) */ dist = 0;
    for(code = 0; code < 16; code++){
        base_dist[code] = dist;
        for(n = 0; n < 1 << extra_dbits[code]; n++)_dist_code[dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: dist != 256");
    dist >>= 7; /* from now on, all distances are divided by 128 */ 
    for(; code < D_CODES$1; code++){
        base_dist[code] = dist << 7;
        for(n = 0; n < 1 << extra_dbits[code] - 7; n++)_dist_code[256 + dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: 256+dist != 512");
    /* Construct the codes of the static literal tree */ for(bits = 0; bits <= MAX_BITS$1; bits++)bl_count[bits] = 0;
    n = 0;
    while(n <= 143){
        static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    while(n <= 255){
        static_ltree[n * 2 + 1] = 9;
        n++;
        bl_count[9]++;
    }
    while(n <= 279){
        static_ltree[n * 2 + 1] = 7;
        n++;
        bl_count[7]++;
    }
    while(n <= 287){
        static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */ gen_codes(static_ltree, L_CODES$1 + 1, bl_count);
    /* The static distance tree is trivial: */ for(n = 0; n < D_CODES$1; n++){
        static_dtree[n * 2 + 1] = 5;
        static_dtree[n * 2] = bi_reverse(n, 5);
    }
    // Now data ready and we can init static trees
    static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS$1 + 1, L_CODES$1, MAX_BITS$1);
    static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0, D_CODES$1, MAX_BITS$1);
    static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0, BL_CODES$1, MAX_BL_BITS);
//static_init_done = true;
};
/* ===========================================================================
 * Initialize a new block.
 */ const init_block = (s)=>{
    let n; /* iterates over tree elements */ 
    /* Initialize the trees. */ for(n = 0; n < L_CODES$1; n++)s.dyn_ltree[n * 2] = 0;
    for(n = 0; n < D_CODES$1; n++)s.dyn_dtree[n * 2] = 0;
    for(n = 0; n < BL_CODES$1; n++)s.bl_tree[n * 2] = 0;
    s.dyn_ltree[END_BLOCK * 2] = 1;
    s.opt_len = s.static_len = 0;
    s.sym_next = s.matches = 0;
};
/* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */ const bi_windup = (s)=>{
    if (s.bi_valid > 8) put_short(s, s.bi_buf);
    else if (s.bi_valid > 0) //put_byte(s, (Byte)s->bi_buf);
    s.pending_buf[s.pending++] = s.bi_buf;
    s.bi_buf = 0;
    s.bi_valid = 0;
};
/* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */ const smaller = (tree, n, m, depth)=>{
    const _n2 = n * 2;
    const _m2 = m * 2;
    return tree[_n2] < tree[_m2] || tree[_n2] === tree[_m2] && depth[n] <= depth[m];
};
/* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */ const pqdownheap = (s, tree, k)=>{
    //    deflate_state *s;
    //    ct_data *tree;  /* the tree to restore */
    //    int k;               /* node to move down */
    const v = s.heap[k];
    let j = k << 1; /* left son of k */ 
    while(j <= s.heap_len){
        /* Set j to the smallest of the two sons: */ if (j < s.heap_len && smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) j++;
        /* Exit if v is smaller than both sons */ if (smaller(tree, v, s.heap[j], s.depth)) break;
        /* Exchange v with the smallest son */ s.heap[k] = s.heap[j];
        k = j;
        /* And continue down the tree, setting j to the left son of k */ j <<= 1;
    }
    s.heap[k] = v;
};
// inlined manually
// const SMALLEST = 1;
/* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */ const compress_block = (s, ltree, dtree)=>{
    //    deflate_state *s;
    //    const ct_data *ltree; /* literal tree */
    //    const ct_data *dtree; /* distance tree */
    let dist; /* distance of matched string */ 
    let lc; /* match length or unmatched char (if dist == 0) */ 
    let sx = 0; /* running index in sym_buf */ 
    let code; /* the code to send */ 
    let extra; /* number of extra bits to send */ 
    if (s.sym_next !== 0) do {
        dist = s.pending_buf[s.sym_buf + sx++] & 0xff;
        dist += (s.pending_buf[s.sym_buf + sx++] & 0xff) << 8;
        lc = s.pending_buf[s.sym_buf + sx++];
        if (dist === 0) send_code(s, lc, ltree); /* send a literal byte */ 
        else {
            /* Here, lc is the match length - MIN_MATCH */ code = _length_code[lc];
            send_code(s, code + LITERALS$1 + 1, ltree); /* send the length code */ 
            extra = extra_lbits[code];
            if (extra !== 0) {
                lc -= base_length[code];
                send_bits(s, lc, extra); /* send the extra length bits */ 
            }
            dist--; /* dist is now the match distance - 1 */ 
            code = d_code(dist);
            //Assert (code < D_CODES, "bad d_code");
            send_code(s, code, dtree); /* send the distance code */ 
            extra = extra_dbits[code];
            if (extra !== 0) {
                dist -= base_dist[code];
                send_bits(s, dist, extra); /* send the extra distance bits */ 
            }
        } /* literal or match pair ? */ 
    /* Check that the overlay between pending_buf and sym_buf is ok: */ //Assert(s->pending < s->lit_bufsize + sx, "pendingBuf overflow");
    }while (sx < s.sym_next);
    send_code(s, END_BLOCK, ltree);
};
/* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */ const build_tree = (s, desc)=>{
    //    deflate_state *s;
    //    tree_desc *desc; /* the tree descriptor */
    const tree = desc.dyn_tree;
    const stree = desc.stat_desc.static_tree;
    const has_stree = desc.stat_desc.has_stree;
    const elems = desc.stat_desc.elems;
    let n, m; /* iterate over heap elements */ 
    let max_code = -1; /* largest code with non zero frequency */ 
    let node; /* new node being created */ 
    /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */ s.heap_len = 0;
    s.heap_max = HEAP_SIZE$1;
    for(n = 0; n < elems; n++)if (tree[n * 2] !== 0) {
        s.heap[++s.heap_len] = max_code = n;
        s.depth[n] = 0;
    } else tree[n * 2 + 1] = 0;
    /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */ while(s.heap_len < 2){
        node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
        tree[node * 2] = 1;
        s.depth[node] = 0;
        s.opt_len--;
        if (has_stree) s.static_len -= stree[node * 2 + 1] /*.Len*/ ;
    /* node is 0 or 1 so it does not have extra bits */ }
    desc.max_code = max_code;
    /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */ for(n = s.heap_len >> 1 /*int /2*/ ; n >= 1; n--)pqdownheap(s, tree, n);
    /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */ node = elems; /* next internal node of the tree */ 
    do {
        //pqremove(s, tree, n);  /* n = node of least frequency */
        /*** pqremove ***/ n = s.heap[1 /*SMALLEST*/ ];
        s.heap[1 /*SMALLEST*/ ] = s.heap[s.heap_len--];
        pqdownheap(s, tree, 1 /*SMALLEST*/ );
        /***/ m = s.heap[1 /*SMALLEST*/ ]; /* m = node of next least frequency */ 
        s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */ 
        s.heap[--s.heap_max] = m;
        /* Create a new node father of n and m */ tree[node * 2] = tree[n * 2] + tree[m * 2] /*.Freq*/ ;
        s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
        tree[n * 2 + 1] = tree[m * 2 + 1] = node;
        /* and insert the new node in the heap */ s.heap[1 /*SMALLEST*/ ] = node++;
        pqdownheap(s, tree, 1 /*SMALLEST*/ );
    }while (s.heap_len >= 2);
    s.heap[--s.heap_max] = s.heap[1 /*SMALLEST*/ ];
    /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */ gen_bitlen(s, desc);
    /* The field len is now set, we can generate the bit codes */ gen_codes(tree, max_code, s.bl_count);
};
/* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */ const scan_tree = (s, tree, max_code)=>{
    //    deflate_state *s;
    //    ct_data *tree;   /* the tree to be scanned */
    //    int max_code;    /* and its largest code of non zero frequency */
    let n; /* iterates over all tree elements */ 
    let prevlen = -1; /* last emitted length */ 
    let curlen; /* length of current code */ 
    let nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    let count = 0; /* repeat count of the current code */ 
    let max_count = 7; /* max repeat count */ 
    let min_count = 4; /* min repeat count */ 
    if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    tree[(max_code + 1) * 2 + 1] = 0xffff; /* guard */ 
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) s.bl_tree[curlen * 2] += count;
        else if (curlen !== 0) {
            if (curlen !== prevlen) s.bl_tree[curlen * 2]++;
            s.bl_tree[REP_3_6 * 2]++;
        } else if (count <= 10) s.bl_tree[REPZ_3_10 * 2]++;
        else s.bl_tree[REPZ_11_138 * 2]++;
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
};
/* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */ const send_tree = (s, tree, max_code)=>{
    //    deflate_state *s;
    //    ct_data *tree; /* the tree to be scanned */
    //    int max_code;       /* and its largest code of non zero frequency */
    let n; /* iterates over all tree elements */ 
    let prevlen = -1; /* last emitted length */ 
    let curlen; /* length of current code */ 
    let nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    let count = 0; /* repeat count of the current code */ 
    let max_count = 7; /* max repeat count */ 
    let min_count = 4; /* min repeat count */ 
    /* tree[max_code+1].Len = -1; */ /* guard already set */ if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) do send_code(s, curlen, s.bl_tree);
        while (--count !== 0);
        else if (curlen !== 0) {
            if (curlen !== prevlen) {
                send_code(s, curlen, s.bl_tree);
                count--;
            }
            //Assert(count >= 3 && count <= 6, " 3_6?");
            send_code(s, REP_3_6, s.bl_tree);
            send_bits(s, count - 3, 2);
        } else if (count <= 10) {
            send_code(s, REPZ_3_10, s.bl_tree);
            send_bits(s, count - 3, 3);
        } else {
            send_code(s, REPZ_11_138, s.bl_tree);
            send_bits(s, count - 11, 7);
        }
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
};
/* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */ const build_bl_tree = (s)=>{
    let max_blindex; /* index of last bit length code of non zero freq */ 
    /* Determine the bit length frequencies for literal and distance trees */ scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
    scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
    /* Build the bit length tree: */ build_tree(s, s.bl_desc);
    /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */ /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */ for(max_blindex = BL_CODES$1 - 1; max_blindex >= 3; max_blindex--){
        if (s.bl_tree[bl_order[max_blindex] * 2 + 1] !== 0) break;
    }
    /* Update opt_len to include the bit length tree and counts */ s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
    //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
    //        s->opt_len, s->static_len));
    return max_blindex;
};
/* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */ const send_all_trees = (s, lcodes, dcodes, blcodes)=>{
    //    deflate_state *s;
    //    int lcodes, dcodes, blcodes; /* number of codes for each tree */
    let rank; /* index in bl_order */ 
    //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
    //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
    //        "too many codes");
    //Tracev((stderr, "\nbl counts: "));
    send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */ 
    send_bits(s, dcodes - 1, 5);
    send_bits(s, blcodes - 4, 4); /* not -3 as stated in appnote.txt */ 
    for(rank = 0; rank < blcodes; rank++)//Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
    send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1], 3);
    //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
    send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */ 
    //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
    send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */ 
//Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
};
/* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "block list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "allow list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */ const detect_data_type = (s)=>{
    /* block_mask is the bit mask of block-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */ let block_mask = 0xf3ffc07f;
    let n;
    /* Check for non-textual ("block-listed") bytes. */ for(n = 0; n <= 31; n++, block_mask >>>= 1){
        if (block_mask & 1 && s.dyn_ltree[n * 2] !== 0) return Z_BINARY;
    }
    /* Check for textual ("allow-listed") bytes. */ if (s.dyn_ltree[18] !== 0 || s.dyn_ltree[20] !== 0 || s.dyn_ltree[26] !== 0) return Z_TEXT;
    for(n = 32; n < LITERALS$1; n++){
        if (s.dyn_ltree[n * 2] !== 0) return Z_TEXT;
    }
    /* There are no "block-listed" or "allow-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */ return Z_BINARY;
};
let static_init_done = false;
/* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */ const _tr_init$1 = (s)=>{
    if (!static_init_done) {
        tr_static_init();
        static_init_done = true;
    }
    s.l_desc = new TreeDesc(s.dyn_ltree, static_l_desc);
    s.d_desc = new TreeDesc(s.dyn_dtree, static_d_desc);
    s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);
    s.bi_buf = 0;
    s.bi_valid = 0;
    /* Initialize the first block of the first file: */ init_block(s);
};
/* ===========================================================================
 * Send a stored block
 */ const _tr_stored_block$1 = (s, buf, stored_len, last)=>{
    //DeflateState *s;
    //charf *buf;       /* input block */
    //ulg stored_len;   /* length of input block */
    //int last;         /* one if this is the last block for a file */
    send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3); /* send block type */ 
    bi_windup(s); /* align on byte boundary */ 
    put_short(s, stored_len);
    put_short(s, ~stored_len);
    if (stored_len) s.pending_buf.set(s.window.subarray(buf, buf + stored_len), s.pending);
    s.pending += stored_len;
};
/* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */ const _tr_align$1 = (s)=>{
    send_bits(s, STATIC_TREES << 1, 3);
    send_code(s, END_BLOCK, static_ltree);
    bi_flush(s);
};
/* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and write out the encoded block.
 */ const _tr_flush_block$1 = (s, buf, stored_len, last)=>{
    //DeflateState *s;
    //charf *buf;       /* input block, or NULL if too old */
    //ulg stored_len;   /* length of input block */
    //int last;         /* one if this is the last block for a file */
    let opt_lenb, static_lenb; /* opt_len and static_len in bytes */ 
    let max_blindex = 0; /* index of last bit length code of non zero freq */ 
    /* Build the Huffman trees unless a stored block is forced */ if (s.level > 0) {
        /* Check if the file is binary or text */ if (s.strm.data_type === Z_UNKNOWN$1) s.strm.data_type = detect_data_type(s);
        /* Construct the literal and distance trees */ build_tree(s, s.l_desc);
        // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        build_tree(s, s.d_desc);
        // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */ /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */ max_blindex = build_bl_tree(s);
        /* Determine the best encoding. Compute the block lengths in bytes. */ opt_lenb = s.opt_len + 3 + 7 >>> 3;
        static_lenb = s.static_len + 3 + 7 >>> 3;
        // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
        //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
        //        s->sym_next / 3));
        if (static_lenb <= opt_lenb) opt_lenb = static_lenb;
    } else // Assert(buf != (char*)0, "lost buf");
    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */ 
    if (stored_len + 4 <= opt_lenb && buf !== -1) /* 4: two words for the lengths */ /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */ _tr_stored_block$1(s, buf, stored_len, last);
    else if (s.strategy === Z_FIXED$1 || static_lenb === opt_lenb) {
        send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
        compress_block(s, static_ltree, static_dtree);
    } else {
        send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
        send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
        compress_block(s, s.dyn_ltree, s.dyn_dtree);
    }
    // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
    /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */ init_block(s);
    if (last) bi_windup(s);
// Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
//       s->compressed_len-7*last));
};
/* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */ const _tr_tally$1 = (s, dist, lc)=>{
    //    deflate_state *s;
    //    unsigned dist;  /* distance of matched string */
    //    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
    s.pending_buf[s.sym_buf + s.sym_next++] = dist;
    s.pending_buf[s.sym_buf + s.sym_next++] = dist >> 8;
    s.pending_buf[s.sym_buf + s.sym_next++] = lc;
    if (dist === 0) /* lc is the unmatched char */ s.dyn_ltree[lc * 2]++;
    else {
        s.matches++;
        /* Here, lc is the match length - MIN_MATCH */ dist--; /* dist = match distance - 1 */ 
        //Assert((ush)dist < (ush)MAX_DIST(s) &&
        //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
        //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
        s.dyn_ltree[(_length_code[lc] + LITERALS$1 + 1) * 2]++;
        s.dyn_dtree[d_code(dist) * 2]++;
    }
    return s.sym_next === s.sym_end;
};
var _tr_init_1 = _tr_init$1;
var _tr_stored_block_1 = _tr_stored_block$1;
var _tr_flush_block_1 = _tr_flush_block$1;
var _tr_tally_1 = _tr_tally$1;
var _tr_align_1 = _tr_align$1;
var trees = {
    _tr_init: _tr_init_1,
    _tr_stored_block: _tr_stored_block_1,
    _tr_flush_block: _tr_flush_block_1,
    _tr_tally: _tr_tally_1,
    _tr_align: _tr_align_1
};
// Note: adler32 takes 12% for level 0 and 2% for level 6.
// It isn't worth it to make additional optimizations as in original.
// Small size is preferable.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
const adler32 = (adler, buf, len, pos)=>{
    let s1 = adler & 0xffff | 0, s2 = adler >>> 16 & 0xffff | 0, n = 0;
    while(len !== 0){
        // Set limit ~ twice less than 5552, to keep
        // s2 in 31-bits, because we force signed ints.
        // in other case %= will fail.
        n = len > 2000 ? 2000 : len;
        len -= n;
        do {
            s1 = s1 + buf[pos++] | 0;
            s2 = s2 + s1 | 0;
        }while (--n);
        s1 %= 65521;
        s2 %= 65521;
    }
    return s1 | s2 << 16 | 0;
};
var adler32_1 = adler32;
// Note: we can't get significant speed boost here.
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// Use ordinary array, since untyped makes no boost here
const makeTable = ()=>{
    let c, table = [];
    for(var n = 0; n < 256; n++){
        c = n;
        for(var k = 0; k < 8; k++)c = c & 1 ? 0xEDB88320 ^ c >>> 1 : c >>> 1;
        table[n] = c;
    }
    return table;
};
// Create table on load. Just 255 signed longs. Not a problem.
const crcTable = new Uint32Array(makeTable());
const crc32 = (crc, buf, len, pos)=>{
    const t = crcTable;
    const end = pos + len;
    crc ^= -1;
    for(let i = pos; i < end; i++)crc = crc >>> 8 ^ t[(crc ^ buf[i]) & 0xFF];
    return crc ^ -1; // >>> 0;
};
var crc32_1 = crc32;
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
var messages = {
    2: 'need dictionary',
    /* Z_NEED_DICT       2  */ 1: 'stream end',
    /* Z_STREAM_END      1  */ 0: '',
    /* Z_OK              0  */ '-1': 'file error',
    /* Z_ERRNO         (-1) */ '-2': 'stream error',
    /* Z_STREAM_ERROR  (-2) */ '-3': 'data error',
    /* Z_DATA_ERROR    (-3) */ '-4': 'insufficient memory',
    /* Z_MEM_ERROR     (-4) */ '-5': 'buffer error',
    /* Z_BUF_ERROR     (-5) */ '-6': 'incompatible version' /* Z_VERSION_ERROR (-6) */ 
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
var constants$2 = {
    /* Allowed flush values; see deflate() and inflate() below for details */ Z_NO_FLUSH: 0,
    Z_PARTIAL_FLUSH: 1,
    Z_SYNC_FLUSH: 2,
    Z_FULL_FLUSH: 3,
    Z_FINISH: 4,
    Z_BLOCK: 5,
    Z_TREES: 6,
    /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */ Z_OK: 0,
    Z_STREAM_END: 1,
    Z_NEED_DICT: 2,
    Z_ERRNO: -1,
    Z_STREAM_ERROR: -2,
    Z_DATA_ERROR: -3,
    Z_MEM_ERROR: -4,
    Z_BUF_ERROR: -5,
    //Z_VERSION_ERROR: -6,
    /* compression levels */ Z_NO_COMPRESSION: 0,
    Z_BEST_SPEED: 1,
    Z_BEST_COMPRESSION: 9,
    Z_DEFAULT_COMPRESSION: -1,
    Z_FILTERED: 1,
    Z_HUFFMAN_ONLY: 2,
    Z_RLE: 3,
    Z_FIXED: 4,
    Z_DEFAULT_STRATEGY: 0,
    /* Possible values of the data_type field (though see inflate()) */ Z_BINARY: 0,
    Z_TEXT: 1,
    //Z_ASCII:                1, // = Z_TEXT (deprecated)
    Z_UNKNOWN: 2,
    /* The deflate compression method */ Z_DEFLATED: 8
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
const { _tr_init, _tr_stored_block, _tr_flush_block, _tr_tally, _tr_align } = trees;
/* Public constants ==========================================================*/ /* ===========================================================================*/ const { Z_NO_FLUSH: Z_NO_FLUSH$2, Z_PARTIAL_FLUSH, Z_FULL_FLUSH: Z_FULL_FLUSH$1, Z_FINISH: Z_FINISH$3, Z_BLOCK: Z_BLOCK$1, Z_OK: Z_OK$3, Z_STREAM_END: Z_STREAM_END$3, Z_STREAM_ERROR: Z_STREAM_ERROR$2, Z_DATA_ERROR: Z_DATA_ERROR$2, Z_BUF_ERROR: Z_BUF_ERROR$1, Z_DEFAULT_COMPRESSION: Z_DEFAULT_COMPRESSION$1, Z_FILTERED, Z_HUFFMAN_ONLY, Z_RLE, Z_FIXED, Z_DEFAULT_STRATEGY: Z_DEFAULT_STRATEGY$1, Z_UNKNOWN, Z_DEFLATED: Z_DEFLATED$2 } = constants$2;
/*============================================================================*/ const MAX_MEM_LEVEL = 9;
/* Maximum value for memLevel in deflateInit2 */ const MAX_WBITS$1 = 15;
/* 32K LZ77 window */ const DEF_MEM_LEVEL = 8;
const LENGTH_CODES = 29;
/* number of length codes, not counting the special END_BLOCK code */ const LITERALS = 256;
/* number of literal bytes 0..255 */ const L_CODES = LITERALS + 1 + LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */ const D_CODES = 30;
/* number of distance codes */ const BL_CODES = 19;
/* number of codes used to transfer the bit lengths */ const HEAP_SIZE = 2 * L_CODES + 1;
/* maximum heap size */ const MAX_BITS = 15;
/* All codes must not exceed MAX_BITS bits */ const MIN_MATCH = 3;
const MAX_MATCH = 258;
const MIN_LOOKAHEAD = MAX_MATCH + MIN_MATCH + 1;
const PRESET_DICT = 0x20;
const INIT_STATE = 42; /* zlib header -> BUSY_STATE */ 
//#ifdef GZIP
const GZIP_STATE = 57; /* gzip header -> BUSY_STATE | EXTRA_STATE */ 
//#endif
const EXTRA_STATE = 69; /* gzip extra block -> NAME_STATE */ 
const NAME_STATE = 73; /* gzip file name -> COMMENT_STATE */ 
const COMMENT_STATE = 91; /* gzip comment -> HCRC_STATE */ 
const HCRC_STATE = 103; /* gzip header CRC -> BUSY_STATE */ 
const BUSY_STATE = 113; /* deflate -> FINISH_STATE */ 
const FINISH_STATE = 666; /* stream complete */ 
const BS_NEED_MORE = 1; /* block not completed, need more input or more output */ 
const BS_BLOCK_DONE = 2; /* block flush performed */ 
const BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */ 
const BS_FINISH_DONE = 4; /* finish done, accept no more input or output */ 
const OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
const err = (strm, errorCode)=>{
    strm.msg = messages[errorCode];
    return errorCode;
};
const rank = (f)=>{
    return f * 2 - (f > 4 ? 9 : 0);
};
const zero = (buf)=>{
    let len = buf.length;
    while(--len >= 0)buf[len] = 0;
};
/* ===========================================================================
 * Slide the hash table when sliding the window down (could be avoided with 32
 * bit values at the expense of memory usage). We slide even when level == 0 to
 * keep the hash table consistent if we switch back to level > 0 later.
 */ const slide_hash = (s)=>{
    let n, m;
    let p;
    let wsize = s.w_size;
    n = s.hash_size;
    p = n;
    do {
        m = s.head[--p];
        s.head[p] = m >= wsize ? m - wsize : 0;
    }while (--n);
    n = wsize;
    //#ifndef FASTEST
    p = n;
    do {
        m = s.prev[--p];
        s.prev[p] = m >= wsize ? m - wsize : 0;
    /* If n is not on any hash chain, prev[n] is garbage but
     * its value will never be used.
     */ }while (--n);
//#endif
};
/* eslint-disable new-cap */ let HASH_ZLIB = (s, prev, data)=>(prev << s.hash_shift ^ data) & s.hash_mask;
// This hash causes less collisions, https://github.com/nodeca/pako/issues/135
// But breaks binary compatibility
//let HASH_FAST = (s, prev, data) => ((prev << 8) + (prev >> 8) + (data << 4)) & s.hash_mask;
let HASH = HASH_ZLIB;
/* =========================================================================
 * Flush as much pending output as possible. All deflate() output, except for
 * some deflate_stored() output, goes through this function so some
 * applications may wish to modify it to avoid allocating a large
 * strm->next_out buffer and copying into it. (See also read_buf()).
 */ const flush_pending = (strm)=>{
    const s = strm.state;
    //_tr_flush_bits(s);
    let len = s.pending;
    if (len > strm.avail_out) len = strm.avail_out;
    if (len === 0) return;
    strm.output.set(s.pending_buf.subarray(s.pending_out, s.pending_out + len), strm.next_out);
    strm.next_out += len;
    s.pending_out += len;
    strm.total_out += len;
    strm.avail_out -= len;
    s.pending -= len;
    if (s.pending === 0) s.pending_out = 0;
};
const flush_block_only = (s, last)=>{
    _tr_flush_block(s, s.block_start >= 0 ? s.block_start : -1, s.strstart - s.block_start, last);
    s.block_start = s.strstart;
    flush_pending(s.strm);
};
const put_byte = (s, b)=>{
    s.pending_buf[s.pending++] = b;
};
/* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */ const putShortMSB = (s, b)=>{
    //  put_byte(s, (Byte)(b >> 8));
    //  put_byte(s, (Byte)(b & 0xff));
    s.pending_buf[s.pending++] = b >>> 8 & 0xff;
    s.pending_buf[s.pending++] = b & 0xff;
};
/* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */ const read_buf = (strm, buf, start, size)=>{
    let len = strm.avail_in;
    if (len > size) len = size;
    if (len === 0) return 0;
    strm.avail_in -= len;
    // zmemcpy(buf, strm->next_in, len);
    buf.set(strm.input.subarray(strm.next_in, strm.next_in + len), start);
    if (strm.state.wrap === 1) strm.adler = adler32_1(strm.adler, buf, len, start);
    else if (strm.state.wrap === 2) strm.adler = crc32_1(strm.adler, buf, len, start);
    strm.next_in += len;
    strm.total_in += len;
    return len;
};
/* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */ const longest_match = (s, cur_match)=>{
    let chain_length = s.max_chain_length; /* max hash chain length */ 
    let scan = s.strstart; /* current string */ 
    let match; /* matched string */ 
    let len; /* length of current match */ 
    let best_len = s.prev_length; /* best match length so far */ 
    let nice_match = s.nice_match; /* stop if match long enough */ 
    const limit = s.strstart > s.w_size - MIN_LOOKAHEAD ? s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0 /*NIL*/ ;
    const _win = s.window; // shortcut
    const wmask = s.w_mask;
    const prev = s.prev;
    /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */ const strend = s.strstart + MAX_MATCH;
    let scan_end1 = _win[scan + best_len - 1];
    let scan_end = _win[scan + best_len];
    /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */ // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
    /* Do not waste too much time if we already have a good match: */ if (s.prev_length >= s.good_match) chain_length >>= 2;
    /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */ if (nice_match > s.lookahead) nice_match = s.lookahead;
    // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
    do {
        // Assert(cur_match < s->strstart, "no future");
        match = cur_match;
        /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */ if (_win[match + best_len] !== scan_end || _win[match + best_len - 1] !== scan_end1 || _win[match] !== _win[scan] || _win[++match] !== _win[scan + 1]) continue;
        /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */ scan += 2;
        match++;
        // Assert(*scan == *match, "match[2]?");
        /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */ do ;
        while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && scan < strend);
        // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
        len = MAX_MATCH - (strend - scan);
        scan = strend - MAX_MATCH;
        if (len > best_len) {
            s.match_start = cur_match;
            best_len = len;
            if (len >= nice_match) break;
            scan_end1 = _win[scan + best_len - 1];
            scan_end = _win[scan + best_len];
        }
    }while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
    if (best_len <= s.lookahead) return best_len;
    return s.lookahead;
};
/* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */ const fill_window = (s)=>{
    const _w_size = s.w_size;
    let n, more, str;
    //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
    do {
        more = s.window_size - s.lookahead - s.strstart;
        // JS ints have 32 bit, block below not needed
        /* Deal with !@#$% 64K limit: */ //if (sizeof(int) <= 2) {
        //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
        //        more = wsize;
        //
        //  } else if (more == (unsigned)(-1)) {
        //        /* Very unlikely, but possible on 16 bit machine if
        //         * strstart == 0 && lookahead == 1 (input done a byte at time)
        //         */
        //        more--;
        //    }
        //}
        /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */ if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {
            s.window.set(s.window.subarray(_w_size, _w_size + _w_size - more), 0);
            s.match_start -= _w_size;
            s.strstart -= _w_size;
            /* we now have strstart >= MAX_DIST */ s.block_start -= _w_size;
            if (s.insert > s.strstart) s.insert = s.strstart;
            slide_hash(s);
            more += _w_size;
        }
        if (s.strm.avail_in === 0) break;
        /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */ //Assert(more >= 2, "more < 2");
        n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
        s.lookahead += n;
        /* Initialize the hash value now that we have some input: */ if (s.lookahead + s.insert >= MIN_MATCH) {
            str = s.strstart - s.insert;
            s.ins_h = s.window[str];
            /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */ s.ins_h = HASH(s, s.ins_h, s.window[str + 1]);
            //#if MIN_MATCH != 3
            //        Call update_hash() MIN_MATCH-3 more times
            //#endif
            while(s.insert){
                /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = HASH(s, s.ins_h, s.window[str + MIN_MATCH - 1]);
                s.prev[str & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = str;
                str++;
                s.insert--;
                if (s.lookahead + s.insert < MIN_MATCH) break;
            }
        }
    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */ }while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);
/* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */ //  if (s.high_water < s.window_size) {
//    const curr = s.strstart + s.lookahead;
//    let init = 0;
//
//    if (s.high_water < curr) {
//      /* Previous high water mark below current data -- zero WIN_INIT
//       * bytes or up to end of window, whichever is less.
//       */
//      init = s.window_size - curr;
//      if (init > WIN_INIT)
//        init = WIN_INIT;
//      zmemzero(s->window + curr, (unsigned)init);
//      s->high_water = curr + init;
//    }
//    else if (s->high_water < (ulg)curr + WIN_INIT) {
//      /* High water mark at or above current data, but below current data
//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
//       * to end of window, whichever is less.
//       */
//      init = (ulg)curr + WIN_INIT - s->high_water;
//      if (init > s->window_size - s->high_water)
//        init = s->window_size - s->high_water;
//      zmemzero(s->window + s->high_water, (unsigned)init);
//      s->high_water += init;
//    }
//  }
//
//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
//    "not enough room for search");
};
/* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 *
 * In case deflateParams() is used to later switch to a non-zero compression
 * level, s->matches (otherwise unused when storing) keeps track of the number
 * of hash table slides to perform. If s->matches is 1, then one hash table
 * slide will be done when switching. If s->matches is 2, the maximum value
 * allowed here, then the hash table will be cleared, since two or more slides
 * is the same as a clear.
 *
 * deflate_stored() is written to minimize the number of times an input byte is
 * copied. It is most efficient with large input and output buffers, which
 * maximizes the opportunites to have a single copy from next_in to next_out.
 */ const deflate_stored = (s, flush)=>{
    /* Smallest worthy block size when not flushing or finishing. By default
   * this is 32K. This can be as small as 507 bytes for memLevel == 1. For
   * large input and output buffers, the stored block size will be larger.
   */ let min_block = s.pending_buf_size - 5 > s.w_size ? s.w_size : s.pending_buf_size - 5;
    /* Copy as many min_block or larger stored blocks directly to next_out as
   * possible. If flushing, copy the remaining available input to next_out as
   * stored blocks, if there is enough space.
   */ let len, left, have, last = 0;
    let used = s.strm.avail_in;
    do {
        /* Set len to the maximum size block that we can copy directly with the
     * available input data and output space. Set left to how much of that
     * would be copied from what's left in the window.
     */ len = 65535 /* MAX_STORED */ ; /* maximum deflate stored block length */ 
        have = s.bi_valid + 42 >> 3; /* number of header bytes */ 
        if (s.strm.avail_out < have) break;
        /* maximum stored block length that will fit in avail_out: */ have = s.strm.avail_out - have;
        left = s.strstart - s.block_start; /* bytes left in window */ 
        if (len > left + s.strm.avail_in) len = left + s.strm.avail_in; /* limit len to the input */ 
        if (len > have) len = have; /* limit len to the output */ 
        /* If the stored block would be less than min_block in length, or if
     * unable to copy all of the available input when flushing, then try
     * copying to the window and the pending buffer instead. Also don't
     * write an empty block when flushing -- deflate() does that.
     */ if (len < min_block && (len === 0 && flush !== Z_FINISH$3 || flush === Z_NO_FLUSH$2 || len !== left + s.strm.avail_in)) break;
        /* Make a dummy stored block in pending to get the header bytes,
     * including any pending bits. This also updates the debugging counts.
     */ last = flush === Z_FINISH$3 && len === left + s.strm.avail_in ? 1 : 0;
        _tr_stored_block(s, 0, 0, last);
        /* Replace the lengths in the dummy stored block with len. */ s.pending_buf[s.pending - 4] = len;
        s.pending_buf[s.pending - 3] = len >> 8;
        s.pending_buf[s.pending - 2] = ~len;
        s.pending_buf[s.pending - 1] = ~len >> 8;
        /* Write the stored block header bytes. */ flush_pending(s.strm);
        //#ifdef ZLIB_DEBUG
        //    /* Update debugging counts for the data about to be copied. */
        //    s->compressed_len += len << 3;
        //    s->bits_sent += len << 3;
        //#endif
        /* Copy uncompressed bytes from the window to next_out. */ if (left) {
            if (left > len) left = len;
            //zmemcpy(s->strm->next_out, s->window + s->block_start, left);
            s.strm.output.set(s.window.subarray(s.block_start, s.block_start + left), s.strm.next_out);
            s.strm.next_out += left;
            s.strm.avail_out -= left;
            s.strm.total_out += left;
            s.block_start += left;
            len -= left;
        }
        /* Copy uncompressed bytes directly from next_in to next_out, updating
     * the check value.
     */ if (len) {
            read_buf(s.strm, s.strm.output, s.strm.next_out, len);
            s.strm.next_out += len;
            s.strm.avail_out -= len;
            s.strm.total_out += len;
        }
    }while (last === 0);
    /* Update the sliding window with the last s->w_size bytes of the copied
   * data, or append all of the copied data to the existing window if less
   * than s->w_size bytes were copied. Also update the number of bytes to
   * insert in the hash tables, in the event that deflateParams() switches to
   * a non-zero compression level.
   */ used -= s.strm.avail_in; /* number of input bytes directly copied */ 
    if (used) {
        /* If any input was used, then no unused input remains in the window,
     * therefore s->block_start == s->strstart.
     */ if (used >= s.w_size) {
            s.matches = 2; /* clear hash */ 
            //zmemcpy(s->window, s->strm->next_in - s->w_size, s->w_size);
            s.window.set(s.strm.input.subarray(s.strm.next_in - s.w_size, s.strm.next_in), 0);
            s.strstart = s.w_size;
            s.insert = s.strstart;
        } else {
            if (s.window_size - s.strstart <= used) {
                /* Slide the window down. */ s.strstart -= s.w_size;
                //zmemcpy(s->window, s->window + s->w_size, s->strstart);
                s.window.set(s.window.subarray(s.w_size, s.w_size + s.strstart), 0);
                if (s.matches < 2) s.matches++; /* add a pending slide_hash() */ 
                if (s.insert > s.strstart) s.insert = s.strstart;
            }
            //zmemcpy(s->window + s->strstart, s->strm->next_in - used, used);
            s.window.set(s.strm.input.subarray(s.strm.next_in - used, s.strm.next_in), s.strstart);
            s.strstart += used;
            s.insert += used > s.w_size - s.insert ? s.w_size - s.insert : used;
        }
        s.block_start = s.strstart;
    }
    if (s.high_water < s.strstart) s.high_water = s.strstart;
    /* If the last block was written to next_out, then done. */ if (last) return BS_FINISH_DONE;
    /* If flushing and all input has been consumed, then done. */ if (flush !== Z_NO_FLUSH$2 && flush !== Z_FINISH$3 && s.strm.avail_in === 0 && s.strstart === s.block_start) return BS_BLOCK_DONE;
    /* Fill the window with any remaining input. */ have = s.window_size - s.strstart;
    if (s.strm.avail_in > have && s.block_start >= s.w_size) {
        /* Slide the window down. */ s.block_start -= s.w_size;
        s.strstart -= s.w_size;
        //zmemcpy(s->window, s->window + s->w_size, s->strstart);
        s.window.set(s.window.subarray(s.w_size, s.w_size + s.strstart), 0);
        if (s.matches < 2) s.matches++; /* add a pending slide_hash() */ 
        have += s.w_size; /* more space now */ 
        if (s.insert > s.strstart) s.insert = s.strstart;
    }
    if (have > s.strm.avail_in) have = s.strm.avail_in;
    if (have) {
        read_buf(s.strm, s.window, s.strstart, have);
        s.strstart += have;
        s.insert += have > s.w_size - s.insert ? s.w_size - s.insert : have;
    }
    if (s.high_water < s.strstart) s.high_water = s.strstart;
    /* There was not enough avail_out to write a complete worthy or flushed
   * stored block to next_out. Write a stored block to pending instead, if we
   * have enough input for a worthy block, or if flushing and there is enough
   * room for the remaining input as a stored block in the pending buffer.
   */ have = s.bi_valid + 42 >> 3; /* number of header bytes */ 
    /* maximum stored block length that will fit in pending: */ have = s.pending_buf_size - have > 65535 /* MAX_STORED */  ? 65535 /* MAX_STORED */  : s.pending_buf_size - have;
    min_block = have > s.w_size ? s.w_size : have;
    left = s.strstart - s.block_start;
    if (left >= min_block || (left || flush === Z_FINISH$3) && flush !== Z_NO_FLUSH$2 && s.strm.avail_in === 0 && left <= have) {
        len = left > have ? have : left;
        last = flush === Z_FINISH$3 && s.strm.avail_in === 0 && len === left ? 1 : 0;
        _tr_stored_block(s, s.block_start, len, last);
        s.block_start += len;
        flush_pending(s.strm);
    }
    /* We've done all we can with the available input and output. */ return last ? BS_FINISH_STARTED : BS_NEED_MORE;
};
/* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */ const deflate_fast = (s, flush)=>{
    let hash_head; /* head of the hash chain */ 
    let bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < MIN_LOOKAHEAD) {
            fill_window(s);
            if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH$2) return BS_NEED_MORE;
            if (s.lookahead === 0) break; /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + MIN_MATCH - 1]);
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */ if (hash_head !== 0 /*NIL*/  && s.strstart - hash_head <= s.w_size - MIN_LOOKAHEAD) /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = longest_match(s, hash_head);
        if (s.match_length >= MIN_MATCH) {
            // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
            /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/ bflush = _tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);
            s.lookahead -= s.match_length;
            /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */ if (s.match_length <= s.max_lazy_match /*max_insert_length*/  && s.lookahead >= MIN_MATCH) {
                s.match_length--; /* string at strstart already in table */ 
                do {
                    s.strstart++;
                    /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + MIN_MATCH - 1]);
                    hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                    s.head[s.ins_h] = s.strstart;
                /***/ /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */ }while (--s.match_length !== 0);
                s.strstart++;
            } else {
                s.strstart += s.match_length;
                s.match_length = 0;
                s.ins_h = s.window[s.strstart];
                /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */ s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + 1]);
            //#if MIN_MATCH != 3
            //                Call UPDATE_HASH() MIN_MATCH-3 more times
            //#endif
            /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */ }
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s.window[s.strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = _tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
            if (s.strm.avail_out === 0) return BS_NEED_MORE;
        /***/ }
    }
    s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
    if (flush === Z_FINISH$3) {
        /*** FLUSH_BLOCK(s, 1); ***/ flush_block_only(s, true);
        if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
        /***/ return BS_FINISH_DONE;
    }
    if (s.sym_next) {
        /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
        if (s.strm.avail_out === 0) return BS_NEED_MORE;
    /***/ }
    return BS_BLOCK_DONE;
};
/* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */ const deflate_slow = (s, flush)=>{
    let hash_head; /* head of hash chain */ 
    let bflush; /* set if current block must be flushed */ 
    let max_insert;
    /* Process the input block. */ for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < MIN_LOOKAHEAD) {
            fill_window(s);
            if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH$2) return BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + MIN_MATCH - 1]);
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     */ s.prev_length = s.match_length;
        s.prev_match = s.match_start;
        s.match_length = MIN_MATCH - 1;
        if (hash_head !== 0 /*NIL*/  && s.prev_length < s.max_lazy_match && s.strstart - hash_head <= s.w_size - MIN_LOOKAHEAD) {
            /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = longest_match(s, hash_head);
            /* longest_match() sets match_start */ if (s.match_length <= 5 && (s.strategy === Z_FILTERED || s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096 /*TOO_FAR*/ )) /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */ s.match_length = MIN_MATCH - 1;
        }
        /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */ if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
            max_insert = s.strstart + s.lookahead - MIN_MATCH;
            /* Do not insert strings in hash table beyond this. */ //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
            /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/ bflush = _tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH);
            /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */ s.lookahead -= s.prev_length - 1;
            s.prev_length -= 2;
            do if (++s.strstart <= max_insert) {
                /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + MIN_MATCH - 1]);
                hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = s.strstart;
            /***/ }
            while (--s.prev_length !== 0);
            s.match_available = 0;
            s.match_length = MIN_MATCH - 1;
            s.strstart++;
            if (bflush) {
                /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
                if (s.strm.avail_out === 0) return BS_NEED_MORE;
            /***/ }
        } else if (s.match_available) {
            /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */ //Tracevv((stderr,"%c", s->window[s->strstart-1]));
            /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = _tr_tally(s, 0, s.window[s.strstart - 1]);
            if (bflush) /*** FLUSH_BLOCK_ONLY(s, 0) ***/ flush_block_only(s, false);
            s.strstart++;
            s.lookahead--;
            if (s.strm.avail_out === 0) return BS_NEED_MORE;
        } else {
            /* There is no previous match to compare with, wait for
       * the next step to decide.
       */ s.match_available = 1;
            s.strstart++;
            s.lookahead--;
        }
    }
    //Assert (flush != Z_NO_FLUSH, "no flush?");
    if (s.match_available) {
        //Tracevv((stderr,"%c", s->window[s->strstart-1]));
        /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = _tr_tally(s, 0, s.window[s.strstart - 1]);
        s.match_available = 0;
    }
    s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
    if (flush === Z_FINISH$3) {
        /*** FLUSH_BLOCK(s, 1); ***/ flush_block_only(s, true);
        if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
        /***/ return BS_FINISH_DONE;
    }
    if (s.sym_next) {
        /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
        if (s.strm.avail_out === 0) return BS_NEED_MORE;
    /***/ }
    return BS_BLOCK_DONE;
};
/* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */ const deflate_rle = (s, flush)=>{
    let bflush; /* set if current block must be flushed */ 
    let prev; /* byte at distance one to match */ 
    let scan, strend; /* scan goes up to strend for length of run */ 
    const _win = s.window;
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */ if (s.lookahead <= MAX_MATCH) {
            fill_window(s);
            if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH$2) return BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* See how many times the previous byte repeats */ s.match_length = 0;
        if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
            scan = s.strstart - 1;
            prev = _win[scan];
            if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
                strend = s.strstart + MAX_MATCH;
                do ;
                while (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && scan < strend);
                s.match_length = MAX_MATCH - (strend - scan);
                if (s.match_length > s.lookahead) s.match_length = s.lookahead;
            }
        //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
        }
        /* Emit match if have run of MIN_MATCH or longer, else emit literal */ if (s.match_length >= MIN_MATCH) {
            //check_match(s, s.strstart, s.strstart - 1, s.match_length);
            /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/ bflush = _tr_tally(s, 1, s.match_length - MIN_MATCH);
            s.lookahead -= s.match_length;
            s.strstart += s.match_length;
            s.match_length = 0;
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s->window[s->strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = _tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
            if (s.strm.avail_out === 0) return BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === Z_FINISH$3) {
        /*** FLUSH_BLOCK(s, 1); ***/ flush_block_only(s, true);
        if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
        /***/ return BS_FINISH_DONE;
    }
    if (s.sym_next) {
        /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
        if (s.strm.avail_out === 0) return BS_NEED_MORE;
    /***/ }
    return BS_BLOCK_DONE;
};
/* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */ const deflate_huff = (s, flush)=>{
    let bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we have a literal to write. */ if (s.lookahead === 0) {
            fill_window(s);
            if (s.lookahead === 0) {
                if (flush === Z_NO_FLUSH$2) return BS_NEED_MORE;
                break; /* flush the current block */ 
            }
        }
        /* Output a literal byte */ s.match_length = 0;
        //Tracevv((stderr,"%c", s->window[s->strstart]));
        /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = _tr_tally(s, 0, s.window[s.strstart]);
        s.lookahead--;
        s.strstart++;
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
            if (s.strm.avail_out === 0) return BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === Z_FINISH$3) {
        /*** FLUSH_BLOCK(s, 1); ***/ flush_block_only(s, true);
        if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
        /***/ return BS_FINISH_DONE;
    }
    if (s.sym_next) {
        /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
        if (s.strm.avail_out === 0) return BS_NEED_MORE;
    /***/ }
    return BS_BLOCK_DONE;
};
/* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */ function Config(good_length, max_lazy, nice_length, max_chain, func) {
    this.good_length = good_length;
    this.max_lazy = max_lazy;
    this.nice_length = nice_length;
    this.max_chain = max_chain;
    this.func = func;
}
const configuration_table = [
    /*      good lazy nice chain */ new Config(0, 0, 0, 0, deflate_stored),
    /* 0 store only */ new Config(4, 4, 8, 4, deflate_fast),
    /* 1 max speed, no lazy matches */ new Config(4, 5, 16, 8, deflate_fast),
    /* 2 */ new Config(4, 6, 32, 32, deflate_fast),
    /* 3 */ new Config(4, 4, 16, 16, deflate_slow),
    /* 4 lazy matches */ new Config(8, 16, 32, 32, deflate_slow),
    /* 5 */ new Config(8, 16, 128, 128, deflate_slow),
    /* 6 */ new Config(8, 32, 128, 256, deflate_slow),
    /* 7 */ new Config(32, 128, 258, 1024, deflate_slow),
    /* 8 */ new Config(32, 258, 258, 4096, deflate_slow)
];
/* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */ const lm_init = (s)=>{
    s.window_size = 2 * s.w_size;
    /*** CLEAR_HASH(s); ***/ zero(s.head); // Fill with NIL (= 0);
    /* Set the default configuration parameters:
   */ s.max_lazy_match = configuration_table[s.level].max_lazy;
    s.good_match = configuration_table[s.level].good_length;
    s.nice_match = configuration_table[s.level].nice_length;
    s.max_chain_length = configuration_table[s.level].max_chain;
    s.strstart = 0;
    s.block_start = 0;
    s.lookahead = 0;
    s.insert = 0;
    s.match_length = s.prev_length = MIN_MATCH - 1;
    s.match_available = 0;
    s.ins_h = 0;
};
function DeflateState() {
    this.strm = null; /* pointer back to this zlib stream */ 
    this.status = 0; /* as the name implies */ 
    this.pending_buf = null; /* output still pending */ 
    this.pending_buf_size = 0; /* size of pending_buf */ 
    this.pending_out = 0; /* next pending byte to output to the stream */ 
    this.pending = 0; /* nb of bytes in the pending buffer */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.gzhead = null; /* gzip header information to write */ 
    this.gzindex = 0; /* where in extra, name, or comment */ 
    this.method = Z_DEFLATED$2; /* can only be DEFLATED */ 
    this.last_flush = -1; /* value of flush param for previous deflate call */ 
    this.w_size = 0; /* LZ77 window size (32K by default) */ 
    this.w_bits = 0; /* log2(w_size)  (8..16) */ 
    this.w_mask = 0; /* w_size - 1 */ 
    this.window = null;
    /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */ this.window_size = 0;
    /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */ this.prev = null;
    /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */ this.head = null; /* Heads of the hash chains or NIL. */ 
    this.ins_h = 0; /* hash index of string to be inserted */ 
    this.hash_size = 0; /* number of elements in hash table */ 
    this.hash_bits = 0; /* log2(hash_size) */ 
    this.hash_mask = 0; /* hash_size-1 */ 
    this.hash_shift = 0;
    /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */ this.block_start = 0;
    /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */ this.match_length = 0; /* length of best match */ 
    this.prev_match = 0; /* previous match */ 
    this.match_available = 0; /* set if previous match exists */ 
    this.strstart = 0; /* start of string to insert */ 
    this.match_start = 0; /* start of matching string */ 
    this.lookahead = 0; /* number of valid bytes ahead in window */ 
    this.prev_length = 0;
    /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */ this.max_chain_length = 0;
    /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */ this.max_lazy_match = 0;
    /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */ // That's alias to max_lazy_match, don't use directly
    //this.max_insert_length = 0;
    /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */ this.level = 0; /* compression level (1..9) */ 
    this.strategy = 0; /* favor or force Huffman coding*/ 
    this.good_match = 0;
    /* Use a faster search when the previous match is longer than this */ this.nice_match = 0; /* Stop searching when current match exceeds this */ 
    /* used by trees.c: */ /* Didn't use ct_data typedef below to suppress compiler warning */ // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
    // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
    // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
    // Use flat array of DOUBLE size, with interleaved fata,
    // because JS does not support effective
    this.dyn_ltree = new Uint16Array(HEAP_SIZE * 2);
    this.dyn_dtree = new Uint16Array((2 * D_CODES + 1) * 2);
    this.bl_tree = new Uint16Array((2 * BL_CODES + 1) * 2);
    zero(this.dyn_ltree);
    zero(this.dyn_dtree);
    zero(this.bl_tree);
    this.l_desc = null; /* desc. for literal tree */ 
    this.d_desc = null; /* desc. for distance tree */ 
    this.bl_desc = null; /* desc. for bit length tree */ 
    //ush bl_count[MAX_BITS+1];
    this.bl_count = new Uint16Array(MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */ //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
    this.heap = new Uint16Array(2 * L_CODES + 1); /* heap used to build the Huffman trees */ 
    zero(this.heap);
    this.heap_len = 0; /* number of elements in the heap */ 
    this.heap_max = 0; /* element of largest frequency */ 
    /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */ this.depth = new Uint16Array(2 * L_CODES + 1); //uch depth[2*L_CODES+1];
    zero(this.depth);
    /* Depth of each subtree used as tie breaker for trees of equal frequency
   */ this.sym_buf = 0; /* buffer for distances and literals/lengths */ 
    this.lit_bufsize = 0;
    /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */ this.sym_next = 0; /* running index in sym_buf */ 
    this.sym_end = 0; /* symbol table full when sym_next reaches this */ 
    this.opt_len = 0; /* bit length of current block with optimal trees */ 
    this.static_len = 0; /* bit length of current block with static trees */ 
    this.matches = 0; /* number of string matches in current block */ 
    this.insert = 0; /* bytes at end of window left to insert */ 
    this.bi_buf = 0;
    /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */ this.bi_valid = 0;
/* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */ // Used for window memory init. We safely ignore it for JS. That makes
// sense only for pointers and memory check tools.
//this.high_water = 0;
/* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */ }
/* =========================================================================
 * Check for a valid deflate stream state. Return 0 if ok, 1 if not.
 */ const deflateStateCheck = (strm)=>{
    if (!strm) return 1;
    const s = strm.state;
    if (!s || s.strm !== strm || s.status !== INIT_STATE && //#ifdef GZIP
    s.status !== GZIP_STATE && //#endif
    s.status !== EXTRA_STATE && s.status !== NAME_STATE && s.status !== COMMENT_STATE && s.status !== HCRC_STATE && s.status !== BUSY_STATE && s.status !== FINISH_STATE) return 1;
    return 0;
};
const deflateResetKeep = (strm)=>{
    if (deflateStateCheck(strm)) return err(strm, Z_STREAM_ERROR$2);
    strm.total_in = strm.total_out = 0;
    strm.data_type = Z_UNKNOWN;
    const s = strm.state;
    s.pending = 0;
    s.pending_out = 0;
    if (s.wrap < 0) s.wrap = -s.wrap;
    s.status = //#ifdef GZIP
    s.wrap === 2 ? GZIP_STATE : //#endif
    s.wrap ? INIT_STATE : BUSY_STATE;
    strm.adler = s.wrap === 2 ? 0 // crc32(0, Z_NULL, 0)
     : 1; // adler32(0, Z_NULL, 0)
    s.last_flush = -2;
    _tr_init(s);
    return Z_OK$3;
};
const deflateReset = (strm)=>{
    const ret = deflateResetKeep(strm);
    if (ret === Z_OK$3) lm_init(strm.state);
    return ret;
};
const deflateSetHeader = (strm, head)=>{
    if (deflateStateCheck(strm) || strm.state.wrap !== 2) return Z_STREAM_ERROR$2;
    strm.state.gzhead = head;
    return Z_OK$3;
};
const deflateInit2 = (strm, level, method, windowBits, memLevel, strategy)=>{
    if (!strm) return Z_STREAM_ERROR$2;
    let wrap = 1;
    if (level === Z_DEFAULT_COMPRESSION$1) level = 6;
    if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else if (windowBits > 15) {
        wrap = 2; /* write gzip wrapper instead */ 
        windowBits -= 16;
    }
    if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED$2 || windowBits < 8 || windowBits > 15 || level < 0 || level > 9 || strategy < 0 || strategy > Z_FIXED || windowBits === 8 && wrap !== 1) return err(strm, Z_STREAM_ERROR$2);
    if (windowBits === 8) windowBits = 9;
    /* until 256-byte window bug fixed */ const s = new DeflateState();
    strm.state = s;
    s.strm = strm;
    s.status = INIT_STATE; /* to pass state test in deflateReset() */ 
    s.wrap = wrap;
    s.gzhead = null;
    s.w_bits = windowBits;
    s.w_size = 1 << s.w_bits;
    s.w_mask = s.w_size - 1;
    s.hash_bits = memLevel + 7;
    s.hash_size = 1 << s.hash_bits;
    s.hash_mask = s.hash_size - 1;
    s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);
    s.window = new Uint8Array(s.w_size * 2);
    s.head = new Uint16Array(s.hash_size);
    s.prev = new Uint16Array(s.w_size);
    // Don't need mem init magic for JS.
    //s.high_water = 0;  /* nothing written to s->window yet */
    s.lit_bufsize = 1 << memLevel + 6; /* 16K elements by default */ 
    /* We overlay pending_buf and sym_buf. This works since the average size
   * for length/distance pairs over any compressed block is assured to be 31
   * bits or less.
   *
   * Analysis: The longest fixed codes are a length code of 8 bits plus 5
   * extra bits, for lengths 131 to 257. The longest fixed distance codes are
   * 5 bits plus 13 extra bits, for distances 16385 to 32768. The longest
   * possible fixed-codes length/distance pair is then 31 bits total.
   *
   * sym_buf starts one-fourth of the way into pending_buf. So there are
   * three bytes in sym_buf for every four bytes in pending_buf. Each symbol
   * in sym_buf is three bytes -- two for the distance and one for the
   * literal/length. As each symbol is consumed, the pointer to the next
   * sym_buf value to read moves forward three bytes. From that symbol, up to
   * 31 bits are written to pending_buf. The closest the written pending_buf
   * bits gets to the next sym_buf symbol to read is just before the last
   * code is written. At that time, 31*(n-2) bits have been written, just
   * after 24*(n-2) bits have been consumed from sym_buf. sym_buf starts at
   * 8*n bits into pending_buf. (Note that the symbol buffer fills when n-1
   * symbols are written.) The closest the writing gets to what is unread is
   * then n+14 bits. Here n is lit_bufsize, which is 16384 by default, and
   * can range from 128 to 32768.
   *
   * Therefore, at a minimum, there are 142 bits of space between what is
   * written and what is read in the overlain buffers, so the symbols cannot
   * be overwritten by the compressed data. That space is actually 139 bits,
   * due to the three-bit fixed-code block header.
   *
   * That covers the case where either Z_FIXED is specified, forcing fixed
   * codes, or when the use of fixed codes is chosen, because that choice
   * results in a smaller compressed block than dynamic codes. That latter
   * condition then assures that the above analysis also covers all dynamic
   * blocks. A dynamic-code block will only be chosen to be emitted if it has
   * fewer bits than a fixed-code block would for the same set of symbols.
   * Therefore its average symbol length is assured to be less than 31. So
   * the compressed data for a dynamic block also cannot overwrite the
   * symbols from which it is being constructed.
   */ s.pending_buf_size = s.lit_bufsize * 4;
    s.pending_buf = new Uint8Array(s.pending_buf_size);
    // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
    //s->sym_buf = s->pending_buf + s->lit_bufsize;
    s.sym_buf = s.lit_bufsize;
    //s->sym_end = (s->lit_bufsize - 1) * 3;
    s.sym_end = (s.lit_bufsize - 1) * 3;
    /* We avoid equality with lit_bufsize*3 because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */ s.level = level;
    s.strategy = strategy;
    s.method = method;
    return deflateReset(strm);
};
const deflateInit = (strm, level)=>{
    return deflateInit2(strm, level, Z_DEFLATED$2, MAX_WBITS$1, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY$1);
};
/* ========================================================================= */ const deflate$2 = (strm, flush)=>{
    if (deflateStateCheck(strm) || flush > Z_BLOCK$1 || flush < 0) return strm ? err(strm, Z_STREAM_ERROR$2) : Z_STREAM_ERROR$2;
    const s = strm.state;
    if (!strm.output || strm.avail_in !== 0 && !strm.input || s.status === FINISH_STATE && flush !== Z_FINISH$3) return err(strm, strm.avail_out === 0 ? Z_BUF_ERROR$1 : Z_STREAM_ERROR$2);
    const old_flush = s.last_flush;
    s.last_flush = flush;
    /* Flush as much pending output as possible */ if (s.pending !== 0) {
        flush_pending(strm);
        if (strm.avail_out === 0) {
            /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */ s.last_flush = -1;
            return Z_OK$3;
        }
    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */ } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) && flush !== Z_FINISH$3) return err(strm, Z_BUF_ERROR$1);
    /* User must not provide more input after the first FINISH: */ if (s.status === FINISH_STATE && strm.avail_in !== 0) return err(strm, Z_BUF_ERROR$1);
    /* Write the header */ if (s.status === INIT_STATE && s.wrap === 0) s.status = BUSY_STATE;
    if (s.status === INIT_STATE) {
        /* zlib header */ let header = Z_DEFLATED$2 + (s.w_bits - 8 << 4) << 8;
        let level_flags = -1;
        if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) level_flags = 0;
        else if (s.level < 6) level_flags = 1;
        else if (s.level === 6) level_flags = 2;
        else level_flags = 3;
        header |= level_flags << 6;
        if (s.strstart !== 0) header |= PRESET_DICT;
        header += 31 - header % 31;
        putShortMSB(s, header);
        /* Save the adler32 of the preset dictionary: */ if (s.strstart !== 0) {
            putShortMSB(s, strm.adler >>> 16);
            putShortMSB(s, strm.adler & 0xffff);
        }
        strm.adler = 1; // adler32(0L, Z_NULL, 0);
        s.status = BUSY_STATE;
        /* Compression must start with an empty pending buffer */ flush_pending(strm);
        if (s.pending !== 0) {
            s.last_flush = -1;
            return Z_OK$3;
        }
    }
    //#ifdef GZIP
    if (s.status === GZIP_STATE) {
        /* gzip header */ strm.adler = 0; //crc32(0L, Z_NULL, 0);
        put_byte(s, 31);
        put_byte(s, 139);
        put_byte(s, 8);
        if (!s.gzhead) {
            put_byte(s, 0);
            put_byte(s, 0);
            put_byte(s, 0);
            put_byte(s, 0);
            put_byte(s, 0);
            put_byte(s, s.level === 9 ? 2 : s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
            put_byte(s, OS_CODE);
            s.status = BUSY_STATE;
            /* Compression must start with an empty pending buffer */ flush_pending(strm);
            if (s.pending !== 0) {
                s.last_flush = -1;
                return Z_OK$3;
            }
        } else {
            put_byte(s, (s.gzhead.text ? 1 : 0) + (s.gzhead.hcrc ? 2 : 0) + (!s.gzhead.extra ? 0 : 4) + (!s.gzhead.name ? 0 : 8) + (!s.gzhead.comment ? 0 : 16));
            put_byte(s, s.gzhead.time & 0xff);
            put_byte(s, s.gzhead.time >> 8 & 0xff);
            put_byte(s, s.gzhead.time >> 16 & 0xff);
            put_byte(s, s.gzhead.time >> 24 & 0xff);
            put_byte(s, s.level === 9 ? 2 : s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
            put_byte(s, s.gzhead.os & 0xff);
            if (s.gzhead.extra && s.gzhead.extra.length) {
                put_byte(s, s.gzhead.extra.length & 0xff);
                put_byte(s, s.gzhead.extra.length >> 8 & 0xff);
            }
            if (s.gzhead.hcrc) strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending, 0);
            s.gzindex = 0;
            s.status = EXTRA_STATE;
        }
    }
    if (s.status === EXTRA_STATE) {
        if (s.gzhead.extra /* != Z_NULL*/ ) {
            let beg = s.pending; /* start of bytes to update crc */ 
            let left = (s.gzhead.extra.length & 0xffff) - s.gzindex;
            while(s.pending + left > s.pending_buf_size){
                let copy = s.pending_buf_size - s.pending;
                // zmemcpy(s.pending_buf + s.pending,
                //    s.gzhead.extra + s.gzindex, copy);
                s.pending_buf.set(s.gzhead.extra.subarray(s.gzindex, s.gzindex + copy), s.pending);
                s.pending = s.pending_buf_size;
                //--- HCRC_UPDATE(beg) ---//
                if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                //---//
                s.gzindex += copy;
                flush_pending(strm);
                if (s.pending !== 0) {
                    s.last_flush = -1;
                    return Z_OK$3;
                }
                beg = 0;
                left -= copy;
            }
            // JS specific: s.gzhead.extra may be TypedArray or Array for backward compatibility
            //              TypedArray.slice and TypedArray.from don't exist in IE10-IE11
            let gzhead_extra = new Uint8Array(s.gzhead.extra);
            // zmemcpy(s->pending_buf + s->pending,
            //     s->gzhead->extra + s->gzindex, left);
            s.pending_buf.set(gzhead_extra.subarray(s.gzindex, s.gzindex + left), s.pending);
            s.pending += left;
            //--- HCRC_UPDATE(beg) ---//
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
            //---//
            s.gzindex = 0;
        }
        s.status = NAME_STATE;
    }
    if (s.status === NAME_STATE) {
        if (s.gzhead.name /* != Z_NULL*/ ) {
            let beg = s.pending; /* start of bytes to update crc */ 
            let val;
            do {
                if (s.pending === s.pending_buf_size) {
                    //--- HCRC_UPDATE(beg) ---//
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                    //---//
                    flush_pending(strm);
                    if (s.pending !== 0) {
                        s.last_flush = -1;
                        return Z_OK$3;
                    }
                    beg = 0;
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.name.length) val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                put_byte(s, val);
            }while (val !== 0);
            //--- HCRC_UPDATE(beg) ---//
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
            //---//
            s.gzindex = 0;
        }
        s.status = COMMENT_STATE;
    }
    if (s.status === COMMENT_STATE) {
        if (s.gzhead.comment /* != Z_NULL*/ ) {
            let beg = s.pending; /* start of bytes to update crc */ 
            let val;
            do {
                if (s.pending === s.pending_buf_size) {
                    //--- HCRC_UPDATE(beg) ---//
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                    //---//
                    flush_pending(strm);
                    if (s.pending !== 0) {
                        s.last_flush = -1;
                        return Z_OK$3;
                    }
                    beg = 0;
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.comment.length) val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                put_byte(s, val);
            }while (val !== 0);
            //--- HCRC_UPDATE(beg) ---//
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
        //---//
        }
        s.status = HCRC_STATE;
    }
    if (s.status === HCRC_STATE) {
        if (s.gzhead.hcrc) {
            if (s.pending + 2 > s.pending_buf_size) {
                flush_pending(strm);
                if (s.pending !== 0) {
                    s.last_flush = -1;
                    return Z_OK$3;
                }
            }
            put_byte(s, strm.adler & 0xff);
            put_byte(s, strm.adler >> 8 & 0xff);
            strm.adler = 0; //crc32(0L, Z_NULL, 0);
        }
        s.status = BUSY_STATE;
        /* Compression must start with an empty pending buffer */ flush_pending(strm);
        if (s.pending !== 0) {
            s.last_flush = -1;
            return Z_OK$3;
        }
    }
    //#endif
    /* Start a new block or continue the current one.
   */ if (strm.avail_in !== 0 || s.lookahead !== 0 || flush !== Z_NO_FLUSH$2 && s.status !== FINISH_STATE) {
        let bstate = s.level === 0 ? deflate_stored(s, flush) : s.strategy === Z_HUFFMAN_ONLY ? deflate_huff(s, flush) : s.strategy === Z_RLE ? deflate_rle(s, flush) : configuration_table[s.level].func(s, flush);
        if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) s.status = FINISH_STATE;
        if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
            if (strm.avail_out === 0) s.last_flush = -1;
            return Z_OK$3;
        /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */ }
        if (bstate === BS_BLOCK_DONE) {
            if (flush === Z_PARTIAL_FLUSH) _tr_align(s);
            else if (flush !== Z_BLOCK$1) {
                _tr_stored_block(s, 0, 0, false);
                /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */ if (flush === Z_FULL_FLUSH$1) {
                    /*** CLEAR_HASH(s); ***/ /* forget history */ zero(s.head); // Fill with NIL (= 0);
                    if (s.lookahead === 0) {
                        s.strstart = 0;
                        s.block_start = 0;
                        s.insert = 0;
                    }
                }
            }
            flush_pending(strm);
            if (strm.avail_out === 0) {
                s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */ 
                return Z_OK$3;
            }
        }
    }
    if (flush !== Z_FINISH$3) return Z_OK$3;
    if (s.wrap <= 0) return Z_STREAM_END$3;
    /* Write the trailer */ if (s.wrap === 2) {
        put_byte(s, strm.adler & 0xff);
        put_byte(s, strm.adler >> 8 & 0xff);
        put_byte(s, strm.adler >> 16 & 0xff);
        put_byte(s, strm.adler >> 24 & 0xff);
        put_byte(s, strm.total_in & 0xff);
        put_byte(s, strm.total_in >> 8 & 0xff);
        put_byte(s, strm.total_in >> 16 & 0xff);
        put_byte(s, strm.total_in >> 24 & 0xff);
    } else {
        putShortMSB(s, strm.adler >>> 16);
        putShortMSB(s, strm.adler & 0xffff);
    }
    flush_pending(strm);
    /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */ if (s.wrap > 0) s.wrap = -s.wrap;
    /* write the trailer only once! */ return s.pending !== 0 ? Z_OK$3 : Z_STREAM_END$3;
};
const deflateEnd = (strm)=>{
    if (deflateStateCheck(strm)) return Z_STREAM_ERROR$2;
    const status = strm.state.status;
    strm.state = null;
    return status === BUSY_STATE ? err(strm, Z_DATA_ERROR$2) : Z_OK$3;
};
/* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */ const deflateSetDictionary = (strm, dictionary)=>{
    let dictLength = dictionary.length;
    if (deflateStateCheck(strm)) return Z_STREAM_ERROR$2;
    const s = strm.state;
    const wrap = s.wrap;
    if (wrap === 2 || wrap === 1 && s.status !== INIT_STATE || s.lookahead) return Z_STREAM_ERROR$2;
    /* when using zlib wrappers, compute Adler-32 for provided dictionary */ if (wrap === 1) /* adler32(strm->adler, dictionary, dictLength); */ strm.adler = adler32_1(strm.adler, dictionary, dictLength, 0);
    s.wrap = 0; /* avoid computing Adler-32 in read_buf */ 
    /* if dictionary would fill window, just replace the history */ if (dictLength >= s.w_size) {
        if (wrap === 0) {
            /*** CLEAR_HASH(s); ***/ zero(s.head); // Fill with NIL (= 0);
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
        }
        /* use the tail */ // dictionary = dictionary.slice(dictLength - s.w_size);
        let tmpDict = new Uint8Array(s.w_size);
        tmpDict.set(dictionary.subarray(dictLength - s.w_size, dictLength), 0);
        dictionary = tmpDict;
        dictLength = s.w_size;
    }
    /* insert dictionary into window and hash */ const avail = strm.avail_in;
    const next = strm.next_in;
    const input = strm.input;
    strm.avail_in = dictLength;
    strm.next_in = 0;
    strm.input = dictionary;
    fill_window(s);
    while(s.lookahead >= MIN_MATCH){
        let str = s.strstart;
        let n = s.lookahead - (MIN_MATCH - 1);
        do {
            /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = HASH(s, s.ins_h, s.window[str + MIN_MATCH - 1]);
            s.prev[str & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = str;
            str++;
        }while (--n);
        s.strstart = str;
        s.lookahead = MIN_MATCH - 1;
        fill_window(s);
    }
    s.strstart += s.lookahead;
    s.block_start = s.strstart;
    s.insert = s.lookahead;
    s.lookahead = 0;
    s.match_length = s.prev_length = MIN_MATCH - 1;
    s.match_available = 0;
    strm.next_in = next;
    strm.input = input;
    strm.avail_in = avail;
    s.wrap = wrap;
    return Z_OK$3;
};
var deflateInit_1 = deflateInit;
var deflateInit2_1 = deflateInit2;
var deflateReset_1 = deflateReset;
var deflateResetKeep_1 = deflateResetKeep;
var deflateSetHeader_1 = deflateSetHeader;
var deflate_2$1 = deflate$2;
var deflateEnd_1 = deflateEnd;
var deflateSetDictionary_1 = deflateSetDictionary;
var deflateInfo = 'pako deflate (from Nodeca project)';
/* Not implemented
module.exports.deflateBound = deflateBound;
module.exports.deflateCopy = deflateCopy;
module.exports.deflateGetDictionary = deflateGetDictionary;
module.exports.deflateParams = deflateParams;
module.exports.deflatePending = deflatePending;
module.exports.deflatePrime = deflatePrime;
module.exports.deflateTune = deflateTune;
*/ var deflate_1$2 = {
    deflateInit: deflateInit_1,
    deflateInit2: deflateInit2_1,
    deflateReset: deflateReset_1,
    deflateResetKeep: deflateResetKeep_1,
    deflateSetHeader: deflateSetHeader_1,
    deflate: deflate_2$1,
    deflateEnd: deflateEnd_1,
    deflateSetDictionary: deflateSetDictionary_1,
    deflateInfo: deflateInfo
};
const _has = (obj, key)=>{
    return Object.prototype.hasOwnProperty.call(obj, key);
};
var assign = function(obj /*from1, from2, from3, ...*/ ) {
    const sources = Array.prototype.slice.call(arguments, 1);
    while(sources.length){
        const source = sources.shift();
        if (!source) continue;
        if (typeof source !== 'object') throw new TypeError(source + 'must be non-object');
        for(const p in source)if (_has(source, p)) obj[p] = source[p];
    }
    return obj;
};
// Join array of chunks to single array.
var flattenChunks = (chunks)=>{
    // calculate data length
    let len = 0;
    for(let i = 0, l = chunks.length; i < l; i++)len += chunks[i].length;
    // join chunks
    const result = new Uint8Array(len);
    for(let i = 0, pos = 0, l = chunks.length; i < l; i++){
        let chunk = chunks[i];
        result.set(chunk, pos);
        pos += chunk.length;
    }
    return result;
};
var common = {
    assign: assign,
    flattenChunks: flattenChunks
};
// String encode/decode helpers
// Quick check if we can use fast array to bin string conversion
//
// - apply(Array) can fail on Android 2.2
// - apply(Uint8Array) can fail on iOS 5.1 Safari
//
let STR_APPLY_UIA_OK = true;
try {
    String.fromCharCode.apply(null, new Uint8Array(1));
} catch (__) {
    STR_APPLY_UIA_OK = false;
}
// Table with utf8 lengths (calculated by first byte of sequence)
// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
// because max possible codepoint is 0x10ffff
const _utf8len = new Uint8Array(256);
for(let q = 0; q < 256; q++)_utf8len[q] = q >= 252 ? 6 : q >= 248 ? 5 : q >= 240 ? 4 : q >= 224 ? 3 : q >= 192 ? 2 : 1;
_utf8len[254] = _utf8len[254] = 1; // Invalid sequence start
// convert string to array (typed, when possible)
var string2buf = (str)=>{
    if (typeof TextEncoder === 'function' && TextEncoder.prototype.encode) return new TextEncoder().encode(str);
    let buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;
    // count binary size
    for(m_pos = 0; m_pos < str_len; m_pos++){
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
    }
    // allocate buffer
    buf = new Uint8Array(buf_len);
    // convert
    for(i = 0, m_pos = 0; i < buf_len; m_pos++){
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        if (c < 0x80) /* one byte */ buf[i++] = c;
        else if (c < 0x800) {
            /* two bytes */ buf[i++] = 0xC0 | c >>> 6;
            buf[i++] = 0x80 | c & 0x3f;
        } else if (c < 0x10000) {
            /* three bytes */ buf[i++] = 0xE0 | c >>> 12;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
        } else {
            /* four bytes */ buf[i++] = 0xf0 | c >>> 18;
            buf[i++] = 0x80 | c >>> 12 & 0x3f;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
        }
    }
    return buf;
};
// Helper
const buf2binstring = (buf, len)=>{
    // On Chrome, the arguments in a function call that are allowed is `65534`.
    // If the length of the buffer is smaller than that, we can use this optimization,
    // otherwise we will take a slower path.
    if (len < 65534) {
        if (buf.subarray && STR_APPLY_UIA_OK) return String.fromCharCode.apply(null, buf.length === len ? buf : buf.subarray(0, len));
    }
    let result = '';
    for(let i = 0; i < len; i++)result += String.fromCharCode(buf[i]);
    return result;
};
// convert array to string
var buf2string = (buf, max)=>{
    const len = max || buf.length;
    if (typeof TextDecoder === 'function' && TextDecoder.prototype.decode) return new TextDecoder().decode(buf.subarray(0, max));
    let i, out;
    // Reserve max possible length (2 words per char)
    // NB: by unknown reasons, Array is significantly faster for
    //     String.fromCharCode.apply than Uint16Array.
    const utf16buf = new Array(len * 2);
    for(out = 0, i = 0; i < len;){
        let c = buf[i++];
        // quick process ascii
        if (c < 0x80) {
            utf16buf[out++] = c;
            continue;
        }
        let c_len = _utf8len[c];
        // skip 5 & 6 byte codes
        if (c_len > 4) {
            utf16buf[out++] = 0xfffd;
            i += c_len - 1;
            continue;
        }
        // apply mask on first byte
        c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
        // join the rest
        while(c_len > 1 && i < len){
            c = c << 6 | buf[i++] & 0x3f;
            c_len--;
        }
        // terminated by end of string?
        if (c_len > 1) {
            utf16buf[out++] = 0xfffd;
            continue;
        }
        if (c < 0x10000) utf16buf[out++] = c;
        else {
            c -= 0x10000;
            utf16buf[out++] = 0xd800 | c >> 10 & 0x3ff;
            utf16buf[out++] = 0xdc00 | c & 0x3ff;
        }
    }
    return buf2binstring(utf16buf, out);
};
// Calculate max possible position in utf8 buffer,
// that will not break sequence. If that's not possible
// - (very small limits) return max size as is.
//
// buf[] - utf8 bytes array
// max   - length limit (mandatory);
var utf8border = (buf, max)=>{
    max = max || buf.length;
    if (max > buf.length) max = buf.length;
    // go back from last position, until start of sequence found
    let pos = max - 1;
    while(pos >= 0 && (buf[pos] & 0xC0) === 0x80)pos--;
    // Very small and broken sequence,
    // return max, because we should return something anyway.
    if (pos < 0) return max;
    // If we came to start of buffer - that means buffer is too small,
    // return max too.
    if (pos === 0) return max;
    return pos + _utf8len[buf[pos]] > max ? pos : max;
};
var strings = {
    string2buf: string2buf,
    buf2string: buf2string,
    utf8border: utf8border
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function ZStream() {
    /* next input byte */ this.input = null; // JS specific, because we have no pointers
    this.next_in = 0;
    /* number of bytes available at input */ this.avail_in = 0;
    /* total number of input bytes read so far */ this.total_in = 0;
    /* next output byte should be put there */ this.output = null; // JS specific, because we have no pointers
    this.next_out = 0;
    /* remaining free space at output */ this.avail_out = 0;
    /* total number of bytes output so far */ this.total_out = 0;
    /* last error message, NULL if no error */ this.msg = '' /*Z_NULL*/ ;
    /* not visible by applications */ this.state = null;
    /* best guess about the data type: binary or text */ this.data_type = 2 /*Z_UNKNOWN*/ ;
    /* adler32 value of the uncompressed data */ this.adler = 0;
}
var zstream = ZStream;
const toString$1 = Object.prototype.toString;
/* Public constants ==========================================================*/ /* ===========================================================================*/ const { Z_NO_FLUSH: Z_NO_FLUSH$1, Z_SYNC_FLUSH, Z_FULL_FLUSH, Z_FINISH: Z_FINISH$2, Z_OK: Z_OK$2, Z_STREAM_END: Z_STREAM_END$2, Z_DEFAULT_COMPRESSION, Z_DEFAULT_STRATEGY, Z_DEFLATED: Z_DEFLATED$1 } = constants$2;
/* ===========================================================================*/ /**
 * class Deflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[deflate]],
 * [[deflateRaw]] and [[gzip]].
 **/ /* internal
 * Deflate.chunks -> Array
 *
 * Chunks of output data, if [[Deflate#onData]] not overridden.
 **/ /**
 * Deflate.result -> Uint8Array
 *
 * Compressed result, generated by default [[Deflate#onData]]
 * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Deflate#push]] with `Z_FINISH` / `true` param).
 **/ /**
 * Deflate.err -> Number
 *
 * Error code after deflate finished. 0 (Z_OK) on success.
 * You will not need it in real life, because deflate errors
 * are possible only on wrong options or bad `onData` / `onEnd`
 * custom handlers.
 **/ /**
 * Deflate.msg -> String
 *
 * Error message, if [[Deflate.err]] != 0
 **/ /**
 * new Deflate(options)
 * - options (Object): zlib deflate options.
 *
 * Creates new deflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `level`
 * - `windowBits`
 * - `memLevel`
 * - `strategy`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw deflate
 * - `gzip` (Boolean) - create gzip wrapper
 * - `header` (Object) - custom header for gzip
 *   - `text` (Boolean) - true if compressed data believed to be text
 *   - `time` (Number) - modification time, unix timestamp
 *   - `os` (Number) - operation system code
 *   - `extra` (Array) - array of bytes with extra data (max 65536)
 *   - `name` (String) - file name (binary string)
 *   - `comment` (String) - comment (binary string)
 *   - `hcrc` (Boolean) - true if header crc should be added
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako')
 *   , chunk1 = new Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = new Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * const deflate = new pako.Deflate({ level: 3});
 *
 * deflate.push(chunk1, false);
 * deflate.push(chunk2, true);  // true -> last chunk
 *
 * if (deflate.err) { throw new Error(deflate.err); }
 *
 * console.log(deflate.result);
 * ```
 **/ function Deflate$1(options) {
    this.options = common.assign({
        level: Z_DEFAULT_COMPRESSION,
        method: Z_DEFLATED$1,
        chunkSize: 16384,
        windowBits: 15,
        memLevel: 8,
        strategy: Z_DEFAULT_STRATEGY
    }, options || {});
    let opt = this.options;
    if (opt.raw && opt.windowBits > 0) opt.windowBits = -opt.windowBits;
    else if (opt.gzip && opt.windowBits > 0 && opt.windowBits < 16) opt.windowBits += 16;
    this.err = 0; // error code, if happens (0 = Z_OK)
    this.msg = ''; // error message
    this.ended = false; // used to avoid multiple onEnd() calls
    this.chunks = []; // chunks of compressed data
    this.strm = new zstream();
    this.strm.avail_out = 0;
    let status = deflate_1$2.deflateInit2(this.strm, opt.level, opt.method, opt.windowBits, opt.memLevel, opt.strategy);
    if (status !== Z_OK$2) throw new Error(messages[status]);
    if (opt.header) deflate_1$2.deflateSetHeader(this.strm, opt.header);
    if (opt.dictionary) {
        let dict;
        // Convert data if needed
        if (typeof opt.dictionary === 'string') // If we need to compress text, change encoding to utf8.
        dict = strings.string2buf(opt.dictionary);
        else if (toString$1.call(opt.dictionary) === '[object ArrayBuffer]') dict = new Uint8Array(opt.dictionary);
        else dict = opt.dictionary;
        status = deflate_1$2.deflateSetDictionary(this.strm, dict);
        if (status !== Z_OK$2) throw new Error(messages[status]);
        this._dict_set = true;
    }
}
/**
 * Deflate#push(data[, flush_mode]) -> Boolean
 * - data (Uint8Array|ArrayBuffer|String): input data. Strings will be
 *   converted to utf8 byte sequence.
 * - flush_mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
 * new compressed chunks. Returns `true` on success. The last data block must
 * have `flush_mode` Z_FINISH (or `true`). That will flush internal pending
 * buffers and call [[Deflate#onEnd]].
 *
 * On fail call [[Deflate#onEnd]] with error code and return false.
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/ Deflate$1.prototype.push = function(data, flush_mode) {
    const strm = this.strm;
    const chunkSize = this.options.chunkSize;
    let status, _flush_mode;
    if (this.ended) return false;
    if (flush_mode === ~~flush_mode) _flush_mode = flush_mode;
    else _flush_mode = flush_mode === true ? Z_FINISH$2 : Z_NO_FLUSH$1;
    // Convert data if needed
    if (typeof data === 'string') // If we need to compress text, change encoding to utf8.
    strm.input = strings.string2buf(data);
    else if (toString$1.call(data) === '[object ArrayBuffer]') strm.input = new Uint8Array(data);
    else strm.input = data;
    strm.next_in = 0;
    strm.avail_in = strm.input.length;
    for(;;){
        if (strm.avail_out === 0) {
            strm.output = new Uint8Array(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
        }
        // Make sure avail_out > 6 to avoid repeating markers
        if ((_flush_mode === Z_SYNC_FLUSH || _flush_mode === Z_FULL_FLUSH) && strm.avail_out <= 6) {
            this.onData(strm.output.subarray(0, strm.next_out));
            strm.avail_out = 0;
            continue;
        }
        status = deflate_1$2.deflate(strm, _flush_mode);
        // Ended => flush and finish
        if (status === Z_STREAM_END$2) {
            if (strm.next_out > 0) this.onData(strm.output.subarray(0, strm.next_out));
            status = deflate_1$2.deflateEnd(this.strm);
            this.onEnd(status);
            this.ended = true;
            return status === Z_OK$2;
        }
        // Flush if out buffer full
        if (strm.avail_out === 0) {
            this.onData(strm.output);
            continue;
        }
        // Flush if requested and has data
        if (_flush_mode > 0 && strm.next_out > 0) {
            this.onData(strm.output.subarray(0, strm.next_out));
            strm.avail_out = 0;
            continue;
        }
        if (strm.avail_in === 0) break;
    }
    return true;
};
/**
 * Deflate#onData(chunk) -> Void
 * - chunk (Uint8Array): output data.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/ Deflate$1.prototype.onData = function(chunk) {
    this.chunks.push(chunk);
};
/**
 * Deflate#onEnd(status) -> Void
 * - status (Number): deflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called once after you tell deflate that the input stream is
 * complete (Z_FINISH). By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/ Deflate$1.prototype.onEnd = function(status) {
    // On success - join
    if (status === Z_OK$2) this.result = common.flattenChunks(this.chunks);
    this.chunks = [];
    this.err = status;
    this.msg = this.strm.msg;
};
/**
 * deflate(data[, options]) -> Uint8Array
 * - data (Uint8Array|ArrayBuffer|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * Compress `data` with deflate algorithm and `options`.
 *
 * Supported options are:
 *
 * - level
 * - windowBits
 * - memLevel
 * - strategy
 * - dictionary
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako')
 * const data = new Uint8Array([1,2,3,4,5,6,7,8,9]);
 *
 * console.log(pako.deflate(data));
 * ```
 **/ function deflate$1(input, options) {
    const deflator = new Deflate$1(options);
    deflator.push(input, true);
    // That will never happens, if you don't cheat with options :)
    if (deflator.err) throw deflator.msg || messages[deflator.err];
    return deflator.result;
}
/**
 * deflateRaw(data[, options]) -> Uint8Array
 * - data (Uint8Array|ArrayBuffer|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/ function deflateRaw$1(input, options) {
    options = options || {};
    options.raw = true;
    return deflate$1(input, options);
}
/**
 * gzip(data[, options]) -> Uint8Array
 * - data (Uint8Array|ArrayBuffer|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but create gzip wrapper instead of
 * deflate one.
 **/ function gzip$1(input, options) {
    options = options || {};
    options.gzip = true;
    return deflate$1(input, options);
}
var Deflate_1$1 = Deflate$1;
var deflate_2 = deflate$1;
var deflateRaw_1$1 = deflateRaw$1;
var gzip_1$1 = gzip$1;
var constants$1 = constants$2;
var deflate_1$1 = {
    Deflate: Deflate_1$1,
    deflate: deflate_2,
    deflateRaw: deflateRaw_1$1,
    gzip: gzip_1$1,
    constants: constants$1
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// See state defs from inflate.js
const BAD$1 = 16209; /* got a data error -- remain here until reset */ 
const TYPE$1 = 16191; /* i: waiting for type bits, including last-flag bit */ 
/*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */ var inffast = function inflate_fast(strm, start) {
    let _in; /* local strm.input */ 
    let last; /* have enough input while in < last */ 
    let _out; /* local strm.output */ 
    let beg; /* inflate()'s initial strm.output */ 
    let end; /* while out < end, enough space available */ 
    //#ifdef INFLATE_STRICT
    let dmax; /* maximum distance from zlib header */ 
    //#endif
    let wsize; /* window size or zero if not using window */ 
    let whave; /* valid bytes in the window */ 
    let wnext; /* window write index */ 
    // Use `s_window` instead `window`, avoid conflict with instrumentation tools
    let s_window; /* allocated sliding window, if wsize != 0 */ 
    let hold; /* local strm.hold */ 
    let bits; /* local strm.bits */ 
    let lcode; /* local strm.lencode */ 
    let dcode; /* local strm.distcode */ 
    let lmask; /* mask for first level of length codes */ 
    let dmask; /* mask for first level of distance codes */ 
    let here; /* retrieved table entry */ 
    let op; /* code bits, operation, extra bits, or */ 
    /*  window position, window bytes to copy */ let len; /* match length, unused bytes */ 
    let dist; /* match distance */ 
    let from; /* where to copy match from */ 
    let from_source;
    let input, output; // JS specific, because we have no pointers
    /* copy state to local variables */ const state = strm.state;
    //here = state.here;
    _in = strm.next_in;
    input = strm.input;
    last = _in + (strm.avail_in - 5);
    _out = strm.next_out;
    output = strm.output;
    beg = _out - (start - strm.avail_out);
    end = _out + (strm.avail_out - 257);
    //#ifdef INFLATE_STRICT
    dmax = state.dmax;
    //#endif
    wsize = state.wsize;
    whave = state.whave;
    wnext = state.wnext;
    s_window = state.window;
    hold = state.hold;
    bits = state.bits;
    lcode = state.lencode;
    dcode = state.distcode;
    lmask = (1 << state.lenbits) - 1;
    dmask = (1 << state.distbits) - 1;
    /* decode literals and length/distances until end-of-block or not enough
     input data or output space */ top: do {
        if (bits < 15) {
            hold += input[_in++] << bits;
            bits += 8;
            hold += input[_in++] << bits;
            bits += 8;
        }
        here = lcode[hold & lmask];
        dolen: for(;;){
            op = here >>> 24 /*here.bits*/ ;
            hold >>>= op;
            bits -= op;
            op = here >>> 16 & 0xff /*here.op*/ ;
            if (op === 0) //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
            //        "inflate:         literal '%c'\n" :
            //        "inflate:         literal 0x%02x\n", here.val));
            output[_out++] = here & 0xffff /*here.val*/ ;
            else if (op & 16) {
                len = here & 0xffff /*here.val*/ ;
                op &= 15; /* number of extra bits */ 
                if (op) {
                    if (bits < op) {
                        hold += input[_in++] << bits;
                        bits += 8;
                    }
                    len += hold & (1 << op) - 1;
                    hold >>>= op;
                    bits -= op;
                }
                //Tracevv((stderr, "inflate:         length %u\n", len));
                if (bits < 15) {
                    hold += input[_in++] << bits;
                    bits += 8;
                    hold += input[_in++] << bits;
                    bits += 8;
                }
                here = dcode[hold & dmask];
                dodist: for(;;){
                    op = here >>> 24 /*here.bits*/ ;
                    hold >>>= op;
                    bits -= op;
                    op = here >>> 16 & 0xff /*here.op*/ ;
                    if (op & 16) {
                        dist = here & 0xffff /*here.val*/ ;
                        op &= 15; /* number of extra bits */ 
                        if (bits < op) {
                            hold += input[_in++] << bits;
                            bits += 8;
                            if (bits < op) {
                                hold += input[_in++] << bits;
                                bits += 8;
                            }
                        }
                        dist += hold & (1 << op) - 1;
                        //#ifdef INFLATE_STRICT
                        if (dist > dmax) {
                            strm.msg = 'invalid distance too far back';
                            state.mode = BAD$1;
                            break top;
                        }
                        //#endif
                        hold >>>= op;
                        bits -= op;
                        //Tracevv((stderr, "inflate:         distance %u\n", dist));
                        op = _out - beg; /* max distance in output */ 
                        if (dist > op) {
                            op = dist - op; /* distance back in window */ 
                            if (op > whave) {
                                if (state.sane) {
                                    strm.msg = 'invalid distance too far back';
                                    state.mode = BAD$1;
                                    break top;
                                }
                            }
                            from = 0; // window index
                            from_source = s_window;
                            if (wnext === 0) {
                                from += wsize - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            } else if (wnext < op) {
                                from += wsize + wnext - op;
                                op -= wnext;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = 0;
                                    if (wnext < len) {
                                        op = wnext;
                                        len -= op;
                                        do output[_out++] = s_window[from++];
                                        while (--op);
                                        from = _out - dist; /* rest from output */ 
                                        from_source = output;
                                    }
                                }
                            } else {
                                from += wnext - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            }
                            while(len > 2){
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                len -= 3;
                            }
                            if (len) {
                                output[_out++] = from_source[from++];
                                if (len > 1) output[_out++] = from_source[from++];
                            }
                        } else {
                            from = _out - dist; /* copy direct from output */ 
                            do {
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                len -= 3;
                            }while (len > 2);
                            if (len) {
                                output[_out++] = output[from++];
                                if (len > 1) output[_out++] = output[from++];
                            }
                        }
                    } else if ((op & 64) === 0) {
                        here = dcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                        continue dodist;
                    } else {
                        strm.msg = 'invalid distance code';
                        state.mode = BAD$1;
                        break top;
                    }
                    break; // need to emulate goto via "continue"
                }
            } else if ((op & 64) === 0) {
                here = lcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                continue dolen;
            } else if (op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.mode = TYPE$1;
                break top;
            } else {
                strm.msg = 'invalid literal/length code';
                state.mode = BAD$1;
                break top;
            }
            break; // need to emulate goto via "continue"
        }
    }while (_in < last && _out < end);
    /* return unused bytes (on entry, bits < 8, so in won't go too far back) */ len = bits >> 3;
    _in -= len;
    bits -= len << 3;
    hold &= (1 << bits) - 1;
    /* update state and return */ strm.next_in = _in;
    strm.next_out = _out;
    strm.avail_in = _in < last ? 5 + (last - _in) : 5 - (_in - last);
    strm.avail_out = _out < end ? 257 + (end - _out) : 257 - (_out - end);
    state.hold = hold;
    state.bits = bits;
    return;
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
const MAXBITS = 15;
const ENOUGH_LENS$1 = 852;
const ENOUGH_DISTS$1 = 592;
//const ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
const CODES$1 = 0;
const LENS$1 = 1;
const DISTS$1 = 2;
const lbase = new Uint16Array([
    /* Length codes 257..285 base */ 3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    13,
    15,
    17,
    19,
    23,
    27,
    31,
    35,
    43,
    51,
    59,
    67,
    83,
    99,
    115,
    131,
    163,
    195,
    227,
    258,
    0,
    0
]);
const lext = new Uint8Array([
    /* Length codes 257..285 extra */ 16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    16,
    72,
    78
]);
const dbase = new Uint16Array([
    /* Distance codes 0..29 base */ 1,
    2,
    3,
    4,
    5,
    7,
    9,
    13,
    17,
    25,
    33,
    49,
    65,
    97,
    129,
    193,
    257,
    385,
    513,
    769,
    1025,
    1537,
    2049,
    3073,
    4097,
    6145,
    8193,
    12289,
    16385,
    24577,
    0,
    0
]);
const dext = new Uint8Array([
    /* Distance codes 0..29 extra */ 16,
    16,
    16,
    16,
    17,
    17,
    18,
    18,
    19,
    19,
    20,
    20,
    21,
    21,
    22,
    22,
    23,
    23,
    24,
    24,
    25,
    25,
    26,
    26,
    27,
    27,
    28,
    28,
    29,
    29,
    64,
    64
]);
const inflate_table = (type, lens, lens_index, codes, table, table_index, work, opts)=>{
    const bits = opts.bits;
    //here = opts.here; /* table entry for duplication */
    let len = 0; /* a code's length in bits */ 
    let sym = 0; /* index of code symbols */ 
    let min = 0, max = 0; /* minimum and maximum code lengths */ 
    let root = 0; /* number of index bits for root table */ 
    let curr = 0; /* number of index bits for current table */ 
    let drop = 0; /* code bits to drop for sub-table */ 
    let left = 0; /* number of prefix codes available */ 
    let used = 0; /* code entries in table used */ 
    let huff = 0; /* Huffman code */ 
    let incr; /* for incrementing code, index */ 
    let fill; /* index for replicating entries */ 
    let low; /* low bits for current root entry */ 
    let mask; /* mask for low root bits */ 
    let next; /* next available space in table */ 
    let base = null; /* base value table to use */ 
    //  let shoextra;    /* extra bits table to use */
    let match; /* use base and extra for symbol >= match */ 
    const count = new Uint16Array(MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
    const offs = new Uint16Array(MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
    let extra = null;
    let here_bits, here_op, here_val;
    /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */ /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */ for(len = 0; len <= MAXBITS; len++)count[len] = 0;
    for(sym = 0; sym < codes; sym++)count[lens[lens_index + sym]]++;
    /* bound code lengths, force root to be within code lengths */ root = bits;
    for(max = MAXBITS; max >= 1; max--){
        if (count[max] !== 0) break;
    }
    if (root > max) root = max;
    if (max === 0) {
        //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
        //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
        //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
        table[table_index++] = 20971520;
        //table.op[opts.table_index] = 64;
        //table.bits[opts.table_index] = 1;
        //table.val[opts.table_index++] = 0;
        table[table_index++] = 20971520;
        opts.bits = 1;
        return 0; /* no symbols, but wait for decoding to report error */ 
    }
    for(min = 1; min < max; min++){
        if (count[min] !== 0) break;
    }
    if (root < min) root = min;
    /* check for an over-subscribed or incomplete set of lengths */ left = 1;
    for(len = 1; len <= MAXBITS; len++){
        left <<= 1;
        left -= count[len];
        if (left < 0) return -1;
         /* over-subscribed */ 
    }
    if (left > 0 && (type === CODES$1 || max !== 1)) return -1; /* incomplete set */ 
    /* generate offsets into symbol table for each length for sorting */ offs[1] = 0;
    for(len = 1; len < MAXBITS; len++)offs[len + 1] = offs[len] + count[len];
    /* sort symbols by length, by symbol order within each length */ for(sym = 0; sym < codes; sym++)if (lens[lens_index + sym] !== 0) work[offs[lens[lens_index + sym]]++] = sym;
    /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */ /* set up for code type */ // poor man optimization - use if-else instead of switch,
    // to avoid deopts in old v8
    if (type === CODES$1) {
        base = extra = work; /* dummy value--not used */ 
        match = 20;
    } else if (type === LENS$1) {
        base = lbase;
        extra = lext;
        match = 257;
    } else {
        base = dbase;
        extra = dext;
        match = 0;
    }
    /* initialize opts for loop */ huff = 0; /* starting code */ 
    sym = 0; /* starting code symbol */ 
    len = min; /* starting code length */ 
    next = table_index; /* current table to fill in */ 
    curr = root; /* current table index bits */ 
    drop = 0; /* current bits to drop from code for index */ 
    low = -1; /* trigger new sub-table when len > root */ 
    used = 1 << root; /* use root table entries */ 
    mask = used - 1; /* mask for comparing low */ 
    /* check available table space */ if (type === LENS$1 && used > ENOUGH_LENS$1 || type === DISTS$1 && used > ENOUGH_DISTS$1) return 1;
    /* process all codes and make table entries */ for(;;){
        /* create table entry */ here_bits = len - drop;
        if (work[sym] + 1 < match) {
            here_op = 0;
            here_val = work[sym];
        } else if (work[sym] >= match) {
            here_op = extra[work[sym] - match];
            here_val = base[work[sym] - match];
        } else {
            here_op = 96; /* end of block */ 
            here_val = 0;
        }
        /* replicate for those indices with low len bits equal to huff */ incr = 1 << len - drop;
        fill = 1 << curr;
        min = fill; /* save offset to next table */ 
        do {
            fill -= incr;
            table[next + (huff >> drop) + fill] = here_bits << 24 | here_op << 16 | here_val | 0;
        }while (fill !== 0);
        /* backwards increment the len-bit code huff */ incr = 1 << len - 1;
        while(huff & incr)incr >>= 1;
        if (incr !== 0) {
            huff &= incr - 1;
            huff += incr;
        } else huff = 0;
        /* go to next symbol, update count, len */ sym++;
        if (--count[len] === 0) {
            if (len === max) break;
            len = lens[lens_index + work[sym]];
        }
        /* create new sub-table if needed */ if (len > root && (huff & mask) !== low) {
            /* if first time, transition to sub-tables */ if (drop === 0) drop = root;
            /* increment past last table */ next += min; /* here min is 1 << curr */ 
            /* determine length of next table */ curr = len - drop;
            left = 1 << curr;
            while(curr + drop < max){
                left -= count[curr + drop];
                if (left <= 0) break;
                curr++;
                left <<= 1;
            }
            /* check for enough space */ used += 1 << curr;
            if (type === LENS$1 && used > ENOUGH_LENS$1 || type === DISTS$1 && used > ENOUGH_DISTS$1) return 1;
            /* point entry in root table to sub-table */ low = huff & mask;
            /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/ table[low] = root << 24 | curr << 16 | next - table_index | 0;
        }
    }
    /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */ if (huff !== 0) //table.op[next + huff] = 64;            /* invalid code marker */
    //table.bits[next + huff] = len - drop;
    //table.val[next + huff] = 0;
    table[next + huff] = len - drop << 24 | 4194304;
    /* set return parameters */ //opts.table_index += used;
    opts.bits = root;
    return 0;
};
var inftrees = inflate_table;
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
const CODES = 0;
const LENS = 1;
const DISTS = 2;
/* Public constants ==========================================================*/ /* ===========================================================================*/ const { Z_FINISH: Z_FINISH$1, Z_BLOCK, Z_TREES, Z_OK: Z_OK$1, Z_STREAM_END: Z_STREAM_END$1, Z_NEED_DICT: Z_NEED_DICT$1, Z_STREAM_ERROR: Z_STREAM_ERROR$1, Z_DATA_ERROR: Z_DATA_ERROR$1, Z_MEM_ERROR: Z_MEM_ERROR$1, Z_BUF_ERROR, Z_DEFLATED } = constants$2;
/* STATES ====================================================================*/ /* ===========================================================================*/ const HEAD = 16180; /* i: waiting for magic header */ 
const FLAGS = 16181; /* i: waiting for method and flags (gzip) */ 
const TIME = 16182; /* i: waiting for modification time (gzip) */ 
const OS = 16183; /* i: waiting for extra flags and operating system (gzip) */ 
const EXLEN = 16184; /* i: waiting for extra length (gzip) */ 
const EXTRA = 16185; /* i: waiting for extra bytes (gzip) */ 
const NAME = 16186; /* i: waiting for end of file name (gzip) */ 
const COMMENT = 16187; /* i: waiting for end of comment (gzip) */ 
const HCRC = 16188; /* i: waiting for header crc (gzip) */ 
const DICTID = 16189; /* i: waiting for dictionary check value */ 
const DICT = 16190; /* waiting for inflateSetDictionary() call */ 
const TYPE = 16191; /* i: waiting for type bits, including last-flag bit */ 
const TYPEDO = 16192; /* i: same, but skip check to exit inflate on new block */ 
const STORED = 16193; /* i: waiting for stored size (length and complement) */ 
const COPY_ = 16194; /* i/o: same as COPY below, but only first time in */ 
const COPY = 16195; /* i/o: waiting for input or output to copy stored block */ 
const TABLE = 16196; /* i: waiting for dynamic block table lengths */ 
const LENLENS = 16197; /* i: waiting for code length code lengths */ 
const CODELENS = 16198; /* i: waiting for length/lit and distance code lengths */ 
const LEN_ = 16199; /* i: same as LEN below, but only first time in */ 
const LEN = 16200; /* i: waiting for length/lit/eob code */ 
const LENEXT = 16201; /* i: waiting for length extra bits */ 
const DIST = 16202; /* i: waiting for distance code */ 
const DISTEXT = 16203; /* i: waiting for distance extra bits */ 
const MATCH = 16204; /* o: waiting for output space to copy string */ 
const LIT = 16205; /* o: waiting for output space to write literal */ 
const CHECK = 16206; /* i: waiting for 32-bit check value */ 
const LENGTH = 16207; /* i: waiting for 32-bit length (gzip) */ 
const DONE = 16208; /* finished check, done -- remain here until reset */ 
const BAD = 16209; /* got a data error -- remain here until reset */ 
const MEM = 16210; /* got an inflate() memory error -- remain here until reset */ 
const SYNC = 16211; /* looking for synchronization bytes to restart inflate() */ 
/* ===========================================================================*/ const ENOUGH_LENS = 852;
const ENOUGH_DISTS = 592;
//const ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
const MAX_WBITS = 15;
/* 32K LZ77 window */ const DEF_WBITS = MAX_WBITS;
const zswap32 = (q)=>{
    return (q >>> 24 & 0xff) + (q >>> 8 & 0xff00) + ((q & 0xff00) << 8) + ((q & 0xff) << 24);
};
function InflateState() {
    this.strm = null; /* pointer back to this zlib stream */ 
    this.mode = 0; /* current inflate mode */ 
    this.last = false; /* true if processing last block */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip,
                                 bit 2 true to validate check value */ 
    this.havedict = false; /* true if dictionary provided */ 
    this.flags = 0; /* gzip header method and flags (0 if zlib), or
                                 -1 if raw or no header yet */ 
    this.dmax = 0; /* zlib header max distance (INFLATE_STRICT) */ 
    this.check = 0; /* protected copy of check value */ 
    this.total = 0; /* protected copy of output count */ 
    // TODO: may be {}
    this.head = null; /* where to save gzip header information */ 
    /* sliding window */ this.wbits = 0; /* log base 2 of requested window size */ 
    this.wsize = 0; /* window size or zero if not using window */ 
    this.whave = 0; /* valid bytes in the window */ 
    this.wnext = 0; /* window write index */ 
    this.window = null; /* allocated sliding window, if needed */ 
    /* bit accumulator */ this.hold = 0; /* input bit accumulator */ 
    this.bits = 0; /* number of bits in "in" */ 
    /* for string and stored block copying */ this.length = 0; /* literal or length of data to copy */ 
    this.offset = 0; /* distance back to copy string from */ 
    /* for table and code decoding */ this.extra = 0; /* extra bits needed */ 
    /* fixed and dynamic code tables */ this.lencode = null; /* starting table for length/literal codes */ 
    this.distcode = null; /* starting table for distance codes */ 
    this.lenbits = 0; /* index bits for lencode */ 
    this.distbits = 0; /* index bits for distcode */ 
    /* dynamic table building */ this.ncode = 0; /* number of code length code lengths */ 
    this.nlen = 0; /* number of length code lengths */ 
    this.ndist = 0; /* number of distance code lengths */ 
    this.have = 0; /* number of code lengths in lens[] */ 
    this.next = null; /* next available space in codes[] */ 
    this.lens = new Uint16Array(320); /* temporary storage for code lengths */ 
    this.work = new Uint16Array(288); /* work area for code table building */ 
    /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */ //this.codes = new Int32Array(ENOUGH);       /* space for code tables */
    this.lendyn = null; /* dynamic table for length/literal codes (JS specific) */ 
    this.distdyn = null; /* dynamic table for distance codes (JS specific) */ 
    this.sane = 0; /* if false, allow invalid distance too far */ 
    this.back = 0; /* bits back of last unprocessed length/lit */ 
    this.was = 0; /* initial length of match */ 
}
const inflateStateCheck = (strm)=>{
    if (!strm) return 1;
    const state = strm.state;
    if (!state || state.strm !== strm || state.mode < HEAD || state.mode > SYNC) return 1;
    return 0;
};
const inflateResetKeep = (strm)=>{
    if (inflateStateCheck(strm)) return Z_STREAM_ERROR$1;
    const state = strm.state;
    strm.total_in = strm.total_out = state.total = 0;
    strm.msg = ''; /*Z_NULL*/ 
    if (state.wrap) strm.adler = state.wrap & 1;
    state.mode = HEAD;
    state.last = 0;
    state.havedict = 0;
    state.flags = -1;
    state.dmax = 32768;
    state.head = null /*Z_NULL*/ ;
    state.hold = 0;
    state.bits = 0;
    //state.lencode = state.distcode = state.next = state.codes;
    state.lencode = state.lendyn = new Int32Array(ENOUGH_LENS);
    state.distcode = state.distdyn = new Int32Array(ENOUGH_DISTS);
    state.sane = 1;
    state.back = -1;
    //Tracev((stderr, "inflate: reset\n"));
    return Z_OK$1;
};
const inflateReset = (strm)=>{
    if (inflateStateCheck(strm)) return Z_STREAM_ERROR$1;
    const state = strm.state;
    state.wsize = 0;
    state.whave = 0;
    state.wnext = 0;
    return inflateResetKeep(strm);
};
const inflateReset2 = (strm, windowBits)=>{
    let wrap;
    /* get the state */ if (inflateStateCheck(strm)) return Z_STREAM_ERROR$1;
    const state = strm.state;
    /* extract wrap request from windowBits parameter */ if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else {
        wrap = (windowBits >> 4) + 5;
        if (windowBits < 48) windowBits &= 15;
    }
    /* set number of window bits, free window if different */ if (windowBits && (windowBits < 8 || windowBits > 15)) return Z_STREAM_ERROR$1;
    if (state.window !== null && state.wbits !== windowBits) state.window = null;
    /* update state and reset the rest of it */ state.wrap = wrap;
    state.wbits = windowBits;
    return inflateReset(strm);
};
const inflateInit2 = (strm, windowBits)=>{
    if (!strm) return Z_STREAM_ERROR$1;
    //strm.msg = Z_NULL;                 /* in case we return an error */
    const state = new InflateState();
    //if (state === Z_NULL) return Z_MEM_ERROR;
    //Tracev((stderr, "inflate: allocated\n"));
    strm.state = state;
    state.strm = strm;
    state.window = null /*Z_NULL*/ ;
    state.mode = HEAD; /* to pass state test in inflateReset2() */ 
    const ret = inflateReset2(strm, windowBits);
    if (ret !== Z_OK$1) strm.state = null /*Z_NULL*/ ;
    return ret;
};
const inflateInit = (strm)=>{
    return inflateInit2(strm, DEF_WBITS);
};
/*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */ let virgin = true;
let lenfix, distfix; // We have no pointers in JS, so keep tables separate
const fixedtables = (state)=>{
    /* build fixed huffman tables if first call (may not be thread safe) */ if (virgin) {
        lenfix = new Int32Array(512);
        distfix = new Int32Array(32);
        /* literal/length table */ let sym = 0;
        while(sym < 144)state.lens[sym++] = 8;
        while(sym < 256)state.lens[sym++] = 9;
        while(sym < 280)state.lens[sym++] = 7;
        while(sym < 288)state.lens[sym++] = 8;
        inftrees(LENS, state.lens, 0, 288, lenfix, 0, state.work, {
            bits: 9
        });
        /* distance table */ sym = 0;
        while(sym < 32)state.lens[sym++] = 5;
        inftrees(DISTS, state.lens, 0, 32, distfix, 0, state.work, {
            bits: 5
        });
        /* do this just once */ virgin = false;
    }
    state.lencode = lenfix;
    state.lenbits = 9;
    state.distcode = distfix;
    state.distbits = 5;
};
/*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */ const updatewindow = (strm, src, end, copy)=>{
    let dist;
    const state = strm.state;
    /* if it hasn't been done already, allocate space for the window */ if (state.window === null) {
        state.wsize = 1 << state.wbits;
        state.wnext = 0;
        state.whave = 0;
        state.window = new Uint8Array(state.wsize);
    }
    /* copy state->wsize or less output bytes into the circular window */ if (copy >= state.wsize) {
        state.window.set(src.subarray(end - state.wsize, end), 0);
        state.wnext = 0;
        state.whave = state.wsize;
    } else {
        dist = state.wsize - state.wnext;
        if (dist > copy) dist = copy;
        //zmemcpy(state->window + state->wnext, end - copy, dist);
        state.window.set(src.subarray(end - copy, end - copy + dist), state.wnext);
        copy -= dist;
        if (copy) {
            //zmemcpy(state->window, end - copy, copy);
            state.window.set(src.subarray(end - copy, end), 0);
            state.wnext = copy;
            state.whave = state.wsize;
        } else {
            state.wnext += dist;
            if (state.wnext === state.wsize) state.wnext = 0;
            if (state.whave < state.wsize) state.whave += dist;
        }
    }
    return 0;
};
const inflate$2 = (strm, flush)=>{
    let state;
    let input, output; // input/output buffers
    let next; /* next input INDEX */ 
    let put; /* next output INDEX */ 
    let have, left; /* available input and output */ 
    let hold; /* bit buffer */ 
    let bits; /* bits in bit buffer */ 
    let _in, _out; /* save starting available input and output */ 
    let copy; /* number of stored or match bytes to copy */ 
    let from; /* where to copy match bytes from */ 
    let from_source;
    let here = 0; /* current decoding table entry */ 
    let here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
    //let last;                   /* parent table entry */
    let last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
    let len; /* length to copy for repeats, bits to drop */ 
    let ret; /* return code */ 
    const hbuf = new Uint8Array(4); /* buffer for gzip header crc calculation */ 
    let opts;
    let n; // temporary variable for NEED_BITS
    const order = /* permutation of code lengths */ new Uint8Array([
        16,
        17,
        18,
        0,
        8,
        7,
        9,
        6,
        10,
        5,
        11,
        4,
        12,
        3,
        13,
        2,
        14,
        1,
        15
    ]);
    if (inflateStateCheck(strm) || !strm.output || !strm.input && strm.avail_in !== 0) return Z_STREAM_ERROR$1;
    state = strm.state;
    if (state.mode === TYPE) state.mode = TYPEDO;
     /* skip check */ 
    //--- LOAD() ---
    put = strm.next_out;
    output = strm.output;
    left = strm.avail_out;
    next = strm.next_in;
    input = strm.input;
    have = strm.avail_in;
    hold = state.hold;
    bits = state.bits;
    //---
    _in = have;
    _out = left;
    ret = Z_OK$1;
    inf_leave: for(;;)switch(state.mode){
        case HEAD:
            if (state.wrap === 0) {
                state.mode = TYPEDO;
                break;
            }
            //=== NEEDBITS(16);
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.wrap & 2 && hold === 0x8b1f) {
                if (state.wbits === 0) state.wbits = 15;
                state.check = 0 /*crc32(0L, Z_NULL, 0)*/ ;
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = crc32_1(state.check, hbuf, 2, 0);
                //===//
                //=== INITBITS();
                hold = 0;
                bits = 0;
                //===//
                state.mode = FLAGS;
                break;
            }
            if (state.head) state.head.done = false;
            if (!(state.wrap & 1) || /* check if zlib header allowed */ (((hold & 0xff) << 8) + (hold >> 8)) % 31) {
                strm.msg = 'incorrect header check';
                state.mode = BAD;
                break;
            }
            if ((hold & 0x0f) !== Z_DEFLATED) {
                strm.msg = 'unknown compression method';
                state.mode = BAD;
                break;
            }
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            len = (hold & 0x0f) + 8;
            if (state.wbits === 0) state.wbits = len;
            if (len > 15 || len > state.wbits) {
                strm.msg = 'invalid window size';
                state.mode = BAD;
                break;
            }
            // !!! pako patch. Force use `options.windowBits` if passed.
            // Required to always use max window size by default.
            state.dmax = 1 << state.wbits;
            //state.dmax = 1 << len;
            state.flags = 0; /* indicate zlib header */ 
            //Tracev((stderr, "inflate:   zlib header ok\n"));
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = hold & 0x200 ? DICTID : TYPE;
            //=== INITBITS();
            hold = 0;
            bits = 0;
            break;
        case FLAGS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.flags = hold;
            if ((state.flags & 0xff) !== Z_DEFLATED) {
                strm.msg = 'unknown compression method';
                state.mode = BAD;
                break;
            }
            if (state.flags & 0xe000) {
                strm.msg = 'unknown header flags set';
                state.mode = BAD;
                break;
            }
            if (state.head) state.head.text = hold >> 8 & 1;
            if (state.flags & 0x0200 && state.wrap & 4) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = crc32_1(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = TIME;
        /* falls through */ case TIME:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) state.head.time = hold;
            if (state.flags & 0x0200 && state.wrap & 4) {
                //=== CRC4(state.check, hold)
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                hbuf[2] = hold >>> 16 & 0xff;
                hbuf[3] = hold >>> 24 & 0xff;
                state.check = crc32_1(state.check, hbuf, 4, 0);
            //===
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = OS;
        /* falls through */ case OS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) {
                state.head.xflags = hold & 0xff;
                state.head.os = hold >> 8;
            }
            if (state.flags & 0x0200 && state.wrap & 4) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = crc32_1(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = EXLEN;
        /* falls through */ case EXLEN:
            if (state.flags & 0x0400) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length = hold;
                if (state.head) state.head.extra_len = hold;
                if (state.flags & 0x0200 && state.wrap & 4) {
                    //=== CRC2(state.check, hold);
                    hbuf[0] = hold & 0xff;
                    hbuf[1] = hold >>> 8 & 0xff;
                    state.check = crc32_1(state.check, hbuf, 2, 0);
                //===//
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            } else if (state.head) state.head.extra = null /*Z_NULL*/ ;
            state.mode = EXTRA;
        /* falls through */ case EXTRA:
            if (state.flags & 0x0400) {
                copy = state.length;
                if (copy > have) copy = have;
                if (copy) {
                    if (state.head) {
                        len = state.head.extra_len - state.length;
                        if (!state.head.extra) // Use untyped array for more convenient processing later
                        state.head.extra = new Uint8Array(state.head.extra_len);
                        state.head.extra.set(input.subarray(next, // extra field is limited to 65536 bytes
                        // - no need for additional size check
                        next + copy), /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/ len);
                    //zmemcpy(state.head.extra + len, next,
                    //        len + copy > state.head.extra_max ?
                    //        state.head.extra_max - len : copy);
                    }
                    if (state.flags & 0x0200 && state.wrap & 4) state.check = crc32_1(state.check, input, copy, next);
                    have -= copy;
                    next += copy;
                    state.length -= copy;
                }
                if (state.length) break inf_leave;
            }
            state.length = 0;
            state.mode = NAME;
        /* falls through */ case NAME:
            if (state.flags & 0x0800) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    // TODO: 2 or 1 bytes?
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.name_max*/ ) state.head.name += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200 && state.wrap & 4) state.check = crc32_1(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.name = null;
            state.length = 0;
            state.mode = COMMENT;
        /* falls through */ case COMMENT:
            if (state.flags & 0x1000) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.comm_max*/ ) state.head.comment += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200 && state.wrap & 4) state.check = crc32_1(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.comment = null;
            state.mode = HCRC;
        /* falls through */ case HCRC:
            if (state.flags & 0x0200) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (state.wrap & 4 && hold !== (state.check & 0xffff)) {
                    strm.msg = 'header crc mismatch';
                    state.mode = BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            }
            if (state.head) {
                state.head.hcrc = state.flags >> 9 & 1;
                state.head.done = true;
            }
            strm.adler = state.check = 0;
            state.mode = TYPE;
            break;
        case DICTID:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            strm.adler = state.check = zswap32(hold);
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = DICT;
        /* falls through */ case DICT:
            if (state.havedict === 0) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                return Z_NEED_DICT$1;
            }
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = TYPE;
        /* falls through */ case TYPE:
            if (flush === Z_BLOCK || flush === Z_TREES) break inf_leave;
        /* falls through */ case TYPEDO:
            if (state.last) {
                //--- BYTEBITS() ---//
                hold >>>= bits & 7;
                bits -= bits & 7;
                //---//
                state.mode = CHECK;
                break;
            }
            //=== NEEDBITS(3); */
            while(bits < 3){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.last = hold & 0x01 /*BITS(1)*/ ;
            //--- DROPBITS(1) ---//
            hold >>>= 1;
            bits -= 1;
            //---//
            switch(hold & 0x03){
                case 0:
                    /* stored block */ //Tracev((stderr, "inflate:     stored block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = STORED;
                    break;
                case 1:
                    /* fixed block */ fixedtables(state);
                    //Tracev((stderr, "inflate:     fixed codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = LEN_; /* decode codes */ 
                    if (flush === Z_TREES) {
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                        break inf_leave;
                    }
                    break;
                case 2:
                    /* dynamic block */ //Tracev((stderr, "inflate:     dynamic codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = TABLE;
                    break;
                case 3:
                    strm.msg = 'invalid block type';
                    state.mode = BAD;
            }
            //--- DROPBITS(2) ---//
            hold >>>= 2;
            bits -= 2;
            break;
        case STORED:
            //--- BYTEBITS() ---// /* go to byte boundary */
            hold >>>= bits & 7;
            bits -= bits & 7;
            //---//
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if ((hold & 0xffff) !== (hold >>> 16 ^ 0xffff)) {
                strm.msg = 'invalid stored block lengths';
                state.mode = BAD;
                break;
            }
            state.length = hold & 0xffff;
            //Tracev((stderr, "inflate:       stored length %u\n",
            //        state.length));
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = COPY_;
            if (flush === Z_TREES) break inf_leave;
        /* falls through */ case COPY_:
            state.mode = COPY;
        /* falls through */ case COPY:
            copy = state.length;
            if (copy) {
                if (copy > have) copy = have;
                if (copy > left) copy = left;
                if (copy === 0) break inf_leave;
                //--- zmemcpy(put, next, copy); ---
                output.set(input.subarray(next, next + copy), put);
                //---//
                have -= copy;
                next += copy;
                left -= copy;
                put += copy;
                state.length -= copy;
                break;
            }
            //Tracev((stderr, "inflate:       stored end\n"));
            state.mode = TYPE;
            break;
        case TABLE:
            //=== NEEDBITS(14); */
            while(bits < 14){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.nlen = (hold & 0x1f) + 257;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ndist = (hold & 0x1f) + 1;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ncode = (hold & 0x0f) + 4;
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            //#ifndef PKZIP_BUG_WORKAROUND
            if (state.nlen > 286 || state.ndist > 30) {
                strm.msg = 'too many length or distance symbols';
                state.mode = BAD;
                break;
            }
            //#endif
            //Tracev((stderr, "inflate:       table sizes ok\n"));
            state.have = 0;
            state.mode = LENLENS;
        /* falls through */ case LENLENS:
            while(state.have < state.ncode){
                //=== NEEDBITS(3);
                while(bits < 3){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.lens[order[state.have++]] = hold & 0x07; //BITS(3);
                //--- DROPBITS(3) ---//
                hold >>>= 3;
                bits -= 3;
            //---//
            }
            while(state.have < 19)state.lens[order[state.have++]] = 0;
            // We have separate tables & no pointers. 2 commented lines below not needed.
            //state.next = state.codes;
            //state.lencode = state.next;
            // Switch to use dynamic table
            state.lencode = state.lendyn;
            state.lenbits = 7;
            opts = {
                bits: state.lenbits
            };
            ret = inftrees(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
            state.lenbits = opts.bits;
            if (ret) {
                strm.msg = 'invalid code lengths set';
                state.mode = BAD;
                break;
            }
            //Tracev((stderr, "inflate:       code lengths ok\n"));
            state.have = 0;
            state.mode = CODELENS;
        /* falls through */ case CODELENS:
            while(state.have < state.nlen + state.ndist){
                for(;;){
                    here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                if (here_val < 16) {
                    //--- DROPBITS(here.bits) ---//
                    hold >>>= here_bits;
                    bits -= here_bits;
                    //---//
                    state.lens[state.have++] = here_val;
                } else {
                    if (here_val === 16) {
                        //=== NEEDBITS(here.bits + 2);
                        n = here_bits + 2;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        if (state.have === 0) {
                            strm.msg = 'invalid bit length repeat';
                            state.mode = BAD;
                            break;
                        }
                        len = state.lens[state.have - 1];
                        copy = 3 + (hold & 0x03); //BITS(2);
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                    //---//
                    } else if (here_val === 17) {
                        //=== NEEDBITS(here.bits + 3);
                        n = here_bits + 3;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 3 + (hold & 0x07); //BITS(3);
                        //--- DROPBITS(3) ---//
                        hold >>>= 3;
                        bits -= 3;
                    //---//
                    } else {
                        //=== NEEDBITS(here.bits + 7);
                        n = here_bits + 7;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 11 + (hold & 0x7f); //BITS(7);
                        //--- DROPBITS(7) ---//
                        hold >>>= 7;
                        bits -= 7;
                    //---//
                    }
                    if (state.have + copy > state.nlen + state.ndist) {
                        strm.msg = 'invalid bit length repeat';
                        state.mode = BAD;
                        break;
                    }
                    while(copy--)state.lens[state.have++] = len;
                }
            }
            /* handle error breaks in while */ if (state.mode === BAD) break;
            /* check for end-of-block code (better have one) */ if (state.lens[256] === 0) {
                strm.msg = 'invalid code -- missing end-of-block';
                state.mode = BAD;
                break;
            }
            /* build code tables -- note: do not change the lenbits or distbits
           values here (9 and 6) without reading the comments in inftrees.h
           concerning the ENOUGH constants, which depend on those values */ state.lenbits = 9;
            opts = {
                bits: state.lenbits
            };
            ret = inftrees(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.lenbits = opts.bits;
            // state.lencode = state.next;
            if (ret) {
                strm.msg = 'invalid literal/lengths set';
                state.mode = BAD;
                break;
            }
            state.distbits = 6;
            //state.distcode.copy(state.codes);
            // Switch to use dynamic table
            state.distcode = state.distdyn;
            opts = {
                bits: state.distbits
            };
            ret = inftrees(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.distbits = opts.bits;
            // state.distcode = state.next;
            if (ret) {
                strm.msg = 'invalid distances set';
                state.mode = BAD;
                break;
            }
            //Tracev((stderr, 'inflate:       codes ok\n'));
            state.mode = LEN_;
            if (flush === Z_TREES) break inf_leave;
        /* falls through */ case LEN_:
            state.mode = LEN;
        /* falls through */ case LEN:
            if (have >= 6 && left >= 258) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                inffast(strm, _out);
                //--- LOAD() ---
                put = strm.next_out;
                output = strm.output;
                left = strm.avail_out;
                next = strm.next_in;
                input = strm.input;
                have = strm.avail_in;
                hold = state.hold;
                bits = state.bits;
                //---
                if (state.mode === TYPE) state.back = -1;
                break;
            }
            state.back = 0;
            for(;;){
                here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if (here_op && (here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.lencode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            state.length = here_val;
            if (here_op === 0) {
                //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
                //        "inflate:         literal '%c'\n" :
                //        "inflate:         literal 0x%02x\n", here.val));
                state.mode = LIT;
                break;
            }
            if (here_op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.back = -1;
                state.mode = TYPE;
                break;
            }
            if (here_op & 64) {
                strm.msg = 'invalid literal/length code';
                state.mode = BAD;
                break;
            }
            state.extra = here_op & 15;
            state.mode = LENEXT;
        /* falls through */ case LENEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //Tracevv((stderr, "inflate:         length %u\n", state.length));
            state.was = state.length;
            state.mode = DIST;
        /* falls through */ case DIST:
            for(;;){
                here = state.distcode[hold & (1 << state.distbits) - 1]; /*BITS(state.distbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if ((here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.distcode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            if (here_op & 64) {
                strm.msg = 'invalid distance code';
                state.mode = BAD;
                break;
            }
            state.offset = here_val;
            state.extra = here_op & 15;
            state.mode = DISTEXT;
        /* falls through */ case DISTEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.offset += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //#ifdef INFLATE_STRICT
            if (state.offset > state.dmax) {
                strm.msg = 'invalid distance too far back';
                state.mode = BAD;
                break;
            }
            //#endif
            //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
            state.mode = MATCH;
        /* falls through */ case MATCH:
            if (left === 0) break inf_leave;
            copy = _out - left;
            if (state.offset > copy) {
                copy = state.offset - copy;
                if (copy > state.whave) {
                    if (state.sane) {
                        strm.msg = 'invalid distance too far back';
                        state.mode = BAD;
                        break;
                    }
                }
                if (copy > state.wnext) {
                    copy -= state.wnext;
                    from = state.wsize - copy;
                } else from = state.wnext - copy;
                if (copy > state.length) copy = state.length;
                from_source = state.window;
            } else {
                from_source = output;
                from = put - state.offset;
                copy = state.length;
            }
            if (copy > left) copy = left;
            left -= copy;
            state.length -= copy;
            do output[put++] = from_source[from++];
            while (--copy);
            if (state.length === 0) state.mode = LEN;
            break;
        case LIT:
            if (left === 0) break inf_leave;
            output[put++] = state.length;
            left--;
            state.mode = LEN;
            break;
        case CHECK:
            if (state.wrap) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    // Use '|' instead of '+' to make sure that result is signed
                    hold |= input[next++] << bits;
                    bits += 8;
                }
                //===//
                _out -= left;
                strm.total_out += _out;
                state.total += _out;
                if (state.wrap & 4 && _out) strm.adler = state.check = /*UPDATE_CHECK(state.check, put - _out, _out);*/ state.flags ? crc32_1(state.check, output, _out, put - _out) : adler32_1(state.check, output, _out, put - _out);
                _out = left;
                // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
                if (state.wrap & 4 && (state.flags ? hold : zswap32(hold)) !== state.check) {
                    strm.msg = 'incorrect data check';
                    state.mode = BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   check matches trailer\n"));
            }
            state.mode = LENGTH;
        /* falls through */ case LENGTH:
            if (state.wrap && state.flags) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (state.wrap & 4 && hold !== (state.total & 0xffffffff)) {
                    strm.msg = 'incorrect length check';
                    state.mode = BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   length matches trailer\n"));
            }
            state.mode = DONE;
        /* falls through */ case DONE:
            ret = Z_STREAM_END$1;
            break inf_leave;
        case BAD:
            ret = Z_DATA_ERROR$1;
            break inf_leave;
        case MEM:
            return Z_MEM_ERROR$1;
        case SYNC:
        /* falls through */ default:
            return Z_STREAM_ERROR$1;
    }
    // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
    /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */ //--- RESTORE() ---
    strm.next_out = put;
    strm.avail_out = left;
    strm.next_in = next;
    strm.avail_in = have;
    state.hold = hold;
    state.bits = bits;
    //---
    if (state.wsize || _out !== strm.avail_out && state.mode < BAD && (state.mode < CHECK || flush !== Z_FINISH$1)) updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out);
    _in -= strm.avail_in;
    _out -= strm.avail_out;
    strm.total_in += _in;
    strm.total_out += _out;
    state.total += _out;
    if (state.wrap & 4 && _out) strm.adler = state.check = /*UPDATE_CHECK(state.check, strm.next_out - _out, _out);*/ state.flags ? crc32_1(state.check, output, _out, strm.next_out - _out) : adler32_1(state.check, output, _out, strm.next_out - _out);
    strm.data_type = state.bits + (state.last ? 64 : 0) + (state.mode === TYPE ? 128 : 0) + (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
    if ((_in === 0 && _out === 0 || flush === Z_FINISH$1) && ret === Z_OK$1) ret = Z_BUF_ERROR;
    return ret;
};
const inflateEnd = (strm)=>{
    if (inflateStateCheck(strm)) return Z_STREAM_ERROR$1;
    let state = strm.state;
    if (state.window) state.window = null;
    strm.state = null;
    return Z_OK$1;
};
const inflateGetHeader = (strm, head)=>{
    /* check state */ if (inflateStateCheck(strm)) return Z_STREAM_ERROR$1;
    const state = strm.state;
    if ((state.wrap & 2) === 0) return Z_STREAM_ERROR$1;
    /* save header structure */ state.head = head;
    head.done = false;
    return Z_OK$1;
};
const inflateSetDictionary = (strm, dictionary)=>{
    const dictLength = dictionary.length;
    let state;
    let dictid;
    let ret;
    /* check state */ if (inflateStateCheck(strm)) return Z_STREAM_ERROR$1;
    state = strm.state;
    if (state.wrap !== 0 && state.mode !== DICT) return Z_STREAM_ERROR$1;
    /* check for correct dictionary identifier */ if (state.mode === DICT) {
        dictid = 1; /* adler32(0, null, 0)*/ 
        /* dictid = adler32(dictid, dictionary, dictLength); */ dictid = adler32_1(dictid, dictionary, dictLength, 0);
        if (dictid !== state.check) return Z_DATA_ERROR$1;
    }
    /* copy dictionary to window using updatewindow(), which will amend the
   existing dictionary if appropriate */ ret = updatewindow(strm, dictionary, dictLength, dictLength);
    if (ret) {
        state.mode = MEM;
        return Z_MEM_ERROR$1;
    }
    state.havedict = 1;
    // Tracev((stderr, "inflate:   dictionary set\n"));
    return Z_OK$1;
};
var inflateReset_1 = inflateReset;
var inflateReset2_1 = inflateReset2;
var inflateResetKeep_1 = inflateResetKeep;
var inflateInit_1 = inflateInit;
var inflateInit2_1 = inflateInit2;
var inflate_2$1 = inflate$2;
var inflateEnd_1 = inflateEnd;
var inflateGetHeader_1 = inflateGetHeader;
var inflateSetDictionary_1 = inflateSetDictionary;
var inflateInfo = 'pako inflate (from Nodeca project)';
/* Not implemented
module.exports.inflateCodesUsed = inflateCodesUsed;
module.exports.inflateCopy = inflateCopy;
module.exports.inflateGetDictionary = inflateGetDictionary;
module.exports.inflateMark = inflateMark;
module.exports.inflatePrime = inflatePrime;
module.exports.inflateSync = inflateSync;
module.exports.inflateSyncPoint = inflateSyncPoint;
module.exports.inflateUndermine = inflateUndermine;
module.exports.inflateValidate = inflateValidate;
*/ var inflate_1$2 = {
    inflateReset: inflateReset_1,
    inflateReset2: inflateReset2_1,
    inflateResetKeep: inflateResetKeep_1,
    inflateInit: inflateInit_1,
    inflateInit2: inflateInit2_1,
    inflate: inflate_2$1,
    inflateEnd: inflateEnd_1,
    inflateGetHeader: inflateGetHeader_1,
    inflateSetDictionary: inflateSetDictionary_1,
    inflateInfo: inflateInfo
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function GZheader() {
    /* true if compressed data believed to be text */ this.text = 0;
    /* modification time */ this.time = 0;
    /* extra flags (not used when writing a gzip file) */ this.xflags = 0;
    /* operating system */ this.os = 0;
    /* pointer to extra field or Z_NULL if none */ this.extra = null;
    /* extra field length (valid if extra != Z_NULL) */ this.extra_len = 0; // Actually, we don't need it in JS,
    // but leave for few code modifications
    //
    // Setup limits is not necessary because in js we should not preallocate memory
    // for inflate use constant limit in 65536 bytes
    //
    /* space at extra (only when reading header) */ // this.extra_max  = 0;
    /* pointer to zero-terminated file name or Z_NULL */ this.name = '';
    /* space at name (only when reading header) */ // this.name_max   = 0;
    /* pointer to zero-terminated comment or Z_NULL */ this.comment = '';
    /* space at comment (only when reading header) */ // this.comm_max   = 0;
    /* true if there was or will be a header crc */ this.hcrc = 0;
    /* true when done reading gzip header (not used when writing a gzip file) */ this.done = false;
}
var gzheader = GZheader;
const toString = Object.prototype.toString;
/* Public constants ==========================================================*/ /* ===========================================================================*/ const { Z_NO_FLUSH, Z_FINISH, Z_OK, Z_STREAM_END, Z_NEED_DICT, Z_STREAM_ERROR, Z_DATA_ERROR, Z_MEM_ERROR } = constants$2;
/* ===========================================================================*/ /**
 * class Inflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[inflate]]
 * and [[inflateRaw]].
 **/ /* internal
 * inflate.chunks -> Array
 *
 * Chunks of output data, if [[Inflate#onData]] not overridden.
 **/ /**
 * Inflate.result -> Uint8Array|String
 *
 * Uncompressed result, generated by default [[Inflate#onData]]
 * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Inflate#push]] with `Z_FINISH` / `true` param).
 **/ /**
 * Inflate.err -> Number
 *
 * Error code after inflate finished. 0 (Z_OK) on success.
 * Should be checked if broken data possible.
 **/ /**
 * Inflate.msg -> String
 *
 * Error message, if [[Inflate.err]] != 0
 **/ /**
 * new Inflate(options)
 * - options (Object): zlib inflate options.
 *
 * Creates new inflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `windowBits`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw inflate
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 * By default, when no options set, autodetect deflate/gzip data format via
 * wrapper header.
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako')
 * const chunk1 = new Uint8Array([1,2,3,4,5,6,7,8,9])
 * const chunk2 = new Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * const inflate = new pako.Inflate({ level: 3});
 *
 * inflate.push(chunk1, false);
 * inflate.push(chunk2, true);  // true -> last chunk
 *
 * if (inflate.err) { throw new Error(inflate.err); }
 *
 * console.log(inflate.result);
 * ```
 **/ function Inflate$1(options) {
    this.options = common.assign({
        chunkSize: 65536,
        windowBits: 15,
        to: ''
    }, options || {});
    const opt = this.options;
    // Force window size for `raw` data, if not set directly,
    // because we have no header for autodetect.
    if (opt.raw && opt.windowBits >= 0 && opt.windowBits < 16) {
        opt.windowBits = -opt.windowBits;
        if (opt.windowBits === 0) opt.windowBits = -15;
    }
    // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
    if (opt.windowBits >= 0 && opt.windowBits < 16 && !(options && options.windowBits)) opt.windowBits += 32;
    // Gzip header has no info about windows size, we can do autodetect only
    // for deflate. So, if window size not set, force it to max when gzip possible
    if (opt.windowBits > 15 && opt.windowBits < 48) // bit 3 (16) -> gzipped data
    // bit 4 (32) -> autodetect gzip/deflate
    {
        if ((opt.windowBits & 15) === 0) opt.windowBits |= 15;
    }
    this.err = 0; // error code, if happens (0 = Z_OK)
    this.msg = ''; // error message
    this.ended = false; // used to avoid multiple onEnd() calls
    this.chunks = []; // chunks of compressed data
    this.strm = new zstream();
    this.strm.avail_out = 0;
    let status = inflate_1$2.inflateInit2(this.strm, opt.windowBits);
    if (status !== Z_OK) throw new Error(messages[status]);
    this.header = new gzheader();
    inflate_1$2.inflateGetHeader(this.strm, this.header);
    // Setup dictionary
    if (opt.dictionary) {
        // Convert data if needed
        if (typeof opt.dictionary === 'string') opt.dictionary = strings.string2buf(opt.dictionary);
        else if (toString.call(opt.dictionary) === '[object ArrayBuffer]') opt.dictionary = new Uint8Array(opt.dictionary);
        if (opt.raw) {
            status = inflate_1$2.inflateSetDictionary(this.strm, opt.dictionary);
            if (status !== Z_OK) throw new Error(messages[status]);
        }
    }
}
/**
 * Inflate#push(data[, flush_mode]) -> Boolean
 * - data (Uint8Array|ArrayBuffer): input data
 * - flush_mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE
 *   flush modes. See constants. Skipped or `false` means Z_NO_FLUSH,
 *   `true` means Z_FINISH.
 *
 * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
 * new output chunks. Returns `true` on success. If end of stream detected,
 * [[Inflate#onEnd]] will be called.
 *
 * `flush_mode` is not needed for normal operation, because end of stream
 * detected automatically. You may try to use it for advanced things, but
 * this functionality was not tested.
 *
 * On fail call [[Inflate#onEnd]] with error code and return false.
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/ Inflate$1.prototype.push = function(data, flush_mode) {
    const strm = this.strm;
    const chunkSize = this.options.chunkSize;
    const dictionary = this.options.dictionary;
    let status, _flush_mode, last_avail_out;
    if (this.ended) return false;
    if (flush_mode === ~~flush_mode) _flush_mode = flush_mode;
    else _flush_mode = flush_mode === true ? Z_FINISH : Z_NO_FLUSH;
    // Convert data if needed
    if (toString.call(data) === '[object ArrayBuffer]') strm.input = new Uint8Array(data);
    else strm.input = data;
    strm.next_in = 0;
    strm.avail_in = strm.input.length;
    for(;;){
        if (strm.avail_out === 0) {
            strm.output = new Uint8Array(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
        }
        status = inflate_1$2.inflate(strm, _flush_mode);
        if (status === Z_NEED_DICT && dictionary) {
            status = inflate_1$2.inflateSetDictionary(strm, dictionary);
            if (status === Z_OK) status = inflate_1$2.inflate(strm, _flush_mode);
            else if (status === Z_DATA_ERROR) // Replace code with more verbose
            status = Z_NEED_DICT;
        }
        // Skip snyc markers if more data follows and not raw mode
        while(strm.avail_in > 0 && status === Z_STREAM_END && strm.state.wrap > 0 && data[strm.next_in] !== 0){
            inflate_1$2.inflateReset(strm);
            status = inflate_1$2.inflate(strm, _flush_mode);
        }
        switch(status){
            case Z_STREAM_ERROR:
            case Z_DATA_ERROR:
            case Z_NEED_DICT:
            case Z_MEM_ERROR:
                this.onEnd(status);
                this.ended = true;
                return false;
        }
        // Remember real `avail_out` value, because we may patch out buffer content
        // to align utf8 strings boundaries.
        last_avail_out = strm.avail_out;
        if (strm.next_out) {
            if (strm.avail_out === 0 || status === Z_STREAM_END) {
                if (this.options.to === 'string') {
                    let next_out_utf8 = strings.utf8border(strm.output, strm.next_out);
                    let tail = strm.next_out - next_out_utf8;
                    let utf8str = strings.buf2string(strm.output, next_out_utf8);
                    // move tail & realign counters
                    strm.next_out = tail;
                    strm.avail_out = chunkSize - tail;
                    if (tail) strm.output.set(strm.output.subarray(next_out_utf8, next_out_utf8 + tail), 0);
                    this.onData(utf8str);
                } else this.onData(strm.output.length === strm.next_out ? strm.output : strm.output.subarray(0, strm.next_out));
            }
        }
        // Must repeat iteration if out buffer is full
        if (status === Z_OK && last_avail_out === 0) continue;
        // Finalize if end of stream reached.
        if (status === Z_STREAM_END) {
            status = inflate_1$2.inflateEnd(this.strm);
            this.onEnd(status);
            this.ended = true;
            return true;
        }
        if (strm.avail_in === 0) break;
    }
    return true;
};
/**
 * Inflate#onData(chunk) -> Void
 * - chunk (Uint8Array|String): output data. When string output requested,
 *   each chunk will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/ Inflate$1.prototype.onData = function(chunk) {
    this.chunks.push(chunk);
};
/**
 * Inflate#onEnd(status) -> Void
 * - status (Number): inflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called either after you tell inflate that the input stream is
 * complete (Z_FINISH). By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/ Inflate$1.prototype.onEnd = function(status) {
    // On success - join
    if (status === Z_OK) {
        if (this.options.to === 'string') this.result = this.chunks.join('');
        else this.result = common.flattenChunks(this.chunks);
    }
    this.chunks = [];
    this.err = status;
    this.msg = this.strm.msg;
};
/**
 * inflate(data[, options]) -> Uint8Array|String
 * - data (Uint8Array|ArrayBuffer): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Decompress `data` with inflate/ungzip and `options`. Autodetect
 * format via wrapper header by default. That's why we don't provide
 * separate `ungzip` method.
 *
 * Supported options are:
 *
 * - windowBits
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako');
 * const input = pako.deflate(new Uint8Array([1,2,3,4,5,6,7,8,9]));
 * let output;
 *
 * try {
 *   output = pako.inflate(input);
 * } catch (err) {
 *   console.log(err);
 * }
 * ```
 **/ function inflate$1(input, options) {
    const inflator = new Inflate$1(options);
    inflator.push(input);
    // That will never happens, if you don't cheat with options :)
    if (inflator.err) throw inflator.msg || messages[inflator.err];
    return inflator.result;
}
/**
 * inflateRaw(data[, options]) -> Uint8Array|String
 * - data (Uint8Array|ArrayBuffer): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * The same as [[inflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/ function inflateRaw$1(input, options) {
    options = options || {};
    options.raw = true;
    return inflate$1(input, options);
}
/**
 * ungzip(data[, options]) -> Uint8Array|String
 * - data (Uint8Array|ArrayBuffer): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Just shortcut to [[inflate]], because it autodetects format
 * by header.content. Done for convenience.
 **/ var Inflate_1$1 = Inflate$1;
var inflate_2 = inflate$1;
var inflateRaw_1$1 = inflateRaw$1;
var ungzip$1 = inflate$1;
var constants = constants$2;
var inflate_1$1 = {
    Inflate: Inflate_1$1,
    inflate: inflate_2,
    inflateRaw: inflateRaw_1$1,
    ungzip: ungzip$1,
    constants: constants
};
const { Deflate, deflate, deflateRaw, gzip } = deflate_1$1;
const { Inflate, inflate, inflateRaw, ungzip } = inflate_1$1;
var Deflate_1 = Deflate;
var deflate_1 = deflate;
var deflateRaw_1 = deflateRaw;
var gzip_1 = gzip;
var Inflate_1 = Inflate;
var inflate_1 = inflate;
var inflateRaw_1 = inflateRaw;
var ungzip_1 = ungzip;
var constants_1 = constants$2;
var pako = {
    Deflate: Deflate_1,
    deflate: deflate_1,
    deflateRaw: deflateRaw_1,
    gzip: gzip_1,
    Inflate: Inflate_1,
    inflate: inflate_1,
    inflateRaw: inflateRaw_1,
    ungzip: ungzip_1,
    constants: constants_1
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lMHUJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "checkCrc", ()=>checkCrc);
parcelHelpers.export(exports, "writeCrc", ()=>writeCrc);
const crcTable = [];
for(let n = 0; n < 256; n++){
    let c = n;
    for(let k = 0; k < 8; k++)if (c & 1) c = 0xedb88320 ^ c >>> 1;
    else c = c >>> 1;
    crcTable[n] = c;
}
const initialCrc = 0xffffffff;
function updateCrc(currentCrc, data, length) {
    let c = currentCrc;
    for(let n = 0; n < length; n++)c = crcTable[(c ^ data[n]) & 0xff] ^ c >>> 8;
    return c;
}
function crc(data, length) {
    return (updateCrc(initialCrc, data, length) ^ initialCrc) >>> 0;
}
function checkCrc(buffer, crcLength, chunkName) {
    const expectedCrc = buffer.readUint32();
    const actualCrc = crc(new Uint8Array(buffer.buffer, buffer.byteOffset + buffer.offset - crcLength - 4, crcLength), crcLength); // "- 4" because we already advanced by reading the CRC
    if (actualCrc !== expectedCrc) throw new Error(`CRC mismatch for chunk ${chunkName}. Expected ${expectedCrc}, found ${actualCrc}`);
}
function writeCrc(buffer, length) {
    buffer.writeUint32(crc(new Uint8Array(buffer.buffer, buffer.byteOffset + buffer.offset - length, length), length));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ieqRH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Decodes the Adam7 interlaced PNG data.
 *
 * @param params - DecodeInterlaceNullParams
 * @returns - array of pixel data.
 */ parcelHelpers.export(exports, "decodeInterlaceAdam7", ()=>decodeInterlaceAdam7);
var _applyUnfilter = require("./applyUnfilter");
const uint16 = new Uint16Array([
    0x00ff
]);
const uint8 = new Uint8Array(uint16.buffer);
const osIsLittleEndian = uint8[0] === 0xff;
function decodeInterlaceAdam7(params) {
    const { data, width, height, channels, depth } = params;
    // Adam7 interlacing pattern
    const passes = [
        {
            x: 0,
            y: 0,
            xStep: 8,
            yStep: 8
        },
        {
            x: 4,
            y: 0,
            xStep: 8,
            yStep: 8
        },
        {
            x: 0,
            y: 4,
            xStep: 4,
            yStep: 8
        },
        {
            x: 2,
            y: 0,
            xStep: 4,
            yStep: 4
        },
        {
            x: 0,
            y: 2,
            xStep: 2,
            yStep: 4
        },
        {
            x: 1,
            y: 0,
            xStep: 2,
            yStep: 2
        },
        {
            x: 0,
            y: 1,
            xStep: 1,
            yStep: 2
        }
    ];
    const bytesPerPixel = Math.ceil(depth / 8) * channels;
    const resultData = new Uint8Array(height * width * bytesPerPixel);
    let offset = 0;
    // Process each pass
    for(let passIndex = 0; passIndex < 7; passIndex++){
        const pass = passes[passIndex];
        // Calculate pass dimensions
        const passWidth = Math.ceil((width - pass.x) / pass.xStep);
        const passHeight = Math.ceil((height - pass.y) / pass.yStep);
        if (passWidth <= 0 || passHeight <= 0) continue;
        const passLineBytes = passWidth * bytesPerPixel;
        const prevLine = new Uint8Array(passLineBytes);
        // Process each scanline in this pass
        for(let y = 0; y < passHeight; y++){
            // First byte is the filter type
            const filterType = data[offset++];
            const currentLine = data.subarray(offset, offset + passLineBytes);
            offset += passLineBytes;
            // Create a new line for the unfiltered data
            const newLine = new Uint8Array(passLineBytes);
            // Apply the appropriate unfilter
            (0, _applyUnfilter.applyUnfilter)(filterType, currentLine, newLine, prevLine, passLineBytes, bytesPerPixel);
            prevLine.set(newLine);
            for(let x = 0; x < passWidth; x++){
                const outputX = pass.x + x * pass.xStep;
                const outputY = pass.y + y * pass.yStep;
                if (outputX >= width || outputY >= height) continue;
                for(let i = 0; i < bytesPerPixel; i++)resultData[(outputY * width + outputX) * bytesPerPixel + i] = newLine[x * bytesPerPixel + i];
            }
        }
    }
    if (depth === 16) {
        const uint16Data = new Uint16Array(resultData.buffer);
        if (osIsLittleEndian) for(let k = 0; k < uint16Data.length; k++)// PNG is always big endian. Swap the bytes.
        uint16Data[k] = swap16(uint16Data[k]);
        return uint16Data;
    } else return resultData;
}
function swap16(val) {
    return (val & 0xff) << 8 | val >> 8 & 0xff;
}

},{"./applyUnfilter":"4j7uB","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4j7uB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Apllies filter on scanline based on the filter type.
 * @param filterType - The filter type to apply.
 * @param currentLine - The current line of pixel data.
 * @param newLine - The new line of pixel data.
 * @param prevLine - The previous line of pixel data.
 * @param passLineBytes - The number of bytes in the pass line.
 * @param bytesPerPixel - The number of bytes per pixel.
 */ parcelHelpers.export(exports, "applyUnfilter", ()=>applyUnfilter);
var _unfilter = require("./unfilter");
function applyUnfilter(filterType, currentLine, newLine, prevLine, passLineBytes, bytesPerPixel) {
    switch(filterType){
        case 0:
            (0, _unfilter.unfilterNone)(currentLine, newLine, passLineBytes);
            break;
        case 1:
            (0, _unfilter.unfilterSub)(currentLine, newLine, passLineBytes, bytesPerPixel);
            break;
        case 2:
            (0, _unfilter.unfilterUp)(currentLine, newLine, prevLine, passLineBytes);
            break;
        case 3:
            (0, _unfilter.unfilterAverage)(currentLine, newLine, prevLine, passLineBytes, bytesPerPixel);
            break;
        case 4:
            (0, _unfilter.unfilterPaeth)(currentLine, newLine, prevLine, passLineBytes, bytesPerPixel);
            break;
        default:
            throw new Error(`Unsupported filter: ${filterType}`);
    }
}

},{"./unfilter":"gQknm","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gQknm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unfilterNone", ()=>unfilterNone);
parcelHelpers.export(exports, "unfilterSub", ()=>unfilterSub);
parcelHelpers.export(exports, "unfilterUp", ()=>unfilterUp);
parcelHelpers.export(exports, "unfilterAverage", ()=>unfilterAverage);
parcelHelpers.export(exports, "unfilterPaeth", ()=>unfilterPaeth);
function unfilterNone(currentLine, newLine, bytesPerLine) {
    for(let i = 0; i < bytesPerLine; i++)newLine[i] = currentLine[i];
}
function unfilterSub(currentLine, newLine, bytesPerLine, bytesPerPixel) {
    let i = 0;
    for(; i < bytesPerPixel; i++)// just copy first bytes
    newLine[i] = currentLine[i];
    for(; i < bytesPerLine; i++)newLine[i] = currentLine[i] + newLine[i - bytesPerPixel] & 0xff;
}
function unfilterUp(currentLine, newLine, prevLine, bytesPerLine) {
    let i = 0;
    if (prevLine.length === 0) // just copy bytes for first line
    for(; i < bytesPerLine; i++)newLine[i] = currentLine[i];
    else for(; i < bytesPerLine; i++)newLine[i] = currentLine[i] + prevLine[i] & 0xff;
}
function unfilterAverage(currentLine, newLine, prevLine, bytesPerLine, bytesPerPixel) {
    let i = 0;
    if (prevLine.length === 0) {
        for(; i < bytesPerPixel; i++)newLine[i] = currentLine[i];
        for(; i < bytesPerLine; i++)newLine[i] = currentLine[i] + (newLine[i - bytesPerPixel] >> 1) & 0xff;
    } else {
        for(; i < bytesPerPixel; i++)newLine[i] = currentLine[i] + (prevLine[i] >> 1) & 0xff;
        for(; i < bytesPerLine; i++)newLine[i] = currentLine[i] + (newLine[i - bytesPerPixel] + prevLine[i] >> 1) & 0xff;
    }
}
function unfilterPaeth(currentLine, newLine, prevLine, bytesPerLine, bytesPerPixel) {
    let i = 0;
    if (prevLine.length === 0) {
        for(; i < bytesPerPixel; i++)newLine[i] = currentLine[i];
        for(; i < bytesPerLine; i++)newLine[i] = currentLine[i] + newLine[i - bytesPerPixel] & 0xff;
    } else {
        for(; i < bytesPerPixel; i++)newLine[i] = currentLine[i] + prevLine[i] & 0xff;
        for(; i < bytesPerLine; i++)newLine[i] = currentLine[i] + paethPredictor(newLine[i - bytesPerPixel], prevLine[i], prevLine[i - bytesPerPixel]) & 0xff;
    }
}
function paethPredictor(a, b, c) {
    const p = a + b - c;
    const pa = Math.abs(p - a);
    const pb = Math.abs(p - b);
    const pc = Math.abs(p - c);
    if (pa <= pb && pa <= pc) return a;
    else if (pb <= pc) return b;
    else return c;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3cgMk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "decodeInterlaceNull", ()=>decodeInterlaceNull);
var _unfilter = require("./unfilter");
const uint16 = new Uint16Array([
    0x00ff
]);
const uint8 = new Uint8Array(uint16.buffer);
const osIsLittleEndian = uint8[0] === 0xff;
const empty = new Uint8Array(0);
function decodeInterlaceNull(params) {
    const { data, width, height, channels, depth } = params;
    const bytesPerPixel = Math.ceil(depth / 8) * channels;
    const bytesPerLine = Math.ceil(depth / 8 * channels * width);
    const newData = new Uint8Array(height * bytesPerLine);
    let prevLine = empty;
    let offset = 0;
    let currentLine;
    let newLine;
    for(let i = 0; i < height; i++){
        currentLine = data.subarray(offset + 1, offset + 1 + bytesPerLine);
        newLine = newData.subarray(i * bytesPerLine, (i + 1) * bytesPerLine);
        switch(data[offset]){
            case 0:
                (0, _unfilter.unfilterNone)(currentLine, newLine, bytesPerLine);
                break;
            case 1:
                (0, _unfilter.unfilterSub)(currentLine, newLine, bytesPerLine, bytesPerPixel);
                break;
            case 2:
                (0, _unfilter.unfilterUp)(currentLine, newLine, prevLine, bytesPerLine);
                break;
            case 3:
                (0, _unfilter.unfilterAverage)(currentLine, newLine, prevLine, bytesPerLine, bytesPerPixel);
                break;
            case 4:
                (0, _unfilter.unfilterPaeth)(currentLine, newLine, prevLine, bytesPerLine, bytesPerPixel);
                break;
            default:
                throw new Error(`Unsupported filter: ${data[offset]}`);
        }
        prevLine = newLine;
        offset += bytesPerLine + 1;
    }
    if (depth === 16) {
        const uint16Data = new Uint16Array(newData.buffer);
        if (osIsLittleEndian) for(let k = 0; k < uint16Data.length; k++)// PNG is always big endian. Swap the bytes.
        uint16Data[k] = swap16(uint16Data[k]);
        return uint16Data;
    } else return newData;
}
function swap16(val) {
    return (val & 0xff) << 8 | val >> 8 & 0xff;
}

},{"./unfilter":"gQknm","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8dCHg":[function(require,module,exports,__globalThis) {
// https://www.w3.org/TR/PNG/#5PNG-file-signature
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "writeSignature", ()=>writeSignature);
parcelHelpers.export(exports, "checkSignature", ()=>checkSignature);
parcelHelpers.export(exports, "hasPngSignature", ()=>hasPngSignature);
const pngSignature = Uint8Array.of(137, 80, 78, 71, 13, 10, 26, 10);
function writeSignature(buffer) {
    buffer.writeBytes(pngSignature);
}
function checkSignature(buffer) {
    if (!hasPngSignature(buffer.readBytes(pngSignature.length))) throw new Error('wrong PNG signature');
}
function hasPngSignature(array) {
    if (array.length < pngSignature.length) return false;
    for(let i = 0; i < pngSignature.length; i++){
        if (array[i] !== pngSignature[i]) return false;
    }
    return true;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"g232d":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "textChunkName", ()=>textChunkName);
parcelHelpers.export(exports, "decodetEXt", ()=>decodetEXt);
parcelHelpers.export(exports, "encodetEXt", ()=>encodetEXt);
// https://www.w3.org/TR/png/#11keywords
parcelHelpers.export(exports, "readKeyword", ()=>readKeyword);
parcelHelpers.export(exports, "readLatin1", ()=>readLatin1);
var _crc = require("./crc");
const textChunkName = 'tEXt';
const NULL = 0;
const latin1Decoder = new TextDecoder('latin1');
function validateKeyword(keyword) {
    validateLatin1(keyword);
    if (keyword.length === 0 || keyword.length > 79) throw new Error('keyword length must be between 1 and 79');
}
// eslint-disable-next-line no-control-regex
const latin1Regex = /^[\u0000-\u00FF]*$/;
function validateLatin1(text) {
    if (!latin1Regex.test(text)) throw new Error('invalid latin1 text');
}
function decodetEXt(text, buffer, length) {
    const keyword = readKeyword(buffer);
    text[keyword] = readLatin1(buffer, length - keyword.length - 1);
}
function encodetEXt(buffer, keyword, text) {
    validateKeyword(keyword);
    validateLatin1(text);
    const length = keyword.length + 1 /* NULL */  + text.length;
    buffer.writeUint32(length);
    buffer.writeChars(textChunkName);
    buffer.writeChars(keyword);
    buffer.writeByte(NULL);
    buffer.writeChars(text);
    (0, _crc.writeCrc)(buffer, length + 4);
}
function readKeyword(buffer) {
    buffer.mark();
    while(buffer.readByte() !== NULL);
    const end = buffer.offset;
    buffer.reset();
    const keyword = latin1Decoder.decode(buffer.readBytes(end - buffer.offset - 1));
    // NULL
    buffer.skip(1);
    validateKeyword(keyword);
    return keyword;
}
function readLatin1(buffer, length) {
    return latin1Decoder.decode(buffer.readBytes(length));
}

},{"./crc":"lMHUJ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"i8ZBt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ColorType", ()=>ColorType);
parcelHelpers.export(exports, "CompressionMethod", ()=>CompressionMethod);
parcelHelpers.export(exports, "FilterMethod", ()=>FilterMethod);
parcelHelpers.export(exports, "InterlaceMethod", ()=>InterlaceMethod);
parcelHelpers.export(exports, "DisposeOpType", ()=>DisposeOpType);
parcelHelpers.export(exports, "BlendOpType", ()=>BlendOpType);
const ColorType = {
    UNKNOWN: -1,
    GREYSCALE: 0,
    TRUECOLOUR: 2,
    INDEXED_COLOUR: 3,
    GREYSCALE_ALPHA: 4,
    TRUECOLOUR_ALPHA: 6
};
const CompressionMethod = {
    UNKNOWN: -1,
    DEFLATE: 0
};
const FilterMethod = {
    UNKNOWN: -1,
    ADAPTIVE: 0
};
const InterlaceMethod = {
    UNKNOWN: -1,
    NO_INTERLACE: 0,
    ADAM7: 1
};
const DisposeOpType = {
    NONE: 0,
    BACKGROUND: 1,
    PREVIOUS: 2
};
const BlendOpType = {
    SOURCE: 0,
    OVER: 1
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iBYpz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _iobuffer = require("iobuffer");
var _pako = require("pako");
var _crc = require("./helpers/crc");
var _signature = require("./helpers/signature");
var _text = require("./helpers/text");
var _internalTypes = require("./internalTypes");
const defaultZlibOptions = {
    level: 3
};
class PngEncoder extends (0, _iobuffer.IOBuffer) {
    _png;
    _zlibOptions;
    _colorType;
    _interlaceMethod;
    constructor(data, options = {}){
        super();
        this._colorType = (0, _internalTypes.ColorType).UNKNOWN;
        this._zlibOptions = {
            ...defaultZlibOptions,
            ...options.zlib
        };
        this._png = this._checkData(data);
        this._interlaceMethod = (options.interlace === 'Adam7' ? (0, _internalTypes.InterlaceMethod).ADAM7 : (0, _internalTypes.InterlaceMethod).NO_INTERLACE) ?? (0, _internalTypes.InterlaceMethod).NO_INTERLACE;
        this.setBigEndian();
    }
    encode() {
        (0, _signature.writeSignature)(this);
        this.encodeIHDR();
        if (this._png.palette) {
            this.encodePLTE();
            if (this._png.palette[0].length === 4) this.encodeTRNS();
        }
        this.encodeData();
        if (this._png.text) for (const [keyword, text] of Object.entries(this._png.text))(0, _text.encodetEXt)(this, keyword, text);
        this.encodeIEND();
        return this.toArray();
    }
    // https://www.w3.org/TR/PNG/#11IHDR
    encodeIHDR() {
        this.writeUint32(13);
        this.writeChars('IHDR');
        this.writeUint32(this._png.width);
        this.writeUint32(this._png.height);
        this.writeByte(this._png.depth);
        this.writeByte(this._colorType);
        this.writeByte((0, _internalTypes.CompressionMethod).DEFLATE);
        this.writeByte((0, _internalTypes.FilterMethod).ADAPTIVE);
        this.writeByte(this._interlaceMethod);
        (0, _crc.writeCrc)(this, 17);
    }
    // https://www.w3.org/TR/PNG/#11IEND
    encodeIEND() {
        this.writeUint32(0);
        this.writeChars('IEND');
        (0, _crc.writeCrc)(this, 4);
    }
    encodePLTE() {
        const paletteLength = this._png.palette?.length * 3;
        this.writeUint32(paletteLength);
        this.writeChars('PLTE');
        for (const color of this._png.palette){
            this.writeByte(color[0]);
            this.writeByte(color[1]);
            this.writeByte(color[2]);
        }
        (0, _crc.writeCrc)(this, 4 + paletteLength);
    }
    encodeTRNS() {
        const alpha = this._png.palette.filter((color)=>{
            return color.at(-1) !== 255;
        });
        this.writeUint32(alpha.length);
        this.writeChars('tRNS');
        for (const el of alpha)this.writeByte(el.at(-1));
        (0, _crc.writeCrc)(this, 4 + alpha.length);
    }
    // https://www.w3.org/TR/PNG/#11IDAT
    encodeIDAT(data) {
        this.writeUint32(data.length);
        this.writeChars('IDAT');
        this.writeBytes(data);
        (0, _crc.writeCrc)(this, data.length + 4);
    }
    encodeData() {
        const { width, height, channels, depth, data } = this._png;
        const slotsPerLine = depth <= 8 ? Math.ceil(width * depth / 8) * channels : Math.ceil(width * depth / 8 * channels / 2);
        const newData = new (0, _iobuffer.IOBuffer)().setBigEndian();
        let offset = 0;
        if (this._interlaceMethod === (0, _internalTypes.InterlaceMethod).NO_INTERLACE) for(let i = 0; i < height; i++){
            newData.writeByte(0); // no filter
            if (depth === 16) offset = writeDataUint16(data, newData, slotsPerLine, offset);
            else offset = writeDataBytes(data, newData, slotsPerLine, offset);
        }
        else if (this._interlaceMethod === (0, _internalTypes.InterlaceMethod).ADAM7) // Adam7 interlacing
        offset = writeDataInterlaced(this._png, data, newData, offset);
        const buffer = newData.toArray();
        const compressed = (0, _pako.deflate)(buffer, this._zlibOptions);
        this.encodeIDAT(compressed);
    }
    _checkData(data) {
        const { colorType, channels, depth } = getColorType(data, data.palette);
        const png = {
            width: checkInteger(data.width, 'width'),
            height: checkInteger(data.height, 'height'),
            channels,
            data: data.data,
            depth,
            text: data.text,
            palette: data.palette
        };
        this._colorType = colorType;
        const expectedSize = depth < 8 ? Math.ceil(png.width * depth / 8) * png.height * channels : png.width * png.height * channels;
        if (png.data.length !== expectedSize) throw new RangeError(`wrong data size. Found ${png.data.length}, expected ${expectedSize}`);
        return png;
    }
}
exports.default = PngEncoder;
function checkInteger(value, name) {
    if (Number.isInteger(value) && value > 0) return value;
    throw new TypeError(`${name} must be a positive integer`);
}
function getColorType(data, palette) {
    const { channels = 4, depth = 8 } = data;
    if (channels !== 4 && channels !== 3 && channels !== 2 && channels !== 1) throw new RangeError(`unsupported number of channels: ${channels}`);
    const returnValue = {
        channels,
        depth,
        colorType: (0, _internalTypes.ColorType).UNKNOWN
    };
    switch(channels){
        case 4:
            returnValue.colorType = (0, _internalTypes.ColorType).TRUECOLOUR_ALPHA;
            break;
        case 3:
            returnValue.colorType = (0, _internalTypes.ColorType).TRUECOLOUR;
            break;
        case 1:
            if (palette) returnValue.colorType = (0, _internalTypes.ColorType).INDEXED_COLOUR;
            else returnValue.colorType = (0, _internalTypes.ColorType).GREYSCALE;
            break;
        case 2:
            returnValue.colorType = (0, _internalTypes.ColorType).GREYSCALE_ALPHA;
            break;
        default:
            throw new Error('unsupported number of channels');
    }
    return returnValue;
}
function writeDataBytes(data, newData, slotsPerLine, offset) {
    for(let j = 0; j < slotsPerLine; j++)newData.writeByte(data[offset++]);
    return offset;
}
function writeDataInterlaced(imageData, data, newData, offset) {
    const passes = [
        {
            x: 0,
            y: 0,
            xStep: 8,
            yStep: 8
        },
        {
            x: 4,
            y: 0,
            xStep: 8,
            yStep: 8
        },
        {
            x: 0,
            y: 4,
            xStep: 4,
            yStep: 8
        },
        {
            x: 2,
            y: 0,
            xStep: 4,
            yStep: 4
        },
        {
            x: 0,
            y: 2,
            xStep: 2,
            yStep: 4
        },
        {
            x: 1,
            y: 0,
            xStep: 2,
            yStep: 2
        },
        {
            x: 0,
            y: 1,
            xStep: 1,
            yStep: 2
        }
    ];
    const { width, height, channels, depth } = imageData;
    let pixelSize = 0;
    if (depth === 16) pixelSize = channels * depth / 8 / 2;
    else pixelSize = channels * depth / 8;
    // Process each pass
    for(let passIndex = 0; passIndex < 7; passIndex++){
        const pass = passes[passIndex];
        const passWidth = Math.floor((width - pass.x + pass.xStep - 1) / pass.xStep);
        const passHeight = Math.floor((height - pass.y + pass.yStep - 1) / pass.yStep);
        if (passWidth <= 0 || passHeight <= 0) continue;
        const passLineBytes = passWidth * pixelSize;
        // For each scanline in this pass
        for(let y = 0; y < passHeight; y++){
            const imageY = pass.y + y * pass.yStep;
            // Extract raw scanline data
            const rawScanline = depth <= 8 ? new Uint8Array(passLineBytes) : new Uint16Array(passLineBytes);
            let rawOffset = 0;
            for(let x = 0; x < passWidth; x++){
                const imageX = pass.x + x * pass.xStep;
                if (imageX < width && imageY < height) {
                    const srcPos = (imageY * width + imageX) * pixelSize;
                    for(let i = 0; i < pixelSize; i++)rawScanline[rawOffset++] = data[srcPos + i];
                }
            }
            newData.writeByte(0); // no filter
            if (depth === 8) newData.writeBytes(rawScanline);
            else if (depth === 16) for (const value of rawScanline){
                newData.writeByte(value >> 8 & 0xff); // High byte
                newData.writeByte(value & 0xff);
            }
        }
    }
    return offset;
}
function writeDataUint16(data, newData, slotsPerLine, offset) {
    for(let j = 0; j < slotsPerLine; j++)newData.writeUint16(data[offset++]);
    return offset;
}

},{"iobuffer":"eCbjH","pako":"8ETxB","./helpers/crc":"lMHUJ","./helpers/signature":"8dCHg","./helpers/text":"g232d","./internalTypes":"i8ZBt","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jqyHk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResolutionUnitSpecifier", ()=>ResolutionUnitSpecifier);
var ResolutionUnitSpecifier;
(function(ResolutionUnitSpecifier) {
    /**
     * Unit is unknown
     */ ResolutionUnitSpecifier[ResolutionUnitSpecifier["UNKNOWN"] = 0] = "UNKNOWN";
    /**
     * Unit is the metre
     */ ResolutionUnitSpecifier[ResolutionUnitSpecifier["METRE"] = 1] = "METRE";
})(ResolutionUnitSpecifier || (ResolutionUnitSpecifier = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"g07w4":[function(require,module,exports,__globalThis) {
/**
 * Converts indexed data into RGB/RGBA format
 * @param decodedImage - Image to decode data from.
 * @returns Uint8Array with RGB data.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "convertIndexedToRgb", ()=>convertIndexedToRgb);
function convertIndexedToRgb(decodedImage) {
    const palette = decodedImage.palette;
    const depth = decodedImage.depth;
    if (!palette) throw new Error('Color palette is undefined.');
    checkDataSize(decodedImage);
    const indexSize = decodedImage.width * decodedImage.height;
    const resSize = indexSize * palette[0].length;
    const res = new Uint8Array(resSize);
    let indexPos = 0;
    let offset = 0;
    const indexes = new Uint8Array(indexSize);
    let bit = 0xff;
    switch(depth){
        case 1:
            bit = 0x80;
            break;
        case 2:
            bit = 0xc0;
            break;
        case 4:
            bit = 0xf0;
            break;
        case 8:
            bit = 0xff;
            break;
        default:
            throw new Error('Incorrect depth value');
    }
    for (const byte of decodedImage.data){
        let bit2 = bit;
        let shift = 8;
        while(bit2){
            shift -= depth;
            indexes[indexPos++] = (byte & bit2) >> shift;
            bit2 = bit2 >> depth;
            if (indexPos % decodedImage.width === 0) break;
        }
    }
    if (decodedImage.palette) for (const index of indexes){
        const color = decodedImage.palette.at(index);
        if (!color) throw new Error('Incorrect index of palette color');
        res.set(color, offset);
        offset += color.length;
    }
    return res;
}
function checkDataSize(image) {
    const expectedSize = image.depth < 8 ? Math.ceil(image.width * image.depth / 8) * image.height * image.channels : image.width * image.height * image.channels;
    if (image.data.length !== expectedSize) throw new RangeError(`wrong data size. Found ${image.data.length}, expected ${expectedSize}`);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cLPCq":[function(require,module,exports,__globalThis) {
module.exports = Promise.resolve(module.bundle.root("3eyQ5"));

},{}],"451Vz":[function(require,module,exports,__globalThis) {
module.exports = import("5ECTG").then(()=>module.bundle.root('fijpn'));

},{}],"jDKvb":[function(require,module,exports,__globalThis) {
module.exports = import("ayg3m").then(()=>module.bundle.root('l02kN'));

},{}],"dHEdA":[function(require,module,exports,__globalThis) {
// src/components/GRAIEditorLite/index.jsx
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _graieditorLiteCss = require("./GRAIEditorLite.css");
var _reactflow = require("reactflow");
var _reactflowDefault = parcelHelpers.interopDefault(_reactflow);
var _styleCss = require("reactflow/dist/style.css");
var _html2Canvas = require("html2canvas");
var _html2CanvasDefault = parcelHelpers.interopDefault(_html2Canvas);
var _jspdf = require("jspdf");
var _jspdfDefault = parcelHelpers.interopDefault(_jspdf);
// Composants internes version Lite
var _gridHeaderLite = require("./GridHeaderLite");
var _gridHeaderLiteDefault = parcelHelpers.interopDefault(_gridHeaderLite);
var _gridCellLite = require("./GridCellLite");
var _gridCellLiteDefault = parcelHelpers.interopDefault(_gridCellLite);
var _arrowManagerLite = require("./ArrowManagerLite");
var _arrowManagerLiteDefault = parcelHelpers.interopDefault(_arrowManagerLite);
var _toolbarLite = require("./ToolbarLite");
var _toolbarLiteDefault = parcelHelpers.interopDefault(_toolbarLite);
var _externalSourceLite = require("./ExternalSourceLite");
var _externalSourceLiteDefault = parcelHelpers.interopDefault(_externalSourceLite);
const GRAIEditorLite = ({ instanceId = "grai_lite_default", storageKey: customStorageKey, title = "Grille GRAI \u2013 Lite" })=>{
    // 🔑 Clé de stockage propre à chaque instance
    const storageKey = (0, _react.useMemo)(()=>customStorageKey || `graiGridData_${instanceId}`, [
        customStorageKey,
        instanceId
    ]);
    // --------------------
    // ÉTATS PRINCIPAUX
    // --------------------
    const [columns, setColumns] = (0, _react.useState)([
        {
            id: 1,
            title: "Informations externes",
            isPseudoFunction: true,
            isObligatory: true,
            isFixed: true
        },
        {
            id: 2,
            title: "G\xe9rer les produits",
            isObligatory: true
        },
        {
            id: 3,
            title: "Planifier",
            isObligatory: true
        },
        {
            id: 4,
            title: "G\xe9rer les ressources",
            isObligatory: true
        },
        {
            id: 5,
            title: "Informations internes",
            isPseudoFunction: true,
            isObligatory: true,
            isFixed: true
        }
    ]);
    const [rows, setRows] = (0, _react.useState)([
        {
            id: 1,
            title: "2 ans",
            horizon: "H1",
            period: 730
        },
        {
            id: 2,
            title: "1 an",
            horizon: "H2",
            period: 365
        },
        {
            id: 3,
            title: "6 mois",
            horizon: "H3",
            period: 180
        },
        {
            id: 4,
            title: "1 mois",
            horizon: "H4",
            period: 30
        }
    ]);
    const [cells, setCells] = (0, _react.useState)({});
    const [arrows, setArrows] = (0, _react.useState)([]);
    const [externalSources, setExternalSources] = (0, _react.useState)([
        {
            id: 1,
            position: "top",
            title: "Pr\xe9visions commerciales"
        },
        {
            id: 2,
            position: "left",
            title: "Historique des ventes"
        },
        {
            id: 3,
            position: "right",
            title: "Stocks PF"
        }
    ]);
    const [isExporting, setIsExporting] = (0, _react.useState)(false);
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const [zoomLevel, setZoomLevel] = (0, _react.useState)(100);
    const [isDragging, setIsDragging] = (0, _react.useState)(false);
    const [startPoint, setStartPoint] = (0, _react.useState)({
        x: 0,
        y: 0
    });
    const [scrollPosition, setScrollPosition] = (0, _react.useState)({
        x: 0,
        y: 0
    });
    const gridRef = (0, _react.useRef)(null);
    const gridContentRef = (0, _react.useRef)(null);
    const arrowManagerRef = (0, _react.useRef)(null);
    // "cell", "arrow-info", "arrow-decision", "delete"
    const [editorMode, setEditorMode] = (0, _react.useState)("cell");
    const [arrowStart, setArrowStart] = (0, _react.useState)(null);
    const [notification, setNotification] = (0, _react.useState)(null);
    const [connectedCells, setConnectedCells] = (0, _react.useState)({});
    const [tooltip, setTooltip] = (0, _react.useState)({
        visible: false,
        text: "",
        x: 0,
        y: 0
    });
    const [validationErrors, setValidationErrors] = (0, _react.useState)([]);
    const [showValidationErrors, setShowValidationErrors] = (0, _react.useState)(false);
    const [automaticValidation, setAutomaticValidation] = (0, _react.useState)(true);
    // --- Sous-éditeur ---
    const [activeCell, setActiveCell] = (0, _react.useState)(null);
    const [cellDiagrams, setCellDiagrams] = (0, _react.useState)({});
    const [subNodes, setSubNodes] = (0, _react.useState)([]);
    const [subEdges, setSubEdges] = (0, _react.useState)([]);
    (0, _react.useEffect)(()=>{
        console.log(`\u{1F9E9} [${instanceId}] Cellule active :`, activeCell);
    }, [
        activeCell,
        instanceId
    ]);
    const [arrowTooltip, setArrowTooltip] = (0, _react.useState)({
        visible: false,
        text: "",
        x: 0,
        y: 0,
        arrowId: null
    });
    // Sécurité anti-NaN tooltips
    (0, _react.useEffect)(()=>{
        if (!Number.isFinite(tooltip.x) || !Number.isFinite(tooltip.y)) {
            console.warn("\uD83E\uDDE9 Tooltip invalide d\xe9tect\xe9 :", tooltip);
            setTooltip((prev)=>({
                    ...prev,
                    x: 0,
                    y: 0
                }));
        }
        if (!Number.isFinite(arrowTooltip.x) || !Number.isFinite(arrowTooltip.y)) {
            console.warn("\uD83E\uDDE9 ArrowTooltip invalide d\xe9tect\xe9 :", arrowTooltip);
            setArrowTooltip((prev)=>({
                    ...prev,
                    x: 0,
                    y: 0
                }));
        }
    }, [
        tooltip,
        arrowTooltip
    ]);
    const normalize = (text)=>text.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    // --------------------
    // AJOUT / MODIF COLONNES / LIGNES
    // --------------------
    const addColumn = (title, position = "end")=>{
        const newColumn = {
            id: Date.now(),
            title,
            type: "Bonus",
            color: "#FACC15",
            isBonus: true
        };
        setColumns((prevColumns)=>{
            const updated = [
                ...prevColumns
            ];
            const indexProduct = updated.findIndex((col)=>col.title?.toLowerCase().includes("g\xe9rer les produits") || col.title?.toLowerCase().includes("g\xe9rer produits"));
            const indexResource = updated.findIndex((col)=>col.title?.toLowerCase().includes("g\xe9rer les ressources") || col.title?.toLowerCase().includes("g\xe9rer ressources"));
            if (position === "beforeProduct" && indexProduct !== -1) updated.splice(indexProduct, 0, newColumn);
            else if (position === "afterResource" && indexResource !== -1) updated.splice(indexResource + 1, 0, newColumn);
            else updated.push(newColumn);
            return updated;
        });
        showNotification(`Colonne "${title}" ajout\xe9e (type Bonus)`, "success");
    };
    const addRow = (title, horizon)=>{
        let period = 0;
        const periodMatch = title.toLowerCase().match(/(\d+)\s*(an|ans|mois|semaine|semaines|jour|jours|heure|heures)/);
        if (periodMatch) {
            const value = parseInt(periodMatch[1]);
            const unit = periodMatch[2];
            switch(unit){
                case "an":
                case "ans":
                    period = value * 365;
                    break;
                case "mois":
                    period = value * 30;
                    break;
                case "semaine":
                case "semaines":
                    period = value * 7;
                    break;
                case "jour":
                case "jours":
                    period = value;
                    break;
                case "heure":
                case "heures":
                    period = value / 24;
                    break;
                default:
                    period = 0;
            }
        }
        let insertIndex = 0;
        while(insertIndex < rows.length && rows[insertIndex].period >= period)insertIndex++;
        const newRowId = Math.max(...rows.map((row)=>row.id), 0) + 1;
        const newRow = {
            id: newRowId,
            title,
            horizon,
            period
        };
        const newRows = [
            ...rows
        ];
        newRows.splice(insertIndex, 0, newRow);
        setRows(newRows);
        if (automaticValidation) setTimeout(()=>validateGraiRules(), 0);
    };
    const updateCell = (rowId, colId, content)=>{
        setCells((prev)=>({
                ...prev,
                [`${rowId}-${colId}`]: {
                    ...prev[`${rowId}-${colId}`],
                    content
                }
            }));
        const cellElement = document.getElementById(`cell-${rowId}-${colId}`);
        if (cellElement) {
            cellElement.classList.add("animate-pulse");
            setTimeout(()=>{
                cellElement.classList.remove("animate-pulse");
            }, 1500);
        }
    };
    // --------------------
    // CLIC SUR CELLULE
    // --------------------
    const handleCellClick = (rowId, colId, e)=>{
        // Double clic → sous-éditeur
        if (e && e.detail === 2) {
            const key = `${rowId}-${colId}`;
            setActiveCell(key);
            const existing = cellDiagrams[key];
            setSubNodes(existing?.nodes || []);
            setSubEdges(existing?.edges || []);
            return;
        }
        if (editorMode === "cell") return;
        if (editorMode === "arrow-info" || editorMode === "arrow-decision") {
            if (!arrowStart) {
                setArrowStart({
                    rowId,
                    colId
                });
                showNotification("Cellule de d\xe9part s\xe9lectionn\xe9e.", "info");
                return;
            }
            const newArrowId = arrows.length > 0 ? Math.max(...arrows.map((a)=>a.id)) + 1 : 1;
            const newArrow = {
                id: newArrowId,
                start: {
                    ...arrowStart
                },
                end: {
                    rowId,
                    colId
                },
                created: Date.now(),
                type: editorMode === "arrow-info" ? "information" : "decision",
                color: editorMode === "arrow-info" ? "#EF4444" : "#3B82F6",
                thickness: editorMode === "arrow-info" ? 2 : 8
            };
            setArrows((prev)=>[
                    ...prev,
                    newArrow
                ]);
            setArrowStart(null);
            showNotification(`Fl\xe8che ${newArrow.type} ajout\xe9e avec succ\xe8s`, "success");
        }
    };
    // --------------------
    // HIGHLIGHT / CONNECTÉ
    // --------------------
    const highlightAvailableCells = (sourceRowId, sourceColId)=>{
        const allCells = document.querySelectorAll(".grid-cell");
        allCells.forEach((cell)=>{
            const cellId = cell.id;
            if (!cellId || !cellId.startsWith("cell-")) return;
            const [, rowIdStr, colIdStr] = cellId.split("-");
            const rowId = parseInt(rowIdStr, 10);
            const colId = parseInt(colIdStr, 10);
            if (rowId === sourceRowId && colId === sourceColId) return;
            const sourceColumn = columns.find((col)=>col.id === sourceColId);
            const targetColumn = columns.find((col)=>col.id === colId);
            if (sourceColumn?.isPseudoFunction && targetColumn?.isPseudoFunction) cell.classList.add("connection-not-allowed");
            else cell.classList.add("connection-allowed");
        });
    };
    const clearAvailableCells = ()=>{
        const allCells = document.querySelectorAll(".grid-cell");
        allCells.forEach((cell)=>{
            cell.classList.remove("connection-allowed", "connection-not-allowed");
        });
    };
    const highlightConnectedCells = (rowId, colId, type)=>{
        setConnectedCells((prev)=>({
                ...prev,
                [`${rowId}-${colId}`]: type
            }));
    };
    const clearConnectedCells = ()=>{
        setConnectedCells({});
    };
    // --------------------
    // FLÈCHES
    // --------------------
    const deleteArrow = (arrowId)=>{
        setArrows((prev)=>prev.filter((a)=>a.id !== arrowId));
        showNotification("Relation supprim\xe9e", "success");
    };
    const changeArrowType = (arrowId, type)=>{
        const updatedArrows = arrows.map((a)=>{
            if (a.id === arrowId) {
                let color = "#3B82F6";
                let thickness = 2;
                if (type === "information") color = "#EF4444";
                else if (type === "vertical") {
                    color = "#10B981";
                    thickness = 5;
                }
                return {
                    ...a,
                    type,
                    color,
                    thickness
                };
            }
            return a;
        });
        setArrows(updatedArrows);
        showNotification(`Type de fl\xe8che modifi\xe9 : ${type}`, "info");
    };
    const addExternalSource = (title, position)=>{
        const newId = externalSources.length > 0 ? Math.max(...externalSources.map((s)=>s.id)) + 1 : 1;
        setExternalSources((prev)=>[
                ...prev,
                {
                    id: newId,
                    title,
                    position
                }
            ]);
        showNotification(`Source '${title}' ajout\xe9e`, "success");
    };
    // --------------------
    // EXPORTS
    // --------------------
    const exportAsImage = ()=>{
        if (!gridRef.current) {
            showNotification("Erreur: R\xe9f\xe9rence \xe0 la grille non disponible", "error");
            return;
        }
        const format = window.confirm("Souhaitez-vous exporter en PDF ?\nCliquez sur 'OK' pour PDF, ou 'Annuler' pour PNG.") ? "pdf" : "png";
        setIsExporting(true);
        showNotification(`Pr\xe9paration de l'exportation en ${format.toUpperCase()}...`, "info");
        const currentZoom = zoomLevel;
        setZoomLevel(100);
        setTimeout(()=>{
            try {
                const originalElement = document.querySelector(".grai-grid");
                if (!originalElement) throw new Error("Grille GRAI introuvable dans le DOM");
                const container = document.createElement("div");
                container.style.position = "fixed";
                container.style.top = "0";
                container.style.left = "0";
                container.style.width = `${originalElement.scrollWidth}px`;
                container.style.height = `${originalElement.scrollHeight}px`;
                container.style.backgroundColor = "white";
                container.style.zIndex = "-9999";
                container.style.overflow = "hidden";
                const clone = originalElement.cloneNode(true);
                clone.style.transform = "none";
                clone.style.border = "1px solid #ddd";
                clone.style.boxShadow = "none";
                container.appendChild(clone);
                document.body.appendChild(container);
                setTimeout(()=>{
                    (0, _html2CanvasDefault.default)(clone, {
                        backgroundColor: "#ffffff",
                        scale: 2,
                        useCORS: true,
                        allowTaint: true,
                        logging: false
                    }).then((canvas)=>{
                        document.body.removeChild(container);
                        setZoomLevel(currentZoom);
                        try {
                            const fileName = `decisional-modele-${new Date().toISOString().slice(0, 10)}`;
                            if (format === "pdf") {
                                const imgData = canvas.toDataURL("image/png");
                                const pdf = new (0, _jspdfDefault.default)({
                                    orientation: "landscape",
                                    unit: "px",
                                    format: [
                                        canvas.width,
                                        canvas.height
                                    ]
                                });
                                pdf.addImage(imgData, "PNG", 0, 0, canvas.width, canvas.height);
                                pdf.save(`${fileName}.pdf`);
                                showNotification("Exportation PDF r\xe9ussie !", "success");
                            } else {
                                const dataUrl = canvas.toDataURL("image/png");
                                const link = document.createElement("a");
                                link.href = dataUrl;
                                link.download = `${fileName}.png`;
                                link.click();
                                showNotification("Exportation PNG r\xe9ussie !", "success");
                            }
                            setIsExporting(false);
                        } catch (err) {
                            console.error("Erreur lors de l'exportation:", err);
                            setIsExporting(false);
                            showNotification("Erreur lors de l'exportation", "error");
                        }
                    }).catch((err)=>{
                        console.error("Erreur html2canvas:", err);
                        document.body.removeChild(container);
                        setIsExporting(false);
                        setZoomLevel(currentZoom);
                        showNotification("Erreur lors de la g\xe9n\xe9ration du rendu", "error");
                    });
                }, 500);
            } catch (error) {
                console.error("Erreur lors de la pr\xe9paration de l'exportation:", error);
                setIsExporting(false);
                setZoomLevel(currentZoom);
                showNotification("Erreur lors de la pr\xe9paration de l'exportation", "error");
            }
        }, 300);
    };
    const exportAsImageAlternative = ()=>{
        if (!gridRef.current) {
            showNotification("Erreur: R\xe9f\xe9rence \xe0 la grille non disponible", "error");
            return;
        }
        setIsExporting(true);
        showNotification("Pr\xe9paration de l'exportation (m\xe9thode alternative)...", "info");
        try {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");
            const gridElement = document.querySelector(".grai-grid");
            if (!gridElement) throw new Error("\xc9l\xe9ment de grille introuvable");
            const width = gridElement.offsetWidth;
            const height = gridElement.offsetHeight;
            canvas.width = width * 2;
            canvas.height = height * 2;
            ctx.scale(2, 2);
            ctx.fillStyle = "#ffffff";
            ctx.fillRect(0, 0, width, height);
            ctx.strokeStyle = "#dddddd";
            ctx.lineWidth = 1;
            ctx.strokeRect(0, 0, width, height);
            ctx.fillStyle = "#333333";
            ctx.font = "bold 18px Arial";
            ctx.textAlign = "center";
            ctx.fillText("Grille GRAI", width / 2, 30);
            const cellWidth = (width - 100) / columns.length;
            const cellHeight = 40;
            const startX = 100;
            const startY = 60;
            ctx.fillStyle = "#f0f0f0";
            ctx.fillRect(0, startY, startX, cellHeight);
            columns.forEach((column, colIndex)=>{
                const x = startX + colIndex * cellWidth;
                ctx.fillStyle = "#f0f0f0";
                ctx.fillRect(x, startY, cellWidth, cellHeight);
                ctx.strokeStyle = "#cccccc";
                ctx.strokeRect(x, startY, cellWidth, cellHeight);
                ctx.fillStyle = "#333333";
                ctx.font = "bold 12px Arial";
                ctx.textAlign = "center";
                ctx.fillText(column.title.length > 15 ? column.title.substring(0, 15) + "..." : column.title, x + cellWidth / 2, startY + 25);
            });
            rows.forEach((row, rowIndex)=>{
                const y = startY + (rowIndex + 1) * cellHeight;
                ctx.fillStyle = "#f0f0f0";
                ctx.fillRect(0, y, startX, cellHeight);
                ctx.strokeStyle = "#cccccc";
                ctx.strokeRect(0, y, startX, cellHeight);
                ctx.fillStyle = "#333333";
                ctx.font = "bold 12px Arial";
                ctx.textAlign = "center";
                ctx.fillText(row.title, startX / 2, y + 25);
                columns.forEach((column, colIndex)=>{
                    const x = startX + colIndex * cellWidth;
                    ctx.fillStyle = "#ffffff";
                    ctx.fillRect(x, y, cellWidth, cellHeight);
                    ctx.strokeStyle = "#cccccc";
                    ctx.strokeRect(x, y, cellWidth, cellHeight);
                    const cellContent = cells[`${row.id}-${column.id}`]?.content || "";
                    ctx.fillStyle = "#333333";
                    ctx.font = "11px Arial";
                    ctx.textAlign = "center";
                    const maxCharsPerLine = 20;
                    let yOffset = 15;
                    if (cellContent.length <= maxCharsPerLine) ctx.fillText(cellContent, x + cellWidth / 2, y + yOffset);
                    else {
                        let remainingText = cellContent;
                        while(remainingText.length > 0 && yOffset < cellHeight - 5){
                            let lineText;
                            if (remainingText.length > maxCharsPerLine) {
                                let cutIndex = remainingText.substring(0, maxCharsPerLine).lastIndexOf(" ");
                                if (cutIndex === -1) cutIndex = maxCharsPerLine;
                                lineText = remainingText.substring(0, cutIndex);
                                remainingText = remainingText.substring(cutIndex + 1);
                            } else {
                                lineText = remainingText;
                                remainingText = "";
                            }
                            ctx.fillText(lineText, x + cellWidth / 2, y + yOffset);
                            yOffset += 15;
                        }
                    }
                });
            });
            arrows.forEach((arrow)=>{
                const startRow = rows.findIndex((r)=>r.id === arrow.start.rowId);
                const startCol = columns.findIndex((c)=>c.id === arrow.start.colId);
                const endRow = rows.findIndex((r)=>r.id === arrow.end.rowId);
                const endCol = columns.findIndex((c)=>c.id === arrow.end.colId);
                if (startRow === -1 || startCol === -1 || endRow === -1 || endCol === -1) return;
                const startX1 = startX + startCol * cellWidth + cellWidth / 2;
                const startY1 = startY + (startRow + 1) * cellHeight + cellHeight / 2;
                const endX1 = startX + endCol * cellWidth + cellWidth / 2;
                const endY1 = startY + (endRow + 1) * cellHeight + cellHeight / 2;
                ctx.beginPath();
                ctx.moveTo(startX1, startY1);
                ctx.lineTo(endX1, endY1);
                ctx.strokeStyle = arrow.color || (arrow.type === "decision" ? "#3b82f6" : "#ef4444");
                ctx.lineWidth = arrow.thickness || 2;
                ctx.stroke();
                const angle = Math.atan2(endY1 - startY1, endX1 - startX1);
                const arrowSize = arrow.type === "vertical" ? 12 : 8;
                ctx.beginPath();
                ctx.moveTo(endX1, endY1);
                ctx.lineTo(endX1 - arrowSize * Math.cos(angle - Math.PI / 6), endY1 - arrowSize * Math.sin(angle - Math.PI / 6));
                ctx.lineTo(endX1 - arrowSize * Math.cos(angle + Math.PI / 6), endY1 - arrowSize * Math.sin(angle + Math.PI / 6));
                ctx.closePath();
                ctx.fillStyle = arrow.type === "decision" ? "#3b82f6" : "#ef4444";
                ctx.fill();
            });
            const dataUrl = canvas.toDataURL("image/png");
            const link = document.createElement("a");
            link.href = dataUrl;
            link.download = `grille-grai-${new Date().toISOString().slice(0, 10)}-alt.png`;
            link.click();
            setIsExporting(false);
            showNotification("Exportation alternative r\xe9ussie! L'image a \xe9t\xe9 t\xe9l\xe9charg\xe9e.", "success");
        } catch (error) {
            console.error("Erreur lors de l'exportation alternative:", error);
            setIsExporting(false);
            showNotification("Erreur lors de l'exportation alternative", "error");
        }
    };
    const exportWithOptions = ()=>{
        if (window.confirm("Choisir une m\xe9thode d'exportation:\n\n- OK pour la m\xe9thode standard\n- Annuler pour la m\xe9thode alternative (recommand\xe9e si l'image est blanche)")) exportAsImage();
        else exportAsImageAlternative();
    };
    // --------------------
    // SAUVEGARDE / CHARGEMENT
    // --------------------
    const saveGrid = ()=>{
        const gridData = {
            columns,
            rows,
            cells,
            arrows,
            externalSources,
            cellDiagrams
        };
        try {
            localStorage.setItem(storageKey, JSON.stringify(gridData));
            showNotification("Grille sauvegard\xe9e avec succ\xe8s", "success");
            console.log(`[${instanceId}] Grid saved`, gridData);
        } catch (error) {
            console.error("Erreur lors de la sauvegarde", error);
            showNotification("Erreur lors de la sauvegarde", "error");
        }
    };
    const loadGrid = ()=>{
        try {
            setIsLoading(true);
            const savedData = localStorage.getItem(storageKey);
            if (savedData) {
                const parsedData = JSON.parse(savedData);
                setColumns(parsedData.columns || []);
                setRows(parsedData.rows || []);
                setCells(parsedData.cells || {});
                setArrows(parsedData.arrows || []);
                setExternalSources(parsedData.externalSources || []);
                setCellDiagrams(parsedData.cellDiagrams || {});
                showNotification("Grille charg\xe9e avec succ\xe8s", "success");
            } else showNotification("Aucune grille sauvegard\xe9e trouv\xe9e", "info");
            setTimeout(()=>{
                setIsLoading(false);
            }, 500);
        } catch (error) {
            console.error("Erreur lors du chargement", error);
            showNotification("Erreur lors du chargement des donn\xe9es", "error");
            setIsLoading(false);
        }
    };
    const loadEmptyTemplate = ()=>{
        if (window.confirm("\xcates-vous s\xfbr de vouloir cr\xe9er un nouveau mod\xe8le? Toutes les donn\xe9es non sauvegard\xe9es seront perdues.")) {
            setIsLoading(true);
            setColumns([]);
            setRows([]);
            setCells({});
            setArrows([]);
            setExternalSources([]);
            setCellDiagrams({});
            setTimeout(()=>{
                setIsLoading(false);
                showNotification("Nouveau mod\xe8le cr\xe9\xe9", "success");
            }, 300);
        }
    };
    // Chargement initial
    (0, _react.useEffect)(()=>{
        setIsLoading(true);
        const savedData = localStorage.getItem(storageKey);
        if (savedData) try {
            const parsedData = JSON.parse(savedData);
            setColumns(parsedData.columns || []);
            setRows(parsedData.rows || []);
            setCells(parsedData.cells || {});
            setArrows(parsedData.arrows || []);
            setExternalSources(parsedData.externalSources || []);
            setCellDiagrams(parsedData.cellDiagrams || {});
        } catch (error) {
            console.error("Error loading saved data", error);
            showNotification("Erreur lors du chargement des donn\xe9es sauvegard\xe9es", "error");
        }
        setTimeout(()=>{
            setIsLoading(false);
        }, 500);
    }, [
        storageKey
    ]);
    // --------------------
    // ZOOM
    // --------------------
    const handleZoomIn = ()=>{
        if (zoomLevel < 200) setZoomLevel((prevZoom)=>Math.min(prevZoom + 10, 200));
    };
    const handleZoomOut = ()=>{
        if (zoomLevel > 50) setZoomLevel((prevZoom)=>Math.max(prevZoom - 10, 50));
    };
    const handleZoomReset = ()=>{
        setZoomLevel(100);
    };
    const handleWheel = (0, _react.useCallback)((e)=>{
        if (e.ctrlKey || e.metaKey) {
            e.preventDefault();
            if (e.deltaY < 0) handleZoomIn();
            else handleZoomOut();
        }
    }, []);
    // --------------------
    // TOOLTIP / NOTIFS
    // --------------------
    const handleShowTooltip = (e, text)=>{
        if (!text) return;
        if (typeof e === "string") {
            text = e;
            setTooltip({
                visible: true,
                text,
                x: window.innerWidth / 2,
                y: window.innerHeight / 2
            });
            return;
        }
        if (!e || !e.currentTarget) {
            setTooltip({
                visible: true,
                text,
                x: window.innerWidth / 2,
                y: window.innerHeight / 2
            });
            return;
        }
        const rect = e.currentTarget.getBoundingClientRect();
        setTooltip({
            visible: true,
            text,
            x: rect.left + rect.width / 2,
            y: rect.bottom + 10
        });
    };
    const handleHideTooltip = ()=>{
        setTooltip((prev)=>({
                ...prev,
                visible: false
            }));
    };
    const showNotification = (message, type = "info")=>{
        setNotification({
            message,
            type
        });
        setTimeout(()=>{
            setNotification(null);
        }, 3000);
    };
    // --------------------
    // MODES ÉDITEUR
    // --------------------
    const changeEditorMode = (mode)=>{
        setEditorMode(mode);
        if (mode !== "arrow-info" && mode !== "arrow-decision") {
            setArrowStart(null);
            clearAvailableCells();
        }
        const container = document.querySelector(".grai-editor-container");
        if (container) {
            container.classList.remove("cell-mode", "arrow-info-mode", "arrow-decision-mode", "delete-mode");
            container.classList.add(`${mode}-mode`);
        }
        const gridElement = document.querySelector(".grai-grid");
        if (gridElement) {
            if (mode === "arrow-info" || mode === "arrow-decision") gridElement.style.cursor = "crosshair";
            else if (mode === "delete") gridElement.style.cursor = "not-allowed";
            else gridElement.style.cursor = "default";
        }
    };
    // --------------------
    // DRAG POUR DÉFILEMENT
    // --------------------
    const handleMouseDown = (0, _react.useCallback)((e)=>{
        if (e.button === 1 || e.button === 0 && e.altKey) {
            e.preventDefault();
            if (gridContentRef.current) {
                setIsDragging(true);
                setStartPoint({
                    x: e.clientX,
                    y: e.clientY
                });
                setScrollPosition({
                    x: gridContentRef.current.scrollLeft,
                    y: gridContentRef.current.scrollTop
                });
                gridContentRef.current.classList.add("can-scroll");
            }
        }
    }, []);
    const handleMouseMove = (0, _react.useCallback)((e)=>{
        if (!isDragging || !gridContentRef.current) return;
        const dx = e.clientX - startPoint.x;
        const dy = e.clientY - startPoint.y;
        gridContentRef.current.scrollLeft = scrollPosition.x - dx;
        gridContentRef.current.scrollTop = scrollPosition.y - dy;
    }, [
        isDragging,
        startPoint,
        scrollPosition
    ]);
    const handleMouseUp = (0, _react.useCallback)(()=>{
        if (isDragging && gridContentRef.current) {
            setIsDragging(false);
            gridContentRef.current.classList.remove("can-scroll");
        }
    }, [
        isDragging
    ]);
    (0, _react.useEffect)(()=>{
        if (gridRef.current) {
            const gridElement = gridRef.current;
            gridElement.addEventListener("wheel", handleWheel, {
                passive: false
            });
            gridElement.addEventListener("mousedown", handleMouseDown);
            document.addEventListener("mousemove", handleMouseMove);
            document.addEventListener("mouseup", handleMouseUp);
            return ()=>{
                gridElement.removeEventListener("wheel", handleWheel);
                gridElement.removeEventListener("mousedown", handleMouseDown);
                document.removeEventListener("mousemove", handleMouseMove);
                document.removeEventListener("mouseup", handleMouseUp);
            };
        }
    }, [
        handleWheel,
        handleMouseDown,
        handleMouseMove,
        handleMouseUp
    ]);
    // --------------------
    // REDIMENSIONNEMENT COLONNES
    // --------------------
    (0, _react.useEffect)(()=>{
        let isResizing = false;
        let currentColumn = null;
        let startX = 0;
        let startWidth = 0;
        const initColumnResize = ()=>{
            const headerCells = document.querySelectorAll(".grid-header-cell.column-header");
            headerCells.forEach((cell)=>{
                const resizer = document.createElement("div");
                resizer.className = "column-resizer";
                resizer.style.position = "absolute";
                resizer.style.top = "0";
                resizer.style.right = "0";
                resizer.style.width = "8px";
                resizer.style.height = "100%";
                resizer.style.cursor = "col-resize";
                resizer.style.zIndex = "20";
                cell.style.position = "relative";
                cell.appendChild(resizer);
                resizer.addEventListener("mousedown", (e)=>{
                    isResizing = true;
                    currentColumn = cell;
                    startX = e.pageX;
                    startWidth = cell.offsetWidth;
                    document.body.classList.add("column-resizing");
                    e.preventDefault();
                    e.stopPropagation();
                });
            });
            const onMouseMove = (e)=>{
                if (!isResizing || !currentColumn) return;
                const width = startWidth + (e.pageX - startX);
                if (width >= 100) {
                    const columnIndex = Array.from(currentColumn.parentNode.children).indexOf(currentColumn);
                    const columnCells = document.querySelectorAll(`.grid-row > *:nth-child(${columnIndex + 1})`);
                    currentColumn.style.width = `${width}px`;
                    currentColumn.style.minWidth = `${width}px`;
                    columnCells.forEach((cell)=>{
                        cell.style.width = `${width}px`;
                        cell.style.minWidth = `${width}px`;
                    });
                }
            };
            const onMouseUp = ()=>{
                if (isResizing) {
                    isResizing = false;
                    currentColumn = null;
                    document.body.classList.remove("column-resizing");
                }
            };
            document.addEventListener("mousemove", onMouseMove);
            document.addEventListener("mouseup", onMouseUp);
            return ()=>{
                document.removeEventListener("mousemove", onMouseMove);
                document.removeEventListener("mouseup", onMouseUp);
            };
        };
        if (gridRef.current && columns.length > 0 && rows.length > 0) setTimeout(initColumnResize, 500);
        return ()=>{
            const resizers = document.querySelectorAll(".column-resizer");
            resizers.forEach((resizer)=>{
                resizer.parentNode?.removeChild(resizer);
            });
        };
    }, [
        columns.length,
        rows.length
    ]);
    // --------------------
    // STYLE ZOOM
    // --------------------
    const gridStyle = {
        transform: `scale(${zoomLevel / 100})`,
        transformOrigin: "top left",
        transition: "transform 0.2s ease"
    };
    // --------------------
    // CLASSES CONNECTÉS + ERREURS
    // --------------------
    const connectedCellsClasses = (0, _react.useMemo)(()=>{
        const classes = {};
        if (validationErrors.length > 0) validationErrors.forEach((error)=>{
            if (error.elements) error.elements.forEach((elementId)=>{
                if (elementId.startsWith("cell-")) classes[elementId.replace("cell-", "")] = "validation-error";
            });
        });
        arrows.forEach((arrow)=>{
            const startKey = `${arrow.start.rowId}-${arrow.start.colId}`;
            const endKey = `${arrow.end.rowId}-${arrow.end.colId}`;
            const hasError = validationErrors.some((error)=>error.arrowId === arrow.id);
            classes[startKey] = `${classes[startKey] || ""} connected-cell arrow-start${hasError ? " validation-error" : ""}`.trim();
            classes[endKey] = `${classes[endKey] || ""} connected-cell arrow-end${hasError ? " validation-error" : ""}`.trim();
        });
        return classes;
    }, [
        arrows,
        connectedCells,
        validationErrors
    ]);
    const getColumnHeaderClass = (0, _react.useCallback)((columnId)=>{
        const hasError = validationErrors.some((error)=>error.elements && error.elements.includes(`header-col-${columnId}`));
        return hasError ? "validation-error" : "";
    }, [
        validationErrors
    ]);
    const getRowHeaderClass = (0, _react.useCallback)((rowId)=>{
        const hasError = validationErrors.some((error)=>error.elements && error.elements.includes(`header-row-${rowId}`));
        return hasError ? "validation-error" : "";
    }, [
        validationErrors
    ]);
    const getArrowClass = (0, _react.useCallback)((arrowId)=>{
        const hasError = validationErrors.some((error)=>error.arrowId === arrowId);
        return hasError ? "validation-error" : "";
    }, [
        validationErrors
    ]);
    // --------------------
    // VALIDATION GRAI
    // --------------------
    const validateGraiRules = (0, _react.useCallback)(()=>{
        const errors = [];
        // CMG1
        arrows.forEach((arrow)=>{
            if (arrow.type === "decision" && arrow.start.rowId === arrow.end.rowId && arrow.start.colId === arrow.end.colId) errors.push({
                rule: "CMG1",
                message: "Un cadre de d\xe9cision ne peut \xeatre re\xe7u par ce m\xeame centre",
                elements: [
                    `cell-${arrow.start.rowId}-${arrow.start.colId}`
                ],
                arrowId: arrow.id
            });
        });
        // CMG2 & CMG4
        arrows.forEach((arrow)=>{
            if (arrow.type === "decision") {
                const startColumn = columns.find((col)=>col.id === arrow.start.colId);
                const endColumn = columns.find((col)=>col.id === arrow.end.colId);
                if (startColumn?.isPseudoFunction && endColumn?.isPseudoFunction) errors.push({
                    rule: "CMG2/4",
                    message: "Un cadre de d\xe9cision ne peut \xeatre \xe9mis d'une pseudo-fonction \xe0 une autre",
                    elements: [
                        `cell-${arrow.start.rowId}-${arrow.start.colId}`,
                        `cell-${arrow.end.rowId}-${arrow.end.colId}`
                    ],
                    arrowId: arrow.id
                });
            }
        });
        // CMG3
        const externalInfoColumn = columns.find((col)=>col.title.toLowerCase().includes("informations externes"));
        if (externalInfoColumn && externalInfoColumn.id !== 1) errors.push({
            rule: "CMG3",
            message: "La fonction 'informations externes' doit \xeatre plac\xe9e en colonne 1",
            elements: [
                `header-col-${externalInfoColumn.id}`
            ]
        });
        // CMG5
        const internalInfoColumn = columns.find((col)=>col.title.toLowerCase().includes("informations internes"));
        if (internalInfoColumn && internalInfoColumn.id !== columns.length) errors.push({
            rule: "CMG5",
            message: "La fonction 'informations internes' doit \xeatre plac\xe9e en derni\xe8re colonne",
            elements: [
                `header-col-${internalInfoColumn.id}`
            ]
        });
        // CMG6, 7, 8
        const requiredFunctions = [
            {
                name: "G\xe9rer les produits",
                rule: "CMG6"
            },
            {
                name: "G\xe9rer les ressources",
                rule: "CMG7"
            },
            {
                name: "Planifier",
                rule: "CMG8"
            }
        ];
        requiredFunctions.forEach((func)=>{
            if (!columns.some((col)=>col.title.toLowerCase().includes(func.name.toLowerCase()))) errors.push({
                rule: func.rule,
                message: `La fonction '${func.name}' ne peut \xeatre absente de la grille`,
                elements: []
            });
        });
        // CMG9
        for(let i = 1; i < rows.length; i++)if (rows[i].period > rows[i - 1].period) {
            errors.push({
                rule: "CMG9",
                message: "Les p\xe9riodes des niveaux d\xe9cisionnels doivent \xeatre class\xe9es par ordre d\xe9croissant",
                elements: [
                    `header-row-${rows[i - 1].id}`,
                    `header-row-${rows[i].id}`
                ]
            });
            break;
        }
        // CMG10
        if (rows.length < 3) errors.push({
            rule: "CMG10",
            message: "Les niveaux d\xe9cisionnels ne peuvent \xeatre moins de trois dans une grille GRAI",
            elements: []
        });
        // CMG12
        const internalInfoCount = columns.filter((col)=>col.title.toLowerCase().includes("informations internes")).length;
        if (internalInfoCount > 1) {
            const internalInfoColumns = columns.filter((col)=>col.title.toLowerCase().includes("informations internes")).map((col)=>`header-col-${col.id}`);
            errors.push({
                rule: "CMG12",
                message: "Une grille GRAI ne peut contenir qu'une seule fonction 'informations internes'",
                elements: internalInfoColumns
            });
        }
        // CMG13
        const externalInfoCount = columns.filter((col)=>col.title.toLowerCase().includes("informations externes")).length;
        if (externalInfoCount > 1) {
            const externalInfoColumns = columns.filter((col)=>col.title.toLowerCase().includes("informations externes")).map((col)=>`header-col-${col.id}`);
            errors.push({
                rule: "CMG13",
                message: "Une grille GRAI ne peut contenir qu'une seule fonction 'informations externes'",
                elements: externalInfoColumns
            });
        }
        // évite de mettre à jour l’état si les erreurs n'ont pas changé
        if (JSON.stringify(errors) === JSON.stringify(validationErrors)) return;
        setValidationErrors(errors);
        return errors.length === 0;
    }, [
        columns,
        rows,
        arrows
    ]);
    (0, _react.useEffect)(()=>{
        if (!automaticValidation) return;
        // On utilise un petit debounce de 150ms
        const timeout = setTimeout(()=>{
            validateGraiRules();
        }, 150);
        return ()=>clearTimeout(timeout);
    }, [
        columns,
        rows,
        arrows,
        automaticValidation
    ]);
    // --------------------
    // SUPPRESSION COL / LIGNE
    // --------------------
    const deleteColumn = (columnId)=>{
        const columnToDelete = columns.find((col)=>col.id === columnId);
        if (columnToDelete?.isObligatory) {
            const columnTitle = columnToDelete.title.toLowerCase();
            const isUniqueObligatory = !columns.some((col)=>col.id !== columnId && col.title.toLowerCase() === columnTitle);
            if (isUniqueObligatory) {
                alert(`Cette fonction est obligatoire selon les r\xe8gles GRAI et ne peut \xeatre supprim\xe9e.`);
                return;
            }
        }
        if (columnToDelete?.isFixed) {
            alert(`Cette fonction ne peut pas \xeatre supprim\xe9e car elle a une position fixe dans la grille GRAI.`);
            return;
        }
        const newColumns = columns.filter((col)=>col.id !== columnId).map((col, index)=>({
                ...col,
                id: index + 1
            }));
        setColumns(newColumns);
        const newArrows = arrows.filter((arrow)=>arrow.start.colId !== columnId && arrow.end.colId !== columnId);
        setArrows(newArrows);
        const newCells = {
            ...cells
        };
        rows.forEach((row)=>{
            delete newCells[`${row.id}-${columnId}`];
        });
        setCells(newCells);
        if (automaticValidation) setTimeout(()=>validateGraiRules(), 0);
    };
    const deleteRow = (rowId)=>{
        if (rows.length <= 3) {
            alert("CMG10: Les niveaux d\xe9cisionnels ne peuvent \xeatre moins de trois dans une grille GRAI.");
            return;
        }
        const newRows = rows.filter((row)=>row.id !== rowId);
        setRows(newRows);
        const newArrows = arrows.filter((arrow)=>arrow.start.rowId !== rowId && arrow.end.rowId !== rowId);
        setArrows(newArrows);
        const newCells = {
            ...cells
        };
        columns.forEach((col)=>{
            delete newCells[`${rowId}-${col.id}`];
        });
        setCells(newCells);
        if (automaticValidation) setTimeout(()=>validateGraiRules(), 0);
    };
    // --------------------
    // TOOLTIP FLÈCHES
    // --------------------
    const handleArrowHover = (0, _react.useCallback)((arrow, position)=>{
        const startCell = cells[`${arrow.start.rowId}-${arrow.start.colId}`] || {};
        const endCell = cells[`${arrow.end.rowId}-${arrow.end.colId}`] || {};
        const startColumn = columns.find((col)=>col.id === arrow.start.colId) || {};
        const endColumn = columns.find((col)=>col.id === arrow.end.colId) || {};
        const startRow = rows.find((row)=>row.id === arrow.start.rowId) || {};
        const endRow = rows.find((row)=>row.id === arrow.end.rowId) || {};
        const typeLabel = arrow.type === "decision" ? "D\xe9cision" : "Information";
        let tooltipText = `${typeLabel}: ${startRow.title || "Horizon"} / ${startColumn.title || "Fonction"} \u{2192} ${endRow.title || "Horizon"} / ${endColumn.title || "Fonction"}`;
        if (startCell.content && endCell.content) {
            tooltipText += `\nDe: "${startCell.content.substring(0, 30)}${startCell.content.length > 30 ? "..." : ""}"`;
            tooltipText += `\nVers: "${endCell.content.substring(0, 30)}${endCell.content.length > 30 ? "..." : ""}"`;
        }
        setArrowTooltip({
            visible: true,
            text: tooltipText,
            x: position.x,
            y: position.y,
            arrowId: arrow.id
        });
    }, [
        cells,
        columns,
        rows
    ]);
    const handleArrowLeave = (0, _react.useCallback)(()=>{
        setArrowTooltip((prev)=>({
                ...prev,
                visible: false
            }));
    }, []);
    // --------------------
    // NOEUDS SOUS-ÉDITEUR
    // --------------------
    const addNode = (label, style)=>{
        const newNode = {
            id: `${Date.now()}`,
            type: "default",
            data: {
                label,
                style
            },
            style,
            position: {
                x: Math.random() * 400,
                y: Math.random() * 300
            }
        };
        setSubNodes((prev)=>[
                ...prev,
                newNode
            ]);
    };
    // --------------------
    // RENDU
    // --------------------
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `grai-editor-container ${isExporting ? "exporting" : ""}`,
        "data-instance-id": instanceId,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "grai-editor-header",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                        className: "grai-editor-title",
                        children: title
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toolbarLiteDefault.default), {
                        editorMode: editorMode,
                        setEditorMode: changeEditorMode,
                        addColumn: addColumn,
                        addRow: addRow,
                        addExternalSource: addExternalSource,
                        exportAsImage: exportWithOptions,
                        saveGrid: saveGrid,
                        loadGrid: loadGrid,
                        loadEmptyTemplate: loadEmptyTemplate,
                        zoomLevel: zoomLevel,
                        onShowTooltip: handleShowTooltip,
                        onHideTooltip: handleHideTooltip,
                        validateGrid: validateGraiRules,
                        validationErrors: validationErrors,
                        showValidationErrors: showValidationErrors,
                        setShowValidationErrors: setShowValidationErrors,
                        automaticValidation: automaticValidation,
                        setAutomaticValidation: setAutomaticValidation
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: `grai-grid-container ${isDragging ? "dragging" : ""}`,
                ref: gridRef,
                children: [
                    isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "grid-loading",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "grid-loading-spinner"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                children: "Chargement de la grille..."
                            })
                        ]
                    }),
                    showValidationErrors && validationErrors.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "grai-validation-errors",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h3", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "16",
                                        height: "16",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: "currentColor",
                                        strokeWidth: "2",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                                cx: "12",
                                                cy: "12",
                                                r: "10"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                                x1: "12",
                                                y1: "8",
                                                x2: "12",
                                                y2: "12"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                                x1: "12",
                                                y1: "16",
                                                x2: "12.01",
                                                y2: "16"
                                            })
                                        ]
                                    }),
                                    "Erreurs de validation (",
                                    validationErrors.length,
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
                                className: "validation-error-list",
                                children: validationErrors.map((error, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                        className: "validation-error-item",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("strong", {
                                                children: [
                                                    error.rule,
                                                    ":"
                                                ]
                                            }),
                                            " ",
                                            error.message
                                        ]
                                    }, index))
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "validation-actions",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    className: "toolbar-button",
                                    onClick: ()=>setShowValidationErrors(false),
                                    children: "Fermer"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "external-sources-top",
                        children: externalSources.filter((source)=>source.position === "top").map((source)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _externalSourceLiteDefault.default), {
                                source: source,
                                onDelete: ()=>{
                                    setExternalSources((prev)=>prev.filter((s)=>s.id !== source.id));
                                },
                                editorMode: editorMode
                            }, source.id))
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "grai-grid-sides",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "external-sources-left",
                                children: externalSources.filter((source)=>source.position === "left").map((source)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _externalSourceLiteDefault.default), {
                                        source: source,
                                        onDelete: ()=>{
                                            setExternalSources((prev)=>prev.filter((s)=>s.id !== source.id));
                                        },
                                        editorMode: editorMode
                                    }, source.id))
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "grai-grid-content",
                                ref: gridContentRef,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "grai-grid",
                                    style: gridStyle,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "grid-header",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "header-corner",
                                                    children: "Horizon / Fonction"
                                                }),
                                                columns.map((column)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridHeaderLiteDefault.default), {
                                                        header: column,
                                                        isColumn: true,
                                                        onUpdate: (title)=>{
                                                            setColumns((prev)=>prev.map((col)=>col.id === column.id ? {
                                                                        ...col,
                                                                        title
                                                                    } : col));
                                                        },
                                                        onDelete: ()=>{
                                                            if (window.confirm(`Supprimer la fonction "${column.title}" ?`)) deleteColumn(column.id);
                                                        },
                                                        editorMode: editorMode,
                                                        className: getColumnHeaderClass(column.id),
                                                        style: {
                                                            backgroundColor: column.color || "#3B82F6",
                                                            color: "white",
                                                            borderTop: `4px solid ${column.color || "#3B82F6"}`
                                                        }
                                                    }, column.id))
                                            ]
                                        }),
                                        rows.map((row)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "grid-row",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridHeaderLiteDefault.default), {
                                                        header: row,
                                                        isColumn: false,
                                                        onUpdate: (data)=>{
                                                            setRows((prev)=>prev.map((r)=>r.id === row.id ? {
                                                                        ...r,
                                                                        ...data
                                                                    } : r));
                                                        },
                                                        onDelete: ()=>{
                                                            if (window.confirm(`Supprimer l'horizon "${row.title}" ?`)) deleteRow(row.id);
                                                        },
                                                        editorMode: editorMode,
                                                        className: getRowHeaderClass(row.id)
                                                    }),
                                                    columns.map((column)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridCellLiteDefault.default), {
                                                            id: `cell-${row.id}-${column.id}`,
                                                            rowId: row.id,
                                                            colId: column.id,
                                                            content: cells[`${row.id}-${column.id}`]?.content || "",
                                                            onClick: (e)=>handleCellClick(row.id, column.id, e),
                                                            onUpdate: (content)=>updateCell(row.id, column.id, content),
                                                            editorMode: editorMode,
                                                            isStart: arrowStart && arrowStart.rowId === row.id && arrowStart.colId === column.id,
                                                            className: connectedCellsClasses[`${row.id}-${column.id}`],
                                                            onOpenSubEditor: (r, c)=>{
                                                                const key = `${r}-${c}`;
                                                                setActiveCell(key);
                                                                const existing = cellDiagrams[key];
                                                                setSubNodes(existing?.nodes || []);
                                                                setSubEdges(existing?.edges || []);
                                                            }
                                                        }, `${row.id}-${column.id}`))
                                                ]
                                            }, row.id)),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrowManagerLiteDefault.default), {
                                            ref: arrowManagerRef,
                                            arrows: arrows,
                                            columns: columns,
                                            rows: rows,
                                            containerRef: gridContentRef,
                                            zoomLevel: zoomLevel,
                                            editorMode: editorMode,
                                            deleteArrow: deleteArrow,
                                            changeArrowType: changeArrowType,
                                            getArrowClass: (arrow)=>validationErrors.find((e)=>e.arrowId === arrow.id) ? "validation-error" : "",
                                            onArrowHover: (arrow, position)=>{
                                                const startCell = columns.find((c)=>c.id === arrow.start.colId)?.title;
                                                const endCell = columns.find((c)=>c.id === arrow.end.colId)?.title;
                                                const startRow = rows.find((r)=>r.id === arrow.start.rowId)?.title;
                                                const endRow = rows.find((r)=>r.id === arrow.end.rowId)?.title;
                                                const arrowTypeLabel = arrow.type === "decision" ? "D\xe9cision (Bleu)" : arrow.type === "information" ? "Information (Rouge)" : "Relation verticale (Vert)";
                                                const tooltipText = `${arrowTypeLabel}: ${startCell} (${startRow}) \u{2192} ${endCell} (${endRow})`;
                                                setArrowTooltip({
                                                    visible: true,
                                                    text: tooltipText,
                                                    x: position.x,
                                                    y: position.y,
                                                    arrowId: arrow.id
                                                });
                                            },
                                            onArrowLeave: ()=>{
                                                setArrowTooltip((prev)=>({
                                                        ...prev,
                                                        visible: false
                                                    }));
                                            }
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "external-sources-right",
                                children: externalSources.filter((source)=>source.position === "right").map((source)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _externalSourceLiteDefault.default), {
                                        source: source,
                                        onDelete: ()=>{
                                            setExternalSources((prev)=>prev.filter((s)=>s.id !== source.id));
                                        },
                                        editorMode: editorMode
                                    }, source.id))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "external-sources-bottom",
                        children: externalSources.filter((source)=>source.position === "bottom").map((source)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _externalSourceLiteDefault.default), {
                                source: source,
                                onDelete: ()=>{
                                    setExternalSources((prev)=>prev.filter((s)=>s.id !== source.id));
                                },
                                editorMode: editorMode
                            }, source.id))
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "grai-zoom-controls",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: "zoom-button",
                                onClick: handleZoomOut,
                                disabled: zoomLevel <= 50,
                                onMouseEnter: (e)=>handleShowTooltip(e, "R\xe9duire"),
                                onMouseLeave: handleHideTooltip,
                                children: "\u2212"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                className: "zoom-level",
                                children: [
                                    zoomLevel,
                                    "%"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: "zoom-button",
                                onClick: handleZoomReset,
                                onMouseEnter: (e)=>handleShowTooltip(e, "R\xe9initialiser"),
                                onMouseLeave: handleHideTooltip,
                                children: "\u2299"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: "zoom-button",
                                onClick: handleZoomIn,
                                disabled: zoomLevel >= 200,
                                onMouseEnter: (e)=>handleShowTooltip(e, "Agrandir"),
                                onMouseLeave: handleHideTooltip,
                                children: "+"
                            })
                        ]
                    })
                ]
            }),
            isExporting && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "export-loading",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "export-loading-content",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "export-loading-spinner"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                            children: "Pr\xe9paration de l'exportation"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: "Veuillez patienter pendant que nous pr\xe9parons votre grille GRAI pour l'exportation..."
                        })
                    ]
                })
            }),
            notification && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: `grai-notification ${notification.type}`,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "notification-content",
                    children: [
                        notification.type === "success" && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                            width: "20",
                            height: "20",
                            viewBox: "0 0 20 20",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M10 18.333C14.6024 18.333 18.333 14.6024 18.333 10C18.333 5.39763 14.6024 1.66667 10 1.66667C5.39762 1.66667 1.66666 5.39763 1.66666 10C1.66666 14.6024 5.39762 18.333 10 18.333Z",
                                    stroke: "#10B981",
                                    strokeWidth: "1.5",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M6.66666 10L9.16666 12.5L13.3333 8.33334",
                                    stroke: "#10B981",
                                    strokeWidth: "1.5",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                })
                            ]
                        }),
                        notification.type === "error" && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                            width: "20",
                            height: "20",
                            viewBox: "0 0 20 20",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M10 18.333C14.6024 18.333 18.333 14.6024 18.333 10C18.333 5.39763 14.6024 1.66667 10 1.66667C5.39762 1.66667 1.66666 5.39763 1.66666 10C1.66666 14.6024 5.39762 18.333 10 18.333Z",
                                    stroke: "#EF4444",
                                    strokeWidth: "1.5",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M12.5 7.5L7.5 12.5",
                                    stroke: "#EF4444",
                                    strokeWidth: "1.5",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M7.5 7.5L12.5 12.5",
                                    stroke: "#EF4444",
                                    strokeWidth: "1.5",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                })
                            ]
                        }),
                        notification.type === "info" && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                            width: "20",
                            height: "20",
                            viewBox: "0 0 20 20",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M10 18.333C14.6024 18.333 18.333 14.6024 18.333 10C18.333 5.39763 14.6024 1.66667 10 1.66667C5.39762 1.66667 1.66666 5.39763 1.66666 10C1.66666 14.6024 5.39762 18.333 10 18.333Z",
                                    stroke: "#3B82F6",
                                    strokeWidth: "1.5",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M10 6.66667V10",
                                    stroke: "#3B82F6",
                                    strokeWidth: "1.5",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M10 13.333H10.0083",
                                    stroke: "#3B82F6",
                                    strokeWidth: "1.5",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                })
                            ]
                        }),
                        notification.message
                    ]
                })
            }),
            activeCell && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "subeditor-overlay",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "subeditor-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "subeditor-header",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h3", {
                                    children: [
                                        "Diagramme pour la cellule ",
                                        activeCell
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    className: "subeditor-close",
                                    onClick: ()=>setActiveCell(null),
                                    children: "\u2715"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "subeditor-toolbar",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    onClick: ()=>addNode("Activit\xe9", {
                                            background: "#e0f2fe",
                                            border: "2px solid #2563eb",
                                            borderRadius: 6,
                                            width: 140,
                                            height: 60
                                        }),
                                    children: "\uD83D\uDFE6 Activit\xe9"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    onClick: ()=>addNode("D\xe9cision", {
                                            background: "#fef9c3",
                                            border: "2px solid #eab308",
                                            shape: "diamond",
                                            width: 100,
                                            height: 100
                                        }),
                                    children: "\uD83D\uDD36 D\xe9cision"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    onClick: ()=>addNode("Donn\xe9e", {
                                            background: "#ecfdf5",
                                            border: "2px solid #10b981",
                                            shape: "parallelogram",
                                            width: 150,
                                            height: 60
                                        }),
                                    children: "\uD83D\uDCC4 Donn\xe9e"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    onClick: ()=>addNode("D\xe9but", {
                                            background: "#dcfce7",
                                            border: "2px solid #16a34a",
                                            borderRadius: "50%",
                                            width: 70,
                                            height: 70
                                        }),
                                    children: "\uD83D\uDFE2 D\xe9but"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    onClick: ()=>addNode("Fin", {
                                            background: "#fee2e2",
                                            border: "2px solid #ef4444",
                                            borderRadius: "50%",
                                            width: 70,
                                            height: 70
                                        }),
                                    children: "\uD83D\uDD34 Fin"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    onClick: ()=>addNode("Commentaire", {
                                            background: "#f3f4f6",
                                            border: "1px dashed #6b7280",
                                            padding: "8px 12px",
                                            fontStyle: "italic",
                                            color: "#374151"
                                        }),
                                    children: "\uD83D\uDCAC Commentaire"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    onClick: ()=>setSubEdges((prev)=>prev.slice(0, -1)),
                                    style: {
                                        color: "red"
                                    },
                                    children: "\uD83D\uDDD1 Supprimer fl\xe8che"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    onClick: ()=>{
                                        if (window.confirm("Effacer tout le diagramme ?")) {
                                            setSubNodes([]);
                                            setSubEdges([]);
                                        }
                                    },
                                    style: {
                                        color: "darkred"
                                    },
                                    children: "\u274C Tout effacer"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "subeditor-body",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactflowDefault.default), {
                                nodes: subNodes.map((node)=>({
                                        ...node,
                                        type: "editable"
                                    })),
                                edges: subEdges,
                                onNodesChange: (changes)=>setSubNodes((nds)=>(0, _reactflow.applyNodeChanges)(changes, nds)),
                                onEdgesChange: (changes)=>setSubEdges((eds)=>(0, _reactflow.applyEdgeChanges)(changes, eds)),
                                onConnect: (params)=>setSubEdges((eds)=>[
                                            ...eds,
                                            {
                                                ...params,
                                                type: "orthogonal",
                                                markerEnd: "url(#arrow)",
                                                style: {
                                                    stroke: "#111",
                                                    strokeWidth: 1.6
                                                }
                                            }
                                        ]),
                                fitView: true,
                                panOnDrag: true,
                                zoomOnScroll: true,
                                nodesDraggable: true,
                                nodesConnectable: true,
                                elementsSelectable: true,
                                defaultEdgeOptions: {
                                    type: "orthogonal",
                                    markerEnd: "url(#arrow)",
                                    style: {
                                        stroke: "#111",
                                        strokeWidth: 1.6
                                    }
                                },
                                nodeTypes: {
                                    editable: ({ id, data })=>{
                                        const [isEditing, setIsEditing] = (0, _reactDefault.default).useState(false);
                                        const [text, setText] = (0, _reactDefault.default).useState(data.label || "");
                                        const handleSave = ()=>{
                                            setIsEditing(false);
                                            setSubNodes((prev)=>prev.map((n)=>n.id === id ? {
                                                        ...n,
                                                        data: {
                                                            ...n.data,
                                                            label: text
                                                        }
                                                    } : n));
                                        };
                                        const style = {
                                            ...data.style || {},
                                            cursor: isEditing ? "text" : "move",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            userSelect: "none",
                                            position: "relative",
                                            textAlign: "center",
                                            overflow: "hidden"
                                        };
                                        if (data.style?.shape === "diamond") style.clipPath = "polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%)";
                                        else if (data.style?.shape === "parallelogram") style.clipPath = "polygon(15% 0%, 100% 0%, 85% 100%, 0% 100%)";
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            style: style,
                                            onDoubleClick: (e)=>{
                                                e.stopPropagation();
                                                setIsEditing(true);
                                            },
                                            children: isEditing ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                value: text,
                                                onChange: (e)=>setText(e.target.value),
                                                onBlur: handleSave,
                                                onKeyDown: (e)=>e.key === "Enter" && handleSave(),
                                                autoFocus: true,
                                                style: {
                                                    width: "90%",
                                                    border: "none",
                                                    outline: "none",
                                                    background: "transparent",
                                                    textAlign: "center",
                                                    fontWeight: "inherit",
                                                    color: "inherit"
                                                },
                                                onClick: (e)=>e.stopPropagation()
                                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: text
                                            })
                                        });
                                    }
                                },
                                style: {
                                    width: "100%",
                                    height: "100%"
                                },
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                        style: {
                                            height: 0,
                                            width: 0,
                                            position: "absolute"
                                        },
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("marker", {
                                                id: "arrow",
                                                markerWidth: "12",
                                                markerHeight: "12",
                                                refX: "12",
                                                refY: "6",
                                                orient: "auto",
                                                markerUnits: "strokeWidth",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                    d: "M0,0 L12,6 L0,12 L4,6 z",
                                                    fill: "#111"
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactflow.MiniMap), {}),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactflow.Controls), {}),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactflow.Background), {
                                        color: "#ddd",
                                        gap: 16
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "subeditor-footer",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                onClick: ()=>{
                                    setCellDiagrams({
                                        ...cellDiagrams,
                                        [activeCell]: {
                                            nodes: subNodes,
                                            edges: subEdges
                                        }
                                    });
                                    setActiveCell(null);
                                    showNotification("Sous-diagramme sauvegard\xe9", "success");
                                },
                                className: "subeditor-save",
                                children: "\uD83D\uDCBE Enregistrer"
                            })
                        })
                    ]
                })
            }),
            tooltip.visible && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "grai-tooltip visible",
                style: {
                    top: `${Number.isFinite(tooltip.y) ? tooltip.y : 0}px`,
                    left: `${Number.isFinite(tooltip.x) ? tooltip.x : 0}px`,
                    transform: `translateX(-50%)`
                },
                children: tooltip.text
            }),
            arrowTooltip.visible && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "arrow-tooltip visible",
                style: {
                    left: `${Number.isFinite(arrowTooltip.x) ? arrowTooltip.x + 15 : 0}px`,
                    top: `${Number.isFinite(arrowTooltip.y) ? arrowTooltip.y - 10 : 0}px`
                },
                children: arrowTooltip.text.split("\n").map((line, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        children: line
                    }, i))
            })
        ]
    });
};
exports.default = GRAIEditorLite;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./GRAIEditorLite.css":"15bfG","reactflow":[["applyEdgeChanges","jvp3v"],["applyNodeChanges","jvp3v"],["default","jvp3v","ReactFlow"],["Background","lA6mU"],["Controls","9o7DF"],["MiniMap","bawIp"]],"reactflow/dist/style.css":"BZvWP","html2canvas":"3eyQ5","jspdf":"hkJ4Q","./GridHeaderLite":"7Jd9b","./GridCellLite":"gn6dQ","./ArrowManagerLite":"aXJDJ","./ToolbarLite":"iUJmT","./ExternalSourceLite":"gZwrX","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"15bfG":[function() {},{}],"jvp3v":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BaseEdge", ()=>BaseEdge);
parcelHelpers.export(exports, "BezierEdge", ()=>BezierEdge);
parcelHelpers.export(exports, "ConnectionLineType", ()=>ConnectionLineType);
parcelHelpers.export(exports, "ConnectionMode", ()=>ConnectionMode);
parcelHelpers.export(exports, "EdgeLabelRenderer", ()=>EdgeLabelRenderer);
parcelHelpers.export(exports, "EdgeText", ()=>EdgeText$1);
parcelHelpers.export(exports, "Handle", ()=>Handle$1);
parcelHelpers.export(exports, "MarkerType", ()=>MarkerType);
parcelHelpers.export(exports, "PanOnScrollMode", ()=>PanOnScrollMode);
parcelHelpers.export(exports, "Panel", ()=>Panel);
parcelHelpers.export(exports, "Position", ()=>Position);
parcelHelpers.export(exports, "ReactFlow", ()=>ReactFlow);
parcelHelpers.export(exports, "ReactFlowProvider", ()=>ReactFlowProvider);
parcelHelpers.export(exports, "SelectionMode", ()=>SelectionMode);
parcelHelpers.export(exports, "SimpleBezierEdge", ()=>SimpleBezierEdge);
parcelHelpers.export(exports, "SmoothStepEdge", ()=>SmoothStepEdge);
parcelHelpers.export(exports, "StepEdge", ()=>StepEdge);
parcelHelpers.export(exports, "StraightEdge", ()=>StraightEdge);
parcelHelpers.export(exports, "addEdge", ()=>addEdge);
parcelHelpers.export(exports, "applyEdgeChanges", ()=>applyEdgeChanges);
parcelHelpers.export(exports, "applyNodeChanges", ()=>applyNodeChanges);
parcelHelpers.export(exports, "boxToRect", ()=>boxToRect);
parcelHelpers.export(exports, "clamp", ()=>clamp);
parcelHelpers.export(exports, "getBezierPath", ()=>getBezierPath);
parcelHelpers.export(exports, "getBoundsOfRects", ()=>getBoundsOfRects);
parcelHelpers.export(exports, "getConnectedEdges", ()=>getConnectedEdges);
parcelHelpers.export(exports, "getIncomers", ()=>getIncomers);
parcelHelpers.export(exports, "getMarkerEnd", ()=>getMarkerEnd);
parcelHelpers.export(exports, "getNodePositionWithOrigin", ()=>getNodePositionWithOrigin);
parcelHelpers.export(exports, "getNodesBounds", ()=>getNodesBounds);
parcelHelpers.export(exports, "getOutgoers", ()=>getOutgoers);
parcelHelpers.export(exports, "getRectOfNodes", ()=>getRectOfNodes);
parcelHelpers.export(exports, "getSimpleBezierPath", ()=>getSimpleBezierPath);
parcelHelpers.export(exports, "getSmoothStepPath", ()=>getSmoothStepPath);
parcelHelpers.export(exports, "getStraightPath", ()=>getStraightPath);
parcelHelpers.export(exports, "getTransformForBounds", ()=>getTransformForBounds);
parcelHelpers.export(exports, "getViewportForBounds", ()=>getViewportForBounds);
parcelHelpers.export(exports, "handleParentExpand", ()=>handleParentExpand);
parcelHelpers.export(exports, "internalsSymbol", ()=>internalsSymbol);
parcelHelpers.export(exports, "isEdge", ()=>isEdge);
parcelHelpers.export(exports, "isNode", ()=>isNode);
parcelHelpers.export(exports, "reconnectEdge", ()=>reconnectEdge);
parcelHelpers.export(exports, "rectToBox", ()=>rectToBox);
parcelHelpers.export(exports, "updateEdge", ()=>updateEdge);
parcelHelpers.export(exports, "useEdges", ()=>useEdges);
parcelHelpers.export(exports, "useEdgesState", ()=>useEdgesState);
parcelHelpers.export(exports, "useGetPointerPosition", ()=>useGetPointerPosition);
parcelHelpers.export(exports, "useKeyPress", ()=>useKeyPress);
parcelHelpers.export(exports, "useNodeId", ()=>useNodeId);
parcelHelpers.export(exports, "useNodes", ()=>useNodes);
parcelHelpers.export(exports, "useNodesInitialized", ()=>useNodesInitialized);
parcelHelpers.export(exports, "useNodesState", ()=>useNodesState);
parcelHelpers.export(exports, "useOnSelectionChange", ()=>useOnSelectionChange);
parcelHelpers.export(exports, "useOnViewportChange", ()=>useOnViewportChange);
parcelHelpers.export(exports, "useReactFlow", ()=>useReactFlow);
parcelHelpers.export(exports, "useStore", ()=>useStore);
parcelHelpers.export(exports, "useStoreApi", ()=>useStoreApi);
parcelHelpers.export(exports, "useUpdateNodeInternals", ()=>useUpdateNodeInternals);
parcelHelpers.export(exports, "useViewport", ()=>useViewport);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classcat = require("classcat");
var _classcatDefault = parcelHelpers.interopDefault(_classcat);
var _traditional = require("zustand/traditional");
var _shallow = require("zustand/shallow");
var _d3Zoom = require("d3-zoom");
var _d3Selection = require("d3-selection");
var _d3Drag = require("d3-drag");
var _reactDom = require("react-dom");
const StoreContext = (0, _react.createContext)(null);
const Provider$1 = StoreContext.Provider;
const errorMessages = {
    error001: ()=>'[React Flow]: Seems like you have not used zustand provider as an ancestor. Help: https://reactflow.dev/error#001',
    error002: ()=>"It looks like you've created a new nodeTypes or edgeTypes object. If this wasn't on purpose please define the nodeTypes/edgeTypes outside of the component or memoize them.",
    error003: (nodeType)=>`Node type "${nodeType}" not found. Using fallback type "default".`,
    error004: ()=>'The React Flow parent container needs a width and a height to render the graph.',
    error005: ()=>'Only child nodes can use a parent extent.',
    error006: ()=>"Can't create edge. An edge needs a source and a target.",
    error007: (id)=>`The old edge with id=${id} does not exist.`,
    error009: (type)=>`Marker type "${type}" doesn't exist.`,
    error008: (sourceHandle, edge)=>`Couldn't create edge for ${!sourceHandle ? 'source' : 'target'} handle id: "${!sourceHandle ? edge.sourceHandle : edge.targetHandle}", edge id: ${edge.id}.`,
    error010: ()=>'Handle: No node id found. Make sure to only use a Handle inside a custom Node.',
    error011: (edgeType)=>`Edge type "${edgeType}" not found. Using fallback type "default".`,
    error012: (id)=>`Node with id "${id}" does not exist, it may have been removed. This can happen when a node is deleted before the "onNodeClick" handler is called.`
};
const zustandErrorMessage = errorMessages['error001']();
function useStore(selector, equalityFn) {
    const store = (0, _react.useContext)(StoreContext);
    if (store === null) throw new Error(zustandErrorMessage);
    return (0, _traditional.useStoreWithEqualityFn)(store, selector, equalityFn);
}
const useStoreApi = ()=>{
    const store = (0, _react.useContext)(StoreContext);
    if (store === null) throw new Error(zustandErrorMessage);
    return (0, _react.useMemo)(()=>({
            getState: store.getState,
            setState: store.setState,
            subscribe: store.subscribe,
            destroy: store.destroy
        }), [
        store
    ]);
};
const selector$g = (s)=>s.userSelectionActive ? 'none' : 'all';
function Panel({ position, children, className, style, ...rest }) {
    const pointerEvents = useStore(selector$g);
    const positionClasses = `${position}`.split('-');
    return (0, _reactDefault.default).createElement("div", {
        className: (0, _classcatDefault.default)([
            'react-flow__panel',
            className,
            ...positionClasses
        ]),
        style: {
            ...style,
            pointerEvents
        },
        ...rest
    }, children);
}
function Attribution({ proOptions, position = 'bottom-right' }) {
    if (proOptions?.hideAttribution) return null;
    return (0, _reactDefault.default).createElement(Panel, {
        position: position,
        className: "react-flow__attribution",
        "data-message": "Please only hide this attribution when you are subscribed to React Flow Pro: https://reactflow.dev/pro"
    }, (0, _reactDefault.default).createElement("a", {
        href: "https://reactflow.dev",
        target: "_blank",
        rel: "noopener noreferrer",
        "aria-label": "React Flow attribution"
    }, "React Flow"));
}
const EdgeText = ({ x, y, label, labelStyle = {}, labelShowBg = true, labelBgStyle = {}, labelBgPadding = [
    2,
    4
], labelBgBorderRadius = 2, children, className, ...rest })=>{
    const edgeRef = (0, _react.useRef)(null);
    const [edgeTextBbox, setEdgeTextBbox] = (0, _react.useState)({
        x: 0,
        y: 0,
        width: 0,
        height: 0
    });
    const edgeTextClasses = (0, _classcatDefault.default)([
        'react-flow__edge-textwrapper',
        className
    ]);
    (0, _react.useEffect)(()=>{
        if (edgeRef.current) {
            const textBbox = edgeRef.current.getBBox();
            setEdgeTextBbox({
                x: textBbox.x,
                y: textBbox.y,
                width: textBbox.width,
                height: textBbox.height
            });
        }
    }, [
        label
    ]);
    if (typeof label === 'undefined' || !label) return null;
    return (0, _reactDefault.default).createElement("g", {
        transform: `translate(${x - edgeTextBbox.width / 2} ${y - edgeTextBbox.height / 2})`,
        className: edgeTextClasses,
        visibility: edgeTextBbox.width ? 'visible' : 'hidden',
        ...rest
    }, labelShowBg && (0, _reactDefault.default).createElement("rect", {
        width: edgeTextBbox.width + 2 * labelBgPadding[0],
        x: -labelBgPadding[0],
        y: -labelBgPadding[1],
        height: edgeTextBbox.height + 2 * labelBgPadding[1],
        className: "react-flow__edge-textbg",
        style: labelBgStyle,
        rx: labelBgBorderRadius,
        ry: labelBgBorderRadius
    }), (0, _reactDefault.default).createElement("text", {
        className: "react-flow__edge-text",
        y: edgeTextBbox.height / 2,
        dy: "0.3em",
        ref: edgeRef,
        style: labelStyle
    }, label), children);
};
var EdgeText$1 = (0, _react.memo)(EdgeText);
const getDimensions = (node)=>({
        width: node.offsetWidth,
        height: node.offsetHeight
    });
const clamp = (val, min = 0, max = 1)=>Math.min(Math.max(val, min), max);
const clampPosition = (position = {
    x: 0,
    y: 0
}, extent)=>({
        x: clamp(position.x, extent[0][0], extent[1][0]),
        y: clamp(position.y, extent[0][1], extent[1][1])
    });
// returns a number between 0 and 1 that represents the velocity of the movement
// when the mouse is close to the edge of the canvas
const calcAutoPanVelocity = (value, min, max)=>{
    if (value < min) return clamp(Math.abs(value - min), 1, 50) / 50;
    else if (value > max) return -clamp(Math.abs(value - max), 1, 50) / 50;
    return 0;
};
const calcAutoPan = (pos, bounds)=>{
    const xMovement = calcAutoPanVelocity(pos.x, 35, bounds.width - 35) * 20;
    const yMovement = calcAutoPanVelocity(pos.y, 35, bounds.height - 35) * 20;
    return [
        xMovement,
        yMovement
    ];
};
const getHostForElement = (element)=>element.getRootNode?.() || window?.document;
const getBoundsOfBoxes = (box1, box2)=>({
        x: Math.min(box1.x, box2.x),
        y: Math.min(box1.y, box2.y),
        x2: Math.max(box1.x2, box2.x2),
        y2: Math.max(box1.y2, box2.y2)
    });
const rectToBox = ({ x, y, width, height })=>({
        x,
        y,
        x2: x + width,
        y2: y + height
    });
const boxToRect = ({ x, y, x2, y2 })=>({
        x,
        y,
        width: x2 - x,
        height: y2 - y
    });
const nodeToRect = (node)=>({
        ...node.positionAbsolute || {
            x: 0,
            y: 0
        },
        width: node.width || 0,
        height: node.height || 0
    });
const getBoundsOfRects = (rect1, rect2)=>boxToRect(getBoundsOfBoxes(rectToBox(rect1), rectToBox(rect2)));
const getOverlappingArea = (rectA, rectB)=>{
    const xOverlap = Math.max(0, Math.min(rectA.x + rectA.width, rectB.x + rectB.width) - Math.max(rectA.x, rectB.x));
    const yOverlap = Math.max(0, Math.min(rectA.y + rectA.height, rectB.y + rectB.height) - Math.max(rectA.y, rectB.y));
    return Math.ceil(xOverlap * yOverlap);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isRectObject = (obj)=>isNumeric(obj.width) && isNumeric(obj.height) && isNumeric(obj.x) && isNumeric(obj.y);
/* eslint-disable-next-line @typescript-eslint/no-explicit-any */ const isNumeric = (n)=>!isNaN(n) && isFinite(n);
const internalsSymbol = Symbol.for('internals');
// used for a11y key board controls for nodes and edges
const elementSelectionKeys = [
    'Enter',
    ' ',
    'Escape'
];
const devWarn = (id, message)=>{};
const isReactKeyboardEvent = (event)=>'nativeEvent' in event;
function isInputDOMNode(event) {
    const kbEvent = isReactKeyboardEvent(event) ? event.nativeEvent : event;
    // using composed path for handling shadow dom
    const target = kbEvent.composedPath?.()?.[0] || event.target;
    const isInput = [
        'INPUT',
        'SELECT',
        'TEXTAREA'
    ].includes(target?.nodeName) || target?.hasAttribute('contenteditable');
    // when an input field is focused we don't want to trigger deletion or movement of nodes
    return isInput || !!target?.closest('.nokey');
}
const isMouseEvent = (event)=>'clientX' in event;
const getEventPosition = (event, bounds)=>{
    const isMouseTriggered = isMouseEvent(event);
    const evtX = isMouseTriggered ? event.clientX : event.touches?.[0].clientX;
    const evtY = isMouseTriggered ? event.clientY : event.touches?.[0].clientY;
    return {
        x: evtX - (bounds?.left ?? 0),
        y: evtY - (bounds?.top ?? 0)
    };
};
const isMacOs = ()=>typeof navigator !== 'undefined' && navigator?.userAgent?.indexOf('Mac') >= 0;
const BaseEdge = ({ id, path, labelX, labelY, label, labelStyle, labelShowBg, labelBgStyle, labelBgPadding, labelBgBorderRadius, style, markerEnd, markerStart, interactionWidth = 20 })=>{
    return (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        id: id,
        style: style,
        d: path,
        fill: "none",
        className: "react-flow__edge-path",
        markerEnd: markerEnd,
        markerStart: markerStart
    }), interactionWidth && (0, _reactDefault.default).createElement("path", {
        d: path,
        fill: "none",
        strokeOpacity: 0,
        strokeWidth: interactionWidth,
        className: "react-flow__edge-interaction"
    }), label && isNumeric(labelX) && isNumeric(labelY) ? (0, _reactDefault.default).createElement(EdgeText$1, {
        x: labelX,
        y: labelY,
        label: label,
        labelStyle: labelStyle,
        labelShowBg: labelShowBg,
        labelBgStyle: labelBgStyle,
        labelBgPadding: labelBgPadding,
        labelBgBorderRadius: labelBgBorderRadius
    }) : null);
};
BaseEdge.displayName = 'BaseEdge';
const getMarkerEnd = (markerType, markerEndId)=>{
    if (typeof markerEndId !== 'undefined' && markerEndId) return `url(#${markerEndId})`;
    return typeof markerType !== 'undefined' ? `url(#react-flow__${markerType})` : 'none';
};
function getMouseHandler$1(id, getState, handler) {
    return handler === undefined ? handler : (event)=>{
        const edge = getState().edges.find((e)=>e.id === id);
        if (edge) handler(event, {
            ...edge
        });
    };
}
// this is used for straight edges and simple smoothstep edges (LTR, RTL, BTT, TTB)
function getEdgeCenter({ sourceX, sourceY, targetX, targetY }) {
    const xOffset = Math.abs(targetX - sourceX) / 2;
    const centerX = targetX < sourceX ? targetX + xOffset : targetX - xOffset;
    const yOffset = Math.abs(targetY - sourceY) / 2;
    const centerY = targetY < sourceY ? targetY + yOffset : targetY - yOffset;
    return [
        centerX,
        centerY,
        xOffset,
        yOffset
    ];
}
function getBezierEdgeCenter({ sourceX, sourceY, targetX, targetY, sourceControlX, sourceControlY, targetControlX, targetControlY }) {
    // cubic bezier t=0.5 mid point, not the actual mid point, but easy to calculate
    // https://stackoverflow.com/questions/67516101/how-to-find-distance-mid-point-of-bezier-curve
    const centerX = sourceX * 0.125 + sourceControlX * 0.375 + targetControlX * 0.375 + targetX * 0.125;
    const centerY = sourceY * 0.125 + sourceControlY * 0.375 + targetControlY * 0.375 + targetY * 0.125;
    const offsetX = Math.abs(centerX - sourceX);
    const offsetY = Math.abs(centerY - sourceY);
    return [
        centerX,
        centerY,
        offsetX,
        offsetY
    ];
}
var ConnectionMode;
(function(ConnectionMode) {
    ConnectionMode["Strict"] = "strict";
    ConnectionMode["Loose"] = "loose";
})(ConnectionMode || (ConnectionMode = {}));
var PanOnScrollMode;
(function(PanOnScrollMode) {
    PanOnScrollMode["Free"] = "free";
    PanOnScrollMode["Vertical"] = "vertical";
    PanOnScrollMode["Horizontal"] = "horizontal";
})(PanOnScrollMode || (PanOnScrollMode = {}));
var SelectionMode;
(function(SelectionMode) {
    SelectionMode["Partial"] = "partial";
    SelectionMode["Full"] = "full";
})(SelectionMode || (SelectionMode = {}));
var ConnectionLineType;
(function(ConnectionLineType) {
    ConnectionLineType["Bezier"] = "default";
    ConnectionLineType["Straight"] = "straight";
    ConnectionLineType["Step"] = "step";
    ConnectionLineType["SmoothStep"] = "smoothstep";
    ConnectionLineType["SimpleBezier"] = "simplebezier";
})(ConnectionLineType || (ConnectionLineType = {}));
var MarkerType;
(function(MarkerType) {
    MarkerType["Arrow"] = "arrow";
    MarkerType["ArrowClosed"] = "arrowclosed";
})(MarkerType || (MarkerType = {}));
var Position;
(function(Position) {
    Position["Left"] = "left";
    Position["Top"] = "top";
    Position["Right"] = "right";
    Position["Bottom"] = "bottom";
})(Position || (Position = {}));
function getControl({ pos, x1, y1, x2, y2 }) {
    if (pos === Position.Left || pos === Position.Right) return [
        0.5 * (x1 + x2),
        y1
    ];
    return [
        x1,
        0.5 * (y1 + y2)
    ];
}
function getSimpleBezierPath({ sourceX, sourceY, sourcePosition = Position.Bottom, targetX, targetY, targetPosition = Position.Top }) {
    const [sourceControlX, sourceControlY] = getControl({
        pos: sourcePosition,
        x1: sourceX,
        y1: sourceY,
        x2: targetX,
        y2: targetY
    });
    const [targetControlX, targetControlY] = getControl({
        pos: targetPosition,
        x1: targetX,
        y1: targetY,
        x2: sourceX,
        y2: sourceY
    });
    const [labelX, labelY, offsetX, offsetY] = getBezierEdgeCenter({
        sourceX,
        sourceY,
        targetX,
        targetY,
        sourceControlX,
        sourceControlY,
        targetControlX,
        targetControlY
    });
    return [
        `M${sourceX},${sourceY} C${sourceControlX},${sourceControlY} ${targetControlX},${targetControlY} ${targetX},${targetY}`,
        labelX,
        labelY,
        offsetX,
        offsetY
    ];
}
const SimpleBezierEdge = (0, _react.memo)(({ sourceX, sourceY, targetX, targetY, sourcePosition = Position.Bottom, targetPosition = Position.Top, label, labelStyle, labelShowBg, labelBgStyle, labelBgPadding, labelBgBorderRadius, style, markerEnd, markerStart, interactionWidth })=>{
    const [path, labelX, labelY] = getSimpleBezierPath({
        sourceX,
        sourceY,
        sourcePosition,
        targetX,
        targetY,
        targetPosition
    });
    return (0, _reactDefault.default).createElement(BaseEdge, {
        path: path,
        labelX: labelX,
        labelY: labelY,
        label: label,
        labelStyle: labelStyle,
        labelShowBg: labelShowBg,
        labelBgStyle: labelBgStyle,
        labelBgPadding: labelBgPadding,
        labelBgBorderRadius: labelBgBorderRadius,
        style: style,
        markerEnd: markerEnd,
        markerStart: markerStart,
        interactionWidth: interactionWidth
    });
});
SimpleBezierEdge.displayName = 'SimpleBezierEdge';
const handleDirections = {
    [Position.Left]: {
        x: -1,
        y: 0
    },
    [Position.Right]: {
        x: 1,
        y: 0
    },
    [Position.Top]: {
        x: 0,
        y: -1
    },
    [Position.Bottom]: {
        x: 0,
        y: 1
    }
};
const getDirection = ({ source, sourcePosition = Position.Bottom, target })=>{
    if (sourcePosition === Position.Left || sourcePosition === Position.Right) return source.x < target.x ? {
        x: 1,
        y: 0
    } : {
        x: -1,
        y: 0
    };
    return source.y < target.y ? {
        x: 0,
        y: 1
    } : {
        x: 0,
        y: -1
    };
};
const distance = (a, b)=>Math.sqrt(Math.pow(b.x - a.x, 2) + Math.pow(b.y - a.y, 2));
// ith this function we try to mimic a orthogonal edge routing behaviour
// It's not as good as a real orthogonal edge routing but it's faster and good enough as a default for step and smooth step edges
function getPoints({ source, sourcePosition = Position.Bottom, target, targetPosition = Position.Top, center, offset }) {
    const sourceDir = handleDirections[sourcePosition];
    const targetDir = handleDirections[targetPosition];
    const sourceGapped = {
        x: source.x + sourceDir.x * offset,
        y: source.y + sourceDir.y * offset
    };
    const targetGapped = {
        x: target.x + targetDir.x * offset,
        y: target.y + targetDir.y * offset
    };
    const dir = getDirection({
        source: sourceGapped,
        sourcePosition,
        target: targetGapped
    });
    const dirAccessor = dir.x !== 0 ? 'x' : 'y';
    const currDir = dir[dirAccessor];
    let points = [];
    let centerX, centerY;
    const sourceGapOffset = {
        x: 0,
        y: 0
    };
    const targetGapOffset = {
        x: 0,
        y: 0
    };
    const [defaultCenterX, defaultCenterY, defaultOffsetX, defaultOffsetY] = getEdgeCenter({
        sourceX: source.x,
        sourceY: source.y,
        targetX: target.x,
        targetY: target.y
    });
    // opposite handle positions, default case
    if (sourceDir[dirAccessor] * targetDir[dirAccessor] === -1) {
        centerX = center.x ?? defaultCenterX;
        centerY = center.y ?? defaultCenterY;
        //    --->
        //    |
        // >---
        const verticalSplit = [
            {
                x: centerX,
                y: sourceGapped.y
            },
            {
                x: centerX,
                y: targetGapped.y
            }
        ];
        //    |
        //  ---
        //  |
        const horizontalSplit = [
            {
                x: sourceGapped.x,
                y: centerY
            },
            {
                x: targetGapped.x,
                y: centerY
            }
        ];
        if (sourceDir[dirAccessor] === currDir) points = dirAccessor === 'x' ? verticalSplit : horizontalSplit;
        else points = dirAccessor === 'x' ? horizontalSplit : verticalSplit;
    } else {
        // sourceTarget means we take x from source and y from target, targetSource is the opposite
        const sourceTarget = [
            {
                x: sourceGapped.x,
                y: targetGapped.y
            }
        ];
        const targetSource = [
            {
                x: targetGapped.x,
                y: sourceGapped.y
            }
        ];
        // this handles edges with same handle positions
        if (dirAccessor === 'x') points = sourceDir.x === currDir ? targetSource : sourceTarget;
        else points = sourceDir.y === currDir ? sourceTarget : targetSource;
        if (sourcePosition === targetPosition) {
            const diff = Math.abs(source[dirAccessor] - target[dirAccessor]);
            // if an edge goes from right to right for example (sourcePosition === targetPosition) and the distance between source.x and target.x is less than the offset, the added point and the gapped source/target will overlap. This leads to a weird edge path. To avoid this we add a gapOffset to the source/target
            if (diff <= offset) {
                const gapOffset = Math.min(offset - 1, offset - diff);
                if (sourceDir[dirAccessor] === currDir) sourceGapOffset[dirAccessor] = (sourceGapped[dirAccessor] > source[dirAccessor] ? -1 : 1) * gapOffset;
                else targetGapOffset[dirAccessor] = (targetGapped[dirAccessor] > target[dirAccessor] ? -1 : 1) * gapOffset;
            }
        }
        // these are conditions for handling mixed handle positions like Right -> Bottom for example
        if (sourcePosition !== targetPosition) {
            const dirAccessorOpposite = dirAccessor === 'x' ? 'y' : 'x';
            const isSameDir = sourceDir[dirAccessor] === targetDir[dirAccessorOpposite];
            const sourceGtTargetOppo = sourceGapped[dirAccessorOpposite] > targetGapped[dirAccessorOpposite];
            const sourceLtTargetOppo = sourceGapped[dirAccessorOpposite] < targetGapped[dirAccessorOpposite];
            const flipSourceTarget = sourceDir[dirAccessor] === 1 && (!isSameDir && sourceGtTargetOppo || isSameDir && sourceLtTargetOppo) || sourceDir[dirAccessor] !== 1 && (!isSameDir && sourceLtTargetOppo || isSameDir && sourceGtTargetOppo);
            if (flipSourceTarget) points = dirAccessor === 'x' ? sourceTarget : targetSource;
        }
        const sourceGapPoint = {
            x: sourceGapped.x + sourceGapOffset.x,
            y: sourceGapped.y + sourceGapOffset.y
        };
        const targetGapPoint = {
            x: targetGapped.x + targetGapOffset.x,
            y: targetGapped.y + targetGapOffset.y
        };
        const maxXDistance = Math.max(Math.abs(sourceGapPoint.x - points[0].x), Math.abs(targetGapPoint.x - points[0].x));
        const maxYDistance = Math.max(Math.abs(sourceGapPoint.y - points[0].y), Math.abs(targetGapPoint.y - points[0].y));
        // we want to place the label on the longest segment of the edge
        if (maxXDistance >= maxYDistance) {
            centerX = (sourceGapPoint.x + targetGapPoint.x) / 2;
            centerY = points[0].y;
        } else {
            centerX = points[0].x;
            centerY = (sourceGapPoint.y + targetGapPoint.y) / 2;
        }
    }
    const pathPoints = [
        source,
        {
            x: sourceGapped.x + sourceGapOffset.x,
            y: sourceGapped.y + sourceGapOffset.y
        },
        ...points,
        {
            x: targetGapped.x + targetGapOffset.x,
            y: targetGapped.y + targetGapOffset.y
        },
        target
    ];
    return [
        pathPoints,
        centerX,
        centerY,
        defaultOffsetX,
        defaultOffsetY
    ];
}
function getBend(a, b, c, size) {
    const bendSize = Math.min(distance(a, b) / 2, distance(b, c) / 2, size);
    const { x, y } = b;
    // no bend
    if (a.x === x && x === c.x || a.y === y && y === c.y) return `L${x} ${y}`;
    // first segment is horizontal
    if (a.y === y) {
        const xDir = a.x < c.x ? -1 : 1;
        const yDir = a.y < c.y ? 1 : -1;
        return `L ${x + bendSize * xDir},${y}Q ${x},${y} ${x},${y + bendSize * yDir}`;
    }
    const xDir = a.x < c.x ? 1 : -1;
    const yDir = a.y < c.y ? -1 : 1;
    return `L ${x},${y + bendSize * yDir}Q ${x},${y} ${x + bendSize * xDir},${y}`;
}
function getSmoothStepPath({ sourceX, sourceY, sourcePosition = Position.Bottom, targetX, targetY, targetPosition = Position.Top, borderRadius = 5, centerX, centerY, offset = 20 }) {
    const [points, labelX, labelY, offsetX, offsetY] = getPoints({
        source: {
            x: sourceX,
            y: sourceY
        },
        sourcePosition,
        target: {
            x: targetX,
            y: targetY
        },
        targetPosition,
        center: {
            x: centerX,
            y: centerY
        },
        offset
    });
    const path = points.reduce((res, p, i)=>{
        let segment = '';
        if (i > 0 && i < points.length - 1) segment = getBend(points[i - 1], p, points[i + 1], borderRadius);
        else segment = `${i === 0 ? 'M' : 'L'}${p.x} ${p.y}`;
        res += segment;
        return res;
    }, '');
    return [
        path,
        labelX,
        labelY,
        offsetX,
        offsetY
    ];
}
const SmoothStepEdge = (0, _react.memo)(({ sourceX, sourceY, targetX, targetY, label, labelStyle, labelShowBg, labelBgStyle, labelBgPadding, labelBgBorderRadius, style, sourcePosition = Position.Bottom, targetPosition = Position.Top, markerEnd, markerStart, pathOptions, interactionWidth })=>{
    const [path, labelX, labelY] = getSmoothStepPath({
        sourceX,
        sourceY,
        sourcePosition,
        targetX,
        targetY,
        targetPosition,
        borderRadius: pathOptions?.borderRadius,
        offset: pathOptions?.offset
    });
    return (0, _reactDefault.default).createElement(BaseEdge, {
        path: path,
        labelX: labelX,
        labelY: labelY,
        label: label,
        labelStyle: labelStyle,
        labelShowBg: labelShowBg,
        labelBgStyle: labelBgStyle,
        labelBgPadding: labelBgPadding,
        labelBgBorderRadius: labelBgBorderRadius,
        style: style,
        markerEnd: markerEnd,
        markerStart: markerStart,
        interactionWidth: interactionWidth
    });
});
SmoothStepEdge.displayName = 'SmoothStepEdge';
const StepEdge = (0, _react.memo)((props)=>(0, _reactDefault.default).createElement(SmoothStepEdge, {
        ...props,
        pathOptions: (0, _react.useMemo)(()=>({
                borderRadius: 0,
                offset: props.pathOptions?.offset
            }), [
            props.pathOptions?.offset
        ])
    }));
StepEdge.displayName = 'StepEdge';
function getStraightPath({ sourceX, sourceY, targetX, targetY }) {
    const [labelX, labelY, offsetX, offsetY] = getEdgeCenter({
        sourceX,
        sourceY,
        targetX,
        targetY
    });
    return [
        `M ${sourceX},${sourceY}L ${targetX},${targetY}`,
        labelX,
        labelY,
        offsetX,
        offsetY
    ];
}
const StraightEdge = (0, _react.memo)(({ sourceX, sourceY, targetX, targetY, label, labelStyle, labelShowBg, labelBgStyle, labelBgPadding, labelBgBorderRadius, style, markerEnd, markerStart, interactionWidth })=>{
    const [path, labelX, labelY] = getStraightPath({
        sourceX,
        sourceY,
        targetX,
        targetY
    });
    return (0, _reactDefault.default).createElement(BaseEdge, {
        path: path,
        labelX: labelX,
        labelY: labelY,
        label: label,
        labelStyle: labelStyle,
        labelShowBg: labelShowBg,
        labelBgStyle: labelBgStyle,
        labelBgPadding: labelBgPadding,
        labelBgBorderRadius: labelBgBorderRadius,
        style: style,
        markerEnd: markerEnd,
        markerStart: markerStart,
        interactionWidth: interactionWidth
    });
});
StraightEdge.displayName = 'StraightEdge';
function calculateControlOffset(distance, curvature) {
    if (distance >= 0) return 0.5 * distance;
    return curvature * 25 * Math.sqrt(-distance);
}
function getControlWithCurvature({ pos, x1, y1, x2, y2, c }) {
    switch(pos){
        case Position.Left:
            return [
                x1 - calculateControlOffset(x1 - x2, c),
                y1
            ];
        case Position.Right:
            return [
                x1 + calculateControlOffset(x2 - x1, c),
                y1
            ];
        case Position.Top:
            return [
                x1,
                y1 - calculateControlOffset(y1 - y2, c)
            ];
        case Position.Bottom:
            return [
                x1,
                y1 + calculateControlOffset(y2 - y1, c)
            ];
    }
}
function getBezierPath({ sourceX, sourceY, sourcePosition = Position.Bottom, targetX, targetY, targetPosition = Position.Top, curvature = 0.25 }) {
    const [sourceControlX, sourceControlY] = getControlWithCurvature({
        pos: sourcePosition,
        x1: sourceX,
        y1: sourceY,
        x2: targetX,
        y2: targetY,
        c: curvature
    });
    const [targetControlX, targetControlY] = getControlWithCurvature({
        pos: targetPosition,
        x1: targetX,
        y1: targetY,
        x2: sourceX,
        y2: sourceY,
        c: curvature
    });
    const [labelX, labelY, offsetX, offsetY] = getBezierEdgeCenter({
        sourceX,
        sourceY,
        targetX,
        targetY,
        sourceControlX,
        sourceControlY,
        targetControlX,
        targetControlY
    });
    return [
        `M${sourceX},${sourceY} C${sourceControlX},${sourceControlY} ${targetControlX},${targetControlY} ${targetX},${targetY}`,
        labelX,
        labelY,
        offsetX,
        offsetY
    ];
}
const BezierEdge = (0, _react.memo)(({ sourceX, sourceY, targetX, targetY, sourcePosition = Position.Bottom, targetPosition = Position.Top, label, labelStyle, labelShowBg, labelBgStyle, labelBgPadding, labelBgBorderRadius, style, markerEnd, markerStart, pathOptions, interactionWidth })=>{
    const [path, labelX, labelY] = getBezierPath({
        sourceX,
        sourceY,
        sourcePosition,
        targetX,
        targetY,
        targetPosition,
        curvature: pathOptions?.curvature
    });
    return (0, _reactDefault.default).createElement(BaseEdge, {
        path: path,
        labelX: labelX,
        labelY: labelY,
        label: label,
        labelStyle: labelStyle,
        labelShowBg: labelShowBg,
        labelBgStyle: labelBgStyle,
        labelBgPadding: labelBgPadding,
        labelBgBorderRadius: labelBgBorderRadius,
        style: style,
        markerEnd: markerEnd,
        markerStart: markerStart,
        interactionWidth: interactionWidth
    });
});
BezierEdge.displayName = 'BezierEdge';
const NodeIdContext = (0, _react.createContext)(null);
const Provider = NodeIdContext.Provider;
NodeIdContext.Consumer;
const useNodeId = ()=>{
    const nodeId = (0, _react.useContext)(NodeIdContext);
    return nodeId;
};
const isEdge = (element)=>'id' in element && 'source' in element && 'target' in element;
const isNode = (element)=>'id' in element && !('source' in element) && !('target' in element);
const getOutgoers = (node, nodes, edges)=>{
    if (!isNode(node)) return [];
    const outgoerIds = edges.filter((e)=>e.source === node.id).map((e)=>e.target);
    return nodes.filter((n)=>outgoerIds.includes(n.id));
};
const getIncomers = (node, nodes, edges)=>{
    if (!isNode(node)) return [];
    const incomersIds = edges.filter((e)=>e.target === node.id).map((e)=>e.source);
    return nodes.filter((n)=>incomersIds.includes(n.id));
};
const getEdgeId = ({ source, sourceHandle, target, targetHandle })=>`reactflow__edge-${source}${sourceHandle || ''}-${target}${targetHandle || ''}`;
const getMarkerId = (marker, rfId)=>{
    if (typeof marker === 'undefined') return '';
    if (typeof marker === 'string') return marker;
    const idPrefix = rfId ? `${rfId}__` : '';
    return `${idPrefix}${Object.keys(marker).sort().map((key)=>`${key}=${marker[key]}`).join('&')}`;
};
const connectionExists = (edge, edges)=>{
    return edges.some((el)=>el.source === edge.source && el.target === edge.target && (el.sourceHandle === edge.sourceHandle || !el.sourceHandle && !edge.sourceHandle) && (el.targetHandle === edge.targetHandle || !el.targetHandle && !edge.targetHandle));
};
const addEdge = (edgeParams, edges)=>{
    if (!edgeParams.source || !edgeParams.target) {
        devWarn('006', errorMessages['error006']());
        return edges;
    }
    let edge;
    if (isEdge(edgeParams)) edge = {
        ...edgeParams
    };
    else edge = {
        ...edgeParams,
        id: getEdgeId(edgeParams)
    };
    if (connectionExists(edge, edges)) return edges;
    return edges.concat(edge);
};
const reconnectEdge = (oldEdge, newConnection, edges, options = {
    shouldReplaceId: true
})=>{
    const { id: oldEdgeId, ...rest } = oldEdge;
    if (!newConnection.source || !newConnection.target) {
        devWarn('006', errorMessages['error006']());
        return edges;
    }
    const foundEdge = edges.find((e)=>e.id === oldEdgeId);
    if (!foundEdge) {
        devWarn('007', errorMessages['error007'](oldEdgeId));
        return edges;
    }
    // Remove old edge and create the new edge with parameters of old edge.
    const edge = {
        ...rest,
        id: options.shouldReplaceId ? getEdgeId(newConnection) : oldEdgeId,
        source: newConnection.source,
        target: newConnection.target,
        sourceHandle: newConnection.sourceHandle,
        targetHandle: newConnection.targetHandle
    };
    return edges.filter((e)=>e.id !== oldEdgeId).concat(edge);
};
/**
 *
 * @deprecated Use `reconnectEdge` instead.
 */ const updateEdge = (oldEdge, newConnection, edges, options = {
    shouldReplaceId: true
})=>{
    console.warn('[DEPRECATED] `updateEdge` is deprecated. Instead use `reconnectEdge` https://reactflow.dev/api-reference/utils/reconnect-edge');
    return reconnectEdge(oldEdge, newConnection, edges, options);
};
const pointToRendererPoint = ({ x, y }, [tx, ty, tScale], snapToGrid, [snapX, snapY])=>{
    const position = {
        x: (x - tx) / tScale,
        y: (y - ty) / tScale
    };
    if (snapToGrid) return {
        x: snapX * Math.round(position.x / snapX),
        y: snapY * Math.round(position.y / snapY)
    };
    return position;
};
const rendererPointToPoint = ({ x, y }, [tx, ty, tScale])=>{
    return {
        x: x * tScale + tx,
        y: y * tScale + ty
    };
};
const getNodePositionWithOrigin = (node, nodeOrigin = [
    0,
    0
])=>{
    if (!node) return {
        x: 0,
        y: 0,
        positionAbsolute: {
            x: 0,
            y: 0
        }
    };
    const offsetX = (node.width ?? 0) * nodeOrigin[0];
    const offsetY = (node.height ?? 0) * nodeOrigin[1];
    const position = {
        x: node.position.x - offsetX,
        y: node.position.y - offsetY
    };
    return {
        ...position,
        positionAbsolute: node.positionAbsolute ? {
            x: node.positionAbsolute.x - offsetX,
            y: node.positionAbsolute.y - offsetY
        } : position
    };
};
const getNodesBounds = (nodes, nodeOrigin = [
    0,
    0
])=>{
    if (nodes.length === 0) return {
        x: 0,
        y: 0,
        width: 0,
        height: 0
    };
    const box = nodes.reduce((currBox, node)=>{
        const { x, y } = getNodePositionWithOrigin(node, nodeOrigin).positionAbsolute;
        return getBoundsOfBoxes(currBox, rectToBox({
            x,
            y,
            width: node.width || 0,
            height: node.height || 0
        }));
    }, {
        x: Infinity,
        y: Infinity,
        x2: -Infinity,
        y2: -Infinity
    });
    return boxToRect(box);
};
// @deprecated Use `getNodesBounds`.
const getRectOfNodes = (nodes, nodeOrigin = [
    0,
    0
])=>{
    console.warn('[DEPRECATED] `getRectOfNodes` is deprecated. Instead use `getNodesBounds` https://reactflow.dev/api-reference/utils/get-nodes-bounds.');
    return getNodesBounds(nodes, nodeOrigin);
};
const getNodesInside = (nodeInternals, rect, [tx, ty, tScale] = [
    0,
    0,
    1
], partially = false, // set excludeNonSelectableNodes if you want to pay attention to the nodes "selectable" attribute
excludeNonSelectableNodes = false, nodeOrigin = [
    0,
    0
])=>{
    const paneRect = {
        x: (rect.x - tx) / tScale,
        y: (rect.y - ty) / tScale,
        width: rect.width / tScale,
        height: rect.height / tScale
    };
    const visibleNodes = [];
    nodeInternals.forEach((node)=>{
        const { width, height, selectable = true, hidden = false } = node;
        if (excludeNonSelectableNodes && !selectable || hidden) return false;
        const { positionAbsolute } = getNodePositionWithOrigin(node, nodeOrigin);
        const nodeRect = {
            x: positionAbsolute.x,
            y: positionAbsolute.y,
            width: width || 0,
            height: height || 0
        };
        const overlappingArea = getOverlappingArea(paneRect, nodeRect);
        const notInitialized = typeof width === 'undefined' || typeof height === 'undefined' || width === null || height === null;
        const partiallyVisible = partially && overlappingArea > 0;
        const area = (width || 0) * (height || 0);
        const isVisible = notInitialized || partiallyVisible || overlappingArea >= area;
        if (isVisible || node.dragging) visibleNodes.push(node);
    });
    return visibleNodes;
};
const getConnectedEdges = (nodes, edges)=>{
    const nodeIds = nodes.map((node)=>node.id);
    return edges.filter((edge)=>nodeIds.includes(edge.source) || nodeIds.includes(edge.target));
};
// @deprecated Use `getViewportForBounds`.
const getTransformForBounds = (bounds, width, height, minZoom, maxZoom, padding = 0.1)=>{
    const { x, y, zoom } = getViewportForBounds(bounds, width, height, minZoom, maxZoom, padding);
    console.warn('[DEPRECATED] `getTransformForBounds` is deprecated. Instead use `getViewportForBounds`. Beware that the return value is type Viewport (`{ x: number, y: number, zoom: number }`) instead of Transform (`[number, number, number]`). https://reactflow.dev/api-reference/utils/get-viewport-for-bounds');
    return [
        x,
        y,
        zoom
    ];
};
const getViewportForBounds = (bounds, width, height, minZoom, maxZoom, padding = 0.1)=>{
    const xZoom = width / (bounds.width * (1 + padding));
    const yZoom = height / (bounds.height * (1 + padding));
    const zoom = Math.min(xZoom, yZoom);
    const clampedZoom = clamp(zoom, minZoom, maxZoom);
    const boundsCenterX = bounds.x + bounds.width / 2;
    const boundsCenterY = bounds.y + bounds.height / 2;
    const x = width / 2 - boundsCenterX * clampedZoom;
    const y = height / 2 - boundsCenterY * clampedZoom;
    return {
        x,
        y,
        zoom: clampedZoom
    };
};
const getD3Transition = (selection, duration = 0)=>{
    return selection.transition().duration(duration);
};
// this functions collects all handles and adds an absolute position
// so that we can later find the closest handle to the mouse position
function getHandles(node, handleBounds, type, currentHandle) {
    return (handleBounds[type] || []).reduce((res, h)=>{
        if (`${node.id}-${h.id}-${type}` !== currentHandle) res.push({
            id: h.id || null,
            type,
            nodeId: node.id,
            x: (node.positionAbsolute?.x ?? 0) + h.x + h.width / 2,
            y: (node.positionAbsolute?.y ?? 0) + h.y + h.height / 2
        });
        return res;
    }, []);
}
function getClosestHandle(event, doc, pos, connectionRadius, handles, validator) {
    // we always want to prioritize the handle below the mouse cursor over the closest distance handle,
    // because it could be that the center of another handle is closer to the mouse pointer than the handle below the cursor
    const { x, y } = getEventPosition(event);
    const domNodes = doc.elementsFromPoint(x, y);
    const handleBelow = domNodes.find((el)=>el.classList.contains('react-flow__handle'));
    if (handleBelow) {
        const handleNodeId = handleBelow.getAttribute('data-nodeid');
        if (handleNodeId) {
            const handleType = getHandleType(undefined, handleBelow);
            const handleId = handleBelow.getAttribute('data-handleid');
            const validHandleResult = validator({
                nodeId: handleNodeId,
                id: handleId,
                type: handleType
            });
            if (validHandleResult) {
                const handle = handles.find((h)=>h.nodeId === handleNodeId && h.type === handleType && h.id === handleId);
                return {
                    handle: {
                        id: handleId,
                        type: handleType,
                        nodeId: handleNodeId,
                        x: handle?.x || pos.x,
                        y: handle?.y || pos.y
                    },
                    validHandleResult
                };
            }
        }
    }
    // if we couldn't find a handle below the mouse cursor we look for the closest distance based on the connectionRadius
    let closestHandles = [];
    let minDistance = Infinity;
    handles.forEach((handle)=>{
        const distance = Math.sqrt((handle.x - pos.x) ** 2 + (handle.y - pos.y) ** 2);
        if (distance <= connectionRadius) {
            const validHandleResult = validator(handle);
            if (distance <= minDistance) {
                if (distance < minDistance) closestHandles = [
                    {
                        handle,
                        validHandleResult
                    }
                ];
                else if (distance === minDistance) // when multiple handles are on the same distance we collect all of them
                closestHandles.push({
                    handle,
                    validHandleResult
                });
                minDistance = distance;
            }
        }
    });
    if (!closestHandles.length) return {
        handle: null,
        validHandleResult: defaultResult()
    };
    if (closestHandles.length === 1) return closestHandles[0];
    const hasValidHandle = closestHandles.some(({ validHandleResult })=>validHandleResult.isValid);
    const hasTargetHandle = closestHandles.some(({ handle })=>handle.type === 'target');
    // if multiple handles are layouted on top of each other we prefer the one with type = target and the one that is valid
    return closestHandles.find(({ handle, validHandleResult })=>hasTargetHandle ? handle.type === 'target' : hasValidHandle ? validHandleResult.isValid : true) || closestHandles[0];
}
const nullConnection = {
    source: null,
    target: null,
    sourceHandle: null,
    targetHandle: null
};
const defaultResult = ()=>({
        handleDomNode: null,
        isValid: false,
        connection: nullConnection,
        endHandle: null
    });
// checks if  and returns connection in fom of an object { source: 123, target: 312 }
function isValidHandle(handle, connectionMode, fromNodeId, fromHandleId, fromType, isValidConnection, doc) {
    const isTarget = fromType === 'target';
    const handleToCheck = doc.querySelector(`.react-flow__handle[data-id="${handle?.nodeId}-${handle?.id}-${handle?.type}"]`);
    const result = {
        ...defaultResult(),
        handleDomNode: handleToCheck
    };
    if (handleToCheck) {
        const handleType = getHandleType(undefined, handleToCheck);
        const handleNodeId = handleToCheck.getAttribute('data-nodeid');
        const handleId = handleToCheck.getAttribute('data-handleid');
        const connectable = handleToCheck.classList.contains('connectable');
        const connectableEnd = handleToCheck.classList.contains('connectableend');
        const connection = {
            source: isTarget ? handleNodeId : fromNodeId,
            sourceHandle: isTarget ? handleId : fromHandleId,
            target: isTarget ? fromNodeId : handleNodeId,
            targetHandle: isTarget ? fromHandleId : handleId
        };
        result.connection = connection;
        const isConnectable = connectable && connectableEnd;
        // in strict mode we don't allow target to target or source to source connections
        const isValid = isConnectable && (connectionMode === ConnectionMode.Strict ? isTarget && handleType === 'source' || !isTarget && handleType === 'target' : handleNodeId !== fromNodeId || handleId !== fromHandleId);
        if (isValid) {
            result.endHandle = {
                nodeId: handleNodeId,
                handleId,
                type: handleType
            };
            result.isValid = isValidConnection(connection);
        }
    }
    return result;
}
function getHandleLookup({ nodes, nodeId, handleId, handleType }) {
    return nodes.reduce((res, node)=>{
        if (node[internalsSymbol]) {
            const { handleBounds } = node[internalsSymbol];
            let sourceHandles = [];
            let targetHandles = [];
            if (handleBounds) {
                sourceHandles = getHandles(node, handleBounds, 'source', `${nodeId}-${handleId}-${handleType}`);
                targetHandles = getHandles(node, handleBounds, 'target', `${nodeId}-${handleId}-${handleType}`);
            }
            res.push(...sourceHandles, ...targetHandles);
        }
        return res;
    }, []);
}
function getHandleType(edgeUpdaterType, handleDomNode) {
    if (edgeUpdaterType) return edgeUpdaterType;
    else if (handleDomNode?.classList.contains('target')) return 'target';
    else if (handleDomNode?.classList.contains('source')) return 'source';
    return null;
}
function resetRecentHandle(handleDomNode) {
    handleDomNode?.classList.remove('valid', 'connecting', 'react-flow__handle-valid', 'react-flow__handle-connecting');
}
function getConnectionStatus(isInsideConnectionRadius, isHandleValid) {
    let connectionStatus = null;
    if (isHandleValid) connectionStatus = 'valid';
    else if (isInsideConnectionRadius && !isHandleValid) connectionStatus = 'invalid';
    return connectionStatus;
}
function handlePointerDown({ event, handleId, nodeId, onConnect, isTarget, getState, setState, isValidConnection, edgeUpdaterType, onReconnectEnd }) {
    // when react-flow is used inside a shadow root we can't use document
    const doc = getHostForElement(event.target);
    const { connectionMode, domNode, autoPanOnConnect, connectionRadius, onConnectStart, panBy, getNodes, cancelConnection } = getState();
    let autoPanId = 0;
    let closestHandle;
    const { x, y } = getEventPosition(event);
    const clickedHandle = doc?.elementFromPoint(x, y);
    const handleType = getHandleType(edgeUpdaterType, clickedHandle);
    const containerBounds = domNode?.getBoundingClientRect();
    if (!containerBounds || !handleType) return;
    let prevActiveHandle;
    let connectionPosition = getEventPosition(event, containerBounds);
    let autoPanStarted = false;
    let connection = null;
    let isValid = false;
    let handleDomNode = null;
    const handleLookup = getHandleLookup({
        nodes: getNodes(),
        nodeId,
        handleId,
        handleType
    });
    // when the user is moving the mouse close to the edge of the canvas while connecting we move the canvas
    const autoPan = ()=>{
        if (!autoPanOnConnect) return;
        const [xMovement, yMovement] = calcAutoPan(connectionPosition, containerBounds);
        panBy({
            x: xMovement,
            y: yMovement
        });
        autoPanId = requestAnimationFrame(autoPan);
    };
    setState({
        connectionPosition,
        connectionStatus: null,
        // connectionNodeId etc will be removed in the next major in favor of connectionStartHandle
        connectionNodeId: nodeId,
        connectionHandleId: handleId,
        connectionHandleType: handleType,
        connectionStartHandle: {
            nodeId,
            handleId,
            type: handleType
        },
        connectionEndHandle: null
    });
    onConnectStart?.(event, {
        nodeId,
        handleId,
        handleType
    });
    function onPointerMove(event) {
        const { transform } = getState();
        connectionPosition = getEventPosition(event, containerBounds);
        const { handle, validHandleResult } = getClosestHandle(event, doc, pointToRendererPoint(connectionPosition, transform, false, [
            1,
            1
        ]), connectionRadius, handleLookup, (handle)=>isValidHandle(handle, connectionMode, nodeId, handleId, isTarget ? 'target' : 'source', isValidConnection, doc));
        closestHandle = handle;
        if (!autoPanStarted) {
            autoPan();
            autoPanStarted = true;
        }
        handleDomNode = validHandleResult.handleDomNode;
        connection = validHandleResult.connection;
        isValid = validHandleResult.isValid;
        setState({
            connectionPosition: closestHandle && isValid ? rendererPointToPoint({
                x: closestHandle.x,
                y: closestHandle.y
            }, transform) : connectionPosition,
            connectionStatus: getConnectionStatus(!!closestHandle, isValid),
            connectionEndHandle: validHandleResult.endHandle
        });
        if (!closestHandle && !isValid && !handleDomNode) return resetRecentHandle(prevActiveHandle);
        if (connection.source !== connection.target && handleDomNode) {
            resetRecentHandle(prevActiveHandle);
            prevActiveHandle = handleDomNode;
            // @todo: remove the old class names "react-flow__handle-" in the next major version
            handleDomNode.classList.add('connecting', 'react-flow__handle-connecting');
            handleDomNode.classList.toggle('valid', isValid);
            handleDomNode.classList.toggle('react-flow__handle-valid', isValid);
        }
    }
    function onPointerUp(event) {
        if ((closestHandle || handleDomNode) && connection && isValid) onConnect?.(connection);
        // it's important to get a fresh reference from the store here
        // in order to get the latest state of onConnectEnd
        getState().onConnectEnd?.(event);
        if (edgeUpdaterType) onReconnectEnd?.(event);
        resetRecentHandle(prevActiveHandle);
        cancelConnection();
        cancelAnimationFrame(autoPanId);
        autoPanStarted = false;
        isValid = false;
        connection = null;
        handleDomNode = null;
        doc.removeEventListener('mousemove', onPointerMove);
        doc.removeEventListener('mouseup', onPointerUp);
        doc.removeEventListener('touchmove', onPointerMove);
        doc.removeEventListener('touchend', onPointerUp);
    }
    doc.addEventListener('mousemove', onPointerMove);
    doc.addEventListener('mouseup', onPointerUp);
    doc.addEventListener('touchmove', onPointerMove);
    doc.addEventListener('touchend', onPointerUp);
}
const alwaysValid = ()=>true;
const selector$f = (s)=>({
        connectionStartHandle: s.connectionStartHandle,
        connectOnClick: s.connectOnClick,
        noPanClassName: s.noPanClassName
    });
const connectingSelector = (nodeId, handleId, type)=>(state)=>{
        const { connectionStartHandle: startHandle, connectionEndHandle: endHandle, connectionClickStartHandle: clickHandle } = state;
        return {
            connecting: startHandle?.nodeId === nodeId && startHandle?.handleId === handleId && startHandle?.type === type || endHandle?.nodeId === nodeId && endHandle?.handleId === handleId && endHandle?.type === type,
            clickConnecting: clickHandle?.nodeId === nodeId && clickHandle?.handleId === handleId && clickHandle?.type === type
        };
    };
const Handle = (0, _react.forwardRef)(({ type = 'source', position = Position.Top, isValidConnection, isConnectable = true, isConnectableStart = true, isConnectableEnd = true, id, onConnect, children, className, onMouseDown, onTouchStart, ...rest }, ref)=>{
    const handleId = id || null;
    const isTarget = type === 'target';
    const store = useStoreApi();
    const nodeId = useNodeId();
    const { connectOnClick, noPanClassName } = useStore(selector$f, (0, _shallow.shallow));
    const { connecting, clickConnecting } = useStore(connectingSelector(nodeId, handleId, type), (0, _shallow.shallow));
    if (!nodeId) store.getState().onError?.('010', errorMessages['error010']());
    const onConnectExtended = (params)=>{
        const { defaultEdgeOptions, onConnect: onConnectAction, hasDefaultEdges } = store.getState();
        const edgeParams = {
            ...defaultEdgeOptions,
            ...params
        };
        if (hasDefaultEdges) {
            const { edges, setEdges } = store.getState();
            setEdges(addEdge(edgeParams, edges));
        }
        onConnectAction?.(edgeParams);
        onConnect?.(edgeParams);
    };
    const onPointerDown = (event)=>{
        if (!nodeId) return;
        const isMouseTriggered = isMouseEvent(event);
        if (isConnectableStart && (isMouseTriggered && event.button === 0 || !isMouseTriggered)) handlePointerDown({
            event,
            handleId,
            nodeId,
            onConnect: onConnectExtended,
            isTarget,
            getState: store.getState,
            setState: store.setState,
            isValidConnection: isValidConnection || store.getState().isValidConnection || alwaysValid
        });
        if (isMouseTriggered) onMouseDown?.(event);
        else onTouchStart?.(event);
    };
    const onClick = (event)=>{
        const { onClickConnectStart, onClickConnectEnd, connectionClickStartHandle, connectionMode, isValidConnection: isValidConnectionStore } = store.getState();
        if (!nodeId || !connectionClickStartHandle && !isConnectableStart) return;
        if (!connectionClickStartHandle) {
            onClickConnectStart?.(event, {
                nodeId,
                handleId,
                handleType: type
            });
            store.setState({
                connectionClickStartHandle: {
                    nodeId,
                    type,
                    handleId
                }
            });
            return;
        }
        const doc = getHostForElement(event.target);
        const isValidConnectionHandler = isValidConnection || isValidConnectionStore || alwaysValid;
        const { connection, isValid } = isValidHandle({
            nodeId,
            id: handleId,
            type
        }, connectionMode, connectionClickStartHandle.nodeId, connectionClickStartHandle.handleId || null, connectionClickStartHandle.type, isValidConnectionHandler, doc);
        if (isValid) onConnectExtended(connection);
        onClickConnectEnd?.(event);
        store.setState({
            connectionClickStartHandle: null
        });
    };
    return (0, _reactDefault.default).createElement("div", {
        "data-handleid": handleId,
        "data-nodeid": nodeId,
        "data-handlepos": position,
        "data-id": `${nodeId}-${handleId}-${type}`,
        className: (0, _classcatDefault.default)([
            'react-flow__handle',
            `react-flow__handle-${position}`,
            'nodrag',
            noPanClassName,
            className,
            {
                source: !isTarget,
                target: isTarget,
                connectable: isConnectable,
                connectablestart: isConnectableStart,
                connectableend: isConnectableEnd,
                connecting: clickConnecting,
                // this class is used to style the handle when the user is connecting
                connectionindicator: isConnectable && (isConnectableStart && !connecting || isConnectableEnd && connecting)
            }
        ]),
        onMouseDown: onPointerDown,
        onTouchStart: onPointerDown,
        onClick: connectOnClick ? onClick : undefined,
        ref: ref,
        ...rest
    }, children);
});
Handle.displayName = 'Handle';
var Handle$1 = (0, _react.memo)(Handle);
const DefaultNode = ({ data, isConnectable, targetPosition = Position.Top, sourcePosition = Position.Bottom })=>{
    return (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement(Handle$1, {
        type: "target",
        position: targetPosition,
        isConnectable: isConnectable
    }), data?.label, (0, _reactDefault.default).createElement(Handle$1, {
        type: "source",
        position: sourcePosition,
        isConnectable: isConnectable
    }));
};
DefaultNode.displayName = 'DefaultNode';
var DefaultNode$1 = (0, _react.memo)(DefaultNode);
const InputNode = ({ data, isConnectable, sourcePosition = Position.Bottom })=>(0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, data?.label, (0, _reactDefault.default).createElement(Handle$1, {
        type: "source",
        position: sourcePosition,
        isConnectable: isConnectable
    }));
InputNode.displayName = 'InputNode';
var InputNode$1 = (0, _react.memo)(InputNode);
const OutputNode = ({ data, isConnectable, targetPosition = Position.Top })=>(0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement(Handle$1, {
        type: "target",
        position: targetPosition,
        isConnectable: isConnectable
    }), data?.label);
OutputNode.displayName = 'OutputNode';
var OutputNode$1 = (0, _react.memo)(OutputNode);
const GroupNode = ()=>null;
GroupNode.displayName = 'GroupNode';
const selector$e = (s)=>({
        selectedNodes: s.getNodes().filter((n)=>n.selected),
        selectedEdges: s.edges.filter((e)=>e.selected).map((e)=>({
                ...e
            }))
    });
const selectId = (obj)=>obj.id;
function areEqual(a, b) {
    return (0, _shallow.shallow)(a.selectedNodes.map(selectId), b.selectedNodes.map(selectId)) && (0, _shallow.shallow)(a.selectedEdges.map(selectId), b.selectedEdges.map(selectId));
}
// This is just a helper component for calling the onSelectionChange listener.
// @TODO: Now that we have the onNodesChange and on EdgesChange listeners, do we still need this component?
const SelectionListener = (0, _react.memo)(({ onSelectionChange })=>{
    const store = useStoreApi();
    const { selectedNodes, selectedEdges } = useStore(selector$e, areEqual);
    (0, _react.useEffect)(()=>{
        const params = {
            nodes: selectedNodes,
            edges: selectedEdges
        };
        onSelectionChange?.(params);
        store.getState().onSelectionChange.forEach((fn)=>fn(params));
    }, [
        selectedNodes,
        selectedEdges,
        onSelectionChange
    ]);
    return null;
});
SelectionListener.displayName = 'SelectionListener';
const changeSelector = (s)=>!!s.onSelectionChange;
function Wrapper$1({ onSelectionChange }) {
    const storeHasSelectionChange = useStore(changeSelector);
    if (onSelectionChange || storeHasSelectionChange) return (0, _reactDefault.default).createElement(SelectionListener, {
        onSelectionChange: onSelectionChange
    });
    return null;
}
const selector$d = (s)=>({
        setNodes: s.setNodes,
        setEdges: s.setEdges,
        setDefaultNodesAndEdges: s.setDefaultNodesAndEdges,
        setMinZoom: s.setMinZoom,
        setMaxZoom: s.setMaxZoom,
        setTranslateExtent: s.setTranslateExtent,
        setNodeExtent: s.setNodeExtent,
        reset: s.reset
    });
function useStoreUpdater(value, setStoreState) {
    (0, _react.useEffect)(()=>{
        if (typeof value !== 'undefined') setStoreState(value);
    }, [
        value
    ]);
}
// updates with values in store that don't have a dedicated setter function
function useDirectStoreUpdater(key, value, setState) {
    (0, _react.useEffect)(()=>{
        if (typeof value !== 'undefined') setState({
            [key]: value
        });
    }, [
        value
    ]);
}
const StoreUpdater = ({ nodes, edges, defaultNodes, defaultEdges, onConnect, onConnectStart, onConnectEnd, onClickConnectStart, onClickConnectEnd, nodesDraggable, nodesConnectable, nodesFocusable, edgesFocusable, edgesUpdatable, elevateNodesOnSelect, minZoom, maxZoom, nodeExtent, onNodesChange, onEdgesChange, elementsSelectable, connectionMode, snapGrid, snapToGrid, translateExtent, connectOnClick, defaultEdgeOptions, fitView, fitViewOptions, onNodesDelete, onEdgesDelete, onNodeDrag, onNodeDragStart, onNodeDragStop, onSelectionDrag, onSelectionDragStart, onSelectionDragStop, noPanClassName, nodeOrigin, rfId, autoPanOnConnect, autoPanOnNodeDrag, onError, connectionRadius, isValidConnection, nodeDragThreshold })=>{
    const { setNodes, setEdges, setDefaultNodesAndEdges, setMinZoom, setMaxZoom, setTranslateExtent, setNodeExtent, reset } = useStore(selector$d, (0, _shallow.shallow));
    const store = useStoreApi();
    (0, _react.useEffect)(()=>{
        const edgesWithDefaults = defaultEdges?.map((e)=>({
                ...e,
                ...defaultEdgeOptions
            }));
        setDefaultNodesAndEdges(defaultNodes, edgesWithDefaults);
        return ()=>{
            reset();
        };
    }, []);
    useDirectStoreUpdater('defaultEdgeOptions', defaultEdgeOptions, store.setState);
    useDirectStoreUpdater('connectionMode', connectionMode, store.setState);
    useDirectStoreUpdater('onConnect', onConnect, store.setState);
    useDirectStoreUpdater('onConnectStart', onConnectStart, store.setState);
    useDirectStoreUpdater('onConnectEnd', onConnectEnd, store.setState);
    useDirectStoreUpdater('onClickConnectStart', onClickConnectStart, store.setState);
    useDirectStoreUpdater('onClickConnectEnd', onClickConnectEnd, store.setState);
    useDirectStoreUpdater('nodesDraggable', nodesDraggable, store.setState);
    useDirectStoreUpdater('nodesConnectable', nodesConnectable, store.setState);
    useDirectStoreUpdater('nodesFocusable', nodesFocusable, store.setState);
    useDirectStoreUpdater('edgesFocusable', edgesFocusable, store.setState);
    useDirectStoreUpdater('edgesUpdatable', edgesUpdatable, store.setState);
    useDirectStoreUpdater('elementsSelectable', elementsSelectable, store.setState);
    useDirectStoreUpdater('elevateNodesOnSelect', elevateNodesOnSelect, store.setState);
    useDirectStoreUpdater('snapToGrid', snapToGrid, store.setState);
    useDirectStoreUpdater('snapGrid', snapGrid, store.setState);
    useDirectStoreUpdater('onNodesChange', onNodesChange, store.setState);
    useDirectStoreUpdater('onEdgesChange', onEdgesChange, store.setState);
    useDirectStoreUpdater('connectOnClick', connectOnClick, store.setState);
    useDirectStoreUpdater('fitViewOnInit', fitView, store.setState);
    useDirectStoreUpdater('fitViewOnInitOptions', fitViewOptions, store.setState);
    useDirectStoreUpdater('onNodesDelete', onNodesDelete, store.setState);
    useDirectStoreUpdater('onEdgesDelete', onEdgesDelete, store.setState);
    useDirectStoreUpdater('onNodeDrag', onNodeDrag, store.setState);
    useDirectStoreUpdater('onNodeDragStart', onNodeDragStart, store.setState);
    useDirectStoreUpdater('onNodeDragStop', onNodeDragStop, store.setState);
    useDirectStoreUpdater('onSelectionDrag', onSelectionDrag, store.setState);
    useDirectStoreUpdater('onSelectionDragStart', onSelectionDragStart, store.setState);
    useDirectStoreUpdater('onSelectionDragStop', onSelectionDragStop, store.setState);
    useDirectStoreUpdater('noPanClassName', noPanClassName, store.setState);
    useDirectStoreUpdater('nodeOrigin', nodeOrigin, store.setState);
    useDirectStoreUpdater('rfId', rfId, store.setState);
    useDirectStoreUpdater('autoPanOnConnect', autoPanOnConnect, store.setState);
    useDirectStoreUpdater('autoPanOnNodeDrag', autoPanOnNodeDrag, store.setState);
    useDirectStoreUpdater('onError', onError, store.setState);
    useDirectStoreUpdater('connectionRadius', connectionRadius, store.setState);
    useDirectStoreUpdater('isValidConnection', isValidConnection, store.setState);
    useDirectStoreUpdater('nodeDragThreshold', nodeDragThreshold, store.setState);
    useStoreUpdater(nodes, setNodes);
    useStoreUpdater(edges, setEdges);
    useStoreUpdater(minZoom, setMinZoom);
    useStoreUpdater(maxZoom, setMaxZoom);
    useStoreUpdater(translateExtent, setTranslateExtent);
    useStoreUpdater(nodeExtent, setNodeExtent);
    return null;
};
const style = {
    display: 'none'
};
const ariaLiveStyle = {
    position: 'absolute',
    width: 1,
    height: 1,
    margin: -1,
    border: 0,
    padding: 0,
    overflow: 'hidden',
    clip: 'rect(0px, 0px, 0px, 0px)',
    clipPath: 'inset(100%)'
};
const ARIA_NODE_DESC_KEY = 'react-flow__node-desc';
const ARIA_EDGE_DESC_KEY = 'react-flow__edge-desc';
const ARIA_LIVE_MESSAGE = 'react-flow__aria-live';
const selector$c = (s)=>s.ariaLiveMessage;
function AriaLiveMessage({ rfId }) {
    const ariaLiveMessage = useStore(selector$c);
    return (0, _reactDefault.default).createElement("div", {
        id: `${ARIA_LIVE_MESSAGE}-${rfId}`,
        "aria-live": "assertive",
        "aria-atomic": "true",
        style: ariaLiveStyle
    }, ariaLiveMessage);
}
function A11yDescriptions({ rfId, disableKeyboardA11y }) {
    return (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("div", {
        id: `${ARIA_NODE_DESC_KEY}-${rfId}`,
        style: style
    }, "Press enter or space to select a node.", !disableKeyboardA11y && 'You can then use the arrow keys to move the node around.', " Press delete to remove it and escape to cancel.", ' '), (0, _reactDefault.default).createElement("div", {
        id: `${ARIA_EDGE_DESC_KEY}-${rfId}`,
        style: style
    }, "Press enter or space to select an edge. You can then press delete to remove it or escape to cancel."), !disableKeyboardA11y && (0, _reactDefault.default).createElement(AriaLiveMessage, {
        rfId: rfId
    }));
}
// the keycode can be a string 'a' or an array of strings ['a', 'a+d']
// a string means a single key 'a' or a combination when '+' is used 'a+d'
// an array means different possibilities. Explainer: ['a', 'd+s'] here the
// user can use the single key 'a' or the combination 'd' + 's'
var useKeyPress = (keyCode = null, options = {
    actInsideInputWithModifier: true
})=>{
    const [keyPressed, setKeyPressed] = (0, _react.useState)(false);
    // we need to remember if a modifier key is pressed in order to track it
    const modifierPressed = (0, _react.useRef)(false);
    // we need to remember the pressed keys in order to support combinations
    const pressedKeys = (0, _react.useRef)(new Set([]));
    // keyCodes = array with single keys [['a']] or key combinations [['a', 's']]
    // keysToWatch = array with all keys flattened ['a', 'd', 'ShiftLeft']
    // used to check if we store event.code or event.key. When the code is in the list of keysToWatch
    // we use the code otherwise the key. Explainer: When you press the left "command" key, the code is "MetaLeft"
    // and the key is "Meta". We want users to be able to pass keys and codes so we assume that the key is meant when
    // we can't find it in the list of keysToWatch.
    const [keyCodes, keysToWatch] = (0, _react.useMemo)(()=>{
        if (keyCode !== null) {
            const keyCodeArr = Array.isArray(keyCode) ? keyCode : [
                keyCode
            ];
            const keys = keyCodeArr.filter((kc)=>typeof kc === 'string').map((kc)=>kc.split('+'));
            const keysFlat = keys.reduce((res, item)=>res.concat(...item), []);
            return [
                keys,
                keysFlat
            ];
        }
        return [
            [],
            []
        ];
    }, [
        keyCode
    ]);
    (0, _react.useEffect)(()=>{
        const doc = typeof document !== 'undefined' ? document : null;
        const target = options?.target || doc;
        if (keyCode !== null) {
            const downHandler = (event)=>{
                modifierPressed.current = event.ctrlKey || event.metaKey || event.shiftKey;
                const preventAction = (!modifierPressed.current || modifierPressed.current && !options.actInsideInputWithModifier) && isInputDOMNode(event);
                if (preventAction) return false;
                const keyOrCode = useKeyOrCode(event.code, keysToWatch);
                pressedKeys.current.add(event[keyOrCode]);
                if (isMatchingKey(keyCodes, pressedKeys.current, false)) {
                    event.preventDefault();
                    setKeyPressed(true);
                }
            };
            const upHandler = (event)=>{
                const preventAction = (!modifierPressed.current || modifierPressed.current && !options.actInsideInputWithModifier) && isInputDOMNode(event);
                if (preventAction) return false;
                const keyOrCode = useKeyOrCode(event.code, keysToWatch);
                if (isMatchingKey(keyCodes, pressedKeys.current, true)) {
                    setKeyPressed(false);
                    pressedKeys.current.clear();
                } else pressedKeys.current.delete(event[keyOrCode]);
                // fix for Mac: when cmd key is pressed, keyup is not triggered for any other key, see: https://stackoverflow.com/questions/27380018/when-cmd-key-is-kept-pressed-keyup-is-not-triggered-for-any-other-key
                if (event.key === 'Meta') pressedKeys.current.clear();
                modifierPressed.current = false;
            };
            const resetHandler = ()=>{
                pressedKeys.current.clear();
                setKeyPressed(false);
            };
            target?.addEventListener('keydown', downHandler);
            target?.addEventListener('keyup', upHandler);
            window.addEventListener('blur', resetHandler);
            return ()=>{
                target?.removeEventListener('keydown', downHandler);
                target?.removeEventListener('keyup', upHandler);
                window.removeEventListener('blur', resetHandler);
            };
        }
    }, [
        keyCode,
        setKeyPressed
    ]);
    return keyPressed;
};
// utils
function isMatchingKey(keyCodes, pressedKeys, isUp) {
    return keyCodes// we only want to compare same sizes of keyCode definitions
    // and pressed keys. When the user specified 'Meta' as a key somewhere
    // this would also be truthy without this filter when user presses 'Meta' + 'r'
    .filter((keys)=>isUp || keys.length === pressedKeys.size)// since we want to support multiple possibilities only one of the
    // combinations need to be part of the pressed keys
    .some((keys)=>keys.every((k)=>pressedKeys.has(k)));
}
function useKeyOrCode(eventCode, keysToWatch) {
    return keysToWatch.includes(eventCode) ? 'code' : 'key';
}
function calculateXYZPosition(node, nodeInternals, result, nodeOrigin) {
    const parentId = node.parentNode || node.parentId;
    if (!parentId) return result;
    const parentNode = nodeInternals.get(parentId);
    const parentNodePosition = getNodePositionWithOrigin(parentNode, nodeOrigin);
    return calculateXYZPosition(parentNode, nodeInternals, {
        x: (result.x ?? 0) + parentNodePosition.x,
        y: (result.y ?? 0) + parentNodePosition.y,
        z: (parentNode[internalsSymbol]?.z ?? 0) > (result.z ?? 0) ? parentNode[internalsSymbol]?.z ?? 0 : result.z ?? 0
    }, nodeOrigin);
}
function updateAbsoluteNodePositions(nodeInternals, nodeOrigin, parentNodes) {
    nodeInternals.forEach((node)=>{
        const parentId = node.parentNode || node.parentId;
        if (parentId && !nodeInternals.has(parentId)) throw new Error(`Parent node ${parentId} not found`);
        if (parentId || parentNodes?.[node.id]) {
            const { x, y, z } = calculateXYZPosition(node, nodeInternals, {
                ...node.position,
                z: node[internalsSymbol]?.z ?? 0
            }, nodeOrigin);
            node.positionAbsolute = {
                x,
                y
            };
            node[internalsSymbol].z = z;
            if (parentNodes?.[node.id]) node[internalsSymbol].isParent = true;
        }
    });
}
function createNodeInternals(nodes, nodeInternals, nodeOrigin, elevateNodesOnSelect) {
    const nextNodeInternals = new Map();
    const parentNodes = {};
    const selectedNodeZ = elevateNodesOnSelect ? 1000 : 0;
    nodes.forEach((node)=>{
        const z = (isNumeric(node.zIndex) ? node.zIndex : 0) + (node.selected ? selectedNodeZ : 0);
        const currInternals = nodeInternals.get(node.id);
        const internals = {
            ...node,
            positionAbsolute: {
                x: node.position.x,
                y: node.position.y
            }
        };
        const parentId = node.parentNode || node.parentId;
        if (parentId) parentNodes[parentId] = true;
        const resetHandleBounds = currInternals?.type && currInternals?.type !== node.type;
        Object.defineProperty(internals, internalsSymbol, {
            enumerable: false,
            value: {
                handleBounds: resetHandleBounds ? undefined : currInternals?.[internalsSymbol]?.handleBounds,
                z
            }
        });
        nextNodeInternals.set(node.id, internals);
    });
    updateAbsoluteNodePositions(nextNodeInternals, nodeOrigin, parentNodes);
    return nextNodeInternals;
}
function fitView(get, options = {}) {
    const { getNodes, width, height, minZoom, maxZoom, d3Zoom, d3Selection, fitViewOnInitDone, fitViewOnInit, nodeOrigin } = get();
    const isInitialFitView = options.initial && !fitViewOnInitDone && fitViewOnInit;
    const d3initialized = d3Zoom && d3Selection;
    if (d3initialized && (isInitialFitView || !options.initial)) {
        const nodes = getNodes().filter((n)=>{
            const isVisible = options.includeHiddenNodes ? n.width && n.height : !n.hidden;
            if (options.nodes?.length) return isVisible && options.nodes.some((optionNode)=>optionNode.id === n.id);
            return isVisible;
        });
        const nodesInitialized = nodes.every((n)=>n.width && n.height);
        if (nodes.length > 0 && nodesInitialized) {
            const bounds = getNodesBounds(nodes, nodeOrigin);
            const { x, y, zoom } = getViewportForBounds(bounds, width, height, options.minZoom ?? minZoom, options.maxZoom ?? maxZoom, options.padding ?? 0.1);
            const nextTransform = (0, _d3Zoom.zoomIdentity).translate(x, y).scale(zoom);
            if (typeof options.duration === 'number' && options.duration > 0) d3Zoom.transform(getD3Transition(d3Selection, options.duration), nextTransform);
            else d3Zoom.transform(d3Selection, nextTransform);
            return true;
        }
    }
    return false;
}
function handleControlledNodeSelectionChange(nodeChanges, nodeInternals) {
    nodeChanges.forEach((change)=>{
        const node = nodeInternals.get(change.id);
        if (node) nodeInternals.set(node.id, {
            ...node,
            [internalsSymbol]: node[internalsSymbol],
            selected: change.selected
        });
    });
    return new Map(nodeInternals);
}
function handleControlledEdgeSelectionChange(edgeChanges, edges) {
    return edges.map((e)=>{
        const change = edgeChanges.find((change)=>change.id === e.id);
        if (change) e.selected = change.selected;
        return e;
    });
}
function updateNodesAndEdgesSelections({ changedNodes, changedEdges, get, set }) {
    const { nodeInternals, edges, onNodesChange, onEdgesChange, hasDefaultNodes, hasDefaultEdges } = get();
    if (changedNodes?.length) {
        if (hasDefaultNodes) set({
            nodeInternals: handleControlledNodeSelectionChange(changedNodes, nodeInternals)
        });
        onNodesChange?.(changedNodes);
    }
    if (changedEdges?.length) {
        if (hasDefaultEdges) set({
            edges: handleControlledEdgeSelectionChange(changedEdges, edges)
        });
        onEdgesChange?.(changedEdges);
    }
}
// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = ()=>{};
const initialViewportHelper = {
    zoomIn: noop,
    zoomOut: noop,
    zoomTo: noop,
    getZoom: ()=>1,
    setViewport: noop,
    getViewport: ()=>({
            x: 0,
            y: 0,
            zoom: 1
        }),
    fitView: ()=>false,
    setCenter: noop,
    fitBounds: noop,
    project: (position)=>position,
    screenToFlowPosition: (position)=>position,
    flowToScreenPosition: (position)=>position,
    viewportInitialized: false
};
const selector$b = (s)=>({
        d3Zoom: s.d3Zoom,
        d3Selection: s.d3Selection
    });
const useViewportHelper = ()=>{
    const store = useStoreApi();
    const { d3Zoom, d3Selection } = useStore(selector$b, (0, _shallow.shallow));
    const viewportHelperFunctions = (0, _react.useMemo)(()=>{
        if (d3Selection && d3Zoom) return {
            zoomIn: (options)=>d3Zoom.scaleBy(getD3Transition(d3Selection, options?.duration), 1.2),
            zoomOut: (options)=>d3Zoom.scaleBy(getD3Transition(d3Selection, options?.duration), 1 / 1.2),
            zoomTo: (zoomLevel, options)=>d3Zoom.scaleTo(getD3Transition(d3Selection, options?.duration), zoomLevel),
            getZoom: ()=>store.getState().transform[2],
            setViewport: (transform, options)=>{
                const [x, y, zoom] = store.getState().transform;
                const nextTransform = (0, _d3Zoom.zoomIdentity).translate(transform.x ?? x, transform.y ?? y).scale(transform.zoom ?? zoom);
                d3Zoom.transform(getD3Transition(d3Selection, options?.duration), nextTransform);
            },
            getViewport: ()=>{
                const [x, y, zoom] = store.getState().transform;
                return {
                    x,
                    y,
                    zoom
                };
            },
            fitView: (options)=>fitView(store.getState, options),
            setCenter: (x, y, options)=>{
                const { width, height, maxZoom } = store.getState();
                const nextZoom = typeof options?.zoom !== 'undefined' ? options.zoom : maxZoom;
                const centerX = width / 2 - x * nextZoom;
                const centerY = height / 2 - y * nextZoom;
                const transform = (0, _d3Zoom.zoomIdentity).translate(centerX, centerY).scale(nextZoom);
                d3Zoom.transform(getD3Transition(d3Selection, options?.duration), transform);
            },
            fitBounds: (bounds, options)=>{
                const { width, height, minZoom, maxZoom } = store.getState();
                const { x, y, zoom } = getViewportForBounds(bounds, width, height, minZoom, maxZoom, options?.padding ?? 0.1);
                const transform = (0, _d3Zoom.zoomIdentity).translate(x, y).scale(zoom);
                d3Zoom.transform(getD3Transition(d3Selection, options?.duration), transform);
            },
            // @deprecated Use `screenToFlowPosition`.
            project: (position)=>{
                const { transform, snapToGrid, snapGrid } = store.getState();
                console.warn('[DEPRECATED] `project` is deprecated. Instead use `screenToFlowPosition`. There is no need to subtract the react flow bounds anymore! https://reactflow.dev/api-reference/types/react-flow-instance#screen-to-flow-position');
                return pointToRendererPoint(position, transform, snapToGrid, snapGrid);
            },
            screenToFlowPosition: (position)=>{
                const { transform, snapToGrid, snapGrid, domNode } = store.getState();
                if (!domNode) return position;
                const { x: domX, y: domY } = domNode.getBoundingClientRect();
                const relativePosition = {
                    x: position.x - domX,
                    y: position.y - domY
                };
                return pointToRendererPoint(relativePosition, transform, snapToGrid, snapGrid);
            },
            flowToScreenPosition: (position)=>{
                const { transform, domNode } = store.getState();
                if (!domNode) return position;
                const { x: domX, y: domY } = domNode.getBoundingClientRect();
                const rendererPosition = rendererPointToPoint(position, transform);
                return {
                    x: rendererPosition.x + domX,
                    y: rendererPosition.y + domY
                };
            },
            viewportInitialized: true
        };
        return initialViewportHelper;
    }, [
        d3Zoom,
        d3Selection
    ]);
    return viewportHelperFunctions;
};
/* eslint-disable-next-line @typescript-eslint/no-explicit-any */ function useReactFlow() {
    const viewportHelper = useViewportHelper();
    const store = useStoreApi();
    const getNodes = (0, _react.useCallback)(()=>{
        return store.getState().getNodes().map((n)=>({
                ...n
            }));
    }, []);
    const getNode = (0, _react.useCallback)((id)=>{
        return store.getState().nodeInternals.get(id);
    }, []);
    const getEdges = (0, _react.useCallback)(()=>{
        const { edges = [] } = store.getState();
        return edges.map((e)=>({
                ...e
            }));
    }, []);
    const getEdge = (0, _react.useCallback)((id)=>{
        const { edges = [] } = store.getState();
        return edges.find((e)=>e.id === id);
    }, []);
    const setNodes = (0, _react.useCallback)((payload)=>{
        const { getNodes, setNodes, hasDefaultNodes, onNodesChange } = store.getState();
        const nodes = getNodes();
        const nextNodes = typeof payload === 'function' ? payload(nodes) : payload;
        if (hasDefaultNodes) setNodes(nextNodes);
        else if (onNodesChange) {
            const changes = nextNodes.length === 0 ? nodes.map((node)=>({
                    type: 'remove',
                    id: node.id
                })) : nextNodes.map((node)=>({
                    item: node,
                    type: 'reset'
                }));
            onNodesChange(changes);
        }
    }, []);
    const setEdges = (0, _react.useCallback)((payload)=>{
        const { edges = [], setEdges, hasDefaultEdges, onEdgesChange } = store.getState();
        const nextEdges = typeof payload === 'function' ? payload(edges) : payload;
        if (hasDefaultEdges) setEdges(nextEdges);
        else if (onEdgesChange) {
            const changes = nextEdges.length === 0 ? edges.map((edge)=>({
                    type: 'remove',
                    id: edge.id
                })) : nextEdges.map((edge)=>({
                    item: edge,
                    type: 'reset'
                }));
            onEdgesChange(changes);
        }
    }, []);
    const addNodes = (0, _react.useCallback)((payload)=>{
        const nodes = Array.isArray(payload) ? payload : [
            payload
        ];
        const { getNodes, setNodes, hasDefaultNodes, onNodesChange } = store.getState();
        if (hasDefaultNodes) {
            const currentNodes = getNodes();
            const nextNodes = [
                ...currentNodes,
                ...nodes
            ];
            setNodes(nextNodes);
        } else if (onNodesChange) {
            const changes = nodes.map((node)=>({
                    item: node,
                    type: 'add'
                }));
            onNodesChange(changes);
        }
    }, []);
    const addEdges = (0, _react.useCallback)((payload)=>{
        const nextEdges = Array.isArray(payload) ? payload : [
            payload
        ];
        const { edges = [], setEdges, hasDefaultEdges, onEdgesChange } = store.getState();
        if (hasDefaultEdges) setEdges([
            ...edges,
            ...nextEdges
        ]);
        else if (onEdgesChange) {
            const changes = nextEdges.map((edge)=>({
                    item: edge,
                    type: 'add'
                }));
            onEdgesChange(changes);
        }
    }, []);
    const toObject = (0, _react.useCallback)(()=>{
        const { getNodes, edges = [], transform } = store.getState();
        const [x, y, zoom] = transform;
        return {
            nodes: getNodes().map((n)=>({
                    ...n
                })),
            edges: edges.map((e)=>({
                    ...e
                })),
            viewport: {
                x,
                y,
                zoom
            }
        };
    }, []);
    const deleteElements = (0, _react.useCallback)(({ nodes: nodesDeleted, edges: edgesDeleted })=>{
        const { nodeInternals, getNodes, edges, hasDefaultNodes, hasDefaultEdges, onNodesDelete, onEdgesDelete, onNodesChange, onEdgesChange } = store.getState();
        const nodeIds = (nodesDeleted || []).map((node)=>node.id);
        const edgeIds = (edgesDeleted || []).map((edge)=>edge.id);
        const nodesToRemove = getNodes().reduce((res, node)=>{
            const parentId = node.parentNode || node.parentId;
            const parentHit = !nodeIds.includes(node.id) && parentId && res.find((n)=>n.id === parentId);
            const deletable = typeof node.deletable === 'boolean' ? node.deletable : true;
            if (deletable && (nodeIds.includes(node.id) || parentHit)) res.push(node);
            return res;
        }, []);
        const deletableEdges = edges.filter((e)=>typeof e.deletable === 'boolean' ? e.deletable : true);
        const initialHitEdges = deletableEdges.filter((e)=>edgeIds.includes(e.id));
        if (nodesToRemove || initialHitEdges) {
            const connectedEdges = getConnectedEdges(nodesToRemove, deletableEdges);
            const edgesToRemove = [
                ...initialHitEdges,
                ...connectedEdges
            ];
            const edgeIdsToRemove = edgesToRemove.reduce((res, edge)=>{
                if (!res.includes(edge.id)) res.push(edge.id);
                return res;
            }, []);
            if (hasDefaultEdges || hasDefaultNodes) {
                if (hasDefaultEdges) store.setState({
                    edges: edges.filter((e)=>!edgeIdsToRemove.includes(e.id))
                });
                if (hasDefaultNodes) {
                    nodesToRemove.forEach((node)=>{
                        nodeInternals.delete(node.id);
                    });
                    store.setState({
                        nodeInternals: new Map(nodeInternals)
                    });
                }
            }
            if (edgeIdsToRemove.length > 0) {
                onEdgesDelete?.(edgesToRemove);
                if (onEdgesChange) onEdgesChange(edgeIdsToRemove.map((id)=>({
                        id,
                        type: 'remove'
                    })));
            }
            if (nodesToRemove.length > 0) {
                onNodesDelete?.(nodesToRemove);
                if (onNodesChange) {
                    const nodeChanges = nodesToRemove.map((n)=>({
                            id: n.id,
                            type: 'remove'
                        }));
                    onNodesChange(nodeChanges);
                }
            }
        }
    }, []);
    const getNodeRect = (0, _react.useCallback)((nodeOrRect)=>{
        const isRect = isRectObject(nodeOrRect);
        const node = isRect ? null : store.getState().nodeInternals.get(nodeOrRect.id);
        if (!isRect && !node) return [
            null,
            null,
            isRect
        ];
        const nodeRect = isRect ? nodeOrRect : nodeToRect(node);
        return [
            nodeRect,
            node,
            isRect
        ];
    }, []);
    const getIntersectingNodes = (0, _react.useCallback)((nodeOrRect, partially = true, nodes)=>{
        const [nodeRect, node, isRect] = getNodeRect(nodeOrRect);
        if (!nodeRect) return [];
        return (nodes || store.getState().getNodes()).filter((n)=>{
            if (!isRect && (n.id === node.id || !n.positionAbsolute)) return false;
            const currNodeRect = nodeToRect(n);
            const overlappingArea = getOverlappingArea(currNodeRect, nodeRect);
            const partiallyVisible = partially && overlappingArea > 0;
            return partiallyVisible || overlappingArea >= nodeRect.width * nodeRect.height;
        });
    }, []);
    const isNodeIntersecting = (0, _react.useCallback)((nodeOrRect, area, partially = true)=>{
        const [nodeRect] = getNodeRect(nodeOrRect);
        if (!nodeRect) return false;
        const overlappingArea = getOverlappingArea(nodeRect, area);
        const partiallyVisible = partially && overlappingArea > 0;
        return partiallyVisible || overlappingArea >= nodeRect.width * nodeRect.height;
    }, []);
    return (0, _react.useMemo)(()=>{
        return {
            ...viewportHelper,
            getNodes,
            getNode,
            getEdges,
            getEdge,
            setNodes,
            setEdges,
            addNodes,
            addEdges,
            toObject,
            deleteElements,
            getIntersectingNodes,
            isNodeIntersecting
        };
    }, [
        viewportHelper,
        getNodes,
        getNode,
        getEdges,
        getEdge,
        setNodes,
        setEdges,
        addNodes,
        addEdges,
        toObject,
        deleteElements,
        getIntersectingNodes,
        isNodeIntersecting
    ]);
}
const deleteKeyOptions = {
    actInsideInputWithModifier: false
};
var useGlobalKeyHandler = ({ deleteKeyCode, multiSelectionKeyCode })=>{
    const store = useStoreApi();
    const { deleteElements } = useReactFlow();
    const deleteKeyPressed = useKeyPress(deleteKeyCode, deleteKeyOptions);
    const multiSelectionKeyPressed = useKeyPress(multiSelectionKeyCode);
    (0, _react.useEffect)(()=>{
        if (deleteKeyPressed) {
            const { edges, getNodes } = store.getState();
            const selectedNodes = getNodes().filter((node)=>node.selected);
            const selectedEdges = edges.filter((edge)=>edge.selected);
            deleteElements({
                nodes: selectedNodes,
                edges: selectedEdges
            });
            store.setState({
                nodesSelectionActive: false
            });
        }
    }, [
        deleteKeyPressed
    ]);
    (0, _react.useEffect)(()=>{
        store.setState({
            multiSelectionActive: multiSelectionKeyPressed
        });
    }, [
        multiSelectionKeyPressed
    ]);
};
function useResizeHandler(rendererNode) {
    const store = useStoreApi();
    (0, _react.useEffect)(()=>{
        let resizeObserver;
        const updateDimensions = ()=>{
            if (!rendererNode.current) return;
            const size = getDimensions(rendererNode.current);
            if (size.height === 0 || size.width === 0) store.getState().onError?.('004', errorMessages['error004']());
            store.setState({
                width: size.width || 500,
                height: size.height || 500
            });
        };
        updateDimensions();
        window.addEventListener('resize', updateDimensions);
        if (rendererNode.current) {
            resizeObserver = new ResizeObserver(()=>updateDimensions());
            resizeObserver.observe(rendererNode.current);
        }
        return ()=>{
            window.removeEventListener('resize', updateDimensions);
            if (resizeObserver && rendererNode.current) resizeObserver.unobserve(rendererNode.current);
        };
    }, []);
}
const containerStyle = {
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0
};
/* eslint-disable @typescript-eslint/ban-ts-comment */ const viewChanged = (prevViewport, eventTransform)=>prevViewport.x !== eventTransform.x || prevViewport.y !== eventTransform.y || prevViewport.zoom !== eventTransform.k;
const eventToFlowTransform = (eventTransform)=>({
        x: eventTransform.x,
        y: eventTransform.y,
        zoom: eventTransform.k
    });
const isWrappedWithClass = (event, className)=>event.target.closest(`.${className}`);
const isRightClickPan = (panOnDrag, usedButton)=>usedButton === 2 && Array.isArray(panOnDrag) && panOnDrag.includes(2);
const wheelDelta = (event)=>{
    const factor = event.ctrlKey && isMacOs() ? 10 : 1;
    return -event.deltaY * (event.deltaMode === 1 ? 0.05 : event.deltaMode ? 1 : 0.002) * factor;
};
const selector$a = (s)=>({
        d3Zoom: s.d3Zoom,
        d3Selection: s.d3Selection,
        d3ZoomHandler: s.d3ZoomHandler,
        userSelectionActive: s.userSelectionActive
    });
const ZoomPane = ({ onMove, onMoveStart, onMoveEnd, onPaneContextMenu, zoomOnScroll = true, zoomOnPinch = true, panOnScroll = false, panOnScrollSpeed = 0.5, panOnScrollMode = PanOnScrollMode.Free, zoomOnDoubleClick = true, elementsSelectable, panOnDrag = true, defaultViewport, translateExtent, minZoom, maxZoom, zoomActivationKeyCode, preventScrolling = true, children, noWheelClassName, noPanClassName })=>{
    const timerId = (0, _react.useRef)();
    const store = useStoreApi();
    const isZoomingOrPanning = (0, _react.useRef)(false);
    const zoomedWithRightMouseButton = (0, _react.useRef)(false);
    const zoomPane = (0, _react.useRef)(null);
    const prevTransform = (0, _react.useRef)({
        x: 0,
        y: 0,
        zoom: 0
    });
    const { d3Zoom, d3Selection, d3ZoomHandler, userSelectionActive } = useStore(selector$a, (0, _shallow.shallow));
    const zoomActivationKeyPressed = useKeyPress(zoomActivationKeyCode);
    const mouseButton = (0, _react.useRef)(0);
    const isPanScrolling = (0, _react.useRef)(false);
    const panScrollTimeout = (0, _react.useRef)();
    useResizeHandler(zoomPane);
    (0, _react.useEffect)(()=>{
        if (zoomPane.current) {
            const bbox = zoomPane.current.getBoundingClientRect();
            const d3ZoomInstance = (0, _d3Zoom.zoom)().scaleExtent([
                minZoom,
                maxZoom
            ]).translateExtent(translateExtent);
            const selection = (0, _d3Selection.select)(zoomPane.current).call(d3ZoomInstance);
            const updatedTransform = (0, _d3Zoom.zoomIdentity).translate(defaultViewport.x, defaultViewport.y).scale(clamp(defaultViewport.zoom, minZoom, maxZoom));
            const extent = [
                [
                    0,
                    0
                ],
                [
                    bbox.width,
                    bbox.height
                ]
            ];
            const constrainedTransform = d3ZoomInstance.constrain()(updatedTransform, extent, translateExtent);
            d3ZoomInstance.transform(selection, constrainedTransform);
            d3ZoomInstance.wheelDelta(wheelDelta);
            store.setState({
                d3Zoom: d3ZoomInstance,
                d3Selection: selection,
                d3ZoomHandler: selection.on('wheel.zoom'),
                // we need to pass transform because zoom handler is not registered when we set the initial transform
                transform: [
                    constrainedTransform.x,
                    constrainedTransform.y,
                    constrainedTransform.k
                ],
                domNode: zoomPane.current.closest('.react-flow')
            });
        }
    }, []);
    (0, _react.useEffect)(()=>{
        if (d3Selection && d3Zoom) {
            if (panOnScroll && !zoomActivationKeyPressed && !userSelectionActive) d3Selection.on('wheel.zoom', (event)=>{
                if (isWrappedWithClass(event, noWheelClassName)) return false;
                event.preventDefault();
                event.stopImmediatePropagation();
                const currentZoom = d3Selection.property('__zoom').k || 1;
                // macos and win set ctrlKey=true for pinch gesture on a trackpad
                if (event.ctrlKey && zoomOnPinch) {
                    const point = (0, _d3Selection.pointer)(event);
                    const pinchDelta = wheelDelta(event);
                    const zoom = currentZoom * Math.pow(2, pinchDelta);
                    // @ts-ignore
                    d3Zoom.scaleTo(d3Selection, zoom, point, event);
                    return;
                }
                // increase scroll speed in firefox
                // firefox: deltaMode === 1; chrome: deltaMode === 0
                const deltaNormalize = event.deltaMode === 1 ? 20 : 1;
                let deltaX = panOnScrollMode === PanOnScrollMode.Vertical ? 0 : event.deltaX * deltaNormalize;
                let deltaY = panOnScrollMode === PanOnScrollMode.Horizontal ? 0 : event.deltaY * deltaNormalize;
                // this enables vertical scrolling with shift + scroll on windows
                if (!isMacOs() && event.shiftKey && panOnScrollMode !== PanOnScrollMode.Vertical) {
                    deltaX = event.deltaY * deltaNormalize;
                    deltaY = 0;
                }
                d3Zoom.translateBy(d3Selection, -(deltaX / currentZoom) * panOnScrollSpeed, -(deltaY / currentZoom) * panOnScrollSpeed, // @ts-ignore
                {
                    internal: true
                });
                const nextViewport = eventToFlowTransform(d3Selection.property('__zoom'));
                const { onViewportChangeStart, onViewportChange, onViewportChangeEnd } = store.getState();
                clearTimeout(panScrollTimeout.current);
                // for pan on scroll we need to handle the event calls on our own
                // we can't use the start, zoom and end events from d3-zoom
                // because start and move gets called on every scroll event and not once at the beginning
                if (!isPanScrolling.current) {
                    isPanScrolling.current = true;
                    onMoveStart?.(event, nextViewport);
                    onViewportChangeStart?.(nextViewport);
                }
                if (isPanScrolling.current) {
                    onMove?.(event, nextViewport);
                    onViewportChange?.(nextViewport);
                    panScrollTimeout.current = setTimeout(()=>{
                        onMoveEnd?.(event, nextViewport);
                        onViewportChangeEnd?.(nextViewport);
                        isPanScrolling.current = false;
                    }, 150);
                }
            }, {
                passive: false
            });
            else if (typeof d3ZoomHandler !== 'undefined') d3Selection.on('wheel.zoom', function(event, d) {
                // we still want to enable pinch zooming even if preventScrolling is set to false
                const invalidEvent = !preventScrolling && event.type === 'wheel' && !event.ctrlKey;
                if (invalidEvent || isWrappedWithClass(event, noWheelClassName)) return null;
                event.preventDefault();
                d3ZoomHandler.call(this, event, d);
            }, {
                passive: false
            });
        }
    }, [
        userSelectionActive,
        panOnScroll,
        panOnScrollMode,
        d3Selection,
        d3Zoom,
        d3ZoomHandler,
        zoomActivationKeyPressed,
        zoomOnPinch,
        preventScrolling,
        noWheelClassName,
        onMoveStart,
        onMove,
        onMoveEnd
    ]);
    (0, _react.useEffect)(()=>{
        if (d3Zoom) d3Zoom.on('start', (event)=>{
            if (!event.sourceEvent || event.sourceEvent.internal) return null;
            // we need to remember it here, because it's always 0 in the "zoom" event
            mouseButton.current = event.sourceEvent?.button;
            const { onViewportChangeStart } = store.getState();
            const flowTransform = eventToFlowTransform(event.transform);
            isZoomingOrPanning.current = true;
            prevTransform.current = flowTransform;
            if (event.sourceEvent?.type === 'mousedown') store.setState({
                paneDragging: true
            });
            onViewportChangeStart?.(flowTransform);
            onMoveStart?.(event.sourceEvent, flowTransform);
        });
    }, [
        d3Zoom,
        onMoveStart
    ]);
    (0, _react.useEffect)(()=>{
        if (d3Zoom) {
            if (userSelectionActive && !isZoomingOrPanning.current) d3Zoom.on('zoom', null);
            else if (!userSelectionActive) d3Zoom.on('zoom', (event)=>{
                const { onViewportChange } = store.getState();
                store.setState({
                    transform: [
                        event.transform.x,
                        event.transform.y,
                        event.transform.k
                    ]
                });
                zoomedWithRightMouseButton.current = !!(onPaneContextMenu && isRightClickPan(panOnDrag, mouseButton.current ?? 0));
                if ((onMove || onViewportChange) && !event.sourceEvent?.internal) {
                    const flowTransform = eventToFlowTransform(event.transform);
                    onViewportChange?.(flowTransform);
                    onMove?.(event.sourceEvent, flowTransform);
                }
            });
        }
    }, [
        userSelectionActive,
        d3Zoom,
        onMove,
        panOnDrag,
        onPaneContextMenu
    ]);
    (0, _react.useEffect)(()=>{
        if (d3Zoom) d3Zoom.on('end', (event)=>{
            if (!event.sourceEvent || event.sourceEvent.internal) return null;
            const { onViewportChangeEnd } = store.getState();
            isZoomingOrPanning.current = false;
            store.setState({
                paneDragging: false
            });
            if (onPaneContextMenu && isRightClickPan(panOnDrag, mouseButton.current ?? 0) && !zoomedWithRightMouseButton.current) onPaneContextMenu(event.sourceEvent);
            zoomedWithRightMouseButton.current = false;
            if ((onMoveEnd || onViewportChangeEnd) && viewChanged(prevTransform.current, event.transform)) {
                const flowTransform = eventToFlowTransform(event.transform);
                prevTransform.current = flowTransform;
                clearTimeout(timerId.current);
                timerId.current = setTimeout(()=>{
                    onViewportChangeEnd?.(flowTransform);
                    onMoveEnd?.(event.sourceEvent, flowTransform);
                }, panOnScroll ? 150 : 0);
            }
        });
    }, [
        d3Zoom,
        panOnScroll,
        panOnDrag,
        onMoveEnd,
        onPaneContextMenu
    ]);
    (0, _react.useEffect)(()=>{
        if (d3Zoom) d3Zoom.filter((event)=>{
            const zoomScroll = zoomActivationKeyPressed || zoomOnScroll;
            const pinchZoom = zoomOnPinch && event.ctrlKey;
            if ((panOnDrag === true || Array.isArray(panOnDrag) && panOnDrag.includes(1)) && event.button === 1 && event.type === 'mousedown' && (isWrappedWithClass(event, 'react-flow__node') || isWrappedWithClass(event, 'react-flow__edge'))) return true;
            // if all interactions are disabled, we prevent all zoom events
            if (!panOnDrag && !zoomScroll && !panOnScroll && !zoomOnDoubleClick && !zoomOnPinch) return false;
            // during a selection we prevent all other interactions
            if (userSelectionActive) return false;
            // if zoom on double click is disabled, we prevent the double click event
            if (!zoomOnDoubleClick && event.type === 'dblclick') return false;
            // if the target element is inside an element with the nowheel class, we prevent zooming
            if (isWrappedWithClass(event, noWheelClassName) && event.type === 'wheel') return false;
            // if the target element is inside an element with the nopan class, we prevent panning
            if (isWrappedWithClass(event, noPanClassName) && (event.type !== 'wheel' || panOnScroll && event.type === 'wheel' && !zoomActivationKeyPressed)) return false;
            if (!zoomOnPinch && event.ctrlKey && event.type === 'wheel') return false;
            // when there is no scroll handling enabled, we prevent all wheel events
            if (!zoomScroll && !panOnScroll && !pinchZoom && event.type === 'wheel') return false;
            // if the pane is not movable, we prevent dragging it with mousestart or touchstart
            if (!panOnDrag && (event.type === 'mousedown' || event.type === 'touchstart')) return false;
            // if the pane is only movable using allowed clicks
            if (Array.isArray(panOnDrag) && !panOnDrag.includes(event.button) && event.type === 'mousedown') return false;
            // We only allow right clicks if pan on drag is set to right click
            const buttonAllowed = Array.isArray(panOnDrag) && panOnDrag.includes(event.button) || !event.button || event.button <= 1;
            // default filter for d3-zoom
            return (!event.ctrlKey || event.type === 'wheel') && buttonAllowed;
        });
    }, [
        userSelectionActive,
        d3Zoom,
        zoomOnScroll,
        zoomOnPinch,
        panOnScroll,
        zoomOnDoubleClick,
        panOnDrag,
        elementsSelectable,
        zoomActivationKeyPressed
    ]);
    return (0, _reactDefault.default).createElement("div", {
        className: "react-flow__renderer",
        ref: zoomPane,
        style: containerStyle
    }, children);
};
const selector$9 = (s)=>({
        userSelectionActive: s.userSelectionActive,
        userSelectionRect: s.userSelectionRect
    });
function UserSelection() {
    const { userSelectionActive, userSelectionRect } = useStore(selector$9, (0, _shallow.shallow));
    const isActive = userSelectionActive && userSelectionRect;
    if (!isActive) return null;
    return (0, _reactDefault.default).createElement("div", {
        className: "react-flow__selection react-flow__container",
        style: {
            width: userSelectionRect.width,
            height: userSelectionRect.height,
            transform: `translate(${userSelectionRect.x}px, ${userSelectionRect.y}px)`
        }
    });
}
function handleParentExpand(res, updateItem) {
    const parentId = updateItem.parentNode || updateItem.parentId;
    const parent = res.find((e)=>e.id === parentId);
    if (parent) {
        const extendWidth = updateItem.position.x + updateItem.width - parent.width;
        const extendHeight = updateItem.position.y + updateItem.height - parent.height;
        if (extendWidth > 0 || extendHeight > 0 || updateItem.position.x < 0 || updateItem.position.y < 0) {
            parent.style = {
                ...parent.style
            };
            parent.style.width = parent.style.width ?? parent.width;
            parent.style.height = parent.style.height ?? parent.height;
            if (extendWidth > 0) parent.style.width += extendWidth;
            if (extendHeight > 0) parent.style.height += extendHeight;
            if (updateItem.position.x < 0) {
                const xDiff = Math.abs(updateItem.position.x);
                parent.position.x = parent.position.x - xDiff;
                parent.style.width += xDiff;
                updateItem.position.x = 0;
            }
            if (updateItem.position.y < 0) {
                const yDiff = Math.abs(updateItem.position.y);
                parent.position.y = parent.position.y - yDiff;
                parent.style.height += yDiff;
                updateItem.position.y = 0;
            }
            parent.width = parent.style.width;
            parent.height = parent.style.height;
        }
    }
}
function applyChanges(changes, elements) {
    // we need this hack to handle the setNodes and setEdges function of the useReactFlow hook for controlled flows
    if (changes.some((c)=>c.type === 'reset')) return changes.filter((c)=>c.type === 'reset').map((c)=>c.item);
    const initElements = changes.filter((c)=>c.type === 'add').map((c)=>c.item);
    return elements.reduce((res, item)=>{
        const currentChanges = changes.filter((c)=>c.id === item.id);
        if (currentChanges.length === 0) {
            res.push(item);
            return res;
        }
        const updateItem = {
            ...item
        };
        for (const currentChange of currentChanges)if (currentChange) switch(currentChange.type){
            case 'select':
                updateItem.selected = currentChange.selected;
                break;
            case 'position':
                if (typeof currentChange.position !== 'undefined') updateItem.position = currentChange.position;
                if (typeof currentChange.positionAbsolute !== 'undefined') updateItem.positionAbsolute = currentChange.positionAbsolute;
                if (typeof currentChange.dragging !== 'undefined') updateItem.dragging = currentChange.dragging;
                if (updateItem.expandParent) handleParentExpand(res, updateItem);
                break;
            case 'dimensions':
                if (typeof currentChange.dimensions !== 'undefined') {
                    updateItem.width = currentChange.dimensions.width;
                    updateItem.height = currentChange.dimensions.height;
                }
                if (typeof currentChange.updateStyle !== 'undefined') updateItem.style = {
                    ...updateItem.style || {},
                    ...currentChange.dimensions
                };
                if (typeof currentChange.resizing === 'boolean') updateItem.resizing = currentChange.resizing;
                if (updateItem.expandParent) handleParentExpand(res, updateItem);
                break;
            case 'remove':
                return res;
        }
        res.push(updateItem);
        return res;
    }, initElements);
}
function applyNodeChanges(changes, nodes) {
    return applyChanges(changes, nodes);
}
function applyEdgeChanges(changes, edges) {
    return applyChanges(changes, edges);
}
const createSelectionChange = (id, selected)=>({
        id,
        type: 'select',
        selected
    });
function getSelectionChanges(items, selectedIds) {
    return items.reduce((res, item)=>{
        const willBeSelected = selectedIds.includes(item.id);
        if (!item.selected && willBeSelected) {
            item.selected = true;
            res.push(createSelectionChange(item.id, true));
        } else if (item.selected && !willBeSelected) {
            item.selected = false;
            res.push(createSelectionChange(item.id, false));
        }
        return res;
    }, []);
}
/**
 * The user selection rectangle gets displayed when a user drags the mouse while pressing shift
 */ const wrapHandler = (handler, containerRef)=>{
    return (event)=>{
        if (event.target !== containerRef.current) return;
        handler?.(event);
    };
};
const selector$8 = (s)=>({
        userSelectionActive: s.userSelectionActive,
        elementsSelectable: s.elementsSelectable,
        dragging: s.paneDragging
    });
const Pane = (0, _react.memo)(({ isSelecting, selectionMode = SelectionMode.Full, panOnDrag, onSelectionStart, onSelectionEnd, onPaneClick, onPaneContextMenu, onPaneScroll, onPaneMouseEnter, onPaneMouseMove, onPaneMouseLeave, children })=>{
    const container = (0, _react.useRef)(null);
    const store = useStoreApi();
    const prevSelectedNodesCount = (0, _react.useRef)(0);
    const prevSelectedEdgesCount = (0, _react.useRef)(0);
    const containerBounds = (0, _react.useRef)();
    const { userSelectionActive, elementsSelectable, dragging } = useStore(selector$8, (0, _shallow.shallow));
    const resetUserSelection = ()=>{
        store.setState({
            userSelectionActive: false,
            userSelectionRect: null
        });
        prevSelectedNodesCount.current = 0;
        prevSelectedEdgesCount.current = 0;
    };
    const onClick = (event)=>{
        onPaneClick?.(event);
        store.getState().resetSelectedElements();
        store.setState({
            nodesSelectionActive: false
        });
    };
    const onContextMenu = (event)=>{
        if (Array.isArray(panOnDrag) && panOnDrag?.includes(2)) {
            event.preventDefault();
            return;
        }
        onPaneContextMenu?.(event);
    };
    const onWheel = onPaneScroll ? (event)=>onPaneScroll(event) : undefined;
    const onMouseDown = (event)=>{
        const { resetSelectedElements, domNode } = store.getState();
        containerBounds.current = domNode?.getBoundingClientRect();
        if (!elementsSelectable || !isSelecting || event.button !== 0 || event.target !== container.current || !containerBounds.current) return;
        const { x, y } = getEventPosition(event, containerBounds.current);
        resetSelectedElements();
        store.setState({
            userSelectionRect: {
                width: 0,
                height: 0,
                startX: x,
                startY: y,
                x,
                y
            }
        });
        onSelectionStart?.(event);
    };
    const onMouseMove = (event)=>{
        const { userSelectionRect, nodeInternals, edges, transform, onNodesChange, onEdgesChange, nodeOrigin, getNodes } = store.getState();
        if (!isSelecting || !containerBounds.current || !userSelectionRect) return;
        store.setState({
            userSelectionActive: true,
            nodesSelectionActive: false
        });
        const mousePos = getEventPosition(event, containerBounds.current);
        const startX = userSelectionRect.startX ?? 0;
        const startY = userSelectionRect.startY ?? 0;
        const nextUserSelectRect = {
            ...userSelectionRect,
            x: mousePos.x < startX ? mousePos.x : startX,
            y: mousePos.y < startY ? mousePos.y : startY,
            width: Math.abs(mousePos.x - startX),
            height: Math.abs(mousePos.y - startY)
        };
        const nodes = getNodes();
        const selectedNodes = getNodesInside(nodeInternals, nextUserSelectRect, transform, selectionMode === SelectionMode.Partial, true, nodeOrigin);
        const selectedEdgeIds = getConnectedEdges(selectedNodes, edges).map((e)=>e.id);
        const selectedNodeIds = selectedNodes.map((n)=>n.id);
        if (prevSelectedNodesCount.current !== selectedNodeIds.length) {
            prevSelectedNodesCount.current = selectedNodeIds.length;
            const changes = getSelectionChanges(nodes, selectedNodeIds);
            if (changes.length) onNodesChange?.(changes);
        }
        if (prevSelectedEdgesCount.current !== selectedEdgeIds.length) {
            prevSelectedEdgesCount.current = selectedEdgeIds.length;
            const changes = getSelectionChanges(edges, selectedEdgeIds);
            if (changes.length) onEdgesChange?.(changes);
        }
        store.setState({
            userSelectionRect: nextUserSelectRect
        });
    };
    const onMouseUp = (event)=>{
        if (event.button !== 0) return;
        const { userSelectionRect } = store.getState();
        // We only want to trigger click functions when in selection mode if
        // the user did not move the mouse.
        if (!userSelectionActive && userSelectionRect && event.target === container.current) onClick?.(event);
        store.setState({
            nodesSelectionActive: prevSelectedNodesCount.current > 0
        });
        resetUserSelection();
        onSelectionEnd?.(event);
    };
    const onMouseLeave = (event)=>{
        if (userSelectionActive) {
            store.setState({
                nodesSelectionActive: prevSelectedNodesCount.current > 0
            });
            onSelectionEnd?.(event);
        }
        resetUserSelection();
    };
    const hasActiveSelection = elementsSelectable && (isSelecting || userSelectionActive);
    return (0, _reactDefault.default).createElement("div", {
        className: (0, _classcatDefault.default)([
            'react-flow__pane',
            {
                dragging,
                selection: isSelecting
            }
        ]),
        onClick: hasActiveSelection ? undefined : wrapHandler(onClick, container),
        onContextMenu: wrapHandler(onContextMenu, container),
        onWheel: wrapHandler(onWheel, container),
        onMouseEnter: hasActiveSelection ? undefined : onPaneMouseEnter,
        onMouseDown: hasActiveSelection ? onMouseDown : undefined,
        onMouseMove: hasActiveSelection ? onMouseMove : onPaneMouseMove,
        onMouseUp: hasActiveSelection ? onMouseUp : undefined,
        onMouseLeave: hasActiveSelection ? onMouseLeave : onPaneMouseLeave,
        ref: container,
        style: containerStyle
    }, children, (0, _reactDefault.default).createElement(UserSelection, null));
});
Pane.displayName = 'Pane';
function isParentSelected(node, nodeInternals) {
    const parentId = node.parentNode || node.parentId;
    if (!parentId) return false;
    const parentNode = nodeInternals.get(parentId);
    if (!parentNode) return false;
    if (parentNode.selected) return true;
    return isParentSelected(parentNode, nodeInternals);
}
function hasSelector(target, selector, nodeRef) {
    let current = target;
    do {
        if (current?.matches(selector)) return true;
        if (current === nodeRef.current) return false;
        current = current.parentElement;
    }while (current);
    return false;
}
// looks for all selected nodes and created a NodeDragItem for each of them
function getDragItems(nodeInternals, nodesDraggable, mousePos, nodeId) {
    return Array.from(nodeInternals.values()).filter((n)=>(n.selected || n.id === nodeId) && (!n.parentNode || n.parentId || !isParentSelected(n, nodeInternals)) && (n.draggable || nodesDraggable && typeof n.draggable === 'undefined')).map((n)=>({
            id: n.id,
            position: n.position || {
                x: 0,
                y: 0
            },
            positionAbsolute: n.positionAbsolute || {
                x: 0,
                y: 0
            },
            distance: {
                x: mousePos.x - (n.positionAbsolute?.x ?? 0),
                y: mousePos.y - (n.positionAbsolute?.y ?? 0)
            },
            delta: {
                x: 0,
                y: 0
            },
            extent: n.extent,
            parentNode: n.parentNode || n.parentId,
            parentId: n.parentNode || n.parentId,
            width: n.width,
            height: n.height,
            expandParent: n.expandParent
        }));
}
function clampNodeExtent(node, extent) {
    if (!extent || extent === 'parent') return extent;
    return [
        extent[0],
        [
            extent[1][0] - (node.width || 0),
            extent[1][1] - (node.height || 0)
        ]
    ];
}
function calcNextPosition(node, nextPosition, nodeInternals, nodeExtent, nodeOrigin = [
    0,
    0
], onError) {
    const clampedNodeExtent = clampNodeExtent(node, node.extent || nodeExtent);
    let currentExtent = clampedNodeExtent;
    const parentId = node.parentNode || node.parentId;
    if (node.extent === 'parent' && !node.expandParent) {
        if (parentId && node.width && node.height) {
            const parent = nodeInternals.get(parentId);
            const { x: parentX, y: parentY } = getNodePositionWithOrigin(parent, nodeOrigin).positionAbsolute;
            currentExtent = parent && isNumeric(parentX) && isNumeric(parentY) && isNumeric(parent.width) && isNumeric(parent.height) ? [
                [
                    parentX + node.width * nodeOrigin[0],
                    parentY + node.height * nodeOrigin[1]
                ],
                [
                    parentX + parent.width - node.width + node.width * nodeOrigin[0],
                    parentY + parent.height - node.height + node.height * nodeOrigin[1]
                ]
            ] : currentExtent;
        } else {
            onError?.('005', errorMessages['error005']());
            currentExtent = clampedNodeExtent;
        }
    } else if (node.extent && parentId && node.extent !== 'parent') {
        const parent = nodeInternals.get(parentId);
        const { x: parentX, y: parentY } = getNodePositionWithOrigin(parent, nodeOrigin).positionAbsolute;
        currentExtent = [
            [
                node.extent[0][0] + parentX,
                node.extent[0][1] + parentY
            ],
            [
                node.extent[1][0] + parentX,
                node.extent[1][1] + parentY
            ]
        ];
    }
    let parentPosition = {
        x: 0,
        y: 0
    };
    if (parentId) {
        const parentNode = nodeInternals.get(parentId);
        parentPosition = getNodePositionWithOrigin(parentNode, nodeOrigin).positionAbsolute;
    }
    const positionAbsolute = currentExtent && currentExtent !== 'parent' ? clampPosition(nextPosition, currentExtent) : nextPosition;
    return {
        position: {
            x: positionAbsolute.x - parentPosition.x,
            y: positionAbsolute.y - parentPosition.y
        },
        positionAbsolute
    };
}
// returns two params:
// 1. the dragged node (or the first of the list, if we are dragging a node selection)
// 2. array of selected nodes (for multi selections)
function getEventHandlerParams({ nodeId, dragItems, nodeInternals }) {
    const extentedDragItems = dragItems.map((n)=>{
        const node = nodeInternals.get(n.id);
        return {
            ...node,
            position: n.position,
            positionAbsolute: n.positionAbsolute
        };
    });
    return [
        nodeId ? extentedDragItems.find((n)=>n.id === nodeId) : extentedDragItems[0],
        extentedDragItems
    ];
}
const getHandleBounds = (selector, nodeElement, zoom, nodeOrigin)=>{
    const handles = nodeElement.querySelectorAll(selector);
    if (!handles || !handles.length) return null;
    const handlesArray = Array.from(handles);
    const nodeBounds = nodeElement.getBoundingClientRect();
    const nodeOffset = {
        x: nodeBounds.width * nodeOrigin[0],
        y: nodeBounds.height * nodeOrigin[1]
    };
    return handlesArray.map((handle)=>{
        const handleBounds = handle.getBoundingClientRect();
        return {
            id: handle.getAttribute('data-handleid'),
            position: handle.getAttribute('data-handlepos'),
            x: (handleBounds.left - nodeBounds.left - nodeOffset.x) / zoom,
            y: (handleBounds.top - nodeBounds.top - nodeOffset.y) / zoom,
            ...getDimensions(handle)
        };
    });
};
function getMouseHandler(id, getState, handler) {
    return handler === undefined ? handler : (event)=>{
        const node = getState().nodeInternals.get(id);
        if (node) handler(event, {
            ...node
        });
    };
}
// this handler is called by
// 1. the click handler when node is not draggable or selectNodesOnDrag = false
// or
// 2. the on drag start handler when node is draggable and selectNodesOnDrag = true
function handleNodeClick({ id, store, unselect = false, nodeRef }) {
    const { addSelectedNodes, unselectNodesAndEdges, multiSelectionActive, nodeInternals, onError } = store.getState();
    const node = nodeInternals.get(id);
    if (!node) {
        onError?.('012', errorMessages['error012'](id));
        return;
    }
    store.setState({
        nodesSelectionActive: false
    });
    if (!node.selected) addSelectedNodes([
        id
    ]);
    else if (unselect || node.selected && multiSelectionActive) {
        unselectNodesAndEdges({
            nodes: [
                node
            ],
            edges: []
        });
        requestAnimationFrame(()=>nodeRef?.current?.blur());
    }
}
function useGetPointerPosition() {
    const store = useStoreApi();
    // returns the pointer position projected to the RF coordinate system
    const getPointerPosition = (0, _react.useCallback)(({ sourceEvent })=>{
        const { transform, snapGrid, snapToGrid } = store.getState();
        const x = sourceEvent.touches ? sourceEvent.touches[0].clientX : sourceEvent.clientX;
        const y = sourceEvent.touches ? sourceEvent.touches[0].clientY : sourceEvent.clientY;
        const pointerPos = {
            x: (x - transform[0]) / transform[2],
            y: (y - transform[1]) / transform[2]
        };
        // we need the snapped position in order to be able to skip unnecessary drag events
        return {
            xSnapped: snapToGrid ? snapGrid[0] * Math.round(pointerPos.x / snapGrid[0]) : pointerPos.x,
            ySnapped: snapToGrid ? snapGrid[1] * Math.round(pointerPos.y / snapGrid[1]) : pointerPos.y,
            ...pointerPos
        };
    }, []);
    return getPointerPosition;
}
function wrapSelectionDragFunc(selectionFunc) {
    return (event, _, nodes)=>selectionFunc?.(event, nodes);
}
function useDrag({ nodeRef, disabled = false, noDragClassName, handleSelector, nodeId, isSelectable, selectNodesOnDrag }) {
    const store = useStoreApi();
    const [dragging, setDragging] = (0, _react.useState)(false);
    const dragItems = (0, _react.useRef)([]);
    const lastPos = (0, _react.useRef)({
        x: null,
        y: null
    });
    const autoPanId = (0, _react.useRef)(0);
    const containerBounds = (0, _react.useRef)(null);
    const mousePosition = (0, _react.useRef)({
        x: 0,
        y: 0
    });
    const dragEvent = (0, _react.useRef)(null);
    const autoPanStarted = (0, _react.useRef)(false);
    const dragStarted = (0, _react.useRef)(false);
    const abortDrag = (0, _react.useRef)(false);
    const getPointerPosition = useGetPointerPosition();
    (0, _react.useEffect)(()=>{
        if (nodeRef?.current) {
            const selection = (0, _d3Selection.select)(nodeRef.current);
            const updateNodes = ({ x, y })=>{
                const { nodeInternals, onNodeDrag, onSelectionDrag, updateNodePositions, nodeExtent, snapGrid, snapToGrid, nodeOrigin, onError } = store.getState();
                lastPos.current = {
                    x,
                    y
                };
                let hasChange = false;
                let nodesBox = {
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 0
                };
                if (dragItems.current.length > 1 && nodeExtent) {
                    const rect = getNodesBounds(dragItems.current, nodeOrigin);
                    nodesBox = rectToBox(rect);
                }
                dragItems.current = dragItems.current.map((n)=>{
                    const nextPosition = {
                        x: x - n.distance.x,
                        y: y - n.distance.y
                    };
                    if (snapToGrid) {
                        nextPosition.x = snapGrid[0] * Math.round(nextPosition.x / snapGrid[0]);
                        nextPosition.y = snapGrid[1] * Math.round(nextPosition.y / snapGrid[1]);
                    }
                    // if there is selection with multiple nodes and a node extent is set, we need to adjust the node extent for each node
                    // based on its position so that the node stays at it's position relative to the selection.
                    const adjustedNodeExtent = [
                        [
                            nodeExtent[0][0],
                            nodeExtent[0][1]
                        ],
                        [
                            nodeExtent[1][0],
                            nodeExtent[1][1]
                        ]
                    ];
                    if (dragItems.current.length > 1 && nodeExtent && !n.extent) {
                        adjustedNodeExtent[0][0] = n.positionAbsolute.x - nodesBox.x + nodeExtent[0][0];
                        adjustedNodeExtent[1][0] = n.positionAbsolute.x + (n.width ?? 0) - nodesBox.x2 + nodeExtent[1][0];
                        adjustedNodeExtent[0][1] = n.positionAbsolute.y - nodesBox.y + nodeExtent[0][1];
                        adjustedNodeExtent[1][1] = n.positionAbsolute.y + (n.height ?? 0) - nodesBox.y2 + nodeExtent[1][1];
                    }
                    const updatedPos = calcNextPosition(n, nextPosition, nodeInternals, adjustedNodeExtent, nodeOrigin, onError);
                    // we want to make sure that we only fire a change event when there is a change
                    hasChange = hasChange || n.position.x !== updatedPos.position.x || n.position.y !== updatedPos.position.y;
                    n.position = updatedPos.position;
                    n.positionAbsolute = updatedPos.positionAbsolute;
                    return n;
                });
                if (!hasChange) return;
                updateNodePositions(dragItems.current, true, true);
                setDragging(true);
                const onDrag = nodeId ? onNodeDrag : wrapSelectionDragFunc(onSelectionDrag);
                if (onDrag && dragEvent.current) {
                    const [currentNode, nodes] = getEventHandlerParams({
                        nodeId,
                        dragItems: dragItems.current,
                        nodeInternals
                    });
                    onDrag(dragEvent.current, currentNode, nodes);
                }
            };
            const autoPan = ()=>{
                if (!containerBounds.current) return;
                const [xMovement, yMovement] = calcAutoPan(mousePosition.current, containerBounds.current);
                if (xMovement !== 0 || yMovement !== 0) {
                    const { transform, panBy } = store.getState();
                    lastPos.current.x = (lastPos.current.x ?? 0) - xMovement / transform[2];
                    lastPos.current.y = (lastPos.current.y ?? 0) - yMovement / transform[2];
                    if (panBy({
                        x: xMovement,
                        y: yMovement
                    })) updateNodes(lastPos.current);
                }
                autoPanId.current = requestAnimationFrame(autoPan);
            };
            const startDrag = (event)=>{
                const { nodeInternals, multiSelectionActive, nodesDraggable, unselectNodesAndEdges, onNodeDragStart, onSelectionDragStart } = store.getState();
                dragStarted.current = true;
                const onStart = nodeId ? onNodeDragStart : wrapSelectionDragFunc(onSelectionDragStart);
                if ((!selectNodesOnDrag || !isSelectable) && !multiSelectionActive && nodeId) {
                    if (!nodeInternals.get(nodeId)?.selected) // we need to reset selected nodes when selectNodesOnDrag=false
                    unselectNodesAndEdges();
                }
                if (nodeId && isSelectable && selectNodesOnDrag) handleNodeClick({
                    id: nodeId,
                    store,
                    nodeRef: nodeRef
                });
                const pointerPos = getPointerPosition(event);
                lastPos.current = pointerPos;
                dragItems.current = getDragItems(nodeInternals, nodesDraggable, pointerPos, nodeId);
                if (onStart && dragItems.current) {
                    const [currentNode, nodes] = getEventHandlerParams({
                        nodeId,
                        dragItems: dragItems.current,
                        nodeInternals
                    });
                    onStart(event.sourceEvent, currentNode, nodes);
                }
            };
            if (disabled) selection.on('.drag', null);
            else {
                const dragHandler = (0, _d3Drag.drag)().on('start', (event)=>{
                    const { domNode, nodeDragThreshold } = store.getState();
                    if (nodeDragThreshold === 0) startDrag(event);
                    abortDrag.current = false;
                    const pointerPos = getPointerPosition(event);
                    lastPos.current = pointerPos;
                    containerBounds.current = domNode?.getBoundingClientRect() || null;
                    mousePosition.current = getEventPosition(event.sourceEvent, containerBounds.current);
                }).on('drag', (event)=>{
                    const pointerPos = getPointerPosition(event);
                    const { autoPanOnNodeDrag, nodeDragThreshold } = store.getState();
                    if (event.sourceEvent.type === 'touchmove' && event.sourceEvent.touches.length > 1) abortDrag.current = true;
                    if (abortDrag.current) return;
                    if (!autoPanStarted.current && dragStarted.current && autoPanOnNodeDrag) {
                        autoPanStarted.current = true;
                        autoPan();
                    }
                    if (!dragStarted.current) {
                        const x = pointerPos.xSnapped - (lastPos?.current?.x ?? 0);
                        const y = pointerPos.ySnapped - (lastPos?.current?.y ?? 0);
                        const distance = Math.sqrt(x * x + y * y);
                        if (distance > nodeDragThreshold) startDrag(event);
                    }
                    // skip events without movement
                    if ((lastPos.current.x !== pointerPos.xSnapped || lastPos.current.y !== pointerPos.ySnapped) && dragItems.current && dragStarted.current) {
                        dragEvent.current = event.sourceEvent;
                        mousePosition.current = getEventPosition(event.sourceEvent, containerBounds.current);
                        updateNodes(pointerPos);
                    }
                }).on('end', (event)=>{
                    if (!dragStarted.current || abortDrag.current) return;
                    setDragging(false);
                    autoPanStarted.current = false;
                    dragStarted.current = false;
                    cancelAnimationFrame(autoPanId.current);
                    if (dragItems.current) {
                        const { updateNodePositions, nodeInternals, onNodeDragStop, onSelectionDragStop } = store.getState();
                        const onStop = nodeId ? onNodeDragStop : wrapSelectionDragFunc(onSelectionDragStop);
                        updateNodePositions(dragItems.current, false, false);
                        if (onStop) {
                            const [currentNode, nodes] = getEventHandlerParams({
                                nodeId,
                                dragItems: dragItems.current,
                                nodeInternals
                            });
                            onStop(event.sourceEvent, currentNode, nodes);
                        }
                    }
                }).filter((event)=>{
                    const target = event.target;
                    const isDraggable = !event.button && (!noDragClassName || !hasSelector(target, `.${noDragClassName}`, nodeRef)) && (!handleSelector || hasSelector(target, handleSelector, nodeRef));
                    return isDraggable;
                });
                selection.call(dragHandler);
                return ()=>{
                    selection.on('.drag', null);
                };
            }
        }
    }, [
        nodeRef,
        disabled,
        noDragClassName,
        handleSelector,
        isSelectable,
        store,
        nodeId,
        selectNodesOnDrag,
        getPointerPosition
    ]);
    return dragging;
}
function useUpdateNodePositions() {
    const store = useStoreApi();
    const updatePositions = (0, _react.useCallback)((params)=>{
        const { nodeInternals, nodeExtent, updateNodePositions, getNodes, snapToGrid, snapGrid, onError, nodesDraggable } = store.getState();
        const selectedNodes = getNodes().filter((n)=>n.selected && (n.draggable || nodesDraggable && typeof n.draggable === 'undefined'));
        // by default a node moves 5px on each key press, or 20px if shift is pressed
        // if snap grid is enabled, we use that for the velocity.
        const xVelo = snapToGrid ? snapGrid[0] : 5;
        const yVelo = snapToGrid ? snapGrid[1] : 5;
        const factor = params.isShiftPressed ? 4 : 1;
        const positionDiffX = params.x * xVelo * factor;
        const positionDiffY = params.y * yVelo * factor;
        const nodeUpdates = selectedNodes.map((n)=>{
            if (n.positionAbsolute) {
                const nextPosition = {
                    x: n.positionAbsolute.x + positionDiffX,
                    y: n.positionAbsolute.y + positionDiffY
                };
                if (snapToGrid) {
                    nextPosition.x = snapGrid[0] * Math.round(nextPosition.x / snapGrid[0]);
                    nextPosition.y = snapGrid[1] * Math.round(nextPosition.y / snapGrid[1]);
                }
                const { positionAbsolute, position } = calcNextPosition(n, nextPosition, nodeInternals, nodeExtent, undefined, onError);
                n.position = position;
                n.positionAbsolute = positionAbsolute;
            }
            return n;
        });
        updateNodePositions(nodeUpdates, true, false);
    }, []);
    return updatePositions;
}
const arrowKeyDiffs = {
    ArrowUp: {
        x: 0,
        y: -1
    },
    ArrowDown: {
        x: 0,
        y: 1
    },
    ArrowLeft: {
        x: -1,
        y: 0
    },
    ArrowRight: {
        x: 1,
        y: 0
    }
};
var wrapNode = (NodeComponent)=>{
    const NodeWrapper = ({ id, type, data, xPos, yPos, xPosOrigin, yPosOrigin, selected, onClick, onMouseEnter, onMouseMove, onMouseLeave, onContextMenu, onDoubleClick, style, className, isDraggable, isSelectable, isConnectable, isFocusable, selectNodesOnDrag, sourcePosition, targetPosition, hidden, resizeObserver, dragHandle, zIndex, isParent, noDragClassName, noPanClassName, initialized, disableKeyboardA11y, ariaLabel, rfId, hasHandleBounds })=>{
        const store = useStoreApi();
        const nodeRef = (0, _react.useRef)(null);
        const prevNodeRef = (0, _react.useRef)(null);
        const prevSourcePosition = (0, _react.useRef)(sourcePosition);
        const prevTargetPosition = (0, _react.useRef)(targetPosition);
        const prevType = (0, _react.useRef)(type);
        const hasPointerEvents = isSelectable || isDraggable || onClick || onMouseEnter || onMouseMove || onMouseLeave;
        const updatePositions = useUpdateNodePositions();
        const onMouseEnterHandler = getMouseHandler(id, store.getState, onMouseEnter);
        const onMouseMoveHandler = getMouseHandler(id, store.getState, onMouseMove);
        const onMouseLeaveHandler = getMouseHandler(id, store.getState, onMouseLeave);
        const onContextMenuHandler = getMouseHandler(id, store.getState, onContextMenu);
        const onDoubleClickHandler = getMouseHandler(id, store.getState, onDoubleClick);
        const onSelectNodeHandler = (event)=>{
            const { nodeDragThreshold } = store.getState();
            if (isSelectable && (!selectNodesOnDrag || !isDraggable || nodeDragThreshold > 0)) // this handler gets called within the drag start event when selectNodesOnDrag=true
            handleNodeClick({
                id,
                store,
                nodeRef
            });
            if (onClick) {
                const node = store.getState().nodeInternals.get(id);
                if (node) onClick(event, {
                    ...node
                });
            }
        };
        const onKeyDown = (event)=>{
            if (isInputDOMNode(event)) return;
            if (disableKeyboardA11y) return;
            if (elementSelectionKeys.includes(event.key) && isSelectable) {
                const unselect = event.key === 'Escape';
                handleNodeClick({
                    id,
                    store,
                    unselect,
                    nodeRef
                });
            } else if (isDraggable && selected && Object.prototype.hasOwnProperty.call(arrowKeyDiffs, event.key)) {
                store.setState({
                    ariaLiveMessage: `Moved selected node ${event.key.replace('Arrow', '').toLowerCase()}. New position, x: ${~~xPos}, y: ${~~yPos}`
                });
                updatePositions({
                    x: arrowKeyDiffs[event.key].x,
                    y: arrowKeyDiffs[event.key].y,
                    isShiftPressed: event.shiftKey
                });
            }
        };
        (0, _react.useEffect)(()=>{
            return ()=>{
                if (prevNodeRef.current) {
                    resizeObserver?.unobserve(prevNodeRef.current);
                    prevNodeRef.current = null;
                }
            };
        }, []);
        (0, _react.useEffect)(()=>{
            if (nodeRef.current && !hidden) {
                const currNode = nodeRef.current;
                if (!initialized || !hasHandleBounds || prevNodeRef.current !== currNode) {
                    // At this point we always want to make sure that the node gets re-measured / re-initialized.
                    // We need to unobserve it first in case it is still observed
                    if (prevNodeRef.current) resizeObserver?.unobserve(prevNodeRef.current);
                    resizeObserver?.observe(currNode);
                    prevNodeRef.current = currNode;
                }
            }
        }, [
            hidden,
            initialized,
            hasHandleBounds
        ]);
        (0, _react.useEffect)(()=>{
            // when the user programmatically changes the source or handle position, we re-initialize the node
            const typeChanged = prevType.current !== type;
            const sourcePosChanged = prevSourcePosition.current !== sourcePosition;
            const targetPosChanged = prevTargetPosition.current !== targetPosition;
            if (nodeRef.current && (typeChanged || sourcePosChanged || targetPosChanged)) {
                if (typeChanged) prevType.current = type;
                if (sourcePosChanged) prevSourcePosition.current = sourcePosition;
                if (targetPosChanged) prevTargetPosition.current = targetPosition;
                store.getState().updateNodeDimensions([
                    {
                        id,
                        nodeElement: nodeRef.current,
                        forceUpdate: true
                    }
                ]);
            }
        }, [
            id,
            type,
            sourcePosition,
            targetPosition
        ]);
        const dragging = useDrag({
            nodeRef,
            disabled: hidden || !isDraggable,
            noDragClassName,
            handleSelector: dragHandle,
            nodeId: id,
            isSelectable,
            selectNodesOnDrag
        });
        if (hidden) return null;
        return (0, _reactDefault.default).createElement("div", {
            className: (0, _classcatDefault.default)([
                'react-flow__node',
                `react-flow__node-${type}`,
                {
                    // this is overwritable by passing `nopan` as a class name
                    [noPanClassName]: isDraggable
                },
                className,
                {
                    selected,
                    selectable: isSelectable,
                    parent: isParent,
                    dragging
                }
            ]),
            ref: nodeRef,
            style: {
                zIndex,
                transform: `translate(${xPosOrigin}px,${yPosOrigin}px)`,
                pointerEvents: hasPointerEvents ? 'all' : 'none',
                visibility: initialized ? 'visible' : 'hidden',
                ...style
            },
            "data-id": id,
            "data-testid": `rf__node-${id}`,
            onMouseEnter: onMouseEnterHandler,
            onMouseMove: onMouseMoveHandler,
            onMouseLeave: onMouseLeaveHandler,
            onContextMenu: onContextMenuHandler,
            onClick: onSelectNodeHandler,
            onDoubleClick: onDoubleClickHandler,
            onKeyDown: isFocusable ? onKeyDown : undefined,
            tabIndex: isFocusable ? 0 : undefined,
            role: isFocusable ? 'button' : undefined,
            "aria-describedby": disableKeyboardA11y ? undefined : `${ARIA_NODE_DESC_KEY}-${rfId}`,
            "aria-label": ariaLabel
        }, (0, _reactDefault.default).createElement(Provider, {
            value: id
        }, (0, _reactDefault.default).createElement(NodeComponent, {
            id: id,
            data: data,
            type: type,
            xPos: xPos,
            yPos: yPos,
            selected: selected,
            isConnectable: isConnectable,
            sourcePosition: sourcePosition,
            targetPosition: targetPosition,
            dragging: dragging,
            dragHandle: dragHandle,
            zIndex: zIndex
        })));
    };
    NodeWrapper.displayName = 'NodeWrapper';
    return (0, _react.memo)(NodeWrapper);
};
/**
 * The nodes selection rectangle gets displayed when a user
 * made a selection with on or several nodes
 */ const selector$7 = (s)=>{
    const selectedNodes = s.getNodes().filter((n)=>n.selected);
    return {
        ...getNodesBounds(selectedNodes, s.nodeOrigin),
        transformString: `translate(${s.transform[0]}px,${s.transform[1]}px) scale(${s.transform[2]})`,
        userSelectionActive: s.userSelectionActive
    };
};
function NodesSelection({ onSelectionContextMenu, noPanClassName, disableKeyboardA11y }) {
    const store = useStoreApi();
    const { width, height, x: left, y: top, transformString, userSelectionActive } = useStore(selector$7, (0, _shallow.shallow));
    const updatePositions = useUpdateNodePositions();
    const nodeRef = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        if (!disableKeyboardA11y) nodeRef.current?.focus({
            preventScroll: true
        });
    }, [
        disableKeyboardA11y
    ]);
    useDrag({
        nodeRef
    });
    if (userSelectionActive || !width || !height) return null;
    const onContextMenu = onSelectionContextMenu ? (event)=>{
        const selectedNodes = store.getState().getNodes().filter((n)=>n.selected);
        onSelectionContextMenu(event, selectedNodes);
    } : undefined;
    const onKeyDown = (event)=>{
        if (Object.prototype.hasOwnProperty.call(arrowKeyDiffs, event.key)) updatePositions({
            x: arrowKeyDiffs[event.key].x,
            y: arrowKeyDiffs[event.key].y,
            isShiftPressed: event.shiftKey
        });
    };
    return (0, _reactDefault.default).createElement("div", {
        className: (0, _classcatDefault.default)([
            'react-flow__nodesselection',
            'react-flow__container',
            noPanClassName
        ]),
        style: {
            transform: transformString
        }
    }, (0, _reactDefault.default).createElement("div", {
        ref: nodeRef,
        className: "react-flow__nodesselection-rect",
        onContextMenu: onContextMenu,
        tabIndex: disableKeyboardA11y ? undefined : -1,
        onKeyDown: disableKeyboardA11y ? undefined : onKeyDown,
        style: {
            width,
            height,
            top,
            left
        }
    }));
}
var NodesSelection$1 = (0, _react.memo)(NodesSelection);
const selector$6 = (s)=>s.nodesSelectionActive;
const FlowRenderer = ({ children, onPaneClick, onPaneMouseEnter, onPaneMouseMove, onPaneMouseLeave, onPaneContextMenu, onPaneScroll, deleteKeyCode, onMove, onMoveStart, onMoveEnd, selectionKeyCode, selectionOnDrag, selectionMode, onSelectionStart, onSelectionEnd, multiSelectionKeyCode, panActivationKeyCode, zoomActivationKeyCode, elementsSelectable, zoomOnScroll, zoomOnPinch, panOnScroll: _panOnScroll, panOnScrollSpeed, panOnScrollMode, zoomOnDoubleClick, panOnDrag: _panOnDrag, defaultViewport, translateExtent, minZoom, maxZoom, preventScrolling, onSelectionContextMenu, noWheelClassName, noPanClassName, disableKeyboardA11y })=>{
    const nodesSelectionActive = useStore(selector$6);
    const selectionKeyPressed = useKeyPress(selectionKeyCode);
    const panActivationKeyPressed = useKeyPress(panActivationKeyCode);
    const panOnDrag = panActivationKeyPressed || _panOnDrag;
    const panOnScroll = panActivationKeyPressed || _panOnScroll;
    const isSelecting = selectionKeyPressed || selectionOnDrag && panOnDrag !== true;
    useGlobalKeyHandler({
        deleteKeyCode,
        multiSelectionKeyCode
    });
    return (0, _reactDefault.default).createElement(ZoomPane, {
        onMove: onMove,
        onMoveStart: onMoveStart,
        onMoveEnd: onMoveEnd,
        onPaneContextMenu: onPaneContextMenu,
        elementsSelectable: elementsSelectable,
        zoomOnScroll: zoomOnScroll,
        zoomOnPinch: zoomOnPinch,
        panOnScroll: panOnScroll,
        panOnScrollSpeed: panOnScrollSpeed,
        panOnScrollMode: panOnScrollMode,
        zoomOnDoubleClick: zoomOnDoubleClick,
        panOnDrag: !selectionKeyPressed && panOnDrag,
        defaultViewport: defaultViewport,
        translateExtent: translateExtent,
        minZoom: minZoom,
        maxZoom: maxZoom,
        zoomActivationKeyCode: zoomActivationKeyCode,
        preventScrolling: preventScrolling,
        noWheelClassName: noWheelClassName,
        noPanClassName: noPanClassName
    }, (0, _reactDefault.default).createElement(Pane, {
        onSelectionStart: onSelectionStart,
        onSelectionEnd: onSelectionEnd,
        onPaneClick: onPaneClick,
        onPaneMouseEnter: onPaneMouseEnter,
        onPaneMouseMove: onPaneMouseMove,
        onPaneMouseLeave: onPaneMouseLeave,
        onPaneContextMenu: onPaneContextMenu,
        onPaneScroll: onPaneScroll,
        panOnDrag: panOnDrag,
        isSelecting: !!isSelecting,
        selectionMode: selectionMode
    }, children, nodesSelectionActive && (0, _reactDefault.default).createElement(NodesSelection$1, {
        onSelectionContextMenu: onSelectionContextMenu,
        noPanClassName: noPanClassName,
        disableKeyboardA11y: disableKeyboardA11y
    })));
};
FlowRenderer.displayName = 'FlowRenderer';
var FlowRenderer$1 = (0, _react.memo)(FlowRenderer);
function useVisibleNodes(onlyRenderVisible) {
    const nodes = useStore((0, _react.useCallback)((s)=>onlyRenderVisible ? getNodesInside(s.nodeInternals, {
            x: 0,
            y: 0,
            width: s.width,
            height: s.height
        }, s.transform, true) : s.getNodes(), [
        onlyRenderVisible
    ]));
    return nodes;
}
function createNodeTypes(nodeTypes) {
    const standardTypes = {
        input: wrapNode(nodeTypes.input || InputNode$1),
        default: wrapNode(nodeTypes.default || DefaultNode$1),
        output: wrapNode(nodeTypes.output || OutputNode$1),
        group: wrapNode(nodeTypes.group || GroupNode)
    };
    const wrappedTypes = {};
    const specialTypes = Object.keys(nodeTypes).filter((k)=>![
            'input',
            'default',
            'output',
            'group'
        ].includes(k)).reduce((res, key)=>{
        res[key] = wrapNode(nodeTypes[key] || DefaultNode$1);
        return res;
    }, wrappedTypes);
    return {
        ...standardTypes,
        ...specialTypes
    };
}
const getPositionWithOrigin = ({ x, y, width, height, origin })=>{
    if (!width || !height) return {
        x,
        y
    };
    if (origin[0] < 0 || origin[1] < 0 || origin[0] > 1 || origin[1] > 1) return {
        x,
        y
    };
    return {
        x: x - width * origin[0],
        y: y - height * origin[1]
    };
};
const selector$5 = (s)=>({
        nodesDraggable: s.nodesDraggable,
        nodesConnectable: s.nodesConnectable,
        nodesFocusable: s.nodesFocusable,
        elementsSelectable: s.elementsSelectable,
        updateNodeDimensions: s.updateNodeDimensions,
        onError: s.onError
    });
const NodeRenderer = (props)=>{
    const { nodesDraggable, nodesConnectable, nodesFocusable, elementsSelectable, updateNodeDimensions, onError } = useStore(selector$5, (0, _shallow.shallow));
    const nodes = useVisibleNodes(props.onlyRenderVisibleElements);
    const resizeObserverRef = (0, _react.useRef)();
    const resizeObserver = (0, _react.useMemo)(()=>{
        if (typeof ResizeObserver === 'undefined') return null;
        const observer = new ResizeObserver((entries)=>{
            const updates = entries.map((entry)=>({
                    id: entry.target.getAttribute('data-id'),
                    nodeElement: entry.target,
                    forceUpdate: true
                }));
            updateNodeDimensions(updates);
        });
        resizeObserverRef.current = observer;
        return observer;
    }, []);
    (0, _react.useEffect)(()=>{
        return ()=>{
            resizeObserverRef?.current?.disconnect();
        };
    }, []);
    return (0, _reactDefault.default).createElement("div", {
        className: "react-flow__nodes",
        style: containerStyle
    }, nodes.map((node)=>{
        let nodeType = node.type || 'default';
        if (!props.nodeTypes[nodeType]) {
            onError?.('003', errorMessages['error003'](nodeType));
            nodeType = 'default';
        }
        const NodeComponent = props.nodeTypes[nodeType] || props.nodeTypes.default;
        const isDraggable = !!(node.draggable || nodesDraggable && typeof node.draggable === 'undefined');
        const isSelectable = !!(node.selectable || elementsSelectable && typeof node.selectable === 'undefined');
        const isConnectable = !!(node.connectable || nodesConnectable && typeof node.connectable === 'undefined');
        const isFocusable = !!(node.focusable || nodesFocusable && typeof node.focusable === 'undefined');
        const clampedPosition = props.nodeExtent ? clampPosition(node.positionAbsolute, props.nodeExtent) : node.positionAbsolute;
        const posX = clampedPosition?.x ?? 0;
        const posY = clampedPosition?.y ?? 0;
        const posOrigin = getPositionWithOrigin({
            x: posX,
            y: posY,
            width: node.width ?? 0,
            height: node.height ?? 0,
            origin: props.nodeOrigin
        });
        return (0, _reactDefault.default).createElement(NodeComponent, {
            key: node.id,
            id: node.id,
            className: node.className,
            style: node.style,
            type: nodeType,
            data: node.data,
            sourcePosition: node.sourcePosition || Position.Bottom,
            targetPosition: node.targetPosition || Position.Top,
            hidden: node.hidden,
            xPos: posX,
            yPos: posY,
            xPosOrigin: posOrigin.x,
            yPosOrigin: posOrigin.y,
            selectNodesOnDrag: props.selectNodesOnDrag,
            onClick: props.onNodeClick,
            onMouseEnter: props.onNodeMouseEnter,
            onMouseMove: props.onNodeMouseMove,
            onMouseLeave: props.onNodeMouseLeave,
            onContextMenu: props.onNodeContextMenu,
            onDoubleClick: props.onNodeDoubleClick,
            selected: !!node.selected,
            isDraggable: isDraggable,
            isSelectable: isSelectable,
            isConnectable: isConnectable,
            isFocusable: isFocusable,
            resizeObserver: resizeObserver,
            dragHandle: node.dragHandle,
            zIndex: node[internalsSymbol]?.z ?? 0,
            isParent: !!node[internalsSymbol]?.isParent,
            noDragClassName: props.noDragClassName,
            noPanClassName: props.noPanClassName,
            initialized: !!node.width && !!node.height,
            rfId: props.rfId,
            disableKeyboardA11y: props.disableKeyboardA11y,
            ariaLabel: node.ariaLabel,
            hasHandleBounds: !!node[internalsSymbol]?.handleBounds
        });
    }));
};
NodeRenderer.displayName = 'NodeRenderer';
var NodeRenderer$1 = (0, _react.memo)(NodeRenderer);
const shiftX = (x, shift, position)=>{
    if (position === Position.Left) return x - shift;
    if (position === Position.Right) return x + shift;
    return x;
};
const shiftY = (y, shift, position)=>{
    if (position === Position.Top) return y - shift;
    if (position === Position.Bottom) return y + shift;
    return y;
};
const EdgeUpdaterClassName = 'react-flow__edgeupdater';
const EdgeAnchor = ({ position, centerX, centerY, radius = 10, onMouseDown, onMouseEnter, onMouseOut, type })=>(0, _reactDefault.default).createElement("circle", {
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter,
        onMouseOut: onMouseOut,
        className: (0, _classcatDefault.default)([
            EdgeUpdaterClassName,
            `${EdgeUpdaterClassName}-${type}`
        ]),
        cx: shiftX(centerX, radius, position),
        cy: shiftY(centerY, radius, position),
        r: radius,
        stroke: "transparent",
        fill: "transparent"
    });
const alwaysValidConnection = ()=>true;
var wrapEdge = (EdgeComponent)=>{
    const EdgeWrapper = ({ id, className, type, data, onClick, onEdgeDoubleClick, selected, animated, label, labelStyle, labelShowBg, labelBgStyle, labelBgPadding, labelBgBorderRadius, style, source, target, sourceX, sourceY, targetX, targetY, sourcePosition, targetPosition, elementsSelectable, hidden, sourceHandleId, targetHandleId, onContextMenu, onMouseEnter, onMouseMove, onMouseLeave, reconnectRadius, onReconnect, onReconnectStart, onReconnectEnd, markerEnd, markerStart, rfId, ariaLabel, isFocusable, isReconnectable, pathOptions, interactionWidth, disableKeyboardA11y })=>{
        const edgeRef = (0, _react.useRef)(null);
        const [updateHover, setUpdateHover] = (0, _react.useState)(false);
        const [updating, setUpdating] = (0, _react.useState)(false);
        const store = useStoreApi();
        const markerStartUrl = (0, _react.useMemo)(()=>`url('#${getMarkerId(markerStart, rfId)}')`, [
            markerStart,
            rfId
        ]);
        const markerEndUrl = (0, _react.useMemo)(()=>`url('#${getMarkerId(markerEnd, rfId)}')`, [
            markerEnd,
            rfId
        ]);
        if (hidden) return null;
        const onEdgeClick = (event)=>{
            const { edges, addSelectedEdges, unselectNodesAndEdges, multiSelectionActive } = store.getState();
            const edge = edges.find((e)=>e.id === id);
            if (!edge) return;
            if (elementsSelectable) {
                store.setState({
                    nodesSelectionActive: false
                });
                if (edge.selected && multiSelectionActive) {
                    unselectNodesAndEdges({
                        nodes: [],
                        edges: [
                            edge
                        ]
                    });
                    edgeRef.current?.blur();
                } else addSelectedEdges([
                    id
                ]);
            }
            if (onClick) onClick(event, edge);
        };
        const onEdgeDoubleClickHandler = getMouseHandler$1(id, store.getState, onEdgeDoubleClick);
        const onEdgeContextMenu = getMouseHandler$1(id, store.getState, onContextMenu);
        const onEdgeMouseEnter = getMouseHandler$1(id, store.getState, onMouseEnter);
        const onEdgeMouseMove = getMouseHandler$1(id, store.getState, onMouseMove);
        const onEdgeMouseLeave = getMouseHandler$1(id, store.getState, onMouseLeave);
        const handleEdgeUpdater = (event, isSourceHandle)=>{
            // avoid triggering edge updater if mouse btn is not left
            if (event.button !== 0) return;
            const { edges, isValidConnection: isValidConnectionStore } = store.getState();
            const nodeId = isSourceHandle ? target : source;
            const handleId = (isSourceHandle ? targetHandleId : sourceHandleId) || null;
            const handleType = isSourceHandle ? 'target' : 'source';
            const isValidConnection = isValidConnectionStore || alwaysValidConnection;
            const isTarget = isSourceHandle;
            const edge = edges.find((e)=>e.id === id);
            setUpdating(true);
            onReconnectStart?.(event, edge, handleType);
            const _onReconnectEnd = (evt)=>{
                setUpdating(false);
                onReconnectEnd?.(evt, edge, handleType);
            };
            const onConnectEdge = (connection)=>onReconnect?.(edge, connection);
            handlePointerDown({
                event,
                handleId,
                nodeId,
                onConnect: onConnectEdge,
                isTarget,
                getState: store.getState,
                setState: store.setState,
                isValidConnection,
                edgeUpdaterType: handleType,
                onReconnectEnd: _onReconnectEnd
            });
        };
        const onEdgeUpdaterSourceMouseDown = (event)=>handleEdgeUpdater(event, true);
        const onEdgeUpdaterTargetMouseDown = (event)=>handleEdgeUpdater(event, false);
        const onEdgeUpdaterMouseEnter = ()=>setUpdateHover(true);
        const onEdgeUpdaterMouseOut = ()=>setUpdateHover(false);
        const inactive = !elementsSelectable && !onClick;
        const onKeyDown = (event)=>{
            if (!disableKeyboardA11y && elementSelectionKeys.includes(event.key) && elementsSelectable) {
                const { unselectNodesAndEdges, addSelectedEdges, edges } = store.getState();
                const unselect = event.key === 'Escape';
                if (unselect) {
                    edgeRef.current?.blur();
                    unselectNodesAndEdges({
                        edges: [
                            edges.find((e)=>e.id === id)
                        ]
                    });
                } else addSelectedEdges([
                    id
                ]);
            }
        };
        return (0, _reactDefault.default).createElement("g", {
            className: (0, _classcatDefault.default)([
                'react-flow__edge',
                `react-flow__edge-${type}`,
                className,
                {
                    selected,
                    animated,
                    inactive,
                    updating: updateHover
                }
            ]),
            onClick: onEdgeClick,
            onDoubleClick: onEdgeDoubleClickHandler,
            onContextMenu: onEdgeContextMenu,
            onMouseEnter: onEdgeMouseEnter,
            onMouseMove: onEdgeMouseMove,
            onMouseLeave: onEdgeMouseLeave,
            onKeyDown: isFocusable ? onKeyDown : undefined,
            tabIndex: isFocusable ? 0 : undefined,
            role: isFocusable ? 'button' : 'img',
            "data-testid": `rf__edge-${id}`,
            "aria-label": ariaLabel === null ? undefined : ariaLabel ? ariaLabel : `Edge from ${source} to ${target}`,
            "aria-describedby": isFocusable ? `${ARIA_EDGE_DESC_KEY}-${rfId}` : undefined,
            ref: edgeRef
        }, !updating && (0, _reactDefault.default).createElement(EdgeComponent, {
            id: id,
            source: source,
            target: target,
            selected: selected,
            animated: animated,
            label: label,
            labelStyle: labelStyle,
            labelShowBg: labelShowBg,
            labelBgStyle: labelBgStyle,
            labelBgPadding: labelBgPadding,
            labelBgBorderRadius: labelBgBorderRadius,
            data: data,
            style: style,
            sourceX: sourceX,
            sourceY: sourceY,
            targetX: targetX,
            targetY: targetY,
            sourcePosition: sourcePosition,
            targetPosition: targetPosition,
            sourceHandleId: sourceHandleId,
            targetHandleId: targetHandleId,
            markerStart: markerStartUrl,
            markerEnd: markerEndUrl,
            pathOptions: pathOptions,
            interactionWidth: interactionWidth
        }), isReconnectable && (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (isReconnectable === 'source' || isReconnectable === true) && (0, _reactDefault.default).createElement(EdgeAnchor, {
            position: sourcePosition,
            centerX: sourceX,
            centerY: sourceY,
            radius: reconnectRadius,
            onMouseDown: onEdgeUpdaterSourceMouseDown,
            onMouseEnter: onEdgeUpdaterMouseEnter,
            onMouseOut: onEdgeUpdaterMouseOut,
            type: "source"
        }), (isReconnectable === 'target' || isReconnectable === true) && (0, _reactDefault.default).createElement(EdgeAnchor, {
            position: targetPosition,
            centerX: targetX,
            centerY: targetY,
            radius: reconnectRadius,
            onMouseDown: onEdgeUpdaterTargetMouseDown,
            onMouseEnter: onEdgeUpdaterMouseEnter,
            onMouseOut: onEdgeUpdaterMouseOut,
            type: "target"
        })));
    };
    EdgeWrapper.displayName = 'EdgeWrapper';
    return (0, _react.memo)(EdgeWrapper);
};
function createEdgeTypes(edgeTypes) {
    const standardTypes = {
        default: wrapEdge(edgeTypes.default || BezierEdge),
        straight: wrapEdge(edgeTypes.bezier || StraightEdge),
        step: wrapEdge(edgeTypes.step || StepEdge),
        smoothstep: wrapEdge(edgeTypes.step || SmoothStepEdge),
        simplebezier: wrapEdge(edgeTypes.simplebezier || SimpleBezierEdge)
    };
    const wrappedTypes = {};
    const specialTypes = Object.keys(edgeTypes).filter((k)=>![
            'default',
            'bezier'
        ].includes(k)).reduce((res, key)=>{
        res[key] = wrapEdge(edgeTypes[key] || BezierEdge);
        return res;
    }, wrappedTypes);
    return {
        ...standardTypes,
        ...specialTypes
    };
}
function getHandlePosition(position, nodeRect, handle = null) {
    const x = (handle?.x || 0) + nodeRect.x;
    const y = (handle?.y || 0) + nodeRect.y;
    const width = handle?.width || nodeRect.width;
    const height = handle?.height || nodeRect.height;
    switch(position){
        case Position.Top:
            return {
                x: x + width / 2,
                y
            };
        case Position.Right:
            return {
                x: x + width,
                y: y + height / 2
            };
        case Position.Bottom:
            return {
                x: x + width / 2,
                y: y + height
            };
        case Position.Left:
            return {
                x,
                y: y + height / 2
            };
    }
}
function getHandle(bounds, handleId) {
    if (!bounds) return null;
    if (bounds.length === 1 || !handleId) return bounds[0];
    else if (handleId) return bounds.find((d)=>d.id === handleId) || null;
    return null;
}
const getEdgePositions = (sourceNodeRect, sourceHandle, sourcePosition, targetNodeRect, targetHandle, targetPosition)=>{
    const sourceHandlePos = getHandlePosition(sourcePosition, sourceNodeRect, sourceHandle);
    const targetHandlePos = getHandlePosition(targetPosition, targetNodeRect, targetHandle);
    return {
        sourceX: sourceHandlePos.x,
        sourceY: sourceHandlePos.y,
        targetX: targetHandlePos.x,
        targetY: targetHandlePos.y
    };
};
function isEdgeVisible({ sourcePos, targetPos, sourceWidth, sourceHeight, targetWidth, targetHeight, width, height, transform }) {
    const edgeBox = {
        x: Math.min(sourcePos.x, targetPos.x),
        y: Math.min(sourcePos.y, targetPos.y),
        x2: Math.max(sourcePos.x + sourceWidth, targetPos.x + targetWidth),
        y2: Math.max(sourcePos.y + sourceHeight, targetPos.y + targetHeight)
    };
    if (edgeBox.x === edgeBox.x2) edgeBox.x2 += 1;
    if (edgeBox.y === edgeBox.y2) edgeBox.y2 += 1;
    const viewBox = rectToBox({
        x: (0 - transform[0]) / transform[2],
        y: (0 - transform[1]) / transform[2],
        width: width / transform[2],
        height: height / transform[2]
    });
    const xOverlap = Math.max(0, Math.min(viewBox.x2, edgeBox.x2) - Math.max(viewBox.x, edgeBox.x));
    const yOverlap = Math.max(0, Math.min(viewBox.y2, edgeBox.y2) - Math.max(viewBox.y, edgeBox.y));
    const overlappingArea = Math.ceil(xOverlap * yOverlap);
    return overlappingArea > 0;
}
function getNodeData(node) {
    const handleBounds = node?.[internalsSymbol]?.handleBounds || null;
    const isValid = handleBounds && node?.width && node?.height && typeof node?.positionAbsolute?.x !== 'undefined' && typeof node?.positionAbsolute?.y !== 'undefined';
    return [
        {
            x: node?.positionAbsolute?.x || 0,
            y: node?.positionAbsolute?.y || 0,
            width: node?.width || 0,
            height: node?.height || 0
        },
        handleBounds,
        !!isValid
    ];
}
const defaultEdgeTree = [
    {
        level: 0,
        isMaxLevel: true,
        edges: []
    }
];
function groupEdgesByZLevel(edges, nodeInternals, elevateEdgesOnSelect = false) {
    let maxLevel = -1;
    const levelLookup = edges.reduce((tree, edge)=>{
        const hasZIndex = isNumeric(edge.zIndex);
        let z = hasZIndex ? edge.zIndex : 0;
        if (elevateEdgesOnSelect) {
            const targetNode = nodeInternals.get(edge.target);
            const sourceNode = nodeInternals.get(edge.source);
            const edgeOrConnectedNodeSelected = edge.selected || targetNode?.selected || sourceNode?.selected;
            const selectedZIndex = Math.max(sourceNode?.[internalsSymbol]?.z || 0, targetNode?.[internalsSymbol]?.z || 0, 1000);
            z = (hasZIndex ? edge.zIndex : 0) + (edgeOrConnectedNodeSelected ? selectedZIndex : 0);
        }
        if (tree[z]) tree[z].push(edge);
        else tree[z] = [
            edge
        ];
        maxLevel = z > maxLevel ? z : maxLevel;
        return tree;
    }, {});
    const edgeTree = Object.entries(levelLookup).map(([key, edges])=>{
        const level = +key;
        return {
            edges,
            level,
            isMaxLevel: level === maxLevel
        };
    });
    if (edgeTree.length === 0) return defaultEdgeTree;
    return edgeTree;
}
function useVisibleEdges(onlyRenderVisible, nodeInternals, elevateEdgesOnSelect) {
    const edges = useStore((0, _react.useCallback)((s)=>{
        if (!onlyRenderVisible) return s.edges;
        return s.edges.filter((e)=>{
            const sourceNode = nodeInternals.get(e.source);
            const targetNode = nodeInternals.get(e.target);
            return sourceNode?.width && sourceNode?.height && targetNode?.width && targetNode?.height && isEdgeVisible({
                sourcePos: sourceNode.positionAbsolute || {
                    x: 0,
                    y: 0
                },
                targetPos: targetNode.positionAbsolute || {
                    x: 0,
                    y: 0
                },
                sourceWidth: sourceNode.width,
                sourceHeight: sourceNode.height,
                targetWidth: targetNode.width,
                targetHeight: targetNode.height,
                width: s.width,
                height: s.height,
                transform: s.transform
            });
        });
    }, [
        onlyRenderVisible,
        nodeInternals
    ]));
    return groupEdgesByZLevel(edges, nodeInternals, elevateEdgesOnSelect);
}
const ArrowSymbol = ({ color = 'none', strokeWidth = 1 })=>{
    return (0, _reactDefault.default).createElement("polyline", {
        style: {
            stroke: color,
            strokeWidth
        },
        strokeLinecap: "round",
        strokeLinejoin: "round",
        fill: "none",
        points: "-5,-4 0,0 -5,4"
    });
};
const ArrowClosedSymbol = ({ color = 'none', strokeWidth = 1 })=>{
    return (0, _reactDefault.default).createElement("polyline", {
        style: {
            stroke: color,
            fill: color,
            strokeWidth
        },
        strokeLinecap: "round",
        strokeLinejoin: "round",
        points: "-5,-4 0,0 -5,4 -5,-4"
    });
};
const MarkerSymbols = {
    [MarkerType.Arrow]: ArrowSymbol,
    [MarkerType.ArrowClosed]: ArrowClosedSymbol
};
function useMarkerSymbol(type) {
    const store = useStoreApi();
    const symbol = (0, _react.useMemo)(()=>{
        const symbolExists = Object.prototype.hasOwnProperty.call(MarkerSymbols, type);
        if (!symbolExists) {
            store.getState().onError?.('009', errorMessages['error009'](type));
            return null;
        }
        return MarkerSymbols[type];
    }, [
        type
    ]);
    return symbol;
}
const Marker = ({ id, type, color, width = 12.5, height = 12.5, markerUnits = 'strokeWidth', strokeWidth, orient = 'auto-start-reverse' })=>{
    const Symbol1 = useMarkerSymbol(type);
    if (!Symbol1) return null;
    return (0, _reactDefault.default).createElement("marker", {
        className: "react-flow__arrowhead",
        id: id,
        markerWidth: `${width}`,
        markerHeight: `${height}`,
        viewBox: "-10 -10 20 20",
        markerUnits: markerUnits,
        orient: orient,
        refX: "0",
        refY: "0"
    }, (0, _reactDefault.default).createElement(Symbol1, {
        color: color,
        strokeWidth: strokeWidth
    }));
};
const markerSelector = ({ defaultColor, rfId })=>(s)=>{
        const ids = [];
        return s.edges.reduce((markers, edge)=>{
            [
                edge.markerStart,
                edge.markerEnd
            ].forEach((marker)=>{
                if (marker && typeof marker === 'object') {
                    const markerId = getMarkerId(marker, rfId);
                    if (!ids.includes(markerId)) {
                        markers.push({
                            id: markerId,
                            color: marker.color || defaultColor,
                            ...marker
                        });
                        ids.push(markerId);
                    }
                }
            });
            return markers;
        }, []).sort((a, b)=>a.id.localeCompare(b.id));
    };
// when you have multiple flows on a page and you hide the first one, the other ones have no markers anymore
// when they do have markers with the same ids. To prevent this the user can pass a unique id to the react flow wrapper
// that we can then use for creating our unique marker ids
const MarkerDefinitions = ({ defaultColor, rfId })=>{
    const markers = useStore((0, _react.useCallback)(markerSelector({
        defaultColor,
        rfId
    }), [
        defaultColor,
        rfId
    ]), // the id includes all marker options, so we just need to look at that part of the marker
    (a, b)=>!(a.length !== b.length || a.some((m, i)=>m.id !== b[i].id)));
    return (0, _reactDefault.default).createElement("defs", null, markers.map((marker)=>(0, _reactDefault.default).createElement(Marker, {
            id: marker.id,
            key: marker.id,
            type: marker.type,
            color: marker.color,
            width: marker.width,
            height: marker.height,
            markerUnits: marker.markerUnits,
            strokeWidth: marker.strokeWidth,
            orient: marker.orient
        })));
};
MarkerDefinitions.displayName = 'MarkerDefinitions';
var MarkerDefinitions$1 = (0, _react.memo)(MarkerDefinitions);
const selector$4 = (s)=>({
        nodesConnectable: s.nodesConnectable,
        edgesFocusable: s.edgesFocusable,
        edgesUpdatable: s.edgesUpdatable,
        elementsSelectable: s.elementsSelectable,
        width: s.width,
        height: s.height,
        connectionMode: s.connectionMode,
        nodeInternals: s.nodeInternals,
        onError: s.onError
    });
const EdgeRenderer = ({ defaultMarkerColor, onlyRenderVisibleElements, elevateEdgesOnSelect, rfId, edgeTypes, noPanClassName, onEdgeContextMenu, onEdgeMouseEnter, onEdgeMouseMove, onEdgeMouseLeave, onEdgeClick, onEdgeDoubleClick, onReconnect, onReconnectStart, onReconnectEnd, reconnectRadius, children, disableKeyboardA11y })=>{
    const { edgesFocusable, edgesUpdatable, elementsSelectable, width, height, connectionMode, nodeInternals, onError } = useStore(selector$4, (0, _shallow.shallow));
    const edgeTree = useVisibleEdges(onlyRenderVisibleElements, nodeInternals, elevateEdgesOnSelect);
    if (!width) return null;
    return (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, edgeTree.map(({ level, edges, isMaxLevel })=>(0, _reactDefault.default).createElement("svg", {
            key: level,
            style: {
                zIndex: level
            },
            width: width,
            height: height,
            className: "react-flow__edges react-flow__container"
        }, isMaxLevel && (0, _reactDefault.default).createElement(MarkerDefinitions$1, {
            defaultColor: defaultMarkerColor,
            rfId: rfId
        }), (0, _reactDefault.default).createElement("g", null, edges.map((edge)=>{
            const [sourceNodeRect, sourceHandleBounds, sourceIsValid] = getNodeData(nodeInternals.get(edge.source));
            const [targetNodeRect, targetHandleBounds, targetIsValid] = getNodeData(nodeInternals.get(edge.target));
            if (!sourceIsValid || !targetIsValid) return null;
            let edgeType = edge.type || 'default';
            if (!edgeTypes[edgeType]) {
                onError?.('011', errorMessages['error011'](edgeType));
                edgeType = 'default';
            }
            const EdgeComponent = edgeTypes[edgeType] || edgeTypes.default;
            // when connection type is loose we can define all handles as sources and connect source -> source
            const targetNodeHandles = connectionMode === ConnectionMode.Strict ? targetHandleBounds.target : (targetHandleBounds.target ?? []).concat(targetHandleBounds.source ?? []);
            const sourceHandle = getHandle(sourceHandleBounds.source, edge.sourceHandle);
            const targetHandle = getHandle(targetNodeHandles, edge.targetHandle);
            const sourcePosition = sourceHandle?.position || Position.Bottom;
            const targetPosition = targetHandle?.position || Position.Top;
            const isFocusable = !!(edge.focusable || edgesFocusable && typeof edge.focusable === 'undefined');
            const edgeReconnectable = edge.reconnectable || edge.updatable;
            const isReconnectable = typeof onReconnect !== 'undefined' && (edgeReconnectable || edgesUpdatable && typeof edgeReconnectable === 'undefined');
            if (!sourceHandle || !targetHandle) {
                onError?.('008', errorMessages['error008'](sourceHandle, edge));
                return null;
            }
            const { sourceX, sourceY, targetX, targetY } = getEdgePositions(sourceNodeRect, sourceHandle, sourcePosition, targetNodeRect, targetHandle, targetPosition);
            return (0, _reactDefault.default).createElement(EdgeComponent, {
                key: edge.id,
                id: edge.id,
                className: (0, _classcatDefault.default)([
                    edge.className,
                    noPanClassName
                ]),
                type: edgeType,
                data: edge.data,
                selected: !!edge.selected,
                animated: !!edge.animated,
                hidden: !!edge.hidden,
                label: edge.label,
                labelStyle: edge.labelStyle,
                labelShowBg: edge.labelShowBg,
                labelBgStyle: edge.labelBgStyle,
                labelBgPadding: edge.labelBgPadding,
                labelBgBorderRadius: edge.labelBgBorderRadius,
                style: edge.style,
                source: edge.source,
                target: edge.target,
                sourceHandleId: edge.sourceHandle,
                targetHandleId: edge.targetHandle,
                markerEnd: edge.markerEnd,
                markerStart: edge.markerStart,
                sourceX: sourceX,
                sourceY: sourceY,
                targetX: targetX,
                targetY: targetY,
                sourcePosition: sourcePosition,
                targetPosition: targetPosition,
                elementsSelectable: elementsSelectable,
                onContextMenu: onEdgeContextMenu,
                onMouseEnter: onEdgeMouseEnter,
                onMouseMove: onEdgeMouseMove,
                onMouseLeave: onEdgeMouseLeave,
                onClick: onEdgeClick,
                onEdgeDoubleClick: onEdgeDoubleClick,
                onReconnect: onReconnect,
                onReconnectStart: onReconnectStart,
                onReconnectEnd: onReconnectEnd,
                reconnectRadius: reconnectRadius,
                rfId: rfId,
                ariaLabel: edge.ariaLabel,
                isFocusable: isFocusable,
                isReconnectable: isReconnectable,
                pathOptions: 'pathOptions' in edge ? edge.pathOptions : undefined,
                interactionWidth: edge.interactionWidth,
                disableKeyboardA11y: disableKeyboardA11y
            });
        })))), children);
};
EdgeRenderer.displayName = 'EdgeRenderer';
var EdgeRenderer$1 = (0, _react.memo)(EdgeRenderer);
const selector$3 = (s)=>`translate(${s.transform[0]}px,${s.transform[1]}px) scale(${s.transform[2]})`;
function Viewport({ children }) {
    const transform = useStore(selector$3);
    return (0, _reactDefault.default).createElement("div", {
        className: "react-flow__viewport react-flow__container",
        style: {
            transform
        }
    }, children);
}
function useOnInitHandler(onInit) {
    const rfInstance = useReactFlow();
    const isInitialized = (0, _react.useRef)(false);
    (0, _react.useEffect)(()=>{
        if (!isInitialized.current && rfInstance.viewportInitialized && onInit) {
            setTimeout(()=>onInit(rfInstance), 1);
            isInitialized.current = true;
        }
    }, [
        onInit,
        rfInstance.viewportInitialized
    ]);
}
const oppositePosition = {
    [Position.Left]: Position.Right,
    [Position.Right]: Position.Left,
    [Position.Top]: Position.Bottom,
    [Position.Bottom]: Position.Top
};
const ConnectionLine = ({ nodeId, handleType, style, type = ConnectionLineType.Bezier, CustomComponent, connectionStatus })=>{
    const { fromNode, handleId, toX, toY, connectionMode } = useStore((0, _react.useCallback)((s)=>({
            fromNode: s.nodeInternals.get(nodeId),
            handleId: s.connectionHandleId,
            toX: (s.connectionPosition.x - s.transform[0]) / s.transform[2],
            toY: (s.connectionPosition.y - s.transform[1]) / s.transform[2],
            connectionMode: s.connectionMode
        }), [
        nodeId
    ]), (0, _shallow.shallow));
    const fromHandleBounds = fromNode?.[internalsSymbol]?.handleBounds;
    let handleBounds = fromHandleBounds?.[handleType];
    if (connectionMode === ConnectionMode.Loose) handleBounds = handleBounds ? handleBounds : fromHandleBounds?.[handleType === 'source' ? 'target' : 'source'];
    if (!fromNode || !handleBounds) return null;
    const fromHandle = handleId ? handleBounds.find((d)=>d.id === handleId) : handleBounds[0];
    const fromHandleX = fromHandle ? fromHandle.x + fromHandle.width / 2 : (fromNode.width ?? 0) / 2;
    const fromHandleY = fromHandle ? fromHandle.y + fromHandle.height / 2 : fromNode.height ?? 0;
    const fromX = (fromNode.positionAbsolute?.x ?? 0) + fromHandleX;
    const fromY = (fromNode.positionAbsolute?.y ?? 0) + fromHandleY;
    const fromPosition = fromHandle?.position;
    const toPosition = fromPosition ? oppositePosition[fromPosition] : null;
    if (!fromPosition || !toPosition) return null;
    if (CustomComponent) return (0, _reactDefault.default).createElement(CustomComponent, {
        connectionLineType: type,
        connectionLineStyle: style,
        fromNode: fromNode,
        fromHandle: fromHandle,
        fromX: fromX,
        fromY: fromY,
        toX: toX,
        toY: toY,
        fromPosition: fromPosition,
        toPosition: toPosition,
        connectionStatus: connectionStatus
    });
    let dAttr = '';
    const pathParams = {
        sourceX: fromX,
        sourceY: fromY,
        sourcePosition: fromPosition,
        targetX: toX,
        targetY: toY,
        targetPosition: toPosition
    };
    if (type === ConnectionLineType.Bezier) // we assume the destination position is opposite to the source position
    [dAttr] = getBezierPath(pathParams);
    else if (type === ConnectionLineType.Step) [dAttr] = getSmoothStepPath({
        ...pathParams,
        borderRadius: 0
    });
    else if (type === ConnectionLineType.SmoothStep) [dAttr] = getSmoothStepPath(pathParams);
    else if (type === ConnectionLineType.SimpleBezier) [dAttr] = getSimpleBezierPath(pathParams);
    else dAttr = `M${fromX},${fromY} ${toX},${toY}`;
    return (0, _reactDefault.default).createElement("path", {
        d: dAttr,
        fill: "none",
        className: "react-flow__connection-path",
        style: style
    });
};
ConnectionLine.displayName = 'ConnectionLine';
const selector$2 = (s)=>({
        nodeId: s.connectionNodeId,
        handleType: s.connectionHandleType,
        nodesConnectable: s.nodesConnectable,
        connectionStatus: s.connectionStatus,
        width: s.width,
        height: s.height
    });
function ConnectionLineWrapper({ containerStyle, style, type, component }) {
    const { nodeId, handleType, nodesConnectable, width, height, connectionStatus } = useStore(selector$2, (0, _shallow.shallow));
    const isValid = !!(nodeId && handleType && width && nodesConnectable);
    if (!isValid) return null;
    return (0, _reactDefault.default).createElement("svg", {
        style: containerStyle,
        width: width,
        height: height,
        className: "react-flow__edges react-flow__connectionline react-flow__container"
    }, (0, _reactDefault.default).createElement("g", {
        className: (0, _classcatDefault.default)([
            'react-flow__connection',
            connectionStatus
        ])
    }, (0, _reactDefault.default).createElement(ConnectionLine, {
        nodeId: nodeId,
        handleType: handleType,
        style: style,
        type: type,
        CustomComponent: component,
        connectionStatus: connectionStatus
    })));
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function useNodeOrEdgeTypes(nodeOrEdgeTypes, createTypes) {
    const typesKeysRef = (0, _react.useRef)(null);
    const store = useStoreApi();
    const typesParsed = (0, _react.useMemo)(()=>{
        return createTypes(nodeOrEdgeTypes);
    }, [
        nodeOrEdgeTypes
    ]);
    return typesParsed;
}
const GraphView = ({ nodeTypes, edgeTypes, onMove, onMoveStart, onMoveEnd, onInit, onNodeClick, onEdgeClick, onNodeDoubleClick, onEdgeDoubleClick, onNodeMouseEnter, onNodeMouseMove, onNodeMouseLeave, onNodeContextMenu, onSelectionContextMenu, onSelectionStart, onSelectionEnd, connectionLineType, connectionLineStyle, connectionLineComponent, connectionLineContainerStyle, selectionKeyCode, selectionOnDrag, selectionMode, multiSelectionKeyCode, panActivationKeyCode, zoomActivationKeyCode, deleteKeyCode, onlyRenderVisibleElements, elementsSelectable, selectNodesOnDrag, defaultViewport, translateExtent, minZoom, maxZoom, preventScrolling, defaultMarkerColor, zoomOnScroll, zoomOnPinch, panOnScroll, panOnScrollSpeed, panOnScrollMode, zoomOnDoubleClick, panOnDrag, onPaneClick, onPaneMouseEnter, onPaneMouseMove, onPaneMouseLeave, onPaneScroll, onPaneContextMenu, onEdgeContextMenu, onEdgeMouseEnter, onEdgeMouseMove, onEdgeMouseLeave, onReconnect, onReconnectStart, onReconnectEnd, reconnectRadius, noDragClassName, noWheelClassName, noPanClassName, elevateEdgesOnSelect, disableKeyboardA11y, nodeOrigin, nodeExtent, rfId })=>{
    const nodeTypesWrapped = useNodeOrEdgeTypes(nodeTypes, createNodeTypes);
    const edgeTypesWrapped = useNodeOrEdgeTypes(edgeTypes, createEdgeTypes);
    useOnInitHandler(onInit);
    return (0, _reactDefault.default).createElement(FlowRenderer$1, {
        onPaneClick: onPaneClick,
        onPaneMouseEnter: onPaneMouseEnter,
        onPaneMouseMove: onPaneMouseMove,
        onPaneMouseLeave: onPaneMouseLeave,
        onPaneContextMenu: onPaneContextMenu,
        onPaneScroll: onPaneScroll,
        deleteKeyCode: deleteKeyCode,
        selectionKeyCode: selectionKeyCode,
        selectionOnDrag: selectionOnDrag,
        selectionMode: selectionMode,
        onSelectionStart: onSelectionStart,
        onSelectionEnd: onSelectionEnd,
        multiSelectionKeyCode: multiSelectionKeyCode,
        panActivationKeyCode: panActivationKeyCode,
        zoomActivationKeyCode: zoomActivationKeyCode,
        elementsSelectable: elementsSelectable,
        onMove: onMove,
        onMoveStart: onMoveStart,
        onMoveEnd: onMoveEnd,
        zoomOnScroll: zoomOnScroll,
        zoomOnPinch: zoomOnPinch,
        zoomOnDoubleClick: zoomOnDoubleClick,
        panOnScroll: panOnScroll,
        panOnScrollSpeed: panOnScrollSpeed,
        panOnScrollMode: panOnScrollMode,
        panOnDrag: panOnDrag,
        defaultViewport: defaultViewport,
        translateExtent: translateExtent,
        minZoom: minZoom,
        maxZoom: maxZoom,
        onSelectionContextMenu: onSelectionContextMenu,
        preventScrolling: preventScrolling,
        noDragClassName: noDragClassName,
        noWheelClassName: noWheelClassName,
        noPanClassName: noPanClassName,
        disableKeyboardA11y: disableKeyboardA11y
    }, (0, _reactDefault.default).createElement(Viewport, null, (0, _reactDefault.default).createElement(EdgeRenderer$1, {
        edgeTypes: edgeTypesWrapped,
        onEdgeClick: onEdgeClick,
        onEdgeDoubleClick: onEdgeDoubleClick,
        onlyRenderVisibleElements: onlyRenderVisibleElements,
        onEdgeContextMenu: onEdgeContextMenu,
        onEdgeMouseEnter: onEdgeMouseEnter,
        onEdgeMouseMove: onEdgeMouseMove,
        onEdgeMouseLeave: onEdgeMouseLeave,
        onReconnect: onReconnect,
        onReconnectStart: onReconnectStart,
        onReconnectEnd: onReconnectEnd,
        reconnectRadius: reconnectRadius,
        defaultMarkerColor: defaultMarkerColor,
        noPanClassName: noPanClassName,
        elevateEdgesOnSelect: !!elevateEdgesOnSelect,
        disableKeyboardA11y: disableKeyboardA11y,
        rfId: rfId
    }, (0, _reactDefault.default).createElement(ConnectionLineWrapper, {
        style: connectionLineStyle,
        type: connectionLineType,
        component: connectionLineComponent,
        containerStyle: connectionLineContainerStyle
    })), (0, _reactDefault.default).createElement("div", {
        className: "react-flow__edgelabel-renderer"
    }), (0, _reactDefault.default).createElement(NodeRenderer$1, {
        nodeTypes: nodeTypesWrapped,
        onNodeClick: onNodeClick,
        onNodeDoubleClick: onNodeDoubleClick,
        onNodeMouseEnter: onNodeMouseEnter,
        onNodeMouseMove: onNodeMouseMove,
        onNodeMouseLeave: onNodeMouseLeave,
        onNodeContextMenu: onNodeContextMenu,
        selectNodesOnDrag: selectNodesOnDrag,
        onlyRenderVisibleElements: onlyRenderVisibleElements,
        noPanClassName: noPanClassName,
        noDragClassName: noDragClassName,
        disableKeyboardA11y: disableKeyboardA11y,
        nodeOrigin: nodeOrigin,
        nodeExtent: nodeExtent,
        rfId: rfId
    })));
};
GraphView.displayName = 'GraphView';
var GraphView$1 = (0, _react.memo)(GraphView);
const infiniteExtent = [
    [
        Number.NEGATIVE_INFINITY,
        Number.NEGATIVE_INFINITY
    ],
    [
        Number.POSITIVE_INFINITY,
        Number.POSITIVE_INFINITY
    ]
];
const initialState = {
    rfId: '1',
    width: 0,
    height: 0,
    transform: [
        0,
        0,
        1
    ],
    nodeInternals: new Map(),
    edges: [],
    onNodesChange: null,
    onEdgesChange: null,
    hasDefaultNodes: false,
    hasDefaultEdges: false,
    d3Zoom: null,
    d3Selection: null,
    d3ZoomHandler: undefined,
    minZoom: 0.5,
    maxZoom: 2,
    translateExtent: infiniteExtent,
    nodeExtent: infiniteExtent,
    nodesSelectionActive: false,
    userSelectionActive: false,
    userSelectionRect: null,
    connectionNodeId: null,
    connectionHandleId: null,
    connectionHandleType: 'source',
    connectionPosition: {
        x: 0,
        y: 0
    },
    connectionStatus: null,
    connectionMode: ConnectionMode.Strict,
    domNode: null,
    paneDragging: false,
    noPanClassName: 'nopan',
    nodeOrigin: [
        0,
        0
    ],
    nodeDragThreshold: 0,
    snapGrid: [
        15,
        15
    ],
    snapToGrid: false,
    nodesDraggable: true,
    nodesConnectable: true,
    nodesFocusable: true,
    edgesFocusable: true,
    edgesUpdatable: true,
    elementsSelectable: true,
    elevateNodesOnSelect: true,
    fitViewOnInit: false,
    fitViewOnInitDone: false,
    fitViewOnInitOptions: undefined,
    onSelectionChange: [],
    multiSelectionActive: false,
    connectionStartHandle: null,
    connectionEndHandle: null,
    connectionClickStartHandle: null,
    connectOnClick: true,
    ariaLiveMessage: '',
    autoPanOnConnect: true,
    autoPanOnNodeDrag: true,
    connectionRadius: 20,
    onError: devWarn,
    isValidConnection: undefined
};
const createRFStore = ()=>(0, _traditional.createWithEqualityFn)((set, get)=>({
            ...initialState,
            setNodes: (nodes)=>{
                const { nodeInternals, nodeOrigin, elevateNodesOnSelect } = get();
                set({
                    nodeInternals: createNodeInternals(nodes, nodeInternals, nodeOrigin, elevateNodesOnSelect)
                });
            },
            getNodes: ()=>{
                return Array.from(get().nodeInternals.values());
            },
            setEdges: (edges)=>{
                const { defaultEdgeOptions = {} } = get();
                set({
                    edges: edges.map((e)=>({
                            ...defaultEdgeOptions,
                            ...e
                        }))
                });
            },
            setDefaultNodesAndEdges: (nodes, edges)=>{
                const hasDefaultNodes = typeof nodes !== 'undefined';
                const hasDefaultEdges = typeof edges !== 'undefined';
                const nodeInternals = hasDefaultNodes ? createNodeInternals(nodes, new Map(), get().nodeOrigin, get().elevateNodesOnSelect) : new Map();
                const nextEdges = hasDefaultEdges ? edges : [];
                set({
                    nodeInternals,
                    edges: nextEdges,
                    hasDefaultNodes,
                    hasDefaultEdges
                });
            },
            updateNodeDimensions: (updates)=>{
                const { onNodesChange, nodeInternals, fitViewOnInit, fitViewOnInitDone, fitViewOnInitOptions, domNode, nodeOrigin } = get();
                const viewportNode = domNode?.querySelector('.react-flow__viewport');
                if (!viewportNode) return;
                const style = window.getComputedStyle(viewportNode);
                const { m22: zoom } = new window.DOMMatrixReadOnly(style.transform);
                const changes = updates.reduce((res, update)=>{
                    const node = nodeInternals.get(update.id);
                    if (node?.hidden) nodeInternals.set(node.id, {
                        ...node,
                        [internalsSymbol]: {
                            ...node[internalsSymbol],
                            // we need to reset the handle bounds when the node is hidden
                            // in order to force a new observation when the node is shown again
                            handleBounds: undefined
                        }
                    });
                    else if (node) {
                        const dimensions = getDimensions(update.nodeElement);
                        const doUpdate = !!(dimensions.width && dimensions.height && (node.width !== dimensions.width || node.height !== dimensions.height || update.forceUpdate));
                        if (doUpdate) {
                            nodeInternals.set(node.id, {
                                ...node,
                                [internalsSymbol]: {
                                    ...node[internalsSymbol],
                                    handleBounds: {
                                        source: getHandleBounds('.source', update.nodeElement, zoom, nodeOrigin),
                                        target: getHandleBounds('.target', update.nodeElement, zoom, nodeOrigin)
                                    }
                                },
                                ...dimensions
                            });
                            res.push({
                                id: node.id,
                                type: 'dimensions',
                                dimensions
                            });
                        }
                    }
                    return res;
                }, []);
                updateAbsoluteNodePositions(nodeInternals, nodeOrigin);
                const nextFitViewOnInitDone = fitViewOnInitDone || fitViewOnInit && !fitViewOnInitDone && fitView(get, {
                    initial: true,
                    ...fitViewOnInitOptions
                });
                set({
                    nodeInternals: new Map(nodeInternals),
                    fitViewOnInitDone: nextFitViewOnInitDone
                });
                if (changes?.length > 0) onNodesChange?.(changes);
            },
            updateNodePositions: (nodeDragItems, positionChanged = true, dragging = false)=>{
                const { triggerNodeChanges } = get();
                const changes = nodeDragItems.map((node)=>{
                    const change = {
                        id: node.id,
                        type: 'position',
                        dragging
                    };
                    if (positionChanged) {
                        change.positionAbsolute = node.positionAbsolute;
                        change.position = node.position;
                    }
                    return change;
                });
                triggerNodeChanges(changes);
            },
            triggerNodeChanges: (changes)=>{
                const { onNodesChange, nodeInternals, hasDefaultNodes, nodeOrigin, getNodes, elevateNodesOnSelect } = get();
                if (changes?.length) {
                    if (hasDefaultNodes) {
                        const nodes = applyNodeChanges(changes, getNodes());
                        const nextNodeInternals = createNodeInternals(nodes, nodeInternals, nodeOrigin, elevateNodesOnSelect);
                        set({
                            nodeInternals: nextNodeInternals
                        });
                    }
                    onNodesChange?.(changes);
                }
            },
            addSelectedNodes: (selectedNodeIds)=>{
                const { multiSelectionActive, edges, getNodes } = get();
                let changedNodes;
                let changedEdges = null;
                if (multiSelectionActive) changedNodes = selectedNodeIds.map((nodeId)=>createSelectionChange(nodeId, true));
                else {
                    changedNodes = getSelectionChanges(getNodes(), selectedNodeIds);
                    changedEdges = getSelectionChanges(edges, []);
                }
                updateNodesAndEdgesSelections({
                    changedNodes,
                    changedEdges,
                    get,
                    set
                });
            },
            addSelectedEdges: (selectedEdgeIds)=>{
                const { multiSelectionActive, edges, getNodes } = get();
                let changedEdges;
                let changedNodes = null;
                if (multiSelectionActive) changedEdges = selectedEdgeIds.map((edgeId)=>createSelectionChange(edgeId, true));
                else {
                    changedEdges = getSelectionChanges(edges, selectedEdgeIds);
                    changedNodes = getSelectionChanges(getNodes(), []);
                }
                updateNodesAndEdgesSelections({
                    changedNodes,
                    changedEdges,
                    get,
                    set
                });
            },
            unselectNodesAndEdges: ({ nodes, edges } = {})=>{
                const { edges: storeEdges, getNodes } = get();
                const nodesToUnselect = nodes ? nodes : getNodes();
                const edgesToUnselect = edges ? edges : storeEdges;
                const changedNodes = nodesToUnselect.map((n)=>{
                    n.selected = false;
                    return createSelectionChange(n.id, false);
                });
                const changedEdges = edgesToUnselect.map((edge)=>createSelectionChange(edge.id, false));
                updateNodesAndEdgesSelections({
                    changedNodes,
                    changedEdges,
                    get,
                    set
                });
            },
            setMinZoom: (minZoom)=>{
                const { d3Zoom, maxZoom } = get();
                d3Zoom?.scaleExtent([
                    minZoom,
                    maxZoom
                ]);
                set({
                    minZoom
                });
            },
            setMaxZoom: (maxZoom)=>{
                const { d3Zoom, minZoom } = get();
                d3Zoom?.scaleExtent([
                    minZoom,
                    maxZoom
                ]);
                set({
                    maxZoom
                });
            },
            setTranslateExtent: (translateExtent)=>{
                get().d3Zoom?.translateExtent(translateExtent);
                set({
                    translateExtent
                });
            },
            resetSelectedElements: ()=>{
                const { edges, getNodes } = get();
                const nodes = getNodes();
                const nodesToUnselect = nodes.filter((e)=>e.selected).map((n)=>createSelectionChange(n.id, false));
                const edgesToUnselect = edges.filter((e)=>e.selected).map((e)=>createSelectionChange(e.id, false));
                updateNodesAndEdgesSelections({
                    changedNodes: nodesToUnselect,
                    changedEdges: edgesToUnselect,
                    get,
                    set
                });
            },
            setNodeExtent: (nodeExtent)=>{
                const { nodeInternals } = get();
                nodeInternals.forEach((node)=>{
                    node.positionAbsolute = clampPosition(node.position, nodeExtent);
                });
                set({
                    nodeExtent,
                    nodeInternals: new Map(nodeInternals)
                });
            },
            panBy: (delta)=>{
                const { transform, width, height, d3Zoom, d3Selection, translateExtent } = get();
                if (!d3Zoom || !d3Selection || !delta.x && !delta.y) return false;
                const nextTransform = (0, _d3Zoom.zoomIdentity).translate(transform[0] + delta.x, transform[1] + delta.y).scale(transform[2]);
                const extent = [
                    [
                        0,
                        0
                    ],
                    [
                        width,
                        height
                    ]
                ];
                const constrainedTransform = d3Zoom?.constrain()(nextTransform, extent, translateExtent);
                d3Zoom.transform(d3Selection, constrainedTransform);
                const transformChanged = transform[0] !== constrainedTransform.x || transform[1] !== constrainedTransform.y || transform[2] !== constrainedTransform.k;
                return transformChanged;
            },
            cancelConnection: ()=>set({
                    connectionNodeId: initialState.connectionNodeId,
                    connectionHandleId: initialState.connectionHandleId,
                    connectionHandleType: initialState.connectionHandleType,
                    connectionStatus: initialState.connectionStatus,
                    connectionStartHandle: initialState.connectionStartHandle,
                    connectionEndHandle: initialState.connectionEndHandle
                }),
            reset: ()=>set({
                    ...initialState
                })
        }), Object.is);
const ReactFlowProvider = ({ children })=>{
    const storeRef = (0, _react.useRef)(null);
    if (!storeRef.current) storeRef.current = createRFStore();
    return (0, _reactDefault.default).createElement(Provider$1, {
        value: storeRef.current
    }, children);
};
ReactFlowProvider.displayName = 'ReactFlowProvider';
const Wrapper = ({ children })=>{
    const isWrapped = (0, _react.useContext)(StoreContext);
    if (isWrapped) // we need to wrap it with a fragment because it's not allowed for children to be a ReactNode
    // https://github.com/DefinitelyTyped/DefinitelyTyped/issues/18051
    return (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, children);
    return (0, _reactDefault.default).createElement(ReactFlowProvider, null, children);
};
Wrapper.displayName = 'ReactFlowWrapper';
const defaultNodeTypes = {
    input: InputNode$1,
    default: DefaultNode$1,
    output: OutputNode$1,
    group: GroupNode
};
const defaultEdgeTypes = {
    default: BezierEdge,
    straight: StraightEdge,
    step: StepEdge,
    smoothstep: SmoothStepEdge,
    simplebezier: SimpleBezierEdge
};
const initNodeOrigin = [
    0,
    0
];
const initSnapGrid = [
    15,
    15
];
const initDefaultViewport = {
    x: 0,
    y: 0,
    zoom: 1
};
const wrapperStyle = {
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    position: 'relative',
    zIndex: 0
};
const ReactFlow = (0, _react.forwardRef)(({ nodes, edges, defaultNodes, defaultEdges, className, nodeTypes = defaultNodeTypes, edgeTypes = defaultEdgeTypes, onNodeClick, onEdgeClick, onInit, onMove, onMoveStart, onMoveEnd, onConnect, onConnectStart, onConnectEnd, onClickConnectStart, onClickConnectEnd, onNodeMouseEnter, onNodeMouseMove, onNodeMouseLeave, onNodeContextMenu, onNodeDoubleClick, onNodeDragStart, onNodeDrag, onNodeDragStop, onNodesDelete, onEdgesDelete, onSelectionChange, onSelectionDragStart, onSelectionDrag, onSelectionDragStop, onSelectionContextMenu, onSelectionStart, onSelectionEnd, connectionMode = ConnectionMode.Strict, connectionLineType = ConnectionLineType.Bezier, connectionLineStyle, connectionLineComponent, connectionLineContainerStyle, deleteKeyCode = 'Backspace', selectionKeyCode = 'Shift', selectionOnDrag = false, selectionMode = SelectionMode.Full, panActivationKeyCode = 'Space', multiSelectionKeyCode = isMacOs() ? 'Meta' : 'Control', zoomActivationKeyCode = isMacOs() ? 'Meta' : 'Control', snapToGrid = false, snapGrid = initSnapGrid, onlyRenderVisibleElements = false, selectNodesOnDrag = true, nodesDraggable, nodesConnectable, nodesFocusable, nodeOrigin = initNodeOrigin, edgesFocusable, edgesUpdatable, elementsSelectable, defaultViewport = initDefaultViewport, minZoom = 0.5, maxZoom = 2, translateExtent = infiniteExtent, preventScrolling = true, nodeExtent, defaultMarkerColor = '#b1b1b7', zoomOnScroll = true, zoomOnPinch = true, panOnScroll = false, panOnScrollSpeed = 0.5, panOnScrollMode = PanOnScrollMode.Free, zoomOnDoubleClick = true, panOnDrag = true, onPaneClick, onPaneMouseEnter, onPaneMouseMove, onPaneMouseLeave, onPaneScroll, onPaneContextMenu, children, onEdgeContextMenu, onEdgeDoubleClick, onEdgeMouseEnter, onEdgeMouseMove, onEdgeMouseLeave, onEdgeUpdate, onEdgeUpdateStart, onEdgeUpdateEnd, onReconnect, onReconnectStart, onReconnectEnd, reconnectRadius = 10, edgeUpdaterRadius = 10, onNodesChange, onEdgesChange, noDragClassName = 'nodrag', noWheelClassName = 'nowheel', noPanClassName = 'nopan', fitView = false, fitViewOptions, connectOnClick = true, attributionPosition, proOptions, defaultEdgeOptions, elevateNodesOnSelect = true, elevateEdgesOnSelect = false, disableKeyboardA11y = false, autoPanOnConnect = true, autoPanOnNodeDrag = true, connectionRadius = 20, isValidConnection, onError, style, id, nodeDragThreshold, ...rest }, ref)=>{
    const rfId = id || '1';
    return (0, _reactDefault.default).createElement("div", {
        ...rest,
        style: {
            ...style,
            ...wrapperStyle
        },
        ref: ref,
        className: (0, _classcatDefault.default)([
            'react-flow',
            className
        ]),
        "data-testid": "rf__wrapper",
        id: id
    }, (0, _reactDefault.default).createElement(Wrapper, null, (0, _reactDefault.default).createElement(GraphView$1, {
        onInit: onInit,
        onMove: onMove,
        onMoveStart: onMoveStart,
        onMoveEnd: onMoveEnd,
        onNodeClick: onNodeClick,
        onEdgeClick: onEdgeClick,
        onNodeMouseEnter: onNodeMouseEnter,
        onNodeMouseMove: onNodeMouseMove,
        onNodeMouseLeave: onNodeMouseLeave,
        onNodeContextMenu: onNodeContextMenu,
        onNodeDoubleClick: onNodeDoubleClick,
        nodeTypes: nodeTypes,
        edgeTypes: edgeTypes,
        connectionLineType: connectionLineType,
        connectionLineStyle: connectionLineStyle,
        connectionLineComponent: connectionLineComponent,
        connectionLineContainerStyle: connectionLineContainerStyle,
        selectionKeyCode: selectionKeyCode,
        selectionOnDrag: selectionOnDrag,
        selectionMode: selectionMode,
        deleteKeyCode: deleteKeyCode,
        multiSelectionKeyCode: multiSelectionKeyCode,
        panActivationKeyCode: panActivationKeyCode,
        zoomActivationKeyCode: zoomActivationKeyCode,
        onlyRenderVisibleElements: onlyRenderVisibleElements,
        selectNodesOnDrag: selectNodesOnDrag,
        defaultViewport: defaultViewport,
        translateExtent: translateExtent,
        minZoom: minZoom,
        maxZoom: maxZoom,
        preventScrolling: preventScrolling,
        zoomOnScroll: zoomOnScroll,
        zoomOnPinch: zoomOnPinch,
        zoomOnDoubleClick: zoomOnDoubleClick,
        panOnScroll: panOnScroll,
        panOnScrollSpeed: panOnScrollSpeed,
        panOnScrollMode: panOnScrollMode,
        panOnDrag: panOnDrag,
        onPaneClick: onPaneClick,
        onPaneMouseEnter: onPaneMouseEnter,
        onPaneMouseMove: onPaneMouseMove,
        onPaneMouseLeave: onPaneMouseLeave,
        onPaneScroll: onPaneScroll,
        onPaneContextMenu: onPaneContextMenu,
        onSelectionContextMenu: onSelectionContextMenu,
        onSelectionStart: onSelectionStart,
        onSelectionEnd: onSelectionEnd,
        onEdgeContextMenu: onEdgeContextMenu,
        onEdgeDoubleClick: onEdgeDoubleClick,
        onEdgeMouseEnter: onEdgeMouseEnter,
        onEdgeMouseMove: onEdgeMouseMove,
        onEdgeMouseLeave: onEdgeMouseLeave,
        onReconnect: onReconnect ?? onEdgeUpdate,
        onReconnectStart: onReconnectStart ?? onEdgeUpdateStart,
        onReconnectEnd: onReconnectEnd ?? onEdgeUpdateEnd,
        reconnectRadius: reconnectRadius ?? edgeUpdaterRadius,
        defaultMarkerColor: defaultMarkerColor,
        noDragClassName: noDragClassName,
        noWheelClassName: noWheelClassName,
        noPanClassName: noPanClassName,
        elevateEdgesOnSelect: elevateEdgesOnSelect,
        rfId: rfId,
        disableKeyboardA11y: disableKeyboardA11y,
        nodeOrigin: nodeOrigin,
        nodeExtent: nodeExtent
    }), (0, _reactDefault.default).createElement(StoreUpdater, {
        nodes: nodes,
        edges: edges,
        defaultNodes: defaultNodes,
        defaultEdges: defaultEdges,
        onConnect: onConnect,
        onConnectStart: onConnectStart,
        onConnectEnd: onConnectEnd,
        onClickConnectStart: onClickConnectStart,
        onClickConnectEnd: onClickConnectEnd,
        nodesDraggable: nodesDraggable,
        nodesConnectable: nodesConnectable,
        nodesFocusable: nodesFocusable,
        edgesFocusable: edgesFocusable,
        edgesUpdatable: edgesUpdatable,
        elementsSelectable: elementsSelectable,
        elevateNodesOnSelect: elevateNodesOnSelect,
        minZoom: minZoom,
        maxZoom: maxZoom,
        nodeExtent: nodeExtent,
        onNodesChange: onNodesChange,
        onEdgesChange: onEdgesChange,
        snapToGrid: snapToGrid,
        snapGrid: snapGrid,
        connectionMode: connectionMode,
        translateExtent: translateExtent,
        connectOnClick: connectOnClick,
        defaultEdgeOptions: defaultEdgeOptions,
        fitView: fitView,
        fitViewOptions: fitViewOptions,
        onNodesDelete: onNodesDelete,
        onEdgesDelete: onEdgesDelete,
        onNodeDragStart: onNodeDragStart,
        onNodeDrag: onNodeDrag,
        onNodeDragStop: onNodeDragStop,
        onSelectionDrag: onSelectionDrag,
        onSelectionDragStart: onSelectionDragStart,
        onSelectionDragStop: onSelectionDragStop,
        noPanClassName: noPanClassName,
        nodeOrigin: nodeOrigin,
        rfId: rfId,
        autoPanOnConnect: autoPanOnConnect,
        autoPanOnNodeDrag: autoPanOnNodeDrag,
        onError: onError,
        connectionRadius: connectionRadius,
        isValidConnection: isValidConnection,
        nodeDragThreshold: nodeDragThreshold
    }), (0, _reactDefault.default).createElement(Wrapper$1, {
        onSelectionChange: onSelectionChange
    }), children, (0, _reactDefault.default).createElement(Attribution, {
        proOptions: proOptions,
        position: attributionPosition
    }), (0, _reactDefault.default).createElement(A11yDescriptions, {
        rfId: rfId,
        disableKeyboardA11y: disableKeyboardA11y
    })));
});
ReactFlow.displayName = 'ReactFlow';
const selector$1 = (s)=>s.domNode?.querySelector('.react-flow__edgelabel-renderer');
function EdgeLabelRenderer({ children }) {
    const edgeLabelRenderer = useStore(selector$1);
    if (!edgeLabelRenderer) return null;
    return (0, _reactDom.createPortal)(children, edgeLabelRenderer);
}
function useUpdateNodeInternals() {
    const store = useStoreApi();
    return (0, _react.useCallback)((id)=>{
        const { domNode, updateNodeDimensions } = store.getState();
        const updateIds = Array.isArray(id) ? id : [
            id
        ];
        const updates = updateIds.reduce((res, updateId)=>{
            const nodeElement = domNode?.querySelector(`.react-flow__node[data-id="${updateId}"]`);
            if (nodeElement) res.push({
                id: updateId,
                nodeElement,
                forceUpdate: true
            });
            return res;
        }, []);
        requestAnimationFrame(()=>updateNodeDimensions(updates));
    }, []);
}
const nodesSelector = (state)=>state.getNodes();
function useNodes() {
    const nodes = useStore(nodesSelector, (0, _shallow.shallow));
    return nodes;
}
const edgesSelector = (state)=>state.edges;
function useEdges() {
    const edges = useStore(edgesSelector, (0, _shallow.shallow));
    return edges;
}
const viewportSelector = (state)=>({
        x: state.transform[0],
        y: state.transform[1],
        zoom: state.transform[2]
    });
function useViewport() {
    const viewport = useStore(viewportSelector, (0, _shallow.shallow));
    return viewport;
}
/* eslint-disable @typescript-eslint/no-explicit-any */ function createUseItemsState(applyChanges) {
    return (initialItems)=>{
        const [items, setItems] = (0, _react.useState)(initialItems);
        const onItemsChange = (0, _react.useCallback)((changes)=>setItems((items)=>applyChanges(changes, items)), []);
        return [
            items,
            setItems,
            onItemsChange
        ];
    };
}
const useNodesState = createUseItemsState(applyNodeChanges);
const useEdgesState = createUseItemsState(applyEdgeChanges);
function useOnViewportChange({ onStart, onChange, onEnd }) {
    const store = useStoreApi();
    (0, _react.useEffect)(()=>{
        store.setState({
            onViewportChangeStart: onStart
        });
    }, [
        onStart
    ]);
    (0, _react.useEffect)(()=>{
        store.setState({
            onViewportChange: onChange
        });
    }, [
        onChange
    ]);
    (0, _react.useEffect)(()=>{
        store.setState({
            onViewportChangeEnd: onEnd
        });
    }, [
        onEnd
    ]);
}
function useOnSelectionChange({ onChange }) {
    const store = useStoreApi();
    (0, _react.useEffect)(()=>{
        const nextSelectionChangeHandlers = [
            ...store.getState().onSelectionChange,
            onChange
        ];
        store.setState({
            onSelectionChange: nextSelectionChangeHandlers
        });
        return ()=>{
            const nextHandlers = store.getState().onSelectionChange.filter((fn)=>fn !== onChange);
            store.setState({
                onSelectionChange: nextHandlers
            });
        };
    }, [
        onChange
    ]);
}
const selector = (options)=>(s)=>{
        if (s.nodeInternals.size === 0) return false;
        return s.getNodes().filter((n)=>options.includeHiddenNodes ? true : !n.hidden).every((n)=>n[internalsSymbol]?.handleBounds !== undefined);
    };
const defaultOptions = {
    includeHiddenNodes: false
};
function useNodesInitialized(options = defaultOptions) {
    const initialized = useStore(selector(options));
    return initialized;
}

},{"react":"bmhQu","classcat":"gT31h","zustand/traditional":"196jd","zustand/shallow":"8Q3tx","d3-zoom":"h8Ny4","d3-selection":[["pointer","04Hca","default"],["select","4CEQV","default"]],"d3-drag":[["drag","2iRCi","default"]],"react-dom":"82aNB","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gT31h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>cc);
function cc(names) {
    if (typeof names === "string" || typeof names === "number") return "" + names;
    let out = "";
    if (Array.isArray(names)) {
        for(let i = 0, tmp; i < names.length; i++)if ((tmp = cc(names[i])) !== "") out += (out && " ") + tmp;
    } else {
        for(let k in names)if (names[k]) out += (out && " ") + k;
    }
    return out;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"196jd":[function(require,module,exports,__globalThis) {
'use strict';
var ReactExports = require("55fe33b72be7f997");
var useSyncExternalStoreExports = require("bfacb3376c7259e5");
var vanilla = require("93e7584e5ac2a823");
var useDebugValue = ReactExports.useDebugValue;
var useSyncExternalStoreWithSelector = useSyncExternalStoreExports.useSyncExternalStoreWithSelector;
var identity = function identity(arg) {
    return arg;
};
function useStoreWithEqualityFn(api, selector, equalityFn) {
    if (selector === void 0) selector = identity;
    var slice = useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
    useDebugValue(slice);
    return slice;
}
var createWithEqualityFnImpl = function createWithEqualityFnImpl(createState, defaultEqualityFn) {
    var api = vanilla.createStore(createState);
    var useBoundStoreWithEqualityFn = function useBoundStoreWithEqualityFn(selector, equalityFn) {
        if (equalityFn === void 0) equalityFn = defaultEqualityFn;
        return useStoreWithEqualityFn(api, selector, equalityFn);
    };
    Object.assign(useBoundStoreWithEqualityFn, api);
    return useBoundStoreWithEqualityFn;
};
var createWithEqualityFn = function createWithEqualityFn(createState, defaultEqualityFn) {
    return createState ? createWithEqualityFnImpl(createState, defaultEqualityFn) : createWithEqualityFnImpl;
};
exports.createWithEqualityFn = createWithEqualityFn;
exports.useStoreWithEqualityFn = useStoreWithEqualityFn;

},{"55fe33b72be7f997":"bmhQu","bfacb3376c7259e5":"j1vWm","93e7584e5ac2a823":"bsCIB"}],"j1vWm":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("d1848724d1e53763");

},{"d1848724d1e53763":"8sq3O"}],"8sq3O":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var React = require("d57a74df6bca20fd"), shim = require("5be634d856d1f9fa");
function is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var objectIs = "function" === typeof Object.is ? Object.is : is, useSyncExternalStore = shim.useSyncExternalStore, useRef = React.useRef, useEffect = React.useEffect, useMemo = React.useMemo, useDebugValue = React.useDebugValue;
exports.useSyncExternalStoreWithSelector = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if (objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    useDebugValue(value);
    return value;
};

},{"d57a74df6bca20fd":"bmhQu","5be634d856d1f9fa":"6U7cH"}],"6U7cH":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("3e3e060a1c619377");

},{"3e3e060a1c619377":"adP2B"}],"adP2B":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var React = require("a18024ece7b3cd12");
function is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var objectIs = "function" === typeof Object.is ? Object.is : is, useState = React.useState, useEffect = React.useEffect, useLayoutEffect = React.useLayoutEffect, useDebugValue = React.useDebugValue;
function useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    useEffect(function() {
        checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    useDebugValue(value);
    return value;
}
function checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? useSyncExternalStore$1 : useSyncExternalStore$2;
exports.useSyncExternalStore = void 0 !== React.useSyncExternalStore ? React.useSyncExternalStore : shim;

},{"a18024ece7b3cd12":"bmhQu"}],"bsCIB":[function(require,module,exports,__globalThis) {
'use strict';
var createStoreImpl = function createStoreImpl(createState) {
    var state;
    var listeners = new Set();
    var setState = function setState(partial, replace) {
        var nextState = typeof partial === 'function' ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            var _previousState = state;
            state = (replace != null ? replace : typeof nextState !== 'object' || nextState === null) ? nextState : Object.assign({}, state, nextState);
            listeners.forEach(function(listener) {
                return listener(state, _previousState);
            });
        }
    };
    var getState = function getState() {
        return state;
    };
    var getInitialState = function getInitialState() {
        return initialState;
    };
    var subscribe = function subscribe(listener) {
        listeners.add(listener);
        return function() {
            return listeners.delete(listener);
        };
    };
    var destroy = function destroy() {
        listeners.clear();
    };
    var api = {
        setState: setState,
        getState: getState,
        getInitialState: getInitialState,
        subscribe: subscribe,
        destroy: destroy
    };
    var initialState = state = createState(setState, getState, api);
    return api;
};
var createStore = function createStore(createState) {
    return createState ? createStoreImpl(createState) : createStoreImpl;
};
var vanilla = function(createState) {
    return createStore(createState);
};
exports.createStore = createStore;
exports.default = vanilla;
module.exports = vanilla;
module.exports.createStore = createStore;
exports.default = module.exports;

},{}],"8Q3tx":[function(require,module,exports,__globalThis) {
'use strict';
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function _createForOfIteratorHelperLoose(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (t) return (t = t.call(r)).next.bind(t);
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e) {
        t && (r = t);
        var o = 0;
        return function() {
            return o >= r.length ? {
                done: !0
            } : {
                done: !1,
                value: r[o++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return _arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
    }
}
function shallow$1(objA, objB) {
    if (Object.is(objA, objB)) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    if (objA instanceof Map && objB instanceof Map) {
        if (objA.size !== objB.size) return false;
        for(var _iterator = _createForOfIteratorHelperLoose(objA), _step; !(_step = _iterator()).done;){
            var _step$value = _step.value, key = _step$value[0], value = _step$value[1];
            if (!Object.is(value, objB.get(key))) return false;
        }
        return true;
    }
    if (objA instanceof Set && objB instanceof Set) {
        if (objA.size !== objB.size) return false;
        for(var _iterator2 = _createForOfIteratorHelperLoose(objA), _step2; !(_step2 = _iterator2()).done;){
            var _value = _step2.value;
            if (!objB.has(_value)) return false;
        }
        return true;
    }
    var keysA = Object.keys(objA);
    if (keysA.length !== Object.keys(objB).length) return false;
    for(var _i = 0, _keysA = keysA; _i < _keysA.length; _i++){
        var keyA = _keysA[_i];
        if (!Object.prototype.hasOwnProperty.call(objB, keyA) || !Object.is(objA[keyA], objB[keyA])) return false;
    }
    return true;
}
var shallow = function(objA, objB) {
    return shallow$1(objA, objB);
};
exports.default = shallow;
exports.shallow = shallow$1;
module.exports = shallow;
module.exports.shallow = shallow$1;
exports.default = module.exports;

},{}],"h8Ny4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "zoom", ()=>(0, _zoomJsDefault.default));
parcelHelpers.export(exports, "zoomTransform", ()=>(0, _transformJsDefault.default));
parcelHelpers.export(exports, "zoomIdentity", ()=>(0, _transformJs.identity));
parcelHelpers.export(exports, "ZoomTransform", ()=>(0, _transformJs.Transform));
var _zoomJs = require("./zoom.js");
var _zoomJsDefault = parcelHelpers.interopDefault(_zoomJs);
var _transformJs = require("./transform.js");
var _transformJsDefault = parcelHelpers.interopDefault(_transformJs);

},{"./zoom.js":"k0uTV","./transform.js":"KmKi8","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"k0uTV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var filter = defaultFilter, extent = defaultExtent, constrain = defaultConstrain, wheelDelta = defaultWheelDelta, touchable = defaultTouchable, scaleExtent = [
            0,
            Infinity
        ], translateExtent = [
            [
                -Infinity,
                -Infinity
            ],
            [
                Infinity,
                Infinity
            ]
        ], duration = 250, interpolate = (0, _d3Interpolate.interpolateZoom), listeners = (0, _d3Dispatch.dispatch)("start", "zoom", "end"), touchstarting, touchfirst, touchending, touchDelay = 500, wheelDelay = 150, clickDistance2 = 0, tapDistance = 10;
        function zoom(selection) {
            selection.property("__zoom", defaultTransform).on("wheel.zoom", wheeled, {
                passive: false
            }).on("mousedown.zoom", mousedowned).on("dblclick.zoom", dblclicked).filter(touchable).on("touchstart.zoom", touchstarted).on("touchmove.zoom", touchmoved).on("touchend.zoom touchcancel.zoom", touchended).style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
        }
        zoom.transform = function(collection, transform, point, event) {
            var selection = collection.selection ? collection.selection() : collection;
            selection.property("__zoom", defaultTransform);
            if (collection !== selection) schedule(collection, transform, point, event);
            else selection.interrupt().each(function() {
                gesture(this, arguments).event(event).start().zoom(null, typeof transform === "function" ? transform.apply(this, arguments) : transform).end();
            });
        };
        zoom.scaleBy = function(selection, k, p, event) {
            zoom.scaleTo(selection, function() {
                var k0 = this.__zoom.k, k1 = typeof k === "function" ? k.apply(this, arguments) : k;
                return k0 * k1;
            }, p, event);
        };
        zoom.scaleTo = function(selection, k, p, event) {
            zoom.transform(selection, function() {
                var e = extent.apply(this, arguments), t0 = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p, p1 = t0.invert(p0), k1 = typeof k === "function" ? k.apply(this, arguments) : k;
                return constrain(translate(scale(t0, k1), p0, p1), e, translateExtent);
            }, p, event);
        };
        zoom.translateBy = function(selection, x, y, event) {
            zoom.transform(selection, function() {
                return constrain(this.__zoom.translate(typeof x === "function" ? x.apply(this, arguments) : x, typeof y === "function" ? y.apply(this, arguments) : y), extent.apply(this, arguments), translateExtent);
            }, null, event);
        };
        zoom.translateTo = function(selection, x, y, p, event) {
            zoom.transform(selection, function() {
                var e = extent.apply(this, arguments), t = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p;
                return constrain((0, _transformJs.identity).translate(p0[0], p0[1]).scale(t.k).translate(typeof x === "function" ? -x.apply(this, arguments) : -x, typeof y === "function" ? -y.apply(this, arguments) : -y), e, translateExtent);
            }, p, event);
        };
        function scale(transform, k) {
            k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], k));
            return k === transform.k ? transform : new (0, _transformJs.Transform)(k, transform.x, transform.y);
        }
        function translate(transform, p0, p1) {
            var x = p0[0] - p1[0] * transform.k, y = p0[1] - p1[1] * transform.k;
            return x === transform.x && y === transform.y ? transform : new (0, _transformJs.Transform)(transform.k, x, y);
        }
        function centroid(extent) {
            return [
                (+extent[0][0] + +extent[1][0]) / 2,
                (+extent[0][1] + +extent[1][1]) / 2
            ];
        }
        function schedule(transition, transform, point, event) {
            transition.on("start.zoom", function() {
                gesture(this, arguments).event(event).start();
            }).on("interrupt.zoom end.zoom", function() {
                gesture(this, arguments).event(event).end();
            }).tween("zoom", function() {
                var that = this, args = arguments, g = gesture(that, args).event(event), e = extent.apply(that, args), p = point == null ? centroid(e) : typeof point === "function" ? point.apply(that, args) : point, w = Math.max(e[1][0] - e[0][0], e[1][1] - e[0][1]), a = that.__zoom, b = typeof transform === "function" ? transform.apply(that, args) : transform, i = interpolate(a.invert(p).concat(w / a.k), b.invert(p).concat(w / b.k));
                return function(t) {
                    if (t === 1) t = b; // Avoid rounding error on end.
                    else {
                        var l = i(t), k = w / l[2];
                        t = new (0, _transformJs.Transform)(k, p[0] - l[0] * k, p[1] - l[1] * k);
                    }
                    g.zoom(null, t);
                };
            });
        }
        function gesture(that, args, clean) {
            return !clean && that.__zooming || new Gesture(that, args);
        }
        function Gesture(that, args) {
            this.that = that;
            this.args = args;
            this.active = 0;
            this.sourceEvent = null;
            this.extent = extent.apply(that, args);
            this.taps = 0;
        }
        Gesture.prototype = {
            event: function(event) {
                if (event) this.sourceEvent = event;
                return this;
            },
            start: function() {
                if (++this.active === 1) {
                    this.that.__zooming = this;
                    this.emit("start");
                }
                return this;
            },
            zoom: function(key, transform) {
                if (this.mouse && key !== "mouse") this.mouse[1] = transform.invert(this.mouse[0]);
                if (this.touch0 && key !== "touch") this.touch0[1] = transform.invert(this.touch0[0]);
                if (this.touch1 && key !== "touch") this.touch1[1] = transform.invert(this.touch1[0]);
                this.that.__zoom = transform;
                this.emit("zoom");
                return this;
            },
            end: function() {
                if (--this.active === 0) {
                    delete this.that.__zooming;
                    this.emit("end");
                }
                return this;
            },
            emit: function(type) {
                var d = (0, _d3Selection.select)(this.that).datum();
                listeners.call(type, this.that, new (0, _eventJsDefault.default)(type, {
                    sourceEvent: this.sourceEvent,
                    target: zoom,
                    type,
                    transform: this.that.__zoom,
                    dispatch: listeners
                }), d);
            }
        };
        function wheeled(event, ...args) {
            if (!filter.apply(this, arguments)) return;
            var g = gesture(this, args).event(event), t = this.__zoom, k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], t.k * Math.pow(2, wheelDelta.apply(this, arguments)))), p = (0, _d3Selection.pointer)(event);
            // If the mouse is in the same location as before, reuse it.
            // If there were recent wheel events, reset the wheel idle timeout.
            if (g.wheel) {
                if (g.mouse[0][0] !== p[0] || g.mouse[0][1] !== p[1]) g.mouse[1] = t.invert(g.mouse[0] = p);
                clearTimeout(g.wheel);
            } else if (t.k === k) return;
            else {
                g.mouse = [
                    p,
                    t.invert(p)
                ];
                (0, _d3Transition.interrupt)(this);
                g.start();
            }
            (0, _noeventJsDefault.default)(event);
            g.wheel = setTimeout(wheelidled, wheelDelay);
            g.zoom("mouse", constrain(translate(scale(t, k), g.mouse[0], g.mouse[1]), g.extent, translateExtent));
            function wheelidled() {
                g.wheel = null;
                g.end();
            }
        }
        function mousedowned(event, ...args) {
            if (touchending || !filter.apply(this, arguments)) return;
            var currentTarget = event.currentTarget, g = gesture(this, args, true).event(event), v = (0, _d3Selection.select)(event.view).on("mousemove.zoom", mousemoved, true).on("mouseup.zoom", mouseupped, true), p = (0, _d3Selection.pointer)(event, currentTarget), x0 = event.clientX, y0 = event.clientY;
            (0, _d3Drag.dragDisable)(event.view);
            (0, _noeventJs.nopropagation)(event);
            g.mouse = [
                p,
                this.__zoom.invert(p)
            ];
            (0, _d3Transition.interrupt)(this);
            g.start();
            function mousemoved(event) {
                (0, _noeventJsDefault.default)(event);
                if (!g.moved) {
                    var dx = event.clientX - x0, dy = event.clientY - y0;
                    g.moved = dx * dx + dy * dy > clickDistance2;
                }
                g.event(event).zoom("mouse", constrain(translate(g.that.__zoom, g.mouse[0] = (0, _d3Selection.pointer)(event, currentTarget), g.mouse[1]), g.extent, translateExtent));
            }
            function mouseupped(event) {
                v.on("mousemove.zoom mouseup.zoom", null);
                (0, _d3Drag.dragEnable)(event.view, g.moved);
                (0, _noeventJsDefault.default)(event);
                g.event(event).end();
            }
        }
        function dblclicked(event, ...args) {
            if (!filter.apply(this, arguments)) return;
            var t0 = this.__zoom, p0 = (0, _d3Selection.pointer)(event.changedTouches ? event.changedTouches[0] : event, this), p1 = t0.invert(p0), k1 = t0.k * (event.shiftKey ? 0.5 : 2), t1 = constrain(translate(scale(t0, k1), p0, p1), extent.apply(this, args), translateExtent);
            (0, _noeventJsDefault.default)(event);
            if (duration > 0) (0, _d3Selection.select)(this).transition().duration(duration).call(schedule, t1, p0, event);
            else (0, _d3Selection.select)(this).call(zoom.transform, t1, p0, event);
        }
        function touchstarted(event, ...args) {
            if (!filter.apply(this, arguments)) return;
            var touches = event.touches, n = touches.length, g = gesture(this, args, event.changedTouches.length === n).event(event), started, i, t, p;
            (0, _noeventJs.nopropagation)(event);
            for(i = 0; i < n; ++i){
                t = touches[i], p = (0, _d3Selection.pointer)(t, this);
                p = [
                    p,
                    this.__zoom.invert(p),
                    t.identifier
                ];
                if (!g.touch0) g.touch0 = p, started = true, g.taps = 1 + !!touchstarting;
                else if (!g.touch1 && g.touch0[2] !== p[2]) g.touch1 = p, g.taps = 0;
            }
            if (touchstarting) touchstarting = clearTimeout(touchstarting);
            if (started) {
                if (g.taps < 2) touchfirst = p[0], touchstarting = setTimeout(function() {
                    touchstarting = null;
                }, touchDelay);
                (0, _d3Transition.interrupt)(this);
                g.start();
            }
        }
        function touchmoved(event, ...args) {
            if (!this.__zooming) return;
            var g = gesture(this, args).event(event), touches = event.changedTouches, n = touches.length, i, t, p, l;
            (0, _noeventJsDefault.default)(event);
            for(i = 0; i < n; ++i){
                t = touches[i], p = (0, _d3Selection.pointer)(t, this);
                if (g.touch0 && g.touch0[2] === t.identifier) g.touch0[0] = p;
                else if (g.touch1 && g.touch1[2] === t.identifier) g.touch1[0] = p;
            }
            t = g.that.__zoom;
            if (g.touch1) {
                var p0 = g.touch0[0], l0 = g.touch0[1], p1 = g.touch1[0], l1 = g.touch1[1], dp = (dp = p1[0] - p0[0]) * dp + (dp = p1[1] - p0[1]) * dp, dl = (dl = l1[0] - l0[0]) * dl + (dl = l1[1] - l0[1]) * dl;
                t = scale(t, Math.sqrt(dp / dl));
                p = [
                    (p0[0] + p1[0]) / 2,
                    (p0[1] + p1[1]) / 2
                ];
                l = [
                    (l0[0] + l1[0]) / 2,
                    (l0[1] + l1[1]) / 2
                ];
            } else if (g.touch0) p = g.touch0[0], l = g.touch0[1];
            else return;
            g.zoom("touch", constrain(translate(t, p, l), g.extent, translateExtent));
        }
        function touchended(event, ...args) {
            if (!this.__zooming) return;
            var g = gesture(this, args).event(event), touches = event.changedTouches, n = touches.length, i, t;
            (0, _noeventJs.nopropagation)(event);
            if (touchending) clearTimeout(touchending);
            touchending = setTimeout(function() {
                touchending = null;
            }, touchDelay);
            for(i = 0; i < n; ++i){
                t = touches[i];
                if (g.touch0 && g.touch0[2] === t.identifier) delete g.touch0;
                else if (g.touch1 && g.touch1[2] === t.identifier) delete g.touch1;
            }
            if (g.touch1 && !g.touch0) g.touch0 = g.touch1, delete g.touch1;
            if (g.touch0) g.touch0[1] = this.__zoom.invert(g.touch0[0]);
            else {
                g.end();
                // If this was a dbltap, reroute to the (optional) dblclick.zoom handler.
                if (g.taps === 2) {
                    t = (0, _d3Selection.pointer)(t, this);
                    if (Math.hypot(touchfirst[0] - t[0], touchfirst[1] - t[1]) < tapDistance) {
                        var p = (0, _d3Selection.select)(this).on("dblclick.zoom");
                        if (p) p.apply(this, arguments);
                    }
                }
            }
        }
        zoom.wheelDelta = function(_) {
            return arguments.length ? (wheelDelta = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), zoom) : wheelDelta;
        };
        zoom.filter = function(_) {
            return arguments.length ? (filter = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(!!_), zoom) : filter;
        };
        zoom.touchable = function(_) {
            return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(!!_), zoom) : touchable;
        };
        zoom.extent = function(_) {
            return arguments.length ? (extent = typeof _ === "function" ? _ : (0, _constantJsDefault.default)([
                [
                    +_[0][0],
                    +_[0][1]
                ],
                [
                    +_[1][0],
                    +_[1][1]
                ]
            ]), zoom) : extent;
        };
        zoom.scaleExtent = function(_) {
            return arguments.length ? (scaleExtent[0] = +_[0], scaleExtent[1] = +_[1], zoom) : [
                scaleExtent[0],
                scaleExtent[1]
            ];
        };
        zoom.translateExtent = function(_) {
            return arguments.length ? (translateExtent[0][0] = +_[0][0], translateExtent[1][0] = +_[1][0], translateExtent[0][1] = +_[0][1], translateExtent[1][1] = +_[1][1], zoom) : [
                [
                    translateExtent[0][0],
                    translateExtent[0][1]
                ],
                [
                    translateExtent[1][0],
                    translateExtent[1][1]
                ]
            ];
        };
        zoom.constrain = function(_) {
            return arguments.length ? (constrain = _, zoom) : constrain;
        };
        zoom.duration = function(_) {
            return arguments.length ? (duration = +_, zoom) : duration;
        };
        zoom.interpolate = function(_) {
            return arguments.length ? (interpolate = _, zoom) : interpolate;
        };
        zoom.on = function() {
            var value = listeners.on.apply(listeners, arguments);
            return value === listeners ? zoom : value;
        };
        zoom.clickDistance = function(_) {
            return arguments.length ? (clickDistance2 = (_ = +_) * _, zoom) : Math.sqrt(clickDistance2);
        };
        zoom.tapDistance = function(_) {
            return arguments.length ? (tapDistance = +_, zoom) : tapDistance;
        };
        return zoom;
    });
var _d3Dispatch = require("d3-dispatch");
var _d3Drag = require("d3-drag");
var _d3Interpolate = require("d3-interpolate");
var _d3Selection = require("d3-selection");
var _d3Transition = require("d3-transition");
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _eventJs = require("./event.js");
var _eventJsDefault = parcelHelpers.interopDefault(_eventJs);
var _transformJs = require("./transform.js");
var _noeventJs = require("./noevent.js");
var _noeventJsDefault = parcelHelpers.interopDefault(_noeventJs);
// Ignore right-click, since that should open the context menu.
// except for pinch-to-zoom, which is sent as a wheel+ctrlKey event
function defaultFilter(event) {
    return (!event.ctrlKey || event.type === 'wheel') && !event.button;
}
function defaultExtent() {
    var e = this;
    if (e instanceof SVGElement) {
        e = e.ownerSVGElement || e;
        if (e.hasAttribute("viewBox")) {
            e = e.viewBox.baseVal;
            return [
                [
                    e.x,
                    e.y
                ],
                [
                    e.x + e.width,
                    e.y + e.height
                ]
            ];
        }
        return [
            [
                0,
                0
            ],
            [
                e.width.baseVal.value,
                e.height.baseVal.value
            ]
        ];
    }
    return [
        [
            0,
            0
        ],
        [
            e.clientWidth,
            e.clientHeight
        ]
    ];
}
function defaultTransform() {
    return this.__zoom || (0, _transformJs.identity);
}
function defaultWheelDelta(event) {
    return -event.deltaY * (event.deltaMode === 1 ? 0.05 : event.deltaMode ? 1 : 0.002) * (event.ctrlKey ? 10 : 1);
}
function defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
function defaultConstrain(transform, extent, translateExtent) {
    var dx0 = transform.invertX(extent[0][0]) - translateExtent[0][0], dx1 = transform.invertX(extent[1][0]) - translateExtent[1][0], dy0 = transform.invertY(extent[0][1]) - translateExtent[0][1], dy1 = transform.invertY(extent[1][1]) - translateExtent[1][1];
    return transform.translate(dx1 > dx0 ? (dx0 + dx1) / 2 : Math.min(0, dx0) || Math.max(0, dx1), dy1 > dy0 ? (dy0 + dy1) / 2 : Math.min(0, dy0) || Math.max(0, dy1));
}

},{"d3-dispatch":[["dispatch","avnlO","default"]],"d3-drag":[["dragDisable","2o3My","default"],["dragEnable","2o3My","yesdrag"]],"d3-interpolate":[["interpolateZoom","7BEmP","default"]],"d3-selection":[["pointer","04Hca","default"],["select","4CEQV","default"]],"d3-transition":"aUsOn","./constant.js":"bPwFS","./event.js":"a6d1t","./transform.js":"KmKi8","./noevent.js":"eC3Wp","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"avnlO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var noop = {
    value: ()=>{}
};
function dispatch() {
    for(var i = 0, n = arguments.length, _ = {}, t; i < n; ++i){
        if (!(t = arguments[i] + "") || t in _ || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
        _[t] = [];
    }
    return new Dispatch(_);
}
function Dispatch(_) {
    this._ = _;
}
function parseTypenames(typenames, types) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
        return {
            type: t,
            name: name
        };
    });
}
Dispatch.prototype = dispatch.prototype = {
    constructor: Dispatch,
    on: function(typename, callback) {
        var _ = this._, T = parseTypenames(typename + "", _), t, i = -1, n = T.length;
        // If no callback was specified, return the callback of the given type and name.
        if (arguments.length < 2) {
            while(++i < n)if ((t = (typename = T[i]).type) && (t = get(_[t], typename.name))) return t;
            return;
        }
        // If a type was specified, set the callback for the given type and name.
        // Otherwise, if a null callback was specified, remove callbacks of the given name.
        if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
        while(++i < n){
            if (t = (typename = T[i]).type) _[t] = set(_[t], typename.name, callback);
            else if (callback == null) for(t in _)_[t] = set(_[t], typename.name, null);
        }
        return this;
    },
    copy: function() {
        var copy = {}, _ = this._;
        for(var t in _)copy[t] = _[t].slice();
        return new Dispatch(copy);
    },
    call: function(type, that) {
        if ((n = arguments.length - 2) > 0) for(var args = new Array(n), i = 0, n, t; i < n; ++i)args[i] = arguments[i + 2];
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    },
    apply: function(type, that, args) {
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(var t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    }
};
function get(type, name) {
    for(var i = 0, n = type.length, c; i < n; ++i){
        if ((c = type[i]).name === name) return c.value;
    }
}
function set(type, name, callback) {
    for(var i = 0, n = type.length; i < n; ++i)if (type[i].name === name) {
        type[i] = noop, type = type.slice(0, i).concat(type.slice(i + 1));
        break;
    }
    if (callback != null) type.push({
        name: name,
        value: callback
    });
    return type;
}
exports.default = dispatch;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2o3My":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(view) {
        var root = view.document.documentElement, selection = (0, _d3Selection.select)(view).on("dragstart.drag", (0, _noeventJsDefault.default), (0, _noeventJs.nonpassivecapture));
        if ("onselectstart" in root) selection.on("selectstart.drag", (0, _noeventJsDefault.default), (0, _noeventJs.nonpassivecapture));
        else {
            root.__noselect = root.style.MozUserSelect;
            root.style.MozUserSelect = "none";
        }
    });
parcelHelpers.export(exports, "yesdrag", ()=>yesdrag);
var _d3Selection = require("d3-selection");
var _noeventJs = require("./noevent.js");
var _noeventJsDefault = parcelHelpers.interopDefault(_noeventJs);
function yesdrag(view, noclick) {
    var root = view.document.documentElement, selection = (0, _d3Selection.select)(view).on("dragstart.drag", null);
    if (noclick) {
        selection.on("click.drag", (0, _noeventJsDefault.default), (0, _noeventJs.nonpassivecapture));
        setTimeout(function() {
            selection.on("click.drag", null);
        }, 0);
    }
    if ("onselectstart" in root) selection.on("selectstart.drag", null);
    else {
        root.style.MozUserSelect = root.__noselect;
        delete root.__noselect;
    }
}

},{"d3-selection":[["select","4CEQV","default"]],"./noevent.js":"lC7cP","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4CEQV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(selector) {
        return typeof selector === "string" ? new (0, _indexJs.Selection)([
            [
                document.querySelector(selector)
            ]
        ], [
            document.documentElement
        ]) : new (0, _indexJs.Selection)([
            [
                selector
            ]
        ], (0, _indexJs.root));
    });
var _indexJs = require("./selection/index.js");

},{"./selection/index.js":"c44R6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"c44R6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "root", ()=>root);
parcelHelpers.export(exports, "Selection", ()=>Selection);
var _selectJs = require("./select.js");
var _selectJsDefault = parcelHelpers.interopDefault(_selectJs);
var _selectAllJs = require("./selectAll.js");
var _selectAllJsDefault = parcelHelpers.interopDefault(_selectAllJs);
var _selectChildJs = require("./selectChild.js");
var _selectChildJsDefault = parcelHelpers.interopDefault(_selectChildJs);
var _selectChildrenJs = require("./selectChildren.js");
var _selectChildrenJsDefault = parcelHelpers.interopDefault(_selectChildrenJs);
var _filterJs = require("./filter.js");
var _filterJsDefault = parcelHelpers.interopDefault(_filterJs);
var _dataJs = require("./data.js");
var _dataJsDefault = parcelHelpers.interopDefault(_dataJs);
var _enterJs = require("./enter.js");
var _enterJsDefault = parcelHelpers.interopDefault(_enterJs);
var _exitJs = require("./exit.js");
var _exitJsDefault = parcelHelpers.interopDefault(_exitJs);
var _joinJs = require("./join.js");
var _joinJsDefault = parcelHelpers.interopDefault(_joinJs);
var _mergeJs = require("./merge.js");
var _mergeJsDefault = parcelHelpers.interopDefault(_mergeJs);
var _orderJs = require("./order.js");
var _orderJsDefault = parcelHelpers.interopDefault(_orderJs);
var _sortJs = require("./sort.js");
var _sortJsDefault = parcelHelpers.interopDefault(_sortJs);
var _callJs = require("./call.js");
var _callJsDefault = parcelHelpers.interopDefault(_callJs);
var _nodesJs = require("./nodes.js");
var _nodesJsDefault = parcelHelpers.interopDefault(_nodesJs);
var _nodeJs = require("./node.js");
var _nodeJsDefault = parcelHelpers.interopDefault(_nodeJs);
var _sizeJs = require("./size.js");
var _sizeJsDefault = parcelHelpers.interopDefault(_sizeJs);
var _emptyJs = require("./empty.js");
var _emptyJsDefault = parcelHelpers.interopDefault(_emptyJs);
var _eachJs = require("./each.js");
var _eachJsDefault = parcelHelpers.interopDefault(_eachJs);
var _attrJs = require("./attr.js");
var _attrJsDefault = parcelHelpers.interopDefault(_attrJs);
var _styleJs = require("./style.js");
var _styleJsDefault = parcelHelpers.interopDefault(_styleJs);
var _propertyJs = require("./property.js");
var _propertyJsDefault = parcelHelpers.interopDefault(_propertyJs);
var _classedJs = require("./classed.js");
var _classedJsDefault = parcelHelpers.interopDefault(_classedJs);
var _textJs = require("./text.js");
var _textJsDefault = parcelHelpers.interopDefault(_textJs);
var _htmlJs = require("./html.js");
var _htmlJsDefault = parcelHelpers.interopDefault(_htmlJs);
var _raiseJs = require("./raise.js");
var _raiseJsDefault = parcelHelpers.interopDefault(_raiseJs);
var _lowerJs = require("./lower.js");
var _lowerJsDefault = parcelHelpers.interopDefault(_lowerJs);
var _appendJs = require("./append.js");
var _appendJsDefault = parcelHelpers.interopDefault(_appendJs);
var _insertJs = require("./insert.js");
var _insertJsDefault = parcelHelpers.interopDefault(_insertJs);
var _removeJs = require("./remove.js");
var _removeJsDefault = parcelHelpers.interopDefault(_removeJs);
var _cloneJs = require("./clone.js");
var _cloneJsDefault = parcelHelpers.interopDefault(_cloneJs);
var _datumJs = require("./datum.js");
var _datumJsDefault = parcelHelpers.interopDefault(_datumJs);
var _onJs = require("./on.js");
var _onJsDefault = parcelHelpers.interopDefault(_onJs);
var _dispatchJs = require("./dispatch.js");
var _dispatchJsDefault = parcelHelpers.interopDefault(_dispatchJs);
var _iteratorJs = require("./iterator.js");
var _iteratorJsDefault = parcelHelpers.interopDefault(_iteratorJs);
var root = [
    null
];
function Selection(groups, parents) {
    this._groups = groups;
    this._parents = parents;
}
function selection() {
    return new Selection([
        [
            document.documentElement
        ]
    ], root);
}
function selection_selection() {
    return this;
}
Selection.prototype = selection.prototype = {
    constructor: Selection,
    select: (0, _selectJsDefault.default),
    selectAll: (0, _selectAllJsDefault.default),
    selectChild: (0, _selectChildJsDefault.default),
    selectChildren: (0, _selectChildrenJsDefault.default),
    filter: (0, _filterJsDefault.default),
    data: (0, _dataJsDefault.default),
    enter: (0, _enterJsDefault.default),
    exit: (0, _exitJsDefault.default),
    join: (0, _joinJsDefault.default),
    merge: (0, _mergeJsDefault.default),
    selection: selection_selection,
    order: (0, _orderJsDefault.default),
    sort: (0, _sortJsDefault.default),
    call: (0, _callJsDefault.default),
    nodes: (0, _nodesJsDefault.default),
    node: (0, _nodeJsDefault.default),
    size: (0, _sizeJsDefault.default),
    empty: (0, _emptyJsDefault.default),
    each: (0, _eachJsDefault.default),
    attr: (0, _attrJsDefault.default),
    style: (0, _styleJsDefault.default),
    property: (0, _propertyJsDefault.default),
    classed: (0, _classedJsDefault.default),
    text: (0, _textJsDefault.default),
    html: (0, _htmlJsDefault.default),
    raise: (0, _raiseJsDefault.default),
    lower: (0, _lowerJsDefault.default),
    append: (0, _appendJsDefault.default),
    insert: (0, _insertJsDefault.default),
    remove: (0, _removeJsDefault.default),
    clone: (0, _cloneJsDefault.default),
    datum: (0, _datumJsDefault.default),
    on: (0, _onJsDefault.default),
    dispatch: (0, _dispatchJsDefault.default),
    [Symbol.iterator]: (0, _iteratorJsDefault.default)
};
exports.default = selection;

},{"./select.js":"jThnY","./selectAll.js":"BcdEF","./selectChild.js":"7cTWi","./selectChildren.js":"dlxsy","./filter.js":"kUYOE","./data.js":"fgP1j","./enter.js":"lmM9E","./exit.js":"2p8KH","./join.js":"daI42","./merge.js":"5vqne","./order.js":"c1xIF","./sort.js":"f4hiX","./call.js":"j3Hlh","./nodes.js":"9pWqB","./node.js":"7QU4v","./size.js":"9Ekbp","./empty.js":"iI41J","./each.js":"KNRWO","./attr.js":"i51aH","./style.js":"jEBVs","./property.js":"3F4kb","./classed.js":"8PX0y","./text.js":"i8K0e","./html.js":"i1OWe","./raise.js":"6PNKJ","./lower.js":"aZVnM","./append.js":"685tA","./insert.js":"gMCYh","./remove.js":"90pUx","./clone.js":"gtufo","./datum.js":"dvdJ8","./on.js":"lkgsT","./dispatch.js":"cwbD6","./iterator.js":"2FeiE","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jThnY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(select) {
        if (typeof select !== "function") select = (0, _selectorJsDefault.default)(select);
        for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
                if ("__data__" in node) subnode.__data__ = node.__data__;
                subgroup[i] = subnode;
            }
        }
        return new (0, _indexJs.Selection)(subgroups, this._parents);
    });
var _indexJs = require("./index.js");
var _selectorJs = require("../selector.js");
var _selectorJsDefault = parcelHelpers.interopDefault(_selectorJs);

},{"./index.js":"c44R6","../selector.js":"4I2PW","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4I2PW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(selector) {
        return selector == null ? none : function() {
            return this.querySelector(selector);
        };
    });
function none() {}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"BcdEF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(select) {
        if (typeof select === "function") select = arrayAll(select);
        else select = (0, _selectorAllJsDefault.default)(select);
        for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
                subgroups.push(select.call(node, node.__data__, i, group));
                parents.push(node);
            }
        }
        return new (0, _indexJs.Selection)(subgroups, parents);
    });
var _indexJs = require("./index.js");
var _arrayJs = require("../array.js");
var _arrayJsDefault = parcelHelpers.interopDefault(_arrayJs);
var _selectorAllJs = require("../selectorAll.js");
var _selectorAllJsDefault = parcelHelpers.interopDefault(_selectorAllJs);
function arrayAll(select) {
    return function() {
        return (0, _arrayJsDefault.default)(select.apply(this, arguments));
    };
}

},{"./index.js":"c44R6","../array.js":"2iarJ","../selectorAll.js":"9H6e7","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2iarJ":[function(require,module,exports,__globalThis) {
// Given something array like (or null), returns something that is strictly an
// array. This is used to ensure that array-like objects passed to d3.selectAll
// or selection.selectAll are converted into proper arrays when creating a
// selection; we don’t ever want to create a selection backed by a live
// HTMLCollection or NodeList. However, note that selection.selectAll will use a
// static NodeList as a group, since it safely derived from querySelectorAll.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>array);
function array(x) {
    return x == null ? [] : Array.isArray(x) ? x : Array.from(x);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9H6e7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(selector) {
        return selector == null ? empty : function() {
            return this.querySelectorAll(selector);
        };
    });
function empty() {
    return [];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7cTWi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(match) {
        return this.select(match == null ? childFirst : childFind(typeof match === "function" ? match : (0, _matcherJs.childMatcher)(match)));
    });
var _matcherJs = require("../matcher.js");
var find = Array.prototype.find;
function childFind(match) {
    return function() {
        return find.call(this.children, match);
    };
}
function childFirst() {
    return this.firstElementChild;
}

},{"../matcher.js":"iOc8r","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iOc8r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(selector) {
        return function() {
            return this.matches(selector);
        };
    });
parcelHelpers.export(exports, "childMatcher", ()=>childMatcher);
function childMatcher(selector) {
    return function(node) {
        return node.matches(selector);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dlxsy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(match) {
        return this.selectAll(match == null ? children : childrenFilter(typeof match === "function" ? match : (0, _matcherJs.childMatcher)(match)));
    });
var _matcherJs = require("../matcher.js");
var filter = Array.prototype.filter;
function children() {
    return Array.from(this.children);
}
function childrenFilter(match) {
    return function() {
        return filter.call(this.children, match);
    };
}

},{"../matcher.js":"iOc8r","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kUYOE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(match) {
        if (typeof match !== "function") match = (0, _matcherJsDefault.default)(match);
        for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
        }
        return new (0, _indexJs.Selection)(subgroups, this._parents);
    });
var _indexJs = require("./index.js");
var _matcherJs = require("../matcher.js");
var _matcherJsDefault = parcelHelpers.interopDefault(_matcherJs);

},{"./index.js":"c44R6","../matcher.js":"iOc8r","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fgP1j":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value, key) {
        if (!arguments.length) return Array.from(this, datum);
        var bind = key ? bindKey : bindIndex, parents = this._parents, groups = this._groups;
        if (typeof value !== "function") value = (0, _constantJsDefault.default)(value);
        for(var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j){
            var parent = parents[j], group = groups[j], groupLength = group.length, data = arraylike(value.call(parent, parent && parent.__data__, j, parents)), dataLength = data.length, enterGroup = enter[j] = new Array(dataLength), updateGroup = update[j] = new Array(dataLength), exitGroup = exit[j] = new Array(groupLength);
            bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);
            // Now connect the enter nodes to their following update node, such that
            // appendChild can insert the materialized enter node before this node,
            // rather than at the end of the parent node.
            for(var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0)if (previous = enterGroup[i0]) {
                if (i0 >= i1) i1 = i0 + 1;
                while(!(next = updateGroup[i1]) && ++i1 < dataLength);
                previous._next = next || null;
            }
        }
        update = new (0, _indexJs.Selection)(update, parents);
        update._enter = enter;
        update._exit = exit;
        return update;
    });
var _indexJs = require("./index.js");
var _enterJs = require("./enter.js");
var _constantJs = require("../constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
function bindIndex(parent, group, enter, update, exit, data) {
    var i = 0, node, groupLength = group.length, dataLength = data.length;
    // Put any non-null nodes that fit into update.
    // Put any null nodes into enter.
    // Put any remaining data into enter.
    for(; i < dataLength; ++i)if (node = group[i]) {
        node.__data__ = data[i];
        update[i] = node;
    } else enter[i] = new (0, _enterJs.EnterNode)(parent, data[i]);
    // Put any non-null nodes that don’t fit into exit.
    for(; i < groupLength; ++i)if (node = group[i]) exit[i] = node;
}
function bindKey(parent, group, enter, update, exit, data, key) {
    var i, node, nodeByKeyValue = new Map, groupLength = group.length, dataLength = data.length, keyValues = new Array(groupLength), keyValue;
    // Compute the key for each node.
    // If multiple nodes have the same key, the duplicates are added to exit.
    for(i = 0; i < groupLength; ++i)if (node = group[i]) {
        keyValues[i] = keyValue = key.call(node, node.__data__, i, group) + "";
        if (nodeByKeyValue.has(keyValue)) exit[i] = node;
        else nodeByKeyValue.set(keyValue, node);
    }
    // Compute the key for each datum.
    // If there a node associated with this key, join and add it to update.
    // If there is not (or the key is a duplicate), add it to enter.
    for(i = 0; i < dataLength; ++i){
        keyValue = key.call(parent, data[i], i, data) + "";
        if (node = nodeByKeyValue.get(keyValue)) {
            update[i] = node;
            node.__data__ = data[i];
            nodeByKeyValue.delete(keyValue);
        } else enter[i] = new (0, _enterJs.EnterNode)(parent, data[i]);
    }
    // Add any remaining nodes that were not bound to data to exit.
    for(i = 0; i < groupLength; ++i)if ((node = group[i]) && nodeByKeyValue.get(keyValues[i]) === node) exit[i] = node;
}
function datum(node) {
    return node.__data__;
}
// Given some data, this returns an array-like view of it: an object that
// exposes a length property and allows numeric indexing. Note that unlike
// selectAll, this isn’t worried about “live” collections because the resulting
// array will only be used briefly while data is being bound. (It is possible to
// cause the data to change while iterating by using a key function, but please
// don’t; we’d rather avoid a gratuitous copy.)
function arraylike(data) {
    return typeof data === "object" && "length" in data ? data // Array, TypedArray, NodeList, array-like
     : Array.from(data); // Map, Set, iterable, string, or anything else
}

},{"./index.js":"c44R6","./enter.js":"lmM9E","../constant.js":"7old4","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lmM9E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return new (0, _indexJs.Selection)(this._enter || this._groups.map((0, _sparseJsDefault.default)), this._parents);
    });
parcelHelpers.export(exports, "EnterNode", ()=>EnterNode);
var _sparseJs = require("./sparse.js");
var _sparseJsDefault = parcelHelpers.interopDefault(_sparseJs);
var _indexJs = require("./index.js");
function EnterNode(parent, datum) {
    this.ownerDocument = parent.ownerDocument;
    this.namespaceURI = parent.namespaceURI;
    this._next = null;
    this._parent = parent;
    this.__data__ = datum;
}
EnterNode.prototype = {
    constructor: EnterNode,
    appendChild: function(child) {
        return this._parent.insertBefore(child, this._next);
    },
    insertBefore: function(child, next) {
        return this._parent.insertBefore(child, next);
    },
    querySelector: function(selector) {
        return this._parent.querySelector(selector);
    },
    querySelectorAll: function(selector) {
        return this._parent.querySelectorAll(selector);
    }
};

},{"./sparse.js":"5bra5","./index.js":"c44R6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5bra5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(update) {
        return new Array(update.length);
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7old4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return function() {
            return x;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2p8KH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return new (0, _indexJs.Selection)(this._exit || this._groups.map((0, _sparseJsDefault.default)), this._parents);
    });
var _sparseJs = require("./sparse.js");
var _sparseJsDefault = parcelHelpers.interopDefault(_sparseJs);
var _indexJs = require("./index.js");

},{"./sparse.js":"5bra5","./index.js":"c44R6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"daI42":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(onenter, onupdate, onexit) {
        var enter = this.enter(), update = this, exit = this.exit();
        if (typeof onenter === "function") {
            enter = onenter(enter);
            if (enter) enter = enter.selection();
        } else enter = enter.append(onenter + "");
        if (onupdate != null) {
            update = onupdate(update);
            if (update) update = update.selection();
        }
        if (onexit == null) exit.remove();
        else onexit(exit);
        return enter && update ? enter.merge(update).order() : update;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5vqne":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(context) {
        var selection = context.selection ? context.selection() : context;
        for(var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
            for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
        }
        for(; j < m0; ++j)merges[j] = groups0[j];
        return new (0, _indexJs.Selection)(merges, this._parents);
    });
var _indexJs = require("./index.js");

},{"./index.js":"c44R6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"c1xIF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        for(var groups = this._groups, j = -1, m = groups.length; ++j < m;){
            for(var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;)if (node = group[i]) {
                if (next && node.compareDocumentPosition(next) ^ 4) next.parentNode.insertBefore(node, next);
                next = node;
            }
        }
        return this;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"f4hiX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(compare) {
        if (!compare) compare = ascending;
        function compareNode(a, b) {
            return a && b ? compare(a.__data__, b.__data__) : !a - !b;
        }
        for(var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group[i]) sortgroup[i] = node;
            sortgroup.sort(compareNode);
        }
        return new (0, _indexJs.Selection)(sortgroups, this._parents).order();
    });
var _indexJs = require("./index.js");
function ascending(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

},{"./index.js":"c44R6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"j3Hlh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var callback = arguments[0];
        arguments[0] = this;
        callback.apply(null, arguments);
        return this;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9pWqB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return Array.from(this);
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7QU4v":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j)for(var group = groups[j], i = 0, n = group.length; i < n; ++i){
            var node = group[i];
            if (node) return node;
        }
        return null;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9Ekbp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        let size = 0;
        for (const node of this)++size; // eslint-disable-line no-unused-vars
        return size;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iI41J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return !this.node();
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"KNRWO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(callback) {
        for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
            for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) callback.call(node, node.__data__, i, group);
        }
        return this;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"i51aH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, value) {
        var fullname = (0, _namespaceJsDefault.default)(name);
        if (arguments.length < 2) {
            var node = this.node();
            return fullname.local ? node.getAttributeNS(fullname.space, fullname.local) : node.getAttribute(fullname);
        }
        return this.each((value == null ? fullname.local ? attrRemoveNS : attrRemove : typeof value === "function" ? fullname.local ? attrFunctionNS : attrFunction : fullname.local ? attrConstantNS : attrConstant)(fullname, value));
    });
var _namespaceJs = require("../namespace.js");
var _namespaceJsDefault = parcelHelpers.interopDefault(_namespaceJs);
function attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function attrConstant(name, value) {
    return function() {
        this.setAttribute(name, value);
    };
}
function attrConstantNS(fullname, value) {
    return function() {
        this.setAttributeNS(fullname.space, fullname.local, value);
    };
}
function attrFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttribute(name);
        else this.setAttribute(name, v);
    };
}
function attrFunctionNS(fullname, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
        else this.setAttributeNS(fullname.space, fullname.local, v);
    };
}

},{"../namespace.js":"e2lf9","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"e2lf9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name) {
        var prefix = name += "", i = prefix.indexOf(":");
        if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
        return (0, _namespacesJsDefault.default).hasOwnProperty(prefix) ? {
            space: (0, _namespacesJsDefault.default)[prefix],
            local: name
        } : name; // eslint-disable-line no-prototype-builtins
    });
var _namespacesJs = require("./namespaces.js");
var _namespacesJsDefault = parcelHelpers.interopDefault(_namespacesJs);

},{"./namespaces.js":"eaqJV","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eaqJV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "xhtml", ()=>xhtml);
var xhtml = "http://www.w3.org/1999/xhtml";
exports.default = {
    svg: "http://www.w3.org/2000/svg",
    xhtml: xhtml,
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace",
    xmlns: "http://www.w3.org/2000/xmlns/"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jEBVs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, value, priority) {
        return arguments.length > 1 ? this.each((value == null ? styleRemove : typeof value === "function" ? styleFunction : styleConstant)(name, value, priority == null ? "" : priority)) : styleValue(this.node(), name);
    });
parcelHelpers.export(exports, "styleValue", ()=>styleValue);
var _windowJs = require("../window.js");
var _windowJsDefault = parcelHelpers.interopDefault(_windowJs);
function styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function styleConstant(name, value, priority) {
    return function() {
        this.style.setProperty(name, value, priority);
    };
}
function styleFunction(name, value, priority) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.style.removeProperty(name);
        else this.style.setProperty(name, v, priority);
    };
}
function styleValue(node, name) {
    return node.style.getPropertyValue(name) || (0, _windowJsDefault.default)(node).getComputedStyle(node, null).getPropertyValue(name);
}

},{"../window.js":"esh79","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"esh79":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(node) {
        return node.ownerDocument && node.ownerDocument.defaultView // node is a Node
         || node.document && node // node is a Window
         || node.defaultView; // node is a Document
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3F4kb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, value) {
        return arguments.length > 1 ? this.each((value == null ? propertyRemove : typeof value === "function" ? propertyFunction : propertyConstant)(name, value)) : this.node()[name];
    });
function propertyRemove(name) {
    return function() {
        delete this[name];
    };
}
function propertyConstant(name, value) {
    return function() {
        this[name] = value;
    };
}
function propertyFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) delete this[name];
        else this[name] = v;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8PX0y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, value) {
        var names = classArray(name + "");
        if (arguments.length < 2) {
            var list = classList(this.node()), i = -1, n = names.length;
            while(++i < n)if (!list.contains(names[i])) return false;
            return true;
        }
        return this.each((typeof value === "function" ? classedFunction : value ? classedTrue : classedFalse)(names, value));
    });
function classArray(string) {
    return string.trim().split(/^|\s+/);
}
function classList(node) {
    return node.classList || new ClassList(node);
}
function ClassList(node) {
    this._node = node;
    this._names = classArray(node.getAttribute("class") || "");
}
ClassList.prototype = {
    add: function(name) {
        var i = this._names.indexOf(name);
        if (i < 0) {
            this._names.push(name);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    remove: function(name) {
        var i = this._names.indexOf(name);
        if (i >= 0) {
            this._names.splice(i, 1);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    contains: function(name) {
        return this._names.indexOf(name) >= 0;
    }
};
function classedAdd(node, names) {
    var list = classList(node), i = -1, n = names.length;
    while(++i < n)list.add(names[i]);
}
function classedRemove(node, names) {
    var list = classList(node), i = -1, n = names.length;
    while(++i < n)list.remove(names[i]);
}
function classedTrue(names) {
    return function() {
        classedAdd(this, names);
    };
}
function classedFalse(names) {
    return function() {
        classedRemove(this, names);
    };
}
function classedFunction(names, value) {
    return function() {
        (value.apply(this, arguments) ? classedAdd : classedRemove)(this, names);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"i8K0e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        return arguments.length ? this.each(value == null ? textRemove : (typeof value === "function" ? textFunction : textConstant)(value)) : this.node().textContent;
    });
function textRemove() {
    this.textContent = "";
}
function textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function textFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.textContent = v == null ? "" : v;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"i1OWe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        return arguments.length ? this.each(value == null ? htmlRemove : (typeof value === "function" ? htmlFunction : htmlConstant)(value)) : this.node().innerHTML;
    });
function htmlRemove() {
    this.innerHTML = "";
}
function htmlConstant(value) {
    return function() {
        this.innerHTML = value;
    };
}
function htmlFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.innerHTML = v == null ? "" : v;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6PNKJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return this.each(raise);
    });
function raise() {
    if (this.nextSibling) this.parentNode.appendChild(this);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aZVnM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return this.each(lower);
    });
function lower() {
    if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"685tA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name) {
        var create = typeof name === "function" ? name : (0, _creatorJsDefault.default)(name);
        return this.select(function() {
            return this.appendChild(create.apply(this, arguments));
        });
    });
var _creatorJs = require("../creator.js");
var _creatorJsDefault = parcelHelpers.interopDefault(_creatorJs);

},{"../creator.js":"8Llrx","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8Llrx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name) {
        var fullname = (0, _namespaceJsDefault.default)(name);
        return (fullname.local ? creatorFixed : creatorInherit)(fullname);
    });
var _namespaceJs = require("./namespace.js");
var _namespaceJsDefault = parcelHelpers.interopDefault(_namespaceJs);
var _namespacesJs = require("./namespaces.js");
function creatorInherit(name) {
    return function() {
        var document = this.ownerDocument, uri = this.namespaceURI;
        return uri === (0, _namespacesJs.xhtml) && document.documentElement.namespaceURI === (0, _namespacesJs.xhtml) ? document.createElement(name) : document.createElementNS(uri, name);
    };
}
function creatorFixed(fullname) {
    return function() {
        return this.ownerDocument.createElementNS(fullname.space, fullname.local);
    };
}

},{"./namespace.js":"e2lf9","./namespaces.js":"eaqJV","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gMCYh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, before) {
        var create = typeof name === "function" ? name : (0, _creatorJsDefault.default)(name), select = before == null ? constantNull : typeof before === "function" ? before : (0, _selectorJsDefault.default)(before);
        return this.select(function() {
            return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
        });
    });
var _creatorJs = require("../creator.js");
var _creatorJsDefault = parcelHelpers.interopDefault(_creatorJs);
var _selectorJs = require("../selector.js");
var _selectorJsDefault = parcelHelpers.interopDefault(_selectorJs);
function constantNull() {
    return null;
}

},{"../creator.js":"8Llrx","../selector.js":"4I2PW","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"90pUx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return this.each(remove);
    });
function remove() {
    var parent = this.parentNode;
    if (parent) parent.removeChild(this);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gtufo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(deep) {
        return this.select(deep ? selection_cloneDeep : selection_cloneShallow);
    });
function selection_cloneShallow() {
    var clone = this.cloneNode(false), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function selection_cloneDeep() {
    var clone = this.cloneNode(true), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dvdJ8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        return arguments.length ? this.property("__data__", value) : this.node().__data__;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lkgsT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(typename, value, options) {
        var typenames = parseTypenames(typename + ""), i, n = typenames.length, t;
        if (arguments.length < 2) {
            var on = this.node().__on;
            if (on) for(var j = 0, m = on.length, o; j < m; ++j)for(i = 0, o = on[j]; i < n; ++i){
                if ((t = typenames[i]).type === o.type && t.name === o.name) return o.value;
            }
            return;
        }
        on = value ? onAdd : onRemove;
        for(i = 0; i < n; ++i)this.each(on(typenames[i], value, options));
        return this;
    });
function contextListener(listener) {
    return function(event) {
        listener.call(this, event, this.__data__);
    };
}
function parseTypenames(typenames) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        return {
            type: t,
            name: name
        };
    });
}
function onRemove(typename) {
    return function() {
        var on = this.__on;
        if (!on) return;
        for(var j = 0, i = -1, m = on.length, o; j < m; ++j)if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) this.removeEventListener(o.type, o.listener, o.options);
        else on[++i] = o;
        if (++i) on.length = i;
        else delete this.__on;
    };
}
function onAdd(typename, value, options) {
    return function() {
        var on = this.__on, o, listener = contextListener(value);
        if (on) {
            for(var j = 0, m = on.length; j < m; ++j)if ((o = on[j]).type === typename.type && o.name === typename.name) {
                this.removeEventListener(o.type, o.listener, o.options);
                this.addEventListener(o.type, o.listener = listener, o.options = options);
                o.value = value;
                return;
            }
        }
        this.addEventListener(typename.type, listener, options);
        o = {
            type: typename.type,
            name: typename.name,
            value: value,
            listener: listener,
            options: options
        };
        if (!on) this.__on = [
            o
        ];
        else on.push(o);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cwbD6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(type, params) {
        return this.each((typeof params === "function" ? dispatchFunction : dispatchConstant)(type, params));
    });
var _windowJs = require("../window.js");
var _windowJsDefault = parcelHelpers.interopDefault(_windowJs);
function dispatchEvent(node, type, params) {
    var window = (0, _windowJsDefault.default)(node), event = window.CustomEvent;
    if (typeof event === "function") event = new event(type, params);
    else {
        event = window.document.createEvent("Event");
        if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
        else event.initEvent(type, false, false);
    }
    node.dispatchEvent(event);
}
function dispatchConstant(type, params) {
    return function() {
        return dispatchEvent(this, type, params);
    };
}
function dispatchFunction(type, params) {
    return function() {
        return dispatchEvent(this, type, params.apply(this, arguments));
    };
}

},{"../window.js":"esh79","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2FeiE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function*() {
        for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
            for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) yield node;
        }
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lC7cP":[function(require,module,exports,__globalThis) {
// These are typically used in conjunction with noevent to ensure that we can
// preventDefault on the event.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "nonpassive", ()=>nonpassive);
parcelHelpers.export(exports, "nonpassivecapture", ()=>nonpassivecapture);
parcelHelpers.export(exports, "nopropagation", ()=>nopropagation);
parcelHelpers.export(exports, "default", ()=>function(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
    });
const nonpassive = {
    passive: false
};
const nonpassivecapture = {
    capture: true,
    passive: false
};
function nopropagation(event) {
    event.stopImmediatePropagation();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7BEmP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var epsilon2 = 1e-12;
function cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
}
function sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
}
function tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}
exports.default = function zoomRho(rho, rho2, rho4) {
    // p0 = [ux0, uy0, w0]
    // p1 = [ux1, uy1, w1]
    function zoom(p0, p1) {
        var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
        // Special case for u0 ≅ u1.
        if (d2 < epsilon2) {
            S = Math.log(w1 / w0) / rho;
            i = function(t) {
                return [
                    ux0 + t * dx,
                    uy0 + t * dy,
                    w0 * Math.exp(rho * t * S)
                ];
            };
        } else {
            var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1), b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
            S = (r1 - r0) / rho;
            i = function(t) {
                var s = t * S, coshr0 = cosh(r0), u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
                return [
                    ux0 + u * dx,
                    uy0 + u * dy,
                    w0 * coshr0 / cosh(rho * s + r0)
                ];
            };
        }
        i.duration = S * 1000 * rho / Math.SQRT2;
        return i;
    }
    zoom.rho = function(_) {
        var _1 = Math.max(1e-3, +_), _2 = _1 * _1, _4 = _2 * _2;
        return zoomRho(_1, _2, _4);
    };
    return zoom;
}(Math.SQRT2, 2, 4);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"04Hca":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(event, node) {
        event = (0, _sourceEventJsDefault.default)(event);
        if (node === undefined) node = event.currentTarget;
        if (node) {
            var svg = node.ownerSVGElement || node;
            if (svg.createSVGPoint) {
                var point = svg.createSVGPoint();
                point.x = event.clientX, point.y = event.clientY;
                point = point.matrixTransform(node.getScreenCTM().inverse());
                return [
                    point.x,
                    point.y
                ];
            }
            if (node.getBoundingClientRect) {
                var rect = node.getBoundingClientRect();
                return [
                    event.clientX - rect.left - node.clientLeft,
                    event.clientY - rect.top - node.clientTop
                ];
            }
        }
        return [
            event.pageX,
            event.pageY
        ];
    });
var _sourceEventJs = require("./sourceEvent.js");
var _sourceEventJsDefault = parcelHelpers.interopDefault(_sourceEventJs);

},{"./sourceEvent.js":"awReS","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"awReS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(event) {
        let sourceEvent;
        while(sourceEvent = event.sourceEvent)event = sourceEvent;
        return event;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aUsOn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "transition", ()=>(0, _indexJsDefault.default));
parcelHelpers.export(exports, "active", ()=>(0, _activeJsDefault.default));
parcelHelpers.export(exports, "interrupt", ()=>(0, _interruptJsDefault.default));
var _indexJs = require("./selection/index.js");
var _indexJs1 = require("./transition/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs1);
var _activeJs = require("./active.js");
var _activeJsDefault = parcelHelpers.interopDefault(_activeJs);
var _interruptJs = require("./interrupt.js");
var _interruptJsDefault = parcelHelpers.interopDefault(_interruptJs);

},{"./selection/index.js":"kbAB7","./transition/index.js":false,"./active.js":false,"./interrupt.js":"1GwKS","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kbAB7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _d3Selection = require("d3-selection");
var _interruptJs = require("./interrupt.js");
var _interruptJsDefault = parcelHelpers.interopDefault(_interruptJs);
var _transitionJs = require("./transition.js");
var _transitionJsDefault = parcelHelpers.interopDefault(_transitionJs);
(0, _d3Selection.selection).prototype.interrupt = (0, _interruptJsDefault.default);
(0, _d3Selection.selection).prototype.transition = (0, _transitionJsDefault.default);

},{"d3-selection":[["selection","c44R6","default"]],"./interrupt.js":"6Q4h6","./transition.js":"4zdbY","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6Q4h6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name) {
        return this.each(function() {
            (0, _interruptJsDefault.default)(this, name);
        });
    });
var _interruptJs = require("../interrupt.js");
var _interruptJsDefault = parcelHelpers.interopDefault(_interruptJs);

},{"../interrupt.js":"1GwKS","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1GwKS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(node, name) {
        var schedules = node.__transition, schedule, active, empty = true, i;
        if (!schedules) return;
        name = name == null ? null : name + "";
        for(i in schedules){
            if ((schedule = schedules[i]).name !== name) {
                empty = false;
                continue;
            }
            active = schedule.state > (0, _scheduleJs.STARTING) && schedule.state < (0, _scheduleJs.ENDING);
            schedule.state = (0, _scheduleJs.ENDED);
            schedule.timer.stop();
            schedule.on.call(active ? "interrupt" : "cancel", node, node.__data__, schedule.index, schedule.group);
            delete schedules[i];
        }
        if (empty) delete node.__transition;
    });
var _scheduleJs = require("./transition/schedule.js");

},{"./transition/schedule.js":"1oCbn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1oCbn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CREATED", ()=>CREATED);
parcelHelpers.export(exports, "SCHEDULED", ()=>SCHEDULED);
parcelHelpers.export(exports, "STARTING", ()=>STARTING);
parcelHelpers.export(exports, "STARTED", ()=>STARTED);
parcelHelpers.export(exports, "RUNNING", ()=>RUNNING);
parcelHelpers.export(exports, "ENDING", ()=>ENDING);
parcelHelpers.export(exports, "ENDED", ()=>ENDED);
parcelHelpers.export(exports, "default", ()=>function(node, name, id, index, group, timing) {
        var schedules = node.__transition;
        if (!schedules) node.__transition = {};
        else if (id in schedules) return;
        create(node, id, {
            name: name,
            index: index,
            group: group,
            on: emptyOn,
            tween: emptyTween,
            time: timing.time,
            delay: timing.delay,
            duration: timing.duration,
            ease: timing.ease,
            timer: null,
            state: CREATED
        });
    });
parcelHelpers.export(exports, "init", ()=>init);
parcelHelpers.export(exports, "set", ()=>set);
parcelHelpers.export(exports, "get", ()=>get);
var _d3Dispatch = require("d3-dispatch");
var _d3Timer = require("d3-timer");
var emptyOn = (0, _d3Dispatch.dispatch)("start", "end", "cancel", "interrupt");
var emptyTween = [];
var CREATED = 0;
var SCHEDULED = 1;
var STARTING = 2;
var STARTED = 3;
var RUNNING = 4;
var ENDING = 5;
var ENDED = 6;
function init(node, id) {
    var schedule = get(node, id);
    if (schedule.state > CREATED) throw new Error("too late; already scheduled");
    return schedule;
}
function set(node, id) {
    var schedule = get(node, id);
    if (schedule.state > STARTED) throw new Error("too late; already running");
    return schedule;
}
function get(node, id) {
    var schedule = node.__transition;
    if (!schedule || !(schedule = schedule[id])) throw new Error("transition not found");
    return schedule;
}
function create(node, id, self) {
    var schedules = node.__transition, tween;
    // Initialize the self timer when the transition is created.
    // Note the actual delay is not known until the first callback!
    schedules[id] = self;
    self.timer = (0, _d3Timer.timer)(schedule, 0, self.time);
    function schedule(elapsed) {
        self.state = SCHEDULED;
        self.timer.restart(start, self.delay, self.time);
        // If the elapsed delay is less than our first sleep, start immediately.
        if (self.delay <= elapsed) start(elapsed - self.delay);
    }
    function start(elapsed) {
        var i, j, n, o;
        // If the state is not SCHEDULED, then we previously errored on start.
        if (self.state !== SCHEDULED) return stop();
        for(i in schedules){
            o = schedules[i];
            if (o.name !== self.name) continue;
            // While this element already has a starting transition during this frame,
            // defer starting an interrupting transition until that transition has a
            // chance to tick (and possibly end); see d3/d3-transition#54!
            if (o.state === STARTED) return (0, _d3Timer.timeout)(start);
            // Interrupt the active transition, if any.
            if (o.state === RUNNING) {
                o.state = ENDED;
                o.timer.stop();
                o.on.call("interrupt", node, node.__data__, o.index, o.group);
                delete schedules[i];
            } else if (+i < id) {
                o.state = ENDED;
                o.timer.stop();
                o.on.call("cancel", node, node.__data__, o.index, o.group);
                delete schedules[i];
            }
        }
        // Defer the first tick to end of the current frame; see d3/d3#1576.
        // Note the transition may be canceled after start and before the first tick!
        // Note this must be scheduled before the start event; see d3/d3-transition#16!
        // Assuming this is successful, subsequent callbacks go straight to tick.
        (0, _d3Timer.timeout)(function() {
            if (self.state === STARTED) {
                self.state = RUNNING;
                self.timer.restart(tick, self.delay, self.time);
                tick(elapsed);
            }
        });
        // Dispatch the start event.
        // Note this must be done before the tween are initialized.
        self.state = STARTING;
        self.on.call("start", node, node.__data__, self.index, self.group);
        if (self.state !== STARTING) return; // interrupted
        self.state = STARTED;
        // Initialize the tween, deleting null tween.
        tween = new Array(n = self.tween.length);
        for(i = 0, j = -1; i < n; ++i)if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) tween[++j] = o;
        tween.length = j + 1;
    }
    function tick(elapsed) {
        var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = ENDING, 1), i = -1, n = tween.length;
        while(++i < n)tween[i].call(node, t);
        // Dispatch the end event.
        if (self.state === ENDING) {
            self.on.call("end", node, node.__data__, self.index, self.group);
            stop();
        }
    }
    function stop() {
        self.state = ENDED;
        self.timer.stop();
        delete schedules[id];
        for(var i in schedules)return; // eslint-disable-line no-unused-vars
        delete node.__transition;
    }
}

},{"d3-dispatch":[["dispatch","avnlO","default"]],"d3-timer":[["timeout","gA1Vs","default"],["timer","bgtMb"]],"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gA1Vs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(callback, delay, time) {
        var t = new (0, _timerJs.Timer);
        delay = delay == null ? 0 : +delay;
        t.restart((elapsed)=>{
            t.stop();
            callback(elapsed + delay);
        }, delay, time);
        return t;
    });
var _timerJs = require("./timer.js");

},{"./timer.js":"bgtMb","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bgtMb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "now", ()=>now);
parcelHelpers.export(exports, "Timer", ()=>Timer);
parcelHelpers.export(exports, "timer", ()=>timer);
parcelHelpers.export(exports, "timerFlush", ()=>timerFlush);
var frame = 0, timeout = 0, interval = 0, pokeDelay = 1000, taskHead, taskTail, clockLast = 0, clockNow = 0, clockSkew = 0, clock = typeof performance === "object" && performance.now ? performance : Date, setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) {
    setTimeout(f, 17);
};
function now() {
    return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
}
function clearNow() {
    clockNow = 0;
}
function Timer() {
    this._call = this._time = this._next = null;
}
Timer.prototype = timer.prototype = {
    constructor: Timer,
    restart: function(callback, delay, time) {
        if (typeof callback !== "function") throw new TypeError("callback is not a function");
        time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);
        if (!this._next && taskTail !== this) {
            if (taskTail) taskTail._next = this;
            else taskHead = this;
            taskTail = this;
        }
        this._call = callback;
        this._time = time;
        sleep();
    },
    stop: function() {
        if (this._call) {
            this._call = null;
            this._time = Infinity;
            sleep();
        }
    }
};
function timer(callback, delay, time) {
    var t = new Timer;
    t.restart(callback, delay, time);
    return t;
}
function timerFlush() {
    now(); // Get the current time, if not already set.
    ++frame; // Pretend we’ve set an alarm, if we haven’t already.
    var t = taskHead, e;
    while(t){
        if ((e = clockNow - t._time) >= 0) t._call.call(undefined, e);
        t = t._next;
    }
    --frame;
}
function wake() {
    clockNow = (clockLast = clock.now()) + clockSkew;
    frame = timeout = 0;
    try {
        timerFlush();
    } finally{
        frame = 0;
        nap();
        clockNow = 0;
    }
}
function poke() {
    var now = clock.now(), delay = now - clockLast;
    if (delay > pokeDelay) clockSkew -= delay, clockLast = now;
}
function nap() {
    var t0, t1 = taskHead, t2, time = Infinity;
    while(t1)if (t1._call) {
        if (time > t1._time) time = t1._time;
        t0 = t1, t1 = t1._next;
    } else {
        t2 = t1._next, t1._next = null;
        t1 = t0 ? t0._next = t2 : taskHead = t2;
    }
    taskTail = t0;
    sleep(time);
}
function sleep(time) {
    if (frame) return; // Soonest alarm already set, or will be.
    if (timeout) timeout = clearTimeout(timeout);
    var delay = time - clockNow; // Strictly less than if we recomputed clockNow.
    if (delay > 24) {
        if (time < Infinity) timeout = setTimeout(wake, time - clock.now() - clockSkew);
        if (interval) interval = clearInterval(interval);
    } else {
        if (!interval) clockLast = clock.now(), interval = setInterval(poke, pokeDelay);
        frame = 1, setFrame(wake);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4zdbY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name) {
        var id, timing;
        if (name instanceof (0, _indexJs.Transition)) id = name._id, name = name._name;
        else id = (0, _indexJs.newId)(), (timing = defaultTiming).time = (0, _d3Timer.now)(), name = name == null ? null : name + "";
        for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) (0, _scheduleJsDefault.default)(node, name, id, i, group, timing || inherit(node, id));
        }
        return new (0, _indexJs.Transition)(groups, this._parents, name, id);
    });
var _indexJs = require("../transition/index.js");
var _scheduleJs = require("../transition/schedule.js");
var _scheduleJsDefault = parcelHelpers.interopDefault(_scheduleJs);
var _d3Ease = require("d3-ease");
var _d3Timer = require("d3-timer");
var defaultTiming = {
    time: null,
    delay: 0,
    duration: 250,
    ease: (0, _d3Ease.easeCubicInOut)
};
function inherit(node, id) {
    var timing;
    while(!(timing = node.__transition) || !(timing = timing[id])){
        if (!(node = node.parentNode)) throw new Error(`transition ${id} not found`);
    }
    return timing;
}

},{"../transition/index.js":"aaeaM","../transition/schedule.js":"1oCbn","d3-ease":[["easeCubicInOut","eWkjr","cubicInOut"]],"d3-timer":"bgtMb","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aaeaM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Transition", ()=>Transition);
parcelHelpers.export(exports, "default", ()=>transition);
parcelHelpers.export(exports, "newId", ()=>newId);
var _d3Selection = require("d3-selection");
var _attrJs = require("./attr.js");
var _attrJsDefault = parcelHelpers.interopDefault(_attrJs);
var _attrTweenJs = require("./attrTween.js");
var _attrTweenJsDefault = parcelHelpers.interopDefault(_attrTweenJs);
var _delayJs = require("./delay.js");
var _delayJsDefault = parcelHelpers.interopDefault(_delayJs);
var _durationJs = require("./duration.js");
var _durationJsDefault = parcelHelpers.interopDefault(_durationJs);
var _easeJs = require("./ease.js");
var _easeJsDefault = parcelHelpers.interopDefault(_easeJs);
var _easeVaryingJs = require("./easeVarying.js");
var _easeVaryingJsDefault = parcelHelpers.interopDefault(_easeVaryingJs);
var _filterJs = require("./filter.js");
var _filterJsDefault = parcelHelpers.interopDefault(_filterJs);
var _mergeJs = require("./merge.js");
var _mergeJsDefault = parcelHelpers.interopDefault(_mergeJs);
var _onJs = require("./on.js");
var _onJsDefault = parcelHelpers.interopDefault(_onJs);
var _removeJs = require("./remove.js");
var _removeJsDefault = parcelHelpers.interopDefault(_removeJs);
var _selectJs = require("./select.js");
var _selectJsDefault = parcelHelpers.interopDefault(_selectJs);
var _selectAllJs = require("./selectAll.js");
var _selectAllJsDefault = parcelHelpers.interopDefault(_selectAllJs);
var _selectionJs = require("./selection.js");
var _selectionJsDefault = parcelHelpers.interopDefault(_selectionJs);
var _styleJs = require("./style.js");
var _styleJsDefault = parcelHelpers.interopDefault(_styleJs);
var _styleTweenJs = require("./styleTween.js");
var _styleTweenJsDefault = parcelHelpers.interopDefault(_styleTweenJs);
var _textJs = require("./text.js");
var _textJsDefault = parcelHelpers.interopDefault(_textJs);
var _textTweenJs = require("./textTween.js");
var _textTweenJsDefault = parcelHelpers.interopDefault(_textTweenJs);
var _transitionJs = require("./transition.js");
var _transitionJsDefault = parcelHelpers.interopDefault(_transitionJs);
var _tweenJs = require("./tween.js");
var _tweenJsDefault = parcelHelpers.interopDefault(_tweenJs);
var _endJs = require("./end.js");
var _endJsDefault = parcelHelpers.interopDefault(_endJs);
var id = 0;
function Transition(groups, parents, name, id) {
    this._groups = groups;
    this._parents = parents;
    this._name = name;
    this._id = id;
}
function transition(name) {
    return (0, _d3Selection.selection)().transition(name);
}
function newId() {
    return ++id;
}
var selection_prototype = (0, _d3Selection.selection).prototype;
Transition.prototype = transition.prototype = {
    constructor: Transition,
    select: (0, _selectJsDefault.default),
    selectAll: (0, _selectAllJsDefault.default),
    selectChild: selection_prototype.selectChild,
    selectChildren: selection_prototype.selectChildren,
    filter: (0, _filterJsDefault.default),
    merge: (0, _mergeJsDefault.default),
    selection: (0, _selectionJsDefault.default),
    transition: (0, _transitionJsDefault.default),
    call: selection_prototype.call,
    nodes: selection_prototype.nodes,
    node: selection_prototype.node,
    size: selection_prototype.size,
    empty: selection_prototype.empty,
    each: selection_prototype.each,
    on: (0, _onJsDefault.default),
    attr: (0, _attrJsDefault.default),
    attrTween: (0, _attrTweenJsDefault.default),
    style: (0, _styleJsDefault.default),
    styleTween: (0, _styleTweenJsDefault.default),
    text: (0, _textJsDefault.default),
    textTween: (0, _textTweenJsDefault.default),
    remove: (0, _removeJsDefault.default),
    tween: (0, _tweenJsDefault.default),
    delay: (0, _delayJsDefault.default),
    duration: (0, _durationJsDefault.default),
    ease: (0, _easeJsDefault.default),
    easeVarying: (0, _easeVaryingJsDefault.default),
    end: (0, _endJsDefault.default),
    [Symbol.iterator]: selection_prototype[Symbol.iterator]
};

},{"d3-selection":[["selection","c44R6","default"]],"./attr.js":"9pTF6","./attrTween.js":"4y7yx","./delay.js":"jpYbS","./duration.js":"bS8QM","./ease.js":"ch4gA","./easeVarying.js":"9tsi5","./filter.js":"1SOMQ","./merge.js":"3i9NJ","./on.js":"2aVC6","./remove.js":"2AsGY","./select.js":"ctive","./selectAll.js":"9V26T","./selection.js":"a3x7P","./style.js":"2gmad","./styleTween.js":"cyLVZ","./text.js":"dNCcW","./textTween.js":"fUt07","./transition.js":"hRfsB","./tween.js":"ecbar","./end.js":"9nUPj","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9pTF6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, value) {
        var fullname = (0, _d3Selection.namespace)(name), i = fullname === "transform" ? (0, _d3Interpolate.interpolateTransformSvg) : (0, _interpolateJsDefault.default);
        return this.attrTween(name, typeof value === "function" ? (fullname.local ? attrFunctionNS : attrFunction)(fullname, i, (0, _tweenJs.tweenValue)(this, "attr." + name, value)) : value == null ? (fullname.local ? attrRemoveNS : attrRemove)(fullname) : (fullname.local ? attrConstantNS : attrConstant)(fullname, i, value));
    });
var _d3Interpolate = require("d3-interpolate");
var _d3Selection = require("d3-selection");
var _tweenJs = require("./tween.js");
var _interpolateJs = require("./interpolate.js");
var _interpolateJsDefault = parcelHelpers.interopDefault(_interpolateJs);
function attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function attrConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttribute(name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function attrConstantNS(fullname, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttributeNS(fullname.space, fullname.local);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function attrFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttribute(name);
        string0 = this.getAttribute(name);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function attrFunctionNS(fullname, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
        string0 = this.getAttributeNS(fullname.space, fullname.local);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}

},{"d3-interpolate":"iN9Uy","d3-selection":[["namespace","e2lf9","default"]],"./tween.js":"ecbar","./interpolate.js":"ixUdt","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iN9Uy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "interpolateTransformCss", ()=>interpolateTransformCss);
parcelHelpers.export(exports, "interpolateTransformSvg", ()=>interpolateTransformSvg);
var _numberJs = require("../number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
var _parseJs = require("./parse.js");
function interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, _numberJsDefault.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, _numberJsDefault.default)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, _numberJsDefault.default)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, _numberJsDefault.default)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, _numberJsDefault.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, _numberJsDefault.default)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var interpolateTransformCss = interpolateTransform((0, _parseJs.parseCss), "px, ", "px)", "deg)");
var interpolateTransformSvg = interpolateTransform((0, _parseJs.parseSvg), ", ", ")", ")");

},{"../number.js":"lU4Z0","./parse.js":"4Gvvu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lU4Z0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        return a = +a, b = +b, function(t) {
            return a * (1 - t) + b * t;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4Gvvu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/* eslint-disable no-undef */ parcelHelpers.export(exports, "parseCss", ()=>parseCss);
parcelHelpers.export(exports, "parseSvg", ()=>parseSvg);
var _decomposeJs = require("./decompose.js");
var _decomposeJsDefault = parcelHelpers.interopDefault(_decomposeJs);
var svgNode;
function parseCss(value) {
    const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
    return m.isIdentity ? (0, _decomposeJs.identity) : (0, _decomposeJsDefault.default)(m.a, m.b, m.c, m.d, m.e, m.f);
}
function parseSvg(value) {
    if (value == null) return 0, _decomposeJs.identity;
    if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    svgNode.setAttribute("transform", value);
    if (!(value = svgNode.transform.baseVal.consolidate())) return 0, _decomposeJs.identity;
    value = value.matrix;
    return (0, _decomposeJsDefault.default)(value.a, value.b, value.c, value.d, value.e, value.f);
}

},{"./decompose.js":"8mHaF","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8mHaF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "identity", ()=>identity);
parcelHelpers.export(exports, "default", ()=>function(a, b, c, d, e, f) {
        var scaleX, scaleY, skewX;
        if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
        if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
        if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
        if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
        return {
            translateX: e,
            translateY: f,
            rotate: Math.atan2(b, a) * degrees,
            skewX: Math.atan(skewX) * degrees,
            scaleX: scaleX,
            scaleY: scaleY
        };
    });
var degrees = 180 / Math.PI;
var identity = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ecbar":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, value) {
        var id = this._id;
        name += "";
        if (arguments.length < 2) {
            var tween = (0, _scheduleJs.get)(this.node(), id).tween;
            for(var i = 0, n = tween.length, t; i < n; ++i){
                if ((t = tween[i]).name === name) return t.value;
            }
            return null;
        }
        return this.each((value == null ? tweenRemove : tweenFunction)(id, name, value));
    });
parcelHelpers.export(exports, "tweenValue", ()=>tweenValue);
var _scheduleJs = require("./schedule.js");
function tweenRemove(id, name) {
    var tween0, tween1;
    return function() {
        var schedule = (0, _scheduleJs.set)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = tween0 = tween;
            for(var i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1 = tween1.slice();
                tween1.splice(i, 1);
                break;
            }
        }
        schedule.tween = tween1;
    };
}
function tweenFunction(id, name, value) {
    var tween0, tween1;
    if (typeof value !== "function") throw new Error;
    return function() {
        var schedule = (0, _scheduleJs.set)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = (tween0 = tween).slice();
            for(var t = {
                name: name,
                value: value
            }, i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1[i] = t;
                break;
            }
            if (i === n) tween1.push(t);
        }
        schedule.tween = tween1;
    };
}
function tweenValue(transition, name, value) {
    var id = transition._id;
    transition.each(function() {
        var schedule = (0, _scheduleJs.set)(this, id);
        (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
    });
    return function(node) {
        return (0, _scheduleJs.get)(node, id).value[name];
    };
}

},{"./schedule.js":"1oCbn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ixUdt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        var c;
        return (typeof b === "number" ? (0, _d3Interpolate.interpolateNumber) : b instanceof (0, _d3Color.color) ? (0, _d3Interpolate.interpolateRgb) : (c = (0, _d3Color.color)(b)) ? (b = c, _d3Interpolate.interpolateRgb) : (0, _d3Interpolate.interpolateString))(a, b);
    });
var _d3Color = require("d3-color");
var _d3Interpolate = require("d3-interpolate");

},{"d3-color":[["color","cZjkf","default"]],"d3-interpolate":[["interpolateNumber","lU4Z0","default"],["interpolateRgb","bG7wU","default"],["interpolateString","iNjOh","default"]],"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cZjkf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Color", ()=>Color);
parcelHelpers.export(exports, "darker", ()=>darker);
parcelHelpers.export(exports, "brighter", ()=>brighter);
parcelHelpers.export(exports, "default", ()=>color);
parcelHelpers.export(exports, "rgbConvert", ()=>rgbConvert);
parcelHelpers.export(exports, "rgb", ()=>rgb);
parcelHelpers.export(exports, "Rgb", ()=>Rgb);
parcelHelpers.export(exports, "hslConvert", ()=>hslConvert);
parcelHelpers.export(exports, "hsl", ()=>hsl);
var _defineJs = require("./define.js");
var _defineJsDefault = parcelHelpers.interopDefault(_defineJs);
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, _defineJsDefault.default)(Color, color, {
    copy (channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHex8: color_formatHex8,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHex8() {
    return this.rgb().formatHex8();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, _defineJsDefault.default)(Rgb, rgb, (0, _defineJs.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatHex8: rgb_formatHex8,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
    value = clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, _defineJsDefault.default)(Hsl, hsl, (0, _defineJs.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp () {
        return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const a = clampa(this.opacity);
        return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
    }
}));
function clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

},{"./define.js":"34Inj","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"34Inj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(constructor, factory, prototype) {
        constructor.prototype = factory.prototype = prototype;
        prototype.constructor = constructor;
    });
parcelHelpers.export(exports, "extend", ()=>extend);
function extend(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bG7wU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rgbBasis", ()=>rgbBasis);
parcelHelpers.export(exports, "rgbBasisClosed", ()=>rgbBasisClosed);
var _d3Color = require("d3-color");
var _basisJs = require("./basis.js");
var _basisJsDefault = parcelHelpers.interopDefault(_basisJs);
var _basisClosedJs = require("./basisClosed.js");
var _basisClosedJsDefault = parcelHelpers.interopDefault(_basisClosedJs);
var _colorJs = require("./color.js");
var _colorJsDefault = parcelHelpers.interopDefault(_colorJs);
exports.default = function rgbGamma(y) {
    var color = (0, _colorJs.gamma)(y);
    function rgb(start, end) {
        var r = color((start = (0, _d3Color.rgb)(start)).r, (end = (0, _d3Color.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, _colorJsDefault.default)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, _d3Color.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var rgbBasis = rgbSpline((0, _basisJsDefault.default));
var rgbBasisClosed = rgbSpline((0, _basisClosedJsDefault.default));

},{"d3-color":"cZjkf","./basis.js":"8v2RP","./basisClosed.js":"93ABE","./color.js":"igqbp","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8v2RP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "basis", ()=>basis);
parcelHelpers.export(exports, "default", ()=>function(values) {
        var n = values.length - 1;
        return function(t) {
            var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
            return basis((t - i / n) * n, v0, v1, v2, v3);
        };
    });
function basis(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"93ABE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(values) {
        var n = values.length;
        return function(t) {
            var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
            return (0, _basisJs.basis)((t - i / n) * n, v0, v1, v2, v3);
        };
    });
var _basisJs = require("./basis.js");

},{"./basis.js":"8v2RP","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"igqbp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hue", ()=>hue);
parcelHelpers.export(exports, "gamma", ()=>gamma);
parcelHelpers.export(exports, "default", ()=>nogamma);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
function linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function hue(a, b) {
    var d = b - a;
    return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, _constantJsDefault.default)(isNaN(a) ? b : a);
}
function gamma(y) {
    return (y = +y) === 1 ? nogamma : function(a, b) {
        return b - a ? exponential(a, b, y) : (0, _constantJsDefault.default)(isNaN(a) ? b : a);
    };
}
function nogamma(a, b) {
    var d = b - a;
    return d ? linear(a, d) : (0, _constantJsDefault.default)(isNaN(a) ? b : a);
}

},{"./constant.js":"lJpIo","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lJpIo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = (x)=>()=>x;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iNjOh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        var bi = reA.lastIndex = reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
        // Coerce inputs to strings.
        a = a + "", b = b + "";
        // Interpolate pairs of numbers in a & b.
        while((am = reA.exec(a)) && (bm = reB.exec(b))){
            if ((bs = bm.index) > bi) {
                bs = b.slice(bi, bs);
                if (s[i]) s[i] += bs; // coalesce with previous string
                else s[++i] = bs;
            }
            if ((am = am[0]) === (bm = bm[0])) {
                if (s[i]) s[i] += bm; // coalesce with previous string
                else s[++i] = bm;
            } else {
                s[++i] = null;
                q.push({
                    i: i,
                    x: (0, _numberJsDefault.default)(am, bm)
                });
            }
            bi = reB.lastIndex;
        }
        // Add remains of b.
        if (bi < b.length) {
            bs = b.slice(bi);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        // Special optimization for only a single match.
        // Otherwise, interpolate each of the numbers and rejoin the string.
        return s.length < 2 ? q[0] ? one(q[0].x) : zero(b) : (b = q.length, function(t) {
            for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        });
    });
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, reB = new RegExp(reA.source, "g");
function zero(b) {
    return function() {
        return b;
    };
}
function one(b) {
    return function(t) {
        return b(t) + "";
    };
}

},{"./number.js":"lU4Z0","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4y7yx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, value) {
        var key = "attr." + name;
        if (arguments.length < 2) return (key = this.tween(key)) && key._value;
        if (value == null) return this.tween(key, null);
        if (typeof value !== "function") throw new Error;
        var fullname = (0, _d3Selection.namespace)(name);
        return this.tween(key, (fullname.local ? attrTweenNS : attrTween)(fullname, value));
    });
var _d3Selection = require("d3-selection");
function attrInterpolate(name, i) {
    return function(t) {
        this.setAttribute(name, i.call(this, t));
    };
}
function attrInterpolateNS(fullname, i) {
    return function(t) {
        this.setAttributeNS(fullname.space, fullname.local, i.call(this, t));
    };
}
function attrTweenNS(fullname, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && attrInterpolateNS(fullname, i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function attrTween(name, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && attrInterpolate(name, i);
        return t0;
    }
    tween._value = value;
    return tween;
}

},{"d3-selection":[["namespace","e2lf9","default"]],"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jpYbS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        var id = this._id;
        return arguments.length ? this.each((typeof value === "function" ? delayFunction : delayConstant)(id, value)) : (0, _scheduleJs.get)(this.node(), id).delay;
    });
var _scheduleJs = require("./schedule.js");
function delayFunction(id, value) {
    return function() {
        (0, _scheduleJs.init)(this, id).delay = +value.apply(this, arguments);
    };
}
function delayConstant(id, value) {
    return value = +value, function() {
        (0, _scheduleJs.init)(this, id).delay = value;
    };
}

},{"./schedule.js":"1oCbn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bS8QM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        var id = this._id;
        return arguments.length ? this.each((typeof value === "function" ? durationFunction : durationConstant)(id, value)) : (0, _scheduleJs.get)(this.node(), id).duration;
    });
var _scheduleJs = require("./schedule.js");
function durationFunction(id, value) {
    return function() {
        (0, _scheduleJs.set)(this, id).duration = +value.apply(this, arguments);
    };
}
function durationConstant(id, value) {
    return value = +value, function() {
        (0, _scheduleJs.set)(this, id).duration = value;
    };
}

},{"./schedule.js":"1oCbn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ch4gA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        var id = this._id;
        return arguments.length ? this.each(easeConstant(id, value)) : (0, _scheduleJs.get)(this.node(), id).ease;
    });
var _scheduleJs = require("./schedule.js");
function easeConstant(id, value) {
    if (typeof value !== "function") throw new Error;
    return function() {
        (0, _scheduleJs.set)(this, id).ease = value;
    };
}

},{"./schedule.js":"1oCbn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9tsi5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        if (typeof value !== "function") throw new Error;
        return this.each(easeVarying(this._id, value));
    });
var _scheduleJs = require("./schedule.js");
function easeVarying(id, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (typeof v !== "function") throw new Error;
        (0, _scheduleJs.set)(this, id).ease = v;
    };
}

},{"./schedule.js":"1oCbn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1SOMQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(match) {
        if (typeof match !== "function") match = (0, _d3Selection.matcher)(match);
        for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
        }
        return new (0, _indexJs.Transition)(subgroups, this._parents, this._name, this._id);
    });
var _d3Selection = require("d3-selection");
var _indexJs = require("./index.js");

},{"d3-selection":[["matcher","iOc8r","default"]],"./index.js":"aaeaM","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3i9NJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(transition) {
        if (transition._id !== this._id) throw new Error;
        for(var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
            for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
        }
        for(; j < m0; ++j)merges[j] = groups0[j];
        return new (0, _indexJs.Transition)(merges, this._parents, this._name, this._id);
    });
var _indexJs = require("./index.js");

},{"./index.js":"aaeaM","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2aVC6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, listener) {
        var id = this._id;
        return arguments.length < 2 ? (0, _scheduleJs.get)(this.node(), id).on.on(name) : this.each(onFunction(id, name, listener));
    });
var _scheduleJs = require("./schedule.js");
function start(name) {
    return (name + "").trim().split(/^|\s+/).every(function(t) {
        var i = t.indexOf(".");
        if (i >= 0) t = t.slice(0, i);
        return !t || t === "start";
    });
}
function onFunction(id, name, listener) {
    var on0, on1, sit = start(name) ? (0, _scheduleJs.init) : (0, _scheduleJs.set);
    return function() {
        var schedule = sit(this, id), on = schedule.on;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);
        schedule.on = on1;
    };
}

},{"./schedule.js":"1oCbn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2AsGY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return this.on("end.remove", removeFunction(this._id));
    });
function removeFunction(id) {
    return function() {
        var parent = this.parentNode;
        for(var i in this.__transition)if (+i !== id) return;
        if (parent) parent.removeChild(this);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ctive":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(select) {
        var name = this._name, id = this._id;
        if (typeof select !== "function") select = (0, _d3Selection.selector)(select);
        for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
                if ("__data__" in node) subnode.__data__ = node.__data__;
                subgroup[i] = subnode;
                (0, _scheduleJsDefault.default)(subgroup[i], name, id, i, subgroup, (0, _scheduleJs.get)(node, id));
            }
        }
        return new (0, _indexJs.Transition)(subgroups, this._parents, name, id);
    });
var _d3Selection = require("d3-selection");
var _indexJs = require("./index.js");
var _scheduleJs = require("./schedule.js");
var _scheduleJsDefault = parcelHelpers.interopDefault(_scheduleJs);

},{"d3-selection":[["selector","4I2PW","default"]],"./index.js":"aaeaM","./schedule.js":"1oCbn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9V26T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(select) {
        var name = this._name, id = this._id;
        if (typeof select !== "function") select = (0, _d3Selection.selectorAll)(select);
        for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
                for(var children = select.call(node, node.__data__, i, group), child, inherit = (0, _scheduleJs.get)(node, id), k = 0, l = children.length; k < l; ++k)if (child = children[k]) (0, _scheduleJsDefault.default)(child, name, id, k, children, inherit);
                subgroups.push(children);
                parents.push(node);
            }
        }
        return new (0, _indexJs.Transition)(subgroups, parents, name, id);
    });
var _d3Selection = require("d3-selection");
var _indexJs = require("./index.js");
var _scheduleJs = require("./schedule.js");
var _scheduleJsDefault = parcelHelpers.interopDefault(_scheduleJs);

},{"d3-selection":[["selectorAll","9H6e7","default"]],"./index.js":"aaeaM","./schedule.js":"1oCbn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"a3x7P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return new Selection(this._groups, this._parents);
    });
var _d3Selection = require("d3-selection");
var Selection = (0, _d3Selection.selection).prototype.constructor;

},{"d3-selection":[["selection","c44R6","default"]],"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2gmad":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, value, priority) {
        var i = (name += "") === "transform" ? (0, _d3Interpolate.interpolateTransformCss) : (0, _interpolateJsDefault.default);
        return value == null ? this.styleTween(name, styleNull(name, i)).on("end.style." + name, styleRemove(name)) : typeof value === "function" ? this.styleTween(name, styleFunction(name, i, (0, _tweenJs.tweenValue)(this, "style." + name, value))).each(styleMaybeRemove(this._id, name)) : this.styleTween(name, styleConstant(name, i, value), priority).on("end.style." + name, null);
    });
var _d3Interpolate = require("d3-interpolate");
var _d3Selection = require("d3-selection");
var _scheduleJs = require("./schedule.js");
var _tweenJs = require("./tween.js");
var _interpolateJs = require("./interpolate.js");
var _interpolateJsDefault = parcelHelpers.interopDefault(_interpolateJs);
function styleNull(name, interpolate) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, _d3Selection.style)(this, name), string1 = (this.style.removeProperty(name), (0, _d3Selection.style)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : interpolate0 = interpolate(string00 = string0, string10 = string1);
    };
}
function styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function styleConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = (0, _d3Selection.style)(this, name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function styleFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, _d3Selection.style)(this, name), value1 = value(this), string1 = value1 + "";
        if (value1 == null) string1 = value1 = (this.style.removeProperty(name), (0, _d3Selection.style)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function styleMaybeRemove(id, name) {
    var on0, on1, listener0, key = "style." + name, event = "end." + key, remove;
    return function() {
        var schedule = (0, _scheduleJs.set)(this, id), on = schedule.on, listener = schedule.value[key] == null ? remove || (remove = styleRemove(name)) : undefined;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0 || listener0 !== listener) (on1 = (on0 = on).copy()).on(event, listener0 = listener);
        schedule.on = on1;
    };
}

},{"d3-interpolate":"iN9Uy","d3-selection":[["style","jEBVs","styleValue"]],"./schedule.js":"1oCbn","./tween.js":"ecbar","./interpolate.js":"ixUdt","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cyLVZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, value, priority) {
        var key = "style." + (name += "");
        if (arguments.length < 2) return (key = this.tween(key)) && key._value;
        if (value == null) return this.tween(key, null);
        if (typeof value !== "function") throw new Error;
        return this.tween(key, styleTween(name, value, priority == null ? "" : priority));
    });
function styleInterpolate(name, i, priority) {
    return function(t) {
        this.style.setProperty(name, i.call(this, t), priority);
    };
}
function styleTween(name, value, priority) {
    var t, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t = (i0 = i) && styleInterpolate(name, i, priority);
        return t;
    }
    tween._value = value;
    return tween;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dNCcW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        return this.tween("text", typeof value === "function" ? textFunction((0, _tweenJs.tweenValue)(this, "text", value)) : textConstant(value == null ? "" : value + ""));
    });
var _tweenJs = require("./tween.js");
function textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function textFunction(value) {
    return function() {
        var value1 = value(this);
        this.textContent = value1 == null ? "" : value1;
    };
}

},{"./tween.js":"ecbar","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fUt07":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        var key = "text";
        if (arguments.length < 1) return (key = this.tween(key)) && key._value;
        if (value == null) return this.tween(key, null);
        if (typeof value !== "function") throw new Error;
        return this.tween(key, textTween(value));
    });
function textInterpolate(i) {
    return function(t) {
        this.textContent = i.call(this, t);
    };
}
function textTween(value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && textInterpolate(i);
        return t0;
    }
    tween._value = value;
    return tween;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hRfsB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var name = this._name, id0 = this._id, id1 = (0, _indexJs.newId)();
        for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
                var inherit = (0, _scheduleJs.get)(node, id0);
                (0, _scheduleJsDefault.default)(node, name, id1, i, group, {
                    time: inherit.time + inherit.delay + inherit.duration,
                    delay: 0,
                    duration: inherit.duration,
                    ease: inherit.ease
                });
            }
        }
        return new (0, _indexJs.Transition)(groups, this._parents, name, id1);
    });
var _indexJs = require("./index.js");
var _scheduleJs = require("./schedule.js");
var _scheduleJsDefault = parcelHelpers.interopDefault(_scheduleJs);

},{"./index.js":"aaeaM","./schedule.js":"1oCbn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9nUPj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var on0, on1, that = this, id = that._id, size = that.size();
        return new Promise(function(resolve, reject) {
            var cancel = {
                value: reject
            }, end = {
                value: function() {
                    if (--size === 0) resolve();
                }
            };
            that.each(function() {
                var schedule = (0, _scheduleJs.set)(this, id), on = schedule.on;
                // If this node shared a dispatch with the previous node,
                // just assign the updated shared dispatch and we’re done!
                // Otherwise, copy-on-write.
                if (on !== on0) {
                    on1 = (on0 = on).copy();
                    on1._.cancel.push(cancel);
                    on1._.interrupt.push(cancel);
                    on1._.end.push(end);
                }
                schedule.on = on1;
            });
            // The selection was empty, resolve end immediately
            if (size === 0) resolve();
        });
    });
var _scheduleJs = require("./schedule.js");

},{"./schedule.js":"1oCbn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eWkjr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cubicIn", ()=>cubicIn);
parcelHelpers.export(exports, "cubicOut", ()=>cubicOut);
parcelHelpers.export(exports, "cubicInOut", ()=>cubicInOut);
function cubicIn(t) {
    return t * t * t;
}
function cubicOut(t) {
    return --t * t * t + 1;
}
function cubicInOut(t) {
    return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bPwFS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = (x)=>()=>x;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"a6d1t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ZoomEvent);
function ZoomEvent(type, { sourceEvent, target, transform, dispatch }) {
    Object.defineProperties(this, {
        type: {
            value: type,
            enumerable: true,
            configurable: true
        },
        sourceEvent: {
            value: sourceEvent,
            enumerable: true,
            configurable: true
        },
        target: {
            value: target,
            enumerable: true,
            configurable: true
        },
        transform: {
            value: transform,
            enumerable: true,
            configurable: true
        },
        _: {
            value: dispatch
        }
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"KmKi8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Transform", ()=>Transform);
parcelHelpers.export(exports, "identity", ()=>identity);
parcelHelpers.export(exports, "default", ()=>transform);
function Transform(k, x, y) {
    this.k = k;
    this.x = x;
    this.y = y;
}
Transform.prototype = {
    constructor: Transform,
    scale: function(k) {
        return k === 1 ? this : new Transform(this.k * k, this.x, this.y);
    },
    translate: function(x, y) {
        return x === 0 & y === 0 ? this : new Transform(this.k, this.x + this.k * x, this.y + this.k * y);
    },
    apply: function(point) {
        return [
            point[0] * this.k + this.x,
            point[1] * this.k + this.y
        ];
    },
    applyX: function(x) {
        return x * this.k + this.x;
    },
    applyY: function(y) {
        return y * this.k + this.y;
    },
    invert: function(location) {
        return [
            (location[0] - this.x) / this.k,
            (location[1] - this.y) / this.k
        ];
    },
    invertX: function(x) {
        return (x - this.x) / this.k;
    },
    invertY: function(y) {
        return (y - this.y) / this.k;
    },
    rescaleX: function(x) {
        return x.copy().domain(x.range().map(this.invertX, this).map(x.invert, x));
    },
    rescaleY: function(y) {
        return y.copy().domain(y.range().map(this.invertY, this).map(y.invert, y));
    },
    toString: function() {
        return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
    }
};
var identity = new Transform(1, 0, 0);
transform.prototype = Transform.prototype;
function transform(node) {
    while(!node.__zoom)if (!(node = node.parentNode)) return identity;
    return node.__zoom;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eC3Wp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "nopropagation", ()=>nopropagation);
parcelHelpers.export(exports, "default", ()=>function(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
    });
function nopropagation(event) {
    event.stopImmediatePropagation();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2iRCi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var filter = defaultFilter, container = defaultContainer, subject = defaultSubject, touchable = defaultTouchable, gestures = {}, listeners = (0, _d3Dispatch.dispatch)("start", "drag", "end"), active = 0, mousedownx, mousedowny, mousemoving, touchending, clickDistance2 = 0;
        function drag(selection) {
            selection.on("mousedown.drag", mousedowned).filter(touchable).on("touchstart.drag", touchstarted).on("touchmove.drag", touchmoved, (0, _noeventJs.nonpassive)).on("touchend.drag touchcancel.drag", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
        }
        function mousedowned(event, d) {
            if (touchending || !filter.call(this, event, d)) return;
            var gesture = beforestart(this, container.call(this, event, d), event, d, "mouse");
            if (!gesture) return;
            (0, _d3Selection.select)(event.view).on("mousemove.drag", mousemoved, (0, _noeventJs.nonpassivecapture)).on("mouseup.drag", mouseupped, (0, _noeventJs.nonpassivecapture));
            (0, _nodragJsDefault.default)(event.view);
            (0, _noeventJs.nopropagation)(event);
            mousemoving = false;
            mousedownx = event.clientX;
            mousedowny = event.clientY;
            gesture("start", event);
        }
        function mousemoved(event) {
            (0, _noeventJsDefault.default)(event);
            if (!mousemoving) {
                var dx = event.clientX - mousedownx, dy = event.clientY - mousedowny;
                mousemoving = dx * dx + dy * dy > clickDistance2;
            }
            gestures.mouse("drag", event);
        }
        function mouseupped(event) {
            (0, _d3Selection.select)(event.view).on("mousemove.drag mouseup.drag", null);
            (0, _nodragJs.yesdrag)(event.view, mousemoving);
            (0, _noeventJsDefault.default)(event);
            gestures.mouse("end", event);
        }
        function touchstarted(event, d) {
            if (!filter.call(this, event, d)) return;
            var touches = event.changedTouches, c = container.call(this, event, d), n = touches.length, i, gesture;
            for(i = 0; i < n; ++i)if (gesture = beforestart(this, c, event, d, touches[i].identifier, touches[i])) {
                (0, _noeventJs.nopropagation)(event);
                gesture("start", event, touches[i]);
            }
        }
        function touchmoved(event) {
            var touches = event.changedTouches, n = touches.length, i, gesture;
            for(i = 0; i < n; ++i)if (gesture = gestures[touches[i].identifier]) {
                (0, _noeventJsDefault.default)(event);
                gesture("drag", event, touches[i]);
            }
        }
        function touchended(event) {
            var touches = event.changedTouches, n = touches.length, i, gesture;
            if (touchending) clearTimeout(touchending);
            touchending = setTimeout(function() {
                touchending = null;
            }, 500); // Ghost clicks are delayed!
            for(i = 0; i < n; ++i)if (gesture = gestures[touches[i].identifier]) {
                (0, _noeventJs.nopropagation)(event);
                gesture("end", event, touches[i]);
            }
        }
        function beforestart(that, container, event, d, identifier, touch) {
            var dispatch = listeners.copy(), p = (0, _d3Selection.pointer)(touch || event, container), dx, dy, s;
            if ((s = subject.call(that, new (0, _eventJsDefault.default)("beforestart", {
                sourceEvent: event,
                target: drag,
                identifier,
                active,
                x: p[0],
                y: p[1],
                dx: 0,
                dy: 0,
                dispatch
            }), d)) == null) return;
            dx = s.x - p[0] || 0;
            dy = s.y - p[1] || 0;
            return function gesture(type, event, touch) {
                var p0 = p, n;
                switch(type){
                    case "start":
                        gestures[identifier] = gesture, n = active++;
                        break;
                    case "end":
                        delete gestures[identifier], --active; // falls through
                    case "drag":
                        p = (0, _d3Selection.pointer)(touch || event, container), n = active;
                        break;
                }
                dispatch.call(type, that, new (0, _eventJsDefault.default)(type, {
                    sourceEvent: event,
                    subject: s,
                    target: drag,
                    identifier,
                    active: n,
                    x: p[0] + dx,
                    y: p[1] + dy,
                    dx: p[0] - p0[0],
                    dy: p[1] - p0[1],
                    dispatch
                }), d);
            };
        }
        drag.filter = function(_) {
            return arguments.length ? (filter = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(!!_), drag) : filter;
        };
        drag.container = function(_) {
            return arguments.length ? (container = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(_), drag) : container;
        };
        drag.subject = function(_) {
            return arguments.length ? (subject = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(_), drag) : subject;
        };
        drag.touchable = function(_) {
            return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(!!_), drag) : touchable;
        };
        drag.on = function() {
            var value = listeners.on.apply(listeners, arguments);
            return value === listeners ? drag : value;
        };
        drag.clickDistance = function(_) {
            return arguments.length ? (clickDistance2 = (_ = +_) * _, drag) : Math.sqrt(clickDistance2);
        };
        return drag;
    });
var _d3Dispatch = require("d3-dispatch");
var _d3Selection = require("d3-selection");
var _nodragJs = require("./nodrag.js");
var _nodragJsDefault = parcelHelpers.interopDefault(_nodragJs);
var _noeventJs = require("./noevent.js");
var _noeventJsDefault = parcelHelpers.interopDefault(_noeventJs);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _eventJs = require("./event.js");
var _eventJsDefault = parcelHelpers.interopDefault(_eventJs);
// Ignore right-click, since that should open the context menu.
function defaultFilter(event) {
    return !event.ctrlKey && !event.button;
}
function defaultContainer() {
    return this.parentNode;
}
function defaultSubject(event, d) {
    return d == null ? {
        x: event.x,
        y: event.y
    } : d;
}
function defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}

},{"d3-dispatch":[["dispatch","avnlO","default"]],"d3-selection":[["pointer","04Hca","default"],["select","4CEQV","default"]],"./nodrag.js":"2o3My","./noevent.js":"lC7cP","./constant.js":"dYY1a","./event.js":"5PN43","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dYY1a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = (x)=>()=>x;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5PN43":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DragEvent);
function DragEvent(type, { sourceEvent, subject, target, identifier, active, x, y, dx, dy, dispatch }) {
    Object.defineProperties(this, {
        type: {
            value: type,
            enumerable: true,
            configurable: true
        },
        sourceEvent: {
            value: sourceEvent,
            enumerable: true,
            configurable: true
        },
        subject: {
            value: subject,
            enumerable: true,
            configurable: true
        },
        target: {
            value: target,
            enumerable: true,
            configurable: true
        },
        identifier: {
            value: identifier,
            enumerable: true,
            configurable: true
        },
        active: {
            value: active,
            enumerable: true,
            configurable: true
        },
        x: {
            value: x,
            enumerable: true,
            configurable: true
        },
        y: {
            value: y,
            enumerable: true,
            configurable: true
        },
        dx: {
            value: dx,
            enumerable: true,
            configurable: true
        },
        dy: {
            value: dy,
            enumerable: true,
            configurable: true
        },
        _: {
            value: dispatch
        }
    });
}
DragEvent.prototype.on = function() {
    var value = this._.on.apply(this._, arguments);
    return value === this._ ? this : value;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lA6mU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Background", ()=>Background$1);
parcelHelpers.export(exports, "BackgroundVariant", ()=>BackgroundVariant);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classcat = require("classcat");
var _classcatDefault = parcelHelpers.interopDefault(_classcat);
var _core = require("@reactflow/core");
var _shallow = require("zustand/shallow");
var BackgroundVariant;
(function(BackgroundVariant) {
    BackgroundVariant["Lines"] = "lines";
    BackgroundVariant["Dots"] = "dots";
    BackgroundVariant["Cross"] = "cross";
})(BackgroundVariant || (BackgroundVariant = {}));
function LinePattern({ color, dimensions, lineWidth }) {
    return (0, _reactDefault.default).createElement("path", {
        stroke: color,
        strokeWidth: lineWidth,
        d: `M${dimensions[0] / 2} 0 V${dimensions[1]} M0 ${dimensions[1] / 2} H${dimensions[0]}`
    });
}
function DotPattern({ color, radius }) {
    return (0, _reactDefault.default).createElement("circle", {
        cx: radius,
        cy: radius,
        r: radius,
        fill: color
    });
}
const defaultColor = {
    [BackgroundVariant.Dots]: '#91919a',
    [BackgroundVariant.Lines]: '#eee',
    [BackgroundVariant.Cross]: '#e2e2e2'
};
const defaultSize = {
    [BackgroundVariant.Dots]: 1,
    [BackgroundVariant.Lines]: 1,
    [BackgroundVariant.Cross]: 6
};
const selector = (s)=>({
        transform: s.transform,
        patternId: `pattern-${s.rfId}`
    });
function Background({ id, variant = BackgroundVariant.Dots, // only used for dots and cross
gap = 20, // only used for lines and cross
size, lineWidth = 1, offset = 2, color, style, className }) {
    const ref = (0, _react.useRef)(null);
    const { transform, patternId } = (0, _core.useStore)(selector, (0, _shallow.shallow));
    const patternColor = color || defaultColor[variant];
    const patternSize = size || defaultSize[variant];
    const isDots = variant === BackgroundVariant.Dots;
    const isCross = variant === BackgroundVariant.Cross;
    const gapXY = Array.isArray(gap) ? gap : [
        gap,
        gap
    ];
    const scaledGap = [
        gapXY[0] * transform[2] || 1,
        gapXY[1] * transform[2] || 1
    ];
    const scaledSize = patternSize * transform[2];
    const patternDimensions = isCross ? [
        scaledSize,
        scaledSize
    ] : scaledGap;
    const patternOffset = isDots ? [
        scaledSize / offset,
        scaledSize / offset
    ] : [
        patternDimensions[0] / offset,
        patternDimensions[1] / offset
    ];
    return (0, _reactDefault.default).createElement("svg", {
        className: (0, _classcatDefault.default)([
            'react-flow__background',
            className
        ]),
        style: {
            ...style,
            position: 'absolute',
            width: '100%',
            height: '100%',
            top: 0,
            left: 0
        },
        ref: ref,
        "data-testid": "rf__background"
    }, (0, _reactDefault.default).createElement("pattern", {
        id: patternId + id,
        x: transform[0] % scaledGap[0],
        y: transform[1] % scaledGap[1],
        width: scaledGap[0],
        height: scaledGap[1],
        patternUnits: "userSpaceOnUse",
        patternTransform: `translate(-${patternOffset[0]},-${patternOffset[1]})`
    }, isDots ? (0, _reactDefault.default).createElement(DotPattern, {
        color: patternColor,
        radius: scaledSize / offset
    }) : (0, _reactDefault.default).createElement(LinePattern, {
        dimensions: patternDimensions,
        color: patternColor,
        lineWidth: lineWidth
    })), (0, _reactDefault.default).createElement("rect", {
        x: "0",
        y: "0",
        width: "100%",
        height: "100%",
        fill: `url(#${patternId + id})`
    }));
}
Background.displayName = 'Background';
var Background$1 = (0, _react.memo)(Background);

},{"react":"bmhQu","classcat":"gT31h","@reactflow/core":"jvp3v","zustand/shallow":"8Q3tx","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9o7DF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ControlButton", ()=>ControlButton);
parcelHelpers.export(exports, "Controls", ()=>Controls$1);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classcat = require("classcat");
var _classcatDefault = parcelHelpers.interopDefault(_classcat);
var _shallow = require("zustand/shallow");
var _core = require("@reactflow/core");
function PlusIcon() {
    return (0, _reactDefault.default).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32"
    }, (0, _reactDefault.default).createElement("path", {
        d: "M32 18.133H18.133V32h-4.266V18.133H0v-4.266h13.867V0h4.266v13.867H32z"
    }));
}
function MinusIcon() {
    return (0, _reactDefault.default).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 5"
    }, (0, _reactDefault.default).createElement("path", {
        d: "M0 0h32v4.2H0z"
    }));
}
function FitViewIcon() {
    return (0, _reactDefault.default).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 30"
    }, (0, _reactDefault.default).createElement("path", {
        d: "M3.692 4.63c0-.53.4-.938.939-.938h5.215V0H4.708C2.13 0 0 2.054 0 4.63v5.216h3.692V4.631zM27.354 0h-5.2v3.692h5.17c.53 0 .984.4.984.939v5.215H32V4.631A4.624 4.624 0 0027.354 0zm.954 24.83c0 .532-.4.94-.939.94h-5.215v3.768h5.215c2.577 0 4.631-2.13 4.631-4.707v-5.139h-3.692v5.139zm-23.677.94c-.531 0-.939-.4-.939-.94v-5.138H0v5.139c0 2.577 2.13 4.707 4.708 4.707h5.138V25.77H4.631z"
    }));
}
function LockIcon() {
    return (0, _reactDefault.default).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 25 32"
    }, (0, _reactDefault.default).createElement("path", {
        d: "M21.333 10.667H19.81V7.619C19.81 3.429 16.38 0 12.19 0 8 0 4.571 3.429 4.571 7.619v3.048H3.048A3.056 3.056 0 000 13.714v15.238A3.056 3.056 0 003.048 32h18.285a3.056 3.056 0 003.048-3.048V13.714a3.056 3.056 0 00-3.048-3.047zM12.19 24.533a3.056 3.056 0 01-3.047-3.047 3.056 3.056 0 013.047-3.048 3.056 3.056 0 013.048 3.048 3.056 3.056 0 01-3.048 3.047zm4.724-13.866H7.467V7.619c0-2.59 2.133-4.724 4.723-4.724 2.591 0 4.724 2.133 4.724 4.724v3.048z"
    }));
}
function UnlockIcon() {
    return (0, _reactDefault.default).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 25 32"
    }, (0, _reactDefault.default).createElement("path", {
        d: "M21.333 10.667H19.81V7.619C19.81 3.429 16.38 0 12.19 0c-4.114 1.828-1.37 2.133.305 2.438 1.676.305 4.42 2.59 4.42 5.181v3.048H3.047A3.056 3.056 0 000 13.714v15.238A3.056 3.056 0 003.048 32h18.285a3.056 3.056 0 003.048-3.048V13.714a3.056 3.056 0 00-3.048-3.047zM12.19 24.533a3.056 3.056 0 01-3.047-3.047 3.056 3.056 0 013.047-3.048 3.056 3.056 0 013.048 3.048 3.056 3.056 0 01-3.048 3.047z"
    }));
}
const ControlButton = ({ children, className, ...rest })=>(0, _reactDefault.default).createElement("button", {
        type: "button",
        className: (0, _classcatDefault.default)([
            'react-flow__controls-button',
            className
        ]),
        ...rest
    }, children);
ControlButton.displayName = 'ControlButton';
const selector = (s)=>({
        isInteractive: s.nodesDraggable || s.nodesConnectable || s.elementsSelectable,
        minZoomReached: s.transform[2] <= s.minZoom,
        maxZoomReached: s.transform[2] >= s.maxZoom
    });
const Controls = ({ style, showZoom = true, showFitView = true, showInteractive = true, fitViewOptions, onZoomIn, onZoomOut, onFitView, onInteractiveChange, className, children, position = 'bottom-left' })=>{
    const store = (0, _core.useStoreApi)();
    const [isVisible, setIsVisible] = (0, _react.useState)(false);
    const { isInteractive, minZoomReached, maxZoomReached } = (0, _core.useStore)(selector, (0, _shallow.shallow));
    const { zoomIn, zoomOut, fitView } = (0, _core.useReactFlow)();
    (0, _react.useEffect)(()=>{
        setIsVisible(true);
    }, []);
    if (!isVisible) return null;
    const onZoomInHandler = ()=>{
        zoomIn();
        onZoomIn?.();
    };
    const onZoomOutHandler = ()=>{
        zoomOut();
        onZoomOut?.();
    };
    const onFitViewHandler = ()=>{
        fitView(fitViewOptions);
        onFitView?.();
    };
    const onToggleInteractivity = ()=>{
        store.setState({
            nodesDraggable: !isInteractive,
            nodesConnectable: !isInteractive,
            elementsSelectable: !isInteractive
        });
        onInteractiveChange?.(!isInteractive);
    };
    return (0, _reactDefault.default).createElement((0, _core.Panel), {
        className: (0, _classcatDefault.default)([
            'react-flow__controls',
            className
        ]),
        position: position,
        style: style,
        "data-testid": "rf__controls"
    }, showZoom && (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement(ControlButton, {
        onClick: onZoomInHandler,
        className: "react-flow__controls-zoomin",
        title: "zoom in",
        "aria-label": "zoom in",
        disabled: maxZoomReached
    }, (0, _reactDefault.default).createElement(PlusIcon, null)), (0, _reactDefault.default).createElement(ControlButton, {
        onClick: onZoomOutHandler,
        className: "react-flow__controls-zoomout",
        title: "zoom out",
        "aria-label": "zoom out",
        disabled: minZoomReached
    }, (0, _reactDefault.default).createElement(MinusIcon, null))), showFitView && (0, _reactDefault.default).createElement(ControlButton, {
        className: "react-flow__controls-fitview",
        onClick: onFitViewHandler,
        title: "fit view",
        "aria-label": "fit view"
    }, (0, _reactDefault.default).createElement(FitViewIcon, null)), showInteractive && (0, _reactDefault.default).createElement(ControlButton, {
        className: "react-flow__controls-interactive",
        onClick: onToggleInteractivity,
        title: "toggle interactivity",
        "aria-label": "toggle interactivity"
    }, isInteractive ? (0, _reactDefault.default).createElement(UnlockIcon, null) : (0, _reactDefault.default).createElement(LockIcon, null)), children);
};
Controls.displayName = 'Controls';
var Controls$1 = (0, _react.memo)(Controls);

},{"react":"bmhQu","classcat":"gT31h","zustand/shallow":"8Q3tx","@reactflow/core":"jvp3v","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bawIp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MiniMap", ()=>MiniMap$1);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classcat = require("classcat");
var _classcatDefault = parcelHelpers.interopDefault(_classcat);
var _shallow = require("zustand/shallow");
var _d3Zoom = require("d3-zoom");
var _d3Selection = require("d3-selection");
var _core = require("@reactflow/core");
const MiniMapNode = ({ id, x, y, width, height, style, color, strokeColor, strokeWidth, className, borderRadius, shapeRendering, onClick, selected })=>{
    const { background, backgroundColor } = style || {};
    const fill = color || background || backgroundColor;
    return (0, _reactDefault.default).createElement("rect", {
        className: (0, _classcatDefault.default)([
            'react-flow__minimap-node',
            {
                selected
            },
            className
        ]),
        x: x,
        y: y,
        rx: borderRadius,
        ry: borderRadius,
        width: width,
        height: height,
        fill: fill,
        stroke: strokeColor,
        strokeWidth: strokeWidth,
        shapeRendering: shapeRendering,
        onClick: onClick ? (event)=>onClick(event, id) : undefined
    });
};
MiniMapNode.displayName = 'MiniMapNode';
var MiniMapNode$1 = (0, _react.memo)(MiniMapNode);
/* eslint-disable @typescript-eslint/ban-ts-comment */ const selector$1 = (s)=>s.nodeOrigin;
const selectorNodes = (s)=>s.getNodes().filter((node)=>!node.hidden && node.width && node.height);
const getAttrFunction = (func)=>func instanceof Function ? func : ()=>func;
function MiniMapNodes({ nodeStrokeColor = 'transparent', nodeColor = '#e2e2e2', nodeClassName = '', nodeBorderRadius = 5, nodeStrokeWidth = 2, // We need to rename the prop to be `CapitalCase` so that JSX will render it as
// a component properly.
nodeComponent: NodeComponent = MiniMapNode$1, onClick }) {
    const nodes = (0, _core.useStore)(selectorNodes, (0, _shallow.shallow));
    const nodeOrigin = (0, _core.useStore)(selector$1);
    const nodeColorFunc = getAttrFunction(nodeColor);
    const nodeStrokeColorFunc = getAttrFunction(nodeStrokeColor);
    const nodeClassNameFunc = getAttrFunction(nodeClassName);
    const shapeRendering = typeof window === 'undefined' || !!window.chrome ? 'crispEdges' : 'geometricPrecision';
    return (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, nodes.map((node)=>{
        const { x, y } = (0, _core.getNodePositionWithOrigin)(node, nodeOrigin).positionAbsolute;
        return (0, _reactDefault.default).createElement(NodeComponent, {
            key: node.id,
            x: x,
            y: y,
            width: node.width,
            height: node.height,
            style: node.style,
            selected: node.selected,
            className: nodeClassNameFunc(node),
            color: nodeColorFunc(node),
            borderRadius: nodeBorderRadius,
            strokeColor: nodeStrokeColorFunc(node),
            strokeWidth: nodeStrokeWidth,
            shapeRendering: shapeRendering,
            onClick: onClick,
            id: node.id
        });
    }));
}
var MiniMapNodes$1 = (0, _react.memo)(MiniMapNodes);
/* eslint-disable @typescript-eslint/ban-ts-comment */ const defaultWidth = 200;
const defaultHeight = 150;
const selector = (s)=>{
    const nodes = s.getNodes();
    const viewBB = {
        x: -s.transform[0] / s.transform[2],
        y: -s.transform[1] / s.transform[2],
        width: s.width / s.transform[2],
        height: s.height / s.transform[2]
    };
    return {
        viewBB,
        boundingRect: nodes.length > 0 ? (0, _core.getBoundsOfRects)((0, _core.getNodesBounds)(nodes, s.nodeOrigin), viewBB) : viewBB,
        rfId: s.rfId
    };
};
const ARIA_LABEL_KEY = 'react-flow__minimap-desc';
function MiniMap({ style, className, nodeStrokeColor = 'transparent', nodeColor = '#e2e2e2', nodeClassName = '', nodeBorderRadius = 5, nodeStrokeWidth = 2, // We need to rename the prop to be `CapitalCase` so that JSX will render it as
// a component properly.
nodeComponent, maskColor = 'rgb(240, 240, 240, 0.6)', maskStrokeColor = 'none', maskStrokeWidth = 1, position = 'bottom-right', onClick, onNodeClick, pannable = false, zoomable = false, ariaLabel = 'React Flow mini map', inversePan = false, zoomStep = 10, offsetScale = 5 }) {
    const store = (0, _core.useStoreApi)();
    const svg = (0, _react.useRef)(null);
    const { boundingRect, viewBB, rfId } = (0, _core.useStore)(selector, (0, _shallow.shallow));
    const elementWidth = style?.width ?? defaultWidth;
    const elementHeight = style?.height ?? defaultHeight;
    const scaledWidth = boundingRect.width / elementWidth;
    const scaledHeight = boundingRect.height / elementHeight;
    const viewScale = Math.max(scaledWidth, scaledHeight);
    const viewWidth = viewScale * elementWidth;
    const viewHeight = viewScale * elementHeight;
    const offset = offsetScale * viewScale;
    const x = boundingRect.x - (viewWidth - boundingRect.width) / 2 - offset;
    const y = boundingRect.y - (viewHeight - boundingRect.height) / 2 - offset;
    const width = viewWidth + offset * 2;
    const height = viewHeight + offset * 2;
    const labelledBy = `${ARIA_LABEL_KEY}-${rfId}`;
    const viewScaleRef = (0, _react.useRef)(0);
    viewScaleRef.current = viewScale;
    (0, _react.useEffect)(()=>{
        if (svg.current) {
            const selection = (0, _d3Selection.select)(svg.current);
            const zoomHandler = (event)=>{
                const { transform, d3Selection, d3Zoom } = store.getState();
                if (event.sourceEvent.type !== 'wheel' || !d3Selection || !d3Zoom) return;
                const pinchDelta = -event.sourceEvent.deltaY * (event.sourceEvent.deltaMode === 1 ? 0.05 : event.sourceEvent.deltaMode ? 1 : 0.002) * zoomStep;
                const zoom = transform[2] * Math.pow(2, pinchDelta);
                d3Zoom.scaleTo(d3Selection, zoom);
            };
            const panHandler = (event)=>{
                const { transform, d3Selection, d3Zoom, translateExtent, width, height } = store.getState();
                if (event.sourceEvent.type !== 'mousemove' || !d3Selection || !d3Zoom) return;
                // @TODO: how to calculate the correct next position? Math.max(1, transform[2]) is a workaround.
                const moveScale = viewScaleRef.current * Math.max(1, transform[2]) * (inversePan ? -1 : 1);
                const position = {
                    x: transform[0] - event.sourceEvent.movementX * moveScale,
                    y: transform[1] - event.sourceEvent.movementY * moveScale
                };
                const extent = [
                    [
                        0,
                        0
                    ],
                    [
                        width,
                        height
                    ]
                ];
                const nextTransform = (0, _d3Zoom.zoomIdentity).translate(position.x, position.y).scale(transform[2]);
                const constrainedTransform = d3Zoom.constrain()(nextTransform, extent, translateExtent);
                d3Zoom.transform(d3Selection, constrainedTransform);
            };
            const zoomAndPanHandler = (0, _d3Zoom.zoom)()// @ts-ignore
            .on('zoom', pannable ? panHandler : null)// @ts-ignore
            .on('zoom.wheel', zoomable ? zoomHandler : null);
            selection.call(zoomAndPanHandler);
            return ()=>{
                selection.on('zoom', null);
            };
        }
    }, [
        pannable,
        zoomable,
        inversePan,
        zoomStep
    ]);
    const onSvgClick = onClick ? (event)=>{
        const rfCoord = (0, _d3Selection.pointer)(event);
        onClick(event, {
            x: rfCoord[0],
            y: rfCoord[1]
        });
    } : undefined;
    const onSvgNodeClick = onNodeClick ? (event, nodeId)=>{
        const node = store.getState().nodeInternals.get(nodeId);
        onNodeClick(event, node);
    } : undefined;
    return (0, _reactDefault.default).createElement((0, _core.Panel), {
        position: position,
        style: style,
        className: (0, _classcatDefault.default)([
            'react-flow__minimap',
            className
        ]),
        "data-testid": "rf__minimap"
    }, (0, _reactDefault.default).createElement("svg", {
        width: elementWidth,
        height: elementHeight,
        viewBox: `${x} ${y} ${width} ${height}`,
        role: "img",
        "aria-labelledby": labelledBy,
        ref: svg,
        onClick: onSvgClick
    }, ariaLabel && (0, _reactDefault.default).createElement("title", {
        id: labelledBy
    }, ariaLabel), (0, _reactDefault.default).createElement(MiniMapNodes$1, {
        onClick: onSvgNodeClick,
        nodeColor: nodeColor,
        nodeStrokeColor: nodeStrokeColor,
        nodeBorderRadius: nodeBorderRadius,
        nodeClassName: nodeClassName,
        nodeStrokeWidth: nodeStrokeWidth,
        nodeComponent: nodeComponent
    }), (0, _reactDefault.default).createElement("path", {
        className: "react-flow__minimap-mask",
        d: `M${x - offset},${y - offset}h${width + offset * 2}v${height + offset * 2}h${-width - offset * 2}z
        M${viewBB.x},${viewBB.y}h${viewBB.width}v${viewBB.height}h${-viewBB.width}z`,
        fill: maskColor,
        fillRule: "evenodd",
        stroke: maskStrokeColor,
        strokeWidth: maskStrokeWidth,
        pointerEvents: "none"
    })));
}
MiniMap.displayName = 'MiniMap';
var MiniMap$1 = (0, _react.memo)(MiniMap);

},{"react":"bmhQu","classcat":"gT31h","zustand/shallow":"8Q3tx","d3-zoom":"h8Ny4","d3-selection":[["pointer","04Hca","default"],["select","4CEQV","default"]],"@reactflow/core":"jvp3v","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"BZvWP":[function() {},{}],"7Jd9b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const GridHeaderLite = ({ header, isColumn, onUpdate, onDelete, editorMode, className = '' })=>{
    const [isEditing, setIsEditing] = (0, _react.useState)(false);
    const [title, setTitle] = (0, _react.useState)(header.title || '');
    const [horizon, setHorizon] = (0, _react.useState)(header.horizon || '');
    const [isHovered, setIsHovered] = (0, _react.useState)(false);
    const inputRef = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        if (isEditing && inputRef.current) inputRef.current.focus();
    }, [
        isEditing
    ]);
    const handleEdit = ()=>{
        if (editorMode === 'cell') setIsEditing(true);
    };
    const handleSave = ()=>{
        if (isColumn) onUpdate(title);
        else onUpdate({
            title,
            horizon
        });
        setIsEditing(false);
    };
    const handleCancel = ()=>{
        setTitle(header.title);
        setHorizon(header.horizon || '');
        setIsEditing(false);
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter') {
            e.preventDefault();
            handleSave();
        } else if (e.key === 'Escape') {
            e.preventDefault();
            handleCancel();
        }
    };
    // Gérer le survol
    const handleMouseEnter = ()=>{
        setIsHovered(true);
    };
    const handleMouseLeave = ()=>{
        setIsHovered(false);
    };
    // Déterminer si l'en-tête est obligatoire
    const isObligatory = header.isObligatory || false;
    const isPseudoFunction = header.isPseudoFunction || false;
    // Classe conditionnelle pour les en-têtes obligatoires ou pseudo-fonctions
    const headerTypeClass = isObligatory ? 'obligatory' : '';
    const pseudoFunctionClass = isPseudoFunction ? 'pseudo-function' : '';
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `grid-header-cell ${isColumn ? 'column-header' : 'row-header'} ${headerTypeClass} ${pseudoFunctionClass} ${className}`,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        "data-id": isColumn ? `header-col-${header.id}` : `header-row-${header.id}`,
        children: [
            isEditing ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "header-edit-form",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        ref: inputRef,
                        type: "text",
                        value: title,
                        onChange: (e)=>setTitle(e.target.value),
                        onKeyDown: handleKeyDown,
                        className: "header-input",
                        placeholder: isColumn ? "Titre de la fonction" : "Titre de l'horizon"
                    }),
                    !isColumn && /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        type: "text",
                        value: horizon,
                        onChange: (e)=>setHorizon(e.target.value),
                        onKeyDown: handleKeyDown,
                        className: "header-input",
                        placeholder: "Code horizon (ex: H1)"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "header-edit-buttons",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                onClick: handleSave,
                                className: "header-button confirm",
                                children: "\u2713"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                onClick: handleCancel,
                                className: "header-button cancel",
                                children: "\u2717"
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "header-content",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "header-title",
                        children: [
                            title,
                            title && title.length > 20 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "header-title-tooltip",
                                children: title
                            })
                        ]
                    }),
                    !isColumn && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "header-subtitle",
                        children: horizon
                    }),
                    editorMode === 'cell' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: `header-action-buttons ${isHovered ? 'visible' : ''}`,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                onClick: handleEdit,
                                className: "header-button edit",
                                title: "Modifier",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "12",
                                    height: "12",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    strokeWidth: "2",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M17 3a2.85 2.85 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"
                                    })
                                })
                            }),
                            !header.isFixed && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                onClick: onDelete,
                                className: "header-button delete",
                                title: "Supprimer",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "12",
                                    height: "12",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    strokeWidth: "2",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                            d: "M3 6h18"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                            d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            isObligatory && !isEditing && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "obligatory-indicator",
                title: "Fonction obligatoire",
                children: "*"
            }),
            isPseudoFunction && !isEditing && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "pseudo-function-indicator",
                title: "Pseudo-fonction",
                children: "P"
            })
        ]
    });
};
exports.default = GridHeaderLite;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gn6dQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const GridCellLite = ({ content, onClick, onUpdate, editorMode, isArrowStart, className, id, rowId, colId, onOpenSubEditor })=>{
    const [isEditing, setIsEditing] = (0, _react.useState)(false);
    const [cellContent, setCellContent] = (0, _react.useState)(content || '');
    const [isHovered, setIsHovered] = (0, _react.useState)(false);
    const [isExpanded, setIsExpanded] = (0, _react.useState)(false);
    const [hasLongContent, setHasLongContent] = (0, _react.useState)(false);
    // États pour le redimensionnement
    const [cellHeight, setCellHeight] = (0, _react.useState)(null);
    const [cellWidth, setCellWidth] = (0, _react.useState)(null);
    const [isResizing, setIsResizing] = (0, _react.useState)(false);
    const [resizeDirection, setResizeDirection] = (0, _react.useState)(null); // 'vertical' ou 'horizontal'
    const inputRef = (0, _react.useRef)(null);
    const cellRef = (0, _react.useRef)(null);
    const contentRef = (0, _react.useRef)(null);
    // Mettre à jour le contenu local lorsque la prop content change
    (0, _react.useEffect)(()=>{
        setCellContent(content || '');
    }, [
        content
    ]);
    // Détecter les contenus longs qui pourraient nécessiter un bouton d'expansion
    (0, _react.useEffect)(()=>{
        if (contentRef.current && content) {
            // Vérifier si le contenu dépasse la taille visible de la cellule
            const isContentOverflowing = content.length > 150 || // Texte très long
            content.split('\n').length > 3 || // Plusieurs lignes
            contentRef.current.scrollHeight > contentRef.current.clientHeight || contentRef.current.scrollWidth > contentRef.current.clientWidth;
            setHasLongContent(isContentOverflowing);
        }
    }, [
        content,
        contentRef
    ]);
    // Focus sur l'input lors de l'entrée en mode édition
    (0, _react.useEffect)(()=>{
        if (isEditing && inputRef.current) {
            inputRef.current.focus();
            inputRef.current.select();
        }
    }, [
        isEditing
    ]);
    // Animer la cellule après modification
    (0, _react.useEffect)(()=>{
        if (!isEditing && cellRef.current && cellContent !== content) {
            cellRef.current.classList.add('animate-pulse');
            const timer = setTimeout(()=>{
                if (cellRef.current) cellRef.current.classList.remove('animate-pulse');
            }, 1500);
            return ()=>clearTimeout(timer);
        }
    }, [
        isEditing,
        content,
        cellContent
    ]);
    // Déterminer si la cellule est éditable
    const canEdit = editorMode === 'cell';
    // Gérer le clic sur la cellule
    const handleCellClick = ()=>{
        if (canEdit) setIsEditing(true);
        else onClick();
    };
    // Gérer l'enregistrement des modifications
    const handleSave = ()=>{
        if (cellContent !== content) onUpdate(cellContent);
        setIsEditing(false);
    };
    // Gérer la touche Entrée pendant l'édition
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleSave();
        } else if (e.key === 'Escape') {
            setIsEditing(false);
            setCellContent(content || '');
        }
    };
    // Basculer l'état d'expansion
    const toggleExpand = (e)=>{
        e.stopPropagation();
        setIsExpanded(!isExpanded);
    };
    // Fonctions pour le redimensionnement vertical des cellules
    const handleResizeVerticalStart = (e)=>{
        e.stopPropagation();
        e.preventDefault();
        if (!cellRef.current) return;
        setIsResizing(true);
        setResizeDirection('vertical');
        const startY = e.clientY;
        const startHeight = cellRef.current.offsetHeight;
        const handleMouseMove = (moveEvent)=>{
            const newHeight = startHeight + (moveEvent.clientY - startY);
            if (newHeight >= 40) {
                setCellHeight(newHeight);
                if (cellRef.current) {
                    cellRef.current.style.height = `${newHeight}px`;
                    cellRef.current.classList.add('has-custom-height');
                }
            }
        };
        const handleMouseUp = ()=>{
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
            setIsResizing(false);
            setResizeDirection(null);
            // Enregistrer la hauteur dans localStorage pour cette cellule spécifique
            if (cellHeight) {
                const cellSizes = JSON.parse(localStorage.getItem('graiCellSizes') || '{}');
                cellSizes[`${rowId}-${colId}`] = {
                    ...cellSizes[`${rowId}-${colId}`] || {},
                    height: cellHeight
                };
                localStorage.setItem('graiCellSizes', JSON.stringify(cellSizes));
            }
        };
        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
    };
    // Fonctions pour le redimensionnement horizontal des cellules
    const handleResizeHorizontalStart = (e)=>{
        e.stopPropagation();
        e.preventDefault();
        if (!cellRef.current) return;
        setIsResizing(true);
        setResizeDirection('horizontal');
        const startX = e.clientX;
        const startWidth = cellRef.current.offsetWidth;
        const handleMouseMove = (moveEvent)=>{
            const newWidth = startWidth + (moveEvent.clientX - startX);
            if (newWidth >= 100) {
                setCellWidth(newWidth);
                if (cellRef.current) {
                    cellRef.current.style.width = `${newWidth}px`;
                    cellRef.current.style.minWidth = `${newWidth}px`;
                    cellRef.current.style.maxWidth = `${newWidth}px`;
                    cellRef.current.classList.add('has-custom-width');
                }
            }
        };
        const handleMouseUp = ()=>{
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
            setIsResizing(false);
            setResizeDirection(null);
            // Enregistrer la largeur dans localStorage pour cette cellule spécifique
            if (cellWidth) {
                const cellSizes = JSON.parse(localStorage.getItem('graiCellSizes') || '{}');
                cellSizes[`${rowId}-${colId}`] = {
                    ...cellSizes[`${rowId}-${colId}`] || {},
                    width: cellWidth
                };
                localStorage.setItem('graiCellSizes', JSON.stringify(cellSizes));
            }
        };
        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
    };
    // Charger les dimensions sauvegardées au montage
    (0, _react.useEffect)(()=>{
        const cellSizes = JSON.parse(localStorage.getItem('graiCellSizes') || '{}');
        const savedSize = cellSizes[`${rowId}-${colId}`];
        if (savedSize && cellRef.current) {
            if (savedSize.height) {
                setCellHeight(savedSize.height);
                cellRef.current.style.height = `${savedSize.height}px`;
                cellRef.current.classList.add('has-custom-height');
            }
            if (savedSize.width) {
                setCellWidth(savedSize.width);
                cellRef.current.style.width = `${savedSize.width}px`;
                cellRef.current.style.minWidth = `${savedSize.width}px`;
                cellRef.current.style.maxWidth = `${savedSize.width}px`;
                cellRef.current.classList.add('has-custom-width');
            }
        }
    }, [
        rowId,
        colId
    ]);
    // Réinitialiser les dimensions
    const resetDimensions = (e, type)=>{
        e.stopPropagation();
        if (!cellRef.current) return;
        const cellSizes = JSON.parse(localStorage.getItem('graiCellSizes') || '{}');
        const existingSize = cellSizes[`${rowId}-${colId}`] || {};
        if (type === 'height' || type === 'all') {
            setCellHeight(null);
            cellRef.current.style.height = '';
            cellRef.current.classList.remove('has-custom-height');
            delete existingSize.height;
        }
        if (type === 'width' || type === 'all') {
            setCellWidth(null);
            cellRef.current.style.width = '';
            cellRef.current.style.minWidth = '';
            cellRef.current.style.maxWidth = '';
            cellRef.current.classList.remove('has-custom-width');
            delete existingSize.width;
        }
        // Mettre à jour ou supprimer l'entrée dans localStorage
        if (Object.keys(existingSize).length > 0) cellSizes[`${rowId}-${colId}`] = existingSize;
        else delete cellSizes[`${rowId}-${colId}`];
        localStorage.setItem('graiCellSizes', JSON.stringify(cellSizes));
    };
    // Déterminer les classes CSS
    const cellClasses = [
        'grid-cell',
        canEdit ? 'editable' : '',
        isArrowStart ? 'is-arrow-start' : '',
        editorMode === 'arrow' ? 'arrow-mode' : '',
        isHovered && canEdit ? 'cell-hovered' : '',
        hasLongContent ? 'has-long-content' : '',
        isExpanded ? 'expanded' : '',
        isResizing ? `resizing resizing-${resizeDirection}` : '',
        cellHeight ? 'has-custom-height' : '',
        cellWidth ? 'has-custom-width' : '',
        className || ''
    ].filter(Boolean).join(' ');
    // Gérer le survol
    const handleMouseEnter = ()=>{
        setIsHovered(true);
    };
    const handleMouseLeave = ()=>{
        setIsHovered(false);
    };
    // Contenu de la cellule
    const cellContentElement = isEditing ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
        ref: inputRef,
        value: cellContent,
        onChange: (e)=>setCellContent(e.target.value),
        onBlur: handleSave,
        onKeyDown: handleKeyDown,
        className: "cell-input",
        onClick: (e)=>e.stopPropagation(),
        placeholder: "Entrez le contenu ici..."
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "grid-cell-content",
        ref: contentRef,
        children: cellContent ? cellContent.split('\n').map((line, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                children: [
                    line,
                    index < cellContent.split('\n').length - 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {})
                ]
            }, index)) : canEdit && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "empty-cell-indicator",
            children: isHovered && /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "18",
                height: "18",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M17 3a2.85 2.85 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"
                })
            })
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        ref: cellRef,
        className: cellClasses,
        onClick: handleCellClick,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        title: canEdit ? "Cliquez pour \xe9diter" : editorMode === 'arrow' ? "Cliquez pour cr\xe9er une relation" : "",
        id: id,
        children: [
            cellContentElement,
            isHovered && canEdit && !isEditing && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "cell-edit-indicator",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "14",
                    height: "14",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M17 3a2.85 2.85 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"
                    })
                })
            }),
            !isEditing && hasLongContent && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                className: "cell-expand-button",
                onClick: toggleExpand,
                title: isExpanded ? "R\xe9duire" : "Afficher tout le contenu",
                children: isExpanded ? "\u2212" : "+"
            }),
            canEdit && !isEditing && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "cell-resize-handle-bottom",
                onMouseDown: handleResizeVerticalStart,
                title: "Redimensionner la hauteur",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "resize-handle-indicator"
                })
            }),
            canEdit && !isEditing && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "cell-resize-handle-right",
                onMouseDown: handleResizeHorizontalStart,
                title: "Redimensionner la largeur",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "resize-handle-indicator"
                })
            }),
            canEdit && !isEditing && (cellHeight || cellWidth) && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "cell-dimensions-controls",
                children: [
                    cellHeight && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        className: "cell-reset-size reset-height",
                        onClick: (e)=>resetDimensions(e, 'height'),
                        title: "R\xe9initialiser la hauteur",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "12",
                                height: "12",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M3 2v6h6"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M3 13a9 9 0 1 0 3-7.7L3 8"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "dimension-icon",
                                children: "\u2195"
                            })
                        ]
                    }),
                    cellWidth && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        className: "cell-reset-size reset-width",
                        onClick: (e)=>resetDimensions(e, 'width'),
                        title: "R\xe9initialiser la largeur",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "12",
                                height: "12",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M3 2v6h6"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M3 13a9 9 0 1 0 3-7.7L3 8"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "dimension-icon",
                                children: "\u2194"
                            })
                        ]
                    }),
                    cellHeight && cellWidth && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: "cell-reset-size reset-all",
                        onClick: (e)=>resetDimensions(e, 'all'),
                        title: "R\xe9initialiser toutes les dimensions",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "12",
                            height: "12",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            strokeWidth: "2",
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M3 2v6h6"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M3 13a9 9 0 1 0 3-7.7L3 8"
                                })
                            ]
                        })
                    })
                ]
            }),
            isHovered && !isEditing && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                className: "cell-subeditor-button",
                onClick: (e)=>{
                    e.stopPropagation();
                    if (onOpenSubEditor) onOpenSubEditor(rowId, colId);
                },
                title: "Ouvrir le sous-\xe9diteur",
                children: "+"
            })
        ]
    });
};
exports.default = GridCellLite;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aXJDJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const ArrowManagerLite = /*#__PURE__*/ (0, _react.forwardRef)(({ arrows, columns, rows, deleteArrow, changeArrowType, containerRef, zoomLevel, editorMode, getArrowClass, onArrowHover, onArrowLeave }, ref)=>{
    const [cellPositions, setCellPositions] = (0, _react.useState)({});
    const [activeArrow, setActiveArrow] = (0, _react.useState)(null);
    const [menuPosition, setMenuPosition] = (0, _react.useState)({
        x: 0,
        y: 0
    });
    // ✅ Sécurisation anti-NaN dès le départ
    (0, _react.useEffect)(()=>{
        if (!menuPosition || !Number.isFinite(menuPosition.x) || !Number.isFinite(menuPosition.y)) {
            console.warn("\uD83E\uDDE9 Correction automatique d'un menuPosition invalide :", menuPosition);
            setMenuPosition({
                x: 0,
                y: 0
            });
        }
    }, [
        menuPosition
    ]);
    // ✅ Calcul des positions précises des cellules avec zoom + scroll
    const calculateCellPositions = (0, _react.useCallback)(()=>{
        if (!containerRef?.current) return;
        const grid = containerRef.current.querySelector(".grai-grid");
        if (!grid) return;
        const gridRect = grid.getBoundingClientRect();
        const scrollX = containerRef.current.scrollLeft;
        const scrollY = containerRef.current.scrollTop;
        const zoomRatio = zoomLevel / 100;
        const cells = grid.querySelectorAll(".grid-cell");
        const positions = {};
        cells.forEach((cell)=>{
            const id = cell.id;
            if (!id || !id.startsWith("cell-")) return;
            const [, rowStr, colStr] = id.split("-");
            const rowId = parseInt(rowStr);
            const colId = parseInt(colStr);
            if (isNaN(rowId) || isNaN(colId)) return;
            const rect = cell.getBoundingClientRect();
            // ✅ Coordonnées ajustées selon le scroll et le zoom
            const adjustedX = (rect.left - gridRect.left + rect.width / 2 + scrollX) * zoomRatio;
            const adjustedY = (rect.top - gridRect.top + rect.height / 2 + scrollY) * zoomRatio;
            positions[`${rowId}-${colId}`] = {
                x: adjustedX,
                y: adjustedY
            };
        });
        setCellPositions(positions);
    }, [
        containerRef,
        zoomLevel
    ]);
    // ✅ Permet un recalcul externe (depuis GRAIEditor)
    (0, _react.useImperativeHandle)(ref, ()=>({
            calculateCellPositions
        }));
    // ⚙️ Recalcul automatique à chaque changement
    (0, _react.useEffect)(()=>{
        calculateCellPositions();
        const timer = setTimeout(calculateCellPositions, 300);
        return ()=>clearTimeout(timer);
    }, [
        columns,
        rows,
        zoomLevel,
        calculateCellPositions
    ]);
    // ✅ Recalcule aussi en cas de scroll du conteneur
    (0, _react.useEffect)(()=>{
        const handleScroll = ()=>calculateCellPositions();
        if (containerRef.current) containerRef.current.addEventListener("scroll", handleScroll);
        return ()=>{
            if (containerRef.current) containerRef.current.removeEventListener("scroll", handleScroll);
        };
    }, [
        calculateCellPositions
    ]);
    // ✅ Création des flèches avec position exacte centre à centre
    const createArrowPath = (arrow)=>{
        const start = cellPositions[`${arrow.start.rowId}-${arrow.start.colId}`];
        const end = cellPositions[`${arrow.end.rowId}-${arrow.end.colId}`];
        if (!start || !end) return null;
        return {
            path: `M ${start.x} ${start.y} L ${end.x} ${end.y}`,
            color: arrow.type === "decision" ? "#2563EB" : "#DC2626",
            thickness: arrow.type === "decision" ? 7 : 2
        };
    };
    // ✅ Gestion du clic sur une flèche
    const handleArrowClick = (e, arrow)=>{
        if (editorMode === "delete") {
            deleteArrow(arrow.id);
            return;
        }
        e.stopPropagation();
        const rect = containerRef?.current?.getBoundingClientRect?.() || {
            left: 0,
            top: 0
        };
        const rawX = Number(e?.clientX) || 0;
        const rawY = Number(e?.clientY) || 0;
        const left = Number(rect?.left) || 0;
        const top = Number(rect?.top) || 0;
        const x = rawX - left;
        const y = rawY - top;
        setMenuPosition({
            x: Number.isFinite(x) ? x : 0,
            y: Number.isFinite(y) ? y : 0
        });
        setActiveArrow(arrow);
    };
    // ✅ Changement de type ou suppression
    const handleTypeChange = (type)=>{
        if (activeArrow) {
            changeArrowType(activeArrow.id, type);
            setActiveArrow(null);
        }
    };
    const handleDelete = ()=>{
        if (activeArrow) {
            deleteArrow(activeArrow.id);
            setActiveArrow(null);
        }
    };
    // ✅ Valeurs sécurisées
    const safeX = menuPosition && Number.isFinite(menuPosition.x) ? menuPosition.x : 0;
    const safeY = menuPosition && Number.isFinite(menuPosition.y) ? menuPosition.y : 0;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "arrow-container",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                className: "arrow-svg",
                width: containerRef.current?.scrollWidth || "100%",
                height: containerRef.current?.scrollHeight || "100%",
                style: {
                    position: "absolute",
                    top: 0,
                    left: 0,
                    pointerEvents: "none",
                    zIndex: 10
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("marker", {
                                id: "arrowhead-decision",
                                markerWidth: "14",
                                markerHeight: "14",
                                refX: "12",
                                refY: "7",
                                orient: "auto",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("polygon", {
                                    points: "0 0, 14 7, 0 14",
                                    fill: "#3B82F6"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("marker", {
                                id: "arrowhead-information",
                                markerWidth: "10",
                                markerHeight: "6",
                                refX: "10",
                                refY: "3",
                                orient: "auto",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("polygon", {
                                    points: "0 0, 10 3, 0 6",
                                    fill: "#EF4444"
                                })
                            })
                        ]
                    }),
                    arrows.map((arrow)=>{
                        const pathData = createArrowPath(arrow);
                        if (!pathData) return null;
                        const markerId = arrow.type === "decision" ? "arrowhead-decision" : "arrowhead-information";
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            id: `arrow-${arrow.id}`,
                            d: pathData.path,
                            fill: "none",
                            stroke: pathData.color,
                            strokeWidth: pathData.thickness,
                            markerEnd: `url(#${markerId})`,
                            style: {
                                pointerEvents: "stroke",
                                cursor: "pointer"
                            },
                            onClick: (e)=>handleArrowClick(e, arrow),
                            onMouseEnter: (e)=>onArrowHover?.(arrow, e),
                            onMouseLeave: onArrowLeave
                        }, arrow.id);
                    })
                ]
            }),
            activeArrow && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "arrow-control-panel",
                style: {
                    position: "absolute",
                    left: `${safeX}px`,
                    top: `${safeY}px`,
                    zIndex: 1000,
                    background: "#fff",
                    border: "1px solid #ccc",
                    borderRadius: "8px",
                    padding: "10px"
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                        children: "Type de relation :"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: ()=>handleTypeChange("information"),
                        children: "Fl\xe8che d\u2019information"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: ()=>handleTypeChange("decision"),
                        children: "Fl\xe8che de d\xe9cision"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: handleDelete,
                        children: "Supprimer"
                    })
                ]
            })
        ]
    });
});
exports.default = ArrowManagerLite;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iUJmT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const ToolbarLite = ({ editorMode, setEditorMode, addColumn, addRow, addExternalSource, exportAsImage, saveGrid, loadGrid, loadEmptyTemplate, zoomLevel, onZoomIn, onZoomOut, onZoomReset, onShowTooltip, onHideTooltip, validateGrid, validationErrors, showValidationErrors, setShowValidationErrors, automaticValidation, setAutomaticValidation })=>{
    // États pour les formulaires
    const [newColumnTitle, setNewColumnTitle] = (0, _react.useState)('');
    const [newRowTitle, setNewRowTitle] = (0, _react.useState)('');
    const [newRowHorizon, setNewRowHorizon] = (0, _react.useState)('H');
    const [newSourceTitle, setNewSourceTitle] = (0, _react.useState)('');
    const [newSourcePosition, setNewSourcePosition] = (0, _react.useState)('top');
    const [columnInsertPosition, setColumnInsertPosition] = (0, _react.useState)('end');
    // États pour les modales
    const [showColumnModal, setShowColumnModal] = (0, _react.useState)(false);
    const [showRowModal, setShowRowModal] = (0, _react.useState)(false);
    const [showSourceModal, setShowSourceModal] = (0, _react.useState)(false);
    const [showHelpModal, setShowHelpModal] = (0, _react.useState)(false);
    const [showZoomControls, setShowZoomControls] = (0, _react.useState)(false);
    // Gérer l'ajout d'une colonne
    const handleAddColumn = ()=>{
        if (newColumnTitle.trim()) {
            addColumn(newColumnTitle, columnInsertPosition);
            setNewColumnTitle('');
            setColumnInsertPosition('end');
            setShowColumnModal(false);
        }
    };
    // Gérer l'ajout d'une ligne
    const handleAddRow = ()=>{
        if (newRowTitle.trim() && newRowHorizon.trim()) {
            addRow(newRowTitle, newRowHorizon);
            setNewRowTitle('');
            setNewRowHorizon('H');
            setShowRowModal(false);
        }
    };
    // Gérer l'ajout d'une source externe
    const handleAddSource = ()=>{
        if (newSourceTitle.trim()) {
            addExternalSource(newSourceTitle, newSourcePosition);
            setNewSourceTitle('');
            setShowSourceModal(false);
        }
    };
    // Annuler l'ajout
    const handleCancel = (modalSetter)=>{
        modalSetter(false);
    };
    // Gérer les touches dans les champs de texte
    const handleKeyDown = (e, submitHandler)=>{
        if (e.key === 'Enter') {
            e.preventDefault();
            submitHandler();
        } else if (e.key === 'Escape') {
            e.preventDefault();
            if (showColumnModal) handleCancel(setShowColumnModal);
            if (showRowModal) handleCancel(setShowRowModal);
            if (showSourceModal) handleCancel(setShowSourceModal);
        }
    };
    // Ajouter une nouvelle section dans la toolbar pour la validation GRAI
    const validationSection = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "toolbar-section",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                className: `toolbar-button ${validationErrors.length > 0 ? 'has-errors' : ''}`,
                onClick: ()=>{
                    validateGrid();
                    setShowValidationErrors(true);
                },
                title: "V\xe9rifier les r\xe8gles GRAI",
                onMouseEnter: (e)=>onShowTooltip(e, "Valider la conformit\xe9 aux r\xe8gles GRAI"),
                onMouseLeave: onHideTooltip,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "16",
                        height: "16",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                d: "M22 11.08V12a10 10 0 1 1-5.93-9.14"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                                points: "22 4 12 14.01 9 11.01"
                            })
                        ]
                    }),
                    "Validation",
                    validationErrors.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "validation-badge",
                        children: validationErrors.length
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "toolbar-toggle",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        type: "checkbox",
                        id: "auto-validation",
                        checked: automaticValidation,
                        onChange: ()=>setAutomaticValidation(!automaticValidation)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                        htmlFor: "auto-validation",
                        title: "Activer/d\xe9sactiver la validation automatique",
                        onMouseEnter: (e)=>onShowTooltip(e, "Validation en temps r\xe9el"),
                        onMouseLeave: onHideTooltip,
                        children: "Validation auto"
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "grai-toolbar",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "toolbar-section",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        className: `toolbar-button ${editorMode === 'cell' ? 'active' : ''}`,
                        onClick: ()=>setEditorMode('cell'),
                        title: "Mode \xc9dition",
                        onMouseEnter: (e)=>onShowTooltip(e, "Mode \xe9dition des cellules"),
                        onMouseLeave: onHideTooltip,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "16",
                                height: "16",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M17 3a2.85 2.85 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"
                                })
                            }),
                            "\xc9diter"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "toolbar-group",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                children: "Relations"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "relation-buttons",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        className: `toolbar-button ${editorMode === 'arrow-info' ? 'active' : ''}`,
                                        onClick: ()=>setEditorMode('arrow-info'),
                                        title: "Fl\xe8che d'information",
                                        onMouseEnter: (e)=>onShowTooltip(e, "Cr\xe9er une fl\xe8che d'information (rouge, horizontale)"),
                                        onMouseLeave: onHideTooltip,
                                        children: "\u279C Fl\xe8che d\u2019information"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        className: `toolbar-button ${editorMode === 'arrow-decision' ? 'active' : ''}`,
                                        onClick: ()=>setEditorMode('arrow-decision'),
                                        title: "Fl\xe8che de d\xe9cision",
                                        onMouseEnter: (e)=>onShowTooltip(e, "Cr\xe9er une fl\xe8che de d\xe9cision (bleue, verticale)"),
                                        onMouseLeave: onHideTooltip,
                                        children: "\u2B07 Fl\xe8che de d\xe9cision"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "toolbar-divider"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "toolbar-section",
                children: [
                    !showColumnModal ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        className: "toolbar-button",
                        onClick: ()=>setShowColumnModal(true),
                        title: "Ajouter une fonction",
                        onMouseEnter: (e)=>onShowTooltip(e, "Ajouter une nouvelle colonne"),
                        onMouseLeave: onHideTooltip,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "16",
                                height: "16",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                        x1: "12",
                                        y1: "5",
                                        x2: "12",
                                        y2: "19"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                        x1: "5",
                                        y1: "12",
                                        x2: "19",
                                        y2: "12"
                                    })
                                ]
                            }),
                            "Colonne"
                        ]
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "toolbar-modal",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                type: "text",
                                value: newColumnTitle,
                                onChange: (e)=>setNewColumnTitle(e.target.value),
                                onKeyDown: (e)=>handleKeyDown(e, handleAddColumn),
                                className: "toolbar-input",
                                placeholder: "Nom de la fonction",
                                autoFocus: true
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("select", {
                                value: columnInsertPosition,
                                onChange: (e)=>setColumnInsertPosition(e.target.value),
                                className: "toolbar-input",
                                title: "Choisir la position d'insertion",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                        value: "end",
                                        children: "\xc0 la fin"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                        value: "beforeProduct",
                                        children: "Avant \u201CG\xe9rer produits\u201D"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                        value: "afterResource",
                                        children: "Apr\xe8s \u201CG\xe9rer ressources\u201D"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: "toolbar-button confirm",
                                onClick: handleAddColumn,
                                title: "Confirmer",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "16",
                                    height: "16",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    strokeWidth: "2",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                                        points: "20 6 9 17 4 12"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: "toolbar-button cancel",
                                onClick: ()=>handleCancel(setShowColumnModal),
                                title: "Annuler",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "16",
                                    height: "16",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    strokeWidth: "2",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                            x1: "18",
                                            y1: "6",
                                            x2: "6",
                                            y2: "18"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                            x1: "6",
                                            y1: "6",
                                            x2: "18",
                                            y2: "18"
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    !showRowModal ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        className: "toolbar-button",
                        onClick: ()=>setShowRowModal(true),
                        title: "Ajouter un horizon temporel",
                        onMouseEnter: (e)=>onShowTooltip(e, "Ajouter un nouvel horizon"),
                        onMouseLeave: onHideTooltip,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "16",
                                height: "16",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                        x1: "12",
                                        y1: "5",
                                        x2: "12",
                                        y2: "19"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                        x1: "5",
                                        y1: "12",
                                        x2: "19",
                                        y2: "12"
                                    })
                                ]
                            }),
                            "Ligne"
                        ]
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "toolbar-modal",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "modal-form",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                        type: "text",
                                        value: newRowTitle,
                                        onChange: (e)=>setNewRowTitle(e.target.value),
                                        onKeyDown: (e)=>handleKeyDown(e, handleAddRow),
                                        className: "toolbar-input",
                                        placeholder: "Description (ex: 1 an)",
                                        autoFocus: true
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                        type: "text",
                                        value: newRowHorizon,
                                        onChange: (e)=>setNewRowHorizon(e.target.value),
                                        onKeyDown: (e)=>handleKeyDown(e, handleAddRow),
                                        className: "toolbar-input horizon-input",
                                        placeholder: "Code (ex: H1)"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: "toolbar-button confirm",
                                onClick: handleAddRow,
                                title: "Confirmer",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "16",
                                    height: "16",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    strokeWidth: "2",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                                        points: "20 6 9 17 4 12"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: "toolbar-button cancel",
                                onClick: ()=>handleCancel(setShowRowModal),
                                title: "Annuler",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "16",
                                    height: "16",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    strokeWidth: "2",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                            x1: "18",
                                            y1: "6",
                                            x2: "6",
                                            y2: "18"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                            x1: "6",
                                            y1: "6",
                                            x2: "18",
                                            y2: "18"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "toolbar-divider"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "toolbar-section",
                children: !showSourceModal ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                    className: "toolbar-button",
                    onClick: ()=>setShowSourceModal(true),
                    title: "Ajouter une source d'information",
                    onMouseEnter: (e)=>onShowTooltip(e, "Ajouter une source externe"),
                    onMouseLeave: onHideTooltip,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "16",
                            height: "16",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            strokeWidth: "2",
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M12 5v14"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M5 12h14"
                                })
                            ]
                        }),
                        "Source"
                    ]
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "toolbar-modal",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                            type: "text",
                            value: newSourceTitle,
                            onChange: (e)=>setNewSourceTitle(e.target.value),
                            onKeyDown: (e)=>handleKeyDown(e, handleAddSource),
                            className: "toolbar-input",
                            placeholder: "Nom de la source",
                            autoFocus: true
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("select", {
                            value: newSourcePosition,
                            onChange: (e)=>setNewSourcePosition(e.target.value),
                            className: "toolbar-input",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                    value: "top",
                                    children: "Haut"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                    value: "right",
                                    children: "Droite"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                    value: "bottom",
                                    children: "Bas"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                    value: "left",
                                    children: "Gauche"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            className: "toolbar-button confirm",
                            onClick: handleAddSource,
                            title: "Confirmer",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "16",
                                height: "16",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                                    points: "20 6 9 17 4 12"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            className: "toolbar-button cancel",
                            onClick: ()=>handleCancel(setShowSourceModal),
                            title: "Annuler",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "16",
                                height: "16",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                        x1: "18",
                                        y1: "6",
                                        x2: "6",
                                        y2: "18"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                        x1: "6",
                                        y1: "6",
                                        x2: "18",
                                        y2: "18"
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "toolbar-divider"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "toolbar-section",
                children: !showZoomControls ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                    className: "toolbar-button",
                    onClick: ()=>setShowZoomControls(true),
                    title: "Contr\xf4les de zoom",
                    onMouseEnter: (e)=>onShowTooltip(e, "Ajuster le niveau de zoom"),
                    onMouseLeave: onHideTooltip,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "16",
                            height: "16",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            strokeWidth: "2",
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                    cx: "11",
                                    cy: "11",
                                    r: "8"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                    x1: "21",
                                    y1: "21",
                                    x2: "16.65",
                                    y2: "16.65"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                    x1: "11",
                                    y1: "8",
                                    x2: "11",
                                    y2: "14"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                    x1: "8",
                                    y1: "11",
                                    x2: "14",
                                    y2: "11"
                                })
                            ]
                        }),
                        "Zoom ",
                        zoomLevel,
                        "%"
                    ]
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "toolbar-modal",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            className: "toolbar-button",
                            onClick: onZoomOut,
                            disabled: zoomLevel <= 50,
                            title: "Zoom arri\xe8re",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "16",
                                height: "16",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                        cx: "11",
                                        cy: "11",
                                        r: "8"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                        x1: "21",
                                        y1: "21",
                                        x2: "16.65",
                                        y2: "16.65"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                        x1: "8",
                                        y1: "11",
                                        x2: "14",
                                        y2: "11"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "zoom-level",
                            children: [
                                zoomLevel,
                                "%"
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            className: "toolbar-button",
                            onClick: onZoomReset,
                            title: "R\xe9initialiser le zoom",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "16",
                                height: "16",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M3 3v5h5"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            className: "toolbar-button",
                            onClick: onZoomIn,
                            disabled: zoomLevel >= 200,
                            title: "Zoom avant",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "16",
                                height: "16",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                        cx: "11",
                                        cy: "11",
                                        r: "8"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                        x1: "21",
                                        y1: "21",
                                        x2: "16.65",
                                        y2: "16.65"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                        x1: "11",
                                        y1: "8",
                                        x2: "11",
                                        y2: "14"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                        x1: "8",
                                        y1: "11",
                                        x2: "14",
                                        y2: "11"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            className: "toolbar-button cancel",
                            onClick: ()=>setShowZoomControls(false),
                            title: "Fermer",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "16",
                                height: "16",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                        x1: "18",
                                        y1: "6",
                                        x2: "6",
                                        y2: "18"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                        x1: "6",
                                        y1: "6",
                                        x2: "18",
                                        y2: "18"
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "toolbar-divider"
            }),
            validationSection,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "toolbar-divider"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "toolbar-section",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        className: "toolbar-button save",
                        onClick: saveGrid,
                        title: "Sauvegarder la grille",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "16",
                                height: "16",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                                        points: "17 21 17 13 7 13 7 21"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                                        points: "7 3 7 8 15 8"
                                    })
                                ]
                            }),
                            "Sauvegarder"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        className: "toolbar-button",
                        onClick: loadGrid,
                        title: "Charger une grille sauvegard\xe9e",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "16",
                                height: "16",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                                        points: "7 10 12 15 17 10"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                        x1: "12",
                                        y1: "15",
                                        x2: "12",
                                        y2: "3"
                                    })
                                ]
                            }),
                            "Charger"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        className: "toolbar-button export",
                        onClick: exportAsImage,
                        title: "Exporter en image",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "16",
                                height: "16",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                        x: "3",
                                        y: "3",
                                        width: "18",
                                        height: "18",
                                        rx: "2",
                                        ry: "2"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                        cx: "8.5",
                                        cy: "8.5",
                                        r: "1.5"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                                        points: "21 15 16 10 5 21"
                                    })
                                ]
                            }),
                            "Exporter"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "toolbar-divider"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "toolbar-section",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        className: "toolbar-button",
                        onClick: loadEmptyTemplate,
                        title: "Nouveau mod\xe8le vide",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "16",
                                height: "16",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M3 6h18"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
                                    })
                                ]
                            }),
                            "Nouveau"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        className: "toolbar-button",
                        onClick: ()=>setShowHelpModal(!showHelpModal),
                        title: "Aide sur l'outil GRAI",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "16",
                                height: "16",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                        cx: "12",
                                        cy: "12",
                                        r: "10"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                        x1: "12",
                                        y1: "17",
                                        x2: "12.01",
                                        y2: "17"
                                    })
                                ]
                            }),
                            "Aide"
                        ]
                    })
                ]
            }),
            showHelpModal && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "grai-help",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                        children: "Guide de l'\xe9diteur GRAI"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "L'\xe9diteur GRAI vous permet de cr\xe9er des mod\xe8les d\xe9cisionnels selon la m\xe9thode GRAI. Voici comment l'utiliser :"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("ul", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                        children: "\xc9diter les cellules"
                                    }),
                                    " : Cliquez sur une cellule pour \xe9diter son contenu"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                        children: "Ajouter des fl\xe8ches"
                                    }),
                                    ' : Utilisez le mode "Relations" puis cliquez sur une cellule de d\xe9part puis sur une cellule d\'arriv\xe9e'
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                        children: "Types de fl\xe8ches"
                                    }),
                                    " : Flux de d\xe9cision (bleu) ou Flux d'information (rouge)"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                        children: "Sources externes"
                                    }),
                                    " : Informations provenant de l'ext\xe9rieur du syst\xe8me"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                        children: "Navigation"
                                    }),
                                    " : Utilisez la molette de souris (avec Ctrl) pour zoomer, ou cliquez et faites glisser avec le bouton du milieu (ou Alt+clic gauche) pour d\xe9placer la grille"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                        children: "R\xe8gles GRAI appliqu\xe9es"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("ul", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                        children: "CMG1"
                                    }),
                                    " : Un cadre de d\xe9cision ne peut \xeatre re\xe7u par ce m\xeame centre"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                        children: "CMG2/4"
                                    }),
                                    " : Un cadre de d\xe9cision ne peut \xeatre \xe9mis d'une pseudo-fonction \xe0 une autre"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                        children: "CMG3"
                                    }),
                                    " : La fonction 'informations externes' est plac\xe9e exclusivement en colonne 1"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                        children: "CMG5"
                                    }),
                                    " : La fonction 'informations internes' est plac\xe9e exclusivement en derni\xe8re colonne"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                        children: "CMG6/7/8"
                                    }),
                                    " : Les fonctions 'g\xe9rer les produits', 'g\xe9rer les ressources', et 'planifier' sont obligatoires"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                        children: "CMG9"
                                    }),
                                    " : Les p\xe9riodes des niveaux d\xe9cisionnels doivent \xeatre class\xe9es par ordre d\xe9croissant"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                        children: "CMG10"
                                    }),
                                    " : Les niveaux d\xe9cisionnels ne peuvent \xeatre moins de trois dans une grille GRAI"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "Pour plus d'informations sur la m\xe9thode GRAI, consultez la documentation technique."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: "toolbar-button",
                        onClick: ()=>setShowHelpModal(false),
                        children: "Fermer"
                    })
                ]
            })
        ]
    });
};
exports.default = ToolbarLite;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gZwrX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const ExternalSourceLite = ({ source, onDelete })=>{
    const [isEditing, setIsEditing] = (0, _react.useState)(false);
    const [title, setTitle] = (0, _react.useState)(source.title);
    const inputRef = (0, _react.useRef)(null);
    // Mettre à jour le titre local lorsque le titre de la source change
    (0, _react.useEffect)(()=>{
        setTitle(source.title);
    }, [
        source.title
    ]);
    // Focus sur l'input lors de l'entrée en mode édition
    (0, _react.useEffect)(()=>{
        if (isEditing && inputRef.current) inputRef.current.focus();
    }, [
        isEditing
    ]);
    // Gérer le début de l'édition
    const handleEditStart = ()=>{
        setIsEditing(true);
    };
    // Gérer l'enregistrement des modifications
    const handleSave = ()=>{
        // On pourrait ajouter une fonction de mise à jour dans les props
        setIsEditing(false);
    };
    // Gérer la touche Entrée pendant l'édition
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter') {
            e.preventDefault();
            handleSave();
        } else if (e.key === 'Escape') {
            setIsEditing(false);
            setTitle(source.title);
        }
    };
    // Déterminer les classes CSS en fonction de la position
    const sourceClasses = [
        'external-source',
        `position-${source.position}`
    ].join(' ');
    // Contenu de la source
    const sourceContent = isEditing ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
        ref: inputRef,
        type: "text",
        value: title,
        onChange: (e)=>setTitle(e.target.value),
        onBlur: handleSave,
        onKeyDown: handleKeyDown,
        className: "external-source-input",
        onClick: (e)=>e.stopPropagation()
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "external-source-content",
        onClick: handleEditStart,
        children: title
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: sourceClasses,
        children: [
            sourceContent,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                className: "external-source-delete",
                onClick: onDelete,
                title: "Supprimer",
                children: "\xd7"
            })
        ]
    });
};
exports.default = ExternalSourceLite;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gbRmf":[function() {},{}],"55Ura":[function() {},{}],"7eeEz":[function() {},{}],"fdZ0G":[function() {},{}],"5fsmo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AuthProvider", ()=>AuthProvider);
parcelHelpers.export(exports, "useAuth", ()=>useAuth);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const AuthContext = /*#__PURE__*/ (0, _react.createContext)(null);
const AuthProvider = ({ children })=>{
    // Vérifier si l'utilisateur est déjà authentifié dans localStorage
    const [isAuthenticated, setIsAuthenticated] = (0, _react.useState)(()=>{
        return localStorage.getItem('isAuthenticated') === 'true';
    });
    // Ajouter le statut d'administrateur
    const [isAdmin, setIsAdmin] = (0, _react.useState)(()=>{
        return localStorage.getItem('isAdmin') === 'true';
    });
    // Mettre à jour localStorage lorsque isAuthenticated change
    (0, _react.useEffect)(()=>{
        localStorage.setItem('isAuthenticated', isAuthenticated);
        console.log("\xc9tat d'authentification mis \xe0 jour:", isAuthenticated);
    }, [
        isAuthenticated
    ]);
    // Mettre à jour localStorage lorsque isAdmin change
    (0, _react.useEffect)(()=>{
        localStorage.setItem('isAdmin', isAdmin);
        console.log("\xc9tat d'administrateur mis \xe0 jour:", isAdmin);
    }, [
        isAdmin
    ]);
    const login = (adminStatus = false)=>{
        console.log("Fonction login appel\xe9e - authentification de l'utilisateur");
        setIsAuthenticated(true);
        setIsAdmin(adminStatus);
        localStorage.setItem('isAuthenticated', 'true');
        localStorage.setItem('isAdmin', adminStatus.toString());
    };
    const logout = ()=>{
        console.log("Fonction logout appel\xe9e - d\xe9connexion de l'utilisateur");
        setIsAuthenticated(false);
        setIsAdmin(false);
        localStorage.removeItem('isAuthenticated');
        localStorage.removeItem('isAdmin');
        localStorage.setItem('isAuthenticated', 'false');
        localStorage.setItem('isAdmin', 'false');
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(AuthContext.Provider, {
        value: {
            isAuthenticated,
            isAdmin,
            login,
            logout
        },
        children: children
    });
};
const useAuth = ()=>{
    const context = (0, _react.useContext)(AuthContext);
    if (!context) throw new Error('useAuth must be used within an AuthProvider');
    return context;
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jRUQi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EnterpriseProvider", ()=>EnterpriseProvider);
parcelHelpers.export(exports, "useEnterprise", ()=>useEnterprise);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const EnterpriseContext = /*#__PURE__*/ (0, _react.createContext)(null);
const EnterpriseProvider = ({ children })=>{
    const [companyName, setCompanyName] = (0, _react.useState)('');
    const [companySize, setCompanySize] = (0, _react.useState)('');
    const [activitySector, setActivitySector] = (0, _react.useState)('');
    const [enterpriseId, setEnterpriseId] = (0, _react.useState)(()=>localStorage.getItem('enterpriseId') || '');
    const [scores, setScores] = (0, _react.useState)({
        environmental: 0,
        social: 0,
        modernization: 0,
        leadTime: 0,
        cost: 0,
        quality: 0,
        clientConsumer: 0
    });
    // âœ… Fonction pour mettre à  jour les scores
    const updateScores = (newScores)=>{
        if (JSON.stringify(newScores) !== JSON.stringify(scores)) setScores(newScores);
    };
    // âœ… Fonction pour récupérer les données d'entreprise
    const fetchEnterpriseData = async (id)=>{
        try {
            console.log(`fetchEnterpriseData appel\xe9 avec ID: ${id}`);
            const response = await fetch(`${"/api"}/api/enterprise/${id}`, {
                headers: {
                    'Authorization': localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : ''
                }
            });
            if (!response.ok) {
                console.error(`Erreur HTTP: ${response.status} - ${await response.text()}`);
                throw new Error(`Erreur HTTP: ${response.status}`);
            }
            const data = await response.json();
            console.log("Donn\xe9es entreprise re\xe0\xa7ues:", data);
            // Mettre à  jour l'état local
            setCompanyName(data.company_name || '');
            setCompanySize(data.company_size || '');
            setActivitySector(data.activity_sector || '');
            setEnterpriseId(id);
            return data;
        } catch (error) {
            console.error("Erreur lors de la r\xe9cup\xe9ration des donn\xe9es:", error);
            return {
                success: false,
                error: error.message
            };
        }
    };
    // âœ… Fonction pour enregistrer les données d'entreprise
    const saveEnterpriseData = async (data)=>{
        try {
            const response = await fetch(`${"/api"}/api/save-enterprises`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : ''
                },
                body: JSON.stringify(data)
            });
            if (!response.ok) throw new Error(`Erreur HTTP: ${response.status}`);
            const result = await response.json();
            // âœ… Mise à  jour de l'état local
            setCompanyName(data.company_name);
            setCompanySize(data.company_size);
            setActivitySector(data.activity_sector);
            // âœ… Stocker l'ID dans le localStorage (compatibilité totale avec le PDFUploader)
            if (result.enterpriseId || result.case_id || result.id) {
                const newId = result.enterpriseId || result.case_id || result.id;
                // Sauvegarde dans le state et localStorage
                setEnterpriseId(newId);
                localStorage.setItem('enterpriseId', newId);
                // ðŸ” Synchronisation avec le PDFUploader
                localStorage.setItem('caseId', newId);
                console.log("Nouveau caseId enregistr\xe9 :", newId);
            } else console.warn("Aucun ID trouv\xe9 dans la r\xe9ponse du backend :", result);
            return result;
        } catch (error) {
            console.error("Erreur lors de la sauvegarde des donn\xe9es:", error);
            return {
                success: false,
                error: error.message
            };
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(EnterpriseContext.Provider, {
        value: {
            companyName,
            setCompanyName,
            companySize,
            setCompanySize,
            activitySector,
            setActivitySector,
            enterpriseId,
            setEnterpriseId,
            scores,
            updateScores,
            fetchEnterpriseData,
            saveEnterpriseData
        },
        children: children
    });
};
const useEnterprise = ()=>{
    const context = (0, _react.useContext)(EnterpriseContext);
    if (!context) throw new Error('useEnterprise must be used within an EnterpriseProvider');
    return context;
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aaKMz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Header", ()=>(0, _headerDefault.default));
parcelHelpers.export(exports, "NavbarPrimary", ()=>(0, _navbarPrimaryDefault.default));
parcelHelpers.export(exports, "NavbarSecondary", ()=>(0, _navbarSecondaryDefault.default));
parcelHelpers.export(exports, "HeaderProvider", ()=>(0, _headerProviderDefault.default));
parcelHelpers.export(exports, "getNavigationConfig", ()=>(0, _navigationConfig.getNavigationConfig));
var _header = require("./Header");
var _headerDefault = parcelHelpers.interopDefault(_header);
var _navbarPrimary = require("./NavbarPrimary");
var _navbarPrimaryDefault = parcelHelpers.interopDefault(_navbarPrimary);
var _navbarSecondary = require("./NavbarSecondary");
var _navbarSecondaryDefault = parcelHelpers.interopDefault(_navbarSecondary);
var _headerProvider = require("./HeaderProvider");
var _headerProviderDefault = parcelHelpers.interopDefault(_headerProvider);
var _navigationConfig = require("./navigationConfig");
exports.default = (0, _headerProviderDefault.default);

},{"./Header":"2OveL","./NavbarPrimary":"eVVir","./NavbarSecondary":"kLN8i","./HeaderProvider":"ncLku","./navigationConfig":"5RLK2","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2OveL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navbarPrimary = require("./NavbarPrimary");
var _navbarPrimaryDefault = parcelHelpers.interopDefault(_navbarPrimary);
var _navbarSecondary = require("./NavbarSecondary");
var _navbarSecondaryDefault = parcelHelpers.interopDefault(_navbarSecondary);
var _frame11322 = require("../Frame11322");
var _frame11322Default = parcelHelpers.interopDefault(_frame11322);
var _headerCss = require("./Header.css");
const icamLogo = "https://upload.wikimedia.org/wikipedia/commons/3/3f/ICAM_logo.png";
/**
 * Composant Header unifié pour l'ensemble du site
 */ const Header = ({ primaryItems = [], secondaryItems = [], showSecondary = false })=>{
    const [isMobile, setIsMobile] = (0, _react.useState)(false);
    const [menuOpen, setMenuOpen] = (0, _react.useState)(false);
    const [collapsed, setCollapsed] = (0, _react.useState)(false); // ✅ pour replier/déplier le header
    const location = (0, _reactRouterDom.useLocation)();
    // ✅ Gestion responsive
    (0, _react.useEffect)(()=>{
        const handleResize = ()=>{
            setIsMobile(window.innerWidth <= 768);
            if (window.innerWidth > 768) setMenuOpen(false);
        };
        window.addEventListener("resize", handleResize);
        handleResize();
        return ()=>window.removeEventListener("resize", handleResize);
    }, []);
    // ✅ Fermer le menu mobile au changement de page
    (0, _react.useEffect)(()=>{
        setMenuOpen(false);
    }, [
        location.pathname
    ]);
    // ✅ Toggle menu mobile
    const toggleMenu = ()=>setMenuOpen(!menuOpen);
    // ✅ Toggle header plié/déplié
    const toggleHeader = ()=>setCollapsed(!collapsed);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("header", {
                className: `app-header ${collapsed ? "collapsed" : ""}`,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "header-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "header-logo-container",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                to: "/home",
                                className: "header-logo-link",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    src: icamLogo,
                                    alt: "ICAM Logo",
                                    className: "header-logo"
                                })
                            })
                        }),
                        isMobile ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                    className: `mobile-menu-button ${menuOpen ? "active" : ""}`,
                                    onClick: toggleMenu,
                                    "aria-label": "Menu principal",
                                    "aria-expanded": menuOpen,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "hamburger-line"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "hamburger-line"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "hamburger-line"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: `mobile-menu ${menuOpen ? "open" : ""}`,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navbarPrimaryDefault.default), {
                                            items: primaryItems,
                                            isMobile: true
                                        }),
                                        showSecondary && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navbarSecondaryDefault.default), {
                                            items: secondaryItems,
                                            isMobile: true
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11322Default.default), {
                                            className: "logout-button-mobile"
                                        })
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "navigation-container",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navbarPrimaryDefault.default), {
                                    items: primaryItems
                                }),
                                showSecondary && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navbarSecondaryDefault.default), {
                                    items: secondaryItems
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11322Default.default), {
                                    className: "logout-button"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                className: `toggle-header-button ${collapsed ? "collapsed" : ""}`,
                onClick: toggleHeader,
                title: collapsed ? "Afficher le header" : "Masquer le header",
                children: collapsed ? "\u25BC" : "\u25B2"
            })
        ]
    });
};
exports.default = Header;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["Link","b9X5n"],["useLocation","ditZI"]],"./NavbarPrimary":"eVVir","./NavbarSecondary":"kLN8i","../Frame11322":"ju7Cp","./Header.css":"3l5hh","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eVVir":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom"); // ✅ useHistory au lieu de useNavigate
var _navbarPrimaryCss = require("./NavbarPrimary.css");
var _navigationConfig = require("./navigationConfig");
const NavbarPrimary = ()=>{
    const [openMenu, setOpenMenu] = (0, _react.useState)(null);
    const menuRef = (0, _react.useRef)(null);
    const history = (0, _reactRouterDom.useHistory)(); // ✅ React Router v5
    // Ferme le menu si clic en dehors
    (0, _react.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (menuRef.current && !menuRef.current.contains(event.target)) setOpenMenu(null);
        };
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>document.removeEventListener("mousedown", handleClickOutside);
    }, []);
    const toggleMenu = (menuLabel)=>{
        setOpenMenu(openMenu === menuLabel ? null : menuLabel);
    };
    const getSubMenu = (label)=>{
        if (label === "Modeling") return 0, _navigationConfig.modelingViews;
        if (label === "Management") return 0, _navigationConfig.leanTools;
        return [];
    };
    const handleNavigation = (path)=>{
        history.push(path); // ✅ version v5
        setOpenMenu(null);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("nav", {
        className: "navbar",
        ref: menuRef,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
            className: "nav-list",
            children: (0, _navigationConfig.primaryNavigation).map((item, index)=>{
                const subItems = getSubMenu(item.label);
                const isOpen = openMenu === item.label;
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                    className: `nav-item ${subItems.length ? "has-submenu" : ""}`,
                    children: subItems.length > 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                className: "nav-link-button",
                                onClick: ()=>toggleMenu(item.label),
                                children: [
                                    item.label,
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: `arrow ${isOpen ? "open" : ""}`,
                                        children: "\u25BC"
                                    })
                                ]
                            }),
                            isOpen && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "submenu-wrapper",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
                                    className: "submenu",
                                    children: subItems.map((sub, subIndex)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                className: "submenu-link",
                                                onClick: ()=>handleNavigation(sub.path),
                                                children: sub.label
                                            })
                                        }, subIndex))
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.NavLink), {
                        to: item.path,
                        className: "nav-link",
                        activeClassName: "active",
                        exact: item.exact,
                        onClick: ()=>setOpenMenu(null),
                        children: item.label
                    })
                }, index);
            })
        })
    });
};
exports.default = NavbarPrimary;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["NavLink","b9X5n"],["useHistory","ditZI"]],"./NavbarPrimary.css":"caujc","./navigationConfig":"5RLK2","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"caujc":[function() {},{}],"5RLK2":[function(require,module,exports,__globalThis) {
/**
 * ============================================================
 * CONFIGURATION GLOBALE DE LA NAVIGATION — VERSION CORRIGÉE
 * ============================================================
 */ // ======================
// NAVIGATION PRINCIPALE
// ======================
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "primaryNavigation", ()=>primaryNavigation);
parcelHelpers.export(exports, "modelingViews", ()=>modelingViews);
parcelHelpers.export(exports, "leanTools", ()=>leanTools);
parcelHelpers.export(exports, "navigationConfigs", ()=>navigationConfigs);
parcelHelpers.export(exports, "getNavigationConfig", ()=>getNavigationConfig);
const primaryNavigation = [
    {
        label: "Acquisition",
        path: "/acquisition",
        exact: true
    },
    {
        label: "Modeling",
        path: "/modeling",
        exact: true
    },
    {
        label: "Management",
        path: "/management",
        exact: true
    },
    {
        label: "Saving",
        path: "/pdf-uploader",
        exact: true
    },
    {
        label: "Analysis",
        path: "/analysisbeta",
        exact: true
    },
    {
        label: "Conception",
        path: "/conception",
        exact: true
    },
    {
        label: "Evaluation",
        path: "/implementation",
        exact: true
    }
];
const modelingViews = [
    {
        label: "Functional View",
        path: "/functional-view-1",
        exact: true
    },
    {
        label: "Process View",
        path: "/process-view-1",
        exact: true
    },
    {
        label: "Physical Model",
        path: "/physical-model-1",
        exact: true
    },
    {
        label: "Decisional View",
        path: "/decisional-model-1",
        exact: true
    },
    {
        label: "Information Model",
        path: "/informational-model-1",
        exact: true
    }
];
const leanTools = [
    {
        label: "VSM",
        path: "/lean-vsm-1",
        exact: true
    },
    {
        label: "5S",
        path: "/5s-1",
        exact: true
    },
    {
        label: "Kaizen",
        path: "/kaizen-1",
        exact: true
    },
    {
        label: "SMED",
        path: "/smed-1",
        exact: true
    },
    {
        label: "Kanban",
        path: "/kanban-1",
        exact: true
    },
    {
        label: "Visual Management",
        path: "/visual-management-1",
        exact: true
    }
];
const navigationConfigs = {
    acquisition: {
        primary: primaryNavigation,
        secondary: []
    },
    modeling: {
        primary: primaryNavigation,
        secondary: modelingViews
    },
    management: {
        primary: primaryNavigation,
        secondary: leanTools
    },
    analysis: {
        primary: primaryNavigation,
        secondary: []
    },
    conception: {
        primary: primaryNavigation,
        secondary: []
    },
    implementation: {
        primary: primaryNavigation,
        secondary: []
    },
    admin: {
        primary: [
            {
                label: "Dashboard",
                path: "/admin",
                exact: true
            },
            {
                label: "Users",
                path: "/admin/users",
                exact: true
            },
            {
                label: "Enterprises",
                path: "/admin/enterprises",
                exact: true
            },
            {
                label: "Settings",
                path: "/admin/settings",
                exact: true
            }
        ],
        secondary: []
    }
};
// ======================
// ROUTES ASSOCIÉES PAR DOMAINE
// ======================
const modelingRoutes = [
    "modeling",
    "functional-view",
    "process-view",
    "physical-model",
    "decisional-model",
    "informational-model"
];
// Pas besoin d'ajouter pdf-uploader ici → il n'est plus dans Modeling
const managementRoutes = [
    "management",
    "lean",
    "vsm",
    "5s",
    "kaizen",
    "smed",
    "kanban",
    "visual-management"
];
const getNavigationConfig = (pathname)=>{
    const path = pathname.toLowerCase();
    if (path.startsWith("/acquisition")) return navigationConfigs.acquisition;
    if (modelingRoutes.some((route)=>path.includes(route))) return navigationConfigs.modeling;
    if (managementRoutes.some((route)=>path.includes(route))) return navigationConfigs.management;
    if (path.startsWith("/analysis")) return navigationConfigs.analysis;
    if (path.startsWith("/conception")) return navigationConfigs.conception;
    if (path.startsWith("/implementation")) return navigationConfigs.implementation;
    if (path.startsWith("/admin")) return navigationConfigs.admin;
    return {
        primary: primaryNavigation,
        secondary: []
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kLN8i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navbarSecondaryCss = require("./NavbarSecondary.css");
/**
 * Composant pour la barre de navigation secondaire
 * @param {Object} props - Les propriétés du composant
 * @param {Array} props.items - Items de navigation secondaire
 * @param {boolean} props.isMobile - Si le composant est affiché en version mobile
 */ const NavbarSecondary = ({ items = [], isMobile = false })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("nav", {
        className: `navbar-secondary ${isMobile ? "mobile" : ""}`,
        children: items.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
            className: "nav-list-secondary",
            children: items.map((item, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                    className: "nav-item-secondary",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.NavLink), {
                        to: item.path,
                        className: ({ isActive })=>`nav-link-secondary ${isActive ? "active" : ""}`,
                        end: item.exact ? "true" : undefined,
                        children: [
                            item.icon && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "nav-icon",
                                children: item.icon
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "nav-label",
                                children: item.label
                            })
                        ]
                    })
                }, `secondary-${index}`))
        })
    });
};
exports.default = NavbarSecondary;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"b9X5n","./NavbarSecondary.css":"iojum","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iojum":[function() {},{}],"ju7Cp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame11322Css = require("./Frame11322.css");
var _reactRouterDom = require("react-router-dom");
var _authContext = require("../../context/AuthContext");
function Frame11322(props) {
    const { className } = props;
    const { logout } = (0, _authContext.useAuth)();
    const history = (0, _reactRouterDom.useHistory)();
    const handleLogout = (e)=>{
        e.preventDefault();
        e.stopPropagation(); // Empêcher toute propagation d'événement
        console.log("Bouton de d\xe9connexion cliqu\xe9");
        // Forcer la suppression de l'état d'authentification dans localStorage
        localStorage.removeItem('isAuthenticated');
        localStorage.setItem('isAuthenticated', 'false');
        // Appeler explicitement la fonction logout du contexte d'authentification
        logout();
        console.log("\xc9tat d'authentification mis \xe0 jour, redirection vers la page de connexion");
        // Rediriger vers la page de connexion avec rechargement complet
        window.location.href = '/';
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `frame-113-2 ${className || ""}`,
        onClick: handleLogout,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "logout valign-text-middle inter-medium-rum-swizzle-18px",
            children: "Logout"
        })
    });
}
exports.default = Frame11322;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./Frame11322.css":"2k6TS","react-router-dom":"ditZI","../../context/AuthContext":"5fsmo","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2k6TS":[function() {},{}],"3l5hh":[function() {},{}],"ncLku":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _header = require("./Header");
var _headerDefault = parcelHelpers.interopDefault(_header);
var _navigationConfig = require("./navigationConfig");
const HeaderProvider = ({ children, logoPath })=>{
    const location = (0, _reactRouterDom.useLocation)();
    // Pages sans header
    const excludedPaths = [
        "/",
        "/login",
        "/inscription"
    ];
    const isExcludedPath = excludedPaths.some((path)=>location.pathname === path || location.pathname.startsWith(path + "/"));
    if (isExcludedPath) return children;
    // 🔍 Debug pour vérifier la configuration reçue
    const config = (0, _navigationConfig.getNavigationConfig)(location.pathname);
    console.log("\uD83D\uDCCD PAGE:", location.pathname);
    console.log("\uD83D\uDCE6 CONFIG:", config);
    const { primary, secondary } = config;
    const showSecondary = secondary && secondary.length > 0;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "page-with-header",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerDefault.default), {
                logo: logoPath || "/img/1200px-logo-icam---2008-1@2x.png",
                primaryItems: primary,
                secondaryItems: secondary,
                showSecondary: showSecondary
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("main", {
                className: "main-content",
                children: children
            })
        ]
    });
};
exports.default = HeaderProvider;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"ditZI","./Header":"2OveL","./navigationConfig":"5RLK2","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hsdzg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
var _authContext = require("../../context/AuthContext");
var _adminCss = require("./Admin.css");
var _adminDashboardCss = require("./AdminDashboard.css");
var _userDetails = require("./UserDetails");
var _userDetailsDefault = parcelHelpers.interopDefault(_userDetails);
var _advancedUserStats = require("./AdvancedUserStats");
var _advancedUserStatsDefault = parcelHelpers.interopDefault(_advancedUserStats);
var _userManagement = require("./UserManagement");
var _userManagementDefault = parcelHelpers.interopDefault(_userManagement);
var _caseManagement = require("./CaseManagement");
var _caseManagementDefault = parcelHelpers.interopDefault(_caseManagement);
var _casePerformance = require("./CasePerformance");
var _casePerformanceDefault = parcelHelpers.interopDefault(_casePerformance);
var _reactChartjs2 = require("react-chartjs-2");
var _chartJs = require("chart.js");
var _fa = require("react-icons/fa");
(0, _chartJs.Chart).register((0, _chartJs.CategoryScale), (0, _chartJs.LinearScale), (0, _chartJs.PointElement), (0, _chartJs.LineElement), (0, _chartJs.BarElement), (0, _chartJs.ArcElement), (0, _chartJs.Title), (0, _chartJs.Tooltip), (0, _chartJs.Legend));
const DashboardMap = /*#__PURE__*/ (0, _react.lazy)(()=>require("c6c60f69209f5b8e"));
const AdvancedAnalytics = /*#__PURE__*/ (0, _react.lazy)(()=>require("724a14fdf923c0f1"));
function Admin() {
    const [users, setUsers] = (0, _react.useState)([]);
    const [statistics, setStatistics] = (0, _react.useState)({
        user_count: 0,
        enterprise_count: 0,
        case_count: 0,
        completed_cases: 0,
        new_cases_week: 0
    });
    const [userStats, setUserStats] = (0, _react.useState)(null);
    const [activeTab, setActiveTab] = (0, _react.useState)('dashboard');
    const [isLoading, setIsLoading] = (0, _react.useState)(true);
    const [error, setError] = (0, _react.useState)('');
    const [timeframe, setTimeframe] = (0, _react.useState)('week');
    const [refreshInterval, setRefreshInterval] = (0, _react.useState)(null);
    const [isDarkMode, setIsDarkMode] = (0, _react.useState)(()=>{
        return localStorage.getItem('adminDarkMode') === 'true';
    });
    const [dashboardLayout, setDashboardLayout] = (0, _react.useState)('default');
    const [showNotifications, setShowNotifications] = (0, _react.useState)(false);
    const [notifications, setNotifications] = (0, _react.useState)([]);
    const [trendData, setTrendData] = (0, _react.useState)({
        labels: [],
        datasets: []
    });
    const [showExportMenu, setShowExportMenu] = (0, _react.useState)(false);
    const [kpiTargets, setKpiTargets] = (0, _react.useState)({
        user_growth: 10,
        case_completion: 75,
        active_users: 50
    });
    const [lastUpdate, setLastUpdate] = (0, _react.useState)(new Date());
    const [recentActivity, setRecentActivity] = (0, _react.useState)([]);
    const { isAdmin, isAuthenticated, logout } = (0, _authContext.useAuth)();
    const history = (0, _reactRouterDom.useHistory)();
    // Appliquer le thème dès le chargement initial
    (0, _react.useEffect)(()=>{
        document.body.classList.toggle('dark-theme', isDarkMode);
        document.body.classList.toggle('light-theme', !isDarkMode);
        if (isDarkMode) document.documentElement.setAttribute('data-theme', 'dark');
        else document.documentElement.setAttribute('data-theme', 'light');
    }, []);
    (0, _react.useEffect)(()=>{
        if (!isAuthenticated) {
            history.push('/login');
            return;
        }
        if (!isAdmin) {
            history.push('/home');
            return;
        }
        fetchData();
        fetchRecentActivity();
        setupWebSocket();
        document.body.classList.toggle('dark-theme', isDarkMode);
        document.body.classList.toggle('light-theme', !isDarkMode);
        localStorage.setItem('adminDarkMode', isDarkMode);
        return ()=>{
            if (refreshInterval) clearInterval(refreshInterval);
        };
    }, [
        isAuthenticated,
        isAdmin,
        history,
        isDarkMode
    ]);
    (0, _react.useEffect)(()=>{
        if (refreshInterval) clearInterval(refreshInterval);
        if (activeTab === 'dashboard') {
            const interval = setInterval(()=>{
                fetchData(true);
                setLastUpdate(new Date());
            }, 60000);
            setRefreshInterval(interval);
        }
        return ()=>{
            if (refreshInterval) clearInterval(refreshInterval);
        };
    }, [
        activeTab
    ]);
    (0, _react.useEffect)(()=>{
        fetchTrendData();
    }, [
        timeframe
    ]);
    const setupWebSocket = ()=>{
        try {
            // Vérifier si l'URL WebSocket est disponible
            const wsUrl = undefined;
            if (!wsUrl) {
                console.log("URL WebSocket non d\xe9finie, fonctionnement en mode d\xe9mo");
                return;
            }
            const ws = new WebSocket(`${wsUrl}/admin/updates`);
            ws.onopen = ()=>{
                console.log('WebSocket connection established');
                addNotification({
                    type: 'success',
                    message: "Connexion temps r\xe9el \xe9tablie",
                    timestamp: Date.now()
                });
            };
            ws.onmessage = (event)=>{
                const data = JSON.parse(event.data);
                if (data.type === 'stats_update') {
                    setStatistics((prev)=>({
                            ...prev,
                            ...data.payload
                        }));
                    setLastUpdate(new Date());
                } else if (data.type === 'notification') {
                    addNotification(data.payload);
                    fetchRecentActivity();
                }
            };
            ws.onerror = (error)=>{
                console.error('WebSocket error:', error);
                addNotification({
                    type: 'error',
                    message: 'Erreur de connexion WebSocket',
                    timestamp: Date.now()
                });
            };
            return ()=>{
                ws.close();
            };
        } catch (error) {
            console.error('Failed to setup WebSocket:', error);
            // Simuler quelques notifications en mode démo
            setTimeout(()=>{
                addNotification({
                    type: 'info',
                    message: "Mode d\xe9mo activ\xe9 - donn\xe9es g\xe9n\xe9r\xe9es automatiquement",
                    timestamp: Date.now()
                });
            }, 2000);
        }
    };
    const addNotification = (notification)=>{
        setNotifications((prev)=>[
                {
                    id: Date.now(),
                    ...notification
                },
                ...prev
            ].slice(0, 10));
    };
    const fetchData = async (silent = false)=>{
        if (!silent) setIsLoading(true);
        try {
            const apiUrl = "/api";
            if (!apiUrl) {
                // Mode démo si l'API n'est pas disponible
                console.log("API URL non d\xe9finie, utilisation des donn\xe9es de d\xe9monstration");
                setDemoData();
                if (!silent) setIsLoading(false);
                return;
            }
            try {
                const usersResponse = await (0, _axiosDefault.default).get(`${apiUrl}/admin/users`, {
                    headers: {
                        'Authorization': 'Bearer admin',
                        'Content-Type': 'application/json',
                        'ngrok-skip-browser-warning': 'true'
                    },
                    timeout: 5000
                });
                setUsers(usersResponse.data);
            } catch (error) {
                console.error('Erreur lors du chargement des utilisateurs:', error);
                // Utiliser des données fictives pour les utilisateurs
                setUsers(generateDemoUsers(25));
            }
            try {
                const statsResponse = await (0, _axiosDefault.default).get(`${apiUrl}/admin/statistics`, {
                    params: {
                        timeframe
                    },
                    headers: {
                        'Authorization': 'Bearer admin',
                        'Content-Type': 'application/json',
                        'ngrok-skip-browser-warning': 'true'
                    },
                    timeout: 5000
                });
                setStatistics(statsResponse.data);
            } catch (error) {
                console.error('Erreur lors du chargement des statistiques:', error);
                // Utiliser des données fictives pour les statistiques
                setStatistics(generateDemoStats());
            }
            try {
                const userStatsResponse = await (0, _axiosDefault.default).get(`${apiUrl}/api/users/statistics`, {
                    params: {
                        timeframe
                    },
                    headers: {
                        'Authorization': 'Bearer admin',
                        'Content-Type': 'application/json',
                        'ngrok-skip-browser-warning': 'true'
                    },
                    timeout: 5000
                });
                setUserStats(userStatsResponse.data);
            } catch (statsError) {
                console.error("Erreur lors du chargement des statistiques avanc\xe9es:", statsError);
                // Utiliser des données fictives pour les statistiques utilisateurs
                setUserStats(generateDemoUserStats());
            }
        } catch (error) {
            console.error("Erreur lors du chargement des donn\xe9es:", error);
            setError("Erreur lors du chargement des donn\xe9es. Mode d\xe9mo activ\xe9.");
            setDemoData();
        } finally{
            if (!silent) setIsLoading(false);
        }
    };
    const fetchRecentActivity = async ()=>{
        try {
            const apiUrl = "/api";
            if (!apiUrl) {
                // Mode démo 
                setRecentActivity(generateDemoActivity());
                return;
            }
            const response = await (0, _axiosDefault.default).get(`${apiUrl}/admin/recent-activity`, {
                headers: {
                    'Authorization': 'Bearer admin',
                    'Content-Type': 'application/json',
                    'ngrok-skip-browser-warning': 'true'
                },
                timeout: 5000
            });
            setRecentActivity(response.data);
        } catch (error) {
            console.error("Erreur lors du chargement des activit\xe9s r\xe9centes:", error);
            setRecentActivity(generateDemoActivity());
        }
    };
    const generateDemoUsers = (count = 25)=>{
        const roles = [
            'user',
            'admin'
        ];
        const users = [];
        for(let i = 0; i < count; i++)users.push({
            id: i + 1,
            username: `user${i + 1}`,
            email: `user${i + 1}@example.com`,
            is_admin: i < 3 ? true : false,
            is_active: Math.random() > 0.2,
            last_login: new Date(Date.now() - Math.floor(Math.random() * 604800000)),
            login_count: Math.floor(Math.random() * 50)
        });
        return users;
    };
    const generateDemoStats = ()=>{
        return {
            user_count: 25,
            enterprise_count: 12,
            case_count: 45,
            completed_cases: 32,
            in_progress_cases: 10,
            new_cases_week: 8,
            completed_cases_week: 6,
            growth_users: 12.5,
            growth_cases: 15.3,
            sectors_data: [
                {
                    name: 'Technologie',
                    cases: 15
                },
                {
                    name: "Sant\xe9",
                    cases: 10
                },
                {
                    name: "\xe0\u2030ducation",
                    cases: 8
                },
                {
                    name: 'Finance',
                    cases: 7
                },
                {
                    name: 'Autres',
                    cases: 5
                }
            ]
        };
    };
    const generateDemoUserStats = ()=>{
        return {
            active_users_count: 18,
            inactive_users_count: 7,
            average_logins_per_week: 4.2,
            user_growth_rate: 15,
            most_active_day: 'Lundi',
            least_active_day: 'Dimanche',
            daily_active_users: [
                12,
                15,
                14,
                18,
                20,
                10,
                8
            ],
            user_retention_rate: 85
        };
    };
    const generateDemoActivity = ()=>{
        const activities = [
            {
                type: 'user_login',
                username: 'martin.dupont',
                timestamp: Date.now() - 300000
            },
            {
                type: 'case_created',
                username: 'sophie.martin',
                company: 'TechSolutions',
                timestamp: Date.now() - 2100000
            },
            {
                type: 'user_registered',
                username: 'jean.durand',
                timestamp: Date.now() - 7200000
            },
            {
                type: 'case_completed',
                username: 'admin',
                company: "Sant\xe9 Plus",
                timestamp: Date.now() - 18000000
            },
            {
                type: 'user_login',
                username: 'admin',
                timestamp: Date.now() - 21600000
            }
        ];
        return activities;
    };
    const setDemoData = ()=>{
        setUsers(generateDemoUsers(25));
        setStatistics(generateDemoStats());
        setUserStats(generateDemoUserStats());
        setRecentActivity(generateDemoActivity());
    };
    const fetchTrendData = async ()=>{
        try {
            const apiUrl = "/api";
            if (!apiUrl) {
                setDemoTrendData();
                return;
            }
            const response = await (0, _axiosDefault.default).get(`${apiUrl}/admin/trends`, {
                params: {
                    timeframe
                },
                headers: {
                    'Authorization': 'Bearer admin',
                    'Content-Type': 'application/json',
                    'ngrok-skip-browser-warning': 'true'
                }
            });
            setTrendData(response.data);
        } catch (error) {
            console.error('Erreur lors du chargement des tendances:', error);
            setDemoTrendData();
        }
    };
    const setDemoTrendData = ()=>{
        // Générer des données de tendances de démonstration
        const days = [
            'Lun',
            'Mar',
            'Mer',
            'Jeu',
            'Ven',
            'Sam',
            'Dim'
        ];
        const weeks = [
            'Sem 1',
            'Sem 2',
            'Sem 3',
            'Sem 4'
        ];
        const months = [
            'Jan',
            "F\xe9v",
            'Mar',
            'Avr',
            'Mai',
            'Juin'
        ];
        let labels = [];
        switch(timeframe){
            case 'week':
                labels = days;
                break;
            case 'month':
                labels = weeks;
                break;
            case 'year':
                labels = months;
                break;
            default:
                labels = days;
        }
        setTrendData({
            labels,
            datasets: [
                {
                    label: 'Nouveaux utilisateurs',
                    data: labels.map(()=>Math.floor(Math.random() * 10) + 1),
                    borderColor: '#4CAF50',
                    backgroundColor: 'rgba(76, 175, 80, 0.2)'
                },
                {
                    label: 'Nouveaux cas',
                    data: labels.map(()=>Math.floor(Math.random() * 15) + 1),
                    borderColor: '#2196F3',
                    backgroundColor: 'rgba(33, 150, 243, 0.2)'
                }
            ]
        });
    };
    const toggleDarkMode = ()=>{
        setIsDarkMode((prev)=>!prev);
    };
    const handleExport = (format)=>{
        // Simuler l'exportation de données
        setShowExportMenu(false);
        const timestamp = new Date().toISOString().replace(/:/g, '-').slice(0, 19);
        const fileName = `admin-dashboard-export-${timestamp}.${format}`;
        addNotification({
            type: 'success',
            message: `Export des donn\xe9es en ${format.toUpperCase()} r\xe9ussi: ${fileName}`,
            timestamp: Date.now()
        });
        // Vous pouvez implémenter l'exportation réelle ici, ou montrer un message de démonstration
        setTimeout(()=>{
            alert(`D\xe9monstration: Les donn\xe9es seraient export\xe9es au format ${format.toUpperCase()} dans un fichier nomm\xe9 ${fileName}`);
        }, 500);
    };
    const handleRefresh = ()=>{
        fetchData();
        fetchRecentActivity();
        fetchTrendData();
        setLastUpdate(new Date());
        addNotification({
            type: 'info',
            message: "Donn\xe9es rafra\xe0\xaechies avec succ\xe8s",
            timestamp: Date.now()
        });
    };
    const handleTimeframeChange = (newTimeframe)=>{
        setTimeframe(newTimeframe);
        addNotification({
            type: 'info',
            message: `P\xe9riode modifi\xe9e: ${getTimeframeLabel(newTimeframe)}`,
            timestamp: Date.now()
        });
    };
    const getTimeframeLabel = (timeframe)=>{
        switch(timeframe){
            case 'week':
                return 'Semaine';
            case 'month':
                return 'Mois';
            case 'year':
                return "Ann\xe9e";
            default:
                return 'Semaine';
        }
    };
    const handleLogout = ()=>{
        logout();
        history.push('/');
    };
    const toggleNotificationsPanel = ()=>{
        setShowNotifications((prev)=>!prev);
    };
    const formatTimeAgo = (timestamp)=>{
        const now = new Date();
        const time = new Date(timestamp);
        const diff = Math.floor((now - time) / 1000); // différence en secondes
        if (diff < 60) return `il y a ${diff} secondes`;
        else if (diff < 3600) return `il y a ${Math.floor(diff / 60)} minutes`;
        else if (diff < 86400) return `il y a ${Math.floor(diff / 3600)} heures`;
        else return `il y a ${Math.floor(diff / 86400)} jours`;
    };
    const renderTabContent = ()=>{
        switch(activeTab){
            case 'dashboard':
                return renderDashboard();
            case 'users':
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _userManagementDefault.default), {
                    users: users,
                    onUserUpdated: fetchData
                });
            case 'cases':
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _caseManagementDefault.default), {});
            case 'analytics':
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Suspense), {
                    fallback: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "admin-loading",
                        children: "Chargement des analyses avanc\xe9es..."
                    }),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(AdvancedAnalytics, {
                        statistics: statistics,
                        trendData: trendData,
                        timeframe: timeframe
                    })
                });
            default:
                return renderDashboard();
        }
    };
    const renderDashboard = ()=>{
        // Format d'affichage pour dernière mise à  jour
        const formatLastUpdate = ()=>{
            return lastUpdate.toLocaleTimeString('fr-FR');
        };
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "admin-dashboard",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "dashboard-controls",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "timeframe-selector",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                    className: `timeframe-btn ${timeframe === 'week' ? 'active' : ''}`,
                                    onClick: ()=>handleTimeframeChange('week'),
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa.FaClock), {}),
                                        " Semaine"
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                    className: `timeframe-btn ${timeframe === 'month' ? 'active' : ''}`,
                                    onClick: ()=>handleTimeframeChange('month'),
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa.FaClock), {}),
                                        " Mois"
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                    className: `timeframe-btn ${timeframe === 'year' ? 'active' : ''}`,
                                    onClick: ()=>handleTimeframeChange('year'),
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa.FaClock), {}),
                                        " Ann\xe9e"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "dashboard-actions",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "last-update",
                                    children: [
                                        "Derni\xe8re mise \xe0\xa0 jour: ",
                                        formatLastUpdate()
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                    className: "theme-toggle",
                                    onClick: toggleDarkMode,
                                    children: [
                                        isDarkMode ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa.FaSun), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa.FaMoon), {}),
                                        " ",
                                        isDarkMode ? 'Mode clair' : 'Mode sombre'
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                    className: "refresh-btn",
                                    onClick: handleRefresh,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa.FaSync), {}),
                                        " Actualiser"
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "export-dropdown",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                            className: "export-btn",
                                            onClick: ()=>setShowExportMenu(!showExportMenu),
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa.FaFileExport), {}),
                                                " Exporter"
                                            ]
                                        }),
                                        showExportMenu && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "export-menu",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                    onClick: ()=>handleExport('csv'),
                                                    children: "CSV"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                    onClick: ()=>handleExport('pdf'),
                                                    children: "PDF"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                    onClick: ()=>handleExport('json'),
                                                    children: "JSON"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                    className: "notification-bell",
                                    onClick: toggleNotificationsPanel,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa.FaBell), {}),
                                        notifications.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: `notification-badge ${notifications.length > 0 ? 'has-notifications' : ''}`,
                                            children: notifications.length
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "admin-stats-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "admin-stat-card animated",
                            style: {
                                animationDelay: '0.1s'
                            },
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "stat-icon",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa.FaUsers), {})
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "stat-content",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                            children: "Utilisateurs"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "admin-stat-value",
                                            children: statistics.user_count || 0
                                        }),
                                        statistics.growth_users && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                            className: `stat-trend ${statistics.growth_users >= 0 ? 'positive' : 'negative'}`,
                                            children: [
                                                statistics.growth_users >= 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa.FaArrowUp), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa.FaArrowDown), {}),
                                                " ",
                                                Math.abs(statistics.growth_users),
                                                "%"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "admin-stat-card animated",
                            style: {
                                animationDelay: '0.2s'
                            },
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "stat-icon",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa.FaBuilding), {})
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "stat-content",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                            children: "Entreprises"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "admin-stat-value",
                                            children: statistics.enterprise_count || 0
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                            className: "admin-stat-subvalue",
                                            children: [
                                                "Secteurs actifs: ",
                                                statistics.sectors_data?.length || 0
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "admin-stat-card animated",
                            style: {
                                animationDelay: '0.3s'
                            },
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "stat-icon",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa.FaClipboardList), {})
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "stat-content",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                            children: "Cas d'\xe9tude"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "admin-stat-value",
                                            children: statistics.case_count || 0
                                        }),
                                        statistics.growth_cases && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                            className: `stat-trend ${statistics.growth_cases >= 0 ? 'positive' : 'negative'}`,
                                            children: [
                                                statistics.growth_cases >= 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa.FaArrowUp), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa.FaArrowDown), {}),
                                                " ",
                                                Math.abs(statistics.growth_cases),
                                                "%"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "admin-stat-card animated",
                            style: {
                                animationDelay: '0.4s'
                            },
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "stat-icon",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa.FaCheckCircle), {})
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "stat-content",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                            children: "Cas compl\xe9t\xe9s"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "admin-stat-value",
                                            children: statistics.completed_cases || 0
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                            className: "admin-stat-subvalue",
                                            children: [
                                                statistics.case_count ? Math.round(statistics.completed_cases / statistics.case_count * 100) : 0,
                                                "% du total"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "kpi-gauge",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "kpi-progress",
                                                style: {
                                                    width: `${statistics.case_count ? Math.min(100, Math.round(statistics.completed_cases / statistics.case_count * 100)) : 0}%`
                                                }
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "dashboard-charts",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "chart-row",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "chart-card",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                            children: "Tendances d'activit\xe9"
                                        }),
                                        trendData.labels && trendData.labels.length > 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "chart-container",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactChartjs2.Line), {
                                                data: trendData,
                                                options: {
                                                    responsive: true,
                                                    plugins: {
                                                        legend: {
                                                            position: 'top'
                                                        },
                                                        title: {
                                                            display: false,
                                                            text: 'Tendances'
                                                        }
                                                    },
                                                    scales: {
                                                        y: {
                                                            beginAtZero: true
                                                        }
                                                    }
                                                }
                                            })
                                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "chart-loading",
                                            children: "Chargement des donn\xe9es..."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "chart-card",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                            children: "R\xe9partition par secteur"
                                        }),
                                        statistics.sectors_data && statistics.sectors_data.length > 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "chart-container",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactChartjs2.Doughnut), {
                                                data: {
                                                    labels: statistics.sectors_data.map((s)=>s.name),
                                                    datasets: [
                                                        {
                                                            data: statistics.sectors_data.map((s)=>s.cases),
                                                            backgroundColor: [
                                                                'rgba(54, 162, 235, 0.6)',
                                                                'rgba(255, 99, 132, 0.6)',
                                                                'rgba(255, 206, 86, 0.6)',
                                                                'rgba(75, 192, 192, 0.6)',
                                                                'rgba(153, 102, 255, 0.6)'
                                                            ],
                                                            borderWidth: 1
                                                        }
                                                    ]
                                                },
                                                options: {
                                                    responsive: true,
                                                    plugins: {
                                                        legend: {
                                                            position: 'right'
                                                        }
                                                    }
                                                }
                                            })
                                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "chart-loading",
                                            children: "Chargement des donn\xe9es..."
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "chart-card full-width",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "section-header",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                            children: "Activit\xe9 r\xe9cente"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "section-actions",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                                className: "section-action-btn",
                                                onClick: fetchRecentActivity,
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa.FaSync), {}),
                                                    " Actualiser"
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "admin-activity-feed",
                                    children: recentActivity.length > 0 ? recentActivity.map((activity, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "admin-activity-card animated",
                                            style: {
                                                animationDelay: `${index * 0.1}s`
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: `admin-activity-icon ${activity.type.includes('user') ? 'user-icon' : 'case-icon'}`,
                                                    children: activity.type.includes('user') ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa.FaUsers), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa.FaClipboardList), {})
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "admin-activity-content",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "admin-activity-text",
                                                            children: [
                                                                activity.type === 'user_login' && `${activity.username} s'est connect\xe9`,
                                                                activity.type === 'user_registered' && `Nouvel utilisateur inscrit: ${activity.username}`,
                                                                activity.type === 'case_created' && `${activity.username} a cr\xe9\xe9 un nouveau cas pour ${activity.company}`,
                                                                activity.type === 'case_completed' && `${activity.username} a compl\xe9t\xe9 le cas de ${activity.company}`
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "admin-activity-value",
                                                            children: formatTimeAgo(activity.timestamp)
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, index)) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "empty-activity",
                                        children: "Aucune activit\xe9 r\xe9cente \xe0\xa0 afficher"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "chart-row",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "chart-card",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                            children: "Utilisateurs actifs par jour"
                                        }),
                                        userStats && userStats.daily_active_users ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "chart-container",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactChartjs2.Bar), {
                                                data: {
                                                    labels: [
                                                        'Lun',
                                                        'Mar',
                                                        'Mer',
                                                        'Jeu',
                                                        'Ven',
                                                        'Sam',
                                                        'Dim'
                                                    ],
                                                    datasets: [
                                                        {
                                                            label: 'Utilisateurs actifs',
                                                            data: userStats.daily_active_users,
                                                            backgroundColor: 'rgba(54, 162, 235, 0.6)'
                                                        }
                                                    ]
                                                },
                                                options: {
                                                    responsive: true,
                                                    plugins: {
                                                        legend: {
                                                            display: false
                                                        }
                                                    },
                                                    scales: {
                                                        y: {
                                                            beginAtZero: true
                                                        }
                                                    }
                                                }
                                            })
                                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "chart-loading",
                                            children: "Chargement des donn\xe9es..."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "chart-card",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                            children: "Statuts des utilisateurs"
                                        }),
                                        userStats ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "chart-container",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactChartjs2.Pie), {
                                                data: {
                                                    labels: [
                                                        'Actifs',
                                                        'Inactifs'
                                                    ],
                                                    datasets: [
                                                        {
                                                            data: [
                                                                userStats.active_users_count || 0,
                                                                userStats.inactive_users_count || 0
                                                            ],
                                                            backgroundColor: [
                                                                'rgba(75, 192, 192, 0.6)',
                                                                'rgba(255, 99, 132, 0.6)'
                                                            ],
                                                            borderWidth: 1
                                                        }
                                                    ]
                                                },
                                                options: {
                                                    responsive: true,
                                                    plugins: {
                                                        legend: {
                                                            position: 'right'
                                                        }
                                                    }
                                                }
                                            })
                                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "chart-loading",
                                            children: "Chargement des donn\xe9es..."
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                showNotifications && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "notifications-panel",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "notifications-header",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                    children: "Notifications"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    className: "close-notifications",
                                    onClick: ()=>setShowNotifications(false),
                                    children: "\xe0\u2014"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "notifications-list",
                            children: notifications.length > 0 ? notifications.map((notification)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: `notification-item ${notification.type}`,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "notification-icon",
                                            children: [
                                                notification.type === 'success' && "\xe2\u0153\u201C",
                                                notification.type === 'error' && "\xe2\u0153\u2014",
                                                notification.type === 'warning' && "\xe2\u0161\xa0",
                                                notification.type === 'info' && "\xe2\u201E\xb9"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "notification-content",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "notification-message",
                                                    children: notification.message
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "notification-time",
                                                    children: formatTimeAgo(notification.timestamp)
                                                })
                                            ]
                                        })
                                    ]
                                }, notification.id)) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "empty-notifications",
                                children: "Aucune notification"
                            })
                        })
                    ]
                })
            ]
        });
    };
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `admin-loading ${isDarkMode ? 'dark-theme' : 'light-theme'}`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
            children: "Chargement du tableau de bord administrateur..."
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `admin-container ${isDarkMode ? 'dark-theme' : 'light-theme'}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "admin-header",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                        children: "Tableau de Bord Administrateur"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        className: "admin-logout-btn",
                        onClick: handleLogout,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa.FaSignOutAlt), {}),
                            " D\xe9connexion"
                        ]
                    })
                ]
            }),
            error && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "admin-error",
                children: error
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "admin-tabs",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        className: `admin-tab ${activeTab === 'dashboard' ? 'admin-tab-active' : ''}`,
                        onClick: ()=>setActiveTab('dashboard'),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa.FaTachometerAlt), {}),
                            " Tableau de bord"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        className: `admin-tab ${activeTab === 'users' ? 'admin-tab-active' : ''}`,
                        onClick: ()=>setActiveTab('users'),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa.FaUsersCog), {}),
                            " Gestion des utilisateurs"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        className: `admin-tab ${activeTab === 'cases' ? 'admin-tab-active' : ''}`,
                        onClick: ()=>setActiveTab('cases'),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa.FaClipboardList), {}),
                            " Gestion des cas"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        className: `admin-tab ${activeTab === 'analytics' ? 'admin-tab-active' : ''}`,
                        onClick: ()=>setActiveTab('analytics'),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fa.FaChartLine), {}),
                            " Analyses avanc\xe9es"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "admin-content",
                children: renderTabContent()
            })
        ]
    });
}
exports.default = Admin;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"ditZI","axios":"kL5AO","../../context/AuthContext":"5fsmo","./Admin.css":"bvYXn","./AdminDashboard.css":"4Rcx9","./UserDetails":"aEn67","./AdvancedUserStats":"9CFw0","./UserManagement":"nGHlO","./CaseManagement":"2l6WH","./CasePerformance":"13Jpt","react-chartjs-2":"by1A5","chart.js":"epfF8","react-icons/fa":"fM6o0","c6c60f69209f5b8e":"lHgQj","724a14fdf923c0f1":"5MC16","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kL5AO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _axiosJsDefault.default));
parcelHelpers.export(exports, "Axios", ()=>Axios);
parcelHelpers.export(exports, "AxiosError", ()=>AxiosError);
parcelHelpers.export(exports, "CanceledError", ()=>CanceledError);
parcelHelpers.export(exports, "isCancel", ()=>isCancel);
parcelHelpers.export(exports, "CancelToken", ()=>CancelToken);
parcelHelpers.export(exports, "VERSION", ()=>VERSION);
parcelHelpers.export(exports, "all", ()=>all);
parcelHelpers.export(exports, "Cancel", ()=>Cancel);
parcelHelpers.export(exports, "isAxiosError", ()=>isAxiosError);
parcelHelpers.export(exports, "spread", ()=>spread);
parcelHelpers.export(exports, "toFormData", ()=>toFormData);
parcelHelpers.export(exports, "AxiosHeaders", ()=>AxiosHeaders);
parcelHelpers.export(exports, "HttpStatusCode", ()=>HttpStatusCode);
parcelHelpers.export(exports, "formToJSON", ()=>formToJSON);
parcelHelpers.export(exports, "getAdapter", ()=>getAdapter);
parcelHelpers.export(exports, "mergeConfig", ()=>mergeConfig);
var _axiosJs = require("./lib/axios.js");
var _axiosJsDefault = parcelHelpers.interopDefault(_axiosJs);
// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios, AxiosError, CanceledError, isCancel, CancelToken, VERSION, all, Cancel, isAxiosError, spread, toFormData, AxiosHeaders, HttpStatusCode, formToJSON, getAdapter, mergeConfig } = (0, _axiosJsDefault.default);

},{"./lib/axios.js":"dH7oj","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dH7oj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _bindJs = require("./helpers/bind.js");
var _bindJsDefault = parcelHelpers.interopDefault(_bindJs);
var _axiosJs = require("./core/Axios.js");
var _axiosJsDefault = parcelHelpers.interopDefault(_axiosJs);
var _mergeConfigJs = require("./core/mergeConfig.js");
var _mergeConfigJsDefault = parcelHelpers.interopDefault(_mergeConfigJs);
var _indexJs = require("./defaults/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _formDataToJSONJs = require("./helpers/formDataToJSON.js");
var _formDataToJSONJsDefault = parcelHelpers.interopDefault(_formDataToJSONJs);
var _canceledErrorJs = require("./cancel/CanceledError.js");
var _canceledErrorJsDefault = parcelHelpers.interopDefault(_canceledErrorJs);
var _cancelTokenJs = require("./cancel/CancelToken.js");
var _cancelTokenJsDefault = parcelHelpers.interopDefault(_cancelTokenJs);
var _isCancelJs = require("./cancel/isCancel.js");
var _isCancelJsDefault = parcelHelpers.interopDefault(_isCancelJs);
var _dataJs = require("./env/data.js");
var _toFormDataJs = require("./helpers/toFormData.js");
var _toFormDataJsDefault = parcelHelpers.interopDefault(_toFormDataJs);
var _axiosErrorJs = require("./core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _spreadJs = require("./helpers/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
var _isAxiosErrorJs = require("./helpers/isAxiosError.js");
var _isAxiosErrorJsDefault = parcelHelpers.interopDefault(_isAxiosErrorJs);
var _axiosHeadersJs = require("./core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
var _adaptersJs = require("./adapters/adapters.js");
var _adaptersJsDefault = parcelHelpers.interopDefault(_adaptersJs);
var _httpStatusCodeJs = require("./helpers/HttpStatusCode.js");
var _httpStatusCodeJsDefault = parcelHelpers.interopDefault(_httpStatusCodeJs);
'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function createInstance(defaultConfig) {
    const context = new (0, _axiosJsDefault.default)(defaultConfig);
    const instance = (0, _bindJsDefault.default)((0, _axiosJsDefault.default).prototype.request, context);
    // Copy axios.prototype to instance
    (0, _utilsJsDefault.default).extend(instance, (0, _axiosJsDefault.default).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, _utilsJsDefault.default).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return createInstance((0, _mergeConfigJsDefault.default)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const axios = createInstance((0, _indexJsDefault.default));
// Expose Axios class to allow class inheritance
axios.Axios = (0, _axiosJsDefault.default);
// Expose Cancel & CancelToken
axios.CanceledError = (0, _canceledErrorJsDefault.default);
axios.CancelToken = (0, _cancelTokenJsDefault.default);
axios.isCancel = (0, _isCancelJsDefault.default);
axios.VERSION = (0, _dataJs.VERSION);
axios.toFormData = (0, _toFormDataJsDefault.default);
// Expose AxiosError class
axios.AxiosError = (0, _axiosErrorJsDefault.default);
// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;
// Expose all/spread
axios.all = function all(promises) {
    return Promise.all(promises);
};
axios.spread = (0, _spreadJsDefault.default);
// Expose isAxiosError
axios.isAxiosError = (0, _isAxiosErrorJsDefault.default);
// Expose mergeConfig
axios.mergeConfig = (0, _mergeConfigJsDefault.default);
axios.AxiosHeaders = (0, _axiosHeadersJsDefault.default);
axios.formToJSON = (thing)=>(0, _formDataToJSONJsDefault.default)((0, _utilsJsDefault.default).isHTMLForm(thing) ? new FormData(thing) : thing);
axios.getAdapter = (0, _adaptersJsDefault.default).getAdapter;
axios.HttpStatusCode = (0, _httpStatusCodeJsDefault.default);
axios.default = axios;
// this module should only have a default export
exports.default = axios;

},{"./utils.js":"4AdI3","./helpers/bind.js":"dVXC5","./core/Axios.js":"lsoIO","./core/mergeConfig.js":"79q17","./defaults/index.js":"6V8DG","./helpers/formDataToJSON.js":"8eWn8","./cancel/CanceledError.js":"h2iVm","./cancel/CancelToken.js":"2bdtR","./cancel/isCancel.js":"2JSXk","./env/data.js":"2JBGK","./helpers/toFormData.js":"g2re0","./core/AxiosError.js":"fZ7SQ","./helpers/spread.js":"axv13","./helpers/isAxiosError.js":"eb8Z2","./core/AxiosHeaders.js":"jKjps","./adapters/adapters.js":"kiY1x","./helpers/HttpStatusCode.js":"lm3tN","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4AdI3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _bindJs = require("./helpers/bind.js");
var _bindJsDefault = parcelHelpers.interopDefault(_bindJs);
var global = arguments[3];
'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString } = Object.prototype;
const { getPrototypeOf } = Object;
const { iterator, toStringTag } = Symbol;
const kindOf = ((cache)=>(thing)=>{
        const str = toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>kindOf(thing) === type;
};
const typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const isUndefined = typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function isBuffer(val) {
    return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const isArrayBuffer = kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const isString = typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const isFunction = typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const isNumber = typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const isPlainObject = (val)=>{
    if (kindOf(val) !== 'object') return false;
    const prototype = getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(toStringTag in val) && !(iterator in val);
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ const isEmptyObject = (val)=>{
    // Early return for non-objects or Buffers to prevent RangeError
    if (!isObject(val) || isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const isDate = kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const isFile = kindOfTest('File');
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const isBlob = kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const isFileList = kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const isStream = (val)=>isObject(val) && isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === 'function' && thing instanceof FormData || isFunction(thing.append) && ((kind = kindOf(thing)) === 'formdata' || // detect form-data instance
    kind === 'object' && isFunction(thing.toString) && thing.toString() === '[object FormData]'));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const isURLSearchParams = kindOfTest('URLSearchParams');
const [isReadableStream, isRequest, isResponse, isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map(kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function forEach(obj, fn, { allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if (isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if (isBuffer(obj)) return;
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function findKey(obj, key) {
    if (isBuffer(obj)) return null;
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const _global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== 'undefined' ? window : global;
})();
const isContextDefined = (context)=>!isUndefined(context) && context !== _global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function merge() {
    const { caseless, skipUndefined } = isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && findKey(result, key) || key;
        if (isPlainObject(result[targetKey]) && isPlainObject(val)) result[targetKey] = merge(result[targetKey], val);
        else if (isPlainObject(val)) result[targetKey] = merge({}, val);
        else if (isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !isUndefined(val)) result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const extend = (a, b, thisArg, { allOwnKeys } = {})=>{
    forEach(b, (val, key)=>{
        if (thisArg && isFunction(val)) a[key] = (0, _bindJsDefault.default)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, 'super', {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const toArray = (thing)=>{
    if (!thing) return null;
    if (isArray(thing)) return thing;
    let i = thing.length;
    if (!isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const forEachEntry = (obj, fn)=>{
    const generator = obj && obj[iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const isHTMLForm = kindOfTest('HTMLFormElement');
const toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const hasOwnProperty = (({ hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const isRegExp = kindOfTest('RegExp');
const reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const freezeMethods = (obj)=>{
    reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if (isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error('Can not rewrite read-only method \'' + name + '\'');
        };
    });
};
const toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const noop = ()=>{};
const toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function isSpecCompliantForm(thing) {
    return !!(thing && isFunction(thing.append) && thing[toStringTag] === 'FormData' && thing[iterator]);
}
const toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if (isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            //Buffer check
            if (isBuffer(source)) return source;
            if (!('toJSON' in source)) {
                stack[i] = source;
                const target = isArray(source) ? [] : {};
                forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const isAsyncFn = kindOfTest('AsyncFunction');
const isThenable = (thing)=>thing && (isObject(thing) || isFunction(thing)) && isFunction(thing.then) && isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
const _setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        _global.addEventListener("message", ({ source, data })=>{
            if (source === _global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            _global.postMessage(token, "*");
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', isFunction(_global.postMessage));
const asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind(_global) : _setImmediate;
// *********************
const isIterable = (thing)=>thing != null && isFunction(thing[iterator]);
exports.default = {
    isArray,
    isArrayBuffer,
    isBuffer,
    isFormData,
    isArrayBufferView,
    isString,
    isNumber,
    isBoolean,
    isObject,
    isPlainObject,
    isEmptyObject,
    isReadableStream,
    isRequest,
    isResponse,
    isHeaders,
    isUndefined,
    isDate,
    isFile,
    isBlob,
    isRegExp,
    isFunction,
    isStream,
    isURLSearchParams,
    isTypedArray,
    isFileList,
    forEach,
    merge,
    extend,
    trim,
    stripBOM,
    inherits,
    toFlatObject,
    kindOf,
    kindOfTest,
    endsWith,
    toArray,
    forEachEntry,
    matchAll,
    isHTMLForm,
    hasOwnProperty,
    hasOwnProp: hasOwnProperty,
    reduceDescriptors,
    freezeMethods,
    toObjectSet,
    toCamelCase,
    noop,
    toFiniteNumber,
    findKey,
    global: _global,
    isContextDefined,
    isSpecCompliantForm,
    toJSONObject,
    isAsyncFn,
    isThenable,
    setImmediate: _setImmediate,
    asap,
    isIterable
};

},{"./helpers/bind.js":"dVXC5","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dVXC5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>bind);
'use strict';
function bind(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lsoIO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _buildURLJs = require("../helpers/buildURL.js");
var _buildURLJsDefault = parcelHelpers.interopDefault(_buildURLJs);
var _interceptorManagerJs = require("./InterceptorManager.js");
var _interceptorManagerJsDefault = parcelHelpers.interopDefault(_interceptorManagerJs);
var _dispatchRequestJs = require("./dispatchRequest.js");
var _dispatchRequestJsDefault = parcelHelpers.interopDefault(_dispatchRequestJs);
var _mergeConfigJs = require("./mergeConfig.js");
var _mergeConfigJsDefault = parcelHelpers.interopDefault(_mergeConfigJs);
var _buildFullPathJs = require("./buildFullPath.js");
var _buildFullPathJsDefault = parcelHelpers.interopDefault(_buildFullPathJs);
var _validatorJs = require("../helpers/validator.js");
var _validatorJsDefault = parcelHelpers.interopDefault(_validatorJs);
var _axiosHeadersJs = require("./AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
'use strict';
const validators = (0, _validatorJsDefault.default).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, _interceptorManagerJsDefault.default)(),
            response: new (0, _interceptorManagerJsDefault.default)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) err.stack += '\n' + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, _mergeConfigJsDefault.default)(this.defaults, config);
        const { transitional, paramsSerializer, headers } = config;
        if (transitional !== undefined) (0, _validatorJsDefault.default).assertOptions(transitional, {
            silentJSONParsing: validators.transitional(validators.boolean),
            forcedJSONParsing: validators.transitional(validators.boolean),
            clarifyTimeoutError: validators.transitional(validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, _utilsJsDefault.default).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, _validatorJsDefault.default).assertOptions(paramsSerializer, {
                encode: validators.function,
                serialize: validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, _validatorJsDefault.default).assertOptions(config, {
            baseUrl: validators.spelling('baseURL'),
            withXsrfToken: validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, _utilsJsDefault.default).merge(headers.common, headers[config.method]);
        headers && (0, _utilsJsDefault.default).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, _axiosHeadersJsDefault.default).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, _dispatchRequestJsDefault.default).bind(this),
                undefined
            ];
            chain.unshift(...requestInterceptorChain);
            chain.push(...responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, _dispatchRequestJsDefault.default).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, _mergeConfigJsDefault.default)(this.defaults, config);
        const fullPath = (0, _buildFullPathJsDefault.default)(config.baseURL, config.url, config.allowAbsoluteUrls);
        return (0, _buildURLJsDefault.default)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, _utilsJsDefault.default).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ Axios.prototype[method] = function(url, config) {
        return this.request((0, _mergeConfigJsDefault.default)(config || {}, {
            method,
            url,
            data: (config || {}).data
        }));
    };
});
(0, _utilsJsDefault.default).forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, _mergeConfigJsDefault.default)(config || {}, {
                method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url,
                data
            }));
        };
    }
    Axios.prototype[method] = generateHTTPMethod();
    Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
exports.default = Axios;

},{"./../utils.js":"4AdI3","../helpers/buildURL.js":"4Gx5k","./InterceptorManager.js":"1SpXj","./dispatchRequest.js":"5W7kJ","./mergeConfig.js":"79q17","./buildFullPath.js":"cRRFe","../helpers/validator.js":"ii46t","./AxiosHeaders.js":"jKjps","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4Gx5k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>buildURL);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosURLSearchParamsJs = require("../helpers/AxiosURLSearchParams.js");
var _axiosURLSearchParamsJsDefault = parcelHelpers.interopDefault(_axiosURLSearchParamsJs);
'use strict';
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+');
}
function buildURL(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || encode;
    if ((0, _utilsJsDefault.default).isFunction(options)) options = {
        serialize: options
    };
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, _utilsJsDefault.default).isURLSearchParams(params) ? params.toString() : new (0, _axiosURLSearchParamsJsDefault.default)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}

},{"../utils.js":"4AdI3","../helpers/AxiosURLSearchParams.js":"445v1","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"445v1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _toFormDataJs = require("./toFormData.js");
var _toFormDataJsDefault = parcelHelpers.interopDefault(_toFormDataJs);
'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+',
        '%00': '\x00'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, _toFormDataJsDefault.default)(params, this, options);
}
const prototype = AxiosURLSearchParams.prototype;
prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, encode);
    } : encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
exports.default = AxiosURLSearchParams;

},{"./toFormData.js":"g2re0","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"g2re0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
// temporary hotfix to avoid circular references until AxiosURLSearchParams is refactored
var _formDataJs = require("../platform/node/classes/FormData.js");
var _formDataJsDefault = parcelHelpers.interopDefault(_formDataJs);
var Buffer = require("adfd9b103875c2dd").Buffer;
'use strict';
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function isVisitable(thing) {
    return (0, _utilsJsDefault.default).isPlainObject(thing) || (0, _utilsJsDefault.default).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function removeBrackets(key) {
    return (0, _utilsJsDefault.default).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function isFlatArray(arr) {
    return (0, _utilsJsDefault.default).isArray(arr) && !arr.some(isVisitable);
}
const predicates = (0, _utilsJsDefault.default).toFlatObject((0, _utilsJsDefault.default), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function toFormData(obj, formData, options) {
    if (!(0, _utilsJsDefault.default).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, _formDataJsDefault.default) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, _utilsJsDefault.default).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, _utilsJsDefault.default).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const useBlob = _Blob && (0, _utilsJsDefault.default).isSpecCompliantForm(formData);
    if (!(0, _utilsJsDefault.default).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, _utilsJsDefault.default).isDate(value)) return value.toISOString();
        if ((0, _utilsJsDefault.default).isBoolean(value)) return value.toString();
        if (!useBlob && (0, _utilsJsDefault.default).isBlob(value)) throw new (0, _axiosErrorJsDefault.default)('Blob is not supported. Use a Buffer instead.');
        if ((0, _utilsJsDefault.default).isArrayBuffer(value) || (0, _utilsJsDefault.default).isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === 'object') {
            if ((0, _utilsJsDefault.default).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, _utilsJsDefault.default).isArray(value) && isFlatArray(value) || ((0, _utilsJsDefault.default).isFileList(value) || (0, _utilsJsDefault.default).endsWith(key, '[]')) && (arr = (0, _utilsJsDefault.default).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, _utilsJsDefault.default).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if (isVisitable(value)) return true;
        formData.append(renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign(predicates, {
        defaultVisitor,
        convertValue,
        isVisitable
    });
    function build(value, path) {
        if ((0, _utilsJsDefault.default).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, _utilsJsDefault.default).forEach(value, function each(el, key) {
            const result = !((0, _utilsJsDefault.default).isUndefined(el) || el === null) && visitor.call(formData, el, (0, _utilsJsDefault.default).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, _utilsJsDefault.default).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
exports.default = toFormData;

},{"adfd9b103875c2dd":"cjdyz","../utils.js":"4AdI3","../core/AxiosError.js":"fZ7SQ","../platform/node/classes/FormData.js":"b3JVo","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cjdyz":[function(require,module,exports,__globalThis) {
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 'use strict';
var base64 = require("9c62938f1dccc73c");
var ieee754 = require("aceacb6a4531a9d2");
var customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
exports.Buffer = Buffer;
exports.SlowBuffer = SlowBuffer;
exports.INSPECT_MAX_BYTES = 50;
var K_MAX_LENGTH = 0x7fffffff;
exports.kMaxLength = K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty(Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty(Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function createBuffer(length) {
    if (length > K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return allocUnsafe(arg);
    }
    return from(arg, encodingOrOffset, length);
}
Buffer.poolSize = 8192 // not used by this implementation
;
function from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return Buffer.from(valueOf, encodingOrOffset, length);
    var b = fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ Buffer.from = function(value, encodingOrOffset, length) {
    return from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf(Buffer, Uint8Array);
function assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function alloc(size, fill, encoding) {
    assertSize(size);
    if (size <= 0) return createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
    return createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ Buffer.alloc = function(size, fill, encoding) {
    return alloc(size, fill, encoding);
};
function allocUnsafe(size) {
    assertSize(size);
    return createBuffer(size < 0 ? 0 : checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ Buffer.allocUnsafe = function(size) {
    return allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ Buffer.allocUnsafeSlow = function(size) {
    return allocUnsafe(size);
};
function fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = byteLength(string, encoding) | 0;
    var buf = createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function fromArrayLike(array) {
    var length = array.length < 0 ? 0 : checked(array.length) | 0;
    var buf = createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function fromArrayView(arrayView) {
    if (isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return fromArrayLike(arrayView);
}
function fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
function fromObject(obj) {
    if (Buffer.isBuffer(obj)) {
        var len = checked(obj.length) | 0;
        var buf = createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) return createBuffer(0);
        return fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return fromArrayLike(obj.data);
}
function checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function SlowBuffer(length) {
    if (+length != length) length = 0;
    return Buffer.alloc(+length);
}
Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
Buffer.compare = function compare(a, b) {
    if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
    if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength);
    if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if (isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function byteLength(string, encoding) {
    if (Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
Buffer.byteLength = byteLength;
function slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return utf8Slice(this, start, end);
        case 'ascii':
            return asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return latin1Slice(this, start, end);
        case 'base64':
            return base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true;
function swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)swap(this, i, i + 1);
    return this;
};
Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        swap(this, i, i + 3);
        swap(this, i + 1, i + 2);
    }
    return this;
};
Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        swap(this, i, i + 7);
        swap(this, i + 1, i + 6);
        swap(this, i + 2, i + 5);
        swap(this, i + 3, i + 4);
    }
    return this;
};
Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return utf8Slice(this, 0, length);
    return slowToString.apply(this, arguments);
};
Buffer.prototype.toLocaleString = Buffer.prototype.toString;
Buffer.prototype.equals = function equals(b) {
    if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return Buffer.compare(this, b) === 0;
};
Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = exports.INSPECT_MAX_BYTES;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if (customInspectSymbol) Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect;
Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (isInstance(target, Uint8Array)) target = Buffer.from(target, target.offset, target.byteLength);
    if (!Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if (Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if (numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function utf8Write(buf, string, offset, length) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function asciiWrite(buf, string, offset, length) {
    return blitBuffer(asciiToBytes(string), buf, offset, length);
}
function base64Write(buf, string, offset, length) {
    return blitBuffer(base64ToBytes(string), buf, offset, length);
}
function ucs2Write(buf, string, offset, length) {
    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return base64.fromByteArray(buf);
    else return base64.fromByteArray(buf.slice(start, end));
}
function utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000;
function decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
    return res;
}
function asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += hexSliceLookupTable[buf[i]];
    return out;
}
function utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
Buffer.prototype.readUintLE = Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
Buffer.prototype.readUintBE = Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
Buffer.prototype.readUint8 = Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    return this[offset];
};
Buffer.prototype.readUint16LE = Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
Buffer.prototype.readUint16BE = Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
Buffer.prototype.readUint32LE = Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
Buffer.prototype.readUint32BE = Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, true, 23, 4);
};
Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, false, 23, 4);
};
Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, true, 52, 8);
};
Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, false, 52, 8);
};
function checkInt(buf, value, offset, ext, max, min) {
    if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
Buffer.prototype.writeUintLE = Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUintBE = Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUint8 = Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeUint16LE = Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeUint16BE = Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeUint32LE = Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeUint32BE = Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return writeFloat(this, value, offset, true, noAssert);
};
Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return writeFloat(this, value, offset, false, noAssert);
};
function writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return writeDouble(this, value, offset, true, noAssert);
};
Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace(INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function base64ToBytes(str) {
    return base64.toByteArray(base64clean(str));
}
function blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

},{"9c62938f1dccc73c":"bICrG","aceacb6a4531a9d2":"7IMNJ"}],"bICrG":[function(require,module,exports,__globalThis) {
'use strict';
exports.byteLength = byteLength;
exports.toByteArray = toByteArray;
exports.fromByteArray = fromByteArray;
var lookup = [];
var revLookup = [];
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var i = 0, len = code.length; i < len; ++i){
    lookup[i] = code[i];
    revLookup[code.charCodeAt(i)] = i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62;
revLookup['_'.charCodeAt(0)] = 63;
function getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function byteLength(b64) {
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function _byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function toByteArray(b64) {
    var tmp;
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function tripletToBase64(num) {
    return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
}
function encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push(tripletToBase64(tmp));
    }
    return output.join('');
}
function fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 0x3F] + lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

},{}],"7IMNJ":[function(require,module,exports,__globalThis) {
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ exports.read = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
exports.write = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

},{}],"fZ7SQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
'use strict';
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = 'AxiosError';
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    if (response) {
        this.response = response;
        this.status = response.status ? response.status : null;
    }
}
(0, _utilsJsDefault.default).inherits(AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, _utilsJsDefault.default).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
});
const prototype = AxiosError.prototype;
const descriptors = {};
[
    'ERR_BAD_OPTION_VALUE',
    'ERR_BAD_OPTION',
    'ECONNABORTED',
    'ETIMEDOUT',
    'ERR_NETWORK',
    'ERR_FR_TOO_MANY_REDIRECTS',
    'ERR_DEPRECATED',
    'ERR_BAD_RESPONSE',
    'ERR_BAD_REQUEST',
    'ERR_CANCELED',
    'ERR_NOT_SUPPORT',
    'ERR_INVALID_URL'
].forEach((code)=>{
    descriptors[code] = {
        value: code
    };
});
Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(prototype, 'isAxiosError', {
    value: true
});
// eslint-disable-next-line func-names
AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create(prototype);
    (0, _utilsJsDefault.default).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== 'isAxiosError';
    });
    const msg = error && error.message ? error.message : 'Error';
    // Prefer explicit code; otherwise copy the low-level error's code (e.g. ECONNREFUSED)
    const errCode = code == null && error ? error.code : code;
    AxiosError.call(axiosError, msg, errCode, config, request, response);
    // Chain the original error on the standard field; non-enumerable to avoid JSON noise
    if (error && axiosError.cause == null) Object.defineProperty(axiosError, 'cause', {
        value: error,
        configurable: true
    });
    axiosError.name = error && error.name || 'Error';
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
exports.default = AxiosError;

},{"../utils.js":"4AdI3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"b3JVo":[function(require,module,exports,__globalThis) {
// eslint-disable-next-line strict
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = null;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1SpXj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
'use strict';
class InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled,
            rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, _utilsJsDefault.default).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
exports.default = InterceptorManager;

},{"./../utils.js":"4AdI3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5W7kJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>dispatchRequest);
var _transformDataJs = require("./transformData.js");
var _transformDataJsDefault = parcelHelpers.interopDefault(_transformDataJs);
var _isCancelJs = require("../cancel/isCancel.js");
var _isCancelJsDefault = parcelHelpers.interopDefault(_isCancelJs);
var _indexJs = require("../defaults/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _canceledErrorJs = require("../cancel/CanceledError.js");
var _canceledErrorJsDefault = parcelHelpers.interopDefault(_canceledErrorJs);
var _axiosHeadersJs = require("../core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
var _adaptersJs = require("../adapters/adapters.js");
var _adaptersJsDefault = parcelHelpers.interopDefault(_adaptersJs);
'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, _canceledErrorJsDefault.default)(null, config);
}
function dispatchRequest(config) {
    throwIfCancellationRequested(config);
    config.headers = (0, _axiosHeadersJsDefault.default).from(config.headers);
    // Transform request data
    config.data = (0, _transformDataJsDefault.default).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, _adaptersJsDefault.default).getAdapter(config.adapter || (0, _indexJsDefault.default).adapter, config);
    return adapter(config).then(function onAdapterResolution(response) {
        throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, _transformDataJsDefault.default).call(config, config.transformResponse, response);
        response.headers = (0, _axiosHeadersJsDefault.default).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, _isCancelJsDefault.default)(reason)) {
            throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, _transformDataJsDefault.default).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, _axiosHeadersJsDefault.default).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}

},{"./transformData.js":"5PMg8","../cancel/isCancel.js":"2JSXk","../defaults/index.js":"6V8DG","../cancel/CanceledError.js":"h2iVm","../core/AxiosHeaders.js":"jKjps","../adapters/adapters.js":"kiY1x","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5PMg8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>transformData);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _indexJs = require("../defaults/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _axiosHeadersJs = require("../core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
'use strict';
function transformData(fns, response) {
    const config = this || (0, _indexJsDefault.default);
    const context = response || config;
    const headers = (0, _axiosHeadersJsDefault.default).from(context.headers);
    let data = context.data;
    (0, _utilsJsDefault.default).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}

},{"./../utils.js":"4AdI3","../defaults/index.js":"6V8DG","../core/AxiosHeaders.js":"jKjps","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6V8DG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _transitionalJs = require("./transitional.js");
var _transitionalJsDefault = parcelHelpers.interopDefault(_transitionalJs);
var _toFormDataJs = require("../helpers/toFormData.js");
var _toFormDataJsDefault = parcelHelpers.interopDefault(_toFormDataJs);
var _toURLEncodedFormJs = require("../helpers/toURLEncodedForm.js");
var _toURLEncodedFormJsDefault = parcelHelpers.interopDefault(_toURLEncodedFormJs);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _formDataToJSONJs = require("../helpers/formDataToJSON.js");
var _formDataToJSONJsDefault = parcelHelpers.interopDefault(_formDataToJSONJs);
'use strict';
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function stringifySafely(rawValue, parser, encoder) {
    if ((0, _utilsJsDefault.default).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, _utilsJsDefault.default).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const defaults = {
    transitional: (0, _transitionalJsDefault.default),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, _utilsJsDefault.default).isObject(data);
            if (isObjectPayload && (0, _utilsJsDefault.default).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, _utilsJsDefault.default).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, _formDataToJSONJsDefault.default)(data)) : data;
            if ((0, _utilsJsDefault.default).isArrayBuffer(data) || (0, _utilsJsDefault.default).isBuffer(data) || (0, _utilsJsDefault.default).isStream(data) || (0, _utilsJsDefault.default).isFile(data) || (0, _utilsJsDefault.default).isBlob(data) || (0, _utilsJsDefault.default).isReadableStream(data)) return data;
            if ((0, _utilsJsDefault.default).isArrayBufferView(data)) return data.buffer;
            if ((0, _utilsJsDefault.default).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, _toURLEncodedFormJsDefault.default)(data, this.formSerializer).toString();
                if ((isFileList = (0, _utilsJsDefault.default).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, _toFormDataJsDefault.default)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === 'json';
            if ((0, _utilsJsDefault.default).isResponse(data) || (0, _utilsJsDefault.default).isReadableStream(data)) return data;
            if (data && (0, _utilsJsDefault.default).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, this.parseReviver);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, _axiosErrorJsDefault.default).from(e, (0, _axiosErrorJsDefault.default).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, _indexJsDefault.default).classes.FormData,
        Blob: (0, _indexJsDefault.default).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, _utilsJsDefault.default).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch'
], (method)=>{
    defaults.headers[method] = {};
});
exports.default = defaults;

},{"../utils.js":"4AdI3","../core/AxiosError.js":"fZ7SQ","./transitional.js":"jktpl","../helpers/toFormData.js":"g2re0","../helpers/toURLEncodedForm.js":"3U162","../platform/index.js":"dnuuz","../helpers/formDataToJSON.js":"8eWn8","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jktpl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
'use strict';
exports.default = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3U162":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toURLEncodedForm);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _toFormDataJs = require("./toFormData.js");
var _toFormDataJsDefault = parcelHelpers.interopDefault(_toFormDataJs);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
'use strict';
function toURLEncodedForm(data, options) {
    return (0, _toFormDataJsDefault.default)(data, new (0, _indexJsDefault.default).classes.URLSearchParams(), {
        visitor: function(value, key, path, helpers) {
            if ((0, _indexJsDefault.default).isNode && (0, _utilsJsDefault.default).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        },
        ...options
    });
}

},{"../utils.js":"4AdI3","./toFormData.js":"g2re0","../platform/index.js":"dnuuz","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dnuuz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./node/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _utilsJs = require("./common/utils.js");
exports.default = {
    ..._utilsJs,
    ...(0, _indexJsDefault.default)
};

},{"./node/index.js":"2AMRr","./common/utils.js":"giiKQ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2AMRr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _urlsearchParamsJs = require("./classes/URLSearchParams.js");
var _urlsearchParamsJsDefault = parcelHelpers.interopDefault(_urlsearchParamsJs);
var _formDataJs = require("./classes/FormData.js");
var _formDataJsDefault = parcelHelpers.interopDefault(_formDataJs);
var _blobJs = require("./classes/Blob.js");
var _blobJsDefault = parcelHelpers.interopDefault(_blobJs);
exports.default = {
    isBrowser: true,
    classes: {
        URLSearchParams: (0, _urlsearchParamsJsDefault.default),
        FormData: (0, _formDataJsDefault.default),
        Blob: (0, _blobJsDefault.default)
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};

},{"./classes/URLSearchParams.js":"lpTM0","./classes/FormData.js":"iMRAt","./classes/Blob.js":"hYmoQ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lpTM0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _axiosURLSearchParamsJs = require("../../../helpers/AxiosURLSearchParams.js");
var _axiosURLSearchParamsJsDefault = parcelHelpers.interopDefault(_axiosURLSearchParamsJs);
'use strict';
exports.default = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, _axiosURLSearchParamsJsDefault.default);

},{"../../../helpers/AxiosURLSearchParams.js":"445v1","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iMRAt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
'use strict';
exports.default = typeof FormData !== 'undefined' ? FormData : null;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hYmoQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
'use strict';
exports.default = typeof Blob !== 'undefined' ? Blob : null;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"giiKQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasBrowserEnv", ()=>hasBrowserEnv);
parcelHelpers.export(exports, "hasStandardBrowserWebWorkerEnv", ()=>hasStandardBrowserWebWorkerEnv);
parcelHelpers.export(exports, "hasStandardBrowserEnv", ()=>hasStandardBrowserEnv);
parcelHelpers.export(exports, "navigator", ()=>_navigator);
parcelHelpers.export(exports, "origin", ()=>origin);
const hasBrowserEnv = typeof window !== 'undefined' && typeof document !== 'undefined';
const _navigator = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const hasStandardBrowserEnv = hasBrowserEnv && (!_navigator || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf(_navigator.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const hasStandardBrowserWebWorkerEnv = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const origin = hasBrowserEnv && window.location.href || 'http://localhost';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8eWn8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
'use strict';
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, _utilsJsDefault.default).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === '[]' ? '' : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, _utilsJsDefault.default).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, _utilsJsDefault.default).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, _utilsJsDefault.default).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, _utilsJsDefault.default).isArray(target[name])) target[name] = arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, _utilsJsDefault.default).isFormData(formData) && (0, _utilsJsDefault.default).isFunction(formData.entries)) {
        const obj = {};
        (0, _utilsJsDefault.default).forEachEntry(formData, (name, value)=>{
            buildPath(parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
exports.default = formDataToJSON;

},{"../utils.js":"4AdI3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jKjps":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _parseHeadersJs = require("../helpers/parseHeaders.js");
var _parseHeadersJsDefault = parcelHelpers.interopDefault(_parseHeadersJs);
'use strict';
const $internals = Symbol('internals');
function normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, _utilsJsDefault.default).isArray(value) ? value.map(normalizeValue) : String(value);
}
function parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, _utilsJsDefault.default).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, _utilsJsDefault.default).isString(value)) return;
    if ((0, _utilsJsDefault.default).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, _utilsJsDefault.default).isRegExp(filter)) return filter.test(value);
}
function formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function buildAccessors(obj, header) {
    const accessorName = (0, _utilsJsDefault.default).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = normalizeHeader(_header);
            if (!lHeader) throw new Error('header name must be a non-empty string');
            const key = (0, _utilsJsDefault.default).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, _utilsJsDefault.default).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, _utilsJsDefault.default).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, _utilsJsDefault.default).isString(header) && (header = header.trim()) && !isValidHeaderName(header)) setHeaders((0, _parseHeadersJsDefault.default)(header), valueOrRewrite);
        else if ((0, _utilsJsDefault.default).isObject(header) && (0, _utilsJsDefault.default).isIterable(header)) {
            let obj = {}, dest, key;
            for (const entry of header){
                if (!(0, _utilsJsDefault.default).isArray(entry)) throw TypeError('Object iterator must return a key-value pair');
                obj[key = entry[0]] = (dest = obj[key]) ? (0, _utilsJsDefault.default).isArray(dest) ? [
                    ...dest,
                    entry[1]
                ] : [
                    dest,
                    entry[1]
                ] : entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = normalizeHeader(header);
        if (header) {
            const key = (0, _utilsJsDefault.default).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return parseTokens(value);
                if ((0, _utilsJsDefault.default).isFunction(parser)) return parser.call(this, value, key);
                if ((0, _utilsJsDefault.default).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = normalizeHeader(header);
        if (header) {
            const key = (0, _utilsJsDefault.default).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = normalizeHeader(_header);
            if (_header) {
                const key = (0, _utilsJsDefault.default).findKey(self, _header);
                if (key && (!matcher || matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, _utilsJsDefault.default).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, _utilsJsDefault.default).forEach(this, (value, header)=>{
            const key = (0, _utilsJsDefault.default).findKey(headers, header);
            if (key) {
                self[key] = normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, _utilsJsDefault.default).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, _utilsJsDefault.default).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    getSetCookie() {
        return this.get("set-cookie") || [];
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$internals] = this[$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = normalizeHeader(_header);
            if (!accessors[lHeader]) {
                buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, _utilsJsDefault.default).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, _utilsJsDefault.default).reduceDescriptors(AxiosHeaders.prototype, ({ value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, _utilsJsDefault.default).freezeMethods(AxiosHeaders);
exports.default = AxiosHeaders;

},{"../utils.js":"4AdI3","../helpers/parseHeaders.js":"hf5eq","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hf5eq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const ignoreDuplicateOf = (0, _utilsJsDefault.default).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ exports.default = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};

},{"./../utils.js":"4AdI3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2JSXk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isCancel);
'use strict';
function isCancel(value) {
    return !!(value && value.__CANCEL__);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"h2iVm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
'use strict';
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, _axiosErrorJsDefault.default).call(this, message == null ? 'canceled' : message, (0, _axiosErrorJsDefault.default).ERR_CANCELED, config, request);
    this.name = 'CanceledError';
}
(0, _utilsJsDefault.default).inherits(CanceledError, (0, _axiosErrorJsDefault.default), {
    __CANCEL__: true
});
exports.default = CanceledError;

},{"../core/AxiosError.js":"fZ7SQ","../utils.js":"4AdI3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kiY1x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _httpJs = require("./http.js");
var _httpJsDefault = parcelHelpers.interopDefault(_httpJs);
var _xhrJs = require("./xhr.js");
var _xhrJsDefault = parcelHelpers.interopDefault(_xhrJs);
var _fetchJs = require("./fetch.js");
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
const knownAdapters = {
    http: (0, _httpJsDefault.default),
    xhr: (0, _xhrJsDefault.default),
    fetch: {
        get: _fetchJs.getFetch
    }
};
(0, _utilsJsDefault.default).forEach(knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, 'name', {
                value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            value
        });
    }
});
const renderReason = (reason)=>`- ${reason}`;
const isResolvedHandle = (adapter)=>(0, _utilsJsDefault.default).isFunction(adapter) || adapter === null || adapter === false;
exports.default = {
    getAdapter: (adapters, config)=>{
        adapters = (0, _utilsJsDefault.default).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!isResolvedHandle(nameOrAdapter)) {
                adapter = knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, _axiosErrorJsDefault.default)(`Unknown adapter '${id}'`);
            }
            if (adapter && ((0, _utilsJsDefault.default).isFunction(adapter) || (adapter = adapter.get(config)))) break;
            rejectedReasons[id || '#' + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
            let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map(renderReason).join('\n') : ' ' + renderReason(reasons[0]) : 'as no adapter specified';
            throw new (0, _axiosErrorJsDefault.default)(`There is no suitable adapter to dispatch the request ` + s, 'ERR_NOT_SUPPORT');
        }
        return adapter;
    },
    adapters: knownAdapters
};

},{"../utils.js":"4AdI3","./http.js":"b3JVo","./xhr.js":"f0yTJ","./fetch.js":"1RQlp","../core/AxiosError.js":"fZ7SQ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"f0yTJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _settleJs = require("./../core/settle.js");
var _settleJsDefault = parcelHelpers.interopDefault(_settleJs);
var _transitionalJs = require("../defaults/transitional.js");
var _transitionalJsDefault = parcelHelpers.interopDefault(_transitionalJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _canceledErrorJs = require("../cancel/CanceledError.js");
var _canceledErrorJsDefault = parcelHelpers.interopDefault(_canceledErrorJs);
var _parseProtocolJs = require("../helpers/parseProtocol.js");
var _parseProtocolJsDefault = parcelHelpers.interopDefault(_parseProtocolJs);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _axiosHeadersJs = require("../core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
var _progressEventReducerJs = require("../helpers/progressEventReducer.js");
var _resolveConfigJs = require("../helpers/resolveConfig.js");
var _resolveConfigJsDefault = parcelHelpers.interopDefault(_resolveConfigJs);
const isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
exports.default = isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, _resolveConfigJsDefault.default)(config);
        let requestData = _config.data;
        const requestHeaders = (0, _axiosHeadersJsDefault.default).from(_config.headers).normalize();
        let { responseType, onUploadProgress, onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, _axiosHeadersJsDefault.default).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config,
                request
            };
            (0, _settleJsDefault.default)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, _axiosErrorJsDefault.default)('Request aborted', (0, _axiosErrorJsDefault.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            const msg = event && event.message ? event.message : 'Network Error';
            const err = new (0, _axiosErrorJsDefault.default)(msg, (0, _axiosErrorJsDefault.default).ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, _transitionalJsDefault.default);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, _axiosErrorJsDefault.default)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, _axiosErrorJsDefault.default).ETIMEDOUT : (0, _axiosErrorJsDefault.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, _utilsJsDefault.default).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, _utilsJsDefault.default).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, _progressEventReducerJs.progressEventReducer)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, _progressEventReducerJs.progressEventReducer)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, _canceledErrorJsDefault.default)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, _parseProtocolJsDefault.default)(_config.url);
        if (protocol && (0, _indexJsDefault.default).protocols.indexOf(protocol) === -1) {
            reject(new (0, _axiosErrorJsDefault.default)('Unsupported protocol ' + protocol + ':', (0, _axiosErrorJsDefault.default).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};

},{"./../utils.js":"4AdI3","./../core/settle.js":"f469A","../defaults/transitional.js":"jktpl","../core/AxiosError.js":"fZ7SQ","../cancel/CanceledError.js":"h2iVm","../helpers/parseProtocol.js":"5fJNM","../platform/index.js":"dnuuz","../core/AxiosHeaders.js":"jKjps","../helpers/progressEventReducer.js":"ctmjb","../helpers/resolveConfig.js":"ed2el","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"f469A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>settle);
var _axiosErrorJs = require("./AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
'use strict';
function settle(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, _axiosErrorJsDefault.default)('Request failed with status code ' + response.status, [
        (0, _axiosErrorJsDefault.default).ERR_BAD_REQUEST,
        (0, _axiosErrorJsDefault.default).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}

},{"./AxiosError.js":"fZ7SQ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5fJNM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>parseProtocol);
'use strict';
function parseProtocol(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || '';
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ctmjb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "progressEventReducer", ()=>progressEventReducer);
parcelHelpers.export(exports, "progressEventDecorator", ()=>progressEventDecorator);
parcelHelpers.export(exports, "asyncDecorator", ()=>asyncDecorator);
var _speedometerJs = require("./speedometer.js");
var _speedometerJsDefault = parcelHelpers.interopDefault(_speedometerJs);
var _throttleJs = require("./throttle.js");
var _throttleJsDefault = parcelHelpers.interopDefault(_throttleJs);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
const progressEventReducer = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, _speedometerJsDefault.default)(50, 250);
    return (0, _throttleJsDefault.default)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded,
            total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const progressEventDecorator = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable,
                total,
                loaded
            }),
        throttled[1]
    ];
};
const asyncDecorator = (fn)=>(...args)=>(0, _utilsJsDefault.default).asap(()=>fn(...args));

},{"./speedometer.js":"eVf9f","./throttle.js":"lGTVn","../utils.js":"4AdI3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eVf9f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
exports.default = speedometer;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lGTVn":[function(require,module,exports,__globalThis) {
/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn(...args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
exports.default = throttle;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ed2el":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _isURLSameOriginJs = require("./isURLSameOrigin.js");
var _isURLSameOriginJsDefault = parcelHelpers.interopDefault(_isURLSameOriginJs);
var _cookiesJs = require("./cookies.js");
var _cookiesJsDefault = parcelHelpers.interopDefault(_cookiesJs);
var _buildFullPathJs = require("../core/buildFullPath.js");
var _buildFullPathJsDefault = parcelHelpers.interopDefault(_buildFullPathJs);
var _mergeConfigJs = require("../core/mergeConfig.js");
var _mergeConfigJsDefault = parcelHelpers.interopDefault(_mergeConfigJs);
var _axiosHeadersJs = require("../core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
var _buildURLJs = require("./buildURL.js");
var _buildURLJsDefault = parcelHelpers.interopDefault(_buildURLJs);
exports.default = (config)=>{
    const newConfig = (0, _mergeConfigJsDefault.default)({}, config);
    let { data, withXSRFToken, xsrfHeaderName, xsrfCookieName, headers, auth } = newConfig;
    newConfig.headers = headers = (0, _axiosHeadersJsDefault.default).from(headers);
    newConfig.url = (0, _buildURLJsDefault.default)((0, _buildFullPathJsDefault.default)(newConfig.baseURL, newConfig.url, newConfig.allowAbsoluteUrls), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set('Authorization', 'Basic ' + btoa((auth.username || '') + ':' + (auth.password ? unescape(encodeURIComponent(auth.password)) : '')));
    if ((0, _utilsJsDefault.default).isFormData(data)) {
        if ((0, _indexJsDefault.default).hasStandardBrowserEnv || (0, _indexJsDefault.default).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // browser handles it
        else if ((0, _utilsJsDefault.default).isFunction(data.getHeaders)) {
            // Node.js FormData (like form-data package)
            const formHeaders = data.getHeaders();
            // Only set safe headers to avoid overwriting security headers
            const allowedHeaders = [
                'content-type',
                'content-length'
            ];
            Object.entries(formHeaders).forEach(([key, val])=>{
                if (allowedHeaders.includes(key.toLowerCase())) headers.set(key, val);
            });
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, _indexJsDefault.default).hasStandardBrowserEnv) {
        withXSRFToken && (0, _utilsJsDefault.default).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, _isURLSameOriginJsDefault.default)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, _cookiesJsDefault.default).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};

},{"../platform/index.js":"dnuuz","../utils.js":"4AdI3","./isURLSameOrigin.js":"bJ3hX","./cookies.js":"g1WPK","../core/buildFullPath.js":"cRRFe","../core/mergeConfig.js":"79q17","../core/AxiosHeaders.js":"jKjps","./buildURL.js":"4Gx5k","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bJ3hX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
exports.default = (0, _indexJsDefault.default).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, _indexJsDefault.default).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, _indexJsDefault.default).origin), (0, _indexJsDefault.default).navigator && /(msie|trident)/i.test((0, _indexJsDefault.default).navigator.userAgent)) : ()=>true;

},{"../platform/index.js":"dnuuz","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"g1WPK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
exports.default = (0, _indexJsDefault.default).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + '=' + encodeURIComponent(value)
        ];
        (0, _utilsJsDefault.default).isNumber(expires) && cookie.push('expires=' + new Date(expires).toGMTString());
        (0, _utilsJsDefault.default).isString(path) && cookie.push('path=' + path);
        (0, _utilsJsDefault.default).isString(domain) && cookie.push('domain=' + domain);
        secure === true && cookie.push('secure');
        document.cookie = cookie.join('; ');
    },
    read (name) {
        const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};

},{"./../utils.js":"4AdI3","../platform/index.js":"dnuuz","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cRRFe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>buildFullPath);
var _isAbsoluteURLJs = require("../helpers/isAbsoluteURL.js");
var _isAbsoluteURLJsDefault = parcelHelpers.interopDefault(_isAbsoluteURLJs);
var _combineURLsJs = require("../helpers/combineURLs.js");
var _combineURLsJsDefault = parcelHelpers.interopDefault(_combineURLsJs);
'use strict';
function buildFullPath(baseURL, requestedURL, allowAbsoluteUrls) {
    let isRelativeUrl = !(0, _isAbsoluteURLJsDefault.default)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls == false)) return (0, _combineURLsJsDefault.default)(baseURL, requestedURL);
    return requestedURL;
}

},{"../helpers/isAbsoluteURL.js":"WNHRO","../helpers/combineURLs.js":"92Aol","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"WNHRO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isAbsoluteURL);
'use strict';
function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"92Aol":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>combineURLs);
'use strict';
function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"79q17":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>mergeConfig);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosHeadersJs = require("./AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
'use strict';
const headersToObject = (thing)=>thing instanceof (0, _axiosHeadersJsDefault.default) ? {
        ...thing
    } : thing;
function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, prop, caseless) {
        if ((0, _utilsJsDefault.default).isPlainObject(target) && (0, _utilsJsDefault.default).isPlainObject(source)) return (0, _utilsJsDefault.default).merge.call({
            caseless
        }, target, source);
        else if ((0, _utilsJsDefault.default).isPlainObject(source)) return (0, _utilsJsDefault.default).merge({}, source);
        else if ((0, _utilsJsDefault.default).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, _utilsJsDefault.default).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, _utilsJsDefault.default).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, _utilsJsDefault.default).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, _utilsJsDefault.default).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, _utilsJsDefault.default).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties(headersToObject(a), headersToObject(b), prop, true)
    };
    (0, _utilsJsDefault.default).forEach(Object.keys({
        ...config1,
        ...config2
    }), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, _utilsJsDefault.default).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}

},{"../utils.js":"4AdI3","./AxiosHeaders.js":"jKjps","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1RQlp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFetch", ()=>getFetch);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _composeSignalsJs = require("../helpers/composeSignals.js");
var _composeSignalsJsDefault = parcelHelpers.interopDefault(_composeSignalsJs);
var _trackStreamJs = require("../helpers/trackStream.js");
var _axiosHeadersJs = require("../core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
var _progressEventReducerJs = require("../helpers/progressEventReducer.js");
var _resolveConfigJs = require("../helpers/resolveConfig.js");
var _resolveConfigJsDefault = parcelHelpers.interopDefault(_resolveConfigJs);
var _settleJs = require("../core/settle.js");
var _settleJsDefault = parcelHelpers.interopDefault(_settleJs);
const DEFAULT_CHUNK_SIZE = 65536;
const { isFunction } = (0, _utilsJsDefault.default);
const globalFetchAPI = (({ Request, Response })=>({
        Request,
        Response
    }))((0, _utilsJsDefault.default).global);
const { ReadableStream, TextEncoder } = (0, _utilsJsDefault.default).global;
const test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const factory = (env)=>{
    env = (0, _utilsJsDefault.default).merge.call({
        skipUndefined: true
    }, globalFetchAPI, env);
    const { fetch: envFetch, Request, Response } = env;
    const isFetchSupported = envFetch ? isFunction(envFetch) : typeof fetch === 'function';
    const isRequestSupported = isFunction(Request);
    const isResponseSupported = isFunction(Response);
    if (!isFetchSupported) return false;
    const isReadableStreamSupported = isFetchSupported && isFunction(ReadableStream);
    const encodeText = isFetchSupported && (typeof TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Request(str).arrayBuffer()));
    const supportsRequestStream = isRequestSupported && isReadableStreamSupported && test(()=>{
        let duplexAccessed = false;
        const hasContentType = new Request((0, _indexJsDefault.default).origin, {
            body: new ReadableStream(),
            method: 'POST',
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        }).headers.has('Content-Type');
        return duplexAccessed && !hasContentType;
    });
    const supportsResponseStream = isResponseSupported && isReadableStreamSupported && test(()=>(0, _utilsJsDefault.default).isReadableStream(new Response('').body));
    const resolvers = {
        stream: supportsResponseStream && ((res)=>res.body)
    };
    isFetchSupported && (()=>{
        [
            'text',
            'arrayBuffer',
            'blob',
            'formData',
            'stream'
        ].forEach((type)=>{
            !resolvers[type] && (resolvers[type] = (res, config)=>{
                let method = res && res[type];
                if (method) return method.call(res);
                throw new (0, _axiosErrorJsDefault.default)(`Response type '${type}' is not supported`, (0, _axiosErrorJsDefault.default).ERR_NOT_SUPPORT, config);
            });
        });
    })();
    const getBodyLength = async (body)=>{
        if (body == null) return 0;
        if ((0, _utilsJsDefault.default).isBlob(body)) return body.size;
        if ((0, _utilsJsDefault.default).isSpecCompliantForm(body)) {
            const _request = new Request((0, _indexJsDefault.default).origin, {
                method: 'POST',
                body
            });
            return (await _request.arrayBuffer()).byteLength;
        }
        if ((0, _utilsJsDefault.default).isArrayBufferView(body) || (0, _utilsJsDefault.default).isArrayBuffer(body)) return body.byteLength;
        if ((0, _utilsJsDefault.default).isURLSearchParams(body)) body = body + '';
        if ((0, _utilsJsDefault.default).isString(body)) return (await encodeText(body)).byteLength;
    };
    const resolveBodyLength = async (headers, body)=>{
        const length = (0, _utilsJsDefault.default).toFiniteNumber(headers.getContentLength());
        return length == null ? getBodyLength(body) : length;
    };
    return async (config)=>{
        let { url, method, data, signal, cancelToken, timeout, onDownloadProgress, onUploadProgress, responseType, headers, withCredentials = 'same-origin', fetchOptions } = (0, _resolveConfigJsDefault.default)(config);
        let _fetch = envFetch || fetch;
        responseType = responseType ? (responseType + '').toLowerCase() : 'text';
        let composedSignal = (0, _composeSignalsJsDefault.default)([
            signal,
            cancelToken && cancelToken.toAbortSignal()
        ], timeout);
        let request = null;
        const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
            composedSignal.unsubscribe();
        });
        let requestContentLength;
        try {
            if (onUploadProgress && supportsRequestStream && method !== 'get' && method !== 'head' && (requestContentLength = await resolveBodyLength(headers, data)) !== 0) {
                let _request = new Request(url, {
                    method: 'POST',
                    body: data,
                    duplex: "half"
                });
                let contentTypeHeader;
                if ((0, _utilsJsDefault.default).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
                if (_request.body) {
                    const [onProgress, flush] = (0, _progressEventReducerJs.progressEventDecorator)(requestContentLength, (0, _progressEventReducerJs.progressEventReducer)((0, _progressEventReducerJs.asyncDecorator)(onUploadProgress)));
                    data = (0, _trackStreamJs.trackStream)(_request.body, DEFAULT_CHUNK_SIZE, onProgress, flush);
                }
            }
            if (!(0, _utilsJsDefault.default).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
            // Cloudflare Workers throws when credentials are defined
            // see https://github.com/cloudflare/workerd/issues/902
            const isCredentialsSupported = isRequestSupported && "credentials" in Request.prototype;
            const resolvedOptions = {
                ...fetchOptions,
                signal: composedSignal,
                method: method.toUpperCase(),
                headers: headers.normalize().toJSON(),
                body: data,
                duplex: "half",
                credentials: isCredentialsSupported ? withCredentials : undefined
            };
            request = isRequestSupported && new Request(url, resolvedOptions);
            let response = await (isRequestSupported ? _fetch(request, fetchOptions) : _fetch(url, resolvedOptions));
            const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
            if (supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
                const options = {};
                [
                    'status',
                    'statusText',
                    'headers'
                ].forEach((prop)=>{
                    options[prop] = response[prop];
                });
                const responseContentLength = (0, _utilsJsDefault.default).toFiniteNumber(response.headers.get('content-length'));
                const [onProgress, flush] = onDownloadProgress && (0, _progressEventReducerJs.progressEventDecorator)(responseContentLength, (0, _progressEventReducerJs.progressEventReducer)((0, _progressEventReducerJs.asyncDecorator)(onDownloadProgress), true)) || [];
                response = new Response((0, _trackStreamJs.trackStream)(response.body, DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                    flush && flush();
                    unsubscribe && unsubscribe();
                }), options);
            }
            responseType = responseType || 'text';
            let responseData = await resolvers[(0, _utilsJsDefault.default).findKey(resolvers, responseType) || 'text'](response, config);
            !isStreamResponse && unsubscribe && unsubscribe();
            return await new Promise((resolve, reject)=>{
                (0, _settleJsDefault.default)(resolve, reject, {
                    data: responseData,
                    headers: (0, _axiosHeadersJsDefault.default).from(response.headers),
                    status: response.status,
                    statusText: response.statusText,
                    config,
                    request
                });
            });
        } catch (err) {
            unsubscribe && unsubscribe();
            if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) throw Object.assign(new (0, _axiosErrorJsDefault.default)('Network Error', (0, _axiosErrorJsDefault.default).ERR_NETWORK, config, request), {
                cause: err.cause || err
            });
            throw (0, _axiosErrorJsDefault.default).from(err, err && err.code, config, request);
        }
    };
};
const seedCache = new Map();
const getFetch = (config)=>{
    let env = config ? config.env : {};
    const { fetch: fetch1, Request, Response } = env;
    const seeds = [
        Request,
        Response,
        fetch1
    ];
    let len = seeds.length, i = len, seed, target, map = seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : factory(env));
        map = target;
    }
    return target;
};
const adapter = getFetch();
exports.default = adapter;

},{"../platform/index.js":"dnuuz","../utils.js":"4AdI3","../core/AxiosError.js":"fZ7SQ","../helpers/composeSignals.js":"5luDQ","../helpers/trackStream.js":"5CnPE","../core/AxiosHeaders.js":"jKjps","../helpers/progressEventReducer.js":"ctmjb","../helpers/resolveConfig.js":"ed2el","../core/settle.js":"f469A","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5luDQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _canceledErrorJs = require("../cancel/CanceledError.js");
var _canceledErrorJsDefault = parcelHelpers.interopDefault(_canceledErrorJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
const composeSignals = (signals, timeout)=>{
    const { length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, _axiosErrorJsDefault.default) ? err : new (0, _canceledErrorJsDefault.default)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, _axiosErrorJsDefault.default)(`timeout ${timeout} of ms exceeded`, (0, _axiosErrorJsDefault.default).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener('abort', onabort));
        const { signal } = controller;
        signal.unsubscribe = ()=>(0, _utilsJsDefault.default).asap(unsubscribe);
        return signal;
    }
};
exports.default = composeSignals;

},{"../cancel/CanceledError.js":"h2iVm","../core/AxiosError.js":"fZ7SQ","../utils.js":"4AdI3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5CnPE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "streamChunk", ()=>streamChunk);
parcelHelpers.export(exports, "readBytes", ()=>readBytes);
parcelHelpers.export(exports, "trackStream", ()=>trackStream);
const streamChunk = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const readBytes = async function*(iterable, chunkSize) {
    for await (const chunk of readStream(iterable))yield* streamChunk(chunk, chunkSize);
};
const readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done, value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const trackStream = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = readBytes(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done, value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ii46t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _dataJs = require("../env/data.js");
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
'use strict';
const validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, _dataJs.VERSION) + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, _axiosErrorJsDefault.default)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, _axiosErrorJsDefault.default).ERR_DEPRECATED);
        if (version && !deprecatedWarnings[opt]) {
            deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new (0, _axiosErrorJsDefault.default)('options must be an object', (0, _axiosErrorJsDefault.default).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, _axiosErrorJsDefault.default)('option ' + opt + ' must be ' + result, (0, _axiosErrorJsDefault.default).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, _axiosErrorJsDefault.default)('Unknown option ' + opt, (0, _axiosErrorJsDefault.default).ERR_BAD_OPTION);
    }
}
exports.default = {
    assertOptions,
    validators
};

},{"../env/data.js":"2JBGK","../core/AxiosError.js":"fZ7SQ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2JBGK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VERSION", ()=>VERSION);
const VERSION = "1.12.2";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2bdtR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _canceledErrorJs = require("./CanceledError.js");
var _canceledErrorJsDefault = parcelHelpers.interopDefault(_canceledErrorJs);
'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, _canceledErrorJsDefault.default)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token,
            cancel
        };
    }
}
exports.default = CancelToken;

},{"./CanceledError.js":"h2iVm","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"axv13":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>spread);
'use strict';
function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eb8Z2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isAxiosError);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
'use strict';
function isAxiosError(payload) {
    return (0, _utilsJsDefault.default).isObject(payload) && payload.isAxiosError === true;
}

},{"./../utils.js":"4AdI3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lm3tN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries(HttpStatusCode).forEach(([key, value])=>{
    HttpStatusCode[value] = key;
});
exports.default = HttpStatusCode;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bvYXn":[function() {},{}],"4Rcx9":[function() {},{}],"aEn67":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
var _userDetailsCss = require("./UserDetails.css");
function UserDetails({ user, onClose, onUserUpdated }) {
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const [error, setError] = (0, _react.useState)('');
    const [isAdmin, setIsAdmin] = (0, _react.useState)(user.is_admin);
    const handleToggleAdmin = async ()=>{
        setIsLoading(true);
        setError('');
        try {
            await (0, _axiosDefault.default).put(`${"/api"}/admin/user/${user.username}/admin-status`, {
                is_admin: !isAdmin
            }, {
                headers: {
                    'Authorization': 'Bearer admin',
                    'Content-Type': 'application/json',
                    'ngrok-skip-browser-warning': 'true'
                }
            });
            setIsAdmin(!isAdmin);
            if (onUserUpdated) onUserUpdated();
        } catch (error) {
            console.error('Erreur lors de la modification du statut admin:', error);
            setError("Erreur lors de la modification du statut admin. Veuillez r\xe9essayer.");
        } finally{
            setIsLoading(false);
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "user-details-container",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "user-details-header",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                        children: "D\xe9tails de l'utilisateur"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: "user-details-close-btn",
                        onClick: onClose,
                        children: "\xe0\u2014"
                    })
                ]
            }),
            error && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "user-details-error",
                children: error
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "user-details-content",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "user-details-field",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "user-details-label",
                                children: "Nom d'utilisateur:"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "user-details-value",
                                children: user.username
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "user-details-field",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "user-details-label",
                                children: "Statut Admin:"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "user-details-value",
                                children: isAdmin ? 'Administrateur' : 'Utilisateur standard'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: `user-details-btn ${isAdmin ? 'user-details-btn-warning' : 'user-details-btn-primary'}`,
                        onClick: handleToggleAdmin,
                        disabled: isLoading,
                        children: isLoading ? 'Chargement...' : isAdmin ? "R\xe9voquer les droits admin" : 'Accorder les droits admin'
                    })
                ]
            })
        ]
    });
}
exports.default = UserDetails;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","axios":"kL5AO","./UserDetails.css":"cg6jH","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cg6jH":[function() {},{}],"9CFw0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _adminAdvancedCss = require("./AdminAdvanced.css"); // Utiliser le nouveau fichier CSS
// Composant simple pour afficher un graphique à barres
const BarChart = ({ data, title })=>{
    // Vérifier si les données sont disponibles
    if (!data || data.length === 0) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "bar-chart-container",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                children: title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "empty-chart-message",
                children: "Aucune donn\xe9e disponible"
            })
        ]
    });
    // Trouver la valeur maximale pour dimensionner correctement les barres
    const maxValue = Math.max(...data.map((item)=>item.count));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "bar-chart-container",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                children: title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "bar-chart",
                children: data.map((item, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "bar-chart-item",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "bar-chart-label",
                                children: item.date
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "bar-chart-bar-container",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "bar-chart-bar",
                                        style: {
                                            width: `${item.count / maxValue * 100}%`,
                                            minWidth: item.count > 0 ? '2%' : '0'
                                        }
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "bar-chart-value",
                                        children: item.count
                                    })
                                ]
                            })
                        ]
                    }, index))
            })
        ]
    });
};
// Composant pour afficher un graphique circulaire simple
const PieChart = ({ data, title })=>{
    // Vérifier si les données sont disponibles et valides
    if (!data || data.length === 0 || data.every((item)=>item.value === 0)) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "pie-chart-container",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                children: title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "empty-chart-message",
                children: "Aucune donn\xe9e disponible"
            })
        ]
    });
    const total = data.reduce((sum, item)=>sum + item.value, 0);
    let startAngle = 0;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "pie-chart-container",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                children: title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "pie-chart-wrapper",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "pie-chart",
                        children: data.map((item, index)=>{
                            const angle = item.value / total * 360;
                            const styles = {
                                '--start-angle': `${startAngle}deg`,
                                '--end-angle': `${startAngle + angle}deg`,
                                '--color': item.color
                            };
                            startAngle += angle;
                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "pie-slice",
                                style: styles
                            }, index);
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "pie-chart-legend",
                        children: data.map((item, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "legend-item",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "legend-color",
                                        style: {
                                            backgroundColor: item.color
                                        }
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "legend-label",
                                        children: item.label
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "legend-value",
                                        children: [
                                            item.value,
                                            " (",
                                            Math.round(item.value / total * 100),
                                            "%)"
                                        ]
                                    })
                                ]
                            }, index))
                    })
                ]
            })
        ]
    });
};
function AdvancedUserStats({ stats }) {
    // Vérifier si les statistiques sont disponibles
    if (!stats) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "advanced-stats-container",
        children: "Chargement des statistiques..."
    });
    // Données pour le graphique circulaire des statuts utilisateur
    const userStatusData = [
        {
            label: 'Actifs',
            value: stats.active_users || 0,
            color: '#4CAF50'
        },
        {
            label: 'Inactifs',
            value: stats.inactive_users || 0,
            color: '#F44336'
        }
    ];
    // Données pour le graphique circulaire des rôles utilisateur
    const userRolesData = [
        {
            label: 'Admins',
            value: stats.admin_users || 0,
            color: '#2196F3'
        },
        {
            label: 'Utilisateurs',
            value: (stats.total_users || 0) - (stats.admin_users || 0),
            color: '#FF9800'
        }
    ];
    // Vérifier si les données de top_users sont disponibles
    const hasTopUsers = stats.top_users && stats.top_users.length > 0;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "advanced-stats-container",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                children: "Statistiques des Utilisateurs"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "stats-overview",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "stats-card",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                children: "Total des utilisateurs"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "stats-value",
                                children: stats.total_users || 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "stats-card",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                children: "Utilisateurs actifs"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "stats-value",
                                children: stats.active_users || 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "stats-card",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                children: "Utilisateurs inactifs"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "stats-value",
                                children: stats.inactive_users || 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "stats-card",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                children: "Administrateurs"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "stats-value",
                                children: stats.admin_users || 0
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "charts-container",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "chart-row",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "chart-column",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(PieChart, {
                                    data: userStatusData,
                                    title: "R\xe9partition par statut"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "chart-column",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(PieChart, {
                                    data: userRolesData,
                                    title: "R\xe9partition par r\xf4le"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "chart-row full-width",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(BarChart, {
                            data: stats.users_by_month || [],
                            title: "Nouveaux utilisateurs par mois"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "top-users-section",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                        children: "Utilisateurs les plus actifs"
                    }),
                    hasTopUsers ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "admin-table-container",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("table", {
                            className: "admin-table",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                                children: "Rang"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                                children: "Nom d'utilisateur"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                                children: "Nombre de connexions"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {
                                    children: stats.top_users.map((user, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                    children: index + 1
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                    children: user.username
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                    children: user.login_count || 0
                                                })
                                            ]
                                        }, index))
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "empty-chart-message",
                        children: "Aucun utilisateur actif trouv\xe9"
                    })
                ]
            })
        ]
    });
}
exports.default = AdvancedUserStats;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./AdminAdvanced.css":"brEL2","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"brEL2":[function() {},{}],"nGHlO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
var _adminAdvancedCss = require("./AdminAdvanced.css"); // Utiliser le nouveau fichier CSS
function UserManagement({ users, onUserUpdated }) {
    const [selectedUser, setSelectedUser] = (0, _react.useState)(null);
    const [resetPasswordData, setResetPasswordData] = (0, _react.useState)({
        username: '',
        new_password: '',
        confirm_password: ''
    });
    const [isResetting, setIsResetting] = (0, _react.useState)(false);
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const [error, setError] = (0, _react.useState)('');
    const [success, setSuccess] = (0, _react.useState)('');
    const handleUserSelect = (user)=>{
        setSelectedUser(user);
        setResetPasswordData({
            username: user.username,
            new_password: '',
            confirm_password: ''
        });
        setIsResetting(false);
        setError('');
        setSuccess('');
    };
    const handleToggleActive = async (username, currentStatus)=>{
        setIsLoading(true);
        setError('');
        setSuccess('');
        try {
            await (0, _axiosDefault.default).post(`${"/api"}/api/users/toggle-status`, {
                username,
                active: !currentStatus
            }, {
                headers: {
                    'Authorization': 'Bearer admin',
                    'Content-Type': 'application/json',
                    'ngrok-skip-browser-warning': 'true'
                }
            });
            setSuccess(`Le statut de l'utilisateur ${username} a \xe9t\xe9 mis \xe0\xa0 jour avec succ\xe8s.`);
            if (onUserUpdated) onUserUpdated();
            // Si c'est l'utilisateur actuellement sélectionné, mettre à  jour son statut
            if (selectedUser && selectedUser.username === username) setSelectedUser({
                ...selectedUser,
                is_active: !currentStatus
            });
        } catch (error) {
            console.error('Erreur lors de la modification du statut:', error);
            setError("Erreur lors de la modification du statut. Veuillez r\xe9essayer.");
        } finally{
            setIsLoading(false);
        }
    };
    const handleToggleAdmin = async (username, currentAdminStatus)=>{
        setIsLoading(true);
        setError('');
        setSuccess('');
        try {
            await (0, _axiosDefault.default).put(`${"/api"}/admin/user/${username}/admin-status`, {
                is_admin: !currentAdminStatus
            }, {
                headers: {
                    'Authorization': 'Bearer admin',
                    'Content-Type': 'application/json',
                    'ngrok-skip-browser-warning': 'true'
                }
            });
            setSuccess(`Le statut administrateur de ${username} a \xe9t\xe9 mis \xe0\xa0 jour avec succ\xe8s.`);
            if (onUserUpdated) onUserUpdated();
            // Si c'est l'utilisateur actuellement sélectionné, mettre à  jour son statut
            if (selectedUser && selectedUser.username === username) setSelectedUser({
                ...selectedUser,
                is_admin: !currentAdminStatus
            });
        } catch (error) {
            console.error('Erreur lors de la modification du statut admin:', error);
            setError("Erreur lors de la modification du statut admin. Veuillez r\xe9essayer.");
        } finally{
            setIsLoading(false);
        }
    };
    const handleResetPassword = async (e)=>{
        e.preventDefault();
        if (resetPasswordData.new_password !== resetPasswordData.confirm_password) {
            setError('Les mots de passe ne correspondent pas.');
            return;
        }
        if (resetPasswordData.new_password.length < 6) {
            setError("Le mot de passe doit contenir au moins 6 caract\xe8res.");
            return;
        }
        setIsLoading(true);
        setError('');
        setSuccess('');
        try {
            await (0, _axiosDefault.default).post(`${"/api"}/api/users/reset-password`, {
                username: resetPasswordData.username,
                new_password: resetPasswordData.new_password
            }, {
                headers: {
                    'Authorization': 'Bearer admin',
                    'Content-Type': 'application/json',
                    'ngrok-skip-browser-warning': 'true'
                }
            });
            setSuccess(`Le mot de passe de l'utilisateur ${resetPasswordData.username} a \xe9t\xe9 r\xe9initialis\xe9 avec succ\xe8s.`);
            setResetPasswordData({
                ...resetPasswordData,
                new_password: '',
                confirm_password: ''
            });
            setIsResetting(false);
        } catch (error) {
            console.error("Erreur lors de la r\xe9initialisation du mot de passe:", error);
            setError("Erreur lors de la r\xe9initialisation du mot de passe. Veuillez r\xe9essayer.");
        } finally{
            setIsLoading(false);
        }
    };
    const fetchUserDetails = async (username)=>{
        setIsLoading(true);
        setError('');
        try {
            const response = await (0, _axiosDefault.default).get(`${"/api"}/api/users/${username}`, {
                headers: {
                    'Authorization': 'Bearer admin',
                    'Content-Type': 'application/json',
                    'ngrok-skip-browser-warning': 'true'
                }
            });
            setSelectedUser(response.data);
            setResetPasswordData({
                username: response.data.username,
                new_password: '',
                confirm_password: ''
            });
        } catch (error) {
            console.error("Erreur lors du chargement des d\xe9tails utilisateur:", error);
            setError("Erreur lors du chargement des d\xe9tails utilisateur. Veuillez r\xe9essayer.");
        } finally{
            setIsLoading(false);
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "user-management-container",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                children: "Gestion des Utilisateurs"
            }),
            error && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "admin-error",
                children: error
            }),
            success && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "admin-success",
                children: success
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "user-management-layout",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "user-list-container",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                children: "Liste des Utilisateurs"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "admin-table-container",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("table", {
                                    className: "admin-table",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("thead", {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                                        children: "Nom d'utilisateur"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                                        children: "Administrateur"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                                        children: "Statut"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                                        children: "Actions"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {
                                            children: users.map((user, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                                    className: selectedUser && selectedUser.username === user.username ? 'selected-row' : '',
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                            children: user.username
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                            children: user.is_admin ? 'Oui' : 'Non'
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                            children: user.is_active !== false ? 'Actif' : 'Inactif'
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("td", {
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                                    className: "admin-btn admin-btn-primary",
                                                                    onClick: ()=>fetchUserDetails(user.username),
                                                                    children: "D\xe9tails"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                                    className: `admin-btn ${user.is_admin ? 'admin-btn-warning' : 'admin-btn-success'}`,
                                                                    onClick: ()=>handleToggleAdmin(user.username, user.is_admin),
                                                                    disabled: isLoading,
                                                                    children: user.is_admin ? "R\xe9voquer admin" : 'Faire admin'
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                                    className: `admin-btn ${user.is_active !== false ? 'admin-btn-warning' : 'admin-btn-success'}`,
                                                                    onClick: ()=>handleToggleActive(user.username, user.is_active !== false),
                                                                    disabled: isLoading,
                                                                    children: user.is_active !== false ? "D\xe9sactiver" : 'Activer'
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }, index))
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    selectedUser && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "user-details-panel",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                children: "D\xe9tails de l'Utilisateur"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "user-details-content",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "user-details-field",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "user-details-label",
                                                children: "Nom d'utilisateur:"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "user-details-value",
                                                children: selectedUser.username
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "user-details-field",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "user-details-label",
                                                children: "Statut:"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "user-details-value",
                                                children: selectedUser.is_active !== false ? 'Actif' : 'Inactif'
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "user-details-field",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "user-details-label",
                                                children: "R\xe0\xb4le:"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "user-details-value",
                                                children: selectedUser.is_admin ? 'Administrateur' : 'Utilisateur standard'
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "user-details-field",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "user-details-label",
                                                children: "Derni\xe8re connexion:"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "user-details-value",
                                                children: selectedUser.last_login_formatted || "Jamais connect\xe9"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "user-details-field",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "user-details-label",
                                                children: "Nombre de connexions:"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "user-details-value",
                                                children: selectedUser.login_count || 0
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "user-details-field",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "user-details-label",
                                                children: "Cr\xe9\xe9 le:"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "user-details-value",
                                                children: selectedUser.created_at_formatted || 'Non disponible'
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "user-details-actions",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            className: "admin-btn admin-btn-primary",
                                            onClick: ()=>setIsResetting(!isResetting),
                                            children: isResetting ? 'Annuler' : "R\xe9initialiser le mot de passe"
                                        })
                                    }),
                                    isResetting && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                                        onSubmit: handleResetPassword,
                                        className: "reset-password-form",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                                children: "R\xe9initialisation du mot de passe"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "form-group",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                        htmlFor: "new_password",
                                                        children: "Nouveau mot de passe:"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                        type: "password",
                                                        id: "new_password",
                                                        value: resetPasswordData.new_password,
                                                        onChange: (e)=>setResetPasswordData({
                                                                ...resetPasswordData,
                                                                new_password: e.target.value
                                                            }),
                                                        required: true
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "form-group",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                        htmlFor: "confirm_password",
                                                        children: "Confirmer le mot de passe:"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                        type: "password",
                                                        id: "confirm_password",
                                                        value: resetPasswordData.confirm_password,
                                                        onChange: (e)=>setResetPasswordData({
                                                                ...resetPasswordData,
                                                                confirm_password: e.target.value
                                                            }),
                                                        required: true
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                type: "submit",
                                                className: "admin-btn admin-btn-success",
                                                disabled: isLoading,
                                                children: isLoading ? 'Chargement...' : "Confirmer la r\xe9initialisation"
                                            })
                                        ]
                                    }),
                                    selectedUser.login_history && selectedUser.login_history.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "login-history",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                                children: "Historique des connexions"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
                                                children: selectedUser.login_history_formatted?.map((date, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                                        children: date
                                                    }, index))
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
exports.default = UserManagement;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","axios":"kL5AO","./AdminAdvanced.css":"brEL2","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"brEL2":[function() {},{}],"2l6WH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
var _adminAdvancedCss = require("./AdminAdvanced.css");
function CaseManagement() {
    const [cases, setCases] = (0, _react.useState)([]);
    const [filteredCases, setFilteredCases] = (0, _react.useState)([]);
    const [selectedCase, setSelectedCase] = (0, _react.useState)(null);
    const [isLoading, setIsLoading] = (0, _react.useState)(true);
    const [error, setError] = (0, _react.useState)('');
    const [success, setSuccess] = (0, _react.useState)('');
    const [statsData, setStatsData] = (0, _react.useState)({
        totalCases: 0,
        completedCases: 0,
        inProgressCases: 0,
        categoriesAvgScores: {}
    });
    // à‰tats pour le filtrage et la recherche
    const [searchTerm, setSearchTerm] = (0, _react.useState)('');
    const [filterByStatus, setFilterByStatus] = (0, _react.useState)('all');
    const [filterByCategory, setFilterByCategory] = (0, _react.useState)('all');
    const [sortBy, setSortBy] = (0, _react.useState)('date_desc');
    (0, _react.useEffect)(()=>{
        fetchCases();
    }, []);
    // Effet pour filtrer les cas lorsque les critères de filtre changent
    (0, _react.useEffect)(()=>{
        const filtered = cases.filter((caseItem)=>{
            const matchesSearch = caseItem.company_name?.toLowerCase().includes(searchTerm.toLowerCase()) || caseItem.activity_sector?.toLowerCase().includes(searchTerm.toLowerCase());
            const status = getCaseStatus(caseItem);
            const matchesStatus = filterByStatus === 'all' || filterByStatus === 'completed' && status === "Compl\xe9t\xe9" || filterByStatus === 'in_progress' && status === 'En cours' || filterByStatus === 'not_started' && status === "Non d\xe9marr\xe9";
            return matchesSearch && matchesStatus;
        });
        setFilteredCases(filtered);
    }, [
        cases,
        searchTerm,
        filterByStatus,
        filterByCategory
    ]);
    const fetchCases = async ()=>{
        setIsLoading(true);
        try {
            const response = await (0, _axiosDefault.default).get(`${"/api"}/api/all-cases`);
            const casesData = response.data;
            setCases(casesData);
            setFilteredCases(casesData);
            // Calculer les statistiques à  partir des données des cas
            updateStatsData(casesData);
            setError(null);
        } catch (err) {
            console.error("Erreur lors de la r\xe9cup\xe9ration des cas:", err);
            setError("Impossible de charger les donn\xe9es des cas. Utilisation des donn\xe9es de d\xe9monstration.");
            // Utiliser des données de démonstration en cas d'erreur
            const demoData = generateDemoCases(15); // Générer 15 cas de démonstration
            setCases(demoData);
            setFilteredCases(demoData);
            // Calculer les statistiques pour les données de démo
            updateStatsData(demoData);
        } finally{
            setIsLoading(false);
        }
    };
    // Fonction pour générer des données de démonstration
    const generateDemoCases = (count = 15)=>{
        const sectors = [
            'Industrie',
            'Services',
            'Agroalimentaire',
            'Technologie',
            "Sant\xe9"
        ];
        const cases = [];
        for(let i = 0; i < count; i++){
            const caseData = {
                _id: `demo-case-${i}`,
                company_name: `Entreprise ${i + 1}`,
                activity_sector: sectors[Math.floor(Math.random() * sectors.length)],
                company_size: Math.floor(Math.random() * 500) + 10,
                timestamp: new Date(Date.now() - Math.floor(Math.random() * 10000000000)).toISOString(),
                userId: `user-${Math.floor(Math.random() * 10) + 1}`,
                // Générer des scores aléatoires pour chaque catégorie
                environmental: {
                    Total: Math.floor(Math.random() * 10)
                },
                social: {
                    Total: Math.floor(Math.random() * 10)
                },
                modernization: {
                    Total: Math.floor(Math.random() * 10)
                },
                leadTime: {
                    Total: Math.floor(Math.random() * 10)
                },
                cost: {
                    Total: Math.floor(Math.random() * 10)
                },
                quality: {
                    Total: Math.floor(Math.random() * 10)
                },
                clientConsumer: {
                    Total: Math.floor(Math.random() * 10)
                }
            };
            // Certains cas auront des scores à  0 pour simuler des cas non démarrés ou partiellement complétés
            if (i % 3 === 0) {
                caseData.environmental.Total = 0;
                caseData.social.Total = 0;
            } else if (i % 5 === 0) {
                caseData.quality.Total = 0;
                caseData.clientConsumer.Total = 0;
            }
            cases.push(caseData);
        }
        return cases;
    };
    const handleCaseSelect = (caseData)=>{
        setSelectedCase(caseData);
        setError('');
        setSuccess('');
    };
    const handleRefreshScores = async (caseId)=>{
        setIsLoading(true);
        setError('');
        setSuccess('');
        try {
            await (0, _axiosDefault.default).post(`${"/api"}/api/refresh-scores/${caseId}`, {}, {
                headers: {
                    'Authorization': 'Bearer admin',
                    'Content-Type': 'application/json',
                    'ngrok-skip-browser-warning': 'true'
                }
            });
            setSuccess(`Les scores du cas ont \xe9t\xe9 recalcul\xe9s avec succ\xe8s.`);
            fetchCases(); // Recharger tous les cas pour mettre à  jour la liste
        } catch (error) {
            console.error('Erreur lors du recalcul des scores:', error);
            setError("Erreur lors du recalcul des scores. Veuillez r\xe9essayer.");
        } finally{
            setIsLoading(false);
        }
    };
    // Fonction pour obtenir le statut d'un cas en fonction des scores
    const getCaseStatus = (caseItem)=>{
        if (!caseItem) return "Non d\xe9marr\xe9";
        // Vérifier quelles catégories sont présentes dans ce cas
        const presentCategories = [
            'environmental',
            'social',
            'modernization',
            'leadTime',
            'cost',
            'quality',
            'clientConsumer'
        ].filter((category)=>caseItem[category] && typeof caseItem[category] === 'object');
        // Si aucune catégorie n'est présente, considérer comme non démarré
        if (presentCategories.length === 0) return "Non d\xe9marr\xe9";
        // Vérifier si tous les scores sont à  0 pour les catégories présentes
        const allZero = presentCategories.every((category)=>!caseItem[category].Total || caseItem[category].Total === 0);
        if (allZero) return "Non d\xe9marr\xe9";
        // Compter combien de catégories ont un score supérieur à  0
        const categoriesWithScores = presentCategories.filter((category)=>caseItem[category] && caseItem[category].Total > 0);
        // Si au moins 60% des catégories présentes ont un score, considérer comme complété
        const completionRatio = categoriesWithScores.length / presentCategories.length;
        // Un cas est complété si au moins 60% des catégories disponibles ont un score
        return completionRatio >= 0.6 ? "Compl\xe9t\xe9" : 'En cours';
    };
    // Formatage de la date
    const formatDate = (dateString)=>{
        if (!dateString) return 'Date inconnue';
        const date = new Date(dateString);
        return date.toLocaleDateString('fr-FR', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };
    // Trier les cas
    const sortedCases = [
        ...filteredCases
    ].sort((a, b)=>{
        switch(sortBy){
            case 'date_asc':
                return new Date(a.timestamp || a.date_created) - new Date(b.timestamp || b.date_created);
            case 'date_desc':
                return new Date(b.timestamp || b.date_created) - new Date(a.timestamp || a.date_created);
            case 'name_asc':
                return (a.company_name || '').localeCompare(b.company_name || '');
            case 'name_desc':
                return (b.company_name || '').localeCompare(a.company_name || '');
            default:
                return 0;
        }
    });
    // Rendu des statistiques
    const renderCaseStats = ()=>{
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "case-stats",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "stats-card",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                            children: "Total des cas"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "stats-value",
                            children: statsData.totalCases
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "stats-card",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                            children: "Cas compl\xe9t\xe9s"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "stats-value",
                            children: statsData.completedCases
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "stats-card",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                            children: "Cas en cours"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "stats-value",
                            children: statsData.inProgressCases
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "stats-card",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                            children: "Taux de compl\xe9tion"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "stats-value",
                            children: statsData.totalCases > 0 ? `${Math.round(statsData.completedCases / statsData.totalCases * 100)}%` : '0%'
                        })
                    ]
                })
            ]
        });
    };
    // Rendu du graphique des scores moyens par catégorie
    const renderCategoryScores = ()=>{
        const categories = {
            environmental: 'Environnement',
            social: 'Social',
            modernization: 'Modernisation',
            leadTime: "D\xe9lai",
            cost: "Co\xe0\xbbt",
            quality: "Qualit\xe9",
            clientConsumer: 'Client/Consommateur'
        };
        const scores = statsData.categoriesAvgScores;
        if (!scores || Object.keys(scores).length === 0) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "empty-chart-message",
            children: "Aucune donn\xe9e disponible"
        });
        // Trouver le score maximum pour dimensionner correctement les barres
        const maxScore = Math.max(...Object.values(scores));
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "category-scores-chart",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                    children: "Scores moyens par cat\xe9gorie"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "bar-chart",
                    children: Object.entries(scores).map(([category, score], index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "bar-chart-item",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "bar-chart-label",
                                    children: categories[category] || category
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "bar-chart-bar-container",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "bar-chart-bar",
                                            style: {
                                                width: `${score / maxScore * 100}%`,
                                                minWidth: score > 0 ? '2%' : '0'
                                            }
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "bar-chart-value",
                                            children: score.toFixed(1)
                                        })
                                    ]
                                })
                            ]
                        }, index))
                })
            ]
        });
    };
    // Fonction pour calculer et mettre à  jour les statistiques
    const updateStatsData = (casesData)=>{
        if (!casesData || casesData.length === 0) {
            setStatsData({
                totalCases: 0,
                completedCases: 0,
                inProgressCases: 0,
                categoriesAvgScores: {}
            });
            return;
        }
        // Calculer le nombre total de cas
        const totalCases = casesData.length;
        // Calculer le nombre de cas par statut
        let completedCount = 0;
        let inProgressCount = 0;
        // Calculer les scores moyens par catégorie
        const categoryScores = {
            environmental: [],
            social: [],
            modernization: [],
            leadTime: [],
            cost: [],
            quality: [],
            clientConsumer: []
        };
        casesData.forEach((caseItem)=>{
            const status = getCaseStatus(caseItem);
            if (status === "Compl\xe9t\xe9") completedCount++;
            else if (status === 'En cours') inProgressCount++;
            // Collecter les scores par catégorie
            Object.entries(categoryScores).forEach(([category, scores])=>{
                if (caseItem[category] && typeof caseItem[category].Total === 'number') scores.push(caseItem[category].Total);
            });
        });
        // Calculer les moyennes pour chaque catégorie
        const categoriesAvgScores = {};
        Object.entries(categoryScores).forEach(([category, scores])=>{
            if (scores.length > 0) {
                const sum = scores.reduce((acc, score)=>acc + score, 0);
                categoriesAvgScores[category] = parseFloat((sum / scores.length).toFixed(1));
            } else categoriesAvgScores[category] = 0;
        });
        // Mettre à  jour l'état des statistiques
        setStatsData({
            totalCases,
            completedCases: completedCount,
            inProgressCases: inProgressCount,
            categoriesAvgScores
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "case-management-container",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                children: "Gestion des Cas"
            }),
            error && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "admin-error",
                children: error
            }),
            success && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "admin-success",
                children: success
            }),
            renderCaseStats(),
            renderCategoryScores(),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "filters-container",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "search-filter",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                            type: "text",
                            placeholder: "Rechercher une entreprise...",
                            value: searchTerm,
                            onChange: (e)=>setSearchTerm(e.target.value),
                            className: "search-input"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "status-filter",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                children: "Statut:"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("select", {
                                value: filterByStatus,
                                onChange: (e)=>setFilterByStatus(e.target.value),
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                        value: "all",
                                        children: "Tous"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                        value: "completed",
                                        children: "Compl\xe9t\xe9s"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                        value: "in_progress",
                                        children: "En cours"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                        value: "not_started",
                                        children: "Non d\xe9marr\xe9s"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "sort-options",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                children: "Trier par:"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("select", {
                                value: sortBy,
                                onChange: (e)=>setSortBy(e.target.value),
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                        value: "date_desc",
                                        children: "Date (r\xe9cent \xe2\u2020\u2019 ancien)"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                        value: "date_asc",
                                        children: "Date (ancien \xe2\u2020\u2019 r\xe9cent)"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                        value: "name_asc",
                                        children: "Nom (A \xe2\u2020\u2019 Z)"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                        value: "name_desc",
                                        children: "Nom (Z \xe2\u2020\u2019 A)"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "case-management-layout",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "cases-list-container",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h3", {
                                children: [
                                    "Liste des Cas (",
                                    sortedCases.length,
                                    ")"
                                ]
                            }),
                            isLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "loading-indicator",
                                children: "Chargement des cas..."
                            }) : sortedCases.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "empty-list-message",
                                children: "Aucun cas trouv\xe9"
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "admin-table-container",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("table", {
                                    className: "admin-table",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("thead", {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                                        children: "Entreprise"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                                        children: "Secteur"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                                        children: "Taille"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                                        children: "Date"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                                        children: "Statut"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                                        children: "Actions"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {
                                            children: sortedCases.map((caseItem, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                                    className: selectedCase && selectedCase._id === caseItem._id ? 'selected-row' : '',
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                            children: caseItem.company_name || "Non sp\xe9cifi\xe9"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                            children: caseItem.activity_sector || "Non sp\xe9cifi\xe9"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                            children: caseItem.company_size || 'N/A'
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                            children: formatDate(caseItem.timestamp || caseItem.date_created)
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: `status-badge ${getCaseStatus(caseItem).toLowerCase().replace(/\s+/g, '-')}`,
                                                                children: getCaseStatus(caseItem)
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("td", {
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                                    className: "admin-btn admin-btn-primary",
                                                                    onClick: ()=>handleCaseSelect(caseItem),
                                                                    children: "D\xe9tails"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                                    className: "admin-btn admin-btn-warning",
                                                                    onClick: ()=>handleRefreshScores(caseItem._id),
                                                                    disabled: isLoading,
                                                                    children: "Recalculer scores"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }, index))
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    selectedCase && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "case-details-panel",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                children: "D\xe9tails du Cas"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "case-details-header",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                        children: selectedCase.company_name || 'Entreprise sans nom'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: `status-badge ${getCaseStatus(selectedCase).toLowerCase().replace(/\s+/g, '-')}`,
                                        children: getCaseStatus(selectedCase)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "case-details-content",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "case-details-field",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "case-details-label",
                                                children: "ID:"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "case-details-value",
                                                children: selectedCase._id
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "case-details-field",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "case-details-label",
                                                children: "Secteur:"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "case-details-value",
                                                children: selectedCase.activity_sector || "Non sp\xe9cifi\xe9"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "case-details-field",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "case-details-label",
                                                children: "Taille:"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                className: "case-details-value",
                                                children: [
                                                    selectedCase.company_size || "Non sp\xe9cifi\xe9",
                                                    " employ\xe9s"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "case-details-field",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "case-details-label",
                                                children: "Date de cr\xe9ation:"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "case-details-value",
                                                children: formatDate(selectedCase.date_created || selectedCase.timestamp)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "case-details-field",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "case-details-label",
                                                children: "Utilisateur:"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "case-details-value",
                                                children: selectedCase.userId || "Non assign\xe9"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "case-scores-section",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                        children: "Scores par cat\xe9gorie"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "scores-grid",
                                        children: [
                                            'environmental',
                                            'social',
                                            'modernization',
                                            'leadTime',
                                            'cost',
                                            'quality',
                                            'clientConsumer'
                                        ].map((category, idx)=>{
                                            const categoryNames = {
                                                'environmental': 'Environnement',
                                                'social': 'Social',
                                                'modernization': 'Modernisation',
                                                'leadTime': "D\xe9lai",
                                                'cost': "Co\xe0\xbbt",
                                                'quality': "Qualit\xe9",
                                                'clientConsumer': 'Client/Consommateur'
                                            };
                                            const score = selectedCase[category]?.Total || 0;
                                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "score-card",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h5", {
                                                        children: categoryNames[category]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "score-value",
                                                        children: score
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "score-bar-container",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "score-bar",
                                                            style: {
                                                                width: `${Math.min(100, score)}%`
                                                            }
                                                        })
                                                    })
                                                ]
                                            }, idx);
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "case-actions",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        className: "admin-btn admin-btn-success",
                                        onClick: ()=>window.open(`/case-details/${selectedCase._id}`, '_blank'),
                                        children: "Voir page compl\xe8te"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        className: "admin-btn admin-btn-warning",
                                        onClick: ()=>handleRefreshScores(selectedCase._id),
                                        disabled: isLoading,
                                        children: "Recalculer les scores"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
exports.default = CaseManagement;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","axios":"kL5AO","./AdminAdvanced.css":"brEL2","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"brEL2":[function() {},{}],"13Jpt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
var _adminAdvancedCss = require("./AdminAdvanced.css");
function CasePerformance() {
    const [performanceData, setPerformanceData] = (0, _react.useState)({
        categoriesOverTime: [],
        completionRates: [],
        topSectors: [],
        scoreDistribution: {},
        monthlyActivity: []
    });
    const [isLoading, setIsLoading] = (0, _react.useState)(true);
    const [error, setError] = (0, _react.useState)('');
    const [timeframe, setTimeframe] = (0, _react.useState)('6m'); // 1m, 3m, 6m, 1y, all
    (0, _react.useEffect)(()=>{
        fetchPerformanceData();
    }, [
        timeframe
    ]);
    const fetchPerformanceData = async ()=>{
        setIsLoading(true);
        try {
            // Utiliser le nouvel endpoint
            const response = await (0, _axiosDefault.default).get(`${"/api"}/api/case-performance`);
            const data = response.data;
            setPerformanceData(data);
            setError(null);
        } catch (err) {
            console.error("Erreur lors de la r\xe9cup\xe9ration des donn\xe9es de performance:", err);
            setError("Impossible de charger les donn\xe9es de performance. Utilisation des donn\xe9es de d\xe9monstration.");
            // Utiliser des données de démonstration en cas d'erreur
            setPerformanceData({
                categoriesOverTime: [
                    {
                        category: "environmental",
                        data: [
                            {
                                month: "Jan",
                                value: 5.2
                            },
                            {
                                month: "F\xe9v",
                                value: 5.7
                            },
                            {
                                month: "Mar",
                                value: 6.1
                            },
                            {
                                month: "Avr",
                                value: 6.3
                            },
                            {
                                month: "Mai",
                                value: 6.5
                            },
                            {
                                month: "Juin",
                                value: 6.8
                            }
                        ]
                    },
                    {
                        category: "social",
                        data: [
                            {
                                month: "Jan",
                                value: 4.1
                            },
                            {
                                month: "F\xe9v",
                                value: 4.2
                            },
                            {
                                month: "Mar",
                                value: 4.5
                            },
                            {
                                month: "Avr",
                                value: 4.8
                            },
                            {
                                month: "Mai",
                                value: 5.2
                            },
                            {
                                month: "Juin",
                                value: 5.5
                            }
                        ]
                    },
                    {
                        category: "modernization",
                        data: [
                            {
                                month: "Jan",
                                value: 6.7
                            },
                            {
                                month: "F\xe9v",
                                value: 7.1
                            },
                            {
                                month: "Mar",
                                value: 7.3
                            },
                            {
                                month: "Avr",
                                value: 7.5
                            },
                            {
                                month: "Mai",
                                value: 7.8
                            },
                            {
                                month: "Juin",
                                value: 8.0
                            }
                        ]
                    }
                ],
                completionRates: [
                    {
                        period: "Dernier mois",
                        rate: 65
                    },
                    {
                        period: "3 derniers mois",
                        rate: 72
                    },
                    {
                        period: "6 derniers mois",
                        rate: 68
                    }
                ],
                topSectors: [
                    {
                        sector: "Automobile",
                        count: 24,
                        percentage: 24
                    },
                    {
                        sector: "A\xe9rospatiale",
                        count: 18,
                        percentage: 18
                    },
                    {
                        sector: "\xe0\u2030lectronique",
                        count: 16,
                        percentage: 16
                    },
                    {
                        sector: "Chimie",
                        count: 15,
                        percentage: 15
                    },
                    {
                        sector: "Pharmaceutique",
                        count: 14,
                        percentage: 14
                    },
                    {
                        sector: "Autres",
                        count: 13,
                        percentage: 13
                    }
                ],
                scoreDistribution: {
                    high: 30,
                    medium: 50,
                    low: 20
                },
                monthlyActivity: [
                    {
                        month: "Jan",
                        newCases: 12,
                        updatedCases: 8
                    },
                    {
                        month: "F\xe9v",
                        newCases: 15,
                        updatedCases: 10
                    },
                    {
                        month: "Mar",
                        newCases: 18,
                        updatedCases: 12
                    },
                    {
                        month: "Avr",
                        newCases: 22,
                        updatedCases: 15
                    },
                    {
                        month: "Mai",
                        newCases: 19,
                        updatedCases: 14
                    },
                    {
                        month: "Juin",
                        newCases: 25,
                        updatedCases: 18
                    }
                ]
            });
        } finally{
            setIsLoading(false);
        }
    };
    // Fonction pour rendre le graphique de tendance des catégories
    const renderCategoryTrends = ()=>{
        const categoryNames = {
            'environmental': 'Environnement',
            'social': 'Social',
            'modernization': 'Modernisation',
            'leadTime': "D\xe9lai",
            'cost': "Co\xe0\xbbt",
            'quality': "Qualit\xe9",
            'clientConsumer': 'Client/Consommateur'
        };
        if (!performanceData.categoriesOverTime || performanceData.categoriesOverTime.length === 0) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "empty-chart-message",
            children: "Aucune donn\xe9e disponible"
        });
        // Vérifier si les données sont au format attendu (avec data)
        const isNewFormat = performanceData.categoriesOverTime[0] && 'data' in performanceData.categoriesOverTime[0];
        if (isNewFormat) {
            // Obtenir la liste des mois uniques de toutes les catégories
            const allMonths = new Set();
            performanceData.categoriesOverTime.forEach((category)=>{
                if (category.data) category.data.forEach((item)=>{
                    allMonths.add(item.month);
                });
            });
            const months = Array.from(allMonths);
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "trends-chart",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "chart-legend",
                        children: performanceData.categoriesOverTime.map((category, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "legend-item",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "legend-color",
                                        style: {
                                            backgroundColor: getCategoryColor(category.category)
                                        }
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "legend-label",
                                        children: categoryNames[category.category] || category.category
                                    })
                                ]
                            }, index))
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "line-chart",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "line-chart-grid",
                                children: months.map((month, monthIndex)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "grid-line"
                                    }, monthIndex))
                            }),
                            performanceData.categoriesOverTime.map((category, categoryIndex)=>{
                                if (!category.data) return null;
                                const points = category.data.map((item, i)=>{
                                    const monthIndex = months.indexOf(item.month);
                                    // Positionner les points proportionnellement
                                    const x = `${monthIndex / (months.length - 1) * 100}%`;
                                    // Normaliser la valeur entre 0 et 100%
                                    const maxValue = Math.max(...performanceData.categoriesOverTime.flatMap((c)=>c.data ? c.data.map((d)=>d.value) : []));
                                    const y = `${100 - item.value / maxValue * 80}%`; // 80% pour laisser de l'espace en haut/bas
                                    return {
                                        x,
                                        y,
                                        value: item.value,
                                        month: item.month
                                    };
                                });
                                // Construire le chemin de la ligne
                                const pathData = points.map((point, i)=>`${i === 0 ? 'M' : 'L'} ${point.x} ${point.y}`).join(' ');
                                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                            className: "line-chart-paths",
                                            viewBox: "0 0 100 100",
                                            preserveAspectRatio: "none",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: pathData,
                                                fill: "none",
                                                stroke: getCategoryColor(category.category),
                                                strokeWidth: "2"
                                            })
                                        }),
                                        points.map((point, pointIndex)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "data-point",
                                                style: {
                                                    left: point.x,
                                                    top: point.y,
                                                    backgroundColor: getCategoryColor(category.category)
                                                },
                                                title: `${categoryNames[category.category] || category.category}: ${point.value} (${point.month})`
                                            }, pointIndex))
                                    ]
                                }, categoryIndex);
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "chart-axis x-axis",
                                children: months.map((month, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "axis-label",
                                        style: {
                                            left: `${index / (months.length - 1) * 100}%`
                                        },
                                        children: month
                                    }, index))
                            })
                        ]
                    })
                ]
            });
        } else {
            // Format ancien (comme dans les données de démonstration)
            const months = performanceData.categoriesOverTime.map((item)=>item.month);
            const categories = Object.keys(performanceData.categoriesOverTime[0]).filter((key)=>key !== 'month');
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "trends-chart",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "chart-legend",
                        children: categories.map((category, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "legend-item",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "legend-color",
                                        style: {
                                            backgroundColor: getCategoryColor(category)
                                        }
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "legend-label",
                                        children: categoryNames[category] || category
                                    })
                                ]
                            }, index))
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "line-chart",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "line-chart-grid",
                                children: months.map((month, monthIndex)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "grid-line"
                                    }, monthIndex))
                            }),
                            categories.map((category, categoryIndex)=>{
                                const points = performanceData.categoriesOverTime.map((item, i)=>{
                                    // Positionner les points proportionnellement
                                    const x = `${i / (performanceData.categoriesOverTime.length - 1) * 100}%`;
                                    // Normaliser la valeur entre 0 et 100%
                                    const maxValue = Math.max(...performanceData.categoriesOverTime.flatMap((item)=>categories.map((cat)=>item[cat])));
                                    const y = `${100 - item[category] / maxValue * 80}%`; // 80% pour laisser de l'espace en haut/bas
                                    return {
                                        x,
                                        y,
                                        value: item[category],
                                        month: item.month
                                    };
                                });
                                // Construire le chemin de la ligne
                                const pathData = points.map((point, i)=>`${i === 0 ? 'M' : 'L'} ${point.x} ${point.y}`).join(' ');
                                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                            className: "line-chart-paths",
                                            viewBox: "0 0 100 100",
                                            preserveAspectRatio: "none",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: pathData,
                                                fill: "none",
                                                stroke: getCategoryColor(category),
                                                strokeWidth: "2"
                                            })
                                        }),
                                        points.map((point, pointIndex)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "data-point",
                                                style: {
                                                    left: point.x,
                                                    top: point.y,
                                                    backgroundColor: getCategoryColor(category)
                                                },
                                                title: `${categoryNames[category] || category}: ${point.value} (${point.month})`
                                            }, pointIndex))
                                    ]
                                }, categoryIndex);
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "chart-axis x-axis",
                                children: months.map((month, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "axis-label",
                                        style: {
                                            left: `${index / (months.length - 1) * 100}%`
                                        },
                                        children: month
                                    }, index))
                            })
                        ]
                    })
                ]
            });
        }
    };
    // Fonction pour obtenir une couleur par catégorie
    const getCategoryColor = (category)=>{
        const colors = {
            'environmental': '#4CAF50',
            'social': '#2196F3',
            'modernization': '#9C27B0',
            'leadTime': '#FF9800',
            'cost': '#F44336',
            'quality': '#00BCD4',
            'clientConsumer': '#795548'
        };
        return colors[category] || '#888888';
    };
    // Fonction pour rendre les taux de complétion
    const renderCompletionRates = ()=>{
        if (!performanceData.completionRates) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "empty-chart-message",
            children: "Aucune donn\xe9e disponible"
        });
        // Vérifier si completionRates est un tableau ou un objet
        const isArray = Array.isArray(performanceData.completionRates);
        if (isArray) {
            // Format sous forme de tableau (comme dans les données mises à  jour)
            if (performanceData.completionRates.length === 0) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "empty-chart-message",
                children: "Aucune donn\xe9e disponible"
            });
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "completion-rates",
                children: performanceData.completionRates.map((item, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "completion-rate-item",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "rate-label",
                                children: item.period
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "rate-bar-container",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "rate-bar",
                                        style: {
                                            width: `${item.rate}%`
                                        }
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                        className: "rate-value",
                                        children: [
                                            item.rate,
                                            "%"
                                        ]
                                    })
                                ]
                            })
                        ]
                    }, index))
            });
        } else {
            // Format sous forme d'objet (comme dans les anciennes données)
            const { total, completed, rate } = performanceData.completionRates;
            if (!total && !completed && !rate) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "empty-chart-message",
                children: "Aucune donn\xe9e disponible"
            });
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "completion-rates",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "completion-rate-item",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "rate-label",
                                children: "Taux global"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "rate-bar-container",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "rate-bar",
                                        style: {
                                            width: `${rate}%`
                                        }
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                        className: "rate-value",
                                        children: [
                                            rate,
                                            "%"
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "completion-stats",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            children: [
                                "Cas compl\xe9t\xe9s: ",
                                completed,
                                " sur ",
                                total
                            ]
                        })
                    })
                ]
            });
        }
    };
    // Fonction pour rendre les meilleurs secteurs
    const renderTopSectors = ()=>{
        if (!performanceData.topSectors || performanceData.topSectors.length === 0) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "empty-chart-message",
            children: "Aucune donn\xe9e disponible"
        });
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "top-sectors",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("table", {
                className: "admin-table",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("thead", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                    children: "Secteur"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                    children: "Nombre de cas"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                    children: "Score moyen"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {
                        children: performanceData.topSectors.map((item, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                        children: item.sector
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                        children: item.count
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "score-bar-mini-container",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "score-bar-mini",
                                                    style: {
                                                        width: `${item.percentage}%`
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                    children: [
                                                        item.percentage,
                                                        "%"
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }, index))
                    })
                ]
            })
        });
    };
    // Fonction pour rendre la distribution des scores
    const renderScoreDistribution = ()=>{
        if (!performanceData.scoreDistribution) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "empty-chart-message",
            children: "Aucune donn\xe9e disponible"
        });
        // Vérifier si les données sont au nouveau format (objet avec high, medium, low)
        const isNewFormat = 'high' in performanceData.scoreDistribution && 'medium' in performanceData.scoreDistribution && 'low' in performanceData.scoreDistribution;
        if (isNewFormat) {
            const { high, medium, low } = performanceData.scoreDistribution;
            const total = high + medium + low;
            if (total === 0) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "empty-chart-message",
                children: "Aucune donn\xe9e disponible"
            });
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "score-distribution",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "donut-chart-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "donut-chart",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                viewBox: "0 0 42 42",
                                className: "donut",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                        className: "donut-hole",
                                        cx: "21",
                                        cy: "21",
                                        r: "15.91549430918954",
                                        fill: "#fff"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                        className: "donut-ring",
                                        cx: "21",
                                        cy: "21",
                                        r: "15.91549430918954",
                                        fill: "transparent",
                                        stroke: "#d2d3d4",
                                        strokeWidth: "3"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                        className: "donut-segment donut-segment-high",
                                        cx: "21",
                                        cy: "21",
                                        r: "15.91549430918954",
                                        fill: "transparent",
                                        stroke: "#4CAF50",
                                        strokeWidth: "3",
                                        strokeDasharray: `${high / total * 100} ${100 - high / total * 100}`,
                                        strokeDashoffset: "25"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                        className: "donut-segment donut-segment-medium",
                                        cx: "21",
                                        cy: "21",
                                        r: "15.91549430918954",
                                        fill: "transparent",
                                        stroke: "#FFC107",
                                        strokeWidth: "3",
                                        strokeDasharray: `${medium / total * 100} ${100 - medium / total * 100}`,
                                        strokeDashoffset: `${25 - high / total * 100}`
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                        className: "donut-segment donut-segment-low",
                                        cx: "21",
                                        cy: "21",
                                        r: "15.91549430918954",
                                        fill: "transparent",
                                        stroke: "#F44336",
                                        strokeWidth: "3",
                                        strokeDasharray: `${low / total * 100} ${100 - low / total * 100}`,
                                        strokeDashoffset: `${25 - (high + medium) / total * 100}`
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "donut-chart-legend",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "legend-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "legend-color",
                                            style: {
                                                backgroundColor: '#4CAF50'
                                            }
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "legend-label",
                                            children: "Score \xe9lev\xe9"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "legend-value",
                                            children: [
                                                high,
                                                " (",
                                                Math.round(high / total * 100),
                                                "%)"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "legend-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "legend-color",
                                            style: {
                                                backgroundColor: '#FFC107'
                                            }
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "legend-label",
                                            children: "Score moyen"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "legend-value",
                                            children: [
                                                medium,
                                                " (",
                                                Math.round(medium / total * 100),
                                                "%)"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "legend-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "legend-color",
                                            style: {
                                                backgroundColor: '#F44336'
                                            }
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "legend-label",
                                            children: "Score faible"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "legend-value",
                                            children: [
                                                low,
                                                " (",
                                                Math.round(low / total * 100),
                                                "%)"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            });
        } else {
            // Format ancien (tableau de {score, count})
            if (!Array.isArray(performanceData.scoreDistribution) || performanceData.scoreDistribution.length === 0) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "empty-chart-message",
                children: "Aucune donn\xe9e disponible"
            });
            // Calculer les totaux par catégorie
            const totalCount = performanceData.scoreDistribution.reduce((sum, item)=>sum + item.count, 0);
            const highScores = performanceData.scoreDistribution.filter((item)=>item.score >= 8).reduce((sum, item)=>sum + item.count, 0);
            const mediumScores = performanceData.scoreDistribution.filter((item)=>item.score >= 4 && item.score < 8).reduce((sum, item)=>sum + item.count, 0);
            const lowScores = performanceData.scoreDistribution.filter((item)=>item.score < 4).reduce((sum, item)=>sum + item.count, 0);
            if (totalCount === 0) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "empty-chart-message",
                children: "Aucune donn\xe9e disponible"
            });
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "score-distribution",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "donut-chart-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "donut-chart",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                viewBox: "0 0 42 42",
                                className: "donut",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                        className: "donut-hole",
                                        cx: "21",
                                        cy: "21",
                                        r: "15.91549430918954",
                                        fill: "#fff"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                        className: "donut-ring",
                                        cx: "21",
                                        cy: "21",
                                        r: "15.91549430918954",
                                        fill: "transparent",
                                        stroke: "#d2d3d4",
                                        strokeWidth: "3"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                        className: "donut-segment donut-segment-high",
                                        cx: "21",
                                        cy: "21",
                                        r: "15.91549430918954",
                                        fill: "transparent",
                                        stroke: "#4CAF50",
                                        strokeWidth: "3",
                                        strokeDasharray: `${highScores / totalCount * 100} ${100 - highScores / totalCount * 100}`,
                                        strokeDashoffset: "25"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                        className: "donut-segment donut-segment-medium",
                                        cx: "21",
                                        cy: "21",
                                        r: "15.91549430918954",
                                        fill: "transparent",
                                        stroke: "#FFC107",
                                        strokeWidth: "3",
                                        strokeDasharray: `${mediumScores / totalCount * 100} ${100 - mediumScores / totalCount * 100}`,
                                        strokeDashoffset: `${25 - highScores / totalCount * 100}`
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                        className: "donut-segment donut-segment-low",
                                        cx: "21",
                                        cy: "21",
                                        r: "15.91549430918954",
                                        fill: "transparent",
                                        stroke: "#F44336",
                                        strokeWidth: "3",
                                        strokeDasharray: `${lowScores / totalCount * 100} ${100 - lowScores / totalCount * 100}`,
                                        strokeDashoffset: `${25 - (highScores + mediumScores) / totalCount * 100}`
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "donut-chart-legend",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "legend-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "legend-color",
                                            style: {
                                                backgroundColor: '#4CAF50'
                                            }
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "legend-label",
                                            children: "Score \xe9lev\xe9 (8-10)"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "legend-value",
                                            children: [
                                                highScores,
                                                " (",
                                                Math.round(highScores / totalCount * 100),
                                                "%)"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "legend-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "legend-color",
                                            style: {
                                                backgroundColor: '#FFC107'
                                            }
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "legend-label",
                                            children: "Score moyen (4-7)"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "legend-value",
                                            children: [
                                                mediumScores,
                                                " (",
                                                Math.round(mediumScores / totalCount * 100),
                                                "%)"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "legend-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "legend-color",
                                            style: {
                                                backgroundColor: '#F44336'
                                            }
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "legend-label",
                                            children: "Score faible (1-3)"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "legend-value",
                                            children: [
                                                lowScores,
                                                " (",
                                                Math.round(lowScores / totalCount * 100),
                                                "%)"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            });
        }
    };
    // Fonction pour rendre l'activité mensuelle
    const renderMonthlyActivity = ()=>{
        if (!performanceData.monthlyActivity) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "empty-chart-message",
            children: "Aucune donn\xe9e disponible"
        });
        // Vérifier si les données sont au format attendu
        const hasNewAndUpdatedCases = performanceData.monthlyActivity.length > 0 && 'newCases' in performanceData.monthlyActivity[0] && 'updatedCases' in performanceData.monthlyActivity[0];
        if (hasNewAndUpdatedCases) {
            // Format avec newCases et updatedCases
            if (performanceData.monthlyActivity.length === 0) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "empty-chart-message",
                children: "Aucune donn\xe9e disponible"
            });
            // Trouver la valeur maximale pour dimensionner correctement les barres
            const maxValue = Math.max(...performanceData.monthlyActivity.flatMap((item)=>[
                    item.newCases,
                    item.updatedCases
                ]));
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "monthly-activity",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "chart-legend",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "legend-item",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "legend-color",
                                        style: {
                                            backgroundColor: '#4CAF50'
                                        }
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "legend-label",
                                        children: "Nouveaux cas"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "legend-item",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "legend-color",
                                        style: {
                                            backgroundColor: '#2196F3'
                                        }
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "legend-label",
                                        children: "Cas mis \xe0\xa0 jour"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "bar-chart-grouped",
                        children: performanceData.monthlyActivity.map((item, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "bar-chart-group",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "bar-chart-label",
                                        children: item.month
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "bar-chart-bars",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "bar-chart-bar-container",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "bar-chart-bar bar-new",
                                                    style: {
                                                        height: `${item.newCases / maxValue * 100}%`,
                                                        minHeight: item.newCases > 0 ? '4px' : '0'
                                                    },
                                                    title: `${item.newCases} nouveaux cas`
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "bar-chart-bar-container",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "bar-chart-bar bar-updated",
                                                    style: {
                                                        height: `${item.updatedCases / maxValue * 100}%`,
                                                        minHeight: item.updatedCases > 0 ? '4px' : '0'
                                                    },
                                                    title: `${item.updatedCases} cas mis \xe0\xa0 jour`
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "bar-chart-values",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "bar-value",
                                                children: item.newCases
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "bar-value",
                                                children: item.updatedCases
                                            })
                                        ]
                                    })
                                ]
                            }, index))
                    })
                ]
            });
        } else {
            // Format ancien (avec month et count)
            if (performanceData.monthlyActivity.length === 0) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "empty-chart-message",
                children: "Aucune donn\xe9e disponible"
            });
            // Trouver la valeur maximale pour dimensionner correctement les barres
            const maxValue = Math.max(...performanceData.monthlyActivity.map((item)=>item.count));
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "monthly-activity",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "bar-chart-simple",
                    children: performanceData.monthlyActivity.map((item, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "bar-chart-item",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "bar-chart-label",
                                    children: typeof item.month === 'number' ? `Mois ${item.month}` : item.month
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "bar-chart-bar-container",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "bar-chart-bar",
                                        style: {
                                            height: `${item.count / maxValue * 100}%`,
                                            minHeight: item.count > 0 ? '4px' : '0'
                                        },
                                        title: `${item.count} cas`
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "bar-value",
                                    children: item.count
                                })
                            ]
                        }, index))
                })
            });
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "case-performance-container",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "performance-header",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                        children: "Performance des Cas"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "timeframe-selector",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                children: "P\xe9riode:"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("select", {
                                value: timeframe,
                                onChange: (e)=>setTimeframe(e.target.value),
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                        value: "1m",
                                        children: "1 mois"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                        value: "3m",
                                        children: "3 mois"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                        value: "6m",
                                        children: "6 mois"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                        value: "1y",
                                        children: "1 an"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                        value: "all",
                                        children: "Tout"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            error && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "admin-error",
                children: error
            }),
            isLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "loading-indicator",
                children: "Chargement des donn\xe9es de performance..."
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "performance-content",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "performance-card wide-card",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                children: "\xe0\u2030volution des scores par cat\xe9gorie"
                            }),
                            renderCategoryTrends()
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "performance-row",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "performance-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        children: "Taux de compl\xe9tion"
                                    }),
                                    renderCompletionRates()
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "performance-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        children: "Distribution des scores"
                                    }),
                                    renderScoreDistribution()
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "performance-row",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "performance-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        children: "Top secteurs d'activit\xe9"
                                    }),
                                    renderTopSectors()
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "performance-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        children: "Activit\xe9 mensuelle"
                                    }),
                                    renderMonthlyActivity()
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
exports.default = CasePerformance;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","axios":"kL5AO","./AdminAdvanced.css":"brEL2","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"brEL2":[function() {},{}],"by1A5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Bar", ()=>Bar);
parcelHelpers.export(exports, "Bubble", ()=>Bubble);
parcelHelpers.export(exports, "Chart", ()=>Chart);
parcelHelpers.export(exports, "Doughnut", ()=>Doughnut);
parcelHelpers.export(exports, "Line", ()=>Line);
parcelHelpers.export(exports, "Pie", ()=>Pie);
parcelHelpers.export(exports, "PolarArea", ()=>PolarArea);
parcelHelpers.export(exports, "Radar", ()=>Radar);
parcelHelpers.export(exports, "Scatter", ()=>Scatter);
parcelHelpers.export(exports, "getDatasetAtEvent", ()=>getDatasetAtEvent);
parcelHelpers.export(exports, "getElementAtEvent", ()=>getElementAtEvent);
parcelHelpers.export(exports, "getElementsAtEvent", ()=>getElementsAtEvent);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _chartJs = require("chart.js");
const defaultDatasetIdKey = 'label';
function reforwardRef(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}
function setOptions(chart, nextOptions) {
    const options = chart.options;
    if (options && nextOptions) Object.assign(options, nextOptions);
}
function setLabels(currentData, nextLabels) {
    currentData.labels = nextLabels;
}
function setDatasets(currentData, nextDatasets) {
    let datasetIdKey = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : defaultDatasetIdKey;
    const addedDatasets = [];
    currentData.datasets = nextDatasets.map((nextDataset)=>{
        // given the new set, find it's current match
        const currentDataset = currentData.datasets.find((dataset)=>dataset[datasetIdKey] === nextDataset[datasetIdKey]);
        // There is no original to update, so simply add new one
        if (!currentDataset || !nextDataset.data || addedDatasets.includes(currentDataset)) return {
            ...nextDataset
        };
        addedDatasets.push(currentDataset);
        Object.assign(currentDataset, nextDataset);
        return currentDataset;
    });
}
function cloneData(data) {
    let datasetIdKey = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultDatasetIdKey;
    const nextData = {
        labels: [],
        datasets: []
    };
    setLabels(nextData, data.labels);
    setDatasets(nextData, data.datasets, datasetIdKey);
    return nextData;
}
/**
 * Get dataset from mouse click event
 * @param chart - Chart.js instance
 * @param event - Mouse click event
 * @returns Dataset
 */ function getDatasetAtEvent(chart, event) {
    return chart.getElementsAtEventForMode(event.nativeEvent, 'dataset', {
        intersect: true
    }, false);
}
/**
 * Get single dataset element from mouse click event
 * @param chart - Chart.js instance
 * @param event - Mouse click event
 * @returns Dataset
 */ function getElementAtEvent(chart, event) {
    return chart.getElementsAtEventForMode(event.nativeEvent, 'nearest', {
        intersect: true
    }, false);
}
/**
 * Get all dataset elements from mouse click event
 * @param chart - Chart.js instance
 * @param event - Mouse click event
 * @returns Dataset
 */ function getElementsAtEvent(chart, event) {
    return chart.getElementsAtEventForMode(event.nativeEvent, 'index', {
        intersect: true
    }, false);
}
function ChartComponent(props, ref) {
    const { height = 150, width = 300, redraw = false, datasetIdKey, type, data, options, plugins = [], fallbackContent, updateMode, ...canvasProps } = props;
    const canvasRef = (0, _react.useRef)(null);
    const chartRef = (0, _react.useRef)(null);
    const renderChart = ()=>{
        if (!canvasRef.current) return;
        chartRef.current = new (0, _chartJs.Chart)(canvasRef.current, {
            type,
            data: cloneData(data, datasetIdKey),
            options: options && {
                ...options
            },
            plugins
        });
        reforwardRef(ref, chartRef.current);
    };
    const destroyChart = ()=>{
        reforwardRef(ref, null);
        if (chartRef.current) {
            chartRef.current.destroy();
            chartRef.current = null;
        }
    };
    (0, _react.useEffect)(()=>{
        if (!redraw && chartRef.current && options) setOptions(chartRef.current, options);
    }, [
        redraw,
        options
    ]);
    (0, _react.useEffect)(()=>{
        if (!redraw && chartRef.current) setLabels(chartRef.current.config.data, data.labels);
    }, [
        redraw,
        data.labels
    ]);
    (0, _react.useEffect)(()=>{
        if (!redraw && chartRef.current && data.datasets) setDatasets(chartRef.current.config.data, data.datasets, datasetIdKey);
    }, [
        redraw,
        data.datasets
    ]);
    (0, _react.useEffect)(()=>{
        if (!chartRef.current) return;
        if (redraw) {
            destroyChart();
            setTimeout(renderChart);
        } else chartRef.current.update(updateMode);
    }, [
        redraw,
        options,
        data.labels,
        data.datasets,
        updateMode
    ]);
    (0, _react.useEffect)(()=>{
        if (!chartRef.current) return;
        destroyChart();
        setTimeout(renderChart);
    }, [
        type
    ]);
    (0, _react.useEffect)(()=>{
        renderChart();
        return ()=>destroyChart();
    }, []);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("canvas", {
        ref: canvasRef,
        role: "img",
        height: height,
        width: width,
        ...canvasProps
    }, fallbackContent);
}
const Chart = /*#__PURE__*/ (0, _react.forwardRef)(ChartComponent);
function createTypedChart(type, registerables) {
    (0, _chartJs.Chart).register(registerables);
    return /*#__PURE__*/ (0, _react.forwardRef)((props, ref)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(Chart, {
            ...props,
            ref: ref,
            type: type
        }));
}
const Line = /* #__PURE__ */ createTypedChart('line', (0, _chartJs.LineController));
const Bar = /* #__PURE__ */ createTypedChart('bar', (0, _chartJs.BarController));
const Radar = /* #__PURE__ */ createTypedChart('radar', (0, _chartJs.RadarController));
const Doughnut = /* #__PURE__ */ createTypedChart('doughnut', (0, _chartJs.DoughnutController));
const PolarArea = /* #__PURE__ */ createTypedChart('polarArea', (0, _chartJs.PolarAreaController));
const Bubble = /* #__PURE__ */ createTypedChart('bubble', (0, _chartJs.BubbleController));
const Pie = /* #__PURE__ */ createTypedChart('pie', (0, _chartJs.PieController));
const Scatter = /* #__PURE__ */ createTypedChart('scatter', (0, _chartJs.ScatterController));

},{"react":"bmhQu","chart.js":"epfF8","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"epfF8":[function(require,module,exports,__globalThis) {
/*!
 * Chart.js v4.4.9
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Animation", ()=>Animation);
parcelHelpers.export(exports, "Animations", ()=>Animations);
parcelHelpers.export(exports, "ArcElement", ()=>ArcElement);
parcelHelpers.export(exports, "BarController", ()=>BarController);
parcelHelpers.export(exports, "BarElement", ()=>BarElement);
parcelHelpers.export(exports, "BasePlatform", ()=>BasePlatform);
parcelHelpers.export(exports, "BasicPlatform", ()=>BasicPlatform);
parcelHelpers.export(exports, "BubbleController", ()=>BubbleController);
parcelHelpers.export(exports, "CategoryScale", ()=>CategoryScale);
parcelHelpers.export(exports, "Chart", ()=>Chart);
parcelHelpers.export(exports, "Colors", ()=>plugin_colors);
parcelHelpers.export(exports, "DatasetController", ()=>DatasetController);
parcelHelpers.export(exports, "Decimation", ()=>plugin_decimation);
parcelHelpers.export(exports, "DomPlatform", ()=>DomPlatform);
parcelHelpers.export(exports, "DoughnutController", ()=>DoughnutController);
parcelHelpers.export(exports, "Element", ()=>Element);
parcelHelpers.export(exports, "Filler", ()=>index);
parcelHelpers.export(exports, "Interaction", ()=>Interaction);
parcelHelpers.export(exports, "Legend", ()=>plugin_legend);
parcelHelpers.export(exports, "LineController", ()=>LineController);
parcelHelpers.export(exports, "LineElement", ()=>LineElement);
parcelHelpers.export(exports, "LinearScale", ()=>LinearScale);
parcelHelpers.export(exports, "LogarithmicScale", ()=>LogarithmicScale);
parcelHelpers.export(exports, "PieController", ()=>PieController);
parcelHelpers.export(exports, "PointElement", ()=>PointElement);
parcelHelpers.export(exports, "PolarAreaController", ()=>PolarAreaController);
parcelHelpers.export(exports, "RadarController", ()=>RadarController);
parcelHelpers.export(exports, "RadialLinearScale", ()=>RadialLinearScale);
parcelHelpers.export(exports, "Scale", ()=>Scale);
parcelHelpers.export(exports, "ScatterController", ()=>ScatterController);
parcelHelpers.export(exports, "SubTitle", ()=>plugin_subtitle);
parcelHelpers.export(exports, "Ticks", ()=>(0, _helpersDatasetJs.aM));
parcelHelpers.export(exports, "TimeScale", ()=>TimeScale);
parcelHelpers.export(exports, "TimeSeriesScale", ()=>TimeSeriesScale);
parcelHelpers.export(exports, "Title", ()=>plugin_title);
parcelHelpers.export(exports, "Tooltip", ()=>plugin_tooltip);
parcelHelpers.export(exports, "_adapters", ()=>adapters);
parcelHelpers.export(exports, "_detectPlatform", ()=>_detectPlatform);
parcelHelpers.export(exports, "animator", ()=>animator);
parcelHelpers.export(exports, "controllers", ()=>controllers);
parcelHelpers.export(exports, "defaults", ()=>(0, _helpersDatasetJs.d));
parcelHelpers.export(exports, "elements", ()=>elements);
parcelHelpers.export(exports, "layouts", ()=>layouts);
parcelHelpers.export(exports, "plugins", ()=>plugins);
parcelHelpers.export(exports, "registerables", ()=>registerables);
parcelHelpers.export(exports, "registry", ()=>registry);
parcelHelpers.export(exports, "scales", ()=>scales);
var _helpersDatasetJs = require("./chunks/helpers.dataset.js");
var _color = require("@kurkle/color");
class Animator {
    constructor(){
        this._request = null;
        this._charts = new Map();
        this._running = false;
        this._lastDate = undefined;
    }
    _notify(chart, anims, date, type) {
        const callbacks = anims.listeners[type];
        const numSteps = anims.duration;
        callbacks.forEach((fn)=>fn({
                chart,
                initial: anims.initial,
                numSteps,
                currentStep: Math.min(date - anims.start, numSteps)
            }));
    }
    _refresh() {
        if (this._request) return;
        this._running = true;
        this._request = (0, _helpersDatasetJs.r).call(window, ()=>{
            this._update();
            this._request = null;
            if (this._running) this._refresh();
        });
    }
    _update(date = Date.now()) {
        let remaining = 0;
        this._charts.forEach((anims, chart)=>{
            if (!anims.running || !anims.items.length) return;
            const items = anims.items;
            let i = items.length - 1;
            let draw = false;
            let item;
            for(; i >= 0; --i){
                item = items[i];
                if (item._active) {
                    if (item._total > anims.duration) anims.duration = item._total;
                    item.tick(date);
                    draw = true;
                } else {
                    items[i] = items[items.length - 1];
                    items.pop();
                }
            }
            if (draw) {
                chart.draw();
                this._notify(chart, anims, date, 'progress');
            }
            if (!items.length) {
                anims.running = false;
                this._notify(chart, anims, date, 'complete');
                anims.initial = false;
            }
            remaining += items.length;
        });
        this._lastDate = date;
        if (remaining === 0) this._running = false;
    }
    _getAnims(chart) {
        const charts = this._charts;
        let anims = charts.get(chart);
        if (!anims) {
            anims = {
                running: false,
                initial: true,
                items: [],
                listeners: {
                    complete: [],
                    progress: []
                }
            };
            charts.set(chart, anims);
        }
        return anims;
    }
    listen(chart, event, cb) {
        this._getAnims(chart).listeners[event].push(cb);
    }
    add(chart, items) {
        if (!items || !items.length) return;
        this._getAnims(chart).items.push(...items);
    }
    has(chart) {
        return this._getAnims(chart).items.length > 0;
    }
    start(chart) {
        const anims = this._charts.get(chart);
        if (!anims) return;
        anims.running = true;
        anims.start = Date.now();
        anims.duration = anims.items.reduce((acc, cur)=>Math.max(acc, cur._duration), 0);
        this._refresh();
    }
    running(chart) {
        if (!this._running) return false;
        const anims = this._charts.get(chart);
        if (!anims || !anims.running || !anims.items.length) return false;
        return true;
    }
    stop(chart) {
        const anims = this._charts.get(chart);
        if (!anims || !anims.items.length) return;
        const items = anims.items;
        let i = items.length - 1;
        for(; i >= 0; --i)items[i].cancel();
        anims.items = [];
        this._notify(chart, anims, Date.now(), 'complete');
    }
    remove(chart) {
        return this._charts.delete(chart);
    }
}
var animator = /* #__PURE__ */ new Animator();
const transparent = 'transparent';
const interpolators = {
    boolean (from, to, factor) {
        return factor > 0.5 ? to : from;
    },
    color (from, to, factor) {
        const c0 = (0, _helpersDatasetJs.c)(from || transparent);
        const c1 = c0.valid && (0, _helpersDatasetJs.c)(to || transparent);
        return c1 && c1.valid ? c1.mix(c0, factor).hexString() : to;
    },
    number (from, to, factor) {
        return from + (to - from) * factor;
    }
};
class Animation {
    constructor(cfg, target, prop, to){
        const currentValue = target[prop];
        to = (0, _helpersDatasetJs.a)([
            cfg.to,
            to,
            currentValue,
            cfg.from
        ]);
        const from = (0, _helpersDatasetJs.a)([
            cfg.from,
            currentValue,
            to
        ]);
        this._active = true;
        this._fn = cfg.fn || interpolators[cfg.type || typeof from];
        this._easing = (0, _helpersDatasetJs.e)[cfg.easing] || (0, _helpersDatasetJs.e).linear;
        this._start = Math.floor(Date.now() + (cfg.delay || 0));
        this._duration = this._total = Math.floor(cfg.duration);
        this._loop = !!cfg.loop;
        this._target = target;
        this._prop = prop;
        this._from = from;
        this._to = to;
        this._promises = undefined;
    }
    active() {
        return this._active;
    }
    update(cfg, to, date) {
        if (this._active) {
            this._notify(false);
            const currentValue = this._target[this._prop];
            const elapsed = date - this._start;
            const remain = this._duration - elapsed;
            this._start = date;
            this._duration = Math.floor(Math.max(remain, cfg.duration));
            this._total += elapsed;
            this._loop = !!cfg.loop;
            this._to = (0, _helpersDatasetJs.a)([
                cfg.to,
                to,
                currentValue,
                cfg.from
            ]);
            this._from = (0, _helpersDatasetJs.a)([
                cfg.from,
                currentValue,
                to
            ]);
        }
    }
    cancel() {
        if (this._active) {
            this.tick(Date.now());
            this._active = false;
            this._notify(false);
        }
    }
    tick(date) {
        const elapsed = date - this._start;
        const duration = this._duration;
        const prop = this._prop;
        const from = this._from;
        const loop = this._loop;
        const to = this._to;
        let factor;
        this._active = from !== to && (loop || elapsed < duration);
        if (!this._active) {
            this._target[prop] = to;
            this._notify(true);
            return;
        }
        if (elapsed < 0) {
            this._target[prop] = from;
            return;
        }
        factor = elapsed / duration % 2;
        factor = loop && factor > 1 ? 2 - factor : factor;
        factor = this._easing(Math.min(1, Math.max(0, factor)));
        this._target[prop] = this._fn(from, to, factor);
    }
    wait() {
        const promises = this._promises || (this._promises = []);
        return new Promise((res, rej)=>{
            promises.push({
                res,
                rej
            });
        });
    }
    _notify(resolved) {
        const method = resolved ? 'res' : 'rej';
        const promises = this._promises || [];
        for(let i = 0; i < promises.length; i++)promises[i][method]();
    }
}
class Animations {
    constructor(chart, config){
        this._chart = chart;
        this._properties = new Map();
        this.configure(config);
    }
    configure(config) {
        if (!(0, _helpersDatasetJs.i)(config)) return;
        const animationOptions = Object.keys((0, _helpersDatasetJs.d).animation);
        const animatedProps = this._properties;
        Object.getOwnPropertyNames(config).forEach((key)=>{
            const cfg = config[key];
            if (!(0, _helpersDatasetJs.i)(cfg)) return;
            const resolved = {};
            for (const option of animationOptions)resolved[option] = cfg[option];
            ((0, _helpersDatasetJs.b)(cfg.properties) && cfg.properties || [
                key
            ]).forEach((prop)=>{
                if (prop === key || !animatedProps.has(prop)) animatedProps.set(prop, resolved);
            });
        });
    }
    _animateOptions(target, values) {
        const newOptions = values.options;
        const options = resolveTargetOptions(target, newOptions);
        if (!options) return [];
        const animations = this._createAnimations(options, newOptions);
        if (newOptions.$shared) awaitAll(target.options.$animations, newOptions).then(()=>{
            target.options = newOptions;
        }, ()=>{});
        return animations;
    }
    _createAnimations(target, values) {
        const animatedProps = this._properties;
        const animations = [];
        const running = target.$animations || (target.$animations = {});
        const props = Object.keys(values);
        const date = Date.now();
        let i;
        for(i = props.length - 1; i >= 0; --i){
            const prop = props[i];
            if (prop.charAt(0) === '$') continue;
            if (prop === 'options') {
                animations.push(...this._animateOptions(target, values));
                continue;
            }
            const value = values[prop];
            let animation = running[prop];
            const cfg = animatedProps.get(prop);
            if (animation) {
                if (cfg && animation.active()) {
                    animation.update(cfg, value, date);
                    continue;
                } else animation.cancel();
            }
            if (!cfg || !cfg.duration) {
                target[prop] = value;
                continue;
            }
            running[prop] = animation = new Animation(cfg, target, prop, value);
            animations.push(animation);
        }
        return animations;
    }
    update(target, values) {
        if (this._properties.size === 0) {
            Object.assign(target, values);
            return;
        }
        const animations = this._createAnimations(target, values);
        if (animations.length) {
            animator.add(this._chart, animations);
            return true;
        }
    }
}
function awaitAll(animations, properties) {
    const running = [];
    const keys = Object.keys(properties);
    for(let i = 0; i < keys.length; i++){
        const anim = animations[keys[i]];
        if (anim && anim.active()) running.push(anim.wait());
    }
    return Promise.all(running);
}
function resolveTargetOptions(target, newOptions) {
    if (!newOptions) return;
    let options = target.options;
    if (!options) {
        target.options = newOptions;
        return;
    }
    if (options.$shared) target.options = options = Object.assign({}, options, {
        $shared: false,
        $animations: {}
    });
    return options;
}
function scaleClip(scale, allowedOverflow) {
    const opts = scale && scale.options || {};
    const reverse = opts.reverse;
    const min = opts.min === undefined ? allowedOverflow : 0;
    const max = opts.max === undefined ? allowedOverflow : 0;
    return {
        start: reverse ? max : min,
        end: reverse ? min : max
    };
}
function defaultClip(xScale, yScale, allowedOverflow) {
    if (allowedOverflow === false) return false;
    const x = scaleClip(xScale, allowedOverflow);
    const y = scaleClip(yScale, allowedOverflow);
    return {
        top: y.end,
        right: x.end,
        bottom: y.start,
        left: x.start
    };
}
function toClip(value) {
    let t, r, b, l;
    if ((0, _helpersDatasetJs.i)(value)) {
        t = value.top;
        r = value.right;
        b = value.bottom;
        l = value.left;
    } else t = r = b = l = value;
    return {
        top: t,
        right: r,
        bottom: b,
        left: l,
        disabled: value === false
    };
}
function getSortedDatasetIndices(chart, filterVisible) {
    const keys = [];
    const metasets = chart._getSortedDatasetMetas(filterVisible);
    let i, ilen;
    for(i = 0, ilen = metasets.length; i < ilen; ++i)keys.push(metasets[i].index);
    return keys;
}
function applyStack(stack, value, dsIndex, options = {}) {
    const keys = stack.keys;
    const singleMode = options.mode === 'single';
    let i, ilen, datasetIndex, otherValue;
    if (value === null) return;
    let found = false;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        datasetIndex = +keys[i];
        if (datasetIndex === dsIndex) {
            found = true;
            if (options.all) continue;
            break;
        }
        otherValue = stack.values[datasetIndex];
        if ((0, _helpersDatasetJs.g)(otherValue) && (singleMode || value === 0 || (0, _helpersDatasetJs.s)(value) === (0, _helpersDatasetJs.s)(otherValue))) value += otherValue;
    }
    if (!found && !options.all) return 0;
    return value;
}
function convertObjectDataToArray(data, meta) {
    const { iScale, vScale } = meta;
    const iAxisKey = iScale.axis === 'x' ? 'x' : 'y';
    const vAxisKey = vScale.axis === 'x' ? 'x' : 'y';
    const keys = Object.keys(data);
    const adata = new Array(keys.length);
    let i, ilen, key;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        key = keys[i];
        adata[i] = {
            [iAxisKey]: key,
            [vAxisKey]: data[key]
        };
    }
    return adata;
}
function isStacked(scale, meta) {
    const stacked = scale && scale.options.stacked;
    return stacked || stacked === undefined && meta.stack !== undefined;
}
function getStackKey(indexScale, valueScale, meta) {
    return `${indexScale.id}.${valueScale.id}.${meta.stack || meta.type}`;
}
function getUserBounds(scale) {
    const { min, max, minDefined, maxDefined } = scale.getUserBounds();
    return {
        min: minDefined ? min : Number.NEGATIVE_INFINITY,
        max: maxDefined ? max : Number.POSITIVE_INFINITY
    };
}
function getOrCreateStack(stacks, stackKey, indexValue) {
    const subStack = stacks[stackKey] || (stacks[stackKey] = {});
    return subStack[indexValue] || (subStack[indexValue] = {});
}
function getLastIndexInStack(stack, vScale, positive, type) {
    for (const meta of vScale.getMatchingVisibleMetas(type).reverse()){
        const value = stack[meta.index];
        if (positive && value > 0 || !positive && value < 0) return meta.index;
    }
    return null;
}
function updateStacks(controller, parsed) {
    const { chart, _cachedMeta: meta } = controller;
    const stacks = chart._stacks || (chart._stacks = {});
    const { iScale, vScale, index: datasetIndex } = meta;
    const iAxis = iScale.axis;
    const vAxis = vScale.axis;
    const key = getStackKey(iScale, vScale, meta);
    const ilen = parsed.length;
    let stack;
    for(let i = 0; i < ilen; ++i){
        const item = parsed[i];
        const { [iAxis]: index, [vAxis]: value } = item;
        const itemStacks = item._stacks || (item._stacks = {});
        stack = itemStacks[vAxis] = getOrCreateStack(stacks, key, index);
        stack[datasetIndex] = value;
        stack._top = getLastIndexInStack(stack, vScale, true, meta.type);
        stack._bottom = getLastIndexInStack(stack, vScale, false, meta.type);
        const visualValues = stack._visualValues || (stack._visualValues = {});
        visualValues[datasetIndex] = value;
    }
}
function getFirstScaleId(chart, axis) {
    const scales = chart.scales;
    return Object.keys(scales).filter((key)=>scales[key].axis === axis).shift();
}
function createDatasetContext(parent, index) {
    return (0, _helpersDatasetJs.j)(parent, {
        active: false,
        dataset: undefined,
        datasetIndex: index,
        index,
        mode: 'default',
        type: 'dataset'
    });
}
function createDataContext(parent, index, element) {
    return (0, _helpersDatasetJs.j)(parent, {
        active: false,
        dataIndex: index,
        parsed: undefined,
        raw: undefined,
        element,
        index,
        mode: 'default',
        type: 'data'
    });
}
function clearStacks(meta, items) {
    const datasetIndex = meta.controller.index;
    const axis = meta.vScale && meta.vScale.axis;
    if (!axis) return;
    items = items || meta._parsed;
    for (const parsed of items){
        const stacks = parsed._stacks;
        if (!stacks || stacks[axis] === undefined || stacks[axis][datasetIndex] === undefined) return;
        delete stacks[axis][datasetIndex];
        if (stacks[axis]._visualValues !== undefined && stacks[axis]._visualValues[datasetIndex] !== undefined) delete stacks[axis]._visualValues[datasetIndex];
    }
}
const isDirectUpdateMode = (mode)=>mode === 'reset' || mode === 'none';
const cloneIfNotShared = (cached, shared)=>shared ? cached : Object.assign({}, cached);
const createStack = (canStack, meta, chart)=>canStack && !meta.hidden && meta._stacked && {
        keys: getSortedDatasetIndices(chart, true),
        values: null
    };
class DatasetController {
    static defaults = {};
    static datasetElementType = null;
    static dataElementType = null;
    constructor(chart, datasetIndex){
        this.chart = chart;
        this._ctx = chart.ctx;
        this.index = datasetIndex;
        this._cachedDataOpts = {};
        this._cachedMeta = this.getMeta();
        this._type = this._cachedMeta.type;
        this.options = undefined;
        this._parsing = false;
        this._data = undefined;
        this._objectData = undefined;
        this._sharedOptions = undefined;
        this._drawStart = undefined;
        this._drawCount = undefined;
        this.enableOptionSharing = false;
        this.supportsDecimation = false;
        this.$context = undefined;
        this._syncList = [];
        this.datasetElementType = new.target.datasetElementType;
        this.dataElementType = new.target.dataElementType;
        this.initialize();
    }
    initialize() {
        const meta = this._cachedMeta;
        this.configure();
        this.linkScales();
        meta._stacked = isStacked(meta.vScale, meta);
        this.addElements();
        if (this.options.fill && !this.chart.isPluginEnabled('filler')) console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
    }
    updateIndex(datasetIndex) {
        if (this.index !== datasetIndex) clearStacks(this._cachedMeta);
        this.index = datasetIndex;
    }
    linkScales() {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        const chooseId = (axis, x, y, r)=>axis === 'x' ? x : axis === 'r' ? r : y;
        const xid = meta.xAxisID = (0, _helpersDatasetJs.v)(dataset.xAxisID, getFirstScaleId(chart, 'x'));
        const yid = meta.yAxisID = (0, _helpersDatasetJs.v)(dataset.yAxisID, getFirstScaleId(chart, 'y'));
        const rid = meta.rAxisID = (0, _helpersDatasetJs.v)(dataset.rAxisID, getFirstScaleId(chart, 'r'));
        const indexAxis = meta.indexAxis;
        const iid = meta.iAxisID = chooseId(indexAxis, xid, yid, rid);
        const vid = meta.vAxisID = chooseId(indexAxis, yid, xid, rid);
        meta.xScale = this.getScaleForId(xid);
        meta.yScale = this.getScaleForId(yid);
        meta.rScale = this.getScaleForId(rid);
        meta.iScale = this.getScaleForId(iid);
        meta.vScale = this.getScaleForId(vid);
    }
    getDataset() {
        return this.chart.data.datasets[this.index];
    }
    getMeta() {
        return this.chart.getDatasetMeta(this.index);
    }
    getScaleForId(scaleID) {
        return this.chart.scales[scaleID];
    }
    _getOtherScale(scale) {
        const meta = this._cachedMeta;
        return scale === meta.iScale ? meta.vScale : meta.iScale;
    }
    reset() {
        this._update('reset');
    }
    _destroy() {
        const meta = this._cachedMeta;
        if (this._data) (0, _helpersDatasetJs.u)(this._data, this);
        if (meta._stacked) clearStacks(meta);
    }
    _dataCheck() {
        const dataset = this.getDataset();
        const data = dataset.data || (dataset.data = []);
        const _data = this._data;
        if ((0, _helpersDatasetJs.i)(data)) {
            const meta = this._cachedMeta;
            this._data = convertObjectDataToArray(data, meta);
        } else if (_data !== data) {
            if (_data) {
                (0, _helpersDatasetJs.u)(_data, this);
                const meta = this._cachedMeta;
                clearStacks(meta);
                meta._parsed = [];
            }
            if (data && Object.isExtensible(data)) (0, _helpersDatasetJs.l)(data, this);
            this._syncList = [];
            this._data = data;
        }
    }
    addElements() {
        const meta = this._cachedMeta;
        this._dataCheck();
        if (this.datasetElementType) meta.dataset = new this.datasetElementType();
    }
    buildOrUpdateElements(resetNewElements) {
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        let stackChanged = false;
        this._dataCheck();
        const oldStacked = meta._stacked;
        meta._stacked = isStacked(meta.vScale, meta);
        if (meta.stack !== dataset.stack) {
            stackChanged = true;
            clearStacks(meta);
            meta.stack = dataset.stack;
        }
        this._resyncElements(resetNewElements);
        if (stackChanged || oldStacked !== meta._stacked) {
            updateStacks(this, meta._parsed);
            meta._stacked = isStacked(meta.vScale, meta);
        }
    }
    configure() {
        const config = this.chart.config;
        const scopeKeys = config.datasetScopeKeys(this._type);
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys, true);
        this.options = config.createResolver(scopes, this.getContext());
        this._parsing = this.options.parsing;
        this._cachedDataOpts = {};
    }
    parse(start, count) {
        const { _cachedMeta: meta, _data: data } = this;
        const { iScale, _stacked } = meta;
        const iAxis = iScale.axis;
        let sorted = start === 0 && count === data.length ? true : meta._sorted;
        let prev = start > 0 && meta._parsed[start - 1];
        let i, cur, parsed;
        if (this._parsing === false) {
            meta._parsed = data;
            meta._sorted = true;
            parsed = data;
        } else {
            if ((0, _helpersDatasetJs.b)(data[start])) parsed = this.parseArrayData(meta, data, start, count);
            else if ((0, _helpersDatasetJs.i)(data[start])) parsed = this.parseObjectData(meta, data, start, count);
            else parsed = this.parsePrimitiveData(meta, data, start, count);
            const isNotInOrderComparedToPrev = ()=>cur[iAxis] === null || prev && cur[iAxis] < prev[iAxis];
            for(i = 0; i < count; ++i){
                meta._parsed[i + start] = cur = parsed[i];
                if (sorted) {
                    if (isNotInOrderComparedToPrev()) sorted = false;
                    prev = cur;
                }
            }
            meta._sorted = sorted;
        }
        if (_stacked) updateStacks(this, parsed);
    }
    parsePrimitiveData(meta, data, start, count) {
        const { iScale, vScale } = meta;
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const labels = iScale.getLabels();
        const singleScale = iScale === vScale;
        const parsed = new Array(count);
        let i, ilen, index;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            parsed[i] = {
                [iAxis]: singleScale || iScale.parse(labels[index], index),
                [vAxis]: vScale.parse(data[index], index)
            };
        }
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const { xScale, yScale } = meta;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse(item[0], index),
                y: yScale.parse(item[1], index)
            };
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const { xScale, yScale } = meta;
        const { xAxisKey = 'x', yAxisKey = 'y' } = this._parsing;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse((0, _helpersDatasetJs.f)(item, xAxisKey), index),
                y: yScale.parse((0, _helpersDatasetJs.f)(item, yAxisKey), index)
            };
        }
        return parsed;
    }
    getParsed(index) {
        return this._cachedMeta._parsed[index];
    }
    getDataElement(index) {
        return this._cachedMeta.data[index];
    }
    applyStack(scale, parsed, mode) {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const value = parsed[scale.axis];
        const stack = {
            keys: getSortedDatasetIndices(chart, true),
            values: parsed._stacks[scale.axis]._visualValues
        };
        return applyStack(stack, value, meta.index, {
            mode
        });
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        const parsedValue = parsed[scale.axis];
        let value = parsedValue === null ? NaN : parsedValue;
        const values = stack && parsed._stacks[scale.axis];
        if (stack && values) {
            stack.values = values;
            value = applyStack(stack, parsedValue, this._cachedMeta.index);
        }
        range.min = Math.min(range.min, value);
        range.max = Math.max(range.max, value);
    }
    getMinMax(scale, canStack) {
        const meta = this._cachedMeta;
        const _parsed = meta._parsed;
        const sorted = meta._sorted && scale === meta.iScale;
        const ilen = _parsed.length;
        const otherScale = this._getOtherScale(scale);
        const stack = createStack(canStack, meta, this.chart);
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        const { min: otherMin, max: otherMax } = getUserBounds(otherScale);
        let i, parsed;
        function _skip() {
            parsed = _parsed[i];
            const otherValue = parsed[otherScale.axis];
            return !(0, _helpersDatasetJs.g)(parsed[scale.axis]) || otherMin > otherValue || otherMax < otherValue;
        }
        for(i = 0; i < ilen; ++i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            if (sorted) break;
        }
        if (sorted) for(i = ilen - 1; i >= 0; --i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            break;
        }
        return range;
    }
    getAllParsedValues(scale) {
        const parsed = this._cachedMeta._parsed;
        const values = [];
        let i, ilen, value;
        for(i = 0, ilen = parsed.length; i < ilen; ++i){
            value = parsed[i][scale.axis];
            if ((0, _helpersDatasetJs.g)(value)) values.push(value);
        }
        return values;
    }
    getMaxOverflow() {
        return false;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const vScale = meta.vScale;
        const parsed = this.getParsed(index);
        return {
            label: iScale ? '' + iScale.getLabelForValue(parsed[iScale.axis]) : '',
            value: vScale ? '' + vScale.getLabelForValue(parsed[vScale.axis]) : ''
        };
    }
    _update(mode) {
        const meta = this._cachedMeta;
        this.update(mode || 'default');
        meta._clip = toClip((0, _helpersDatasetJs.v)(this.options.clip, defaultClip(meta.xScale, meta.yScale, this.getMaxOverflow())));
    }
    update(mode) {}
    draw() {
        const ctx = this._ctx;
        const chart = this.chart;
        const meta = this._cachedMeta;
        const elements = meta.data || [];
        const area = chart.chartArea;
        const active = [];
        const start = this._drawStart || 0;
        const count = this._drawCount || elements.length - start;
        const drawActiveElementsOnTop = this.options.drawActiveElementsOnTop;
        let i;
        if (meta.dataset) meta.dataset.draw(ctx, area, start, count);
        for(i = start; i < start + count; ++i){
            const element = elements[i];
            if (element.hidden) continue;
            if (element.active && drawActiveElementsOnTop) active.push(element);
            else element.draw(ctx, area);
        }
        for(i = 0; i < active.length; ++i)active[i].draw(ctx, area);
    }
    getStyle(index, active) {
        const mode = active ? 'active' : 'default';
        return index === undefined && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(mode) : this.resolveDataElementOptions(index || 0, mode);
    }
    getContext(index, active, mode) {
        const dataset = this.getDataset();
        let context;
        if (index >= 0 && index < this._cachedMeta.data.length) {
            const element = this._cachedMeta.data[index];
            context = element.$context || (element.$context = createDataContext(this.getContext(), index, element));
            context.parsed = this.getParsed(index);
            context.raw = dataset.data[index];
            context.index = context.dataIndex = index;
        } else {
            context = this.$context || (this.$context = createDatasetContext(this.chart.getContext(), this.index));
            context.dataset = dataset;
            context.index = context.datasetIndex = this.index;
        }
        context.active = !!active;
        context.mode = mode;
        return context;
    }
    resolveDatasetElementOptions(mode) {
        return this._resolveElementOptions(this.datasetElementType.id, mode);
    }
    resolveDataElementOptions(index, mode) {
        return this._resolveElementOptions(this.dataElementType.id, mode, index);
    }
    _resolveElementOptions(elementType, mode = 'default', index) {
        const active = mode === 'active';
        const cache = this._cachedDataOpts;
        const cacheKey = elementType + '-' + mode;
        const cached = cache[cacheKey];
        const sharing = this.enableOptionSharing && (0, _helpersDatasetJs.h)(index);
        if (cached) return cloneIfNotShared(cached, sharing);
        const config = this.chart.config;
        const scopeKeys = config.datasetElementScopeKeys(this._type, elementType);
        const prefixes = active ? [
            `${elementType}Hover`,
            'hover',
            elementType,
            ''
        ] : [
            elementType,
            ''
        ];
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
        const names = Object.keys((0, _helpersDatasetJs.d).elements[elementType]);
        const context = ()=>this.getContext(index, active, mode);
        const values = config.resolveNamedOptions(scopes, names, context, prefixes);
        if (values.$shared) {
            values.$shared = sharing;
            cache[cacheKey] = Object.freeze(cloneIfNotShared(values, sharing));
        }
        return values;
    }
    _resolveAnimations(index, transition, active) {
        const chart = this.chart;
        const cache = this._cachedDataOpts;
        const cacheKey = `animation-${transition}`;
        const cached = cache[cacheKey];
        if (cached) return cached;
        let options;
        if (chart.options.animation !== false) {
            const config = this.chart.config;
            const scopeKeys = config.datasetAnimationScopeKeys(this._type, transition);
            const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
            options = config.createResolver(scopes, this.getContext(index, active, transition));
        }
        const animations = new Animations(chart, options && options.animations);
        if (options && options._cacheable) cache[cacheKey] = Object.freeze(animations);
        return animations;
    }
    getSharedOptions(options) {
        if (!options.$shared) return;
        return this._sharedOptions || (this._sharedOptions = Object.assign({}, options));
    }
    includeOptions(mode, sharedOptions) {
        return !sharedOptions || isDirectUpdateMode(mode) || this.chart._animationsDisabled;
    }
    _getSharedOptions(start, mode) {
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const previouslySharedOptions = this._sharedOptions;
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions) || sharedOptions !== previouslySharedOptions;
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
        return {
            sharedOptions,
            includeOptions
        };
    }
    updateElement(element, index, properties, mode) {
        if (isDirectUpdateMode(mode)) Object.assign(element, properties);
        else this._resolveAnimations(index, mode).update(element, properties);
    }
    updateSharedOptions(sharedOptions, mode, newOptions) {
        if (sharedOptions && !isDirectUpdateMode(mode)) this._resolveAnimations(undefined, mode).update(sharedOptions, newOptions);
    }
    _setStyle(element, index, mode, active) {
        element.active = active;
        const options = this.getStyle(index, active);
        this._resolveAnimations(index, mode, active).update(element, {
            options: !active && this.getSharedOptions(options) || options
        });
    }
    removeHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, 'active', false);
    }
    setHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, 'active', true);
    }
    _removeDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, 'active', false);
    }
    _setDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, 'active', true);
    }
    _resyncElements(resetNewElements) {
        const data = this._data;
        const elements = this._cachedMeta.data;
        for (const [method, arg1, arg2] of this._syncList)this[method](arg1, arg2);
        this._syncList = [];
        const numMeta = elements.length;
        const numData = data.length;
        const count = Math.min(numData, numMeta);
        if (count) this.parse(0, count);
        if (numData > numMeta) this._insertElements(numMeta, numData - numMeta, resetNewElements);
        else if (numData < numMeta) this._removeElements(numData, numMeta - numData);
    }
    _insertElements(start, count, resetNewElements = true) {
        const meta = this._cachedMeta;
        const data = meta.data;
        const end = start + count;
        let i;
        const move = (arr)=>{
            arr.length += count;
            for(i = arr.length - 1; i >= end; i--)arr[i] = arr[i - count];
        };
        move(data);
        for(i = start; i < end; ++i)data[i] = new this.dataElementType();
        if (this._parsing) move(meta._parsed);
        this.parse(start, count);
        if (resetNewElements) this.updateElements(data, start, count, 'reset');
    }
    updateElements(element, start, count, mode) {}
    _removeElements(start, count) {
        const meta = this._cachedMeta;
        if (this._parsing) {
            const removed = meta._parsed.splice(start, count);
            if (meta._stacked) clearStacks(meta, removed);
        }
        meta.data.splice(start, count);
    }
    _sync(args) {
        if (this._parsing) this._syncList.push(args);
        else {
            const [method, arg1, arg2] = args;
            this[method](arg1, arg2);
        }
        this.chart._dataChanges.push([
            this.index,
            ...args
        ]);
    }
    _onDataPush() {
        const count = arguments.length;
        this._sync([
            '_insertElements',
            this.getDataset().data.length - count,
            count
        ]);
    }
    _onDataPop() {
        this._sync([
            '_removeElements',
            this._cachedMeta.data.length - 1,
            1
        ]);
    }
    _onDataShift() {
        this._sync([
            '_removeElements',
            0,
            1
        ]);
    }
    _onDataSplice(start, count) {
        if (count) this._sync([
            '_removeElements',
            start,
            count
        ]);
        const newCount = arguments.length - 2;
        if (newCount) this._sync([
            '_insertElements',
            start,
            newCount
        ]);
    }
    _onDataUnshift() {
        this._sync([
            '_insertElements',
            0,
            arguments.length
        ]);
    }
}
function getAllScaleValues(scale, type) {
    if (!scale._cache.$bar) {
        const visibleMetas = scale.getMatchingVisibleMetas(type);
        let values = [];
        for(let i = 0, ilen = visibleMetas.length; i < ilen; i++)values = values.concat(visibleMetas[i].controller.getAllParsedValues(scale));
        scale._cache.$bar = (0, _helpersDatasetJs._)(values.sort((a, b)=>a - b));
    }
    return scale._cache.$bar;
}
function computeMinSampleSize(meta) {
    const scale = meta.iScale;
    const values = getAllScaleValues(scale, meta.type);
    let min = scale._length;
    let i, ilen, curr, prev;
    const updateMinAndPrev = ()=>{
        if (curr === 32767 || curr === -32768) return;
        if ((0, _helpersDatasetJs.h)(prev)) min = Math.min(min, Math.abs(curr - prev) || min);
        prev = curr;
    };
    for(i = 0, ilen = values.length; i < ilen; ++i){
        curr = scale.getPixelForValue(values[i]);
        updateMinAndPrev();
    }
    prev = undefined;
    for(i = 0, ilen = scale.ticks.length; i < ilen; ++i){
        curr = scale.getPixelForTick(i);
        updateMinAndPrev();
    }
    return min;
}
function computeFitCategoryTraits(index, ruler, options, stackCount) {
    const thickness = options.barThickness;
    let size, ratio;
    if ((0, _helpersDatasetJs.k)(thickness)) {
        size = ruler.min * options.categoryPercentage;
        ratio = options.barPercentage;
    } else {
        size = thickness * stackCount;
        ratio = 1;
    }
    return {
        chunk: size / stackCount,
        ratio,
        start: ruler.pixels[index] - size / 2
    };
}
function computeFlexCategoryTraits(index, ruler, options, stackCount) {
    const pixels = ruler.pixels;
    const curr = pixels[index];
    let prev = index > 0 ? pixels[index - 1] : null;
    let next = index < pixels.length - 1 ? pixels[index + 1] : null;
    const percent = options.categoryPercentage;
    if (prev === null) prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
    if (next === null) next = curr + curr - prev;
    const start = curr - (curr - Math.min(prev, next)) / 2 * percent;
    const size = Math.abs(next - prev) / 2 * percent;
    return {
        chunk: size / stackCount,
        ratio: options.barPercentage,
        start
    };
}
function parseFloatBar(entry, item, vScale, i) {
    const startValue = vScale.parse(entry[0], i);
    const endValue = vScale.parse(entry[1], i);
    const min = Math.min(startValue, endValue);
    const max = Math.max(startValue, endValue);
    let barStart = min;
    let barEnd = max;
    if (Math.abs(min) > Math.abs(max)) {
        barStart = max;
        barEnd = min;
    }
    item[vScale.axis] = barEnd;
    item._custom = {
        barStart,
        barEnd,
        start: startValue,
        end: endValue,
        min,
        max
    };
}
function parseValue(entry, item, vScale, i) {
    if ((0, _helpersDatasetJs.b)(entry)) parseFloatBar(entry, item, vScale, i);
    else item[vScale.axis] = vScale.parse(entry, i);
    return item;
}
function parseArrayOrPrimitive(meta, data, start, count) {
    const iScale = meta.iScale;
    const vScale = meta.vScale;
    const labels = iScale.getLabels();
    const singleScale = iScale === vScale;
    const parsed = [];
    let i, ilen, item, entry;
    for(i = start, ilen = start + count; i < ilen; ++i){
        entry = data[i];
        item = {};
        item[iScale.axis] = singleScale || iScale.parse(labels[i], i);
        parsed.push(parseValue(entry, item, vScale, i));
    }
    return parsed;
}
function isFloatBar(custom) {
    return custom && custom.barStart !== undefined && custom.barEnd !== undefined;
}
function barSign(size, vScale, actualBase) {
    if (size !== 0) return (0, _helpersDatasetJs.s)(size);
    return (vScale.isHorizontal() ? 1 : -1) * (vScale.min >= actualBase ? 1 : -1);
}
function borderProps(properties) {
    let reverse, start, end, top, bottom;
    if (properties.horizontal) {
        reverse = properties.base > properties.x;
        start = 'left';
        end = 'right';
    } else {
        reverse = properties.base < properties.y;
        start = 'bottom';
        end = 'top';
    }
    if (reverse) {
        top = 'end';
        bottom = 'start';
    } else {
        top = 'start';
        bottom = 'end';
    }
    return {
        start,
        end,
        reverse,
        top,
        bottom
    };
}
function setBorderSkipped(properties, options, stack, index) {
    let edge = options.borderSkipped;
    const res = {};
    if (!edge) {
        properties.borderSkipped = res;
        return;
    }
    if (edge === true) {
        properties.borderSkipped = {
            top: true,
            right: true,
            bottom: true,
            left: true
        };
        return;
    }
    const { start, end, reverse, top, bottom } = borderProps(properties);
    if (edge === 'middle' && stack) {
        properties.enableBorderRadius = true;
        if ((stack._top || 0) === index) edge = top;
        else if ((stack._bottom || 0) === index) edge = bottom;
        else {
            res[parseEdge(bottom, start, end, reverse)] = true;
            edge = top;
        }
    }
    res[parseEdge(edge, start, end, reverse)] = true;
    properties.borderSkipped = res;
}
function parseEdge(edge, a, b, reverse) {
    if (reverse) {
        edge = swap(edge, a, b);
        edge = startEnd(edge, b, a);
    } else edge = startEnd(edge, a, b);
    return edge;
}
function swap(orig, v1, v2) {
    return orig === v1 ? v2 : orig === v2 ? v1 : orig;
}
function startEnd(v, start, end) {
    return v === 'start' ? start : v === 'end' ? end : v;
}
function setInflateAmount(properties, { inflateAmount }, ratio) {
    properties.inflateAmount = inflateAmount === 'auto' ? ratio === 1 ? 0.33 : 0 : inflateAmount;
}
class BarController extends DatasetController {
    static id = 'bar';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'bar',
        categoryPercentage: 0.8,
        barPercentage: 0.9,
        grouped: true,
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'base',
                    'width',
                    'height'
                ]
            }
        }
    };
    static overrides = {
        scales: {
            _index_: {
                type: 'category',
                offset: true,
                grid: {
                    offset: true
                }
            },
            _value_: {
                type: 'linear',
                beginAtZero: true
            }
        }
    };
    parsePrimitiveData(meta, data, start, count) {
        return parseArrayOrPrimitive(meta, data, start, count);
    }
    parseArrayData(meta, data, start, count) {
        return parseArrayOrPrimitive(meta, data, start, count);
    }
    parseObjectData(meta, data, start, count) {
        const { iScale, vScale } = meta;
        const { xAxisKey = 'x', yAxisKey = 'y' } = this._parsing;
        const iAxisKey = iScale.axis === 'x' ? xAxisKey : yAxisKey;
        const vAxisKey = vScale.axis === 'x' ? xAxisKey : yAxisKey;
        const parsed = [];
        let i, ilen, item, obj;
        for(i = start, ilen = start + count; i < ilen; ++i){
            obj = data[i];
            item = {};
            item[iScale.axis] = iScale.parse((0, _helpersDatasetJs.f)(obj, iAxisKey), i);
            parsed.push(parseValue((0, _helpersDatasetJs.f)(obj, vAxisKey), item, vScale, i));
        }
        return parsed;
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        super.updateRangeFromParsed(range, scale, parsed, stack);
        const custom = parsed._custom;
        if (custom && scale === this._cachedMeta.vScale) {
            range.min = Math.min(range.min, custom.min);
            range.max = Math.max(range.max, custom.max);
        }
    }
    getMaxOverflow() {
        return 0;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const { iScale, vScale } = meta;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const value = isFloatBar(custom) ? '[' + custom.start + ', ' + custom.end + ']' : '' + vScale.getLabelForValue(parsed[vScale.axis]);
        return {
            label: '' + iScale.getLabelForValue(parsed[iScale.axis]),
            value
        };
    }
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
        const meta = this._cachedMeta;
        meta.stack = this.getDataset().stack;
    }
    update(mode) {
        const meta = this._cachedMeta;
        this.updateElements(meta.data, 0, meta.data.length, mode);
    }
    updateElements(bars, start, count, mode) {
        const reset = mode === 'reset';
        const { index, _cachedMeta: { vScale } } = this;
        const base = vScale.getBasePixel();
        const horizontal = vScale.isHorizontal();
        const ruler = this._getRuler();
        const { sharedOptions, includeOptions } = this._getSharedOptions(start, mode);
        for(let i = start; i < start + count; i++){
            const parsed = this.getParsed(i);
            const vpixels = reset || (0, _helpersDatasetJs.k)(parsed[vScale.axis]) ? {
                base,
                head: base
            } : this._calculateBarValuePixels(i);
            const ipixels = this._calculateBarIndexPixels(i, ruler);
            const stack = (parsed._stacks || {})[vScale.axis];
            const properties = {
                horizontal,
                base: vpixels.base,
                enableBorderRadius: !stack || isFloatBar(parsed._custom) || index === stack._top || index === stack._bottom,
                x: horizontal ? vpixels.head : ipixels.center,
                y: horizontal ? ipixels.center : vpixels.head,
                height: horizontal ? ipixels.size : Math.abs(vpixels.size),
                width: horizontal ? Math.abs(vpixels.size) : ipixels.size
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, bars[i].active ? 'active' : mode);
            const options = properties.options || bars[i].options;
            setBorderSkipped(properties, options, stack, index);
            setInflateAmount(properties, options, ruler.ratio);
            this.updateElement(bars[i], i, properties, mode);
        }
    }
    _getStacks(last, dataIndex) {
        const { iScale } = this._cachedMeta;
        const metasets = iScale.getMatchingVisibleMetas(this._type).filter((meta)=>meta.controller.options.grouped);
        const stacked = iScale.options.stacked;
        const stacks = [];
        const currentParsed = this._cachedMeta.controller.getParsed(dataIndex);
        const iScaleValue = currentParsed && currentParsed[iScale.axis];
        const skipNull = (meta)=>{
            const parsed = meta._parsed.find((item)=>item[iScale.axis] === iScaleValue);
            const val = parsed && parsed[meta.vScale.axis];
            if ((0, _helpersDatasetJs.k)(val) || isNaN(val)) return true;
        };
        for (const meta of metasets){
            if (dataIndex !== undefined && skipNull(meta)) continue;
            if (stacked === false || stacks.indexOf(meta.stack) === -1 || stacked === undefined && meta.stack === undefined) stacks.push(meta.stack);
            if (meta.index === last) break;
        }
        if (!stacks.length) stacks.push(undefined);
        return stacks;
    }
    _getStackCount(index) {
        return this._getStacks(undefined, index).length;
    }
    _getStackIndex(datasetIndex, name, dataIndex) {
        const stacks = this._getStacks(datasetIndex, dataIndex);
        const index = name !== undefined ? stacks.indexOf(name) : -1;
        return index === -1 ? stacks.length - 1 : index;
    }
    _getRuler() {
        const opts = this.options;
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const pixels = [];
        let i, ilen;
        for(i = 0, ilen = meta.data.length; i < ilen; ++i)pixels.push(iScale.getPixelForValue(this.getParsed(i)[iScale.axis], i));
        const barThickness = opts.barThickness;
        const min = barThickness || computeMinSampleSize(meta);
        return {
            min,
            pixels,
            start: iScale._startPixel,
            end: iScale._endPixel,
            stackCount: this._getStackCount(),
            scale: iScale,
            grouped: opts.grouped,
            ratio: barThickness ? 1 : opts.categoryPercentage * opts.barPercentage
        };
    }
    _calculateBarValuePixels(index) {
        const { _cachedMeta: { vScale, _stacked, index: datasetIndex }, options: { base: baseValue, minBarLength } } = this;
        const actualBase = baseValue || 0;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const floating = isFloatBar(custom);
        let value = parsed[vScale.axis];
        let start = 0;
        let length = _stacked ? this.applyStack(vScale, parsed, _stacked) : value;
        let head, size;
        if (length !== value) {
            start = length - value;
            length = value;
        }
        if (floating) {
            value = custom.barStart;
            length = custom.barEnd - custom.barStart;
            if (value !== 0 && (0, _helpersDatasetJs.s)(value) !== (0, _helpersDatasetJs.s)(custom.barEnd)) start = 0;
            start += value;
        }
        const startValue = !(0, _helpersDatasetJs.k)(baseValue) && !floating ? baseValue : start;
        let base = vScale.getPixelForValue(startValue);
        if (this.chart.getDataVisibility(index)) head = vScale.getPixelForValue(start + length);
        else head = base;
        size = head - base;
        if (Math.abs(size) < minBarLength) {
            size = barSign(size, vScale, actualBase) * minBarLength;
            if (value === actualBase) base -= size / 2;
            const startPixel = vScale.getPixelForDecimal(0);
            const endPixel = vScale.getPixelForDecimal(1);
            const min = Math.min(startPixel, endPixel);
            const max = Math.max(startPixel, endPixel);
            base = Math.max(Math.min(base, max), min);
            head = base + size;
            if (_stacked && !floating) parsed._stacks[vScale.axis]._visualValues[datasetIndex] = vScale.getValueForPixel(head) - vScale.getValueForPixel(base);
        }
        if (base === vScale.getPixelForValue(actualBase)) {
            const halfGrid = (0, _helpersDatasetJs.s)(size) * vScale.getLineWidthForValue(actualBase) / 2;
            base += halfGrid;
            size -= halfGrid;
        }
        return {
            size,
            base,
            head,
            center: head + size / 2
        };
    }
    _calculateBarIndexPixels(index, ruler) {
        const scale = ruler.scale;
        const options = this.options;
        const skipNull = options.skipNull;
        const maxBarThickness = (0, _helpersDatasetJs.v)(options.maxBarThickness, Infinity);
        let center, size;
        if (ruler.grouped) {
            const stackCount = skipNull ? this._getStackCount(index) : ruler.stackCount;
            const range = options.barThickness === 'flex' ? computeFlexCategoryTraits(index, ruler, options, stackCount) : computeFitCategoryTraits(index, ruler, options, stackCount);
            const stackIndex = this._getStackIndex(this.index, this._cachedMeta.stack, skipNull ? index : undefined);
            center = range.start + range.chunk * stackIndex + range.chunk / 2;
            size = Math.min(maxBarThickness, range.chunk * range.ratio);
        } else {
            center = scale.getPixelForValue(this.getParsed(index)[scale.axis], index);
            size = Math.min(maxBarThickness, ruler.min * ruler.ratio);
        }
        return {
            base: center - size / 2,
            head: center + size / 2,
            center,
            size
        };
    }
    draw() {
        const meta = this._cachedMeta;
        const vScale = meta.vScale;
        const rects = meta.data;
        const ilen = rects.length;
        let i = 0;
        for(; i < ilen; ++i)if (this.getParsed(i)[vScale.axis] !== null && !rects[i].hidden) rects[i].draw(this._ctx);
    }
}
class BubbleController extends DatasetController {
    static id = 'bubble';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'point',
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'borderWidth',
                    'radius'
                ]
            }
        }
    };
    static overrides = {
        scales: {
            x: {
                type: 'linear'
            },
            y: {
                type: 'linear'
            }
        }
    };
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
    }
    parsePrimitiveData(meta, data, start, count) {
        const parsed = super.parsePrimitiveData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++)parsed[i]._custom = this.resolveDataElementOptions(i + start).radius;
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const parsed = super.parseArrayData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = (0, _helpersDatasetJs.v)(item[2], this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const parsed = super.parseObjectData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = (0, _helpersDatasetJs.v)(item && item.r && +item.r, this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    getMaxOverflow() {
        const data = this._cachedMeta.data;
        let max = 0;
        for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
        return max > 0 && max;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const labels = this.chart.data.labels || [];
        const { xScale, yScale } = meta;
        const parsed = this.getParsed(index);
        const x = xScale.getLabelForValue(parsed.x);
        const y = yScale.getLabelForValue(parsed.y);
        const r = parsed._custom;
        return {
            label: labels[index] || '',
            value: '(' + x + ', ' + y + (r ? ', ' + r : '') + ')'
        };
    }
    update(mode) {
        const points = this._cachedMeta.data;
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale, vScale } = this._cachedMeta;
        const { sharedOptions, includeOptions } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const parsed = !reset && this.getParsed(i);
            const properties = {};
            const iPixel = properties[iAxis] = reset ? iScale.getPixelForDecimal(0.5) : iScale.getPixelForValue(parsed[iAxis]);
            const vPixel = properties[vAxis] = reset ? vScale.getBasePixel() : vScale.getPixelForValue(parsed[vAxis]);
            properties.skip = isNaN(iPixel) || isNaN(vPixel);
            if (includeOptions) {
                properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
                if (reset) properties.options.radius = 0;
            }
            this.updateElement(point, i, properties, mode);
        }
    }
    resolveDataElementOptions(index, mode) {
        const parsed = this.getParsed(index);
        let values = super.resolveDataElementOptions(index, mode);
        if (values.$shared) values = Object.assign({}, values, {
            $shared: false
        });
        const radius = values.radius;
        if (mode !== 'active') values.radius = 0;
        values.radius += (0, _helpersDatasetJs.v)(parsed && parsed._custom, radius);
        return values;
    }
}
function getRatioAndOffset(rotation, circumference, cutout) {
    let ratioX = 1;
    let ratioY = 1;
    let offsetX = 0;
    let offsetY = 0;
    if (circumference < (0, _helpersDatasetJs.T)) {
        const startAngle = rotation;
        const endAngle = startAngle + circumference;
        const startX = Math.cos(startAngle);
        const startY = Math.sin(startAngle);
        const endX = Math.cos(endAngle);
        const endY = Math.sin(endAngle);
        const calcMax = (angle, a, b)=>(0, _helpersDatasetJs.p)(angle, startAngle, endAngle, true) ? 1 : Math.max(a, a * cutout, b, b * cutout);
        const calcMin = (angle, a, b)=>(0, _helpersDatasetJs.p)(angle, startAngle, endAngle, true) ? -1 : Math.min(a, a * cutout, b, b * cutout);
        const maxX = calcMax(0, startX, endX);
        const maxY = calcMax((0, _helpersDatasetJs.H), startY, endY);
        const minX = calcMin((0, _helpersDatasetJs.P), startX, endX);
        const minY = calcMin((0, _helpersDatasetJs.P) + (0, _helpersDatasetJs.H), startY, endY);
        ratioX = (maxX - minX) / 2;
        ratioY = (maxY - minY) / 2;
        offsetX = -(maxX + minX) / 2;
        offsetY = -(maxY + minY) / 2;
    }
    return {
        ratioX,
        ratioY,
        offsetX,
        offsetY
    };
}
class DoughnutController extends DatasetController {
    static id = 'doughnut';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'arc',
        animation: {
            animateRotate: true,
            animateScale: false
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'circumference',
                    'endAngle',
                    'innerRadius',
                    'outerRadius',
                    'startAngle',
                    'x',
                    'y',
                    'offset',
                    'borderWidth',
                    'spacing'
                ]
            }
        },
        cutout: '50%',
        rotation: 0,
        circumference: 360,
        radius: '100%',
        spacing: 0,
        indexAxis: 'r'
    };
    static descriptors = {
        _scriptable: (name)=>name !== 'spacing',
        _indexable: (name)=>name !== 'spacing' && !name.startsWith('borderDash') && !name.startsWith('hoverBorderDash')
    };
    static overrides = {
        aspectRatio: 1,
        plugins: {
            legend: {
                labels: {
                    generateLabels (chart) {
                        const data = chart.data;
                        if (data.labels.length && data.datasets.length) {
                            const { labels: { pointStyle, color } } = chart.legend.options;
                            return data.labels.map((label, i)=>{
                                const meta = chart.getDatasetMeta(0);
                                const style = meta.controller.getStyle(i);
                                return {
                                    text: label,
                                    fillStyle: style.backgroundColor,
                                    strokeStyle: style.borderColor,
                                    fontColor: color,
                                    lineWidth: style.borderWidth,
                                    pointStyle: pointStyle,
                                    hidden: !chart.getDataVisibility(i),
                                    index: i
                                };
                            });
                        }
                        return [];
                    }
                },
                onClick (e, legendItem, legend) {
                    legend.chart.toggleDataVisibility(legendItem.index);
                    legend.chart.update();
                }
            }
        }
    };
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.enableOptionSharing = true;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.offsetX = undefined;
        this.offsetY = undefined;
    }
    linkScales() {}
    parse(start, count) {
        const data = this.getDataset().data;
        const meta = this._cachedMeta;
        if (this._parsing === false) meta._parsed = data;
        else {
            let getter = (i)=>+data[i];
            if ((0, _helpersDatasetJs.i)(data[start])) {
                const { key = 'value' } = this._parsing;
                getter = (i)=>+(0, _helpersDatasetJs.f)(data[i], key);
            }
            let i, ilen;
            for(i = start, ilen = start + count; i < ilen; ++i)meta._parsed[i] = getter(i);
        }
    }
    _getRotation() {
        return (0, _helpersDatasetJs.t)(this.options.rotation - 90);
    }
    _getCircumference() {
        return (0, _helpersDatasetJs.t)(this.options.circumference);
    }
    _getRotationExtents() {
        let min = (0, _helpersDatasetJs.T);
        let max = -(0, _helpersDatasetJs.T);
        for(let i = 0; i < this.chart.data.datasets.length; ++i)if (this.chart.isDatasetVisible(i) && this.chart.getDatasetMeta(i).type === this._type) {
            const controller = this.chart.getDatasetMeta(i).controller;
            const rotation = controller._getRotation();
            const circumference = controller._getCircumference();
            min = Math.min(min, rotation);
            max = Math.max(max, rotation + circumference);
        }
        return {
            rotation: min,
            circumference: max - min
        };
    }
    update(mode) {
        const chart = this.chart;
        const { chartArea } = chart;
        const meta = this._cachedMeta;
        const arcs = meta.data;
        const spacing = this.getMaxBorderWidth() + this.getMaxOffset(arcs) + this.options.spacing;
        const maxSize = Math.max((Math.min(chartArea.width, chartArea.height) - spacing) / 2, 0);
        const cutout = Math.min((0, _helpersDatasetJs.m)(this.options.cutout, maxSize), 1);
        const chartWeight = this._getRingWeight(this.index);
        const { circumference, rotation } = this._getRotationExtents();
        const { ratioX, ratioY, offsetX, offsetY } = getRatioAndOffset(rotation, circumference, cutout);
        const maxWidth = (chartArea.width - spacing) / ratioX;
        const maxHeight = (chartArea.height - spacing) / ratioY;
        const maxRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
        const outerRadius = (0, _helpersDatasetJs.n)(this.options.radius, maxRadius);
        const innerRadius = Math.max(outerRadius * cutout, 0);
        const radiusLength = (outerRadius - innerRadius) / this._getVisibleDatasetWeightTotal();
        this.offsetX = offsetX * outerRadius;
        this.offsetY = offsetY * outerRadius;
        meta.total = this.calculateTotal();
        this.outerRadius = outerRadius - radiusLength * this._getRingWeightOffset(this.index);
        this.innerRadius = Math.max(this.outerRadius - radiusLength * chartWeight, 0);
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    _circumference(i, reset) {
        const opts = this.options;
        const meta = this._cachedMeta;
        const circumference = this._getCircumference();
        if (reset && opts.animation.animateRotate || !this.chart.getDataVisibility(i) || meta._parsed[i] === null || meta.data[i].hidden) return 0;
        return this.calculateCircumference(meta._parsed[i] * circumference / (0, _helpersDatasetJs.T));
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === 'reset';
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const centerX = (chartArea.left + chartArea.right) / 2;
        const centerY = (chartArea.top + chartArea.bottom) / 2;
        const animateScale = reset && animationOpts.animateScale;
        const innerRadius = animateScale ? 0 : this.innerRadius;
        const outerRadius = animateScale ? 0 : this.outerRadius;
        const { sharedOptions, includeOptions } = this._getSharedOptions(start, mode);
        let startAngle = this._getRotation();
        let i;
        for(i = 0; i < start; ++i)startAngle += this._circumference(i, reset);
        for(i = start; i < start + count; ++i){
            const circumference = this._circumference(i, reset);
            const arc = arcs[i];
            const properties = {
                x: centerX + this.offsetX,
                y: centerY + this.offsetY,
                startAngle,
                endAngle: startAngle + circumference,
                circumference,
                outerRadius,
                innerRadius
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, arc.active ? 'active' : mode);
            startAngle += circumference;
            this.updateElement(arc, i, properties, mode);
        }
    }
    calculateTotal() {
        const meta = this._cachedMeta;
        const metaData = meta.data;
        let total = 0;
        let i;
        for(i = 0; i < metaData.length; i++){
            const value = meta._parsed[i];
            if (value !== null && !isNaN(value) && this.chart.getDataVisibility(i) && !metaData[i].hidden) total += Math.abs(value);
        }
        return total;
    }
    calculateCircumference(value) {
        const total = this._cachedMeta.total;
        if (total > 0 && !isNaN(value)) return (0, _helpersDatasetJs.T) * (Math.abs(value) / total);
        return 0;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = (0, _helpersDatasetJs.o)(meta._parsed[index], chart.options.locale);
        return {
            label: labels[index] || '',
            value
        };
    }
    getMaxBorderWidth(arcs) {
        let max = 0;
        const chart = this.chart;
        let i, ilen, meta, controller, options;
        if (!arcs) {
            for(i = 0, ilen = chart.data.datasets.length; i < ilen; ++i)if (chart.isDatasetVisible(i)) {
                meta = chart.getDatasetMeta(i);
                arcs = meta.data;
                controller = meta.controller;
                break;
            }
        }
        if (!arcs) return 0;
        for(i = 0, ilen = arcs.length; i < ilen; ++i){
            options = controller.resolveDataElementOptions(i);
            if (options.borderAlign !== 'inner') max = Math.max(max, options.borderWidth || 0, options.hoverBorderWidth || 0);
        }
        return max;
    }
    getMaxOffset(arcs) {
        let max = 0;
        for(let i = 0, ilen = arcs.length; i < ilen; ++i){
            const options = this.resolveDataElementOptions(i);
            max = Math.max(max, options.offset || 0, options.hoverOffset || 0);
        }
        return max;
    }
    _getRingWeightOffset(datasetIndex) {
        let ringWeightOffset = 0;
        for(let i = 0; i < datasetIndex; ++i)if (this.chart.isDatasetVisible(i)) ringWeightOffset += this._getRingWeight(i);
        return ringWeightOffset;
    }
    _getRingWeight(datasetIndex) {
        return Math.max((0, _helpersDatasetJs.v)(this.chart.data.datasets[datasetIndex].weight, 1), 0);
    }
    _getVisibleDatasetWeightTotal() {
        return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
    }
}
class LineController extends DatasetController {
    static id = 'line';
    static defaults = {
        datasetElementType: 'line',
        dataElementType: 'point',
        showLine: true,
        spanGaps: false
    };
    static overrides = {
        scales: {
            _index_: {
                type: 'category'
            },
            _value_: {
                type: 'linear'
            }
        }
    };
    initialize() {
        this.enableOptionSharing = true;
        this.supportsDecimation = true;
        super.initialize();
    }
    update(mode) {
        const meta = this._cachedMeta;
        const { dataset: line, data: points = [], _dataset } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start, count } = (0, _helpersDatasetJs.q)(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if ((0, _helpersDatasetJs.w)(meta)) {
            start = 0;
            count = points.length;
        }
        line._chart = this.chart;
        line._datasetIndex = this.index;
        line._decimated = !!_dataset._decimated;
        line.points = points;
        const options = this.resolveDatasetElementOptions(mode);
        if (!this.options.showLine) options.borderWidth = 0;
        options.segment = this.options.segment;
        this.updateElement(line, undefined, {
            animated: !animationsDisabled,
            options
        }, mode);
        this.updateElements(points, start, count, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale, vScale, _stacked, _dataset } = this._cachedMeta;
        const { sharedOptions, includeOptions } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps, segment } = this.options;
        const maxGapLength = (0, _helpersDatasetJs.x)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === 'none';
        const end = start + count;
        const pointsCount = points.length;
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = 0; i < pointsCount; ++i){
            const point = points[i];
            const properties = directUpdate ? point : {};
            if (i < start || i >= end) {
                properties.skip = true;
                continue;
            }
            const parsed = this.getParsed(i);
            const nullData = (0, _helpersDatasetJs.k)(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
    }
    getMaxOverflow() {
        const meta = this._cachedMeta;
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        const data = meta.data || [];
        if (!data.length) return border;
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
    draw() {
        const meta = this._cachedMeta;
        meta.dataset.updateControlPoints(this.chart.chartArea, meta.iScale.axis);
        super.draw();
    }
}
class PolarAreaController extends DatasetController {
    static id = 'polarArea';
    static defaults = {
        dataElementType: 'arc',
        animation: {
            animateRotate: true,
            animateScale: true
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'startAngle',
                    'endAngle',
                    'innerRadius',
                    'outerRadius'
                ]
            }
        },
        indexAxis: 'r',
        startAngle: 0
    };
    static overrides = {
        aspectRatio: 1,
        plugins: {
            legend: {
                labels: {
                    generateLabels (chart) {
                        const data = chart.data;
                        if (data.labels.length && data.datasets.length) {
                            const { labels: { pointStyle, color } } = chart.legend.options;
                            return data.labels.map((label, i)=>{
                                const meta = chart.getDatasetMeta(0);
                                const style = meta.controller.getStyle(i);
                                return {
                                    text: label,
                                    fillStyle: style.backgroundColor,
                                    strokeStyle: style.borderColor,
                                    fontColor: color,
                                    lineWidth: style.borderWidth,
                                    pointStyle: pointStyle,
                                    hidden: !chart.getDataVisibility(i),
                                    index: i
                                };
                            });
                        }
                        return [];
                    }
                },
                onClick (e, legendItem, legend) {
                    legend.chart.toggleDataVisibility(legendItem.index);
                    legend.chart.update();
                }
            }
        },
        scales: {
            r: {
                type: 'radialLinear',
                angleLines: {
                    display: false
                },
                beginAtZero: true,
                grid: {
                    circular: true
                },
                pointLabels: {
                    display: false
                },
                startAngle: 0
            }
        }
    };
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.innerRadius = undefined;
        this.outerRadius = undefined;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = (0, _helpersDatasetJs.o)(meta._parsed[index].r, chart.options.locale);
        return {
            label: labels[index] || '',
            value
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, _helpersDatasetJs.y).bind(this)(meta, data, start, count);
    }
    update(mode) {
        const arcs = this._cachedMeta.data;
        this._updateRadius();
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    getMinMax() {
        const meta = this._cachedMeta;
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        meta.data.forEach((element, index)=>{
            const parsed = this.getParsed(index).r;
            if (!isNaN(parsed) && this.chart.getDataVisibility(index)) {
                if (parsed < range.min) range.min = parsed;
                if (parsed > range.max) range.max = parsed;
            }
        });
        return range;
    }
    _updateRadius() {
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
        const outerRadius = Math.max(minSize / 2, 0);
        const innerRadius = Math.max(opts.cutoutPercentage ? outerRadius / 100 * opts.cutoutPercentage : 1, 0);
        const radiusLength = (outerRadius - innerRadius) / chart.getVisibleDatasetCount();
        this.outerRadius = outerRadius - radiusLength * this.index;
        this.innerRadius = this.outerRadius - radiusLength;
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === 'reset';
        const chart = this.chart;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const scale = this._cachedMeta.rScale;
        const centerX = scale.xCenter;
        const centerY = scale.yCenter;
        const datasetStartAngle = scale.getIndexAngle(0) - 0.5 * (0, _helpersDatasetJs.P);
        let angle = datasetStartAngle;
        let i;
        const defaultAngle = 360 / this.countVisibleElements();
        for(i = 0; i < start; ++i)angle += this._computeAngle(i, mode, defaultAngle);
        for(i = start; i < start + count; i++){
            const arc = arcs[i];
            let startAngle = angle;
            let endAngle = angle + this._computeAngle(i, mode, defaultAngle);
            let outerRadius = chart.getDataVisibility(i) ? scale.getDistanceFromCenterForValue(this.getParsed(i).r) : 0;
            angle = endAngle;
            if (reset) {
                if (animationOpts.animateScale) outerRadius = 0;
                if (animationOpts.animateRotate) startAngle = endAngle = datasetStartAngle;
            }
            const properties = {
                x: centerX,
                y: centerY,
                innerRadius: 0,
                outerRadius,
                startAngle,
                endAngle,
                options: this.resolveDataElementOptions(i, arc.active ? 'active' : mode)
            };
            this.updateElement(arc, i, properties, mode);
        }
    }
    countVisibleElements() {
        const meta = this._cachedMeta;
        let count = 0;
        meta.data.forEach((element, index)=>{
            if (!isNaN(this.getParsed(index).r) && this.chart.getDataVisibility(index)) count++;
        });
        return count;
    }
    _computeAngle(index, mode, defaultAngle) {
        return this.chart.getDataVisibility(index) ? (0, _helpersDatasetJs.t)(this.resolveDataElementOptions(index, mode).angle || defaultAngle) : 0;
    }
}
class PieController extends DoughnutController {
    static id = 'pie';
    static defaults = {
        cutout: 0,
        rotation: 0,
        circumference: 360,
        radius: '100%'
    };
}
class RadarController extends DatasetController {
    static id = 'radar';
    static defaults = {
        datasetElementType: 'line',
        dataElementType: 'point',
        indexAxis: 'r',
        showLine: true,
        elements: {
            line: {
                fill: 'start'
            }
        }
    };
    static overrides = {
        aspectRatio: 1,
        scales: {
            r: {
                type: 'radialLinear'
            }
        }
    };
    getLabelAndValue(index) {
        const vScale = this._cachedMeta.vScale;
        const parsed = this.getParsed(index);
        return {
            label: vScale.getLabels()[index],
            value: '' + vScale.getLabelForValue(parsed[vScale.axis])
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, _helpersDatasetJs.y).bind(this)(meta, data, start, count);
    }
    update(mode) {
        const meta = this._cachedMeta;
        const line = meta.dataset;
        const points = meta.data || [];
        const labels = meta.iScale.getLabels();
        line.points = points;
        if (mode !== 'resize') {
            const options = this.resolveDatasetElementOptions(mode);
            if (!this.options.showLine) options.borderWidth = 0;
            const properties = {
                _loop: true,
                _fullLoop: labels.length === points.length,
                options
            };
            this.updateElement(line, undefined, properties, mode);
        }
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const scale = this._cachedMeta.rScale;
        const reset = mode === 'reset';
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const options = this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            const pointPosition = scale.getPointPositionForValue(i, this.getParsed(i).r);
            const x = reset ? scale.xCenter : pointPosition.x;
            const y = reset ? scale.yCenter : pointPosition.y;
            const properties = {
                x,
                y,
                angle: pointPosition.angle,
                skip: isNaN(x) || isNaN(y),
                options
            };
            this.updateElement(point, i, properties, mode);
        }
    }
}
class ScatterController extends DatasetController {
    static id = 'scatter';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'point',
        showLine: false,
        fill: false
    };
    static overrides = {
        interaction: {
            mode: 'point'
        },
        scales: {
            x: {
                type: 'linear'
            },
            y: {
                type: 'linear'
            }
        }
    };
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const labels = this.chart.data.labels || [];
        const { xScale, yScale } = meta;
        const parsed = this.getParsed(index);
        const x = xScale.getLabelForValue(parsed.x);
        const y = yScale.getLabelForValue(parsed.y);
        return {
            label: labels[index] || '',
            value: '(' + x + ', ' + y + ')'
        };
    }
    update(mode) {
        const meta = this._cachedMeta;
        const { data: points = [] } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start, count } = (0, _helpersDatasetJs.q)(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if ((0, _helpersDatasetJs.w)(meta)) {
            start = 0;
            count = points.length;
        }
        if (this.options.showLine) {
            if (!this.datasetElementType) this.addElements();
            const { dataset: line, _dataset } = meta;
            line._chart = this.chart;
            line._datasetIndex = this.index;
            line._decimated = !!_dataset._decimated;
            line.points = points;
            const options = this.resolveDatasetElementOptions(mode);
            options.segment = this.options.segment;
            this.updateElement(line, undefined, {
                animated: !animationsDisabled,
                options
            }, mode);
        } else if (this.datasetElementType) {
            delete meta.dataset;
            this.datasetElementType = false;
        }
        this.updateElements(points, start, count, mode);
    }
    addElements() {
        const { showLine } = this.options;
        if (!this.datasetElementType && showLine) this.datasetElementType = this.chart.registry.getElement('line');
        super.addElements();
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale, vScale, _stacked, _dataset } = this._cachedMeta;
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps, segment } = this.options;
        const maxGapLength = (0, _helpersDatasetJs.x)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === 'none';
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = start; i < start + count; ++i){
            const point = points[i];
            const parsed = this.getParsed(i);
            const properties = directUpdate ? point : {};
            const nullData = (0, _helpersDatasetJs.k)(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
    }
    getMaxOverflow() {
        const meta = this._cachedMeta;
        const data = meta.data || [];
        if (!this.options.showLine) {
            let max = 0;
            for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
            return max > 0 && max;
        }
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        if (!data.length) return border;
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
}
var controllers = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BarController: BarController,
    BubbleController: BubbleController,
    DoughnutController: DoughnutController,
    LineController: LineController,
    PieController: PieController,
    PolarAreaController: PolarAreaController,
    RadarController: RadarController,
    ScatterController: ScatterController
});
/**
 * @namespace Chart._adapters
 * @since 2.8.0
 * @private
 */ function abstract() {
    throw new Error('This method is not implemented: Check that a complete date adapter is provided.');
}
/**
 * Date adapter (current used by the time scale)
 * @namespace Chart._adapters._date
 * @memberof Chart._adapters
 * @private
 */ class DateAdapterBase {
    /**
   * Override default date adapter methods.
   * Accepts type parameter to define options type.
   * @example
   * Chart._adapters._date.override<{myAdapterOption: string}>({
   *   init() {
   *     console.log(this.options.myAdapterOption);
   *   }
   * })
   */ static override(members) {
        Object.assign(DateAdapterBase.prototype, members);
    }
    options;
    constructor(options){
        this.options = options || {};
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    init() {}
    formats() {
        return abstract();
    }
    parse() {
        return abstract();
    }
    format() {
        return abstract();
    }
    add() {
        return abstract();
    }
    diff() {
        return abstract();
    }
    startOf() {
        return abstract();
    }
    endOf() {
        return abstract();
    }
}
var adapters = {
    _date: DateAdapterBase
};
function binarySearch(metaset, axis, value, intersect) {
    const { controller, data, _sorted } = metaset;
    const iScale = controller._cachedMeta.iScale;
    const spanGaps = metaset.dataset ? metaset.dataset.options ? metaset.dataset.options.spanGaps : null : null;
    if (iScale && axis === iScale.axis && axis !== 'r' && _sorted && data.length) {
        const lookupMethod = iScale._reversePixels ? (0, _helpersDatasetJs.A) : (0, _helpersDatasetJs.B);
        if (!intersect) {
            const result = lookupMethod(data, axis, value);
            if (spanGaps) {
                const { vScale } = controller._cachedMeta;
                const { _parsed } = metaset;
                const distanceToDefinedLo = _parsed.slice(0, result.lo + 1).reverse().findIndex((point)=>!(0, _helpersDatasetJs.k)(point[vScale.axis]));
                result.lo -= Math.max(0, distanceToDefinedLo);
                const distanceToDefinedHi = _parsed.slice(result.hi).findIndex((point)=>!(0, _helpersDatasetJs.k)(point[vScale.axis]));
                result.hi += Math.max(0, distanceToDefinedHi);
            }
            return result;
        } else if (controller._sharedOptions) {
            const el = data[0];
            const range = typeof el.getRange === 'function' && el.getRange(axis);
            if (range) {
                const start = lookupMethod(data, axis, value - range);
                const end = lookupMethod(data, axis, value + range);
                return {
                    lo: start.lo,
                    hi: end.hi
                };
            }
        }
    }
    return {
        lo: 0,
        hi: data.length - 1
    };
}
function evaluateInteractionItems(chart, axis, position, handler, intersect) {
    const metasets = chart.getSortedVisibleDatasetMetas();
    const value = position[axis];
    for(let i = 0, ilen = metasets.length; i < ilen; ++i){
        const { index, data } = metasets[i];
        const { lo, hi } = binarySearch(metasets[i], axis, value, intersect);
        for(let j = lo; j <= hi; ++j){
            const element = data[j];
            if (!element.skip) handler(element, index, j);
        }
    }
}
function getDistanceMetricForAxis(axis) {
    const useX = axis.indexOf('x') !== -1;
    const useY = axis.indexOf('y') !== -1;
    return function(pt1, pt2) {
        const deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
        const deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
        return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
    };
}
function getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) {
    const items = [];
    if (!includeInvisible && !chart.isPointInArea(position)) return items;
    const evaluationFunc = function(element, datasetIndex, index) {
        if (!includeInvisible && !(0, _helpersDatasetJs.C)(element, chart.chartArea, 0)) return;
        if (element.inRange(position.x, position.y, useFinalPosition)) items.push({
            element,
            datasetIndex,
            index
        });
    };
    evaluateInteractionItems(chart, axis, position, evaluationFunc, true);
    return items;
}
function getNearestRadialItems(chart, position, axis, useFinalPosition) {
    let items = [];
    function evaluationFunc(element, datasetIndex, index) {
        const { startAngle, endAngle } = element.getProps([
            'startAngle',
            'endAngle'
        ], useFinalPosition);
        const { angle } = (0, _helpersDatasetJs.D)(element, {
            x: position.x,
            y: position.y
        });
        if ((0, _helpersDatasetJs.p)(angle, startAngle, endAngle)) items.push({
            element,
            datasetIndex,
            index
        });
    }
    evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    let items = [];
    const distanceMetric = getDistanceMetricForAxis(axis);
    let minDistance = Number.POSITIVE_INFINITY;
    function evaluationFunc(element, datasetIndex, index) {
        const inRange = element.inRange(position.x, position.y, useFinalPosition);
        if (intersect && !inRange) return;
        const center = element.getCenterPoint(useFinalPosition);
        const pointInArea = !!includeInvisible || chart.isPointInArea(center);
        if (!pointInArea && !inRange) return;
        const distance = distanceMetric(position, center);
        if (distance < minDistance) {
            items = [
                {
                    element,
                    datasetIndex,
                    index
                }
            ];
            minDistance = distance;
        } else if (distance === minDistance) items.push({
            element,
            datasetIndex,
            index
        });
    }
    evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function getNearestItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    if (!includeInvisible && !chart.isPointInArea(position)) return [];
    return axis === 'r' && !intersect ? getNearestRadialItems(chart, position, axis, useFinalPosition) : getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible);
}
function getAxisItems(chart, position, axis, intersect, useFinalPosition) {
    const items = [];
    const rangeMethod = axis === 'x' ? 'inXRange' : 'inYRange';
    let intersectsItem = false;
    evaluateInteractionItems(chart, axis, position, (element, datasetIndex, index)=>{
        if (element[rangeMethod] && element[rangeMethod](position[axis], useFinalPosition)) {
            items.push({
                element,
                datasetIndex,
                index
            });
            intersectsItem = intersectsItem || element.inRange(position.x, position.y, useFinalPosition);
        }
    });
    if (intersect && !intersectsItem) return [];
    return items;
}
var Interaction = {
    evaluateInteractionItems,
    modes: {
        index (chart, e, options, useFinalPosition) {
            const position = (0, _helpersDatasetJs.z)(e, chart);
            const axis = options.axis || 'x';
            const includeInvisible = options.includeInvisible || false;
            const items = options.intersect ? getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            const elements = [];
            if (!items.length) return [];
            chart.getSortedVisibleDatasetMetas().forEach((meta)=>{
                const index = items[0].index;
                const element = meta.data[index];
                if (element && !element.skip) elements.push({
                    element,
                    datasetIndex: meta.index,
                    index
                });
            });
            return elements;
        },
        dataset (chart, e, options, useFinalPosition) {
            const position = (0, _helpersDatasetJs.z)(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            let items = options.intersect ? getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            if (items.length > 0) {
                const datasetIndex = items[0].datasetIndex;
                const data = chart.getDatasetMeta(datasetIndex).data;
                items = [];
                for(let i = 0; i < data.length; ++i)items.push({
                    element: data[i],
                    datasetIndex,
                    index: i
                });
            }
            return items;
        },
        point (chart, e, options, useFinalPosition) {
            const position = (0, _helpersDatasetJs.z)(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            return getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible);
        },
        nearest (chart, e, options, useFinalPosition) {
            const position = (0, _helpersDatasetJs.z)(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            return getNearestItems(chart, position, axis, options.intersect, useFinalPosition, includeInvisible);
        },
        x (chart, e, options, useFinalPosition) {
            const position = (0, _helpersDatasetJs.z)(e, chart);
            return getAxisItems(chart, position, 'x', options.intersect, useFinalPosition);
        },
        y (chart, e, options, useFinalPosition) {
            const position = (0, _helpersDatasetJs.z)(e, chart);
            return getAxisItems(chart, position, 'y', options.intersect, useFinalPosition);
        }
    }
};
const STATIC_POSITIONS = [
    'left',
    'top',
    'right',
    'bottom'
];
function filterByPosition(array, position) {
    return array.filter((v)=>v.pos === position);
}
function filterDynamicPositionByAxis(array, axis) {
    return array.filter((v)=>STATIC_POSITIONS.indexOf(v.pos) === -1 && v.box.axis === axis);
}
function sortByWeight(array, reverse) {
    return array.sort((a, b)=>{
        const v0 = reverse ? b : a;
        const v1 = reverse ? a : b;
        return v0.weight === v1.weight ? v0.index - v1.index : v0.weight - v1.weight;
    });
}
function wrapBoxes(boxes) {
    const layoutBoxes = [];
    let i, ilen, box, pos, stack, stackWeight;
    for(i = 0, ilen = (boxes || []).length; i < ilen; ++i){
        box = boxes[i];
        ({ position: pos, options: { stack, stackWeight = 1 } } = box);
        layoutBoxes.push({
            index: i,
            box,
            pos,
            horizontal: box.isHorizontal(),
            weight: box.weight,
            stack: stack && pos + stack,
            stackWeight
        });
    }
    return layoutBoxes;
}
function buildStacks(layouts) {
    const stacks = {};
    for (const wrap of layouts){
        const { stack, pos, stackWeight } = wrap;
        if (!stack || !STATIC_POSITIONS.includes(pos)) continue;
        const _stack = stacks[stack] || (stacks[stack] = {
            count: 0,
            placed: 0,
            weight: 0,
            size: 0
        });
        _stack.count++;
        _stack.weight += stackWeight;
    }
    return stacks;
}
function setLayoutDims(layouts, params) {
    const stacks = buildStacks(layouts);
    const { vBoxMaxWidth, hBoxMaxHeight } = params;
    let i, ilen, layout;
    for(i = 0, ilen = layouts.length; i < ilen; ++i){
        layout = layouts[i];
        const { fullSize } = layout.box;
        const stack = stacks[layout.stack];
        const factor = stack && layout.stackWeight / stack.weight;
        if (layout.horizontal) {
            layout.width = factor ? factor * vBoxMaxWidth : fullSize && params.availableWidth;
            layout.height = hBoxMaxHeight;
        } else {
            layout.width = vBoxMaxWidth;
            layout.height = factor ? factor * hBoxMaxHeight : fullSize && params.availableHeight;
        }
    }
    return stacks;
}
function buildLayoutBoxes(boxes) {
    const layoutBoxes = wrapBoxes(boxes);
    const fullSize = sortByWeight(layoutBoxes.filter((wrap)=>wrap.box.fullSize), true);
    const left = sortByWeight(filterByPosition(layoutBoxes, 'left'), true);
    const right = sortByWeight(filterByPosition(layoutBoxes, 'right'));
    const top = sortByWeight(filterByPosition(layoutBoxes, 'top'), true);
    const bottom = sortByWeight(filterByPosition(layoutBoxes, 'bottom'));
    const centerHorizontal = filterDynamicPositionByAxis(layoutBoxes, 'x');
    const centerVertical = filterDynamicPositionByAxis(layoutBoxes, 'y');
    return {
        fullSize,
        leftAndTop: left.concat(top),
        rightAndBottom: right.concat(centerVertical).concat(bottom).concat(centerHorizontal),
        chartArea: filterByPosition(layoutBoxes, 'chartArea'),
        vertical: left.concat(right).concat(centerVertical),
        horizontal: top.concat(bottom).concat(centerHorizontal)
    };
}
function getCombinedMax(maxPadding, chartArea, a, b) {
    return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
}
function updateMaxPadding(maxPadding, boxPadding) {
    maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
    maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
    maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
    maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
}
function updateDims(chartArea, params, layout, stacks) {
    const { pos, box } = layout;
    const maxPadding = chartArea.maxPadding;
    if (!(0, _helpersDatasetJs.i)(pos)) {
        if (layout.size) chartArea[pos] -= layout.size;
        const stack = stacks[layout.stack] || {
            size: 0,
            count: 1
        };
        stack.size = Math.max(stack.size, layout.horizontal ? box.height : box.width);
        layout.size = stack.size / stack.count;
        chartArea[pos] += layout.size;
    }
    if (box.getPadding) updateMaxPadding(maxPadding, box.getPadding());
    const newWidth = Math.max(0, params.outerWidth - getCombinedMax(maxPadding, chartArea, 'left', 'right'));
    const newHeight = Math.max(0, params.outerHeight - getCombinedMax(maxPadding, chartArea, 'top', 'bottom'));
    const widthChanged = newWidth !== chartArea.w;
    const heightChanged = newHeight !== chartArea.h;
    chartArea.w = newWidth;
    chartArea.h = newHeight;
    return layout.horizontal ? {
        same: widthChanged,
        other: heightChanged
    } : {
        same: heightChanged,
        other: widthChanged
    };
}
function handleMaxPadding(chartArea) {
    const maxPadding = chartArea.maxPadding;
    function updatePos(pos) {
        const change = Math.max(maxPadding[pos] - chartArea[pos], 0);
        chartArea[pos] += change;
        return change;
    }
    chartArea.y += updatePos('top');
    chartArea.x += updatePos('left');
    updatePos('right');
    updatePos('bottom');
}
function getMargins(horizontal, chartArea) {
    const maxPadding = chartArea.maxPadding;
    function marginForPositions(positions) {
        const margin = {
            left: 0,
            top: 0,
            right: 0,
            bottom: 0
        };
        positions.forEach((pos)=>{
            margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
        });
        return margin;
    }
    return horizontal ? marginForPositions([
        'left',
        'right'
    ]) : marginForPositions([
        'top',
        'bottom'
    ]);
}
function fitBoxes(boxes, chartArea, params, stacks) {
    const refitBoxes = [];
    let i, ilen, layout, box, refit, changed;
    for(i = 0, ilen = boxes.length, refit = 0; i < ilen; ++i){
        layout = boxes[i];
        box = layout.box;
        box.update(layout.width || chartArea.w, layout.height || chartArea.h, getMargins(layout.horizontal, chartArea));
        const { same, other } = updateDims(chartArea, params, layout, stacks);
        refit |= same && refitBoxes.length;
        changed = changed || other;
        if (!box.fullSize) refitBoxes.push(layout);
    }
    return refit && fitBoxes(refitBoxes, chartArea, params, stacks) || changed;
}
function setBoxDims(box, left, top, width, height) {
    box.top = top;
    box.left = left;
    box.right = left + width;
    box.bottom = top + height;
    box.width = width;
    box.height = height;
}
function placeBoxes(boxes, chartArea, params, stacks) {
    const userPadding = params.padding;
    let { x, y } = chartArea;
    for (const layout of boxes){
        const box = layout.box;
        const stack = stacks[layout.stack] || {
            count: 1,
            placed: 0,
            weight: 1
        };
        const weight = layout.stackWeight / stack.weight || 1;
        if (layout.horizontal) {
            const width = chartArea.w * weight;
            const height = stack.size || box.height;
            if ((0, _helpersDatasetJs.h)(stack.start)) y = stack.start;
            if (box.fullSize) setBoxDims(box, userPadding.left, y, params.outerWidth - userPadding.right - userPadding.left, height);
            else setBoxDims(box, chartArea.left + stack.placed, y, width, height);
            stack.start = y;
            stack.placed += width;
            y = box.bottom;
        } else {
            const height = chartArea.h * weight;
            const width = stack.size || box.width;
            if ((0, _helpersDatasetJs.h)(stack.start)) x = stack.start;
            if (box.fullSize) setBoxDims(box, x, userPadding.top, width, params.outerHeight - userPadding.bottom - userPadding.top);
            else setBoxDims(box, x, chartArea.top + stack.placed, width, height);
            stack.start = x;
            stack.placed += height;
            x = box.right;
        }
    }
    chartArea.x = x;
    chartArea.y = y;
}
var layouts = {
    addBox (chart, item) {
        if (!chart.boxes) chart.boxes = [];
        item.fullSize = item.fullSize || false;
        item.position = item.position || 'top';
        item.weight = item.weight || 0;
        item._layers = item._layers || function() {
            return [
                {
                    z: 0,
                    draw (chartArea) {
                        item.draw(chartArea);
                    }
                }
            ];
        };
        chart.boxes.push(item);
    },
    removeBox (chart, layoutItem) {
        const index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
        if (index !== -1) chart.boxes.splice(index, 1);
    },
    configure (chart, item, options) {
        item.fullSize = options.fullSize;
        item.position = options.position;
        item.weight = options.weight;
    },
    update (chart, width, height, minPadding) {
        if (!chart) return;
        const padding = (0, _helpersDatasetJs.E)(chart.options.layout.padding);
        const availableWidth = Math.max(width - padding.width, 0);
        const availableHeight = Math.max(height - padding.height, 0);
        const boxes = buildLayoutBoxes(chart.boxes);
        const verticalBoxes = boxes.vertical;
        const horizontalBoxes = boxes.horizontal;
        (0, _helpersDatasetJs.F)(chart.boxes, (box)=>{
            if (typeof box.beforeLayout === 'function') box.beforeLayout();
        });
        const visibleVerticalBoxCount = verticalBoxes.reduce((total, wrap)=>wrap.box.options && wrap.box.options.display === false ? total : total + 1, 0) || 1;
        const params = Object.freeze({
            outerWidth: width,
            outerHeight: height,
            padding,
            availableWidth,
            availableHeight,
            vBoxMaxWidth: availableWidth / 2 / visibleVerticalBoxCount,
            hBoxMaxHeight: availableHeight / 2
        });
        const maxPadding = Object.assign({}, padding);
        updateMaxPadding(maxPadding, (0, _helpersDatasetJs.E)(minPadding));
        const chartArea = Object.assign({
            maxPadding,
            w: availableWidth,
            h: availableHeight,
            x: padding.left,
            y: padding.top
        }, padding);
        const stacks = setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
        fitBoxes(boxes.fullSize, chartArea, params, stacks);
        fitBoxes(verticalBoxes, chartArea, params, stacks);
        if (fitBoxes(horizontalBoxes, chartArea, params, stacks)) fitBoxes(verticalBoxes, chartArea, params, stacks);
        handleMaxPadding(chartArea);
        placeBoxes(boxes.leftAndTop, chartArea, params, stacks);
        chartArea.x += chartArea.w;
        chartArea.y += chartArea.h;
        placeBoxes(boxes.rightAndBottom, chartArea, params, stacks);
        chart.chartArea = {
            left: chartArea.left,
            top: chartArea.top,
            right: chartArea.left + chartArea.w,
            bottom: chartArea.top + chartArea.h,
            height: chartArea.h,
            width: chartArea.w
        };
        (0, _helpersDatasetJs.F)(boxes.chartArea, (layout)=>{
            const box = layout.box;
            Object.assign(box, chart.chartArea);
            box.update(chartArea.w, chartArea.h, {
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            });
        });
    }
};
class BasePlatform {
    acquireContext(canvas, aspectRatio) {}
    releaseContext(context) {
        return false;
    }
    addEventListener(chart, type, listener) {}
    removeEventListener(chart, type, listener) {}
    getDevicePixelRatio() {
        return 1;
    }
    getMaximumSize(element, width, height, aspectRatio) {
        width = Math.max(0, width || element.width);
        height = height || element.height;
        return {
            width,
            height: Math.max(0, aspectRatio ? Math.floor(width / aspectRatio) : height)
        };
    }
    isAttached(canvas) {
        return true;
    }
    updateConfig(config) {}
}
class BasicPlatform extends BasePlatform {
    acquireContext(item) {
        return item && item.getContext && item.getContext('2d') || null;
    }
    updateConfig(config) {
        config.options.animation = false;
    }
}
const EXPANDO_KEY = '$chartjs';
const EVENT_TYPES = {
    touchstart: 'mousedown',
    touchmove: 'mousemove',
    touchend: 'mouseup',
    pointerenter: 'mouseenter',
    pointerdown: 'mousedown',
    pointermove: 'mousemove',
    pointerup: 'mouseup',
    pointerleave: 'mouseout',
    pointerout: 'mouseout'
};
const isNullOrEmpty = (value)=>value === null || value === '';
function initCanvas(canvas, aspectRatio) {
    const style = canvas.style;
    const renderHeight = canvas.getAttribute('height');
    const renderWidth = canvas.getAttribute('width');
    canvas[EXPANDO_KEY] = {
        initial: {
            height: renderHeight,
            width: renderWidth,
            style: {
                display: style.display,
                height: style.height,
                width: style.width
            }
        }
    };
    style.display = style.display || 'block';
    style.boxSizing = style.boxSizing || 'border-box';
    if (isNullOrEmpty(renderWidth)) {
        const displayWidth = (0, _helpersDatasetJs.J)(canvas, 'width');
        if (displayWidth !== undefined) canvas.width = displayWidth;
    }
    if (isNullOrEmpty(renderHeight)) {
        if (canvas.style.height === '') canvas.height = canvas.width / (aspectRatio || 2);
        else {
            const displayHeight = (0, _helpersDatasetJs.J)(canvas, 'height');
            if (displayHeight !== undefined) canvas.height = displayHeight;
        }
    }
    return canvas;
}
const eventListenerOptions = (0, _helpersDatasetJs.K) ? {
    passive: true
} : false;
function addListener(node, type, listener) {
    if (node) node.addEventListener(type, listener, eventListenerOptions);
}
function removeListener(chart, type, listener) {
    if (chart && chart.canvas) chart.canvas.removeEventListener(type, listener, eventListenerOptions);
}
function fromNativeEvent(event, chart) {
    const type = EVENT_TYPES[event.type] || event.type;
    const { x, y } = (0, _helpersDatasetJs.z)(event, chart);
    return {
        type,
        chart,
        native: event,
        x: x !== undefined ? x : null,
        y: y !== undefined ? y : null
    };
}
function nodeListContains(nodeList, canvas) {
    for (const node of nodeList){
        if (node === canvas || node.contains(canvas)) return true;
    }
}
function createAttachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || nodeListContains(entry.addedNodes, canvas);
            trigger = trigger && !nodeListContains(entry.removedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
function createDetachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || nodeListContains(entry.removedNodes, canvas);
            trigger = trigger && !nodeListContains(entry.addedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
const drpListeningCharts = new Map();
let oldDevicePixelRatio = 0;
function onWindowResize() {
    const dpr = window.devicePixelRatio;
    if (dpr === oldDevicePixelRatio) return;
    oldDevicePixelRatio = dpr;
    drpListeningCharts.forEach((resize, chart)=>{
        if (chart.currentDevicePixelRatio !== dpr) resize();
    });
}
function listenDevicePixelRatioChanges(chart, resize) {
    if (!drpListeningCharts.size) window.addEventListener('resize', onWindowResize);
    drpListeningCharts.set(chart, resize);
}
function unlistenDevicePixelRatioChanges(chart) {
    drpListeningCharts.delete(chart);
    if (!drpListeningCharts.size) window.removeEventListener('resize', onWindowResize);
}
function createResizeObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const container = canvas && (0, _helpersDatasetJs.I)(canvas);
    if (!container) return;
    const resize = (0, _helpersDatasetJs.L)((width, height)=>{
        const w = container.clientWidth;
        listener(width, height);
        if (w < container.clientWidth) listener();
    }, window);
    const observer = new ResizeObserver((entries)=>{
        const entry = entries[0];
        const width = entry.contentRect.width;
        const height = entry.contentRect.height;
        if (width === 0 && height === 0) return;
        resize(width, height);
    });
    observer.observe(container);
    listenDevicePixelRatioChanges(chart, resize);
    return observer;
}
function releaseObserver(chart, type, observer) {
    if (observer) observer.disconnect();
    if (type === 'resize') unlistenDevicePixelRatioChanges(chart);
}
function createProxyAndListen(chart, type, listener) {
    const canvas = chart.canvas;
    const proxy = (0, _helpersDatasetJs.L)((event)=>{
        if (chart.ctx !== null) listener(fromNativeEvent(event, chart));
    }, chart);
    addListener(canvas, type, proxy);
    return proxy;
}
class DomPlatform extends BasePlatform {
    acquireContext(canvas, aspectRatio) {
        const context = canvas && canvas.getContext && canvas.getContext('2d');
        if (context && context.canvas === canvas) {
            initCanvas(canvas, aspectRatio);
            return context;
        }
        return null;
    }
    releaseContext(context) {
        const canvas = context.canvas;
        if (!canvas[EXPANDO_KEY]) return false;
        const initial = canvas[EXPANDO_KEY].initial;
        [
            'height',
            'width'
        ].forEach((prop)=>{
            const value = initial[prop];
            if ((0, _helpersDatasetJs.k)(value)) canvas.removeAttribute(prop);
            else canvas.setAttribute(prop, value);
        });
        const style = initial.style || {};
        Object.keys(style).forEach((key)=>{
            canvas.style[key] = style[key];
        });
        canvas.width = canvas.width;
        delete canvas[EXPANDO_KEY];
        return true;
    }
    addEventListener(chart, type, listener) {
        this.removeEventListener(chart, type);
        const proxies = chart.$proxies || (chart.$proxies = {});
        const handlers = {
            attach: createAttachObserver,
            detach: createDetachObserver,
            resize: createResizeObserver
        };
        const handler = handlers[type] || createProxyAndListen;
        proxies[type] = handler(chart, type, listener);
    }
    removeEventListener(chart, type) {
        const proxies = chart.$proxies || (chart.$proxies = {});
        const proxy = proxies[type];
        if (!proxy) return;
        const handlers = {
            attach: releaseObserver,
            detach: releaseObserver,
            resize: releaseObserver
        };
        const handler = handlers[type] || removeListener;
        handler(chart, type, proxy);
        proxies[type] = undefined;
    }
    getDevicePixelRatio() {
        return window.devicePixelRatio;
    }
    getMaximumSize(canvas, width, height, aspectRatio) {
        return (0, _helpersDatasetJs.G)(canvas, width, height, aspectRatio);
    }
    isAttached(canvas) {
        const container = canvas && (0, _helpersDatasetJs.I)(canvas);
        return !!(container && container.isConnected);
    }
}
function _detectPlatform(canvas) {
    if (!(0, _helpersDatasetJs.M)() || typeof OffscreenCanvas !== 'undefined' && canvas instanceof OffscreenCanvas) return BasicPlatform;
    return DomPlatform;
}
class Element {
    static defaults = {};
    static defaultRoutes = undefined;
    x;
    y;
    active = false;
    options;
    $animations;
    tooltipPosition(useFinalPosition) {
        const { x, y } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return {
            x,
            y
        };
    }
    hasValue() {
        return (0, _helpersDatasetJs.x)(this.x) && (0, _helpersDatasetJs.x)(this.y);
    }
    getProps(props, final) {
        const anims = this.$animations;
        if (!final || !anims) // let's not create an object, if not needed
        return this;
        const ret = {};
        props.forEach((prop)=>{
            ret[prop] = anims[prop] && anims[prop].active() ? anims[prop]._to : this[prop];
        });
        return ret;
    }
}
function autoSkip(scale, ticks) {
    const tickOpts = scale.options.ticks;
    const determinedMaxTicks = determineMaxTicks(scale);
    const ticksLimit = Math.min(tickOpts.maxTicksLimit || determinedMaxTicks, determinedMaxTicks);
    const majorIndices = tickOpts.major.enabled ? getMajorIndices(ticks) : [];
    const numMajorIndices = majorIndices.length;
    const first = majorIndices[0];
    const last = majorIndices[numMajorIndices - 1];
    const newTicks = [];
    if (numMajorIndices > ticksLimit) {
        skipMajors(ticks, newTicks, majorIndices, numMajorIndices / ticksLimit);
        return newTicks;
    }
    const spacing = calculateSpacing(majorIndices, ticks, ticksLimit);
    if (numMajorIndices > 0) {
        let i, ilen;
        const avgMajorSpacing = numMajorIndices > 1 ? Math.round((last - first) / (numMajorIndices - 1)) : null;
        skip(ticks, newTicks, spacing, (0, _helpersDatasetJs.k)(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
        for(i = 0, ilen = numMajorIndices - 1; i < ilen; i++)skip(ticks, newTicks, spacing, majorIndices[i], majorIndices[i + 1]);
        skip(ticks, newTicks, spacing, last, (0, _helpersDatasetJs.k)(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
        return newTicks;
    }
    skip(ticks, newTicks, spacing);
    return newTicks;
}
function determineMaxTicks(scale) {
    const offset = scale.options.offset;
    const tickLength = scale._tickSize();
    const maxScale = scale._length / tickLength + (offset ? 0 : 1);
    const maxChart = scale._maxLength / tickLength;
    return Math.floor(Math.min(maxScale, maxChart));
}
function calculateSpacing(majorIndices, ticks, ticksLimit) {
    const evenMajorSpacing = getEvenSpacing(majorIndices);
    const spacing = ticks.length / ticksLimit;
    if (!evenMajorSpacing) return Math.max(spacing, 1);
    const factors = (0, _helpersDatasetJs.N)(evenMajorSpacing);
    for(let i = 0, ilen = factors.length - 1; i < ilen; i++){
        const factor = factors[i];
        if (factor > spacing) return factor;
    }
    return Math.max(spacing, 1);
}
function getMajorIndices(ticks) {
    const result = [];
    let i, ilen;
    for(i = 0, ilen = ticks.length; i < ilen; i++)if (ticks[i].major) result.push(i);
    return result;
}
function skipMajors(ticks, newTicks, majorIndices, spacing) {
    let count = 0;
    let next = majorIndices[0];
    let i;
    spacing = Math.ceil(spacing);
    for(i = 0; i < ticks.length; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = majorIndices[count * spacing];
    }
}
function skip(ticks, newTicks, spacing, majorStart, majorEnd) {
    const start = (0, _helpersDatasetJs.v)(majorStart, 0);
    const end = Math.min((0, _helpersDatasetJs.v)(majorEnd, ticks.length), ticks.length);
    let count = 0;
    let length, i, next;
    spacing = Math.ceil(spacing);
    if (majorEnd) {
        length = majorEnd - majorStart;
        spacing = length / Math.floor(length / spacing);
    }
    next = start;
    while(next < 0){
        count++;
        next = Math.round(start + count * spacing);
    }
    for(i = Math.max(start, 0); i < end; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = Math.round(start + count * spacing);
    }
}
function getEvenSpacing(arr) {
    const len = arr.length;
    let i, diff;
    if (len < 2) return false;
    for(diff = arr[0], i = 1; i < len; ++i){
        if (arr[i] - arr[i - 1] !== diff) return false;
    }
    return diff;
}
const reverseAlign = (align)=>align === 'left' ? 'right' : align === 'right' ? 'left' : align;
const offsetFromEdge = (scale, edge, offset)=>edge === 'top' || edge === 'left' ? scale[edge] + offset : scale[edge] - offset;
const getTicksLimit = (ticksLength, maxTicksLimit)=>Math.min(maxTicksLimit || ticksLength, ticksLength);
function sample(arr, numItems) {
    const result = [];
    const increment = arr.length / numItems;
    const len = arr.length;
    let i = 0;
    for(; i < len; i += increment)result.push(arr[Math.floor(i)]);
    return result;
}
function getPixelForGridLine(scale, index, offsetGridLines) {
    const length = scale.ticks.length;
    const validIndex = Math.min(index, length - 1);
    const start = scale._startPixel;
    const end = scale._endPixel;
    const epsilon = 1e-6;
    let lineValue = scale.getPixelForTick(validIndex);
    let offset;
    if (offsetGridLines) {
        if (length === 1) offset = Math.max(lineValue - start, end - lineValue);
        else if (index === 0) offset = (scale.getPixelForTick(1) - lineValue) / 2;
        else offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
        lineValue += validIndex < index ? offset : -offset;
        if (lineValue < start - epsilon || lineValue > end + epsilon) return;
    }
    return lineValue;
}
function garbageCollect(caches, length) {
    (0, _helpersDatasetJs.F)(caches, (cache)=>{
        const gc = cache.gc;
        const gcLen = gc.length / 2;
        let i;
        if (gcLen > length) {
            for(i = 0; i < gcLen; ++i)delete cache.data[gc[i]];
            gc.splice(0, gcLen);
        }
    });
}
function getTickMarkLength(options) {
    return options.drawTicks ? options.tickLength : 0;
}
function getTitleHeight(options, fallback) {
    if (!options.display) return 0;
    const font = (0, _helpersDatasetJs.a0)(options.font, fallback);
    const padding = (0, _helpersDatasetJs.E)(options.padding);
    const lines = (0, _helpersDatasetJs.b)(options.text) ? options.text.length : 1;
    return lines * font.lineHeight + padding.height;
}
function createScaleContext(parent, scale) {
    return (0, _helpersDatasetJs.j)(parent, {
        scale,
        type: 'scale'
    });
}
function createTickContext(parent, index, tick) {
    return (0, _helpersDatasetJs.j)(parent, {
        tick,
        index,
        type: 'tick'
    });
}
function titleAlign(align, position, reverse) {
    let ret = (0, _helpersDatasetJs.a1)(align);
    if (reverse && position !== 'right' || !reverse && position === 'right') ret = reverseAlign(ret);
    return ret;
}
function titleArgs(scale, offset, position, align) {
    const { top, left, bottom, right, chart } = scale;
    const { chartArea, scales } = chart;
    let rotation = 0;
    let maxWidth, titleX, titleY;
    const height = bottom - top;
    const width = right - left;
    if (scale.isHorizontal()) {
        titleX = (0, _helpersDatasetJs.a2)(align, left, right);
        if ((0, _helpersDatasetJs.i)(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleY = scales[positionAxisID].getPixelForValue(value) + height - offset;
        } else if (position === 'center') titleY = (chartArea.bottom + chartArea.top) / 2 + height - offset;
        else titleY = offsetFromEdge(scale, position, offset);
        maxWidth = right - left;
    } else {
        if ((0, _helpersDatasetJs.i)(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleX = scales[positionAxisID].getPixelForValue(value) - width + offset;
        } else if (position === 'center') titleX = (chartArea.left + chartArea.right) / 2 - width + offset;
        else titleX = offsetFromEdge(scale, position, offset);
        titleY = (0, _helpersDatasetJs.a2)(align, bottom, top);
        rotation = position === 'left' ? -(0, _helpersDatasetJs.H) : (0, _helpersDatasetJs.H);
    }
    return {
        titleX,
        titleY,
        maxWidth,
        rotation
    };
}
class Scale extends Element {
    constructor(cfg){
        super();
        this.id = cfg.id;
        this.type = cfg.type;
        this.options = undefined;
        this.ctx = cfg.ctx;
        this.chart = cfg.chart;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this._margins = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        };
        this.maxWidth = undefined;
        this.maxHeight = undefined;
        this.paddingTop = undefined;
        this.paddingBottom = undefined;
        this.paddingLeft = undefined;
        this.paddingRight = undefined;
        this.axis = undefined;
        this.labelRotation = undefined;
        this.min = undefined;
        this.max = undefined;
        this._range = undefined;
        this.ticks = [];
        this._gridLineItems = null;
        this._labelItems = null;
        this._labelSizes = null;
        this._length = 0;
        this._maxLength = 0;
        this._longestTextCache = {};
        this._startPixel = undefined;
        this._endPixel = undefined;
        this._reversePixels = false;
        this._userMax = undefined;
        this._userMin = undefined;
        this._suggestedMax = undefined;
        this._suggestedMin = undefined;
        this._ticksLength = 0;
        this._borderValue = 0;
        this._cache = {};
        this._dataLimitsCached = false;
        this.$context = undefined;
    }
    init(options) {
        this.options = options.setContext(this.getContext());
        this.axis = options.axis;
        this._userMin = this.parse(options.min);
        this._userMax = this.parse(options.max);
        this._suggestedMin = this.parse(options.suggestedMin);
        this._suggestedMax = this.parse(options.suggestedMax);
    }
    parse(raw, index) {
        return raw;
    }
    getUserBounds() {
        let { _userMin, _userMax, _suggestedMin, _suggestedMax } = this;
        _userMin = (0, _helpersDatasetJs.O)(_userMin, Number.POSITIVE_INFINITY);
        _userMax = (0, _helpersDatasetJs.O)(_userMax, Number.NEGATIVE_INFINITY);
        _suggestedMin = (0, _helpersDatasetJs.O)(_suggestedMin, Number.POSITIVE_INFINITY);
        _suggestedMax = (0, _helpersDatasetJs.O)(_suggestedMax, Number.NEGATIVE_INFINITY);
        return {
            min: (0, _helpersDatasetJs.O)(_userMin, _suggestedMin),
            max: (0, _helpersDatasetJs.O)(_userMax, _suggestedMax),
            minDefined: (0, _helpersDatasetJs.g)(_userMin),
            maxDefined: (0, _helpersDatasetJs.g)(_userMax)
        };
    }
    getMinMax(canStack) {
        let { min, max, minDefined, maxDefined } = this.getUserBounds();
        let range;
        if (minDefined && maxDefined) return {
            min,
            max
        };
        const metas = this.getMatchingVisibleMetas();
        for(let i = 0, ilen = metas.length; i < ilen; ++i){
            range = metas[i].controller.getMinMax(this, canStack);
            if (!minDefined) min = Math.min(min, range.min);
            if (!maxDefined) max = Math.max(max, range.max);
        }
        min = maxDefined && min > max ? max : min;
        max = minDefined && min > max ? min : max;
        return {
            min: (0, _helpersDatasetJs.O)(min, (0, _helpersDatasetJs.O)(max, min)),
            max: (0, _helpersDatasetJs.O)(max, (0, _helpersDatasetJs.O)(min, max))
        };
    }
    getPadding() {
        return {
            left: this.paddingLeft || 0,
            top: this.paddingTop || 0,
            right: this.paddingRight || 0,
            bottom: this.paddingBottom || 0
        };
    }
    getTicks() {
        return this.ticks;
    }
    getLabels() {
        const data = this.chart.data;
        return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
    }
    getLabelItems(chartArea = this.chart.chartArea) {
        const items = this._labelItems || (this._labelItems = this._computeLabelItems(chartArea));
        return items;
    }
    beforeLayout() {
        this._cache = {};
        this._dataLimitsCached = false;
    }
    beforeUpdate() {
        (0, _helpersDatasetJs.Q)(this.options.beforeUpdate, [
            this
        ]);
    }
    update(maxWidth, maxHeight, margins) {
        const { beginAtZero, grace, ticks: tickOpts } = this.options;
        const sampleSize = tickOpts.sampleSize;
        this.beforeUpdate();
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins = Object.assign({
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        }, margins);
        this.ticks = null;
        this._labelSizes = null;
        this._gridLineItems = null;
        this._labelItems = null;
        this.beforeSetDimensions();
        this.setDimensions();
        this.afterSetDimensions();
        this._maxLength = this.isHorizontal() ? this.width + margins.left + margins.right : this.height + margins.top + margins.bottom;
        if (!this._dataLimitsCached) {
            this.beforeDataLimits();
            this.determineDataLimits();
            this.afterDataLimits();
            this._range = (0, _helpersDatasetJs.R)(this, grace, beginAtZero);
            this._dataLimitsCached = true;
        }
        this.beforeBuildTicks();
        this.ticks = this.buildTicks() || [];
        this.afterBuildTicks();
        const samplingEnabled = sampleSize < this.ticks.length;
        this._convertTicksToLabels(samplingEnabled ? sample(this.ticks, sampleSize) : this.ticks);
        this.configure();
        this.beforeCalculateLabelRotation();
        this.calculateLabelRotation();
        this.afterCalculateLabelRotation();
        if (tickOpts.display && (tickOpts.autoSkip || tickOpts.source === 'auto')) {
            this.ticks = autoSkip(this, this.ticks);
            this._labelSizes = null;
            this.afterAutoSkip();
        }
        if (samplingEnabled) this._convertTicksToLabels(this.ticks);
        this.beforeFit();
        this.fit();
        this.afterFit();
        this.afterUpdate();
    }
    configure() {
        let reversePixels = this.options.reverse;
        let startPixel, endPixel;
        if (this.isHorizontal()) {
            startPixel = this.left;
            endPixel = this.right;
        } else {
            startPixel = this.top;
            endPixel = this.bottom;
            reversePixels = !reversePixels;
        }
        this._startPixel = startPixel;
        this._endPixel = endPixel;
        this._reversePixels = reversePixels;
        this._length = endPixel - startPixel;
        this._alignToPixels = this.options.alignToPixels;
    }
    afterUpdate() {
        (0, _helpersDatasetJs.Q)(this.options.afterUpdate, [
            this
        ]);
    }
    beforeSetDimensions() {
        (0, _helpersDatasetJs.Q)(this.options.beforeSetDimensions, [
            this
        ]);
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = 0;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = 0;
            this.bottom = this.height;
        }
        this.paddingLeft = 0;
        this.paddingTop = 0;
        this.paddingRight = 0;
        this.paddingBottom = 0;
    }
    afterSetDimensions() {
        (0, _helpersDatasetJs.Q)(this.options.afterSetDimensions, [
            this
        ]);
    }
    _callHooks(name) {
        this.chart.notifyPlugins(name, this.getContext());
        (0, _helpersDatasetJs.Q)(this.options[name], [
            this
        ]);
    }
    beforeDataLimits() {
        this._callHooks('beforeDataLimits');
    }
    determineDataLimits() {}
    afterDataLimits() {
        this._callHooks('afterDataLimits');
    }
    beforeBuildTicks() {
        this._callHooks('beforeBuildTicks');
    }
    buildTicks() {
        return [];
    }
    afterBuildTicks() {
        this._callHooks('afterBuildTicks');
    }
    beforeTickToLabelConversion() {
        (0, _helpersDatasetJs.Q)(this.options.beforeTickToLabelConversion, [
            this
        ]);
    }
    generateTickLabels(ticks) {
        const tickOpts = this.options.ticks;
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; i++){
            tick = ticks[i];
            tick.label = (0, _helpersDatasetJs.Q)(tickOpts.callback, [
                tick.value,
                i,
                ticks
            ], this);
        }
    }
    afterTickToLabelConversion() {
        (0, _helpersDatasetJs.Q)(this.options.afterTickToLabelConversion, [
            this
        ]);
    }
    beforeCalculateLabelRotation() {
        (0, _helpersDatasetJs.Q)(this.options.beforeCalculateLabelRotation, [
            this
        ]);
    }
    calculateLabelRotation() {
        const options = this.options;
        const tickOpts = options.ticks;
        const numTicks = getTicksLimit(this.ticks.length, options.ticks.maxTicksLimit);
        const minRotation = tickOpts.minRotation || 0;
        const maxRotation = tickOpts.maxRotation;
        let labelRotation = minRotation;
        let tickWidth, maxHeight, maxLabelDiagonal;
        if (!this._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !this.isHorizontal()) {
            this.labelRotation = minRotation;
            return;
        }
        const labelSizes = this._getLabelSizes();
        const maxLabelWidth = labelSizes.widest.width;
        const maxLabelHeight = labelSizes.highest.height;
        const maxWidth = (0, _helpersDatasetJs.S)(this.chart.width - maxLabelWidth, 0, this.maxWidth);
        tickWidth = options.offset ? this.maxWidth / numTicks : maxWidth / (numTicks - 1);
        if (maxLabelWidth + 6 > tickWidth) {
            tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
            maxHeight = this.maxHeight - getTickMarkLength(options.grid) - tickOpts.padding - getTitleHeight(options.title, this.chart.options.font);
            maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
            labelRotation = (0, _helpersDatasetJs.U)(Math.min(Math.asin((0, _helpersDatasetJs.S)((labelSizes.highest.height + 6) / tickWidth, -1, 1)), Math.asin((0, _helpersDatasetJs.S)(maxHeight / maxLabelDiagonal, -1, 1)) - Math.asin((0, _helpersDatasetJs.S)(maxLabelHeight / maxLabelDiagonal, -1, 1))));
            labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
        }
        this.labelRotation = labelRotation;
    }
    afterCalculateLabelRotation() {
        (0, _helpersDatasetJs.Q)(this.options.afterCalculateLabelRotation, [
            this
        ]);
    }
    afterAutoSkip() {}
    beforeFit() {
        (0, _helpersDatasetJs.Q)(this.options.beforeFit, [
            this
        ]);
    }
    fit() {
        const minSize = {
            width: 0,
            height: 0
        };
        const { chart, options: { ticks: tickOpts, title: titleOpts, grid: gridOpts } } = this;
        const display = this._isVisible();
        const isHorizontal = this.isHorizontal();
        if (display) {
            const titleHeight = getTitleHeight(titleOpts, chart.options.font);
            if (isHorizontal) {
                minSize.width = this.maxWidth;
                minSize.height = getTickMarkLength(gridOpts) + titleHeight;
            } else {
                minSize.height = this.maxHeight;
                minSize.width = getTickMarkLength(gridOpts) + titleHeight;
            }
            if (tickOpts.display && this.ticks.length) {
                const { first, last, widest, highest } = this._getLabelSizes();
                const tickPadding = tickOpts.padding * 2;
                const angleRadians = (0, _helpersDatasetJs.t)(this.labelRotation);
                const cos = Math.cos(angleRadians);
                const sin = Math.sin(angleRadians);
                if (isHorizontal) {
                    const labelHeight = tickOpts.mirror ? 0 : sin * widest.width + cos * highest.height;
                    minSize.height = Math.min(this.maxHeight, minSize.height + labelHeight + tickPadding);
                } else {
                    const labelWidth = tickOpts.mirror ? 0 : cos * widest.width + sin * highest.height;
                    minSize.width = Math.min(this.maxWidth, minSize.width + labelWidth + tickPadding);
                }
                this._calculatePadding(first, last, sin, cos);
            }
        }
        this._handleMargins();
        if (isHorizontal) {
            this.width = this._length = chart.width - this._margins.left - this._margins.right;
            this.height = minSize.height;
        } else {
            this.width = minSize.width;
            this.height = this._length = chart.height - this._margins.top - this._margins.bottom;
        }
    }
    _calculatePadding(first, last, sin, cos) {
        const { ticks: { align, padding }, position } = this.options;
        const isRotated = this.labelRotation !== 0;
        const labelsBelowTicks = position !== 'top' && this.axis === 'x';
        if (this.isHorizontal()) {
            const offsetLeft = this.getPixelForTick(0) - this.left;
            const offsetRight = this.right - this.getPixelForTick(this.ticks.length - 1);
            let paddingLeft = 0;
            let paddingRight = 0;
            if (isRotated) {
                if (labelsBelowTicks) {
                    paddingLeft = cos * first.width;
                    paddingRight = sin * last.height;
                } else {
                    paddingLeft = sin * first.height;
                    paddingRight = cos * last.width;
                }
            } else if (align === 'start') paddingRight = last.width;
            else if (align === 'end') paddingLeft = first.width;
            else if (align !== 'inner') {
                paddingLeft = first.width / 2;
                paddingRight = last.width / 2;
            }
            this.paddingLeft = Math.max((paddingLeft - offsetLeft + padding) * this.width / (this.width - offsetLeft), 0);
            this.paddingRight = Math.max((paddingRight - offsetRight + padding) * this.width / (this.width - offsetRight), 0);
        } else {
            let paddingTop = last.height / 2;
            let paddingBottom = first.height / 2;
            if (align === 'start') {
                paddingTop = 0;
                paddingBottom = first.height;
            } else if (align === 'end') {
                paddingTop = last.height;
                paddingBottom = 0;
            }
            this.paddingTop = paddingTop + padding;
            this.paddingBottom = paddingBottom + padding;
        }
    }
    _handleMargins() {
        if (this._margins) {
            this._margins.left = Math.max(this.paddingLeft, this._margins.left);
            this._margins.top = Math.max(this.paddingTop, this._margins.top);
            this._margins.right = Math.max(this.paddingRight, this._margins.right);
            this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom);
        }
    }
    afterFit() {
        (0, _helpersDatasetJs.Q)(this.options.afterFit, [
            this
        ]);
    }
    isHorizontal() {
        const { axis, position } = this.options;
        return position === 'top' || position === 'bottom' || axis === 'x';
    }
    isFullSize() {
        return this.options.fullSize;
    }
    _convertTicksToLabels(ticks) {
        this.beforeTickToLabelConversion();
        this.generateTickLabels(ticks);
        let i, ilen;
        for(i = 0, ilen = ticks.length; i < ilen; i++)if ((0, _helpersDatasetJs.k)(ticks[i].label)) {
            ticks.splice(i, 1);
            ilen--;
            i--;
        }
        this.afterTickToLabelConversion();
    }
    _getLabelSizes() {
        let labelSizes = this._labelSizes;
        if (!labelSizes) {
            const sampleSize = this.options.ticks.sampleSize;
            let ticks = this.ticks;
            if (sampleSize < ticks.length) ticks = sample(ticks, sampleSize);
            this._labelSizes = labelSizes = this._computeLabelSizes(ticks, ticks.length, this.options.ticks.maxTicksLimit);
        }
        return labelSizes;
    }
    _computeLabelSizes(ticks, length, maxTicksLimit) {
        const { ctx, _longestTextCache: caches } = this;
        const widths = [];
        const heights = [];
        const increment = Math.floor(length / getTicksLimit(length, maxTicksLimit));
        let widestLabelSize = 0;
        let highestLabelSize = 0;
        let i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel;
        for(i = 0; i < length; i += increment){
            label = ticks[i].label;
            tickFont = this._resolveTickFontOptions(i);
            ctx.font = fontString = tickFont.string;
            cache = caches[fontString] = caches[fontString] || {
                data: {},
                gc: []
            };
            lineHeight = tickFont.lineHeight;
            width = height = 0;
            if (!(0, _helpersDatasetJs.k)(label) && !(0, _helpersDatasetJs.b)(label)) {
                width = (0, _helpersDatasetJs.V)(ctx, cache.data, cache.gc, width, label);
                height = lineHeight;
            } else if ((0, _helpersDatasetJs.b)(label)) for(j = 0, jlen = label.length; j < jlen; ++j){
                nestedLabel = label[j];
                if (!(0, _helpersDatasetJs.k)(nestedLabel) && !(0, _helpersDatasetJs.b)(nestedLabel)) {
                    width = (0, _helpersDatasetJs.V)(ctx, cache.data, cache.gc, width, nestedLabel);
                    height += lineHeight;
                }
            }
            widths.push(width);
            heights.push(height);
            widestLabelSize = Math.max(width, widestLabelSize);
            highestLabelSize = Math.max(height, highestLabelSize);
        }
        garbageCollect(caches, length);
        const widest = widths.indexOf(widestLabelSize);
        const highest = heights.indexOf(highestLabelSize);
        const valueAt = (idx)=>({
                width: widths[idx] || 0,
                height: heights[idx] || 0
            });
        return {
            first: valueAt(0),
            last: valueAt(length - 1),
            widest: valueAt(widest),
            highest: valueAt(highest),
            widths,
            heights
        };
    }
    getLabelForValue(value) {
        return value;
    }
    getPixelForValue(value, index) {
        return NaN;
    }
    getValueForPixel(pixel) {}
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getPixelForDecimal(decimal) {
        if (this._reversePixels) decimal = 1 - decimal;
        const pixel = this._startPixel + decimal * this._length;
        return (0, _helpersDatasetJs.W)(this._alignToPixels ? (0, _helpersDatasetJs.X)(this.chart, pixel, 0) : pixel);
    }
    getDecimalForPixel(pixel) {
        const decimal = (pixel - this._startPixel) / this._length;
        return this._reversePixels ? 1 - decimal : decimal;
    }
    getBasePixel() {
        return this.getPixelForValue(this.getBaseValue());
    }
    getBaseValue() {
        const { min, max } = this;
        return min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0;
    }
    getContext(index) {
        const ticks = this.ticks || [];
        if (index >= 0 && index < ticks.length) {
            const tick = ticks[index];
            return tick.$context || (tick.$context = createTickContext(this.getContext(), index, tick));
        }
        return this.$context || (this.$context = createScaleContext(this.chart.getContext(), this));
    }
    _tickSize() {
        const optionTicks = this.options.ticks;
        const rot = (0, _helpersDatasetJs.t)(this.labelRotation);
        const cos = Math.abs(Math.cos(rot));
        const sin = Math.abs(Math.sin(rot));
        const labelSizes = this._getLabelSizes();
        const padding = optionTicks.autoSkipPadding || 0;
        const w = labelSizes ? labelSizes.widest.width + padding : 0;
        const h = labelSizes ? labelSizes.highest.height + padding : 0;
        return this.isHorizontal() ? h * cos > w * sin ? w / cos : h / sin : h * sin < w * cos ? h / cos : w / sin;
    }
    _isVisible() {
        const display = this.options.display;
        if (display !== 'auto') return !!display;
        return this.getMatchingVisibleMetas().length > 0;
    }
    _computeGridLineItems(chartArea) {
        const axis = this.axis;
        const chart = this.chart;
        const options = this.options;
        const { grid, position, border } = options;
        const offset = grid.offset;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const ticksLength = ticks.length + (offset ? 1 : 0);
        const tl = getTickMarkLength(grid);
        const items = [];
        const borderOpts = border.setContext(this.getContext());
        const axisWidth = borderOpts.display ? borderOpts.width : 0;
        const axisHalfWidth = axisWidth / 2;
        const alignBorderValue = function(pixel) {
            return (0, _helpersDatasetJs.X)(chart, pixel, axisWidth);
        };
        let borderValue, i, lineValue, alignedLineValue;
        let tx1, ty1, tx2, ty2, x1, y1, x2, y2;
        if (position === 'top') {
            borderValue = alignBorderValue(this.bottom);
            ty1 = this.bottom - tl;
            ty2 = borderValue - axisHalfWidth;
            y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
            y2 = chartArea.bottom;
        } else if (position === 'bottom') {
            borderValue = alignBorderValue(this.top);
            y1 = chartArea.top;
            y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
            ty1 = borderValue + axisHalfWidth;
            ty2 = this.top + tl;
        } else if (position === 'left') {
            borderValue = alignBorderValue(this.right);
            tx1 = this.right - tl;
            tx2 = borderValue - axisHalfWidth;
            x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
            x2 = chartArea.right;
        } else if (position === 'right') {
            borderValue = alignBorderValue(this.left);
            x1 = chartArea.left;
            x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
            tx1 = borderValue + axisHalfWidth;
            tx2 = this.left + tl;
        } else if (axis === 'x') {
            if (position === 'center') borderValue = alignBorderValue((chartArea.top + chartArea.bottom) / 2 + 0.5);
            else if ((0, _helpersDatasetJs.i)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            y1 = chartArea.top;
            y2 = chartArea.bottom;
            ty1 = borderValue + axisHalfWidth;
            ty2 = ty1 + tl;
        } else if (axis === 'y') {
            if (position === 'center') borderValue = alignBorderValue((chartArea.left + chartArea.right) / 2);
            else if ((0, _helpersDatasetJs.i)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            tx1 = borderValue - axisHalfWidth;
            tx2 = tx1 - tl;
            x1 = chartArea.left;
            x2 = chartArea.right;
        }
        const limit = (0, _helpersDatasetJs.v)(options.ticks.maxTicksLimit, ticksLength);
        const step = Math.max(1, Math.ceil(ticksLength / limit));
        for(i = 0; i < ticksLength; i += step){
            const context = this.getContext(i);
            const optsAtIndex = grid.setContext(context);
            const optsAtIndexBorder = border.setContext(context);
            const lineWidth = optsAtIndex.lineWidth;
            const lineColor = optsAtIndex.color;
            const borderDash = optsAtIndexBorder.dash || [];
            const borderDashOffset = optsAtIndexBorder.dashOffset;
            const tickWidth = optsAtIndex.tickWidth;
            const tickColor = optsAtIndex.tickColor;
            const tickBorderDash = optsAtIndex.tickBorderDash || [];
            const tickBorderDashOffset = optsAtIndex.tickBorderDashOffset;
            lineValue = getPixelForGridLine(this, i, offset);
            if (lineValue === undefined) continue;
            alignedLineValue = (0, _helpersDatasetJs.X)(chart, lineValue, lineWidth);
            if (isHorizontal) tx1 = tx2 = x1 = x2 = alignedLineValue;
            else ty1 = ty2 = y1 = y2 = alignedLineValue;
            items.push({
                tx1,
                ty1,
                tx2,
                ty2,
                x1,
                y1,
                x2,
                y2,
                width: lineWidth,
                color: lineColor,
                borderDash,
                borderDashOffset,
                tickWidth,
                tickColor,
                tickBorderDash,
                tickBorderDashOffset
            });
        }
        this._ticksLength = ticksLength;
        this._borderValue = borderValue;
        return items;
    }
    _computeLabelItems(chartArea) {
        const axis = this.axis;
        const options = this.options;
        const { position, ticks: optionTicks } = options;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const { align, crossAlign, padding, mirror } = optionTicks;
        const tl = getTickMarkLength(options.grid);
        const tickAndPadding = tl + padding;
        const hTickAndPadding = mirror ? -padding : tickAndPadding;
        const rotation = -(0, _helpersDatasetJs.t)(this.labelRotation);
        const items = [];
        let i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
        let textBaseline = 'middle';
        if (position === 'top') {
            y = this.bottom - hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === 'bottom') {
            y = this.top + hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === 'left') {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (position === 'right') {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (axis === 'x') {
            if (position === 'center') y = (chartArea.top + chartArea.bottom) / 2 + tickAndPadding;
            else if ((0, _helpersDatasetJs.i)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                y = this.chart.scales[positionAxisID].getPixelForValue(value) + tickAndPadding;
            }
            textAlign = this._getXAxisLabelAlignment();
        } else if (axis === 'y') {
            if (position === 'center') x = (chartArea.left + chartArea.right) / 2 - tickAndPadding;
            else if ((0, _helpersDatasetJs.i)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                x = this.chart.scales[positionAxisID].getPixelForValue(value);
            }
            textAlign = this._getYAxisLabelAlignment(tl).textAlign;
        }
        if (axis === 'y') {
            if (align === 'start') textBaseline = 'top';
            else if (align === 'end') textBaseline = 'bottom';
        }
        const labelSizes = this._getLabelSizes();
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            label = tick.label;
            const optsAtIndex = optionTicks.setContext(this.getContext(i));
            pixel = this.getPixelForTick(i) + optionTicks.labelOffset;
            font = this._resolveTickFontOptions(i);
            lineHeight = font.lineHeight;
            lineCount = (0, _helpersDatasetJs.b)(label) ? label.length : 1;
            const halfCount = lineCount / 2;
            const color = optsAtIndex.color;
            const strokeColor = optsAtIndex.textStrokeColor;
            const strokeWidth = optsAtIndex.textStrokeWidth;
            let tickTextAlign = textAlign;
            if (isHorizontal) {
                x = pixel;
                if (textAlign === 'inner') {
                    if (i === ilen - 1) tickTextAlign = !this.options.reverse ? 'right' : 'left';
                    else if (i === 0) tickTextAlign = !this.options.reverse ? 'left' : 'right';
                    else tickTextAlign = 'center';
                }
                if (position === 'top') {
                    if (crossAlign === 'near' || rotation !== 0) textOffset = -lineCount * lineHeight + lineHeight / 2;
                    else if (crossAlign === 'center') textOffset = -labelSizes.highest.height / 2 - halfCount * lineHeight + lineHeight;
                    else textOffset = -labelSizes.highest.height + lineHeight / 2;
                } else {
                    if (crossAlign === 'near' || rotation !== 0) textOffset = lineHeight / 2;
                    else if (crossAlign === 'center') textOffset = labelSizes.highest.height / 2 - halfCount * lineHeight;
                    else textOffset = labelSizes.highest.height - lineCount * lineHeight;
                }
                if (mirror) textOffset *= -1;
                if (rotation !== 0 && !optsAtIndex.showLabelBackdrop) x += lineHeight / 2 * Math.sin(rotation);
            } else {
                y = pixel;
                textOffset = (1 - lineCount) * lineHeight / 2;
            }
            let backdrop;
            if (optsAtIndex.showLabelBackdrop) {
                const labelPadding = (0, _helpersDatasetJs.E)(optsAtIndex.backdropPadding);
                const height = labelSizes.heights[i];
                const width = labelSizes.widths[i];
                let top = textOffset - labelPadding.top;
                let left = 0 - labelPadding.left;
                switch(textBaseline){
                    case 'middle':
                        top -= height / 2;
                        break;
                    case 'bottom':
                        top -= height;
                        break;
                }
                switch(textAlign){
                    case 'center':
                        left -= width / 2;
                        break;
                    case 'right':
                        left -= width;
                        break;
                    case 'inner':
                        if (i === ilen - 1) left -= width;
                        else if (i > 0) left -= width / 2;
                        break;
                }
                backdrop = {
                    left,
                    top,
                    width: width + labelPadding.width,
                    height: height + labelPadding.height,
                    color: optsAtIndex.backdropColor
                };
            }
            items.push({
                label,
                font,
                textOffset,
                options: {
                    rotation,
                    color,
                    strokeColor,
                    strokeWidth,
                    textAlign: tickTextAlign,
                    textBaseline,
                    translation: [
                        x,
                        y
                    ],
                    backdrop
                }
            });
        }
        return items;
    }
    _getXAxisLabelAlignment() {
        const { position, ticks } = this.options;
        const rotation = -(0, _helpersDatasetJs.t)(this.labelRotation);
        if (rotation) return position === 'top' ? 'left' : 'right';
        let align = 'center';
        if (ticks.align === 'start') align = 'left';
        else if (ticks.align === 'end') align = 'right';
        else if (ticks.align === 'inner') align = 'inner';
        return align;
    }
    _getYAxisLabelAlignment(tl) {
        const { position, ticks: { crossAlign, mirror, padding } } = this.options;
        const labelSizes = this._getLabelSizes();
        const tickAndPadding = tl + padding;
        const widest = labelSizes.widest.width;
        let textAlign;
        let x;
        if (position === 'left') {
            if (mirror) {
                x = this.right + padding;
                if (crossAlign === 'near') textAlign = 'left';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x += widest / 2;
                } else {
                    textAlign = 'right';
                    x += widest;
                }
            } else {
                x = this.right - tickAndPadding;
                if (crossAlign === 'near') textAlign = 'right';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x -= widest / 2;
                } else {
                    textAlign = 'left';
                    x = this.left;
                }
            }
        } else if (position === 'right') {
            if (mirror) {
                x = this.left + padding;
                if (crossAlign === 'near') textAlign = 'right';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x -= widest / 2;
                } else {
                    textAlign = 'left';
                    x -= widest;
                }
            } else {
                x = this.left + tickAndPadding;
                if (crossAlign === 'near') textAlign = 'left';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x += widest / 2;
                } else {
                    textAlign = 'right';
                    x = this.right;
                }
            }
        } else textAlign = 'right';
        return {
            textAlign,
            x
        };
    }
    _computeLabelArea() {
        if (this.options.ticks.mirror) return;
        const chart = this.chart;
        const position = this.options.position;
        if (position === 'left' || position === 'right') return {
            top: 0,
            left: this.left,
            bottom: chart.height,
            right: this.right
        };
        if (position === 'top' || position === 'bottom') return {
            top: this.top,
            left: 0,
            bottom: this.bottom,
            right: chart.width
        };
    }
    drawBackground() {
        const { ctx, options: { backgroundColor }, left, top, width, height } = this;
        if (backgroundColor) {
            ctx.save();
            ctx.fillStyle = backgroundColor;
            ctx.fillRect(left, top, width, height);
            ctx.restore();
        }
    }
    getLineWidthForValue(value) {
        const grid = this.options.grid;
        if (!this._isVisible() || !grid.display) return 0;
        const ticks = this.ticks;
        const index = ticks.findIndex((t)=>t.value === value);
        if (index >= 0) {
            const opts = grid.setContext(this.getContext(index));
            return opts.lineWidth;
        }
        return 0;
    }
    drawGrid(chartArea) {
        const grid = this.options.grid;
        const ctx = this.ctx;
        const items = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(chartArea));
        let i, ilen;
        const drawLine = (p1, p2, style)=>{
            if (!style.width || !style.color) return;
            ctx.save();
            ctx.lineWidth = style.width;
            ctx.strokeStyle = style.color;
            ctx.setLineDash(style.borderDash || []);
            ctx.lineDashOffset = style.borderDashOffset;
            ctx.beginPath();
            ctx.moveTo(p1.x, p1.y);
            ctx.lineTo(p2.x, p2.y);
            ctx.stroke();
            ctx.restore();
        };
        if (grid.display) for(i = 0, ilen = items.length; i < ilen; ++i){
            const item = items[i];
            if (grid.drawOnChartArea) drawLine({
                x: item.x1,
                y: item.y1
            }, {
                x: item.x2,
                y: item.y2
            }, item);
            if (grid.drawTicks) drawLine({
                x: item.tx1,
                y: item.ty1
            }, {
                x: item.tx2,
                y: item.ty2
            }, {
                color: item.tickColor,
                width: item.tickWidth,
                borderDash: item.tickBorderDash,
                borderDashOffset: item.tickBorderDashOffset
            });
        }
    }
    drawBorder() {
        const { chart, ctx, options: { border, grid } } = this;
        const borderOpts = border.setContext(this.getContext());
        const axisWidth = border.display ? borderOpts.width : 0;
        if (!axisWidth) return;
        const lastLineWidth = grid.setContext(this.getContext(0)).lineWidth;
        const borderValue = this._borderValue;
        let x1, x2, y1, y2;
        if (this.isHorizontal()) {
            x1 = (0, _helpersDatasetJs.X)(chart, this.left, axisWidth) - axisWidth / 2;
            x2 = (0, _helpersDatasetJs.X)(chart, this.right, lastLineWidth) + lastLineWidth / 2;
            y1 = y2 = borderValue;
        } else {
            y1 = (0, _helpersDatasetJs.X)(chart, this.top, axisWidth) - axisWidth / 2;
            y2 = (0, _helpersDatasetJs.X)(chart, this.bottom, lastLineWidth) + lastLineWidth / 2;
            x1 = x2 = borderValue;
        }
        ctx.save();
        ctx.lineWidth = borderOpts.width;
        ctx.strokeStyle = borderOpts.color;
        ctx.beginPath();
        ctx.moveTo(x1, y1);
        ctx.lineTo(x2, y2);
        ctx.stroke();
        ctx.restore();
    }
    drawLabels(chartArea) {
        const optionTicks = this.options.ticks;
        if (!optionTicks.display) return;
        const ctx = this.ctx;
        const area = this._computeLabelArea();
        if (area) (0, _helpersDatasetJs.Y)(ctx, area);
        const items = this.getLabelItems(chartArea);
        for (const item of items){
            const renderTextOptions = item.options;
            const tickFont = item.font;
            const label = item.label;
            const y = item.textOffset;
            (0, _helpersDatasetJs.Z)(ctx, label, 0, y, tickFont, renderTextOptions);
        }
        if (area) (0, _helpersDatasetJs.$)(ctx);
    }
    drawTitle() {
        const { ctx, options: { position, title, reverse } } = this;
        if (!title.display) return;
        const font = (0, _helpersDatasetJs.a0)(title.font);
        const padding = (0, _helpersDatasetJs.E)(title.padding);
        const align = title.align;
        let offset = font.lineHeight / 2;
        if (position === 'bottom' || position === 'center' || (0, _helpersDatasetJs.i)(position)) {
            offset += padding.bottom;
            if ((0, _helpersDatasetJs.b)(title.text)) offset += font.lineHeight * (title.text.length - 1);
        } else offset += padding.top;
        const { titleX, titleY, maxWidth, rotation } = titleArgs(this, offset, position, align);
        (0, _helpersDatasetJs.Z)(ctx, title.text, 0, 0, font, {
            color: title.color,
            maxWidth,
            rotation,
            textAlign: titleAlign(align, position, reverse),
            textBaseline: 'middle',
            translation: [
                titleX,
                titleY
            ]
        });
    }
    draw(chartArea) {
        if (!this._isVisible()) return;
        this.drawBackground();
        this.drawGrid(chartArea);
        this.drawBorder();
        this.drawTitle();
        this.drawLabels(chartArea);
    }
    _layers() {
        const opts = this.options;
        const tz = opts.ticks && opts.ticks.z || 0;
        const gz = (0, _helpersDatasetJs.v)(opts.grid && opts.grid.z, -1);
        const bz = (0, _helpersDatasetJs.v)(opts.border && opts.border.z, 0);
        if (!this._isVisible() || this.draw !== Scale.prototype.draw) return [
            {
                z: tz,
                draw: (chartArea)=>{
                    this.draw(chartArea);
                }
            }
        ];
        return [
            {
                z: gz,
                draw: (chartArea)=>{
                    this.drawBackground();
                    this.drawGrid(chartArea);
                    this.drawTitle();
                }
            },
            {
                z: bz,
                draw: ()=>{
                    this.drawBorder();
                }
            },
            {
                z: tz,
                draw: (chartArea)=>{
                    this.drawLabels(chartArea);
                }
            }
        ];
    }
    getMatchingVisibleMetas(type) {
        const metas = this.chart.getSortedVisibleDatasetMetas();
        const axisID = this.axis + 'AxisID';
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metas.length; i < ilen; ++i){
            const meta = metas[i];
            if (meta[axisID] === this.id && (!type || meta.type === type)) result.push(meta);
        }
        return result;
    }
    _resolveTickFontOptions(index) {
        const opts = this.options.ticks.setContext(this.getContext(index));
        return (0, _helpersDatasetJs.a0)(opts.font);
    }
    _maxDigits() {
        const fontSize = this._resolveTickFontOptions(0).lineHeight;
        return (this.isHorizontal() ? this.width : this.height) / fontSize;
    }
}
class TypedRegistry {
    constructor(type, scope, override){
        this.type = type;
        this.scope = scope;
        this.override = override;
        this.items = Object.create(null);
    }
    isForType(type) {
        return Object.prototype.isPrototypeOf.call(this.type.prototype, type.prototype);
    }
    register(item) {
        const proto = Object.getPrototypeOf(item);
        let parentScope;
        if (isIChartComponent(proto)) parentScope = this.register(proto);
        const items = this.items;
        const id = item.id;
        const scope = this.scope + '.' + id;
        if (!id) throw new Error('class does not have id: ' + item);
        if (id in items) return scope;
        items[id] = item;
        registerDefaults(item, scope, parentScope);
        if (this.override) (0, _helpersDatasetJs.d).override(item.id, item.overrides);
        return scope;
    }
    get(id) {
        return this.items[id];
    }
    unregister(item) {
        const items = this.items;
        const id = item.id;
        const scope = this.scope;
        if (id in items) delete items[id];
        if (scope && id in (0, _helpersDatasetJs.d)[scope]) {
            delete (0, _helpersDatasetJs.d)[scope][id];
            if (this.override) delete (0, _helpersDatasetJs.a3)[id];
        }
    }
}
function registerDefaults(item, scope, parentScope) {
    const itemDefaults = (0, _helpersDatasetJs.a4)(Object.create(null), [
        parentScope ? (0, _helpersDatasetJs.d).get(parentScope) : {},
        (0, _helpersDatasetJs.d).get(scope),
        item.defaults
    ]);
    (0, _helpersDatasetJs.d).set(scope, itemDefaults);
    if (item.defaultRoutes) routeDefaults(scope, item.defaultRoutes);
    if (item.descriptors) (0, _helpersDatasetJs.d).describe(scope, item.descriptors);
}
function routeDefaults(scope, routes) {
    Object.keys(routes).forEach((property)=>{
        const propertyParts = property.split('.');
        const sourceName = propertyParts.pop();
        const sourceScope = [
            scope
        ].concat(propertyParts).join('.');
        const parts = routes[property].split('.');
        const targetName = parts.pop();
        const targetScope = parts.join('.');
        (0, _helpersDatasetJs.d).route(sourceScope, sourceName, targetScope, targetName);
    });
}
function isIChartComponent(proto) {
    return 'id' in proto && 'defaults' in proto;
}
class Registry {
    constructor(){
        this.controllers = new TypedRegistry(DatasetController, 'datasets', true);
        this.elements = new TypedRegistry(Element, 'elements');
        this.plugins = new TypedRegistry(Object, 'plugins');
        this.scales = new TypedRegistry(Scale, 'scales');
        this._typedRegistries = [
            this.controllers,
            this.scales,
            this.elements
        ];
    }
    add(...args) {
        this._each('register', args);
    }
    remove(...args) {
        this._each('unregister', args);
    }
    addControllers(...args) {
        this._each('register', args, this.controllers);
    }
    addElements(...args) {
        this._each('register', args, this.elements);
    }
    addPlugins(...args) {
        this._each('register', args, this.plugins);
    }
    addScales(...args) {
        this._each('register', args, this.scales);
    }
    getController(id) {
        return this._get(id, this.controllers, 'controller');
    }
    getElement(id) {
        return this._get(id, this.elements, 'element');
    }
    getPlugin(id) {
        return this._get(id, this.plugins, 'plugin');
    }
    getScale(id) {
        return this._get(id, this.scales, 'scale');
    }
    removeControllers(...args) {
        this._each('unregister', args, this.controllers);
    }
    removeElements(...args) {
        this._each('unregister', args, this.elements);
    }
    removePlugins(...args) {
        this._each('unregister', args, this.plugins);
    }
    removeScales(...args) {
        this._each('unregister', args, this.scales);
    }
    _each(method, args, typedRegistry) {
        [
            ...args
        ].forEach((arg)=>{
            const reg = typedRegistry || this._getRegistryForType(arg);
            if (typedRegistry || reg.isForType(arg) || reg === this.plugins && arg.id) this._exec(method, reg, arg);
            else (0, _helpersDatasetJs.F)(arg, (item)=>{
                const itemReg = typedRegistry || this._getRegistryForType(item);
                this._exec(method, itemReg, item);
            });
        });
    }
    _exec(method, registry, component) {
        const camelMethod = (0, _helpersDatasetJs.a5)(method);
        (0, _helpersDatasetJs.Q)(component['before' + camelMethod], [], component);
        registry[method](component);
        (0, _helpersDatasetJs.Q)(component['after' + camelMethod], [], component);
    }
    _getRegistryForType(type) {
        for(let i = 0; i < this._typedRegistries.length; i++){
            const reg = this._typedRegistries[i];
            if (reg.isForType(type)) return reg;
        }
        return this.plugins;
    }
    _get(id, typedRegistry, type) {
        const item = typedRegistry.get(id);
        if (item === undefined) throw new Error('"' + id + '" is not a registered ' + type + '.');
        return item;
    }
}
var registry = /* #__PURE__ */ new Registry();
class PluginService {
    constructor(){
        this._init = [];
    }
    notify(chart, hook, args, filter) {
        if (hook === 'beforeInit') {
            this._init = this._createDescriptors(chart, true);
            this._notify(this._init, chart, 'install');
        }
        const descriptors = filter ? this._descriptors(chart).filter(filter) : this._descriptors(chart);
        const result = this._notify(descriptors, chart, hook, args);
        if (hook === 'afterDestroy') {
            this._notify(descriptors, chart, 'stop');
            this._notify(this._init, chart, 'uninstall');
        }
        return result;
    }
    _notify(descriptors, chart, hook, args) {
        args = args || {};
        for (const descriptor of descriptors){
            const plugin = descriptor.plugin;
            const method = plugin[hook];
            const params = [
                chart,
                args,
                descriptor.options
            ];
            if ((0, _helpersDatasetJs.Q)(method, params, plugin) === false && args.cancelable) return false;
        }
        return true;
    }
    invalidate() {
        if (!(0, _helpersDatasetJs.k)(this._cache)) {
            this._oldCache = this._cache;
            this._cache = undefined;
        }
    }
    _descriptors(chart) {
        if (this._cache) return this._cache;
        const descriptors = this._cache = this._createDescriptors(chart);
        this._notifyStateChanges(chart);
        return descriptors;
    }
    _createDescriptors(chart, all) {
        const config = chart && chart.config;
        const options = (0, _helpersDatasetJs.v)(config.options && config.options.plugins, {});
        const plugins = allPlugins(config);
        return options === false && !all ? [] : createDescriptors(chart, plugins, options, all);
    }
    _notifyStateChanges(chart) {
        const previousDescriptors = this._oldCache || [];
        const descriptors = this._cache;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.plugin.id === y.plugin.id));
        this._notify(diff(previousDescriptors, descriptors), chart, 'stop');
        this._notify(diff(descriptors, previousDescriptors), chart, 'start');
    }
}
function allPlugins(config) {
    const localIds = {};
    const plugins = [];
    const keys = Object.keys(registry.plugins.items);
    for(let i = 0; i < keys.length; i++)plugins.push(registry.getPlugin(keys[i]));
    const local = config.plugins || [];
    for(let i = 0; i < local.length; i++){
        const plugin = local[i];
        if (plugins.indexOf(plugin) === -1) {
            plugins.push(plugin);
            localIds[plugin.id] = true;
        }
    }
    return {
        plugins,
        localIds
    };
}
function getOpts(options, all) {
    if (!all && options === false) return null;
    if (options === true) return {};
    return options;
}
function createDescriptors(chart, { plugins, localIds }, options, all) {
    const result = [];
    const context = chart.getContext();
    for (const plugin of plugins){
        const id = plugin.id;
        const opts = getOpts(options[id], all);
        if (opts === null) continue;
        result.push({
            plugin,
            options: pluginOpts(chart.config, {
                plugin,
                local: localIds[id]
            }, opts, context)
        });
    }
    return result;
}
function pluginOpts(config, { plugin, local }, opts, context) {
    const keys = config.pluginScopeKeys(plugin);
    const scopes = config.getOptionScopes(opts, keys);
    if (local && plugin.defaults) scopes.push(plugin.defaults);
    return config.createResolver(scopes, context, [
        ''
    ], {
        scriptable: false,
        indexable: false,
        allKeys: true
    });
}
function getIndexAxis(type, options) {
    const datasetDefaults = (0, _helpersDatasetJs.d).datasets[type] || {};
    const datasetOptions = (options.datasets || {})[type] || {};
    return datasetOptions.indexAxis || options.indexAxis || datasetDefaults.indexAxis || 'x';
}
function getAxisFromDefaultScaleID(id, indexAxis) {
    let axis = id;
    if (id === '_index_') axis = indexAxis;
    else if (id === '_value_') axis = indexAxis === 'x' ? 'y' : 'x';
    return axis;
}
function getDefaultScaleIDFromAxis(axis, indexAxis) {
    return axis === indexAxis ? '_index_' : '_value_';
}
function idMatchesAxis(id) {
    if (id === 'x' || id === 'y' || id === 'r') return id;
}
function axisFromPosition(position) {
    if (position === 'top' || position === 'bottom') return 'x';
    if (position === 'left' || position === 'right') return 'y';
}
function determineAxis(id, ...scaleOptions) {
    if (idMatchesAxis(id)) return id;
    for (const opts of scaleOptions){
        const axis = opts.axis || axisFromPosition(opts.position) || id.length > 1 && idMatchesAxis(id[0].toLowerCase());
        if (axis) return axis;
    }
    throw new Error(`Cannot determine type of '${id}' axis. Please provide 'axis' or 'position' option.`);
}
function getAxisFromDataset(id, axis, dataset) {
    if (dataset[axis + 'AxisID'] === id) return {
        axis
    };
}
function retrieveAxisFromDatasets(id, config) {
    if (config.data && config.data.datasets) {
        const boundDs = config.data.datasets.filter((d)=>d.xAxisID === id || d.yAxisID === id);
        if (boundDs.length) return getAxisFromDataset(id, 'x', boundDs[0]) || getAxisFromDataset(id, 'y', boundDs[0]);
    }
    return {};
}
function mergeScaleConfig(config, options) {
    const chartDefaults = (0, _helpersDatasetJs.a3)[config.type] || {
        scales: {}
    };
    const configScales = options.scales || {};
    const chartIndexAxis = getIndexAxis(config.type, options);
    const scales = Object.create(null);
    Object.keys(configScales).forEach((id)=>{
        const scaleConf = configScales[id];
        if (!(0, _helpersDatasetJs.i)(scaleConf)) return console.error(`Invalid scale configuration for scale: ${id}`);
        if (scaleConf._proxy) return console.warn(`Ignoring resolver passed as options for scale: ${id}`);
        const axis = determineAxis(id, scaleConf, retrieveAxisFromDatasets(id, config), (0, _helpersDatasetJs.d).scales[scaleConf.type]);
        const defaultId = getDefaultScaleIDFromAxis(axis, chartIndexAxis);
        const defaultScaleOptions = chartDefaults.scales || {};
        scales[id] = (0, _helpersDatasetJs.ab)(Object.create(null), [
            {
                axis
            },
            scaleConf,
            defaultScaleOptions[axis],
            defaultScaleOptions[defaultId]
        ]);
    });
    config.data.datasets.forEach((dataset)=>{
        const type = dataset.type || config.type;
        const indexAxis = dataset.indexAxis || getIndexAxis(type, options);
        const datasetDefaults = (0, _helpersDatasetJs.a3)[type] || {};
        const defaultScaleOptions = datasetDefaults.scales || {};
        Object.keys(defaultScaleOptions).forEach((defaultID)=>{
            const axis = getAxisFromDefaultScaleID(defaultID, indexAxis);
            const id = dataset[axis + 'AxisID'] || axis;
            scales[id] = scales[id] || Object.create(null);
            (0, _helpersDatasetJs.ab)(scales[id], [
                {
                    axis
                },
                configScales[id],
                defaultScaleOptions[defaultID]
            ]);
        });
    });
    Object.keys(scales).forEach((key)=>{
        const scale = scales[key];
        (0, _helpersDatasetJs.ab)(scale, [
            (0, _helpersDatasetJs.d).scales[scale.type],
            (0, _helpersDatasetJs.d).scale
        ]);
    });
    return scales;
}
function initOptions(config) {
    const options = config.options || (config.options = {});
    options.plugins = (0, _helpersDatasetJs.v)(options.plugins, {});
    options.scales = mergeScaleConfig(config, options);
}
function initData(data) {
    data = data || {};
    data.datasets = data.datasets || [];
    data.labels = data.labels || [];
    return data;
}
function initConfig(config) {
    config = config || {};
    config.data = initData(config.data);
    initOptions(config);
    return config;
}
const keyCache = new Map();
const keysCached = new Set();
function cachedKeys(cacheKey, generate) {
    let keys = keyCache.get(cacheKey);
    if (!keys) {
        keys = generate();
        keyCache.set(cacheKey, keys);
        keysCached.add(keys);
    }
    return keys;
}
const addIfFound = (set, obj, key)=>{
    const opts = (0, _helpersDatasetJs.f)(obj, key);
    if (opts !== undefined) set.add(opts);
};
class Config {
    constructor(config){
        this._config = initConfig(config);
        this._scopeCache = new Map();
        this._resolverCache = new Map();
    }
    get platform() {
        return this._config.platform;
    }
    get type() {
        return this._config.type;
    }
    set type(type) {
        this._config.type = type;
    }
    get data() {
        return this._config.data;
    }
    set data(data) {
        this._config.data = initData(data);
    }
    get options() {
        return this._config.options;
    }
    set options(options) {
        this._config.options = options;
    }
    get plugins() {
        return this._config.plugins;
    }
    update() {
        const config = this._config;
        this.clearCache();
        initOptions(config);
    }
    clearCache() {
        this._scopeCache.clear();
        this._resolverCache.clear();
    }
    datasetScopeKeys(datasetType) {
        return cachedKeys(datasetType, ()=>[
                [
                    `datasets.${datasetType}`,
                    ''
                ]
            ]);
    }
    datasetAnimationScopeKeys(datasetType, transition) {
        return cachedKeys(`${datasetType}.transition.${transition}`, ()=>[
                [
                    `datasets.${datasetType}.transitions.${transition}`,
                    `transitions.${transition}`
                ],
                [
                    `datasets.${datasetType}`,
                    ''
                ]
            ]);
    }
    datasetElementScopeKeys(datasetType, elementType) {
        return cachedKeys(`${datasetType}-${elementType}`, ()=>[
                [
                    `datasets.${datasetType}.elements.${elementType}`,
                    `datasets.${datasetType}`,
                    `elements.${elementType}`,
                    ''
                ]
            ]);
    }
    pluginScopeKeys(plugin) {
        const id = plugin.id;
        const type = this.type;
        return cachedKeys(`${type}-plugin-${id}`, ()=>[
                [
                    `plugins.${id}`,
                    ...plugin.additionalOptionScopes || []
                ]
            ]);
    }
    _cachedScopes(mainScope, resetCache) {
        const _scopeCache = this._scopeCache;
        let cache = _scopeCache.get(mainScope);
        if (!cache || resetCache) {
            cache = new Map();
            _scopeCache.set(mainScope, cache);
        }
        return cache;
    }
    getOptionScopes(mainScope, keyLists, resetCache) {
        const { options, type } = this;
        const cache = this._cachedScopes(mainScope, resetCache);
        const cached = cache.get(keyLists);
        if (cached) return cached;
        const scopes = new Set();
        keyLists.forEach((keys)=>{
            if (mainScope) {
                scopes.add(mainScope);
                keys.forEach((key)=>addIfFound(scopes, mainScope, key));
            }
            keys.forEach((key)=>addIfFound(scopes, options, key));
            keys.forEach((key)=>addIfFound(scopes, (0, _helpersDatasetJs.a3)[type] || {}, key));
            keys.forEach((key)=>addIfFound(scopes, (0, _helpersDatasetJs.d), key));
            keys.forEach((key)=>addIfFound(scopes, (0, _helpersDatasetJs.a6), key));
        });
        const array = Array.from(scopes);
        if (array.length === 0) array.push(Object.create(null));
        if (keysCached.has(keyLists)) cache.set(keyLists, array);
        return array;
    }
    chartOptionScopes() {
        const { options, type } = this;
        return [
            options,
            (0, _helpersDatasetJs.a3)[type] || {},
            (0, _helpersDatasetJs.d).datasets[type] || {},
            {
                type
            },
            (0, _helpersDatasetJs.d),
            (0, _helpersDatasetJs.a6)
        ];
    }
    resolveNamedOptions(scopes, names, context, prefixes = [
        ''
    ]) {
        const result = {
            $shared: true
        };
        const { resolver, subPrefixes } = getResolver(this._resolverCache, scopes, prefixes);
        let options = resolver;
        if (needContext(resolver, names)) {
            result.$shared = false;
            context = (0, _helpersDatasetJs.a7)(context) ? context() : context;
            const subResolver = this.createResolver(scopes, context, subPrefixes);
            options = (0, _helpersDatasetJs.a8)(resolver, context, subResolver);
        }
        for (const prop of names)result[prop] = options[prop];
        return result;
    }
    createResolver(scopes, context, prefixes = [
        ''
    ], descriptorDefaults) {
        const { resolver } = getResolver(this._resolverCache, scopes, prefixes);
        return (0, _helpersDatasetJs.i)(context) ? (0, _helpersDatasetJs.a8)(resolver, context, undefined, descriptorDefaults) : resolver;
    }
}
function getResolver(resolverCache, scopes, prefixes) {
    let cache = resolverCache.get(scopes);
    if (!cache) {
        cache = new Map();
        resolverCache.set(scopes, cache);
    }
    const cacheKey = prefixes.join();
    let cached = cache.get(cacheKey);
    if (!cached) {
        const resolver = (0, _helpersDatasetJs.a9)(scopes, prefixes);
        cached = {
            resolver,
            subPrefixes: prefixes.filter((p)=>!p.toLowerCase().includes('hover'))
        };
        cache.set(cacheKey, cached);
    }
    return cached;
}
const hasFunction = (value)=>(0, _helpersDatasetJs.i)(value) && Object.getOwnPropertyNames(value).some((key)=>(0, _helpersDatasetJs.a7)(value[key]));
function needContext(proxy, names) {
    const { isScriptable, isIndexable } = (0, _helpersDatasetJs.aa)(proxy);
    for (const prop of names){
        const scriptable = isScriptable(prop);
        const indexable = isIndexable(prop);
        const value = (indexable || scriptable) && proxy[prop];
        if (scriptable && ((0, _helpersDatasetJs.a7)(value) || hasFunction(value)) || indexable && (0, _helpersDatasetJs.b)(value)) return true;
    }
    return false;
}
var version = "4.4.9";
const KNOWN_POSITIONS = [
    'top',
    'bottom',
    'left',
    'right',
    'chartArea'
];
function positionIsHorizontal(position, axis) {
    return position === 'top' || position === 'bottom' || KNOWN_POSITIONS.indexOf(position) === -1 && axis === 'x';
}
function compare2Level(l1, l2) {
    return function(a, b) {
        return a[l1] === b[l1] ? a[l2] - b[l2] : a[l1] - b[l1];
    };
}
function onAnimationsComplete(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    chart.notifyPlugins('afterRender');
    (0, _helpersDatasetJs.Q)(animationOptions && animationOptions.onComplete, [
        context
    ], chart);
}
function onAnimationProgress(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    (0, _helpersDatasetJs.Q)(animationOptions && animationOptions.onProgress, [
        context
    ], chart);
}
function getCanvas(item) {
    if ((0, _helpersDatasetJs.M)() && typeof item === 'string') item = document.getElementById(item);
    else if (item && item.length) item = item[0];
    if (item && item.canvas) item = item.canvas;
    return item;
}
const instances = {};
const getChart = (key)=>{
    const canvas = getCanvas(key);
    return Object.values(instances).filter((c)=>c.canvas === canvas).pop();
};
function moveNumericKeys(obj, start, move) {
    const keys = Object.keys(obj);
    for (const key of keys){
        const intKey = +key;
        if (intKey >= start) {
            const value = obj[key];
            delete obj[key];
            if (move > 0 || intKey > start) obj[intKey + move] = value;
        }
    }
}
function determineLastEvent(e, lastEvent, inChartArea, isClick) {
    if (!inChartArea || e.type === 'mouseout') return null;
    if (isClick) return lastEvent;
    return e;
}
class Chart {
    static defaults = (0, _helpersDatasetJs.d);
    static instances = instances;
    static overrides = (0, _helpersDatasetJs.a3);
    static registry = registry;
    static version = version;
    static getChart = getChart;
    static register(...items) {
        registry.add(...items);
        invalidatePlugins();
    }
    static unregister(...items) {
        registry.remove(...items);
        invalidatePlugins();
    }
    constructor(item, userConfig){
        const config = this.config = new Config(userConfig);
        const initialCanvas = getCanvas(item);
        const existingChart = getChart(initialCanvas);
        if (existingChart) throw new Error('Canvas is already in use. Chart with ID \'' + existingChart.id + '\'' + ' must be destroyed before the canvas with ID \'' + existingChart.canvas.id + '\' can be reused.');
        const options = config.createResolver(config.chartOptionScopes(), this.getContext());
        this.platform = new (config.platform || _detectPlatform(initialCanvas))();
        this.platform.updateConfig(config);
        const context = this.platform.acquireContext(initialCanvas, options.aspectRatio);
        const canvas = context && context.canvas;
        const height = canvas && canvas.height;
        const width = canvas && canvas.width;
        this.id = (0, _helpersDatasetJs.ac)();
        this.ctx = context;
        this.canvas = canvas;
        this.width = width;
        this.height = height;
        this._options = options;
        this._aspectRatio = this.aspectRatio;
        this._layers = [];
        this._metasets = [];
        this._stacks = undefined;
        this.boxes = [];
        this.currentDevicePixelRatio = undefined;
        this.chartArea = undefined;
        this._active = [];
        this._lastEvent = undefined;
        this._listeners = {};
        this._responsiveListeners = undefined;
        this._sortedMetasets = [];
        this.scales = {};
        this._plugins = new PluginService();
        this.$proxies = {};
        this._hiddenIndices = {};
        this.attached = false;
        this._animationsDisabled = undefined;
        this.$context = undefined;
        this._doResize = (0, _helpersDatasetJs.ad)((mode)=>this.update(mode), options.resizeDelay || 0);
        this._dataChanges = [];
        instances[this.id] = this;
        if (!context || !canvas) {
            console.error("Failed to create chart: can't acquire context from the given item");
            return;
        }
        animator.listen(this, 'complete', onAnimationsComplete);
        animator.listen(this, 'progress', onAnimationProgress);
        this._initialize();
        if (this.attached) this.update();
    }
    get aspectRatio() {
        const { options: { aspectRatio, maintainAspectRatio }, width, height, _aspectRatio } = this;
        if (!(0, _helpersDatasetJs.k)(aspectRatio)) return aspectRatio;
        if (maintainAspectRatio && _aspectRatio) return _aspectRatio;
        return height ? width / height : null;
    }
    get data() {
        return this.config.data;
    }
    set data(data) {
        this.config.data = data;
    }
    get options() {
        return this._options;
    }
    set options(options) {
        this.config.options = options;
    }
    get registry() {
        return registry;
    }
    _initialize() {
        this.notifyPlugins('beforeInit');
        if (this.options.responsive) this.resize();
        else (0, _helpersDatasetJs.ae)(this, this.options.devicePixelRatio);
        this.bindEvents();
        this.notifyPlugins('afterInit');
        return this;
    }
    clear() {
        (0, _helpersDatasetJs.af)(this.canvas, this.ctx);
        return this;
    }
    stop() {
        animator.stop(this);
        return this;
    }
    resize(width, height) {
        if (!animator.running(this)) this._resize(width, height);
        else this._resizeBeforeDraw = {
            width,
            height
        };
    }
    _resize(width, height) {
        const options = this.options;
        const canvas = this.canvas;
        const aspectRatio = options.maintainAspectRatio && this.aspectRatio;
        const newSize = this.platform.getMaximumSize(canvas, width, height, aspectRatio);
        const newRatio = options.devicePixelRatio || this.platform.getDevicePixelRatio();
        const mode = this.width ? 'resize' : 'attach';
        this.width = newSize.width;
        this.height = newSize.height;
        this._aspectRatio = this.aspectRatio;
        if (!(0, _helpersDatasetJs.ae)(this, newRatio, true)) return;
        this.notifyPlugins('resize', {
            size: newSize
        });
        (0, _helpersDatasetJs.Q)(options.onResize, [
            this,
            newSize
        ], this);
        if (this.attached) {
            if (this._doResize(mode)) this.render();
        }
    }
    ensureScalesHaveIDs() {
        const options = this.options;
        const scalesOptions = options.scales || {};
        (0, _helpersDatasetJs.F)(scalesOptions, (axisOptions, axisID)=>{
            axisOptions.id = axisID;
        });
    }
    buildOrUpdateScales() {
        const options = this.options;
        const scaleOpts = options.scales;
        const scales = this.scales;
        const updated = Object.keys(scales).reduce((obj, id)=>{
            obj[id] = false;
            return obj;
        }, {});
        let items = [];
        if (scaleOpts) items = items.concat(Object.keys(scaleOpts).map((id)=>{
            const scaleOptions = scaleOpts[id];
            const axis = determineAxis(id, scaleOptions);
            const isRadial = axis === 'r';
            const isHorizontal = axis === 'x';
            return {
                options: scaleOptions,
                dposition: isRadial ? 'chartArea' : isHorizontal ? 'bottom' : 'left',
                dtype: isRadial ? 'radialLinear' : isHorizontal ? 'category' : 'linear'
            };
        }));
        (0, _helpersDatasetJs.F)(items, (item)=>{
            const scaleOptions = item.options;
            const id = scaleOptions.id;
            const axis = determineAxis(id, scaleOptions);
            const scaleType = (0, _helpersDatasetJs.v)(scaleOptions.type, item.dtype);
            if (scaleOptions.position === undefined || positionIsHorizontal(scaleOptions.position, axis) !== positionIsHorizontal(item.dposition)) scaleOptions.position = item.dposition;
            updated[id] = true;
            let scale = null;
            if (id in scales && scales[id].type === scaleType) scale = scales[id];
            else {
                const scaleClass = registry.getScale(scaleType);
                scale = new scaleClass({
                    id,
                    type: scaleType,
                    ctx: this.ctx,
                    chart: this
                });
                scales[scale.id] = scale;
            }
            scale.init(scaleOptions, options);
        });
        (0, _helpersDatasetJs.F)(updated, (hasUpdated, id)=>{
            if (!hasUpdated) delete scales[id];
        });
        (0, _helpersDatasetJs.F)(scales, (scale)=>{
            layouts.configure(this, scale, scale.options);
            layouts.addBox(this, scale);
        });
    }
    _updateMetasets() {
        const metasets = this._metasets;
        const numData = this.data.datasets.length;
        const numMeta = metasets.length;
        metasets.sort((a, b)=>a.index - b.index);
        if (numMeta > numData) {
            for(let i = numData; i < numMeta; ++i)this._destroyDatasetMeta(i);
            metasets.splice(numData, numMeta - numData);
        }
        this._sortedMetasets = metasets.slice(0).sort(compare2Level('order', 'index'));
    }
    _removeUnreferencedMetasets() {
        const { _metasets: metasets, data: { datasets } } = this;
        if (metasets.length > datasets.length) delete this._stacks;
        metasets.forEach((meta, index)=>{
            if (datasets.filter((x)=>x === meta._dataset).length === 0) this._destroyDatasetMeta(index);
        });
    }
    buildOrUpdateControllers() {
        const newControllers = [];
        const datasets = this.data.datasets;
        let i, ilen;
        this._removeUnreferencedMetasets();
        for(i = 0, ilen = datasets.length; i < ilen; i++){
            const dataset = datasets[i];
            let meta = this.getDatasetMeta(i);
            const type = dataset.type || this.config.type;
            if (meta.type && meta.type !== type) {
                this._destroyDatasetMeta(i);
                meta = this.getDatasetMeta(i);
            }
            meta.type = type;
            meta.indexAxis = dataset.indexAxis || getIndexAxis(type, this.options);
            meta.order = dataset.order || 0;
            meta.index = i;
            meta.label = '' + dataset.label;
            meta.visible = this.isDatasetVisible(i);
            if (meta.controller) {
                meta.controller.updateIndex(i);
                meta.controller.linkScales();
            } else {
                const ControllerClass = registry.getController(type);
                const { datasetElementType, dataElementType } = (0, _helpersDatasetJs.d).datasets[type];
                Object.assign(ControllerClass, {
                    dataElementType: registry.getElement(dataElementType),
                    datasetElementType: datasetElementType && registry.getElement(datasetElementType)
                });
                meta.controller = new ControllerClass(this, i);
                newControllers.push(meta.controller);
            }
        }
        this._updateMetasets();
        return newControllers;
    }
    _resetElements() {
        (0, _helpersDatasetJs.F)(this.data.datasets, (dataset, datasetIndex)=>{
            this.getDatasetMeta(datasetIndex).controller.reset();
        }, this);
    }
    reset() {
        this._resetElements();
        this.notifyPlugins('reset');
    }
    update(mode) {
        const config = this.config;
        config.update();
        const options = this._options = config.createResolver(config.chartOptionScopes(), this.getContext());
        const animsDisabled = this._animationsDisabled = !options.animation;
        this._updateScales();
        this._checkEventBindings();
        this._updateHiddenIndices();
        this._plugins.invalidate();
        if (this.notifyPlugins('beforeUpdate', {
            mode,
            cancelable: true
        }) === false) return;
        const newControllers = this.buildOrUpdateControllers();
        this.notifyPlugins('beforeElementsUpdate');
        let minPadding = 0;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; i++){
            const { controller } = this.getDatasetMeta(i);
            const reset = !animsDisabled && newControllers.indexOf(controller) === -1;
            controller.buildOrUpdateElements(reset);
            minPadding = Math.max(+controller.getMaxOverflow(), minPadding);
        }
        minPadding = this._minPadding = options.layout.autoPadding ? minPadding : 0;
        this._updateLayout(minPadding);
        if (!animsDisabled) (0, _helpersDatasetJs.F)(newControllers, (controller)=>{
            controller.reset();
        });
        this._updateDatasets(mode);
        this.notifyPlugins('afterUpdate', {
            mode
        });
        this._layers.sort(compare2Level('z', '_idx'));
        const { _active, _lastEvent } = this;
        if (_lastEvent) this._eventHandler(_lastEvent, true);
        else if (_active.length) this._updateHoverStyles(_active, _active, true);
        this.render();
    }
    _updateScales() {
        (0, _helpersDatasetJs.F)(this.scales, (scale)=>{
            layouts.removeBox(this, scale);
        });
        this.ensureScalesHaveIDs();
        this.buildOrUpdateScales();
    }
    _checkEventBindings() {
        const options = this.options;
        const existingEvents = new Set(Object.keys(this._listeners));
        const newEvents = new Set(options.events);
        if (!(0, _helpersDatasetJs.ag)(existingEvents, newEvents) || !!this._responsiveListeners !== options.responsive) {
            this.unbindEvents();
            this.bindEvents();
        }
    }
    _updateHiddenIndices() {
        const { _hiddenIndices } = this;
        const changes = this._getUniformDataChanges() || [];
        for (const { method, start, count } of changes){
            const move = method === '_removeElements' ? -count : count;
            moveNumericKeys(_hiddenIndices, start, move);
        }
    }
    _getUniformDataChanges() {
        const _dataChanges = this._dataChanges;
        if (!_dataChanges || !_dataChanges.length) return;
        this._dataChanges = [];
        const datasetCount = this.data.datasets.length;
        const makeSet = (idx)=>new Set(_dataChanges.filter((c)=>c[0] === idx).map((c, i)=>i + ',' + c.splice(1).join(',')));
        const changeSet = makeSet(0);
        for(let i = 1; i < datasetCount; i++){
            if (!(0, _helpersDatasetJs.ag)(changeSet, makeSet(i))) return;
        }
        return Array.from(changeSet).map((c)=>c.split(',')).map((a)=>({
                method: a[1],
                start: +a[2],
                count: +a[3]
            }));
    }
    _updateLayout(minPadding) {
        if (this.notifyPlugins('beforeLayout', {
            cancelable: true
        }) === false) return;
        layouts.update(this, this.width, this.height, minPadding);
        const area = this.chartArea;
        const noArea = area.width <= 0 || area.height <= 0;
        this._layers = [];
        (0, _helpersDatasetJs.F)(this.boxes, (box)=>{
            if (noArea && box.position === 'chartArea') return;
            if (box.configure) box.configure();
            this._layers.push(...box._layers());
        }, this);
        this._layers.forEach((item, index)=>{
            item._idx = index;
        });
        this.notifyPlugins('afterLayout');
    }
    _updateDatasets(mode) {
        if (this.notifyPlugins('beforeDatasetsUpdate', {
            mode,
            cancelable: true
        }) === false) return;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this.getDatasetMeta(i).controller.configure();
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._updateDataset(i, (0, _helpersDatasetJs.a7)(mode) ? mode({
            datasetIndex: i
        }) : mode);
        this.notifyPlugins('afterDatasetsUpdate', {
            mode
        });
    }
    _updateDataset(index, mode) {
        const meta = this.getDatasetMeta(index);
        const args = {
            meta,
            index,
            mode,
            cancelable: true
        };
        if (this.notifyPlugins('beforeDatasetUpdate', args) === false) return;
        meta.controller._update(mode);
        args.cancelable = false;
        this.notifyPlugins('afterDatasetUpdate', args);
    }
    render() {
        if (this.notifyPlugins('beforeRender', {
            cancelable: true
        }) === false) return;
        if (animator.has(this)) {
            if (this.attached && !animator.running(this)) animator.start(this);
        } else {
            this.draw();
            onAnimationsComplete({
                chart: this
            });
        }
    }
    draw() {
        let i;
        if (this._resizeBeforeDraw) {
            const { width, height } = this._resizeBeforeDraw;
            this._resizeBeforeDraw = null;
            this._resize(width, height);
        }
        this.clear();
        if (this.width <= 0 || this.height <= 0) return;
        if (this.notifyPlugins('beforeDraw', {
            cancelable: true
        }) === false) return;
        const layers = this._layers;
        for(i = 0; i < layers.length && layers[i].z <= 0; ++i)layers[i].draw(this.chartArea);
        this._drawDatasets();
        for(; i < layers.length; ++i)layers[i].draw(this.chartArea);
        this.notifyPlugins('afterDraw');
    }
    _getSortedDatasetMetas(filterVisible) {
        const metasets = this._sortedMetasets;
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metasets.length; i < ilen; ++i){
            const meta = metasets[i];
            if (!filterVisible || meta.visible) result.push(meta);
        }
        return result;
    }
    getSortedVisibleDatasetMetas() {
        return this._getSortedDatasetMetas(true);
    }
    _drawDatasets() {
        if (this.notifyPlugins('beforeDatasetsDraw', {
            cancelable: true
        }) === false) return;
        const metasets = this.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i)this._drawDataset(metasets[i]);
        this.notifyPlugins('afterDatasetsDraw');
    }
    _drawDataset(meta) {
        const ctx = this.ctx;
        const args = {
            meta,
            index: meta.index,
            cancelable: true
        };
        const clip = (0, _helpersDatasetJs.ah)(this, meta);
        if (this.notifyPlugins('beforeDatasetDraw', args) === false) return;
        if (clip) (0, _helpersDatasetJs.Y)(ctx, clip);
        meta.controller.draw();
        if (clip) (0, _helpersDatasetJs.$)(ctx);
        args.cancelable = false;
        this.notifyPlugins('afterDatasetDraw', args);
    }
    isPointInArea(point) {
        return (0, _helpersDatasetJs.C)(point, this.chartArea, this._minPadding);
    }
    getElementsAtEventForMode(e, mode, options, useFinalPosition) {
        const method = Interaction.modes[mode];
        if (typeof method === 'function') return method(this, e, options, useFinalPosition);
        return [];
    }
    getDatasetMeta(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        const metasets = this._metasets;
        let meta = metasets.filter((x)=>x && x._dataset === dataset).pop();
        if (!meta) {
            meta = {
                type: null,
                data: [],
                dataset: null,
                controller: null,
                hidden: null,
                xAxisID: null,
                yAxisID: null,
                order: dataset && dataset.order || 0,
                index: datasetIndex,
                _dataset: dataset,
                _parsed: [],
                _sorted: false
            };
            metasets.push(meta);
        }
        return meta;
    }
    getContext() {
        return this.$context || (this.$context = (0, _helpersDatasetJs.j)(null, {
            chart: this,
            type: 'chart'
        }));
    }
    getVisibleDatasetCount() {
        return this.getSortedVisibleDatasetMetas().length;
    }
    isDatasetVisible(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        if (!dataset) return false;
        const meta = this.getDatasetMeta(datasetIndex);
        return typeof meta.hidden === 'boolean' ? !meta.hidden : !dataset.hidden;
    }
    setDatasetVisibility(datasetIndex, visible) {
        const meta = this.getDatasetMeta(datasetIndex);
        meta.hidden = !visible;
    }
    toggleDataVisibility(index) {
        this._hiddenIndices[index] = !this._hiddenIndices[index];
    }
    getDataVisibility(index) {
        return !this._hiddenIndices[index];
    }
    _updateVisibility(datasetIndex, dataIndex, visible) {
        const mode = visible ? 'show' : 'hide';
        const meta = this.getDatasetMeta(datasetIndex);
        const anims = meta.controller._resolveAnimations(undefined, mode);
        if ((0, _helpersDatasetJs.h)(dataIndex)) {
            meta.data[dataIndex].hidden = !visible;
            this.update();
        } else {
            this.setDatasetVisibility(datasetIndex, visible);
            anims.update(meta, {
                visible
            });
            this.update((ctx)=>ctx.datasetIndex === datasetIndex ? mode : undefined);
        }
    }
    hide(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, false);
    }
    show(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, true);
    }
    _destroyDatasetMeta(datasetIndex) {
        const meta = this._metasets[datasetIndex];
        if (meta && meta.controller) meta.controller._destroy();
        delete this._metasets[datasetIndex];
    }
    _stop() {
        let i, ilen;
        this.stop();
        animator.remove(this);
        for(i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._destroyDatasetMeta(i);
    }
    destroy() {
        this.notifyPlugins('beforeDestroy');
        const { canvas, ctx } = this;
        this._stop();
        this.config.clearCache();
        if (canvas) {
            this.unbindEvents();
            (0, _helpersDatasetJs.af)(canvas, ctx);
            this.platform.releaseContext(ctx);
            this.canvas = null;
            this.ctx = null;
        }
        delete instances[this.id];
        this.notifyPlugins('afterDestroy');
    }
    toBase64Image(...args) {
        return this.canvas.toDataURL(...args);
    }
    bindEvents() {
        this.bindUserEvents();
        if (this.options.responsive) this.bindResponsiveEvents();
        else this.attached = true;
    }
    bindUserEvents() {
        const listeners = this._listeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const listener = (e, x, y)=>{
            e.offsetX = x;
            e.offsetY = y;
            this._eventHandler(e);
        };
        (0, _helpersDatasetJs.F)(this.options.events, (type)=>_add(type, listener));
    }
    bindResponsiveEvents() {
        if (!this._responsiveListeners) this._responsiveListeners = {};
        const listeners = this._responsiveListeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const _remove = (type, listener)=>{
            if (listeners[type]) {
                platform.removeEventListener(this, type, listener);
                delete listeners[type];
            }
        };
        const listener = (width, height)=>{
            if (this.canvas) this.resize(width, height);
        };
        let detached;
        const attached = ()=>{
            _remove('attach', attached);
            this.attached = true;
            this.resize();
            _add('resize', listener);
            _add('detach', detached);
        };
        detached = ()=>{
            this.attached = false;
            _remove('resize', listener);
            this._stop();
            this._resize(0, 0);
            _add('attach', attached);
        };
        if (platform.isAttached(this.canvas)) attached();
        else detached();
    }
    unbindEvents() {
        (0, _helpersDatasetJs.F)(this._listeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._listeners = {};
        (0, _helpersDatasetJs.F)(this._responsiveListeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._responsiveListeners = undefined;
    }
    updateHoverStyle(items, mode, enabled) {
        const prefix = enabled ? 'set' : 'remove';
        let meta, item, i, ilen;
        if (mode === 'dataset') {
            meta = this.getDatasetMeta(items[0].datasetIndex);
            meta.controller['_' + prefix + 'DatasetHoverStyle']();
        }
        for(i = 0, ilen = items.length; i < ilen; ++i){
            item = items[i];
            const controller = item && this.getDatasetMeta(item.datasetIndex).controller;
            if (controller) controller[prefix + 'HoverStyle'](item.element, item.datasetIndex, item.index);
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements) {
        const lastActive = this._active || [];
        const active = activeElements.map(({ datasetIndex, index })=>{
            const meta = this.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error('No dataset found at index ' + datasetIndex);
            return {
                datasetIndex,
                element: meta.data[index],
                index
            };
        });
        const changed = !(0, _helpersDatasetJs.ai)(active, lastActive);
        if (changed) {
            this._active = active;
            this._lastEvent = null;
            this._updateHoverStyles(active, lastActive);
        }
    }
    notifyPlugins(hook, args, filter) {
        return this._plugins.notify(this, hook, args, filter);
    }
    isPluginEnabled(pluginId) {
        return this._plugins._cache.filter((p)=>p.plugin.id === pluginId).length === 1;
    }
    _updateHoverStyles(active, lastActive, replay) {
        const hoverOptions = this.options.hover;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.datasetIndex === y.datasetIndex && x.index === y.index));
        const deactivated = diff(lastActive, active);
        const activated = replay ? active : diff(active, lastActive);
        if (deactivated.length) this.updateHoverStyle(deactivated, hoverOptions.mode, false);
        if (activated.length && hoverOptions.mode) this.updateHoverStyle(activated, hoverOptions.mode, true);
    }
    _eventHandler(e, replay) {
        const args = {
            event: e,
            replay,
            cancelable: true,
            inChartArea: this.isPointInArea(e)
        };
        const eventFilter = (plugin)=>(plugin.options.events || this.options.events).includes(e.native.type);
        if (this.notifyPlugins('beforeEvent', args, eventFilter) === false) return;
        const changed = this._handleEvent(e, replay, args.inChartArea);
        args.cancelable = false;
        this.notifyPlugins('afterEvent', args, eventFilter);
        if (changed || args.changed) this.render();
        return this;
    }
    _handleEvent(e, replay, inChartArea) {
        const { _active: lastActive = [], options } = this;
        const useFinalPosition = replay;
        const active = this._getActiveElements(e, lastActive, inChartArea, useFinalPosition);
        const isClick = (0, _helpersDatasetJs.aj)(e);
        const lastEvent = determineLastEvent(e, this._lastEvent, inChartArea, isClick);
        if (inChartArea) {
            this._lastEvent = null;
            (0, _helpersDatasetJs.Q)(options.onHover, [
                e,
                active,
                this
            ], this);
            if (isClick) (0, _helpersDatasetJs.Q)(options.onClick, [
                e,
                active,
                this
            ], this);
        }
        const changed = !(0, _helpersDatasetJs.ai)(active, lastActive);
        if (changed || replay) {
            this._active = active;
            this._updateHoverStyles(active, lastActive, replay);
        }
        this._lastEvent = lastEvent;
        return changed;
    }
    _getActiveElements(e, lastActive, inChartArea, useFinalPosition) {
        if (e.type === 'mouseout') return [];
        if (!inChartArea) return lastActive;
        const hoverOptions = this.options.hover;
        return this.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions, useFinalPosition);
    }
}
function invalidatePlugins() {
    return (0, _helpersDatasetJs.F)(Chart.instances, (chart)=>chart._plugins.invalidate());
}
function clipArc(ctx, element, endAngle) {
    const { startAngle, pixelMargin, x, y, outerRadius, innerRadius } = element;
    let angleMargin = pixelMargin / outerRadius;
    // Draw an inner border by clipping the arc and drawing a double-width border
    // Enlarge the clipping arc by 0.33 pixels to eliminate glitches between borders
    ctx.beginPath();
    ctx.arc(x, y, outerRadius, startAngle - angleMargin, endAngle + angleMargin);
    if (innerRadius > pixelMargin) {
        angleMargin = pixelMargin / innerRadius;
        ctx.arc(x, y, innerRadius, endAngle + angleMargin, startAngle - angleMargin, true);
    } else ctx.arc(x, y, pixelMargin, endAngle + (0, _helpersDatasetJs.H), startAngle - (0, _helpersDatasetJs.H));
    ctx.closePath();
    ctx.clip();
}
function toRadiusCorners(value) {
    return (0, _helpersDatasetJs.al)(value, [
        'outerStart',
        'outerEnd',
        'innerStart',
        'innerEnd'
    ]);
}
/**
 * Parse border radius from the provided options
 */ function parseBorderRadius$1(arc, innerRadius, outerRadius, angleDelta) {
    const o = toRadiusCorners(arc.options.borderRadius);
    const halfThickness = (outerRadius - innerRadius) / 2;
    const innerLimit = Math.min(halfThickness, angleDelta * innerRadius / 2);
    // Outer limits are complicated. We want to compute the available angular distance at
    // a radius of outerRadius - borderRadius because for small angular distances, this term limits.
    // We compute at r = outerRadius - borderRadius because this circle defines the center of the border corners.
    //
    // If the borderRadius is large, that value can become negative.
    // This causes the outer borders to lose their radius entirely, which is rather unexpected. To solve that, if borderRadius > outerRadius
    // we know that the thickness term will dominate and compute the limits at that point
    const computeOuterLimit = (val)=>{
        const outerArcLimit = (outerRadius - Math.min(halfThickness, val)) * angleDelta / 2;
        return (0, _helpersDatasetJs.S)(val, 0, Math.min(halfThickness, outerArcLimit));
    };
    return {
        outerStart: computeOuterLimit(o.outerStart),
        outerEnd: computeOuterLimit(o.outerEnd),
        innerStart: (0, _helpersDatasetJs.S)(o.innerStart, 0, innerLimit),
        innerEnd: (0, _helpersDatasetJs.S)(o.innerEnd, 0, innerLimit)
    };
}
/**
 * Convert (r, 𝜃) to (x, y)
 */ function rThetaToXY(r, theta, x, y) {
    return {
        x: x + r * Math.cos(theta),
        y: y + r * Math.sin(theta)
    };
}
/**
 * Path the arc, respecting border radius by separating into left and right halves.
 *
 *   Start      End
 *
 *    1--->a--->2    Outer
 *   /           \
 *   8           3
 *   |           |
 *   |           |
 *   7           4
 *   \           /
 *    6<---b<---5    Inner
 */ function pathArc(ctx, element, offset, spacing, end, circular) {
    const { x, y, startAngle: start, pixelMargin, innerRadius: innerR } = element;
    const outerRadius = Math.max(element.outerRadius + spacing + offset - pixelMargin, 0);
    const innerRadius = innerR > 0 ? innerR + spacing + offset + pixelMargin : 0;
    let spacingOffset = 0;
    const alpha = end - start;
    if (spacing) {
        // When spacing is present, it is the same for all items
        // So we adjust the start and end angle of the arc such that
        // the distance is the same as it would be without the spacing
        const noSpacingInnerRadius = innerR > 0 ? innerR - spacing : 0;
        const noSpacingOuterRadius = outerRadius > 0 ? outerRadius - spacing : 0;
        const avNogSpacingRadius = (noSpacingInnerRadius + noSpacingOuterRadius) / 2;
        const adjustedAngle = avNogSpacingRadius !== 0 ? alpha * avNogSpacingRadius / (avNogSpacingRadius + spacing) : alpha;
        spacingOffset = (alpha - adjustedAngle) / 2;
    }
    const beta = Math.max(0.001, alpha * outerRadius - offset / (0, _helpersDatasetJs.P)) / outerRadius;
    const angleOffset = (alpha - beta) / 2;
    const startAngle = start + angleOffset + spacingOffset;
    const endAngle = end - angleOffset - spacingOffset;
    const { outerStart, outerEnd, innerStart, innerEnd } = parseBorderRadius$1(element, innerRadius, outerRadius, endAngle - startAngle);
    const outerStartAdjustedRadius = outerRadius - outerStart;
    const outerEndAdjustedRadius = outerRadius - outerEnd;
    const outerStartAdjustedAngle = startAngle + outerStart / outerStartAdjustedRadius;
    const outerEndAdjustedAngle = endAngle - outerEnd / outerEndAdjustedRadius;
    const innerStartAdjustedRadius = innerRadius + innerStart;
    const innerEndAdjustedRadius = innerRadius + innerEnd;
    const innerStartAdjustedAngle = startAngle + innerStart / innerStartAdjustedRadius;
    const innerEndAdjustedAngle = endAngle - innerEnd / innerEndAdjustedRadius;
    ctx.beginPath();
    if (circular) {
        // The first arc segments from point 1 to point a to point 2
        const outerMidAdjustedAngle = (outerStartAdjustedAngle + outerEndAdjustedAngle) / 2;
        ctx.arc(x, y, outerRadius, outerStartAdjustedAngle, outerMidAdjustedAngle);
        ctx.arc(x, y, outerRadius, outerMidAdjustedAngle, outerEndAdjustedAngle);
        // The corner segment from point 2 to point 3
        if (outerEnd > 0) {
            const pCenter = rThetaToXY(outerEndAdjustedRadius, outerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerEnd, outerEndAdjustedAngle, endAngle + (0, _helpersDatasetJs.H));
        }
        // The line from point 3 to point 4
        const p4 = rThetaToXY(innerEndAdjustedRadius, endAngle, x, y);
        ctx.lineTo(p4.x, p4.y);
        // The corner segment from point 4 to point 5
        if (innerEnd > 0) {
            const pCenter = rThetaToXY(innerEndAdjustedRadius, innerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerEnd, endAngle + (0, _helpersDatasetJs.H), innerEndAdjustedAngle + Math.PI);
        }
        // The inner arc from point 5 to point b to point 6
        const innerMidAdjustedAngle = (endAngle - innerEnd / innerRadius + (startAngle + innerStart / innerRadius)) / 2;
        ctx.arc(x, y, innerRadius, endAngle - innerEnd / innerRadius, innerMidAdjustedAngle, true);
        ctx.arc(x, y, innerRadius, innerMidAdjustedAngle, startAngle + innerStart / innerRadius, true);
        // The corner segment from point 6 to point 7
        if (innerStart > 0) {
            const pCenter = rThetaToXY(innerStartAdjustedRadius, innerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerStart, innerStartAdjustedAngle + Math.PI, startAngle - (0, _helpersDatasetJs.H));
        }
        // The line from point 7 to point 8
        const p8 = rThetaToXY(outerStartAdjustedRadius, startAngle, x, y);
        ctx.lineTo(p8.x, p8.y);
        // The corner segment from point 8 to point 1
        if (outerStart > 0) {
            const pCenter = rThetaToXY(outerStartAdjustedRadius, outerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerStart, startAngle - (0, _helpersDatasetJs.H), outerStartAdjustedAngle);
        }
    } else {
        ctx.moveTo(x, y);
        const outerStartX = Math.cos(outerStartAdjustedAngle) * outerRadius + x;
        const outerStartY = Math.sin(outerStartAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerStartX, outerStartY);
        const outerEndX = Math.cos(outerEndAdjustedAngle) * outerRadius + x;
        const outerEndY = Math.sin(outerEndAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerEndX, outerEndY);
    }
    ctx.closePath();
}
function drawArc(ctx, element, offset, spacing, circular) {
    const { fullCircles, startAngle, circumference } = element;
    let endAngle = element.endAngle;
    if (fullCircles) {
        pathArc(ctx, element, offset, spacing, endAngle, circular);
        for(let i = 0; i < fullCircles; ++i)ctx.fill();
        if (!isNaN(circumference)) endAngle = startAngle + (circumference % (0, _helpersDatasetJs.T) || (0, _helpersDatasetJs.T));
    }
    pathArc(ctx, element, offset, spacing, endAngle, circular);
    ctx.fill();
    return endAngle;
}
function drawBorder(ctx, element, offset, spacing, circular) {
    const { fullCircles, startAngle, circumference, options } = element;
    const { borderWidth, borderJoinStyle, borderDash, borderDashOffset } = options;
    const inner = options.borderAlign === 'inner';
    if (!borderWidth) return;
    ctx.setLineDash(borderDash || []);
    ctx.lineDashOffset = borderDashOffset;
    if (inner) {
        ctx.lineWidth = borderWidth * 2;
        ctx.lineJoin = borderJoinStyle || 'round';
    } else {
        ctx.lineWidth = borderWidth;
        ctx.lineJoin = borderJoinStyle || 'bevel';
    }
    let endAngle = element.endAngle;
    if (fullCircles) {
        pathArc(ctx, element, offset, spacing, endAngle, circular);
        for(let i = 0; i < fullCircles; ++i)ctx.stroke();
        if (!isNaN(circumference)) endAngle = startAngle + (circumference % (0, _helpersDatasetJs.T) || (0, _helpersDatasetJs.T));
    }
    if (inner) clipArc(ctx, element, endAngle);
    if (!fullCircles) {
        pathArc(ctx, element, offset, spacing, endAngle, circular);
        ctx.stroke();
    }
}
class ArcElement extends Element {
    static id = 'arc';
    static defaults = {
        borderAlign: 'center',
        borderColor: '#fff',
        borderDash: [],
        borderDashOffset: 0,
        borderJoinStyle: undefined,
        borderRadius: 0,
        borderWidth: 2,
        offset: 0,
        spacing: 0,
        angle: undefined,
        circular: true
    };
    static defaultRoutes = {
        backgroundColor: 'backgroundColor'
    };
    static descriptors = {
        _scriptable: true,
        _indexable: (name)=>name !== 'borderDash'
    };
    circumference;
    endAngle;
    fullCircles;
    innerRadius;
    outerRadius;
    pixelMargin;
    startAngle;
    constructor(cfg){
        super();
        this.options = undefined;
        this.circumference = undefined;
        this.startAngle = undefined;
        this.endAngle = undefined;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.pixelMargin = 0;
        this.fullCircles = 0;
        if (cfg) Object.assign(this, cfg);
    }
    inRange(chartX, chartY, useFinalPosition) {
        const point = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        const { angle, distance } = (0, _helpersDatasetJs.D)(point, {
            x: chartX,
            y: chartY
        });
        const { startAngle, endAngle, innerRadius, outerRadius, circumference } = this.getProps([
            'startAngle',
            'endAngle',
            'innerRadius',
            'outerRadius',
            'circumference'
        ], useFinalPosition);
        const rAdjust = (this.options.spacing + this.options.borderWidth) / 2;
        const _circumference = (0, _helpersDatasetJs.v)(circumference, endAngle - startAngle);
        const nonZeroBetween = (0, _helpersDatasetJs.p)(angle, startAngle, endAngle) && startAngle !== endAngle;
        const betweenAngles = _circumference >= (0, _helpersDatasetJs.T) || nonZeroBetween;
        const withinRadius = (0, _helpersDatasetJs.ak)(distance, innerRadius + rAdjust, outerRadius + rAdjust);
        return betweenAngles && withinRadius;
    }
    getCenterPoint(useFinalPosition) {
        const { x, y, startAngle, endAngle, innerRadius, outerRadius } = this.getProps([
            'x',
            'y',
            'startAngle',
            'endAngle',
            'innerRadius',
            'outerRadius'
        ], useFinalPosition);
        const { offset, spacing } = this.options;
        const halfAngle = (startAngle + endAngle) / 2;
        const halfRadius = (innerRadius + outerRadius + spacing + offset) / 2;
        return {
            x: x + Math.cos(halfAngle) * halfRadius,
            y: y + Math.sin(halfAngle) * halfRadius
        };
    }
    tooltipPosition(useFinalPosition) {
        return this.getCenterPoint(useFinalPosition);
    }
    draw(ctx) {
        const { options, circumference } = this;
        const offset = (options.offset || 0) / 4;
        const spacing = (options.spacing || 0) / 2;
        const circular = options.circular;
        this.pixelMargin = options.borderAlign === 'inner' ? 0.33 : 0;
        this.fullCircles = circumference > (0, _helpersDatasetJs.T) ? Math.floor(circumference / (0, _helpersDatasetJs.T)) : 0;
        if (circumference === 0 || this.innerRadius < 0 || this.outerRadius < 0) return;
        ctx.save();
        const halfAngle = (this.startAngle + this.endAngle) / 2;
        ctx.translate(Math.cos(halfAngle) * offset, Math.sin(halfAngle) * offset);
        const fix = 1 - Math.sin(Math.min((0, _helpersDatasetJs.P), circumference || 0));
        const radiusOffset = offset * fix;
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        drawArc(ctx, this, radiusOffset, spacing, circular);
        drawBorder(ctx, this, radiusOffset, spacing, circular);
        ctx.restore();
    }
}
function setStyle(ctx, options, style = options) {
    ctx.lineCap = (0, _helpersDatasetJs.v)(style.borderCapStyle, options.borderCapStyle);
    ctx.setLineDash((0, _helpersDatasetJs.v)(style.borderDash, options.borderDash));
    ctx.lineDashOffset = (0, _helpersDatasetJs.v)(style.borderDashOffset, options.borderDashOffset);
    ctx.lineJoin = (0, _helpersDatasetJs.v)(style.borderJoinStyle, options.borderJoinStyle);
    ctx.lineWidth = (0, _helpersDatasetJs.v)(style.borderWidth, options.borderWidth);
    ctx.strokeStyle = (0, _helpersDatasetJs.v)(style.borderColor, options.borderColor);
}
function lineTo(ctx, previous, target) {
    ctx.lineTo(target.x, target.y);
}
function getLineMethod(options) {
    if (options.stepped) return 0, _helpersDatasetJs.as;
    if (options.tension || options.cubicInterpolationMode === 'monotone') return 0, _helpersDatasetJs.at;
    return lineTo;
}
function pathVars(points, segment, params = {}) {
    const count = points.length;
    const { start: paramsStart = 0, end: paramsEnd = count - 1 } = params;
    const { start: segmentStart, end: segmentEnd } = segment;
    const start = Math.max(paramsStart, segmentStart);
    const end = Math.min(paramsEnd, segmentEnd);
    const outside = paramsStart < segmentStart && paramsEnd < segmentStart || paramsStart > segmentEnd && paramsEnd > segmentEnd;
    return {
        count,
        start,
        loop: segment.loop,
        ilen: end < start && !outside ? count + end - start : end - start
    };
}
function pathSegment(ctx, line, segment, params) {
    const { points, options } = line;
    const { count, start, loop, ilen } = pathVars(points, segment, params);
    const lineMethod = getLineMethod(options);
    let { move = true, reverse } = params || {};
    let i, point, prev;
    for(i = 0; i <= ilen; ++i){
        point = points[(start + (reverse ? ilen - i : i)) % count];
        if (point.skip) continue;
        else if (move) {
            ctx.moveTo(point.x, point.y);
            move = false;
        } else lineMethod(ctx, prev, point, reverse, options.stepped);
        prev = point;
    }
    if (loop) {
        point = points[(start + (reverse ? ilen : 0)) % count];
        lineMethod(ctx, prev, point, reverse, options.stepped);
    }
    return !!loop;
}
function fastPathSegment(ctx, line, segment, params) {
    const points = line.points;
    const { count, start, ilen } = pathVars(points, segment, params);
    const { move = true, reverse } = params || {};
    let avgX = 0;
    let countX = 0;
    let i, point, prevX, minY, maxY, lastY;
    const pointIndex = (index)=>(start + (reverse ? ilen - index : index)) % count;
    const drawX = ()=>{
        if (minY !== maxY) {
            ctx.lineTo(avgX, maxY);
            ctx.lineTo(avgX, minY);
            ctx.lineTo(avgX, lastY);
        }
    };
    if (move) {
        point = points[pointIndex(0)];
        ctx.moveTo(point.x, point.y);
    }
    for(i = 0; i <= ilen; ++i){
        point = points[pointIndex(i)];
        if (point.skip) continue;
        const x = point.x;
        const y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) minY = y;
            else if (y > maxY) maxY = y;
            avgX = (countX * avgX + x) / ++countX;
        } else {
            drawX();
            ctx.lineTo(x, y);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
        }
        lastY = y;
    }
    drawX();
}
function _getSegmentMethod(line) {
    const opts = line.options;
    const borderDash = opts.borderDash && opts.borderDash.length;
    const useFastPath = !line._decimated && !line._loop && !opts.tension && opts.cubicInterpolationMode !== 'monotone' && !opts.stepped && !borderDash;
    return useFastPath ? fastPathSegment : pathSegment;
}
function _getInterpolationMethod(options) {
    if (options.stepped) return 0, _helpersDatasetJs.ap;
    if (options.tension || options.cubicInterpolationMode === 'monotone') return 0, _helpersDatasetJs.aq;
    return 0, _helpersDatasetJs.ar;
}
function strokePathWithCache(ctx, line, start, count) {
    let path = line._path;
    if (!path) {
        path = line._path = new Path2D();
        if (line.path(path, start, count)) path.closePath();
    }
    setStyle(ctx, line.options);
    ctx.stroke(path);
}
function strokePathDirect(ctx, line, start, count) {
    const { segments, options } = line;
    const segmentMethod = _getSegmentMethod(line);
    for (const segment of segments){
        setStyle(ctx, options, segment.style);
        ctx.beginPath();
        if (segmentMethod(ctx, line, segment, {
            start,
            end: start + count - 1
        })) ctx.closePath();
        ctx.stroke();
    }
}
const usePath2D = typeof Path2D === 'function';
function draw(ctx, line, start, count) {
    if (usePath2D && !line.options.segment) strokePathWithCache(ctx, line, start, count);
    else strokePathDirect(ctx, line, start, count);
}
class LineElement extends Element {
    static id = 'line';
    static defaults = {
        borderCapStyle: 'butt',
        borderDash: [],
        borderDashOffset: 0,
        borderJoinStyle: 'miter',
        borderWidth: 3,
        capBezierPoints: true,
        cubicInterpolationMode: 'default',
        fill: false,
        spanGaps: false,
        stepped: false,
        tension: 0
    };
    static defaultRoutes = {
        backgroundColor: 'backgroundColor',
        borderColor: 'borderColor'
    };
    static descriptors = {
        _scriptable: true,
        _indexable: (name)=>name !== 'borderDash' && name !== 'fill'
    };
    constructor(cfg){
        super();
        this.animated = true;
        this.options = undefined;
        this._chart = undefined;
        this._loop = undefined;
        this._fullLoop = undefined;
        this._path = undefined;
        this._points = undefined;
        this._segments = undefined;
        this._decimated = false;
        this._pointsUpdated = false;
        this._datasetIndex = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    updateControlPoints(chartArea, indexAxis) {
        const options = this.options;
        if ((options.tension || options.cubicInterpolationMode === 'monotone') && !options.stepped && !this._pointsUpdated) {
            const loop = options.spanGaps ? this._loop : this._fullLoop;
            (0, _helpersDatasetJs.am)(this._points, options, chartArea, loop, indexAxis);
            this._pointsUpdated = true;
        }
    }
    set points(points) {
        this._points = points;
        delete this._segments;
        delete this._path;
        this._pointsUpdated = false;
    }
    get points() {
        return this._points;
    }
    get segments() {
        return this._segments || (this._segments = (0, _helpersDatasetJs.an)(this, this.options.segment));
    }
    first() {
        const segments = this.segments;
        const points = this.points;
        return segments.length && points[segments[0].start];
    }
    last() {
        const segments = this.segments;
        const points = this.points;
        const count = segments.length;
        return count && points[segments[count - 1].end];
    }
    interpolate(point, property) {
        const options = this.options;
        const value = point[property];
        const points = this.points;
        const segments = (0, _helpersDatasetJs.ao)(this, {
            property,
            start: value,
            end: value
        });
        if (!segments.length) return;
        const result = [];
        const _interpolate = _getInterpolationMethod(options);
        let i, ilen;
        for(i = 0, ilen = segments.length; i < ilen; ++i){
            const { start, end } = segments[i];
            const p1 = points[start];
            const p2 = points[end];
            if (p1 === p2) {
                result.push(p1);
                continue;
            }
            const t = Math.abs((value - p1[property]) / (p2[property] - p1[property]));
            const interpolated = _interpolate(p1, p2, t, options.stepped);
            interpolated[property] = point[property];
            result.push(interpolated);
        }
        return result.length === 1 ? result[0] : result;
    }
    pathSegment(ctx, segment, params) {
        const segmentMethod = _getSegmentMethod(this);
        return segmentMethod(ctx, this, segment, params);
    }
    path(ctx, start, count) {
        const segments = this.segments;
        const segmentMethod = _getSegmentMethod(this);
        let loop = this._loop;
        start = start || 0;
        count = count || this.points.length - start;
        for (const segment of segments)loop &= segmentMethod(ctx, this, segment, {
            start,
            end: start + count - 1
        });
        return !!loop;
    }
    draw(ctx, chartArea, start, count) {
        const options = this.options || {};
        const points = this.points || [];
        if (points.length && options.borderWidth) {
            ctx.save();
            draw(ctx, this, start, count);
            ctx.restore();
        }
        if (this.animated) {
            this._pointsUpdated = false;
            this._path = undefined;
        }
    }
}
function inRange$1(el, pos, axis, useFinalPosition) {
    const options = el.options;
    const { [axis]: value } = el.getProps([
        axis
    ], useFinalPosition);
    return Math.abs(pos - value) < options.radius + options.hitRadius;
}
class PointElement extends Element {
    static id = 'point';
    parsed;
    skip;
    stop;
    /**
   * @type {any}
   */ static defaults = {
        borderWidth: 1,
        hitRadius: 1,
        hoverBorderWidth: 1,
        hoverRadius: 4,
        pointStyle: 'circle',
        radius: 3,
        rotation: 0
    };
    /**
   * @type {any}
   */ static defaultRoutes = {
        backgroundColor: 'backgroundColor',
        borderColor: 'borderColor'
    };
    constructor(cfg){
        super();
        this.options = undefined;
        this.parsed = undefined;
        this.skip = undefined;
        this.stop = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        const options = this.options;
        const { x, y } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return Math.pow(mouseX - x, 2) + Math.pow(mouseY - y, 2) < Math.pow(options.hitRadius + options.radius, 2);
    }
    inXRange(mouseX, useFinalPosition) {
        return inRange$1(this, mouseX, 'x', useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return inRange$1(this, mouseY, 'y', useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x, y } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return {
            x,
            y
        };
    }
    size(options) {
        options = options || this.options || {};
        let radius = options.radius || 0;
        radius = Math.max(radius, radius && options.hoverRadius || 0);
        const borderWidth = radius && options.borderWidth || 0;
        return (radius + borderWidth) * 2;
    }
    draw(ctx, area) {
        const options = this.options;
        if (this.skip || options.radius < 0.1 || !(0, _helpersDatasetJs.C)(this, area, this.size(options) / 2)) return;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.fillStyle = options.backgroundColor;
        (0, _helpersDatasetJs.au)(ctx, options, this.x, this.y);
    }
    getRange() {
        const options = this.options || {};
        // @ts-expect-error Fallbacks should never be hit in practice
        return options.radius + options.hitRadius;
    }
}
function getBarBounds(bar, useFinalPosition) {
    const { x, y, base, width, height } = bar.getProps([
        'x',
        'y',
        'base',
        'width',
        'height'
    ], useFinalPosition);
    let left, right, top, bottom, half;
    if (bar.horizontal) {
        half = height / 2;
        left = Math.min(x, base);
        right = Math.max(x, base);
        top = y - half;
        bottom = y + half;
    } else {
        half = width / 2;
        left = x - half;
        right = x + half;
        top = Math.min(y, base);
        bottom = Math.max(y, base);
    }
    return {
        left,
        top,
        right,
        bottom
    };
}
function skipOrLimit(skip, value, min, max) {
    return skip ? 0 : (0, _helpersDatasetJs.S)(value, min, max);
}
function parseBorderWidth(bar, maxW, maxH) {
    const value = bar.options.borderWidth;
    const skip = bar.borderSkipped;
    const o = (0, _helpersDatasetJs.aw)(value);
    return {
        t: skipOrLimit(skip.top, o.top, 0, maxH),
        r: skipOrLimit(skip.right, o.right, 0, maxW),
        b: skipOrLimit(skip.bottom, o.bottom, 0, maxH),
        l: skipOrLimit(skip.left, o.left, 0, maxW)
    };
}
function parseBorderRadius(bar, maxW, maxH) {
    const { enableBorderRadius } = bar.getProps([
        'enableBorderRadius'
    ]);
    const value = bar.options.borderRadius;
    const o = (0, _helpersDatasetJs.ax)(value);
    const maxR = Math.min(maxW, maxH);
    const skip = bar.borderSkipped;
    const enableBorder = enableBorderRadius || (0, _helpersDatasetJs.i)(value);
    return {
        topLeft: skipOrLimit(!enableBorder || skip.top || skip.left, o.topLeft, 0, maxR),
        topRight: skipOrLimit(!enableBorder || skip.top || skip.right, o.topRight, 0, maxR),
        bottomLeft: skipOrLimit(!enableBorder || skip.bottom || skip.left, o.bottomLeft, 0, maxR),
        bottomRight: skipOrLimit(!enableBorder || skip.bottom || skip.right, o.bottomRight, 0, maxR)
    };
}
function boundingRects(bar) {
    const bounds = getBarBounds(bar);
    const width = bounds.right - bounds.left;
    const height = bounds.bottom - bounds.top;
    const border = parseBorderWidth(bar, width / 2, height / 2);
    const radius = parseBorderRadius(bar, width / 2, height / 2);
    return {
        outer: {
            x: bounds.left,
            y: bounds.top,
            w: width,
            h: height,
            radius
        },
        inner: {
            x: bounds.left + border.l,
            y: bounds.top + border.t,
            w: width - border.l - border.r,
            h: height - border.t - border.b,
            radius: {
                topLeft: Math.max(0, radius.topLeft - Math.max(border.t, border.l)),
                topRight: Math.max(0, radius.topRight - Math.max(border.t, border.r)),
                bottomLeft: Math.max(0, radius.bottomLeft - Math.max(border.b, border.l)),
                bottomRight: Math.max(0, radius.bottomRight - Math.max(border.b, border.r))
            }
        }
    };
}
function inRange(bar, x, y, useFinalPosition) {
    const skipX = x === null;
    const skipY = y === null;
    const skipBoth = skipX && skipY;
    const bounds = bar && !skipBoth && getBarBounds(bar, useFinalPosition);
    return bounds && (skipX || (0, _helpersDatasetJs.ak)(x, bounds.left, bounds.right)) && (skipY || (0, _helpersDatasetJs.ak)(y, bounds.top, bounds.bottom));
}
function hasRadius(radius) {
    return radius.topLeft || radius.topRight || radius.bottomLeft || radius.bottomRight;
}
function addNormalRectPath(ctx, rect) {
    ctx.rect(rect.x, rect.y, rect.w, rect.h);
}
function inflateRect(rect, amount, refRect = {}) {
    const x = rect.x !== refRect.x ? -amount : 0;
    const y = rect.y !== refRect.y ? -amount : 0;
    const w = (rect.x + rect.w !== refRect.x + refRect.w ? amount : 0) - x;
    const h = (rect.y + rect.h !== refRect.y + refRect.h ? amount : 0) - y;
    return {
        x: rect.x + x,
        y: rect.y + y,
        w: rect.w + w,
        h: rect.h + h,
        radius: rect.radius
    };
}
class BarElement extends Element {
    static id = 'bar';
    static defaults = {
        borderSkipped: 'start',
        borderWidth: 0,
        borderRadius: 0,
        inflateAmount: 'auto',
        pointStyle: undefined
    };
    static defaultRoutes = {
        backgroundColor: 'backgroundColor',
        borderColor: 'borderColor'
    };
    constructor(cfg){
        super();
        this.options = undefined;
        this.horizontal = undefined;
        this.base = undefined;
        this.width = undefined;
        this.height = undefined;
        this.inflateAmount = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    draw(ctx) {
        const { inflateAmount, options: { borderColor, backgroundColor } } = this;
        const { inner, outer } = boundingRects(this);
        const addRectPath = hasRadius(outer.radius) ? (0, _helpersDatasetJs.av) : addNormalRectPath;
        ctx.save();
        if (outer.w !== inner.w || outer.h !== inner.h) {
            ctx.beginPath();
            addRectPath(ctx, inflateRect(outer, inflateAmount, inner));
            ctx.clip();
            addRectPath(ctx, inflateRect(inner, -inflateAmount, outer));
            ctx.fillStyle = borderColor;
            ctx.fill('evenodd');
        }
        ctx.beginPath();
        addRectPath(ctx, inflateRect(inner, inflateAmount));
        ctx.fillStyle = backgroundColor;
        ctx.fill();
        ctx.restore();
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        return inRange(this, mouseX, mouseY, useFinalPosition);
    }
    inXRange(mouseX, useFinalPosition) {
        return inRange(this, mouseX, null, useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return inRange(this, null, mouseY, useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x, y, base, horizontal } = this.getProps([
            'x',
            'y',
            'base',
            'horizontal'
        ], useFinalPosition);
        return {
            x: horizontal ? (x + base) / 2 : x,
            y: horizontal ? y : (y + base) / 2
        };
    }
    getRange(axis) {
        return axis === 'x' ? this.width / 2 : this.height / 2;
    }
}
var elements = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcElement: ArcElement,
    BarElement: BarElement,
    LineElement: LineElement,
    PointElement: PointElement
});
const BORDER_COLORS = [
    'rgb(54, 162, 235)',
    'rgb(255, 99, 132)',
    'rgb(255, 159, 64)',
    'rgb(255, 205, 86)',
    'rgb(75, 192, 192)',
    'rgb(153, 102, 255)',
    'rgb(201, 203, 207)' // grey
];
// Border colors with 50% transparency
const BACKGROUND_COLORS = /* #__PURE__ */ BORDER_COLORS.map((color)=>color.replace('rgb(', 'rgba(').replace(')', ', 0.5)'));
function getBorderColor(i) {
    return BORDER_COLORS[i % BORDER_COLORS.length];
}
function getBackgroundColor(i) {
    return BACKGROUND_COLORS[i % BACKGROUND_COLORS.length];
}
function colorizeDefaultDataset(dataset, i) {
    dataset.borderColor = getBorderColor(i);
    dataset.backgroundColor = getBackgroundColor(i);
    return ++i;
}
function colorizeDoughnutDataset(dataset, i) {
    dataset.backgroundColor = dataset.data.map(()=>getBorderColor(i++));
    return i;
}
function colorizePolarAreaDataset(dataset, i) {
    dataset.backgroundColor = dataset.data.map(()=>getBackgroundColor(i++));
    return i;
}
function getColorizer(chart) {
    let i = 0;
    return (dataset, datasetIndex)=>{
        const controller = chart.getDatasetMeta(datasetIndex).controller;
        if (controller instanceof DoughnutController) i = colorizeDoughnutDataset(dataset, i);
        else if (controller instanceof PolarAreaController) i = colorizePolarAreaDataset(dataset, i);
        else if (controller) i = colorizeDefaultDataset(dataset, i);
    };
}
function containsColorsDefinitions(descriptors) {
    let k;
    for(k in descriptors){
        if (descriptors[k].borderColor || descriptors[k].backgroundColor) return true;
    }
    return false;
}
function containsColorsDefinition(descriptor) {
    return descriptor && (descriptor.borderColor || descriptor.backgroundColor);
}
function containsDefaultColorsDefenitions() {
    return (0, _helpersDatasetJs.d).borderColor !== 'rgba(0,0,0,0.1)' || (0, _helpersDatasetJs.d).backgroundColor !== 'rgba(0,0,0,0.1)';
}
var plugin_colors = {
    id: 'colors',
    defaults: {
        enabled: true,
        forceOverride: false
    },
    beforeLayout (chart, _args, options) {
        if (!options.enabled) return;
        const { data: { datasets }, options: chartOptions } = chart.config;
        const { elements } = chartOptions;
        const containsColorDefenition = containsColorsDefinitions(datasets) || containsColorsDefinition(chartOptions) || elements && containsColorsDefinitions(elements) || containsDefaultColorsDefenitions();
        if (!options.forceOverride && containsColorDefenition) return;
        const colorizer = getColorizer(chart);
        datasets.forEach(colorizer);
    }
};
function lttbDecimation(data, start, count, availableWidth, options) {
    const samples = options.samples || availableWidth;
    if (samples >= count) return data.slice(start, start + count);
    const decimated = [];
    const bucketWidth = (count - 2) / (samples - 2);
    let sampledIndex = 0;
    const endIndex = start + count - 1;
    let a = start;
    let i, maxAreaPoint, maxArea, area, nextA;
    decimated[sampledIndex++] = data[a];
    for(i = 0; i < samples - 2; i++){
        let avgX = 0;
        let avgY = 0;
        let j;
        const avgRangeStart = Math.floor((i + 1) * bucketWidth) + 1 + start;
        const avgRangeEnd = Math.min(Math.floor((i + 2) * bucketWidth) + 1, count) + start;
        const avgRangeLength = avgRangeEnd - avgRangeStart;
        for(j = avgRangeStart; j < avgRangeEnd; j++){
            avgX += data[j].x;
            avgY += data[j].y;
        }
        avgX /= avgRangeLength;
        avgY /= avgRangeLength;
        const rangeOffs = Math.floor(i * bucketWidth) + 1 + start;
        const rangeTo = Math.min(Math.floor((i + 1) * bucketWidth) + 1, count) + start;
        const { x: pointAx, y: pointAy } = data[a];
        maxArea = area = -1;
        for(j = rangeOffs; j < rangeTo; j++){
            area = 0.5 * Math.abs((pointAx - avgX) * (data[j].y - pointAy) - (pointAx - data[j].x) * (avgY - pointAy));
            if (area > maxArea) {
                maxArea = area;
                maxAreaPoint = data[j];
                nextA = j;
            }
        }
        decimated[sampledIndex++] = maxAreaPoint;
        a = nextA;
    }
    decimated[sampledIndex++] = data[endIndex];
    return decimated;
}
function minMaxDecimation(data, start, count, availableWidth) {
    let avgX = 0;
    let countX = 0;
    let i, point, x, y, prevX, minIndex, maxIndex, startIndex, minY, maxY;
    const decimated = [];
    const endIndex = start + count - 1;
    const xMin = data[start].x;
    const xMax = data[endIndex].x;
    const dx = xMax - xMin;
    for(i = start; i < start + count; ++i){
        point = data[i];
        x = (point.x - xMin) / dx * availableWidth;
        y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) {
                minY = y;
                minIndex = i;
            } else if (y > maxY) {
                maxY = y;
                maxIndex = i;
            }
            avgX = (countX * avgX + point.x) / ++countX;
        } else {
            const lastIndex = i - 1;
            if (!(0, _helpersDatasetJs.k)(minIndex) && !(0, _helpersDatasetJs.k)(maxIndex)) {
                const intermediateIndex1 = Math.min(minIndex, maxIndex);
                const intermediateIndex2 = Math.max(minIndex, maxIndex);
                if (intermediateIndex1 !== startIndex && intermediateIndex1 !== lastIndex) decimated.push({
                    ...data[intermediateIndex1],
                    x: avgX
                });
                if (intermediateIndex2 !== startIndex && intermediateIndex2 !== lastIndex) decimated.push({
                    ...data[intermediateIndex2],
                    x: avgX
                });
            }
            if (i > 0 && lastIndex !== startIndex) decimated.push(data[lastIndex]);
            decimated.push(point);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
            minIndex = maxIndex = startIndex = i;
        }
    }
    return decimated;
}
function cleanDecimatedDataset(dataset) {
    if (dataset._decimated) {
        const data = dataset._data;
        delete dataset._decimated;
        delete dataset._data;
        Object.defineProperty(dataset, 'data', {
            configurable: true,
            enumerable: true,
            writable: true,
            value: data
        });
    }
}
function cleanDecimatedData(chart) {
    chart.data.datasets.forEach((dataset)=>{
        cleanDecimatedDataset(dataset);
    });
}
function getStartAndCountOfVisiblePointsSimplified(meta, points) {
    const pointCount = points.length;
    let start = 0;
    let count;
    const { iScale } = meta;
    const { min, max, minDefined, maxDefined } = iScale.getUserBounds();
    if (minDefined) start = (0, _helpersDatasetJs.S)((0, _helpersDatasetJs.B)(points, iScale.axis, min).lo, 0, pointCount - 1);
    if (maxDefined) count = (0, _helpersDatasetJs.S)((0, _helpersDatasetJs.B)(points, iScale.axis, max).hi + 1, start, pointCount) - start;
    else count = pointCount - start;
    return {
        start,
        count
    };
}
var plugin_decimation = {
    id: 'decimation',
    defaults: {
        algorithm: 'min-max',
        enabled: false
    },
    beforeElementsUpdate: (chart, args, options)=>{
        if (!options.enabled) {
            cleanDecimatedData(chart);
            return;
        }
        const availableWidth = chart.width;
        chart.data.datasets.forEach((dataset, datasetIndex)=>{
            const { _data, indexAxis } = dataset;
            const meta = chart.getDatasetMeta(datasetIndex);
            const data = _data || dataset.data;
            if ((0, _helpersDatasetJs.a)([
                indexAxis,
                chart.options.indexAxis
            ]) === 'y') return;
            if (!meta.controller.supportsDecimation) return;
            const xAxis = chart.scales[meta.xAxisID];
            if (xAxis.type !== 'linear' && xAxis.type !== 'time') return;
            if (chart.options.parsing) return;
            let { start, count } = getStartAndCountOfVisiblePointsSimplified(meta, data);
            const threshold = options.threshold || 4 * availableWidth;
            if (count <= threshold) {
                cleanDecimatedDataset(dataset);
                return;
            }
            if ((0, _helpersDatasetJs.k)(_data)) {
                dataset._data = data;
                delete dataset.data;
                Object.defineProperty(dataset, 'data', {
                    configurable: true,
                    enumerable: true,
                    get: function() {
                        return this._decimated;
                    },
                    set: function(d) {
                        this._data = d;
                    }
                });
            }
            let decimated;
            switch(options.algorithm){
                case 'lttb':
                    decimated = lttbDecimation(data, start, count, availableWidth, options);
                    break;
                case 'min-max':
                    decimated = minMaxDecimation(data, start, count, availableWidth);
                    break;
                default:
                    throw new Error(`Unsupported decimation algorithm '${options.algorithm}'`);
            }
            dataset._decimated = decimated;
        });
    },
    destroy (chart) {
        cleanDecimatedData(chart);
    }
};
function _segments(line, target, property) {
    const segments = line.segments;
    const points = line.points;
    const tpoints = target.points;
    const parts = [];
    for (const segment of segments){
        let { start, end } = segment;
        end = _findSegmentEnd(start, end, points);
        const bounds = _getBounds(property, points[start], points[end], segment.loop);
        if (!target.segments) {
            parts.push({
                source: segment,
                target: bounds,
                start: points[start],
                end: points[end]
            });
            continue;
        }
        const targetSegments = (0, _helpersDatasetJs.ao)(target, bounds);
        for (const tgt of targetSegments){
            const subBounds = _getBounds(property, tpoints[tgt.start], tpoints[tgt.end], tgt.loop);
            const fillSources = (0, _helpersDatasetJs.ay)(segment, points, subBounds);
            for (const fillSource of fillSources)parts.push({
                source: fillSource,
                target: tgt,
                start: {
                    [property]: _getEdge(bounds, subBounds, 'start', Math.max)
                },
                end: {
                    [property]: _getEdge(bounds, subBounds, 'end', Math.min)
                }
            });
        }
    }
    return parts;
}
function _getBounds(property, first, last, loop) {
    if (loop) return;
    let start = first[property];
    let end = last[property];
    if (property === 'angle') {
        start = (0, _helpersDatasetJs.az)(start);
        end = (0, _helpersDatasetJs.az)(end);
    }
    return {
        property,
        start,
        end
    };
}
function _pointsFromSegments(boundary, line) {
    const { x = null, y = null } = boundary || {};
    const linePoints = line.points;
    const points = [];
    line.segments.forEach(({ start, end })=>{
        end = _findSegmentEnd(start, end, linePoints);
        const first = linePoints[start];
        const last = linePoints[end];
        if (y !== null) {
            points.push({
                x: first.x,
                y
            });
            points.push({
                x: last.x,
                y
            });
        } else if (x !== null) {
            points.push({
                x,
                y: first.y
            });
            points.push({
                x,
                y: last.y
            });
        }
    });
    return points;
}
function _findSegmentEnd(start, end, points) {
    for(; end > start; end--){
        const point = points[end];
        if (!isNaN(point.x) && !isNaN(point.y)) break;
    }
    return end;
}
function _getEdge(a, b, prop, fn) {
    if (a && b) return fn(a[prop], b[prop]);
    return a ? a[prop] : b ? b[prop] : 0;
}
function _createBoundaryLine(boundary, line) {
    let points = [];
    let _loop = false;
    if ((0, _helpersDatasetJs.b)(boundary)) {
        _loop = true;
        points = boundary;
    } else points = _pointsFromSegments(boundary, line);
    return points.length ? new LineElement({
        points,
        options: {
            tension: 0
        },
        _loop,
        _fullLoop: _loop
    }) : null;
}
function _shouldApplyFill(source) {
    return source && source.fill !== false;
}
function _resolveTarget(sources, index, propagate) {
    const source = sources[index];
    let fill = source.fill;
    const visited = [
        index
    ];
    let target;
    if (!propagate) return fill;
    while(fill !== false && visited.indexOf(fill) === -1){
        if (!(0, _helpersDatasetJs.g)(fill)) return fill;
        target = sources[fill];
        if (!target) return false;
        if (target.visible) return fill;
        visited.push(fill);
        fill = target.fill;
    }
    return false;
}
function _decodeFill(line, index, count) {
    const fill = parseFillOption(line);
    if ((0, _helpersDatasetJs.i)(fill)) return isNaN(fill.value) ? false : fill;
    let target = parseFloat(fill);
    if ((0, _helpersDatasetJs.g)(target) && Math.floor(target) === target) return decodeTargetIndex(fill[0], index, target, count);
    return [
        'origin',
        'start',
        'end',
        'stack',
        'shape'
    ].indexOf(fill) >= 0 && fill;
}
function decodeTargetIndex(firstCh, index, target, count) {
    if (firstCh === '-' || firstCh === '+') target = index + target;
    if (target === index || target < 0 || target >= count) return false;
    return target;
}
function _getTargetPixel(fill, scale) {
    let pixel = null;
    if (fill === 'start') pixel = scale.bottom;
    else if (fill === 'end') pixel = scale.top;
    else if ((0, _helpersDatasetJs.i)(fill)) pixel = scale.getPixelForValue(fill.value);
    else if (scale.getBasePixel) pixel = scale.getBasePixel();
    return pixel;
}
function _getTargetValue(fill, scale, startValue) {
    let value;
    if (fill === 'start') value = startValue;
    else if (fill === 'end') value = scale.options.reverse ? scale.min : scale.max;
    else if ((0, _helpersDatasetJs.i)(fill)) value = fill.value;
    else value = scale.getBaseValue();
    return value;
}
function parseFillOption(line) {
    const options = line.options;
    const fillOption = options.fill;
    let fill = (0, _helpersDatasetJs.v)(fillOption && fillOption.target, fillOption);
    if (fill === undefined) fill = !!options.backgroundColor;
    if (fill === false || fill === null) return false;
    if (fill === true) return 'origin';
    return fill;
}
function _buildStackLine(source) {
    const { scale, index, line } = source;
    const points = [];
    const segments = line.segments;
    const sourcePoints = line.points;
    const linesBelow = getLinesBelow(scale, index);
    linesBelow.push(_createBoundaryLine({
        x: null,
        y: scale.bottom
    }, line));
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        for(let j = segment.start; j <= segment.end; j++)addPointsBelow(points, sourcePoints[j], linesBelow);
    }
    return new LineElement({
        points,
        options: {}
    });
}
function getLinesBelow(scale, index) {
    const below = [];
    const metas = scale.getMatchingVisibleMetas('line');
    for(let i = 0; i < metas.length; i++){
        const meta = metas[i];
        if (meta.index === index) break;
        if (!meta.hidden) below.unshift(meta.dataset);
    }
    return below;
}
function addPointsBelow(points, sourcePoint, linesBelow) {
    const postponed = [];
    for(let j = 0; j < linesBelow.length; j++){
        const line = linesBelow[j];
        const { first, last, point } = findPoint(line, sourcePoint, 'x');
        if (!point || first && last) continue;
        if (first) postponed.unshift(point);
        else {
            points.push(point);
            if (!last) break;
        }
    }
    points.push(...postponed);
}
function findPoint(line, sourcePoint, property) {
    const point = line.interpolate(sourcePoint, property);
    if (!point) return {};
    const pointValue = point[property];
    const segments = line.segments;
    const linePoints = line.points;
    let first = false;
    let last = false;
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        const firstValue = linePoints[segment.start][property];
        const lastValue = linePoints[segment.end][property];
        if ((0, _helpersDatasetJs.ak)(pointValue, firstValue, lastValue)) {
            first = pointValue === firstValue;
            last = pointValue === lastValue;
            break;
        }
    }
    return {
        first,
        last,
        point
    };
}
class simpleArc {
    constructor(opts){
        this.x = opts.x;
        this.y = opts.y;
        this.radius = opts.radius;
    }
    pathSegment(ctx, bounds, opts) {
        const { x, y, radius } = this;
        bounds = bounds || {
            start: 0,
            end: (0, _helpersDatasetJs.T)
        };
        ctx.arc(x, y, radius, bounds.end, bounds.start, true);
        return !opts.bounds;
    }
    interpolate(point) {
        const { x, y, radius } = this;
        const angle = point.angle;
        return {
            x: x + Math.cos(angle) * radius,
            y: y + Math.sin(angle) * radius,
            angle
        };
    }
}
function _getTarget(source) {
    const { chart, fill, line } = source;
    if ((0, _helpersDatasetJs.g)(fill)) return getLineByIndex(chart, fill);
    if (fill === 'stack') return _buildStackLine(source);
    if (fill === 'shape') return true;
    const boundary = computeBoundary(source);
    if (boundary instanceof simpleArc) return boundary;
    return _createBoundaryLine(boundary, line);
}
function getLineByIndex(chart, index) {
    const meta = chart.getDatasetMeta(index);
    const visible = meta && chart.isDatasetVisible(index);
    return visible ? meta.dataset : null;
}
function computeBoundary(source) {
    const scale = source.scale || {};
    if (scale.getPointPositionForValue) return computeCircularBoundary(source);
    return computeLinearBoundary(source);
}
function computeLinearBoundary(source) {
    const { scale = {}, fill } = source;
    const pixel = _getTargetPixel(fill, scale);
    if ((0, _helpersDatasetJs.g)(pixel)) {
        const horizontal = scale.isHorizontal();
        return {
            x: horizontal ? pixel : null,
            y: horizontal ? null : pixel
        };
    }
    return null;
}
function computeCircularBoundary(source) {
    const { scale, fill } = source;
    const options = scale.options;
    const length = scale.getLabels().length;
    const start = options.reverse ? scale.max : scale.min;
    const value = _getTargetValue(fill, scale, start);
    const target = [];
    if (options.grid.circular) {
        const center = scale.getPointPositionForValue(0, start);
        return new simpleArc({
            x: center.x,
            y: center.y,
            radius: scale.getDistanceFromCenterForValue(value)
        });
    }
    for(let i = 0; i < length; ++i)target.push(scale.getPointPositionForValue(i, value));
    return target;
}
function _drawfill(ctx, source, area) {
    const target = _getTarget(source);
    const { chart, index, line, scale, axis } = source;
    const lineOpts = line.options;
    const fillOption = lineOpts.fill;
    const color = lineOpts.backgroundColor;
    const { above = color, below = color } = fillOption || {};
    const meta = chart.getDatasetMeta(index);
    const clip = (0, _helpersDatasetJs.ah)(chart, meta);
    if (target && line.points.length) {
        (0, _helpersDatasetJs.Y)(ctx, area);
        doFill(ctx, {
            line,
            target,
            above,
            below,
            area,
            scale,
            axis,
            clip
        });
        (0, _helpersDatasetJs.$)(ctx);
    }
}
function doFill(ctx, cfg) {
    const { line, target, above, below, area, scale, clip } = cfg;
    const property = line._loop ? 'angle' : cfg.axis;
    ctx.save();
    if (property === 'x' && below !== above) {
        clipVertical(ctx, target, area.top);
        fill(ctx, {
            line,
            target,
            color: above,
            scale,
            property,
            clip
        });
        ctx.restore();
        ctx.save();
        clipVertical(ctx, target, area.bottom);
    }
    fill(ctx, {
        line,
        target,
        color: below,
        scale,
        property,
        clip
    });
    ctx.restore();
}
function clipVertical(ctx, target, clipY) {
    const { segments, points } = target;
    let first = true;
    let lineLoop = false;
    ctx.beginPath();
    for (const segment of segments){
        const { start, end } = segment;
        const firstPoint = points[start];
        const lastPoint = points[_findSegmentEnd(start, end, points)];
        if (first) {
            ctx.moveTo(firstPoint.x, firstPoint.y);
            first = false;
        } else {
            ctx.lineTo(firstPoint.x, clipY);
            ctx.lineTo(firstPoint.x, firstPoint.y);
        }
        lineLoop = !!target.pathSegment(ctx, segment, {
            move: lineLoop
        });
        if (lineLoop) ctx.closePath();
        else ctx.lineTo(lastPoint.x, clipY);
    }
    ctx.lineTo(target.first().x, clipY);
    ctx.closePath();
    ctx.clip();
}
function fill(ctx, cfg) {
    const { line, target, property, color, scale, clip } = cfg;
    const segments = _segments(line, target, property);
    for (const { source: src, target: tgt, start, end } of segments){
        const { style: { backgroundColor = color } = {} } = src;
        const notShape = target !== true;
        ctx.save();
        ctx.fillStyle = backgroundColor;
        clipBounds(ctx, scale, clip, notShape && _getBounds(property, start, end));
        ctx.beginPath();
        const lineLoop = !!line.pathSegment(ctx, src);
        let loop;
        if (notShape) {
            if (lineLoop) ctx.closePath();
            else interpolatedLineTo(ctx, target, end, property);
            const targetLoop = !!target.pathSegment(ctx, tgt, {
                move: lineLoop,
                reverse: true
            });
            loop = lineLoop && targetLoop;
            if (!loop) interpolatedLineTo(ctx, target, start, property);
        }
        ctx.closePath();
        ctx.fill(loop ? 'evenodd' : 'nonzero');
        ctx.restore();
    }
}
function clipBounds(ctx, scale, clip, bounds) {
    const chartArea = scale.chart.chartArea;
    const { property, start, end } = bounds || {};
    if (property === 'x' || property === 'y') {
        let left, top, right, bottom;
        if (property === 'x') {
            left = start;
            top = chartArea.top;
            right = end;
            bottom = chartArea.bottom;
        } else {
            left = chartArea.left;
            top = start;
            right = chartArea.right;
            bottom = end;
        }
        ctx.beginPath();
        if (clip) {
            left = Math.max(left, clip.left);
            right = Math.min(right, clip.right);
            top = Math.max(top, clip.top);
            bottom = Math.min(bottom, clip.bottom);
        }
        ctx.rect(left, top, right - left, bottom - top);
        ctx.clip();
    }
}
function interpolatedLineTo(ctx, target, point, property) {
    const interpolatedPoint = target.interpolate(point, property);
    if (interpolatedPoint) ctx.lineTo(interpolatedPoint.x, interpolatedPoint.y);
}
var index = {
    id: 'filler',
    afterDatasetsUpdate (chart, _args, options) {
        const count = (chart.data.datasets || []).length;
        const sources = [];
        let meta, i, line, source;
        for(i = 0; i < count; ++i){
            meta = chart.getDatasetMeta(i);
            line = meta.dataset;
            source = null;
            if (line && line.options && line instanceof LineElement) source = {
                visible: chart.isDatasetVisible(i),
                index: i,
                fill: _decodeFill(line, i, count),
                chart,
                axis: meta.controller.options.indexAxis,
                scale: meta.vScale,
                line
            };
            meta.$filler = source;
            sources.push(source);
        }
        for(i = 0; i < count; ++i){
            source = sources[i];
            if (!source || source.fill === false) continue;
            source.fill = _resolveTarget(sources, i, options.propagate);
        }
    },
    beforeDraw (chart, _args, options) {
        const draw = options.drawTime === 'beforeDraw';
        const metasets = chart.getSortedVisibleDatasetMetas();
        const area = chart.chartArea;
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if (!source) continue;
            source.line.updateControlPoints(area, source.axis);
            if (draw && source.fill) _drawfill(chart.ctx, source, area);
        }
    },
    beforeDatasetsDraw (chart, _args, options) {
        if (options.drawTime !== 'beforeDatasetsDraw') return;
        const metasets = chart.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if (_shouldApplyFill(source)) _drawfill(chart.ctx, source, chart.chartArea);
        }
    },
    beforeDatasetDraw (chart, args, options) {
        const source = args.meta.$filler;
        if (!_shouldApplyFill(source) || options.drawTime !== 'beforeDatasetDraw') return;
        _drawfill(chart.ctx, source, chart.chartArea);
    },
    defaults: {
        propagate: true,
        drawTime: 'beforeDatasetDraw'
    }
};
const getBoxSize = (labelOpts, fontSize)=>{
    let { boxHeight = fontSize, boxWidth = fontSize } = labelOpts;
    if (labelOpts.usePointStyle) {
        boxHeight = Math.min(boxHeight, fontSize);
        boxWidth = labelOpts.pointStyleWidth || Math.min(boxWidth, fontSize);
    }
    return {
        boxWidth,
        boxHeight,
        itemHeight: Math.max(fontSize, boxHeight)
    };
};
const itemsEqual = (a, b)=>a !== null && b !== null && a.datasetIndex === b.datasetIndex && a.index === b.index;
class Legend extends Element {
    constructor(config){
        super();
        this._added = false;
        this.legendHitBoxes = [];
        this._hoveredItem = null;
        this.doughnutMode = false;
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this.legendItems = undefined;
        this.columnSizes = undefined;
        this.lineWidths = undefined;
        this.maxHeight = undefined;
        this.maxWidth = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.height = undefined;
        this.width = undefined;
        this._margins = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
    update(maxWidth, maxHeight, margins) {
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins;
        this.setDimensions();
        this.buildLabels();
        this.fit();
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = this._margins.left;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = this._margins.top;
            this.bottom = this.height;
        }
    }
    buildLabels() {
        const labelOpts = this.options.labels || {};
        let legendItems = (0, _helpersDatasetJs.Q)(labelOpts.generateLabels, [
            this.chart
        ], this) || [];
        if (labelOpts.filter) legendItems = legendItems.filter((item)=>labelOpts.filter(item, this.chart.data));
        if (labelOpts.sort) legendItems = legendItems.sort((a, b)=>labelOpts.sort(a, b, this.chart.data));
        if (this.options.reverse) legendItems.reverse();
        this.legendItems = legendItems;
    }
    fit() {
        const { options, ctx } = this;
        if (!options.display) {
            this.width = this.height = 0;
            return;
        }
        const labelOpts = options.labels;
        const labelFont = (0, _helpersDatasetJs.a0)(labelOpts.font);
        const fontSize = labelFont.size;
        const titleHeight = this._computeTitleHeight();
        const { boxWidth, itemHeight } = getBoxSize(labelOpts, fontSize);
        let width, height;
        ctx.font = labelFont.string;
        if (this.isHorizontal()) {
            width = this.maxWidth;
            height = this._fitRows(titleHeight, fontSize, boxWidth, itemHeight) + 10;
        } else {
            height = this.maxHeight;
            width = this._fitCols(titleHeight, labelFont, boxWidth, itemHeight) + 10;
        }
        this.width = Math.min(width, options.maxWidth || this.maxWidth);
        this.height = Math.min(height, options.maxHeight || this.maxHeight);
    }
    _fitRows(titleHeight, fontSize, boxWidth, itemHeight) {
        const { ctx, maxWidth, options: { labels: { padding } } } = this;
        const hitboxes = this.legendHitBoxes = [];
        const lineWidths = this.lineWidths = [
            0
        ];
        const lineHeight = itemHeight + padding;
        let totalHeight = titleHeight;
        ctx.textAlign = 'left';
        ctx.textBaseline = 'middle';
        let row = -1;
        let top = -lineHeight;
        this.legendItems.forEach((legendItem, i)=>{
            const itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
            if (i === 0 || lineWidths[lineWidths.length - 1] + itemWidth + 2 * padding > maxWidth) {
                totalHeight += lineHeight;
                lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
                top += lineHeight;
                row++;
            }
            hitboxes[i] = {
                left: 0,
                top,
                row,
                width: itemWidth,
                height: itemHeight
            };
            lineWidths[lineWidths.length - 1] += itemWidth + padding;
        });
        return totalHeight;
    }
    _fitCols(titleHeight, labelFont, boxWidth, _itemHeight) {
        const { ctx, maxHeight, options: { labels: { padding } } } = this;
        const hitboxes = this.legendHitBoxes = [];
        const columnSizes = this.columnSizes = [];
        const heightLimit = maxHeight - titleHeight;
        let totalWidth = padding;
        let currentColWidth = 0;
        let currentColHeight = 0;
        let left = 0;
        let col = 0;
        this.legendItems.forEach((legendItem, i)=>{
            const { itemWidth, itemHeight } = calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight);
            if (i > 0 && currentColHeight + itemHeight + 2 * padding > heightLimit) {
                totalWidth += currentColWidth + padding;
                columnSizes.push({
                    width: currentColWidth,
                    height: currentColHeight
                });
                left += currentColWidth + padding;
                col++;
                currentColWidth = currentColHeight = 0;
            }
            hitboxes[i] = {
                left,
                top: currentColHeight,
                col,
                width: itemWidth,
                height: itemHeight
            };
            currentColWidth = Math.max(currentColWidth, itemWidth);
            currentColHeight += itemHeight + padding;
        });
        totalWidth += currentColWidth;
        columnSizes.push({
            width: currentColWidth,
            height: currentColHeight
        });
        return totalWidth;
    }
    adjustHitBoxes() {
        if (!this.options.display) return;
        const titleHeight = this._computeTitleHeight();
        const { legendHitBoxes: hitboxes, options: { align, labels: { padding }, rtl } } = this;
        const rtlHelper = (0, _helpersDatasetJs.aA)(rtl, this.left, this.width);
        if (this.isHorizontal()) {
            let row = 0;
            let left = (0, _helpersDatasetJs.a2)(align, this.left + padding, this.right - this.lineWidths[row]);
            for (const hitbox of hitboxes){
                if (row !== hitbox.row) {
                    row = hitbox.row;
                    left = (0, _helpersDatasetJs.a2)(align, this.left + padding, this.right - this.lineWidths[row]);
                }
                hitbox.top += this.top + titleHeight + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(left), hitbox.width);
                left += hitbox.width + padding;
            }
        } else {
            let col = 0;
            let top = (0, _helpersDatasetJs.a2)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
            for (const hitbox of hitboxes){
                if (hitbox.col !== col) {
                    col = hitbox.col;
                    top = (0, _helpersDatasetJs.a2)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
                }
                hitbox.top = top;
                hitbox.left += this.left + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(hitbox.left), hitbox.width);
                top += hitbox.height + padding;
            }
        }
    }
    isHorizontal() {
        return this.options.position === 'top' || this.options.position === 'bottom';
    }
    draw() {
        if (this.options.display) {
            const ctx = this.ctx;
            (0, _helpersDatasetJs.Y)(ctx, this);
            this._draw();
            (0, _helpersDatasetJs.$)(ctx);
        }
    }
    _draw() {
        const { options: opts, columnSizes, lineWidths, ctx } = this;
        const { align, labels: labelOpts } = opts;
        const defaultColor = (0, _helpersDatasetJs.d).color;
        const rtlHelper = (0, _helpersDatasetJs.aA)(opts.rtl, this.left, this.width);
        const labelFont = (0, _helpersDatasetJs.a0)(labelOpts.font);
        const { padding } = labelOpts;
        const fontSize = labelFont.size;
        const halfFontSize = fontSize / 2;
        let cursor;
        this.drawTitle();
        ctx.textAlign = rtlHelper.textAlign('left');
        ctx.textBaseline = 'middle';
        ctx.lineWidth = 0.5;
        ctx.font = labelFont.string;
        const { boxWidth, boxHeight, itemHeight } = getBoxSize(labelOpts, fontSize);
        const drawLegendBox = function(x, y, legendItem) {
            if (isNaN(boxWidth) || boxWidth <= 0 || isNaN(boxHeight) || boxHeight < 0) return;
            ctx.save();
            const lineWidth = (0, _helpersDatasetJs.v)(legendItem.lineWidth, 1);
            ctx.fillStyle = (0, _helpersDatasetJs.v)(legendItem.fillStyle, defaultColor);
            ctx.lineCap = (0, _helpersDatasetJs.v)(legendItem.lineCap, 'butt');
            ctx.lineDashOffset = (0, _helpersDatasetJs.v)(legendItem.lineDashOffset, 0);
            ctx.lineJoin = (0, _helpersDatasetJs.v)(legendItem.lineJoin, 'miter');
            ctx.lineWidth = lineWidth;
            ctx.strokeStyle = (0, _helpersDatasetJs.v)(legendItem.strokeStyle, defaultColor);
            ctx.setLineDash((0, _helpersDatasetJs.v)(legendItem.lineDash, []));
            if (labelOpts.usePointStyle) {
                const drawOptions = {
                    radius: boxHeight * Math.SQRT2 / 2,
                    pointStyle: legendItem.pointStyle,
                    rotation: legendItem.rotation,
                    borderWidth: lineWidth
                };
                const centerX = rtlHelper.xPlus(x, boxWidth / 2);
                const centerY = y + halfFontSize;
                (0, _helpersDatasetJs.aE)(ctx, drawOptions, centerX, centerY, labelOpts.pointStyleWidth && boxWidth);
            } else {
                const yBoxTop = y + Math.max((fontSize - boxHeight) / 2, 0);
                const xBoxLeft = rtlHelper.leftForLtr(x, boxWidth);
                const borderRadius = (0, _helpersDatasetJs.ax)(legendItem.borderRadius);
                ctx.beginPath();
                if (Object.values(borderRadius).some((v)=>v !== 0)) (0, _helpersDatasetJs.av)(ctx, {
                    x: xBoxLeft,
                    y: yBoxTop,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                else ctx.rect(xBoxLeft, yBoxTop, boxWidth, boxHeight);
                ctx.fill();
                if (lineWidth !== 0) ctx.stroke();
            }
            ctx.restore();
        };
        const fillText = function(x, y, legendItem) {
            (0, _helpersDatasetJs.Z)(ctx, legendItem.text, x, y + itemHeight / 2, labelFont, {
                strikethrough: legendItem.hidden,
                textAlign: rtlHelper.textAlign(legendItem.textAlign)
            });
        };
        const isHorizontal = this.isHorizontal();
        const titleHeight = this._computeTitleHeight();
        if (isHorizontal) cursor = {
            x: (0, _helpersDatasetJs.a2)(align, this.left + padding, this.right - lineWidths[0]),
            y: this.top + padding + titleHeight,
            line: 0
        };
        else cursor = {
            x: this.left + padding,
            y: (0, _helpersDatasetJs.a2)(align, this.top + titleHeight + padding, this.bottom - columnSizes[0].height),
            line: 0
        };
        (0, _helpersDatasetJs.aB)(this.ctx, opts.textDirection);
        const lineHeight = itemHeight + padding;
        this.legendItems.forEach((legendItem, i)=>{
            ctx.strokeStyle = legendItem.fontColor;
            ctx.fillStyle = legendItem.fontColor;
            const textWidth = ctx.measureText(legendItem.text).width;
            const textAlign = rtlHelper.textAlign(legendItem.textAlign || (legendItem.textAlign = labelOpts.textAlign));
            const width = boxWidth + halfFontSize + textWidth;
            let x = cursor.x;
            let y = cursor.y;
            rtlHelper.setWidth(this.width);
            if (isHorizontal) {
                if (i > 0 && x + width + padding > this.right) {
                    y = cursor.y += lineHeight;
                    cursor.line++;
                    x = cursor.x = (0, _helpersDatasetJs.a2)(align, this.left + padding, this.right - lineWidths[cursor.line]);
                }
            } else if (i > 0 && y + lineHeight > this.bottom) {
                x = cursor.x = x + columnSizes[cursor.line].width + padding;
                cursor.line++;
                y = cursor.y = (0, _helpersDatasetJs.a2)(align, this.top + titleHeight + padding, this.bottom - columnSizes[cursor.line].height);
            }
            const realX = rtlHelper.x(x);
            drawLegendBox(realX, y, legendItem);
            x = (0, _helpersDatasetJs.aC)(textAlign, x + boxWidth + halfFontSize, isHorizontal ? x + width : this.right, opts.rtl);
            fillText(rtlHelper.x(x), y, legendItem);
            if (isHorizontal) cursor.x += width + padding;
            else if (typeof legendItem.text !== 'string') {
                const fontLineHeight = labelFont.lineHeight;
                cursor.y += calculateLegendItemHeight(legendItem, fontLineHeight) + padding;
            } else cursor.y += lineHeight;
        });
        (0, _helpersDatasetJs.aD)(this.ctx, opts.textDirection);
    }
    drawTitle() {
        const opts = this.options;
        const titleOpts = opts.title;
        const titleFont = (0, _helpersDatasetJs.a0)(titleOpts.font);
        const titlePadding = (0, _helpersDatasetJs.E)(titleOpts.padding);
        if (!titleOpts.display) return;
        const rtlHelper = (0, _helpersDatasetJs.aA)(opts.rtl, this.left, this.width);
        const ctx = this.ctx;
        const position = titleOpts.position;
        const halfFontSize = titleFont.size / 2;
        const topPaddingPlusHalfFontSize = titlePadding.top + halfFontSize;
        let y;
        let left = this.left;
        let maxWidth = this.width;
        if (this.isHorizontal()) {
            maxWidth = Math.max(...this.lineWidths);
            y = this.top + topPaddingPlusHalfFontSize;
            left = (0, _helpersDatasetJs.a2)(opts.align, left, this.right - maxWidth);
        } else {
            const maxHeight = this.columnSizes.reduce((acc, size)=>Math.max(acc, size.height), 0);
            y = topPaddingPlusHalfFontSize + (0, _helpersDatasetJs.a2)(opts.align, this.top, this.bottom - maxHeight - opts.labels.padding - this._computeTitleHeight());
        }
        const x = (0, _helpersDatasetJs.a2)(position, left, left + maxWidth);
        ctx.textAlign = rtlHelper.textAlign((0, _helpersDatasetJs.a1)(position));
        ctx.textBaseline = 'middle';
        ctx.strokeStyle = titleOpts.color;
        ctx.fillStyle = titleOpts.color;
        ctx.font = titleFont.string;
        (0, _helpersDatasetJs.Z)(ctx, titleOpts.text, x, y, titleFont);
    }
    _computeTitleHeight() {
        const titleOpts = this.options.title;
        const titleFont = (0, _helpersDatasetJs.a0)(titleOpts.font);
        const titlePadding = (0, _helpersDatasetJs.E)(titleOpts.padding);
        return titleOpts.display ? titleFont.lineHeight + titlePadding.height : 0;
    }
    _getLegendItemAt(x, y) {
        let i, hitBox, lh;
        if ((0, _helpersDatasetJs.ak)(x, this.left, this.right) && (0, _helpersDatasetJs.ak)(y, this.top, this.bottom)) {
            lh = this.legendHitBoxes;
            for(i = 0; i < lh.length; ++i){
                hitBox = lh[i];
                if ((0, _helpersDatasetJs.ak)(x, hitBox.left, hitBox.left + hitBox.width) && (0, _helpersDatasetJs.ak)(y, hitBox.top, hitBox.top + hitBox.height)) return this.legendItems[i];
            }
        }
        return null;
    }
    handleEvent(e) {
        const opts = this.options;
        if (!isListened(e.type, opts)) return;
        const hoveredItem = this._getLegendItemAt(e.x, e.y);
        if (e.type === 'mousemove' || e.type === 'mouseout') {
            const previous = this._hoveredItem;
            const sameItem = itemsEqual(previous, hoveredItem);
            if (previous && !sameItem) (0, _helpersDatasetJs.Q)(opts.onLeave, [
                e,
                previous,
                this
            ], this);
            this._hoveredItem = hoveredItem;
            if (hoveredItem && !sameItem) (0, _helpersDatasetJs.Q)(opts.onHover, [
                e,
                hoveredItem,
                this
            ], this);
        } else if (hoveredItem) (0, _helpersDatasetJs.Q)(opts.onClick, [
            e,
            hoveredItem,
            this
        ], this);
    }
}
function calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight) {
    const itemWidth = calculateItemWidth(legendItem, boxWidth, labelFont, ctx);
    const itemHeight = calculateItemHeight(_itemHeight, legendItem, labelFont.lineHeight);
    return {
        itemWidth,
        itemHeight
    };
}
function calculateItemWidth(legendItem, boxWidth, labelFont, ctx) {
    let legendItemText = legendItem.text;
    if (legendItemText && typeof legendItemText !== 'string') legendItemText = legendItemText.reduce((a, b)=>a.length > b.length ? a : b);
    return boxWidth + labelFont.size / 2 + ctx.measureText(legendItemText).width;
}
function calculateItemHeight(_itemHeight, legendItem, fontLineHeight) {
    let itemHeight = _itemHeight;
    if (typeof legendItem.text !== 'string') itemHeight = calculateLegendItemHeight(legendItem, fontLineHeight);
    return itemHeight;
}
function calculateLegendItemHeight(legendItem, fontLineHeight) {
    const labelHeight = legendItem.text ? legendItem.text.length : 0;
    return fontLineHeight * labelHeight;
}
function isListened(type, opts) {
    if ((type === 'mousemove' || type === 'mouseout') && (opts.onHover || opts.onLeave)) return true;
    if (opts.onClick && (type === 'click' || type === 'mouseup')) return true;
    return false;
}
var plugin_legend = {
    id: 'legend',
    _element: Legend,
    start (chart, _args, options) {
        const legend = chart.legend = new Legend({
            ctx: chart.ctx,
            options,
            chart
        });
        layouts.configure(chart, legend, options);
        layouts.addBox(chart, legend);
    },
    stop (chart) {
        layouts.removeBox(chart, chart.legend);
        delete chart.legend;
    },
    beforeUpdate (chart, _args, options) {
        const legend = chart.legend;
        layouts.configure(chart, legend, options);
        legend.options = options;
    },
    afterUpdate (chart) {
        const legend = chart.legend;
        legend.buildLabels();
        legend.adjustHitBoxes();
    },
    afterEvent (chart, args) {
        if (!args.replay) chart.legend.handleEvent(args.event);
    },
    defaults: {
        display: true,
        position: 'top',
        align: 'center',
        fullSize: true,
        reverse: false,
        weight: 1000,
        onClick (e, legendItem, legend) {
            const index = legendItem.datasetIndex;
            const ci = legend.chart;
            if (ci.isDatasetVisible(index)) {
                ci.hide(index);
                legendItem.hidden = true;
            } else {
                ci.show(index);
                legendItem.hidden = false;
            }
        },
        onHover: null,
        onLeave: null,
        labels: {
            color: (ctx)=>ctx.chart.options.color,
            boxWidth: 40,
            padding: 10,
            generateLabels (chart) {
                const datasets = chart.data.datasets;
                const { labels: { usePointStyle, pointStyle, textAlign, color, useBorderRadius, borderRadius } } = chart.legend.options;
                return chart._getSortedDatasetMetas().map((meta)=>{
                    const style = meta.controller.getStyle(usePointStyle ? 0 : undefined);
                    const borderWidth = (0, _helpersDatasetJs.E)(style.borderWidth);
                    return {
                        text: datasets[meta.index].label,
                        fillStyle: style.backgroundColor,
                        fontColor: color,
                        hidden: !meta.visible,
                        lineCap: style.borderCapStyle,
                        lineDash: style.borderDash,
                        lineDashOffset: style.borderDashOffset,
                        lineJoin: style.borderJoinStyle,
                        lineWidth: (borderWidth.width + borderWidth.height) / 4,
                        strokeStyle: style.borderColor,
                        pointStyle: pointStyle || style.pointStyle,
                        rotation: style.rotation,
                        textAlign: textAlign || style.textAlign,
                        borderRadius: useBorderRadius && (borderRadius || style.borderRadius),
                        datasetIndex: meta.index
                    };
                }, this);
            }
        },
        title: {
            color: (ctx)=>ctx.chart.options.color,
            display: false,
            position: 'center',
            text: ''
        }
    },
    descriptors: {
        _scriptable: (name)=>!name.startsWith('on'),
        labels: {
            _scriptable: (name)=>![
                    'generateLabels',
                    'filter',
                    'sort'
                ].includes(name)
        }
    }
};
class Title extends Element {
    constructor(config){
        super();
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this._padding = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
    update(maxWidth, maxHeight) {
        const opts = this.options;
        this.left = 0;
        this.top = 0;
        if (!opts.display) {
            this.width = this.height = this.right = this.bottom = 0;
            return;
        }
        this.width = this.right = maxWidth;
        this.height = this.bottom = maxHeight;
        const lineCount = (0, _helpersDatasetJs.b)(opts.text) ? opts.text.length : 1;
        this._padding = (0, _helpersDatasetJs.E)(opts.padding);
        const textSize = lineCount * (0, _helpersDatasetJs.a0)(opts.font).lineHeight + this._padding.height;
        if (this.isHorizontal()) this.height = textSize;
        else this.width = textSize;
    }
    isHorizontal() {
        const pos = this.options.position;
        return pos === 'top' || pos === 'bottom';
    }
    _drawArgs(offset) {
        const { top, left, bottom, right, options } = this;
        const align = options.align;
        let rotation = 0;
        let maxWidth, titleX, titleY;
        if (this.isHorizontal()) {
            titleX = (0, _helpersDatasetJs.a2)(align, left, right);
            titleY = top + offset;
            maxWidth = right - left;
        } else {
            if (options.position === 'left') {
                titleX = left + offset;
                titleY = (0, _helpersDatasetJs.a2)(align, bottom, top);
                rotation = (0, _helpersDatasetJs.P) * -0.5;
            } else {
                titleX = right - offset;
                titleY = (0, _helpersDatasetJs.a2)(align, top, bottom);
                rotation = (0, _helpersDatasetJs.P) * 0.5;
            }
            maxWidth = bottom - top;
        }
        return {
            titleX,
            titleY,
            maxWidth,
            rotation
        };
    }
    draw() {
        const ctx = this.ctx;
        const opts = this.options;
        if (!opts.display) return;
        const fontOpts = (0, _helpersDatasetJs.a0)(opts.font);
        const lineHeight = fontOpts.lineHeight;
        const offset = lineHeight / 2 + this._padding.top;
        const { titleX, titleY, maxWidth, rotation } = this._drawArgs(offset);
        (0, _helpersDatasetJs.Z)(ctx, opts.text, 0, 0, fontOpts, {
            color: opts.color,
            maxWidth,
            rotation,
            textAlign: (0, _helpersDatasetJs.a1)(opts.align),
            textBaseline: 'middle',
            translation: [
                titleX,
                titleY
            ]
        });
    }
}
function createTitle(chart, titleOpts) {
    const title = new Title({
        ctx: chart.ctx,
        options: titleOpts,
        chart
    });
    layouts.configure(chart, title, titleOpts);
    layouts.addBox(chart, title);
    chart.titleBlock = title;
}
var plugin_title = {
    id: 'title',
    _element: Title,
    start (chart, _args, options) {
        createTitle(chart, options);
    },
    stop (chart) {
        const titleBlock = chart.titleBlock;
        layouts.removeBox(chart, titleBlock);
        delete chart.titleBlock;
    },
    beforeUpdate (chart, _args, options) {
        const title = chart.titleBlock;
        layouts.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: 'center',
        display: false,
        font: {
            weight: 'bold'
        },
        fullSize: true,
        padding: 10,
        position: 'top',
        text: '',
        weight: 2000
    },
    defaultRoutes: {
        color: 'color'
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const map = new WeakMap();
var plugin_subtitle = {
    id: 'subtitle',
    start (chart, _args, options) {
        const title = new Title({
            ctx: chart.ctx,
            options,
            chart
        });
        layouts.configure(chart, title, options);
        layouts.addBox(chart, title);
        map.set(chart, title);
    },
    stop (chart) {
        layouts.removeBox(chart, map.get(chart));
        map.delete(chart);
    },
    beforeUpdate (chart, _args, options) {
        const title = map.get(chart);
        layouts.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: 'center',
        display: false,
        font: {
            weight: 'normal'
        },
        fullSize: true,
        padding: 0,
        position: 'top',
        text: '',
        weight: 1500
    },
    defaultRoutes: {
        color: 'color'
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const positioners = {
    average (items) {
        if (!items.length) return false;
        let i, len;
        let xSet = new Set();
        let y = 0;
        let count = 0;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const pos = el.tooltipPosition();
                xSet.add(pos.x);
                y += pos.y;
                ++count;
            }
        }
        if (count === 0 || xSet.size === 0) return false;
        const xAverage = [
            ...xSet
        ].reduce((a, b)=>a + b) / xSet.size;
        return {
            x: xAverage,
            y: y / count
        };
    },
    nearest (items, eventPosition) {
        if (!items.length) return false;
        let x = eventPosition.x;
        let y = eventPosition.y;
        let minDistance = Number.POSITIVE_INFINITY;
        let i, len, nearestElement;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const center = el.getCenterPoint();
                const d = (0, _helpersDatasetJs.aF)(eventPosition, center);
                if (d < minDistance) {
                    minDistance = d;
                    nearestElement = el;
                }
            }
        }
        if (nearestElement) {
            const tp = nearestElement.tooltipPosition();
            x = tp.x;
            y = tp.y;
        }
        return {
            x,
            y
        };
    }
};
function pushOrConcat(base, toPush) {
    if (toPush) {
        if ((0, _helpersDatasetJs.b)(toPush)) Array.prototype.push.apply(base, toPush);
        else base.push(toPush);
    }
    return base;
}
function splitNewlines(str) {
    if ((typeof str === 'string' || str instanceof String) && str.indexOf('\n') > -1) return str.split('\n');
    return str;
}
function createTooltipItem(chart, item) {
    const { element, datasetIndex, index } = item;
    const controller = chart.getDatasetMeta(datasetIndex).controller;
    const { label, value } = controller.getLabelAndValue(index);
    return {
        chart,
        label,
        parsed: controller.getParsed(index),
        raw: chart.data.datasets[datasetIndex].data[index],
        formattedValue: value,
        dataset: controller.getDataset(),
        dataIndex: index,
        datasetIndex,
        element
    };
}
function getTooltipSize(tooltip, options) {
    const ctx = tooltip.chart.ctx;
    const { body, footer, title } = tooltip;
    const { boxWidth, boxHeight } = options;
    const bodyFont = (0, _helpersDatasetJs.a0)(options.bodyFont);
    const titleFont = (0, _helpersDatasetJs.a0)(options.titleFont);
    const footerFont = (0, _helpersDatasetJs.a0)(options.footerFont);
    const titleLineCount = title.length;
    const footerLineCount = footer.length;
    const bodyLineItemCount = body.length;
    const padding = (0, _helpersDatasetJs.E)(options.padding);
    let height = padding.height;
    let width = 0;
    let combinedBodyLength = body.reduce((count, bodyItem)=>count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length, 0);
    combinedBodyLength += tooltip.beforeBody.length + tooltip.afterBody.length;
    if (titleLineCount) height += titleLineCount * titleFont.lineHeight + (titleLineCount - 1) * options.titleSpacing + options.titleMarginBottom;
    if (combinedBodyLength) {
        const bodyLineHeight = options.displayColors ? Math.max(boxHeight, bodyFont.lineHeight) : bodyFont.lineHeight;
        height += bodyLineItemCount * bodyLineHeight + (combinedBodyLength - bodyLineItemCount) * bodyFont.lineHeight + (combinedBodyLength - 1) * options.bodySpacing;
    }
    if (footerLineCount) height += options.footerMarginTop + footerLineCount * footerFont.lineHeight + (footerLineCount - 1) * options.footerSpacing;
    let widthPadding = 0;
    const maxLineWidth = function(line) {
        width = Math.max(width, ctx.measureText(line).width + widthPadding);
    };
    ctx.save();
    ctx.font = titleFont.string;
    (0, _helpersDatasetJs.F)(tooltip.title, maxLineWidth);
    ctx.font = bodyFont.string;
    (0, _helpersDatasetJs.F)(tooltip.beforeBody.concat(tooltip.afterBody), maxLineWidth);
    widthPadding = options.displayColors ? boxWidth + 2 + options.boxPadding : 0;
    (0, _helpersDatasetJs.F)(body, (bodyItem)=>{
        (0, _helpersDatasetJs.F)(bodyItem.before, maxLineWidth);
        (0, _helpersDatasetJs.F)(bodyItem.lines, maxLineWidth);
        (0, _helpersDatasetJs.F)(bodyItem.after, maxLineWidth);
    });
    widthPadding = 0;
    ctx.font = footerFont.string;
    (0, _helpersDatasetJs.F)(tooltip.footer, maxLineWidth);
    ctx.restore();
    width += padding.width;
    return {
        width,
        height
    };
}
function determineYAlign(chart, size) {
    const { y, height } = size;
    if (y < height / 2) return 'top';
    else if (y > chart.height - height / 2) return 'bottom';
    return 'center';
}
function doesNotFitWithAlign(xAlign, chart, options, size) {
    const { x, width } = size;
    const caret = options.caretSize + options.caretPadding;
    if (xAlign === 'left' && x + width + caret > chart.width) return true;
    if (xAlign === 'right' && x - width - caret < 0) return true;
}
function determineXAlign(chart, options, size, yAlign) {
    const { x, width } = size;
    const { width: chartWidth, chartArea: { left, right } } = chart;
    let xAlign = 'center';
    if (yAlign === 'center') xAlign = x <= (left + right) / 2 ? 'left' : 'right';
    else if (x <= width / 2) xAlign = 'left';
    else if (x >= chartWidth - width / 2) xAlign = 'right';
    if (doesNotFitWithAlign(xAlign, chart, options, size)) xAlign = 'center';
    return xAlign;
}
function determineAlignment(chart, options, size) {
    const yAlign = size.yAlign || options.yAlign || determineYAlign(chart, size);
    return {
        xAlign: size.xAlign || options.xAlign || determineXAlign(chart, options, size, yAlign),
        yAlign
    };
}
function alignX(size, xAlign) {
    let { x, width } = size;
    if (xAlign === 'right') x -= width;
    else if (xAlign === 'center') x -= width / 2;
    return x;
}
function alignY(size, yAlign, paddingAndSize) {
    let { y, height } = size;
    if (yAlign === 'top') y += paddingAndSize;
    else if (yAlign === 'bottom') y -= height + paddingAndSize;
    else y -= height / 2;
    return y;
}
function getBackgroundPoint(options, size, alignment, chart) {
    const { caretSize, caretPadding, cornerRadius } = options;
    const { xAlign, yAlign } = alignment;
    const paddingAndSize = caretSize + caretPadding;
    const { topLeft, topRight, bottomLeft, bottomRight } = (0, _helpersDatasetJs.ax)(cornerRadius);
    let x = alignX(size, xAlign);
    const y = alignY(size, yAlign, paddingAndSize);
    if (yAlign === 'center') {
        if (xAlign === 'left') x += paddingAndSize;
        else if (xAlign === 'right') x -= paddingAndSize;
    } else if (xAlign === 'left') x -= Math.max(topLeft, bottomLeft) + caretSize;
    else if (xAlign === 'right') x += Math.max(topRight, bottomRight) + caretSize;
    return {
        x: (0, _helpersDatasetJs.S)(x, 0, chart.width - size.width),
        y: (0, _helpersDatasetJs.S)(y, 0, chart.height - size.height)
    };
}
function getAlignedX(tooltip, align, options) {
    const padding = (0, _helpersDatasetJs.E)(options.padding);
    return align === 'center' ? tooltip.x + tooltip.width / 2 : align === 'right' ? tooltip.x + tooltip.width - padding.right : tooltip.x + padding.left;
}
function getBeforeAfterBodyLines(callback) {
    return pushOrConcat([], splitNewlines(callback));
}
function createTooltipContext(parent, tooltip, tooltipItems) {
    return (0, _helpersDatasetJs.j)(parent, {
        tooltip,
        tooltipItems,
        type: 'tooltip'
    });
}
function overrideCallbacks(callbacks, context) {
    const override = context && context.dataset && context.dataset.tooltip && context.dataset.tooltip.callbacks;
    return override ? callbacks.override(override) : callbacks;
}
const defaultCallbacks = {
    beforeTitle: (0, _helpersDatasetJs.aG),
    title (tooltipItems) {
        if (tooltipItems.length > 0) {
            const item = tooltipItems[0];
            const labels = item.chart.data.labels;
            const labelCount = labels ? labels.length : 0;
            if (this && this.options && this.options.mode === 'dataset') return item.dataset.label || '';
            else if (item.label) return item.label;
            else if (labelCount > 0 && item.dataIndex < labelCount) return labels[item.dataIndex];
        }
        return '';
    },
    afterTitle: (0, _helpersDatasetJs.aG),
    beforeBody: (0, _helpersDatasetJs.aG),
    beforeLabel: (0, _helpersDatasetJs.aG),
    label (tooltipItem) {
        if (this && this.options && this.options.mode === 'dataset') return tooltipItem.label + ': ' + tooltipItem.formattedValue || tooltipItem.formattedValue;
        let label = tooltipItem.dataset.label || '';
        if (label) label += ': ';
        const value = tooltipItem.formattedValue;
        if (!(0, _helpersDatasetJs.k)(value)) label += value;
        return label;
    },
    labelColor (tooltipItem) {
        const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        const options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
            borderColor: options.borderColor,
            backgroundColor: options.backgroundColor,
            borderWidth: options.borderWidth,
            borderDash: options.borderDash,
            borderDashOffset: options.borderDashOffset,
            borderRadius: 0
        };
    },
    labelTextColor () {
        return this.options.bodyColor;
    },
    labelPointStyle (tooltipItem) {
        const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        const options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
            pointStyle: options.pointStyle,
            rotation: options.rotation
        };
    },
    afterLabel: (0, _helpersDatasetJs.aG),
    afterBody: (0, _helpersDatasetJs.aG),
    beforeFooter: (0, _helpersDatasetJs.aG),
    footer: (0, _helpersDatasetJs.aG),
    afterFooter: (0, _helpersDatasetJs.aG)
};
function invokeCallbackWithFallback(callbacks, name, ctx, arg) {
    const result = callbacks[name].call(ctx, arg);
    if (typeof result === 'undefined') return defaultCallbacks[name].call(ctx, arg);
    return result;
}
class Tooltip extends Element {
    static positioners = positioners;
    constructor(config){
        super();
        this.opacity = 0;
        this._active = [];
        this._eventPosition = undefined;
        this._size = undefined;
        this._cachedAnimations = undefined;
        this._tooltipItems = [];
        this.$animations = undefined;
        this.$context = undefined;
        this.chart = config.chart;
        this.options = config.options;
        this.dataPoints = undefined;
        this.title = undefined;
        this.beforeBody = undefined;
        this.body = undefined;
        this.afterBody = undefined;
        this.footer = undefined;
        this.xAlign = undefined;
        this.yAlign = undefined;
        this.x = undefined;
        this.y = undefined;
        this.height = undefined;
        this.width = undefined;
        this.caretX = undefined;
        this.caretY = undefined;
        this.labelColors = undefined;
        this.labelPointStyles = undefined;
        this.labelTextColors = undefined;
    }
    initialize(options) {
        this.options = options;
        this._cachedAnimations = undefined;
        this.$context = undefined;
    }
    _resolveAnimations() {
        const cached = this._cachedAnimations;
        if (cached) return cached;
        const chart = this.chart;
        const options = this.options.setContext(this.getContext());
        const opts = options.enabled && chart.options.animation && options.animations;
        const animations = new Animations(this.chart, opts);
        if (opts._cacheable) this._cachedAnimations = Object.freeze(animations);
        return animations;
    }
    getContext() {
        return this.$context || (this.$context = createTooltipContext(this.chart.getContext(), this, this._tooltipItems));
    }
    getTitle(context, options) {
        const { callbacks } = options;
        const beforeTitle = invokeCallbackWithFallback(callbacks, 'beforeTitle', this, context);
        const title = invokeCallbackWithFallback(callbacks, 'title', this, context);
        const afterTitle = invokeCallbackWithFallback(callbacks, 'afterTitle', this, context);
        let lines = [];
        lines = pushOrConcat(lines, splitNewlines(beforeTitle));
        lines = pushOrConcat(lines, splitNewlines(title));
        lines = pushOrConcat(lines, splitNewlines(afterTitle));
        return lines;
    }
    getBeforeBody(tooltipItems, options) {
        return getBeforeAfterBodyLines(invokeCallbackWithFallback(options.callbacks, 'beforeBody', this, tooltipItems));
    }
    getBody(tooltipItems, options) {
        const { callbacks } = options;
        const bodyItems = [];
        (0, _helpersDatasetJs.F)(tooltipItems, (context)=>{
            const bodyItem = {
                before: [],
                lines: [],
                after: []
            };
            const scoped = overrideCallbacks(callbacks, context);
            pushOrConcat(bodyItem.before, splitNewlines(invokeCallbackWithFallback(scoped, 'beforeLabel', this, context)));
            pushOrConcat(bodyItem.lines, invokeCallbackWithFallback(scoped, 'label', this, context));
            pushOrConcat(bodyItem.after, splitNewlines(invokeCallbackWithFallback(scoped, 'afterLabel', this, context)));
            bodyItems.push(bodyItem);
        });
        return bodyItems;
    }
    getAfterBody(tooltipItems, options) {
        return getBeforeAfterBodyLines(invokeCallbackWithFallback(options.callbacks, 'afterBody', this, tooltipItems));
    }
    getFooter(tooltipItems, options) {
        const { callbacks } = options;
        const beforeFooter = invokeCallbackWithFallback(callbacks, 'beforeFooter', this, tooltipItems);
        const footer = invokeCallbackWithFallback(callbacks, 'footer', this, tooltipItems);
        const afterFooter = invokeCallbackWithFallback(callbacks, 'afterFooter', this, tooltipItems);
        let lines = [];
        lines = pushOrConcat(lines, splitNewlines(beforeFooter));
        lines = pushOrConcat(lines, splitNewlines(footer));
        lines = pushOrConcat(lines, splitNewlines(afterFooter));
        return lines;
    }
    _createItems(options) {
        const active = this._active;
        const data = this.chart.data;
        const labelColors = [];
        const labelPointStyles = [];
        const labelTextColors = [];
        let tooltipItems = [];
        let i, len;
        for(i = 0, len = active.length; i < len; ++i)tooltipItems.push(createTooltipItem(this.chart, active[i]));
        if (options.filter) tooltipItems = tooltipItems.filter((element, index, array)=>options.filter(element, index, array, data));
        if (options.itemSort) tooltipItems = tooltipItems.sort((a, b)=>options.itemSort(a, b, data));
        (0, _helpersDatasetJs.F)(tooltipItems, (context)=>{
            const scoped = overrideCallbacks(options.callbacks, context);
            labelColors.push(invokeCallbackWithFallback(scoped, 'labelColor', this, context));
            labelPointStyles.push(invokeCallbackWithFallback(scoped, 'labelPointStyle', this, context));
            labelTextColors.push(invokeCallbackWithFallback(scoped, 'labelTextColor', this, context));
        });
        this.labelColors = labelColors;
        this.labelPointStyles = labelPointStyles;
        this.labelTextColors = labelTextColors;
        this.dataPoints = tooltipItems;
        return tooltipItems;
    }
    update(changed, replay) {
        const options = this.options.setContext(this.getContext());
        const active = this._active;
        let properties;
        let tooltipItems = [];
        if (!active.length) {
            if (this.opacity !== 0) properties = {
                opacity: 0
            };
        } else {
            const position = positioners[options.position].call(this, active, this._eventPosition);
            tooltipItems = this._createItems(options);
            this.title = this.getTitle(tooltipItems, options);
            this.beforeBody = this.getBeforeBody(tooltipItems, options);
            this.body = this.getBody(tooltipItems, options);
            this.afterBody = this.getAfterBody(tooltipItems, options);
            this.footer = this.getFooter(tooltipItems, options);
            const size = this._size = getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, size);
            const alignment = determineAlignment(this.chart, options, positionAndSize);
            const backgroundPoint = getBackgroundPoint(options, positionAndSize, alignment, this.chart);
            this.xAlign = alignment.xAlign;
            this.yAlign = alignment.yAlign;
            properties = {
                opacity: 1,
                x: backgroundPoint.x,
                y: backgroundPoint.y,
                width: size.width,
                height: size.height,
                caretX: position.x,
                caretY: position.y
            };
        }
        this._tooltipItems = tooltipItems;
        this.$context = undefined;
        if (properties) this._resolveAnimations().update(this, properties);
        if (changed && options.external) options.external.call(this, {
            chart: this.chart,
            tooltip: this,
            replay
        });
    }
    drawCaret(tooltipPoint, ctx, size, options) {
        const caretPosition = this.getCaretPosition(tooltipPoint, size, options);
        ctx.lineTo(caretPosition.x1, caretPosition.y1);
        ctx.lineTo(caretPosition.x2, caretPosition.y2);
        ctx.lineTo(caretPosition.x3, caretPosition.y3);
    }
    getCaretPosition(tooltipPoint, size, options) {
        const { xAlign, yAlign } = this;
        const { caretSize, cornerRadius } = options;
        const { topLeft, topRight, bottomLeft, bottomRight } = (0, _helpersDatasetJs.ax)(cornerRadius);
        const { x: ptX, y: ptY } = tooltipPoint;
        const { width, height } = size;
        let x1, x2, x3, y1, y2, y3;
        if (yAlign === 'center') {
            y2 = ptY + height / 2;
            if (xAlign === 'left') {
                x1 = ptX;
                x2 = x1 - caretSize;
                y1 = y2 + caretSize;
                y3 = y2 - caretSize;
            } else {
                x1 = ptX + width;
                x2 = x1 + caretSize;
                y1 = y2 - caretSize;
                y3 = y2 + caretSize;
            }
            x3 = x1;
        } else {
            if (xAlign === 'left') x2 = ptX + Math.max(topLeft, bottomLeft) + caretSize;
            else if (xAlign === 'right') x2 = ptX + width - Math.max(topRight, bottomRight) - caretSize;
            else x2 = this.caretX;
            if (yAlign === 'top') {
                y1 = ptY;
                y2 = y1 - caretSize;
                x1 = x2 - caretSize;
                x3 = x2 + caretSize;
            } else {
                y1 = ptY + height;
                y2 = y1 + caretSize;
                x1 = x2 + caretSize;
                x3 = x2 - caretSize;
            }
            y3 = y1;
        }
        return {
            x1,
            x2,
            x3,
            y1,
            y2,
            y3
        };
    }
    drawTitle(pt, ctx, options) {
        const title = this.title;
        const length = title.length;
        let titleFont, titleSpacing, i;
        if (length) {
            const rtlHelper = (0, _helpersDatasetJs.aA)(options.rtl, this.x, this.width);
            pt.x = getAlignedX(this, options.titleAlign, options);
            ctx.textAlign = rtlHelper.textAlign(options.titleAlign);
            ctx.textBaseline = 'middle';
            titleFont = (0, _helpersDatasetJs.a0)(options.titleFont);
            titleSpacing = options.titleSpacing;
            ctx.fillStyle = options.titleColor;
            ctx.font = titleFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFont.lineHeight / 2);
                pt.y += titleFont.lineHeight + titleSpacing;
                if (i + 1 === length) pt.y += options.titleMarginBottom - titleSpacing;
            }
        }
    }
    _drawColorBox(ctx, pt, i, rtlHelper, options) {
        const labelColor = this.labelColors[i];
        const labelPointStyle = this.labelPointStyles[i];
        const { boxHeight, boxWidth } = options;
        const bodyFont = (0, _helpersDatasetJs.a0)(options.bodyFont);
        const colorX = getAlignedX(this, 'left', options);
        const rtlColorX = rtlHelper.x(colorX);
        const yOffSet = boxHeight < bodyFont.lineHeight ? (bodyFont.lineHeight - boxHeight) / 2 : 0;
        const colorY = pt.y + yOffSet;
        if (options.usePointStyle) {
            const drawOptions = {
                radius: Math.min(boxWidth, boxHeight) / 2,
                pointStyle: labelPointStyle.pointStyle,
                rotation: labelPointStyle.rotation,
                borderWidth: 1
            };
            const centerX = rtlHelper.leftForLtr(rtlColorX, boxWidth) + boxWidth / 2;
            const centerY = colorY + boxHeight / 2;
            ctx.strokeStyle = options.multiKeyBackground;
            ctx.fillStyle = options.multiKeyBackground;
            (0, _helpersDatasetJs.au)(ctx, drawOptions, centerX, centerY);
            ctx.strokeStyle = labelColor.borderColor;
            ctx.fillStyle = labelColor.backgroundColor;
            (0, _helpersDatasetJs.au)(ctx, drawOptions, centerX, centerY);
        } else {
            ctx.lineWidth = (0, _helpersDatasetJs.i)(labelColor.borderWidth) ? Math.max(...Object.values(labelColor.borderWidth)) : labelColor.borderWidth || 1;
            ctx.strokeStyle = labelColor.borderColor;
            ctx.setLineDash(labelColor.borderDash || []);
            ctx.lineDashOffset = labelColor.borderDashOffset || 0;
            const outerX = rtlHelper.leftForLtr(rtlColorX, boxWidth);
            const innerX = rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), boxWidth - 2);
            const borderRadius = (0, _helpersDatasetJs.ax)(labelColor.borderRadius);
            if (Object.values(borderRadius).some((v)=>v !== 0)) {
                ctx.beginPath();
                ctx.fillStyle = options.multiKeyBackground;
                (0, _helpersDatasetJs.av)(ctx, {
                    x: outerX,
                    y: colorY,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                ctx.fill();
                ctx.stroke();
                ctx.fillStyle = labelColor.backgroundColor;
                ctx.beginPath();
                (0, _helpersDatasetJs.av)(ctx, {
                    x: innerX,
                    y: colorY + 1,
                    w: boxWidth - 2,
                    h: boxHeight - 2,
                    radius: borderRadius
                });
                ctx.fill();
            } else {
                ctx.fillStyle = options.multiKeyBackground;
                ctx.fillRect(outerX, colorY, boxWidth, boxHeight);
                ctx.strokeRect(outerX, colorY, boxWidth, boxHeight);
                ctx.fillStyle = labelColor.backgroundColor;
                ctx.fillRect(innerX, colorY + 1, boxWidth - 2, boxHeight - 2);
            }
        }
        ctx.fillStyle = this.labelTextColors[i];
    }
    drawBody(pt, ctx, options) {
        const { body } = this;
        const { bodySpacing, bodyAlign, displayColors, boxHeight, boxWidth, boxPadding } = options;
        const bodyFont = (0, _helpersDatasetJs.a0)(options.bodyFont);
        let bodyLineHeight = bodyFont.lineHeight;
        let xLinePadding = 0;
        const rtlHelper = (0, _helpersDatasetJs.aA)(options.rtl, this.x, this.width);
        const fillLineOfText = function(line) {
            ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyLineHeight / 2);
            pt.y += bodyLineHeight + bodySpacing;
        };
        const bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
        let bodyItem, textColor, lines, i, j, ilen, jlen;
        ctx.textAlign = bodyAlign;
        ctx.textBaseline = 'middle';
        ctx.font = bodyFont.string;
        pt.x = getAlignedX(this, bodyAlignForCalculation, options);
        ctx.fillStyle = options.bodyColor;
        (0, _helpersDatasetJs.F)(this.beforeBody, fillLineOfText);
        xLinePadding = displayColors && bodyAlignForCalculation !== 'right' ? bodyAlign === 'center' ? boxWidth / 2 + boxPadding : boxWidth + 2 + boxPadding : 0;
        for(i = 0, ilen = body.length; i < ilen; ++i){
            bodyItem = body[i];
            textColor = this.labelTextColors[i];
            ctx.fillStyle = textColor;
            (0, _helpersDatasetJs.F)(bodyItem.before, fillLineOfText);
            lines = bodyItem.lines;
            if (displayColors && lines.length) {
                this._drawColorBox(ctx, pt, i, rtlHelper, options);
                bodyLineHeight = Math.max(bodyFont.lineHeight, boxHeight);
            }
            for(j = 0, jlen = lines.length; j < jlen; ++j){
                fillLineOfText(lines[j]);
                bodyLineHeight = bodyFont.lineHeight;
            }
            (0, _helpersDatasetJs.F)(bodyItem.after, fillLineOfText);
        }
        xLinePadding = 0;
        bodyLineHeight = bodyFont.lineHeight;
        (0, _helpersDatasetJs.F)(this.afterBody, fillLineOfText);
        pt.y -= bodySpacing;
    }
    drawFooter(pt, ctx, options) {
        const footer = this.footer;
        const length = footer.length;
        let footerFont, i;
        if (length) {
            const rtlHelper = (0, _helpersDatasetJs.aA)(options.rtl, this.x, this.width);
            pt.x = getAlignedX(this, options.footerAlign, options);
            pt.y += options.footerMarginTop;
            ctx.textAlign = rtlHelper.textAlign(options.footerAlign);
            ctx.textBaseline = 'middle';
            footerFont = (0, _helpersDatasetJs.a0)(options.footerFont);
            ctx.fillStyle = options.footerColor;
            ctx.font = footerFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFont.lineHeight / 2);
                pt.y += footerFont.lineHeight + options.footerSpacing;
            }
        }
    }
    drawBackground(pt, ctx, tooltipSize, options) {
        const { xAlign, yAlign } = this;
        const { x, y } = pt;
        const { width, height } = tooltipSize;
        const { topLeft, topRight, bottomLeft, bottomRight } = (0, _helpersDatasetJs.ax)(options.cornerRadius);
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.beginPath();
        ctx.moveTo(x + topLeft, y);
        if (yAlign === 'top') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width - topRight, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + topRight);
        if (yAlign === 'center' && xAlign === 'right') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width, y + height - bottomRight);
        ctx.quadraticCurveTo(x + width, y + height, x + width - bottomRight, y + height);
        if (yAlign === 'bottom') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + bottomLeft, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - bottomLeft);
        if (yAlign === 'center' && xAlign === 'left') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x, y + topLeft);
        ctx.quadraticCurveTo(x, y, x + topLeft, y);
        ctx.closePath();
        ctx.fill();
        if (options.borderWidth > 0) ctx.stroke();
    }
    _updateAnimationTarget(options) {
        const chart = this.chart;
        const anims = this.$animations;
        const animX = anims && anims.x;
        const animY = anims && anims.y;
        if (animX || animY) {
            const position = positioners[options.position].call(this, this._active, this._eventPosition);
            if (!position) return;
            const size = this._size = getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, this._size);
            const alignment = determineAlignment(chart, options, positionAndSize);
            const point = getBackgroundPoint(options, positionAndSize, alignment, chart);
            if (animX._to !== point.x || animY._to !== point.y) {
                this.xAlign = alignment.xAlign;
                this.yAlign = alignment.yAlign;
                this.width = size.width;
                this.height = size.height;
                this.caretX = position.x;
                this.caretY = position.y;
                this._resolveAnimations().update(this, point);
            }
        }
    }
    _willRender() {
        return !!this.opacity;
    }
    draw(ctx) {
        const options = this.options.setContext(this.getContext());
        let opacity = this.opacity;
        if (!opacity) return;
        this._updateAnimationTarget(options);
        const tooltipSize = {
            width: this.width,
            height: this.height
        };
        const pt = {
            x: this.x,
            y: this.y
        };
        opacity = Math.abs(opacity) < 1e-3 ? 0 : opacity;
        const padding = (0, _helpersDatasetJs.E)(options.padding);
        const hasTooltipContent = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
        if (options.enabled && hasTooltipContent) {
            ctx.save();
            ctx.globalAlpha = opacity;
            this.drawBackground(pt, ctx, tooltipSize, options);
            (0, _helpersDatasetJs.aB)(ctx, options.textDirection);
            pt.y += padding.top;
            this.drawTitle(pt, ctx, options);
            this.drawBody(pt, ctx, options);
            this.drawFooter(pt, ctx, options);
            (0, _helpersDatasetJs.aD)(ctx, options.textDirection);
            ctx.restore();
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements, eventPosition) {
        const lastActive = this._active;
        const active = activeElements.map(({ datasetIndex, index })=>{
            const meta = this.chart.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error('Cannot find a dataset at index ' + datasetIndex);
            return {
                datasetIndex,
                element: meta.data[index],
                index
            };
        });
        const changed = !(0, _helpersDatasetJs.ai)(lastActive, active);
        const positionChanged = this._positionChanged(active, eventPosition);
        if (changed || positionChanged) {
            this._active = active;
            this._eventPosition = eventPosition;
            this._ignoreReplayEvents = true;
            this.update(true);
        }
    }
    handleEvent(e, replay, inChartArea = true) {
        if (replay && this._ignoreReplayEvents) return false;
        this._ignoreReplayEvents = false;
        const options = this.options;
        const lastActive = this._active || [];
        const active = this._getActiveElements(e, lastActive, replay, inChartArea);
        const positionChanged = this._positionChanged(active, e);
        const changed = replay || !(0, _helpersDatasetJs.ai)(active, lastActive) || positionChanged;
        if (changed) {
            this._active = active;
            if (options.enabled || options.external) {
                this._eventPosition = {
                    x: e.x,
                    y: e.y
                };
                this.update(true, replay);
            }
        }
        return changed;
    }
    _getActiveElements(e, lastActive, replay, inChartArea) {
        const options = this.options;
        if (e.type === 'mouseout') return [];
        if (!inChartArea) return lastActive.filter((i)=>this.chart.data.datasets[i.datasetIndex] && this.chart.getDatasetMeta(i.datasetIndex).controller.getParsed(i.index) !== undefined);
        const active = this.chart.getElementsAtEventForMode(e, options.mode, options, replay);
        if (options.reverse) active.reverse();
        return active;
    }
    _positionChanged(active, e) {
        const { caretX, caretY, options } = this;
        const position = positioners[options.position].call(this, active, e);
        return position !== false && (caretX !== position.x || caretY !== position.y);
    }
}
var plugin_tooltip = {
    id: 'tooltip',
    _element: Tooltip,
    positioners,
    afterInit (chart, _args, options) {
        if (options) chart.tooltip = new Tooltip({
            chart,
            options
        });
    },
    beforeUpdate (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    reset (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    afterDraw (chart) {
        const tooltip = chart.tooltip;
        if (tooltip && tooltip._willRender()) {
            const args = {
                tooltip
            };
            if (chart.notifyPlugins('beforeTooltipDraw', {
                ...args,
                cancelable: true
            }) === false) return;
            tooltip.draw(chart.ctx);
            chart.notifyPlugins('afterTooltipDraw', args);
        }
    },
    afterEvent (chart, args) {
        if (chart.tooltip) {
            const useFinalPosition = args.replay;
            if (chart.tooltip.handleEvent(args.event, useFinalPosition, args.inChartArea)) args.changed = true;
        }
    },
    defaults: {
        enabled: true,
        external: null,
        position: 'average',
        backgroundColor: 'rgba(0,0,0,0.8)',
        titleColor: '#fff',
        titleFont: {
            weight: 'bold'
        },
        titleSpacing: 2,
        titleMarginBottom: 6,
        titleAlign: 'left',
        bodyColor: '#fff',
        bodySpacing: 2,
        bodyFont: {},
        bodyAlign: 'left',
        footerColor: '#fff',
        footerSpacing: 2,
        footerMarginTop: 6,
        footerFont: {
            weight: 'bold'
        },
        footerAlign: 'left',
        padding: 6,
        caretPadding: 2,
        caretSize: 5,
        cornerRadius: 6,
        boxHeight: (ctx, opts)=>opts.bodyFont.size,
        boxWidth: (ctx, opts)=>opts.bodyFont.size,
        multiKeyBackground: '#fff',
        displayColors: true,
        boxPadding: 0,
        borderColor: 'rgba(0,0,0,0)',
        borderWidth: 0,
        animation: {
            duration: 400,
            easing: 'easeOutQuart'
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'width',
                    'height',
                    'caretX',
                    'caretY'
                ]
            },
            opacity: {
                easing: 'linear',
                duration: 200
            }
        },
        callbacks: defaultCallbacks
    },
    defaultRoutes: {
        bodyFont: 'font',
        footerFont: 'font',
        titleFont: 'font'
    },
    descriptors: {
        _scriptable: (name)=>name !== 'filter' && name !== 'itemSort' && name !== 'external',
        _indexable: false,
        callbacks: {
            _scriptable: false,
            _indexable: false
        },
        animation: {
            _fallback: false
        },
        animations: {
            _fallback: 'animation'
        }
    },
    additionalOptionScopes: [
        'interaction'
    ]
};
var plugins = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Colors: plugin_colors,
    Decimation: plugin_decimation,
    Filler: index,
    Legend: plugin_legend,
    SubTitle: plugin_subtitle,
    Title: plugin_title,
    Tooltip: plugin_tooltip
});
const addIfString = (labels, raw, index, addedLabels)=>{
    if (typeof raw === 'string') {
        index = labels.push(raw) - 1;
        addedLabels.unshift({
            index,
            label: raw
        });
    } else if (isNaN(raw)) index = null;
    return index;
};
function findOrAddLabel(labels, raw, index, addedLabels) {
    const first = labels.indexOf(raw);
    if (first === -1) return addIfString(labels, raw, index, addedLabels);
    const last = labels.lastIndexOf(raw);
    return first !== last ? index : first;
}
const validIndex = (index, max)=>index === null ? null : (0, _helpersDatasetJs.S)(Math.round(index), 0, max);
function _getLabelForValue(value) {
    const labels = this.getLabels();
    if (value >= 0 && value < labels.length) return labels[value];
    return value;
}
class CategoryScale extends Scale {
    static id = 'category';
    static defaults = {
        ticks: {
            callback: _getLabelForValue
        }
    };
    constructor(cfg){
        super(cfg);
        this._startValue = undefined;
        this._valueRange = 0;
        this._addedLabels = [];
    }
    init(scaleOptions) {
        const added = this._addedLabels;
        if (added.length) {
            const labels = this.getLabels();
            for (const { index, label } of added)if (labels[index] === label) labels.splice(index, 1);
            this._addedLabels = [];
        }
        super.init(scaleOptions);
    }
    parse(raw, index) {
        if ((0, _helpersDatasetJs.k)(raw)) return null;
        const labels = this.getLabels();
        index = isFinite(index) && labels[index] === raw ? index : findOrAddLabel(labels, raw, (0, _helpersDatasetJs.v)(index, raw), this._addedLabels);
        return validIndex(index, labels.length - 1);
    }
    determineDataLimits() {
        const { minDefined, maxDefined } = this.getUserBounds();
        let { min, max } = this.getMinMax(true);
        if (this.options.bounds === 'ticks') {
            if (!minDefined) min = 0;
            if (!maxDefined) max = this.getLabels().length - 1;
        }
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const min = this.min;
        const max = this.max;
        const offset = this.options.offset;
        const ticks = [];
        let labels = this.getLabels();
        labels = min === 0 && max === labels.length - 1 ? labels : labels.slice(min, max + 1);
        this._valueRange = Math.max(labels.length - (offset ? 0 : 1), 1);
        this._startValue = this.min - (offset ? 0.5 : 0);
        for(let value = min; value <= max; value++)ticks.push({
            value
        });
        return ticks;
    }
    getLabelForValue(value) {
        return _getLabelForValue.call(this, value);
    }
    configure() {
        super.configure();
        if (!this.isHorizontal()) this._reversePixels = !this._reversePixels;
    }
    getPixelForValue(value) {
        if (typeof value !== 'number') value = this.parse(value);
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getValueForPixel(pixel) {
        return Math.round(this._startValue + this.getDecimalForPixel(pixel) * this._valueRange);
    }
    getBasePixel() {
        return this.bottom;
    }
}
function generateTicks$1(generationOptions, dataRange) {
    const ticks = [];
    const MIN_SPACING = 1e-14;
    const { bounds, step, min, max, precision, count, maxTicks, maxDigits, includeBounds } = generationOptions;
    const unit = step || 1;
    const maxSpaces = maxTicks - 1;
    const { min: rmin, max: rmax } = dataRange;
    const minDefined = !(0, _helpersDatasetJs.k)(min);
    const maxDefined = !(0, _helpersDatasetJs.k)(max);
    const countDefined = !(0, _helpersDatasetJs.k)(count);
    const minSpacing = (rmax - rmin) / (maxDigits + 1);
    let spacing = (0, _helpersDatasetJs.aI)((rmax - rmin) / maxSpaces / unit) * unit;
    let factor, niceMin, niceMax, numSpaces;
    if (spacing < MIN_SPACING && !minDefined && !maxDefined) return [
        {
            value: rmin
        },
        {
            value: rmax
        }
    ];
    numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
    if (numSpaces > maxSpaces) spacing = (0, _helpersDatasetJs.aI)(numSpaces * spacing / maxSpaces / unit) * unit;
    if (!(0, _helpersDatasetJs.k)(precision)) {
        factor = Math.pow(10, precision);
        spacing = Math.ceil(spacing * factor) / factor;
    }
    if (bounds === 'ticks') {
        niceMin = Math.floor(rmin / spacing) * spacing;
        niceMax = Math.ceil(rmax / spacing) * spacing;
    } else {
        niceMin = rmin;
        niceMax = rmax;
    }
    if (minDefined && maxDefined && step && (0, _helpersDatasetJs.aJ)((max - min) / step, spacing / 1000)) {
        numSpaces = Math.round(Math.min((max - min) / spacing, maxTicks));
        spacing = (max - min) / numSpaces;
        niceMin = min;
        niceMax = max;
    } else if (countDefined) {
        niceMin = minDefined ? min : niceMin;
        niceMax = maxDefined ? max : niceMax;
        numSpaces = count - 1;
        spacing = (niceMax - niceMin) / numSpaces;
    } else {
        numSpaces = (niceMax - niceMin) / spacing;
        if ((0, _helpersDatasetJs.aK)(numSpaces, Math.round(numSpaces), spacing / 1000)) numSpaces = Math.round(numSpaces);
        else numSpaces = Math.ceil(numSpaces);
    }
    const decimalPlaces = Math.max((0, _helpersDatasetJs.aL)(spacing), (0, _helpersDatasetJs.aL)(niceMin));
    factor = Math.pow(10, (0, _helpersDatasetJs.k)(precision) ? decimalPlaces : precision);
    niceMin = Math.round(niceMin * factor) / factor;
    niceMax = Math.round(niceMax * factor) / factor;
    let j = 0;
    if (minDefined) {
        if (includeBounds && niceMin !== min) {
            ticks.push({
                value: min
            });
            if (niceMin < min) j++;
            if ((0, _helpersDatasetJs.aK)(Math.round((niceMin + j * spacing) * factor) / factor, min, relativeLabelSize(min, minSpacing, generationOptions))) j++;
        } else if (niceMin < min) j++;
    }
    for(; j < numSpaces; ++j){
        const tickValue = Math.round((niceMin + j * spacing) * factor) / factor;
        if (maxDefined && tickValue > max) break;
        ticks.push({
            value: tickValue
        });
    }
    if (maxDefined && includeBounds && niceMax !== max) {
        if (ticks.length && (0, _helpersDatasetJs.aK)(ticks[ticks.length - 1].value, max, relativeLabelSize(max, minSpacing, generationOptions))) ticks[ticks.length - 1].value = max;
        else ticks.push({
            value: max
        });
    } else if (!maxDefined || niceMax === max) ticks.push({
        value: niceMax
    });
    return ticks;
}
function relativeLabelSize(value, minSpacing, { horizontal, minRotation }) {
    const rad = (0, _helpersDatasetJs.t)(minRotation);
    const ratio = (horizontal ? Math.sin(rad) : Math.cos(rad)) || 0.001;
    const length = 0.75 * minSpacing * ('' + value).length;
    return Math.min(minSpacing / ratio, length);
}
class LinearScaleBase extends Scale {
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._endValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        if ((0, _helpersDatasetJs.k)(raw)) return null;
        if ((typeof raw === 'number' || raw instanceof Number) && !isFinite(+raw)) return null;
        return +raw;
    }
    handleTickRangeOptions() {
        const { beginAtZero } = this.options;
        const { minDefined, maxDefined } = this.getUserBounds();
        let { min, max } = this;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        if (beginAtZero) {
            const minSign = (0, _helpersDatasetJs.s)(min);
            const maxSign = (0, _helpersDatasetJs.s)(max);
            if (minSign < 0 && maxSign < 0) setMax(0);
            else if (minSign > 0 && maxSign > 0) setMin(0);
        }
        if (min === max) {
            let offset = max === 0 ? 1 : Math.abs(max * 0.05);
            setMax(max + offset);
            if (!beginAtZero) setMin(min - offset);
        }
        this.min = min;
        this.max = max;
    }
    getTickLimit() {
        const tickOpts = this.options.ticks;
        let { maxTicksLimit, stepSize } = tickOpts;
        let maxTicks;
        if (stepSize) {
            maxTicks = Math.ceil(this.max / stepSize) - Math.floor(this.min / stepSize) + 1;
            if (maxTicks > 1000) {
                console.warn(`scales.${this.id}.ticks.stepSize: ${stepSize} would result generating up to ${maxTicks} ticks. Limiting to 1000.`);
                maxTicks = 1000;
            }
        } else {
            maxTicks = this.computeTickLimit();
            maxTicksLimit = maxTicksLimit || 11;
        }
        if (maxTicksLimit) maxTicks = Math.min(maxTicksLimit, maxTicks);
        return maxTicks;
    }
    computeTickLimit() {
        return Number.POSITIVE_INFINITY;
    }
    buildTicks() {
        const opts = this.options;
        const tickOpts = opts.ticks;
        let maxTicks = this.getTickLimit();
        maxTicks = Math.max(2, maxTicks);
        const numericGeneratorOptions = {
            maxTicks,
            bounds: opts.bounds,
            min: opts.min,
            max: opts.max,
            precision: tickOpts.precision,
            step: tickOpts.stepSize,
            count: tickOpts.count,
            maxDigits: this._maxDigits(),
            horizontal: this.isHorizontal(),
            minRotation: tickOpts.minRotation || 0,
            includeBounds: tickOpts.includeBounds !== false
        };
        const dataRange = this._range || this;
        const ticks = generateTicks$1(numericGeneratorOptions, dataRange);
        if (opts.bounds === 'ticks') (0, _helpersDatasetJs.aH)(ticks, this, 'value');
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    configure() {
        const ticks = this.ticks;
        let start = this.min;
        let end = this.max;
        super.configure();
        if (this.options.offset && ticks.length) {
            const offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
            start -= offset;
            end += offset;
        }
        this._startValue = start;
        this._endValue = end;
        this._valueRange = end - start;
    }
    getLabelForValue(value) {
        return (0, _helpersDatasetJs.o)(value, this.chart.options.locale, this.options.ticks.format);
    }
}
class LinearScale extends LinearScaleBase {
    static id = 'linear';
    static defaults = {
        ticks: {
            callback: (0, _helpersDatasetJs.aM).formatters.numeric
        }
    };
    determineDataLimits() {
        const { min, max } = this.getMinMax(true);
        this.min = (0, _helpersDatasetJs.g)(min) ? min : 0;
        this.max = (0, _helpersDatasetJs.g)(max) ? max : 1;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        const horizontal = this.isHorizontal();
        const length = horizontal ? this.width : this.height;
        const minRotation = (0, _helpersDatasetJs.t)(this.options.ticks.minRotation);
        const ratio = (horizontal ? Math.sin(minRotation) : Math.cos(minRotation)) || 0.001;
        const tickFont = this._resolveTickFontOptions(0);
        return Math.ceil(length / Math.min(40, tickFont.lineHeight / ratio));
    }
    getPixelForValue(value) {
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
    }
}
const log10Floor = (v)=>Math.floor((0, _helpersDatasetJs.aN)(v));
const changeExponent = (v, m)=>Math.pow(10, log10Floor(v) + m);
function isMajor(tickVal) {
    const remain = tickVal / Math.pow(10, log10Floor(tickVal));
    return remain === 1;
}
function steps(min, max, rangeExp) {
    const rangeStep = Math.pow(10, rangeExp);
    const start = Math.floor(min / rangeStep);
    const end = Math.ceil(max / rangeStep);
    return end - start;
}
function startExp(min, max) {
    const range = max - min;
    let rangeExp = log10Floor(range);
    while(steps(min, max, rangeExp) > 10)rangeExp++;
    while(steps(min, max, rangeExp) < 10)rangeExp--;
    return Math.min(rangeExp, log10Floor(min));
}
function generateTicks(generationOptions, { min, max }) {
    min = (0, _helpersDatasetJs.O)(generationOptions.min, min);
    const ticks = [];
    const minExp = log10Floor(min);
    let exp = startExp(min, max);
    let precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
    const stepSize = Math.pow(10, exp);
    const base = minExp > exp ? Math.pow(10, minExp) : 0;
    const start = Math.round((min - base) * precision) / precision;
    const offset = Math.floor((min - base) / stepSize / 10) * stepSize * 10;
    let significand = Math.floor((start - offset) / Math.pow(10, exp));
    let value = (0, _helpersDatasetJs.O)(generationOptions.min, Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision);
    while(value < max){
        ticks.push({
            value,
            major: isMajor(value),
            significand
        });
        if (significand >= 10) significand = significand < 15 ? 15 : 20;
        else significand++;
        if (significand >= 20) {
            exp++;
            significand = 2;
            precision = exp >= 0 ? 1 : precision;
        }
        value = Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision;
    }
    const lastTick = (0, _helpersDatasetJs.O)(generationOptions.max, value);
    ticks.push({
        value: lastTick,
        major: isMajor(lastTick),
        significand
    });
    return ticks;
}
class LogarithmicScale extends Scale {
    static id = 'logarithmic';
    static defaults = {
        ticks: {
            callback: (0, _helpersDatasetJs.aM).formatters.logarithmic,
            major: {
                enabled: true
            }
        }
    };
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        const value = LinearScaleBase.prototype.parse.apply(this, [
            raw,
            index
        ]);
        if (value === 0) {
            this._zero = true;
            return undefined;
        }
        return (0, _helpersDatasetJs.g)(value) && value > 0 ? value : null;
    }
    determineDataLimits() {
        const { min, max } = this.getMinMax(true);
        this.min = (0, _helpersDatasetJs.g)(min) ? Math.max(0, min) : null;
        this.max = (0, _helpersDatasetJs.g)(max) ? Math.max(0, max) : null;
        if (this.options.beginAtZero) this._zero = true;
        if (this._zero && this.min !== this._suggestedMin && !(0, _helpersDatasetJs.g)(this._userMin)) this.min = min === changeExponent(this.min, 0) ? changeExponent(this.min, -1) : changeExponent(this.min, 0);
        this.handleTickRangeOptions();
    }
    handleTickRangeOptions() {
        const { minDefined, maxDefined } = this.getUserBounds();
        let min = this.min;
        let max = this.max;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        if (min === max) {
            if (min <= 0) {
                setMin(1);
                setMax(10);
            } else {
                setMin(changeExponent(min, -1));
                setMax(changeExponent(max, 1));
            }
        }
        if (min <= 0) setMin(changeExponent(max, -1));
        if (max <= 0) setMax(changeExponent(min, 1));
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const opts = this.options;
        const generationOptions = {
            min: this._userMin,
            max: this._userMax
        };
        const ticks = generateTicks(generationOptions, this);
        if (opts.bounds === 'ticks') (0, _helpersDatasetJs.aH)(ticks, this, 'value');
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    getLabelForValue(value) {
        return value === undefined ? '0' : (0, _helpersDatasetJs.o)(value, this.chart.options.locale, this.options.ticks.format);
    }
    configure() {
        const start = this.min;
        super.configure();
        this._startValue = (0, _helpersDatasetJs.aN)(start);
        this._valueRange = (0, _helpersDatasetJs.aN)(this.max) - (0, _helpersDatasetJs.aN)(start);
    }
    getPixelForValue(value) {
        if (value === undefined || value === 0) value = this.min;
        if (value === null || isNaN(value)) return NaN;
        return this.getPixelForDecimal(value === this.min ? 0 : ((0, _helpersDatasetJs.aN)(value) - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        const decimal = this.getDecimalForPixel(pixel);
        return Math.pow(10, this._startValue + decimal * this._valueRange);
    }
}
function getTickBackdropHeight(opts) {
    const tickOpts = opts.ticks;
    if (tickOpts.display && opts.display) {
        const padding = (0, _helpersDatasetJs.E)(tickOpts.backdropPadding);
        return (0, _helpersDatasetJs.v)(tickOpts.font && tickOpts.font.size, (0, _helpersDatasetJs.d).font.size) + padding.height;
    }
    return 0;
}
function measureLabelSize(ctx, font, label) {
    label = (0, _helpersDatasetJs.b)(label) ? label : [
        label
    ];
    return {
        w: (0, _helpersDatasetJs.aO)(ctx, font.string, label),
        h: label.length * font.lineHeight
    };
}
function determineLimits(angle, pos, size, min, max) {
    if (angle === min || angle === max) return {
        start: pos - size / 2,
        end: pos + size / 2
    };
    else if (angle < min || angle > max) return {
        start: pos - size,
        end: pos
    };
    return {
        start: pos,
        end: pos + size
    };
}
function fitWithPointLabels(scale) {
    const orig = {
        l: scale.left + scale._padding.left,
        r: scale.right - scale._padding.right,
        t: scale.top + scale._padding.top,
        b: scale.bottom - scale._padding.bottom
    };
    const limits = Object.assign({}, orig);
    const labelSizes = [];
    const padding = [];
    const valueCount = scale._pointLabels.length;
    const pointLabelOpts = scale.options.pointLabels;
    const additionalAngle = pointLabelOpts.centerPointLabels ? (0, _helpersDatasetJs.P) / valueCount : 0;
    for(let i = 0; i < valueCount; i++){
        const opts = pointLabelOpts.setContext(scale.getPointLabelContext(i));
        padding[i] = opts.padding;
        const pointPosition = scale.getPointPosition(i, scale.drawingArea + padding[i], additionalAngle);
        const plFont = (0, _helpersDatasetJs.a0)(opts.font);
        const textSize = measureLabelSize(scale.ctx, plFont, scale._pointLabels[i]);
        labelSizes[i] = textSize;
        const angleRadians = (0, _helpersDatasetJs.az)(scale.getIndexAngle(i) + additionalAngle);
        const angle = Math.round((0, _helpersDatasetJs.U)(angleRadians));
        const hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
        const vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
        updateLimits(limits, orig, angleRadians, hLimits, vLimits);
    }
    scale.setCenterPoint(orig.l - limits.l, limits.r - orig.r, orig.t - limits.t, limits.b - orig.b);
    scale._pointLabelItems = buildPointLabelItems(scale, labelSizes, padding);
}
function updateLimits(limits, orig, angle, hLimits, vLimits) {
    const sin = Math.abs(Math.sin(angle));
    const cos = Math.abs(Math.cos(angle));
    let x = 0;
    let y = 0;
    if (hLimits.start < orig.l) {
        x = (orig.l - hLimits.start) / sin;
        limits.l = Math.min(limits.l, orig.l - x);
    } else if (hLimits.end > orig.r) {
        x = (hLimits.end - orig.r) / sin;
        limits.r = Math.max(limits.r, orig.r + x);
    }
    if (vLimits.start < orig.t) {
        y = (orig.t - vLimits.start) / cos;
        limits.t = Math.min(limits.t, orig.t - y);
    } else if (vLimits.end > orig.b) {
        y = (vLimits.end - orig.b) / cos;
        limits.b = Math.max(limits.b, orig.b + y);
    }
}
function createPointLabelItem(scale, index, itemOpts) {
    const outerDistance = scale.drawingArea;
    const { extra, additionalAngle, padding, size } = itemOpts;
    const pointLabelPosition = scale.getPointPosition(index, outerDistance + extra + padding, additionalAngle);
    const angle = Math.round((0, _helpersDatasetJs.U)((0, _helpersDatasetJs.az)(pointLabelPosition.angle + (0, _helpersDatasetJs.H))));
    const y = yForAngle(pointLabelPosition.y, size.h, angle);
    const textAlign = getTextAlignForAngle(angle);
    const left = leftForTextAlign(pointLabelPosition.x, size.w, textAlign);
    return {
        visible: true,
        x: pointLabelPosition.x,
        y,
        textAlign,
        left,
        top: y,
        right: left + size.w,
        bottom: y + size.h
    };
}
function isNotOverlapped(item, area) {
    if (!area) return true;
    const { left, top, right, bottom } = item;
    const apexesInArea = (0, _helpersDatasetJs.C)({
        x: left,
        y: top
    }, area) || (0, _helpersDatasetJs.C)({
        x: left,
        y: bottom
    }, area) || (0, _helpersDatasetJs.C)({
        x: right,
        y: top
    }, area) || (0, _helpersDatasetJs.C)({
        x: right,
        y: bottom
    }, area);
    return !apexesInArea;
}
function buildPointLabelItems(scale, labelSizes, padding) {
    const items = [];
    const valueCount = scale._pointLabels.length;
    const opts = scale.options;
    const { centerPointLabels, display } = opts.pointLabels;
    const itemOpts = {
        extra: getTickBackdropHeight(opts) / 2,
        additionalAngle: centerPointLabels ? (0, _helpersDatasetJs.P) / valueCount : 0
    };
    let area;
    for(let i = 0; i < valueCount; i++){
        itemOpts.padding = padding[i];
        itemOpts.size = labelSizes[i];
        const item = createPointLabelItem(scale, i, itemOpts);
        items.push(item);
        if (display === 'auto') {
            item.visible = isNotOverlapped(item, area);
            if (item.visible) area = item;
        }
    }
    return items;
}
function getTextAlignForAngle(angle) {
    if (angle === 0 || angle === 180) return 'center';
    else if (angle < 180) return 'left';
    return 'right';
}
function leftForTextAlign(x, w, align) {
    if (align === 'right') x -= w;
    else if (align === 'center') x -= w / 2;
    return x;
}
function yForAngle(y, h, angle) {
    if (angle === 90 || angle === 270) y -= h / 2;
    else if (angle > 270 || angle < 90) y -= h;
    return y;
}
function drawPointLabelBox(ctx, opts, item) {
    const { left, top, right, bottom } = item;
    const { backdropColor } = opts;
    if (!(0, _helpersDatasetJs.k)(backdropColor)) {
        const borderRadius = (0, _helpersDatasetJs.ax)(opts.borderRadius);
        const padding = (0, _helpersDatasetJs.E)(opts.backdropPadding);
        ctx.fillStyle = backdropColor;
        const backdropLeft = left - padding.left;
        const backdropTop = top - padding.top;
        const backdropWidth = right - left + padding.width;
        const backdropHeight = bottom - top + padding.height;
        if (Object.values(borderRadius).some((v)=>v !== 0)) {
            ctx.beginPath();
            (0, _helpersDatasetJs.av)(ctx, {
                x: backdropLeft,
                y: backdropTop,
                w: backdropWidth,
                h: backdropHeight,
                radius: borderRadius
            });
            ctx.fill();
        } else ctx.fillRect(backdropLeft, backdropTop, backdropWidth, backdropHeight);
    }
}
function drawPointLabels(scale, labelCount) {
    const { ctx, options: { pointLabels } } = scale;
    for(let i = labelCount - 1; i >= 0; i--){
        const item = scale._pointLabelItems[i];
        if (!item.visible) continue;
        const optsAtIndex = pointLabels.setContext(scale.getPointLabelContext(i));
        drawPointLabelBox(ctx, optsAtIndex, item);
        const plFont = (0, _helpersDatasetJs.a0)(optsAtIndex.font);
        const { x, y, textAlign } = item;
        (0, _helpersDatasetJs.Z)(ctx, scale._pointLabels[i], x, y + plFont.lineHeight / 2, plFont, {
            color: optsAtIndex.color,
            textAlign: textAlign,
            textBaseline: 'middle'
        });
    }
}
function pathRadiusLine(scale, radius, circular, labelCount) {
    const { ctx } = scale;
    if (circular) ctx.arc(scale.xCenter, scale.yCenter, radius, 0, (0, _helpersDatasetJs.T));
    else {
        let pointPosition = scale.getPointPosition(0, radius);
        ctx.moveTo(pointPosition.x, pointPosition.y);
        for(let i = 1; i < labelCount; i++){
            pointPosition = scale.getPointPosition(i, radius);
            ctx.lineTo(pointPosition.x, pointPosition.y);
        }
    }
}
function drawRadiusLine(scale, gridLineOpts, radius, labelCount, borderOpts) {
    const ctx = scale.ctx;
    const circular = gridLineOpts.circular;
    const { color, lineWidth } = gridLineOpts;
    if (!circular && !labelCount || !color || !lineWidth || radius < 0) return;
    ctx.save();
    ctx.strokeStyle = color;
    ctx.lineWidth = lineWidth;
    ctx.setLineDash(borderOpts.dash || []);
    ctx.lineDashOffset = borderOpts.dashOffset;
    ctx.beginPath();
    pathRadiusLine(scale, radius, circular, labelCount);
    ctx.closePath();
    ctx.stroke();
    ctx.restore();
}
function createPointLabelContext(parent, index, label) {
    return (0, _helpersDatasetJs.j)(parent, {
        label,
        index,
        type: 'pointLabel'
    });
}
class RadialLinearScale extends LinearScaleBase {
    static id = 'radialLinear';
    static defaults = {
        display: true,
        animate: true,
        position: 'chartArea',
        angleLines: {
            display: true,
            lineWidth: 1,
            borderDash: [],
            borderDashOffset: 0.0
        },
        grid: {
            circular: false
        },
        startAngle: 0,
        ticks: {
            showLabelBackdrop: true,
            callback: (0, _helpersDatasetJs.aM).formatters.numeric
        },
        pointLabels: {
            backdropColor: undefined,
            backdropPadding: 2,
            display: true,
            font: {
                size: 10
            },
            callback (label) {
                return label;
            },
            padding: 5,
            centerPointLabels: false
        }
    };
    static defaultRoutes = {
        'angleLines.color': 'borderColor',
        'pointLabels.color': 'color',
        'ticks.color': 'color'
    };
    static descriptors = {
        angleLines: {
            _fallback: 'grid'
        }
    };
    constructor(cfg){
        super(cfg);
        this.xCenter = undefined;
        this.yCenter = undefined;
        this.drawingArea = undefined;
        this._pointLabels = [];
        this._pointLabelItems = [];
    }
    setDimensions() {
        const padding = this._padding = (0, _helpersDatasetJs.E)(getTickBackdropHeight(this.options) / 2);
        const w = this.width = this.maxWidth - padding.width;
        const h = this.height = this.maxHeight - padding.height;
        this.xCenter = Math.floor(this.left + w / 2 + padding.left);
        this.yCenter = Math.floor(this.top + h / 2 + padding.top);
        this.drawingArea = Math.floor(Math.min(w, h) / 2);
    }
    determineDataLimits() {
        const { min, max } = this.getMinMax(false);
        this.min = (0, _helpersDatasetJs.g)(min) && !isNaN(min) ? min : 0;
        this.max = (0, _helpersDatasetJs.g)(max) && !isNaN(max) ? max : 0;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        return Math.ceil(this.drawingArea / getTickBackdropHeight(this.options));
    }
    generateTickLabels(ticks) {
        LinearScaleBase.prototype.generateTickLabels.call(this, ticks);
        this._pointLabels = this.getLabels().map((value, index)=>{
            const label = (0, _helpersDatasetJs.Q)(this.options.pointLabels.callback, [
                value,
                index
            ], this);
            return label || label === 0 ? label : '';
        }).filter((v, i)=>this.chart.getDataVisibility(i));
    }
    fit() {
        const opts = this.options;
        if (opts.display && opts.pointLabels.display) fitWithPointLabels(this);
        else this.setCenterPoint(0, 0, 0, 0);
    }
    setCenterPoint(leftMovement, rightMovement, topMovement, bottomMovement) {
        this.xCenter += Math.floor((leftMovement - rightMovement) / 2);
        this.yCenter += Math.floor((topMovement - bottomMovement) / 2);
        this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(leftMovement, rightMovement, topMovement, bottomMovement));
    }
    getIndexAngle(index) {
        const angleMultiplier = (0, _helpersDatasetJs.T) / (this._pointLabels.length || 1);
        const startAngle = this.options.startAngle || 0;
        return (0, _helpersDatasetJs.az)(index * angleMultiplier + (0, _helpersDatasetJs.t)(startAngle));
    }
    getDistanceFromCenterForValue(value) {
        if ((0, _helpersDatasetJs.k)(value)) return NaN;
        const scalingFactor = this.drawingArea / (this.max - this.min);
        if (this.options.reverse) return (this.max - value) * scalingFactor;
        return (value - this.min) * scalingFactor;
    }
    getValueForDistanceFromCenter(distance) {
        if ((0, _helpersDatasetJs.k)(distance)) return NaN;
        const scaledDistance = distance / (this.drawingArea / (this.max - this.min));
        return this.options.reverse ? this.max - scaledDistance : this.min + scaledDistance;
    }
    getPointLabelContext(index) {
        const pointLabels = this._pointLabels || [];
        if (index >= 0 && index < pointLabels.length) {
            const pointLabel = pointLabels[index];
            return createPointLabelContext(this.getContext(), index, pointLabel);
        }
    }
    getPointPosition(index, distanceFromCenter, additionalAngle = 0) {
        const angle = this.getIndexAngle(index) - (0, _helpersDatasetJs.H) + additionalAngle;
        return {
            x: Math.cos(angle) * distanceFromCenter + this.xCenter,
            y: Math.sin(angle) * distanceFromCenter + this.yCenter,
            angle
        };
    }
    getPointPositionForValue(index, value) {
        return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
    }
    getBasePosition(index) {
        return this.getPointPositionForValue(index || 0, this.getBaseValue());
    }
    getPointLabelPosition(index) {
        const { left, top, right, bottom } = this._pointLabelItems[index];
        return {
            left,
            top,
            right,
            bottom
        };
    }
    drawBackground() {
        const { backgroundColor, grid: { circular } } = this.options;
        if (backgroundColor) {
            const ctx = this.ctx;
            ctx.save();
            ctx.beginPath();
            pathRadiusLine(this, this.getDistanceFromCenterForValue(this._endValue), circular, this._pointLabels.length);
            ctx.closePath();
            ctx.fillStyle = backgroundColor;
            ctx.fill();
            ctx.restore();
        }
    }
    drawGrid() {
        const ctx = this.ctx;
        const opts = this.options;
        const { angleLines, grid, border } = opts;
        const labelCount = this._pointLabels.length;
        let i, offset, position;
        if (opts.pointLabels.display) drawPointLabels(this, labelCount);
        if (grid.display) this.ticks.forEach((tick, index)=>{
            if (index !== 0 || index === 0 && this.min < 0) {
                offset = this.getDistanceFromCenterForValue(tick.value);
                const context = this.getContext(index);
                const optsAtIndex = grid.setContext(context);
                const optsAtIndexBorder = border.setContext(context);
                drawRadiusLine(this, optsAtIndex, offset, labelCount, optsAtIndexBorder);
            }
        });
        if (angleLines.display) {
            ctx.save();
            for(i = labelCount - 1; i >= 0; i--){
                const optsAtIndex = angleLines.setContext(this.getPointLabelContext(i));
                const { color, lineWidth } = optsAtIndex;
                if (!lineWidth || !color) continue;
                ctx.lineWidth = lineWidth;
                ctx.strokeStyle = color;
                ctx.setLineDash(optsAtIndex.borderDash);
                ctx.lineDashOffset = optsAtIndex.borderDashOffset;
                offset = this.getDistanceFromCenterForValue(opts.reverse ? this.min : this.max);
                position = this.getPointPosition(i, offset);
                ctx.beginPath();
                ctx.moveTo(this.xCenter, this.yCenter);
                ctx.lineTo(position.x, position.y);
                ctx.stroke();
            }
            ctx.restore();
        }
    }
    drawBorder() {}
    drawLabels() {
        const ctx = this.ctx;
        const opts = this.options;
        const tickOpts = opts.ticks;
        if (!tickOpts.display) return;
        const startAngle = this.getIndexAngle(0);
        let offset, width;
        ctx.save();
        ctx.translate(this.xCenter, this.yCenter);
        ctx.rotate(startAngle);
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        this.ticks.forEach((tick, index)=>{
            if (index === 0 && this.min >= 0 && !opts.reverse) return;
            const optsAtIndex = tickOpts.setContext(this.getContext(index));
            const tickFont = (0, _helpersDatasetJs.a0)(optsAtIndex.font);
            offset = this.getDistanceFromCenterForValue(this.ticks[index].value);
            if (optsAtIndex.showLabelBackdrop) {
                ctx.font = tickFont.string;
                width = ctx.measureText(tick.label).width;
                ctx.fillStyle = optsAtIndex.backdropColor;
                const padding = (0, _helpersDatasetJs.E)(optsAtIndex.backdropPadding);
                ctx.fillRect(-width / 2 - padding.left, -offset - tickFont.size / 2 - padding.top, width + padding.width, tickFont.size + padding.height);
            }
            (0, _helpersDatasetJs.Z)(ctx, tick.label, 0, -offset, tickFont, {
                color: optsAtIndex.color,
                strokeColor: optsAtIndex.textStrokeColor,
                strokeWidth: optsAtIndex.textStrokeWidth
            });
        });
        ctx.restore();
    }
    drawTitle() {}
}
const INTERVALS = {
    millisecond: {
        common: true,
        size: 1,
        steps: 1000
    },
    second: {
        common: true,
        size: 1000,
        steps: 60
    },
    minute: {
        common: true,
        size: 60000,
        steps: 60
    },
    hour: {
        common: true,
        size: 3600000,
        steps: 24
    },
    day: {
        common: true,
        size: 86400000,
        steps: 30
    },
    week: {
        common: false,
        size: 604800000,
        steps: 4
    },
    month: {
        common: true,
        size: 2.628e9,
        steps: 12
    },
    quarter: {
        common: false,
        size: 7.884e9,
        steps: 4
    },
    year: {
        common: true,
        size: 3.154e10
    }
};
const UNITS = /* #__PURE__ */ Object.keys(INTERVALS);
function sorter(a, b) {
    return a - b;
}
function parse(scale, input) {
    if ((0, _helpersDatasetJs.k)(input)) return null;
    const adapter = scale._adapter;
    const { parser, round, isoWeekday } = scale._parseOpts;
    let value = input;
    if (typeof parser === 'function') value = parser(value);
    if (!(0, _helpersDatasetJs.g)(value)) value = typeof parser === 'string' ? adapter.parse(value, parser) : adapter.parse(value);
    if (value === null) return null;
    if (round) value = round === 'week' && ((0, _helpersDatasetJs.x)(isoWeekday) || isoWeekday === true) ? adapter.startOf(value, 'isoWeek', isoWeekday) : adapter.startOf(value, round);
    return +value;
}
function determineUnitForAutoTicks(minUnit, min, max, capacity) {
    const ilen = UNITS.length;
    for(let i = UNITS.indexOf(minUnit); i < ilen - 1; ++i){
        const interval = INTERVALS[UNITS[i]];
        const factor = interval.steps ? interval.steps : Number.MAX_SAFE_INTEGER;
        if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) return UNITS[i];
    }
    return UNITS[ilen - 1];
}
function determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
    for(let i = UNITS.length - 1; i >= UNITS.indexOf(minUnit); i--){
        const unit = UNITS[i];
        if (INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) return unit;
    }
    return UNITS[minUnit ? UNITS.indexOf(minUnit) : 0];
}
function determineMajorUnit(unit) {
    for(let i = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i < ilen; ++i){
        if (INTERVALS[UNITS[i]].common) return UNITS[i];
    }
}
function addTick(ticks, time, timestamps) {
    if (!timestamps) ticks[time] = true;
    else if (timestamps.length) {
        const { lo, hi } = (0, _helpersDatasetJs.aQ)(timestamps, time);
        const timestamp = timestamps[lo] >= time ? timestamps[lo] : timestamps[hi];
        ticks[timestamp] = true;
    }
}
function setMajorTicks(scale, ticks, map, majorUnit) {
    const adapter = scale._adapter;
    const first = +adapter.startOf(ticks[0].value, majorUnit);
    const last = ticks[ticks.length - 1].value;
    let major, index;
    for(major = first; major <= last; major = +adapter.add(major, 1, majorUnit)){
        index = map[major];
        if (index >= 0) ticks[index].major = true;
    }
    return ticks;
}
function ticksFromTimestamps(scale, values, majorUnit) {
    const ticks = [];
    const map = {};
    const ilen = values.length;
    let i, value;
    for(i = 0; i < ilen; ++i){
        value = values[i];
        map[value] = i;
        ticks.push({
            value,
            major: false
        });
    }
    return ilen === 0 || !majorUnit ? ticks : setMajorTicks(scale, ticks, map, majorUnit);
}
class TimeScale extends Scale {
    static id = 'time';
    static defaults = {
        bounds: 'data',
        adapters: {},
        time: {
            parser: false,
            unit: false,
            round: false,
            isoWeekday: false,
            minUnit: 'millisecond',
            displayFormats: {}
        },
        ticks: {
            source: 'auto',
            callback: false,
            major: {
                enabled: false
            }
        }
    };
    constructor(props){
        super(props);
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
        this._unit = 'day';
        this._majorUnit = undefined;
        this._offsets = {};
        this._normalized = false;
        this._parseOpts = undefined;
    }
    init(scaleOpts, opts = {}) {
        const time = scaleOpts.time || (scaleOpts.time = {});
        const adapter = this._adapter = new adapters._date(scaleOpts.adapters.date);
        adapter.init(opts);
        (0, _helpersDatasetJs.ab)(time.displayFormats, adapter.formats());
        this._parseOpts = {
            parser: time.parser,
            round: time.round,
            isoWeekday: time.isoWeekday
        };
        super.init(scaleOpts);
        this._normalized = opts.normalized;
    }
    parse(raw, index) {
        if (raw === undefined) return null;
        return parse(this, raw);
    }
    beforeLayout() {
        super.beforeLayout();
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
    }
    determineDataLimits() {
        const options = this.options;
        const adapter = this._adapter;
        const unit = options.time.unit || 'day';
        let { min, max, minDefined, maxDefined } = this.getUserBounds();
        function _applyBounds(bounds) {
            if (!minDefined && !isNaN(bounds.min)) min = Math.min(min, bounds.min);
            if (!maxDefined && !isNaN(bounds.max)) max = Math.max(max, bounds.max);
        }
        if (!minDefined || !maxDefined) {
            _applyBounds(this._getLabelBounds());
            if (options.bounds !== 'ticks' || options.ticks.source !== 'labels') _applyBounds(this.getMinMax(false));
        }
        min = (0, _helpersDatasetJs.g)(min) && !isNaN(min) ? min : +adapter.startOf(Date.now(), unit);
        max = (0, _helpersDatasetJs.g)(max) && !isNaN(max) ? max : +adapter.endOf(Date.now(), unit) + 1;
        this.min = Math.min(min, max - 1);
        this.max = Math.max(min + 1, max);
    }
    _getLabelBounds() {
        const arr = this.getLabelTimestamps();
        let min = Number.POSITIVE_INFINITY;
        let max = Number.NEGATIVE_INFINITY;
        if (arr.length) {
            min = arr[0];
            max = arr[arr.length - 1];
        }
        return {
            min,
            max
        };
    }
    buildTicks() {
        const options = this.options;
        const timeOpts = options.time;
        const tickOpts = options.ticks;
        const timestamps = tickOpts.source === 'labels' ? this.getLabelTimestamps() : this._generate();
        if (options.bounds === 'ticks' && timestamps.length) {
            this.min = this._userMin || timestamps[0];
            this.max = this._userMax || timestamps[timestamps.length - 1];
        }
        const min = this.min;
        const max = this.max;
        const ticks = (0, _helpersDatasetJs.aP)(timestamps, min, max);
        this._unit = timeOpts.unit || (tickOpts.autoSkip ? determineUnitForAutoTicks(timeOpts.minUnit, this.min, this.max, this._getLabelCapacity(min)) : determineUnitForFormatting(this, ticks.length, timeOpts.minUnit, this.min, this.max));
        this._majorUnit = !tickOpts.major.enabled || this._unit === 'year' ? undefined : determineMajorUnit(this._unit);
        this.initOffsets(timestamps);
        if (options.reverse) ticks.reverse();
        return ticksFromTimestamps(this, ticks, this._majorUnit);
    }
    afterAutoSkip() {
        if (this.options.offsetAfterAutoskip) this.initOffsets(this.ticks.map((tick)=>+tick.value));
    }
    initOffsets(timestamps = []) {
        let start = 0;
        let end = 0;
        let first, last;
        if (this.options.offset && timestamps.length) {
            first = this.getDecimalForValue(timestamps[0]);
            if (timestamps.length === 1) start = 1 - first;
            else start = (this.getDecimalForValue(timestamps[1]) - first) / 2;
            last = this.getDecimalForValue(timestamps[timestamps.length - 1]);
            if (timestamps.length === 1) end = last;
            else end = (last - this.getDecimalForValue(timestamps[timestamps.length - 2])) / 2;
        }
        const limit = timestamps.length < 3 ? 0.5 : 0.25;
        start = (0, _helpersDatasetJs.S)(start, 0, limit);
        end = (0, _helpersDatasetJs.S)(end, 0, limit);
        this._offsets = {
            start,
            end,
            factor: 1 / (start + 1 + end)
        };
    }
    _generate() {
        const adapter = this._adapter;
        const min = this.min;
        const max = this.max;
        const options = this.options;
        const timeOpts = options.time;
        const minor = timeOpts.unit || determineUnitForAutoTicks(timeOpts.minUnit, min, max, this._getLabelCapacity(min));
        const stepSize = (0, _helpersDatasetJs.v)(options.ticks.stepSize, 1);
        const weekday = minor === 'week' ? timeOpts.isoWeekday : false;
        const hasWeekday = (0, _helpersDatasetJs.x)(weekday) || weekday === true;
        const ticks = {};
        let first = min;
        let time, count;
        if (hasWeekday) first = +adapter.startOf(first, 'isoWeek', weekday);
        first = +adapter.startOf(first, hasWeekday ? 'day' : minor);
        if (adapter.diff(max, min, minor) > 100000 * stepSize) throw new Error(min + ' and ' + max + ' are too far apart with stepSize of ' + stepSize + ' ' + minor);
        const timestamps = options.ticks.source === 'data' && this.getDataTimestamps();
        for(time = first, count = 0; time < max; time = +adapter.add(time, stepSize, minor), count++)addTick(ticks, time, timestamps);
        if (time === max || options.bounds === 'ticks' || count === 1) addTick(ticks, time, timestamps);
        return Object.keys(ticks).sort(sorter).map((x)=>+x);
    }
    getLabelForValue(value) {
        const adapter = this._adapter;
        const timeOpts = this.options.time;
        if (timeOpts.tooltipFormat) return adapter.format(value, timeOpts.tooltipFormat);
        return adapter.format(value, timeOpts.displayFormats.datetime);
    }
    format(value, format) {
        const options = this.options;
        const formats = options.time.displayFormats;
        const unit = this._unit;
        const fmt = format || formats[unit];
        return this._adapter.format(value, fmt);
    }
    _tickFormatFunction(time, index, ticks, format) {
        const options = this.options;
        const formatter = options.ticks.callback;
        if (formatter) return (0, _helpersDatasetJs.Q)(formatter, [
            time,
            index,
            ticks
        ], this);
        const formats = options.time.displayFormats;
        const unit = this._unit;
        const majorUnit = this._majorUnit;
        const minorFormat = unit && formats[unit];
        const majorFormat = majorUnit && formats[majorUnit];
        const tick = ticks[index];
        const major = majorUnit && majorFormat && tick && tick.major;
        return this._adapter.format(time, format || (major ? majorFormat : minorFormat));
    }
    generateTickLabels(ticks) {
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            tick.label = this._tickFormatFunction(tick.value, i, ticks);
        }
    }
    getDecimalForValue(value) {
        return value === null ? NaN : (value - this.min) / (this.max - this.min);
    }
    getPixelForValue(value) {
        const offsets = this._offsets;
        const pos = this.getDecimalForValue(value);
        return this.getPixelForDecimal((offsets.start + pos) * offsets.factor);
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const pos = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return this.min + pos * (this.max - this.min);
    }
    _getLabelSize(label) {
        const ticksOpts = this.options.ticks;
        const tickLabelWidth = this.ctx.measureText(label).width;
        const angle = (0, _helpersDatasetJs.t)(this.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
        const cosRotation = Math.cos(angle);
        const sinRotation = Math.sin(angle);
        const tickFontSize = this._resolveTickFontOptions(0).size;
        return {
            w: tickLabelWidth * cosRotation + tickFontSize * sinRotation,
            h: tickLabelWidth * sinRotation + tickFontSize * cosRotation
        };
    }
    _getLabelCapacity(exampleTime) {
        const timeOpts = this.options.time;
        const displayFormats = timeOpts.displayFormats;
        const format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
        const exampleLabel = this._tickFormatFunction(exampleTime, 0, ticksFromTimestamps(this, [
            exampleTime
        ], this._majorUnit), format);
        const size = this._getLabelSize(exampleLabel);
        const capacity = Math.floor(this.isHorizontal() ? this.width / size.w : this.height / size.h) - 1;
        return capacity > 0 ? capacity : 1;
    }
    getDataTimestamps() {
        let timestamps = this._cache.data || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const metas = this.getMatchingVisibleMetas();
        if (this._normalized && metas.length) return this._cache.data = metas[0].controller.getAllParsedValues(this);
        for(i = 0, ilen = metas.length; i < ilen; ++i)timestamps = timestamps.concat(metas[i].controller.getAllParsedValues(this));
        return this._cache.data = this.normalize(timestamps);
    }
    getLabelTimestamps() {
        const timestamps = this._cache.labels || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const labels = this.getLabels();
        for(i = 0, ilen = labels.length; i < ilen; ++i)timestamps.push(parse(this, labels[i]));
        return this._cache.labels = this._normalized ? timestamps : this.normalize(timestamps);
    }
    normalize(values) {
        return (0, _helpersDatasetJs._)(values.sort(sorter));
    }
}
function interpolate(table, val, reverse) {
    let lo = 0;
    let hi = table.length - 1;
    let prevSource, nextSource, prevTarget, nextTarget;
    if (reverse) {
        if (val >= table[lo].pos && val <= table[hi].pos) ({ lo, hi } = (0, _helpersDatasetJs.B)(table, 'pos', val));
        ({ pos: prevSource, time: prevTarget } = table[lo]);
        ({ pos: nextSource, time: nextTarget } = table[hi]);
    } else {
        if (val >= table[lo].time && val <= table[hi].time) ({ lo, hi } = (0, _helpersDatasetJs.B)(table, 'time', val));
        ({ time: prevSource, pos: prevTarget } = table[lo]);
        ({ time: nextSource, pos: nextTarget } = table[hi]);
    }
    const span = nextSource - prevSource;
    return span ? prevTarget + (nextTarget - prevTarget) * (val - prevSource) / span : prevTarget;
}
class TimeSeriesScale extends TimeScale {
    static id = 'timeseries';
    static defaults = TimeScale.defaults;
    constructor(props){
        super(props);
        this._table = [];
        this._minPos = undefined;
        this._tableRange = undefined;
    }
    initOffsets() {
        const timestamps = this._getTimestampsForTable();
        const table = this._table = this.buildLookupTable(timestamps);
        this._minPos = interpolate(table, this.min);
        this._tableRange = interpolate(table, this.max) - this._minPos;
        super.initOffsets(timestamps);
    }
    buildLookupTable(timestamps) {
        const { min, max } = this;
        const items = [];
        const table = [];
        let i, ilen, prev, curr, next;
        for(i = 0, ilen = timestamps.length; i < ilen; ++i){
            curr = timestamps[i];
            if (curr >= min && curr <= max) items.push(curr);
        }
        if (items.length < 2) return [
            {
                time: min,
                pos: 0
            },
            {
                time: max,
                pos: 1
            }
        ];
        for(i = 0, ilen = items.length; i < ilen; ++i){
            next = items[i + 1];
            prev = items[i - 1];
            curr = items[i];
            if (Math.round((next + prev) / 2) !== curr) table.push({
                time: curr,
                pos: i / (ilen - 1)
            });
        }
        return table;
    }
    _generate() {
        const min = this.min;
        const max = this.max;
        let timestamps = super.getDataTimestamps();
        if (!timestamps.includes(min) || !timestamps.length) timestamps.splice(0, 0, min);
        if (!timestamps.includes(max) || timestamps.length === 1) timestamps.push(max);
        return timestamps.sort((a, b)=>a - b);
    }
    _getTimestampsForTable() {
        let timestamps = this._cache.all || [];
        if (timestamps.length) return timestamps;
        const data = this.getDataTimestamps();
        const label = this.getLabelTimestamps();
        if (data.length && label.length) timestamps = this.normalize(data.concat(label));
        else timestamps = data.length ? data : label;
        timestamps = this._cache.all = timestamps;
        return timestamps;
    }
    getDecimalForValue(value) {
        return (interpolate(this._table, value) - this._minPos) / this._tableRange;
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const decimal = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return interpolate(this._table, decimal * this._tableRange + this._minPos, true);
    }
}
var scales = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    CategoryScale: CategoryScale,
    LinearScale: LinearScale,
    LogarithmicScale: LogarithmicScale,
    RadialLinearScale: RadialLinearScale,
    TimeScale: TimeScale,
    TimeSeriesScale: TimeSeriesScale
});
const registerables = [
    controllers,
    elements,
    plugins,
    scales
];

},{"./chunks/helpers.dataset.js":"c6tkY","@kurkle/color":"haii5","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"c6tkY":[function(require,module,exports,__globalThis) {
/*!
 * Chart.js v4.4.9
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "$", ()=>unclipArea);
parcelHelpers.export(exports, "A", ()=>_rlookupByKey);
parcelHelpers.export(exports, "B", ()=>_lookupByKey);
parcelHelpers.export(exports, "C", ()=>_isPointInArea);
parcelHelpers.export(exports, "D", ()=>getAngleFromPoint);
parcelHelpers.export(exports, "E", ()=>toPadding);
parcelHelpers.export(exports, "F", ()=>each);
parcelHelpers.export(exports, "G", ()=>getMaximumSize);
parcelHelpers.export(exports, "H", ()=>HALF_PI);
parcelHelpers.export(exports, "I", ()=>_getParentNode);
parcelHelpers.export(exports, "J", ()=>readUsedSize);
parcelHelpers.export(exports, "K", ()=>supportsEventListenerOptions);
parcelHelpers.export(exports, "L", ()=>throttled);
parcelHelpers.export(exports, "M", ()=>_isDomSupported);
parcelHelpers.export(exports, "N", ()=>_factorize);
parcelHelpers.export(exports, "O", ()=>finiteOrDefault);
parcelHelpers.export(exports, "P", ()=>PI);
parcelHelpers.export(exports, "Q", ()=>callback);
parcelHelpers.export(exports, "R", ()=>_addGrace);
parcelHelpers.export(exports, "S", ()=>_limitValue);
parcelHelpers.export(exports, "T", ()=>TAU);
parcelHelpers.export(exports, "U", ()=>toDegrees);
parcelHelpers.export(exports, "V", ()=>_measureText);
parcelHelpers.export(exports, "W", ()=>_int16Range);
parcelHelpers.export(exports, "X", ()=>_alignPixel);
parcelHelpers.export(exports, "Y", ()=>clipArea);
parcelHelpers.export(exports, "Z", ()=>renderText);
parcelHelpers.export(exports, "_", ()=>_arrayUnique);
parcelHelpers.export(exports, "a", ()=>resolve);
parcelHelpers.export(exports, "a$", ()=>getStyle);
parcelHelpers.export(exports, "a0", ()=>toFont);
parcelHelpers.export(exports, "a1", ()=>_toLeftRightCenter);
parcelHelpers.export(exports, "a2", ()=>_alignStartEnd);
parcelHelpers.export(exports, "a3", ()=>overrides);
parcelHelpers.export(exports, "a4", ()=>merge);
parcelHelpers.export(exports, "a5", ()=>_capitalize);
parcelHelpers.export(exports, "a6", ()=>descriptors);
parcelHelpers.export(exports, "a7", ()=>isFunction);
parcelHelpers.export(exports, "a8", ()=>_attachContext);
parcelHelpers.export(exports, "a9", ()=>_createResolver);
parcelHelpers.export(exports, "aA", ()=>getRtlAdapter);
parcelHelpers.export(exports, "aB", ()=>overrideTextDirection);
parcelHelpers.export(exports, "aC", ()=>_textX);
parcelHelpers.export(exports, "aD", ()=>restoreTextDirection);
parcelHelpers.export(exports, "aE", ()=>drawPointLegend);
parcelHelpers.export(exports, "aF", ()=>distanceBetweenPoints);
parcelHelpers.export(exports, "aG", ()=>noop);
parcelHelpers.export(exports, "aH", ()=>_setMinAndMaxByKey);
parcelHelpers.export(exports, "aI", ()=>niceNum);
parcelHelpers.export(exports, "aJ", ()=>almostWhole);
parcelHelpers.export(exports, "aK", ()=>almostEquals);
parcelHelpers.export(exports, "aL", ()=>_decimalPlaces);
parcelHelpers.export(exports, "aM", ()=>Ticks);
parcelHelpers.export(exports, "aN", ()=>log10);
parcelHelpers.export(exports, "aO", ()=>_longestText);
parcelHelpers.export(exports, "aP", ()=>_filterBetween);
parcelHelpers.export(exports, "aQ", ()=>_lookup);
parcelHelpers.export(exports, "aR", ()=>isPatternOrGradient);
parcelHelpers.export(exports, "aS", ()=>getHoverColor);
parcelHelpers.export(exports, "aT", ()=>clone);
parcelHelpers.export(exports, "aU", ()=>_merger);
parcelHelpers.export(exports, "aV", ()=>_mergerIf);
parcelHelpers.export(exports, "aW", ()=>_deprecated);
parcelHelpers.export(exports, "aX", ()=>_splitKey);
parcelHelpers.export(exports, "aY", ()=>toFontString);
parcelHelpers.export(exports, "aZ", ()=>splineCurve);
parcelHelpers.export(exports, "a_", ()=>splineCurveMonotone);
parcelHelpers.export(exports, "aa", ()=>_descriptors);
parcelHelpers.export(exports, "ab", ()=>mergeIf);
parcelHelpers.export(exports, "ac", ()=>uid);
parcelHelpers.export(exports, "ad", ()=>debounce);
parcelHelpers.export(exports, "ae", ()=>retinaScale);
parcelHelpers.export(exports, "af", ()=>clearCanvas);
parcelHelpers.export(exports, "ag", ()=>setsEqual);
parcelHelpers.export(exports, "ah", ()=>getDatasetClipArea);
parcelHelpers.export(exports, "ai", ()=>_elementsEqual);
parcelHelpers.export(exports, "aj", ()=>_isClickEvent);
parcelHelpers.export(exports, "ak", ()=>_isBetween);
parcelHelpers.export(exports, "al", ()=>_readValueToProps);
parcelHelpers.export(exports, "am", ()=>_updateBezierControlPoints);
parcelHelpers.export(exports, "an", ()=>_computeSegments);
parcelHelpers.export(exports, "ao", ()=>_boundSegments);
parcelHelpers.export(exports, "ap", ()=>_steppedInterpolation);
parcelHelpers.export(exports, "aq", ()=>_bezierInterpolation);
parcelHelpers.export(exports, "ar", ()=>_pointInLine);
parcelHelpers.export(exports, "as", ()=>_steppedLineTo);
parcelHelpers.export(exports, "at", ()=>_bezierCurveTo);
parcelHelpers.export(exports, "au", ()=>drawPoint);
parcelHelpers.export(exports, "av", ()=>addRoundedRectPath);
parcelHelpers.export(exports, "aw", ()=>toTRBL);
parcelHelpers.export(exports, "ax", ()=>toTRBLCorners);
parcelHelpers.export(exports, "ay", ()=>_boundSegment);
parcelHelpers.export(exports, "az", ()=>_normalizeAngle);
parcelHelpers.export(exports, "b", ()=>isArray);
parcelHelpers.export(exports, "b0", ()=>fontString);
parcelHelpers.export(exports, "b1", ()=>toLineHeight);
parcelHelpers.export(exports, "b2", ()=>PITAU);
parcelHelpers.export(exports, "b3", ()=>INFINITY);
parcelHelpers.export(exports, "b4", ()=>RAD_PER_DEG);
parcelHelpers.export(exports, "b5", ()=>QUARTER_PI);
parcelHelpers.export(exports, "b6", ()=>TWO_THIRDS_PI);
parcelHelpers.export(exports, "b7", ()=>_angleDiff);
parcelHelpers.export(exports, "c", ()=>color);
parcelHelpers.export(exports, "d", ()=>defaults);
parcelHelpers.export(exports, "e", ()=>effects);
parcelHelpers.export(exports, "f", ()=>resolveObjectKey);
parcelHelpers.export(exports, "g", ()=>isNumberFinite);
parcelHelpers.export(exports, "h", ()=>defined);
parcelHelpers.export(exports, "i", ()=>isObject);
parcelHelpers.export(exports, "j", ()=>createContext);
parcelHelpers.export(exports, "k", ()=>isNullOrUndef);
parcelHelpers.export(exports, "l", ()=>listenArrayEvents);
parcelHelpers.export(exports, "m", ()=>toPercentage);
parcelHelpers.export(exports, "n", ()=>toDimension);
parcelHelpers.export(exports, "o", ()=>formatNumber);
parcelHelpers.export(exports, "p", ()=>_angleBetween);
parcelHelpers.export(exports, "q", ()=>_getStartAndCountOfVisiblePoints);
parcelHelpers.export(exports, "r", ()=>requestAnimFrame);
parcelHelpers.export(exports, "s", ()=>sign);
parcelHelpers.export(exports, "t", ()=>toRadians);
parcelHelpers.export(exports, "u", ()=>unlistenArrayEvents);
parcelHelpers.export(exports, "v", ()=>valueOrDefault);
parcelHelpers.export(exports, "w", ()=>_scaleRangesChanged);
parcelHelpers.export(exports, "x", ()=>isNumber);
parcelHelpers.export(exports, "y", ()=>_parseObjectDataRadialScale);
parcelHelpers.export(exports, "z", ()=>getRelativePosition);
var _color = require("@kurkle/color");
/**
 * @namespace Chart.helpers
 */ /**
 * An empty function that can be used, for example, for optional callback.
 */ function noop() {
/* noop */ }
/**
 * Returns a unique id, sequentially generated from a global variable.
 */ const uid = (()=>{
    let id = 0;
    return ()=>id++;
})();
/**
 * Returns true if `value` is neither null nor undefined, else returns false.
 * @param value - The value to test.
 * @since 2.7.0
 */ function isNullOrUndef(value) {
    return value === null || value === undefined;
}
/**
 * Returns true if `value` is an array (including typed arrays), else returns false.
 * @param value - The value to test.
 * @function
 */ function isArray(value) {
    if (Array.isArray && Array.isArray(value)) return true;
    const type = Object.prototype.toString.call(value);
    if (type.slice(0, 7) === '[object' && type.slice(-6) === 'Array]') return true;
    return false;
}
/**
 * Returns true if `value` is an object (excluding null), else returns false.
 * @param value - The value to test.
 * @since 2.7.0
 */ function isObject(value) {
    return value !== null && Object.prototype.toString.call(value) === '[object Object]';
}
/**
 * Returns true if `value` is a finite number, else returns false
 * @param value  - The value to test.
 */ function isNumberFinite(value) {
    return (typeof value === 'number' || value instanceof Number) && isFinite(+value);
}
/**
 * Returns `value` if finite, else returns `defaultValue`.
 * @param value - The value to return if defined.
 * @param defaultValue - The value to return if `value` is not finite.
 */ function finiteOrDefault(value, defaultValue) {
    return isNumberFinite(value) ? value : defaultValue;
}
/**
 * Returns `value` if defined, else returns `defaultValue`.
 * @param value - The value to return if defined.
 * @param defaultValue - The value to return if `value` is undefined.
 */ function valueOrDefault(value, defaultValue) {
    return typeof value === 'undefined' ? defaultValue : value;
}
const toPercentage = (value, dimension)=>typeof value === 'string' && value.endsWith('%') ? parseFloat(value) / 100 : +value / dimension;
const toDimension = (value, dimension)=>typeof value === 'string' && value.endsWith('%') ? parseFloat(value) / 100 * dimension : +value;
/**
 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
 * @param fn - The function to call.
 * @param args - The arguments with which `fn` should be called.
 * @param [thisArg] - The value of `this` provided for the call to `fn`.
 */ function callback(fn, args, thisArg) {
    if (fn && typeof fn.call === 'function') return fn.apply(thisArg, args);
}
function each(loopable, fn, thisArg, reverse) {
    let i, len, keys;
    if (isArray(loopable)) {
        len = loopable.length;
        if (reverse) for(i = len - 1; i >= 0; i--)fn.call(thisArg, loopable[i], i);
        else for(i = 0; i < len; i++)fn.call(thisArg, loopable[i], i);
    } else if (isObject(loopable)) {
        keys = Object.keys(loopable);
        len = keys.length;
        for(i = 0; i < len; i++)fn.call(thisArg, loopable[keys[i]], keys[i]);
    }
}
/**
 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
 * @param a0 - The array to compare
 * @param a1 - The array to compare
 * @private
 */ function _elementsEqual(a0, a1) {
    let i, ilen, v0, v1;
    if (!a0 || !a1 || a0.length !== a1.length) return false;
    for(i = 0, ilen = a0.length; i < ilen; ++i){
        v0 = a0[i];
        v1 = a1[i];
        if (v0.datasetIndex !== v1.datasetIndex || v0.index !== v1.index) return false;
    }
    return true;
}
/**
 * Returns a deep copy of `source` without keeping references on objects and arrays.
 * @param source - The value to clone.
 */ function clone(source) {
    if (isArray(source)) return source.map(clone);
    if (isObject(source)) {
        const target = Object.create(null);
        const keys = Object.keys(source);
        const klen = keys.length;
        let k = 0;
        for(; k < klen; ++k)target[keys[k]] = clone(source[keys[k]]);
        return target;
    }
    return source;
}
function isValidKey(key) {
    return [
        '__proto__',
        'prototype',
        'constructor'
    ].indexOf(key) === -1;
}
/**
 * The default merger when Chart.helpers.merge is called without merger option.
 * Note(SB): also used by mergeConfig and mergeScaleConfig as fallback.
 * @private
 */ function _merger(key, target, source, options) {
    if (!isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if (isObject(tval) && isObject(sval)) // eslint-disable-next-line @typescript-eslint/no-use-before-define
    merge(tval, sval, options);
    else target[key] = clone(sval);
}
function merge(target, source, options) {
    const sources = isArray(source) ? source : [
        source
    ];
    const ilen = sources.length;
    if (!isObject(target)) return target;
    options = options || {};
    const merger = options.merger || _merger;
    let current;
    for(let i = 0; i < ilen; ++i){
        current = sources[i];
        if (!isObject(current)) continue;
        const keys = Object.keys(current);
        for(let k = 0, klen = keys.length; k < klen; ++k)merger(keys[k], target, current, options);
    }
    return target;
}
function mergeIf(target, source) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return merge(target, source, {
        merger: _mergerIf
    });
}
/**
 * Merges source[key] in target[key] only if target[key] is undefined.
 * @private
 */ function _mergerIf(key, target, source) {
    if (!isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if (isObject(tval) && isObject(sval)) mergeIf(tval, sval);
    else if (!Object.prototype.hasOwnProperty.call(target, key)) target[key] = clone(sval);
}
/**
 * @private
 */ function _deprecated(scope, value, previous, current) {
    if (value !== undefined) console.warn(scope + ': "' + previous + '" is deprecated. Please use "' + current + '" instead');
}
// resolveObjectKey resolver cache
const keyResolvers = {
    // Chart.helpers.core resolveObjectKey should resolve empty key to root object
    '': (v)=>v,
    // default resolvers
    x: (o)=>o.x,
    y: (o)=>o.y
};
/**
 * @private
 */ function _splitKey(key) {
    const parts = key.split('.');
    const keys = [];
    let tmp = '';
    for (const part of parts){
        tmp += part;
        if (tmp.endsWith('\\')) tmp = tmp.slice(0, -1) + '.';
        else {
            keys.push(tmp);
            tmp = '';
        }
    }
    return keys;
}
function _getKeyResolver(key) {
    const keys = _splitKey(key);
    return (obj)=>{
        for (const k of keys){
            if (k === '') break;
            obj = obj && obj[k];
        }
        return obj;
    };
}
function resolveObjectKey(obj, key) {
    const resolver = keyResolvers[key] || (keyResolvers[key] = _getKeyResolver(key));
    return resolver(obj);
}
/**
 * @private
 */ function _capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
const defined = (value)=>typeof value !== 'undefined';
const isFunction = (value)=>typeof value === 'function';
// Adapted from https://stackoverflow.com/questions/31128855/comparing-ecma6-sets-for-equality#31129384
const setsEqual = (a, b)=>{
    if (a.size !== b.size) return false;
    for (const item of a){
        if (!b.has(item)) return false;
    }
    return true;
};
/**
 * @param e - The event
 * @private
 */ function _isClickEvent(e) {
    return e.type === 'mouseup' || e.type === 'click' || e.type === 'contextmenu';
}
/**
 * @alias Chart.helpers.math
 * @namespace
 */ const PI = Math.PI;
const TAU = 2 * PI;
const PITAU = TAU + PI;
const INFINITY = Number.POSITIVE_INFINITY;
const RAD_PER_DEG = PI / 180;
const HALF_PI = PI / 2;
const QUARTER_PI = PI / 4;
const TWO_THIRDS_PI = PI * 2 / 3;
const log10 = Math.log10;
const sign = Math.sign;
function almostEquals(x, y, epsilon) {
    return Math.abs(x - y) < epsilon;
}
/**
 * Implementation of the nice number algorithm used in determining where axis labels will go
 */ function niceNum(range) {
    const roundedRange = Math.round(range);
    range = almostEquals(range, roundedRange, range / 1000) ? roundedRange : range;
    const niceRange = Math.pow(10, Math.floor(log10(range)));
    const fraction = range / niceRange;
    const niceFraction = fraction <= 1 ? 1 : fraction <= 2 ? 2 : fraction <= 5 ? 5 : 10;
    return niceFraction * niceRange;
}
/**
 * Returns an array of factors sorted from 1 to sqrt(value)
 * @private
 */ function _factorize(value) {
    const result = [];
    const sqrt = Math.sqrt(value);
    let i;
    for(i = 1; i < sqrt; i++)if (value % i === 0) {
        result.push(i);
        result.push(value / i);
    }
    if (sqrt === (sqrt | 0)) result.push(sqrt);
    result.sort((a, b)=>a - b).pop();
    return result;
}
/**
 * Verifies that attempting to coerce n to string or number won't throw a TypeError.
 */ function isNonPrimitive(n) {
    return typeof n === 'symbol' || typeof n === 'object' && n !== null && !(Symbol.toPrimitive in n || 'toString' in n || 'valueOf' in n);
}
function isNumber(n) {
    return !isNonPrimitive(n) && !isNaN(parseFloat(n)) && isFinite(n);
}
function almostWhole(x, epsilon) {
    const rounded = Math.round(x);
    return rounded - epsilon <= x && rounded + epsilon >= x;
}
/**
 * @private
 */ function _setMinAndMaxByKey(array, target, property) {
    let i, ilen, value;
    for(i = 0, ilen = array.length; i < ilen; i++){
        value = array[i][property];
        if (!isNaN(value)) {
            target.min = Math.min(target.min, value);
            target.max = Math.max(target.max, value);
        }
    }
}
function toRadians(degrees) {
    return degrees * (PI / 180);
}
function toDegrees(radians) {
    return radians * (180 / PI);
}
/**
 * Returns the number of decimal places
 * i.e. the number of digits after the decimal point, of the value of this Number.
 * @param x - A number.
 * @returns The number of decimal places.
 * @private
 */ function _decimalPlaces(x) {
    if (!isNumberFinite(x)) return;
    let e = 1;
    let p = 0;
    while(Math.round(x * e) / e !== x){
        e *= 10;
        p++;
    }
    return p;
}
// Gets the angle from vertical upright to the point about a centre.
function getAngleFromPoint(centrePoint, anglePoint) {
    const distanceFromXCenter = anglePoint.x - centrePoint.x;
    const distanceFromYCenter = anglePoint.y - centrePoint.y;
    const radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
    let angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
    if (angle < -0.5 * PI) angle += TAU; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
    return {
        angle,
        distance: radialDistanceFromCenter
    };
}
function distanceBetweenPoints(pt1, pt2) {
    return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
}
/**
 * Shortest distance between angles, in either direction.
 * @private
 */ function _angleDiff(a, b) {
    return (a - b + PITAU) % TAU - PI;
}
/**
 * Normalize angle to be between 0 and 2*PI
 * @private
 */ function _normalizeAngle(a) {
    return (a % TAU + TAU) % TAU;
}
/**
 * @private
 */ function _angleBetween(angle, start, end, sameAngleIsFullCircle) {
    const a = _normalizeAngle(angle);
    const s = _normalizeAngle(start);
    const e = _normalizeAngle(end);
    const angleToStart = _normalizeAngle(s - a);
    const angleToEnd = _normalizeAngle(e - a);
    const startToAngle = _normalizeAngle(a - s);
    const endToAngle = _normalizeAngle(a - e);
    return a === s || a === e || sameAngleIsFullCircle && s === e || angleToStart > angleToEnd && startToAngle < endToAngle;
}
/**
 * Limit `value` between `min` and `max`
 * @param value
 * @param min
 * @param max
 * @private
 */ function _limitValue(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
/**
 * @param {number} value
 * @private
 */ function _int16Range(value) {
    return _limitValue(value, -32768, 32767);
}
/**
 * @param value
 * @param start
 * @param end
 * @param [epsilon]
 * @private
 */ function _isBetween(value, start, end, epsilon = 1e-6) {
    return value >= Math.min(start, end) - epsilon && value <= Math.max(start, end) + epsilon;
}
function _lookup(table, value, cmp) {
    cmp = cmp || ((index)=>table[index] < value);
    let hi = table.length - 1;
    let lo = 0;
    let mid;
    while(hi - lo > 1){
        mid = lo + hi >> 1;
        if (cmp(mid)) lo = mid;
        else hi = mid;
    }
    return {
        lo,
        hi
    };
}
/**
 * Binary search
 * @param table - the table search. must be sorted!
 * @param key - property name for the value in each entry
 * @param value - value to find
 * @param last - lookup last index
 * @private
 */ const _lookupByKey = (table, key, value, last)=>_lookup(table, value, last ? (index)=>{
        const ti = table[index][key];
        return ti < value || ti === value && table[index + 1][key] === value;
    } : (index)=>table[index][key] < value);
/**
 * Reverse binary search
 * @param table - the table search. must be sorted!
 * @param key - property name for the value in each entry
 * @param value - value to find
 * @private
 */ const _rlookupByKey = (table, key, value)=>_lookup(table, value, (index)=>table[index][key] >= value);
/**
 * Return subset of `values` between `min` and `max` inclusive.
 * Values are assumed to be in sorted order.
 * @param values - sorted array of values
 * @param min - min value
 * @param max - max value
 */ function _filterBetween(values, min, max) {
    let start = 0;
    let end = values.length;
    while(start < end && values[start] < min)start++;
    while(end > start && values[end - 1] > max)end--;
    return start > 0 || end < values.length ? values.slice(start, end) : values;
}
const arrayEvents = [
    'push',
    'pop',
    'shift',
    'splice',
    'unshift'
];
function listenArrayEvents(array, listener) {
    if (array._chartjs) {
        array._chartjs.listeners.push(listener);
        return;
    }
    Object.defineProperty(array, '_chartjs', {
        configurable: true,
        enumerable: false,
        value: {
            listeners: [
                listener
            ]
        }
    });
    arrayEvents.forEach((key)=>{
        const method = '_onData' + _capitalize(key);
        const base = array[key];
        Object.defineProperty(array, key, {
            configurable: true,
            enumerable: false,
            value (...args) {
                const res = base.apply(this, args);
                array._chartjs.listeners.forEach((object)=>{
                    if (typeof object[method] === 'function') object[method](...args);
                });
                return res;
            }
        });
    });
}
function unlistenArrayEvents(array, listener) {
    const stub = array._chartjs;
    if (!stub) return;
    const listeners = stub.listeners;
    const index = listeners.indexOf(listener);
    if (index !== -1) listeners.splice(index, 1);
    if (listeners.length > 0) return;
    arrayEvents.forEach((key)=>{
        delete array[key];
    });
    delete array._chartjs;
}
/**
 * @param items
 */ function _arrayUnique(items) {
    const set = new Set(items);
    if (set.size === items.length) return items;
    return Array.from(set);
}
function fontString(pixelSize, fontStyle, fontFamily) {
    return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
}
/**
* Request animation polyfill
*/ const requestAnimFrame = function() {
    if (typeof window === 'undefined') return function(callback) {
        return callback();
    };
    return window.requestAnimationFrame;
}();
/**
 * Throttles calling `fn` once per animation frame
 * Latest arguments are used on the actual call
 */ function throttled(fn, thisArg) {
    let argsToUse = [];
    let ticking = false;
    return function(...args) {
        // Save the args for use later
        argsToUse = args;
        if (!ticking) {
            ticking = true;
            requestAnimFrame.call(window, ()=>{
                ticking = false;
                fn.apply(thisArg, argsToUse);
            });
        }
    };
}
/**
 * Debounces calling `fn` for `delay` ms
 */ function debounce(fn, delay) {
    let timeout;
    return function(...args) {
        if (delay) {
            clearTimeout(timeout);
            timeout = setTimeout(fn, delay, args);
        } else fn.apply(this, args);
        return delay;
    };
}
/**
 * Converts 'start' to 'left', 'end' to 'right' and others to 'center'
 * @private
 */ const _toLeftRightCenter = (align)=>align === 'start' ? 'left' : align === 'end' ? 'right' : 'center';
/**
 * Returns `start`, `end` or `(start + end) / 2` depending on `align`. Defaults to `center`
 * @private
 */ const _alignStartEnd = (align, start, end)=>align === 'start' ? start : align === 'end' ? end : (start + end) / 2;
/**
 * Returns `left`, `right` or `(left + right) / 2` depending on `align`. Defaults to `left`
 * @private
 */ const _textX = (align, left, right, rtl)=>{
    const check = rtl ? 'left' : 'right';
    return align === check ? right : align === 'center' ? (left + right) / 2 : left;
};
/**
 * Return start and count of visible points.
 * @private
 */ function _getStartAndCountOfVisiblePoints(meta, points, animationsDisabled) {
    const pointCount = points.length;
    let start = 0;
    let count = pointCount;
    if (meta._sorted) {
        const { iScale, vScale, _parsed } = meta;
        const spanGaps = meta.dataset ? meta.dataset.options ? meta.dataset.options.spanGaps : null : null;
        const axis = iScale.axis;
        const { min, max, minDefined, maxDefined } = iScale.getUserBounds();
        if (minDefined) {
            start = Math.min(_lookupByKey(_parsed, axis, min).lo, animationsDisabled ? pointCount : _lookupByKey(points, axis, iScale.getPixelForValue(min)).lo);
            if (spanGaps) {
                const distanceToDefinedLo = _parsed.slice(0, start + 1).reverse().findIndex((point)=>!isNullOrUndef(point[vScale.axis]));
                start -= Math.max(0, distanceToDefinedLo);
            }
            start = _limitValue(start, 0, pointCount - 1);
        }
        if (maxDefined) {
            let end = Math.max(_lookupByKey(_parsed, iScale.axis, max, true).hi + 1, animationsDisabled ? 0 : _lookupByKey(points, axis, iScale.getPixelForValue(max), true).hi + 1);
            if (spanGaps) {
                const distanceToDefinedHi = _parsed.slice(end - 1).findIndex((point)=>!isNullOrUndef(point[vScale.axis]));
                end += Math.max(0, distanceToDefinedHi);
            }
            count = _limitValue(end, start, pointCount) - start;
        } else count = pointCount - start;
    }
    return {
        start,
        count
    };
}
/**
 * Checks if the scale ranges have changed.
 * @param {object} meta - dataset meta.
 * @returns {boolean}
 * @private
 */ function _scaleRangesChanged(meta) {
    const { xScale, yScale, _scaleRanges } = meta;
    const newRanges = {
        xmin: xScale.min,
        xmax: xScale.max,
        ymin: yScale.min,
        ymax: yScale.max
    };
    if (!_scaleRanges) {
        meta._scaleRanges = newRanges;
        return true;
    }
    const changed = _scaleRanges.xmin !== xScale.min || _scaleRanges.xmax !== xScale.max || _scaleRanges.ymin !== yScale.min || _scaleRanges.ymax !== yScale.max;
    Object.assign(_scaleRanges, newRanges);
    return changed;
}
const atEdge = (t)=>t === 0 || t === 1;
const elasticIn = (t, s, p)=>-(Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * TAU / p));
const elasticOut = (t, s, p)=>Math.pow(2, -10 * t) * Math.sin((t - s) * TAU / p) + 1;
/**
 * Easing functions adapted from Robert Penner's easing equations.
 * @namespace Chart.helpers.easing.effects
 * @see http://www.robertpenner.com/easing/
 */ const effects = {
    linear: (t)=>t,
    easeInQuad: (t)=>t * t,
    easeOutQuad: (t)=>-t * (t - 2),
    easeInOutQuad: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t : -0.5 * (--t * (t - 2) - 1),
    easeInCubic: (t)=>t * t * t,
    easeOutCubic: (t)=>(t -= 1) * t * t + 1,
    easeInOutCubic: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t : 0.5 * ((t -= 2) * t * t + 2),
    easeInQuart: (t)=>t * t * t * t,
    easeOutQuart: (t)=>-((t -= 1) * t * t * t - 1),
    easeInOutQuart: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t : -0.5 * ((t -= 2) * t * t * t - 2),
    easeInQuint: (t)=>t * t * t * t * t,
    easeOutQuint: (t)=>(t -= 1) * t * t * t * t + 1,
    easeInOutQuint: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t * t : 0.5 * ((t -= 2) * t * t * t * t + 2),
    easeInSine: (t)=>-Math.cos(t * HALF_PI) + 1,
    easeOutSine: (t)=>Math.sin(t * HALF_PI),
    easeInOutSine: (t)=>-0.5 * (Math.cos(PI * t) - 1),
    easeInExpo: (t)=>t === 0 ? 0 : Math.pow(2, 10 * (t - 1)),
    easeOutExpo: (t)=>t === 1 ? 1 : -Math.pow(2, -10 * t) + 1,
    easeInOutExpo: (t)=>atEdge(t) ? t : t < 0.5 ? 0.5 * Math.pow(2, 10 * (t * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (t * 2 - 1)) + 2),
    easeInCirc: (t)=>t >= 1 ? t : -(Math.sqrt(1 - t * t) - 1),
    easeOutCirc: (t)=>Math.sqrt(1 - (t -= 1) * t),
    easeInOutCirc: (t)=>(t /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - t * t) - 1) : 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1),
    easeInElastic: (t)=>atEdge(t) ? t : elasticIn(t, 0.075, 0.3),
    easeOutElastic: (t)=>atEdge(t) ? t : elasticOut(t, 0.075, 0.3),
    easeInOutElastic (t) {
        const s = 0.1125;
        const p = 0.45;
        return atEdge(t) ? t : t < 0.5 ? 0.5 * elasticIn(t * 2, s, p) : 0.5 + 0.5 * elasticOut(t * 2 - 1, s, p);
    },
    easeInBack (t) {
        const s = 1.70158;
        return t * t * ((s + 1) * t - s);
    },
    easeOutBack (t) {
        const s = 1.70158;
        return (t -= 1) * t * ((s + 1) * t + s) + 1;
    },
    easeInOutBack (t) {
        let s = 1.70158;
        if ((t /= 0.5) < 1) return 0.5 * (t * t * (((s *= 1.525) + 1) * t - s));
        return 0.5 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2);
    },
    easeInBounce: (t)=>1 - effects.easeOutBounce(1 - t),
    easeOutBounce (t) {
        const m = 7.5625;
        const d = 2.75;
        if (t < 1 / d) return m * t * t;
        if (t < 2 / d) return m * (t -= 1.5 / d) * t + 0.75;
        if (t < 2.5 / d) return m * (t -= 2.25 / d) * t + 0.9375;
        return m * (t -= 2.625 / d) * t + 0.984375;
    },
    easeInOutBounce: (t)=>t < 0.5 ? effects.easeInBounce(t * 2) * 0.5 : effects.easeOutBounce(t * 2 - 1) * 0.5 + 0.5
};
function isPatternOrGradient(value) {
    if (value && typeof value === 'object') {
        const type = value.toString();
        return type === '[object CanvasPattern]' || type === '[object CanvasGradient]';
    }
    return false;
}
function color(value) {
    return isPatternOrGradient(value) ? value : new (0, _color.Color)(value);
}
function getHoverColor(value) {
    return isPatternOrGradient(value) ? value : new (0, _color.Color)(value).saturate(0.5).darken(0.1).hexString();
}
const numbers = [
    'x',
    'y',
    'borderWidth',
    'radius',
    'tension'
];
const colors = [
    'color',
    'borderColor',
    'backgroundColor'
];
function applyAnimationsDefaults(defaults) {
    defaults.set('animation', {
        delay: undefined,
        duration: 1000,
        easing: 'easeOutQuart',
        fn: undefined,
        from: undefined,
        loop: undefined,
        to: undefined,
        type: undefined
    });
    defaults.describe('animation', {
        _fallback: false,
        _indexable: false,
        _scriptable: (name)=>name !== 'onProgress' && name !== 'onComplete' && name !== 'fn'
    });
    defaults.set('animations', {
        colors: {
            type: 'color',
            properties: colors
        },
        numbers: {
            type: 'number',
            properties: numbers
        }
    });
    defaults.describe('animations', {
        _fallback: 'animation'
    });
    defaults.set('transitions', {
        active: {
            animation: {
                duration: 400
            }
        },
        resize: {
            animation: {
                duration: 0
            }
        },
        show: {
            animations: {
                colors: {
                    from: 'transparent'
                },
                visible: {
                    type: 'boolean',
                    duration: 0
                }
            }
        },
        hide: {
            animations: {
                colors: {
                    to: 'transparent'
                },
                visible: {
                    type: 'boolean',
                    easing: 'linear',
                    fn: (v)=>v | 0
                }
            }
        }
    });
}
function applyLayoutsDefaults(defaults) {
    defaults.set('layout', {
        autoPadding: true,
        padding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        }
    });
}
const intlCache = new Map();
function getNumberFormat(locale, options) {
    options = options || {};
    const cacheKey = locale + JSON.stringify(options);
    let formatter = intlCache.get(cacheKey);
    if (!formatter) {
        formatter = new Intl.NumberFormat(locale, options);
        intlCache.set(cacheKey, formatter);
    }
    return formatter;
}
function formatNumber(num, locale, options) {
    return getNumberFormat(locale, options).format(num);
}
const formatters = {
    values (value) {
        return isArray(value) ? value : '' + value;
    },
    numeric (tickValue, index, ticks) {
        if (tickValue === 0) return '0';
        const locale = this.chart.options.locale;
        let notation;
        let delta = tickValue;
        if (ticks.length > 1) {
            const maxTick = Math.max(Math.abs(ticks[0].value), Math.abs(ticks[ticks.length - 1].value));
            if (maxTick < 1e-4 || maxTick > 1e+15) notation = 'scientific';
            delta = calculateDelta(tickValue, ticks);
        }
        const logDelta = log10(Math.abs(delta));
        const numDecimal = isNaN(logDelta) ? 1 : Math.max(Math.min(-1 * Math.floor(logDelta), 20), 0);
        const options = {
            notation,
            minimumFractionDigits: numDecimal,
            maximumFractionDigits: numDecimal
        };
        Object.assign(options, this.options.ticks.format);
        return formatNumber(tickValue, locale, options);
    },
    logarithmic (tickValue, index, ticks) {
        if (tickValue === 0) return '0';
        const remain = ticks[index].significand || tickValue / Math.pow(10, Math.floor(log10(tickValue)));
        if ([
            1,
            2,
            3,
            5,
            10,
            15
        ].includes(remain) || index > 0.8 * ticks.length) return formatters.numeric.call(this, tickValue, index, ticks);
        return '';
    }
};
function calculateDelta(tickValue, ticks) {
    let delta = ticks.length > 3 ? ticks[2].value - ticks[1].value : ticks[1].value - ticks[0].value;
    if (Math.abs(delta) >= 1 && tickValue !== Math.floor(tickValue)) delta = tickValue - Math.floor(tickValue);
    return delta;
}
var Ticks = {
    formatters
};
function applyScaleDefaults(defaults) {
    defaults.set('scale', {
        display: true,
        offset: false,
        reverse: false,
        beginAtZero: false,
        bounds: 'ticks',
        clip: true,
        grace: 0,
        grid: {
            display: true,
            lineWidth: 1,
            drawOnChartArea: true,
            drawTicks: true,
            tickLength: 8,
            tickWidth: (_ctx, options)=>options.lineWidth,
            tickColor: (_ctx, options)=>options.color,
            offset: false
        },
        border: {
            display: true,
            dash: [],
            dashOffset: 0.0,
            width: 1
        },
        title: {
            display: false,
            text: '',
            padding: {
                top: 4,
                bottom: 4
            }
        },
        ticks: {
            minRotation: 0,
            maxRotation: 50,
            mirror: false,
            textStrokeWidth: 0,
            textStrokeColor: '',
            padding: 3,
            display: true,
            autoSkip: true,
            autoSkipPadding: 3,
            labelOffset: 0,
            callback: Ticks.formatters.values,
            minor: {},
            major: {},
            align: 'center',
            crossAlign: 'near',
            showLabelBackdrop: false,
            backdropColor: 'rgba(255, 255, 255, 0.75)',
            backdropPadding: 2
        }
    });
    defaults.route('scale.ticks', 'color', '', 'color');
    defaults.route('scale.grid', 'color', '', 'borderColor');
    defaults.route('scale.border', 'color', '', 'borderColor');
    defaults.route('scale.title', 'color', '', 'color');
    defaults.describe('scale', {
        _fallback: false,
        _scriptable: (name)=>!name.startsWith('before') && !name.startsWith('after') && name !== 'callback' && name !== 'parser',
        _indexable: (name)=>name !== 'borderDash' && name !== 'tickBorderDash' && name !== 'dash'
    });
    defaults.describe('scales', {
        _fallback: 'scale'
    });
    defaults.describe('scale.ticks', {
        _scriptable: (name)=>name !== 'backdropPadding' && name !== 'callback',
        _indexable: (name)=>name !== 'backdropPadding'
    });
}
const overrides = Object.create(null);
const descriptors = Object.create(null);
function getScope$1(node, key) {
    if (!key) return node;
    const keys = key.split('.');
    for(let i = 0, n = keys.length; i < n; ++i){
        const k = keys[i];
        node = node[k] || (node[k] = Object.create(null));
    }
    return node;
}
function set(root, scope, values) {
    if (typeof scope === 'string') return merge(getScope$1(root, scope), values);
    return merge(getScope$1(root, ''), scope);
}
class Defaults {
    constructor(_descriptors, _appliers){
        this.animation = undefined;
        this.backgroundColor = 'rgba(0,0,0,0.1)';
        this.borderColor = 'rgba(0,0,0,0.1)';
        this.color = '#666';
        this.datasets = {};
        this.devicePixelRatio = (context)=>context.chart.platform.getDevicePixelRatio();
        this.elements = {};
        this.events = [
            'mousemove',
            'mouseout',
            'click',
            'touchstart',
            'touchmove'
        ];
        this.font = {
            family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
            size: 12,
            style: 'normal',
            lineHeight: 1.2,
            weight: null
        };
        this.hover = {};
        this.hoverBackgroundColor = (ctx, options)=>getHoverColor(options.backgroundColor);
        this.hoverBorderColor = (ctx, options)=>getHoverColor(options.borderColor);
        this.hoverColor = (ctx, options)=>getHoverColor(options.color);
        this.indexAxis = 'x';
        this.interaction = {
            mode: 'nearest',
            intersect: true,
            includeInvisible: false
        };
        this.maintainAspectRatio = true;
        this.onHover = null;
        this.onClick = null;
        this.parsing = true;
        this.plugins = {};
        this.responsive = true;
        this.scale = undefined;
        this.scales = {};
        this.showLine = true;
        this.drawActiveElementsOnTop = true;
        this.describe(_descriptors);
        this.apply(_appliers);
    }
    set(scope, values) {
        return set(this, scope, values);
    }
    get(scope) {
        return getScope$1(this, scope);
    }
    describe(scope, values) {
        return set(descriptors, scope, values);
    }
    override(scope, values) {
        return set(overrides, scope, values);
    }
    route(scope, name, targetScope, targetName) {
        const scopeObject = getScope$1(this, scope);
        const targetScopeObject = getScope$1(this, targetScope);
        const privateName = '_' + name;
        Object.defineProperties(scopeObject, {
            [privateName]: {
                value: scopeObject[name],
                writable: true
            },
            [name]: {
                enumerable: true,
                get () {
                    const local = this[privateName];
                    const target = targetScopeObject[targetName];
                    if (isObject(local)) return Object.assign({}, target, local);
                    return valueOrDefault(local, target);
                },
                set (value) {
                    this[privateName] = value;
                }
            }
        });
    }
    apply(appliers) {
        appliers.forEach((apply)=>apply(this));
    }
}
var defaults = /* #__PURE__ */ new Defaults({
    _scriptable: (name)=>!name.startsWith('on'),
    _indexable: (name)=>name !== 'events',
    hover: {
        _fallback: 'interaction'
    },
    interaction: {
        _scriptable: false,
        _indexable: false
    }
}, [
    applyAnimationsDefaults,
    applyLayoutsDefaults,
    applyScaleDefaults
]);
/**
 * Converts the given font object into a CSS font string.
 * @param font - A font object.
 * @return The CSS font string. See https://developer.mozilla.org/en-US/docs/Web/CSS/font
 * @private
 */ function toFontString(font) {
    if (!font || isNullOrUndef(font.size) || isNullOrUndef(font.family)) return null;
    return (font.style ? font.style + ' ' : '') + (font.weight ? font.weight + ' ' : '') + font.size + 'px ' + font.family;
}
/**
 * @private
 */ function _measureText(ctx, data, gc, longest, string) {
    let textWidth = data[string];
    if (!textWidth) {
        textWidth = data[string] = ctx.measureText(string).width;
        gc.push(string);
    }
    if (textWidth > longest) longest = textWidth;
    return longest;
}
/**
 * @private
 */ // eslint-disable-next-line complexity
function _longestText(ctx, font, arrayOfThings, cache) {
    cache = cache || {};
    let data = cache.data = cache.data || {};
    let gc = cache.garbageCollect = cache.garbageCollect || [];
    if (cache.font !== font) {
        data = cache.data = {};
        gc = cache.garbageCollect = [];
        cache.font = font;
    }
    ctx.save();
    ctx.font = font;
    let longest = 0;
    const ilen = arrayOfThings.length;
    let i, j, jlen, thing, nestedThing;
    for(i = 0; i < ilen; i++){
        thing = arrayOfThings[i];
        // Undefined strings and arrays should not be measured
        if (thing !== undefined && thing !== null && !isArray(thing)) longest = _measureText(ctx, data, gc, longest, thing);
        else if (isArray(thing)) // if it is an array lets measure each element
        // to do maybe simplify this function a bit so we can do this more recursively?
        for(j = 0, jlen = thing.length; j < jlen; j++){
            nestedThing = thing[j];
            // Undefined strings and arrays should not be measured
            if (nestedThing !== undefined && nestedThing !== null && !isArray(nestedThing)) longest = _measureText(ctx, data, gc, longest, nestedThing);
        }
    }
    ctx.restore();
    const gcLen = gc.length / 2;
    if (gcLen > arrayOfThings.length) {
        for(i = 0; i < gcLen; i++)delete data[gc[i]];
        gc.splice(0, gcLen);
    }
    return longest;
}
/**
 * Returns the aligned pixel value to avoid anti-aliasing blur
 * @param chart - The chart instance.
 * @param pixel - A pixel value.
 * @param width - The width of the element.
 * @returns The aligned pixel value.
 * @private
 */ function _alignPixel(chart, pixel, width) {
    const devicePixelRatio = chart.currentDevicePixelRatio;
    const halfWidth = width !== 0 ? Math.max(width / 2, 0.5) : 0;
    return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
}
/**
 * Clears the entire canvas.
 */ function clearCanvas(canvas, ctx) {
    if (!ctx && !canvas) return;
    ctx = ctx || canvas.getContext('2d');
    ctx.save();
    // canvas.width and canvas.height do not consider the canvas transform,
    // while clearRect does
    ctx.resetTransform();
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.restore();
}
function drawPoint(ctx, options, x, y) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    drawPointLegend(ctx, options, x, y, null);
}
// eslint-disable-next-line complexity
function drawPointLegend(ctx, options, x, y, w) {
    let type, xOffset, yOffset, size, cornerRadius, width, xOffsetW, yOffsetW;
    const style = options.pointStyle;
    const rotation = options.rotation;
    const radius = options.radius;
    let rad = (rotation || 0) * RAD_PER_DEG;
    if (style && typeof style === 'object') {
        type = style.toString();
        if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
            ctx.save();
            ctx.translate(x, y);
            ctx.rotate(rad);
            ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
            ctx.restore();
            return;
        }
    }
    if (isNaN(radius) || radius <= 0) return;
    ctx.beginPath();
    switch(style){
        // Default includes circle
        default:
            if (w) ctx.ellipse(x, y, w / 2, radius, 0, 0, TAU);
            else ctx.arc(x, y, radius, 0, TAU);
            ctx.closePath();
            break;
        case 'triangle':
            width = w ? w / 2 : radius;
            ctx.moveTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            rad += TWO_THIRDS_PI;
            ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            rad += TWO_THIRDS_PI;
            ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            ctx.closePath();
            break;
        case 'rectRounded':
            // NOTE: the rounded rect implementation changed to use `arc` instead of
            // `quadraticCurveTo` since it generates better results when rect is
            // almost a circle. 0.516 (instead of 0.5) produces results with visually
            // closer proportion to the previous impl and it is inscribed in the
            // circle with `radius`. For more details, see the following PRs:
            // https://github.com/chartjs/Chart.js/issues/5597
            // https://github.com/chartjs/Chart.js/issues/5858
            cornerRadius = radius * 0.516;
            size = radius - cornerRadius;
            xOffset = Math.cos(rad + QUARTER_PI) * size;
            xOffsetW = Math.cos(rad + QUARTER_PI) * (w ? w / 2 - cornerRadius : size);
            yOffset = Math.sin(rad + QUARTER_PI) * size;
            yOffsetW = Math.sin(rad + QUARTER_PI) * (w ? w / 2 - cornerRadius : size);
            ctx.arc(x - xOffsetW, y - yOffset, cornerRadius, rad - PI, rad - HALF_PI);
            ctx.arc(x + yOffsetW, y - xOffset, cornerRadius, rad - HALF_PI, rad);
            ctx.arc(x + xOffsetW, y + yOffset, cornerRadius, rad, rad + HALF_PI);
            ctx.arc(x - yOffsetW, y + xOffset, cornerRadius, rad + HALF_PI, rad + PI);
            ctx.closePath();
            break;
        case 'rect':
            if (!rotation) {
                size = Math.SQRT1_2 * radius;
                width = w ? w / 2 : size;
                ctx.rect(x - width, y - size, 2 * width, 2 * size);
                break;
            }
            rad += QUARTER_PI;
        /* falls through */ case 'rectRot':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            ctx.closePath();
            break;
        case 'crossRot':
            rad += QUARTER_PI;
        /* falls through */ case 'cross':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            break;
        case 'star':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            rad += QUARTER_PI;
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            break;
        case 'line':
            xOffset = w ? w / 2 : Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            break;
        case 'dash':
            ctx.moveTo(x, y);
            ctx.lineTo(x + Math.cos(rad) * (w ? w / 2 : radius), y + Math.sin(rad) * radius);
            break;
        case false:
            ctx.closePath();
            break;
    }
    ctx.fill();
    if (options.borderWidth > 0) ctx.stroke();
}
/**
 * Returns true if the point is inside the rectangle
 * @param point - The point to test
 * @param area - The rectangle
 * @param margin - allowed margin
 * @private
 */ function _isPointInArea(point, area, margin) {
    margin = margin || 0.5; // margin - default is to match rounded decimals
    return !area || point && point.x > area.left - margin && point.x < area.right + margin && point.y > area.top - margin && point.y < area.bottom + margin;
}
function clipArea(ctx, area) {
    ctx.save();
    ctx.beginPath();
    ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
    ctx.clip();
}
function unclipArea(ctx) {
    ctx.restore();
}
/**
 * @private
 */ function _steppedLineTo(ctx, previous, target, flip, mode) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    if (mode === 'middle') {
        const midpoint = (previous.x + target.x) / 2.0;
        ctx.lineTo(midpoint, previous.y);
        ctx.lineTo(midpoint, target.y);
    } else if (mode === 'after' !== !!flip) ctx.lineTo(previous.x, target.y);
    else ctx.lineTo(target.x, previous.y);
    ctx.lineTo(target.x, target.y);
}
/**
 * @private
 */ function _bezierCurveTo(ctx, previous, target, flip) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    ctx.bezierCurveTo(flip ? previous.cp1x : previous.cp2x, flip ? previous.cp1y : previous.cp2y, flip ? target.cp2x : target.cp1x, flip ? target.cp2y : target.cp1y, target.x, target.y);
}
function setRenderOpts(ctx, opts) {
    if (opts.translation) ctx.translate(opts.translation[0], opts.translation[1]);
    if (!isNullOrUndef(opts.rotation)) ctx.rotate(opts.rotation);
    if (opts.color) ctx.fillStyle = opts.color;
    if (opts.textAlign) ctx.textAlign = opts.textAlign;
    if (opts.textBaseline) ctx.textBaseline = opts.textBaseline;
}
function decorateText(ctx, x, y, line, opts) {
    if (opts.strikethrough || opts.underline) {
        /**
     * Now that IE11 support has been dropped, we can use more
     * of the TextMetrics object. The actual bounding boxes
     * are unflagged in Chrome, Firefox, Edge, and Safari so they
     * can be safely used.
     * See https://developer.mozilla.org/en-US/docs/Web/API/TextMetrics#Browser_compatibility
     */ const metrics = ctx.measureText(line);
        const left = x - metrics.actualBoundingBoxLeft;
        const right = x + metrics.actualBoundingBoxRight;
        const top = y - metrics.actualBoundingBoxAscent;
        const bottom = y + metrics.actualBoundingBoxDescent;
        const yDecoration = opts.strikethrough ? (top + bottom) / 2 : bottom;
        ctx.strokeStyle = ctx.fillStyle;
        ctx.beginPath();
        ctx.lineWidth = opts.decorationWidth || 2;
        ctx.moveTo(left, yDecoration);
        ctx.lineTo(right, yDecoration);
        ctx.stroke();
    }
}
function drawBackdrop(ctx, opts) {
    const oldColor = ctx.fillStyle;
    ctx.fillStyle = opts.color;
    ctx.fillRect(opts.left, opts.top, opts.width, opts.height);
    ctx.fillStyle = oldColor;
}
/**
 * Render text onto the canvas
 */ function renderText(ctx, text, x, y, font, opts = {}) {
    const lines = isArray(text) ? text : [
        text
    ];
    const stroke = opts.strokeWidth > 0 && opts.strokeColor !== '';
    let i, line;
    ctx.save();
    ctx.font = font.string;
    setRenderOpts(ctx, opts);
    for(i = 0; i < lines.length; ++i){
        line = lines[i];
        if (opts.backdrop) drawBackdrop(ctx, opts.backdrop);
        if (stroke) {
            if (opts.strokeColor) ctx.strokeStyle = opts.strokeColor;
            if (!isNullOrUndef(opts.strokeWidth)) ctx.lineWidth = opts.strokeWidth;
            ctx.strokeText(line, x, y, opts.maxWidth);
        }
        ctx.fillText(line, x, y, opts.maxWidth);
        decorateText(ctx, x, y, line, opts);
        y += Number(font.lineHeight);
    }
    ctx.restore();
}
/**
 * Add a path of a rectangle with rounded corners to the current sub-path
 * @param ctx - Context
 * @param rect - Bounding rect
 */ function addRoundedRectPath(ctx, rect) {
    const { x, y, w, h, radius } = rect;
    // top left arc
    ctx.arc(x + radius.topLeft, y + radius.topLeft, radius.topLeft, 1.5 * PI, PI, true);
    // line from top left to bottom left
    ctx.lineTo(x, y + h - radius.bottomLeft);
    // bottom left arc
    ctx.arc(x + radius.bottomLeft, y + h - radius.bottomLeft, radius.bottomLeft, PI, HALF_PI, true);
    // line from bottom left to bottom right
    ctx.lineTo(x + w - radius.bottomRight, y + h);
    // bottom right arc
    ctx.arc(x + w - radius.bottomRight, y + h - radius.bottomRight, radius.bottomRight, HALF_PI, 0, true);
    // line from bottom right to top right
    ctx.lineTo(x + w, y + radius.topRight);
    // top right arc
    ctx.arc(x + w - radius.topRight, y + radius.topRight, radius.topRight, 0, -HALF_PI, true);
    // line from top right to top left
    ctx.lineTo(x + radius.topLeft, y);
}
const LINE_HEIGHT = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/;
const FONT_STYLE = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
/**
 * @alias Chart.helpers.options
 * @namespace
 */ /**
 * Converts the given line height `value` in pixels for a specific font `size`.
 * @param value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
 * @param size - The font size (in pixels) used to resolve relative `value`.
 * @returns The effective line height in pixels (size * 1.2 if value is invalid).
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
 * @since 2.7.0
 */ function toLineHeight(value, size) {
    const matches = ('' + value).match(LINE_HEIGHT);
    if (!matches || matches[1] === 'normal') return size * 1.2;
    value = +matches[2];
    switch(matches[3]){
        case 'px':
            return value;
        case '%':
            value /= 100;
            break;
    }
    return size * value;
}
const numberOrZero = (v)=>+v || 0;
function _readValueToProps(value, props) {
    const ret = {};
    const objProps = isObject(props);
    const keys = objProps ? Object.keys(props) : props;
    const read = isObject(value) ? objProps ? (prop)=>valueOrDefault(value[prop], value[props[prop]]) : (prop)=>value[prop] : ()=>value;
    for (const prop of keys)ret[prop] = numberOrZero(read(prop));
    return ret;
}
/**
 * Converts the given value into a TRBL object.
 * @param value - If a number, set the value to all TRBL component,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 *  x / y are shorthands for same value for left/right and top/bottom.
 * @returns The padding values (top, right, bottom, left)
 * @since 3.0.0
 */ function toTRBL(value) {
    return _readValueToProps(value, {
        top: 'y',
        right: 'x',
        bottom: 'y',
        left: 'x'
    });
}
/**
 * Converts the given value into a TRBL corners object (similar with css border-radius).
 * @param value - If a number, set the value to all TRBL corner components,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 * @returns The TRBL corner values (topLeft, topRight, bottomLeft, bottomRight)
 * @since 3.0.0
 */ function toTRBLCorners(value) {
    return _readValueToProps(value, [
        'topLeft',
        'topRight',
        'bottomLeft',
        'bottomRight'
    ]);
}
/**
 * Converts the given value into a padding object with pre-computed width/height.
 * @param value - If a number, set the value to all TRBL component,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 *  x / y are shorthands for same value for left/right and top/bottom.
 * @returns The padding values (top, right, bottom, left, width, height)
 * @since 2.7.0
 */ function toPadding(value) {
    const obj = toTRBL(value);
    obj.width = obj.left + obj.right;
    obj.height = obj.top + obj.bottom;
    return obj;
}
/**
 * Parses font options and returns the font object.
 * @param options - A object that contains font options to be parsed.
 * @param fallback - A object that contains fallback font options.
 * @return The font object.
 * @private
 */ function toFont(options, fallback) {
    options = options || {};
    fallback = fallback || defaults.font;
    let size = valueOrDefault(options.size, fallback.size);
    if (typeof size === 'string') size = parseInt(size, 10);
    let style = valueOrDefault(options.style, fallback.style);
    if (style && !('' + style).match(FONT_STYLE)) {
        console.warn('Invalid font style specified: "' + style + '"');
        style = undefined;
    }
    const font = {
        family: valueOrDefault(options.family, fallback.family),
        lineHeight: toLineHeight(valueOrDefault(options.lineHeight, fallback.lineHeight), size),
        size,
        style,
        weight: valueOrDefault(options.weight, fallback.weight),
        string: ''
    };
    font.string = toFontString(font);
    return font;
}
/**
 * Evaluates the given `inputs` sequentially and returns the first defined value.
 * @param inputs - An array of values, falling back to the last value.
 * @param context - If defined and the current value is a function, the value
 * is called with `context` as first argument and the result becomes the new input.
 * @param index - If defined and the current value is an array, the value
 * at `index` become the new input.
 * @param info - object to return information about resolution in
 * @param info.cacheable - Will be set to `false` if option is not cacheable.
 * @since 2.7.0
 */ function resolve(inputs, context, index, info) {
    let cacheable = true;
    let i, ilen, value;
    for(i = 0, ilen = inputs.length; i < ilen; ++i){
        value = inputs[i];
        if (value === undefined) continue;
        if (context !== undefined && typeof value === 'function') {
            value = value(context);
            cacheable = false;
        }
        if (index !== undefined && isArray(value)) {
            value = value[index % value.length];
            cacheable = false;
        }
        if (value !== undefined) {
            if (info && !cacheable) info.cacheable = false;
            return value;
        }
    }
}
/**
 * @param minmax
 * @param grace
 * @param beginAtZero
 * @private
 */ function _addGrace(minmax, grace, beginAtZero) {
    const { min, max } = minmax;
    const change = toDimension(grace, (max - min) / 2);
    const keepZero = (value, add)=>beginAtZero && value === 0 ? 0 : value + add;
    return {
        min: keepZero(min, -Math.abs(change)),
        max: keepZero(max, change)
    };
}
function createContext(parentContext, context) {
    return Object.assign(Object.create(parentContext), context);
}
/**
 * Creates a Proxy for resolving raw values for options.
 * @param scopes - The option scopes to look for values, in resolution order
 * @param prefixes - The prefixes for values, in resolution order.
 * @param rootScopes - The root option scopes
 * @param fallback - Parent scopes fallback
 * @param getTarget - callback for getting the target for changed values
 * @returns Proxy
 * @private
 */ function _createResolver(scopes, prefixes = [
    ''
], rootScopes, fallback, getTarget = ()=>scopes[0]) {
    const finalRootScopes = rootScopes || scopes;
    if (typeof fallback === 'undefined') fallback = _resolve('_fallback', scopes);
    const cache = {
        [Symbol.toStringTag]: 'Object',
        _cacheable: true,
        _scopes: scopes,
        _rootScopes: finalRootScopes,
        _fallback: fallback,
        _getTarget: getTarget,
        override: (scope)=>_createResolver([
                scope,
                ...scopes
            ], prefixes, finalRootScopes, fallback)
    };
    return new Proxy(cache, {
        /**
     * A trap for the delete operator.
     */ deleteProperty (target, prop) {
            delete target[prop]; // remove from cache
            delete target._keys; // remove cached keys
            delete scopes[0][prop]; // remove from top level scope
            return true;
        },
        /**
     * A trap for getting property values.
     */ get (target, prop) {
            return _cached(target, prop, ()=>_resolveWithPrefixes(prop, prefixes, scopes, target));
        },
        /**
     * A trap for Object.getOwnPropertyDescriptor.
     * Also used by Object.hasOwnProperty.
     */ getOwnPropertyDescriptor (target, prop) {
            return Reflect.getOwnPropertyDescriptor(target._scopes[0], prop);
        },
        /**
     * A trap for Object.getPrototypeOf.
     */ getPrototypeOf () {
            return Reflect.getPrototypeOf(scopes[0]);
        },
        /**
     * A trap for the in operator.
     */ has (target, prop) {
            return getKeysFromAllScopes(target).includes(prop);
        },
        /**
     * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
     */ ownKeys (target) {
            return getKeysFromAllScopes(target);
        },
        /**
     * A trap for setting property values.
     */ set (target, prop, value) {
            const storage = target._storage || (target._storage = getTarget());
            target[prop] = storage[prop] = value; // set to top level scope + cache
            delete target._keys; // remove cached keys
            return true;
        }
    });
}
/**
 * Returns an Proxy for resolving option values with context.
 * @param proxy - The Proxy returned by `_createResolver`
 * @param context - Context object for scriptable/indexable options
 * @param subProxy - The proxy provided for scriptable options
 * @param descriptorDefaults - Defaults for descriptors
 * @private
 */ function _attachContext(proxy, context, subProxy, descriptorDefaults) {
    const cache = {
        _cacheable: false,
        _proxy: proxy,
        _context: context,
        _subProxy: subProxy,
        _stack: new Set(),
        _descriptors: _descriptors(proxy, descriptorDefaults),
        setContext: (ctx)=>_attachContext(proxy, ctx, subProxy, descriptorDefaults),
        override: (scope)=>_attachContext(proxy.override(scope), context, subProxy, descriptorDefaults)
    };
    return new Proxy(cache, {
        /**
     * A trap for the delete operator.
     */ deleteProperty (target, prop) {
            delete target[prop]; // remove from cache
            delete proxy[prop]; // remove from proxy
            return true;
        },
        /**
     * A trap for getting property values.
     */ get (target, prop, receiver) {
            return _cached(target, prop, ()=>_resolveWithContext(target, prop, receiver));
        },
        /**
     * A trap for Object.getOwnPropertyDescriptor.
     * Also used by Object.hasOwnProperty.
     */ getOwnPropertyDescriptor (target, prop) {
            return target._descriptors.allKeys ? Reflect.has(proxy, prop) ? {
                enumerable: true,
                configurable: true
            } : undefined : Reflect.getOwnPropertyDescriptor(proxy, prop);
        },
        /**
     * A trap for Object.getPrototypeOf.
     */ getPrototypeOf () {
            return Reflect.getPrototypeOf(proxy);
        },
        /**
     * A trap for the in operator.
     */ has (target, prop) {
            return Reflect.has(proxy, prop);
        },
        /**
     * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
     */ ownKeys () {
            return Reflect.ownKeys(proxy);
        },
        /**
     * A trap for setting property values.
     */ set (target, prop, value) {
            proxy[prop] = value; // set to proxy
            delete target[prop]; // remove from cache
            return true;
        }
    });
}
/**
 * @private
 */ function _descriptors(proxy, defaults = {
    scriptable: true,
    indexable: true
}) {
    const { _scriptable = defaults.scriptable, _indexable = defaults.indexable, _allKeys = defaults.allKeys } = proxy;
    return {
        allKeys: _allKeys,
        scriptable: _scriptable,
        indexable: _indexable,
        isScriptable: isFunction(_scriptable) ? _scriptable : ()=>_scriptable,
        isIndexable: isFunction(_indexable) ? _indexable : ()=>_indexable
    };
}
const readKey = (prefix, name)=>prefix ? prefix + _capitalize(name) : name;
const needsSubResolver = (prop, value)=>isObject(value) && prop !== 'adapters' && (Object.getPrototypeOf(value) === null || value.constructor === Object);
function _cached(target, prop, resolve) {
    if (Object.prototype.hasOwnProperty.call(target, prop) || prop === 'constructor') return target[prop];
    const value = resolve();
    // cache the resolved value
    target[prop] = value;
    return value;
}
function _resolveWithContext(target, prop, receiver) {
    const { _proxy, _context, _subProxy, _descriptors: descriptors } = target;
    let value = _proxy[prop]; // resolve from proxy
    // resolve with context
    if (isFunction(value) && descriptors.isScriptable(prop)) value = _resolveScriptable(prop, value, target, receiver);
    if (isArray(value) && value.length) value = _resolveArray(prop, value, target, descriptors.isIndexable);
    if (needsSubResolver(prop, value)) // if the resolved value is an object, create a sub resolver for it
    value = _attachContext(value, _context, _subProxy && _subProxy[prop], descriptors);
    return value;
}
function _resolveScriptable(prop, getValue, target, receiver) {
    const { _proxy, _context, _subProxy, _stack } = target;
    if (_stack.has(prop)) throw new Error('Recursion detected: ' + Array.from(_stack).join('->') + '->' + prop);
    _stack.add(prop);
    let value = getValue(_context, _subProxy || receiver);
    _stack.delete(prop);
    if (needsSubResolver(prop, value)) // When scriptable option returns an object, create a resolver on that.
    value = createSubResolver(_proxy._scopes, _proxy, prop, value);
    return value;
}
function _resolveArray(prop, value, target, isIndexable) {
    const { _proxy, _context, _subProxy, _descriptors: descriptors } = target;
    if (typeof _context.index !== 'undefined' && isIndexable(prop)) return value[_context.index % value.length];
    else if (isObject(value[0])) {
        // Array of objects, return array or resolvers
        const arr = value;
        const scopes = _proxy._scopes.filter((s)=>s !== arr);
        value = [];
        for (const item of arr){
            const resolver = createSubResolver(scopes, _proxy, prop, item);
            value.push(_attachContext(resolver, _context, _subProxy && _subProxy[prop], descriptors));
        }
    }
    return value;
}
function resolveFallback(fallback, prop, value) {
    return isFunction(fallback) ? fallback(prop, value) : fallback;
}
const getScope = (key, parent)=>key === true ? parent : typeof key === 'string' ? resolveObjectKey(parent, key) : undefined;
function addScopes(set, parentScopes, key, parentFallback, value) {
    for (const parent of parentScopes){
        const scope = getScope(key, parent);
        if (scope) {
            set.add(scope);
            const fallback = resolveFallback(scope._fallback, key, value);
            if (typeof fallback !== 'undefined' && fallback !== key && fallback !== parentFallback) // When we reach the descriptor that defines a new _fallback, return that.
            // The fallback will resume to that new scope.
            return fallback;
        } else if (scope === false && typeof parentFallback !== 'undefined' && key !== parentFallback) // Fallback to `false` results to `false`, when falling back to different key.
        // For example `interaction` from `hover` or `plugins.tooltip` and `animation` from `animations`
        return null;
    }
    return false;
}
function createSubResolver(parentScopes, resolver, prop, value) {
    const rootScopes = resolver._rootScopes;
    const fallback = resolveFallback(resolver._fallback, prop, value);
    const allScopes = [
        ...parentScopes,
        ...rootScopes
    ];
    const set = new Set();
    set.add(value);
    let key = addScopesFromKey(set, allScopes, prop, fallback || prop, value);
    if (key === null) return false;
    if (typeof fallback !== 'undefined' && fallback !== prop) {
        key = addScopesFromKey(set, allScopes, fallback, key, value);
        if (key === null) return false;
    }
    return _createResolver(Array.from(set), [
        ''
    ], rootScopes, fallback, ()=>subGetTarget(resolver, prop, value));
}
function addScopesFromKey(set, allScopes, key, fallback, item) {
    while(key)key = addScopes(set, allScopes, key, fallback, item);
    return key;
}
function subGetTarget(resolver, prop, value) {
    const parent = resolver._getTarget();
    if (!(prop in parent)) parent[prop] = {};
    const target = parent[prop];
    if (isArray(target) && isObject(value)) // For array of objects, the object is used to store updated values
    return value;
    return target || {};
}
function _resolveWithPrefixes(prop, prefixes, scopes, proxy) {
    let value;
    for (const prefix of prefixes){
        value = _resolve(readKey(prefix, prop), scopes);
        if (typeof value !== 'undefined') return needsSubResolver(prop, value) ? createSubResolver(scopes, proxy, prop, value) : value;
    }
}
function _resolve(key, scopes) {
    for (const scope of scopes){
        if (!scope) continue;
        const value = scope[key];
        if (typeof value !== 'undefined') return value;
    }
}
function getKeysFromAllScopes(target) {
    let keys = target._keys;
    if (!keys) keys = target._keys = resolveKeysFromAllScopes(target._scopes);
    return keys;
}
function resolveKeysFromAllScopes(scopes) {
    const set = new Set();
    for (const scope of scopes)for (const key of Object.keys(scope).filter((k)=>!k.startsWith('_')))set.add(key);
    return Array.from(set);
}
function _parseObjectDataRadialScale(meta, data, start, count) {
    const { iScale } = meta;
    const { key = 'r' } = this._parsing;
    const parsed = new Array(count);
    let i, ilen, index, item;
    for(i = 0, ilen = count; i < ilen; ++i){
        index = i + start;
        item = data[index];
        parsed[i] = {
            r: iScale.parse(resolveObjectKey(item, key), index)
        };
    }
    return parsed;
}
const EPSILON = Number.EPSILON || 1e-14;
const getPoint = (points, i)=>i < points.length && !points[i].skip && points[i];
const getValueAxis = (indexAxis)=>indexAxis === 'x' ? 'y' : 'x';
function splineCurve(firstPoint, middlePoint, afterPoint, t) {
    // Props to Rob Spencer at scaled innovation for his post on splining between points
    // http://scaledinnovation.com/analytics/splines/aboutSplines.html
    // This function must also respect "skipped" points
    const previous = firstPoint.skip ? middlePoint : firstPoint;
    const current = middlePoint;
    const next = afterPoint.skip ? middlePoint : afterPoint;
    const d01 = distanceBetweenPoints(current, previous);
    const d12 = distanceBetweenPoints(next, current);
    let s01 = d01 / (d01 + d12);
    let s12 = d12 / (d01 + d12);
    // If all points are the same, s01 & s02 will be inf
    s01 = isNaN(s01) ? 0 : s01;
    s12 = isNaN(s12) ? 0 : s12;
    const fa = t * s01; // scaling factor for triangle Ta
    const fb = t * s12;
    return {
        previous: {
            x: current.x - fa * (next.x - previous.x),
            y: current.y - fa * (next.y - previous.y)
        },
        next: {
            x: current.x + fb * (next.x - previous.x),
            y: current.y + fb * (next.y - previous.y)
        }
    };
}
/**
 * Adjust tangents to ensure monotonic properties
 */ function monotoneAdjust(points, deltaK, mK) {
    const pointsLen = points.length;
    let alphaK, betaK, tauK, squaredMagnitude, pointCurrent;
    let pointAfter = getPoint(points, 0);
    for(let i = 0; i < pointsLen - 1; ++i){
        pointCurrent = pointAfter;
        pointAfter = getPoint(points, i + 1);
        if (!pointCurrent || !pointAfter) continue;
        if (almostEquals(deltaK[i], 0, EPSILON)) {
            mK[i] = mK[i + 1] = 0;
            continue;
        }
        alphaK = mK[i] / deltaK[i];
        betaK = mK[i + 1] / deltaK[i];
        squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
        if (squaredMagnitude <= 9) continue;
        tauK = 3 / Math.sqrt(squaredMagnitude);
        mK[i] = alphaK * tauK * deltaK[i];
        mK[i + 1] = betaK * tauK * deltaK[i];
    }
}
function monotoneCompute(points, mK, indexAxis = 'x') {
    const valueAxis = getValueAxis(indexAxis);
    const pointsLen = points.length;
    let delta, pointBefore, pointCurrent;
    let pointAfter = getPoint(points, 0);
    for(let i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = getPoint(points, i + 1);
        if (!pointCurrent) continue;
        const iPixel = pointCurrent[indexAxis];
        const vPixel = pointCurrent[valueAxis];
        if (pointBefore) {
            delta = (iPixel - pointBefore[indexAxis]) / 3;
            pointCurrent[`cp1${indexAxis}`] = iPixel - delta;
            pointCurrent[`cp1${valueAxis}`] = vPixel - delta * mK[i];
        }
        if (pointAfter) {
            delta = (pointAfter[indexAxis] - iPixel) / 3;
            pointCurrent[`cp2${indexAxis}`] = iPixel + delta;
            pointCurrent[`cp2${valueAxis}`] = vPixel + delta * mK[i];
        }
    }
}
/**
 * This function calculates Bézier control points in a similar way than |splineCurve|,
 * but preserves monotonicity of the provided data and ensures no local extremums are added
 * between the dataset discrete points due to the interpolation.
 * See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation
 */ function splineCurveMonotone(points, indexAxis = 'x') {
    const valueAxis = getValueAxis(indexAxis);
    const pointsLen = points.length;
    const deltaK = Array(pointsLen).fill(0);
    const mK = Array(pointsLen);
    // Calculate slopes (deltaK) and initialize tangents (mK)
    let i, pointBefore, pointCurrent;
    let pointAfter = getPoint(points, 0);
    for(i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = getPoint(points, i + 1);
        if (!pointCurrent) continue;
        if (pointAfter) {
            const slopeDelta = pointAfter[indexAxis] - pointCurrent[indexAxis];
            // In the case of two points that appear at the same x pixel, slopeDeltaX is 0
            deltaK[i] = slopeDelta !== 0 ? (pointAfter[valueAxis] - pointCurrent[valueAxis]) / slopeDelta : 0;
        }
        mK[i] = !pointBefore ? deltaK[i] : !pointAfter ? deltaK[i - 1] : sign(deltaK[i - 1]) !== sign(deltaK[i]) ? 0 : (deltaK[i - 1] + deltaK[i]) / 2;
    }
    monotoneAdjust(points, deltaK, mK);
    monotoneCompute(points, mK, indexAxis);
}
function capControlPoint(pt, min, max) {
    return Math.max(Math.min(pt, max), min);
}
function capBezierPoints(points, area) {
    let i, ilen, point, inArea, inAreaPrev;
    let inAreaNext = _isPointInArea(points[0], area);
    for(i = 0, ilen = points.length; i < ilen; ++i){
        inAreaPrev = inArea;
        inArea = inAreaNext;
        inAreaNext = i < ilen - 1 && _isPointInArea(points[i + 1], area);
        if (!inArea) continue;
        point = points[i];
        if (inAreaPrev) {
            point.cp1x = capControlPoint(point.cp1x, area.left, area.right);
            point.cp1y = capControlPoint(point.cp1y, area.top, area.bottom);
        }
        if (inAreaNext) {
            point.cp2x = capControlPoint(point.cp2x, area.left, area.right);
            point.cp2y = capControlPoint(point.cp2y, area.top, area.bottom);
        }
    }
}
/**
 * @private
 */ function _updateBezierControlPoints(points, options, area, loop, indexAxis) {
    let i, ilen, point, controlPoints;
    // Only consider points that are drawn in case the spanGaps option is used
    if (options.spanGaps) points = points.filter((pt)=>!pt.skip);
    if (options.cubicInterpolationMode === 'monotone') splineCurveMonotone(points, indexAxis);
    else {
        let prev = loop ? points[points.length - 1] : points[0];
        for(i = 0, ilen = points.length; i < ilen; ++i){
            point = points[i];
            controlPoints = splineCurve(prev, point, points[Math.min(i + 1, ilen - (loop ? 0 : 1)) % ilen], options.tension);
            point.cp1x = controlPoints.previous.x;
            point.cp1y = controlPoints.previous.y;
            point.cp2x = controlPoints.next.x;
            point.cp2y = controlPoints.next.y;
            prev = point;
        }
    }
    if (options.capBezierPoints) capBezierPoints(points, area);
}
/**
 * @private
 */ function _isDomSupported() {
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}
/**
 * @private
 */ function _getParentNode(domNode) {
    let parent = domNode.parentNode;
    if (parent && parent.toString() === '[object ShadowRoot]') parent = parent.host;
    return parent;
}
/**
 * convert max-width/max-height values that may be percentages into a number
 * @private
 */ function parseMaxStyle(styleValue, node, parentProperty) {
    let valueInPixels;
    if (typeof styleValue === 'string') {
        valueInPixels = parseInt(styleValue, 10);
        if (styleValue.indexOf('%') !== -1) // percentage * size in dimension
        valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
    } else valueInPixels = styleValue;
    return valueInPixels;
}
const getComputedStyle = (element)=>element.ownerDocument.defaultView.getComputedStyle(element, null);
function getStyle(el, property) {
    return getComputedStyle(el).getPropertyValue(property);
}
const positions = [
    'top',
    'right',
    'bottom',
    'left'
];
function getPositionedStyle(styles, style, suffix) {
    const result = {};
    suffix = suffix ? '-' + suffix : '';
    for(let i = 0; i < 4; i++){
        const pos = positions[i];
        result[pos] = parseFloat(styles[style + '-' + pos + suffix]) || 0;
    }
    result.width = result.left + result.right;
    result.height = result.top + result.bottom;
    return result;
}
const useOffsetPos = (x, y, target)=>(x > 0 || y > 0) && (!target || !target.shadowRoot);
/**
 * @param e
 * @param canvas
 * @returns Canvas position
 */ function getCanvasPosition(e, canvas) {
    const touches = e.touches;
    const source = touches && touches.length ? touches[0] : e;
    const { offsetX, offsetY } = source;
    let box = false;
    let x, y;
    if (useOffsetPos(offsetX, offsetY, e.target)) {
        x = offsetX;
        y = offsetY;
    } else {
        const rect = canvas.getBoundingClientRect();
        x = source.clientX - rect.left;
        y = source.clientY - rect.top;
        box = true;
    }
    return {
        x,
        y,
        box
    };
}
/**
 * Gets an event's x, y coordinates, relative to the chart area
 * @param event
 * @param chart
 * @returns x and y coordinates of the event
 */ function getRelativePosition(event, chart) {
    if ('native' in event) return event;
    const { canvas, currentDevicePixelRatio } = chart;
    const style = getComputedStyle(canvas);
    const borderBox = style.boxSizing === 'border-box';
    const paddings = getPositionedStyle(style, 'padding');
    const borders = getPositionedStyle(style, 'border', 'width');
    const { x, y, box } = getCanvasPosition(event, canvas);
    const xOffset = paddings.left + (box && borders.left);
    const yOffset = paddings.top + (box && borders.top);
    let { width, height } = chart;
    if (borderBox) {
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    return {
        x: Math.round((x - xOffset) / width * canvas.width / currentDevicePixelRatio),
        y: Math.round((y - yOffset) / height * canvas.height / currentDevicePixelRatio)
    };
}
function getContainerSize(canvas, width, height) {
    let maxWidth, maxHeight;
    if (width === undefined || height === undefined) {
        const container = canvas && _getParentNode(canvas);
        if (!container) {
            width = canvas.clientWidth;
            height = canvas.clientHeight;
        } else {
            const rect = container.getBoundingClientRect(); // this is the border box of the container
            const containerStyle = getComputedStyle(container);
            const containerBorder = getPositionedStyle(containerStyle, 'border', 'width');
            const containerPadding = getPositionedStyle(containerStyle, 'padding');
            width = rect.width - containerPadding.width - containerBorder.width;
            height = rect.height - containerPadding.height - containerBorder.height;
            maxWidth = parseMaxStyle(containerStyle.maxWidth, container, 'clientWidth');
            maxHeight = parseMaxStyle(containerStyle.maxHeight, container, 'clientHeight');
        }
    }
    return {
        width,
        height,
        maxWidth: maxWidth || INFINITY,
        maxHeight: maxHeight || INFINITY
    };
}
const round1 = (v)=>Math.round(v * 10) / 10;
// eslint-disable-next-line complexity
function getMaximumSize(canvas, bbWidth, bbHeight, aspectRatio) {
    const style = getComputedStyle(canvas);
    const margins = getPositionedStyle(style, 'margin');
    const maxWidth = parseMaxStyle(style.maxWidth, canvas, 'clientWidth') || INFINITY;
    const maxHeight = parseMaxStyle(style.maxHeight, canvas, 'clientHeight') || INFINITY;
    const containerSize = getContainerSize(canvas, bbWidth, bbHeight);
    let { width, height } = containerSize;
    if (style.boxSizing === 'content-box') {
        const borders = getPositionedStyle(style, 'border', 'width');
        const paddings = getPositionedStyle(style, 'padding');
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    width = Math.max(0, width - margins.width);
    height = Math.max(0, aspectRatio ? width / aspectRatio : height - margins.height);
    width = round1(Math.min(width, maxWidth, containerSize.maxWidth));
    height = round1(Math.min(height, maxHeight, containerSize.maxHeight));
    if (width && !height) // https://github.com/chartjs/Chart.js/issues/4659
    // If the canvas has width, but no height, default to aspectRatio of 2 (canvas default)
    height = round1(width / 2);
    const maintainHeight = bbWidth !== undefined || bbHeight !== undefined;
    if (maintainHeight && aspectRatio && containerSize.height && height > containerSize.height) {
        height = containerSize.height;
        width = round1(Math.floor(height * aspectRatio));
    }
    return {
        width,
        height
    };
}
/**
 * @param chart
 * @param forceRatio
 * @param forceStyle
 * @returns True if the canvas context size or transformation has changed.
 */ function retinaScale(chart, forceRatio, forceStyle) {
    const pixelRatio = forceRatio || 1;
    const deviceHeight = Math.floor(chart.height * pixelRatio);
    const deviceWidth = Math.floor(chart.width * pixelRatio);
    chart.height = Math.floor(chart.height);
    chart.width = Math.floor(chart.width);
    const canvas = chart.canvas;
    // If no style has been set on the canvas, the render size is used as display size,
    // making the chart visually bigger, so let's enforce it to the "correct" values.
    // See https://github.com/chartjs/Chart.js/issues/3575
    if (canvas.style && (forceStyle || !canvas.style.height && !canvas.style.width)) {
        canvas.style.height = `${chart.height}px`;
        canvas.style.width = `${chart.width}px`;
    }
    if (chart.currentDevicePixelRatio !== pixelRatio || canvas.height !== deviceHeight || canvas.width !== deviceWidth) {
        chart.currentDevicePixelRatio = pixelRatio;
        canvas.height = deviceHeight;
        canvas.width = deviceWidth;
        chart.ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        return true;
    }
    return false;
}
/**
 * Detects support for options object argument in addEventListener.
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
 * @private
 */ const supportsEventListenerOptions = function() {
    let passiveSupported = false;
    try {
        const options = {
            get passive () {
                passiveSupported = true;
                return false;
            }
        };
        if (_isDomSupported()) {
            window.addEventListener('test', null, options);
            window.removeEventListener('test', null, options);
        }
    } catch (e) {
    // continue regardless of error
    }
    return passiveSupported;
}();
/**
 * The "used" size is the final value of a dimension property after all calculations have
 * been performed. This method uses the computed style of `element` but returns undefined
 * if the computed style is not expressed in pixels. That can happen in some cases where
 * `element` has a size relative to its parent and this last one is not yet displayed,
 * for example because of `display: none` on a parent node.
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
 * @returns Size in pixels or undefined if unknown.
 */ function readUsedSize(element, property) {
    const value = getStyle(element, property);
    const matches = value && value.match(/^(\d+)(\.\d+)?px$/);
    return matches ? +matches[1] : undefined;
}
/**
 * @private
 */ function _pointInLine(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: p1.y + t * (p2.y - p1.y)
    };
}
/**
 * @private
 */ function _steppedInterpolation(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: mode === 'middle' ? t < 0.5 ? p1.y : p2.y : mode === 'after' ? t < 1 ? p1.y : p2.y : t > 0 ? p2.y : p1.y
    };
}
/**
 * @private
 */ function _bezierInterpolation(p1, p2, t, mode) {
    const cp1 = {
        x: p1.cp2x,
        y: p1.cp2y
    };
    const cp2 = {
        x: p2.cp1x,
        y: p2.cp1y
    };
    const a = _pointInLine(p1, cp1, t);
    const b = _pointInLine(cp1, cp2, t);
    const c = _pointInLine(cp2, p2, t);
    const d = _pointInLine(a, b, t);
    const e = _pointInLine(b, c, t);
    return _pointInLine(d, e, t);
}
const getRightToLeftAdapter = function(rectX, width) {
    return {
        x (x) {
            return rectX + rectX + width - x;
        },
        setWidth (w) {
            width = w;
        },
        textAlign (align) {
            if (align === 'center') return align;
            return align === 'right' ? 'left' : 'right';
        },
        xPlus (x, value) {
            return x - value;
        },
        leftForLtr (x, itemWidth) {
            return x - itemWidth;
        }
    };
};
const getLeftToRightAdapter = function() {
    return {
        x (x) {
            return x;
        },
        setWidth (w) {},
        textAlign (align) {
            return align;
        },
        xPlus (x, value) {
            return x + value;
        },
        leftForLtr (x, _itemWidth) {
            return x;
        }
    };
};
function getRtlAdapter(rtl, rectX, width) {
    return rtl ? getRightToLeftAdapter(rectX, width) : getLeftToRightAdapter();
}
function overrideTextDirection(ctx, direction) {
    let style, original;
    if (direction === 'ltr' || direction === 'rtl') {
        style = ctx.canvas.style;
        original = [
            style.getPropertyValue('direction'),
            style.getPropertyPriority('direction')
        ];
        style.setProperty('direction', direction, 'important');
        ctx.prevTextDirection = original;
    }
}
function restoreTextDirection(ctx, original) {
    if (original !== undefined) {
        delete ctx.prevTextDirection;
        ctx.canvas.style.setProperty('direction', original[0], original[1]);
    }
}
function propertyFn(property) {
    if (property === 'angle') return {
        between: _angleBetween,
        compare: _angleDiff,
        normalize: _normalizeAngle
    };
    return {
        between: _isBetween,
        compare: (a, b)=>a - b,
        normalize: (x)=>x
    };
}
function normalizeSegment({ start, end, count, loop, style }) {
    return {
        start: start % count,
        end: end % count,
        loop: loop && (end - start + 1) % count === 0,
        style
    };
}
function getSegment(segment, points, bounds) {
    const { property, start: startBound, end: endBound } = bounds;
    const { between, normalize } = propertyFn(property);
    const count = points.length;
    let { start, end, loop } = segment;
    let i, ilen;
    if (loop) {
        start += count;
        end += count;
        for(i = 0, ilen = count; i < ilen; ++i){
            if (!between(normalize(points[start % count][property]), startBound, endBound)) break;
            start--;
            end--;
        }
        start %= count;
        end %= count;
    }
    if (end < start) end += count;
    return {
        start,
        end,
        loop,
        style: segment.style
    };
}
function _boundSegment(segment, points, bounds) {
    if (!bounds) return [
        segment
    ];
    const { property, start: startBound, end: endBound } = bounds;
    const count = points.length;
    const { compare, between, normalize } = propertyFn(property);
    const { start, end, loop, style } = getSegment(segment, points, bounds);
    const result = [];
    let inside = false;
    let subStart = null;
    let value, point, prevValue;
    const startIsBefore = ()=>between(startBound, prevValue, value) && compare(startBound, prevValue) !== 0;
    const endIsBefore = ()=>compare(endBound, value) === 0 || between(endBound, prevValue, value);
    const shouldStart = ()=>inside || startIsBefore();
    const shouldStop = ()=>!inside || endIsBefore();
    for(let i = start, prev = start; i <= end; ++i){
        point = points[i % count];
        if (point.skip) continue;
        value = normalize(point[property]);
        if (value === prevValue) continue;
        inside = between(value, startBound, endBound);
        if (subStart === null && shouldStart()) subStart = compare(value, startBound) === 0 ? i : prev;
        if (subStart !== null && shouldStop()) {
            result.push(normalizeSegment({
                start: subStart,
                end: i,
                loop,
                count,
                style
            }));
            subStart = null;
        }
        prev = i;
        prevValue = value;
    }
    if (subStart !== null) result.push(normalizeSegment({
        start: subStart,
        end,
        loop,
        count,
        style
    }));
    return result;
}
function _boundSegments(line, bounds) {
    const result = [];
    const segments = line.segments;
    for(let i = 0; i < segments.length; i++){
        const sub = _boundSegment(segments[i], line.points, bounds);
        if (sub.length) result.push(...sub);
    }
    return result;
}
function findStartAndEnd(points, count, loop, spanGaps) {
    let start = 0;
    let end = count - 1;
    if (loop && !spanGaps) while(start < count && !points[start].skip)start++;
    while(start < count && points[start].skip)start++;
    start %= count;
    if (loop) end += start;
    while(end > start && points[end % count].skip)end--;
    end %= count;
    return {
        start,
        end
    };
}
function solidSegments(points, start, max, loop) {
    const count = points.length;
    const result = [];
    let last = start;
    let prev = points[start];
    let end;
    for(end = start + 1; end <= max; ++end){
        const cur = points[end % count];
        if (cur.skip || cur.stop) {
            if (!prev.skip) {
                loop = false;
                result.push({
                    start: start % count,
                    end: (end - 1) % count,
                    loop
                });
                start = last = cur.stop ? end : null;
            }
        } else {
            last = end;
            if (prev.skip) start = end;
        }
        prev = cur;
    }
    if (last !== null) result.push({
        start: start % count,
        end: last % count,
        loop
    });
    return result;
}
function _computeSegments(line, segmentOptions) {
    const points = line.points;
    const spanGaps = line.options.spanGaps;
    const count = points.length;
    if (!count) return [];
    const loop = !!line._loop;
    const { start, end } = findStartAndEnd(points, count, loop, spanGaps);
    if (spanGaps === true) return splitByStyles(line, [
        {
            start,
            end,
            loop
        }
    ], points, segmentOptions);
    const max = end < start ? end + count : end;
    const completeLoop = !!line._fullLoop && start === 0 && end === count - 1;
    return splitByStyles(line, solidSegments(points, start, max, completeLoop), points, segmentOptions);
}
function splitByStyles(line, segments, points, segmentOptions) {
    if (!segmentOptions || !segmentOptions.setContext || !points) return segments;
    return doSplitByStyles(line, segments, points, segmentOptions);
}
function doSplitByStyles(line, segments, points, segmentOptions) {
    const chartContext = line._chart.getContext();
    const baseStyle = readStyle(line.options);
    const { _datasetIndex: datasetIndex, options: { spanGaps } } = line;
    const count = points.length;
    const result = [];
    let prevStyle = baseStyle;
    let start = segments[0].start;
    let i = start;
    function addStyle(s, e, l, st) {
        const dir = spanGaps ? -1 : 1;
        if (s === e) return;
        s += count;
        while(points[s % count].skip)s -= dir;
        while(points[e % count].skip)e += dir;
        if (s % count !== e % count) {
            result.push({
                start: s % count,
                end: e % count,
                loop: l,
                style: st
            });
            prevStyle = st;
            start = e % count;
        }
    }
    for (const segment of segments){
        start = spanGaps ? start : segment.start;
        let prev = points[start % count];
        let style;
        for(i = start + 1; i <= segment.end; i++){
            const pt = points[i % count];
            style = readStyle(segmentOptions.setContext(createContext(chartContext, {
                type: 'segment',
                p0: prev,
                p1: pt,
                p0DataIndex: (i - 1) % count,
                p1DataIndex: i % count,
                datasetIndex
            })));
            if (styleChanged(style, prevStyle)) addStyle(start, i - 1, segment.loop, prevStyle);
            prev = pt;
            prevStyle = style;
        }
        if (start < i - 1) addStyle(start, i - 1, segment.loop, prevStyle);
    }
    return result;
}
function readStyle(options) {
    return {
        backgroundColor: options.backgroundColor,
        borderCapStyle: options.borderCapStyle,
        borderDash: options.borderDash,
        borderDashOffset: options.borderDashOffset,
        borderJoinStyle: options.borderJoinStyle,
        borderWidth: options.borderWidth,
        borderColor: options.borderColor
    };
}
function styleChanged(style, prevStyle) {
    if (!prevStyle) return false;
    const cache = [];
    const replacer = function(key, value) {
        if (!isPatternOrGradient(value)) return value;
        if (!cache.includes(value)) cache.push(value);
        return cache.indexOf(value);
    };
    return JSON.stringify(style, replacer) !== JSON.stringify(prevStyle, replacer);
}
function getSizeForArea(scale, chartArea, field) {
    return scale.options.clip ? scale[field] : chartArea[field];
}
function getDatasetArea(meta, chartArea) {
    const { xScale, yScale } = meta;
    if (xScale && yScale) return {
        left: getSizeForArea(xScale, chartArea, 'left'),
        right: getSizeForArea(xScale, chartArea, 'right'),
        top: getSizeForArea(yScale, chartArea, 'top'),
        bottom: getSizeForArea(yScale, chartArea, 'bottom')
    };
    return chartArea;
}
function getDatasetClipArea(chart, meta) {
    const clip = meta._clip;
    if (clip.disabled) return false;
    const area = getDatasetArea(meta, chart.chartArea);
    return {
        left: clip.left === false ? 0 : area.left - (clip.left === true ? 0 : clip.left),
        right: clip.right === false ? chart.width : area.right + (clip.right === true ? 0 : clip.right),
        top: clip.top === false ? 0 : area.top - (clip.top === true ? 0 : clip.top),
        bottom: clip.bottom === false ? chart.height : area.bottom + (clip.bottom === true ? 0 : clip.bottom)
    };
}

},{"@kurkle/color":"haii5","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"haii5":[function(require,module,exports,__globalThis) {
/*!
 * @kurkle/color v0.3.4
 * https://github.com/kurkle/color#readme
 * (c) 2024 Jukka Kurkela
 * Released under the MIT License
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Color", ()=>Color);
parcelHelpers.export(exports, "b2n", ()=>b2n);
parcelHelpers.export(exports, "b2p", ()=>b2p);
parcelHelpers.export(exports, "default", ()=>index_esm);
parcelHelpers.export(exports, "hexParse", ()=>hexParse);
parcelHelpers.export(exports, "hexString", ()=>hexString);
parcelHelpers.export(exports, "hsl2rgb", ()=>hsl2rgb);
parcelHelpers.export(exports, "hslString", ()=>hslString);
parcelHelpers.export(exports, "hsv2rgb", ()=>hsv2rgb);
parcelHelpers.export(exports, "hueParse", ()=>hueParse);
parcelHelpers.export(exports, "hwb2rgb", ()=>hwb2rgb);
parcelHelpers.export(exports, "lim", ()=>lim);
parcelHelpers.export(exports, "n2b", ()=>n2b);
parcelHelpers.export(exports, "n2p", ()=>n2p);
parcelHelpers.export(exports, "nameParse", ()=>nameParse);
parcelHelpers.export(exports, "p2b", ()=>p2b);
parcelHelpers.export(exports, "rgb2hsl", ()=>rgb2hsl);
parcelHelpers.export(exports, "rgbParse", ()=>rgbParse);
parcelHelpers.export(exports, "rgbString", ()=>rgbString);
parcelHelpers.export(exports, "rotate", ()=>rotate);
parcelHelpers.export(exports, "round", ()=>round);
function round(v) {
    return v + 0.5 | 0;
}
const lim = (v, l, h)=>Math.max(Math.min(v, h), l);
function p2b(v) {
    return lim(round(v * 2.55), 0, 255);
}
function b2p(v) {
    return lim(round(v / 2.55), 0, 100);
}
function n2b(v) {
    return lim(round(v * 255), 0, 255);
}
function b2n(v) {
    return lim(round(v / 2.55) / 100, 0, 1);
}
function n2p(v) {
    return lim(round(v * 100), 0, 100);
}
const map$1 = {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    A: 10,
    B: 11,
    C: 12,
    D: 13,
    E: 14,
    F: 15,
    a: 10,
    b: 11,
    c: 12,
    d: 13,
    e: 14,
    f: 15
};
const hex = [
    ...'0123456789ABCDEF'
];
const h1 = (b)=>hex[b & 0xF];
const h2 = (b)=>hex[(b & 0xF0) >> 4] + hex[b & 0xF];
const eq = (b)=>(b & 0xF0) >> 4 === (b & 0xF);
const isShort = (v)=>eq(v.r) && eq(v.g) && eq(v.b) && eq(v.a);
function hexParse(str) {
    var len = str.length;
    var ret;
    if (str[0] === '#') {
        if (len === 4 || len === 5) ret = {
            r: 255 & map$1[str[1]] * 17,
            g: 255 & map$1[str[2]] * 17,
            b: 255 & map$1[str[3]] * 17,
            a: len === 5 ? map$1[str[4]] * 17 : 255
        };
        else if (len === 7 || len === 9) ret = {
            r: map$1[str[1]] << 4 | map$1[str[2]],
            g: map$1[str[3]] << 4 | map$1[str[4]],
            b: map$1[str[5]] << 4 | map$1[str[6]],
            a: len === 9 ? map$1[str[7]] << 4 | map$1[str[8]] : 255
        };
    }
    return ret;
}
const alpha = (a, f)=>a < 255 ? f(a) : '';
function hexString(v) {
    var f = isShort(v) ? h1 : h2;
    return v ? '#' + f(v.r) + f(v.g) + f(v.b) + alpha(v.a, f) : undefined;
}
const HUE_RE = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function hsl2rgbn(h, s, l) {
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    return [
        f(0),
        f(8),
        f(4)
    ];
}
function hsv2rgbn(h, s, v) {
    const f = (n, k = (n + h / 60) % 6)=>v - v * s * Math.max(Math.min(k, 4 - k, 1), 0);
    return [
        f(5),
        f(3),
        f(1)
    ];
}
function hwb2rgbn(h, w, b) {
    const rgb = hsl2rgbn(h, 1, 0.5);
    let i;
    if (w + b > 1) {
        i = 1 / (w + b);
        w *= i;
        b *= i;
    }
    for(i = 0; i < 3; i++){
        rgb[i] *= 1 - w - b;
        rgb[i] += w;
    }
    return rgb;
}
function hueValue(r, g, b, d, max) {
    if (r === max) return (g - b) / d + (g < b ? 6 : 0);
    if (g === max) return (b - r) / d + 2;
    return (r - g) / d + 4;
}
function rgb2hsl(v) {
    const range = 255;
    const r = v.r / range;
    const g = v.g / range;
    const b = v.b / range;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const l = (max + min) / 2;
    let h, s, d;
    if (max !== min) {
        d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        h = hueValue(r, g, b, d, max);
        h = h * 60 + 0.5;
    }
    return [
        h | 0,
        s || 0,
        l
    ];
}
function calln(f, a, b, c) {
    return (Array.isArray(a) ? f(a[0], a[1], a[2]) : f(a, b, c)).map(n2b);
}
function hsl2rgb(h, s, l) {
    return calln(hsl2rgbn, h, s, l);
}
function hwb2rgb(h, w, b) {
    return calln(hwb2rgbn, h, w, b);
}
function hsv2rgb(h, s, v) {
    return calln(hsv2rgbn, h, s, v);
}
function hue(h) {
    return (h % 360 + 360) % 360;
}
function hueParse(str) {
    const m = HUE_RE.exec(str);
    let a = 255;
    let v;
    if (!m) return;
    if (m[5] !== v) a = m[6] ? p2b(+m[5]) : n2b(+m[5]);
    const h = hue(+m[2]);
    const p1 = +m[3] / 100;
    const p2 = +m[4] / 100;
    if (m[1] === 'hwb') v = hwb2rgb(h, p1, p2);
    else if (m[1] === 'hsv') v = hsv2rgb(h, p1, p2);
    else v = hsl2rgb(h, p1, p2);
    return {
        r: v[0],
        g: v[1],
        b: v[2],
        a: a
    };
}
function rotate(v, deg) {
    var h = rgb2hsl(v);
    h[0] = hue(h[0] + deg);
    h = hsl2rgb(h);
    v.r = h[0];
    v.g = h[1];
    v.b = h[2];
}
function hslString(v) {
    if (!v) return;
    const a = rgb2hsl(v);
    const h = a[0];
    const s = n2p(a[1]);
    const l = n2p(a[2]);
    return v.a < 255 ? `hsla(${h}, ${s}%, ${l}%, ${b2n(v.a)})` : `hsl(${h}, ${s}%, ${l}%)`;
}
const map = {
    x: 'dark',
    Z: 'light',
    Y: 're',
    X: 'blu',
    W: 'gr',
    V: 'medium',
    U: 'slate',
    A: 'ee',
    T: 'ol',
    S: 'or',
    B: 'ra',
    C: 'lateg',
    D: 'ights',
    R: 'in',
    Q: 'turquois',
    E: 'hi',
    P: 'ro',
    O: 'al',
    N: 'le',
    M: 'de',
    L: 'yello',
    F: 'en',
    K: 'ch',
    G: 'arks',
    H: 'ea',
    I: 'ightg',
    J: 'wh'
};
const names$1 = {
    OiceXe: 'f0f8ff',
    antiquewEte: 'faebd7',
    aqua: 'ffff',
    aquamarRe: '7fffd4',
    azuY: 'f0ffff',
    beige: 'f5f5dc',
    bisque: 'ffe4c4',
    black: '0',
    blanKedOmond: 'ffebcd',
    Xe: 'ff',
    XeviTet: '8a2be2',
    bPwn: 'a52a2a',
    burlywood: 'deb887',
    caMtXe: '5f9ea0',
    KartYuse: '7fff00',
    KocTate: 'd2691e',
    cSO: 'ff7f50',
    cSnflowerXe: '6495ed',
    cSnsilk: 'fff8dc',
    crimson: 'dc143c',
    cyan: 'ffff',
    xXe: '8b',
    xcyan: '8b8b',
    xgTMnPd: 'b8860b',
    xWay: 'a9a9a9',
    xgYF: '6400',
    xgYy: 'a9a9a9',
    xkhaki: 'bdb76b',
    xmagFta: '8b008b',
    xTivegYF: '556b2f',
    xSange: 'ff8c00',
    xScEd: '9932cc',
    xYd: '8b0000',
    xsOmon: 'e9967a',
    xsHgYF: '8fbc8f',
    xUXe: '483d8b',
    xUWay: '2f4f4f',
    xUgYy: '2f4f4f',
    xQe: 'ced1',
    xviTet: '9400d3',
    dAppRk: 'ff1493',
    dApskyXe: 'bfff',
    dimWay: '696969',
    dimgYy: '696969',
    dodgerXe: '1e90ff',
    fiYbrick: 'b22222',
    flSOwEte: 'fffaf0',
    foYstWAn: '228b22',
    fuKsia: 'ff00ff',
    gaRsbSo: 'dcdcdc',
    ghostwEte: 'f8f8ff',
    gTd: 'ffd700',
    gTMnPd: 'daa520',
    Way: '808080',
    gYF: '8000',
    gYFLw: 'adff2f',
    gYy: '808080',
    honeyMw: 'f0fff0',
    hotpRk: 'ff69b4',
    RdianYd: 'cd5c5c',
    Rdigo: '4b0082',
    ivSy: 'fffff0',
    khaki: 'f0e68c',
    lavFMr: 'e6e6fa',
    lavFMrXsh: 'fff0f5',
    lawngYF: '7cfc00',
    NmoncEffon: 'fffacd',
    ZXe: 'add8e6',
    ZcSO: 'f08080',
    Zcyan: 'e0ffff',
    ZgTMnPdLw: 'fafad2',
    ZWay: 'd3d3d3',
    ZgYF: '90ee90',
    ZgYy: 'd3d3d3',
    ZpRk: 'ffb6c1',
    ZsOmon: 'ffa07a',
    ZsHgYF: '20b2aa',
    ZskyXe: '87cefa',
    ZUWay: '778899',
    ZUgYy: '778899',
    ZstAlXe: 'b0c4de',
    ZLw: 'ffffe0',
    lime: 'ff00',
    limegYF: '32cd32',
    lRF: 'faf0e6',
    magFta: 'ff00ff',
    maPon: '800000',
    VaquamarRe: '66cdaa',
    VXe: 'cd',
    VScEd: 'ba55d3',
    VpurpN: '9370db',
    VsHgYF: '3cb371',
    VUXe: '7b68ee',
    VsprRggYF: 'fa9a',
    VQe: '48d1cc',
    VviTetYd: 'c71585',
    midnightXe: '191970',
    mRtcYam: 'f5fffa',
    mistyPse: 'ffe4e1',
    moccasR: 'ffe4b5',
    navajowEte: 'ffdead',
    navy: '80',
    Tdlace: 'fdf5e6',
    Tive: '808000',
    TivedBb: '6b8e23',
    Sange: 'ffa500',
    SangeYd: 'ff4500',
    ScEd: 'da70d6',
    pOegTMnPd: 'eee8aa',
    pOegYF: '98fb98',
    pOeQe: 'afeeee',
    pOeviTetYd: 'db7093',
    papayawEp: 'ffefd5',
    pHKpuff: 'ffdab9',
    peru: 'cd853f',
    pRk: 'ffc0cb',
    plum: 'dda0dd',
    powMrXe: 'b0e0e6',
    purpN: '800080',
    YbeccapurpN: '663399',
    Yd: 'ff0000',
    Psybrown: 'bc8f8f',
    PyOXe: '4169e1',
    saddNbPwn: '8b4513',
    sOmon: 'fa8072',
    sandybPwn: 'f4a460',
    sHgYF: '2e8b57',
    sHshell: 'fff5ee',
    siFna: 'a0522d',
    silver: 'c0c0c0',
    skyXe: '87ceeb',
    UXe: '6a5acd',
    UWay: '708090',
    UgYy: '708090',
    snow: 'fffafa',
    sprRggYF: 'ff7f',
    stAlXe: '4682b4',
    tan: 'd2b48c',
    teO: '8080',
    tEstN: 'd8bfd8',
    tomato: 'ff6347',
    Qe: '40e0d0',
    viTet: 'ee82ee',
    JHt: 'f5deb3',
    wEte: 'ffffff',
    wEtesmoke: 'f5f5f5',
    Lw: 'ffff00',
    LwgYF: '9acd32'
};
function unpack() {
    const unpacked = {};
    const keys = Object.keys(names$1);
    const tkeys = Object.keys(map);
    let i, j, k, ok, nk;
    for(i = 0; i < keys.length; i++){
        ok = nk = keys[i];
        for(j = 0; j < tkeys.length; j++){
            k = tkeys[j];
            nk = nk.replace(k, map[k]);
        }
        k = parseInt(names$1[ok], 16);
        unpacked[nk] = [
            k >> 16 & 0xFF,
            k >> 8 & 0xFF,
            k & 0xFF
        ];
    }
    return unpacked;
}
let names;
function nameParse(str) {
    if (!names) {
        names = unpack();
        names.transparent = [
            0,
            0,
            0,
            0
        ];
    }
    const a = names[str.toLowerCase()];
    return a && {
        r: a[0],
        g: a[1],
        b: a[2],
        a: a.length === 4 ? a[3] : 255
    };
}
const RGB_RE = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function rgbParse(str) {
    const m = RGB_RE.exec(str);
    let a = 255;
    let r, g, b;
    if (!m) return;
    if (m[7] !== r) {
        const v = +m[7];
        a = m[8] ? p2b(v) : lim(v * 255, 0, 255);
    }
    r = +m[1];
    g = +m[3];
    b = +m[5];
    r = 255 & (m[2] ? p2b(r) : lim(r, 0, 255));
    g = 255 & (m[4] ? p2b(g) : lim(g, 0, 255));
    b = 255 & (m[6] ? p2b(b) : lim(b, 0, 255));
    return {
        r: r,
        g: g,
        b: b,
        a: a
    };
}
function rgbString(v) {
    return v && (v.a < 255 ? `rgba(${v.r}, ${v.g}, ${v.b}, ${b2n(v.a)})` : `rgb(${v.r}, ${v.g}, ${v.b})`);
}
const to = (v)=>v <= 0.0031308 ? v * 12.92 : Math.pow(v, 1.0 / 2.4) * 1.055 - 0.055;
const from = (v)=>v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
function interpolate(rgb1, rgb2, t) {
    const r = from(b2n(rgb1.r));
    const g = from(b2n(rgb1.g));
    const b = from(b2n(rgb1.b));
    return {
        r: n2b(to(r + t * (from(b2n(rgb2.r)) - r))),
        g: n2b(to(g + t * (from(b2n(rgb2.g)) - g))),
        b: n2b(to(b + t * (from(b2n(rgb2.b)) - b))),
        a: rgb1.a + t * (rgb2.a - rgb1.a)
    };
}
function modHSL(v, i, ratio) {
    if (v) {
        let tmp = rgb2hsl(v);
        tmp[i] = Math.max(0, Math.min(tmp[i] + tmp[i] * ratio, i === 0 ? 360 : 1));
        tmp = hsl2rgb(tmp);
        v.r = tmp[0];
        v.g = tmp[1];
        v.b = tmp[2];
    }
}
function clone(v, proto) {
    return v ? Object.assign(proto || {}, v) : v;
}
function fromObject(input) {
    var v = {
        r: 0,
        g: 0,
        b: 0,
        a: 255
    };
    if (Array.isArray(input)) {
        if (input.length >= 3) {
            v = {
                r: input[0],
                g: input[1],
                b: input[2],
                a: 255
            };
            if (input.length > 3) v.a = n2b(input[3]);
        }
    } else {
        v = clone(input, {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        });
        v.a = n2b(v.a);
    }
    return v;
}
function functionParse(str) {
    if (str.charAt(0) === 'r') return rgbParse(str);
    return hueParse(str);
}
class Color {
    constructor(input){
        if (input instanceof Color) return input;
        const type = typeof input;
        let v;
        if (type === 'object') v = fromObject(input);
        else if (type === 'string') v = hexParse(input) || nameParse(input) || functionParse(input);
        this._rgb = v;
        this._valid = !!v;
    }
    get valid() {
        return this._valid;
    }
    get rgb() {
        var v = clone(this._rgb);
        if (v) v.a = b2n(v.a);
        return v;
    }
    set rgb(obj) {
        this._rgb = fromObject(obj);
    }
    rgbString() {
        return this._valid ? rgbString(this._rgb) : undefined;
    }
    hexString() {
        return this._valid ? hexString(this._rgb) : undefined;
    }
    hslString() {
        return this._valid ? hslString(this._rgb) : undefined;
    }
    mix(color, weight) {
        if (color) {
            const c1 = this.rgb;
            const c2 = color.rgb;
            let w2;
            const p = weight === w2 ? 0.5 : weight;
            const w = 2 * p - 1;
            const a = c1.a - c2.a;
            const w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
            w2 = 1 - w1;
            c1.r = 0xFF & w1 * c1.r + w2 * c2.r + 0.5;
            c1.g = 0xFF & w1 * c1.g + w2 * c2.g + 0.5;
            c1.b = 0xFF & w1 * c1.b + w2 * c2.b + 0.5;
            c1.a = p * c1.a + (1 - p) * c2.a;
            this.rgb = c1;
        }
        return this;
    }
    interpolate(color, t) {
        if (color) this._rgb = interpolate(this._rgb, color._rgb, t);
        return this;
    }
    clone() {
        return new Color(this.rgb);
    }
    alpha(a) {
        this._rgb.a = n2b(a);
        return this;
    }
    clearer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 - ratio;
        return this;
    }
    greyscale() {
        const rgb = this._rgb;
        const val = round(rgb.r * 0.3 + rgb.g * 0.59 + rgb.b * 0.11);
        rgb.r = rgb.g = rgb.b = val;
        return this;
    }
    opaquer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 + ratio;
        return this;
    }
    negate() {
        const v = this._rgb;
        v.r = 255 - v.r;
        v.g = 255 - v.g;
        v.b = 255 - v.b;
        return this;
    }
    lighten(ratio) {
        modHSL(this._rgb, 2, ratio);
        return this;
    }
    darken(ratio) {
        modHSL(this._rgb, 2, -ratio);
        return this;
    }
    saturate(ratio) {
        modHSL(this._rgb, 1, ratio);
        return this;
    }
    desaturate(ratio) {
        modHSL(this._rgb, 1, -ratio);
        return this;
    }
    rotate(deg) {
        rotate(this._rgb, deg);
        return this;
    }
}
function index_esm(input) {
    return new Color(input);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fM6o0":[function(require,module,exports,__globalThis) {
// THIS FILE IS AUTO GENERATED
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Fa500Px", ()=>Fa500Px);
parcelHelpers.export(exports, "FaAccessibleIcon", ()=>FaAccessibleIcon);
parcelHelpers.export(exports, "FaAccusoft", ()=>FaAccusoft);
parcelHelpers.export(exports, "FaAcquisitionsIncorporated", ()=>FaAcquisitionsIncorporated);
parcelHelpers.export(exports, "FaAdn", ()=>FaAdn);
parcelHelpers.export(exports, "FaAdversal", ()=>FaAdversal);
parcelHelpers.export(exports, "FaAffiliatetheme", ()=>FaAffiliatetheme);
parcelHelpers.export(exports, "FaAirbnb", ()=>FaAirbnb);
parcelHelpers.export(exports, "FaAlgolia", ()=>FaAlgolia);
parcelHelpers.export(exports, "FaAlipay", ()=>FaAlipay);
parcelHelpers.export(exports, "FaAmazonPay", ()=>FaAmazonPay);
parcelHelpers.export(exports, "FaAmazon", ()=>FaAmazon);
parcelHelpers.export(exports, "FaAmilia", ()=>FaAmilia);
parcelHelpers.export(exports, "FaAndroid", ()=>FaAndroid);
parcelHelpers.export(exports, "FaAngellist", ()=>FaAngellist);
parcelHelpers.export(exports, "FaAngrycreative", ()=>FaAngrycreative);
parcelHelpers.export(exports, "FaAngular", ()=>FaAngular);
parcelHelpers.export(exports, "FaAppStoreIos", ()=>FaAppStoreIos);
parcelHelpers.export(exports, "FaAppStore", ()=>FaAppStore);
parcelHelpers.export(exports, "FaApper", ()=>FaApper);
parcelHelpers.export(exports, "FaApplePay", ()=>FaApplePay);
parcelHelpers.export(exports, "FaApple", ()=>FaApple);
parcelHelpers.export(exports, "FaArtstation", ()=>FaArtstation);
parcelHelpers.export(exports, "FaAsymmetrik", ()=>FaAsymmetrik);
parcelHelpers.export(exports, "FaAtlassian", ()=>FaAtlassian);
parcelHelpers.export(exports, "FaAudible", ()=>FaAudible);
parcelHelpers.export(exports, "FaAutoprefixer", ()=>FaAutoprefixer);
parcelHelpers.export(exports, "FaAvianex", ()=>FaAvianex);
parcelHelpers.export(exports, "FaAviato", ()=>FaAviato);
parcelHelpers.export(exports, "FaAws", ()=>FaAws);
parcelHelpers.export(exports, "FaBandcamp", ()=>FaBandcamp);
parcelHelpers.export(exports, "FaBattleNet", ()=>FaBattleNet);
parcelHelpers.export(exports, "FaBehanceSquare", ()=>FaBehanceSquare);
parcelHelpers.export(exports, "FaBehance", ()=>FaBehance);
parcelHelpers.export(exports, "FaBimobject", ()=>FaBimobject);
parcelHelpers.export(exports, "FaBitbucket", ()=>FaBitbucket);
parcelHelpers.export(exports, "FaBitcoin", ()=>FaBitcoin);
parcelHelpers.export(exports, "FaBity", ()=>FaBity);
parcelHelpers.export(exports, "FaBlackTie", ()=>FaBlackTie);
parcelHelpers.export(exports, "FaBlackberry", ()=>FaBlackberry);
parcelHelpers.export(exports, "FaBloggerB", ()=>FaBloggerB);
parcelHelpers.export(exports, "FaBlogger", ()=>FaBlogger);
parcelHelpers.export(exports, "FaBluetoothB", ()=>FaBluetoothB);
parcelHelpers.export(exports, "FaBluetooth", ()=>FaBluetooth);
parcelHelpers.export(exports, "FaBootstrap", ()=>FaBootstrap);
parcelHelpers.export(exports, "FaBtc", ()=>FaBtc);
parcelHelpers.export(exports, "FaBuffer", ()=>FaBuffer);
parcelHelpers.export(exports, "FaBuromobelexperte", ()=>FaBuromobelexperte);
parcelHelpers.export(exports, "FaBuyNLarge", ()=>FaBuyNLarge);
parcelHelpers.export(exports, "FaBuysellads", ()=>FaBuysellads);
parcelHelpers.export(exports, "FaCanadianMapleLeaf", ()=>FaCanadianMapleLeaf);
parcelHelpers.export(exports, "FaCcAmazonPay", ()=>FaCcAmazonPay);
parcelHelpers.export(exports, "FaCcAmex", ()=>FaCcAmex);
parcelHelpers.export(exports, "FaCcApplePay", ()=>FaCcApplePay);
parcelHelpers.export(exports, "FaCcDinersClub", ()=>FaCcDinersClub);
parcelHelpers.export(exports, "FaCcDiscover", ()=>FaCcDiscover);
parcelHelpers.export(exports, "FaCcJcb", ()=>FaCcJcb);
parcelHelpers.export(exports, "FaCcMastercard", ()=>FaCcMastercard);
parcelHelpers.export(exports, "FaCcPaypal", ()=>FaCcPaypal);
parcelHelpers.export(exports, "FaCcStripe", ()=>FaCcStripe);
parcelHelpers.export(exports, "FaCcVisa", ()=>FaCcVisa);
parcelHelpers.export(exports, "FaCentercode", ()=>FaCentercode);
parcelHelpers.export(exports, "FaCentos", ()=>FaCentos);
parcelHelpers.export(exports, "FaChrome", ()=>FaChrome);
parcelHelpers.export(exports, "FaChromecast", ()=>FaChromecast);
parcelHelpers.export(exports, "FaCloudflare", ()=>FaCloudflare);
parcelHelpers.export(exports, "FaCloudscale", ()=>FaCloudscale);
parcelHelpers.export(exports, "FaCloudsmith", ()=>FaCloudsmith);
parcelHelpers.export(exports, "FaCloudversify", ()=>FaCloudversify);
parcelHelpers.export(exports, "FaCodepen", ()=>FaCodepen);
parcelHelpers.export(exports, "FaCodiepie", ()=>FaCodiepie);
parcelHelpers.export(exports, "FaConfluence", ()=>FaConfluence);
parcelHelpers.export(exports, "FaConnectdevelop", ()=>FaConnectdevelop);
parcelHelpers.export(exports, "FaContao", ()=>FaContao);
parcelHelpers.export(exports, "FaCottonBureau", ()=>FaCottonBureau);
parcelHelpers.export(exports, "FaCpanel", ()=>FaCpanel);
parcelHelpers.export(exports, "FaCreativeCommonsBy", ()=>FaCreativeCommonsBy);
parcelHelpers.export(exports, "FaCreativeCommonsNcEu", ()=>FaCreativeCommonsNcEu);
parcelHelpers.export(exports, "FaCreativeCommonsNcJp", ()=>FaCreativeCommonsNcJp);
parcelHelpers.export(exports, "FaCreativeCommonsNc", ()=>FaCreativeCommonsNc);
parcelHelpers.export(exports, "FaCreativeCommonsNd", ()=>FaCreativeCommonsNd);
parcelHelpers.export(exports, "FaCreativeCommonsPdAlt", ()=>FaCreativeCommonsPdAlt);
parcelHelpers.export(exports, "FaCreativeCommonsPd", ()=>FaCreativeCommonsPd);
parcelHelpers.export(exports, "FaCreativeCommonsRemix", ()=>FaCreativeCommonsRemix);
parcelHelpers.export(exports, "FaCreativeCommonsSa", ()=>FaCreativeCommonsSa);
parcelHelpers.export(exports, "FaCreativeCommonsSamplingPlus", ()=>FaCreativeCommonsSamplingPlus);
parcelHelpers.export(exports, "FaCreativeCommonsSampling", ()=>FaCreativeCommonsSampling);
parcelHelpers.export(exports, "FaCreativeCommonsShare", ()=>FaCreativeCommonsShare);
parcelHelpers.export(exports, "FaCreativeCommonsZero", ()=>FaCreativeCommonsZero);
parcelHelpers.export(exports, "FaCreativeCommons", ()=>FaCreativeCommons);
parcelHelpers.export(exports, "FaCriticalRole", ()=>FaCriticalRole);
parcelHelpers.export(exports, "FaCss3Alt", ()=>FaCss3Alt);
parcelHelpers.export(exports, "FaCss3", ()=>FaCss3);
parcelHelpers.export(exports, "FaCuttlefish", ()=>FaCuttlefish);
parcelHelpers.export(exports, "FaDAndDBeyond", ()=>FaDAndDBeyond);
parcelHelpers.export(exports, "FaDAndD", ()=>FaDAndD);
parcelHelpers.export(exports, "FaDailymotion", ()=>FaDailymotion);
parcelHelpers.export(exports, "FaDashcube", ()=>FaDashcube);
parcelHelpers.export(exports, "FaDeezer", ()=>FaDeezer);
parcelHelpers.export(exports, "FaDelicious", ()=>FaDelicious);
parcelHelpers.export(exports, "FaDeploydog", ()=>FaDeploydog);
parcelHelpers.export(exports, "FaDeskpro", ()=>FaDeskpro);
parcelHelpers.export(exports, "FaDev", ()=>FaDev);
parcelHelpers.export(exports, "FaDeviantart", ()=>FaDeviantart);
parcelHelpers.export(exports, "FaDhl", ()=>FaDhl);
parcelHelpers.export(exports, "FaDiaspora", ()=>FaDiaspora);
parcelHelpers.export(exports, "FaDigg", ()=>FaDigg);
parcelHelpers.export(exports, "FaDigitalOcean", ()=>FaDigitalOcean);
parcelHelpers.export(exports, "FaDiscord", ()=>FaDiscord);
parcelHelpers.export(exports, "FaDiscourse", ()=>FaDiscourse);
parcelHelpers.export(exports, "FaDochub", ()=>FaDochub);
parcelHelpers.export(exports, "FaDocker", ()=>FaDocker);
parcelHelpers.export(exports, "FaDraft2Digital", ()=>FaDraft2Digital);
parcelHelpers.export(exports, "FaDribbbleSquare", ()=>FaDribbbleSquare);
parcelHelpers.export(exports, "FaDribbble", ()=>FaDribbble);
parcelHelpers.export(exports, "FaDropbox", ()=>FaDropbox);
parcelHelpers.export(exports, "FaDrupal", ()=>FaDrupal);
parcelHelpers.export(exports, "FaDyalog", ()=>FaDyalog);
parcelHelpers.export(exports, "FaEarlybirds", ()=>FaEarlybirds);
parcelHelpers.export(exports, "FaEbay", ()=>FaEbay);
parcelHelpers.export(exports, "FaEdgeLegacy", ()=>FaEdgeLegacy);
parcelHelpers.export(exports, "FaEdge", ()=>FaEdge);
parcelHelpers.export(exports, "FaElementor", ()=>FaElementor);
parcelHelpers.export(exports, "FaEllo", ()=>FaEllo);
parcelHelpers.export(exports, "FaEmber", ()=>FaEmber);
parcelHelpers.export(exports, "FaEmpire", ()=>FaEmpire);
parcelHelpers.export(exports, "FaEnvira", ()=>FaEnvira);
parcelHelpers.export(exports, "FaErlang", ()=>FaErlang);
parcelHelpers.export(exports, "FaEthereum", ()=>FaEthereum);
parcelHelpers.export(exports, "FaEtsy", ()=>FaEtsy);
parcelHelpers.export(exports, "FaEvernote", ()=>FaEvernote);
parcelHelpers.export(exports, "FaExpeditedssl", ()=>FaExpeditedssl);
parcelHelpers.export(exports, "FaFacebookF", ()=>FaFacebookF);
parcelHelpers.export(exports, "FaFacebookMessenger", ()=>FaFacebookMessenger);
parcelHelpers.export(exports, "FaFacebookSquare", ()=>FaFacebookSquare);
parcelHelpers.export(exports, "FaFacebook", ()=>FaFacebook);
parcelHelpers.export(exports, "FaFantasyFlightGames", ()=>FaFantasyFlightGames);
parcelHelpers.export(exports, "FaFedex", ()=>FaFedex);
parcelHelpers.export(exports, "FaFedora", ()=>FaFedora);
parcelHelpers.export(exports, "FaFigma", ()=>FaFigma);
parcelHelpers.export(exports, "FaFirefoxBrowser", ()=>FaFirefoxBrowser);
parcelHelpers.export(exports, "FaFirefox", ()=>FaFirefox);
parcelHelpers.export(exports, "FaFirstOrderAlt", ()=>FaFirstOrderAlt);
parcelHelpers.export(exports, "FaFirstOrder", ()=>FaFirstOrder);
parcelHelpers.export(exports, "FaFirstdraft", ()=>FaFirstdraft);
parcelHelpers.export(exports, "FaFlickr", ()=>FaFlickr);
parcelHelpers.export(exports, "FaFlipboard", ()=>FaFlipboard);
parcelHelpers.export(exports, "FaFly", ()=>FaFly);
parcelHelpers.export(exports, "FaFontAwesomeAlt", ()=>FaFontAwesomeAlt);
parcelHelpers.export(exports, "FaFontAwesomeFlag", ()=>FaFontAwesomeFlag);
parcelHelpers.export(exports, "FaFontAwesomeLogoFull", ()=>FaFontAwesomeLogoFull);
parcelHelpers.export(exports, "FaFontAwesome", ()=>FaFontAwesome);
parcelHelpers.export(exports, "FaFonticonsFi", ()=>FaFonticonsFi);
parcelHelpers.export(exports, "FaFonticons", ()=>FaFonticons);
parcelHelpers.export(exports, "FaFortAwesomeAlt", ()=>FaFortAwesomeAlt);
parcelHelpers.export(exports, "FaFortAwesome", ()=>FaFortAwesome);
parcelHelpers.export(exports, "FaForumbee", ()=>FaForumbee);
parcelHelpers.export(exports, "FaFoursquare", ()=>FaFoursquare);
parcelHelpers.export(exports, "FaFreeCodeCamp", ()=>FaFreeCodeCamp);
parcelHelpers.export(exports, "FaFreebsd", ()=>FaFreebsd);
parcelHelpers.export(exports, "FaFulcrum", ()=>FaFulcrum);
parcelHelpers.export(exports, "FaGalacticRepublic", ()=>FaGalacticRepublic);
parcelHelpers.export(exports, "FaGalacticSenate", ()=>FaGalacticSenate);
parcelHelpers.export(exports, "FaGetPocket", ()=>FaGetPocket);
parcelHelpers.export(exports, "FaGgCircle", ()=>FaGgCircle);
parcelHelpers.export(exports, "FaGg", ()=>FaGg);
parcelHelpers.export(exports, "FaGitAlt", ()=>FaGitAlt);
parcelHelpers.export(exports, "FaGitSquare", ()=>FaGitSquare);
parcelHelpers.export(exports, "FaGit", ()=>FaGit);
parcelHelpers.export(exports, "FaGithubAlt", ()=>FaGithubAlt);
parcelHelpers.export(exports, "FaGithubSquare", ()=>FaGithubSquare);
parcelHelpers.export(exports, "FaGithub", ()=>FaGithub);
parcelHelpers.export(exports, "FaGitkraken", ()=>FaGitkraken);
parcelHelpers.export(exports, "FaGitlab", ()=>FaGitlab);
parcelHelpers.export(exports, "FaGitter", ()=>FaGitter);
parcelHelpers.export(exports, "FaGlideG", ()=>FaGlideG);
parcelHelpers.export(exports, "FaGlide", ()=>FaGlide);
parcelHelpers.export(exports, "FaGofore", ()=>FaGofore);
parcelHelpers.export(exports, "FaGoodreadsG", ()=>FaGoodreadsG);
parcelHelpers.export(exports, "FaGoodreads", ()=>FaGoodreads);
parcelHelpers.export(exports, "FaGoogleDrive", ()=>FaGoogleDrive);
parcelHelpers.export(exports, "FaGooglePay", ()=>FaGooglePay);
parcelHelpers.export(exports, "FaGooglePlay", ()=>FaGooglePlay);
parcelHelpers.export(exports, "FaGooglePlusG", ()=>FaGooglePlusG);
parcelHelpers.export(exports, "FaGooglePlusSquare", ()=>FaGooglePlusSquare);
parcelHelpers.export(exports, "FaGooglePlus", ()=>FaGooglePlus);
parcelHelpers.export(exports, "FaGoogleWallet", ()=>FaGoogleWallet);
parcelHelpers.export(exports, "FaGoogle", ()=>FaGoogle);
parcelHelpers.export(exports, "FaGratipay", ()=>FaGratipay);
parcelHelpers.export(exports, "FaGrav", ()=>FaGrav);
parcelHelpers.export(exports, "FaGripfire", ()=>FaGripfire);
parcelHelpers.export(exports, "FaGrunt", ()=>FaGrunt);
parcelHelpers.export(exports, "FaGuilded", ()=>FaGuilded);
parcelHelpers.export(exports, "FaGulp", ()=>FaGulp);
parcelHelpers.export(exports, "FaHackerNewsSquare", ()=>FaHackerNewsSquare);
parcelHelpers.export(exports, "FaHackerNews", ()=>FaHackerNews);
parcelHelpers.export(exports, "FaHackerrank", ()=>FaHackerrank);
parcelHelpers.export(exports, "FaHips", ()=>FaHips);
parcelHelpers.export(exports, "FaHireAHelper", ()=>FaHireAHelper);
parcelHelpers.export(exports, "FaHive", ()=>FaHive);
parcelHelpers.export(exports, "FaHooli", ()=>FaHooli);
parcelHelpers.export(exports, "FaHornbill", ()=>FaHornbill);
parcelHelpers.export(exports, "FaHotjar", ()=>FaHotjar);
parcelHelpers.export(exports, "FaHouzz", ()=>FaHouzz);
parcelHelpers.export(exports, "FaHtml5", ()=>FaHtml5);
parcelHelpers.export(exports, "FaHubspot", ()=>FaHubspot);
parcelHelpers.export(exports, "FaIdeal", ()=>FaIdeal);
parcelHelpers.export(exports, "FaImdb", ()=>FaImdb);
parcelHelpers.export(exports, "FaInnosoft", ()=>FaInnosoft);
parcelHelpers.export(exports, "FaInstagramSquare", ()=>FaInstagramSquare);
parcelHelpers.export(exports, "FaInstagram", ()=>FaInstagram);
parcelHelpers.export(exports, "FaInstalod", ()=>FaInstalod);
parcelHelpers.export(exports, "FaIntercom", ()=>FaIntercom);
parcelHelpers.export(exports, "FaInternetExplorer", ()=>FaInternetExplorer);
parcelHelpers.export(exports, "FaInvision", ()=>FaInvision);
parcelHelpers.export(exports, "FaIoxhost", ()=>FaIoxhost);
parcelHelpers.export(exports, "FaItchIo", ()=>FaItchIo);
parcelHelpers.export(exports, "FaItunesNote", ()=>FaItunesNote);
parcelHelpers.export(exports, "FaItunes", ()=>FaItunes);
parcelHelpers.export(exports, "FaJava", ()=>FaJava);
parcelHelpers.export(exports, "FaJediOrder", ()=>FaJediOrder);
parcelHelpers.export(exports, "FaJenkins", ()=>FaJenkins);
parcelHelpers.export(exports, "FaJira", ()=>FaJira);
parcelHelpers.export(exports, "FaJoget", ()=>FaJoget);
parcelHelpers.export(exports, "FaJoomla", ()=>FaJoomla);
parcelHelpers.export(exports, "FaJsSquare", ()=>FaJsSquare);
parcelHelpers.export(exports, "FaJs", ()=>FaJs);
parcelHelpers.export(exports, "FaJsfiddle", ()=>FaJsfiddle);
parcelHelpers.export(exports, "FaKaggle", ()=>FaKaggle);
parcelHelpers.export(exports, "FaKeybase", ()=>FaKeybase);
parcelHelpers.export(exports, "FaKeycdn", ()=>FaKeycdn);
parcelHelpers.export(exports, "FaKickstarterK", ()=>FaKickstarterK);
parcelHelpers.export(exports, "FaKickstarter", ()=>FaKickstarter);
parcelHelpers.export(exports, "FaKorvue", ()=>FaKorvue);
parcelHelpers.export(exports, "FaLaravel", ()=>FaLaravel);
parcelHelpers.export(exports, "FaLastfmSquare", ()=>FaLastfmSquare);
parcelHelpers.export(exports, "FaLastfm", ()=>FaLastfm);
parcelHelpers.export(exports, "FaLeanpub", ()=>FaLeanpub);
parcelHelpers.export(exports, "FaLess", ()=>FaLess);
parcelHelpers.export(exports, "FaLine", ()=>FaLine);
parcelHelpers.export(exports, "FaLinkedinIn", ()=>FaLinkedinIn);
parcelHelpers.export(exports, "FaLinkedin", ()=>FaLinkedin);
parcelHelpers.export(exports, "FaLinode", ()=>FaLinode);
parcelHelpers.export(exports, "FaLinux", ()=>FaLinux);
parcelHelpers.export(exports, "FaLyft", ()=>FaLyft);
parcelHelpers.export(exports, "FaMagento", ()=>FaMagento);
parcelHelpers.export(exports, "FaMailchimp", ()=>FaMailchimp);
parcelHelpers.export(exports, "FaMandalorian", ()=>FaMandalorian);
parcelHelpers.export(exports, "FaMarkdown", ()=>FaMarkdown);
parcelHelpers.export(exports, "FaMastodon", ()=>FaMastodon);
parcelHelpers.export(exports, "FaMaxcdn", ()=>FaMaxcdn);
parcelHelpers.export(exports, "FaMdb", ()=>FaMdb);
parcelHelpers.export(exports, "FaMedapps", ()=>FaMedapps);
parcelHelpers.export(exports, "FaMediumM", ()=>FaMediumM);
parcelHelpers.export(exports, "FaMedium", ()=>FaMedium);
parcelHelpers.export(exports, "FaMedrt", ()=>FaMedrt);
parcelHelpers.export(exports, "FaMeetup", ()=>FaMeetup);
parcelHelpers.export(exports, "FaMegaport", ()=>FaMegaport);
parcelHelpers.export(exports, "FaMendeley", ()=>FaMendeley);
parcelHelpers.export(exports, "FaMicroblog", ()=>FaMicroblog);
parcelHelpers.export(exports, "FaMicrosoft", ()=>FaMicrosoft);
parcelHelpers.export(exports, "FaMix", ()=>FaMix);
parcelHelpers.export(exports, "FaMixcloud", ()=>FaMixcloud);
parcelHelpers.export(exports, "FaMixer", ()=>FaMixer);
parcelHelpers.export(exports, "FaMizuni", ()=>FaMizuni);
parcelHelpers.export(exports, "FaModx", ()=>FaModx);
parcelHelpers.export(exports, "FaMonero", ()=>FaMonero);
parcelHelpers.export(exports, "FaNapster", ()=>FaNapster);
parcelHelpers.export(exports, "FaNeos", ()=>FaNeos);
parcelHelpers.export(exports, "FaNimblr", ()=>FaNimblr);
parcelHelpers.export(exports, "FaNodeJs", ()=>FaNodeJs);
parcelHelpers.export(exports, "FaNode", ()=>FaNode);
parcelHelpers.export(exports, "FaNpm", ()=>FaNpm);
parcelHelpers.export(exports, "FaNs8", ()=>FaNs8);
parcelHelpers.export(exports, "FaNutritionix", ()=>FaNutritionix);
parcelHelpers.export(exports, "FaOctopusDeploy", ()=>FaOctopusDeploy);
parcelHelpers.export(exports, "FaOdnoklassnikiSquare", ()=>FaOdnoklassnikiSquare);
parcelHelpers.export(exports, "FaOdnoklassniki", ()=>FaOdnoklassniki);
parcelHelpers.export(exports, "FaOldRepublic", ()=>FaOldRepublic);
parcelHelpers.export(exports, "FaOpencart", ()=>FaOpencart);
parcelHelpers.export(exports, "FaOpenid", ()=>FaOpenid);
parcelHelpers.export(exports, "FaOpera", ()=>FaOpera);
parcelHelpers.export(exports, "FaOptinMonster", ()=>FaOptinMonster);
parcelHelpers.export(exports, "FaOrcid", ()=>FaOrcid);
parcelHelpers.export(exports, "FaOsi", ()=>FaOsi);
parcelHelpers.export(exports, "FaPage4", ()=>FaPage4);
parcelHelpers.export(exports, "FaPagelines", ()=>FaPagelines);
parcelHelpers.export(exports, "FaPalfed", ()=>FaPalfed);
parcelHelpers.export(exports, "FaPatreon", ()=>FaPatreon);
parcelHelpers.export(exports, "FaPaypal", ()=>FaPaypal);
parcelHelpers.export(exports, "FaPennyArcade", ()=>FaPennyArcade);
parcelHelpers.export(exports, "FaPerbyte", ()=>FaPerbyte);
parcelHelpers.export(exports, "FaPeriscope", ()=>FaPeriscope);
parcelHelpers.export(exports, "FaPhabricator", ()=>FaPhabricator);
parcelHelpers.export(exports, "FaPhoenixFramework", ()=>FaPhoenixFramework);
parcelHelpers.export(exports, "FaPhoenixSquadron", ()=>FaPhoenixSquadron);
parcelHelpers.export(exports, "FaPhp", ()=>FaPhp);
parcelHelpers.export(exports, "FaPiedPiperAlt", ()=>FaPiedPiperAlt);
parcelHelpers.export(exports, "FaPiedPiperHat", ()=>FaPiedPiperHat);
parcelHelpers.export(exports, "FaPiedPiperPp", ()=>FaPiedPiperPp);
parcelHelpers.export(exports, "FaPiedPiperSquare", ()=>FaPiedPiperSquare);
parcelHelpers.export(exports, "FaPiedPiper", ()=>FaPiedPiper);
parcelHelpers.export(exports, "FaPinterestP", ()=>FaPinterestP);
parcelHelpers.export(exports, "FaPinterestSquare", ()=>FaPinterestSquare);
parcelHelpers.export(exports, "FaPinterest", ()=>FaPinterest);
parcelHelpers.export(exports, "FaPlaystation", ()=>FaPlaystation);
parcelHelpers.export(exports, "FaProductHunt", ()=>FaProductHunt);
parcelHelpers.export(exports, "FaPushed", ()=>FaPushed);
parcelHelpers.export(exports, "FaPython", ()=>FaPython);
parcelHelpers.export(exports, "FaQq", ()=>FaQq);
parcelHelpers.export(exports, "FaQuinscape", ()=>FaQuinscape);
parcelHelpers.export(exports, "FaQuora", ()=>FaQuora);
parcelHelpers.export(exports, "FaRProject", ()=>FaRProject);
parcelHelpers.export(exports, "FaRaspberryPi", ()=>FaRaspberryPi);
parcelHelpers.export(exports, "FaRavelry", ()=>FaRavelry);
parcelHelpers.export(exports, "FaReact", ()=>FaReact);
parcelHelpers.export(exports, "FaReacteurope", ()=>FaReacteurope);
parcelHelpers.export(exports, "FaReadme", ()=>FaReadme);
parcelHelpers.export(exports, "FaRebel", ()=>FaRebel);
parcelHelpers.export(exports, "FaRedRiver", ()=>FaRedRiver);
parcelHelpers.export(exports, "FaRedditAlien", ()=>FaRedditAlien);
parcelHelpers.export(exports, "FaRedditSquare", ()=>FaRedditSquare);
parcelHelpers.export(exports, "FaReddit", ()=>FaReddit);
parcelHelpers.export(exports, "FaRedhat", ()=>FaRedhat);
parcelHelpers.export(exports, "FaRenren", ()=>FaRenren);
parcelHelpers.export(exports, "FaReplyd", ()=>FaReplyd);
parcelHelpers.export(exports, "FaResearchgate", ()=>FaResearchgate);
parcelHelpers.export(exports, "FaResolving", ()=>FaResolving);
parcelHelpers.export(exports, "FaRev", ()=>FaRev);
parcelHelpers.export(exports, "FaRocketchat", ()=>FaRocketchat);
parcelHelpers.export(exports, "FaRockrms", ()=>FaRockrms);
parcelHelpers.export(exports, "FaRust", ()=>FaRust);
parcelHelpers.export(exports, "FaSafari", ()=>FaSafari);
parcelHelpers.export(exports, "FaSalesforce", ()=>FaSalesforce);
parcelHelpers.export(exports, "FaSass", ()=>FaSass);
parcelHelpers.export(exports, "FaSchlix", ()=>FaSchlix);
parcelHelpers.export(exports, "FaScribd", ()=>FaScribd);
parcelHelpers.export(exports, "FaSearchengin", ()=>FaSearchengin);
parcelHelpers.export(exports, "FaSellcast", ()=>FaSellcast);
parcelHelpers.export(exports, "FaSellsy", ()=>FaSellsy);
parcelHelpers.export(exports, "FaServicestack", ()=>FaServicestack);
parcelHelpers.export(exports, "FaShirtsinbulk", ()=>FaShirtsinbulk);
parcelHelpers.export(exports, "FaShopify", ()=>FaShopify);
parcelHelpers.export(exports, "FaShopware", ()=>FaShopware);
parcelHelpers.export(exports, "FaSimplybuilt", ()=>FaSimplybuilt);
parcelHelpers.export(exports, "FaSistrix", ()=>FaSistrix);
parcelHelpers.export(exports, "FaSith", ()=>FaSith);
parcelHelpers.export(exports, "FaSketch", ()=>FaSketch);
parcelHelpers.export(exports, "FaSkyatlas", ()=>FaSkyatlas);
parcelHelpers.export(exports, "FaSkype", ()=>FaSkype);
parcelHelpers.export(exports, "FaSlackHash", ()=>FaSlackHash);
parcelHelpers.export(exports, "FaSlack", ()=>FaSlack);
parcelHelpers.export(exports, "FaSlideshare", ()=>FaSlideshare);
parcelHelpers.export(exports, "FaSnapchatGhost", ()=>FaSnapchatGhost);
parcelHelpers.export(exports, "FaSnapchatSquare", ()=>FaSnapchatSquare);
parcelHelpers.export(exports, "FaSnapchat", ()=>FaSnapchat);
parcelHelpers.export(exports, "FaSoundcloud", ()=>FaSoundcloud);
parcelHelpers.export(exports, "FaSourcetree", ()=>FaSourcetree);
parcelHelpers.export(exports, "FaSpeakap", ()=>FaSpeakap);
parcelHelpers.export(exports, "FaSpeakerDeck", ()=>FaSpeakerDeck);
parcelHelpers.export(exports, "FaSpotify", ()=>FaSpotify);
parcelHelpers.export(exports, "FaSquarespace", ()=>FaSquarespace);
parcelHelpers.export(exports, "FaStackExchange", ()=>FaStackExchange);
parcelHelpers.export(exports, "FaStackOverflow", ()=>FaStackOverflow);
parcelHelpers.export(exports, "FaStackpath", ()=>FaStackpath);
parcelHelpers.export(exports, "FaStaylinked", ()=>FaStaylinked);
parcelHelpers.export(exports, "FaSteamSquare", ()=>FaSteamSquare);
parcelHelpers.export(exports, "FaSteamSymbol", ()=>FaSteamSymbol);
parcelHelpers.export(exports, "FaSteam", ()=>FaSteam);
parcelHelpers.export(exports, "FaStickerMule", ()=>FaStickerMule);
parcelHelpers.export(exports, "FaStrava", ()=>FaStrava);
parcelHelpers.export(exports, "FaStripeS", ()=>FaStripeS);
parcelHelpers.export(exports, "FaStripe", ()=>FaStripe);
parcelHelpers.export(exports, "FaStudiovinari", ()=>FaStudiovinari);
parcelHelpers.export(exports, "FaStumbleuponCircle", ()=>FaStumbleuponCircle);
parcelHelpers.export(exports, "FaStumbleupon", ()=>FaStumbleupon);
parcelHelpers.export(exports, "FaSuperpowers", ()=>FaSuperpowers);
parcelHelpers.export(exports, "FaSupple", ()=>FaSupple);
parcelHelpers.export(exports, "FaSuse", ()=>FaSuse);
parcelHelpers.export(exports, "FaSwift", ()=>FaSwift);
parcelHelpers.export(exports, "FaSymfony", ()=>FaSymfony);
parcelHelpers.export(exports, "FaTeamspeak", ()=>FaTeamspeak);
parcelHelpers.export(exports, "FaTelegramPlane", ()=>FaTelegramPlane);
parcelHelpers.export(exports, "FaTelegram", ()=>FaTelegram);
parcelHelpers.export(exports, "FaTencentWeibo", ()=>FaTencentWeibo);
parcelHelpers.export(exports, "FaTheRedYeti", ()=>FaTheRedYeti);
parcelHelpers.export(exports, "FaThemeco", ()=>FaThemeco);
parcelHelpers.export(exports, "FaThemeisle", ()=>FaThemeisle);
parcelHelpers.export(exports, "FaThinkPeaks", ()=>FaThinkPeaks);
parcelHelpers.export(exports, "FaTiktok", ()=>FaTiktok);
parcelHelpers.export(exports, "FaTradeFederation", ()=>FaTradeFederation);
parcelHelpers.export(exports, "FaTrello", ()=>FaTrello);
parcelHelpers.export(exports, "FaTripadvisor", ()=>FaTripadvisor);
parcelHelpers.export(exports, "FaTumblrSquare", ()=>FaTumblrSquare);
parcelHelpers.export(exports, "FaTumblr", ()=>FaTumblr);
parcelHelpers.export(exports, "FaTwitch", ()=>FaTwitch);
parcelHelpers.export(exports, "FaTwitterSquare", ()=>FaTwitterSquare);
parcelHelpers.export(exports, "FaTwitter", ()=>FaTwitter);
parcelHelpers.export(exports, "FaTypo3", ()=>FaTypo3);
parcelHelpers.export(exports, "FaUber", ()=>FaUber);
parcelHelpers.export(exports, "FaUbuntu", ()=>FaUbuntu);
parcelHelpers.export(exports, "FaUikit", ()=>FaUikit);
parcelHelpers.export(exports, "FaUmbraco", ()=>FaUmbraco);
parcelHelpers.export(exports, "FaUncharted", ()=>FaUncharted);
parcelHelpers.export(exports, "FaUniregistry", ()=>FaUniregistry);
parcelHelpers.export(exports, "FaUnity", ()=>FaUnity);
parcelHelpers.export(exports, "FaUnsplash", ()=>FaUnsplash);
parcelHelpers.export(exports, "FaUntappd", ()=>FaUntappd);
parcelHelpers.export(exports, "FaUps", ()=>FaUps);
parcelHelpers.export(exports, "FaUsb", ()=>FaUsb);
parcelHelpers.export(exports, "FaUsps", ()=>FaUsps);
parcelHelpers.export(exports, "FaUssunnah", ()=>FaUssunnah);
parcelHelpers.export(exports, "FaVaadin", ()=>FaVaadin);
parcelHelpers.export(exports, "FaViacoin", ()=>FaViacoin);
parcelHelpers.export(exports, "FaViadeoSquare", ()=>FaViadeoSquare);
parcelHelpers.export(exports, "FaViadeo", ()=>FaViadeo);
parcelHelpers.export(exports, "FaViber", ()=>FaViber);
parcelHelpers.export(exports, "FaVimeoSquare", ()=>FaVimeoSquare);
parcelHelpers.export(exports, "FaVimeoV", ()=>FaVimeoV);
parcelHelpers.export(exports, "FaVimeo", ()=>FaVimeo);
parcelHelpers.export(exports, "FaVine", ()=>FaVine);
parcelHelpers.export(exports, "FaVk", ()=>FaVk);
parcelHelpers.export(exports, "FaVnv", ()=>FaVnv);
parcelHelpers.export(exports, "FaVuejs", ()=>FaVuejs);
parcelHelpers.export(exports, "FaWatchmanMonitoring", ()=>FaWatchmanMonitoring);
parcelHelpers.export(exports, "FaWaze", ()=>FaWaze);
parcelHelpers.export(exports, "FaWeebly", ()=>FaWeebly);
parcelHelpers.export(exports, "FaWeibo", ()=>FaWeibo);
parcelHelpers.export(exports, "FaWeixin", ()=>FaWeixin);
parcelHelpers.export(exports, "FaWhatsappSquare", ()=>FaWhatsappSquare);
parcelHelpers.export(exports, "FaWhatsapp", ()=>FaWhatsapp);
parcelHelpers.export(exports, "FaWhmcs", ()=>FaWhmcs);
parcelHelpers.export(exports, "FaWikipediaW", ()=>FaWikipediaW);
parcelHelpers.export(exports, "FaWindows", ()=>FaWindows);
parcelHelpers.export(exports, "FaWix", ()=>FaWix);
parcelHelpers.export(exports, "FaWizardsOfTheCoast", ()=>FaWizardsOfTheCoast);
parcelHelpers.export(exports, "FaWodu", ()=>FaWodu);
parcelHelpers.export(exports, "FaWolfPackBattalion", ()=>FaWolfPackBattalion);
parcelHelpers.export(exports, "FaWordpressSimple", ()=>FaWordpressSimple);
parcelHelpers.export(exports, "FaWordpress", ()=>FaWordpress);
parcelHelpers.export(exports, "FaWpbeginner", ()=>FaWpbeginner);
parcelHelpers.export(exports, "FaWpexplorer", ()=>FaWpexplorer);
parcelHelpers.export(exports, "FaWpforms", ()=>FaWpforms);
parcelHelpers.export(exports, "FaWpressr", ()=>FaWpressr);
parcelHelpers.export(exports, "FaXbox", ()=>FaXbox);
parcelHelpers.export(exports, "FaXingSquare", ()=>FaXingSquare);
parcelHelpers.export(exports, "FaXing", ()=>FaXing);
parcelHelpers.export(exports, "FaYCombinator", ()=>FaYCombinator);
parcelHelpers.export(exports, "FaYahoo", ()=>FaYahoo);
parcelHelpers.export(exports, "FaYammer", ()=>FaYammer);
parcelHelpers.export(exports, "FaYandexInternational", ()=>FaYandexInternational);
parcelHelpers.export(exports, "FaYandex", ()=>FaYandex);
parcelHelpers.export(exports, "FaYarn", ()=>FaYarn);
parcelHelpers.export(exports, "FaYelp", ()=>FaYelp);
parcelHelpers.export(exports, "FaYoast", ()=>FaYoast);
parcelHelpers.export(exports, "FaYoutubeSquare", ()=>FaYoutubeSquare);
parcelHelpers.export(exports, "FaYoutube", ()=>FaYoutube);
parcelHelpers.export(exports, "FaZhihu", ()=>FaZhihu);
parcelHelpers.export(exports, "FaAd", ()=>FaAd);
parcelHelpers.export(exports, "FaAddressBook", ()=>FaAddressBook);
parcelHelpers.export(exports, "FaAddressCard", ()=>FaAddressCard);
parcelHelpers.export(exports, "FaAdjust", ()=>FaAdjust);
parcelHelpers.export(exports, "FaAirFreshener", ()=>FaAirFreshener);
parcelHelpers.export(exports, "FaAlignCenter", ()=>FaAlignCenter);
parcelHelpers.export(exports, "FaAlignJustify", ()=>FaAlignJustify);
parcelHelpers.export(exports, "FaAlignLeft", ()=>FaAlignLeft);
parcelHelpers.export(exports, "FaAlignRight", ()=>FaAlignRight);
parcelHelpers.export(exports, "FaAllergies", ()=>FaAllergies);
parcelHelpers.export(exports, "FaAmbulance", ()=>FaAmbulance);
parcelHelpers.export(exports, "FaAmericanSignLanguageInterpreting", ()=>FaAmericanSignLanguageInterpreting);
parcelHelpers.export(exports, "FaAnchor", ()=>FaAnchor);
parcelHelpers.export(exports, "FaAngleDoubleDown", ()=>FaAngleDoubleDown);
parcelHelpers.export(exports, "FaAngleDoubleLeft", ()=>FaAngleDoubleLeft);
parcelHelpers.export(exports, "FaAngleDoubleRight", ()=>FaAngleDoubleRight);
parcelHelpers.export(exports, "FaAngleDoubleUp", ()=>FaAngleDoubleUp);
parcelHelpers.export(exports, "FaAngleDown", ()=>FaAngleDown);
parcelHelpers.export(exports, "FaAngleLeft", ()=>FaAngleLeft);
parcelHelpers.export(exports, "FaAngleRight", ()=>FaAngleRight);
parcelHelpers.export(exports, "FaAngleUp", ()=>FaAngleUp);
parcelHelpers.export(exports, "FaAngry", ()=>FaAngry);
parcelHelpers.export(exports, "FaAnkh", ()=>FaAnkh);
parcelHelpers.export(exports, "FaAppleAlt", ()=>FaAppleAlt);
parcelHelpers.export(exports, "FaArchive", ()=>FaArchive);
parcelHelpers.export(exports, "FaArchway", ()=>FaArchway);
parcelHelpers.export(exports, "FaArrowAltCircleDown", ()=>FaArrowAltCircleDown);
parcelHelpers.export(exports, "FaArrowAltCircleLeft", ()=>FaArrowAltCircleLeft);
parcelHelpers.export(exports, "FaArrowAltCircleRight", ()=>FaArrowAltCircleRight);
parcelHelpers.export(exports, "FaArrowAltCircleUp", ()=>FaArrowAltCircleUp);
parcelHelpers.export(exports, "FaArrowCircleDown", ()=>FaArrowCircleDown);
parcelHelpers.export(exports, "FaArrowCircleLeft", ()=>FaArrowCircleLeft);
parcelHelpers.export(exports, "FaArrowCircleRight", ()=>FaArrowCircleRight);
parcelHelpers.export(exports, "FaArrowCircleUp", ()=>FaArrowCircleUp);
parcelHelpers.export(exports, "FaArrowDown", ()=>FaArrowDown);
parcelHelpers.export(exports, "FaArrowLeft", ()=>FaArrowLeft);
parcelHelpers.export(exports, "FaArrowRight", ()=>FaArrowRight);
parcelHelpers.export(exports, "FaArrowUp", ()=>FaArrowUp);
parcelHelpers.export(exports, "FaArrowsAltH", ()=>FaArrowsAltH);
parcelHelpers.export(exports, "FaArrowsAltV", ()=>FaArrowsAltV);
parcelHelpers.export(exports, "FaArrowsAlt", ()=>FaArrowsAlt);
parcelHelpers.export(exports, "FaAssistiveListeningSystems", ()=>FaAssistiveListeningSystems);
parcelHelpers.export(exports, "FaAsterisk", ()=>FaAsterisk);
parcelHelpers.export(exports, "FaAt", ()=>FaAt);
parcelHelpers.export(exports, "FaAtlas", ()=>FaAtlas);
parcelHelpers.export(exports, "FaAtom", ()=>FaAtom);
parcelHelpers.export(exports, "FaAudioDescription", ()=>FaAudioDescription);
parcelHelpers.export(exports, "FaAward", ()=>FaAward);
parcelHelpers.export(exports, "FaBabyCarriage", ()=>FaBabyCarriage);
parcelHelpers.export(exports, "FaBaby", ()=>FaBaby);
parcelHelpers.export(exports, "FaBackspace", ()=>FaBackspace);
parcelHelpers.export(exports, "FaBackward", ()=>FaBackward);
parcelHelpers.export(exports, "FaBacon", ()=>FaBacon);
parcelHelpers.export(exports, "FaBacteria", ()=>FaBacteria);
parcelHelpers.export(exports, "FaBacterium", ()=>FaBacterium);
parcelHelpers.export(exports, "FaBahai", ()=>FaBahai);
parcelHelpers.export(exports, "FaBalanceScaleLeft", ()=>FaBalanceScaleLeft);
parcelHelpers.export(exports, "FaBalanceScaleRight", ()=>FaBalanceScaleRight);
parcelHelpers.export(exports, "FaBalanceScale", ()=>FaBalanceScale);
parcelHelpers.export(exports, "FaBan", ()=>FaBan);
parcelHelpers.export(exports, "FaBandAid", ()=>FaBandAid);
parcelHelpers.export(exports, "FaBarcode", ()=>FaBarcode);
parcelHelpers.export(exports, "FaBars", ()=>FaBars);
parcelHelpers.export(exports, "FaBaseballBall", ()=>FaBaseballBall);
parcelHelpers.export(exports, "FaBasketballBall", ()=>FaBasketballBall);
parcelHelpers.export(exports, "FaBath", ()=>FaBath);
parcelHelpers.export(exports, "FaBatteryEmpty", ()=>FaBatteryEmpty);
parcelHelpers.export(exports, "FaBatteryFull", ()=>FaBatteryFull);
parcelHelpers.export(exports, "FaBatteryHalf", ()=>FaBatteryHalf);
parcelHelpers.export(exports, "FaBatteryQuarter", ()=>FaBatteryQuarter);
parcelHelpers.export(exports, "FaBatteryThreeQuarters", ()=>FaBatteryThreeQuarters);
parcelHelpers.export(exports, "FaBed", ()=>FaBed);
parcelHelpers.export(exports, "FaBeer", ()=>FaBeer);
parcelHelpers.export(exports, "FaBellSlash", ()=>FaBellSlash);
parcelHelpers.export(exports, "FaBell", ()=>FaBell);
parcelHelpers.export(exports, "FaBezierCurve", ()=>FaBezierCurve);
parcelHelpers.export(exports, "FaBible", ()=>FaBible);
parcelHelpers.export(exports, "FaBicycle", ()=>FaBicycle);
parcelHelpers.export(exports, "FaBiking", ()=>FaBiking);
parcelHelpers.export(exports, "FaBinoculars", ()=>FaBinoculars);
parcelHelpers.export(exports, "FaBiohazard", ()=>FaBiohazard);
parcelHelpers.export(exports, "FaBirthdayCake", ()=>FaBirthdayCake);
parcelHelpers.export(exports, "FaBlenderPhone", ()=>FaBlenderPhone);
parcelHelpers.export(exports, "FaBlender", ()=>FaBlender);
parcelHelpers.export(exports, "FaBlind", ()=>FaBlind);
parcelHelpers.export(exports, "FaBlog", ()=>FaBlog);
parcelHelpers.export(exports, "FaBold", ()=>FaBold);
parcelHelpers.export(exports, "FaBolt", ()=>FaBolt);
parcelHelpers.export(exports, "FaBomb", ()=>FaBomb);
parcelHelpers.export(exports, "FaBone", ()=>FaBone);
parcelHelpers.export(exports, "FaBong", ()=>FaBong);
parcelHelpers.export(exports, "FaBookDead", ()=>FaBookDead);
parcelHelpers.export(exports, "FaBookMedical", ()=>FaBookMedical);
parcelHelpers.export(exports, "FaBookOpen", ()=>FaBookOpen);
parcelHelpers.export(exports, "FaBookReader", ()=>FaBookReader);
parcelHelpers.export(exports, "FaBook", ()=>FaBook);
parcelHelpers.export(exports, "FaBookmark", ()=>FaBookmark);
parcelHelpers.export(exports, "FaBorderAll", ()=>FaBorderAll);
parcelHelpers.export(exports, "FaBorderNone", ()=>FaBorderNone);
parcelHelpers.export(exports, "FaBorderStyle", ()=>FaBorderStyle);
parcelHelpers.export(exports, "FaBowlingBall", ()=>FaBowlingBall);
parcelHelpers.export(exports, "FaBoxOpen", ()=>FaBoxOpen);
parcelHelpers.export(exports, "FaBoxTissue", ()=>FaBoxTissue);
parcelHelpers.export(exports, "FaBox", ()=>FaBox);
parcelHelpers.export(exports, "FaBoxes", ()=>FaBoxes);
parcelHelpers.export(exports, "FaBraille", ()=>FaBraille);
parcelHelpers.export(exports, "FaBrain", ()=>FaBrain);
parcelHelpers.export(exports, "FaBreadSlice", ()=>FaBreadSlice);
parcelHelpers.export(exports, "FaBriefcaseMedical", ()=>FaBriefcaseMedical);
parcelHelpers.export(exports, "FaBriefcase", ()=>FaBriefcase);
parcelHelpers.export(exports, "FaBroadcastTower", ()=>FaBroadcastTower);
parcelHelpers.export(exports, "FaBroom", ()=>FaBroom);
parcelHelpers.export(exports, "FaBrush", ()=>FaBrush);
parcelHelpers.export(exports, "FaBug", ()=>FaBug);
parcelHelpers.export(exports, "FaBuilding", ()=>FaBuilding);
parcelHelpers.export(exports, "FaBullhorn", ()=>FaBullhorn);
parcelHelpers.export(exports, "FaBullseye", ()=>FaBullseye);
parcelHelpers.export(exports, "FaBurn", ()=>FaBurn);
parcelHelpers.export(exports, "FaBusAlt", ()=>FaBusAlt);
parcelHelpers.export(exports, "FaBus", ()=>FaBus);
parcelHelpers.export(exports, "FaBusinessTime", ()=>FaBusinessTime);
parcelHelpers.export(exports, "FaCalculator", ()=>FaCalculator);
parcelHelpers.export(exports, "FaCalendarAlt", ()=>FaCalendarAlt);
parcelHelpers.export(exports, "FaCalendarCheck", ()=>FaCalendarCheck);
parcelHelpers.export(exports, "FaCalendarDay", ()=>FaCalendarDay);
parcelHelpers.export(exports, "FaCalendarMinus", ()=>FaCalendarMinus);
parcelHelpers.export(exports, "FaCalendarPlus", ()=>FaCalendarPlus);
parcelHelpers.export(exports, "FaCalendarTimes", ()=>FaCalendarTimes);
parcelHelpers.export(exports, "FaCalendarWeek", ()=>FaCalendarWeek);
parcelHelpers.export(exports, "FaCalendar", ()=>FaCalendar);
parcelHelpers.export(exports, "FaCameraRetro", ()=>FaCameraRetro);
parcelHelpers.export(exports, "FaCamera", ()=>FaCamera);
parcelHelpers.export(exports, "FaCampground", ()=>FaCampground);
parcelHelpers.export(exports, "FaCandyCane", ()=>FaCandyCane);
parcelHelpers.export(exports, "FaCannabis", ()=>FaCannabis);
parcelHelpers.export(exports, "FaCapsules", ()=>FaCapsules);
parcelHelpers.export(exports, "FaCarAlt", ()=>FaCarAlt);
parcelHelpers.export(exports, "FaCarBattery", ()=>FaCarBattery);
parcelHelpers.export(exports, "FaCarCrash", ()=>FaCarCrash);
parcelHelpers.export(exports, "FaCarSide", ()=>FaCarSide);
parcelHelpers.export(exports, "FaCar", ()=>FaCar);
parcelHelpers.export(exports, "FaCaravan", ()=>FaCaravan);
parcelHelpers.export(exports, "FaCaretDown", ()=>FaCaretDown);
parcelHelpers.export(exports, "FaCaretLeft", ()=>FaCaretLeft);
parcelHelpers.export(exports, "FaCaretRight", ()=>FaCaretRight);
parcelHelpers.export(exports, "FaCaretSquareDown", ()=>FaCaretSquareDown);
parcelHelpers.export(exports, "FaCaretSquareLeft", ()=>FaCaretSquareLeft);
parcelHelpers.export(exports, "FaCaretSquareRight", ()=>FaCaretSquareRight);
parcelHelpers.export(exports, "FaCaretSquareUp", ()=>FaCaretSquareUp);
parcelHelpers.export(exports, "FaCaretUp", ()=>FaCaretUp);
parcelHelpers.export(exports, "FaCarrot", ()=>FaCarrot);
parcelHelpers.export(exports, "FaCartArrowDown", ()=>FaCartArrowDown);
parcelHelpers.export(exports, "FaCartPlus", ()=>FaCartPlus);
parcelHelpers.export(exports, "FaCashRegister", ()=>FaCashRegister);
parcelHelpers.export(exports, "FaCat", ()=>FaCat);
parcelHelpers.export(exports, "FaCertificate", ()=>FaCertificate);
parcelHelpers.export(exports, "FaChair", ()=>FaChair);
parcelHelpers.export(exports, "FaChalkboardTeacher", ()=>FaChalkboardTeacher);
parcelHelpers.export(exports, "FaChalkboard", ()=>FaChalkboard);
parcelHelpers.export(exports, "FaChargingStation", ()=>FaChargingStation);
parcelHelpers.export(exports, "FaChartArea", ()=>FaChartArea);
parcelHelpers.export(exports, "FaChartBar", ()=>FaChartBar);
parcelHelpers.export(exports, "FaChartLine", ()=>FaChartLine);
parcelHelpers.export(exports, "FaChartPie", ()=>FaChartPie);
parcelHelpers.export(exports, "FaCheckCircle", ()=>FaCheckCircle);
parcelHelpers.export(exports, "FaCheckDouble", ()=>FaCheckDouble);
parcelHelpers.export(exports, "FaCheckSquare", ()=>FaCheckSquare);
parcelHelpers.export(exports, "FaCheck", ()=>FaCheck);
parcelHelpers.export(exports, "FaCheese", ()=>FaCheese);
parcelHelpers.export(exports, "FaChessBishop", ()=>FaChessBishop);
parcelHelpers.export(exports, "FaChessBoard", ()=>FaChessBoard);
parcelHelpers.export(exports, "FaChessKing", ()=>FaChessKing);
parcelHelpers.export(exports, "FaChessKnight", ()=>FaChessKnight);
parcelHelpers.export(exports, "FaChessPawn", ()=>FaChessPawn);
parcelHelpers.export(exports, "FaChessQueen", ()=>FaChessQueen);
parcelHelpers.export(exports, "FaChessRook", ()=>FaChessRook);
parcelHelpers.export(exports, "FaChess", ()=>FaChess);
parcelHelpers.export(exports, "FaChevronCircleDown", ()=>FaChevronCircleDown);
parcelHelpers.export(exports, "FaChevronCircleLeft", ()=>FaChevronCircleLeft);
parcelHelpers.export(exports, "FaChevronCircleRight", ()=>FaChevronCircleRight);
parcelHelpers.export(exports, "FaChevronCircleUp", ()=>FaChevronCircleUp);
parcelHelpers.export(exports, "FaChevronDown", ()=>FaChevronDown);
parcelHelpers.export(exports, "FaChevronLeft", ()=>FaChevronLeft);
parcelHelpers.export(exports, "FaChevronRight", ()=>FaChevronRight);
parcelHelpers.export(exports, "FaChevronUp", ()=>FaChevronUp);
parcelHelpers.export(exports, "FaChild", ()=>FaChild);
parcelHelpers.export(exports, "FaChurch", ()=>FaChurch);
parcelHelpers.export(exports, "FaCircleNotch", ()=>FaCircleNotch);
parcelHelpers.export(exports, "FaCircle", ()=>FaCircle);
parcelHelpers.export(exports, "FaCity", ()=>FaCity);
parcelHelpers.export(exports, "FaClinicMedical", ()=>FaClinicMedical);
parcelHelpers.export(exports, "FaClipboardCheck", ()=>FaClipboardCheck);
parcelHelpers.export(exports, "FaClipboardList", ()=>FaClipboardList);
parcelHelpers.export(exports, "FaClipboard", ()=>FaClipboard);
parcelHelpers.export(exports, "FaClock", ()=>FaClock);
parcelHelpers.export(exports, "FaClone", ()=>FaClone);
parcelHelpers.export(exports, "FaClosedCaptioning", ()=>FaClosedCaptioning);
parcelHelpers.export(exports, "FaCloudDownloadAlt", ()=>FaCloudDownloadAlt);
parcelHelpers.export(exports, "FaCloudMeatball", ()=>FaCloudMeatball);
parcelHelpers.export(exports, "FaCloudMoonRain", ()=>FaCloudMoonRain);
parcelHelpers.export(exports, "FaCloudMoon", ()=>FaCloudMoon);
parcelHelpers.export(exports, "FaCloudRain", ()=>FaCloudRain);
parcelHelpers.export(exports, "FaCloudShowersHeavy", ()=>FaCloudShowersHeavy);
parcelHelpers.export(exports, "FaCloudSunRain", ()=>FaCloudSunRain);
parcelHelpers.export(exports, "FaCloudSun", ()=>FaCloudSun);
parcelHelpers.export(exports, "FaCloudUploadAlt", ()=>FaCloudUploadAlt);
parcelHelpers.export(exports, "FaCloud", ()=>FaCloud);
parcelHelpers.export(exports, "FaCocktail", ()=>FaCocktail);
parcelHelpers.export(exports, "FaCodeBranch", ()=>FaCodeBranch);
parcelHelpers.export(exports, "FaCode", ()=>FaCode);
parcelHelpers.export(exports, "FaCoffee", ()=>FaCoffee);
parcelHelpers.export(exports, "FaCog", ()=>FaCog);
parcelHelpers.export(exports, "FaCogs", ()=>FaCogs);
parcelHelpers.export(exports, "FaCoins", ()=>FaCoins);
parcelHelpers.export(exports, "FaColumns", ()=>FaColumns);
parcelHelpers.export(exports, "FaCommentAlt", ()=>FaCommentAlt);
parcelHelpers.export(exports, "FaCommentDollar", ()=>FaCommentDollar);
parcelHelpers.export(exports, "FaCommentDots", ()=>FaCommentDots);
parcelHelpers.export(exports, "FaCommentMedical", ()=>FaCommentMedical);
parcelHelpers.export(exports, "FaCommentSlash", ()=>FaCommentSlash);
parcelHelpers.export(exports, "FaComment", ()=>FaComment);
parcelHelpers.export(exports, "FaCommentsDollar", ()=>FaCommentsDollar);
parcelHelpers.export(exports, "FaComments", ()=>FaComments);
parcelHelpers.export(exports, "FaCompactDisc", ()=>FaCompactDisc);
parcelHelpers.export(exports, "FaCompass", ()=>FaCompass);
parcelHelpers.export(exports, "FaCompressAlt", ()=>FaCompressAlt);
parcelHelpers.export(exports, "FaCompressArrowsAlt", ()=>FaCompressArrowsAlt);
parcelHelpers.export(exports, "FaCompress", ()=>FaCompress);
parcelHelpers.export(exports, "FaConciergeBell", ()=>FaConciergeBell);
parcelHelpers.export(exports, "FaCookieBite", ()=>FaCookieBite);
parcelHelpers.export(exports, "FaCookie", ()=>FaCookie);
parcelHelpers.export(exports, "FaCopy", ()=>FaCopy);
parcelHelpers.export(exports, "FaCopyright", ()=>FaCopyright);
parcelHelpers.export(exports, "FaCouch", ()=>FaCouch);
parcelHelpers.export(exports, "FaCreditCard", ()=>FaCreditCard);
parcelHelpers.export(exports, "FaCropAlt", ()=>FaCropAlt);
parcelHelpers.export(exports, "FaCrop", ()=>FaCrop);
parcelHelpers.export(exports, "FaCross", ()=>FaCross);
parcelHelpers.export(exports, "FaCrosshairs", ()=>FaCrosshairs);
parcelHelpers.export(exports, "FaCrow", ()=>FaCrow);
parcelHelpers.export(exports, "FaCrown", ()=>FaCrown);
parcelHelpers.export(exports, "FaCrutch", ()=>FaCrutch);
parcelHelpers.export(exports, "FaCube", ()=>FaCube);
parcelHelpers.export(exports, "FaCubes", ()=>FaCubes);
parcelHelpers.export(exports, "FaCut", ()=>FaCut);
parcelHelpers.export(exports, "FaDatabase", ()=>FaDatabase);
parcelHelpers.export(exports, "FaDeaf", ()=>FaDeaf);
parcelHelpers.export(exports, "FaDemocrat", ()=>FaDemocrat);
parcelHelpers.export(exports, "FaDesktop", ()=>FaDesktop);
parcelHelpers.export(exports, "FaDharmachakra", ()=>FaDharmachakra);
parcelHelpers.export(exports, "FaDiagnoses", ()=>FaDiagnoses);
parcelHelpers.export(exports, "FaDiceD20", ()=>FaDiceD20);
parcelHelpers.export(exports, "FaDiceD6", ()=>FaDiceD6);
parcelHelpers.export(exports, "FaDiceFive", ()=>FaDiceFive);
parcelHelpers.export(exports, "FaDiceFour", ()=>FaDiceFour);
parcelHelpers.export(exports, "FaDiceOne", ()=>FaDiceOne);
parcelHelpers.export(exports, "FaDiceSix", ()=>FaDiceSix);
parcelHelpers.export(exports, "FaDiceThree", ()=>FaDiceThree);
parcelHelpers.export(exports, "FaDiceTwo", ()=>FaDiceTwo);
parcelHelpers.export(exports, "FaDice", ()=>FaDice);
parcelHelpers.export(exports, "FaDigitalTachograph", ()=>FaDigitalTachograph);
parcelHelpers.export(exports, "FaDirections", ()=>FaDirections);
parcelHelpers.export(exports, "FaDisease", ()=>FaDisease);
parcelHelpers.export(exports, "FaDivide", ()=>FaDivide);
parcelHelpers.export(exports, "FaDizzy", ()=>FaDizzy);
parcelHelpers.export(exports, "FaDna", ()=>FaDna);
parcelHelpers.export(exports, "FaDog", ()=>FaDog);
parcelHelpers.export(exports, "FaDollarSign", ()=>FaDollarSign);
parcelHelpers.export(exports, "FaDollyFlatbed", ()=>FaDollyFlatbed);
parcelHelpers.export(exports, "FaDolly", ()=>FaDolly);
parcelHelpers.export(exports, "FaDonate", ()=>FaDonate);
parcelHelpers.export(exports, "FaDoorClosed", ()=>FaDoorClosed);
parcelHelpers.export(exports, "FaDoorOpen", ()=>FaDoorOpen);
parcelHelpers.export(exports, "FaDotCircle", ()=>FaDotCircle);
parcelHelpers.export(exports, "FaDove", ()=>FaDove);
parcelHelpers.export(exports, "FaDownload", ()=>FaDownload);
parcelHelpers.export(exports, "FaDraftingCompass", ()=>FaDraftingCompass);
parcelHelpers.export(exports, "FaDragon", ()=>FaDragon);
parcelHelpers.export(exports, "FaDrawPolygon", ()=>FaDrawPolygon);
parcelHelpers.export(exports, "FaDrumSteelpan", ()=>FaDrumSteelpan);
parcelHelpers.export(exports, "FaDrum", ()=>FaDrum);
parcelHelpers.export(exports, "FaDrumstickBite", ()=>FaDrumstickBite);
parcelHelpers.export(exports, "FaDumbbell", ()=>FaDumbbell);
parcelHelpers.export(exports, "FaDumpsterFire", ()=>FaDumpsterFire);
parcelHelpers.export(exports, "FaDumpster", ()=>FaDumpster);
parcelHelpers.export(exports, "FaDungeon", ()=>FaDungeon);
parcelHelpers.export(exports, "FaEdit", ()=>FaEdit);
parcelHelpers.export(exports, "FaEgg", ()=>FaEgg);
parcelHelpers.export(exports, "FaEject", ()=>FaEject);
parcelHelpers.export(exports, "FaEllipsisH", ()=>FaEllipsisH);
parcelHelpers.export(exports, "FaEllipsisV", ()=>FaEllipsisV);
parcelHelpers.export(exports, "FaEnvelopeOpenText", ()=>FaEnvelopeOpenText);
parcelHelpers.export(exports, "FaEnvelopeOpen", ()=>FaEnvelopeOpen);
parcelHelpers.export(exports, "FaEnvelopeSquare", ()=>FaEnvelopeSquare);
parcelHelpers.export(exports, "FaEnvelope", ()=>FaEnvelope);
parcelHelpers.export(exports, "FaEquals", ()=>FaEquals);
parcelHelpers.export(exports, "FaEraser", ()=>FaEraser);
parcelHelpers.export(exports, "FaEthernet", ()=>FaEthernet);
parcelHelpers.export(exports, "FaEuroSign", ()=>FaEuroSign);
parcelHelpers.export(exports, "FaExchangeAlt", ()=>FaExchangeAlt);
parcelHelpers.export(exports, "FaExclamationCircle", ()=>FaExclamationCircle);
parcelHelpers.export(exports, "FaExclamationTriangle", ()=>FaExclamationTriangle);
parcelHelpers.export(exports, "FaExclamation", ()=>FaExclamation);
parcelHelpers.export(exports, "FaExpandAlt", ()=>FaExpandAlt);
parcelHelpers.export(exports, "FaExpandArrowsAlt", ()=>FaExpandArrowsAlt);
parcelHelpers.export(exports, "FaExpand", ()=>FaExpand);
parcelHelpers.export(exports, "FaExternalLinkAlt", ()=>FaExternalLinkAlt);
parcelHelpers.export(exports, "FaExternalLinkSquareAlt", ()=>FaExternalLinkSquareAlt);
parcelHelpers.export(exports, "FaEyeDropper", ()=>FaEyeDropper);
parcelHelpers.export(exports, "FaEyeSlash", ()=>FaEyeSlash);
parcelHelpers.export(exports, "FaEye", ()=>FaEye);
parcelHelpers.export(exports, "FaFan", ()=>FaFan);
parcelHelpers.export(exports, "FaFastBackward", ()=>FaFastBackward);
parcelHelpers.export(exports, "FaFastForward", ()=>FaFastForward);
parcelHelpers.export(exports, "FaFaucet", ()=>FaFaucet);
parcelHelpers.export(exports, "FaFax", ()=>FaFax);
parcelHelpers.export(exports, "FaFeatherAlt", ()=>FaFeatherAlt);
parcelHelpers.export(exports, "FaFeather", ()=>FaFeather);
parcelHelpers.export(exports, "FaFemale", ()=>FaFemale);
parcelHelpers.export(exports, "FaFighterJet", ()=>FaFighterJet);
parcelHelpers.export(exports, "FaFileAlt", ()=>FaFileAlt);
parcelHelpers.export(exports, "FaFileArchive", ()=>FaFileArchive);
parcelHelpers.export(exports, "FaFileAudio", ()=>FaFileAudio);
parcelHelpers.export(exports, "FaFileCode", ()=>FaFileCode);
parcelHelpers.export(exports, "FaFileContract", ()=>FaFileContract);
parcelHelpers.export(exports, "FaFileCsv", ()=>FaFileCsv);
parcelHelpers.export(exports, "FaFileDownload", ()=>FaFileDownload);
parcelHelpers.export(exports, "FaFileExcel", ()=>FaFileExcel);
parcelHelpers.export(exports, "FaFileExport", ()=>FaFileExport);
parcelHelpers.export(exports, "FaFileImage", ()=>FaFileImage);
parcelHelpers.export(exports, "FaFileImport", ()=>FaFileImport);
parcelHelpers.export(exports, "FaFileInvoiceDollar", ()=>FaFileInvoiceDollar);
parcelHelpers.export(exports, "FaFileInvoice", ()=>FaFileInvoice);
parcelHelpers.export(exports, "FaFileMedicalAlt", ()=>FaFileMedicalAlt);
parcelHelpers.export(exports, "FaFileMedical", ()=>FaFileMedical);
parcelHelpers.export(exports, "FaFilePdf", ()=>FaFilePdf);
parcelHelpers.export(exports, "FaFilePowerpoint", ()=>FaFilePowerpoint);
parcelHelpers.export(exports, "FaFilePrescription", ()=>FaFilePrescription);
parcelHelpers.export(exports, "FaFileSignature", ()=>FaFileSignature);
parcelHelpers.export(exports, "FaFileUpload", ()=>FaFileUpload);
parcelHelpers.export(exports, "FaFileVideo", ()=>FaFileVideo);
parcelHelpers.export(exports, "FaFileWord", ()=>FaFileWord);
parcelHelpers.export(exports, "FaFile", ()=>FaFile);
parcelHelpers.export(exports, "FaFillDrip", ()=>FaFillDrip);
parcelHelpers.export(exports, "FaFill", ()=>FaFill);
parcelHelpers.export(exports, "FaFilm", ()=>FaFilm);
parcelHelpers.export(exports, "FaFilter", ()=>FaFilter);
parcelHelpers.export(exports, "FaFingerprint", ()=>FaFingerprint);
parcelHelpers.export(exports, "FaFireAlt", ()=>FaFireAlt);
parcelHelpers.export(exports, "FaFireExtinguisher", ()=>FaFireExtinguisher);
parcelHelpers.export(exports, "FaFire", ()=>FaFire);
parcelHelpers.export(exports, "FaFirstAid", ()=>FaFirstAid);
parcelHelpers.export(exports, "FaFish", ()=>FaFish);
parcelHelpers.export(exports, "FaFistRaised", ()=>FaFistRaised);
parcelHelpers.export(exports, "FaFlagCheckered", ()=>FaFlagCheckered);
parcelHelpers.export(exports, "FaFlagUsa", ()=>FaFlagUsa);
parcelHelpers.export(exports, "FaFlag", ()=>FaFlag);
parcelHelpers.export(exports, "FaFlask", ()=>FaFlask);
parcelHelpers.export(exports, "FaFlushed", ()=>FaFlushed);
parcelHelpers.export(exports, "FaFolderMinus", ()=>FaFolderMinus);
parcelHelpers.export(exports, "FaFolderOpen", ()=>FaFolderOpen);
parcelHelpers.export(exports, "FaFolderPlus", ()=>FaFolderPlus);
parcelHelpers.export(exports, "FaFolder", ()=>FaFolder);
parcelHelpers.export(exports, "FaFont", ()=>FaFont);
parcelHelpers.export(exports, "FaFootballBall", ()=>FaFootballBall);
parcelHelpers.export(exports, "FaForward", ()=>FaForward);
parcelHelpers.export(exports, "FaFrog", ()=>FaFrog);
parcelHelpers.export(exports, "FaFrownOpen", ()=>FaFrownOpen);
parcelHelpers.export(exports, "FaFrown", ()=>FaFrown);
parcelHelpers.export(exports, "FaFunnelDollar", ()=>FaFunnelDollar);
parcelHelpers.export(exports, "FaFutbol", ()=>FaFutbol);
parcelHelpers.export(exports, "FaGamepad", ()=>FaGamepad);
parcelHelpers.export(exports, "FaGasPump", ()=>FaGasPump);
parcelHelpers.export(exports, "FaGavel", ()=>FaGavel);
parcelHelpers.export(exports, "FaGem", ()=>FaGem);
parcelHelpers.export(exports, "FaGenderless", ()=>FaGenderless);
parcelHelpers.export(exports, "FaGhost", ()=>FaGhost);
parcelHelpers.export(exports, "FaGift", ()=>FaGift);
parcelHelpers.export(exports, "FaGifts", ()=>FaGifts);
parcelHelpers.export(exports, "FaGlassCheers", ()=>FaGlassCheers);
parcelHelpers.export(exports, "FaGlassMartiniAlt", ()=>FaGlassMartiniAlt);
parcelHelpers.export(exports, "FaGlassMartini", ()=>FaGlassMartini);
parcelHelpers.export(exports, "FaGlassWhiskey", ()=>FaGlassWhiskey);
parcelHelpers.export(exports, "FaGlasses", ()=>FaGlasses);
parcelHelpers.export(exports, "FaGlobeAfrica", ()=>FaGlobeAfrica);
parcelHelpers.export(exports, "FaGlobeAmericas", ()=>FaGlobeAmericas);
parcelHelpers.export(exports, "FaGlobeAsia", ()=>FaGlobeAsia);
parcelHelpers.export(exports, "FaGlobeEurope", ()=>FaGlobeEurope);
parcelHelpers.export(exports, "FaGlobe", ()=>FaGlobe);
parcelHelpers.export(exports, "FaGolfBall", ()=>FaGolfBall);
parcelHelpers.export(exports, "FaGopuram", ()=>FaGopuram);
parcelHelpers.export(exports, "FaGraduationCap", ()=>FaGraduationCap);
parcelHelpers.export(exports, "FaGreaterThanEqual", ()=>FaGreaterThanEqual);
parcelHelpers.export(exports, "FaGreaterThan", ()=>FaGreaterThan);
parcelHelpers.export(exports, "FaGrimace", ()=>FaGrimace);
parcelHelpers.export(exports, "FaGrinAlt", ()=>FaGrinAlt);
parcelHelpers.export(exports, "FaGrinBeamSweat", ()=>FaGrinBeamSweat);
parcelHelpers.export(exports, "FaGrinBeam", ()=>FaGrinBeam);
parcelHelpers.export(exports, "FaGrinHearts", ()=>FaGrinHearts);
parcelHelpers.export(exports, "FaGrinSquintTears", ()=>FaGrinSquintTears);
parcelHelpers.export(exports, "FaGrinSquint", ()=>FaGrinSquint);
parcelHelpers.export(exports, "FaGrinStars", ()=>FaGrinStars);
parcelHelpers.export(exports, "FaGrinTears", ()=>FaGrinTears);
parcelHelpers.export(exports, "FaGrinTongueSquint", ()=>FaGrinTongueSquint);
parcelHelpers.export(exports, "FaGrinTongueWink", ()=>FaGrinTongueWink);
parcelHelpers.export(exports, "FaGrinTongue", ()=>FaGrinTongue);
parcelHelpers.export(exports, "FaGrinWink", ()=>FaGrinWink);
parcelHelpers.export(exports, "FaGrin", ()=>FaGrin);
parcelHelpers.export(exports, "FaGripHorizontal", ()=>FaGripHorizontal);
parcelHelpers.export(exports, "FaGripLinesVertical", ()=>FaGripLinesVertical);
parcelHelpers.export(exports, "FaGripLines", ()=>FaGripLines);
parcelHelpers.export(exports, "FaGripVertical", ()=>FaGripVertical);
parcelHelpers.export(exports, "FaGuitar", ()=>FaGuitar);
parcelHelpers.export(exports, "FaHSquare", ()=>FaHSquare);
parcelHelpers.export(exports, "FaHamburger", ()=>FaHamburger);
parcelHelpers.export(exports, "FaHammer", ()=>FaHammer);
parcelHelpers.export(exports, "FaHamsa", ()=>FaHamsa);
parcelHelpers.export(exports, "FaHandHoldingHeart", ()=>FaHandHoldingHeart);
parcelHelpers.export(exports, "FaHandHoldingMedical", ()=>FaHandHoldingMedical);
parcelHelpers.export(exports, "FaHandHoldingUsd", ()=>FaHandHoldingUsd);
parcelHelpers.export(exports, "FaHandHoldingWater", ()=>FaHandHoldingWater);
parcelHelpers.export(exports, "FaHandHolding", ()=>FaHandHolding);
parcelHelpers.export(exports, "FaHandLizard", ()=>FaHandLizard);
parcelHelpers.export(exports, "FaHandMiddleFinger", ()=>FaHandMiddleFinger);
parcelHelpers.export(exports, "FaHandPaper", ()=>FaHandPaper);
parcelHelpers.export(exports, "FaHandPeace", ()=>FaHandPeace);
parcelHelpers.export(exports, "FaHandPointDown", ()=>FaHandPointDown);
parcelHelpers.export(exports, "FaHandPointLeft", ()=>FaHandPointLeft);
parcelHelpers.export(exports, "FaHandPointRight", ()=>FaHandPointRight);
parcelHelpers.export(exports, "FaHandPointUp", ()=>FaHandPointUp);
parcelHelpers.export(exports, "FaHandPointer", ()=>FaHandPointer);
parcelHelpers.export(exports, "FaHandRock", ()=>FaHandRock);
parcelHelpers.export(exports, "FaHandScissors", ()=>FaHandScissors);
parcelHelpers.export(exports, "FaHandSparkles", ()=>FaHandSparkles);
parcelHelpers.export(exports, "FaHandSpock", ()=>FaHandSpock);
parcelHelpers.export(exports, "FaHandsHelping", ()=>FaHandsHelping);
parcelHelpers.export(exports, "FaHandsWash", ()=>FaHandsWash);
parcelHelpers.export(exports, "FaHands", ()=>FaHands);
parcelHelpers.export(exports, "FaHandshakeAltSlash", ()=>FaHandshakeAltSlash);
parcelHelpers.export(exports, "FaHandshakeSlash", ()=>FaHandshakeSlash);
parcelHelpers.export(exports, "FaHandshake", ()=>FaHandshake);
parcelHelpers.export(exports, "FaHanukiah", ()=>FaHanukiah);
parcelHelpers.export(exports, "FaHardHat", ()=>FaHardHat);
parcelHelpers.export(exports, "FaHashtag", ()=>FaHashtag);
parcelHelpers.export(exports, "FaHatCowboySide", ()=>FaHatCowboySide);
parcelHelpers.export(exports, "FaHatCowboy", ()=>FaHatCowboy);
parcelHelpers.export(exports, "FaHatWizard", ()=>FaHatWizard);
parcelHelpers.export(exports, "FaHdd", ()=>FaHdd);
parcelHelpers.export(exports, "FaHeadSideCoughSlash", ()=>FaHeadSideCoughSlash);
parcelHelpers.export(exports, "FaHeadSideCough", ()=>FaHeadSideCough);
parcelHelpers.export(exports, "FaHeadSideMask", ()=>FaHeadSideMask);
parcelHelpers.export(exports, "FaHeadSideVirus", ()=>FaHeadSideVirus);
parcelHelpers.export(exports, "FaHeading", ()=>FaHeading);
parcelHelpers.export(exports, "FaHeadphonesAlt", ()=>FaHeadphonesAlt);
parcelHelpers.export(exports, "FaHeadphones", ()=>FaHeadphones);
parcelHelpers.export(exports, "FaHeadset", ()=>FaHeadset);
parcelHelpers.export(exports, "FaHeartBroken", ()=>FaHeartBroken);
parcelHelpers.export(exports, "FaHeart", ()=>FaHeart);
parcelHelpers.export(exports, "FaHeartbeat", ()=>FaHeartbeat);
parcelHelpers.export(exports, "FaHelicopter", ()=>FaHelicopter);
parcelHelpers.export(exports, "FaHighlighter", ()=>FaHighlighter);
parcelHelpers.export(exports, "FaHiking", ()=>FaHiking);
parcelHelpers.export(exports, "FaHippo", ()=>FaHippo);
parcelHelpers.export(exports, "FaHistory", ()=>FaHistory);
parcelHelpers.export(exports, "FaHockeyPuck", ()=>FaHockeyPuck);
parcelHelpers.export(exports, "FaHollyBerry", ()=>FaHollyBerry);
parcelHelpers.export(exports, "FaHome", ()=>FaHome);
parcelHelpers.export(exports, "FaHorseHead", ()=>FaHorseHead);
parcelHelpers.export(exports, "FaHorse", ()=>FaHorse);
parcelHelpers.export(exports, "FaHospitalAlt", ()=>FaHospitalAlt);
parcelHelpers.export(exports, "FaHospitalSymbol", ()=>FaHospitalSymbol);
parcelHelpers.export(exports, "FaHospitalUser", ()=>FaHospitalUser);
parcelHelpers.export(exports, "FaHospital", ()=>FaHospital);
parcelHelpers.export(exports, "FaHotTub", ()=>FaHotTub);
parcelHelpers.export(exports, "FaHotdog", ()=>FaHotdog);
parcelHelpers.export(exports, "FaHotel", ()=>FaHotel);
parcelHelpers.export(exports, "FaHourglassEnd", ()=>FaHourglassEnd);
parcelHelpers.export(exports, "FaHourglassHalf", ()=>FaHourglassHalf);
parcelHelpers.export(exports, "FaHourglassStart", ()=>FaHourglassStart);
parcelHelpers.export(exports, "FaHourglass", ()=>FaHourglass);
parcelHelpers.export(exports, "FaHouseDamage", ()=>FaHouseDamage);
parcelHelpers.export(exports, "FaHouseUser", ()=>FaHouseUser);
parcelHelpers.export(exports, "FaHryvnia", ()=>FaHryvnia);
parcelHelpers.export(exports, "FaICursor", ()=>FaICursor);
parcelHelpers.export(exports, "FaIceCream", ()=>FaIceCream);
parcelHelpers.export(exports, "FaIcicles", ()=>FaIcicles);
parcelHelpers.export(exports, "FaIcons", ()=>FaIcons);
parcelHelpers.export(exports, "FaIdBadge", ()=>FaIdBadge);
parcelHelpers.export(exports, "FaIdCardAlt", ()=>FaIdCardAlt);
parcelHelpers.export(exports, "FaIdCard", ()=>FaIdCard);
parcelHelpers.export(exports, "FaIgloo", ()=>FaIgloo);
parcelHelpers.export(exports, "FaImage", ()=>FaImage);
parcelHelpers.export(exports, "FaImages", ()=>FaImages);
parcelHelpers.export(exports, "FaInbox", ()=>FaInbox);
parcelHelpers.export(exports, "FaIndent", ()=>FaIndent);
parcelHelpers.export(exports, "FaIndustry", ()=>FaIndustry);
parcelHelpers.export(exports, "FaInfinity", ()=>FaInfinity);
parcelHelpers.export(exports, "FaInfoCircle", ()=>FaInfoCircle);
parcelHelpers.export(exports, "FaInfo", ()=>FaInfo);
parcelHelpers.export(exports, "FaItalic", ()=>FaItalic);
parcelHelpers.export(exports, "FaJedi", ()=>FaJedi);
parcelHelpers.export(exports, "FaJoint", ()=>FaJoint);
parcelHelpers.export(exports, "FaJournalWhills", ()=>FaJournalWhills);
parcelHelpers.export(exports, "FaKaaba", ()=>FaKaaba);
parcelHelpers.export(exports, "FaKey", ()=>FaKey);
parcelHelpers.export(exports, "FaKeyboard", ()=>FaKeyboard);
parcelHelpers.export(exports, "FaKhanda", ()=>FaKhanda);
parcelHelpers.export(exports, "FaKissBeam", ()=>FaKissBeam);
parcelHelpers.export(exports, "FaKissWinkHeart", ()=>FaKissWinkHeart);
parcelHelpers.export(exports, "FaKiss", ()=>FaKiss);
parcelHelpers.export(exports, "FaKiwiBird", ()=>FaKiwiBird);
parcelHelpers.export(exports, "FaLandmark", ()=>FaLandmark);
parcelHelpers.export(exports, "FaLanguage", ()=>FaLanguage);
parcelHelpers.export(exports, "FaLaptopCode", ()=>FaLaptopCode);
parcelHelpers.export(exports, "FaLaptopHouse", ()=>FaLaptopHouse);
parcelHelpers.export(exports, "FaLaptopMedical", ()=>FaLaptopMedical);
parcelHelpers.export(exports, "FaLaptop", ()=>FaLaptop);
parcelHelpers.export(exports, "FaLaughBeam", ()=>FaLaughBeam);
parcelHelpers.export(exports, "FaLaughSquint", ()=>FaLaughSquint);
parcelHelpers.export(exports, "FaLaughWink", ()=>FaLaughWink);
parcelHelpers.export(exports, "FaLaugh", ()=>FaLaugh);
parcelHelpers.export(exports, "FaLayerGroup", ()=>FaLayerGroup);
parcelHelpers.export(exports, "FaLeaf", ()=>FaLeaf);
parcelHelpers.export(exports, "FaLemon", ()=>FaLemon);
parcelHelpers.export(exports, "FaLessThanEqual", ()=>FaLessThanEqual);
parcelHelpers.export(exports, "FaLessThan", ()=>FaLessThan);
parcelHelpers.export(exports, "FaLevelDownAlt", ()=>FaLevelDownAlt);
parcelHelpers.export(exports, "FaLevelUpAlt", ()=>FaLevelUpAlt);
parcelHelpers.export(exports, "FaLifeRing", ()=>FaLifeRing);
parcelHelpers.export(exports, "FaLightbulb", ()=>FaLightbulb);
parcelHelpers.export(exports, "FaLink", ()=>FaLink);
parcelHelpers.export(exports, "FaLiraSign", ()=>FaLiraSign);
parcelHelpers.export(exports, "FaListAlt", ()=>FaListAlt);
parcelHelpers.export(exports, "FaListOl", ()=>FaListOl);
parcelHelpers.export(exports, "FaListUl", ()=>FaListUl);
parcelHelpers.export(exports, "FaList", ()=>FaList);
parcelHelpers.export(exports, "FaLocationArrow", ()=>FaLocationArrow);
parcelHelpers.export(exports, "FaLockOpen", ()=>FaLockOpen);
parcelHelpers.export(exports, "FaLock", ()=>FaLock);
parcelHelpers.export(exports, "FaLongArrowAltDown", ()=>FaLongArrowAltDown);
parcelHelpers.export(exports, "FaLongArrowAltLeft", ()=>FaLongArrowAltLeft);
parcelHelpers.export(exports, "FaLongArrowAltRight", ()=>FaLongArrowAltRight);
parcelHelpers.export(exports, "FaLongArrowAltUp", ()=>FaLongArrowAltUp);
parcelHelpers.export(exports, "FaLowVision", ()=>FaLowVision);
parcelHelpers.export(exports, "FaLuggageCart", ()=>FaLuggageCart);
parcelHelpers.export(exports, "FaLungsVirus", ()=>FaLungsVirus);
parcelHelpers.export(exports, "FaLungs", ()=>FaLungs);
parcelHelpers.export(exports, "FaMagic", ()=>FaMagic);
parcelHelpers.export(exports, "FaMagnet", ()=>FaMagnet);
parcelHelpers.export(exports, "FaMailBulk", ()=>FaMailBulk);
parcelHelpers.export(exports, "FaMale", ()=>FaMale);
parcelHelpers.export(exports, "FaMapMarkedAlt", ()=>FaMapMarkedAlt);
parcelHelpers.export(exports, "FaMapMarked", ()=>FaMapMarked);
parcelHelpers.export(exports, "FaMapMarkerAlt", ()=>FaMapMarkerAlt);
parcelHelpers.export(exports, "FaMapMarker", ()=>FaMapMarker);
parcelHelpers.export(exports, "FaMapPin", ()=>FaMapPin);
parcelHelpers.export(exports, "FaMapSigns", ()=>FaMapSigns);
parcelHelpers.export(exports, "FaMap", ()=>FaMap);
parcelHelpers.export(exports, "FaMarker", ()=>FaMarker);
parcelHelpers.export(exports, "FaMarsDouble", ()=>FaMarsDouble);
parcelHelpers.export(exports, "FaMarsStrokeH", ()=>FaMarsStrokeH);
parcelHelpers.export(exports, "FaMarsStrokeV", ()=>FaMarsStrokeV);
parcelHelpers.export(exports, "FaMarsStroke", ()=>FaMarsStroke);
parcelHelpers.export(exports, "FaMars", ()=>FaMars);
parcelHelpers.export(exports, "FaMask", ()=>FaMask);
parcelHelpers.export(exports, "FaMedal", ()=>FaMedal);
parcelHelpers.export(exports, "FaMedkit", ()=>FaMedkit);
parcelHelpers.export(exports, "FaMehBlank", ()=>FaMehBlank);
parcelHelpers.export(exports, "FaMehRollingEyes", ()=>FaMehRollingEyes);
parcelHelpers.export(exports, "FaMeh", ()=>FaMeh);
parcelHelpers.export(exports, "FaMemory", ()=>FaMemory);
parcelHelpers.export(exports, "FaMenorah", ()=>FaMenorah);
parcelHelpers.export(exports, "FaMercury", ()=>FaMercury);
parcelHelpers.export(exports, "FaMeteor", ()=>FaMeteor);
parcelHelpers.export(exports, "FaMicrochip", ()=>FaMicrochip);
parcelHelpers.export(exports, "FaMicrophoneAltSlash", ()=>FaMicrophoneAltSlash);
parcelHelpers.export(exports, "FaMicrophoneAlt", ()=>FaMicrophoneAlt);
parcelHelpers.export(exports, "FaMicrophoneSlash", ()=>FaMicrophoneSlash);
parcelHelpers.export(exports, "FaMicrophone", ()=>FaMicrophone);
parcelHelpers.export(exports, "FaMicroscope", ()=>FaMicroscope);
parcelHelpers.export(exports, "FaMinusCircle", ()=>FaMinusCircle);
parcelHelpers.export(exports, "FaMinusSquare", ()=>FaMinusSquare);
parcelHelpers.export(exports, "FaMinus", ()=>FaMinus);
parcelHelpers.export(exports, "FaMitten", ()=>FaMitten);
parcelHelpers.export(exports, "FaMobileAlt", ()=>FaMobileAlt);
parcelHelpers.export(exports, "FaMobile", ()=>FaMobile);
parcelHelpers.export(exports, "FaMoneyBillAlt", ()=>FaMoneyBillAlt);
parcelHelpers.export(exports, "FaMoneyBillWaveAlt", ()=>FaMoneyBillWaveAlt);
parcelHelpers.export(exports, "FaMoneyBillWave", ()=>FaMoneyBillWave);
parcelHelpers.export(exports, "FaMoneyBill", ()=>FaMoneyBill);
parcelHelpers.export(exports, "FaMoneyCheckAlt", ()=>FaMoneyCheckAlt);
parcelHelpers.export(exports, "FaMoneyCheck", ()=>FaMoneyCheck);
parcelHelpers.export(exports, "FaMonument", ()=>FaMonument);
parcelHelpers.export(exports, "FaMoon", ()=>FaMoon);
parcelHelpers.export(exports, "FaMortarPestle", ()=>FaMortarPestle);
parcelHelpers.export(exports, "FaMosque", ()=>FaMosque);
parcelHelpers.export(exports, "FaMotorcycle", ()=>FaMotorcycle);
parcelHelpers.export(exports, "FaMountain", ()=>FaMountain);
parcelHelpers.export(exports, "FaMousePointer", ()=>FaMousePointer);
parcelHelpers.export(exports, "FaMouse", ()=>FaMouse);
parcelHelpers.export(exports, "FaMugHot", ()=>FaMugHot);
parcelHelpers.export(exports, "FaMusic", ()=>FaMusic);
parcelHelpers.export(exports, "FaNetworkWired", ()=>FaNetworkWired);
parcelHelpers.export(exports, "FaNeuter", ()=>FaNeuter);
parcelHelpers.export(exports, "FaNewspaper", ()=>FaNewspaper);
parcelHelpers.export(exports, "FaNotEqual", ()=>FaNotEqual);
parcelHelpers.export(exports, "FaNotesMedical", ()=>FaNotesMedical);
parcelHelpers.export(exports, "FaObjectGroup", ()=>FaObjectGroup);
parcelHelpers.export(exports, "FaObjectUngroup", ()=>FaObjectUngroup);
parcelHelpers.export(exports, "FaOilCan", ()=>FaOilCan);
parcelHelpers.export(exports, "FaOm", ()=>FaOm);
parcelHelpers.export(exports, "FaOtter", ()=>FaOtter);
parcelHelpers.export(exports, "FaOutdent", ()=>FaOutdent);
parcelHelpers.export(exports, "FaPager", ()=>FaPager);
parcelHelpers.export(exports, "FaPaintBrush", ()=>FaPaintBrush);
parcelHelpers.export(exports, "FaPaintRoller", ()=>FaPaintRoller);
parcelHelpers.export(exports, "FaPalette", ()=>FaPalette);
parcelHelpers.export(exports, "FaPallet", ()=>FaPallet);
parcelHelpers.export(exports, "FaPaperPlane", ()=>FaPaperPlane);
parcelHelpers.export(exports, "FaPaperclip", ()=>FaPaperclip);
parcelHelpers.export(exports, "FaParachuteBox", ()=>FaParachuteBox);
parcelHelpers.export(exports, "FaParagraph", ()=>FaParagraph);
parcelHelpers.export(exports, "FaParking", ()=>FaParking);
parcelHelpers.export(exports, "FaPassport", ()=>FaPassport);
parcelHelpers.export(exports, "FaPastafarianism", ()=>FaPastafarianism);
parcelHelpers.export(exports, "FaPaste", ()=>FaPaste);
parcelHelpers.export(exports, "FaPauseCircle", ()=>FaPauseCircle);
parcelHelpers.export(exports, "FaPause", ()=>FaPause);
parcelHelpers.export(exports, "FaPaw", ()=>FaPaw);
parcelHelpers.export(exports, "FaPeace", ()=>FaPeace);
parcelHelpers.export(exports, "FaPenAlt", ()=>FaPenAlt);
parcelHelpers.export(exports, "FaPenFancy", ()=>FaPenFancy);
parcelHelpers.export(exports, "FaPenNib", ()=>FaPenNib);
parcelHelpers.export(exports, "FaPenSquare", ()=>FaPenSquare);
parcelHelpers.export(exports, "FaPen", ()=>FaPen);
parcelHelpers.export(exports, "FaPencilAlt", ()=>FaPencilAlt);
parcelHelpers.export(exports, "FaPencilRuler", ()=>FaPencilRuler);
parcelHelpers.export(exports, "FaPeopleArrows", ()=>FaPeopleArrows);
parcelHelpers.export(exports, "FaPeopleCarry", ()=>FaPeopleCarry);
parcelHelpers.export(exports, "FaPepperHot", ()=>FaPepperHot);
parcelHelpers.export(exports, "FaPercent", ()=>FaPercent);
parcelHelpers.export(exports, "FaPercentage", ()=>FaPercentage);
parcelHelpers.export(exports, "FaPersonBooth", ()=>FaPersonBooth);
parcelHelpers.export(exports, "FaPhoneAlt", ()=>FaPhoneAlt);
parcelHelpers.export(exports, "FaPhoneSlash", ()=>FaPhoneSlash);
parcelHelpers.export(exports, "FaPhoneSquareAlt", ()=>FaPhoneSquareAlt);
parcelHelpers.export(exports, "FaPhoneSquare", ()=>FaPhoneSquare);
parcelHelpers.export(exports, "FaPhoneVolume", ()=>FaPhoneVolume);
parcelHelpers.export(exports, "FaPhone", ()=>FaPhone);
parcelHelpers.export(exports, "FaPhotoVideo", ()=>FaPhotoVideo);
parcelHelpers.export(exports, "FaPiggyBank", ()=>FaPiggyBank);
parcelHelpers.export(exports, "FaPills", ()=>FaPills);
parcelHelpers.export(exports, "FaPizzaSlice", ()=>FaPizzaSlice);
parcelHelpers.export(exports, "FaPlaceOfWorship", ()=>FaPlaceOfWorship);
parcelHelpers.export(exports, "FaPlaneArrival", ()=>FaPlaneArrival);
parcelHelpers.export(exports, "FaPlaneDeparture", ()=>FaPlaneDeparture);
parcelHelpers.export(exports, "FaPlaneSlash", ()=>FaPlaneSlash);
parcelHelpers.export(exports, "FaPlane", ()=>FaPlane);
parcelHelpers.export(exports, "FaPlayCircle", ()=>FaPlayCircle);
parcelHelpers.export(exports, "FaPlay", ()=>FaPlay);
parcelHelpers.export(exports, "FaPlug", ()=>FaPlug);
parcelHelpers.export(exports, "FaPlusCircle", ()=>FaPlusCircle);
parcelHelpers.export(exports, "FaPlusSquare", ()=>FaPlusSquare);
parcelHelpers.export(exports, "FaPlus", ()=>FaPlus);
parcelHelpers.export(exports, "FaPodcast", ()=>FaPodcast);
parcelHelpers.export(exports, "FaPollH", ()=>FaPollH);
parcelHelpers.export(exports, "FaPoll", ()=>FaPoll);
parcelHelpers.export(exports, "FaPooStorm", ()=>FaPooStorm);
parcelHelpers.export(exports, "FaPoo", ()=>FaPoo);
parcelHelpers.export(exports, "FaPoop", ()=>FaPoop);
parcelHelpers.export(exports, "FaPortrait", ()=>FaPortrait);
parcelHelpers.export(exports, "FaPoundSign", ()=>FaPoundSign);
parcelHelpers.export(exports, "FaPowerOff", ()=>FaPowerOff);
parcelHelpers.export(exports, "FaPray", ()=>FaPray);
parcelHelpers.export(exports, "FaPrayingHands", ()=>FaPrayingHands);
parcelHelpers.export(exports, "FaPrescriptionBottleAlt", ()=>FaPrescriptionBottleAlt);
parcelHelpers.export(exports, "FaPrescriptionBottle", ()=>FaPrescriptionBottle);
parcelHelpers.export(exports, "FaPrescription", ()=>FaPrescription);
parcelHelpers.export(exports, "FaPrint", ()=>FaPrint);
parcelHelpers.export(exports, "FaProcedures", ()=>FaProcedures);
parcelHelpers.export(exports, "FaProjectDiagram", ()=>FaProjectDiagram);
parcelHelpers.export(exports, "FaPumpMedical", ()=>FaPumpMedical);
parcelHelpers.export(exports, "FaPumpSoap", ()=>FaPumpSoap);
parcelHelpers.export(exports, "FaPuzzlePiece", ()=>FaPuzzlePiece);
parcelHelpers.export(exports, "FaQrcode", ()=>FaQrcode);
parcelHelpers.export(exports, "FaQuestionCircle", ()=>FaQuestionCircle);
parcelHelpers.export(exports, "FaQuestion", ()=>FaQuestion);
parcelHelpers.export(exports, "FaQuidditch", ()=>FaQuidditch);
parcelHelpers.export(exports, "FaQuoteLeft", ()=>FaQuoteLeft);
parcelHelpers.export(exports, "FaQuoteRight", ()=>FaQuoteRight);
parcelHelpers.export(exports, "FaQuran", ()=>FaQuran);
parcelHelpers.export(exports, "FaRadiationAlt", ()=>FaRadiationAlt);
parcelHelpers.export(exports, "FaRadiation", ()=>FaRadiation);
parcelHelpers.export(exports, "FaRainbow", ()=>FaRainbow);
parcelHelpers.export(exports, "FaRandom", ()=>FaRandom);
parcelHelpers.export(exports, "FaReceipt", ()=>FaReceipt);
parcelHelpers.export(exports, "FaRecordVinyl", ()=>FaRecordVinyl);
parcelHelpers.export(exports, "FaRecycle", ()=>FaRecycle);
parcelHelpers.export(exports, "FaRedoAlt", ()=>FaRedoAlt);
parcelHelpers.export(exports, "FaRedo", ()=>FaRedo);
parcelHelpers.export(exports, "FaRegistered", ()=>FaRegistered);
parcelHelpers.export(exports, "FaRemoveFormat", ()=>FaRemoveFormat);
parcelHelpers.export(exports, "FaReplyAll", ()=>FaReplyAll);
parcelHelpers.export(exports, "FaReply", ()=>FaReply);
parcelHelpers.export(exports, "FaRepublican", ()=>FaRepublican);
parcelHelpers.export(exports, "FaRestroom", ()=>FaRestroom);
parcelHelpers.export(exports, "FaRetweet", ()=>FaRetweet);
parcelHelpers.export(exports, "FaRibbon", ()=>FaRibbon);
parcelHelpers.export(exports, "FaRing", ()=>FaRing);
parcelHelpers.export(exports, "FaRoad", ()=>FaRoad);
parcelHelpers.export(exports, "FaRobot", ()=>FaRobot);
parcelHelpers.export(exports, "FaRocket", ()=>FaRocket);
parcelHelpers.export(exports, "FaRoute", ()=>FaRoute);
parcelHelpers.export(exports, "FaRssSquare", ()=>FaRssSquare);
parcelHelpers.export(exports, "FaRss", ()=>FaRss);
parcelHelpers.export(exports, "FaRubleSign", ()=>FaRubleSign);
parcelHelpers.export(exports, "FaRulerCombined", ()=>FaRulerCombined);
parcelHelpers.export(exports, "FaRulerHorizontal", ()=>FaRulerHorizontal);
parcelHelpers.export(exports, "FaRulerVertical", ()=>FaRulerVertical);
parcelHelpers.export(exports, "FaRuler", ()=>FaRuler);
parcelHelpers.export(exports, "FaRunning", ()=>FaRunning);
parcelHelpers.export(exports, "FaRupeeSign", ()=>FaRupeeSign);
parcelHelpers.export(exports, "FaSadCry", ()=>FaSadCry);
parcelHelpers.export(exports, "FaSadTear", ()=>FaSadTear);
parcelHelpers.export(exports, "FaSatelliteDish", ()=>FaSatelliteDish);
parcelHelpers.export(exports, "FaSatellite", ()=>FaSatellite);
parcelHelpers.export(exports, "FaSave", ()=>FaSave);
parcelHelpers.export(exports, "FaSchool", ()=>FaSchool);
parcelHelpers.export(exports, "FaScrewdriver", ()=>FaScrewdriver);
parcelHelpers.export(exports, "FaScroll", ()=>FaScroll);
parcelHelpers.export(exports, "FaSdCard", ()=>FaSdCard);
parcelHelpers.export(exports, "FaSearchDollar", ()=>FaSearchDollar);
parcelHelpers.export(exports, "FaSearchLocation", ()=>FaSearchLocation);
parcelHelpers.export(exports, "FaSearchMinus", ()=>FaSearchMinus);
parcelHelpers.export(exports, "FaSearchPlus", ()=>FaSearchPlus);
parcelHelpers.export(exports, "FaSearch", ()=>FaSearch);
parcelHelpers.export(exports, "FaSeedling", ()=>FaSeedling);
parcelHelpers.export(exports, "FaServer", ()=>FaServer);
parcelHelpers.export(exports, "FaShapes", ()=>FaShapes);
parcelHelpers.export(exports, "FaShareAltSquare", ()=>FaShareAltSquare);
parcelHelpers.export(exports, "FaShareAlt", ()=>FaShareAlt);
parcelHelpers.export(exports, "FaShareSquare", ()=>FaShareSquare);
parcelHelpers.export(exports, "FaShare", ()=>FaShare);
parcelHelpers.export(exports, "FaShekelSign", ()=>FaShekelSign);
parcelHelpers.export(exports, "FaShieldAlt", ()=>FaShieldAlt);
parcelHelpers.export(exports, "FaShieldVirus", ()=>FaShieldVirus);
parcelHelpers.export(exports, "FaShip", ()=>FaShip);
parcelHelpers.export(exports, "FaShippingFast", ()=>FaShippingFast);
parcelHelpers.export(exports, "FaShoePrints", ()=>FaShoePrints);
parcelHelpers.export(exports, "FaShoppingBag", ()=>FaShoppingBag);
parcelHelpers.export(exports, "FaShoppingBasket", ()=>FaShoppingBasket);
parcelHelpers.export(exports, "FaShoppingCart", ()=>FaShoppingCart);
parcelHelpers.export(exports, "FaShower", ()=>FaShower);
parcelHelpers.export(exports, "FaShuttleVan", ()=>FaShuttleVan);
parcelHelpers.export(exports, "FaSignInAlt", ()=>FaSignInAlt);
parcelHelpers.export(exports, "FaSignLanguage", ()=>FaSignLanguage);
parcelHelpers.export(exports, "FaSignOutAlt", ()=>FaSignOutAlt);
parcelHelpers.export(exports, "FaSign", ()=>FaSign);
parcelHelpers.export(exports, "FaSignal", ()=>FaSignal);
parcelHelpers.export(exports, "FaSignature", ()=>FaSignature);
parcelHelpers.export(exports, "FaSimCard", ()=>FaSimCard);
parcelHelpers.export(exports, "FaSink", ()=>FaSink);
parcelHelpers.export(exports, "FaSitemap", ()=>FaSitemap);
parcelHelpers.export(exports, "FaSkating", ()=>FaSkating);
parcelHelpers.export(exports, "FaSkiingNordic", ()=>FaSkiingNordic);
parcelHelpers.export(exports, "FaSkiing", ()=>FaSkiing);
parcelHelpers.export(exports, "FaSkullCrossbones", ()=>FaSkullCrossbones);
parcelHelpers.export(exports, "FaSkull", ()=>FaSkull);
parcelHelpers.export(exports, "FaSlash", ()=>FaSlash);
parcelHelpers.export(exports, "FaSleigh", ()=>FaSleigh);
parcelHelpers.export(exports, "FaSlidersH", ()=>FaSlidersH);
parcelHelpers.export(exports, "FaSmileBeam", ()=>FaSmileBeam);
parcelHelpers.export(exports, "FaSmileWink", ()=>FaSmileWink);
parcelHelpers.export(exports, "FaSmile", ()=>FaSmile);
parcelHelpers.export(exports, "FaSmog", ()=>FaSmog);
parcelHelpers.export(exports, "FaSmokingBan", ()=>FaSmokingBan);
parcelHelpers.export(exports, "FaSmoking", ()=>FaSmoking);
parcelHelpers.export(exports, "FaSms", ()=>FaSms);
parcelHelpers.export(exports, "FaSnowboarding", ()=>FaSnowboarding);
parcelHelpers.export(exports, "FaSnowflake", ()=>FaSnowflake);
parcelHelpers.export(exports, "FaSnowman", ()=>FaSnowman);
parcelHelpers.export(exports, "FaSnowplow", ()=>FaSnowplow);
parcelHelpers.export(exports, "FaSoap", ()=>FaSoap);
parcelHelpers.export(exports, "FaSocks", ()=>FaSocks);
parcelHelpers.export(exports, "FaSolarPanel", ()=>FaSolarPanel);
parcelHelpers.export(exports, "FaSortAlphaDownAlt", ()=>FaSortAlphaDownAlt);
parcelHelpers.export(exports, "FaSortAlphaDown", ()=>FaSortAlphaDown);
parcelHelpers.export(exports, "FaSortAlphaUpAlt", ()=>FaSortAlphaUpAlt);
parcelHelpers.export(exports, "FaSortAlphaUp", ()=>FaSortAlphaUp);
parcelHelpers.export(exports, "FaSortAmountDownAlt", ()=>FaSortAmountDownAlt);
parcelHelpers.export(exports, "FaSortAmountDown", ()=>FaSortAmountDown);
parcelHelpers.export(exports, "FaSortAmountUpAlt", ()=>FaSortAmountUpAlt);
parcelHelpers.export(exports, "FaSortAmountUp", ()=>FaSortAmountUp);
parcelHelpers.export(exports, "FaSortDown", ()=>FaSortDown);
parcelHelpers.export(exports, "FaSortNumericDownAlt", ()=>FaSortNumericDownAlt);
parcelHelpers.export(exports, "FaSortNumericDown", ()=>FaSortNumericDown);
parcelHelpers.export(exports, "FaSortNumericUpAlt", ()=>FaSortNumericUpAlt);
parcelHelpers.export(exports, "FaSortNumericUp", ()=>FaSortNumericUp);
parcelHelpers.export(exports, "FaSortUp", ()=>FaSortUp);
parcelHelpers.export(exports, "FaSort", ()=>FaSort);
parcelHelpers.export(exports, "FaSpa", ()=>FaSpa);
parcelHelpers.export(exports, "FaSpaceShuttle", ()=>FaSpaceShuttle);
parcelHelpers.export(exports, "FaSpellCheck", ()=>FaSpellCheck);
parcelHelpers.export(exports, "FaSpider", ()=>FaSpider);
parcelHelpers.export(exports, "FaSpinner", ()=>FaSpinner);
parcelHelpers.export(exports, "FaSplotch", ()=>FaSplotch);
parcelHelpers.export(exports, "FaSprayCan", ()=>FaSprayCan);
parcelHelpers.export(exports, "FaSquareFull", ()=>FaSquareFull);
parcelHelpers.export(exports, "FaSquareRootAlt", ()=>FaSquareRootAlt);
parcelHelpers.export(exports, "FaSquare", ()=>FaSquare);
parcelHelpers.export(exports, "FaStamp", ()=>FaStamp);
parcelHelpers.export(exports, "FaStarAndCrescent", ()=>FaStarAndCrescent);
parcelHelpers.export(exports, "FaStarHalfAlt", ()=>FaStarHalfAlt);
parcelHelpers.export(exports, "FaStarHalf", ()=>FaStarHalf);
parcelHelpers.export(exports, "FaStarOfDavid", ()=>FaStarOfDavid);
parcelHelpers.export(exports, "FaStarOfLife", ()=>FaStarOfLife);
parcelHelpers.export(exports, "FaStar", ()=>FaStar);
parcelHelpers.export(exports, "FaStepBackward", ()=>FaStepBackward);
parcelHelpers.export(exports, "FaStepForward", ()=>FaStepForward);
parcelHelpers.export(exports, "FaStethoscope", ()=>FaStethoscope);
parcelHelpers.export(exports, "FaStickyNote", ()=>FaStickyNote);
parcelHelpers.export(exports, "FaStopCircle", ()=>FaStopCircle);
parcelHelpers.export(exports, "FaStop", ()=>FaStop);
parcelHelpers.export(exports, "FaStopwatch20", ()=>FaStopwatch20);
parcelHelpers.export(exports, "FaStopwatch", ()=>FaStopwatch);
parcelHelpers.export(exports, "FaStoreAltSlash", ()=>FaStoreAltSlash);
parcelHelpers.export(exports, "FaStoreAlt", ()=>FaStoreAlt);
parcelHelpers.export(exports, "FaStoreSlash", ()=>FaStoreSlash);
parcelHelpers.export(exports, "FaStore", ()=>FaStore);
parcelHelpers.export(exports, "FaStream", ()=>FaStream);
parcelHelpers.export(exports, "FaStreetView", ()=>FaStreetView);
parcelHelpers.export(exports, "FaStrikethrough", ()=>FaStrikethrough);
parcelHelpers.export(exports, "FaStroopwafel", ()=>FaStroopwafel);
parcelHelpers.export(exports, "FaSubscript", ()=>FaSubscript);
parcelHelpers.export(exports, "FaSubway", ()=>FaSubway);
parcelHelpers.export(exports, "FaSuitcaseRolling", ()=>FaSuitcaseRolling);
parcelHelpers.export(exports, "FaSuitcase", ()=>FaSuitcase);
parcelHelpers.export(exports, "FaSun", ()=>FaSun);
parcelHelpers.export(exports, "FaSuperscript", ()=>FaSuperscript);
parcelHelpers.export(exports, "FaSurprise", ()=>FaSurprise);
parcelHelpers.export(exports, "FaSwatchbook", ()=>FaSwatchbook);
parcelHelpers.export(exports, "FaSwimmer", ()=>FaSwimmer);
parcelHelpers.export(exports, "FaSwimmingPool", ()=>FaSwimmingPool);
parcelHelpers.export(exports, "FaSynagogue", ()=>FaSynagogue);
parcelHelpers.export(exports, "FaSyncAlt", ()=>FaSyncAlt);
parcelHelpers.export(exports, "FaSync", ()=>FaSync);
parcelHelpers.export(exports, "FaSyringe", ()=>FaSyringe);
parcelHelpers.export(exports, "FaTableTennis", ()=>FaTableTennis);
parcelHelpers.export(exports, "FaTable", ()=>FaTable);
parcelHelpers.export(exports, "FaTabletAlt", ()=>FaTabletAlt);
parcelHelpers.export(exports, "FaTablet", ()=>FaTablet);
parcelHelpers.export(exports, "FaTablets", ()=>FaTablets);
parcelHelpers.export(exports, "FaTachometerAlt", ()=>FaTachometerAlt);
parcelHelpers.export(exports, "FaTag", ()=>FaTag);
parcelHelpers.export(exports, "FaTags", ()=>FaTags);
parcelHelpers.export(exports, "FaTape", ()=>FaTape);
parcelHelpers.export(exports, "FaTasks", ()=>FaTasks);
parcelHelpers.export(exports, "FaTaxi", ()=>FaTaxi);
parcelHelpers.export(exports, "FaTeethOpen", ()=>FaTeethOpen);
parcelHelpers.export(exports, "FaTeeth", ()=>FaTeeth);
parcelHelpers.export(exports, "FaTemperatureHigh", ()=>FaTemperatureHigh);
parcelHelpers.export(exports, "FaTemperatureLow", ()=>FaTemperatureLow);
parcelHelpers.export(exports, "FaTenge", ()=>FaTenge);
parcelHelpers.export(exports, "FaTerminal", ()=>FaTerminal);
parcelHelpers.export(exports, "FaTextHeight", ()=>FaTextHeight);
parcelHelpers.export(exports, "FaTextWidth", ()=>FaTextWidth);
parcelHelpers.export(exports, "FaThLarge", ()=>FaThLarge);
parcelHelpers.export(exports, "FaThList", ()=>FaThList);
parcelHelpers.export(exports, "FaTh", ()=>FaTh);
parcelHelpers.export(exports, "FaTheaterMasks", ()=>FaTheaterMasks);
parcelHelpers.export(exports, "FaThermometerEmpty", ()=>FaThermometerEmpty);
parcelHelpers.export(exports, "FaThermometerFull", ()=>FaThermometerFull);
parcelHelpers.export(exports, "FaThermometerHalf", ()=>FaThermometerHalf);
parcelHelpers.export(exports, "FaThermometerQuarter", ()=>FaThermometerQuarter);
parcelHelpers.export(exports, "FaThermometerThreeQuarters", ()=>FaThermometerThreeQuarters);
parcelHelpers.export(exports, "FaThermometer", ()=>FaThermometer);
parcelHelpers.export(exports, "FaThumbsDown", ()=>FaThumbsDown);
parcelHelpers.export(exports, "FaThumbsUp", ()=>FaThumbsUp);
parcelHelpers.export(exports, "FaThumbtack", ()=>FaThumbtack);
parcelHelpers.export(exports, "FaTicketAlt", ()=>FaTicketAlt);
parcelHelpers.export(exports, "FaTimesCircle", ()=>FaTimesCircle);
parcelHelpers.export(exports, "FaTimes", ()=>FaTimes);
parcelHelpers.export(exports, "FaTintSlash", ()=>FaTintSlash);
parcelHelpers.export(exports, "FaTint", ()=>FaTint);
parcelHelpers.export(exports, "FaTired", ()=>FaTired);
parcelHelpers.export(exports, "FaToggleOff", ()=>FaToggleOff);
parcelHelpers.export(exports, "FaToggleOn", ()=>FaToggleOn);
parcelHelpers.export(exports, "FaToiletPaperSlash", ()=>FaToiletPaperSlash);
parcelHelpers.export(exports, "FaToiletPaper", ()=>FaToiletPaper);
parcelHelpers.export(exports, "FaToilet", ()=>FaToilet);
parcelHelpers.export(exports, "FaToolbox", ()=>FaToolbox);
parcelHelpers.export(exports, "FaTools", ()=>FaTools);
parcelHelpers.export(exports, "FaTooth", ()=>FaTooth);
parcelHelpers.export(exports, "FaTorah", ()=>FaTorah);
parcelHelpers.export(exports, "FaToriiGate", ()=>FaToriiGate);
parcelHelpers.export(exports, "FaTractor", ()=>FaTractor);
parcelHelpers.export(exports, "FaTrademark", ()=>FaTrademark);
parcelHelpers.export(exports, "FaTrafficLight", ()=>FaTrafficLight);
parcelHelpers.export(exports, "FaTrailer", ()=>FaTrailer);
parcelHelpers.export(exports, "FaTrain", ()=>FaTrain);
parcelHelpers.export(exports, "FaTram", ()=>FaTram);
parcelHelpers.export(exports, "FaTransgenderAlt", ()=>FaTransgenderAlt);
parcelHelpers.export(exports, "FaTransgender", ()=>FaTransgender);
parcelHelpers.export(exports, "FaTrashAlt", ()=>FaTrashAlt);
parcelHelpers.export(exports, "FaTrashRestoreAlt", ()=>FaTrashRestoreAlt);
parcelHelpers.export(exports, "FaTrashRestore", ()=>FaTrashRestore);
parcelHelpers.export(exports, "FaTrash", ()=>FaTrash);
parcelHelpers.export(exports, "FaTree", ()=>FaTree);
parcelHelpers.export(exports, "FaTrophy", ()=>FaTrophy);
parcelHelpers.export(exports, "FaTruckLoading", ()=>FaTruckLoading);
parcelHelpers.export(exports, "FaTruckMonster", ()=>FaTruckMonster);
parcelHelpers.export(exports, "FaTruckMoving", ()=>FaTruckMoving);
parcelHelpers.export(exports, "FaTruckPickup", ()=>FaTruckPickup);
parcelHelpers.export(exports, "FaTruck", ()=>FaTruck);
parcelHelpers.export(exports, "FaTshirt", ()=>FaTshirt);
parcelHelpers.export(exports, "FaTty", ()=>FaTty);
parcelHelpers.export(exports, "FaTv", ()=>FaTv);
parcelHelpers.export(exports, "FaUmbrellaBeach", ()=>FaUmbrellaBeach);
parcelHelpers.export(exports, "FaUmbrella", ()=>FaUmbrella);
parcelHelpers.export(exports, "FaUnderline", ()=>FaUnderline);
parcelHelpers.export(exports, "FaUndoAlt", ()=>FaUndoAlt);
parcelHelpers.export(exports, "FaUndo", ()=>FaUndo);
parcelHelpers.export(exports, "FaUniversalAccess", ()=>FaUniversalAccess);
parcelHelpers.export(exports, "FaUniversity", ()=>FaUniversity);
parcelHelpers.export(exports, "FaUnlink", ()=>FaUnlink);
parcelHelpers.export(exports, "FaUnlockAlt", ()=>FaUnlockAlt);
parcelHelpers.export(exports, "FaUnlock", ()=>FaUnlock);
parcelHelpers.export(exports, "FaUpload", ()=>FaUpload);
parcelHelpers.export(exports, "FaUserAltSlash", ()=>FaUserAltSlash);
parcelHelpers.export(exports, "FaUserAlt", ()=>FaUserAlt);
parcelHelpers.export(exports, "FaUserAstronaut", ()=>FaUserAstronaut);
parcelHelpers.export(exports, "FaUserCheck", ()=>FaUserCheck);
parcelHelpers.export(exports, "FaUserCircle", ()=>FaUserCircle);
parcelHelpers.export(exports, "FaUserClock", ()=>FaUserClock);
parcelHelpers.export(exports, "FaUserCog", ()=>FaUserCog);
parcelHelpers.export(exports, "FaUserEdit", ()=>FaUserEdit);
parcelHelpers.export(exports, "FaUserFriends", ()=>FaUserFriends);
parcelHelpers.export(exports, "FaUserGraduate", ()=>FaUserGraduate);
parcelHelpers.export(exports, "FaUserInjured", ()=>FaUserInjured);
parcelHelpers.export(exports, "FaUserLock", ()=>FaUserLock);
parcelHelpers.export(exports, "FaUserMd", ()=>FaUserMd);
parcelHelpers.export(exports, "FaUserMinus", ()=>FaUserMinus);
parcelHelpers.export(exports, "FaUserNinja", ()=>FaUserNinja);
parcelHelpers.export(exports, "FaUserNurse", ()=>FaUserNurse);
parcelHelpers.export(exports, "FaUserPlus", ()=>FaUserPlus);
parcelHelpers.export(exports, "FaUserSecret", ()=>FaUserSecret);
parcelHelpers.export(exports, "FaUserShield", ()=>FaUserShield);
parcelHelpers.export(exports, "FaUserSlash", ()=>FaUserSlash);
parcelHelpers.export(exports, "FaUserTag", ()=>FaUserTag);
parcelHelpers.export(exports, "FaUserTie", ()=>FaUserTie);
parcelHelpers.export(exports, "FaUserTimes", ()=>FaUserTimes);
parcelHelpers.export(exports, "FaUser", ()=>FaUser);
parcelHelpers.export(exports, "FaUsersCog", ()=>FaUsersCog);
parcelHelpers.export(exports, "FaUsersSlash", ()=>FaUsersSlash);
parcelHelpers.export(exports, "FaUsers", ()=>FaUsers);
parcelHelpers.export(exports, "FaUtensilSpoon", ()=>FaUtensilSpoon);
parcelHelpers.export(exports, "FaUtensils", ()=>FaUtensils);
parcelHelpers.export(exports, "FaVectorSquare", ()=>FaVectorSquare);
parcelHelpers.export(exports, "FaVenusDouble", ()=>FaVenusDouble);
parcelHelpers.export(exports, "FaVenusMars", ()=>FaVenusMars);
parcelHelpers.export(exports, "FaVenus", ()=>FaVenus);
parcelHelpers.export(exports, "FaVestPatches", ()=>FaVestPatches);
parcelHelpers.export(exports, "FaVest", ()=>FaVest);
parcelHelpers.export(exports, "FaVial", ()=>FaVial);
parcelHelpers.export(exports, "FaVials", ()=>FaVials);
parcelHelpers.export(exports, "FaVideoSlash", ()=>FaVideoSlash);
parcelHelpers.export(exports, "FaVideo", ()=>FaVideo);
parcelHelpers.export(exports, "FaVihara", ()=>FaVihara);
parcelHelpers.export(exports, "FaVirusSlash", ()=>FaVirusSlash);
parcelHelpers.export(exports, "FaVirus", ()=>FaVirus);
parcelHelpers.export(exports, "FaViruses", ()=>FaViruses);
parcelHelpers.export(exports, "FaVoicemail", ()=>FaVoicemail);
parcelHelpers.export(exports, "FaVolleyballBall", ()=>FaVolleyballBall);
parcelHelpers.export(exports, "FaVolumeDown", ()=>FaVolumeDown);
parcelHelpers.export(exports, "FaVolumeMute", ()=>FaVolumeMute);
parcelHelpers.export(exports, "FaVolumeOff", ()=>FaVolumeOff);
parcelHelpers.export(exports, "FaVolumeUp", ()=>FaVolumeUp);
parcelHelpers.export(exports, "FaVoteYea", ()=>FaVoteYea);
parcelHelpers.export(exports, "FaVrCardboard", ()=>FaVrCardboard);
parcelHelpers.export(exports, "FaWalking", ()=>FaWalking);
parcelHelpers.export(exports, "FaWallet", ()=>FaWallet);
parcelHelpers.export(exports, "FaWarehouse", ()=>FaWarehouse);
parcelHelpers.export(exports, "FaWater", ()=>FaWater);
parcelHelpers.export(exports, "FaWaveSquare", ()=>FaWaveSquare);
parcelHelpers.export(exports, "FaWeightHanging", ()=>FaWeightHanging);
parcelHelpers.export(exports, "FaWeight", ()=>FaWeight);
parcelHelpers.export(exports, "FaWheelchair", ()=>FaWheelchair);
parcelHelpers.export(exports, "FaWifi", ()=>FaWifi);
parcelHelpers.export(exports, "FaWind", ()=>FaWind);
parcelHelpers.export(exports, "FaWindowClose", ()=>FaWindowClose);
parcelHelpers.export(exports, "FaWindowMaximize", ()=>FaWindowMaximize);
parcelHelpers.export(exports, "FaWindowMinimize", ()=>FaWindowMinimize);
parcelHelpers.export(exports, "FaWindowRestore", ()=>FaWindowRestore);
parcelHelpers.export(exports, "FaWineBottle", ()=>FaWineBottle);
parcelHelpers.export(exports, "FaWineGlassAlt", ()=>FaWineGlassAlt);
parcelHelpers.export(exports, "FaWineGlass", ()=>FaWineGlass);
parcelHelpers.export(exports, "FaWonSign", ()=>FaWonSign);
parcelHelpers.export(exports, "FaWrench", ()=>FaWrench);
parcelHelpers.export(exports, "FaXRay", ()=>FaXRay);
parcelHelpers.export(exports, "FaYenSign", ()=>FaYenSign);
parcelHelpers.export(exports, "FaYinYang", ()=>FaYinYang);
parcelHelpers.export(exports, "FaRegAddressBook", ()=>FaRegAddressBook);
parcelHelpers.export(exports, "FaRegAddressCard", ()=>FaRegAddressCard);
parcelHelpers.export(exports, "FaRegAngry", ()=>FaRegAngry);
parcelHelpers.export(exports, "FaRegArrowAltCircleDown", ()=>FaRegArrowAltCircleDown);
parcelHelpers.export(exports, "FaRegArrowAltCircleLeft", ()=>FaRegArrowAltCircleLeft);
parcelHelpers.export(exports, "FaRegArrowAltCircleRight", ()=>FaRegArrowAltCircleRight);
parcelHelpers.export(exports, "FaRegArrowAltCircleUp", ()=>FaRegArrowAltCircleUp);
parcelHelpers.export(exports, "FaRegBellSlash", ()=>FaRegBellSlash);
parcelHelpers.export(exports, "FaRegBell", ()=>FaRegBell);
parcelHelpers.export(exports, "FaRegBookmark", ()=>FaRegBookmark);
parcelHelpers.export(exports, "FaRegBuilding", ()=>FaRegBuilding);
parcelHelpers.export(exports, "FaRegCalendarAlt", ()=>FaRegCalendarAlt);
parcelHelpers.export(exports, "FaRegCalendarCheck", ()=>FaRegCalendarCheck);
parcelHelpers.export(exports, "FaRegCalendarMinus", ()=>FaRegCalendarMinus);
parcelHelpers.export(exports, "FaRegCalendarPlus", ()=>FaRegCalendarPlus);
parcelHelpers.export(exports, "FaRegCalendarTimes", ()=>FaRegCalendarTimes);
parcelHelpers.export(exports, "FaRegCalendar", ()=>FaRegCalendar);
parcelHelpers.export(exports, "FaRegCaretSquareDown", ()=>FaRegCaretSquareDown);
parcelHelpers.export(exports, "FaRegCaretSquareLeft", ()=>FaRegCaretSquareLeft);
parcelHelpers.export(exports, "FaRegCaretSquareRight", ()=>FaRegCaretSquareRight);
parcelHelpers.export(exports, "FaRegCaretSquareUp", ()=>FaRegCaretSquareUp);
parcelHelpers.export(exports, "FaRegChartBar", ()=>FaRegChartBar);
parcelHelpers.export(exports, "FaRegCheckCircle", ()=>FaRegCheckCircle);
parcelHelpers.export(exports, "FaRegCheckSquare", ()=>FaRegCheckSquare);
parcelHelpers.export(exports, "FaRegCircle", ()=>FaRegCircle);
parcelHelpers.export(exports, "FaRegClipboard", ()=>FaRegClipboard);
parcelHelpers.export(exports, "FaRegClock", ()=>FaRegClock);
parcelHelpers.export(exports, "FaRegClone", ()=>FaRegClone);
parcelHelpers.export(exports, "FaRegClosedCaptioning", ()=>FaRegClosedCaptioning);
parcelHelpers.export(exports, "FaRegCommentAlt", ()=>FaRegCommentAlt);
parcelHelpers.export(exports, "FaRegCommentDots", ()=>FaRegCommentDots);
parcelHelpers.export(exports, "FaRegComment", ()=>FaRegComment);
parcelHelpers.export(exports, "FaRegComments", ()=>FaRegComments);
parcelHelpers.export(exports, "FaRegCompass", ()=>FaRegCompass);
parcelHelpers.export(exports, "FaRegCopy", ()=>FaRegCopy);
parcelHelpers.export(exports, "FaRegCopyright", ()=>FaRegCopyright);
parcelHelpers.export(exports, "FaRegCreditCard", ()=>FaRegCreditCard);
parcelHelpers.export(exports, "FaRegDizzy", ()=>FaRegDizzy);
parcelHelpers.export(exports, "FaRegDotCircle", ()=>FaRegDotCircle);
parcelHelpers.export(exports, "FaRegEdit", ()=>FaRegEdit);
parcelHelpers.export(exports, "FaRegEnvelopeOpen", ()=>FaRegEnvelopeOpen);
parcelHelpers.export(exports, "FaRegEnvelope", ()=>FaRegEnvelope);
parcelHelpers.export(exports, "FaRegEyeSlash", ()=>FaRegEyeSlash);
parcelHelpers.export(exports, "FaRegEye", ()=>FaRegEye);
parcelHelpers.export(exports, "FaRegFileAlt", ()=>FaRegFileAlt);
parcelHelpers.export(exports, "FaRegFileArchive", ()=>FaRegFileArchive);
parcelHelpers.export(exports, "FaRegFileAudio", ()=>FaRegFileAudio);
parcelHelpers.export(exports, "FaRegFileCode", ()=>FaRegFileCode);
parcelHelpers.export(exports, "FaRegFileExcel", ()=>FaRegFileExcel);
parcelHelpers.export(exports, "FaRegFileImage", ()=>FaRegFileImage);
parcelHelpers.export(exports, "FaRegFilePdf", ()=>FaRegFilePdf);
parcelHelpers.export(exports, "FaRegFilePowerpoint", ()=>FaRegFilePowerpoint);
parcelHelpers.export(exports, "FaRegFileVideo", ()=>FaRegFileVideo);
parcelHelpers.export(exports, "FaRegFileWord", ()=>FaRegFileWord);
parcelHelpers.export(exports, "FaRegFile", ()=>FaRegFile);
parcelHelpers.export(exports, "FaRegFlag", ()=>FaRegFlag);
parcelHelpers.export(exports, "FaRegFlushed", ()=>FaRegFlushed);
parcelHelpers.export(exports, "FaRegFolderOpen", ()=>FaRegFolderOpen);
parcelHelpers.export(exports, "FaRegFolder", ()=>FaRegFolder);
parcelHelpers.export(exports, "FaRegFontAwesomeLogoFull", ()=>FaRegFontAwesomeLogoFull);
parcelHelpers.export(exports, "FaRegFrownOpen", ()=>FaRegFrownOpen);
parcelHelpers.export(exports, "FaRegFrown", ()=>FaRegFrown);
parcelHelpers.export(exports, "FaRegFutbol", ()=>FaRegFutbol);
parcelHelpers.export(exports, "FaRegGem", ()=>FaRegGem);
parcelHelpers.export(exports, "FaRegGrimace", ()=>FaRegGrimace);
parcelHelpers.export(exports, "FaRegGrinAlt", ()=>FaRegGrinAlt);
parcelHelpers.export(exports, "FaRegGrinBeamSweat", ()=>FaRegGrinBeamSweat);
parcelHelpers.export(exports, "FaRegGrinBeam", ()=>FaRegGrinBeam);
parcelHelpers.export(exports, "FaRegGrinHearts", ()=>FaRegGrinHearts);
parcelHelpers.export(exports, "FaRegGrinSquintTears", ()=>FaRegGrinSquintTears);
parcelHelpers.export(exports, "FaRegGrinSquint", ()=>FaRegGrinSquint);
parcelHelpers.export(exports, "FaRegGrinStars", ()=>FaRegGrinStars);
parcelHelpers.export(exports, "FaRegGrinTears", ()=>FaRegGrinTears);
parcelHelpers.export(exports, "FaRegGrinTongueSquint", ()=>FaRegGrinTongueSquint);
parcelHelpers.export(exports, "FaRegGrinTongueWink", ()=>FaRegGrinTongueWink);
parcelHelpers.export(exports, "FaRegGrinTongue", ()=>FaRegGrinTongue);
parcelHelpers.export(exports, "FaRegGrinWink", ()=>FaRegGrinWink);
parcelHelpers.export(exports, "FaRegGrin", ()=>FaRegGrin);
parcelHelpers.export(exports, "FaRegHandLizard", ()=>FaRegHandLizard);
parcelHelpers.export(exports, "FaRegHandPaper", ()=>FaRegHandPaper);
parcelHelpers.export(exports, "FaRegHandPeace", ()=>FaRegHandPeace);
parcelHelpers.export(exports, "FaRegHandPointDown", ()=>FaRegHandPointDown);
parcelHelpers.export(exports, "FaRegHandPointLeft", ()=>FaRegHandPointLeft);
parcelHelpers.export(exports, "FaRegHandPointRight", ()=>FaRegHandPointRight);
parcelHelpers.export(exports, "FaRegHandPointUp", ()=>FaRegHandPointUp);
parcelHelpers.export(exports, "FaRegHandPointer", ()=>FaRegHandPointer);
parcelHelpers.export(exports, "FaRegHandRock", ()=>FaRegHandRock);
parcelHelpers.export(exports, "FaRegHandScissors", ()=>FaRegHandScissors);
parcelHelpers.export(exports, "FaRegHandSpock", ()=>FaRegHandSpock);
parcelHelpers.export(exports, "FaRegHandshake", ()=>FaRegHandshake);
parcelHelpers.export(exports, "FaRegHdd", ()=>FaRegHdd);
parcelHelpers.export(exports, "FaRegHeart", ()=>FaRegHeart);
parcelHelpers.export(exports, "FaRegHospital", ()=>FaRegHospital);
parcelHelpers.export(exports, "FaRegHourglass", ()=>FaRegHourglass);
parcelHelpers.export(exports, "FaRegIdBadge", ()=>FaRegIdBadge);
parcelHelpers.export(exports, "FaRegIdCard", ()=>FaRegIdCard);
parcelHelpers.export(exports, "FaRegImage", ()=>FaRegImage);
parcelHelpers.export(exports, "FaRegImages", ()=>FaRegImages);
parcelHelpers.export(exports, "FaRegKeyboard", ()=>FaRegKeyboard);
parcelHelpers.export(exports, "FaRegKissBeam", ()=>FaRegKissBeam);
parcelHelpers.export(exports, "FaRegKissWinkHeart", ()=>FaRegKissWinkHeart);
parcelHelpers.export(exports, "FaRegKiss", ()=>FaRegKiss);
parcelHelpers.export(exports, "FaRegLaughBeam", ()=>FaRegLaughBeam);
parcelHelpers.export(exports, "FaRegLaughSquint", ()=>FaRegLaughSquint);
parcelHelpers.export(exports, "FaRegLaughWink", ()=>FaRegLaughWink);
parcelHelpers.export(exports, "FaRegLaugh", ()=>FaRegLaugh);
parcelHelpers.export(exports, "FaRegLemon", ()=>FaRegLemon);
parcelHelpers.export(exports, "FaRegLifeRing", ()=>FaRegLifeRing);
parcelHelpers.export(exports, "FaRegLightbulb", ()=>FaRegLightbulb);
parcelHelpers.export(exports, "FaRegListAlt", ()=>FaRegListAlt);
parcelHelpers.export(exports, "FaRegMap", ()=>FaRegMap);
parcelHelpers.export(exports, "FaRegMehBlank", ()=>FaRegMehBlank);
parcelHelpers.export(exports, "FaRegMehRollingEyes", ()=>FaRegMehRollingEyes);
parcelHelpers.export(exports, "FaRegMeh", ()=>FaRegMeh);
parcelHelpers.export(exports, "FaRegMinusSquare", ()=>FaRegMinusSquare);
parcelHelpers.export(exports, "FaRegMoneyBillAlt", ()=>FaRegMoneyBillAlt);
parcelHelpers.export(exports, "FaRegMoon", ()=>FaRegMoon);
parcelHelpers.export(exports, "FaRegNewspaper", ()=>FaRegNewspaper);
parcelHelpers.export(exports, "FaRegObjectGroup", ()=>FaRegObjectGroup);
parcelHelpers.export(exports, "FaRegObjectUngroup", ()=>FaRegObjectUngroup);
parcelHelpers.export(exports, "FaRegPaperPlane", ()=>FaRegPaperPlane);
parcelHelpers.export(exports, "FaRegPauseCircle", ()=>FaRegPauseCircle);
parcelHelpers.export(exports, "FaRegPlayCircle", ()=>FaRegPlayCircle);
parcelHelpers.export(exports, "FaRegPlusSquare", ()=>FaRegPlusSquare);
parcelHelpers.export(exports, "FaRegQuestionCircle", ()=>FaRegQuestionCircle);
parcelHelpers.export(exports, "FaRegRegistered", ()=>FaRegRegistered);
parcelHelpers.export(exports, "FaRegSadCry", ()=>FaRegSadCry);
parcelHelpers.export(exports, "FaRegSadTear", ()=>FaRegSadTear);
parcelHelpers.export(exports, "FaRegSave", ()=>FaRegSave);
parcelHelpers.export(exports, "FaRegShareSquare", ()=>FaRegShareSquare);
parcelHelpers.export(exports, "FaRegSmileBeam", ()=>FaRegSmileBeam);
parcelHelpers.export(exports, "FaRegSmileWink", ()=>FaRegSmileWink);
parcelHelpers.export(exports, "FaRegSmile", ()=>FaRegSmile);
parcelHelpers.export(exports, "FaRegSnowflake", ()=>FaRegSnowflake);
parcelHelpers.export(exports, "FaRegSquare", ()=>FaRegSquare);
parcelHelpers.export(exports, "FaRegStarHalf", ()=>FaRegStarHalf);
parcelHelpers.export(exports, "FaRegStar", ()=>FaRegStar);
parcelHelpers.export(exports, "FaRegStickyNote", ()=>FaRegStickyNote);
parcelHelpers.export(exports, "FaRegStopCircle", ()=>FaRegStopCircle);
parcelHelpers.export(exports, "FaRegSun", ()=>FaRegSun);
parcelHelpers.export(exports, "FaRegSurprise", ()=>FaRegSurprise);
parcelHelpers.export(exports, "FaRegThumbsDown", ()=>FaRegThumbsDown);
parcelHelpers.export(exports, "FaRegThumbsUp", ()=>FaRegThumbsUp);
parcelHelpers.export(exports, "FaRegTimesCircle", ()=>FaRegTimesCircle);
parcelHelpers.export(exports, "FaRegTired", ()=>FaRegTired);
parcelHelpers.export(exports, "FaRegTrashAlt", ()=>FaRegTrashAlt);
parcelHelpers.export(exports, "FaRegUserCircle", ()=>FaRegUserCircle);
parcelHelpers.export(exports, "FaRegUser", ()=>FaRegUser);
parcelHelpers.export(exports, "FaRegWindowClose", ()=>FaRegWindowClose);
parcelHelpers.export(exports, "FaRegWindowMaximize", ()=>FaRegWindowMaximize);
parcelHelpers.export(exports, "FaRegWindowMinimize", ()=>FaRegWindowMinimize);
parcelHelpers.export(exports, "FaRegWindowRestore", ()=>FaRegWindowRestore);
var _indexMjs = require("../lib/index.mjs");
function Fa500Px(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M103.3 344.3c-6.5-14.2-6.9-18.3 7.4-23.1 25.6-8 8 9.2 43.2 49.2h.3v-93.9c1.2-50.2 44-92.2 97.7-92.2 53.9 0 97.7 43.5 97.7 96.8 0 63.4-60.8 113.2-128.5 93.3-10.5-4.2-2.1-31.7 8.5-28.6 53 0 89.4-10.1 89.4-64.4 0-61-77.1-89.6-116.9-44.6-23.5 26.4-17.6 42.1-17.6 157.6 50.7 31 118.3 22 160.4-20.1 24.8-24.8 38.5-58 38.5-93 0-35.2-13.8-68.2-38.8-93.3-24.8-24.8-57.8-38.5-93.3-38.5s-68.8 13.8-93.5 38.5c-.3.3-16 16.5-21.2 23.9l-.5.6c-3.3 4.7-6.3 9.1-20.1 6.1-6.9-1.7-14.3-5.8-14.3-11.8V20c0-5 3.9-10.5 10.5-10.5h241.3c8.3 0 8.3 11.6 8.3 15.1 0 3.9 0 15.1-8.3 15.1H130.3v132.9h.3c104.2-109.8 282.8-36 282.8 108.9 0 178.1-244.8 220.3-310.1 62.8zm63.3-260.8c-.5 4.2 4.6 24.5 14.6 20.6C306 56.6 384 144.5 390.6 144.5c4.8 0 22.8-15.3 14.3-22.8-93.2-89-234.5-57-238.3-38.2zM393 414.7C283 524.6 94 475.5 61 310.5c0-12.2-30.4-7.4-28.9 3.3 24 173.4 246 256.9 381.6 121.3 6.9-7.8-12.6-28.4-20.7-20.4zM213.6 306.6c0 4 4.3 7.3 5.5 8.5 3 3 6.1 4.4 8.5 4.4 3.8 0 2.6.2 22.3-19.5 19.6 19.3 19.1 19.5 22.3 19.5 5.4 0 18.5-10.4 10.7-18.2L265.6 284l18.2-18.2c6.3-6.8-10.1-21.8-16.2-15.7L249.7 268c-18.6-18.8-18.4-19.5-21.5-19.5-5 0-18 11.7-12.4 17.3L234 284c-18.1 17.9-20.4 19.2-20.4 22.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAccessibleIcon(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M423.9 255.8L411 413.1c-3.3 40.7-63.9 35.1-60.6-4.9l10-122.5-41.1 2.3c10.1 20.7 15.8 43.9 15.8 68.5 0 41.2-16.1 78.7-42.3 106.5l-39.3-39.3c57.9-63.7 13.1-167.2-74-167.2-25.9 0-49.5 9.9-67.2 26L73 243.2c22-20.7 50.1-35.1 81.4-40.2l75.3-85.7-42.6-24.8-51.6 46c-30 26.8-70.6-18.5-40.5-45.4l68-60.7c9.8-8.8 24.1-10.2 35.5-3.6 0 0 139.3 80.9 139.5 81.1 16.2 10.1 20.7 36 6.1 52.6L285.7 229l106.1-5.9c18.5-1.1 33.6 14.4 32.1 32.7zm-64.9-154c28.1 0 50.9-22.8 50.9-50.9C409.9 22.8 387.1 0 359 0c-28.1 0-50.9 22.8-50.9 50.9 0 28.1 22.8 50.9 50.9 50.9zM179.6 456.5c-80.6 0-127.4-90.6-82.7-156.1l-39.7-39.7C36.4 287 24 320.3 24 356.4c0 130.7 150.7 201.4 251.4 122.5l-39.7-39.7c-16 10.9-35.3 17.3-56.1 17.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAccusoft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M322.1 252v-1l-51.2-65.8s-12 1.6-25 15.1c-9 9.3-242.1 239.1-243.4 240.9-7 10 1.6 6.8 15.7 1.7.8 0 114.5-36.6 114.5-36.6.5-.6-.1-.1.6-.6-.4-5.1-.8-26.2-1-27.7-.6-5.2 2.2-6.9 7-8.9l92.6-33.8c.6-.8 88.5-81.7 90.2-83.3zm160.1 120.1c13.3 16.1 20.7 13.3 30.8 9.3 3.2-1.2 115.4-47.6 117.8-48.9 8-4.3-1.7-16.7-7.2-23.4-2.1-2.5-205.1-245.6-207.2-248.3-9.7-12.2-14.3-12.9-38.4-12.8-10.2 0-106.8.5-116.5.6-19.2.1-32.9-.3-19.2 16.9C250 75 476.5 365.2 482.2 372.1zm152.7 1.6c-2.3-.3-24.6-4.7-38-7.2 0 0-115 50.4-117.5 51.6-16 7.3-26.9-3.2-36.7-14.6l-57.1-74c-5.4-.9-60.4-9.6-65.3-9.3-3.1.2-9.6.8-14.4 2.9-4.9 2.1-145.2 52.8-150.2 54.7-5.1 2-11.4 3.6-11.1 7.6.2 2.5 2 2.6 4.6 3.5 2.7.8 300.9 67.6 308 69.1 15.6 3.3 38.5 10.5 53.6 1.7 2.1-1.2 123.8-76.4 125.8-77.8 5.4-4 4.3-6.8-1.7-8.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAcquisitionsIncorporated(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M357.45 468.2c-1.2-7.7-1.3-7.6-9.6-7.6-99.8.2-111.8-2.4-112.7-2.6-12.3-1.7-20.6-10.5-21-23.1-.1-1.6-.2-71.6-1-129.1-.1-4.7 1.6-6.4 5.9-7.5 12.5-3 24.9-6.1 37.3-9.7 4.3-1.3 6.8-.2 8.4 3.5 4.5 10.3 8.8 20.6 13.2 30.9 1.6 3.7.1 4.4-3.4 4.4-10-.2-20-.1-30.4-.1v27h116c-1.4-9.5-2.7-18.1-4-27.5-7 0-13.8.4-20.4-.1-22.6-1.6-18.3-4.4-84-158.6-8.8-20.1-27.9-62.1-36.5-89.2-4.4-14 5.5-25.4 18.9-26.6 18.6-1.7 37.5-1.6 56.2-2 20.6-.4 41.2-.4 61.8-.5 3.1 0 4-1.4 4.3-4.3 1.2-9.8 2.7-19.5 4-29.2.8-5.3 1.6-10.7 2.4-16.1L23.75 0c-3.6 0-5.3 1.1-4.6 5.3 2.2 13.2-.8.8 6.4 45.3 63.4 0 71.8.9 101.8.5 12.3-.2 37 3.5 37.7 22.1.4 11.4-1.1 11.3-32.6 87.4-53.8 129.8-50.7 120.3-67.3 161-1.7 4.1-3.6 5.2-7.6 5.2-8.5-.2-17-.3-25.4.1-1.9.1-5.2 1.8-5.5 3.2-1.5 8.1-2.2 16.3-3.2 24.9h114.3v-27.6c-6.9 0-33.5.4-35.3-2.9 5.3-12.3 10.4-24.4 15.7-36.7 16.3 4 31.9 7.8 47.6 11.7 3.4.9 4.6 3 4.6 6.8-.1 42.9.1 85.9.2 128.8 0 10.2-5.5 19.1-14.9 23.1-6.5 2.7-3.3 3.4-121.4 2.4-5.3 0-7.1 2-7.6 6.8-1.5 12.9-2.9 25.9-5 38.8-.8 5 1.3 5.7 5.3 5.7 183.2.6-30.7 0 337.1 0-2.5-15-4.4-29.4-6.6-43.7zm-174.9-205.7c-13.3-4.2-26.6-8.2-39.9-12.5a44.53 44.53 0 0 1-5.8-2.9c17.2-44.3 34.2-88.1 51.3-132.1 7.5 2.4 7.9-.8 9.4 0 9.3 22.5 18.1 60.1 27 82.8 6.6 16.7 13 33.5 19.7 50.9a35.78 35.78 0 0 1-3.9 2.1c-13.1 3.9-26.4 7.5-39.4 11.7a27.66 27.66 0 0 1-18.4 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAdn(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 167.5l64.9 98.8H183.1l64.9-98.8zM496 256c0 136.9-111.1 248-248 248S0 392.9 0 256 111.1 8 248 8s248 111.1 248 248zm-99.8 82.7L248 115.5 99.8 338.7h30.4l33.6-51.7h168.6l33.6 51.7h30.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAdversal(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M482.1 32H28.7C5.8 32 0 37.9 0 60.9v390.2C0 474.4 5.8 480 28.7 480h453.4c24.4 0 29.9-5.2 29.9-29.7V62.2c0-24.6-5.4-30.2-29.9-30.2zM178.4 220.3c-27.5-20.2-72.1-8.7-84.2 23.4-4.3 11.1-9.3 9.5-17.5 8.3-9.7-1.5-17.2-3.2-22.5-5.5-28.8-11.4 8.6-55.3 24.9-64.3 41.1-21.4 83.4-22.2 125.3-4.8 40.9 16.8 34.5 59.2 34.5 128.5 2.7 25.8-4.3 58.3 9.3 88.8 1.9 4.4.4 7.9-2.7 10.7-8.4 6.7-39.3 2.2-46.6-7.4-1.9-2.2-1.8-3.6-3.9-6.2-3.6-3.9-7.3-2.2-11.9 1-57.4 36.4-140.3 21.4-147-43.3-3.1-29.3 12.4-57.1 39.6-71 38.2-19.5 112.2-11.8 114-30.9 1.1-10.2-1.9-20.1-11.3-27.3zm286.7 222c0 15.1-11.1 9.9-17.8 9.9H52.4c-7.4 0-18.2 4.8-17.8-10.7.4-13.9 10.5-9.1 17.1-9.1 132.3-.4 264.5-.4 396.8 0 6.8 0 16.6-4.4 16.6 9.9zm3.8-340.5v291c0 5.7-.7 13.9-8.1 13.9-12.4-.4-27.5 7.1-36.1-5.6-5.8-8.7-7.8-4-12.4-1.2-53.4 29.7-128.1 7.1-144.4-85.2-6.1-33.4-.7-67.1 15.7-100 11.8-23.9 56.9-76.1 136.1-30.5v-71c0-26.2-.1-26.2 26-26.2 3.1 0 6.6.4 9.7 0 10.1-.8 13.6 4.4 13.6 14.3-.1.2-.1.3-.1.5zm-51.5 232.3c-19.5 47.6-72.9 43.3-90 5.2-15.1-33.3-15.5-68.2.4-101.5 16.3-34.1 59.7-35.7 81.5-4.8 20.6 28.8 14.9 84.6 8.1 101.1zm-294.8 35.3c-7.5-1.3-33-3.3-33.7-27.8-.4-13.9 7.8-23 19.8-25.8 24.4-5.9 49.3-9.9 73.7-14.7 8.9-2 7.4 4.4 7.8 9.5 1.4 33-26.1 59.2-67.6 58.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAffiliatetheme(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M159.7 237.4C108.4 308.3 43.1 348.2 14 326.6-15.2 304.9 2.8 230 54.2 159.1c51.3-70.9 116.6-110.8 145.7-89.2 29.1 21.6 11.1 96.6-40.2 167.5zm351.2-57.3C437.1 303.5 319 367.8 246.4 323.7c-25-15.2-41.3-41.2-49-73.8-33.6 64.8-92.8 113.8-164.1 133.2 49.8 59.3 124.1 96.9 207 96.9 150 0 271.6-123.1 271.6-274.9.1-8.5-.3-16.8-1-25z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAirbnb(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 373.12c-25.24-31.67-40.08-59.43-45-83.18-22.55-88 112.61-88 90.06 0-5.45 24.25-20.29 52-45 83.18zm138.15 73.23c-42.06 18.31-83.67-10.88-119.3-50.47 103.9-130.07 46.11-200-18.85-200-54.92 0-85.16 46.51-73.28 100.5 6.93 29.19 25.23 62.39 54.43 99.5-32.53 36.05-60.55 52.69-85.15 54.92-50 7.43-89.11-41.06-71.3-91.09 15.1-39.16 111.72-231.18 115.87-241.56 15.75-30.07 25.56-57.4 59.38-57.4 32.34 0 43.4 25.94 60.37 59.87 36 70.62 89.35 177.48 114.84 239.09 13.17 33.07-1.37 71.29-37.01 86.64zm47-136.12C280.27 35.93 273.13 32 224 32c-45.52 0-64.87 31.67-84.66 72.79C33.18 317.1 22.89 347.19 22 349.81-3.22 419.14 48.74 480 111.63 480c21.71 0 60.61-6.06 112.37-62.4 58.68 63.78 101.26 62.4 112.37 62.4 62.89.05 114.85-60.86 89.61-130.19.02-3.89-16.82-38.9-16.82-39.58z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAlgolia(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M229.3 182.6c-49.3 0-89.2 39.9-89.2 89.2 0 49.3 39.9 89.2 89.2 89.2s89.2-39.9 89.2-89.2c0-49.3-40-89.2-89.2-89.2zm62.7 56.6l-58.9 30.6c-1.8.9-3.8-.4-3.8-2.3V201c0-1.5 1.3-2.7 2.7-2.6 26.2 1 48.9 15.7 61.1 37.1.7 1.3.2 3-1.1 3.7zM389.1 32H58.9C26.4 32 0 58.4 0 90.9V421c0 32.6 26.4 59 58.9 59H389c32.6 0 58.9-26.4 58.9-58.9V90.9C448 58.4 421.6 32 389.1 32zm-202.6 84.7c0-10.8 8.7-19.5 19.5-19.5h45.3c10.8 0 19.5 8.7 19.5 19.5v15.4c0 1.8-1.7 3-3.3 2.5-12.3-3.4-25.1-5.1-38.1-5.1-13.5 0-26.7 1.8-39.4 5.5-1.7.5-3.4-.8-3.4-2.5v-15.8zm-84.4 37l9.2-9.2c7.6-7.6 19.9-7.6 27.5 0l7.7 7.7c1.1 1.1 1 3-.3 4-6.2 4.5-12.1 9.4-17.6 14.9-5.4 5.4-10.4 11.3-14.8 17.4-1 1.3-2.9 1.5-4 .3l-7.7-7.7c-7.6-7.5-7.6-19.8 0-27.4zm127.2 244.8c-70 0-126.6-56.7-126.6-126.6s56.7-126.6 126.6-126.6c70 0 126.6 56.6 126.6 126.6 0 69.8-56.7 126.6-126.6 126.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAlipay(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M377.74 32H70.26C31.41 32 0 63.41 0 102.26v307.48C0 448.59 31.41 480 70.26 480h307.48c38.52 0 69.76-31.08 70.26-69.6-45.96-25.62-110.59-60.34-171.6-88.44-32.07 43.97-84.14 81-148.62 81-70.59 0-93.73-45.3-97.04-76.37-3.97-39.01 14.88-81.5 99.52-81.5 35.38 0 79.35 10.25 127.13 24.96 16.53-30.09 26.45-60.34 26.45-60.34h-178.2v-16.7h92.08v-31.24H88.28v-19.01h109.44V92.34h50.92v50.42h109.44v19.01H248.63v31.24h88.77s-15.21 46.62-38.35 90.92c48.93 16.7 100.01 36.04 148.62 52.74V102.26C447.83 63.57 416.43 32 377.74 32zM47.28 322.95c.99 20.17 10.25 53.73 69.93 53.73 52.07 0 92.58-39.68 117.87-72.9-44.63-18.68-84.48-31.41-109.44-31.41-67.45 0-79.35 33.06-78.36 50.58z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAmazonPay(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 325.3c2.3-4.2 5.2-4.9 9.7-2.5 10.4 5.6 20.6 11.4 31.2 16.7a595.88 595.88 0 0 0 127.4 46.3 616.61 616.61 0 0 0 63.2 11.8 603.33 603.33 0 0 0 95 5.2c17.4-.4 34.8-1.8 52.1-3.8a603.66 603.66 0 0 0 163.3-42.8c2.9-1.2 5.9-2 9.1-1.2 6.7 1.8 9 9 4.1 13.9a70 70 0 0 1-9.6 7.4c-30.7 21.1-64.2 36.4-99.6 47.9a473.31 473.31 0 0 1-75.1 17.6 431 431 0 0 1-53.2 4.8 21.3 21.3 0 0 0-2.5.3H308a21.3 21.3 0 0 0-2.5-.3c-3.6-.2-7.2-.3-10.7-.4a426.3 426.3 0 0 1-50.4-5.3A448.4 448.4 0 0 1 164 420a443.33 443.33 0 0 1-145.6-87c-1.8-1.6-3-3.8-4.4-5.7zM172 65.1l-4.3.6a80.92 80.92 0 0 0-38 15.1c-2.4 1.7-4.6 3.5-7.1 5.4a4.29 4.29 0 0 1-.4-1.4c-.4-2.7-.8-5.5-1.3-8.2-.7-4.6-3-6.6-7.6-6.6h-11.5c-6.9 0-8.2 1.3-8.2 8.2v209.3c0 1 0 2 .1 3 .2 3 2 4.9 4.9 5 7 .1 14.1.1 21.1 0 2.9 0 4.7-2 5-5 .1-1 .1-2 .1-3v-72.4c1.1.9 1.7 1.4 2.2 1.9 17.9 14.9 38.5 19.8 61 15.4 20.4-4 34.6-16.5 43.8-34.9 7-13.9 9.9-28.7 10.3-44.1.5-17.1-1.2-33.9-8.1-49.8-8.5-19.6-22.6-32.5-43.9-36.9-3.2-.7-6.5-1-9.8-1.5-2.8-.1-5.5-.1-8.3-.1zM124.6 107a3.48 3.48 0 0 1 1.7-3.3c13.7-9.5 28.8-14.5 45.6-13.2 14.9 1.1 27.1 8.4 33.5 25.9 3.9 10.7 4.9 21.8 4.9 33 0 10.4-.8 20.6-4 30.6-6.8 21.3-22.4 29.4-42.6 28.5-14-.6-26.2-6-37.4-13.9a3.57 3.57 0 0 1-1.7-3.3c.1-14.1 0-28.1 0-42.2s.1-28 0-42.1zm205.7-41.9c-1 .1-2 .3-2.9.4a148 148 0 0 0-28.9 4.1c-6.1 1.6-12 3.8-17.9 5.8-3.6 1.2-5.4 3.8-5.3 7.7.1 3.3-.1 6.6 0 9.9.1 4.8 2.1 6.1 6.8 4.9 7.8-2 15.6-4.2 23.5-5.7 12.3-2.3 24.7-3.3 37.2-1.4 6.5 1 12.6 2.9 16.8 8.4 3.7 4.8 5.1 10.5 5.3 16.4.3 8.3.2 16.6.3 24.9a7.84 7.84 0 0 1-.2 1.4c-.5-.1-.9 0-1.3-.1a180.56 180.56 0 0 0-32-4.9c-11.3-.6-22.5.1-33.3 3.9-12.9 4.5-23.3 12.3-29.4 24.9-4.7 9.8-5.4 20.2-3.9 30.7 2 14 9 24.8 21.4 31.7 11.9 6.6 24.8 7.4 37.9 5.4 15.1-2.3 28.5-8.7 40.3-18.4a7.36 7.36 0 0 1 1.6-1.1c.6 3.8 1.1 7.4 1.8 11 .6 3.1 2.5 5.1 5.4 5.2 5.4.1 10.9.1 16.3 0a4.84 4.84 0 0 0 4.8-4.7 26.2 26.2 0 0 0 .1-2.8v-106a80 80 0 0 0-.9-12.9c-1.9-12.9-7.4-23.5-19-30.4-6.7-4-14.1-6-21.8-7.1-3.6-.5-7.2-.8-10.8-1.3-3.9.1-7.9.1-11.9.1zm35 127.7a3.33 3.33 0 0 1-1.5 3c-11.2 8.1-23.5 13.5-37.4 14.9-5.7.6-11.4.4-16.8-1.8a20.08 20.08 0 0 1-12.4-13.3 32.9 32.9 0 0 1-.1-19.4c2.5-8.3 8.4-13 16.4-15.6a61.33 61.33 0 0 1 24.8-2.2c8.4.7 16.6 2.3 25 3.4 1.6.2 2.1 1 2.1 2.6-.1 4.8 0 9.5 0 14.3s-.2 9.4-.1 14.1zm259.9 129.4c-1-5-4.8-6.9-9.1-8.3a88.42 88.42 0 0 0-21-3.9 147.32 147.32 0 0 0-39.2 1.9c-14.3 2.7-27.9 7.3-40 15.6a13.75 13.75 0 0 0-3.7 3.5 5.11 5.11 0 0 0-.5 4c.4 1.5 2.1 1.9 3.6 1.8a16.2 16.2 0 0 0 2.2-.1c7.8-.8 15.5-1.7 23.3-2.5 11.4-1.1 22.9-1.8 34.3-.9a71.64 71.64 0 0 1 14.4 2.7c5.1 1.4 7.4 5.2 7.6 10.4.4 8-1.4 15.7-3.5 23.3-4.1 15.4-10 30.3-15.8 45.1a17.6 17.6 0 0 0-1 3c-.5 2.9 1.2 4.8 4.1 4.1a10.56 10.56 0 0 0 4.8-2.5 145.91 145.91 0 0 0 12.7-13.4c12.8-16.4 20.3-35.3 24.7-55.6.8-3.6 1.4-7.3 2.1-10.9v-17.3zM493.1 199q-19.35-53.55-38.7-107.2c-2-5.7-4.2-11.3-6.3-16.9-1.1-2.9-3.2-4.8-6.4-4.8-7.6-.1-15.2-.2-22.9-.1-2.5 0-3.7 2-3.2 4.5a43.1 43.1 0 0 0 1.9 6.1q29.4 72.75 59.1 145.5c1.7 4.1 2.1 7.6.2 11.8-3.3 7.3-5.9 15-9.3 22.3-3 6.5-8 11.4-15.2 13.3a42.13 42.13 0 0 1-15.4 1.1c-2.5-.2-5-.8-7.5-1-3.4-.2-5.1 1.3-5.2 4.8q-.15 5 0 9.9c.1 5.5 2 8 7.4 8.9a108.18 108.18 0 0 0 16.9 2c17.1.4 30.7-6.5 39.5-21.4a131.63 131.63 0 0 0 9.2-18.4q35.55-89.7 70.6-179.6a26.62 26.62 0 0 0 1.6-5.5c.4-2.8-.9-4.4-3.7-4.4-6.6-.1-13.3 0-19.9 0a7.54 7.54 0 0 0-7.7 5.2c-.5 1.4-1.1 2.7-1.6 4.1l-34.8 100c-2.5 7.2-5.1 14.5-7.7 22.2-.4-1.1-.6-1.7-.9-2.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAmazon(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M257.2 162.7c-48.7 1.8-169.5 15.5-169.5 117.5 0 109.5 138.3 114 183.5 43.2 6.5 10.2 35.4 37.5 45.3 46.8l56.8-56S341 288.9 341 261.4V114.3C341 89 316.5 32 228.7 32 140.7 32 94 87 94 136.3l73.5 6.8c16.3-49.5 54.2-49.5 54.2-49.5 40.7-.1 35.5 29.8 35.5 69.1zm0 86.8c0 80-84.2 68-84.2 17.2 0-47.2 50.5-56.7 84.2-57.8v40.6zm136 163.5c-7.7 10-70 67-174.5 67S34.2 408.5 9.7 379c-6.8-7.7 1-11.3 5.5-8.3C88.5 415.2 203 488.5 387.7 401c7.5-3.7 13.3 2 5.5 12zm39.8 2.2c-6.5 15.8-16 26.8-21.2 31-5.5 4.5-9.5 2.7-6.5-3.8s19.3-46.5 12.7-55c-6.5-8.3-37-4.3-48-3.2-10.8 1-13 2-14-.3-2.3-5.7 21.7-15.5 37.5-17.5 15.7-1.8 41-.8 46 5.7 3.7 5.1 0 27.1-6.5 43.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAmilia(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M240.1 32c-61.9 0-131.5 16.9-184.2 55.4-5.1 3.1-9.1 9.2-7.2 19.4 1.1 5.1 5.1 27.4 10.2 39.6 4.1 10.2 14.2 10.2 20.3 6.1 32.5-22.3 96.5-47.7 152.3-47.7 57.9 0 58.9 28.4 58.9 73.1v38.5C203 227.7 78.2 251 46.7 264.2 11.2 280.5 16.3 357.7 16.3 376s15.2 104 124.9 104c47.8 0 113.7-20.7 153.3-42.1v25.4c0 3 2.1 8.2 6.1 9.1 3.1 1 50.7 2 59.9 2s62.5.3 66.5-.7c4.1-1 5.1-6.1 5.1-9.1V168c-.1-80.3-57.9-136-192-136zm50.2 348c-21.4 13.2-48.7 24.4-79.1 24.4-52.8 0-58.9-33.5-59-44.7 0-12.2-3-42.7 18.3-52.9 24.3-13.2 75.1-29.4 119.8-33.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAndroid(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M420.55,301.93a24,24,0,1,1,24-24,24,24,0,0,1-24,24m-265.1,0a24,24,0,1,1,24-24,24,24,0,0,1-24,24m273.7-144.48,47.94-83a10,10,0,1,0-17.27-10h0l-48.54,84.07a301.25,301.25,0,0,0-246.56,0L116.18,64.45a10,10,0,1,0-17.27,10h0l47.94,83C64.53,202.22,8.24,285.55,0,384H576c-8.24-98.45-64.54-181.78-146.85-226.55"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAngellist(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M347.1 215.4c11.7-32.6 45.4-126.9 45.4-157.1 0-26.6-15.7-48.9-43.7-48.9-44.6 0-84.6 131.7-97.1 163.1C242 144 196.6 0 156.6 0c-31.1 0-45.7 22.9-45.7 51.7 0 35.3 34.2 126.8 46.6 162-6.3-2.3-13.1-4.3-20-4.3-23.4 0-48.3 29.1-48.3 52.6 0 8.9 4.9 21.4 8 29.7-36.9 10-51.1 34.6-51.1 71.7C46 435.6 114.4 512 210.6 512c118 0 191.4-88.6 191.4-202.9 0-43.1-6.9-82-54.9-93.7zM311.7 108c4-12.3 21.1-64.3 37.1-64.3 8.6 0 10.9 8.9 10.9 16 0 19.1-38.6 124.6-47.1 148l-34-6 33.1-93.7zM142.3 48.3c0-11.9 14.5-45.7 46.3 47.1l34.6 100.3c-15.6-1.3-27.7-3-35.4 1.4-10.9-28.8-45.5-119.7-45.5-148.8zM140 244c29.3 0 67.1 94.6 67.1 107.4 0 5.1-4.9 11.4-10.6 11.4-20.9 0-76.9-76.9-76.9-97.7.1-7.7 12.7-21.1 20.4-21.1zm184.3 186.3c-29.1 32-66.3 48.6-109.7 48.6-59.4 0-106.3-32.6-128.9-88.3-17.1-43.4 3.8-68.3 20.6-68.3 11.4 0 54.3 60.3 54.3 73.1 0 4.9-7.7 8.3-11.7 8.3-16.1 0-22.4-15.5-51.1-51.4-29.7 29.7 20.5 86.9 58.3 86.9 26.1 0 43.1-24.2 38-42 3.7 0 8.3.3 11.7-.6 1.1 27.1 9.1 59.4 41.7 61.7 0-.9 2-7.1 2-7.4 0-17.4-10.6-32.6-10.6-50.3 0-28.3 21.7-55.7 43.7-71.7 8-6 17.7-9.7 27.1-13.1 9.7-3.7 20-8 27.4-15.4-1.1-11.2-5.7-21.1-16.9-21.1-27.7 0-120.6 4-120.6-39.7 0-6.7.1-13.1 17.4-13.1 32.3 0 114.3 8 138.3 29.1 18.1 16.1 24.3 113.2-31 174.7zm-98.6-126c9.7 3.1 19.7 4 29.7 6-7.4 5.4-14 12-20.3 19.1-2.8-8.5-6.2-16.8-9.4-25.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAngrycreative(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M640 238.2l-3.2 28.2-34.5 2.3-2 18.1 34.5-2.3-3.2 28.2-34.4 2.2-2.3 20.1 34.4-2.2-3 26.1-64.7 4.1 12.7-113.2L527 365.2l-31.9 2-23.8-117.8 30.3-2 13.6 79.4 31.7-82.4 93.1-6.2zM426.8 371.5l28.3-1.8L468 249.6l-28.4 1.9-12.8 120zM162 388.1l-19.4-36-3.5 37.4-28.2 1.7 2.7-29.1c-11 18-32 34.3-56.9 35.8C23.9 399.9-3 377 .3 339.7c2.6-29.3 26.7-62.8 67.5-65.4 37.7-2.4 47.6 23.2 51.3 28.8l2.8-30.8 38.9-2.5c20.1-1.3 38.7 3.7 42.5 23.7l2.6-26.6 64.8-4.2-2.7 27.9-36.4 2.4-1.7 17.9 36.4-2.3-2.7 27.9-36.4 2.3-1.9 19.9 36.3-2.3-2.1 20.8 55-117.2 23.8-1.6L370.4 369l8.9-85.6-22.3 1.4 2.9-27.9 75-4.9-3 28-24.3 1.6-9.7 91.9-58 3.7-4.3-15.6-39.4 2.5-8 16.3-126.2 7.7zm-44.3-70.2l-26.4 1.7C84.6 307.2 76.9 303 65 303.8c-19 1.2-33.3 17.5-34.6 33.3-1.4 16 7.3 32.5 28.7 31.2 12.8-.8 21.3-8.6 28.9-18.9l27-1.7 2.7-29.8zm56.1-7.7c1.2-12.9-7.6-13.6-26.1-12.4l-2.7 28.5c14.2-.9 27.5-2.1 28.8-16.1zm21.1 70.8l5.8-60c-5 13.5-14.7 21.1-27.9 26.6l22.1 33.4zm135.4-45l-7.9-37.8-15.8 39.3 23.7-1.5zm-170.1-74.6l-4.3-17.5-39.6 2.6-8.1 18.2-31.9 2.1 57-121.9 23.9-1.6 30.7 102 9.9-104.7 27-1.8 37.8 63.6 6.5-66.6 28.5-1.9-4 41.2c7.4-13.5 22.9-44.7 63.6-47.5 40.5-2.8 52.4 29.3 53.4 30.3l3.3-32 39.3-2.7c12.7-.9 27.8.3 36.3 9.7l-4.4-11.9 32.2-2.2 12.9 43.2 23-45.7 31-2.2-43.6 78.4-4.8 44.3-28.4 1.9 4.8-44.3-15.8-43c1 22.3-9.2 40.1-32 49.6l25.2 38.8-36.4 2.4-19.2-36.8-4 38.3-28.4 1.9 3.3-31.5c-6.7 9.3-19.7 35.4-59.6 38-26.2 1.7-45.6-10.3-55.4-39.2l-4 40.3-25 1.6-37.6-63.3-6.3 66.2-56.8 3.7zm276.6-82.1c10.2-.7 17.5-2.1 21.6-4.3 4.5-2.4 7-6.4 7.6-12.1.6-5.3-.6-8.8-3.4-10.4-3.6-2.1-10.6-2.8-22.9-2l-2.9 28.8zM327.7 214c5.6 5.9 12.7 8.5 21.3 7.9 4.7-.3 9.1-1.8 13.3-4.1 5.5-3 10.6-8 15.1-14.3l-34.2 2.3 2.4-23.9 63.1-4.3 1.2-12-31.2 2.1c-4.1-3.7-7.8-6.6-11.1-8.1-4-1.7-8.1-2.8-12.2-2.5-8 .5-15.3 3.6-22 9.2-7.7 6.4-12 14.5-12.9 24.4-1.1 9.6 1.4 17.3 7.2 23.3zm-201.3 8.2l23.8-1.6-8.3-37.6-15.5 39.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAngular(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M185.7 268.1h76.2l-38.1-91.6-38.1 91.6zM223.8 32L16 106.4l31.8 275.7 176 97.9 176-97.9 31.8-275.7zM354 373.8h-48.6l-26.2-65.4H168.6l-26.2 65.4H93.7L223.8 81.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAppStoreIos(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM127 384.5c-5.5 9.6-17.8 12.8-27.3 7.3-9.6-5.5-12.8-17.8-7.3-27.3l14.3-24.7c16.1-4.9 29.3-1.1 39.6 11.4L127 384.5zm138.9-53.9H84c-11 0-20-9-20-20s9-20 20-20h51l65.4-113.2-20.5-35.4c-5.5-9.6-2.2-21.8 7.3-27.3 9.6-5.5 21.8-2.2 27.3 7.3l8.9 15.4 8.9-15.4c5.5-9.6 17.8-12.8 27.3-7.3 9.6 5.5 12.8 17.8 7.3 27.3l-85.8 148.6h62.1c20.2 0 31.5 23.7 22.7 40zm98.1 0h-29l19.6 33.9c5.5 9.6 2.2 21.8-7.3 27.3-9.6 5.5-21.8 2.2-27.3-7.3-32.9-56.9-57.5-99.7-74-128.1-16.7-29-4.8-58 7.1-67.8 13.1 22.7 32.7 56.7 58.9 102h52c11 0 20 9 20 20 0 11.1-9 20-20 20z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAppStore(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M255.9 120.9l9.1-15.7c5.6-9.8 18.1-13.1 27.9-7.5 9.8 5.6 13.1 18.1 7.5 27.9l-87.5 151.5h63.3c20.5 0 32 24.1 23.1 40.8H113.8c-11.3 0-20.4-9.1-20.4-20.4 0-11.3 9.1-20.4 20.4-20.4h52l66.6-115.4-20.8-36.1c-5.6-9.8-2.3-22.2 7.5-27.9 9.8-5.6 22.2-2.3 27.9 7.5l8.9 15.7zm-78.7 218l-19.6 34c-5.6 9.8-18.1 13.1-27.9 7.5-9.8-5.6-13.1-18.1-7.5-27.9l14.6-25.2c16.4-5.1 29.8-1.2 40.4 11.6zm168.9-61.7h53.1c11.3 0 20.4 9.1 20.4 20.4 0 11.3-9.1 20.4-20.4 20.4h-29.5l19.9 34.5c5.6 9.8 2.3 22.2-7.5 27.9-9.8 5.6-22.2 2.3-27.9-7.5-33.5-58.1-58.7-101.6-75.4-130.6-17.1-29.5-4.9-59.1 7.2-69.1 13.4 23 33.4 57.7 60.1 104zM256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm216 248c0 118.7-96.1 216-216 216-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaApper(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M42.1 239.1c22.2 0 29 2.8 33.5 14.6h.8v-22.9c0-11.3-4.8-15.4-17.9-15.4-11.3 0-14.4 2.5-15.1 12.8H4.8c.3-13.9 1.5-19.1 5.8-24.4C17.9 195 29.5 192 56.7 192c33 0 47.1 5 53.9 18.9 2 4.3 4 15.6 4 23.7v76.3H76.3l1.3-19.1h-1c-5.3 15.6-13.6 20.4-35.5 20.4-30.3 0-41.1-10.1-41.1-37.3 0-25.2 12.3-35.8 42.1-35.8zm17.1 48.1c13.1 0 16.9-3 16.9-13.4 0-9.1-4.3-11.6-19.6-11.6-13.1 0-17.9 3-17.9 12.1-.1 10.4 3.7 12.9 20.6 12.9zm77.8-94.9h38.3l-1.5 20.6h.8c9.1-17.1 15.9-20.9 37.5-20.9 14.4 0 24.7 3 31.5 9.1 9.8 8.6 12.8 20.4 12.8 48.1 0 30-3 43.1-12.1 52.9-6.8 7.3-16.4 10.1-33.2 10.1-20.4 0-29.2-5.5-33.8-21.2h-.8v70.3H137v-169zm80.9 60.7c0-27.5-3.3-32.5-20.7-32.5-16.9 0-20.7 5-20.7 28.7 0 28 3.5 33.5 21.2 33.5 16.4 0 20.2-5.6 20.2-29.7zm57.9-60.7h38.3l-1.5 20.6h.8c9.1-17.1 15.9-20.9 37.5-20.9 14.4 0 24.7 3 31.5 9.1 9.8 8.6 12.8 20.4 12.8 48.1 0 30-3 43.1-12.1 52.9-6.8 7.3-16.4 10.1-33.3 10.1-20.4 0-29.2-5.5-33.8-21.2h-.8v70.3h-39.5v-169zm80.9 60.7c0-27.5-3.3-32.5-20.7-32.5-16.9 0-20.7 5-20.7 28.7 0 28 3.5 33.5 21.2 33.5 16.4 0 20.2-5.6 20.2-29.7zm53.8-3.8c0-25.4 3.3-37.8 12.3-45.8 8.8-8.1 22.2-11.3 45.1-11.3 42.8 0 55.7 12.8 55.7 55.7v11.1h-75.3c-.3 2-.3 4-.3 4.8 0 16.9 4.5 21.9 20.1 21.9 13.9 0 17.9-3 17.9-13.9h37.5v2.3c0 9.8-2.5 18.9-6.8 24.7-7.3 9.8-19.6 13.6-44.3 13.6-27.5 0-41.6-3.3-50.6-12.3-8.5-8.5-11.3-21.3-11.3-50.8zm76.4-11.6c-.3-1.8-.3-3.3-.3-3.8 0-12.3-3.3-14.6-19.6-14.6-14.4 0-17.1 3-18.1 15.1l-.3 3.3h38.3zm55.6-45.3h38.3l-1.8 19.9h.7c6.8-14.9 14.4-20.2 29.7-20.2 10.8 0 19.1 3.3 23.4 9.3 5.3 7.3 6.8 14.4 6.8 34 0 1.5 0 5 .2 9.3h-35c.3-1.8.3-3.3.3-4 0-15.4-2-19.4-10.3-19.4-6.3 0-10.8 3.3-13.1 9.3-1 3-1 4.3-1 12.3v68h-38.3V192.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaApplePay(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M116.9 158.5c-7.5 8.9-19.5 15.9-31.5 14.9-1.5-12 4.4-24.8 11.3-32.6 7.5-9.1 20.6-15.6 31.3-16.1 1.2 12.4-3.7 24.7-11.1 33.8m10.9 17.2c-17.4-1-32.3 9.9-40.5 9.9-8.4 0-21-9.4-34.8-9.1-17.9.3-34.5 10.4-43.6 26.5-18.8 32.3-4.9 80 13.3 106.3 8.9 13 19.5 27.3 33.5 26.8 13.3-.5 18.5-8.6 34.5-8.6 16.1 0 20.8 8.6 34.8 8.4 14.5-.3 23.6-13 32.5-26 10.1-14.8 14.3-29.1 14.5-29.9-.3-.3-28-10.9-28.3-42.9-.3-26.8 21.9-39.5 22.9-40.3-12.5-18.6-32-20.6-38.8-21.1m100.4-36.2v194.9h30.3v-66.6h41.9c38.3 0 65.1-26.3 65.1-64.3s-26.4-64-64.1-64h-73.2zm30.3 25.5h34.9c26.3 0 41.3 14 41.3 38.6s-15 38.8-41.4 38.8h-34.8V165zm162.2 170.9c19 0 36.6-9.6 44.6-24.9h.6v23.4h28v-97c0-28.1-22.5-46.3-57.1-46.3-32.1 0-55.9 18.4-56.8 43.6h27.3c2.3-12 13.4-19.9 28.6-19.9 18.5 0 28.9 8.6 28.9 24.5v10.8l-37.8 2.3c-35.1 2.1-54.1 16.5-54.1 41.5.1 25.2 19.7 42 47.8 42zm8.2-23.1c-16.1 0-26.4-7.8-26.4-19.6 0-12.3 9.9-19.4 28.8-20.5l33.6-2.1v11c0 18.2-15.5 31.2-36 31.2zm102.5 74.6c29.5 0 43.4-11.3 55.5-45.4L640 193h-30.8l-35.6 115.1h-.6L537.4 193h-31.6L557 334.9l-2.8 8.6c-4.6 14.6-12.1 20.3-25.5 20.3-2.4 0-7-.3-8.9-.5v23.4c1.8.4 9.3.7 11.6.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaApple(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArtstation(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 377.4l43 74.3A51.35 51.35 0 0 0 90.9 480h285.4l-59.2-102.6zM501.8 350L335.6 59.3A51.38 51.38 0 0 0 290.2 32h-88.4l257.3 447.6 40.7-70.5c1.9-3.2 21-29.7 2-59.1zM275 304.5l-115.5-200L44 304.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAsymmetrik(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M517.5 309.2c38.8-40 58.1-80 58.5-116.1.8-65.5-59.4-118.2-169.4-135C277.9 38.4 118.1 73.6 0 140.5 52 114 110.6 92.3 170.7 82.3c74.5-20.5 153-25.4 221.3-14.8C544.5 91.3 588.8 195 490.8 299.2c-10.2 10.8-22 21.1-35 30.6L304.9 103.4 114.7 388.9c-65.6-29.4-76.5-90.2-19.1-151.2 20.8-22.2 48.3-41.9 79.5-58.1 20-12.2 39.7-22.6 62-30.7-65.1 20.3-122.7 52.9-161.6 92.9-27.7 28.6-41.4 57.1-41.7 82.9-.5 35.1 23.4 65.1 68.4 83l-34.5 51.7h101.6l22-34.4c22.2 1 45.3 0 68.6-2.7l-22.8 37.1h135.5L340 406.3c18.6-5.3 36.9-11.5 54.5-18.7l45.9 71.8H542L468.6 349c18.5-12.1 35-25.5 48.9-39.8zm-187.6 80.5l-25-40.6-32.7 53.3c-23.4 3.5-46.7 5.1-69.2 4.4l101.9-159.3 78.7 123c-17.2 7.4-35.3 13.9-53.7 19.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAtlassian(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M152.2 236.4c-7.7-8.2-19.7-7.7-24.8 2.8L1.6 490.2c-5 10 2.4 21.7 13.4 21.7h175c5.8.1 11-3.2 13.4-8.4 37.9-77.8 15.1-196.3-51.2-267.1zM244.4 8.1c-122.3 193.4-8.5 348.6 65 495.5 2.5 5.1 7.7 8.4 13.4 8.4H497c11.2 0 18.4-11.8 13.4-21.7 0 0-234.5-470.6-240.4-482.3-5.3-10.6-18.8-10.8-25.6.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAudible(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M640 199.9v54l-320 200L0 254v-54l320 200 320-200.1zm-194.5 72l47.1-29.4c-37.2-55.8-100.7-92.6-172.7-92.6-72 0-135.5 36.7-172.6 92.4h.3c2.5-2.3 5.1-4.5 7.7-6.7 89.7-74.4 219.4-58.1 290.2 36.3zm-220.1 18.8c16.9-11.9 36.5-18.7 57.4-18.7 34.4 0 65.2 18.4 86.4 47.6l45.4-28.4c-20.9-29.9-55.6-49.5-94.8-49.5-38.9 0-73.4 19.4-94.4 49zM103.6 161.1c131.8-104.3 318.2-76.4 417.5 62.1l.7 1 48.8-30.4C517.1 112.1 424.8 58.1 319.9 58.1c-103.5 0-196.6 53.5-250.5 135.6 9.9-10.5 22.7-23.5 34.2-32.6zm467 32.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAutoprefixer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M318.4 16l-161 480h77.5l25.4-81.4h119.5L405 496h77.5L318.4 16zm-40.3 341.9l41.2-130.4h1.5l40.9 130.4h-83.6zM640 405l-10-31.4L462.1 358l19.4 56.5L640 405zm-462.1-47L10 373.7 0 405l158.5 9.4 19.4-56.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAvianex(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M453.1 32h-312c-38.9 0-76.2 31.2-83.3 69.7L1.2 410.3C-5.9 448.8 19.9 480 58.9 480h312c38.9 0 76.2-31.2 83.3-69.7l56.7-308.5c7-38.6-18.8-69.8-57.8-69.8zm-58.2 347.3l-32 13.5-115.4-110c-14.7 10-29.2 19.5-41.7 27.1l22.1 64.2-17.9 12.7-40.6-61-52.4-48.1 15.7-15.4 58 31.1c9.3-10.5 20.8-22.6 32.8-34.9L203 228.9l-68.8-99.8 18.8-28.9 8.9-4.8L265 207.8l4.9 4.5c19.4-18.8 33.8-32.4 33.8-32.4 7.7-6.5 21.5-2.9 30.7 7.9 9 10.5 10.6 24.7 2.7 31.3-1.8 1.3-15.5 11.4-35.3 25.6l4.5 7.3 94.9 119.4-6.3 7.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAviato(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M107.2 283.5l-19-41.8H36.1l-19 41.8H0l62.2-131.4 62.2 131.4h-17.2zm-45-98.1l-19.6 42.5h39.2l-19.6-42.5zm112.7 102.4l-62.2-131.4h17.1l45.1 96 45.1-96h17l-62.1 131.4zm80.6-4.3V156.4H271v127.1h-15.5zm209.1-115.6v115.6h-17.3V167.9h-41.2v-11.5h99.6v11.5h-41.1zM640 218.8c0 9.2-1.7 17.8-5.1 25.8-3.4 8-8.2 15.1-14.2 21.1-6 6-13.1 10.8-21.1 14.2-8 3.4-16.6 5.1-25.8 5.1s-17.8-1.7-25.8-5.1c-8-3.4-15.1-8.2-21.1-14.2-6-6-10.8-13-14.2-21.1-3.4-8-5.1-16.6-5.1-25.8s1.7-17.8 5.1-25.8c3.4-8 8.2-15.1 14.2-21.1 6-6 13-8.4 21.1-11.9 8-3.4 16.6-5.1 25.8-5.1s17.8 1.7 25.8 5.1c8 3.4 15.1 5.8 21.1 11.9 6 6 10.7 13.1 14.2 21.1 3.4 8 5.1 16.6 5.1 25.8zm-15.5 0c0-7.3-1.3-14-3.9-20.3-2.6-6.3-6.2-11.7-10.8-16.3-4.6-4.6-10-8.2-16.2-10.9-6.2-2.7-12.8-4-19.8-4s-13.6 1.3-19.8 4c-6.2 2.7-11.6 6.3-16.2 10.9-4.6 4.6-8.2 10-10.8 16.3-2.6 6.3-3.9 13.1-3.9 20.3 0 7.3 1.3 14 3.9 20.3 2.6 6.3 6.2 11.7 10.8 16.3 4.6 4.6 10 8.2 16.2 10.9 6.2 2.7 12.8 4 19.8 4s13.6-1.3 19.8-4c6.2-2.7 11.6-6.3 16.2-10.9 4.6-4.6 8.2-10 10.8-16.3 2.6-6.3 3.9-13.1 3.9-20.3zm-94.8 96.7v-6.3l88.9-10-242.9 13.4c.6-2.2 1.1-4.6 1.4-7.2.3-2 .5-4.2.6-6.5l64.8-8.1-64.9 1.9c0-.4-.1-.7-.1-1.1-2.8-17.2-25.5-23.7-25.5-23.7l-1.1-26.3h23.8l19 41.8h17.1L348.6 152l-62.2 131.4h17.1l19-41.8h23.6L345 268s-22.7 6.5-25.5 23.7c-.1.3-.1.7-.1 1.1l-64.9-1.9 64.8 8.1c.1 2.3.3 4.4.6 6.5.3 2.6.8 5 1.4 7.2L78.4 299.2l88.9 10v6.3c-5.9.9-10.5 6-10.5 12.2 0 6.8 5.6 12.4 12.4 12.4 6.8 0 12.4-5.6 12.4-12.4 0-6.2-4.6-11.3-10.5-12.2v-5.8l80.3 9v5.4c-5.7 1.1-9.9 6.2-9.9 12.1 0 6.8 5.6 10.2 12.4 10.2 6.8 0 12.4-3.4 12.4-10.2 0-6-4.3-11-9.9-12.1v-4.9l28.4 3.2v23.7h-5.9V360h5.9v-6.6h5v6.6h5.9v-13.8h-5.9V323l38.3 4.3c8.1 11.4 19 13.6 19 13.6l-.1 6.7-5.1.2-.1 12.1h4.1l.1-5h5.2l.1 5h4.1l-.1-12.1-5.1-.2-.1-6.7s10.9-2.1 19-13.6l38.3-4.3v23.2h-5.9V360h5.9v-6.6h5v6.6h5.9v-13.8h-5.9v-23.7l28.4-3.2v4.9c-5.7 1.1-9.9 6.2-9.9 12.1 0 6.8 5.6 10.2 12.4 10.2 6.8 0 12.4-3.4 12.4-10.2 0-6-4.3-11-9.9-12.1v-5.4l80.3-9v5.8c-5.9.9-10.5 6-10.5 12.2 0 6.8 5.6 12.4 12.4 12.4 6.8 0 12.4-5.6 12.4-12.4-.2-6.3-4.7-11.4-10.7-12.3zm-200.8-87.6l19.6-42.5 19.6 42.5h-17.9l-1.7-40.3-1.7 40.3h-17.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAws(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M180.41 203.01c-.72 22.65 10.6 32.68 10.88 39.05a8.164 8.164 0 0 1-4.1 6.27l-12.8 8.96a10.66 10.66 0 0 1-5.63 1.92c-.43-.02-8.19 1.83-20.48-25.61a78.608 78.608 0 0 1-62.61 29.45c-16.28.89-60.4-9.24-58.13-56.21-1.59-38.28 34.06-62.06 70.93-60.05 7.1.02 21.6.37 46.99 6.27v-15.62c2.69-26.46-14.7-46.99-44.81-43.91-2.4.01-19.4-.5-45.84 10.11-7.36 3.38-8.3 2.82-10.75 2.82-7.41 0-4.36-21.48-2.94-24.2 5.21-6.4 35.86-18.35 65.94-18.18a76.857 76.857 0 0 1 55.69 17.28 70.285 70.285 0 0 1 17.67 52.36l-.01 69.29zM93.99 235.4c32.43-.47 46.16-19.97 49.29-30.47 2.46-10.05 2.05-16.41 2.05-27.4-9.67-2.32-23.59-4.85-39.56-4.87-15.15-1.14-42.82 5.63-41.74 32.26-1.24 16.79 11.12 31.4 29.96 30.48zm170.92 23.05c-7.86.72-11.52-4.86-12.68-10.37l-49.8-164.65c-.97-2.78-1.61-5.65-1.92-8.58a4.61 4.61 0 0 1 3.86-5.25c.24-.04-2.13 0 22.25 0 8.78-.88 11.64 6.03 12.55 10.37l35.72 140.83 33.16-140.83c.53-3.22 2.94-11.07 12.8-10.24h17.16c2.17-.18 11.11-.5 12.68 10.37l33.42 142.63L420.98 80.1c.48-2.18 2.72-11.37 12.68-10.37h19.72c.85-.13 6.15-.81 5.25 8.58-.43 1.85 3.41-10.66-52.75 169.9-1.15 5.51-4.82 11.09-12.68 10.37h-18.69c-10.94 1.15-12.51-9.66-12.68-10.75L328.67 110.7l-32.78 136.99c-.16 1.09-1.73 11.9-12.68 10.75h-18.3zm273.48 5.63c-5.88.01-33.92-.3-57.36-12.29a12.802 12.802 0 0 1-7.81-11.91v-10.75c0-8.45 6.2-6.9 8.83-5.89 10.04 4.06 16.48 7.14 28.81 9.6 36.65 7.53 52.77-2.3 56.72-4.48 13.15-7.81 14.19-25.68 5.25-34.95-10.48-8.79-15.48-9.12-53.13-21-4.64-1.29-43.7-13.61-43.79-52.36-.61-28.24 25.05-56.18 69.52-55.95 12.67-.01 46.43 4.13 55.57 15.62 1.35 2.09 2.02 4.55 1.92 7.04v10.11c0 4.44-1.62 6.66-4.87 6.66-7.71-.86-21.39-11.17-49.16-10.75-6.89-.36-39.89.91-38.41 24.97-.43 18.96 26.61 26.07 29.7 26.89 36.46 10.97 48.65 12.79 63.12 29.58 17.14 22.25 7.9 48.3 4.35 55.44-19.08 37.49-68.42 34.44-69.26 34.42zm40.2 104.86c-70.03 51.72-171.69 79.25-258.49 79.25A469.127 469.127 0 0 1 2.83 327.46c-6.53-5.89-.77-13.96 7.17-9.47a637.37 637.37 0 0 0 316.88 84.12 630.22 630.22 0 0 0 241.59-49.55c11.78-5 21.77 7.8 10.12 16.38zm29.19-33.29c-8.96-11.52-59.28-5.38-81.81-2.69-6.79.77-7.94-5.12-1.79-9.47 40.07-28.17 105.88-20.1 113.44-10.63 7.55 9.47-2.05 75.41-39.56 106.91-5.76 4.87-11.27 2.3-8.71-4.1 8.44-21.25 27.39-68.49 18.43-80.02z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBandcamp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256,8C119,8,8,119,8,256S119,504,256,504,504,393,504,256,393,8,256,8Zm48.2,326.1h-181L207.9,178h181Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBattleNet(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448.61 225.62c26.87.18 35.57-7.43 38.92-12.37 12.47-16.32-7.06-47.6-52.85-71.33 17.76-33.58 30.11-63.68 36.34-85.3 3.38-11.83 1.09-19 .45-20.25-1.72 10.52-15.85 48.46-48.2 100.05-25-11.22-56.52-20.1-93.77-23.8-8.94-16.94-34.88-63.86-60.48-88.93C252.18 7.14 238.7 1.07 228.18.22h-.05c-13.83-1.55-22.67 5.85-27.4 11-17.2 18.53-24.33 48.87-25 84.07-7.24-12.35-17.17-24.63-28.5-25.93h-.18c-20.66-3.48-38.39 29.22-36 81.29-38.36 1.38-71 5.75-93 11.23-9.9 2.45-16.22 7.27-17.76 9.72 1-.38 22.4-9.22 111.56-9.22 5.22 53 29.75 101.82 26 93.19-9.73 15.4-38.24 62.36-47.31 97.7-5.87 22.88-4.37 37.61.15 47.14 5.57 12.75 16.41 16.72 23.2 18.26 25 5.71 55.38-3.63 86.7-21.14-7.53 12.84-13.9 28.51-9.06 39.34 7.31 19.65 44.49 18.66 88.44-9.45 20.18 32.18 40.07 57.94 55.7 74.12a39.79 39.79 0 0 0 8.75 7.09c5.14 3.21 8.58 3.37 8.58 3.37-8.24-6.75-34-38-62.54-91.78 22.22-16 45.65-38.87 67.47-69.27 122.82 4.6 143.29-24.76 148-31.64 14.67-19.88 3.43-57.44-57.32-93.69zm-77.85 106.22c23.81-37.71 30.34-67.77 29.45-92.33 27.86 17.57 47.18 37.58 49.06 58.83 1.14 12.93-8.1 29.12-78.51 33.5zM216.9 387.69c9.76-6.23 19.53-13.12 29.2-20.49 6.68 13.33 13.6 26.1 20.6 38.19-40.6 21.86-68.84 12.76-49.8-17.7zm215-171.35c-10.29-5.34-21.16-10.34-32.38-15.05a722.459 722.459 0 0 0 22.74-36.9c39.06 24.1 45.9 53.18 9.64 51.95zM279.18 398c-5.51-11.35-11-23.5-16.5-36.44 43.25 1.27 62.42-18.73 63.28-20.41 0 .07-25 15.64-62.53 12.25a718.78 718.78 0 0 0 85.06-84q13.06-15.31 24.93-31.11c-.36-.29-1.54-3-16.51-12-51.7 60.27-102.34 98-132.75 115.92-20.59-11.18-40.84-31.78-55.71-61.49-20-39.92-30-82.39-31.57-116.07 12.3.91 25.27 2.17 38.85 3.88-22.29 36.8-14.39 63-13.47 64.23 0-.07-.95-29.17 20.14-59.57a695.23 695.23 0 0 0 44.67 152.84c.93-.38 1.84.88 18.67-8.25-26.33-74.47-33.76-138.17-34-173.43 20-12.42 48.18-19.8 81.63-17.81 44.57 2.67 86.36 15.25 116.32 30.71q-10.69 15.66-23.33 32.47C365.63 152 339.1 145.84 337.5 146c.11 0 25.9 14.07 41.52 47.22a717.63 717.63 0 0 0-115.34-31.71 646.608 646.608 0 0 0-39.39-6.05c-.07.45-1.81 1.85-2.16 20.33C300 190.28 358.78 215.68 389.36 233c.74 23.55-6.95 51.61-25.41 79.57-24.6 37.31-56.39 67.23-84.77 85.43zm27.4-287c-44.56-1.66-73.58 7.43-94.69 20.67 2-52.3 21.31-76.38 38.21-75.28C267 52.15 305 108.55 306.58 111zm-130.65 3.1c.48 12.11 1.59 24.62 3.21 37.28-14.55-.85-28.74-1.25-42.4-1.26-.08 3.24-.12-51 24.67-49.59h.09c5.76 1.09 10.63 6.88 14.43 13.57zm-28.06 162c20.76 39.7 43.3 60.57 65.25 72.31-46.79 24.76-77.53 20-84.92 4.51-.2-.21-11.13-15.3 19.67-76.81zm210.06 74.8"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBehanceSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M186.5 293c0 19.3-14 25.4-31.2 25.4h-45.1v-52.9h46c18.6.1 30.3 7.8 30.3 27.5zm-7.7-82.3c0-17.7-13.7-21.9-28.9-21.9h-39.6v44.8H153c15.1 0 25.8-6.6 25.8-22.9zm132.3 23.2c-18.3 0-30.5 11.4-31.7 29.7h62.2c-1.7-18.5-11.3-29.7-30.5-29.7zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zM271.7 185h77.8v-18.9h-77.8V185zm-43 110.3c0-24.1-11.4-44.9-35-51.6 17.2-8.2 26.2-17.7 26.2-37 0-38.2-28.5-47.5-61.4-47.5H68v192h93.1c34.9-.2 67.6-16.9 67.6-55.9zM380 280.5c0-41.1-24.1-75.4-67.6-75.4-42.4 0-71.1 31.8-71.1 73.6 0 43.3 27.3 73 71.1 73 33.2 0 54.7-14.9 65.1-46.8h-33.7c-3.7 11.9-18.6 18.1-30.2 18.1-22.4 0-34.1-13.1-34.1-35.3h100.2c.1-2.3.3-4.8.3-7.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBehance(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M232 237.2c31.8-15.2 48.4-38.2 48.4-74 0-70.6-52.6-87.8-113.3-87.8H0v354.4h171.8c64.4 0 124.9-30.9 124.9-102.9 0-44.5-21.1-77.4-64.7-89.7zM77.9 135.9H151c28.1 0 53.4 7.9 53.4 40.5 0 30.1-19.7 42.2-47.5 42.2h-79v-82.7zm83.3 233.7H77.9V272h84.9c34.3 0 56 14.3 56 50.6 0 35.8-25.9 47-57.6 47zm358.5-240.7H376V94h143.7v34.9zM576 305.2c0-75.9-44.4-139.2-124.9-139.2-78.2 0-131.3 58.8-131.3 135.8 0 79.9 50.3 134.7 131.3 134.7 61.3 0 101-27.6 120.1-86.3H509c-6.7 21.9-34.3 33.5-55.7 33.5-41.3 0-63-24.2-63-65.3h185.1c.3-4.2.6-8.7.6-13.2zM390.4 274c2.3-33.7 24.7-54.8 58.5-54.8 35.4 0 53.2 20.8 56.2 54.8H390.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBimobject(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 32H32C14.4 32 0 46.4 0 64v384c0 17.6 14.4 32 32 32h384c17.6 0 32-14.4 32-32V64c0-17.6-14.4-32-32-32zm-64 257.4c0 49.4-11.4 82.6-103.8 82.6h-16.9c-44.1 0-62.4-14.9-70.4-38.8h-.9V368H96V136h64v74.7h1.1c4.6-30.5 39.7-38.8 69.7-38.8h17.3c92.4 0 103.8 33.1 103.8 82.5v35zm-64-28.9v22.9c0 21.7-3.4 33.8-38.4 33.8h-45.3c-28.9 0-44.1-6.5-44.1-35.7v-19c0-29.3 15.2-35.7 44.1-35.7h45.3c35-.2 38.4 12 38.4 33.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBitbucket(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22.2 32A16 16 0 0 0 6 47.8a26.35 26.35 0 0 0 .2 2.8l67.9 412.1a21.77 21.77 0 0 0 21.3 18.2h325.7a16 16 0 0 0 16-13.4L505 50.7a16 16 0 0 0-13.2-18.3 24.58 24.58 0 0 0-2.8-.2L22.2 32zm285.9 297.8h-104l-28.1-147h157.3l-25.2 147z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBitcoin(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zm-141.651-35.33c4.937-32.999-20.191-50.739-54.55-62.573l11.146-44.702-27.213-6.781-10.851 43.524c-7.154-1.783-14.502-3.464-21.803-5.13l10.929-43.81-27.198-6.781-11.153 44.686c-5.922-1.349-11.735-2.682-17.377-4.084l.031-.14-37.53-9.37-7.239 29.062s20.191 4.627 19.765 4.913c11.022 2.751 13.014 10.044 12.68 15.825l-12.696 50.925c.76.194 1.744.473 2.829.907-.907-.225-1.876-.473-2.876-.713l-17.796 71.338c-1.349 3.348-4.767 8.37-12.471 6.464.271.395-19.78-4.937-19.78-4.937l-13.51 31.147 35.414 8.827c6.588 1.651 13.045 3.379 19.4 5.006l-11.262 45.213 27.182 6.781 11.153-44.733a1038.209 1038.209 0 0 0 21.687 5.627l-11.115 44.523 27.213 6.781 11.262-45.128c46.404 8.781 81.299 5.239 95.986-36.727 11.836-33.79-.589-53.281-25.004-65.991 17.78-4.098 31.174-15.792 34.747-39.949zm-62.177 87.179c-8.41 33.79-65.308 15.523-83.755 10.943l14.944-59.899c18.446 4.603 77.6 13.717 68.811 48.956zm8.417-87.667c-7.673 30.736-55.031 15.12-70.393 11.292l13.548-54.327c15.363 3.828 64.836 10.973 56.845 43.035z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBity(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M78.4 67.2C173.8-22 324.5-24 421.5 71c14.3 14.1-6.4 37.1-22.4 21.5-84.8-82.4-215.8-80.3-298.9-3.2-16.3 15.1-36.5-8.3-21.8-22.1zm98.9 418.6c19.3 5.7 29.3-23.6 7.9-30C73 421.9 9.4 306.1 37.7 194.8c5-19.6-24.9-28.1-30.2-7.1-32.1 127.4 41.1 259.8 169.8 298.1zm148.1-2c121.9-40.2 192.9-166.9 164.4-291-4.5-19.7-34.9-13.8-30 7.9 24.2 107.7-37.1 217.9-143.2 253.4-21.2 7-10.4 36 8.8 29.7zm-62.9-79l.2-71.8c0-8.2-6.6-14.8-14.8-14.8-8.2 0-14.8 6.7-14.8 14.8l-.2 71.8c0 8.2 6.6 14.8 14.8 14.8s14.8-6.6 14.8-14.8zm71-269c2.1 90.9 4.7 131.9-85.5 132.5-92.5-.7-86.9-44.3-85.5-132.5 0-21.8-32.5-19.6-32.5 0v71.6c0 69.3 60.7 90.9 118 90.1 57.3.8 118-20.8 118-90.1v-71.6c0-19.6-32.5-21.8-32.5 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBlackTie(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32v448h448V32H0zm316.5 325.2L224 445.9l-92.5-88.7 64.5-184-64.5-86.6h184.9L252 173.2l64.5 184z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBlackberry(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M166 116.9c0 23.4-16.4 49.1-72.5 49.1H23.4l21-88.8h67.8c42.1 0 53.8 23.3 53.8 39.7zm126.2-39.7h-67.8L205.7 166h70.1c53.8 0 70.1-25.7 70.1-49.1.1-16.4-11.6-39.7-53.7-39.7zM88.8 208.1H21L0 296.9h70.1c56.1 0 72.5-23.4 72.5-49.1 0-16.3-11.7-39.7-53.8-39.7zm180.1 0h-67.8l-18.7 88.8h70.1c53.8 0 70.1-23.4 70.1-49.1 0-16.3-11.7-39.7-53.7-39.7zm189.3-53.8h-67.8l-18.7 88.8h70.1c53.8 0 70.1-23.4 70.1-49.1.1-16.3-11.6-39.7-53.7-39.7zm-28 137.9h-67.8L343.7 381h70.1c56.1 0 70.1-23.4 70.1-49.1 0-16.3-11.6-39.7-53.7-39.7zM240.8 346H173l-18.7 88.8h70.1c56.1 0 70.1-25.7 70.1-49.1.1-16.3-11.6-39.7-53.7-39.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBloggerB(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M446.6 222.7c-1.8-8-6.8-15.4-12.5-18.5-1.8-1-13-2.2-25-2.7-20.1-.9-22.3-1.3-28.7-5-10.1-5.9-12.8-12.3-12.9-29.5-.1-33-13.8-63.7-40.9-91.3-19.3-19.7-40.9-33-65.5-40.5-5.9-1.8-19.1-2.4-63.3-2.9-69.4-.8-84.8.6-108.4 10C45.9 59.5 14.7 96.1 3.3 142.9 1.2 151.7.7 165.8.2 246.8c-.6 101.5.1 116.4 6.4 136.5 15.6 49.6 59.9 86.3 104.4 94.3 14.8 2.7 197.3 3.3 216 .8 32.5-4.4 58-17.5 81.9-41.9 17.3-17.7 28.1-36.8 35.2-62.1 4.9-17.6 4.5-142.8 2.5-151.7zm-322.1-63.6c7.8-7.9 10-8.2 58.8-8.2 43.9 0 45.4.1 51.8 3.4 9.3 4.7 13.4 11.3 13.4 21.9 0 9.5-3.8 16.2-12.3 21.6-4.6 2.9-7.3 3.1-50.3 3.3-26.5.2-47.7-.4-50.8-1.2-16.6-4.7-22.8-28.5-10.6-40.8zm191.8 199.8l-14.9 2.4-77.5.9c-68.1.8-87.3-.4-90.9-2-7.1-3.1-13.8-11.7-14.9-19.4-1.1-7.3 2.6-17.3 8.2-22.4 7.1-6.4 10.2-6.6 97.3-6.7 89.6-.1 89.1-.1 97.6 7.8 12.1 11.3 9.5 31.2-4.9 39.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBlogger(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M162.4 196c4.8-4.9 6.2-5.1 36.4-5.1 27.2 0 28.1.1 32.1 2.1 5.8 2.9 8.3 7 8.3 13.6 0 5.9-2.4 10-7.6 13.4-2.8 1.8-4.5 1.9-31.1 2.1-16.4.1-29.5-.2-31.5-.8-10.3-2.9-14.1-17.7-6.6-25.3zm61.4 94.5c-53.9 0-55.8.2-60.2 4.1-3.5 3.1-5.7 9.4-5.1 13.9.7 4.7 4.8 10.1 9.2 12 2.2 1 14.1 1.7 56.3 1.2l47.9-.6 9.2-1.5c9-5.1 10.5-17.4 3.1-24.4-5.3-4.7-5-4.7-60.4-4.7zm223.4 130.1c-3.5 28.4-23 50.4-51.1 57.5-7.2 1.8-9.7 1.9-172.9 1.8-157.8 0-165.9-.1-172-1.8-8.4-2.2-15.6-5.5-22.3-10-5.6-3.8-13.9-11.8-17-16.4-3.8-5.6-8.2-15.3-10-22C.1 423 0 420.3 0 256.3 0 93.2 0 89.7 1.8 82.6 8.1 57.9 27.7 39 53 33.4c7.3-1.6 332.1-1.9 340-.3 21.2 4.3 37.9 17.1 47.6 36.4 7.7 15.3 7-1.5 7.3 180.6.2 115.8 0 164.5-.7 170.5zm-85.4-185.2c-1.1-5-4.2-9.6-7.7-11.5-1.1-.6-8-1.3-15.5-1.7-12.4-.6-13.8-.8-17.8-3.1-6.2-3.6-7.9-7.6-8-18.3 0-20.4-8.5-39.4-25.3-56.5-12-12.2-25.3-20.5-40.6-25.1-3.6-1.1-11.8-1.5-39.2-1.8-42.9-.5-52.5.4-67.1 6.2-27 10.7-46.3 33.4-53.4 62.4-1.3 5.4-1.6 14.2-1.9 64.3-.4 62.8 0 72.1 4 84.5 9.7 30.7 37.1 53.4 64.6 58.4 9.2 1.7 122.2 2.1 133.7.5 20.1-2.7 35.9-10.8 50.7-25.9 10.7-10.9 17.4-22.8 21.8-38.5 3.2-10.9 2.9-88.4 1.7-93.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBluetoothB(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M196.48 260.023l92.626-103.333L143.125 0v206.33l-86.111-86.111-31.406 31.405 108.061 108.399L25.608 368.422l31.406 31.405 86.111-86.111L145.84 512l148.552-148.644-97.912-103.333zm40.86-102.996l-49.977 49.978-.338-100.295 50.315 50.317zM187.363 313.04l49.977 49.978-50.315 50.316.338-100.294z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBluetooth(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M292.6 171.1L249.7 214l-.3-86 43.2 43.1m-43.2 219.8l43.1-43.1-42.9-42.9-.2 86zM416 259.4C416 465 344.1 512 230.9 512S32 465 32 259.4 115.4 0 228.6 0 416 53.9 416 259.4zm-158.5 0l79.4-88.6L211.8 36.5v176.9L138 139.6l-27 26.9 92.7 93-92.7 93 26.9 26.9 73.8-73.8 2.3 170 127.4-127.5-83.9-88.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBootstrap(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M333.5,201.4c0-22.1-15.6-34.3-43-34.3h-50.4v71.2h42.5C315.4,238.2,333.5,225,333.5,201.4z M517,188.6 c-9.5-30.9-10.9-68.8-9.8-98.1c1.1-30.5-22.7-58.5-54.7-58.5H123.7c-32.1,0-55.8,28.1-54.7,58.5c1,29.3-0.3,67.2-9.8,98.1 c-9.6,31-25.7,50.6-52.2,53.1v28.5c26.4,2.5,42.6,22.1,52.2,53.1c9.5,30.9,10.9,68.8,9.8,98.1c-1.1,30.5,22.7,58.5,54.7,58.5h328.7 c32.1,0,55.8-28.1,54.7-58.5c-1-29.3,0.3-67.2,9.8-98.1c9.6-31,25.7-50.6,52.1-53.1v-28.5C542.7,239.2,526.5,219.6,517,188.6z M300.2,375.1h-97.9V136.8h97.4c43.3,0,71.7,23.4,71.7,59.4c0,25.3-19.1,47.9-43.5,51.8v1.3c33.2,3.6,55.5,26.6,55.5,58.3 C383.4,349.7,352.1,375.1,300.2,375.1z M290.2,266.4h-50.1v78.4h52.3c34.2,0,52.3-13.7,52.3-39.5 C344.7,279.6,326.1,266.4,290.2,266.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBtc(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M310.204 242.638c27.73-14.18 45.377-39.39 41.28-81.3-5.358-57.351-52.458-76.573-114.85-81.929V0h-48.528v77.203c-12.605 0-25.525.315-38.444.63V0h-48.528v79.409c-17.842.539-38.622.276-97.37 0v51.678c38.314-.678 58.417-3.14 63.023 21.427v217.429c-2.925 19.492-18.524 16.685-53.255 16.071L3.765 443.68c88.481 0 97.37.315 97.37.315V512h48.528v-67.06c13.234.315 26.154.315 38.444.315V512h48.528v-68.005c81.299-4.412 135.647-24.894 142.895-101.467 5.671-61.446-23.32-88.862-69.326-99.89zM150.608 134.553c27.415 0 113.126-8.507 113.126 48.528 0 54.515-85.71 48.212-113.126 48.212v-96.74zm0 251.776V279.821c32.772 0 133.127-9.138 133.127 53.255-.001 60.186-100.355 53.253-133.127 53.253z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBuffer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M427.84 380.67l-196.5 97.82a18.6 18.6 0 0 1-14.67 0L20.16 380.67c-4-2-4-5.28 0-7.29L67.22 350a18.65 18.65 0 0 1 14.69 0l134.76 67a18.51 18.51 0 0 0 14.67 0l134.76-67a18.62 18.62 0 0 1 14.68 0l47.06 23.43c4.05 1.96 4.05 5.24 0 7.24zm0-136.53l-47.06-23.43a18.62 18.62 0 0 0-14.68 0l-134.76 67.08a18.68 18.68 0 0 1-14.67 0L81.91 220.71a18.65 18.65 0 0 0-14.69 0l-47.06 23.43c-4 2-4 5.29 0 7.31l196.51 97.8a18.6 18.6 0 0 0 14.67 0l196.5-97.8c4.05-2.02 4.05-5.3 0-7.31zM20.16 130.42l196.5 90.29a20.08 20.08 0 0 0 14.67 0l196.51-90.29c4-1.86 4-4.89 0-6.74L231.33 33.4a19.88 19.88 0 0 0-14.67 0l-196.5 90.28c-4.05 1.85-4.05 4.88 0 6.74z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBuromobelexperte(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32v128h128V32H0zm120 120H8V40h112v112zm40-120v128h128V32H160zm120 120H168V40h112v112zm40-120v128h128V32H320zm120 120H328V40h112v112zM0 192v128h128V192H0zm120 120H8V200h112v112zm40-120v128h128V192H160zm120 120H168V200h112v112zm40-120v128h128V192H320zm120 120H328V200h112v112zM0 352v128h128V352H0zm120 120H8V360h112v112zm40-120v128h128V352H160zm120 120H168V360h112v112zm40-120v128h128V352H320z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBuyNLarge(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 32C133.27 32 7.79 132.32 7.79 256S133.27 480 288 480s280.21-100.32 280.21-224S442.73 32 288 32zm-85.39 357.19L64.1 390.55l77.25-290.74h133.44c63.15 0 84.93 28.65 78 72.84a60.24 60.24 0 0 1-1.5 6.85 77.39 77.39 0 0 0-17.21-1.93c-42.35 0-76.69 33.88-76.69 75.65 0 37.14 27.14 68 62.93 74.45-18.24 37.16-56.16 60.92-117.71 61.52zM358 207.11h32l-22.16 90.31h-35.41l-11.19-35.63-7.83 35.63h-37.83l26.63-90.31h31.34l15 36.75zm145.86 182.08H306.79L322.63 328a78.8 78.8 0 0 0 11.47.83c42.34 0 76.69-33.87 76.69-75.65 0-32.65-21-60.46-50.38-71.06l21.33-82.35h92.5l-53.05 205.36h103.87zM211.7 269.39H187l-13.8 56.47h24.7c16.14 0 32.11-3.18 37.94-26.65 5.56-22.31-7.99-29.82-24.14-29.82zM233 170h-21.34L200 217.71h21.37c18 0 35.38-14.64 39.21-30.14C265.23 168.71 251.07 170 233 170z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBuysellads(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 150.7l42.9 160.7h-85.8L224 150.7zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-65.3 325.3l-94.5-298.7H159.8L65.3 405.3H156l111.7-91.6 24.2 91.6h90.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCanadianMapleLeaf(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M383.8 351.7c2.5-2.5 105.2-92.4 105.2-92.4l-17.5-7.5c-10-4.9-7.4-11.5-5-17.4 2.4-7.6 20.1-67.3 20.1-67.3s-47.7 10-57.7 12.5c-7.5 2.4-10-2.5-12.5-7.5s-15-32.4-15-32.4-52.6 59.9-55.1 62.3c-10 7.5-20.1 0-17.6-10 0-10 27.6-129.6 27.6-129.6s-30.1 17.4-40.1 22.4c-7.5 5-12.6 5-17.6-5C293.5 72.3 255.9 0 255.9 0s-37.5 72.3-42.5 79.8c-5 10-10 10-17.6 5-10-5-40.1-22.4-40.1-22.4S183.3 182 183.3 192c2.5 10-7.5 17.5-17.6 10-2.5-2.5-55.1-62.3-55.1-62.3S98.1 167 95.6 172s-5 9.9-12.5 7.5C73 177 25.4 167 25.4 167s17.6 59.7 20.1 67.3c2.4 6 5 12.5-5 17.4L23 259.3s102.6 89.9 105.2 92.4c5.1 5 10 7.5 5.1 22.5-5.1 15-10.1 35.1-10.1 35.1s95.2-20.1 105.3-22.6c8.7-.9 18.3 2.5 18.3 12.5S241 512 241 512h30s-5.8-102.7-5.8-112.8 9.5-13.4 18.4-12.5c10 2.5 105.2 22.6 105.2 22.6s-5-20.1-10-35.1 0-17.5 5-22.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCcAmazonPay(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M124.7 201.8c.1-11.8 0-23.5 0-35.3v-35.3c0-1.3.4-2 1.4-2.7 11.5-8 24.1-12.1 38.2-11.1 12.5.9 22.7 7 28.1 21.7 3.3 8.9 4.1 18.2 4.1 27.7 0 8.7-.7 17.3-3.4 25.6-5.7 17.8-18.7 24.7-35.7 23.9-11.7-.5-21.9-5-31.4-11.7-.9-.8-1.4-1.6-1.3-2.8zm154.9 14.6c4.6 1.8 9.3 2 14.1 1.5 11.6-1.2 21.9-5.7 31.3-12.5.9-.6 1.3-1.3 1.3-2.5-.1-3.9 0-7.9 0-11.8 0-4-.1-8 0-12 0-1.4-.4-2-1.8-2.2-7-.9-13.9-2.2-20.9-2.9-7-.6-14-.3-20.8 1.9-6.7 2.2-11.7 6.2-13.7 13.1-1.6 5.4-1.6 10.8.1 16.2 1.6 5.5 5.2 9.2 10.4 11.2zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zm-207.5 23.9c.4 1.7.9 3.4 1.6 5.1 16.5 40.6 32.9 81.3 49.5 121.9 1.4 3.5 1.7 6.4.2 9.9-2.8 6.2-4.9 12.6-7.8 18.7-2.6 5.5-6.7 9.5-12.7 11.2-4.2 1.1-8.5 1.3-12.9.9-2.1-.2-4.2-.7-6.3-.8-2.8-.2-4.2 1.1-4.3 4-.1 2.8-.1 5.6 0 8.3.1 4.6 1.6 6.7 6.2 7.5 4.7.8 9.4 1.6 14.2 1.7 14.3.3 25.7-5.4 33.1-17.9 2.9-4.9 5.6-10.1 7.7-15.4 19.8-50.1 39.5-100.3 59.2-150.5.6-1.5 1.1-3 1.3-4.6.4-2.4-.7-3.6-3.1-3.7-5.6-.1-11.1 0-16.7 0-3.1 0-5.3 1.4-6.4 4.3-.4 1.1-.9 2.3-1.3 3.4l-29.1 83.7c-2.1 6.1-4.2 12.1-6.5 18.6-.4-.9-.6-1.4-.8-1.9-10.8-29.9-21.6-59.9-32.4-89.8-1.7-4.7-3.5-9.5-5.3-14.2-.9-2.5-2.7-4-5.4-4-6.4-.1-12.8-.2-19.2-.1-2.2 0-3.3 1.6-2.8 3.7zM242.4 206c1.7 11.7 7.6 20.8 18 26.6 9.9 5.5 20.7 6.2 31.7 4.6 12.7-1.9 23.9-7.3 33.8-15.5.4-.3.8-.6 1.4-1 .5 3.2.9 6.2 1.5 9.2.5 2.6 2.1 4.3 4.5 4.4 4.6.1 9.1.1 13.7 0 2.3-.1 3.8-1.6 4-3.9.1-.8.1-1.6.1-2.3v-88.8c0-3.6-.2-7.2-.7-10.8-1.6-10.8-6.2-19.7-15.9-25.4-5.6-3.3-11.8-5-18.2-5.9-3-.4-6-.7-9.1-1.1h-10c-.8.1-1.6.3-2.5.3-8.2.4-16.3 1.4-24.2 3.5-5.1 1.3-10 3.2-15 4.9-3 1-4.5 3.2-4.4 6.5.1 2.8-.1 5.6 0 8.3.1 4.1 1.8 5.2 5.7 4.1 6.5-1.7 13.1-3.5 19.7-4.8 10.3-1.9 20.7-2.7 31.1-1.2 5.4.8 10.5 2.4 14.1 7 3.1 4 4.2 8.8 4.4 13.7.3 6.9.2 13.9.3 20.8 0 .4-.1.7-.2 1.2-.4 0-.8 0-1.1-.1-8.8-2.1-17.7-3.6-26.8-4.1-9.5-.5-18.9.1-27.9 3.2-10.8 3.8-19.5 10.3-24.6 20.8-4.1 8.3-4.6 17-3.4 25.8zM98.7 106.9v175.3c0 .8 0 1.7.1 2.5.2 2.5 1.7 4.1 4.1 4.2 5.9.1 11.8.1 17.7 0 2.5 0 4-1.7 4.1-4.1.1-.8.1-1.7.1-2.5v-60.7c.9.7 1.4 1.2 1.9 1.6 15 12.5 32.2 16.6 51.1 12.9 17.1-3.4 28.9-13.9 36.7-29.2 5.8-11.6 8.3-24.1 8.7-37 .5-14.3-1-28.4-6.8-41.7-7.1-16.4-18.9-27.3-36.7-30.9-2.7-.6-5.5-.8-8.2-1.2h-7c-1.2.2-2.4.3-3.6.5-11.7 1.4-22.3 5.8-31.8 12.7-2 1.4-3.9 3-5.9 4.5-.1-.5-.3-.8-.4-1.2-.4-2.3-.7-4.6-1.1-6.9-.6-3.9-2.5-5.5-6.4-5.6h-9.7c-5.9-.1-6.9 1-6.9 6.8zM493.6 339c-2.7-.7-5.1 0-7.6 1-43.9 18.4-89.5 30.2-136.8 35.8-14.5 1.7-29.1 2.8-43.7 3.2-26.6.7-53.2-.8-79.6-4.3-17.8-2.4-35.5-5.7-53-9.9-37-8.9-72.7-21.7-106.7-38.8-8.8-4.4-17.4-9.3-26.1-14-3.8-2.1-6.2-1.5-8.2 2.1v1.7c1.2 1.6 2.2 3.4 3.7 4.8 36 32.2 76.6 56.5 122 72.9 21.9 7.9 44.4 13.7 67.3 17.5 14 2.3 28 3.8 42.2 4.5 3 .1 6 .2 9 .4.7 0 1.4.2 2.1.3h17.7c.7-.1 1.4-.3 2.1-.3 14.9-.4 29.8-1.8 44.6-4 21.4-3.2 42.4-8.1 62.9-14.7 29.6-9.6 57.7-22.4 83.4-40.1 2.8-1.9 5.7-3.8 8-6.2 4.3-4.4 2.3-10.4-3.3-11.9zm50.4-27.7c-.8-4.2-4-5.8-7.6-7-5.7-1.9-11.6-2.8-17.6-3.3-11-.9-22-.4-32.8 1.6-12 2.2-23.4 6.1-33.5 13.1-1.2.8-2.4 1.8-3.1 3-.6.9-.7 2.3-.5 3.4.3 1.3 1.7 1.6 3 1.5.6 0 1.2 0 1.8-.1l19.5-2.1c9.6-.9 19.2-1.5 28.8-.8 4.1.3 8.1 1.2 12 2.2 4.3 1.1 6.2 4.4 6.4 8.7.3 6.7-1.2 13.1-2.9 19.5-3.5 12.9-8.3 25.4-13.3 37.8-.3.8-.7 1.7-.8 2.5-.4 2.5 1 4 3.4 3.5 1.4-.3 3-1.1 4-2.1 3.7-3.6 7.5-7.2 10.6-11.2 10.7-13.8 17-29.6 20.7-46.6.7-3 1.2-6.1 1.7-9.1.2-4.7.2-9.6.2-14.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCcAmex(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M325.1 167.8c0-16.4-14.1-18.4-27.4-18.4l-39.1-.3v69.3H275v-25.1h18c18.4 0 14.5 10.3 14.8 25.1h16.6v-13.5c0-9.2-1.5-15.1-11-18.4 7.4-3 11.8-10.7 11.7-18.7zm-29.4 11.3H275v-15.3h21c5.1 0 10.7 1 10.7 7.4 0 6.6-5.3 7.9-11 7.9zM279 268.6h-52.7l-21 22.8-20.5-22.8h-66.5l-.1 69.3h65.4l21.3-23 20.4 23h32.2l.1-23.3c18.9 0 49.3 4.6 49.3-23.3 0-17.3-12.3-22.7-27.9-22.7zm-103.8 54.7h-40.6v-13.8h36.3v-14.1h-36.3v-12.5h41.7l17.9 20.2zm65.8 8.2l-25.3-28.1L241 276zm37.8-31h-21.2v-17.6h21.5c5.6 0 10.2 2.3 10.2 8.4 0 6.4-4.6 9.2-10.5 9.2zm-31.6-136.7v-14.6h-55.5v69.3h55.5v-14.3h-38.9v-13.8h37.8v-14.1h-37.8v-12.5zM576 255.4h-.2zm-194.6 31.9c0-16.4-14.1-18.7-27.1-18.7h-39.4l-.1 69.3h16.6l.1-25.3h17.6c11 0 14.8 2 14.8 13.8l-.1 11.5h16.6l.1-13.8c0-8.9-1.8-15.1-11-18.4 7.7-3.1 11.8-10.8 11.9-18.4zm-29.2 11.2h-20.7v-15.6h21c5.1 0 10.7 1 10.7 7.4 0 6.9-5.4 8.2-11 8.2zm-172.8-80v-69.3h-27.6l-19.7 47-21.7-47H83.3v65.7l-28.1-65.7H30.7L1 218.5h17.9l6.4-15.3h34.5l6.4 15.3H100v-54.2l24 54.2h14.6l24-54.2v54.2zM31.2 188.8l11.2-27.6 11.5 27.6zm477.4 158.9v-4.5c-10.8 5.6-3.9 4.5-156.7 4.5 0-25.2.1-23.9 0-25.2-1.7-.1-3.2-.1-9.4-.1 0 17.9-.1 6.8-.1 25.3h-39.6c0-12.1.1-15.3.1-29.2-10 6-22.8 6.4-34.3 6.2 0 14.7-.1 8.3-.1 23h-48.9c-5.1-5.7-2.7-3.1-15.4-17.4-3.2 3.5-12.8 13.9-16.1 17.4h-82v-92.3h83.1c5 5.6 2.8 3.1 15.5 17.2 3.2-3.5 12.2-13.4 15.7-17.2h58c9.8 0 18 1.9 24.3 5.6v-5.6c54.3 0 64.3-1.4 75.7 5.1v-5.1h78.2v5.2c11.4-6.9 19.6-5.2 64.9-5.2v5c10.3-5.9 16.6-5.2 54.3-5V80c0-26.5-21.5-48-48-48h-480c-26.5 0-48 21.5-48 48v109.8c9.4-21.9 19.7-46 23.1-53.9h39.7c4.3 10.1 1.6 3.7 9 21.1v-21.1h46c2.9 6.2 11.1 24 13.9 30 5.8-13.6 10.1-23.9 12.6-30h103c0-.1 11.5 0 11.6 0 43.7.2 53.6-.8 64.4 5.3v-5.3H363v9.3c7.6-6.1 17.9-9.3 30.7-9.3h27.6c0 .5 1.9.3 2.3.3H456c4.2 9.8 2.6 6 8.8 20.6v-20.6h43.3c4.9 8-1-1.8 11.2 18.4v-18.4h39.9v92h-41.6c-5.4-9-1.4-2.2-13.2-21.9v21.9h-52.8c-6.4-14.8-.1-.3-6.6-15.3h-19c-4.2 10-2.2 5.2-6.4 15.3h-26.8c-12.3 0-22.3-3-29.7-8.9v8.9h-66.5c-.3-13.9-.1-24.8-.1-24.8-1.8-.3-3.4-.2-9.8-.2v25.1H151.2v-11.4c-2.5 5.6-2.7 5.9-5.1 11.4h-29.5c-4-8.9-2.9-6.4-5.1-11.4v11.4H58.6c-4.2-10.1-2.2-5.3-6.4-15.3H33c-4.2 10-2.2 5.2-6.4 15.3H0V432c0 26.5 21.5 48 48 48h480.1c26.5 0 48-21.5 48-48v-90.4c-12.7 8.3-32.7 6.1-67.5 6.1zm36.3-64.5H575v-14.6h-32.9c-12.8 0-23.8 6.6-23.8 20.7 0 33 42.7 12.8 42.7 27.4 0 5.1-4.3 6.4-8.4 6.4h-32l-.1 14.8h32c8.4 0 17.6-1.8 22.5-8.9v-25.8c-10.5-13.8-39.3-1.3-39.3-13.5 0-5.8 4.6-6.5 9.2-6.5zm-57 39.8h-32.2l-.1 14.8h32.2c14.8 0 26.2-5.6 26.2-22 0-33.2-42.9-11.2-42.9-26.3 0-5.6 4.9-6.4 9.2-6.4h30.4v-14.6h-33.2c-12.8 0-23.5 6.6-23.5 20.7 0 33 42.7 12.5 42.7 27.4-.1 5.4-4.7 6.4-8.8 6.4zm-42.2-40.1v-14.3h-55.2l-.1 69.3h55.2l.1-14.3-38.6-.3v-13.8H445v-14.1h-37.8v-12.5zm-56.3-108.1c-.3.2-1.4 2.2-1.4 7.6 0 6 .9 7.7 1.1 7.9.2.1 1.1.5 3.4.5l7.3-16.9c-1.1 0-2.1-.1-3.1-.1-5.6 0-7 .7-7.3 1zm20.4-10.5h-.1zm-16.2-15.2c-23.5 0-34 12-34 35.3 0 22.2 10.2 34 33 34h19.2l6.4-15.3h34.3l6.6 15.3h33.7v-51.9l31.2 51.9h23.6v-69h-16.9v48.1l-29.1-48.1h-25.3v65.4l-27.9-65.4h-24.8l-23.5 54.5h-7.4c-13.3 0-16.1-8.1-16.1-19.9 0-23.8 15.7-20 33.1-19.7v-15.2zm42.1 12.1l11.2 27.6h-22.8zm-101.1-12v69.3h16.9v-69.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCcApplePay(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M302.2 218.4c0 17.2-10.5 27.1-29 27.1h-24.3v-54.2h24.4c18.4 0 28.9 9.8 28.9 27.1zm47.5 62.6c0 8.3 7.2 13.7 18.5 13.7 14.4 0 25.2-9.1 25.2-21.9v-7.7l-23.5 1.5c-13.3.9-20.2 5.8-20.2 14.4zM576 79v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V79c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM127.8 197.2c8.4.7 16.8-4.2 22.1-10.4 5.2-6.4 8.6-15 7.7-23.7-7.4.3-16.6 4.9-21.9 11.3-4.8 5.5-8.9 14.4-7.9 22.8zm60.6 74.5c-.2-.2-19.6-7.6-19.8-30-.2-18.7 15.3-27.7 16-28.2-8.8-13-22.4-14.4-27.1-14.7-12.2-.7-22.6 6.9-28.4 6.9-5.9 0-14.7-6.6-24.3-6.4-12.5.2-24.2 7.3-30.5 18.6-13.1 22.6-3.4 56 9.3 74.4 6.2 9.1 13.7 19.1 23.5 18.7 9.3-.4 13-6 24.2-6 11.3 0 14.5 6 24.3 5.9 10.2-.2 16.5-9.1 22.8-18.2 6.9-10.4 9.8-20.4 10-21zm135.4-53.4c0-26.6-18.5-44.8-44.9-44.8h-51.2v136.4h21.2v-46.6h29.3c26.8 0 45.6-18.4 45.6-45zm90 23.7c0-19.7-15.8-32.4-40-32.4-22.5 0-39.1 12.9-39.7 30.5h19.1c1.6-8.4 9.4-13.9 20-13.9 13 0 20.2 6 20.2 17.2v7.5l-26.4 1.6c-24.6 1.5-37.9 11.6-37.9 29.1 0 17.7 13.7 29.4 33.4 29.4 13.3 0 25.6-6.7 31.2-17.4h.4V310h19.6v-68zM516 210.9h-21.5l-24.9 80.6h-.4l-24.9-80.6H422l35.9 99.3-1.9 6c-3.2 10.2-8.5 14.2-17.9 14.2-1.7 0-4.9-.2-6.2-.3v16.4c1.2.4 6.5.5 8.1.5 20.7 0 30.4-7.9 38.9-31.8L516 210.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCcDinersClub(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M239.7 79.9c-96.9 0-175.8 78.6-175.8 175.8 0 96.9 78.9 175.8 175.8 175.8 97.2 0 175.8-78.9 175.8-175.8 0-97.2-78.6-175.8-175.8-175.8zm-39.9 279.6c-41.7-15.9-71.4-56.4-71.4-103.8s29.7-87.9 71.4-104.1v207.9zm79.8.3V151.6c41.7 16.2 71.4 56.7 71.4 104.1s-29.7 87.9-71.4 104.1zM528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM329.7 448h-90.3c-106.2 0-193.8-85.5-193.8-190.2C45.6 143.2 133.2 64 239.4 64h90.3c105 0 200.7 79.2 200.7 193.8 0 104.7-95.7 190.2-200.7 190.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCcDiscover(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M520.4 196.1c0-7.9-5.5-12.1-15.6-12.1h-4.9v24.9h4.7c10.3 0 15.8-4.4 15.8-12.8zM528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-44.1 138.9c22.6 0 52.9-4.1 52.9 24.4 0 12.6-6.6 20.7-18.7 23.2l25.8 34.4h-19.6l-22.2-32.8h-2.2v32.8h-16zm-55.9.1h45.3v14H444v18.2h28.3V217H444v22.2h29.3V253H428zm-68.7 0l21.9 55.2 22.2-55.2h17.5l-35.5 84.2h-8.6l-35-84.2zm-55.9-3c24.7 0 44.6 20 44.6 44.6 0 24.7-20 44.6-44.6 44.6-24.7 0-44.6-20-44.6-44.6 0-24.7 20-44.6 44.6-44.6zm-49.3 6.1v19c-20.1-20.1-46.8-4.7-46.8 19 0 25 27.5 38.5 46.8 19.2v19c-29.7 14.3-63.3-5.7-63.3-38.2 0-31.2 33.1-53 63.3-38zm-97.2 66.3c11.4 0 22.4-15.3-3.3-24.4-15-5.5-20.2-11.4-20.2-22.7 0-23.2 30.6-31.4 49.7-14.3l-8.4 10.8c-10.4-11.6-24.9-6.2-24.9 2.5 0 4.4 2.7 6.9 12.3 10.3 18.2 6.6 23.6 12.5 23.6 25.6 0 29.5-38.8 37.4-56.6 11.3l10.3-9.9c3.7 7.1 9.9 10.8 17.5 10.8zM55.4 253H32v-82h23.4c26.1 0 44.1 17 44.1 41.1 0 18.5-13.2 40.9-44.1 40.9zm67.5 0h-16v-82h16zM544 433c0 8.2-6.8 15-15 15H128c189.6-35.6 382.7-139.2 416-160zM74.1 191.6c-5.2-4.9-11.6-6.6-21.9-6.6H48v54.2h4.2c10.3 0 17-2 21.9-6.4 5.7-5.2 8.9-12.8 8.9-20.7s-3.2-15.5-8.9-20.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCcJcb(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M431.5 244.3V212c41.2 0 38.5.2 38.5.2 7.3 1.3 13.3 7.3 13.3 16 0 8.8-6 14.5-13.3 15.8-1.2.4-3.3.3-38.5.3zm42.8 20.2c-2.8-.7-3.3-.5-42.8-.5v35c39.6 0 40 .2 42.8-.5 7.5-1.5 13.5-8 13.5-17 0-8.7-6-15.5-13.5-17zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM182 192.3h-57c0 67.1 10.7 109.7-35.8 109.7-19.5 0-38.8-5.7-57.2-14.8v28c30 8.3 68 8.3 68 8.3 97.9 0 82-47.7 82-131.2zm178.5 4.5c-63.4-16-165-14.9-165 59.3 0 77.1 108.2 73.6 165 59.2V287C312.9 311.7 253 309 253 256s59.8-55.6 107.5-31.2v-28zM544 286.5c0-18.5-16.5-30.5-38-32v-.8c19.5-2.7 30.3-15.5 30.3-30.2 0-19-15.7-30-37-31 0 0 6.3-.3-120.3-.3v127.5h122.7c24.3.1 42.3-12.9 42.3-33.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCcMastercard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M482.9 410.3c0 6.8-4.6 11.7-11.2 11.7-6.8 0-11.2-5.2-11.2-11.7 0-6.5 4.4-11.7 11.2-11.7 6.6 0 11.2 5.2 11.2 11.7zm-310.8-11.7c-7.1 0-11.2 5.2-11.2 11.7 0 6.5 4.1 11.7 11.2 11.7 6.5 0 10.9-4.9 10.9-11.7-.1-6.5-4.4-11.7-10.9-11.7zm117.5-.3c-5.4 0-8.7 3.5-9.5 8.7h19.1c-.9-5.7-4.4-8.7-9.6-8.7zm107.8.3c-6.8 0-10.9 5.2-10.9 11.7 0 6.5 4.1 11.7 10.9 11.7 6.8 0 11.2-4.9 11.2-11.7 0-6.5-4.4-11.7-11.2-11.7zm105.9 26.1c0 .3.3.5.3 1.1 0 .3-.3.5-.3 1.1-.3.3-.3.5-.5.8-.3.3-.5.5-1.1.5-.3.3-.5.3-1.1.3-.3 0-.5 0-1.1-.3-.3 0-.5-.3-.8-.5-.3-.3-.5-.5-.5-.8-.3-.5-.3-.8-.3-1.1 0-.5 0-.8.3-1.1 0-.5.3-.8.5-1.1.3-.3.5-.3.8-.5.5-.3.8-.3 1.1-.3.5 0 .8 0 1.1.3.5.3.8.3 1.1.5s.2.6.5 1.1zm-2.2 1.4c.5 0 .5-.3.8-.3.3-.3.3-.5.3-.8 0-.3 0-.5-.3-.8-.3 0-.5-.3-1.1-.3h-1.6v3.5h.8V426h.3l1.1 1.4h.8l-1.1-1.3zM576 81v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V81c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM64 220.6c0 76.5 62.1 138.5 138.5 138.5 27.2 0 53.9-8.2 76.5-23.1-72.9-59.3-72.4-171.2 0-230.5-22.6-15-49.3-23.1-76.5-23.1-76.4-.1-138.5 62-138.5 138.2zm224 108.8c70.5-55 70.2-162.2 0-217.5-70.2 55.3-70.5 162.6 0 217.5zm-142.3 76.3c0-8.7-5.7-14.4-14.7-14.7-4.6 0-9.5 1.4-12.8 6.5-2.4-4.1-6.5-6.5-12.2-6.5-3.8 0-7.6 1.4-10.6 5.4V392h-8.2v36.7h8.2c0-18.9-2.5-30.2 9-30.2 10.2 0 8.2 10.2 8.2 30.2h7.9c0-18.3-2.5-30.2 9-30.2 10.2 0 8.2 10 8.2 30.2h8.2v-23zm44.9-13.7h-7.9v4.4c-2.7-3.3-6.5-5.4-11.7-5.4-10.3 0-18.2 8.2-18.2 19.3 0 11.2 7.9 19.3 18.2 19.3 5.2 0 9-1.9 11.7-5.4v4.6h7.9V392zm40.5 25.6c0-15-22.9-8.2-22.9-15.2 0-5.7 11.9-4.8 18.5-1.1l3.3-6.5c-9.4-6.1-30.2-6-30.2 8.2 0 14.3 22.9 8.3 22.9 15 0 6.3-13.5 5.8-20.7.8l-3.5 6.3c11.2 7.6 32.6 6 32.6-7.5zm35.4 9.3l-2.2-6.8c-3.8 2.1-12.2 4.4-12.2-4.1v-16.6h13.1V392h-13.1v-11.2h-8.2V392h-7.6v7.3h7.6V416c0 17.6 17.3 14.4 22.6 10.9zm13.3-13.4h27.5c0-16.2-7.4-22.6-17.4-22.6-10.6 0-18.2 7.9-18.2 19.3 0 20.5 22.6 23.9 33.8 14.2l-3.8-6c-7.8 6.4-19.6 5.8-21.9-4.9zm59.1-21.5c-4.6-2-11.6-1.8-15.2 4.4V392h-8.2v36.7h8.2V408c0-11.6 9.5-10.1 12.8-8.4l2.4-7.6zm10.6 18.3c0-11.4 11.6-15.1 20.7-8.4l3.8-6.5c-11.6-9.1-32.7-4.1-32.7 15 0 19.8 22.4 23.8 32.7 15l-3.8-6.5c-9.2 6.5-20.7 2.6-20.7-8.6zm66.7-18.3H408v4.4c-8.3-11-29.9-4.8-29.9 13.9 0 19.2 22.4 24.7 29.9 13.9v4.6h8.2V392zm33.7 0c-2.4-1.2-11-2.9-15.2 4.4V392h-7.9v36.7h7.9V408c0-11 9-10.3 12.8-8.4l2.4-7.6zm40.3-14.9h-7.9v19.3c-8.2-10.9-29.9-5.1-29.9 13.9 0 19.4 22.5 24.6 29.9 13.9v4.6h7.9v-51.7zm7.6-75.1v4.6h.8V302h1.9v-.8h-4.6v.8h1.9zm6.6 123.8c0-.5 0-1.1-.3-1.6-.3-.3-.5-.8-.8-1.1-.3-.3-.8-.5-1.1-.8-.5 0-1.1-.3-1.6-.3-.3 0-.8.3-1.4.3-.5.3-.8.5-1.1.8-.5.3-.8.8-.8 1.1-.3.5-.3 1.1-.3 1.6 0 .3 0 .8.3 1.4 0 .3.3.8.8 1.1.3.3.5.5 1.1.8.5.3 1.1.3 1.4.3.5 0 1.1 0 1.6-.3.3-.3.8-.5 1.1-.8.3-.3.5-.8.8-1.1.3-.6.3-1.1.3-1.4zm3.2-124.7h-1.4l-1.6 3.5-1.6-3.5h-1.4v5.4h.8v-4.1l1.6 3.5h1.1l1.4-3.5v4.1h1.1v-5.4zm4.4-80.5c0-76.2-62.1-138.3-138.5-138.3-27.2 0-53.9 8.2-76.5 23.1 72.1 59.3 73.2 171.5 0 230.5 22.6 15 49.5 23.1 76.5 23.1 76.4.1 138.5-61.9 138.5-138.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCcPaypal(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M186.3 258.2c0 12.2-9.7 21.5-22 21.5-9.2 0-16-5.2-16-15 0-12.2 9.5-22 21.7-22 9.3 0 16.3 5.7 16.3 15.5zM80.5 209.7h-4.7c-1.5 0-3 1-3.2 2.7l-4.3 26.7 8.2-.3c11 0 19.5-1.5 21.5-14.2 2.3-13.4-6.2-14.9-17.5-14.9zm284 0H360c-1.8 0-3 1-3.2 2.7l-4.2 26.7 8-.3c13 0 22-3 22-18-.1-10.6-9.6-11.1-18.1-11.1zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM128.3 215.4c0-21-16.2-28-34.7-28h-40c-2.5 0-5 2-5.2 4.7L32 294.2c-.3 2 1.2 4 3.2 4h19c2.7 0 5.2-2.9 5.5-5.7l4.5-26.6c1-7.2 13.2-4.7 18-4.7 28.6 0 46.1-17 46.1-45.8zm84.2 8.8h-19c-3.8 0-4 5.5-4.2 8.2-5.8-8.5-14.2-10-23.7-10-24.5 0-43.2 21.5-43.2 45.2 0 19.5 12.2 32.2 31.7 32.2 9 0 20.2-4.9 26.5-11.9-.5 1.5-1 4.7-1 6.2 0 2.3 1 4 3.2 4H200c2.7 0 5-2.9 5.5-5.7l10.2-64.3c.3-1.9-1.2-3.9-3.2-3.9zm40.5 97.9l63.7-92.6c.5-.5.5-1 .5-1.7 0-1.7-1.5-3.5-3.2-3.5h-19.2c-1.7 0-3.5 1-4.5 2.5l-26.5 39-11-37.5c-.8-2.2-3-4-5.5-4h-18.7c-1.7 0-3.2 1.8-3.2 3.5 0 1.2 19.5 56.8 21.2 62.1-2.7 3.8-20.5 28.6-20.5 31.6 0 1.8 1.5 3.2 3.2 3.2h19.2c1.8-.1 3.5-1.1 4.5-2.6zm159.3-106.7c0-21-16.2-28-34.7-28h-39.7c-2.7 0-5.2 2-5.5 4.7l-16.2 102c-.2 2 1.3 4 3.2 4h20.5c2 0 3.5-1.5 4-3.2l4.5-29c1-7.2 13.2-4.7 18-4.7 28.4 0 45.9-17 45.9-45.8zm84.2 8.8h-19c-3.8 0-4 5.5-4.3 8.2-5.5-8.5-14-10-23.7-10-24.5 0-43.2 21.5-43.2 45.2 0 19.5 12.2 32.2 31.7 32.2 9.3 0 20.5-4.9 26.5-11.9-.3 1.5-1 4.7-1 6.2 0 2.3 1 4 3.2 4H484c2.7 0 5-2.9 5.5-5.7l10.2-64.3c.3-1.9-1.2-3.9-3.2-3.9zm47.5-33.3c0-2-1.5-3.5-3.2-3.5h-18.5c-1.5 0-3 1.2-3.2 2.7l-16.2 104-.3.5c0 1.8 1.5 3.5 3.5 3.5h16.5c2.5 0 5-2.9 5.2-5.7L544 191.2v-.3zm-90 51.8c-12.2 0-21.7 9.7-21.7 22 0 9.7 7 15 16.2 15 12 0 21.7-9.2 21.7-21.5.1-9.8-6.9-15.5-16.2-15.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCcStripe(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M492.4 220.8c-8.9 0-18.7 6.7-18.7 22.7h36.7c0-16-9.3-22.7-18-22.7zM375 223.4c-8.2 0-13.3 2.9-17 7l.2 52.8c3.5 3.7 8.5 6.7 16.8 6.7 13.1 0 21.9-14.3 21.9-33.4 0-18.6-9-33.2-21.9-33.1zM528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM122.2 281.1c0 25.6-20.3 40.1-49.9 40.3-12.2 0-25.6-2.4-38.8-8.1v-33.9c12 6.4 27.1 11.3 38.9 11.3 7.9 0 13.6-2.1 13.6-8.7 0-17-54-10.6-54-49.9 0-25.2 19.2-40.2 48-40.2 11.8 0 23.5 1.8 35.3 6.5v33.4c-10.8-5.8-24.5-9.1-35.3-9.1-7.5 0-12.1 2.2-12.1 7.7 0 16 54.3 8.4 54.3 50.7zm68.8-56.6h-27V275c0 20.9 22.5 14.4 27 12.6v28.9c-4.7 2.6-13.3 4.7-24.9 4.7-21.1 0-36.9-15.5-36.9-36.5l.2-113.9 34.7-7.4v30.8H191zm74 2.4c-4.5-1.5-18.7-3.6-27.1 7.4v84.4h-35.5V194.2h30.7l2.2 10.5c8.3-15.3 24.9-12.2 29.6-10.5h.1zm44.1 91.8h-35.7V194.2h35.7zm0-142.9l-35.7 7.6v-28.9l35.7-7.6zm74.1 145.5c-12.4 0-20-5.3-25.1-9l-.1 40.2-35.5 7.5V194.2h31.3l1.8 8.8c4.9-4.5 13.9-11.1 27.8-11.1 24.9 0 48.4 22.5 48.4 63.8 0 45.1-23.2 65.5-48.6 65.6zm160.4-51.5h-69.5c1.6 16.6 13.8 21.5 27.6 21.5 14.1 0 25.2-3 34.9-7.9V312c-9.7 5.3-22.4 9.2-39.4 9.2-34.6 0-58.8-21.7-58.8-64.5 0-36.2 20.5-64.9 54.3-64.9 33.7 0 51.3 28.7 51.3 65.1 0 3.5-.3 10.9-.4 12.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCcVisa(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M470.1 231.3s7.6 37.2 9.3 45H446c3.3-8.9 16-43.5 16-43.5-.2.3 3.3-9.1 5.3-14.9l2.8 13.4zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM152.5 331.2L215.7 176h-42.5l-39.3 106-4.3-21.5-14-71.4c-2.3-9.9-9.4-12.7-18.2-13.1H32.7l-.7 3.1c15.8 4 29.9 9.8 42.2 17.1l35.8 135h42.5zm94.4.2L272.1 176h-40.2l-25.1 155.4h40.1zm139.9-50.8c.2-17.7-10.6-31.2-33.7-42.3-14.1-7.1-22.7-11.9-22.7-19.2.2-6.6 7.3-13.4 23.1-13.4 13.1-.3 22.7 2.8 29.9 5.9l3.6 1.7 5.5-33.6c-7.9-3.1-20.5-6.6-36-6.6-39.7 0-67.6 21.2-67.8 51.4-.3 22.3 20 34.7 35.2 42.2 15.5 7.6 20.8 12.6 20.8 19.3-.2 10.4-12.6 15.2-24.1 15.2-16 0-24.6-2.5-37.7-8.3l-5.3-2.5-5.6 34.9c9.4 4.3 26.8 8.1 44.8 8.3 42.2.1 69.7-20.8 70-53zM528 331.4L495.6 176h-31.1c-9.6 0-16.9 2.8-21 12.9l-59.7 142.5H426s6.9-19.2 8.4-23.3H486c1.2 5.5 4.8 23.3 4.8 23.3H528z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCentercode(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M329.2 268.6c-3.8 35.2-35.4 60.6-70.6 56.8-35.2-3.8-60.6-35.4-56.8-70.6 3.8-35.2 35.4-60.6 70.6-56.8 35.1 3.8 60.6 35.4 56.8 70.6zm-85.8 235.1C96.7 496-8.2 365.5 10.1 224.3c11.2-86.6 65.8-156.9 139.1-192 161-77.1 349.7 37.4 354.7 216.6 4.1 147-118.4 262.2-260.5 254.8zm179.9-180c27.9-118-160.5-205.9-237.2-234.2-57.5 56.3-69.1 188.6-33.8 344.4 68.8 15.8 169.1-26.4 271-110.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCentos(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M289.6 97.5l31.6 31.7-76.3 76.5V97.5zm-162.4 31.7l76.3 76.5V97.5h-44.7zm41.5-41.6h44.7v127.9l10.8 10.8 10.8-10.8V87.6h44.7L224.2 32zm26.2 168.1l-10.8-10.8H55.5v-44.8L0 255.7l55.5 55.6v-44.8h128.6l10.8-10.8zm79.3-20.7h107.9v-44.8l-31.6-31.7zm173.3 20.7L392 200.1v44.8H264.3l-10.8 10.8 10.8 10.8H392v44.8l55.5-55.6zM65.4 176.2l32.5-31.7 90.3 90.5h15.3v-15.3l-90.3-90.5 31.6-31.7H65.4zm316.7-78.7h-78.5l31.6 31.7-90.3 90.5V235h15.3l90.3-90.5 31.6 31.7zM203.5 413.9V305.8l-76.3 76.5 31.6 31.7h44.7zM65.4 235h108.8l-76.3-76.5-32.5 31.7zm316.7 100.2l-31.6 31.7-90.3-90.5h-15.3v15.3l90.3 90.5-31.6 31.7h78.5zm0-58.8H274.2l76.3 76.5 31.6-31.7zm-60.9 105.8l-76.3-76.5v108.1h44.7zM97.9 352.9l76.3-76.5H65.4v44.8zm181.8 70.9H235V295.9l-10.8-10.8-10.8 10.8v127.9h-44.7l55.5 55.6zm-166.5-41.6l90.3-90.5v-15.3h-15.3l-90.3 90.5-32.5-31.7v78.7h79.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChrome(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M131.5 217.5L55.1 100.1c47.6-59.2 119-91.8 192-92.1 42.3-.3 85.5 10.5 124.8 33.2 43.4 25.2 76.4 61.4 97.4 103L264 133.4c-58.1-3.4-113.4 29.3-132.5 84.1zm32.9 38.5c0 46.2 37.4 83.6 83.6 83.6s83.6-37.4 83.6-83.6-37.4-83.6-83.6-83.6-83.6 37.3-83.6 83.6zm314.9-89.2L339.6 174c37.9 44.3 38.5 108.2 6.6 157.2L234.1 503.6c46.5 2.5 94.4-7.7 137.8-32.9 107.4-62 150.9-192 107.4-303.9zM133.7 303.6L40.4 120.1C14.9 159.1 0 205.9 0 256c0 124 90.8 226.7 209.5 244.9l63.7-124.8c-57.6 10.8-113.2-20.8-139.5-72.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChromecast(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M447.8,64H64c-23.6,0-42.7,19.1-42.7,42.7v63.9H64v-63.9h383.8v298.6H298.6V448H448c23.6,0,42.7-19.1,42.7-42.7V106.7 C490.7,83.1,471.4,64,447.8,64z M21.3,383.6L21.3,383.6l0,63.9h63.9C85.2,412.2,56.6,383.6,21.3,383.6L21.3,383.6z M21.3,298.6V341 c58.9,0,106.6,48.1,106.6,107h42.7C170.7,365.6,103.7,298.7,21.3,298.6z M213.4,448h42.7c-0.5-129.5-105.3-234.3-234.8-234.6l0,42.4 C127.3,255.6,213.3,342,213.4,448z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCloudflare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M407.906,319.913l-230.8-2.928a4.58,4.58,0,0,1-3.632-1.926,4.648,4.648,0,0,1-.494-4.147,6.143,6.143,0,0,1,5.361-4.076L411.281,303.9c27.631-1.26,57.546-23.574,68.022-50.784l13.286-34.542a7.944,7.944,0,0,0,.524-2.936,7.735,7.735,0,0,0-.164-1.631A151.91,151.91,0,0,0,201.257,198.4,68.12,68.12,0,0,0,94.2,269.59C41.924,271.106,0,313.728,0,366.12a96.054,96.054,0,0,0,1.029,13.958,4.508,4.508,0,0,0,4.445,3.871l426.1.051c.043,0,.08-.019.122-.02a5.606,5.606,0,0,0,5.271-4l3.273-11.265c3.9-13.4,2.448-25.8-4.1-34.9C430.124,325.423,420.09,320.487,407.906,319.913ZM513.856,221.1c-2.141,0-4.271.062-6.391.164a3.771,3.771,0,0,0-3.324,2.653l-9.077,31.193c-3.9,13.4-2.449,25.786,4.1,34.89,6.02,8.4,16.054,13.323,28.238,13.9l49.2,2.939a4.491,4.491,0,0,1,3.51,1.894,4.64,4.64,0,0,1,.514,4.169,6.153,6.153,0,0,1-5.351,4.075l-51.125,2.939c-27.754,1.27-57.669,23.574-68.145,50.784l-3.695,9.606a2.716,2.716,0,0,0,2.427,3.68c.046,0,.088.017.136.017h175.91a4.69,4.69,0,0,0,4.539-3.37,124.807,124.807,0,0,0,4.682-34C640,277.3,583.524,221.1,513.856,221.1Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCloudscale(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M318.1 154l-9.4 7.6c-22.5-19.3-51.5-33.6-83.3-33.6C153.8 128 96 188.8 96 260.3c0 6.6.4 13.1 1.4 19.4-2-56 41.8-97.4 92.6-97.4 24.2 0 46.2 9.4 62.6 24.7l-25.2 20.4c-8.3-.9-16.8 1.8-23.1 8.1-11.1 11-11.1 28.9 0 40 11.1 11 28.9 11 40 0 6.3-6.3 9-14.9 8.1-23.1l75.2-88.8c6.3-6.5-3.3-15.9-9.5-9.6zm-83.8 111.5c-5.6 5.5-14.6 5.5-20.2 0-5.6-5.6-5.6-14.6 0-20.2s14.6-5.6 20.2 0 5.6 14.7 0 20.2zM224 32C100.5 32 0 132.5 0 256s100.5 224 224 224 224-100.5 224-224S347.5 32 224 32zm0 384c-88.2 0-160-71.8-160-160S135.8 96 224 96s160 71.8 160 160-71.8 160-160 160z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCloudsmith(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 332 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M332.5 419.9c0 46.4-37.6 84.1-84 84.1s-84-37.7-84-84.1 37.6-84 84-84 84 37.6 84 84zm-84-243.9c46.4 0 80-37.6 80-84s-33.6-84-80-84-88 37.6-88 84-29.6 76-76 76-84 41.6-84 88 37.6 80 84 80 84-33.6 84-80 33.6-80 80-80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCloudversify(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 616 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M148.6 304c8.2 68.5 67.4 115.5 146 111.3 51.2 43.3 136.8 45.8 186.4-5.6 69.2 1.1 118.5-44.6 131.5-99.5 14.8-62.5-18.2-132.5-92.1-155.1-33-88.1-131.4-101.5-186.5-85-57.3 17.3-84.3 53.2-99.3 109.7-7.8 2.7-26.5 8.9-45 24.1 11.7 0 15.2 8.9 15.2 19.5v20.4c0 10.7-8.7 19.5-19.5 19.5h-20.2c-10.7 0-19.5-6-19.5-16.7V240H98.8C95 240 88 244.3 88 251.9v40.4c0 6.4 5.3 11.8 11.7 11.8h48.9zm227.4 8c-10.7 46.3 21.7 72.4 55.3 86.8C324.1 432.6 259.7 348 296 288c-33.2 21.6-33.7 71.2-29.2 92.9-17.9-12.4-53.8-32.4-57.4-79.8-3-39.9 21.5-75.7 57-93.9C297 191.4 369.9 198.7 400 248c-14.1-48-53.8-70.1-101.8-74.8 30.9-30.7 64.4-50.3 114.2-43.7 69.8 9.3 133.2 82.8 67.7 150.5 35-16.3 48.7-54.4 47.5-76.9l10.5 19.6c11.8 22 15.2 47.6 9.4 72-9.2 39-40.6 68.8-79.7 76.5-32.1 6.3-83.1-5.1-91.8-59.2zM128 208H88.2c-8.9 0-16.2-7.3-16.2-16.2v-39.6c0-8.9 7.3-16.2 16.2-16.2H128c8.9 0 16.2 7.3 16.2 16.2v39.6c0 8.9-7.3 16.2-16.2 16.2zM10.1 168C4.5 168 0 163.5 0 157.9v-27.8c0-5.6 4.5-10.1 10.1-10.1h27.7c5.5 0 10.1 4.5 10.1 10.1v27.8c0 5.6-4.5 10.1-10.1 10.1H10.1zM168 142.7v-21.4c0-5.1 4.2-9.3 9.3-9.3h21.4c5.1 0 9.3 4.2 9.3 9.3v21.4c0 5.1-4.2 9.3-9.3 9.3h-21.4c-5.1 0-9.3-4.2-9.3-9.3zM56 235.5v25c0 6.3-5.1 11.5-11.4 11.5H19.4C13.1 272 8 266.8 8 260.5v-25c0-6.3 5.1-11.5 11.4-11.5h25.1c6.4 0 11.5 5.2 11.5 11.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCodepen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M502.285 159.704l-234-156c-7.987-4.915-16.511-4.96-24.571 0l-234 156C3.714 163.703 0 170.847 0 177.989v155.999c0 7.143 3.714 14.286 9.715 18.286l234 156.022c7.987 4.915 16.511 4.96 24.571 0l234-156.022c6-3.999 9.715-11.143 9.715-18.286V177.989c-.001-7.142-3.715-14.286-9.716-18.285zM278 63.131l172.286 114.858-76.857 51.429L278 165.703V63.131zm-44 0v102.572l-95.429 63.715-76.857-51.429L234 63.131zM44 219.132l55.143 36.857L44 292.846v-73.714zm190 229.715L61.714 333.989l76.857-51.429L234 346.275v102.572zm22-140.858l-77.715-52 77.715-52 77.715 52-77.715 52zm22 140.858V346.275l95.429-63.715 76.857 51.429L278 448.847zm190-156.001l-55.143-36.857L468 219.132v73.714z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCodiepie(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 472 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M422.5 202.9c30.7 0 33.5 53.1-.3 53.1h-10.8v44.3h-26.6v-97.4h37.7zM472 352.6C429.9 444.5 350.4 504 248 504 111 504 0 393 0 256S111 8 248 8c97.4 0 172.8 53.7 218.2 138.4l-186 108.8L472 352.6zm-38.5 12.5l-60.3-30.7c-27.1 44.3-70.4 71.4-122.4 71.4-82.5 0-149.2-66.7-149.2-148.9 0-82.5 66.7-149.2 149.2-149.2 48.4 0 88.9 23.5 116.9 63.4l59.5-34.6c-40.7-62.6-104.7-100-179.2-100-121.2 0-219.5 98.3-219.5 219.5S126.8 475.5 248 475.5c78.6 0 146.5-42.1 185.5-110.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaConfluence(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.3 412.2c-4.5 7.6-2.1 17.5 5.5 22.2l105.9 65.2c7.7 4.7 17.7 2.4 22.4-5.3 0-.1.1-.2.1-.2 67.1-112.2 80.5-95.9 280.9-.7 8.1 3.9 17.8.4 21.7-7.7.1-.1.1-.3.2-.4l50.4-114.1c3.6-8.1-.1-17.6-8.1-21.3-22.2-10.4-66.2-31.2-105.9-50.3C127.5 179 44.6 345.3 2.3 412.2zm507.4-312.1c4.5-7.6 2.1-17.5-5.5-22.2L398.4 12.8c-7.5-5-17.6-3.1-22.6 4.4-.2.3-.4.6-.6 1-67.3 112.6-81.1 95.6-280.6.9-8.1-3.9-17.8-.4-21.7 7.7-.1.1-.1.3-.2.4L22.2 141.3c-3.6 8.1.1 17.6 8.1 21.3 22.2 10.4 66.3 31.2 106 50.4 248 120 330.8-45.4 373.4-112.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaConnectdevelop(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M550.5 241l-50.089-86.786c1.071-2.142 1.875-4.553 1.875-7.232 0-8.036-6.696-14.733-14.732-15.001l-55.447-95.893c.536-1.607 1.071-3.214 1.071-4.821 0-8.571-6.964-15.268-15.268-15.268-4.821 0-8.839 2.143-11.786 5.625H299.518C296.839 18.143 292.821 16 288 16s-8.839 2.143-11.518 5.625H170.411C167.464 18.143 163.447 16 158.625 16c-8.303 0-15.268 6.696-15.268 15.268 0 1.607.536 3.482 1.072 4.821l-55.983 97.233c-5.356 2.41-9.107 7.5-9.107 13.661 0 .535.268 1.071.268 1.607l-53.304 92.143c-7.232 1.339-12.59 7.5-12.59 15 0 7.232 5.089 13.393 12.054 15l55.179 95.358c-.536 1.607-.804 2.946-.804 4.821 0 7.232 5.089 13.393 12.054 14.732l51.697 89.732c-.536 1.607-1.071 3.482-1.071 5.357 0 8.571 6.964 15.268 15.268 15.268 4.821 0 8.839-2.143 11.518-5.357h106.875C279.161 493.857 283.447 496 288 496s8.839-2.143 11.518-5.357h107.143c2.678 2.946 6.696 4.821 10.982 4.821 8.571 0 15.268-6.964 15.268-15.268 0-1.607-.267-2.946-.803-4.285l51.697-90.268c6.964-1.339 12.054-7.5 12.054-14.732 0-1.607-.268-3.214-.804-4.821l54.911-95.358c6.964-1.339 12.322-7.5 12.322-15-.002-7.232-5.092-13.393-11.788-14.732zM153.535 450.732l-43.66-75.803h43.66v75.803zm0-83.839h-43.66c-.268-1.071-.804-2.142-1.339-3.214l44.999-47.41v50.624zm0-62.411l-50.357 53.304c-1.339-.536-2.679-1.34-4.018-1.607L43.447 259.75c.535-1.339.535-2.679.535-4.018s0-2.41-.268-3.482l51.965-90c2.679-.268 5.357-1.072 7.768-2.679l50.089 51.965v92.946zm0-102.322l-45.803-47.41c1.339-2.143 2.143-4.821 2.143-7.767 0-.268-.268-.804-.268-1.072l43.928-15.804v72.053zm0-80.625l-43.66 15.804 43.66-75.536v59.732zm326.519 39.108l.804 1.339L445.5 329.125l-63.75-67.232 98.036-101.518.268.268zM291.75 355.107l11.518 11.786H280.5l11.25-11.786zm-.268-11.25l-83.303-85.446 79.553-84.375 83.036 87.589-79.286 82.232zm5.357 5.893l79.286-82.232 67.5 71.25-5.892 28.125H313.714l-16.875-17.143zM410.411 44.393c1.071.536 2.142 1.072 3.482 1.34l57.857 100.714v.536c0 2.946.803 5.624 2.143 7.767L376.393 256l-83.035-87.589L410.411 44.393zm-9.107-2.143L287.732 162.518l-57.054-60.268 166.339-60h4.287zm-123.483 0c2.678 2.678 6.16 4.285 10.179 4.285s7.5-1.607 10.179-4.285h75L224.786 95.821 173.893 42.25h103.928zm-116.249 5.625l1.071-2.142a33.834 33.834 0 0 0 2.679-.804l51.161 53.84-54.911 19.821V47.875zm0 79.286l60.803-21.964 59.732 63.214-79.553 84.107-40.982-42.053v-83.304zm0 92.678L198 257.607l-36.428 38.304v-76.072zm0 87.858l42.053-44.464 82.768 85.982-17.143 17.678H161.572v-59.196zm6.964 162.053c-1.607-1.607-3.482-2.678-5.893-3.482l-1.071-1.607v-89.732h99.91l-91.607 94.821h-1.339zm129.911 0c-2.679-2.41-6.428-4.285-10.447-4.285s-7.767 1.875-10.447 4.285h-96.429l91.607-94.821h38.304l91.607 94.821H298.447zm120-11.786l-4.286 7.5c-1.339.268-2.41.803-3.482 1.339l-89.196-91.875h114.376l-17.412 83.036zm12.856-22.232l12.858-60.803h21.964l-34.822 60.803zm34.822-68.839h-20.357l4.553-21.16 17.143 18.214c-.535.803-1.071 1.874-1.339 2.946zm66.161-107.411l-55.447 96.697c-1.339.535-2.679 1.071-4.018 1.874l-20.625-21.964 34.554-163.928 45.803 79.286c-.267 1.339-.803 2.678-.803 4.285 0 1.339.268 2.411.536 3.75z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaContao(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M45.4 305c14.4 67.1 26.4 129 68.2 175H34c-18.7 0-34-15.2-34-34V66c0-18.7 15.2-34 34-34h57.7C77.9 44.6 65.6 59.2 54.8 75.6c-45.4 70-27 146.8-9.4 229.4zM478 32h-90.2c21.4 21.4 39.2 49.5 52.7 84.1l-137.1 29.3c-14.9-29-37.8-53.3-82.6-43.9-24.6 5.3-41 19.3-48.3 34.6-8.8 18.7-13.2 39.8 8.2 140.3 21.1 100.2 33.7 117.7 49.5 131.2 12.9 11.1 33.4 17 58.3 11.7 44.5-9.4 55.7-40.7 57.4-73.2l137.4-29.6c3.2 71.5-18.7 125.2-57.4 163.6H478c18.7 0 34-15.2 34-34V66c0-18.8-15.2-34-34-34z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCottonBureau(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M474.31 330.41c-23.66 91.85-94.23 144.59-201.9 148.35V429.6c0-48 26.41-74.39 74.39-74.39 62 0 99.2-37.2 99.2-99.21 0-61.37-36.53-98.28-97.38-99.06-33-69.32-146.5-64.65-177.24 0C110.52 157.72 74 194.63 74 256c0 62.13 37.27 99.41 99.4 99.41 48 0 74.55 26.23 74.55 74.39V479c-134.43-5-211.1-85.07-211.1-223 0-141.82 81.35-223.2 223.2-223.2 114.77 0 189.84 53.2 214.69 148.81H500C473.88 71.51 388.22 8 259.82 8 105 8 12 101.19 12 255.82 12 411.14 105.19 504.34 259.82 504c128.27 0 213.87-63.81 239.67-173.59zM357 182.33c41.37 3.45 64.2 29 64.2 73.67 0 48-26.43 74.41-74.4 74.41-28.61 0-49.33-9.59-61.59-27.33 83.06-16.55 75.59-99.67 71.79-120.75zm-81.68 97.36c-2.46-10.34-16.33-87 56.23-97 2.27 10.09 16.52 87.11-56.26 97zM260 132c28.61 0 49 9.67 61.44 27.61-28.36 5.48-49.36 20.59-61.59 43.45-12.23-22.86-33.23-38-61.6-43.45 12.41-17.69 33.27-27.35 61.57-27.35zm-71.52 50.72c73.17 10.57 58.91 86.81 56.49 97-72.41-9.84-59-86.95-56.25-97zM173.2 330.41c-48 0-74.4-26.4-74.4-74.41 0-44.36 22.86-70 64.22-73.67-6.75 37.2-1.38 106.53 71.65 120.75-12.14 17.63-32.84 27.3-61.14 27.3zm53.21 12.39A80.8 80.8 0 0 0 260 309.25c7.77 14.49 19.33 25.54 33.82 33.55a80.28 80.28 0 0 0-33.58 33.83c-8-14.5-19.07-26.23-33.56-33.83z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCpanel(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M210.3 220.2c-5.6-24.8-26.9-41.2-51-41.2h-37c-7.1 0-12.5 4.5-14.3 10.9L73.1 320l24.7-.1c6.8 0 12.3-4.5 14.2-10.7l25.8-95.7h19.8c8.4 0 16.2 5.6 18.3 14.8 2.5 10.9-5.9 22.6-18.3 22.6h-10.3c-7 0-12.5 4.6-14.3 10.8l-6.4 23.8h32c37.2 0 58.3-36.2 51.7-65.3zm-156.5 28h18.6c6.9 0 12.4-4.4 14.3-10.9l6.2-23.6h-40C30 213.7 9 227.8 1.7 254.8-7 288.6 18.5 320 52 320h12.4l7.1-26.1c1.2-4.4-2.2-8.3-6.4-8.3H53.8c-24.7 0-24.9-37.4 0-37.4zm247.5-34.8h-77.9l-3.5 13.4c-2.4 9.6 4.5 18.5 14.2 18.5h57.5c4 0 2.4 4.3 2.1 5.3l-8.6 31.8c-.4 1.4-.9 5.3-5.5 5.3h-34.9c-5.3 0-5.3-7.9 0-7.9h21.6c6.8 0 12.3-4.6 14.2-10.8l3.5-13.2h-48.4c-39.2 0-43.6 63.8-.7 63.8l57.5.2c11.2 0 20.6-7.2 23.4-17.8l14-51.8c4.8-19.2-9.7-36.8-28.5-36.8zM633.1 179h-18.9c-4.9 0-9.2 3.2-10.4 7.9L568.2 320c20.7 0 39.8-13.8 44.9-34.5l26.5-98.2c1.2-4.3-2-8.3-6.5-8.3zm-236.3 34.7v.1h-48.3l-26.2 98c-1.2 4.4 2.2 8.3 6.4 8.3h18.9c4.8 0 9.2-3 10.4-7.8l17.2-64H395c12.5 0 21.4 11.8 18.1 23.4l-10.6 40c-1.2 4.3 1.9 8.3 6.4 8.3H428c4.6 0 9.1-2.9 10.3-7.8l8.8-33.1c9-33.1-15.9-65.4-50.3-65.4zm98.3 74.6c-3.6 0-6-3.4-5.1-6.7l8-30c.9-3.9 3.7-6 7.8-6h32.9c2.6 0 4.6 2.4 3.9 5.1l-.7 2.6c-.6 2-1.9 3-3.9 3h-21.6c-7 0-12.6 4.6-14.2 10.8l-3.5 13h53.4c10.5 0 20.3-6.6 23.2-17.6l3.2-12c4.9-19.1-9.3-36.8-28.3-36.8h-47.3c-17.9 0-33.8 12-38.6 29.6l-10.8 40c-5 17.7 8.3 36.7 28.3 36.7h66.7c6.8 0 12.3-4.5 14.2-10.7l5.7-21z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCreativeCommonsBy(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M314.9 194.4v101.4h-28.3v120.5h-77.1V295.9h-28.3V194.4c0-4.4 1.6-8.2 4.6-11.3 3.1-3.1 6.9-4.7 11.3-4.7H299c4.1 0 7.8 1.6 11.1 4.7 3.1 3.2 4.8 6.9 4.8 11.3zm-101.5-63.7c0-23.3 11.5-35 34.5-35s34.5 11.7 34.5 35c0 23-11.5 34.5-34.5 34.5s-34.5-11.5-34.5-34.5zM247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCreativeCommonsNcEu(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.7 8C103.6 8 0 124.8 0 256c0 136.3 111.7 248 247.7 248C377.9 504 496 403.1 496 256 496 117 388.4 8 247.7 8zm.6 450.7c-112 0-203.6-92.5-203.6-202.7 0-23.2 3.7-45.2 10.9-66l65.7 29.1h-4.7v29.5h23.3c0 6.2-.4 3.2-.4 19.5h-22.8v29.5h27c11.4 67 67.2 101.3 124.6 101.3 26.6 0 50.6-7.9 64.8-15.8l-10-46.1c-8.7 4.6-28.2 10.8-47.3 10.8-28.2 0-58.1-10.9-67.3-50.2h90.3l128.3 56.8c-1.5 2.1-56.2 104.3-178.8 104.3zm-16.7-190.6l-.5-.4.9.4h-.4zm77.2-19.5h3.7v-29.5h-70.3l-28.6-12.6c2.5-5.5 5.4-10.5 8.8-14.3 12.9-15.8 31.1-22.4 51.1-22.4 18.3 0 35.3 5.4 46.1 10l11.6-47.3c-15-6.6-37-12.4-62.3-12.4-39 0-72.2 15.8-95.9 42.3-5.3 6.1-9.8 12.9-13.9 20.1l-81.6-36.1c64.6-96.8 157.7-93.6 170.7-93.6 113 0 203 90.2 203 203.4 0 18.7-2.1 36.3-6.3 52.9l-136.1-60.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCreativeCommonsNcJp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.7 8C103.6 8 0 124.8 0 256c0 136.4 111.8 248 247.7 248C377.9 504 496 403.2 496 256 496 117.2 388.5 8 247.7 8zm.6 450.7c-112 0-203.6-92.5-203.6-202.7 0-21.1 3-41.2 9-60.3l127 56.5h-27.9v38.6h58.1l5.7 11.8v18.7h-63.8V360h63.8v56h61.7v-56h64.2v-35.7l81 36.1c-1.5 2.2-57.1 98.3-175.2 98.3zm87.6-137.3h-57.6v-18.7l2.9-5.6 54.7 24.3zm6.5-51.4v-17.8h-38.6l63-116H301l-43.4 96-23-10.2-39.6-85.7h-65.8l27.3 51-81.9-36.5c27.8-44.1 82.6-98.1 173.7-98.1 112.8 0 203 90 203 203.4 0 21-2.7 40.6-7.9 59l-101-45.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCreativeCommonsNc(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.6 8C387.4 8 496 115.9 496 256c0 147.2-118.5 248-248.4 248C113.1 504 0 393.2 0 256 0 123.1 104.7 8 247.6 8zM55.8 189.1c-7.4 20.4-11.1 42.7-11.1 66.9 0 110.9 92.1 202.4 203.7 202.4 122.4 0 177.2-101.8 178.5-104.1l-93.4-41.6c-7.7 37.1-41.2 53-68.2 55.4v38.1h-28.8V368c-27.5-.3-52.6-10.2-75.3-29.7l34.1-34.5c31.7 29.4 86.4 31.8 86.4-2.2 0-6.2-2.2-11.2-6.6-15.1-14.2-6-1.8-.1-219.3-97.4zM248.4 52.3c-38.4 0-112.4 8.7-170.5 93l94.8 42.5c10-31.3 40.4-42.9 63.8-44.3v-38.1h28.8v38.1c22.7 1.2 43.4 8.9 62 23L295 199.7c-42.7-29.9-83.5-8-70 11.1 53.4 24.1 43.8 19.8 93 41.6l127.1 56.7c4.1-17.4 6.2-35.1 6.2-53.1 0-57-19.8-105-59.3-143.9-39.3-39.9-87.2-59.8-143.6-59.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCreativeCommonsNd(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm94 144.3v42.5H162.1V197h180.3zm0 79.8v42.5H162.1v-42.5h180.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCreativeCommonsPdAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.6 8C104.7 8 0 123.1 0 256c0 138.5 113.6 248 247.6 248C377.5 504 496 403.1 496 256 496 118.1 389.4 8 247.6 8zm.8 450.8c-112.5 0-203.7-93-203.7-202.8 0-105.4 85.5-203.3 203.7-203.3 112.6 0 202.9 89.5 202.8 203.3 0 121.7-99.6 202.8-202.8 202.8zM316.7 186h-53.2v137.2h53.2c21.4 0 70-5.1 70-68.6 0-63.4-48.6-68.6-70-68.6zm.8 108.5h-19.9v-79.7l19.4-.1c3.8 0 35-2.1 35 39.9 0 24.6-10.5 39.9-34.5 39.9zM203.7 186h-68.2v137.3h34.6V279h27c54.1 0 57.1-37.5 57.1-46.5 0-31-16.8-46.5-50.5-46.5zm-4.9 67.3h-29.2v-41.6h28.3c30.9 0 28.8 41.6.9 41.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCreativeCommonsPd(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119.1 0 256c0 137 111 248 248 248s248-111 248-248C496 119.1 385 8 248 8zm0 449.5c-139.2 0-235.8-138-190.2-267.9l78.8 35.1c-2.1 10.5-3.3 21.5-3.3 32.9 0 99 73.9 126.9 120.4 126.9 22.9 0 53.5-6.7 79.4-29.5L297 311.1c-5.5 6.3-17.6 16.7-36.3 16.7-37.8 0-53.7-39.9-53.9-71.9 230.4 102.6 216.5 96.5 217.9 96.8-34.3 62.4-100.6 104.8-176.7 104.8zm194.2-150l-224-100c18.8-34 54.9-30.7 74.7-11l40.4-41.6c-27.1-23.3-58-27.5-78.1-27.5-47.4 0-80.9 20.5-100.7 51.6l-74.9-33.4c36.1-54.9 98.1-91.2 168.5-91.2 111.1 0 201.5 90.4 201.5 201.5 0 18-2.4 35.4-6.8 52-.3-.1-.4-.2-.6-.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCreativeCommonsRemix(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm161.7 207.7l4.9 2.2v70c-7.2 3.6-63.4 27.5-67.3 28.8-6.5-1.8-113.7-46.8-137.3-56.2l-64.2 26.6-63.3-27.5v-63.8l59.3-24.8c-.7-.7-.4 5-.4-70.4l67.3-29.7L361 178.5v61.6l49.1 20.3zm-70.4 81.5v-43.8h-.4v-1.8l-113.8-46.5V295l113.8 46.9v-.4l.4.4zm7.5-57.6l39.9-16.4-36.8-15.5-39 16.4 35.9 15.5zm52.3 38.1v-43L355.2 298v43.4l44.3-19z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCreativeCommonsSa(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zM137.7 221c13-83.9 80.5-95.7 108.9-95.7 99.8 0 127.5 82.5 127.5 134.2 0 63.6-41 132.9-128.9 132.9-38.9 0-99.1-20-109.4-97h62.5c1.5 30.1 19.6 45.2 54.5 45.2 23.3 0 58-18.2 58-82.8 0-82.5-49.1-80.6-56.7-80.6-33.1 0-51.7 14.6-55.8 43.8h18.2l-49.2 49.2-49-49.2h19.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCreativeCommonsSamplingPlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm107 205.6c-4.7 0-9 2.8-10.7 7.2l-4 9.5-11-92.8c-1.7-13.9-22-13.4-23.1.4l-4.3 51.4-5.2-68.8c-1.1-14.3-22.1-14.2-23.2 0l-3.5 44.9-5.9-94.3c-.9-14.5-22.3-14.4-23.2 0l-5.1 83.7-4.3-66.3c-.9-14.4-22.2-14.4-23.2 0l-5.3 80.2-4.1-57c-1.1-14.3-22-14.3-23.2-.2l-7.7 89.8-1.8-12.2c-1.7-11.4-17.1-13.6-22-3.3l-13.2 27.7H87.5v23.2h51.3c4.4 0 8.4-2.5 10.4-6.4l10.7 73.1c2 13.5 21.9 13 23.1-.7l3.8-43.6 5.7 78.3c1.1 14.4 22.3 14.2 23.2-.1l4.6-70.4 4.8 73.3c.9 14.4 22.3 14.4 23.2-.1l4.9-80.5 4.5 71.8c.9 14.3 22.1 14.5 23.2.2l4.6-58.6 4.9 64.4c1.1 14.3 22 14.2 23.1.1l6.8-83 2.7 22.3c1.4 11.8 17.7 14.1 22.3 3.1l18-43.4h50.5V258l-58.4.3zm-78 5.2h-21.9v21.9c0 4.1-3.3 7.5-7.5 7.5-4.1 0-7.5-3.3-7.5-7.5v-21.9h-21.9c-4.1 0-7.5-3.3-7.5-7.5 0-4.1 3.4-7.5 7.5-7.5h21.9v-21.9c0-4.1 3.4-7.5 7.5-7.5s7.5 3.3 7.5 7.5v21.9h21.9c4.1 0 7.5 3.3 7.5 7.5 0 4.1-3.4 7.5-7.5 7.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCreativeCommonsSampling(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm3.6 53.2c2.8-.3 11.5 1 11.5 11.5l6.6 107.2 4.9-59.3c0-6 4.7-10.6 10.6-10.6 5.9 0 10.6 4.7 10.6 10.6 0 2.5-.5-5.7 5.7 81.5l5.8-64.2c.3-2.9 2.9-9.3 10.2-9.3 3.8 0 9.9 2.3 10.6 8.9l11.5 96.5 5.3-12.8c1.8-4.4 5.2-6.6 10.2-6.6h58v21.3h-50.9l-18.2 44.3c-3.9 9.9-19.5 9.1-20.8-3.1l-4-31.9-7.5 92.6c-.3 3-3 9.3-10.2 9.3-3 0-9.8-2.1-10.6-9.3 0-1.9.6 5.8-6.2-77.9l-5.3 72.2c-1.1 4.8-4.8 9.3-10.6 9.3-2.9 0-9.8-2-10.6-9.3 0-1.9.5 6.7-5.8-87.7l-5.8 94.8c0 6.3-3.6 12.4-10.6 12.4-5.2 0-10.6-4.1-10.6-12l-5.8-87.7c-5.8 92.5-5.3 84-5.3 85.9-1.1 4.8-4.8 9.3-10.6 9.3-3 0-9.8-2.1-10.6-9.3 0-.7-.4-1.1-.4-2.6l-6.2-88.6L182 348c-.7 6.5-6.7 9.3-10.6 9.3-5.8 0-9.6-4.1-10.6-8.9L149.7 272c-2 4-3.5 8.4-11.1 8.4H87.2v-21.3H132l13.7-27.9c4.4-9.9 18.2-7.2 19.9 2.7l3.1 20.4 8.4-97.9c0-6 4.8-10.6 10.6-10.6.5 0 10.6-.2 10.6 12.4l4.9 69.1 6.6-92.6c0-10.1 9.5-10.6 10.2-10.6.6 0 10.6.7 10.6 10.6l5.3 80.6 6.2-97.9c.1-1.1-.6-10.3 9.9-11.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCreativeCommonsShare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm101 132.4c7.8 0 13.7 6.1 13.7 13.7v182.5c0 7.7-6.1 13.7-13.7 13.7H214.3c-7.7 0-13.7-6-13.7-13.7v-54h-54c-7.8 0-13.7-6-13.7-13.7V131.1c0-8.2 6.6-12.7 12.4-13.7h136.4c7.7 0 13.7 6 13.7 13.7v54h54zM159.9 300.3h40.7V198.9c0-7.4 5.8-12.6 12-13.7h55.8v-40.3H159.9v155.4zm176.2-88.1H227.6v155.4h108.5V212.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCreativeCommonsZero(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm-.4 60.5c-81.9 0-102.5 77.3-102.5 142.8 0 65.5 20.6 142.8 102.5 142.8S350.5 321.5 350.5 256c0-65.5-20.6-142.8-102.5-142.8zm0 53.9c3.3 0 6.4.5 9.2 1.2 5.9 5.1 8.8 12.1 3.1 21.9l-54.5 100.2c-1.7-12.7-1.9-25.1-1.9-34.4 0-28.8 2-88.9 44.1-88.9zm40.8 46.2c2.9 15.4 3.3 31.4 3.3 42.7 0 28.9-2 88.9-44.1 88.9-13.5 0-32.6-7.7-20.1-26.4l60.9-105.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCreativeCommons(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M245.83 214.87l-33.22 17.28c-9.43-19.58-25.24-19.93-27.46-19.93-22.13 0-33.22 14.61-33.22 43.84 0 23.57 9.21 43.84 33.22 43.84 14.47 0 24.65-7.09 30.57-21.26l30.55 15.5c-6.17 11.51-25.69 38.98-65.1 38.98-22.6 0-73.96-10.32-73.96-77.05 0-58.69 43-77.06 72.63-77.06 30.72-.01 52.7 11.95 65.99 35.86zm143.05 0l-32.78 17.28c-9.5-19.77-25.72-19.93-27.9-19.93-22.14 0-33.22 14.61-33.22 43.84 0 23.55 9.23 43.84 33.22 43.84 14.45 0 24.65-7.09 30.54-21.26l31 15.5c-2.1 3.75-21.39 38.98-65.09 38.98-22.69 0-73.96-9.87-73.96-77.05 0-58.67 42.97-77.06 72.63-77.06 30.71-.01 52.58 11.95 65.56 35.86zM247.56 8.05C104.74 8.05 0 123.11 0 256.05c0 138.49 113.6 248 247.56 248 129.93 0 248.44-100.87 248.44-248 0-137.87-106.62-248-248.44-248zm.87 450.81c-112.54 0-203.7-93.04-203.7-202.81 0-105.42 85.43-203.27 203.72-203.27 112.53 0 202.82 89.46 202.82 203.26-.01 121.69-99.68 202.82-202.84 202.82z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCriticalRole(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M225.82 0c.26.15 216.57 124.51 217.12 124.72 3 1.18 3.7 3.46 3.7 6.56q-.11 125.17 0 250.36a5.88 5.88 0 0 1-3.38 5.78c-21.37 12-207.86 118.29-218.93 124.58h-3C142 466.34 3.08 386.56 2.93 386.48a3.29 3.29 0 0 1-1.88-3.24c0-.87 0-225.94-.05-253.1a5 5 0 0 1 2.93-4.93C27.19 112.11 213.2 6 224.07 0zM215.4 20.42l-.22-.16Q118.06 75.55 21 130.87c0 .12.08.23.13.35l30.86 11.64c-7.71 6-8.32 6-10.65 5.13-.1 0-24.17-9.28-26.8-10v230.43c.88-1.41 64.07-110.91 64.13-111 1.62-2.82 3-1.92 9.12-1.52 1.4.09 1.48.22.78 1.42-41.19 71.33-36.4 63-67.48 116.94-.81 1.4-.61 1.13 1.25 1.13h186.5c1.44 0 1.69-.23 1.7-1.64v-8.88c0-1.34 2.36-.81-18.37-1-7.46-.07-14.14-3.22-21.38-12.7-7.38-9.66-14.62-19.43-21.85-29.21-2.28-3.08-3.45-2.38-16.76-2.38-1.75 0-1.78 0-1.76 1.82.29 26.21.15 25.27 1 32.66.52 4.37 2.16 4.2 9.69 4.81 3.14.26 3.88 4.08.52 4.92-1.57.39-31.6.51-33.67-.1a2.42 2.42 0 0 1 .3-4.73c3.29-.76 6.16.81 6.66-4.44 1.3-13.66 1.17-9 1.1-79.42 0-10.82-.35-12.58-5.36-13.55-1.22-.24-3.54-.16-4.69-.55-2.88-1-2-4.84 1.77-4.85 33.67 0 46.08-1.07 56.06 4.86 7.74 4.61 12 11.48 12.51 20.4.88 14.59-6.51 22.35-15 32.59a1.46 1.46 0 0 0 0 2.22c2.6 3.25 5 6.63 7.71 9.83 27.56 33.23 24.11 30.54 41.28 33.06.89.13 1-.42 1-1.15v-11c0-1 .32-1.43 1.41-1.26a72.37 72.37 0 0 0 23.58-.3c1.08-.15 1.5.2 1.48 1.33 0 .11.88 26.69.87 26.8-.05 1.52.67 1.62 1.89 1.62h186.71Q386.51 304.6 346 234.33c2.26-.66-.4 0 6.69-1.39 2-.39 2.05-.41 3.11 1.44 7.31 12.64 77.31 134 77.37 134.06V138c-1.72.5-103.3 38.72-105.76 39.68-1.08.42-1.55.2-1.91-.88-.63-1.9-1.34-3.76-2.09-5.62-.32-.79-.09-1.13.65-1.39.1 0 95.53-35.85 103-38.77-65.42-37.57-130.56-75-196-112.6l86.82 150.39-.28.33c-9.57-.9-10.46-1.6-11.8-3.94-1-1.69-73.5-127.71-82-142.16-9.1 14.67-83.56 146.21-85.37 146.32-2.93.17-5.88.08-9.25.08q43.25-74.74 86.18-149zm51.93 129.92a37.68 37.68 0 0 0 5.54-.85c1.69-.3 2.53.2 2.6 1.92 0 .11.07 19.06-.86 20.45s-1.88 1.22-2.6-.19c-5-9.69 6.22-9.66-39.12-12-.7 0-1 .23-1 .93 0 .13 3.72 122 3.73 122.11 0 .89.52 1.2 1.21 1.51a83.92 83.92 0 0 1 8.7 4.05c7.31 4.33 11.38 10.84 12.41 19.31 1.44 11.8-2.77 35.77-32.21 37.14-2.75.13-28.26 1.08-34.14-23.25-4.66-19.26 8.26-32.7 19.89-36.4a2.45 2.45 0 0 0 2-2.66c.1-5.63 3-107.1 3.71-121.35.05-1.08-.62-1.16-1.35-1.15-32.35.52-36.75-.34-40.22 8.52-2.42 6.18-4.14 1.32-3.95.23q1.59-9 3.31-18c.4-2.11 1.43-2.61 3.43-1.86 5.59 2.11 6.72 1.7 37.25 1.92 1.73 0 1.78-.08 1.82-1.85.68-27.49.58-22.59 1-29.55a2.69 2.69 0 0 0-1.63-2.8c-5.6-2.91-8.75-7.55-8.9-13.87-.35-14.81 17.72-21.67 27.38-11.51 6.84 7.19 5.8 18.91-2.45 24.15a4.35 4.35 0 0 0-2.22 4.34c0 .59-.11-4.31 1 30.05 0 .9.43 1.12 1.24 1.11.1 0 23-.09 34.47-.37zM68.27 141.7c19.84-4.51 32.68-.56 52.49 1.69 2.76.31 3.74 1.22 3.62 4-.21 5-1.16 22.33-1.24 23.15a2.65 2.65 0 0 1-1.63 2.34c-4.06 1.7-3.61-4.45-4-7.29-3.13-22.43-73.87-32.7-74.63 25.4-.31 23.92 17 53.63 54.08 50.88 27.24-2 19-20.19 24.84-20.47a2.72 2.72 0 0 1 3 3.36c-1.83 10.85-3.42 18.95-3.45 19.15-1.54 9.17-86.7 22.09-93.35-42.06-2.71-25.85 10.44-53.37 40.27-60.15zm80 87.67h-19.49a2.57 2.57 0 0 1-2.66-1.79c2.38-3.75 5.89.92 5.86-6.14-.08-25.75.21-38 .23-40.1 0-3.42-.53-4.65-3.32-4.94-7-.72-3.11-3.37-1.11-3.38 11.84-.1 22.62-.18 30.05.72 8.77 1.07 16.71 12.63 7.93 22.62-2 2.25-4 4.42-6.14 6.73.95 1.15 6.9 8.82 17.28 19.68 2.66 2.78 6.15 3.51 9.88 3.13a2.21 2.21 0 0 0 2.23-2.12c.3-3.42.26 4.73.45-40.58 0-5.65-.34-6.58-3.23-6.83-3.95-.35-4-2.26-.69-3.37l19.09-.09c.32 0 4.49.53 1 3.38 0 .05-.16 0-.24 0-3.61.26-3.94 1-4 4.62-.27 43.93.07 40.23.41 42.82.11.84.27 2.23 5.1 2.14 2.49 0 3.86 3.37 0 3.4-10.37.08-20.74 0-31.11.07-10.67 0-13.47-6.2-24.21-20.82-1.6-2.18-8.31-2.36-8.2-.37.88 16.47 0 17.78 4 17.67 4.75-.1 4.73 3.57.83 3.55zm275-10.15c-1.21 7.13.17 10.38-5.3 10.34-61.55-.42-47.82-.22-50.72-.31a18.4 18.4 0 0 1-3.63-.73c-2.53-.6 1.48-1.23-.38-5.6-1.43-3.37-2.78-6.78-4.11-10.19a1.94 1.94 0 0 0-2-1.44 138 138 0 0 0-14.58.07 2.23 2.23 0 0 0-1.62 1.06c-1.58 3.62-3.07 7.29-4.51 11-1.27 3.23 7.86 1.32 12.19 2.16 3 .57 4.53 3.72.66 3.73H322.9c-2.92 0-3.09-3.15-.74-3.21a6.3 6.3 0 0 0 5.92-3.47c1.5-3 2.8-6 4.11-9.09 18.18-42.14 17.06-40.17 18.42-41.61a1.83 1.83 0 0 1 3 0c2.93 3.34 18.4 44.71 23.62 51.92 2 2.7 5.74 2 6.36 2 3.61.13 4-1.11 4.13-4.29.09-1.87.08 1.17.07-41.24 0-4.46-2.36-3.74-5.55-4.27-.26 0-2.56-.63-.08-3.06.21-.2-.89-.24 21.7-.15 2.32 0 5.32 2.75-1.21 3.45a2.56 2.56 0 0 0-2.66 2.83c-.07 1.63-.19 38.89.29 41.21a3.06 3.06 0 0 0 3.23 2.43c13.25.43 14.92.44 16-3.41 1.67-5.78 4.13-2.52 3.73-.19zm-104.72 64.37c-4.24 0-4.42-3.39-.61-3.41 35.91-.16 28.11.38 37.19-.65 1.68-.19 2.38.24 2.25 1.89-.26 3.39-.64 6.78-1 10.16-.25 2.16-3.2 2.61-3.4-.15-.38-5.31-2.15-4.45-15.63-5.08-1.58-.07-1.64 0-1.64 1.52V304c0 1.65 0 1.6 1.62 1.47 3.12-.25 10.31.34 15.69-1.52.47-.16 3.3-1.79 3.07 1.76 0 .21-.76 10.35-1.18 11.39-.53 1.29-1.88 1.51-2.58.32-1.17-2 0-5.08-3.71-5.3-15.42-.9-12.91-2.55-12.91 6 0 12.25-.76 16.11 3.89 16.24 16.64.48 14.4 0 16.43-5.71.84-2.37 3.5-1.77 3.18.58-.44 3.21-.85 6.43-1.23 9.64 0 .36-.16 2.4-4.66 2.39-37.16-.08-34.54-.19-35.21-.31-2.72-.51-2.2-3 .22-3.45 1.1-.19 4 .54 4.16-2.56 2.44-56.22-.07-51.34-3.91-51.33zm-.41-109.52c2.46.61 3.13 1.76 2.95 4.65-.33 5.3-.34 9-.55 9.69-.66 2.23-3.15 2.12-3.34-.27-.38-4.81-3.05-7.82-7.57-9.15-26.28-7.73-32.81 15.46-27.17 30.22 5.88 15.41 22 15.92 28.86 13.78 5.92-1.85 5.88-6.5 6.91-7.58 1.23-1.3 2.25-1.84 3.12 1.1 0 .1.57 11.89-6 12.75-1.6.21-19.38 3.69-32.68-3.39-21-11.19-16.74-35.47-6.88-45.33 14-14.06 39.91-7.06 42.32-6.47zM289.8 280.14c3.28 0 3.66 3 .16 3.43-2.61.32-5-.42-5 5.46 0 2-.19 29.05.4 41.45.11 2.29 1.15 3.52 3.44 3.65 22 1.21 14.95-1.65 18.79-6.34 1.83-2.24 2.76.84 2.76 1.08.35 13.62-4 12.39-5.19 12.4l-38.16-.19c-1.93-.23-2.06-3-.42-3.38 2-.48 4.94.4 5.13-2.8 1-15.87.57-44.65.34-47.81-.27-3.77-2.8-3.27-5.68-3.71-2.47-.38-2-3.22.34-3.22 1.45-.02 17.97-.03 23.09-.02zm-31.63-57.79c.07 4.08 2.86 3.46 6 3.58 2.61.1 2.53 3.41-.07 3.43-6.48 0-13.7 0-21.61-.06-3.84 0-3.38-3.35 0-3.37 4.49 0 3.24 1.61 3.41-45.54 0-5.08-3.27-3.54-4.72-4.23-2.58-1.23-1.36-3.09.41-3.15 1.29 0 20.19-.41 21.17.21s1.87 1.65-.42 2.86c-1 .52-3.86-.28-4.15 2.47 0 .21-.82 1.63-.07 43.8zm-36.91 274.27a2.93 2.93 0 0 0 3.26 0c17-9.79 182-103.57 197.42-112.51-.14-.43 11.26-.18-181.52-.27-1.22 0-1.57.37-1.53 1.56 0 .1 1.25 44.51 1.22 50.38a28.33 28.33 0 0 1-1.36 7.71c-.55 1.83.38-.5-13.5 32.23-.73 1.72-1 2.21-2-.08-4.19-10.34-8.28-20.72-12.57-31a23.6 23.6 0 0 1-2-10.79c.16-2.46.8-16.12 1.51-48 0-1.95 0-2-2-2h-183c2.58 1.63 178.32 102.57 196 112.76zm-90.9-188.75c0 2.4.36 2.79 2.76 3 11.54 1.17 21 3.74 25.64-7.32 6-14.46 2.66-34.41-12.48-38.84-2-.59-16-2.76-15.94 1.51.05 8.04.01 11.61.02 41.65zm105.75-15.05c0 2.13 1.07 38.68 1.09 39.13.34 9.94-25.58 5.77-25.23-2.59.08-2 1.37-37.42 1.1-39.43-14.1 7.44-14.42 40.21 6.44 48.8a17.9 17.9 0 0 0 22.39-7.07c4.91-7.76 6.84-29.47-5.43-39a2.53 2.53 0 0 1-.36.12zm-12.28-198c-9.83 0-9.73 14.75-.07 14.87s10.1-14.88.07-14.91zm-80.15 103.83c0 1.8.41 2.4 2.17 2.58 13.62 1.39 12.51-11 12.16-13.36-1.69-11.22-14.38-10.2-14.35-7.81.05 4.5-.03 13.68.02 18.59zm212.32 6.4l-6.1-15.84c-2.16 5.48-4.16 10.57-6.23 15.84z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCss3Alt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32l34.9 395.8L192 480l157.1-52.2L384 32H0zm313.1 80l-4.8 47.3L193 208.6l-.3.1h111.5l-12.8 146.6-98.2 28.7-98.8-29.2-6.4-73.9h48.9l3.2 38.3 52.6 13.3 54.7-15.4 3.7-61.6-166.3-.5v-.1l-.2.1-3.6-46.3L193.1 162l6.5-2.7H76.7L70.9 112h242.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCss3(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 32l-64 368-223.3 80L0 400l19.6-94.8h82l-8 40.6L210 390.2l134.1-44.4 18.8-97.1H29.5l16-82h333.7l10.5-52.7H56.3l16.3-82H480z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCuttlefish(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 440 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M344 305.5c-17.5 31.6-57.4 54.5-96 54.5-56.6 0-104-47.4-104-104s47.4-104 104-104c38.6 0 78.5 22.9 96 54.5 13.7-50.9 41.7-93.3 87-117.8C385.7 39.1 320.5 8 248 8 111 8 0 119 0 256s111 248 248 248c72.5 0 137.7-31.1 183-80.7-45.3-24.5-73.3-66.9-87-117.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDAndDBeyond(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M313.8 241.5c13.8 0 21-10.1 24.8-17.9-1-1.1-5-4.2-7.4-6.6-2.4 4.3-8.2 10.7-13.9 10.7-10.2 0-15.4-14.7-3.2-26.6-.5-.2-4.3-1.8-8 2.4 0-3 1-5.1 2.1-6.6-3.5 1.3-9.8 5.6-11.4 7.9.2-5.8 1.6-7.5.6-9l-.2-.2s-8.5 5.6-9.3 14.7c0 0 1.1-1.6 2.1-1.9.6-.3 1.3 0 .6 1.9-.2.6-5.8 15.7 5.1 26-.6-1.6-1.9-7.6 2.4-1.9-.3.1 5.8 7.1 15.7 7.1zm52.4-21.1c0-4-4.9-4.4-5.6-4.5 2 3.9.9 7.5.2 9 2.5-.4 5.4-1.6 5.4-4.5zm10.3 5.2c0-6.4-6.2-11.4-13.5-10.7 8 1.3 5.6 13.8-5 11.4 3.7-2.6 3.2-9.9-1.3-12.5 1.4 4.2-3 8.2-7.4 4.6-2.4-1.9-8-6.6-10.6-8.6-2.4-2.1-5.5-1-6.6-1.8-1.3-1.1-.5-3.8-2.2-5-1.6-.8-3-.3-4.8-1-1.6-.6-2.7-1.9-2.6-3.5-2.5 4.4 3.4 6.3 4.5 8.5 1 1.9-.8 4.8 4 8.5 14.8 11.6 9.1 8 10.4 18.1.6 4.3 4.2 6.7 6.4 7.4-2.1-1.9-2.9-6.4 0-9.3 0 13.9 19.2 13.3 23.1 6.4-2.4 1.1-7-.2-9-1.9 7.7 1 14.2-4.1 14.6-10.6zm-39.4-18.4c2 .8 1.6.7 6.4 4.5 10.2-24.5 21.7-15.7 22-15.5 2.2-1.9 9.8-3.8 13.8-2.7-2.4-2.7-7.5-6.2-13.3-6.2-4.7 0-7.4 2.2-8 1.3-.8-1.4 3.2-3.4 3.2-3.4-5.4.2-9.6 6.7-11.2 5.9-1.1-.5 1.4-3.7 1.4-3.7-5.1 2.9-9.3 9.1-10.2 13 4.6-5.8 13.8-9.8 19.7-9-10.5.5-19.5 9.7-23.8 15.8zm242.5 51.9c-20.7 0-40 1.3-50.3 2.1l7.4 8.2v77.2l-7.4 8.2c10.4.8 30.9 2.1 51.6 2.1 42.1 0 59.1-20.7 59.1-48.9 0-29.3-23.2-48.9-60.4-48.9zm-15.1 75.6v-53.3c30.1-3.3 46.8 3.8 46.8 26.3 0 25.6-21.4 30.2-46.8 27zM301.6 181c-1-3.4-.2-6.9 1.1-9.4 1 3 2.6 6.4 7.5 9-.5-2.4-.2-5.6.5-8-1.4-5.4 2.1-9.9 6.4-9.9 6.9 0 8.5 8.8 4.7 14.4 2.1 3.2 5.5 5.6 7.7 7.8 3.2-3.7 5.5-9.5 5.5-13.8 0-8.2-5.5-15.9-16.7-16.5-20-.9-20.2 16.6-20 18.9.5 5.2 3.4 7.8 3.3 7.5zm-.4 6c-.5 1.8-7 3.7-10.2 6.9 4.8-1 7-.2 7.8 1.8.5 1.4-.2 3.4-.5 5.6 1.6-1.8 7-5.5 11-6.2-1-.3-3.4-.8-4.3-.8 2.9-3.4 9.3-4.5 12.8-3.7-2.2-.2-6.7 1.1-8.5 2.6 1.6.3 3 .6 4.3 1.1-2.1.8-4.8 3.4-5.8 6.1 7-5 13.1 5.2 7 8.2.8.2 2.7 0 3.5-.5-.3 1.1-1.9 3-3 3.4 2.9 0 7-1.9 8.2-4.6 0 0-1.8.6-2.6-.2s.3-4.3.3-4.3c-2.3 2.9-3.4-1.3-1.3-4.2-1-.3-3.5-.6-4.6-.5 3.2-1.1 10.4-1.8 11.2-.3.6 1.1-1 3.4-1 3.4 4-.5 8.3 1.1 6.7 5.1 2.9-1.4 5.5-5.9 4.8-10.4-.3 1-1.6 2.4-2.9 2.7.2-1.4-1-2.2-1.9-2.6 1.7-9.6-14.6-14.2-14.1-23.9-1 1.3-1.8 5-.8 7.1 2.7 3.2 8.7 6.7 10.1 12.2-2.6-6.4-15.1-11.4-14.6-20.2-1.6 1.6-2.6 7.8-1.3 11 2.4 1.4 4.5 3.8 4.8 6.1-2.2-5.1-11.4-6.1-13.9-12.2-.6 2.2-.3 5 1 6.7 0 0-2.2-.8-7-.6 1.7.6 5.1 3.5 4.8 5.2zm25.9 7.4c-2.7 0-3.5-2.1-4.2-4.3 3.3 1.3 4.2 4.3 4.2 4.3zm38.9 3.7l-1-.6c-1.1-1-2.9-1.4-4.7-1.4-2.9 0-5.8 1.3-7.5 3.4-.8.8-1.4 1.8-2.1 2.6v15.7c3.5 2.6 7.1-2.9 3-7.2 1.5.3 4.6 2.7 5.1 3.2 0 0 2.6-.5 5-.5 2.1 0 3.9.3 5.6 1.1V196c-1.1.5-2.2 1-2.7 1.4zM79.9 305.9c17.2-4.6 16.2-18 16.2-19.9 0-20.6-24.1-25-37-25H3l8.3 8.6v29.5H0l11.4 14.6V346L3 354.6c61.7 0 73.8 1.5 86.4-5.9 6.7-4 9.9-9.8 9.9-17.6 0-5.1 2.6-18.8-19.4-25.2zm-41.3-27.5c20 0 29.6-.8 29.6 9.1v3c0 12.1-19 8.8-29.6 8.8zm0 59.2V315c12.2 0 32.7-2.3 32.7 8.8v4.5h.2c0 11.2-12.5 9.3-32.9 9.3zm101.2-19.3l23.1.2v-.2l14.1-21.2h-37.2v-14.9h52.4l-14.1-21v-.2l-73.5.2 7.4 8.2v77.1l-7.4 8.2h81.2l14.1-21.2-60.1.2zm214.7-60.1c-73.9 0-77.5 99.3-.3 99.3 77.9 0 74.1-99.3.3-99.3zm-.3 77.5c-37.4 0-36.9-55.3.2-55.3 36.8.1 38.8 55.3-.2 55.3zm-91.3-8.3l44.1-66.2h-41.7l6.1 7.2-20.5 37.2h-.3l-21-37.2 6.4-7.2h-44.9l44.1 65.8.2 19.4-7.7 8.2h42.6l-7.2-8.2zm-28.4-151.3c1.6 1.3 2.9 2.4 2.9 6.6v38.8c0 4.2-.8 5.3-2.7 6.4-.1.1-7.5 4.5-7.9 4.6h35.1c10 0 17.4-1.5 26-8.6-.6-5 .2-9.5.8-12 0-.2-1.8 1.4-2.7 3.5 0-5.7 1.6-15.4 9.6-20.5-.1 0-3.7-.8-9 1.1 2-3.1 10-7.9 10.4-7.9-8.2-26-38-22.9-32.2-22.9-30.9 0-32.6.3-39.9-4 .1.8.5 8.2 9.6 14.9zm21.5 5.5c4.6 0 23.1-3.3 23.1 17.3 0 20.7-18.4 17.3-23.1 17.3zm228.9 79.6l7 8.3V312h-.3c-5.4-14.4-42.3-41.5-45.2-50.9h-31.6l7.4 8.5v76.9l-7.2 8.3h39l-7.4-8.2v-47.4h.3c3.7 10.6 44.5 42.9 48.5 55.6h21.3v-85.2l7.4-8.3zm-106.7-96.1c-32.2 0-32.8.2-39.9-4 .1.7.5 8.3 9.6 14.9 3.1 2 2.9 4.3 2.9 9.5 1.8-1.1 3.8-2.2 6.1-3-1.1 1.1-2.7 2.7-3.5 4.5 1-1.1 7.5-5.1 14.6-3.5-1.6.3-4 1.1-6.1 2.9.1 0 2.1-1.1 7.5-.3v-4.3c4.7 0 23.1-3.4 23.1 17.3 0 20.5-18.5 17.3-19.7 17.3 5.7 4.4 5.8 12 2.2 16.3h.3c33.4 0 36.7-27.3 36.7-34 0-3.8-1.1-32-33.8-33.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDAndD(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M82.5 98.9c-.6-17.2 2-33.8 12.7-48.2.3 7.4 1.2 14.5 4.2 21.6 5.9-27.5 19.7-49.3 42.3-65.5-1.9 5.9-3.5 11.8-3 17.7 8.7-7.4 18.8-17.8 44.4-22.7 14.7-2.8 29.7-2 42.1 1 38.5 9.3 61 34.3 69.7 72.3 5.3 23.1.7 45-8.3 66.4-5.2 12.4-12 24.4-20.7 35.1-2-1.9-3.9-3.8-5.8-5.6-42.8-40.8-26.8-25.2-37.4-37.4-1.1-1.2-1-2.2-.1-3.6 8.3-13.5 11.8-28.2 10-44-1.1-9.8-4.3-18.9-11.3-26.2-14.5-15.3-39.2-15-53.5.6-11.4 12.5-14.1 27.4-10.9 43.6.2 1.3.4 2.7 0 3.9-3.4 13.7-4.6 27.6-2.5 41.6.1.5.1 1.1.1 1.6 0 .3-.1.5-.2 1.1-21.8-11-36-28.3-43.2-52.2-8.3 17.8-11.1 35.5-6.6 54.1-15.6-15.2-21.3-34.3-22-55.2zm469.6 123.2c-11.6-11.6-25-20.4-40.1-26.6-12.8-5.2-26-7.9-39.9-7.1-10 .6-19.6 3.1-29 6.4-2.5.9-5.1 1.6-7.7 2.2-4.9 1.2-7.3-3.1-4.7-6.8 3.2-4.6 3.4-4.2 15-12 .6-.4 1.2-.8 2.2-1.5h-2.5c-.6 0-1.2.2-1.9.3-19.3 3.3-30.7 15.5-48.9 29.6-10.4 8.1-13.8 3.8-12-.5 1.4-3.5 3.3-6.7 5.1-10 1-1.8 2.3-3.4 3.5-5.1-.2-.2-.5-.3-.7-.5-27 18.3-46.7 42.4-57.7 73.3.3.3.7.6 1 .9.3-.6.5-1.2.9-1.7 10.4-12.1 22.8-21.8 36.6-29.8 18.2-10.6 37.5-18.3 58.7-20.2 4.3-.4 8.7-.1 13.1-.1-1.8.7-3.5.9-5.3 1.1-18.5 2.4-35.5 9-51.5 18.5-30.2 17.9-54.5 42.2-75.1 70.4-.3.4-.4.9-.7 1.3 14.5 5.3 24 17.3 36.1 25.6.2-.1.3-.2.4-.4l1.2-2.7c12.2-26.9 27-52.3 46.7-74.5 16.7-18.8 38-25.3 62.5-20 5.9 1.3 11.4 4.4 17.2 6.8 2.3-1.4 5.1-3.2 8-4.7 8.4-4.3 17.4-7 26.7-9 14.7-3.1 29.5-4.9 44.5-1.3v-.5c-.5-.4-1.2-.8-1.7-1.4zM316.7 397.6c-39.4-33-22.8-19.5-42.7-35.6-.8.9 0-.2-1.9 3-11.2 19.1-25.5 35.3-44 47.6-10.3 6.8-21.5 11.8-34.1 11.8-21.6 0-38.2-9.5-49.4-27.8-12-19.5-13.3-40.7-8.2-62.6 7.8-33.8 30.1-55.2 38.6-64.3-18.7-6.2-33 1.7-46.4 13.9.8-13.9 4.3-26.2 11.8-37.3-24.3 10.6-45.9 25-64.8 43.9-.3-5.8 5.4-43.7 5.6-44.7.3-2.7-.6-5.3-3-7.4-24.2 24.7-44.5 51.8-56.1 84.6 7.4-5.9 14.9-11.4 23.6-16.2-8.3 22.3-19.6 52.8-7.8 101.1 4.6 19 11.9 36.8 24.1 52.3 2.9 3.7 6.3 6.9 9.5 10.3.2-.2.4-.3.6-.5-1.4-7-2.2-14.1-1.5-21.9 2.2 3.2 3.9 6 5.9 8.6 12.6 16 28.7 27.4 47.2 35.6 25 11.3 51.1 13.3 77.9 8.6 54.9-9.7 90.7-48.6 116-98.8 1-1.8.6-2.9-.9-4.2zm172-46.4c-9.5-3.1-22.2-4.2-28.7-2.9 9.9 4 14.1 6.6 18.8 12 12.6 14.4 10.4 34.7-5.4 45.6-11.7 8.1-24.9 10.5-38.9 9.1-1.2-.1-2.3-.4-3-.6 2.8-3.7 6-7 8.1-10.8 9.4-16.8 5.4-42.1-8.7-56.1-2.1-2.1-4.6-3.9-7-5.9-.3 1.3-.1 2.1.1 2.8 4.2 16.6-8.1 32.4-24.8 31.8-7.6-.3-13.9-3.8-19.6-8.5-19.5-16.1-39.1-32.1-58.5-48.3-5.9-4.9-12.5-8.1-20.1-8.7-4.6-.4-9.3-.6-13.9-.9-5.9-.4-8.8-2.8-10.4-8.4-.9-3.4-1.5-6.8-2.2-10.2-1.5-8.1-6.2-13-14.3-14.2-4.4-.7-8.9-1-13.3-1.5-13-1.4-19.8-7.4-22.6-20.3-5 11-1.6 22.4 7.3 29.9 4.5 3.8 9.3 7.3 13.8 11.2 4.6 3.8 7.4 8.7 7.9 14.8.4 4.7.8 9.5 1.8 14.1 2.2 10.6 8.9 18.4 17 25.1 16.5 13.7 33 27.3 49.5 41.1 17.9 15 13.9 32.8 13 56-.9 22.9 12.2 42.9 33.5 51.2 1 .4 2 .6 3.6 1.1-15.7-18.2-10.1-44.1.7-52.3.3 2.2.4 4.3.9 6.4 9.4 44.1 45.4 64.2 85 56.9 16-2.9 30.6-8.9 42.9-19.8 2-1.8 3.7-4.1 5.9-6.5-19.3 4.6-35.8.1-50.9-10.6.7-.3 1.3-.3 1.9-.3 21.3 1.8 40.6-3.4 57-17.4 19.5-16.6 26.6-42.9 17.4-66-8.3-20.1-23.6-32.3-43.8-38.9zM99.4 179.3c-5.3-9.2-13.2-15.6-22.1-21.3 13.7-.5 26.6.2 39.6 3.7-7-12.2-8.5-24.7-5-38.7 5.3 11.9 13.7 20.1 23.6 26.8 19.7 13.2 35.7 19.6 46.7 30.2 3.4 3.3 6.3 7.1 9.6 10.9-.8-2.1-1.4-4.1-2.2-6-5-10.6-13-18.6-22.6-25-1.8-1.2-2.8-2.5-3.4-4.5-3.3-12.5-3-25.1-.7-37.6 1-5.5 2.8-10.9 4.5-16.3.8-2.4 2.3-4.6 4-6.6.6 6.9 0 25.5 19.6 46 10.8 11.3 22.4 21.9 33.9 32.7 9 8.5 18.3 16.7 25.5 26.8 1.1 1.6 2.2 3.3 3.8 4.7-5-13-14.2-24.1-24.2-33.8-9.6-9.3-19.4-18.4-29.2-27.4-3.3-3-4.6-6.7-5.1-10.9-1.2-10.4 0-20.6 4.3-30.2.5-1 1.1-2 1.9-3.3.5 4.2.6 7.9 1.4 11.6 4.8 23.1 20.4 36.3 49.3 63.5 10 9.4 19.3 19.2 25.6 31.6 4.8 9.3 7.3 19 5.7 29.6-.1.6.5 1.7 1.1 2 6.2 2.6 10 6.9 9.7 14.3 7.7-2.6 12.5-8 16.4-14.5 4.2 20.2-9.1 50.3-27.2 58.7.4-4.5 5-23.4-16.5-27.7-6.8-1.3-12.8-1.3-22.9-2.1 4.7-9 10.4-20.6.5-22.4-24.9-4.6-52.8 1.9-57.8 4.6 8.2.4 16.3 1 23.5 3.3-2 6.5-4 12.7-5.8 18.9-1.9 6.5 2.1 14.6 9.3 9.6 1.2-.9 2.3-1.9 3.3-2.7-3.1 17.9-2.9 15.9-2.8 18.3.3 10.2 9.5 7.8 15.7 7.3-2.5 11.8-29.5 27.3-45.4 25.8 7-4.7 12.7-10.3 15.9-17.9-6.5.8-12.9 1.6-19.2 2.4l-.3-.9c4.7-3.4 8-7.8 10.2-13.1 8.7-21.1-3.6-38-25-39.9-9.1-.8-17.8.8-25.9 5.5 6.2-15.6 17.2-26.6 32.6-34.5-15.2-4.3-8.9-2.7-24.6-6.3 14.6-9.3 30.2-13.2 46.5-14.6-5.2-3.2-48.1-3.6-70.2 20.9 7.9 1.4 15.5 2.8 23.2 4.2-23.8 7-44 19.7-62.4 35.6 1.1-4.8 2.7-9.5 3.3-14.3.6-4.5.8-9.2.1-13.6-1.5-9.4-8.9-15.1-19.7-16.3-7.9-.9-15.6.1-23.3 1.3-.9.1-1.7.3-2.9 0 15.8-14.8 36-21.7 53.1-33.5 6-4.5 6.8-8.2 3-14.9zm128.4 26.8c3.3 16 12.6 25.5 23.8 24.3-4.6-11.3-12.1-19.5-23.8-24.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDailymotion(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M298.93,267a48.4,48.4,0,0,0-24.36-6.21q-19.83,0-33.44,13.27t-13.61,33.42q0,21.16,13.28,34.6t33.43,13.44q20.5,0,34.11-13.78T322,307.47A47.13,47.13,0,0,0,315.9,284,44.13,44.13,0,0,0,298.93,267ZM0,32V480H448V32ZM374.71,405.26h-53.1V381.37h-.67q-15.79,26.2-55.78,26.2-27.56,0-48.89-13.1a88.29,88.29,0,0,1-32.94-35.77q-11.6-22.68-11.59-50.89,0-27.56,11.76-50.22a89.9,89.9,0,0,1,32.93-35.78q21.18-13.09,47.72-13.1a80.87,80.87,0,0,1,29.74,5.21q13.28,5.21,25,17V153l55.79-12.09Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDashcube(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M326.6 104H110.4c-51.1 0-91.2 43.3-91.2 93.5V427c0 50.5 40.1 85 91.2 85h227.2c51.1 0 91.2-34.5 91.2-85V0L326.6 104zM153.9 416.5c-17.7 0-32.4-15.1-32.4-32.8V240.8c0-17.7 14.7-32.5 32.4-32.5h140.7c17.7 0 32 14.8 32 32.5v123.5l51.1 52.3H153.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDeezer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M451.46,244.71H576V172H451.46Zm0-173.89v72.67H576V70.82Zm0,275.06H576V273.2H451.46ZM0,447.09H124.54V374.42H0Zm150.47,0H275V374.42H150.47Zm150.52,0H425.53V374.42H301Zm150.47,0H576V374.42H451.46ZM301,345.88H425.53V273.2H301Zm-150.52,0H275V273.2H150.47Zm0-101.17H275V172H150.47Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDelicious(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M446.5 68c-.4-1.5-.9-3-1.4-4.5-.9-2.5-2-4.8-3.3-7.1-1.4-2.4-3-4.8-4.7-6.9-2.1-2.5-4.4-4.8-6.9-6.8-1.1-.9-2.2-1.7-3.3-2.5-1.3-.9-2.6-1.7-4-2.4-1.8-1-3.6-1.8-5.5-2.5-1.7-.7-3.5-1.3-5.4-1.7-3.8-1-7.9-1.5-12-1.5H48C21.5 32 0 53.5 0 80v352c0 4.1.5 8.2 1.5 12 2 7.7 5.8 14.6 11 20.3 1 1.1 2.1 2.2 3.3 3.3 5.7 5.2 12.6 9 20.3 11 3.8 1 7.9 1.5 12 1.5h352c26.5 0 48-21.5 48-48V80c-.1-4.1-.6-8.2-1.6-12zM416 432c0 8.8-7.2 16-16 16H224V256H32V80c0-8.8 7.2-16 16-16h176v192h192z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDeploydog(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M382.2 136h51.7v239.6h-51.7v-20.7c-19.8 24.8-52.8 24.1-73.8 14.7-26.2-11.7-44.3-38.1-44.3-71.8 0-29.8 14.8-57.9 43.3-70.8 20.2-9.1 52.7-10.6 74.8 12.9V136zm-64.7 161.8c0 18.2 13.6 33.5 33.2 33.5 19.8 0 33.2-16.4 33.2-32.9 0-17.1-13.7-33.2-33.2-33.2-19.6 0-33.2 16.4-33.2 32.6zM188.5 136h51.7v239.6h-51.7v-20.7c-19.8 24.8-52.8 24.1-73.8 14.7-26.2-11.7-44.3-38.1-44.3-71.8 0-29.8 14.8-57.9 43.3-70.8 20.2-9.1 52.7-10.6 74.8 12.9V136zm-64.7 161.8c0 18.2 13.6 33.5 33.2 33.5 19.8 0 33.2-16.4 33.2-32.9 0-17.1-13.7-33.2-33.2-33.2-19.7 0-33.2 16.4-33.2 32.6zM448 96c17.5 0 32 14.4 32 32v256c0 17.5-14.4 32-32 32H64c-17.5 0-32-14.4-32-32V128c0-17.5 14.4-32 32-32h384m0-32H64C28.8 64 0 92.8 0 128v256c0 35.2 28.8 64 64 64h384c35.2 0 64-28.8 64-64V128c0-35.2-28.8-64-64-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDeskpro(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 480 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M205.9 512l31.1-38.4c12.3-.2 25.6-1.4 36.5-6.6 38.9-18.6 38.4-61.9 38.3-63.8-.1-5-.8-4.4-28.9-37.4H362c-.2 50.1-7.3 68.5-10.2 75.7-9.4 23.7-43.9 62.8-95.2 69.4-8.7 1.1-32.8 1.2-50.7 1.1zm200.4-167.7c38.6 0 58.5-13.6 73.7-30.9l-175.5-.3-17.4 31.3 119.2-.1zm-43.6-223.9v168.3h-73.5l-32.7 55.5H250c-52.3 0-58.1-56.5-58.3-58.9-1.2-13.2-21.3-11.6-20.1 1.8 1.4 15.8 8.8 40 26.4 57.1h-91c-25.5 0-110.8-26.8-107-114V16.9C0 .9 9.7.3 15 .1h82c.2 0 .3.1.5.1 4.3-.4 50.1-2.1 50.1 43.7 0 13.3 20.2 13.4 20.2 0 0-18.2-5.5-32.8-15.8-43.7h84.2c108.7-.4 126.5 79.4 126.5 120.2zm-132.5 56l64 29.3c13.3-45.5-42.2-71.7-64-29.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDev(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M120.12 208.29c-3.88-2.9-7.77-4.35-11.65-4.35H91.03v104.47h17.45c3.88 0 7.77-1.45 11.65-4.35 3.88-2.9 5.82-7.25 5.82-13.06v-69.65c-.01-5.8-1.96-10.16-5.83-13.06zM404.1 32H43.9C19.7 32 .06 51.59 0 75.8v360.4C.06 460.41 19.7 480 43.9 480h360.2c24.21 0 43.84-19.59 43.9-43.8V75.8c-.06-24.21-19.7-43.8-43.9-43.8zM154.2 291.19c0 18.81-11.61 47.31-48.36 47.25h-46.4V172.98h47.38c35.44 0 47.36 28.46 47.37 47.28l.01 70.93zm100.68-88.66H201.6v38.42h32.57v29.57H201.6v38.41h53.29v29.57h-62.18c-11.16.29-20.44-8.53-20.72-19.69V193.7c-.27-11.15 8.56-20.41 19.71-20.69h63.19l-.01 29.52zm103.64 115.29c-13.2 30.75-36.85 24.63-47.44 0l-38.53-144.8h32.57l29.71 113.72 29.57-113.72h32.58l-38.46 144.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDeviantart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 93.2l-98.2 179.1 7.4 9.5H320v127.7H159.1l-13.5 9.2-43.7 84c-.3 0-8.6 8.6-9.2 9.2H0v-93.2l93.2-179.4-7.4-9.2H0V102.5h156l13.5-9.2 43.7-84c.3 0 8.6-8.6 9.2-9.2H320v93.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDhl(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M238 301.2h58.7L319 271h-58.7L238 301.2zM0 282.9v6.4h81.8l4.7-6.4H0zM172.9 271c-8.7 0-6-3.6-4.6-5.5 2.8-3.8 7.6-10.4 10.4-14.1 2.8-3.7 2.8-5.9-2.8-5.9h-51l-41.1 55.8h100.1c33.1 0 51.5-22.5 57.2-30.3h-68.2zm317.5-6.9l39.3-53.4h-62.2l-39.3 53.4h62.2zM95.3 271H0v6.4h90.6l4.7-6.4zm111-26.6c-2.8 3.8-7.5 10.4-10.3 14.2-1.4 2-4.1 5.5 4.6 5.5h45.6s7.3-10 13.5-18.4c8.4-11.4.7-35-29.2-35H112.6l-20.4 27.8h111.4c5.6 0 5.5 2.2 2.7 5.9zM0 301.2h73.1l4.7-6.4H0v6.4zm323 0h58.7L404 271h-58.7c-.1 0-22.3 30.2-22.3 30.2zm222 .1h95v-6.4h-90.3l-4.7 6.4zm22.3-30.3l-4.7 6.4H640V271h-72.7zm-13.5 18.3H640v-6.4h-81.5l-4.7 6.4zm-164.2-78.6l-22.5 30.6h-26.2l22.5-30.6h-58.7l-39.3 53.4H409l39.3-53.4h-58.7zm33.5 60.3s-4.3 5.9-6.4 8.7c-7.4 10-.9 21.6 23.2 21.6h94.3l22.3-30.3H423.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDiaspora(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M251.64 354.55c-1.4 0-88 119.9-88.7 119.9S76.34 414 76 413.25s86.6-125.7 86.6-127.4c0-2.2-129.6-44-137.6-47.1-1.3-.5 31.4-101.8 31.7-102.1.6-.7 144.4 47 145.5 47 .4 0 .9-.6 1-1.3.4-2 1-148.6 1.7-149.6.8-1.2 104.5-.7 105.1-.3 1.5 1 3.5 156.1 6.1 156.1 1.4 0 138.7-47 139.3-46.3.8.9 31.9 102.2 31.5 102.6-.9.9-140.2 47.1-140.6 48.8-.3 1.4 82.8 122.1 82.5 122.9s-85.5 63.5-86.3 63.5c-1-.2-89-125.5-90.9-125.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDigg(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M81.7 172.3H0v174.4h132.7V96h-51v76.3zm0 133.4H50.9v-92.3h30.8v92.3zm297.2-133.4v174.4h81.8v28.5h-81.8V416H512V172.3H378.9zm81.8 133.4h-30.8v-92.3h30.8v92.3zm-235.6 41h82.1v28.5h-82.1V416h133.3V172.3H225.1v174.4zm51.2-133.3h30.8v92.3h-30.8v-92.3zM153.3 96h51.3v51h-51.3V96zm0 76.3h51.3v174.4h-51.3V172.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDigitalOcean(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M87 481.8h73.7v-73.6H87zM25.4 346.6v61.6H87v-61.6zm466.2-169.7c-23-74.2-82.4-133.3-156.6-156.6C164.9-32.8 8 93.7 8 255.9h95.8c0-101.8 101-180.5 208.1-141.7 39.7 14.3 71.5 46.1 85.8 85.7 39.1 107-39.7 207.8-141.4 208v.3h-.3V504c162.6 0 288.8-156.8 235.6-327.1zm-235.3 231v-95.3h-95.6v95.6H256v-.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDiscord(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M524.531,69.836a1.5,1.5,0,0,0-.764-.7A485.065,485.065,0,0,0,404.081,32.03a1.816,1.816,0,0,0-1.923.91,337.461,337.461,0,0,0-14.9,30.6,447.848,447.848,0,0,0-134.426,0,309.541,309.541,0,0,0-15.135-30.6,1.89,1.89,0,0,0-1.924-.91A483.689,483.689,0,0,0,116.085,69.137a1.712,1.712,0,0,0-.788.676C39.068,183.651,18.186,294.69,28.43,404.354a2.016,2.016,0,0,0,.765,1.375A487.666,487.666,0,0,0,176.02,479.918a1.9,1.9,0,0,0,2.063-.676A348.2,348.2,0,0,0,208.12,430.4a1.86,1.86,0,0,0-1.019-2.588,321.173,321.173,0,0,1-45.868-21.853,1.885,1.885,0,0,1-.185-3.126c3.082-2.309,6.166-4.711,9.109-7.137a1.819,1.819,0,0,1,1.9-.256c96.229,43.917,200.41,43.917,295.5,0a1.812,1.812,0,0,1,1.924.233c2.944,2.426,6.027,4.851,9.132,7.16a1.884,1.884,0,0,1-.162,3.126,301.407,301.407,0,0,1-45.89,21.83,1.875,1.875,0,0,0-1,2.611,391.055,391.055,0,0,0,30.014,48.815,1.864,1.864,0,0,0,2.063.7A486.048,486.048,0,0,0,610.7,405.729a1.882,1.882,0,0,0,.765-1.352C623.729,277.594,590.933,167.465,524.531,69.836ZM222.491,337.58c-28.972,0-52.844-26.587-52.844-59.239S193.056,219.1,222.491,219.1c29.665,0,53.306,26.82,52.843,59.239C275.334,310.993,251.924,337.58,222.491,337.58Zm195.38,0c-28.971,0-52.843-26.587-52.843-59.239S388.437,219.1,417.871,219.1c29.667,0,53.307,26.82,52.844,59.239C470.715,310.993,447.538,337.58,417.871,337.58Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDiscourse(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M225.9 32C103.3 32 0 130.5 0 252.1 0 256 .1 480 .1 480l225.8-.2c122.7 0 222.1-102.3 222.1-223.9C448 134.3 348.6 32 225.9 32zM224 384c-19.4 0-37.9-4.3-54.4-12.1L88.5 392l22.9-75c-9.8-18.1-15.4-38.9-15.4-61 0-70.7 57.3-128 128-128s128 57.3 128 128-57.3 128-128 128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDochub(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 416 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M397.9 160H256V19.6L397.9 160zM304 192v130c0 66.8-36.5 100.1-113.3 100.1H96V84.8h94.7c12 0 23.1.8 33.1 2.5v-84C212.9 1.1 201.4 0 189.2 0H0v512h189.2C329.7 512 400 447.4 400 318.1V192h-96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDocker(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M349.9 236.3h-66.1v-59.4h66.1v59.4zm0-204.3h-66.1v60.7h66.1V32zm78.2 144.8H362v59.4h66.1v-59.4zm-156.3-72.1h-66.1v60.1h66.1v-60.1zm78.1 0h-66.1v60.1h66.1v-60.1zm276.8 100c-14.4-9.7-47.6-13.2-73.1-8.4-3.3-24-16.7-44.9-41.1-63.7l-14-9.3-9.3 14c-18.4 27.8-23.4 73.6-3.7 103.8-8.7 4.7-25.8 11.1-48.4 10.7H2.4c-8.7 50.8 5.8 116.8 44 162.1 37.1 43.9 92.7 66.2 165.4 66.2 157.4 0 273.9-72.5 328.4-204.2 21.4.4 67.6.1 91.3-45.2 1.5-2.5 6.6-13.2 8.5-17.1l-13.3-8.9zm-511.1-27.9h-66v59.4h66.1v-59.4zm78.1 0h-66.1v59.4h66.1v-59.4zm78.1 0h-66.1v59.4h66.1v-59.4zm-78.1-72.1h-66.1v60.1h66.1v-60.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDraft2Digital(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 480 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 398.1l-144-82.2v64.7h-91.3c30.8-35 81.8-95.9 111.8-149.3 35.2-62.6 16.1-123.4-12.8-153.3-4.4-4.6-62.2-62.9-166-41.2-59.1 12.4-89.4 43.4-104.3 67.3-13.1 20.9-17 39.8-18.2 47.7-5.5 33 19.4 67.1 56.7 67.1 31.7 0 57.3-25.7 57.3-57.4 0-27.1-19.7-52.1-48-56.8 1.8-7.3 17.7-21.1 26.3-24.7 41.1-17.3 78 5.2 83.3 33.5 8.3 44.3-37.1 90.4-69.7 127.6C84.5 328.1 18.3 396.8 0 415.9l336-.1V480zM369.9 371l47.1 27.2-47.1 27.2zM134.2 161.4c0 12.4-10 22.4-22.4 22.4s-22.4-10-22.4-22.4 10-22.4 22.4-22.4 22.4 10.1 22.4 22.4zM82.5 380.5c25.6-27.4 97.7-104.7 150.8-169.9 35.1-43.1 40.3-82.4 28.4-112.7-7.4-18.8-17.5-30.2-24.3-35.7 45.3 2.1 68 23.4 82.2 38.3 0 0 42.4 48.2 5.8 113.3-37 65.9-110.9 147.5-128.5 166.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDribbbleSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M90.2 228.2c8.9-42.4 37.4-77.7 75.7-95.7 3.6 4.9 28 38.8 50.7 79-64 17-120.3 16.8-126.4 16.7zM314.6 154c-33.6-29.8-79.3-41.1-122.6-30.6 3.8 5.1 28.6 38.9 51 80 48.6-18.3 69.1-45.9 71.6-49.4zM140.1 364c40.5 31.6 93.3 36.7 137.3 18-2-12-10-53.8-29.2-103.6-55.1 18.8-93.8 56.4-108.1 85.6zm98.8-108.2c-3.4-7.8-7.2-15.5-11.1-23.2C159.6 253 93.4 252.2 87.4 252c0 1.4-.1 2.8-.1 4.2 0 35.1 13.3 67.1 35.1 91.4 22.2-37.9 67.1-77.9 116.5-91.8zm34.9 16.3c17.9 49.1 25.1 89.1 26.5 97.4 30.7-20.7 52.5-53.6 58.6-91.6-4.6-1.5-42.3-12.7-85.1-5.8zm-20.3-48.4c4.8 9.8 8.3 17.8 12 26.8 45.5-5.7 90.7 3.4 95.2 4.4-.3-32.3-11.8-61.9-30.9-85.1-2.9 3.9-25.8 33.2-76.3 53.9zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-64 176c0-88.2-71.8-160-160-160S64 167.8 64 256s71.8 160 160 160 160-71.8 160-160z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDribbble(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119.252 8 8 119.252 8 256s111.252 248 248 248 248-111.252 248-248S392.748 8 256 8zm163.97 114.366c29.503 36.046 47.369 81.957 47.835 131.955-6.984-1.477-77.018-15.682-147.502-6.818-5.752-14.041-11.181-26.393-18.617-41.614 78.321-31.977 113.818-77.482 118.284-83.523zM396.421 97.87c-3.81 5.427-35.697 48.286-111.021 76.519-34.712-63.776-73.185-116.168-79.04-124.008 67.176-16.193 137.966 1.27 190.061 47.489zm-230.48-33.25c5.585 7.659 43.438 60.116 78.537 122.509-99.087 26.313-186.36 25.934-195.834 25.809C62.38 147.205 106.678 92.573 165.941 64.62zM44.17 256.323c0-2.166.043-4.322.108-6.473 9.268.19 111.92 1.513 217.706-30.146 6.064 11.868 11.857 23.915 17.174 35.949-76.599 21.575-146.194 83.527-180.531 142.306C64.794 360.405 44.17 310.73 44.17 256.323zm81.807 167.113c22.127-45.233 82.178-103.622 167.579-132.756 29.74 77.283 42.039 142.053 45.189 160.638-68.112 29.013-150.015 21.053-212.768-27.882zm248.38 8.489c-2.171-12.886-13.446-74.897-41.152-151.033 66.38-10.626 124.7 6.768 131.947 9.055-9.442 58.941-43.273 109.844-90.795 141.978z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDropbox(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 528 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M264.4 116.3l-132 84.3 132 84.3-132 84.3L0 284.1l132.3-84.3L0 116.3 132.3 32l132.1 84.3zM131.6 395.7l132-84.3 132 84.3-132 84.3-132-84.3zm132.8-111.6l132-84.3-132-83.6L395.7 32 528 116.3l-132.3 84.3L528 284.8l-132.3 84.3-131.3-85z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDrupal(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M319.5 114.7c-22.2-14-43.5-19.5-64.7-33.5-13-8.8-31.3-30-46.5-48.3-2.7 29.3-11.5 41.2-22 49.5-21.3 17-34.8 22.2-53.5 32.3C117 123 32 181.5 32 290.5 32 399.7 123.8 480 225.8 480 327.5 480 416 406 416 294c0-112.3-83-171-96.5-179.3zm2.5 325.6c-20.1 20.1-90.1 28.7-116.7 4.2-4.8-4.8.3-12 6.5-12 0 0 17 13.3 51.5 13.3 27 0 46-7.7 54.5-14 6.1-4.6 8.4 4.3 4.2 8.5zm-54.5-52.6c8.7-3.6 29-3.8 36.8 1.3 4.1 2.8 16.1 18.8 6.2 23.7-8.4 4.2-1.2-15.7-26.5-15.7-14.7 0-19.5 5.2-26.7 11-7 6-9.8 8-12.2 4.7-6-8.2 15.9-22.3 22.4-25zM360 405c-15.2-1-45.5-48.8-65-49.5-30.9-.9-104.1 80.7-161.3 42-38.8-26.6-14.6-104.8 51.8-105.2 49.5-.5 83.8 49 108.5 48.5 21.3-.3 61.8-41.8 81.8-41.8 48.7 0 23.3 109.3-15.8 106z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDyalog(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 416 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32v119.2h64V96h107.2C284.6 96 352 176.2 352 255.9 352 332 293.4 416 171.2 416H0v64h171.2C331.9 480 416 367.3 416 255.9c0-58.7-22.1-113.4-62.3-154.3C308.9 56 245.7 32 171.2 32H0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEarlybirds(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 480 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M313.2 47.5c1.2-13 21.3-14 36.6-8.7.9.3 26.2 9.7 19 15.2-27.9-7.4-56.4 18.2-55.6-6.5zm-201 6.9c30.7-8.1 62 20 61.1-7.1-1.3-14.2-23.4-15.3-40.2-9.6-1 .3-28.7 10.5-20.9 16.7zM319.4 160c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm-159.7 0c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm318.5 163.2c-9.9 24-40.7 11-63.9-1.2-13.5 69.1-58.1 111.4-126.3 124.2.3.9-2-.1 24 1 33.6 1.4 63.8-3.1 97.4-8-19.8-13.8-11.4-37.1-9.8-38.1 1.4-.9 14.7 1.7 21.6 11.5 8.6-12.5 28.4-14.8 30.2-13.6 1.6 1.1 6.6 20.9-6.9 34.6 4.7-.9 8.2-1.6 9.8-2.1 2.6-.8 17.7 11.3 3.1 13.3-14.3 2.3-22.6 5.1-47.1 10.8-45.9 10.7-85.9 11.8-117.7 12.8l1 11.6c3.8 18.1-23.4 24.3-27.6 6.2.8 17.9-27.1 21.8-28.4-1l-.5 5.3c-.7 18.4-28.4 17.9-28.3-.6-7.5 13.5-28.1 6.8-26.4-8.5l1.2-12.4c-36.7.9-59.7 3.1-61.8 3.1-20.9 0-20.9-31.6 0-31.6 2.4 0 27.7 1.3 63.2 2.8-61.1-15.5-103.7-55-114.9-118.2-25 12.8-57.5 26.8-68.2.8-10.5-25.4 21.5-42.6 66.8-73.4.7-6.6 1.6-13.3 2.7-19.8-14.4-19.6-11.6-36.3-16.1-60.4-16.8 2.4-23.2-9.1-23.6-23.1.3-7.3 2.1-14.9 2.4-15.4 1.1-1.8 10.1-2 12.7-2.6 6-31.7 50.6-33.2 90.9-34.5 19.7-21.8 45.2-41.5 80.9-48.3C203.3 29 215.2 8.5 216.2 8c1.7-.8 21.2 4.3 26.3 23.2 5.2-8.8 18.3-11.4 19.6-10.7 1.1.6 6.4 15-4.9 25.9 40.3 3.5 72.2 24.7 96 50.7 36.1 1.5 71.8 5.9 77.1 34 2.7.6 11.6.8 12.7 2.6.3.5 2.1 8.1 2.4 15.4-.5 13.9-6.8 25.4-23.6 23.1-3.2 17.3-2.7 32.9-8.7 47.7 2.4 11.7 4 23.8 4.8 36.4 37 25.4 70.3 42.5 60.3 66.9zM207.4 159.9c.9-44-37.9-42.2-78.6-40.3-21.7 1-38.9 1.9-45.5 13.9-11.4 20.9 5.9 92.9 23.2 101.2 9.8 4.7 73.4 7.9 86.3-7.1 8.2-9.4 15-49.4 14.6-67.7zm52 58.3c-4.3-12.4-6-30.1-15.3-32.7-2-.5-9-.5-11 0-10 2.8-10.8 22.1-17 37.2 15.4 0 19.3 9.7 23.7 9.7 4.3 0 6.3-11.3 19.6-14.2zm135.7-84.7c-6.6-12.1-24.8-12.9-46.5-13.9-40.2-1.9-78.2-3.8-77.3 40.3-.5 18.3 5 58.3 13.2 67.8 13 14.9 76.6 11.8 86.3 7.1 15.8-7.6 36.5-78.9 24.3-101.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEbay(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M606 189.5l-54.8 109.9-54.9-109.9h-37.5l10.9 20.6c-11.5-19-35.9-26-63.3-26-31.8 0-67.9 8.7-71.5 43.1h33.7c1.4-13.8 15.7-21.8 35-21.8 26 0 41 9.6 41 33v3.4c-12.7 0-28 .1-41.7.4-42.4.9-69.6 10-76.7 34.4 1-5.2 1.5-10.6 1.5-16.2 0-52.1-39.7-76.2-75.4-76.2-21.3 0-43 5.5-58.7 24.2v-80.6h-32.1v169.5c0 10.3-.6 22.9-1.1 33.1h31.5c.7-6.3 1.1-12.9 1.1-19.5 13.6 16.6 35.4 24.9 58.7 24.9 36.9 0 64.9-21.9 73.3-54.2-.5 2.8-.7 5.8-.7 9 0 24.1 21.1 45 60.6 45 26.6 0 45.8-5.7 61.9-25.5 0 6.6.3 13.3 1.1 20.2h29.8c-.7-8.2-1-17.5-1-26.8v-65.6c0-9.3-1.7-17.2-4.8-23.8l61.5 116.1-28.5 54.1h35.9L640 189.5zM243.7 313.8c-29.6 0-50.2-21.5-50.2-53.8 0-32.4 20.6-53.8 50.2-53.8 29.8 0 50.2 21.4 50.2 53.8 0 32.3-20.4 53.8-50.2 53.8zm200.9-47.3c0 30-17.9 48.4-51.6 48.4-25.1 0-35-13.4-35-25.8 0-19.1 18.1-24.4 47.2-25.3 13.1-.5 27.6-.6 39.4-.6zm-411.9 1.6h128.8v-8.5c0-51.7-33.1-75.4-78.4-75.4-56.8 0-83 30.8-83 77.6 0 42.5 25.3 74 82.5 74 31.4 0 68-11.7 74.4-46.1h-33.1c-12 35.8-87.7 36.7-91.2-21.6zm95-21.4H33.3c6.9-56.6 92.1-54.7 94.4 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEdgeLegacy(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M25.71,228.16l.35-.48c0,.16,0,.32-.07.48Zm460.58,15.51c0-44-7.76-84.46-28.81-122.4C416.5,47.88,343.91,8,258.89,8,119,7.72,40.62,113.21,26.06,227.68c42.42-61.31,117.07-121.38,220.37-125,0,0,109.67,0,99.42,105H170c6.37-37.39,18.55-59,34.34-78.93-75.05,34.9-121.85,96.1-120.75,188.32.83,71.45,50.13,144.84,120.75,172,83.35,31.84,192.77,7.2,240.13-21.33V363.31C363.6,419.8,173.6,424.23,172.21,295.74H486.29V243.67Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEdge(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M481.92,134.48C440.87,54.18,352.26,8,255.91,8,137.05,8,37.51,91.68,13.47,203.66c26-46.49,86.22-79.14,149.46-79.14,79.27,0,121.09,48.93,122.25,50.18,22,23.8,33,50.39,33,83.1,0,10.4-5.31,25.82-15.11,38.57-1.57,2-6.39,4.84-6.39,11,0,5.06,3.29,9.92,9.14,14,27.86,19.37,80.37,16.81,80.51,16.81A115.39,115.39,0,0,0,444.94,322a118.92,118.92,0,0,0,58.95-102.44C504.39,176.13,488.39,147.26,481.92,134.48ZM212.77,475.67a154.88,154.88,0,0,1-46.64-45c-32.94-47.42-34.24-95.6-20.1-136A155.5,155.5,0,0,1,203,215.75c59-45.2,94.84-5.65,99.06-1a80,80,0,0,0-4.89-10.14c-9.24-15.93-24-36.41-56.56-53.51-33.72-17.69-70.59-18.59-77.64-18.59-38.71,0-77.9,13-107.53,35.69C35.68,183.3,12.77,208.72,8.6,243c-1.08,12.31-2.75,62.8,23,118.27a248,248,0,0,0,248.3,141.61C241.78,496.26,214.05,476.24,212.77,475.67Zm250.72-98.33a7.76,7.76,0,0,0-7.92-.23,181.66,181.66,0,0,1-20.41,9.12,197.54,197.54,0,0,1-69.55,12.52c-91.67,0-171.52-63.06-171.52-144A61.12,61.12,0,0,1,200.61,228,168.72,168.72,0,0,0,161.85,278c-14.92,29.37-33,88.13,13.33,151.66,6.51,8.91,23,30,56,47.67,23.57,12.65,49,19.61,71.7,19.61,35.14,0,115.43-33.44,163-108.87A7.75,7.75,0,0,0,463.49,377.34Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaElementor(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M425.6 32H22.4C10 32 0 42 0 54.4v403.2C0 470 10 480 22.4 480h403.2c12.4 0 22.4-10 22.4-22.4V54.4C448 42 438 32 425.6 32M164.3 355.5h-39.8v-199h39.8v199zm159.3 0H204.1v-39.8h119.5v39.8zm0-79.6H204.1v-39.8h119.5v39.8zm0-79.7H204.1v-39.8h119.5v39.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEllo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm143.84 285.2C375.31 358.51 315.79 404.8 248 404.8s-127.31-46.29-143.84-111.6c-1.65-7.44 2.48-15.71 9.92-17.36 7.44-1.65 15.71 2.48 17.36 9.92 14.05 52.91 62 90.11 116.56 90.11s102.51-37.2 116.56-90.11c1.65-7.44 9.92-12.4 17.36-9.92 7.44 1.65 12.4 9.92 9.92 17.36z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEmber(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M639.9 254.6c-1.1-10.7-10.7-6.8-10.7-6.8s-15.6 12.1-29.3 10.7c-13.7-1.3-9.4-32-9.4-32s3-28.1-5.1-30.4c-8.1-2.4-18 7.3-18 7.3s-12.4 13.7-18.3 31.2l-1.6.5s1.9-30.6-.3-37.6c-1.6-3.5-16.4-3.2-18.8 3s-14.2 49.2-15 67.2c0 0-23.1 19.6-43.3 22.8s-25-9.4-25-9.4 54.8-15.3 52.9-59.1-44.2-27.6-49-24c-4.6 3.5-29.4 18.4-36.6 59.7-.2 1.4-.7 7.5-.7 7.5s-21.2 14.2-33 18c0 0 33-55.6-7.3-80.9-11.4-6.8-21.3-.5-27.2 5.3 13.6-17.3 46.4-64.2 36.9-105.2-5.8-24.4-18-27.1-29.2-23.1-17 6.7-23.5 16.7-23.5 16.7s-22 32-27.1 79.5-12.6 105.1-12.6 105.1-10.5 10.2-20.2 10.7-5.4-28.7-5.4-28.7 7.5-44.6 7-52.1-1.1-11.6-9.9-14.2c-8.9-2.7-18.5 8.6-18.5 8.6s-25.5 38.7-27.7 44.6l-1.3 2.4-1.3-1.6s18-52.7.8-53.5-28.5 18.8-28.5 18.8-19.6 32.8-20.4 36.5l-1.3-1.6s8.1-38.2 6.4-47.6c-1.6-9.4-10.5-7.5-10.5-7.5s-11.3-1.3-14.2 5.9-13.7 55.3-15 70.7c0 0-28.2 20.2-46.8 20.4-18.5.3-16.7-11.8-16.7-11.8s68-23.3 49.4-69.2c-8.3-11.8-18-15.5-31.7-15.3-13.7.3-30.3 8.6-41.3 33.3-5.3 11.8-6.8 23-7.8 31.5 0 0-12.3 2.4-18.8-2.9s-10 0-10 0-11.2 14-.1 18.3 28.1 6.1 28.1 6.1c1.6 7.5 6.2 19.5 19.6 29.7 20.2 15.3 58.8-1.3 58.8-1.3l15.9-8.8s.5 14.6 12.1 16.7 16.4 1 36.5-47.9c11.8-25 12.6-23.6 12.6-23.6l1.3-.3s-9.1 46.8-5.6 59.7C187.7 319.4 203 318 203 318s8.3 2.4 15-21.2 19.6-49.9 19.6-49.9h1.6s-5.6 48.1 3 63.7 30.9 5.3 30.9 5.3 15.6-7.8 18-10.2c0 0 18.5 15.8 44.6 12.9 58.3-11.5 79.1-25.9 79.1-25.9s10 24.4 41.1 26.7c35.5 2.7 54.8-18.6 54.8-18.6s-.3 13.5 12.1 18.6 20.7-22.8 20.7-22.8l20.7-57.2h1.9s1.1 37.3 21.5 43.2 47-13.7 47-13.7 6.4-3.5 5.3-14.3zm-578 5.3c.8-32 21.8-45.9 29-39 7.3 7 4.6 22-9.1 31.4-13.7 9.5-19.9 7.6-19.9 7.6zm272.8-123.8s19.1-49.7 23.6-25.5-40 96.2-40 96.2c.5-16.2 16.4-70.7 16.4-70.7zm22.8 138.4c-12.6 33-43.3 19.6-43.3 19.6s-3.5-11.8 6.4-44.9 33.3-20.2 33.3-20.2 16.2 12.4 3.6 45.5zm84.6-14.6s-3-10.5 8.1-30.6c11-20.2 19.6-9.1 19.6-9.1s9.4 10.2-1.3 25.5-26.4 14.2-26.4 14.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEmpire(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M287.6 54.2c-10.8-2.2-22.1-3.3-33.5-3.6V32.4c78.1 2.2 146.1 44 184.6 106.6l-15.8 9.1c-6.1-9.7-12.7-18.8-20.2-27.1l-18 15.5c-26-29.6-61.4-50.7-101.9-58.4l4.8-23.9zM53.4 322.4l23-7.7c-6.4-18.3-10-38.2-10-58.7s3.3-40.4 9.7-58.7l-22.7-7.7c3.6-10.8 8.3-21.3 13.6-31l-15.8-9.1C34 181 24.1 217.5 24.1 256s10 75 27.1 106.6l15.8-9.1c-5.3-10-9.7-20.3-13.6-31.1zM213.1 434c-40.4-8-75.8-29.1-101.9-58.7l-18 15.8c-7.5-8.6-14.4-17.7-20.2-27.4l-16 9.4c38.5 62.3 106.8 104.3 184.9 106.6v-18.3c-11.3-.3-22.7-1.7-33.5-3.6l4.7-23.8zM93.3 120.9l18 15.5c26-29.6 61.4-50.7 101.9-58.4l-4.7-23.8c10.8-2.2 22.1-3.3 33.5-3.6V32.4C163.9 34.6 95.9 76.4 57.4 139l15.8 9.1c6-9.7 12.6-18.9 20.1-27.2zm309.4 270.2l-18-15.8c-26 29.6-61.4 50.7-101.9 58.7l4.7 23.8c-10.8 1.9-22.1 3.3-33.5 3.6v18.3c78.1-2.2 146.4-44.3 184.9-106.6l-16.1-9.4c-5.7 9.7-12.6 18.8-20.1 27.4zM496 256c0 137-111 248-248 248S0 393 0 256 111 8 248 8s248 111 248 248zm-12.2 0c0-130.1-105.7-235.8-235.8-235.8S12.2 125.9 12.2 256 117.9 491.8 248 491.8 483.8 386.1 483.8 256zm-39-106.6l-15.8 9.1c5.3 9.7 10 20.2 13.6 31l-22.7 7.7c6.4 18.3 9.7 38.2 9.7 58.7s-3.6 40.4-10 58.7l23 7.7c-3.9 10.8-8.3 21-13.6 31l15.8 9.1C462 331 471.9 294.5 471.9 256s-9.9-75-27.1-106.6zm-183 177.7c16.3-3.3 30.4-11.6 40.7-23.5l51.2 44.8c11.9-13.6 21.3-29.3 27.1-46.8l-64.2-22.1c2.5-7.5 3.9-15.2 3.9-23.5s-1.4-16.1-3.9-23.5l64.5-22.1c-6.1-17.4-15.5-33.2-27.4-46.8l-51.2 44.8c-10.2-11.9-24.4-20.5-40.7-23.8l13.3-66.4c-8.6-1.9-17.7-2.8-27.1-2.8-9.4 0-18.5.8-27.1 2.8l13.3 66.4c-16.3 3.3-30.4 11.9-40.7 23.8l-51.2-44.8c-11.9 13.6-21.3 29.3-27.4 46.8l64.5 22.1c-2.5 7.5-3.9 15.2-3.9 23.5s1.4 16.1 3.9 23.5l-64.2 22.1c5.8 17.4 15.2 33.2 27.1 46.8l51.2-44.8c10.2 11.9 24.4 20.2 40.7 23.5l-13.3 66.7c8.6 1.7 17.7 2.8 27.1 2.8 9.4 0 18.5-1.1 27.1-2.8l-13.3-66.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEnvira(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32c477.6 0 366.6 317.3 367.1 366.3L448 480h-26l-70.4-71.2c-39 4.2-124.4 34.5-214.4-37C47 300.3 52 214.7 0 32zm79.7 46c-49.7-23.5-5.2 9.2-5.2 9.2 45.2 31.2 66 73.7 90.2 119.9 31.5 60.2 79 139.7 144.2 167.7 65 28 34.2 12.5 6-8.5-28.2-21.2-68.2-87-91-130.2-31.7-60-61-118.6-144.2-158.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaErlang(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M87.2 53.5H0v405h100.4c-49.7-52.6-78.8-125.3-78.7-212.1-.1-76.7 24-142.7 65.5-192.9zm238.2 9.7c-45.9.1-85.1 33.5-89.2 83.2h169.9c-1.1-49.7-34.5-83.1-80.7-83.2zm230.7-9.6h.3l-.1-.1zm.3 0c31.4 42.7 48.7 97.5 46.2 162.7.5 6 .5 11.7 0 24.1H230.2c-.2 109.7 38.9 194.9 138.6 195.3 68.5-.3 118-51 151.9-106.1l96.4 48.2c-17.4 30.9-36.5 57.8-57.9 80.8H640v-405z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEthereum(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M311.9 260.8L160 353.6 8 260.8 160 0l151.9 260.8zM160 383.4L8 290.6 160 512l152-221.4-152 92.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEtsy(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 348c-1.75 10.75-13.75 110-15.5 132-117.879-4.299-219.895-4.743-368.5 0v-25.5c45.457-8.948 60.627-8.019 61-35.25 1.793-72.322 3.524-244.143 0-322-1.029-28.46-12.13-26.765-61-36v-25.5c73.886 2.358 255.933 8.551 362.999-3.75-3.5 38.25-7.75 126.5-7.75 126.5H332C320.947 115.665 313.241 68 277.25 68h-137c-10.25 0-10.75 3.5-10.75 9.75V241.5c58 .5 88.5-2.5 88.5-2.5 29.77-.951 27.56-8.502 40.75-65.251h25.75c-4.407 101.351-3.91 61.829-1.75 160.25H257c-9.155-40.086-9.065-61.045-39.501-61.5 0 0-21.5-2-88-2v139c0 26 14.25 38.25 44.25 38.25H263c63.636 0 66.564-24.996 98.751-99.75H384z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEvernote(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M120.82 132.21c1.6 22.31-17.55 21.59-21.61 21.59-68.93 0-73.64-1-83.58 3.34-.56.22-.74 0-.37-.37L123.79 46.45c.38-.37.6-.22.38.37-4.35 9.99-3.35 15.09-3.35 85.39zm79 308c-14.68-37.08 13-76.93 52.52-76.62 17.49 0 22.6 23.21 7.95 31.42-6.19 3.3-24.95 1.74-25.14 19.2-.05 17.09 19.67 25 31.2 24.89A45.64 45.64 0 0 0 312 393.45v-.08c0-11.63-7.79-47.22-47.54-55.34-7.72-1.54-65-6.35-68.35-50.52-3.74 16.93-17.4 63.49-43.11 69.09-8.74 1.94-69.68 7.64-112.92-36.77 0 0-18.57-15.23-28.23-57.95-3.38-15.75-9.28-39.7-11.14-62 0-18 11.14-30.45 25.07-32.2 81 0 90 2.32 101-7.8 9.82-9.24 7.8-15.5 7.8-102.78 1-8.3 7.79-30.81 53.41-24.14 6 .86 31.91 4.18 37.48 30.64l64.26 11.15c20.43 3.71 70.94 7 80.6 57.94 22.66 121.09 8.91 238.46 7.8 238.46C362.15 485.53 267.06 480 267.06 480c-18.95-.23-54.25-9.4-67.27-39.83zm80.94-204.84c-1 1.92-2.2 6 .85 7 14.09 4.93 39.75 6.84 45.88 5.53 3.11-.25 3.05-4.43 2.48-6.65-3.53-21.85-40.83-26.5-49.24-5.92z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaExpeditedssl(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 43.4C130.6 43.4 35.4 138.6 35.4 256S130.6 468.6 248 468.6 460.6 373.4 460.6 256 365.4 43.4 248 43.4zm-97.4 132.9c0-53.7 43.7-97.4 97.4-97.4s97.4 43.7 97.4 97.4v26.6c0 5-3.9 8.9-8.9 8.9h-17.7c-5 0-8.9-3.9-8.9-8.9v-26.6c0-82.1-124-82.1-124 0v26.6c0 5-3.9 8.9-8.9 8.9h-17.7c-5 0-8.9-3.9-8.9-8.9v-26.6zM389.7 380c0 9.7-8 17.7-17.7 17.7H124c-9.7 0-17.7-8-17.7-17.7V238.3c0-9.7 8-17.7 17.7-17.7h248c9.7 0 17.7 8 17.7 17.7V380zm-248-137.3v132.9c0 2.5-1.9 4.4-4.4 4.4h-8.9c-2.5 0-4.4-1.9-4.4-4.4V242.7c0-2.5 1.9-4.4 4.4-4.4h8.9c2.5 0 4.4 1.9 4.4 4.4zm141.7 48.7c0 13-7.2 24.4-17.7 30.4v31.6c0 5-3.9 8.9-8.9 8.9h-17.7c-5 0-8.9-3.9-8.9-8.9v-31.6c-10.5-6.1-17.7-17.4-17.7-30.4 0-19.7 15.8-35.4 35.4-35.4s35.5 15.8 35.5 35.4zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 478.3C121 486.3 17.7 383 17.7 256S121 25.7 248 25.7 478.3 129 478.3 256 375 486.3 248 486.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFacebookF(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFacebookMessenger(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256.55 8C116.52 8 8 110.34 8 248.57c0 72.3 29.71 134.78 78.07 177.94 8.35 7.51 6.63 11.86 8.05 58.23A19.92 19.92 0 0 0 122 502.31c52.91-23.3 53.59-25.14 62.56-22.7C337.85 521.8 504 423.7 504 248.57 504 110.34 396.59 8 256.55 8zm149.24 185.13l-73 115.57a37.37 37.37 0 0 1-53.91 9.93l-58.08-43.47a15 15 0 0 0-18 0l-78.37 59.44c-10.46 7.93-24.16-4.6-17.11-15.67l73-115.57a37.36 37.36 0 0 1 53.91-9.93l58.06 43.46a15 15 0 0 0 18 0l78.41-59.38c10.44-7.98 24.14 4.54 17.09 15.62z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFacebookSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h137.25V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.27c-30.81 0-40.42 19.12-40.42 38.73V256h68.78l-11 71.69h-57.78V480H400a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFacebook(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFantasyFlightGames(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32.86L32.86 256 256 479.14 479.14 256 256 32.86zM88.34 255.83c1.96-2 11.92-12.3 96.49-97.48 41.45-41.75 86.19-43.77 119.77-18.69 24.63 18.4 62.06 58.9 62.15 59 .68.74 1.07 2.86.58 3.38-11.27 11.84-22.68 23.54-33.5 34.69-34.21-32.31-40.52-38.24-48.51-43.95-17.77-12.69-41.4-10.13-56.98 5.1-2.17 2.13-1.79 3.43.12 5.35 2.94 2.95 28.1 28.33 35.09 35.78-11.95 11.6-23.66 22.97-35.69 34.66-12.02-12.54-24.48-25.53-36.54-38.11-21.39 21.09-41.69 41.11-61.85 60.99a42569.01 42569.01 0 0 1-41.13-40.72zm234.82 101.6c-35.49 35.43-78.09 38.14-106.99 20.47-22.08-13.5-39.38-32.08-72.93-66.84 12.05-12.37 23.79-24.42 35.37-36.31 33.02 31.91 37.06 36.01 44.68 42.09 18.48 14.74 42.52 13.67 59.32-1.8 3.68-3.39 3.69-3.64.14-7.24-10.59-10.73-21.19-21.44-31.77-32.18-1.32-1.34-3.03-2.48-.8-4.69 10.79-10.71 21.48-21.52 32.21-32.29.26-.26.65-.38 1.91-1.07 12.37 12.87 24.92 25.92 37.25 38.75 21.01-20.73 41.24-40.68 61.25-60.42 13.68 13.4 27.13 26.58 40.86 40.03-20.17 20.86-81.68 82.71-100.5 101.5zM256 0L0 256l256 256 256-256L256 0zM16 256L256 16l240 240-240 240L16 256z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFedex(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M586 284.5l53.3-59.9h-62.4l-21.7 24.8-22.5-24.8H414v-16h56.1v-48.1H318.9V236h-.5c-9.6-11-21.5-14.8-35.4-14.8-28.4 0-49.8 19.4-57.3 44.9-18-59.4-97.4-57.6-121.9-14v-24.2H49v-26.2h60v-41.1H0V345h49v-77.5h48.9c-1.5 5.7-2.3 11.8-2.3 18.2 0 73.1 102.6 91.4 130.2 23.7h-42c-14.7 20.9-45.8 8.9-45.8-14.6h85.5c3.7 30.5 27.4 56.9 60.1 56.9 14.1 0 27-6.9 34.9-18.6h.5V345h212.2l22.1-25 22.3 25H640l-54-60.5zm-446.7-16.6c6.1-26.3 41.7-25.6 46.5 0h-46.5zm153.4 48.9c-34.6 0-34-62.8 0-62.8 32.6 0 34.5 62.8 0 62.8zm167.8 19.1h-94.4V169.4h95v30.2H405v33.9h55.5v28.1h-56.1v44.7h56.1v29.6zm-45.9-39.8v-24.4h56.1v-44l50.7 57-50.7 57v-45.6h-56.1zm138.6 10.3l-26.1 29.5H489l45.6-51.2-45.6-51.2h39.7l26.6 29.3 25.6-29.3h38.5l-45.4 51 46 51.4h-40.5l-26.3-29.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFedora(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M225 32C101.3 31.7.8 131.7.4 255.4L0 425.7a53.6 53.6 0 0 0 53.6 53.9l170.2.4c123.7.3 224.3-99.7 224.6-223.4S348.7 32.3 225 32zm169.8 157.2L333 126.6c2.3-4.7 3.8-9.2 3.8-14.3v-1.6l55.2 56.1a101 101 0 0 1 2.8 22.4zM331 94.3a106.06 106.06 0 0 1 58.5 63.8l-54.3-54.6a26.48 26.48 0 0 0-4.2-9.2zM118.1 247.2a49.66 49.66 0 0 0-7.7 11.4l-8.5-8.5a85.78 85.78 0 0 1 16.2-2.9zM97 251.4l11.8 11.9-.9 8a34.74 34.74 0 0 0 2.4 12.5l-27-27.2a80.6 80.6 0 0 1 13.7-5.2zm-18.2 7.4l38.2 38.4a53.17 53.17 0 0 0-14.1 4.7L67.6 266a107 107 0 0 1 11.2-7.2zm-15.2 9.8l35.3 35.5a67.25 67.25 0 0 0-10.5 8.5L53.5 278a64.33 64.33 0 0 1 10.1-9.4zm-13.3 12.3l34.9 35a56.84 56.84 0 0 0-7.7 11.4l-35.8-35.9c2.8-3.8 5.7-7.2 8.6-10.5zm-11 14.3l36.4 36.6a48.29 48.29 0 0 0-3.6 15.2l-39.5-39.8a99.81 99.81 0 0 1 6.7-12zm-8.8 16.3l41.3 41.8a63.47 63.47 0 0 0 6.7 26.2L25.8 326c1.4-4.9 2.9-9.6 4.7-14.5zm-7.9 43l61.9 62.2a31.24 31.24 0 0 0-3.6 14.3v1.1l-55.4-55.7a88.27 88.27 0 0 1-2.9-21.9zm5.3 30.7l54.3 54.6a28.44 28.44 0 0 0 4.2 9.2 106.32 106.32 0 0 1-58.5-63.8zm-5.3-37a80.69 80.69 0 0 1 2.1-17l72.2 72.5a37.59 37.59 0 0 0-9.9 8.7zm253.3-51.8l-42.6-.1-.1 56c-.2 69.3-64.4 115.8-125.7 102.9-5.7 0-19.9-8.7-19.9-24.2a24.89 24.89 0 0 1 24.5-24.6c6.3 0 6.3 1.6 15.7 1.6a55.91 55.91 0 0 0 56.1-55.9l.1-47c0-4.5-4.5-9-8.9-9l-33.6-.1c-32.6-.1-32.5-49.4.1-49.3l42.6.1.1-56a105.18 105.18 0 0 1 105.6-105 86.35 86.35 0 0 1 20.2 2.3c11.2 1.8 19.9 11.9 19.9 24 0 15.5-14.9 27.8-30.3 23.9-27.4-5.9-65.9 14.4-66 54.9l-.1 47a8.94 8.94 0 0 0 8.9 9l33.6.1c32.5.2 32.4 49.5-.2 49.4zm23.5-.3a35.58 35.58 0 0 0 7.6-11.4l8.5 8.5a102 102 0 0 1-16.1 2.9zm21-4.2L308.6 280l.9-8.1a34.74 34.74 0 0 0-2.4-12.5l27 27.2a74.89 74.89 0 0 1-13.7 5.3zm18-7.4l-38-38.4c4.9-1.1 9.6-2.4 13.7-4.7l36.2 35.9c-3.8 2.5-7.9 5-11.9 7.2zm15.5-9.8l-35.3-35.5a61.06 61.06 0 0 0 10.5-8.5l34.9 35a124.56 124.56 0 0 1-10.1 9zm13.2-12.3l-34.9-35a63.18 63.18 0 0 0 7.7-11.4l35.8 35.9a130.28 130.28 0 0 1-8.6 10.5zm11-14.3l-36.4-36.6a48.29 48.29 0 0 0 3.6-15.2l39.5 39.8a87.72 87.72 0 0 1-6.7 12zm13.5-30.9a140.63 140.63 0 0 1-4.7 14.3L345.6 190a58.19 58.19 0 0 0-7.1-26.2zm1-5.6l-71.9-72.1a32 32 0 0 0 9.9-9.2l64.3 64.7a90.93 90.93 0 0 1-2.3 16.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFigma(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 95.7924C14 42.8877 56.8878 0 109.793 0H274.161C327.066 0 369.954 42.8877 369.954 95.7924C369.954 129.292 352.758 158.776 326.711 175.897C352.758 193.019 369.954 222.502 369.954 256.002C369.954 308.907 327.066 351.795 274.161 351.795H272.081C247.279 351.795 224.678 342.369 207.666 326.904V415.167C207.666 468.777 163.657 512 110.309 512C57.5361 512 14 469.243 14 416.207C14 382.709 31.1945 353.227 57.2392 336.105C31.1945 318.983 14 289.5 14 256.002C14 222.502 31.196 193.019 57.2425 175.897C31.196 158.776 14 129.292 14 95.7924ZM176.288 191.587H109.793C74.2172 191.587 45.3778 220.427 45.3778 256.002C45.3778 291.44 73.9948 320.194 109.381 320.416C109.518 320.415 109.655 320.415 109.793 320.415H176.288V191.587ZM207.666 256.002C207.666 291.577 236.505 320.417 272.081 320.417H274.161C309.737 320.417 338.576 291.577 338.576 256.002C338.576 220.427 309.737 191.587 274.161 191.587H272.081C236.505 191.587 207.666 220.427 207.666 256.002ZM109.793 351.795C109.655 351.795 109.518 351.794 109.381 351.794C73.9948 352.015 45.3778 380.769 45.3778 416.207C45.3778 451.652 74.6025 480.622 110.309 480.622C146.591 480.622 176.288 451.186 176.288 415.167V351.795H109.793ZM109.793 31.3778C74.2172 31.3778 45.3778 60.2173 45.3778 95.7924C45.3778 131.368 74.2172 160.207 109.793 160.207H176.288V31.3778H109.793ZM207.666 160.207H274.161C309.737 160.207 338.576 131.368 338.576 95.7924C338.576 60.2173 309.737 31.3778 274.161 31.3778H207.666V160.207Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFirefoxBrowser(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M189.37,152.86Zm-58.74-29.37C130.79,123.5,130.71,123.5,130.63,123.49Zm351.42,45.35c-10.61-25.5-32.08-53-48.94-61.73,13.72,26.89,21.67,53.88,24.7,74,0,0,0,.14.05.41-27.58-68.75-74.35-96.47-112.55-156.83-1.93-3.05-3.86-6.11-5.74-9.33-1-1.65-1.86-3.34-2.69-5.05A44.88,44.88,0,0,1,333.24.69a.63.63,0,0,0-.55-.66.9.9,0,0,0-.46,0l-.12.07-.18.1.1-.14c-54.23,31.77-76.72,87.38-82.5,122.78a130,130,0,0,0-48.33,12.33,6.25,6.25,0,0,0-3.09,7.75,6.13,6.13,0,0,0,7.79,3.79l.52-.21a117.84,117.84,0,0,1,42.11-11l1.42-.1c2-.12,4-.2,6-.22A122.61,122.61,0,0,1,291,140c.67.2,1.32.42,2,.63,1.89.57,3.76,1.2,5.62,1.87,1.36.5,2.71,1,4.05,1.58,1.09.44,2.18.88,3.25,1.35q2.52,1.13,5,2.35c.75.37,1.5.74,2.25,1.13q2.4,1.26,4.74,2.63,1.51.87,3,1.8a124.89,124.89,0,0,1,42.66,44.13c-13-9.15-36.35-18.19-58.82-14.28,87.74,43.86,64.18,194.9-57.39,189.2a108.43,108.43,0,0,1-31.74-6.12c-2.42-.91-4.8-1.89-7.16-2.93-1.38-.63-2.76-1.27-4.12-2C174.5,346,149.9,316.92,146.83,281.59c0,0,11.25-41.95,80.62-41.95,7.5,0,28.93-20.92,29.33-27-.09-2-42.54-18.87-59.09-35.18-8.85-8.71-13.05-12.91-16.77-16.06a69.58,69.58,0,0,0-6.31-4.77A113.05,113.05,0,0,1,173.92,97c-25.06,11.41-44.55,29.45-58.71,45.37h-.12c-9.67-12.25-9-52.65-8.43-61.08-.12-.53-7.22,3.68-8.15,4.31a178.54,178.54,0,0,0-23.84,20.43A214,214,0,0,0,51.9,133.36l0,0a.08.08,0,0,1,0,0,205.84,205.84,0,0,0-32.73,73.9c-.06.27-2.33,10.21-4,22.48q-.42,2.87-.78,5.74c-.57,3.69-1,7.71-1.44,14,0,.24,0,.48-.05.72-.18,2.71-.34,5.41-.49,8.12,0,.41,0,.82,0,1.24,0,134.7,109.21,243.89,243.92,243.89,120.64,0,220.82-87.58,240.43-202.62.41-3.12.74-6.26,1.11-9.41,4.85-41.83-.54-85.79-15.82-122.55Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFirefox(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M503.52,241.48c-.12-1.56-.24-3.12-.24-4.68v-.12l-.36-4.68v-.12a245.86,245.86,0,0,0-7.32-41.15c0-.12,0-.12-.12-.24l-1.08-4c-.12-.24-.12-.48-.24-.6-.36-1.2-.72-2.52-1.08-3.72-.12-.24-.12-.6-.24-.84-.36-1.2-.72-2.4-1.08-3.48-.12-.36-.24-.6-.36-1-.36-1.2-.72-2.28-1.2-3.48l-.36-1.08c-.36-1.08-.84-2.28-1.2-3.36a8.27,8.27,0,0,0-.36-1c-.48-1.08-.84-2.28-1.32-3.36-.12-.24-.24-.6-.36-.84-.48-1.2-1-2.28-1.44-3.48,0-.12-.12-.24-.12-.36-1.56-3.84-3.24-7.68-5-11.4l-.36-.72c-.48-1-.84-1.8-1.32-2.64-.24-.48-.48-1.08-.72-1.56-.36-.84-.84-1.56-1.2-2.4-.36-.6-.6-1.2-1-1.8s-.84-1.44-1.2-2.28c-.36-.6-.72-1.32-1.08-1.92s-.84-1.44-1.2-2.16a18.07,18.07,0,0,0-1.2-2c-.36-.72-.84-1.32-1.2-2s-.84-1.32-1.2-2-.84-1.32-1.2-1.92-.84-1.44-1.32-2.16a15.63,15.63,0,0,0-1.2-1.8L463.2,119a15.63,15.63,0,0,0-1.2-1.8c-.48-.72-1.08-1.56-1.56-2.28-.36-.48-.72-1.08-1.08-1.56l-1.8-2.52c-.36-.48-.6-.84-1-1.32-1-1.32-1.8-2.52-2.76-3.72a248.76,248.76,0,0,0-23.51-26.64A186.82,186.82,0,0,0,412,62.46c-4-3.48-8.16-6.72-12.48-9.84a162.49,162.49,0,0,0-24.6-15.12c-2.4-1.32-4.8-2.52-7.2-3.72a254,254,0,0,0-55.43-19.56c-1.92-.36-3.84-.84-5.64-1.2h-.12c-1-.12-1.8-.36-2.76-.48a236.35,236.35,0,0,0-38-4H255.14a234.62,234.62,0,0,0-45.48,5c-33.59,7.08-63.23,21.24-82.91,39-1.08,1-1.92,1.68-2.4,2.16l-.48.48H124l-.12.12.12-.12a.12.12,0,0,0,.12-.12l-.12.12a.42.42,0,0,1,.24-.12c14.64-8.76,34.92-16,49.44-19.56l5.88-1.44c.36-.12.84-.12,1.2-.24,1.68-.36,3.36-.72,5.16-1.08.24,0,.6-.12.84-.12C250.94,20.94,319.34,40.14,367,85.61a171.49,171.49,0,0,1,26.88,32.76c30.36,49.2,27.48,111.11,3.84,147.59-34.44,53-111.35,71.27-159,24.84a84.19,84.19,0,0,1-25.56-59,74.05,74.05,0,0,1,6.24-31c1.68-3.84,13.08-25.67,18.24-24.59-13.08-2.76-37.55,2.64-54.71,28.19-15.36,22.92-14.52,58.2-5,83.28a132.85,132.85,0,0,1-12.12-39.24c-12.24-82.55,43.31-153,94.31-170.51-27.48-24-96.47-22.31-147.71,15.36-29.88,22-51.23,53.16-62.51,90.36,1.68-20.88,9.6-52.08,25.8-83.88-17.16,8.88-39,37-49.8,62.88-15.6,37.43-21,82.19-16.08,124.79.36,3.24.72,6.36,1.08,9.6,19.92,117.11,122,206.38,244.78,206.38C392.77,503.42,504,392.19,504,255,503.88,250.48,503.76,245.92,503.52,241.48Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFirstOrderAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 488.21C115.34 496.21 7.79 388.66 7.79 256S115.34 15.79 248 15.79 488.21 123.34 488.21 256 380.66 496.21 248 496.21zm0-459.92C126.66 36.29 28.29 134.66 28.29 256S126.66 475.71 248 475.71 467.71 377.34 467.71 256 369.34 36.29 248 36.29zm0 431.22c-116.81 0-211.51-94.69-211.51-211.51S131.19 44.49 248 44.49 459.51 139.19 459.51 256 364.81 467.51 248 467.51zm186.23-162.98a191.613 191.613 0 0 1-20.13 48.69l-74.13-35.88 61.48 54.82a193.515 193.515 0 0 1-37.2 37.29l-54.8-61.57 35.88 74.27a190.944 190.944 0 0 1-48.63 20.23l-27.29-78.47 4.79 82.93c-8.61 1.18-17.4 1.8-26.33 1.8s-17.72-.62-26.33-1.8l4.76-82.46-27.15 78.03a191.365 191.365 0 0 1-48.65-20.2l35.93-74.34-54.87 61.64a193.85 193.85 0 0 1-37.22-37.28l61.59-54.9-74.26 35.93a191.638 191.638 0 0 1-20.14-48.69l77.84-27.11-82.23 4.76c-1.16-8.57-1.78-17.32-1.78-26.21 0-9 .63-17.84 1.82-26.51l82.38 4.77-77.94-27.16a191.726 191.726 0 0 1 20.23-48.67l74.22 35.92-61.52-54.86a193.85 193.85 0 0 1 37.28-37.22l54.76 61.53-35.83-74.17a191.49 191.49 0 0 1 48.65-20.13l26.87 77.25-4.71-81.61c8.61-1.18 17.39-1.8 26.32-1.8s17.71.62 26.32 1.8l-4.74 82.16 27.05-77.76c17.27 4.5 33.6 11.35 48.63 20.17l-35.82 74.12 54.72-61.47a193.13 193.13 0 0 1 37.24 37.23l-61.45 54.77 74.12-35.86a191.515 191.515 0 0 1 20.2 48.65l-77.81 27.1 82.24-4.75c1.19 8.66 1.82 17.5 1.82 26.49 0 8.88-.61 17.63-1.78 26.19l-82.12-4.75 77.72 27.09z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFirstOrder(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.9 229.2c.1-.1.2-.3.3-.4 0 .1 0 .3-.1.4h-.2zM224 96.6c-7.1 0-14.6.6-21.4 1.7l3.7 67.4-22-64c-14.3 3.7-27.7 9.4-40 16.6l29.4 61.4-45.1-50.9c-11.4 8.9-21.7 19.1-30.6 30.9l50.6 45.4-61.1-29.7c-7.1 12.3-12.9 25.7-16.6 40l64.3 22.6-68-4c-.9 7.1-1.4 14.6-1.4 22s.6 14.6 1.4 21.7l67.7-4-64 22.6c3.7 14.3 9.4 27.7 16.6 40.3l61.1-29.7L97.7 352c8.9 11.7 19.1 22.3 30.9 30.9l44.9-50.9-29.5 61.4c12.3 7.4 25.7 13.1 40 16.9l22.3-64.6-4 68c7.1 1.1 14.6 1.7 21.7 1.7 7.4 0 14.6-.6 21.7-1.7l-4-68.6 22.6 65.1c14.3-4 27.7-9.4 40-16.9L274.9 332l44.9 50.9c11.7-8.9 22-19.1 30.6-30.9l-50.6-45.1 61.1 29.4c7.1-12.3 12.9-25.7 16.6-40.3l-64-22.3 67.4 4c1.1-7.1 1.4-14.3 1.4-21.7s-.3-14.9-1.4-22l-67.7 4 64-22.3c-3.7-14.3-9.1-28-16.6-40.3l-60.9 29.7 50.6-45.4c-8.9-11.7-19.1-22-30.6-30.9l-45.1 50.9 29.4-61.1c-12.3-7.4-25.7-13.1-40-16.9L241.7 166l4-67.7c-7.1-1.2-14.3-1.7-21.7-1.7zM443.4 128v256L224 512 4.6 384V128L224 0l219.4 128zm-17.1 10.3L224 20.9 21.7 138.3v235.1L224 491.1l202.3-117.7V138.3zM224 37.1l187.7 109.4v218.9L224 474.9 36.3 365.4V146.6L224 37.1zm0 50.9c-92.3 0-166.9 75.1-166.9 168 0 92.6 74.6 167.7 166.9 167.7 92 0 166.9-75.1 166.9-167.7 0-92.9-74.9-168-166.9-168z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFirstdraft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 192h-64v128H192v128H0v-25.6h166.4v-128h128v-128H384V192zm-25.6 38.4v128h-128v128H64V512h192V384h128V230.4h-25.6zm25.6 192h-89.6V512H320v-64h64v-25.6zM0 0v384h128V256h128V128h128V0H0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFlickr(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM144.5 319c-35.1 0-63.5-28.4-63.5-63.5s28.4-63.5 63.5-63.5 63.5 28.4 63.5 63.5-28.4 63.5-63.5 63.5zm159 0c-35.1 0-63.5-28.4-63.5-63.5s28.4-63.5 63.5-63.5 63.5 28.4 63.5 63.5-28.4 63.5-63.5 63.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFlipboard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32v448h448V32H0zm358.4 179.2h-89.6v89.6h-89.6v89.6H89.6V121.6h268.8v89.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFly(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M197.8 427.8c12.9 11.7 33.7 33.3 33.2 50.7 0 .8-.1 1.6-.1 2.5-1.8 19.8-18.8 31.1-39.1 31-25-.1-39.9-16.8-38.7-35.8 1-16.2 20.5-36.7 32.4-47.6 2.3-2.1 2.7-2.7 5.6-3.6 3.4 0 3.9.3 6.7 2.8zM331.9 67.3c-16.3-25.7-38.6-40.6-63.3-52.1C243.1 4.5 214-.2 192 0c-44.1 0-71.2 13.2-81.1 17.3C57.3 45.2 26.5 87.2 28 158.6c7.1 82.2 97 176 155.8 233.8 1.7 1.6 4.5 4.5 6.2 5.1l3.3.1c2.1-.7 1.8-.5 3.5-2.1 52.3-49.2 140.7-145.8 155.9-215.7 7-39.2 3.1-72.5-20.8-112.5zM186.8 351.9c-28-51.1-65.2-130.7-69.3-189-3.4-47.5 11.4-131.2 69.3-136.7v325.7zM328.7 180c-16.4 56.8-77.3 128-118.9 170.3C237.6 298.4 275 217 277 158.4c1.6-45.9-9.8-105.8-48-131.4 88.8 18.3 115.5 98.1 99.7 153z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFontAwesomeAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48A48 48 0 0 0 0 80V432a48 48 0 0 0 48 48H400a48 48 0 0 0 48-48V80A48 48 0 0 0 400 32Zm16 400a16 16 0 0 1-16 16H48a16 16 0 0 1-16-16V80A16 16 0 0 1 48 64H400a16 16 0 0 1 16 16ZM201.6 152c-25.4 0-37.4 10.4-57.6 14.4V160a16 16 0 0 0-32 0V352a16 16 0 0 0 32 0V198.4c20.2-4 32.2-14.4 57.6-14.4 31.4 0 43.2 16 74.6 16 10.2 0 17.8-1.4 27.8-4.6v96c-10 3.2-17.6 4.6-27.8 4.6-31.4 0-43.4-16-74.6-16a85.9 85.9 0 0 0-25.6 4v32a80 80 0 0 1 25.6-4c31.4 0 43.2 16 74.6 16 18.6 0 28.2-4.8 59.8-16V152c-31.6 11.2-41.2 16-59.8 16C244.8 168 232.8 152 201.6 152Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFontAwesomeFlag(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 48V384c-63 23-82 32-119 32-63 0-87-32-150-32-20 0-36 4-51 8V328c15-4 31-8 51-8 63 0 87 32 150 32 20 0 35-3 55-9V135c-20 6-35 9-55 9-63 0-87-32-150-32-51 0-75 21-115 29V448a31.6 31.6 0 0 1-32 32A31.6 31.6 0 0 1 0 448V64A31.6 31.6 0 0 1 32 32 31.6 31.6 0 0 1 64 64V77c40-8 64-29 115-29 63 0 87 32 150 32C366 80 385 71 448 48Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFontAwesomeLogoFull(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 3992 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1209.7 156.5c-57.8 0-102 43.9-102 99.1 0 56 44.6 99.1 102 99.1 57.4 0 102-43.1 102-99.1C1311.7 200.4 1267.5 156.5 1209.7 156.5Zm0 152.7c-35.1 0-51.8-27.4-51.8-53.2 0-25.8 16.7-53.2 51.8-53.2 35.1 0 51.8 27.8 51.8 53.2C1261.1 281.8 1244.8 309.2 1209.7 309.2Zm962.1-136.1c-4.4-10.9-12.3-16.5-23.5-16.5s-19.1 5.6-23.5 16.5l-59.4 145.8c-7.2 17.7 2.8 27.4 4.4 29a24.6 24.6 0 0 0 17.5 6.8c10.8 0 18.7-6 23.1-18.1l4-10.1h67.7l4 10.1c4.8 12.1 12.3 18.1 23.1 18.1a24.6 24.6 0 0 0 17.5-6.8c10-10.1 6.8-22.6 4.4-29Zm-43 113.6 19.1-56 19.1 56Zm-574.5-130.1c-14.3 0-24.7 10.9-24.7 25.4v76.5l-68.5-85.8c-4.4-5.6-11.6-16.1-25.5-16.1-19.1 0-24.3 17.7-24.3 25.4V329.7c0 14.1 10.4 25.4 24.7 25.4 14.3 0 24.7-10.9 24.7-25.4V252.8l68.9 86.2c4.8 5.6 11.6 16.1 25.5 16.1 19.1 0 23.9-17.3 23.9-25.4V181.9C1579 167.4 1568.6 156.5 1554.3 156.5Zm-554.1 1.6H916.5c-19.9 0-25.1 17.3-25.1 25.4V328.1c0 19.7 16.7 25.4 24.7 25.4 8 0 24.7-5.2 24.7-25.4V285h44.6c12.8 0 22.7-9.3 22.7-22.6 0-17.7-15.5-22.1-22.7-22.1H940.8V203.6h59.4c12.8 0 22.7-9.3 22.7-22.6C1022.9 163 1007.3 158.1 1000.2 158.1Zm815.1 0H1691.7c-7.2 0-22.7 4.4-22.7 22.2 0 13.3 10 22.6 22.7 22.6h37V327.7c0 14.1 10.4 25.4 24.7 25.4 14.3 0 24.7-10.9 24.7-25.4V202.8h37c12.7 0 22.7-9.3 22.7-22.6C1837.9 163 1822.4 158.1 1815.2 158.1Zm1789.5-1.6c-9.6 0-17.5 6-25.1 18.1l-46.6 76.1L3486.4 174.6q-10.8-18.1-25.1-18.1c-19.5 0-24.7 18.1-24.7 25.8V329.7c0 14.1 10.4 25.4 24.7 25.4s24.7-10.9 24.7-25.4V262.8L3510.7 302.7c6.4 10.1 13.9 15.3 22.3 15.3 8.8 0 15.9-5.2 22.3-15.3l24.7-39.9v66.9c0 14.1 10.3 25.4 24.7 25.4 14.3 0 24.7-10.9 24.7-25.4V182.3C3629.4 174.2 3624.6 156.5 3604.7 156.5Zm248.6 149.8h-65.7V272.9h39.4c11.9 0 21.1-8.9 21.1-20.9 0-12.1-9.2-20.9-21.1-20.9h-39.4V204.8h62.1c12.8 0 22.7-9.3 22.7-22.6 0-17.7-15.6-22.2-22.7-22.2h-86.4c-19.9 0-25.1 17.3-25.1 25.4V326.5c0 8.1 5.2 25.4 25.1 25.4h90c12.8 0 22.7-9.3 22.7-22.6C3876 311.2 3860.5 306.3 3853.3 306.3ZM3235 156.5c-57.8 0-102 43.9-102 99.1 0 56 44.6 99.1 102 99.1 57.4 0 102-43.1 102-99.1C3337 200.4 3292.8 156.5 3235 156.5Zm0 152.7c-35.1 0-51.8-27.4-51.8-53.2 0-25.8 16.7-53.2 51.8-53.2 35.1 0 51.8 27.8 51.8 53.2C3286.8 281.8 3270.1 309.2 3235 309.2ZM2550.2 156.5c-11.2 0-19.1 5.6-23.1 16.5l-34.3 94.7-31.5-92.2c-4.4-12.5-12.3-18.9-24.3-18.9-11.9 0-19.9 6.4-24.3 18.9l-31.5 92.2-34.3-95.5q-5.4-15.7-22.7-15.7c-6.8 0-12.3 2.4-17.5 7.3-5.2 5.2-10.8 14.5-4.8 28.6l55.8 145.8c4 11.3 11.6 16.9 23.1 16.9q16.7 0 22.7-16.9l33.5-91.8 33.5 91.8q6 16.9 22.7 16.9c11.2 0 19.1-5.6 23.1-16.9l55.8-145.8c3.6-9.3 4.4-19.3-4.8-28.6A23 23 0 0 0 2550.2 156.5Zm444.2 81-21.9-9.3c-11.9-4.8-16.3-8.5-16.3-15.7q0-12.1 16.7-12.1c12.7 0 19.5 7.7 24.3 10.9 7.2 5.2 18.3 6.8 27.9-2 10.8-10.5 6.8-23.8 1.2-30.6-12.3-14.9-30.3-22.2-53.8-22.2-19.1 0-35.1 5.2-47.4 15.7-12.3 10.5-18.7 24.2-18.7 41.1 0 24.2 15.9 43.5 47.8 57.6l19.5 8.9c15.9 6.8 19.1 9.7 19.1 17.7 0 9.3-6.4 14.1-19.5 14.1-19.1 0-34.7-14.9-36.3-16.1-10.8-7.3-21.5-2-26.3 2.8-6.8 6.4-12.7 20.9 3.2 36.2 6.8 6.4 15.5 11.7 26.7 15.3a94.6 94.6 0 0 0 32.7 5.6c19.9 0 36.7-5.2 49.8-16.1 13.1-10.9 19.5-25.4 19.5-43.5q0-20.5-12-33.8C3022.7 253.2 3010.7 244.3 2994.4 237.5Zm-206.4 68.9h-65.7V272.9h39.4c12 0 21.1-8.9 21.1-20.9 0-12.1-9.2-20.9-21.1-20.9h-39.4V204.8h62.1c12.8 0 22.7-9.3 22.7-22.6 0-17.7-15.5-22.2-22.7-22.2h-86.4c-19.9 0-25.1 17.3-25.1 25.4V326.5c0 8.1 5.2 25.4 25.1 25.4h90c12.7 0 22.7-9.3 22.7-22.6C2810.8 311.2 2795.2 306.3 2788 306.3ZM178.3 49.1c-50.5 0-74.4 20.7-114.6 28.7V65A31.8 31.8 0 1 0 0 65V447a31.8 31.8 0 0 0 63.7 0V141.4c40.2-8 64.1-28.7 114.6-28.7 62.5 0 86 31.8 148.4 31.8 20.3 0 35.4-2.8 55.3-9.2v191c-19.9 6.4-35 9.2-55.3 9.2-62.5 0-86.4-31.8-148.4-31.8-20.3 0-36.2 3.6-50.9 8V375.4a159.1 159.1 0 0 1 50.9-8c62.5 0 86 31.8 148.4 31.8 37 0 56.1-9.6 119-31.8V49.1C382.8 71.4 363.7 80.9 326.7 80.9 264.2 80.9 240.4 49.1 178.3 49.1Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFontAwesome(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48A48 48 0 0 0 0 80V432a48 48 0 0 0 48 48H400a48 48 0 0 0 48-48V80A48 48 0 0 0 400 32ZM336 312c-31.6 11.2-41.2 16-59.8 16-31.4 0-43.2-16-74.6-16a80 80 0 0 0-25.6 4V284a85.9 85.9 0 0 1 25.6-4c31.2 0 43.2 16 74.6 16 10.2 0 17.8-1.4 27.8-4.6v-96c-10 3.2-17.6 4.6-27.8 4.6-31.4 0-43.2-16-74.6-16-25.4 0-37.4 10.4-57.6 14.4V352a16 16 0 0 1-32 0V160a16 16 0 0 1 32 0v6.4c20.2-4 32.2-14.4 57.6-14.4 31.2 0 43.2 16 74.6 16 18.6 0 28.2-4.8 59.8-16Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFonticonsFi(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M114.4 224h92.4l-15.2 51.2h-76.4V433c0 8-2.8 9.2 4.4 10l59.6 5.6V483H0v-35.2l29.2-2.8c7.2-.8 9.2-3.2 9.2-10.8V278.4c0-3.2-4-3.2-8-3.2H0V224h38.4v-28.8c0-68 36.4-96 106-96 46.8 0 88.8 11.2 88.8 72.4l-69.6 8.4c.4-25.6-6-31.6-22.4-31.6-25.2 0-26 13.6-26 37.6v32c0 3.2-4.8 6-.8 6zM384 483H243.2v-34.4l28-3.6c7.2-.8 10.4-2.4 10.4-10V287c0-5.6-4-9.2-9.2-10.8l-33.2-8.8 9.2-40.4h110v208c0 8-3.6 8.8 4 10l21.6 3.6V483zm-30-347.2l12.4 45.6-10 10-42.8-22.8-42.8 22.8-10-10 12.4-45.6-30-36.4 4.8-10h38L307.2 51H320l21.2 38.4h38l4.8 13.2-30 33.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFonticons(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32v448h448V32zm187 140.9c-18.4 0-19 9.9-19 27.4v23.3c0 2.4-3.5 4.4-.6 4.4h67.4l-11.1 37.3H168v112.9c0 5.8-2 6.7 3.2 7.3l43.5 4.1v25.1H84V389l21.3-2c5.2-.6 6.7-2.3 6.7-7.9V267.7c0-2.3-2.9-2.3-5.8-2.3H84V228h28v-21c0-49.6 26.5-70 77.3-70 34.1 0 64.7 8.2 64.7 52.8l-50.7 6.1c.3-18.7-4.4-23-16.3-23zm74.3 241.8v-25.1l20.4-2.6c5.2-.6 7.6-1.7 7.6-7.3V271.8c0-4.1-2.9-6.7-6.7-7.9l-24.2-6.4 6.7-29.5h80.2v151.7c0 5.8-2.6 6.4 2.9 7.3l15.7 2.6v25.1zm80.8-255.5l9 33.2-7.3 7.3-31.2-16.6-31.2 16.6-7.3-7.3 9-33.2-21.8-24.2 3.5-9.6h27.7l15.5-28h9.3l15.5 28h27.7l3.5 9.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFortAwesomeAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208 237.4h-22.2c-2.1 0-3.7 1.6-3.7 3.7v51.7c0 2.1 1.6 3.7 3.7 3.7H208c2.1 0 3.7-1.6 3.7-3.7v-51.7c0-2.1-1.6-3.7-3.7-3.7zm118.2 0H304c-2.1 0-3.7 1.6-3.7 3.7v51.7c0 2.1 1.6 3.7 3.7 3.7h22.2c2.1 0 3.7-1.6 3.7-3.7v-51.7c-.1-2.1-1.7-3.7-3.7-3.7zm132-125.1c-2.3-3.2-4.6-6.4-7.1-9.5-9.8-12.5-20.8-24-32.8-34.4-4.5-3.9-9.1-7.6-13.9-11.2-1.6-1.2-3.2-2.3-4.8-3.5C372 34.1 340.3 20 306 13c-16.2-3.3-32.9-5-50-5s-33.9 1.7-50 5c-34.3 7.1-66 21.2-93.3 40.8-1.6 1.1-3.2 2.3-4.8 3.5-4.8 3.6-9.4 7.3-13.9 11.2-3 2.6-5.9 5.3-8.8 8s-5.7 5.5-8.4 8.4c-5.5 5.7-10.7 11.8-15.6 18-2.4 3.1-4.8 6.3-7.1 9.5C25.2 153 8.3 202.5 8.3 256c0 2 .1 4 .1 6 .1.7.1 1.3.1 2 .1 1.3.1 2.7.2 4 0 .8.1 1.5.1 2.3 0 1.3.1 2.5.2 3.7.1.8.1 1.6.2 2.4.1 1.1.2 2.3.3 3.5 0 .8.1 1.6.2 2.4.1 1.2.3 2.4.4 3.6.1.8.2 1.5.3 2.3.1 1.3.3 2.6.5 3.9.1.6.2 1.3.3 1.9l.9 5.7c.1.6.2 1.1.3 1.7.3 1.3.5 2.7.8 4 .2.8.3 1.6.5 2.4.2 1 .5 2.1.7 3.2.2.9.4 1.7.6 2.6.2 1 .4 2 .7 3 .2.9.5 1.8.7 2.7.3 1 .5 1.9.8 2.9.3.9.5 1.8.8 2.7.2.9.5 1.9.8 2.8s.5 1.8.8 2.7c.3 1 .6 1.9.9 2.8.6 1.6 1.1 3.3 1.7 4.9.4 1 .7 1.9 1 2.8.3 1 .7 2 1.1 3 .3.8.6 1.5.9 2.3l1.2 3c.3.7.6 1.5.9 2.2.4 1 .9 2 1.3 3l.9 2.1c.5 1 .9 2 1.4 3 .3.7.6 1.3.9 2 .5 1 1 2.1 1.5 3.1.2.6.5 1.1.8 1.7.6 1.1 1.1 2.2 1.7 3.3.1.2.2.3.3.5 2.2 4.1 4.4 8.2 6.8 12.2.2.4.5.8.7 1.2.7 1.1 1.3 2.2 2 3.3.3.5.6.9.9 1.4.6 1.1 1.3 2.1 2 3.2.3.5.6.9.9 1.4.7 1.1 1.4 2.1 2.1 3.2.2.4.5.8.8 1.2.7 1.1 1.5 2.2 2.3 3.3.2.2.3.5.5.7 37.5 51.7 94.4 88.5 160 99.4.9.1 1.7.3 2.6.4 1 .2 2.1.4 3.1.5s1.9.3 2.8.4c1 .2 2 .3 3 .4.9.1 1.9.2 2.9.3s1.9.2 2.9.3 2.1.2 3.1.3c.9.1 1.8.1 2.7.2 1.1.1 2.3.1 3.4.2.8 0 1.7.1 2.5.1 1.3 0 2.6.1 3.9.1.7.1 1.4.1 2.1.1 2 .1 4 .1 6 .1s4-.1 6-.1c.7 0 1.4-.1 2.1-.1 1.3 0 2.6 0 3.9-.1.8 0 1.7-.1 2.5-.1 1.1-.1 2.3-.1 3.4-.2.9 0 1.8-.1 2.7-.2 1-.1 2.1-.2 3.1-.3s1.9-.2 2.9-.3c.9-.1 1.9-.2 2.9-.3s2-.3 3-.4 1.9-.3 2.8-.4c1-.2 2.1-.3 3.1-.5.9-.1 1.7-.3 2.6-.4 65.6-11 122.5-47.7 160.1-102.4.2-.2.3-.5.5-.7.8-1.1 1.5-2.2 2.3-3.3.2-.4.5-.8.8-1.2.7-1.1 1.4-2.1 2.1-3.2.3-.5.6-.9.9-1.4.6-1.1 1.3-2.1 2-3.2.3-.5.6-.9.9-1.4.7-1.1 1.3-2.2 2-3.3.2-.4.5-.8.7-1.2 2.4-4 4.6-8.1 6.8-12.2.1-.2.2-.3.3-.5.6-1.1 1.1-2.2 1.7-3.3.2-.6.5-1.1.8-1.7.5-1 1-2.1 1.5-3.1.3-.7.6-1.3.9-2 .5-1 1-2 1.4-3l.9-2.1c.5-1 .9-2 1.3-3 .3-.7.6-1.5.9-2.2l1.2-3c.3-.8.6-1.5.9-2.3.4-1 .7-2 1.1-3s.7-1.9 1-2.8c.6-1.6 1.2-3.3 1.7-4.9.3-1 .6-1.9.9-2.8s.5-1.8.8-2.7c.2-.9.5-1.9.8-2.8s.6-1.8.8-2.7c.3-1 .5-1.9.8-2.9.2-.9.5-1.8.7-2.7.2-1 .5-2 .7-3 .2-.9.4-1.7.6-2.6.2-1 .5-2.1.7-3.2.2-.8.3-1.6.5-2.4.3-1.3.6-2.7.8-4 .1-.6.2-1.1.3-1.7l.9-5.7c.1-.6.2-1.3.3-1.9.1-1.3.3-2.6.5-3.9.1-.8.2-1.5.3-2.3.1-1.2.3-2.4.4-3.6 0-.8.1-1.6.2-2.4.1-1.1.2-2.3.3-3.5.1-.8.1-1.6.2-2.4.1 1.7.1.5.2-.7 0-.8.1-1.5.1-2.3.1-1.3.2-2.7.2-4 .1-.7.1-1.3.1-2 .1-2 .1-4 .1-6 0-53.5-16.9-103-45.8-143.7zM448 371.5c-9.4 15.5-20.6 29.9-33.6 42.9-20.6 20.6-44.5 36.7-71.2 48-13.9 5.8-28.2 10.3-42.9 13.2v-75.8c0-58.6-88.6-58.6-88.6 0v75.8c-14.7-2.9-29-7.3-42.9-13.2-26.7-11.3-50.6-27.4-71.2-48-13-13-24.2-27.4-33.6-42.9v-71.3c0-2.1 1.6-3.7 3.7-3.7h22.1c2.1 0 3.7 1.6 3.7 3.7V326h29.6V182c0-2.1 1.6-3.7 3.7-3.7h22.1c2.1 0 3.7 1.6 3.7 3.7v25.9h29.5V182c0-2.1 1.6-3.7 3.7-3.7H208c2.1 0 3.7 1.6 3.7 3.7v25.9h29.5V182c0-4.8 6.5-3.7 9.5-3.7V88.1c-4.4-2-7.4-6.7-7.4-11.5 0-16.8 25.4-16.8 25.4 0 0 4.8-3 9.4-7.4 11.5V92c6.3-1.4 12.7-2.3 19.2-2.3 9.4 0 18.4 3.5 26.3 3.5 7.2 0 15.2-3.5 19.4-3.5 2.1 0 3.7 1.6 3.7 3.7v48.4c0 5.6-18.7 6.5-22.4 6.5-8.6 0-16.6-3.5-25.4-3.5-7 0-14.1 1.2-20.8 2.8v30.7c3 0 9.5-1.1 9.5 3.7v25.9h29.5V182c0-2.1 1.6-3.7 3.7-3.7h22.2c2.1 0 3.7 1.6 3.7 3.7v25.9h29.5V182c0-2.1 1.6-3.7 3.7-3.7h22.1c2.1 0 3.7 1.6 3.7 3.7v144h29.5v-25.8c0-2.1 1.6-3.7 3.7-3.7h22.2c2.1 0 3.7 1.6 3.7 3.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFortAwesome(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M489.2 287.9h-27.4c-2.6 0-4.6 2-4.6 4.6v32h-36.6V146.2c0-2.6-2-4.6-4.6-4.6h-27.4c-2.6 0-4.6 2-4.6 4.6v32h-36.6v-32c0-2.6-2-4.6-4.6-4.6h-27.4c-2.6 0-4.6 2-4.6 4.6v32h-36.6v-32c0-6-8-4.6-11.7-4.6v-38c8.3-2 17.1-3.4 25.7-3.4 10.9 0 20.9 4.3 31.4 4.3 4.6 0 27.7-1.1 27.7-8v-60c0-2.6-2-4.6-4.6-4.6-5.1 0-15.1 4.3-24 4.3-9.7 0-20.9-4.3-32.6-4.3-8 0-16 1.1-23.7 2.9v-4.9c5.4-2.6 9.1-8.3 9.1-14.3 0-20.7-31.4-20.8-31.4 0 0 6 3.7 11.7 9.1 14.3v111.7c-3.7 0-11.7-1.4-11.7 4.6v32h-36.6v-32c0-2.6-2-4.6-4.6-4.6h-27.4c-2.6 0-4.6 2-4.6 4.6v32H128v-32c0-2.6-2-4.6-4.6-4.6H96c-2.6 0-4.6 2-4.6 4.6v178.3H54.8v-32c0-2.6-2-4.6-4.6-4.6H22.8c-2.6 0-4.6 2-4.6 4.6V512h182.9v-96c0-72.6 109.7-72.6 109.7 0v96h182.9V292.5c.1-2.6-1.9-4.6-4.5-4.6zm-288.1-4.5c0 2.6-2 4.6-4.6 4.6h-27.4c-2.6 0-4.6-2-4.6-4.6v-64c0-2.6 2-4.6 4.6-4.6h27.4c2.6 0 4.6 2 4.6 4.6v64zm146.4 0c0 2.6-2 4.6-4.6 4.6h-27.4c-2.6 0-4.6-2-4.6-4.6v-64c0-2.6 2-4.6 4.6-4.6h27.4c2.6 0 4.6 2 4.6 4.6v64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaForumbee(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.8 309.7C2 292.7 0 275.5 0 258.3 0 135 99.8 35 223.1 35c16.6 0 33.3 2 49.3 5.5C149 87.5 51.9 186 5.8 309.7zm392.9-189.2C385 103 369 87.8 350.9 75.2c-149.6 44.3-266.3 162.1-309.7 312 12.5 18.1 28 35.6 45.2 49 43.1-151.3 161.2-271.7 312.3-315.7zm15.8 252.7c15.2-25.1 25.4-53.7 29.5-82.8-79.4 42.9-145 110.6-187.6 190.3 30-4.4 58.9-15.3 84.6-31.3 35 13.1 70.9 24.3 107 33.6-9.3-36.5-20.4-74.5-33.5-109.8zm29.7-145.5c-2.6-19.5-7.9-38.7-15.8-56.8C290.5 216.7 182 327.5 137.1 466c18.1 7.6 37 12.5 56.6 15.2C240 367.1 330.5 274.4 444.2 227.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFoursquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 368 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M323.1 3H49.9C12.4 3 0 31.3 0 49.1v433.8c0 20.3 12.1 27.7 18.2 30.1 6.2 2.5 22.8 4.6 32.9-7.1C180 356.5 182.2 354 182.2 354c3.1-3.4 3.4-3.1 6.8-3.1h83.4c35.1 0 40.6-25.2 44.3-39.7l48.6-243C373.8 25.8 363.1 3 323.1 3zm-16.3 73.8l-11.4 59.7c-1.2 6.5-9.5 13.2-16.9 13.2H172.1c-12 0-20.6 8.3-20.6 20.3v13c0 12 8.6 20.6 20.6 20.6h90.4c8.3 0 16.6 9.2 14.8 18.2-1.8 8.9-10.5 53.8-11.4 58.8-.9 4.9-6.8 13.5-16.9 13.5h-73.5c-13.5 0-17.2 1.8-26.5 12.6 0 0-8.9 11.4-89.5 108.3-.9.9-1.8.6-1.8-.3V75.9c0-7.7 6.8-16.6 16.6-16.6h219c8.2 0 15.6 7.7 13.5 17.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFreeCodeCamp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M97.22,96.21c10.36-10.65,16-17.12,16-21.9,0-2.76-1.92-5.51-3.83-7.42A14.81,14.81,0,0,0,101,64.05c-8.48,0-20.92,8.79-35.84,25.69C23.68,137,2.51,182.81,3.37,250.34s17.47,117,54.06,161.87C76.22,435.86,90.62,448,100.9,448a13.55,13.55,0,0,0,8.37-3.84c1.91-2.76,3.81-5.63,3.81-8.38,0-5.63-3.86-12.2-13.2-20.55-44.45-42.33-67.32-97-67.48-165C32.25,188.8,54,137.83,97.22,96.21ZM239.47,420.07c.58.37.91.55.91.55Zm93.79.55.17-.13C333.24,420.62,333.17,420.67,333.26,420.62Zm3.13-158.18c-16.24-4.15,50.41-82.89-68.05-177.17,0,0,15.54,49.38-62.83,159.57-74.27,104.35,23.46,168.73,34,175.23-6.73-4.35-47.4-35.7,9.55-128.64,11-18.3,25.53-34.87,43.5-72.16,0,0,15.91,22.45,7.6,71.13C287.7,364,354,342.91,355,343.94c22.75,26.78-17.72,73.51-21.58,76.55,5.49-3.65,117.71-78,33-188.1C360.43,238.4,352.62,266.59,336.39,262.44ZM510.88,89.69C496,72.79,483.52,64,475,64a14.81,14.81,0,0,0-8.39,2.84c-1.91,1.91-3.83,4.66-3.83,7.42,0,4.78,5.6,11.26,16,21.9,43.23,41.61,65,92.59,64.82,154.06-.16,68-23,122.63-67.48,165-9.34,8.35-13.18,14.92-13.2,20.55,0,2.75,1.9,5.62,3.81,8.38A13.61,13.61,0,0,0,475.1,448c10.28,0,24.68-12.13,43.47-35.79,36.59-44.85,53.14-94.38,54.06-161.87S552.32,137,510.88,89.69Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFreebsd(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M303.7 96.2c11.1-11.1 115.5-77 139.2-53.2 23.7 23.7-42.1 128.1-53.2 139.2-11.1 11.1-39.4.9-63.1-22.9-23.8-23.7-34.1-52-22.9-63.1zM109.9 68.1C73.6 47.5 22 24.6 5.6 41.1c-16.6 16.6 7.1 69.4 27.9 105.7 18.5-32.2 44.8-59.3 76.4-78.7zM406.7 174c3.3 11.3 2.7 20.7-2.7 26.1-20.3 20.3-87.5-27-109.3-70.1-18-32.3-11.1-53.4 14.9-48.7 5.7-3.6 12.3-7.6 19.6-11.6-29.8-15.5-63.6-24.3-99.5-24.3-119.1 0-215.6 96.5-215.6 215.6 0 119 96.5 215.6 215.6 215.6S445.3 380.1 445.3 261c0-38.4-10.1-74.5-27.7-105.8-3.9 7-7.6 13.3-10.9 18.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFulcrum(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M95.75 164.14l-35.38 43.55L25 164.14l35.38-43.55zM144.23 0l-20.54 198.18L72.72 256l51 57.82L144.23 512V300.89L103.15 256l41.08-44.89zm79.67 164.14l35.38 43.55 35.38-43.55-35.38-43.55zm-48.48 47L216.5 256l-41.08 44.89V512L196 313.82 247 256l-51-57.82L175.42 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGalacticRepublic(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 504C111.25 504 0 392.75 0 256S111.25 8 248 8s248 111.25 248 248-111.25 248-248 248zm0-479.47C120.37 24.53 16.53 128.37 16.53 256S120.37 487.47 248 487.47 479.47 383.63 479.47 256 375.63 24.53 248 24.53zm27.62 21.81v24.62a185.933 185.933 0 0 1 83.57 34.54l17.39-17.36c-28.75-22.06-63.3-36.89-100.96-41.8zm-55.37.07c-37.64 4.94-72.16 19.8-100.88 41.85l17.28 17.36h.08c24.07-17.84 52.55-30.06 83.52-34.67V46.41zm12.25 50.17v82.87c-10.04 2.03-19.42 5.94-27.67 11.42l-58.62-58.59-21.93 21.93 58.67 58.67c-5.47 8.23-9.45 17.59-11.47 27.62h-82.9v31h82.9c2.02 10.02 6.01 19.31 11.47 27.54l-58.67 58.69 21.93 21.93 58.62-58.62a77.873 77.873 0 0 0 27.67 11.47v82.9h31v-82.9c10.05-2.03 19.37-6.06 27.62-11.55l58.67 58.69 21.93-21.93-58.67-58.69c5.46-8.23 9.47-17.52 11.5-27.54h82.87v-31h-82.87c-2.02-10.02-6.03-19.38-11.5-27.62l58.67-58.67-21.93-21.93-58.67 58.67c-8.25-5.49-17.57-9.47-27.62-11.5V96.58h-31zm183.24 30.72l-17.36 17.36a186.337 186.337 0 0 1 34.67 83.67h24.62c-4.95-37.69-19.83-72.29-41.93-101.03zm-335.55.13c-22.06 28.72-36.91 63.26-41.85 100.91h24.65c4.6-30.96 16.76-59.45 34.59-83.52l-17.39-17.39zM38.34 283.67c4.92 37.64 19.75 72.18 41.8 100.9l17.36-17.39c-17.81-24.07-29.92-52.57-34.51-83.52H38.34zm394.7 0c-4.61 30.99-16.8 59.5-34.67 83.6l17.36 17.36c22.08-28.74 36.98-63.29 41.93-100.96h-24.62zM136.66 406.38l-17.36 17.36c28.73 22.09 63.3 36.98 100.96 41.93v-24.64c-30.99-4.63-59.53-16.79-83.6-34.65zm222.53.05c-24.09 17.84-52.58 30.08-83.57 34.67v24.57c37.67-4.92 72.21-19.79 100.96-41.85l-17.31-17.39h-.08z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGalacticSenate(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M249.86 33.48v26.07C236.28 80.17 226 168.14 225.39 274.9c11.74-15.62 19.13-33.33 19.13-48.24v-16.88c-.03-5.32.75-10.53 2.19-15.65.65-2.14 1.39-4.08 2.62-5.82 1.23-1.75 3.43-3.79 6.68-3.79 3.24 0 5.45 2.05 6.68 3.79 1.23 1.75 1.97 3.68 2.62 5.82 1.44 5.12 2.22 10.33 2.19 15.65v16.88c0 14.91 7.39 32.62 19.13 48.24-.63-106.76-10.91-194.73-24.49-215.35V33.48h-12.28zm-26.34 147.77c-9.52 2.15-18.7 5.19-27.46 9.08 8.9 16.12 9.76 32.64 1.71 37.29-8 4.62-21.85-4.23-31.36-19.82-11.58 8.79-21.88 19.32-30.56 31.09 14.73 9.62 22.89 22.92 18.32 30.66-4.54 7.7-20.03 7.14-35.47-.96-5.78 13.25-9.75 27.51-11.65 42.42 9.68.18 18.67 2.38 26.18 6.04 17.78-.3 32.77-1.96 40.49-4.22 5.55-26.35 23.02-48.23 46.32-59.51.73-25.55 1.88-49.67 3.48-72.07zm64.96 0c1.59 22.4 2.75 46.52 3.47 72.07 23.29 11.28 40.77 33.16 46.32 59.51 7.72 2.26 22.71 3.92 40.49 4.22 7.51-3.66 16.5-5.85 26.18-6.04-1.9-14.91-5.86-29.17-11.65-42.42-15.44 8.1-30.93 8.66-35.47.96-4.57-7.74 3.6-21.05 18.32-30.66-8.68-11.77-18.98-22.3-30.56-31.09-9.51 15.59-23.36 24.44-31.36 19.82-8.05-4.65-7.19-21.16 1.71-37.29a147.49 147.49 0 0 0-27.45-9.08zm-32.48 8.6c-3.23 0-5.86 8.81-6.09 19.93h-.05v16.88c0 41.42-49.01 95.04-93.49 95.04-52 0-122.75-1.45-156.37 29.17v2.51c9.42 17.12 20.58 33.17 33.18 47.97C45.7 380.26 84.77 360.4 141.2 360c45.68 1.02 79.03 20.33 90.76 40.87.01.01-.01.04 0 .05 7.67 2.14 15.85 3.23 24.04 3.21 8.19.02 16.37-1.07 24.04-3.21.01-.01-.01-.04 0-.05 11.74-20.54 45.08-39.85 90.76-40.87 56.43.39 95.49 20.26 108.02 41.35 12.6-14.8 23.76-30.86 33.18-47.97v-2.51c-33.61-30.62-104.37-29.17-156.37-29.17-44.48 0-93.49-53.62-93.49-95.04v-16.88h-.05c-.23-11.12-2.86-19.93-6.09-19.93zm0 96.59c22.42 0 40.6 18.18 40.6 40.6s-18.18 40.65-40.6 40.65-40.6-18.23-40.6-40.65c0-22.42 18.18-40.6 40.6-40.6zm0 7.64c-18.19 0-32.96 14.77-32.96 32.96S237.81 360 256 360s32.96-14.77 32.96-32.96-14.77-32.96-32.96-32.96zm0 6.14c14.81 0 26.82 12.01 26.82 26.82s-12.01 26.82-26.82 26.82-26.82-12.01-26.82-26.82 12.01-26.82 26.82-26.82zm-114.8 66.67c-10.19.07-21.6.36-30.5 1.66.43 4.42 1.51 18.63 7.11 29.76 9.11-2.56 18.36-3.9 27.62-3.9 41.28.94 71.48 34.35 78.26 74.47l.11 4.7c10.4 1.91 21.19 2.94 32.21 2.94 11.03 0 21.81-1.02 32.21-2.94l.11-4.7c6.78-40.12 36.98-73.53 78.26-74.47 9.26 0 18.51 1.34 27.62 3.9 5.6-11.13 6.68-25.34 7.11-29.76-8.9-1.3-20.32-1.58-30.5-1.66-18.76.42-35.19 4.17-48.61 9.67-12.54 16.03-29.16 30.03-49.58 33.07-.09.02-.17.04-.27.05-.05.01-.11.04-.16.05-5.24 1.07-10.63 1.6-16.19 1.6-5.55 0-10.95-.53-16.19-1.6-.05-.01-.11-.04-.16-.05-.1-.02-.17-.04-.27-.05-20.42-3.03-37.03-17.04-49.58-33.07-13.42-5.49-29.86-9.25-48.61-9.67z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGetPocket(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M407.6 64h-367C18.5 64 0 82.5 0 104.6v135.2C0 364.5 99.7 464 224.2 464c124 0 223.8-99.5 223.8-224.2V104.6c0-22.4-17.7-40.6-40.4-40.6zm-162 268.5c-12.4 11.8-31.4 11.1-42.4 0C89.5 223.6 88.3 227.4 88.3 209.3c0-16.9 13.8-30.7 30.7-30.7 17 0 16.1 3.8 105.2 89.3 90.6-86.9 88.6-89.3 105.5-89.3 16.9 0 30.7 13.8 30.7 30.7 0 17.8-2.9 15.7-114.8 123.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGgCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M257 8C120 8 9 119 9 256s111 248 248 248 248-111 248-248S394 8 257 8zm-49.5 374.8L81.8 257.1l125.7-125.7 35.2 35.4-24.2 24.2-11.1-11.1-77.2 77.2 77.2 77.2 26.6-26.6-53.1-52.9 24.4-24.4 77.2 77.2-75 75.2zm99-2.2l-35.2-35.2 24.1-24.4 11.1 11.1 77.2-77.2-77.2-77.2-26.5 26.5 53.1 52.9-24.4 24.4-77.2-77.2 75-75L432.2 255 306.5 380.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGg(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M179.2 230.4l102.4 102.4-102.4 102.4L0 256 179.2 76.8l44.8 44.8-25.6 25.6-19.2-19.2-128 128 128 128 51.5-51.5-77.1-76.5 25.6-25.6zM332.8 76.8L230.4 179.2l102.4 102.4 25.6-25.6-77.1-76.5 51.5-51.5 128 128-128 128-19.2-19.2-25.6 25.6 44.8 44.8L512 256 332.8 76.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGitAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M439.55 236.05L244 40.45a28.87 28.87 0 0 0-40.81 0l-40.66 40.63 51.52 51.52c27.06-9.14 52.68 16.77 43.39 43.68l49.66 49.66c34.23-11.8 61.18 31 35.47 56.69-26.49 26.49-70.21-2.87-56-37.34L240.22 199v121.85c25.3 12.54 22.26 41.85 9.08 55a34.34 34.34 0 0 1-48.55 0c-17.57-17.6-11.07-46.91 11.25-56v-123c-20.8-8.51-24.6-30.74-18.64-45L142.57 101 8.45 235.14a28.86 28.86 0 0 0 0 40.81l195.61 195.6a28.86 28.86 0 0 0 40.8 0l194.69-194.69a28.86 28.86 0 0 0 0-40.81z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGitSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M100.59 334.24c48.57 3.31 58.95 2.11 58.95 11.94 0 20-65.55 20.06-65.55 1.52.01-5.09 3.29-9.4 6.6-13.46zm27.95-116.64c-32.29 0-33.75 44.47-.75 44.47 32.51 0 31.71-44.47.75-44.47zM448 80v352a48 48 0 0 1-48 48H48a48 48 0 0 1-48-48V80a48 48 0 0 1 48-48h352a48 48 0 0 1 48 48zm-227 69.31c0 14.49 8.38 22.88 22.86 22.88 14.74 0 23.13-8.39 23.13-22.88S258.62 127 243.88 127c-14.48 0-22.88 7.84-22.88 22.31zM199.18 195h-49.55c-25-6.55-81.56-4.85-81.56 46.75 0 18.8 9.4 32 21.85 38.11C74.23 294.23 66.8 301 66.8 310.6c0 6.87 2.79 13.22 11.18 16.76-8.9 8.4-14 14.48-14 25.92C64 373.35 81.53 385 127.52 385c44.22 0 69.87-16.51 69.87-45.73 0-36.67-28.23-35.32-94.77-39.38l8.38-13.43c17 4.74 74.19 6.23 74.19-42.43 0-11.69-4.83-19.82-9.4-25.67l23.38-1.78zm84.34 109.84l-13-1.78c-3.82-.51-4.07-1-4.07-5.09V192.52h-52.6l-2.79 20.57c15.75 5.55 17 4.86 17 10.17V298c0 5.62-.31 4.58-17 6.87v20.06h72.42zM384 315l-6.87-22.37c-40.93 15.37-37.85-12.41-37.85-16.73v-60.72h37.85v-25.41h-35.82c-2.87 0-2 2.52-2-38.63h-24.18c-2.79 27.7-11.68 38.88-34 41.42v22.62c20.47 0 19.82-.85 19.82 2.54v66.57c0 28.72 11.43 40.91 41.67 40.91 14.45 0 30.45-4.83 41.38-10.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGit(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M216.29 158.39H137C97 147.9 6.51 150.63 6.51 233.18c0 30.09 15 51.23 35 61-25.1 23-37 33.85-37 49.21 0 11 4.47 21.14 17.89 26.81C8.13 383.61 0 393.35 0 411.65c0 32.11 28.05 50.82 101.63 50.82 70.75 0 111.79-26.42 111.79-73.18 0-58.66-45.16-56.5-151.63-63l13.43-21.55c27.27 7.58 118.7 10 118.7-67.89 0-18.7-7.73-31.71-15-41.07l37.41-2.84zm-63.42 241.9c0 32.06-104.89 32.1-104.89 2.43 0-8.14 5.27-15 10.57-21.54 77.71 5.3 94.32 3.37 94.32 19.11zm-50.81-134.58c-52.8 0-50.46-71.16 1.2-71.16 49.54 0 50.82 71.16-1.2 71.16zm133.3 100.51v-32.1c26.75-3.66 27.24-2 27.24-11V203.61c0-8.5-2.05-7.38-27.24-16.26l4.47-32.92H324v168.71c0 6.51.4 7.32 6.51 8.14l20.73 2.84v32.1zm52.45-244.31c-23.17 0-36.59-13.43-36.59-36.61s13.42-35.77 36.59-35.77c23.58 0 37 12.62 37 35.77s-13.42 36.61-37 36.61zM512 350.46c-17.49 8.53-43.1 16.26-66.28 16.26-48.38 0-66.67-19.5-66.67-65.46V194.75c0-5.42 1.05-4.06-31.71-4.06V154.5c35.78-4.07 50-22 54.47-66.27h38.63c0 65.83-1.34 61.81 3.26 61.81H501v40.65h-60.56v97.15c0 6.92-4.92 51.41 60.57 26.84z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGithubAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 480 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M186.1 328.7c0 20.9-10.9 55.1-36.7 55.1s-36.7-34.2-36.7-55.1 10.9-55.1 36.7-55.1 36.7 34.2 36.7 55.1zM480 278.2c0 31.9-3.2 65.7-17.5 95-37.9 76.6-142.1 74.8-216.7 74.8-75.8 0-186.2 2.7-225.6-74.8-14.6-29-20.2-63.1-20.2-95 0-41.9 13.9-81.5 41.5-113.6-5.2-15.8-7.7-32.4-7.7-48.8 0-21.5 4.9-32.3 14.6-51.8 45.3 0 74.3 9 108.8 36 29-6.9 58.8-10 88.7-10 27 0 54.2 2.9 80.4 9.2 34-26.7 63-35.2 107.8-35.2 9.8 19.5 14.6 30.3 14.6 51.8 0 16.4-2.6 32.7-7.7 48.2 27.5 32.4 39 72.3 39 114.2zm-64.3 50.5c0-43.9-26.7-82.6-73.5-82.6-18.9 0-37 3.4-56 6-14.9 2.3-29.8 3.2-45.1 3.2-15.2 0-30.1-.9-45.1-3.2-18.7-2.6-37-6-56-6-46.8 0-73.5 38.7-73.5 82.6 0 87.8 80.4 101.3 150.4 101.3h48.2c70.3 0 150.6-13.4 150.6-101.3zm-82.6-55.1c-25.8 0-36.7 34.2-36.7 55.1s10.9 55.1 36.7 55.1 36.7-34.2 36.7-55.1-10.9-55.1-36.7-55.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGithubSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM277.3 415.7c-8.4 1.5-11.5-3.7-11.5-8 0-5.4.2-33 .2-55.3 0-15.6-5.2-25.5-11.3-30.7 37-4.1 76-9.2 76-73.1 0-18.2-6.5-27.3-17.1-39 1.7-4.3 7.4-22-1.7-45-13.9-4.3-45.7 17.9-45.7 17.9-13.2-3.7-27.5-5.6-41.6-5.6-14.1 0-28.4 1.9-41.6 5.6 0 0-31.8-22.2-45.7-17.9-9.1 22.9-3.5 40.6-1.7 45-10.6 11.7-15.6 20.8-15.6 39 0 63.6 37.3 69 74.3 73.1-4.8 4.3-9.1 11.7-10.6 22.3-9.5 4.3-33.8 11.7-48.3-13.9-9.1-15.8-25.5-17.1-25.5-17.1-16.2-.2-1.1 10.2-1.1 10.2 10.8 5 18.4 24.2 18.4 24.2 9.7 29.7 56.1 19.7 56.1 19.7 0 13.9.2 36.5.2 40.6 0 4.3-3 9.5-11.5 8-66-22.1-112.2-84.9-112.2-158.3 0-91.8 70.2-161.5 162-161.5S388 165.6 388 257.4c.1 73.4-44.7 136.3-110.7 158.3zm-98.1-61.1c-1.9.4-3.7-.4-3.9-1.7-.2-1.5 1.1-2.8 3-3.2 1.9-.2 3.7.6 3.9 1.9.3 1.3-1 2.6-3 3zm-9.5-.9c0 1.3-1.5 2.4-3.5 2.4-2.2.2-3.7-.9-3.7-2.4 0-1.3 1.5-2.4 3.5-2.4 1.9-.2 3.7.9 3.7 2.4zm-13.7-1.1c-.4 1.3-2.4 1.9-4.1 1.3-1.9-.4-3.2-1.9-2.8-3.2.4-1.3 2.4-1.9 4.1-1.5 2 .6 3.3 2.1 2.8 3.4zm-12.3-5.4c-.9 1.1-2.8.9-4.3-.6-1.5-1.3-1.9-3.2-.9-4.1.9-1.1 2.8-.9 4.3.6 1.3 1.3 1.8 3.3.9 4.1zm-9.1-9.1c-.9.6-2.6 0-3.7-1.5s-1.1-3.2 0-3.9c1.1-.9 2.8-.2 3.7 1.3 1.1 1.5 1.1 3.3 0 4.1zm-6.5-9.7c-.9.9-2.4.4-3.5-.6-1.1-1.3-1.3-2.8-.4-3.5.9-.9 2.4-.4 3.5.6 1.1 1.3 1.3 2.8.4 3.5zm-6.7-7.4c-.4.9-1.7 1.1-2.8.4-1.3-.6-1.9-1.7-1.5-2.6.4-.6 1.5-.9 2.8-.4 1.3.7 1.9 1.8 1.5 2.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGithub(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGitkraken(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 592 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M565.7 118.1c-2.3-6.1-9.3-9.2-15.3-6.6-5.7 2.4-8.5 8.9-6.3 14.6 10.9 29 16.9 60.5 16.9 93.3 0 134.6-100.3 245.7-230.2 262.7V358.4c7.9-1.5 15.5-3.6 23-6.2v104c106.7-25.9 185.9-122.1 185.9-236.8 0-91.8-50.8-171.8-125.8-213.3-5.7-3.2-13-.9-15.9 5-2.7 5.5-.6 12.2 4.7 15.1 67.9 37.6 113.9 110 113.9 193.2 0 93.3-57.9 173.1-139.8 205.4v-92.2c14.2-4.5 24.9-17.7 24.9-33.5 0-13.1-6.8-24.4-17.3-30.5 8.3-79.5 44.5-58.6 44.5-83.9V170c0-38-87.9-161.8-129-164.7-2.5-.2-5-.2-7.6 0C251.1 8.3 163.2 132 163.2 170v14.8c0 25.3 36.3 4.3 44.5 83.9-10.6 6.1-17.3 17.4-17.3 30.5 0 15.8 10.6 29 24.8 33.5v92.2c-81.9-32.2-139.8-112-139.8-205.4 0-83.1 46-155.5 113.9-193.2 5.4-3 7.4-9.6 4.7-15.1-2.9-5.9-10.1-8.2-15.9-5-75 41.5-125.8 121.5-125.8 213.3 0 114.7 79.2 210.8 185.9 236.8v-104c7.6 2.5 15.1 4.6 23 6.2v123.7C131.4 465.2 31 354.1 31 219.5c0-32.8 6-64.3 16.9-93.3 2.2-5.8-.6-12.2-6.3-14.6-6-2.6-13 .4-15.3 6.6C14.5 149.7 8 183.8 8 219.5c0 155.1 122.6 281.6 276.3 287.8V361.4c6.8.4 15 .5 23.4 0v145.8C461.4 501.1 584 374.6 584 219.5c0-35.7-6.5-69.8-18.3-101.4zM365.9 275.5c13 0 23.7 10.5 23.7 23.7 0 13.1-10.6 23.7-23.7 23.7-13 0-23.7-10.5-23.7-23.7 0-13.1 10.6-23.7 23.7-23.7zm-139.8 47.3c-13.2 0-23.7-10.7-23.7-23.7s10.5-23.7 23.7-23.7c13.1 0 23.7 10.6 23.7 23.7 0 13-10.5 23.7-23.7 23.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGitlab(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M105.2 24.9c-3.1-8.9-15.7-8.9-18.9 0L29.8 199.7h132c-.1 0-56.6-174.8-56.6-174.8zM.9 287.7c-2.6 8 .3 16.9 7.1 22l247.9 184-226.2-294zm160.8-88l94.3 294 94.3-294zm349.4 88l-28.8-88-226.3 294 247.9-184c6.9-5.1 9.7-14 7.2-22zM425.7 24.9c-3.1-8.9-15.7-8.9-18.9 0l-56.6 174.8h132z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGitter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M66.4 322.5H16V0h50.4v322.5zM166.9 76.1h-50.4V512h50.4V76.1zm100.6 0h-50.4V512h50.4V76.1zM368 76h-50.4v247H368V76z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGlideG(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M407.1 211.2c-3.5-1.4-11.6-3.8-15.4-3.8-37.1 0-62.2 16.8-93.5 34.5l-.9-.9c7-47.3 23.5-91.9 23.5-140.4C320.8 29.1 282.6 0 212.4 0 97.3 0 39 113.7 39 198.4 39 286.3 90.3 335 177.6 335c12 0 11-1 11 3.8-16.9 128.9-90.8 133.1-90.8 94.6 0-39.2 45-58.6 45.5-61-.3-12.2-47-27.6-58.9-27.6-33.9.1-52.4 51.2-52.4 79.3C32 476 64.8 512 117.5 512c77.4 0 134-77.8 151.4-145.4 15.1-60.5 11.2-63.3 19.7-67.6 32.2-16.2 57.5-27 93.8-27 17.8 0 30.5 3.7 58.9 8.4 2.9 0 6.7-2.9 6.7-5.8 0-8-33.4-60.5-40.9-63.4zm-175.3-84.4c-9.3 44.7-18.6 89.6-27.8 134.3-2.3 10.2-13.3 7.8-22 7.8-38.3 0-49-41.8-49-73.1 0-47 18-109.3 61.8-133.4 7-4.1 14.8-6.7 22.6-6.7 18.6 0 20 13.3 20 28.7-.1 14.3-2.7 28.5-5.6 42.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGlide(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M252.8 148.6c0 8.8-1.6 17.7-3.4 26.4-5.8 27.8-11.6 55.8-17.3 83.6-1.4 6.3-8.3 4.9-13.7 4.9-23.8 0-30.5-26-30.5-45.5 0-29.3 11.2-68.1 38.5-83.1 4.3-2.5 9.2-4.2 14.1-4.2 11.4 0 12.3 8.3 12.3 17.9zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-64 187c0-5.1-20.8-37.7-25.5-39.5-2.2-.9-7.2-2.3-9.6-2.3-23.1 0-38.7 10.5-58.2 21.5l-.5-.5c4.3-29.4 14.6-57.2 14.6-87.4 0-44.6-23.8-62.7-67.5-62.7-71.7 0-108 70.8-108 123.5 0 54.7 32 85 86.3 85 7.5 0 6.9-.6 6.9 2.3-10.5 80.3-56.5 82.9-56.5 58.9 0-24.4 28-36.5 28.3-38-.2-7.6-29.3-17.2-36.7-17.2-21.1 0-32.7 33-32.7 50.6 0 32.3 20.4 54.7 53.3 54.7 48.2 0 83.4-49.7 94.3-91.7 9.4-37.7 7-39.4 12.3-42.1 20-10.1 35.8-16.8 58.4-16.8 11.1 0 19 2.3 36.7 5.2 1.8.1 4.1-1.7 4.1-3.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGofore(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 400 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M324 319.8h-13.2v34.7c-24.5 23.1-56.3 35.8-89.9 35.8-73.2 0-132.4-60.2-132.4-134.4 0-74.1 59.2-134.4 132.4-134.4 35.3 0 68.6 14 93.6 39.4l62.3-63.3C335 55.3 279.7 32 220.7 32 98 32 0 132.6 0 256c0 122.5 97 224 220.7 224 63.2 0 124.5-26.2 171-82.5-2-27.6-13.4-77.7-67.7-77.7zm-12.1-112.5H205.6v89H324c33.5 0 60.5 15.1 76 41.8v-30.6c0-65.2-40.4-100.2-88.1-100.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGoodreadsG(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M42.6 403.3h2.8c12.7 0 25.5 0 38.2.1 1.6 0 3.1-.4 3.6 2.1 7.1 34.9 30 54.6 62.9 63.9 26.9 7.6 54.1 7.8 81.3 1.8 33.8-7.4 56-28.3 68-60.4 8-21.5 10.7-43.8 11-66.5.1-5.8.3-47-.2-52.8l-.9-.3c-.8 1.5-1.7 2.9-2.5 4.4-22.1 43.1-61.3 67.4-105.4 69.1-103 4-169.4-57-172-176.2-.5-23.7 1.8-46.9 8.3-69.7C58.3 47.7 112.3.6 191.6 0c61.3-.4 101.5 38.7 116.2 70.3.5 1.1 1.3 2.3 2.4 1.9V10.6h44.3c0 280.3.1 332.2.1 332.2-.1 78.5-26.7 143.7-103 162.2-69.5 16.9-159 4.8-196-57.2-8-13.5-11.8-28.3-13-44.5zM188.9 36.5c-52.5-.5-108.5 40.7-115 133.8-4.1 59 14.8 122.2 71.5 148.6 27.6 12.9 74.3 15 108.3-8.7 47.6-33.2 62.7-97 54.8-154-9.7-71.1-47.8-120-119.6-119.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGoodreads(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M299.9 191.2c5.1 37.3-4.7 79-35.9 100.7-22.3 15.5-52.8 14.1-70.8 5.7-37.1-17.3-49.5-58.6-46.8-97.2 4.3-60.9 40.9-87.9 75.3-87.5 46.9-.2 71.8 31.8 78.2 78.3zM448 88v336c0 30.9-25.1 56-56 56H56c-30.9 0-56-25.1-56-56V88c0-30.9 25.1-56 56-56h336c30.9 0 56 25.1 56 56zM330 313.2s-.1-34-.1-217.3h-29v40.3c-.8.3-1.2-.5-1.6-1.2-9.6-20.7-35.9-46.3-76-46-51.9.4-87.2 31.2-100.6 77.8-4.3 14.9-5.8 30.1-5.5 45.6 1.7 77.9 45.1 117.8 112.4 115.2 28.9-1.1 54.5-17 69-45.2.5-1 1.1-1.9 1.7-2.9.2.1.4.1.6.2.3 3.8.2 30.7.1 34.5-.2 14.8-2 29.5-7.2 43.5-7.8 21-22.3 34.7-44.5 39.5-17.8 3.9-35.6 3.8-53.2-1.2-21.5-6.1-36.5-19-41.1-41.8-.3-1.6-1.3-1.3-2.3-1.3h-26.8c.8 10.6 3.2 20.3 8.5 29.2 24.2 40.5 82.7 48.5 128.2 37.4 49.9-12.3 67.3-54.9 67.4-106.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGoogleDrive(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M339 314.9L175.4 32h161.2l163.6 282.9H339zm-137.5 23.6L120.9 480h310.5L512 338.5H201.5zM154.1 67.4L0 338.5 80.6 480 237 208.8 154.1 67.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGooglePay(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M105.72,215v41.25h57.1a49.66,49.66,0,0,1-21.14,32.6c-9.54,6.55-21.72,10.28-36,10.28-27.6,0-50.93-18.91-59.3-44.22a65.61,65.61,0,0,1,0-41l0,0c8.37-25.46,31.7-44.37,59.3-44.37a56.43,56.43,0,0,1,40.51,16.08L176.47,155a101.24,101.24,0,0,0-70.75-27.84,105.55,105.55,0,0,0-94.38,59.11,107.64,107.64,0,0,0,0,96.18v.15a105.41,105.41,0,0,0,94.38,59c28.47,0,52.55-9.53,70-25.91,20-18.61,31.41-46.15,31.41-78.91A133.76,133.76,0,0,0,205.38,215Zm389.41-4c-10.13-9.38-23.93-14.14-41.39-14.14-22.46,0-39.34,8.34-50.5,24.86l20.85,13.26q11.45-17,31.26-17a34.05,34.05,0,0,1,22.75,8.79A28.14,28.14,0,0,1,487.79,248v5.51c-9.1-5.07-20.55-7.75-34.64-7.75-16.44,0-29.65,3.88-39.49,11.77s-14.82,18.31-14.82,31.56a39.74,39.74,0,0,0,13.94,31.27c9.25,8.34,21,12.51,34.79,12.51,16.29,0,29.21-7.3,39-21.89h1v17.72h22.61V250C510.25,233.45,505.26,220.34,495.13,211ZM475.9,300.3a37.32,37.32,0,0,1-26.57,11.16A28.61,28.61,0,0,1,431,305.21a19.41,19.41,0,0,1-7.77-15.63c0-7,3.22-12.81,9.54-17.42s14.53-7,24.07-7C470,265,480.3,268,487.64,273.94,487.64,284.07,483.68,292.85,475.9,300.3Zm-93.65-142A55.71,55.71,0,0,0,341.74,142H279.07V328.74H302.7V253.1h39c16,0,29.5-5.36,40.51-15.93.88-.89,1.76-1.79,2.65-2.68A54.45,54.45,0,0,0,382.25,158.26Zm-16.58,62.23a30.65,30.65,0,0,1-23.34,9.68H302.7V165h39.63a32,32,0,0,1,22.6,9.23A33.18,33.18,0,0,1,365.67,220.49ZM614.31,201,577.77,292.7h-.45L539.9,201H514.21L566,320.55l-29.35,64.32H561L640,201Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGooglePlay(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M325.3 234.3L104.6 13l280.8 161.2-60.1 60.1zM47 0C34 6.8 25.3 19.2 25.3 35.3v441.3c0 16.1 8.7 28.5 21.7 35.3l256.6-256L47 0zm425.2 225.6l-58.9-34.1-65.7 64.5 65.7 64.5 60.1-34.1c18-14.3 18-46.5-1.2-60.8zM104.6 499l280.8-161.2-60.1-60.1L104.6 499z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGooglePlusG(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M386.061 228.496c1.834 9.692 3.143 19.384 3.143 31.956C389.204 370.205 315.599 448 204.8 448c-106.084 0-192-85.915-192-192s85.916-192 192-192c51.864 0 95.083 18.859 128.611 50.292l-52.126 50.03c-14.145-13.621-39.028-29.599-76.485-29.599-65.484 0-118.92 54.221-118.92 121.277 0 67.056 53.436 121.277 118.92 121.277 75.961 0 104.513-54.745 108.965-82.773H204.8v-66.009h181.261zm185.406 6.437V179.2h-56.001v55.733h-55.733v56.001h55.733v55.733h56.001v-55.733H627.2v-56.001h-55.733z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGooglePlusSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM164 356c-55.3 0-100-44.7-100-100s44.7-100 100-100c27 0 49.5 9.8 67 26.2l-27.1 26.1c-7.4-7.1-20.3-15.4-39.8-15.4-34.1 0-61.9 28.2-61.9 63.2 0 34.9 27.8 63.2 61.9 63.2 39.6 0 54.4-28.5 56.8-43.1H164v-34.4h94.4c1 5 1.6 10.1 1.6 16.6 0 57.1-38.3 97.6-96 97.6zm220-81.8h-29v29h-29.2v-29h-29V245h29v-29H355v29h29v29.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGooglePlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256,8C119.1,8,8,119.1,8,256S119.1,504,256,504,504,392.9,504,256,392.9,8,256,8ZM185.3,380a124,124,0,0,1,0-248c31.3,0,60.1,11,83,32.3l-33.6,32.6c-13.2-12.9-31.3-19.1-49.4-19.1-42.9,0-77.2,35.5-77.2,78.1S142.3,334,185.3,334c32.6,0,64.9-19.1,70.1-53.3H185.3V238.1H302.2a109.2,109.2,0,0,1,1.9,20.7c0,70.8-47.5,121.2-118.8,121.2ZM415.5,273.8v35.5H380V273.8H344.5V238.3H380V202.8h35.5v35.5h35.2v35.5Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGoogleWallet(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M156.8 126.8c37.6 60.6 64.2 113.1 84.3 162.5-8.3 33.8-18.8 66.5-31.3 98.3-13.2-52.3-26.5-101.3-56-148.5 6.5-36.4 2.3-73.6 3-112.3zM109.3 200H16.1c-6.5 0-10.5 7.5-6.5 12.7C51.8 267 81.3 330.5 101.3 400h103.5c-16.2-69.7-38.7-133.7-82.5-193.5-3-4-8-6.5-13-6.5zm47.8-88c68.5 108 130 234.5 138.2 368H409c-12-138-68.4-265-143.2-368H157.1zm251.8-68.5c-1.8-6.8-8.2-11.5-15.2-11.5h-88.3c-5.3 0-9 5-7.8 10.3 13.2 46.5 22.3 95.5 26.5 146 48.2 86.2 79.7 178.3 90.6 270.8 15.8-60.5 25.3-133.5 25.3-203 0-73.6-12.1-145.1-31.1-212.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGoogle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 488 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488 261.8C488 403.3 391.1 504 248 504 110.8 504 0 393.2 0 256S110.8 8 248 8c66.8 0 123 24.5 166.3 64.9l-67.5 64.9C258.5 52.6 94.3 116.6 94.3 256c0 86.5 69.1 156.6 153.7 156.6 98.2 0 135-70.4 140.8-106.9H248v-85.3h236.1c2.3 12.7 3.9 24.9 3.9 41.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGratipay(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111.1 8 0 119.1 0 256s111.1 248 248 248 248-111.1 248-248S384.9 8 248 8zm114.6 226.4l-113 152.7-112.7-152.7c-8.7-11.9-19.1-50.4 13.6-72 28.1-18.1 54.6-4.2 68.5 11.9 15.9 17.9 46.6 16.9 61.7 0 13.9-16.1 40.4-30 68.1-11.9 32.9 21.6 22.6 60 13.8 72z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGrav(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M301.1 212c4.4 4.4 4.4 11.9 0 16.3l-9.7 9.7c-4.4 4.7-11.9 4.7-16.6 0l-10.5-10.5c-4.4-4.7-4.4-11.9 0-16.6l9.7-9.7c4.4-4.4 11.9-4.4 16.6 0l10.5 10.8zm-30.2-19.7c3-3 3-7.8 0-10.5-2.8-3-7.5-3-10.5 0-2.8 2.8-2.8 7.5 0 10.5 3.1 2.8 7.8 2.8 10.5 0zm-26 5.3c-3 2.8-3 7.5 0 10.2 2.8 3 7.5 3 10.5 0 2.8-2.8 2.8-7.5 0-10.2-3-3-7.7-3-10.5 0zm72.5-13.3c-19.9-14.4-33.8-43.2-11.9-68.1 21.6-24.9 40.7-17.2 59.8.8 11.9 11.3 29.3 24.9 17.2 48.2-12.5 23.5-45.1 33.2-65.1 19.1zm47.7-44.5c-8.9-10-23.3 6.9-15.5 16.1 7.4 9 32.1 2.4 15.5-16.1zM504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-66.2 42.6c2.5-16.1-20.2-16.6-25.2-25.7-13.6-24.1-27.7-36.8-54.5-30.4 11.6-8 23.5-6.1 23.5-6.1.3-6.4 0-13-9.4-24.9 3.9-12.5.3-22.4.3-22.4 15.5-8.6 26.8-24.4 29.1-43.2 3.6-31-18.8-59.2-49.8-62.8-22.1-2.5-43.7 7.7-54.3 25.7-23.2 40.1 1.4 70.9 22.4 81.4-14.4-1.4-34.3-11.9-40.1-34.3-6.6-25.7 2.8-49.8 8.9-61.4 0 0-4.4-5.8-8-8.9 0 0-13.8 0-24.6 5.3 11.9-15.2 25.2-14.4 25.2-14.4 0-6.4-.6-14.9-3.6-21.6-5.4-11-23.8-12.9-31.7 2.8.1-.2.3-.4.4-.5-5 11.9-1.1 55.9 16.9 87.2-2.5 1.4-9.1 6.1-13 10-21.6 9.7-56.2 60.3-56.2 60.3-28.2 10.8-77.2 50.9-70.6 79.7.3 3 1.4 5.5 3 7.5-2.8 2.2-5.5 5-8.3 8.3-11.9 13.8-5.3 35.2 17.7 24.4 15.8-7.2 29.6-20.2 36.3-30.4 0 0-5.5-5-16.3-4.4 27.7-6.6 34.3-9.4 46.2-9.1 8 3.9 8-34.3 8-34.3 0-14.7-2.2-31-11.1-41.5 12.5 12.2 29.1 32.7 28 60.6-.8 18.3-15.2 23-15.2 23-9.1 16.6-43.2 65.9-30.4 106 0 0-9.7-14.9-10.2-22.1-17.4 19.4-46.5 52.3-24.6 64.5 26.6 14.7 108.8-88.6 126.2-142.3 34.6-20.8 55.4-47.3 63.9-65 22 43.5 95.3 94.5 101.1 59z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGripfire(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112.5 301.4c0-73.8 105.1-122.5 105.1-203 0-47.1-34-88-39.1-90.4.4 3.3.6 6.7.6 10C179.1 110.1 32 171.9 32 286.6c0 49.8 32.2 79.2 66.5 108.3 65.1 46.7 78.1 71.4 78.1 86.6 0 10.1-4.8 17-4.8 22.3 13.1-16.7 17.4-31.9 17.5-46.4 0-29.6-21.7-56.3-44.2-86.5-16-22.3-32.6-42.6-32.6-69.5zm205.3-39c-12.1-66.8-78-124.4-94.7-130.9l4 7.2c2.4 5.1 3.4 10.9 3.4 17.1 0 44.7-54.2 111.2-56.6 116.7-2.2 5.1-3.2 10.5-3.2 15.8 0 20.1 15.2 42.1 17.9 42.1 2.4 0 56.6-55.4 58.1-87.7 6.4 11.7 9.1 22.6 9.1 33.4 0 41.2-41.8 96.9-41.8 96.9 0 11.6 31.9 53.2 35.5 53.2 1 0 2.2-1.4 3.2-2.4 37.9-39.3 67.3-85 67.3-136.8 0-8-.7-16.2-2.2-24.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGrunt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M61.3 189.3c-1.1 10 5.2 19.1 5.2 19.1.7-7.5 2.2-12.8 4-16.6.4 10.3 3.2 23.5 12.8 34.1 6.9 7.6 35.6 23.3 54.9 6.1 1 2.4 2.1 5.3 3 8.5 2.9 10.3-2.7 25.3-2.7 25.3s15.1-17.1 13.9-32.5c10.8-.5 21.4-8.4 21.1-19.5 0 0-18.9 10.4-35.5-8.8-9.7-11.2-40.9-42-83.1-31.8 4.3 1 8.9 2.4 13.5 4.1h-.1c-4.2 2-6.5 7.1-7 12zm28.3-1.8c19.5 11 37.4 25.7 44.9 37-5.7 3.3-21.7 10.4-38-1.7-10.3-7.6-9.8-26.2-6.9-35.3zm142.1 45.8c-1.2 15.5 13.9 32.5 13.9 32.5s-5.6-15-2.7-25.3c.9-3.2 2-6 3-8.5 19.3 17.3 48 1.5 54.8-6.1 9.6-10.6 12.3-23.8 12.8-34.1 1.8 3.8 3.4 9.1 4 16.6 0 0 6.4-9.1 5.2-19.1-.6-5-2.9-10-7-11.8h-.1c4.6-1.8 9.2-3.2 13.5-4.1-42.3-10.2-73.4 20.6-83.1 31.8-16.7 19.2-35.5 8.8-35.5 8.8-.2 10.9 10.4 18.9 21.2 19.3zm62.7-45.8c3 9.1 3.4 27.7-7 35.4-16.3 12.1-32.2 5-37.9 1.6 7.5-11.4 25.4-26 44.9-37zM160 418.5h-29.4c-5.5 0-8.2 1.6-9.5 2.9-1.9 2-2.2 4.7-.9 8.1 3.5 9.1 11.4 16.5 13.7 18.6 3.1 2.7 7.5 4.3 11.8 4.3 4.4 0 8.3-1.7 11-4.6 7.5-8.2 11.9-17.1 13-19.8.6-1.5 1.3-4.5-.9-6.8-1.8-1.8-4.7-2.7-8.8-2.7zm189.2-101.2c-2.4 17.9-13 33.8-24.6 43.7-3.1-22.7-3.7-55.5-3.7-62.4 0-14.7 9.5-24.5 12.2-26.1 2.5-1.5 5.4-3 8.3-4.6 18-9.6 40.4-21.6 40.4-43.7 0-16.2-9.3-23.2-15.4-27.8-.8-.6-1.5-1.1-2.2-1.7-2.1-1.7-3.7-3-4.3-4.4-4.4-9.8-3.6-34.2-1.7-37.6.6-.6 16.7-20.9 11.8-39.2-2-7.4-6.9-13.3-14.1-17-5.3-2.7-11.9-4.2-19.5-4.5-.1-2-.5-3.9-.9-5.9-.6-2.6-1.1-5.3-.9-8.1.4-4.7.8-9 2.2-11.3 8.4-13.3 28.8-17.6 29-17.6l12.3-2.4-8.1-9.5c-.1-.2-17.3-17.5-46.3-17.5-7.9 0-16 1.3-24.1 3.9-24.2 7.8-42.9 30.5-49.4 39.3-3.1-1-6.3-1.9-9.6-2.7-4.2-15.8 9-38.5 9-38.5s-13.6-3-33.7 15.2c-2.6-6.5-8.1-20.5-1.8-37.2C184.6 10.1 177.2 26 175 40.4c-7.6-5.4-6.7-23.1-7.2-27.6-7.5.9-29.2 21.9-28.2 48.3-2 .5-3.9 1.1-5.9 1.7-6.5-8.8-25.1-31.5-49.4-39.3-7.9-2.2-16-3.5-23.9-3.5-29 0-46.1 17.3-46.3 17.5L6 46.9l12.3 2.4c.2 0 20.6 4.3 29 17.6 1.4 2.2 1.8 6.6 2.2 11.3.2 2.8-.4 5.5-.9 8.1-.4 1.9-.8 3.9-.9 5.9-7.7.3-14.2 1.8-19.5 4.5-7.2 3.7-12.1 9.6-14.1 17-5 18.2 11.2 38.5 11.8 39.2 1.9 3.4 2.7 27.8-1.7 37.6-.6 1.4-2.2 2.7-4.3 4.4-.7.5-1.4 1.1-2.2 1.7-6.1 4.6-15.4 11.7-15.4 27.8 0 22.1 22.4 34.1 40.4 43.7 3 1.6 5.8 3.1 8.3 4.6 2.7 1.6 12.2 11.4 12.2 26.1 0 6.9-.6 39.7-3.7 62.4-11.6-9.9-22.2-25.9-24.6-43.8 0 0-29.2 22.6-20.6 70.8 5.2 29.5 23.2 46.1 47 54.7 8.8 19.1 29.4 45.7 67.3 49.6C143 504.3 163 512 192.2 512h.2c29.1 0 49.1-7.7 63.6-19.5 37.9-3.9 58.5-30.5 67.3-49.6 23.8-8.7 41.7-25.2 47-54.7 8.2-48.4-21.1-70.9-21.1-70.9zM305.7 37.7c5.6-1.8 11.6-2.7 17.7-2.7 11 0 19.9 3 24.7 5-3.1 1.4-6.4 3.2-9.7 5.3-2.4-.4-5.6-.8-9.2-.8-10.5 0-20.5 3.1-28.7 8.9-12.3 8.7-18 16.9-20.7 22.4-2.2-1.3-4.5-2.5-7.1-3.7-1.6-.8-3.1-1.5-4.7-2.2 6.1-9.1 19.9-26.5 37.7-32.2zm21 18.2c-.8 1-1.6 2.1-2.3 3.2-3.3 5.2-3.9 11.6-4.4 17.8-.5 6.4-1.1 12.5-4.4 17-4.2.8-8.1 1.7-11.5 2.7-2.3-3.1-5.6-7-10.5-11.2 1.4-4.8 5.5-16.1 13.5-22.5 5.6-4.3 12.2-6.7 19.6-7zM45.6 45.3c-3.3-2.2-6.6-4-9.7-5.3 4.8-2 13.7-5 24.7-5 6.1 0 12 .9 17.7 2.7 17.8 5.8 31.6 23.2 37.7 32.1-1.6.7-3.2 1.4-4.8 2.2-2.5 1.2-4.9 2.5-7.1 3.7-2.6-5.4-8.3-13.7-20.7-22.4-8.3-5.8-18.2-8.9-28.8-8.9-3.4.1-6.6.5-9 .9zm44.7 40.1c-4.9 4.2-8.3 8-10.5 11.2-3.4-.9-7.3-1.9-11.5-2.7C65 89.5 64.5 83.4 64 77c-.5-6.2-1.1-12.6-4.4-17.8-.7-1.1-1.5-2.2-2.3-3.2 7.4.3 14 2.6 19.5 7 8 6.3 12.1 17.6 13.5 22.4zM58.1 259.9c-2.7-1.6-5.6-3.1-8.4-4.6-14.9-8-30.2-16.3-30.2-30.5 0-11.1 4.3-14.6 8.9-18.2l.5-.4c.7-.6 1.4-1.2 2.2-1.8-.9 7.2-1.9 13.3-2.7 14.9 0 0 12.1-15 15.7-44.3 1.4-11.5-1.1-34.3-5.1-43 .2 4.9 0 9.8-.3 14.4-.4-.8-.8-1.6-1.3-2.2-3.2-4-11.8-17.5-9.4-26.6.9-3.5 3.1-6 6.7-7.8 3.8-1.9 8.8-2.9 15.1-2.9 12.3 0 25.9 3.7 32.9 6 25.1 8 55.4 30.9 64.1 37.7.2.2.4.3.4.3l5.6 3.9-3.5-5.8c-.2-.3-19.1-31.4-53.2-46.5 2-2.9 7.4-8.1 21.6-15.1 21.4-10.5 46.5-15.8 74.3-15.8 27.9 0 52.9 5.3 74.3 15.8 14.2 6.9 19.6 12.2 21.6 15.1-34 15.1-52.9 46.2-53.1 46.5l-3.5 5.8 5.6-3.9s.2-.1.4-.3c8.7-6.8 39-29.8 64.1-37.7 7-2.2 20.6-6 32.9-6 6.3 0 11.3 1 15.1 2.9 3.5 1.8 5.7 4.4 6.7 7.8 2.5 9.1-6.1 22.6-9.4 26.6-.5.6-.9 1.3-1.3 2.2-.3-4.6-.5-9.5-.3-14.4-4 8.8-6.5 31.5-5.1 43 3.6 29.3 15.7 44.3 15.7 44.3-.8-1.6-1.8-7.7-2.7-14.9.7.6 1.5 1.2 2.2 1.8l.5.4c4.6 3.7 8.9 7.1 8.9 18.2 0 14.2-15.4 22.5-30.2 30.5-2.9 1.5-5.7 3.1-8.4 4.6-8.7 5-18 16.7-19.1 34.2-.9 14.6.9 49.9 3.4 75.9-12.4 4.8-26.7 6.4-39.7 6.8-2-4.1-3.9-8.5-5.5-13.1-.7-2-19.6-51.1-26.4-62.2 5.5 39 17.5 73.7 23.5 89.6-3.5-.5-7.3-.7-11.7-.7h-117c-4.4 0-8.3.3-11.7.7 6-15.9 18.1-50.6 23.5-89.6-6.8 11.2-25.7 60.3-26.4 62.2-1.6 4.6-3.5 9-5.5 13.1-13-.4-27.2-2-39.7-6.8 2.5-26 4.3-61.2 3.4-75.9-.9-17.4-10.3-29.2-19-34.2zM34.8 404.6c-12.1-20-8.7-54.1-3.7-59.1 10.9 34.4 47.2 44.3 74.4 45.4-2.7 4.2-5.2 7.6-7 10l-1.4 1.4c-7.2 7.8-8.6 18.5-4.1 31.8-22.7-.1-46.3-9.8-58.2-29.5zm45.7 43.5c6 1.1 12.2 1.9 18.6 2.4 3.5 8 7.4 15.9 12.3 23.1-14.4-5.9-24.4-16-30.9-25.5zM192 498.2c-60.6-.1-78.3-45.8-84.9-64.7-3.7-10.5-3.4-18.2.9-23.1 2.9-3.3 9.5-7.2 24.6-7.2h118.8c15.1 0 21.8 3.9 24.6 7.2 4.2 4.8 4.5 12.6.9 23.1-6.6 18.8-24.3 64.6-84.9 64.7zm80.6-24.6c4.9-7.2 8.8-15.1 12.3-23.1 6.4-.5 12.6-1.3 18.6-2.4-6.5 9.5-16.5 19.6-30.9 25.5zm76.6-69c-12 19.7-35.6 29.3-58.1 29.7 4.5-13.3 3.1-24.1-4.1-31.8-.4-.5-.9-1-1.4-1.5-1.8-2.4-4.3-5.8-7-10 27.2-1.2 63.5-11 74.4-45.4 5 5 8.4 39.1-3.8 59zM191.9 187.7h.2c12.7-.1 27.2-17.8 27.2-17.8-9.9 6-18.8 8.1-27.3 8.3-8.5-.2-17.4-2.3-27.3-8.3 0 0 14.5 17.6 27.2 17.8zm61.7 230.7h-29.4c-4.2 0-7.2.9-8.9 2.7-2.2 2.3-1.5 5.2-.9 6.7 1 2.6 5.5 11.3 13 19.3 2.7 2.9 6.6 4.5 11 4.5s8.7-1.6 11.8-4.2c2.3-2 10.2-9.2 13.7-18.1 1.3-3.3 1-6-.9-7.9-1.3-1.3-4-2.9-9.4-3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGuilded(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M443.427,64H4.571c0,103.26,22.192,180.06,43.418,222.358C112.046,414.135,224,448,225.256,448a312.824,312.824,0,0,0,140.55-103.477c25.907-33.923,53.1-87.19,65.916-145.761H171.833c4.14,36.429,22.177,67.946,45.1,86.944h88.589c-17.012,28.213-48.186,54.4-80.456,69.482-31.232-13.259-69.09-46.544-96.548-98.362-26.726-53.833-27.092-105.883-27.092-105.883H437.573A625.91,625.91,0,0,0,443.427,64Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGulp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M209.8 391.1l-14.1 24.6-4.6 80.2c0 8.9-28.3 16.1-63.1 16.1s-63.1-7.2-63.1-16.1l-5.8-79.4-14.9-25.4c41.2 17.3 126 16.7 165.6 0zm-196-253.3l13.6 125.5c5.9-20 20.8-47 40-55.2 6.3-2.7 12.7-2.7 18.7.9 5.2 3 9.6 9.3 10.1 11.8 1.2 6.5-2 9.1-4.5 9.1-3 0-5.3-4.6-6.8-7.3-4.1-7.3-10.3-7.6-16.9-2.8-6.9 5-12.9 13.4-17.1 20.7-5.1 8.8-9.4 18.5-12 28.2-1.5 5.6-2.9 14.6-.6 19.9 1 2.2 2.5 3.6 4.9 3.6 5 0 12.3-6.6 15.8-10.1 4.5-4.5 10.3-11.5 12.5-16l5.2-15.5c2.6-6.8 9.9-5.6 9.9 0 0 10.2-3.7 13.6-10 34.7-5.8 19.5-7.6 25.8-7.6 25.8-.7 2.8-3.4 7.5-6.3 7.5-1.2 0-2.1-.4-2.6-1.2-1-1.4-.9-5.3-.8-6.3.2-3.2 6.3-22.2 7.3-25.2-2 2.2-4.1 4.4-6.4 6.6-5.4 5.1-14.1 11.8-21.5 11.8-3.4 0-5.6-.9-7.7-2.4l7.6 79.6c2 5 39.2 17.1 88.2 17.1 49.1 0 86.3-12.2 88.2-17.1l10.9-94.6c-5.7 5.2-12.3 11.6-19.6 14.8-5.4 2.3-17.4 3.8-17.4-5.7 0-5.2 9.1-14.8 14.4-21.5 1.4-1.7 4.7-5.9 4.7-8.1 0-2.9-6-2.2-11.7 2.5-3.2 2.7-6.2 6.3-8.7 9.7-4.3 6-6.6 11.2-8.5 15.5-6.2 14.2-4.1 8.6-9.1 22-5 13.3-4.2 11.8-5.2 14-.9 1.9-2.2 3.5-4 4.5-1.9 1-4.5.9-6.1-.3-.9-.6-1.3-1.9-1.3-3.7 0-.9.1-1.8.3-2.7 1.5-6.1 7.8-18.1 15-34.3 1.6-3.7 1-2.6.8-2.3-6.2 6-10.9 8.9-14.4 10.5-5.8 2.6-13 2.6-14.5-4.1-.1-.4-.1-.8-.2-1.2-11.8 9.2-24.3 11.7-20-8.1-4.6 8.2-12.6 14.9-22.4 14.9-4.1 0-7.1-1.4-8.6-5.1-2.3-5.5 1.3-14.9 4.6-23.8 1.7-4.5 4-9.9 7.1-16.2 1.6-3.4 4.2-5.4 7.6-4.5.6.2 1.1.4 1.6.7 2.6 1.8 1.6 4.5.3 7.2-3.8 7.5-7.1 13-9.3 20.8-.9 3.3-2 9 1.5 9 2.4 0 4.7-.8 6.9-2.4 4.6-3.4 8.3-8.5 11.1-13.5 2-3.6 4.4-8.3 5.6-12.3.5-1.7 1.1-3.3 1.8-4.8 1.1-2.5 2.6-5.1 5.2-5.1 1.3 0 2.4.5 3.2 1.5 1.7 2.2 1.3 4.5.4 6.9-2 5.6-4.7 10.6-6.9 16.7-1.3 3.5-2.7 8-2.7 11.7 0 3.4 3.7 2.6 6.8 1.2 2.4-1.1 4.8-2.8 6.8-4.5 1.2-4.9.9-3.8 26.4-68.2 1.3-3.3 3.7-4.7 6.1-4.7 1.2 0 2.2.4 3.2 1.1 1.7 1.3 1.7 4.1 1 6.2-.7 1.9-.6 1.3-4.5 10.5-5.2 12.1-8.6 20.8-13.2 31.9-1.9 4.6-7.7 18.9-8.7 22.3-.6 2.2-1.3 5.8 1 5.8 5.4 0 19.3-13.1 23.1-17 .2-.3.5-.4.9-.6.6-1.9 1.2-3.7 1.7-5.5 1.4-3.8 2.7-8.2 5.3-11.3.8-1 1.7-1.6 2.7-1.6 2.8 0 4.2 1.2 4.2 4 0 1.1-.7 5.1-1.1 6.2 1.4-1.5 2.9-3 4.5-4.5 15-13.9 25.7-6.8 25.7.2 0 7.4-8.9 17.7-13.8 23.4-1.6 1.9-4.9 5.4-5 6.4 0 1.3.9 1.8 2.2 1.8 2 0 6.4-3.5 8-4.7 5-3.9 11.8-9.9 16.6-14.1l14.8-136.8c-30.5 17.1-197.6 17.2-228.3.2zm229.7-8.5c0 21-231.2 21-231.2 0 0-8.8 51.8-15.9 115.6-15.9 9 0 17.8.1 26.3.4l12.6-48.7L228.1.6c1.4-1.4 5.8-.2 9.9 3.5s6.6 7.9 5.3 9.3l-.1.1L185.9 74l-10 40.7c39.9 2.6 67.6 8.1 67.6 14.6zm-69.4 4.6c0-.8-.9-1.5-2.5-2.1l-.2.8c0 1.3-5 2.4-11.1 2.4s-11.1-1.1-11.1-2.4c0-.1 0-.2.1-.3l.2-.7c-1.8.6-3 1.4-3 2.3 0 2.1 6.2 3.7 13.7 3.7 7.7.1 13.9-1.6 13.9-3.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHackerNewsSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM21.2 229.2H21c.1-.1.2-.3.3-.4 0 .1 0 .3-.1.4zm218 53.9V384h-31.4V281.3L128 128h37.3c52.5 98.3 49.2 101.2 59.3 125.6 12.3-27 5.8-24.4 60.6-125.6H320l-80.8 155.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHackerNews(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32v448h448V32H0zm21.2 197.2H21c.1-.1.2-.3.3-.4 0 .1 0 .3-.1.4zm218 53.9V384h-31.4V281.3L128 128h37.3c52.5 98.3 49.2 101.2 59.3 125.6 12.3-27 5.8-24.4 60.6-125.6H320l-80.8 155.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHackerrank(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M477.5 128C463 103.05 285.13 0 256.16 0S49.25 102.79 34.84 128s-14.49 230.8 0 256 192.38 128 221.32 128S463 409.08 477.49 384s14.51-231 .01-256zM316.13 414.22c-4 0-40.91-35.77-38-38.69.87-.87 6.26-1.48 17.55-1.83 0-26.23.59-68.59.94-86.32 0-2-.44-3.43-.44-5.85h-79.93c0 7.1-.46 36.2 1.37 72.88.23 4.54-1.58 6-5.74 5.94-10.13 0-20.27-.11-30.41-.08-4.1 0-5.87-1.53-5.74-6.11.92-33.44 3-84-.15-212.67v-3.17c-9.67-.35-16.38-1-17.26-1.84-2.92-2.92 34.54-38.69 38.49-38.69s41.17 35.78 38.27 38.69c-.87.87-7.9 1.49-16.77 1.84v3.16c-2.42 25.75-2 79.59-2.63 105.39h80.26c0-4.55.39-34.74-1.2-83.64-.1-3.39.95-5.17 4.21-5.2 11.07-.08 22.15-.13 33.23-.06 3.46 0 4.57 1.72 4.5 5.38C333 354.64 336 341.29 336 373.69c8.87.35 16.82 1 17.69 1.84 2.88 2.91-33.62 38.69-37.58 38.69z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHips(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M251.6 157.6c0-1.9-.9-2.8-2.8-2.8h-40.9c-1.6 0-2.7 1.4-2.7 2.8v201.8c0 1.4 1.1 2.8 2.7 2.8h40.9c1.9 0 2.8-.9 2.8-2.8zM156.5 168c-16.1-11.8-36.3-17.9-60.3-18-18.1-.1-34.6 3.7-49.8 11.4V80.2c0-1.8-.9-2.7-2.8-2.7H2.7c-1.8 0-2.7.9-2.7 2.7v279.2c0 1.9.9 2.8 2.7 2.8h41c1.9 0 2.8-.9 2.8-2.8V223.3c0-.8-2.8-27 45.8-27 48.5 0 45.8 26.1 45.8 27v122.6c0 9 7.3 16.3 16.4 16.3h27.3c1.8 0 2.7-.9 2.7-2.8V223.3c0-23.4-9.3-41.8-28-55.3zm478.4 110.1c-6.8-15.7-18.4-27-34.9-34.1l-57.6-25.3c-8.6-3.6-9.2-11.2-2.6-16.1 7.4-5.5 44.3-13.9 84 6.8 1.7 1 4-.3 4-2.4v-44.7c0-1.3-.6-2.1-1.9-2.6-17.7-6.6-36.1-9.9-55.1-9.9-26.5 0-45.3 5.8-58.5 15.4-.5.4-28.4 20-22.7 53.7 3.4 19.6 15.8 34.2 37.2 43.6l53.6 23.5c11.6 5.1 15.2 13.3 12.2 21.2-3.7 9.1-13.2 13.6-36.5 13.6-24.3 0-44.7-8.9-58.4-19.1-2.1-1.4-4.4.2-4.4 2.3v34.4c0 10.4 4.9 17.3 14.6 20.7 15.6 5.5 31.6 8.2 48.2 8.2 12.7 0 25.8-1.2 36.3-4.3.7-.3 36-8.9 45.6-45.8 3.5-13.5 2.4-26.5-3.1-39.1zM376.2 149.8c-31.7 0-104.2 20.1-104.2 103.5v183.5c0 .8.6 2.7 2.7 2.7h40.9c1.9 0 2.8-.9 2.8-2.7V348c16.5 12.7 35.8 19.1 57.7 19.1 60.5 0 108.7-48.5 108.7-108.7.1-60.3-48.2-108.6-108.6-108.6zm0 170.9c-17.2 0-31.9-6.1-44-18.2-12.2-12.2-18.2-26.8-18.2-44 0-34.5 27.6-62.2 62.2-62.2 34.5 0 62.2 27.6 62.2 62.2.1 34.3-27.3 62.2-62.2 62.2zM228.3 72.5c-15.9 0-28.8 12.9-28.9 28.9 0 15.6 12.7 28.9 28.9 28.9s28.9-13.1 28.9-28.9c0-16.2-13-28.9-28.9-28.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHireAHelper(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M443.1 0H71.9C67.9 37.3 37.4 67.8 0 71.7v371.5c37.4 4.9 66 32.4 71.9 68.8h372.2c3-36.4 32.5-65.8 67.9-69.8V71.7c-36.4-5.9-65-35.3-68.9-71.7zm-37 404.9c-36.3 0-18.8-2-55.1-2-35.8 0-21 2-56.1 2-5.9 0-4.9-8.2 0-9.8 22.8-7.6 22.9-10.2 24.6-12.8 10.4-15.6 5.9-83 5.9-113 0-5.3-6.4-12.8-13.8-12.8H200.4c-7.4 0-13.8 7.5-13.8 12.8 0 30-4.5 97.4 5.9 113 1.7 2.5 1.8 5.2 24.6 12.8 4.9 1.6 6 9.8 0 9.8-35.1 0-20.3-2-56.1-2-36.3 0-18.8 2-55.1 2-7.9 0-5.8-10.8 0-10.8 10.2-3.4 13.5-3.5 21.7-13.8 7.7-12.9 7.9-44.4 7.9-127.8V151.3c0-22.2-12.2-28.3-28.6-32.4-8.8-2.2-4-11.8 1-11.8 36.5 0 20.6 2 57.1 2 32.7 0 16.5-2 49.2-2 3.3 0 8.5 8.3 1 10.8-4.9 1.6-27.6 3.7-27.6 39.3 0 45.6-.2 55.8 1 68.8 0 1.3 2.3 12.8 12.8 12.8h109.2c10.5 0 12.8-11.5 12.8-12.8 1.2-13 1-23.2 1-68.8 0-35.6-22.7-37.7-27.6-39.3-7.5-2.5-2.3-10.8 1-10.8 32.7 0 16.5 2 49.2 2 36.5 0 20.6-2 57.1-2 4.9 0 9.9 9.6 1 11.8-16.4 4.1-28.6 10.3-28.6 32.4v101.2c0 83.4.1 114.9 7.9 127.8 8.2 10.2 11.4 10.4 21.7 13.8 5.8 0 7.8 10.8 0 10.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHive(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M260.353,254.878,131.538,33.1a2.208,2.208,0,0,0-3.829.009L.3,254.887A2.234,2.234,0,0,0,.3,257.122L129.116,478.9a2.208,2.208,0,0,0,3.83-.009L260.358,257.113A2.239,2.239,0,0,0,260.353,254.878Zm39.078-25.713a2.19,2.19,0,0,0,1.9,1.111h66.509a2.226,2.226,0,0,0,1.9-3.341L259.115,33.111a2.187,2.187,0,0,0-1.9-1.111H190.707a2.226,2.226,0,0,0-1.9,3.341ZM511.7,254.886,384.9,33.112A2.2,2.2,0,0,0,382.99,32h-66.6a2.226,2.226,0,0,0-1.906,3.34L440.652,256,314.481,476.66a2.226,2.226,0,0,0,1.906,3.34h66.6a2.2,2.2,0,0,0,1.906-1.112L511.7,257.114A2.243,2.243,0,0,0,511.7,254.886ZM366.016,284.917H299.508a2.187,2.187,0,0,0-1.9,1.111l-108.8,190.631a2.226,2.226,0,0,0,1.9,3.341h66.509a2.187,2.187,0,0,0,1.9-1.111l108.8-190.631A2.226,2.226,0,0,0,366.016,284.917Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHooli(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144.5 352l38.3.8c-13.2-4.6-26-10.2-38.3-16.8zm57.7-5.3v5.3l-19.4.8c36.5 12.5 69.9 14.2 94.7 7.2-19.9.2-45.8-2.6-75.3-13.3zm408.9-115.2c15.9 0 28.9-12.9 28.9-28.9s-12.9-24.5-28.9-24.5c-15.9 0-28.9 8.6-28.9 24.5s12.9 28.9 28.9 28.9zm-29 120.5H640V241.5h-57.9zm-73.7 0h57.9V156.7L508.4 184zm-31-119.4c-18.2-18.2-50.4-17.1-50.4-17.1s-32.3-1.1-50.4 17.1c-18.2 18.2-16.8 33.9-16.8 52.6s-1.4 34.3 16.8 52.5 50.4 17.1 50.4 17.1 32.3 1.1 50.4-17.1c18.2-18.2 16.8-33.8 16.8-52.5-.1-18.8 1.3-34.5-16.8-52.6zm-39.8 71.9c0 3.6-1.8 12.5-10.7 12.5s-10.7-8.9-10.7-12.5v-40.4c0-8.7 7.3-10.9 10.7-10.9s10.7 2.1 10.7 10.9zm-106.2-71.9c-18.2-18.2-50.4-17.1-50.4-17.1s-32.2-1.1-50.4 17.1c-1.9 1.9-3.7 3.9-5.3 6-38.2-29.6-72.5-46.5-102.1-61.1v-20.7l-22.5 10.6c-54.4-22.1-89-18.2-97.3.1 0 0-24.9 32.8 61.8 110.8V352h57.9v-28.6c-6.5-4.2-13-8.7-19.4-13.6-14.8-11.2-27.4-21.6-38.4-31.4v-31c13.1 14.7 30.5 31.4 53.4 50.3l4.5 3.6v-29.8c0-6.9 1.7-18.2 10.8-18.2s10.6 6.9 10.6 15V317c18 12.2 37.3 22.1 57.7 29.6v-93.9c0-18.7-13.4-37.4-40.6-37.4-15.8-.1-30.5 8.2-38.5 21.9v-54.3c41.9 20.9 83.9 46.5 99.9 58.3-10.2 14.6-9.3 28.1-9.3 43.7 0 18.7-1.4 34.3 16.8 52.5s50.4 17.1 50.4 17.1 32.3 1.1 50.4-17.1c18.2-18.2 16.7-33.8 16.7-52.5 0-18.5 1.5-34.2-16.7-52.3zM65.2 184v63.3c-48.7-54.5-38.9-76-35.2-79.1 13.5-11.4 37.5-8 64.4 2.1zm226.5 120.5c0 3.6-1.8 12.5-10.7 12.5s-10.7-8.9-10.7-12.5v-40.4c0-8.7 7.3-10.9 10.7-10.9s10.7 2.1 10.7 10.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHornbill(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M76.38 370.3a37.8 37.8 0 1 1-32.07-32.42c-78.28-111.35 52-190.53 52-190.53-5.86 43-8.24 91.16-8.24 91.16-67.31 41.49.93 64.06 39.81 72.87a140.38 140.38 0 0 0 131.66 91.94c1.92 0 3.77-.21 5.67-.28l.11 18.86c-99.22 1.39-158.7-29.14-188.94-51.6zm108-327.7A37.57 37.57 0 0 0 181 21.45a37.95 37.95 0 1 0-31.17 54.22c-22.55 29.91-53.83 89.57-52.42 190l21.84-.15c0-.9-.14-1.77-.14-2.68A140.42 140.42 0 0 1 207 132.71c8-37.71 30.7-114.3 73.8-44.29 0 0 48.14 2.38 91.18 8.24 0 0-77.84-128-187.59-54.06zm304.19 134.17a37.94 37.94 0 1 0-53.84-28.7C403 126.13 344.89 99 251.28 100.33l.14 22.5c2.7-.15 5.39-.41 8.14-.41a140.37 140.37 0 0 1 130.49 88.76c39.1 9 105.06 31.58 38.46 72.54 0 0-2.34 48.13-8.21 91.16 0 0 133.45-81.16 49-194.61a37.45 37.45 0 0 0 19.31-3.5zM374.06 436.24c21.43-32.46 46.42-89.69 45.14-179.66l-19.52.14c.08 2.06.3 4.07.3 6.15a140.34 140.34 0 0 1-91.39 131.45c-8.85 38.95-31.44 106.66-72.77 39.49 0 0-48.12-2.34-91.19-8.22 0 0 79.92 131.34 191.9 51a37.5 37.5 0 0 0 3.64 14 37.93 37.93 0 1 0 33.89-54.29z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHotjar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M414.9 161.5C340.2 29 121.1 0 121.1 0S222.2 110.4 93 197.7C11.3 252.8-21 324.4 14 402.6c26.8 59.9 83.5 84.3 144.6 93.4-29.2-55.1-6.6-122.4-4.1-129.6 57.1 86.4 165 0 110.8-93.9 71 15.4 81.6 138.6 27.1 215.5 80.5-25.3 134.1-88.9 148.8-145.6 15.5-59.3 3.7-127.9-26.3-180.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHouzz(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M275.9 330.7H171.3V480H17V32h109.5v104.5l305.1 85.6V480H275.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHtml5(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32l34.9 395.8L191.5 480l157.6-52.2L384 32H0zm308.2 127.9H124.4l4.1 49.4h175.6l-13.6 148.4-97.9 27v.3h-1.1l-98.7-27.3-6-75.8h47.7L138 320l53.5 14.5 53.7-14.5 6-62.2H84.3L71.5 112.2h241.1l-4.4 47.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHubspot(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M267.4 211.6c-25.1 23.7-40.8 57.3-40.8 94.6 0 29.3 9.7 56.3 26 78L203.1 434c-4.4-1.6-9.1-2.5-14-2.5-10.8 0-20.9 4.2-28.5 11.8-7.6 7.6-11.8 17.8-11.8 28.6s4.2 20.9 11.8 28.5c7.6 7.6 17.8 11.6 28.5 11.6 10.8 0 20.9-3.9 28.6-11.6 7.6-7.6 11.8-17.8 11.8-28.5 0-4.2-.6-8.2-1.9-12.1l50-50.2c22 16.9 49.4 26.9 79.3 26.9 71.9 0 130-58.3 130-130.2 0-65.2-47.7-119.2-110.2-128.7V116c17.5-7.4 28.2-23.8 28.2-42.9 0-26.1-20.9-47.9-47-47.9S311.2 47 311.2 73.1c0 19.1 10.7 35.5 28.2 42.9v61.2c-15.2 2.1-29.6 6.7-42.7 13.6-27.6-20.9-117.5-85.7-168.9-124.8 1.2-4.4 2-9 2-13.8C129.8 23.4 106.3 0 77.4 0 48.6 0 25.2 23.4 25.2 52.2c0 28.9 23.4 52.3 52.2 52.3 9.8 0 18.9-2.9 26.8-7.6l163.2 114.7zm89.5 163.6c-38.1 0-69-30.9-69-69s30.9-69 69-69 69 30.9 69 69-30.9 69-69 69z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaIdeal(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M125.61,165.48a49.07,49.07,0,1,0,49.06,49.06A49.08,49.08,0,0,0,125.61,165.48ZM86.15,425.84h78.94V285.32H86.15Zm151.46-211.6c0-20-10-22.53-18.74-22.53H204.82V237.5h14.05C228.62,237.5,237.61,234.69,237.61,214.24Zm201.69,46V168.93h22.75V237.5h33.69C486.5,113.08,388.61,86.19,299.67,86.19H204.84V169h14c25.6,0,41.5,17.35,41.5,45.26,0,28.81-15.52,46-41.5,46h-14V425.88h94.83c144.61,0,194.94-67.16,196.72-165.64Zm-109.75,0H273.3V169h54.43v22.73H296v10.58h30V225H296V237.5h33.51Zm74.66,0-5.16-17.67H369.31l-5.18,17.67H340.47L368,168.92h32.35l27.53,91.34ZM299.65,32H32V480H299.65c161.85,0,251-79.73,251-224.52C550.62,172,518,32,299.65,32Zm0,426.92H53.07V53.07H299.65c142.1,0,229.9,64.61,229.9,202.41C529.55,389.57,448.55,458.92,299.65,458.92Zm83.86-264.85L376,219.88H392.4l-7.52-25.81Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaImdb(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM21.3 229.2H21c.1-.1.2-.3.3-.4zM97 319.8H64V192h33zm113.2 0h-28.7v-86.4l-11.6 86.4h-20.6l-12.2-84.5v84.5h-29V192h42.8c3.3 19.8 6 39.9 8.7 59.9l7.6-59.9h43zm11.4 0V192h24.6c17.6 0 44.7-1.6 49 20.9 1.7 7.6 1.4 16.3 1.4 24.4 0 88.5 11.1 82.6-75 82.5zm160.9-29.2c0 15.7-2.4 30.9-22.2 30.9-9 0-15.2-3-20.9-9.8l-1.9 8.1h-29.8V192h31.7v41.7c6-6.5 12-9.2 20.9-9.2 21.4 0 22.2 12.8 22.2 30.1zM265 229.9c0-9.7 1.6-16-10.3-16v83.7c12.2.3 10.3-8.7 10.3-18.4zm85.5 26.1c0-5.4 1.1-12.7-6.2-12.7-6 0-4.9 8.9-4.9 12.7 0 .6-1.1 39.6 1.1 44.7.8 1.6 2.2 2.4 3.8 2.4 7.8 0 6.2-9 6.2-14.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaInnosoft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M422.559,159.71a27.379,27.379,0,0,0-13.866-23.337,26.42,26.42,0,0,0-26.211.133L73.943,314.647V176.261a11.955,11.955,0,0,1,6.047-10.34L218.066,86.208a12.153,12.153,0,0,1,11.922.025l32.656,18.853L112.581,191.723v56L359.642,105.086,241.129,36.679c-10.992-6.129-22.3-6.255-33.8-.27l-164.6,95.026c-10.634,6.12-16.771,16.39-17.29,29.124l0,191.5c.17,10.135,5.08,18.672,13.474,23.428a27.037,27.037,0,0,0,26.736-.045L374.057,197.376V335.657a11.976,11.976,0,0,1-5.92,10.368L230.025,425.77a12.175,12.175,0,0,1-11.937.062l-32.723-18.9,150.051-86.627v-56L88.367,406.932l118.794,68.583a33.88,33.88,0,0,0,34.25-.327l164.527-94.995c10.746-6.631,16.649-17.118,16.624-29.528Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaInstagramSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224,202.66A53.34,53.34,0,1,0,277.36,256,53.38,53.38,0,0,0,224,202.66Zm124.71-41a54,54,0,0,0-30.41-30.41c-21-8.29-71-6.43-94.3-6.43s-73.25-1.93-94.31,6.43a54,54,0,0,0-30.41,30.41c-8.28,21-6.43,71.05-6.43,94.33S91,329.26,99.32,350.33a54,54,0,0,0,30.41,30.41c21,8.29,71,6.43,94.31,6.43s73.24,1.93,94.3-6.43a54,54,0,0,0,30.41-30.41c8.35-21,6.43-71.05,6.43-94.33S357.1,182.74,348.75,161.67ZM224,338a82,82,0,1,1,82-82A81.9,81.9,0,0,1,224,338Zm85.38-148.3a19.14,19.14,0,1,1,19.13-19.14A19.1,19.1,0,0,1,309.42,189.74ZM400,32H48A48,48,0,0,0,0,80V432a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V80A48,48,0,0,0,400,32ZM382.88,322c-1.29,25.63-7.14,48.34-25.85,67s-41.4,24.63-67,25.85c-26.41,1.49-105.59,1.49-132,0-25.63-1.29-48.26-7.15-67-25.85s-24.63-41.42-25.85-67c-1.49-26.42-1.49-105.61,0-132,1.29-25.63,7.07-48.34,25.85-67s41.47-24.56,67-25.78c26.41-1.49,105.59-1.49,132,0,25.63,1.29,48.33,7.15,67,25.85s24.63,41.42,25.85,67.05C384.37,216.44,384.37,295.56,382.88,322Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaInstagram(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaInstalod(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M153.384,480H387.113L502.554,275.765,204.229,333.211ZM504.726,240.078,387.113,32H155.669L360.23,267.9ZM124.386,48.809,7.274,256,123.236,461.154,225.627,165.561Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaIntercom(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M392 32H56C25.1 32 0 57.1 0 88v336c0 30.9 25.1 56 56 56h336c30.9 0 56-25.1 56-56V88c0-30.9-25.1-56-56-56zm-108.3 82.1c0-19.8 29.9-19.8 29.9 0v199.5c0 19.8-29.9 19.8-29.9 0V114.1zm-74.6-7.5c0-19.8 29.9-19.8 29.9 0v216.5c0 19.8-29.9 19.8-29.9 0V106.6zm-74.7 7.5c0-19.8 29.9-19.8 29.9 0v199.5c0 19.8-29.9 19.8-29.9 0V114.1zM59.7 144c0-19.8 29.9-19.8 29.9 0v134.3c0 19.8-29.9 19.8-29.9 0V144zm323.4 227.8c-72.8 63-241.7 65.4-318.1 0-15-12.8 4.4-35.5 19.4-22.7 65.9 55.3 216.1 53.9 279.3 0 14.9-12.9 34.3 9.8 19.4 22.7zm5.2-93.5c0 19.8-29.9 19.8-29.9 0V144c0-19.8 29.9-19.8 29.9 0v134.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaInternetExplorer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M483.049 159.706c10.855-24.575 21.424-60.438 21.424-87.871 0-72.722-79.641-98.371-209.673-38.577-107.632-7.181-211.221 73.67-237.098 186.457 30.852-34.862 78.271-82.298 121.977-101.158C125.404 166.85 79.128 228.002 43.992 291.725 23.246 329.651 0 390.94 0 436.747c0 98.575 92.854 86.5 180.251 42.006 31.423 15.43 66.559 15.573 101.695 15.573 97.124 0 184.249-54.294 216.814-146.022H377.927c-52.509 88.593-196.819 52.996-196.819-47.436H509.9c6.407-43.581-1.655-95.715-26.851-141.162zM64.559 346.877c17.711 51.15 53.703 95.871 100.266 123.304-88.741 48.94-173.267 29.096-100.266-123.304zm115.977-108.873c2-55.151 50.276-94.871 103.98-94.871 53.418 0 101.981 39.72 103.981 94.871H180.536zm184.536-187.6c21.425-10.287 48.563-22.003 72.558-22.003 31.422 0 54.274 21.717 54.274 53.722 0 20.003-7.427 49.007-14.569 67.867-26.28-42.292-65.986-81.584-112.263-99.586z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaInvision(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M407.4 32H40.6C18.2 32 0 50.2 0 72.6v366.8C0 461.8 18.2 480 40.6 480h366.8c22.4 0 40.6-18.2 40.6-40.6V72.6c0-22.4-18.2-40.6-40.6-40.6zM176.1 145.6c.4 23.4-22.4 27.3-26.6 27.4-14.9 0-27.1-12-27.1-27 .1-35.2 53.1-35.5 53.7-.4zM332.8 377c-65.6 0-34.1-74-25-106.6 14.1-46.4-45.2-59-59.9.7l-25.8 103.3H177l8.1-32.5c-31.5 51.8-94.6 44.4-94.6-4.3.1-14.3.9-14 23-104.1H81.7l9.7-35.6h76.4c-33.6 133.7-32.6 126.9-32.9 138.2 0 20.9 40.9 13.5 57.4-23.2l19.8-79.4h-32.3l9.7-35.6h68.8l-8.9 40.5c40.5-75.5 127.9-47.8 101.8 38-14.2 51.1-14.6 50.7-14.9 58.8 0 15.5 17.5 22.6 31.8-16.9L386 325c-10.5 36.7-29.4 52-53.2 52z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaIoxhost(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M616 160h-67.3C511.2 70.7 422.9 8 320 8 183 8 72 119 72 256c0 16.4 1.6 32.5 4.7 48H24c-13.3 0-24 10.8-24 24 0 13.3 10.7 24 24 24h67.3c37.5 89.3 125.8 152 228.7 152 137 0 248-111 248-248 0-16.4-1.6-32.5-4.7-48H616c13.3 0 24-10.8 24-24 0-13.3-10.7-24-24-24zm-96 96c0 110.5-89.5 200-200 200-75.7 0-141.6-42-175.5-104H424c13.3 0 24-10.8 24-24 0-13.3-10.7-24-24-24H125.8c-3.8-15.4-5.8-31.4-5.8-48 0-110.5 89.5-200 200-200 75.7 0 141.6 42 175.5 104H216c-13.3 0-24 10.8-24 24 0 13.3 10.7 24 24 24h298.2c3.8 15.4 5.8 31.4 5.8 48zm-304-24h208c13.3 0 24 10.7 24 24 0 13.2-10.7 24-24 24H216c-13.3 0-24-10.7-24-24 0-13.2 10.7-24 24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaItchIo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M71.92 34.77C50.2 47.67 7.4 96.84 7 109.73v21.34c0 27.06 25.29 50.84 48.25 50.84 27.57 0 50.54-22.85 50.54-50 0 27.12 22.18 50 49.76 50s49-22.85 49-50c0 27.12 23.59 50 51.16 50h.5c27.57 0 51.16-22.85 51.16-50 0 27.12 21.47 50 49 50s49.76-22.85 49.76-50c0 27.12 23 50 50.54 50 23 0 48.25-23.78 48.25-50.84v-21.34c-.4-12.9-43.2-62.07-64.92-75C372.56 32.4 325.76 32 256 32S91.14 33.1 71.92 34.77zm132.32 134.39c-22 38.4-77.9 38.71-99.85.25-13.17 23.14-43.17 32.07-56 27.66-3.87 40.15-13.67 237.13 17.73 269.15 80 18.67 302.08 18.12 379.76 0 31.65-32.27 21.32-232 17.75-269.15-12.92 4.44-42.88-4.6-56-27.66-22 38.52-77.85 38.1-99.85-.24-7.1 12.49-23.05 28.94-51.76 28.94a57.54 57.54 0 0 1-51.75-28.94zm-41.58 53.77c16.47 0 31.09 0 49.22 19.78a436.91 436.91 0 0 1 88.18 0C318.22 223 332.85 223 349.31 223c52.33 0 65.22 77.53 83.87 144.45 17.26 62.15-5.52 63.67-33.95 63.73-42.15-1.57-65.49-32.18-65.49-62.79-39.25 6.43-101.93 8.79-155.55 0 0 30.61-23.34 61.22-65.49 62.79-28.42-.06-51.2-1.58-33.94-63.73 18.67-67 31.56-144.45 83.88-144.45zM256 270.79s-44.38 40.77-52.35 55.21l29-1.17v25.32c0 1.55 21.34.16 23.33.16 11.65.54 23.31 1 23.31-.16v-25.28l29 1.17c-8-14.48-52.35-55.24-52.35-55.24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaItunesNote(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M381.9 388.2c-6.4 27.4-27.2 42.8-55.1 48-24.5 4.5-44.9 5.6-64.5-10.2-23.9-20.1-24.2-53.4-2.7-74.4 17-16.2 40.9-19.5 76.8-25.8 6-1.1 11.2-2.5 15.6-7.4 6.4-7.2 4.4-4.1 4.4-163.2 0-11.2-5.5-14.3-17-12.3-8.2 1.4-185.7 34.6-185.7 34.6-10.2 2.2-13.4 5.2-13.4 16.7 0 234.7 1.1 223.9-2.5 239.5-4.2 18.2-15.4 31.9-30.2 39.5-16.8 9.3-47.2 13.4-63.4 10.4-43.2-8.1-58.4-58-29.1-86.6 17-16.2 40.9-19.5 76.8-25.8 6-1.1 11.2-2.5 15.6-7.4 10.1-11.5 1.8-256.6 5.2-270.2.8-5.2 3-9.6 7.1-12.9 4.2-3.5 11.8-5.5 13.4-5.5 204-38.2 228.9-43.1 232.4-43.1 11.5-.8 18.1 6 18.1 17.6.2 344.5 1.1 326-1.8 338.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaItunes(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M223.6 80.3C129 80.3 52.5 157 52.5 251.5S129 422.8 223.6 422.8s171.2-76.7 171.2-171.2c0-94.6-76.7-171.3-171.2-171.3zm79.4 240c-3.2 13.6-13.5 21.2-27.3 23.8-12.1 2.2-22.2 2.8-31.9-5-11.8-10-12-26.4-1.4-36.8 8.4-8 20.3-9.6 38-12.8 3-.5 5.6-1.2 7.7-3.7 3.2-3.6 2.2-2 2.2-80.8 0-5.6-2.7-7.1-8.4-6.1-4 .7-91.9 17.1-91.9 17.1-5 1.1-6.7 2.6-6.7 8.3 0 116.1.5 110.8-1.2 118.5-2.1 9-7.6 15.8-14.9 19.6-8.3 4.6-23.4 6.6-31.4 5.2-21.4-4-28.9-28.7-14.4-42.9 8.4-8 20.3-9.6 38-12.8 3-.5 5.6-1.2 7.7-3.7 5-5.7.9-127 2.6-133.7.4-2.6 1.5-4.8 3.5-6.4 2.1-1.7 5.8-2.7 6.7-2.7 101-19 113.3-21.4 115.1-21.4 5.7-.4 9 3 9 8.7-.1 170.6.4 161.4-1 167.6zM345.2 32H102.8C45.9 32 0 77.9 0 134.8v242.4C0 434.1 45.9 480 102.8 480h242.4c57 0 102.8-45.9 102.8-102.8V134.8C448 77.9 402.1 32 345.2 32zM223.6 444c-106.3 0-192.5-86.2-192.5-192.5S117.3 59 223.6 59s192.5 86.2 192.5 192.5S329.9 444 223.6 444z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaJava(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M277.74 312.9c9.8-6.7 23.4-12.5 23.4-12.5s-38.7 7-77.2 10.2c-47.1 3.9-97.7 4.7-123.1 1.3-60.1-8 33-30.1 33-30.1s-36.1-2.4-80.6 19c-52.5 25.4 130 37 224.5 12.1zm-85.4-32.1c-19-42.7-83.1-80.2 0-145.8C296 53.2 242.84 0 242.84 0c21.5 84.5-75.6 110.1-110.7 162.6-23.9 35.9 11.7 74.4 60.2 118.2zm114.6-176.2c.1 0-175.2 43.8-91.5 140.2 24.7 28.4-6.5 54-6.5 54s62.7-32.4 33.9-72.9c-26.9-37.8-47.5-56.6 64.1-121.3zm-6.1 270.5a12.19 12.19 0 0 1-2 2.6c128.3-33.7 81.1-118.9 19.8-97.3a17.33 17.33 0 0 0-8.2 6.3 70.45 70.45 0 0 1 11-3c31-6.5 75.5 41.5-20.6 91.4zM348 437.4s14.5 11.9-15.9 21.2c-57.9 17.5-240.8 22.8-291.6.7-18.3-7.9 16-19 26.8-21.3 11.2-2.4 17.7-2 17.7-2-20.3-14.3-131.3 28.1-56.4 40.2C232.84 509.4 401 461.3 348 437.4zM124.44 396c-78.7 22 47.9 67.4 148.1 24.5a185.89 185.89 0 0 1-28.2-13.8c-44.7 8.5-65.4 9.1-106 4.5-33.5-3.8-13.9-15.2-13.9-15.2zm179.8 97.2c-78.7 14.8-175.8 13.1-233.3 3.6 0-.1 11.8 9.7 72.4 13.6 92.2 5.9 233.8-3.3 237.1-46.9 0 0-6.4 16.5-76.2 29.7zM260.64 353c-59.2 11.4-93.5 11.1-136.8 6.6-33.5-3.5-11.6-19.7-11.6-19.7-86.8 28.8 48.2 61.4 169.5 25.9a60.37 60.37 0 0 1-21.1-12.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaJediOrder(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M398.5 373.6c95.9-122.1 17.2-233.1 17.2-233.1 45.4 85.8-41.4 170.5-41.4 170.5 105-171.5-60.5-271.5-60.5-271.5 96.9 72.7-10.1 190.7-10.1 190.7 85.8 158.4-68.6 230.1-68.6 230.1s-.4-16.9-2.2-85.7c4.3 4.5 34.5 36.2 34.5 36.2l-24.2-47.4 62.6-9.1-62.6-9.1 20.2-55.5-31.4 45.9c-2.2-87.7-7.8-305.1-7.9-306.9v-2.4 1-1 2.4c0 1-5.6 219-7.9 306.9l-31.4-45.9 20.2 55.5-62.6 9.1 62.6 9.1-24.2 47.4 34.5-36.2c-1.8 68.8-2.2 85.7-2.2 85.7s-154.4-71.7-68.6-230.1c0 0-107-118.1-10.1-190.7 0 0-165.5 99.9-60.5 271.5 0 0-86.8-84.8-41.4-170.5 0 0-78.7 111 17.2 233.1 0 0-26.2-16.1-49.4-77.7 0 0 16.9 183.3 222 185.7h4.1c205-2.4 222-185.7 222-185.7-23.6 61.5-49.9 77.7-49.9 77.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaJenkins(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M487.1 425c-1.4-11.2-19-23.1-28.2-31.9-5.1-5-29-23.1-30.4-29.9-1.4-6.6 9.7-21.5 13.3-28.9 5.1-10.7 8.8-23.7 11.3-32.6 18.8-66.1 20.7-156.9-6.2-211.2-10.2-20.6-38.6-49-56.4-62.5-42-31.7-119.6-35.3-170.1-16.6-14.1 5.2-27.8 9.8-40.1 17.1-33.1 19.4-68.3 32.5-78.1 71.6-24.2 10.8-31.5 41.8-30.3 77.8.2 7 4.1 15.8 2.7 22.4-.7 3.3-5.2 7.6-6.1 9.8-11.6 27.7-2.3 64 11.1 83.7 8.1 11.9 21.5 22.4 39.2 25.2.7 10.6 3.3 19.7 8.2 30.4 3.1 6.8 14.7 19 10.4 27.7-2.2 4.4-21 13.8-27.3 17.6C89 407.2 73.7 415 54.2 429c-12.6 9-32.3 10.2-29.2 31.1 2.1 14.1 10.1 31.6 14.7 45.8.7 2 1.4 4.1 2.1 6h422c4.9-15.3 9.7-30.9 14.6-47.2 3.4-11.4 10.2-27.8 8.7-39.7zM205.9 33.7c1.8-.5 3.4.7 4.9 2.4-.2 5.2-5.4 5.1-8.9 6.8-5.4 6.7-13.4 9.8-20 17.2-6.8 7.5-14.4 27.7-23.4 30-4.5 1.1-9.7-.8-13.6-.5-10.4.7-17.7 6-28.3 7.5 13.6-29.9 56.1-54 89.3-63.4zm-104.8 93.6c13.5-14.9 32.1-24.1 54.8-25.9 11.7 29.7-8.4 65-.9 97.6 2.3 9.9 10.2 25.4-2.4 25.7.3-28.3-34.8-46.3-61.3-29.6-1.8-21.5-4.9-51.7 9.8-67.8zm36.7 200.2c-1-4.1-2.7-12.9-2.3-15.1 1.6-8.7 17.1-12.5 11-24.7-11.3-.1-13.8 10.2-24.1 11.3-26.7 2.6-45.6-35.4-44.4-58.4 1-19.5 17.6-38.2 40.1-35.8 16 1.8 21.4 19.2 24.5 34.7 9.2.5 22.5-.4 26.9-7.6-.6-17.5-8.8-31.6-8.2-47.7 1-30.3 17.5-57.6 4.8-87.4 13.6-30.9 53.5-55.3 83.1-70 36.6-18.3 94.9-3.7 129.3 15.8 19.7 11.1 34.4 32.7 48.3 50.7-19.5-5.8-36.1 4.2-33.1 20.3 16.3-14.9 44.2-.2 52.5 16.4 7.9 15.8 7.8 39.3 9 62.8 2.9 57-10.4 115.9-39.1 157.1-7.7 11-14.1 23-24.9 30.6-26 18.2-65.4 34.7-99.2 23.4-44.7-15-65-44.8-89.5-78.8.7 18.7 13.8 34.1 26.8 48.4 11.3 12.5 25 26.6 39.7 32.4-12.3-2.9-31.1-3.8-36.2 7.2-28.6-1.9-55.1-4.8-68.7-24.2-10.6-15.4-21.4-41.4-26.3-61.4zm222 124.1c4.1-3 11.1-2.9 17.4-3.6-5.4-2.7-13-3.7-19.3-2.2-.1-4.2-2-6.8-3.2-10.2 10.6-3.8 35.5-28.5 49.6-20.3 6.7 3.9 9.5 26.2 10.1 37 .4 9-.8 18-4.5 22.8-18.8-.6-35.8-2.8-50.7-7 .9-6.1-1-12.1.6-16.5zm-17.2-20c-16.8.8-26-1.2-38.3-10.8.2-.8 1.4-.5 1.5-1.4 18 8 40.8-3.3 59-4.9-7.9 5.1-14.6 11.6-22.2 17.1zm-12.1 33.2c-1.6-9.4-3.5-12-2.8-20.2 25-16.6 29.7 28.6 2.8 20.2zM226 438.6c-11.6-.7-48.1-14-38.5-23.7 9.4 6.5 27.5 4.9 41.3 7.3.8 4.4-2.8 10.2-2.8 16.4zM57.7 497.1c-4.3-12.7-9.2-25.1-14.8-36.9 30.8-23.8 65.3-48.9 102.2-63.5 2.8-1.1 23.2 25.4 26.2 27.6 16.5 11.7 37 21 56.2 30.2 1.2 8.8 3.9 20.2 8.7 35.5.7 2.3 1.4 4.7 2.2 7.2H57.7zm240.6 5.7h-.8c.3-.2.5-.4.8-.5v.5zm7.5-5.7c2.1-1.4 4.3-2.8 6.4-4.3 1.1 1.4 2.2 2.8 3.2 4.3h-9.6zm15.1-24.7c-10.8 7.3-20.6 18.3-33.3 25.2-6 3.3-27 11.7-33.4 10.2-3.6-.8-3.9-5.3-5.4-9.5-3.1-9-10.1-23.4-10.8-37-.8-17.2-2.5-46 16-42.4 14.9 2.9 32.3 9.7 43.9 16.1 7.1 3.9 11.1 8.6 21.9 9.5-.1 1.4-.1 2.8-.2 4.3-5.9 3.9-15.3 3.8-21.8 7.1 9.5.4 17 2.7 23.5 5.9-.1 3.4-.3 7-.4 10.6zm53.4 24.7h-14c-.1-3.2-2.8-5.8-6.1-5.8s-5.9 2.6-6.1 5.8h-17.4c-2.8-4.4-5.7-8.6-8.9-12.5 2.1-2.2 4-4.7 6-6.9 9 3.7 14.8-4.9 21.7-4.2 7.9.8 14.2 11.7 25.4 11l-.6 12.6zm8.7 0c.2-4 .4-7.8.6-11.5 15.6-7.3 29 1.3 35.7 11.5H383zm83.4-37c-2.3 11.2-5.8 24-9.9 37.1-.2-.1-.4-.1-.6-.1H428c.6-1.1 1.2-2.2 1.9-3.3-2.6-6.1-9-8.7-10.9-15.5 12.1-22.7 6.5-93.4-24.2-78.5 4.3-6.3 15.6-11.5 20.8-19.3 13 10.4 20.8 20.3 33.2 31.4 6.8 6 20 13.3 21.4 23.1.8 5.5-2.6 18.9-3.8 25.1zM222.2 130.5c5.4-14.9 27.2-34.7 45-32 7.7 1.2 18 8.2 12.2 17.7-30.2-7-45.2 12.6-54.4 33.1-8.1-2-4.9-13.1-2.8-18.8zm184.1 63.1c8.2-3.6 22.4-.7 29.6-5.3-4.2-11.5-10.3-21.4-9.3-37.7.5 0 1 0 1.4.1 6.8 14.2 12.7 29.2 21.4 41.7-5.7 13.5-43.6 25.4-43.1 1.2zm20.4-43zm-117.2 45.7c-6.8-10.9-19-32.5-14.5-45.3 6.5 11.9 8.6 24.4 17.8 33.3 4.1 4 12.2 9 8.2 20.2-.9 2.7-7.8 8.6-11.7 9.7-14.4 4.3-47.9.9-36.6-17.1 11.9.7 27.9 7.8 36.8-.8zm27.3 70c3.8 6.6 1.4 18.7 12.1 20.6 20.2 3.4 43.6-12.3 58.1-17.8 9-15.2-.8-20.7-8.9-30.5-16.6-20-38.8-44.8-38-74.7 6.7-4.9 7.3 7.4 8.2 9.7 8.7 20.3 30.4 46.2 46.3 63.5 3.9 4.3 10.3 8.4 11 11.2 2.1 8.2-5.4 18-4.5 23.5-21.7 13.9-45.8 29.1-81.4 25.6-7.4-6.7-10.3-21.4-2.9-31.1zm-201.3-9.2c-6.8-3.9-8.4-21-16.4-21.4-11.4-.7-9.3 22.2-9.3 35.5-7.8-7.1-9.2-29.1-3.5-40.3-6.6-3.2-9.5 3.6-13.1 5.9 4.7-34.1 49.8-15.8 42.3 20.3zm299.6 28.8c-10.1 19.2-24.4 40.4-54 41-.6-6.2-1.1-15.6 0-19.4 22.7-2.2 36.6-13.7 54-21.6zm-141.9 12.4c18.9 9.9 53.6 11 79.3 10.2 1.4 5.6 1.3 12.6 1.4 19.4-33 1.8-72-6.4-80.7-29.6zm92.2 46.7c-1.7 4.3-5.3 9.3-9.8 11.1-12.1 4.9-45.6 8.7-62.4-.3-10.7-5.7-17.5-18.5-23.4-26-2.8-3.6-16.9-12.9-.2-12.9 13.1 32.7 58 29 95.8 28.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaJira(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M490 241.7C417.1 169 320.6 71.8 248.5 0 83 164.9 6 241.7 6 241.7c-7.9 7.9-7.9 20.7 0 28.7C138.8 402.7 67.8 331.9 248.5 512c379.4-378 15.7-16.7 241.5-241.7 8-7.9 8-20.7 0-28.6zm-241.5 90l-76-75.7 76-75.7 76 75.7-76 75.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaJoget(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M378.1 45C337.6 19.9 292.6 8 248.2 8 165 8 83.8 49.9 36.9 125.9c-71.9 116.6-35.6 269.3 81 341.2s269.3 35.6 341.2-80.9c71.9-116.6 35.6-269.4-81-341.2zm51.8 323.2c-40.4 65.5-110.4 101.5-182 101.5-6.8 0-13.6-.4-20.4-1-9-13.6-19.9-33.3-23.7-42.4-5.7-13.7-27.2-45.6 31.2-67.1 51.7-19.1 176.7-16.5 208.8-17.6-4 9-8.6 17.9-13.9 26.6zm-200.8-86.3c-55.5-1.4-81.7-20.8-58.5-48.2s51.1-40.7 68.9-51.2c17.9-10.5 27.3-33.7-23.6-29.7C87.3 161.5 48.6 252.1 37.6 293c-8.8-49.7-.1-102.7 28.5-149.1C128 43.4 259.6 12.2 360.1 74.1c74.8 46.1 111.2 130.9 99.3 212.7-24.9-.5-179.3-3.6-230.3-4.9zm183.8-54.8c-22.7-6-57 11.3-86.7 27.2-29.7 15.8-31.1 8.2-31.1 8.2s40.2-28.1 50.7-34.5 31.9-14 13.4-24.6c-3.2-1.8-6.7-2.7-10.4-2.7-17.8 0-41.5 18.7-67.5 35.6-31.5 20.5-65.3 31.3-65.3 31.3l169.5-1.6 46.5-23.4s3.6-9.5-19.1-15.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaJoomla(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.6 92.1C.6 58.8 27.4 32 60.4 32c30 0 54.5 21.9 59.2 50.2 32.6-7.6 67.1.6 96.5 30l-44.3 44.3c-20.5-20.5-42.6-16.3-55.4-3.5-14.3 14.3-14.3 37.9 0 52.2l99.5 99.5-44 44.3c-87.7-87.2-49.7-49.7-99.8-99.7-26.8-26.5-35-64.8-24.8-98.9C20.4 144.6.6 120.7.6 92.1zm129.5 116.4l44.3 44.3c10-10 89.7-89.7 99.7-99.8 14.3-14.3 37.6-14.3 51.9 0 12.8 12.8 17 35-3.5 55.4l44 44.3c31.2-31.2 38.5-67.6 28.9-101.2 29.2-4.1 51.9-29.2 51.9-59.5 0-33.2-26.8-60.1-59.8-60.1-30.3 0-55.4 22.5-59.5 51.6-33.8-9.9-71.7-1.5-98.3 25.1-18.3 19.1-71.1 71.5-99.6 99.9zm266.3 152.2c8.2-32.7-.9-68.5-26.3-93.9-11.8-12.2 5 4.7-99.5-99.7l-44.3 44.3 99.7 99.7c14.3 14.3 14.3 37.6 0 51.9-12.8 12.8-35 17-55.4-3.5l-44 44.3c27.6 30.2 68 38.8 102.7 28 5.5 27.4 29.7 48.1 58.9 48.1 33 0 59.8-26.8 59.8-60.1 0-30.2-22.5-55-51.6-59.1zm-84.3-53.1l-44-44.3c-87 86.4-50.4 50.4-99.7 99.8-14.3 14.3-37.6 14.3-51.9 0-13.1-13.4-16.9-35.3 3.2-55.4l-44-44.3c-30.2 30.2-38 65.2-29.5 98.3-26.7 6-46.2 29.9-46.2 58.2C0 453.2 26.8 480 59.8 480c28.6 0 52.5-19.8 58.6-46.7 32.7 8.2 68.5-.6 94.2-26 32.1-32 12.2-12.4 99.5-99.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaJsSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM243.8 381.4c0 43.6-25.6 63.5-62.9 63.5-33.7 0-53.2-17.4-63.2-38.5l34.3-20.7c6.6 11.7 12.6 21.6 27.1 21.6 13.8 0 22.6-5.4 22.6-26.5V237.7h42.1v143.7zm99.6 63.5c-39.1 0-64.4-18.6-76.7-43l34.3-19.8c9 14.7 20.8 25.6 41.5 25.6 17.4 0 28.6-8.7 28.6-20.8 0-14.4-11.4-19.5-30.7-28l-10.5-4.5c-30.4-12.9-50.5-29.2-50.5-63.5 0-31.6 24.1-55.6 61.6-55.6 26.8 0 46 9.3 59.8 33.7L368 290c-7.2-12.9-15-18-27.1-18-12.3 0-20.1 7.8-20.1 18 0 12.6 7.8 17.7 25.9 25.6l10.5 4.5c35.8 15.3 55.9 31 55.9 66.2 0 37.8-29.8 58.6-69.7 58.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaJs(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32v448h448V32H0zm243.8 349.4c0 43.6-25.6 63.5-62.9 63.5-33.7 0-53.2-17.4-63.2-38.5l34.3-20.7c6.6 11.7 12.6 21.6 27.1 21.6 13.8 0 22.6-5.4 22.6-26.5V237.7h42.1v143.7zm99.6 63.5c-39.1 0-64.4-18.6-76.7-43l34.3-19.8c9 14.7 20.8 25.6 41.5 25.6 17.4 0 28.6-8.7 28.6-20.8 0-14.4-11.4-19.5-30.7-28l-10.5-4.5c-30.4-12.9-50.5-29.2-50.5-63.5 0-31.6 24.1-55.6 61.6-55.6 26.8 0 46 9.3 59.8 33.7L368 290c-7.2-12.9-15-18-27.1-18-12.3 0-20.1 7.8-20.1 18 0 12.6 7.8 17.7 25.9 25.6l10.5 4.5c35.8 15.3 55.9 31 55.9 66.2 0 37.8-29.8 58.6-69.7 58.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaJsfiddle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M510.634 237.462c-4.727-2.621-5.664-5.748-6.381-10.776-2.352-16.488-3.539-33.619-9.097-49.095-35.895-99.957-153.99-143.386-246.849-91.646-27.37 15.25-48.971 36.369-65.493 63.903-3.184-1.508-5.458-2.71-7.824-3.686-30.102-12.421-59.049-10.121-85.331 9.167-25.531 18.737-36.422 44.548-32.676 76.408.355 3.025-1.967 7.621-4.514 9.545-39.712 29.992-56.031 78.065-41.902 124.615 13.831 45.569 57.514 79.796 105.608 81.433 30.291 1.031 60.637.546 90.959.539 84.041-.021 168.09.531 252.12-.48 52.664-.634 96.108-36.873 108.212-87.293 11.54-48.074-11.144-97.3-56.832-122.634zm21.107 156.88c-18.23 22.432-42.343 35.253-71.28 35.65-56.874.781-113.767.23-170.652.23 0 .7-163.028.159-163.728.154-43.861-.332-76.739-19.766-95.175-59.995-18.902-41.245-4.004-90.848 34.186-116.106 9.182-6.073 12.505-11.566 10.096-23.136-5.49-26.361 4.453-47.956 26.42-62.981 22.987-15.723 47.422-16.146 72.034-3.083 10.269 5.45 14.607 11.564 22.198-2.527 14.222-26.399 34.557-46.727 60.671-61.294 97.46-54.366 228.37 7.568 230.24 132.697.122 8.15 2.412 12.428 9.848 15.894 57.56 26.829 74.456 96.122 35.142 144.497zm-87.789-80.499c-5.848 31.157-34.622 55.096-66.666 55.095-16.953-.001-32.058-6.545-44.079-17.705-27.697-25.713-71.141-74.98-95.937-93.387-20.056-14.888-41.99-12.333-60.272 3.782-49.996 44.071 15.859 121.775 67.063 77.188 4.548-3.96 7.84-9.543 12.744-12.844 8.184-5.509 20.766-.884 13.168 10.622-17.358 26.284-49.33 38.197-78.863 29.301-28.897-8.704-48.84-35.968-48.626-70.179 1.225-22.485 12.364-43.06 35.414-55.965 22.575-12.638 46.369-13.146 66.991 2.474C295.68 280.7 320.467 323.97 352.185 343.47c24.558 15.099 54.254 7.363 68.823-17.506 28.83-49.209-34.592-105.016-78.868-63.46-3.989 3.744-6.917 8.932-11.41 11.72-10.975 6.811-17.333-4.113-12.809-10.353 20.703-28.554 50.464-40.44 83.271-28.214 31.429 11.714 49.108 44.366 42.76 78.186z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaKaggle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304.2 501.5L158.4 320.3 298.2 185c2.6-2.7 1.7-10.5-5.3-10.5h-69.2c-3.5 0-7 1.8-10.5 5.3L80.9 313.5V7.5q0-7.5-7.5-7.5H21.5Q14 0 14 7.5v497q0 7.5 7.5 7.5h51.9q7.5 0 7.5-7.5v-109l30.8-29.3 110.5 140.6c3 3.5 6.5 5.3 10.5 5.3h66.9q5.25 0 6-3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaKeybase(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M286.17 419a18 18 0 1 0 18 18 18 18 0 0 0-18-18zm111.92-147.6c-9.5-14.62-39.37-52.45-87.26-73.71q-9.1-4.06-18.38-7.27a78.43 78.43 0 0 0-47.88-104.13c-12.41-4.1-23.33-6-32.41-5.77-.6-2-1.89-11 9.4-35L198.66 32l-5.48 7.56c-8.69 12.06-16.92 23.55-24.34 34.89a51 51 0 0 0-8.29-1.25c-41.53-2.45-39-2.33-41.06-2.33-50.61 0-50.75 52.12-50.75 45.88l-2.36 36.68c-1.61 27 19.75 50.21 47.63 51.85l8.93.54a214 214 0 0 0-46.29 35.54C14 304.66 14 374 14 429.77v33.64l23.32-29.8a148.6 148.6 0 0 0 14.56 37.56c5.78 10.13 14.87 9.45 19.64 7.33 4.21-1.87 10-6.92 3.75-20.11a178.29 178.29 0 0 1-15.76-53.13l46.82-59.83-24.66 74.11c58.23-42.4 157.38-61.76 236.25-38.59 34.2 10.05 67.45.69 84.74-23.84.72-1 1.2-2.16 1.85-3.22a156.09 156.09 0 0 1 2.8 28.43c0 23.3-3.69 52.93-14.88 81.64-2.52 6.46 1.76 14.5 8.6 15.74 7.42 1.57 15.33-3.1 18.37-11.15C429 443 434 414 434 382.32c0-38.58-13-77.46-35.91-110.92zM142.37 128.58l-15.7-.93-1.39 21.79 13.13.78a93 93 0 0 0 .32 19.57l-22.38-1.34a12.28 12.28 0 0 1-11.76-12.79L107 119c1-12.17 13.87-11.27 13.26-11.32l29.11 1.73a144.35 144.35 0 0 0-7 19.17zm148.42 172.18a10.51 10.51 0 0 1-14.35-1.39l-9.68-11.49-34.42 27a8.09 8.09 0 0 1-11.13-1.08l-15.78-18.64a7.38 7.38 0 0 1 1.34-10.34l34.57-27.18-14.14-16.74-17.09 13.45a7.75 7.75 0 0 1-10.59-1s-3.72-4.42-3.8-4.53a7.38 7.38 0 0 1 1.37-10.34L214 225.19s-18.51-22-18.6-22.14a9.56 9.56 0 0 1 1.74-13.42 10.38 10.38 0 0 1 14.3 1.37l81.09 96.32a9.58 9.58 0 0 1-1.74 13.44zM187.44 419a18 18 0 1 0 18 18 18 18 0 0 0-18-18z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaKeycdn(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M63.8 409.3l60.5-59c32.1 42.8 71.1 66 126.6 67.4 30.5.7 60.3-7 86.4-22.4 5.1 5.3 18.5 19.5 20.9 22-32.2 20.7-69.6 31.1-108.1 30.2-43.3-1.1-84.6-16.7-117.7-44.4.3-.6-38.2 37.5-38.6 37.9 9.5 29.8-13.1 62.4-46.3 62.4C20.7 503.3 0 481.7 0 454.9c0-34.3 33.1-56.6 63.8-45.6zm354.9-252.4c19.1 31.3 29.6 67.4 28.7 104-1.1 44.8-19 87.5-48.6 121 .3.3 23.8 25.2 24.1 25.5 9.6-1.3 19.2 2 25.9 9.1 11.3 12 10.9 30.9-1.1 42.4-12 11.3-30.9 10.9-42.4-1.1-6.7-7-9.4-16.8-7.6-26.3-24.9-26.6-44.4-47.2-44.4-47.2 42.7-34.1 63.3-79.6 64.4-124.2.7-28.9-7.2-57.2-21.1-82.2l22.1-21zM104 53.1c6.7 7 9.4 16.8 7.6 26.3l45.9 48.1c-4.7 3.8-13.3 10.4-22.8 21.3-25.4 28.5-39.6 64.8-40.7 102.9-.7 28.9 6.1 57.2 20 82.4l-22 21.5C72.7 324 63.1 287.9 64.2 250.9c1-44.6 18.3-87.6 47.5-121.1l-25.3-26.4c-9.6 1.3-19.2-2-25.9-9.1-11.3-12-10.9-30.9 1.1-42.4C73.5 40.7 92.2 41 104 53.1zM464.9 8c26 0 47.1 22.4 47.1 48.3S490.9 104 464.9 104c-6.3.1-14-1.1-15.9-1.8l-62.9 59.7c-32.7-43.6-76.7-65.9-126.9-67.2-30.5-.7-60.3 6.8-86.2 22.4l-21.1-22C184.1 74.3 221.5 64 260 64.9c43.3 1.1 84.6 16.7 117.7 44.6l41.1-38.6c-1.5-4.7-2.2-9.6-2.2-14.5C416.5 29.7 438.9 8 464.9 8zM256.7 113.4c5.5 0 10.9.4 16.4 1.1 78.1 9.8 133.4 81.1 123.8 159.1-9.8 78.1-81.1 133.4-159.1 123.8-78.1-9.8-133.4-81.1-123.8-159.2 9.3-72.4 70.1-124.6 142.7-124.8zm-59 119.4c.6 22.7 12.2 41.8 32.4 52.2l-11 51.7h73.7l-11-51.7c20.1-10.9 32.1-29 32.4-52.2-.4-32.8-25.8-57.5-58.3-58.3-32.1.8-57.3 24.8-58.2 58.3zM256 160"
                },
                "child": []
            }
        ]
    })(props);
}
function FaKickstarterK(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M147.3 114.4c0-56.2-32.5-82.4-73.4-82.4C26.2 32 0 68.2 0 113.4v283c0 47.3 25.3 83.4 74.9 83.4 39.8 0 72.4-25.6 72.4-83.4v-76.5l112.1 138.3c22.7 27.2 72.1 30.7 103.2 0 27-27.6 27.3-67.4 7.4-92.2l-90.8-114.8 74.9-107.4c17.4-24.7 17.5-63.1-10.4-89.8-30.3-29-82.4-31.6-113.6 12.8L147.3 185v-70.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaKickstarter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 480H48c-26.4 0-48-21.6-48-48V80c0-26.4 21.6-48 48-48h352c26.4 0 48 21.6 48 48v352c0 26.4-21.6 48-48 48zM199.6 178.5c0-30.7-17.6-45.1-39.7-45.1-25.8 0-40 19.8-40 44.5v154.8c0 25.8 13.7 45.6 40.5 45.6 21.5 0 39.2-14 39.2-45.6v-41.8l60.6 75.7c12.3 14.9 39 16.8 55.8 0 14.6-15.1 14.8-36.8 4-50.4l-49.1-62.8 40.5-58.7c9.4-13.5 9.5-34.5-5.6-49.1-16.4-15.9-44.6-17.3-61.4 7l-44.8 64.7v-38.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaKorvue(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 446 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M386.5 34h-327C26.8 34 0 60.8 0 93.5v327.1C0 453.2 26.8 480 59.5 480h327.1c33 0 59.5-26.8 59.5-59.5v-327C446 60.8 419.2 34 386.5 34zM87.1 120.8h96v116l61.8-116h110.9l-81.2 132H87.1v-132zm161.8 272.1l-65.7-113.6v113.6h-96V262.1h191.5l88.6 130.8H248.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLaravel(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504.4,115.83a5.72,5.72,0,0,0-.28-.68,8.52,8.52,0,0,0-.53-1.25,6,6,0,0,0-.54-.71,9.36,9.36,0,0,0-.72-.94c-.23-.22-.52-.4-.77-.6a8.84,8.84,0,0,0-.9-.68L404.4,55.55a8,8,0,0,0-8,0L300.12,111h0a8.07,8.07,0,0,0-.88.69,7.68,7.68,0,0,0-.78.6,8.23,8.23,0,0,0-.72.93c-.17.24-.39.45-.54.71a9.7,9.7,0,0,0-.52,1.25c-.08.23-.21.44-.28.68a8.08,8.08,0,0,0-.28,2.08V223.18l-80.22,46.19V63.44a7.8,7.8,0,0,0-.28-2.09c-.06-.24-.2-.45-.28-.68a8.35,8.35,0,0,0-.52-1.24c-.14-.26-.37-.47-.54-.72a9.36,9.36,0,0,0-.72-.94,9.46,9.46,0,0,0-.78-.6,9.8,9.8,0,0,0-.88-.68h0L115.61,1.07a8,8,0,0,0-8,0L11.34,56.49h0a6.52,6.52,0,0,0-.88.69,7.81,7.81,0,0,0-.79.6,8.15,8.15,0,0,0-.71.93c-.18.25-.4.46-.55.72a7.88,7.88,0,0,0-.51,1.24,6.46,6.46,0,0,0-.29.67,8.18,8.18,0,0,0-.28,2.1v329.7a8,8,0,0,0,4,6.95l192.5,110.84a8.83,8.83,0,0,0,1.33.54c.21.08.41.2.63.26a7.92,7.92,0,0,0,4.1,0c.2-.05.37-.16.55-.22a8.6,8.6,0,0,0,1.4-.58L404.4,400.09a8,8,0,0,0,4-6.95V287.88l92.24-53.11a8,8,0,0,0,4-7V117.92A8.63,8.63,0,0,0,504.4,115.83ZM111.6,17.28h0l80.19,46.15-80.2,46.18L31.41,63.44Zm88.25,60V278.6l-46.53,26.79-33.69,19.4V123.5l46.53-26.79Zm0,412.78L23.37,388.5V77.32L57.06,96.7l46.52,26.8V338.68a6.94,6.94,0,0,0,.12.9,8,8,0,0,0,.16,1.18h0a5.92,5.92,0,0,0,.38.9,6.38,6.38,0,0,0,.42,1v0a8.54,8.54,0,0,0,.6.78,7.62,7.62,0,0,0,.66.84l0,0c.23.22.52.38.77.58a8.93,8.93,0,0,0,.86.66l0,0,0,0,92.19,52.18Zm8-106.17-80.06-45.32,84.09-48.41,92.26-53.11,80.13,46.13-58.8,33.56Zm184.52,4.57L215.88,490.11V397.8L346.6,323.2l45.77-26.15Zm0-119.13L358.68,250l-46.53-26.79V131.79l33.69,19.4L392.37,178Zm8-105.28-80.2-46.17,80.2-46.16,80.18,46.15Zm8,105.28V178L455,151.19l33.68-19.4v91.39h0Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLastfmSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-92.2 312.9c-63.4 0-85.4-28.6-97.1-64.1-16.3-51-21.5-84.3-63-84.3-22.4 0-45.1 16.1-45.1 61.2 0 35.2 18 57.2 43.3 57.2 28.6 0 47.6-21.3 47.6-21.3l11.7 31.9s-19.8 19.4-61.2 19.4c-51.3 0-79.9-30.1-79.9-85.8 0-57.9 28.6-92 82.5-92 73.5 0 80.8 41.4 100.8 101.9 8.8 26.8 24.2 46.2 61.2 46.2 24.9 0 38.1-5.5 38.1-19.1 0-19.9-21.8-22-49.9-28.6-30.4-7.3-42.5-23.1-42.5-48 0-40 32.3-52.4 65.2-52.4 37.4 0 60.1 13.6 63 46.6l-36.7 4.4c-1.5-15.8-11-22.4-28.6-22.4-16.1 0-26 7.3-26 19.8 0 11 4.8 17.6 20.9 21.3 32.7 7.1 71.8 12 71.8 57.5.1 36.7-30.7 50.6-76.1 50.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLastfm(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M225.8 367.1l-18.8-51s-30.5 34-76.2 34c-40.5 0-69.2-35.2-69.2-91.5 0-72.1 36.4-97.9 72.1-97.9 66.5 0 74.8 53.3 100.9 134.9 18.8 56.9 54 102.6 155.4 102.6 72.7 0 122-22.3 122-80.9 0-72.9-62.7-80.6-115-92.1-25.8-5.9-33.4-16.4-33.4-34 0-19.9 15.8-31.7 41.6-31.7 28.2 0 43.4 10.6 45.7 35.8l58.6-7c-4.7-52.8-41.1-74.5-100.9-74.5-52.8 0-104.4 19.9-104.4 83.9 0 39.9 19.4 65.1 68 76.8 44.9 10.6 79.8 13.8 79.8 45.7 0 21.7-21.1 30.5-61 30.5-59.2 0-83.9-31.1-97.9-73.9-32-96.8-43.6-163-161.3-163C45.7 113.8 0 168.3 0 261c0 89.1 45.7 137.2 127.9 137.2 66.2 0 97.9-31.1 97.9-31.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLeanpub(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M386.539 111.485l15.096 248.955-10.979-.275c-36.232-.824-71.64 8.783-102.657 27.997-31.016-19.214-66.424-27.997-102.657-27.997-45.564 0-82.07 10.705-123.516 27.723L93.117 129.6c28.546-11.803 61.484-18.115 92.226-18.115 41.173 0 73.836 13.175 102.657 42.544 27.723-28.271 59.013-41.721 98.539-42.544zM569.07 448c-25.526 0-47.485-5.215-70.542-15.645-34.31-15.645-69.993-24.978-107.871-24.978-38.977 0-74.934 12.901-102.657 40.623-27.723-27.723-63.68-40.623-102.657-40.623-37.878 0-73.561 9.333-107.871 24.978C55.239 442.236 32.731 448 8.303 448H6.93L49.475 98.859C88.726 76.626 136.486 64 181.775 64 218.83 64 256.984 71.685 288 93.095 319.016 71.685 357.17 64 394.225 64c45.289 0 93.049 12.626 132.3 34.859L569.07 448zm-43.368-44.741l-34.036-280.246c-30.742-13.999-67.248-21.41-101.009-21.41-38.428 0-74.385 12.077-102.657 38.702-28.272-26.625-64.228-38.702-102.657-38.702-33.761 0-70.267 7.411-101.009 21.41L50.298 403.259c47.211-19.487 82.894-33.486 135.045-33.486 37.604 0 70.817 9.606 102.657 29.644 31.84-20.038 65.052-29.644 102.657-29.644 52.151 0 87.834 13.999 135.045 33.486z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLess(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M612.7 219c0-20.5 3.2-32.6 3.2-54.6 0-34.2-12.6-45.2-40.5-45.2h-20.5v24.2h6.3c14.2 0 17.3 4.7 17.3 22.1 0 16.3-1.6 32.6-1.6 51.5 0 24.2 7.9 33.6 23.6 37.3v1.6c-15.8 3.7-23.6 13.1-23.6 37.3 0 18.9 1.6 34.2 1.6 51.5 0 17.9-3.7 22.6-17.3 22.6v.5h-6.3V393h20.5c27.8 0 40.5-11 40.5-45.2 0-22.6-3.2-34.2-3.2-54.6 0-11 6.8-22.6 27.3-23.6v-27.3c-20.5-.7-27.3-12.3-27.3-23.3zm-105.6 32c-15.8-6.3-30.5-10-30.5-20.5 0-7.9 6.3-12.6 17.9-12.6s22.1 4.7 33.6 13.1l21-27.8c-13.1-10-31-20.5-55.2-20.5-35.7 0-59.9 20.5-59.9 49.4 0 25.7 22.6 38.9 41.5 46.2 16.3 6.3 32.1 11.6 32.1 22.1 0 7.9-6.3 13.1-20.5 13.1-13.1 0-26.3-5.3-40.5-16.3l-21 30.5c15.8 13.1 39.9 22.1 59.9 22.1 42 0 64.6-22.1 64.6-51s-22.5-41-43-47.8zm-358.9 59.4c-3.7 0-8.4-3.2-8.4-13.1V119.1H65.2c-28.4 0-41 11-41 45.2 0 22.6 3.2 35.2 3.2 54.6 0 11-6.8 22.6-27.3 23.6v27.3c20.5.5 27.3 12.1 27.3 23.1 0 19.4-3.2 31-3.2 53.6 0 34.2 12.6 45.2 40.5 45.2h20.5v-24.2h-6.3c-13.1 0-17.3-5.3-17.3-22.6s1.6-32.1 1.6-51.5c0-24.2-7.9-33.6-23.6-37.3v-1.6c15.8-3.7 23.6-13.1 23.6-37.3 0-18.9-1.6-34.2-1.6-51.5s3.7-22.1 17.3-22.1H93v150.8c0 32.1 11 53.1 43.1 53.1 10 0 17.9-1.6 23.6-3.7l-5.3-34.2c-3.1.8-4.6.8-6.2.8zM379.9 251c-16.3-6.3-31-10-31-20.5 0-7.9 6.3-12.6 17.9-12.6 11.6 0 22.1 4.7 33.6 13.1l21-27.8c-13.1-10-31-20.5-55.2-20.5-35.7 0-59.9 20.5-59.9 49.4 0 25.7 22.6 38.9 41.5 46.2 16.3 6.3 32.1 11.6 32.1 22.1 0 7.9-6.3 13.1-20.5 13.1-13.1 0-26.3-5.3-40.5-16.3l-20.5 30.5c15.8 13.1 39.9 22.1 59.9 22.1 42 0 64.6-22.1 64.6-51 .1-28.9-22.5-41-43-47.8zm-155-68.8c-38.4 0-75.1 32.1-74.1 82.5 0 52 34.2 82.5 79.3 82.5 18.9 0 39.9-6.8 56.2-17.9l-15.8-27.8c-11.6 6.8-22.6 10-34.2 10-21 0-37.3-10-41.5-34.2H290c.5-3.7 1.6-11 1.6-19.4.6-42.6-22.6-75.7-66.7-75.7zm-30 66.2c3.2-21 15.8-31 30.5-31 18.9 0 26.3 13.1 26.3 31h-56.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLine(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272.1 204.2v71.1c0 1.8-1.4 3.2-3.2 3.2h-11.4c-1.1 0-2.1-.6-2.6-1.3l-32.6-44v42.2c0 1.8-1.4 3.2-3.2 3.2h-11.4c-1.8 0-3.2-1.4-3.2-3.2v-71.1c0-1.8 1.4-3.2 3.2-3.2H219c1 0 2.1.5 2.6 1.4l32.6 44v-42.2c0-1.8 1.4-3.2 3.2-3.2h11.4c1.8-.1 3.3 1.4 3.3 3.1zm-82-3.2h-11.4c-1.8 0-3.2 1.4-3.2 3.2v71.1c0 1.8 1.4 3.2 3.2 3.2h11.4c1.8 0 3.2-1.4 3.2-3.2v-71.1c0-1.7-1.4-3.2-3.2-3.2zm-27.5 59.6h-31.1v-56.4c0-1.8-1.4-3.2-3.2-3.2h-11.4c-1.8 0-3.2 1.4-3.2 3.2v71.1c0 .9.3 1.6.9 2.2.6.5 1.3.9 2.2.9h45.7c1.8 0 3.2-1.4 3.2-3.2v-11.4c0-1.7-1.4-3.2-3.1-3.2zM332.1 201h-45.7c-1.7 0-3.2 1.4-3.2 3.2v71.1c0 1.7 1.4 3.2 3.2 3.2h45.7c1.8 0 3.2-1.4 3.2-3.2v-11.4c0-1.8-1.4-3.2-3.2-3.2H301v-12h31.1c1.8 0 3.2-1.4 3.2-3.2V234c0-1.8-1.4-3.2-3.2-3.2H301v-12h31.1c1.8 0 3.2-1.4 3.2-3.2v-11.4c-.1-1.7-1.5-3.2-3.2-3.2zM448 113.7V399c-.1 44.8-36.8 81.1-81.7 81H81c-44.8-.1-81.1-36.9-81-81.7V113c.1-44.8 36.9-81.1 81.7-81H367c44.8.1 81.1 36.8 81 81.7zm-61.6 122.6c0-73-73.2-132.4-163.1-132.4-89.9 0-163.1 59.4-163.1 132.4 0 65.4 58 120.2 136.4 130.6 19.1 4.1 16.9 11.1 12.6 36.8-.7 4.1-3.3 16.1 14.1 8.8 17.4-7.3 93.9-55.3 128.2-94.7 23.6-26 34.9-52.3 34.9-81.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLinkedinIn(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLinkedin(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLinode(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M437.4 226.3c-.3-.9-.9-1.4-1.4-2l-70-38.6c-.9-.6-2-.6-3.1 0l-58.9 36c-.9.6-1.4 1.7-1.4 2.6l-.9 31.4-24-16c-.9-.6-2.3-.6-3.1 0L240 260.9l-1.4-35.1c0-.9-.6-2-1.4-2.3l-36-24.3 33.7-17.4c1.1-.6 1.7-1.7 1.7-2.9l-5.7-132.3c0-.9-.9-2-1.7-2.6L138.6.3c-.9-.3-1.7-.3-2.3-.3L12.6 38.6c-1.4.6-2.3 2-2 3.7L38 175.4c.9 3.4 34 27.4 38.6 30.9l-26.9 12.9c-1.4.9-2 2.3-1.7 3.4l20.6 100.3c.6 2.9 23.7 23.1 27.1 26.3l-17.4 10.6c-.9.6-1.7 2-1.4 3.1 1.4 7.1 15.4 77.7 16.9 79.1l65.1 69.1c.6.6 1.4.6 2.3.9.6 0 1.1-.3 1.7-.6l83.7-66.9c.9-.6 1.1-1.4 1.1-2.3l-2-46 28 23.7c1.1.9 2.9.9 4 0l66.9-53.4c.9-.6 1.1-1.4 1.1-2.3l2.3-33.4 20.3 14c1.1.9 2.6.9 3.7 0l54.6-43.7c.6-.3 1.1-1.1 1.1-2 .9-6.5 10.3-70.8 9.7-72.8zm-204.8 4.8l4 92.6-90.6 61.2-14-96.6 100.6-57.2zm-7.7-180l5.4 126-106.6 55.4L104 97.7l120.9-46.6zM44 173.1L18 48l79.7 49.4 19.4 132.9L44 173.1zm30.6 147.8L55.7 230l70 58.3 13.7 93.4-64.8-60.8zm24.3 117.7l-13.7-67.1 61.7 60.9 9.7 67.4-57.7-61.2zm64.5 64.5l-10.6-70.9 85.7-61.4 3.1 70-78.2 62.3zm82-115.1c0-3.4.9-22.9-2-25.1l-24.3-20 22.3-14.9c2.3-1.7 1.1-5.7 1.1-8l29.4 22.6.6 68.3-27.1-22.9zm94.3-25.4l-60.9 48.6-.6-68.6 65.7-46.9-4.2 66.9zm27.7-25.7l-19.1-13.4 2-34c.3-.9-.3-2-1.1-2.6L308 259.7l.6-30 64.6 40.6-5.8 66.6zm54.6-39.8l-48.3 38.3 5.7-65.1 51.1-36.6-8.5 63.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLinux(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M220.8 123.3c1 .5 1.8 1.7 3 1.7 1.1 0 2.8-.4 2.9-1.5.2-1.4-1.9-2.3-3.2-2.9-1.7-.7-3.9-1-5.5-.1-.4.2-.8.7-.6 1.1.3 1.3 2.3 1.1 3.4 1.7zm-21.9 1.7c1.2 0 2-1.2 3-1.7 1.1-.6 3.1-.4 3.5-1.6.2-.4-.2-.9-.6-1.1-1.6-.9-3.8-.6-5.5.1-1.3.6-3.4 1.5-3.2 2.9.1 1 1.8 1.5 2.8 1.4zM420 403.8c-3.6-4-5.3-11.6-7.2-19.7-1.8-8.1-3.9-16.8-10.5-22.4-1.3-1.1-2.6-2.1-4-2.9-1.3-.8-2.7-1.5-4.1-2 9.2-27.3 5.6-54.5-3.7-79.1-11.4-30.1-31.3-56.4-46.5-74.4-17.1-21.5-33.7-41.9-33.4-72C311.1 85.4 315.7.1 234.8 0 132.4-.2 158 103.4 156.9 135.2c-1.7 23.4-6.4 41.8-22.5 64.7-18.9 22.5-45.5 58.8-58.1 96.7-6 17.9-8.8 36.1-6.2 53.3-6.5 5.8-11.4 14.7-16.6 20.2-4.2 4.3-10.3 5.9-17 8.3s-14 6-18.5 14.5c-2.1 3.9-2.8 8.1-2.8 12.4 0 3.9.6 7.9 1.2 11.8 1.2 8.1 2.5 15.7.8 20.8-5.2 14.4-5.9 24.4-2.2 31.7 3.8 7.3 11.4 10.5 20.1 12.3 17.3 3.6 40.8 2.7 59.3 12.5 19.8 10.4 39.9 14.1 55.9 10.4 11.6-2.6 21.1-9.6 25.9-20.2 12.5-.1 26.3-5.4 48.3-6.6 14.9-1.2 33.6 5.3 55.1 4.1.6 2.3 1.4 4.6 2.5 6.7v.1c8.3 16.7 23.8 24.3 40.3 23 16.6-1.3 34.1-11 48.3-27.9 13.6-16.4 36-23.2 50.9-32.2 7.4-4.5 13.4-10.1 13.9-18.3.4-8.2-4.4-17.3-15.5-29.7zM223.7 87.3c9.8-22.2 34.2-21.8 44-.4 6.5 14.2 3.6 30.9-4.3 40.4-1.6-.8-5.9-2.6-12.6-4.9 1.1-1.2 3.1-2.7 3.9-4.6 4.8-11.8-.2-27-9.1-27.3-7.3-.5-13.9 10.8-11.8 23-4.1-2-9.4-3.5-13-4.4-1-6.9-.3-14.6 2.9-21.8zM183 75.8c10.1 0 20.8 14.2 19.1 33.5-3.5 1-7.1 2.5-10.2 4.6 1.2-8.9-3.3-20.1-9.6-19.6-8.4.7-9.8 21.2-1.8 28.1 1 .8 1.9-.2-5.9 5.5-15.6-14.6-10.5-52.1 8.4-52.1zm-13.6 60.7c6.2-4.6 13.6-10 14.1-10.5 4.7-4.4 13.5-14.2 27.9-14.2 7.1 0 15.6 2.3 25.9 8.9 6.3 4.1 11.3 4.4 22.6 9.3 8.4 3.5 13.7 9.7 10.5 18.2-2.6 7.1-11 14.4-22.7 18.1-11.1 3.6-19.8 16-38.2 14.9-3.9-.2-7-1-9.6-2.1-8-3.5-12.2-10.4-20-15-8.6-4.8-13.2-10.4-14.7-15.3-1.4-4.9 0-9 4.2-12.3zm3.3 334c-2.7 35.1-43.9 34.4-75.3 18-29.9-15.8-68.6-6.5-76.5-21.9-2.4-4.7-2.4-12.7 2.6-26.4v-.2c2.4-7.6.6-16-.6-23.9-1.2-7.8-1.8-15 .9-20 3.5-6.7 8.5-9.1 14.8-11.3 10.3-3.7 11.8-3.4 19.6-9.9 5.5-5.7 9.5-12.9 14.3-18 5.1-5.5 10-8.1 17.7-6.9 8.1 1.2 15.1 6.8 21.9 16l19.6 35.6c9.5 19.9 43.1 48.4 41 68.9zm-1.4-25.9c-4.1-6.6-9.6-13.6-14.4-19.6 7.1 0 14.2-2.2 16.7-8.9 2.3-6.2 0-14.9-7.4-24.9-13.5-18.2-38.3-32.5-38.3-32.5-13.5-8.4-21.1-18.7-24.6-29.9s-3-23.3-.3-35.2c5.2-22.9 18.6-45.2 27.2-59.2 2.3-1.7.8 3.2-8.7 20.8-8.5 16.1-24.4 53.3-2.6 82.4.6-20.7 5.5-41.8 13.8-61.5 12-27.4 37.3-74.9 39.3-112.7 1.1.8 4.6 3.2 6.2 4.1 4.6 2.7 8.1 6.7 12.6 10.3 12.4 10 28.5 9.2 42.4 1.2 6.2-3.5 11.2-7.5 15.9-9 9.9-3.1 17.8-8.6 22.3-15 7.7 30.4 25.7 74.3 37.2 95.7 6.1 11.4 18.3 35.5 23.6 64.6 3.3-.1 7 .4 10.9 1.4 13.8-35.7-11.7-74.2-23.3-84.9-4.7-4.6-4.9-6.6-2.6-6.5 12.6 11.2 29.2 33.7 35.2 59 2.8 11.6 3.3 23.7.4 35.7 16.4 6.8 35.9 17.9 30.7 34.8-2.2-.1-3.2 0-4.2 0 3.2-10.1-3.9-17.6-22.8-26.1-19.6-8.6-36-8.6-38.3 12.5-12.1 4.2-18.3 14.7-21.4 27.3-2.8 11.2-3.6 24.7-4.4 39.9-.5 7.7-3.6 18-6.8 29-32.1 22.9-76.7 32.9-114.3 7.2zm257.4-11.5c-.9 16.8-41.2 19.9-63.2 46.5-13.2 15.7-29.4 24.4-43.6 25.5s-26.5-4.8-33.7-19.3c-4.7-11.1-2.4-23.1 1.1-36.3 3.7-14.2 9.2-28.8 9.9-40.6.8-15.2 1.7-28.5 4.2-38.7 2.6-10.3 6.6-17.2 13.7-21.1.3-.2.7-.3 1-.5.8 13.2 7.3 26.6 18.8 29.5 12.6 3.3 30.7-7.5 38.4-16.3 9-.3 15.7-.9 22.6 5.1 9.9 8.5 7.1 30.3 17.1 41.6 10.6 11.6 14 19.5 13.7 24.6zM173.3 148.7c2 1.9 4.7 4.5 8 7.1 6.6 5.2 15.8 10.6 27.3 10.6 11.6 0 22.5-5.9 31.8-10.8 4.9-2.6 10.9-7 14.8-10.4s5.9-6.3 3.1-6.6-2.6 2.6-6 5.1c-4.4 3.2-9.7 7.4-13.9 9.8-7.4 4.2-19.5 10.2-29.9 10.2s-18.7-4.8-24.9-9.7c-3.1-2.5-5.7-5-7.7-6.9-1.5-1.4-1.9-4.6-4.3-4.9-1.4-.1-1.8 3.7 1.7 6.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLyft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 81.1h77.8v208.7c0 33.1 15 52.8 27.2 61-12.7 11.1-51.2 20.9-80.2-2.8C7.8 334 0 310.7 0 289V81.1zm485.9 173.5v-22h23.8v-76.8h-26.1c-10.1-46.3-51.2-80.7-100.3-80.7-56.6 0-102.7 46-102.7 102.7V357c16 2.3 35.4-.3 51.7-14 17.1-14 24.8-37.2 24.8-59v-6.7h38.8v-76.8h-38.8v-23.3c0-34.6 52.2-34.6 52.2 0v77.1c0 56.6 46 102.7 102.7 102.7v-76.5c-14.5 0-26.1-11.7-26.1-25.9zm-294.3-99v113c0 15.4-23.8 15.4-23.8 0v-113H91v132.7c0 23.8 8 54 45 63.9 37 9.8 58.2-10.6 58.2-10.6-2.1 13.4-14.5 23.3-34.9 25.3-15.5 1.6-35.2-3.6-45-7.8v70.3c25.1 7.5 51.5 9.8 77.6 4.7 47.1-9.1 76.8-48.4 76.8-100.8V155.1h-77.1v.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMagento(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M445.7 127.9V384l-63.4 36.5V164.7L223.8 73.1 65.2 164.7l.4 255.9L2.3 384V128.1L224.2 0l221.5 127.9zM255.6 420.5L224 438.9l-31.8-18.2v-256l-63.3 36.6.1 255.9 94.9 54.9 95.1-54.9v-256l-63.4-36.6v255.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMailchimp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M330.61 243.52a36.15 36.15 0 0 1 9.3 0c1.66-3.83 1.95-10.43.45-17.61-2.23-10.67-5.25-17.14-11.48-16.13s-6.47 8.74-4.24 19.42c1.26 6 3.49 11.14 6 14.32zM277.05 252c4.47 2 7.2 3.26 8.28 2.13 1.89-1.94-3.48-9.39-12.12-13.09a31.44 31.44 0 0 0-30.61 3.68c-3 2.18-5.81 5.22-5.41 7.06.85 3.74 10-2.71 22.6-3.48 7-.44 12.8 1.75 17.26 3.71zm-9 5.13c-9.07 1.42-15 6.53-13.47 10.1.9.34 1.17.81 5.21-.81a37 37 0 0 1 18.72-1.95c2.92.34 4.31.52 4.94-.49 1.46-2.22-5.71-8-15.39-6.85zm54.17 17.1c3.38-6.87-10.9-13.93-14.3-7s10.92 13.88 14.32 6.97zm15.66-20.47c-7.66-.13-7.95 15.8-.26 15.93s7.98-15.81.28-15.96zm-218.79 78.9c-1.32.31-6 1.45-8.47-2.35-5.2-8 11.11-20.38 3-35.77-9.1-17.47-27.82-13.54-35.05-5.54-8.71 9.6-8.72 23.54-5 24.08 4.27.57 4.08-6.47 7.38-11.63a12.83 12.83 0 0 1 17.85-3.72c11.59 7.59 1.37 17.76 2.28 28.62 1.39 16.68 18.42 16.37 21.58 9a2.08 2.08 0 0 0-.2-2.33c.03.89.68-1.3-3.35-.39zm299.72-17.07c-3.35-11.73-2.57-9.22-6.78-20.52 2.45-3.67 15.29-24-3.07-43.25-10.4-10.92-33.9-16.54-41.1-18.54-1.5-11.39 4.65-58.7-21.52-83 20.79-21.55 33.76-45.29 33.73-65.65-.06-39.16-48.15-51-107.42-26.47l-12.55 5.33c-.06-.05-22.71-22.27-23.05-22.57C169.5-18-41.77 216.81 25.78 273.85l14.76 12.51a72.49 72.49 0 0 0-4.1 33.5c3.36 33.4 36 60.42 67.53 60.38 57.73 133.06 267.9 133.28 322.29 3 1.74-4.47 9.11-24.61 9.11-42.38s-10.09-25.27-16.53-25.27zm-316 48.16c-22.82-.61-47.46-21.15-49.91-45.51-6.17-61.31 74.26-75.27 84-12.33 4.54 29.64-4.67 58.49-34.12 57.81zM84.3 249.55C69.14 252.5 55.78 261.09 47.6 273c-4.88-4.07-14-12-15.59-15-13.01-24.85 14.24-73 33.3-100.21C112.42 90.56 186.19 39.68 220.36 48.91c5.55 1.57 23.94 22.89 23.94 22.89s-34.15 18.94-65.8 45.35c-42.66 32.85-74.89 80.59-94.2 132.4zM323.18 350.7s-35.74 5.3-69.51-7.07c6.21-20.16 27 6.1 96.4-13.81 15.29-4.38 35.37-13 51-25.35a102.85 102.85 0 0 1 7.12 24.28c3.66-.66 14.25-.52 11.44 18.1-3.29 19.87-11.73 36-25.93 50.84A106.86 106.86 0 0 1 362.55 421a132.45 132.45 0 0 1-20.34 8.58c-53.51 17.48-108.3-1.74-126-43a66.33 66.33 0 0 1-3.55-9.74c-7.53-27.2-1.14-59.83 18.84-80.37 1.23-1.31 2.48-2.85 2.48-4.79a8.45 8.45 0 0 0-1.92-4.54c-7-10.13-31.19-27.4-26.33-60.83 3.5-24 24.49-40.91 44.07-39.91l5 .29c8.48.5 15.89 1.59 22.88 1.88 11.69.5 22.2-1.19 34.64-11.56 4.2-3.5 7.57-6.54 13.26-7.51a17.45 17.45 0 0 1 13.6 2.24c10 6.64 11.4 22.73 11.92 34.49.29 6.72 1.1 23 1.38 27.63.63 10.67 3.43 12.17 9.11 14 3.19 1.05 6.15 1.83 10.51 3.06 13.21 3.71 21 7.48 26 12.31a16.38 16.38 0 0 1 4.74 9.29c1.56 11.37-8.82 25.4-36.31 38.16-46.71 21.68-93.68 14.45-100.48 13.68-20.15-2.71-31.63 23.32-19.55 41.15 22.64 33.41 122.4 20 151.37-21.35.69-1 .12-1.59-.73-1-41.77 28.58-97.06 38.21-128.46 26-4.77-1.85-14.73-6.44-15.94-16.67 43.6 13.49 71 .74 71 .74s2.03-2.79-.56-2.53zm-68.47-5.7zm-83.4-187.5c16.74-19.35 37.36-36.18 55.83-45.63a.73.73 0 0 1 1 1c-1.46 2.66-4.29 8.34-5.19 12.65a.75.75 0 0 0 1.16.79c11.49-7.83 31.48-16.22 49-17.3a.77.77 0 0 1 .52 1.38 41.86 41.86 0 0 0-7.71 7.74.75.75 0 0 0 .59 1.19c12.31.09 29.66 4.4 41 10.74.76.43.22 1.91-.64 1.72-69.55-15.94-123.08 18.53-134.5 26.83a.76.76 0 0 1-1-1.12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMandalorian(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M232.27 511.89c-1-3.26-1.69-15.83-1.39-24.58.55-15.89 1-24.72 1.4-28.76.64-6.2 2.87-20.72 3.28-21.38.6-1 .4-27.87-.24-33.13-.31-2.58-.63-11.9-.69-20.73-.13-16.47-.53-20.12-2.73-24.76-1.1-2.32-1.23-3.84-1-11.43a92.38 92.38 0 0 0-.34-12.71c-2-13-3.46-27.7-3.25-33.9s.43-7.15 2.06-9.67c3.05-4.71 6.51-14 8.62-23.27 2.26-9.86 3.88-17.18 4.59-20.74a109.54 109.54 0 0 1 4.42-15.05c2.27-6.25 2.49-15.39.37-15.39-.3 0-1.38 1.22-2.41 2.71s-4.76 4.8-8.29 7.36c-8.37 6.08-11.7 9.39-12.66 12.58s-1 7.23-.16 7.76c.34.21 1.29 2.4 2.11 4.88a28.83 28.83 0 0 1 .72 15.36c-.39 1.77-1 5.47-1.46 8.23s-1 6.46-1.25 8.22a9.85 9.85 0 0 1-1.55 4.26c-1 1-1.14.91-2.05-.53a14.87 14.87 0 0 1-1.44-4.75c-.25-1.74-1.63-7.11-3.08-11.93-3.28-10.9-3.52-16.15-1-21a14.24 14.24 0 0 0 1.67-4.61c0-2.39-2.2-5.32-7.41-9.89-7-6.18-8.63-7.92-10.23-11.3-1.71-3.6-3.06-4.06-4.54-1.54-1.78 3-2.6 9.11-3 22l-.34 12.19 2 2.25c3.21 3.7 12.07 16.45 13.78 19.83 3.41 6.74 4.34 11.69 4.41 23.56s.95 22.75 2 24.71c.36.66.51 1.35.34 1.52s.41 2.09 1.29 4.27a38.14 38.14 0 0 1 2.06 9 91 91 0 0 0 1.71 10.37c2.23 9.56 2.77 14.08 2.39 20.14-.2 3.27-.53 11.07-.73 17.32-1.31 41.76-1.85 58-2 61.21-.12 2-.39 11.51-.6 21.07-.36 16.3-1.3 27.37-2.42 28.65-.64.73-8.07-4.91-12.52-9.49-3.75-3.87-4-4.79-2.83-9.95.7-3 2.26-18.29 3.33-32.62.36-4.78.81-10.5 1-12.71.83-9.37 1.66-20.35 2.61-34.78.56-8.46 1.33-16.44 1.72-17.73s.89-9.89 1.13-19.11l.43-16.77-2.26-4.3c-1.72-3.28-4.87-6.94-13.22-15.34-6-6.07-11.84-12.3-12.91-13.85l-1.95-2.81.75-10.9c1.09-15.71 1.1-48.57 0-59.06l-.89-8.7-3.28-4.52c-5.86-8.08-5.8-7.75-6.22-33.27-.1-6.07-.38-11.5-.63-12.06-.83-1.87-3.05-2.66-8.54-3.05-8.86-.62-11-1.9-23.85-14.55-6.15-6-12.34-12-13.75-13.19-2.81-2.42-2.79-2-.56-9.63l1.35-4.65-1.69-3a32.22 32.22 0 0 0-2.59-4.07c-1.33-1.51-5.5-10.89-6-13.49a4.24 4.24 0 0 1 .87-3.9c2.23-2.86 3.4-5.68 4.45-10.73 2.33-11.19 7.74-26.09 10.6-29.22 3.18-3.47 7.7-1 9.41 5 1.34 4.79 1.37 9.79.1 18.55a101.2 101.2 0 0 0-1 11.11c0 4 .19 4.69 2.25 7.39 3.33 4.37 7.73 7.41 15.2 10.52a18.67 18.67 0 0 1 4.72 2.85c11.17 10.72 18.62 16.18 22.95 16.85 5.18.8 8 4.54 10 13.39 1.31 5.65 4 11.14 5.46 11.14a9.38 9.38 0 0 0 3.33-1.39c2-1.22 2.25-1.73 2.25-4.18a132.88 132.88 0 0 0-2-17.84c-.37-1.66-.78-4.06-.93-5.35s-.61-3.85-1-5.69c-2.55-11.16-3.65-15.46-4.1-16-1.55-2-4.08-10.2-4.93-15.92-1.64-11.11-4-14.23-12.91-17.39A43.15 43.15 0 0 1 165.24 78c-1.15-1-4-3.22-6.35-5.06s-4.41-3.53-4.6-3.76a22.7 22.7 0 0 0-2.69-2c-6.24-4.22-8.84-7-11.26-12l-2.44-5-.22-13-.22-13 6.91-6.55c3.95-3.75 8.48-7.35 10.59-8.43 3.31-1.69 4.45-1.89 11.37-2 8.53-.19 10.12 0 11.66 1.56s1.36 6.4-.29 8.5a6.66 6.66 0 0 0-1.34 2.32c0 .58-2.61 4.91-5.42 9a30.39 30.39 0 0 0-2.37 6.82c20.44 13.39 21.55 3.77 14.07 29L194 66.92c3.11-8.66 6.47-17.26 8.61-26.22.29-7.63-12-4.19-15.4-8.68-2.33-5.93 3.13-14.18 6.06-19.2 1.6-2.34 6.62-4.7 8.82-4.15.88.22 4.16-.35 7.37-1.28a45.3 45.3 0 0 1 7.55-1.68 29.57 29.57 0 0 0 6-1.29c3.65-1.11 4.5-1.17 6.35-.4a29.54 29.54 0 0 0 5.82 1.36 18.18 18.18 0 0 1 6 1.91 22.67 22.67 0 0 0 5 2.17c2.51.68 3 .57 7.05-1.67l4.35-2.4L268.32 5c10.44-.4 10.81-.47 15.26-2.68L288.16 0l2.46 1.43c1.76 1 3.14 2.73 4.85 6 2.36 4.51 2.38 4.58 1.37 7.37-.88 2.44-.89 3.3-.1 6.39a35.76 35.76 0 0 0 2.1 5.91 13.55 13.55 0 0 1 1.31 4c.31 4.33 0 5.3-2.41 6.92-2.17 1.47-7 7.91-7 9.34a14.77 14.77 0 0 1-1.07 3c-5 11.51-6.76 13.56-14.26 17-9.2 4.2-12.3 5.19-16.21 5.19-3.1 0-4 .25-4.54 1.26a18.33 18.33 0 0 1-4.09 3.71 13.62 13.62 0 0 0-4.38 4.78 5.89 5.89 0 0 1-2.49 2.91 6.88 6.88 0 0 0-2.45 1.71 67.62 67.62 0 0 1-7 5.38c-3.33 2.34-6.87 5-7.87 6A7.27 7.27 0 0 1 224 100a5.76 5.76 0 0 0-2.13 1.65c-1.31 1.39-1.49 2.11-1.14 4.6a36.45 36.45 0 0 0 1.42 5.88c1.32 3.8 1.31 7.86 0 10.57s-.89 6.65 1.35 9.59c2 2.63 2.16 4.56.71 8.84a33.45 33.45 0 0 0-1.06 8.91c0 4.88.22 6.28 1.46 8.38s1.82 2.48 3.24 2.32c2-.23 2.3-1.05 4.71-12.12 2.18-10 3.71-11.92 13.76-17.08 2.94-1.51 7.46-4 10-5.44s6.79-3.69 9.37-4.91a40.09 40.09 0 0 0 15.22-11.67c7.11-8.79 10-16.22 12.85-33.3a18.37 18.37 0 0 1 2.86-7.73 20.39 20.39 0 0 0 2.89-7.31c1-5.3 2.85-9.08 5.58-11.51 4.7-4.18 6-1.09 4.59 10.87-.46 3.86-1.1 10.33-1.44 14.38l-.61 7.36 4.45 4.09 4.45 4.09.11 8.42c.06 4.63.47 9.53.92 10.89l.82 2.47-6.43 6.28c-8.54 8.33-12.88 13.93-16.76 21.61-1.77 3.49-3.74 7.11-4.38 8-2.18 3.11-6.46 13-8.76 20.26l-2.29 7.22-7 6.49c-3.83 3.57-8 7.25-9.17 8.17-3.05 2.32-4.26 5.15-4.26 10a14.62 14.62 0 0 0 1.59 7.26 42 42 0 0 1 2.09 4.83 9.28 9.28 0 0 0 1.57 2.89c1.4 1.59 1.92 16.12.83 23.22-.68 4.48-3.63 12-4.7 12-1.79 0-4.06 9.27-5.07 20.74-.18 2-.62 5.94-1 8.7s-1 10-1.35 16.05c-.77 12.22-.19 18.77 2 23.15 3.41 6.69.52 12.69-11 22.84l-4 3.49.07 5.19a40.81 40.81 0 0 0 1.14 8.87c4.61 16 4.73 16.92 4.38 37.13-.46 26.4-.26 40.27.63 44.15a61.31 61.31 0 0 1 1.08 7c.17 2 .66 5.33 1.08 7.36.47 2.26.78 11 .79 22.74v19.06l-1.81 2.63c-2.71 3.91-15.11 13.54-15.49 12.29zm29.53-45.11c-.18-.3-.33-6.87-.33-14.59 0-14.06-.89-27.54-2.26-34.45-.4-2-.81-9.7-.9-17.06-.15-11.93-1.4-24.37-2.64-26.38-.66-1.07-3-17.66-3-21.3 0-4.23 1-6 5.28-9.13s4.86-3.14 5.48-.72c.28 1.1 1.45 5.62 2.6 10 3.93 15.12 4.14 16.27 4.05 21.74-.1 5.78-.13 6.13-1.74 17.73-1 7.07-1.17 12.39-1 28.43.17 19.4-.64 35.73-2 41.27-.71 2.78-2.8 5.48-3.43 4.43zm-71-37.58a101 101 0 0 1-1.73-10.79 100.5 100.5 0 0 0-1.73-10.79 37.53 37.53 0 0 1-1-6.49c-.31-3.19-.91-7.46-1.33-9.48-1-4.79-3.35-19.35-3.42-21.07 0-.74-.34-4.05-.7-7.36-.67-6.21-.84-27.67-.22-28.29 1-1 6.63 2.76 11.33 7.43l5.28 5.25-.45 6.47c-.25 3.56-.6 10.23-.78 14.83s-.49 9.87-.67 11.71-.61 9.36-.94 16.72c-.79 17.41-1.94 31.29-2.65 32a.62.62 0 0 1-1-.14zm-87.18-266.59c21.07 12.79 17.84 14.15 28.49 17.66 13 4.29 18.87 7.13 23.15 16.87C111.6 233.28 86.25 255 78.55 268c-31 52-6 101.59 62.75 87.21-14.18 29.23-78 28.63-98.68-4.9-24.68-39.95-22.09-118.3 61-187.66zm210.79 179c56.66 6.88 82.32-37.74 46.54-89.23 0 0-26.87-29.34-64.28-68 3-15.45 9.49-32.12 30.57-53.82 89.2 63.51 92 141.61 92.46 149.36 4.3 70.64-78.7 91.18-105.29 61.71z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMarkdown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M593.8 59.1H46.2C20.7 59.1 0 79.8 0 105.2v301.5c0 25.5 20.7 46.2 46.2 46.2h547.7c25.5 0 46.2-20.7 46.1-46.1V105.2c0-25.4-20.7-46.1-46.2-46.1zM338.5 360.6H277v-120l-61.5 76.9-61.5-76.9v120H92.3V151.4h61.5l61.5 76.9 61.5-76.9h61.5v209.2zm135.3 3.1L381.5 256H443V151.4h61.5V256H566z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMastodon(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M433 179.11c0-97.2-63.71-125.7-63.71-125.7-62.52-28.7-228.56-28.4-290.48 0 0 0-63.72 28.5-63.72 125.7 0 115.7-6.6 259.4 105.63 289.1 40.51 10.7 75.32 13 103.33 11.4 50.81-2.8 79.32-18.1 79.32-18.1l-1.7-36.9s-36.31 11.4-77.12 10.1c-40.41-1.4-83-4.4-89.63-54a102.54 102.54 0 0 1-.9-13.9c85.63 20.9 158.65 9.1 178.75 6.7 56.12-6.7 105-41.3 111.23-72.9 9.8-49.8 9-121.5 9-121.5zm-75.12 125.2h-46.63v-114.2c0-49.7-64-51.6-64 6.9v62.5h-46.33V197c0-58.5-64-56.6-64-6.9v114.2H90.19c0-122.1-5.2-147.9 18.41-175 25.9-28.9 79.82-30.8 103.83 6.1l11.6 19.5 11.6-19.5c24.11-37.1 78.12-34.8 103.83-6.1 23.71 27.3 18.4 53 18.4 175z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMaxcdn(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M461.1 442.7h-97.4L415.6 200c2.3-10.2.9-19.5-4.4-25.7-5-6.1-13.7-9.6-24.2-9.6h-49.3l-59.5 278h-97.4l59.5-278h-83.4l-59.5 278H0l59.5-278-44.6-95.4H387c39.4 0 75.3 16.3 98.3 44.9 23.3 28.6 31.8 67.4 23.6 105.9l-47.8 222.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMdb(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.37 160.41L7 352h43.91l5.59-79.83L84.43 352h44.71l25.54-77.43 4.79 77.43H205l-12.79-191.59H146.7L106 277.74 63.67 160.41zm281 0h-47.9V352h47.9s95 .8 94.2-95.79c-.78-94.21-94.18-95.78-94.18-95.78zm-1.2 146.46V204.78s46 4.27 46.8 50.57-46.78 51.54-46.78 51.54zm238.29-74.24a56.16 56.16 0 0 0 8-38.31c-5.34-35.76-55.08-34.32-55.08-34.32h-51.9v191.58H482s87 4.79 87-63.85c0-43.14-33.52-55.08-33.52-55.08zm-51.9-31.94s13.57-1.59 16 9.59c1.43 6.66-4 12-4 12h-12v-21.57zm-.1 109.46l.1-24.92V267h.08s41.58-4.73 41.19 22.43c-.33 25.65-41.35 20.74-41.35 20.74z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMedapps(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M118.3 238.4c3.5-12.5 6.9-33.6 13.2-33.6 8.3 1.8 9.6 23.4 18.6 36.6 4.6-23.5 5.3-85.1 14.1-86.7 9-.7 19.7 66.5 22 77.5 9.9 4.1 48.9 6.6 48.9 6.6 1.9 7.3-24 7.6-40 7.8-4.6 14.8-5.4 27.7-11.4 28-4.7.2-8.2-28.8-17.5-49.6l-9.4 65.5c-4.4 13-15.5-22.5-21.9-39.3-3.3-.1-62.4-1.6-47.6-7.8l31-5zM228 448c21.2 0 21.2-32 0-32H92c-21.2 0-21.2 32 0 32h136zm-24 64c21.2 0 21.2-32 0-32h-88c-21.2 0-21.2 32 0 32h88zm34.2-141.5c3.2-18.9 5.2-36.4 11.9-48.8 7.9-14.7 16.1-28.1 24-41 24.6-40.4 45.9-75.2 45.9-125.5C320 69.6 248.2 0 160 0S0 69.6 0 155.2c0 50.2 21.3 85.1 45.9 125.5 7.9 12.9 16 26.3 24 41 6.7 12.5 8.7 29.8 11.9 48.9 3.5 21 36.1 15.7 32.6-5.1-3.6-21.7-5.6-40.7-15.3-58.6C66.5 246.5 33 211.3 33 155.2 33 87.3 90 32 160 32s127 55.3 127 123.2c0 56.1-33.5 91.3-66.1 151.6-9.7 18-11.7 37.4-15.3 58.6-3.4 20.6 29 26.4 32.6 5.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMediumM(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M71.5 142.3c.6-5.9-1.7-11.8-6.1-15.8L20.3 72.1V64h140.2l108.4 237.7L364.2 64h133.7v8.1l-38.6 37c-3.3 2.5-5 6.7-4.3 10.8v272c-.7 4.1 1 8.3 4.3 10.8l37.7 37v8.1H307.3v-8.1l39.1-37.9c3.8-3.8 3.8-5 3.8-10.8V171.2L241.5 447.1h-14.7L100.4 171.2v184.9c-1.1 7.8 1.5 15.6 7 21.2l50.8 61.6v8.1h-144v-8L65 377.3c5.4-5.6 7.9-13.5 6.5-21.2V142.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMedium(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32v448h448V32H0zm372.2 106.1l-24 23c-2.1 1.6-3.1 4.2-2.7 6.7v169.3c-.4 2.6.6 5.2 2.7 6.7l23.5 23v5.1h-118V367l24.3-23.6c2.4-2.4 2.4-3.1 2.4-6.7V199.8l-67.6 171.6h-9.1L125 199.8v115c-.7 4.8 1 9.7 4.4 13.2l31.6 38.3v5.1H71.2v-5.1l31.6-38.3c3.4-3.5 4.9-8.4 4.1-13.2v-133c.4-3.7-1-7.3-3.8-9.8L75 138.1V133h87.3l67.4 148L289 133.1h83.2v5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMedrt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 544 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M113.7 256c0 121.8 83.9 222.8 193.5 241.1-18.7 4.5-38.2 6.9-58.2 6.9C111.4 504 0 393 0 256S111.4 8 248.9 8c20.1 0 39.6 2.4 58.2 6.9C197.5 33.2 113.7 134.2 113.7 256m297.4 100.3c-77.7 55.4-179.6 47.5-240.4-14.6 5.5 14.1 12.7 27.7 21.7 40.5 61.6 88.2 182.4 109.3 269.7 47 87.3-62.3 108.1-184.3 46.5-272.6-9-12.9-19.3-24.3-30.5-34.2 37.4 78.8 10.7 178.5-67 233.9m-218.8-244c-1.4 1-2.7 2.1-4 3.1 64.3-17.8 135.9 4 178.9 60.5 35.7 47 42.9 106.6 24.4 158 56.7-56.2 67.6-142.1 22.3-201.8-50-65.5-149.1-74.4-221.6-19.8M296 224c-4.4 0-8-3.6-8-8v-40c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v40c0 4.4-3.6 8-8 8h-40c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h40c4.4 0 8 3.6 8 8v40c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-40c0-4.4 3.6-8 8-8h40c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-40z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMeetup(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M99 414.3c1.1 5.7-2.3 11.1-8 12.3-5.4 1.1-10.9-2.3-12-8-1.1-5.4 2.3-11.1 7.7-12.3 5.4-1.2 11.1 2.3 12.3 8zm143.1 71.4c-6.3 4.6-8 13.4-3.7 20 4.6 6.6 13.4 8.3 20 3.7 6.3-4.6 8-13.4 3.4-20-4.2-6.5-13.1-8.3-19.7-3.7zm-86-462.3c6.3-1.4 10.3-7.7 8.9-14-1.1-6.6-7.4-10.6-13.7-9.1-6.3 1.4-10.3 7.7-9.1 14 1.4 6.6 7.6 10.6 13.9 9.1zM34.4 226.3c-10-6.9-23.7-4.3-30.6 6-6.9 10-4.3 24 5.7 30.9 10 7.1 23.7 4.6 30.6-5.7 6.9-10.4 4.3-24.1-5.7-31.2zm272-170.9c10.6-6.3 13.7-20 7.7-30.3-6.3-10.6-19.7-14-30-7.7s-13.7 20-7.4 30.6c6 10.3 19.4 13.7 29.7 7.4zm-191.1 58c7.7-5.4 9.4-16 4.3-23.7s-15.7-9.4-23.1-4.3c-7.7 5.4-9.4 16-4.3 23.7 5.1 7.8 15.6 9.5 23.1 4.3zm372.3 156c-7.4 1.7-12.3 9.1-10.6 16.9 1.4 7.4 8.9 12.3 16.3 10.6 7.4-1.4 12.3-8.9 10.6-16.6-1.5-7.4-8.9-12.3-16.3-10.9zm39.7-56.8c-1.1-5.7-6.6-9.1-12-8-5.7 1.1-9.1 6.9-8 12.6 1.1 5.4 6.6 9.1 12.3 8 5.4-1.5 9.1-6.9 7.7-12.6zM447 138.9c-8.6 6-10.6 17.7-4.9 26.3 5.7 8.6 17.4 10.6 26 4.9 8.3-6 10.3-17.7 4.6-26.3-5.7-8.7-17.4-10.9-25.7-4.9zm-6.3 139.4c26.3 43.1 15.1 100-26.3 129.1-17.4 12.3-37.1 17.7-56.9 17.1-12 47.1-69.4 64.6-105.1 32.6-1.1.9-2.6 1.7-3.7 2.9-39.1 27.1-92.3 17.4-119.4-22.3-9.7-14.3-14.6-30.6-15.1-46.9-65.4-10.9-90-94-41.1-139.7-28.3-46.9.6-107.4 53.4-114.9C151.6 70 234.1 38.6 290.1 82c67.4-22.3 136.3 29.4 130.9 101.1 41.1 12.6 52.8 66.9 19.7 95.2zm-70 74.3c-3.1-20.6-40.9-4.6-43.1-27.1-3.1-32 43.7-101.1 40-128-3.4-24-19.4-29.1-33.4-29.4-13.4-.3-16.9 2-21.4 4.6-2.9 1.7-6.6 4.9-11.7-.3-6.3-6-11.1-11.7-19.4-12.9-12.3-2-17.7 2-26.6 9.7-3.4 2.9-12 12.9-20 9.1-3.4-1.7-15.4-7.7-24-11.4-16.3-7.1-40 4.6-48.6 20-12.9 22.9-38 113.1-41.7 125.1-8.6 26.6 10.9 48.6 36.9 47.1 11.1-.6 18.3-4.6 25.4-17.4 4-7.4 41.7-107.7 44.6-112.6 2-3.4 8.9-8 14.6-5.1 5.7 3.1 6.9 9.4 6 15.1-1.1 9.7-28 70.9-28.9 77.7-3.4 22.9 26.9 26.6 38.6 4 3.7-7.1 45.7-92.6 49.4-98.3 4.3-6.3 7.4-8.3 11.7-8 3.1 0 8.3.9 7.1 10.9-1.4 9.4-35.1 72.3-38.9 87.7-4.6 20.6 6.6 41.4 24.9 50.6 11.4 5.7 62.5 15.7 58.5-11.1zm5.7 92.3c-10.3 7.4-12.9 22-5.7 32.6 7.1 10.6 21.4 13.1 32 6 10.6-7.4 13.1-22 6-32.6-7.4-10.6-21.7-13.5-32.3-6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMegaport(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M214.5 209.6v66.2l33.5 33.5 33.3-33.3v-66.4l-33.4-33.4zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm145.1 414.4L367 441.6l-26-19.2v-65.5l-33.4-33.4-33.4 33.4v65.5L248 441.6l-26.1-19.2v-65.5l-33.4-33.4-33.5 33.4v65.5l-26.1 19.2-26.1-19.2v-87l59.5-59.5V188l59.5-59.5V52.9l26.1-19.2L274 52.9v75.6l59.5 59.5v87.6l59.7 59.7v87.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMendeley(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624.6 325.2c-12.3-12.4-29.7-19.2-48.4-17.2-43.3-1-49.7-34.9-37.5-98.8 22.8-57.5-14.9-131.5-87.4-130.8-77.4.7-81.7 82-130.9 82-48.1 0-54-81.3-130.9-82-72.9-.8-110.1 73.3-87.4 130.8 12.2 63.9 5.8 97.8-37.5 98.8-21.2-2.3-37 6.5-53 22.5-19.9 19.7-19.3 94.8 42.6 102.6 47.1 5.9 81.6-42.9 61.2-87.8-47.3-103.7 185.9-106.1 146.5-8.2-.1.1-.2.2-.3.4-26.8 42.8 6.8 97.4 58.8 95.2 52.1 2.1 85.4-52.6 58.8-95.2-.1-.2-.2-.3-.3-.4-39.4-97.9 193.8-95.5 146.5 8.2-4.6 10-6.7 21.3-5.7 33 4.9 53.4 68.7 74.1 104.9 35.2 17.8-14.8 23.1-65.6 0-88.3zm-303.9-19.1h-.6c-43.4 0-62.8-37.5-62.8-62.8 0-34.7 28.2-62.8 62.8-62.8h.6c34.7 0 62.8 28.1 62.8 62.8 0 25-19.2 62.8-62.8 62.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMicroblog(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M399.36,362.23c29.49-34.69,47.1-78.34,47.1-125.79C446.46,123.49,346.86,32,224,32S1.54,123.49,1.54,236.44,101.14,440.87,224,440.87a239.28,239.28,0,0,0,79.44-13.44,7.18,7.18,0,0,1,8.12,2.56c18.58,25.09,47.61,42.74,79.89,49.92a4.42,4.42,0,0,0,5.22-3.43,4.37,4.37,0,0,0-.85-3.62,87,87,0,0,1,3.69-110.69ZM329.52,212.4l-57.3,43.49L293,324.75a6.5,6.5,0,0,1-9.94,7.22L224,290.92,164.94,332a6.51,6.51,0,0,1-9.95-7.22l20.79-68.86-57.3-43.49a6.5,6.5,0,0,1,3.8-11.68l71.88-1.51,23.66-67.92a6.5,6.5,0,0,1,12.28,0l23.66,67.92,71.88,1.51a6.5,6.5,0,0,1,3.88,11.68Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMicrosoft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32h214.6v214.6H0V32zm233.4 0H448v214.6H233.4V32zM0 265.4h214.6V480H0V265.4zm233.4 0H448V480H233.4V265.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMix(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64v348.9c0 56.2 88 58.1 88 0V174.3c7.9-52.9 88-50.4 88 6.5v175.3c0 57.9 96 58 96 0V240c5.3-54.7 88-52.5 88 4.3v23.8c0 59.9 88 56.6 88 0V64H0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMixcloud(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M424.43 219.729C416.124 134.727 344.135 68 256.919 68c-72.266 0-136.224 46.516-159.205 114.074-54.545 8.029-96.63 54.822-96.63 111.582 0 62.298 50.668 112.966 113.243 112.966h289.614c52.329 0 94.969-42.362 94.969-94.693 0-45.131-32.118-83.063-74.48-92.2zm-20.489 144.53H114.327c-39.04 0-70.881-31.564-70.881-70.604s31.841-70.604 70.881-70.604c18.827 0 36.548 7.475 49.838 20.766 19.963 19.963 50.133-10.227 30.18-30.18-14.675-14.398-32.672-24.365-52.053-29.349 19.935-44.3 64.79-73.926 114.628-73.926 69.496 0 125.979 56.483 125.979 125.702 0 13.568-2.215 26.857-6.369 39.594-8.943 27.517 32.133 38.939 40.147 13.29 2.769-8.306 4.984-16.889 6.369-25.472 19.381 7.476 33.502 26.303 33.502 48.453 0 28.795-23.535 52.33-52.607 52.33zm235.069-52.33c0 44.024-12.737 86.386-37.102 122.657-4.153 6.092-10.798 9.414-17.72 9.414-16.317 0-27.127-18.826-17.443-32.949 19.381-29.349 29.903-63.682 29.903-99.122s-10.521-69.773-29.903-98.845c-15.655-22.831 19.361-47.24 35.163-23.534 24.366 35.993 37.102 78.356 37.102 122.379zm-70.88 0c0 31.565-9.137 62.021-26.857 88.325-4.153 6.091-10.798 9.136-17.72 9.136-17.201 0-27.022-18.979-17.443-32.948 13.013-19.104 19.658-41.255 19.658-64.513 0-22.981-6.645-45.408-19.658-64.512-15.761-22.986 19.008-47.095 35.163-23.535 17.719 26.026 26.857 56.483 26.857 88.047z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMixer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M114.57,76.07a45.71,45.71,0,0,0-67.51-6.41c-17.58,16.18-19,43.52-4.75,62.77l91.78,123L41.76,379.58c-14.23,19.25-13.11,46.59,4.74,62.77A45.71,45.71,0,0,0,114,435.94L242.89,262.7a12.14,12.14,0,0,0,0-14.23ZM470.24,379.58,377.91,255.45l91.78-123c14.22-19.25,12.83-46.59-4.75-62.77a45.71,45.71,0,0,0-67.51,6.41l-128,172.12a12.14,12.14,0,0,0,0,14.23L398,435.94a45.71,45.71,0,0,0,67.51,6.41C483.35,426.17,484.47,398.83,470.24,379.58Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMizuni(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119.1 0 256c0 137 111 248 248 248s248-111 248-248C496 119.1 385 8 248 8zm-80 351.9c-31.4 10.6-58.8 27.3-80 48.2V136c0-22.1 17.9-40 40-40s40 17.9 40 40v223.9zm120-9.9c-12.9-2-26.2-3.1-39.8-3.1-13.8 0-27.2 1.1-40.2 3.1V136c0-22.1 17.9-40 40-40s40 17.9 40 40v214zm120 57.7c-21.2-20.8-48.6-37.4-80-48V136c0-22.1 17.9-40 40-40s40 17.9 40 40v271.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaModx(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M356 241.8l36.7 23.7V480l-133-83.8L356 241.8zM440 75H226.3l-23 37.8 153.5 96.5L440 75zm-89 142.8L55.2 32v214.5l46 29L351 217.8zM97 294.2L8 437h213.7l125-200.5L97 294.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMonero(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 384h108.4C417 455.9 338.1 504 248 504S79 455.9 35.6 384H144V256.2L248 361l104-105v128zM88 336V128l159.4 159.4L408 128v208h74.8c8.5-25.1 13.2-52 13.2-80C496 119 385 8 248 8S0 119 0 256c0 28 4.6 54.9 13.2 80H88z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaNapster(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M298.3 373.6c-14.2 13.6-31.3 24.1-50.4 30.5-19-6.4-36.2-16.9-50.3-30.5h100.7zm44-199.6c20-16.9 43.6-29.2 69.6-36.2V299c0 219.4-328 217.6-328 .3V137.7c25.9 6.9 49.6 19.6 69.5 36.4 56.8-40 132.5-39.9 188.9-.1zm-208.8-58.5c64.4-60 164.3-60.1 228.9-.2-7.1 3.5-13.9 7.3-20.6 11.5-58.7-30.5-129.2-30.4-187.9.1-6.3-4-13.9-8.2-20.4-11.4zM43.8 93.2v69.3c-58.4 36.5-58.4 121.1.1 158.3 26.4 245.1 381.7 240.3 407.6 1.5l.3-1.7c58.7-36.3 58.9-121.7.2-158.2V93.2c-17.3.5-34 3-50.1 7.4-82-91.5-225.5-91.5-307.5.1-16.3-4.4-33.1-7-50.6-7.5zM259.2 352s36-.3 61.3-1.5c10.2-.5 21.1-4 25.5-6.5 26.3-15.1 25.4-39.2 26.2-47.4-79.5-.6-99.9-3.9-113 55.4zm-135.5-55.3c.8 8.2-.1 32.3 26.2 47.4 4.4 2.5 15.2 6 25.5 6.5 25.3 1.1 61.3 1.5 61.3 1.5-13.2-59.4-33.7-56.1-113-55.4zm169.1 123.4c-3.2-5.3-6.9-7.3-6.9-7.3-24.8 7.3-52.2 6.9-75.9 0 0 0-2.9 1.5-6.4 6.6-2.8 4.1-3.7 9.6-3.7 9.6 29.1 17.6 67.1 17.6 96.2 0-.1-.1-.3-4-3.3-8.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaNeos(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M415.44 512h-95.11L212.12 357.46v91.1L125.69 512H28V29.82L68.47 0h108.05l123.74 176.13V63.45L386.69 0h97.69v461.5zM38.77 35.27V496l72-52.88V194l215.5 307.64h84.79l52.35-38.17h-78.27L69 13zm82.54 466.61l80-58.78v-101l-79.76-114.4v220.94L49 501.89h72.34zM80.63 10.77l310.6 442.57h82.37V10.77h-79.75v317.56L170.91 10.77zM311 191.65l72 102.81V15.93l-72 53v122.72z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaNimblr(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M246.6 299.29c15.57 0 27.15 11.46 27.15 27s-11.62 27-27.15 27c-15.7 0-27.15-11.57-27.15-27s11.55-27 27.15-27zM113 326.25c0-15.61 11.68-27 27.15-27s27.15 11.46 27.15 27-11.47 27-27.15 27c-15.44 0-27.15-11.31-27.15-27M191.76 159C157 159 89.45 178.77 59.25 227L14 0v335.48C14 433.13 93.61 512 191.76 512s177.76-78.95 177.76-176.52S290.13 159 191.76 159zm0 308.12c-73.27 0-132.51-58.9-132.51-131.59s59.24-131.59 132.51-131.59 132.51 58.86 132.51 131.54S265 467.07 191.76 467.07z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaNodeJs(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 508c-6.7 0-13.5-1.8-19.4-5.2l-61.7-36.5c-9.2-5.2-4.7-7-1.7-8 12.3-4.3 14.8-5.2 27.9-12.7 1.4-.8 3.2-.5 4.6.4l47.4 28.1c1.7 1 4.1 1 5.7 0l184.7-106.6c1.7-1 2.8-3 2.8-5V149.3c0-2.1-1.1-4-2.9-5.1L226.8 37.7c-1.7-1-4-1-5.7 0L36.6 144.3c-1.8 1-2.9 3-2.9 5.1v213.1c0 2 1.1 4 2.9 4.9l50.6 29.2c27.5 13.7 44.3-2.4 44.3-18.7V167.5c0-3 2.4-5.3 5.4-5.3h23.4c2.9 0 5.4 2.3 5.4 5.3V378c0 36.6-20 57.6-54.7 57.6-10.7 0-19.1 0-42.5-11.6l-48.4-27.9C8.1 389.2.7 376.3.7 362.4V149.3c0-13.8 7.4-26.8 19.4-33.7L204.6 9c11.7-6.6 27.2-6.6 38.8 0l184.7 106.7c12 6.9 19.4 19.8 19.4 33.7v213.1c0 13.8-7.4 26.7-19.4 33.7L243.4 502.8c-5.9 3.4-12.6 5.2-19.4 5.2zm149.1-210.1c0-39.9-27-50.5-83.7-58-57.4-7.6-63.2-11.5-63.2-24.9 0-11.1 4.9-25.9 47.4-25.9 37.9 0 51.9 8.2 57.7 33.8.5 2.4 2.7 4.2 5.2 4.2h24c1.5 0 2.9-.6 3.9-1.7s1.5-2.6 1.4-4.1c-3.7-44.1-33-64.6-92.2-64.6-52.7 0-84.1 22.2-84.1 59.5 0 40.4 31.3 51.6 81.8 56.6 60.5 5.9 65.2 14.8 65.2 26.7 0 20.6-16.6 29.4-55.5 29.4-48.9 0-59.6-12.3-63.2-36.6-.4-2.6-2.6-4.5-5.3-4.5h-23.9c-3 0-5.3 2.4-5.3 5.3 0 31.1 16.9 68.2 97.8 68.2 58.4-.1 92-23.2 92-63.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaNode(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M316.3 452c-2.1 0-4.2-.6-6.1-1.6L291 439c-2.9-1.6-1.5-2.2-.5-2.5 3.8-1.3 4.6-1.6 8.7-4 .4-.2 1-.1 1.4.1l14.8 8.8c.5.3 1.3.3 1.8 0L375 408c.5-.3.9-.9.9-1.6v-66.7c0-.7-.3-1.3-.9-1.6l-57.8-33.3c-.5-.3-1.2-.3-1.8 0l-57.8 33.3c-.6.3-.9 1-.9 1.6v66.7c0 .6.4 1.2.9 1.5l15.8 9.1c8.6 4.3 13.9-.8 13.9-5.8v-65.9c0-.9.7-1.7 1.7-1.7h7.3c.9 0 1.7.7 1.7 1.7v65.9c0 11.5-6.2 18-17.1 18-3.3 0-6 0-13.3-3.6l-15.2-8.7c-3.7-2.2-6.1-6.2-6.1-10.5v-66.7c0-4.3 2.3-8.4 6.1-10.5l57.8-33.4c3.7-2.1 8.5-2.1 12.1 0l57.8 33.4c3.7 2.2 6.1 6.2 6.1 10.5v66.7c0 4.3-2.3 8.4-6.1 10.5l-57.8 33.4c-1.7 1.1-3.8 1.7-6 1.7zm46.7-65.8c0-12.5-8.4-15.8-26.2-18.2-18-2.4-19.8-3.6-19.8-7.8 0-3.5 1.5-8.1 14.8-8.1 11.9 0 16.3 2.6 18.1 10.6.2.8.8 1.3 1.6 1.3h7.5c.5 0 .9-.2 1.2-.5.3-.4.5-.8.4-1.3-1.2-13.8-10.3-20.2-28.8-20.2-16.5 0-26.3 7-26.3 18.6 0 12.7 9.8 16.1 25.6 17.7 18.9 1.9 20.4 4.6 20.4 8.3 0 6.5-5.2 9.2-17.4 9.2-15.3 0-18.7-3.8-19.8-11.4-.1-.8-.8-1.4-1.7-1.4h-7.5c-.9 0-1.7.7-1.7 1.7 0 9.7 5.3 21.3 30.6 21.3 18.5 0 29-7.2 29-19.8zm54.5-50.1c0 6.1-5 11.1-11.1 11.1s-11.1-5-11.1-11.1c0-6.3 5.2-11.1 11.1-11.1 6-.1 11.1 4.8 11.1 11.1zm-1.8 0c0-5.2-4.2-9.3-9.4-9.3-5.1 0-9.3 4.1-9.3 9.3 0 5.2 4.2 9.4 9.3 9.4 5.2-.1 9.4-4.3 9.4-9.4zm-4.5 6.2h-2.6c-.1-.6-.5-3.8-.5-3.9-.2-.7-.4-1.1-1.3-1.1h-2.2v5h-2.4v-12.5h4.3c1.5 0 4.4 0 4.4 3.3 0 2.3-1.5 2.8-2.4 3.1 1.7.1 1.8 1.2 2.1 2.8.1 1 .3 2.7.6 3.3zm-2.8-8.8c0-1.7-1.2-1.7-1.8-1.7h-2v3.5h1.9c1.6 0 1.9-1.1 1.9-1.8zM137.3 191c0-2.7-1.4-5.1-3.7-6.4l-61.3-35.3c-1-.6-2.2-.9-3.4-1h-.6c-1.2 0-2.3.4-3.4 1L3.7 184.6C1.4 185.9 0 188.4 0 191l.1 95c0 1.3.7 2.5 1.8 3.2 1.1.7 2.5.7 3.7 0L42 268.3c2.3-1.4 3.7-3.8 3.7-6.4v-44.4c0-2.6 1.4-5.1 3.7-6.4l15.5-8.9c1.2-.7 2.4-1 3.7-1 1.3 0 2.6.3 3.7 1l15.5 8.9c2.3 1.3 3.7 3.8 3.7 6.4v44.4c0 2.6 1.4 5.1 3.7 6.4l36.4 20.9c1.1.7 2.6.7 3.7 0 1.1-.6 1.8-1.9 1.8-3.2l.2-95zM472.5 87.3v176.4c0 2.6-1.4 5.1-3.7 6.4l-61.3 35.4c-2.3 1.3-5.1 1.3-7.4 0l-61.3-35.4c-2.3-1.3-3.7-3.8-3.7-6.4v-70.8c0-2.6 1.4-5.1 3.7-6.4l61.3-35.4c2.3-1.3 5.1-1.3 7.4 0l15.3 8.8c1.7 1 3.9-.3 3.9-2.2v-94c0-2.8 3-4.6 5.5-3.2l36.5 20.4c2.3 1.2 3.8 3.7 3.8 6.4zm-46 128.9c0-.7-.4-1.3-.9-1.6l-21-12.2c-.6-.3-1.3-.3-1.9 0l-21 12.2c-.6.3-.9.9-.9 1.6v24.3c0 .7.4 1.3.9 1.6l21 12.1c.6.3 1.3.3 1.8 0l21-12.1c.6-.3.9-.9.9-1.6v-24.3zm209.8-.7c2.3-1.3 3.7-3.8 3.7-6.4V192c0-2.6-1.4-5.1-3.7-6.4l-60.9-35.4c-2.3-1.3-5.1-1.3-7.4 0l-61.3 35.4c-2.3 1.3-3.7 3.8-3.7 6.4v70.8c0 2.7 1.4 5.1 3.7 6.4l60.9 34.7c2.2 1.3 5 1.3 7.3 0l36.8-20.5c2.5-1.4 2.5-5 0-6.4L550 241.6c-1.2-.7-1.9-1.9-1.9-3.2v-22.2c0-1.3.7-2.5 1.9-3.2l19.2-11.1c1.1-.7 2.6-.7 3.7 0l19.2 11.1c1.1.7 1.9 1.9 1.9 3.2v17.4c0 2.8 3.1 4.6 5.6 3.2l36.7-21.3zM559 219c-.4.3-.7.7-.7 1.2v13.6c0 .5.3 1 .7 1.2l11.8 6.8c.4.3 1 .3 1.4 0L584 235c.4-.3.7-.7.7-1.2v-13.6c0-.5-.3-1-.7-1.2l-11.8-6.8c-.4-.3-1-.3-1.4 0L559 219zm-254.2 43.5v-70.4c0-2.6-1.6-5.1-3.9-6.4l-61.1-35.2c-2.1-1.2-5-1.4-7.4 0l-61.1 35.2c-2.3 1.3-3.9 3.7-3.9 6.4v70.4c0 2.8 1.9 5.2 4 6.4l61.2 35.2c2.4 1.4 5.2 1.3 7.4 0l61-35.2c1.8-1 3.1-2.7 3.6-4.7.1-.5.2-1.1.2-1.7zm-74.3-124.9l-.8.5h1.1l-.3-.5zm76.2 130.2l-.4-.7v.9l.4-.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaNpm(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 288h-32v-64h32v64zm288-128v192H288v32H160v-32H0V160h576zm-416 32H32v128h64v-96h32v96h32V192zm160 0H192v160h64v-32h64V192zm224 0H352v128h64v-96h32v96h32v-96h32v96h32V192z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaNs8(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M104.324,269.172h26.067V242.994H104.324Zm52.466-26.178-.055-26.178v-.941a39.325,39.325,0,0,0-78.644.941v.166h26.4v-.166a12.98,12.98,0,0,1,25.956,0v26.178Zm52.356,25.846a91.1,91.1,0,0,1-91.1,91.1h-.609a91.1,91.1,0,0,1-91.1-91.1H0v.166A117.33,117.33,0,0,0,117.44,386.28h.775A117.331,117.331,0,0,0,235.49,268.84V242.828H209.146Zm-157.233,0a65.362,65.362,0,0,0,130.723,0H156.292a39.023,39.023,0,0,1-78.035,0V242.883H51.968v-26.62A65.42,65.42,0,0,1,182.8,217.48v25.293h26.344V217.48a91.761,91.761,0,0,0-183.522,0v25.4H51.913Zm418.4-71.173c13.67,0,24.573,6.642,30.052,18.264l.719,1.549,23.245-11.511-.609-1.439c-8.025-19.26-28.5-31.27-53.407-31.27-23.134,0-43.611,11.4-50.972,28.447-.123,26.876-.158,23.9,0,24.85,4.7,11.013,14.555,19.37,28.668,24.241a102.033,102.033,0,0,0,19.813,3.984c5.479.72,10.626,1.384,15.829,3.1,6.364,2.1,10.46,5.257,12.84,9.851v9.851c-3.708,7.527-13.781,12.342-25.791,12.342-14.334,0-25.956-6.918-31.933-19.039l-.72-1.494L415.026,280.9l.553,1.439c7.915,19.426,29.609,32.044,55.289,32.044,23.632,0,44.608-11.4,52.3-28.447l.166-25.9-.166-.664c-4.87-11.014-15.219-19.647-28.944-24.241-7.693-2.712-14.335-3.6-20.7-4.427a83.777,83.777,0,0,1-14.832-2.878c-6.31-1.937-10.4-5.092-12.619-9.63v-8.412C449.45,202.427,458.969,197.667,470.315,197.667ZM287.568,311.344h26.067v-68.4H287.568Zm352.266-53.3c-2.933-6.254-8.3-12.01-15.441-16.714A37.99,37.99,0,0,0,637.4,226l.166-25.347-.166-.664C630.038,184,610.667,173.26,589.25,173.26S548.461,184,541.1,199.992l-.166,25.347.166.664a39.643,39.643,0,0,0,13.006,15.331c-7.2,4.7-12.508,10.46-15.441,16.714l-.166,28.889.166.72c7.582,15.994,27.893,26.731,50.585,26.731s43.057-10.737,50.584-26.731l.166-28.89Zm-73.22-50.806c3.6-6.31,12.563-10.516,22.58-10.516s19.038,4.206,22.636,10.516v13.725c-3.542,6.2-12.563,10.349-22.636,10.349s-19.094-4.15-22.58-10.349Zm47.319,72.169c-3.764,6.641-13.338,10.9-24.683,10.9-11.125,0-20.976-4.372-24.684-10.9V263.25c3.708-6.309,13.5-10.515,24.684-10.515,11.345,0,20.919,4.15,24.683,10.515ZM376.4,265.962l-59.827-89.713h-29v40.623h26.51v.387l62.539,94.085H402.3V176.249H376.4Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaNutritionix(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 400 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M88 8.1S221.4-.1 209 112.5c0 0 19.1-74.9 103-40.6 0 0-17.7 74-88 56 0 0 14.6-54.6 66.1-56.6 0 0-39.9-10.3-82.1 48.8 0 0-19.8-94.5-93.6-99.7 0 0 75.2 19.4 77.6 107.5 0 .1-106.4 7-104-119.8zm312 315.6c0 48.5-9.7 95.3-32 132.3-42.2 30.9-105 48-168 48-62.9 0-125.8-17.1-168-48C9.7 419 0 372.2 0 323.7 0 275.3 17.7 229 40 192c42.2-30.9 97.1-48.6 160-48.6 63 0 117.8 17.6 160 48.6 22.3 37 40 83.3 40 131.7zM120 428c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zM192 428c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zM264 428c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zM336 428c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm24-39.6c-4.8-22.3-7.4-36.9-16-56-38.8-19.9-90.5-32-144-32S94.8 180.1 56 200c-8.8 19.5-11.2 33.9-16 56 42.2-7.9 98.7-14.8 160-14.8s117.8 6.9 160 14.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaOctopusDeploy(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M455.6,349.2c-45.891-39.09-36.67-77.877-16.095-128.11C475.16,134.04,415.967,34.14,329.93,8.3,237.04-19.6,134.252,24.341,99.677,117.147a180.862,180.862,0,0,0-10.988,73.544c1.733,29.543,14.717,52.97,24.09,80.3,17.2,50.161-28.1,92.743-66.662,117.582-46.806,30.2-36.319,39.857-8.428,41.858,23.378,1.68,44.478-4.548,65.265-15.045,9.2-4.647,40.687-18.931,45.13-28.588C135.9,413.388,111.122,459.5,126.621,488.9c19.1,36.229,67.112-31.77,76.709-45.812,8.591-12.572,42.963-81.279,63.627-46.926,18.865,31.361,8.6,76.391,35.738,104.622,32.854,34.2,51.155-18.312,51.412-44.221.163-16.411-6.1-95.852,29.9-59.944C405.428,418,436.912,467.8,472.568,463.642c38.736-4.516-22.123-67.967-28.262-78.695,5.393,4.279,53.665,34.128,53.818,9.52C498.234,375.678,468.039,359.8,455.6,349.2Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaOdnoklassnikiSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M184.2 177.1c0-22.1 17.9-40 39.8-40s39.8 17.9 39.8 40c0 22-17.9 39.8-39.8 39.8s-39.8-17.9-39.8-39.8zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-305.1 97.1c0 44.6 36.4 80.9 81.1 80.9s81.1-36.2 81.1-80.9c0-44.8-36.4-81.1-81.1-81.1s-81.1 36.2-81.1 81.1zm174.5 90.7c-4.6-9.1-17.3-16.8-34.1-3.6 0 0-22.7 18-59.3 18s-59.3-18-59.3-18c-16.8-13.2-29.5-5.5-34.1 3.6-7.9 16.1 1.1 23.7 21.4 37 17.3 11.1 41.2 15.2 56.6 16.8l-12.9 12.9c-18.2 18-35.5 35.5-47.7 47.7-17.6 17.6 10.7 45.8 28.4 28.6l47.7-47.9c18.2 18.2 35.7 35.7 47.7 47.9 17.6 17.2 46-10.7 28.6-28.6l-47.7-47.7-13-12.9c15.5-1.6 39.1-5.9 56.2-16.8 20.4-13.3 29.3-21 21.5-37z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaOdnoklassniki(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M275.1 334c-27.4 17.4-65.1 24.3-90 26.9l20.9 20.6 76.3 76.3c27.9 28.6-17.5 73.3-45.7 45.7-19.1-19.4-47.1-47.4-76.3-76.6L84 503.4c-28.2 27.5-73.6-17.6-45.4-45.7 19.4-19.4 47.1-47.4 76.3-76.3l20.6-20.6c-24.6-2.6-62.9-9.1-90.6-26.9-32.6-21-46.9-33.3-34.3-59 7.4-14.6 27.7-26.9 54.6-5.7 0 0 36.3 28.9 94.9 28.9s94.9-28.9 94.9-28.9c26.9-21.1 47.1-8.9 54.6 5.7 12.4 25.7-1.9 38-34.5 59.1zM30.3 129.7C30.3 58 88.6 0 160 0s129.7 58 129.7 129.7c0 71.4-58.3 129.4-129.7 129.4s-129.7-58-129.7-129.4zm66 0c0 35.1 28.6 63.7 63.7 63.7s63.7-28.6 63.7-63.7c0-35.4-28.6-64-63.7-64s-63.7 28.6-63.7 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaOldRepublic(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M235.76 10.23c7.5-.31 15-.28 22.5-.09 3.61.14 7.2.4 10.79.73 4.92.27 9.79 1.03 14.67 1.62 2.93.43 5.83.98 8.75 1.46 7.9 1.33 15.67 3.28 23.39 5.4 12.24 3.47 24.19 7.92 35.76 13.21 26.56 12.24 50.94 29.21 71.63 49.88 20.03 20.09 36.72 43.55 48.89 69.19 1.13 2.59 2.44 5.1 3.47 7.74 2.81 6.43 5.39 12.97 7.58 19.63 4.14 12.33 7.34 24.99 9.42 37.83.57 3.14 1.04 6.3 1.4 9.47.55 3.83.94 7.69 1.18 11.56.83 8.34.84 16.73.77 25.1-.07 4.97-.26 9.94-.75 14.89-.24 3.38-.51 6.76-.98 10.12-.39 2.72-.63 5.46-1.11 8.17-.9 5.15-1.7 10.31-2.87 15.41-4.1 18.5-10.3 36.55-18.51 53.63-15.77 32.83-38.83 62.17-67.12 85.12a246.503 246.503 0 0 1-56.91 34.86c-6.21 2.68-12.46 5.25-18.87 7.41-3.51 1.16-7.01 2.38-10.57 3.39-6.62 1.88-13.29 3.64-20.04 5-4.66.91-9.34 1.73-14.03 2.48-5.25.66-10.5 1.44-15.79 1.74-6.69.66-13.41.84-20.12.81-6.82.03-13.65-.12-20.45-.79-3.29-.23-6.57-.5-9.83-.95-2.72-.39-5.46-.63-8.17-1.11-4.12-.72-8.25-1.37-12.35-2.22-4.25-.94-8.49-1.89-12.69-3.02-8.63-2.17-17.08-5.01-25.41-8.13-10.49-4.12-20.79-8.75-30.64-14.25-2.14-1.15-4.28-2.29-6.35-3.57-11.22-6.58-21.86-14.1-31.92-22.34-34.68-28.41-61.41-66.43-76.35-108.7-3.09-8.74-5.71-17.65-7.8-26.68-1.48-6.16-2.52-12.42-3.58-18.66-.4-2.35-.61-4.73-.95-7.09-.6-3.96-.75-7.96-1.17-11.94-.8-9.47-.71-18.99-.51-28.49.14-3.51.34-7.01.7-10.51.31-3.17.46-6.37.92-9.52.41-2.81.65-5.65 1.16-8.44.7-3.94 1.3-7.9 2.12-11.82 3.43-16.52 8.47-32.73 15.26-48.18 1.15-2.92 2.59-5.72 3.86-8.59 8.05-16.71 17.9-32.56 29.49-47.06 20-25.38 45.1-46.68 73.27-62.47 7.5-4.15 15.16-8.05 23.07-11.37 15.82-6.88 32.41-11.95 49.31-15.38 3.51-.67 7.04-1.24 10.56-1.85 2.62-.47 5.28-.7 7.91-1.08 3.53-.53 7.1-.68 10.65-1.04 2.46-.24 4.91-.36 7.36-.51m8.64 24.41c-9.23.1-18.43.99-27.57 2.23-7.3 1.08-14.53 2.6-21.71 4.3-13.91 3.5-27.48 8.34-40.46 14.42-10.46 4.99-20.59 10.7-30.18 17.22-4.18 2.92-8.4 5.8-12.34 9.03-5.08 3.97-9.98 8.17-14.68 12.59-2.51 2.24-4.81 4.7-7.22 7.06-28.22 28.79-48.44 65.39-57.5 104.69-2.04 8.44-3.54 17.02-4.44 25.65-1.1 8.89-1.44 17.85-1.41 26.8.11 7.14.38 14.28 1.22 21.37.62 7.12 1.87 14.16 3.2 21.18 1.07 4.65 2.03 9.32 3.33 13.91 6.29 23.38 16.5 45.7 30.07 65.75 8.64 12.98 18.78 24.93 29.98 35.77 16.28 15.82 35.05 29.04 55.34 39.22 7.28 3.52 14.66 6.87 22.27 9.63 5.04 1.76 10.06 3.57 15.22 4.98 11.26 3.23 22.77 5.6 34.39 7.06 2.91.29 5.81.61 8.72.9 13.82 1.08 27.74 1 41.54-.43 4.45-.6 8.92-.99 13.35-1.78 3.63-.67 7.28-1.25 10.87-2.1 4.13-.98 8.28-1.91 12.36-3.07 26.5-7.34 51.58-19.71 73.58-36.2 15.78-11.82 29.96-25.76 42.12-41.28 3.26-4.02 6.17-8.31 9.13-12.55 3.39-5.06 6.58-10.25 9.6-15.54 2.4-4.44 4.74-8.91 6.95-13.45 5.69-12.05 10.28-24.62 13.75-37.49 2.59-10.01 4.75-20.16 5.9-30.45 1.77-13.47 1.94-27.1 1.29-40.65-.29-3.89-.67-7.77-1-11.66-2.23-19.08-6.79-37.91-13.82-55.8-5.95-15.13-13.53-29.63-22.61-43.13-12.69-18.8-28.24-35.68-45.97-49.83-25.05-20-54.47-34.55-85.65-42.08-7.78-1.93-15.69-3.34-23.63-4.45-3.91-.59-7.85-.82-11.77-1.24-7.39-.57-14.81-.72-22.22-.58zM139.26 83.53c13.3-8.89 28.08-15.38 43.3-20.18-3.17 1.77-6.44 3.38-9.53 5.29-11.21 6.68-21.52 14.9-30.38 24.49-6.8 7.43-12.76 15.73-17.01 24.89-3.29 6.86-5.64 14.19-6.86 21.71-.93 4.85-1.3 9.81-1.17 14.75.13 13.66 4.44 27.08 11.29 38.82 5.92 10.22 13.63 19.33 22.36 27.26 4.85 4.36 10.24 8.09 14.95 12.6 2.26 2.19 4.49 4.42 6.43 6.91 2.62 3.31 4.89 6.99 5.99 11.1.9 3.02.66 6.2.69 9.31.02 4.1-.04 8.2.03 12.3.14 3.54-.02 7.09.11 10.63.08 2.38.02 4.76.05 7.14.16 5.77.06 11.53.15 17.3.11 2.91.02 5.82.13 8.74.03 1.63.13 3.28-.03 4.91-.91.12-1.82.18-2.73.16-10.99 0-21.88-2.63-31.95-6.93-6-2.7-11.81-5.89-17.09-9.83-5.75-4.19-11.09-8.96-15.79-14.31-6.53-7.24-11.98-15.39-16.62-23.95-1.07-2.03-2.24-4.02-3.18-6.12-1.16-2.64-2.62-5.14-3.67-7.82-4.05-9.68-6.57-19.94-8.08-30.31-.49-4.44-1.09-8.88-1.2-13.35-.7-15.73.84-31.55 4.67-46.82 2.12-8.15 4.77-16.18 8.31-23.83 6.32-14.2 15.34-27.18 26.3-38.19 6.28-6.2 13.13-11.84 20.53-16.67zm175.37-20.12c2.74.74 5.41 1.74 8.09 2.68 6.36 2.33 12.68 4.84 18.71 7.96 13.11 6.44 25.31 14.81 35.82 24.97 10.2 9.95 18.74 21.6 25.14 34.34 1.28 2.75 2.64 5.46 3.81 8.26 6.31 15.1 10 31.26 11.23 47.57.41 4.54.44 9.09.45 13.64.07 11.64-1.49 23.25-4.3 34.53-1.97 7.27-4.35 14.49-7.86 21.18-3.18 6.64-6.68 13.16-10.84 19.24-6.94 10.47-15.6 19.87-25.82 27.22-10.48 7.64-22.64 13.02-35.4 15.38-3.51.69-7.08 1.08-10.66 1.21-1.85.06-3.72.16-5.56-.1-.28-2.15 0-4.31-.01-6.46-.03-3.73.14-7.45.1-11.17.19-7.02.02-14.05.21-21.07.03-2.38-.03-4.76.03-7.14.17-5.07-.04-10.14.14-15.21.1-2.99-.24-6.04.51-8.96.66-2.5 1.78-4.86 3.09-7.08 4.46-7.31 11.06-12.96 17.68-18.26 5.38-4.18 10.47-8.77 15.02-13.84 7.68-8.37 14.17-17.88 18.78-28.27 2.5-5.93 4.52-12.1 5.55-18.46.86-4.37 1.06-8.83 1.01-13.27-.02-7.85-1.4-15.65-3.64-23.17-1.75-5.73-4.27-11.18-7.09-16.45-3.87-6.93-8.65-13.31-13.96-19.2-9.94-10.85-21.75-19.94-34.6-27.1-1.85-1.02-3.84-1.82-5.63-2.97zm-100.8 58.45c.98-1.18 1.99-2.33 3.12-3.38-.61.93-1.27 1.81-1.95 2.68-3.1 3.88-5.54 8.31-7.03 13.06-.87 3.27-1.68 6.6-1.73 10-.07 2.52-.08 5.07.32 7.57 1.13 7.63 4.33 14.85 8.77 21.12 2 2.7 4.25 5.27 6.92 7.33 1.62 1.27 3.53 2.09 5.34 3.05 3.11 1.68 6.32 3.23 9.07 5.48 2.67 2.09 4.55 5.33 4.4 8.79-.01 73.67 0 147.34-.01 221.02 0 1.35-.08 2.7.04 4.04.13 1.48.82 2.83 1.47 4.15.86 1.66 1.78 3.34 3.18 4.62.85.77 1.97 1.4 3.15 1.24 1.5-.2 2.66-1.35 3.45-2.57.96-1.51 1.68-3.16 2.28-4.85.76-2.13.44-4.42.54-6.63.14-4.03-.02-8.06.14-12.09.03-5.89.03-11.77.06-17.66.14-3.62.03-7.24.11-10.86.15-4.03-.02-8.06.14-12.09.03-5.99.03-11.98.07-17.97.14-3.62.02-7.24.11-10.86.14-3.93-.02-7.86.14-11.78.03-5.99.03-11.98.06-17.97.16-3.94-.01-7.88.19-11.82.29 1.44.13 2.92.22 4.38.19 3.61.42 7.23.76 10.84.32 3.44.44 6.89.86 10.32.37 3.1.51 6.22.95 9.31.57 4.09.87 8.21 1.54 12.29 1.46 9.04 2.83 18.11 5.09 26.99 1.13 4.82 2.4 9.61 4 14.3 2.54 7.9 5.72 15.67 10.31 22.62 1.73 2.64 3.87 4.98 6.1 7.21.27.25.55.51.88.71.6.25 1.31-.07 1.7-.57.71-.88 1.17-1.94 1.7-2.93 4.05-7.8 8.18-15.56 12.34-23.31.7-1.31 1.44-2.62 2.56-3.61 1.75-1.57 3.84-2.69 5.98-3.63 2.88-1.22 5.9-2.19 9.03-2.42 6.58-.62 13.11.75 19.56 1.85 3.69.58 7.4 1.17 11.13 1.41 3.74.1 7.48.05 11.21-.28 8.55-.92 16.99-2.96 24.94-6.25 5.3-2.24 10.46-4.83 15.31-7.93 11.46-7.21 21.46-16.57 30.04-27.01 1.17-1.42 2.25-2.9 3.46-4.28-1.2 3.24-2.67 6.37-4.16 9.48-1.25 2.9-2.84 5.61-4.27 8.42-5.16 9.63-11.02 18.91-17.75 27.52-4.03 5.21-8.53 10.05-13.33 14.57-6.64 6.05-14.07 11.37-22.43 14.76-8.21 3.37-17.31 4.63-26.09 3.29-3.56-.58-7.01-1.69-10.41-2.88-2.79-.97-5.39-2.38-8.03-3.69-3.43-1.71-6.64-3.81-9.71-6.08 2.71 3.06 5.69 5.86 8.7 8.61 4.27 3.76 8.74 7.31 13.63 10.23 3.98 2.45 8.29 4.4 12.84 5.51 1.46.37 2.96.46 4.45.6-1.25 1.1-2.63 2.04-3.99 2.98-9.61 6.54-20.01 11.86-30.69 16.43-20.86 8.7-43.17 13.97-65.74 15.34-4.66.24-9.32.36-13.98.36-4.98-.11-9.97-.13-14.92-.65-11.2-.76-22.29-2.73-33.17-5.43-10.35-2.71-20.55-6.12-30.3-10.55-8.71-3.86-17.12-8.42-24.99-13.79-1.83-1.31-3.74-2.53-5.37-4.08 6.6-1.19 13.03-3.39 18.99-6.48 5.74-2.86 10.99-6.66 15.63-11.07 2.24-2.19 4.29-4.59 6.19-7.09-3.43 2.13-6.93 4.15-10.62 5.78-4.41 2.16-9.07 3.77-13.81 5.02-5.73 1.52-11.74 1.73-17.61 1.14-8.13-.95-15.86-4.27-22.51-8.98-4.32-2.94-8.22-6.43-11.96-10.06-9.93-10.16-18.2-21.81-25.66-33.86-3.94-6.27-7.53-12.75-11.12-19.22-1.05-2.04-2.15-4.05-3.18-6.1 2.85 2.92 5.57 5.97 8.43 8.88 8.99 8.97 18.56 17.44 29.16 24.48 7.55 4.9 15.67 9.23 24.56 11.03 3.11.73 6.32.47 9.47.81 2.77.28 5.56.2 8.34.3 5.05.06 10.11.04 15.16-.16 3.65-.16 7.27-.66 10.89-1.09 2.07-.25 4.11-.71 6.14-1.2 3.88-.95 8.11-.96 11.83.61 4.76 1.85 8.44 5.64 11.38 9.71 2.16 3.02 4.06 6.22 5.66 9.58 1.16 2.43 2.46 4.79 3.55 7.26 1 2.24 2.15 4.42 3.42 6.52.67 1.02 1.4 2.15 2.62 2.55 1.06-.75 1.71-1.91 2.28-3.03 2.1-4.16 3.42-8.65 4.89-13.05 2.02-6.59 3.78-13.27 5.19-20.02 2.21-9.25 3.25-18.72 4.54-28.13.56-3.98.83-7.99 1.31-11.97.87-10.64 1.9-21.27 2.24-31.94.08-1.86.24-3.71.25-5.57.01-4.35.25-8.69.22-13.03-.01-2.38-.01-4.76 0-7.13.05-5.07-.2-10.14-.22-15.21-.2-6.61-.71-13.2-1.29-19.78-.73-5.88-1.55-11.78-3.12-17.51-2.05-7.75-5.59-15.03-9.8-21.82-3.16-5.07-6.79-9.88-11.09-14.03-3.88-3.86-8.58-7.08-13.94-8.45-1.5-.41-3.06-.45-4.59-.64.07-2.99.7-5.93 1.26-8.85 1.59-7.71 3.8-15.3 6.76-22.6 1.52-4.03 3.41-7.9 5.39-11.72 3.45-6.56 7.62-12.79 12.46-18.46zm31.27 1.7c.35-.06.71-.12 1.07-.19.19 1.79.09 3.58.1 5.37v38.13c-.01 1.74.13 3.49-.15 5.22-.36-.03-.71-.05-1.06-.05-.95-3.75-1.72-7.55-2.62-11.31-.38-1.53-.58-3.09-1.07-4.59-1.7-.24-3.43-.17-5.15-.2-5.06-.01-10.13 0-15.19-.01-1.66-.01-3.32.09-4.98-.03-.03-.39-.26-.91.16-1.18 1.28-.65 2.72-.88 4.06-1.35 3.43-1.14 6.88-2.16 10.31-3.31 1.39-.48 2.9-.72 4.16-1.54.04-.56.02-1.13-.05-1.68-1.23-.55-2.53-.87-3.81-1.28-3.13-1.03-6.29-1.96-9.41-3.02-1.79-.62-3.67-1-5.41-1.79-.03-.37-.07-.73-.11-1.09 5.09-.19 10.2.06 15.3-.12 3.36-.13 6.73.08 10.09-.07.12-.39.26-.77.37-1.16 1.08-4.94 2.33-9.83 3.39-14.75zm5.97-.2c.36.05.72.12 1.08.2.98 3.85 1.73 7.76 2.71 11.61.36 1.42.56 2.88 1.03 4.27 2.53.18 5.07-.01 7.61.05 5.16.12 10.33.12 15.49.07.76-.01 1.52.03 2.28.08-.04.36-.07.72-.1 1.08-1.82.83-3.78 1.25-5.67 1.89-3.73 1.23-7.48 2.39-11.22 3.57-.57.17-1.12.42-1.67.64-.15.55-.18 1.12-.12 1.69.87.48 1.82.81 2.77 1.09 4.88 1.52 9.73 3.14 14.63 4.6.38.13.78.27 1.13.49.4.27.23.79.15 1.18-1.66.13-3.31.03-4.97.04-5.17.01-10.33-.01-15.5.01-1.61.03-3.22-.02-4.82.21-.52 1.67-.72 3.42-1.17 5.11-.94 3.57-1.52 7.24-2.54 10.78-.36.01-.71.02-1.06.06-.29-1.73-.15-3.48-.15-5.22v-38.13c.02-1.78-.08-3.58.11-5.37zM65.05 168.33c1.12-2.15 2.08-4.4 3.37-6.46-1.82 7.56-2.91 15.27-3.62 23-.8 7.71-.85 15.49-.54 23.23 1.05 19.94 5.54 39.83 14.23 57.88 2.99 5.99 6.35 11.83 10.5 17.11 6.12 7.47 12.53 14.76 19.84 21.09 4.8 4.1 9.99 7.78 15.54 10.8 3.27 1.65 6.51 3.39 9.94 4.68 5.01 2.03 10.19 3.61 15.42 4.94 3.83.96 7.78 1.41 11.52 2.71 5 1.57 9.47 4.61 13.03 8.43 4.93 5.23 8.09 11.87 10.2 18.67.99 2.9 1.59 5.91 2.17 8.92.15.75.22 1.52.16 2.29-6.5 2.78-13.26 5.06-20.26 6.18-4.11.78-8.29.99-12.46 1.08-10.25.24-20.47-1.76-30.12-5.12-3.74-1.42-7.49-2.85-11.03-4.72-8.06-3.84-15.64-8.7-22.46-14.46-2.92-2.55-5.83-5.13-8.4-8.03-9.16-9.83-16.3-21.41-21.79-33.65-2.39-5.55-4.61-11.18-6.37-16.96-1.17-3.94-2.36-7.89-3.26-11.91-.75-2.94-1.22-5.95-1.87-8.92-.46-2.14-.69-4.32-1.03-6.48-.85-5.43-1.28-10.93-1.33-16.43.11-6.18.25-12.37 1.07-18.5.4-2.86.67-5.74 1.15-8.6.98-5.7 2.14-11.37 3.71-16.93 3.09-11.65 7.48-22.95 12.69-33.84zm363.73-6.44c1.1 1.66 1.91 3.48 2.78 5.26 2.1 4.45 4.24 8.9 6.02 13.49 7.61 18.76 12.3 38.79 13.04 59.05.02 1.76.07 3.52.11 5.29.13 9.57-1.27 19.09-3.18 28.45-.73 3.59-1.54 7.17-2.58 10.69-4.04 14.72-10 29-18.41 41.78-8.21 12.57-19.01 23.55-31.84 31.41-5.73 3.59-11.79 6.64-18.05 9.19-5.78 2.19-11.71 4.03-17.8 5.11-6.4 1.05-12.91 1.52-19.4 1.23-7.92-.48-15.78-2.07-23.21-4.85-1.94-.8-3.94-1.46-5.84-2.33-.21-1.51.25-2.99.53-4.46 1.16-5.74 3.03-11.36 5.7-16.58 2.37-4.51 5.52-8.65 9.46-11.9 2.43-2.05 5.24-3.61 8.16-4.83 3.58-1.5 7.47-1.97 11.24-2.83 7.23-1.71 14.37-3.93 21.15-7 10.35-4.65 19.71-11.38 27.65-19.46 1.59-1.61 3.23-3.18 4.74-4.87 3.37-3.76 6.71-7.57 9.85-11.53 7.48-10.07 12.82-21.59 16.71-33.48 1.58-5.3 3.21-10.6 4.21-16.05.63-2.87 1.04-5.78 1.52-8.68.87-6.09 1.59-12.22 1.68-18.38.12-6.65.14-13.32-.53-19.94-.73-7.99-1.87-15.96-3.71-23.78z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaOpencart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M423.3 440.7c0 25.3-20.3 45.6-45.6 45.6s-45.8-20.3-45.8-45.6 20.6-45.8 45.8-45.8c25.4 0 45.6 20.5 45.6 45.8zm-253.9-45.8c-25.3 0-45.6 20.6-45.6 45.8s20.3 45.6 45.6 45.6 45.8-20.3 45.8-45.6-20.5-45.8-45.8-45.8zm291.7-270C158.9 124.9 81.9 112.1 0 25.7c34.4 51.7 53.3 148.9 373.1 144.2 333.3-5 130 86.1 70.8 188.9 186.7-166.7 319.4-233.9 17.2-233.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaOpenid(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M271.5 432l-68 32C88.5 453.7 0 392.5 0 318.2c0-71.5 82.5-131 191.7-144.3v43c-71.5 12.5-124 53-124 101.3 0 51 58.5 93.3 135.7 103v-340l68-33.2v384zM448 291l-131.3-28.5 36.8-20.7c-19.5-11.5-43.5-20-70-24.8v-43c46.2 5.5 87.7 19.5 120.3 39.3l35-19.8L448 291z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaOpera(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M313.9 32.7c-170.2 0-252.6 223.8-147.5 355.1 36.5 45.4 88.6 75.6 147.5 75.6 36.3 0 70.3-11.1 99.4-30.4-43.8 39.2-101.9 63-165.3 63-3.9 0-8 0-11.9-.3C104.6 489.6 0 381.1 0 248 0 111 111 0 248 0h.8c63.1.3 120.7 24.1 164.4 63.1-29-19.4-63.1-30.4-99.3-30.4zm101.8 397.7c-40.9 24.7-90.7 23.6-132-5.8 56.2-20.5 97.7-91.6 97.7-176.6 0-84.7-41.2-155.8-97.4-176.6 41.8-29.2 91.2-30.3 132.9-5 105.9 98.7 105.5 265.7-1.2 364z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaOptinMonster(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M572.6 421.4c5.6-9.5 4.7-15.2-5.4-11.6-3-4.9-7-9.5-11.1-13.8 2.9-9.7-.7-14.2-10.8-9.2-4.6-3.2-10.3-6.5-15.9-9.2 0-15.1-11.6-11.6-17.6-5.7-10.4-1.5-18.7-.3-26.8 5.7.3-6.5.3-13 .3-19.7 12.6 0 40.2-11 45.9-36.2 1.4-6.8 1.6-13.8-.3-21.9-3-13.5-14.3-21.3-25.1-25.7-.8-5.9-7.6-14.3-14.9-15.9s-12.4 4.9-14.1 10.3c-8.5 0-19.2 2.8-21.1 8.4-5.4-.5-11.1-1.4-16.8-1.9 2.7-1.9 5.4-3.5 8.4-4.6 5.4-9.2 14.6-11.4 25.7-11.6V256c19.5-.5 43-5.9 53.8-18.1 12.7-13.8 14.6-37.3 12.4-55.1-2.4-17.3-9.7-37.6-24.6-48.1-8.4-5.9-21.6-.8-22.7 9.5-2.2 19.6 1.2 30-38.6 25.1-10.3-23.8-24.6-44.6-42.7-60C341 49.6 242.9 55.5 166.4 71.7c19.7 4.6 41.1 8.6 59.7 16.5-26.2 2.4-52.7 11.3-76.2 23.2-32.8 17-44 29.9-56.7 42.4 14.9-2.2 28.9-5.1 43.8-3.8-9.7 5.4-18.4 12.2-26.5 20-25.8.9-23.8-5.3-26.2-25.9-1.1-10.5-14.3-15.4-22.7-9.7-28.1 19.9-33.5 79.9-12.2 103.5 10.8 12.2 35.1 17.3 54.9 17.8-.3 1.1-.3 1.9-.3 2.7 10.8.5 19.5 2.7 24.6 11.6 3 1.1 5.7 2.7 8.1 4.6-5.4.5-11.1 1.4-16.5 1.9-3.3-6.6-13.7-8.1-21.1-8.1-1.6-5.7-6.5-12.2-14.1-10.3-6.8 1.9-14.1 10-14.9 15.9-22.5 9.5-30.1 26.8-25.1 47.6 5.3 24.8 33 36.2 45.9 36.2v19.7c-6.6-5-14.3-7.5-26.8-5.7-5.5-5.5-17.3-10.1-17.3 5.7-5.9 2.7-11.4 5.9-15.9 9.2-9.8-4.9-13.6-1.7-11.1 9.2-4.1 4.3-7.8 8.6-11.1 13.8-10.2-3.7-11 2.2-5.4 11.6-1.1 3.5-1.6 7-1.9 10.8-.5 31.6 44.6 64 73.5 65.1 17.3.5 34.6-8.4 43-23.5 113.2 4.9 226.7 4.1 340.2 0 8.1 15.1 25.4 24.3 42.7 23.5 29.2-1.1 74.3-33.5 73.5-65.1.2-3.7-.7-7.2-1.7-10.7zm-73.8-254c1.1-3 2.4-8.4 2.4-14.6 0-5.9 6.8-8.1 14.1-.8 11.1 11.6 14.9 40.5 13.8 51.1-4.1-13.6-13-29-30.3-35.7zm-4.6 6.7c19.5 6.2 28.6 27.6 29.7 48.9-1.1 2.7-3 5.4-4.9 7.6-5.7 5.9-15.4 10-26.2 12.2 4.3-21.3.3-47.3-12.7-63 4.9-.8 10.9-2.4 14.1-5.7zm-24.1 6.8c13.8 11.9 20 39.2 14.1 63.5-4.1.5-8.1.8-11.6.8-1.9-21.9-6.8-44-14.3-64.6 3.7.3 8.1.3 11.8.3zM47.5 203c-1.1-10.5 2.4-39.5 13.8-51.1 7-7.3 14.1-5.1 14.1.8 0 6.2 1.4 11.6 2.4 14.6-17.3 6.8-26.2 22.2-30.3 35.7zm9.7 27.6c-1.9-2.2-3.5-4.9-4.9-7.6 1.4-21.3 10.3-42.7 29.7-48.9 3.2 3.2 9.2 4.9 14.1 5.7-13 15.7-17 41.6-12.7 63-10.8-2.2-20.5-6-26.2-12.2zm47.9 14.6c-4.1 0-8.1-.3-12.7-.8-4.6-18.6-1.9-38.9 5.4-53v.3l12.2-5.1c4.9-1.9 9.7-3.8 14.9-4.9-10.7 19.7-17.4 41.3-19.8 63.5zm184-162.7c41.9 0 76.2 34 76.2 75.9 0 42.2-34.3 76.2-76.2 76.2s-76.2-34-76.2-76.2c0-41.8 34.3-75.9 76.2-75.9zm115.6 174.3c-.3 17.8-7 48.9-23 57-13.2 6.6-6.5-7.5-16.5-58.1 13.3.3 26.6.3 39.5 1.1zm-54-1.6c.8 4.9 3.8 40.3-1.6 41.9-11.6 3.5-40 4.3-51.1-1.1-4.1-3-4.6-35.9-4.3-41.1v.3c18.9-.3 38.1-.3 57 0zM278.3 309c-13 3.5-41.6 4.1-54.6-1.6-6.5-2.7-3.8-42.4-1.9-51.6 19.2-.5 38.4-.5 57.8-.8v.3c1.1 8.3 3.3 51.2-1.3 53.7zm-106.5-51.1c12.2-.8 24.6-1.4 36.8-1.6-2.4 15.4-3 43.5-4.9 52.2-1.1 6.8-4.3 6.8-9.7 4.3-21.9-9.8-27.6-35.2-22.2-54.9zm-35.4 31.3c7.8-1.1 15.7-1.9 23.5-2.7 1.6 6.2 3.8 11.9 7 17.6 10 17 44 35.7 45.1 7 6.2 14.9 40.8 12.2 54.9 10.8 15.7-1.4 23.8-1.4 26.8-14.3 12.4 4.3 30.8 4.1 44 3 11.3-.8 20.8-.5 24.6-8.9 1.1 5.1 1.9 11.6 4.6 16.8 10.8 21.3 37.3 1.4 46.8-31.6 8.6.8 17.6 1.9 26.5 2.7-.4 1.3-3.8 7.3 7.3 11.6-47.6 47-95.7 87.8-163.2 107-63.2-20.8-112.1-59.5-155.9-106.5 9.6-3.4 10.4-8.8 8-12.5zm-21.6 172.5c-3.8 17.8-21.9 29.7-39.7 28.9-19.2-.8-46.5-17-59.2-36.5-2.7-31.1 43.8-61.3 66.2-54.6 14.9 4.3 27.8 30.8 33.5 54 0 3-.3 5.7-.8 8.2zm-8.7-66c-.5-13.5-.5-27-.3-40.5h.3c2.7-1.6 5.7-3.8 7.8-6.5 6.5-1.6 13-5.1 15.1-9.2 3.3-7.1-7-7.5-5.4-12.4 2.7-1.1 5.7-2.2 7.8-3.5 29.2 29.2 58.6 56.5 97.3 77-36.8 11.3-72.4 27.6-105.9 47-1.2-18.6-7.7-35.9-16.7-51.9zm337.6 64.6c-103 3.5-206.2 4.1-309.4 0 0 .3 0 .3-.3.3v-.3h.3c35.1-21.6 72.2-39.2 112.4-50.8 11.6 5.1 23 9.5 34.9 13.2 2.2.8 2.2.8 4.3 0 14.3-4.1 28.4-9.2 42.2-15.4 41.5 11.7 78.8 31.7 115.6 53zm10.5-12.4c-35.9-19.5-73-35.9-111.9-47.6 38.1-20 71.9-47.3 103.5-76.7 2.2 1.4 4.6 2.4 7.6 3.2 0 .8.3 1.9.5 2.4-4.6 2.7-7.8 6.2-5.9 10.3 2.2 3.8 8.6 7.6 15.1 8.9 2.4 2.7 5.1 5.1 8.1 6.8 0 13.8-.3 27.6-.8 41.3l.3-.3c-9.3 15.9-15.5 37-16.5 51.7zm105.9 6.2c-12.7 19.5-40 35.7-59.2 36.5-19.3.9-40.5-13.2-40.5-37 5.7-23.2 18.9-49.7 33.5-54 22.7-6.9 69.2 23.4 66.2 54.5zM372.9 75.2c-3.8-72.1-100.8-79.7-126-23.5 44.6-24.3 90.3-15.7 126 23.5zM74.8 407.1c-15.7 1.6-49.5 25.4-49.5 43.2 0 11.6 15.7 19.5 32.2 14.9 12.2-3.2 31.1-17.6 35.9-27.3 6-11.6-3.7-32.7-18.6-30.8zm215.9-176.2c28.6 0 51.9-21.6 51.9-48.4 0-36.1-40.5-58.1-72.2-44.3 9.5 3 16.5 11.6 16.5 21.6 0 23.3-33.3 32-46.5 11.3-7.3 34.1 19.4 59.8 50.3 59.8zM68 474.1c.5 6.5 12.2 12.7 21.6 9.5 6.8-2.7 14.6-10.5 17.3-16.2 3-7-1.1-20-9.7-18.4-8.9 1.6-29.7 16.7-29.2 25.1zm433.2-67c-14.9-1.9-24.6 19.2-18.9 30.8 4.9 9.7 24.1 24.1 36.2 27.3 16.5 4.6 32.2-3.2 32.2-14.9 0-17.8-33.8-41.6-49.5-43.2zM478.8 449c-8.4-1.6-12.4 11.3-9.5 18.4 2.4 5.7 10.3 13.5 17.3 16.2 9.2 3.2 21.1-3 21.3-9.5.9-8.4-20.2-23.5-29.1-25.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaOrcid(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M294.75 188.19h-45.92V342h47.47c67.62 0 83.12-51.34 83.12-76.91 0-41.64-26.54-76.9-84.67-76.9zM256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm-80.79 360.76h-29.84v-207.5h29.84zm-14.92-231.14a19.57 19.57 0 1 1 19.57-19.57 19.64 19.64 0 0 1-19.57 19.57zM300 369h-81V161.26h80.6c76.73 0 110.44 54.83 110.44 103.85C410 318.39 368.38 369 300 369z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaOsi(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 266.44C10.3 130.64 105.4 34 221.8 18.34c138.8-18.6 255.6 75.8 278 201.1 21.3 118.8-44 230-151.6 274-9.3 3.8-14.4 1.7-18-7.7q-26.7-69.45-53.4-139c-3.1-8.1-1-13.2 7-16.8 24.2-11 39.3-29.4 43.3-55.8a71.47 71.47 0 0 0-64.5-82.2c-39-3.4-71.8 23.7-77.5 59.7-5.2 33 11.1 63.7 41.9 77.7 9.6 4.4 11.5 8.6 7.8 18.4q-26.85 69.9-53.7 139.9c-2.6 6.9-8.3 9.3-15.5 6.5-52.6-20.3-101.4-61-130.8-119-24.9-49.2-25.2-87.7-26.8-108.7zm20.9-1.9c.4 6.6.6 14.3 1.3 22.1 6.3 71.9 49.6 143.5 131 183.1 3.2 1.5 4.4.8 5.6-2.3q22.35-58.65 45-117.3c1.3-3.3.6-4.8-2.4-6.7-31.6-19.9-47.3-48.5-45.6-86 1-21.6 9.3-40.5 23.8-56.3 30-32.7 77-39.8 115.5-17.6a91.64 91.64 0 0 1 45.2 90.4c-3.6 30.6-19.3 53.9-45.7 69.8-2.7 1.6-3.5 2.9-2.3 6q22.8 58.8 45.2 117.7c1.2 3.1 2.4 3.8 5.6 2.3 35.5-16.6 65.2-40.3 88.1-72 34.8-48.2 49.1-101.9 42.3-161-13.7-117.5-119.4-214.8-255.5-198-106.1 13-195.3 102.5-197.1 225.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPage4(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 504C111 504 0 393 0 256S111 8 248 8c20.9 0 41.3 2.6 60.7 7.5L42.3 392H248v112zm0-143.6V146.8L98.6 360.4H248zm96 31.6v92.7c45.7-19.2 84.5-51.7 111.4-92.7H344zm57.4-138.2l-21.2 8.4 21.2 8.3v-16.7zm-20.3 54.5c-6.7 0-8 6.3-8 12.9v7.7h16.2v-10c0-5.9-2.3-10.6-8.2-10.6zM496 256c0 37.3-8.2 72.7-23 104.4H344V27.3C433.3 64.8 496 153.1 496 256zM360.4 143.6h68.2V96h-13.9v32.6h-13.9V99h-13.9v29.6h-12.7V96h-13.9v47.6zm68.1 185.3H402v-11c0-15.4-5.6-25.2-20.9-25.2-15.4 0-20.7 10.6-20.7 25.9v25.3h68.2v-15zm0-103l-68.2 29.7V268l68.2 29.5v-16.6l-14.4-5.7v-26.5l14.4-5.9v-16.9zm-4.8-68.5h-35.6V184H402v-12.2h11c8.6 15.8 1.3 35.3-18.6 35.3-22.5 0-28.3-25.3-15.5-37.7l-11.6-10.6c-16.2 17.5-12.2 63.9 27.1 63.9 34 0 44.7-35.9 29.3-65.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPagelines(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 312.7c-55.1 136.7-187.1 54-187.1 54-40.5 81.8-107.4 134.4-184.6 134.7-16.1 0-16.6-24.4 0-24.4 64.4-.3 120.5-42.7 157.2-110.1-41.1 15.9-118.6 27.9-161.6-82.2 109-44.9 159.1 11.2 178.3 45.5 9.9-24.4 17-50.9 21.6-79.7 0 0-139.7 21.9-149.5-98.1 119.1-47.9 152.6 76.7 152.6 76.7 1.6-16.7 3.3-52.6 3.3-53.4 0 0-106.3-73.7-38.1-165.2 124.6 43 61.4 162.4 61.4 162.4.5 1.6.5 23.8 0 33.4 0 0 45.2-89 136.4-57.5-4.2 134-141.9 106.4-141.9 106.4-4.4 27.4-11.2 53.4-20 77.5 0 0 83-91.8 172-20z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPalfed(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384.9 193.9c0-47.4-55.2-44.2-95.4-29.8-1.3 39.4-2.5 80.7-3 119.8.7 2.8 2.6 6.2 15.1 6.2 36.8 0 83.4-42.8 83.3-96.2zm-194.5 72.2c.2 0 6.5-2.7 11.2-2.7 26.6 0 20.7 44.1-14.4 44.1-21.5 0-37.1-18.1-37.1-43 0-42 42.9-95.6 100.7-126.5 1-12.4 3-22 10.5-28.2 11.2-9 26.6-3.5 29.5 11.1 72.2-22.2 135.2 1 135.2 72 0 77.9-79.3 152.6-140.1 138.2-.1 39.4.9 74.4 2.7 100v.2c.2 3.4.6 12.5-5.3 19.1-9.6 10.6-33.4 10-36.4-22.3-4.1-44.4.2-206.1 1.4-242.5-21.5 15-58.5 50.3-58.5 75.9.2 2.5.4 4 .6 4.6zM8 181.1s-.1 37.4 38.4 37.4h30l22.4 217.2s0 44.3 44.7 44.3h288.9s44.7-.4 44.7-44.3l22.4-217.2h30s38.4 1.2 38.4-37.4c0 0 .1-37.4-38.4-37.4h-30.1c-7.3-25.6-30.2-74.3-119.4-74.3h-28V50.3s-2.7-18.4-21.1-18.4h-85.8s-21.1 0-21.1 18.4v19.1h-28.1s-105 4.2-120.5 74.3h-29S8 142.5 8 181.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPatreon(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 194.8c0 101.3-82.4 183.8-183.8 183.8-101.7 0-184.4-82.4-184.4-183.8 0-101.6 82.7-184.3 184.4-184.3C429.6 10.5 512 93.2 512 194.8zM0 501.5h90v-491H0v491z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPaypal(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M111.4 295.9c-3.5 19.2-17.4 108.7-21.5 134-.3 1.8-1 2.5-3 2.5H12.3c-7.6 0-13.1-6.6-12.1-13.9L58.8 46.6c1.5-9.6 10.1-16.9 20-16.9 152.3 0 165.1-3.7 204 11.4 60.1 23.3 65.6 79.5 44 140.3-21.5 62.6-72.5 89.5-140.1 90.3-43.4.7-69.5-7-75.3 24.2zM357.1 152c-1.8-1.3-2.5-1.8-3 1.3-2 11.4-5.1 22.5-8.8 33.6-39.9 113.8-150.5 103.9-204.5 103.9-6.1 0-10.1 3.3-10.9 9.4-22.6 140.4-27.1 169.7-27.1 169.7-1 7.1 3.5 12.9 10.6 12.9h63.5c8.6 0 15.7-6.3 17.4-14.9.7-5.4-1.1 6.1 14.4-91.3 4.6-22 14.3-19.7 29.3-19.7 71 0 126.4-28.8 142.9-112.3 6.5-34.8 4.6-71.4-23.8-92.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPennyArcade(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M421.91 164.27c-4.49 19.45-1.4 6.06-15.1 65.29l39.73-10.61c-22.34-49.61-17.29-38.41-24.63-54.68zm-206.09 51.11c-20.19 5.4-11.31 3.03-39.63 10.58l4.46 46.19c28.17-7.59 20.62-5.57 34.82-9.34 42.3-9.79 32.85-56.42.35-47.43zm326.16-26.19l-45.47-99.2c-5.69-12.37-19.46-18.84-32.62-15.33-70.27 18.75-38.72 10.32-135.59 36.23a27.618 27.618 0 0 0-18.89 17.41C144.26 113.27 0 153.75 0 226.67c0 33.5 30.67 67.11 80.9 95.37l1.74 17.88a27.891 27.891 0 0 0-17.77 28.67l4.3 44.48c1.39 14.31 13.43 25.21 27.8 25.2 5.18-.01-3.01 1.78 122.53-31.76 12.57-3.37 21.12-15.02 20.58-28.02 216.59 45.5 401.99-5.98 399.89-84.83.01-28.15-22.19-66.56-97.99-104.47zM255.14 298.3l-21.91 5.88-48.44 12.91 2.46 23.55 20.53-5.51 4.51 44.51-115.31 30.78-4.3-44.52 20.02-5.35-11.11-114.64-20.12 5.39-4.35-44.5c178.15-47.54 170.18-46.42 186.22-46.65 56.66-1.13 64.15 71.84 42.55 104.43a86.7 86.7 0 0 1-50.75 33.72zm199.18 16.62l-3.89-39.49 14.9-3.98-6.61-14.68-57.76 15.42-4.1 17.54 19.2-5.12 4.05 39.54-112.85 30.07-4.46-44.43 20.99-5.59 33.08-126.47-17.15 4.56-4.2-44.48c93.36-24.99 65.01-17.41 135.59-36.24l66.67 145.47 20.79-5.56 4.3 44.48-108.55 28.96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPerbyte(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M305.314,284.578H246.6V383.3h58.711q24.423,0,38.193-13.77t13.77-36.11q0-21.826-14.032-35.335T305.314,284.578ZM149.435,128.7H90.724v98.723h58.711q24.42,0,38.19-13.773t13.77-36.107q0-21.826-14.029-35.338T149.435,128.7ZM366.647,32H81.353A81.445,81.445,0,0,0,0,113.352V398.647A81.445,81.445,0,0,0,81.353,480H366.647A81.445,81.445,0,0,0,448,398.647V113.352A81.445,81.445,0,0,0,366.647,32Zm63.635,366.647a63.706,63.706,0,0,1-63.635,63.635H81.353a63.706,63.706,0,0,1-63.635-63.635V113.352A63.706,63.706,0,0,1,81.353,49.718H366.647a63.706,63.706,0,0,1,63.635,63.634ZM305.314,128.7H246.6v98.723h58.711q24.423,0,38.193-13.773t13.77-36.107q0-21.826-14.032-35.338T305.314,128.7Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPeriscope(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M370 63.6C331.4 22.6 280.5 0 226.6 0 111.9 0 18.5 96.2 18.5 214.4c0 75.1 57.8 159.8 82.7 192.7C137.8 455.5 192.6 512 226.6 512c41.6 0 112.9-94.2 120.9-105 24.6-33.1 82-118.3 82-192.6 0-56.5-21.1-110.1-59.5-150.8zM226.6 493.9c-42.5 0-190-167.3-190-279.4 0-107.4 83.9-196.3 190-196.3 100.8 0 184.7 89 184.7 196.3.1 112.1-147.4 279.4-184.7 279.4zM338 206.8c0 59.1-51.1 109.7-110.8 109.7-100.6 0-150.7-108.2-92.9-181.8v.4c0 24.5 20.1 44.4 44.8 44.4 24.7 0 44.8-19.9 44.8-44.4 0-18.2-11.1-33.8-26.9-40.7 76.6-19.2 141 39.3 141 112.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPhabricator(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M323 262.1l-.1-13s21.7-19.8 21.1-21.2l-9.5-20c-.6-1.4-29.5-.5-29.5-.5l-9.4-9.3s.2-28.5-1.2-29.1l-20.1-9.2c-1.4-.6-20.7 21-20.7 21l-13.1-.2s-20.5-21.4-21.9-20.8l-20 8.3c-1.4.5.2 28.9.2 28.9l-9.1 9.1s-29.2-.9-29.7.4l-8.1 19.8c-.6 1.4 21 21 21 21l.1 12.9s-21.7 19.8-21.1 21.2l9.5 20c.6 1.4 29.5.5 29.5.5l9.4 9.3s-.2 31.8 1.2 32.3l20.1 8.3c1.4.6 20.7-23.5 20.7-23.5l13.1.2s20.5 23.8 21.8 23.3l20-7.5c1.4-.6-.2-32.1-.2-32.1l9.1-9.1s29.2.9 29.7-.5l8.1-19.8c.7-1.1-20.9-20.7-20.9-20.7zm-44.9-8.7c.7 17.1-12.8 31.6-30.1 32.4-17.3.8-32.1-12.5-32.8-29.6-.7-17.1 12.8-31.6 30.1-32.3 17.3-.8 32.1 12.5 32.8 29.5zm201.2-37.9l-97-97-.1.1c-75.1-73.3-195.4-72.8-269.8 1.6-50.9 51-27.8 27.9-95.7 95.3-22.3 22.3-22.3 58.7 0 81 69.9 69.4 46.4 46 97.4 97l.1-.1c75.1 73.3 195.4 72.9 269.8-1.6 51-50.9 27.9-27.9 95.3-95.3 22.3-22.3 22.3-58.7 0-81zM140.4 363.8c-59.6-59.5-59.6-156 0-215.5 59.5-59.6 156-59.5 215.6 0 59.5 59.5 59.6 156 0 215.6-59.6 59.5-156 59.4-215.6-.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPhoenixFramework(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M212.9 344.3c3.8-.1 22.8-1.4 25.6-2.2-2.4-2.6-43.6-1-68-49.6-4.3-8.6-7.5-17.6-6.4-27.6 2.9-25.5 32.9-30 52-18.5 36 21.6 63.3 91.3 113.7 97.5 37 4.5 84.6-17 108.2-45.4-.6-.1-.8-.2-1-.1-.4.1-.8.2-1.1.3-33.3 12.1-94.3 9.7-134.7-14.8-37.6-22.8-53.1-58.7-51.8-74.6 1.8-21.3 22.9-23.2 35.9-19.6 14.4 3.9 24.4 17.6 38.9 27.4 15.6 10.4 32.9 13.7 51.3 10.3 14.9-2.7 34.4-12.3 36.5-14.5-1.1-.1-1.8-.1-2.5-.2-6.2-.6-12.4-.8-18.5-1.7C279.8 194.5 262.1 47.4 138.5 37.9 94.2 34.5 39.1 46 2.2 72.9c-.8.6-1.5 1.2-2.2 1.8.1.2.1.3.2.5.8 0 1.6-.1 2.4-.2 6.3-1 12.5-.8 18.7.3 23.8 4.3 47.7 23.1 55.9 76.5 5.3 34.3-.7 50.8 8 86.1 19 77.1 91 107.6 127.7 106.4zM75.3 64.9c-.9-1-.9-1.2-1.3-2 12.1-2.6 24.2-4.1 36.6-4.8-1.1 14.7-22.2 21.3-35.3 6.8zm196.9 350.5c-42.8 1.2-92-26.7-123.5-61.4-4.6-5-16.8-20.2-18.6-23.4l.4-.4c6.6 4.1 25.7 18.6 54.8 27 24.2 7 48.1 6.3 71.6-3.3 22.7-9.3 41-.5 43.1 2.9-18.5 3.8-20.1 4.4-24 7.9-5.1 4.4-4.6 11.7 7 17.2 26.2 12.4 63-2.8 97.2 25.4 2.4 2 8.1 7.8 10.1 10.7-.1.2-.3.3-.4.5-4.8-1.5-16.4-7.5-40.2-9.3-24.7-2-46.3 5.3-77.5 6.2zm174.8-252c16.4-5.2 41.3-13.4 66.5-3.3 16.1 6.5 26.2 18.7 32.1 34.6 3.5 9.4 5.1 19.7 5.1 28.7-.2 0-.4 0-.6.1-.2-.4-.4-.9-.5-1.3-5-22-29.9-43.8-67.6-29.9-50.2 18.6-130.4 9.7-176.9-48-.7-.9-2.4-1.7-1.3-3.2.1-.2 2.1.6 3 1.3 18.1 13.4 38.3 21.9 60.3 26.2 30.5 6.1 54.6 2.9 79.9-5.2zm102.7 117.5c-32.4.2-33.8 50.1-103.6 64.4-18.2 3.7-38.7 4.6-44.9 4.2v-.4c2.8-1.5 14.7-2.6 29.7-16.6 7.9-7.3 15.3-15.1 22.8-22.9 19.5-20.2 41.4-42.2 81.9-39 23.1 1.8 29.3 8.2 36.1 12.7.3.2.4.5.7.9-.5 0-.7.1-.9 0-7-2.7-14.3-3.3-21.8-3.3zm-12.3-24.1c-.1.2-.1.4-.2.6-28.9-4.4-48-7.9-68.5 4-17 9.9-31.4 20.5-62 24.4-27.1 3.4-45.1 2.4-66.1-8-.3-.2-.6-.4-1-.6 0-.2.1-.3.1-.5 24.9 3.8 36.4 5.1 55.5-5.8 22.3-12.9 40.1-26.6 71.3-31 29.6-4.1 51.3 2.5 70.9 16.9zM268.6 97.3c-.6-.6-1.1-1.2-2.1-2.3 7.6 0 29.7-1.2 53.4 8.4 19.7 8 32.2 21 50.2 32.9 11.1 7.3 23.4 9.3 36.4 8.1 4.3-.4 8.5-1.2 12.8-1.7.4-.1.9 0 1.5.3-.6.4-1.2.9-1.8 1.2-8.1 4-16.7 6.3-25.6 7.1-26.1 2.6-50.3-3.7-73.4-15.4-19.3-9.9-36.4-22.9-51.4-38.6zM640 335.7c-3.5 3.1-22.7 11.6-42.7 5.3-12.3-3.9-19.5-14.9-31.6-24.1-10-7.6-20.9-7.9-28.1-8.4.6-.8.9-1.2 1.2-1.4 14.8-9.2 30.5-12.2 47.3-6.5 12.5 4.2 19.2 13.5 30.4 24.2 10.8 10.4 21 9.9 23.1 10.5.1-.1.2 0 .4.4zm-212.5 137c2.2 1.2 1.6 1.5 1.5 2-18.5-1.4-33.9-7.6-46.8-22.2-21.8-24.7-41.7-27.9-48.6-29.7.5-.2.8-.4 1.1-.4 13.1.1 26.1.7 38.9 3.9 25.3 6.4 35 25.4 41.6 35.3 3.2 4.8 7.3 8.3 12.3 11.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPhoenixSquadron(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 63.38C142.49 27.25 201.55 7.31 260.51 8.81c29.58-.38 59.11 5.37 86.91 15.33-24.13-4.63-49-6.34-73.38-2.45C231.17 27 191 48.84 162.21 80.87c5.67-1 10.78-3.67 16-5.86 18.14-7.87 37.49-13.26 57.23-14.83 19.74-2.13 39.64-.43 59.28 1.92-14.42 2.79-29.12 4.57-43 9.59-34.43 11.07-65.27 33.16-86.3 62.63-13.8 19.71-23.63 42.86-24.67 67.13-.35 16.49 5.22 34.81 19.83 44a53.27 53.27 0 0 0 37.52 6.74c15.45-2.46 30.07-8.64 43.6-16.33 11.52-6.82 22.67-14.55 32-24.25 3.79-3.22 2.53-8.45 2.62-12.79-2.12-.34-4.38-1.11-6.3.3a203 203 0 0 1-35.82 15.37c-20 6.17-42.16 8.46-62.1.78 12.79 1.73 26.06.31 37.74-5.44 20.23-9.72 36.81-25.2 54.44-38.77a526.57 526.57 0 0 1 88.9-55.31c25.71-12 52.94-22.78 81.57-24.12-15.63 13.72-32.15 26.52-46.78 41.38-14.51 14-27.46 29.5-40.11 45.18-3.52 4.6-8.95 6.94-13.58 10.16a150.7 150.7 0 0 0-51.89 60.1c-9.33 19.68-14.5 41.85-11.77 63.65 1.94 13.69 8.71 27.59 20.9 34.91 12.9 8 29.05 8.07 43.48 5.1 32.8-7.45 61.43-28.89 81-55.84 20.44-27.52 30.52-62.2 29.16-96.35-.52-7.5-1.57-15-1.66-22.49 8 19.48 14.82 39.71 16.65 60.83 2 14.28.75 28.76-1.62 42.9-1.91 11-5.67 21.51-7.78 32.43a165 165 0 0 0 39.34-81.07 183.64 183.64 0 0 0-14.21-104.64c20.78 32 32.34 69.58 35.71 107.48.49 12.73.49 25.51 0 38.23A243.21 243.21 0 0 1 482 371.34c-26.12 47.34-68 85.63-117.19 108-78.29 36.23-174.68 31.32-248-14.68A248.34 248.34 0 0 1 25.36 366 238.34 238.34 0 0 1 0 273.08v-31.34C3.93 172 40.87 105.82 96 63.38m222 80.33a79.13 79.13 0 0 0 16-4.48c5-1.77 9.24-5.94 10.32-11.22-8.96 4.99-17.98 9.92-26.32 15.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPhp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 104.5c171.4 0 303.2 72.2 303.2 151.5S491.3 407.5 320 407.5c-171.4 0-303.2-72.2-303.2-151.5S148.7 104.5 320 104.5m0-16.8C143.3 87.7 0 163 0 256s143.3 168.3 320 168.3S640 349 640 256 496.7 87.7 320 87.7zM218.2 242.5c-7.9 40.5-35.8 36.3-70.1 36.3l13.7-70.6c38 0 63.8-4.1 56.4 34.3zM97.4 350.3h36.7l8.7-44.8c41.1 0 66.6 3 90.2-19.1 26.1-24 32.9-66.7 14.3-88.1-9.7-11.2-25.3-16.7-46.5-16.7h-70.7L97.4 350.3zm185.7-213.6h36.5l-8.7 44.8c31.5 0 60.7-2.3 74.8 10.7 14.8 13.6 7.7 31-8.3 113.1h-37c15.4-79.4 18.3-86 12.7-92-5.4-5.8-17.7-4.6-47.4-4.6l-18.8 96.6h-36.5l32.7-168.6zM505 242.5c-8 41.1-36.7 36.3-70.1 36.3l13.7-70.6c38.2 0 63.8-4.1 56.4 34.3zM384.2 350.3H421l8.7-44.8c43.2 0 67.1 2.5 90.2-19.1 26.1-24 32.9-66.7 14.3-88.1-9.7-11.2-25.3-16.7-46.5-16.7H417l-32.8 168.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPiedPiperAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M244 246c-3.2-2-6.3-2.9-10.1-2.9-6.6 0-12.6 3.2-19.3 3.7l1.7 4.9zm135.9 197.9c-19 0-64.1 9.5-79.9 19.8l6.9 45.1c35.7 6.1 70.1 3.6 106-9.8-4.8-10-23.5-55.1-33-55.1zM340.8 177c6.6 2.8 11.5 9.2 22.7 22.1 2-1.4 7.5-5.2 7.5-8.6 0-4.9-11.8-13.2-13.2-23 11.2-5.7 25.2-6 37.6-8.9 68.1-16.4 116.3-52.9 146.8-116.7C548.3 29.3 554 16.1 554.6 2l-2 2.6c-28.4 50-33 63.2-81.3 100-31.9 24.4-69.2 40.2-106.6 54.6l-6.3-.3v-21.8c-19.6 1.6-19.7-14.6-31.6-23-18.7 20.6-31.6 40.8-58.9 51.1-12.7 4.8-19.6 10-25.9 21.8 34.9-16.4 91.2-13.5 98.8-10zM555.5 0l-.6 1.1-.3.9.6-.6zm-59.2 382.1c-33.9-56.9-75.3-118.4-150-115.5l-.3-6c-1.1-13.5 32.8 3.2 35.1-31l-14.4 7.2c-19.8-45.7-8.6-54.3-65.5-54.3-14.7 0-26.7 1.7-41.4 4.6 2.9 18.6 2.2 36.7-10.9 50.3l19.5 5.5c-1.7 3.2-2.9 6.3-2.9 9.8 0 21 42.8 2.9 42.8 33.6 0 18.4-36.8 60.1-54.9 60.1-8 0-53.7-50-53.4-60.1l.3-4.6 52.3-11.5c13-2.6 12.3-22.7-2.9-22.7-3.7 0-43.1 9.2-49.4 10.6-2-5.2-7.5-14.1-13.8-14.1-3.2 0-6.3 3.2-9.5 4-9.2 2.6-31 2.9-21.5 20.1L15.9 298.5c-5.5 1.1-8.9 6.3-8.9 11.8 0 6 5.5 10.9 11.5 10.9 8 0 131.3-28.4 147.4-32.2 2.6 3.2 4.6 6.3 7.8 8.6 20.1 14.4 59.8 85.9 76.4 85.9 24.1 0 58-22.4 71.3-41.9 3.2-4.3 6.9-7.5 12.4-6.9.6 13.8-31.6 34.2-33 43.7-1.4 10.2-1 35.2-.3 41.1 26.7 8.1 52-3.6 77.9-2.9 4.3-21 10.6-41.9 9.8-63.5l-.3-9.5c-1.4-34.2-10.9-38.5-34.8-58.6-1.1-1.1-2.6-2.6-3.7-4 2.2-1.4 1.1-1 4.6-1.7 88.5 0 56.3 183.6 111.5 229.9 33.1-15 72.5-27.9 103.5-47.2-29-25.6-52.6-45.7-72.7-79.9zm-196.2 46.1v27.2l11.8-3.4-2.9-23.8zm-68.7-150.4l24.1 61.2 21-13.8-31.3-50.9zm84.4 154.9l2 12.4c9-1.5 58.4-6.6 58.4-14.1 0-1.4-.6-3.2-.9-4.6-26.8 0-36.9 3.8-59.5 6.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPiedPiperHat(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M640 24.9c-80.8 53.6-89.4 92.5-96.4 104.4-6.7 12.2-11.7 60.3-23.3 83.6-11.7 23.6-54.2 42.2-66.1 50-11.7 7.8-28.3 38.1-41.9 64.2-108.1-4.4-167.4 38.8-259.2 93.6 29.4-9.7 43.3-16.7 43.3-16.7 94.2-36 139.3-68.3 281.1-49.2 1.1 0 1.9.6 2.8.8 3.9 2.2 5.3 6.9 3.1 10.8l-53.9 95.8c-2.5 4.7-7.8 7.2-13.1 6.1-126.8-23.8-226.9 17.3-318.9 18.6C24.1 488 0 453.4 0 451.8c0-1.1.6-1.7 1.7-1.7 0 0 38.3 0 103.1-15.3C178.4 294.5 244 245.4 315.4 245.4c0 0 71.7 0 90.6 61.9 22.8-39.7 28.3-49.2 28.3-49.2 5.3-9.4 35-77.2 86.4-141.4 51.5-64 90.4-79.9 119.3-91.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPiedPiperPp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M205.3 174.6c0 21.1-14.2 38.1-31.7 38.1-7.1 0-12.8-1.2-17.2-3.7v-68c4.4-2.7 10.1-4.2 17.2-4.2 17.5 0 31.7 16.9 31.7 37.8zm52.6 67c-7.1 0-12.8 1.5-17.2 4.2v68c4.4 2.5 10.1 3.7 17.2 3.7 17.4 0 31.7-16.9 31.7-37.8 0-21.1-14.3-38.1-31.7-38.1zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zM185 255.1c41 0 74.2-35.6 74.2-79.6 0-44-33.2-79.6-74.2-79.6-12 0-24.1 3.2-34.6 8.8h-45.7V311l51.8-10.1v-50.6c8.6 3.1 18.1 4.8 28.5 4.8zm158.4 25.3c0-44-33.2-79.6-73.9-79.6-3.2 0-6.4.2-9.6.7-3.7 12.5-10.1 23.8-19.2 33.4-13.8 15-32.2 23.8-51.8 24.8V416l51.8-10.1v-50.6c8.6 3.2 18.2 4.7 28.7 4.7 40.8 0 74-35.6 74-79.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPiedPiperSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 419L0 479.2l.8-328C.8 85.3 54 32 120 32h327.2c-93 28.9-189.9 94.2-253.9 168.6C122.7 282 82.6 338 32 419M448 32S305.2 98.8 261.6 199.1c-23.2 53.6-28.9 118.1-71 158.6-28.9 27.8-69.8 38.2-105.3 56.3-23.2 12-66.4 40.5-84.9 66h328.4c66 0 119.3-53.3 119.3-119.2-.1 0-.1-328.8-.1-328.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPiedPiper(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 480 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M455.93,23.2C429.23,30,387.79,51.69,341.35,90.66A206,206,0,0,0,240,64C125.13,64,32,157.12,32,272s93.13,208,208,208,208-93.13,208-208a207.25,207.25,0,0,0-58.75-144.81,155.35,155.35,0,0,0-17,27.4A176.16,176.16,0,0,1,417.1,272c0,97.66-79.44,177.11-177.09,177.11a175.81,175.81,0,0,1-87.63-23.4c82.94-107.33,150.79-37.77,184.31-226.65,5.79-32.62,28-94.26,126.23-160.18C471,33.45,465.35,20.8,455.93,23.2ZM125,406.4A176.66,176.66,0,0,1,62.9,272C62.9,174.34,142.35,94.9,240,94.9a174,174,0,0,1,76.63,17.75C250.64,174.76,189.77,265.52,125,406.4Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPinterestP(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M204 6.5C101.4 6.5 0 74.9 0 185.6 0 256 39.6 296 63.6 296c9.9 0 15.6-27.6 15.6-35.4 0-9.3-23.7-29.1-23.7-67.8 0-80.4 61.2-137.4 140.4-137.4 68.1 0 118.5 38.7 118.5 109.8 0 53.1-21.3 152.7-90.3 152.7-24.9 0-46.2-18-46.2-43.8 0-37.8 26.4-74.4 26.4-113.4 0-66.2-93.9-54.2-93.9 25.8 0 16.8 2.1 35.4 9.6 50.7-13.8 59.4-42 147.9-42 209.1 0 18.9 2.7 37.5 4.5 56.4 3.4 3.8 1.7 3.4 6.9 1.5 50.4-69 48.6-82.5 71.4-172.8 12.3 23.4 44.1 36 69.3 36 106.2 0 153.9-103.5 153.9-196.8C384 71.3 298.2 6.5 204 6.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPinterestSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 80v352c0 26.5-21.5 48-48 48H154.4c9.8-16.4 22.4-40 27.4-59.3 3-11.5 15.3-58.4 15.3-58.4 8 15.3 31.4 28.2 56.3 28.2 74.1 0 127.4-68.1 127.4-152.7 0-81.1-66.2-141.8-151.4-141.8-106 0-162.2 71.1-162.2 148.6 0 36 19.2 80.8 49.8 95.1 4.7 2.2 7.1 1.2 8.2-3.3.8-3.4 5-20.1 6.8-27.8.6-2.5.3-4.6-1.7-7-10.1-12.3-18.3-34.9-18.3-56 0-54.2 41-106.6 110.9-106.6 60.3 0 102.6 41.1 102.6 99.9 0 66.4-33.5 112.4-77.2 112.4-24.1 0-42.1-19.9-36.4-44.4 6.9-29.2 20.3-60.7 20.3-81.8 0-53-75.5-45.7-75.5 25 0 21.7 7.3 36.5 7.3 36.5-31.4 132.8-36.1 134.5-29.6 192.6l2.2.8H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPinterest(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 256c0 137-111 248-248 248-25.6 0-50.2-3.9-73.4-11.1 10.1-16.5 25.2-43.5 30.8-65 3-11.6 15.4-59 15.4-59 8.1 15.4 31.7 28.5 56.8 28.5 74.8 0 128.7-68.8 128.7-154.3 0-81.9-66.9-143.2-152.9-143.2-107 0-163.9 71.8-163.9 150.1 0 36.4 19.4 81.7 50.3 96.1 4.7 2.2 7.2 1.2 8.3-3.3.8-3.4 5-20.3 6.9-28.1.6-2.5.3-4.7-1.7-7.1-10.1-12.5-18.3-35.3-18.3-56.6 0-54.7 41.4-107.6 112-107.6 60.9 0 103.6 41.5 103.6 100.9 0 67.1-33.9 113.6-78 113.6-24.3 0-42.6-20.1-36.7-44.8 7-29.5 20.5-61.3 20.5-82.6 0-19-10.2-34.9-31.4-34.9-24.9 0-44.9 25.7-44.9 60.2 0 22 7.4 36.8 7.4 36.8s-24.5 103.8-29 123.2c-5 21.4-3 51.6-.9 71.2C65.4 450.9 0 361.1 0 256 0 119 111 8 248 8s248 111 248 248z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPlaystation(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M570.9 372.3c-11.3 14.2-38.8 24.3-38.8 24.3L327 470.2v-54.3l150.9-53.8c17.1-6.1 19.8-14.8 5.8-19.4-13.9-4.6-39.1-3.3-56.2 2.9L327 381.1v-56.4c23.2-7.8 47.1-13.6 75.7-16.8 40.9-4.5 90.9.6 130.2 15.5 44.2 14 49.2 34.7 38 48.9zm-224.4-92.5v-139c0-16.3-3-31.3-18.3-35.6-11.7-3.8-19 7.1-19 23.4v347.9l-93.8-29.8V32c39.9 7.4 98 24.9 129.2 35.4C424.1 94.7 451 128.7 451 205.2c0 74.5-46 102.8-104.5 74.6zM43.2 410.2c-45.4-12.8-53-39.5-32.3-54.8 19.1-14.2 51.7-24.9 51.7-24.9l134.5-47.8v54.5l-96.8 34.6c-17.1 6.1-19.7 14.8-5.8 19.4 13.9 4.6 39.1 3.3 56.2-2.9l46.4-16.9v48.8c-51.6 9.3-101.4 7.3-153.9-10z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaProductHunt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M326.3 218.8c0 20.5-16.7 37.2-37.2 37.2h-70.3v-74.4h70.3c20.5 0 37.2 16.7 37.2 37.2zM504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-128.1-37.2c0-47.9-38.9-86.8-86.8-86.8H169.2v248h49.6v-74.4h70.3c47.9 0 86.8-38.9 86.8-86.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPushed(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 432 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M407 111.9l-98.5-9 14-33.4c10.4-23.5-10.8-40.4-28.7-37L22.5 76.9c-15.1 2.7-26 18.3-21.4 36.6l105.1 348.3c6.5 21.3 36.7 24.2 47.7 7l35.3-80.8 235.2-231.3c16.4-16.8 4.3-42.9-17.4-44.8zM297.6 53.6c5.1-.7 7.5 2.5 5.2 7.4L286 100.9 108.6 84.6l189-31zM22.7 107.9c-3.1-5.1 1-10 6.1-9.1l248.7 22.7-96.9 230.7L22.7 107.9zM136 456.4c-2.6 4-7.9 3.1-9.4-1.2L43.5 179.7l127.7 197.6c-7 15-35.2 79.1-35.2 79.1zm272.8-314.5L210.1 337.3l89.7-213.7 106.4 9.7c4 1.1 5.7 5.3 2.6 8.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPython(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M439.8 200.5c-7.7-30.9-22.3-54.2-53.4-54.2h-40.1v47.4c0 36.8-31.2 67.8-66.8 67.8H172.7c-29.2 0-53.4 25-53.4 54.3v101.8c0 29 25.2 46 53.4 54.3 33.8 9.9 66.3 11.7 106.8 0 26.9-7.8 53.4-23.5 53.4-54.3v-40.7H226.2v-13.6h160.2c31.1 0 42.6-21.7 53.4-54.2 11.2-33.5 10.7-65.7 0-108.6zM286.2 404c11.1 0 20.1 9.1 20.1 20.3 0 11.3-9 20.4-20.1 20.4-11 0-20.1-9.2-20.1-20.4.1-11.3 9.1-20.3 20.1-20.3zM167.8 248.1h106.8c29.7 0 53.4-24.5 53.4-54.3V91.9c0-29-24.4-50.7-53.4-55.6-35.8-5.9-74.7-5.6-106.8.1-45.2 8-53.4 24.7-53.4 55.6v40.7h106.9v13.6h-147c-31.1 0-58.3 18.7-66.8 54.2-9.8 40.7-10.2 66.1 0 108.6 7.6 31.6 25.7 54.2 56.8 54.2H101v-48.8c0-35.3 30.5-66.4 66.8-66.4zm-6.7-142.6c-11.1 0-20.1-9.1-20.1-20.3.1-11.3 9-20.4 20.1-20.4 11 0 20.1 9.2 20.1 20.4s-9 20.3-20.1 20.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaQq(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M433.754 420.445c-11.526 1.393-44.86-52.741-44.86-52.741 0 31.345-16.136 72.247-51.051 101.786 16.842 5.192 54.843 19.167 45.803 34.421-7.316 12.343-125.51 7.881-159.632 4.037-34.122 3.844-152.316 8.306-159.632-4.037-9.045-15.25 28.918-29.214 45.783-34.415-34.92-29.539-51.059-70.445-51.059-101.792 0 0-33.334 54.134-44.859 52.741-5.37-.65-12.424-29.644 9.347-99.704 10.261-33.024 21.995-60.478 40.144-105.779C60.683 98.063 108.982.006 224 0c113.737.006 163.156 96.133 160.264 214.963 18.118 45.223 29.912 72.85 40.144 105.778 21.768 70.06 14.716 99.053 9.346 99.704z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaQuinscape(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M313.6 474.6h-1a158.1 158.1 0 0 1 0-316.2c94.9 0 168.2 83.1 157 176.6 4 5.1 8.2 9.6 11.2 15.3 13.4-30.3 20.3-62.4 20.3-97.7C501.1 117.5 391.6 8 256.5 8S12 117.5 12 252.6s109.5 244.6 244.5 244.6a237.36 237.36 0 0 0 70.4-10.1c-5.2-3.5-8.9-8.1-13.3-12.5zm-.1-.1l.4.1zm78.4-168.9a99.2 99.2 0 1 0 99.2 99.2 99.18 99.18 0 0 0-99.2-99.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaQuora(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M440.5 386.7h-29.3c-1.5 13.5-10.5 30.8-33 30.8-20.5 0-35.3-14.2-49.5-35.8 44.2-34.2 74.7-87.5 74.7-153C403.5 111.2 306.8 32 205 32 105.3 32 7.3 111.7 7.3 228.7c0 134.1 131.3 221.6 249 189C276 451.3 302 480 351.5 480c81.8 0 90.8-75.3 89-93.3zM297 329.2C277.5 300 253.3 277 205.5 277c-30.5 0-54.3 10-69 22.8l12.2 24.3c6.2-3 13-4 19.8-4 35.5 0 53.7 30.8 69.2 61.3-10 3-20.7 4.2-32.7 4.2-75 0-107.5-53-107.5-156.7C97.5 124.5 130 71 205 71c76.2 0 108.7 53.5 108.7 157.7.1 41.8-5.4 75.6-16.7 100.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRProject(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 581 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M581 226.6C581 119.1 450.9 32 290.5 32S0 119.1 0 226.6C0 322.4 103.3 402 239.4 418.1V480h99.1v-61.5c24.3-2.7 47.6-7.4 69.4-13.9L448 480h112l-67.4-113.7c54.5-35.4 88.4-84.9 88.4-139.7zm-466.8 14.5c0-73.5 98.9-133 220.8-133s211.9 40.7 211.9 133c0 50.1-26.5 85-70.3 106.4-2.4-1.6-4.7-2.9-6.4-3.7-10.2-5.2-27.8-10.5-27.8-10.5s86.6-6.4 86.6-92.7-90.6-87.9-90.6-87.9h-199V361c-74.1-21.5-125.2-67.1-125.2-119.9zm225.1 38.3v-55.6c57.8 0 87.8-6.8 87.8 27.3 0 36.5-38.2 28.3-87.8 28.3zm-.9 72.5H365c10.8 0 18.9 11.7 24 19.2-16.1 1.9-33 2.8-50.6 2.9v-22.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRaspberryPi(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 407 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M372 232.5l-3.7-6.5c.1-46.4-21.4-65.3-46.5-79.7 7.6-2 15.4-3.6 17.6-13.2 13.1-3.3 15.8-9.4 17.1-15.8 3.4-2.3 14.8-8.7 13.6-19.7 6.4-4.4 10-10.1 8.1-18.1 6.9-7.5 8.7-13.7 5.8-19.4 8.3-10.3 4.6-15.6 1.1-20.9 6.2-11.2.7-23.2-16.6-21.2-6.9-10.1-21.9-7.8-24.2-7.8-2.6-3.2-6-6-16.5-4.7-6.8-6.1-14.4-5-22.3-2.1-9.3-7.3-15.5-1.4-22.6.8C271.6.6 269 5.5 263.5 7.6c-12.3-2.6-16.1 3-22 8.9l-6.9-.1c-18.6 10.8-27.8 32.8-31.1 44.1-3.3-11.3-12.5-33.3-31.1-44.1l-6.9.1c-5.9-5.9-9.7-11.5-22-8.9-5.6-2-8.1-7-19.4-3.4-4.6-1.4-8.9-4.4-13.9-4.3-2.6.1-5.5 1-8.7 3.5-7.9-3-15.5-4-22.3 2.1-10.5-1.3-14 1.4-16.5 4.7-2.3 0-17.3-2.3-24.2 7.8C21.2 16 15.8 28 22 39.2c-3.5 5.4-7.2 10.7 1.1 20.9-2.9 5.7-1.1 11.9 5.8 19.4-1.8 8 1.8 13.7 8.1 18.1-1.2 11 10.2 17.4 13.6 19.7 1.3 6.4 4 12.4 17.1 15.8 2.2 9.5 10 11.2 17.6 13.2-25.1 14.4-46.6 33.3-46.5 79.7l-3.7 6.5c-28.8 17.2-54.7 72.7-14.2 117.7 2.6 14.1 7.1 24.2 11 35.4 5.9 45.2 44.5 66.3 54.6 68.8 14.9 11.2 30.8 21.8 52.2 29.2C159 504.2 181 512 203 512h1c22.1 0 44-7.8 64.2-28.4 21.5-7.4 37.3-18 52.2-29.2 10.2-2.5 48.7-23.6 54.6-68.8 3.9-11.2 8.4-21.3 11-35.4 40.6-45.1 14.7-100.5-14-117.7zm-22.2-8c-1.5 18.7-98.9-65.1-82.1-67.9 45.7-7.5 83.6 19.2 82.1 67.9zm-43 93.1c-24.5 15.8-59.8 5.6-78.8-22.8s-14.6-64.2 9.9-80c24.5-15.8 59.8-5.6 78.8 22.8s14.6 64.2-9.9 80zM238.9 29.3c.8 4.2 1.8 6.8 2.9 7.6 5.4-5.8 9.8-11.7 16.8-17.3 0 3.3-1.7 6.8 2.5 9.4 3.7-5 8.8-9.5 15.5-13.3-3.2 5.6-.6 7.3 1.2 9.6 5.1-4.4 10-8.8 19.4-12.3-2.6 3.1-6.2 6.2-2.4 9.8 5.3-3.3 10.6-6.6 23.1-8.9-2.8 3.1-8.7 6.3-5.1 9.4 6.6-2.5 14-4.4 22.1-5.4-3.9 3.2-7.1 6.3-3.9 8.8 7.1-2.2 16.9-5.1 26.4-2.6l-6 6.1c-.7.8 14.1.6 23.9.8-3.6 5-7.2 9.7-9.3 18.2 1 1 5.8.4 10.4 0-4.7 9.9-12.8 12.3-14.7 16.6 2.9 2.2 6.8 1.6 11.2.1-3.4 6.9-10.4 11.7-16 17.3 1.4 1 3.9 1.6 9.7.9-5.2 5.5-11.4 10.5-18.8 15 1.3 1.5 5.8 1.5 10 1.6-6.7 6.5-15.3 9.9-23.4 14.2 4 2.7 6.9 2.1 10 2.1-5.7 4.7-15.4 7.1-24.4 10 1.7 2.7 3.4 3.4 7.1 4.1-9.5 5.3-23.2 2.9-27 5.6.9 2.7 3.6 4.4 6.7 5.8-15.4.9-57.3-.6-65.4-32.3 15.7-17.3 44.4-37.5 93.7-62.6-38.4 12.8-73 30-102 53.5-34.3-15.9-10.8-55.9 5.8-71.8zm-34.4 114.6c24.2-.3 54.1 17.8 54 34.7-.1 15-21 27.1-53.8 26.9-32.1-.4-53.7-15.2-53.6-29.8 0-11.9 26.2-32.5 53.4-31.8zm-123-12.8c3.7-.7 5.4-1.5 7.1-4.1-9-2.8-18.7-5.3-24.4-10 3.1 0 6 .7 10-2.1-8.1-4.3-16.7-7.7-23.4-14.2 4.2-.1 8.7 0 10-1.6-7.4-4.5-13.6-9.5-18.8-15 5.8.7 8.3.1 9.7-.9-5.6-5.6-12.7-10.4-16-17.3 4.3 1.5 8.3 2 11.2-.1-1.9-4.2-10-6.7-14.7-16.6 4.6.4 9.4 1 10.4 0-2.1-8.5-5.8-13.3-9.3-18.2 9.8-.1 24.6 0 23.9-.8l-6-6.1c9.5-2.5 19.3.4 26.4 2.6 3.2-2.5-.1-5.6-3.9-8.8 8.1 1.1 15.4 2.9 22.1 5.4 3.5-3.1-2.3-6.3-5.1-9.4 12.5 2.3 17.8 5.6 23.1 8.9 3.8-3.6.2-6.7-2.4-9.8 9.4 3.4 14.3 7.9 19.4 12.3 1.7-2.3 4.4-4 1.2-9.6 6.7 3.8 11.8 8.3 15.5 13.3 4.1-2.6 2.5-6.2 2.5-9.4 7 5.6 11.4 11.5 16.8 17.3 1.1-.8 2-3.4 2.9-7.6 16.6 15.9 40.1 55.9 6 71.8-29-23.5-63.6-40.7-102-53.5 49.3 25 78 45.3 93.7 62.6-8 31.8-50 33.2-65.4 32.3 3.1-1.4 5.8-3.2 6.7-5.8-4-2.8-17.6-.4-27.2-5.6zm60.1 24.1c16.8 2.8-80.6 86.5-82.1 67.9-1.5-48.7 36.5-75.5 82.1-67.9zM38.2 342c-23.7-18.8-31.3-73.7 12.6-98.3 26.5-7 9 107.8-12.6 98.3zm91 98.2c-13.3 7.9-45.8 4.7-68.8-27.9-15.5-27.4-13.5-55.2-2.6-63.4 16.3-9.8 41.5 3.4 60.9 25.6 16.9 20 24.6 55.3 10.5 65.7zm-26.4-119.7c-24.5-15.8-28.9-51.6-9.9-80s54.3-38.6 78.8-22.8 28.9 51.6 9.9 80c-19.1 28.4-54.4 38.6-78.8 22.8zM205 496c-29.4 1.2-58.2-23.7-57.8-32.3-.4-12.7 35.8-22.6 59.3-22 23.7-1 55.6 7.5 55.7 18.9.5 11-28.8 35.9-57.2 35.4zm58.9-124.9c.2 29.7-26.2 53.8-58.8 54-32.6.2-59.2-23.8-59.4-53.4v-.6c-.2-29.7 26.2-53.8 58.8-54 32.6-.2 59.2 23.8 59.4 53.4v.6zm82.2 42.7c-25.3 34.6-59.6 35.9-72.3 26.3-13.3-12.4-3.2-50.9 15.1-72 20.9-23.3 43.3-38.5 58.9-26.6 10.5 10.3 16.7 49.1-1.7 72.3zm22.9-73.2c-21.5 9.4-39-105.3-12.6-98.3 43.9 24.7 36.3 79.6 12.6 98.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRavelry(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M498.252,234.223c-1.208-10.34-1.7-20.826-3.746-31a310.306,310.306,0,0,0-9.622-36.6,184.068,184.068,0,0,0-30.874-57.5,251.154,251.154,0,0,0-18.818-21.689,237.362,237.362,0,0,0-47.113-36.116A240.8,240.8,0,0,0,331.356,26.65c-11.018-3.1-22.272-5.431-33.515-7.615-6.78-1.314-13.749-1.667-20.627-2.482-.316-.036-.6-.358-.9-.553q-16.143.009-32.288.006c-2.41.389-4.808.925-7.236,1.15a179.331,179.331,0,0,0-34.256,7.1,221.5,221.5,0,0,0-39.768,16.355,281.385,281.385,0,0,0-38.08,24.158c-6.167,4.61-12.268,9.36-17.974,14.518C96.539,88.494,86.34,97.72,76.785,107.555a243.878,243.878,0,0,0-33.648,43.95,206.488,206.488,0,0,0-20.494,44.6,198.2,198.2,0,0,0-7.691,34.759A201.13,201.13,0,0,0,13.4,266.385a299.716,299.716,0,0,0,4.425,40.24,226.865,226.865,0,0,0,16.73,53.3,210.543,210.543,0,0,0,24,39.528,213.589,213.589,0,0,0,26.358,28.416A251.313,251.313,0,0,0,126.7,458.455a287.831,287.831,0,0,0,55.9,25.277,269.5,269.5,0,0,0,40.641,9.835c6.071,1.01,12.275,1.253,18.412,1.873a4.149,4.149,0,0,1,1.19.56h32.289c2.507-.389,5-.937,7.527-1.143,16.336-1.332,32.107-5.335,47.489-10.717A219.992,219.992,0,0,0,379.1,460.322c9.749-6.447,19.395-13.077,28.737-20.1,5.785-4.348,10.988-9.5,16.3-14.457,3.964-3.7,7.764-7.578,11.51-11.5a232.162,232.162,0,0,0,31.427-41.639c9.542-16.045,17.355-32.905,22.3-50.926,2.859-10.413,4.947-21.045,7.017-31.652,1.032-5.279,1.251-10.723,1.87-16.087.036-.317.358-.6.552-.9V236.005A9.757,9.757,0,0,1,498.252,234.223Zm-161.117-1.15s-16.572-2.98-28.47-2.98c-27.2,0-33.57,14.9-33.57,37.04V360.8H201.582V170.062H275.1v31.931c8.924-26.822,26.771-36.189,62.04-36.189Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaReact(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M418.2 177.2c-5.4-1.8-10.8-3.5-16.2-5.1.9-3.7 1.7-7.4 2.5-11.1 12.3-59.6 4.2-107.5-23.1-123.3-26.3-15.1-69.2.6-112.6 38.4-4.3 3.7-8.5 7.6-12.5 11.5-2.7-2.6-5.5-5.2-8.3-7.7-45.5-40.4-91.1-57.4-118.4-41.5-26.2 15.2-34 60.3-23 116.7 1.1 5.6 2.3 11.1 3.7 16.7-6.4 1.8-12.7 3.8-18.6 5.9C38.3 196.2 0 225.4 0 255.6c0 31.2 40.8 62.5 96.3 81.5 4.5 1.5 9 3 13.6 4.3-1.5 6-2.8 11.9-4 18-10.5 55.5-2.3 99.5 23.9 114.6 27 15.6 72.4-.4 116.6-39.1 3.5-3.1 7-6.3 10.5-9.7 4.4 4.3 9 8.4 13.6 12.4 42.8 36.8 85.1 51.7 111.2 36.6 27-15.6 35.8-62.9 24.4-120.5-.9-4.4-1.9-8.9-3-13.5 3.2-.9 6.3-1.9 9.4-2.9 57.7-19.1 99.5-50 99.5-81.7 0-30.3-39.4-59.7-93.8-78.4zM282.9 92.3c37.2-32.4 71.9-45.1 87.7-36 16.9 9.7 23.4 48.9 12.8 100.4-.7 3.4-1.4 6.7-2.3 10-22.2-5-44.7-8.6-67.3-10.6-13-18.6-27.2-36.4-42.6-53.1 3.9-3.7 7.7-7.2 11.7-10.7zM167.2 307.5c5.1 8.7 10.3 17.4 15.8 25.9-15.6-1.7-31.1-4.2-46.4-7.5 4.4-14.4 9.9-29.3 16.3-44.5 4.6 8.8 9.3 17.5 14.3 26.1zm-30.3-120.3c14.4-3.2 29.7-5.8 45.6-7.8-5.3 8.3-10.5 16.8-15.4 25.4-4.9 8.5-9.7 17.2-14.2 26-6.3-14.9-11.6-29.5-16-43.6zm27.4 68.9c6.6-13.8 13.8-27.3 21.4-40.6s15.8-26.2 24.4-38.9c15-1.1 30.3-1.7 45.9-1.7s31 .6 45.9 1.7c8.5 12.6 16.6 25.5 24.3 38.7s14.9 26.7 21.7 40.4c-6.7 13.8-13.9 27.4-21.6 40.8-7.6 13.3-15.7 26.2-24.2 39-14.9 1.1-30.4 1.6-46.1 1.6s-30.9-.5-45.6-1.4c-8.7-12.7-16.9-25.7-24.6-39s-14.8-26.8-21.5-40.6zm180.6 51.2c5.1-8.8 9.9-17.7 14.6-26.7 6.4 14.5 12 29.2 16.9 44.3-15.5 3.5-31.2 6.2-47 8 5.4-8.4 10.5-17 15.5-25.6zm14.4-76.5c-4.7-8.8-9.5-17.6-14.5-26.2-4.9-8.5-10-16.9-15.3-25.2 16.1 2 31.5 4.7 45.9 8-4.6 14.8-10 29.2-16.1 43.4zM256.2 118.3c10.5 11.4 20.4 23.4 29.6 35.8-19.8-.9-39.7-.9-59.5 0 9.8-12.9 19.9-24.9 29.9-35.8zM140.2 57c16.8-9.8 54.1 4.2 93.4 39 2.5 2.2 5 4.6 7.6 7-15.5 16.7-29.8 34.5-42.9 53.1-22.6 2-45 5.5-67.2 10.4-1.3-5.1-2.4-10.3-3.5-15.5-9.4-48.4-3.2-84.9 12.6-94zm-24.5 263.6c-4.2-1.2-8.3-2.5-12.4-3.9-21.3-6.7-45.5-17.3-63-31.2-10.1-7-16.9-17.8-18.8-29.9 0-18.3 31.6-41.7 77.2-57.6 5.7-2 11.5-3.8 17.3-5.5 6.8 21.7 15 43 24.5 63.6-9.6 20.9-17.9 42.5-24.8 64.5zm116.6 98c-16.5 15.1-35.6 27.1-56.4 35.3-11.1 5.3-23.9 5.8-35.3 1.3-15.9-9.2-22.5-44.5-13.5-92 1.1-5.6 2.3-11.2 3.7-16.7 22.4 4.8 45 8.1 67.9 9.8 13.2 18.7 27.7 36.6 43.2 53.4-3.2 3.1-6.4 6.1-9.6 8.9zm24.5-24.3c-10.2-11-20.4-23.2-30.3-36.3 9.6.4 19.5.6 29.5.6 10.3 0 20.4-.2 30.4-.7-9.2 12.7-19.1 24.8-29.6 36.4zm130.7 30c-.9 12.2-6.9 23.6-16.5 31.3-15.9 9.2-49.8-2.8-86.4-34.2-4.2-3.6-8.4-7.5-12.7-11.5 15.3-16.9 29.4-34.8 42.2-53.6 22.9-1.9 45.7-5.4 68.2-10.5 1 4.1 1.9 8.2 2.7 12.2 4.9 21.6 5.7 44.1 2.5 66.3zm18.2-107.5c-2.8.9-5.6 1.8-8.5 2.6-7-21.8-15.6-43.1-25.5-63.8 9.6-20.4 17.7-41.4 24.5-62.9 5.2 1.5 10.2 3.1 15 4.7 46.6 16 79.3 39.8 79.3 58 0 19.6-34.9 44.9-84.8 61.4zm-149.7-15c25.3 0 45.8-20.5 45.8-45.8s-20.5-45.8-45.8-45.8c-25.3 0-45.8 20.5-45.8 45.8s20.5 45.8 45.8 45.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaReacteurope(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M250.6 211.74l5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3-7.1-.1-2.3-6.8-2.3 6.8-7.2.1 5.7 4.3zm63.7 0l5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3-7.2-.1-2.3-6.8-2.3 6.8-7.2.1 5.7 4.3zm-91.3 50.5h-3.4c-4.8 0-3.8 4-3.8 12.1 0 4.7-2.3 6.1-5.8 6.1s-5.8-1.4-5.8-6.1v-36.6c0-4.7 2.3-6.1 5.8-6.1s5.8 1.4 5.8 6.1c0 7.2-.7 10.5 3.8 10.5h3.4c4.7-.1 3.8-3.9 3.8-12.3 0-9.9-6.7-14.1-16.8-14.1h-.2c-10.1 0-16.8 4.2-16.8 14.1V276c0 10.4 6.7 14.1 16.8 14.1h.2c10.1 0 16.8-3.8 16.8-14.1 0-9.86 1.1-13.76-3.8-13.76zm-80.7 17.4h-14.7v-19.3H139c2.5 0 3.8-1.3 3.8-3.8v-2.1c0-2.5-1.3-3.8-3.8-3.8h-11.4v-18.3H142c2.5 0 3.8-1.3 3.8-3.8v-2.1c0-2.5-1.3-3.8-3.8-3.8h-21.7c-2.4-.1-3.7 1.3-3.7 3.8v59.1c0 2.5 1.3 3.8 3.8 3.8h21.9c2.5 0 3.8-1.3 3.8-3.8v-2.1c0-2.5-1.3-3.8-3.8-3.8zm-42-18.5c4.6-2 7.3-6 7.3-12.4v-11.9c0-10.1-6.7-14.1-16.8-14.1H77.4c-2.5 0-3.8 1.3-3.8 3.8v59.1c0 2.5 1.3 3.8 3.8 3.8h3.4c2.5 0 3.8-1.3 3.8-3.8v-22.9h5.6l7.4 23.5a4.1 4.1 0 0 0 4.3 3.2h3.3c2.8 0 4-1.8 3.2-4.4zm-3.8-14c0 4.8-2.5 6.1-6.1 6.1h-5.8v-20.9h5.8c3.6 0 6.1 1.3 6.1 6.1zM176 226a3.82 3.82 0 0 0-4.2-3.4h-6.9a3.68 3.68 0 0 0-4 3.4l-11 59.2c-.5 2.7.9 4.1 3.4 4.1h3a3.74 3.74 0 0 0 4.1-3.5l1.8-11.3h12.2l1.8 11.3a3.74 3.74 0 0 0 4.1 3.5h3.5c2.6 0 3.9-1.4 3.4-4.1zm-12.3 39.3l4.7-29.7 4.7 29.7zm89.3 20.2v-53.2h7.5c2.5 0 3.8-1.3 3.8-3.8v-2.1c0-2.5-1.3-3.8-3.8-3.8h-25.8c-2.5 0-3.8 1.3-3.8 3.8v2.1c0 2.5 1.3 3.8 3.8 3.8h7.3v53.2c0 2.5 1.3 3.8 3.8 3.8h3.4c2.5.04 3.8-1.3 3.8-3.76zm248-.8h-19.4V258h16.1a1.89 1.89 0 0 0 2-2v-.8a1.89 1.89 0 0 0-2-2h-16.1v-25.8h19.1a1.89 1.89 0 0 0 2-2v-.8a1.77 1.77 0 0 0-2-1.9h-22.2a1.62 1.62 0 0 0-2 1.8v63a1.81 1.81 0 0 0 2 1.9H501a1.81 1.81 0 0 0 2-1.9v-.8a1.84 1.84 0 0 0-2-1.96zm-93.1-62.9h-.8c-10.1 0-15.3 4.7-15.3 14.1V276c0 9.3 5.2 14.1 15.3 14.1h.8c10.1 0 15.3-4.8 15.3-14.1v-40.1c0-9.36-5.2-14.06-15.3-14.06zm10.2 52.4c-.1 8-3 11.1-10.5 11.1s-10.5-3.1-10.5-11.1v-36.6c0-7.9 3-11.1 10.5-11.1s10.5 3.2 10.5 11.1zm-46.5-14.5c6.1-1.6 9.2-6.1 9.2-13.3v-9.7c0-9.4-5.2-14.1-15.3-14.1h-13.7a1.81 1.81 0 0 0-2 1.9v63a1.81 1.81 0 0 0 2 1.9h1.2a1.74 1.74 0 0 0 1.9-1.9v-26.9h11.6l10.4 27.2a2.32 2.32 0 0 0 2.3 1.5h1.5c1.4 0 2-1 1.5-2.3zm-6.4-3.9H355v-28.5h10.2c7.5 0 10.5 3.1 10.5 11.1v6.4c0 7.84-3 11.04-10.5 11.04zm85.9-33.1h-13.7a1.62 1.62 0 0 0-2 1.8v63a1.81 1.81 0 0 0 2 1.9h1.2a1.74 1.74 0 0 0 1.9-1.9v-26.1h10.6c10.1 0 15.3-4.8 15.3-14.1v-10.5c0-9.4-5.2-14.1-15.3-14.1zm10.2 22.8c0 7.9-3 11.1-10.5 11.1h-10.2v-29.2h10.2c7.5-.1 10.5 3.1 10.5 11zM259.5 308l-2.3-6.8-2.3 6.8-7.1.1 5.7 4.3-2.1 6.8 5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3zm227.6-136.1a364.42 364.42 0 0 0-35.6-11.3c19.6-78 11.6-134.7-22.3-153.9C394.7-12.66 343.3 11 291 61.94q5.1 4.95 10.2 10.2c82.5-80 119.6-53.5 120.9-52.8 22.4 12.7 36 55.8 15.5 137.8a587.83 587.83 0 0 0-84.6-13C281.1 43.64 212.4 2 170.8 2 140 2 127 23 123.2 29.74c-18.1 32-13.3 84.2.1 133.8-70.5 20.3-120.7 54.1-120.3 95 .5 59.6 103.2 87.8 122.1 92.8-20.5 81.9-10.1 135.6 22.3 153.9 28 15.8 75.1 6 138.2-55.2q-5.1-4.95-10.2-10.2c-82.5 80-119.7 53.5-120.9 52.8-22.3-12.6-36-55.6-15.5-137.9 12.4 2.9 41.8 9.5 84.6 13 71.9 100.4 140.6 142 182.1 142 30.8 0 43.8-21 47.6-27.7 18-31.9 13.3-84.1-.1-133.8 152.3-43.8 156.2-130.2 33.9-176.3zM135.9 36.84c2.9-5.1 11.9-20.3 34.9-20.3 36.8 0 98.8 39.6 163.3 126.2a714 714 0 0 0-93.9.9 547.76 547.76 0 0 1 42.2-52.4Q277.3 86 272.2 81a598.25 598.25 0 0 0-50.7 64.2 569.69 569.69 0 0 0-84.4 14.6c-.2-1.4-24.3-82.2-1.2-123zm304.8 438.3c-2.9 5.1-11.8 20.3-34.9 20.3-36.7 0-98.7-39.4-163.3-126.2a695.38 695.38 0 0 0 93.9-.9 547.76 547.76 0 0 1-42.2 52.4q5.1 5.25 10.2 10.2a588.47 588.47 0 0 0 50.7-64.2c47.3-4.7 80.3-13.5 84.4-14.6 22.7 84.4 4.5 117 1.2 123zm9.1-138.6c-3.6-11.9-7.7-24.1-12.4-36.4a12.67 12.67 0 0 1-10.7-5.7l-.1.1a19.61 19.61 0 0 1-5.4 3.6c5.7 14.3 10.6 28.4 14.7 42.2a535.3 535.3 0 0 1-72 13c3.5-5.3 17.2-26.2 32.2-54.2a24.6 24.6 0 0 1-6-3.2c-1.1 1.2-3.6 4.2-10.9 4.2-6.2 11.2-17.4 30.9-33.9 55.2a711.91 711.91 0 0 1-112.4 1c-7.9-11.2-21.5-31.1-36.8-57.8a21 21 0 0 1-3-1.5c-1.9 1.6-3.9 3.2-12.6 3.2 6.3 11.2 17.5 30.7 33.8 54.6a548.81 548.81 0 0 1-72.2-11.7q5.85-21 14.1-42.9c-3.2 0-5.4.2-8.4-1a17.58 17.58 0 0 1-6.9 1c-4.9 13.4-9.1 26.5-12.7 39.4C-31.7 297-12.1 216 126.7 175.64c3.6 11.9 7.7 24.1 12.4 36.4 10.4 0 12.9 3.4 14.4 5.3a12 12 0 0 1 2.3-2.2c-5.8-14.7-10.9-29.2-15.2-43.3 7-1.8 32.4-8.4 72-13-15.9 24.3-26.7 43.9-32.8 55.3a14.22 14.22 0 0 1 6.4 8 23.42 23.42 0 0 1 10.2-8.4c6.5-11.7 17.9-31.9 34.8-56.9a711.72 711.72 0 0 1 112.4-1c31.5 44.6 28.9 48.1 42.5 64.5a21.42 21.42 0 0 1 10.4-7.4c-6.4-11.4-17.6-31-34.3-55.5 40.4 4.1 65 10 72.2 11.7-4 14.4-8.9 29.2-14.6 44.2a20.74 20.74 0 0 1 6.8 4.3l.1.1a12.72 12.72 0 0 1 8.9-5.6c4.9-13.4 9.2-26.6 12.8-39.5a359.71 359.71 0 0 1 34.5 11c106.1 39.9 74 87.9 72.6 90.4-19.8 35.1-80.1 55.2-105.7 62.5zm-114.4-114h-1.2a1.74 1.74 0 0 0-1.9 1.9v49.8c0 7.9-2.6 11.1-10.1 11.1s-10.1-3.1-10.1-11.1v-49.8a1.69 1.69 0 0 0-1.9-1.9H309a1.81 1.81 0 0 0-2 1.9v51.5c0 9.6 5 14.1 15.1 14.1h.4c10.1 0 15.1-4.6 15.1-14.1v-51.5a2 2 0 0 0-2.2-1.9zM321.7 308l-2.3-6.8-2.3 6.8-7.1.1 5.7 4.3-2.1 6.8 5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3zm-31.1 7.4l-2.3-6.8-2.3 6.8-7.1.1 5.7 4.3-2.1 6.8 5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3zm5.1-30.8h-19.4v-26.7h16.1a1.89 1.89 0 0 0 2-2v-.8a1.89 1.89 0 0 0-2-2h-16.1v-25.8h19.1a1.89 1.89 0 0 0 2-2v-.8a1.77 1.77 0 0 0-2-1.9h-22.2a1.81 1.81 0 0 0-2 1.9v63a1.81 1.81 0 0 0 2 1.9h22.5a1.77 1.77 0 0 0 2-1.9v-.8a1.83 1.83 0 0 0-2-2.06zm-7.4-99.4L286 192l-7.1.1 5.7 4.3-2.1 6.8 5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3-7.1-.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaReadme(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528.3 46.5H388.5c-48.1 0-89.9 33.3-100.4 80.3-10.6-47-52.3-80.3-100.4-80.3H48c-26.5 0-48 21.5-48 48v245.8c0 26.5 21.5 48 48 48h89.7c102.2 0 132.7 24.4 147.3 75 .7 2.8 5.2 2.8 6 0 14.7-50.6 45.2-75 147.3-75H528c26.5 0 48-21.5 48-48V94.6c0-26.4-21.3-47.9-47.7-48.1zM242 311.9c0 1.9-1.5 3.5-3.5 3.5H78.2c-1.9 0-3.5-1.5-3.5-3.5V289c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5v22.9zm0-60.9c0 1.9-1.5 3.5-3.5 3.5H78.2c-1.9 0-3.5-1.5-3.5-3.5v-22.9c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5V251zm0-60.9c0 1.9-1.5 3.5-3.5 3.5H78.2c-1.9 0-3.5-1.5-3.5-3.5v-22.9c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5v22.9zm259.3 121.7c0 1.9-1.5 3.5-3.5 3.5H337.5c-1.9 0-3.5-1.5-3.5-3.5v-22.9c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5v22.9zm0-60.9c0 1.9-1.5 3.5-3.5 3.5H337.5c-1.9 0-3.5-1.5-3.5-3.5V228c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5v22.9zm0-60.9c0 1.9-1.5 3.5-3.5 3.5H337.5c-1.9 0-3.5-1.5-3.5-3.5v-22.8c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5V190z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRebel(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256.5 504C117.2 504 9 387.8 13.2 249.9 16 170.7 56.4 97.7 129.7 49.5c.3 0 1.9-.6 1.1.8-5.8 5.5-111.3 129.8-14.1 226.4 49.8 49.5 90 2.5 90 2.5 38.5-50.1-.6-125.9-.6-125.9-10-24.9-45.7-40.1-45.7-40.1l28.8-31.8c24.4 10.5 43.2 38.7 43.2 38.7.8-29.6-21.9-61.4-21.9-61.4L255.1 8l44.3 50.1c-20.5 28.8-21.9 62.6-21.9 62.6 13.8-23 43.5-39.3 43.5-39.3l28.5 31.8c-27.4 8.9-45.4 39.9-45.4 39.9-15.8 28.5-27.1 89.4.6 127.3 32.4 44.6 87.7-2.8 87.7-2.8 102.7-91.9-10.5-225-10.5-225-6.1-5.5.8-2.8.8-2.8 50.1 36.5 114.6 84.4 116.2 204.8C500.9 400.2 399 504 256.5 504z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRedRiver(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M353.2 32H94.8C42.4 32 0 74.4 0 126.8v258.4C0 437.6 42.4 480 94.8 480h258.4c52.4 0 94.8-42.4 94.8-94.8V126.8c0-52.4-42.4-94.8-94.8-94.8zM144.9 200.9v56.3c0 27-21.9 48.9-48.9 48.9V151.9c0-13.2 10.7-23.9 23.9-23.9h154.2c0 27-21.9 48.9-48.9 48.9h-56.3c-12.3-.6-24.6 11.6-24 24zm176.3 72h-56.3c-12.3-.6-24.6 11.6-24 24v56.3c0 27-21.9 48.9-48.9 48.9V247.9c0-13.2 10.7-23.9 23.9-23.9h154.2c0 27-21.9 48.9-48.9 48.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRedditAlien(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M440.3 203.5c-15 0-28.2 6.2-37.9 15.9-35.7-24.7-83.8-40.6-137.1-42.3L293 52.3l88.2 19.8c0 21.6 17.6 39.2 39.2 39.2 22 0 39.7-18.1 39.7-39.7s-17.6-39.7-39.7-39.7c-15.4 0-28.7 9.3-35.3 22l-97.4-21.6c-4.9-1.3-9.7 2.2-11 7.1L246.3 177c-52.9 2.2-100.5 18.1-136.3 42.8-9.7-10.1-23.4-16.3-38.4-16.3-55.6 0-73.8 74.6-22.9 100.1-1.8 7.9-2.6 16.3-2.6 24.7 0 83.8 94.4 151.7 210.3 151.7 116.4 0 210.8-67.9 210.8-151.7 0-8.4-.9-17.2-3.1-25.1 49.9-25.6 31.5-99.7-23.8-99.7zM129.4 308.9c0-22 17.6-39.7 39.7-39.7 21.6 0 39.2 17.6 39.2 39.7 0 21.6-17.6 39.2-39.2 39.2-22 .1-39.7-17.6-39.7-39.2zm214.3 93.5c-36.4 36.4-139.1 36.4-175.5 0-4-3.5-4-9.7 0-13.7 3.5-3.5 9.7-3.5 13.2 0 27.8 28.5 120 29 149 0 3.5-3.5 9.7-3.5 13.2 0 4.1 4 4.1 10.2.1 13.7zm-.8-54.2c-21.6 0-39.2-17.6-39.2-39.2 0-22 17.6-39.7 39.2-39.7 22 0 39.7 17.6 39.7 39.7-.1 21.5-17.7 39.2-39.7 39.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRedditSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M283.2 345.5c2.7 2.7 2.7 6.8 0 9.2-24.5 24.5-93.8 24.6-118.4 0-2.7-2.4-2.7-6.5 0-9.2 2.4-2.4 6.5-2.4 8.9 0 18.7 19.2 81 19.6 100.5 0 2.4-2.3 6.6-2.3 9 0zm-91.3-53.8c0-14.9-11.9-26.8-26.5-26.8-14.9 0-26.8 11.9-26.8 26.8 0 14.6 11.9 26.5 26.8 26.5 14.6 0 26.5-11.9 26.5-26.5zm90.7-26.8c-14.6 0-26.5 11.9-26.5 26.8 0 14.6 11.9 26.5 26.5 26.5 14.9 0 26.8-11.9 26.8-26.5 0-14.9-11.9-26.8-26.8-26.8zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-99.7 140.6c-10.1 0-19 4.2-25.6 10.7-24.1-16.7-56.5-27.4-92.5-28.6l18.7-84.2 59.5 13.4c0 14.6 11.9 26.5 26.5 26.5 14.9 0 26.8-12.2 26.8-26.8 0-14.6-11.9-26.8-26.8-26.8-10.4 0-19.3 6.2-23.8 14.9l-65.7-14.6c-3.3-.9-6.5 1.5-7.4 4.8l-20.5 92.8c-35.7 1.5-67.8 12.2-91.9 28.9-6.5-6.8-15.8-11-25.9-11-37.5 0-49.8 50.4-15.5 67.5-1.2 5.4-1.8 11-1.8 16.7 0 56.5 63.7 102.3 141.9 102.3 78.5 0 142.2-45.8 142.2-102.3 0-5.7-.6-11.6-2.1-17 33.6-17.2 21.2-67.2-16.1-67.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaReddit(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M201.5 305.5c-13.8 0-24.9-11.1-24.9-24.6 0-13.8 11.1-24.9 24.9-24.9 13.6 0 24.6 11.1 24.6 24.9 0 13.6-11.1 24.6-24.6 24.6zM504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-132.3-41.2c-9.4 0-17.7 3.9-23.8 10-22.4-15.5-52.6-25.5-86.1-26.6l17.4-78.3 55.4 12.5c0 13.6 11.1 24.6 24.6 24.6 13.8 0 24.9-11.3 24.9-24.9s-11.1-24.9-24.9-24.9c-9.7 0-18 5.8-22.1 13.8l-61.2-13.6c-3-.8-6.1 1.4-6.9 4.4l-19.1 86.4c-33.2 1.4-63.1 11.3-85.5 26.8-6.1-6.4-14.7-10.2-24.1-10.2-34.9 0-46.3 46.9-14.4 62.8-1.1 5-1.7 10.2-1.7 15.5 0 52.6 59.2 95.2 132 95.2 73.1 0 132.3-42.6 132.3-95.2 0-5.3-.6-10.8-1.9-15.8 31.3-16 19.8-62.5-14.9-62.5zM302.8 331c-18.2 18.2-76.1 17.9-93.6 0-2.2-2.2-6.1-2.2-8.3 0-2.5 2.5-2.5 6.4 0 8.6 22.8 22.8 87.3 22.8 110.2 0 2.5-2.2 2.5-6.1 0-8.6-2.2-2.2-6.1-2.2-8.3 0zm7.7-75c-13.6 0-24.6 11.1-24.6 24.9 0 13.6 11.1 24.6 24.6 24.6 13.8 0 24.9-11.1 24.9-24.6 0-13.8-11-24.9-24.9-24.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRedhat(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M341.52 285.56c33.65 0 82.34-6.94 82.34-47 .22-6.74.86-1.82-20.88-96.24-4.62-19.15-8.68-27.84-42.31-44.65-26.09-13.34-82.92-35.37-99.73-35.37-15.66 0-20.2 20.17-38.87 20.17-18 0-31.31-15.06-48.12-15.06-16.14 0-26.66 11-34.78 33.62-27.5 77.55-26.28 74.27-26.12 78.27 0 24.8 97.64 106.11 228.47 106.11M429 254.84c4.65 22 4.65 24.35 4.65 27.25 0 37.66-42.33 58.56-98 58.56-125.74.08-235.91-73.65-235.91-122.33a49.55 49.55 0 0 1 4.06-19.72C58.56 200.86 0 208.93 0 260.63c0 84.67 200.63 189 359.49 189 121.79 0 152.51-55.08 152.51-98.58 0-34.21-29.59-73.05-82.93-96.24"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRenren(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M214 169.1c0 110.4-61 205.4-147.6 247.4C30 373.2 8 317.7 8 256.6 8 133.9 97.1 32.2 214 12.5v156.6zM255 504c-42.9 0-83.3-11-118.5-30.4C193.7 437.5 239.9 382.9 255 319c15.5 63.9 61.7 118.5 118.8 154.7C338.7 493 298.3 504 255 504zm190.6-87.5C359 374.5 298 279.6 298 169.1V12.5c116.9 19.7 206 121.4 206 244.1 0 61.1-22 116.6-58.4 159.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaReplyd(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 480H128C57.6 480 0 422.4 0 352V160C0 89.6 57.6 32 128 32h192c70.4 0 128 57.6 128 128v192c0 70.4-57.6 128-128 128zM193.4 273.2c-6.1-2-11.6-3.1-16.4-3.1-7.2 0-13.5 1.9-18.9 5.6-5.4 3.7-9.6 9-12.8 15.8h-1.1l-4.2-18.3h-28v138.9h36.1v-89.7c1.5-5.4 4.4-9.8 8.7-13.2 4.3-3.4 9.8-5.1 16.2-5.1 4.6 0 9.8 1 15.6 3.1l4.8-34zm115.2 103.4c-3.2 2.4-7.7 4.8-13.7 7.1-6 2.3-12.8 3.5-20.4 3.5-12.2 0-21.1-3-26.5-8.9-5.5-5.9-8.5-14.7-9-26.4h83.3c.9-4.8 1.6-9.4 2.1-13.9.5-4.4.7-8.6.7-12.5 0-10.7-1.6-19.7-4.7-26.9-3.2-7.2-7.3-13-12.5-17.2-5.2-4.3-11.1-7.3-17.8-9.2-6.7-1.8-13.5-2.8-20.6-2.8-21.1 0-37.5 6.1-49.2 18.3s-17.5 30.5-17.5 55c0 22.8 5.2 40.7 15.6 53.7 10.4 13.1 26.8 19.6 49.2 19.6 10.7 0 20.9-1.5 30.4-4.6 9.5-3.1 17.1-6.8 22.6-11.2l-12-23.6zm-21.8-70.3c3.8 5.4 5.3 13.1 4.6 23.1h-51.7c.9-9.4 3.7-17 8.2-22.6 4.5-5.6 11.5-8.5 21-8.5 8.2-.1 14.1 2.6 17.9 8zm79.9 2.5c4.1 3.9 9.4 5.8 16.1 5.8 7 0 12.6-1.9 16.7-5.8s6.1-9.1 6.1-15.6-2-11.6-6.1-15.4c-4.1-3.8-9.6-5.7-16.7-5.7-6.7 0-12 1.9-16.1 5.7-4.1 3.8-6.1 8.9-6.1 15.4s2 11.7 6.1 15.6zm0 100.5c4.1 3.9 9.4 5.8 16.1 5.8 7 0 12.6-1.9 16.7-5.8s6.1-9.1 6.1-15.6-2-11.6-6.1-15.4c-4.1-3.8-9.6-5.7-16.7-5.7-6.7 0-12 1.9-16.1 5.7-4.1 3.8-6.1 8.9-6.1 15.4 0 6.6 2 11.7 6.1 15.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaResearchgate(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32v448h448V32H0zm262.2 334.4c-6.6 3-33.2 6-50-14.2-9.2-10.6-25.3-33.3-42.2-63.6-8.9 0-14.7 0-21.4-.6v46.4c0 23.5 6 21.2 25.8 23.9v8.1c-6.9-.3-23.1-.8-35.6-.8-13.1 0-26.1.6-33.6.8v-8.1c15.5-2.9 22-1.3 22-23.9V225c0-22.6-6.4-21-22-23.9V193c25.8 1 53.1-.6 70.9-.6 31.7 0 55.9 14.4 55.9 45.6 0 21.1-16.7 42.2-39.2 47.5 13.6 24.2 30 45.6 42.2 58.9 7.2 7.8 17.2 14.7 27.2 14.7v7.3zm22.9-135c-23.3 0-32.2-15.7-32.2-32.2V167c0-12.2 8.8-30.4 34-30.4s30.4 17.9 30.4 17.9l-10.7 7.2s-5.5-12.5-19.7-12.5c-7.9 0-19.7 7.3-19.7 19.7v26.8c0 13.4 6.6 23.3 17.9 23.3 14.1 0 21.5-10.9 21.5-26.8h-17.9v-10.7h30.4c0 20.5 4.7 49.9-34 49.9zm-116.5 44.7c-9.4 0-13.6-.3-20-.8v-69.7c6.4-.6 15-.6 22.5-.6 23.3 0 37.2 12.2 37.2 34.5 0 21.9-15 36.6-39.7 36.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaResolving(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M281.2 278.2c46-13.3 49.6-23.5 44-43.4L314 195.5c-6.1-20.9-18.4-28.1-71.1-12.8L54.7 236.8l28.6 98.6 197.9-57.2zM248.5 8C131.4 8 33.2 88.7 7.2 197.5l221.9-63.9c34.8-10.2 54.2-11.7 79.3-8.2 36.3 6.1 52.7 25 61.4 55.2l10.7 37.8c8.2 28.1 1 50.6-23.5 73.6-19.4 17.4-31.2 24.5-61.4 33.2L203 351.8l220.4 27.1 9.7 34.2-48.1 13.3-286.8-37.3 23 80.2c36.8 22 80.3 34.7 126.3 34.7 137 0 248.5-111.4 248.5-248.3C497 119.4 385.5 8 248.5 8zM38.3 388.6L0 256.8c0 48.5 14.3 93.4 38.3 131.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRev(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M289.67 274.89a65.57 65.57 0 1 1-65.56-65.56 65.64 65.64 0 0 1 65.56 65.56zm139.55-5.05h-.13a204.69 204.69 0 0 0-74.32-153l-45.38 26.2a157.07 157.07 0 0 1 71.81 131.84C381.2 361.5 310.73 432 224.11 432S67 361.5 67 274.88c0-81.88 63-149.27 143-156.43v39.12l108.77-62.79L210 32v38.32c-106.7 7.25-191 96-191 204.57 0 111.59 89.12 202.29 200.06 205v.11h210.16V269.84z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRocketchat(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M284.046,224.8a34.114,34.114,0,1,0,34.317,34.113A34.217,34.217,0,0,0,284.046,224.8Zm-110.45,0a34.114,34.114,0,1,0,34.317,34.113A34.217,34.217,0,0,0,173.6,224.8Zm220.923,0a34.114,34.114,0,1,0,34.317,34.113A34.215,34.215,0,0,0,394.519,224.8Zm153.807-55.319c-15.535-24.172-37.31-45.57-64.681-63.618-52.886-34.817-122.374-54-195.666-54a405.975,405.975,0,0,0-72.032,6.357,238.524,238.524,0,0,0-49.51-36.588C99.684-11.7,40.859.711,11.135,11.421A14.291,14.291,0,0,0,5.58,34.782C26.542,56.458,61.222,99.3,52.7,138.252c-33.142,33.9-51.112,74.776-51.112,117.337,0,43.372,17.97,84.248,51.112,118.148,8.526,38.956-26.154,81.816-47.116,103.491a14.284,14.284,0,0,0,5.555,23.34c29.724,10.709,88.549,23.147,155.324-10.2a238.679,238.679,0,0,0,49.51-36.589A405.972,405.972,0,0,0,288,460.14c73.313,0,142.8-19.159,195.667-53.975,27.371-18.049,49.145-39.426,64.679-63.619,17.309-26.923,26.07-55.916,26.07-86.125C574.394,225.4,565.634,196.43,548.326,169.485ZM284.987,409.9a345.65,345.65,0,0,1-89.446-11.5l-20.129,19.393a184.366,184.366,0,0,1-37.138,27.585,145.767,145.767,0,0,1-52.522,14.87c.983-1.771,1.881-3.563,2.842-5.356q30.258-55.68,16.325-100.078c-32.992-25.962-52.778-59.2-52.778-95.4,0-83.1,104.254-150.469,232.846-150.469s232.867,67.373,232.867,150.469C517.854,342.525,413.6,409.9,284.987,409.9Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRockrms(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm157.4 419.5h-90l-112-131.3c-17.9-20.4-3.9-56.1 26.6-56.1h75.3l-84.6-99.3-84.3 98.9h-90L193.5 67.2c14.4-18.4 41.3-17.3 54.5 0l157.7 185.1c19 22.8 2 57.2-27.6 56.1-.6 0-74.2.2-74.2.2l101.5 118.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRust(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M508.52,249.75,486.7,236.24c-.17-2-.34-3.93-.55-5.88l18.72-17.5a7.35,7.35,0,0,0-2.44-12.25l-24-9c-.54-1.88-1.08-3.78-1.67-5.64l15-20.83a7.35,7.35,0,0,0-4.79-11.54l-25.42-4.15c-.9-1.73-1.79-3.45-2.73-5.15l10.68-23.42a7.35,7.35,0,0,0-6.95-10.39l-25.82.91q-1.79-2.22-3.61-4.4L439,81.84A7.36,7.36,0,0,0,430.16,73L405,78.93q-2.17-1.83-4.4-3.61l.91-25.82a7.35,7.35,0,0,0-10.39-7L367.7,53.23c-1.7-.94-3.43-1.84-5.15-2.73L358.4,25.08a7.35,7.35,0,0,0-11.54-4.79L326,35.26c-1.86-.59-3.75-1.13-5.64-1.67l-9-24a7.35,7.35,0,0,0-12.25-2.44l-17.5,18.72c-1.95-.21-3.91-.38-5.88-.55L262.25,3.48a7.35,7.35,0,0,0-12.5,0L236.24,25.3c-2,.17-3.93.34-5.88.55L212.86,7.13a7.35,7.35,0,0,0-12.25,2.44l-9,24c-1.89.55-3.79,1.08-5.66,1.68l-20.82-15a7.35,7.35,0,0,0-11.54,4.79l-4.15,25.41c-1.73.9-3.45,1.79-5.16,2.73L120.88,42.55a7.35,7.35,0,0,0-10.39,7l.92,25.81c-1.49,1.19-3,2.39-4.42,3.61L81.84,73A7.36,7.36,0,0,0,73,81.84L78.93,107c-1.23,1.45-2.43,2.93-3.62,4.41l-25.81-.91a7.42,7.42,0,0,0-6.37,3.26,7.35,7.35,0,0,0-.57,7.13l10.66,23.41c-.94,1.7-1.83,3.43-2.73,5.16L25.08,153.6a7.35,7.35,0,0,0-4.79,11.54l15,20.82c-.59,1.87-1.13,3.77-1.68,5.66l-24,9a7.35,7.35,0,0,0-2.44,12.25l18.72,17.5c-.21,1.95-.38,3.91-.55,5.88L3.48,249.75a7.35,7.35,0,0,0,0,12.5L25.3,275.76c.17,2,.34,3.92.55,5.87L7.13,299.13a7.35,7.35,0,0,0,2.44,12.25l24,9c.55,1.89,1.08,3.78,1.68,5.65l-15,20.83a7.35,7.35,0,0,0,4.79,11.54l25.42,4.15c.9,1.72,1.79,3.45,2.73,5.14L42.56,391.12a7.35,7.35,0,0,0,.57,7.13,7.13,7.13,0,0,0,6.37,3.26l25.83-.91q1.77,2.22,3.6,4.4L73,430.16A7.36,7.36,0,0,0,81.84,439L107,433.07q2.18,1.83,4.41,3.61l-.92,25.82a7.35,7.35,0,0,0,10.39,6.95l23.43-10.68c1.69.94,3.42,1.83,5.14,2.73l4.15,25.42a7.34,7.34,0,0,0,11.54,4.78l20.83-15c1.86.6,3.76,1.13,5.65,1.68l9,24a7.36,7.36,0,0,0,12.25,2.44l17.5-18.72c1.95.21,3.92.38,5.88.55l13.51,21.82a7.35,7.35,0,0,0,12.5,0l13.51-21.82c2-.17,3.93-.34,5.88-.56l17.5,18.73a7.36,7.36,0,0,0,12.25-2.44l9-24c1.89-.55,3.78-1.08,5.65-1.68l20.82,15a7.34,7.34,0,0,0,11.54-4.78l4.15-25.42c1.72-.9,3.45-1.79,5.15-2.73l23.42,10.68a7.35,7.35,0,0,0,10.39-6.95l-.91-25.82q2.22-1.79,4.4-3.61L430.16,439a7.36,7.36,0,0,0,8.84-8.84L433.07,405q1.83-2.17,3.61-4.4l25.82.91a7.23,7.23,0,0,0,6.37-3.26,7.35,7.35,0,0,0,.58-7.13L458.77,367.7c.94-1.7,1.83-3.43,2.73-5.15l25.42-4.15a7.35,7.35,0,0,0,4.79-11.54l-15-20.83c.59-1.87,1.13-3.76,1.67-5.65l24-9a7.35,7.35,0,0,0,2.44-12.25l-18.72-17.5c.21-1.95.38-3.91.55-5.87l21.82-13.51a7.35,7.35,0,0,0,0-12.5Zm-151,129.08A13.91,13.91,0,0,0,341,389.51l-7.64,35.67A187.51,187.51,0,0,1,177,424.44l-7.64-35.66a13.87,13.87,0,0,0-16.46-10.68l-31.51,6.76a187.38,187.38,0,0,1-16.26-19.21H258.3c1.72,0,2.89-.29,2.89-1.91V309.55c0-1.57-1.17-1.91-2.89-1.91H213.47l.05-34.35H262c4.41,0,23.66,1.28,29.79,25.87,1.91,7.55,6.17,32.14,9.06,40,2.89,8.82,14.6,26.46,27.1,26.46H407a187.3,187.3,0,0,1-17.34,20.09Zm25.77,34.49A15.24,15.24,0,1,1,368,398.08h.44A15.23,15.23,0,0,1,383.24,413.32Zm-225.62-.68a15.24,15.24,0,1,1-15.25-15.25h.45A15.25,15.25,0,0,1,157.62,412.64ZM69.57,234.15l32.83-14.6a13.88,13.88,0,0,0,7.06-18.33L102.69,186h26.56V305.73H75.65A187.65,187.65,0,0,1,69.57,234.15ZM58.31,198.09a15.24,15.24,0,0,1,15.23-15.25H74a15.24,15.24,0,1,1-15.67,15.24Zm155.16,24.49.05-35.32h63.26c3.28,0,23.07,3.77,23.07,18.62,0,12.29-15.19,16.7-27.68,16.7ZM399,306.71c-9.8,1.13-20.63-4.12-22-10.09-5.78-32.49-15.39-39.4-30.57-51.4,18.86-11.95,38.46-29.64,38.46-53.26,0-25.52-17.49-41.59-29.4-49.48-16.76-11-35.28-13.23-40.27-13.23H116.32A187.49,187.49,0,0,1,221.21,70.06l23.47,24.6a13.82,13.82,0,0,0,19.6.44l26.26-25a187.51,187.51,0,0,1,128.37,91.43l-18,40.57A14,14,0,0,0,408,220.43l34.59,15.33a187.12,187.12,0,0,1,.4,32.54H423.71c-1.91,0-2.69,1.27-2.69,3.13v8.82C421,301,409.31,305.58,399,306.71ZM240,60.21A15.24,15.24,0,0,1,255.21,45h.45A15.24,15.24,0,1,1,240,60.21ZM436.84,214a15.24,15.24,0,1,1,0-30.48h.44a15.24,15.24,0,0,1-.44,30.48Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSafari(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M274.69,274.69l-37.38-37.38L166,346ZM256,8C119,8,8,119,8,256S119,504,256,504,504,393,504,256,393,8,256,8ZM411.85,182.79l14.78-6.13A8,8,0,0,1,437.08,181h0a8,8,0,0,1-4.33,10.46L418,197.57a8,8,0,0,1-10.45-4.33h0A8,8,0,0,1,411.85,182.79ZM314.43,94l6.12-14.78A8,8,0,0,1,331,74.92h0a8,8,0,0,1,4.33,10.45l-6.13,14.78a8,8,0,0,1-10.45,4.33h0A8,8,0,0,1,314.43,94ZM256,60h0a8,8,0,0,1,8,8V84a8,8,0,0,1-8,8h0a8,8,0,0,1-8-8V68A8,8,0,0,1,256,60ZM181,74.92a8,8,0,0,1,10.46,4.33L197.57,94a8,8,0,1,1-14.78,6.12l-6.13-14.78A8,8,0,0,1,181,74.92Zm-63.58,42.49h0a8,8,0,0,1,11.31,0L140,128.72A8,8,0,0,1,140,140h0a8,8,0,0,1-11.31,0l-11.31-11.31A8,8,0,0,1,117.41,117.41ZM60,256h0a8,8,0,0,1,8-8H84a8,8,0,0,1,8,8h0a8,8,0,0,1-8,8H68A8,8,0,0,1,60,256Zm40.15,73.21-14.78,6.13A8,8,0,0,1,74.92,331h0a8,8,0,0,1,4.33-10.46L94,314.43a8,8,0,0,1,10.45,4.33h0A8,8,0,0,1,100.15,329.21Zm4.33-136h0A8,8,0,0,1,94,197.57l-14.78-6.12A8,8,0,0,1,74.92,181h0a8,8,0,0,1,10.45-4.33l14.78,6.13A8,8,0,0,1,104.48,193.24ZM197.57,418l-6.12,14.78a8,8,0,0,1-14.79-6.12l6.13-14.78A8,8,0,1,1,197.57,418ZM264,444a8,8,0,0,1-8,8h0a8,8,0,0,1-8-8V428a8,8,0,0,1,8-8h0a8,8,0,0,1,8,8Zm67-6.92h0a8,8,0,0,1-10.46-4.33L314.43,418a8,8,0,0,1,4.33-10.45h0a8,8,0,0,1,10.45,4.33l6.13,14.78A8,8,0,0,1,331,437.08Zm63.58-42.49h0a8,8,0,0,1-11.31,0L372,383.28A8,8,0,0,1,372,372h0a8,8,0,0,1,11.31,0l11.31,11.31A8,8,0,0,1,394.59,394.59ZM286.25,286.25,110.34,401.66,225.75,225.75,401.66,110.34ZM437.08,331h0a8,8,0,0,1-10.45,4.33l-14.78-6.13a8,8,0,0,1-4.33-10.45h0A8,8,0,0,1,418,314.43l14.78,6.12A8,8,0,0,1,437.08,331ZM444,264H428a8,8,0,0,1-8-8h0a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8h0A8,8,0,0,1,444,264Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSalesforce(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248.89 245.64h-26.35c.69-5.16 3.32-14.12 13.64-14.12 6.75 0 11.97 3.82 12.71 14.12zm136.66-13.88c-.47 0-14.11-1.77-14.11 20s13.63 20 14.11 20c13 0 14.11-13.54 14.11-20 0-21.76-13.66-20-14.11-20zm-243.22 23.76a8.63 8.63 0 0 0-3.29 7.29c0 4.78 2.08 6.05 3.29 7.05 4.7 3.7 15.07 2.12 20.93.95v-16.94c-5.32-1.07-16.73-1.96-20.93 1.65zM640 232c0 87.58-80 154.39-165.36 136.43-18.37 33-70.73 70.75-132.2 41.63-41.16 96.05-177.89 92.18-213.81-5.17C8.91 428.78-50.19 266.52 53.36 205.61 18.61 126.18 76 32 167.67 32a124.24 124.24 0 0 1 98.56 48.7c20.7-21.4 49.4-34.81 81.15-34.81 42.34 0 79 23.52 98.8 58.57C539 63.78 640 132.69 640 232zm-519.55 31.8c0-11.76-11.69-15.17-17.87-17.17-5.27-2.11-13.41-3.51-13.41-8.94 0-9.46 17-6.66 25.17-2.12 0 0 1.17.71 1.64-.47.24-.7 2.36-6.58 2.59-7.29a1.13 1.13 0 0 0-.7-1.41c-12.33-7.63-40.7-8.51-40.7 12.7 0 12.46 11.49 15.44 17.88 17.17 4.72 1.58 13.17 3 13.17 8.7 0 4-3.53 7.06-9.17 7.06a31.76 31.76 0 0 1-19-6.35c-.47-.23-1.42-.71-1.65.71l-2.4 7.47c-.47.94.23 1.18.23 1.41 1.75 1.4 10.3 6.59 22.82 6.59 13.17 0 21.4-7.06 21.4-18.11zm32-42.58c-10.13 0-18.66 3.17-21.4 5.18a1 1 0 0 0-.24 1.41l2.59 7.06a1 1 0 0 0 1.18.7c.65 0 6.8-4 16.93-4 4 0 7.06.71 9.18 2.36 3.6 2.8 3.06 8.29 3.06 10.58-4.79-.3-19.11-3.44-29.41 3.76a16.92 16.92 0 0 0-7.34 14.54c0 5.9 1.51 10.4 6.59 14.35 12.24 8.16 36.28 2 38.1 1.41 1.58-.32 3.53-.66 3.53-1.88v-33.88c.04-4.61.32-21.64-22.78-21.64zM199 200.24a1.11 1.11 0 0 0-1.18-1.18H188a1.11 1.11 0 0 0-1.17 1.18v79a1.11 1.11 0 0 0 1.17 1.18h9.88a1.11 1.11 0 0 0 1.18-1.18zm55.75 28.93c-2.1-2.31-6.79-7.53-17.65-7.53-3.51 0-14.16.23-20.7 8.94-6.35 7.63-6.58 18.11-6.58 21.41 0 3.12.15 14.26 7.06 21.17 2.64 2.91 9.06 8.23 22.81 8.23 10.82 0 16.47-2.35 18.58-3.76.47-.24.71-.71.24-1.88l-2.35-6.83a1.26 1.26 0 0 0-1.41-.7c-2.59.94-6.35 2.82-15.29 2.82-17.42 0-16.85-14.74-16.94-16.7h37.17a1.23 1.23 0 0 0 1.17-.94c-.29 0 2.07-14.7-6.09-24.23zm36.69 52.69c13.17 0 21.41-7.06 21.41-18.11 0-11.76-11.7-15.17-17.88-17.17-4.14-1.66-13.41-3.38-13.41-8.94 0-3.76 3.29-6.35 8.47-6.35a38.11 38.11 0 0 1 16.7 4.23s1.18.71 1.65-.47c.23-.7 2.35-6.58 2.58-7.29a1.13 1.13 0 0 0-.7-1.41c-7.91-4.9-16.74-4.94-20.23-4.94-12 0-20.46 7.29-20.46 17.64 0 12.46 11.48 15.44 17.87 17.17 6.11 2 13.17 3.26 13.17 8.7 0 4-3.52 7.06-9.17 7.06a31.8 31.8 0 0 1-19-6.35 1 1 0 0 0-1.65.71l-2.35 7.52c-.47.94.23 1.18.23 1.41 1.72 1.4 10.33 6.59 22.79 6.59zM357.09 224c0-.71-.24-1.18-1.18-1.18h-11.76c0-.14.94-8.94 4.47-12.47 4.16-4.15 11.76-1.64 12-1.64 1.17.47 1.41 0 1.64-.47l2.83-7.77c.7-.94 0-1.17-.24-1.41-5.09-2-17.35-2.87-24.46 4.24-5.48 5.48-7 13.92-8 19.52h-8.47a1.28 1.28 0 0 0-1.17 1.18l-1.42 7.76c0 .7.24 1.17 1.18 1.17h8.23c-8.51 47.9-8.75 50.21-10.35 55.52-1.08 3.62-3.29 6.9-5.88 7.76-.09 0-3.88 1.68-9.64-.24 0 0-.94-.47-1.41.71-.24.71-2.59 6.82-2.83 7.53s0 1.41.47 1.41c5.11 2 13 1.77 17.88 0 6.28-2.28 9.72-7.89 11.53-12.94 2.75-7.71 2.81-9.79 11.76-59.74h12.23a1.29 1.29 0 0 0 1.18-1.18zm53.39 16c-.56-1.68-5.1-18.11-25.17-18.11-15.25 0-23 10-25.16 18.11-1 3-3.18 14 0 23.52.09.3 4.41 18.12 25.16 18.12 14.95 0 22.9-9.61 25.17-18.12 3.21-9.61 1.01-20.52 0-23.52zm45.4-16.7c-5-1.65-16.62-1.9-22.11 5.41v-4.47a1.11 1.11 0 0 0-1.18-1.17h-9.4a1.11 1.11 0 0 0-1.18 1.17v55.28a1.12 1.12 0 0 0 1.18 1.18h9.64a1.12 1.12 0 0 0 1.18-1.18v-27.77c0-2.91.05-11.37 4.46-15.05 4.9-4.9 12-3.36 13.41-3.06a1.57 1.57 0 0 0 1.41-.94 74 74 0 0 0 3.06-8 1.16 1.16 0 0 0-.47-1.41zm46.81 54.1l-2.12-7.29c-.47-1.18-1.41-.71-1.41-.71-4.23 1.82-10.15 1.89-11.29 1.89-4.64 0-17.17-1.13-17.17-19.76 0-6.23 1.85-19.76 16.47-19.76a34.85 34.85 0 0 1 11.52 1.65s.94.47 1.18-.71c.94-2.59 1.64-4.47 2.59-7.53.23-.94-.47-1.17-.71-1.17-11.59-3.87-22.34-2.53-27.76 0-1.59.74-16.23 6.49-16.23 27.52 0 2.9-.58 30.11 28.94 30.11a44.45 44.45 0 0 0 15.52-2.83 1.3 1.3 0 0 0 .47-1.42zm53.87-39.52c-.8-3-5.37-16.23-22.35-16.23-16 0-23.52 10.11-25.64 18.59a38.58 38.58 0 0 0-1.65 11.76c0 25.87 18.84 29.4 29.88 29.4 10.82 0 16.46-2.35 18.58-3.76.47-.24.71-.71.24-1.88l-2.36-6.83a1.26 1.26 0 0 0-1.41-.7c-2.59.94-6.35 2.82-15.29 2.82-17.42 0-16.85-14.74-16.93-16.7h37.16a1.25 1.25 0 0 0 1.18-.94c-.24-.01.94-7.07-1.41-15.54zm-23.29-6.35c-10.33 0-13 9-13.64 14.12H546c-.88-11.92-7.62-14.13-12.73-14.13z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSass(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M301.84 378.92c-.3.6-.6 1.08 0 0zm249.13-87a131.16 131.16 0 0 0-58 13.5c-5.9-11.9-12-22.3-13-30.1-1.2-9.1-2.5-14.5-1.1-25.3s7.7-26.1 7.6-27.2-1.4-6.6-14.3-6.7-24 2.5-25.29 5.9a122.83 122.83 0 0 0-5.3 19.1c-2.3 11.7-25.79 53.5-39.09 75.3-4.4-8.5-8.1-16-8.9-22-1.2-9.1-2.5-14.5-1.1-25.3s7.7-26.1 7.6-27.2-1.4-6.6-14.29-6.7-24 2.5-25.3 5.9-2.7 11.4-5.3 19.1-33.89 77.3-42.08 95.4c-4.2 9.2-7.8 16.6-10.4 21.6-.4.8-.7 1.3-.9 1.7.3-.5.5-1 .5-.8-2.2 4.3-3.5 6.7-3.5 6.7v.1c-1.7 3.2-3.6 6.1-4.5 6.1-.6 0-1.9-8.4.3-19.9 4.7-24.2 15.8-61.8 15.7-63.1-.1-.7 2.1-7.2-7.3-10.7-9.1-3.3-12.4 2.2-13.2 2.2s-1.4 2-1.4 2 10.1-42.4-19.39-42.4c-18.4 0-44 20.2-56.58 38.5-7.9 4.3-25 13.6-43 23.5-6.9 3.8-14 7.7-20.7 11.4-.5-.5-.9-1-1.4-1.5-35.79-38.2-101.87-65.2-99.07-116.5 1-18.7 7.5-67.8 127.07-127.4 98-48.8 176.35-35.4 189.84-5.6 19.4 42.5-41.89 121.6-143.66 133-38.79 4.3-59.18-10.7-64.28-16.3-5.3-5.9-6.1-6.2-8.1-5.1-3.3 1.8-1.2 7 0 10.1 3 7.9 15.5 21.9 36.79 28.9 18.7 6.1 64.18 9.5 119.17-11.8 61.78-23.8 109.87-90.1 95.77-145.6C386.52 18.32 293-.18 204.57 31.22c-52.69 18.7-109.67 48.1-150.66 86.4-48.69 45.6-56.48 85.3-53.28 101.9 11.39 58.9 92.57 97.3 125.06 125.7-1.6.9-3.1 1.7-4.5 2.5-16.29 8.1-78.18 40.5-93.67 74.7-17.5 38.8 2.9 66.6 16.29 70.4 41.79 11.6 84.58-9.3 107.57-43.6s20.2-79.1 9.6-99.5c-.1-.3-.3-.5-.4-.8 4.2-2.5 8.5-5 12.8-7.5 8.29-4.9 16.39-9.4 23.49-13.3-4 10.8-6.9 23.8-8.4 42.6-1.8 22 7.3 50.5 19.1 61.7 5.2 4.9 11.49 5 15.39 5 13.8 0 20-11.4 26.89-25 8.5-16.6 16-35.9 16-35.9s-9.4 52.2 16.3 52.2c9.39 0 18.79-12.1 23-18.3v.1s.2-.4.7-1.2c1-1.5 1.5-2.4 1.5-2.4v-.3c3.8-6.5 12.1-21.4 24.59-46 16.2-31.8 31.69-71.5 31.69-71.5a201.24 201.24 0 0 0 6.2 25.8c2.8 9.5 8.7 19.9 13.4 30-3.8 5.2-6.1 8.2-6.1 8.2a.31.31 0 0 0 .1.2c-3 4-6.4 8.3-9.9 12.5-12.79 15.2-28 32.6-30 37.6-2.4 5.9-1.8 10.3 2.8 13.7 3.4 2.6 9.4 3 15.69 2.5 11.5-.8 19.6-3.6 23.5-5.4a82.2 82.2 0 0 0 20.19-10.6c12.5-9.2 20.1-22.4 19.4-39.8-.4-9.6-3.5-19.2-7.3-28.2 1.1-1.6 2.3-3.3 3.4-5C434.8 301.72 450.1 270 450.1 270a201.24 201.24 0 0 0 6.2 25.8c2.4 8.1 7.09 17 11.39 25.7-18.59 15.1-30.09 32.6-34.09 44.1-7.4 21.3-1.6 30.9 9.3 33.1 4.9 1 11.9-1.3 17.1-3.5a79.46 79.46 0 0 0 21.59-11.1c12.5-9.2 24.59-22.1 23.79-39.6-.3-7.9-2.5-15.8-5.4-23.4 15.7-6.6 36.09-10.2 62.09-7.2 55.68 6.5 66.58 41.3 64.48 55.8s-13.8 22.6-17.7 25-5.1 3.3-4.8 5.1c.5 2.6 2.3 2.5 5.6 1.9 4.6-.8 29.19-11.8 30.29-38.7 1.6-34-31.09-71.4-89-71.1zm-429.18 144.7c-18.39 20.1-44.19 27.7-55.28 21.3C54.61 451 59.31 421.42 82 400c13.8-13 31.59-25 43.39-32.4 2.7-1.6 6.6-4 11.4-6.9.8-.5 1.2-.7 1.2-.7.9-.6 1.9-1.1 2.9-1.7 8.29 30.4.3 57.2-19.1 78.3zm134.36-91.4c-6.4 15.7-19.89 55.7-28.09 53.6-7-1.8-11.3-32.3-1.4-62.3 5-15.1 15.6-33.1 21.9-40.1 10.09-11.3 21.19-14.9 23.79-10.4 3.5 5.9-12.2 49.4-16.2 59.2zm111 53c-2.7 1.4-5.2 2.3-6.4 1.6-.9-.5 1.1-2.4 1.1-2.4s13.9-14.9 19.4-21.7c3.2-4 6.9-8.7 10.89-13.9 0 .5.1 1 .1 1.6-.13 17.9-17.32 30-25.12 34.8zm85.58-19.5c-2-1.4-1.7-6.1 5-20.7 2.6-5.7 8.59-15.3 19-24.5a36.18 36.18 0 0 1 1.9 10.8c-.1 22.5-16.2 30.9-25.89 34.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSchlix(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M350.5 157.7l-54.2-46.1 73.4-39 78.3 44.2-97.5 40.9zM192 122.1l45.7-28.2 34.7 34.6-55.4 29-25-35.4zm-65.1 6.6l31.9-22.1L176 135l-36.7 22.5-12.4-28.8zm-23.3 88.2l-8.8-34.8 29.6-18.3 13.1 35.3-33.9 17.8zm-21.2-83.7l23.9-18.1 8.9 24-26.7 18.3-6.1-24.2zM59 206.5l-3.6-28.4 22.3-15.5 6.1 28.7L59 206.5zm-30.6 16.6l20.8-12.8 3.3 33.4-22.9 12-1.2-32.6zM1.4 268l19.2-10.2.4 38.2-21 8.8L1.4 268zm59.1 59.3l-28.3 8.3-1.6-46.8 25.1-10.7 4.8 49.2zM99 263.2l-31.1 13-5.2-40.8L90.1 221l8.9 42.2zM123.2 377l-41.6 5.9-8.1-63.5 35.2-10.8 14.5 68.4zm28.5-139.9l21.2 57.1-46.2 13.6-13.7-54.1 38.7-16.6zm85.7 230.5l-70.9-3.3-24.3-95.8 55.2-8.6 40 107.7zm-84.9-279.7l42.2-22.4 28 45.9-50.8 21.3-19.4-44.8zm41 94.9l61.3-18.7 52.8 86.6-79.8 11.3-34.3-79.2zm51.4-85.6l67.3-28.8 65.5 65.4-88.6 26.2-44.2-62.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaScribd(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M42.3 252.7c-16.1-19-24.7-45.9-24.8-79.9 0-100.4 75.2-153.1 167.2-153.1 98.6-1.6 156.8 49 184.3 70.6l-50.5 72.1-37.3-24.6 26.9-38.6c-36.5-24-79.4-36.5-123-35.8-50.7-.8-111.7 27.2-111.7 76.2 0 18.7 11.2 20.7 28.6 15.6 23.3-5.3 41.9.6 55.8 14 26.4 24.3 23.2 67.6-.7 91.9-29.2 29.5-85.2 27.3-114.8-8.4zm317.7 5.9c-15.5-18.8-38.9-29.4-63.2-28.6-38.1-2-71.1 28-70.5 67.2-.7 16.8 6 33 18.4 44.3 14.1 13.9 33 19.7 56.3 14.4 17.4-5.1 28.6-3.1 28.6 15.6 0 4.3-.5 8.5-1.4 12.7-16.7 40.9-59.5 64.4-121.4 64.4-51.9.2-102.4-16.4-144.1-47.3l33.7-39.4-35.6-27.4L0 406.3l15.4 13.8c52.5 46.8 120.4 72.5 190.7 72.2 51.4 0 94.4-10.5 133.6-44.1 57.1-51.4 54.2-149.2 20.3-189.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSearchengin(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 460 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M220.6 130.3l-67.2 28.2V43.2L98.7 233.5l54.7-24.2v130.3l67.2-209.3zm-83.2-96.7l-1.3 4.7-15.2 52.9C80.6 106.7 52 145.8 52 191.5c0 52.3 34.3 95.9 83.4 105.5v53.6C57.5 340.1 0 272.4 0 191.6c0-80.5 59.8-147.2 137.4-158zm311.4 447.2c-11.2 11.2-23.1 12.3-28.6 10.5-5.4-1.8-27.1-19.9-60.4-44.4-33.3-24.6-33.6-35.7-43-56.7-9.4-20.9-30.4-42.6-57.5-52.4l-9.7-14.7c-24.7 16.9-53 26.9-81.3 28.7l2.1-6.6 15.9-49.5c46.5-11.9 80.9-54 80.9-104.2 0-54.5-38.4-102.1-96-107.1V32.3C254.4 37.4 320 106.8 320 191.6c0 33.6-11.2 64.7-29 90.4l14.6 9.6c9.8 27.1 31.5 48 52.4 57.4s32.2 9.7 56.8 43c24.6 33.2 42.7 54.9 44.5 60.3s.7 17.3-10.5 28.5zm-9.9-17.9c0-4.4-3.6-8-8-8s-8 3.6-8 8 3.6 8 8 8 8-3.6 8-8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSellcast(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M353.4 32H94.7C42.6 32 0 74.6 0 126.6v258.7C0 437.4 42.6 480 94.7 480h258.7c52.1 0 94.7-42.6 94.7-94.6V126.6c0-52-42.6-94.6-94.7-94.6zm-50 316.4c-27.9 48.2-89.9 64.9-138.2 37.2-22.9 39.8-54.9 8.6-42.3-13.2l15.7-27.2c5.9-10.3 19.2-13.9 29.5-7.9 18.6 10.8-.1-.1 18.5 10.7 27.6 15.9 63.4 6.3 79.4-21.3 15.9-27.6 6.3-63.4-21.3-79.4-17.8-10.2-.6-.4-18.6-10.6-24.6-14.2-3.4-51.9 21.6-37.5 18.6 10.8-.1-.1 18.5 10.7 48.4 28 65.1 90.3 37.2 138.5zm21.8-208.8c-17 29.5-16.3 28.8-19 31.5-6.5 6.5-16.3 8.7-26.5 3.6-18.6-10.8.1.1-18.5-10.7-27.6-15.9-63.4-6.3-79.4 21.3s-6.3 63.4 21.3 79.4c0 0 18.5 10.6 18.6 10.6 24.6 14.2 3.4 51.9-21.6 37.5-18.6-10.8.1.1-18.5-10.7-48.2-27.8-64.9-90.1-37.1-138.4 27.9-48.2 89.9-64.9 138.2-37.2l4.8-8.4c14.3-24.9 52-3.3 37.7 21.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSellsy(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M539.71 237.308c3.064-12.257 4.29-24.821 4.29-37.384C544 107.382 468.618 32 376.076 32c-77.22 0-144.634 53.012-163.02 127.781-15.322-13.176-34.934-20.53-55.157-20.53-46.271 0-83.962 37.69-83.962 83.961 0 7.354.92 15.015 3.065 22.369-42.9 20.225-70.785 63.738-70.785 111.234C6.216 424.843 61.68 480 129.401 480h381.198c67.72 0 123.184-55.157 123.184-123.184.001-56.384-38.916-106.025-94.073-119.508zM199.88 401.554c0 8.274-7.048 15.321-15.321 15.321H153.61c-8.274 0-15.321-7.048-15.321-15.321V290.626c0-8.273 7.048-15.321 15.321-15.321h30.949c8.274 0 15.321 7.048 15.321 15.321v110.928zm89.477 0c0 8.274-7.048 15.321-15.322 15.321h-30.949c-8.274 0-15.321-7.048-15.321-15.321V270.096c0-8.274 7.048-15.321 15.321-15.321h30.949c8.274 0 15.322 7.048 15.322 15.321v131.458zm89.477 0c0 8.274-7.047 15.321-15.321 15.321h-30.949c-8.274 0-15.322-7.048-15.322-15.321V238.84c0-8.274 7.048-15.321 15.322-15.321h30.949c8.274 0 15.321 7.048 15.321 15.321v162.714zm87.027 0c0 8.274-7.048 15.321-15.322 15.321h-28.497c-8.274 0-15.321-7.048-15.321-15.321V176.941c0-8.579 7.047-15.628 15.321-15.628h28.497c8.274 0 15.322 7.048 15.322 15.628v224.613z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaServicestack(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M88 216c81.7 10.2 273.7 102.3 304 232H0c99.5-8.1 184.5-137 88-232zm32-152c32.3 35.6 47.7 83.9 46.4 133.6C249.3 231.3 373.7 321.3 400 448h96C455.3 231.9 222.8 79.5 120 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaShirtsinbulk(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M100 410.3l30.6 13.4 4.4-9.9-30.6-13.4zm39.4 17.5l30.6 13.4 4.4-9.9-30.6-13.4zm172.1-14l4.4 9.9 30.6-13.4-4.4-9.9zM179.1 445l30.3 13.7 4.4-9.9-30.3-13.4zM60.4 392.8L91 406.2l4.4-9.6-30.6-13.7zm211.4 38.5l4.4 9.9 30.6-13.4-4.4-9.9zm-39.3 17.5l4.4 9.9 30.6-13.7-4.4-9.6zm118.4-52.2l4.4 9.6 30.6-13.4-4.4-9.9zM170 46.6h-33.5v10.5H170zm-47.2 0H89.2v10.5h33.5zm-47.3 0H42.3v10.5h33.3zm141.5 0h-33.2v10.5H217zm94.5 0H278v10.5h33.5zm47.3 0h-33.5v10.5h33.5zm-94.6 0H231v10.5h33.2zm141.5 0h-33.3v10.5h33.3zM52.8 351.1H42v33.5h10.8zm70-215.9H89.2v10.5h33.5zm-70 10.6h22.8v-10.5H42v33.5h10.8zm168.9 228.6c50.5 0 91.3-40.8 91.3-91.3 0-50.2-40.8-91.3-91.3-91.3-50.2 0-91.3 41.1-91.3 91.3 0 50.5 41.1 91.3 91.3 91.3zm-48.2-111.1c0-25.4 29.5-31.8 49.6-31.8 16.9 0 29.2 5.8 44.3 12l-8.8 16.9h-.9c-6.4-9.9-24.8-13.1-35.6-13.1-9 0-29.8 1.8-29.8 14.9 0 21.6 78.5-10.2 78.5 37.9 0 25.4-31.5 31.2-51 31.2-18.1 0-32.4-2.9-47.2-12.2l9-18.4h.9c6.1 12.2 23.6 14.9 35.9 14.9 8.7 0 32.7-1.2 32.7-14.3 0-26.1-77.6 6.3-77.6-38zM52.8 178.4H42V212h10.8zm342.4 206.2H406v-33.5h-10.8zM52.8 307.9H42v33.5h10.8zM0 3.7v406l221.7 98.6L448 409.7V3.7zm418.8 387.1L222 476.5 29.2 390.8V120.7h389.7v270.1zm0-299.3H29.2V32.9h389.7v58.6zm-366 130.1H42v33.5h10.8zm0 43.2H42v33.5h10.8zM170 135.2h-33.5v10.5H170zm225.2 163.1H406v-33.5h-10.8zm0-43.2H406v-33.5h-10.8zM217 135.2h-33.2v10.5H217zM395.2 212H406v-33.5h-10.8zm0 129.5H406V308h-10.8zm-131-206.3H231v10.5h33.2zm47.3 0H278v10.5h33.5zm83.7 33.6H406v-33.5h-33.5v10.5h22.8zm-36.4-33.6h-33.5v10.5h33.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaShopify(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M388.32,104.1a4.66,4.66,0,0,0-4.4-4c-2,0-37.23-.8-37.23-.8s-21.61-20.82-29.62-28.83V503.2L442.76,472S388.72,106.5,388.32,104.1ZM288.65,70.47a116.67,116.67,0,0,0-7.21-17.61C271,32.85,255.42,22,237,22a15,15,0,0,0-4,.4c-.4-.8-1.2-1.2-1.6-2C223.4,11.63,213,7.63,200.58,8c-24,.8-48,18-67.25,48.83-13.61,21.62-24,48.84-26.82,70.06-27.62,8.4-46.83,14.41-47.23,14.81-14,4.4-14.41,4.8-16,18-1.2,10-38,291.82-38,291.82L307.86,504V65.67a41.66,41.66,0,0,0-4.4.4S297.86,67.67,288.65,70.47ZM233.41,87.69c-16,4.8-33.63,10.4-50.84,15.61,4.8-18.82,14.41-37.63,25.62-50,4.4-4.4,10.41-9.61,17.21-12.81C232.21,54.86,233.81,74.48,233.41,87.69ZM200.58,24.44A27.49,27.49,0,0,1,215,28c-6.4,3.2-12.81,8.41-18.81,14.41-15.21,16.42-26.82,42-31.62,66.45-14.42,4.41-28.83,8.81-42,12.81C131.33,83.28,163.75,25.24,200.58,24.44ZM154.15,244.61c1.6,25.61,69.25,31.22,73.25,91.66,2.8,47.64-25.22,80.06-65.65,82.47-48.83,3.2-75.65-25.62-75.65-25.62l10.4-44s26.82,20.42,48.44,18.82c14-.8,19.22-12.41,18.81-20.42-2-33.62-57.24-31.62-60.84-86.86-3.2-46.44,27.22-93.27,94.47-97.68,26-1.6,39.23,4.81,39.23,4.81L221.4,225.39s-17.21-8-37.63-6.4C154.15,221,153.75,239.8,154.15,244.61ZM249.42,82.88c0-12-1.6-29.22-7.21-43.63,18.42,3.6,27.22,24,31.23,36.43Q262.63,78.68,249.42,82.88Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaShopware(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M403.5 455.41A246.17 246.17 0 0 1 256 504C118.81 504 8 393 8 256 8 118.81 119 8 256 8a247.39 247.39 0 0 1 165.7 63.5 3.57 3.57 0 0 1-2.86 6.18A418.62 418.62 0 0 0 362.13 74c-129.36 0-222.4 53.47-222.4 155.35 0 109 92.13 145.88 176.83 178.73 33.64 13 65.4 25.36 87 41.59a3.58 3.58 0 0 1 0 5.72zM503 233.09a3.64 3.64 0 0 0-1.27-2.44c-51.76-43-93.62-60.48-144.48-60.48-84.13 0-80.25 52.17-80.25 53.63 0 42.6 52.06 62 112.34 84.49 31.07 11.59 63.19 23.57 92.68 39.93a3.57 3.57 0 0 0 5-1.82A249 249 0 0 0 503 233.09z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSimplybuilt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M481.2 64h-106c-14.5 0-26.6 11.8-26.6 26.3v39.6H163.3V90.3c0-14.5-12-26.3-26.6-26.3h-106C16.1 64 4.3 75.8 4.3 90.3v331.4c0 14.5 11.8 26.3 26.6 26.3h450.4c14.8 0 26.6-11.8 26.6-26.3V90.3c-.2-14.5-12-26.3-26.7-26.3zM149.8 355.8c-36.6 0-66.4-29.7-66.4-66.4 0-36.9 29.7-66.6 66.4-66.6 36.9 0 66.6 29.7 66.6 66.6 0 36.7-29.7 66.4-66.6 66.4zm212.4 0c-36.9 0-66.6-29.7-66.6-66.6 0-36.6 29.7-66.4 66.6-66.4 36.6 0 66.4 29.7 66.4 66.4 0 36.9-29.8 66.6-66.4 66.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSistrix(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 449L301.2 300.2c20-27.9 31.9-62.2 31.9-99.2 0-93.1-74.7-168.9-166.5-168.9C74.7 32 0 107.8 0 200.9s74.7 168.9 166.5 168.9c39.8 0 76.3-14.2 105-37.9l146 148.1 30.5-31zM166.5 330.8c-70.6 0-128.1-58.3-128.1-129.9S95.9 71 166.5 71s128.1 58.3 128.1 129.9-57.4 129.9-128.1 129.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSith(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32l69.71 118.75-58.86-11.52 69.84 91.03a146.741 146.741 0 0 0 0 51.45l-69.84 91.03 58.86-11.52L0 480l118.75-69.71-11.52 58.86 91.03-69.84c17.02 3.04 34.47 3.04 51.48 0l91.03 69.84-11.52-58.86L448 480l-69.71-118.78 58.86 11.52-69.84-91.03c3.03-17.01 3.04-34.44 0-51.45l69.84-91.03-58.86 11.52L448 32l-118.75 69.71 11.52-58.9-91.06 69.87c-8.5-1.52-17.1-2.29-25.71-2.29s-17.21.78-25.71 2.29l-91.06-69.87 11.52 58.9L0 32zm224 99.78c31.8 0 63.6 12.12 87.85 36.37 48.5 48.5 48.49 127.21 0 175.7s-127.2 48.46-175.7-.03c-48.5-48.5-48.49-127.21 0-175.7 24.24-24.25 56.05-36.34 87.85-36.34zm0 36.66c-22.42 0-44.83 8.52-61.92 25.61-34.18 34.18-34.19 89.68 0 123.87s89.65 34.18 123.84 0c34.18-34.18 34.19-89.68 0-123.87-17.09-17.09-39.5-25.61-61.92-25.61z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSketch(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M27.5 162.2L9 187.1h90.5l6.9-130.7-78.9 105.8zM396.3 45.7L267.7 32l135.7 147.2-7.1-133.5zM112.2 218.3l-11.2-22H9.9L234.8 458zm2-31.2h284l-81.5-88.5L256.3 33zm297.3 9.1L277.6 458l224.8-261.7h-90.9zM415.4 69L406 56.4l.9 17.3 6.1 113.4h90.3zM113.5 93.5l-4.6 85.6L244.7 32 116.1 45.7zm287.7 102.7h-290l42.4 82.9L256.3 480l144.9-283.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSkyatlas(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M640 329.3c0 65.9-52.5 114.4-117.5 114.4-165.9 0-196.6-249.7-359.7-249.7-146.9 0-147.1 212.2 5.6 212.2 42.5 0 90.9-17.8 125.3-42.5 5.6-4.1 16.9-16.3 22.8-16.3s10.9 5 10.9 10.9c0 7.8-13.1 19.1-18.7 24.1-40.9 35.6-100.3 61.2-154.7 61.2-83.4.1-154-59-154-144.9s67.5-149.1 152.8-149.1c185.3 0 222.5 245.9 361.9 245.9 99.9 0 94.8-139.7 3.4-139.7-17.5 0-35 11.6-46.9 11.6-8.4 0-15.9-7.2-15.9-15.6 0-11.6 5.3-23.7 5.3-36.3 0-66.6-50.9-114.7-116.9-114.7-53.1 0-80 36.9-88.8 36.9-6.2 0-11.2-5-11.2-11.2 0-5.6 4.1-10.3 7.8-14.4 25.3-28.8 64.7-43.7 102.8-43.7 79.4 0 139.1 58.4 139.1 137.8 0 6.9-.3 13.7-1.2 20.6 11.9-3.1 24.1-4.7 35.9-4.7 60.7 0 111.9 45.3 111.9 107.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSkype(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M424.7 299.8c2.9-14 4.7-28.9 4.7-43.8 0-113.5-91.9-205.3-205.3-205.3-14.9 0-29.7 1.7-43.8 4.7C161.3 40.7 137.7 32 112 32 50.2 32 0 82.2 0 144c0 25.7 8.7 49.3 23.3 68.2-2.9 14-4.7 28.9-4.7 43.8 0 113.5 91.9 205.3 205.3 205.3 14.9 0 29.7-1.7 43.8-4.7 19 14.6 42.6 23.3 68.2 23.3 61.8 0 112-50.2 112-112 .1-25.6-8.6-49.2-23.2-68.1zm-194.6 91.5c-65.6 0-120.5-29.2-120.5-65 0-16 9-30.6 29.5-30.6 31.2 0 34.1 44.9 88.1 44.9 25.7 0 42.3-11.4 42.3-26.3 0-18.7-16-21.6-42-28-62.5-15.4-117.8-22-117.8-87.2 0-59.2 58.6-81.1 109.1-81.1 55.1 0 110.8 21.9 110.8 55.4 0 16.9-11.4 31.8-30.3 31.8-28.3 0-29.2-33.5-75-33.5-25.7 0-42 7-42 22.5 0 19.8 20.8 21.8 69.1 33 41.4 9.3 90.7 26.8 90.7 77.6 0 59.1-57.1 86.5-112 86.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSlackHash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M446.2 270.4c-6.2-19-26.9-29.1-46-22.9l-45.4 15.1-30.3-90 45.4-15.1c19.1-6.2 29.1-26.8 23-45.9-6.2-19-26.9-29.1-46-22.9l-45.4 15.1-15.7-47c-6.2-19-26.9-29.1-46-22.9-19.1 6.2-29.1 26.8-23 45.9l15.7 47-93.4 31.2-15.7-47c-6.2-19-26.9-29.1-46-22.9-19.1 6.2-29.1 26.8-23 45.9l15.7 47-45.3 15c-19.1 6.2-29.1 26.8-23 45.9 5 14.5 19.1 24 33.6 24.6 6.8 1 12-1.6 57.7-16.8l30.3 90L78 354.8c-19 6.2-29.1 26.9-23 45.9 5 14.5 19.1 24 33.6 24.6 6.8 1 12-1.6 57.7-16.8l15.7 47c5.9 16.9 24.7 29 46 22.9 19.1-6.2 29.1-26.8 23-45.9l-15.7-47 93.6-31.3 15.7 47c5.9 16.9 24.7 29 46 22.9 19.1-6.2 29.1-26.8 23-45.9l-15.7-47 45.4-15.1c19-6 29.1-26.7 22.9-45.7zm-254.1 47.2l-30.3-90.2 93.5-31.3 30.3 90.2-93.5 31.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSlack(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M94.12 315.1c0 25.9-21.16 47.06-47.06 47.06S0 341 0 315.1c0-25.9 21.16-47.06 47.06-47.06h47.06v47.06zm23.72 0c0-25.9 21.16-47.06 47.06-47.06s47.06 21.16 47.06 47.06v117.84c0 25.9-21.16 47.06-47.06 47.06s-47.06-21.16-47.06-47.06V315.1zm47.06-188.98c-25.9 0-47.06-21.16-47.06-47.06S139 32 164.9 32s47.06 21.16 47.06 47.06v47.06H164.9zm0 23.72c25.9 0 47.06 21.16 47.06 47.06s-21.16 47.06-47.06 47.06H47.06C21.16 243.96 0 222.8 0 196.9s21.16-47.06 47.06-47.06H164.9zm188.98 47.06c0-25.9 21.16-47.06 47.06-47.06 25.9 0 47.06 21.16 47.06 47.06s-21.16 47.06-47.06 47.06h-47.06V196.9zm-23.72 0c0 25.9-21.16 47.06-47.06 47.06-25.9 0-47.06-21.16-47.06-47.06V79.06c0-25.9 21.16-47.06 47.06-47.06 25.9 0 47.06 21.16 47.06 47.06V196.9zM283.1 385.88c25.9 0 47.06 21.16 47.06 47.06 0 25.9-21.16 47.06-47.06 47.06-25.9 0-47.06-21.16-47.06-47.06v-47.06h47.06zm0-23.72c-25.9 0-47.06-21.16-47.06-47.06 0-25.9 21.16-47.06 47.06-47.06h117.84c25.9 0 47.06 21.16 47.06 47.06 0 25.9-21.16 47.06-47.06 47.06H283.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSlideshare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M187.7 153.7c-34 0-61.7 25.7-61.7 57.7 0 31.7 27.7 57.7 61.7 57.7s61.7-26 61.7-57.7c0-32-27.7-57.7-61.7-57.7zm143.4 0c-34 0-61.7 25.7-61.7 57.7 0 31.7 27.7 57.7 61.7 57.7 34.3 0 61.7-26 61.7-57.7.1-32-27.4-57.7-61.7-57.7zm156.6 90l-6 4.3V49.7c0-27.4-20.6-49.7-46-49.7H76.6c-25.4 0-46 22.3-46 49.7V248c-2-1.4-4.3-2.9-6.3-4.3-15.1-10.6-25.1 4-16 17.7 18.3 22.6 53.1 50.3 106.3 72C58.3 525.1 252 555.7 248.9 457.5c0-.7.3-56.6.3-96.6 5.1 1.1 9.4 2.3 13.7 3.1 0 39.7.3 92.8.3 93.5-3.1 98.3 190.6 67.7 134.3-124 53.1-21.7 88-49.4 106.3-72 9.1-13.8-.9-28.3-16.1-17.8zm-30.5 19.2c-68.9 37.4-128.3 31.1-160.6 29.7-23.7-.9-32.6 9.1-33.7 24.9-10.3-7.7-18.6-15.5-20.3-17.1-5.1-5.4-13.7-8-27.1-7.7-31.7 1.1-89.7 7.4-157.4-28V72.3c0-34.9 8.9-45.7 40.6-45.7h317.7c30.3 0 40.9 12.9 40.9 45.7v190.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSnapchatGhost(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M510.846 392.673c-5.211 12.157-27.239 21.089-67.36 27.318-2.064 2.786-3.775 14.686-6.507 23.956-1.625 5.566-5.623 8.869-12.128 8.869l-.297-.005c-9.395 0-19.203-4.323-38.852-4.323-26.521 0-35.662 6.043-56.254 20.588-21.832 15.438-42.771 28.764-74.027 27.399-31.646 2.334-58.025-16.908-72.871-27.404-20.714-14.643-29.828-20.582-56.241-20.582-18.864 0-30.736 4.72-38.852 4.72-8.073 0-11.213-4.922-12.422-9.04-2.703-9.189-4.404-21.263-6.523-24.13-20.679-3.209-67.31-11.344-68.498-32.15a10.627 10.627 0 0 1 8.877-11.069c69.583-11.455 100.924-82.901 102.227-85.934.074-.176.155-.344.237-.515 3.713-7.537 4.544-13.849 2.463-18.753-5.05-11.896-26.872-16.164-36.053-19.796-23.715-9.366-27.015-20.128-25.612-27.504 2.437-12.836 21.725-20.735 33.002-15.453 8.919 4.181 16.843 6.297 23.547 6.297 5.022 0 8.212-1.204 9.96-2.171-2.043-35.936-7.101-87.29 5.687-115.969C158.122 21.304 229.705 15.42 250.826 15.42c.944 0 9.141-.089 10.11-.089 52.148 0 102.254 26.78 126.723 81.643 12.777 28.65 7.749 79.792 5.695 116.009 1.582.872 4.357 1.942 8.599 2.139 6.397-.286 13.815-2.389 22.069-6.257 6.085-2.846 14.406-2.461 20.48.058l.029.01c9.476 3.385 15.439 10.215 15.589 17.87.184 9.747-8.522 18.165-25.878 25.018-2.118.835-4.694 1.655-7.434 2.525-9.797 3.106-24.6 7.805-28.616 17.271-2.079 4.904-1.256 11.211 2.46 18.748.087.168.166.342.239.515 1.301 3.03 32.615 74.46 102.23 85.934 6.427 1.058 11.163 7.877 7.725 15.859z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSnapchatSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-6.5 314.9c-3.5 8.1-18.1 14-44.8 18.2-1.4 1.9-2.5 9.8-4.3 15.9-1.1 3.7-3.7 5.9-8.1 5.9h-.2c-6.2 0-12.8-2.9-25.8-2.9-17.6 0-23.7 4-37.4 13.7-14.5 10.3-28.4 19.1-49.2 18.2-21 1.6-38.6-11.2-48.5-18.2-13.8-9.7-19.8-13.7-37.4-13.7-12.5 0-20.4 3.1-25.8 3.1-5.4 0-7.5-3.3-8.3-6-1.8-6.1-2.9-14.1-4.3-16-13.8-2.1-44.8-7.5-45.5-21.4-.2-3.6 2.3-6.8 5.9-7.4 46.3-7.6 67.1-55.1 68-57.1 0-.1.1-.2.2-.3 2.5-5 3-9.2 1.6-12.5-3.4-7.9-17.9-10.7-24-13.2-15.8-6.2-18-13.4-17-18.3 1.6-8.5 14.4-13.8 21.9-10.3 5.9 2.8 11.2 4.2 15.7 4.2 3.3 0 5.5-.8 6.6-1.4-1.4-23.9-4.7-58 3.8-77.1C159.1 100 206.7 96 220.7 96c.6 0 6.1-.1 6.7-.1 34.7 0 68 17.8 84.3 54.3 8.5 19.1 5.2 53.1 3.8 77.1 1.1.6 2.9 1.3 5.7 1.4 4.3-.2 9.2-1.6 14.7-4.2 4-1.9 9.6-1.6 13.6 0 6.3 2.3 10.3 6.8 10.4 11.9.1 6.5-5.7 12.1-17.2 16.6-1.4.6-3.1 1.1-4.9 1.7-6.5 2.1-16.4 5.2-19 11.5-1.4 3.3-.8 7.5 1.6 12.5.1.1.1.2.2.3.9 2 21.7 49.5 68 57.1 4 1 7.1 5.5 4.9 10.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSnapchat(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm169.5 338.9c-3.5 8.1-18.1 14-44.8 18.2-1.4 1.9-2.5 9.8-4.3 15.9-1.1 3.7-3.7 5.9-8.1 5.9h-.2c-6.2 0-12.8-2.9-25.8-2.9-17.6 0-23.7 4-37.4 13.7-14.5 10.3-28.4 19.1-49.2 18.2-21 1.6-38.6-11.2-48.5-18.2-13.8-9.7-19.8-13.7-37.4-13.7-12.5 0-20.4 3.1-25.8 3.1-5.4 0-7.5-3.3-8.3-6-1.8-6.1-2.9-14.1-4.3-16-13.8-2.1-44.8-7.5-45.5-21.4-.2-3.6 2.3-6.8 5.9-7.4 46.3-7.6 67.1-55.1 68-57.1 0-.1.1-.2.2-.3 2.5-5 3-9.2 1.6-12.5-3.4-7.9-17.9-10.7-24-13.2-15.8-6.2-18-13.4-17-18.3 1.6-8.5 14.4-13.8 21.9-10.3 5.9 2.8 11.2 4.2 15.7 4.2 3.3 0 5.5-.8 6.6-1.4-1.4-23.9-4.7-58 3.8-77.1C183.1 100 230.7 96 244.7 96c.6 0 6.1-.1 6.7-.1 34.7 0 68 17.8 84.3 54.3 8.5 19.1 5.2 53.1 3.8 77.1 1.1.6 2.9 1.3 5.7 1.4 4.3-.2 9.2-1.6 14.7-4.2 4-1.9 9.6-1.6 13.6 0 6.3 2.3 10.3 6.8 10.4 11.9.1 6.5-5.7 12.1-17.2 16.6-1.4.6-3.1 1.1-4.9 1.7-6.5 2.1-16.4 5.2-19 11.5-1.4 3.3-.8 7.5 1.6 12.5.1.1.1.2.2.3.9 2 21.7 49.5 68 57.1 4 1 7.1 5.5 4.9 10.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSoundcloud(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M111.4 256.3l5.8 65-5.8 68.3c-.3 2.5-2.2 4.4-4.4 4.4s-4.2-1.9-4.2-4.4l-5.6-68.3 5.6-65c0-2.2 1.9-4.2 4.2-4.2 2.2 0 4.1 2 4.4 4.2zm21.4-45.6c-2.8 0-4.7 2.2-5 5l-5 105.6 5 68.3c.3 2.8 2.2 5 5 5 2.5 0 4.7-2.2 4.7-5l5.8-68.3-5.8-105.6c0-2.8-2.2-5-4.7-5zm25.5-24.1c-3.1 0-5.3 2.2-5.6 5.3l-4.4 130 4.4 67.8c.3 3.1 2.5 5.3 5.6 5.3 2.8 0 5.3-2.2 5.3-5.3l5.3-67.8-5.3-130c0-3.1-2.5-5.3-5.3-5.3zM7.2 283.2c-1.4 0-2.2 1.1-2.5 2.5L0 321.3l4.7 35c.3 1.4 1.1 2.5 2.5 2.5s2.2-1.1 2.5-2.5l5.6-35-5.6-35.6c-.3-1.4-1.1-2.5-2.5-2.5zm23.6-21.9c-1.4 0-2.5 1.1-2.5 2.5l-6.4 57.5 6.4 56.1c0 1.7 1.1 2.8 2.5 2.8s2.5-1.1 2.8-2.5l7.2-56.4-7.2-57.5c-.3-1.4-1.4-2.5-2.8-2.5zm25.3-11.4c-1.7 0-3.1 1.4-3.3 3.3L47 321.3l5.8 65.8c.3 1.7 1.7 3.1 3.3 3.1 1.7 0 3.1-1.4 3.1-3.1l6.9-65.8-6.9-68.1c0-1.9-1.4-3.3-3.1-3.3zm25.3-2.2c-1.9 0-3.6 1.4-3.6 3.6l-5.8 70 5.8 67.8c0 2.2 1.7 3.6 3.6 3.6s3.6-1.4 3.9-3.6l6.4-67.8-6.4-70c-.3-2.2-2-3.6-3.9-3.6zm241.4-110.9c-1.1-.8-2.8-1.4-4.2-1.4-2.2 0-4.2.8-5.6 1.9-1.9 1.7-3.1 4.2-3.3 6.7v.8l-3.3 176.7 1.7 32.5 1.7 31.7c.3 4.7 4.2 8.6 8.9 8.6s8.6-3.9 8.6-8.6l3.9-64.2-3.9-177.5c-.4-3-2-5.8-4.5-7.2zm-26.7 15.3c-1.4-.8-2.8-1.4-4.4-1.4s-3.1.6-4.4 1.4c-2.2 1.4-3.6 3.9-3.6 6.7l-.3 1.7-2.8 160.8s0 .3 3.1 65.6v.3c0 1.7.6 3.3 1.7 4.7 1.7 1.9 3.9 3.1 6.4 3.1 2.2 0 4.2-1.1 5.6-2.5 1.7-1.4 2.5-3.3 2.5-5.6l.3-6.7 3.1-58.6-3.3-162.8c-.3-2.8-1.7-5.3-3.9-6.7zm-111.4 22.5c-3.1 0-5.8 2.8-5.8 6.1l-4.4 140.6 4.4 67.2c.3 3.3 2.8 5.8 5.8 5.8 3.3 0 5.8-2.5 6.1-5.8l5-67.2-5-140.6c-.2-3.3-2.7-6.1-6.1-6.1zm376.7 62.8c-10.8 0-21.1 2.2-30.6 6.1-6.4-70.8-65.8-126.4-138.3-126.4-17.8 0-35 3.3-50.3 9.4-6.1 2.2-7.8 4.4-7.8 9.2v249.7c0 5 3.9 8.6 8.6 9.2h218.3c43.3 0 78.6-35 78.6-78.3.1-43.6-35.2-78.9-78.5-78.9zm-296.7-60.3c-4.2 0-7.5 3.3-7.8 7.8l-3.3 136.7 3.3 65.6c.3 4.2 3.6 7.5 7.8 7.5 4.2 0 7.5-3.3 7.5-7.5l3.9-65.6-3.9-136.7c-.3-4.5-3.3-7.8-7.5-7.8zm-53.6-7.8c-3.3 0-6.4 3.1-6.4 6.7l-3.9 145.3 3.9 66.9c.3 3.6 3.1 6.4 6.4 6.4 3.6 0 6.4-2.8 6.7-6.4l4.4-66.9-4.4-145.3c-.3-3.6-3.1-6.7-6.7-6.7zm26.7 3.4c-3.9 0-6.9 3.1-6.9 6.9L227 321.3l3.9 66.4c.3 3.9 3.1 6.9 6.9 6.9s6.9-3.1 6.9-6.9l4.2-66.4-4.2-141.7c0-3.9-3-6.9-6.9-6.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSourcetree(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M427.2 203c0-112.1-90.9-203-203-203C112.1-.2 21.2 90.6 21 202.6A202.86 202.86 0 0 0 161.5 396v101.7a14.3 14.3 0 0 0 14.3 14.3h96.4a14.3 14.3 0 0 0 14.3-14.3V396.1A203.18 203.18 0 0 0 427.2 203zm-271.6 0c0-90.8 137.3-90.8 137.3 0-.1 89.9-137.3 91-137.3 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSpeakap(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 391.78C-15.41 303.59-8 167.42 80.64 87.64s224.8-73 304.21 15.24 72 224.36-16.64 304.14c-18.74 16.87 64 43.09 42 52.26-82.06 34.21-253.91 35-346.23-67.5zm213.31-211.6l38.5-40.86c-9.61-8.89-32-26.83-76.17-27.6-52.33-.91-95.86 28.3-96.77 80-.2 11.33.29 36.72 29.42 54.83 34.46 21.42 86.52 21.51 86 52.26-.37 21.28-26.42 25.81-38.59 25.6-3-.05-30.23-.46-47.61-24.62l-40 42.61c28.16 27 59 32.62 83.49 33.05 10.23.18 96.42.33 97.84-81 .28-15.81-2.07-39.72-28.86-56.59-34.36-21.64-85-19.45-84.43-49.75.41-23.25 31-25.37 37.53-25.26.43 0 26.62.26 39.62 17.37z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSpeakerDeck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M213.86 296H100a100 100 0 0 1 0-200h132.84a40 40 0 0 1 0 80H98c-26.47 0-26.45 40 0 40h113.82a100 100 0 0 1 0 200H40a40 40 0 0 1 0-80h173.86c26.48 0 26.46-40 0-40zM298 416a120.21 120.21 0 0 0 51.11-80h64.55a19.83 19.83 0 0 0 19.66-20V196a19.83 19.83 0 0 0-19.66-20H296.42a60.77 60.77 0 0 0 0-80h136.93c43.44 0 78.65 35.82 78.65 80v160c0 44.18-35.21 80-78.65 80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSpotify(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111.1 8 0 119.1 0 256s111.1 248 248 248 248-111.1 248-248S384.9 8 248 8zm100.7 364.9c-4.2 0-6.8-1.3-10.7-3.6-62.4-37.6-135-39.2-206.7-24.5-3.9 1-9 2.6-11.9 2.6-9.7 0-15.8-7.7-15.8-15.8 0-10.3 6.1-15.2 13.6-16.8 81.9-18.1 165.6-16.5 237 26.2 6.1 3.9 9.7 7.4 9.7 16.5s-7.1 15.4-15.2 15.4zm26.9-65.6c-5.2 0-8.7-2.3-12.3-4.2-62.5-37-155.7-51.9-238.6-29.4-4.8 1.3-7.4 2.6-11.9 2.6-10.7 0-19.4-8.7-19.4-19.4s5.2-17.8 15.5-20.7c27.8-7.8 56.2-13.6 97.8-13.6 64.9 0 127.6 16.1 177 45.5 8.1 4.8 11.3 11 11.3 19.7-.1 10.8-8.5 19.5-19.4 19.5zm31-76.2c-5.2 0-8.4-1.3-12.9-3.9-71.2-42.5-198.5-52.7-280.9-29.7-3.6 1-8.1 2.6-12.9 2.6-13.2 0-23.3-10.3-23.3-23.6 0-13.6 8.4-21.3 17.4-23.9 35.2-10.3 74.6-15.2 117.5-15.2 73 0 149.5 15.2 205.4 47.8 7.8 4.5 12.9 10.7 12.9 22.6 0 13.6-11 23.3-23.2 23.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSquarespace(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M186.12 343.34c-9.65 9.65-9.65 25.29 0 34.94 9.65 9.65 25.29 9.65 34.94 0L378.24 221.1c19.29-19.29 50.57-19.29 69.86 0s19.29 50.57 0 69.86L293.95 445.1c19.27 19.29 50.53 19.31 69.82.04l.04-.04 119.25-119.24c38.59-38.59 38.59-101.14 0-139.72-38.59-38.59-101.15-38.59-139.72 0l-157.22 157.2zm244.53-104.8c-9.65-9.65-25.29-9.65-34.93 0l-157.2 157.18c-19.27 19.29-50.53 19.31-69.82.05l-.05-.05c-9.64-9.64-25.27-9.65-34.92-.01l-.01.01c-9.65 9.64-9.66 25.28-.02 34.93l.02.02c38.58 38.57 101.14 38.57 139.72 0l157.2-157.2c9.65-9.65 9.65-25.29.01-34.93zm-261.99 87.33l157.18-157.18c9.64-9.65 9.64-25.29 0-34.94-9.64-9.64-25.27-9.64-34.91 0L133.72 290.93c-19.28 19.29-50.56 19.3-69.85.01l-.01-.01c-19.29-19.28-19.31-50.54-.03-69.84l.03-.03L218.03 66.89c-19.28-19.29-50.55-19.3-69.85-.02l-.02.02L28.93 186.14c-38.58 38.59-38.58 101.14 0 139.72 38.6 38.59 101.13 38.59 139.73.01zm-87.33-52.4c9.64 9.64 25.27 9.64 34.91 0l157.21-157.19c19.28-19.29 50.55-19.3 69.84-.02l.02.02c9.65 9.65 25.29 9.65 34.93 0 9.65-9.65 9.65-25.29 0-34.93-38.59-38.59-101.13-38.59-139.72 0L81.33 238.54c-9.65 9.64-9.65 25.28-.01 34.93h.01z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStackExchange(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.7 332.3h412.7v22c0 37.7-29.3 68-65.3 68h-19L259.3 512v-89.7H83c-36 0-65.3-30.3-65.3-68v-22zm0-23.6h412.7v-85H17.7v85zm0-109.4h412.7v-85H17.7v85zM365 0H83C47 0 17.7 30.3 17.7 67.7V90h412.7V67.7C430.3 30.3 401 0 365 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStackOverflow(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M290.7 311L95 269.7 86.8 309l195.7 41zm51-87L188.2 95.7l-25.5 30.8 153.5 128.3zm-31.2 39.7L129.2 179l-16.7 36.5L293.7 300zM262 32l-32 24 119.3 160.3 32-24zm20.5 328h-200v39.7h200zm39.7 80H42.7V320h-40v160h359.5V320h-40z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStackpath(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M244.6 232.4c0 8.5-4.26 20.49-21.34 20.49h-19.61v-41.47h19.61c17.13 0 21.34 12.36 21.34 20.98zM448 32v448H0V32zM151.3 287.84c0-21.24-12.12-34.54-46.72-44.85-20.57-7.41-26-10.91-26-18.63s7-14.61 20.41-14.61c14.09 0 20.79 8.45 20.79 18.35h30.7l.19-.57c.5-19.57-15.06-41.65-51.12-41.65-23.37 0-52.55 10.75-52.55 38.29 0 19.4 9.25 31.29 50.74 44.37 17.26 6.15 21.91 10.4 21.91 19.48 0 15.2-19.13 14.23-19.47 14.23-20.4 0-25.65-9.1-25.65-21.9h-30.8l-.18.56c-.68 31.32 28.38 45.22 56.63 45.22 29.98 0 51.12-13.55 51.12-38.29zm125.38-55.63c0-25.3-18.43-45.46-53.42-45.46h-51.78v138.18h32.17v-47.36h19.61c30.25 0 53.42-15.95 53.42-45.36zM297.94 325L347 186.78h-31.09L268 325zm106.52-138.22h-31.09L325.46 325h29.94z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStaylinked(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 440 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M382.7 292.5l2.7 2.7-170-167.3c-3.5-3.5-9.7-3.7-13.8-.5L144.3 171c-4.2 3.2-4.6 8.7-1.1 12.2l68.1 64.3c3.6 3.5 9.9 3.7 14 .5l.1-.1c4.1-3.2 10.4-3 14 .5l84 81.3c3.6 3.5 3.2 9-.9 12.2l-93.2 74c-4.2 3.3-10.5 3.1-14.2-.4L63.2 268c-3.5-3.5-9.7-3.7-13.9-.5L3.5 302.4c-4.2 3.2-4.7 8.7-1.2 12.2L211 510.7s7.4 6.8 17.3-.8l198-163.9c4-3.2 4.4-8.7.7-12.2zm54.5-83.4L226.7 2.5c-1.5-1.2-8-5.5-16.3 1.1L3.6 165.7c-4.2 3.2-4.8 8.7-1.2 12.2l42.3 41.7 171.7 165.1c3.7 3.5 10.1 3.7 14.3.4l50.2-38.8-.3-.3 7.7-6c4.2-3.2 4.6-8.7.9-12.2l-57.1-54.4c-3.6-3.5-10-3.7-14.2-.5l-.1.1c-4.2 3.2-10.5 3.1-14.2-.4L109 180.8c-3.6-3.5-3.1-8.9 1.1-12.2l92.2-71.5c4.1-3.2 10.3-3 13.9.5l160.4 159c3.7 3.5 10 3.7 14.1.5l45.8-35.8c4.1-3.2 4.4-8.7.7-12.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSteamSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M185.2 356.5c7.7-18.5-1-39.7-19.6-47.4l-29.5-12.2c11.4-4.3 24.3-4.5 36.4.5 12.2 5.1 21.6 14.6 26.7 26.7 5 12.2 5 25.6-.1 37.7-10.5 25.1-39.4 37-64.6 26.5-11.6-4.8-20.4-13.6-25.4-24.2l28.5 11.8c18.6 7.8 39.9-.9 47.6-19.4zM400 32H48C21.5 32 0 53.5 0 80v160.7l116.6 48.1c12-8.2 26.2-12.1 40.7-11.3l55.4-80.2v-1.1c0-48.2 39.3-87.5 87.6-87.5s87.6 39.3 87.6 87.5c0 49.2-40.9 88.7-89.6 87.5l-79 56.3c1.6 38.5-29.1 68.8-65.7 68.8-31.8 0-58.5-22.7-64.5-52.7L0 319.2V432c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-99.7 222.5c-32.2 0-58.4-26.1-58.4-58.3s26.2-58.3 58.4-58.3 58.4 26.2 58.4 58.3-26.2 58.3-58.4 58.3zm.1-14.6c24.2 0 43.9-19.6 43.9-43.8 0-24.2-19.6-43.8-43.9-43.8-24.2 0-43.9 19.6-43.9 43.8 0 24.2 19.7 43.8 43.9 43.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSteamSymbol(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M395.5 177.5c0 33.8-27.5 61-61 61-33.8 0-61-27.3-61-61s27.3-61 61-61c33.5 0 61 27.2 61 61zm52.5.2c0 63-51 113.8-113.7 113.8L225 371.3c-4 43-40.5 76.8-84.5 76.8-40.5 0-74.7-28.8-83-67L0 358V250.7L97.2 290c15.1-9.2 32.2-13.3 52-11.5l71-101.7c.5-62.3 51.5-112.8 114-112.8C397 64 448 115 448 177.7zM203 363c0-34.7-27.8-62.5-62.5-62.5-4.5 0-9 .5-13.5 1.5l26 10.5c25.5 10.2 38 39 27.7 64.5-10.2 25.5-39.2 38-64.7 27.5-10.2-4-20.5-8.3-30.7-12.2 10.5 19.7 31.2 33.2 55.2 33.2 34.7 0 62.5-27.8 62.5-62.5zm207.5-185.3c0-42-34.3-76.2-76.2-76.2-42.3 0-76.5 34.2-76.5 76.2 0 42.2 34.3 76.2 76.5 76.2 41.9.1 76.2-33.9 76.2-76.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSteam(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 256c0 137-111.2 248-248.4 248-113.8 0-209.6-76.3-239-180.4l95.2 39.3c6.4 32.1 34.9 56.4 68.9 56.4 39.2 0 71.9-32.4 70.2-73.5l84.5-60.2c52.1 1.3 95.8-40.9 95.8-93.5 0-51.6-42-93.5-93.7-93.5s-93.7 42-93.7 93.5v1.2L176.6 279c-15.5-.9-30.7 3.4-43.5 12.1L0 236.1C10.2 108.4 117.1 8 247.6 8 384.8 8 496 119 496 256zM155.7 384.3l-30.5-12.6a52.79 52.79 0 0 0 27.2 25.8c26.9 11.2 57.8-1.6 69-28.4 5.4-13 5.5-27.3.1-40.3-5.4-13-15.5-23.2-28.5-28.6-12.9-5.4-26.7-5.2-38.9-.6l31.5 13c19.8 8.2 29.2 30.9 20.9 50.7-8.3 19.9-31 29.2-50.8 21zm173.8-129.9c-34.4 0-62.4-28-62.4-62.3s28-62.3 62.4-62.3 62.4 28 62.4 62.3-27.9 62.3-62.4 62.3zm.1-15.6c25.9 0 46.9-21 46.9-46.8 0-25.9-21-46.8-46.9-46.8s-46.9 21-46.9 46.8c.1 25.8 21.1 46.8 46.9 46.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStickerMule(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M561.7 199.6c-1.3.3.3 0 0 0zm-6.2-77.4c-7.7-22.3-5.1-7.2-13.4-36.9-1.6-6.5-3.6-14.5-6.2-20-4.4-8.7-4.6-7.5-4.6-9.5 0-5.3 30.7-45.3 19-46.9-5.7-.6-12.2 11.6-20.6 17-8.6 4.2-8 5-10.3 5-2.6 0-5.7-3-6.2-5-2-5.7 1.9-25.9-3.6-25.9-3.6 0-12.3 24.8-17 25.8-5.2 1.3-27.9-11.4-75.1 18-25.3 13.2-86.9 65.2-87 65.3-6.7 4.7-20 4.7-35.5 16-44.4 30.1-109.6 9.4-110.7 9-110.6-26.8-128-15.2-159 11.5-20.8 17.9-23.7 36.5-24.2 38.9-4.2 20.4 5.2 48.3 6.7 64.3 1.8 19.3-2.7 17.7 7.7 98.3.5 1 4.1 0 5.1 1.5 0 8.4-3.8 12.1-4.1 13-1.5 4.5-1.5 10.5 0 16 2.3 8.2 8.2 37.2 8.2 46.9 0 41.8.4 44 2.6 49.4 3.9 10 12.5 9.1 17 12 3.1 3.5-.5 8.5 1 12.5.5 2 3.6 4 6.2 5 9.2 3.6 27 .3 29.9-2.5 1.6-1.5.5-4.5 3.1-5 5.1 0 10.8-.5 14.4-2.5 5.1-2.5 4.1-6 1.5-10.5-.4-.8-7-13.3-9.8-16-2.1-2-5.1-3-7.2-4.5-5.8-4.9-10.3-19.4-10.3-19.5-4.6-19.4-10.3-46.3-4.1-66.8 4.6-17.2 39.5-87.7 39.6-87.8 4.1-6.5 17-11.5 27.3-7 6 1.9 19.3 22 65.4 30.9 47.9 8.7 97.4-2 112.2-2 2.8 2-1.9 13-.5 38.9 0 26.4-.4 13.7-4.1 29.9-2.2 9.7 3.4 23.2-1.5 46.9-1.4 9.8-9.9 32.7-8.2 43.4.5 1 1 2 1.5 3.5.5 4.5 1.5 8.5 4.6 10 7.3 3.6 12-3.5 9.8 11.5-.7 3.1-2.6 12 1.5 15 4.4 3.7 30.6 3.4 36.5.5 2.6-1.5 1.6-4.5 6.4-7.4 1.9-.9 11.3-.4 11.3-6.5.3-1.8-9.2-19.9-9.3-20-2.6-3.5-9.2-4.5-11.3-8-6.9-10.1-1.7-52.6.5-59.4 3-11 5.6-22.4 8.7-32.4 11-42.5 10.3-50.6 16.5-68.3.8-1.8 6.4-23.1 10.3-29.9 9.3-17 21.7-32.4 33.5-47.4 18-22.9 34-46.9 52-69.8 6.1-7 8.2-13.7 18-8 10.8 5.7 21.6 7 31.9 17 14.6 12.8 10.2 18.2 11.8 22.9 1.5 5 7.7 10.5 14.9 9.5 10.4-2 13-2.5 13.4-2.5 2.6-.5 5.7-5 7.2-8 3.1-5.5 7.2-9 7.2-16.5 0-7.7-.4-2.8-20.6-52.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStrava(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M158.4 0L7 292h89.2l62.2-116.1L220.1 292h88.5zm150.2 292l-43.9 88.2-44.6-88.2h-67.6l112.2 220 111.5-220z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStripeS(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M155.3 154.6c0-22.3 18.6-30.9 48.4-30.9 43.4 0 98.5 13.3 141.9 36.7V26.1C298.3 7.2 251.1 0 203.8 0 88.1 0 11 60.4 11 161.4c0 157.9 216.8 132.3 216.8 200.4 0 26.4-22.9 34.9-54.7 34.9-47.2 0-108.2-19.5-156.1-45.5v128.5a396.09 396.09 0 0 0 156 32.4c118.6 0 200.3-51 200.3-153.6 0-170.2-218-139.7-218-203.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStripe(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M165 144.7l-43.3 9.2-.2 142.4c0 26.3 19.8 43.3 46.1 43.3 14.6 0 25.3-2.7 31.2-5.9v-33.8c-5.7 2.3-33.7 10.5-33.7-15.7V221h33.7v-37.8h-33.7zm89.1 51.6l-2.7-13.1H213v153.2h44.3V233.3c10.5-13.8 28.2-11.1 33.9-9.3v-40.8c-6-2.1-26.7-6-37.1 13.1zm92.3-72.3l-44.6 9.5v36.2l44.6-9.5zM44.9 228.3c0-6.9 5.8-9.6 15.1-9.7 13.5 0 30.7 4.1 44.2 11.4v-41.8c-14.7-5.8-29.4-8.1-44.1-8.1-36 0-60 18.8-60 50.2 0 49.2 67.5 41.2 67.5 62.4 0 8.2-7.1 10.9-17 10.9-14.7 0-33.7-6.1-48.6-14.2v40c16.5 7.1 33.2 10.1 48.5 10.1 36.9 0 62.3-15.8 62.3-47.8 0-52.9-67.9-43.4-67.9-63.4zM640 261.6c0-45.5-22-81.4-64.2-81.4s-67.9 35.9-67.9 81.1c0 53.5 30.3 78.2 73.5 78.2 21.2 0 37.1-4.8 49.2-11.5v-33.4c-12.1 6.1-26 9.8-43.6 9.8-17.3 0-32.5-6.1-34.5-26.9h86.9c.2-2.3.6-11.6.6-15.9zm-87.9-16.8c0-20 12.3-28.4 23.4-28.4 10.9 0 22.5 8.4 22.5 28.4zm-112.9-64.6c-17.4 0-28.6 8.2-34.8 13.9l-2.3-11H363v204.8l44.4-9.4.1-50.2c6.4 4.7 15.9 11.2 31.4 11.2 31.8 0 60.8-23.2 60.8-79.6.1-51.6-29.3-79.7-60.5-79.7zm-10.6 122.5c-10.4 0-16.6-3.8-20.9-8.4l-.3-66c4.6-5.1 11-8.8 21.2-8.8 16.2 0 27.4 18.2 27.4 41.4.1 23.9-10.9 41.8-27.4 41.8zm-126.7 33.7h44.6V183.2h-44.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStudiovinari(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480.3 187.7l4.2 28v28l-25.1 44.1-39.8 78.4-56.1 67.5-79.1 37.8-17.7 24.5-7.7 12-9.6 4s17.3-63.6 19.4-63.6c2.1 0 20.3.7 20.3.7l66.7-38.6-92.5 26.1-55.9 36.8-22.8 28-6.6 1.4 20.8-73.6 6.9-5.5 20.7 12.9 88.3-45.2 56.8-51.5 14.8-68.4-125.4 23.3 15.2-18.2-173.4-53.3 81.9-10.5-166-122.9L133.5 108 32.2 0l252.9 126.6-31.5-38L378 163 234.7 64l18.7 38.4-49.6-18.1L158.3 0l194.6 122L310 66.2l108 96.4 12-8.9-21-16.4 4.2-37.8L451 89.1l29.2 24.7 11.5 4.2-7 6.2 8.5 12-13.1 7.4-10.3 20.2 10.5 23.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStumbleuponCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 177.5c-9.8 0-17.8 8-17.8 17.8v106.9c0 40.9-33.9 73.9-74.9 73.9-41.4 0-74.9-33.5-74.9-74.9v-46.5h57.3v45.8c0 10 8 17.8 17.8 17.8s17.8-7.9 17.8-17.8V200.1c0-40 34.2-72.1 74.7-72.1 40.7 0 74.7 32.3 74.7 72.6v23.7l-34.1 10.1-22.9-10.7v-20.6c.1-9.6-7.9-17.6-17.7-17.6zm167.6 123.6c0 41.4-33.5 74.9-74.9 74.9-41.2 0-74.9-33.2-74.9-74.2V263l22.9 10.7 34.1-10.1v47.1c0 9.8 8 17.6 17.8 17.6s17.8-7.9 17.8-17.6v-48h57.3c-.1 45.9-.1 46.4-.1 46.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStumbleupon(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M502.9 266v69.7c0 62.1-50.3 112.4-112.4 112.4-61.8 0-112.4-49.8-112.4-111.3v-70.2l34.3 16 51.1-15.2V338c0 14.7 12 26.5 26.7 26.5S417 352.7 417 338v-72h85.9zm-224.7-58.2l34.3 16 51.1-15.2V173c0-60.5-51.1-109-112.1-109-60.8 0-112.1 48.2-112.1 108.2v162.4c0 14.9-12 26.7-26.7 26.7S86 349.5 86 334.6V266H0v69.7C0 397.7 50.3 448 112.4 448c61.6 0 112.4-49.5 112.4-110.8V176.9c0-14.7 12-26.7 26.7-26.7s26.7 12 26.7 26.7v30.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSuperpowers(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 32c-83.3 11-166.8 22-250 33-92 12.5-163.3 86.7-169 180-3.3 55.5 18 109.5 57.8 148.2L0 480c83.3-11 166.5-22 249.8-33 91.8-12.5 163.3-86.8 168.7-179.8 3.5-55.5-18-109.5-57.7-148.2L448 32zm-79.7 232.3c-4.2 79.5-74 139.2-152.8 134.5-79.5-4.7-140.7-71-136.3-151 4.5-79.2 74.3-139.3 153-134.5 79.3 4.7 140.5 71 136.1 151z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSupple(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M640 262.5c0 64.1-109 116.1-243.5 116.1-24.8 0-48.6-1.8-71.1-5 7.7.4 15.5.6 23.4.6 134.5 0 243.5-56.9 243.5-127.1 0-29.4-19.1-56.4-51.2-78 60 21.1 98.9 55.1 98.9 93.4zM47.7 227.9c-.1-70.2 108.8-127.3 243.3-127.6 7.9 0 15.6.2 23.3.5-22.5-3.2-46.3-4.9-71-4.9C108.8 96.3-.1 148.5 0 212.6c.1 38.3 39.1 72.3 99.3 93.3-32.3-21.5-51.5-48.6-51.6-78zm60.2 39.9s10.5 13.2 29.3 13.2c17.9 0 28.4-11.5 28.4-25.1 0-28-40.2-25.1-40.2-39.7 0-5.4 5.3-9.1 12.5-9.1 5.7 0 11.3 2.6 11.3 6.6v3.9h14.2v-7.9c0-12.1-15.4-16.8-25.4-16.8-16.5 0-28.5 10.2-28.5 24.1 0 26.6 40.2 25.4 40.2 39.9 0 6.6-5.8 10.1-12.3 10.1-11.9 0-20.7-10.1-20.7-10.1l-8.8 10.9zm120.8-73.6v54.4c0 11.3-7.1 17.8-17.8 17.8-10.7 0-17.8-6.5-17.8-17.7v-54.5h-15.8v55c0 18.9 13.4 31.9 33.7 31.9 20.1 0 33.4-13 33.4-31.9v-55h-15.7zm34.4 85.4h15.8v-29.5h15.5c16 0 27.2-11.5 27.2-28.1s-11.2-27.8-27.2-27.8h-39.1v13.4h7.8v72zm15.8-43v-29.1h12.9c8.7 0 13.7 5.7 13.7 14.4 0 8.9-5.1 14.7-14 14.7h-12.6zm57 43h15.8v-29.5h15.5c16 0 27.2-11.5 27.2-28.1s-11.2-27.8-27.2-27.8h-39.1v13.4h7.8v72zm15.7-43v-29.1h12.9c8.7 0 13.7 5.7 13.7 14.4 0 8.9-5 14.7-14 14.7h-12.6zm57.1 34.8c0 5.8 2.4 8.2 8.2 8.2h37.6c5.8 0 8.2-2.4 8.2-8.2v-13h-14.3v5.2c0 1.7-1 2.6-2.6 2.6h-18.6c-1.7 0-2.6-1-2.6-2.6v-61.2c0-5.7-2.4-8.2-8.2-8.2H401v13.4h5.2c1.7 0 2.6 1 2.6 2.6v61.2zm63.4 0c0 5.8 2.4 8.2 8.2 8.2H519c5.7 0 8.2-2.4 8.2-8.2v-13h-14.3v5.2c0 1.7-1 2.6-2.6 2.6h-19.7c-1.7 0-2.6-1-2.6-2.6v-20.3h27.7v-13.4H488v-22.4h19.2c1.7 0 2.6 1 2.6 2.6v5.2H524v-13c0-5.7-2.5-8.2-8.2-8.2h-51.6v13.4h7.8v63.9zm58.9-76v5.9h1.6v-5.9h2.7v-1.2h-7v1.2h2.7zm5.7-1.2v7.1h1.5v-5.7l2.3 5.7h1.3l2.3-5.7v5.7h1.5v-7.1h-2.3l-2.1 5.1-2.1-5.1h-2.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSuse(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M471.08 102.66s-.3 18.3-.3 20.3c-9.1-3-74.4-24.1-135.7-26.3-51.9-1.8-122.8-4.3-223 57.3-19.4 12.4-73.9 46.1-99.6 109.7C7 277-.12 307 7 335.06a111 111 0 0 0 16.5 35.7c17.4 25 46.6 41.6 78.1 44.4 44.4 3.9 78.1-16 90-53.3 8.2-25.8 0-63.6-31.5-82.9-25.6-15.7-53.3-12.1-69.2-1.6-13.9 9.2-21.8 23.5-21.6 39.2.3 27.8 24.3 42.6 41.5 42.6a49 49 0 0 0 15.8-2.7c6.5-1.8 13.3-6.5 13.3-14.9 0-12.1-11.6-14.8-16.8-13.9-2.9.5-4.5 2-11.8 2.4-2-.2-12-3.1-12-14V316c.2-12.3 13.2-18 25.5-16.9 32.3 2.8 47.7 40.7 28.5 65.7-18.3 23.7-76.6 23.2-99.7-20.4-26-49.2 12.7-111.2 87-98.4 33.2 5.7 83.6 35.5 102.4 104.3h45.9c-5.7-17.6-8.9-68.3 42.7-68.3 56.7 0 63.9 39.9 79.8 68.3H460c-12.8-18.3-21.7-38.7-18.9-55.8 5.6-33.8 39.7-18.4 82.4-17.4 66.5.4 102.1-27 103.1-28 3.7-3.1 6.5-15.8 7-17.7 1.3-5.1-3.2-2.4-3.2-2.4-8.7 5.2-30.5 15.2-50.9 15.6-25.3.5-76.2-25.4-81.6-28.2-.3-.4.1 1.2-11-25.5 88.4 58.3 118.3 40.5 145.2 21.7.8-.6 4.3-2.9 3.6-5.7-13.8-48.1-22.4-62.7-34.5-69.6-37-21.6-125-34.7-129.2-35.3.1-.1-.9-.3-.9.7zm60.4 72.8a37.54 37.54 0 0 1 38.9-36.3c33.4 1.2 48.8 42.3 24.4 65.2-24.2 22.7-64.4 4.6-63.3-28.9zm38.6-25.3a26.27 26.27 0 1 0 25.4 27.2 26.19 26.19 0 0 0-25.4-27.2zm4.3 28.8c-15.4 0-15.4-15.6 0-15.6s15.4 15.64 0 15.64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSwift(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 156.09c0-4.51-.08-9-.2-13.52a196.31 196.31 0 0 0-2.58-29.42 99.62 99.62 0 0 0-9.22-28A94.08 94.08 0 0 0 394.84 44a99.17 99.17 0 0 0-28-9.22 195 195 0 0 0-29.43-2.59c-4.51-.12-9-.17-13.52-.2H124.14c-4.51 0-9 .08-13.52.2-2.45.07-4.91.15-7.37.27a171.68 171.68 0 0 0-22.06 2.32 103.06 103.06 0 0 0-21.21 6.1q-3.46 1.45-6.81 3.12a94.66 94.66 0 0 0-18.39 12.32c-1.88 1.61-3.69 3.28-5.43 5A93.86 93.86 0 0 0 12 85.17a99.45 99.45 0 0 0-9.22 28 196.31 196.31 0 0 0-2.54 29.4c-.13 4.51-.18 9-.21 13.52v199.83c0 4.51.08 9 .21 13.51a196.08 196.08 0 0 0 2.58 29.42 99.3 99.3 0 0 0 9.22 28A94.31 94.31 0 0 0 53.17 468a99.47 99.47 0 0 0 28 9.21 195 195 0 0 0 29.43 2.59c4.5.12 9 .17 13.52.2H323.91c4.51 0 9-.08 13.52-.2a196.59 196.59 0 0 0 29.44-2.59 99.57 99.57 0 0 0 28-9.21A94.22 94.22 0 0 0 436 426.84a99.3 99.3 0 0 0 9.22-28 194.79 194.79 0 0 0 2.59-29.42c.12-4.5.17-9 .2-13.51V172.14c-.01-5.35-.01-10.7-.01-16.05zm-69.88 241c-20-38.93-57.23-29.27-76.31-19.47-1.72 1-3.48 2-5.25 3l-.42.25c-39.5 21-92.53 22.54-145.85-.38A234.64 234.64 0 0 1 45 290.12a230.63 230.63 0 0 0 39.17 23.37c56.36 26.4 113 24.49 153 0-57-43.85-104.6-101-141.09-147.22a197.09 197.09 0 0 1-18.78-25.9c43.7 40 112.7 90.22 137.48 104.12-52.57-55.49-98.89-123.94-96.72-121.74 82.79 83.42 159.18 130.59 159.18 130.59 2.88 1.58 5 2.85 6.73 4a127.44 127.44 0 0 0 4.16-12.47c13.22-48.33-1.66-103.58-35.31-149.2C329.61 141.75 375 229.34 356.4 303.42c-.44 1.73-.95 3.4-1.44 5.09 38.52 47.4 28.04 98.17 23.13 88.59z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSymfony(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm133.74 143.54c-11.47.41-19.4-6.45-19.77-16.87-.27-9.18 6.68-13.44 6.53-18.85-.23-6.55-10.16-6.82-12.87-6.67-39.78 1.29-48.59 57-58.89 113.85 21.43 3.15 36.65-.72 45.14-6.22 12-7.75-3.34-15.72-1.42-24.56 4-18.16 32.55-19 32 5.3-.36 17.86-25.92 41.81-77.6 35.7-10.76 59.52-18.35 115-58.2 161.72-29 34.46-58.4 39.82-71.58 40.26-24.65.85-41-12.31-41.58-29.84-.56-17 14.45-26.26 24.31-26.59 21.89-.75 30.12 25.67 14.88 34-12.09 9.71.11 12.61 2.05 12.55 10.42-.36 17.34-5.51 22.18-9 24-20 33.24-54.86 45.35-118.35 8.19-49.66 17-78 18.23-82-16.93-12.75-27.08-28.55-49.85-34.72-15.61-4.23-25.12-.63-31.81 7.83-7.92 10-5.29 23 2.37 30.7l12.63 14c15.51 17.93 24 31.87 20.8 50.62-5.06 29.93-40.72 52.9-82.88 39.94-36-11.11-42.7-36.56-38.38-50.62 7.51-24.15 42.36-11.72 34.62 13.6-2.79 8.6-4.92 8.68-6.28 13.07-4.56 14.77 41.85 28.4 51-1.39 4.47-14.52-5.3-21.71-22.25-39.85-28.47-31.75-16-65.49 2.95-79.67C204.23 140.13 251.94 197 262 205.29c37.17-109 100.53-105.46 102.43-105.53 25.16-.81 44.19 10.59 44.83 28.65.25 7.69-4.17 22.59-19.52 23.13z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTeamspeak(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M244.2 346.79c2.4-12.3-12-30-32.4-48.7-20.9-19.2-48.2-39.1-63.4-46.6-21.7-12-41.7-1.8-46.3 22.7-5 26.2 0 51.4 14.5 73.9 10.2 15.5 25.4 22.7 43.4 24 11.6.6 52.5 2.2 61.7-1 11.9-4.3 20.1-11.8 22.5-24.3zm205 20.8a5.22 5.22 0 0 0-8.3 2.4c-8 25.4-44.7 112.5-172.1 121.5-149.7 10.5 80.3 43.6 145.4-6.4 22.7-17.4 47.6-35 46.6-85.4-.4-10.1-4.9-26.69-11.6-32.1zm62-122.4c-.3-18.9-8.6-33.4-26-42.2-2.9-1.3-5-2.7-5.9-6.4A222.64 222.64 0 0 0 438.9 103c-1.1-1.5-3.5-3.2-2.2-5 8.5-11.5-.3-18-7-24.4Q321.4-31.11 177.4 13.09c-40.1 12.3-73.9 35.6-102 67.4-4 4.3-6.7 9.1-3 14.5 3 4 1.3 6.2-1 9.3C51.6 132 38.2 162.59 32.1 196c-.7 4.3-2.9 6-6.4 7.8-14.2 7-22.5 18.5-24.9 34L0 264.29v20.9c0 30.8 21 50.4 51.8 49 7.7-.3 11.7-4.3 12-11.5 2-77.5-2.4-95.4 3.7-125.8C92.1 72.39 234.3 5 345.3 65.39 411.4 102 445.7 159 447.6 234.79c.8 28.2 0 56.5 0 84.6 0 7 2.2 12.5 9.4 14.2 24.1 5 49.2-12 53.2-36.7 2.9-17.1 1-34.5 1-51.7zm-159.6 131.5c36.5 2.8 59.3-28.5 58.4-60.5-2.1-45.2-66.2-16.5-87.8-8-73.2 28.1-45 54.9-22.2 60.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTelegramPlane(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M446.7 98.6l-67.6 318.8c-5.1 22.5-18.4 28.1-37.3 17.5l-103-75.9-49.7 47.8c-5.5 5.5-10.1 10.1-20.7 10.1l7.4-104.9 190.9-172.5c8.3-7.4-1.8-11.5-12.9-4.1L117.8 284 16.2 252.2c-22.1-6.9-22.5-22.1 4.6-32.7L418.2 66.4c18.4-6.9 34.5 4.1 28.5 32.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTelegram(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm121.8 169.9l-40.7 191.8c-3 13.6-11.1 16.9-22.4 10.5l-62-45.7-29.9 28.8c-3.3 3.3-6.1 6.1-12.5 6.1l4.4-63.1 114.9-103.8c5-4.4-1.1-6.9-7.7-2.5l-142 89.4-61.2-19.1c-13.3-4.2-13.6-13.3 2.8-19.7l239.1-92.2c11.1-4 20.8 2.7 17.2 19.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTencentWeibo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M72.3 495.8c1.4 19.9-27.6 22.2-29.7 2.9C31 368.8 73.7 259.2 144 185.5c-15.6-34 9.2-77.1 50.6-77.1 30.3 0 55.1 24.6 55.1 55.1 0 44-49.5 70.8-86.9 45.1-65.7 71.3-101.4 169.8-90.5 287.2zM192 .1C66.1.1-12.3 134.3 43.7 242.4 52.4 259.8 79 246.9 70 229 23.7 136.4 91 29.8 192 29.8c75.4 0 136.9 61.4 136.9 136.9 0 90.8-86.9 153.9-167.7 133.1-19.1-4.1-25.6 24.4-6.6 29.1 110.7 23.2 204-60 204-162.3C358.6 74.7 284 .1 192 .1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTheRedYeti(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488.23 241.7l20.7 7.1c-9.6-23.9-23.9-37-31.7-44.8l7.1-18.2c.2 0 12.3-27.8-2.5-30.7-.6-11.3-6.6-27-18.4-27-7.6-10.6-17.7-12.3-30.7-5.9a122.2 122.2 0 0 0-25.3 16.5c-5.3-6.4-3 .4-3-29.8-37.1-24.3-45.4-11.7-74.8 3l.5.5a239.36 239.36 0 0 0-68.4-13.3c-5.5-8.7-18.6-19.1-25.1-25.1l24.8 7.1c-5.5-5.5-26.8-12.9-34.2-15.2 18.2-4.1 29.8-20.8 42.5-33-34.9-10.1-67.9-5.9-97.9 11.8l12-44.2L182 0c-31.6 24.2-33 41.9-33.7 45.5-.9-2.4-6.3-19.6-15.2-27a35.12 35.12 0 0 0-.5 25.3c3 8.4 5.9 14.8 8.4 18.9-16-3.3-28.3-4.9-49.2 0h-3.7l33 14.3a194.26 194.26 0 0 0-46.7 67.4l-1.7 8.4 1.7 1.7 7.6-4.7c-3.3 11.6-5.3 19.4-6.6 25.8a200.18 200.18 0 0 0-27.8 40.3c-15 1-31.8 10.8-40.3 14.3l3 3.4 28.8 1c-.5 1-.7 2.2-1.2 3.2-7.3 6.4-39.8 37.7-33 80.7l20.2-22.4c.5 1.7.7 3.4 1.2 5.2 0 25.5.4 89.6 64.9 150.5 43.6 40 96 60.2 157.5 60.2 121.7 0 223-87.3 223-211.5 6.8-9.7-1.2 3 16.7-25.1l13 14.3 2.5-.5A181.84 181.84 0 0 0 495 255a44.74 44.74 0 0 0-6.8-13.3zM398 111.2l-.5 21.9c5.5 18.1 16.9 17.2 22.4 17.2l-3.4-4.7 22.4-5.4a242.44 242.44 0 0 1-27 0c12.8-2.1 33.3-29 43-11.3 3.4 7.6 6.4 17.2 9.3 27.8l1.7-5.9a56.38 56.38 0 0 1-1.7-15.2c5.4.5 8.8 3.4 9.3 10.1.5 6.4 1.7 14.8 3.4 25.3l4.7-11.3c4.6 0 4.5-3.6-2.5 20.7-20.9-8.7-35.1-8.4-46.5-8.4l18.2-16c-25.3 8.2-33 10.8-54.8 20.9-1.1-5.4-5-13.5-16-19.9-3.2 3.8-2.8.9-.7 14.8h-2.5a62.32 62.32 0 0 0-8.4-23.1l4.2-3.4c8.4-7.1 11.8-14.3 10.6-21.9-.5-6.4-5.4-13.5-13.5-20.7 5.6-3.4 15.2-.4 28.3 8.5zm-39.6-10.1c2.7 1.9 11.4 5.4 18.9 17.2 4.2 8.4 4 9.8 3.4 11.1-.5 2.4-.5 4.3-3 7.1-1.7 2.5-5.4 4.7-11.8 7.6-7.6-13-16.5-23.6-27.8-31.2zM91 143.1l1.2-1.7c1.2-2.9 4.2-7.6 9.3-15.2l2.5-3.4-13 12.3 5.4-4.7-10.1 9.3-4.2 1.2c12.3-24.1 23.1-41.3 32.5-50.2 9.3-9.3 16-16 20.2-19.4l-6.4 1.2c-11.3-4.2-19.4-7.1-24.8-8.4 2.5-.5 3.7-.5 3.2-.5 10.3 0 17.5.5 20.9 1.2a52.35 52.35 0 0 0 16 2.5l.5-1.7-8.4-35.8 13.5 29a42.89 42.89 0 0 0 5.9-14.3c1.7-6.4 5.4-13 10.1-19.4s7.6-10.6 9.3-11.3a234.68 234.68 0 0 0-6.4 25.3l-1.7 7.1-.5 4.7 2.5 2.5C190.4 39.9 214 34 239.8 34.5l21.1.5c-11.8 13.5-27.8 21.9-48.5 24.8a201.26 201.26 0 0 1-23.4 2.9l-.2-.5-2.5-1.2a20.75 20.75 0 0 0-14 2c-2.5-.2-4.9-.5-7.1-.7l-2.5 1.7.5 1.2c2 .2 3.9.5 6.2.7l-2 3.4 3.4-.5-10.6 11.3c-4.2 3-5.4 6.4-4.2 9.3l5.4-3.4h1.2a39.4 39.4 0 0 1 25.3-15.2v-3c6.4.5 13 1 19.4 1.2 6.4 0 8.4.5 5.4 1.2a189.6 189.6 0 0 1 20.7 13.5c13.5 10.1 23.6 21.9 30 35.4 8.8 18.2 13.5 37.1 13.5 56.6a141.13 141.13 0 0 1-3 28.3 209.91 209.91 0 0 1-16 46l2.5.5c18.2-19.7 41.9-16 49.2-16l-6.4 5.9 22.4 17.7-1.7 30.7c-5.4-12.3-16.5-21.1-33-27.8 16.5 14.8 23.6 21.1 21.9 20.2-4.8-2.8-3.5-1.9-10.8-3.7 4.1 4.1 17.5 18.8 18.2 20.7l.2.2-.2.2c0 1.8 1.6-1.2-14 22.9-75.2-15.3-106.27-42.7-141.2-63.2l11.8 1.2c-11.8-18.5-15.6-17.7-38.4-26.1L149 225c-8.8-3-18.2-3-28.3.5l7.6-10.6-1.2-1.7c-14.9 4.3-19.8 9.2-22.6 11.3-1.1-5.5-2.8-12.4-12.3-28.8l-1.2 27-13.2-5c1.5-25.2 5.4-50.5 13.2-74.6zm276.5 330c-49.9 25-56.1 22.4-59 23.9-29.8-11.8-50.9-31.7-63.5-58.8l30 16.5c-9.8-9.3-18.3-16.5-38.4-44.3l11.8 23.1-17.7-7.6c14.2 21.1 23.5 51.7 66.6 73.5-120.8 24.2-199-72.1-200.9-74.3a262.57 262.57 0 0 0 35.4 24.8c3.4 1.7 7.1 2.5 10.1 1.2l-16-20.7c9.2 4.2 9.5 4.5 69.1 29-42.5-20.7-73.8-40.8-93.2-60.2-.5 6.4-1.2 10.1-1.2 10.1a80.25 80.25 0 0 1 20.7 26.6c-39-18.9-57.6-47.6-71.3-82.6 49.9 55.1 118.9 37.5 120.5 37.1 34.8 16.4 69.9 23.6 113.9 10.6 3.3 0 20.3 17 25.3 39.1l4.2-3-2.5-23.6c9 9 24.9 22.6 34.4 13-15.6-5.3-23.5-9.5-29.5-31.7 4.6 4.2 7.6 9 27.8 15l1.2-1.2-10.5-14.2c11.7-4.8-3.5 1 32-10.8 4.3 34.3 9 49.2.7 89.5zm115.3-214.4l-2.5.5 3 9.3c-3.5 5.9-23.7 44.3-71.6 79.7-39.5 29.8-76.6 39.1-80.9 40.3l-7.6-7.1-1.2 3 14.3 16-7.1-4.7 3.4 4.2h-1.2l-21.9-13.5 9.3 26.6-19-27.9-1.2 2.5 7.6 29c-6.1-8.2-21-32.6-56.8-39.6l32.5 21.2a214.82 214.82 0 0 1-93.2-6.4c-4.2-1.2-8.9-2.5-13.5-4.2l1.2-3-44.8-22.4 26.1 22.4c-57.7 9.1-113-25.4-126.4-83.4l-2.5-16.4-22.27 22.3c19.5-57.5 25.6-57.9 51.4-70.1-9.1-5.3-1.6-3.3-38.4-9.3 15.8-5.8 33-15.4 73 5.2a18.5 18.5 0 0 1 3.7-1.7c.6-3.2.4-.8 1-11.8 3.9 10 3.6 8.7 3 9.3l1.7.5c12.7-6.5 8.9-4.5 17-8.9l-5.4 13.5 22.3-5.8-8.4 8.4 2.5 2.5c4.5-1.8 30.3 3.4 40.8 16l-23.6-2.5c39.4 23 51.5 54 55.8 69.6l1.7-1.2c-2.8-22.3-12.4-33.9-16-40.1 4.2 5 39.2 34.6 110.4 46-11.3-.5-23.1 5.4-34.9 18.9l46.7-20.2-9.3 21.9c7.6-10.1 14.8-23.6 21.2-39.6v-.5l1.2-3-1.2 16c13.5-41.8 25.3-78.5 35.4-109.7l13.5-27.8v-2l-5.4-4.2h10.1l5.9 4.2 2.5-1.2-3.4-16 12.3 18.9 41.8-20.2-14.8 13 .5 2.9 17.7-.5a184 184 0 0 1 33 4.2l-23.6 2.5-1.2 3 26.6 23.1a254.21 254.21 0 0 1 27 32c-11.2-3.3-10.3-3.4-21.2-3.4l12.3 32.5zm-6.1-71.3l-3.9 13-14.3-11.8zm-254.8 7.1c1.7 10.6 4.7 17.7 8.8 21.9-9.3 6.6-27.5 13.9-46.5 16l.5 1.2a50.22 50.22 0 0 0 24.8-2.5l-7.1 13c4.2-1.7 10.1-7.1 17.7-14.8 11.9-5.5 12.7-5.1 20.2-16-12.7-6.4-15.7-13.7-18.4-18.8zm3.7-102.3c-6.4-3.4-10.6 3-12.3 18.9s2.5 29.5 11.8 39.6 18.2 10.6 26.1 3 3.4-23.6-11.3-47.7a39.57 39.57 0 0 0-14.27-13.8zm-4.7 46.3c5.4 2.2 10.5 1.9 12.3-10.6v-4.7l-1.2.5c-4.3-3.1-2.5-4.5-1.7-6.2l.5-.5c-.9-1.2-5-8.1-12.5 4.7-.5-13.5.5-21.9 3-24.8 1.2-2.5 4.7-1.2 11.3 4.2 6.4 5.4 11.3 16 15.2 32.5 6.5 28-19.8 26.2-26.9 4.9zm-45-5.5c1.6.3 9.3-1.1 9.3-14.8h-.5c-5.4-1.1-2.2-5.5-.7-5.9-1.7-3-3.4-4.2-5.4-4.7-8.1 0-11.6 12.7-8.1 21.2a7.51 7.51 0 0 0 5.43 4.2zM216 82.9l-2.5.5.5 3a48.94 48.94 0 0 1 26.1 5.9c-2.5-5.5-10-14.3-28.3-14.3l.5 2.5zm-71.8 49.4c21.7 16.8 16.5 21.4 46.5 23.6l-2.9-4.7a42.67 42.67 0 0 0 14.8-28.3c1.7-16-1.2-29.5-8.8-41.3l13-7.6a2.26 2.26 0 0 0-.5-1.7 14.21 14.21 0 0 0-13.5 1.7c-12.7 6.7-28 20.9-29 22.4-1.7 1.7-3.4 5.9-5.4 13.5a99.61 99.61 0 0 0-2.9 23.6c-4.7-8-10.5-6.4-19.9-5.9l7.1 7.6c-16.5 0-23.3 15.4-23.6 16 6.8 0 4.6-7.6 30-12.3-4.3-6.3-3.3-5-4.9-6.6zm18.7-18.7c1.2-7.6 3.4-13 6.4-17.2 5.4-6.4 10.6-10.1 16-11.8 4.2-1.7 7.1 1.2 10.1 9.3a72.14 72.14 0 0 1 3 25.3c-.5 9.3-3.4 17.2-8.4 23.1-2.9 3.4-5.4 5.9-6.4 7.6a39.21 39.21 0 0 1-11.3-.5l-7.1-3.4-5.4-6.4c.8-10 1.3-18.8 3.1-26zm42 56.1c-34.8 14.4-34.7 14-36.1 14.3-20.8 4.7-19-24.4-18.9-24.8l5.9-1.2-.5-2.5c-20.2-2.6-31 4.2-32.5 4.9.5.5 3 3.4 5.9 9.3 4.2-6.4 8.8-10.1 15.2-10.6a83.47 83.47 0 0 0 1.7 33.7c.1.5 2.6 17.4 27.5 24.1 11.3 3 27 1.2 48.9-5.4l-9.2.5c-4.2-14.8-6.4-24.8-5.9-29.5 11.3-8.8 21.9-11.3 30.7-7.6h2.5l-11.8-7.6-7.1.5c-5.9 1.2-12.3 4.2-19.4 8.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaThemeco(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M202.9 8.43c9.9-5.73 26-5.82 35.95-.21L430 115.85c10 5.6 18 19.44 18 30.86V364c0 11.44-8.06 25.29-18 31L238.81 503.74c-9.93 5.66-26 5.57-35.85-.21L17.86 395.12C8 389.34 0 375.38 0 364V146.71c0-11.44 8-25.36 17.91-31.08zm-77.4 199.83c-15.94 0-31.89.14-47.83.14v101.45H96.8V280h28.7c49.71 0 49.56-71.74 0-71.74zm140.14 100.29l-30.73-34.64c37-7.51 34.8-65.23-10.87-65.51-16.09 0-32.17-.14-48.26-.14v101.59h19.13v-33.91h18.41l29.56 33.91h22.76zm-41.59-82.32c23.34 0 23.26 32.46 0 32.46h-29.13v-32.46zm-95.56-1.6c21.18 0 21.11 38.85 0 38.85H96.18v-38.84zm192.65-18.25c-68.46 0-71 105.8 0 105.8 69.48-.01 69.41-105.8 0-105.8zm0 17.39c44.12 0 44.8 70.86 0 70.86s-44.43-70.86 0-70.86z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaThemeisle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208 88.286c0-10 6.286-21.714 17.715-21.714 11.142 0 17.714 11.714 17.714 21.714 0 10.285-6.572 21.714-17.714 21.714C214.286 110 208 98.571 208 88.286zm304 160c0 36.001-11.429 102.286-36.286 129.714-22.858 24.858-87.428 61.143-120.857 70.572l-1.143.286v32.571c0 16.286-12.572 30.571-29.143 30.571-10 0-19.429-5.714-24.572-14.286-5.427 8.572-14.856 14.286-24.856 14.286-10 0-19.429-5.714-24.858-14.286-5.142 8.572-14.571 14.286-24.57 14.286-10.286 0-19.429-5.714-24.858-14.286-5.143 8.572-14.571 14.286-24.571 14.286-18.857 0-29.429-15.714-29.429-32.857-16.286 12.285-35.715 19.428-56.571 19.428-22 0-43.429-8.285-60.286-22.857 10.285-.286 20.571-2.286 30.285-5.714-20.857-5.714-39.428-18.857-52-36.286 21.37 4.645 46.209 1.673 67.143-11.143-22-22-56.571-58.857-68.572-87.428C1.143 321.714 0 303.714 0 289.429c0-49.714 20.286-160 86.286-160 10.571 0 18.857 4.858 23.143 14.857a158.792 158.792 0 0 1 12-15.428c2-2.572 5.714-5.429 7.143-8.286 7.999-12.571 11.714-21.142 21.714-34C182.571 45.428 232 17.143 285.143 17.143c6 0 12 .285 17.714 1.143C313.714 6.571 328.857 0 344.572 0c14.571 0 29.714 6 40 16.286.857.858 1.428 2.286 1.428 3.428 0 3.714-10.285 13.429-12.857 16.286 4.286 1.429 15.714 6.858 15.714 12 0 2.857-2.857 5.143-4.571 7.143 31.429 27.714 49.429 67.143 56.286 108 4.286-5.143 10.285-8.572 17.143-8.572 10.571 0 20.857 7.144 28.571 14.001C507.143 187.143 512 221.714 512 248.286zM188 89.428c0 18.286 12.571 37.143 32.286 37.143 19.714 0 32.285-18.857 32.285-37.143 0-18-12.571-36.857-32.285-36.857-19.715 0-32.286 18.858-32.286 36.857zM237.714 194c0-19.714 3.714-39.143 8.571-58.286-52.039 79.534-13.531 184.571 68.858 184.571 21.428 0 42.571-7.714 60-20 2-7.429 3.714-14.857 3.714-22.572 0-14.286-6.286-21.428-20.572-21.428-4.571 0-9.143.857-13.429 1.714-63.343 12.668-107.142 3.669-107.142-63.999zm-41.142 254.858c0-11.143-8.858-20.857-20.286-20.857-11.429 0-20 9.715-20 20.857v32.571c0 11.143 8.571 21.142 20 21.142 11.428 0 20.286-9.715 20.286-21.142v-32.571zm49.143 0c0-11.143-8.572-20.857-20-20.857-11.429 0-20.286 9.715-20.286 20.857v32.571c0 11.143 8.857 21.142 20.286 21.142 11.428 0 20-10 20-21.142v-32.571zm49.713 0c0-11.143-8.857-20.857-20.285-20.857-11.429 0-20.286 9.715-20.286 20.857v32.571c0 11.143 8.857 21.142 20.286 21.142 11.428 0 20.285-9.715 20.285-21.142v-32.571zm49.715 0c0-11.143-8.857-20.857-20.286-20.857-11.428 0-20.286 9.715-20.286 20.857v32.571c0 11.143 8.858 21.142 20.286 21.142 11.429 0 20.286-10 20.286-21.142v-32.571zM421.714 286c-30.857 59.142-90.285 102.572-158.571 102.572-96.571 0-160.571-84.572-160.571-176.572 0-16.857 2-33.429 6-49.714-20 33.715-29.714 72.572-29.714 111.429 0 60.286 24.857 121.715 71.429 160.857 5.143-9.714 14.857-16.286 26-16.286 10 0 19.428 5.714 24.571 14.286 5.429-8.571 14.571-14.286 24.858-14.286 10 0 19.428 5.714 24.571 14.286 5.429-8.571 14.857-14.286 24.858-14.286 10 0 19.428 5.714 24.857 14.286 5.143-8.571 14.571-14.286 24.572-14.286 10.857 0 20.857 6.572 25.714 16 43.427-36.286 68.569-92 71.426-148.286zm10.572-99.714c0-53.714-34.571-105.714-92.572-105.714-30.285 0-58.571 15.143-78.857 36.857C240.862 183.812 233.41 254 302.286 254c28.805 0 97.357-28.538 84.286 36.857 28.857-26 45.714-65.714 45.714-104.571z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaThinkPeaks(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M465.4 409.4l87.1-150.2-32-.3-55.1 95L259.2 0 23 407.4l32 .3L259.2 55.6zm-355.3-44.1h32.1l117.4-202.5L463 511.9l32.5.1-235.8-404.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTiktok(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448,209.91a210.06,210.06,0,0,1-122.77-39.25V349.38A162.55,162.55,0,1,1,185,188.31V278.2a74.62,74.62,0,1,0,52.23,71.18V0l88,0a121.18,121.18,0,0,0,1.86,22.17h0A122.18,122.18,0,0,0,381,102.39a121.43,121.43,0,0,0,67,20.14Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTradeFederation(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8.8c-137 0-248 111-248 248s111 248 248 248 248-111 248-248-111-248-248-248zm0 482.8c-129.7 0-234.8-105.1-234.8-234.8S118.3 22 248 22s234.8 105.1 234.8 234.8S377.7 491.6 248 491.6zm155.1-328.5v-46.8H209.3V198H54.2l36.7 46h117.7v196.8h48.8V245h83.3v-47h-83.3v-34.8h145.7zm-73.3 45.1v23.9h-82.9v197.4h-26.8V232.1H96.3l-20.1-23.9h143.9v-80.6h171.8V152h-145v56.2zm-161.3-69l-12.4-20.7 2.1 23.8-23.5 5.4 23.3 5.4-2.1 24 12.3-20.5 22.2 9.5-15.7-18.1 15.8-18.1zm-29.6-19.7l9.3-11.5-12.7 5.9-8-12.4 1.7 13.9-14.3 3.8 13.7 2.7-.8 14.7 6.8-12.2 13.8 5.3zm165.4 145.2l-13.1 5.6-7.3-12.2 1.3 14.2-13.9 3.2 13.9 3.2-1.2 14.2 7.3-12.2 13.1 5.5-9.4-10.7zm106.9-77.2l-20.9 9.1-12-19.6 2.2 22.7-22.3 5.4 22.2 4.9-1.8 22.9 11.5-19.6 21.2 8.8-15.1-17zM248 29.9c-125.3 0-226.9 101.6-226.9 226.9S122.7 483.7 248 483.7s226.9-101.6 226.9-226.9S373.3 29.9 248 29.9zM342.6 196v51h-83.3v195.7h-52.7V245.9H89.9l-40-49.9h157.4v-81.6h197.8v50.7H259.4V196zM248 43.2c60.3 0 114.8 25 153.6 65.2H202.5V190H45.1C73.1 104.8 153.4 43.2 248 43.2zm0 427.1c-117.9 0-213.6-95.6-213.6-213.5 0-21.2 3.1-41.8 8.9-61.1L87.1 252h114.7v196.8h64.6V253h83.3v-62.7h-83.2v-19.2h145.6v-50.8c30.8 37 49.3 84.6 49.3 136.5.1 117.9-95.5 213.5-213.4 213.5zM178.8 275l-11-21.4 1.7 24.5-23.7 3.9 23.8 5.9-3.7 23.8 13-20.9 21.5 10.8-15.8-18.8 16.9-17.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTrello(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M392.3 32H56.1C25.1 32 0 57.1 0 88c-.1 0 0-4 0 336 0 30.9 25.1 56 56 56h336.2c30.8-.2 55.7-25.2 55.7-56V88c.1-30.8-24.8-55.8-55.6-56zM197 371.3c-.2 14.7-12.1 26.6-26.9 26.6H87.4c-14.8.1-26.9-11.8-27-26.6V117.1c0-14.8 12-26.9 26.9-26.9h82.9c14.8 0 26.9 12 26.9 26.9v254.2zm193.1-112c0 14.8-12 26.9-26.9 26.9h-81c-14.8 0-26.9-12-26.9-26.9V117.2c0-14.8 12-26.9 26.8-26.9h81.1c14.8 0 26.9 12 26.9 26.9v142.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTripadvisor(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528.91,178.82,576,127.58H471.66a326.11,326.11,0,0,0-367,0H0l47.09,51.24A143.911,143.911,0,0,0,241.86,390.73L288,440.93l46.11-50.17A143.94,143.94,0,0,0,575.88,285.18h-.03A143.56,143.56,0,0,0,528.91,178.82ZM144.06,382.57a97.39,97.39,0,1,1,97.39-97.39A97.39,97.39,0,0,1,144.06,382.57ZM288,282.37c0-64.09-46.62-119.08-108.09-142.59a281,281,0,0,1,216.17,0C334.61,163.3,288,218.29,288,282.37Zm143.88,100.2h-.01a97.405,97.405,0,1,1,.01,0ZM144.06,234.12h-.01a51.06,51.06,0,1,0,51.06,51.06v-.11A51,51,0,0,0,144.06,234.12Zm287.82,0a51.06,51.06,0,1,0,51.06,51.06A51.06,51.06,0,0,0,431.88,234.12Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTumblrSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-82.3 364.2c-8.5 9.1-31.2 19.8-60.9 19.8-75.5 0-91.9-55.5-91.9-87.9v-90h-29.7c-3.4 0-6.2-2.8-6.2-6.2v-42.5c0-4.5 2.8-8.5 7.1-10 38.8-13.7 50.9-47.5 52.7-73.2.5-6.9 4.1-10.2 10-10.2h44.3c3.4 0 6.2 2.8 6.2 6.2v72h51.9c3.4 0 6.2 2.8 6.2 6.2v51.1c0 3.4-2.8 6.2-6.2 6.2h-52.1V321c0 21.4 14.8 33.5 42.5 22.4 3-1.2 5.6-2 8-1.4 2.2.5 3.6 2.1 4.6 4.9l13.8 40.2c1 3.2 2 6.7-.3 9.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTumblr(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M309.8 480.3c-13.6 14.5-50 31.7-97.4 31.7-120.8 0-147-88.8-147-140.6v-144H17.9c-5.5 0-10-4.5-10-10v-68c0-7.2 4.5-13.6 11.3-16 62-21.8 81.5-76 84.3-117.1.8-11 6.5-16.3 16.1-16.3h70.9c5.5 0 10 4.5 10 10v115.2h83c5.5 0 10 4.4 10 9.9v81.7c0 5.5-4.5 10-10 10h-83.4V360c0 34.2 23.7 53.6 68 35.8 4.8-1.9 9-3.2 12.7-2.2 3.5.9 5.8 3.4 7.4 7.9l22 64.3c1.8 5 3.3 10.6-.4 14.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTwitch(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M391.17,103.47H352.54v109.7h38.63ZM285,103H246.37V212.75H285ZM120.83,0,24.31,91.42V420.58H140.14V512l96.53-91.42h77.25L487.69,256V0ZM449.07,237.75l-77.22,73.12H294.61l-67.6,64v-64H140.14V36.58H449.07Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTwitterSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-48.9 158.8c.2 2.8.2 5.7.2 8.5 0 86.7-66 186.6-186.6 186.6-37.2 0-71.7-10.8-100.7-29.4 5.3.6 10.4.8 15.8.8 30.7 0 58.9-10.4 81.4-28-28.8-.6-53-19.5-61.3-45.5 10.1 1.5 19.2 1.5 29.6-1.2-30-6.1-52.5-32.5-52.5-64.4v-.8c8.7 4.9 18.9 7.9 29.6 8.3a65.447 65.447 0 0 1-29.2-54.6c0-12.2 3.2-23.4 8.9-33.1 32.3 39.8 80.8 65.8 135.2 68.6-9.3-44.5 24-80.6 64-80.6 18.9 0 35.9 7.9 47.9 20.7 14.8-2.8 29-8.3 41.6-15.8-4.9 15.2-15.2 28-28.8 36.1 13.2-1.4 26-5.1 37.8-10.2-8.9 13.1-20.1 24.7-32.9 34z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTwitter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTypo3(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M178.7 78.4c0-24.7 5.4-32.4 13.9-39.4-69.5 8.5-149.3 34-176.3 66.4-5.4 7.7-9.3 20.8-9.3 37.1C7 246 113.8 480 191.1 480c36.3 0 97.3-59.5 146.7-139-7 2.3-11.6 2.3-18.5 2.3-57.2 0-140.6-198.5-140.6-264.9zM301.5 32c-30.1 0-41.7 5.4-41.7 36.3 0 66.4 53.8 198.5 101.7 198.5 26.3 0 78.8-99.7 78.8-182.3 0-40.9-67-52.5-138.8-52.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUber(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M414.1 32H33.9C15.2 32 0 47.2 0 65.9V446c0 18.8 15.2 34 33.9 34H414c18.7 0 33.9-15.2 33.9-33.9V65.9C448 47.2 432.8 32 414.1 32zM237.6 391.1C163 398.6 96.4 344.2 88.9 269.6h94.4V290c0 3.7 3 6.8 6.8 6.8H258c3.7 0 6.8-3 6.8-6.8v-67.9c0-3.7-3-6.8-6.8-6.8h-67.9c-3.7 0-6.8 3-6.8 6.8v20.4H88.9c7-69.4 65.4-122.2 135.1-122.2 69.7 0 128.1 52.8 135.1 122.2 7.5 74.5-46.9 141.1-121.5 148.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUbuntu(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm52.7 93c8.8-15.2 28.3-20.5 43.5-11.7 15.3 8.8 20.5 28.3 11.7 43.6-8.8 15.2-28.3 20.5-43.5 11.7-15.3-8.9-20.5-28.4-11.7-43.6zM87.4 287.9c-17.6 0-31.9-14.3-31.9-31.9 0-17.6 14.3-31.9 31.9-31.9 17.6 0 31.9 14.3 31.9 31.9 0 17.6-14.3 31.9-31.9 31.9zm28.1 3.1c22.3-17.9 22.4-51.9 0-69.9 8.6-32.8 29.1-60.7 56.5-79.1l23.7 39.6c-51.5 36.3-51.5 112.5 0 148.8L172 370c-27.4-18.3-47.8-46.3-56.5-79zm228.7 131.7c-15.3 8.8-34.7 3.6-43.5-11.7-8.8-15.3-3.6-34.8 11.7-43.6 15.2-8.8 34.7-3.6 43.5 11.7 8.8 15.3 3.6 34.8-11.7 43.6zm.3-69.5c-26.7-10.3-56.1 6.6-60.5 35-5.2 1.4-48.9 14.3-96.7-9.4l22.5-40.3c57 26.5 123.4-11.7 128.9-74.4l46.1.7c-2.3 34.5-17.3 65.5-40.3 88.4zm-5.9-105.3c-5.4-62-71.3-101.2-128.9-74.4l-22.5-40.3c47.9-23.7 91.5-10.8 96.7-9.4 4.4 28.3 33.8 45.3 60.5 35 23.1 22.9 38 53.9 40.2 88.5l-46 .6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUikit(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M443.9 128v256L218 512 0 384V169.7l87.6 45.1v117l133.5 75.5 135.8-75.5v-151l-101.1-57.6 87.6-53.1L443.9 128zM308.6 49.1L223.8 0l-88.6 54.8 86 47.3 87.4-53z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUmbraco(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 510 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M255.35 8C118.36 7.83 7.14 118.72 7 255.68c-.07 137 111 248.2 248 248.27 136.85 0 247.82-110.7 248-247.67S392.34 8.17 255.35 8zm145 266q-1.14 40.68-14 65t-43.51 35q-30.61 10.7-85.45 10.47h-4.6q-54.78.22-85.44-10.47t-43.52-35q-12.85-24.36-14-65a224.81 224.81 0 0 1 0-30.71 418.37 418.37 0 0 1 3.6-43.88c1.88-13.39 3.57-22.58 5.4-32 1-4.88 1.28-6.42 1.82-8.45a5.09 5.09 0 0 1 4.9-3.89h.69l32 5a5.07 5.07 0 0 1 4.16 5 5 5 0 0 1 0 .77l-1.7 8.78q-2.41 13.25-4.84 33.68a380.62 380.62 0 0 0-2.64 42.15q-.28 40.43 8.13 59.83a43.87 43.87 0 0 0 31.31 25.18A243 243 0 0 0 250 340.6h10.25a242.64 242.64 0 0 0 57.27-5.16 43.86 43.86 0 0 0 31.15-25.23q8.53-19.42 8.13-59.78a388 388 0 0 0-2.6-42.15q-2.48-20.38-4.89-33.68l-1.69-8.78a5 5 0 0 1 0-.77 5 5 0 0 1 4.2-5l32-5h.82a5 5 0 0 1 4.9 3.89c.55 2.05.81 3.57 1.83 8.45 1.82 9.62 3.52 18.78 5.39 32a415.71 415.71 0 0 1 3.61 43.88 228.06 228.06 0 0 1-.04 30.73z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUncharted(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M171.73,232.813A5.381,5.381,0,0,0,176.7,229.5,48.081,48.081,0,0,1,191.6,204.244c1.243-.828,1.657-2.484,1.657-4.141a4.22,4.22,0,0,0-2.071-3.312L74.429,128.473,148.958,85a9.941,9.941,0,0,0,4.968-8.281,9.108,9.108,0,0,0-4.968-8.281L126.6,55.6a9.748,9.748,0,0,0-9.523,0l-100.2,57.966a9.943,9.943,0,0,0-4.969,8.281V236.954a9.109,9.109,0,0,0,4.969,8.281L39.235,258.07a8.829,8.829,0,0,0,4.968,1.242,9.4,9.4,0,0,0,6.625-2.484,10.8,10.8,0,0,0,2.9-7.039V164.5L169.66,232.4A4.5,4.5,0,0,0,171.73,232.813ZM323.272,377.73a12.478,12.478,0,0,0-4.969,1.242l-74.528,43.062V287.882c0-2.9-2.9-5.8-6.211-4.555a53.036,53.036,0,0,1-28.984.414,4.86,4.86,0,0,0-6.21,4.555V421.619l-74.529-43.061a8.83,8.83,0,0,0-4.969-1.242,9.631,9.631,0,0,0-9.523,9.523v26.085a9.107,9.107,0,0,0,4.969,8.281l100.2,57.553A8.829,8.829,0,0,0,223.486,480a11.027,11.027,0,0,0,4.969-1.242l100.2-57.553a9.941,9.941,0,0,0,4.968-8.281V386.839C332.8,382.285,328.24,377.73,323.272,377.73ZM286.007,78a23,23,0,1,0-23-23A23,23,0,0,0,286.007,78Zm63.627-10.086a23,23,0,1,0,23,23A23,23,0,0,0,349.634,67.914ZM412.816,151.6a23,23,0,1,0-23-23A23,23,0,0,0,412.816,151.6Zm-63.182-9.2a23,23,0,1,0,23,23A23,23,0,0,0,349.634,142.4Zm-63.627,83.244a23,23,0,1,0-23-23A23,23,0,0,0,286.007,225.648Zm-62.074,36.358a23,23,0,1,0-23-23A23,23,0,0,0,223.933,262.006Zm188.883-82.358a23,23,0,1,0,23,23A23,23,0,0,0,412.816,179.648Zm0,72.272a23,23,0,1,0,23,23A23,23,0,0,0,412.816,251.92Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUniregistry(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 480c39.5 0 76.2-11.8 106.8-32.2H85.3C115.8 468.2 152.5 480 192 480zm-89.1-193.1v-12.4H0v12.4c0 2.5 0 5 .1 7.4h103.1c-.2-2.4-.3-4.9-.3-7.4zm20.5 57H8.5c2.6 8.5 5.8 16.8 9.6 24.8h138.3c-12.9-5.7-24.1-14.2-33-24.8zm-17.7-34.7H1.3c.9 7.6 2.2 15 3.9 22.3h109.7c-4-6.9-7.2-14.4-9.2-22.3zm-2.8-69.3H0v17.3h102.9zm0-173.2H0v4.9h102.9zm0-34.7H0v2.5h102.9zm0 69.3H0v7.4h102.9zm0 104H0v14.8h102.9zm0-69.3H0v9.9h102.9zm0 34.6H0V183h102.9zm166.2 160.9h109.7c1.8-7.3 3.1-14.7 3.9-22.3H278.3c-2.1 7.9-5.2 15.4-9.2 22.3zm12-185.7H384V136H281.1zm0 37.2H384v-12.4H281.1zm0-74.3H384v-7.4H281.1zm0-76.7v2.5H384V32zm-203 410.9h227.7c11.8-8.7 22.7-18.6 32.2-29.7H44.9c9.6 11 21.4 21 33.2 29.7zm203-371.3H384v-4.9H281.1zm0 148.5H384v-14.8H281.1zM38.8 405.7h305.3c6.7-8.5 12.6-17.6 17.8-27.2H23c5.2 9.6 9.2 18.7 15.8 27.2zm188.8-37.1H367c3.7-8 5.8-16.2 8.5-24.8h-115c-8.8 10.7-20.1 19.2-32.9 24.8zm53.5-81.7c0 2.5-.1 5-.4 7.4h103.1c.1-2.5.2-4.9.2-7.4v-12.4H281.1zm0-29.7H384v-17.3H281.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUnity(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M498.11,206.4,445.31,14.72,248.2,66.08,219,116.14l-59.2-.43L15.54,256,159.82,396.32l59.17-.43,29.24,50,197.08,51.36,52.8-191.62-30-49.63ZM223.77,124.2,374.55,86.51,288,232.33H114.87Zm0,263.63L114.87,279.71H288l86.55,145.81Zm193,14L330.17,256l86.58-145.84L458.56,256Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUnsplash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448,230.17V480H0V230.17H141.13V355.09H306.87V230.17ZM306.87,32H141.13V156.91H306.87Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUntappd(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M401.3 49.9c-79.8 160.1-84.6 152.5-87.9 173.2l-5.2 32.8c-1.9 12-6.6 23.5-13.7 33.4L145.6 497.1c-7.6 10.6-20.4 16.2-33.4 14.6-40.3-5-77.8-32.2-95.3-68.5-5.7-11.8-4.5-25.8 3.1-36.4l148.9-207.9c7.1-9.9 16.4-18 27.2-23.7l29.3-15.5c18.5-9.8 9.7-11.9 135.6-138.9 1-4.8 1-7.3 3.6-8 3-.7 6.6-1 6.3-4.6l-.4-4.6c-.2-1.9 1.3-3.6 3.2-3.6 4.5-.1 13.2 1.2 25.6 10 12.3 8.9 16.4 16.8 17.7 21.1.6 1.8-.6 3.7-2.4 4.2l-4.5 1.1c-3.4.9-2.5 4.4-2.3 7.4.1 2.8-2.3 3.6-6.5 6.1zM230.1 36.4c3.4.9 2.5 4.4 2.3 7.4-.2 2.7 2.1 3.5 6.4 6 7.9 15.9 15.3 30.5 22.2 44 .7 1.3 2.3 1.5 3.3.5 11.2-12 24.6-26.2 40.5-42.6 1.3-1.4 1.4-3.5.1-4.9-8-8.2-16.5-16.9-25.6-26.1-1-4.7-1-7.3-3.6-8-3-.8-6.6-1-6.3-4.6.3-3.3 1.4-8.1-2.8-8.2-4.5-.1-13.2 1.1-25.6 10-12.3 8.9-16.4 16.8-17.7 21.1-1.4 4.2 3.6 4.6 6.8 5.4zM620 406.7L471.2 198.8c-13.2-18.5-26.6-23.4-56.4-39.1-11.2-5.9-14.2-10.9-30.5-28.9-1-1.1-2.9-.9-3.6.5-46.3 88.8-47.1 82.8-49 94.8-1.7 10.7-1.3 20 .3 29.8 1.9 12 6.6 23.5 13.7 33.4l148.9 207.9c7.6 10.6 20.2 16.2 33.1 14.7 40.3-4.9 78-32 95.7-68.6 5.4-11.9 4.3-25.9-3.4-36.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUps(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M103.2 303c-5.2 3.6-32.6 13.1-32.6-19V180H37.9v102.6c0 74.9 80.2 51.1 97.9 39V180h-32.6zM4 74.82v220.9c0 103.7 74.9 135.2 187.7 184.1 112.4-48.9 187.7-80.2 187.7-184.1V74.82c-116.3-61.6-281.8-49.6-375.4 0zm358.1 220.9c0 86.6-53.2 113.6-170.4 165.3-117.5-51.8-170.5-78.7-170.5-165.3v-126.4c102.3-93.8 231.6-100 340.9-89.8zm-209.6-107.4v212.8h32.7v-68.7c24.4 7.3 71.7-2.6 71.7-78.5 0-97.4-80.7-80.92-104.4-65.6zm32.7 117.3v-100.3c8.4-4.2 38.4-12.7 38.4 49.3 0 67.9-36.4 51.8-38.4 51zm79.1-86.4c.1 47.3 51.6 42.5 52.2 70.4.6 23.5-30.4 23-50.8 4.9v30.1c36.2 21.5 81.9 8.1 83.2-33.5 1.7-51.5-54.1-46.6-53.4-73.2.6-20.3 30.6-20.5 48.5-2.2v-28.4c-28.5-22-79.9-9.2-79.7 31.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUsb(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M641.5 256c0 3.1-1.7 6.1-4.5 7.5L547.9 317c-1.4.8-2.8 1.4-4.5 1.4-1.4 0-3.1-.3-4.5-1.1-2.8-1.7-4.5-4.5-4.5-7.8v-35.6H295.7c25.3 39.6 40.5 106.9 69.6 106.9H392V354c0-5 3.9-8.9 8.9-8.9H490c5 0 8.9 3.9 8.9 8.9v89.1c0 5-3.9 8.9-8.9 8.9h-89.1c-5 0-8.9-3.9-8.9-8.9v-26.7h-26.7c-75.4 0-81.1-142.5-124.7-142.5H140.3c-8.1 30.6-35.9 53.5-69 53.5C32 327.3 0 295.3 0 256s32-71.3 71.3-71.3c33.1 0 61 22.8 69 53.5 39.1 0 43.9 9.5 74.6-60.4C255 88.7 273 95.7 323.8 95.7c7.5-20.9 27-35.6 50.4-35.6 29.5 0 53.5 23.9 53.5 53.5s-23.9 53.5-53.5 53.5c-23.4 0-42.9-14.8-50.4-35.6H294c-29.1 0-44.3 67.4-69.6 106.9h310.1v-35.6c0-3.3 1.7-6.1 4.5-7.8 2.8-1.7 6.4-1.4 8.9.3l89.1 53.5c2.8 1.1 4.5 4.1 4.5 7.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUsps(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M460.3 241.7c25.8-41.3 15.2-48.8-11.7-48.8h-27c-.1 0-1.5-1.4-10.9 8-11.2 5.6-37.9 6.3-37.9 8.7 0 4.5 70.3-3.1 88.1 0 9.5 1.5-1.5 20.4-4.4 32-.5 4.5 2.4 2.3 3.8.1zm-112.1 22.6c64-21.3 97.3-23.9 102-26.2 4.4-2.9-4.4-6.6-26.2-5.8-51.7 2.2-137.6 37.1-172.6 53.9l-30.7-93.3h196.6c-2.7-28.2-152.9-22.6-337.9-22.6L27 415.8c196.4-97.3 258.9-130.3 321.2-151.5zM94.7 96c253.3 53.7 330 65.7 332.1 85.2 36.4 0 45.9 0 52.4 6.6 21.1 19.7-14.6 67.7-14.6 67.7-4.4 2.9-406.4 160.2-406.4 160.2h423.1L549 96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUssunnah(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M156.8 285.1l5.7 14.4h-8.2c-1.3-3.2-3.1-7.7-3.8-9.5-2.5-6.3-1.1-8.4 0-10 1.9-2.7 3.2-4.4 3.6-5.2 0 2.2.8 5.7 2.7 10.3zm297.3 18.8c-2.1 13.8-5.7 27.1-10.5 39.7l43 23.4-44.8-18.8c-5.3 13.2-12 25.6-19.9 37.2l34.2 30.2-36.8-26.4c-8.4 11.8-18 22.6-28.7 32.3l24.9 34.7-28.1-31.8c-11 9.6-23.1 18-36.1 25.1l15.7 37.2-19.3-35.3c-13.1 6.8-27 12.1-41.6 15.9l6.7 38.4-10.5-37.4c-14.3 3.4-29.2 5.3-44.5 5.4L256 512l-1.9-38.4c-15.3-.1-30.2-2-44.5-5.3L199 505.6l6.7-38.2c-14.6-3.7-28.6-9.1-41.7-15.8l-19.2 35.1 15.6-37c-13-7-25.2-15.4-36.2-25.1l-27.9 31.6 24.7-34.4c-10.7-9.7-20.4-20.5-28.8-32.3l-36.5 26.2 33.9-29.9c-7.9-11.6-14.6-24.1-20-37.3l-44.4 18.7L67.8 344c-4.8-12.7-8.4-26.1-10.5-39.9l-51 9 50.3-14.2c-1.1-8.5-1.7-17.1-1.7-25.9 0-4.7.2-9.4.5-14.1L0 256l56-2.8c1.3-13.1 3.8-25.8 7.5-38.1L6.4 199l58.9 10.4c4-12 9.1-23.5 15.2-34.4l-55.1-30 58.3 24.6C90 159 97.2 149.2 105.3 140L55.8 96.4l53.9 38.7c8.1-8.6 17-16.5 26.6-23.6l-40-55.6 45.6 51.6c9.5-6.6 19.7-12.3 30.3-17.2l-27.3-64.9 33.8 62.1c10.5-4.4 21.4-7.9 32.7-10.4L199 6.4l19.5 69.2c11-2.1 22.3-3.2 33.8-3.4L256 0l3.6 72.2c11.5.2 22.8 1.4 33.8 3.5L313 6.4l-12.4 70.7c11.3 2.6 22.2 6.1 32.6 10.5l33.9-62.2-27.4 65.1c10.6 4.9 20.7 10.7 30.2 17.2l45.8-51.8-40.1 55.9c9.5 7.1 18.4 15 26.5 23.6l54.2-38.9-49.7 43.9c8 9.1 15.2 18.9 21.5 29.4l58.7-24.7-55.5 30.2c6.1 10.9 11.1 22.3 15.1 34.3l59.3-10.4-57.5 16.2c3.7 12.2 6.2 24.9 7.5 37.9L512 256l-56 2.8c.3 4.6.5 9.3.5 14.1 0 8.7-.6 17.3-1.6 25.8l50.7 14.3-51.5-9.1zm-21.8-31c0-97.5-79-176.5-176.5-176.5s-176.5 79-176.5 176.5 79 176.5 176.5 176.5 176.5-79 176.5-176.5zm-24 0c0 84.3-68.3 152.6-152.6 152.6s-152.6-68.3-152.6-152.6 68.3-152.6 152.6-152.6 152.6 68.3 152.6 152.6zM195 241c0 2.1 1.3 3.8 3.6 5.1 3.3 1.9 6.2 4.6 8.2 8.2 2.8-5.7 4.3-9.5 4.3-11.2 0-2.2-1.1-4.4-3.2-7-2.1-2.5-3.2-5.2-3.3-7.7-6.5 6.8-9.6 10.9-9.6 12.6zm-40.7-19c0 2.1 1.3 3.8 3.6 5.1 3.5 1.9 6.2 4.6 8.2 8.2 2.8-5.7 4.3-9.5 4.3-11.2 0-2.2-1.1-4.4-3.2-7-2.1-2.5-3.2-5.2-3.3-7.7-6.5 6.8-9.6 10.9-9.6 12.6zm-19 0c0 2.1 1.3 3.8 3.6 5.1 3.3 1.9 6.2 4.6 8.2 8.2 2.8-5.7 4.3-9.5 4.3-11.2 0-2.2-1.1-4.4-3.2-7-2.1-2.5-3.2-5.2-3.3-7.7-6.4 6.8-9.6 10.9-9.6 12.6zm204.9 87.9c-8.4-3-8.7-6.8-8.7-15.6V182c-8.2 12.5-14.2 18.6-18 18.6 6.3 14.4 9.5 23.9 9.5 28.3v64.3c0 2.2-2.2 6.5-4.7 6.5h-18c-2.8-7.5-10.2-26.9-15.3-40.3-2 2.5-7.2 9.2-10.7 13.7 2.4 1.6 4.1 3.6 5.2 6.3 2.6 6.7 6.4 16.5 7.9 20.2h-9.2c-3.9-10.4-9.6-25.4-11.8-31.1-2 2.5-7.2 9.2-10.7 13.7 2.4 1.6 4.1 3.6 5.2 6.3.8 2 2.8 7.3 4.3 10.9H256c-1.5-4.1-5.6-14.6-8.4-22-2 2.5-7.2 9.2-10.7 13.7 2.5 1.6 4.3 3.6 5.2 6.3.2.6.5 1.4.6 1.7H225c-4.6-13.9-11.4-27.7-11.4-34.1 0-2.2.3-5.1 1.1-8.2-8.8 10.8-14 15.9-14 25 0 7.5 10.4 28.3 10.4 33.3 0 1.7-.5 3.3-1.4 4.9-9.6-12.7-15.5-20.7-18.8-20.7h-12l-11.2-28c-3.8-9.6-5.7-16-5.7-18.8 0-3.8.5-7.7 1.7-12.2-1 1.3-3.7 4.7-5.5 7.1-.8-2.1-3.1-7.7-4.6-11.5-2.1 2.5-7.5 9.1-11.2 13.6.9 2.3 3.3 8.1 4.9 12.2-2.5 3.3-9.1 11.8-13.6 17.7-4 5.3-5.8 13.3-2.7 21.8 2.5 6.7 2 7.9-1.7 14.1H191c5.5 0 14.3 14 15.5 22 13.2-16 15.4-19.6 16.8-21.6h107c3.9 0 7.2-1.9 9.9-5.8zm20.1-26.6V181.7c-9 12.5-15.9 18.6-20.7 18.6 7.1 14.4 10.7 23.9 10.7 28.3v66.3c0 17.5 8.6 20.4 24 20.4 8.1 0 12.5-.8 13.7-2.7-4.3-1.6-7.6-2.5-9.9-3.3-8.1-3.2-17.8-7.4-17.8-26z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVaadin(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224.5 140.7c1.5-17.6 4.9-52.7 49.8-52.7h98.6c20.7 0 32.1-7.8 32.1-21.6V54.1c0-12.2 9.3-22.1 21.5-22.1S448 41.9 448 54.1v36.5c0 42.9-21.5 62-66.8 62H280.7c-30.1 0-33 14.7-33 27.1 0 1.3-.1 2.5-.2 3.7-.7 12.3-10.9 22.2-23.4 22.2s-22.7-9.8-23.4-22.2c-.1-1.2-.2-2.4-.2-3.7 0-12.3-3-27.1-33-27.1H66.8c-45.3 0-66.8-19.1-66.8-62V54.1C0 41.9 9.4 32 21.6 32s21.5 9.9 21.5 22.1v12.3C43.1 80.2 54.5 88 75.2 88h98.6c44.8 0 48.3 35.1 49.8 52.7h.9zM224 456c11.5 0 21.4-7 25.7-16.3 1.1-1.8 97.1-169.6 98.2-171.4 11.9-19.6-3.2-44.3-27.2-44.3-13.9 0-23.3 6.4-29.8 20.3L224 362l-66.9-117.7c-6.4-13.9-15.9-20.3-29.8-20.3-24 0-39.1 24.6-27.2 44.3 1.1 1.9 97.1 169.6 98.2 171.4 4.3 9.3 14.2 16.3 25.7 16.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaViacoin(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 32h-64l-80.7 192h-94.5L64 32H0l48 112H0v48h68.5l13.8 32H0v48h102.8L192 480l89.2-208H384v-48h-82.3l13.8-32H384v-48h-48l48-112zM192 336l-27-64h54l-27 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaViadeoSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM280.7 381.2c-42.4 46.2-120 46.6-162.4 0-68-73.6-19.8-196.1 81.2-196.1 13.3 0 26.6 2.1 39.1 6.7-4.3 8.4-7.3 17.6-8.4 27.1-9.7-4.1-20.2-6-30.7-6-48.8 0-84.6 41.7-84.6 88.9 0 43 28.5 78.7 69.5 85.9 61.5-24 72.9-117.6 72.9-175 0-7.3 0-14.8-.6-22.1-11.2-32.9-26.6-64.6-44.2-94.5 27.1 18.3 41.9 62.5 44.2 94.1v.4c7.7 22.5 11.8 46.2 11.8 70 0 54.1-21.9 99-68.3 128.2l-2.4.2c50 1 86.2-38.6 86.2-87.2 0-12.2-2.1-24.3-6.9-35.7 9.5-1.9 18.5-5.6 26.4-10.5 15.3 36.6 12.6 87.3-22.8 125.6zM309 233.7c-13.3 0-25.1-7.1-34.4-16.1 21.9-12 49.6-30.7 62.3-53 1.5-3 4.1-8.6 4.5-12-12.5 27.9-44.2 49.8-73.9 56.7-4.7-7.3-7.5-15.5-7.5-24.3 0-10.3 5.2-24.1 12.9-31.6 21.6-20.5 53-8.5 72.4-50 32.5 46.2 13.1 130.3-36.3 130.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaViadeo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M276.2 150.5v.7C258.3 98.6 233.6 47.8 205.4 0c43.3 29.2 67 100 70.8 150.5zm32.7 121.7c7.6 18.2 11 37.5 11 57 0 77.7-57.8 141-137.8 139.4l3.8-.3c74.2-46.7 109.3-118.6 109.3-205.1 0-38.1-6.5-75.9-18.9-112 1 11.7 1 23.7 1 35.4 0 91.8-18.1 241.6-116.6 280C95 455.2 49.4 398 49.4 329.2c0-75.6 57.4-142.3 135.4-142.3 16.8 0 33.7 3.1 49.1 9.6 1.7-15.1 6.5-29.9 13.4-43.3-19.9-7.2-41.2-10.7-62.5-10.7-161.5 0-238.7 195.9-129.9 313.7 67.9 74.6 192 73.9 259.8 0 56.6-61.3 60.9-142.4 36.4-201-12.7 8-27.1 13.9-42.2 17zM418.1 11.7c-31 66.5-81.3 47.2-115.8 80.1-12.4 12-20.6 34-20.6 50.5 0 14.1 4.5 27.1 12 38.8 47.4-11 98.3-46 118.2-90.7-.7 5.5-4.8 14.4-7.2 19.2-20.3 35.7-64.6 65.6-99.7 84.9 14.8 14.4 33.7 25.8 55 25.8 79 0 110.1-134.6 58.1-208.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaViber(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M444 49.9C431.3 38.2 379.9.9 265.3.4c0 0-135.1-8.1-200.9 52.3C27.8 89.3 14.9 143 13.5 209.5c-1.4 66.5-3.1 191.1 117 224.9h.1l-.1 51.6s-.8 20.9 13 25.1c16.6 5.2 26.4-10.7 42.3-27.8 8.7-9.4 20.7-23.2 29.8-33.7 82.2 6.9 145.3-8.9 152.5-11.2 16.6-5.4 110.5-17.4 125.7-142 15.8-128.6-7.6-209.8-49.8-246.5zM457.9 287c-12.9 104-89 110.6-103 115.1-6 1.9-61.5 15.7-131.2 11.2 0 0-52 62.7-68.2 79-5.3 5.3-11.1 4.8-11-5.7 0-6.9.4-85.7.4-85.7-.1 0-.1 0 0 0-101.8-28.2-95.8-134.3-94.7-189.8 1.1-55.5 11.6-101 42.6-131.6 55.7-50.5 170.4-43 170.4-43 96.9.4 143.3 29.6 154.1 39.4 35.7 30.6 53.9 103.8 40.6 211.1zm-139-80.8c.4 8.6-12.5 9.2-12.9.6-1.1-22-11.4-32.7-32.6-33.9-8.6-.5-7.8-13.4.7-12.9 27.9 1.5 43.4 17.5 44.8 46.2zm20.3 11.3c1-42.4-25.5-75.6-75.8-79.3-8.5-.6-7.6-13.5.9-12.9 58 4.2 88.9 44.1 87.8 92.5-.1 8.6-13.1 8.2-12.9-.3zm47 13.4c.1 8.6-12.9 8.7-12.9.1-.6-81.5-54.9-125.9-120.8-126.4-8.5-.1-8.5-12.9 0-12.9 73.7.5 133 51.4 133.7 139.2zM374.9 329v.2c-10.8 19-31 40-51.8 33.3l-.2-.3c-21.1-5.9-70.8-31.5-102.2-56.5-16.2-12.8-31-27.9-42.4-42.4-10.3-12.9-20.7-28.2-30.8-46.6-21.3-38.5-26-55.7-26-55.7-6.7-20.8 14.2-41 33.3-51.8h.2c9.2-4.8 18-3.2 23.9 3.9 0 0 12.4 14.8 17.7 22.1 5 6.8 11.7 17.7 15.2 23.8 6.1 10.9 2.3 22-3.7 26.6l-12 9.6c-6.1 4.9-5.3 14-5.3 14s17.8 67.3 84.3 84.3c0 0 9.1.8 14-5.3l9.6-12c4.6-6 15.7-9.8 26.6-3.7 14.7 8.3 33.4 21.2 45.8 32.9 7 5.7 8.6 14.4 3.8 23.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVimeoSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-16.2 149.6c-1.4 31.1-23.2 73.8-65.3 127.9-43.5 56.5-80.3 84.8-110.4 84.8-18.7 0-34.4-17.2-47.3-51.6-25.2-92.3-35.9-146.4-56.7-146.4-2.4 0-10.8 5-25.1 15.1L64 192c36.9-32.4 72.1-68.4 94.1-70.4 24.9-2.4 40.2 14.6 46 51.1 20.5 129.6 29.6 149.2 66.8 90.5 13.4-21.2 20.6-37.2 21.5-48.3 3.4-32.8-25.6-30.6-45.2-22.2 15.7-51.5 45.8-76.5 90.1-75.1 32.9 1 48.4 22.4 46.5 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVimeoV(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M447.8 153.6c-2 43.6-32.4 103.3-91.4 179.1-60.9 79.2-112.4 118.8-154.6 118.8-26.1 0-48.2-24.1-66.3-72.3C100.3 250 85.3 174.3 56.2 174.3c-3.4 0-15.1 7.1-35.2 21.1L0 168.2c51.6-45.3 100.9-95.7 131.8-98.5 34.9-3.4 56.3 20.5 64.4 71.5 28.7 181.5 41.4 208.9 93.6 126.7 18.7-29.6 28.8-52.1 30.2-67.6 4.8-45.9-35.8-42.8-63.3-31 22-72.1 64.1-107.1 126.2-105.1 45.8 1.2 67.5 31.1 64.9 89.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVimeo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M403.2 32H44.8C20.1 32 0 52.1 0 76.8v358.4C0 459.9 20.1 480 44.8 480h358.4c24.7 0 44.8-20.1 44.8-44.8V76.8c0-24.7-20.1-44.8-44.8-44.8zM377 180.8c-1.4 31.5-23.4 74.7-66 129.4-44 57.2-81.3 85.8-111.7 85.8-18.9 0-34.8-17.4-47.9-52.3-25.5-93.3-36.4-148-57.4-148-2.4 0-10.9 5.1-25.4 15.2l-15.2-19.6c37.3-32.8 72.9-69.2 95.2-71.2 25.2-2.4 40.7 14.8 46.5 51.7 20.7 131.2 29.9 151 67.6 91.6 13.5-21.4 20.8-37.7 21.8-48.9 3.5-33.2-25.9-30.9-45.8-22.4 15.9-52.1 46.3-77.4 91.2-76 33.3.9 49 22.5 47.1 64.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVine(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 254.7v52.1c-18.4 4.2-36.9 6.1-52.1 6.1-36.9 77.4-103 143.8-125.1 156.2-14 7.9-27.1 8.4-42.7-.8C137 452 34.2 367.7 0 102.7h74.5C93.2 261.8 139 343.4 189.3 404.5c27.9-27.9 54.8-65.1 75.6-106.9-49.8-25.3-80.1-80.9-80.1-145.6 0-65.6 37.7-115.1 102.2-115.1 114.9 0 106.2 127.9 81.6 181.5 0 0-46.4 9.2-63.5-20.5 3.4-11.3 8.2-30.8 8.2-48.5 0-31.3-11.3-46.6-28.4-46.6-18.2 0-30.8 17.1-30.8 50 .1 79.2 59.4 118.7 129.9 101.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVk(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M545 117.7c3.7-12.5 0-21.7-17.8-21.7h-58.9c-15 0-21.9 7.9-25.6 16.7 0 0-30 73.1-72.4 120.5-13.7 13.7-20 18.1-27.5 18.1-3.7 0-9.4-4.4-9.4-16.9V117.7c0-15-4.2-21.7-16.6-21.7h-92.6c-9.4 0-15 7-15 13.5 0 14.2 21.2 17.5 23.4 57.5v86.8c0 19-3.4 22.5-10.9 22.5-20 0-68.6-73.4-97.4-157.4-5.8-16.3-11.5-22.9-26.6-22.9H38.8c-16.8 0-20.2 7.9-20.2 16.7 0 15.6 20 93.1 93.1 195.5C160.4 378.1 229 416 291.4 416c37.5 0 42.1-8.4 42.1-22.9 0-66.8-3.4-73.1 15.4-73.1 8.7 0 23.7 4.4 58.7 38.1 40 40 46.6 57.9 69 57.9h58.9c16.8 0 25.3-8.4 20.4-25-11.2-34.9-86.9-106.7-90.3-111.5-8.7-11.2-6.2-16.2 0-26.2.1-.1 72-101.3 79.4-135.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVnv(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M104.9 352c-34.1 0-46.4-30.4-46.4-30.4L2.6 210.1S-7.8 192 13 192h32.8c10.4 0 13.2 8.7 18.8 18.1l36.7 74.5s5.2 13.1 21.1 13.1 21.1-13.1 21.1-13.1l36.7-74.5c5.6-9.5 8.4-18.1 18.8-18.1h32.8c20.8 0 10.4 18.1 10.4 18.1l-55.8 111.5S174.2 352 140 352h-35.1zm395 0c-34.1 0-46.4-30.4-46.4-30.4l-55.9-111.5S387.2 192 408 192h32.8c10.4 0 13.2 8.7 18.8 18.1l36.7 74.5s5.2 13.1 21.1 13.1 21.1-13.1 21.1-13.1l36.8-74.5c5.6-9.5 8.4-18.1 18.8-18.1H627c20.8 0 10.4 18.1 10.4 18.1l-55.9 111.5S569.3 352 535.1 352h-35.2zM337.6 192c34.1 0 46.4 30.4 46.4 30.4l55.9 111.5s10.4 18.1-10.4 18.1h-32.8c-10.4 0-13.2-8.7-18.8-18.1l-36.7-74.5s-5.2-13.1-21.1-13.1c-15.9 0-21.1 13.1-21.1 13.1l-36.7 74.5c-5.6 9.4-8.4 18.1-18.8 18.1h-32.9c-20.8 0-10.4-18.1-10.4-18.1l55.9-111.5s12.2-30.4 46.4-30.4h35.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVuejs(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M356.9 64.3H280l-56 88.6-48-88.6H0L224 448 448 64.3h-91.1zm-301.2 32h53.8L224 294.5 338.4 96.3h53.8L224 384.5 55.7 96.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWatchmanMonitoring(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256,16C123.452,16,16,123.452,16,256S123.452,496,256,496,496,388.548,496,256,388.548,16,256,16ZM121.69,429.122C70.056,388.972,36.741,326.322,36.741,256a218.519,218.519,0,0,1,9.587-64.122l102.9-17.895-.121,10.967-13.943,2.013s-.144,12.5-.144,19.549a12.778,12.778,0,0,0,4.887,10.349l9.468,7.4Zm105.692-283.27,8.48-7.618s6.934-5.38-.143-9.344c-7.188-4.024-39.53-34.5-39.53-34.5-5.348-5.477-8.257-7.347-15.46,0,0,0-32.342,30.474-39.529,34.5-7.078,3.964-.144,9.344-.144,9.344l8.481,7.618-.048,4.369L75.982,131.045c39.644-56.938,105.532-94.3,180.018-94.3A218.754,218.754,0,0,1,420.934,111.77l-193.512,37.7Zm34.063,329.269-33.9-250.857,9.467-7.4a12.778,12.778,0,0,0,4.888-10.349c0-7.044-.144-19.549-.144-19.549l-13.943-2.013-.116-10.474,241.711,31.391A218.872,218.872,0,0,1,475.259,256C475.259,375.074,379.831,472.212,261.445,475.121Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWaze(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M502.17 201.67C516.69 287.53 471.23 369.59 389 409.8c13 34.1-12.4 70.2-48.32 70.2a51.68 51.68 0 0 1-51.57-49c-6.44.19-64.2 0-76.33-.64A51.69 51.69 0 0 1 159 479.92c-33.86-1.36-57.95-34.84-47-67.92-37.21-13.11-72.54-34.87-99.62-70.8-13-17.28-.48-41.8 20.84-41.8 46.31 0 32.22-54.17 43.15-110.26C94.8 95.2 193.12 32 288.09 32c102.48 0 197.15 70.67 214.08 169.67zM373.51 388.28c42-19.18 81.33-56.71 96.29-102.14 40.48-123.09-64.15-228-181.71-228-83.45 0-170.32 55.42-186.07 136-9.53 48.91 5 131.35-68.75 131.35C58.21 358.6 91.6 378.11 127 389.54c24.66-21.8 63.87-15.47 79.83 14.34 14.22 1 79.19 1.18 87.9.82a51.69 51.69 0 0 1 78.78-16.42zM205.12 187.13c0-34.74 50.84-34.75 50.84 0s-50.84 34.74-50.84 0zm116.57 0c0-34.74 50.86-34.75 50.86 0s-50.86 34.75-50.86 0zm-122.61 70.69c-3.44-16.94 22.18-22.18 25.62-5.21l.06.28c4.14 21.42 29.85 44 64.12 43.07 35.68-.94 59.25-22.21 64.11-42.77 4.46-16.05 28.6-10.36 25.47 6-5.23 22.18-31.21 62-91.46 62.9-42.55 0-80.88-27.84-87.9-64.25z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWeebly(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M425.09 65.83c-39.88 0-73.28 25.73-83.66 64.33-18.16-58.06-65.5-64.33-84.95-64.33-19.78 0-66.8 6.28-85.28 64.33-10.38-38.6-43.45-64.33-83.66-64.33C38.59 65.83 0 99.72 0 143.03c0 28.96 4.18 33.27 77.17 233.48 22.37 60.57 67.77 69.35 92.74 69.35 39.23 0 70.04-19.46 85.93-53.98 15.89 34.83 46.69 54.29 85.93 54.29 24.97 0 70.36-9.1 92.74-69.67 76.55-208.65 77.5-205.58 77.5-227.2.63-48.32-36.01-83.47-86.92-83.47zm26.34 114.81l-65.57 176.44c-7.92 21.49-21.22 37.22-46.24 37.22-23.44 0-37.38-12.41-44.03-33.9l-39.28-117.42h-.95L216.08 360.4c-6.96 21.5-20.9 33.6-44.02 33.6-25.02 0-38.33-15.74-46.24-37.22L60.88 181.55c-5.38-14.83-7.92-23.91-7.92-34.5 0-16.34 15.84-29.36 38.33-29.36 18.69 0 31.99 11.8 36.11 29.05l44.03 139.82h.95l44.66-136.79c6.02-19.67 16.47-32.08 38.96-32.08s32.94 12.11 38.96 32.08l44.66 136.79h.95l44.03-139.82c4.12-17.25 17.42-29.05 36.11-29.05 22.17 0 38.33 13.32 38.33 35.71-.32 7.87-4.12 16.04-7.61 27.24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWeibo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M407 177.6c7.6-24-13.4-46.8-37.4-41.7-22 4.8-28.8-28.1-7.1-32.8 50.1-10.9 92.3 37.1 76.5 84.8-6.8 21.2-38.8 10.8-32-10.3zM214.8 446.7C108.5 446.7 0 395.3 0 310.4c0-44.3 28-95.4 76.3-143.7C176 67 279.5 65.8 249.9 161c-4 13.1 12.3 5.7 12.3 6 79.5-33.6 140.5-16.8 114 51.4-3.7 9.4 1.1 10.9 8.3 13.1 135.7 42.3 34.8 215.2-169.7 215.2zm143.7-146.3c-5.4-55.7-78.5-94-163.4-85.7-84.8 8.6-148.8 60.3-143.4 116s78.5 94 163.4 85.7c84.8-8.6 148.8-60.3 143.4-116zM347.9 35.1c-25.9 5.6-16.8 43.7 8.3 38.3 72.3-15.2 134.8 52.8 111.7 124-7.4 24.2 29.1 37 37.4 12 31.9-99.8-55.1-195.9-157.4-174.3zm-78.5 311c-17.1 38.8-66.8 60-109.1 46.3-40.8-13.1-58-53.4-40.3-89.7 17.7-35.4 63.1-55.4 103.4-45.1 42 10.8 63.1 50.2 46 88.5zm-86.3-30c-12.9-5.4-30 .3-38 12.9-8.3 12.9-4.3 28 8.6 34 13.1 6 30.8.3 39.1-12.9 8-13.1 3.7-28.3-9.7-34zm32.6-13.4c-5.1-1.7-11.4.6-14.3 5.4-2.9 5.1-1.4 10.6 3.7 12.9 5.1 2 11.7-.3 14.6-5.4 2.8-5.2 1.1-10.9-4-12.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWeixin(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M385.2 167.6c6.4 0 12.6.3 18.8 1.1C387.4 90.3 303.3 32 207.7 32 100.5 32 13 104.8 13 197.4c0 53.4 29.3 97.5 77.9 131.6l-19.3 58.6 68-34.1c24.4 4.8 43.8 9.7 68.2 9.7 6.2 0 12.1-.3 18.3-.8-4-12.9-6.2-26.6-6.2-40.8-.1-84.9 72.9-154 165.3-154zm-104.5-52.9c14.5 0 24.2 9.7 24.2 24.4 0 14.5-9.7 24.2-24.2 24.2-14.8 0-29.3-9.7-29.3-24.2.1-14.7 14.6-24.4 29.3-24.4zm-136.4 48.6c-14.5 0-29.3-9.7-29.3-24.2 0-14.8 14.8-24.4 29.3-24.4 14.8 0 24.4 9.7 24.4 24.4 0 14.6-9.6 24.2-24.4 24.2zM563 319.4c0-77.9-77.9-141.3-165.4-141.3-92.7 0-165.4 63.4-165.4 141.3S305 460.7 397.6 460.7c19.3 0 38.9-5.1 58.6-9.9l53.4 29.3-14.8-48.6C534 402.1 563 363.2 563 319.4zm-219.1-24.5c-9.7 0-19.3-9.7-19.3-19.6 0-9.7 9.7-19.3 19.3-19.3 14.8 0 24.4 9.7 24.4 19.3 0 10-9.7 19.6-24.4 19.6zm107.1 0c-9.7 0-19.3-9.7-19.3-19.6 0-9.7 9.7-19.3 19.3-19.3 14.5 0 24.4 9.7 24.4 19.3.1 10-9.9 19.6-24.4 19.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWhatsappSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 122.8c-72.7 0-131.8 59.1-131.9 131.8 0 24.9 7 49.2 20.2 70.1l3.1 5-13.3 48.6 49.9-13.1 4.8 2.9c20.2 12 43.4 18.4 67.1 18.4h.1c72.6 0 133.3-59.1 133.3-131.8 0-35.2-15.2-68.3-40.1-93.2-25-25-58-38.7-93.2-38.7zm77.5 188.4c-3.3 9.3-19.1 17.7-26.7 18.8-12.6 1.9-22.4.9-47.5-9.9-39.7-17.2-65.7-57.2-67.7-59.8-2-2.6-16.2-21.5-16.2-41s10.2-29.1 13.9-33.1c3.6-4 7.9-5 10.6-5 2.6 0 5.3 0 7.6.1 2.4.1 5.7-.9 8.9 6.8 3.3 7.9 11.2 27.4 12.2 29.4s1.7 4.3.3 6.9c-7.6 15.2-15.7 14.6-11.6 21.6 15.3 26.3 30.6 35.4 53.9 47.1 4 2 6.3 1.7 8.6-1 2.3-2.6 9.9-11.6 12.5-15.5 2.6-4 5.3-3.3 8.9-2 3.6 1.3 23.1 10.9 27.1 12.9s6.6 3 7.6 4.6c.9 1.9.9 9.9-2.4 19.1zM400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM223.9 413.2c-26.6 0-52.7-6.7-75.8-19.3L64 416l22.5-82.2c-13.9-24-21.2-51.3-21.2-79.3C65.4 167.1 136.5 96 223.9 96c42.4 0 82.2 16.5 112.2 46.5 29.9 30 47.9 69.8 47.9 112.2 0 87.4-72.7 158.5-160.1 158.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWhatsapp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWhmcs(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 161v-21.3l-28.5-8.8-2.2-10.4 20.1-20.7L427 80.4l-29 7.5-7.2-7.5 7.5-28.2-19.1-11.6-21.3 21-10.7-3.2-7-26.4h-22.6l-6.2 26.4-12.1 3.2-19.7-21-19.4 11 8.1 27.7-8.1 8.4-28.5-7.5-11 19.1 20.7 21-2.9 10.4-28.5 7.8-.3 21.7 28.8 7.5 2.4 12.1-20.1 19.9 10.4 18.5 29.6-7.5 7.2 8.6-8.1 26.9 19.9 11.6 19.4-20.4 11.6 2.9 6.7 28.5 22.6.3 6.7-28.8 11.6-3.5 20.7 21.6 20.4-12.1-8.8-28 7.8-8.1 28.8 8.8 10.3-20.1-20.9-18.8 2.2-12.1 29.1-7zm-119.2 45.2c-31.3 0-56.8-25.4-56.8-56.8s25.4-56.8 56.8-56.8 56.8 25.4 56.8 56.8c0 31.5-25.4 56.8-56.8 56.8zm72.3 16.4l46.9 14.5V277l-55.1 13.4-4.1 22.7 38.9 35.3-19.2 37.9-54-16.7-14.6 15.2 16.7 52.5-38.3 22.7-38.9-40.5-21.7 6.6-12.6 54-42.4-.5-12.6-53.6-21.7-5.6-36.4 38.4-37.4-21.7 15.2-50.5-13.7-16.1-55.5 14.1-19.7-34.8 37.9-37.4-4.8-22.8-54-14.1.5-40.9L54 219.9l5.7-19.7-38.9-39.4L41.5 125l53.6 14.1 15.2-15.7-15.2-52 36.4-20.7 36.8 39.4L191 84l11.6-52H245l11.6 45.9L234 72l-6.3-1.7-3.3 5.7-11 19.1-3.3 5.6 4.6 4.6 17.2 17.4-.3 1-23.8 6.5-6.2 1.7-.1 6.4-.2 12.9C153.8 161.6 118 204 118 254.7c0 58.3 47.3 105.7 105.7 105.7 50.5 0 92.7-35.4 103.2-82.8l13.2.2 6.9.1 1.6-6.7 5.6-24 1.9-.6 17.1 17.8 4.7 4.9 5.8-3.4 20.4-12.1 5.8-3.5-2-6.5-6.8-21.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWikipediaW(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M640 51.2l-.3 12.2c-28.1.8-45 15.8-55.8 40.3-25 57.8-103.3 240-155.3 358.6H415l-81.9-193.1c-32.5 63.6-68.3 130-99.2 193.1-.3.3-15 0-15-.3C172 352.3 122.8 243.4 75.8 133.4 64.4 106.7 26.4 63.4.2 63.7c0-3.1-.3-10-.3-14.2h161.9v13.9c-19.2 1.1-52.8 13.3-43.3 34.2 21.9 49.7 103.6 240.3 125.6 288.6 15-29.7 57.8-109.2 75.3-142.8-13.9-28.3-58.6-133.9-72.8-160-9.7-17.8-36.1-19.4-55.8-19.7V49.8l142.5.3v13.1c-19.4.6-38.1 7.8-29.4 26.1 18.9 40 30.6 68.1 48.1 104.7 5.6-10.8 34.7-69.4 48.1-100.8 8.9-20.6-3.9-28.6-38.6-29.4.3-3.6 0-10.3.3-13.6 44.4-.3 111.1-.3 123.1-.6v13.6c-22.5.8-45.8 12.8-58.1 31.7l-59.2 122.8c6.4 16.1 63.3 142.8 69.2 156.7L559.2 91.8c-8.6-23.1-36.4-28.1-47.2-28.3V49.6l127.8 1.1.2.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWindows(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 93.7l183.6-25.3v177.4H0V93.7zm0 324.6l183.6 25.3V268.4H0v149.9zm203.8 28L448 480V268.4H203.8v177.9zm0-380.6v180.1H448V32L203.8 65.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWix(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M393.38 131.69c0 13.03 2.08 32.69-28.68 43.83-9.52 3.45-15.95 9.66-15.95 9.66 0-31 4.72-42.22 17.4-48.86 9.75-5.11 27.23-4.63 27.23-4.63zm-115.8 35.54l-34.24 132.66-28.48-108.57c-7.69-31.99-20.81-48.53-48.43-48.53-27.37 0-40.66 16.18-48.43 48.53L89.52 299.89 55.28 167.23C49.73 140.51 23.86 128.96 0 131.96l65.57 247.93s21.63 1.56 32.46-3.96c14.22-7.25 20.98-12.84 29.59-46.57 7.67-30.07 29.11-118.41 31.12-124.7 4.76-14.94 11.09-13.81 15.4 0 1.97 6.3 23.45 94.63 31.12 124.7 8.6 33.73 15.37 39.32 29.59 46.57 10.82 5.52 32.46 3.96 32.46 3.96l65.57-247.93c-24.42-3.07-49.82 8.93-55.3 35.27zm115.78 5.21s-4.1 6.34-13.46 11.57c-6.01 3.36-11.78 5.64-17.97 8.61-15.14 7.26-13.18 13.95-13.18 35.2v152.07s16.55 2.09 27.37-3.43c13.93-7.1 17.13-13.95 17.26-44.78V181.41l-.02.01v-8.98zm163.44 84.08L640 132.78s-35.11-5.98-52.5 9.85c-13.3 12.1-24.41 29.55-54.18 72.47-.47.73-6.25 10.54-13.07 0-29.29-42.23-40.8-60.29-54.18-72.47-17.39-15.83-52.5-9.85-52.5-9.85l83.2 123.74-82.97 123.36s36.57 4.62 53.95-11.21c11.49-10.46 17.58-20.37 52.51-70.72 6.81-10.52 12.57-.77 13.07 0 29.4 42.38 39.23 58.06 53.14 70.72 17.39 15.83 53.32 11.21 53.32 11.21L556.8 256.52z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWizardsOfTheCoast(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M219.19 345.69c-1.9 1.38-11.07 8.44-.26 23.57 4.64 6.42 14.11 12.79 21.73 6.55 6.5-4.88 7.35-12.92.26-23.04-5.47-7.76-14.28-12.88-21.73-7.08zm336.75 75.94c-.34 1.7-.55 1.67.79 0 2.09-4.19 4.19-10.21 4.98-19.9 3.14-38.49-40.33-71.49-101.34-78.03-54.73-6.02-124.38 9.17-188.8 60.49l-.26 1.57c2.62 4.98 4.98 10.74 3.4 21.21l.79.26c63.89-58.4 131.19-77.25 184.35-73.85 58.4 3.67 100.03 34.04 100.03 68.08-.01 9.96-2.63 15.72-3.94 20.17zM392.28 240.42c.79 7.07 4.19 10.21 9.17 10.47 5.5.26 9.43-2.62 10.47-6.55.79-3.4 2.09-29.85 2.09-29.85s-11.26 6.55-14.93 10.47c-3.66 3.68-7.33 8.39-6.8 15.46zm-50.02-151.1C137.75 89.32 13.1 226.8.79 241.2c-1.05.52-1.31.79.79 1.31 60.49 16.5 155.81 81.18 196.13 202.16l1.05.26c55.25-69.92 140.88-128.05 236.99-128.05 80.92 0 130.15 42.16 130.15 80.39 0 18.33-6.55 33.52-22.26 46.35 0 .96-.2.79.79.79 14.66-10.74 27.5-28.8 27.5-48.18 0-22.78-12.05-38.23-12.05-38.23 7.07 7.07 10.74 16.24 10.74 16.24 5.76-40.85 26.97-62.32 26.97-62.32-2.36-9.69-6.81-17.81-6.81-17.81 7.59 8.12 14.4 27.5 14.4 41.37 0 10.47-3.4 22.78-12.57 31.95l.26.52c8.12-4.98 16.5-16.76 16.5-37.97 0-15.71-4.71-25.92-4.71-25.92 5.76-5.24 11.26-9.17 15.97-11.78.79 3.4 2.09 9.69 2.36 14.93 0 1.05.79 1.83 1.05 0 .79-5.76-.26-16.24-.26-16.5 6.02-3.14 9.69-4.45 9.69-4.45C617.74 176 489.43 89.32 342.26 89.32zm-99.24 289.62c-11.06 8.99-24.2 4.08-30.64-4.19-7.45-9.58-6.76-24.09 4.19-32.47 14.85-11.35 27.08-.49 31.16 5.5.28.39 12.13 16.57-4.71 31.16zm2.09-136.43l9.43-17.81 11.78 70.96-12.57 6.02-24.62-28.8 14.14-26.71 3.67 4.45-1.83-8.11zm18.59 117.58l-.26-.26c2.05-4.1-2.5-6.61-17.54-31.69-1.31-2.36-3.14-2.88-4.45-2.62l-.26-.52c7.86-5.76 15.45-10.21 25.4-15.71l.52.26c1.31 1.83 2.09 2.88 3.4 4.71l-.26.52c-1.05-.26-2.36-.79-5.24.26-2.09.79-7.86 3.67-12.31 7.59v1.31c1.57 2.36 3.93 6.55 5.76 9.69h.26c10.05-6.28 7.56-4.55 11.52-7.86h.26c.52 1.83.52 1.83 1.83 5.5l-.26.26c-3.06.61-4.65.34-11.52 5.5v.26c9.46 17.02 11.01 16.75 12.57 15.97l.26.26c-2.34 1.59-6.27 4.21-9.68 6.57zm55.26-32.47c-3.14 1.57-6.02 2.88-9.95 4.98l-.26-.26c1.29-2.59 1.16-2.71-11.78-32.47l-.26-.26c-.15 0-8.9 3.65-9.95 7.33h-.52l-1.05-5.76.26-.52c7.29-4.56 25.53-11.64 27.76-12.57l.52.26 3.14 4.98-.26.52c-3.53-1.76-7.35.76-12.31 2.62v.26c12.31 32.01 12.67 30.64 14.66 30.64v.25zm44.77-16.5c-4.19 1.05-5.24 1.31-9.69 2.88l-.26-.26.52-4.45c-1.05-3.4-3.14-11.52-3.67-13.62l-.26-.26c-3.4.79-8.9 2.62-12.83 3.93l-.26.26c.79 2.62 3.14 9.95 4.19 13.88.79 2.36 1.83 2.88 2.88 3.14v.52c-3.67 1.05-7.07 2.62-10.21 3.93l-.26-.26c1.05-1.31 1.05-2.88.26-4.98-1.05-3.14-8.12-23.83-9.17-27.23-.52-1.83-1.57-3.14-2.62-3.14v-.52c3.14-1.05 6.02-2.09 10.74-3.4l.26.26-.26 4.71c1.31 3.93 2.36 7.59 3.14 9.69h.26c3.93-1.31 9.43-2.88 12.83-3.93l.26-.26-2.62-9.43c-.52-1.83-1.05-3.4-2.62-3.93v-.26c4.45-1.05 7.33-1.83 10.74-2.36l.26.26c-1.05 1.31-1.05 2.88-.52 4.45 1.57 6.28 4.71 20.43 6.28 26.45.54 2.62 1.85 3.41 2.63 3.93zm32.21-6.81l-.26.26c-4.71.52-14.14 2.36-22.52 4.19l-.26-.26.79-4.19c-1.57-7.86-3.4-18.59-4.98-26.19-.26-1.83-.79-2.88-2.62-3.67l.79-.52c9.17-1.57 20.16-2.36 24.88-2.62l.26.26c.52 2.36.79 3.14 1.57 5.5l-.26.26c-1.14-1.14-3.34-3.2-16.24-.79l-.26.26c.26 1.57 1.05 6.55 1.57 9.95l.26.26c9.52-1.68 4.76-.06 10.74-2.36h.26c0 1.57-.26 1.83-.26 5.24h-.26c-4.81-1.03-2.15-.9-10.21 0l-.26.26c.26 2.09 1.57 9.43 2.09 12.57l.26.26c1.15.38 14.21-.65 16.24-4.71h.26c-.53 2.38-1.05 4.21-1.58 6.04zm10.74-44.51c-4.45 2.36-8.12 2.88-11 2.88-.25.02-11.41 1.09-17.54-9.95-6.74-10.79-.98-25.2 5.5-31.69 8.8-8.12 23.35-10.1 28.54-17.02 8.03-10.33-13.04-22.31-29.59-5.76l-2.62-2.88 5.24-16.24c25.59-1.57 45.2-3.04 50.02 16.24.79 3.14 0 9.43-.26 12.05 0 2.62-1.83 18.85-2.09 23.04-.52 4.19-.79 18.33-.79 20.69.26 2.36.52 4.19 1.57 5.5 1.57 1.83 5.76 1.83 5.76 1.83l-.79 4.71c-11.82-1.07-10.28-.59-20.43-1.05-3.22-5.15-2.23-3.28-4.19-7.86 0 .01-4.19 3.94-7.33 5.51zm37.18 21.21c-6.35-10.58-19.82-7.16-21.73 5.5-2.63 17.08 14.3 19.79 20.69 10.21l.26.26c-.52 1.83-1.83 6.02-1.83 6.28l-.52.52c-10.3 6.87-28.5-2.5-25.66-18.59 1.94-10.87 14.44-18.93 28.8-9.95l.26.52c0 1.06-.27 3.41-.27 5.25zm5.77-87.73v-6.55c.69 0 19.65 3.28 27.76 7.33l-1.57 17.54s10.21-9.43 15.45-10.74c5.24-1.57 14.93 7.33 14.93 7.33l-11.26 11.26c-12.07-6.35-19.59-.08-20.69.79-5.29 38.72-8.6 42.17 4.45 46.09l-.52 4.71c-17.55-4.29-18.53-4.5-36.92-7.33l.79-4.71c7.25 0 7.48-5.32 7.59-6.81 0 0 4.98-53.16 4.98-55.25-.02-2.87-4.99-3.66-4.99-3.66zm10.99 114.44c-8.12-2.09-14.14-11-10.74-20.69 3.14-9.43 12.31-12.31 18.85-10.21 9.17 2.62 12.83 11.78 10.74 19.38-2.61 8.9-9.42 13.87-18.85 11.52zm42.16 9.69c-2.36-.52-7.07-2.36-8.64-2.88v-.26l1.57-1.83c.59-8.24.59-7.27.26-7.59-4.82-1.81-6.66-2.36-7.07-2.36-1.31 1.83-2.88 4.45-3.67 5.5l-.79 3.4v.26c-1.31-.26-3.93-1.31-6.02-1.57v-.26l2.62-1.83c3.4-4.71 9.95-14.14 13.88-20.16v-2.09l.52-.26c2.09.79 5.5 2.09 7.59 2.88.48.48.18-1.87-1.05 25.14-.24 1.81.02 2.6.8 3.91zm-4.71-89.82c11.25-18.27 30.76-16.19 34.04-3.4L539.7 198c2.34-6.25-2.82-9.9-4.45-11.26l1.83-3.67c12.22 10.37 16.38 13.97 22.52 20.43-25.91 73.07-30.76 80.81-24.62 84.32l-1.83 4.45c-6.37-3.35-8.9-4.42-17.81-8.64l2.09-6.81c-.26-.26-3.93 3.93-9.69 3.67-19.06-1.3-22.89-31.75-9.67-52.9zm29.33 79.34c0-5.71-6.34-7.89-7.86-5.24-1.31 2.09 1.05 4.98 2.88 8.38 1.57 2.62 2.62 6.28 1.05 9.43-2.64 6.34-12.4 5.31-15.45-.79 0-.7-.27.09 1.83-4.71l.79-.26c-.57 5.66 6.06 9.61 8.38 4.98 1.05-2.09-.52-5.5-2.09-8.38-1.57-2.62-3.67-6.28-1.83-9.69 2.72-5.06 11.25-4.47 14.66 2.36v.52l-2.36 3.4zm21.21 13.36c-1.96-3.27-.91-2.14-4.45-4.71h-.26c-2.36 4.19-5.76 10.47-8.64 16.24-1.31 2.36-1.05 3.4-.79 3.93l-.26.26-5.76-4.45.26-.26 2.09-1.31c3.14-5.76 6.55-12.05 9.17-17.02v-.26c-2.64-1.98-1.22-1.51-6.02-1.83v-.26l3.14-3.4h.26c3.67 2.36 9.95 6.81 12.31 8.9l.26.26-1.31 3.91zm27.23-44.26l-2.88-2.88c.79-2.36 1.83-4.98 2.09-7.59.75-9.74-11.52-11.84-11.52-4.98 0 4.98 7.86 19.38 7.86 27.76 0 10.21-5.76 15.71-13.88 16.5-8.38.79-20.16-10.47-20.16-10.47l4.98-14.4 2.88 2.09c-2.97 17.8 17.68 20.37 13.35 5.24-1.06-4.02-18.75-34.2 2.09-38.23 13.62-2.36 23.04 16.5 23.04 16.5l-7.85 10.46zm35.62-10.21c-11-30.38-60.49-127.53-191.95-129.62-53.42-1.05-94.27 15.45-132.76 37.97l85.63-9.17-91.39 20.69 25.14 19.64-3.93-16.5c7.5-1.71 39.15-8.45 66.77-8.9l-22.26 80.39c13.61-.7 18.97-8.98 19.64-22.78l4.98-1.05.26 26.71c-22.46 3.21-37.3 6.69-49.49 9.95l13.09-43.21-61.54-36.66 2.36 8.12 10.21 4.98c6.28 18.59 19.38 56.56 20.43 58.66 1.95 4.28 3.16 5.78 12.05 4.45l1.05 4.98c-16.08 4.86-23.66 7.61-39.02 14.4l-2.36-4.71c4.4-2.94 8.73-3.94 5.5-12.83-23.7-62.5-21.48-58.14-22.78-59.44l2.36-4.45 33.52 67.3c-3.84-11.87 1.68 1.69-32.99-78.82l-41.9 88.51 4.71-13.88-35.88-42.16 27.76 93.48-11.78 8.38C95 228.58 101.05 231.87 93.23 231.52c-5.5-.26-13.62 5.5-13.62 5.5L74.63 231c30.56-23.53 31.62-24.33 58.4-42.68l4.19 7.07s-5.76 4.19-7.86 7.07c-5.9 9.28 1.67 13.28 61.8 75.68l-18.85-58.92 39.8-10.21 25.66 30.64 4.45-12.31-4.98-24.62 13.09-3.4.52 3.14 3.67-10.47-94.27 29.33 11.26-4.98-13.62-42.42 17.28-9.17 30.11 36.14 28.54-13.09c-1.41-7.47-2.47-14.5-4.71-19.64l17.28 13.88 4.71-2.09-59.18-42.68 23.08 11.5c18.98-6.07 25.23-7.47 32.21-9.69l2.62 11c-12.55 12.55 1.43 16.82 6.55 19.38l-13.62-61.01 12.05 28.28c4.19-1.31 7.33-2.09 7.33-2.09l2.62 8.64s-3.14 1.05-6.28 2.09l8.9 20.95 33.78-65.73-20.69 61.01c42.42-24.09 81.44-36.66 131.98-35.88 67.04 1.05 167.33 40.85 199.8 139.83.78 2.1-.01 2.63-.79.27zM203.48 152.43s1.83-.52 4.19-1.31l9.43 7.59c-.4 0-3.44-.25-11.26 2.36l-2.36-8.64zm143.76 38.5c-1.57-.6-26.46-4.81-33.26 20.69l21.73 17.02 11.53-37.71zM318.43 67.07c-58.4 0-106.05 12.05-114.96 14.4v.79c8.38 2.09 14.4 4.19 21.21 11.78l1.57.26c6.55-1.83 48.97-13.88 110.24-13.88 180.16 0 301.67 116.79 301.67 223.37v9.95c0 1.31.79 2.62 1.05.52.52-2.09.79-8.64.79-19.64.26-83.79-96.63-227.55-321.57-227.55zm211.06 169.68c1.31-5.76 0-12.31-7.33-13.09-9.62-1.13-16.14 23.79-17.02 33.52-.79 5.5-1.31 14.93 6.02 14.93 4.68-.01 9.72-.91 18.33-35.36zm-61.53 42.95c-2.62-.79-9.43-.79-12.57 10.47-1.83 6.81.52 13.35 6.02 14.66 3.67 1.05 8.9.52 11.78-10.74 2.62-9.94-1.83-13.61-5.23-14.39zM491 300.65c1.83.52 3.14 1.05 5.76 1.83 0-1.83.52-8.38.79-12.05-1.05 1.31-5.5 8.12-6.55 9.95v.27z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWodu(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M178.414 339.706H141.1L112.166 223.475h-.478L83.228 339.706H45.2L0 168.946H37.548L64.574 285.177h.478L94.707 168.946h35.157l29.178 117.667h.479L187.5 168.946h36.831zM271.4 212.713c38.984 0 64.1 25.828 64.1 65.291 0 39.222-25.111 65.05-64.1 65.05-38.743 0-63.855-25.828-63.855-65.05C207.547 238.541 232.659 212.713 271.4 212.713zm0 104.753c23.2 0 30.133-19.852 30.133-39.462 0-19.852-6.934-39.7-30.133-39.7-27.7 0-29.894 19.85-29.894 39.7C241.508 297.614 248.443 317.466 271.4 317.466zM435.084 323.922h-.478c-7.893 13.392-21.765 19.132-37.548 19.132-37.31 0-55.485-32.045-55.485-66.246 0-33.243 18.415-64.095 54.767-64.095 14.589 0 28.938 6.218 36.831 18.416h.24V168.946h33.96v170.76H435.084zM405.428 238.3c-22.24 0-29.894 19.134-29.894 39.463 0 19.371 8.848 39.7 29.894 39.7 22.482 0 29.178-19.613 29.178-39.94C434.606 257.436 427.432 238.3 405.428 238.3zM592.96 339.706H560.673V322.487h-.718c-8.609 13.87-23.436 20.567-37.786 20.567-36.113 0-45.2-20.328-45.2-50.941V216.061h33.959V285.9c0 20.329 5.979 30.372 21.765 30.372 18.415 0 26.306-10.283 26.306-35.393V216.061H592.96zM602.453 302.876H640v36.83H602.453z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWolfPackBattalion(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M267.73 471.53l10.56 15.84 5.28-12.32 5.28 7V512c21.06-7.92 21.11-66.86 25.51-97.21 4.62-31.89-.88-92.81 81.37-149.11-8.88-23.61-12-49.43-2.64-80.05C421 189 447 196.21 456.43 239.73l-30.35 8.36c11.15 23 17 46.76 13.2 72.14L412 313.18l-6.16 33.43-18.47-7-8.8 33.39-19.35-7 26.39 21.11 8.8-28.15L419 364.2l7-35.63 26.39 14.52c.25-20 7-58.06-8.8-84.45l26.39 5.28c4-22.07-2.38-39.21-7.92-56.74l22.43 9.68c-.44-25.07-29.94-56.79-61.58-58.5-20.22-1.09-56.74-25.17-54.1-51.9 2-19.87 17.45-42.62 43.11-49.7-44 36.51-9.68 67.3 5.28 73.46 4.4-11.44 17.54-69.08 0-130.2-40.39 22.87-89.65 65.1-93.2 147.79l-58 38.71-3.52 93.25L369.78 220l7 7-17.59 3.52-44 38.71-15.84-5.28-28.1 49.25-3.52 119.64 21.11 15.84-32.55 15.84-32.55-15.84 21.11-15.84-3.52-119.64-28.15-49.26-15.84 5.28-44-38.71-17.58-3.51 7-7 107.33 59.82-3.52-93.25-58.06-38.71C185 65.1 135.77 22.87 95.3 0c-17.54 61.12-4.4 118.76 0 130.2 15-6.16 49.26-36.95 5.28-73.46 25.66 7.08 41.15 29.83 43.11 49.7 2.63 26.74-33.88 50.81-54.1 51.9-31.65 1.72-61.15 33.44-61.59 58.51l22.43-9.68c-5.54 17.53-11.91 34.67-7.92 56.74l26.39-5.28c-15.76 26.39-9.05 64.43-8.8 84.45l26.39-14.52 7 35.63 24.63-5.28 8.8 28.15L153.35 366 134 373l-8.8-33.43-18.47 7-6.16-33.43-27.27 7c-3.82-25.38 2-49.1 13.2-72.14l-30.35-8.36c9.4-43.52 35.47-50.77 63.34-54.1 9.36 30.62 6.24 56.45-2.64 80.05 82.25 56.3 76.75 117.23 81.37 149.11 4.4 30.35 4.45 89.29 25.51 97.21v-29.83l5.28-7 5.28 12.32 10.56-15.84 11.44 21.11 11.43-21.1zm79.17-95L331.06 366c7.47-4.36 13.76-8.42 19.35-12.32-.6 7.22-.27 13.84-3.51 22.84zm28.15-49.26c-.4 10.94-.9 21.66-1.76 31.67-7.85-1.86-15.57-3.8-21.11-7 8.24-7.94 15.55-16.32 22.87-24.68zm24.63 5.28c0-13.43-2.05-24.21-5.28-33.43a235 235 0 0 1-18.47 27.27zm3.52-80.94c19.44 12.81 27.8 33.66 29.91 56.3-12.32-4.53-24.63-9.31-36.95-10.56 5.06-12 6.65-28.14 7-45.74zm-1.76-45.74c.81 14.3 1.84 28.82 1.76 42.23 19.22-8.11 29.78-9.72 44-14.08-10.61-18.96-27.2-25.53-45.76-28.16zM165.68 376.52L181.52 366c-7.47-4.36-13.76-8.42-19.35-12.32.6 7.26.27 13.88 3.51 22.88zm-28.15-49.26c.4 10.94.9 21.66 1.76 31.67 7.85-1.86 15.57-3.8 21.11-7-8.24-7.93-15.55-16.31-22.87-24.67zm-24.64 5.28c0-13.43 2-24.21 5.28-33.43a235 235 0 0 0 18.47 27.27zm-3.52-80.94c-19.44 12.81-27.8 33.66-29.91 56.3 12.32-4.53 24.63-9.31 37-10.56-5-12-6.65-28.14-7-45.74zm1.76-45.74c-.81 14.3-1.84 28.82-1.76 42.23-19.22-8.11-29.78-9.72-44-14.08 10.63-18.95 27.23-25.52 45.76-28.15z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWordpressSimple(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119.3 8 8 119.2 8 256c0 136.7 111.3 248 248 248s248-111.3 248-248C504 119.2 392.7 8 256 8zM33 256c0-32.3 6.9-63 19.3-90.7l106.4 291.4C84.3 420.5 33 344.2 33 256zm223 223c-21.9 0-43-3.2-63-9.1l66.9-194.4 68.5 187.8c.5 1.1 1 2.1 1.6 3.1-23.1 8.1-48 12.6-74 12.6zm30.7-327.5c13.4-.7 25.5-2.1 25.5-2.1 12-1.4 10.6-19.1-1.4-18.4 0 0-36.1 2.8-59.4 2.8-21.9 0-58.7-2.8-58.7-2.8-12-.7-13.4 17.7-1.4 18.4 0 0 11.4 1.4 23.4 2.1l34.7 95.2L200.6 393l-81.2-241.5c13.4-.7 25.5-2.1 25.5-2.1 12-1.4 10.6-19.1-1.4-18.4 0 0-36.1 2.8-59.4 2.8-4.2 0-9.1-.1-14.4-.3C109.6 73 178.1 33 256 33c58 0 110.9 22.2 150.6 58.5-1-.1-1.9-.2-2.9-.2-21.9 0-37.4 19.1-37.4 39.6 0 18.4 10.6 33.9 21.9 52.3 8.5 14.8 18.4 33.9 18.4 61.5 0 19.1-7.3 41.2-17 72.1l-22.2 74.3-80.7-239.6zm81.4 297.2l68.1-196.9c12.7-31.8 17-57.2 17-79.9 0-8.2-.5-15.8-1.5-22.9 17.4 31.8 27.3 68.2 27.3 107 0 82.3-44.6 154.1-110.9 192.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWordpress(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M61.7 169.4l101.5 278C92.2 413 43.3 340.2 43.3 256c0-30.9 6.6-60.1 18.4-86.6zm337.9 75.9c0-26.3-9.4-44.5-17.5-58.7-10.8-17.5-20.9-32.4-20.9-49.9 0-19.6 14.8-37.8 35.7-37.8.9 0 1.8.1 2.8.2-37.9-34.7-88.3-55.9-143.7-55.9-74.3 0-139.7 38.1-177.8 95.9 5 .2 9.7.3 13.7.3 22.2 0 56.7-2.7 56.7-2.7 11.5-.7 12.8 16.2 1.4 17.5 0 0-11.5 1.3-24.3 2l77.5 230.4L249.8 247l-33.1-90.8c-11.5-.7-22.3-2-22.3-2-11.5-.7-10.1-18.2 1.3-17.5 0 0 35.1 2.7 56 2.7 22.2 0 56.7-2.7 56.7-2.7 11.5-.7 12.8 16.2 1.4 17.5 0 0-11.5 1.3-24.3 2l76.9 228.7 21.2-70.9c9-29.4 16-50.5 16-68.7zm-139.9 29.3l-63.8 185.5c19.1 5.6 39.2 8.7 60.1 8.7 24.8 0 48.5-4.3 70.6-12.1-.6-.9-1.1-1.9-1.5-2.9l-65.4-179.2zm183-120.7c.9 6.8 1.4 14 1.4 21.9 0 21.6-4 45.8-16.2 76.2l-65 187.9C426.2 403 468.7 334.5 468.7 256c0-37-9.4-71.8-26-102.1zM504 256c0 136.8-111.3 248-248 248C119.2 504 8 392.7 8 256 8 119.2 119.2 8 256 8c136.7 0 248 111.2 248 248zm-11.4 0c0-130.5-106.2-236.6-236.6-236.6C125.5 19.4 19.4 125.5 19.4 256S125.6 492.6 256 492.6c130.5 0 236.6-106.1 236.6-236.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWpbeginner(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M462.799 322.374C519.01 386.682 466.961 480 370.944 480c-39.602 0-78.824-17.687-100.142-50.04-6.887.356-22.702.356-29.59 0C219.848 462.381 180.588 480 141.069 480c-95.49 0-148.348-92.996-91.855-157.626C-29.925 190.523 80.479 32 256.006 32c175.632 0 285.87 158.626 206.793 290.374zm-339.647-82.972h41.529v-58.075h-41.529v58.075zm217.18 86.072v-23.839c-60.506 20.915-132.355 9.198-187.589-33.971l.246 24.897c51.101 46.367 131.746 57.875 187.343 32.913zm-150.753-86.072h166.058v-58.075H189.579v58.075z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWpexplorer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 256c0 141.2-114.7 256-256 256C114.8 512 0 397.3 0 256S114.7 0 256 0s256 114.7 256 256zm-32 0c0-123.2-100.3-224-224-224C132.5 32 32 132.5 32 256s100.5 224 224 224 224-100.5 224-224zM160.9 124.6l86.9 37.1-37.1 86.9-86.9-37.1 37.1-86.9zm110 169.1l46.6 94h-14.6l-50-100-48.9 100h-14l51.1-106.9-22.3-9.4 6-14 68.6 29.1-6 14.3-16.5-7.1zm-11.8-116.3l68.6 29.4-29.4 68.3L230 246l29.1-68.6zm80.3 42.9l54.6 23.1-23.4 54.3-54.3-23.1 23.1-54.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWpforms(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 75.2v361.7c0 24.3-19 43.2-43.2 43.2H43.2C19.3 480 0 461.4 0 436.8V75.2C0 51.1 18.8 32 43.2 32h361.7c24 0 43.1 18.8 43.1 43.2zm-37.3 361.6V75.2c0-3-2.6-5.8-5.8-5.8h-9.3L285.3 144 224 94.1 162.8 144 52.5 69.3h-9.3c-3.2 0-5.8 2.8-5.8 5.8v361.7c0 3 2.6 5.8 5.8 5.8h361.7c3.2.1 5.8-2.7 5.8-5.8zM150.2 186v37H76.7v-37h73.5zm0 74.4v37.3H76.7v-37.3h73.5zm11.1-147.3l54-43.7H96.8l64.5 43.7zm210 72.9v37h-196v-37h196zm0 74.4v37.3h-196v-37.3h196zm-84.6-147.3l64.5-43.7H232.8l53.9 43.7zM371.3 335v37.3h-99.4V335h99.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWpressr(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm171.33 158.6c-15.18 34.51-30.37 69.02-45.63 103.5-2.44 5.51-6.89 8.24-12.97 8.24-23.02-.01-46.03.06-69.05-.05-5.12-.03-8.25 1.89-10.34 6.72-10.19 23.56-20.63 47-30.95 70.5-1.54 3.51-4.06 5.29-7.92 5.29-45.94-.01-91.87-.02-137.81 0-3.13 0-5.63-1.15-7.72-3.45-11.21-12.33-22.46-24.63-33.68-36.94-2.69-2.95-2.79-6.18-1.21-9.73 8.66-19.54 17.27-39.1 25.89-58.66 12.93-29.35 25.89-58.69 38.75-88.08 1.7-3.88 4.28-5.68 8.54-5.65 14.24.1 28.48.02 42.72.05 6.24.01 9.2 4.84 6.66 10.59-13.6 30.77-27.17 61.55-40.74 92.33-5.72 12.99-11.42 25.99-17.09 39-3.91 8.95 7.08 11.97 10.95 5.6.23-.37-1.42 4.18 30.01-67.69 1.36-3.1 3.41-4.4 6.77-4.39 15.21.08 30.43.02 45.64.04 5.56.01 7.91 3.64 5.66 8.75-8.33 18.96-16.71 37.9-24.98 56.89-4.98 11.43 8.08 12.49 11.28 5.33.04-.08 27.89-63.33 32.19-73.16 2.02-4.61 5.44-6.51 10.35-6.5 26.43.05 52.86 0 79.29.05 12.44.02 13.93-13.65 3.9-13.64-25.26.03-50.52.02-75.78.02-6.27 0-7.84-2.47-5.27-8.27 5.78-13.06 11.59-26.11 17.3-39.21 1.73-3.96 4.52-5.79 8.84-5.78 23.09.06 25.98.02 130.78.03 6.08-.01 8.03 2.79 5.62 8.27z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaXbox(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M369.9 318.2c44.3 54.3 64.7 98.8 54.4 118.7-7.9 15.1-56.7 44.6-92.6 55.9-29.6 9.3-68.4 13.3-100.4 10.2-38.2-3.7-76.9-17.4-110.1-39C93.3 445.8 87 438.3 87 423.4c0-29.9 32.9-82.3 89.2-142.1 32-33.9 76.5-73.7 81.4-72.6 9.4 2.1 84.3 75.1 112.3 109.5zM188.6 143.8c-29.7-26.9-58.1-53.9-86.4-63.4-15.2-5.1-16.3-4.8-28.7 8.1-29.2 30.4-53.5 79.7-60.3 122.4-5.4 34.2-6.1 43.8-4.2 60.5 5.6 50.5 17.3 85.4 40.5 120.9 9.5 14.6 12.1 17.3 9.3 9.9-4.2-11-.3-37.5 9.5-64 14.3-39 53.9-112.9 120.3-194.4zm311.6 63.5C483.3 127.3 432.7 77 425.6 77c-7.3 0-24.2 6.5-36 13.9-23.3 14.5-41 31.4-64.3 52.8C367.7 197 427.5 283.1 448.2 346c6.8 20.7 9.7 41.1 7.4 52.3-1.7 8.5-1.7 8.5 1.4 4.6 6.1-7.7 19.9-31.3 25.4-43.5 7.4-16.2 15-40.2 18.6-58.7 4.3-22.5 3.9-70.8-.8-93.4zM141.3 43C189 40.5 251 77.5 255.6 78.4c.7.1 10.4-4.2 21.6-9.7 63.9-31.1 94-25.8 107.4-25.2-63.9-39.3-152.7-50-233.9-11.7-23.4 11.1-24 11.9-9.4 11.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaXingSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM140.4 320.2H93.8c-5.5 0-8.7-5.3-6-10.3l49.3-86.7c.1 0 .1-.1 0-.2l-31.4-54c-3-5.6.2-10.1 6-10.1h46.6c5.2 0 9.5 2.9 12.9 8.7l31.9 55.3c-1.3 2.3-18 31.7-50.1 88.2-3.5 6.2-7.7 9.1-12.6 9.1zm219.7-214.1L257.3 286.8v.2l65.5 119c2.8 5.1.1 10.1-6 10.1h-46.6c-5.5 0-9.7-2.9-12.9-8.7l-66-120.3c2.3-4.1 36.8-64.9 103.4-182.3 3.3-5.8 7.4-8.7 12.5-8.7h46.9c5.7-.1 8.8 4.7 6 10z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaXing(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M162.7 210c-1.8 3.3-25.2 44.4-70.1 123.5-4.9 8.3-10.8 12.5-17.7 12.5H9.8c-7.7 0-12.1-7.5-8.5-14.4l69-121.3c.2 0 .2-.1 0-.3l-43.9-75.6c-4.3-7.8.3-14.1 8.5-14.1H100c7.3 0 13.3 4.1 18 12.2l44.7 77.5zM382.6 46.1l-144 253v.3L330.2 466c3.9 7.1.2 14.1-8.5 14.1h-65.2c-7.6 0-13.6-4-18-12.2l-92.4-168.5c3.3-5.8 51.5-90.8 144.8-255.2 4.6-8.1 10.4-12.2 17.5-12.2h65.7c8 0 12.3 6.7 8.5 14.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaYCombinator(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 32v448H0V32h448zM236 287.5L313.5 142h-32.7L235 233c-4.7 9.3-9 18.3-12.8 26.8L210 233l-45.2-91h-35l76.7 143.8v94.5H236v-92.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaYahoo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M223.69,141.06,167,284.23,111,141.06H14.93L120.76,390.19,82.19,480h94.17L317.27,141.06Zm105.4,135.79a58.22,58.22,0,1,0,58.22,58.22A58.22,58.22,0,0,0,329.09,276.85ZM394.65,32l-93,223.47H406.44L499.07,32Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaYammer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M421.78 152.17A23.06 23.06 0 0 0 400.9 112c-.83.43-1.71.9-2.63 1.4-15.25 8.4-118.33 80.62-106.69 88.77s82.04-23.61 130.2-50zm0 217.17c-48.16-26.38-118.64-58.1-130.2-50s91.42 80.35 106.69 88.74c.92.51 1.8 1 2.63 1.41a23.07 23.07 0 0 0 20.88-40.15zM464.21 237c-.95 0-1.95-.06-3-.06-17.4 0-142.52 13.76-136.24 26.51s83.3 18.74 138.21 18.76a23 23 0 0 0 1-45.21zM31 96.65a24.88 24.88 0 0 1 46.14-18.4l81 205.06h1.21l77-203.53a23.52 23.52 0 0 1 44.45 15.27L171.2 368.44C152.65 415.66 134.08 448 77.91 448a139.67 139.67 0 0 1-23.81-1.95 21.31 21.31 0 0 1 6.9-41.77c.66.06 10.91.66 13.86.66 30.47 0 43.74-18.94 58.07-59.41z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaYandexInternational(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M129.5 512V345.9L18.5 48h55.8l81.8 229.7L250.2 0h51.3L180.8 347.8V512h-51.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaYandex(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M153.1 315.8L65.7 512H2l96-209.8c-45.1-22.9-75.2-64.4-75.2-141.1C22.7 53.7 90.8 0 171.7 0H254v512h-55.1V315.8h-45.8zm45.8-269.3h-29.4c-44.4 0-87.4 29.4-87.4 114.6 0 82.3 39.4 108.8 87.4 108.8h29.4V46.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaYarn(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M393.9 345.2c-39 9.3-48.4 32.1-104 47.4 0 0-2.7 4-10.4 5.8-13.4 3.3-63.9 6-68.5 6.1-12.4.1-19.9-3.2-22-8.2-6.4-15.3 9.2-22 9.2-22-8.1-5-9-9.9-9.8-8.1-2.4 5.8-3.6 20.1-10.1 26.5-8.8 8.9-25.5 5.9-35.3.8-10.8-5.7.8-19.2.8-19.2s-5.8 3.4-10.5-3.6c-6-9.3-17.1-37.3 11.5-62-1.3-10.1-4.6-53.7 40.6-85.6 0 0-20.6-22.8-12.9-43.3 5-13.4 7-13.3 8.6-13.9 5.7-2.2 11.3-4.6 15.4-9.1 20.6-22.2 46.8-18 46.8-18s12.4-37.8 23.9-30.4c3.5 2.3 16.3 30.6 16.3 30.6s13.6-7.9 15.1-5c8.2 16 9.2 46.5 5.6 65.1-6.1 30.6-21.4 47.1-27.6 57.5-1.4 2.4 16.5 10 27.8 41.3 10.4 28.6 1.1 52.7 2.8 55.3.8 1.4 13.7.8 36.4-13.2 12.8-7.9 28.1-16.9 45.4-17 16.7-.5 17.6 19.2 4.9 22.2zM496 256c0 136.9-111.1 248-248 248S0 392.9 0 256 111.1 8 248 8s248 111.1 248 248zm-79.3 75.2c-1.7-13.6-13.2-23-28-22.8-22 .3-40.5 11.7-52.8 19.2-4.8 3-8.9 5.2-12.4 6.8 3.1-44.5-22.5-73.1-28.7-79.4 7.8-11.3 18.4-27.8 23.4-53.2 4.3-21.7 3-55.5-6.9-74.5-1.6-3.1-7.4-11.2-21-7.4-9.7-20-13-22.1-15.6-23.8-1.1-.7-23.6-16.4-41.4 28-12.2.9-31.3 5.3-47.5 22.8-2 2.2-5.9 3.8-10.1 5.4h.1c-8.4 3-12.3 9.9-16.9 22.3-6.5 17.4.2 34.6 6.8 45.7-17.8 15.9-37 39.8-35.7 82.5-34 36-11.8 73-5.6 79.6-1.6 11.1 3.7 19.4 12 23.8 12.6 6.7 30.3 9.6 43.9 2.8 4.9 5.2 13.8 10.1 30 10.1 6.8 0 58-2.9 72.6-6.5 6.8-1.6 11.5-4.5 14.6-7.1 9.8-3.1 36.8-12.3 62.2-28.7 18-11.7 24.2-14.2 37.6-17.4 12.9-3.2 21-15.1 19.4-28.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaYelp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M42.9 240.32l99.62 48.61c19.2 9.4 16.2 37.51-4.5 42.71L30.5 358.45a22.79 22.79 0 0 1-28.21-19.6 197.16 197.16 0 0 1 9-85.32 22.8 22.8 0 0 1 31.61-13.21zm44 239.25a199.45 199.45 0 0 0 79.42 32.11A22.78 22.78 0 0 0 192.94 490l3.9-110.82c.7-21.3-25.5-31.91-39.81-16.1l-74.21 82.4a22.82 22.82 0 0 0 4.09 34.09zm145.34-109.92l58.81 94a22.93 22.93 0 0 0 34 5.5 198.36 198.36 0 0 0 52.71-67.61A23 23 0 0 0 364.17 370l-105.42-34.26c-20.31-6.5-37.81 15.8-26.51 33.91zm148.33-132.23a197.44 197.44 0 0 0-50.41-69.31 22.85 22.85 0 0 0-34 4.4l-62 91.92c-11.9 17.7 4.7 40.61 25.2 34.71L366 268.63a23 23 0 0 0 14.61-31.21zM62.11 30.18a22.86 22.86 0 0 0-9.9 32l104.12 180.44c11.7 20.2 42.61 11.9 42.61-11.4V22.88a22.67 22.67 0 0 0-24.5-22.8 320.37 320.37 0 0 0-112.33 30.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaYoast(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M91.3 76h186l-7 18.9h-179c-39.7 0-71.9 31.6-71.9 70.3v205.4c0 35.4 24.9 70.3 84 70.3V460H91.3C41.2 460 0 419.8 0 370.5V165.2C0 115.9 40.7 76 91.3 76zm229.1-56h66.5C243.1 398.1 241.2 418.9 202.2 459.3c-20.8 21.6-49.3 31.7-78.3 32.7v-51.1c49.2-7.7 64.6-49.9 64.6-75.3 0-20.1.6-12.6-82.1-223.2h61.4L218.2 299 320.4 20zM448 161.5V460H234c6.6-9.6 10.7-16.3 12.1-19.4h182.5V161.5c0-32.5-17.1-51.9-48.2-62.9l6.7-17.6c41.7 13.6 60.9 43.1 60.9 80.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaYoutubeSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M186.8 202.1l95.2 54.1-95.2 54.1V202.1zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-42 176.3s0-59.6-7.6-88.2c-4.2-15.8-16.5-28.2-32.2-32.4C337.9 128 224 128 224 128s-113.9 0-142.2 7.7c-15.7 4.2-28 16.6-32.2 32.4-7.6 28.5-7.6 88.2-7.6 88.2s0 59.6 7.6 88.2c4.2 15.8 16.5 27.7 32.2 31.9C110.1 384 224 384 224 384s113.9 0 142.2-7.7c15.7-4.2 28-16.1 32.2-31.9 7.6-28.5 7.6-88.1 7.6-88.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaYoutube(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaZhihu(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M170.54 148.13v217.54l23.43.01 7.71 26.37 42.01-26.37h49.53V148.13H170.54zm97.75 193.93h-27.94l-27.9 17.51-5.08-17.47-11.9-.04V171.75h72.82v170.31zm-118.46-94.39H97.5c1.74-27.1 2.2-51.59 2.2-73.46h51.16s1.97-22.56-8.58-22.31h-88.5c3.49-13.12 7.87-26.66 13.12-40.67 0 0-24.07 0-32.27 21.57-3.39 8.9-13.21 43.14-30.7 78.12 5.89-.64 25.37-1.18 36.84-22.21 2.11-5.89 2.51-6.66 5.14-14.53h28.87c0 10.5-1.2 66.88-1.68 73.44H20.83c-11.74 0-15.56 23.62-15.56 23.62h65.58C66.45 321.1 42.83 363.12 0 396.34c20.49 5.85 40.91-.93 51-9.9 0 0 22.98-20.9 35.59-69.25l53.96 64.94s7.91-26.89-1.24-39.99c-7.58-8.92-28.06-33.06-36.79-41.81L87.9 311.95c4.36-13.98 6.99-27.55 7.87-40.67h61.65s-.09-23.62-7.59-23.62v.01zm412.02-1.6c20.83-25.64 44.98-58.57 44.98-58.57s-18.65-14.8-27.38-4.06c-6 8.15-36.83 48.2-36.83 48.2l19.23 14.43zm-150.09-59.09c-9.01-8.25-25.91 2.13-25.91 2.13s39.52 55.04 41.12 57.45l19.46-13.73s-25.67-37.61-34.66-45.86h-.01zM640 258.35c-19.78 0-130.91.93-131.06.93v-101c4.81 0 12.42-.4 22.85-1.2 40.88-2.41 70.13-4 87.77-4.81 0 0 12.22-27.19-.59-33.44-3.07-1.18-23.17 4.58-23.17 4.58s-165.22 16.49-232.36 18.05c1.6 8.82 7.62 17.08 15.78 19.55 13.31 3.48 22.69 1.7 49.15.89 24.83-1.6 43.68-2.43 56.51-2.43v99.81H351.41s2.82 22.31 25.51 22.85h107.94v70.92c0 13.97-11.19 21.99-24.48 21.12-14.08.11-26.08-1.15-41.69-1.81 1.99 3.97 6.33 14.39 19.31 21.84 9.88 4.81 16.17 6.57 26.02 6.57 29.56 0 45.67-17.28 44.89-45.31v-73.32h122.36c9.68 0 8.7-23.78 8.7-23.78l.03-.01z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAd(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M157.52 272h36.96L176 218.78 157.52 272zM352 256c-13.23 0-24 10.77-24 24s10.77 24 24 24 24-10.77 24-24-10.77-24-24-24zM464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM250.58 352h-16.94c-6.81 0-12.88-4.32-15.12-10.75L211.15 320h-70.29l-7.38 21.25A16 16 0 0 1 118.36 352h-16.94c-11.01 0-18.73-10.85-15.12-21.25L140 176.12A23.995 23.995 0 0 1 162.67 160h26.66A23.99 23.99 0 0 1 212 176.13l53.69 154.62c3.61 10.4-4.11 21.25-15.11 21.25zM424 336c0 8.84-7.16 16-16 16h-16c-4.85 0-9.04-2.27-11.98-5.68-8.62 3.66-18.09 5.68-28.02 5.68-39.7 0-72-32.3-72-72s32.3-72 72-72c8.46 0 16.46 1.73 24 4.42V176c0-8.84 7.16-16 16-16h16c8.84 0 16 7.16 16 16v160z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAddressBook(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M436 160c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48v-48h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20v-64h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20v-64h20zm-228-32c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H118.4C106 384 96 375.4 96 364.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAddressCard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-352 96c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H86.4C74 384 64 375.4 64 364.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2zM512 312c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-64c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-64c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAdjust(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 256c0 136.966 111.033 248 248 248s248-111.034 248-248S392.966 8 256 8 8 119.033 8 256zm248 184V72c101.705 0 184 82.311 184 184 0 101.705-82.311 184-184 184z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAirFreshener(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 160H96C43 160 0 203 0 256V480C0 497.625 14.375 512 32 512H288C305.625 512 320 497.625 320 480V256C320 203 277 160 224 160ZM160 416C115.875 416 80 380.125 80 336S115.875 256 160 256S240 291.875 240 336S204.125 416 160 416ZM224 32C224 14.375 209.625 0 192 0H128C110.375 0 96 14.375 96 32V128H224V32ZM381.781 51.578C383 50.969 384 49.359 384 48C384 46.625 383 45.031 381.781 44.422L352 32L339.562 2.219C338.969 1 337.375 0 336 0S333.031 1 332.406 2.219L320 32L290.219 44.422C289 45.031 288 46.625 288 48C288 49.359 289 50.969 290.219 51.578L320 64L332.406 93.781C333.031 95 334.625 96 336 96S338.969 95 339.562 93.781L352 64L381.781 51.578ZM448 64L460.406 93.781C461.031 95 462.625 96 464 96S466.969 95 467.562 93.781L480 64L509.781 51.578C511 50.969 512 49.359 512 48C512 46.625 511 45.031 509.781 44.422L480 32L467.562 2.219C466.969 1 465.375 0 464 0S461.031 1 460.406 2.219L448 32L418.219 44.422C417 45.031 416 46.625 416 48C416 49.359 417 50.969 418.219 51.578L448 64ZM480 224L467.562 194.219C466.969 193 465.375 192 464 192S461.031 193 460.406 194.219L448 224L418.219 236.422C417 237.031 416 238.625 416 240C416 241.359 417 242.969 418.219 243.578L448 256L460.406 285.781C461.031 287 462.625 288 464 288S466.969 287 467.562 285.781L480 256L509.781 243.578C511 242.969 512 241.359 512 240C512 238.625 511 237.031 509.781 236.422L480 224ZM445.781 147.578C447 146.969 448 145.359 448 144C448 142.625 447 141.031 445.781 140.422L416 128L403.562 98.219C402.969 97 401.375 96 400 96S397.031 97 396.406 98.219L384 128L354.219 140.422C353 141.031 352 142.625 352 144C352 145.359 353 146.969 354.219 147.578L384 160L396.406 189.781C397.031 191 398.625 192 400 192S402.969 191 403.562 189.781L416 160L445.781 147.578Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAlignCenter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 160H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 256H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM108.1 96h231.81A12.09 12.09 0 0 0 352 83.9V44.09A12.09 12.09 0 0 0 339.91 32H108.1A12.09 12.09 0 0 0 96 44.09V83.9A12.1 12.1 0 0 0 108.1 96zm231.81 256A12.09 12.09 0 0 0 352 339.9v-39.81A12.09 12.09 0 0 0 339.91 288H108.1A12.09 12.09 0 0 0 96 300.09v39.81a12.1 12.1 0 0 0 12.1 12.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAlignJustify(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-128H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-128H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-128H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAlignLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.83 352h262.34A12.82 12.82 0 0 0 288 339.17v-38.34A12.82 12.82 0 0 0 275.17 288H12.83A12.82 12.82 0 0 0 0 300.83v38.34A12.82 12.82 0 0 0 12.83 352zm0-256h262.34A12.82 12.82 0 0 0 288 83.17V44.83A12.82 12.82 0 0 0 275.17 32H12.83A12.82 12.82 0 0 0 0 44.83v38.34A12.82 12.82 0 0 0 12.83 96zM432 160H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 256H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAlignRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 224h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm416 192H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm3.17-384H172.83A12.82 12.82 0 0 0 160 44.83v38.34A12.82 12.82 0 0 0 172.83 96h262.34A12.82 12.82 0 0 0 448 83.17V44.83A12.82 12.82 0 0 0 435.17 32zm0 256H172.83A12.82 12.82 0 0 0 160 300.83v38.34A12.82 12.82 0 0 0 172.83 352h262.34A12.82 12.82 0 0 0 448 339.17v-38.34A12.82 12.82 0 0 0 435.17 288z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAllergies(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 112c-17.6 0-32 14.4-32 32v72c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V64c0-17.6-14.4-32-32-32s-32 14.4-32 32v152c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V32c0-17.6-14.4-32-32-32s-32 14.4-32 32v184c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V64c0-17.6-14.4-32-32-32S96 46.4 96 64v241l-23.6-32.5c-13-17.9-38-21.8-55.9-8.8s-21.8 38-8.8 55.9l125.6 172.7c9 12.4 23.5 19.8 38.8 19.8h197.6c22.3 0 41.6-15.3 46.7-37l26.5-112.7c3.2-13.7 4.9-28.3 5.1-42.3V144c0-17.6-14.4-32-32-32zM176 416c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-96c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm64 128c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-96c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm64 32c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm32 64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm32-128c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAmbulance(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h16c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm144-248c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48zm176 248c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAmericanSignLanguageInterpreting(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M290.547 189.039c-20.295-10.149-44.147-11.199-64.739-3.89 42.606 0 71.208 20.475 85.578 50.576 8.576 17.899-5.148 38.071-23.617 38.071 18.429 0 32.211 20.136 23.617 38.071-14.725 30.846-46.123 50.854-80.298 50.854-.557 0-94.471-8.615-94.471-8.615l-66.406 33.347c-9.384 4.693-19.815.379-23.895-7.781L1.86 290.747c-4.167-8.615-1.111-18.897 6.946-23.621l58.072-33.069L108 159.861c6.39-57.245 34.731-109.767 79.743-146.726 11.391-9.448 28.341-7.781 37.51 3.613 9.446 11.394 7.78 28.067-3.612 37.516-12.503 10.559-23.618 22.509-32.509 35.57 21.672-14.729 46.679-24.732 74.186-28.067 14.725-1.945 28.063 8.336 29.73 23.065 1.945 14.728-8.336 28.067-23.062 29.734-16.116 1.945-31.12 7.503-44.178 15.284 26.114-5.713 58.712-3.138 88.079 11.115 13.336 6.669 18.893 22.509 12.224 35.848-6.389 13.06-22.504 18.617-35.564 12.226zm-27.229 69.472c-6.112-12.505-18.338-20.286-32.231-20.286a35.46 35.46 0 0 0-35.565 35.57c0 21.428 17.808 35.57 35.565 35.57 13.893 0 26.119-7.781 32.231-20.286 4.446-9.449 13.614-15.006 23.339-15.284-9.725-.277-18.893-5.835-23.339-15.284zm374.821-37.237c4.168 8.615 1.111 18.897-6.946 23.621l-58.071 33.069L532 352.16c-6.39 57.245-34.731 109.767-79.743 146.726-10.932 9.112-27.799 8.144-37.51-3.613-9.446-11.394-7.78-28.067 3.613-37.516 12.503-10.559 23.617-22.509 32.508-35.57-21.672 14.729-46.679 24.732-74.186 28.067-10.021 2.506-27.552-5.643-29.73-23.065-1.945-14.728 8.336-28.067 23.062-29.734 16.116-1.946 31.12-7.503 44.178-15.284-26.114 5.713-58.712 3.138-88.079-11.115-13.336-6.669-18.893-22.509-12.224-35.848 6.389-13.061 22.505-18.619 35.565-12.227 20.295 10.149 44.147 11.199 64.739 3.89-42.606 0-71.208-20.475-85.578-50.576-8.576-17.899 5.148-38.071 23.617-38.071-18.429 0-32.211-20.136-23.617-38.071 14.033-29.396 44.039-50.887 81.966-50.854l92.803 8.615 66.406-33.347c9.408-4.704 19.828-.354 23.894 7.781l44.455 88.926zm-229.227-18.618c-13.893 0-26.119 7.781-32.231 20.286-4.446 9.449-13.614 15.006-23.339 15.284 9.725.278 18.893 5.836 23.339 15.284 6.112 12.505 18.338 20.286 32.231 20.286a35.46 35.46 0 0 0 35.565-35.57c0-21.429-17.808-35.57-35.565-35.57z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAnchor(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.971 352h32.394C67.172 454.735 181.944 512 288 512c106.229 0 220.853-57.38 242.635-160h32.394c10.691 0 16.045-12.926 8.485-20.485l-67.029-67.029c-4.686-4.686-12.284-4.686-16.971 0l-67.029 67.029c-7.56 7.56-2.206 20.485 8.485 20.485h35.146c-20.29 54.317-84.963 86.588-144.117 94.015V256h52c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-52v-5.47c37.281-13.178 63.995-48.725 64-90.518C384.005 43.772 341.605.738 289.37.01 235.723-.739 192 42.525 192 96c0 41.798 26.716 77.35 64 90.53V192h-52c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h52v190.015c-58.936-7.399-123.82-39.679-144.117-94.015h35.146c10.691 0 16.045-12.926 8.485-20.485l-67.029-67.029c-4.686-4.686-12.284-4.686-16.971 0L4.485 331.515C-3.074 339.074 2.28 352 12.971 352zM288 64c17.645 0 32 14.355 32 32s-14.355 32-32 32-32-14.355-32-32 14.355-32 32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAngleDoubleDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M143 256.3L7 120.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0L313 86.3c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.4 9.5-24.6 9.5-34 .1zm34 192l136-136c9.4-9.4 9.4-24.6 0-33.9l-22.6-22.6c-9.4-9.4-24.6-9.4-33.9 0L160 352.1l-96.4-96.4c-9.4-9.4-24.6-9.4-33.9 0L7 278.3c-9.4 9.4-9.4 24.6 0 33.9l136 136c9.4 9.5 24.6 9.5 34 .1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAngleDoubleLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M223.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L319.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L393.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34zm-192 34l136 136c9.4 9.4 24.6 9.4 33.9 0l22.6-22.6c9.4-9.4 9.4-24.6 0-33.9L127.9 256l96.4-96.4c9.4-9.4 9.4-24.6 0-33.9L201.7 103c-9.4-9.4-24.6-9.4-33.9 0l-136 136c-9.5 9.4-9.5 24.6-.1 34z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAngleDoubleRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34zm192-34l-136-136c-9.4-9.4-24.6-9.4-33.9 0l-22.6 22.6c-9.4 9.4-9.4 24.6 0 33.9l96.4 96.4-96.4 96.4c-9.4 9.4-9.4 24.6 0 33.9l22.6 22.6c9.4 9.4 24.6 9.4 33.9 0l136-136c9.4-9.2 9.4-24.4 0-33.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAngleDoubleUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M177 255.7l136 136c9.4 9.4 9.4 24.6 0 33.9l-22.6 22.6c-9.4 9.4-24.6 9.4-33.9 0L160 351.9l-96.4 96.4c-9.4 9.4-24.6 9.4-33.9 0L7 425.7c-9.4-9.4-9.4-24.6 0-33.9l136-136c9.4-9.5 24.6-9.5 34-.1zm-34-192L7 199.7c-9.4 9.4-9.4 24.6 0 33.9l22.6 22.6c9.4 9.4 24.6 9.4 33.9 0l96.4-96.4 96.4 96.4c9.4 9.4 24.6 9.4 33.9 0l22.6-22.6c9.4-9.4 9.4-24.6 0-33.9l-136-136c-9.2-9.4-24.4-9.4-33.8 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAngleDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M143 352.3L7 216.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.2 9.4-24.4 9.4-33.8 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAngleLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M31.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L127.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L201.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAngleRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAngleUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M177 159.7l136 136c9.4 9.4 9.4 24.6 0 33.9l-22.6 22.6c-9.4 9.4-24.6 9.4-33.9 0L160 255.9l-96.4 96.4c-9.4 9.4-24.6 9.4-33.9 0L7 329.7c-9.4-9.4-9.4-24.6 0-33.9l136-136c9.4-9.5 24.6-9.5 34-.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAngry(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM136 240c0-9.3 4.1-17.5 10.5-23.4l-31-9.3c-8.5-2.5-13.3-11.5-10.7-19.9 2.5-8.5 11.4-13.2 19.9-10.7l80 24c8.5 2.5 13.3 11.5 10.7 19.9-2.1 6.9-8.4 11.4-15.3 11.4-.5 0-1.1-.2-1.7-.2.7 2.7 1.7 5.3 1.7 8.2 0 17.7-14.3 32-32 32S136 257.7 136 240zm168 154.2c-27.8-33.4-84.2-33.4-112.1 0-13.5 16.3-38.2-4.2-24.6-20.5 20-24 49.4-37.8 80.6-37.8s60.6 13.8 80.6 37.8c13.8 16.5-11.1 36.6-24.5 20.5zm76.6-186.9l-31 9.3c6.3 5.8 10.5 14.1 10.5 23.4 0 17.7-14.3 32-32 32s-32-14.3-32-32c0-2.9.9-5.6 1.7-8.2-.6.1-1.1.2-1.7.2-6.9 0-13.2-4.5-15.3-11.4-2.5-8.5 2.3-17.4 10.7-19.9l80-24c8.4-2.5 17.4 2.3 19.9 10.7 2.5 8.5-2.3 17.4-10.8 19.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAnkh(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M296 256h-44.62C272.46 222.01 288 181.65 288 144 288 55.63 230.69 0 160 0S32 55.63 32 144c0 37.65 15.54 78.01 36.62 112H24c-13.25 0-24 10.74-24 24v32c0 13.25 10.75 24 24 24h96v152c0 13.25 10.75 24 24 24h32c13.25 0 24-10.75 24-24V336h96c13.25 0 24-10.75 24-24v-32c0-13.26-10.75-24-24-24zM160 80c29.61 0 48 24.52 48 64 0 34.66-27.14 78.14-48 100.87-20.86-22.72-48-66.21-48-100.87 0-39.48 18.39-64 48-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAppleAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M350.85 129c25.97 4.67 47.27 18.67 63.92 42 14.65 20.67 24.64 46.67 29.96 78 4.67 28.67 4.32 57.33-1 86-7.99 47.33-23.97 87-47.94 119-28.64 38.67-64.59 58-107.87 58-10.66 0-22.3-3.33-34.96-10-8.66-5.33-18.31-8-28.97-8s-20.3 2.67-28.97 8c-12.66 6.67-24.3 10-34.96 10-43.28 0-79.23-19.33-107.87-58-23.97-32-39.95-71.67-47.94-119-5.32-28.67-5.67-57.33-1-86 5.32-31.33 15.31-57.33 29.96-78 16.65-23.33 37.95-37.33 63.92-42 15.98-2.67 37.95-.33 65.92 7 23.97 6.67 44.28 14.67 60.93 24 16.65-9.33 36.96-17.33 60.93-24 27.98-7.33 49.96-9.67 65.94-7zm-54.94-41c-9.32 8.67-21.65 15-36.96 19-10.66 3.33-22.3 5-34.96 5l-14.98-1c-1.33-9.33-1.33-20 0-32 2.67-24 10.32-42.33 22.97-55 9.32-8.67 21.65-15 36.96-19 10.66-3.33 22.3-5 34.96-5l14.98 1 1 15c0 12.67-1.67 24.33-4.99 35-3.99 15.33-10.31 27.67-18.98 37z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArchive(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 448c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V160H32v288zm160-212c0-6.6 5.4-12 12-12h104c6.6 0 12 5.4 12 12v8c0 6.6-5.4 12-12 12H204c-6.6 0-12-5.4-12-12v-8zM480 32H32C14.3 32 0 46.3 0 64v48c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16V64c0-17.7-14.3-32-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArchway(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M560 448h-16V96H32v352H16.02c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16H176c8.84 0 16-7.16 16-16V320c0-53.02 42.98-96 96-96s96 42.98 96 96l.02 160v16c0 8.84 7.16 16 16 16H560c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm0-448H16C7.16 0 0 7.16 0 16v32c0 8.84 7.16 16 16 16h544c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowAltCircleDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zM212 140v116h-70.9c-10.7 0-16.1 13-8.5 20.5l114.9 114.3c4.7 4.7 12.2 4.7 16.9 0l114.9-114.3c7.6-7.6 2.2-20.5-8.5-20.5H300V140c0-6.6-5.4-12-12-12h-64c-6.6 0-12 5.4-12 12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowAltCircleLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zm116-292H256v-70.9c0-10.7-13-16.1-20.5-8.5L121.2 247.5c-4.7 4.7-4.7 12.2 0 16.9l114.3 114.9c7.6 7.6 20.5 2.2 20.5-8.5V300h116c6.6 0 12-5.4 12-12v-64c0-6.6-5.4-12-12-12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowAltCircleRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zM140 300h116v70.9c0 10.7 13 16.1 20.5 8.5l114.3-114.9c4.7-4.7 4.7-12.2 0-16.9l-114.3-115c-7.6-7.6-20.5-2.2-20.5 8.5V212H140c-6.6 0-12 5.4-12 12v64c0 6.6 5.4 12 12 12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowAltCircleUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 256C8 119 119 8 256 8s248 111 248 248-111 248-248 248S8 393 8 256zm292 116V256h70.9c10.7 0 16.1-13 8.5-20.5L264.5 121.2c-4.7-4.7-12.2-4.7-16.9 0l-115 114.3c-7.6 7.6-2.2 20.5 8.5 20.5H212v116c0 6.6 5.4 12 12 12h64c6.6 0 12-5.4 12-12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowCircleDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-143.6-28.9L288 302.6V120c0-13.3-10.7-24-24-24h-16c-13.3 0-24 10.7-24 24v182.6l-72.4-75.5c-9.3-9.7-24.8-9.9-34.3-.4l-10.9 11c-9.4 9.4-9.4 24.6 0 33.9L239 404.3c9.4 9.4 24.6 9.4 33.9 0l132.7-132.7c9.4-9.4 9.4-24.6 0-33.9l-10.9-11c-9.5-9.5-25-9.3-34.3.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowCircleLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zm28.9-143.6L209.4 288H392c13.3 0 24-10.7 24-24v-16c0-13.3-10.7-24-24-24H209.4l75.5-72.4c9.7-9.3 9.9-24.8.4-34.3l-11-10.9c-9.4-9.4-24.6-9.4-33.9 0L107.7 239c-9.4 9.4-9.4 24.6 0 33.9l132.7 132.7c9.4 9.4 24.6 9.4 33.9 0l11-10.9c9.5-9.5 9.3-25-.4-34.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowCircleRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zm-28.9 143.6l75.5 72.4H120c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h182.6l-75.5 72.4c-9.7 9.3-9.9 24.8-.4 34.3l11 10.9c9.4 9.4 24.6 9.4 33.9 0L404.3 273c9.4-9.4 9.4-24.6 0-33.9L271.6 106.3c-9.4-9.4-24.6-9.4-33.9 0l-11 10.9c-9.5 9.6-9.3 25.1.4 34.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowCircleUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 256C8 119 119 8 256 8s248 111 248 248-111 248-248 248S8 393 8 256zm143.6 28.9l72.4-75.5V392c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V209.4l72.4 75.5c9.3 9.7 24.8 9.9 34.3.4l10.9-11c9.4-9.4 9.4-24.6 0-33.9L273 107.7c-9.4-9.4-24.6-9.4-33.9 0L106.3 240.4c-9.4 9.4-9.4 24.6 0 33.9l10.9 11c9.6 9.5 25.1 9.3 34.4-.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M413.1 222.5l22.2 22.2c9.4 9.4 9.4 24.6 0 33.9L241 473c-9.4 9.4-24.6 9.4-33.9 0L12.7 278.6c-9.4-9.4-9.4-24.6 0-33.9l22.2-22.2c9.5-9.5 25-9.3 34.3.4L184 343.4V56c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v287.4l114.8-120.5c9.3-9.8 24.8-10 34.3-.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4 44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M34.9 289.5l-22.2-22.2c-9.4-9.4-9.4-24.6 0-33.9L207 39c9.4-9.4 24.6-9.4 33.9 0l194.3 194.3c9.4 9.4 9.4 24.6 0 33.9L413 289.4c-9.5 9.5-25 9.3-34.3-.4L264 168.6V456c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24V168.6L69.2 289.1c-9.3 9.8-24.8 10-34.3.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowsAltH(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M377.941 169.941V216H134.059v-46.059c0-21.382-25.851-32.09-40.971-16.971L7.029 239.029c-9.373 9.373-9.373 24.568 0 33.941l86.059 86.059c15.119 15.119 40.971 4.411 40.971-16.971V296h243.882v46.059c0 21.382 25.851 32.09 40.971 16.971l86.059-86.059c9.373-9.373 9.373-24.568 0-33.941l-86.059-86.059c-15.119-15.12-40.971-4.412-40.971 16.97z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowsAltV(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M214.059 377.941H168V134.059h46.059c21.382 0 32.09-25.851 16.971-40.971L144.971 7.029c-9.373-9.373-24.568-9.373-33.941 0L24.971 93.088c-15.119 15.119-4.411 40.971 16.971 40.971H88v243.882H41.941c-21.382 0-32.09 25.851-16.971 40.971l86.059 86.059c9.373 9.373 24.568 9.373 33.941 0l86.059-86.059c15.12-15.119 4.412-40.971-16.97-40.971z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaArrowsAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352.201 425.775l-79.196 79.196c-9.373 9.373-24.568 9.373-33.941 0l-79.196-79.196c-15.119-15.119-4.411-40.971 16.971-40.97h51.162L228 284H127.196v51.162c0 21.382-25.851 32.09-40.971 16.971L7.029 272.937c-9.373-9.373-9.373-24.569 0-33.941L86.225 159.8c15.119-15.119 40.971-4.411 40.971 16.971V228H228V127.196h-51.23c-21.382 0-32.09-25.851-16.971-40.971l79.196-79.196c9.373-9.373 24.568-9.373 33.941 0l79.196 79.196c15.119 15.119 4.411 40.971-16.971 40.971h-51.162V228h100.804v-51.162c0-21.382 25.851-32.09 40.97-16.971l79.196 79.196c9.373 9.373 9.373 24.569 0 33.941L425.773 352.2c-15.119 15.119-40.971 4.411-40.97-16.971V284H284v100.804h51.23c21.382 0 32.09 25.851 16.971 40.971z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAssistiveListeningSystems(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M216 260c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-44.112 35.888-80 80-80s80 35.888 80 80c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-13.234-10.767-24-24-24s-24 10.766-24 24zm24-176c-97.047 0-176 78.953-176 176 0 15.464 12.536 28 28 28s28-12.536 28-28c0-66.168 53.832-120 120-120s120 53.832 120 120c0 75.164-71.009 70.311-71.997 143.622L288 404c0 28.673-23.327 52-52 52-15.464 0-28 12.536-28 28s12.536 28 28 28c59.475 0 107.876-48.328 108-107.774.595-34.428 72-48.24 72-144.226 0-97.047-78.953-176-176-176zm-80 236c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zM32 448c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm480-187.993c0-1.518-.012-3.025-.045-4.531C510.076 140.525 436.157 38.47 327.994 1.511c-14.633-4.998-30.549 2.809-35.55 17.442-5 14.633 2.81 30.549 17.442 35.55 85.906 29.354 144.61 110.513 146.077 201.953l.003.188c.026 1.118.033 2.236.033 3.363 0 15.464 12.536 28 28 28s28.001-12.536 28.001-28zM152.971 439.029l-80-80L39.03 392.97l80 80 33.941-33.941z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAsterisk(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M478.21 334.093L336 256l142.21-78.093c11.795-6.477 15.961-21.384 9.232-33.037l-19.48-33.741c-6.728-11.653-21.72-15.499-33.227-8.523L296 186.718l3.475-162.204C299.763 11.061 288.937 0 275.48 0h-38.96c-13.456 0-24.283 11.061-23.994 24.514L216 186.718 77.265 102.607c-11.506-6.976-26.499-3.13-33.227 8.523l-19.48 33.741c-6.728 11.653-2.562 26.56 9.233 33.037L176 256 33.79 334.093c-11.795 6.477-15.961 21.384-9.232 33.037l19.48 33.741c6.728 11.653 21.721 15.499 33.227 8.523L216 325.282l-3.475 162.204C212.237 500.939 223.064 512 236.52 512h38.961c13.456 0 24.283-11.061 23.995-24.514L296 325.282l138.735 84.111c11.506 6.976 26.499 3.13 33.227-8.523l19.48-33.741c6.728-11.653 2.563-26.559-9.232-33.036z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C118.941 8 8 118.919 8 256c0 137.059 110.919 248 248 248 48.154 0 95.342-14.14 135.408-40.223 12.005-7.815 14.625-24.288 5.552-35.372l-10.177-12.433c-7.671-9.371-21.179-11.667-31.373-5.129C325.92 429.757 291.314 440 256 440c-101.458 0-184-82.542-184-184S154.542 72 256 72c100.139 0 184 57.619 184 160 0 38.786-21.093 79.742-58.17 83.693-17.349-.454-16.91-12.857-13.476-30.024l23.433-121.11C394.653 149.75 383.308 136 368.225 136h-44.981a13.518 13.518 0 0 0-13.432 11.993l-.01.092c-14.697-17.901-40.448-21.775-59.971-21.775-74.58 0-137.831 62.234-137.831 151.46 0 65.303 36.785 105.87 96 105.87 26.984 0 57.369-15.637 74.991-38.333 9.522 34.104 40.613 34.103 70.71 34.103C462.609 379.41 504 307.798 504 232 504 95.653 394.023 8 256 8zm-21.68 304.43c-22.249 0-36.07-15.623-36.07-40.771 0-44.993 30.779-72.729 58.63-72.729 22.292 0 35.601 15.241 35.601 40.77 0 45.061-33.875 72.73-58.161 72.73z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAtlas(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M318.38 208h-39.09c-1.49 27.03-6.54 51.35-14.21 70.41 27.71-13.24 48.02-39.19 53.3-70.41zm0-32c-5.29-31.22-25.59-57.17-53.3-70.41 7.68 19.06 12.72 43.38 14.21 70.41h39.09zM224 97.31c-7.69 7.45-20.77 34.42-23.43 78.69h46.87c-2.67-44.26-15.75-71.24-23.44-78.69zm-41.08 8.28c-27.71 13.24-48.02 39.19-53.3 70.41h39.09c1.49-27.03 6.53-51.35 14.21-70.41zm0 172.82c-7.68-19.06-12.72-43.38-14.21-70.41h-39.09c5.28 31.22 25.59 57.17 53.3 70.41zM247.43 208h-46.87c2.66 44.26 15.74 71.24 23.43 78.69 7.7-7.45 20.78-34.43 23.44-78.69zM448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM224 64c70.69 0 128 57.31 128 128s-57.31 128-128 128S96 262.69 96 192 153.31 64 224 64zm160 384H96c-19.2 0-32-12.8-32-32s16-32 32-32h288v64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAtom(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M223.99908,224a32,32,0,1,0,32.00782,32A32.06431,32.06431,0,0,0,223.99908,224Zm214.172-96c-10.877-19.5-40.50979-50.75-116.27544-41.875C300.39168,34.875,267.63386,0,223.99908,0s-76.39066,34.875-97.89653,86.125C50.3369,77.375,20.706,108.5,9.82907,128-6.54984,157.375-5.17484,201.125,34.958,256-5.17484,310.875-6.54984,354.625,9.82907,384c29.13087,52.375,101.64652,43.625,116.27348,41.875C147.60842,477.125,180.36429,512,223.99908,512s76.3926-34.875,97.89652-86.125c14.62891,1.75,87.14456,10.5,116.27544-41.875C454.55,354.625,453.175,310.875,413.04017,256,453.175,201.125,454.55,157.375,438.171,128ZM63.33886,352c-4-7.25-.125-24.75,15.00391-48.25,6.87695,6.5,14.12891,12.875,21.88087,19.125,1.625,13.75,4,27.125,6.75,40.125C82.34472,363.875,67.09081,358.625,63.33886,352Zm36.88478-162.875c-7.752,6.25-15.00392,12.625-21.88087,19.125-15.12891-23.5-19.00392-41-15.00391-48.25,3.377-6.125,16.37891-11.5,37.88478-11.5,1.75,0,3.875.375,5.75.375C104.09864,162.25,101.84864,175.625,100.22364,189.125ZM223.99908,64c9.50195,0,22.25586,13.5,33.88282,37.25-11.252,3.75-22.50391,8-33.88282,12.875-11.377-4.875-22.62892-9.125-33.88283-12.875C201.74516,77.5,214.49712,64,223.99908,64Zm0,384c-9.502,0-22.25392-13.5-33.88283-37.25,11.25391-3.75,22.50587-8,33.88283-12.875C235.378,402.75,246.62994,407,257.8819,410.75,246.25494,434.5,233.501,448,223.99908,448Zm0-112a80,80,0,1,1,80-80A80.00023,80.00023,0,0,1,223.99908,336ZM384.6593,352c-3.625,6.625-19.00392,11.875-43.63479,11,2.752-13,5.127-26.375,6.752-40.125,7.75195-6.25,15.00391-12.625,21.87891-19.125C384.7843,327.25,388.6593,344.75,384.6593,352ZM369.65538,208.25c-6.875-6.5-14.127-12.875-21.87891-19.125-1.625-13.5-3.875-26.875-6.752-40.25,1.875,0,4.002-.375,5.752-.375,21.50391,0,34.50782,5.375,37.88283,11.5C388.6593,167.25,384.7843,184.75,369.65538,208.25Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAudioDescription(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M162.925 238.709l8.822 30.655h-25.606l9.041-30.652c1.277-4.421 2.651-9.994 3.872-15.245 1.22 5.251 2.594 10.823 3.871 15.242zm166.474-32.099h-14.523v98.781h14.523c29.776 0 46.175-17.678 46.175-49.776 0-32.239-17.49-49.005-46.175-49.005zM512 112v288c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48zM245.459 336.139l-57.097-168A12.001 12.001 0 0 0 177 160h-35.894a12.001 12.001 0 0 0-11.362 8.139l-57.097 168C70.003 343.922 75.789 352 84.009 352h29.133a12 12 0 0 0 11.535-8.693l8.574-29.906h51.367l8.793 29.977A12 12 0 0 0 204.926 352h29.172c8.22 0 14.006-8.078 11.361-15.861zm184.701-80.525c0-58.977-37.919-95.614-98.96-95.614h-57.366c-6.627 0-12 5.373-12 12v168c0 6.627 5.373 12 12 12H331.2c61.041 0 98.96-36.933 98.96-96.386z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaAward(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M97.12 362.63c-8.69-8.69-4.16-6.24-25.12-11.85-9.51-2.55-17.87-7.45-25.43-13.32L1.2 448.7c-4.39 10.77 3.81 22.47 15.43 22.03l52.69-2.01L105.56 507c8 8.44 22.04 5.81 26.43-4.96l52.05-127.62c-10.84 6.04-22.87 9.58-35.31 9.58-19.5 0-37.82-7.59-51.61-21.37zM382.8 448.7l-45.37-111.24c-7.56 5.88-15.92 10.77-25.43 13.32-21.07 5.64-16.45 3.18-25.12 11.85-13.79 13.78-32.12 21.37-51.62 21.37-12.44 0-24.47-3.55-35.31-9.58L252 502.04c4.39 10.77 18.44 13.4 26.43 4.96l36.25-38.28 52.69 2.01c11.62.44 19.82-11.27 15.43-22.03zM263 340c15.28-15.55 17.03-14.21 38.79-20.14 13.89-3.79 24.75-14.84 28.47-28.98 7.48-28.4 5.54-24.97 25.95-45.75 10.17-10.35 14.14-25.44 10.42-39.58-7.47-28.38-7.48-24.42 0-52.83 3.72-14.14-.25-29.23-10.42-39.58-20.41-20.78-18.47-17.36-25.95-45.75-3.72-14.14-14.58-25.19-28.47-28.98-27.88-7.61-24.52-5.62-44.95-26.41-10.17-10.35-25-14.4-38.89-10.61-27.87 7.6-23.98 7.61-51.9 0-13.89-3.79-28.72.25-38.89 10.61-20.41 20.78-17.05 18.8-44.94 26.41-13.89 3.79-24.75 14.84-28.47 28.98-7.47 28.39-5.54 24.97-25.95 45.75-10.17 10.35-14.15 25.44-10.42 39.58 7.47 28.36 7.48 24.4 0 52.82-3.72 14.14.25 29.23 10.42 39.59 20.41 20.78 18.47 17.35 25.95 45.75 3.72 14.14 14.58 25.19 28.47 28.98C104.6 325.96 106.27 325 121 340c13.23 13.47 33.84 15.88 49.74 5.82a39.676 39.676 0 0 1 42.53 0c15.89 10.06 36.5 7.65 49.73-5.82zM97.66 175.96c0-53.03 42.24-96.02 94.34-96.02s94.34 42.99 94.34 96.02-42.24 96.02-94.34 96.02-94.34-42.99-94.34-96.02z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBabyCarriage(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144.8 17c-11.3-17.8-37.2-22.8-54-9.4C35.3 51.9 0 118 0 192h256L144.8 17zM496 96h-48c-35.3 0-64 28.7-64 64v64H0c0 50.6 23 96.4 60.3 130.7C25.7 363.6 0 394.7 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-8.9-1.8-17.2-4.4-25.2 21.6 5.9 44.6 9.2 68.4 9.2s46.9-3.3 68.4-9.2c-2.7 8-4.4 16.3-4.4 25.2 0 44.2 35.8 80 80 80s80-35.8 80-80c0-37.3-25.7-68.4-60.3-77.3C425 320.4 448 274.6 448 224v-64h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM80 464c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm320-32c0 17.6-14.4 32-32 32s-32-14.4-32-32 14.4-32 32-32 32 14.4 32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBaby(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 160c44.2 0 80-35.8 80-80S236.2 0 192 0s-80 35.8-80 80 35.8 80 80 80zm-53.4 248.8l25.6-32-61.5-51.2L56.8 383c-11.4 14.2-11.7 34.4-.8 49l48 64c7.9 10.5 19.9 16 32 16 8.3 0 16.8-2.6 24-8 17.7-13.2 21.2-38.3 8-56l-29.4-39.2zm142.7-83.2l-61.5 51.2 25.6 32L216 448c-13.2 17.7-9.7 42.8 8 56 7.2 5.4 15.6 8 24 8 12.2 0 24.2-5.5 32-16l48-64c10.9-14.6 10.6-34.8-.8-49l-45.9-57.4zM376.7 145c-12.7-18.1-37.6-22.4-55.7-9.8l-40.6 28.5c-52.7 37-124.2 37-176.8 0L63 135.3C44.9 122.6 20 127 7.3 145-5.4 163.1-1 188 17 200.7l40.6 28.5c17 11.9 35.4 20.9 54.4 27.9V288h160v-30.8c19-7 37.4-16 54.4-27.9l40.6-28.5c18.1-12.8 22.4-37.7 9.7-55.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBackspace(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M576 64H205.26A63.97 63.97 0 0 0 160 82.75L9.37 233.37c-12.5 12.5-12.5 32.76 0 45.25L160 429.25c12 12 28.28 18.75 45.25 18.75H576c35.35 0 64-28.65 64-64V128c0-35.35-28.65-64-64-64zm-84.69 254.06c6.25 6.25 6.25 16.38 0 22.63l-22.62 22.62c-6.25 6.25-16.38 6.25-22.63 0L384 301.25l-62.06 62.06c-6.25 6.25-16.38 6.25-22.63 0l-22.62-22.62c-6.25-6.25-6.25-16.38 0-22.63L338.75 256l-62.06-62.06c-6.25-6.25-6.25-16.38 0-22.63l22.62-22.62c6.25-6.25 16.38-6.25 22.63 0L384 210.75l62.06-62.06c6.25-6.25 16.38-6.25 22.63 0l22.62 22.62c6.25 6.25 6.25 16.38 0 22.63L429.25 256l62.06 62.06z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBackward(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 280.6l192 160c20.6 17.2 52.5 2.8 52.5-24.6V96c0-27.4-31.9-41.8-52.5-24.6l-192 160c-15.3 12.8-15.3 36.4 0 49.2zm256 0l192 160c20.6 17.2 52.5 2.8 52.5-24.6V96c0-27.4-31.9-41.8-52.5-24.6l-192 160c-15.3 12.8-15.3 36.4 0 49.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBacon(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M218.92 336.39c34.89-34.89 44.2-59.7 54.05-86 10.61-28.29 21.59-57.54 61.37-97.34s69.05-50.77 97.35-61.38c23.88-9 46.64-17.68 76.79-45.37L470.81 8.91a31 31 0 0 0-40.18-2.83c-13.64 10.1-25.15 14.39-41 20.3C247 79.52 209.26 191.29 200.65 214.1c-29.75 78.83-89.55 94.68-98.72 98.09-24.86 9.26-54.73 20.38-91.07 50.36C-3 374-3.63 395 9.07 407.61l35.76 35.51C80 410.52 107 400.15 133 390.39c26.27-9.84 51.06-19.12 85.92-54zm348-232l-35.75-35.51c-35.19 32.63-62.18 43-88.25 52.79-26.26 9.85-51.06 19.16-85.95 54s-44.19 59.69-54 86C292.33 290 281.34 319.22 241.55 359s-69 50.73-97.3 61.32c-23.86 9-46.61 17.66-76.72 45.33l37.68 37.43a31 31 0 0 0 40.18 2.82c13.6-10.06 25.09-14.34 40.94-20.24 142.2-53 180-164.1 188.94-187.69C405 219.18 464.8 203.3 474 199.86c24.87-9.27 54.74-20.4 91.11-50.41 13.89-11.4 14.52-32.45 1.82-45.05z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBacteria(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272.35,226.4A17.71,17.71,0,0,0,281.46,203l-4-9.08a121.29,121.29,0,0,1,12.36-3.08A83.34,83.34,0,0,0,323.57,177l10,9a17.76,17.76,0,1,0,23.92-26.27l-9.72-8.76a83.12,83.12,0,0,0,11.65-48.18l11.85-3.51a17.73,17.73,0,1,0-10.15-34l-11.34,3.36a84,84,0,0,0-36.38-35.57l2.84-10.85a17.8,17.8,0,0,0-34.47-8.93l-2.82,10.78a83.25,83.25,0,0,0-16.74,1.1C250.83,27,240,30.22,229.1,33.39l-3.38-9.46a17.8,17.8,0,0,0-33.56,11.89l3.49,9.8a286.74,286.74,0,0,0-43.94,23.57l-6.32-8.43a17.9,17.9,0,0,0-24.94-3.6A17.69,17.69,0,0,0,116.84,82l6.45,8.61a286.59,286.59,0,0,0-34.95,35.33l-8.82-6.42a17.84,17.84,0,0,0-24.89,3.86,17.66,17.66,0,0,0,3.88,24.77l8.88,6.47a286.6,286.6,0,0,0-23,43.91l-10.48-3.59a17.73,17.73,0,1,0-11.59,33.52L32.67,232c-2.79,10-5.79,19.84-7.52,30.22a83.16,83.16,0,0,0-.82,19l-11.58,3.43a17.73,17.73,0,1,0,10.13,34l11.27-3.33a83.51,83.51,0,0,0,36.39,35.43l-2.88,11.06a17.81,17.81,0,0,0,34.48,8.92l2.87-11c1,0,2.07.26,3.1.26a83.39,83.39,0,0,0,45.65-13.88l8.59,8.8a17.77,17.77,0,0,0,25.56-24.7l-9.14-9.37a83.41,83.41,0,0,0,12.08-31.05,119.08,119.08,0,0,1,3.87-15.53l9,4.22a17.74,17.74,0,1,0,15.15-32.09l-8.8-4.11c.67-1,1.2-2.08,1.9-3.05a119.89,119.89,0,0,1,7.87-9.41,121.73,121.73,0,0,1,11.65-11.4,119.49,119.49,0,0,1,9.94-7.82c1.12-.77,2.32-1.42,3.47-2.15l3.92,8.85a17.86,17.86,0,0,0,16.32,10.58A18.14,18.14,0,0,0,272.35,226.4ZM128,256a32,32,0,1,1,32-32A32,32,0,0,1,128,256Zm80-96a16,16,0,1,1,16-16A16,16,0,0,1,208,160Zm431.26,45.3a17.79,17.79,0,0,0-17.06-12.69,17.55,17.55,0,0,0-5.08.74l-11.27,3.33a83.61,83.61,0,0,0-36.39-35.43l2.88-11.06a17.81,17.81,0,0,0-34.48-8.91l-2.87,11c-1,0-2.07-.26-3.1-.26a83.32,83.32,0,0,0-45.65,13.89l-8.59-8.81a17.77,17.77,0,0,0-25.56,24.7l9.14,9.37a83.28,83.28,0,0,0-12.08,31.06,119.34,119.34,0,0,1-3.87,15.52l-9-4.22a17.74,17.74,0,1,0-15.15,32.09l8.8,4.11c-.67,1-1.2,2.08-1.89,3.05a117.71,117.71,0,0,1-7.94,9.47,119,119,0,0,1-11.57,11.33,121.59,121.59,0,0,1-10,7.83c-1.12.77-2.32,1.42-3.47,2.15l-3.92-8.85a17.86,17.86,0,0,0-16.32-10.58,18.14,18.14,0,0,0-7.18,1.5A17.71,17.71,0,0,0,358.54,309l4,9.08a118.71,118.71,0,0,1-12.36,3.08,83.34,83.34,0,0,0-33.77,13.9l-10-9a17.77,17.77,0,1,0-23.92,26.28l9.72,8.75a83.12,83.12,0,0,0-11.65,48.18l-11.86,3.51a17.73,17.73,0,1,0,10.16,34l11.34-3.36A84,84,0,0,0,326.61,479l-2.84,10.85a17.8,17.8,0,0,0,34.47,8.93L361.06,488a83.3,83.3,0,0,0,16.74-1.1c11.37-1.89,22.24-5.07,33.1-8.24l3.38,9.46a17.8,17.8,0,0,0,33.56-11.89l-3.49-9.79a287.66,287.66,0,0,0,43.94-23.58l6.32,8.43a17.88,17.88,0,0,0,24.93,3.6A17.67,17.67,0,0,0,523.16,430l-6.45-8.61a287.37,287.37,0,0,0,34.95-35.34l8.82,6.42a17.76,17.76,0,1,0,21-28.63l-8.88-6.46a287.17,287.17,0,0,0,23-43.92l10.48,3.59a17.73,17.73,0,1,0,11.59-33.52L607.33,280c2.79-10,5.79-19.84,7.52-30.21a83.27,83.27,0,0,0,.82-19.05l11.58-3.43A17.7,17.7,0,0,0,639.26,205.3ZM416,416a32,32,0,1,1,32-32A32,32,0,0,1,416,416Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBacterium(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M511,102.93A23.76,23.76,0,0,0,481.47,87l-15.12,4.48a111.85,111.85,0,0,0-48.5-47.42l3.79-14.47a23.74,23.74,0,0,0-46-11.91l-3.76,14.37a111.94,111.94,0,0,0-22.33,1.47,386.74,386.74,0,0,0-44.33,10.41l-4.3-12a23.74,23.74,0,0,0-44.75,15.85l4.3,12.05a383.4,383.4,0,0,0-58.69,31.83l-8-10.63a23.85,23.85,0,0,0-33.24-4.8,23.57,23.57,0,0,0-4.83,33.09l8,10.63a386.14,386.14,0,0,0-46.7,47.44l-11-8a23.68,23.68,0,1,0-28,38.17l11.09,8.06a383.45,383.45,0,0,0-30.92,58.75l-12.93-4.43a23.65,23.65,0,1,0-15.47,44.69l13,4.48a385.81,385.81,0,0,0-9.3,40.53A111.58,111.58,0,0,0,32.44,375L17,379.56a23.64,23.64,0,0,0,13.51,45.31l15-4.44a111.49,111.49,0,0,0,48.53,47.24l-3.85,14.75a23.66,23.66,0,0,0,17,28.83,24.7,24.7,0,0,0,6,.75,23.73,23.73,0,0,0,23-17.7L140,479.67c1.37.05,2.77.35,4.13.35A111.22,111.22,0,0,0,205,461.5l11.45,11.74a23.7,23.7,0,0,0,34.08-32.93l-12.19-12.5a111,111,0,0,0,16.11-41.4,158.69,158.69,0,0,1,5.16-20.71l12,5.64a23.66,23.66,0,1,0,20.19-42.79l-11.72-5.49c.89-1.32,1.59-2.77,2.52-4.06a157.86,157.86,0,0,1,10.46-12.49,159.5,159.5,0,0,1,15.59-15.28,162.18,162.18,0,0,1,13.23-10.4c1.5-1,3.1-1.89,4.63-2.87l5.23,11.8a23.74,23.74,0,0,0,43.48-19.08l-5.36-12.11a158.87,158.87,0,0,1,16.49-4.1,111,111,0,0,0,45-18.54l13.33,12a23.69,23.69,0,1,0,31.88-35l-12.94-11.67A110.83,110.83,0,0,0,479.21,137L495,132.32A23.61,23.61,0,0,0,511,102.93ZM160,368a48,48,0,1,1,48-48A48,48,0,0,1,160,368Zm80-136a24,24,0,1,1,24-24A24,24,0,0,1,240,232Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBahai(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496.25 202.52l-110-15.44 41.82-104.34c6.67-16.64-11.6-32.18-26.59-22.63L307.44 120 273.35 12.82C270.64 4.27 263.32 0 256 0c-7.32 0-14.64 4.27-17.35 12.82l-34.09 107.19-94.04-59.89c-14.99-9.55-33.25 5.99-26.59 22.63l41.82 104.34-110 15.43c-17.54 2.46-21.68 26.27-6.03 34.67l98.16 52.66-74.48 83.54c-10.92 12.25-1.72 30.93 13.29 30.93 1.31 0 2.67-.14 4.07-.45l108.57-23.65-4.11 112.55c-.43 11.65 8.87 19.22 18.41 19.22 5.15 0 10.39-2.21 14.2-7.18l68.18-88.9 68.18 88.9c3.81 4.97 9.04 7.18 14.2 7.18 9.54 0 18.84-7.57 18.41-19.22l-4.11-112.55 108.57 23.65c17.36 3.76 29.21-17.2 17.35-30.49l-74.48-83.54 98.16-52.66c15.64-8.39 11.5-32.2-6.04-34.66zM338.51 311.68l-51.89-11.3 1.97 53.79L256 311.68l-32.59 42.49 1.96-53.79-51.89 11.3 35.6-39.93-46.92-25.17 52.57-7.38-19.99-49.87 44.95 28.62L256 166.72l16.29 51.23 44.95-28.62-19.99 49.87 52.57 7.38-46.92 25.17 35.61 39.93z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBalanceScaleLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528 448H352V153.25c20.42-8.94 36.1-26.22 43.38-47.47l132-44.26c8.38-2.81 12.89-11.88 10.08-20.26l-10.17-30.34C524.48 2.54 515.41-1.97 507.03.84L389.11 40.37C375.3 16.36 349.69 0 320 0c-44.18 0-80 35.82-80 80 0 3.43.59 6.71 1.01 10.03l-128.39 43.05c-8.38 2.81-12.89 11.88-10.08 20.26l10.17 30.34c2.81 8.38 11.88 12.89 20.26 10.08l142.05-47.63c4.07 2.77 8.43 5.12 12.99 7.12V496c0 8.84 7.16 16 16 16h224c8.84 0 16-7.16 16-16v-32c-.01-8.84-7.17-16-16.01-16zm111.98-144c0-16.18 1.34-8.73-85.05-181.51-17.65-35.29-68.19-35.36-85.87 0-87.12 174.26-85.04 165.84-85.04 181.51H384c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02zM440 288l72-144 72 144H440zm-269.07-37.51c-17.65-35.29-68.19-35.36-85.87 0C-2.06 424.75.02 416.33.02 432H0c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02c0-16.18 1.34-8.73-85.05-181.51zM56 416l72-144 72 144H56z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBalanceScaleRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 464v32c0 8.84 7.16 16 16 16h224c8.84 0 16-7.16 16-16V153.25c4.56-2 8.92-4.35 12.99-7.12l142.05 47.63c8.38 2.81 17.45-1.71 20.26-10.08l10.17-30.34c2.81-8.38-1.71-17.45-10.08-20.26l-128.4-43.05c.42-3.32 1.01-6.6 1.01-10.03 0-44.18-35.82-80-80-80-29.69 0-55.3 16.36-69.11 40.37L132.96.83c-8.38-2.81-17.45 1.71-20.26 10.08l-10.17 30.34c-2.81 8.38 1.71 17.45 10.08 20.26l132 44.26c7.28 21.25 22.96 38.54 43.38 47.47V448H112c-8.84 0-16 7.16-16 16zM0 304c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02c0-15.67 2.08-7.25-85.05-181.51-17.68-35.36-68.22-35.29-85.87 0C-1.32 295.27.02 287.82.02 304H0zm56-16l72-144 72 144H56zm328.02 144H384c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02c0-15.67 2.08-7.25-85.05-181.51-17.68-35.36-68.22-35.29-85.87 0-86.38 172.78-85.04 165.33-85.04 181.51zM440 416l72-144 72 144H440z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBalanceScale(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 336h-.02c0-16.18 1.34-8.73-85.05-181.51-17.65-35.29-68.19-35.36-85.87 0C-2.06 328.75.02 320.33.02 336H0c0 44.18 57.31 80 128 80s128-35.82 128-80zM128 176l72 144H56l72-144zm511.98 160c0-16.18 1.34-8.73-85.05-181.51-17.65-35.29-68.19-35.36-85.87 0-87.12 174.26-85.04 165.84-85.04 181.51H384c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02zM440 320l72-144 72 144H440zm88 128H352V153.25c23.51-10.29 41.16-31.48 46.39-57.25H528c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16H383.64C369.04 12.68 346.09 0 320 0s-49.04 12.68-63.64 32H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h129.61c5.23 25.76 22.87 46.96 46.39 57.25V448H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBan(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119.034 8 8 119.033 8 256s111.034 248 248 248 248-111.034 248-248S392.967 8 256 8zm130.108 117.892c65.448 65.448 70 165.481 20.677 235.637L150.47 105.216c70.204-49.356 170.226-44.735 235.638 20.676zM125.892 386.108c-65.448-65.448-70-165.481-20.677-235.637L361.53 406.784c-70.203 49.356-170.226 44.736-235.638-20.676z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBandAid(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 160v192c0 35.3 28.7 64 64 64h96V96H64c-35.3 0-64 28.7-64 64zm576-64h-96v320h96c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64zM192 416h256V96H192v320zm176-232c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm0 96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm-96-96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm0 96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBarcode(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 448V64h18v384H0zm26.857-.273V64H36v383.727h-9.143zm27.143 0V64h8.857v383.727H54zm44.857 0V64h8.857v383.727h-8.857zm36 0V64h17.714v383.727h-17.714zm44.857 0V64h8.857v383.727h-8.857zm18 0V64h8.857v383.727h-8.857zm18 0V64h8.857v383.727h-8.857zm35.715 0V64h18v383.727h-18zm44.857 0V64h18v383.727h-18zm35.999 0V64h18.001v383.727h-18.001zm36.001 0V64h18.001v383.727h-18.001zm26.857 0V64h18v383.727h-18zm45.143 0V64h26.857v383.727h-26.857zm35.714 0V64h9.143v383.727H476zm18 .273V64h18v384h-18z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBars(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBaseballBall(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368.5 363.9l28.8-13.9c11.1 22.9 26 43.2 44.1 60.9 34-42.5 54.5-96.3 54.5-154.9 0-58.5-20.4-112.2-54.2-154.6-17.8 17.3-32.6 37.1-43.6 59.5l-28.7-14.1c12.8-26 30-49 50.8-69C375.6 34.7 315 8 248 8 181.1 8 120.5 34.6 75.9 77.7c20.7 19.9 37.9 42.9 50.7 68.8l-28.7 14.1c-11-22.3-25.7-42.1-43.5-59.4C20.4 143.7 0 197.4 0 256c0 58.6 20.4 112.3 54.4 154.7 18.2-17.7 33.2-38 44.3-61l28.8 13.9c-12.9 26.7-30.3 50.3-51.5 70.7 44.5 43.1 105.1 69.7 172 69.7 66.8 0 127.3-26.5 171.9-69.5-21.1-20.4-38.5-43.9-51.4-70.6zm-228.3-32l-30.5-9.8c14.9-46.4 12.7-93.8-.6-134l30.4-10c15 45.6 18 99.9.7 153.8zm216.3-153.4l30.4 10c-13.2 40.1-15.5 87.5-.6 134l-30.5 9.8c-17.3-54-14.3-108.3.7-153.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBasketballBall(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M212.3 10.3c-43.8 6.3-86.2 24.1-122.2 53.8l77.4 77.4c27.8-35.8 43.3-81.2 44.8-131.2zM248 222L405.9 64.1c-42.4-35-93.6-53.5-145.5-56.1-1.2 63.9-21.5 122.3-58.7 167.7L248 222zM56.1 98.1c-29.7 36-47.5 78.4-53.8 122.2 50-1.5 95.5-17 131.2-44.8L56.1 98.1zm272.2 204.2c45.3-37.1 103.7-57.4 167.7-58.7-2.6-51.9-21.1-103.1-56.1-145.5L282 256l46.3 46.3zM248 290L90.1 447.9c42.4 34.9 93.6 53.5 145.5 56.1 1.3-64 21.6-122.4 58.7-167.7L248 290zm191.9 123.9c29.7-36 47.5-78.4 53.8-122.2-50.1 1.6-95.5 17.1-131.2 44.8l77.4 77.4zM167.7 209.7C122.3 246.9 63.9 267.3 0 268.4c2.6 51.9 21.1 103.1 56.1 145.5L214 256l-46.3-46.3zm116 292c43.8-6.3 86.2-24.1 122.2-53.8l-77.4-77.4c-27.7 35.7-43.2 81.2-44.8 131.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBath(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32,384a95.4,95.4,0,0,0,32,71.09V496a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V480H384v16a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V455.09A95.4,95.4,0,0,0,480,384V336H32ZM496,256H80V69.25a21.26,21.26,0,0,1,36.28-15l19.27,19.26c-13.13,29.88-7.61,59.11,8.62,79.73l-.17.17A16,16,0,0,0,144,176l11.31,11.31a16,16,0,0,0,22.63,0L283.31,81.94a16,16,0,0,0,0-22.63L272,48a16,16,0,0,0-22.62,0l-.17.17c-20.62-16.23-49.83-21.75-79.73-8.62L150.22,20.28A69.25,69.25,0,0,0,32,69.25V256H16A16,16,0,0,0,0,272v16a16,16,0,0,0,16,16H496a16,16,0,0,0,16-16V272A16,16,0,0,0,496,256Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBatteryEmpty(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBatteryFull(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-48 96H96v128h416V192z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBatteryHalf(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-240 96H96v128h224V192z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBatteryQuarter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-336 96H96v128h128V192z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBatteryThreeQuarters(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-144 96H96v128h320V192z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBed(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 256c44.11 0 80-35.89 80-80s-35.89-80-80-80-80 35.89-80 80 35.89 80 80 80zm352-128H304c-8.84 0-16 7.16-16 16v144H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v352c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48h512v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V240c0-61.86-50.14-112-112-112z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBeer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 96h-48V56c0-13.255-10.745-24-24-24H24C10.745 32 0 42.745 0 56v400c0 13.255 10.745 24 24 24h272c13.255 0 24-10.745 24-24v-42.11l80.606-35.977C429.396 365.063 448 336.388 448 304.86V176c0-44.112-35.888-80-80-80zm16 208.86a16.018 16.018 0 0 1-9.479 14.611L320 343.805V160h48c8.822 0 16 7.178 16 16v128.86zM208 384c-8.836 0-16-7.164-16-16V144c0-8.836 7.164-16 16-16s16 7.164 16 16v224c0 8.836-7.164 16-16 16zm-96 0c-8.836 0-16-7.164-16-16V144c0-8.836 7.164-16 16-16s16 7.164 16 16v224c0 8.836-7.164 16-16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBellSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M633.82 458.1l-90.62-70.05c.19-1.38.8-2.66.8-4.06.05-7.55-2.61-15.27-8.61-21.71-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84c-40.33 8.38-74.66 31.07-97.59 62.57L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.35 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.42-6.97 4.17-17.02-2.81-22.45zM157.23 251.54c-8.61 67.96-36.41 93.33-52.62 110.75-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h241.92L157.23 251.54zM320 512c35.32 0 63.97-28.65 63.97-64H256.03c0 35.35 28.65 64 63.97 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBell(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 512c35.32 0 63.97-28.65 63.97-64H160.03c0 35.35 28.65 64 63.97 64zm215.39-149.71c-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84C118.56 68.1 64.08 130.3 64.08 208c0 102.3-36.15 133.53-55.47 154.29-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h383.8c19.12 0 32-15.6 32.1-32 .05-7.55-2.61-15.27-8.61-21.71z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBezierCurve(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 32h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zM208 88h-84.75C113.75 64.56 90.84 48 64 48 28.66 48 0 76.65 0 112s28.66 64 64 64c26.84 0 49.75-16.56 59.25-40h79.73c-55.37 32.52-95.86 87.32-109.54 152h49.4c11.3-41.61 36.77-77.21 71.04-101.56-3.7-8.08-5.88-16.99-5.88-26.44V88zm-48 232H64c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zM576 48c-26.84 0-49.75 16.56-59.25 40H432v72c0 9.45-2.19 18.36-5.88 26.44 34.27 24.35 59.74 59.95 71.04 101.56h49.4c-13.68-64.68-54.17-119.48-109.54-152h79.73c9.5 23.44 32.41 40 59.25 40 35.34 0 64-28.65 64-64s-28.66-64-64-64zm0 272h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBible(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM144 144c0-8.84 7.16-16 16-16h48V80c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v48h48c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16h-48v112c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16V192h-48c-8.84 0-16-7.16-16-16v-32zm236.8 304H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8v64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBicycle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512.509 192.001c-16.373-.064-32.03 2.955-46.436 8.495l-77.68-125.153A24 24 0 0 0 368.001 64h-64c-8.837 0-16 7.163-16 16v16c0 8.837 7.163 16 16 16h50.649l14.896 24H256.002v-16c0-8.837-7.163-16-16-16h-87.459c-13.441 0-24.777 10.999-24.536 24.437.232 13.044 10.876 23.563 23.995 23.563h48.726l-29.417 47.52c-13.433-4.83-27.904-7.483-42.992-7.52C58.094 191.83.412 249.012.002 319.236-.413 390.279 57.055 448 128.002 448c59.642 0 109.758-40.793 123.967-96h52.033a24 24 0 0 0 20.406-11.367L410.37 201.77l14.938 24.067c-25.455 23.448-41.385 57.081-41.307 94.437.145 68.833 57.899 127.051 126.729 127.719 70.606.685 128.181-55.803 129.255-125.996 1.086-70.941-56.526-129.72-127.476-129.996zM186.75 265.772c9.727 10.529 16.673 23.661 19.642 38.228h-43.306l23.664-38.228zM128.002 400c-44.112 0-80-35.888-80-80s35.888-80 80-80c5.869 0 11.586.653 17.099 1.859l-45.505 73.509C89.715 331.327 101.213 352 120.002 352h81.3c-12.37 28.225-40.562 48-73.3 48zm162.63-96h-35.624c-3.96-31.756-19.556-59.894-42.383-80.026L237.371 184h127.547l-74.286 120zm217.057 95.886c-41.036-2.165-74.049-35.692-75.627-76.755-.812-21.121 6.633-40.518 19.335-55.263l44.433 71.586c4.66 7.508 14.524 9.816 22.032 5.156l13.594-8.437c7.508-4.66 9.817-14.524 5.156-22.032l-44.468-71.643a79.901 79.901 0 0 1 19.858-2.497c44.112 0 80 35.888 80 80-.001 45.54-38.252 82.316-84.313 79.885z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBiking(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 96a48 48 0 1 0-48-48 48 48 0 0 0 48 48zm-4 121a31.9 31.9 0 0 0 20 7h64a32 32 0 0 0 0-64h-52.78L356 103a31.94 31.94 0 0 0-40.81.68l-112 96a32 32 0 0 0 3.08 50.92L288 305.12V416a32 32 0 0 0 64 0V288a32 32 0 0 0-14.25-26.62l-41.36-27.57 58.25-49.92zm116 39a128 128 0 1 0 128 128 128 128 0 0 0-128-128zm0 192a64 64 0 1 1 64-64 64 64 0 0 1-64 64zM128 256a128 128 0 1 0 128 128 128 128 0 0 0-128-128zm0 192a64 64 0 1 1 64-64 64 64 0 0 1-64 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBinoculars(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 48c0-8.84-7.16-16-16-16h-64c-8.84 0-16 7.16-16 16v48h96V48zM63.91 159.99C61.4 253.84 3.46 274.22 0 404v44c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32V288h32V128H95.84c-17.63 0-31.45 14.37-31.93 31.99zm384.18 0c-.48-17.62-14.3-31.99-31.93-31.99H320v160h32v160c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-44c-3.46-129.78-61.4-150.16-63.91-244.01zM176 32h-64c-8.84 0-16 7.16-16 16v48h96V48c0-8.84-7.16-16-16-16zm48 256h64V128h-64v160z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBiohazard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M287.9 112c18.6 0 36.2 3.8 52.8 9.6 13.3-10.3 23.6-24.3 29.5-40.7-25.2-10.9-53-17-82.2-17-29.1 0-56.9 6-82.1 16.9 5.9 16.4 16.2 30.4 29.5 40.7 16.5-5.7 34-9.5 52.5-9.5zM163.6 438.7c12-11.8 20.4-26.4 24.5-42.4-32.9-26.4-54.8-65.3-58.9-109.6-8.5-2.8-17.2-4.6-26.4-4.6-7.6 0-15.2 1-22.5 3.1 4.1 62.8 35.8 118 83.3 153.5zm224.2-42.6c4.1 16 12.5 30.7 24.5 42.5 47.4-35.5 79.1-90.7 83-153.5-7.2-2-14.7-3-22.2-3-9.2 0-18 1.9-26.6 4.7-4.1 44.2-26 82.9-58.7 109.3zm113.5-205c-17.6-10.4-36.3-16.6-55.3-19.9 6-17.7 10-36.4 10-56.2 0-41-14.5-80.8-41-112.2-2.5-3-6.6-3.7-10-1.8-3.3 1.9-4.8 6-3.6 9.7 4.5 13.8 6.6 26.3 6.6 38.5 0 67.8-53.8 122.9-120 122.9S168 117 168 49.2c0-12.1 2.2-24.7 6.6-38.5 1.2-3.7-.3-7.8-3.6-9.7-3.4-1.9-7.5-1.2-10 1.8C134.6 34.2 120 74 120 115c0 19.8 3.9 38.5 10 56.2-18.9 3.3-37.7 9.5-55.3 19.9-34.6 20.5-61 53.3-74.3 92.4-1.3 3.7.2 7.7 3.5 9.8 3.3 2 7.5 1.3 10-1.6 9.4-10.8 19-19.1 29.2-25.1 57.3-33.9 130.8-13.7 163.9 45 33.1 58.7 13.4 134-43.9 167.9-10.2 6.1-22 10.4-35.8 13.4-3.7.8-6.4 4.2-6.4 8.1.1 4 2.7 7.3 6.5 8 39.7 7.8 80.6.8 115.2-19.7 18-10.6 32.9-24.5 45.3-40.1 12.4 15.6 27.3 29.5 45.3 40.1 34.6 20.5 75.5 27.5 115.2 19.7 3.8-.7 6.4-4 6.5-8 0-3.9-2.6-7.3-6.4-8.1-13.9-2.9-25.6-7.3-35.8-13.4-57.3-33.9-77-109.2-43.9-167.9s106.6-78.9 163.9-45c10.2 6.1 19.8 14.3 29.2 25.1 2.5 2.9 6.7 3.6 10 1.6s4.8-6.1 3.5-9.8c-13.1-39.1-39.5-72-74.1-92.4zm-213.4 129c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBirthdayCake(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 384c-28.02 0-31.26-32-74.5-32-43.43 0-46.825 32-74.75 32-27.695 0-31.454-32-74.75-32-42.842 0-47.218 32-74.5 32-28.148 0-31.202-32-74.75-32-43.547 0-46.653 32-74.75 32v-80c0-26.5 21.5-48 48-48h16V112h64v144h64V112h64v144h64V112h64v144h16c26.5 0 48 21.5 48 48v80zm0 128H0v-96c43.356 0 46.767-32 74.75-32 27.951 0 31.253 32 74.75 32 42.843 0 47.217-32 74.5-32 28.148 0 31.201 32 74.75 32 43.357 0 46.767-32 74.75-32 27.488 0 31.252 32 74.5 32v96zM96 96c-17.75 0-32-14.25-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.25 40-32 40zm128 0c-17.75 0-32-14.25-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.25 40-32 40zm128 0c-17.75 0-32-14.25-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.25 40-32 40z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBlenderPhone(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M392 64h166.54L576 0H192v352h288l17.46-64H392c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h114.18l17.46-64H392c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h140.36l17.46-64H392c-4.42 0-8-3.58-8-8V72c0-4.42 3.58-8 8-8zM158.8 335.01l-25.78-63.26c-2.78-6.81-9.8-10.99-17.24-10.26l-45.03 4.42c-17.28-46.94-17.65-99.78 0-147.72l45.03 4.42c7.43.73 14.46-3.46 17.24-10.26l25.78-63.26c3.02-7.39.2-15.85-6.68-20.07l-39.28-24.1C98.51-3.87 80.09-.5 68.95 11.97c-92.57 103.6-92 259.55 2.1 362.49 9.87 10.8 29.12 12.48 41.65 4.8l39.41-24.18c6.89-4.22 9.7-12.67 6.69-20.07zM480 384H192c-35.35 0-64 28.65-64 64v32c0 17.67 14.33 32 32 32h352c17.67 0 32-14.33 32-32v-32c0-35.35-28.65-64-64-64zm-144 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBlender(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 384H160c-35.35 0-64 28.65-64 64v32c0 17.67 14.33 32 32 32h320c17.67 0 32-14.33 32-32v-32c0-35.35-28.65-64-64-64zm-128 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm40-416h166.54L512 0H48C21.49 0 0 21.49 0 48v160c0 26.51 21.49 48 48 48h103.27l8.73 96h256l17.46-64H328c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h114.18l17.46-64H328c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h140.36l17.46-64H328c-4.42 0-8-3.58-8-8V72c0-4.42 3.58-8 8-8zM64 192V64h69.82l11.64 128H64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBlind(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M380.15 510.837a8 8 0 0 1-10.989-2.687l-125.33-206.427a31.923 31.923 0 0 0 12.958-9.485l126.048 207.608a8 8 0 0 1-2.687 10.991zM142.803 314.338l-32.54 89.485 36.12 88.285c6.693 16.36 25.377 24.192 41.733 17.501 16.357-6.692 24.193-25.376 17.501-41.734l-62.814-153.537zM96 88c24.301 0 44-19.699 44-44S120.301 0 96 0 52 19.699 52 44s19.699 44 44 44zm154.837 169.128l-120-152c-4.733-5.995-11.75-9.108-18.837-9.112V96H80v.026c-7.146.003-14.217 3.161-18.944 9.24L0 183.766v95.694c0 13.455 11.011 24.791 24.464 24.536C37.505 303.748 48 293.1 48 280v-79.766l16-20.571v140.698L9.927 469.055c-6.04 16.609 2.528 34.969 19.138 41.009 16.602 6.039 34.968-2.524 41.009-19.138L136 309.638V202.441l-31.406-39.816a4 4 0 1 1 6.269-4.971l102.3 129.217c9.145 11.584 24.368 11.339 33.708 3.965 10.41-8.216 12.159-23.334 3.966-33.708z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBlog(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M172.2 226.8c-14.6-2.9-28.2 8.9-28.2 23.8V301c0 10.2 7.1 18.4 16.7 22 18.2 6.8 31.3 24.4 31.3 45 0 26.5-21.5 48-48 48s-48-21.5-48-48V120c0-13.3-10.7-24-24-24H24c-13.3 0-24 10.7-24 24v248c0 89.5 82.1 160.2 175 140.7 54.4-11.4 98.3-55.4 109.7-109.7 17.4-82.9-37-157.2-112.5-172.2zM209 0c-9.2-.5-17 6.8-17 16v31.6c0 8.5 6.6 15.5 15 15.9 129.4 7 233.4 112 240.9 241.5.5 8.4 7.5 15 15.9 15h32.1c9.2 0 16.5-7.8 16-17C503.4 139.8 372.2 8.6 209 0zm.3 96c-9.3-.7-17.3 6.7-17.3 16.1v32.1c0 8.4 6.5 15.3 14.8 15.9 76.8 6.3 138 68.2 144.9 145.2.8 8.3 7.6 14.7 15.9 14.7h32.2c9.3 0 16.8-8 16.1-17.3-8.4-110.1-96.5-198.2-206.6-206.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBold(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M333.49 238a122 122 0 0 0 27-65.21C367.87 96.49 308 32 233.42 32H34a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h31.87v288H34a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h209.32c70.8 0 134.14-51.75 141-122.4 4.74-48.45-16.39-92.06-50.83-119.6zM145.66 112h87.76a48 48 0 0 1 0 96h-87.76zm87.76 288h-87.76V288h87.76a56 56 0 0 1 0 112z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBolt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M296 160H180.6l42.6-129.8C227.2 15 215.7 0 200 0H56C44 0 33.8 8.9 32.2 20.8l-32 240C-1.7 275.2 9.5 288 24 288h118.7L96.6 482.5c-3.6 15.2 8 29.5 23.3 29.5 8.4 0 16.4-4.4 20.8-12l176-304c9.3-15.9-2.2-36-20.7-36z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBomb(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M440.5 88.5l-52 52L415 167c9.4 9.4 9.4 24.6 0 33.9l-17.4 17.4c11.8 26.1 18.4 55.1 18.4 85.6 0 114.9-93.1 208-208 208S0 418.9 0 304 93.1 96 208 96c30.5 0 59.5 6.6 85.6 18.4L311 97c9.4-9.4 24.6-9.4 33.9 0l26.5 26.5 52-52 17.1 17zM500 60h-24c-6.6 0-12 5.4-12 12s5.4 12 12 12h24c6.6 0 12-5.4 12-12s-5.4-12-12-12zM440 0c-6.6 0-12 5.4-12 12v24c0 6.6 5.4 12 12 12s12-5.4 12-12V12c0-6.6-5.4-12-12-12zm33.9 55l17-17c4.7-4.7 4.7-12.3 0-17-4.7-4.7-12.3-4.7-17 0l-17 17c-4.7 4.7-4.7 12.3 0 17 4.8 4.7 12.4 4.7 17 0zm-67.8 0c4.7 4.7 12.3 4.7 17 0 4.7-4.7 4.7-12.3 0-17l-17-17c-4.7-4.7-12.3-4.7-17 0-4.7 4.7-4.7 12.3 0 17l17 17zm67.8 34c-4.7-4.7-12.3-4.7-17 0-4.7 4.7-4.7 12.3 0 17l17 17c4.7 4.7 12.3 4.7 17 0 4.7-4.7 4.7-12.3 0-17l-17-17zM112 272c0-35.3 28.7-64 64-64 8.8 0 16-7.2 16-16s-7.2-16-16-16c-52.9 0-96 43.1-96 96 0 8.8 7.2 16 16 16s16-7.2 16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBone(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M598.88 244.56c25.2-12.6 41.12-38.36 41.12-66.53v-7.64C640 129.3 606.7 96 565.61 96c-32.02 0-60.44 20.49-70.57 50.86-7.68 23.03-11.6 45.14-38.11 45.14H183.06c-27.38 0-31.58-25.54-38.11-45.14C134.83 116.49 106.4 96 74.39 96 33.3 96 0 129.3 0 170.39v7.64c0 28.17 15.92 53.93 41.12 66.53 9.43 4.71 9.43 18.17 0 22.88C15.92 280.04 0 305.8 0 333.97v7.64C0 382.7 33.3 416 74.38 416c32.02 0 60.44-20.49 70.57-50.86 7.68-23.03 11.6-45.14 38.11-45.14h273.87c27.38 0 31.58 25.54 38.11 45.14C505.17 395.51 533.6 416 565.61 416c41.08 0 74.38-33.3 74.38-74.39v-7.64c0-28.18-15.92-53.93-41.12-66.53-9.42-4.71-9.42-18.17.01-22.88z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBong(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M302.5 512c23.18 0 44.43-12.58 56-32.66C374.69 451.26 384 418.75 384 384c0-36.12-10.08-69.81-27.44-98.62L400 241.94l9.38 9.38c6.25 6.25 16.38 6.25 22.63 0l11.3-11.32c6.25-6.25 6.25-16.38 0-22.63l-52.69-52.69c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63l9.38 9.38-39.41 39.41c-11.56-11.37-24.53-21.33-38.65-29.51V63.74l15.97-.02c8.82-.01 15.97-7.16 15.98-15.98l.04-31.72C320 7.17 312.82-.01 303.97 0L80.03.26c-8.82.01-15.97 7.16-15.98 15.98l-.04 31.73c-.01 8.85 7.17 16.02 16.02 16.01L96 63.96v153.93C38.67 251.1 0 312.97 0 384c0 34.75 9.31 67.27 25.5 95.34C37.08 499.42 58.33 512 81.5 512h221zM120.06 259.43L144 245.56V63.91l96-.11v181.76l23.94 13.87c24.81 14.37 44.12 35.73 56.56 60.57h-257c12.45-24.84 31.75-46.2 56.56-60.57z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBookDead(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272 136c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm176 222.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM240 56c44.2 0 80 28.7 80 64 0 20.9-12.7 39.2-32 50.9V184c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16v-13.1c-19.3-11.7-32-30-32-50.9 0-35.3 35.8-64 80-64zM124.8 223.3l6.3-14.7c1.7-4.1 6.4-5.9 10.5-4.2l98.3 42.1 98.4-42.1c4.1-1.7 8.8.1 10.5 4.2l6.3 14.7c1.7 4.1-.1 8.8-4.2 10.5L280.6 264l70.3 30.1c4.1 1.7 5.9 6.4 4.2 10.5l-6.3 14.7c-1.7 4.1-6.4 5.9-10.5 4.2L240 281.4l-98.3 42.2c-4.1 1.7-8.8-.1-10.5-4.2l-6.3-14.7c-1.7-4.1.1-8.8 4.2-10.5l70.4-30.1-70.5-30.3c-4.1-1.7-5.9-6.4-4.2-10.5zm256 224.7H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8zM208 136c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBookMedical(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16q0-9.6-9.6-19.2c-3.2-16-3.2-60.8 0-73.6q9.6-4.8 9.6-19.2zM144 168a8 8 0 0 1 8-8h56v-56a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v56h56a8 8 0 0 1 8 8v48a8 8 0 0 1-8 8h-56v56a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8v-56h-56a8 8 0 0 1-8-8zm236.8 280H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBookOpen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M542.22 32.05c-54.8 3.11-163.72 14.43-230.96 55.59-4.64 2.84-7.27 7.89-7.27 13.17v363.87c0 11.55 12.63 18.85 23.28 13.49 69.18-34.82 169.23-44.32 218.7-46.92 16.89-.89 30.02-14.43 30.02-30.66V62.75c.01-17.71-15.35-31.74-33.77-30.7zM264.73 87.64C197.5 46.48 88.58 35.17 33.78 32.05 15.36 31.01 0 45.04 0 62.75V400.6c0 16.24 13.13 29.78 30.02 30.66 49.49 2.6 149.59 12.11 218.77 46.95 10.62 5.35 23.21-1.94 23.21-13.46V100.63c0-5.29-2.62-10.14-7.27-12.99z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBookReader(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 96c0-53.02-42.98-96-96-96s-96 42.98-96 96 42.98 96 96 96 96-42.98 96-96zM233.59 241.1c-59.33-36.32-155.43-46.3-203.79-49.05C13.55 191.13 0 203.51 0 219.14v222.8c0 14.33 11.59 26.28 26.49 27.05 43.66 2.29 131.99 10.68 193.04 41.43 9.37 4.72 20.48-1.71 20.48-11.87V252.56c-.01-4.67-2.32-8.95-6.42-11.46zm248.61-49.05c-48.35 2.74-144.46 12.73-203.78 49.05-4.1 2.51-6.41 6.96-6.41 11.63v245.79c0 10.19 11.14 16.63 20.54 11.9 61.04-30.72 149.32-39.11 192.97-41.4 14.9-.78 26.49-12.73 26.49-27.06V219.14c-.01-15.63-13.56-28.01-29.81-27.09z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBook(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 360V24c0-13.3-10.7-24-24-24H96C43 0 0 43 0 96v320c0 53 43 96 96 96h328c13.3 0 24-10.7 24-24v-16c0-7.5-3.5-14.3-8.9-18.7-4.2-15.4-4.2-59.3 0-74.7 5.4-4.3 8.9-11.1 8.9-18.6zM128 134c0-3.3 2.7-6 6-6h212c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H134c-3.3 0-6-2.7-6-6v-20zm0 64c0-3.3 2.7-6 6-6h212c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H134c-3.3 0-6-2.7-6-6v-20zm253.4 250H96c-17.7 0-32-14.3-32-32 0-17.6 14.4-32 32-32h285.4c-1.9 17.1-1.9 46.9 0 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBookmark(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 512V48C0 21.49 21.49 0 48 0h288c26.51 0 48 21.49 48 48v464L192 400 0 512z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBorderAll(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 32H32A32 32 0 0 0 0 64v384a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V64a32 32 0 0 0-32-32zm-32 64v128H256V96zm-192 0v128H64V96zM64 416V288h128v128zm192 0V288h128v128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBorderNone(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M240 224h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-288 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM240 320h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-96 288h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96-384h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM48 224H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 192H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-192H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBorderStyle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M240 416h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm192 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96-192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 96h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 96h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-288h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96H32A32 32 0 0 0 0 64v400a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V96h368a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBowlingBall(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM120 192c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm64-96c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm48 144c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBoxOpen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M425.7 256c-16.9 0-32.8-9-41.4-23.4L320 126l-64.2 106.6c-8.7 14.5-24.6 23.5-41.5 23.5-4.5 0-9-.6-13.3-1.9L64 215v178c0 14.7 10 27.5 24.2 31l216.2 54.1c10.2 2.5 20.9 2.5 31 0L551.8 424c14.2-3.6 24.2-16.4 24.2-31V215l-137 39.1c-4.3 1.3-8.8 1.9-13.3 1.9zm212.6-112.2L586.8 41c-3.1-6.2-9.8-9.8-16.7-8.9L320 64l91.7 152.1c3.8 6.3 11.4 9.3 18.5 7.3l197.9-56.5c9.9-2.9 14.7-13.9 10.2-23.1zM53.2 41L1.7 143.8c-4.6 9.2.3 20.2 10.1 23l197.9 56.5c7.1 2 14.7-1 18.5-7.3L320 64 69.8 32.1c-6.9-.8-13.5 2.7-16.6 8.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBoxTissue(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M383.88,287.82l64-192H338.47a70.2,70.2,0,0,1-66.59-48,70.21,70.21,0,0,0-66.6-48H63.88l64,288Zm-384,192a32,32,0,0,0,32,32h448a32,32,0,0,0,32-32v-64H-.12Zm480-256H438.94l-21.33,64h14.27a16,16,0,0,1,0,32h-352a16,16,0,1,1,0-32H95.09l-14.22-64h-49a32,32,0,0,0-32,32v128h512v-128A32,32,0,0,0,479.88,223.82Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBox(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M509.5 184.6L458.9 32.8C452.4 13.2 434.1 0 413.4 0H272v192h238.7c-.4-2.5-.4-5-1.2-7.4zM240 0H98.6c-20.7 0-39 13.2-45.5 32.8L2.5 184.6c-.8 2.4-.8 4.9-1.2 7.4H240V0zM0 224v240c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V224H0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBoxes(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M560 288h-80v96l-32-21.3-32 21.3v-96h-80c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16zm-384-64h224c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16h-80v96l-32-21.3L256 96V0h-80c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16zm64 64h-80v96l-32-21.3L96 384v-96H16c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBraille(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 256c0 35.346-28.654 64-64 64S0 291.346 0 256s28.654-64 64-64 64 28.654 64 64zM64 384c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-352C28.654 32 0 60.654 0 96s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64zm160 192c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0 160c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-352c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64zm224 192c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0 160c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-352c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64zm160 192c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0 160c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-320c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBrain(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208 0c-29.9 0-54.7 20.5-61.8 48.2-.8 0-1.4-.2-2.2-.2-35.3 0-64 28.7-64 64 0 4.8.6 9.5 1.7 14C52.5 138 32 166.6 32 200c0 12.6 3.2 24.3 8.3 34.9C16.3 248.7 0 274.3 0 304c0 33.3 20.4 61.9 49.4 73.9-.9 4.6-1.4 9.3-1.4 14.1 0 39.8 32.2 72 72 72 4.1 0 8.1-.5 12-1.2 9.6 28.5 36.2 49.2 68 49.2 39.8 0 72-32.2 72-72V64c0-35.3-28.7-64-64-64zm368 304c0-29.7-16.3-55.3-40.3-69.1 5.2-10.6 8.3-22.3 8.3-34.9 0-33.4-20.5-62-49.7-74 1-4.5 1.7-9.2 1.7-14 0-35.3-28.7-64-64-64-.8 0-1.5.2-2.2.2C422.7 20.5 397.9 0 368 0c-35.3 0-64 28.6-64 64v376c0 39.8 32.2 72 72 72 31.8 0 58.4-20.7 68-49.2 3.9.7 7.9 1.2 12 1.2 39.8 0 72-32.2 72-72 0-4.8-.5-9.5-1.4-14.1 29-12 49.4-40.6 49.4-73.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBreadSlice(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 0C108 0 0 93.4 0 169.14 0 199.44 24.24 224 64 224v256c0 17.67 16.12 32 36 32h376c19.88 0 36-14.33 36-32V224c39.76 0 64-24.56 64-54.86C576 93.4 468 0 288 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBriefcaseMedical(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 128h-80V80c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48v48H48c-26.5 0-48 21.5-48 48v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48zM192 96h128v32H192V96zm160 248c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBriefcase(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 336c0 8.84-7.16 16-16 16h-96c-8.84 0-16-7.16-16-16v-48H0v144c0 25.6 22.4 48 48 48h416c25.6 0 48-22.4 48-48V288H320v48zm144-208h-80V80c0-25.6-22.4-48-48-48H176c-25.6 0-48 22.4-48 48v48H48c-25.6 0-48 22.4-48 48v80h512v-80c0-25.6-22.4-48-48-48zm-144 0H192V96h128v32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBroadcastTower(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M150.94 192h33.73c11.01 0 18.61-10.83 14.86-21.18-4.93-13.58-7.55-27.98-7.55-42.82s2.62-29.24 7.55-42.82C203.29 74.83 195.68 64 184.67 64h-33.73c-7.01 0-13.46 4.49-15.41 11.23C130.64 92.21 128 109.88 128 128c0 18.12 2.64 35.79 7.54 52.76 1.94 6.74 8.39 11.24 15.4 11.24zM89.92 23.34C95.56 12.72 87.97 0 75.96 0H40.63c-6.27 0-12.14 3.59-14.74 9.31C9.4 45.54 0 85.65 0 128c0 24.75 3.12 68.33 26.69 118.86 2.62 5.63 8.42 9.14 14.61 9.14h34.84c12.02 0 19.61-12.74 13.95-23.37-49.78-93.32-16.71-178.15-.17-209.29zM614.06 9.29C611.46 3.58 605.6 0 599.33 0h-35.42c-11.98 0-19.66 12.66-14.02 23.25 18.27 34.29 48.42 119.42.28 209.23-5.72 10.68 1.8 23.52 13.91 23.52h35.23c6.27 0 12.13-3.58 14.73-9.29C630.57 210.48 640 170.36 640 128s-9.42-82.48-25.94-118.71zM489.06 64h-33.73c-11.01 0-18.61 10.83-14.86 21.18 4.93 13.58 7.55 27.98 7.55 42.82s-2.62 29.24-7.55 42.82c-3.76 10.35 3.85 21.18 14.86 21.18h33.73c7.02 0 13.46-4.49 15.41-11.24 4.9-16.97 7.53-34.64 7.53-52.76 0-18.12-2.64-35.79-7.54-52.76-1.94-6.75-8.39-11.24-15.4-11.24zm-116.3 100.12c7.05-10.29 11.2-22.71 11.2-36.12 0-35.35-28.63-64-63.96-64-35.32 0-63.96 28.65-63.96 64 0 13.41 4.15 25.83 11.2 36.12l-130.5 313.41c-3.4 8.15.46 17.52 8.61 20.92l29.51 12.31c8.15 3.4 17.52-.46 20.91-8.61L244.96 384h150.07l49.2 118.15c3.4 8.16 12.76 12.01 20.91 8.61l29.51-12.31c8.15-3.4 12-12.77 8.61-20.92l-130.5-313.41zM271.62 320L320 203.81 368.38 320h-96.76z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBroom(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256.47 216.77l86.73 109.18s-16.6 102.36-76.57 150.12C206.66 523.85 0 510.19 0 510.19s3.8-23.14 11-55.43l94.62-112.17c3.97-4.7-.87-11.62-6.65-9.5l-60.4 22.09c14.44-41.66 32.72-80.04 54.6-97.47 59.97-47.76 163.3-40.94 163.3-40.94zM636.53 31.03l-19.86-25c-5.49-6.9-15.52-8.05-22.41-2.56l-232.48 177.8-34.14-42.97c-5.09-6.41-15.14-5.21-18.59 2.21l-25.33 54.55 86.73 109.18 58.8-12.45c8-1.69 11.42-11.2 6.34-17.6l-34.09-42.92 232.48-177.8c6.89-5.48 8.04-15.53 2.55-22.44z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBrush(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 0H32C14.33 0 0 14.33 0 32v224h384V32c0-17.67-14.33-32-32-32zM0 320c0 35.35 28.66 64 64 64h64v64c0 35.35 28.66 64 64 64s64-28.65 64-64v-64h64c35.34 0 64-28.65 64-64v-32H0v32zm192 104c13.25 0 24 10.74 24 24 0 13.25-10.75 24-24 24s-24-10.75-24-24c0-13.26 10.75-24 24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBug(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M511.988 288.9c-.478 17.43-15.217 31.1-32.653 31.1H424v16c0 21.864-4.882 42.584-13.6 61.145l60.228 60.228c12.496 12.497 12.496 32.758 0 45.255-12.498 12.497-32.759 12.496-45.256 0l-54.736-54.736C345.886 467.965 314.351 480 280 480V236c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v244c-34.351 0-65.886-12.035-90.636-32.108l-54.736 54.736c-12.498 12.497-32.759 12.496-45.256 0-12.496-12.497-12.496-32.758 0-45.255l60.228-60.228C92.882 378.584 88 357.864 88 336v-16H32.666C15.23 320 .491 306.33.013 288.9-.484 270.816 14.028 256 32 256h56v-58.745l-46.628-46.628c-12.496-12.497-12.496-32.758 0-45.255 12.498-12.497 32.758-12.497 45.256 0L141.255 160h229.489l54.627-54.627c12.498-12.497 32.758-12.497 45.256 0 12.496 12.497 12.496 32.758 0 45.255L424 197.255V256h56c17.972 0 32.484 14.816 31.988 32.9zM257 0c-61.856 0-112 50.144-112 112h224C369 50.144 318.856 0 257 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBuilding(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M436 480h-20V24c0-13.255-10.745-24-24-24H56C42.745 0 32 10.745 32 24v456H12c-6.627 0-12 5.373-12 12v20h448v-20c0-6.627-5.373-12-12-12zM128 76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76zm0 96c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40zm52 148h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12zm76 160h-64v-84c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v84zm64-172c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBullhorn(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M576 240c0-23.63-12.95-44.04-32-55.12V32.01C544 23.26 537.02 0 512 0c-7.12 0-14.19 2.38-19.98 7.02l-85.03 68.03C364.28 109.19 310.66 128 256 128H64c-35.35 0-64 28.65-64 64v96c0 35.35 28.65 64 64 64h33.7c-1.39 10.48-2.18 21.14-2.18 32 0 39.77 9.26 77.35 25.56 110.94 5.19 10.69 16.52 17.06 28.4 17.06h74.28c26.05 0 41.69-29.84 25.9-50.56-16.4-21.52-26.15-48.36-26.15-77.44 0-11.11 1.62-21.79 4.41-32H256c54.66 0 108.28 18.81 150.98 52.95l85.03 68.03a32.023 32.023 0 0 0 19.98 7.02c24.92 0 32-22.78 32-32V295.13C563.05 284.04 576 263.63 576 240zm-96 141.42l-33.05-26.44C392.95 311.78 325.12 288 256 288v-96c69.12 0 136.95-23.78 190.95-66.98L480 98.58v282.84z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBullseye(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 432c-101.69 0-184-82.29-184-184 0-101.69 82.29-184 184-184 101.69 0 184 82.29 184 184 0 101.69-82.29 184-184 184zm0-312c-70.69 0-128 57.31-128 128s57.31 128 128 128 128-57.31 128-128-57.31-128-128-128zm0 192c-35.29 0-64-28.71-64-64s28.71-64 64-64 64 28.71 64 64-28.71 64-64 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBurn(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 0C79.7 101.3 0 220.9 0 300.5 0 425 79 512 192 512s192-87 192-211.5c0-79.9-80.2-199.6-192-300.5zm0 448c-56.5 0-96-39-96-94.8 0-13.5 4.6-61.5 96-161.2 91.4 99.7 96 147.7 96 161.2 0 55.8-39.5 94.8-96 94.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBusAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488 128h-8V80c0-44.8-99.2-80-224-80S32 35.2 32 80v48h-8c-13.25 0-24 10.74-24 24v80c0 13.25 10.75 24 24 24h8v160c0 17.67 14.33 32 32 32v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h192v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h6.4c16 0 25.6-12.8 25.6-25.6V256h8c13.25 0 24-10.75 24-24v-80c0-13.26-10.75-24-24-24zM160 72c0-4.42 3.58-8 8-8h176c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H168c-4.42 0-8-3.58-8-8V72zm-48 328c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm128-112H128c-17.67 0-32-14.33-32-32v-96c0-17.67 14.33-32 32-32h112v160zm32 0V128h112c17.67 0 32 14.33 32 32v96c0 17.67-14.33 32-32 32H272zm128 112c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488 128h-8V80c0-44.8-99.2-80-224-80S32 35.2 32 80v48h-8c-13.25 0-24 10.74-24 24v80c0 13.25 10.75 24 24 24h8v160c0 17.67 14.33 32 32 32v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h192v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h6.4c16 0 25.6-12.8 25.6-25.6V256h8c13.25 0 24-10.75 24-24v-80c0-13.26-10.75-24-24-24zM112 400c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm16-112c-17.67 0-32-14.33-32-32V128c0-17.67 14.33-32 32-32h256c17.67 0 32 14.33 32 32v128c0 17.67-14.33 32-32 32H128zm272 112c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaBusinessTime(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 224c-79.59 0-144 64.41-144 144s64.41 144 144 144 144-64.41 144-144-64.41-144-144-144zm64 150.29c0 5.34-4.37 9.71-9.71 9.71h-60.57c-5.34 0-9.71-4.37-9.71-9.71v-76.57c0-5.34 4.37-9.71 9.71-9.71h12.57c5.34 0 9.71 4.37 9.71 9.71V352h38.29c5.34 0 9.71 4.37 9.71 9.71v12.58zM496 192c5.4 0 10.72.33 16 .81V144c0-25.6-22.4-48-48-48h-80V48c0-25.6-22.4-48-48-48H176c-25.6 0-48 22.4-48 48v48H48c-25.6 0-48 22.4-48 48v80h395.12c28.6-20.09 63.35-32 100.88-32zM320 96H192V64h128v32zm6.82 224H208c-8.84 0-16-7.16-16-16v-48H0v144c0 25.6 22.4 48 48 48h291.43C327.1 423.96 320 396.82 320 368c0-16.66 2.48-32.72 6.82-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCalculator(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 0H48C22.4 0 0 22.4 0 48v416c0 25.6 22.4 48 48 48h352c25.6 0 48-22.4 48-48V48c0-25.6-22.4-48-48-48zM128 435.2c0 6.4-6.4 12.8-12.8 12.8H76.8c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm0-128c0 6.4-6.4 12.8-12.8 12.8H76.8c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm128 128c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm0-128c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm128 128c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8V268.8c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v166.4zm0-256c0 6.4-6.4 12.8-12.8 12.8H76.8c-6.4 0-12.8-6.4-12.8-12.8V76.8C64 70.4 70.4 64 76.8 64h294.4c6.4 0 12.8 6.4 12.8 12.8v102.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCalendarAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm320-196c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zM192 268c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zM64 268c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCalendarCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M436 160H12c-6.627 0-12-5.373-12-12v-36c0-26.51 21.49-48 48-48h48V12c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v52h128V12c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v52h48c26.51 0 48 21.49 48 48v36c0 6.627-5.373 12-12 12zM12 192h424c6.627 0 12 5.373 12 12v260c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V204c0-6.627 5.373-12 12-12zm333.296 95.947l-28.169-28.398c-4.667-4.705-12.265-4.736-16.97-.068L194.12 364.665l-45.98-46.352c-4.667-4.705-12.266-4.736-16.971-.068l-28.397 28.17c-4.705 4.667-4.736 12.265-.068 16.97l82.601 83.269c4.667 4.705 12.265 4.736 16.97.068l142.953-141.805c4.705-4.667 4.736-12.265.068-16.97z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCalendarDay(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm64-192c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-96zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCalendarMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M436 160H12c-6.6 0-12-5.4-12-12v-36c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48v36c0 6.6-5.4 12-12 12zM12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm304 192c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12H132c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h184z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCalendarPlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M436 160H12c-6.6 0-12-5.4-12-12v-36c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48v36c0 6.6-5.4 12-12 12zM12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm316 140c0-6.6-5.4-12-12-12h-60v-60c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v60h-60c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h60v60c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-60h60c6.6 0 12-5.4 12-12v-40z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCalendarTimes(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M436 160H12c-6.6 0-12-5.4-12-12v-36c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48v36c0 6.6-5.4 12-12 12zM12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm257.3 160l48.1-48.1c4.7-4.7 4.7-12.3 0-17l-28.3-28.3c-4.7-4.7-12.3-4.7-17 0L224 306.7l-48.1-48.1c-4.7-4.7-12.3-4.7-17 0l-28.3 28.3c-4.7 4.7-4.7 12.3 0 17l48.1 48.1-48.1 48.1c-4.7 4.7-4.7 12.3 0 17l28.3 28.3c4.7 4.7 12.3 4.7 17 0l48.1-48.1 48.1 48.1c4.7 4.7 12.3 4.7 17 0l28.3-28.3c4.7-4.7 4.7-12.3 0-17L269.3 352z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCalendarWeek(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm64-192c0-8.8 7.2-16 16-16h288c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-64zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCalendar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm436-44v-36c0-26.5-21.5-48-48-48h-48V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H160V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H48C21.5 64 0 85.5 0 112v36c0 6.6 5.4 12 12 12h424c6.6 0 12-5.4 12-12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCameraRetro(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 32C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H48zm0 32h106c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H38c-3.3 0-6-2.7-6-6V80c0-8.8 7.2-16 16-16zm426 96H38c-3.3 0-6-2.7-6-6v-36c0-3.3 2.7-6 6-6h138l30.2-45.3c1.1-1.7 3-2.7 5-2.7H464c8.8 0 16 7.2 16 16v74c0 3.3-2.7 6-6 6zM256 424c-66.2 0-120-53.8-120-120s53.8-120 120-120 120 53.8 120 120-53.8 120-120 120zm0-208c-48.5 0-88 39.5-88 88s39.5 88 88 88 88-39.5 88-88-39.5-88-88-88zm-48 104c-8.8 0-16-7.2-16-16 0-35.3 28.7-64 64-64 8.8 0 16 7.2 16 16s-7.2 16-16 16c-17.6 0-32 14.4-32 32 0 8.8-7.2 16-16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCamera(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 144v288c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48h88l12.3-32.9c7-18.7 24.9-31.1 44.9-31.1h125.5c20 0 37.9 12.4 44.9 31.1L376 96h88c26.5 0 48 21.5 48 48zM376 288c0-66.2-53.8-120-120-120s-120 53.8-120 120 53.8 120 120 120 120-53.8 120-120zm-32 0c0 48.5-39.5 88-88 88s-88-39.5-88-88 39.5-88 88-88 88 39.5 88 88z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCampground(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 448h-24.68L359.54 117.75l53.41-73.55c5.19-7.15 3.61-17.16-3.54-22.35l-25.9-18.79c-7.15-5.19-17.15-3.61-22.35 3.55L320 63.3 278.83 6.6c-5.19-7.15-15.2-8.74-22.35-3.55l-25.88 18.8c-7.15 5.19-8.74 15.2-3.54 22.35l53.41 73.55L40.68 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM320 288l116.36 160H203.64L320 288z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCandyCane(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M497.5 92C469.6 33.1 411.8 0 352.4 0c-27.9 0-56.2 7.3-81.8 22.6L243.1 39c-15.2 9.1-20.1 28.7-11 43.9l32.8 54.9c6 10 16.6 15.6 27.5 15.6 5.6 0 11.2-1.5 16.4-4.5l27.5-16.4c5.1-3.1 10.8-4.5 16.4-4.5 10.9 0 21.5 5.6 27.5 15.6 9.1 15.1 4.1 34.8-11 43.9L15.6 397.6c-15.2 9.1-20.1 28.7-11 43.9l32.8 54.9c6 10 16.6 15.6 27.5 15.6 5.6 0 11.2-1.5 16.4-4.5L428.6 301c71.7-42.9 104.6-133.5 68.9-209zm-177.7 13l-2.5 1.5L296.8 45c9.7-4.7 19.8-8.1 30.3-10.2l20.6 61.8c-9.8.8-19.4 3.3-27.9 8.4zM145.9 431.8l-60.5-38.5 30.8-18.3 60.5 38.5-30.8 18.3zm107.5-63.9l-60.5-38.5 30.8-18.3 60.5 38.5-30.8 18.3zM364.3 302l-60.5-38.5 30.8-18.3 60.5 38.5-30.8 18.3zm20.4-197.3l46-46c8.4 6.5 16 14.1 22.6 22.6L407.6 127c-5.7-9.3-13.7-16.9-22.9-22.3zm82.1 107.8l-59.5-19.8c3.2-5.3 5.8-10.9 7.4-17.1 1.1-4.5 1.7-9.1 1.8-13.6l60.4 20.1c-2.1 10.4-5.5 20.6-10.1 30.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCannabis(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M503.47 360.25c-1.56-.82-32.39-16.89-76.78-25.81 64.25-75.12 84.05-161.67 84.93-165.64 1.18-5.33-.44-10.9-4.3-14.77-3.03-3.04-7.12-4.7-11.32-4.7-1.14 0-2.29.12-3.44.38-3.88.85-86.54 19.59-160.58 79.76.01-1.46.01-2.93.01-4.4 0-118.79-59.98-213.72-62.53-217.7A15.973 15.973 0 0 0 256 0c-5.45 0-10.53 2.78-13.47 7.37-2.55 3.98-62.53 98.91-62.53 217.7 0 1.47.01 2.94.01 4.4-74.03-60.16-156.69-78.9-160.58-79.76-1.14-.25-2.29-.38-3.44-.38-4.2 0-8.29 1.66-11.32 4.7A15.986 15.986 0 0 0 .38 168.8c.88 3.97 20.68 90.52 84.93 165.64-44.39 8.92-75.21 24.99-76.78 25.81a16.003 16.003 0 0 0-.02 28.29c2.45 1.29 60.76 31.72 133.49 31.72 6.14 0 11.96-.1 17.5-.31-11.37 22.23-16.52 38.31-16.81 39.22-1.8 5.68-.29 11.89 3.91 16.11a16.019 16.019 0 0 0 16.1 3.99c1.83-.57 37.72-11.99 77.3-39.29V504c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-64.01c39.58 27.3 75.47 38.71 77.3 39.29a16.019 16.019 0 0 0 16.1-3.99c4.2-4.22 5.71-10.43 3.91-16.11-.29-.91-5.45-16.99-16.81-39.22 5.54.21 11.37.31 17.5.31 72.72 0 131.04-30.43 133.49-31.72 5.24-2.78 8.52-8.22 8.51-14.15-.01-5.94-3.29-11.39-8.53-14.15z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCapsules(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M555.3 300.1L424.2 112.8C401.9 81 366.4 64 330.4 64c-22.6 0-45.5 6.7-65.5 20.7-19.7 13.8-33.7 32.8-41.5 53.8C220.5 79.2 172 32 112 32 50.1 32 0 82.1 0 144v224c0 61.9 50.1 112 112 112s112-50.1 112-112V218.9c3.3 8.6 7.3 17.1 12.8 25L368 431.2c22.2 31.8 57.7 48.8 93.8 48.8 22.7 0 45.5-6.7 65.5-20.7 51.7-36.2 64.2-107.5 28-159.2zM160 256H64V144c0-26.5 21.5-48 48-48s48 21.5 48 48v112zm194.8 44.9l-65.6-93.7c-7.7-11-10.7-24.4-8.3-37.6 2.3-13.2 9.7-24.8 20.7-32.5 8.5-6 18.5-9.1 28.8-9.1 16.5 0 31.9 8 41.3 21.5l65.6 93.7-82.5 57.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCarAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 480 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M438.66 212.33l-11.24-28.1-19.93-49.83C390.38 91.63 349.57 64 303.5 64h-127c-46.06 0-86.88 27.63-103.99 70.4l-19.93 49.83-11.24 28.1C17.22 221.5 0 244.66 0 272v48c0 16.12 6.16 30.67 16 41.93V416c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h256v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-54.07c9.84-11.25 16-25.8 16-41.93v-48c0-27.34-17.22-50.5-41.34-59.67zm-306.73-54.16c7.29-18.22 24.94-30.17 44.57-30.17h127c19.63 0 37.28 11.95 44.57 30.17L368 208H112l19.93-49.83zM80 319.8c-19.2 0-32-12.76-32-31.9S60.8 256 80 256s48 28.71 48 47.85-28.8 15.95-48 15.95zm320 0c-19.2 0-48 3.19-48-15.95S380.8 256 400 256s32 12.76 32 31.9-12.8 31.9-32 31.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCarBattery(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 128h-32V80c0-8.84-7.16-16-16-16h-96c-8.84 0-16 7.16-16 16v48H192V80c0-8.84-7.16-16-16-16H80c-8.84 0-16 7.16-16 16v48H32c-17.67 0-32 14.33-32 32v256c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32V160c0-17.67-14.33-32-32-32zM192 264c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h112c4.42 0 8 3.58 8 8v16zm256 0c0 4.42-3.58 8-8 8h-40v40c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-40h-40c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h40v-40c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v40h40c4.42 0 8 3.58 8 8v16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCarCrash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M143.25 220.81l-12.42 46.37c-3.01 11.25-3.63 22.89-2.41 34.39l-35.2 28.98c-6.57 5.41-16.31-.43-14.62-8.77l15.44-76.68c1.06-5.26-2.66-10.28-8-10.79l-77.86-7.55c-8.47-.82-11.23-11.83-4.14-16.54l65.15-43.3c4.46-2.97 5.38-9.15 1.98-13.29L21.46 93.22c-5.41-6.57.43-16.3 8.78-14.62l76.68 15.44c5.26 1.06 10.28-2.66 10.8-8l7.55-77.86c.82-8.48 11.83-11.23 16.55-4.14l43.3 65.14c2.97 4.46 9.15 5.38 13.29 1.98l60.4-49.71c6.57-5.41 16.3.43 14.62 8.77L262.1 86.38c-2.71 3.05-5.43 6.09-7.91 9.4l-32.15 42.97-10.71 14.32c-32.73 8.76-59.18 34.53-68.08 67.74zm494.57 132.51l-12.42 46.36c-3.13 11.68-9.38 21.61-17.55 29.36a66.876 66.876 0 0 1-8.76 7l-13.99 52.23c-1.14 4.27-3.1 8.1-5.65 11.38-7.67 9.84-20.74 14.68-33.54 11.25L515 502.62c-17.07-4.57-27.2-22.12-22.63-39.19l8.28-30.91-247.28-66.26-8.28 30.91c-4.57 17.07-22.12 27.2-39.19 22.63l-30.91-8.28c-12.8-3.43-21.7-14.16-23.42-26.51-.57-4.12-.35-8.42.79-12.68l13.99-52.23a66.62 66.62 0 0 1-4.09-10.45c-3.2-10.79-3.65-22.52-.52-34.2l12.42-46.37c5.31-19.8 19.36-34.83 36.89-42.21a64.336 64.336 0 0 1 18.49-4.72l18.13-24.23 32.15-42.97c3.45-4.61 7.19-8.9 11.2-12.84 8-7.89 17.03-14.44 26.74-19.51 4.86-2.54 9.89-4.71 15.05-6.49 10.33-3.58 21.19-5.63 32.24-6.04 11.05-.41 22.31.82 33.43 3.8l122.68 32.87c11.12 2.98 21.48 7.54 30.85 13.43a111.11 111.11 0 0 1 34.69 34.5c8.82 13.88 14.64 29.84 16.68 46.99l6.36 53.29 3.59 30.05a64.49 64.49 0 0 1 22.74 29.93c4.39 11.88 5.29 25.19 1.75 38.39zM255.58 234.34c-18.55-4.97-34.21 4.04-39.17 22.53-4.96 18.49 4.11 34.12 22.65 39.09 18.55 4.97 45.54 15.51 50.49-2.98 4.96-18.49-15.43-53.67-33.97-58.64zm290.61 28.17l-6.36-53.29c-.58-4.87-1.89-9.53-3.82-13.86-5.8-12.99-17.2-23.01-31.42-26.82l-122.68-32.87a48.008 48.008 0 0 0-50.86 17.61l-32.15 42.97 172 46.08 75.29 20.18zm18.49 54.65c-18.55-4.97-53.8 15.31-58.75 33.79-4.95 18.49 23.69 22.86 42.24 27.83 18.55 4.97 34.21-4.04 39.17-22.53 4.95-18.48-4.11-34.12-22.66-39.09z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCarSide(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 192h-16L419.22 56.02A64.025 64.025 0 0 0 369.24 32H155.33c-26.17 0-49.7 15.93-59.42 40.23L48 194.26C20.44 201.4 0 226.21 0 256v112c0 8.84 7.16 16 16 16h48c0 53.02 42.98 96 96 96s96-42.98 96-96h128c0 53.02 42.98 96 96 96s96-42.98 96-96h48c8.84 0 16-7.16 16-16v-80c0-53.02-42.98-96-96-96zM160 432c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48zm72-240H116.93l38.4-96H232v96zm48 0V96h89.24l76.8 96H280zm200 240c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M499.99 176h-59.87l-16.64-41.6C406.38 91.63 365.57 64 319.5 64h-127c-46.06 0-86.88 27.63-103.99 70.4L71.87 176H12.01C4.2 176-1.53 183.34.37 190.91l6 24C7.7 220.25 12.5 224 18.01 224h20.07C24.65 235.73 16 252.78 16 272v48c0 16.12 6.16 30.67 16 41.93V416c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h256v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-54.07c9.84-11.25 16-25.8 16-41.93v-48c0-19.22-8.65-36.27-22.07-48H494c5.51 0 10.31-3.75 11.64-9.09l6-24c1.89-7.57-3.84-14.91-11.65-14.91zm-352.06-17.83c7.29-18.22 24.94-30.17 44.57-30.17h127c19.63 0 37.28 11.95 44.57 30.17L384 208H128l19.93-49.83zM96 319.8c-19.2 0-32-12.76-32-31.9S76.8 256 96 256s48 28.71 48 47.85-28.8 15.95-48 15.95zm320 0c-19.2 0-48 3.19-48-15.95S396.8 256 416 256s32 12.76 32 31.9-12.8 31.9-32 31.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCaravan(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416,208a16,16,0,1,0,16,16A16,16,0,0,0,416,208ZM624,320H576V160A160,160,0,0,0,416,0H64A64,64,0,0,0,0,64V320a64,64,0,0,0,64,64H96a96,96,0,0,0,192,0H624a16,16,0,0,0,16-16V336A16,16,0,0,0,624,320ZM192,432a48,48,0,1,1,48-48A48.05,48.05,0,0,1,192,432Zm64-240a32,32,0,0,1-32,32H96a32,32,0,0,1-32-32V128A32,32,0,0,1,96,96H224a32,32,0,0,1,32,32ZM448,320H320V128a32,32,0,0,1,32-32h64a32,32,0,0,1,32,32Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCaretDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCaretLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 192 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 127.338v257.324c0 17.818-21.543 26.741-34.142 14.142L29.196 270.142c-7.81-7.81-7.81-20.474 0-28.284l128.662-128.662c12.599-12.6 34.142-3.676 34.142 14.142z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCaretRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 192 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 384.662V127.338c0-17.818 21.543-26.741 34.142-14.142l128.662 128.662c7.81 7.81 7.81 20.474 0 28.284L34.142 398.804C21.543 411.404 0 402.48 0 384.662z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCaretSquareDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zM92.5 220.5l123 123c4.7 4.7 12.3 4.7 17 0l123-123c7.6-7.6 2.2-20.5-8.5-20.5H101c-10.7 0-16.1 12.9-8.5 20.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCaretSquareLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zM259.515 124.485l-123.03 123.03c-4.686 4.686-4.686 12.284 0 16.971l123.029 123.029c7.56 7.56 20.485 2.206 20.485-8.485V132.971c.001-10.691-12.925-16.045-20.484-8.486z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCaretSquareRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 32h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48zm140.485 355.515l123.029-123.029c4.686-4.686 4.686-12.284 0-16.971l-123.029-123.03c-7.56-7.56-20.485-2.206-20.485 8.485v246.059c0 10.691 12.926 16.045 20.485 8.486z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCaretSquareUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 432V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48zm355.515-140.485l-123.03-123.03c-4.686-4.686-12.284-4.686-16.971 0L92.485 291.515c-7.56 7.56-2.206 20.485 8.485 20.485h246.059c10.691 0 16.045-12.926 8.486-20.485z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCaretUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288.662 352H31.338c-17.818 0-26.741-21.543-14.142-34.142l128.662-128.662c7.81-7.81 20.474-7.81 28.284 0l128.662 128.662c12.6 12.599 3.676 34.142-14.142 34.142z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCarrot(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M298.2 156.6c-52.7-25.7-114.5-10.5-150.2 32.8l55.2 55.2c6.3 6.3 6.3 16.4 0 22.6-3.1 3.1-7.2 4.7-11.3 4.7s-8.2-1.6-11.3-4.7L130.4 217 2.3 479.7c-2.9 6-3.1 13.3 0 19.7 5.4 11.1 18.9 15.7 30 10.3l133.6-65.2-49.2-49.2c-6.3-6.2-6.3-16.4 0-22.6 6.3-6.2 16.4-6.2 22.6 0l57 57 102-49.8c24-11.7 44.5-31.3 57.1-57.1 30.1-61.7 4.5-136.1-57.2-166.2zm92.1-34.9C409.8 81 399.7 32.9 360 0c-50.3 41.7-52.5 107.5-7.9 151.9l8 8c44.4 44.6 110.3 42.4 151.9-7.9-32.9-39.7-81-49.8-121.7-30.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCartArrowDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504.717 320H211.572l6.545 32h268.418c15.401 0 26.816 14.301 23.403 29.319l-5.517 24.276C523.112 414.668 536 433.828 536 456c0 31.202-25.519 56.444-56.824 55.994-29.823-.429-54.35-24.631-55.155-54.447-.44-16.287 6.085-31.049 16.803-41.548H231.176C241.553 426.165 248 440.326 248 456c0 31.813-26.528 57.431-58.67 55.938-28.54-1.325-51.751-24.385-53.251-52.917-1.158-22.034 10.436-41.455 28.051-51.586L93.883 64H24C10.745 64 0 53.255 0 40V24C0 10.745 10.745 0 24 0h102.529c11.401 0 21.228 8.021 23.513 19.19L159.208 64H551.99c15.401 0 26.816 14.301 23.403 29.319l-47.273 208C525.637 312.246 515.923 320 504.717 320zM403.029 192H360v-60c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v60h-43.029c-10.691 0-16.045 12.926-8.485 20.485l67.029 67.029c4.686 4.686 12.284 4.686 16.971 0l67.029-67.029c7.559-7.559 2.205-20.485-8.486-20.485z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCartPlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504.717 320H211.572l6.545 32h268.418c15.401 0 26.816 14.301 23.403 29.319l-5.517 24.276C523.112 414.668 536 433.828 536 456c0 31.202-25.519 56.444-56.824 55.994-29.823-.429-54.35-24.631-55.155-54.447-.44-16.287 6.085-31.049 16.803-41.548H231.176C241.553 426.165 248 440.326 248 456c0 31.813-26.528 57.431-58.67 55.938-28.54-1.325-51.751-24.385-53.251-52.917-1.158-22.034 10.436-41.455 28.051-51.586L93.883 64H24C10.745 64 0 53.255 0 40V24C0 10.745 10.745 0 24 0h102.529c11.401 0 21.228 8.021 23.513 19.19L159.208 64H551.99c15.401 0 26.816 14.301 23.403 29.319l-47.273 208C525.637 312.246 515.923 320 504.717 320zM408 168h-48v-40c0-8.837-7.163-16-16-16h-16c-8.837 0-16 7.163-16 16v40h-48c-8.837 0-16 7.163-16 16v16c0 8.837 7.163 16 16 16h48v40c0 8.837 7.163 16 16 16h16c8.837 0 16-7.163 16-16v-40h48c8.837 0 16-7.163 16-16v-16c0-8.837-7.163-16-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCashRegister(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M511.1 378.8l-26.7-160c-2.6-15.4-15.9-26.7-31.6-26.7H208v-64h96c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96v64H59.1c-15.6 0-29 11.3-31.6 26.7L.8 378.7c-.6 3.5-.9 7-.9 10.5V480c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32v-90.7c.1-3.5-.2-7-.8-10.5zM280 248c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16zm-32 64h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16zm-32-80c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16zM80 80V48h192v32H80zm40 200h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16zm16 64v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16zm216 112c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h176c4.4 0 8 3.6 8 8v16zm24-112c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16zm48-80c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCat(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M290.59 192c-20.18 0-106.82 1.98-162.59 85.95V192c0-52.94-43.06-96-96-96-17.67 0-32 14.33-32 32s14.33 32 32 32c17.64 0 32 14.36 32 32v256c0 35.3 28.7 64 64 64h176c8.84 0 16-7.16 16-16v-16c0-17.67-14.33-32-32-32h-32l128-96v144c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V289.86c-10.29 2.67-20.89 4.54-32 4.54-61.81 0-113.52-44.05-125.41-102.4zM448 96h-64l-64-64v134.4c0 53.02 42.98 96 96 96s96-42.98 96-96V32l-64 64zm-72 80c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm80 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCertificate(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M458.622 255.92l45.985-45.005c13.708-12.977 7.316-36.039-10.664-40.339l-62.65-15.99 17.661-62.015c4.991-17.838-11.829-34.663-29.661-29.671l-61.994 17.667-15.984-62.671C337.085.197 313.765-6.276 300.99 7.228L256 53.57 211.011 7.229c-12.63-13.351-36.047-7.234-40.325 10.668l-15.984 62.671-61.995-17.667C74.87 57.907 58.056 74.738 63.046 92.572l17.661 62.015-62.65 15.99C.069 174.878-6.31 197.944 7.392 210.915l45.985 45.005-45.985 45.004c-13.708 12.977-7.316 36.039 10.664 40.339l62.65 15.99-17.661 62.015c-4.991 17.838 11.829 34.663 29.661 29.671l61.994-17.667 15.984 62.671c4.439 18.575 27.696 24.018 40.325 10.668L256 458.61l44.989 46.001c12.5 13.488 35.987 7.486 40.325-10.668l15.984-62.671 61.994 17.667c17.836 4.994 34.651-11.837 29.661-29.671l-17.661-62.015 62.65-15.99c17.987-4.302 24.366-27.367 10.664-40.339l-45.984-45.004z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChair(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112 128c0-29.5 16.2-55 40-68.9V256h48V48h48v208h48V59.1c23.8 13.9 40 39.4 40 68.9v128h48V128C384 57.3 326.7 0 256 0h-64C121.3 0 64 57.3 64 128v128h48zm334.3 213.9l-10.7-32c-4.4-13.1-16.6-21.9-30.4-21.9H42.7c-13.8 0-26 8.8-30.4 21.9l-10.7 32C-5.2 362.6 10.2 384 32 384v112c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V384h256v112c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V384c21.8 0 37.2-21.4 30.3-42.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChalkboardTeacher(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208 352c-2.39 0-4.78.35-7.06 1.09C187.98 357.3 174.35 360 160 360c-14.35 0-27.98-2.7-40.95-6.91-2.28-.74-4.66-1.09-7.05-1.09C49.94 352-.33 402.48 0 464.62.14 490.88 21.73 512 48 512h224c26.27 0 47.86-21.12 48-47.38.33-62.14-49.94-112.62-112-112.62zm-48-32c53.02 0 96-42.98 96-96s-42.98-96-96-96-96 42.98-96 96 42.98 96 96 96zM592 0H208c-26.47 0-48 22.25-48 49.59V96c23.42 0 45.1 6.78 64 17.8V64h352v288h-64v-64H384v64h-76.24c19.1 16.69 33.12 38.73 39.69 64H592c26.47 0 48-22.25 48-49.59V49.59C640 22.25 618.47 0 592 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChalkboard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 64h448v352h64V40c0-22.06-17.94-40-40-40H72C49.94 0 32 17.94 32 40v376h64V64zm528 384H480v-64H288v64H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChargingStation(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h320c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm208-320V80c0-8.84-7.16-16-16-16s-16 7.16-16 16v48h-32V80c0-8.84-7.16-16-16-16s-16 7.16-16 16v48h-16c-8.84 0-16 7.16-16 16v32c0 35.76 23.62 65.69 56 75.93v118.49c0 13.95-9.5 26.92-23.26 29.19C431.22 402.5 416 388.99 416 372v-28c0-48.6-39.4-88-88-88h-8V64c0-35.35-28.65-64-64-64H96C60.65 0 32 28.65 32 64v352h288V304h8c22.09 0 40 17.91 40 40v24.61c0 39.67 28.92 75.16 68.41 79.01C481.71 452.05 520 416.41 520 372V251.93c32.38-10.24 56-40.17 56-75.93v-32c0-8.84-7.16-16-16-16h-16zm-283.91 47.76l-93.7 139c-2.2 3.33-6.21 5.24-10.39 5.24-7.67 0-13.47-6.28-11.67-12.92L167.35 224H108c-7.25 0-12.85-5.59-11.89-11.89l16-107C112.9 99.9 117.98 96 124 96h68c7.88 0 13.62 6.54 11.6 13.21L192 160h57.7c9.24 0 15.01 8.78 10.39 15.76z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChartArea(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M500 384c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12V76c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v308h436zM372.7 159.5L288 216l-85.3-113.7c-5.1-6.8-15.5-6.3-19.9 1L96 248v104h384l-89.9-187.8c-3.2-6.5-11.4-8.7-17.4-4.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChartBar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M332.8 320h38.4c6.4 0 12.8-6.4 12.8-12.8V172.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v134.4c0 6.4 6.4 12.8 12.8 12.8zm96 0h38.4c6.4 0 12.8-6.4 12.8-12.8V76.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v230.4c0 6.4 6.4 12.8 12.8 12.8zm-288 0h38.4c6.4 0 12.8-6.4 12.8-12.8v-70.4c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v70.4c0 6.4 6.4 12.8 12.8 12.8zm96 0h38.4c6.4 0 12.8-6.4 12.8-12.8V108.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v198.4c0 6.4 6.4 12.8 12.8 12.8zM496 384H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v336c0 17.67 14.33 32 32 32h464c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChartLine(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 384H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v336c0 17.67 14.33 32 32 32h464c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM464 96H345.94c-21.38 0-32.09 25.85-16.97 40.97l32.4 32.4L288 242.75l-73.37-73.37c-12.5-12.5-32.76-12.5-45.25 0l-68.69 68.69c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0L192 237.25l73.37 73.37c12.5 12.5 32.76 12.5 45.25 0l96-96 32.4 32.4c15.12 15.12 40.97 4.41 40.97-16.97V112c.01-8.84-7.15-16-15.99-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChartPie(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 544 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M527.79 288H290.5l158.03 158.03c6.04 6.04 15.98 6.53 22.19.68 38.7-36.46 65.32-85.61 73.13-140.86 1.34-9.46-6.51-17.85-16.06-17.85zm-15.83-64.8C503.72 103.74 408.26 8.28 288.8.04 279.68-.59 272 7.1 272 16.24V240h223.77c9.14 0 16.82-7.68 16.19-16.8zM224 288V50.71c0-9.55-8.39-17.4-17.84-16.06C86.99 51.49-4.1 155.6.14 280.37 4.5 408.51 114.83 513.59 243.03 511.98c50.4-.63 96.97-16.87 135.26-44.03 7.9-5.6 8.42-17.23 1.57-24.08L224 288z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCheckCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCheckDouble(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M505 174.8l-39.6-39.6c-9.4-9.4-24.6-9.4-33.9 0L192 374.7 80.6 263.2c-9.4-9.4-24.6-9.4-33.9 0L7 302.9c-9.4 9.4-9.4 24.6 0 34L175 505c9.4 9.4 24.6 9.4 33.9 0l296-296.2c9.4-9.5 9.4-24.7.1-34zm-324.3 106c6.2 6.3 16.4 6.3 22.6 0l208-208.2c6.2-6.3 6.2-16.4 0-22.6L366.1 4.7c-6.2-6.3-16.4-6.3-22.6 0L192 156.2l-55.4-55.5c-6.2-6.3-16.4-6.3-22.6 0L68.7 146c-6.2 6.3-6.2 16.4 0 22.6l112 112.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCheckSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zm-204.686-98.059l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.248-16.379-6.249-22.628 0L184 302.745l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.25 16.379 6.25 22.628.001z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCheese(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 288v160a32 32 0 0 0 32 32h448a32 32 0 0 0 32-32V288zM299.83 32a32 32 0 0 0-21.13 7L0 256h512c0-119.89-94-217.8-212.17-224z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChessBishop(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 287.88c0 51.64 22.14 73.83 56 84.6V416h192v-43.52c33.86-10.77 56-33 56-84.6 0-30.61-10.73-67.1-26.69-102.56L185 285.65a8 8 0 0 1-11.31 0l-11.31-11.31a8 8 0 0 1 0-11.31L270.27 155.1c-20.8-37.91-46.47-72.1-70.87-92.59C213.4 59.09 224 47.05 224 32a32 32 0 0 0-32-32h-64a32 32 0 0 0-32 32c0 15 10.6 27.09 24.6 30.51C67.81 106.8 8 214.5 8 287.88zM304 448H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChessBoard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M255.9.2h-64v64h64zM0 64.17v64h64v-64zM128 .2H64v64h64zm64 255.9v64h64v-64zM0 192.12v64h64v-64zM383.85.2h-64v64h64zm128 0h-64v64h64zM128 256.1H64v64h64zM511.8 448v-64h-64v64zm0-128v-64h-64v64zM383.85 512h64v-64h-64zm128-319.88v-64h-64v64zM128 512h64v-64h-64zM0 512h64v-64H0zm255.9 0h64v-64h-64zM0 320.07v64h64v-64zm319.88-191.92v-64h-64v64zm-64 128h64v-64h-64zm-64 128v64h64v-64zm128-64h64v-64h-64zm0-127.95h64v-64h-64zm0 191.93v64h64v-64zM64 384.05v64h64v-64zm128-255.9v-64h-64v64zm191.92 255.9h64v-64h-64zm-128-191.93v-64h-64v64zm128-127.95v64h64v-64zm-128 255.9v64h64v-64zm-64-127.95H128v64h64zm191.92 64h64v-64h-64zM128 128.15H64v64h64zm0 191.92v64h64v-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChessKing(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 448H48a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm16-288H256v-48h40a8 8 0 0 0 8-8V56a8 8 0 0 0-8-8h-40V8a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v40h-40a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h40v48H32a32 32 0 0 0-30.52 41.54L74.56 416h298.88l73.08-214.46A32 32 0 0 0 416 160z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChessKnight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 272.47l40.63 18.06a32 32 0 0 0 24.88.47l12.78-5.12a32 32 0 0 0 18.76-20.5l9.22-30.65a24 24 0 0 1 12.55-15.65L159.94 208v50.33a48 48 0 0 1-26.53 42.94l-57.22 28.65A80 80 0 0 0 32 401.48V416h319.86V224c0-106-85.92-192-191.92-192H12A12 12 0 0 0 0 44a16.9 16.9 0 0 0 1.79 7.58L16 80l-9 9a24 24 0 0 0-7 17v137.21a32 32 0 0 0 19 29.26zM52 128a20 20 0 1 1-20 20 20 20 0 0 1 20-20zm316 320H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChessPawn(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M105.1 224H80a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h16v5.49c0 44-4.14 86.6-24 122.51h176c-19.89-35.91-24-78.51-24-122.51V288h16a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-25.1c29.39-18.38 49.1-50.78 49.1-88a104 104 0 0 0-208 0c0 37.22 19.71 69.62 49.1 88zM304 448H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChessQueen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 112a56 56 0 1 0-56-56 56 56 0 0 0 56 56zm176 336H80a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm72.87-263.84l-28.51-15.92c-7.44-5-16.91-2.46-22.29 4.68a47.59 47.59 0 0 1-47.23 18.23C383.7 186.86 368 164.93 368 141.4a13.4 13.4 0 0 0-13.4-13.4h-38.77c-6 0-11.61 4-12.86 9.91a48 48 0 0 1-93.94 0c-1.25-5.92-6.82-9.91-12.86-9.91H157.4a13.4 13.4 0 0 0-13.4 13.4c0 25.69-19 48.75-44.67 50.49a47.5 47.5 0 0 1-41.54-19.15c-5.28-7.09-14.73-9.45-22.09-4.54l-28.57 16a16 16 0 0 0-5.44 20.47L104.24 416h303.52l102.55-211.37a16 16 0 0 0-5.44-20.47z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChessRook(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 32h-56a16 16 0 0 0-16 16v48h-48V48a16 16 0 0 0-16-16h-80a16 16 0 0 0-16 16v48H88.1V48a16 16 0 0 0-16-16H16A16 16 0 0 0 0 48v176l64 32c0 48.33-1.54 95-13.21 160h282.42C321.54 351 320 303.72 320 256l64-32V48a16 16 0 0 0-16-16zM224 320h-64v-64a32 32 0 0 1 64 0zm144 128H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChess(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M74 208H64a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h15.94A535.78 535.78 0 0 1 64 384h128a535.78 535.78 0 0 1-15.94-128H192a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16h-10l33.89-90.38a16 16 0 0 0-15-21.62H144V64h24a8 8 0 0 0 8-8V40a8 8 0 0 0-8-8h-24V8a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v24H88a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h24v32H55.09a16 16 0 0 0-15 21.62zm173.16 251.58L224 448v-16a16 16 0 0 0-16-16H48a16 16 0 0 0-16 16v16L8.85 459.58A16 16 0 0 0 0 473.89V496a16 16 0 0 0 16 16h224a16 16 0 0 0 16-16v-22.11a16 16 0 0 0-8.84-14.31zm92.77-157.78l-3.29 82.2h126.72l-3.29-82.21 24.6-20.79A32 32 0 0 0 496 256.54V198a6 6 0 0 0-6-6h-26.38a6 6 0 0 0-6 6v26h-24.71v-26a6 6 0 0 0-6-6H373.1a6 6 0 0 0-6 6v26h-24.71v-26a6 6 0 0 0-6-6H310a6 6 0 0 0-6 6v58.6a32 32 0 0 0 11.36 24.4zM384 304a16 16 0 0 1 32 0v32h-32zm119.16 155.58L480 448v-16a16 16 0 0 0-16-16H336a16 16 0 0 0-16 16v16l-23.15 11.58a16 16 0 0 0-8.85 14.31V496a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-22.11a16 16 0 0 0-8.84-14.31z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChevronCircleDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zM273 369.9l135.5-135.5c9.4-9.4 9.4-24.6 0-33.9l-17-17c-9.4-9.4-24.6-9.4-33.9 0L256 285.1 154.4 183.5c-9.4-9.4-24.6-9.4-33.9 0l-17 17c-9.4 9.4-9.4 24.6 0 33.9L239 369.9c9.4 9.4 24.6 9.4 34 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChevronCircleLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zM142.1 273l135.5 135.5c9.4 9.4 24.6 9.4 33.9 0l17-17c9.4-9.4 9.4-24.6 0-33.9L226.9 256l101.6-101.6c9.4-9.4 9.4-24.6 0-33.9l-17-17c-9.4-9.4-24.6-9.4-33.9 0L142.1 239c-9.4 9.4-9.4 24.6 0 34z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChevronCircleRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zm113.9 231L234.4 103.5c-9.4-9.4-24.6-9.4-33.9 0l-17 17c-9.4 9.4-9.4 24.6 0 33.9L285.1 256 183.5 357.6c-9.4 9.4-9.4 24.6 0 33.9l17 17c9.4 9.4 24.6 9.4 33.9 0L369.9 273c9.4-9.4 9.4-24.6 0-34z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChevronCircleUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 256C8 119 119 8 256 8s248 111 248 248-111 248-248 248S8 393 8 256zm231-113.9L103.5 277.6c-9.4 9.4-9.4 24.6 0 33.9l17 17c9.4 9.4 24.6 9.4 33.9 0L256 226.9l101.6 101.6c9.4 9.4 24.6 9.4 33.9 0l17-17c9.4-9.4 9.4-24.6 0-33.9L273 142.1c-9.4-9.4-24.6-9.4-34 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChevronDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChevronLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChevronRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChevronUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M240.971 130.524l194.343 194.343c9.373 9.373 9.373 24.569 0 33.941l-22.667 22.667c-9.357 9.357-24.522 9.375-33.901.04L224 227.495 69.255 381.516c-9.379 9.335-24.544 9.317-33.901-.04l-22.667-22.667c-9.373-9.373-9.373-24.569 0-33.941L207.03 130.525c9.372-9.373 24.568-9.373 33.941-.001z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChild(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M120 72c0-39.765 32.235-72 72-72s72 32.235 72 72c0 39.764-32.235 72-72 72s-72-32.236-72-72zm254.627 1.373c-12.496-12.497-32.758-12.497-45.254 0L242.745 160H141.254L54.627 73.373c-12.496-12.497-32.758-12.497-45.254 0-12.497 12.497-12.497 32.758 0 45.255L104 213.254V480c0 17.673 14.327 32 32 32h16c17.673 0 32-14.327 32-32V368h16v112c0 17.673 14.327 32 32 32h16c17.673 0 32-14.327 32-32V213.254l94.627-94.627c12.497-12.497 12.497-32.757 0-45.254z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaChurch(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464.46 246.68L352 179.2V128h48c8.84 0 16-7.16 16-16V80c0-8.84-7.16-16-16-16h-48V16c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v48h-48c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h48v51.2l-112.46 67.48A31.997 31.997 0 0 0 160 274.12V512h96v-96c0-35.35 28.65-64 64-64s64 28.65 64 64v96h96V274.12c0-11.24-5.9-21.66-15.54-27.44zM0 395.96V496c0 8.84 7.16 16 16 16h112V320L19.39 366.54A32.024 32.024 0 0 0 0 395.96zm620.61-29.42L512 320v192h112c8.84 0 16-7.16 16-16V395.96c0-12.8-7.63-24.37-19.39-29.42z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCircleNotch(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 39.056v16.659c0 10.804 7.281 20.159 17.686 23.066C383.204 100.434 440 171.518 440 256c0 101.689-82.295 184-184 184-101.689 0-184-82.295-184-184 0-84.47 56.786-155.564 134.312-177.219C216.719 75.874 224 66.517 224 55.712V39.064c0-15.709-14.834-27.153-30.046-23.234C86.603 43.482 7.394 141.206 8.003 257.332c.72 137.052 111.477 246.956 248.531 246.667C393.255 503.711 504 392.788 504 256c0-115.633-79.14-212.779-186.211-240.236C302.678 11.889 288 23.456 288 39.056z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCity(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M616 192H480V24c0-13.26-10.74-24-24-24H312c-13.26 0-24 10.74-24 24v72h-64V16c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v80h-64V16c0-8.84-7.16-16-16-16H80c-8.84 0-16 7.16-16 16v80H24c-13.26 0-24 10.74-24 24v360c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V216c0-13.26-10.75-24-24-24zM128 404c0 6.63-5.37 12-12 12H76c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12H76c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12H76c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm128 192c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm160 96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12V76c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm160 288c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaClinicMedical(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 115L69.47 307.71c-1.62 1.46-3.69 2.14-5.47 3.35V496a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V311.1c-1.7-1.16-3.72-1.82-5.26-3.2zm96 261a8 8 0 0 1-8 8h-56v56a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8v-56h-56a8 8 0 0 1-8-8v-48a8 8 0 0 1 8-8h56v-56a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v56h56a8 8 0 0 1 8 8zm186.69-139.72l-255.94-226a39.85 39.85 0 0 0-53.45 0l-256 226a16 16 0 0 0-1.21 22.6L25.5 282.7a16 16 0 0 0 22.6 1.21L277.42 81.63a16 16 0 0 1 21.17 0L527.91 283.9a16 16 0 0 0 22.6-1.21l21.4-23.82a16 16 0 0 0-1.22-22.59z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaClipboardCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 40c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm121.2 231.8l-143 141.8c-4.7 4.7-12.3 4.6-17-.1l-82.6-83.3c-4.7-4.7-4.6-12.3.1-17L99.1 285c4.7-4.7 12.3-4.6 17 .1l46 46.4 106-105.2c4.7-4.7 12.3-4.6 17 .1l28.2 28.4c4.7 4.8 4.6 12.3-.1 17z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaClipboardList(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM96 424c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm0-96c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm0-96c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm96-192c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm128 368c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaClipboard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 112v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h80c0-35.29 28.71-64 64-64s64 28.71 64 64h80c26.51 0 48 21.49 48 48zM192 40c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24m96 114v-20a6 6 0 0 0-6-6H102a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6h180a6 6 0 0 0 6-6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaClock(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256,8C119,8,8,119,8,256S119,504,256,504,504,393,504,256,393,8,256,8Zm92.49,313h0l-20,25a16,16,0,0,1-22.49,2.5h0l-67-49.72a40,40,0,0,1-15-31.23V112a16,16,0,0,1,16-16h32a16,16,0,0,1,16,16V256l58,42.5A16,16,0,0,1,348.49,321Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaClone(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 0c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48H176c-26.51 0-48-21.49-48-48V48c0-26.51 21.49-48 48-48h288M176 416c-44.112 0-80-35.888-80-80V128H48c-26.51 0-48 21.49-48 48v288c0 26.51 21.49 48 48 48h288c26.51 0 48-21.49 48-48v-48H176z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaClosedCaptioning(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM218.1 287.7c2.8-2.5 7.1-2.1 9.2.9l19.5 27.7c1.7 2.4 1.5 5.6-.5 7.7-53.6 56.8-172.8 32.1-172.8-67.9 0-97.3 121.7-119.5 172.5-70.1 2.1 2 2.5 3.2 1 5.7l-17.5 30.5c-1.9 3.1-6.2 4-9.1 1.7-40.8-32-94.6-14.9-94.6 31.2.1 48 51.1 70.5 92.3 32.6zm190.4 0c2.8-2.5 7.1-2.1 9.2.9l19.5 27.7c1.7 2.4 1.5 5.6-.5 7.7-53.5 56.9-172.7 32.1-172.7-67.9 0-97.3 121.7-119.5 172.5-70.1 2.1 2 2.5 3.2 1 5.7L420 222.2c-1.9 3.1-6.2 4-9.1 1.7-40.8-32-94.6-14.9-94.6 31.2 0 48 51 70.5 92.2 32.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCloudDownloadAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4zm-132.9 88.7L299.3 420.7c-6.2 6.2-16.4 6.2-22.6 0L171.3 315.3c-10.1-10.1-2.9-27.3 11.3-27.3H248V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v112h65.4c14.2 0 21.4 17.2 11.3 27.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCloudMeatball(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 352c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm416 0c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm-119 11.1c4.6-14.5 1.6-30.8-9.8-42.3-11.5-11.5-27.8-14.4-42.3-9.9-7-13.5-20.7-23-36.9-23s-29.9 9.5-36.9 23c-14.5-4.6-30.8-1.6-42.3 9.9-11.5 11.5-14.4 27.8-9.9 42.3-13.5 7-23 20.7-23 36.9s9.5 29.9 23 36.9c-4.6 14.5-1.6 30.8 9.9 42.3 8.2 8.2 18.9 12.3 29.7 12.3 4.3 0 8.5-1.1 12.6-2.5 7 13.5 20.7 23 36.9 23s29.9-9.5 36.9-23c4.1 1.3 8.3 2.5 12.6 2.5 10.8 0 21.5-4.1 29.7-12.3 11.5-11.5 14.4-27.8 9.8-42.3 13.5-7 23-20.7 23-36.9s-9.5-29.9-23-36.9zM512 224c0-53-43-96-96-96-.6 0-1.1.2-1.6.2 1.1-5.2 1.6-10.6 1.6-16.2 0-44.2-35.8-80-80-80-24.6 0-46.3 11.3-61 28.8C256.4 24.8 219.3 0 176 0 114.1 0 64 50.1 64 112c0 7.3.8 14.3 2.1 21.2C27.8 145.8 0 181.5 0 224c0 53 43 96 96 96h43.4c3.6-8 8.4-15.4 14.8-21.8 13.5-13.5 31.5-21.1 50.8-21.3 13.5-13.2 31.7-20.9 51-20.9s37.5 7.7 51 20.9c19.3.2 37.3 7.8 50.8 21.3 6.4 6.4 11.3 13.8 14.8 21.8H416c53 0 96-43 96-96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCloudMoonRain(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M350.5 225.5c-6.9-37.2-39.3-65.5-78.5-65.5-12.3 0-23.9 3-34.3 8-17.4-24.1-45.6-40-77.7-40-53 0-96 43-96 96 0 .5.2 1.1.2 1.6C27.6 232.9 0 265.2 0 304c0 44.2 35.8 80 80 80h256c44.2 0 80-35.8 80-80 0-39.2-28.2-71.7-65.5-78.5zm217.4-1.7c-70.4 13.3-135-40.3-135-110.8 0-40.6 21.9-78 57.5-98.1 5.5-3.1 4.1-11.4-2.1-12.5C479.6.8 470.7 0 461.8 0c-77.9 0-141.1 61.2-144.4 137.9 26.7 11.9 48.2 33.8 58.9 61.7 37.1 14.3 64 47.4 70.2 86.8 5.1.5 10 1.5 15.2 1.5 44.7 0 85.6-20.2 112.6-53.3 4.2-4.8-.2-12-6.4-10.8zM364.5 418.1c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCloudMoon(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M342.8 352.7c5.7-9.6 9.2-20.7 9.2-32.7 0-35.3-28.7-64-64-64-17.2 0-32.8 6.9-44.3 17.9-16.3-29.6-47.5-49.9-83.7-49.9-53 0-96 43-96 96 0 2 .5 3.8.6 5.7C27.1 338.8 0 374.1 0 416c0 53 43 96 96 96h240c44.2 0 80-35.8 80-80 0-41.9-32.3-75.8-73.2-79.3zm222.5-54.3c-93.1 17.7-178.5-53.7-178.5-147.7 0-54.2 29-104 76.1-130.8 7.3-4.1 5.4-15.1-2.8-16.7C448.4 1.1 436.7 0 425 0 319.1 0 233.1 85.9 233.1 192c0 8.5.7 16.8 1.8 25 5.9 4.3 11.6 8.9 16.7 14.2 11.4-4.7 23.7-7.2 36.4-7.2 52.9 0 96 43.1 96 96 0 3.6-.2 7.2-.6 10.7 23.6 10.8 42.4 29.5 53.5 52.6 54.4-3.4 103.7-29.3 137.1-70.4 5.3-6.5-.5-16.1-8.7-14.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCloudRain(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 128c-.6 0-1.1.2-1.6.2 1.1-5.2 1.6-10.6 1.6-16.2 0-44.2-35.8-80-80-80-24.6 0-46.3 11.3-61 28.8C256.4 24.8 219.3 0 176 0 114.1 0 64 50.1 64 112c0 7.3.8 14.3 2.1 21.2C27.8 145.8 0 181.5 0 224c0 53 43 96 96 96h320c53 0 96-43 96-96s-43-96-96-96zM88 374.2c-12.8 44.4-40 56.4-40 87.7 0 27.7 21.5 50.1 48 50.1s48-22.4 48-50.1c0-31.4-27.2-43.1-40-87.7-2.2-8.1-13.5-8.5-16 0zm160 0c-12.8 44.4-40 56.4-40 87.7 0 27.7 21.5 50.1 48 50.1s48-22.4 48-50.1c0-31.4-27.2-43.1-40-87.7-2.2-8.1-13.5-8.5-16 0zm160 0c-12.8 44.4-40 56.4-40 87.7 0 27.7 21.5 50.1 48 50.1s48-22.4 48-50.1c0-31.4-27.2-43.1-40-87.7-2.2-8.1-13.5-8.5-16 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCloudShowersHeavy(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M183.9 370.1c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm96 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm-192 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm384 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm-96 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zM416 128c-.6 0-1.1.2-1.6.2 1.1-5.2 1.6-10.6 1.6-16.2 0-44.2-35.8-80-80-80-24.6 0-46.3 11.3-61 28.8C256.4 24.8 219.3 0 176 0 114.2 0 64 50.1 64 112c0 7.3.8 14.3 2.1 21.2C27.8 145.8 0 181.5 0 224c0 53 43 96 96 96h320c53 0 96-43 96-96s-43-96-96-96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCloudSunRain(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M510.5 225.5c-6.9-37.2-39.3-65.5-78.5-65.5-12.3 0-23.9 3-34.3 8-17.4-24.1-45.6-40-77.7-40-53 0-96 43-96 96 0 .5.2 1.1.2 1.6C187.6 233 160 265.2 160 304c0 44.2 35.8 80 80 80h256c44.2 0 80-35.8 80-80 0-39.2-28.2-71.7-65.5-78.5zm-386.4 34.4c-37.4-37.4-37.4-98.3 0-135.8 34.6-34.6 89.1-36.8 126.7-7.4 20-12.9 43.6-20.7 69.2-20.7.7 0 1.3.2 2 .2l8.9-26.7c3.4-10.2-6.3-19.8-16.5-16.4l-75.3 25.1-35.5-71c-4.8-9.6-18.5-9.6-23.3 0l-35.5 71-75.3-25.1c-10.2-3.4-19.8 6.3-16.4 16.5l25.1 75.3-71 35.5c-9.6 4.8-9.6 18.5 0 23.3l71 35.5-25.1 75.3c-3.4 10.2 6.3 19.8 16.5 16.5l59.2-19.7c-.2-2.4-.7-4.7-.7-7.2 0-12.5 2.3-24.5 6.2-35.9-3.6-2.7-7.1-5.2-10.2-8.3zm69.8-58c4.3-24.5 15.8-46.4 31.9-64-9.8-6.2-21.4-9.9-33.8-9.9-35.3 0-64 28.7-64 64 0 18.7 8.2 35.4 21.1 47.1 11.3-15.9 26.6-28.9 44.8-37.2zm330.6 216.2c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCloudSun(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M575.2 325.7c.2-1.9.8-3.7.8-5.6 0-35.3-28.7-64-64-64-12.6 0-24.2 3.8-34.1 10-17.6-38.8-56.5-66-101.9-66-61.8 0-112 50.1-112 112 0 3 .7 5.8.9 8.7-49.6 3.7-88.9 44.7-88.9 95.3 0 53 43 96 96 96h272c53 0 96-43 96-96 0-42.1-27.2-77.4-64.8-90.4zm-430.4-22.6c-43.7-43.7-43.7-114.7 0-158.3 43.7-43.7 114.7-43.7 158.4 0 9.7 9.7 16.9 20.9 22.3 32.7 9.8-3.7 20.1-6 30.7-7.5L386 81.1c4-11.9-7.3-23.1-19.2-19.2L279 91.2 237.5 8.4C232-2.8 216-2.8 210.4 8.4L169 91.2 81.1 61.9C69.3 58 58 69.3 61.9 81.1l29.3 87.8-82.8 41.5c-11.2 5.6-11.2 21.5 0 27.1l82.8 41.4-29.3 87.8c-4 11.9 7.3 23.1 19.2 19.2l76.1-25.3c6.1-12.4 14-23.7 23.6-33.5-13.1-5.4-25.4-13.4-36-24zm-4.8-79.2c0 40.8 29.3 74.8 67.9 82.3 8-4.7 16.3-8.8 25.2-11.7 5.4-44.3 31-82.5 67.4-105C287.3 160.4 258 140 224 140c-46.3 0-84 37.6-84 83.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCloudUploadAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4zM393.4 288H328v112c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V288h-65.4c-14.3 0-21.4-17.2-11.3-27.3l105.4-105.4c6.2-6.2 16.4-6.2 22.6 0l105.4 105.4c10.1 10.1 2.9 27.3-11.3 27.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCloud(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCocktail(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M296 464h-56V338.78l168.74-168.73c15.52-15.52 4.53-42.05-17.42-42.05H24.68c-21.95 0-32.94 26.53-17.42 42.05L176 338.78V464h-56c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h240c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40zM432 0c-62.61 0-115.35 40.2-135.18 96h52.54c16.65-28.55 47.27-48 82.64-48 52.93 0 96 43.06 96 96s-43.07 96-96 96c-14.04 0-27.29-3.2-39.32-8.64l-35.26 35.26C379.23 279.92 404.59 288 432 288c79.53 0 144-64.47 144-144S511.53 0 432 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCodeBranch(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 144c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 36.4 24.3 67.1 57.5 76.8-.6 16.1-4.2 28.5-11 36.9-15.4 19.2-49.3 22.4-85.2 25.7-28.2 2.6-57.4 5.4-81.3 16.9v-144c32.5-10.2 56-40.5 56-76.3 0-44.2-35.8-80-80-80S0 35.8 0 80c0 35.8 23.5 66.1 56 76.3v199.3C23.5 365.9 0 396.2 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-34-21.2-63.1-51.2-74.6 3.1-5.2 7.8-9.8 14.9-13.4 16.2-8.2 40.4-10.4 66.1-12.8 42.2-3.9 90-8.4 118.2-43.4 14-17.4 21.1-39.8 21.6-67.9 31.6-10.8 54.4-40.7 54.4-75.9zM80 64c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16 7.2-16 16-16zm0 384c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm224-320c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16 7.2-16 16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCode(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M278.9 511.5l-61-17.7c-6.4-1.8-10-8.5-8.2-14.9L346.2 8.7c1.8-6.4 8.5-10 14.9-8.2l61 17.7c6.4 1.8 10 8.5 8.2 14.9L293.8 503.3c-1.9 6.4-8.5 10.1-14.9 8.2zm-114-112.2l43.5-46.4c4.6-4.9 4.3-12.7-.8-17.2L117 256l90.6-79.7c5.1-4.5 5.5-12.3.8-17.2l-43.5-46.4c-4.5-4.8-12.1-5.1-17-.5L3.8 247.2c-5.1 4.7-5.1 12.8 0 17.5l144.1 135.1c4.9 4.6 12.5 4.4 17-.5zm327.2.6l144.1-135.1c5.1-4.7 5.1-12.8 0-17.5L492.1 112.1c-4.8-4.5-12.4-4.3-17 .5L431.6 159c-4.6 4.9-4.3 12.7.8 17.2L523 256l-90.6 79.7c-5.1 4.5-5.5 12.3-.8 17.2l43.5 46.4c4.5 4.9 12.1 5.1 17 .6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCoffee(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 384h192c53 0 96-43 96-96h32c70.6 0 128-57.4 128-128S582.6 32 512 32H120c-13.3 0-24 10.7-24 24v232c0 53 43 96 96 96zM512 96c35.3 0 64 28.7 64 64s-28.7 64-64 64h-32V96h32zm47.7 384H48.3c-47.6 0-61-64-36-64h583.3c25 0 11.8 64-35.9 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCog(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M487.4 315.7l-42.6-24.6c4.3-23.2 4.3-47 0-70.2l42.6-24.6c4.9-2.8 7.1-8.6 5.5-14-11.1-35.6-30-67.8-54.7-94.6-3.8-4.1-10-5.1-14.8-2.3L380.8 110c-17.9-15.4-38.5-27.3-60.8-35.1V25.8c0-5.6-3.9-10.5-9.4-11.7-36.7-8.2-74.3-7.8-109.2 0-5.5 1.2-9.4 6.1-9.4 11.7V75c-22.2 7.9-42.8 19.8-60.8 35.1L88.7 85.5c-4.9-2.8-11-1.9-14.8 2.3-24.7 26.7-43.6 58.9-54.7 94.6-1.7 5.4.6 11.2 5.5 14L67.3 221c-4.3 23.2-4.3 47 0 70.2l-42.6 24.6c-4.9 2.8-7.1 8.6-5.5 14 11.1 35.6 30 67.8 54.7 94.6 3.8 4.1 10 5.1 14.8 2.3l42.6-24.6c17.9 15.4 38.5 27.3 60.8 35.1v49.2c0 5.6 3.9 10.5 9.4 11.7 36.7 8.2 74.3 7.8 109.2 0 5.5-1.2 9.4-6.1 9.4-11.7v-49.2c22.2-7.9 42.8-19.8 60.8-35.1l42.6 24.6c4.9 2.8 11 1.9 14.8-2.3 24.7-26.7 43.6-58.9 54.7-94.6 1.5-5.5-.7-11.3-5.6-14.1zM256 336c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCogs(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512.1 191l-8.2 14.3c-3 5.3-9.4 7.5-15.1 5.4-11.8-4.4-22.6-10.7-32.1-18.6-4.6-3.8-5.8-10.5-2.8-15.7l8.2-14.3c-6.9-8-12.3-17.3-15.9-27.4h-16.5c-6 0-11.2-4.3-12.2-10.3-2-12-2.1-24.6 0-37.1 1-6 6.2-10.4 12.2-10.4h16.5c3.6-10.1 9-19.4 15.9-27.4l-8.2-14.3c-3-5.2-1.9-11.9 2.8-15.7 9.5-7.9 20.4-14.2 32.1-18.6 5.7-2.1 12.1.1 15.1 5.4l8.2 14.3c10.5-1.9 21.2-1.9 31.7 0L552 6.3c3-5.3 9.4-7.5 15.1-5.4 11.8 4.4 22.6 10.7 32.1 18.6 4.6 3.8 5.8 10.5 2.8 15.7l-8.2 14.3c6.9 8 12.3 17.3 15.9 27.4h16.5c6 0 11.2 4.3 12.2 10.3 2 12 2.1 24.6 0 37.1-1 6-6.2 10.4-12.2 10.4h-16.5c-3.6 10.1-9 19.4-15.9 27.4l8.2 14.3c3 5.2 1.9 11.9-2.8 15.7-9.5 7.9-20.4 14.2-32.1 18.6-5.7 2.1-12.1-.1-15.1-5.4l-8.2-14.3c-10.4 1.9-21.2 1.9-31.7 0zm-10.5-58.8c38.5 29.6 82.4-14.3 52.8-52.8-38.5-29.7-82.4 14.3-52.8 52.8zM386.3 286.1l33.7 16.8c10.1 5.8 14.5 18.1 10.5 29.1-8.9 24.2-26.4 46.4-42.6 65.8-7.4 8.9-20.2 11.1-30.3 5.3l-29.1-16.8c-16 13.7-34.6 24.6-54.9 31.7v33.6c0 11.6-8.3 21.6-19.7 23.6-24.6 4.2-50.4 4.4-75.9 0-11.5-2-20-11.9-20-23.6V418c-20.3-7.2-38.9-18-54.9-31.7L74 403c-10 5.8-22.9 3.6-30.3-5.3-16.2-19.4-33.3-41.6-42.2-65.7-4-10.9.4-23.2 10.5-29.1l33.3-16.8c-3.9-20.9-3.9-42.4 0-63.4L12 205.8c-10.1-5.8-14.6-18.1-10.5-29 8.9-24.2 26-46.4 42.2-65.8 7.4-8.9 20.2-11.1 30.3-5.3l29.1 16.8c16-13.7 34.6-24.6 54.9-31.7V57.1c0-11.5 8.2-21.5 19.6-23.5 24.6-4.2 50.5-4.4 76-.1 11.5 2 20 11.9 20 23.6v33.6c20.3 7.2 38.9 18 54.9 31.7l29.1-16.8c10-5.8 22.9-3.6 30.3 5.3 16.2 19.4 33.2 41.6 42.1 65.8 4 10.9.1 23.2-10 29.1l-33.7 16.8c3.9 21 3.9 42.5 0 63.5zm-117.6 21.1c59.2-77-28.7-164.9-105.7-105.7-59.2 77 28.7 164.9 105.7 105.7zm243.4 182.7l-8.2 14.3c-3 5.3-9.4 7.5-15.1 5.4-11.8-4.4-22.6-10.7-32.1-18.6-4.6-3.8-5.8-10.5-2.8-15.7l8.2-14.3c-6.9-8-12.3-17.3-15.9-27.4h-16.5c-6 0-11.2-4.3-12.2-10.3-2-12-2.1-24.6 0-37.1 1-6 6.2-10.4 12.2-10.4h16.5c3.6-10.1 9-19.4 15.9-27.4l-8.2-14.3c-3-5.2-1.9-11.9 2.8-15.7 9.5-7.9 20.4-14.2 32.1-18.6 5.7-2.1 12.1.1 15.1 5.4l8.2 14.3c10.5-1.9 21.2-1.9 31.7 0l8.2-14.3c3-5.3 9.4-7.5 15.1-5.4 11.8 4.4 22.6 10.7 32.1 18.6 4.6 3.8 5.8 10.5 2.8 15.7l-8.2 14.3c6.9 8 12.3 17.3 15.9 27.4h16.5c6 0 11.2 4.3 12.2 10.3 2 12 2.1 24.6 0 37.1-1 6-6.2 10.4-12.2 10.4h-16.5c-3.6 10.1-9 19.4-15.9 27.4l8.2 14.3c3 5.2 1.9 11.9-2.8 15.7-9.5 7.9-20.4 14.2-32.1 18.6-5.7 2.1-12.1-.1-15.1-5.4l-8.2-14.3c-10.4 1.9-21.2 1.9-31.7 0zM501.6 431c38.5 29.6 82.4-14.3 52.8-52.8-38.5-29.6-82.4 14.3-52.8 52.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCoins(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 405.3V448c0 35.3 86 64 192 64s192-28.7 192-64v-42.7C342.7 434.4 267.2 448 192 448S41.3 434.4 0 405.3zM320 128c106 0 192-28.7 192-64S426 0 320 0 128 28.7 128 64s86 64 192 64zM0 300.4V352c0 35.3 86 64 192 64s192-28.7 192-64v-51.6c-41.3 34-116.9 51.6-192 51.6S41.3 334.4 0 300.4zm416 11c57.3-11.1 96-31.7 96-55.4v-42.7c-23.2 16.4-57.3 27.6-96 34.5v63.6zM192 160C86 160 0 195.8 0 240s86 80 192 80 192-35.8 192-80-86-80-192-80zm219.3 56.3c60-10.8 100.7-32 100.7-56.3v-42.7c-35.5 25.1-96.5 38.6-160.7 41.8 29.5 14.3 51.2 33.5 60 57.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaColumns(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM224 416H64V160h160v256zm224 0H288V160h160v256z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCommentAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 9.8 11.2 15.5 19.1 9.7L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCommentDollar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32C114.62 32 0 125.12 0 240c0 49.56 21.41 95.01 57.02 130.74C44.46 421.05 2.7 465.97 2.2 466.5A7.995 7.995 0 0 0 8 480c66.26 0 115.99-31.75 140.6-51.38C181.29 440.93 217.59 448 256 448c141.38 0 256-93.12 256-208S397.38 32 256 32zm24 302.44V352c0 8.84-7.16 16-16 16h-16c-8.84 0-16-7.16-16-16v-17.73c-11.42-1.35-22.28-5.19-31.78-11.46-6.22-4.11-6.82-13.11-1.55-18.38l17.52-17.52c3.74-3.74 9.31-4.24 14.11-2.03 3.18 1.46 6.66 2.22 10.26 2.22h32.78c4.66 0 8.44-3.78 8.44-8.42 0-3.75-2.52-7.08-6.12-8.11l-50.07-14.3c-22.25-6.35-40.01-24.71-42.91-47.67-4.05-32.07 19.03-59.43 49.32-63.05V128c0-8.84 7.16-16 16-16h16c8.84 0 16 7.16 16 16v17.73c11.42 1.35 22.28 5.19 31.78 11.46 6.22 4.11 6.82 13.11 1.55 18.38l-17.52 17.52c-3.74 3.74-9.31 4.24-14.11 2.03a24.516 24.516 0 0 0-10.26-2.22h-32.78c-4.66 0-8.44 3.78-8.44 8.42 0 3.75 2.52 7.08 6.12 8.11l50.07 14.3c22.25 6.36 40.01 24.71 42.91 47.67 4.05 32.06-19.03 59.42-49.32 63.04z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCommentDots(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7S4.8 480 8 480c66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32zM128 272c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCommentMedical(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32C114.62 32 0 125.12 0 240c0 49.56 21.41 95 57 130.74C44.46 421.05 2.7 466 2.2 466.5A8 8 0 0 0 8 480c66.26 0 116-31.75 140.6-51.38A304.66 304.66 0 0 0 256 448c141.39 0 256-93.12 256-208S397.39 32 256 32zm96 232a8 8 0 0 1-8 8h-56v56a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8v-56h-56a8 8 0 0 1-8-8v-48a8 8 0 0 1 8-8h56v-56a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v56h56a8 8 0 0 1 8 8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCommentSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 240c0 49.6 21.4 95 57 130.7-12.6 50.3-54.3 95.2-54.8 95.8-2.2 2.3-2.8 5.7-1.5 8.7 1.3 2.9 4.1 4.8 7.3 4.8 66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 27.4 0 53.7-3.6 78.4-10L72.9 186.4c-5.6 17.1-8.9 35-8.9 53.6zm569.8 218.1l-114.4-88.4C554.6 334.1 576 289.2 576 240c0-114.9-114.6-208-256-208-65.1 0-124.2 20.1-169.4 52.7L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaComment(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7S4.8 480 8 480c66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCommentsDollar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 192c0-88.37-93.12-160-208-160S0 103.63 0 192c0 34.27 14.13 65.95 37.97 91.98C24.61 314.22 2.52 338.16 2.2 338.5A7.995 7.995 0 0 0 8 352c36.58 0 66.93-12.25 88.73-24.98C128.93 342.76 167.02 352 208 352c114.88 0 208-71.63 208-160zm-224 96v-16.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V96c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.05 44.44-42.67 45.07V288c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm346.01 123.99C561.87 385.96 576 354.27 576 320c0-66.94-53.49-124.2-129.33-148.07.86 6.6 1.33 13.29 1.33 20.07 0 105.87-107.66 192-240 192-10.78 0-21.32-.77-31.73-1.88C207.8 439.63 281.77 480 368 480c40.98 0 79.07-9.24 111.27-24.98C501.07 467.75 531.42 480 568 480c3.2 0 6.09-1.91 7.34-4.84 1.27-2.94.66-6.34-1.55-8.67-.31-.33-22.42-24.24-35.78-54.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaComments(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 192c0-88.4-93.1-160-208-160S0 103.6 0 192c0 34.3 14.1 65.9 38 92-13.4 30.2-35.5 54.2-35.8 54.5-2.2 2.3-2.8 5.7-1.5 8.7S4.8 352 8 352c36.6 0 66.9-12.3 88.7-25 32.2 15.7 70.3 25 111.3 25 114.9 0 208-71.6 208-160zm122 220c23.9-26 38-57.7 38-92 0-66.9-53.5-124.2-129.3-148.1.9 6.6 1.3 13.3 1.3 20.1 0 105.9-107.7 192-240 192-10.8 0-21.3-.8-31.7-1.9C207.8 439.6 281.8 480 368 480c41 0 79.1-9.2 111.3-25 21.8 12.7 52.1 25 88.7 25 3.2 0 6.1-1.9 7.3-4.8 1.3-2.9.7-6.3-1.5-8.7-.3-.3-22.4-24.2-35.8-54.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCompactDisc(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM88 256H56c0-105.9 86.1-192 192-192v32c-88.2 0-160 71.8-160 160zm160 96c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96zm0-128c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCompass(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M225.38 233.37c-12.5 12.5-12.5 32.76 0 45.25 12.49 12.5 32.76 12.5 45.25 0 12.5-12.5 12.5-32.76 0-45.25-12.5-12.49-32.76-12.49-45.25 0zM248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm126.14 148.05L308.17 300.4a31.938 31.938 0 0 1-15.77 15.77l-144.34 65.97c-16.65 7.61-33.81-9.55-26.2-26.2l65.98-144.35a31.938 31.938 0 0 1 15.77-15.77l144.34-65.97c16.65-7.6 33.8 9.55 26.19 26.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCompressAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.686 427.314L104 328l-32.922-31.029C55.958 281.851 66.666 256 88.048 256h112C213.303 256 224 266.745 224 280v112c0 21.382-25.803 32.09-40.922 16.971L152 376l-99.314 99.314c-6.248 6.248-16.379 6.248-22.627 0L4.686 449.941c-6.248-6.248-6.248-16.379 0-22.627zM443.314 84.686L344 184l32.922 31.029c15.12 15.12 4.412 40.971-16.97 40.971h-112C234.697 256 224 245.255 224 232V120c0-21.382 25.803-32.09 40.922-16.971L296 136l99.314-99.314c6.248-6.248 16.379-6.248 22.627 0l25.373 25.373c6.248 6.248 6.248 16.379 0 22.627z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCompressArrowsAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M200 288H88c-21.4 0-32.1 25.8-17 41l32.9 31-99.2 99.3c-6.2 6.2-6.2 16.4 0 22.6l25.4 25.4c6.2 6.2 16.4 6.2 22.6 0L152 408l31.1 33c15.1 15.1 40.9 4.4 40.9-17V312c0-13.3-10.7-24-24-24zm112-64h112c21.4 0 32.1-25.9 17-41l-33-31 99.3-99.3c6.2-6.2 6.2-16.4 0-22.6L481.9 4.7c-6.2-6.2-16.4-6.2-22.6 0L360 104l-31.1-33C313.8 55.9 288 66.6 288 88v112c0 13.3 10.7 24 24 24zm96 136l33-31.1c15.1-15.1 4.4-40.9-17-40.9H312c-13.3 0-24 10.7-24 24v112c0 21.4 25.9 32.1 41 17l31-32.9 99.3 99.3c6.2 6.2 16.4 6.2 22.6 0l25.4-25.4c6.2-6.2 6.2-16.4 0-22.6L408 360zM183 71.1L152 104 52.7 4.7c-6.2-6.2-16.4-6.2-22.6 0L4.7 30.1c-6.2 6.2-6.2 16.4 0 22.6L104 152l-33 31.1C55.9 198.2 66.6 224 88 224h112c13.3 0 24-10.7 24-24V88c0-21.3-25.9-32-41-16.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCompress(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M436 192H312c-13.3 0-24-10.7-24-24V44c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v84h84c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm-276-24V44c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v84H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h124c13.3 0 24-10.7 24-24zm0 300V344c0-13.3-10.7-24-24-24H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h84v84c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm192 0v-84h84c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12H312c-13.3 0-24 10.7-24 24v124c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaConciergeBell(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 130.54V112h16c8.84 0 16-7.16 16-16V80c0-8.84-7.16-16-16-16h-96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h16v18.54C115.49 146.11 32 239.18 32 352h448c0-112.82-83.49-205.89-192-221.46zM496 384H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCookieBite(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M510.52 255.82c-69.97-.85-126.47-57.69-126.47-127.86-70.17 0-127-56.49-127.86-126.45-27.26-4.14-55.13.3-79.72 12.82l-69.13 35.22a132.221 132.221 0 0 0-57.79 57.81l-35.1 68.88a132.645 132.645 0 0 0-12.82 80.95l12.08 76.27a132.521 132.521 0 0 0 37.16 72.96l54.77 54.76a132.036 132.036 0 0 0 72.71 37.06l76.71 12.15c27.51 4.36 55.7-.11 80.53-12.76l69.13-35.21a132.273 132.273 0 0 0 57.79-57.81l35.1-68.88c12.56-24.64 17.01-52.58 12.91-79.91zM176 368c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm32-160c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm160 128c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCookie(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M510.37 254.79l-12.08-76.26a132.493 132.493 0 0 0-37.16-72.95l-54.76-54.75c-19.73-19.72-45.18-32.7-72.71-37.05l-76.7-12.15c-27.51-4.36-55.69.11-80.52 12.76L107.32 49.6a132.25 132.25 0 0 0-57.79 57.8l-35.1 68.88a132.602 132.602 0 0 0-12.82 80.94l12.08 76.27a132.493 132.493 0 0 0 37.16 72.95l54.76 54.75a132.087 132.087 0 0 0 72.71 37.05l76.7 12.14c27.51 4.36 55.69-.11 80.52-12.75l69.12-35.21a132.302 132.302 0 0 0 57.79-57.8l35.1-68.87c12.71-24.96 17.2-53.3 12.82-80.96zM176 368c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm32-160c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm160 128c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCopy(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 448v40c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V120c0-13.255 10.745-24 24-24h72v296c0 30.879 25.121 56 56 56h168zm0-344V0H152c-13.255 0-24 10.745-24 24v368c0 13.255 10.745 24 24 24h272c13.255 0 24-10.745 24-24V128H344c-13.2 0-24-10.8-24-24zm120.971-31.029L375.029 7.029A24 24 0 0 0 358.059 0H352v96h96v-6.059a24 24 0 0 0-7.029-16.97z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCopyright(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm117.134 346.753c-1.592 1.867-39.776 45.731-109.851 45.731-84.692 0-144.484-63.26-144.484-145.567 0-81.303 62.004-143.401 143.762-143.401 66.957 0 101.965 37.315 103.422 38.904a12 12 0 0 1 1.238 14.623l-22.38 34.655c-4.049 6.267-12.774 7.351-18.234 2.295-.233-.214-26.529-23.88-61.88-23.88-46.116 0-73.916 33.575-73.916 76.082 0 39.602 25.514 79.692 74.277 79.692 38.697 0 65.28-28.338 65.544-28.625 5.132-5.565 14.059-5.033 18.508 1.053l24.547 33.572a12.001 12.001 0 0 1-.553 14.866z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCouch(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 224v64h320v-64c0-35.3 28.7-64 64-64h32c0-53-43-96-96-96H160c-53 0-96 43-96 96h32c35.3 0 64 28.7 64 64zm416-32h-32c-17.7 0-32 14.3-32 32v96H128v-96c0-17.7-14.3-32-32-32H64c-35.3 0-64 28.7-64 64 0 23.6 13 44 32 55.1V432c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-16h384v16c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V311.1c19-11.1 32-31.5 32-55.1 0-35.3-28.7-64-64-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCreditCard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 432c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V256H0v176zm192-68c0-6.6 5.4-12 12-12h136c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H204c-6.6 0-12-5.4-12-12v-40zm-128 0c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zM576 80v48H0V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCropAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488 352h-40V96c0-17.67-14.33-32-32-32H192v96h160v328c0 13.25 10.75 24 24 24h48c13.25 0 24-10.75 24-24v-40h40c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24zM160 24c0-13.26-10.75-24-24-24H88C74.75 0 64 10.74 64 24v40H24C10.75 64 0 74.74 0 88v48c0 13.25 10.75 24 24 24h40v256c0 17.67 14.33 32 32 32h224v-96H160V24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCrop(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488 352h-40V109.25l59.31-59.31c6.25-6.25 6.25-16.38 0-22.63L484.69 4.69c-6.25-6.25-16.38-6.25-22.63 0L402.75 64H192v96h114.75L160 306.75V24c0-13.26-10.75-24-24-24H88C74.75 0 64 10.74 64 24v40H24C10.75 64 0 74.74 0 88v48c0 13.25 10.75 24 24 24h40v264c0 13.25 10.75 24 24 24h232v-96H205.25L352 205.25V488c0 13.25 10.75 24 24 24h48c13.25 0 24-10.75 24-24v-40h40c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCross(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 128h-96V32c0-17.67-14.33-32-32-32h-64c-17.67 0-32 14.33-32 32v96H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h96v224c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V256h96c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCrosshairs(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M500 224h-30.364C455.724 130.325 381.675 56.276 288 42.364V12c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v30.364C130.325 56.276 56.276 130.325 42.364 224H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h30.364C56.276 381.675 130.325 455.724 224 469.636V500c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-30.364C381.675 455.724 455.724 381.675 469.636 288H500c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zM288 404.634V364c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40.634C165.826 392.232 119.783 346.243 107.366 288H148c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-40.634C119.768 165.826 165.757 119.783 224 107.366V148c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40.634C346.174 119.768 392.217 165.757 404.634 224H364c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40.634C392.232 346.174 346.243 392.217 288 404.634zM288 256c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCrow(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 32h-16.36C513.04 12.68 490.09 0 464 0c-44.18 0-80 35.82-80 80v20.98L12.09 393.57A30.216 30.216 0 0 0 0 417.74c0 22.46 23.64 37.07 43.73 27.03L165.27 384h96.49l44.41 120.1c2.27 6.23 9.15 9.44 15.38 7.17l22.55-8.21c6.23-2.27 9.44-9.15 7.17-15.38L312.94 384H352c1.91 0 3.76-.23 5.66-.29l44.51 120.38c2.27 6.23 9.15 9.44 15.38 7.17l22.55-8.21c6.23-2.27 9.44-9.15 7.17-15.38l-41.24-111.53C485.74 352.8 544 279.26 544 192v-80l96-16c0-35.35-42.98-64-96-64zm-80 72c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCrown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528 448H112c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h416c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm64-320c-26.5 0-48 21.5-48 48 0 7.1 1.6 13.7 4.4 19.8L476 239.2c-15.4 9.2-35.3 4-44.2-11.6L350.3 85C361 76.2 368 63 368 48c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 15 7 28.2 17.7 37l-81.5 142.6c-8.9 15.6-28.9 20.8-44.2 11.6l-72.3-43.4c2.7-6 4.4-12.7 4.4-19.8 0-26.5-21.5-48-48-48S0 149.5 0 176s21.5 48 48 48c2.6 0 5.2-.4 7.7-.8L128 416h384l72.3-192.8c2.5.4 5.1.8 7.7.8 26.5 0 48-21.5 48-48s-21.5-48-48-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCrutch(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M507.31 185.71l-181-181a16 16 0 0 0-22.62 0L281 27.31a16 16 0 0 0 0 22.63l181 181a16 16 0 0 0 22.63 0l22.62-22.63a16 16 0 0 0 .06-22.6zm-179.54 66.41l-67.89-67.89 55.1-55.1-45.25-45.25-109.67 109.67a96.08 96.08 0 0 0-25.67 46.29L106.65 360.1l-102 102a16 16 0 0 0 0 22.63l22.62 22.62a16 16 0 0 0 22.63 0l102-102 120.25-27.75a95.88 95.88 0 0 0 46.29-25.65l109.68-109.68L382.87 197zm-54.57 54.57a32 32 0 0 1-15.45 8.54l-79.3 18.32 18.3-79.3a32.22 32.22 0 0 1 8.56-15.45l9.31-9.31 67.89 67.89z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCube(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M239.1 6.3l-208 78c-18.7 7-31.1 25-31.1 45v225.1c0 18.2 10.3 34.8 26.5 42.9l208 104c13.5 6.8 29.4 6.8 42.9 0l208-104c16.3-8.1 26.5-24.8 26.5-42.9V129.3c0-20-12.4-37.9-31.1-44.9l-208-78C262 2.2 250 2.2 239.1 6.3zM256 68.4l192 72v1.1l-192 78-192-78v-1.1l192-72zm32 356V275.5l160-65v133.9l-160 80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCubes(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488.6 250.2L392 214V105.5c0-15-9.3-28.4-23.4-33.7l-100-37.5c-8.1-3.1-17.1-3.1-25.3 0l-100 37.5c-14.1 5.3-23.4 18.7-23.4 33.7V214l-96.6 36.2C9.3 255.5 0 268.9 0 283.9V394c0 13.6 7.7 26.1 19.9 32.2l100 50c10.1 5.1 22.1 5.1 32.2 0l103.9-52 103.9 52c10.1 5.1 22.1 5.1 32.2 0l100-50c12.2-6.1 19.9-18.6 19.9-32.2V283.9c0-15-9.3-28.4-23.4-33.7zM358 214.8l-85 31.9v-68.2l85-37v73.3zM154 104.1l102-38.2 102 38.2v.6l-102 41.4-102-41.4v-.6zm84 291.1l-85 42.5v-79.1l85-38.8v75.4zm0-112l-102 41.4-102-41.4v-.6l102-38.2 102 38.2v.6zm240 112l-85 42.5v-79.1l85-38.8v75.4zm0-112l-102 41.4-102-41.4v-.6l102-38.2 102 38.2v.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaCut(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M278.06 256L444.48 89.57c4.69-4.69 4.69-12.29 0-16.97-32.8-32.8-85.99-32.8-118.79 0L210.18 188.12l-24.86-24.86c4.31-10.92 6.68-22.81 6.68-35.26 0-53.02-42.98-96-96-96S0 74.98 0 128s42.98 96 96 96c4.54 0 8.99-.32 13.36-.93L142.29 256l-32.93 32.93c-4.37-.61-8.83-.93-13.36-.93-53.02 0-96 42.98-96 96s42.98 96 96 96 96-42.98 96-96c0-12.45-2.37-24.34-6.68-35.26l24.86-24.86L325.69 439.4c32.8 32.8 85.99 32.8 118.79 0 4.69-4.68 4.69-12.28 0-16.97L278.06 256zM96 160c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32zm0 256c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDatabase(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 73.143v45.714C448 159.143 347.667 192 224 192S0 159.143 0 118.857V73.143C0 32.857 100.333 0 224 0s224 32.857 224 73.143zM448 176v102.857C448 319.143 347.667 352 224 352S0 319.143 0 278.857V176c48.125 33.143 136.208 48.572 224 48.572S399.874 209.143 448 176zm0 160v102.857C448 479.143 347.667 512 224 512S0 479.143 0 438.857V336c48.125 33.143 136.208 48.572 224 48.572S399.874 369.143 448 336z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDeaf(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M216 260c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-44.112 35.888-80 80-80s80 35.888 80 80c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-13.234-10.767-24-24-24s-24 10.766-24 24zm24-176c-97.047 0-176 78.953-176 176 0 15.464 12.536 28 28 28s28-12.536 28-28c0-66.168 53.832-120 120-120s120 53.832 120 120c0 75.164-71.009 70.311-71.997 143.622L288 404c0 28.673-23.327 52-52 52-15.464 0-28 12.536-28 28s12.536 28 28 28c59.475 0 107.876-48.328 108-107.774.595-34.428 72-48.24 72-144.226 0-97.047-78.953-176-176-176zm268.485-52.201L480.2 3.515c-4.687-4.686-12.284-4.686-16.971 0L376.2 90.544c-4.686 4.686-4.686 12.284 0 16.971l28.285 28.285c4.686 4.686 12.284 4.686 16.97 0l87.03-87.029c4.687-4.688 4.687-12.286 0-16.972zM168.97 314.745c-4.686-4.686-12.284-4.686-16.97 0L3.515 463.23c-4.686 4.686-4.686 12.284 0 16.971L31.8 508.485c4.687 4.686 12.284 4.686 16.971 0L197.256 360c4.686-4.686 4.686-12.284 0-16.971l-28.286-28.284z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDemocrat(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M637.3 256.9l-19.6-29.4c-28.2-42.3-75.3-67.5-126.1-67.5H256l-81.2-81.2c20.1-20.1 22.6-51.1 7.5-73.9-3.4-5.2-10.8-5.9-15.2-1.5l-41.8 41.8L82.4 2.4c-3.6-3.6-9.6-3-12.4 1.2-12.3 18.6-10.3 44 6.1 60.4 3.3 3.3 7.3 5.3 11.3 7.5-2.2 1.7-4.7 3.1-6.4 5.4L6.4 176.2c-7.3 9.7-8.4 22.7-3 33.5l14.3 28.6c5.4 10.8 16.5 17.7 28.6 17.7h31c8.5 0 16.6-3.4 22.6-9.4L138 212l54 108h352v-77.8c16.2 12.2 18.3 17.6 40.1 50.3 4.9 7.4 14.8 9.3 22.2 4.4l26.6-17.7c7.3-5 9.3-14.9 4.4-22.3zm-341.1-13.6l-16.5 16.1 3.9 22.7c.7 4.1-3.6 7.2-7.2 5.3L256 276.7l-20.4 10.7c-3.6 1.9-7.9-1.2-7.2-5.3l3.9-22.7-16.5-16.1c-3-2.9-1.3-7.9 2.8-8.5l22.8-3.3 10.2-20.7c1.8-3.7 7.1-3.7 9 0l10.2 20.7 22.8 3.3c4 .6 5.6 5.6 2.6 8.5zm112 0l-16.5 16.1 3.9 22.7c.7 4.1-3.6 7.2-7.2 5.3L368 276.7l-20.4 10.7c-3.6 1.9-7.9-1.2-7.2-5.3l3.9-22.7-16.5-16.1c-3-2.9-1.3-7.9 2.8-8.5l22.8-3.3 10.2-20.7c1.8-3.7 7.1-3.7 9 0l10.2 20.7 22.8 3.3c4 .6 5.6 5.6 2.6 8.5zm112 0l-16.5 16.1 3.9 22.7c.7 4.1-3.6 7.2-7.2 5.3L480 276.7l-20.4 10.7c-3.6 1.9-7.9-1.2-7.2-5.3l3.9-22.7-16.5-16.1c-3-2.9-1.3-7.9 2.8-8.5l22.8-3.3 10.2-20.7c1.8-3.7 7.1-3.7 9 0l10.2 20.7 22.8 3.3c4 .6 5.6 5.6 2.6 8.5zM192 496c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-80h160v80c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V352H192v144z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDesktop(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528 0H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h192l-16 48h-72c-13.3 0-24 10.7-24 24s10.7 24 24 24h272c13.3 0 24-10.7 24-24s-10.7-24-24-24h-72l-16-48h192c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm-16 352H64V64h448v288z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDharmachakra(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M495 225.06l-17.22 1.08c-5.27-39.49-20.79-75.64-43.86-105.84l12.95-11.43c6.92-6.11 7.25-16.79.73-23.31L426.44 64.4c-6.53-6.53-17.21-6.19-23.31.73L391.7 78.07c-30.2-23.06-66.35-38.58-105.83-43.86L286.94 17c.58-9.21-6.74-17-15.97-17h-29.94c-9.23 0-16.54 7.79-15.97 17l1.08 17.22c-39.49 5.27-75.64 20.79-105.83 43.86l-11.43-12.95c-6.11-6.92-16.79-7.25-23.31-.73L64.4 85.56c-6.53 6.53-6.19 17.21.73 23.31l12.95 11.43c-23.06 30.2-38.58 66.35-43.86 105.84L17 225.06c-9.21-.58-17 6.74-17 15.97v29.94c0 9.23 7.79 16.54 17 15.97l17.22-1.08c5.27 39.49 20.79 75.64 43.86 105.83l-12.95 11.43c-6.92 6.11-7.25 16.79-.73 23.31l21.17 21.17c6.53 6.53 17.21 6.19 23.31-.73l11.43-12.95c30.2 23.06 66.35 38.58 105.84 43.86L225.06 495c-.58 9.21 6.74 17 15.97 17h29.94c9.23 0 16.54-7.79 15.97-17l-1.08-17.22c39.49-5.27 75.64-20.79 105.84-43.86l11.43 12.95c6.11 6.92 16.79 7.25 23.31.73l21.17-21.17c6.53-6.53 6.19-17.21-.73-23.31l-12.95-11.43c23.06-30.2 38.58-66.35 43.86-105.83l17.22 1.08c9.21.58 17-6.74 17-15.97v-29.94c-.01-9.23-7.8-16.54-17.01-15.97zM281.84 98.61c24.81 4.07 47.63 13.66 67.23 27.78l-42.62 48.29c-8.73-5.44-18.32-9.54-28.62-11.95l4.01-64.12zm-51.68 0l4.01 64.12c-10.29 2.41-19.89 6.52-28.62 11.95l-42.62-48.29c19.6-14.12 42.42-23.71 67.23-27.78zm-103.77 64.33l48.3 42.61c-5.44 8.73-9.54 18.33-11.96 28.62l-64.12-4.01c4.07-24.81 13.66-47.62 27.78-67.22zm-27.78 118.9l64.12-4.01c2.41 10.29 6.52 19.89 11.95 28.62l-48.29 42.62c-14.12-19.6-23.71-42.42-27.78-67.23zm131.55 131.55c-24.81-4.07-47.63-13.66-67.23-27.78l42.61-48.3c8.73 5.44 18.33 9.54 28.62 11.96l-4 64.12zM256 288c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm25.84 125.39l-4.01-64.12c10.29-2.41 19.89-6.52 28.62-11.96l42.61 48.3c-19.6 14.12-42.41 23.71-67.22 27.78zm103.77-64.33l-48.29-42.62c5.44-8.73 9.54-18.32 11.95-28.62l64.12 4.01c-4.07 24.82-13.66 47.64-27.78 67.23zm-36.34-114.89c-2.41-10.29-6.52-19.89-11.96-28.62l48.3-42.61c14.12 19.6 23.71 42.42 27.78 67.23l-64.12 4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDiagnoses(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 256c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm-176-80c48.5 0 88-39.5 88-88S368.5 0 320 0s-88 39.5-88 88 39.5 88 88 88zM59.8 364c10.2 15.3 29.3 17.8 42.9 9.8 16.2-9.6 56.2-31.7 105.3-48.6V416h224v-90.7c49.1 16.8 89.1 39 105.3 48.6 13.6 8 32.7 5.3 42.9-9.8l17.8-26.7c8.8-13.2 7.6-34.6-10-45.1-11.9-7.1-29.7-17-51.1-27.4-28.1 46.1-99.4 17.8-87.7-35.1C409.3 217.2 365.1 208 320 208c-57 0-112.9 14.5-160 32.2-.2 40.2-47.6 63.3-79.2 36-11.2 6-21.3 11.6-28.7 16-17.6 10.5-18.8 31.8-10 45.1L59.8 364zM368 344c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm-96-96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm-160 8c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm512 192H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDiceD20(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 480 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M106.75 215.06L1.2 370.95c-3.08 5 .1 11.5 5.93 12.14l208.26 22.07-108.64-190.1zM7.41 315.43L82.7 193.08 6.06 147.1c-2.67-1.6-6.06.32-6.06 3.43v162.81c0 4.03 5.29 5.53 7.41 2.09zM18.25 423.6l194.4 87.66c5.3 2.45 11.35-1.43 11.35-7.26v-65.67l-203.55-22.3c-4.45-.5-6.23 5.59-2.2 7.57zm81.22-257.78L179.4 22.88c4.34-7.06-3.59-15.25-10.78-11.14L17.81 110.35c-2.47 1.62-2.39 5.26.13 6.78l81.53 48.69zM240 176h109.21L253.63 7.62C250.5 2.54 245.25 0 240 0s-10.5 2.54-13.63 7.62L130.79 176H240zm233.94-28.9l-76.64 45.99 75.29 122.35c2.11 3.44 7.41 1.94 7.41-2.1V150.53c0-3.11-3.39-5.03-6.06-3.43zm-93.41 18.72l81.53-48.7c2.53-1.52 2.6-5.16.13-6.78l-150.81-98.6c-7.19-4.11-15.12 4.08-10.78 11.14l79.93 142.94zm79.02 250.21L256 438.32v65.67c0 5.84 6.05 9.71 11.35 7.26l194.4-87.66c4.03-1.97 2.25-8.06-2.2-7.56zm-86.3-200.97l-108.63 190.1 208.26-22.07c5.83-.65 9.01-7.14 5.93-12.14L373.25 215.06zM240 208H139.57L240 383.75 340.43 208H240z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDiceD6(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M422.19 109.95L256.21 9.07c-19.91-12.1-44.52-12.1-64.43 0L25.81 109.95c-5.32 3.23-5.29 11.27.06 14.46L224 242.55l198.14-118.14c5.35-3.19 5.38-11.22.05-14.46zm13.84 44.63L240 271.46v223.82c0 12.88 13.39 20.91 24.05 14.43l152.16-92.48c19.68-11.96 31.79-33.94 31.79-57.7v-197.7c0-6.41-6.64-10.43-11.97-7.25zM0 161.83v197.7c0 23.77 12.11 45.74 31.79 57.7l152.16 92.47c10.67 6.48 24.05-1.54 24.05-14.43V271.46L11.97 154.58C6.64 151.4 0 155.42 0 161.83z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDiceFive(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDiceFour(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm192 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDiceOne(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM224 288c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDiceSix(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm192 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDiceThree(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDiceTwo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm192 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDice(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M592 192H473.26c12.69 29.59 7.12 65.2-17 89.32L320 417.58V464c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48V240c0-26.51-21.49-48-48-48zM480 376c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm-46.37-186.7L258.7 14.37c-19.16-19.16-50.23-19.16-69.39 0L14.37 189.3c-19.16 19.16-19.16 50.23 0 69.39L189.3 433.63c19.16 19.16 50.23 19.16 69.39 0L433.63 258.7c19.16-19.17 19.16-50.24 0-69.4zM96 248c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm128 128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm0-128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm0-128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm128 128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDigitalTachograph(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M608 96H32c-17.67 0-32 14.33-32 32v256c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V128c0-17.67-14.33-32-32-32zM304 352c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-8c0-4.42 3.58-8 8-8h224c4.42 0 8 3.58 8 8v8zM72 288v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H80c-4.42 0-8-3.58-8-8zm64 0v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm64 0v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm64 0v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm40-64c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-48c0-8.84 7.16-16 16-16h208c8.84 0 16 7.16 16 16v48zm272 128c0 4.42-3.58 8-8 8H344c-4.42 0-8-3.58-8-8v-8c0-4.42 3.58-8 8-8h224c4.42 0 8 3.58 8 8v8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDirections(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M502.61 233.32L278.68 9.39c-12.52-12.52-32.83-12.52-45.36 0L9.39 233.32c-12.52 12.53-12.52 32.83 0 45.36l223.93 223.93c12.52 12.53 32.83 12.53 45.36 0l223.93-223.93c12.52-12.53 12.52-32.83 0-45.36zm-100.98 12.56l-84.21 77.73c-5.12 4.73-13.43 1.1-13.43-5.88V264h-96v64c0 4.42-3.58 8-8 8h-32c-4.42 0-8-3.58-8-8v-80c0-17.67 14.33-32 32-32h112v-53.73c0-6.97 8.3-10.61 13.43-5.88l84.21 77.73c3.43 3.17 3.43 8.59 0 11.76z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDisease(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M472.29 195.9l-67.06-23c-19.28-6.6-33.54-20.92-38.14-38.31l-16-60.45c-11.58-43.77-76.57-57.13-110-22.62L195 99.24c-13.26 13.71-33.54 20.93-54.2 19.31l-71.9-5.62c-52-4.07-86.93 44.89-59 82.84l38.54 52.42c11.08 15.07 12.82 33.86 4.64 50.24l-28.43 57C4 396.67 47.46 440.29 98.11 429.23l70-15.28c20.11-4.39 41.45 0 57.07 11.73l54.32 40.83c39.32 29.56 101 7.57 104.45-37.22l4.7-61.86c1.35-17.8 12.8-33.87 30.63-43l62-31.74c44.84-22.96 39.55-80.17-8.99-96.79zM160 256a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm128 96a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm16-128a16 16 0 1 1 16-16 16 16 0 0 1-16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDivide(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 352c-35.35 0-64 28.65-64 64s28.65 64 64 64 64-28.65 64-64-28.65-64-64-64zm0-192c35.35 0 64-28.65 64-64s-28.65-64-64-64-64 28.65-64 64 28.65 64 64 64zm192 48H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDizzy(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-96 206.6l-28.7 28.7c-14.8 14.8-37.8-7.5-22.6-22.6l28.7-28.7-28.7-28.7c-15-15 7.7-37.6 22.6-22.6l28.7 28.7 28.7-28.7c15-15 37.6 7.7 22.6 22.6L174.6 192l28.7 28.7c15.2 15.2-7.9 37.4-22.6 22.6L152 214.6zM248 416c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm147.3-195.3c15.2 15.2-7.9 37.4-22.6 22.6L344 214.6l-28.7 28.7c-14.8 14.8-37.8-7.5-22.6-22.6l28.7-28.7-28.7-28.7c-15-15 7.7-37.6 22.6-22.6l28.7 28.7 28.7-28.7c15-15 37.6 7.7 22.6 22.6L366.6 192l28.7 28.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDna(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.1 494.1c-1.1 9.5 6.3 17.8 15.9 17.8l32.3.1c8.1 0 14.9-5.9 16-13.9.7-4.9 1.8-11.1 3.4-18.1H380c1.6 6.9 2.9 13.2 3.5 18.1 1.1 8 7.9 14 16 13.9l32.3-.1c9.6 0 17.1-8.3 15.9-17.8-4.6-37.9-25.6-129-118.9-207.7-17.6 12.4-37.1 24.2-58.5 35.4 6.2 4.6 11.4 9.4 17 14.2H159.7c21.3-18.1 47-35.6 78.7-51.4C410.5 199.1 442.1 65.8 447.9 17.9 449 8.4 441.6.1 432 .1L399.6 0c-8.1 0-14.9 5.9-16 13.9-.7 4.9-1.8 11.1-3.4 18.1H67.8c-1.6-7-2.7-13.1-3.4-18.1-1.1-8-7.9-14-16-13.9L16.1.1C6.5.1-1 8.4.1 17.9 5.3 60.8 31.4 171.8 160 256 31.5 340.2 5.3 451.2.1 494.1zM224 219.6c-25.1-13.7-46.4-28.4-64.3-43.6h128.5c-17.8 15.2-39.1 30-64.2 43.6zM355.1 96c-5.8 10.4-12.8 21.1-21 32H114c-8.3-10.9-15.3-21.6-21-32h262.1zM92.9 416c5.8-10.4 12.8-21.1 21-32h219.4c8.3 10.9 15.4 21.6 21.2 32H92.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDog(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M298.06,224,448,277.55V496a16,16,0,0,1-16,16H368a16,16,0,0,1-16-16V384H192V496a16,16,0,0,1-16,16H112a16,16,0,0,1-16-16V282.09C58.84,268.84,32,233.66,32,192a32,32,0,0,1,64,0,32.06,32.06,0,0,0,32,32ZM544,112v32a64,64,0,0,1-64,64H448v35.58L320,197.87V48c0-14.25,17.22-21.39,27.31-11.31L374.59,64h53.63c10.91,0,23.75,7.92,28.62,17.69L464,96h64A16,16,0,0,1,544,112Zm-112,0a16,16,0,1,0-16,16A16,16,0,0,0,432,112Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDollarSign(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 288 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M209.2 233.4l-108-31.6C88.7 198.2 80 186.5 80 173.5c0-16.3 13.2-29.5 29.5-29.5h66.3c12.2 0 24.2 3.7 34.2 10.5 6.1 4.1 14.3 3.1 19.5-2l34.8-34c7.1-6.9 6.1-18.4-1.8-24.5C238 74.8 207.4 64.1 176 64V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48h-2.5C45.8 64-5.4 118.7.5 183.6c4.2 46.1 39.4 83.6 83.8 96.6l102.5 30c12.5 3.7 21.2 15.3 21.2 28.3 0 16.3-13.2 29.5-29.5 29.5h-66.3C100 368 88 364.3 78 357.5c-6.1-4.1-14.3-3.1-19.5 2l-34.8 34c-7.1 6.9-6.1 18.4 1.8 24.5 24.5 19.2 55.1 29.9 86.5 30v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48.2c46.6-.9 90.3-28.6 105.7-72.7 21.5-61.6-14.6-124.8-72.5-141.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDollyFlatbed(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208 320h384c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H448v128l-48-32-48 32V32H208c-8.8 0-16 7.2-16 16v256c0 8.8 7.2 16 16 16zm416 64H128V16c0-8.8-7.2-16-16-16H16C7.2 0 0 7.2 0 16v32c0 8.8 7.2 16 16 16h48v368c0 8.8 7.2 16 16 16h82.9c-1.8 5-2.9 10.4-2.9 16 0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1.2-11-2.9-16H451c-1.8 5-2.9 10.4-2.9 16 0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1.2-11-2.9-16H624c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDolly(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M294.2 277.7c18 5 34.7 13.4 49.5 24.7l161.5-53.8c8.4-2.8 12.9-11.9 10.1-20.2L454.9 47.2c-2.8-8.4-11.9-12.9-20.2-10.1l-61.1 20.4 33.1 99.4L346 177l-33.1-99.4-61.6 20.5c-8.4 2.8-12.9 11.9-10.1 20.2l53 159.4zm281 48.7L565 296c-2.8-8.4-11.9-12.9-20.2-10.1l-213.5 71.2c-17.2-22-43.6-36.4-73.5-37L158.4 21.9C154 8.8 141.8 0 128 0H16C7.2 0 0 7.2 0 16v32c0 8.8 7.2 16 16 16h88.9l92.2 276.7c-26.1 20.4-41.7 53.6-36 90.5 6.1 39.4 37.9 72.3 77.3 79.2 60.2 10.7 112.3-34.8 113.4-92.6l213.3-71.2c8.3-2.8 12.9-11.8 10.1-20.2zM256 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDonate(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 416c114.9 0 208-93.1 208-208S370.9 0 256 0 48 93.1 48 208s93.1 208 208 208zM233.8 97.4V80.6c0-9.2 7.4-16.6 16.6-16.6h11.1c9.2 0 16.6 7.4 16.6 16.6v17c15.5.8 30.5 6.1 43 15.4 5.6 4.1 6.2 12.3 1.2 17.1L306 145.6c-3.8 3.7-9.5 3.8-14 1-5.4-3.4-11.4-5.1-17.8-5.1h-38.9c-9 0-16.3 8.2-16.3 18.3 0 8.2 5 15.5 12.1 17.6l62.3 18.7c25.7 7.7 43.7 32.4 43.7 60.1 0 34-26.4 61.5-59.1 62.4v16.8c0 9.2-7.4 16.6-16.6 16.6h-11.1c-9.2 0-16.6-7.4-16.6-16.6v-17c-15.5-.8-30.5-6.1-43-15.4-5.6-4.1-6.2-12.3-1.2-17.1l16.3-15.5c3.8-3.7 9.5-3.8 14-1 5.4 3.4 11.4 5.1 17.8 5.1h38.9c9 0 16.3-8.2 16.3-18.3 0-8.2-5-15.5-12.1-17.6l-62.3-18.7c-25.7-7.7-43.7-32.4-43.7-60.1.1-34 26.4-61.5 59.1-62.4zM480 352h-32.5c-19.6 26-44.6 47.7-73 64h63.8c5.3 0 9.6 3.6 9.6 8v16c0 4.4-4.3 8-9.6 8H73.6c-5.3 0-9.6-3.6-9.6-8v-16c0-4.4 4.3-8 9.6-8h63.8c-28.4-16.3-53.3-38-73-64H32c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32v-96c0-17.7-14.3-32-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDoorClosed(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 448H512V50.8C512 22.78 490.47 0 464 0H175.99c-26.47 0-48 22.78-48 50.8V448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM415.99 288c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32c.01 17.67-14.32 32-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDoorOpen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 448h-80V113.45C544 86.19 522.47 64 496 64H384v64h96v384h144c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM312.24 1.01l-192 49.74C105.99 54.44 96 67.7 96 82.92V448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h336V33.18c0-21.58-19.56-37.41-39.76-32.17zM264 288c-13.25 0-24-14.33-24-32s10.75-32 24-32 24 14.33 24 32-10.75 32-24 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDotCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm80 248c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDove(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 167.2v-28.1c-28.2-36.3-47.1-79.3-54.1-125.2-2.1-13.5-19-18.8-27.8-8.3-21.1 24.9-37.7 54.1-48.9 86.5 34.2 38.3 80 64.6 130.8 75.1zM400 64c-44.2 0-80 35.9-80 80.1v59.4C215.6 197.3 127 133 87 41.8c-5.5-12.5-23.2-13.2-29-.9C41.4 76 32 115.2 32 156.6c0 70.8 34.1 136.9 85.1 185.9 13.2 12.7 26.1 23.2 38.9 32.8l-143.9 36C1.4 414-3.4 426.4 2.6 435.7 20 462.6 63 508.2 155.8 512c8 .3 16-2.6 22.1-7.9l65.2-56.1H320c88.4 0 160-71.5 160-159.9V128l32-64H400zm0 96.1c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDownload(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M216 0h80c13.3 0 24 10.7 24 24v168h87.7c17.8 0 26.7 21.5 14.1 34.1L269.7 378.3c-7.5 7.5-19.8 7.5-27.3 0L90.1 226.1c-12.6-12.6-3.7-34.1 14.1-34.1H192V24c0-13.3 10.7-24 24-24zm296 376v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h146.7l49 49c20.1 20.1 52.5 20.1 72.6 0l49-49H488c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDraftingCompass(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M457.01 344.42c-25.05 20.33-52.63 37.18-82.54 49.05l54.38 94.19 53.95 23.04c9.81 4.19 20.89-2.21 22.17-12.8l7.02-58.25-54.98-95.23zm42.49-94.56c4.86-7.67 1.89-17.99-6.05-22.39l-28.07-15.57c-7.48-4.15-16.61-1.46-21.26 5.72C403.01 281.15 332.25 320 256 320c-23.93 0-47.23-4.25-69.41-11.53l67.36-116.68c.7.02 1.34.21 2.04.21s1.35-.19 2.04-.21l51.09 88.5c31.23-8.96 59.56-25.75 82.61-48.92l-51.79-89.71C347.39 128.03 352 112.63 352 96c0-53.02-42.98-96-96-96s-96 42.98-96 96c0 16.63 4.61 32.03 12.05 45.66l-68.3 118.31c-12.55-11.61-23.96-24.59-33.68-39-4.79-7.1-13.97-9.62-21.38-5.33l-27.75 16.07c-7.85 4.54-10.63 14.9-5.64 22.47 15.57 23.64 34.69 44.21 55.98 62.02L0 439.66l7.02 58.25c1.28 10.59 12.36 16.99 22.17 12.8l53.95-23.04 70.8-122.63C186.13 377.28 220.62 384 256 384c99.05 0 190.88-51.01 243.5-134.14zM256 64c17.67 0 32 14.33 32 32s-14.33 32-32 32-32-14.33-32-32 14.33-32 32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDragon(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.32 255.78L192 223.96l-91.28 68.69c-10.08 10.08-2.94 27.31 11.31 27.31h222.7c-9.44-26.4-14.73-54.47-14.73-83.38v-42.27l-119.73-87.6c-23.82-15.88-55.29-14.01-77.06 4.59L5.81 227.64c-12.38 10.33-3.45 30.42 12.51 28.14zm556.87 34.1l-100.66-50.31A47.992 47.992 0 0 1 448 196.65v-36.69h64l28.09 22.63c6 6 14.14 9.37 22.63 9.37h30.97a32 32 0 0 0 28.62-17.69l14.31-28.62a32.005 32.005 0 0 0-3.02-33.51l-74.53-99.38C553.02 4.7 543.54 0 533.47 0H296.02c-7.13 0-10.7 8.57-5.66 13.61L352 63.96 292.42 88.8c-5.9 2.95-5.9 11.36 0 14.31L352 127.96v108.62c0 72.08 36.03 139.39 96 179.38-195.59 6.81-344.56 41.01-434.1 60.91C5.78 478.67 0 485.88 0 494.2 0 504 7.95 512 17.76 512h499.08c63.29.01 119.61-47.56 122.99-110.76 2.52-47.28-22.73-90.4-64.64-111.36zM489.18 66.25l45.65 11.41c-2.75 10.91-12.47 18.89-24.13 18.26-12.96-.71-25.85-12.53-21.52-29.67z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDrawPolygon(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 352c-.35 0-.67.1-1.02.1l-39.2-65.32c5.07-9.17 8.22-19.56 8.22-30.78s-3.14-21.61-8.22-30.78l39.2-65.32c.35.01.67.1 1.02.1 35.35 0 64-28.65 64-64s-28.65-64-64-64c-23.63 0-44.04 12.95-55.12 32H119.12C108.04 44.95 87.63 32 64 32 28.65 32 0 60.65 0 96c0 23.63 12.95 44.04 32 55.12v209.75C12.95 371.96 0 392.37 0 416c0 35.35 28.65 64 64 64 23.63 0 44.04-12.95 55.12-32h209.75c11.09 19.05 31.49 32 55.12 32 35.35 0 64-28.65 64-64 .01-35.35-28.64-64-63.99-64zm-288 8.88V151.12A63.825 63.825 0 0 0 119.12 128h208.36l-38.46 64.1c-.35-.01-.67-.1-1.02-.1-35.35 0-64 28.65-64 64s28.65 64 64 64c.35 0 .67-.1 1.02-.1l38.46 64.1H119.12A63.748 63.748 0 0 0 96 360.88zM272 256c0-8.82 7.18-16 16-16s16 7.18 16 16-7.18 16-16 16-16-7.18-16-16zM400 96c0 8.82-7.18 16-16 16s-16-7.18-16-16 7.18-16 16-16 16 7.18 16 16zM64 80c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16zM48 416c0-8.82 7.18-16 16-16s16 7.18 16 16-7.18 16-16 16-16-7.18-16-16zm336 16c-8.82 0-16-7.18-16-16s7.18-16 16-16 16 7.18 16 16-7.18 16-16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDrumSteelpan(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 32C128.94 32 0 89.31 0 160v192c0 70.69 128.94 128 288 128s288-57.31 288-128V160c0-70.69-128.94-128-288-128zm-82.99 158.36c-4.45 16.61-14.54 30.57-28.31 40.48C100.23 217.46 48 190.78 48 160c0-30.16 50.11-56.39 124.04-70.03l25.6 44.34c9.86 17.09 12.48 36.99 7.37 56.05zM288 240c-21.08 0-41.41-1-60.89-2.7 8.06-26.13 32.15-45.3 60.89-45.3s52.83 19.17 60.89 45.3C329.41 239 309.08 240 288 240zm64-144c0 35.29-28.71 64-64 64s-64-28.71-64-64V82.96c20.4-1.88 41.8-2.96 64-2.96s43.6 1.08 64 2.96V96zm46.93 134.9c-13.81-9.91-23.94-23.9-28.4-40.54-5.11-19.06-2.49-38.96 7.38-56.04l25.65-44.42C477.72 103.5 528 129.79 528 160c0 30.83-52.4 57.54-129.07 70.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDrum(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M431.34 122.05l73.53-47.42a16 16 0 0 0 4.44-22.19l-8.87-13.31a16 16 0 0 0-22.19-4.44l-110.06 71C318.43 96.91 271.22 96 256 96 219.55 96 0 100.55 0 208.15v160.23c0 30.27 27.5 57.68 72 77.86v-101.9a24 24 0 1 1 48 0v118.93c33.05 9.11 71.07 15.06 112 16.73V376.39a24 24 0 1 1 48 0V480c40.93-1.67 78.95-7.62 112-16.73V344.34a24 24 0 1 1 48 0v101.9c44.5-20.18 72-47.59 72-77.86V208.15c0-43.32-35.76-69.76-80.66-86.1zM256 272.24c-114.88 0-208-28.69-208-64.09s93.12-64.08 208-64.08c17.15 0 33.73.71 49.68 1.91l-72.81 47a16 16 0 0 0-4.43 22.19l8.87 13.31a16 16 0 0 0 22.19 4.44l118.64-76.52C430.09 168 464 186.84 464 208.15c0 35.4-93.13 64.09-208 64.09z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDrumstickBite(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M462.8 49.57a169.44 169.44 0 0 0-239.5 0C187.82 85 160.13 128 160.13 192v85.83l-40.62 40.59c-9.7 9.69-24 11.07-36.78 6a60.33 60.33 0 0 0-65 98.72C33 438.39 54.24 442.7 73.85 438.21c-4.5 19.6-.18 40.83 15.1 56.1a60.35 60.35 0 0 0 98.8-65c-5.09-12.73-3.72-27 6-36.75L234.36 352h85.89a187.87 187.87 0 0 0 61.89-10c-39.64-43.89-39.83-110.23 1.05-151.07 34.38-34.36 86.76-39.46 128.74-16.8 1.3-44.96-14.81-90.28-49.13-124.56z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDumbbell(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M104 96H56c-13.3 0-24 10.7-24 24v104H8c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h24v104c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24zm528 128h-24V120c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24v272c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V288h24c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM456 32h-48c-13.3 0-24 10.7-24 24v168H256V56c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24v400c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V288h128v168c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDumpsterFire(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M418.7 104.1l.2-.2-14.4-72H304v128h60.8c16.2-19.3 34.2-38.2 53.9-55.8zM272 32H171.5l-25.6 128H272V32zm189.3 72.1c18.2 16.3 35.5 33.7 51.1 51.5 5.7-5.6 11.4-11.1 17.3-16.3l21.3-19 21.3 19c1.1.9 2.1 2.1 3.1 3.1-.1-.8.2-1.5 0-2.3l-24-96C549.7 37 543.3 32 536 32h-98.9l12.3 61.5 11.9 10.6zM16 160h97.3l25.6-128H40c-7.3 0-13.7 5-15.5 12.1l-24 96C-2 150.2 5.6 160 16 160zm324.6 32H32l4 32H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h28l20 160v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h208.8c-30.2-33.7-48.8-77.9-48.8-126.4 0-35.9 19.9-82.9 52.6-129.6zm210.5-28.8c-14.9 13.3-28.3 27.2-40.2 41.2-19.5-25.8-43.6-52-71-76.4-70.2 62.7-120 144.3-120 193.6 0 87.5 71.6 158.4 160 158.4s160-70.9 160-158.4c.1-36.6-37-112.2-88.8-158.4zm-18.6 229.4c-14.7 10.7-32.9 17-52.5 17-49 0-88.9-33.5-88.9-88 0-27.1 16.5-51 49.4-91.9 4.7 5.6 67.1 88.1 67.1 88.1l39.8-47c2.8 4.8 5.4 9.5 7.7 14 18.6 36.7 10.8 83.6-22.6 107.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDumpster(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M560 160c10.4 0 18-9.8 15.5-19.9l-24-96C549.7 37 543.3 32 536 32h-98.9l25.6 128H560zM272 32H171.5l-25.6 128H272V32zm132.5 0H304v128h126.1L404.5 32zM16 160h97.3l25.6-128H40c-7.3 0-13.7 5-15.5 12.1l-24 96C-2 150.2 5.6 160 16 160zm544 64h-20l4-32H32l4 32H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h28l20 160v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h320v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16l20-160h28c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaDungeon(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128.73 195.32l-82.81-51.76c-8.04-5.02-18.99-2.17-22.93 6.45A254.19 254.19 0 0 0 .54 239.28C-.05 248.37 7.59 256 16.69 256h97.13c7.96 0 14.08-6.25 15.01-14.16 1.09-9.33 3.24-18.33 6.24-26.94 2.56-7.34.25-15.46-6.34-19.58zM319.03 8C298.86 2.82 277.77 0 256 0s-42.86 2.82-63.03 8c-9.17 2.35-13.91 12.6-10.39 21.39l37.47 104.03A16.003 16.003 0 0 0 235.1 144h41.8c6.75 0 12.77-4.23 15.05-10.58l37.47-104.03c3.52-8.79-1.22-19.03-10.39-21.39zM112 288H16c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm0 128H16c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm77.31-283.67l-36.32-90.8c-3.53-8.83-14.13-12.99-22.42-8.31a257.308 257.308 0 0 0-71.61 59.89c-6.06 7.32-3.85 18.48 4.22 23.52l82.93 51.83c6.51 4.07 14.66 2.62 20.11-2.79 5.18-5.15 10.79-9.85 16.79-14.05 6.28-4.41 9.15-12.17 6.3-19.29zM398.18 256h97.13c9.1 0 16.74-7.63 16.15-16.72a254.135 254.135 0 0 0-22.45-89.27c-3.94-8.62-14.89-11.47-22.93-6.45l-82.81 51.76c-6.59 4.12-8.9 12.24-6.34 19.58 3.01 8.61 5.15 17.62 6.24 26.94.93 7.91 7.05 14.16 15.01 14.16zm54.85-162.89a257.308 257.308 0 0 0-71.61-59.89c-8.28-4.68-18.88-.52-22.42 8.31l-36.32 90.8c-2.85 7.12.02 14.88 6.3 19.28 6 4.2 11.61 8.9 16.79 14.05 5.44 5.41 13.6 6.86 20.11 2.79l82.93-51.83c8.07-5.03 10.29-16.19 4.22-23.51zM496 288h-96c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm0 128h-96c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zM240 177.62V472c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V177.62c-5.23-.89-10.52-1.62-16-1.62s-10.77.73-16 1.62zm-64 41.51V472c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V189.36c-12.78 7.45-23.84 17.47-32 29.77zm128-29.77V472c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V219.13c-8.16-12.3-19.22-22.32-32-29.77z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEdit(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M402.6 83.2l90.2 90.2c3.8 3.8 3.8 10 0 13.8L274.4 405.6l-92.8 10.3c-12.4 1.4-22.9-9.1-21.5-21.5l10.3-92.8L388.8 83.2c3.8-3.8 10-3.8 13.8 0zm162-22.9l-48.8-48.8c-15.2-15.2-39.9-15.2-55.2 0l-35.4 35.4c-3.8 3.8-3.8 10 0 13.8l90.2 90.2c3.8 3.8 10 3.8 13.8 0l35.4-35.4c15.2-15.3 15.2-40 0-55.2zM384 346.2V448H64V128h229.8c3.2 0 6.2-1.3 8.5-3.5l40-40c7.6-7.6 2.2-20.5-8.5-20.5H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V306.2c0-10.7-12.9-16-20.5-8.5l-40 40c-2.2 2.3-3.5 5.3-3.5 8.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEgg(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 0C86 0 0 214 0 320s86 192 192 192 192-86 192-192S298 0 192 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEject(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 384v64c0 17.673-14.327 32-32 32H32c-17.673 0-32-14.327-32-32v-64c0-17.673 14.327-32 32-32h384c17.673 0 32 14.327 32 32zM48.053 320h351.886c41.651 0 63.581-49.674 35.383-80.435L259.383 47.558c-19.014-20.743-51.751-20.744-70.767 0L12.67 239.565C-15.475 270.268 6.324 320 48.053 320z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEllipsisH(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M328 256c0 39.8-32.2 72-72 72s-72-32.2-72-72 32.2-72 72-72 72 32.2 72 72zm104-72c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm-352 0c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEllipsisV(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 192 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 184c39.8 0 72 32.2 72 72s-32.2 72-72 72-72-32.2-72-72 32.2-72 72-72zM24 80c0 39.8 32.2 72 72 72s72-32.2 72-72S135.8 8 96 8 24 40.2 24 80zm0 352c0 39.8 32.2 72 72 72s72-32.2 72-72-32.2-72-72-72-72 32.2-72 72z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEnvelopeOpenText(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 216h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16zm-16 80c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v16zm96 121.13c-16.42 0-32.84-5.06-46.86-15.19L0 250.86V464c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V250.86L302.86 401.94c-14.02 10.12-30.44 15.19-46.86 15.19zm237.61-254.18c-8.85-6.94-17.24-13.47-29.61-22.81V96c0-26.51-21.49-48-48-48h-77.55c-3.04-2.2-5.87-4.26-9.04-6.56C312.6 29.17 279.2-.35 256 0c-23.2-.35-56.59 29.17-73.41 41.44-3.17 2.3-6 4.36-9.04 6.56H96c-26.51 0-48 21.49-48 48v44.14c-12.37 9.33-20.76 15.87-29.61 22.81A47.995 47.995 0 0 0 0 200.72v10.65l96 69.35V96h320v184.72l96-69.35v-10.65c0-14.74-6.78-28.67-18.39-37.77z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEnvelopeOpen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 464c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V200.724a48 48 0 0 1 18.387-37.776c24.913-19.529 45.501-35.365 164.2-121.511C199.412 29.17 232.797-.347 256 .003c23.198-.354 56.596 29.172 73.413 41.433 118.687 86.137 139.303 101.995 164.2 121.512A48 48 0 0 1 512 200.724V464zm-65.666-196.605c-2.563-3.728-7.7-4.595-11.339-1.907-22.845 16.873-55.462 40.705-105.582 77.079-16.825 12.266-50.21 41.781-73.413 41.43-23.211.344-56.559-29.143-73.413-41.43-50.114-36.37-82.734-60.204-105.582-77.079-3.639-2.688-8.776-1.821-11.339 1.907l-9.072 13.196a7.998 7.998 0 0 0 1.839 10.967c22.887 16.899 55.454 40.69 105.303 76.868 20.274 14.781 56.524 47.813 92.264 47.573 35.724.242 71.961-32.771 92.263-47.573 49.85-36.179 82.418-59.97 105.303-76.868a7.998 7.998 0 0 0 1.839-10.967l-9.071-13.196z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEnvelopeSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM178.117 262.104C87.429 196.287 88.353 196.121 64 177.167V152c0-13.255 10.745-24 24-24h272c13.255 0 24 10.745 24 24v25.167c-24.371 18.969-23.434 19.124-114.117 84.938-10.5 7.655-31.392 26.12-45.883 25.894-14.503.218-35.367-18.227-45.883-25.895zM384 217.775V360c0 13.255-10.745 24-24 24H88c-13.255 0-24-10.745-24-24V217.775c13.958 10.794 33.329 25.236 95.303 70.214 14.162 10.341 37.975 32.145 64.694 32.01 26.887.134 51.037-22.041 64.72-32.025 61.958-44.965 81.325-59.406 95.283-70.199z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEnvelope(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEquals(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 304H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32zm0-192H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEraser(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M497.941 273.941c18.745-18.745 18.745-49.137 0-67.882l-160-160c-18.745-18.745-49.136-18.746-67.883 0l-256 256c-18.745 18.745-18.745 49.137 0 67.882l96 96A48.004 48.004 0 0 0 144 480h356c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12H355.883l142.058-142.059zm-302.627-62.627l137.373 137.373L265.373 416H150.628l-80-80 124.686-124.686z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEthernet(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 192h-48v-48c0-8.8-7.2-16-16-16h-48V80c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16v48H80c-8.8 0-16 7.2-16 16v48H16c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16h80V320h32v128h64V320h32v128h64V320h32v128h64V320h32v128h80c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEuroSign(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M310.706 413.765c-1.314-6.63-7.835-10.872-14.424-9.369-10.692 2.439-27.422 5.413-45.426 5.413-56.763 0-101.929-34.79-121.461-85.449h113.689a12 12 0 0 0 11.708-9.369l6.373-28.36c1.686-7.502-4.019-14.631-11.708-14.631H115.22c-1.21-14.328-1.414-28.287.137-42.245H261.95a12 12 0 0 0 11.723-9.434l6.512-29.755c1.638-7.484-4.061-14.566-11.723-14.566H130.184c20.633-44.991 62.69-75.03 117.619-75.03 14.486 0 28.564 2.25 37.851 4.145 6.216 1.268 12.347-2.498 14.002-8.623l11.991-44.368c1.822-6.741-2.465-13.616-9.326-14.917C290.217 34.912 270.71 32 249.635 32 152.451 32 74.03 92.252 45.075 176H12c-6.627 0-12 5.373-12 12v29.755c0 6.627 5.373 12 12 12h21.569c-1.009 13.607-1.181 29.287-.181 42.245H12c-6.627 0-12 5.373-12 12v28.36c0 6.627 5.373 12 12 12h30.114C67.139 414.692 145.264 480 249.635 480c26.301 0 48.562-4.544 61.101-7.788 6.167-1.595 10.027-7.708 8.788-13.957l-8.818-44.49z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaExchangeAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 168v-16c0-13.255 10.745-24 24-24h360V80c0-21.367 25.899-32.042 40.971-16.971l80 80c9.372 9.373 9.372 24.569 0 33.941l-80 80C409.956 271.982 384 261.456 384 240v-48H24c-13.255 0-24-10.745-24-24zm488 152H128v-48c0-21.314-25.862-32.08-40.971-16.971l-80 80c-9.372 9.373-9.372 24.569 0 33.941l80 80C102.057 463.997 128 453.437 128 432v-48h360c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaExclamationCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zm-248 50c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaExclamationTriangle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M569.517 440.013C587.975 472.007 564.806 512 527.94 512H48.054c-36.937 0-59.999-40.055-41.577-71.987L246.423 23.985c18.467-32.009 64.72-31.951 83.154 0l239.94 416.028zM288 354c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaExclamation(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 192 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 432c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80zM25.26 25.199l13.6 272C39.499 309.972 50.041 320 62.83 320h66.34c12.789 0 23.331-10.028 23.97-22.801l13.6-272C167.425 11.49 156.496 0 142.77 0H49.23C35.504 0 24.575 11.49 25.26 25.199z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaExpandAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M212.686 315.314L120 408l32.922 31.029c15.12 15.12 4.412 40.971-16.97 40.971h-112C10.697 480 0 469.255 0 456V344c0-21.382 25.803-32.09 40.922-16.971L72 360l92.686-92.686c6.248-6.248 16.379-6.248 22.627 0l25.373 25.373c6.249 6.248 6.249 16.378 0 22.627zm22.628-118.628L328 104l-32.922-31.029C279.958 57.851 290.666 32 312.048 32h112C437.303 32 448 42.745 448 56v112c0 21.382-25.803 32.09-40.922 16.971L376 152l-92.686 92.686c-6.248 6.248-16.379 6.248-22.627 0l-25.373-25.373c-6.249-6.248-6.249-16.378 0-22.627z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaExpandArrowsAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 344v112a23.94 23.94 0 0 1-24 24H312c-21.39 0-32.09-25.9-17-41l36.2-36.2L224 295.6 116.77 402.9 153 439c15.09 15.1 4.39 41-17 41H24a23.94 23.94 0 0 1-24-24V344c0-21.4 25.89-32.1 41-17l36.19 36.2L184.46 256 77.18 148.7 41 185c-15.1 15.1-41 4.4-41-17V56a23.94 23.94 0 0 1 24-24h112c21.39 0 32.09 25.9 17 41l-36.2 36.2L224 216.4l107.23-107.3L295 73c-15.09-15.1-4.39-41 17-41h112a23.94 23.94 0 0 1 24 24v112c0 21.4-25.89 32.1-41 17l-36.19-36.2L263.54 256l107.28 107.3L407 327.1c15.1-15.2 41-4.5 41 16.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaExpand(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 180V56c0-13.3 10.7-24 24-24h124c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H64v84c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12zM288 44v40c0 6.6 5.4 12 12 12h84v84c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12V56c0-13.3-10.7-24-24-24H300c-6.6 0-12 5.4-12 12zm148 276h-40c-6.6 0-12 5.4-12 12v84h-84c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h124c13.3 0 24-10.7 24-24V332c0-6.6-5.4-12-12-12zM160 468v-40c0-6.6-5.4-12-12-12H64v-84c0-6.6-5.4-12-12-12H12c-6.6 0-12 5.4-12 12v124c0 13.3 10.7 24 24 24h124c6.6 0 12-5.4 12-12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaExternalLinkAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432,320H400a16,16,0,0,0-16,16V448H64V128H208a16,16,0,0,0,16-16V80a16,16,0,0,0-16-16H48A48,48,0,0,0,0,112V464a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V336A16,16,0,0,0,432,320ZM488,0h-128c-21.37,0-32.05,25.91-17,41l35.73,35.73L135,320.37a24,24,0,0,0,0,34L157.67,377a24,24,0,0,0,34,0L435.28,133.32,471,169c15,15,41,4.5,41-17V24A24,24,0,0,0,488,0Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaExternalLinkSquareAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zm-88 16H248.029c-21.313 0-32.08 25.861-16.971 40.971l31.984 31.987L67.515 364.485c-4.686 4.686-4.686 12.284 0 16.971l31.029 31.029c4.687 4.686 12.285 4.686 16.971 0l195.526-195.526 31.988 31.991C358.058 263.977 384 253.425 384 231.979V120c0-13.255-10.745-24-24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEyeDropper(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M50.75 333.25c-12 12-18.75 28.28-18.75 45.26V424L0 480l32 32 56-32h45.49c16.97 0 33.25-6.74 45.25-18.74l126.64-126.62-128-128L50.75 333.25zM483.88 28.12c-37.47-37.5-98.28-37.5-135.75 0l-77.09 77.09-13.1-13.1c-9.44-9.44-24.65-9.31-33.94 0l-40.97 40.97c-9.37 9.37-9.37 24.57 0 33.94l161.94 161.94c9.44 9.44 24.65 9.31 33.94 0L419.88 288c9.37-9.37 9.37-24.57 0-33.94l-13.1-13.1 77.09-77.09c37.51-37.48 37.51-98.26.01-135.75z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEyeSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 400c-75.85 0-137.25-58.71-142.9-133.11L72.2 185.82c-13.79 17.3-26.48 35.59-36.72 55.59a32.35 32.35 0 0 0 0 29.19C89.71 376.41 197.07 448 320 448c26.91 0 52.87-4 77.89-10.46L346 397.39a144.13 144.13 0 0 1-26 2.61zm313.82 58.1l-110.55-85.44a331.25 331.25 0 0 0 81.25-102.07 32.35 32.35 0 0 0 0-29.19C550.29 135.59 442.93 64 320 64a308.15 308.15 0 0 0-147.32 37.7L45.46 3.37A16 16 0 0 0 23 6.18L3.37 31.45A16 16 0 0 0 6.18 53.9l588.36 454.73a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zm-183.72-142l-39.3-30.38A94.75 94.75 0 0 0 416 256a94.76 94.76 0 0 0-121.31-92.21A47.65 47.65 0 0 1 304 192a46.64 46.64 0 0 1-1.54 10l-73.61-56.89A142.31 142.31 0 0 1 320 112a143.92 143.92 0 0 1 144 144c0 21.63-5.29 41.79-13.9 60.11z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaEye(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M572.52 241.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400a144 144 0 1 1 144-144 143.93 143.93 0 0 1-144 144zm0-240a95.31 95.31 0 0 0-25.31 3.79 47.85 47.85 0 0 1-66.9 66.9A95.78 95.78 0 1 0 288 160z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFan(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352.57 128c-28.09 0-54.09 4.52-77.06 12.86l12.41-123.11C289 7.31 279.81-1.18 269.33.13 189.63 10.13 128 77.64 128 159.43c0 28.09 4.52 54.09 12.86 77.06L17.75 224.08C7.31 223-1.18 232.19.13 242.67c10 79.7 77.51 141.33 159.3 141.33 28.09 0 54.09-4.52 77.06-12.86l-12.41 123.11c-1.05 10.43 8.11 18.93 18.59 17.62 79.7-10 141.33-77.51 141.33-159.3 0-28.09-4.52-54.09-12.86-77.06l123.11 12.41c10.44 1.05 18.93-8.11 17.62-18.59-10-79.7-77.51-141.33-159.3-141.33zM256 288a32 32 0 1 1 32-32 32 32 0 0 1-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFastBackward(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 436V76c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v151.9L235.5 71.4C256.1 54.3 288 68.6 288 96v131.9L459.5 71.4C480.1 54.3 512 68.6 512 96v320c0 27.4-31.9 41.7-52.5 24.6L288 285.3V416c0 27.4-31.9 41.7-52.5 24.6L64 285.3V436c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFastForward(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 76v360c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12V284.1L276.5 440.6c-20.6 17.2-52.5 2.8-52.5-24.6V284.1L52.5 440.6C31.9 457.8 0 443.4 0 416V96c0-27.4 31.9-41.7 52.5-24.6L224 226.8V96c0-27.4 31.9-41.7 52.5-24.6L448 226.8V76c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFaucet(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352,256H313.39c-15.71-13.44-35.46-23.07-57.39-28V180.44l-32-3.38-32,3.38V228c-21.93,5-41.68,14.6-57.39,28H16A16,16,0,0,0,0,272v96a16,16,0,0,0,16,16h92.79C129.38,421.73,173,448,224,448s94.62-26.27,115.21-64H352a32,32,0,0,1,32,32,32,32,0,0,0,32,32h64a32,32,0,0,0,32-32A160,160,0,0,0,352,256ZM81.59,159.91l142.41-15,142.41,15c9.42,1,17.59-6.81,17.59-16.8V112.89c0-10-8.17-17.8-17.59-16.81L256,107.74V80a16,16,0,0,0-16-16H208a16,16,0,0,0-16,16v27.74L81.59,96.08C72.17,95.09,64,102.9,64,112.89v30.22C64,153.1,72.17,160.91,81.59,159.91Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFax(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 160V77.25a32 32 0 0 0-9.38-22.63L425.37 9.37A32 32 0 0 0 402.75 0H160a32 32 0 0 0-32 32v448a32 32 0 0 0 32 32h320a32 32 0 0 0 32-32V192a32 32 0 0 0-32-32zM288 432a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm0-128a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm128 128a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm0-128a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm0-112H192V64h160v48a16 16 0 0 0 16 16h48zM64 128H32a32 32 0 0 0-32 32v320a32 32 0 0 0 32 32h32a32 32 0 0 0 32-32V160a32 32 0 0 0-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFeatherAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 0C460.22 3.56 96.44 38.2 71.01 287.61c-3.09 26.66-4.84 53.44-5.99 80.24l178.87-178.69c6.25-6.25 16.4-6.25 22.65 0s6.25 16.38 0 22.63L7.04 471.03c-9.38 9.37-9.38 24.57 0 33.94 9.38 9.37 24.59 9.37 33.98 0l57.13-57.07c42.09-.14 84.15-2.53 125.96-7.36 53.48-5.44 97.02-26.47 132.58-56.54H255.74l146.79-48.88c11.25-14.89 21.37-30.71 30.45-47.12h-81.14l106.54-53.21C500.29 132.86 510.19 26.26 512 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFeather(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M467.14 44.84c-62.55-62.48-161.67-64.78-252.28 25.73-78.61 78.52-60.98 60.92-85.75 85.66-60.46 60.39-70.39 150.83-63.64 211.17l178.44-178.25c6.26-6.25 16.4-6.25 22.65 0s6.25 16.38 0 22.63L7.04 471.03c-9.38 9.37-9.38 24.57 0 33.94 9.38 9.37 24.6 9.37 33.98 0l66.1-66.03C159.42 454.65 279 457.11 353.95 384h-98.19l147.57-49.14c49.99-49.93 36.38-36.18 46.31-46.86h-97.78l131.54-43.8c45.44-74.46 34.31-148.84-16.26-199.36z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFemale(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 0c35.346 0 64 28.654 64 64s-28.654 64-64 64c-35.346 0-64-28.654-64-64S92.654 0 128 0m119.283 354.179l-48-192A24 24 0 0 0 176 144h-11.36c-22.711 10.443-49.59 10.894-73.28 0H80a24 24 0 0 0-23.283 18.179l-48 192C4.935 369.305 16.383 384 32 384h56v104c0 13.255 10.745 24 24 24h32c13.255 0 24-10.745 24-24V384h56c15.591 0 27.071-14.671 23.283-29.821z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFighterJet(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 224l-128-16-48-16h-24L227.158 44h39.509C278.333 44 288 41.375 288 38s-9.667-6-21.333-6H152v12h16v164h-48l-66.667-80H18.667L8 138.667V208h8v16h48v2.666l-64 8v42.667l64 8V288H16v16H8v69.333L18.667 384h34.667L120 304h48v164h-16v12h114.667c11.667 0 21.333-2.625 21.333-6s-9.667-6-21.333-6h-39.509L344 320h24l48-16 128-16c96-21.333 96-26.583 96-32 0-5.417 0-10.667-96-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFileAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm64 236c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-64c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-72v8c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm96-114.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFileArchive(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zM128.4 336c-17.9 0-32.4 12.1-32.4 27 0 15 14.6 27 32.5 27s32.4-12.1 32.4-27-14.6-27-32.5-27zM224 136V0h-63.6v32h-32V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM95.9 32h32v32h-32zm32.3 384c-33.2 0-58-30.4-51.4-62.9L96.4 256v-32h32v-32h-32v-32h32v-32h-32V96h32V64h32v32h-32v32h32v32h-32v32h32v32h-32v32h22.1c5.7 0 10.7 4.1 11.8 9.7l17.3 87.7c6.4 32.4-18.4 62.6-51.4 62.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFileAudio(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm-64 268c0 10.7-12.9 16-20.5 8.5L104 376H76c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h28l35.5-36.5c7.6-7.6 20.5-2.2 20.5 8.5v136zm33.2-47.6c9.1-9.3 9.1-24.1 0-33.4-22.1-22.8 12.2-56.2 34.4-33.5 27.2 27.9 27.2 72.4 0 100.4-21.8 22.3-56.9-10.4-34.4-33.5zm86-117.1c54.4 55.9 54.4 144.8 0 200.8-21.8 22.4-57-10.3-34.4-33.5 36.2-37.2 36.3-96.5 0-133.8-22.1-22.8 12.3-56.3 34.4-33.5zM384 121.9v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFileCode(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 121.941V128H256V0h6.059c6.365 0 12.47 2.529 16.971 7.029l97.941 97.941A24.005 24.005 0 0 1 384 121.941zM248 160c-13.2 0-24-10.8-24-24V0H24C10.745 0 0 10.745 0 24v464c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V160H248zM123.206 400.505a5.4 5.4 0 0 1-7.633.246l-64.866-60.812a5.4 5.4 0 0 1 0-7.879l64.866-60.812a5.4 5.4 0 0 1 7.633.246l19.579 20.885a5.4 5.4 0 0 1-.372 7.747L101.65 336l40.763 35.874a5.4 5.4 0 0 1 .372 7.747l-19.579 20.884zm51.295 50.479l-27.453-7.97a5.402 5.402 0 0 1-3.681-6.692l61.44-211.626a5.402 5.402 0 0 1 6.692-3.681l27.452 7.97a5.4 5.4 0 0 1 3.68 6.692l-61.44 211.626a5.397 5.397 0 0 1-6.69 3.681zm160.792-111.045l-64.866 60.812a5.4 5.4 0 0 1-7.633-.246l-19.58-20.885a5.4 5.4 0 0 1 .372-7.747L284.35 336l-40.763-35.874a5.4 5.4 0 0 1-.372-7.747l19.58-20.885a5.4 5.4 0 0 1 7.633-.246l64.866 60.812a5.4 5.4 0 0 1-.001 7.879z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFileContract(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM64 72c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8V72zm0 64c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zm192.81 248H304c8.84 0 16 7.16 16 16s-7.16 16-16 16h-47.19c-16.45 0-31.27-9.14-38.64-23.86-2.95-5.92-8.09-6.52-10.17-6.52s-7.22.59-10.02 6.19l-7.67 15.34a15.986 15.986 0 0 1-14.31 8.84c-.38 0-.75-.02-1.14-.05-6.45-.45-12-4.75-14.03-10.89L144 354.59l-10.61 31.88c-5.89 17.66-22.38 29.53-41 29.53H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h12.39c4.83 0 9.11-3.08 10.64-7.66l18.19-54.64c3.3-9.81 12.44-16.41 22.78-16.41s19.48 6.59 22.77 16.41l13.88 41.64c19.77-16.19 54.05-9.7 66 14.16 2.02 4.06 5.96 6.5 10.16 6.5zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFileCsv(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm-96 144c0 4.42-3.58 8-8 8h-8c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h8c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-8c-26.51 0-48-21.49-48-48v-32c0-26.51 21.49-48 48-48h8c4.42 0 8 3.58 8 8v16zm44.27 104H160c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h12.27c5.95 0 10.41-3.5 10.41-6.62 0-1.3-.75-2.66-2.12-3.84l-21.89-18.77c-8.47-7.22-13.33-17.48-13.33-28.14 0-21.3 19.02-38.62 42.41-38.62H200c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-12.27c-5.95 0-10.41 3.5-10.41 6.62 0 1.3.75 2.66 2.12 3.84l21.89 18.77c8.47 7.22 13.33 17.48 13.33 28.14.01 21.29-19 38.62-42.39 38.62zM256 264v20.8c0 20.27 5.7 40.17 16 56.88 10.3-16.7 16-36.61 16-56.88V264c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v20.8c0 35.48-12.88 68.89-36.28 94.09-3.02 3.25-7.27 5.11-11.72 5.11s-8.7-1.86-11.72-5.11c-23.4-25.2-36.28-58.61-36.28-94.09V264c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8zm121-159L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFileDownload(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm76.45 211.36l-96.42 95.7c-6.65 6.61-17.39 6.61-24.04 0l-96.42-95.7C73.42 337.29 80.54 320 94.82 320H160v-80c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v80h65.18c14.28 0 21.4 17.29 11.27 27.36zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFileExcel(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm60.1 106.5L224 336l60.1 93.5c5.1 8-.6 18.5-10.1 18.5h-34.9c-4.4 0-8.5-2.4-10.6-6.3C208.9 405.5 192 373 192 373c-6.4 14.8-10 20-36.6 68.8-2.1 3.9-6.1 6.3-10.5 6.3H110c-9.5 0-15.2-10.5-10.1-18.5l60.3-93.5-60.3-93.5c-5.2-8 .6-18.5 10.1-18.5h34.8c4.4 0 8.5 2.4 10.6 6.3 26.1 48.8 20 33.6 36.6 68.5 0 0 6.1-11.7 36.6-68.5 2.1-3.9 6.2-6.3 10.6-6.3H274c9.5-.1 15.2 10.4 10.1 18.4zM384 121.9v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFileExport(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 121.9c0-6.3-2.5-12.4-7-16.9L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128zM571 308l-95.7-96.4c-10.1-10.1-27.4-3-27.4 11.3V288h-64v64h64v65.2c0 14.3 17.3 21.4 27.4 11.3L571 332c6.6-6.6 6.6-17.4 0-24zm-379 28v-32c0-8.8 7.2-16 16-16h176V160H248c-13.2 0-24-10.8-24-24V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V352H208c-8.8 0-16-7.2-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFileImage(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 121.941V128H256V0h6.059a24 24 0 0 1 16.97 7.029l97.941 97.941a24.002 24.002 0 0 1 7.03 16.971zM248 160c-13.2 0-24-10.8-24-24V0H24C10.745 0 0 10.745 0 24v464c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V160H248zm-135.455 16c26.51 0 48 21.49 48 48s-21.49 48-48 48-48-21.49-48-48 21.491-48 48-48zm208 240h-256l.485-48.485L104.545 328c4.686-4.686 11.799-4.201 16.485.485L160.545 368 264.06 264.485c4.686-4.686 12.284-4.686 16.971 0L320.545 304v112z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFileImport(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 288c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h112v-64zm489-183L407.1 7c-4.5-4.5-10.6-7-17-7H384v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H152c-13.3 0-24 10.7-24 24v264h128v-65.2c0-14.3 17.3-21.4 27.4-11.3L379 308c6.6 6.7 6.6 17.4 0 24l-95.7 96.4c-10.1 10.1-27.4 3-27.4-11.3V352H128v136c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H376c-13.2 0-24-10.8-24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFileInvoiceDollar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM64 72c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8V72zm0 80v-16c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8zm144 263.88V440c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-24.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V232c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v24.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.05 44.44-42.67 45.07z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFileInvoice(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 256H96v64h192v-64zm89-151L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM64 72c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8V72zm0 64c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zm256 304c0 4.42-3.58 8-8 8h-80c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16zm0-200v96c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-96c0-8.84 7.16-16 16-16h224c8.84 0 16 7.16 16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFileMedicalAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 136V0H88C74.7 0 64 10.7 64 24v232H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h140.9c3 0 5.8 1.7 7.2 4.4l19.9 39.8 56.8-113.7c2.9-5.9 11.4-5.9 14.3 0l34.7 69.5H352c8.8 0 16 7.2 16 16s-7.2 16-16 16h-89.9L240 275.8l-56.8 113.7c-2.9 5.9-11.4 5.9-14.3 0L134.1 320H64v168c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H312c-13.2 0-24-10.8-24-24zm153-31L343.1 7c-4.5-4.5-10.6-7-17-7H320v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFileMedical(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm64 160v48c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFilePdf(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M181.9 256.1c-5-16-4.9-46.9-2-46.9 8.4 0 7.6 36.9 2 46.9zm-1.7 47.2c-7.7 20.2-17.3 43.3-28.4 62.7 18.3-7 39-17.2 62.9-21.9-12.7-9.6-24.9-23.4-34.5-40.8zM86.1 428.1c0 .8 13.2-5.4 34.9-40.2-6.7 6.3-29.1 24.5-34.9 40.2zM248 160h136v328c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V24C0 10.7 10.7 0 24 0h200v136c0 13.2 10.8 24 24 24zm-8 171.8c-20-12.2-33.3-29-42.7-53.8 4.5-18.5 11.6-46.6 6.2-64.2-4.7-29.4-42.4-26.5-47.8-6.8-5 18.3-.4 44.1 8.1 77-11.6 27.6-28.7 64.6-40.8 85.8-.1 0-.1.1-.2.1-27.1 13.9-73.6 44.5-54.5 68 5.6 6.9 16 10 21.5 10 17.9 0 35.7-18 61.1-61.8 25.8-8.5 54.1-19.1 79-23.2 21.7 11.8 47.1 19.5 64 19.5 29.2 0 31.2-32 19.7-43.4-13.9-13.6-54.3-9.7-73.6-7.2zM377 105L279 7c-4.5-4.5-10.6-7-17-7h-6v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-74.1 255.3c4.1-2.7-2.5-11.9-42.8-9 37.1 15.8 42.8 9 42.8 9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFilePowerpoint(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M193.7 271.2c8.8 0 15.5 2.7 20.3 8.1 9.6 10.9 9.8 32.7-.2 44.1-4.9 5.6-11.9 8.5-21.1 8.5h-26.9v-60.7h27.9zM377 105L279 7c-4.5-4.5-10.6-7-17-7h-6v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm53 165.2c0 90.3-88.8 77.6-111.1 77.6V436c0 6.6-5.4 12-12 12h-30.8c-6.6 0-12-5.4-12-12V236.2c0-6.6 5.4-12 12-12h81c44.5 0 72.9 32.8 72.9 77z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFilePrescription(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm68.53 179.48l11.31 11.31c6.25 6.25 6.25 16.38 0 22.63l-29.9 29.9L304 409.38c6.25 6.25 6.25 16.38 0 22.63l-11.31 11.31c-6.25 6.25-16.38 6.25-22.63 0L240 413.25l-30.06 30.06c-6.25 6.25-16.38 6.25-22.63 0L176 432c-6.25-6.25-6.25-16.38 0-22.63l30.06-30.06L146.74 320H128v48c0 8.84-7.16 16-16 16H96c-8.84 0-16-7.16-16-16V208c0-8.84 7.16-16 16-16h80c35.35 0 64 28.65 64 64 0 24.22-13.62 45.05-33.46 55.92L240 345.38l29.9-29.9c6.25-6.25 16.38-6.25 22.63 0zM176 272h-48v-32h48c8.82 0 16 7.18 16 16s-7.18 16-16 16zm208-150.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFileSignature(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M218.17 424.14c-2.95-5.92-8.09-6.52-10.17-6.52s-7.22.59-10.02 6.19l-7.67 15.34c-6.37 12.78-25.03 11.37-29.48-2.09L144 386.59l-10.61 31.88c-5.89 17.66-22.38 29.53-41 29.53H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h12.39c4.83 0 9.11-3.08 10.64-7.66l18.19-54.64c3.3-9.81 12.44-16.41 22.78-16.41s19.48 6.59 22.77 16.41l13.88 41.64c19.75-16.19 54.06-9.7 66 14.16 1.89 3.78 5.49 5.95 9.36 6.26v-82.12l128-127.09V160H248c-13.2 0-24-10.8-24-24V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24v-40l-128-.11c-16.12-.31-30.58-9.28-37.83-23.75zM384 121.9c0-6.3-2.5-12.4-7-16.9L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1zm-96 225.06V416h68.99l161.68-162.78-67.88-67.88L288 346.96zm280.54-179.63l-31.87-31.87c-9.94-9.94-26.07-9.94-36.01 0l-27.25 27.25 67.88 67.88 27.25-27.25c9.95-9.94 9.95-26.07 0-36.01z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFileUpload(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm65.18 216.01H224v80c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-80H94.82c-14.28 0-21.41-17.29-11.27-27.36l96.42-95.7c6.65-6.61 17.39-6.61 24.04 0l96.42 95.7c10.15 10.07 3.03 27.36-11.25 27.36zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFileVideo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 121.941V128H256V0h6.059c6.365 0 12.47 2.529 16.971 7.029l97.941 97.941A24.005 24.005 0 0 1 384 121.941zM224 136V0H24C10.745 0 0 10.745 0 24v464c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V160H248c-13.2 0-24-10.8-24-24zm96 144.016v111.963c0 21.445-25.943 31.998-40.971 16.971L224 353.941V392c0 13.255-10.745 24-24 24H88c-13.255 0-24-10.745-24-24V280c0-13.255 10.745-24 24-24h112c13.255 0 24 10.745 24 24v38.059l55.029-55.013c15.011-15.01 40.971-4.491 40.971 16.97z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFileWord(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm57.1 120H305c7.7 0 13.4 7.1 11.7 14.7l-38 168c-1.2 5.5-6.1 9.3-11.7 9.3h-38c-5.5 0-10.3-3.8-11.6-9.1-25.8-103.5-20.8-81.2-25.6-110.5h-.5c-1.1 14.3-2.4 17.4-25.6 110.5-1.3 5.3-6.1 9.1-11.6 9.1H117c-5.6 0-10.5-3.9-11.7-9.4l-37.8-168c-1.7-7.5 4-14.6 11.7-14.6h24.5c5.7 0 10.7 4 11.8 9.7 15.6 78 20.1 109.5 21 122.2 1.6-10.2 7.3-32.7 29.4-122.7 1.3-5.4 6.1-9.1 11.7-9.1h29.1c5.6 0 10.4 3.8 11.7 9.2 24 100.4 28.8 124 29.6 129.4-.2-11.2-2.6-17.8 21.6-129.2 1-5.6 5.9-9.5 11.5-9.5zM384 121.9v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFile(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm160-14.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFillDrip(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 320s-64 92.65-64 128c0 35.35 28.66 64 64 64s64-28.65 64-64-64-128-64-128zm-9.37-102.94L294.94 9.37C288.69 3.12 280.5 0 272.31 0s-16.38 3.12-22.62 9.37l-81.58 81.58L81.93 4.76c-6.25-6.25-16.38-6.25-22.62 0L36.69 27.38c-6.24 6.25-6.24 16.38 0 22.62l86.19 86.18-94.76 94.76c-37.49 37.48-37.49 98.26 0 135.75l117.19 117.19c18.74 18.74 43.31 28.12 67.87 28.12 24.57 0 49.13-9.37 67.87-28.12l221.57-221.57c12.5-12.5 12.5-32.75.01-45.25zm-116.22 70.97H65.93c1.36-3.84 3.57-7.98 7.43-11.83l13.15-13.15 81.61-81.61 58.6 58.6c12.49 12.49 32.75 12.49 45.24 0s12.49-32.75 0-45.24l-58.6-58.6 58.95-58.95 162.44 162.44-48.34 48.34z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFill(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M502.63 217.06L294.94 9.37C288.69 3.12 280.5 0 272.31 0s-16.38 3.12-22.62 9.37l-81.58 81.58L81.93 4.77c-6.24-6.25-16.38-6.25-22.62 0L36.69 27.38c-6.24 6.25-6.24 16.38 0 22.63l86.19 86.18-94.76 94.76c-37.49 37.49-37.49 98.26 0 135.75l117.19 117.19c18.75 18.74 43.31 28.12 67.87 28.12 24.57 0 49.13-9.37 67.88-28.12l221.57-221.57c12.49-12.5 12.49-32.76 0-45.26zm-116.22 70.97H65.93c1.36-3.84 3.57-7.98 7.43-11.83l13.15-13.15 81.61-81.61 58.61 58.6c12.49 12.49 32.75 12.49 45.24 0 12.49-12.49 12.49-32.75 0-45.24l-58.61-58.6 58.95-58.95 162.45 162.44-48.35 48.34z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFilm(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488 64h-8v20c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12V64H96v20c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12V64h-8C10.7 64 0 74.7 0 88v336c0 13.3 10.7 24 24 24h8v-20c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v20h320v-20c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v20h8c13.3 0 24-10.7 24-24V88c0-13.3-10.7-24-24-24zM96 372c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm272 208c0 6.6-5.4 12-12 12H156c-6.6 0-12-5.4-12-12v-96c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v96zm0-168c0 6.6-5.4 12-12 12H156c-6.6 0-12-5.4-12-12v-96c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v96zm112 152c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFilter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M487.976 0H24.028C2.71 0-8.047 25.866 7.058 40.971L192 225.941V432c0 7.831 3.821 15.17 10.237 19.662l80 55.98C298.02 518.69 320 507.493 320 487.98V225.941l184.947-184.97C520.021 25.896 509.338 0 487.976 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFingerprint(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256.12 245.96c-13.25 0-24 10.74-24 24 1.14 72.25-8.14 141.9-27.7 211.55-2.73 9.72 2.15 30.49 23.12 30.49 10.48 0 20.11-6.92 23.09-17.52 13.53-47.91 31.04-125.41 29.48-224.52.01-13.25-10.73-24-23.99-24zm-.86-81.73C194 164.16 151.25 211.3 152.1 265.32c.75 47.94-3.75 95.91-13.37 142.55-2.69 12.98 5.67 25.69 18.64 28.36 13.05 2.67 25.67-5.66 28.36-18.64 10.34-50.09 15.17-101.58 14.37-153.02-.41-25.95 19.92-52.49 54.45-52.34 31.31.47 57.15 25.34 57.62 55.47.77 48.05-2.81 96.33-10.61 143.55-2.17 13.06 6.69 25.42 19.76 27.58 19.97 3.33 26.81-15.1 27.58-19.77 8.28-50.03 12.06-101.21 11.27-152.11-.88-55.8-47.94-101.88-104.91-102.72zm-110.69-19.78c-10.3-8.34-25.37-6.8-33.76 3.48-25.62 31.5-39.39 71.28-38.75 112 .59 37.58-2.47 75.27-9.11 112.05-2.34 13.05 6.31 25.53 19.36 27.89 20.11 3.5 27.07-14.81 27.89-19.36 7.19-39.84 10.5-80.66 9.86-121.33-.47-29.88 9.2-57.88 28-80.97 8.35-10.28 6.79-25.39-3.49-33.76zm109.47-62.33c-15.41-.41-30.87 1.44-45.78 4.97-12.89 3.06-20.87 15.98-17.83 28.89 3.06 12.89 16 20.83 28.89 17.83 11.05-2.61 22.47-3.77 34-3.69 75.43 1.13 137.73 61.5 138.88 134.58.59 37.88-1.28 76.11-5.58 113.63-1.5 13.17 7.95 25.08 21.11 26.58 16.72 1.95 25.51-11.88 26.58-21.11a929.06 929.06 0 0 0 5.89-119.85c-1.56-98.75-85.07-180.33-186.16-181.83zm252.07 121.45c-2.86-12.92-15.51-21.2-28.61-18.27-12.94 2.86-21.12 15.66-18.26 28.61 4.71 21.41 4.91 37.41 4.7 61.6-.11 13.27 10.55 24.09 23.8 24.2h.2c13.17 0 23.89-10.61 24-23.8.18-22.18.4-44.11-5.83-72.34zm-40.12-90.72C417.29 43.46 337.6 1.29 252.81.02 183.02-.82 118.47 24.91 70.46 72.94 24.09 119.37-.9 181.04.14 246.65l-.12 21.47c-.39 13.25 10.03 24.31 23.28 24.69.23.02.48.02.72.02 12.92 0 23.59-10.3 23.97-23.3l.16-23.64c-.83-52.5 19.16-101.86 56.28-139 38.76-38.8 91.34-59.67 147.68-58.86 69.45 1.03 134.73 35.56 174.62 92.39 7.61 10.86 22.56 13.45 33.42 5.86 10.84-7.62 13.46-22.59 5.84-33.43z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFireAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M323.56 51.2c-20.8 19.3-39.58 39.59-56.22 59.97C240.08 73.62 206.28 35.53 168 0 69.74 91.17 0 209.96 0 281.6 0 408.85 100.29 512 224 512s224-103.15 224-230.4c0-53.27-51.98-163.14-124.44-230.4zm-19.47 340.65C282.43 407.01 255.72 416 226.86 416 154.71 416 96 368.26 96 290.75c0-38.61 24.31-72.63 72.79-130.75 6.93 7.98 98.83 125.34 98.83 125.34l58.63-66.88c4.14 6.85 7.91 13.55 11.27 19.97 27.35 52.19 15.81 118.97-33.43 153.42z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFireExtinguisher(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M434.027 26.329l-168 28C254.693 56.218 256 67.8 256 72h-58.332C208.353 36.108 181.446 0 144 0c-39.435 0-66.368 39.676-52.228 76.203-52.039 13.051-75.381 54.213-90.049 90.884-4.923 12.307 1.063 26.274 13.37 31.197 12.317 4.926 26.279-1.075 31.196-13.37C75.058 112.99 106.964 120 168 120v27.076c-41.543 10.862-72 49.235-72 94.129V488c0 13.255 10.745 24 24 24h144c13.255 0 24-10.745 24-24V240c0-44.731-30.596-82.312-72-92.97V120h40c0 2.974-1.703 15.716 10.027 17.671l168 28C441.342 166.89 448 161.25 448 153.834V38.166c0-7.416-6.658-13.056-13.973-11.837zM144 72c-8.822 0-16-7.178-16-16s7.178-16 16-16 16 7.178 16 16-7.178 16-16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFire(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M216 23.86c0-23.8-30.65-32.77-44.15-13.04C48 191.85 224 200 224 288c0 35.63-29.11 64.46-64.85 63.99-35.17-.45-63.15-29.77-63.15-64.94v-85.51c0-21.7-26.47-32.23-41.43-16.5C27.8 213.16 0 261.33 0 320c0 105.87 86.13 192 192 192s192-86.13 192-192c0-170.29-168-193-168-296.14z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFirstAid(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 80v352c0 26.5 21.5 48 48 48h48V32H48C21.5 32 0 53.5 0 80zm128 400h320V32H128v448zm64-248c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48zM528 32h-48v448h48c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFish(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M327.1 96c-89.97 0-168.54 54.77-212.27 101.63L27.5 131.58c-12.13-9.18-30.24.6-27.14 14.66L24.54 256 .35 365.77c-3.1 14.06 15.01 23.83 27.14 14.66l87.33-66.05C158.55 361.23 237.13 416 327.1 416 464.56 416 576 288 576 256S464.56 96 327.1 96zm87.43 184c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24 13.26 0 24 10.74 24 24 0 13.25-10.75 24-24 24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFistRaised(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M255.98 160V16c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v146.93c5.02-1.78 10.34-2.93 15.97-2.93h48.03zm128 95.99c-.01-35.34-28.66-63.99-63.99-63.99H207.85c-8.78 0-15.9 7.07-15.9 15.85v.56c0 26.27 21.3 47.59 47.57 47.59h35.26c9.68 0 13.2 3.58 13.2 8v16.2c0 4.29-3.59 7.78-7.88 8-44.52 2.28-64.16 24.71-96.05 72.55l-6.31 9.47a7.994 7.994 0 0 1-11.09 2.22l-13.31-8.88a7.994 7.994 0 0 1-2.22-11.09l6.31-9.47c15.73-23.6 30.2-43.26 47.31-58.08-17.27-5.51-31.4-18.12-38.87-34.45-6.59 3.41-13.96 5.52-21.87 5.52h-32c-12.34 0-23.49-4.81-32-12.48C71.48 251.19 60.33 256 48 256H16c-5.64 0-10.97-1.15-16-2.95v77.93c0 33.95 13.48 66.5 37.49 90.51L63.99 448v64h255.98v-63.96l35.91-35.92A96.035 96.035 0 0 0 384 344.21l-.02-88.22zm-32.01-90.09V48c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v112h32c11.28 0 21.94 2.31 32 5.9zM16 224h32c8.84 0 16-7.16 16-16V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v128c0 8.84 7.16 16 16 16zm95.99 0h32c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v160c0 8.84 7.16 16 16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFlagCheckered(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M243.2 189.9V258c26.1 5.9 49.3 15.6 73.6 22.3v-68.2c-26-5.8-49.4-15.5-73.6-22.2zm223.3-123c-34.3 15.9-76.5 31.9-117 31.9C296 98.8 251.7 64 184.3 64c-25 0-47.3 4.4-68 12 2.8-7.3 4.1-15.2 3.6-23.6C118.1 24 94.8 1.2 66.3 0 34.3-1.3 8 24.3 8 56c0 19 9.5 35.8 24 45.9V488c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24v-94.4c28.3-12.1 63.6-22.1 114.4-22.1 53.6 0 97.8 34.8 165.2 34.8 48.2 0 86.7-16.3 122.5-40.9 8.7-6 13.8-15.8 13.8-26.4V95.9c.1-23.3-24.2-38.8-45.4-29zM169.6 325.5c-25.8 2.7-50 8.2-73.6 16.6v-70.5c26.2-9.3 47.5-15 73.6-17.4zM464 191c-23.6 9.8-46.3 19.5-73.6 23.9V286c24.8-3.4 51.4-11.8 73.6-26v70.5c-25.1 16.1-48.5 24.7-73.6 27.1V286c-27 3.7-47.9 1.5-73.6-5.6v67.4c-23.9-7.4-47.3-16.7-73.6-21.3V258c-19.7-4.4-40.8-6.8-73.6-3.8v-70c-22.4 3.1-44.6 10.2-73.6 20.9v-70.5c33.2-12.2 50.1-19.8 73.6-22v71.6c27-3.7 48.4-1.3 73.6 5.7v-67.4c23.7 7.4 47.2 16.7 73.6 21.3v68.4c23.7 5.3 47.6 6.9 73.6 2.7V143c27-4.8 52.3-13.6 73.6-22.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFlagUsa(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 0C14.3 0 0 14.3 0 32v464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V32C64 14.3 49.7 0 32 0zm267.9 303.6c-57.2-15.1-111.7-28.8-203.9 11.1V384c185.7-92.2 221.7 53.3 397.5-23.1 11.4-5 18.5-16.5 18.5-28.8v-36c-43.6 17.3-80.2 24.1-112.1 24.1-37.4-.1-68.9-8.4-100-16.6zm0-96c-57.2-15.1-111.7-28.8-203.9 11.1v61.5c94.8-37.6 154.6-22.7 212.1-7.6 57.2 15.1 111.7 28.8 203.9-11.1V200c-43.6 17.3-80.2 24.1-112.1 24.1-37.4 0-68.9-8.3-100-16.5zm9.5-125.9c51.8 15.6 97.4 29 202.6-20.1V30.8c0-25.1-26.8-38.1-49.4-26.6C291.3 91.5 305.4-62.2 96 32.4v151.9c94.8-37.5 154.6-22.7 212.1-7.6 57.2 15 111.7 28.7 203.9-11.1V96.7c-53.6 23.5-93.3 31.4-126.1 31.4s-59-7.8-85.7-15.9c-4-1.2-8.1-2.4-12.1-3.5V75.5c7.2 2 14.3 4.1 21.3 6.2zM160 128.1c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16-7.2 16-16 16zm0-55.8c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16c0 8.8-7.2 16-16 16zm64 47.9c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16c0 8.8-7.2 16-16 16zm0-55.9c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16c0 8.8-7.2 16-16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFlag(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M349.565 98.783C295.978 98.783 251.721 64 184.348 64c-24.955 0-47.309 4.384-68.045 12.013a55.947 55.947 0 0 0 3.586-23.562C118.117 24.015 94.806 1.206 66.338.048 34.345-1.254 8 24.296 8 56c0 19.026 9.497 35.825 24 45.945V488c0 13.255 10.745 24 24 24h16c13.255 0 24-10.745 24-24v-94.4c28.311-12.064 63.582-22.122 114.435-22.122 53.588 0 97.844 34.783 165.217 34.783 48.169 0 86.667-16.294 122.505-40.858C506.84 359.452 512 349.571 512 339.045v-243.1c0-23.393-24.269-38.87-45.485-29.016-34.338 15.948-76.454 31.854-116.95 31.854z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFlask(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M437.2 403.5L320 215V64h8c13.3 0 24-10.7 24-24V24c0-13.3-10.7-24-24-24H120c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h8v151L10.8 403.5C-18.5 450.6 15.3 512 70.9 512h306.2c55.7 0 89.4-61.5 60.1-108.5zM137.9 320l48.2-77.6c3.7-5.2 5.8-11.6 5.8-18.4V64h64v160c0 6.9 2.2 13.2 5.8 18.4l48.2 77.6h-172z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFlushed(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M344 200c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm-192 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM80 224c0-39.8 32.2-72 72-72s72 32.2 72 72-32.2 72-72 72-72-32.2-72-72zm232 176H184c-21.2 0-21.2-32 0-32h128c21.2 0 21.2 32 0 32zm32-104c-39.8 0-72-32.2-72-72s32.2-72 72-72 72 32.2 72 72-32.2 72-72 72z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFolderMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 128H272l-64-64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48zm-96 168c0 8.84-7.16 16-16 16H160c-8.84 0-16-7.16-16-16v-16c0-8.84 7.16-16 16-16h192c8.84 0 16 7.16 16 16v16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFolderOpen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M572.694 292.093L500.27 416.248A63.997 63.997 0 0 1 444.989 448H45.025c-18.523 0-30.064-20.093-20.731-36.093l72.424-124.155A64 64 0 0 1 152 256h399.964c18.523 0 30.064 20.093 20.73 36.093zM152 224h328v-48c0-26.51-21.49-48-48-48H272l-64-64H48C21.49 64 0 85.49 0 112v278.046l69.077-118.418C86.214 242.25 117.989 224 152 224z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFolderPlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464,128H272L208,64H48A48,48,0,0,0,0,112V400a48,48,0,0,0,48,48H464a48,48,0,0,0,48-48V176A48,48,0,0,0,464,128ZM359.5,296a16,16,0,0,1-16,16h-64v64a16,16,0,0,1-16,16h-16a16,16,0,0,1-16-16V312h-64a16,16,0,0,1-16-16V280a16,16,0,0,1,16-16h64V200a16,16,0,0,1,16-16h16a16,16,0,0,1,16,16v64h64a16,16,0,0,1,16,16Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFolder(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 128H272l-64-64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFont(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 416h-23.41L277.88 53.69A32 32 0 0 0 247.58 32h-47.16a32 32 0 0 0-30.3 21.69L39.41 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-19.58l23.3-64h152.56l23.3 64H304a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM176.85 272L224 142.51 271.15 272z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFootballBall(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M481.5 60.3c-4.8-18.2-19.1-32.5-37.3-37.4C420.3 16.5 383 8.9 339.4 8L496 164.8c-.8-43.5-8.2-80.6-14.5-104.5zm-467 391.4c4.8 18.2 19.1 32.5 37.3 37.4 23.9 6.4 61.2 14 104.8 14.9L0 347.2c.8 43.5 8.2 80.6 14.5 104.5zM4.2 283.4L220.4 500c132.5-19.4 248.8-118.7 271.5-271.4L275.6 12C143.1 31.4 26.8 130.7 4.2 283.4zm317.3-123.6c3.1-3.1 8.2-3.1 11.3 0l11.3 11.3c3.1 3.1 3.1 8.2 0 11.3l-28.3 28.3 28.3 28.3c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-28.3-28.3-22.6 22.7 28.3 28.3c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0L248 278.6l-22.6 22.6 28.3 28.3c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-28.3-28.3-28.3 28.3c-3.1 3.1-8.2 3.1-11.3 0l-11.3-11.3c-3.1-3.1-3.1-8.2 0-11.3l28.3-28.3-28.3-28.2c-3.1-3.1-3.1-8.2 0-11.3l11.3-11.3c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3 22.6-22.6-28.3-28.3c-3.1-3.1-3.1-8.2 0-11.3l11.3-11.3c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3 22.6-22.6-28.3-28.3c-3.1-3.1-3.1-8.2 0-11.3l11.3-11.3c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3 28.3-28.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaForward(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M500.5 231.4l-192-160C287.9 54.3 256 68.6 256 96v320c0 27.4 31.9 41.8 52.5 24.6l192-160c15.3-12.8 15.3-36.4 0-49.2zm-256 0l-192-160C31.9 54.3 0 68.6 0 96v320c0 27.4 31.9 41.8 52.5 24.6l192-160c15.3-12.8 15.3-36.4 0-49.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFrog(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M446.53 97.43C439.67 60.23 407.19 32 368 32c-39.23 0-71.72 28.29-78.54 65.54C126.75 112.96-.5 250.12 0 416.98.11 451.9 29.08 480 64 480h304c8.84 0 16-7.16 16-16 0-17.67-14.33-32-32-32h-79.49l35.8-48.33c24.14-36.23 10.35-88.28-33.71-106.6-23.89-9.93-51.55-4.65-72.24 10.88l-32.76 24.59c-7.06 5.31-17.09 3.91-22.41-3.19-5.3-7.08-3.88-17.11 3.19-22.41l34.78-26.09c36.84-27.66 88.28-27.62 125.13 0 10.87 8.15 45.87 39.06 40.8 93.21L469.62 480H560c8.84 0 16-7.16 16-16 0-17.67-14.33-32-32-32h-53.63l-98.52-104.68 154.44-86.65A58.16 58.16 0 0 0 576 189.94c0-21.4-11.72-40.95-30.48-51.23-40.56-22.22-98.99-41.28-98.99-41.28zM368 136c-13.26 0-24-10.75-24-24 0-13.26 10.74-24 24-24 13.25 0 24 10.74 24 24 0 13.25-10.75 24-24 24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFrownOpen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM136 208c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm187.3 183.3c-31.2-9.6-59.4-15.3-75.3-15.3s-44.1 5.7-75.3 15.3c-11.5 3.5-22.5-6.3-20.5-18.1 7-40 60.1-61.2 95.8-61.2s88.8 21.3 95.8 61.2c2 11.9-9.1 21.6-20.5 18.1zM328 240c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFrown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm170.2 218.2C315.8 367.4 282.9 352 248 352s-67.8 15.4-90.2 42.2c-13.5 16.3-38.1-4.2-24.6-20.5C161.7 339.6 203.6 320 248 320s86.3 19.6 114.7 53.8c13.6 16.2-11 36.7-24.5 20.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFunnelDollar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M433.46 165.94l101.2-111.87C554.61 34.12 540.48 0 512.26 0H31.74C3.52 0-10.61 34.12 9.34 54.07L192 256v155.92c0 12.59 5.93 24.44 16 32l79.99 60c20.86 15.64 48.47 6.97 59.22-13.57C310.8 455.38 288 406.35 288 352c0-89.79 62.05-165.17 145.46-186.06zM480 192c-88.37 0-160 71.63-160 160s71.63 160 160 160 160-71.63 160-160-71.63-160-160-160zm16 239.88V448c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-16.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V256c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.04 44.44-42.67 45.07z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaFutbol(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zm-48 0l-.003-.282-26.064 22.741-62.679-58.5 16.454-84.355 34.303 3.072c-24.889-34.216-60.004-60.089-100.709-73.141l13.651 31.939L256 139l-74.953-41.525 13.651-31.939c-40.631 13.028-75.78 38.87-100.709 73.141l34.565-3.073 16.192 84.355-62.678 58.5-26.064-22.741-.003.282c0 43.015 13.497 83.952 38.472 117.991l7.704-33.897 85.138 10.447 36.301 77.826-29.902 17.786c40.202 13.122 84.29 13.148 124.572 0l-29.902-17.786 36.301-77.826 85.138-10.447 7.704 33.897C442.503 339.952 456 299.015 456 256zm-248.102 69.571l-29.894-91.312L256 177.732l77.996 56.527-29.622 91.312h-96.476z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGamepad(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480.07 96H160a160 160 0 1 0 114.24 272h91.52A160 160 0 1 0 480.07 96zM248 268a12 12 0 0 1-12 12h-52v52a12 12 0 0 1-12 12h-24a12 12 0 0 1-12-12v-52H84a12 12 0 0 1-12-12v-24a12 12 0 0 1 12-12h52v-52a12 12 0 0 1 12-12h24a12 12 0 0 1 12 12v52h52a12 12 0 0 1 12 12zm216 76a40 40 0 1 1 40-40 40 40 0 0 1-40 40zm64-96a40 40 0 1 1 40-40 40 40 0 0 1-40 40z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGasPump(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 448H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm157.2-340.7l-81-81c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-6.2 6.2-6.2 16.4 0 22.6L416 97.9V160c0 28.1 20.9 51.3 48 55.2V376c0 13.2-10.8 24-24 24s-24-10.8-24-24v-32c0-48.6-39.4-88-88-88h-8V64c0-35.3-28.7-64-64-64H96C60.7 0 32 28.7 32 64v352h288V304h8c22.1 0 40 17.9 40 40v27.8c0 37.7 27 72 64.5 75.9 43 4.3 79.5-29.5 79.5-71.7V152.6c0-17-6.8-33.3-18.8-45.3zM256 192H96V64h160v128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGavel(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504.971 199.362l-22.627-22.627c-9.373-9.373-24.569-9.373-33.941 0l-5.657 5.657L329.608 69.255l5.657-5.657c9.373-9.373 9.373-24.569 0-33.941L312.638 7.029c-9.373-9.373-24.569-9.373-33.941 0L154.246 131.48c-9.373 9.373-9.373 24.569 0 33.941l22.627 22.627c9.373 9.373 24.569 9.373 33.941 0l5.657-5.657 39.598 39.598-81.04 81.04-5.657-5.657c-12.497-12.497-32.758-12.497-45.255 0L9.373 412.118c-12.497 12.497-12.497 32.758 0 45.255l45.255 45.255c12.497 12.497 32.758 12.497 45.255 0l114.745-114.745c12.497-12.497 12.497-32.758 0-45.255l-5.657-5.657 81.04-81.04 39.598 39.598-5.657 5.657c-9.373 9.373-9.373 24.569 0 33.941l22.627 22.627c9.373 9.373 24.569 9.373 33.941 0l124.451-124.451c9.372-9.372 9.372-24.568 0-33.941z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGem(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M485.5 0L576 160H474.9L405.7 0h79.8zm-128 0l69.2 160H149.3L218.5 0h139zm-267 0h79.8l-69.2 160H0L90.5 0zM0 192h100.7l123 251.7c1.5 3.1-2.7 5.9-5 3.3L0 192zm148.2 0h279.6l-137 318.2c-1 2.4-4.5 2.4-5.5 0L148.2 192zm204.1 251.7l123-251.7H576L357.3 446.9c-2.3 2.7-6.5-.1-5-3.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGenderless(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 288 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGhost(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M186.1.09C81.01 3.24 0 94.92 0 200.05v263.92c0 14.26 17.23 21.39 27.31 11.31l24.92-18.53c6.66-4.95 16-3.99 21.51 2.21l42.95 48.35c6.25 6.25 16.38 6.25 22.63 0l40.72-45.85c6.37-7.17 17.56-7.17 23.92 0l40.72 45.85c6.25 6.25 16.38 6.25 22.63 0l42.95-48.35c5.51-6.2 14.85-7.17 21.51-2.21l24.92 18.53c10.08 10.08 27.31 2.94 27.31-11.31V192C384 84 294.83-3.17 186.1.09zM128 224c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm128 0c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGift(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 448c0 17.7 14.3 32 32 32h160V320H32v128zm256 32h160c17.7 0 32-14.3 32-32V320H288v160zm192-320h-42.1c6.2-12.1 10.1-25.5 10.1-40 0-48.5-39.5-88-88-88-41.6 0-68.5 21.3-103 68.3-34.5-47-61.4-68.3-103-68.3-48.5 0-88 39.5-88 88 0 14.5 3.8 27.9 10.1 40H32c-17.7 0-32 14.3-32 32v80c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-80c0-17.7-14.3-32-32-32zm-326.1 0c-22.1 0-40-17.9-40-40s17.9-40 40-40c19.9 0 34.6 3.3 86.1 80h-86.1zm206.1 0h-86.1c51.4-76.5 65.7-80 86.1-80 22.1 0 40 17.9 40 40s-17.9 40-40 40z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGifts(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M240.6 194.1c1.9-30.8 17.3-61.2 44-79.8C279.4 103.5 268.7 96 256 96h-29.4l30.7-22c7.2-5.1 8.9-15.1 3.7-22.3l-9.3-13c-5.1-7.2-15.1-8.9-22.3-3.7l-32 22.9 11.5-30.6c3.1-8.3-1.1-17.5-9.4-20.6l-15-5.6c-8.3-3.1-17.5 1.1-20.6 9.4l-19.9 53-19.9-53.1C121 2.1 111.8-2.1 103.5 1l-15 5.6C80.2 9.7 76 19 79.2 27.2l11.5 30.6L58.6 35c-7.2-5.1-17.2-3.5-22.3 3.7l-9.3 13c-5.1 7.2-3.5 17.2 3.7 22.3l30.7 22H32c-17.7 0-32 14.3-32 32v352c0 17.7 14.3 32 32 32h168.9c-5.5-9.5-8.9-20.3-8.9-32V256c0-29.9 20.8-55 48.6-61.9zM224 480c0 17.7 14.3 32 32 32h160V384H224v96zm224 32h160c17.7 0 32-14.3 32-32v-96H448v128zm160-288h-20.4c2.6-7.6 4.4-15.5 4.4-23.8 0-35.5-27-72.2-72.1-72.2-48.1 0-75.9 47.7-87.9 75.3-12.1-27.6-39.9-75.3-87.9-75.3-45.1 0-72.1 36.7-72.1 72.2 0 8.3 1.7 16.2 4.4 23.8H256c-17.7 0-32 14.3-32 32v96h192V224h15.3l.7-.2.7.2H448v128h192v-96c0-17.7-14.3-32-32-32zm-272 0c-2.7-1.4-5.1-3-7.2-4.8-7.3-6.4-8.8-13.8-8.8-19 0-9.7 6.4-24.2 24.1-24.2 18.7 0 35.6 27.4 44.5 48H336zm199.2-4.8c-2.1 1.8-4.5 3.4-7.2 4.8h-52.6c8.8-20.3 25.8-48 44.5-48 17.7 0 24.1 14.5 24.1 24.2 0 5.2-1.5 12.6-8.8 19z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGlassCheers(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M639.4 433.6c-8.4-20.4-31.8-30.1-52.2-21.6l-22.1 9.2-38.7-101.9c47.9-35 64.8-100.3 34.5-152.8L474.3 16c-8-13.9-25.1-19.7-40-13.6L320 49.8 205.7 2.4c-14.9-6.2-32-.3-40 13.6L79.1 166.5C48.9 219 65.7 284.3 113.6 319.2L74.9 421.1l-22.1-9.2c-20.4-8.5-43.7 1.2-52.2 21.6-1.7 4.1.2 8.8 4.3 10.5l162.3 67.4c4.1 1.7 8.7-.2 10.4-4.3 8.4-20.4-1.2-43.8-21.6-52.3l-22.1-9.2L173.3 342c4.4.5 8.8 1.3 13.1 1.3 51.7 0 99.4-33.1 113.4-85.3l20.2-75.4 20.2 75.4c14 52.2 61.7 85.3 113.4 85.3 4.3 0 8.7-.8 13.1-1.3L506 445.6l-22.1 9.2c-20.4 8.5-30.1 31.9-21.6 52.3 1.7 4.1 6.4 6 10.4 4.3L635.1 444c4-1.7 6-6.3 4.3-10.4zM275.9 162.1l-112.1-46.5 36.5-63.4 94.5 39.2-18.9 70.7zm88.2 0l-18.9-70.7 94.5-39.2 36.5 63.4-112.1 46.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGlassMartiniAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M502.05 57.6C523.3 36.34 508.25 0 478.2 0H33.8C3.75 0-11.3 36.34 9.95 57.6L224 271.64V464h-56c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h240c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40h-56V271.64L502.05 57.6zM443.77 48l-48 48H116.24l-48-48h375.53z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGlassMartini(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M502.05 57.6C523.3 36.34 508.25 0 478.2 0H33.8C3.75 0-11.3 36.34 9.95 57.6L224 271.64V464h-56c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h240c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40h-56V271.64L502.05 57.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGlassWhiskey(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 32H32C12.5 32-2.4 49.2.3 68.5l56 356.5c4.5 31.5 31.5 54.9 63.4 54.9h273c31.8 0 58.9-23.4 63.4-54.9l55.6-356.5C514.4 49.2 499.5 32 480 32zm-37.4 64l-30 192h-313L69.4 96h373.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGlasses(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M574.1 280.37L528.75 98.66c-5.91-23.7-21.59-44.05-43-55.81-21.44-11.73-46.97-14.11-70.19-6.33l-15.25 5.08c-8.39 2.79-12.92 11.86-10.12 20.24l5.06 15.18c2.79 8.38 11.85 12.91 20.23 10.12l13.18-4.39c10.87-3.62 23-3.57 33.16 1.73 10.29 5.37 17.57 14.56 20.37 25.82l38.46 153.82c-22.19-6.81-49.79-12.46-81.2-12.46-34.77 0-73.98 7.02-114.85 26.74h-73.18c-40.87-19.74-80.08-26.75-114.86-26.75-31.42 0-59.02 5.65-81.21 12.46l38.46-153.83c2.79-11.25 10.09-20.45 20.38-25.81 10.16-5.3 22.28-5.35 33.15-1.73l13.17 4.39c8.38 2.79 17.44-1.74 20.23-10.12l5.06-15.18c2.8-8.38-1.73-17.45-10.12-20.24l-15.25-5.08c-23.22-7.78-48.75-5.41-70.19 6.33-21.41 11.77-37.09 32.11-43 55.8L1.9 280.37A64.218 64.218 0 0 0 0 295.86v70.25C0 429.01 51.58 480 115.2 480h37.12c60.28 0 110.37-45.94 114.88-105.37l2.93-38.63h35.75l2.93 38.63C313.31 434.06 363.4 480 423.68 480h37.12c63.62 0 115.2-50.99 115.2-113.88v-70.25c0-5.23-.64-10.43-1.9-15.5zm-370.72 89.42c-1.97 25.91-24.4 46.21-51.06 46.21H115.2C86.97 416 64 393.62 64 366.11v-37.54c18.12-6.49 43.42-12.92 72.58-12.92 23.86 0 47.26 4.33 69.93 12.92l-3.13 41.22zM512 366.12c0 27.51-22.97 49.88-51.2 49.88h-37.12c-26.67 0-49.1-20.3-51.06-46.21l-3.13-41.22c22.67-8.59 46.08-12.92 69.95-12.92 29.12 0 54.43 6.44 72.55 12.93v37.54z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGlobeAfrica(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm160 215.5v6.93c0 5.87-3.32 11.24-8.57 13.86l-15.39 7.7a15.485 15.485 0 0 1-15.53-.97l-18.21-12.14a15.52 15.52 0 0 0-13.5-1.81l-2.65.88c-9.7 3.23-13.66 14.79-7.99 23.3l13.24 19.86c2.87 4.31 7.71 6.9 12.89 6.9h8.21c8.56 0 15.5 6.94 15.5 15.5v11.34c0 3.35-1.09 6.62-3.1 9.3l-18.74 24.98c-1.42 1.9-2.39 4.1-2.83 6.43l-4.3 22.83c-.62 3.29-2.29 6.29-4.76 8.56a159.608 159.608 0 0 0-25 29.16l-13.03 19.55a27.756 27.756 0 0 1-23.09 12.36c-10.51 0-20.12-5.94-24.82-15.34a78.902 78.902 0 0 1-8.33-35.29V367.5c0-8.56-6.94-15.5-15.5-15.5h-25.88c-14.49 0-28.38-5.76-38.63-16a54.659 54.659 0 0 1-16-38.63v-14.06c0-17.19 8.1-33.38 21.85-43.7l27.58-20.69a54.663 54.663 0 0 1 32.78-10.93h.89c8.48 0 16.85 1.97 24.43 5.77l14.72 7.36c3.68 1.84 7.93 2.14 11.83.84l47.31-15.77c6.33-2.11 10.6-8.03 10.6-14.7 0-8.56-6.94-15.5-15.5-15.5h-10.09c-4.11 0-8.05-1.63-10.96-4.54l-6.92-6.92a15.493 15.493 0 0 0-10.96-4.54H199.5c-8.56 0-15.5-6.94-15.5-15.5v-4.4c0-7.11 4.84-13.31 11.74-15.04l14.45-3.61c3.74-.94 7-3.23 9.14-6.44l8.08-12.11c2.87-4.31 7.71-6.9 12.89-6.9h24.21c8.56 0 15.5-6.94 15.5-15.5v-21.7C359.23 71.63 422.86 131.02 441.93 208H423.5c-8.56 0-15.5 6.94-15.5 15.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGlobeAmericas(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm82.29 357.6c-3.9 3.88-7.99 7.95-11.31 11.28-2.99 3-5.1 6.7-6.17 10.71-1.51 5.66-2.73 11.38-4.77 16.87l-17.39 46.85c-13.76 3-28 4.69-42.65 4.69v-27.38c1.69-12.62-7.64-36.26-22.63-51.25-6-6-9.37-14.14-9.37-22.63v-32.01c0-11.64-6.27-22.34-16.46-27.97-14.37-7.95-34.81-19.06-48.81-26.11-11.48-5.78-22.1-13.14-31.65-21.75l-.8-.72a114.792 114.792 0 0 1-18.06-20.74c-9.38-13.77-24.66-36.42-34.59-51.14 20.47-45.5 57.36-82.04 103.2-101.89l24.01 12.01C203.48 89.74 216 82.01 216 70.11v-11.3c7.99-1.29 16.12-2.11 24.39-2.42l28.3 28.3c6.25 6.25 6.25 16.38 0 22.63L264 112l-10.34 10.34c-3.12 3.12-3.12 8.19 0 11.31l4.69 4.69c3.12 3.12 3.12 8.19 0 11.31l-8 8a8.008 8.008 0 0 1-5.66 2.34h-8.99c-2.08 0-4.08.81-5.58 2.27l-9.92 9.65a8.008 8.008 0 0 0-1.58 9.31l15.59 31.19c2.66 5.32-1.21 11.58-7.15 11.58h-5.64c-1.93 0-3.79-.7-5.24-1.96l-9.28-8.06a16.017 16.017 0 0 0-15.55-3.1l-31.17 10.39a11.95 11.95 0 0 0-8.17 11.34c0 4.53 2.56 8.66 6.61 10.69l11.08 5.54c9.41 4.71 19.79 7.16 30.31 7.16s22.59 27.29 32 32h66.75c8.49 0 16.62 3.37 22.63 9.37l13.69 13.69a30.503 30.503 0 0 1 8.93 21.57 46.536 46.536 0 0 1-13.72 32.98zM417 274.25c-5.79-1.45-10.84-5-14.15-9.97l-17.98-26.97a23.97 23.97 0 0 1 0-26.62l19.59-29.38c2.32-3.47 5.5-6.29 9.24-8.15l12.98-6.49C440.2 193.59 448 223.87 448 256c0 8.67-.74 17.16-1.82 25.54L417 274.25z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGlobeAsia(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm-11.34 240.23c-2.89 4.82-8.1 7.77-13.72 7.77h-.31c-4.24 0-8.31 1.69-11.31 4.69l-5.66 5.66c-3.12 3.12-3.12 8.19 0 11.31l5.66 5.66c3 3 4.69 7.07 4.69 11.31V304c0 8.84-7.16 16-16 16h-6.11c-6.06 0-11.6-3.42-14.31-8.85l-22.62-45.23c-2.44-4.88-8.95-5.94-12.81-2.08l-19.47 19.46c-3 3-7.07 4.69-11.31 4.69H50.81C49.12 277.55 48 266.92 48 256c0-110.28 89.72-200 200-200 21.51 0 42.2 3.51 61.63 9.82l-50.16 38.53c-5.11 3.41-4.63 11.06.86 13.81l10.83 5.41c5.42 2.71 8.84 8.25 8.84 14.31V216c0 4.42-3.58 8-8 8h-3.06c-3.03 0-5.8-1.71-7.15-4.42-1.56-3.12-5.96-3.29-7.76-.3l-17.37 28.95zM408 358.43c0 4.24-1.69 8.31-4.69 11.31l-9.57 9.57c-3 3-7.07 4.69-11.31 4.69h-15.16c-4.24 0-8.31-1.69-11.31-4.69l-13.01-13.01a26.767 26.767 0 0 0-25.42-7.04l-21.27 5.32c-1.27.32-2.57.48-3.88.48h-10.34c-4.24 0-8.31-1.69-11.31-4.69l-11.91-11.91a8.008 8.008 0 0 1-2.34-5.66v-10.2c0-3.27 1.99-6.21 5.03-7.43l39.34-15.74c1.98-.79 3.86-1.82 5.59-3.05l23.71-16.89a7.978 7.978 0 0 1 4.64-1.48h12.09c3.23 0 6.15 1.94 7.39 4.93l5.35 12.85a4 4 0 0 0 3.69 2.46h3.8c1.78 0 3.35-1.18 3.84-2.88l4.2-14.47c.5-1.71 2.06-2.88 3.84-2.88h6.06c2.21 0 4 1.79 4 4v12.93c0 2.12.84 4.16 2.34 5.66l11.91 11.91c3 3 4.69 7.07 4.69 11.31v24.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGlobeEurope(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm200 248c0 22.5-3.9 44.2-10.8 64.4h-20.3c-4.3 0-8.4-1.7-11.4-4.8l-32-32.6c-4.5-4.6-4.5-12.1.1-16.7l12.5-12.5v-8.7c0-3-1.2-5.9-3.3-8l-9.4-9.4c-2.1-2.1-5-3.3-8-3.3h-16c-6.2 0-11.3-5.1-11.3-11.3 0-3 1.2-5.9 3.3-8l9.4-9.4c2.1-2.1 5-3.3 8-3.3h32c6.2 0 11.3-5.1 11.3-11.3v-9.4c0-6.2-5.1-11.3-11.3-11.3h-36.7c-8.8 0-16 7.2-16 16v4.5c0 6.9-4.4 13-10.9 15.2l-31.6 10.5c-3.3 1.1-5.5 4.1-5.5 7.6v2.2c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8s-3.6-8-8-8H247c-3 0-5.8 1.7-7.2 4.4l-9.4 18.7c-2.7 5.4-8.2 8.8-14.3 8.8H194c-8.8 0-16-7.2-16-16V199c0-4.2 1.7-8.3 4.7-11.3l20.1-20.1c4.6-4.6 7.2-10.9 7.2-17.5 0-3.4 2.2-6.5 5.5-7.6l40-13.3c1.7-.6 3.2-1.5 4.4-2.7l26.8-26.8c2.1-2.1 3.3-5 3.3-8 0-6.2-5.1-11.3-11.3-11.3H258l-16 16v8c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-20c0-2.5 1.2-4.9 3.2-6.4l28.9-21.7c1.9-.1 3.8-.3 5.7-.3C358.3 56 448 145.7 448 256zM130.1 149.1c0-3 1.2-5.9 3.3-8l25.4-25.4c2.1-2.1 5-3.3 8-3.3 6.2 0 11.3 5.1 11.3 11.3v16c0 3-1.2 5.9-3.3 8l-9.4 9.4c-2.1 2.1-5 3.3-8 3.3h-16c-6.2 0-11.3-5.1-11.3-11.3zm128 306.4v-7.1c0-8.8-7.2-16-16-16h-20.2c-10.8 0-26.7-5.3-35.4-11.8l-22.2-16.7c-11.5-8.6-18.2-22.1-18.2-36.4v-23.9c0-16 8.4-30.8 22.1-39l42.9-25.7c7.1-4.2 15.2-6.5 23.4-6.5h31.2c10.9 0 21.4 3.9 29.6 10.9l43.2 37.1h18.3c8.5 0 16.6 3.4 22.6 9.4l17.3 17.3c3.4 3.4 8.1 5.3 12.9 5.3H423c-32.4 58.9-93.8 99.5-164.9 103.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGlobe(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336.5 160C322 70.7 287.8 8 248 8s-74 62.7-88.5 152h177zM152 256c0 22.2 1.2 43.5 3.3 64h185.3c2.1-20.5 3.3-41.8 3.3-64s-1.2-43.5-3.3-64H155.3c-2.1 20.5-3.3 41.8-3.3 64zm324.7-96c-28.6-67.9-86.5-120.4-158-141.6 24.4 33.8 41.2 84.7 50 141.6h108zM177.2 18.4C105.8 39.6 47.8 92.1 19.3 160h108c8.7-56.9 25.5-107.8 49.9-141.6zM487.4 192H372.7c2.1 21 3.3 42.5 3.3 64s-1.2 43-3.3 64h114.6c5.5-20.5 8.6-41.8 8.6-64s-3.1-43.5-8.5-64zM120 256c0-21.5 1.2-43 3.3-64H8.6C3.2 212.5 0 233.8 0 256s3.2 43.5 8.6 64h114.6c-2-21-3.2-42.5-3.2-64zm39.5 96c14.5 89.3 48.7 152 88.5 152s74-62.7 88.5-152h-177zm159.3 141.6c71.4-21.2 129.4-73.7 158-141.6h-108c-8.8 56.9-25.6 107.8-50 141.6zM19.3 352c28.6 67.9 86.5 120.4 158 141.6-24.4-33.8-41.2-84.7-50-141.6h-108z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGolfBall(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 416 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 416h224c0 17.7-14.3 32-32 32h-16c-17.7 0-32 14.3-32 32v20c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-20c0-17.7-14.3-32-32-32h-16c-17.7 0-32-14.3-32-32zm320-208c0 74.2-39 139.2-97.5 176h-221C39 347.2 0 282.2 0 208 0 93.1 93.1 0 208 0s208 93.1 208 208zm-180.1 43.9c18.3 0 33.1-14.8 33.1-33.1 0-14.4-9.3-26.3-22.1-30.9 9.6 26.8-15.6 51.3-41.9 41.9 4.6 12.8 16.5 22.1 30.9 22.1zm49.1 46.9c0-14.4-9.3-26.3-22.1-30.9 9.6 26.8-15.6 51.3-41.9 41.9 4.6 12.8 16.5 22.1 30.9 22.1 18.3 0 33.1-14.9 33.1-33.1zm64-64c0-14.4-9.3-26.3-22.1-30.9 9.6 26.8-15.6 51.3-41.9 41.9 4.6 12.8 16.5 22.1 30.9 22.1 18.3 0 33.1-14.9 33.1-33.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGopuram(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 352h-16V240c0-8.8-7.2-16-16-16h-16v-80c0-8.8-7.2-16-16-16h-16V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-64V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-64V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-64V16c0-8.8-7.2-16-16-16S96 7.2 96 16v112H80c-8.8 0-16 7.2-16 16v80H48c-8.8 0-16 7.2-16 16v112H16c-8.8 0-16 7.2-16 16v128c0 8.8 7.2 16 16 16h80V352h32V224h32v-96h32v96h-32v128h-32v160h80v-80c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v80h80V352h-32V224h-32v-96h32v96h32v128h32v160h80c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16zM232 176c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v48h-48zm56 176h-64v-64c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGraduationCap(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M622.34 153.2L343.4 67.5c-15.2-4.67-31.6-4.67-46.79 0L17.66 153.2c-23.54 7.23-23.54 38.36 0 45.59l48.63 14.94c-10.67 13.19-17.23 29.28-17.88 46.9C38.78 266.15 32 276.11 32 288c0 10.78 5.68 19.85 13.86 25.65L20.33 428.53C18.11 438.52 25.71 448 35.94 448h56.11c10.24 0 17.84-9.48 15.62-19.47L82.14 313.65C90.32 307.85 96 298.78 96 288c0-11.57-6.47-21.25-15.66-26.87.76-15.02 8.44-28.3 20.69-36.72L296.6 284.5c9.06 2.78 26.44 6.25 46.79 0l278.95-85.7c23.55-7.24 23.55-38.36 0-45.6zM352.79 315.09c-28.53 8.76-52.84 3.92-65.59 0l-145.02-44.55L128 384c0 35.35 85.96 64 192 64s192-28.65 192-64l-14.18-113.47-145.03 44.56z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGreaterThanEqual(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M55.22 107.69l175.56 68.09-175.44 68.05c-18.39 6.03-27.88 24.39-21.2 41l12.09 30.08c6.68 16.61 26.99 25.19 45.38 19.15L393.02 214.2c13.77-4.52 22.98-16.61 22.98-30.17v-15.96c0-13.56-9.21-25.65-22.98-30.17L91.3 17.92c-18.29-6-38.51 2.53-45.15 19.06L34.12 66.9c-6.64 16.53 2.81 34.79 21.1 40.79zM424 400H24c-13.25 0-24 10.74-24 24v48c0 13.25 10.75 24 24 24h400c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGreaterThan(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M365.52 209.85L59.22 67.01c-16.06-7.49-35.15-.54-42.64 15.52L3.01 111.61c-7.49 16.06-.54 35.15 15.52 42.64L236.96 256.1 18.49 357.99C2.47 365.46-4.46 384.5 3.01 400.52l13.52 29C24 445.54 43.04 452.47 59.06 445l306.47-142.91a32.003 32.003 0 0 0 18.48-29v-34.23c-.01-12.45-7.21-23.76-18.49-29.01z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGrimace(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM144 400h-8c-17.7 0-32-14.3-32-32v-8h40v40zm0-56h-40v-8c0-17.7 14.3-32 32-32h8v40zm-8-136c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm72 192h-48v-40h48v40zm0-56h-48v-40h48v40zm64 56h-48v-40h48v40zm0-56h-48v-40h48v40zm64 56h-48v-40h48v40zm0-56h-48v-40h48v40zm-8-104c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm64 128c0 17.7-14.3 32-32 32h-8v-40h40v8zm0-24h-40v-40h8c17.7 0 32 14.3 32 32v8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGrinAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm63.7 128.7c7.6-11.4 24.7-11.7 32.7 0 12.4 18.4 15.1 36.9 15.7 55.3-.5 18.4-3.3 36.9-15.7 55.3-7.6 11.4-24.7 11.7-32.7 0-12.4-18.4-15.1-36.9-15.7-55.3.5-18.4 3.3-36.9 15.7-55.3zm-160 0c7.6-11.4 24.7-11.7 32.7 0 12.4 18.4 15.1 36.9 15.7 55.3-.5 18.4-3.3 36.9-15.7 55.3-7.6 11.4-24.7 11.7-32.7 0-12.4-18.4-15.1-36.9-15.7-55.3.5-18.4 3.3-36.9 15.7-55.3zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGrinBeamSweat(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 504 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M456 128c26.5 0 48-21 48-47 0-20-28.5-60.4-41.6-77.8-3.2-4.3-9.6-4.3-12.8 0C436.5 20.6 408 61 408 81c0 26 21.5 47 48 47zm0 32c-44.1 0-80-35.4-80-79 0-4.4.3-14.2 8.1-32.2C345 23.1 298.3 8 248 8 111 8 0 119 0 256s111 248 248 248 248-111 248-248c0-35.1-7.4-68.4-20.5-98.6-6.3 1.5-12.7 2.6-19.5 2.6zm-128-8c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm-160 0c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm80 280c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.2 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGrinBeam(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 144c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.3-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm-160 0c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm80 280c-60.6 0-134.5-38.3-143.8-93.3-2-11.9 9.4-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGrinHearts(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM90.4 183.6c6.7-17.6 26.7-26.7 44.9-21.9l7.1 1.9 2-7.1c5-18.1 22.8-30.9 41.5-27.9 21.4 3.4 34.4 24.2 28.8 44.5L195.3 243c-1.2 4.5-5.9 7.2-10.5 6l-70.2-18.2c-20.4-5.4-31.9-27-24.2-47.2zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.2-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.6 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3zm133.4-201.3l-70.2 18.2c-4.5 1.2-9.2-1.5-10.5-6L281.3 173c-5.6-20.3 7.4-41.1 28.8-44.5 18.6-3 36.4 9.8 41.5 27.9l2 7.1 7.1-1.9c18.2-4.7 38.2 4.3 44.9 21.9 7.7 20.3-3.8 41.9-24.2 47.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGrinSquintTears(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M409.6 111.9c22.6-3.2 73.5-12 88.3-26.8 19.2-19.2 18.9-50.6-.7-70.2S446-5 426.9 14.2c-14.8 14.8-23.5 65.7-26.8 88.3-.8 5.5 3.9 10.2 9.5 9.4zM102.4 400.1c-22.6 3.2-73.5 12-88.3 26.8-19.1 19.1-18.8 50.6.8 70.2s51 19.9 70.2.7c14.8-14.8 23.5-65.7 26.8-88.3.8-5.5-3.9-10.2-9.5-9.4zm311.7-256.5c-33 3.9-48.6-25.1-45.7-45.7 3.4-24 7.4-42.1 11.5-56.5C285.1-13.4 161.8-.5 80.6 80.6-.5 161.7-13.4 285 41.4 379.9c14.4-4.1 32.4-8 56.5-11.5 33.2-3.9 48.6 25.2 45.7 45.7-3.4 24-7.4 42.1-11.5 56.5 94.8 54.8 218.1 41.9 299.3-39.2s94-204.4 39.2-299.3c-14.4 4.1-32.5 8-56.5 11.5zM255.7 106c3.3-13.2 22.4-11.5 23.6 1.8l4.8 52.3 52.3 4.8c13.4 1.2 14.9 20.3 1.8 23.6l-90.5 22.6c-8.9 2.2-16.7-5.9-14.5-14.5l22.5-90.6zm-90.9 230.3L160 284l-52.3-4.8c-13.4-1.2-14.9-20.3-1.8-23.6l90.5-22.6c8.8-2.2 16.7 5.8 14.5 14.5L188.3 338c-3.1 13.2-22.2 11.7-23.5-1.7zm215.7 44.2c-29.3 29.3-75.7 50.4-116.7 50.4-18.9 0-36.6-4.5-51-14.7-9.8-6.9-8.7-21.8 2-27.2 28.3-14.6 63.9-42.4 97.8-76.3s61.7-69.6 76.3-97.8c5.4-10.5 20.2-11.9 27.3-2 32.3 45.3 7.1 124.7-35.7 167.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGrinSquint(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm33.8 189.7l80-48c11.6-6.9 24 7.7 15.4 18L343.6 208l33.6 40.3c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.7-4.7-7.7-15.9 0-20.6zm-163-30c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.8 4.7 7.8 15.9 0 20.6l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.9 9.4-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.2 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGrinStars(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM94.6 168.9l34.9-5 15.5-31.6c2.9-5.8 11-5.8 13.9 0l15.5 31.6 34.9 5c6.2 1 8.9 8.6 4.3 13.2l-25.4 24.6 6 34.9c1 6.2-5.3 11-11 7.9L152 233.3l-31.3 16.3c-5.7 3.1-12-1.7-11-7.9l6-34.9-25.4-24.6c-4.6-4.7-1.9-12.3 4.3-13.3zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3zm157.7-249.9l-25.4 24.6 6 34.9c1 6.2-5.3 11-11 7.9L344 233.3l-31.3 16.3c-5.7 3.1-12-1.7-11-7.9l6-34.9-25.4-24.6c-4.5-4.6-1.9-12.2 4.3-13.2l34.9-5 15.5-31.6c2.9-5.8 11-5.8 13.9 0l15.5 31.6 34.9 5c6.3.9 9 8.5 4.4 13.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGrinTears(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M102.4 256.1c-22.6 3.2-73.5 12-88.3 26.8-19.1 19.1-18.8 50.6.8 70.2s51 19.9 70.2.7c14.8-14.8 23.5-65.7 26.8-88.3.8-5.5-3.9-10.2-9.5-9.4zm523.4 26.8c-14.8-14.8-65.7-23.5-88.3-26.8-5.5-.8-10.3 3.9-9.5 9.5 3.2 22.6 12 73.5 26.8 88.3 19.2 19.2 50.6 18.9 70.2-.7s20-51.2.8-70.3zm-129.4-12.8c-3.8-26.6 19.1-49.5 45.7-45.7 8.9 1.3 16.8 2.7 24.3 4.1C552.7 104.5 447.7 8 320 8S87.3 104.5 73.6 228.5c7.5-1.4 15.4-2.8 24.3-4.1 33.2-3.9 48.6 25.3 45.7 45.7-11.8 82.3-29.9 100.4-35.8 106.4-.9.9-2 1.6-3 2.5 42.7 74.6 123 125 215.2 125s172.5-50.4 215.2-125.1c-1-.9-2.1-1.5-3-2.5-5.9-5.9-24-24-35.8-106.3zM400 152c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm-160 0c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm80 280c-60.6 0-134.5-38.3-143.8-93.3-2-11.7 9.2-21.6 20.7-17.9C227.1 330.5 272 336 320 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGrinTongueSquint(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M293.1 374.6c-14.4-6.5-31.1 2.2-34.6 17.6l-1.8 7.8c-2.1 9.2-15.2 9.2-17.3 0l-1.8-7.8c-3.5-15.4-20.2-24.1-34.6-17.6-.9.4.3-.2-18.9 9.4v63c0 35.2 28 64.5 63.1 64.9 35.7.5 64.9-28.4 64.9-64v-64c-19.5-9.6-18.2-8.9-19-9.3zM248 8C111 8 0 119 0 256c0 106.3 67 196.7 161 232-5.6-12.2-9-25.7-9-40v-45.5c-24.7-16.2-43.5-38.1-47.8-63.8-2-11.8 9.2-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-4.3 25.7-23.1 47.6-47.8 63.8V448c0 14.3-3.4 27.8-9 40 94-35.3 161-125.7 161-232C496 119 385 8 248 8zm-33.8 210.3l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.7 4.7 7.7 15.9 0 20.6zm163 30c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.8-4.7-7.8-15.9 0-20.6l80-48c11.7-6.9 23.9 7.7 15.4 18L343.6 208l33.6 40.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGrinTongueWink(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M344 184c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM248 8C111 8 0 119 0 256c0 106.3 67 196.7 161 232-5.6-12.2-9-25.7-9-40v-45.5c-24.7-16.2-43.5-38.1-47.8-63.8-2-11.8 9.3-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.1 20.7 17.9-4.3 25.7-23.1 47.6-47.8 63.8V448c0 14.3-3.4 27.8-9 40 94-35.3 161-125.7 161-232C496 119 385 8 248 8zm-56 225l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L112 233c-8.5 7.4-21.6.3-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S208 197 212 222.2c1.6 11.1-11.6 18.2-20 10.8zm152 39c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm-50.9 102.6c-14.4-6.5-31.1 2.2-34.6 17.6l-1.8 7.8c-2.1 9.2-15.2 9.2-17.3 0l-1.8-7.8c-3.5-15.4-20.2-24.1-34.6-17.6-.9.4.3-.2-18.9 9.4v63c0 35.2 28 64.5 63.1 64.9 35.7.5 64.9-28.4 64.9-64v-64c-19.5-9.6-18.2-8.9-19-9.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGrinTongue(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256c0 106.3 67 196.7 161 232-5.6-12.2-9-25.7-9-40v-45.5c-24.7-16.2-43.5-38.1-47.8-63.8-2-11.8 9.3-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.6 22.6 6.1 20.7 17.9-4.3 25.7-23.1 47.6-47.8 63.8V448c0 14.3-3.4 27.8-9 40 94-35.3 161-125.7 161-232C496 119 385 8 248 8zm-80 232c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm160 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm-34.9 134.6c-14.4-6.5-31.1 2.2-34.6 17.6l-1.8 7.8c-2.1 9.2-15.2 9.2-17.3 0l-1.8-7.8c-3.5-15.4-20.2-24.1-34.6-17.6-.9.4.3-.2-18.9 9.4v63c0 35.2 28 64.5 63.1 64.9 35.7.5 64.9-28.4 64.9-64v-64c-19.5-9.6-18.2-8.9-19-9.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGrinWink(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 256c0 137 111 248 248 248s248-111 248-248S385 8 248 8 0 119 0 256zm200-48c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zm168 25l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L288 233c-8.3 7.4-21.6.4-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S384 197 388 222.2c1.6 11-11.5 18.2-20 10.8zm-243.1 87.8C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.3-3.7 22.6 6 20.7 17.9-9.2 55-83.2 93.3-143.8 93.3s-134.5-38.3-143.8-93.3c-2-11.9 9.3-21.6 20.7-17.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGrin(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm80 256c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.3-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGripHorizontal(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 288H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zM96 96H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGripLinesVertical(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 496V16c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16v480c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zm128 0V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v480c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGripLines(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 288H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-128H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGripVertical(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 32H32C14.33 32 0 46.33 0 64v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zm0 160H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm0 160H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zM288 32h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zm0 160h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm0 160h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaGuitar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M502.63 39L473 9.37a32 32 0 0 0-45.26 0L381.46 55.7a35.14 35.14 0 0 0-8.53 13.79L360.77 106l-76.26 76.26c-12.16-8.76-25.5-15.74-40.1-19.14-33.45-7.78-67-.88-89.88 22a82.45 82.45 0 0 0-20.24 33.47c-6 18.56-23.21 32.69-42.15 34.46-23.7 2.27-45.73 11.45-62.61 28.44C-16.11 327-7.9 409 47.58 464.45S185 528 230.56 482.52c17-16.88 26.16-38.9 28.45-62.71 1.76-18.85 15.89-36.13 34.43-42.14a82.6 82.6 0 0 0 33.48-20.25c22.87-22.88 29.74-56.36 22-89.75-3.39-14.64-10.37-28-19.16-40.2L406 151.23l36.48-12.16a35.14 35.14 0 0 0 13.79-8.53l46.33-46.32a32 32 0 0 0 .03-45.22zM208 352a48 48 0 1 1 48-48 48 48 0 0 1-48 48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zm-112 48h-32c-8.837 0-16 7.163-16 16v80H160v-80c0-8.837-7.163-16-16-16h-32c-8.837 0-16 7.163-16 16v224c0 8.837 7.163 16 16 16h32c8.837 0 16-7.163 16-16v-80h128v80c0 8.837 7.163 16 16 16h32c8.837 0 16-7.163 16-16V144c0-8.837-7.163-16-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHamburger(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256H48a48 48 0 0 0 0 96h416a48 48 0 0 0 0-96zm16 128H32a16 16 0 0 0-16 16v16a64 64 0 0 0 64 64h352a64 64 0 0 0 64-64v-16a16 16 0 0 0-16-16zM58.64 224h394.72c34.57 0 54.62-43.9 34.82-75.88C448 83.2 359.55 32.1 256 32c-103.54.1-192 51.2-232.18 116.11C4 180.09 24.07 224 58.64 224zM384 112a16 16 0 1 1-16 16 16 16 0 0 1 16-16zM256 80a16 16 0 1 1-16 16 16 16 0 0 1 16-16zm-128 32a16 16 0 1 1-16 16 16 16 0 0 1 16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHammer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M571.31 193.94l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31-28.9-28.9c5.63-21.31.36-44.9-16.35-61.61l-45.25-45.25c-62.48-62.48-163.79-62.48-226.28 0l90.51 45.25v18.75c0 16.97 6.74 33.25 18.75 45.25l49.14 49.14c16.71 16.71 40.3 21.98 61.61 16.35l28.9 28.9-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l90.51-90.51c6.23-6.24 6.23-16.37-.02-22.62zm-286.72-15.2c-3.7-3.7-6.84-7.79-9.85-11.95L19.64 404.96c-25.57 23.88-26.26 64.19-1.53 88.93s65.05 24.05 88.93-1.53l238.13-255.07c-3.96-2.91-7.9-5.87-11.44-9.41l-49.14-49.14z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHamsa(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M509.34 307.25C504.28 295.56 492.75 288 480 288h-64V80c0-22-18-40-40-40s-40 18-40 40v134c0 5.52-4.48 10-10 10h-20c-5.52 0-10-4.48-10-10V40c0-22-18-40-40-40s-40 18-40 40v174c0 5.52-4.48 10-10 10h-20c-5.52 0-10-4.48-10-10V80c0-22-18-40-40-40S96 58 96 80v208H32c-12.75 0-24.28 7.56-29.34 19.25a31.966 31.966 0 0 0 5.94 34.58l102.69 110.03C146.97 490.08 199.69 512 256 512s109.03-21.92 144.72-60.14L503.4 341.83a31.966 31.966 0 0 0 5.94-34.58zM256 416c-53.02 0-96-64-96-64s42.98-64 96-64 96 64 96 64-42.98 64-96 64zm0-96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandHoldingHeart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M275.3 250.5c7 7.4 18.4 7.4 25.5 0l108.9-114.2c31.6-33.2 29.8-88.2-5.6-118.8-30.8-26.7-76.7-21.9-104.9 7.7L288 36.9l-11.1-11.6C248.7-4.4 202.8-9.2 172 17.5c-35.3 30.6-37.2 85.6-5.6 118.8l108.9 114.2zm290 77.6c-11.8-10.7-30.2-10-42.6 0L430.3 402c-11.3 9.1-25.4 14-40 14H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h78.3c15.9 0 30.7-10.9 33.3-26.6 3.3-20-12.1-37.4-31.6-37.4H192c-27 0-53.1 9.3-74.1 26.3L71.4 384H16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h356.8c14.5 0 28.6-4.9 40-14L564 377c15.2-12.1 16.4-35.3 1.3-48.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandHoldingMedical(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M159.88,175.82h64v64a16,16,0,0,0,16,16h64a16,16,0,0,0,16-16v-64h64a16,16,0,0,0,16-16v-64a16,16,0,0,0-16-16h-64v-64a16,16,0,0,0-16-16h-64a16,16,0,0,0-16,16v64h-64a16,16,0,0,0-16,16v64A16,16,0,0,0,159.88,175.82ZM568.07,336.13a39.91,39.91,0,0,0-55.93-8.47L392.47,415.84H271.86a16,16,0,0,1,0-32H350.1c16,0,30.75-10.87,33.37-26.61a32.06,32.06,0,0,0-31.62-37.38h-160a117.7,117.7,0,0,0-74.12,26.25l-46.5,37.74H15.87a16.11,16.11,0,0,0-16,16v96a16.11,16.11,0,0,0,16,16h347a104.8,104.8,0,0,0,61.7-20.27L559.6,392A40,40,0,0,0,568.07,336.13Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandHoldingUsd(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M271.06,144.3l54.27,14.3a8.59,8.59,0,0,1,6.63,8.1c0,4.6-4.09,8.4-9.12,8.4h-35.6a30,30,0,0,1-11.19-2.2c-5.24-2.2-11.28-1.7-15.3,2l-19,17.5a11.68,11.68,0,0,0-2.25,2.66,11.42,11.42,0,0,0,3.88,15.74,83.77,83.77,0,0,0,34.51,11.5V240c0,8.8,7.83,16,17.37,16h17.37c9.55,0,17.38-7.2,17.38-16V222.4c32.93-3.6,57.84-31,53.5-63-3.15-23-22.46-41.3-46.56-47.7L282.68,97.4a8.59,8.59,0,0,1-6.63-8.1c0-4.6,4.09-8.4,9.12-8.4h35.6A30,30,0,0,1,332,83.1c5.23,2.2,11.28,1.7,15.3-2l19-17.5A11.31,11.31,0,0,0,368.47,61a11.43,11.43,0,0,0-3.84-15.78,83.82,83.82,0,0,0-34.52-11.5V16c0-8.8-7.82-16-17.37-16H295.37C285.82,0,278,7.2,278,16V33.6c-32.89,3.6-57.85,31-53.51,63C227.63,119.6,247,137.9,271.06,144.3ZM565.27,328.1c-11.8-10.7-30.2-10-42.6,0L430.27,402a63.64,63.64,0,0,1-40,14H272a16,16,0,0,1,0-32h78.29c15.9,0,30.71-10.9,33.25-26.6a31.2,31.2,0,0,0,.46-5.46A32,32,0,0,0,352,320H192a117.66,117.66,0,0,0-74.1,26.29L71.4,384H16A16,16,0,0,0,0,400v96a16,16,0,0,0,16,16H372.77a64,64,0,0,0,40-14L564,377a32,32,0,0,0,1.28-48.9Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandHoldingWater(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 256c53 0 96-42.1 96-94 0-40-57.1-120.7-83.2-155.6-6.4-8.5-19.2-8.5-25.6 0C249.1 41.3 192 122 192 162c0 51.9 43 94 96 94zm277.3 72.1c-11.8-10.7-30.2-10-42.6 0L430.3 402c-11.3 9.1-25.4 14-40 14H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h78.3c15.9 0 30.7-10.9 33.3-26.6 3.3-20-12.1-37.4-31.6-37.4H192c-27 0-53.1 9.3-74.1 26.3L71.4 384H16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h356.8c14.5 0 28.6-4.9 40-14L564 377c15.2-12.1 16.4-35.3 1.3-48.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandHolding(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M565.3 328.1c-11.8-10.7-30.2-10-42.6 0L430.3 402c-11.3 9.1-25.4 14-40 14H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h78.3c15.9 0 30.7-10.9 33.3-26.6 3.3-20-12.1-37.4-31.6-37.4H192c-27 0-53.1 9.3-74.1 26.3L71.4 384H16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h356.8c14.5 0 28.6-4.9 40-14L564 377c15.2-12.1 16.4-35.3 1.3-48.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandLizard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 480h192V363.778a95.998 95.998 0 0 0-14.833-51.263L398.127 54.368A48 48 0 0 0 357.544 32H24C10.745 32 0 42.745 0 56v16c0 30.928 25.072 56 56 56h229.981c12.844 0 21.556 13.067 16.615 24.923l-21.41 51.385A32 32 0 0 1 251.648 224H128c-35.346 0-64 28.654-64 64v8c0 13.255 10.745 24 24 24h147.406a47.995 47.995 0 0 1 25.692 7.455l111.748 70.811A24.001 24.001 0 0 1 384 418.539V480z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandMiddleFinger(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M479.93 317.12a37.33 37.33 0 0 0-28.28-36.19L416 272v-49.59c0-11.44-9.69-21.29-23.15-23.54l-38.4-6.4C336.63 189.5 320 200.86 320 216v32a8 8 0 0 1-16 0V50c0-26.28-20.25-49.2-46.52-50A48 48 0 0 0 208 48v200a8 8 0 0 1-16 0v-32c0-15.15-16.63-26.51-34.45-23.54l-30.68 5.12c-18 3-30.87 16.12-30.87 31.38V376a8 8 0 0 1-16 0v-76l-27.36 15A37.34 37.34 0 0 0 32 348.4v73.47a37.31 37.31 0 0 0 10.93 26.39l30.93 30.93A112 112 0 0 0 153.05 512h215A112 112 0 0 0 480 400z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandPaper(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M408.781 128.007C386.356 127.578 368 146.36 368 168.79V256h-8V79.79c0-22.43-18.356-41.212-40.781-40.783C297.488 39.423 280 57.169 280 79v177h-8V40.79C272 18.36 253.644-.422 231.219.007 209.488.423 192 18.169 192 40v216h-8V80.79c0-22.43-18.356-41.212-40.781-40.783C121.488 40.423 104 58.169 104 80v235.992l-31.648-43.519c-12.993-17.866-38.009-21.817-55.877-8.823-17.865 12.994-21.815 38.01-8.822 55.877l125.601 172.705A48 48 0 0 0 172.073 512h197.59c22.274 0 41.622-15.324 46.724-37.006l26.508-112.66a192.011 192.011 0 0 0 5.104-43.975V168c.001-21.831-17.487-39.577-39.218-39.993z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandPeace(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M408 216c-22.092 0-40 17.909-40 40h-8v-32c0-22.091-17.908-40-40-40s-40 17.909-40 40v32h-8V48c0-26.51-21.49-48-48-48s-48 21.49-48 48v208h-13.572L92.688 78.449C82.994 53.774 55.134 41.63 30.461 51.324 5.787 61.017-6.356 88.877 3.337 113.551l74.765 190.342-31.09 24.872c-15.381 12.306-19.515 33.978-9.741 51.081l64 112A39.998 39.998 0 0 0 136 512h240c18.562 0 34.686-12.77 38.937-30.838l32-136A39.97 39.97 0 0 0 448 336v-80c0-22.091-17.908-40-40-40z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandPointDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M91.826 467.2V317.966c-8.248 5.841-16.558 10.57-24.918 14.153C35.098 345.752-.014 322.222 0 288c.008-18.616 10.897-32.203 29.092-40 28.286-12.122 64.329-78.648 77.323-107.534 7.956-17.857 25.479-28.453 43.845-28.464l.001-.002h171.526c11.812 0 21.897 8.596 23.703 20.269 7.25 46.837 38.483 61.76 38.315 123.731-.007 2.724.195 13.254.195 16 0 50.654-22.122 81.574-71.263 72.6-9.297 18.597-39.486 30.738-62.315 16.45-21.177 24.645-53.896 22.639-70.944 6.299V467.2c0 24.15-20.201 44.8-43.826 44.8-23.283 0-43.826-21.35-43.826-44.8zM112 72V24c0-13.255 10.745-24 24-24h192c13.255 0 24 10.745 24 24v48c0 13.255-10.745 24-24 24H136c-13.255 0-24-10.745-24-24zm212-24c0-11.046-8.954-20-20-20s-20 8.954-20 20 8.954 20 20 20 20-8.954 20-20z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandPointLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M44.8 155.826h149.234c-5.841-8.248-10.57-16.558-14.153-24.918C166.248 99.098 189.778 63.986 224 64c18.616.008 32.203 10.897 40 29.092 12.122 28.286 78.648 64.329 107.534 77.323 17.857 7.956 28.453 25.479 28.464 43.845l.002.001v171.526c0 11.812-8.596 21.897-20.269 23.703-46.837 7.25-61.76 38.483-123.731 38.315-2.724-.007-13.254.195-16 .195-50.654 0-81.574-22.122-72.6-71.263-18.597-9.297-30.738-39.486-16.45-62.315-24.645-21.177-22.639-53.896-6.299-70.944H44.8c-24.15 0-44.8-20.201-44.8-43.826 0-23.283 21.35-43.826 44.8-43.826zM440 176h48c13.255 0 24 10.745 24 24v192c0 13.255-10.745 24-24 24h-48c-13.255 0-24-10.745-24-24V200c0-13.255 10.745-24 24-24zm24 212c11.046 0 20-8.954 20-20s-8.954-20-20-20-20 8.954-20 20 8.954 20 20 20z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandPointRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 199.652c0 23.625-20.65 43.826-44.8 43.826h-99.851c16.34 17.048 18.346 49.766-6.299 70.944 14.288 22.829 2.147 53.017-16.45 62.315C353.574 425.878 322.654 448 272 448c-2.746 0-13.276-.203-16-.195-61.971.168-76.894-31.065-123.731-38.315C120.596 407.683 112 397.599 112 385.786V214.261l.002-.001c.011-18.366 10.607-35.889 28.464-43.845 28.886-12.994 95.413-49.038 107.534-77.323 7.797-18.194 21.384-29.084 40-29.092 34.222-.014 57.752 35.098 44.119 66.908-3.583 8.359-8.312 16.67-14.153 24.918H467.2c23.45 0 44.8 20.543 44.8 43.826zM96 200v192c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V200c0-13.255 10.745-24 24-24h48c13.255 0 24 10.745 24 24zM68 368c0-11.046-8.954-20-20-20s-20 8.954-20 20 8.954 20 20 20 20-8.954 20-20z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandPointUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M135.652 0c23.625 0 43.826 20.65 43.826 44.8v99.851c17.048-16.34 49.766-18.346 70.944 6.299 22.829-14.288 53.017-2.147 62.315 16.45C361.878 158.426 384 189.346 384 240c0 2.746-.203 13.276-.195 16 .168 61.971-31.065 76.894-38.315 123.731C343.683 391.404 333.599 400 321.786 400H150.261l-.001-.002c-18.366-.011-35.889-10.607-43.845-28.464C93.421 342.648 57.377 276.122 29.092 264 10.897 256.203.008 242.616 0 224c-.014-34.222 35.098-57.752 66.908-44.119 8.359 3.583 16.67 8.312 24.918 14.153V44.8c0-23.45 20.543-44.8 43.826-44.8zM136 416h192c13.255 0 24 10.745 24 24v48c0 13.255-10.745 24-24 24H136c-13.255 0-24-10.745-24-24v-48c0-13.255 10.745-24 24-24zm168 28c-11.046 0-20 8.954-20 20s8.954 20 20 20 20-8.954 20-20-8.954-20-20-20z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandPointer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 240v96c0 3.084-.356 6.159-1.063 9.162l-32 136C410.686 499.23 394.562 512 376 512H168a40.004 40.004 0 0 1-32.35-16.473l-127.997-176c-12.993-17.866-9.043-42.883 8.822-55.876 17.867-12.994 42.884-9.043 55.877 8.823L104 315.992V40c0-22.091 17.908-40 40-40s40 17.909 40 40v200h8v-40c0-22.091 17.908-40 40-40s40 17.909 40 40v40h8v-24c0-22.091 17.908-40 40-40s40 17.909 40 40v24h8c0-22.091 17.908-40 40-40s40 17.909 40 40zm-256 80h-8v96h8v-96zm88 0h-8v96h8v-96zm88 0h-8v96h8v-96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandRock(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464.8 80c-26.9-.4-48.8 21.2-48.8 48h-8V96.8c0-26.3-20.9-48.3-47.2-48.8-26.9-.4-48.8 21.2-48.8 48v32h-8V80.8c0-26.3-20.9-48.3-47.2-48.8-26.9-.4-48.8 21.2-48.8 48v48h-8V96.8c0-26.3-20.9-48.3-47.2-48.8-26.9-.4-48.8 21.2-48.8 48v136l-8-7.1v-48.1c0-26.3-20.9-48.3-47.2-48.8C21.9 127.6 0 149.2 0 176v66.4c0 27.4 11.7 53.5 32.2 71.8l111.7 99.3c10.2 9.1 16.1 22.2 16.1 35.9v6.7c0 13.3 10.7 24 24 24h240c13.3 0 24-10.7 24-24v-2.9c0-12.8 2.6-25.5 7.5-37.3l49-116.3c5-11.8 7.5-24.5 7.5-37.3V128.8c0-26.3-20.9-48.4-47.2-48.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandScissors(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M216 440c0-22.092 17.909-40 40-40v-8h-32c-22.091 0-40-17.908-40-40s17.909-40 40-40h32v-8H48c-26.51 0-48-21.49-48-48s21.49-48 48-48h208v-13.572l-177.551-69.74c-24.674-9.694-36.818-37.555-27.125-62.228 9.693-24.674 37.554-36.817 62.228-27.124l190.342 74.765 24.872-31.09c12.306-15.381 33.978-19.515 51.081-9.741l112 64A40.002 40.002 0 0 1 512 168v240c0 18.562-12.77 34.686-30.838 38.937l-136 32A39.982 39.982 0 0 1 336 480h-80c-22.091 0-40-17.908-40-40z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandSparkles(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M106.66,170.64l.09,0,49.55-20.65a7.32,7.32,0,0,0,3.68-6h0a7.29,7.29,0,0,0-3.68-6l-49.57-20.67-.07,0L86,67.68a6.66,6.66,0,0,0-11.92,0l-20.7,49.63-.05,0L3.7,138A7.29,7.29,0,0,0,0,144H0a7.32,7.32,0,0,0,3.68,6L53.27,170.6l.07,0L74,220.26a6.65,6.65,0,0,0,11.92,0l20.69-49.62ZM471.38,467.41l-1-.42-1-.5a38.67,38.67,0,0,1,0-69.14l1-.49,1-.43,37.49-15.63,15.63-37.48.41-1,.47-.95c3.85-7.74,10.58-13.63,18.35-17.34,0-1.33.25-2.69.27-4V144a32,32,0,0,0-64,0v72a8,8,0,0,1-8,8H456a8,8,0,0,1-8-8V64a32,32,0,0,0-64,0V216a8,8,0,0,1-8,8H360a8,8,0,0,1-8-8V32a32,32,0,0,0-64,0V216a8,8,0,0,1-8,8H264a8,8,0,0,1-8-8V64a32,32,0,0,0-64,0v241l-23.59-32.49a40,40,0,0,0-64.71,47.09L229.3,492.21A48.07,48.07,0,0,0,268.09,512H465.7c19.24,0,35.65-11.73,43.24-28.79l-.07-.17ZM349.79,339.52,320,351.93l-12.42,29.78a4,4,0,0,1-7.15,0L288,351.93l-29.79-12.41a4,4,0,0,1,0-7.16L288,319.94l12.42-29.78a4,4,0,0,1,7.15,0L320,319.94l29.79,12.42a4,4,0,0,1,0,7.16ZM640,431.91a7.28,7.28,0,0,0-3.68-6l-49.57-20.67-.07,0L566,355.63a6.66,6.66,0,0,0-11.92,0l-20.7,49.63-.05,0L483.7,426a7.28,7.28,0,0,0-3.68,6h0a7.29,7.29,0,0,0,3.68,5.95l49.57,20.67.07,0L554,508.21a6.65,6.65,0,0,0,11.92,0l20.69-49.62h0l.09,0,49.55-20.66a7.29,7.29,0,0,0,3.68-5.95h0Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandSpock(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M510.9005,145.27027,442.604,432.09391A103.99507,103.99507,0,0,1,341.43745,512H214.074a135.96968,135.96968,0,0,1-93.18489-36.95291L12.59072,373.12723a39.992,39.992,0,0,1,54.8122-58.24988l60.59342,57.02528v0a283.24849,283.24849,0,0,0-11.6703-80.46734L73.63726,147.36011a40.00575,40.00575,0,1,1,76.71833-22.7187l37.15458,125.39477a8.33113,8.33113,0,0,0,16.05656-4.4414L153.26183,49.95406A39.99638,39.99638,0,1,1,230.73015,30.0166l56.09491,218.15825a10.42047,10.42047,0,0,0,20.30018-.501L344.80766,63.96966a40.052,40.052,0,0,1,51.30245-30.0893c19.86073,6.2998,30.86262,27.67378,26.67564,48.08487l-33.83869,164.966a7.55172,7.55172,0,0,0,14.74406,3.2666l29.3973-123.45874a39.99414,39.99414,0,1,1,77.81208,18.53121Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandsHelping(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488 192H336v56c0 39.7-32.3 72-72 72s-72-32.3-72-72V126.4l-64.9 39C107.8 176.9 96 197.8 96 220.2v47.3l-80 46.2C.7 322.5-4.6 342.1 4.3 357.4l80 138.6c8.8 15.3 28.4 20.5 43.7 11.7L231.4 448H368c35.3 0 64-28.7 64-64h16c17.7 0 32-14.3 32-32v-64h8c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24zm147.7-37.4L555.7 16C546.9.7 527.3-4.5 512 4.3L408.6 64H306.4c-12 0-23.7 3.4-33.9 9.7L239 94.6c-9.4 5.8-15 16.1-15 27.1V248c0 22.1 17.9 40 40 40s40-17.9 40-40v-88h184c30.9 0 56 25.1 56 56v28.5l80-46.2c15.3-8.9 20.5-28.4 11.7-43.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandsWash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496,224a48,48,0,1,0-48-48A48,48,0,0,0,496,224ZM311.47,178.45A56.77,56.77,0,0,1,328,176a56,56,0,0,1,19,3.49l15.35-48.61A24,24,0,0,0,342,99.74c-11.53-1.35-22.21,6.44-25.71,17.51l-20.9,66.17ZM93.65,386.33c.8-.19,1.54-.54,2.35-.71V359.93a156,156,0,0,1,107.06-148l73.7-22.76L310.92,81.05a24,24,0,0,0-20.33-31.11c-11.53-1.34-22.22,6.45-25.72,17.52L231.42,173.88a8,8,0,0,1-15.26-4.83L259.53,31.26A24,24,0,0,0,239.2.15C227.67-1.19,217,6.6,213.49,17.66L165.56,169.37a8,8,0,1,1-15.26-4.82l38.56-122a24,24,0,0,0-20.33-31.11C157,10,146.32,17.83,142.82,28.9l-60,189.85L80.76,168.7A24,24,0,0,0,56.9,144.55c-13.23-.05-24.72,10.54-24.9,23.86V281.14A123.69,123.69,0,0,0,93.65,386.33ZM519.1,336H360a8,8,0,0,1,0-16H488a24,24,0,0,0,23.54-28.76C509.35,279.84,498.71,272,487.1,272H288l47.09-17.06a24,24,0,0,0-14.18-45.88L213.19,242.31A123.88,123.88,0,0,0,128,360v25.65a79.78,79.78,0,0,1,58,108.63A118.9,118.9,0,0,0,248,512H456a24,24,0,0,0,23.54-28.76C477.35,471.84,466.71,464,455.1,464H360a8,8,0,0,1,0-16H488a24,24,0,0,0,23.54-28.76C509.35,407.84,498.71,400,487.1,400H360a8,8,0,0,1,0-16H520a24,24,0,0,0,23.54-28.76C541.35,343.84,530.71,336,519.1,336ZM416,64a32,32,0,1,0-32-32A32,32,0,0,0,416,64ZM112,416a48,48,0,1,0,48,48A48,48,0,0,0,112,416Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHands(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M204.8 230.4c-10.6-14.1-30.7-17-44.8-6.4-14.1 10.6-17 30.7-6.4 44.8l38.1 50.8c4.8 6.4 4.1 15.3-1.5 20.9l-12.8 12.8c-6.7 6.7-17.6 6.2-23.6-1.1L64 244.4V96c0-17.7-14.3-32-32-32S0 78.3 0 96v218.4c0 10.9 3.7 21.5 10.5 30l104.1 134.3c5 6.5 8.4 13.9 10.4 21.7 1.8 6.9 8.1 11.6 15.3 11.6H272c8.8 0 16-7.2 16-16V384c0-27.7-9-54.6-25.6-76.8l-57.6-76.8zM608 64c-17.7 0-32 14.3-32 32v148.4l-89.8 107.8c-6 7.2-17 7.7-23.6 1.1l-12.8-12.8c-5.6-5.6-6.3-14.5-1.5-20.9l38.1-50.8c10.6-14.1 7.7-34.2-6.4-44.8-14.1-10.6-34.2-7.7-44.8 6.4l-57.6 76.8C361 329.4 352 356.3 352 384v112c0 8.8 7.2 16 16 16h131.7c7.1 0 13.5-4.7 15.3-11.6 2-7.8 5.4-15.2 10.4-21.7l104.1-134.3c6.8-8.5 10.5-19.1 10.5-30V96c0-17.7-14.3-32-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandshakeAltSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M358.59,195.6,504.2,313.8a63.4,63.4,0,0,1,22.21,37.91H624a16.05,16.05,0,0,0,16-16V143.91A16,16,0,0,0,624,128H512L457.41,73.41A32,32,0,0,0,434.8,64H348.91a32,32,0,0,0-21.61,8.41l-88.12,80.68-25.69-19.85L289.09,64H205.3a32,32,0,0,0-22.6,9.41l-20.34,20.3L45.47,3.38A16,16,0,0,0,23,6.19L3.38,31.46A16,16,0,0,0,6.19,53.91L594.54,508.63A16,16,0,0,0,617,505.82l19.64-25.27a16,16,0,0,0-2.81-22.45L303.4,202.72l32.69-29.92,27-24.7a16,16,0,0,1,21.61,23.61ZM16,128A16.05,16.05,0,0,0,0,144V335.91a16,16,0,0,0,16,16H146.3l90.5,81.89a64,64,0,0,0,90-9.3l.2-.2,17.91,15.5a37.16,37.16,0,0,0,52.29-5.39l8.8-10.82L23.56,128Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandshakeSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0,128.21V384H64a32,32,0,0,0,32-32V184L23.83,128.21ZM48,320.1a16,16,0,1,1-16,16A16,16,0,0,1,48,320.1Zm80,31.81h18.3l90.5,81.89a64,64,0,0,0,90-9.3l.2-.2,17.91,15.5a37.16,37.16,0,0,0,52.29-5.39l8.8-10.82L128,208.72Zm416-223.7V352.1a32,32,0,0,0,32,32h64V128.21ZM592,352.1a16,16,0,1,1,16-16A16,16,0,0,1,592,352.1ZM303.33,202.67l59.58-54.57a16,16,0,0,1,21.59,23.61L358.41,195.6,504,313.8a73.08,73.08,0,0,1,7.91,7.7V128L457.3,73.41A31.76,31.76,0,0,0,434.7,64H348.8a31.93,31.93,0,0,0-21.6,8.41l-88.07,80.64-25.64-19.81L289.09,64H205.3a32,32,0,0,0-22.6,9.41L162.36,93.72,45.47,3.38A16,16,0,0,0,23,6.19L3.38,31.46A16,16,0,0,0,6.19,53.91L594.53,508.63A16,16,0,0,0,617,505.82l19.65-25.27a16,16,0,0,0-2.82-22.45Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHandshake(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M434.7 64h-85.9c-8 0-15.7 3-21.6 8.4l-98.3 90c-.1.1-.2.3-.3.4-16.6 15.6-16.3 40.5-2.1 56 12.7 13.9 39.4 17.6 56.1 2.7.1-.1.3-.1.4-.2l79.9-73.2c6.5-5.9 16.7-5.5 22.6 1 6 6.5 5.5 16.6-1 22.6l-26.1 23.9L504 313.8c2.9 2.4 5.5 5 7.9 7.7V128l-54.6-54.6c-5.9-6-14.1-9.4-22.6-9.4zM544 128.2v223.9c0 17.7 14.3 32 32 32h64V128.2h-96zm48 223.9c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zM0 384h64c17.7 0 32-14.3 32-32V128.2H0V384zm48-63.9c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16c0-8.9 7.2-16 16-16zm435.9 18.6L334.6 217.5l-30 27.5c-29.7 27.1-75.2 24.5-101.7-4.4-26.9-29.4-24.8-74.9 4.4-101.7L289.1 64h-83.8c-8.5 0-16.6 3.4-22.6 9.4L128 128v223.9h18.3l90.5 81.9c27.4 22.3 67.7 18.1 90-9.3l.2-.2 17.9 15.5c15.9 13 39.4 10.5 52.3-5.4l31.4-38.6 5.4 4.4c13.7 11.1 33.9 9.1 45-4.7l9.5-11.7c11.2-13.8 9.1-33.9-4.6-45.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHanukiah(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M232 160c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm-64 0c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm224 0c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm64 0c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm88 8c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v120h32V168zm-440-8c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm520 0h-32c-8.84 0-16 7.16-16 16v112c0 17.67-14.33 32-32 32H352V128c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v192H96c-17.67 0-32-14.33-32-32V176c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v112c0 53.02 42.98 96 96 96h192v64H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16H352v-64h192c53.02 0 96-42.98 96-96V176c0-8.84-7.16-16-16-16zm-16-32c13.25 0 24-11.94 24-26.67S608 48 608 48s-24 38.61-24 53.33S594.75 128 608 128zm-576 0c13.25 0 24-11.94 24-26.67S32 48 32 48 8 86.61 8 101.33 18.75 128 32 128zm288-48c13.25 0 24-11.94 24-26.67S320 0 320 0s-24 38.61-24 53.33S306.75 80 320 80zm-208 48c13.25 0 24-11.94 24-26.67S112 48 112 48s-24 38.61-24 53.33S98.75 128 112 128zm64 0c13.25 0 24-11.94 24-26.67S176 48 176 48s-24 38.61-24 53.33S162.75 128 176 128zm64 0c13.25 0 24-11.94 24-26.67S240 48 240 48s-24 38.61-24 53.33S226.75 128 240 128zm160 0c13.25 0 24-11.94 24-26.67S400 48 400 48s-24 38.61-24 53.33S386.75 128 400 128zm64 0c13.25 0 24-11.94 24-26.67S464 48 464 48s-24 38.61-24 53.33S450.75 128 464 128zm64 0c13.25 0 24-11.94 24-26.67S528 48 528 48s-24 38.61-24 53.33S514.75 128 528 128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHardHat(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 288c0-80.25-49.28-148.92-119.19-177.62L320 192V80a16 16 0 0 0-16-16h-96a16 16 0 0 0-16 16v112l-40.81-81.62C81.28 139.08 32 207.75 32 288v64h448zm16 96H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h480a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHashtag(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M440.667 182.109l7.143-40c1.313-7.355-4.342-14.109-11.813-14.109h-74.81l14.623-81.891C377.123 38.754 371.468 32 363.997 32h-40.632a12 12 0 0 0-11.813 9.891L296.175 128H197.54l14.623-81.891C213.477 38.754 207.822 32 200.35 32h-40.632a12 12 0 0 0-11.813 9.891L132.528 128H53.432a12 12 0 0 0-11.813 9.891l-7.143 40C33.163 185.246 38.818 192 46.289 192h74.81L98.242 320H19.146a12 12 0 0 0-11.813 9.891l-7.143 40C-1.123 377.246 4.532 384 12.003 384h74.81L72.19 465.891C70.877 473.246 76.532 480 84.003 480h40.632a12 12 0 0 0 11.813-9.891L151.826 384h98.634l-14.623 81.891C234.523 473.246 240.178 480 247.65 480h40.632a12 12 0 0 0 11.813-9.891L315.472 384h79.096a12 12 0 0 0 11.813-9.891l7.143-40c1.313-7.355-4.342-14.109-11.813-14.109h-74.81l22.857-128h79.096a12 12 0 0 0 11.813-9.891zM261.889 320h-98.634l22.857-128h98.634l-22.857 128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHatCowboySide(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M260.8 291.06c-28.63-22.94-62-35.06-96.4-35.06C87 256 21.47 318.72 1.43 412.06c-3.55 16.6-.43 33.83 8.57 47.3C18.75 472.47 31.83 480 45.88 480H592c-103.21 0-155-37.07-233.19-104.46zm234.65-18.29L468.4 116.2A64 64 0 0 0 392 64.41L200.85 105a64 64 0 0 0-50.35 55.79L143.61 226c6.9-.83 13.7-2 20.79-2 41.79 0 82 14.55 117.29 42.82l98 84.48C450.76 412.54 494.9 448 592 448a48 48 0 0 0 48-48c0-25.39-29.6-119.33-144.55-127.23z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHatCowboy(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M490 296.9C480.51 239.51 450.51 64 392.3 64c-14 0-26.49 5.93-37 14a58.21 58.21 0 0 1-70.58 0c-10.51-8-23-14-37-14-58.2 0-88.2 175.47-97.71 232.88C188.81 309.47 243.73 320 320 320s131.23-10.51 170-23.1zm142.9-37.18a16 16 0 0 0-19.75 1.5c-1 .9-101.27 90.78-293.16 90.78-190.82 0-292.22-89.94-293.24-90.84A16 16 0 0 0 1 278.53C1.73 280.55 78.32 480 320 480s318.27-199.45 319-201.47a16 16 0 0 0-6.09-18.81z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHatWizard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-304-64l-64-32 64-32 32-64 32 64 64 32-64 32-16 32h208l-86.41-201.63a63.955 63.955 0 0 1-1.89-45.45L416 0 228.42 107.19a127.989 127.989 0 0 0-53.46 59.15L64 416h144l-16-32zm64-224l16-32 16 32 32 16-32 16-16 32-16-32-32-16 32-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHdd(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M576 304v96c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48v-96c0-26.51 21.49-48 48-48h480c26.51 0 48 21.49 48 48zm-48-80a79.557 79.557 0 0 1 30.777 6.165L462.25 85.374A48.003 48.003 0 0 0 422.311 64H153.689a48 48 0 0 0-39.938 21.374L17.223 230.165A79.557 79.557 0 0 1 48 224h480zm-48 96c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm-96 0c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHeadSideCoughSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M454.11,319.21c19.56-3.81,31.62-25,23.11-44.21-21-47.12-48.5-151.75-73.12-186.75A208.13,208.13,0,0,0,234.1,0H192A190.64,190.64,0,0,0,84.18,33.3L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.46A16,16,0,0,0,6.18,53.91L594.53,508.63A16,16,0,0,0,617,505.82l19.64-25.27a16,16,0,0,0-2.81-22.45ZM313.39,210.45,263.61,172c5.88-7.14,14.43-12,24.36-12a32.06,32.06,0,0,1,32,32C320,199,317.24,205.17,313.39,210.45ZM616,304a24,24,0,1,0-24-24A24,24,0,0,0,616,304Zm-64,64a24,24,0,1,0-24-24A24,24,0,0,0,552,368ZM288,384a32,32,0,0,1,32-32h19.54L20.73,105.59A190.86,190.86,0,0,0,0,192c0,56.75,24.75,107.62,64,142.88V512H288V480h64a64,64,0,0,0,64-64H320A32,32,0,0,1,288,384Zm328-24a24,24,0,1,0,24,24A24,24,0,0,0,616,360Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHeadSideCough(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M616,304a24,24,0,1,0-24-24A24,24,0,0,0,616,304ZM552,416a24,24,0,1,0,24,24A24,24,0,0,0,552,416Zm-64-56a24,24,0,1,0,24,24A24,24,0,0,0,488,360ZM616,464a24,24,0,1,0,24,24A24,24,0,0,0,616,464Zm0-104a24,24,0,1,0,24,24A24,24,0,0,0,616,360Zm-64-40a24,24,0,1,0,24,24A24,24,0,0,0,552,320Zm-74.78-45c-21-47.12-48.5-151.75-73.12-186.75A208.13,208.13,0,0,0,234.1,0H192C86,0,0,86,0,192c0,56.75,24.75,107.62,64,142.88V512H288V480h64a64,64,0,0,0,64-64H320a32,32,0,0,1,0-64h96V320h32A32,32,0,0,0,477.22,275ZM288,224a32,32,0,1,1,32-32A32.07,32.07,0,0,1,288,224Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHeadSideMask(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.15,184.42C-2.17,244.21,23,298.06,64,334.88V512H224V316.51L3.67,156.25A182.28,182.28,0,0,0,.15,184.42ZM509.22,275c-21-47.12-48.5-151.75-73.12-186.75A208.11,208.11,0,0,0,266.11,0H200C117,0,42.48,50.57,13.25,123.65L239.21,288H511.76A31.35,31.35,0,0,0,509.22,275ZM320,224a32,32,0,1,1,32-32A32.07,32.07,0,0,1,320,224Zm16,144H496l16-48H256V512H401.88a64,64,0,0,0,60.71-43.76L464,464H336a16,16,0,0,1,0-32H474.67l10.67-32H336a16,16,0,0,1,0-32Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHeadSideVirus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272,240a16,16,0,1,0,16,16A16,16,0,0,0,272,240Zm-64-64a16,16,0,1,0,16,16A16,16,0,0,0,208,176Zm301.2,99c-20.93-47.12-48.43-151.73-73.07-186.75A207.9,207.9,0,0,0,266.09,0H192C86,0,0,86,0,192A191.23,191.23,0,0,0,64,334.81V512H320V448h64a64,64,0,0,0,64-64V320H480A32,32,0,0,0,509.2,275ZM368,240H355.88c-28.51,0-42.79,34.47-22.63,54.63l8.58,8.57a16,16,0,1,1-22.63,22.63l-8.57-8.58C290.47,297.09,256,311.37,256,339.88V352a16,16,0,0,1-32,0V339.88c0-28.51-34.47-42.79-54.63-22.63l-8.57,8.58a16,16,0,0,1-22.63-22.63l8.58-8.57c20.16-20.16,5.88-54.63-22.63-54.63H112a16,16,0,0,1,0-32h12.12c28.51,0,42.79-34.47,22.63-54.63l-8.58-8.57a16,16,0,0,1,22.63-22.63l8.57,8.58c20.16,20.16,54.63,5.88,54.63-22.63V96a16,16,0,0,1,32,0v12.12c0,28.51,34.47,42.79,54.63,22.63l8.57-8.58a16,16,0,0,1,22.63,22.63l-8.58,8.57C313.09,173.53,327.37,208,355.88,208H368a16,16,0,0,1,0,32Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHeading(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 96v320h32a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H320a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32V288H160v128h32a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32V96H32a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h160a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16h-32v128h192V96h-32a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h160a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHeadphonesAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 288h-16c-35.35 0-64 28.7-64 64.12v63.76c0 35.41 28.65 64.12 64 64.12h16c17.67 0 32-14.36 32-32.06V320.06c0-17.71-14.33-32.06-32-32.06zm208 0h-16c-17.67 0-32 14.35-32 32.06v127.88c0 17.7 14.33 32.06 32 32.06h16c35.35 0 64-28.71 64-64.12v-63.76c0-35.41-28.65-64.12-64-64.12zM256 32C112.91 32 4.57 151.13 0 288v112c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V288c0-114.67 93.33-207.8 208-207.82 114.67.02 208 93.15 208 207.82v112c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V288C507.43 151.13 399.09 32 256 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHeadphones(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32C114.52 32 0 146.496 0 288v48a32 32 0 0 0 17.689 28.622l14.383 7.191C34.083 431.903 83.421 480 144 480h24c13.255 0 24-10.745 24-24V280c0-13.255-10.745-24-24-24h-24c-31.342 0-59.671 12.879-80 33.627V288c0-105.869 86.131-192 192-192s192 86.131 192 192v1.627C427.671 268.879 399.342 256 368 256h-24c-13.255 0-24 10.745-24 24v176c0 13.255 10.745 24 24 24h24c60.579 0 109.917-48.098 111.928-108.187l14.382-7.191A32 32 0 0 0 512 336v-48c0-141.479-114.496-256-256-256z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHeadset(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 208c0-17.67-14.33-32-32-32h-16c-35.35 0-64 28.65-64 64v48c0 35.35 28.65 64 64 64h16c17.67 0 32-14.33 32-32V208zm176 144c35.35 0 64-28.65 64-64v-48c0-35.35-28.65-64-64-64h-16c-17.67 0-32 14.33-32 32v112c0 17.67 14.33 32 32 32h16zM256 0C113.18 0 4.58 118.83 0 256v16c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-16c0-114.69 93.31-208 208-208s208 93.31 208 208h-.12c.08 2.43.12 165.72.12 165.72 0 23.35-18.93 42.28-42.28 42.28H320c0-26.51-21.49-48-48-48h-32c-26.51 0-48 21.49-48 48s21.49 48 48 48h181.72c49.86 0 90.28-40.42 90.28-90.28V256C507.42 118.83 398.82 0 256 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHeartBroken(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M473.7 73.8l-2.4-2.5c-46-47-118-51.7-169.6-14.8L336 159.9l-96 64 48 128-144-144 96-64-28.6-86.5C159.7 19.6 87 24 40.7 71.4l-2.4 2.4C-10.4 123.6-12.5 202.9 31 256l212.1 218.6c7.1 7.3 18.6 7.3 25.7 0L481 255.9c43.5-53 41.4-132.3-7.3-182.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHeart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHeartbeat(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320.2 243.8l-49.7 99.4c-6 12.1-23.4 11.7-28.9-.6l-56.9-126.3-30 71.7H60.6l182.5 186.5c7.1 7.3 18.6 7.3 25.7 0L451.4 288H342.3l-22.1-44.2zM473.7 73.9l-2.4-2.5c-51.5-52.6-135.8-52.6-187.4 0L256 100l-27.9-28.5c-51.5-52.7-135.9-52.7-187.4 0l-2.4 2.4C-10.4 123.7-12.5 203 31 256h102.4l35.9-86.2c5.4-12.9 23.6-13.2 29.4-.4l58.2 129.3 49-97.9c5.9-11.8 22.7-11.8 28.6 0l27.6 55.2H481c43.5-53 41.4-132.3-7.3-182.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHelicopter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304 384h272c17.67 0 32-14.33 32-32 0-123.71-100.29-224-224-224V64h176c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16H144c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h176v64H112L68.8 70.4C65.78 66.37 61.03 64 56 64H16.01C5.6 64-2.04 73.78.49 83.88L32 192l160 64 86.4 115.2A31.992 31.992 0 0 0 304 384zm112-188.49C478.55 208.3 528.03 257.44 540.79 320H416V195.51zm219.37 263.3l-22.15-22.2c-6.25-6.26-16.24-6.1-22.64.01-7.09 6.77-13.84 11.25-24.64 11.25H240c-8.84 0-16 7.18-16 16.03v32.06c0 8.85 7.16 16.03 16 16.03h325.94c14.88 0 35.3-.47 68.45-29.52 7.02-6.14 7.57-17.05.98-23.66z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHighlighter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 544 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 479.98L99.92 512l35.45-35.45-67.04-67.04L0 479.98zm124.61-240.01a36.592 36.592 0 0 0-10.79 38.1l13.05 42.83-50.93 50.94 96.23 96.23 50.86-50.86 42.74 13.08c13.73 4.2 28.65-.01 38.15-10.78l35.55-41.64-173.34-173.34-41.52 35.44zm403.31-160.7l-63.2-63.2c-20.49-20.49-53.38-21.52-75.12-2.35L190.55 183.68l169.77 169.78L530.27 154.4c19.18-21.74 18.15-54.63-2.35-75.13z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHiking(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M80.95 472.23c-4.28 17.16 6.14 34.53 23.28 38.81 2.61.66 5.22.95 7.8.95 14.33 0 27.37-9.7 31.02-24.23l25.24-100.97-52.78-52.78-34.56 138.22zm14.89-196.12L137 117c2.19-8.42-3.14-16.95-11.92-19.06-43.88-10.52-88.35 15.07-99.32 57.17L.49 253.24c-2.19 8.42 3.14 16.95 11.92 19.06l63.56 15.25c8.79 2.1 17.68-3.02 19.87-11.44zM368 160h-16c-8.84 0-16 7.16-16 16v16h-34.75l-46.78-46.78C243.38 134.11 228.61 128 212.91 128c-27.02 0-50.47 18.3-57.03 44.52l-26.92 107.72a32.012 32.012 0 0 0 8.42 30.39L224 397.25V480c0 17.67 14.33 32 32 32s32-14.33 32-32v-82.75c0-17.09-6.66-33.16-18.75-45.25l-46.82-46.82c.15-.5.49-.89.62-1.41l19.89-79.57 22.43 22.43c6 6 14.14 9.38 22.62 9.38h48v240c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V176c.01-8.84-7.15-16-15.99-16zM240 96c26.51 0 48-21.49 48-48S266.51 0 240 0s-48 21.49-48 48 21.49 48 48 48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHippo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M581.12 96.2c-27.67-.15-52.5 17.58-76.6 26.62C489.98 88.27 455.83 64 416 64c-11.28 0-21.95 2.3-32 5.88V56c0-13.26-10.75-24-24-24h-16c-13.25 0-24 10.74-24 24v48.98C286.01 79.58 241.24 64 192 64 85.96 64 0 135.64 0 224v240c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16v-70.79C128.35 407.57 166.72 416 208 416s79.65-8.43 112-22.79V464c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16V288h128v32c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-32c17.67 0 32-14.33 32-32v-92.02c0-34.09-24.79-67.59-58.88-67.78zM448 176c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHistory(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 255.531c.253 136.64-111.18 248.372-247.82 248.468-59.015.042-113.223-20.53-155.822-54.911-11.077-8.94-11.905-25.541-1.839-35.607l11.267-11.267c8.609-8.609 22.353-9.551 31.891-1.984C173.062 425.135 212.781 440 256 440c101.705 0 184-82.311 184-184 0-101.705-82.311-184-184-184-48.814 0-93.149 18.969-126.068 49.932l50.754 50.754c10.08 10.08 2.941 27.314-11.313 27.314H24c-8.837 0-16-7.163-16-16V38.627c0-14.254 17.234-21.393 27.314-11.314l49.372 49.372C129.209 34.136 189.552 8 256 8c136.81 0 247.747 110.78 248 247.531zm-180.912 78.784l9.823-12.63c8.138-10.463 6.253-25.542-4.21-33.679L288 256.349V152c0-13.255-10.745-24-24-24h-16c-13.255 0-24 10.745-24 24v135.651l65.409 50.874c10.463 8.137 25.541 6.253 33.679-4.21z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHockeyPuck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 160c0-53 114.6-96 256-96s256 43 256 96-114.6 96-256 96S0 213 0 160zm0 82.2V352c0 53 114.6 96 256 96s256-43 256-96V242.2c-113.4 82.3-398.5 82.4-512 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHollyBerry(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144 192c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48zm112-48c0 26.5 21.5 48 48 48s48-21.5 48-48-21.5-48-48-48-48 21.5-48 48zm-32-48c26.5 0 48-21.5 48-48S250.5 0 224 0s-48 21.5-48 48 21.5 48 48 48zm-16.2 139.1c.1-12.4-13.1-20.1-23.8-13.7-34.3 20.3-71.4 32.7-108.7 36.2-9.7.9-15.6 11.3-11.6 20.2 6.2 13.9 11.1 28.6 14.7 43.8 3.6 15.2-5.3 30.6-20.2 35.1-14.9 4.5-30.1 7.6-45.3 9.1-9.7 1-15.7 11.3-11.7 20.2 15 32.8 22.9 69.5 23 107.7.1 14.4 15.2 23.1 27.6 16 33.2-19 68.9-30.5 104.8-33.9 9.7-.9 15.6-11.3 11.6-20.2-6.2-13.9-11.1-28.6-14.7-43.8-3.6-15.2 5.3-30.6 20.2-35.1 14.9-4.5 30.1-7.6 45.3-9.1 9.7-1 15.7-11.3 11.7-20.2-15.5-34.2-23.3-72.5-22.9-112.3zM435 365.6c-15.2-1.6-30.3-4.7-45.3-9.1-14.9-4.5-23.8-19.9-20.2-35.1 3.6-15.2 8.5-29.8 14.7-43.8 4-8.9-1.9-19.3-11.6-20.2-37.3-3.5-74.4-15.9-108.7-36.2-10.7-6.3-23.9 1.4-23.8 13.7 0 1.6-.2 3.2-.2 4.9.2 33.3 7 65.7 19.9 94 5.7 12.4 5.2 26.6-.6 38.9 4.9 1.2 9.9 2.2 14.8 3.7 14.9 4.5 23.8 19.9 20.2 35.1-3.6 15.2-8.5 29.8-14.7 43.8-4 8.9 1.9 19.3 11.6 20.2 35.9 3.4 71.6 14.9 104.8 33.9 12.5 7.1 27.6-1.6 27.6-16 .2-38.2 8-75 23-107.7 4.3-8.7-1.8-19.1-11.5-20.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHome(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M280.37 148.26L96 300.11V464a16 16 0 0 0 16 16l112.06-.29a16 16 0 0 0 15.92-16V368a16 16 0 0 1 16-16h64a16 16 0 0 1 16 16v95.64a16 16 0 0 0 16 16.05L464 480a16 16 0 0 0 16-16V300L295.67 148.26a12.19 12.19 0 0 0-15.3 0zM571.6 251.47L488 182.56V44.05a12 12 0 0 0-12-12h-56a12 12 0 0 0-12 12v72.61L318.47 43a48 48 0 0 0-61 0L4.34 251.47a12 12 0 0 0-1.6 16.9l25.5 31A12 12 0 0 0 45.15 301l235.22-193.74a12.19 12.19 0 0 1 15.3 0L530.9 301a12 12 0 0 0 16.9-1.6l25.5-31a12 12 0 0 0-1.7-16.93z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHorseHead(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M509.8 332.5l-69.9-164.3c-14.9-41.2-50.4-71-93-79.2 18-10.6 46.3-35.9 34.2-82.3-1.3-5-7.1-7.9-12-6.1L166.9 76.3C35.9 123.4 0 238.9 0 398.8V480c0 17.7 14.3 32 32 32h236.2c23.8 0 39.3-25 28.6-46.3L256 384v-.7c-45.6-3.5-84.6-30.7-104.3-69.6-1.6-3.1-.9-6.9 1.6-9.3l12.1-12.1c3.9-3.9 10.6-2.7 12.9 2.4 14.8 33.7 48.2 57.4 87.4 57.4 17.2 0 33-5.1 46.8-13.2l46 63.9c6 8.4 15.7 13.3 26 13.3h50.3c8.5 0 16.6-3.4 22.6-9.4l45.3-39.8c8.9-9.1 11.7-22.6 7.1-34.4zM328 224c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHorse(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M575.92 76.6c-.01-8.13-3.02-15.87-8.58-21.8-3.78-4.03-8.58-9.12-13.69-14.5 11.06-6.84 19.5-17.49 22.18-30.66C576.85 4.68 572.96 0 567.9 0H447.92c-70.69 0-128 57.31-128 128H160c-28.84 0-54.4 12.98-72 33.11V160c-48.53 0-88 39.47-88 88v56c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-56c0-13.22 6.87-24.39 16.78-31.68-.21 2.58-.78 5.05-.78 7.68 0 27.64 11.84 52.36 30.54 69.88l-25.72 68.6a63.945 63.945 0 0 0-2.16 37.99l24.85 99.41A15.982 15.982 0 0 0 107.02 512h65.96c10.41 0 18.05-9.78 15.52-19.88l-26.31-105.26 23.84-63.59L320 345.6V496c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16V318.22c19.74-20.19 32-47.75 32-78.22 0-.22-.07-.42-.08-.64V136.89l16 7.11 18.9 37.7c7.45 14.87 25.05 21.55 40.49 15.37l32.55-13.02a31.997 31.997 0 0 0 20.12-29.74l-.06-77.71zm-64 19.4c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHospitalAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 96H416V32c0-17.7-14.3-32-32-32H192c-17.7 0-32 14.3-32 32v64H32c-17.7 0-32 14.3-32 32v368c0 8.8 7.2 16 16 16h544c8.8 0 16-7.2 16-16V128c0-17.7-14.3-32-32-32zM160 436c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm160 128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm16-170c0 3.3-2.7 6-6 6h-26v26c0 3.3-2.7 6-6 6h-20c-3.3 0-6-2.7-6-6v-26h-26c-3.3 0-6-2.7-6-6v-20c0-3.3 2.7-6 6-6h26V86c0-3.3 2.7-6 6-6h20c3.3 0 6 2.7 6 6v26h26c3.3 0 6 2.7 6 6v20zm144 298c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHospitalSymbol(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256S397.4 0 256 0zm112 376c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-88h-96v88c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V136c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v88h96v-88c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v240z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHospitalUser(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 320a96 96 0 1 0-96-96 96 96 0 0 0 96 96zm48 32a22.88 22.88 0 0 0-7.06 1.09 124.76 124.76 0 0 1-81.89 0A22.82 22.82 0 0 0 432 352a112 112 0 0 0-112 112.62c.14 26.26 21.73 47.38 48 47.38h224c26.27 0 47.86-21.12 48-47.38A112 112 0 0 0 528 352zm-198.09 10.45A145.19 145.19 0 0 1 352 344.62V128a32 32 0 0 0-32-32h-32V32a32 32 0 0 0-32-32H96a32 32 0 0 0-32 32v64H32a32 32 0 0 0-32 32v368a16 16 0 0 0 16 16h288.31A78.62 78.62 0 0 1 288 464.79a143.06 143.06 0 0 1 41.91-102.34zM144 404a12 12 0 0 1-12 12H92a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zm0-128a12 12 0 0 1-12 12H92a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zm48-122a6 6 0 0 1-6 6h-20a6 6 0 0 1-6-6v-26h-26a6 6 0 0 1-6-6v-20a6 6 0 0 1 6-6h26V70a6 6 0 0 1 6-6h20a6 6 0 0 1 6 6v26h26a6 6 0 0 1 6 6v20a6 6 0 0 1-6 6h-26zm80 250a12 12 0 0 1-12 12h-40a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zm0-128a12 12 0 0 1-12 12h-40a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHospital(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 492v20H0v-20c0-6.627 5.373-12 12-12h20V120c0-13.255 10.745-24 24-24h88V24c0-13.255 10.745-24 24-24h112c13.255 0 24 10.745 24 24v72h88c13.255 0 24 10.745 24 24v360h20c6.627 0 12 5.373 12 12zM308 192h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm-168 64h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12zm104 128h-40c-6.627 0-12 5.373-12 12v84h64v-84c0-6.627-5.373-12-12-12zm64-96h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm-116 12c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40zM182 96h26v26a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6V96h26a6 6 0 0 0 6-6V70a6 6 0 0 0-6-6h-26V38a6 6 0 0 0-6-6h-20a6 6 0 0 0-6 6v26h-26a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHotTub(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M414.21 177.65c1.02 8.21 7.75 14.35 15.75 14.35h16.12c9.51 0 17.08-8.57 16-18.35-4.34-39.11-22.4-74.53-50.13-97.16-17.37-14.17-28.82-36.75-31.98-62.15C378.96 6.14 372.22 0 364.23 0h-16.12c-9.51 0-17.09 8.57-16 18.35 4.34 39.11 22.4 74.53 50.13 97.16 17.36 14.17 28.82 36.75 31.97 62.14zm-108 0c1.02 8.21 7.75 14.35 15.75 14.35h16.12c9.51 0 17.08-8.57 16-18.35-4.34-39.11-22.4-74.53-50.13-97.16-17.37-14.17-28.82-36.75-31.98-62.15C270.96 6.14 264.22 0 256.23 0h-16.12c-9.51 0-17.09 8.57-16 18.35 4.34 39.11 22.4 74.53 50.13 97.16 17.36 14.17 28.82 36.75 31.97 62.14zM480 256H256l-110.93-83.2a63.99 63.99 0 0 0-38.4-12.8H64c-35.35 0-64 28.65-64 64v224c0 35.35 28.65 64 64 64h384c35.35 0 64-28.65 64-64V288c0-17.67-14.33-32-32-32zM128 440c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zm96 0c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zm96 0c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zm96 0c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zM64 128c35.35 0 64-28.65 64-64S99.35 0 64 0 0 28.65 0 64s28.65 64 64 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHotdog(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488.56 23.44a80 80 0 0 0-113.12 0l-352 352a80 80 0 1 0 113.12 113.12l352-352a80 80 0 0 0 0-113.12zm-49.93 95.19c-19.6 19.59-37.52 22.67-51.93 25.14C373.76 146 364.4 147.6 352 160s-14 21.76-16.23 34.71c-2.48 14.4-5.55 32.33-25.15 51.92s-37.52 22.67-51.92 25.15C245.75 274 236.4 275.6 224 288s-14 21.75-16.23 34.7c-2.47 14.4-5.54 32.33-25.14 51.92s-37.53 22.68-51.93 25.15C117.76 402 108.4 403.6 96 416a16 16 0 0 1-22.63-22.63c19.6-19.59 37.52-22.67 51.92-25.14 13-2.22 22.3-3.82 34.71-16.23s14-21.75 16.22-34.7c2.48-14.4 5.55-32.33 25.15-51.92s37.52-22.67 51.92-25.14c13-2.22 22.3-3.83 34.7-16.23s14-21.76 16.24-34.71c2.47-14.4 5.54-32.33 25.14-51.92s37.52-22.68 51.92-25.15C394.24 110 403.59 108.41 416 96a16 16 0 0 1 22.63 22.63zM31.44 322.18L322.18 31.44l-11.54-11.55c-25-25-63.85-26.66-86.79-3.72L16.17 223.85c-22.94 22.94-21.27 61.79 3.72 86.78zm449.12-132.36L189.82 480.56l11.54 11.55c25 25 63.85 26.66 86.79 3.72l207.68-207.68c22.94-22.94 21.27-61.79-3.72-86.79z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHotel(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M560 64c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16H16C7.16 0 0 7.16 0 16v32c0 8.84 7.16 16 16 16h15.98v384H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h240v-80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v80h240c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16h-16V64h16zm-304 44.8c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4zm0 96c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4zm-128-96c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4zM179.2 256h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8zM192 384c0-53.02 42.98-96 96-96s96 42.98 96 96H192zm256-140.8c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm0-96c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHourglassEnd(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64zM192 208c-57.787 0-104-66.518-104-144h208c0 77.945-46.51 144-104 144z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHourglassHalf(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M360 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24zm-75.078 384H99.08c17.059-46.797 52.096-80 92.92-80 40.821 0 75.862 33.196 92.922 80zm.019-256H99.078C91.988 108.548 88 86.748 88 64h208c0 22.805-3.987 44.587-11.059 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHourglassStart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M360 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24zm-64 448H88c0-77.458 46.204-144 104-144 57.786 0 104 66.517 104 144z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHourglass(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHouseDamage(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 114.96L69.47 307.71c-1.62 1.46-3.69 2.14-5.47 3.35V496c0 8.84 7.16 16 16 16h149.23L192 439.19l104.11-64-60.16-119.22L384 392.75l-104.11 64L319.81 512H496c8.84 0 16-7.16 16-16V311.1c-1.7-1.16-3.72-1.82-5.26-3.2L288 114.96zm282.69 121.32L512 184.45V48c0-8.84-7.16-16-16-16h-64c-8.84 0-16 7.16-16 16v51.69L314.75 10.31C307.12 3.45 297.56.01 288 0s-19.1 3.41-26.7 10.27L5.31 236.28c-6.57 5.91-7.12 16.02-1.21 22.6l21.4 23.82c5.9 6.57 16.02 7.12 22.6 1.21L277.42 81.63c6.05-5.33 15.12-5.33 21.17 0L527.91 283.9c6.57 5.9 16.69 5.36 22.6-1.21l21.4-23.82c5.9-6.57 5.36-16.69-1.22-22.59z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHouseUser(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M570.69,236.27,512,184.44V48a16,16,0,0,0-16-16H432a16,16,0,0,0-16,16V99.67L314.78,10.3C308.5,4.61,296.53,0,288,0s-20.46,4.61-26.74,10.3l-256,226A18.27,18.27,0,0,0,0,248.2a18.64,18.64,0,0,0,4.09,10.71L25.5,282.7a21.14,21.14,0,0,0,12,5.3,21.67,21.67,0,0,0,10.69-4.11l15.9-14V480a32,32,0,0,0,32,32H480a32,32,0,0,0,32-32V269.88l15.91,14A21.94,21.94,0,0,0,538.63,288a20.89,20.89,0,0,0,11.87-5.31l21.41-23.81A21.64,21.64,0,0,0,576,248.19,21,21,0,0,0,570.69,236.27ZM288,176a64,64,0,1,1-64,64A64,64,0,0,1,288,176ZM400,448H176a16,16,0,0,1-16-16,96,96,0,0,1,96-96h64a96,96,0,0,1,96,96A16,16,0,0,1,400,448Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaHryvnia(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 240c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16h-41.86c13.41-28.63 13.74-63.33-4.13-94.05C303.34 49.84 267.1 32 229.96 32h-78.82c-24.32 0-47.86 8.53-66.54 24.09L72.83 65.9c-10.18 8.49-11.56 23.62-3.07 33.8l20.49 24.59c8.49 10.19 23.62 11.56 33.81 3.07l11.73-9.78c4.32-3.6 9.77-5.57 15.39-5.57h83.62c11.69 0 21.2 9.52 21.2 21.2 0 5.91-2.48 11.58-6.81 15.58L219.7 176H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h134.37l-34.67 32H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h41.86c-13.41 28.63-13.74 63.33 4.13 94.05C80.66 462.15 116.9 480 154.04 480h78.82c24.32 0 47.86-8.53 66.54-24.09l11.77-9.81c10.18-8.49 11.56-23.62 3.07-33.8l-20.49-24.59c-8.49-10.19-23.62-11.56-33.81-3.07l-11.75 9.8a23.992 23.992 0 0 1-15.36 5.56H149.2c-11.69 0-21.2-9.52-21.2-21.2 0-5.91 2.48-11.58 6.81-15.58L164.3 336H368c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16H233.63l34.67-32H368z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaICursor(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 52.048V12.065C256 5.496 250.726.148 244.158.066 211.621-.344 166.469.011 128 37.959 90.266.736 46.979-.114 11.913.114 5.318.157 0 5.519 0 12.114v39.645c0 6.687 5.458 12.078 12.145 11.998C38.111 63.447 96 67.243 96 112.182V224H60c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h36v112c0 44.932-56.075 48.031-83.95 47.959C5.404 447.942 0 453.306 0 459.952v39.983c0 6.569 5.274 11.917 11.842 11.999 32.537.409 77.689.054 116.158-37.894 37.734 37.223 81.021 38.073 116.087 37.845 6.595-.043 11.913-5.405 11.913-12V460.24c0-6.687-5.458-12.078-12.145-11.998C217.889 448.553 160 444.939 160 400V288h36c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-36V112.182c0-44.932 56.075-48.213 83.95-48.142 6.646.018 12.05-5.346 12.05-11.992z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaIceCream(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 160h-.94a144 144 0 1 0-286.12 0H80a48 48 0 0 0 0 96h288a48 48 0 0 0 0-96zM195.38 493.69a31.52 31.52 0 0 0 57.24 0L352 288H96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaIcicles(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M511.4 37.9C515.1 18.2 500 0 480 0H32C10.6 0-4.8 20.7 1.4 41.2l87.1 273.4c2.5 7.2 12.7 7.2 15.1 0L140 190.5l44.2 187.3c1.9 8.3 13.7 8.3 15.6 0l46.5-196.9 34.1 133.4c2.3 7.6 13 7.6 15.3 0l45.8-172.5 66.7 363.8c1.7 8.6 14 8.6 15.7 0l87.5-467.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaIcons(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M116.65 219.35a15.68 15.68 0 0 0 22.65 0l96.75-99.83c28.15-29 26.5-77.1-4.91-103.88C203.75-7.7 163-3.5 137.86 22.44L128 32.58l-9.85-10.14C93.05-3.5 52.25-7.7 24.86 15.64c-31.41 26.78-33 74.85-5 103.88zm143.92 100.49h-48l-7.08-14.24a27.39 27.39 0 0 0-25.66-17.78h-71.71a27.39 27.39 0 0 0-25.66 17.78l-7 14.24h-48A27.45 27.45 0 0 0 0 347.3v137.25A27.44 27.44 0 0 0 27.43 512h233.14A27.45 27.45 0 0 0 288 484.55V347.3a27.45 27.45 0 0 0-27.43-27.46zM144 468a52 52 0 1 1 52-52 52 52 0 0 1-52 52zm355.4-115.9h-60.58l22.36-50.75c2.1-6.65-3.93-13.21-12.18-13.21h-75.59c-6.3 0-11.66 3.9-12.5 9.1l-16.8 106.93c-1 6.3 4.88 11.89 12.5 11.89h62.31l-24.2 83c-1.89 6.65 4.2 12.9 12.23 12.9a13.26 13.26 0 0 0 10.92-5.25l92.4-138.91c4.88-6.91-1.16-15.7-10.87-15.7zM478.08.33L329.51 23.17C314.87 25.42 304 38.92 304 54.83V161.6a83.25 83.25 0 0 0-16-1.7c-35.35 0-64 21.48-64 48s28.65 48 64 48c35.2 0 63.73-21.32 64-47.66V99.66l112-17.22v47.18a83.25 83.25 0 0 0-16-1.7c-35.35 0-64 21.48-64 48s28.65 48 64 48c35.2 0 63.73-21.32 64-47.66V32c0-19.48-16-34.42-33.92-31.67z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaIdBadge(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM144 32h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16zm48 128c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H102.4C90 416 80 407.4 80 396.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaIdCardAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528 64H384v96H192V64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM288 224c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm93.3 224H194.7c-10.4 0-18.8-10-15.6-19.8 8.3-25.6 32.4-44.2 60.9-44.2h8.2c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h8.2c28.4 0 52.5 18.5 60.9 44.2 3.2 9.8-5.2 19.8-15.6 19.8zM352 32c0-17.7-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32v96h128V32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaIdCard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528 32H48C21.5 32 0 53.5 0 80v16h576V80c0-26.5-21.5-48-48-48zM0 432c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V128H0v304zm352-232c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16zm0 64c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16zm0 64c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16zM176 192c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zM67.1 396.2C75.5 370.5 99.6 352 128 352h8.2c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h8.2c28.4 0 52.5 18.5 60.9 44.2 3.2 9.9-5.2 19.8-15.6 19.8H82.7c-10.4 0-18.8-10-15.6-19.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaIgloo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 33.9c-10.5-1.2-21.2-1.9-32-1.9-99.8 0-187.8 50.8-239.4 128H320V33.9zM96 192H30.3C11.1 230.6 0 274 0 320h96V192zM352 39.4V160h175.4C487.2 99.9 424.8 55.9 352 39.4zM480 320h96c0-46-11.1-89.4-30.3-128H480v128zm-64 64v96h128c17.7 0 32-14.3 32-32v-96H411.5c2.6 10.3 4.5 20.9 4.5 32zm32-192H128v128h49.8c22.2-38.1 63-64 110.2-64s88 25.9 110.2 64H448V192zM0 448c0 17.7 14.3 32 32 32h128v-96c0-11.1 1.9-21.7 4.5-32H0v96zm288-160c-53 0-96 43-96 96v96h192v-96c0-53-43-96-96-96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaImage(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 448H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48zM112 120c-30.928 0-56 25.072-56 56s25.072 56 56 56 56-25.072 56-56-25.072-56-56-56zM64 384h384V272l-87.515-87.515c-4.686-4.686-12.284-4.686-16.971 0L208 320l-55.515-55.515c-4.686-4.686-12.284-4.686-16.971 0L64 336v48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaImages(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 416v16c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V176c0-26.51 21.49-48 48-48h16v208c0 44.112 35.888 80 80 80h336zm96-80V80c0-26.51-21.49-48-48-48H144c-26.51 0-48 21.49-48 48v256c0 26.51 21.49 48 48 48h384c26.51 0 48-21.49 48-48zM256 128c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-96 144l55.515-55.515c4.686-4.686 12.284-4.686 16.971 0L272 256l135.515-135.515c4.686-4.686 12.284-4.686 16.971 0L512 208v112H160v-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaInbox(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M567.938 243.908L462.25 85.374A48.003 48.003 0 0 0 422.311 64H153.689a48 48 0 0 0-39.938 21.374L8.062 243.908A47.994 47.994 0 0 0 0 270.533V400c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V270.533a47.994 47.994 0 0 0-8.062-26.625zM162.252 128h251.497l85.333 128H376l-32 64H232l-32-64H76.918l85.334-128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaIndent(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M27.31 363.3l96-96a16 16 0 0 0 0-22.62l-96-96C17.27 138.66 0 145.78 0 160v192c0 14.31 17.33 21.3 27.31 11.3zM432 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm3.17-128H204.83A12.82 12.82 0 0 0 192 300.83v38.34A12.82 12.82 0 0 0 204.83 352h230.34A12.82 12.82 0 0 0 448 339.17v-38.34A12.82 12.82 0 0 0 435.17 288zm0-128H204.83A12.82 12.82 0 0 0 192 172.83v38.34A12.82 12.82 0 0 0 204.83 224h230.34A12.82 12.82 0 0 0 448 211.17v-38.34A12.82 12.82 0 0 0 435.17 160zM432 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaIndustry(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M475.115 163.781L336 252.309v-68.28c0-18.916-20.931-30.399-36.885-20.248L160 252.309V56c0-13.255-10.745-24-24-24H24C10.745 32 0 42.745 0 56v400c0 13.255 10.745 24 24 24h464c13.255 0 24-10.745 24-24V184.029c0-18.917-20.931-30.399-36.885-20.248z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaInfinity(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M471.1 96C405 96 353.3 137.3 320 174.6 286.7 137.3 235 96 168.9 96 75.8 96 0 167.8 0 256s75.8 160 168.9 160c66.1 0 117.8-41.3 151.1-78.6 33.3 37.3 85 78.6 151.1 78.6 93.1 0 168.9-71.8 168.9-160S564.2 96 471.1 96zM168.9 320c-40.2 0-72.9-28.7-72.9-64s32.7-64 72.9-64c38.2 0 73.4 36.1 94 64-20.4 27.6-55.9 64-94 64zm302.2 0c-38.2 0-73.4-36.1-94-64 20.4-27.6 55.9-64 94-64 40.2 0 72.9 28.7 72.9 64s-32.7 64-72.9 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaInfoCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaInfo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 192 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 424.229h20V279.771H20c-11.046 0-20-8.954-20-20V212c0-11.046 8.954-20 20-20h112c11.046 0 20 8.954 20 20v212.229h20c11.046 0 20 8.954 20 20V492c0 11.046-8.954 20-20 20H20c-11.046 0-20-8.954-20-20v-47.771c0-11.046 8.954-20 20-20zM96 0C56.235 0 24 32.235 24 72s32.235 72 72 72 72-32.235 72-72S135.764 0 96 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaItalic(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 48v32a16 16 0 0 1-16 16h-62.76l-80 320H208a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H16a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h62.76l80-320H112a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h192a16 16 0 0 1 16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaJedi(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M535.95308,352c-42.64069,94.17188-137.64086,160-247.9848,160q-6.39844,0-12.84377-.29688C171.15558,506.9375,81.26481,442.23438,40.01474,352H79.93668L21.3272,293.40625a264.82522,264.82522,0,0,1-5.10938-39.42187,273.6653,273.6653,0,0,1,.5-29.98438H63.93665L22.546,182.625A269.79782,269.79782,0,0,1,130.51489,20.54688a16.06393,16.06393,0,0,1,9.28127-3,16.36332,16.36332,0,0,1,13.5,7.25,16.02739,16.02739,0,0,1,1.625,15.09374,138.387,138.387,0,0,0-9.84376,51.26563c0,45.10937,21.04691,86.57813,57.71884,113.73437a16.29989,16.29989,0,0,1,1.20313,25.39063c-26.54692,23.98437-41.17194,56.5-41.17194,91.57813,0,60.03124,42.95319,110.28124,99.89079,121.92187l2.5-65.26563L238.062,397a8.33911,8.33911,0,0,1-10-.75,8.025,8.025,0,0,1-1.39063-9.9375l20.125-33.76562-42.06257-8.73438a7.9898,7.9898,0,0,1,0-15.65625l42.06257-8.71875-20.10941-33.73438a7.99122,7.99122,0,0,1,11.35939-10.71874L268.437,295.64062,279.95265,7.67188a7.97138,7.97138,0,0,1,8-7.67188h.04687a8.02064,8.02064,0,0,1,7.95314,7.70312L307.48394,295.625l30.39068-20.67188a8.08327,8.08327,0,0,1,10,.8125,7.99866,7.99866,0,0,1,1.39062,9.90626L329.12461,319.4375l42.07819,8.73438a7.99373,7.99373,0,0,1,0,15.65624l-42.07819,8.71876,20.1094,33.73437a7.97791,7.97791,0,0,1-1.32812,9.92187A8.25739,8.25739,0,0,1,337.87462,397L310.7027,378.53125l2.5,65.34375c48.48446-9.40625,87.57828-48.15625,97.31267-96.5A123.52652,123.52652,0,0,0,371.9528,230.29688a16.30634,16.30634,0,0,1,1.20313-25.42188c36.65631-27.17188,57.6876-68.60938,57.6876-113.73438a138.01689,138.01689,0,0,0-9.85939-51.3125,15.98132,15.98132,0,0,1,1.60937-15.09374,16.36914,16.36914,0,0,1,13.5-7.23438,16.02453,16.02453,0,0,1,9.25,2.98438A271.26947,271.26947,0,0,1,553.25,182.76562L511.99992,224h46.9532C559.3125,229.76562,560,235.45312,560,241.26562a270.092,270.092,0,0,1-5.125,51.85938L495.98427,352Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaJoint(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M444.34 181.1c22.38 15.68 35.66 41.16 35.66 68.59V280c0 4.42 3.58 8 8 8h48c4.42 0 8-3.58 8-8v-30.31c0-43.24-21.01-83.41-56.34-108.06C463.85 125.02 448 99.34 448 70.31V8c0-4.42-3.58-8-8-8h-48c-4.42 0-8 3.58-8 8v66.4c0 43.69 24.56 81.63 60.34 106.7zM194.97 358.98C126.03 370.07 59.69 394.69 0 432c83.65 52.28 180.3 80 278.94 80h88.57L254.79 380.49c-14.74-17.2-37.45-25.11-59.82-21.51zM553.28 87.09c-5.67-3.8-9.28-9.96-9.28-16.78V8c0-4.42-3.58-8-8-8h-48c-4.42 0-8 3.58-8 8v62.31c0 22.02 10.17 43.41 28.64 55.39C550.79 153.04 576 199.54 576 249.69V280c0 4.42 3.58 8 8 8h48c4.42 0 8-3.58 8-8v-30.31c0-65.44-32.41-126.19-86.72-162.6zM360.89 352.05c-34.4.06-86.81.15-88.21.17l117.8 137.43A63.987 63.987 0 0 0 439.07 512h88.45L409.57 374.4a63.955 63.955 0 0 0-48.68-22.35zM616 352H432l117.99 137.65A63.987 63.987 0 0 0 598.58 512H616c13.25 0 24-10.75 24-24V376c0-13.26-10.75-24-24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaJournalWhills(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M438.40625,377.59375c-3.20313,12.8125-3.20313,57.60937,0,73.60937Q447.9922,460.78907,448,470.40625v16c0,16-12.79688,25.59375-25.59375,25.59375H96c-54.40625,0-96-41.59375-96-96V96C0,41.59375,41.59375,0,96,0H422.40625C438.40625,0,448,9.59375,448,25.59375v332.8125Q448,372.79688,438.40625,377.59375ZM380.79688,384H96c-16,0-32,12.79688-32,32s12.79688,32,32,32H380.79688ZM128.01562,176.01562c0,.51563.14063.98438.14063,1.5l37.10937,32.46876A7.99954,7.99954,0,0,1,160,224h-.01562a9.17678,9.17678,0,0,1-5.25-1.98438L131.14062,201.375C142.6875,250.95312,186.90625,288,240,288s97.3125-37.04688,108.875-86.625l-23.59375,20.64062a8.02516,8.02516,0,0,1-5.26563,1.96876H320a9.14641,9.14641,0,0,1-6.01562-2.71876A9.26508,9.26508,0,0,1,312,216a9.097,9.097,0,0,1,2.73438-6.01562l37.10937-32.46876c.01563-.53124.15625-1,.15625-1.51562,0-11.04688-2.09375-21.51562-5.06251-31.59375l-21.26562,21.25a8.00467,8.00467,0,0,1-11.32812-11.3125l26.42187-26.40625a111.81517,111.81517,0,0,0-46.35937-49.26562,63.02336,63.02336,0,0,1-14.0625,82.64062A55.83846,55.83846,0,0,1,251.625,254.73438l-1.42188-34.28126,12.67188,8.625a3.967,3.967,0,0,0,2.25.6875,3.98059,3.98059,0,0,0,3.43749-6.03124l-8.53124-14.3125,17.90625-3.71876a4.00647,4.00647,0,0,0,0-7.84374l-17.90625-3.71876,8.53124-14.3125a3.98059,3.98059,0,0,0-3.43749-6.03124,4.726,4.726,0,0,0-2.25.67187L248.6875,184.125,244,71.82812a4.00386,4.00386,0,0,0-8,0l-4.625,110.8125-12-8.15624a4.003,4.003,0,0,0-5.68751,5.35937l8.53126,14.3125L204.3125,197.875a3.99686,3.99686,0,0,0,0,7.82812l17.90625,3.73438-8.53126,14.29688a4.72469,4.72469,0,0,0-.56249,2.04687,4.59547,4.59547,0,0,0,1.25,2.90625,4.01059,4.01059,0,0,0,2.75,1.09375,4.09016,4.09016,0,0,0,2.25-.6875l10.35937-7.04687L228.375,254.76562a55.86414,55.86414,0,0,1-28.71875-93.45312,63.01119,63.01119,0,0,1-14.04688-82.65625,111.93158,111.93158,0,0,0-46.375,49.26563l26.42187,26.42187a7.99917,7.99917,0,0,1-11.3125,11.3125l-21.26563-21.26563C130.09375,154.48438,128,164.95312,128.01562,176.01562Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaKaaba(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M554.12 83.51L318.36 4.93a95.962 95.962 0 0 0-60.71 0L21.88 83.51A32.006 32.006 0 0 0 0 113.87v49.01l265.02-79.51c15.03-4.5 30.92-4.5 45.98 0l265 79.51v-49.01c0-13.77-8.81-26-21.88-30.36zm-279.9 30.52L0 196.3v228.38c0 15 10.42 27.98 25.06 31.24l242.12 53.8a95.937 95.937 0 0 0 41.65 0l242.12-53.8c14.64-3.25 25.06-16.24 25.06-31.24V196.29l-274.2-82.26c-9.04-2.72-18.59-2.72-27.59 0zM128 230.11c0 3.61-2.41 6.77-5.89 7.72l-80 21.82C37.02 261.03 32 257.2 32 251.93v-16.58c0-3.61 2.41-6.77 5.89-7.72l80-21.82c5.09-1.39 10.11 2.44 10.11 7.72v16.58zm144-39.28c0 3.61-2.41 6.77-5.89 7.72l-96 26.18c-5.09 1.39-10.11-2.44-10.11-7.72v-16.58c0-3.61 2.41-6.77 5.89-7.72l96-26.18c5.09-1.39 10.11 2.44 10.11 7.72v16.58zm176 22.7c0-5.28 5.02-9.11 10.11-7.72l80 21.82c3.48.95 5.89 4.11 5.89 7.72v16.58c0 5.28-5.02 9.11-10.11 7.72l-80-21.82a7.997 7.997 0 0 1-5.89-7.72v-16.58zm-144-39.27c0-5.28 5.02-9.11 10.11-7.72l96 26.18c3.48.95 5.89 4.11 5.89 7.72v16.58c0 5.28-5.02 9.11-10.11 7.72l-96-26.18a7.997 7.997 0 0 1-5.89-7.72v-16.58z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaKey(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 176.001C512 273.203 433.202 352 336 352c-11.22 0-22.19-1.062-32.827-3.069l-24.012 27.014A23.999 23.999 0 0 1 261.223 384H224v40c0 13.255-10.745 24-24 24h-40v40c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24v-78.059c0-6.365 2.529-12.47 7.029-16.971l161.802-161.802C163.108 213.814 160 195.271 160 176 160 78.798 238.797.001 335.999 0 433.488-.001 512 78.511 512 176.001zM336 128c0 26.51 21.49 48 48 48s48-21.49 48-48-21.49-48-48-48-48 21.49-48 48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaKeyboard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528 448H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h480c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48zM128 180v-40c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm288 0v-40c0-6.627-5.373-12-12-12H172c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h232c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaKhanda(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M415.81 66c-6.37-3.5-14.37-2.33-19.36 3.02a15.974 15.974 0 0 0-1.91 19.52c16.49 26.16 25.2 56.39 25.2 87.41-.19 53.25-26.77 102.69-71.27 132.41l-76.63 53.35v-20.1l44.05-36.09c3.92-4.2 5-10.09 2.81-15.28L310.85 273c33.84-19.26 56.94-55.25 56.94-96.99 0-40.79-22.02-76.13-54.59-95.71l5.22-11.44c2.34-5.53.93-11.83-3.57-16.04L255.86 0l-58.99 52.81c-4.5 4.21-5.9 10.51-3.57 16.04l5.22 11.44c-32.57 19.58-54.59 54.93-54.59 95.72 0 41.75 23.09 77.73 56.94 96.99l-7.85 17.24c-2.19 5.18-1.1 11.07 2.81 15.28l44.05 36.09v19.9l-76.59-53.33C119.02 278.62 92.44 229.19 92.26 176c0-31.08 8.71-61.31 25.2-87.47 3.87-6.16 2.4-13.77-2.59-19.08-5-5.34-13.68-6.2-20.02-2.7C16.32 109.6-22.3 205.3 13.36 295.99c7.07 17.99 17.89 34.38 30.46 49.06l55.97 65.36c4.87 5.69 13.04 7.24 19.65 3.72l79.35-42.23L228 392.23l-47.08 32.78c-1.67-.37-3.23-1.01-5.01-1.01-13.25 0-23.99 10.74-23.99 24 0 13.25 10.74 24 23.99 24 12.1 0 21.69-9.11 23.33-20.76l40.63-28.28v29.95c-9.39 5.57-15.99 15.38-15.99 27.1 0 17.67 14.32 32 31.98 32s31.98-14.33 31.98-32c0-11.71-6.61-21.52-15.99-27.1v-30.15l40.91 28.48C314.41 462.89 324 472 336.09 472c13.25 0 23.99-10.75 23.99-24 0-13.26-10.74-24-23.99-24-1.78 0-3.34.64-5.01 1.01L284 392.23l29.21-20.34 79.35 42.23c6.61 3.52 14.78 1.97 19.65-3.71l52.51-61.31c18.87-22.02 34-47.5 41.25-75.59 21.62-83.66-16.45-167.27-90.16-207.51zm-95.99 110c0 22.3-11.49 41.92-28.83 53.38l-5.65-12.41c-8.75-24.52-8.75-51.04 0-75.56l7.83-17.18c16.07 11.65 26.65 30.45 26.65 51.77zm-127.93 0c0-21.32 10.58-40.12 26.66-51.76l7.83 17.18c8.75 24.52 8.75 51.03 0 75.56l-5.65 12.41c-17.34-11.46-28.84-31.09-28.84-53.39z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaKissBeam(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-39 219.9l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.5 8.5-10.9 12-15.1 4.5zM304 396c0 19.2-28.7 41.5-71.5 44-8.5.8-12.1-11.8-3.6-15.4l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-6-2.5-6.1-12.2 0-14.8l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-8.6-3.6-4.8-16.5 3.6-15.4 42.8 2.5 71.5 24.8 71.5 44 0 13-13.4 27.3-35.2 36C290.6 368.7 304 383 304 396zm65-168.1l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.3-15.6 4-14.9-4.5 3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.5 8.5-10.9 12-15.1 4.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaKissWinkHeart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 504 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M501.1 402.5c-8-20.8-31.5-31.5-53.1-25.9l-8.4 2.2-2.3-8.4c-5.9-21.4-27-36.5-49-33-25.2 4-40.6 28.6-34 52.6l22.9 82.6c1.5 5.3 7 8.5 12.4 7.1l83-21.5c24.1-6.3 37.7-31.8 28.5-55.7zm-177.6-4c-5.6-20.3-2.3-42 9-59.7 29.7-46.3 98.7-45.5 127.8 4.3 6.4.1 12.6 1.4 18.6 2.9 10.9-27.9 17.1-58.2 17.1-90C496 119 385 8 248 8S0 119 0 256s111 248 248 248c35.4 0 68.9-7.5 99.4-20.9-.3-.7-23.9-84.6-23.9-84.6zM168 240c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm120 156c0 19.2-28.7 41.5-71.5 44-8.5.8-12.1-11.8-3.6-15.4l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-6-2.5-5.7-12.3 0-14.8l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-8.8-3.7-4.6-16.6 3.6-15.4 42.8 2.5 71.5 24.8 71.5 44 0 13-13.4 27.3-35.2 36C274.6 368.7 288 383 288 396zm16-179c-8.3 7.4-21.6.4-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S400 181 404 206.2c1.7 11.1-11.3 18.3-19.8 10.8l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L304 217z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaKiss(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-80 232c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm136 156c0 19.2-28.7 41.5-71.5 44-8.5.8-12.1-11.8-3.6-15.4l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-6-2.5-6.1-12.2 0-14.8l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-8.6-3.6-4.8-16.5 3.6-15.4 42.8 2.5 71.5 24.8 71.5 44 0 13-13.4 27.3-35.2 36C290.6 368.7 304 383 304 396zm24-156c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaKiwiBird(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M575.81 217.98C572.64 157.41 518.28 112 457.63 112h-9.37c-52.82 0-104.25-16.25-147.74-46.24-41.99-28.96-96.04-41.62-153.21-28.7C129.3 41.12-.08 78.24 0 224c.04 70.95 38.68 132.8 95.99 166.01V464c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-54.26c15.36 3.96 31.4 6.26 48 6.26 5.44 0 10.68-.73 16-1.18V464c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-59.43c14.24-5.06 27.88-11.39 40.34-19.51C342.07 355.25 393.86 336 448.46 336c25.48 0 16.01-.31 23.05-.78l74.41 136.44c2.86 5.23 8.3 8.34 14.05 8.34 1.31 0 2.64-.16 3.95-.5 7.09-1.8 12.05-8.19 12.05-15.5 0 0 .14-240.24-.16-246.02zM463.97 248c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm80 153.25l-39.86-73.08c15.12-5.83 28.73-14.6 39.86-25.98v99.06z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLandmark(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M501.62 92.11L267.24 2.04a31.958 31.958 0 0 0-22.47 0L10.38 92.11A16.001 16.001 0 0 0 0 107.09V144c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-36.91c0-6.67-4.14-12.64-10.38-14.98zM64 192v160H48c-8.84 0-16 7.16-16 16v48h448v-48c0-8.84-7.16-16-16-16h-16V192h-64v160h-96V192h-64v160h-96V192H64zm432 256H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLanguage(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M152.1 236.2c-3.5-12.1-7.8-33.2-7.8-33.2h-.5s-4.3 21.1-7.8 33.2l-11.1 37.5H163zM616 96H336v320h280c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24zm-24 120c0 6.6-5.4 12-12 12h-11.4c-6.9 23.6-21.7 47.4-42.7 69.9 8.4 6.4 17.1 12.5 26.1 18 5.5 3.4 7.3 10.5 4.1 16.2l-7.9 13.9c-3.4 5.9-10.9 7.8-16.7 4.3-12.6-7.8-24.5-16.1-35.4-24.9-10.9 8.7-22.7 17.1-35.4 24.9-5.8 3.5-13.3 1.6-16.7-4.3l-7.9-13.9c-3.2-5.6-1.4-12.8 4.2-16.2 9.3-5.7 18-11.7 26.1-18-7.9-8.4-14.9-17-21-25.7-4-5.7-2.2-13.6 3.7-17.1l6.5-3.9 7.3-4.3c5.4-3.2 12.4-1.7 16 3.4 5 7 10.8 14 17.4 20.9 13.5-14.2 23.8-28.9 30-43.2H412c-6.6 0-12-5.4-12-12v-16c0-6.6 5.4-12 12-12h64v-16c0-6.6 5.4-12 12-12h16c6.6 0 12 5.4 12 12v16h64c6.6 0 12 5.4 12 12zM0 120v272c0 13.3 10.7 24 24 24h280V96H24c-13.3 0-24 10.7-24 24zm58.9 216.1L116.4 167c1.7-4.9 6.2-8.1 11.4-8.1h32.5c5.1 0 9.7 3.3 11.4 8.1l57.5 169.1c2.6 7.8-3.1 15.9-11.4 15.9h-22.9a12 12 0 0 1-11.5-8.6l-9.4-31.9h-60.2l-9.1 31.8c-1.5 5.1-6.2 8.7-11.5 8.7H70.3c-8.2 0-14-8.1-11.4-15.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLaptopCode(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M255.03 261.65c6.25 6.25 16.38 6.25 22.63 0l11.31-11.31c6.25-6.25 6.25-16.38 0-22.63L253.25 192l35.71-35.72c6.25-6.25 6.25-16.38 0-22.63l-11.31-11.31c-6.25-6.25-16.38-6.25-22.63 0l-58.34 58.34c-6.25 6.25-6.25 16.38 0 22.63l58.35 58.34zm96.01-11.3l11.31 11.31c6.25 6.25 16.38 6.25 22.63 0l58.34-58.34c6.25-6.25 6.25-16.38 0-22.63l-58.34-58.34c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63L386.75 192l-35.71 35.72c-6.25 6.25-6.25 16.38 0 22.63zM624 416H381.54c-.74 19.81-14.71 32-32.74 32H288c-18.69 0-33.02-17.47-32.77-32H16c-8.8 0-16 7.2-16 16v16c0 35.2 28.8 64 64 64h512c35.2 0 64-28.8 64-64v-16c0-8.8-7.2-16-16-16zM576 48c0-26.4-21.6-48-48-48H112C85.6 0 64 21.6 64 48v336h512V48zm-64 272H128V64h384v256z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLaptopHouse(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272,288H208a16,16,0,0,1-16-16V208a16,16,0,0,1,16-16h64a16,16,0,0,1,16,16v37.12C299.11,232.24,315,224,332.8,224H469.74l6.65-7.53A16.51,16.51,0,0,0,480,207a16.31,16.31,0,0,0-4.75-10.61L416,144V48a16,16,0,0,0-16-16H368a16,16,0,0,0-16,16V87.3L263.5,8.92C258,4,247.45,0,240.05,0s-17.93,4-23.47,8.92L4.78,196.42A16.15,16.15,0,0,0,0,207a16.4,16.4,0,0,0,3.55,9.39L22.34,237.7A16.22,16.22,0,0,0,33,242.48,16.51,16.51,0,0,0,42.34,239L64,219.88V384a32,32,0,0,0,32,32H272ZM629.33,448H592V288c0-17.67-12.89-32-28.8-32H332.8c-15.91,0-28.8,14.33-28.8,32V448H266.67A10.67,10.67,0,0,0,256,458.67v10.66A42.82,42.82,0,0,0,298.6,512H597.4A42.82,42.82,0,0,0,640,469.33V458.67A10.67,10.67,0,0,0,629.33,448ZM544,448H352V304H544Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLaptopMedical(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M232 224h56v56a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8v-56h56a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8h-56v-56a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v56h-56a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8zM576 48a48.14 48.14 0 0 0-48-48H112a48.14 48.14 0 0 0-48 48v336h512zm-64 272H128V64h384zm112 96H381.54c-.74 19.81-14.71 32-32.74 32H288c-18.69 0-33-17.47-32.77-32H16a16 16 0 0 0-16 16v16a64.19 64.19 0 0 0 64 64h512a64.19 64.19 0 0 0 64-64v-16a16 16 0 0 0-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLaptop(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 416H381.54c-.74 19.81-14.71 32-32.74 32H288c-18.69 0-33.02-17.47-32.77-32H16c-8.8 0-16 7.2-16 16v16c0 35.2 28.8 64 64 64h512c35.2 0 64-28.8 64-64v-16c0-8.8-7.2-16-16-16zM576 48c0-26.4-21.6-48-48-48H112C85.6 0 64 21.6 64 48v336h512V48zm-64 272H128V64h384v256z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLaughBeam(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm24 199.4c3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.8 4.1-15.1-4.5zm-160 0c3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.3 7.4-15.8 4-15.1-4.5zM398.9 306C390 377 329.4 432 256 432h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLaughSquint(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm33.8 161.7l80-48c11.6-6.9 24 7.7 15.4 18L343.6 180l33.6 40.3c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.7-4.7-7.7-15.9 0-20.6zm-163-30c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.8 4.7 7.8 15.9 0 20.6l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3zM398.9 306C390 377 329.4 432 256 432h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLaughWink(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm20.1 198.1c4-25.2 34.2-42.1 59.9-42.1s55.9 16.9 59.9 42.1c1.7 11.1-11.4 18.3-19.8 10.8l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L288 217c-8.4 7.4-21.6.3-19.9-10.9zM168 160c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm230.9 146C390 377 329.4 432 256 432h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLaugh(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 152c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm88 272h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18-8.9 71-69.5 126-142.9 126z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLayerGroup(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.41 148.02l232.94 105.67c6.8 3.09 14.49 3.09 21.29 0l232.94-105.67c16.55-7.51 16.55-32.52 0-40.03L266.65 2.31a25.607 25.607 0 0 0-21.29 0L12.41 107.98c-16.55 7.51-16.55 32.53 0 40.04zm487.18 88.28l-58.09-26.33-161.64 73.27c-7.56 3.43-15.59 5.17-23.86 5.17s-16.29-1.74-23.86-5.17L70.51 209.97l-58.1 26.33c-16.55 7.5-16.55 32.5 0 40l232.94 105.59c6.8 3.08 14.49 3.08 21.29 0L499.59 276.3c16.55-7.5 16.55-32.5 0-40zm0 127.8l-57.87-26.23-161.86 73.37c-7.56 3.43-15.59 5.17-23.86 5.17s-16.29-1.74-23.86-5.17L70.29 337.87 12.41 364.1c-16.55 7.5-16.55 32.5 0 40l232.94 105.59c6.8 3.08 14.49 3.08 21.29 0L499.59 404.1c16.55-7.5 16.55-32.5 0-40z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLeaf(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLemon(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M489.038 22.963C465.944-.13 434.648-5.93 413.947 6.129c-58.906 34.312-181.25-53.077-321.073 86.746S40.441 355.041 6.129 413.945c-12.059 20.702-6.26 51.999 16.833 75.093 23.095 23.095 54.392 28.891 75.095 16.832 58.901-34.31 181.246 53.079 321.068-86.743S471.56 156.96 505.871 98.056c12.059-20.702 6.261-51.999-16.833-75.093zM243.881 95.522c-58.189 14.547-133.808 90.155-148.358 148.358-1.817 7.27-8.342 12.124-15.511 12.124-1.284 0-2.59-.156-3.893-.481-8.572-2.144-13.784-10.83-11.642-19.403C81.901 166.427 166.316 81.93 236.119 64.478c8.575-2.143 17.261 3.069 19.403 11.642s-3.069 17.259-11.641 19.402z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLessThanEqual(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M54.98 214.2l301.41 119.87c18.39 6.03 38.71-2.54 45.38-19.15l12.09-30.08c6.68-16.61-2.82-34.97-21.21-41l-175.44-68.05 175.56-68.09c18.29-6 27.74-24.27 21.1-40.79l-12.03-29.92c-6.64-16.53-26.86-25.06-45.15-19.06L54.98 137.89C41.21 142.41 32 154.5 32 168.07v15.96c0 13.56 9.21 25.65 22.98 30.17zM424 400H24c-13.25 0-24 10.74-24 24v48c0 13.25 10.75 24 24 24h400c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLessThan(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M365.46 357.74L147.04 255.89l218.47-101.88c16.02-7.47 22.95-26.51 15.48-42.53l-13.52-29C360 66.46 340.96 59.53 324.94 67L18.48 209.91a32.014 32.014 0 0 0-18.48 29v34.24c0 12.44 7.21 23.75 18.48 29l306.31 142.83c16.06 7.49 35.15.54 42.64-15.52l13.56-29.08c7.49-16.06.54-35.15-15.53-42.64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLevelDownAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M313.553 392.331L209.587 504.334c-9.485 10.214-25.676 10.229-35.174 0L70.438 392.331C56.232 377.031 67.062 352 88.025 352H152V80H68.024a11.996 11.996 0 0 1-8.485-3.515l-56-56C-4.021 12.926 1.333 0 12.024 0H208c13.255 0 24 10.745 24 24v328h63.966c20.878 0 31.851 24.969 17.587 40.331z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLevelUpAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M313.553 119.669L209.587 7.666c-9.485-10.214-25.676-10.229-35.174 0L70.438 119.669C56.232 134.969 67.062 160 88.025 160H152v272H68.024a11.996 11.996 0 0 0-8.485 3.515l-56 56C-4.021 499.074 1.333 512 12.024 512H208c13.255 0 24-10.745 24-24V160h63.966c20.878 0 31.851-24.969 17.587-40.331z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLifeRing(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm173.696 119.559l-63.399 63.399c-10.987-18.559-26.67-34.252-45.255-45.255l63.399-63.399a218.396 218.396 0 0 1 45.255 45.255zM256 352c-53.019 0-96-42.981-96-96s42.981-96 96-96 96 42.981 96 96-42.981 96-96 96zM127.559 82.304l63.399 63.399c-18.559 10.987-34.252 26.67-45.255 45.255l-63.399-63.399a218.372 218.372 0 0 1 45.255-45.255zM82.304 384.441l63.399-63.399c10.987 18.559 26.67 34.252 45.255 45.255l-63.399 63.399a218.396 218.396 0 0 1-45.255-45.255zm302.137 45.255l-63.399-63.399c18.559-10.987 34.252-26.67 45.255-45.255l63.399 63.399a218.403 218.403 0 0 1-45.255 45.255z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLightbulb(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 352 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96.06 454.35c.01 6.29 1.87 12.45 5.36 17.69l17.09 25.69a31.99 31.99 0 0 0 26.64 14.28h61.71a31.99 31.99 0 0 0 26.64-14.28l17.09-25.69a31.989 31.989 0 0 0 5.36-17.69l.04-38.35H96.01l.05 38.35zM0 176c0 44.37 16.45 84.85 43.56 115.78 16.52 18.85 42.36 58.23 52.21 91.45.04.26.07.52.11.78h160.24c.04-.26.07-.51.11-.78 9.85-33.22 35.69-72.6 52.21-91.45C335.55 260.85 352 220.37 352 176 352 78.61 272.91-.3 175.45 0 73.44.31 0 82.97 0 176zm176-80c-44.11 0-80 35.89-80 80 0 8.84-7.16 16-16 16s-16-7.16-16-16c0-61.76 50.24-112 112-112 8.84 0 16 7.16 16 16s-7.16 16-16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLink(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M326.612 185.391c59.747 59.809 58.927 155.698.36 214.59-.11.12-.24.25-.36.37l-67.2 67.2c-59.27 59.27-155.699 59.262-214.96 0-59.27-59.26-59.27-155.7 0-214.96l37.106-37.106c9.84-9.84 26.786-3.3 27.294 10.606.648 17.722 3.826 35.527 9.69 52.721 1.986 5.822.567 12.262-3.783 16.612l-13.087 13.087c-28.026 28.026-28.905 73.66-1.155 101.96 28.024 28.579 74.086 28.749 102.325.51l67.2-67.19c28.191-28.191 28.073-73.757 0-101.83-3.701-3.694-7.429-6.564-10.341-8.569a16.037 16.037 0 0 1-6.947-12.606c-.396-10.567 3.348-21.456 11.698-29.806l21.054-21.055c5.521-5.521 14.182-6.199 20.584-1.731a152.482 152.482 0 0 1 20.522 17.197zM467.547 44.449c-59.261-59.262-155.69-59.27-214.96 0l-67.2 67.2c-.12.12-.25.25-.36.37-58.566 58.892-59.387 154.781.36 214.59a152.454 152.454 0 0 0 20.521 17.196c6.402 4.468 15.064 3.789 20.584-1.731l21.054-21.055c8.35-8.35 12.094-19.239 11.698-29.806a16.037 16.037 0 0 0-6.947-12.606c-2.912-2.005-6.64-4.875-10.341-8.569-28.073-28.073-28.191-73.639 0-101.83l67.2-67.19c28.239-28.239 74.3-28.069 102.325.51 27.75 28.3 26.872 73.934-1.155 101.96l-13.087 13.087c-4.35 4.35-5.769 10.79-3.783 16.612 5.864 17.194 9.042 34.999 9.69 52.721.509 13.906 17.454 20.446 27.294 10.606l37.106-37.106c59.271-59.259 59.271-155.699.001-214.959z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLiraSign(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M371.994 256h-48.019C317.64 256 312 260.912 312 267.246 312 368 230.179 416 144 416V256.781l134.603-29.912A12 12 0 0 0 288 215.155v-40.976c0-7.677-7.109-13.38-14.603-11.714L144 191.219V160.78l134.603-29.912A12 12 0 0 0 288 119.154V78.179c0-7.677-7.109-13.38-14.603-11.714L144 95.219V44c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v68.997L9.397 125.131A12 12 0 0 0 0 136.845v40.976c0 7.677 7.109 13.38 14.603 11.714L64 178.558v30.439L9.397 221.131A12 12 0 0 0 0 232.845v40.976c0 7.677 7.109 13.38 14.603 11.714L64 274.558V468c0 6.627 5.373 12 12 12h79.583c134.091 0 223.255-77.834 228.408-211.592.261-6.782-5.211-12.408-11.997-12.408z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaListAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zM128 120c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zm0 96c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zm0 96c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zm288-136v-32c0-6.627-5.373-12-12-12H204c-6.627 0-12 5.373-12 12v32c0 6.627 5.373 12 12 12h200c6.627 0 12-5.373 12-12zm0 96v-32c0-6.627-5.373-12-12-12H204c-6.627 0-12 5.373-12 12v32c0 6.627 5.373 12 12 12h200c6.627 0 12-5.373 12-12zm0 96v-32c0-6.627-5.373-12-12-12H204c-6.627 0-12 5.373-12 12v32c0 6.627 5.373 12 12 12h200c6.627 0 12-5.373 12-12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaListOl(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M61.77 401l17.5-20.15a19.92 19.92 0 0 0 5.07-14.19v-3.31C84.34 356 80.5 352 73 352H16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h22.83a157.41 157.41 0 0 0-11 12.31l-5.61 7c-4 5.07-5.25 10.13-2.8 14.88l1.05 1.93c3 5.76 6.29 7.88 12.25 7.88h4.73c10.33 0 15.94 2.44 15.94 9.09 0 4.72-4.2 8.22-14.36 8.22a41.54 41.54 0 0 1-15.47-3.12c-6.49-3.88-11.74-3.5-15.6 3.12l-5.59 9.31c-3.72 6.13-3.19 11.72 2.63 15.94 7.71 4.69 20.38 9.44 37 9.44 34.16 0 48.5-22.75 48.5-44.12-.03-14.38-9.12-29.76-28.73-34.88zM496 224H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM16 160h64a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H64V40a8 8 0 0 0-8-8H32a8 8 0 0 0-7.14 4.42l-8 16A8 8 0 0 0 24 64h8v64H16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8zm-3.91 160H80a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H41.32c3.29-10.29 48.34-18.68 48.34-56.44 0-29.06-25-39.56-44.47-39.56-21.36 0-33.8 10-40.46 18.75-4.37 5.59-3 10.84 2.8 15.37l8.58 6.88c5.61 4.56 11 2.47 16.12-2.44a13.44 13.44 0 0 1 9.46-3.84c3.33 0 9.28 1.56 9.28 8.75C51 248.19 0 257.31 0 304.59v4C0 316 5.08 320 12.09 320z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaListUl(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 48a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm0 160a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm0 160a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm448 16H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaList(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M80 368H16a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-64a16 16 0 0 0-16-16zm0-320H16A16 16 0 0 0 0 64v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16V64a16 16 0 0 0-16-16zm0 160H16a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-64a16 16 0 0 0-16-16zm416 176H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLocationArrow(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M444.52 3.52L28.74 195.42c-47.97 22.39-31.98 92.75 19.19 92.75h175.91v175.91c0 51.17 70.36 67.17 92.75 19.19l191.9-415.78c15.99-38.39-25.59-79.97-63.97-63.97z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLockOpen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M423.5 0C339.5.3 272 69.5 272 153.5V224H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48h-48v-71.1c0-39.6 31.7-72.5 71.3-72.9 40-.4 72.7 32.1 72.7 72v80c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-80C576 68 507.5-.3 423.5 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLock(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 224h-24v-72C376 68.2 307.8 0 224 0S72 68.2 72 152v72H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48zm-104 0H152v-72c0-39.7 32.3-72 72-72s72 32.3 72 72v72z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLongArrowAltDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M168 345.941V44c0-6.627-5.373-12-12-12h-56c-6.627 0-12 5.373-12 12v301.941H41.941c-21.382 0-32.09 25.851-16.971 40.971l86.059 86.059c9.373 9.373 24.569 9.373 33.941 0l86.059-86.059c15.119-15.119 4.411-40.971-16.971-40.971H168z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLongArrowAltLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M134.059 296H436c6.627 0 12-5.373 12-12v-56c0-6.627-5.373-12-12-12H134.059v-46.059c0-21.382-25.851-32.09-40.971-16.971L7.029 239.029c-9.373 9.373-9.373 24.569 0 33.941l86.059 86.059c15.119 15.119 40.971 4.411 40.971-16.971V296z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLongArrowAltRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M313.941 216H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12h301.941v46.059c0 21.382 25.851 32.09 40.971 16.971l86.059-86.059c9.373-9.373 9.373-24.569 0-33.941l-86.059-86.059c-15.119-15.119-40.971-4.411-40.971 16.971V216z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLongArrowAltUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M88 166.059V468c0 6.627 5.373 12 12 12h56c6.627 0 12-5.373 12-12V166.059h46.059c21.382 0 32.09-25.851 16.971-40.971l-86.059-86.059c-9.373-9.373-24.569-9.373-33.941 0l-86.059 86.059c-15.119 15.119-4.411 40.971 16.971 40.971H88z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLowVision(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M569.344 231.631C512.96 135.949 407.81 72 288 72c-28.468 0-56.102 3.619-82.451 10.409L152.778 10.24c-7.601-10.858-22.564-13.5-33.423-5.9l-13.114 9.178c-10.86 7.601-13.502 22.566-5.9 33.426l43.131 58.395C89.449 131.73 40.228 174.683 6.682 231.581c-.01.017-.023.033-.034.05-8.765 14.875-8.964 33.528 0 48.739 38.5 65.332 99.742 115.862 172.859 141.349L55.316 244.302A272.194 272.194 0 0 1 83.61 208.39l119.4 170.58h.01l40.63 58.04a330.055 330.055 0 0 0 78.94 1.17l-189.98-271.4a277.628 277.628 0 0 1 38.777-21.563l251.836 356.544c7.601 10.858 22.564 13.499 33.423 5.9l13.114-9.178c10.86-7.601 13.502-22.567 5.9-33.426l-43.12-58.377-.007-.009c57.161-27.978 104.835-72.04 136.81-126.301a47.938 47.938 0 0 0 .001-48.739zM390.026 345.94l-19.066-27.23c24.682-32.567 27.711-76.353 8.8-111.68v.03c0 23.65-19.17 42.82-42.82 42.82-23.828 0-42.82-19.349-42.82-42.82 0-23.65 19.17-42.82 42.82-42.82h.03c-24.75-13.249-53.522-15.643-79.51-7.68l-19.068-27.237C253.758 123.306 270.488 120 288 120c75.162 0 136 60.826 136 136 0 34.504-12.833 65.975-33.974 89.94z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLuggageCart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 320h32V96h-32c-17.67 0-32 14.33-32 32v160c0 17.67 14.33 32 32 32zm352-32V128c0-17.67-14.33-32-32-32h-32v224h32c17.67 0 32-14.33 32-32zm48 96H128V16c0-8.84-7.16-16-16-16H16C7.16 0 0 7.16 0 16v32c0 8.84 7.16 16 16 16h48v368c0 8.84 7.16 16 16 16h82.94c-1.79 5.03-2.94 10.36-2.94 16 0 26.51 21.49 48 48 48s48-21.49 48-48c0-5.64-1.15-10.97-2.94-16h197.88c-1.79 5.03-2.94 10.36-2.94 16 0 26.51 21.49 48 48 48s48-21.49 48-48c0-5.64-1.15-10.97-2.94-16H624c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM480 96V48c0-26.51-21.49-48-48-48h-96c-26.51 0-48 21.49-48 48v272h192V96zm-48 0h-96V48h96v48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLungsVirus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M344,150.68V16A16,16,0,0,0,328,0H312a16,16,0,0,0-16,16V150.68a46.45,46.45,0,0,1,48,0ZM195.54,444.46a48.06,48.06,0,0,1,0-67.88l8.58-8.58H192a48,48,0,0,1,0-96h12.12l-8.58-8.57a48,48,0,0,1,60.46-74V161.75C256,125.38,224.62,96,186,96c-44,0-58,28.5-80.12,63.13a819.52,819.52,0,0,0-102,231A113.16,113.16,0,0,0,0,419.75C0,481,62.5,525.26,125.25,508.38l59.5-15.87a98.51,98.51,0,0,0,52.5-34.75,46.49,46.49,0,0,1-41.71-13.3Zm226.29-22.63a16,16,0,0,0,0-22.62l-8.58-8.58C393.09,370.47,407.37,336,435.88,336H448a16,16,0,0,0,0-32H435.88c-28.51,0-42.79-34.47-22.63-54.62l8.58-8.58a16,16,0,0,0-22.63-22.63l-8.57,8.58C370.47,246.91,336,232.63,336,204.12V192a16,16,0,0,0-32,0v12.12c0,28.51-34.47,42.79-54.63,22.63l-8.57-8.58a16,16,0,0,0-22.63,22.63l8.58,8.58c20.16,20.15,5.88,54.62-22.63,54.62H192a16,16,0,0,0,0,32h12.12c28.51,0,42.79,34.47,22.63,54.63l-8.58,8.58a16,16,0,1,0,22.63,22.62l8.57-8.57C269.53,393.1,304,407.38,304,435.88V448a16,16,0,0,0,32,0V435.88c0-28.5,34.47-42.78,54.63-22.62l8.57,8.57a16,16,0,0,0,22.63,0ZM288,304a16,16,0,1,1,16-16A16,16,0,0,1,288,304Zm64,64a16,16,0,1,1,16-16A16,16,0,0,1,352,368Zm284.12,22.13a819.52,819.52,0,0,0-102-231C512,124.5,498,96,454,96c-38.62,0-70,29.38-70,65.75v27.72a48,48,0,0,1,60.46,74L435.88,272H448a48,48,0,0,1,0,96H435.88l8.58,8.58a47.7,47.7,0,0,1-41.71,81.18,98.51,98.51,0,0,0,52.5,34.75l59.5,15.87C577.5,525.26,640,481,640,419.75A113.16,113.16,0,0,0,636.12,390.13Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaLungs(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M636.11 390.15C614.44 308.85 580.07 231 534.1 159.13 511.98 124.56 498.03 96 454.05 96 415.36 96 384 125.42 384 161.71v60.11l-32.88-21.92a15.996 15.996 0 0 1-7.12-13.31V16c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v170.59c0 5.35-2.67 10.34-7.12 13.31L256 221.82v-60.11C256 125.42 224.64 96 185.95 96c-43.98 0-57.93 28.56-80.05 63.13C59.93 231 25.56 308.85 3.89 390.15 1.3 399.84 0 409.79 0 419.78c0 61.23 62.48 105.44 125.24 88.62l59.5-15.95c42.18-11.3 71.26-47.47 71.26-88.62v-87.49l-85.84 57.23a7.992 7.992 0 0 1-11.09-2.22l-8.88-13.31a7.992 7.992 0 0 1 2.22-11.09L320 235.23l167.59 111.72a7.994 7.994 0 0 1 2.22 11.09l-8.88 13.31a7.994 7.994 0 0 1-11.09 2.22L384 316.34v87.49c0 41.15 29.08 77.31 71.26 88.62l59.5 15.95C577.52 525.22 640 481.01 640 419.78c0-9.99-1.3-19.94-3.89-29.63z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMagic(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 96l16-32 32-16-32-16-16-32-16 32-32 16 32 16 16 32zM80 160l26.66-53.33L160 80l-53.34-26.67L80 0 53.34 53.33 0 80l53.34 26.67L80 160zm352 128l-26.66 53.33L352 368l53.34 26.67L432 448l26.66-53.33L512 368l-53.34-26.67L432 288zm70.62-193.77L417.77 9.38C411.53 3.12 403.34 0 395.15 0c-8.19 0-16.38 3.12-22.63 9.38L9.38 372.52c-12.5 12.5-12.5 32.76 0 45.25l84.85 84.85c6.25 6.25 14.44 9.37 22.62 9.37 8.19 0 16.38-3.12 22.63-9.37l363.14-363.15c12.5-12.48 12.5-32.75 0-45.24zM359.45 203.46l-50.91-50.91 86.6-86.6 50.91 50.91-86.6 86.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMagnet(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M164.07 148.1H12a12 12 0 0 1-12-12v-80a36 36 0 0 1 36-36h104a36 36 0 0 1 36 36v80a11.89 11.89 0 0 1-11.93 12zm347.93-12V56a36 36 0 0 0-36-36H372a36 36 0 0 0-36 36v80a12 12 0 0 0 12 12h152a11.89 11.89 0 0 0 12-11.9zm-164 44a12 12 0 0 0-12 12v52c0 128.1-160 127.9-160 0v-52a12 12 0 0 0-12-12H12.1a12 12 0 0 0-12 12.1c.1 21.4.6 40.3 0 53.3 0 150.6 136.17 246.6 256.75 246.6s255-96 255-246.7c-.6-12.8-.2-33 0-53.2a12 12 0 0 0-12-12.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMailBulk(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 448c-25.6 0-51.2-22.4-64-32-64-44.8-83.2-60.8-96-70.4V480c0 17.67 14.33 32 32 32h256c17.67 0 32-14.33 32-32V345.6c-12.8 9.6-32 25.6-96 70.4-12.8 9.6-38.4 32-64 32zm128-192H32c-17.67 0-32 14.33-32 32v16c25.6 19.2 22.4 19.2 115.2 86.4 9.6 6.4 28.8 25.6 44.8 25.6s35.2-19.2 44.8-22.4c92.8-67.2 89.6-67.2 115.2-86.4V288c0-17.67-14.33-32-32-32zm256-96H224c-17.67 0-32 14.33-32 32v32h96c33.21 0 60.59 25.42 63.71 57.82l.29-.22V416h192c17.67 0 32-14.33 32-32V192c0-17.67-14.33-32-32-32zm-32 128h-64v-64h64v64zm-352-96c0-35.29 28.71-64 64-64h224V32c0-17.67-14.33-32-32-32H96C78.33 0 64 14.33 64 32v192h96v-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMale(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 192 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 0c35.346 0 64 28.654 64 64s-28.654 64-64 64-64-28.654-64-64S60.654 0 96 0m48 144h-11.36c-22.711 10.443-49.59 10.894-73.28 0H48c-26.51 0-48 21.49-48 48v136c0 13.255 10.745 24 24 24h16v136c0 13.255 10.745 24 24 24h64c13.255 0 24-10.745 24-24V352h16c13.255 0 24-10.745 24-24V192c0-26.51-21.49-48-48-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMapMarkedAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 0c-69.59 0-126 56.41-126 126 0 56.26 82.35 158.8 113.9 196.02 6.39 7.54 17.82 7.54 24.2 0C331.65 284.8 414 182.26 414 126 414 56.41 357.59 0 288 0zm0 168c-23.2 0-42-18.8-42-42s18.8-42 42-42 42 18.8 42 42-18.8 42-42 42zM20.12 215.95A32.006 32.006 0 0 0 0 245.66v250.32c0 11.32 11.43 19.06 21.94 14.86L160 448V214.92c-8.84-15.98-16.07-31.54-21.25-46.42L20.12 215.95zM288 359.67c-14.07 0-27.38-6.18-36.51-16.96-19.66-23.2-40.57-49.62-59.49-76.72v182l192 64V266c-18.92 27.09-39.82 53.52-59.49 76.72-9.13 10.77-22.44 16.95-36.51 16.95zm266.06-198.51L416 224v288l139.88-55.95A31.996 31.996 0 0 0 576 426.34V176.02c0-11.32-11.43-19.06-21.94-14.86z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMapMarked(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 0c-69.59 0-126 56.41-126 126 0 56.26 82.35 158.8 113.9 196.02 6.39 7.54 17.82 7.54 24.2 0C331.65 284.8 414 182.26 414 126 414 56.41 357.59 0 288 0zM20.12 215.95A32.006 32.006 0 0 0 0 245.66v250.32c0 11.32 11.43 19.06 21.94 14.86L160 448V214.92c-8.84-15.98-16.07-31.54-21.25-46.42L20.12 215.95zM288 359.67c-14.07 0-27.38-6.18-36.51-16.96-19.66-23.2-40.57-49.62-59.49-76.72v182l192 64V266c-18.92 27.09-39.82 53.52-59.49 76.72-9.13 10.77-22.44 16.95-36.51 16.95zm266.06-198.51L416 224v288l139.88-55.95A31.996 31.996 0 0 0 576 426.34V176.02c0-11.32-11.43-19.06-21.94-14.86z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMapMarkerAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMapMarker(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMapPin(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 288 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112 316.94v156.69l22.02 33.02c4.75 7.12 15.22 7.12 19.97 0L176 473.63V316.94c-10.39 1.92-21.06 3.06-32 3.06s-21.61-1.14-32-3.06zM144 0C64.47 0 0 64.47 0 144s64.47 144 144 144 144-64.47 144-144S223.53 0 144 0zm0 76c-37.5 0-68 30.5-68 68 0 6.62-5.38 12-12 12s-12-5.38-12-12c0-50.73 41.28-92 92-92 6.62 0 12 5.38 12 12s-5.38 12-12 12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMapSigns(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M507.31 84.69L464 41.37c-6-6-14.14-9.37-22.63-9.37H288V16c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v16H56c-13.25 0-24 10.75-24 24v80c0 13.25 10.75 24 24 24h385.37c8.49 0 16.62-3.37 22.63-9.37l43.31-43.31c6.25-6.26 6.25-16.38 0-22.63zM224 496c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V384h-64v112zm232-272H288v-32h-64v32H70.63c-8.49 0-16.62 3.37-22.63 9.37L4.69 276.69c-6.25 6.25-6.25 16.38 0 22.63L48 342.63c6 6 14.14 9.37 22.63 9.37H456c13.25 0 24-10.75 24-24v-80c0-13.25-10.75-24-24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMap(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 117.66v346.32c0 11.32 11.43 19.06 21.94 14.86L160 416V32L20.12 87.95A32.006 32.006 0 0 0 0 117.66zM192 416l192 64V96L192 32v384zM554.06 33.16L416 96v384l139.88-55.95A31.996 31.996 0 0 0 576 394.34V48.02c0-11.32-11.43-19.06-21.94-14.86z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMarker(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M93.95 290.03A327.038 327.038 0 0 0 .17 485.11l-.03.23c-1.7 15.28 11.21 28.2 26.49 26.51a327.02 327.02 0 0 0 195.34-93.8l75.4-75.4-128.02-128.02-75.4 75.4zM485.49 26.51c-35.35-35.35-92.67-35.35-128.02 0l-21.76 21.76-36.56-36.55c-15.62-15.62-40.95-15.62-56.56 0L138.47 115.84c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0l87.15-87.15 19.59 19.59L191.98 192 320 320.02l165.49-165.49c35.35-35.35 35.35-92.66 0-128.02z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMarsDouble(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M340 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-48.7 48.7C198.5 72.1 172.2 64 144 64 64.5 64 0 128.5 0 208s64.5 144 144 144 144-64.5 144-144c0-28.2-8.1-54.5-22.1-76.7l48.7-48.7 16.9 16.9c2.4 2.4 5.5 3.5 8.4 3.5 6.2 0 12.1-4.8 12.1-12V12c0-6.6-5.4-12-12-12zM144 288c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80zm356-128.1h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-48.7 48.7c-18.2-11.4-39-18.9-61.5-21.3-2.1 21.8-8.2 43.3-18.4 63.3 1.1 0 2.2-.1 3.2-.1 44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80c0-1.1 0-2.2.1-3.2-20 10.2-41.5 16.4-63.3 18.4C168.4 455.6 229.6 512 304 512c79.5 0 144-64.5 144-144 0-28.2-8.1-54.5-22.1-76.7l48.7-48.7 16.9 16.9c2.4 2.4 5.4 3.5 8.4 3.5 6.2 0 12.1-4.8 12.1-12v-79c0-6.7-5.4-12.1-12-12.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMarsStrokeH(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 480 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M476.2 247.5l-55.9-55.9c-7.6-7.6-20.5-2.2-20.5 8.5V224H376v-20c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v20h-27.6c-5.8-25.6-18.7-49.9-38.6-69.8C189.6 98 98.4 98 42.2 154.2c-56.2 56.2-56.2 147.4 0 203.6 56.2 56.2 147.4 56.2 203.6 0 19.9-19.9 32.8-44.2 38.6-69.8H312v20c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-20h23.9v23.9c0 10.7 12.9 16 20.5 8.5l55.9-55.9c4.6-4.7 4.6-12.3-.1-17zm-275.6 65.1c-31.2 31.2-81.9 31.2-113.1 0-31.2-31.2-31.2-81.9 0-113.1 31.2-31.2 81.9-31.2 113.1 0 31.2 31.1 31.2 81.9 0 113.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMarsStrokeV(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 288 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M245.8 234.2c-19.9-19.9-44.2-32.8-69.8-38.6v-25.4h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20V81.4h23.9c10.7 0 16-12.9 8.5-20.5L152.5 5.1c-4.7-4.7-12.3-4.7-17 0L79.6 61c-7.6 7.6-2.2 20.5 8.5 20.5H112v24.7H92c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h20v25.4c-25.6 5.8-49.9 18.7-69.8 38.6-56.2 56.2-56.2 147.4 0 203.6 56.2 56.2 147.4 56.2 203.6 0 56.3-56.2 56.3-147.4 0-203.6zm-45.2 158.4c-31.2 31.2-81.9 31.2-113.1 0-31.2-31.2-31.2-81.9 0-113.1 31.2-31.2 81.9-31.2 113.1 0 31.2 31.1 31.2 81.9 0 113.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMarsStroke(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M372 64h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-17.5 17.5-14.1-14.1c-4.7-4.7-12.3-4.7-17 0L224.5 133c-4.7 4.7-4.7 12.3 0 17l14.1 14.1-18 18c-22.2-14-48.5-22.1-76.7-22.1C64.5 160 0 224.5 0 304s64.5 144 144 144 144-64.5 144-144c0-28.2-8.1-54.5-22.1-76.7l18-18 14.1 14.1c4.7 4.7 12.3 4.7 17 0l28.3-28.3c4.7-4.7 4.7-12.3 0-17L329.2 164l17.5-17.5 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V76c-.1-6.6-5.5-12-12.1-12zM144 384c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMars(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M372 64h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-80.7 80.7c-22.2-14-48.5-22.1-76.7-22.1C64.5 160 0 224.5 0 304s64.5 144 144 144 144-64.5 144-144c0-28.2-8.1-54.5-22.1-76.7l80.7-80.7 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V76c0-6.6-5.4-12-12-12zM144 384c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMask(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320.67 64c-442.6 0-357.57 384-158.46 384 39.9 0 77.47-20.69 101.42-55.86l25.73-37.79c15.66-22.99 46.97-22.99 62.63 0l25.73 37.79C401.66 427.31 439.23 448 479.13 448c189.86 0 290.63-384-158.46-384zM184 308.36c-41.06 0-67.76-25.66-80.08-41.05-5.23-6.53-5.23-16.09 0-22.63 12.32-15.4 39.01-41.05 80.08-41.05s67.76 25.66 80.08 41.05c5.23 6.53 5.23 16.09 0 22.63-12.32 15.4-39.02 41.05-80.08 41.05zm272 0c-41.06 0-67.76-25.66-80.08-41.05-5.23-6.53-5.23-16.09 0-22.63 12.32-15.4 39.01-41.05 80.08-41.05s67.76 25.66 80.08 41.05c5.23 6.53 5.23 16.09 0 22.63-12.32 15.4-39.02 41.05-80.08 41.05z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMedal(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M223.75 130.75L154.62 15.54A31.997 31.997 0 0 0 127.18 0H16.03C3.08 0-4.5 14.57 2.92 25.18l111.27 158.96c29.72-27.77 67.52-46.83 109.56-53.39zM495.97 0H384.82c-11.24 0-21.66 5.9-27.44 15.54l-69.13 115.21c42.04 6.56 79.84 25.62 109.56 53.38L509.08 25.18C516.5 14.57 508.92 0 495.97 0zM256 160c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm92.52 157.26l-37.93 36.96 8.97 52.22c1.6 9.36-8.26 16.51-16.65 12.09L256 393.88l-46.9 24.65c-8.4 4.45-18.25-2.74-16.65-12.09l8.97-52.22-37.93-36.96c-6.82-6.64-3.05-18.23 6.35-19.59l52.43-7.64 23.43-47.52c2.11-4.28 6.19-6.39 10.28-6.39 4.11 0 8.22 2.14 10.33 6.39l23.43 47.52 52.43 7.64c9.4 1.36 13.17 12.95 6.35 19.59z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMedkit(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 480h320V128h-32V80c0-26.51-21.49-48-48-48H176c-26.51 0-48 21.49-48 48v48H96v352zm96-384h128v32H192V96zm320 80v256c0 26.51-21.49 48-48 48h-16V128h16c26.51 0 48 21.49 48 48zM64 480H48c-26.51 0-48-21.49-48-48V176c0-26.51 21.49-48 48-48h16v352zm288-208v32c0 8.837-7.163 16-16 16h-48v48c0 8.837-7.163 16-16 16h-32c-8.837 0-16-7.163-16-16v-48h-48c-8.837 0-16-7.163-16-16v-32c0-8.837 7.163-16 16-16h48v-48c0-8.837 7.163-16 16-16h32c8.837 0 16 7.163 16 16v48h48c8.837 0 16 7.163 16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMehBlank(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-80 232c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm160 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMehRollingEyes(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM88 224c0-24.3 13.7-45.2 33.6-56-.7 2.6-1.6 5.2-1.6 8 0 17.7 14.3 32 32 32s32-14.3 32-32c0-2.8-.9-5.4-1.6-8 19.9 10.8 33.6 31.7 33.6 56 0 35.3-28.7 64-64 64s-64-28.7-64-64zm224 176H184c-21.2 0-21.2-32 0-32h128c21.2 0 21.2 32 0 32zm32-112c-35.3 0-64-28.7-64-64 0-24.3 13.7-45.2 33.6-56-.7 2.6-1.6 5.2-1.6 8 0 17.7 14.3 32 32 32s32-14.3 32-32c0-2.8-.9-5.4-1.6-8 19.9 10.8 33.6 31.7 33.6 56 0 35.3-28.7 64-64 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMeh(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm176 192H152c-21.2 0-21.2-32 0-32h192c21.2 0 21.2 32 0 32zm-16-128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMemory(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M640 130.94V96c0-17.67-14.33-32-32-32H32C14.33 64 0 78.33 0 96v34.94c18.6 6.61 32 24.19 32 45.06s-13.4 38.45-32 45.06V320h640v-98.94c-18.6-6.61-32-24.19-32-45.06s13.4-38.45 32-45.06zM224 256h-64V128h64v128zm128 0h-64V128h64v128zm128 0h-64V128h64v128zM0 448h64v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h128v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h128v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h128v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h64v-96H0v96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMenorah(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144 128h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm96 0h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm192 0h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm96 0h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm80-32c17.67 0 32-14.33 32-32S608 0 608 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S512 0 512 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S416 0 416 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S320 0 320 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S224 0 224 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S128 0 128 0 96 46.33 96 64s14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S32 0 32 0 0 46.33 0 64s14.33 32 32 32zm544 192c0 17.67-14.33 32-32 32H352V144c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v176H96c-17.67 0-32-14.33-32-32V144c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v144c0 53.02 42.98 96 96 96h192v64H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16H352v-64h192c53.02 0 96-42.98 96-96V144c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v144z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMercury(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 288 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 208c0-44.2-19.9-83.7-51.2-110.1 2.5-1.8 4.9-3.8 7.2-5.8 24.7-21.2 39.8-48.8 43.2-78.8.9-7.1-4.7-13.3-11.9-13.3h-40.5C229 0 224.1 4.1 223 9.8c-2.4 12.5-9.6 24.3-20.7 33.8C187 56.8 166.3 64 144 64s-43-7.2-58.4-20.4C74.5 34.1 67.4 22.3 64.9 9.8 63.8 4.1 58.9 0 53.2 0H12.7C5.5 0-.1 6.2.8 13.3 4.2 43.4 19.2 71 44 92.2c2.3 2 4.7 3.9 7.2 5.8C19.9 124.3 0 163.8 0 208c0 68.5 47.9 125.9 112 140.4V400H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.5 112-71.9 112-140.4zm-224 0c0-44.1 35.9-80 80-80s80 35.9 80 80-35.9 80-80 80-80-35.9-80-80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMeteor(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M511.328,20.8027c-11.60759,38.70264-34.30724,111.70173-61.30311,187.70077,6.99893,2.09372,13.4042,4,18.60653,5.59368a16.06158,16.06158,0,0,1,9.49854,22.906c-22.106,42.29635-82.69047,152.795-142.47819,214.40356-.99984,1.09373-1.99969,2.5-2.99954,3.49995A194.83046,194.83046,0,1,1,57.085,179.41009c.99985-1,2.40588-2,3.49947-3,61.59994-59.90549,171.97367-120.40473,214.37343-142.4982a16.058,16.058,0,0,1,22.90274,9.49988c1.59351,5.09368,3.49947,11.5936,5.5929,18.59351C379.34818,35.00565,452.43074,12.30281,491.12794.70921A16.18325,16.18325,0,0,1,511.328,20.8027ZM319.951,320.00207A127.98041,127.98041,0,1,0,191.97061,448.00046,127.97573,127.97573,0,0,0,319.951,320.00207Zm-127.98041-31.9996a31.9951,31.9951,0,1,1-31.9951-31.9996A31.959,31.959,0,0,1,191.97061,288.00247Zm31.9951,79.999a15.99755,15.99755,0,1,1-15.99755-15.9998A16.04975,16.04975,0,0,1,223.96571,368.00147Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMicrochip(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 48v416c0 26.51-21.49 48-48 48H144c-26.51 0-48-21.49-48-48V48c0-26.51 21.49-48 48-48h224c26.51 0 48 21.49 48 48zm96 58v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42V88h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zm0 96v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42v-48h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zm0 96v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42v-48h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zm0 96v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42v-48h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zM30 376h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6zm0-96h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6zm0-96h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6zm0-96h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMicrophoneAltSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M633.82 458.1L476.26 336.33C488.74 312.21 496 284.98 496 256v-48c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v48c0 17.92-3.96 34.8-10.72 50.2l-26.55-20.52c3.1-9.4 5.28-19.22 5.28-29.67h-43.67l-41.4-32H416v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H416v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H416c0-53.02-42.98-96-96-96s-96 42.98-96 96v45.36L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.36 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.41-6.97 4.16-17.02-2.82-22.45zM400 464h-56v-33.78c11.71-1.62 23.1-4.28 33.96-8.08l-50.4-38.96c-6.71.4-13.41.87-20.35.2-55.85-5.45-98.74-48.63-111.18-101.85L144 241.31v6.85c0 89.64 63.97 169.55 152 181.69V464h-56c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMicrophoneAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 352 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 192h-16c-8.84 0-16 7.16-16 16v48c0 74.8-64.49 134.82-140.79 127.38C96.71 376.89 48 317.11 48 250.3V208c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v40.16c0 89.64 63.97 169.55 152 181.69V464H96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16h-56v-33.77C285.71 418.47 352 344.9 352 256v-48c0-8.84-7.16-16-16-16zM176 352c53.02 0 96-42.98 96-96h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H272v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H272v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H272c0-53.02-42.98-96-96-96S80 42.98 80 96v160c0 53.02 42.98 96 96 96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMicrophoneSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M633.82 458.1l-157.8-121.96C488.61 312.13 496 285.01 496 256v-48c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v48c0 17.92-3.96 34.8-10.72 50.2l-26.55-20.52c3.1-9.4 5.28-19.22 5.28-29.67V96c0-53.02-42.98-96-96-96s-96 42.98-96 96v45.36L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.36 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.41-6.97 4.16-17.02-2.82-22.45zM400 464h-56v-33.77c11.66-1.6 22.85-4.54 33.67-8.31l-50.11-38.73c-6.71.4-13.41.87-20.35.2-55.85-5.45-98.74-48.63-111.18-101.85L144 241.31v6.85c0 89.64 63.97 169.55 152 181.69V464h-56c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMicrophone(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 352 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 352c53.02 0 96-42.98 96-96V96c0-53.02-42.98-96-96-96S80 42.98 80 96v160c0 53.02 42.98 96 96 96zm160-160h-16c-8.84 0-16 7.16-16 16v48c0 74.8-64.49 134.82-140.79 127.38C96.71 376.89 48 317.11 48 250.3V208c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v40.16c0 89.64 63.97 169.55 152 181.69V464H96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16h-56v-33.77C285.71 418.47 352 344.9 352 256v-48c0-8.84-7.16-16-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMicroscope(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 320h12v16c0 8.84 7.16 16 16 16h40c8.84 0 16-7.16 16-16v-16h12c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32V16c0-8.84-7.16-16-16-16h-64c-8.84 0-16 7.16-16 16v16c-17.67 0-32 14.33-32 32v224c0 17.67 14.33 32 32 32zm304 128h-1.29C493.24 413.99 512 369.2 512 320c0-105.88-86.12-192-192-192v64c70.58 0 128 57.42 128 128s-57.42 128-128 128H48c-26.51 0-48 21.49-48 48 0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16 0-26.51-21.49-48-48-48zm-360-32h208c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8H104c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMinusCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zM124 296c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h264c6.6 0 12 5.4 12 12v56c0 6.6-5.4 12-12 12H124z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMinusSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM92 296c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h264c6.6 0 12 5.4 12 12v56c0 6.6-5.4 12-12 12H92z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMitten(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 416H48c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16zm57-209.1c-27.2-22.6-67.5-19-90.1 8.2l-20.9 25-29.6-128.4c-18-77.5-95.4-125.9-172.8-108C34.2 21.6-14.2 98.9 3.7 176.4L51.6 384h309l72.5-87c22.7-27.2 19-67.5-8.1-90.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMobileAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM160 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm112-108c0 6.6-5.4 12-12 12H60c-6.6 0-12-5.4-12-12V60c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v312z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMobile(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM160 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMoneyBillAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 288h-16v-88c0-4.42-3.58-8-8-8h-13.58c-4.74 0-9.37 1.4-13.31 4.03l-15.33 10.22a7.994 7.994 0 0 0-2.22 11.09l8.88 13.31a7.994 7.994 0 0 0 11.09 2.22l.47-.31V288h-16c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h64c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zM608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zM48 400v-64c35.35 0 64 28.65 64 64H48zm0-224v-64h64c0 35.35-28.65 64-64 64zm272 192c-53.02 0-96-50.15-96-112 0-61.86 42.98-112 96-112s96 50.14 96 112c0 61.87-43 112-96 112zm272 32h-64c0-35.35 28.65-64 64-64v64zm0-224c-35.35 0-64-28.65-64-64h64v64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMoneyBillWaveAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M621.16 54.46C582.37 38.19 543.55 32 504.75 32c-123.17-.01-246.33 62.34-369.5 62.34-30.89 0-61.76-3.92-92.65-13.72-3.47-1.1-6.95-1.62-10.35-1.62C15.04 79 0 92.32 0 110.81v317.26c0 12.63 7.23 24.6 18.84 29.46C57.63 473.81 96.45 480 135.25 480c123.17 0 246.34-62.35 369.51-62.35 30.89 0 61.76 3.92 92.65 13.72 3.47 1.1 6.95 1.62 10.35 1.62 17.21 0 32.25-13.32 32.25-31.81V83.93c-.01-12.64-7.24-24.6-18.85-29.47zM320 352c-44.19 0-80-42.99-80-96 0-53.02 35.82-96 80-96s80 42.98 80 96c0 53.03-35.83 96-80 96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMoneyBillWave(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M621.16 54.46C582.37 38.19 543.55 32 504.75 32c-123.17-.01-246.33 62.34-369.5 62.34-30.89 0-61.76-3.92-92.65-13.72-3.47-1.1-6.95-1.62-10.35-1.62C15.04 79 0 92.32 0 110.81v317.26c0 12.63 7.23 24.6 18.84 29.46C57.63 473.81 96.45 480 135.25 480c123.17 0 246.34-62.35 369.51-62.35 30.89 0 61.76 3.92 92.65 13.72 3.47 1.1 6.95 1.62 10.35 1.62 17.21 0 32.25-13.32 32.25-31.81V83.93c-.01-12.64-7.24-24.6-18.85-29.47zM48 132.22c20.12 5.04 41.12 7.57 62.72 8.93C104.84 170.54 79 192.69 48 192.69v-60.47zm0 285v-47.78c34.37 0 62.18 27.27 63.71 61.4-22.53-1.81-43.59-6.31-63.71-13.62zM320 352c-44.19 0-80-42.99-80-96 0-53.02 35.82-96 80-96s80 42.98 80 96c0 53.03-35.83 96-80 96zm272 27.78c-17.52-4.39-35.71-6.85-54.32-8.44 5.87-26.08 27.5-45.88 54.32-49.28v57.72zm0-236.11c-30.89-3.91-54.86-29.7-55.81-61.55 19.54 2.17 38.09 6.23 55.81 12.66v48.89z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMoneyBill(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zM48 400v-64c35.35 0 64 28.65 64 64H48zm0-224v-64h64c0 35.35-28.65 64-64 64zm272 176c-44.19 0-80-42.99-80-96 0-53.02 35.82-96 80-96s80 42.98 80 96c0 53.03-35.83 96-80 96zm272 48h-64c0-35.35 28.65-64 64-64v64zm0-224c-35.35 0-64-28.65-64-64h64v64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMoneyCheckAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M608 32H32C14.33 32 0 46.33 0 64v384c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zM176 327.88V344c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-16.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V152c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.05 44.44-42.67 45.07zM416 312c0 4.42-3.58 8-8 8H296c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h112c4.42 0 8 3.58 8 8v16zm160 0c0 4.42-3.58 8-8 8h-80c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16zm0-96c0 4.42-3.58 8-8 8H296c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h272c4.42 0 8 3.58 8 8v16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMoneyCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 448c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V128H0v320zm448-208c0-8.84 7.16-16 16-16h96c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16h-96c-8.84 0-16-7.16-16-16v-32zm0 120c0-4.42 3.58-8 8-8h112c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H456c-4.42 0-8-3.58-8-8v-16zM64 264c0-4.42 3.58-8 8-8h304c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zm0 96c0-4.42 3.58-8 8-8h176c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zM624 32H16C7.16 32 0 39.16 0 48v48h640V48c0-8.84-7.16-16-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMonument(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h352c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-78.86-347.26a31.97 31.97 0 0 0-9.21-19.44L203.31 4.69c-6.25-6.25-16.38-6.25-22.63 0l-76.6 76.61a31.97 31.97 0 0 0-9.21 19.44L64 416h256l-30.86-315.26zM240 307.2c0 6.4-6.4 12.8-12.8 12.8h-70.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h70.4c6.4 0 12.8 6.4 12.8 12.8v38.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMoon(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M283.211 512c78.962 0 151.079-35.925 198.857-94.792 7.068-8.708-.639-21.43-11.562-19.35-124.203 23.654-238.262-71.576-238.262-196.954 0-72.222 38.662-138.635 101.498-174.394 9.686-5.512 7.25-20.197-3.756-22.23A258.156 258.156 0 0 0 283.211 0c-141.309 0-256 114.511-256 256 0 141.309 114.511 256 256 256z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMortarPestle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M501.54 60.91c17.22-17.22 12.51-46.25-9.27-57.14a35.696 35.696 0 0 0-37.37 3.37L251.09 160h151.37l99.08-99.09zM496 192H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16c0 80.98 50.2 150.11 121.13 178.32-12.76 16.87-21.72 36.8-24.95 58.69-1.46 9.92 6.04 18.98 16.07 18.98h223.5c10.03 0 17.53-9.06 16.07-18.98-3.22-21.89-12.18-41.82-24.95-58.69C429.8 406.11 480 336.98 480 256h16c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMosque(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 480c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V160H0v320zm579.16-192c17.86-17.39 28.84-37.34 28.84-58.91 0-52.86-41.79-93.79-87.92-122.9-41.94-26.47-80.63-57.77-111.96-96.22L400 0l-8.12 9.97c-31.33 38.45-70.01 69.76-111.96 96.22C233.79 135.3 192 176.23 192 229.09c0 21.57 10.98 41.52 28.84 58.91h358.32zM608 320H192c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h32v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h64v-72c0-48 48-72 48-72s48 24 48 72v72h64v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h32c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32zM64 0S0 32 0 96v32h128V96c0-64-64-96-64-96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMotorcycle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512.9 192c-14.9-.1-29.1 2.3-42.4 6.9L437.6 144H520c13.3 0 24-10.7 24-24V88c0-13.3-10.7-24-24-24h-45.3c-6.8 0-13.3 2.9-17.8 7.9l-37.5 41.7-22.8-38C392.2 68.4 384.4 64 376 64h-80c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h66.4l19.2 32H227.9c-17.7-23.1-44.9-40-99.9-40H72.5C59 104 47.7 115 48 128.5c.2 13 10.9 23.5 24 23.5h56c24.5 0 38.7 10.9 47.8 24.8l-11.3 20.5c-13-3.9-26.9-5.7-41.3-5.2C55.9 194.5 1.6 249.6 0 317c-1.6 72.1 56.3 131 128 131 59.6 0 109.7-40.8 124-96h84.2c13.7 0 24.6-11.4 24-25.1-2.1-47.1 17.5-93.7 56.2-125l12.5 20.8c-27.6 23.7-45.1 58.9-44.8 98.2.5 69.6 57.2 126.5 126.8 127.1 71.6.7 129.8-57.5 129.2-129.1-.7-69.6-57.6-126.4-127.2-126.9zM128 400c-44.1 0-80-35.9-80-80s35.9-80 80-80c4.2 0 8.4.3 12.5 1L99 316.4c-8.8 16 2.8 35.6 21 35.6h81.3c-12.4 28.2-40.6 48-73.3 48zm463.9-75.6c-2.2 40.6-35 73.4-75.5 75.5-46.1 2.5-84.4-34.3-84.4-79.9 0-21.4 8.4-40.8 22.1-55.1l49.4 82.4c4.5 7.6 14.4 10 22 5.5l13.7-8.2c7.6-4.5 10-14.4 5.5-22l-48.6-80.9c5.2-1.1 10.5-1.6 15.9-1.6 45.6-.1 82.3 38.2 79.9 84.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMountain(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M634.92 462.7l-288-448C341.03 5.54 330.89 0 320 0s-21.03 5.54-26.92 14.7l-288 448a32.001 32.001 0 0 0-1.17 32.64A32.004 32.004 0 0 0 32 512h576c11.71 0 22.48-6.39 28.09-16.67a31.983 31.983 0 0 0-1.17-32.63zM320 91.18L405.39 224H320l-64 64-38.06-38.06L320 91.18z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMousePointer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M302.189 329.126H196.105l55.831 135.993c3.889 9.428-.555 19.999-9.444 23.999l-49.165 21.427c-9.165 4-19.443-.571-23.332-9.714l-53.053-129.136-86.664 89.138C18.729 472.71 0 463.554 0 447.977V18.299C0 1.899 19.921-6.096 30.277 5.443l284.412 292.542c11.472 11.179 3.007 31.141-12.5 31.141z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMouse(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 352a160 160 0 0 0 160 160h64a160 160 0 0 0 160-160V224H0zM176 0h-16A160 160 0 0 0 0 160v32h176zm48 0h-16v192h176v-32A160 160 0 0 0 224 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMugHot(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M127.1 146.5c1.3 7.7 8 13.5 16 13.5h16.5c9.8 0 17.6-8.5 16.3-18-3.8-28.2-16.4-54.2-36.6-74.7-14.4-14.7-23.6-33.3-26.4-53.5C111.8 5.9 105 0 96.8 0H80.4C70.6 0 63 8.5 64.1 18c3.9 31.9 18 61.3 40.6 84.4 12 12.2 19.7 27.5 22.4 44.1zm112 0c1.3 7.7 8 13.5 16 13.5h16.5c9.8 0 17.6-8.5 16.3-18-3.8-28.2-16.4-54.2-36.6-74.7-14.4-14.7-23.6-33.3-26.4-53.5C223.8 5.9 217 0 208.8 0h-16.4c-9.8 0-17.5 8.5-16.3 18 3.9 31.9 18 61.3 40.6 84.4 12 12.2 19.7 27.5 22.4 44.1zM400 192H32c-17.7 0-32 14.3-32 32v192c0 53 43 96 96 96h192c53 0 96-43 96-96h16c61.8 0 112-50.2 112-112s-50.2-112-112-112zm0 160h-16v-96h16c26.5 0 48 21.5 48 48s-21.5 48-48 48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaMusic(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M470.38 1.51L150.41 96A32 32 0 0 0 128 126.51v261.41A139 139 0 0 0 96 384c-53 0-96 28.66-96 64s43 64 96 64 96-28.66 96-64V214.32l256-75v184.61a138.4 138.4 0 0 0-32-3.93c-53 0-96 28.66-96 64s43 64 96 64 96-28.65 96-64V32a32 32 0 0 0-41.62-30.49z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaNetworkWired(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M640 264v-16c0-8.84-7.16-16-16-16H344v-40h72c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32H224c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h72v40H16c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h104v40H64c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h160c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32h-56v-40h304v40h-56c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h160c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32h-56v-40h104c8.84 0 16-7.16 16-16zM256 128V64h128v64H256zm-64 320H96v-64h96v64zm352 0h-96v-64h96v64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaNeuter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 288 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 176c0-79.5-64.5-144-144-144S0 96.5 0 176c0 68.5 47.9 125.9 112 140.4V468c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12V316.4c64.1-14.5 112-71.9 112-140.4zm-144 80c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaNewspaper(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M552 64H88c-13.255 0-24 10.745-24 24v8H24c-13.255 0-24 10.745-24 24v272c0 30.928 25.072 56 56 56h472c26.51 0 48-21.49 48-48V88c0-13.255-10.745-24-24-24zM56 400a8 8 0 0 1-8-8V144h16v248a8 8 0 0 1-8 8zm236-16H140c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm208 0H348c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm-208-96H140c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm208 0H348c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm0-96H140c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h360c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaNotEqual(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 208c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32h-23.88l51.87-66.81c5.37-7.02 4.04-17.06-2.97-22.43L415.61 3.3c-7.02-5.38-17.06-4.04-22.44 2.97L311.09 112H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h204.56l-74.53 96H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h55.49l-51.87 66.81c-5.37 7.01-4.04 17.05 2.97 22.43L64 508.7c7.02 5.38 17.06 4.04 22.43-2.97L168.52 400H416c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32H243.05l74.53-96H416z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaNotesMedical(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 40c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm96 304c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48zm0-192c0 4.4-3.6 8-8 8H104c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h176c4.4 0 8 3.6 8 8v16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaObjectGroup(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 128V96h20c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v20H64V44c0-6.627-5.373-12-12-12H12C5.373 32 0 37.373 0 44v40c0 6.627 5.373 12 12 12h20v320H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-20h384v20c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-20V128zM96 276V140c0-6.627 5.373-12 12-12h168c6.627 0 12 5.373 12 12v136c0 6.627-5.373 12-12 12H108c-6.627 0-12-5.373-12-12zm320 96c0 6.627-5.373 12-12 12H236c-6.627 0-12-5.373-12-12v-52h72c13.255 0 24-10.745 24-24v-72h84c6.627 0 12 5.373 12 12v136z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaObjectUngroup(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 320v26a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6v-52a6 6 0 0 1 6-6h26V96H6a6 6 0 0 1-6-6V38a6 6 0 0 1 6-6h52a6 6 0 0 1 6 6v26h288V38a6 6 0 0 1 6-6h52a6 6 0 0 1 6 6v52a6 6 0 0 1-6 6h-26v192h26a6 6 0 0 1 6 6v52a6 6 0 0 1-6 6h-52a6 6 0 0 1-6-6v-26H64zm480-64v-32h26a6 6 0 0 0 6-6v-52a6 6 0 0 0-6-6h-52a6 6 0 0 0-6 6v26H408v72h8c13.255 0 24 10.745 24 24v64c0 13.255-10.745 24-24 24h-64c-13.255 0-24-10.745-24-24v-8H192v72h-26a6 6 0 0 0-6 6v52a6 6 0 0 0 6 6h52a6 6 0 0 0 6-6v-26h288v26a6 6 0 0 0 6 6h52a6 6 0 0 0 6-6v-52a6 6 0 0 0-6-6h-26V256z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaOilCan(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M629.8 160.31L416 224l-50.49-25.24a64.07 64.07 0 0 0-28.62-6.76H280v-48h56c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h56v48h-56L37.72 166.86a31.9 31.9 0 0 0-5.79-.53C14.67 166.33 0 180.36 0 198.34v94.95c0 15.46 11.06 28.72 26.28 31.48L96 337.46V384c0 17.67 14.33 32 32 32h274.63c8.55 0 16.75-3.42 22.76-9.51l212.26-214.75c1.5-1.5 2.34-3.54 2.34-5.66V168c.01-5.31-5.08-9.15-10.19-7.69zM96 288.67l-48-8.73v-62.43l48 8.73v62.43zm453.33 84.66c0 23.56 19.1 42.67 42.67 42.67s42.67-19.1 42.67-42.67S592 288 592 288s-42.67 61.77-42.67 85.33z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaOm(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M360.6 60.94a10.43 10.43 0 0 0 14.76 0l21.57-21.56a10.43 10.43 0 0 0 0-14.76L375.35 3.06c-4.08-4.07-10.68-4.07-14.76 0l-21.57 21.56a10.43 10.43 0 0 0 0 14.76l21.58 21.56zM412.11 192c-26.69 0-51.77 10.39-70.64 29.25l-24.25 24.25c-6.78 6.77-15.78 10.5-25.38 10.5H245c10.54-22.1 14.17-48.11 7.73-75.23-10.1-42.55-46.36-76.11-89.52-83.19-36.15-5.93-70.9 5.04-96.01 28.78-7.36 6.96-6.97 18.85 1.12 24.93l26.15 19.63c5.72 4.3 13.66 4.32 19.2-.21 8.45-6.9 19.02-10.71 30.27-10.71 26.47 0 48.01 21.53 48.01 48s-21.54 48-48.01 48h-31.9c-11.96 0-19.74 12.58-14.39 23.28l16.09 32.17c2.53 5.06 7.6 8.1 13.17 8.55h33.03c35.3 0 64.01 28.7 64.01 64s-28.71 64-64.01 64c-96.02 0-122.35-54.02-145.15-92.03-4.53-7.55-14.77-3.58-14.79 5.22C-.09 416 41.13 512 159.94 512c70.59 0 128.02-57.42 128.02-128 0-23.42-6.78-45.1-17.81-64h21.69c26.69 0 51.77-10.39 70.64-29.25l24.25-24.25c6.78-6.77 15.78-10.5 25.38-10.5 19.78 0 35.88 16.09 35.88 35.88V392c0 13.23-18.77 24-32.01 24-39.4 0-66.67-24.24-81.82-42.89-4.77-5.87-14.2-2.54-14.2 5.02V416s0 64 96.02 64c48.54 0 96.02-39.47 96.02-88V291.88c0-55.08-44.8-99.88-99.89-99.88zm42.18-124.73c-85.55 65.12-169.05 2.75-172.58.05-6.02-4.62-14.44-4.38-20.14.55-5.74 4.92-7.27 13.17-3.66 19.8 1.61 2.95 40.37 72.34 118.8 72.34 79.92 0 98.78-31.36 101.75-37.66 1.02-2.12 1.53-4.47 1.53-6.83V80c0-13.22-15.14-20.69-25.7-12.73z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaOtter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M608 32h-32l-13.25-13.25A63.97 63.97 0 0 0 517.49 0H497c-11.14 0-22.08 2.91-31.75 8.43L312 96h-56C149.96 96 64 181.96 64 288v1.61c0 32.75-16 62.14-39.56 84.89-18.19 17.58-28.1 43.68-23.19 71.8 6.76 38.8 42.9 65.7 82.28 65.7H192c17.67 0 32-14.33 32-32s-14.33-32-32-32H80c-8.83 0-16-7.17-16-16s7.17-16 16-16h224c8.84 0 16-7.16 16-16v-16c0-17.67-14.33-32-32-32h-64l149.49-80.5L448 416h80c8.84 0 16-7.16 16-16v-16c0-17.67-14.33-32-32-32h-28.22l-55.11-110.21L521.14 192H544c53.02 0 96-42.98 96-96V64c0-17.67-14.33-32-32-32zm-96 16c8.84 0 16 7.16 16 16s-7.16 16-16 16-16-7.16-16-16 7.16-16 16-16zm32 96h-34.96L407.2 198.84l-13.77-27.55L512 112h77.05c-6.62 18.58-24.22 32-45.05 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaOutdent(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M100.69 363.29c10 10 27.31 2.93 27.31-11.31V160c0-14.32-17.33-21.31-27.31-11.31l-96 96a16 16 0 0 0 0 22.62zM432 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm3.17-128H204.83A12.82 12.82 0 0 0 192 300.83v38.34A12.82 12.82 0 0 0 204.83 352h230.34A12.82 12.82 0 0 0 448 339.17v-38.34A12.82 12.82 0 0 0 435.17 288zm0-128H204.83A12.82 12.82 0 0 0 192 172.83v38.34A12.82 12.82 0 0 0 204.83 224h230.34A12.82 12.82 0 0 0 448 211.17v-38.34A12.82 12.82 0 0 0 435.17 160zM432 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPager(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 64H64a64 64 0 0 0-64 64v256a64 64 0 0 0 64 64h384a64 64 0 0 0 64-64V128a64 64 0 0 0-64-64zM160 368H80a16 16 0 0 1-16-16v-16a16 16 0 0 1 16-16h80zm128-16a16 16 0 0 1-16 16h-80v-48h80a16 16 0 0 1 16 16zm160-128a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32v-64a32 32 0 0 1 32-32h320a32 32 0 0 1 32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPaintBrush(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M167.02 309.34c-40.12 2.58-76.53 17.86-97.19 72.3-2.35 6.21-8 9.98-14.59 9.98-11.11 0-45.46-27.67-55.25-34.35C0 439.62 37.93 512 128 512c75.86 0 128-43.77 128-120.19 0-3.11-.65-6.08-.97-9.13l-88.01-73.34zM457.89 0c-15.16 0-29.37 6.71-40.21 16.45C213.27 199.05 192 203.34 192 257.09c0 13.7 3.25 26.76 8.73 38.7l63.82 53.18c7.21 1.8 14.64 3.03 22.39 3.03 62.11 0 98.11-45.47 211.16-256.46 7.38-14.35 13.9-29.85 13.9-45.99C512 20.64 486 0 457.89 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPaintRoller(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 128V32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v96c0 17.67 14.33 32 32 32h352c17.67 0 32-14.33 32-32zm32-64v128c0 17.67-14.33 32-32 32H256c-35.35 0-64 28.65-64 64v32c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32v-32h160c53.02 0 96-42.98 96-96v-64c0-35.35-28.65-64-64-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPalette(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M204.3 5C104.9 24.4 24.8 104.3 5.2 203.4c-37 187 131.7 326.4 258.8 306.7 41.2-6.4 61.4-54.6 42.5-91.7-23.1-45.4 9.9-98.4 60.9-98.4h79.7c35.8 0 64.8-29.6 64.9-65.3C511.5 97.1 368.1-26.9 204.3 5zM96 320c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm32-128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128-64c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 64c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPallet(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144 256h352c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H384v128l-64-32-64 32V0H144c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16zm480 128c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v64H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-48v-64h48zm-336 64H128v-64h160v64zm224 0H352v-64h160v64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPaperPlane(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M476 3.2L12.5 270.6c-18.1 10.4-15.8 35.6 2.2 43.2L121 358.4l287.3-253.2c5.5-4.9 13.3 2.6 8.6 8.3L176 407v80.5c0 23.6 28.5 32.9 42.5 15.8L282 426l124.6 52.2c14.2 6 30.4-2.9 33-18.2l72-432C515 7.8 493.3-6.8 476 3.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPaperclip(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M43.246 466.142c-58.43-60.289-57.341-157.511 1.386-217.581L254.392 34c44.316-45.332 116.351-45.336 160.671 0 43.89 44.894 43.943 117.329 0 162.276L232.214 383.128c-29.855 30.537-78.633 30.111-107.982-.998-28.275-29.97-27.368-77.473 1.452-106.953l143.743-146.835c6.182-6.314 16.312-6.422 22.626-.241l22.861 22.379c6.315 6.182 6.422 16.312.241 22.626L171.427 319.927c-4.932 5.045-5.236 13.428-.648 18.292 4.372 4.634 11.245 4.711 15.688.165l182.849-186.851c19.613-20.062 19.613-52.725-.011-72.798-19.189-19.627-49.957-19.637-69.154 0L90.39 293.295c-34.763 35.56-35.299 93.12-1.191 128.313 34.01 35.093 88.985 35.137 123.058.286l172.06-175.999c6.177-6.319 16.307-6.433 22.626-.256l22.877 22.364c6.319 6.177 6.434 16.307.256 22.626l-172.06 175.998c-59.576 60.938-155.943 60.216-214.77-.485z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaParachuteBox(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M511.9 175c-9.1-75.6-78.4-132.4-158.3-158.7C390 55.7 416 116.9 416 192h28.1L327.5 321.5c-2.5-.6-4.8-1.5-7.5-1.5h-48V192h112C384 76.8 315.1 0 256 0S128 76.8 128 192h112v128h-48c-2.7 0-5 .9-7.5 1.5L67.9 192H96c0-75.1 26-136.3 62.4-175.7C78.5 42.7 9.2 99.5.1 175c-1.1 9.1 6.8 17 16 17h8.7l136.7 151.9c-.7 2.6-1.6 5.2-1.6 8.1v128c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32V352c0-2.9-.9-5.4-1.6-8.1L487.1 192h8.7c9.3 0 17.2-7.8 16.1-17z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaParagraph(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 48v32a16 16 0 0 1-16 16h-48v368a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V96h-32v368a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V352h-32a160 160 0 0 1 0-320h240a16 16 0 0 1 16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaParking(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM240 320h-48v48c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16h96c52.9 0 96 43.1 96 96s-43.1 96-96 96zm0-128h-48v64h48c17.6 0 32-14.4 32-32s-14.4-32-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPassport(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M129.62 176h39.09c1.49-27.03 6.54-51.35 14.21-70.41-27.71 13.24-48.02 39.19-53.3 70.41zm0 32c5.29 31.22 25.59 57.17 53.3 70.41-7.68-19.06-12.72-43.38-14.21-70.41h-39.09zM224 286.69c7.69-7.45 20.77-34.42 23.43-78.69h-46.87c2.67 44.26 15.75 71.24 23.44 78.69zM200.57 176h46.87c-2.66-44.26-15.74-71.24-23.43-78.69-7.7 7.45-20.78 34.43-23.44 78.69zm64.51 102.41c27.71-13.24 48.02-39.19 53.3-70.41h-39.09c-1.49 27.03-6.53 51.35-14.21 70.41zM416 0H64C28.65 0 0 28.65 0 64v384c0 35.35 28.65 64 64 64h352c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32zm-80 416H112c-8.8 0-16-7.2-16-16s7.2-16 16-16h224c8.8 0 16 7.2 16 16s-7.2 16-16 16zm-112-96c-70.69 0-128-57.31-128-128S153.31 64 224 64s128 57.31 128 128-57.31 128-128 128zm41.08-214.41c7.68 19.06 12.72 43.38 14.21 70.41h39.09c-5.28-31.22-25.59-57.17-53.3-70.41z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPastafarianism(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624.54 347.67c-32.7-12.52-57.36 4.25-75.37 16.45-17.06 11.53-23.25 14.42-31.41 11.36-8.12-3.09-10.83-9.38-15.89-29.38-3.33-13.15-7.44-29.32-17.95-42.65 2.24-2.91 4.43-5.79 6.38-8.57C500.47 304.45 513.71 312 532 312c33.95 0 50.87-25.78 62.06-42.83 10.59-16.14 15-21.17 21.94-21.17 13.25 0 24-10.75 24-24s-10.75-24-24-24c-33.95 0-50.87 25.78-62.06 42.83-10.6 16.14-15 21.17-21.94 21.17-17.31 0-37.48-61.43-97.26-101.91l17.25-34.5C485.43 125.5 512 97.98 512 64c0-35.35-28.65-64-64-64s-64 28.65-64 64c0 13.02 3.94 25.1 10.62 35.21l-18.15 36.3c-16.98-4.6-35.6-7.51-56.46-7.51s-39.49 2.91-56.46 7.51l-18.15-36.3C252.06 89.1 256 77.02 256 64c0-35.35-28.65-64-64-64s-64 28.65-64 64c0 33.98 26.56 61.5 60.02 63.6l17.25 34.5C145.68 202.44 125.15 264 108 264c-6.94 0-11.34-5.03-21.94-21.17C74.88 225.78 57.96 200 24 200c-13.25 0-24 10.75-24 24s10.75 24 24 24c6.94 0 11.34 5.03 21.94 21.17C57.13 286.22 74.05 312 108 312c18.29 0 31.53-7.55 41.7-17.11 1.95 2.79 4.14 5.66 6.38 8.57-10.51 13.33-14.62 29.5-17.95 42.65-5.06 20-7.77 26.28-15.89 29.38-8.11 3.06-14.33.17-31.41-11.36-18.03-12.2-42.72-28.92-75.37-16.45-12.39 4.72-18.59 18.58-13.87 30.97 4.72 12.41 18.61 18.61 30.97 13.88 8.16-3.09 14.34-.19 31.39 11.36 13.55 9.16 30.83 20.86 52.42 20.84 7.17 0 14.83-1.28 22.97-4.39 32.66-12.44 39.98-41.33 45.33-62.44 2.21-8.72 3.99-14.49 5.95-18.87 16.62 13.61 36.95 25.88 61.64 34.17-9.96 37-32.18 90.8-60.26 90.8-13.25 0-24 10.75-24 24s10.75 24 24 24c66.74 0 97.05-88.63 107.42-129.14 6.69.6 13.42 1.14 20.58 1.14s13.89-.54 20.58-1.14C350.95 423.37 381.26 512 448 512c13.25 0 24-10.75 24-24s-10.75-24-24-24c-27.94 0-50.21-53.81-60.22-90.81 24.69-8.29 45-20.56 61.62-34.16 1.96 4.38 3.74 10.15 5.95 18.87 5.34 21.11 12.67 50 45.33 62.44 8.14 3.11 15.8 4.39 22.97 4.39 21.59 0 38.87-11.69 52.42-20.84 17.05-11.55 23.28-14.45 31.39-11.36 12.39 4.75 26.27-1.47 30.97-13.88 4.71-12.4-1.49-26.26-13.89-30.98zM448 48c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16zm-256 0c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPaste(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 184c0-30.879 25.122-56 56-56h136V56c0-13.255-10.745-24-24-24h-80.61C204.306 12.89 183.637 0 160 0s-44.306 12.89-55.39 32H24C10.745 32 0 42.745 0 56v336c0 13.255 10.745 24 24 24h104V184zm32-144c13.255 0 24 10.745 24 24s-10.745 24-24 24-24-10.745-24-24 10.745-24 24-24zm184 248h104v200c0 13.255-10.745 24-24 24H184c-13.255 0-24-10.745-24-24V184c0-13.255 10.745-24 24-24h136v104c0 13.2 10.8 24 24 24zm104-38.059V256h-96v-96h6.059a24 24 0 0 1 16.97 7.029l65.941 65.941a24.002 24.002 0 0 1 7.03 16.971z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPauseCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm-16 328c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v160zm112 0c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v160z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPause(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144 479H48c-26.5 0-48-21.5-48-48V79c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48zm304-48V79c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48v352c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPaw(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 224c-79.41 0-192 122.76-192 200.25 0 34.9 26.81 55.75 71.74 55.75 48.84 0 81.09-25.08 120.26-25.08 39.51 0 71.85 25.08 120.26 25.08 44.93 0 71.74-20.85 71.74-55.75C448 346.76 335.41 224 256 224zm-147.28-12.61c-10.4-34.65-42.44-57.09-71.56-50.13-29.12 6.96-44.29 40.69-33.89 75.34 10.4 34.65 42.44 57.09 71.56 50.13 29.12-6.96 44.29-40.69 33.89-75.34zm84.72-20.78c30.94-8.14 46.42-49.94 34.58-93.36s-46.52-72.01-77.46-63.87-46.42 49.94-34.58 93.36c11.84 43.42 46.53 72.02 77.46 63.87zm281.39-29.34c-29.12-6.96-61.15 15.48-71.56 50.13-10.4 34.65 4.77 68.38 33.89 75.34 29.12 6.96 61.15-15.48 71.56-50.13 10.4-34.65-4.77-68.38-33.89-75.34zm-156.27 29.34c30.94 8.14 65.62-20.45 77.46-63.87 11.84-43.42-3.64-85.21-34.58-93.36s-65.62 20.45-77.46 63.87c-11.84 43.42 3.64 85.22 34.58 93.36z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPeace(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm184 248c0 31.93-8.2 61.97-22.57 88.17L280 240.63V74.97c86.23 15.21 152 90.5 152 181.03zM216 437.03c-33.86-5.97-64.49-21.2-89.29-43.02L216 322.57v114.46zm64-114.46L369.29 394c-24.8 21.82-55.43 37.05-89.29 43.02V322.57zm-64-247.6v165.66L86.57 344.17C72.2 317.97 64 287.93 64 256c0-90.53 65.77-165.82 152-181.03z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPenAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M497.94 74.17l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.75 18.75-49.15 0-67.91zm-246.8-20.53c-15.62-15.62-40.94-15.62-56.56 0L75.8 172.43c-6.25 6.25-6.25 16.38 0 22.62l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l101.82-101.82 22.63 22.62L93.95 290.03A327.038 327.038 0 0 0 .17 485.11l-.03.23c-1.7 15.28 11.21 28.2 26.49 26.51a327.02 327.02 0 0 0 195.34-93.8l196.79-196.79-82.77-82.77-84.85-84.85z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPenFancy(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M79.18 282.94a32.005 32.005 0 0 0-20.24 20.24L0 480l4.69 4.69 92.89-92.89c-.66-2.56-1.57-5.03-1.57-7.8 0-17.67 14.33-32 32-32s32 14.33 32 32-14.33 32-32 32c-2.77 0-5.24-.91-7.8-1.57l-92.89 92.89L32 512l176.82-58.94a31.983 31.983 0 0 0 20.24-20.24l33.07-84.07-98.88-98.88-84.07 33.07zM369.25 28.32L186.14 227.81l97.85 97.85 199.49-183.11C568.4 67.48 443.73-55.94 369.25 28.32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPenNib(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M136.6 138.79a64.003 64.003 0 0 0-43.31 41.35L0 460l14.69 14.69L164.8 324.58c-2.99-6.26-4.8-13.18-4.8-20.58 0-26.51 21.49-48 48-48s48 21.49 48 48-21.49 48-48 48c-7.4 0-14.32-1.81-20.58-4.8L37.31 497.31 52 512l279.86-93.29a64.003 64.003 0 0 0 41.35-43.31L416 224 288 96l-151.4 42.79zm361.34-64.62l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.75 18.75-49.15 0-67.91z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPenSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 480H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48zM238.1 177.9L102.4 313.6l-6.3 57.1c-.8 7.6 5.6 14.1 13.3 13.3l57.1-6.3L302.2 242c2.3-2.3 2.3-6.1 0-8.5L246.7 178c-2.5-2.4-6.3-2.4-8.6-.1zM345 165.1L314.9 135c-9.4-9.4-24.6-9.4-33.9 0l-23.1 23.1c-2.3 2.3-2.3 6.1 0 8.5l55.5 55.5c2.3 2.3 6.1 2.3 8.5 0L345 199c9.3-9.3 9.3-24.5 0-33.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M290.74 93.24l128.02 128.02-277.99 277.99-114.14 12.6C11.35 513.54-1.56 500.62.14 485.34l12.7-114.22 277.9-277.88zm207.2-19.06l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.76 18.75-49.16 0-67.91z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPencilAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M497.9 142.1l-46.1 46.1c-4.7 4.7-12.3 4.7-17 0l-111-111c-4.7-4.7-4.7-12.3 0-17l46.1-46.1c18.7-18.7 49.1-18.7 67.9 0l60.1 60.1c18.8 18.7 18.8 49.1 0 67.9zM284.2 99.8L21.6 362.4.4 483.9c-2.9 16.4 11.4 30.6 27.8 27.8l121.5-21.3 262.6-262.6c4.7-4.7 4.7-12.3 0-17l-111-111c-4.8-4.7-12.4-4.7-17.1 0zM124.1 339.9c-5.5-5.5-5.5-14.3 0-19.8l154-154c5.5-5.5 14.3-5.5 19.8 0s5.5 14.3 0 19.8l-154 154c-5.5 5.5-14.3 5.5-19.8 0zM88 424h48v36.3l-64.5 11.3-31.1-31.1L51.7 376H88v48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPencilRuler(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M109.46 244.04l134.58-134.56-44.12-44.12-61.68 61.68a7.919 7.919 0 0 1-11.21 0l-11.21-11.21c-3.1-3.1-3.1-8.12 0-11.21l61.68-61.68-33.64-33.65C131.47-3.1 111.39-3.1 99 9.29L9.29 99c-12.38 12.39-12.39 32.47 0 44.86l100.17 100.18zm388.47-116.8c18.76-18.76 18.75-49.17 0-67.93l-45.25-45.25c-18.76-18.76-49.18-18.76-67.95 0l-46.02 46.01 113.2 113.2 46.02-46.03zM316.08 82.71l-297 296.96L.32 487.11c-2.53 14.49 10.09 27.11 24.59 24.56l107.45-18.84L429.28 195.9 316.08 82.71zm186.63 285.43l-33.64-33.64-61.68 61.68c-3.1 3.1-8.12 3.1-11.21 0l-11.21-11.21c-3.09-3.1-3.09-8.12 0-11.21l61.68-61.68-44.14-44.14L267.93 402.5l100.21 100.2c12.39 12.39 32.47 12.39 44.86 0l89.71-89.7c12.39-12.39 12.39-32.47 0-44.86z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPeopleArrows(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96,128A64,64,0,1,0,32,64,64,64,0,0,0,96,128Zm0,176.08a44.11,44.11,0,0,1,13.64-32L181.77,204c1.65-1.55,3.77-2.31,5.61-3.57A63.91,63.91,0,0,0,128,160H64A64,64,0,0,0,0,224v96a32,32,0,0,0,32,32V480a32,32,0,0,0,32,32h64a32,32,0,0,0,32-32V383.61l-50.36-47.53A44.08,44.08,0,0,1,96,304.08ZM480,128a64,64,0,1,0-64-64A64,64,0,0,0,480,128Zm32,32H448a63.91,63.91,0,0,0-59.38,40.42c1.84,1.27,4,2,5.62,3.59l72.12,68.06a44.37,44.37,0,0,1,0,64L416,383.62V480a32,32,0,0,0,32,32h64a32,32,0,0,0,32-32V352a32,32,0,0,0,32-32V224A64,64,0,0,0,512,160ZM444.4,295.34l-72.12-68.06A12,12,0,0,0,352,236v36H224V236a12,12,0,0,0-20.28-8.73L131.6,295.34a12.4,12.4,0,0,0,0,17.47l72.12,68.07A12,12,0,0,0,224,372.14V336H352v36.14a12,12,0,0,0,20.28,8.74l72.12-68.07A12.4,12.4,0,0,0,444.4,295.34Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPeopleCarry(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 96c26.5 0 48-21.5 48-48S154.5 0 128 0 80 21.5 80 48s21.5 48 48 48zm384 0c26.5 0 48-21.5 48-48S538.5 0 512 0s-48 21.5-48 48 21.5 48 48 48zm125.7 372.1l-44-110-41.1 46.4-2 18.2 27.7 69.2c5 12.5 17 20.1 29.7 20.1 4 0 8-.7 11.9-2.3 16.4-6.6 24.4-25.2 17.8-41.6zm-34.2-209.8L585 178.1c-4.6-20-18.6-36.8-37.5-44.9-18.5-8-39-6.7-56.1 3.3-22.7 13.4-39.7 34.5-48.1 59.4L432 229.8 416 240v-96c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16v96l-16.1-10.2-11.3-33.9c-8.3-25-25.4-46-48.1-59.4-17.2-10-37.6-11.3-56.1-3.3-18.9 8.1-32.9 24.9-37.5 44.9l-18.4 80.2c-4.6 20 .7 41.2 14.4 56.7l67.2 75.9 10.1 92.6C130 499.8 143.8 512 160 512c1.2 0 2.3-.1 3.5-.2 17.6-1.9 30.2-17.7 28.3-35.3l-10.1-92.8c-1.5-13-6.9-25.1-15.6-35l-43.3-49 17.6-70.3 6.8 20.4c4.1 12.5 11.9 23.4 24.5 32.6l51.1 32.5c4.6 2.9 12.1 4.6 17.2 5h160c5.1-.4 12.6-2.1 17.2-5l51.1-32.5c12.6-9.2 20.4-20 24.5-32.6l6.8-20.4 17.6 70.3-43.3 49c-8.7 9.9-14.1 22-15.6 35l-10.1 92.8c-1.9 17.6 10.8 33.4 28.3 35.3 1.2.1 2.3.2 3.5.2 16.1 0 30-12.1 31.8-28.5l10.1-92.6 67.2-75.9c13.6-15.5 19-36.7 14.4-56.7zM46.3 358.1l-44 110c-6.6 16.4 1.4 35 17.8 41.6 16.8 6.6 35.1-1.7 41.6-17.8l27.7-69.2-2-18.2-41.1-46.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPepperHot(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M330.67 263.12V173.4l-52.75-24.22C219.44 218.76 197.58 400 56 400a56 56 0 0 0 0 112c212.64 0 370.65-122.87 419.18-210.34l-37.05-38.54zm131.09-128.37C493.92 74.91 477.18 26.48 458.62 3a8 8 0 0 0-11.93-.59l-22.9 23a8.06 8.06 0 0 0-.89 10.23c6.86 10.36 17.05 35.1-1.4 72.32A142.85 142.85 0 0 0 364.34 96c-28 0-54 8.54-76.34 22.59l74.67 34.29v78.24h89.09L506.44 288c3.26-12.62 5.56-25.63 5.56-39.31a154 154 0 0 0-50.24-113.94z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPercent(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112 224c61.9 0 112-50.1 112-112S173.9 0 112 0 0 50.1 0 112s50.1 112 112 112zm0-160c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zm224 224c-61.9 0-112 50.1-112 112s50.1 112 112 112 112-50.1 112-112-50.1-112-112-112zm0 160c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zM392.3.2l31.6-.1c19.4-.1 30.9 21.8 19.7 37.8L77.4 501.6a23.95 23.95 0 0 1-19.6 10.2l-33.4.1c-19.5 0-30.9-21.9-19.7-37.8l368-463.7C377.2 4 384.5.2 392.3.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPercentage(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M109.25 173.25c24.99-24.99 24.99-65.52 0-90.51-24.99-24.99-65.52-24.99-90.51 0-24.99 24.99-24.99 65.52 0 90.51 25 25 65.52 25 90.51 0zm256 165.49c-24.99-24.99-65.52-24.99-90.51 0-24.99 24.99-24.99 65.52 0 90.51 24.99 24.99 65.52 24.99 90.51 0 25-24.99 25-65.51 0-90.51zm-1.94-231.43l-22.62-22.62c-12.5-12.5-32.76-12.5-45.25 0L20.69 359.44c-12.5 12.5-12.5 32.76 0 45.25l22.62 22.62c12.5 12.5 32.76 12.5 45.25 0l274.75-274.75c12.5-12.49 12.5-32.75 0-45.25z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPersonBooth(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320h-64v176zm32-272h-50.9l-45.2-45.3C115.8 166.6 99.7 160 82.7 160H64c-17.1 0-33.2 6.7-45.3 18.8C6.7 190.9 0 207 0 224.1L.2 320 0 480c0 17.7 14.3 32 31.9 32 17.6 0 32-14.3 32-32l.1-100.7c.9.5 1.6 1.3 2.5 1.7l29.1 43v56c0 17.7 14.3 32 32 32s32-14.3 32-32v-56.5c0-9.9-2.3-19.8-6.7-28.6l-41.2-61.3V253l20.9 20.9c9.1 9.1 21.1 14.1 33.9 14.1H224c17.7 0 32-14.3 32-32s-14.3-32-32-32zM64 128c26.5 0 48-21.5 48-48S90.5 32 64 32 16 53.5 16 80s21.5 48 48 48zm224-96l31.5 223.1-30.9 154.6c-4.3 21.6 13 38.3 31.4 38.3 15.2 0 28-9.1 32.3-30.4.9 16.9 14.6 30.4 31.7 30.4 17.7 0 32-14.3 32-32 0 17.7 14.3 32 32 32s32-14.3 32-32V0H288v32zm-96 0v160h64V0h-32c-17.7 0-32 14.3-32 32zM544 0h-32v496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V32c0-17.7-14.3-32-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPhoneAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M497.39 361.8l-112-48a24 24 0 0 0-28 6.9l-49.6 60.6A370.66 370.66 0 0 1 130.6 204.11l60.6-49.6a23.94 23.94 0 0 0 6.9-28l-48-112A24.16 24.16 0 0 0 122.6.61l-104 24A24 24 0 0 0 0 48c0 256.5 207.9 464 464 464a24 24 0 0 0 23.4-18.6l24-104a24.29 24.29 0 0 0-14.01-27.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPhoneSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M268.2 381.4l-49.6-60.6c-6.8-8.3-18.2-11.1-28-6.9l-112 48c-10.7 4.6-16.5 16.1-13.9 27.5l24 104c2.5 10.8 12.1 18.6 23.4 18.6 100.7 0 193.7-32.4 269.7-86.9l-80-61.8c-10.9 6.5-22.1 12.7-33.6 18.1zm365.6 76.7L475.1 335.5C537.9 256.4 576 156.9 576 48c0-11.2-7.7-20.9-18.6-23.4l-104-24c-11.3-2.6-22.9 3.3-27.5 13.9l-48 112c-4.2 9.8-1.4 21.3 6.9 28l60.6 49.6c-12.2 26.1-27.9 50.3-46 72.8L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPhoneSquareAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h352a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48zm-16.39 307.37l-15 65A15 15 0 0 1 354 416C194 416 64 286.29 64 126a15.7 15.7 0 0 1 11.63-14.61l65-15A18.23 18.23 0 0 1 144 96a16.27 16.27 0 0 1 13.79 9.09l30 70A17.9 17.9 0 0 1 189 181a17 17 0 0 1-5.5 11.61l-37.89 31a231.91 231.91 0 0 0 110.78 110.78l31-37.89A17 17 0 0 1 299 291a17.85 17.85 0 0 1 5.91 1.21l70 30A16.25 16.25 0 0 1 384 336a17.41 17.41 0 0 1-.39 3.37z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPhoneSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM94 416c-7.033 0-13.057-4.873-14.616-11.627l-14.998-65a15 15 0 0 1 8.707-17.16l69.998-29.999a15 15 0 0 1 17.518 4.289l30.997 37.885c48.944-22.963 88.297-62.858 110.781-110.78l-37.886-30.997a15.001 15.001 0 0 1-4.289-17.518l30-69.998a15 15 0 0 1 17.16-8.707l65 14.998A14.997 14.997 0 0 1 384 126c0 160.292-129.945 290-290 290z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPhoneVolume(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M97.333 506.966c-129.874-129.874-129.681-340.252 0-469.933 5.698-5.698 14.527-6.632 21.263-2.422l64.817 40.513a17.187 17.187 0 0 1 6.849 20.958l-32.408 81.021a17.188 17.188 0 0 1-17.669 10.719l-55.81-5.58c-21.051 58.261-20.612 122.471 0 179.515l55.811-5.581a17.188 17.188 0 0 1 17.669 10.719l32.408 81.022a17.188 17.188 0 0 1-6.849 20.958l-64.817 40.513a17.19 17.19 0 0 1-21.264-2.422zM247.126 95.473c11.832 20.047 11.832 45.008 0 65.055-3.95 6.693-13.108 7.959-18.718 2.581l-5.975-5.726c-3.911-3.748-4.793-9.622-2.261-14.41a32.063 32.063 0 0 0 0-29.945c-2.533-4.788-1.65-10.662 2.261-14.41l5.975-5.726c5.61-5.378 14.768-4.112 18.718 2.581zm91.787-91.187c60.14 71.604 60.092 175.882 0 247.428-4.474 5.327-12.53 5.746-17.552.933l-5.798-5.557c-4.56-4.371-4.977-11.529-.93-16.379 49.687-59.538 49.646-145.933 0-205.422-4.047-4.85-3.631-12.008.93-16.379l5.798-5.557c5.022-4.813 13.078-4.394 17.552.933zm-45.972 44.941c36.05 46.322 36.108 111.149 0 157.546-4.39 5.641-12.697 6.251-17.856 1.304l-5.818-5.579c-4.4-4.219-4.998-11.095-1.285-15.931 26.536-34.564 26.534-82.572 0-117.134-3.713-4.836-3.115-11.711 1.285-15.931l5.818-5.579c5.159-4.947 13.466-4.337 17.856 1.304z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPhone(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M493.4 24.6l-104-24c-11.3-2.6-22.9 3.3-27.5 13.9l-48 112c-4.2 9.8-1.4 21.3 6.9 28l60.6 49.6c-36 76.7-98.9 140.5-177.2 177.2l-49.6-60.6c-6.8-8.3-18.2-11.1-28-6.9l-112 48C3.9 366.5-2 378.1.6 389.4l24 104C27.1 504.2 36.7 512 48 512c256.1 0 464-207.5 464-464 0-11.2-7.7-20.9-18.6-23.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPhotoVideo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M608 0H160a32 32 0 0 0-32 32v96h160V64h192v320h128a32 32 0 0 0 32-32V32a32 32 0 0 0-32-32zM232 103a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9V73a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm352 208a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9v-30a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm0-104a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9v-30a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm0-104a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9V73a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm-168 57H32a32 32 0 0 0-32 32v288a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V192a32 32 0 0 0-32-32zM96 224a32 32 0 1 1-32 32 32 32 0 0 1 32-32zm288 224H64v-32l64-64 32 32 128-128 96 96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPiggyBank(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M560 224h-29.5c-8.8-20-21.6-37.7-37.4-52.5L512 96h-32c-29.4 0-55.4 13.5-73 34.3-7.6-1.1-15.1-2.3-23-2.3H256c-77.4 0-141.9 55-156.8 128H56c-14.8 0-26.5-13.5-23.5-28.8C34.7 215.8 45.4 208 57 208h1c3.3 0 6-2.7 6-6v-20c0-3.3-2.7-6-6-6-28.5 0-53.9 20.4-57.5 48.6C-3.9 258.8 22.7 288 56 288h40c0 52.2 25.4 98.1 64 127.3V496c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-48h128v48c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-80.7c11.8-8.9 22.3-19.4 31.3-31.3H560c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16zm-128 64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zM256 96h128c5.4 0 10.7.4 15.9.8 0-.3.1-.5.1-.8 0-53-43-96-96-96s-96 43-96 96c0 2.1.5 4.1.6 6.2 15.2-3.9 31-6.2 47.4-6.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPills(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112 32C50.1 32 0 82.1 0 144v224c0 61.9 50.1 112 112 112s112-50.1 112-112V144c0-61.9-50.1-112-112-112zm48 224H64V144c0-26.5 21.5-48 48-48s48 21.5 48 48v112zm139.7-29.7c-3.5-3.5-9.4-3.1-12.3.8-45.3 62.5-40.4 150.1 15.9 206.4 56.3 56.3 143.9 61.2 206.4 15.9 4-2.9 4.3-8.8.8-12.3L299.7 226.3zm229.8-19c-56.3-56.3-143.9-61.2-206.4-15.9-4 2.9-4.3 8.8-.8 12.3l210.8 210.8c3.5 3.5 9.4 3.1 12.3-.8 45.3-62.6 40.5-150.1-15.9-206.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPizzaSlice(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M158.87.15c-16.16-1.52-31.2 8.42-35.33 24.12l-14.81 56.27c187.62 5.49 314.54 130.61 322.48 317l56.94-15.78c15.72-4.36 25.49-19.68 23.62-35.9C490.89 165.08 340.78 17.32 158.87.15zm-58.47 112L.55 491.64a16.21 16.21 0 0 0 20 19.75l379-105.1c-4.27-174.89-123.08-292.14-299.15-294.1zM128 416a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm48-152a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm104 104a32 32 0 1 1 32-32 32 32 0 0 1-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPlaceOfWorship(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M620.61 366.55L512 320v192h112c8.84 0 16-7.16 16-16V395.96a32 32 0 0 0-19.39-29.41zM0 395.96V496c0 8.84 7.16 16 16 16h112V320L19.39 366.55A32 32 0 0 0 0 395.96zm464.46-149.28L416 217.6V102.63c0-8.49-3.37-16.62-9.38-22.63L331.31 4.69c-6.25-6.25-16.38-6.25-22.62 0L233.38 80c-6 6-9.38 14.14-9.38 22.63V217.6l-48.46 29.08A31.997 31.997 0 0 0 160 274.12V512h96v-96c0-35.35 28.66-64 64-64s64 28.65 64 64v96h96V274.12c0-11.24-5.9-21.66-15.54-27.44z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPlaneArrival(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM44.81 205.66l88.74 80a62.607 62.607 0 0 0 25.47 13.93l287.6 78.35c26.48 7.21 54.56 8.72 81 1.36 29.67-8.27 43.44-21.21 47.25-35.71 3.83-14.5-1.73-32.71-23.37-54.96-19.28-19.82-44.35-32.79-70.83-40l-97.51-26.56L282.8 30.22c-1.51-5.81-5.95-10.35-11.66-11.91L206.05.58c-10.56-2.88-20.9 5.32-20.71 16.44l47.92 164.21-102.2-27.84-27.59-67.88c-1.93-4.89-6.01-8.57-11.02-9.93L52.72 64.75c-10.34-2.82-20.53 5-20.72 15.88l.23 101.78c.19 8.91 6.03 17.34 12.58 23.25z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPlaneDeparture(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM80.55 341.27c6.28 6.84 15.1 10.72 24.33 10.71l130.54-.18a65.62 65.62 0 0 0 29.64-7.12l290.96-147.65c26.74-13.57 50.71-32.94 67.02-58.31 18.31-28.48 20.3-49.09 13.07-63.65-7.21-14.57-24.74-25.27-58.25-27.45-29.85-1.94-59.54 5.92-86.28 19.48l-98.51 49.99-218.7-82.06a17.799 17.799 0 0 0-18-1.11L90.62 67.29c-10.67 5.41-13.25 19.65-5.17 28.53l156.22 98.1-103.21 52.38-72.35-36.47a17.804 17.804 0 0 0-16.07.02L9.91 230.22c-10.44 5.3-13.19 19.12-5.57 28.08l76.21 82.97z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPlaneSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32.48,147.88,64,256,32.48,364.13A16,16,0,0,0,48,384H88a16,16,0,0,0,12.8-6.41L144,320H246.85l-49,171.59A16,16,0,0,0,213.2,512h65.5a16,16,0,0,0,13.89-8.06l66.6-116.54L34.35,136.34A15.47,15.47,0,0,0,32.48,147.88ZM633.82,458.09,455.14,320H512c35.34,0,96-28.66,96-64s-60.66-64-96-64H397.7L292.61,8.06C290.06,3.61,283.84,0,278.71,0H213.2a16,16,0,0,0-15.38,20.39l36.94,129.29L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.45A16,16,0,0,0,6.18,53.91L594.54,508.63A16,16,0,0,0,617,505.81l19.64-25.26A16,16,0,0,0,633.82,458.09Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPlane(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 192H365.71L260.61 8.06A16.014 16.014 0 0 0 246.71 0h-65.5c-10.63 0-18.3 10.17-15.38 20.39L214.86 192H112l-43.2-57.6c-3.02-4.03-7.77-6.4-12.8-6.4H16.01C5.6 128-2.04 137.78.49 147.88L32 256 .49 364.12C-2.04 374.22 5.6 384 16.01 384H56c5.04 0 9.78-2.37 12.8-6.4L112 320h102.86l-49.03 171.6c-2.92 10.22 4.75 20.4 15.38 20.4h65.5c5.74 0 11.04-3.08 13.89-8.06L365.71 320H480c35.35 0 96-28.65 96-64s-60.65-64-96-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPlayCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm115.7 272l-176 101c-15.8 8.8-35.7-2.5-35.7-21V152c0-18.4 19.8-29.8 35.7-21l176 107c16.4 9.2 16.4 32.9 0 42z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPlay(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPlug(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320,32a32,32,0,0,0-64,0v96h64Zm48,128H16A16,16,0,0,0,0,176v32a16,16,0,0,0,16,16H32v32A160.07,160.07,0,0,0,160,412.8V512h64V412.8A160.07,160.07,0,0,0,352,256V224h16a16,16,0,0,0,16-16V176A16,16,0,0,0,368,160ZM128,32a32,32,0,0,0-64,0v96h64Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPlusCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm144 276c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92h-92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPlusSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-32 252c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92H92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPodcast(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M267.429 488.563C262.286 507.573 242.858 512 224 512c-18.857 0-38.286-4.427-43.428-23.437C172.927 460.134 160 388.898 160 355.75c0-35.156 31.142-43.75 64-43.75s64 8.594 64 43.75c0 32.949-12.871 104.179-20.571 132.813zM156.867 288.554c-18.693-18.308-29.958-44.173-28.784-72.599 2.054-49.724 42.395-89.956 92.124-91.881C274.862 121.958 320 165.807 320 220c0 26.827-11.064 51.116-28.866 68.552-2.675 2.62-2.401 6.986.628 9.187 9.312 6.765 16.46 15.343 21.234 25.363 1.741 3.654 6.497 4.66 9.449 1.891 28.826-27.043 46.553-65.783 45.511-108.565-1.855-76.206-63.595-138.208-139.793-140.369C146.869 73.753 80 139.215 80 220c0 41.361 17.532 78.7 45.55 104.989 2.953 2.771 7.711 1.77 9.453-1.887 4.774-10.021 11.923-18.598 21.235-25.363 3.029-2.2 3.304-6.566.629-9.185zM224 0C100.204 0 0 100.185 0 224c0 89.992 52.602 165.647 125.739 201.408 4.333 2.118 9.267-1.544 8.535-6.31-2.382-15.512-4.342-30.946-5.406-44.339-.146-1.836-1.149-3.486-2.678-4.512-47.4-31.806-78.564-86.016-78.187-147.347.592-96.237 79.29-174.648 175.529-174.899C320.793 47.747 400 126.797 400 224c0 61.932-32.158 116.49-80.65 147.867-.999 14.037-3.069 30.588-5.624 47.23-.732 4.767 4.203 8.429 8.535 6.31C395.227 389.727 448 314.187 448 224 448 100.205 347.815 0 224 0zm0 160c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPollH(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 432V80c0-26.5-21.5-48-48-48H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48zM112 192c-8.84 0-16-7.16-16-16v-32c0-8.84 7.16-16 16-16h128c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16H112zm0 96c-8.84 0-16-7.16-16-16v-32c0-8.84 7.16-16 16-16h224c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16H112zm0 96c-8.84 0-16-7.16-16-16v-32c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16h-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPoll(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM160 368c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16V240c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v128zm96 0c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16V144c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v224zm96 0c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-64c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPooStorm(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M308 336h-57.7l17.3-64.9c2-7.6-3.7-15.1-11.6-15.1h-68c-6 0-11.1 4.5-11.9 10.4l-16 120c-1 7.2 4.6 13.6 11.9 13.6h59.3l-23 97.2c-1.8 7.6 4 14.8 11.7 14.8 4.2 0 8.2-2.2 10.4-6l88-152c4.6-8-1.2-18-10.4-18zm66.4-111.3c5.9-9.6 9.6-20.6 9.6-32.7 0-35.3-28.7-64-64-64h-5.9c3.6-10.1 5.9-20.7 5.9-32 0-53-43-96-96-96-5.2 0-10.2.7-15.1 1.5C218.3 14.6 224 30.6 224 48c0 44.2-35.8 80-80 80h-16c-35.3 0-64 28.7-64 64 0 12.1 3.7 23.1 9.6 32.7C32.6 228 0 262.2 0 304c0 44 36 80 80 80h48.3c.1-.6 0-1.2 0-1.8l16-120c3-21.8 21.7-38.2 43.7-38.2h68c13.8 0 26.5 6.3 34.9 17.2s11.2 24.8 7.6 38.1l-6.6 24.7h16c15.7 0 30.3 8.4 38.1 22 7.8 13.6 7.8 30.5 0 44l-8.1 14h30c44 0 80-36 80-80 .1-41.8-32.5-76-73.5-79.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPoo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M451.4 369.1C468.7 356 480 335.4 480 312c0-39.8-32.2-72-72-72h-14.1c13.4-11.7 22.1-28.8 22.1-48 0-35.3-28.7-64-64-64h-5.9c3.6-10.1 5.9-20.7 5.9-32 0-53-43-96-96-96-5.2 0-10.2.7-15.1 1.5C250.3 14.6 256 30.6 256 48c0 44.2-35.8 80-80 80h-16c-35.3 0-64 28.7-64 64 0 19.2 8.7 36.3 22.1 48H104c-39.8 0-72 32.2-72 72 0 23.4 11.3 44 28.6 57.1C26.3 374.6 0 404.1 0 440c0 39.8 32.2 72 72 72h368c39.8 0 72-32.2 72-72 0-35.9-26.3-65.4-60.6-70.9zM192 256c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm159.5 139C341 422.9 293 448 256 448s-85-25.1-95.5-53c-2-5.3 2-11 7.8-11h175.4c5.8 0 9.8 5.7 7.8 11zM320 320c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPoop(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M451.36 369.14C468.66 355.99 480 335.41 480 312c0-39.77-32.24-72-72-72h-14.07c13.42-11.73 22.07-28.78 22.07-48 0-35.35-28.65-64-64-64h-5.88c3.57-10.05 5.88-20.72 5.88-32 0-53.02-42.98-96-96-96-5.17 0-10.15.74-15.11 1.52C250.31 14.64 256 30.62 256 48c0 44.18-35.82 80-80 80h-16c-35.35 0-64 28.65-64 64 0 19.22 8.65 36.27 22.07 48H104c-39.76 0-72 32.23-72 72 0 23.41 11.34 43.99 28.64 57.14C26.31 374.62 0 404.12 0 440c0 39.76 32.24 72 72 72h368c39.76 0 72-32.24 72-72 0-35.88-26.31-65.38-60.64-70.86z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPortrait(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM192 128c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H102.4C90 384 80 375.4 80 364.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPoundSign(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M308 352h-45.495c-6.627 0-12 5.373-12 12v50.848H128V288h84c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-84v-63.556c0-32.266 24.562-57.086 61.792-57.086 23.658 0 45.878 11.505 57.652 18.849 5.151 3.213 11.888 2.051 15.688-2.685l28.493-35.513c4.233-5.276 3.279-13.005-2.119-17.081C273.124 54.56 236.576 32 187.931 32 106.026 32 48 84.742 48 157.961V224H20c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h28v128H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h296c6.627 0 12-5.373 12-12V364c0-6.627-5.373-12-12-12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPowerOff(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 54.1c63 45 104 118.6 104 201.9 0 136.8-110.8 247.7-247.5 248C120 504.3 8.2 393 8 256.4 7.9 173.1 48.9 99.3 111.8 54.2c11.7-8.3 28-4.8 35 7.7L162.6 90c5.9 10.5 3.1 23.8-6.6 31-41.5 30.8-68 79.6-68 134.9-.1 92.3 74.5 168.1 168 168.1 91.6 0 168.6-74.2 168-169.1-.3-51.8-24.7-101.8-68.1-134-9.7-7.2-12.4-20.5-6.5-30.9l15.8-28.1c7-12.4 23.2-16.1 34.8-7.8zM296 264V24c0-13.3-10.7-24-24-24h-32c-13.3 0-24 10.7-24 24v240c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPray(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 128c35.35 0 64-28.65 64-64S291.35 0 256 0s-64 28.65-64 64 28.65 64 64 64zm-30.63 169.75c14.06 16.72 39 19.09 55.97 5.22l88-72.02c17.09-13.98 19.59-39.19 5.62-56.28-13.97-17.11-39.19-19.59-56.31-5.62l-57.44 47-38.91-46.31c-15.44-18.39-39.22-27.92-64-25.33-24.19 2.48-45.25 16.27-56.37 36.92l-49.37 92.03c-23.4 43.64-8.69 96.37 34.19 123.75L131.56 432H40c-22.09 0-40 17.91-40 40s17.91 40 40 40h208c34.08 0 53.77-42.79 28.28-68.28L166.42 333.86l34.8-64.87 24.15 28.76z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPrayingHands(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272 191.91c-17.6 0-32 14.4-32 32v80c0 8.84-7.16 16-16 16s-16-7.16-16-16v-76.55c0-17.39 4.72-34.47 13.69-49.39l77.75-129.59c9.09-15.16 4.19-34.81-10.97-43.91-14.45-8.67-32.72-4.3-42.3 9.21-.2.23-.62.21-.79.48l-117.26 175.9C117.56 205.9 112 224.31 112 243.29v80.23l-90.12 30.04A31.974 31.974 0 0 0 0 383.91v96c0 10.82 8.52 32 32 32 2.69 0 5.41-.34 8.06-1.03l179.19-46.62C269.16 449.99 304 403.8 304 351.91v-128c0-17.6-14.4-32-32-32zm346.12 161.73L528 323.6v-80.23c0-18.98-5.56-37.39-16.12-53.23L394.62 14.25c-.18-.27-.59-.24-.79-.48-9.58-13.51-27.85-17.88-42.3-9.21-15.16 9.09-20.06 28.75-10.97 43.91l77.75 129.59c8.97 14.92 13.69 32 13.69 49.39V304c0 8.84-7.16 16-16 16s-16-7.16-16-16v-80c0-17.6-14.4-32-32-32s-32 14.4-32 32v128c0 51.89 34.84 98.08 84.75 112.34l179.19 46.62c2.66.69 5.38 1.03 8.06 1.03 23.48 0 32-21.18 32-32v-96c0-13.77-8.81-25.99-21.88-30.35z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPrescriptionBottleAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M360 0H24C10.8 0 0 10.8 0 24v48c0 13.2 10.8 24 24 24h336c13.2 0 24-10.8 24-24V24c0-13.2-10.8-24-24-24zM32 480c0 17.6 14.4 32 32 32h256c17.6 0 32-14.4 32-32V128H32v352zm64-184c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPrescriptionBottle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 192h120c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H32v64h120c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H32v64h120c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H32v64c0 17.6 14.4 32 32 32h256c17.6 0 32-14.4 32-32V128H32v64zM360 0H24C10.8 0 0 10.8 0 24v48c0 13.2 10.8 24 24 24h336c13.2 0 24-10.8 24-24V24c0-13.2-10.8-24-24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPrescription(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M301.26 352l78.06-78.06c6.25-6.25 6.25-16.38 0-22.63l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0L256 306.74l-83.96-83.96C219.31 216.8 256 176.89 256 128c0-53.02-42.98-96-96-96H16C7.16 32 0 39.16 0 48v256c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-80h18.75l128 128-78.06 78.06c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0L256 397.25l78.06 78.06c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.25-6.25 6.25-16.38 0-22.63L301.26 352zM64 96h96c17.64 0 32 14.36 32 32s-14.36 32-32 32H64V96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPrint(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 192V77.25c0-8.49-3.37-16.62-9.37-22.63L393.37 9.37c-6-6-14.14-9.37-22.63-9.37H96C78.33 0 64 14.33 64 32v160c-35.35 0-64 28.65-64 64v112c0 8.84 7.16 16 16 16h48v96c0 17.67 14.33 32 32 32h320c17.67 0 32-14.33 32-32v-96h48c8.84 0 16-7.16 16-16V256c0-35.35-28.65-64-64-64zm-64 256H128v-96h256v96zm0-224H128V64h192v48c0 8.84 7.16 16 16 16h48v96zm48 72c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaProcedures(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528 224H272c-8.8 0-16 7.2-16 16v144H64V144c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16v352c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48h512v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V336c0-61.9-50.1-112-112-112zM136 96h126.1l27.6 55.2c5.9 11.8 22.7 11.8 28.6 0L368 51.8 390.1 96H512c8.8 0 16-7.2 16-16s-7.2-16-16-16H409.9L382.3 8.8C376.4-3 359.6-3 353.7 8.8L304 108.2l-19.9-39.8c-1.4-2.7-4.1-4.4-7.2-4.4H136c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm24 256c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaProjectDiagram(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 320H256c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h128c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32zM192 32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v128c0 17.67 14.33 32 32 32h95.72l73.16 128.04C211.98 300.98 232.4 288 256 288h.28L192 175.51V128h224V64H192V32zM608 0H480c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h128c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPumpMedical(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M235.51,159.82H84.24A64,64,0,0,0,20.51,218L.14,442a64,64,0,0,0,63.74,69.8h192A64,64,0,0,0,319.61,442L299.24,218A64,64,0,0,0,235.51,159.82Zm4.37,173.33a13.35,13.35,0,0,1-13.34,13.34h-40v40a13.33,13.33,0,0,1-13.33,13.33H146.54a13.33,13.33,0,0,1-13.33-13.33v-40h-40a13.34,13.34,0,0,1-13.33-13.34V306.49a13.33,13.33,0,0,1,13.33-13.34h40v-40a13.33,13.33,0,0,1,13.33-13.33h26.67a13.33,13.33,0,0,1,13.33,13.33v40h40a13.34,13.34,0,0,1,13.34,13.34ZM379.19,93.88,335.87,50.56a64,64,0,0,0-45.24-18.74H223.88a32,32,0,0,0-32-32h-64a32,32,0,0,0-32,32v96h128v-32h66.75l43.31,43.31a16,16,0,0,0,22.63,0l22.62-22.62A16,16,0,0,0,379.19,93.88Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPumpSoap(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M235.63,160H84.37a64,64,0,0,0-63.74,58.21L.27,442.21A64,64,0,0,0,64,512H256a64,64,0,0,0,63.74-69.79l-20.36-224A64,64,0,0,0,235.63,160ZM160,416c-33.12,0-60-26.33-60-58.75,0-25,35.7-75.47,52-97.27A10,10,0,0,1,168,260c16.33,21.8,52,72.27,52,97.27C220,389.67,193.12,416,160,416ZM379.31,94.06,336,50.74A64,64,0,0,0,290.75,32H224A32,32,0,0,0,192,0H128A32,32,0,0,0,96,32v96H224V96h66.75l43.31,43.31a16,16,0,0,0,22.63,0l22.62-22.62A16,16,0,0,0,379.31,94.06Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaPuzzlePiece(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M519.442 288.651c-41.519 0-59.5 31.593-82.058 31.593C377.409 320.244 432 144 432 144s-196.288 80-196.288-3.297c0-35.827 36.288-46.25 36.288-85.985C272 19.216 243.885 0 210.539 0c-34.654 0-66.366 18.891-66.366 56.346 0 41.364 31.711 59.277 31.711 81.75C175.885 207.719 0 166.758 0 166.758v333.237s178.635 41.047 178.635-28.662c0-22.473-40-40.107-40-81.471 0-37.456 29.25-56.346 63.577-56.346 33.673 0 61.788 19.216 61.788 54.717 0 39.735-36.288 50.158-36.288 85.985 0 60.803 129.675 25.73 181.23 25.73 0 0-34.725-120.101 25.827-120.101 35.962 0 46.423 36.152 86.308 36.152C556.712 416 576 387.99 576 354.443c0-34.199-18.962-65.792-56.558-65.792z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaQrcode(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 224h192V32H0v192zM64 96h64v64H64V96zm192-64v192h192V32H256zm128 128h-64V96h64v64zM0 480h192V288H0v192zm64-128h64v64H64v-64zm352-64h32v128h-96v-32h-32v96h-64V288h96v32h64v-32zm0 160h32v32h-32v-32zm-64 0h32v32h-32v-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaQuestionCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zM262.655 90c-54.497 0-89.255 22.957-116.549 63.758-3.536 5.286-2.353 12.415 2.715 16.258l34.699 26.31c5.205 3.947 12.621 3.008 16.665-2.122 17.864-22.658 30.113-35.797 57.303-35.797 20.429 0 45.698 13.148 45.698 32.958 0 14.976-12.363 22.667-32.534 33.976C247.128 238.528 216 254.941 216 296v4c0 6.627 5.373 12 12 12h56c6.627 0 12-5.373 12-12v-1.333c0-28.462 83.186-29.647 83.186-106.667 0-58.002-60.165-102-116.531-102zM256 338c-25.365 0-46 20.635-46 46 0 25.364 20.635 46 46 46s46-20.636 46-46c0-25.365-20.635-46-46-46z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaQuestion(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M202.021 0C122.202 0 70.503 32.703 29.914 91.026c-7.363 10.58-5.093 25.086 5.178 32.874l43.138 32.709c10.373 7.865 25.132 6.026 33.253-4.148 25.049-31.381 43.63-49.449 82.757-49.449 30.764 0 68.816 19.799 68.816 49.631 0 22.552-18.617 34.134-48.993 51.164-35.423 19.86-82.299 44.576-82.299 106.405V320c0 13.255 10.745 24 24 24h72.471c13.255 0 24-10.745 24-24v-5.773c0-42.86 125.268-44.645 125.268-160.627C377.504 66.256 286.902 0 202.021 0zM192 373.459c-38.196 0-69.271 31.075-69.271 69.271 0 38.195 31.075 69.27 69.271 69.27s69.271-31.075 69.271-69.271-31.075-69.27-69.271-69.27z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaQuidditch(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256.5 216.8L343.2 326s-16.6 102.4-76.6 150.1C206.7 523.8 0 510.2 0 510.2s3.8-23.1 11-55.4l94.6-112.2c4-4.7-.9-11.6-6.6-9.5l-60.4 22.1c14.4-41.7 32.7-80 54.6-97.5 59.9-47.8 163.3-40.9 163.3-40.9zm238 135c-44 0-79.8 35.8-79.8 79.9 0 44.1 35.7 79.9 79.8 79.9 44.1 0 79.8-35.8 79.8-79.9 0-44.2-35.8-79.9-79.8-79.9zM636.5 31L616.7 6c-5.5-6.9-15.5-8-22.4-2.6L361.8 181.3l-34.1-43c-5.1-6.4-15.1-5.2-18.6 2.2l-25.3 54.6 86.7 109.2 58.8-12.4c8-1.7 11.4-11.2 6.3-17.6l-34.1-42.9L634 53.5c6.9-5.5 8-15.6 2.5-22.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaQuoteLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256h-80v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8c-88.4 0-160 71.6-160 160v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48zm-288 0H96v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8C71.6 32 0 103.6 0 192v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaQuoteRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 32H336c-26.5 0-48 21.5-48 48v128c0 26.5 21.5 48 48 48h80v64c0 35.3-28.7 64-64 64h-8c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h8c88.4 0 160-71.6 160-160V80c0-26.5-21.5-48-48-48zm-288 0H48C21.5 32 0 53.5 0 80v128c0 26.5 21.5 48 48 48h80v64c0 35.3-28.7 64-64 64h-8c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h8c88.4 0 160-71.6 160-160V80c0-26.5-21.5-48-48-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaQuran(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM301.08 145.82c.6-1.21 1.76-1.82 2.92-1.82s2.32.61 2.92 1.82l11.18 22.65 25 3.63c2.67.39 3.74 3.67 1.81 5.56l-18.09 17.63 4.27 24.89c.36 2.11-1.31 3.82-3.21 3.82-.5 0-1.02-.12-1.52-.38L304 211.87l-22.36 11.75c-.5.26-1.02.38-1.52.38-1.9 0-3.57-1.71-3.21-3.82l4.27-24.89-18.09-17.63c-1.94-1.89-.87-5.17 1.81-5.56l24.99-3.63 11.19-22.65zm-57.89-69.01c13.67 0 27.26 2.49 40.38 7.41a6.775 6.775 0 1 1-2.38 13.12c-.67 0-3.09-.21-4.13-.21-52.31 0-94.86 42.55-94.86 94.86 0 52.3 42.55 94.86 94.86 94.86 1.03 0 3.48-.21 4.13-.21 3.93 0 6.8 3.14 6.8 6.78 0 2.98-1.94 5.51-4.62 6.42-13.07 4.87-26.59 7.34-40.19 7.34C179.67 307.19 128 255.51 128 192c0-63.52 51.67-115.19 115.19-115.19zM380.8 448H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8v64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRadiationAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M312 256h79.1c9.2 0 16.9-7.7 16-16.8-4.6-43.6-27-81.8-59.5-107.8-7.6-6.1-18.8-4.5-24 3.8L281.9 202c18 11.2 30.1 31.2 30.1 54zm-97.8 54.1L172.4 377c-4.9 7.8-2.4 18.4 5.8 22.5 21.1 10.4 44.7 16.5 69.8 16.5s48.7-6.1 69.9-16.5c8.2-4.1 10.6-14.7 5.8-22.5l-41.8-66.9c-9.8 6.2-21.4 9.9-33.8 9.9s-24.1-3.7-33.9-9.9zM104.9 256H184c0-22.8 12.1-42.8 30.2-54.1l-41.7-66.8c-5.2-8.3-16.4-9.9-24-3.8-32.6 26-54.9 64.2-59.5 107.8-1.1 9.2 6.7 16.9 15.9 16.9zM248 504c137 0 248-111 248-248S385 8 248 8 0 119 0 256s111 248 248 248zm0-432c101.5 0 184 82.5 184 184s-82.5 184-184 184S64 357.5 64 256 146.5 72 248 72zm0 216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRadiation(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M328.2 255.8h151.6c9.1 0 16.8-7.7 16.2-16.8-5.1-75.8-44.4-142.2-102.5-184.2-7.4-5.3-17.9-2.9-22.7 4.8L290.4 188c22.6 14.3 37.8 39.2 37.8 67.8zm-37.8 67.7c-12.3 7.7-26.8 12.4-42.4 12.4-15.6 0-30-4.7-42.4-12.4L125.2 452c-4.8 7.7-2.4 18.1 5.6 22.4C165.7 493.2 205.6 504 248 504s82.3-10.8 117.2-29.6c8-4.3 10.4-14.8 5.6-22.4l-80.4-128.5zM248 303.8c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48zm-231.8-48h151.6c0-28.6 15.2-53.5 37.8-67.7L125.2 59.7c-4.8-7.7-15.3-10.2-22.7-4.8C44.4 96.9 5.1 163.3 0 239.1c-.6 9 7.1 16.7 16.2 16.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRainbow(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M268.3 32.7C115.4 42.9 0 176.9 0 330.2V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320C64 186.8 180.9 80.3 317.5 97.9 430.4 112.4 512 214 512 327.8V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-165.3-140-298.6-307.7-287.3zm-5.6 96.9C166 142 96 229.1 96 326.7V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-74.8 64.5-134.8 140.8-127.4 66.5 6.5 115.2 66.2 115.2 133.1V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-114.2-100.2-205.4-217.3-190.4zm6.2 96.3c-45.6 8.9-76.9 51.5-76.9 97.9V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-17.6 14.3-32 32-32s32 14.4 32 32v144c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-59.2-53.8-106-115.1-94.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRandom(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504.971 359.029c9.373 9.373 9.373 24.569 0 33.941l-80 79.984c-15.01 15.01-40.971 4.49-40.971-16.971V416h-58.785a12.004 12.004 0 0 1-8.773-3.812l-70.556-75.596 53.333-57.143L352 336h32v-39.981c0-21.438 25.943-31.998 40.971-16.971l80 79.981zM12 176h84l52.781 56.551 53.333-57.143-70.556-75.596A11.999 11.999 0 0 0 122.785 96H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12zm372 0v39.984c0 21.46 25.961 31.98 40.971 16.971l80-79.984c9.373-9.373 9.373-24.569 0-33.941l-80-79.981C409.943 24.021 384 34.582 384 56.019V96h-58.785a12.004 12.004 0 0 0-8.773 3.812L96 336H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12h110.785c3.326 0 6.503-1.381 8.773-3.812L352 176h32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaReceipt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M358.4 3.2L320 48 265.6 3.2a15.9 15.9 0 0 0-19.2 0L192 48 137.6 3.2a15.9 15.9 0 0 0-19.2 0L64 48 25.6 3.2C15-4.7 0 2.8 0 16v480c0 13.2 15 20.7 25.6 12.8L64 464l54.4 44.8a15.9 15.9 0 0 0 19.2 0L192 464l54.4 44.8a15.9 15.9 0 0 0 19.2 0L320 464l38.4 44.8c10.5 7.9 25.6.4 25.6-12.8V16c0-13.2-15-20.7-25.6-12.8zM320 360c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRecordVinyl(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 152a104 104 0 1 0 104 104 104 104 0 0 0-104-104zm0 128a24 24 0 1 1 24-24 24 24 0 0 1-24 24zm0-272C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 376a128 128 0 1 1 128-128 128 128 0 0 1-128 128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRecycle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M184.561 261.903c3.232 13.997-12.123 24.635-24.068 17.168l-40.736-25.455-50.867 81.402C55.606 356.273 70.96 384 96.012 384H148c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12H96.115c-75.334 0-121.302-83.048-81.408-146.88l50.822-81.388-40.725-25.448c-12.081-7.547-8.966-25.961 4.879-29.158l110.237-25.45c8.611-1.988 17.201 3.381 19.189 11.99l25.452 110.237zm98.561-182.915l41.289 66.076-40.74 25.457c-12.051 7.528-9 25.953 4.879 29.158l110.237 25.45c8.672 1.999 17.215-3.438 19.189-11.99l25.45-110.237c3.197-13.844-11.99-24.719-24.068-17.168l-40.687 25.424-41.263-66.082c-37.521-60.033-125.209-60.171-162.816 0l-17.963 28.766c-3.51 5.62-1.8 13.021 3.82 16.533l33.919 21.195c5.62 3.512 13.024 1.803 16.536-3.817l17.961-28.743c12.712-20.341 41.973-19.676 54.257-.022zM497.288 301.12l-27.515-44.065c-3.511-5.623-10.916-7.334-16.538-3.821l-33.861 21.159c-5.62 3.512-7.33 10.915-3.818 16.536l27.564 44.112c13.257 21.211-2.057 48.96-27.136 48.96H320V336.02c0-14.213-17.242-21.383-27.313-11.313l-80 79.981c-6.249 6.248-6.249 16.379 0 22.627l80 79.989C302.689 517.308 320 510.3 320 495.989V448h95.88c75.274 0 121.335-82.997 81.408-146.88z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRedoAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256.455 8c66.269.119 126.437 26.233 170.859 68.685l35.715-35.715C478.149 25.851 504 36.559 504 57.941V192c0 13.255-10.745 24-24 24H345.941c-21.382 0-32.09-25.851-16.971-40.971l41.75-41.75c-30.864-28.899-70.801-44.907-113.23-45.273-92.398-.798-170.283 73.977-169.484 169.442C88.764 348.009 162.184 424 256 424c41.127 0 79.997-14.678 110.629-41.556 4.743-4.161 11.906-3.908 16.368.553l39.662 39.662c4.872 4.872 4.631 12.815-.482 17.433C378.202 479.813 319.926 504 256 504 119.034 504 8.001 392.967 8 256.002 7.999 119.193 119.646 7.755 256.455 8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRedo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M500.33 0h-47.41a12 12 0 0 0-12 12.57l4 82.76A247.42 247.42 0 0 0 256 8C119.34 8 7.9 119.53 8 256.19 8.1 393.07 119.1 504 256 504a247.1 247.1 0 0 0 166.18-63.91 12 12 0 0 0 .48-17.43l-34-34a12 12 0 0 0-16.38-.55A176 176 0 1 1 402.1 157.8l-101.53-4.87a12 12 0 0 0-12.57 12v47.41a12 12 0 0 0 12 12h200.33a12 12 0 0 0 12-12V12a12 12 0 0 0-12-12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegistered(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M285.363 207.475c0 18.6-9.831 28.431-28.431 28.431h-29.876v-56.14h23.378c28.668 0 34.929 8.773 34.929 27.709zM504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM363.411 360.414c-46.729-84.825-43.299-78.636-44.702-80.98 23.432-15.172 37.945-42.979 37.945-74.486 0-54.244-31.5-89.252-105.498-89.252h-70.667c-13.255 0-24 10.745-24 24V372c0 13.255 10.745 24 24 24h22.567c13.255 0 24-10.745 24-24v-71.663h25.556l44.129 82.937a24.001 24.001 0 0 0 21.188 12.727h24.464c18.261-.001 29.829-19.591 21.018-35.587z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRemoveFormat(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 416h-11.17l9.26-27.77L267 336.4 240.49 416H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm297.82 42.1L377 259.59 426.17 112H544v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16H176a16 16 0 0 0-16 16v43.9L45.46 3.38A16 16 0 0 0 23 6.19L3.37 31.46a16 16 0 0 0 2.81 22.45l588.36 454.72a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zM309.91 207.76L224 141.36V112h117.83z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaReplyAll(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M136.309 189.836L312.313 37.851C327.72 24.546 352 35.348 352 56.015v82.763c129.182 10.231 224 52.212 224 183.548 0 61.441-39.582 122.309-83.333 154.132-13.653 9.931-33.111-2.533-28.077-18.631 38.512-123.162-3.922-169.482-112.59-182.015v84.175c0 20.701-24.3 31.453-39.687 18.164L136.309 226.164c-11.071-9.561-11.086-26.753 0-36.328zm-128 36.328L184.313 378.15C199.7 391.439 224 380.687 224 359.986v-15.818l-108.606-93.785A55.96 55.96 0 0 1 96 207.998a55.953 55.953 0 0 1 19.393-42.38L224 71.832V56.015c0-20.667-24.28-31.469-39.687-18.164L8.309 189.836c-11.086 9.575-11.071 26.767 0 36.328z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaReply(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.309 189.836L184.313 37.851C199.719 24.546 224 35.347 224 56.015v80.053c160.629 1.839 288 34.032 288 186.258 0 61.441-39.581 122.309-83.333 154.132-13.653 9.931-33.111-2.533-28.077-18.631 45.344-145.012-21.507-183.51-176.59-185.742V360c0 20.7-24.3 31.453-39.687 18.164l-176.004-152c-11.071-9.562-11.086-26.753 0-36.328z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRepublican(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 192c0-88.4-71.6-160-160-160H160C71.6 32 0 103.6 0 192v64h544v-64zm-367.7-21.6l-19.8 19.3 4.7 27.3c.8 4.9-4.3 8.6-8.7 6.3L128 210.4l-24.5 12.9c-4.3 2.3-9.5-1.4-8.7-6.3l4.7-27.3-19.8-19.3c-3.6-3.5-1.6-9.5 3.3-10.2l27.4-4 12.2-24.8c2.2-4.5 8.6-4.4 10.7 0l12.2 24.8 27.4 4c5 .7 6.9 6.7 3.4 10.2zm144 0l-19.8 19.3 4.7 27.3c.8 4.9-4.3 8.6-8.7 6.3L272 210.4l-24.5 12.9c-4.3 2.3-9.5-1.4-8.7-6.3l4.7-27.3-19.8-19.3c-3.6-3.5-1.6-9.5 3.3-10.2l27.4-4 12.2-24.8c2.2-4.5 8.6-4.4 10.7 0l12.2 24.8 27.4 4c5 .7 6.9 6.7 3.4 10.2zm144 0l-19.8 19.3 4.7 27.3c.8 4.9-4.3 8.6-8.7 6.3L416 210.4l-24.5 12.9c-4.3 2.3-9.5-1.4-8.7-6.3l4.7-27.3-19.8-19.3c-3.6-3.5-1.6-9.5 3.3-10.2l27.4-4 12.2-24.8c2.2-4.5 8.6-4.4 10.7 0l12.2 24.8 27.4 4c5 .7 6.9 6.7 3.4 10.2zM624 320h-32c-8.8 0-16 7.2-16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V288H0v176c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16v-80h192v80c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V352h32v43.3c0 41.8 30 80.1 71.6 84.3 47.8 4.9 88.4-32.7 88.4-79.6v-64c0-8.8-7.2-16-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRestroom(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 128c35.3 0 64-28.7 64-64S163.3 0 128 0 64 28.7 64 64s28.7 64 64 64zm384 0c35.3 0 64-28.7 64-64S547.3 0 512 0s-64 28.7-64 64 28.7 64 64 64zm127.3 226.5l-45.6-185.8c-3.3-13.5-15.5-23-29.8-24.2-15 9.7-32.8 15.5-52 15.5-19.2 0-37-5.8-52-15.5-14.3 1.2-26.5 10.7-29.8 24.2l-45.6 185.8C381 369.6 393 384 409.2 384H464v104c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V384h54.8c16.2 0 28.2-14.4 24.5-29.5zM336 0h-32c-8.8 0-16 7.2-16 16v480c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16zM180.1 144.4c-15 9.8-32.9 15.6-52.1 15.6-19.2 0-37.1-5.8-52.1-15.6C51.3 146.5 32 166.9 32 192v136c0 13.3 10.7 24 24 24h8v136c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V352h8c13.3 0 24-10.7 24-24V192c0-25.1-19.3-45.5-43.9-47.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRetweet(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M629.657 343.598L528.971 444.284c-9.373 9.372-24.568 9.372-33.941 0L394.343 343.598c-9.373-9.373-9.373-24.569 0-33.941l10.823-10.823c9.562-9.562 25.133-9.34 34.419.492L480 342.118V160H292.451a24.005 24.005 0 0 1-16.971-7.029l-16-16C244.361 121.851 255.069 96 276.451 96H520c13.255 0 24 10.745 24 24v222.118l40.416-42.792c9.285-9.831 24.856-10.054 34.419-.492l10.823 10.823c9.372 9.372 9.372 24.569-.001 33.941zm-265.138 15.431A23.999 23.999 0 0 0 347.548 352H160V169.881l40.416 42.792c9.286 9.831 24.856 10.054 34.419.491l10.822-10.822c9.373-9.373 9.373-24.569 0-33.941L144.971 67.716c-9.373-9.373-24.569-9.373-33.941 0L10.343 168.402c-9.373 9.373-9.373 24.569 0 33.941l10.822 10.822c9.562 9.562 25.133 9.34 34.419-.491L96 169.881V392c0 13.255 10.745 24 24 24h243.549c21.382 0 32.09-25.851 16.971-40.971l-16.001-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRibbon(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.1 444.3c-9.6 10.8-7.5 27.6 4.5 35.7l68.8 27.9c9.9 6.7 23.3 5 31.3-3.8l91.8-101.9-79.2-87.9-117.2 130zm435.8 0s-292-324.6-295.4-330.1c15.4-8.4 40.2-17.9 77.5-17.9s62.1 9.5 77.5 17.9c-3.3 5.6-56 64.6-56 64.6l79.1 87.7 34.2-38c28.7-31.9 33.3-78.6 11.4-115.5l-43.7-73.5c-4.3-7.2-9.9-13.3-16.8-18-40.7-27.6-127.4-29.7-171.4 0-6.9 4.7-12.5 10.8-16.8 18l-43.6 73.2c-1.5 2.5-37.1 62.2 11.5 116L337.5 504c8 8.9 21.4 10.5 31.3 3.8l68.8-27.9c11.9-8 14-24.8 4.3-35.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRing(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 64C110.06 64 0 125.91 0 208v98.13C0 384.48 114.62 448 256 448s256-63.52 256-141.87V208c0-82.09-110.06-144-256-144zm0 64c106.04 0 192 35.82 192 80 0 9.26-3.97 18.12-10.91 26.39C392.15 208.21 328.23 192 256 192s-136.15 16.21-181.09 42.39C67.97 226.12 64 217.26 64 208c0-44.18 85.96-80 192-80zM120.43 264.64C155.04 249.93 201.64 240 256 240s100.96 9.93 135.57 24.64C356.84 279.07 308.93 288 256 288s-100.84-8.93-135.57-23.36z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRoad(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M573.19 402.67l-139.79-320C428.43 71.29 417.6 64 405.68 64h-97.59l2.45 23.16c.5 4.72-3.21 8.84-7.96 8.84h-29.16c-4.75 0-8.46-4.12-7.96-8.84L267.91 64h-97.59c-11.93 0-22.76 7.29-27.73 18.67L2.8 402.67C-6.45 423.86 8.31 448 30.54 448h196.84l10.31-97.68c.86-8.14 7.72-14.32 15.91-14.32h68.8c8.19 0 15.05 6.18 15.91 14.32L348.62 448h196.84c22.23 0 36.99-24.14 27.73-45.33zM260.4 135.16a8 8 0 0 1 7.96-7.16h39.29c4.09 0 7.53 3.09 7.96 7.16l4.6 43.58c.75 7.09-4.81 13.26-11.93 13.26h-40.54c-7.13 0-12.68-6.17-11.93-13.26l4.59-43.58zM315.64 304h-55.29c-9.5 0-16.91-8.23-15.91-17.68l5.07-48c.86-8.14 7.72-14.32 15.91-14.32h45.15c8.19 0 15.05 6.18 15.91 14.32l5.07 48c1 9.45-6.41 17.68-15.91 17.68z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRobot(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32,224H64V416H32A31.96166,31.96166,0,0,1,0,384V256A31.96166,31.96166,0,0,1,32,224Zm512-48V448a64.06328,64.06328,0,0,1-64,64H160a64.06328,64.06328,0,0,1-64-64V176a79.974,79.974,0,0,1,80-80H288V32a32,32,0,0,1,64,0V96H464A79.974,79.974,0,0,1,544,176ZM264,256a40,40,0,1,0-40,40A39.997,39.997,0,0,0,264,256Zm-8,128H192v32h64Zm96,0H288v32h64ZM456,256a40,40,0,1,0-40,40A39.997,39.997,0,0,0,456,256Zm-8,128H384v32h64ZM640,256V384a31.96166,31.96166,0,0,1-32,32H576V224h32A31.96166,31.96166,0,0,1,640,256Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRocket(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M505.12019,19.09375c-1.18945-5.53125-6.65819-11-12.207-12.1875C460.716,0,435.507,0,410.40747,0,307.17523,0,245.26909,55.20312,199.05238,128H94.83772c-16.34763.01562-35.55658,11.875-42.88664,26.48438L2.51562,253.29688A28.4,28.4,0,0,0,0,264a24.00867,24.00867,0,0,0,24.00582,24H127.81618l-22.47457,22.46875c-11.36521,11.36133-12.99607,32.25781,0,45.25L156.24582,406.625c11.15623,11.1875,32.15619,13.15625,45.27726,0l22.47457-22.46875V488a24.00867,24.00867,0,0,0,24.00581,24,28.55934,28.55934,0,0,0,10.707-2.51562l98.72834-49.39063c14.62888-7.29687,26.50776-26.5,26.50776-42.85937V312.79688c72.59753-46.3125,128.03493-108.40626,128.03493-211.09376C512.07526,76.5,512.07526,51.29688,505.12019,19.09375ZM384.04033,168A40,40,0,1,1,424.05,128,40.02322,40.02322,0,0,1,384.04033,168Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRoute(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 320h-96c-17.6 0-32-14.4-32-32s14.4-32 32-32h96s96-107 96-160-43-96-96-96-96 43-96 96c0 25.5 22.2 63.4 45.3 96H320c-52.9 0-96 43.1-96 96s43.1 96 96 96h96c17.6 0 32 14.4 32 32s-14.4 32-32 32H185.5c-16 24.8-33.8 47.7-47.3 64H416c52.9 0 96-43.1 96-96s-43.1-96-96-96zm0-256c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zM96 256c-53 0-96 43-96 96s96 160 96 160 96-107 96-160-43-96-96-96zm0 128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRssSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM112 416c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm157.533 0h-34.335c-6.011 0-11.051-4.636-11.442-10.634-5.214-80.05-69.243-143.92-149.123-149.123-5.997-.39-10.633-5.431-10.633-11.441v-34.335c0-6.535 5.468-11.777 11.994-11.425 110.546 5.974 198.997 94.536 204.964 204.964.352 6.526-4.89 11.994-11.425 11.994zm103.027 0h-34.334c-6.161 0-11.175-4.882-11.427-11.038-5.598-136.535-115.204-246.161-251.76-251.76C68.882 152.949 64 147.935 64 141.774V107.44c0-6.454 5.338-11.664 11.787-11.432 167.83 6.025 302.21 141.191 308.205 308.205.232 6.449-4.978 11.787-11.432 11.787z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRss(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128.081 415.959c0 35.369-28.672 64.041-64.041 64.041S0 451.328 0 415.959s28.672-64.041 64.041-64.041 64.04 28.673 64.04 64.041zm175.66 47.25c-8.354-154.6-132.185-278.587-286.95-286.95C7.656 175.765 0 183.105 0 192.253v48.069c0 8.415 6.49 15.472 14.887 16.018 111.832 7.284 201.473 96.702 208.772 208.772.547 8.397 7.604 14.887 16.018 14.887h48.069c9.149.001 16.489-7.655 15.995-16.79zm144.249.288C439.596 229.677 251.465 40.445 16.503 32.01 7.473 31.686 0 38.981 0 48.016v48.068c0 8.625 6.835 15.645 15.453 15.999 191.179 7.839 344.627 161.316 352.465 352.465.353 8.618 7.373 15.453 15.999 15.453h48.068c9.034-.001 16.329-7.474 16.005-16.504z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRubleSign(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M239.36 320C324.48 320 384 260.542 384 175.071S324.48 32 239.36 32H76c-6.627 0-12 5.373-12 12v206.632H12c-6.627 0-12 5.373-12 12V308c0 6.627 5.373 12 12 12h52v32H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h52v52c0 6.627 5.373 12 12 12h58.56c6.627 0 12-5.373 12-12v-52H308c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12H146.56v-32h92.8zm-92.8-219.252h78.72c46.72 0 74.88 29.11 74.88 74.323 0 45.832-28.16 75.561-76.16 75.561h-77.44V100.748z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRulerCombined(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 288h-56c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h56v-64h-56c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h56V96h-56c-4.42 0-8-3.58-8-8V72c0-4.42 3.58-8 8-8h56V32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v448c0 2.77.91 5.24 1.57 7.8L160 329.38V288zm320 64h-32v56c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-56h-64v56c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-56h-64v56c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-56h-41.37L24.2 510.43c2.56.66 5.04 1.57 7.8 1.57h448c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRulerHorizontal(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 128h-48v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8H88c-4.42 0-8-3.58-8-8v-88H32c-17.67 0-32 14.33-32 32v192c0 17.67 14.33 32 32 32h512c17.67 0 32-14.33 32-32V160c0-17.67-14.33-32-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRulerVertical(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M168 416c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88v-64h-88c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88v-64h-88c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88v-64h-88c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88V32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v448c0 17.67 14.33 32 32 32h192c17.67 0 32-14.33 32-32v-64h-88z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRuler(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M635.7 167.2L556.1 31.7c-8.8-15-28.3-20.1-43.5-11.5l-69 39.1L503.3 161c2.2 3.8.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9L416 75l-55.2 31.3 27.9 47.4c2.2 3.8.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9L333.2 122 278 153.3 337.8 255c2.2 3.7.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9l-59.7-101.7-55.2 31.3 27.9 47.4c2.2 3.8.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9l-27.9-47.5-55.2 31.3 59.7 101.7c2.2 3.7.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9L84.9 262.9l-69 39.1C.7 310.7-4.6 329.8 4.2 344.8l79.6 135.6c8.8 15 28.3 20.1 43.5 11.5L624.1 210c15.2-8.6 20.4-27.8 11.6-42.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRunning(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 416 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272 96c26.51 0 48-21.49 48-48S298.51 0 272 0s-48 21.49-48 48 21.49 48 48 48zM113.69 317.47l-14.8 34.52H32c-17.67 0-32 14.33-32 32s14.33 32 32 32h77.45c19.25 0 36.58-11.44 44.11-29.09l8.79-20.52-10.67-6.3c-17.32-10.23-30.06-25.37-37.99-42.61zM384 223.99h-44.03l-26.06-53.25c-12.5-25.55-35.45-44.23-61.78-50.94l-71.08-21.14c-28.3-6.8-57.77-.55-80.84 17.14l-39.67 30.41c-14.03 10.75-16.69 30.83-5.92 44.86s30.84 16.66 44.86 5.92l39.69-30.41c7.67-5.89 17.44-8 25.27-6.14l14.7 4.37-37.46 87.39c-12.62 29.48-1.31 64.01 26.3 80.31l84.98 50.17-27.47 87.73c-5.28 16.86 4.11 34.81 20.97 40.09 3.19 1 6.41 1.48 9.58 1.48 13.61 0 26.23-8.77 30.52-22.45l31.64-101.06c5.91-20.77-2.89-43.08-21.64-54.39l-61.24-36.14 31.31-78.28 20.27 41.43c8 16.34 24.92 26.89 43.11 26.89H384c17.67 0 32-14.33 32-32s-14.33-31.99-32-31.99z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRupeeSign(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M308 96c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12H12C5.373 32 0 37.373 0 44v44.748c0 6.627 5.373 12 12 12h85.28c27.308 0 48.261 9.958 60.97 27.252H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h158.757c-6.217 36.086-32.961 58.632-74.757 58.632H12c-6.627 0-12 5.373-12 12v53.012c0 3.349 1.4 6.546 3.861 8.818l165.052 152.356a12.001 12.001 0 0 0 8.139 3.182h82.562c10.924 0 16.166-13.408 8.139-20.818L116.871 319.906c76.499-2.34 131.144-53.395 138.318-127.906H308c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-58.69c-3.486-11.541-8.28-22.246-14.252-32H308z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSadCry(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256c0 90.1 48.2 168.7 120 212.1V288c0-8.8 7.2-16 16-16s16 7.2 16 16v196.7c29.5 12.4 62 19.3 96 19.3s66.5-6.9 96-19.3V288c0-8.8 7.2-16 16-16s16 7.2 16 16v180.1C447.8 424.7 496 346 496 256 496 119 385 8 248 8zm-65.5 216.5c-14.8-13.2-46.2-13.2-61 0L112 233c-3.8 3.3-9.3 4-13.7 1.6-4.4-2.4-6.9-7.4-6.1-12.4 4-25.2 34.2-42.1 59.9-42.1S208 197 212 222.2c.8 5-1.7 10-6.1 12.4-5.8 3.1-11.2.7-13.7-1.6l-9.7-8.5zM248 416c-26.5 0-48-28.7-48-64s21.5-64 48-64 48 28.7 48 64-21.5 64-48 64zm149.8-181.5c-5.8 3.1-11.2.7-13.7-1.6l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L304 233c-3.8 3.3-9.3 4-13.7 1.6-4.4-2.4-6.9-7.4-6.1-12.4 4-25.2 34.2-42.1 59.9-42.1S400 197 404 222.2c.6 4.9-1.8 9.9-6.2 12.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSadTear(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zM152 416c-26.5 0-48-21-48-47 0-20 28.5-60.4 41.6-77.8 3.2-4.3 9.6-4.3 12.8 0C171.5 308.6 200 349 200 369c0 26-21.5 47-48 47zm16-176c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm170.2 154.2C315.8 367.4 282.9 352 248 352c-21.2 0-21.2-32 0-32 44.4 0 86.3 19.6 114.7 53.8 13.8 16.4-11.2 36.5-24.5 20.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSatelliteDish(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M305.44954,462.59c7.39157,7.29792,6.18829,20.09661-3.00038,25.00356-77.713,41.80281-176.72559,29.9105-242.34331-35.7082C-5.49624,386.28227-17.404,287.362,24.41381,209.554c4.89125-9.095,17.68975-10.29834,25.00318-3.00043L166.22872,323.36708l27.39411-27.39452c-.68759-2.60974-1.594-5.00071-1.594-7.81361a32.00407,32.00407,0,1,1,32.00407,32.00455c-2.79723,0-5.20378-.89075-7.79786-1.594l-27.40974,27.41015ZM511.9758,303.06732a16.10336,16.10336,0,0,1-16.002,17.00242H463.86031a15.96956,15.96956,0,0,1-15.89265-15.00213C440.46671,175.5492,336.45348,70.53427,207.03078,63.53328a15.84486,15.84486,0,0,1-15.00191-15.90852V16.02652A16.09389,16.09389,0,0,1,209.031.02425C372.25491,8.61922,503.47472,139.841,511.9758,303.06732Zm-96.01221-.29692a16.21093,16.21093,0,0,1-16.11142,17.29934H367.645a16.06862,16.06862,0,0,1-15.89265-14.70522c-6.90712-77.01094-68.118-138.91037-144.92467-145.22376a15.94,15.94,0,0,1-14.79876-15.89289V112.13393a16.134,16.134,0,0,1,17.29908-16.096C319.45132,104.5391,407.55627,192.64538,415.96359,302.7704Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSatellite(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M502.60969,310.04206l-96.70393,96.71625a31.88151,31.88151,0,0,1-45.00765,0L280.572,326.34115l-9.89231,9.90759a190.56343,190.56343,0,0,1-5.40716,168.52287c-4.50077,8.50115-16.39342,9.59505-23.20707,2.79725L134.54715,400.05428l-17.7999,17.79929c.70324,2.60972,1.60965,5.00067,1.60965,7.79793a32.00544,32.00544,0,1,1-32.00544-32.00434c2.79735,0,5.18838.90637,7.7982,1.60959l17.7999-17.79929L4.43129,269.94287c-6.798-6.81342-5.70409-18.6119,2.79735-23.20627a190.58161,190.58161,0,0,1,168.52864-5.407l9.79854-9.79821-80.31053-80.41716a32.002,32.002,0,0,1,0-45.09987L201.96474,9.29814A31.62639,31.62639,0,0,1,224.46868,0a31.99951,31.99951,0,0,1,22.59759,9.29814l80.32615,80.30777,47.805-47.89713a33.6075,33.6075,0,0,1,47.50808,0l47.50807,47.50645a33.63308,33.63308,0,0,1,0,47.50644l-47.805,47.89713L502.71908,265.036A31.78938,31.78938,0,0,1,502.60969,310.04206ZM219.56159,197.433l73.82505-73.82252-68.918-68.9-73.80942,73.80689Zm237.74352,90.106-68.90233-68.9156-73.825,73.82252,68.918,68.9Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSave(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M433.941 129.941l-83.882-83.882A48 48 0 0 0 316.118 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V163.882a48 48 0 0 0-14.059-33.941zM224 416c-35.346 0-64-28.654-64-64 0-35.346 28.654-64 64-64s64 28.654 64 64c0 35.346-28.654 64-64 64zm96-304.52V212c0 6.627-5.373 12-12 12H76c-6.627 0-12-5.373-12-12V108c0-6.627 5.373-12 12-12h228.52c3.183 0 6.235 1.264 8.485 3.515l3.48 3.48A11.996 11.996 0 0 1 320 111.48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSchool(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 224v272c0 8.84 7.16 16 16 16h80V192H32c-17.67 0-32 14.33-32 32zm360-48h-24v-40c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v64c0 4.42 3.58 8 8 8h48c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zm137.75-63.96l-160-106.67a32.02 32.02 0 0 0-35.5 0l-160 106.67A32.002 32.002 0 0 0 128 138.66V512h128V368c0-8.84 7.16-16 16-16h96c8.84 0 16 7.16 16 16v144h128V138.67c0-10.7-5.35-20.7-14.25-26.63zM320 256c-44.18 0-80-35.82-80-80s35.82-80 80-80 80 35.82 80 80-35.82 80-80 80zm288-64h-64v320h80c8.84 0 16-7.16 16-16V224c0-17.67-14.33-32-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaScrewdriver(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 0L320 96v62.06l-83.03 83.03c6.79 4.25 13.27 9.06 19.07 14.87 5.8 5.8 10.62 12.28 14.87 19.07L353.94 192H416l96-128-64-64zM128 278.59L10.92 395.67c-14.55 14.55-14.55 38.15 0 52.71l52.7 52.7c14.56 14.56 38.15 14.56 52.71 0L233.41 384c29.11-29.11 29.11-76.3 0-105.41s-76.3-29.11-105.41 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaScroll(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 0C21.53 0 0 21.53 0 48v64c0 8.84 7.16 16 16 16h80V48C96 21.53 74.47 0 48 0zm208 412.57V352h288V96c0-52.94-43.06-96-96-96H111.59C121.74 13.41 128 29.92 128 48v368c0 38.87 34.65 69.65 74.75 63.12C234.22 474 256 444.46 256 412.57zM288 384v32c0 52.93-43.06 96-96 96h336c61.86 0 112-50.14 112-112 0-8.84-7.16-16-16-16H288z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSdCard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 0H128L0 128v320c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zM160 160h-48V64h48v96zm80 0h-48V64h48v96zm80 0h-48V64h48v96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSearchDollar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M505.04 442.66l-99.71-99.69c-4.5-4.5-10.6-7-17-7h-16.3c27.6-35.3 44-79.69 44-127.99C416.03 93.09 322.92 0 208.02 0S0 93.09 0 207.98s93.11 207.98 208.02 207.98c48.3 0 92.71-16.4 128.01-44v16.3c0 6.4 2.5 12.5 7 17l99.71 99.69c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.59.1-33.99zm-297.02-90.7c-79.54 0-144-64.34-144-143.98 0-79.53 64.35-143.98 144-143.98 79.54 0 144 64.34 144 143.98 0 79.53-64.35 143.98-144 143.98zm27.11-152.54l-45.01-13.5c-5.16-1.55-8.77-6.78-8.77-12.73 0-7.27 5.3-13.19 11.8-13.19h28.11c4.56 0 8.96 1.29 12.82 3.72 3.24 2.03 7.36 1.91 10.13-.73l11.75-11.21c3.53-3.37 3.33-9.21-.57-12.14-9.1-6.83-20.08-10.77-31.37-11.35V112c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v16.12c-23.63.63-42.68 20.55-42.68 45.07 0 19.97 12.99 37.81 31.58 43.39l45.01 13.5c5.16 1.55 8.77 6.78 8.77 12.73 0 7.27-5.3 13.19-11.8 13.19h-28.1c-4.56 0-8.96-1.29-12.82-3.72-3.24-2.03-7.36-1.91-10.13.73l-11.75 11.21c-3.53 3.37-3.33 9.21.57 12.14 9.1 6.83 20.08 10.77 31.37 11.35V304c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-16.12c23.63-.63 42.68-20.54 42.68-45.07 0-19.97-12.99-37.81-31.59-43.39z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSearchLocation(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M505.04 442.66l-99.71-99.69c-4.5-4.5-10.6-7-17-7h-16.3c27.6-35.3 44-79.69 44-127.99C416.03 93.09 322.92 0 208.02 0S0 93.09 0 207.98s93.11 207.98 208.02 207.98c48.3 0 92.71-16.4 128.01-44v16.3c0 6.4 2.5 12.5 7 17l99.71 99.69c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.59.1-33.99zm-297.02-90.7c-79.54 0-144-64.34-144-143.98 0-79.53 64.35-143.98 144-143.98 79.54 0 144 64.34 144 143.98 0 79.53-64.35 143.98-144 143.98zm.02-239.96c-40.78 0-73.84 33.05-73.84 73.83 0 32.96 48.26 93.05 66.75 114.86a9.24 9.24 0 0 0 14.18 0c18.49-21.81 66.75-81.89 66.75-114.86 0-40.78-33.06-73.83-73.84-73.83zm0 96c-13.26 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSearchMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304 192v32c0 6.6-5.4 12-12 12H124c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm201 284.7L476.7 505c-9.4 9.4-24.6 9.4-33.9 0L343 405.3c-4.5-4.5-7-10.6-7-17V372c-35.3 27.6-79.7 44-128 44C93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208c0 48.3-16.4 92.7-44 128h16.3c6.4 0 12.5 2.5 17 7l99.7 99.7c9.3 9.4 9.3 24.6 0 34zM344 208c0-75.2-60.8-136-136-136S72 132.8 72 208s60.8 136 136 136 136-60.8 136-136z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSearchPlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304 192v32c0 6.6-5.4 12-12 12h-56v56c0 6.6-5.4 12-12 12h-32c-6.6 0-12-5.4-12-12v-56h-56c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h56v-56c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v56h56c6.6 0 12 5.4 12 12zm201 284.7L476.7 505c-9.4 9.4-24.6 9.4-33.9 0L343 405.3c-4.5-4.5-7-10.6-7-17V372c-35.3 27.6-79.7 44-128 44C93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208c0 48.3-16.4 92.7-44 128h16.3c6.4 0 12.5 2.5 17 7l99.7 99.7c9.3 9.4 9.3 24.6 0 34zM344 208c0-75.2-60.8-136-136-136S72 132.8 72 208s60.8 136 136 136 136-60.8 136-136z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSearch(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSeedling(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 96H0c0 123.7 100.3 224 224 224v144c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320C288 196.3 187.7 96 64 96zm384-64c-84.2 0-157.4 46.5-195.7 115.2 27.7 30.2 48.2 66.9 59 107.6C424 243.1 512 147.9 512 32h-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaServer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 160H32c-17.673 0-32-14.327-32-32V64c0-17.673 14.327-32 32-32h448c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32zm-48-88c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm112 248H32c-17.673 0-32-14.327-32-32v-64c0-17.673 14.327-32 32-32h448c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32zm-48-88c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm112 248H32c-17.673 0-32-14.327-32-32v-64c0-17.673 14.327-32 32-32h448c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32zm-48-88c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaShapes(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128,256A128,128,0,1,0,256,384,128,128,0,0,0,128,256Zm379-54.86L400.07,18.29a37.26,37.26,0,0,0-64.14,0L229,201.14C214.76,225.52,232.58,256,261.09,256H474.91C503.42,256,521.24,225.52,507,201.14ZM480,288H320a32,32,0,0,0-32,32V480a32,32,0,0,0,32,32H480a32,32,0,0,0,32-32V320A32,32,0,0,0,480,288Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaShareAltSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zM304 296c-14.562 0-27.823 5.561-37.783 14.671l-67.958-40.775a56.339 56.339 0 0 0 0-27.793l67.958-40.775C276.177 210.439 289.438 216 304 216c30.928 0 56-25.072 56-56s-25.072-56-56-56-56 25.072-56 56c0 4.797.605 9.453 1.74 13.897l-67.958 40.775C171.823 205.561 158.562 200 144 200c-30.928 0-56 25.072-56 56s25.072 56 56 56c14.562 0 27.823-5.561 37.783-14.671l67.958 40.775a56.088 56.088 0 0 0-1.74 13.897c0 30.928 25.072 56 56 56s56-25.072 56-56C360 321.072 334.928 296 304 296z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaShareAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 320c-22.608 0-43.387 7.819-59.79 20.895l-102.486-64.054a96.551 96.551 0 0 0 0-41.683l102.486-64.054C308.613 184.181 329.392 192 352 192c53.019 0 96-42.981 96-96S405.019 0 352 0s-96 42.981-96 96c0 7.158.79 14.13 2.276 20.841L155.79 180.895C139.387 167.819 118.608 160 96 160c-53.019 0-96 42.981-96 96s42.981 96 96 96c22.608 0 43.387-7.819 59.79-20.895l102.486 64.054A96.301 96.301 0 0 0 256 416c0 53.019 42.981 96 96 96s96-42.981 96-96-42.981-96-96-96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaShareSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M568.482 177.448L424.479 313.433C409.3 327.768 384 317.14 384 295.985v-71.963c-144.575.97-205.566 35.113-164.775 171.353 4.483 14.973-12.846 26.567-25.006 17.33C155.252 383.105 120 326.488 120 269.339c0-143.937 117.599-172.5 264-173.312V24.012c0-21.174 25.317-31.768 40.479-17.448l144.003 135.988c10.02 9.463 10.028 25.425 0 34.896zM384 379.128V448H64V128h50.916a11.99 11.99 0 0 0 8.648-3.693c14.953-15.568 32.237-27.89 51.014-37.676C185.708 80.83 181.584 64 169.033 64H48C21.49 64 0 85.49 0 112v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48v-88.806c0-8.288-8.197-14.066-16.011-11.302a71.83 71.83 0 0 1-34.189 3.377c-7.27-1.046-13.8 4.514-13.8 11.859z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaShare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M503.691 189.836L327.687 37.851C312.281 24.546 288 35.347 288 56.015v80.053C127.371 137.907 0 170.1 0 322.326c0 61.441 39.581 122.309 83.333 154.132 13.653 9.931 33.111-2.533 28.077-18.631C66.066 312.814 132.917 274.316 288 272.085V360c0 20.7 24.3 31.453 39.687 18.164l176.004-152c11.071-9.562 11.086-26.753 0-36.328z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaShekelSign(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 168v168c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V168c0-75.11-60.89-136-136-136H24C10.75 32 0 42.74 0 56v408c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V112h112c30.93 0 56 25.07 56 56zM432 32h-48c-8.84 0-16 7.16-16 16v296c0 30.93-25.07 56-56 56H200V176c0-8.84-7.16-16-16-16h-48c-8.84 0-16 7.16-16 16v280c0 13.25 10.75 24 24 24h168c75.11 0 136-60.89 136-136V48c0-8.84-7.16-16-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaShieldAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M466.5 83.7l-192-80a48.15 48.15 0 0 0-36.9 0l-192 80C27.7 91.1 16 108.6 16 128c0 198.5 114.5 335.7 221.5 380.3 11.8 4.9 25.1 4.9 36.9 0C360.1 472.6 496 349.3 496 128c0-19.4-11.7-36.9-29.5-44.3zM256.1 446.3l-.1-381 175.9 73.3c-3.3 151.4-82.1 261.1-175.8 307.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaShieldVirus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224,192a16,16,0,1,0,16,16A16,16,0,0,0,224,192ZM466.5,83.68l-192-80A57.4,57.4,0,0,0,256.05,0a57.4,57.4,0,0,0-18.46,3.67l-192,80A47.93,47.93,0,0,0,16,128C16,326.5,130.5,463.72,237.5,508.32a48.09,48.09,0,0,0,36.91,0C360.09,472.61,496,349.3,496,128A48,48,0,0,0,466.5,83.68ZM384,256H371.88c-28.51,0-42.79,34.47-22.63,54.63l8.58,8.57a16,16,0,1,1-22.63,22.63l-8.57-8.58C306.47,313.09,272,327.37,272,355.88V368a16,16,0,0,1-32,0V355.88c0-28.51-34.47-42.79-54.63-22.63l-8.57,8.58a16,16,0,0,1-22.63-22.63l8.58-8.57c20.16-20.16,5.88-54.63-22.63-54.63H128a16,16,0,0,1,0-32h12.12c28.51,0,42.79-34.47,22.63-54.63l-8.58-8.57a16,16,0,0,1,22.63-22.63l8.57,8.58c20.16,20.16,54.63,5.88,54.63-22.63V112a16,16,0,0,1,32,0v12.12c0,28.51,34.47,42.79,54.63,22.63l8.57-8.58a16,16,0,0,1,22.63,22.63l-8.58,8.57C329.09,189.53,343.37,224,371.88,224H384a16,16,0,0,1,0,32Zm-96,0a16,16,0,1,0,16,16A16,16,0,0,0,288,256Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaShip(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496.616 372.639l70.012-70.012c16.899-16.9 9.942-45.771-12.836-53.092L512 236.102V96c0-17.673-14.327-32-32-32h-64V24c0-13.255-10.745-24-24-24H248c-13.255 0-24 10.745-24 24v40h-64c-17.673 0-32 14.327-32 32v140.102l-41.792 13.433c-22.753 7.313-29.754 36.173-12.836 53.092l70.012 70.012C125.828 416.287 85.587 448 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24 61.023 0 107.499-20.61 143.258-59.396C181.677 487.432 216.021 512 256 512h128c39.979 0 74.323-24.568 88.742-59.396C508.495 491.384 554.968 512 616 512c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24-60.817 0-101.542-31.001-119.384-75.361zM192 128h256v87.531l-118.208-37.995a31.995 31.995 0 0 0-19.584 0L192 215.531V128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaShippingFast(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H112C85.5 0 64 21.5 64 48v48H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h272c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H40c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h208c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h208c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H64v128c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm320 0c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaShoePrints(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 160h32V32h-32c-35.35 0-64 28.65-64 64s28.65 64 64 64zM0 416c0 35.35 28.65 64 64 64h32V352H64c-35.35 0-64 28.65-64 64zm337.46-128c-34.91 0-76.16 13.12-104.73 32-24.79 16.38-44.52 32-104.73 32v128l57.53 15.97c26.21 7.28 53.01 13.12 80.31 15.05 32.69 2.31 65.6.67 97.58-6.2C472.9 481.3 512 429.22 512 384c0-64-84.18-96-174.54-96zM491.42 7.19C459.44.32 426.53-1.33 393.84.99c-27.3 1.93-54.1 7.77-80.31 15.04L256 32v128c60.2 0 79.94 15.62 104.73 32 28.57 18.88 69.82 32 104.73 32C555.82 224 640 192 640 128c0-45.22-39.1-97.3-148.58-120.81z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaShoppingBag(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 160v-32C352 57.42 294.579 0 224 0 153.42 0 96 57.42 96 128v32H0v272c0 44.183 35.817 80 80 80h288c44.183 0 80-35.817 80-80V160h-96zm-192-32c0-35.29 28.71-64 64-64s64 28.71 64 64v32H160v-32zm160 120c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24zm-192 0c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaShoppingBasket(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M576 216v16c0 13.255-10.745 24-24 24h-8l-26.113 182.788C514.509 462.435 494.257 480 470.37 480H105.63c-23.887 0-44.139-17.565-47.518-41.212L32 256h-8c-13.255 0-24-10.745-24-24v-16c0-13.255 10.745-24 24-24h67.341l106.78-146.821c10.395-14.292 30.407-17.453 44.701-7.058 14.293 10.395 17.453 30.408 7.058 44.701L170.477 192h235.046L326.12 82.821c-10.395-14.292-7.234-34.306 7.059-44.701 14.291-10.395 34.306-7.235 44.701 7.058L484.659 192H552c13.255 0 24 10.745 24 24zM312 392V280c0-13.255-10.745-24-24-24s-24 10.745-24 24v112c0 13.255 10.745 24 24 24s24-10.745 24-24zm112 0V280c0-13.255-10.745-24-24-24s-24 10.745-24 24v112c0 13.255 10.745 24 24 24s24-10.745 24-24zm-224 0V280c0-13.255-10.745-24-24-24s-24 10.745-24 24v112c0 13.255 10.745 24 24 24s24-10.745 24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaShoppingCart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528.12 301.319l47.273-208C578.806 78.301 567.391 64 551.99 64H159.208l-9.166-44.81C147.758 8.021 137.93 0 126.529 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24h69.883l70.248 343.435C147.325 417.1 136 435.222 136 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-15.674-6.447-29.835-16.824-40h209.647C430.447 426.165 424 440.326 424 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-22.172-12.888-41.332-31.579-50.405l5.517-24.276c3.413-15.018-8.002-29.319-23.403-29.319H218.117l-6.545-32h293.145c11.206 0 20.92-7.754 23.403-18.681z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaShower(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304,320a16,16,0,1,0,16,16A16,16,0,0,0,304,320Zm32-96a16,16,0,1,0,16,16A16,16,0,0,0,336,224Zm32,64a16,16,0,1,0-16-16A16,16,0,0,0,368,288Zm-32,32a16,16,0,1,0-16-16A16,16,0,0,0,336,320Zm-32-64a16,16,0,1,0,16,16A16,16,0,0,0,304,256Zm128-32a16,16,0,1,0-16-16A16,16,0,0,0,432,224Zm-48,16a16,16,0,1,0,16-16A16,16,0,0,0,384,240Zm-16-48a16,16,0,1,0,16,16A16,16,0,0,0,368,192Zm96,32a16,16,0,1,0,16,16A16,16,0,0,0,464,224Zm32-32a16,16,0,1,0,16,16A16,16,0,0,0,496,192Zm-64,64a16,16,0,1,0,16,16A16,16,0,0,0,432,256Zm-32,32a16,16,0,1,0,16,16A16,16,0,0,0,400,288Zm-64,64a16,16,0,1,0,16,16A16,16,0,0,0,336,352Zm-32,32a16,16,0,1,0,16,16A16,16,0,0,0,304,384Zm64-64a16,16,0,1,0,16,16A16,16,0,0,0,368,320Zm21.65-218.35-11.3-11.31a16,16,0,0,0-22.63,0L350.05,96A111.19,111.19,0,0,0,272,64c-19.24,0-37.08,5.3-52.9,13.85l-10-10A121.72,121.72,0,0,0,123.44,32C55.49,31.5,0,92.91,0,160.85V464a16,16,0,0,0,16,16H48a16,16,0,0,0,16-16V158.4c0-30.15,21-58.2,51-61.93a58.38,58.38,0,0,1,48.93,16.67l10,10C165.3,138.92,160,156.76,160,176a111.23,111.23,0,0,0,32,78.05l-5.66,5.67a16,16,0,0,0,0,22.62l11.3,11.31a16,16,0,0,0,22.63,0L389.65,124.28A16,16,0,0,0,389.65,101.65Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaShuttleVan(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M628.88 210.65L494.39 49.27A48.01 48.01 0 0 0 457.52 32H32C14.33 32 0 46.33 0 64v288c0 17.67 14.33 32 32 32h32c0 53.02 42.98 96 96 96s96-42.98 96-96h128c0 53.02 42.98 96 96 96s96-42.98 96-96h32c17.67 0 32-14.33 32-32V241.38c0-11.23-3.94-22.1-11.12-30.73zM64 192V96h96v96H64zm96 240c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm160-240h-96V96h96v96zm160 240c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm-96-240V96h66.02l80 96H384z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSignInAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 448h-84c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h84c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32h-84c-6.6 0-12-5.4-12-12V76c0-6.6 5.4-12 12-12h84c53 0 96 43 96 96v192c0 53-43 96-96 96zm-47-201L201 79c-15-15-41-4.5-41 17v96H24c-13.3 0-24 10.7-24 24v96c0 13.3 10.7 24 24 24h136v96c0 21.5 26 32 41 17l168-168c9.3-9.4 9.3-24.6 0-34z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSignLanguage(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M91.434 483.987c-.307-16.018 13.109-29.129 29.13-29.129h62.293v-5.714H56.993c-16.021 0-29.437-13.111-29.13-29.129C28.16 404.491 40.835 392 56.428 392h126.429v-5.714H29.136c-16.021 0-29.437-13.111-29.13-29.129.297-15.522 12.973-28.013 28.566-28.013h154.286v-5.714H57.707c-16.021 0-29.437-13.111-29.13-29.129.297-15.522 12.973-28.013 28.566-28.013h168.566l-31.085-22.606c-12.762-9.281-15.583-27.149-6.302-39.912 9.281-12.761 27.15-15.582 39.912-6.302l123.361 89.715a34.287 34.287 0 0 1 14.12 27.728v141.136c0 15.91-10.946 29.73-26.433 33.374l-80.471 18.934a137.16 137.16 0 0 1-31.411 3.646H120c-15.593-.001-28.269-12.492-28.566-28.014zm73.249-225.701h36.423l-11.187-8.136c-18.579-13.511-20.313-40.887-3.17-56.536l-13.004-16.7c-9.843-12.641-28.43-15.171-40.88-5.088-12.065 9.771-14.133 27.447-4.553 39.75l36.371 46.71zm283.298-2.103l-5.003-152.452c-.518-15.771-13.722-28.136-29.493-27.619-15.773.518-28.137 13.722-27.619 29.493l1.262 38.415L283.565 11.019c-9.58-12.303-27.223-14.63-39.653-5.328-12.827 9.599-14.929 28.24-5.086 40.881l76.889 98.745-4.509 3.511-94.79-121.734c-9.58-12.303-27.223-14.63-39.653-5.328-12.827 9.599-14.929 28.24-5.086 40.881l94.443 121.288-4.509 3.511-77.675-99.754c-9.58-12.303-27.223-14.63-39.653-5.328-12.827 9.599-14.929 28.24-5.086 40.881l52.053 66.849c12.497-8.257 29.055-8.285 41.69.904l123.36 89.714c10.904 7.93 17.415 20.715 17.415 34.198v16.999l61.064-47.549a34.285 34.285 0 0 0 13.202-28.177z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSignOutAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M497 273L329 441c-15 15-41 4.5-41-17v-96H152c-13.3 0-24-10.7-24-24v-96c0-13.3 10.7-24 24-24h136V88c0-21.4 25.9-32 41-17l168 168c9.3 9.4 9.3 24.6 0 34zM192 436v-40c0-6.6-5.4-12-12-12H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h84c6.6 0 12-5.4 12-12V76c0-6.6-5.4-12-12-12H96c-53 0-96 43-96 96v192c0 53 43 96 96 96h84c6.6 0 12-5.4 12-12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSign(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 64H128V16c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16v48H16C7.2 64 0 71.2 0 80v32c0 8.8 7.2 16 16 16h48v368c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V128h368c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16zM160 384h320V160H160v224z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSignal(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M216 288h-48c-8.84 0-16 7.16-16 16v192c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V304c0-8.84-7.16-16-16-16zM88 384H40c-8.84 0-16 7.16-16 16v96c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16v-96c0-8.84-7.16-16-16-16zm256-192h-48c-8.84 0-16 7.16-16 16v288c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V208c0-8.84-7.16-16-16-16zm128-96h-48c-8.84 0-16 7.16-16 16v384c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V112c0-8.84-7.16-16-16-16zM600 0h-48c-8.84 0-16 7.16-16 16v480c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSignature(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M623.2 192c-51.8 3.5-125.7 54.7-163.1 71.5-29.1 13.1-54.2 24.4-76.1 24.4-22.6 0-26-16.2-21.3-51.9 1.1-8 11.7-79.2-42.7-76.1-25.1 1.5-64.3 24.8-169.5 126L192 182.2c30.4-75.9-53.2-151.5-129.7-102.8L7.4 116.3C0 121-2.2 130.9 2.5 138.4l17.2 27c4.7 7.5 14.6 9.7 22.1 4.9l58-38.9c18.4-11.7 40.7 7.2 32.7 27.1L34.3 404.1C27.5 421 37 448 64 448c8.3 0 16.5-3.2 22.6-9.4 42.2-42.2 154.7-150.7 211.2-195.8-2.2 28.5-2.1 58.9 20.6 83.8 15.3 16.8 37.3 25.3 65.5 25.3 35.6 0 68-14.6 102.3-30 33-14.8 99-62.6 138.4-65.8 8.5-.7 15.2-7.3 15.2-15.8v-32.1c.2-9.1-7.5-16.8-16.6-16.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSimCard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V128L256 0H64C28.7 0 0 28.7 0 64zm224 192h-64v-64h64v64zm96 0h-64v-64h32c17.7 0 32 14.3 32 32v32zm-64 128h64v32c0 17.7-14.3 32-32 32h-32v-64zm-96 0h64v64h-64v-64zm-96 0h64v64H96c-17.7 0-32-14.3-32-32v-32zm0-96h256v64H64v-64zm0-64c0-17.7 14.3-32 32-32h32v64H64v-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSink(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32,416a96,96,0,0,0,96,96H384a96,96,0,0,0,96-96V384H32ZM496,288H400V256h64a16,16,0,0,0,16-16V224a16,16,0,0,0-16-16H384a32,32,0,0,0-32,32v48H288V96a32,32,0,0,1,64,0v16a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V96A96.16,96.16,0,0,0,300.87,1.86C255.29,10.71,224,53.36,224,99.79V288H160V240a32,32,0,0,0-32-32H48a16,16,0,0,0-16,16v16a16,16,0,0,0,16,16h64v32H16A16,16,0,0,0,0,304v32a16,16,0,0,0,16,16H496a16,16,0,0,0,16-16V304A16,16,0,0,0,496,288Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSitemap(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 352H32c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zm-24-80h192v48h48v-48h192v48h48v-57.59c0-21.17-17.23-38.41-38.41-38.41H344v-64h40c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32H256c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h40v64H94.41C73.23 224 56 241.23 56 262.41V320h48v-48zm264 80h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zm240 0h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSkating(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 0c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm0 448c-8.8 0-16 7.2-16 16s-7.2 16-16 16h-96c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c26.5 0 48-21.5 48-48 0-8.8-7.2-16-16-16zm-282.2 8.6c-6.2 6.2-16.4 6.3-22.6 0l-67.9-67.9c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l67.9 67.9c9.4 9.4 21.7 14 34 14s24.6-4.7 33.9-14c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.3-22.7 0zm56.1-179.8l-93.7 93.7c-12.5 12.5-12.5 32.8 0 45.2 6.2 6.2 14.4 9.4 22.6 9.4s16.4-3.1 22.6-9.4l91.9-91.9-30.2-30.2c-5-5-9.4-10.7-13.2-16.8zM128 160h105.5l-20.1 17.2c-13.5 11.5-21.6 28.4-22.3 46.1-.7 17.8 6.1 35.2 18.7 47.7l78.2 78.2V432c0 17.7 14.3 32 32 32s32-14.3 32-32v-89.4c0-12.6-5.1-25-14.1-33.9l-61-61c.5-.4 1.2-.6 1.7-1.1l82.3-82.3c11.5-11.5 14.9-28.6 8.7-43.6-6.2-15-20.7-24.7-37-24.7H128c-17.7 0-32 14.3-32 32s14.3 32 32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSkiingNordic(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 96c26.5 0 48-21.5 48-48S362.5 0 336 0s-48 21.5-48 48 21.5 48 48 48zm216 320c-13.2 0-24 10.7-24 24 0 13.2-10.8 24-24 24h-69.5L460 285.6c11.7-4.7 20.1-16.2 20.1-29.6 0-17.7-14.3-32-32-32h-44L378 170.8c-12.5-25.5-35.5-44.2-61.8-50.9L245 98.7c-28.3-6.8-57.8-.5-80.8 17.1l-39.7 30.4c-14 10.7-16.7 30.8-5.9 44.9.7.9 1.7 1.3 2.4 2.1L66.9 464H24c-13.2 0-24 10.7-24 24s10.8 24 24 24h480c39.7 0 72-32.3 72-72 0-13.2-10.8-24-24-24zm-260.5 48h-96.9l43.1-91-22-13c-12.1-7.2-21.9-16.9-29.5-27.8L123.7 464H99.5l52.3-261.4c4.1-1 8.1-2.9 11.7-5.6l39.7-30.4c7.7-5.9 17.4-8 25.3-6.1l14.7 4.4-37.5 87.4c-12.6 29.5-1.3 64 26.3 80.3l85 50.2-25.5 81.2zm110.6 0h-43.6l23.6-75.5c5.9-20.8-2.9-43.1-21.6-54.4L299.3 298l31.3-78.3 20.3 41.4c8 16.3 24.9 26.9 43.1 26.9h33.3l-25.2 176z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSkiing(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 96c26.5 0 48-21.5 48-48S458.5 0 432 0s-48 21.5-48 48 21.5 48 48 48zm73 356.1c-9.4-9.4-24.6-9.4-33.9 0-12.1 12.1-30.5 15.4-45.1 8.7l-135.8-70.2 49.2-73.8c12.7-19 10.2-44.5-6-60.6L293 215.7l-107-53.1c-2.9 19.9 3.4 40 17.7 54.4l75.1 75.2-45.9 68.8L35 258.7c-11.7-6-26.2-1.5-32.3 10.3-6.1 11.8-1.5 26.3 10.3 32.3l391.9 202.5c11.9 5.5 24.5 8.1 37.1 8.1 23.2 0 46-9 63-26 9.3-9.3 9.3-24.5 0-33.8zM120 91.6l-11.5 22.5c14.4 7.3 31.2 4.9 42.8-4.8l47.2 23.4c-.1.1-.1.2-.2.3l114.5 56.8 32.4-13 6.4 19.1c4 12.1 12.6 22 24 27.7l58.1 29c15.9 7.9 35 1.5 42.9-14.3 7.9-15.8 1.5-35-14.3-42.9l-52.1-26.1-17.1-51.2c-8.1-24.2-40.9-56.6-84.5-39.2l-81.2 32.5-62.5-31c.3-14.5-7.2-28.6-20.9-35.6l-11.1 21.7h-.2l-34.4-7c-1.8-.4-3.7.2-5 1.7-1.9 2.2-1.7 5.5.5 7.4l26.2 23z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSkullCrossbones(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M439.15 453.06L297.17 384l141.99-69.06c7.9-3.95 11.11-13.56 7.15-21.46L432 264.85c-3.95-7.9-13.56-11.11-21.47-7.16L224 348.41 37.47 257.69c-7.9-3.95-17.51-.75-21.47 7.16L1.69 293.48c-3.95 7.9-.75 17.51 7.15 21.46L150.83 384 8.85 453.06c-7.9 3.95-11.11 13.56-7.15 21.47l14.31 28.63c3.95 7.9 13.56 11.11 21.47 7.15L224 419.59l186.53 90.72c7.9 3.95 17.51.75 21.47-7.15l14.31-28.63c3.95-7.91.74-17.52-7.16-21.47zM150 237.28l-5.48 25.87c-2.67 12.62 5.42 24.85 16.45 24.85h126.08c11.03 0 19.12-12.23 16.45-24.85l-5.5-25.87c41.78-22.41 70-62.75 70-109.28C368 57.31 303.53 0 224 0S80 57.31 80 128c0 46.53 28.22 86.87 70 109.28zM280 112c17.65 0 32 14.35 32 32s-14.35 32-32 32-32-14.35-32-32 14.35-32 32-32zm-112 0c17.65 0 32 14.35 32 32s-14.35 32-32 32-32-14.35-32-32 14.35-32 32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSkull(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 0C114.6 0 0 100.3 0 224c0 70.1 36.9 132.6 94.5 173.7 9.6 6.9 15.2 18.1 13.5 29.9l-9.4 66.2c-1.4 9.6 6 18.2 15.7 18.2H192v-56c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v56h64v-56c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v56h77.7c9.7 0 17.1-8.6 15.7-18.2l-9.4-66.2c-1.7-11.7 3.8-23 13.5-29.9C475.1 356.6 512 294.1 512 224 512 100.3 397.4 0 256 0zm-96 320c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm192 0c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M594.53 508.63L6.18 53.9c-6.97-5.42-8.23-15.47-2.81-22.45L23.01 6.18C28.43-.8 38.49-2.06 45.47 3.37L633.82 458.1c6.97 5.42 8.23 15.47 2.81 22.45l-19.64 25.27c-5.42 6.98-15.48 8.23-22.46 2.81z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSleigh(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M612.7 350.7l-9.3-7.4c-6.9-5.5-17-4.4-22.5 2.5l-10 12.5c-5.5 6.9-4.4 17 2.5 22.5l9.3 7.4c5.9 4.7 9.2 11.7 9.2 19.2 0 13.6-11 24.6-24.6 24.6H48c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h516c39 0 73.7-29.3 75.9-68.3 1.4-23.8-8.7-46.3-27.2-61zM32 224c0 59.6 40.9 109.2 96 123.5V400h64v-48h192v48h64v-48c53 0 96-43 96-96v-96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-96v64c0 35.3-28.7 64-64 64h-20.7c-65.8 0-125.9-37.2-155.3-96-29.4-58.8-89.6-96-155.3-96H32C14.3 32 0 46.3 0 64s14.3 32 32 32v128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSlidersH(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 384H160v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h80v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h336c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160h-80v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h336v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h80c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160H288V48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16C7.2 64 0 71.2 0 80v32c0 8.8 7.2 16 16 16h208v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h208c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSmileBeam(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM112 223.4c3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.3 7.4-15.8 4-15.1-4.5zm250.8 122.8C334.3 380.4 292.5 400 248 400s-86.3-19.6-114.8-53.8c-13.5-16.3 11-36.7 24.6-20.5 22.4 26.9 55.2 42.2 90.2 42.2s67.8-15.4 90.2-42.2c13.6-16.2 38.1 4.3 24.6 20.5zm6.2-118.3l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.3-15.6 4-14.9-4.5 3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.6 8.6-11 11.9-15.1 4.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSmileWink(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 256c0 137 111 248 248 248s248-111 248-248S385 8 248 8 0 119 0 256zm200-48c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zm158.5 16.5c-14.8-13.2-46.2-13.2-61 0L288 233c-8.3 7.4-21.6.4-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S384 197 388 222.2c1.7 11.1-11.4 18.3-19.8 10.8l-9.7-8.5zM157.8 325.8C180.2 352.7 213 368 248 368s67.8-15.4 90.2-42.2c13.6-16.2 38.1 4.2 24.6 20.5C334.3 380.4 292.5 400 248 400s-86.3-19.6-114.8-53.8c-13.5-16.3 11.2-36.7 24.6-20.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSmile(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm194.8 170.2C334.3 380.4 292.5 400 248 400s-86.3-19.6-114.8-53.8c-13.6-16.3 11-36.7 24.6-20.5 22.4 26.9 55.2 42.2 90.2 42.2s67.8-15.4 90.2-42.2c13.4-16.2 38.1 4.2 24.6 20.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSmog(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 368H80c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h544c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm-480 96H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm416 0H224c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h336c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zM144 288h156.1c22.5 19.7 51.6 32 83.9 32s61.3-12.3 83.9-32H528c61.9 0 112-50.1 112-112S589.9 64 528 64c-18 0-34.7 4.6-49.7 12.1C454 31 406.8 0 352 0c-41 0-77.8 17.3-104 44.8C221.8 17.3 185 0 144 0 64.5 0 0 64.5 0 144s64.5 144 144 144z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSmokingBan(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 304c0 8.8 7.2 16 16 16h117.5l-96-96H112c-8.8 0-16 7.2-16 16v64zM256 0C114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256S397.4 0 256 0zm0 448c-105.9 0-192-86.1-192-192 0-41.4 13.3-79.7 35.7-111.1l267.4 267.4C335.7 434.7 297.4 448 256 448zm45.2-192H384v32h-50.8l-32-32zm111.1 111.1L365.2 320H400c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16H269.2L144.9 99.7C176.3 77.3 214.6 64 256 64c105.9 0 192 86.1 192 192 0 41.4-13.3 79.7-35.7 111.1zM320.6 128c-15.6 0-28.6-11.2-31.4-25.9-.7-3.6-4-6.1-7.7-6.1h-16.2c-5 0-8.7 4.5-8 9.4 4.6 30.9 31.2 54.6 63.3 54.6 15.6 0 28.6 11.2 31.4 25.9.7 3.6 4 6.1 7.7 6.1h16.2c5 0 8.7-4.5 8-9.4-4.6-30.9-31.2-54.6-63.3-54.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSmoking(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M632 352h-48c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8zM553.3 87.1c-5.7-3.8-9.3-10-9.3-16.8V8c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v62.3c0 22 10.2 43.4 28.6 55.4 42.2 27.3 67.4 73.8 67.4 124V280c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-30.3c0-65.5-32.4-126.2-86.7-162.6zM432 352H48c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h384c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16zm-32 112H224v-64h176v64zm87.7-322.4C463.8 125 448 99.3 448 70.3V8c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v66.4c0 43.7 24.6 81.6 60.3 106.7 22.4 15.7 35.7 41.2 35.7 68.6V280c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-30.3c0-43.3-21-83.4-56.3-108.1zM536 352h-48c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSms(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7 1.3 3 4.1 4.8 7.3 4.8 66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32zM128.2 304H116c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h12.3c6 0 10.4-3.5 10.4-6.6 0-1.3-.8-2.7-2.1-3.8l-21.9-18.8c-8.5-7.2-13.3-17.5-13.3-28.1 0-21.3 19-38.6 42.4-38.6H156c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8h-12.3c-6 0-10.4 3.5-10.4 6.6 0 1.3.8 2.7 2.1 3.8l21.9 18.8c8.5 7.2 13.3 17.5 13.3 28.1.1 21.3-19 38.6-42.4 38.6zm191.8-8c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-68.2l-24.8 55.8c-2.9 5.9-11.4 5.9-14.3 0L224 227.8V296c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V192c0-8.8 7.2-16 16-16h16c6.1 0 11.6 3.4 14.3 8.8l17.7 35.4 17.7-35.4c2.7-5.4 8.3-8.8 14.3-8.8h16c8.8 0 16 7.2 16 16v104zm48.3 8H356c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h12.3c6 0 10.4-3.5 10.4-6.6 0-1.3-.8-2.7-2.1-3.8l-21.9-18.8c-8.5-7.2-13.3-17.5-13.3-28.1 0-21.3 19-38.6 42.4-38.6H396c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8h-12.3c-6 0-10.4 3.5-10.4 6.6 0 1.3.8 2.7 2.1 3.8l21.9 18.8c8.5 7.2 13.3 17.5 13.3 28.1.1 21.3-18.9 38.6-42.3 38.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSnowboarding(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 96c26.5 0 48-21.5 48-48S458.5 0 432 0s-48 21.5-48 48 21.5 48 48 48zm28.8 153.6c5.8 4.3 12.5 6.4 19.2 6.4 9.7 0 19.3-4.4 25.6-12.8 10.6-14.1 7.8-34.2-6.4-44.8l-111.4-83.5c-13.8-10.3-29.1-18.4-45.4-23.8l-63.7-21.2-26.1-52.1C244.7 2 225.5-4.4 209.7 3.5c-15.8 7.9-22.2 27.1-14.3 42.9l29.1 58.1c5.7 11.4 15.6 19.9 27.7 24l16.4 5.5-41.2 20.6c-21.8 10.9-35.4 32.8-35.4 57.2v53.1l-74.1 24.7c-16.8 5.6-25.8 23.7-20.2 40.5 1.7 5.2 4.9 9.4 8.7 12.9l-38.7-14.1c-9.7-3.5-17.4-10.6-21.8-20-5.6-12-19.9-17.2-31.9-11.6s-17.2 19.9-11.6 31.9c9.8 21 27.1 36.9 48.9 44.8l364.8 132.7c9.7 3.5 19.7 5.3 29.7 5.3 12.5 0 24.9-2.7 36.5-8.2 12-5.6 17.2-19.9 11.6-31.9S474 454.7 462 460.3c-9.3 4.4-19.8 4.8-29.5 1.3l-90.8-33.1c8.7-4.1 15.6-11.8 17.8-21.9l21.9-102c3.9-18.2-3.2-37.2-18.1-48.4l-52-39 66-30.5 83.5 62.9zm-144.4 51.7l-19.7 92c-1.5 7.1-.1 13.9 2.8 20l-169.4-61.6c2.7-.2 5.4-.4 8-1.3l85-28.4c19.6-6.5 32.8-24.8 32.8-45.5V256l60.5 45.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSnowflake(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M440.3 345.2l-33.8-19.5 26-7c8.2-2.2 13.1-10.7 10.9-18.9l-4-14.9c-2.2-8.2-10.7-13.1-18.9-10.9l-70.8 19-63.9-37 63.8-36.9 70.8 19c8.2 2.2 16.7-2.7 18.9-10.9l4-14.9c2.2-8.2-2.7-16.7-10.9-18.9l-26-7 33.8-19.5c7.4-4.3 9.9-13.7 5.7-21.1L430.4 119c-4.3-7.4-13.7-9.9-21.1-5.7l-33.8 19.5 7-26c2.2-8.2-2.7-16.7-10.9-18.9l-14.9-4c-8.2-2.2-16.7 2.7-18.9 10.9l-19 70.8-62.8 36.2v-77.5l53.7-53.7c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0L256 56.4V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v40.4l-19.7-19.7c-6.2-6.2-16.4-6.2-22.6 0L138.3 48c-6.3 6.2-6.3 16.4 0 22.6l53.7 53.7v77.5l-62.8-36.2-19-70.8c-2.2-8.2-10.7-13.1-18.9-10.9l-14.9 4c-8.2 2.2-13.1 10.7-10.9 18.9l7 26-33.8-19.5c-7.4-4.3-16.8-1.7-21.1 5.7L2.1 145.7c-4.3 7.4-1.7 16.8 5.7 21.1l33.8 19.5-26 7c-8.3 2.2-13.2 10.7-11 19l4 14.9c2.2 8.2 10.7 13.1 18.9 10.9l70.8-19 63.8 36.9-63.8 36.9-70.8-19c-8.2-2.2-16.7 2.7-18.9 10.9l-4 14.9c-2.2 8.2 2.7 16.7 10.9 18.9l26 7-33.8 19.6c-7.4 4.3-9.9 13.7-5.7 21.1l15.5 26.8c4.3 7.4 13.7 9.9 21.1 5.7l33.8-19.5-7 26c-2.2 8.2 2.7 16.7 10.9 18.9l14.9 4c8.2 2.2 16.7-2.7 18.9-10.9l19-70.8 62.8-36.2v77.5l-53.7 53.7c-6.3 6.2-6.3 16.4 0 22.6l11.3 11.3c6.2 6.2 16.4 6.2 22.6 0l19.7-19.7V496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-40.4l19.7 19.7c6.2 6.2 16.4 6.2 22.6 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6L256 387.7v-77.5l62.8 36.2 19 70.8c2.2 8.2 10.7 13.1 18.9 10.9l14.9-4c8.2-2.2 13.1-10.7 10.9-18.9l-7-26 33.8 19.5c7.4 4.3 16.8 1.7 21.1-5.7l15.5-26.8c4.3-7.3 1.8-16.8-5.6-21z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSnowman(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M510.9 152.3l-5.9-14.5c-3.3-8-12.6-11.9-20.8-8.7L456 140.6v-29c0-8.6-7.2-15.6-16-15.6h-16c-8.8 0-16 7-16 15.6v46.9c0 .5.3 1 .3 1.5l-56.4 23c-5.9-10-13.3-18.9-22-26.6 13.6-16.6 22-37.4 22-60.5 0-53-43-96-96-96s-96 43-96 96c0 23.1 8.5 43.9 22 60.5-8.7 7.7-16 16.6-22 26.6l-56.4-23c.1-.5.3-1 .3-1.5v-46.9C104 103 96.8 96 88 96H72c-8.8 0-16 7-16 15.6v29l-28.1-11.5c-8.2-3.2-17.5.7-20.8 8.7l-5.9 14.5c-3.3 8 .7 17.1 8.9 20.3l135.2 55.2c-.4 4-1.2 8-1.2 12.2 0 10.1 1.7 19.6 4.2 28.9C120.9 296.4 104 334.2 104 376c0 54 28.4 100.9 70.8 127.8 9.3 5.9 20.3 8.2 31.3 8.2h99.2c13.3 0 26.3-4.1 37.2-11.7 46.5-32.3 74.4-89.4 62.9-152.6-5.5-30.2-20.5-57.6-41.6-79 2.5-9.2 4.2-18.7 4.2-28.7 0-4.2-.8-8.1-1.2-12.2L502 172.6c8.1-3.1 12.1-12.2 8.9-20.3zM224 96c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm32 272c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-88s-16-23.2-16-32 7.2-16 16-16 16 7.2 16 16-16 32-16 32zm32-56c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSnowplow(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M120 376c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm238.6 49.4c-14.5-14.5-22.6-34.1-22.6-54.6V269.2c0-20.5 8.1-40.1 22.6-54.6l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6l-22.6-22.6c-6.2-6.2-16.4-6.2-22.6 0l-36.7 36.7c-26.5 26.5-41.4 62.4-41.4 99.9V288h-64v-50.9c0-8.7-1.8-17.2-5.2-25.2L364.5 29.1C356.9 11.4 339.6 0 320.3 0H176c-26.5 0-48 21.5-48 48v112h-16c-26.5 0-48 21.5-48 48v91.2C26.3 317.2 0 355.4 0 400c0 61.9 50.1 112 112 112h256c61.9 0 112-50.1 112-112 0-17.3-4.2-33.4-11.2-48H512v18.7c0 37.5 14.9 73.4 41.4 99.9l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0l22.6-22.6c6.2-6.2 6.2-16.4 0-22.6l-36.7-36.7zM192 64h117.8l68.6 160H256l-64-64V64zm176 384H112c-26.5 0-48-21.5-48-48s21.5-48 48-48h256c26.5 0 48 21.5 48 48s-21.5 48-48 48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSoap(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416,192a95.42,95.42,0,0,1-30.94,70.21A95.8,95.8,0,0,1,352,448H160a96,96,0,0,1,0-192h88.91A95.3,95.3,0,0,1,224,192H96A96,96,0,0,0,0,288V416a96,96,0,0,0,96,96H416a96,96,0,0,0,96-96V288A96,96,0,0,0,416,192Zm-96,64a64,64,0,1,0-64-64A64,64,0,0,0,320,256ZM208,96a48,48,0,1,0-48-48A48,48,0,0,0,208,96ZM384,64a32,32,0,1,0-32-32A32,32,0,0,0,384,64ZM160,288a64,64,0,0,0,0,128H352a64,64,0,0,0,0-128Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSocks(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M214.66 311.01L288 256V96H128v176l-86.65 64.61c-39.4 29.56-53.86 84.42-29.21 127.06C30.39 495.25 63.27 512 96.08 512c20.03 0 40.25-6.25 57.52-19.2l21.86-16.39c-29.85-55.38-13.54-125.84 39.2-165.4zM288 32c0-11.05 3.07-21.3 8.02-30.38C293.4.92 290.85 0 288 0H160c-17.67 0-32 14.33-32 32v32h160V32zM480 0H352c-17.67 0-32 14.33-32 32v32h192V32c0-17.67-14.33-32-32-32zM320 272l-86.13 64.61c-39.4 29.56-53.86 84.42-29.21 127.06 18.25 31.58 50.61 48.33 83.42 48.33 20.03 0 40.25-6.25 57.52-19.2l115.2-86.4A127.997 127.997 0 0 0 512 304V96H320v176z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSolarPanel(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M431.98 448.01l-47.97.05V416h-128v32.21l-47.98.05c-8.82.01-15.97 7.16-15.98 15.99l-.05 31.73c-.01 8.85 7.17 16.03 16.02 16.02l223.96-.26c8.82-.01 15.97-7.16 15.98-15.98l.04-31.73c.01-8.85-7.17-16.03-16.02-16.02zM585.2 26.74C582.58 11.31 568.99 0 553.06 0H86.93C71 0 57.41 11.31 54.79 26.74-3.32 369.16.04 348.08.03 352c-.03 17.32 14.29 32 32.6 32h574.74c18.23 0 32.51-14.56 32.59-31.79.02-4.08 3.35 16.95-54.76-325.47zM259.83 64h120.33l9.77 96H250.06l9.77-96zm-75.17 256H71.09L90.1 208h105.97l-11.41 112zm16.29-160H98.24l16.29-96h96.19l-9.77 96zm32.82 160l11.4-112h149.65l11.4 112H233.77zm195.5-256h96.19l16.29 96H439.04l-9.77-96zm26.06 256l-11.4-112H549.9l19.01 112H455.33z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSortAlphaDownAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 352h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm112-128h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 65.63V48a16 16 0 0 0-16-16H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 190.37V208a16 16 0 0 0 16 16zm159.06 234.62l-59.27-160A16 16 0 0 0 372.72 288h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 480h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 480H432a16 16 0 0 0 15.06-21.38zM335.61 400L352 352l16.39 48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSortAlphaDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 352h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm240-64H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 446.37V464a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 321.63V304a16 16 0 0 0-16-16zm31.06-85.38l-59.27-160A16 16 0 0 0 372.72 32h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 224h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 224H432a16 16 0 0 0 15.06-21.38zM335.61 144L352 96l16.39 48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSortAlphaUpAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160zm272 64h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 65.63V48a16 16 0 0 0-16-16H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 190.37V208a16 16 0 0 0 16 16zm159.06 234.62l-59.27-160A16 16 0 0 0 372.72 288h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 480h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 480H432a16 16 0 0 0 15.06-21.38zM335.61 400L352 352l16.39 48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSortAlphaUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160zm400 128H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 446.37V464a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 321.63V304a16 16 0 0 0-16-16zm31.06-85.38l-59.27-160A16 16 0 0 0 372.72 32h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 224h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 224H432a16 16 0 0 0 15.06-21.38zM335.61 144L352 96l16.39 48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSortAmountDownAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M240 96h64a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm0 128h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm256 192H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-256-64h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm-64 0h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.37 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSortAmountDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304 416h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-128-64h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.37 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm256-192H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-64 128H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM496 32H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSortAmountUpAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M240 96h64a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm0 128h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm256 192H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-256-64h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zM16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.39-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSortAmountUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304 416h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.77 160 16 160zm416 0H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-64 128H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM496 32H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSortDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSortNumericDownAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 352h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm224 64h-16V304a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 352h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM330.17 34.91a79 79 0 0 0-55 54.17c-14.27 51.05 21.19 97.77 68.83 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.77 86.25-61.61 86.25-132V112c-.02-51.21-48.4-91.34-101.85-77.09zM352 132a20 20 0 1 1 20-20 20 20 0 0 1-20 20z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSortNumericDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304 96h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-16V48a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 96zm26.15 162.91a79 79 0 0 0-55 54.17c-14.25 51.05 21.21 97.77 68.85 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.76 86.25-61.61 86.25-132V336c-.02-51.21-48.4-91.34-101.85-77.09zM352 356a20 20 0 1 1 20-20 20 20 0 0 1-20 20zm-176-4h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSortNumericUpAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M107.31 36.69a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31zM400 416h-16V304a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 352h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM330.17 34.91a79 79 0 0 0-55 54.17c-14.27 51.05 21.19 97.77 68.83 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.77 86.25-61.61 86.25-132V112c-.02-51.21-48.4-91.34-101.85-77.09zM352 132a20 20 0 1 1 20-20 20 20 0 0 1-20 20z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSortNumericUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M330.17 258.91a79 79 0 0 0-55 54.17c-14.27 51.05 21.19 97.77 68.83 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.76 86.25-61.61 86.25-132V336c-.02-51.21-48.4-91.34-101.85-77.09zM352 356a20 20 0 1 1 20-20 20 20 0 0 1-20 20zM304 96h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-16V48a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 96zM107.31 36.69a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSortUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M279 224H41c-21.4 0-32.1-25.9-17-41L143 64c9.4-9.4 24.6-9.4 33.9 0l119 119c15.2 15.1 4.5 41-16.9 41z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSort(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41zm255-105L177 64c-9.4-9.4-24.6-9.4-33.9 0L24 183c-15.1 15.1-4.4 41 17 41h238c21.4 0 32.1-25.9 17-41z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSpa(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M568.25 192c-29.04.13-135.01 6.16-213.84 83-33.12 29.63-53.36 63.3-66.41 94.86-13.05-31.56-33.29-65.23-66.41-94.86-78.83-76.84-184.8-82.87-213.84-83-4.41-.02-7.79 3.4-7.75 7.82.23 27.92 7.14 126.14 88.77 199.3C172.79 480.94 256 480 288 480s115.19.95 199.23-80.88c81.64-73.17 88.54-171.38 88.77-199.3.04-4.42-3.34-7.84-7.75-7.82zM287.98 302.6c12.82-18.85 27.6-35.78 44.09-50.52 19.09-18.61 39.58-33.3 60.26-45.18-16.44-70.5-51.72-133.05-96.73-172.22-4.11-3.58-11.02-3.58-15.14 0-44.99 39.14-80.27 101.63-96.74 172.07 20.37 11.7 40.5 26.14 59.22 44.39a282.768 282.768 0 0 1 45.04 51.46z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSpaceShuttle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M592.604 208.244C559.735 192.836 515.777 184 472 184H186.327c-4.952-6.555-10.585-11.978-16.72-16H376C229.157 137.747 219.403 32 96.003 32H96v128H80V32c-26.51 0-48 28.654-48 64v64c-23.197 0-32 10.032-32 24v40c0 13.983 8.819 24 32 24v16c-23.197 0-32 10.032-32 24v40c0 13.983 8.819 24 32 24v64c0 35.346 21.49 64 48 64V352h16v128h.003c123.4 0 133.154-105.747 279.997-136H169.606c6.135-4.022 11.768-9.445 16.72-16H472c43.777 0 87.735-8.836 120.604-24.244C622.282 289.845 640 271.992 640 256s-17.718-33.845-47.396-47.756zM488 296a8 8 0 0 1-8-8v-64a8 8 0 0 1 8-8c31.909 0 31.942 80 0 80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSpellCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272 256h91.36c43.2 0 82-32.2 84.51-75.34a79.82 79.82 0 0 0-25.26-63.07 79.81 79.81 0 0 0 9.06-44.91C427.9 30.57 389.3 0 347 0h-75a16 16 0 0 0-16 16v224a16 16 0 0 0 16 16zm40-200h40a24 24 0 0 1 0 48h-40zm0 96h56a24 24 0 0 1 0 48h-56zM155.12 22.25A32 32 0 0 0 124.64 0H99.36a32 32 0 0 0-30.48 22.25L.59 235.73A16 16 0 0 0 16 256h24.93a16 16 0 0 0 15.42-11.73L68.29 208h87.42l11.94 36.27A16 16 0 0 0 183.07 256H208a16 16 0 0 0 15.42-20.27zM89.37 144L112 75.3l22.63 68.7zm482 132.48l-45.21-45.3a15.88 15.88 0 0 0-22.59 0l-151.5 151.5-55.41-55.5a15.88 15.88 0 0 0-22.59 0l-45.3 45.3a16 16 0 0 0 0 22.59l112 112.21a15.89 15.89 0 0 0 22.6 0l208-208.21a16 16 0 0 0-.02-22.59z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSpider(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M151.17 167.35L177.1 176h4.67l5.22-26.12c.72-3.58 1.8-7.58 3.21-11.79l-20.29-40.58 23.8-71.39c2.79-8.38-1.73-17.44-10.12-20.24L168.42.82c-8.38-2.8-17.45 1.73-20.24 10.12l-25.89 77.68a32.04 32.04 0 0 0 1.73 24.43l27.15 54.3zm422.14 182.03l-52.75-79.12a32.002 32.002 0 0 0-26.62-14.25H416l68.99-24.36a32.03 32.03 0 0 0 16.51-12.61l53.6-80.41c4.9-7.35 2.91-17.29-4.44-22.19l-13.31-8.88c-7.35-4.9-17.29-2.91-22.19 4.44l-50.56 75.83L404.1 208H368l-10.37-51.85C355.44 145.18 340.26 96 288 96c-52.26 0-67.44 49.18-69.63 60.15L208 208h-36.1l-60.49-20.17L60.84 112c-4.9-7.35-14.83-9.34-22.19-4.44l-13.31 8.88c-7.35 4.9-9.34 14.83-4.44 22.19l53.6 80.41a32.03 32.03 0 0 0 16.51 12.61L160 256H82.06a32.02 32.02 0 0 0-26.63 14.25L2.69 349.38c-4.9 7.35-2.92 17.29 4.44 22.19l13.31 8.88c7.35 4.9 17.29 2.91 22.19-4.44l48-72h47.06l-60.83 97.33A31.988 31.988 0 0 0 72 418.3V496c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-73.11l74.08-118.53c-1.01 14.05-2.08 28.11-2.08 42.21C192 399.64 232.76 448 288 448s96-48.36 96-101.43c0-14.1-1.08-28.16-2.08-42.21L456 422.89V496c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-77.71c0-6-1.69-11.88-4.86-16.96L438.31 304h47.06l48 72c4.9 7.35 14.84 9.34 22.19 4.44l13.31-8.88c7.36-4.9 9.34-14.83 4.44-22.18zM406.09 97.51l-20.29 40.58c1.41 4.21 2.49 8.21 3.21 11.79l5.22 26.12h4.67l25.93-8.65 27.15-54.3a31.995 31.995 0 0 0 1.73-24.43l-25.89-77.68C425.03 2.56 415.96-1.98 407.58.82l-15.17 5.06c-8.38 2.8-12.91 11.86-10.12 20.24l23.8 71.39z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSpinner(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSplotch(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M472.29 195.89l-67.06-22.95c-19.28-6.6-33.54-20.92-38.14-38.3L351.1 74.19c-11.58-43.77-76.57-57.13-109.98-22.62l-46.14 47.67c-13.26 13.71-33.54 20.93-54.2 19.31l-71.88-5.62c-52.05-4.07-86.93 44.88-59.03 82.83l38.54 52.42c11.08 15.07 12.82 33.86 4.64 50.24L24.62 355.4c-20.59 41.25 22.84 84.87 73.49 73.81l69.96-15.28c20.11-4.39 41.45 0 57.07 11.73l54.32 40.83c39.32 29.56 101.04 7.57 104.45-37.22l4.7-61.86c1.35-17.79 12.8-33.86 30.63-42.99l62-31.74c44.88-22.96 39.59-80.17-8.95-96.79z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSprayCan(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 32c0-17.67-14.33-32-32-32h-64c-17.67 0-32 14.33-32 32v96h128V32zm256 96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm-256 32H96c-53.02 0-96 42.98-96 96v224c0 17.67 14.33 32 32 32h256c17.67 0 32-14.33 32-32V256c0-53.02-42.98-96-96-96zm-64 256c-44.18 0-80-35.82-80-80s35.82-80 80-80 80 35.82 80 80-35.82 80-80 80zM480 96c17.67 0 32-14.33 32-32s-14.33-32-32-32-32 14.33-32 32 14.33 32 32 32zm-96 32c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm-96-96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm96 0c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm96 192c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSquareFull(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 512H0V0h512v512z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSquareRootAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M571.31 251.31l-22.62-22.62c-6.25-6.25-16.38-6.25-22.63 0L480 274.75l-46.06-46.06c-6.25-6.25-16.38-6.25-22.63 0l-22.62 22.62c-6.25 6.25-6.25 16.38 0 22.63L434.75 320l-46.06 46.06c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0L480 365.25l46.06 46.06c6.25 6.25 16.38 6.25 22.63 0l22.62-22.62c6.25-6.25 6.25-16.38 0-22.63L525.25 320l46.06-46.06c6.25-6.25 6.25-16.38 0-22.63zM552 0H307.65c-14.54 0-27.26 9.8-30.95 23.87l-84.79 322.8-58.41-106.1A32.008 32.008 0 0 0 105.47 224H24c-13.25 0-24 10.74-24 24v48c0 13.25 10.75 24 24 24h43.62l88.88 163.73C168.99 503.5 186.3 512 204.94 512c17.27 0 44.44-9 54.28-41.48L357.03 96H552c13.25 0 24-10.75 24-24V24c0-13.26-10.75-24-24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStamp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 512h448v-64H32v64zm384-256h-66.56c-16.26 0-29.44-13.18-29.44-29.44v-9.46c0-27.37 8.88-53.41 21.46-77.72 9.11-17.61 12.9-38.39 9.05-60.42-6.77-38.78-38.47-70.7-77.26-77.45C212.62-9.04 160 37.33 160 96c0 14.16 3.12 27.54 8.69 39.58C182.02 164.43 192 194.7 192 226.49v.07c0 16.26-13.18 29.44-29.44 29.44H96c-53.02 0-96 42.98-96 96v32c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32v-32c0-53.02-42.98-96-96-96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStarAndCrescent(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M340.47 466.36c-1.45 0-6.89.46-9.18.46-116.25 0-210.82-94.57-210.82-210.82S215.04 45.18 331.29 45.18c2.32 0 7.7.46 9.18.46 7.13 0 13.33-5.03 14.75-12.07 1.46-7.25-2.55-14.49-9.47-17.09C316.58 5.54 286.39 0 256 0 114.84 0 0 114.84 0 256s114.84 256 256 256c30.23 0 60.28-5.49 89.32-16.32 5.96-2.02 10.28-7.64 10.28-14.26 0-8.09-6.39-15.06-15.13-15.06zm162.99-252.5l-76.38-11.1-34.16-69.21c-1.83-3.7-5.38-5.55-8.93-5.55s-7.1 1.85-8.93 5.55l-34.16 69.21-76.38 11.1c-8.17 1.18-11.43 11.22-5.52 16.99l55.27 53.87-13.05 76.07c-1.11 6.44 4.01 11.66 9.81 11.66 1.53 0 3.11-.36 4.64-1.17L384 335.37l68.31 35.91c1.53.8 3.11 1.17 4.64 1.17 5.8 0 10.92-5.23 9.81-11.66l-13.05-76.07 55.27-53.87c5.91-5.77 2.65-15.81-5.52-16.99z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStarHalfAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 536 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M508.55 171.51L362.18 150.2 296.77 17.81C290.89 5.98 279.42 0 267.95 0c-11.4 0-22.79 5.9-28.69 17.81l-65.43 132.38-146.38 21.29c-26.25 3.8-36.77 36.09-17.74 54.59l105.89 103-25.06 145.48C86.98 495.33 103.57 512 122.15 512c4.93 0 10-1.17 14.87-3.75l130.95-68.68 130.94 68.7c4.86 2.55 9.92 3.71 14.83 3.71 18.6 0 35.22-16.61 31.66-37.4l-25.03-145.49 105.91-102.98c19.04-18.5 8.52-50.8-17.73-54.6zm-121.74 123.2l-18.12 17.62 4.28 24.88 19.52 113.45-102.13-53.59-22.38-11.74.03-317.19 51.03 103.29 11.18 22.63 25.01 3.64 114.23 16.63-82.65 80.38z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStarHalf(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 0c-11.4 0-22.8 5.9-28.7 17.8L194 150.2 47.9 171.4c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.1 23 46 46.4 33.7L288 439.6V0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStarOfDavid(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 464 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M405.68 256l53.21-89.39C473.3 142.4 455.48 112 426.88 112H319.96l-55.95-93.98C256.86 6.01 244.43 0 232 0s-24.86 6.01-32.01 18.02L144.04 112H37.11c-28.6 0-46.42 30.4-32.01 54.61L58.32 256 5.1 345.39C-9.31 369.6 8.51 400 37.11 400h106.93l55.95 93.98C207.14 505.99 219.57 512 232 512s24.86-6.01 32.01-18.02L319.96 400h106.93c28.6 0 46.42-30.4 32.01-54.61L405.68 256zm-12.78-88l-19.8 33.26L353.3 168h39.6zm-52.39 88l-52.39 88H175.88l-52.39-88 52.38-88h112.25l52.39 88zM232 73.72L254.79 112h-45.57L232 73.72zM71.1 168h39.6l-19.8 33.26L71.1 168zm0 176l19.8-33.26L110.7 344H71.1zM232 438.28L209.21 400h45.57L232 438.28zM353.29 344l19.8-33.26L392.9 344h-39.61z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStarOfLife(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 480 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M471.99 334.43L336.06 256l135.93-78.43c7.66-4.42 10.28-14.2 5.86-21.86l-32.02-55.43c-4.42-7.65-14.21-10.28-21.87-5.86l-135.93 78.43V16c0-8.84-7.17-16-16.01-16h-64.04c-8.84 0-16.01 7.16-16.01 16v156.86L56.04 94.43c-7.66-4.42-17.45-1.79-21.87 5.86L2.15 155.71c-4.42 7.65-1.8 17.44 5.86 21.86L143.94 256 8.01 334.43c-7.66 4.42-10.28 14.21-5.86 21.86l32.02 55.43c4.42 7.65 14.21 10.27 21.87 5.86l135.93-78.43V496c0 8.84 7.17 16 16.01 16h64.04c8.84 0 16.01-7.16 16.01-16V339.14l135.93 78.43c7.66 4.42 17.45 1.8 21.87-5.86l32.02-55.43c4.42-7.65 1.8-17.43-5.86-21.85z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStepBackward(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 468V44c0-6.6 5.4-12 12-12h48c6.6 0 12 5.4 12 12v176.4l195.5-181C352.1 22.3 384 36.6 384 64v384c0 27.4-31.9 41.7-52.5 24.6L136 292.7V468c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStepForward(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 44v424c0 6.6-5.4 12-12 12h-48c-6.6 0-12-5.4-12-12V291.6l-195.5 181C95.9 489.7 64 475.4 64 448V64c0-27.4 31.9-41.7 52.5-24.6L312 219.3V44c0-6.6 5.4-12 12-12h48c6.6 0 12 5.4 12 12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStethoscope(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M447.1 112c-34.2.5-62.3 28.4-63 62.6-.5 24.3 12.5 45.6 32 56.8V344c0 57.3-50.2 104-112 104-60 0-109.2-44.1-111.9-99.2C265 333.8 320 269.2 320 192V36.6c0-11.4-8.1-21.3-19.3-23.5L237.8.5c-13-2.6-25.6 5.8-28.2 18.8L206.4 35c-2.6 13 5.8 25.6 18.8 28.2l30.7 6.1v121.4c0 52.9-42.2 96.7-95.1 97.2-53.4.5-96.9-42.7-96.9-96V69.4l30.7-6.1c13-2.6 21.4-15.2 18.8-28.2l-3.1-15.7C107.7 6.4 95.1-2 82.1.6L19.3 13C8.1 15.3 0 25.1 0 36.6V192c0 77.3 55.1 142 128.1 156.8C130.7 439.2 208.6 512 304 512c97 0 176-75.4 176-168V231.4c19.1-11.1 32-31.7 32-55.4 0-35.7-29.2-64.5-64.9-64zm.9 80c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStickyNote(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M312 320h136V56c0-13.3-10.7-24-24-24H24C10.7 32 0 42.7 0 56v400c0 13.3 10.7 24 24 24h264V344c0-13.2 10.8-24 24-24zm129 55l-98 98c-4.5 4.5-10.6 7-17 7h-6V352h128v6.1c0 6.3-2.5 12.4-7 16.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStopCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm96 328c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16v160z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStop(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStopwatch20(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M398.5,190.91l.59-.61,26.59-26.58a16,16,0,0,0,0-22.63L403,118.41a16,16,0,0,0-22.63,0l-24.68,24.68A206.68,206.68,0,0,0,256,98.5V64h32a16,16,0,0,0,16-16V16A16,16,0,0,0,288,0H160a16.05,16.05,0,0,0-16,16V48a16.05,16.05,0,0,0,16,16h32V98.5A207.92,207.92,0,0,0,16.09,297.57C12.64,411.5,106.76,510.22,220.72,512,337.13,513.77,432,420,432,304A206,206,0,0,0,398.5,190.91ZM204.37,377.55a8.2,8.2,0,0,1,8.32,8.07v22.31a8.2,8.2,0,0,1-8.32,8.07H121.52a16.46,16.46,0,0,1-16.61-17.62c2.78-35.22,14.67-57.41,38.45-91.37,20.42-29.19,27.1-37.32,27.1-62.34,0-16.92-1.79-24.27-12.21-24.27-9.39,0-12.69,7.4-12.69,22.68v5.23a8.2,8.2,0,0,1-8.33,8.07h-24.9a8.2,8.2,0,0,1-8.33-8.07v-4.07c0-27.3,8.48-60.24,56.43-60.24,43,0,55.57,25.85,55.57,61,0,35.58-12.44,51.21-34.35,81.31-11.56,15-24.61,35.57-26.41,51.2ZM344,352.32c0,35.16-12.3,63.68-57.23,63.68C243.19,416,232,386.48,232,352.55V247.22c0-40.73,19.58-63.22,56.2-63.22C325,184,344,206.64,344,245.3ZM287.87,221.73c-9.41,0-13.23,7.5-13.23,20V357.68c0,13.11,3.59,20.59,13.23,20.59s13-8,13-21.27V241.06C300.89,229.79,297.88,221.73,287.87,221.73Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStopwatch(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 304c0 114.9-93.1 208-208 208S16 418.9 16 304c0-104 76.3-190.2 176-205.5V64h-28c-6.6 0-12-5.4-12-12V12c0-6.6 5.4-12 12-12h120c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-28v34.5c37.5 5.8 71.7 21.6 99.7 44.6l27.5-27.5c4.7-4.7 12.3-4.7 17 0l28.3 28.3c4.7 4.7 4.7 12.3 0 17l-29.4 29.4-.6.6C419.7 223.3 432 262.2 432 304zm-176 36V188.5c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12V340c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStoreAltSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.89,123.62,5.51,142.2c-14.2,21.3,1,49.8,26.59,49.8h74.26ZM576,413.42V224H512V364L384,265V224H330.92l-41.4-32H608c25.5,0,40.7-28.5,26.59-49.8l-85.29-128A32.18,32.18,0,0,0,522.6,0H117.42A31.87,31.87,0,0,0,90.81,14.2l-10.66,16L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.46A16,16,0,0,0,6.18,53.91L594.53,508.63A16,16,0,0,0,617,505.81l19.64-25.26a16,16,0,0,0-2.81-22.45ZM320,384H128V224H64V480a32,32,0,0,0,32,32H352a32,32,0,0,0,32-32V406.59l-64-49.47Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStoreAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 384H128V224H64v256c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V224h-64v160zm314.6-241.8l-85.3-128c-6-8.9-16-14.2-26.7-14.2H117.4c-10.7 0-20.7 5.3-26.6 14.2l-85.3 128c-14.2 21.3 1 49.8 26.6 49.8H608c25.5 0 40.7-28.5 26.6-49.8zM512 496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V224h-64v272z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStoreSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M121.51,384V284.2a119.43,119.43,0,0,1-28,3.8,123.46,123.46,0,0,1-17.1-1.2,114.88,114.88,0,0,1-15.58-3.6V480c0,17.7,13.59,32,30.4,32H505.75L348.42,384Zm-28-128.09c25.1,0,47.29-10.72,64-27.24L24,120.05c-30.52,53.39-2.45,126.53,56.49,135A95.68,95.68,0,0,0,93.48,255.91ZM602.13,458.09,547.2,413.41V283.2a93.5,93.5,0,0,1-15.57,3.6,127.31,127.31,0,0,1-17.29,1.2,114.89,114.89,0,0,1-28-3.8v79.68L348.52,251.77a88.06,88.06,0,0,0,25.41,4.14c28.11,0,53-13,70.11-33.11,17.19,20.11,42.08,33.11,70.11,33.11a94.31,94.31,0,0,0,13-.91c59.66-8.41,88-82.8,56.06-136.4L521.55,15A30.1,30.1,0,0,0,495.81,0H112A30.11,30.11,0,0,0,86.27,15L76.88,30.78,43.19,3.38A14.68,14.68,0,0,0,21.86,6.19L3.2,31.45A16.58,16.58,0,0,0,5.87,53.91L564.81,508.63a14.69,14.69,0,0,0,21.33-2.82l18.66-25.26A16.58,16.58,0,0,0,602.13,458.09Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStore(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 616 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M602 118.6L537.1 15C531.3 5.7 521 0 510 0H106C95 0 84.7 5.7 78.9 15L14 118.6c-33.5 53.5-3.8 127.9 58.8 136.4 4.5.6 9.1.9 13.7.9 29.6 0 55.8-13 73.8-33.1 18 20.1 44.3 33.1 73.8 33.1 29.6 0 55.8-13 73.8-33.1 18 20.1 44.3 33.1 73.8 33.1 29.6 0 55.8-13 73.8-33.1 18.1 20.1 44.3 33.1 73.8 33.1 4.7 0 9.2-.3 13.7-.9 62.8-8.4 92.6-82.8 59-136.4zM529.5 288c-10 0-19.9-1.5-29.5-3.8V384H116v-99.8c-9.6 2.2-19.5 3.8-29.5 3.8-6 0-12.1-.4-18-1.2-5.6-.8-11.1-2.1-16.4-3.6V480c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32V283.2c-5.4 1.6-10.8 2.9-16.4 3.6-6.1.8-12.1 1.2-18.2 1.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStream(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 128h416c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16H16C7.16 32 0 39.16 0 48v64c0 8.84 7.16 16 16 16zm480 80H80c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm-64 176H16c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStreetView(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M367.9 329.76c-4.62 5.3-9.78 10.1-15.9 13.65v22.94c66.52 9.34 112 28.05 112 49.65 0 30.93-93.12 56-208 56S48 446.93 48 416c0-21.6 45.48-40.3 112-49.65v-22.94c-6.12-3.55-11.28-8.35-15.9-13.65C58.87 345.34 0 378.05 0 416c0 53.02 114.62 96 256 96s256-42.98 256-96c0-37.95-58.87-70.66-144.1-86.24zM256 128c35.35 0 64-28.65 64-64S291.35 0 256 0s-64 28.65-64 64 28.65 64 64 64zm-64 192v96c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-96c17.67 0 32-14.33 32-32v-96c0-26.51-21.49-48-48-48h-11.8c-11.07 5.03-23.26 8-36.2 8s-25.13-2.97-36.2-8H208c-26.51 0-48 21.49-48 48v96c0 17.67 14.33 32 32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStrikethrough(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 224H293.9l-87.17-26.83A43.55 43.55 0 0 1 219.55 112h66.79A49.89 49.89 0 0 1 331 139.58a16 16 0 0 0 21.46 7.15l42.94-21.47a16 16 0 0 0 7.16-21.46l-.53-1A128 128 0 0 0 287.51 32h-68a123.68 123.68 0 0 0-123 135.64c2 20.89 10.1 39.83 21.78 56.36H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h480a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-180.24 96A43 43 0 0 1 336 356.45 43.59 43.59 0 0 1 292.45 400h-66.79A49.89 49.89 0 0 1 181 372.42a16 16 0 0 0-21.46-7.15l-42.94 21.47a16 16 0 0 0-7.16 21.46l.53 1A128 128 0 0 0 224.49 480h68a123.68 123.68 0 0 0 123-135.64 114.25 114.25 0 0 0-5.34-24.36z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaStroopwafel(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M188.12 210.74L142.86 256l45.25 45.25L233.37 256l-45.25-45.26zm113.13-22.62L256 142.86l-45.25 45.25L256 233.37l45.25-45.25zm-90.5 135.76L256 369.14l45.26-45.26L256 278.63l-45.25 45.25zM256 0C114.62 0 0 114.62 0 256s114.62 256 256 256 256-114.62 256-256S397.38 0 256 0zm186.68 295.6l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-28.29-28.29-45.25 45.25 33.94 33.94 16.97-16.97c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-16.97 16.97 16.97 16.97c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-16.97-16.97-16.97 16.97c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l16.97-16.97-33.94-33.94-45.26 45.26 28.29 28.29c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0L256 414.39l-28.29 28.29c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l28.29-28.29-45.25-45.26-33.94 33.94 16.97 16.97c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-16.97-16.97-16.97 16.97c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l16.97-16.97-16.97-16.97c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l16.97 16.97 33.94-33.94-45.25-45.25-28.29 28.29c-3.12 3.12-8.19 3.12-11.31 0L69.32 295.6c-3.12-3.12-3.12-8.19 0-11.31L97.61 256l-28.29-28.29c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l28.29 28.29 45.25-45.26-33.94-33.94-16.97 16.97c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l16.97-16.97-16.97-16.97c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l16.97 16.97 16.97-16.97c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-16.97 16.97 33.94 33.94 45.26-45.25-28.29-28.29c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0L256 97.61l28.29-28.29c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-28.29 28.29 45.26 45.25 33.94-33.94-16.97-16.97c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l16.97 16.97 16.97-16.97c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-16.97 16.97 16.97 16.97c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-16.97-16.97-33.94 33.94 45.25 45.26 28.29-28.29c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31L414.39 256l28.29 28.28a8.015 8.015 0 0 1 0 11.32zM278.63 256l45.26 45.25L369.14 256l-45.25-45.26L278.63 256z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSubscript(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 448h-16V304a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 400 352h16v96h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM336 64h-67a16 16 0 0 0-13.14 6.87l-79.9 115-79.9-115A16 16 0 0 0 83 64H16A16 16 0 0 0 0 80v48a16 16 0 0 0 16 16h33.48l77.81 112-77.81 112H16a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h67a16 16 0 0 0 13.14-6.87l79.9-115 79.9 115A16 16 0 0 0 269 448h67a16 16 0 0 0 16-16v-48a16 16 0 0 0-16-16h-33.48l-77.81-112 77.81-112H336a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSubway(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 96v256c0 51.815-61.624 96-130.022 96l62.98 49.721C386.905 502.417 383.562 512 376 512H72c-7.578 0-10.892-9.594-4.957-14.279L130.022 448C61.82 448 0 403.954 0 352V96C0 42.981 64 0 128 0h192c65 0 128 42.981 128 96zM200 232V120c0-13.255-10.745-24-24-24H72c-13.255 0-24 10.745-24 24v112c0 13.255 10.745 24 24 24h104c13.255 0 24-10.745 24-24zm200 0V120c0-13.255-10.745-24-24-24H272c-13.255 0-24 10.745-24 24v112c0 13.255 10.745 24 24 24h104c13.255 0 24-10.745 24-24zm-48 56c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm-256 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSuitcaseRolling(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 160H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h16v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16h128v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16h16c26.51 0 48-21.49 48-48V208c0-26.51-21.49-48-48-48zm-16 216c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h240c4.42 0 8 3.58 8 8v16zm0-96c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h240c4.42 0 8 3.58 8 8v16zM144 48h96v80h48V48c0-26.51-21.49-48-48-48h-96c-26.51 0-48 21.49-48 48v80h48V48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSuitcase(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 480h256V80c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48v400zm64-384h128v32H192V96zm320 80v256c0 26.5-21.5 48-48 48h-48V128h48c26.5 0 48 21.5 48 48zM96 480H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48h48v352z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSun(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 160c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96zm246.4 80.5l-94.7-47.3 33.5-100.4c4.5-13.6-8.4-26.5-21.9-21.9l-100.4 33.5-47.4-94.8c-6.4-12.8-24.6-12.8-31 0l-47.3 94.7L92.7 70.8c-13.6-4.5-26.5 8.4-21.9 21.9l33.5 100.4-94.7 47.4c-12.8 6.4-12.8 24.6 0 31l94.7 47.3-33.5 100.5c-4.5 13.6 8.4 26.5 21.9 21.9l100.4-33.5 47.3 94.7c6.4 12.8 24.6 12.8 31 0l47.3-94.7 100.4 33.5c13.6 4.5 26.5-8.4 21.9-21.9l-33.5-100.4 94.7-47.3c13-6.5 13-24.7.2-31.1zm-155.9 106c-49.9 49.9-131.1 49.9-181 0-49.9-49.9-49.9-131.1 0-181 49.9-49.9 131.1-49.9 181 0 49.9 49.9 49.9 131.1 0 181z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSuperscript(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 160h-16V16a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 400 64h16v96h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM336 64h-67a16 16 0 0 0-13.14 6.87l-79.9 115-79.9-115A16 16 0 0 0 83 64H16A16 16 0 0 0 0 80v48a16 16 0 0 0 16 16h33.48l77.81 112-77.81 112H16a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h67a16 16 0 0 0 13.14-6.87l79.9-115 79.9 115A16 16 0 0 0 269 448h67a16 16 0 0 0 16-16v-48a16 16 0 0 0-16-16h-33.48l-77.81-112 77.81-112H336a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSurprise(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM136 208c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm112 208c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm80-176c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSwatchbook(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M434.66,167.71h0L344.5,77.36a31.83,31.83,0,0,0-45-.07h0l-.07.07L224,152.88V424L434.66,212.9A32,32,0,0,0,434.66,167.71ZM480,320H373.09L186.68,506.51c-2.06,2.07-4.5,3.58-6.68,5.49H480a32,32,0,0,0,32-32V352A32,32,0,0,0,480,320ZM192,32A32,32,0,0,0,160,0H32A32,32,0,0,0,0,32V416a96,96,0,0,0,192,0ZM96,440a24,24,0,1,1,24-24A24,24,0,0,1,96,440Zm32-184H64V192h64Zm0-128H64V64h64Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSwimmer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M189.61 310.58c3.54 3.26 15.27 9.42 34.39 9.42s30.86-6.16 34.39-9.42c16.02-14.77 34.5-22.58 53.46-22.58h16.3c18.96 0 37.45 7.81 53.46 22.58 3.54 3.26 15.27 9.42 34.39 9.42s30.86-6.16 34.39-9.42c14.86-13.71 31.88-21.12 49.39-22.16l-112.84-80.6 18-12.86c3.64-2.58 8.28-3.52 12.62-2.61l100.35 21.53c25.91 5.53 51.44-10.97 57-36.88 5.55-25.92-10.95-51.44-36.88-57L437.68 98.47c-30.73-6.58-63.02.12-88.56 18.38l-80.02 57.17c-10.38 7.39-19.36 16.44-26.72 26.94L173.75 299c5.47 3.23 10.82 6.93 15.86 11.58zM624 352h-16c-26.04 0-45.8-8.42-56.09-17.9-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C461.8 343.58 442.04 352 416 352s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C269.8 343.58 250.04 352 224 352s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C77.8 343.58 58.04 352 32 352H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16c38.62 0 72.72-12.19 96-31.84 23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84h16c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-512-96c44.18 0 80-35.82 80-80s-35.82-80-80-80-80 35.82-80 80 35.82 80 80 80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSwimmingPool(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 416h-16c-26.04 0-45.8-8.42-56.09-17.9-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C461.8 407.58 442.04 416 416 416s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C269.8 407.58 250.04 416 224 416s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C77.8 407.58 58.04 416 32 416H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16c38.62 0 72.72-12.19 96-31.84 23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84h16c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-400-32v-96h192v96c19.12 0 30.86-6.16 34.39-9.42 9.17-8.46 19.2-14.34 29.61-18.07V128c0-17.64 14.36-32 32-32s32 14.36 32 32v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16c0-52.94-43.06-96-96-96s-96 43.06-96 96v96H224v-96c0-17.64 14.36-32 32-32s32 14.36 32 32v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16c0-52.94-43.06-96-96-96s-96 43.06-96 96v228.5c10.41 3.73 20.44 9.62 29.61 18.07 3.53 3.27 15.27 9.43 34.39 9.43z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSynagogue(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M70 196.51L6.67 268.29A26.643 26.643 0 0 0 0 285.93V512h128V239.58l-38-43.07c-5.31-6.01-14.69-6.01-20 0zm563.33 71.78L570 196.51c-5.31-6.02-14.69-6.02-20 0l-38 43.07V512h128V285.93c0-6.5-2.37-12.77-6.67-17.64zM339.99 7.01c-11.69-9.35-28.29-9.35-39.98 0l-128 102.4A32.005 32.005 0 0 0 160 134.4V512h96v-92.57c0-31.88 21.78-61.43 53.25-66.55C349.34 346.35 384 377.13 384 416v96h96V134.4c0-9.72-4.42-18.92-12.01-24.99l-128-102.4zm52.07 215.55c1.98 3.15-.29 7.24-4 7.24h-38.94L324 269.79c-1.85 2.95-6.15 2.95-8 0l-25.12-39.98h-38.94c-3.72 0-5.98-4.09-4-7.24l19.2-30.56-19.2-30.56c-1.98-3.15.29-7.24 4-7.24h38.94l25.12-40c1.85-2.95 6.15-2.95 8 0l25.12 39.98h38.95c3.71 0 5.98 4.09 4 7.24L372.87 192l19.19 30.56z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSyncAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M370.72 133.28C339.458 104.008 298.888 87.962 255.848 88c-77.458.068-144.328 53.178-162.791 126.85-1.344 5.363-6.122 9.15-11.651 9.15H24.103c-7.498 0-13.194-6.807-11.807-14.176C33.933 94.924 134.813 8 256 8c66.448 0 126.791 26.136 171.315 68.685L463.03 40.97C478.149 25.851 504 36.559 504 57.941V192c0 13.255-10.745 24-24 24H345.941c-21.382 0-32.09-25.851-16.971-40.971l41.75-41.749zM32 296h134.059c21.382 0 32.09 25.851 16.971 40.971l-41.75 41.75c31.262 29.273 71.835 45.319 114.876 45.28 77.418-.07 144.315-53.144 162.787-126.849 1.344-5.363 6.122-9.15 11.651-9.15h57.304c7.498 0 13.194 6.807 11.807 14.176C478.067 417.076 377.187 504 256 504c-66.448 0-126.791-26.136-171.315-68.685L48.97 471.03C33.851 486.149 8 475.441 8 454.059V320c0-13.255 10.745-24 24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSync(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M440.65 12.57l4 82.77A247.16 247.16 0 0 0 255.83 8C134.73 8 33.91 94.92 12.29 209.82A12 12 0 0 0 24.09 224h49.05a12 12 0 0 0 11.67-9.26 175.91 175.91 0 0 1 317-56.94l-101.46-4.86a12 12 0 0 0-12.57 12v47.41a12 12 0 0 0 12 12H500a12 12 0 0 0 12-12V12a12 12 0 0 0-12-12h-47.37a12 12 0 0 0-11.98 12.57zM255.83 432a175.61 175.61 0 0 1-146-77.8l101.8 4.87a12 12 0 0 0 12.57-12v-47.4a12 12 0 0 0-12-12H12a12 12 0 0 0-12 12V500a12 12 0 0 0 12 12h47.35a12 12 0 0 0 12-12.6l-4.15-82.57A247.17 247.17 0 0 0 255.83 504c121.11 0 221.93-86.92 243.55-201.82a12 12 0 0 0-11.8-14.18h-49.05a12 12 0 0 0-11.67 9.26A175.86 175.86 0 0 1 255.83 432z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaSyringe(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M201.5 174.8l55.7 55.8c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-55.7-55.8-45.3 45.3 55.8 55.8c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0L111 265.2l-26.4 26.4c-17.3 17.3-25.6 41.1-23 65.4l7.1 63.6L2.3 487c-3.1 3.1-3.1 8.2 0 11.3l11.3 11.3c3.1 3.1 8.2 3.1 11.3 0l66.3-66.3 63.6 7.1c23.9 2.6 47.9-5.4 65.4-23l181.9-181.9-135.7-135.7-64.9 65zm308.2-93.3L430.5 2.3c-3.1-3.1-8.2-3.1-11.3 0l-11.3 11.3c-3.1 3.1-3.1 8.2 0 11.3l28.3 28.3-45.3 45.3-56.6-56.6-17-17c-3.1-3.1-8.2-3.1-11.3 0l-33.9 33.9c-3.1 3.1-3.1 8.2 0 11.3l17 17L424.8 223l17 17c3.1 3.1 8.2 3.1 11.3 0l33.9-34c3.1-3.1 3.1-8.2 0-11.3l-73.5-73.5 45.3-45.3 28.3 28.3c3.1 3.1 8.2 3.1 11.3 0l11.3-11.3c3.1-3.2 3.1-8.2 0-11.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTableTennis(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496.2 296.5C527.7 218.7 512 126.2 449 63.1 365.1-21 229-21 145.1 63.1l-56 56.1 211.5 211.5c46.1-62.1 131.5-77.4 195.6-34.2zm-217.9 79.7L57.9 155.9c-27.3 45.3-21.7 105 17.3 144.1l34.5 34.6L6.7 424c-8.6 7.5-9.1 20.7-1 28.8l53.4 53.5c8 8.1 21.2 7.6 28.7-1L177.1 402l35.7 35.7c19.7 19.7 44.6 30.5 70.3 33.3-7.1-17-11-35.6-11-55.1-.1-13.8 2.5-27 6.2-39.7zM416 320c-53 0-96 43-96 96s43 96 96 96 96-43 96-96-43-96-96-96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTable(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM224 416H64v-96h160v96zm0-160H64v-96h160v96zm224 160H288v-96h160v96zm0-160H288v-96h160v96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTabletAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM224 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm176-108c0 6.6-5.4 12-12 12H60c-6.6 0-12-5.4-12-12V60c0-6.6 5.4-12 12-12h328c6.6 0 12 5.4 12 12v312z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTablet(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM224 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTablets(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 192C78.9 192 12.5 250.5.1 326.7c-.8 4.8 3.3 9.3 8.3 9.3h303.3c5 0 9.1-4.5 8.3-9.3C307.5 250.5 241.1 192 160 192zm151.6 176H8.4c-5 0-9.1 4.5-8.3 9.3C12.5 453.5 78.9 512 160 512s147.5-58.5 159.9-134.7c.8-4.8-3.3-9.3-8.3-9.3zM593.4 46.6c-56.5-56.5-144.2-61.4-206.9-16-4 2.9-4.3 8.9-.8 12.3L597 254.3c3.5 3.5 9.5 3.2 12.3-.8 45.5-62.7 40.6-150.4-15.9-206.9zM363 65.7c-3.5-3.5-9.5-3.2-12.3.8-45.4 62.7-40.5 150.4 15.9 206.9 56.5 56.5 144.2 61.4 206.9 15.9 4-2.9 4.3-8.9.8-12.3L363 65.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTachometerAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 32C128.94 32 0 160.94 0 320c0 52.8 14.25 102.26 39.06 144.8 5.61 9.62 16.3 15.2 27.44 15.2h443c11.14 0 21.83-5.58 27.44-15.2C561.75 422.26 576 372.8 576 320c0-159.06-128.94-288-288-288zm0 64c14.71 0 26.58 10.13 30.32 23.65-1.11 2.26-2.64 4.23-3.45 6.67l-9.22 27.67c-5.13 3.49-10.97 6.01-17.64 6.01-17.67 0-32-14.33-32-32S270.33 96 288 96zM96 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm48-160c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm246.77-72.41l-61.33 184C343.13 347.33 352 364.54 352 384c0 11.72-3.38 22.55-8.88 32H232.88c-5.5-9.45-8.88-20.28-8.88-32 0-33.94 26.5-61.43 59.9-63.59l61.34-184.01c4.17-12.56 17.73-19.45 30.36-15.17 12.57 4.19 19.35 17.79 15.17 30.36zm14.66 57.2l15.52-46.55c3.47-1.29 7.13-2.23 11.05-2.23 17.67 0 32 14.33 32 32s-14.33 32-32 32c-11.38-.01-20.89-6.28-26.57-15.22zM480 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTag(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 252.118V48C0 21.49 21.49 0 48 0h204.118a48 48 0 0 1 33.941 14.059l211.882 211.882c18.745 18.745 18.745 49.137 0 67.882L293.823 497.941c-18.745 18.745-49.137 18.745-67.882 0L14.059 286.059A48 48 0 0 1 0 252.118zM112 64c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTags(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M497.941 225.941L286.059 14.059A48 48 0 0 0 252.118 0H48C21.49 0 0 21.49 0 48v204.118a48 48 0 0 0 14.059 33.941l211.882 211.882c18.744 18.745 49.136 18.746 67.882 0l204.118-204.118c18.745-18.745 18.745-49.137 0-67.882zM112 160c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm513.941 133.823L421.823 497.941c-18.745 18.745-49.137 18.745-67.882 0l-.36-.36L527.64 323.522c16.999-16.999 26.36-39.6 26.36-63.64s-9.362-46.641-26.36-63.64L331.397 0h48.721a48 48 0 0 1 33.941 14.059l211.882 211.882c18.745 18.745 18.745 49.137 0 67.882z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTape(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 192c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64zm400 224H380.6c41.5-40.7 67.4-97.3 67.4-160 0-123.7-100.3-224-224-224S0 132.3 0 256s100.3 224 224 224h400c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-400-64c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTasks(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M139.61 35.5a12 12 0 0 0-17 0L58.93 98.81l-22.7-22.12a12 12 0 0 0-17 0L3.53 92.41a12 12 0 0 0 0 17l47.59 47.4a12.78 12.78 0 0 0 17.61 0l15.59-15.62L156.52 69a12.09 12.09 0 0 0 .09-17zm0 159.19a12 12 0 0 0-17 0l-63.68 63.72-22.7-22.1a12 12 0 0 0-17 0L3.53 252a12 12 0 0 0 0 17L51 316.5a12.77 12.77 0 0 0 17.6 0l15.7-15.69 72.2-72.22a12 12 0 0 0 .09-16.9zM64 368c-26.49 0-48.59 21.5-48.59 48S37.53 464 64 464a48 48 0 0 0 0-96zm432 16H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTaxi(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M462 241.64l-22-84.84c-9.6-35.2-41.6-60.8-76.8-60.8H352V64c0-17.67-14.33-32-32-32H192c-17.67 0-32 14.33-32 32v32h-11.2c-35.2 0-67.2 25.6-76.8 60.8l-22 84.84C21.41 248.04 0 273.47 0 304v48c0 23.63 12.95 44.04 32 55.12V448c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h256v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-40.88c19.05-11.09 32-31.5 32-55.12v-48c0-30.53-21.41-55.96-50-62.36zM96 352c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm20.55-112l17.2-66.36c2.23-8.16 9.59-13.64 15.06-13.64h214.4c5.47 0 12.83 5.48 14.85 12.86L395.45 240h-278.9zM416 352c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTeethOpen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 0H96C42.98 0 0 42.98 0 96v64c0 35.35 28.66 64 64 64h512c35.34 0 64-28.65 64-64V96c0-53.02-42.98-96-96-96zM160 176c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-32c0-26.51 21.49-48 48-48s48 21.49 48 48v32zm144 0c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-56c0-30.93 25.07-56 56-56s56 25.07 56 56v56zm144 0c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-56c0-30.93 25.07-56 56-56s56 25.07 56 56v56zm128 0c0 8.84-7.16 16-16 16h-64c-8.84 0-16-7.16-16-16v-32c0-26.51 21.49-48 48-48s48 21.49 48 48v32zm0 144H64c-35.34 0-64 28.65-64 64v32c0 53.02 42.98 96 96 96h448c53.02 0 96-42.98 96-96v-32c0-35.35-28.66-64-64-64zm-416 80c0 26.51-21.49 48-48 48s-48-21.49-48-48v-32c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v32zm144-8c0 30.93-25.07 56-56 56s-56-25.07-56-56v-24c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v24zm144 0c0 30.93-25.07 56-56 56s-56-25.07-56-56v-24c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v24zm128 8c0 26.51-21.49 48-48 48s-48-21.49-48-48v-32c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTeeth(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 0H96C42.98 0 0 42.98 0 96v320c0 53.02 42.98 96 96 96h448c53.02 0 96-42.98 96-96V96c0-53.02-42.98-96-96-96zM160 368c0 26.51-21.49 48-48 48s-48-21.49-48-48v-64c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v64zm0-128c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-64c0-26.51 21.49-48 48-48s48 21.49 48 48v64zm144 120c0 30.93-25.07 56-56 56s-56-25.07-56-56v-56c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v56zm0-120c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-88c0-30.93 25.07-56 56-56s56 25.07 56 56v88zm144 120c0 30.93-25.07 56-56 56s-56-25.07-56-56v-56c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v56zm0-120c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-88c0-30.93 25.07-56 56-56s56 25.07 56 56v88zm128 128c0 26.51-21.49 48-48 48s-48-21.49-48-48v-64c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v64zm0-128c0 8.84-7.16 16-16 16h-64c-8.84 0-16-7.16-16-16v-64c0-26.51 21.49-48 48-48s48 21.49 48 48v64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTemperatureHigh(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 0c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96zm0 128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm-160-16C256 50.1 205.9 0 144 0S32 50.1 32 112v166.5C12.3 303.2 0 334 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-34-12.3-64.9-32-89.5V112zM144 448c-44.1 0-80-35.9-80-80 0-25.5 12.2-48.9 32-63.8V112c0-26.5 21.5-48 48-48s48 21.5 48 48v192.2c19.8 14.8 32 38.3 32 63.8 0 44.1-35.9 80-80 80zm16-125.1V112c0-8.8-7.2-16-16-16s-16 7.2-16 16v210.9c-18.6 6.6-32 24.2-32 45.1 0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.5-32-45.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTemperatureLow(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 0c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96zm0 128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm-160-16C256 50.1 205.9 0 144 0S32 50.1 32 112v166.5C12.3 303.2 0 334 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-34-12.3-64.9-32-89.5V112zM144 448c-44.1 0-80-35.9-80-80 0-25.5 12.2-48.9 32-63.8V112c0-26.5 21.5-48 48-48s48 21.5 48 48v192.2c19.8 14.8 32 38.3 32 63.8 0 44.1-35.9 80-80 80zm16-125.1V304c0-8.8-7.2-16-16-16s-16 7.2-16 16v18.9c-18.6 6.6-32 24.2-32 45.1 0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.5-32-45.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTenge(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M372 160H12c-6.6 0-12 5.4-12 12v56c0 6.6 5.4 12 12 12h140v228c0 6.6 5.4 12 12 12h56c6.6 0 12-5.4 12-12V240h140c6.6 0 12-5.4 12-12v-56c0-6.6-5.4-12-12-12zm0-128H12C5.4 32 0 37.4 0 44v56c0 6.6 5.4 12 12 12h360c6.6 0 12-5.4 12-12V44c0-6.6-5.4-12-12-12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTerminal(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M257.981 272.971L63.638 467.314c-9.373 9.373-24.569 9.373-33.941 0L7.029 444.647c-9.357-9.357-9.375-24.522-.04-33.901L161.011 256 6.99 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L257.981 239.03c9.373 9.372 9.373 24.568 0 33.941zM640 456v-32c0-13.255-10.745-24-24-24H312c-13.255 0-24 10.745-24 24v32c0 13.255 10.745 24 24 24h304c13.255 0 24-10.745 24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTextHeight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304 32H16A16 16 0 0 0 0 48v96a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32h56v304H80a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h160a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-40V112h56v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm256 336h-48V144h48c14.31 0 21.33-17.31 11.31-27.31l-80-80a16 16 0 0 0-22.62 0l-80 80C379.36 126 384.36 144 400 144h48v224h-48c-14.31 0-21.32 17.31-11.31 27.31l80 80a16 16 0 0 0 22.62 0l80-80C580.64 386 575.64 368 560 368z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTextWidth(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 32H16A16 16 0 0 0 0 48v80a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-16h120v112h-24a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-24V112h120v16a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm-68.69 260.69C354 283.36 336 288.36 336 304v48H112v-48c0-14.31-17.31-21.32-27.31-11.31l-80 80a16 16 0 0 0 0 22.62l80 80C94 484.64 112 479.64 112 464v-48h224v48c0 14.31 17.31 21.33 27.31 11.31l80-80a16 16 0 0 0 0-22.62z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaThLarge(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M296 32h192c13.255 0 24 10.745 24 24v160c0 13.255-10.745 24-24 24H296c-13.255 0-24-10.745-24-24V56c0-13.255 10.745-24 24-24zm-80 0H24C10.745 32 0 42.745 0 56v160c0 13.255 10.745 24 24 24h192c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24zM0 296v160c0 13.255 10.745 24 24 24h192c13.255 0 24-10.745 24-24V296c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zm296 184h192c13.255 0 24-10.745 24-24V296c0-13.255-10.745-24-24-24H296c-13.255 0-24 10.745-24 24v160c0 13.255 10.745 24 24 24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaThList(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M149.333 216v80c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24v-80c0-13.255 10.745-24 24-24h101.333c13.255 0 24 10.745 24 24zM0 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zM125.333 32H24C10.745 32 0 42.745 0 56v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24zm80 448H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zm-24-424v80c0 13.255 10.745 24 24 24H488c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24zm24 264H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTh(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M149.333 56v80c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V56c0-13.255 10.745-24 24-24h101.333c13.255 0 24 10.745 24 24zm181.334 240v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.256 0 24.001-10.745 24.001-24zm32-240v80c0 13.255 10.745 24 24 24H488c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24zm-32 80V56c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.256 0 24.001-10.745 24.001-24zm-205.334 56H24c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24zM0 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zm386.667-56H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zm0 160H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zM181.333 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTheaterMasks(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M206.86 245.15c-35.88 10.45-59.95 41.2-57.53 74.1 11.4-12.72 28.81-23.7 49.9-30.92l7.63-43.18zM95.81 295L64.08 115.49c-.29-1.62.28-2.62.24-2.65 57.76-32.06 123.12-49.01 189.01-49.01 1.61 0 3.23.17 4.85.19 13.95-13.47 31.73-22.83 51.59-26 18.89-3.02 38.05-4.55 57.18-5.32-9.99-13.95-24.48-24.23-41.77-27C301.27 1.89 277.24 0 253.32 0 176.66 0 101.02 19.42 33.2 57.06 9.03 70.48-3.92 98.48 1.05 126.58l31.73 179.51c14.23 80.52 136.33 142.08 204.45 142.08 3.59 0 6.75-.46 10.01-.8-13.52-17.08-28.94-40.48-39.5-67.58-47.61-12.98-106.06-51.62-111.93-84.79zm97.55-137.46c-.73-4.12-2.23-7.87-4.07-11.4-8.25 8.91-20.67 15.75-35.32 18.32-14.65 2.58-28.67.4-39.48-5.17-.52 3.94-.64 7.98.09 12.1 3.84 21.7 24.58 36.19 46.34 32.37 21.75-3.82 36.28-24.52 32.44-46.22zM606.8 120.9c-88.98-49.38-191.43-67.41-291.98-51.35-27.31 4.36-49.08 26.26-54.04 54.36l-31.73 179.51c-15.39 87.05 95.28 196.27 158.31 207.35 63.03 11.09 204.47-53.79 219.86-140.84l31.73-179.51c4.97-28.11-7.98-56.11-32.15-69.52zm-273.24 96.8c3.84-21.7 24.58-36.19 46.34-32.36 21.76 3.83 36.28 24.52 32.45 46.22-.73 4.12-2.23 7.87-4.07 11.4-8.25-8.91-20.67-15.75-35.32-18.32-14.65-2.58-28.67-.4-39.48 5.17-.53-3.95-.65-7.99.08-12.11zm70.47 198.76c-55.68-9.79-93.52-59.27-89.04-112.9 20.6 25.54 56.21 46.17 99.49 53.78 43.28 7.61 83.82.37 111.93-16.6-14.18 51.94-66.71 85.51-122.38 75.72zm130.3-151.34c-8.25-8.91-20.68-15.75-35.33-18.32-14.65-2.58-28.67-.4-39.48 5.17-.52-3.94-.64-7.98.09-12.1 3.84-21.7 24.58-36.19 46.34-32.37 21.75 3.83 36.28 24.52 32.45 46.22-.73 4.13-2.23 7.88-4.07 11.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaThermometerEmpty(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 384c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-35.346 28.654-64 64-64s64 28.654 64 64zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaThermometerFull(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 96c0-53.019-42.981-96-96-96S32 42.981 32 96v203.347C12.225 321.756.166 351.136.002 383.333c-.359 70.303 56.787 128.176 127.089 128.664.299.002.61.003.909.003 70.698 0 128-57.304 128-128 0-32.459-12.088-62.09-32-84.653V96zm-96 368l-.576-.002c-43.86-.304-79.647-36.544-79.423-80.42.173-33.98 19.266-51.652 31.999-66.08V96c0-26.467 21.533-48 48-48s48 21.533 48 48v221.498c12.63 14.312 32 32.164 32 66.502 0 44.112-35.888 80-80 80zm64-80c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-23.685 12.876-44.349 32-55.417V96c0-17.673 14.327-32 32-32s32 14.327 32 32v232.583c19.124 11.068 32 31.732 32 55.417z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaThermometerHalf(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 384c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-23.685 12.876-44.349 32-55.417V224c0-17.673 14.327-32 32-32s32 14.327 32 32v104.583c19.124 11.068 32 31.732 32 55.417zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaThermometerQuarter(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 384c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-23.685 12.876-44.349 32-55.417V288c0-17.673 14.327-32 32-32s32 14.327 32 32v40.583c19.124 11.068 32 31.732 32 55.417zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaThermometerThreeQuarters(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 384c0 35.346-28.654 64-64 64-35.346 0-64-28.654-64-64 0-23.685 12.876-44.349 32-55.417V160c0-17.673 14.327-32 32-32s32 14.327 32 32v168.583c19.124 11.068 32 31.732 32 55.417zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaThermometer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M476.8 20.4c-37.5-30.7-95.5-26.3-131.9 10.2l-45.7 46 50.5 50.5c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-50.4-50.5-45.1 45.4 50.3 50.4c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0L209 167.4l-45.1 45.4L214 263c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-50.1-50.2L96 281.1V382L7 471c-9.4 9.4-9.4 24.6 0 33.9 9.4 9.4 24.6 9.4 33.9 0l89-89h99.9L484 162.6c34.9-34.9 42.2-101.5-7.2-142.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaThumbsDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 56v240c0 13.255 10.745 24 24 24h80c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H24C10.745 32 0 42.745 0 56zm40 200c0-13.255 10.745-24 24-24s24 10.745 24 24-10.745 24-24 24-24-10.745-24-24zm272 256c-20.183 0-29.485-39.293-33.931-57.795-5.206-21.666-10.589-44.07-25.393-58.902-32.469-32.524-49.503-73.967-89.117-113.111a11.98 11.98 0 0 1-3.558-8.521V59.901c0-6.541 5.243-11.878 11.783-11.998 15.831-.29 36.694-9.079 52.651-16.178C256.189 17.598 295.709.017 343.995 0h2.844c42.777 0 93.363.413 113.774 29.737 8.392 12.057 10.446 27.034 6.148 44.632 16.312 17.053 25.063 48.863 16.382 74.757 17.544 23.432 19.143 56.132 9.308 79.469l.11.11c11.893 11.949 19.523 31.259 19.439 49.197-.156 30.352-26.157 58.098-59.553 58.098H350.723C358.03 364.34 384 388.132 384 430.548 384 504 336 512 312 512z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaThumbsUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M104 224H24c-13.255 0-24 10.745-24 24v240c0 13.255 10.745 24 24 24h80c13.255 0 24-10.745 24-24V248c0-13.255-10.745-24-24-24zM64 472c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24zM384 81.452c0 42.416-25.97 66.208-33.277 94.548h101.723c33.397 0 59.397 27.746 59.553 58.098.084 17.938-7.546 37.249-19.439 49.197l-.11.11c9.836 23.337 8.237 56.037-9.308 79.469 8.681 25.895-.069 57.704-16.382 74.757 4.298 17.598 2.244 32.575-6.148 44.632C440.202 511.587 389.616 512 346.839 512l-2.845-.001c-48.287-.017-87.806-17.598-119.56-31.725-15.957-7.099-36.821-15.887-52.651-16.178-6.54-.12-11.783-5.457-11.783-11.998v-213.77c0-3.2 1.282-6.271 3.558-8.521 39.614-39.144 56.648-80.587 89.117-113.111 14.804-14.832 20.188-37.236 25.393-58.902C282.515 39.293 291.817 0 312 0c24 0 72 8 72 81.452z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaThumbtack(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M298.028 214.267L285.793 96H328c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24H56C42.745 0 32 10.745 32 24v48c0 13.255 10.745 24 24 24h42.207L85.972 214.267C37.465 236.82 0 277.261 0 328c0 13.255 10.745 24 24 24h136v104.007c0 1.242.289 2.467.845 3.578l24 48c2.941 5.882 11.364 5.893 14.311 0l24-48a8.008 8.008 0 0 0 .845-3.578V352h136c13.255 0 24-10.745 24-24-.001-51.183-37.983-91.42-85.973-113.733z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTicketAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 160h320v192H128V160zm400 96c0 26.51 21.49 48 48 48v96c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48v-96c26.51 0 48-21.49 48-48s-21.49-48-48-48v-96c0-26.51 21.49-48 48-48h480c26.51 0 48 21.49 48 48v96c-26.51 0-48 21.49-48 48zm-48-104c0-13.255-10.745-24-24-24H120c-13.255 0-24 10.745-24 24v208c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V152z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTimesCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTimes(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 352 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTintSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M633.82 458.1L494.97 350.78c.52-5.57 1.03-11.16 1.03-16.87 0-111.76-99.79-153.34-146.78-311.82-7.94-28.78-49.44-30.12-58.44 0-15.52 52.34-36.87 91.96-58.49 125.68L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.36 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.41-6.97 4.16-17.02-2.82-22.45zM144 333.91C144 432.35 222.72 512 320 512c44.71 0 85.37-16.96 116.4-44.7L162.72 255.78c-11.41 23.5-18.72 48.35-18.72 78.13z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTint(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 352 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M205.22 22.09c-7.94-28.78-49.44-30.12-58.44 0C100.01 179.85 0 222.72 0 333.91 0 432.35 78.72 512 176 512s176-79.65 176-178.09c0-111.75-99.79-153.34-146.78-311.82zM176 448c-61.75 0-112-50.25-112-112 0-8.84 7.16-16 16-16s16 7.16 16 16c0 44.11 35.89 80 80 80 8.84 0 16 7.16 16 16s-7.16 16-16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTired(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm33.8 189.7l80-48c11.6-6.9 24 7.7 15.4 18L343.6 208l33.6 40.3c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.7-4.7-7.7-15.9 0-20.6zm-163-30c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.8 4.7 7.8 15.9 0 20.6l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3zM248 288c51.9 0 115.3 43.8 123.2 106.7 1.7 13.6-8 24.6-17.7 20.4-25.9-11.1-64.4-17.4-105.5-17.4s-79.6 6.3-105.5 17.4c-9.8 4.2-19.4-7-17.7-20.4C132.7 331.8 196.1 288 248 288z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaToggleOff(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 64H192C85.961 64 0 149.961 0 256s85.961 192 192 192h192c106.039 0 192-85.961 192-192S490.039 64 384 64zM64 256c0-70.741 57.249-128 128-128 70.741 0 128 57.249 128 128 0 70.741-57.249 128-128 128-70.741 0-128-57.249-128-128zm320 128h-48.905c65.217-72.858 65.236-183.12 0-256H384c70.741 0 128 57.249 128 128 0 70.74-57.249 128-128 128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaToggleOn(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 64H192C86 64 0 150 0 256s86 192 192 192h192c106 0 192-86 192-192S490 64 384 64zm0 320c-70.8 0-128-57.3-128-128 0-70.8 57.3-128 128-128 70.8 0 128 57.3 128 128 0 70.8-57.3 128-128 128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaToiletPaperSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64,192V364.13c0,41.12-9.75,62.75-31.12,126.87A16,16,0,0,0,48,512H328.86a31.87,31.87,0,0,0,30.38-21.87c9.31-27.83,18-53.35,22.18-85.55l-316-244.25C64.53,170.66,64,181.19,64,192ZM633.82,458.09l-102-78.81C575.28,360.91,608,284.32,608,192,608,86,565,0,512,0s-96,86-96,192c0,42,7,80.4,18.43,112L384,265V192c0-83.62,23.63-153.5,60.5-192H160c-23.33,0-44.63,16.83-61.26,44.53L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.45A16,16,0,0,0,6.18,53.91L594.54,508.63A16,16,0,0,0,617,505.81l19.64-25.26A16,16,0,0,0,633.82,458.09ZM512,256c-17.63,0-32-28.62-32-64s14.37-64,32-64,32,28.63,32,64S529.62,256,512,256Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaToiletPaper(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 0C74.98 0 32 85.96 32 192v172.07c0 41.12-9.8 62.77-31.17 126.87C-2.62 501.3 5.09 512 16.01 512h280.92c13.77 0 26-8.81 30.36-21.88 12.83-38.48 24.71-72.4 24.71-126.05V192c0-83.6 23.67-153.52 60.44-192H128zM96 224c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm64 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm64 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm64 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zM480 0c-53.02 0-96 85.96-96 192s42.98 192 96 192 96-85.96 96-192S533.02 0 480 0zm0 256c-17.67 0-32-28.65-32-64s14.33-64 32-64 32 28.65 32 64-14.33 64-32 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaToilet(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 48c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H16C7.2 0 0 7.2 0 16v16c0 8.8 7.2 16 16 16h16v156.7C11.8 214.8 0 226.9 0 240c0 67.2 34.6 126.2 86.8 160.5l-21.4 70.2C59.1 491.2 74.5 512 96 512h192c21.5 0 36.9-20.8 30.6-41.3l-21.4-70.2C349.4 366.2 384 307.2 384 240c0-13.1-11.8-25.2-32-35.3V48h16zM80 72c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H88c-4.4 0-8-3.6-8-8V72zm112 200c-77.1 0-139.6-14.3-139.6-32s62.5-32 139.6-32 139.6 14.3 139.6 32-62.5 32-139.6 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaToolbox(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M502.63 214.63l-45.25-45.25c-6-6-14.14-9.37-22.63-9.37H384V80c0-26.51-21.49-48-48-48H176c-26.51 0-48 21.49-48 48v80H77.25c-8.49 0-16.62 3.37-22.63 9.37L9.37 214.63c-6 6-9.37 14.14-9.37 22.63V320h128v-16c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v16h128v-16c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v16h128v-82.75c0-8.48-3.37-16.62-9.37-22.62zM320 160H192V96h128v64zm64 208c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-16H192v16c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-16H0v96c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32v-96H384v16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTools(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M501.1 395.7L384 278.6c-23.1-23.1-57.6-27.6-85.4-13.9L192 158.1V96L64 0 0 64l96 128h62.1l106.6 106.6c-13.6 27.8-9.2 62.3 13.9 85.4l117.1 117.1c14.6 14.6 38.2 14.6 52.7 0l52.7-52.7c14.5-14.6 14.5-38.2 0-52.7zM331.7 225c28.3 0 54.9 11 74.9 31l19.4 19.4c15.8-6.9 30.8-16.5 43.8-29.5 37.1-37.1 49.7-89.3 37.9-136.7-2.2-9-13.5-12.1-20.1-5.5l-74.4 74.4-67.9-11.3L334 98.9l74.4-74.4c6.6-6.6 3.4-17.9-5.7-20.2-47.4-11.7-99.6.9-136.6 37.9-28.5 28.5-41.9 66.1-41.2 103.6l82.1 82.1c8.1-1.9 16.5-2.9 24.7-2.9zm-103.9 82l-56.7-56.7L18.7 402.8c-25 25-25 65.5 0 90.5s65.5 25 90.5 0l123.6-123.6c-7.6-19.9-9.9-41.6-5-62.7zM64 472c-13.2 0-24-10.8-24-24 0-13.3 10.7-24 24-24s24 10.7 24 24c0 13.2-10.7 24-24 24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTooth(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M443.98 96.25c-11.01-45.22-47.11-82.06-92.01-93.72-32.19-8.36-63 5.1-89.14 24.33-3.25 2.39-6.96 3.73-10.5 5.48l28.32 18.21c7.42 4.77 9.58 14.67 4.8 22.11-4.46 6.95-14.27 9.86-22.11 4.8L162.83 12.84c-20.7-10.85-43.38-16.4-66.81-10.31-44.9 11.67-81 48.5-92.01 93.72-10.13 41.62-.42 80.81 21.5 110.43 23.36 31.57 32.68 68.66 36.29 107.35 4.4 47.16 10.33 94.16 20.94 140.32l7.8 33.95c3.19 13.87 15.49 23.7 29.67 23.7 13.97 0 26.15-9.55 29.54-23.16l34.47-138.42c4.56-18.32 20.96-31.16 39.76-31.16s35.2 12.85 39.76 31.16l34.47 138.42c3.39 13.61 15.57 23.16 29.54 23.16 14.18 0 26.48-9.83 29.67-23.7l7.8-33.95c10.61-46.15 16.53-93.16 20.94-140.32 3.61-38.7 12.93-75.78 36.29-107.35 21.95-29.61 31.66-68.8 21.53-110.43z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTorah(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320.05 366.48l17.72-29.64h-35.46zm99.21-166H382.4l18.46 30.82zM48 0C21.49 0 0 14.33 0 32v448c0 17.67 21.49 32 48 32s48-14.33 48-32V32C96 14.33 74.51 0 48 0zm172.74 311.5h36.85l-18.46-30.82zm161.71 0h36.86l-18.45-30.8zM128 464h384V48H128zm66.77-278.13a21.22 21.22 0 0 1 18.48-10.71h59.45l29.13-48.71a21.13 21.13 0 0 1 18.22-10.37A20.76 20.76 0 0 1 338 126.29l29.25 48.86h59.52a21.12 21.12 0 0 1 18.1 32L415.63 256 445 305a20.69 20.69 0 0 1 .24 21.12 21.25 21.25 0 0 1-18.48 10.72h-59.47l-29.13 48.7a21.13 21.13 0 0 1-18.16 10.4 20.79 20.79 0 0 1-18-10.22l-29.25-48.88h-59.5a21.11 21.11 0 0 1-18.1-32L224.36 256 195 207a20.7 20.7 0 0 1-.23-21.13zM592 0c-26.51 0-48 14.33-48 32v448c0 17.67 21.49 32 48 32s48-14.33 48-32V32c0-17.67-21.49-32-48-32zM320 145.53l-17.78 29.62h35.46zm-62.45 55h-36.81l18.44 30.8zm29.58 111h65.79L386.09 256l-33.23-55.52h-65.79L253.9 256z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaToriiGate(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M376.45 32h-240.9A303.17 303.17 0 0 1 0 0v96c0 17.67 14.33 32 32 32h32v64H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h48v240c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V256h256v240c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V256h48c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16h-48v-64h32c17.67 0 32-14.33 32-32V0a303.17 303.17 0 0 1-135.55 32zM128 128h96v64h-96v-64zm256 64h-96v-64h96v64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTractor(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528 336c-48.6 0-88 39.4-88 88s39.4 88 88 88 88-39.4 88-88-39.4-88-88-88zm0 112c-13.23 0-24-10.77-24-24s10.77-24 24-24 24 10.77 24 24-10.77 24-24 24zm80-288h-64v-40.2c0-14.12 4.7-27.76 13.15-38.84 4.42-5.8 3.55-14.06-1.32-19.49L534.2 37.3c-6.66-7.45-18.32-6.92-24.7.78C490.58 60.9 480 89.81 480 119.8V160H377.67L321.58 29.14A47.914 47.914 0 0 0 277.45 0H144c-26.47 0-48 21.53-48 48v146.52c-8.63-6.73-20.96-6.46-28.89 1.47L36 227.1c-8.59 8.59-8.59 22.52 0 31.11l5.06 5.06c-4.99 9.26-8.96 18.82-11.91 28.72H22c-12.15 0-22 9.85-22 22v44c0 12.15 9.85 22 22 22h7.14c2.96 9.91 6.92 19.46 11.91 28.73l-5.06 5.06c-8.59 8.59-8.59 22.52 0 31.11L67.1 476c8.59 8.59 22.52 8.59 31.11 0l5.06-5.06c9.26 4.99 18.82 8.96 28.72 11.91V490c0 12.15 9.85 22 22 22h44c12.15 0 22-9.85 22-22v-7.14c9.9-2.95 19.46-6.92 28.72-11.91l5.06 5.06c8.59 8.59 22.52 8.59 31.11 0l31.11-31.11c8.59-8.59 8.59-22.52 0-31.11l-5.06-5.06c4.99-9.26 8.96-18.82 11.91-28.72H330c12.15 0 22-9.85 22-22v-6h80.54c21.91-28.99 56.32-48 95.46-48 18.64 0 36.07 4.61 51.8 12.2l50.82-50.82c6-6 9.37-14.14 9.37-22.63V192c.01-17.67-14.32-32-31.99-32zM176 416c-44.18 0-80-35.82-80-80s35.82-80 80-80 80 35.82 80 80-35.82 80-80 80zm22-256h-38V64h106.89l41.15 96H198z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTrademark(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M260.6 96H12c-6.6 0-12 5.4-12 12v43.1c0 6.6 5.4 12 12 12h85.1V404c0 6.6 5.4 12 12 12h54.3c6.6 0 12-5.4 12-12V163.1h85.1c6.6 0 12-5.4 12-12V108c.1-6.6-5.3-12-11.9-12zM640 403l-24-296c-.5-6.2-5.7-11-12-11h-65.4c-5.1 0-9.7 3.3-11.3 8.1l-43.8 127.1c-7.2 20.6-16.1 52.8-16.1 52.8h-.9s-8.9-32.2-16.1-52.8l-43.8-127.1c-1.7-4.8-6.2-8.1-11.3-8.1h-65.4c-6.2 0-11.4 4.8-12 11l-24.4 296c-.6 7 4.9 13 12 13H360c6.3 0 11.5-4.9 12-11.2l9.1-132.9c1.8-24.2 0-53.7 0-53.7h.9s10.7 33.6 17.9 53.7l30.7 84.7c1.7 4.7 6.2 7.9 11.3 7.9h50.3c5.1 0 9.6-3.2 11.3-7.9l30.7-84.7c7.2-20.1 17.9-53.7 17.9-53.7h.9s-1.8 29.5 0 53.7l9.1 132.9c.4 6.3 5.7 11.2 12 11.2H628c7 0 12.5-6 12-13z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTrafficLight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 192h-64v-37.88c37.2-13.22 64-48.38 64-90.12h-64V32c0-17.67-14.33-32-32-32H96C78.33 0 64 14.33 64 32v32H0c0 41.74 26.8 76.9 64 90.12V192H0c0 41.74 26.8 76.9 64 90.12V320H0c0 42.84 28.25 78.69 66.99 91.05C79.42 468.72 130.6 512 192 512s112.58-43.28 125.01-100.95C355.75 398.69 384 362.84 384 320h-64v-37.88c37.2-13.22 64-48.38 64-90.12zM192 416c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm0-128c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm0-128c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTrailer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624,320H544V80a16,16,0,0,0-16-16H16A16,16,0,0,0,0,80V368a16,16,0,0,0,16,16H65.61c7.83-54.21,54-96,110.39-96s102.56,41.79,110.39,96H624a16,16,0,0,0,16-16V336A16,16,0,0,0,624,320ZM96,243.68a176.29,176.29,0,0,0-32,20.71V136a8,8,0,0,1,8-8H88a8,8,0,0,1,8,8Zm96-18.54c-5.31-.49-10.57-1.14-16-1.14s-10.69.65-16,1.14V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8Zm96,39.25a176.29,176.29,0,0,0-32-20.71V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8ZM384,320H352V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8Zm96,0H448V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8Zm-304,0a80,80,0,1,0,80,80A80,80,0,0,0,176,320Zm0,112a32,32,0,1,1,32-32A32,32,0,0,1,176,432Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTrain(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 96v256c0 51.815-61.624 96-130.022 96l62.98 49.721C386.905 502.417 383.562 512 376 512H72c-7.578 0-10.892-9.594-4.957-14.279L130.022 448C61.82 448 0 403.954 0 352V96C0 42.981 64 0 128 0h192c65 0 128 42.981 128 96zm-48 136V120c0-13.255-10.745-24-24-24H72c-13.255 0-24 10.745-24 24v112c0 13.255 10.745 24 24 24h304c13.255 0 24-10.745 24-24zm-176 64c-30.928 0-56 25.072-56 56s25.072 56 56 56 56-25.072 56-56-25.072-56-56-56z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTram(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 64c17.7 0 32-14.3 32-32S305.7 0 288 0s-32 14.3-32 32 14.3 32 32 32zm223.5-12.1c-2.3-8.6-11-13.6-19.6-11.3l-480 128c-8.5 2.3-13.6 11-11.3 19.6C2.5 195.3 8.9 200 16 200c1.4 0 2.8-.2 4.1-.5L240 140.8V224H64c-17.7 0-32 14.3-32 32v224c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32H272v-91.7l228.1-60.8c8.6-2.3 13.6-11.1 11.4-19.6zM176 384H80v-96h96v96zm160-96h96v96h-96v-96zm-32 0v96h-96v-96h96zM192 96c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTransgenderAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 480 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M468 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-80.7 80.7C294.5 104.1 268.2 96 240 96c-28.2 0-54.5 8.1-76.7 22.1l-16.5-16.5 19.8-19.8c4.7-4.7 4.7-12.3 0-17l-28.3-28.3c-4.7-4.7-12.3-4.7-17 0l-19.8 19.8-19-19 16.9-16.9C107.1 12.9 101.7 0 91 0H12C5.4 0 0 5.4 0 12v79c0 10.7 12.9 16 20.5 8.5l16.9-16.9 19 19-19.8 19.8c-4.7 4.7-4.7 12.3 0 17l28.3 28.3c4.7 4.7 12.3 4.7 17 0l19.8-19.8 16.5 16.5C104.1 185.5 96 211.8 96 240c0 68.5 47.9 125.9 112 140.4V408h-36c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v28c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-28h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-27.6c64.1-14.6 112-71.9 112-140.4 0-28.2-8.1-54.5-22.1-76.7l80.7-80.7 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V12c0-6.6-5.4-12-12-12zM240 320c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTransgender(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M372 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-80.7 80.7C198.5 104.1 172.2 96 144 96 64.5 96 0 160.5 0 240c0 68.5 47.9 125.9 112 140.4V408H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v28c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-28h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-27.6c64.1-14.6 112-71.9 112-140.4 0-28.2-8.1-54.5-22.1-76.7l80.7-80.7 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V12c0-6.6-5.4-12-12-12zM144 320c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTrashAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm272-256a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTrashRestoreAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm91.31-172.8l89.38-94.26a15.41 15.41 0 0 1 22.62 0l89.38 94.26c10.08 10.62 2.94 28.8-11.32 28.8H256v112a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V320h-57.37c-14.26 0-21.4-18.18-11.32-28.8zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTrashRestore(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32zm70.11-175.8l89.38-94.26a15.41 15.41 0 0 1 22.62 0l89.38 94.26c10.08 10.62 2.94 28.8-11.32 28.8H256v112a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V320h-57.37c-14.26 0-21.4-18.18-11.32-28.8zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTrash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTree(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M378.31 378.49L298.42 288h30.63c9.01 0 16.98-5 20.78-13.06 3.8-8.04 2.55-17.26-3.28-24.05L268.42 160h28.89c9.1 0 17.3-5.35 20.86-13.61 3.52-8.13 1.86-17.59-4.24-24.08L203.66 4.83c-6.03-6.45-17.28-6.45-23.32 0L70.06 122.31c-6.1 6.49-7.75 15.95-4.24 24.08C69.38 154.65 77.59 160 86.69 160h28.89l-78.14 90.91c-5.81 6.78-7.06 15.99-3.27 24.04C37.97 283 45.93 288 54.95 288h30.63L5.69 378.49c-6 6.79-7.36 16.09-3.56 24.26 3.75 8.05 12 13.25 21.01 13.25H160v24.45l-30.29 48.4c-5.32 10.64 2.42 23.16 14.31 23.16h95.96c11.89 0 19.63-12.52 14.31-23.16L224 440.45V416h136.86c9.01 0 17.26-5.2 21.01-13.25 3.8-8.17 2.44-17.47-3.56-24.26z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTrophy(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M552 64H448V24c0-13.3-10.7-24-24-24H152c-13.3 0-24 10.7-24 24v40H24C10.7 64 0 74.7 0 88v56c0 35.7 22.5 72.4 61.9 100.7 31.5 22.7 69.8 37.1 110 41.7C203.3 338.5 240 360 240 360v72h-48c-35.3 0-64 20.7-64 56v12c0 6.6 5.4 12 12 12h296c6.6 0 12-5.4 12-12v-12c0-35.3-28.7-56-64-56h-48v-72s36.7-21.5 68.1-73.6c40.3-4.6 78.6-19 110-41.7 39.3-28.3 61.9-65 61.9-100.7V88c0-13.3-10.7-24-24-24zM99.3 192.8C74.9 175.2 64 155.6 64 144v-16h64.2c1 32.6 5.8 61.2 12.8 86.2-15.1-5.2-29.2-12.4-41.7-21.4zM512 144c0 16.1-17.7 36.1-35.3 48.8-12.5 9-26.7 16.2-41.8 21.4 7-25 11.8-53.6 12.8-86.2H512v16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTruckLoading(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M50.2 375.6c2.3 8.5 11.1 13.6 19.6 11.3l216.4-58c8.5-2.3 13.6-11.1 11.3-19.6l-49.7-185.5c-2.3-8.5-11.1-13.6-19.6-11.3L151 133.3l24.8 92.7-61.8 16.5-24.8-92.7-77.3 20.7C3.4 172.8-1.7 181.6.6 190.1l49.6 185.5zM384 0c-17.7 0-32 14.3-32 32v323.6L5.9 450c-4.3 1.2-6.8 5.6-5.6 9.8l12.6 46.3c1.2 4.3 5.6 6.8 9.8 5.6l393.7-107.4C418.8 464.1 467.6 512 528 512c61.9 0 112-50.1 112-112V0H384zm144 448c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTruckMonster(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 224h-16v-64c0-17.67-14.33-32-32-32h-73.6L419.22 24.02A64.025 64.025 0 0 0 369.24 0H256c-17.67 0-32 14.33-32 32v96H48c-8.84 0-16 7.16-16 16v80H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16.72c29.21-38.65 75.1-64 127.28-64s98.07 25.35 127.28 64h65.45c29.21-38.65 75.1-64 127.28-64s98.07 25.35 127.28 64H624c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-336-96V64h81.24l51.2 64H288zm304 224h-5.2c-2.2-7.33-5.07-14.28-8.65-20.89l3.67-3.67c6.25-6.25 6.25-16.38 0-22.63l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0l-3.67 3.67A110.85 110.85 0 0 0 512 277.2V272c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v5.2c-7.33 2.2-14.28 5.07-20.89 8.65l-3.67-3.67c-6.25-6.25-16.38-6.25-22.63 0l-22.63 22.63c-6.25 6.25-6.25 16.38 0 22.63l3.67 3.67A110.85 110.85 0 0 0 373.2 352H368c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h5.2c2.2 7.33 5.07 14.28 8.65 20.89l-3.67 3.67c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l3.67-3.67c6.61 3.57 13.57 6.45 20.9 8.65v5.2c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-5.2c7.33-2.2 14.28-5.07 20.9-8.65l3.67 3.67c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.25-6.25 6.25-16.38 0-22.63l-3.67-3.67a110.85 110.85 0 0 0 8.65-20.89h5.2c8.84 0 16-7.16 16-16v-32c-.02-8.84-7.18-16-16.02-16zm-112 80c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm-208-80h-5.2c-2.2-7.33-5.07-14.28-8.65-20.89l3.67-3.67c6.25-6.25 6.25-16.38 0-22.63l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0l-3.67 3.67A110.85 110.85 0 0 0 192 277.2V272c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v5.2c-7.33 2.2-14.28 5.07-20.89 8.65l-3.67-3.67c-6.25-6.25-16.38-6.25-22.63 0L58.18 304.8c-6.25 6.25-6.25 16.38 0 22.63l3.67 3.67a110.85 110.85 0 0 0-8.65 20.89H48c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h5.2c2.2 7.33 5.07 14.28 8.65 20.89l-3.67 3.67c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l3.67-3.67c6.61 3.57 13.57 6.45 20.9 8.65v5.2c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-5.2c7.33-2.2 14.28-5.07 20.9-8.65l3.67 3.67c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.25-6.25 6.25-16.38 0-22.63l-3.67-3.67a110.85 110.85 0 0 0 8.65-20.89h5.2c8.84 0 16-7.16 16-16v-32C288 359.16 280.84 352 272 352zm-112 80c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTruckMoving(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M621.3 237.3l-58.5-58.5c-12-12-28.3-18.7-45.3-18.7H480V64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64v336c0 44.2 35.8 80 80 80 26.3 0 49.4-12.9 64-32.4 14.6 19.6 37.7 32.4 64 32.4 44.2 0 80-35.8 80-80 0-5.5-.6-10.8-1.6-16h163.2c-1.1 5.2-1.6 10.5-1.6 16 0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16H624c8.8 0 16-7.2 16-16v-85.5c0-17-6.7-33.2-18.7-45.2zM80 432c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm128 0c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm272-224h37.5c4.3 0 8.3 1.7 11.3 4.7l43.3 43.3H480v-48zm48 224c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTruckPickup(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 288h-16v-64c0-17.67-14.33-32-32-32h-48L419.22 56.02A64.025 64.025 0 0 0 369.24 32H256c-17.67 0-32 14.33-32 32v128H64c-17.67 0-32 14.33-32 32v64H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h49.61c-.76 5.27-1.61 10.52-1.61 16 0 61.86 50.14 112 112 112s112-50.14 112-112c0-5.48-.85-10.73-1.61-16h67.23c-.76 5.27-1.61 10.52-1.61 16 0 61.86 50.14 112 112 112s112-50.14 112-112c0-5.48-.85-10.73-1.61-16H624c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM288 96h81.24l76.8 96H288V96zM176 416c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48zm288 0c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTruck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h16c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm320 0c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTshirt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M631.2 96.5L436.5 0C416.4 27.8 371.9 47.2 320 47.2S223.6 27.8 203.5 0L8.8 96.5c-7.9 4-11.1 13.6-7.2 21.5l57.2 114.5c4 7.9 13.6 11.1 21.5 7.2l56.6-27.7c10.6-5.2 23 2.5 23 14.4V480c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V226.3c0-11.8 12.4-19.6 23-14.4l56.6 27.7c7.9 4 17.5.8 21.5-7.2L638.3 118c4-7.9.8-17.6-7.1-21.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTty(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.37 103.822c138.532-138.532 362.936-138.326 501.262 0 6.078 6.078 7.074 15.496 2.583 22.681l-43.214 69.138a18.332 18.332 0 0 1-22.356 7.305l-86.422-34.569a18.335 18.335 0 0 1-11.434-18.846L351.741 90c-62.145-22.454-130.636-21.986-191.483 0l5.953 59.532a18.331 18.331 0 0 1-11.434 18.846l-86.423 34.568a18.334 18.334 0 0 1-22.356-7.305L2.787 126.502a18.333 18.333 0 0 1 2.583-22.68zM96 308v-40c0-6.627-5.373-12-12-12H44c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12H92c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zM96 500v-40c0-6.627-5.373-12-12-12H44c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm288 0v-40c0-6.627-5.373-12-12-12H140c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h232c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaTv(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M592 0H48A48 48 0 0 0 0 48v320a48 48 0 0 0 48 48h240v32H112a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H352v-32h240a48 48 0 0 0 48-48V48a48 48 0 0 0-48-48zm-16 352H64V64h512z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUmbrellaBeach(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M115.38 136.9l102.11 37.18c35.19-81.54 86.21-144.29 139-173.7-95.88-4.89-188.78 36.96-248.53 111.8-6.69 8.4-2.66 21.05 7.42 24.72zm132.25 48.16l238.48 86.83c35.76-121.38 18.7-231.66-42.63-253.98-7.4-2.7-15.13-4-23.09-4-58.02.01-128.27 69.17-172.76 171.15zM521.48 60.5c6.22 16.3 10.83 34.6 13.2 55.19 5.74 49.89-1.42 108.23-18.95 166.98l102.62 37.36c10.09 3.67 21.31-3.43 21.57-14.17 2.32-95.69-41.91-187.44-118.44-245.36zM560 447.98H321.06L386 269.5l-60.14-21.9-72.9 200.37H16c-8.84 0-16 7.16-16 16.01v32.01C0 504.83 7.16 512 16 512h544c8.84 0 16-7.17 16-16.01v-32.01c0-8.84-7.16-16-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUmbrella(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M575.7 280.8C547.1 144.5 437.3 62.6 320 49.9V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v17.9C138.3 62.6 29.5 144.5.3 280.8c-2.2 10.1 8.5 21.3 18.7 11.4 52-55 107.7-52.4 158.6 37 5.3 9.5 14.9 8.6 19.7 0 20.2-35.4 44.9-73.2 90.7-73.2 58.5 0 88.2 68.8 90.7 73.2 4.8 8.6 14.4 9.5 19.7 0 51-89.5 107.1-91.4 158.6-37 10.3 10 20.9-1.3 18.7-11.4zM256 301.7V432c0 8.8-7.2 16-16 16-7.8 0-13.2-5.3-15.1-10.7-5.9-16.7-24.1-25.4-40.8-19.5-16.7 5.9-25.4 24.2-19.5 40.8 11.2 31.9 41.6 53.3 75.4 53.3 44.1 0 80-35.9 80-80V301.6c-9.1-7.9-19.8-13.6-32-13.6-12.3.1-22.4 4.8-32 13.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUnderline(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 64h32v160c0 88.22 71.78 160 160 160s160-71.78 160-160V64h32a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16H272a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32v160a80 80 0 0 1-160 0V64h32a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16H32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm400 384H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUndoAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M255.545 8c-66.269.119-126.438 26.233-170.86 68.685L48.971 40.971C33.851 25.851 8 36.559 8 57.941V192c0 13.255 10.745 24 24 24h134.059c21.382 0 32.09-25.851 16.971-40.971l-41.75-41.75c30.864-28.899 70.801-44.907 113.23-45.273 92.398-.798 170.283 73.977 169.484 169.442C423.236 348.009 349.816 424 256 424c-41.127 0-79.997-14.678-110.63-41.556-4.743-4.161-11.906-3.908-16.368.553L89.34 422.659c-4.872 4.872-4.631 12.815.482 17.433C133.798 479.813 192.074 504 256 504c136.966 0 247.999-111.033 248-247.998C504.001 119.193 392.354 7.755 255.545 8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUndo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M212.333 224.333H12c-6.627 0-12-5.373-12-12V12C0 5.373 5.373 0 12 0h48c6.627 0 12 5.373 12 12v78.112C117.773 39.279 184.26 7.47 258.175 8.007c136.906.994 246.448 111.623 246.157 248.532C504.041 393.258 393.12 504 256.333 504c-64.089 0-122.496-24.313-166.51-64.215-5.099-4.622-5.334-12.554-.467-17.42l33.967-33.967c4.474-4.474 11.662-4.717 16.401-.525C170.76 415.336 211.58 432 256.333 432c97.268 0 176-78.716 176-176 0-97.267-78.716-176-176-176-58.496 0-110.28 28.476-142.274 72.333h98.274c6.627 0 12 5.373 12 12v48c0 6.627-5.373 12-12 12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUniversalAccess(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48c114.953 0 208 93.029 208 208 0 114.953-93.029 208-208 208-114.953 0-208-93.029-208-208 0-114.953 93.029-208 208-208m0-40C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 56C149.961 64 64 149.961 64 256s85.961 192 192 192 192-85.961 192-192S362.039 64 256 64zm0 44c19.882 0 36 16.118 36 36s-16.118 36-36 36-36-16.118-36-36 16.118-36 36-36zm117.741 98.023c-28.712 6.779-55.511 12.748-82.14 15.807.851 101.023 12.306 123.052 25.037 155.621 3.617 9.26-.957 19.698-10.217 23.315-9.261 3.617-19.699-.957-23.316-10.217-8.705-22.308-17.086-40.636-22.261-78.549h-9.686c-5.167 37.851-13.534 56.208-22.262 78.549-3.615 9.255-14.05 13.836-23.315 10.217-9.26-3.617-13.834-14.056-10.217-23.315 12.713-32.541 24.185-54.541 25.037-155.621-26.629-3.058-53.428-9.027-82.141-15.807-8.6-2.031-13.926-10.648-11.895-19.249s10.647-13.926 19.249-11.895c96.686 22.829 124.283 22.783 220.775 0 8.599-2.03 17.218 3.294 19.249 11.895 2.029 8.601-3.297 17.219-11.897 19.249z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUniversity(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 128v16a8 8 0 0 1-8 8h-24v12c0 6.627-5.373 12-12 12H60c-6.627 0-12-5.373-12-12v-12H24a8 8 0 0 1-8-8v-16a8 8 0 0 1 4.941-7.392l232-88a7.996 7.996 0 0 1 6.118 0l232 88A8 8 0 0 1 496 128zm-24 304H40c-13.255 0-24 10.745-24 24v16a8 8 0 0 0 8 8h464a8 8 0 0 0 8-8v-16c0-13.255-10.745-24-24-24zM96 192v192H60c-6.627 0-12 5.373-12 12v20h416v-20c0-6.627-5.373-12-12-12h-36V192h-64v192h-64V192h-64v192h-64V192H96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUnlink(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304.083 405.907c4.686 4.686 4.686 12.284 0 16.971l-44.674 44.674c-59.263 59.262-155.693 59.266-214.961 0-59.264-59.265-59.264-155.696 0-214.96l44.675-44.675c4.686-4.686 12.284-4.686 16.971 0l39.598 39.598c4.686 4.686 4.686 12.284 0 16.971l-44.675 44.674c-28.072 28.073-28.072 73.75 0 101.823 28.072 28.072 73.75 28.073 101.824 0l44.674-44.674c4.686-4.686 12.284-4.686 16.971 0l39.597 39.598zm-56.568-260.216c4.686 4.686 12.284 4.686 16.971 0l44.674-44.674c28.072-28.075 73.75-28.073 101.824 0 28.072 28.073 28.072 73.75 0 101.823l-44.675 44.674c-4.686 4.686-4.686 12.284 0 16.971l39.598 39.598c4.686 4.686 12.284 4.686 16.971 0l44.675-44.675c59.265-59.265 59.265-155.695 0-214.96-59.266-59.264-155.695-59.264-214.961 0l-44.674 44.674c-4.686 4.686-4.686 12.284 0 16.971l39.597 39.598zm234.828 359.28l22.627-22.627c9.373-9.373 9.373-24.569 0-33.941L63.598 7.029c-9.373-9.373-24.569-9.373-33.941 0L7.029 29.657c-9.373 9.373-9.373 24.569 0 33.941l441.373 441.373c9.373 9.372 24.569 9.372 33.941 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUnlockAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 256H152V152.9c0-39.6 31.7-72.5 71.3-72.9 40-.4 72.7 32.1 72.7 72v16c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-16C376 68 307.5-.3 223.5 0 139.5.3 72 69.5 72 153.5V256H48c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48zM264 408c0 22.1-17.9 40-40 40s-40-17.9-40-40v-48c0-22.1 17.9-40 40-40s40 17.9 40 40v48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUnlock(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 256H152V152.9c0-39.6 31.7-72.5 71.3-72.9 40-.4 72.7 32.1 72.7 72v16c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-16C376 68 307.5-.3 223.5 0 139.5.3 72 69.5 72 153.5V256H48c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUpload(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M296 384h-80c-13.3 0-24-10.7-24-24V192h-87.7c-17.8 0-26.7-21.5-14.1-34.1L242.3 5.7c7.5-7.5 19.8-7.5 27.3 0l152.2 152.2c12.6 12.6 3.7 34.1-14.1 34.1H320v168c0 13.3-10.7 24-24 24zm216-8v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h136v8c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56v-8h136c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUserAltSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M633.8 458.1L389.6 269.3C433.8 244.7 464 198.1 464 144 464 64.5 399.5 0 320 0c-67.1 0-123 46.1-139 108.2L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3zM198.4 320C124.2 320 64 380.2 64 454.4v9.6c0 26.5 21.5 48 48 48h382.2L245.8 320h-47.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUserAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 288c79.5 0 144-64.5 144-144S335.5 0 256 0 112 64.5 112 144s64.5 144 144 144zm128 32h-55.1c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16H128C57.3 320 0 377.3 0 448v16c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48v-16c0-70.7-57.3-128-128-128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUserAstronaut(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 224h13.5c24.7 56.5 80.9 96 146.5 96s121.8-39.5 146.5-96H384c8.8 0 16-7.2 16-16v-96c0-8.8-7.2-16-16-16h-13.5C345.8 39.5 289.6 0 224 0S102.2 39.5 77.5 96H64c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16zm40-88c0-22.1 21.5-40 48-40h144c26.5 0 48 17.9 48 40v24c0 53-43 96-96 96h-48c-53 0-96-43-96-96v-24zm72 72l12-36 36-12-36-12-12-36-12 36-36 12 36 12 12 36zm151.6 113.4C297.7 340.7 262.2 352 224 352s-73.7-11.3-103.6-30.6C52.9 328.5 0 385 0 454.4v9.6c0 26.5 21.5 48 48 48h80v-64c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32v64h80c26.5 0 48-21.5 48-48v-9.6c0-69.4-52.9-125.9-120.4-133zM272 448c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm-96 0c-8.8 0-16 7.2-16 16v48h32v-48c0-8.8-7.2-16-16-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUserCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4zm323-128.4l-27.8-28.1c-4.6-4.7-12.1-4.7-16.8-.1l-104.8 104-45.5-45.8c-4.6-4.7-12.1-4.7-16.8-.1l-28.1 27.9c-4.7 4.6-4.7 12.1-.1 16.8l81.7 82.3c4.6 4.7 12.1 4.7 16.8.1l141.3-140.2c4.6-4.7 4.7-12.2.1-16.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUserCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 96c48.6 0 88 39.4 88 88s-39.4 88-88 88-88-39.4-88-88 39.4-88 88-88zm0 344c-58.7 0-111.3-26.6-146.5-68.2 18.8-35.4 55.6-59.8 98.5-59.8 2.4 0 4.8.4 7.1 1.1 13 4.2 26.6 6.9 40.9 6.9 14.3 0 28-2.7 40.9-6.9 2.3-.7 4.7-1.1 7.1-1.1 42.9 0 79.7 24.4 98.5 59.8C359.3 421.4 306.7 448 248 448z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUserClock(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 224c-79.6 0-144 64.4-144 144s64.4 144 144 144 144-64.4 144-144-64.4-144-144-144zm64 150.3c0 5.3-4.4 9.7-9.7 9.7h-60.6c-5.3 0-9.7-4.4-9.7-9.7v-76.6c0-5.3 4.4-9.7 9.7-9.7h12.6c5.3 0 9.7 4.4 9.7 9.7V352h38.3c5.3 0 9.7 4.4 9.7 9.7v12.6zM320 368c0-27.8 6.7-54.1 18.2-77.5-8-1.5-16.2-2.5-24.6-2.5h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h347.1c-45.3-31.9-75.1-84.5-75.1-144zm-96-112c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUserCog(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M610.5 373.3c2.6-14.1 2.6-28.5 0-42.6l25.8-14.9c3-1.7 4.3-5.2 3.3-8.5-6.7-21.6-18.2-41.2-33.2-57.4-2.3-2.5-6-3.1-9-1.4l-25.8 14.9c-10.9-9.3-23.4-16.5-36.9-21.3v-29.8c0-3.4-2.4-6.4-5.7-7.1-22.3-5-45-4.8-66.2 0-3.3.7-5.7 3.7-5.7 7.1v29.8c-13.5 4.8-26 12-36.9 21.3l-25.8-14.9c-2.9-1.7-6.7-1.1-9 1.4-15 16.2-26.5 35.8-33.2 57.4-1 3.3.4 6.8 3.3 8.5l25.8 14.9c-2.6 14.1-2.6 28.5 0 42.6l-25.8 14.9c-3 1.7-4.3 5.2-3.3 8.5 6.7 21.6 18.2 41.1 33.2 57.4 2.3 2.5 6 3.1 9 1.4l25.8-14.9c10.9 9.3 23.4 16.5 36.9 21.3v29.8c0 3.4 2.4 6.4 5.7 7.1 22.3 5 45 4.8 66.2 0 3.3-.7 5.7-3.7 5.7-7.1v-29.8c13.5-4.8 26-12 36.9-21.3l25.8 14.9c2.9 1.7 6.7 1.1 9-1.4 15-16.2 26.5-35.8 33.2-57.4 1-3.3-.4-6.8-3.3-8.5l-25.8-14.9zM496 400.5c-26.8 0-48.5-21.8-48.5-48.5s21.8-48.5 48.5-48.5 48.5 21.8 48.5 48.5-21.7 48.5-48.5 48.5zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm201.2 226.5c-2.3-1.2-4.6-2.6-6.8-3.9l-7.9 4.6c-6 3.4-12.8 5.3-19.6 5.3-10.9 0-21.4-4.6-28.9-12.6-18.3-19.8-32.3-43.9-40.2-69.6-5.5-17.7 1.9-36.4 17.9-45.7l7.9-4.6c-.1-2.6-.1-5.2 0-7.8l-7.9-4.6c-16-9.2-23.4-28-17.9-45.7.9-2.9 2.2-5.8 3.2-8.7-3.8-.3-7.5-1.2-11.4-1.2h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c10.1 0 19.5-3.2 27.2-8.5-1.2-3.8-2-7.7-2-11.8v-9.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUserEdit(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h274.9c-2.4-6.8-3.4-14-2.6-21.3l6.8-60.9 1.2-11.1 7.9-7.9 77.3-77.3c-24.5-27.7-60-45.5-99.9-45.5zm45.3 145.3l-6.8 61c-1.1 10.2 7.5 18.8 17.6 17.6l60.9-6.8 137.9-137.9-71.7-71.7-137.9 137.8zM633 268.9L595.1 231c-9.3-9.3-24.5-9.3-33.8 0l-37.8 37.8-4.1 4.1 71.8 71.7 41.8-41.8c9.3-9.4 9.3-24.5 0-33.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUserFriends(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 256c61.9 0 112-50.1 112-112S253.9 32 192 32 80 82.1 80 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C51.6 288 0 339.6 0 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zM480 256c53 0 96-43 96-96s-43-96-96-96-96 43-96 96 43 96 96 96zm48 32h-3.8c-13.9 4.8-28.6 8-44.2 8s-30.3-3.2-44.2-8H432c-20.4 0-39.2 5.9-55.7 15.4 24.4 26.3 39.7 61.2 39.7 99.8v38.4c0 2.2-.5 4.3-.6 6.4H592c26.5 0 48-21.5 48-48 0-61.9-50.1-112-112-112z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUserGraduate(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M319.4 320.6L224 416l-95.4-95.4C57.1 323.7 0 382.2 0 454.4v9.6c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-9.6c0-72.2-57.1-130.7-128.6-133.8zM13.6 79.8l6.4 1.5v58.4c-7 4.2-12 11.5-12 20.3 0 8.4 4.6 15.4 11.1 19.7L3.5 242c-1.7 6.9 2.1 14 7.6 14h41.8c5.5 0 9.3-7.1 7.6-14l-15.6-62.3C51.4 175.4 56 168.4 56 160c0-8.8-5-16.1-12-20.3V87.1l66 15.9c-8.6 17.2-14 36.4-14 57 0 70.7 57.3 128 128 128s128-57.3 128-128c0-20.6-5.3-39.8-14-57l96.3-23.2c18.2-4.4 18.2-27.1 0-31.5l-190.4-46c-13-3.1-26.7-3.1-39.7 0L13.6 48.2c-18.1 4.4-18.1 27.2 0 31.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUserInjured(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M277.37 11.98C261.08 4.47 243.11 0 224 0c-53.69 0-99.5 33.13-118.51 80h81.19l90.69-68.02zM342.51 80c-7.9-19.47-20.67-36.2-36.49-49.52L239.99 80h102.52zM224 256c70.69 0 128-57.31 128-128 0-5.48-.95-10.7-1.61-16H97.61c-.67 5.3-1.61 10.52-1.61 16 0 70.69 57.31 128 128 128zM80 299.7V512h128.26l-98.45-221.52A132.835 132.835 0 0 0 80 299.7zM0 464c0 26.51 21.49 48 48 48V320.24C18.88 344.89 0 381.26 0 422.4V464zm256-48h-55.38l42.67 96H256c26.47 0 48-21.53 48-48s-21.53-48-48-48zm57.6-128h-16.71c-22.24 10.18-46.88 16-72.89 16s-50.65-5.82-72.89-16h-7.37l42.67 96H256c44.11 0 80 35.89 80 80 0 18.08-6.26 34.59-16.41 48H400c26.51 0 48-21.49 48-48v-41.6c0-74.23-60.17-134.4-134.4-134.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUserLock(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 256A128 128 0 1 0 96 128a128 128 0 0 0 128 128zm96 64a63.08 63.08 0 0 1 8.1-30.5c-4.8-.5-9.5-1.5-14.5-1.5h-16.7a174.08 174.08 0 0 1-145.8 0h-16.7A134.43 134.43 0 0 0 0 422.4V464a48 48 0 0 0 48 48h280.9a63.54 63.54 0 0 1-8.9-32zm288-32h-32v-80a80 80 0 0 0-160 0v80h-32a32 32 0 0 0-32 32v160a32 32 0 0 0 32 32h224a32 32 0 0 0 32-32V320a32 32 0 0 0-32-32zM496 432a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm32-144h-64v-80a32 32 0 0 1 64 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUserMd(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zM104 424c0 13.3 10.7 24 24 24s24-10.7 24-24-10.7-24-24-24-24 10.7-24 24zm216-135.4v49c36.5 7.4 64 39.8 64 78.4v41.7c0 7.6-5.4 14.2-12.9 15.7l-32.2 6.4c-4.3.9-8.5-1.9-9.4-6.3l-3.1-15.7c-.9-4.3 1.9-8.6 6.3-9.4l19.3-3.9V416c0-62.8-96-65.1-96 1.9v26.7l19.3 3.9c4.3.9 7.1 5.1 6.3 9.4l-3.1 15.7c-.9 4.3-5.1 7.1-9.4 6.3l-31.2-4.2c-7.9-1.1-13.8-7.8-13.8-15.9V416c0-38.6 27.5-70.9 64-78.4v-45.2c-2.2.7-4.4 1.1-6.6 1.9-18 6.3-37.3 9.8-57.4 9.8s-39.4-3.5-57.4-9.8c-7.4-2.6-14.9-4.2-22.6-5.2v81.6c23.1 6.9 40 28.1 40 53.4 0 30.9-25.1 56-56 56s-56-25.1-56-56c0-25.3 16.9-46.5 40-53.4v-80.4C48.5 301 0 355.8 0 422.4v44.8C0 491.9 20.1 512 44.8 512h358.4c24.7 0 44.8-20.1 44.8-44.8v-44.8c0-72-56.8-130.3-128-133.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUserMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 208H432c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h192c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-400 48c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUserNinja(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M325.4 289.2L224 390.6 122.6 289.2C54 295.3 0 352.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-70.2-54-127.1-122.6-133.2zM32 192c27.3 0 51.8-11.5 69.2-29.7 15.1 53.9 64 93.7 122.8 93.7 70.7 0 128-57.3 128-128S294.7 0 224 0c-50.4 0-93.6 29.4-114.5 71.8C92.1 47.8 64 32 32 32c0 33.4 17.1 62.8 43.1 80-26 17.2-43.1 46.6-43.1 80zm144-96h96c17.7 0 32 14.3 32 32H144c0-17.7 14.3-32 32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUserNurse(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M319.41,320,224,415.39,128.59,320C57.1,323.1,0,381.6,0,453.79A58.21,58.21,0,0,0,58.21,512H389.79A58.21,58.21,0,0,0,448,453.79C448,381.6,390.9,323.1,319.41,320ZM224,304A128,128,0,0,0,352,176V65.82a32,32,0,0,0-20.76-30L246.47,4.07a64,64,0,0,0-44.94,0L116.76,35.86A32,32,0,0,0,96,65.82V176A128,128,0,0,0,224,304ZM184,71.67a5,5,0,0,1,5-5h21.67V45a5,5,0,0,1,5-5h16.66a5,5,0,0,1,5,5V66.67H259a5,5,0,0,1,5,5V88.33a5,5,0,0,1-5,5H237.33V115a5,5,0,0,1-5,5H215.67a5,5,0,0,1-5-5V93.33H189a5,5,0,0,1-5-5ZM144,160H304v16a80,80,0,0,1-160,0Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUserPlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 208h-64v-64c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v64h-64c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h64v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-64h64c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-400 48c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUserSecret(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M383.9 308.3l23.9-62.6c4-10.5-3.7-21.7-15-21.7h-58.5c11-18.9 17.8-40.6 17.8-64v-.3c39.2-7.8 64-19.1 64-31.7 0-13.3-27.3-25.1-70.1-33-9.2-32.8-27-65.8-40.6-82.8-9.5-11.9-25.9-15.6-39.5-8.8l-27.6 13.8c-9 4.5-19.6 4.5-28.6 0L182.1 3.4c-13.6-6.8-30-3.1-39.5 8.8-13.5 17-31.4 50-40.6 82.8-42.7 7.9-70 19.7-70 33 0 12.6 24.8 23.9 64 31.7v.3c0 23.4 6.8 45.1 17.8 64H56.3c-11.5 0-19.2 11.7-14.7 22.3l25.8 60.2C27.3 329.8 0 372.7 0 422.4v44.8C0 491.9 20.1 512 44.8 512h358.4c24.7 0 44.8-20.1 44.8-44.8v-44.8c0-48.4-25.8-90.4-64.1-114.1zM176 480l-41.6-192 49.6 32 24 40-32 120zm96 0l-32-120 24-40 49.6-32L272 480zm41.7-298.5c-3.9 11.9-7 24.6-16.5 33.4-10.1 9.3-48 22.4-64-25-2.8-8.4-15.4-8.4-18.3 0-17 50.2-56 32.4-64 25-9.5-8.8-12.7-21.5-16.5-33.4-.8-2.5-6.3-5.7-6.3-5.8v-10.8c28.3 3.6 61 5.8 96 5.8s67.7-2.1 96-5.8v10.8c-.1.1-5.6 3.2-6.4 5.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUserShield(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M622.3 271.1l-115.2-45c-4.1-1.6-12.6-3.7-22.2 0l-115.2 45c-10.7 4.2-17.7 14-17.7 24.9 0 111.6 68.7 188.8 132.9 213.9 9.6 3.7 18 1.6 22.2 0C558.4 489.9 640 420.5 640 296c0-10.9-7-20.7-17.7-24.9zM496 462.4V273.3l95.5 37.3c-5.6 87.1-60.9 135.4-95.5 151.8zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm96 40c0-2.5.8-4.8 1.1-7.2-2.5-.1-4.9-.8-7.5-.8h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c6.8 0 13.3-1.5 19.2-4-54-42.9-99.2-116.7-99.2-212z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUserSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M633.8 458.1L362.3 248.3C412.1 230.7 448 183.8 448 128 448 57.3 390.7 0 320 0c-67.1 0-121.5 51.8-126.9 117.4L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3zM96 422.4V464c0 26.5 21.5 48 48 48h350.2L207.4 290.3C144.2 301.3 96 356 96 422.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUserTag(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M630.6 364.9l-90.3-90.2c-12-12-28.3-18.7-45.3-18.7h-79.3c-17.7 0-32 14.3-32 32v79.2c0 17 6.7 33.2 18.7 45.2l90.3 90.2c12.5 12.5 32.8 12.5 45.3 0l92.5-92.5c12.6-12.5 12.6-32.7.1-45.2zm-182.8-21c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24c0 13.2-10.7 24-24 24zm-223.8-88c70.7 0 128-57.3 128-128C352 57.3 294.7 0 224 0S96 57.3 96 128c0 70.6 57.3 127.9 128 127.9zm127.8 111.2V294c-12.2-3.6-24.9-6.2-38.2-6.2h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 287.9 0 348.1 0 422.3v41.6c0 26.5 21.5 48 48 48h352c15.5 0 29.1-7.5 37.9-18.9l-58-58c-18.1-18.1-28.1-42.2-28.1-67.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUserTie(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm95.8 32.6L272 480l-32-136 32-56h-96l32 56-32 136-47.8-191.4C56.9 292 0 350.3 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-72.1-56.9-130.4-128.2-133.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUserTimes(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M589.6 240l45.6-45.6c6.3-6.3 6.3-16.5 0-22.8l-22.8-22.8c-6.3-6.3-16.5-6.3-22.8 0L544 194.4l-45.6-45.6c-6.3-6.3-16.5-6.3-22.8 0l-22.8 22.8c-6.3 6.3-6.3 16.5 0 22.8l45.6 45.6-45.6 45.6c-6.3 6.3-6.3 16.5 0 22.8l22.8 22.8c6.3 6.3 16.5 6.3 22.8 0l45.6-45.6 45.6 45.6c6.3 6.3 16.5 6.3 22.8 0l22.8-22.8c6.3-6.3 6.3-16.5 0-22.8L589.6 240zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUser(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUsersCog(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M610.5 341.3c2.6-14.1 2.6-28.5 0-42.6l25.8-14.9c3-1.7 4.3-5.2 3.3-8.5-6.7-21.6-18.2-41.2-33.2-57.4-2.3-2.5-6-3.1-9-1.4l-25.8 14.9c-10.9-9.3-23.4-16.5-36.9-21.3v-29.8c0-3.4-2.4-6.4-5.7-7.1-22.3-5-45-4.8-66.2 0-3.3.7-5.7 3.7-5.7 7.1v29.8c-13.5 4.8-26 12-36.9 21.3l-25.8-14.9c-2.9-1.7-6.7-1.1-9 1.4-15 16.2-26.5 35.8-33.2 57.4-1 3.3.4 6.8 3.3 8.5l25.8 14.9c-2.6 14.1-2.6 28.5 0 42.6l-25.8 14.9c-3 1.7-4.3 5.2-3.3 8.5 6.7 21.6 18.2 41.1 33.2 57.4 2.3 2.5 6 3.1 9 1.4l25.8-14.9c10.9 9.3 23.4 16.5 36.9 21.3v29.8c0 3.4 2.4 6.4 5.7 7.1 22.3 5 45 4.8 66.2 0 3.3-.7 5.7-3.7 5.7-7.1v-29.8c13.5-4.8 26-12 36.9-21.3l25.8 14.9c2.9 1.7 6.7 1.1 9-1.4 15-16.2 26.5-35.8 33.2-57.4 1-3.3-.4-6.8-3.3-8.5l-25.8-14.9zM496 368.5c-26.8 0-48.5-21.8-48.5-48.5s21.8-48.5 48.5-48.5 48.5 21.8 48.5 48.5-21.7 48.5-48.5 48.5zM96 224c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm224 32c1.9 0 3.7-.5 5.6-.6 8.3-21.7 20.5-42.1 36.3-59.2 7.4-8 17.9-12.6 28.9-12.6 6.9 0 13.7 1.8 19.6 5.3l7.9 4.6c.8-.5 1.6-.9 2.4-1.4 7-14.6 11.2-30.8 11.2-48 0-61.9-50.1-112-112-112S208 82.1 208 144c0 61.9 50.1 112 112 112zm105.2 194.5c-2.3-1.2-4.6-2.6-6.8-3.9-8.2 4.8-15.3 9.8-27.5 9.8-10.9 0-21.4-4.6-28.9-12.6-18.3-19.8-32.3-43.9-40.2-69.6-10.7-34.5 24.9-49.7 25.8-50.3-.1-2.6-.1-5.2 0-7.8l-7.9-4.6c-3.8-2.2-7-5-9.8-8.1-3.3.2-6.5.6-9.8.6-24.6 0-47.6-6-68.5-16h-8.3C179.6 288 128 339.6 128 403.2V432c0 26.5 21.5 48 48 48h255.4c-3.7-6-6.2-12.8-6.2-20.3v-9.2zM173.1 274.6C161.5 263.1 145.6 256 128 256H64c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32h65.9c6.3-47.4 34.9-87.3 75.2-109.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUsersSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M132.65,212.32,36.21,137.78A63.4,63.4,0,0,0,32,160a63.84,63.84,0,0,0,100.65,52.32Zm40.44,62.28A63.79,63.79,0,0,0,128,256H64A64.06,64.06,0,0,0,0,320v32a32,32,0,0,0,32,32H97.91A146.62,146.62,0,0,1,173.09,274.6ZM544,224a64,64,0,1,0-64-64A64.06,64.06,0,0,0,544,224ZM500.56,355.11a114.24,114.24,0,0,0-84.47-65.28L361,247.23c41.46-16.3,71-55.92,71-103.23A111.93,111.93,0,0,0,320,32c-57.14,0-103.69,42.83-110.6,98.08L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.46A16,16,0,0,0,6.18,53.91L594.53,508.63A16,16,0,0,0,617,505.82l19.64-25.27a16,16,0,0,0-2.81-22.45ZM128,403.21V432a48,48,0,0,0,48,48H464a47.45,47.45,0,0,0,12.57-1.87L232,289.13C173.74,294.83,128,343.42,128,403.21ZM576,256H512a63.79,63.79,0,0,0-45.09,18.6A146.29,146.29,0,0,1,542,384h66a32,32,0,0,0,32-32V320A64.06,64.06,0,0,0,576,256Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUsers(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 224c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm448 0c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm32 32h-64c-17.6 0-33.5 7.1-45.1 18.6 40.3 22.1 68.9 62 75.1 109.4h66c17.7 0 32-14.3 32-32v-32c0-35.3-28.7-64-64-64zm-256 0c61.9 0 112-50.1 112-112S381.9 32 320 32 208 82.1 208 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C179.6 288 128 339.6 128 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zm-223.7-13.4C161.5 263.1 145.6 256 128 256H64c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32h65.9c6.3-47.4 34.9-87.3 75.2-109.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUtensilSpoon(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480.1 31.9c-55-55.1-164.9-34.5-227.8 28.5-49.3 49.3-55.1 110-28.8 160.4L9 413.2c-11.6 10.5-12.1 28.5-1 39.5L59.3 504c11 11 29.1 10.5 39.5-1.1l192.4-214.4c50.4 26.3 111.1 20.5 160.4-28.8 63-62.9 83.6-172.8 28.5-227.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaUtensils(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 416 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M207.9 15.2c.8 4.7 16.1 94.5 16.1 128.8 0 52.3-27.8 89.6-68.9 104.6L168 486.7c.7 13.7-10.2 25.3-24 25.3H80c-13.7 0-24.7-11.5-24-25.3l12.9-238.1C27.7 233.6 0 196.2 0 144 0 109.6 15.3 19.9 16.1 15.2 19.3-5.1 61.4-5.4 64 16.3v141.2c1.3 3.4 15.1 3.2 16 0 1.4-25.3 7.9-139.2 8-141.8 3.3-20.8 44.7-20.8 47.9 0 .2 2.7 6.6 116.5 8 141.8.9 3.2 14.8 3.4 16 0V16.3c2.6-21.6 44.8-21.4 48-1.1zm119.2 285.7l-15 185.1c-1.2 14 9.9 26 23.9 26h56c13.3 0 24-10.7 24-24V24c0-13.2-10.7-24-24-24-82.5 0-221.4 178.5-64.9 300.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVectorSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 128V32c0-17.67-14.33-32-32-32h-96c-17.67 0-32 14.33-32 32H160c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v96c0 17.67 14.33 32 32 32v192c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32h192c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32V160c17.67 0 32-14.33 32-32zm-96-64h32v32h-32V64zM64 64h32v32H64V64zm32 384H64v-32h32v32zm352 0h-32v-32h32v32zm-32-96h-32c-17.67 0-32 14.33-32 32v32H160v-32c0-17.67-14.33-32-32-32H96V160h32c17.67 0 32-14.33 32-32V96h192v32c0 17.67 14.33 32 32 32h32v192z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVenusDouble(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 176c0-79.5-64.5-144-144-144S0 96.5 0 176c0 68.5 47.9 125.9 112 140.4V368H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.5 112-71.9 112-140.4zm-224 0c0-44.1 35.9-80 80-80s80 35.9 80 80-35.9 80-80 80-80-35.9-80-80zm336 140.4V368h36c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-36v36c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-36h-36c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h36v-51.6c-21.2-4.8-40.6-14.3-57.2-27.3 14-16.7 25-36 32.1-57.1 14.5 14.8 34.7 24 57.1 24 44.1 0 80-35.9 80-80s-35.9-80-80-80c-22.3 0-42.6 9.2-57.1 24-7.1-21.1-18-40.4-32.1-57.1C303.4 43.6 334.3 32 368 32c79.5 0 144 64.5 144 144 0 68.5-47.9 125.9-112 140.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVenusMars(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M564 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-48.7 48.7C422.5 72.1 396.2 64 368 64c-33.7 0-64.6 11.6-89.2 30.9 14 16.7 25 36 32.1 57.1 14.5-14.8 34.7-24 57.1-24 44.1 0 80 35.9 80 80s-35.9 80-80 80c-22.3 0-42.6-9.2-57.1-24-7.1 21.1-18 40.4-32.1 57.1 24.5 19.4 55.5 30.9 89.2 30.9 79.5 0 144-64.5 144-144 0-28.2-8.1-54.5-22.1-76.7l48.7-48.7 16.9 16.9c2.4 2.4 5.4 3.5 8.4 3.5 6.2 0 12.1-4.8 12.1-12V12c0-6.6-5.4-12-12-12zM144 64C64.5 64 0 128.5 0 208c0 68.5 47.9 125.9 112 140.4V400H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.6 112-71.9 112-140.4 0-79.5-64.5-144-144-144zm0 224c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVenus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 288 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 176c0-79.5-64.5-144-144-144S0 96.5 0 176c0 68.5 47.9 125.9 112 140.4V368H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.5 112-71.9 112-140.4zm-224 0c0-44.1 35.9-80 80-80s80 35.9 80 80-35.9 80-80 80-80-35.9-80-80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVestPatches(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M437.252,239.877,384,160V32A32,32,0,0,0,352,0H320a23.982,23.982,0,0,0-13.312,4.031l-25,16.672a103.794,103.794,0,0,1-115.376,0l-25-16.672A23.982,23.982,0,0,0,128,0H96A32,32,0,0,0,64,32V160L10.748,239.877A64,64,0,0,0,0,275.377V480a32,32,0,0,0,32,32H192V288a31.987,31.987,0,0,1,1.643-10.119L207.135,237.4,150.188,66.561A151.579,151.579,0,0,0,224,86.234a151.565,151.565,0,0,0,73.811-19.668L224,288V512H416a32,32,0,0,0,32-32V275.377A64,64,0,0,0,437.252,239.877ZM63.5,272.484a12.01,12.01,0,0,1,17-16.968l15.5,15.5,15.5-15.5a12.01,12.01,0,0,1,17,16.968L112.984,288,128.5,303.516a12.01,12.01,0,0,1-17,16.968L96,304.984l-15.5,15.5a12.01,12.01,0,0,1-17-16.968L79.016,288ZM96,456a40,40,0,1,1,40-40A40,40,0,0,1,96,456ZM359.227,335.785,310.7,336a6.671,6.671,0,0,1-6.7-6.7l.215-48.574A24.987,24.987,0,0,1,331.43,256.1c12.789,1.162,22.129,12.619,22.056,25.419l-.037,5.057,5.051-.037c12.826-.035,24.236,9.275,25.4,22.076A24.948,24.948,0,0,1,359.227,335.785Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVest(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M437.252,239.877,384,160V32A32,32,0,0,0,352,0H320a24.021,24.021,0,0,0-13.312,4.031l-25,16.672a103.794,103.794,0,0,1-115.376,0l-25-16.672A24.021,24.021,0,0,0,128,0H96A32,32,0,0,0,64,32V160L10.748,239.877A64,64,0,0,0,0,275.377V480a32,32,0,0,0,32,32H192V288a31.987,31.987,0,0,1,1.643-10.119L207.135,237.4,150.188,66.564A151.518,151.518,0,0,0,224,86.234a151.55,151.55,0,0,0,73.812-19.672L224,288V512H416a32,32,0,0,0,32-32V275.377A64,64,0,0,0,437.252,239.877ZM131.312,371.312l-48,48a16,16,0,0,1-22.624-22.624l48-48a16,16,0,0,1,22.624,22.624Zm256,48a15.992,15.992,0,0,1-22.624,0l-48-48a16,16,0,0,1,22.624-22.624l48,48A15.993,15.993,0,0,1,387.312,419.312Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVial(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 480 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M477.7 186.1L309.5 18.3c-3.1-3.1-8.2-3.1-11.3 0l-34 33.9c-3.1 3.1-3.1 8.2 0 11.3l11.2 11.1L33 316.5c-38.8 38.7-45.1 102-9.4 143.5 20.6 24 49.5 36 78.4 35.9 26.4 0 52.8-10 72.9-30.1l246.3-245.7 11.2 11.1c3.1 3.1 8.2 3.1 11.3 0l34-33.9c3.1-3 3.1-8.1 0-11.2zM318 256H161l148-147.7 78.5 78.3L318 256z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVials(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M72 64h24v240c0 44.1 35.9 80 80 80s80-35.9 80-80V64h24c4.4 0 8-3.6 8-8V8c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm72 0h64v96h-64V64zm480 384H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM360 64h24v240c0 44.1 35.9 80 80 80s80-35.9 80-80V64h24c4.4 0 8-3.6 8-8V8c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm72 0h64v96h-64V64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVideoSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M633.8 458.1l-55-42.5c15.4-1.4 29.2-13.7 29.2-31.1v-257c0-25.5-29.1-40.4-50.4-25.8L448 177.3v137.2l-32-24.7v-178c0-26.4-21.4-47.8-47.8-47.8H123.9L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4L42.7 82 416 370.6l178.5 138c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.5-6.9 4.2-17-2.8-22.4zM32 400.2c0 26.4 21.4 47.8 47.8 47.8h288.4c11.2 0 21.4-4 29.6-10.5L32 154.7v245.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVideo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336.2 64H47.8C21.4 64 0 85.4 0 111.8v288.4C0 426.6 21.4 448 47.8 448h288.4c26.4 0 47.8-21.4 47.8-47.8V111.8c0-26.4-21.4-47.8-47.8-47.8zm189.4 37.7L416 177.3v157.4l109.6 75.5c21.2 14.6 50.4-.3 50.4-25.8V127.5c0-25.4-29.1-40.4-50.4-25.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVihara(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M632.88 400.71L544 352v-64l55.16-17.69c11.79-5.9 11.79-22.72 0-28.62L480 192v-64l27.31-16.3c7.72-7.72 5.61-20.74-4.16-25.62L320 0 136.85 86.07c-9.77 4.88-11.88 17.9-4.16 25.62L160 128v64L40.84 241.69c-11.79 5.9-11.79 22.72 0 28.62L96 288v64L7.12 400.71c-5.42 3.62-7.7 9.63-7 15.29.62 5.01 3.57 9.75 8.72 12.33L64 448v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48h160v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48h160v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48l55.15-19.67c5.16-2.58 8.1-7.32 8.72-12.33.71-5.67-1.57-11.68-6.99-15.29zM224 128h192v64H224v-64zm-64 224v-64h320v64H160z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVirusSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M114,227.6H92.4C76.7,227.6,64,240.3,64,256s12.7,28.4,28.4,28.4H114c50.7,0,76.1,61.3,40.2,97.1L139,396.8 c-11.5,10.7-12.2,28.7-1.6,40.2s28.7,12.2,40.2,1.6c0.5-0.5,1.1-1,1.6-1.6l15.2-15.2c35.8-35.8,97.1-10.5,97.1,40.2v21.5 c0,15.7,12.8,28.4,28.5,28.4c15.7,0,28.4-12.7,28.4-28.4V462c0-26.6,17-45.9,38.2-53.4l-244.5-189 C133.7,224.7,123.9,227.5,114,227.6z M617,505.8l19.6-25.3c5.4-7,4.2-17-2.8-22.5L470.6,332c4.2-25.4,24.9-47.5,55.4-47.5h21.5 c15.7,0,28.4-12.7,28.4-28.4s-12.7-28.4-28.4-28.4H526c-50.7,0-76.1-61.3-40.2-97.1l15.2-15.3c10.7-11.5,10-29.5-1.6-40.2 c-10.9-10.1-27.7-10.1-38.6,0l-15.2,15.2c-35.8,35.8-97.1,10.5-97.1-40.2V28.5C348.4,12.7,335.7,0,320,0 c-15.7,0-28.4,12.7-28.4,28.4V50c0,50.7-61.3,76.1-97.1,40.2L179.2,75c-11.1-11.1-29.4-10.6-40.5,0.5L45.5,3.4 c-7-5.4-17-4.2-22.5,2.8L3.4,31.5c-5.4,7-4.2,17,2.8,22.5l588.4,454.7C601.5,514.1,611.6,512.8,617,505.8z M335.4,227.5l-62.9-48.6 c4.9-1.8,10.2-2.8,15.4-2.9c26.5,0,48,21.5,48,48C336,225.2,335.5,226.3,335.4,227.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVirus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M483.55,227.55H462c-50.68,0-76.07-61.27-40.23-97.11L437,115.19A28.44,28.44,0,0,0,396.8,75L381.56,90.22c-35.84,35.83-97.11,10.45-97.11-40.23V28.44a28.45,28.45,0,0,0-56.9,0V50c0,50.68-61.27,76.06-97.11,40.23L115.2,75A28.44,28.44,0,0,0,75,115.19l15.25,15.25c35.84,35.84,10.45,97.11-40.23,97.11H28.45a28.45,28.45,0,1,0,0,56.89H50c50.68,0,76.07,61.28,40.23,97.12L75,396.8A28.45,28.45,0,0,0,115.2,437l15.24-15.25c35.84-35.84,97.11-10.45,97.11,40.23v21.54a28.45,28.45,0,0,0,56.9,0V462c0-50.68,61.27-76.07,97.11-40.23L396.8,437A28.45,28.45,0,0,0,437,396.8l-15.25-15.24c-35.84-35.84-10.45-97.12,40.23-97.12h21.54a28.45,28.45,0,1,0,0-56.89ZM224,272a48,48,0,1,1,48-48A48,48,0,0,1,224,272Zm80,56a24,24,0,1,1,24-24A24,24,0,0,1,304,328Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaViruses(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624,352H611.88c-28.51,0-42.79-34.47-22.63-54.63l8.58-8.57a16,16,0,1,0-22.63-22.63l-8.57,8.58C546.47,294.91,512,280.63,512,252.12V240a16,16,0,0,0-32,0v12.12c0,28.51-34.47,42.79-54.63,22.63l-8.57-8.58a16,16,0,0,0-22.63,22.63l8.58,8.57c20.16,20.16,5.88,54.63-22.63,54.63H368a16,16,0,0,0,0,32h12.12c28.51,0,42.79,34.47,22.63,54.63l-8.58,8.57a16,16,0,1,0,22.63,22.63l8.57-8.58c20.16-20.16,54.63-5.88,54.63,22.63V496a16,16,0,0,0,32,0V483.88c0-28.51,34.47-42.79,54.63-22.63l8.57,8.58a16,16,0,1,0,22.63-22.63l-8.58-8.57C569.09,418.47,583.37,384,611.88,384H624a16,16,0,0,0,0-32ZM480,384a32,32,0,1,1,32-32A32,32,0,0,1,480,384ZM346.51,213.33h16.16a21.33,21.33,0,0,0,0-42.66H346.51c-38,0-57.05-46-30.17-72.84l11.43-11.44A21.33,21.33,0,0,0,297.6,56.23L286.17,67.66c-26.88,26.88-72.84,7.85-72.84-30.17V21.33a21.33,21.33,0,0,0-42.66,0V37.49c0,38-46,57.05-72.84,30.17L86.4,56.23A21.33,21.33,0,0,0,56.23,86.39L67.66,97.83c26.88,26.88,7.85,72.84-30.17,72.84H21.33a21.33,21.33,0,0,0,0,42.66H37.49c38,0,57.05,46,30.17,72.84L56.23,297.6A21.33,21.33,0,1,0,86.4,327.77l11.43-11.43c26.88-26.88,72.84-7.85,72.84,30.17v16.16a21.33,21.33,0,0,0,42.66,0V346.51c0-38,46-57.05,72.84-30.17l11.43,11.43a21.33,21.33,0,0,0,30.17-30.17l-11.43-11.43C289.46,259.29,308.49,213.33,346.51,213.33ZM160,192a32,32,0,1,1,32-32A32,32,0,0,1,160,192Zm80,32a16,16,0,1,1,16-16A16,16,0,0,1,240,224Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVoicemail(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 128a144 144 0 0 0-119.74 224H263.74A144 144 0 1 0 144 416h352a144 144 0 0 0 0-288zM64 272a80 80 0 1 1 80 80 80 80 0 0 1-80-80zm432 80a80 80 0 1 1 80-80 80 80 0 0 1-80 80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVolleyballBall(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M231.39 243.48a285.56 285.56 0 0 0-22.7-105.7c-90.8 42.4-157.5 122.4-180.3 216.8a249 249 0 0 0 56.9 81.1 333.87 333.87 0 0 1 146.1-192.2zm-36.9-134.4a284.23 284.23 0 0 0-57.4-70.7c-91 49.8-144.8 152.9-125 262.2 33.4-83.1 98.4-152 182.4-191.5zm187.6 165.1c8.6-99.8-27.3-197.5-97.5-264.4-14.7-1.7-51.6-5.5-98.9 8.5A333.87 333.87 0 0 1 279.19 241a285 285 0 0 0 102.9 33.18zm-124.7 9.5a286.33 286.33 0 0 0-80.2 72.6c82 57.3 184.5 75.1 277.5 47.8a247.15 247.15 0 0 0 42.2-89.9 336.1 336.1 0 0 1-80.9 10.4c-54.6-.1-108.9-14.1-158.6-40.9zm-98.3 99.7c-15.2 26-25.7 54.4-32.1 84.2a247.07 247.07 0 0 0 289-22.1c-112.9 16.1-203.3-24.8-256.9-62.1zm180.3-360.6c55.3 70.4 82.5 161.2 74.6 253.6a286.59 286.59 0 0 0 89.7-14.2c0-2 .3-4 .3-6 0-107.8-68.7-199.1-164.6-233.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVolumeDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M215.03 72.04L126.06 161H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V89.02c0-21.47-25.96-31.98-40.97-16.98zm123.2 108.08c-11.58-6.33-26.19-2.16-32.61 9.45-6.39 11.61-2.16 26.2 9.45 32.61C327.98 229.28 336 242.62 336 257c0 14.38-8.02 27.72-20.92 34.81-11.61 6.41-15.84 21-9.45 32.61 6.43 11.66 21.05 15.8 32.61 9.45 28.23-15.55 45.77-45 45.77-76.88s-17.54-61.32-45.78-76.87z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVolumeMute(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M215.03 71.05L126.06 160H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V88.02c0-21.46-25.96-31.98-40.97-16.97zM461.64 256l45.64-45.64c6.3-6.3 6.3-16.52 0-22.82l-22.82-22.82c-6.3-6.3-16.52-6.3-22.82 0L416 210.36l-45.64-45.64c-6.3-6.3-16.52-6.3-22.82 0l-22.82 22.82c-6.3 6.3-6.3 16.52 0 22.82L370.36 256l-45.63 45.63c-6.3 6.3-6.3 16.52 0 22.82l22.82 22.82c6.3 6.3 16.52 6.3 22.82 0L416 301.64l45.64 45.64c6.3 6.3 16.52 6.3 22.82 0l22.82-22.82c6.3-6.3 6.3-16.52 0-22.82L461.64 256z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVolumeOff(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M215 71l-89 89H24a24 24 0 0 0-24 24v144a24 24 0 0 0 24 24h102.06L215 441c15 15 41 4.47 41-17V88c0-21.47-26-32-41-17z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVolumeUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M215.03 71.05L126.06 160H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V88.02c0-21.46-25.96-31.98-40.97-16.97zm233.32-51.08c-11.17-7.33-26.18-4.24-33.51 6.95-7.34 11.17-4.22 26.18 6.95 33.51 66.27 43.49 105.82 116.6 105.82 195.58 0 78.98-39.55 152.09-105.82 195.58-11.17 7.32-14.29 22.34-6.95 33.5 7.04 10.71 21.93 14.56 33.51 6.95C528.27 439.58 576 351.33 576 256S528.27 72.43 448.35 19.97zM480 256c0-63.53-32.06-121.94-85.77-156.24-11.19-7.14-26.03-3.82-33.12 7.46s-3.78 26.21 7.41 33.36C408.27 165.97 432 209.11 432 256s-23.73 90.03-63.48 115.42c-11.19 7.14-14.5 22.07-7.41 33.36 6.51 10.36 21.12 15.14 33.12 7.46C447.94 377.94 480 319.54 480 256zm-141.77-76.87c-11.58-6.33-26.19-2.16-32.61 9.45-6.39 11.61-2.16 26.2 9.45 32.61C327.98 228.28 336 241.63 336 256c0 14.38-8.02 27.72-20.92 34.81-11.61 6.41-15.84 21-9.45 32.61 6.43 11.66 21.05 15.8 32.61 9.45 28.23-15.55 45.77-45 45.77-76.88s-17.54-61.32-45.78-76.86z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVoteYea(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M608 320h-64v64h22.4c5.3 0 9.6 3.6 9.6 8v16c0 4.4-4.3 8-9.6 8H73.6c-5.3 0-9.6-3.6-9.6-8v-16c0-4.4 4.3-8 9.6-8H96v-64H32c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h576c17.7 0 32-14.3 32-32v-96c0-17.7-14.3-32-32-32zm-96 64V64.3c0-17.9-14.5-32.3-32.3-32.3H160.4C142.5 32 128 46.5 128 64.3V384h384zM211.2 202l25.5-25.3c4.2-4.2 11-4.2 15.2.1l41.3 41.6 95.2-94.4c4.2-4.2 11-4.2 15.2.1l25.3 25.5c4.2 4.2 4.2 11-.1 15.2L300.5 292c-4.2 4.2-11 4.2-15.2-.1l-74.1-74.7c-4.3-4.2-4.2-11 0-15.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaVrCardboard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h160.22c25.19 0 48.03-14.77 58.36-37.74l27.74-61.64C286.21 331.08 302.35 320 320 320s33.79 11.08 41.68 28.62l27.74 61.64C399.75 433.23 422.6 448 447.78 448H608c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zM160 304c-35.35 0-64-28.65-64-64s28.65-64 64-64 64 28.65 64 64-28.65 64-64 64zm320 0c-35.35 0-64-28.65-64-64s28.65-64 64-64 64 28.65 64 64-28.65 64-64 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWalking(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208 96c26.5 0 48-21.5 48-48S234.5 0 208 0s-48 21.5-48 48 21.5 48 48 48zm94.5 149.1l-23.3-11.8-9.7-29.4c-14.7-44.6-55.7-75.8-102.2-75.9-36-.1-55.9 10.1-93.3 25.2-21.6 8.7-39.3 25.2-49.7 46.2L17.6 213c-7.8 15.8-1.5 35 14.2 42.9 15.6 7.9 34.6 1.5 42.5-14.3L81 228c3.5-7 9.3-12.5 16.5-15.4l26.8-10.8-15.2 60.7c-5.2 20.8.4 42.9 14.9 58.8l59.9 65.4c7.2 7.9 12.3 17.4 14.9 27.7l18.3 73.3c4.3 17.1 21.7 27.6 38.8 23.3 17.1-4.3 27.6-21.7 23.3-38.8l-22.2-89c-2.6-10.3-7.7-19.9-14.9-27.7l-45.5-49.7 17.2-68.7 5.5 16.5c5.3 16.1 16.7 29.4 31.7 37l23.3 11.8c15.6 7.9 34.6 1.5 42.5-14.3 7.7-15.7 1.4-35.1-14.3-43zM73.6 385.8c-3.2 8.1-8 15.4-14.2 21.5l-50 50.1c-12.5 12.5-12.5 32.8 0 45.3s32.7 12.5 45.2 0l59.4-59.4c6.1-6.1 10.9-13.4 14.2-21.5l13.5-33.8c-55.3-60.3-38.7-41.8-47.4-53.7l-20.7 51.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWallet(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M461.2 128H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h384c8.84 0 16-7.16 16-16 0-26.51-21.49-48-48-48H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h397.2c28.02 0 50.8-21.53 50.8-48V176c0-26.47-22.78-48-50.8-48zM416 336c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWarehouse(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 352H136.4c-4.4 0-8 3.6-8 8l-.1 48c0 4.4 3.6 8 8 8H504c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm0 96H136.1c-4.4 0-8 3.6-8 8l-.1 48c0 4.4 3.6 8 8 8h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm0-192H136.6c-4.4 0-8 3.6-8 8l-.1 48c0 4.4 3.6 8 8 8H504c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm106.5-139L338.4 3.7a48.15 48.15 0 0 0-36.9 0L29.5 117C11.7 124.5 0 141.9 0 161.3V504c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V256c0-17.6 14.6-32 32.6-32h382.8c18 0 32.6 14.4 32.6 32v248c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V161.3c0-19.4-11.7-36.8-29.5-44.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWater(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M562.1 383.9c-21.5-2.4-42.1-10.5-57.9-22.9-14.1-11.1-34.2-11.3-48.2 0-37.9 30.4-107.2 30.4-145.7-1.5-13.5-11.2-33-9.1-46.7 1.8-38 30.1-106.9 30-145.2-1.7-13.5-11.2-33.3-8.9-47.1 2-15.5 12.2-36 20.1-57.7 22.4-7.9.8-13.6 7.8-13.6 15.7v32.2c0 9.1 7.6 16.8 16.7 16 28.8-2.5 56.1-11.4 79.4-25.9 56.5 34.6 137 34.1 192 0 56.5 34.6 137 34.1 192 0 23.3 14.2 50.9 23.3 79.1 25.8 9.1.8 16.7-6.9 16.7-16v-31.6c.1-8-5.7-15.4-13.8-16.3zm0-144c-21.5-2.4-42.1-10.5-57.9-22.9-14.1-11.1-34.2-11.3-48.2 0-37.9 30.4-107.2 30.4-145.7-1.5-13.5-11.2-33-9.1-46.7 1.8-38 30.1-106.9 30-145.2-1.7-13.5-11.2-33.3-8.9-47.1 2-15.5 12.2-36 20.1-57.7 22.4-7.9.8-13.6 7.8-13.6 15.7v32.2c0 9.1 7.6 16.8 16.7 16 28.8-2.5 56.1-11.4 79.4-25.9 56.5 34.6 137 34.1 192 0 56.5 34.6 137 34.1 192 0 23.3 14.2 50.9 23.3 79.1 25.8 9.1.8 16.7-6.9 16.7-16v-31.6c.1-8-5.7-15.4-13.8-16.3zm0-144C540.6 93.4 520 85.4 504.2 73 490.1 61.9 470 61.7 456 73c-37.9 30.4-107.2 30.4-145.7-1.5-13.5-11.2-33-9.1-46.7 1.8-38 30.1-106.9 30-145.2-1.7-13.5-11.2-33.3-8.9-47.1 2-15.5 12.2-36 20.1-57.7 22.4-7.9.8-13.6 7.8-13.6 15.7v32.2c0 9.1 7.6 16.8 16.7 16 28.8-2.5 56.1-11.4 79.4-25.9 56.5 34.6 137 34.1 192 0 56.5 34.6 137 34.1 192 0 23.3 14.2 50.9 23.3 79.1 25.8 9.1.8 16.7-6.9 16.7-16v-31.6c.1-8-5.7-15.4-13.8-16.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWaveSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M476 480H324a36 36 0 0 1-36-36V96h-96v156a36 36 0 0 1-36 36H16a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h112V68a36 36 0 0 1 36-36h152a36 36 0 0 1 36 36v348h96V260a36 36 0 0 1 36-36h140a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H512v156a36 36 0 0 1-36 36z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWeightHanging(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M510.28 445.86l-73.03-292.13c-3.8-15.19-16.44-25.72-30.87-25.72h-60.25c3.57-10.05 5.88-20.72 5.88-32 0-53.02-42.98-96-96-96s-96 42.98-96 96c0 11.28 2.3 21.95 5.88 32h-60.25c-14.43 0-27.08 10.54-30.87 25.72L1.72 445.86C-6.61 479.17 16.38 512 48.03 512h415.95c31.64 0 54.63-32.83 46.3-66.14zM256 128c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWeight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 64h-25.98C438.44 92.28 448 125.01 448 160c0 105.87-86.13 192-192 192S64 265.87 64 160c0-34.99 9.56-67.72 25.98-96H64C28.71 64 0 92.71 0 128v320c0 35.29 28.71 64 64 64h384c35.29 0 64-28.71 64-64V128c0-35.29-28.71-64-64-64zM256 320c88.37 0 160-71.63 160-160S344.37 0 256 0 96 71.63 96 160s71.63 160 160 160zm-.3-151.94l33.58-78.36c3.5-8.17 12.94-11.92 21.03-8.41 8.12 3.48 11.88 12.89 8.41 21l-33.67 78.55C291.73 188 296 197.45 296 208c0 22.09-17.91 40-40 40s-40-17.91-40-40c0-21.98 17.76-39.77 39.7-39.94z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWheelchair(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496.101 385.669l14.227 28.663c3.929 7.915.697 17.516-7.218 21.445l-65.465 32.886c-16.049 7.967-35.556 1.194-43.189-15.055L331.679 320H192c-15.925 0-29.426-11.71-31.679-27.475C126.433 55.308 128.38 70.044 128 64c0-36.358 30.318-65.635 67.052-63.929 33.271 1.545 60.048 28.905 60.925 62.201.868 32.933-23.152 60.423-54.608 65.039l4.67 32.69H336c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16H215.182l4.572 32H352a32 32 0 0 1 28.962 18.392L438.477 396.8l36.178-18.349c7.915-3.929 17.517-.697 21.446 7.218zM311.358 352h-24.506c-7.788 54.204-54.528 96-110.852 96-61.757 0-112-50.243-112-112 0-41.505 22.694-77.809 56.324-97.156-3.712-25.965-6.844-47.86-9.488-66.333C45.956 198.464 0 261.963 0 336c0 97.047 78.953 176 176 176 71.87 0 133.806-43.308 161.11-105.192L311.358 352z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWifi(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M634.91 154.88C457.74-8.99 182.19-8.93 5.09 154.88c-6.66 6.16-6.79 16.59-.35 22.98l34.24 33.97c6.14 6.1 16.02 6.23 22.4.38 145.92-133.68 371.3-133.71 517.25 0 6.38 5.85 16.26 5.71 22.4-.38l34.24-33.97c6.43-6.39 6.3-16.82-.36-22.98zM320 352c-35.35 0-64 28.65-64 64s28.65 64 64 64 64-28.65 64-64-28.65-64-64-64zm202.67-83.59c-115.26-101.93-290.21-101.82-405.34 0-6.9 6.1-7.12 16.69-.57 23.15l34.44 33.99c6 5.92 15.66 6.32 22.05.8 83.95-72.57 209.74-72.41 293.49 0 6.39 5.52 16.05 5.13 22.05-.8l34.44-33.99c6.56-6.46 6.33-17.06-.56-23.15z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWind(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M156.7 256H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h142.2c15.9 0 30.8 10.9 33.4 26.6 3.3 20-12.1 37.4-31.6 37.4-14.1 0-26.1-9.2-30.4-21.9-2.1-6.3-8.6-10.1-15.2-10.1H81.6c-9.8 0-17.7 8.8-15.9 18.4 8.6 44.1 47.6 77.6 94.2 77.6 57.1 0 102.7-50.1 95.2-108.6C249 291 205.4 256 156.7 256zM16 224h336c59.7 0 106.8-54.8 93.8-116.7-7.6-36.2-36.9-65.5-73.1-73.1-55.4-11.6-105.1 24.9-114.9 75.5-1.9 9.6 6.1 18.3 15.8 18.3h32.8c6.7 0 13.1-3.8 15.2-10.1C325.9 105.2 337.9 96 352 96c19.4 0 34.9 17.4 31.6 37.4-2.6 15.7-17.4 26.6-33.4 26.6H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16zm384 32H243.7c19.3 16.6 33.2 38.8 39.8 64H400c26.5 0 48 21.5 48 48s-21.5 48-48 48c-17.9 0-33.3-9.9-41.6-24.4-2.9-5-8.7-7.6-14.5-7.6h-33.8c-10.9 0-19 10.8-15.3 21.1 17.8 50.6 70.5 84.8 129.4 72.3 41.2-8.7 75.1-41.6 84.7-82.7C526 321.5 470.5 256 400 256z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWindowClose(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-83.6 290.5c4.8 4.8 4.8 12.6 0 17.4l-40.5 40.5c-4.8 4.8-12.6 4.8-17.4 0L256 313.3l-66.5 67.1c-4.8 4.8-12.6 4.8-17.4 0l-40.5-40.5c-4.8-4.8-4.8-12.6 0-17.4l67.1-66.5-67.1-66.5c-4.8-4.8-4.8-12.6 0-17.4l40.5-40.5c4.8-4.8 12.6-4.8 17.4 0l66.5 67.1 66.5-67.1c4.8-4.8 12.6-4.8 17.4 0l40.5 40.5c4.8 4.8 4.8 12.6 0 17.4L313.3 256l67.1 66.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWindowMaximize(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-16 160H64v-84c0-6.6 5.4-12 12-12h360c6.6 0 12 5.4 12 12v84z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWindowMinimize(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 352H48c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48v-32c0-26.5-21.5-48-48-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWindowRestore(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 48v288c0 26.5-21.5 48-48 48h-48V176c0-44.1-35.9-80-80-80H128V48c0-26.5 21.5-48 48-48h288c26.5 0 48 21.5 48 48zM384 176v288c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48h288c26.5 0 48 21.5 48 48zm-68 28c0-6.6-5.4-12-12-12H76c-6.6 0-12 5.4-12 12v52h252v-52z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWineBottle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M507.31 72.57L439.43 4.69c-6.25-6.25-16.38-6.25-22.63 0l-22.63 22.63c-6.25 6.25-6.25 16.38 0 22.63l-76.67 76.67c-46.58-19.7-102.4-10.73-140.37 27.23L18.75 312.23c-24.99 24.99-24.99 65.52 0 90.51l90.51 90.51c24.99 24.99 65.52 24.99 90.51 0l158.39-158.39c37.96-37.96 46.93-93.79 27.23-140.37l76.67-76.67c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.24-6.24 6.24-16.37-.01-22.62zM179.22 423.29l-90.51-90.51 122.04-122.04 90.51 90.51-122.04 122.04z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWineGlassAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 288 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M216 464h-40V346.81c68.47-15.89 118.05-79.91 111.4-154.16l-15.95-178.1C270.71 6.31 263.9 0 255.74 0H32.26c-8.15 0-14.97 6.31-15.7 14.55L.6 192.66C-6.05 266.91 43.53 330.93 112 346.82V464H72c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h208c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40zM61.75 48h164.5l7.17 80H54.58l7.17-80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWineGlass(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 288 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M216 464h-40V346.81c68.47-15.89 118.05-79.91 111.4-154.16l-15.95-178.1C270.71 6.31 263.9 0 255.74 0H32.26c-8.15 0-14.97 6.31-15.7 14.55L.6 192.66C-6.05 266.91 43.53 330.93 112 346.82V464H72c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h208c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWonSign(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M564 192c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-48l18.6-80.6c1.7-7.5-4-14.7-11.7-14.7h-46.1c-5.7 0-10.6 4-11.7 9.5L450.7 128H340.8l-19.7-86c-1.3-5.5-6.1-9.3-11.7-9.3h-44c-5.6 0-10.4 3.8-11.7 9.3l-20 86H125l-17.5-85.7c-1.1-5.6-6.1-9.6-11.8-9.6H53.6c-7.7 0-13.4 7.1-11.7 14.6L60 128H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h62.3l7.2 32H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h83.9l40.9 182.6c1.2 5.5 6.1 9.4 11.7 9.4h56.8c5.6 0 10.4-3.9 11.7-9.3L259.3 288h55.1l42.4 182.7c1.3 5.4 6.1 9.3 11.7 9.3h56.8c5.6 0 10.4-3.9 11.7-9.3L479.1 288H564c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-70.1l7.4-32zM183.8 342c-6.2 25.8-6.8 47.2-7.3 47.2h-1.1s-1.7-22-6.8-47.2l-11-54h38.8zm27.5-118h-66.8l-6.5-32h80.8zm62.9 0l2-8.6c1.9-8 3.5-16 4.8-23.4h11.8c1.3 7.4 2.9 15.4 4.8 23.4l2 8.6zm130.9 118c-5.1 25.2-6.8 47.2-6.8 47.2h-1.1c-.6 0-1.1-21.4-7.3-47.2l-12.4-54h39.1zm25.2-118h-67.4l-7.3-32h81.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaWrench(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M507.73 109.1c-2.24-9.03-13.54-12.09-20.12-5.51l-74.36 74.36-67.88-11.31-11.31-67.88 74.36-74.36c6.62-6.62 3.43-17.9-5.66-20.16-47.38-11.74-99.55.91-136.58 37.93-39.64 39.64-50.55 97.1-34.05 147.2L18.74 402.76c-24.99 24.99-24.99 65.51 0 90.5 24.99 24.99 65.51 24.99 90.5 0l213.21-213.21c50.12 16.71 107.47 5.68 147.37-34.22 37.07-37.07 49.7-89.32 37.91-136.73zM64 472c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaXRay(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M240 384c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm160 32c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zM624 0H16C7.2 0 0 7.2 0 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16zm0 448h-48V96H64v352H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM480 248c0 4.4-3.6 8-8 8H336v32h104c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H336v32h64c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48v-16h-64v16c0 26.5-21.5 48-48 48s-48-21.5-48-48 21.5-48 48-48h64v-32H200c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h104v-32H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h136v-32H200c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h104v-24c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v24h104c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H336v32h136c4.4 0 8 3.6 8 8v16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaYenSign(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M351.2 32h-65.3c-4.6 0-8.8 2.6-10.8 6.7l-55.4 113.2c-14.5 34.7-27.1 71.9-27.1 71.9h-1.3s-12.6-37.2-27.1-71.9L108.8 38.7c-2-4.1-6.2-6.7-10.8-6.7H32.8c-9.1 0-14.8 9.7-10.6 17.6L102.3 200H44c-6.6 0-12 5.4-12 12v32c0 6.6 5.4 12 12 12h88.2l19.8 37.2V320H44c-6.6 0-12 5.4-12 12v32c0 6.6 5.4 12 12 12h108v92c0 6.6 5.4 12 12 12h56c6.6 0 12-5.4 12-12v-92h108c6.6 0 12-5.4 12-12v-32c0-6.6-5.4-12-12-12H232v-26.8l19.8-37.2H340c6.6 0 12-5.4 12-12v-32c0-6.6-5.4-12-12-12h-58.3l80.1-150.4c4.3-7.9-1.5-17.6-10.6-17.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaYinYang(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 376c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-128c-53.02 0-96 42.98-96 96s42.98 96 96 96c-106.04 0-192-85.96-192-192S141.96 64 248 64c53.02 0 96 42.98 96 96s-42.98 96-96 96zm0-128c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegAddressBook(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M436 160c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48v-48h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20v-64h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20v-64h20zm-68 304H48V48h320v416zM208 256c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm-89.6 128h179.2c12.4 0 22.4-8.6 22.4-19.2v-19.2c0-31.8-30.1-57.6-67.2-57.6-10.8 0-18.7 8-44.8 8-26.9 0-33.4-8-44.8-8-37.1 0-67.2 25.8-67.2 57.6v19.2c0 10.6 10 19.2 22.4 19.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegAddressCard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm0 400H48V80h480v352zM208 256c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm-89.6 128h179.2c12.4 0 22.4-8.6 22.4-19.2v-19.2c0-31.8-30.1-57.6-67.2-57.6-10.8 0-18.7 8-44.8 8-26.9 0-33.4-8-44.8-8-37.1 0-67.2 25.8-67.2 57.6v19.2c0 10.6 10 19.2 22.4 19.2zM360 320h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm0-64h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm0-64h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegAngry(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm0-144c-33.6 0-65.2 14.8-86.8 40.6-8.5 10.2-7.1 25.3 3.1 33.8s25.3 7.2 33.8-3c24.8-29.7 75-29.7 99.8 0 8.1 9.7 23.2 11.9 33.8 3 10.2-8.5 11.5-23.6 3.1-33.8-21.6-25.8-53.2-40.6-86.8-40.6zm-48-72c10.3 0 19.9-6.7 23-17.1 3.8-12.7-3.4-26.1-16.1-29.9l-80-24c-12.8-3.9-26.1 3.4-29.9 16.1-3.8 12.7 3.4 26.1 16.1 29.9l28.2 8.5c-3.1 4.9-5.3 10.4-5.3 16.6 0 17.7 14.3 32 32 32s32-14.4 32-32.1zm199-54.9c-3.8-12.7-17.1-19.9-29.9-16.1l-80 24c-12.7 3.8-19.9 17.2-16.1 29.9 3.1 10.4 12.7 17.1 23 17.1 0 17.7 14.3 32 32 32s32-14.3 32-32c0-6.2-2.2-11.7-5.3-16.6l28.2-8.5c12.7-3.7 19.9-17.1 16.1-29.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegArrowAltCircleDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm-32-316v116h-67c-10.7 0-16 12.9-8.5 20.5l99 99c4.7 4.7 12.3 4.7 17 0l99-99c7.6-7.6 2.2-20.5-8.5-20.5h-67V140c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegArrowAltCircleLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 256c0 137 111 248 248 248s248-111 248-248S393 8 256 8 8 119 8 256zm448 0c0 110.5-89.5 200-200 200S56 366.5 56 256 145.5 56 256 56s200 89.5 200 200zm-72-20v40c0 6.6-5.4 12-12 12H256v67c0 10.7-12.9 16-20.5 8.5l-99-99c-4.7-4.7-4.7-12.3 0-17l99-99c7.6-7.6 20.5-2.2 20.5 8.5v67h116c6.6 0 12 5.4 12 12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegArrowAltCircleRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 256C504 119 393 8 256 8S8 119 8 256s111 248 248 248 248-111 248-248zm-448 0c0-110.5 89.5-200 200-200s200 89.5 200 200-89.5 200-200 200S56 366.5 56 256zm72 20v-40c0-6.6 5.4-12 12-12h116v-67c0-10.7 12.9-16 20.5-8.5l99 99c4.7 4.7 4.7 12.3 0 17l-99 99c-7.6 7.6-20.5 2.2-20.5-8.5v-67H140c-6.6 0-12-5.4-12-12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegArrowAltCircleUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 504c137 0 248-111 248-248S393 8 256 8 8 119 8 256s111 248 248 248zm0-448c110.5 0 200 89.5 200 200s-89.5 200-200 200S56 366.5 56 256 145.5 56 256 56zm20 328h-40c-6.6 0-12-5.4-12-12V256h-67c-10.7 0-16-12.9-8.5-20.5l99-99c4.7-4.7 12.3-4.7 17 0l99 99c7.6 7.6 2.2 20.5-8.5 20.5h-67v116c0 6.6-5.4 12-12 12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegBellSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M633.99 471.02L36 3.51C29.1-2.01 19.03-.9 13.51 6l-10 12.49C-2.02 25.39-.9 35.46 6 40.98l598 467.51c6.9 5.52 16.96 4.4 22.49-2.49l10-12.49c5.52-6.9 4.41-16.97-2.5-22.49zM163.53 368c16.71-22.03 34.48-55.8 41.4-110.58l-45.47-35.55c-3.27 90.73-36.47 120.68-54.84 140.42-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h279.66l-61.4-48H163.53zM320 96c61.86 0 112 50.14 112 112 0 .2-.06.38-.06.58.02 16.84 1.16 31.77 2.79 45.73l59.53 46.54c-8.31-22.13-14.34-51.49-14.34-92.85 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84c-26.02 5.41-49.45 16.94-69.13 32.72l38.17 29.84C275 103.18 296.65 96 320 96zm0 416c35.32 0 63.97-28.65 63.97-64H256.03c0 35.35 28.65 64 63.97 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegBell(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M439.39 362.29c-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84C118.56 68.1 64.08 130.3 64.08 208c0 102.3-36.15 133.53-55.47 154.29-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h383.8c19.12 0 32-15.6 32.1-32 .05-7.55-2.61-15.27-8.61-21.71zM67.53 368c21.22-27.97 44.42-74.33 44.53-159.42 0-.2-.06-.38-.06-.58 0-61.86 50.14-112 112-112s112 50.14 112 112c0 .2-.06.38-.06.58.11 85.1 23.31 131.46 44.53 159.42H67.53zM224 512c35.32 0 63.97-28.65 63.97-64H160.03c0 35.35 28.65 64 63.97 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegBookmark(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 0H48C21.49 0 0 21.49 0 48v464l192-112 192 112V48c0-26.51-21.49-48-48-48zm0 428.43l-144-84-144 84V54a6 6 0 0 1 6-6h276c3.314 0 6 2.683 6 5.996V428.43z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegBuilding(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 148v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12zm140 12h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zm-128 96h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zm128 0h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zm-76 84v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm76 12h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zm180 124v36H0v-36c0-6.6 5.4-12 12-12h19.5V24c0-13.3 10.7-24 24-24h337c13.3 0 24 10.7 24 24v440H436c6.6 0 12 5.4 12 12zM79.5 463H192v-67c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v67h112.5V49L80 48l-.5 415z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegCalendarAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M148 288h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm108-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 96v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm192 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96-260v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegCalendarCheck(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 64h-48V12c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v52H160V12c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v52H48C21.49 64 0 85.49 0 112v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm-6 400H54a6 6 0 0 1-6-6V160h352v298a6 6 0 0 1-6 6zm-52.849-200.65L198.842 404.519c-4.705 4.667-12.303 4.637-16.971-.068l-75.091-75.699c-4.667-4.705-4.637-12.303.068-16.971l22.719-22.536c4.705-4.667 12.303-4.637 16.97.069l44.104 44.461 111.072-110.181c4.705-4.667 12.303-4.637 16.971.068l22.536 22.718c4.667 4.705 4.636 12.303-.069 16.97z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegCalendarMinus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M124 328c-6.6 0-12-5.4-12-12v-24c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v24c0 6.6-5.4 12-12 12H124zm324-216v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegCalendarPlus(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 292v24c0 6.6-5.4 12-12 12h-76v76c0 6.6-5.4 12-12 12h-24c-6.6 0-12-5.4-12-12v-76h-76c-6.6 0-12-5.4-12-12v-24c0-6.6 5.4-12 12-12h76v-76c0-6.6 5.4-12 12-12h24c6.6 0 12 5.4 12 12v76h76c6.6 0 12 5.4 12 12zm112-180v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegCalendarTimes(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M311.7 374.7l-17 17c-4.7 4.7-12.3 4.7-17 0L224 337.9l-53.7 53.7c-4.7 4.7-12.3 4.7-17 0l-17-17c-4.7-4.7-4.7-12.3 0-17l53.7-53.7-53.7-53.7c-4.7-4.7-4.7-12.3 0-17l17-17c4.7-4.7 12.3-4.7 17 0l53.7 53.7 53.7-53.7c4.7-4.7 12.3-4.7 17 0l17 17c4.7 4.7 4.7 12.3 0 17L257.9 304l53.7 53.7c4.8 4.7 4.8 12.3.1 17zM448 112v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegCalendar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 64h-48V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H160V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zm-6 400H54c-3.3 0-6-2.7-6-6V160h352v298c0 3.3-2.7 6-6 6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegCaretSquareDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M125.1 208h197.8c10.7 0 16.1 13 8.5 20.5l-98.9 98.3c-4.7 4.7-12.2 4.7-16.9 0l-98.9-98.3c-7.7-7.5-2.3-20.5 8.4-20.5zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegCaretSquareLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272 157.1v197.8c0 10.7-13 16.1-20.5 8.5l-98.3-98.9c-4.7-4.7-4.7-12.2 0-16.9l98.3-98.9c7.5-7.7 20.5-2.3 20.5 8.4zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegCaretSquareRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 354.9V157.1c0-10.7 13-16.1 20.5-8.5l98.3 98.9c4.7 4.7 4.7 12.2 0 16.9l-98.3 98.9c-7.5 7.7-20.5 2.3-20.5-8.4zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegCaretSquareUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M322.9 304H125.1c-10.7 0-16.1-13-8.5-20.5l98.9-98.3c4.7-4.7 12.2-4.7 16.9 0l98.9 98.3c7.7 7.5 2.3 20.5-8.4 20.5zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegChartBar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M396.8 352h22.4c6.4 0 12.8-6.4 12.8-12.8V108.8c0-6.4-6.4-12.8-12.8-12.8h-22.4c-6.4 0-12.8 6.4-12.8 12.8v230.4c0 6.4 6.4 12.8 12.8 12.8zm-192 0h22.4c6.4 0 12.8-6.4 12.8-12.8V140.8c0-6.4-6.4-12.8-12.8-12.8h-22.4c-6.4 0-12.8 6.4-12.8 12.8v198.4c0 6.4 6.4 12.8 12.8 12.8zm96 0h22.4c6.4 0 12.8-6.4 12.8-12.8V204.8c0-6.4-6.4-12.8-12.8-12.8h-22.4c-6.4 0-12.8 6.4-12.8 12.8v134.4c0 6.4 6.4 12.8 12.8 12.8zM496 400H48V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v336c0 17.67 14.33 32 32 32h464c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16zm-387.2-48h22.4c6.4 0 12.8-6.4 12.8-12.8v-70.4c0-6.4-6.4-12.8-12.8-12.8h-22.4c-6.4 0-12.8 6.4-12.8 12.8v70.4c0 6.4 6.4 12.8 12.8 12.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegCheckCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346 303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068 16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegCheckSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zm0 400H48V80h352v352zm-35.864-241.724L191.547 361.48c-4.705 4.667-12.303 4.637-16.97-.068l-90.781-91.516c-4.667-4.705-4.637-12.303.069-16.971l22.719-22.536c4.705-4.667 12.303-4.637 16.97.069l59.792 60.277 141.352-140.216c4.705-4.667 12.303-4.637 16.97.068l22.536 22.718c4.667 4.706 4.637 12.304-.068 16.971z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegClipboard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 40c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm144 418c0 3.3-2.7 6-6 6H54c-3.3 0-6-2.7-6-6V118c0-3.3 2.7-6 6-6h42v36c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12v-36h42c3.3 0 6 2.7 6 6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegClock(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm61.8-104.4l-84.9-61.7c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v141.7l66.8 48.6c5.4 3.9 6.5 11.4 2.6 16.8L334.6 349c-3.9 5.3-11.4 6.5-16.8 2.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegClone(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 0H144c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h320c26.51 0 48-21.49 48-48v-48h48c26.51 0 48-21.49 48-48V48c0-26.51-21.49-48-48-48zM362 464H54a6 6 0 0 1-6-6V150a6 6 0 0 1 6-6h42v224c0 26.51 21.49 48 48 48h224v42a6 6 0 0 1-6 6zm96-96H150a6 6 0 0 1-6-6V54a6 6 0 0 1 6-6h308a6 6 0 0 1 6 6v308a6 6 0 0 1-6 6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegClosedCaptioning(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zm-6 336H54c-3.3 0-6-2.7-6-6V118c0-3.3 2.7-6 6-6h404c3.3 0 6 2.7 6 6v276c0 3.3-2.7 6-6 6zm-211.1-85.7c1.7 2.4 1.5 5.6-.5 7.7-53.6 56.8-172.8 32.1-172.8-67.9 0-97.3 121.7-119.5 172.5-70.1 2.1 2 2.5 3.2 1 5.7l-17.5 30.5c-1.9 3.1-6.2 4-9.1 1.7-40.8-32-94.6-14.9-94.6 31.2 0 48 51 70.5 92.2 32.6 2.8-2.5 7.1-2.1 9.2.9l19.6 27.7zm190.4 0c1.7 2.4 1.5 5.6-.5 7.7-53.6 56.9-172.8 32.1-172.8-67.9 0-97.3 121.7-119.5 172.5-70.1 2.1 2 2.5 3.2 1 5.7L420 220.2c-1.9 3.1-6.2 4-9.1 1.7-40.8-32-94.6-14.9-94.6 31.2 0 48 51 70.5 92.2 32.6 2.8-2.5 7.1-2.1 9.2.9l19.6 27.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegCommentAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 7.1 5.8 12 12 12 2.4 0 4.9-.7 7.1-2.4L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm16 352c0 8.8-7.2 16-16 16H288l-12.8 9.6L208 428v-60H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h384c8.8 0 16 7.2 16 16v288z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegCommentDots(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144 208c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm112 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm112 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zM256 32C114.6 32 0 125.1 0 240c0 47.6 19.9 91.2 52.9 126.3C38 405.7 7 439.1 6.5 439.5c-6.6 7-8.4 17.2-4.6 26S14.4 480 24 480c61.5 0 110-25.7 139.1-46.3C192 442.8 223.2 448 256 448c141.4 0 256-93.1 256-208S397.4 32 256 32zm0 368c-26.7 0-53.1-4.1-78.4-12.1l-22.7-7.2-19.5 13.8c-14.3 10.1-33.9 21.4-57.5 29 7.3-12.1 14.4-25.7 19.9-40.2l10.6-28.1-20.6-21.8C69.7 314.1 48 282.2 48 240c0-88.2 93.3-160 208-160s208 71.8 208 160-93.3 160-208 160z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegComment(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32C114.6 32 0 125.1 0 240c0 47.6 19.9 91.2 52.9 126.3C38 405.7 7 439.1 6.5 439.5c-6.6 7-8.4 17.2-4.6 26S14.4 480 24 480c61.5 0 110-25.7 139.1-46.3C192 442.8 223.2 448 256 448c141.4 0 256-93.1 256-208S397.4 32 256 32zm0 368c-26.7 0-53.1-4.1-78.4-12.1l-22.7-7.2-19.5 13.8c-14.3 10.1-33.9 21.4-57.5 29 7.3-12.1 14.4-25.7 19.9-40.2l10.6-28.1-20.6-21.8C69.7 314.1 48 282.2 48 240c0-88.2 93.3-160 208-160s208 71.8 208 160-93.3 160-208 160z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegComments(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M532 386.2c27.5-27.1 44-61.1 44-98.2 0-80-76.5-146.1-176.2-157.9C368.3 72.5 294.3 32 208 32 93.1 32 0 103.6 0 192c0 37 16.5 71 44 98.2-15.3 30.7-37.3 54.5-37.7 54.9-6.3 6.7-8.1 16.5-4.4 25 3.6 8.5 12 14 21.2 14 53.5 0 96.7-20.2 125.2-38.8 9.2 2.1 18.7 3.7 28.4 4.9C208.1 407.6 281.8 448 368 448c20.8 0 40.8-2.4 59.8-6.8C456.3 459.7 499.4 480 553 480c9.2 0 17.5-5.5 21.2-14 3.6-8.5 1.9-18.3-4.4-25-.4-.3-22.5-24.1-37.8-54.8zm-392.8-92.3L122.1 305c-14.1 9.1-28.5 16.3-43.1 21.4 2.7-4.7 5.4-9.7 8-14.8l15.5-31.1L77.7 256C64.2 242.6 48 220.7 48 192c0-60.7 73.3-112 160-112s160 51.3 160 112-73.3 112-160 112c-16.5 0-33-1.9-49-5.6l-19.8-4.5zM498.3 352l-24.7 24.4 15.5 31.1c2.6 5.1 5.3 10.1 8 14.8-14.6-5.1-29-12.3-43.1-21.4l-17.1-11.1-19.9 4.6c-16 3.7-32.5 5.6-49 5.6-54 0-102.2-20.1-131.3-49.7C338 339.5 416 272.9 416 192c0-3.4-.4-6.7-.7-10C479.7 196.5 528 238.8 528 288c0 28.7-16.2 50.6-29.7 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegCompass(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M347.94 129.86L203.6 195.83a31.938 31.938 0 0 0-15.77 15.77l-65.97 144.34c-7.61 16.65 9.54 33.81 26.2 26.2l144.34-65.97a31.938 31.938 0 0 0 15.77-15.77l65.97-144.34c7.61-16.66-9.54-33.81-26.2-26.2zm-77.36 148.72c-12.47 12.47-32.69 12.47-45.16 0-12.47-12.47-12.47-32.69 0-45.16 12.47-12.47 32.69-12.47 45.16 0 12.47 12.47 12.47 32.69 0 45.16zM248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 448c-110.28 0-200-89.72-200-200S137.72 56 248 56s200 89.72 200 200-89.72 200-200 200z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegCopy(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M433.941 65.941l-51.882-51.882A48 48 0 0 0 348.118 0H176c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48v-48h80c26.51 0 48-21.49 48-48V99.882a48 48 0 0 0-14.059-33.941zM266 464H54a6 6 0 0 1-6-6V150a6 6 0 0 1 6-6h74v224c0 26.51 21.49 48 48 48h96v42a6 6 0 0 1-6 6zm128-96H182a6 6 0 0 1-6-6V54a6 6 0 0 1 6-6h106v88c0 13.255 10.745 24 24 24h88v202a6 6 0 0 1-6 6zm6-256h-64V48h9.632c1.591 0 3.117.632 4.243 1.757l48.368 48.368a6 6 0 0 1 1.757 4.243V112z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegCopyright(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 448c-110.532 0-200-89.451-200-200 0-110.531 89.451-200 200-200 110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200zm107.351-101.064c-9.614 9.712-45.53 41.396-104.065 41.396-82.43 0-140.484-61.425-140.484-141.567 0-79.152 60.275-139.401 139.762-139.401 55.531 0 88.738 26.62 97.593 34.779a11.965 11.965 0 0 1 1.936 15.322l-18.155 28.113c-3.841 5.95-11.966 7.282-17.499 2.921-8.595-6.776-31.814-22.538-61.708-22.538-48.303 0-77.916 35.33-77.916 80.082 0 41.589 26.888 83.692 78.277 83.692 32.657 0 56.843-19.039 65.726-27.225 5.27-4.857 13.596-4.039 17.82 1.738l19.865 27.17a11.947 11.947 0 0 1-1.152 15.518z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegCreditCard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M527.9 32H48.1C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48.1 48h479.8c26.6 0 48.1-21.5 48.1-48V80c0-26.5-21.5-48-48.1-48zM54.1 80h467.8c3.3 0 6 2.7 6 6v42H48.1V86c0-3.3 2.7-6 6-6zm467.8 352H54.1c-3.3 0-6-2.7-6-6V256h479.8v170c0 3.3-2.7 6-6 6zM192 332v40c0 6.6-5.4 12-12 12h-72c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12zm192 0v40c0 6.6-5.4 12-12 12H236c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h136c6.6 0 12 5.4 12 12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegDizzy(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-33.8-217.9c7.8-7.8 7.8-20.5 0-28.3L196.3 192l17.9-17.9c7.8-7.8 7.8-20.5 0-28.3-7.8-7.8-20.5-7.8-28.3 0L168 163.7l-17.8-17.8c-7.8-7.8-20.5-7.8-28.3 0-7.8 7.8-7.8 20.5 0 28.3l17.9 17.9-17.9 17.9c-7.8 7.8-7.8 20.5 0 28.3 7.8 7.8 20.5 7.8 28.3 0l17.8-17.8 17.8 17.8c7.9 7.7 20.5 7.7 28.4-.2zm160-92.2c-7.8-7.8-20.5-7.8-28.3 0L328 163.7l-17.8-17.8c-7.8-7.8-20.5-7.8-28.3 0-7.8 7.8-7.8 20.5 0 28.3l17.9 17.9-17.9 17.9c-7.8 7.8-7.8 20.5 0 28.3 7.8 7.8 20.5 7.8 28.3 0l17.8-17.8 17.8 17.8c7.8 7.8 20.5 7.8 28.3 0 7.8-7.8 7.8-20.5 0-28.3l-17.8-18 17.9-17.9c7.7-7.8 7.7-20.4 0-28.2zM248 272c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegDotCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 56c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m0-48C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 168c-44.183 0-80 35.817-80 80s35.817 80 80 80 80-35.817 80-80-35.817-80-80-80z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegEdit(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M402.3 344.9l32-32c5-5 13.7-1.5 13.7 5.7V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h273.5c7.1 0 10.7 8.6 5.7 13.7l-32 32c-1.5 1.5-3.5 2.3-5.7 2.3H48v352h352V350.5c0-2.1.8-4.1 2.3-5.6zm156.6-201.8L296.3 405.7l-90.4 10c-26.2 2.9-48.5-19.2-45.6-45.6l10-90.4L432.9 17.1c22.9-22.9 59.9-22.9 82.7 0l43.2 43.2c22.9 22.9 22.9 60 .1 82.8zM460.1 174L402 115.9 216.2 301.8l-7.3 65.3 65.3-7.3L460.1 174zm64.8-79.7l-43.2-43.2c-4.1-4.1-10.8-4.1-14.8 0L436 82l58.1 58.1 30.9-30.9c4-4.2 4-10.8-.1-14.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegEnvelopeOpen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M494.586 164.516c-4.697-3.883-111.723-89.95-135.251-108.657C337.231 38.191 299.437 0 256 0c-43.205 0-80.636 37.717-103.335 55.859-24.463 19.45-131.07 105.195-135.15 108.549A48.004 48.004 0 0 0 0 201.485V464c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V201.509a48 48 0 0 0-17.414-36.993zM464 458a6 6 0 0 1-6 6H54a6 6 0 0 1-6-6V204.347c0-1.813.816-3.526 2.226-4.665 15.87-12.814 108.793-87.554 132.364-106.293C200.755 78.88 232.398 48 256 48c23.693 0 55.857 31.369 73.41 45.389 23.573 18.741 116.503 93.493 132.366 106.316a5.99 5.99 0 0 1 2.224 4.663V458zm-31.991-187.704c4.249 5.159 3.465 12.795-1.745 16.981-28.975 23.283-59.274 47.597-70.929 56.863C336.636 362.283 299.205 400 256 400c-43.452 0-81.287-38.237-103.335-55.86-11.279-8.967-41.744-33.413-70.927-56.865-5.21-4.187-5.993-11.822-1.745-16.981l15.258-18.528c4.178-5.073 11.657-5.843 16.779-1.726 28.618 23.001 58.566 47.035 70.56 56.571C200.143 320.631 232.307 352 256 352c23.602 0 55.246-30.88 73.41-45.389 11.994-9.535 41.944-33.57 70.563-56.568 5.122-4.116 12.601-3.346 16.778 1.727l15.258 18.526z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegEnvelope(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm0 48v40.805c-22.422 18.259-58.168 46.651-134.587 106.49-16.841 13.247-50.201 45.072-73.413 44.701-23.208.375-56.579-31.459-73.413-44.701C106.18 199.465 70.425 171.067 48 152.805V112h416zM48 400V214.398c22.914 18.251 55.409 43.862 104.938 82.646 21.857 17.205 60.134 55.186 103.062 54.955 42.717.231 80.509-37.199 103.053-54.947 49.528-38.783 82.032-64.401 104.947-82.653V400H48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegEyeSlash(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M634 471L36 3.51A16 16 0 0 0 13.51 6l-10 12.49A16 16 0 0 0 6 41l598 467.49a16 16 0 0 0 22.49-2.49l10-12.49A16 16 0 0 0 634 471zM296.79 146.47l134.79 105.38C429.36 191.91 380.48 144 320 144a112.26 112.26 0 0 0-23.21 2.47zm46.42 219.07L208.42 260.16C210.65 320.09 259.53 368 320 368a113 113 0 0 0 23.21-2.46zM320 112c98.65 0 189.09 55 237.93 144a285.53 285.53 0 0 1-44 60.2l37.74 29.5a333.7 333.7 0 0 0 52.9-75.11 32.35 32.35 0 0 0 0-29.19C550.29 135.59 442.93 64 320 64c-36.7 0-71.71 7-104.63 18.81l46.41 36.29c18.94-4.3 38.34-7.1 58.22-7.1zm0 288c-98.65 0-189.08-55-237.93-144a285.47 285.47 0 0 1 44.05-60.19l-37.74-29.5a333.6 333.6 0 0 0-52.89 75.1 32.35 32.35 0 0 0 0 29.19C89.72 376.41 197.08 448 320 448c36.7 0 71.71-7.05 104.63-18.81l-46.41-36.28C359.28 397.2 339.89 400 320 400z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegEye(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 144a110.94 110.94 0 0 0-31.24 5 55.4 55.4 0 0 1 7.24 27 56 56 0 0 1-56 56 55.4 55.4 0 0 1-27-7.24A111.71 111.71 0 1 0 288 144zm284.52 97.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400c-98.65 0-189.09-55-237.93-144C98.91 167 189.34 112 288 112s189.09 55 237.93 144C477.1 345 386.66 400 288 400z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFileAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 248v28c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-28c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm-12 72H108c-6.6 0-12 5.4-12 12v28c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12v-28c0-6.6-5.4-12-12-12zm108-188.1V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48C0 21.5 21.5 0 48 0h204.1C264.8 0 277 5.1 286 14.1L369.9 98c9 8.9 14.1 21.2 14.1 33.9zm-128-80V128h76.1L256 51.9zM336 464V176H232c-13.3 0-24-10.7-24-24V48H48v416h288z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFileArchive(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128.3 160v32h32v-32zm64-96h-32v32h32zm-64 32v32h32V96zm64 32h-32v32h32zm177.6-30.1L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM256 51.9l76.1 76.1H256zM336 464H48V48h79.7v16h32V48H208v104c0 13.3 10.7 24 24 24h104zM194.2 265.7c-1.1-5.6-6-9.7-11.8-9.7h-22.1v-32h-32v32l-19.7 97.1C102 385.6 126.8 416 160 416c33.1 0 57.9-30.2 51.5-62.6zm-33.9 124.4c-17.9 0-32.4-12.1-32.4-27s14.5-27 32.4-27 32.4 12.1 32.4 27-14.5 27-32.4 27zm32-198.1h-32v32h32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFileAudio(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M369.941 97.941l-83.882-83.882A48 48 0 0 0 252.118 0H48C21.49 0 0 21.49 0 48v416c0 26.51 21.49 48 48 48h288c26.51 0 48-21.49 48-48V131.882a48 48 0 0 0-14.059-33.941zM332.118 128H256V51.882L332.118 128zM48 464V48h160v104c0 13.255 10.745 24 24 24h104v288H48zm144-76.024c0 10.691-12.926 16.045-20.485 8.485L136 360.486h-28c-6.627 0-12-5.373-12-12v-56c0-6.627 5.373-12 12-12h28l35.515-36.947c7.56-7.56 20.485-2.206 20.485 8.485v135.952zm41.201-47.13c9.051-9.297 9.06-24.133.001-33.439-22.149-22.752 12.235-56.246 34.395-33.481 27.198 27.94 27.212 72.444.001 100.401-21.793 22.386-56.947-10.315-34.397-33.481z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFileCode(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M149.9 349.1l-.2-.2-32.8-28.9 32.8-28.9c3.6-3.2 4-8.8.8-12.4l-.2-.2-17.4-18.6c-3.4-3.6-9-3.7-12.4-.4l-57.7 54.1c-3.7 3.5-3.7 9.4 0 12.8l57.7 54.1c1.6 1.5 3.8 2.4 6 2.4 2.4 0 4.8-1 6.4-2.8l17.4-18.6c3.3-3.5 3.1-9.1-.4-12.4zm220-251.2L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM256 51.9l76.1 76.1H256zM336 464H48V48h160v104c0 13.3 10.7 24 24 24h104zM209.6 214c-4.7-1.4-9.5 1.3-10.9 6L144 408.1c-1.4 4.7 1.3 9.6 6 10.9l24.4 7.1c4.7 1.4 9.6-1.4 10.9-6L240 231.9c1.4-4.7-1.3-9.6-6-10.9zm24.5 76.9l.2.2 32.8 28.9-32.8 28.9c-3.6 3.2-4 8.8-.8 12.4l.2.2 17.4 18.6c3.3 3.5 8.9 3.7 12.4.4l57.7-54.1c3.7-3.5 3.7-9.4 0-12.8l-57.7-54.1c-3.5-3.3-9.1-3.2-12.4.4l-17.4 18.6c-3.3 3.5-3.1 9.1.4 12.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFileExcel(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm212-240h-28.8c-4.4 0-8.4 2.4-10.5 6.3-18 33.1-22.2 42.4-28.6 57.7-13.9-29.1-6.9-17.3-28.6-57.7-2.1-3.9-6.2-6.3-10.6-6.3H124c-9.3 0-15 10-10.4 18l46.3 78-46.3 78c-4.7 8 1.1 18 10.4 18h28.9c4.4 0 8.4-2.4 10.5-6.3 21.7-40 23-45 28.6-57.7 14.9 30.2 5.9 15.9 28.6 57.7 2.1 3.9 6.2 6.3 10.6 6.3H260c9.3 0 15-10 10.4-18L224 320c.7-1.1 30.3-50.5 46.3-78 4.7-8-1.1-18-10.3-18z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFileImage(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm32-48h224V288l-23.5-23.5c-4.7-4.7-12.3-4.7-17 0L176 352l-39.5-39.5c-4.7-4.7-12.3-4.7-17 0L80 352v64zm48-240c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFilePdf(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm250.2-143.7c-12.2-12-47-8.7-64.4-6.5-17.2-10.5-28.7-25-36.8-46.3 3.9-16.1 10.1-40.6 5.4-56-4.2-26.2-37.8-23.6-42.6-5.9-4.4 16.1-.4 38.5 7 67.1-10 23.9-24.9 56-35.4 74.4-20 10.3-47 26.2-51 46.2-3.3 15.8 26 55.2 76.1-31.2 22.4-7.4 46.8-16.5 68.4-20.1 18.9 10.2 41 17 55.8 17 25.5 0 28-28.2 17.5-38.7zm-198.1 77.8c5.1-13.7 24.5-29.5 30.4-35-19 30.3-30.4 35.7-30.4 35zm81.6-190.6c7.4 0 6.7 32.1 1.8 40.8-4.4-13.9-4.3-40.8-1.8-40.8zm-24.4 136.6c9.7-16.9 18-37 24.7-54.7 8.3 15.1 18.9 27.2 30.1 35.5-20.8 4.3-38.9 13.1-54.8 19.2zm131.6-5s-5 6-37.3-7.8c35.1-2.6 40.9 5.4 37.3 7.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFilePowerpoint(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm72-60V236c0-6.6 5.4-12 12-12h69.2c36.7 0 62.8 27 62.8 66.3 0 74.3-68.7 66.5-95.5 66.5V404c0 6.6-5.4 12-12 12H132c-6.6 0-12-5.4-12-12zm48.5-87.4h23c7.9 0 13.9-2.4 18.1-7.2 8.5-9.8 8.4-28.5.1-37.8-4.1-4.6-9.9-7-17.4-7h-23.9v52z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFileVideo(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M369.941 97.941l-83.882-83.882A48 48 0 0 0 252.118 0H48C21.49 0 0 21.49 0 48v416c0 26.51 21.49 48 48 48h288c26.51 0 48-21.49 48-48V131.882a48 48 0 0 0-14.059-33.941zM332.118 128H256V51.882L332.118 128zM48 464V48h160v104c0 13.255 10.745 24 24 24h104v288H48zm228.687-211.303L224 305.374V268c0-11.046-8.954-20-20-20H100c-11.046 0-20 8.954-20 20v104c0 11.046 8.954 20 20 20h104c11.046 0 20-8.954 20-20v-37.374l52.687 52.674C286.704 397.318 304 390.28 304 375.986V264.011c0-14.311-17.309-21.319-27.313-11.314z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFileWord(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm220.1-208c-5.7 0-10.6 4-11.7 9.5-20.6 97.7-20.4 95.4-21 103.5-.2-1.2-.4-2.6-.7-4.3-.8-5.1.3.2-23.6-99.5-1.3-5.4-6.1-9.2-11.7-9.2h-13.3c-5.5 0-10.3 3.8-11.7 9.1-24.4 99-24 96.2-24.8 103.7-.1-1.1-.2-2.5-.5-4.2-.7-5.2-14.1-73.3-19.1-99-1.1-5.6-6-9.7-11.8-9.7h-16.8c-7.8 0-13.5 7.3-11.7 14.8 8 32.6 26.7 109.5 33.2 136 1.3 5.4 6.1 9.1 11.7 9.1h25.2c5.5 0 10.3-3.7 11.6-9.1l17.9-71.4c1.5-6.2 2.5-12 3-17.3l2.9 17.3c.1.4 12.6 50.5 17.9 71.4 1.3 5.3 6.1 9.1 11.6 9.1h24.7c5.5 0 10.3-3.7 11.6-9.1 20.8-81.9 30.2-119 34.5-136 1.9-7.6-3.8-14.9-11.6-14.9h-15.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFile(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFlag(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336.174 80c-49.132 0-93.305-32-161.913-32-31.301 0-58.303 6.482-80.721 15.168a48.04 48.04 0 0 0 2.142-20.727C93.067 19.575 74.167 1.594 51.201.104 23.242-1.71 0 20.431 0 48c0 17.764 9.657 33.262 24 41.562V496c0 8.837 7.163 16 16 16h16c8.837 0 16-7.163 16-16v-83.443C109.869 395.28 143.259 384 199.826 384c49.132 0 93.305 32 161.913 32 58.479 0 101.972-22.617 128.548-39.981C503.846 367.161 512 352.051 512 335.855V95.937c0-34.459-35.264-57.768-66.904-44.117C409.193 67.309 371.641 80 336.174 80zM464 336c-21.783 15.412-60.824 32-102.261 32-59.945 0-102.002-32-161.913-32-43.361 0-96.379 9.403-127.826 24V128c21.784-15.412 60.824-32 102.261-32 59.945 0 102.002 32 161.913 32 43.271 0 96.32-17.366 127.826-32v240z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFlushed(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm96-312c-44.2 0-80 35.8-80 80s35.8 80 80 80 80-35.8 80-80-35.8-80-80-80zm0 128c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm0-72c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm-112 24c0-44.2-35.8-80-80-80s-80 35.8-80 80 35.8 80 80 80 80-35.8 80-80zm-80 48c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm0-72c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm160 144H184c-13.2 0-24 10.8-24 24s10.8 24 24 24h128c13.2 0 24-10.8 24-24s-10.8-24-24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFolderOpen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M527.9 224H480v-48c0-26.5-21.5-48-48-48H272l-64-64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h400c16.5 0 31.9-8.5 40.7-22.6l79.9-128c20-31.9-3-73.4-40.7-73.4zM48 118c0-3.3 2.7-6 6-6h134.1l64 64H426c3.3 0 6 2.7 6 6v42H152c-16.8 0-32.4 8.8-41.1 23.2L48 351.4zm400 282H72l77.2-128H528z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFolder(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 128H272l-54.63-54.63c-6-6-14.14-9.37-22.63-9.37H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48zm0 272H48V112h140.12l54.63 54.63c6 6 14.14 9.37 22.63 9.37H464v224z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFontAwesomeLogoFull(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 3992 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M454.6 0H57.4C25.9 0 0 25.9 0 57.4v397.3C0 486.1 25.9 512 57.4 512h397.3c31.4 0 57.4-25.9 57.4-57.4V57.4C512 25.9 486.1 0 454.6 0zm-58.9 324.9c0 4.8-4.1 6.9-8.9 8.9-19.2 8.1-39.7 15.7-61.5 15.7-40.5 0-68.7-44.8-163.2 2.5v51.8c0 30.3-45.7 30.2-45.7 0v-250c-9-7-15-17.9-15-30.3 0-21 17.1-38.2 38.2-38.2 21 0 38.2 17.1 38.2 38.2 0 12.2-5.8 23.2-14.9 30.2v21c37.1-12 65.5-34.4 146.1-3.4 26.6 11.4 68.7-15.7 76.5-15.7 5.5 0 10.3 4.1 10.3 8.9v160.4zm432.9-174.2h-137v70.1H825c39.8 0 40.4 62.2 0 62.2H691.6v105.6c0 45.5-70.7 46.4-70.7 0V128.3c0-22 18-39.8 39.8-39.8h167.8c39.6 0 40.5 62.2.1 62.2zm191.1 23.4c-169.3 0-169.1 252.4 0 252.4 169.9 0 169.9-252.4 0-252.4zm0 196.1c-81.6 0-82.1-139.8 0-139.8 82.5 0 82.4 139.8 0 139.8zm372.4 53.4c-17.5 0-31.4-13.9-31.4-31.4v-117c0-62.4-72.6-52.5-99.1-16.4v133.4c0 41.5-63.3 41.8-63.3 0V208c0-40 63.1-41.6 63.1 0v3.4c43.3-51.6 162.4-60.4 162.4 39.3v141.5c.3 30.4-31.5 31.4-31.7 31.4zm179.7 2.9c-44.3 0-68.3-22.9-68.3-65.8V235.2H1488c-35.6 0-36.7-55.3 0-55.3h15.5v-37.3c0-41.3 63.8-42.1 63.8 0v37.5h24.9c35.4 0 35.7 55.3 0 55.3h-24.9v108.5c0 29.6 26.1 26.3 27.4 26.3 31.4 0 52.6 56.3-22.9 56.3zM1992 123c-19.5-50.2-95.5-50-114.5 0-107.3 275.7-99.5 252.7-99.5 262.8 0 42.8 58.3 51.2 72.1 14.4l13.5-35.9H2006l13 35.9c14.2 37.7 72.1 27.2 72.1-14.4 0-10.1 5.3 6.8-99.1-262.8zm-108.9 179.1l51.7-142.9 51.8 142.9h-103.5zm591.3-85.6l-53.7 176.3c-12.4 41.2-72 41-84 0l-42.3-135.9-42.3 135.9c-12.4 40.9-72 41.2-84.5 0l-54.2-176.3c-12.5-39.4 49.8-56.1 60.2-16.9L2213 342l45.3-139.5c10.9-32.7 59.6-34.7 71.2 0l45.3 139.5 39.3-142.4c10.3-38.3 72.6-23.8 60.3 16.9zm275.4 75.1c0-42.4-33.9-117.5-119.5-117.5-73.2 0-124.4 56.3-124.4 126 0 77.2 55.3 126.4 128.5 126.4 31.7 0 93-11.5 93-39.8 0-18.3-21.1-31.5-39.3-22.4-49.4 26.2-109 8.4-115.9-43.8h148.3c16.3 0 29.3-13.4 29.3-28.9zM2571 277.7c9.5-73.4 113.9-68.6 118.6 0H2571zm316.7 148.8c-31.4 0-81.6-10.5-96.6-31.9-12.4-17 2.5-39.8 21.8-39.8 16.3 0 36.8 22.9 77.7 22.9 27.4 0 40.4-11 40.4-25.8 0-39.8-142.9-7.4-142.9-102 0-40.4 35.3-75.7 98.6-75.7 31.4 0 74.1 9.9 87.6 29.4 10.8 14.8-1.4 36.2-20.9 36.2-15.1 0-26.7-17.3-66.2-17.3-22.9 0-37.8 10.5-37.8 23.8 0 35.9 142.4 6 142.4 103.1-.1 43.7-37.4 77.1-104.1 77.1zm266.8-252.4c-169.3 0-169.1 252.4 0 252.4 170.1 0 169.6-252.4 0-252.4zm0 196.1c-81.8 0-82-139.8 0-139.8 82.5 0 82.4 139.8 0 139.8zm476.9 22V268.7c0-53.8-61.4-45.8-85.7-10.5v134c0 41.3-63.8 42.1-63.8 0V268.7c0-52.1-59.5-47.4-85.7-10.1v133.6c0 41.5-63.3 41.8-63.3 0V208c0-40 63.1-41.6 63.1 0v3.4c9.9-14.4 41.8-37.3 78.6-37.3 35.3 0 57.7 16.4 66.7 43.8 13.9-21.8 45.8-43.8 82.6-43.8 44.3 0 70.7 23.4 70.7 72.7v145.3c.5 17.3-13.5 31.4-31.9 31.4 3.5.1-31.3 1.1-31.3-31.3zM3992 291.6c0-42.4-32.4-117.5-117.9-117.5-73.2 0-127.5 56.3-127.5 126 0 77.2 58.3 126.4 131.6 126.4 31.7 0 91.5-11.5 91.5-39.8 0-18.3-21.1-31.5-39.3-22.4-49.4 26.2-110.5 8.4-117.5-43.8h149.8c16.3 0 29.1-13.4 29.3-28.9zm-180.5-13.9c9.7-74.4 115.9-68.3 120.1 0h-120.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFrownOpen(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-48-248c0-17.7-14.3-32-32-32s-32 14.3-32 32 14.3 32 32 32 32-14.3 32-32zm128-32c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm-80 112c-35.6 0-88.8 21.3-95.8 61.2-2 11.8 9 21.5 20.5 18.1 31.2-9.6 59.4-15.3 75.3-15.3s44.1 5.7 75.3 15.3c11.4 3.5 22.5-6.3 20.5-18.1-7-39.9-60.2-61.2-95.8-61.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFrown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160-64c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm-80 128c-40.2 0-78 17.7-103.8 48.6-8.5 10.2-7.1 25.3 3.1 33.8 10.2 8.4 25.3 7.1 33.8-3.1 16.6-19.9 41-31.4 66.9-31.4s50.3 11.4 66.9 31.4c8.1 9.7 23.1 11.9 33.8 3.1 10.2-8.5 11.5-23.6 3.1-33.8C326 321.7 288.2 304 248 304z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegFutbol(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M483.8 179.4C449.8 74.6 352.6 8 248.1 8c-25.4 0-51.2 3.9-76.7 12.2C41.2 62.5-30.1 202.4 12.2 332.6 46.2 437.4 143.4 504 247.9 504c25.4 0 51.2-3.9 76.7-12.2 130.2-42.3 201.5-182.2 159.2-312.4zm-74.5 193.7l-52.2 6.4-43.7-60.9 24.4-75.2 71.1-22.1 38.9 36.4c-.2 30.7-7.4 61.1-21.7 89.2-4.7 9.3-10.7 17.8-16.8 26.2zm0-235.4l-10.4 53.1-70.7 22-64.2-46.5V92.5l47.4-26.2c39.2 13 73.4 38 97.9 71.4zM184.9 66.4L232 92.5v73.8l-64.2 46.5-70.6-22-10.1-52.5c24.3-33.4 57.9-58.6 97.8-71.9zM139 379.5L85.9 373c-14.4-20.1-37.3-59.6-37.8-115.3l39-36.4 71.1 22.2 24.3 74.3-43.5 61.7zm48.2 67l-22.4-48.1 43.6-61.7H287l44.3 61.7-22.4 48.1c-6.2 1.8-57.6 20.4-121.7 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegGem(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 0H112c-4 0-7.8 2-10 5.4L2 152.6c-2.9 4.4-2.6 10.2.7 14.2l276 340.8c4.8 5.9 13.8 5.9 18.6 0l276-340.8c3.3-4.1 3.6-9.8.7-14.2L474.1 5.4C471.8 2 468.1 0 464 0zm-19.3 48l63.3 96h-68.4l-51.7-96h56.8zm-202.1 0h90.7l51.7 96H191l51.6-96zm-111.3 0h56.8l-51.7 96H68l63.3-96zm-43 144h51.4L208 352 88.3 192zm102.9 0h193.6L288 435.3 191.2 192zM368 352l68.2-160h51.4L368 352z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegGrimace(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm16 16H152c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48h192c26.5 0 48-21.5 48-48v-32c0-26.5-21.5-48-48-48zm-168 96h-24c-8.8 0-16-7.2-16-16v-8h40v24zm0-40h-40v-8c0-8.8 7.2-16 16-16h24v24zm64 40h-48v-24h48v24zm0-40h-48v-24h48v24zm64 40h-48v-24h48v24zm0-40h-48v-24h48v24zm56 24c0 8.8-7.2 16-16 16h-24v-24h40v8zm0-24h-40v-24h24c8.8 0 16 7.2 16 16v8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegGrinAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M200.3 248c12.4-18.7 15.1-37.3 15.7-56-.5-18.7-3.3-37.3-15.7-56-8-12-25.1-11.4-32.7 0-12.4 18.7-15.1 37.3-15.7 56 .5 18.7 3.3 37.3 15.7 56 8.1 12 25.2 11.4 32.7 0zm128 0c12.4-18.7 15.1-37.3 15.7-56-.5-18.7-3.3-37.3-15.7-56-8-12-25.1-11.4-32.7 0-12.4 18.7-15.1 37.3-15.7 56 .5 18.7 3.3 37.3 15.7 56 8.1 12 25.2 11.4 32.7 0zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm105.6-151.4c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.3-17.7 15.3 7.9 47.2 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegGrinBeamSweat(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M440 160c29.5 0 53.3-26.3 53.3-58.7 0-25-31.7-75.5-46.2-97.3-3.6-5.3-10.7-5.3-14.2 0-14.5 21.8-46.2 72.3-46.2 97.3 0 32.4 23.8 58.7 53.3 58.7zM248 400c51.9 0 115.3-32.9 123.3-80 1.7-9.9-7.7-18.5-17.7-15.3-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.8-3.1-19.4 5.3-17.7 15.3 8 47.1 71.4 80 123.3 80zm130.3-168.3c3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3 3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.6 6.2 4.6 9.3 3.7zm105.3-52.9c-24.6 15.7-46 12.9-46.4 12.9 6.9 20.2 10.8 41.8 10.8 64.3 0 110.3-89.7 200-200 200S48 366.3 48 256 137.7 56 248 56c39.8 0 76.8 11.8 108 31.9 1.7-9.5 6.3-24.1 17.2-45.7C336.4 20.6 293.7 8 248 8 111 8 0 119 0 256s111 248 248 248 248-111 248-248c0-27-4.4-52.9-12.4-77.2zM168 189.4c12.3 0 23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3 3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.8 19.2-21.6 31.5-21.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegGrinBeam(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm105.6-151.4c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.8-3.1-19.4 5.3-17.7 15.3 7.9 47.1 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3zm-235.9-72.9c3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3zm160 0c3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegGrinHearts(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M353.6 304.6c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.8-3.1-19.4 5.3-17.7 15.3 7.9 47.2 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3zm-152.8-48.9c4.5 1.2 9.2-1.5 10.5-6l19.4-69.9c5.6-20.3-7.4-41.1-28.8-44.5-18.6-3-36.4 9.8-41.5 27.9l-2 7.1-7.1-1.9c-18.2-4.7-38.2 4.3-44.9 22-7.7 20.2 3.8 41.9 24.2 47.2l70.2 18.1zm188.8-65.3c-6.7-17.6-26.7-26.7-44.9-22l-7.1 1.9-2-7.1c-5-18.1-22.8-30.9-41.5-27.9-21.4 3.4-34.4 24.2-28.8 44.5l19.4 69.9c1.2 4.5 5.9 7.2 10.5 6l70.2-18.2c20.4-5.3 31.9-26.9 24.2-47.1zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegGrinSquintTears(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M117.1 384.1c-25.8 3.7-84 13.7-100.9 30.6-21.9 21.9-21.5 57.9.9 80.3s58.3 22.8 80.3.9C114.3 479 124.3 420.8 128 395c.8-6.4-4.6-11.8-10.9-10.9zm-41.2-41.7C40.3 268 53 176.1 114.6 114.6 152.4 76.8 202.6 56 256 56c36.2 0 70.8 9.8 101.2 27.7 3.8-20.3 8-36.1 12-48.3C333.8 17.2 294.9 8 256 8 192.5 8 129.1 32.2 80.6 80.6c-74.1 74.1-91.3 183.4-52 274 12.2-4.1 27.7-8.3 47.3-12.2zm352.3-187.6c45 76.6 34.9 176.9-30.8 242.6-37.8 37.8-88 58.6-141.4 58.6-30.5 0-59.8-7-86.4-19.8-3.9 19.5-8 35-12.2 47.2 31.4 13.6 65 20.6 98.7 20.6 63.5 0 126.9-24.2 175.4-72.6 78.1-78.1 93.1-195.4 45.2-288.6-12.3 4-28.2 8.1-48.5 12zm-33.3-26.9c25.8-3.7 84-13.7 100.9-30.6 21.9-21.9 21.5-57.9-.9-80.3s-58.3-22.8-80.3-.9C397.7 33 387.7 91.2 384 117c-.8 6.4 4.6 11.8 10.9 10.9zm-187 108.3c-3-3-7.2-4.2-11.4-3.2L106 255.7c-5.7 1.4-9.5 6.7-9.1 12.6.5 5.8 5.1 10.5 10.9 11l52.3 4.8 4.8 52.3c.5 5.8 5.2 10.4 11 10.9h.9c5.5 0 10.3-3.7 11.7-9.1l22.6-90.5c1-4.2-.2-8.5-3.2-11.5zm39.7-25.1l90.5-22.6c5.7-1.4 9.5-6.7 9.1-12.6-.5-5.8-5.1-10.5-10.9-11l-52.3-4.8-4.8-52.3c-.5-5.8-5.2-10.4-11-10.9-5.6-.1-11.2 3.4-12.6 9.1L233 196.5c-1 4.1.2 8.4 3.2 11.4 5 5 11.3 3.2 11.4 3.2zm52 88.5c-29.1 29.1-59.7 52.9-83.9 65.4-9.2 4.8-10 17.5-1.7 23.4 38.9 27.7 107 6.2 143.7-30.6S416 253 388.3 214.1c-5.8-8.2-18.5-7.6-23.4 1.7-12.3 24.2-36.2 54.7-65.3 83.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegGrinSquint(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm105.6-151.4c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.4-17.7 15.3 7.9 47.1 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3zm-234.7-40.8c3.6 4.2 9.9 5.7 15.3 2.5l80-48c3.6-2.2 5.8-6.1 5.8-10.3s-2.2-8.1-5.8-10.3l-80-48c-5.1-3-11.4-1.9-15.3 2.5-3.8 4.5-3.8 11-.1 15.5l33.6 40.3-33.6 40.3c-3.8 4.5-3.7 11.1.1 15.5zm242.9 2.5c5.4 3.2 11.7 1.7 15.3-2.5 3.8-4.5 3.8-11 .1-15.5L343.6 208l33.6-40.3c3.8-4.5 3.7-11-.1-15.5-3.8-4.4-10.2-5.4-15.3-2.5l-80 48c-3.6 2.2-5.8 6.1-5.8 10.3s2.2 8.1 5.8 10.3l80 48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegGrinStars(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm105.6-151.4c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.8-3.1-19.4 5.3-17.7 15.3 7.9 47.2 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3zm-227.9-57.5c-1 6.2 5.4 11 11 7.9l31.3-16.3 31.3 16.3c5.6 3.1 12-1.7 11-7.9l-6-34.9 25.4-24.6c4.5-4.5 1.9-12.2-4.3-13.2l-34.9-5-15.5-31.6c-2.9-5.8-11-5.8-13.9 0l-15.5 31.6-34.9 5c-6.2.9-8.9 8.6-4.3 13.2l25.4 24.6-6.1 34.9zm259.7-72.7l-34.9-5-15.5-31.6c-2.9-5.8-11-5.8-13.9 0l-15.5 31.6-34.9 5c-6.2.9-8.9 8.6-4.3 13.2l25.4 24.6-6 34.9c-1 6.2 5.4 11 11 7.9l31.3-16.3 31.3 16.3c5.6 3.1 12-1.7 11-7.9l-6-34.9 25.4-24.6c4.5-4.6 1.8-12.2-4.4-13.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegGrinTears(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M117.1 256.1c-25.8 3.7-84 13.7-100.9 30.6-21.9 21.9-21.5 57.9.9 80.3s58.3 22.8 80.3.9C114.3 351 124.3 292.8 128 267c.8-6.4-4.6-11.8-10.9-10.9zm506.7 30.6c-16.9-16.9-75.1-26.9-100.9-30.6-6.3-.9-11.7 4.5-10.8 10.8 3.7 25.8 13.7 84 30.6 100.9 21.9 21.9 57.9 21.5 80.3-.9 22.3-22.3 22.7-58.3.8-80.2zm-126.6 61.7C463.8 412.3 396.9 456 320 456c-76.9 0-143.8-43.7-177.2-107.6-12.5 37.4-25.2 43.9-28.3 46.5C159.1 460.7 234.5 504 320 504s160.9-43.3 205.5-109.1c-3.2-2.7-15.9-9.2-28.3-46.5zM122.7 224.5C137.9 129.2 220.5 56 320 56c99.5 0 182.1 73.2 197.3 168.5 2.1-.2 5.2-2.4 49.5 7C554.4 106 448.7 8 320 8S85.6 106 73.2 231.4c44.5-9.4 47.1-7.2 49.5-6.9zM320 400c51.9 0 115.3-32.9 123.3-80 1.7-9.9-7.7-18.5-17.7-15.3-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.8-3.1-19.4 5.3-17.7 15.3 8 47.1 71.4 80 123.3 80zm130.3-168.3c3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3 3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.6 6.2 4.6 9.3 3.7zM240 189.4c12.3 0 23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3 3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.8 19.2-21.6 31.5-21.6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegGrinTongueSquint(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm64 400c0 35.6-29.1 64.5-64.9 64-35.1-.5-63.1-29.8-63.1-65v-42.8l17.7-8.8c15-7.5 31.5 1.7 34.9 16.5l2.8 12.1c2.1 9.2 15.2 9.2 17.3 0l2.8-12.1c3.4-14.8 19.8-24.1 34.9-16.5l17.7 8.8V408zm28.2 25.3c2.2-8.1 3.8-16.5 3.8-25.3v-43.5c14.2-12.4 24.4-27.5 27.3-44.5 1.7-9.9-7.7-18.5-17.7-15.3-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.3-17.7 15.3 2.9 17 13.1 32.1 27.3 44.5V408c0 8.8 1.6 17.2 3.8 25.3C91.8 399.9 48 333 48 256c0-110.3 89.7-200 200-200s200 89.7 200 200c0 77-43.8 143.9-107.8 177.3zm36.9-281.1c-3.8-4.4-10.3-5.5-15.3-2.5l-80 48c-3.6 2.2-5.8 6.1-5.8 10.3s2.2 8.1 5.8 10.3l80 48c5.4 3.2 11.7 1.7 15.3-2.5 3.8-4.5 3.8-11 .1-15.5L343.6 208l33.6-40.3c3.8-4.5 3.7-11.1-.1-15.5zm-162.9 45.5l-80-48c-5-3-11.4-2-15.3 2.5-3.8 4.5-3.8 11-.1 15.5l33.6 40.3-33.6 40.3c-3.8 4.5-3.7 11 .1 15.5 3.6 4.2 9.9 5.7 15.3 2.5l80-48c3.6-2.2 5.8-6.1 5.8-10.3s-2.2-8.1-5.8-10.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegGrinTongueWink(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M152 180c-25.7 0-55.9 16.9-59.8 42.1-.8 5 1.7 10 6.1 12.4 4.4 2.4 9.9 1.8 13.7-1.6l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c2.5 2.2 8 4.7 13.7 1.6 4.4-2.4 6.9-7.4 6.1-12.4-3.9-25.2-34.1-42.1-59.8-42.1zm176-52c-44.2 0-80 35.8-80 80s35.8 80 80 80 80-35.8 80-80-35.8-80-80-80zm0 128c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm0-72c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm64 400c0 35.6-29.1 64.5-64.9 64-35.1-.5-63.1-29.8-63.1-65v-42.8l17.7-8.8c15-7.5 31.5 1.7 34.9 16.5l2.8 12.1c2.1 9.2 15.2 9.2 17.3 0l2.8-12.1c3.4-14.8 19.8-24.1 34.9-16.5l17.7 8.8V408zm28.2 25.3c2.2-8.1 3.8-16.5 3.8-25.3v-43.5c14.2-12.4 24.4-27.5 27.3-44.5 1.7-9.9-7.7-18.5-17.7-15.3-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.3-17.7 15.3 2.9 17 13.1 32.1 27.3 44.5V408c0 8.8 1.6 17.2 3.8 25.3C91.8 399.9 48 333 48 256c0-110.3 89.7-200 200-200s200 89.7 200 200c0 77-43.8 143.9-107.8 177.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegGrinTongue(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm64 400c0 35.6-29.1 64.5-64.9 64-35.1-.5-63.1-29.8-63.1-65v-42.8l17.7-8.8c15-7.5 31.5 1.7 34.9 16.5l2.8 12.1c2.1 9.2 15.2 9.2 17.3 0l2.8-12.1c3.4-14.8 19.8-24.1 34.9-16.5l17.7 8.8V408zm28.2 25.3c2.2-8.1 3.8-16.5 3.8-25.3v-43.5c14.2-12.4 24.4-27.5 27.3-44.5 1.7-9.9-7.7-18.5-17.7-15.3-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.3-17.7 15.3 2.9 17 13.1 32.1 27.3 44.5V408c0 8.8 1.6 17.2 3.8 25.3C91.8 399.9 48 333 48 256c0-110.3 89.7-200 200-200s200 89.7 200 200c0 77-43.8 143.9-107.8 177.3zM168 176c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm160 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegGrinWink(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M328 180c-25.69 0-55.88 16.92-59.86 42.12-1.75 11.22 11.5 18.24 19.83 10.84l9.55-8.48c14.81-13.19 46.16-13.19 60.97 0l9.55 8.48c8.48 7.43 21.56.25 19.83-10.84C383.88 196.92 353.69 180 328 180zm-160 60c17.67 0 32-14.33 32-32s-14.33-32-32-32-32 14.33-32 32 14.33 32 32 32zm185.55 64.64c-25.93 8.3-64.4 13.06-105.55 13.06s-79.62-4.75-105.55-13.06c-9.94-3.13-19.4 5.37-17.71 15.34C132.67 367.13 196.06 400 248 400s115.33-32.87 123.26-80.02c1.68-9.89-7.67-18.48-17.71-15.34zM248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 448c-110.28 0-200-89.72-200-200S137.72 56 248 56s200 89.72 200 200-89.72 200-200 200z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegGrin(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm105.6-151.4c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.4-17.7 15.3 7.9 47.1 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3zM168 240c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegHandLizard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M556.686 290.542L410.328 64.829C397.001 44.272 374.417 32 349.917 32H56C25.121 32 0 57.122 0 88v8c0 44.112 35.888 80 80 80h196.042l-18.333 48H144c-48.523 0-88 39.477-88 88 0 30.879 25.121 56 56 56h131.552c2.987 0 5.914.549 8.697 1.631L352 408.418V480h224V355.829c0-23.225-6.679-45.801-19.314-65.287zM528 432H400v-23.582c0-19.948-12.014-37.508-30.604-44.736l-99.751-38.788A71.733 71.733 0 0 0 243.552 320H112c-4.411 0-8-3.589-8-8 0-22.056 17.944-40 40-40h113.709c19.767 0 37.786-12.407 44.84-30.873l24.552-64.281c8.996-23.553-8.428-48.846-33.63-48.846H80c-17.645 0-32-14.355-32-32v-8c0-4.411 3.589-8 8-8h293.917c8.166 0 15.693 4.09 20.137 10.942l146.358 225.715A71.84 71.84 0 0 1 528 355.829V432z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegHandPaper(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M372.57 112.641v-10.825c0-43.612-40.52-76.691-83.039-65.546-25.629-49.5-94.09-47.45-117.982.747C130.269 26.456 89.144 57.945 89.144 102v126.13c-19.953-7.427-43.308-5.068-62.083 8.871-29.355 21.796-35.794 63.333-14.55 93.153L132.48 498.569a32 32 0 0 0 26.062 13.432h222.897c14.904 0 27.835-10.289 31.182-24.813l30.184-130.958A203.637 203.637 0 0 0 448 310.564V179c0-40.62-35.523-71.992-75.43-66.359zm27.427 197.922c0 11.731-1.334 23.469-3.965 34.886L368.707 464h-201.92L51.591 302.303c-14.439-20.27 15.023-42.776 29.394-22.605l27.128 38.079c8.995 12.626 29.031 6.287 29.031-9.283V102c0-25.645 36.571-24.81 36.571.691V256c0 8.837 7.163 16 16 16h6.856c8.837 0 16-7.163 16-16V67c0-25.663 36.571-24.81 36.571.691V256c0 8.837 7.163 16 16 16h6.856c8.837 0 16-7.163 16-16V101.125c0-25.672 36.57-24.81 36.57.691V256c0 8.837 7.163 16 16 16h6.857c8.837 0 16-7.163 16-16v-76.309c0-26.242 36.57-25.64 36.57-.691v131.563z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegHandPeace(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M362.146 191.976c-13.71-21.649-38.761-34.016-65.006-30.341V74c0-40.804-32.811-74-73.141-74-40.33 0-73.14 33.196-73.14 74L160 168l-18.679-78.85C126.578 50.843 83.85 32.11 46.209 47.208 8.735 62.238-9.571 104.963 5.008 142.85l55.757 144.927c-30.557 24.956-43.994 57.809-24.733 92.218l54.853 97.999C102.625 498.97 124.73 512 148.575 512h205.702c30.744 0 57.558-21.44 64.555-51.797l27.427-118.999a67.801 67.801 0 0 0 1.729-15.203L448 256c0-44.956-43.263-77.343-85.854-64.024zM399.987 326c0 1.488-.169 2.977-.502 4.423l-27.427 119.001c-1.978 8.582-9.29 14.576-17.782 14.576H148.575c-6.486 0-12.542-3.621-15.805-9.449l-54.854-98c-4.557-8.141-2.619-18.668 4.508-24.488l26.647-21.764a16 16 0 0 0 4.812-18.139l-64.09-166.549C37.226 92.956 84.37 74.837 96.51 106.389l59.784 155.357A16 16 0 0 0 171.227 272h11.632c8.837 0 16-7.163 16-16V74c0-34.375 50.281-34.43 50.281 0v182c0 8.837 7.163 16 16 16h6.856c8.837 0 16-7.163 16-16v-28c0-25.122 36.567-25.159 36.567 0v28c0 8.837 7.163 16 16 16h6.856c8.837 0 16-7.163 16-16 0-25.12 36.567-25.16 36.567 0v70z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegHandPointDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M188.8 512c45.616 0 83.2-37.765 83.2-83.2v-35.647a93.148 93.148 0 0 0 22.064-7.929c22.006 2.507 44.978-3.503 62.791-15.985C409.342 368.1 448 331.841 448 269.299V248c0-60.063-40-98.512-40-127.2v-2.679c4.952-5.747 8-13.536 8-22.12V32c0-17.673-12.894-32-28.8-32H156.8C140.894 0 128 14.327 128 32v64c0 8.584 3.048 16.373 8 22.12v2.679c0 6.964-6.193 14.862-23.668 30.183l-.148.129-.146.131c-9.937 8.856-20.841 18.116-33.253 25.851C48.537 195.798 0 207.486 0 252.8c0 56.928 35.286 92 83.2 92 8.026 0 15.489-.814 22.4-2.176V428.8c0 45.099 38.101 83.2 83.2 83.2zm0-48c-18.7 0-35.2-16.775-35.2-35.2V270.4c-17.325 0-35.2 26.4-70.4 26.4-26.4 0-35.2-20.625-35.2-44 0-8.794 32.712-20.445 56.1-34.926 14.575-9.074 27.225-19.524 39.875-30.799 18.374-16.109 36.633-33.836 39.596-59.075h176.752C364.087 170.79 400 202.509 400 248v21.299c0 40.524-22.197 57.124-61.325 50.601-8.001 14.612-33.979 24.151-53.625 12.925-18.225 19.365-46.381 17.787-61.05 4.95V428.8c0 18.975-16.225 35.2-35.2 35.2zM328 64c0-13.255 10.745-24 24-24s24 10.745 24 24-10.745 24-24 24-24-10.745-24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegHandPointLeft(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 220.8C0 266.416 37.765 304 83.2 304h35.647a93.148 93.148 0 0 0 7.929 22.064c-2.507 22.006 3.503 44.978 15.985 62.791C143.9 441.342 180.159 480 242.701 480H264c60.063 0 98.512-40 127.2-40h2.679c5.747 4.952 13.536 8 22.12 8h64c17.673 0 32-12.894 32-28.8V188.8c0-15.906-14.327-28.8-32-28.8h-64c-8.584 0-16.373 3.048-22.12 8H391.2c-6.964 0-14.862-6.193-30.183-23.668l-.129-.148-.131-.146c-8.856-9.937-18.116-20.841-25.851-33.253C316.202 80.537 304.514 32 259.2 32c-56.928 0-92 35.286-92 83.2 0 8.026.814 15.489 2.176 22.4H83.2C38.101 137.6 0 175.701 0 220.8zm48 0c0-18.7 16.775-35.2 35.2-35.2h158.4c0-17.325-26.4-35.2-26.4-70.4 0-26.4 20.625-35.2 44-35.2 8.794 0 20.445 32.712 34.926 56.1 9.074 14.575 19.524 27.225 30.799 39.875 16.109 18.374 33.836 36.633 59.075 39.596v176.752C341.21 396.087 309.491 432 264 432h-21.299c-40.524 0-57.124-22.197-50.601-61.325-14.612-8.001-24.151-33.979-12.925-53.625-19.365-18.225-17.787-46.381-4.95-61.05H83.2C64.225 256 48 239.775 48 220.8zM448 360c13.255 0 24 10.745 24 24s-10.745 24-24 24-24-10.745-24-24 10.745-24 24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegHandPointRight(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M428.8 137.6h-86.177a115.52 115.52 0 0 0 2.176-22.4c0-47.914-35.072-83.2-92-83.2-45.314 0-57.002 48.537-75.707 78.784-7.735 12.413-16.994 23.317-25.851 33.253l-.131.146-.129.148C135.662 161.807 127.764 168 120.8 168h-2.679c-5.747-4.952-13.536-8-22.12-8H32c-17.673 0-32 12.894-32 28.8v230.4C0 435.106 14.327 448 32 448h64c8.584 0 16.373-3.048 22.12-8h2.679c28.688 0 67.137 40 127.2 40h21.299c62.542 0 98.8-38.658 99.94-91.145 12.482-17.813 18.491-40.785 15.985-62.791A93.148 93.148 0 0 0 393.152 304H428.8c45.435 0 83.2-37.584 83.2-83.2 0-45.099-38.101-83.2-83.2-83.2zm0 118.4h-91.026c12.837 14.669 14.415 42.825-4.95 61.05 11.227 19.646 1.687 45.624-12.925 53.625 6.524 39.128-10.076 61.325-50.6 61.325H248c-45.491 0-77.21-35.913-120-39.676V215.571c25.239-2.964 42.966-21.222 59.075-39.596 11.275-12.65 21.725-25.3 30.799-39.875C232.355 112.712 244.006 80 252.8 80c23.375 0 44 8.8 44 35.2 0 35.2-26.4 53.075-26.4 70.4h158.4c18.425 0 35.2 16.5 35.2 35.2 0 18.975-16.225 35.2-35.2 35.2zM88 384c0 13.255-10.745 24-24 24s-24-10.745-24-24 10.745-24 24-24 24 10.745 24 24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegHandPointUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M105.6 83.2v86.177a115.52 115.52 0 0 0-22.4-2.176c-47.914 0-83.2 35.072-83.2 92 0 45.314 48.537 57.002 78.784 75.707 12.413 7.735 23.317 16.994 33.253 25.851l.146.131.148.129C129.807 376.338 136 384.236 136 391.2v2.679c-4.952 5.747-8 13.536-8 22.12v64c0 17.673 12.894 32 28.8 32h230.4c15.906 0 28.8-14.327 28.8-32v-64c0-8.584-3.048-16.373-8-22.12V391.2c0-28.688 40-67.137 40-127.2v-21.299c0-62.542-38.658-98.8-91.145-99.94-17.813-12.482-40.785-18.491-62.791-15.985A93.148 93.148 0 0 0 272 118.847V83.2C272 37.765 234.416 0 188.8 0c-45.099 0-83.2 38.101-83.2 83.2zm118.4 0v91.026c14.669-12.837 42.825-14.415 61.05 4.95 19.646-11.227 45.624-1.687 53.625 12.925 39.128-6.524 61.325 10.076 61.325 50.6V264c0 45.491-35.913 77.21-39.676 120H183.571c-2.964-25.239-21.222-42.966-39.596-59.075-12.65-11.275-25.3-21.725-39.875-30.799C80.712 279.645 48 267.994 48 259.2c0-23.375 8.8-44 35.2-44 35.2 0 53.075 26.4 70.4 26.4V83.2c0-18.425 16.5-35.2 35.2-35.2 18.975 0 35.2 16.225 35.2 35.2zM352 424c13.255 0 24 10.745 24 24s-10.745 24-24 24-24-10.745-24-24 10.745-24 24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegHandPointer(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M358.182 179.361c-19.493-24.768-52.679-31.945-79.872-19.098-15.127-15.687-36.182-22.487-56.595-19.629V67c0-36.944-29.736-67-66.286-67S89.143 30.056 89.143 67v161.129c-19.909-7.41-43.272-5.094-62.083 8.872-29.355 21.795-35.793 63.333-14.55 93.152l109.699 154.001C134.632 501.59 154.741 512 176 512h178.286c30.802 0 57.574-21.5 64.557-51.797l27.429-118.999A67.873 67.873 0 0 0 448 326v-84c0-46.844-46.625-79.273-89.818-62.639zM80.985 279.697l27.126 38.079c8.995 12.626 29.031 6.287 29.031-9.283V67c0-25.12 36.571-25.16 36.571 0v175c0 8.836 7.163 16 16 16h6.857c8.837 0 16-7.164 16-16v-35c0-25.12 36.571-25.16 36.571 0v35c0 8.836 7.163 16 16 16H272c8.837 0 16-7.164 16-16v-21c0-25.12 36.571-25.16 36.571 0v21c0 8.836 7.163 16 16 16h6.857c8.837 0 16-7.164 16-16 0-25.121 36.571-25.16 36.571 0v84c0 1.488-.169 2.977-.502 4.423l-27.43 119.001c-1.978 8.582-9.29 14.576-17.782 14.576H176c-5.769 0-11.263-2.878-14.697-7.697l-109.712-154c-14.406-20.223 14.994-42.818 29.394-22.606zM176.143 400v-96c0-8.837 6.268-16 14-16h6c7.732 0 14 7.163 14 16v96c0 8.837-6.268 16-14 16h-6c-7.733 0-14-7.163-14-16zm75.428 0v-96c0-8.837 6.268-16 14-16h6c7.732 0 14 7.163 14 16v96c0 8.837-6.268 16-14 16h-6c-7.732 0-14-7.163-14-16zM327 400v-96c0-8.837 6.268-16 14-16h6c7.732 0 14 7.163 14 16v96c0 8.837-6.268 16-14 16h-6c-7.732 0-14-7.163-14-16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegHandRock(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M408.864 79.052c-22.401-33.898-66.108-42.273-98.813-23.588-29.474-31.469-79.145-31.093-108.334-.022-47.16-27.02-108.71 5.055-110.671 60.806C44.846 105.407 0 140.001 0 187.429v56.953c0 32.741 14.28 63.954 39.18 85.634l97.71 85.081c4.252 3.702 3.11 5.573 3.11 32.903 0 17.673 14.327 32 32 32h252c17.673 0 32-14.327 32-32 0-23.513-1.015-30.745 3.982-42.37l42.835-99.656c6.094-14.177 9.183-29.172 9.183-44.568V146.963c0-52.839-54.314-88.662-103.136-67.911zM464 261.406a64.505 64.505 0 0 1-5.282 25.613l-42.835 99.655c-5.23 12.171-7.883 25.04-7.883 38.25V432H188v-10.286c0-16.37-7.14-31.977-19.59-42.817l-97.71-85.08C56.274 281.255 48 263.236 48 244.381v-56.953c0-33.208 52-33.537 52 .677v41.228a16 16 0 0 0 5.493 12.067l7 6.095A16 16 0 0 0 139 235.429V118.857c0-33.097 52-33.725 52 .677v26.751c0 8.836 7.164 16 16 16h7c8.836 0 16-7.164 16-16v-41.143c0-33.134 52-33.675 52 .677v40.466c0 8.836 7.163 16 16 16h7c8.837 0 16-7.164 16-16v-27.429c0-33.03 52-33.78 52 .677v26.751c0 8.836 7.163 16 16 16h7c8.837 0 16-7.164 16-16 0-33.146 52-33.613 52 .677v114.445z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegHandScissors(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 480l70-.013c5.114 0 10.231-.583 15.203-1.729l118.999-27.427C490.56 443.835 512 417.02 512 386.277V180.575c0-23.845-13.03-45.951-34.005-57.69l-97.999-54.853c-34.409-19.261-67.263-5.824-92.218 24.733L142.85 37.008c-37.887-14.579-80.612 3.727-95.642 41.201-15.098 37.642 3.635 80.37 41.942 95.112L168 192l-94-9.141c-40.804 0-74 32.811-74 73.14 0 40.33 33.196 73.141 74 73.141h87.635c-3.675 26.245 8.692 51.297 30.341 65.006C178.657 436.737 211.044 480 256 480zm0-48.013c-25.16 0-25.12-36.567 0-36.567 8.837 0 16-7.163 16-16v-6.856c0-8.837-7.163-16-16-16h-28c-25.159 0-25.122-36.567 0-36.567h28c8.837 0 16-7.163 16-16v-6.856c0-8.837-7.163-16-16-16H74c-34.43 0-34.375-50.281 0-50.281h182c8.837 0 16-7.163 16-16v-11.632a16 16 0 0 0-10.254-14.933L106.389 128.51c-31.552-12.14-13.432-59.283 19.222-46.717l166.549 64.091a16.001 16.001 0 0 0 18.139-4.812l21.764-26.647c5.82-7.127 16.348-9.064 24.488-4.508l98 54.854c5.828 3.263 9.449 9.318 9.449 15.805v205.701c0 8.491-5.994 15.804-14.576 17.782l-119.001 27.427a19.743 19.743 0 0 1-4.423.502h-70z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegHandSpock(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M501.03053,116.17605c-19.39059-31.50779-51.24406-35.72849-66.31044-35.01756-14.11325-50.81051-62.0038-54.08-70.73816-54.08a74.03091,74.03091,0,0,0-72.23816,58.916l-4.64648,22.66014-13.68357-53.207c-9.09569-35.37107-46.412-64.05074-89.66-53.07223a73.89749,73.89749,0,0,0-55.121,78.94722,73.68273,73.68273,0,0,0-64.8495,94.42181l24.35933,82.19721c-38.24017-7.54492-62.79677,16.18358-68.11512,21.84764a73.6791,73.6791,0,0,0,3.19921,104.19329l91.36509,85.9765A154.164,154.164,0,0,0,220.62279,512h107.4549A127.30079,127.30079,0,0,0,452.3392,413.86139l57.623-241.96272A73.20274,73.20274,0,0,0,501.03053,116.17605Zm-37.7597,44.60544L405.64788,402.74812a79.46616,79.46616,0,0,1-77.57019,61.25972H220.62279a106.34052,106.34052,0,0,1-73.1366-28.998l-91.369-85.98041C31.34381,325.72669,66.61133,288.131,91.39644,311.5392l51.123,48.10739c5.42577,5.10937,13.48239.71679,13.48239-5.82617a246.79914,246.79914,0,0,0-10.17771-70.1523l-36.01362-121.539c-9.7324-32.88279,39.69916-47.27145,49.38664-14.625l31.3437,105.77923c5.59374,18.90428,33.78119,10.71288,28.9648-8.00781L177.06427,80.23662c-8.50389-33.1035,41.43157-45.64646,49.86515-12.83593l47.32609,184.035c4.42773,17.24218,29.16207,16.5039,32.71089-.80468l31.791-154.9706c6.81054-33.1074,57.51748-24.10741,50.11906,11.96288L360.32764,246.78924c-3.72265,18.10936,23.66793,24.63084,28.05659,6.21679L413.185,148.85962C421.1498,115.512,471.14,127.79713,463.27083,160.78149Z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegHandshake(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M519.2 127.9l-47.6-47.6A56.252 56.252 0 0 0 432 64H205.2c-14.8 0-29.1 5.9-39.6 16.3L118 127.9H0v255.7h64c17.6 0 31.8-14.2 31.9-31.7h9.1l84.6 76.4c30.9 25.1 73.8 25.7 105.6 3.8 12.5 10.8 26 15.9 41.1 15.9 18.2 0 35.3-7.4 48.8-24 22.1 8.7 48.2 2.6 64-16.8l26.2-32.3c5.6-6.9 9.1-14.8 10.9-23h57.9c.1 17.5 14.4 31.7 31.9 31.7h64V127.9H519.2zM48 351.6c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16c0 8.9-7.2 16-16 16zm390-6.9l-26.1 32.2c-2.8 3.4-7.8 4-11.3 1.2l-23.9-19.4-30 36.5c-6 7.3-15 4.8-18 2.4l-36.8-31.5-15.6 19.2c-13.9 17.1-39.2 19.7-55.3 6.6l-97.3-88H96V175.8h41.9l61.7-61.6c2-.8 3.7-1.5 5.7-2.3H262l-38.7 35.5c-29.4 26.9-31.1 72.3-4.4 101.3 14.8 16.2 61.2 41.2 101.5 4.4l8.2-7.5 108.2 87.8c3.4 2.8 3.9 7.9 1.2 11.3zm106-40.8h-69.2c-2.3-2.8-4.9-5.4-7.7-7.7l-102.7-83.4 12.5-11.4c6.5-6 7-16.1 1-22.6L367 167.1c-6-6.5-16.1-6.9-22.6-1l-55.2 50.6c-9.5 8.7-25.7 9.4-34.6 0-9.3-9.9-8.5-25.1 1.2-33.9l65.6-60.1c7.4-6.8 17-10.5 27-10.5l83.7-.2c2.1 0 4.1.8 5.5 2.3l61.7 61.6H544v128zm48 47.7c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16c0 8.9-7.2 16-16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegHdd(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M567.403 235.642L462.323 84.589A48 48 0 0 0 422.919 64H153.081a48 48 0 0 0-39.404 20.589L8.597 235.642A48.001 48.001 0 0 0 0 263.054V400c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V263.054c0-9.801-3-19.366-8.597-27.412zM153.081 112h269.838l77.913 112H75.168l77.913-112zM528 400H48V272h480v128zm-32-64c0 17.673-14.327 32-32 32s-32-14.327-32-32 14.327-32 32-32 32 14.327 32 32zm-96 0c0 17.673-14.327 32-32 32s-32-14.327-32-32 14.327-32 32-32 32 14.327 32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegHeart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M458.4 64.3C400.6 15.7 311.3 23 256 79.3 200.7 23 111.4 15.6 53.6 64.3-21.6 127.6-10.6 230.8 43 285.5l175.4 178.7c10 10.2 23.4 15.9 37.6 15.9 14.3 0 27.6-5.6 37.6-15.8L469 285.6c53.5-54.7 64.7-157.9-10.6-221.3zm-23.6 187.5L259.4 430.5c-2.4 2.4-4.4 2.4-6.8 0L77.2 251.8c-36.5-37.2-43.9-107.6 7.3-150.7 38.9-32.7 98.9-27.8 136.5 10.5l35 35.7 35-35.7c37.8-38.5 97.8-43.2 136.5-10.6 51.1 43.1 43.5 113.9 7.3 150.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegHospital(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 244v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12zm140 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12zm-76 84v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm76 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12zm180 124v36H0v-36c0-6.627 5.373-12 12-12h19.5V85.035C31.5 73.418 42.245 64 55.5 64H144V24c0-13.255 10.745-24 24-24h112c13.255 0 24 10.745 24 24v40h88.5c13.255 0 24 9.418 24 21.035V464H436c6.627 0 12 5.373 12 12zM79.5 463H192v-67c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v67h112.5V112H304v24c0 13.255-10.745 24-24 24H168c-13.255 0-24-10.745-24-24v-24H79.5v351zM266 64h-26V38a6 6 0 0 0-6-6h-20a6 6 0 0 0-6 6v26h-26a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6h26v26a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6V96h26a6 6 0 0 0 6-6V70a6 6 0 0 0-6-6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegHourglass(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 48h4c6.627 0 12-5.373 12-12V12c0-6.627-5.373-12-12-12H12C5.373 0 0 5.373 0 12v24c0 6.627 5.373 12 12 12h4c0 80.564 32.188 165.807 97.18 208C47.899 298.381 16 383.9 16 464h-4c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12h360c6.627 0 12-5.373 12-12v-24c0-6.627-5.373-12-12-12h-4c0-80.564-32.188-165.807-97.18-208C336.102 213.619 368 128.1 368 48zM64 48h256c0 101.62-57.307 184-128 184S64 149.621 64 48zm256 416H64c0-101.62 57.308-184 128-184s128 82.38 128 184z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegIdBadge(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm0 464H48V48h288v416zM144 112h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96c-8.8 0-16 7.2-16 16s7.2 16 16 16zm48 176c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm-89.6 128h179.2c12.4 0 22.4-8.6 22.4-19.2v-19.2c0-31.8-30.1-57.6-67.2-57.6-10.8 0-18.7 8-44.8 8-26.9 0-33.4-8-44.8-8-37.1 0-67.2 25.8-67.2 57.6v19.2c0 10.6 10 19.2 22.4 19.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegIdCard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm0 400H303.2c.9-4.5.8 3.6.8-22.4 0-31.8-30.1-57.6-67.2-57.6-10.8 0-18.7 8-44.8 8-26.9 0-33.4-8-44.8-8-37.1 0-67.2 25.8-67.2 57.6 0 26-.2 17.9.8 22.4H48V144h480v288zm-168-80h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm0-64h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm0-64h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm-168 96c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegImage(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm-6 336H54a6 6 0 0 1-6-6V118a6 6 0 0 1 6-6h404a6 6 0 0 1 6 6v276a6 6 0 0 1-6 6zM128 152c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zM96 352h320v-80l-87.515-87.515c-4.686-4.686-12.284-4.686-16.971 0L192 304l-39.515-39.515c-4.686-4.686-12.284-4.686-16.971 0L96 304v48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegImages(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 416v16c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V176c0-26.51 21.49-48 48-48h16v48H54a6 6 0 0 0-6 6v244a6 6 0 0 0 6 6h372a6 6 0 0 0 6-6v-10h48zm42-336H150a6 6 0 0 0-6 6v244a6 6 0 0 0 6 6h372a6 6 0 0 0 6-6V86a6 6 0 0 0-6-6zm6-48c26.51 0 48 21.49 48 48v256c0 26.51-21.49 48-48 48H144c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h384zM264 144c0 22.091-17.909 40-40 40s-40-17.909-40-40 17.909-40 40-40 40 17.909 40 40zm-72 96l39.515-39.515c4.686-4.686 12.284-4.686 16.971 0L288 240l103.515-103.515c4.686-4.686 12.284-4.686 16.971 0L480 208v80H192v-48z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegKeyboard(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm8 336c0 4.411-3.589 8-8 8H48c-4.411 0-8-3.589-8-8V112c0-4.411 3.589-8 8-8h480c4.411 0 8 3.589 8 8v288zM170 270v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm-336 82v-28c0-6.627-5.373-12-12-12H82c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm384 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zM122 188v-28c0-6.627-5.373-12-12-12H82c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm-98 158v-16c0-6.627-5.373-12-12-12H180c-6.627 0-12 5.373-12 12v16c0 6.627 5.373 12 12 12h216c6.627 0 12-5.373 12-12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegKissBeam(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M168 152c-23.8 0-52.7 29.3-56 71.4-.3 3.7 2 7.2 5.6 8.3 3.5 1 7.5-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 5.9-4.5 5.6-8.3-3.1-42.1-32-71.4-55.8-71.4zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm56-148c0-19.2-28.8-41.5-71.5-44-3.8-.4-7.4 2.4-8.2 6.2-.9 3.8 1.1 7.7 4.7 9.2l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-5.7 2.4-6 12.2 0 14.8l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-3.6 1.5-5.6 5.4-4.7 9.2.8 3.6 4.1 6.2 7.8 6.2h.5c42.8-2.5 71.5-24.8 71.5-44 0-13-13.4-27.3-35.2-36C290.6 335.3 304 321 304 308zm24-156c-23.8 0-52.7 29.3-56 71.4-.3 3.7 2 7.2 5.6 8.3 3.5 1 7.5-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 5.9-4.5 5.6-8.3-3.1-42.1-32-71.4-55.8-71.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegKissWinkHeart(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 504 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304 308.5c0-19.2-28.8-41.5-71.5-44-3.8-.4-7.4 2.4-8.2 6.2-.9 3.8 1.1 7.7 4.7 9.2l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-5.7 2.4-6 12.2 0 14.8l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-3.6 1.5-5.6 5.4-4.7 9.2.8 3.6 4.1 6.2 7.8 6.2h.5c42.8-2.5 71.5-24.8 71.5-44 0-13-13.4-27.3-35.2-36 21.7-9.1 35.1-23.4 35.1-36.4zm70.5-83.5l9.5 8.5c3.8 3.3 9.3 4 13.7 1.6 4.4-2.4 6.9-7.4 6.1-12.4-4-25.2-34.2-42.1-59.8-42.1s-55.9 16.9-59.8 42.1c-.8 5 1.7 10 6.1 12.4 5.8 3.1 11.2.7 13.7-1.6l9.5-8.5c14.8-13.2 46.2-13.2 61 0zM136 208.5c0 17.7 14.3 32 32 32s32-14.3 32-32-14.3-32-32-32-32 14.3-32 32zm365.1 194c-8-20.8-31.5-31.5-53.1-25.9l-8.4 2.2-2.3-8.4c-5.9-21.4-27-36.5-49-33-25.2 4-40.6 28.6-34 52.6l22.9 82.6c1.5 5.3 7 8.5 12.4 7.1l83-21.5c24.1-6.3 37.7-31.8 28.5-55.7zM334 436.3c-26.1 12.5-55.2 19.7-86 19.7-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200c0 22.1-3.7 43.3-10.4 63.2 9 6.4 17 14.2 22.6 23.9 6.4.1 12.6 1.4 18.6 2.9 10.9-27.9 17.1-58.2 17.1-90C496 119 385 8 248 8S0 119 0 256s111 248 248 248c35.4 0 68.9-7.5 99.4-20.9-2.5-7.3 4.3 17.2-13.4-46.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegKiss(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M168 176c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm136 132c0-19.2-28.8-41.5-71.5-44-3.8-.4-7.4 2.4-8.2 6.2-.9 3.8 1.1 7.7 4.7 9.2l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-5.7 2.4-6 12.2 0 14.8l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-3.6 1.5-5.6 5.4-4.7 9.2.8 3.6 4.1 6.2 7.8 6.2h.5c42.8-2.5 71.5-24.8 71.5-44 0-13-13.4-27.3-35.2-36C290.6 335.3 304 321 304 308zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm80-280c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegLaughBeam(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm141.4 389.4c-37.8 37.8-88 58.6-141.4 58.6s-103.6-20.8-141.4-58.6S48 309.4 48 256s20.8-103.6 58.6-141.4S194.6 56 248 56s103.6 20.8 141.4 58.6S448 202.6 448 256s-20.8 103.6-58.6 141.4zM328 152c-23.8 0-52.7 29.3-56 71.4-.7 8.6 10.8 11.9 14.9 4.5l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c4.1 7.4 15.6 4 14.9-4.5-3.1-42.1-32-71.4-55.8-71.4zm-201 75.9l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c4.1 7.4 15.6 4 14.9-4.5-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.6 8.5 10.9 11.9 15.1 4.5zM362.4 288H133.6c-8.2 0-14.5 7-13.5 15 7.5 59.2 58.9 105 121.1 105h13.6c62.2 0 113.6-45.8 121.1-105 1-8-5.3-15-13.5-15z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegLaughSquint(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm141.4 389.4c-37.8 37.8-88 58.6-141.4 58.6s-103.6-20.8-141.4-58.6S48 309.4 48 256s20.8-103.6 58.6-141.4S194.6 56 248 56s103.6 20.8 141.4 58.6S448 202.6 448 256s-20.8 103.6-58.6 141.4zM343.6 196l33.6-40.3c8.6-10.3-3.8-24.8-15.4-18l-80 48c-7.8 4.7-7.8 15.9 0 20.6l80 48c11.5 6.8 24-7.6 15.4-18L343.6 196zm-209.4 58.3l80-48c7.8-4.7 7.8-15.9 0-20.6l-80-48c-11.6-6.9-24 7.7-15.4 18l33.6 40.3-33.6 40.3c-8.7 10.4 3.8 24.8 15.4 18zM362.4 288H133.6c-8.2 0-14.5 7-13.5 15 7.5 59.2 58.9 105 121.1 105h13.6c62.2 0 113.6-45.8 121.1-105 1-8-5.3-15-13.5-15z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegLaughWink(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm141.4 389.4c-37.8 37.8-88 58.6-141.4 58.6s-103.6-20.8-141.4-58.6C68.8 359.6 48 309.4 48 256s20.8-103.6 58.6-141.4C144.4 76.8 194.6 56 248 56s103.6 20.8 141.4 58.6c37.8 37.8 58.6 88 58.6 141.4s-20.8 103.6-58.6 141.4zM328 164c-25.7 0-55.9 16.9-59.9 42.1-1.7 11.2 11.5 18.2 19.8 10.8l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c8.5 7.4 21.6.3 19.8-10.8-3.8-25.2-34-42.1-59.7-42.1zm-160 60c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm194.4 64H133.6c-8.2 0-14.5 7-13.5 15 7.5 59.2 58.9 105 121.1 105h13.6c62.2 0 113.6-45.8 121.1-105 1-8-5.3-15-13.5-15z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegLaugh(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm141.4 389.4c-37.8 37.8-88 58.6-141.4 58.6s-103.6-20.8-141.4-58.6S48 309.4 48 256s20.8-103.6 58.6-141.4S194.6 56 248 56s103.6 20.8 141.4 58.6S448 202.6 448 256s-20.8 103.6-58.6 141.4zM328 224c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm-160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm194.4 64H133.6c-8.2 0-14.5 7-13.5 15 7.5 59.2 58.9 105 121.1 105h13.6c62.2 0 113.6-45.8 121.1-105 1-8-5.3-15-13.5-15z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegLemon(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M484.112 27.889C455.989-.233 416.108-8.057 387.059 8.865 347.604 31.848 223.504-41.111 91.196 91.197-41.277 223.672 31.923 347.472 8.866 387.058c-16.922 29.051-9.1 68.932 19.022 97.054 28.135 28.135 68.011 35.938 97.057 19.021 39.423-22.97 163.557 49.969 295.858-82.329 132.474-132.477 59.273-256.277 82.331-295.861 16.922-29.05 9.1-68.931-19.022-97.054zm-22.405 72.894c-38.8 66.609 45.6 165.635-74.845 286.08-120.44 120.443-219.475 36.048-286.076 74.843-22.679 13.207-64.035-27.241-50.493-50.488 38.8-66.609-45.6-165.635 74.845-286.08C245.573 4.702 344.616 89.086 411.219 50.292c22.73-13.24 64.005 27.288 50.488 50.491zm-169.861 8.736c1.37 10.96-6.404 20.957-17.365 22.327-54.846 6.855-135.779 87.787-142.635 142.635-1.373 10.989-11.399 18.734-22.326 17.365-10.961-1.37-18.735-11.366-17.365-22.326 9.162-73.286 104.167-168.215 177.365-177.365 10.953-1.368 20.956 6.403 22.326 17.364z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegLifeRing(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 504c136.967 0 248-111.033 248-248S392.967 8 256 8 8 119.033 8 256s111.033 248 248 248zm-103.398-76.72l53.411-53.411c31.806 13.506 68.128 13.522 99.974 0l53.411 53.411c-63.217 38.319-143.579 38.319-206.796 0zM336 256c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80zm91.28 103.398l-53.411-53.411c13.505-31.806 13.522-68.128 0-99.974l53.411-53.411c38.319 63.217 38.319 143.579 0 206.796zM359.397 84.72l-53.411 53.411c-31.806-13.505-68.128-13.522-99.973 0L152.602 84.72c63.217-38.319 143.579-38.319 206.795 0zM84.72 152.602l53.411 53.411c-13.506 31.806-13.522 68.128 0 99.974L84.72 359.398c-38.319-63.217-38.319-143.579 0-206.796z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegLightbulb(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 352 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 80c-52.94 0-96 43.06-96 96 0 8.84 7.16 16 16 16s16-7.16 16-16c0-35.3 28.72-64 64-64 8.84 0 16-7.16 16-16s-7.16-16-16-16zM96.06 459.17c0 3.15.93 6.22 2.68 8.84l24.51 36.84c2.97 4.46 7.97 7.14 13.32 7.14h78.85c5.36 0 10.36-2.68 13.32-7.14l24.51-36.84c1.74-2.62 2.67-5.7 2.68-8.84l.05-43.18H96.02l.04 43.18zM176 0C73.72 0 0 82.97 0 176c0 44.37 16.45 84.85 43.56 115.78 16.64 18.99 42.74 58.8 52.42 92.16v.06h48v-.12c-.01-4.77-.72-9.51-2.15-14.07-5.59-17.81-22.82-64.77-62.17-109.67-20.54-23.43-31.52-53.15-31.61-84.14-.2-73.64 59.67-128 127.95-128 70.58 0 128 57.42 128 128 0 30.97-11.24 60.85-31.65 84.14-39.11 44.61-56.42 91.47-62.1 109.46a47.507 47.507 0 0 0-2.22 14.3v.1h48v-.05c9.68-33.37 35.78-73.18 52.42-92.16C335.55 260.85 352 220.37 352 176 352 78.8 273.2 0 176 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegListAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zm-6 400H54a6 6 0 0 1-6-6V86a6 6 0 0 1 6-6h404a6 6 0 0 1 6 6v340a6 6 0 0 1-6 6zm-42-92v24c0 6.627-5.373 12-12 12H204c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h200c6.627 0 12 5.373 12 12zm0-96v24c0 6.627-5.373 12-12 12H204c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h200c6.627 0 12 5.373 12 12zm0-96v24c0 6.627-5.373 12-12 12H204c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h200c6.627 0 12 5.373 12 12zm-252 12c0 19.882-16.118 36-36 36s-36-16.118-36-36 16.118-36 36-36 36 16.118 36 36zm0 96c0 19.882-16.118 36-36 36s-36-16.118-36-36 16.118-36 36-36 36 16.118 36 36zm0 96c0 19.882-16.118 36-36 36s-36-16.118-36-36 16.118-36 36-36 36 16.118 36 36z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegMap(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M560.02 32c-1.96 0-3.98.37-5.96 1.16L384.01 96H384L212 35.28A64.252 64.252 0 0 0 191.76 32c-6.69 0-13.37 1.05-19.81 3.14L20.12 87.95A32.006 32.006 0 0 0 0 117.66v346.32C0 473.17 7.53 480 15.99 480c1.96 0 3.97-.37 5.96-1.16L192 416l172 60.71a63.98 63.98 0 0 0 40.05.15l151.83-52.81A31.996 31.996 0 0 0 576 394.34V48.02c0-9.19-7.53-16.02-15.98-16.02zM224 90.42l128 45.19v285.97l-128-45.19V90.42zM48 418.05V129.07l128-44.53v286.2l-.64.23L48 418.05zm480-35.13l-128 44.53V141.26l.64-.24L528 93.95v288.97z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegMehBlank(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-280c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm160 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegMehRollingEyes(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm88-304c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm0 112c-22.1 0-40-17.9-40-40 0-13.6 7.3-25.1 17.7-32.3-1 2.6-1.7 5.3-1.7 8.3 0 13.3 10.7 24 24 24s24-10.7 24-24c0-2.9-.7-5.7-1.7-8.3 10.4 7.2 17.7 18.7 17.7 32.3 0 22.1-17.9 40-40 40zm-104-40c0-39.8-32.2-72-72-72s-72 32.2-72 72 32.2 72 72 72 72-32.2 72-72zm-112 0c0-13.6 7.3-25.1 17.7-32.3-1 2.6-1.7 5.3-1.7 8.3 0 13.3 10.7 24 24 24s24-10.7 24-24c0-2.9-.7-5.7-1.7-8.3 10.4 7.2 17.7 18.7 17.7 32.3 0 22.1-17.9 40-40 40s-40-17.9-40-40zm192 128H184c-13.2 0-24 10.8-24 24s10.8 24 24 24h128c13.2 0 24-10.8 24-24s-10.8-24-24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegMeh(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160-64c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm8 144H160c-13.2 0-24 10.8-24 24s10.8 24 24 24h176c13.2 0 24-10.8 24-24s-10.8-24-24-24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegMinusSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M108 284c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h232c6.6 0 12 5.4 12 12v32c0 6.6-5.4 12-12 12H108zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegMoneyBillAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 144c-53.02 0-96 50.14-96 112 0 61.85 42.98 112 96 112 53 0 96-50.13 96-112 0-61.86-42.98-112-96-112zm40 168c0 4.42-3.58 8-8 8h-64c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h16v-55.44l-.47.31a7.992 7.992 0 0 1-11.09-2.22l-8.88-13.31a7.992 7.992 0 0 1 2.22-11.09l15.33-10.22a23.99 23.99 0 0 1 13.31-4.03H328c4.42 0 8 3.58 8 8v88h16c4.42 0 8 3.58 8 8v16zM608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zm-16 272c-35.35 0-64 28.65-64 64H112c0-35.35-28.65-64-64-64V176c35.35 0 64-28.65 64-64h416c0 35.35 28.65 64 64 64v160z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegMoon(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M279.135 512c78.756 0 150.982-35.804 198.844-94.775 28.27-34.831-2.558-85.722-46.249-77.401-82.348 15.683-158.272-47.268-158.272-130.792 0-48.424 26.06-92.292 67.434-115.836 38.745-22.05 28.999-80.788-15.022-88.919A257.936 257.936 0 0 0 279.135 0c-141.36 0-256 114.575-256 256 0 141.36 114.576 256 256 256zm0-464c12.985 0 25.689 1.201 38.016 3.478-54.76 31.163-91.693 90.042-91.693 157.554 0 113.848 103.641 199.2 215.252 177.944C402.574 433.964 344.366 464 279.135 464c-114.875 0-208-93.125-208-208s93.125-208 208-208z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegNewspaper(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M552 64H112c-20.858 0-38.643 13.377-45.248 32H24c-13.255 0-24 10.745-24 24v272c0 30.928 25.072 56 56 56h496c13.255 0 24-10.745 24-24V88c0-13.255-10.745-24-24-24zM48 392V144h16v248c0 4.411-3.589 8-8 8s-8-3.589-8-8zm480 8H111.422c.374-2.614.578-5.283.578-8V112h416v288zM172 280h136c6.627 0 12-5.373 12-12v-96c0-6.627-5.373-12-12-12H172c-6.627 0-12 5.373-12 12v96c0 6.627 5.373 12 12 12zm28-80h80v40h-80v-40zm-40 140v-24c0-6.627 5.373-12 12-12h136c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H172c-6.627 0-12-5.373-12-12zm192 0v-24c0-6.627 5.373-12 12-12h104c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H364c-6.627 0-12-5.373-12-12zm0-144v-24c0-6.627 5.373-12 12-12h104c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H364c-6.627 0-12-5.373-12-12zm0 72v-24c0-6.627 5.373-12 12-12h104c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H364c-6.627 0-12-5.373-12-12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegObjectGroup(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M500 128c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12h-72c-6.627 0-12 5.373-12 12v12H96V44c0-6.627-5.373-12-12-12H12C5.373 32 0 37.373 0 44v72c0 6.627 5.373 12 12 12h12v256H12c-6.627 0-12 5.373-12 12v72c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-12h320v12c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-72c0-6.627-5.373-12-12-12h-12V128h12zm-52-64h32v32h-32V64zM32 64h32v32H32V64zm32 384H32v-32h32v32zm416 0h-32v-32h32v32zm-40-64h-12c-6.627 0-12 5.373-12 12v12H96v-12c0-6.627-5.373-12-12-12H72V128h12c6.627 0 12-5.373 12-12v-12h320v12c0 6.627 5.373 12 12 12h12v256zm-36-192h-84v-52c0-6.628-5.373-12-12-12H108c-6.627 0-12 5.372-12 12v168c0 6.628 5.373 12 12 12h84v52c0 6.628 5.373 12 12 12h200c6.627 0 12-5.372 12-12V204c0-6.628-5.373-12-12-12zm-268-24h144v112H136V168zm240 176H232v-24h76c6.627 0 12-5.372 12-12v-76h56v112z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegObjectUngroup(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M564 224c6.627 0 12-5.373 12-12v-72c0-6.627-5.373-12-12-12h-72c-6.627 0-12 5.373-12 12v12h-88v-24h12c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12h-72c-6.627 0-12 5.373-12 12v12H96V44c0-6.627-5.373-12-12-12H12C5.373 32 0 37.373 0 44v72c0 6.627 5.373 12 12 12h12v160H12c-6.627 0-12 5.373-12 12v72c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-12h88v24h-12c-6.627 0-12 5.373-12 12v72c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-12h224v12c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-72c0-6.627-5.373-12-12-12h-12V224h12zM352 64h32v32h-32V64zm0 256h32v32h-32v-32zM64 352H32v-32h32v32zm0-256H32V64h32v32zm32 216v-12c0-6.627-5.373-12-12-12H72V128h12c6.627 0 12-5.373 12-12v-12h224v12c0 6.627 5.373 12 12 12h12v160h-12c-6.627 0-12 5.373-12 12v12H96zm128 136h-32v-32h32v32zm280-64h-12c-6.627 0-12 5.373-12 12v12H256v-12c0-6.627-5.373-12-12-12h-12v-24h88v12c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-72c0-6.627-5.373-12-12-12h-12v-88h88v12c0 6.627 5.373 12 12 12h12v160zm40 64h-32v-32h32v32zm0-256h-32v-32h32v32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegPaperPlane(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M440 6.5L24 246.4c-34.4 19.9-31.1 70.8 5.7 85.9L144 379.6V464c0 46.4 59.2 65.5 86.6 28.6l43.8-59.1 111.9 46.2c5.9 2.4 12.1 3.6 18.3 3.6 8.2 0 16.3-2.1 23.6-6.2 12.8-7.2 21.6-20 23.9-34.5l59.4-387.2c6.1-40.1-36.9-68.8-71.5-48.9zM192 464v-64.6l36.6 15.1L192 464zm212.6-28.7l-153.8-63.5L391 169.5c10.7-15.5-9.5-33.5-23.7-21.2L155.8 332.6 48 288 464 48l-59.4 387.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegPauseCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm96-280v160c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16zm-112 0v160c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegPlayCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M371.7 238l-176-107c-15.8-8.8-35.7 2.5-35.7 21v208c0 18.4 19.8 29.8 35.7 21l176-101c16.4-9.1 16.4-32.8 0-42zM504 256C504 119 393 8 256 8S8 119 8 256s111 248 248 248 248-111 248-248zm-448 0c0-110.5 89.5-200 200-200s200 89.5 200 200-89.5 200-200 200S56 366.5 56 256z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegPlusSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 240v32c0 6.6-5.4 12-12 12h-88v88c0 6.6-5.4 12-12 12h-32c-6.6 0-12-5.4-12-12v-88h-88c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h88v-88c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v88h88c6.6 0 12 5.4 12 12zm96-160v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegQuestionCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 448c-110.532 0-200-89.431-200-200 0-110.495 89.472-200 200-200 110.491 0 200 89.471 200 200 0 110.53-89.431 200-200 200zm107.244-255.2c0 67.052-72.421 68.084-72.421 92.863V300c0 6.627-5.373 12-12 12h-45.647c-6.627 0-12-5.373-12-12v-8.659c0-35.745 27.1-50.034 47.579-61.516 17.561-9.845 28.324-16.541 28.324-29.579 0-17.246-21.999-28.693-39.784-28.693-23.189 0-33.894 10.977-48.942 29.969-4.057 5.12-11.46 6.071-16.666 2.124l-27.824-21.098c-5.107-3.872-6.251-11.066-2.644-16.363C184.846 131.491 214.94 112 261.794 112c49.071 0 101.45 38.304 101.45 88.8zM298 368c0 23.159-18.841 42-42 42s-42-18.841-42-42 18.841-42 42-42 42 18.841 42 42z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegRegistered(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 448c-110.532 0-200-89.451-200-200 0-110.531 89.451-200 200-200 110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200zm110.442-81.791c-53.046-96.284-50.25-91.468-53.271-96.085 24.267-13.879 39.482-41.563 39.482-73.176 0-52.503-30.247-85.252-101.498-85.252h-78.667c-6.617 0-12 5.383-12 12V380c0 6.617 5.383 12 12 12h38.568c6.617 0 12-5.383 12-12v-83.663h31.958l47.515 89.303a11.98 11.98 0 0 0 10.593 6.36h42.81c9.14 0 14.914-9.799 10.51-17.791zM256.933 239.906h-33.875v-64.14h27.377c32.417 0 38.929 12.133 38.929 31.709-.001 20.913-11.518 32.431-32.431 32.431z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegSadCry(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm144 386.4V280c0-13.2-10.8-24-24-24s-24 10.8-24 24v151.4C315.5 447 282.8 456 248 456s-67.5-9-96-24.6V280c0-13.2-10.8-24-24-24s-24 10.8-24 24v114.4c-34.6-36-56-84.7-56-138.4 0-110.3 89.7-200 200-200s200 89.7 200 200c0 53.7-21.4 102.5-56 138.4zM205.8 234.5c4.4-2.4 6.9-7.4 6.1-12.4-4-25.2-34.2-42.1-59.8-42.1s-55.9 16.9-59.8 42.1c-.8 5 1.7 10 6.1 12.4 4.4 2.4 9.9 1.8 13.7-1.6l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c2.5 2.3 7.9 4.8 13.7 1.6zM344 180c-25.7 0-55.9 16.9-59.8 42.1-.8 5 1.7 10 6.1 12.4 4.5 2.4 9.9 1.8 13.7-1.6l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c2.5 2.2 8 4.7 13.7 1.6 4.4-2.4 6.9-7.4 6.1-12.4-3.9-25.2-34.1-42.1-59.8-42.1zm-96 92c-30.9 0-56 28.7-56 64s25.1 64 56 64 56-28.7 56-64-25.1-64-56-64z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegSadTear(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm8-152c-13.2 0-24 10.8-24 24s10.8 24 24 24c23.8 0 46.3 10.5 61.6 28.8 8.1 9.8 23.2 11.9 33.8 3.1 10.2-8.5 11.6-23.6 3.1-33.8C330 320.8 294.1 304 256 304zm-88-64c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160-64c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm-165.6 98.8C151 290.1 126 325.4 126 342.9c0 22.7 18.8 41.1 42 41.1s42-18.4 42-41.1c0-17.5-25-52.8-36.4-68.1-2.8-3.7-8.4-3.7-11.2 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegSave(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M433.941 129.941l-83.882-83.882A48 48 0 0 0 316.118 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V163.882a48 48 0 0 0-14.059-33.941zM272 80v80H144V80h128zm122 352H54a6 6 0 0 1-6-6V86a6 6 0 0 1 6-6h42v104c0 13.255 10.745 24 24 24h176c13.255 0 24-10.745 24-24V83.882l78.243 78.243a6 6 0 0 1 1.757 4.243V426a6 6 0 0 1-6 6zM224 232c-48.523 0-88 39.477-88 88s39.477 88 88 88 88-39.477 88-88-39.477-88-88-88zm0 128c-22.056 0-40-17.944-40-40s17.944-40 40-40 40 17.944 40 40-17.944 40-40 40z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegShareSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M561.938 158.06L417.94 14.092C387.926-15.922 336 5.097 336 48.032v57.198c-42.45 1.88-84.03 6.55-120.76 17.99-35.17 10.95-63.07 27.58-82.91 49.42C108.22 199.2 96 232.6 96 271.94c0 61.697 33.178 112.455 84.87 144.76 37.546 23.508 85.248-12.651 71.02-55.74-15.515-47.119-17.156-70.923 84.11-78.76V336c0 42.993 51.968 63.913 81.94 33.94l143.998-144c18.75-18.74 18.75-49.14 0-67.88zM384 336V232.16C255.309 234.082 166.492 255.35 206.31 376 176.79 357.55 144 324.08 144 271.94c0-109.334 129.14-118.947 240-119.85V48l144 144-144 144zm24.74 84.493a82.658 82.658 0 0 0 20.974-9.303c7.976-4.952 18.286.826 18.286 10.214V464c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h132c6.627 0 12 5.373 12 12v4.486c0 4.917-2.987 9.369-7.569 11.152-13.702 5.331-26.396 11.537-38.05 18.585a12.138 12.138 0 0 1-6.28 1.777H54a6 6 0 0 0-6 6v340a6 6 0 0 0 6 6h340a6 6 0 0 0 6-6v-25.966c0-5.37 3.579-10.059 8.74-11.541z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegSmileBeam(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm84-143.4c-20.8 25-51.5 39.4-84 39.4s-63.2-14.3-84-39.4c-8.5-10.2-23.6-11.5-33.8-3.1-10.2 8.5-11.5 23.6-3.1 33.8 30 36 74.1 56.6 120.9 56.6s90.9-20.6 120.9-56.6c8.5-10.2 7.1-25.3-3.1-33.8-10.2-8.4-25.3-7.1-33.8 3.1zM136.5 211c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3 3.4 1.1 7.4-.5 9.3-3.7l9.5-17zM328 152c-23.8 0-52.7 29.3-56 71.4-.3 3.7 2.1 7.2 5.7 8.3 3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegSmileWink(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm117.8-146.4c-10.2-8.5-25.3-7.1-33.8 3.1-20.8 25-51.5 39.4-84 39.4s-63.2-14.3-84-39.4c-8.5-10.2-23.7-11.5-33.8-3.1-10.2 8.5-11.5 23.6-3.1 33.8 30 36 74.1 56.6 120.9 56.6s90.9-20.6 120.9-56.6c8.5-10.2 7.1-25.3-3.1-33.8zM168 240c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160-60c-25.7 0-55.9 16.9-59.9 42.1-1.7 11.2 11.5 18.2 19.8 10.8l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c8.5 7.4 21.6.3 19.8-10.8-3.8-25.2-34-42.1-59.7-42.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegSmile(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm4 72.6c-20.8 25-51.5 39.4-84 39.4s-63.2-14.3-84-39.4c-8.5-10.2-23.7-11.5-33.8-3.1-10.2 8.5-11.5 23.6-3.1 33.8 30 36 74.1 56.6 120.9 56.6s90.9-20.6 120.9-56.6c8.5-10.2 7.1-25.3-3.1-33.8-10.1-8.4-25.3-7.1-33.8 3.1z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegSnowflake(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M440.1 355.2l-39.2-23 34.1-9.3c8.4-2.3 13.4-11.1 11.1-19.6l-4.1-15.5c-2.2-8.5-10.9-13.6-19.3-11.3L343 298.2 271.2 256l71.9-42.2 79.7 21.7c8.4 2.3 17-2.8 19.3-11.3l4.1-15.5c2.2-8.5-2.7-17.3-11.1-19.6l-34.1-9.3 39.2-23c7.5-4.4 10.1-14.2 5.8-21.9l-7.9-13.9c-4.3-7.7-14-10.3-21.5-5.9l-39.2 23 9.1-34.7c2.2-8.5-2.7-17.3-11.1-19.6l-15.2-4.1c-8.4-2.3-17 2.8-19.3 11.3l-21.3 81-71.9 42.2v-84.5L306 70.4c6.1-6.2 6.1-16.4 0-22.6l-11.1-11.3c-6.1-6.2-16.1-6.2-22.2 0l-24.9 25.4V16c0-8.8-7-16-15.7-16h-15.7c-8.7 0-15.7 7.2-15.7 16v46.1l-24.9-25.4c-6.1-6.2-16.1-6.2-22.2 0L142.1 48c-6.1 6.2-6.1 16.4 0 22.6l58.3 59.3v84.5l-71.9-42.2-21.3-81c-2.2-8.5-10.9-13.6-19.3-11.3L72.7 84c-8.4 2.3-13.4 11.1-11.1 19.6l9.1 34.7-39.2-23c-7.5-4.4-17.1-1.8-21.5 5.9l-7.9 13.9c-4.3 7.7-1.8 17.4 5.8 21.9l39.2 23-34.1 9.1c-8.4 2.3-13.4 11.1-11.1 19.6L6 224.2c2.2 8.5 10.9 13.6 19.3 11.3l79.7-21.7 71.9 42.2-71.9 42.2-79.7-21.7c-8.4-2.3-17 2.8-19.3 11.3l-4.1 15.5c-2.2 8.5 2.7 17.3 11.1 19.6l34.1 9.3-39.2 23c-7.5 4.4-10.1 14.2-5.8 21.9L10 391c4.3 7.7 14 10.3 21.5 5.9l39.2-23-9.1 34.7c-2.2 8.5 2.7 17.3 11.1 19.6l15.2 4.1c8.4 2.3 17-2.8 19.3-11.3l21.3-81 71.9-42.2v84.5l-58.3 59.3c-6.1 6.2-6.1 16.4 0 22.6l11.1 11.3c6.1 6.2 16.1 6.2 22.2 0l24.9-25.4V496c0 8.8 7 16 15.7 16h15.7c8.7 0 15.7-7.2 15.7-16v-46.1l24.9 25.4c6.1 6.2 16.1 6.2 22.2 0l11.1-11.3c6.1-6.2 6.1-16.4 0-22.6l-58.3-59.3v-84.5l71.9 42.2 21.3 81c2.2 8.5 10.9 13.6 19.3 11.3L375 428c8.4-2.3 13.4-11.1 11.1-19.6l-9.1-34.7 39.2 23c7.5 4.4 17.1 1.8 21.5-5.9l7.9-13.9c4.6-7.5 2.1-17.3-5.5-21.7z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegSquare(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-6 400H54c-3.3 0-6-2.7-6-6V86c0-3.3 2.7-6 6-6h340c3.3 0 6 2.7 6 6v340c0 3.3-2.7 6-6 6z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegStarHalf(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 385.3l-124.3 65.4 23.7-138.4-100.6-98 139-20.2 62.2-126V0c-11.4 0-22.8 5.9-28.7 17.8L194 150.2 47.9 171.4c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.1 23 46 46.4 33.7L288 439.6v-54.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegStar(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528.1 171.5L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6zM388.6 312.3l23.7 138.4L288 385.4l-124.3 65.3 23.7-138.4-100.6-98 139-20.2 62.2-126 62.2 126 139 20.2-100.6 98z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegStickyNote(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 348.106V80c0-26.51-21.49-48-48-48H48C21.49 32 0 53.49 0 80v351.988c0 26.51 21.49 48 48 48h268.118a48 48 0 0 0 33.941-14.059l83.882-83.882A48 48 0 0 0 448 348.106zm-128 80v-76.118h76.118L320 428.106zM400 80v223.988H296c-13.255 0-24 10.745-24 24v104H48V80h352z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegStopCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 256C504 119 393 8 256 8S8 119 8 256s111 248 248 248 248-111 248-248zm-448 0c0-110.5 89.5-200 200-200s200 89.5 200 200-89.5 200-200 200S56 366.5 56 256zm296-80v160c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegSun(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M494.2 221.9l-59.8-40.5 13.7-71c2.6-13.2-1.6-26.8-11.1-36.4-9.6-9.5-23.2-13.7-36.2-11.1l-70.9 13.7-40.4-59.9c-15.1-22.3-51.9-22.3-67 0l-40.4 59.9-70.8-13.7C98 60.4 84.5 64.5 75 74.1c-9.5 9.6-13.7 23.1-11.1 36.3l13.7 71-59.8 40.5C6.6 229.5 0 242 0 255.5s6.7 26 17.8 33.5l59.8 40.5-13.7 71c-2.6 13.2 1.6 26.8 11.1 36.3 9.5 9.5 22.9 13.7 36.3 11.1l70.8-13.7 40.4 59.9C230 505.3 242.6 512 256 512s26-6.7 33.5-17.8l40.4-59.9 70.9 13.7c13.4 2.7 26.8-1.6 36.3-11.1 9.5-9.5 13.6-23.1 11.1-36.3l-13.7-71 59.8-40.5c11.1-7.5 17.8-20.1 17.8-33.5-.1-13.6-6.7-26.1-17.9-33.7zm-112.9 85.6l17.6 91.2-91-17.6L256 458l-51.9-77-90.9 17.6 17.6-91.2-76.8-52 76.8-52-17.6-91.2 91 17.6L256 53l51.9 76.9 91-17.6-17.6 91.1 76.8 52-76.8 52.1zM256 152c-57.3 0-104 46.7-104 104s46.7 104 104 104 104-46.7 104-104-46.7-104-104-104zm0 160c-30.9 0-56-25.1-56-56s25.1-56 56-56 56 25.1 56 56-25.1 56-56 56z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegSurprise(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm0-176c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64zm-48-72c0-17.7-14.3-32-32-32s-32 14.3-32 32 14.3 32 32 32 32-14.3 32-32zm128-32c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegThumbsDown(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M466.27 225.31c4.674-22.647.864-44.538-8.99-62.99 2.958-23.868-4.021-48.565-17.34-66.99C438.986 39.423 404.117 0 327 0c-7 0-15 .01-22.22.01C201.195.01 168.997 40 128 40h-10.845c-5.64-4.975-13.042-8-21.155-8H32C14.327 32 0 46.327 0 64v240c0 17.673 14.327 32 32 32h64c11.842 0 22.175-6.438 27.708-16h7.052c19.146 16.953 46.013 60.653 68.76 83.4 13.667 13.667 10.153 108.6 71.76 108.6 57.58 0 95.27-31.936 95.27-104.73 0-18.41-3.93-33.73-8.85-46.54h36.48c48.602 0 85.82-41.565 85.82-85.58 0-19.15-4.96-34.99-13.73-49.84zM64 296c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24zm330.18 16.73H290.19c0 37.82 28.36 55.37 28.36 94.54 0 23.75 0 56.73-47.27 56.73-18.91-18.91-9.46-66.18-37.82-94.54C206.9 342.89 167.28 272 138.92 272H128V85.83c53.611 0 100.001-37.82 171.64-37.82h37.82c35.512 0 60.82 17.12 53.12 65.9 15.2 8.16 26.5 36.44 13.94 57.57 21.581 20.384 18.699 51.065 5.21 65.62 9.45 0 22.36 18.91 22.27 37.81-.09 18.91-16.71 37.82-37.82 37.82z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegThumbsUp(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M466.27 286.69C475.04 271.84 480 256 480 236.85c0-44.015-37.218-85.58-85.82-85.58H357.7c4.92-12.81 8.85-28.13 8.85-46.54C366.55 31.936 328.86 0 271.28 0c-61.607 0-58.093 94.933-71.76 108.6-22.747 22.747-49.615 66.447-68.76 83.4H32c-17.673 0-32 14.327-32 32v240c0 17.673 14.327 32 32 32h64c14.893 0 27.408-10.174 30.978-23.95 44.509 1.001 75.06 39.94 177.802 39.94 7.22 0 15.22.01 22.22.01 77.117 0 111.986-39.423 112.94-95.33 13.319-18.425 20.299-43.122 17.34-66.99 9.854-18.452 13.664-40.343 8.99-62.99zm-61.75 53.83c12.56 21.13 1.26 49.41-13.94 57.57 7.7 48.78-17.608 65.9-53.12 65.9h-37.82c-71.639 0-118.029-37.82-171.64-37.82V240h10.92c28.36 0 67.98-70.89 94.54-97.46 28.36-28.36 18.91-75.63 37.82-94.54 47.27 0 47.27 32.98 47.27 56.73 0 39.17-28.36 56.72-28.36 94.54h103.99c21.11 0 37.73 18.91 37.82 37.82.09 18.9-12.82 37.81-22.27 37.81 13.489 14.555 16.371 45.236-5.21 65.62zM88 432c0 13.255-10.745 24-24 24s-24-10.745-24-24 10.745-24 24-24 24 10.745 24 24z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegTimesCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm101.8-262.2L295.6 256l62.2 62.2c4.7 4.7 4.7 12.3 0 17l-22.6 22.6c-4.7 4.7-12.3 4.7-17 0L256 295.6l-62.2 62.2c-4.7 4.7-12.3 4.7-17 0l-22.6-22.6c-4.7-4.7-4.7-12.3 0-17l62.2-62.2-62.2-62.2c-4.7-4.7-4.7-12.3 0-17l22.6-22.6c4.7-4.7 12.3-4.7 17 0l62.2 62.2 62.2-62.2c4.7-4.7 12.3-4.7 17 0l22.6 22.6c4.7 4.7 4.7 12.3 0 17z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegTired(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm129.1-303.8c-3.8-4.4-10.3-5.4-15.3-2.5l-80 48c-3.6 2.2-5.8 6.1-5.8 10.3s2.2 8.1 5.8 10.3l80 48c5.4 3.2 11.8 1.6 15.3-2.5 3.8-4.5 3.9-11 .1-15.5L343.6 208l33.6-40.3c3.8-4.5 3.7-11.1-.1-15.5zM220 208c0-4.2-2.2-8.1-5.8-10.3l-80-48c-5-3-11.5-1.9-15.3 2.5-3.8 4.5-3.9 11-.1 15.5l33.6 40.3-33.6 40.3c-3.8 4.5-3.7 11 .1 15.5 3.5 4.1 9.9 5.7 15.3 2.5l80-48c3.6-2.2 5.8-6.1 5.8-10.3zm28 64c-45.4 0-100.9 38.3-107.8 93.3-1.5 11.8 6.9 21.6 15.5 17.9C178.4 373.5 212 368 248 368s69.6 5.5 92.3 15.2c8.5 3.7 17-6 15.5-17.9-6.9-55-62.4-93.3-107.8-93.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegTrashAlt(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M268 416h24a12 12 0 0 0 12-12V188a12 12 0 0 0-12-12h-24a12 12 0 0 0-12 12v216a12 12 0 0 0 12 12zM432 80h-82.41l-34-56.7A48 48 0 0 0 274.41 0H173.59a48 48 0 0 0-41.16 23.3L98.41 80H16A16 16 0 0 0 0 96v16a16 16 0 0 0 16 16h16v336a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128h16a16 16 0 0 0 16-16V96a16 16 0 0 0-16-16zM171.84 50.91A6 6 0 0 1 177 48h94a6 6 0 0 1 5.15 2.91L293.61 80H154.39zM368 464H80V128h288zm-212-48h24a12 12 0 0 0 12-12V188a12 12 0 0 0-12-12h-24a12 12 0 0 0-12 12v216a12 12 0 0 0 12 12z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegUserCircle(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 104c-53 0-96 43-96 96s43 96 96 96 96-43 96-96-43-96-96-96zm0 144c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm0-240C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-49.7 0-95.1-18.3-130.1-48.4 14.9-23 40.4-38.6 69.6-39.5 20.8 6.4 40.6 9.6 60.5 9.6s39.7-3.1 60.5-9.6c29.2 1 54.7 16.5 69.6 39.5-35 30.1-80.4 48.4-130.1 48.4zm162.7-84.1c-24.4-31.4-62.1-51.9-105.1-51.9-10.2 0-26 9.6-57.6 9.6-31.5 0-47.4-9.6-57.6-9.6-42.9 0-80.6 20.5-105.1 51.9C61.9 339.2 48 299.2 48 256c0-110.3 89.7-200 200-200s200 89.7 200 200c0 43.2-13.9 83.2-37.3 115.9z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegUser(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M313.6 304c-28.7 0-42.5 16-89.6 16-47.1 0-60.8-16-89.6-16C60.2 304 0 364.2 0 438.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-25.6c0-74.2-60.2-134.4-134.4-134.4zM400 464H48v-25.6c0-47.6 38.8-86.4 86.4-86.4 14.6 0 38.3 16 89.6 16 51.7 0 74.9-16 89.6-16 47.6 0 86.4 38.8 86.4 86.4V464zM224 288c79.5 0 144-64.5 144-144S303.5 0 224 0 80 64.5 80 144s64.5 144 144 144zm0-240c52.9 0 96 43.1 96 96s-43.1 96-96 96-96-43.1-96-96 43.1-96 96-96z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegWindowClose(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm0 394c0 3.3-2.7 6-6 6H54c-3.3 0-6-2.7-6-6V86c0-3.3 2.7-6 6-6h404c3.3 0 6 2.7 6 6v340zM356.5 194.6L295.1 256l61.4 61.4c4.6 4.6 4.6 12.1 0 16.8l-22.3 22.3c-4.6 4.6-12.1 4.6-16.8 0L256 295.1l-61.4 61.4c-4.6 4.6-12.1 4.6-16.8 0l-22.3-22.3c-4.6-4.6-4.6-12.1 0-16.8l61.4-61.4-61.4-61.4c-4.6-4.6-4.6-12.1 0-16.8l22.3-22.3c4.6-4.6 12.1-4.6 16.8 0l61.4 61.4 61.4-61.4c4.6-4.6 12.1-4.6 16.8 0l22.3 22.3c4.7 4.6 4.7 12.1 0 16.8z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegWindowMaximize(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm0 394c0 3.3-2.7 6-6 6H54c-3.3 0-6-2.7-6-6V192h416v234z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegWindowMinimize(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 480H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h448c17.7 0 32 14.3 32 32s-14.3 32-32 32z"
                },
                "child": []
            }
        ]
    })(props);
}
function FaRegWindowRestore(props) {
    return (0, _indexMjs.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 0H144c-26.5 0-48 21.5-48 48v48H48c-26.5 0-48 21.5-48 48v320c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48v-48h48c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm-96 464H48V256h320v208zm96-96h-48V144c0-26.5-21.5-48-48-48H144V48h320v320z"
                },
                "child": []
            }
        ]
    })(props);
}

},{"../lib/index.mjs":"8wKgn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8wKgn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _iconsManifestMjs = require("./iconsManifest.mjs");
parcelHelpers.exportAll(_iconsManifestMjs, exports);
var _iconBaseMjs = require("./iconBase.mjs");
parcelHelpers.exportAll(_iconBaseMjs, exports);
var _iconContextMjs = require("./iconContext.mjs");
parcelHelpers.exportAll(_iconContextMjs, exports);

},{"./iconsManifest.mjs":"kxr7r","./iconBase.mjs":"j8cIQ","./iconContext.mjs":"6W6af","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kxr7r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconsManifest", ()=>IconsManifest);
var IconsManifest = [
    {
        "id": "ci",
        "name": "Circum Icons",
        "projectUrl": "https://circumicons.com/",
        "license": "MPL-2.0 license",
        "licenseUrl": "https://github.com/Klarr-Agency/Circum-Icons/blob/main/LICENSE"
    },
    {
        "id": "fa",
        "name": "Font Awesome 5",
        "projectUrl": "https://fontawesome.com/",
        "license": "CC BY 4.0 License",
        "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
    },
    {
        "id": "fa6",
        "name": "Font Awesome 6",
        "projectUrl": "https://fontawesome.com/",
        "license": "CC BY 4.0 License",
        "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
    },
    {
        "id": "io",
        "name": "Ionicons 4",
        "projectUrl": "https://ionicons.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
    },
    {
        "id": "io5",
        "name": "Ionicons 5",
        "projectUrl": "https://ionicons.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
    },
    {
        "id": "md",
        "name": "Material Design icons",
        "projectUrl": "http://google.github.io/material-design-icons/",
        "license": "Apache License Version 2.0",
        "licenseUrl": "https://github.com/google/material-design-icons/blob/master/LICENSE"
    },
    {
        "id": "ti",
        "name": "Typicons",
        "projectUrl": "http://s-ings.com/typicons/",
        "license": "CC BY-SA 3.0",
        "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/"
    },
    {
        "id": "go",
        "name": "Github Octicons icons",
        "projectUrl": "https://octicons.github.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/primer/octicons/blob/master/LICENSE"
    },
    {
        "id": "fi",
        "name": "Feather",
        "projectUrl": "https://feathericons.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/feathericons/feather/blob/master/LICENSE"
    },
    {
        "id": "lu",
        "name": "Lucide",
        "projectUrl": "https://lucide.dev/",
        "license": "ISC",
        "licenseUrl": "https://github.com/lucide-icons/lucide/blob/main/LICENSE"
    },
    {
        "id": "gi",
        "name": "Game Icons",
        "projectUrl": "https://game-icons.net/",
        "license": "CC BY 3.0",
        "licenseUrl": "https://creativecommons.org/licenses/by/3.0/"
    },
    {
        "id": "wi",
        "name": "Weather Icons",
        "projectUrl": "https://erikflowers.github.io/weather-icons/",
        "license": "SIL OFL 1.1",
        "licenseUrl": "http://scripts.sil.org/OFL"
    },
    {
        "id": "di",
        "name": "Devicons",
        "projectUrl": "https://vorillaz.github.io/devicons/",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "ai",
        "name": "Ant Design Icons",
        "projectUrl": "https://github.com/ant-design/ant-design-icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "bs",
        "name": "Bootstrap Icons",
        "projectUrl": "https://github.com/twbs/icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "ri",
        "name": "Remix Icon",
        "projectUrl": "https://github.com/Remix-Design/RemixIcon",
        "license": "Apache License Version 2.0",
        "licenseUrl": "http://www.apache.org/licenses/"
    },
    {
        "id": "fc",
        "name": "Flat Color Icons",
        "projectUrl": "https://github.com/icons8/flat-color-icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "gr",
        "name": "Grommet-Icons",
        "projectUrl": "https://github.com/grommet/grommet-icons",
        "license": "Apache License Version 2.0",
        "licenseUrl": "http://www.apache.org/licenses/"
    },
    {
        "id": "hi",
        "name": "Heroicons",
        "projectUrl": "https://github.com/tailwindlabs/heroicons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "hi2",
        "name": "Heroicons 2",
        "projectUrl": "https://github.com/tailwindlabs/heroicons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "si",
        "name": "Simple Icons",
        "projectUrl": "https://simpleicons.org/",
        "license": "CC0 1.0 Universal",
        "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/"
    },
    {
        "id": "sl",
        "name": "Simple Line Icons",
        "projectUrl": "https://thesabbir.github.io/simple-line-icons/",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "im",
        "name": "IcoMoon Free",
        "projectUrl": "https://github.com/Keyamoon/IcoMoon-Free",
        "license": "CC BY 4.0 License",
        "licenseUrl": "https://github.com/Keyamoon/IcoMoon-Free/blob/master/License.txt"
    },
    {
        "id": "bi",
        "name": "BoxIcons",
        "projectUrl": "https://github.com/atisawd/boxicons",
        "license": "MIT",
        "licenseUrl": "https://github.com/atisawd/boxicons/blob/master/LICENSE"
    },
    {
        "id": "cg",
        "name": "css.gg",
        "projectUrl": "https://github.com/astrit/css.gg",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "vsc",
        "name": "VS Code Icons",
        "projectUrl": "https://github.com/microsoft/vscode-codicons",
        "license": "CC BY 4.0",
        "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
    },
    {
        "id": "tb",
        "name": "Tabler Icons",
        "projectUrl": "https://github.com/tabler/tabler-icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "tfi",
        "name": "Themify Icons",
        "projectUrl": "https://github.com/lykmapipo/themify-icons",
        "license": "MIT",
        "licenseUrl": "https://github.com/thecreation/standard-icons/blob/master/modules/themify-icons/LICENSE"
    },
    {
        "id": "rx",
        "name": "Radix Icons",
        "projectUrl": "https://icons.radix-ui.com",
        "license": "MIT",
        "licenseUrl": "https://github.com/radix-ui/icons/blob/master/LICENSE"
    },
    {
        "id": "pi",
        "name": "Phosphor Icons",
        "projectUrl": "https://github.com/phosphor-icons/core",
        "license": "MIT",
        "licenseUrl": "https://github.com/phosphor-icons/core/blob/main/LICENSE"
    },
    {
        "id": "lia",
        "name": "Icons8 Line Awesome",
        "projectUrl": "https://icons8.com/line-awesome",
        "license": "MIT",
        "licenseUrl": "https://github.com/icons8/line-awesome/blob/master/LICENSE.md"
    }
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"j8cIQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GenIcon", ()=>GenIcon);
parcelHelpers.export(exports, "IconBase", ()=>IconBase);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _iconContextMjs = require("./iconContext.mjs");
var _excluded = [
    "attr",
    "size",
    "title"
];
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function Tree2Element(tree) {
    return tree && tree.map((node, i)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(node.tag, _objectSpread({
            key: i
        }, node.attr), Tree2Element(node.child)));
}
function GenIcon(data) {
    return (props)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(IconBase, _extends({
            attr: _objectSpread({}, data.attr)
        }, props), Tree2Element(data.child));
}
function IconBase(props) {
    var elem = (conf)=>{
        var { attr, size, title } = props, svgProps = _objectWithoutProperties(props, _excluded);
        var computedSize = size || conf.size || "1em";
        var className;
        if (conf.className) className = conf.className;
        if (props.className) className = (className ? className + " " : "") + props.className;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
            stroke: "currentColor",
            fill: "currentColor",
            strokeWidth: "0"
        }, conf.attr, attr, svgProps, {
            className: className,
            style: _objectSpread(_objectSpread({
                color: props.color || conf.color
            }, conf.style), props.style),
            height: computedSize,
            width: computedSize,
            xmlns: "http://www.w3.org/2000/svg"
        }), title && /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title), props.children);
    };
    return (0, _iconContextMjs.IconContext) !== undefined ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconContextMjs.IconContext).Consumer, null, (conf)=>elem(conf)) : elem((0, _iconContextMjs.DefaultContext));
}

},{"react":"bmhQu","./iconContext.mjs":"6W6af","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6W6af":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DefaultContext", ()=>DefaultContext);
parcelHelpers.export(exports, "IconContext", ()=>IconContext);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var DefaultContext = {
    color: undefined,
    size: undefined,
    className: undefined,
    style: undefined,
    attr: undefined
};
var IconContext = (0, _reactDefault.default).createContext && /*#__PURE__*/ (0, _reactDefault.default).createContext(DefaultContext);

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lHgQj":[function(require,module,exports,__globalThis) {
module.exports = import("h9hcI").then(()=>module.bundle.root('ciqYm'));

},{}],"5MC16":[function(require,module,exports,__globalThis) {
module.exports = import("juwUs").then(()=>module.bundle.root('kjQ5B'));

},{}],"8DAun":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _headerMenuDefault = require("../HeaderMenuDefault");
var _headerMenuDefaultDefault = parcelHelpers.interopDefault(_headerMenuDefault);
var _frame1 = require("../Frame1");
var _frame1Default = parcelHelpers.interopDefault(_frame1);
var _frame12 = require("../Frame12");
var _frame12Default = parcelHelpers.interopDefault(_frame12);
var _homeCss = require("./Home.css");
function Home(props) {
    const { x1200PxLogo_Icam__20081, takeYourCompanyToTheNextLevel, discoverFromDiffer, headerMenuDefaultProps, frame11Props, frame12Props } = props;
    const handleNavigation = (path)=>{
        window.location.href = path; // Utilisation de window.location.href pour rediriger
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("form", {
            className: "home screen",
            name: "form5",
            action: "form5",
            method: "post",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex-row-4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex-col-2",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-1",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1",
                                onClick: ()=>handleNavigation("/home")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "overlap-group2-1",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                        className: "take-your-company-to-the-next-level valign-text-middle",
                                        children: takeYourCompanyToTheNextLevel
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "discover-from-differ",
                                        children: discoverFromDiffer
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "frame-2-1",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefaultDefault.default), {
                                    children: headerMenuDefaultProps.children
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "flex-col-3",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "overlap-group-container",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "overlap-group1-18",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "frame-3",
                                            onClick: ()=>handleNavigation("/acquisition"),
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1Default.default), {
                                                src: frame11Props.src
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "new-case valign-text-middle poppins-medium-mine-shaft-24px",
                                            onClick: ()=>handleNavigation("/acquisition"),
                                            children: "NEW COMPANY"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "overlap-group4-1",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "group-79",
                                            onClick: ()=>handleNavigation("/existing-case"),
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame12Default.default), {})
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "group-80",
                                            onClick: ()=>handleNavigation("/existing-case"),
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1Default.default), {
                                                src: frame12Props.src,
                                                className: frame12Props.className
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "existing-case-62 valign-text-middle poppins-medium-mine-shaft-24px",
                                            onClick: ()=>handleNavigation("/existing-case"),
                                            children: "EXISTING COMPANY"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
}
exports.default = Home;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","../HeaderMenuDefault":"bD1BI","../Frame1":"kmC9Z","../Frame12":"2U3RV","./Home.css":"jDspG","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bD1BI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _headerMenuDefaultCss = require("./HeaderMenuDefault.css");
function HeaderMenuDefault(props) {
    const { children, className } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `menu-item-default ${className || ""}`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "label-4 inter-medium-cultured-pearl-14px",
            children: children
        })
    });
}
exports.default = HeaderMenuDefault;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./HeaderMenuDefault.css":"8XyW3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8XyW3":[function() {},{}],"kmC9Z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame1Css = require("./Frame1.css");
function Frame1(props) {
    const { src, className } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `frame-5-1 ${className || ""}`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            className: "unsplashym-m-sbz0ro",
            src: src,
            alt: "unsplash:ym--mSBZ0ro"
        })
    });
}
exports.default = Frame1;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./Frame1.css":"80Db5","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"80Db5":[function() {},{}],"2U3RV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame12Css = require("./Frame12.css");
function Frame12() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
        href: "#rectangle-2",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "frame-6-2"
        })
    });
}
exports.default = Frame12;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./Frame12.css":"f4Ean","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"f4Ean":[function() {},{}],"jDspG":[function() {},{}],"3zeVr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FunctionalView1);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _html2Canvas = require("html2canvas");
var _html2CanvasDefault = parcelHelpers.interopDefault(_html2Canvas);
var _jspdf = require("jspdf");
var _functionalView1Css = require("./FunctionalView1.css");
/* === Toolbar Component === */ function Toolbar({ onImport, onExport }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "toolbar",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                onClick: onImport,
                children: "\uD83D\uDCBE Import your diagram"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                onClick: onExport,
                children: "\uD83D\uDCBE Export your diagram"
            })
        ]
    });
}
function FunctionalView1() {
    const iframeRef = (0, _react.useRef)(null);
    const history = (0, _reactRouterDom.useHistory)();
    const [downloading, setDownloading] = (0, _react.useState)(false);
    const [message, setMessage] = (0, _react.useState)("");
    // 🔄 Reset the diagram in the iframe
    const handleReset = ()=>{
        if (iframeRef.current) iframeRef.current.src = iframeRef.current.src;
    };
    // 📥 Import help
    const handleImport = ()=>{
        alert("\uD83D\uDCC2 To import a diagram, use the menu \u2018File > Open Project\u2019 inside Visual Paradigm.");
    };
    // 💾 Export help
    const handleExport = ()=>{
        alert("\uD83D\uDCBE To export your diagram, use \u2018File > Export > PDF/PNG\u2019 inside Visual Paradigm.");
    };
    // 📄 Capture PDF
    const handleDownloadPDF = (0, _react.useCallback)(async ()=>{
        try {
            const element = document.querySelector(".vp-container");
            if (!element) {
                alert("\u274C Unable to find the area to capture!");
                return;
            }
            setDownloading(true);
            window.scrollTo(0, 0);
            document.body.classList.add("no-animations");
            await new Promise((resolve)=>setTimeout(resolve, 500));
            const canvas = await (0, _html2CanvasDefault.default)(element, {
                scale: 3,
                backgroundColor: "#ffffff",
                useCORS: true,
                allowTaint: true
            });
            document.body.classList.remove("no-animations");
            // 🎨 Light color/contrast enhancement
            const ctx = canvas.getContext("2d");
            const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
            const data = imageData.data;
            for(let i = 0; i < data.length; i += 4){
                data[i] = Math.min(data[i] * 1.05 + 8, 255);
                data[i + 1] = Math.min(data[i + 1] * 1.05 + 8, 255);
                data[i + 2] = Math.min(data[i + 2] * 1.05 + 8, 255);
            }
            ctx.putImageData(imageData, 0, 0);
            // 🧾 Create PDF
            const imgData = canvas.toDataURL("image/png", 1.0);
            const pdf = new (0, _jspdf.jsPDF)("p", "mm", "a4");
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = pdf.internal.pageSize.getHeight();
            const imgWidth = canvas.width;
            const imgHeight = canvas.height;
            const ratio = pdfWidth / imgWidth;
            const newHeight = imgHeight * ratio;
            let position = 0;
            while(position < newHeight){
                pdf.addImage(imgData, "PNG", 0, -position, pdfWidth, newHeight);
                position += pdfHeight;
                if (position < newHeight) pdf.addPage();
            }
            const fileName = `Functional-view-activity-${new Date().toISOString().split("T")[0]}.pdf`;
            pdf.save(fileName);
            setMessage("\u2705 Full capture saved to your downloads!");
            setDownloading(false);
            // 🔁 Automatic redirect
            setTimeout(()=>{
                history.push("/process-view-1");
            }, 1500);
        } catch (error) {
            console.error("\uD83D\uDEA8 Capture error:", error);
            alert("Error during PDF generation: " + (error.message || error));
            setDownloading(false);
        }
    }, [
        history
    ]);
    // === Render ===
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "vp-wrapper",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "functional-intro",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                children: "\u2699\uFE0F Functional View \u2013 Activity Diagram"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                children: [
                                    "The ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                        children: "functional view"
                                    }),
                                    " illustrates the main activities and internal processes of the system. It highlights the sequence of actions, decisions, and the processing logic used to achieve the project\u2019s key functions."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(Toolbar, {
                        onImport: handleImport,
                        onExport: handleExport,
                        onReset: handleReset,
                        onDownload: handleDownloadPDF,
                        downloading: downloading
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "vp-container",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("iframe", {
                            ref: iframeRef,
                            title: "Visual Paradigm \u2013 Functional View",
                            className: "vp-editor-frame",
                            src: "https://online.visual-paradigm.com/app/diagrams/#diagram:proj=0&type=ActivityDiagram&width=11&height=8.5&unit=inch",
                            allowFullScreen: true
                        })
                    })
                ]
            }),
            message && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                style: {
                    textAlign: "center",
                    color: message.startsWith("\u2705") ? "green" : "black",
                    marginTop: "10px",
                    fontWeight: 500
                },
                children: message
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "icam-navigation",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                        to: "/pdf-uploader",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            className: "icam-nav-btn",
                            children: "Back"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                        to: "/process-view-1",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            className: "icam-nav-btn",
                            children: "Continue"
                        })
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["Link","b9X5n"],["useHistory","ditZI"]],"html2canvas":"3eyQ5","jspdf":"hkJ4Q","./FunctionalView1.css":"HueWj","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"HueWj":[function() {},{}],"h8aqW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "company_name", ()=>company_name);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _acquisitionCss = require("./Acquisition.css");
var _enterpriseContext = require("../../context/EnterpriseContext");
let company_name = "";
// List of business activity sectors
const ACTIVITY_SECTORS = [
    "Agriculture, forestry and fishing",
    "Mining and quarrying",
    "Manufacturing industry",
    "Electricity, gas production and distribution",
    "Water production and distribution, sanitation",
    "Construction",
    "Trade, repair of motor vehicles and motorcycles",
    "Transport and storage",
    "Accommodation and food service activities",
    "Information and communication",
    "Financial and insurance activities",
    "Real estate activities",
    "Professional, scientific and technical activities",
    "Administrative and support service activities",
    "Public administration",
    "Education",
    "Human health and social work",
    "Arts, entertainment and recreation",
    "Other service activities",
    "Activities of households as employers",
    "Extraterritorial activities"
];
function Acquisition(props) {
    const { companyName, inputPlaceholder1, companySize, inputPlaceholder2, activitySector, inputPlaceholder3, measuringForm } = props;
    const { companyName: contextCompanyName, setCompanyName, companySize: contextCompanySize, setCompanySize, activitySector: contextActivitySector, setActivitySector, saveEnterpriseData } = (0, _enterpriseContext.useEnterprise)();
    const [companyNameValue, setCompanyNameValue] = (0, _react.useState)(contextCompanyName || "");
    const [companySizeValue, setCompanySizeValue] = (0, _react.useState)(contextCompanySize || "");
    const [activitySectorValue, setActivitySectorValue] = (0, _react.useState)(contextActivitySector || "");
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const [error, setError] = (0, _react.useState)("");
    const [success, setSuccess] = (0, _react.useState)("");
    const history = (0, _reactRouterDom.useHistory)();
    // ✅ Form validation
    function validateForm() {
        if (!companyNameValue.trim()) {
            setError("The company name is required");
            return false;
        }
        if (!companySizeValue || isNaN(companySizeValue) || companySizeValue <= 0) {
            setError("The company size must be a positive number");
            return false;
        }
        if (!activitySectorValue.trim()) {
            setError("The activity sector is required");
            return false;
        }
        return true;
    }
    // ✅ Main save function
    async function updateDataFromInput() {
        setError("");
        setSuccess("");
        if (!validateForm()) return;
        setCompanyName(companyNameValue);
        setCompanySize(parseInt(companySizeValue, 10));
        setActivitySector(activitySectorValue);
        company_name = companyNameValue; // global export
        const data = {
            company_name: companyNameValue,
            company_size: parseInt(companySizeValue, 10),
            activity_sector: activitySectorValue
        };
        setIsLoading(true);
        try {
            // Call through the Enterprise context
            const result = await saveEnterpriseData(data);
            console.log("\uD83D\uDCE5 Result of saveEnterpriseData:", result);
            if (result.success) {
                setSuccess("\u2705 Data saved successfully!");
                localStorage.setItem("enterprise_id", result.enterpriseId);
                // Redirect to the form after 1s
                setTimeout(()=>{
                    history.push("/measuring-form");
                }, 1000);
            } else throw new Error(result.error || "Error while saving the data");
        } catch (error) {
            console.error("\u274C Save error:", error);
            setError(error.message || "Error while saving. Please try again.");
        } finally{
            setIsLoading(false);
        }
    }
    // Navigation
    function navigateToMeasuringForm() {
        history.push("/measuring-form");
    }
    function navigateToHome() {
        history.push("/home");
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "acquisition-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "acquisition-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    className: "acquisition-title",
                    children: "Company Information"
                }),
                error && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "error-message",
                    children: [
                        "\u274C ",
                        error
                    ]
                }),
                success && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "success-message",
                    children: success
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "acquisition-form",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "form-group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                    htmlFor: "companyName",
                                    children: companyName || "Company Name"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    id: "companyName",
                                    className: "form-input",
                                    name: "companyName",
                                    placeholder: inputPlaceholder1 || "Enter company name",
                                    type: "text",
                                    value: companyNameValue,
                                    onChange: (e)=>setCompanyNameValue(e.target.value),
                                    required: true
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "form-group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                    htmlFor: "companySize",
                                    children: companySize || "Company Size"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    id: "companySize",
                                    className: "form-input",
                                    name: "companySize",
                                    placeholder: inputPlaceholder2 || "Enter number of employees",
                                    type: "number",
                                    value: companySizeValue,
                                    onChange: (e)=>setCompanySizeValue(e.target.value),
                                    required: true
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "form-group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                    htmlFor: "activitySector",
                                    children: activitySector || "Activity Sector"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("select", {
                                    id: "activitySector",
                                    className: "form-select",
                                    name: "activitySector",
                                    value: activitySectorValue,
                                    onChange: (e)=>setActivitySectorValue(e.target.value),
                                    required: true,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                            value: "",
                                            disabled: true,
                                            children: "Select an activity sector"
                                        }),
                                        ACTIVITY_SECTORS.map((sector, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                                value: sector,
                                                children: sector
                                            }, index))
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "form-actions",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    onClick: updateDataFromInput,
                                    className: "btn-primary",
                                    disabled: isLoading,
                                    children: isLoading ? "\u23F3 Saving..." : "\uD83D\uDCBE Save Data"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    onClick: navigateToMeasuringForm,
                                    className: "btn-secondary",
                                    children: measuringForm || "\u27A1\uFE0F Continue to Measuring Form"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    onClick: navigateToHome,
                                    className: "btn-tertiary",
                                    children: "\u2B05\uFE0F Back to Home"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Acquisition;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"ditZI","./Acquisition.css":"9i0GT","../../context/EnterpriseContext":"jRUQi","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9i0GT":[function() {},{}],"gSchW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FunctionalView1);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _html2Canvas = require("html2canvas");
var _html2CanvasDefault = parcelHelpers.interopDefault(_html2Canvas);
var _jspdf = require("jspdf");
var _physicalModel1Css = require("./PhysicalModel1.css");
/* === Toolbar (separate component) === */ function Toolbar({ onImport, onExport, onReset, onDownload, downloading }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "toolbar",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                onClick: onImport,
                children: "\uD83D\uDCBE Import your diagram"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                onClick: onExport,
                children: "\uD83D\uDCBE Export your diagram"
            })
        ]
    });
}
function FunctionalView1() {
    const iframeRef = (0, _react.useRef)(null);
    const history = (0, _reactRouterDom.useHistory)();
    const [downloading, setDownloading] = (0, _react.useState)(false);
    const [message, setMessage] = (0, _react.useState)("");
    // 🔄 Reset diagram
    const handleReset = ()=>{
        if (iframeRef.current) iframeRef.current.src = iframeRef.current.src;
    };
    // 📥 Import alert
    const handleImport = ()=>{
        alert("\uD83D\uDCC2 To import a diagram, use 'File > Open Project' inside Visual Paradigm.");
    };
    // 💾 Export alert
    const handleExport = ()=>{
        alert("\uD83D\uDCBE To export your diagram, use 'File > Export > PDF/PNG' inside Visual Paradigm.");
    };
    // 📄 Capture PDF
    const handleDownloadPDF = (0, _react.useCallback)(async ()=>{
        try {
            const element = document.querySelector(".vp-container");
            if (!element) {
                alert("\u274C Unable to find the area to capture!");
                return;
            }
            setDownloading(true);
            window.scrollTo(0, 0);
            document.body.classList.add("no-animations");
            await new Promise((resolve)=>setTimeout(resolve, 500));
            const canvas = await (0, _html2CanvasDefault.default)(element, {
                scale: 3,
                backgroundColor: "#ffffff",
                useCORS: true,
                allowTaint: true
            });
            document.body.classList.remove("no-animations");
            // 🎨 Contrast enhancement
            const ctx = canvas.getContext("2d");
            const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
            const data = imageData.data;
            for(let i = 0; i < data.length; i += 4){
                data[i] = Math.min(data[i] * 1.05 + 8, 255);
                data[i + 1] = Math.min(data[i + 1] * 1.05 + 8, 255);
                data[i + 2] = Math.min(data[i + 2] * 1.05 + 8, 255);
            }
            ctx.putImageData(imageData, 0, 0);
            // 🧾 Create PDF
            const imgData = canvas.toDataURL("image/png", 1.0);
            const pdf = new (0, _jspdf.jsPDF)("p", "mm", "a4");
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = pdf.internal.pageSize.getHeight();
            const imgWidth = canvas.width;
            const imgHeight = canvas.height;
            const ratio = pdfWidth / imgWidth;
            const newHeight = imgHeight * ratio;
            let position = 0;
            while(position < newHeight){
                pdf.addImage(imgData, "PNG", 0, -position, pdfWidth, newHeight);
                position += pdfHeight;
                if (position < newHeight) pdf.addPage();
            }
            const fileName = `Functional-view-activity-${new Date().toISOString().split("T")[0]}.pdf`;
            pdf.save(fileName);
            setMessage("\u2705 Full capture saved in your Downloads folder!");
            setDownloading(false);
            // 🔁 Auto-redirect
            setTimeout(()=>{
                history.push("/process-view-1");
            }, 1500);
        } catch (error) {
            console.error("\uD83D\uDEA8 Capture error:", error);
            alert("Error during PDF generation: " + (error.message || error));
            setDownloading(false);
        }
    }, [
        history
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "vp-wrapper",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "functional-intro",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                children: "\u2699\uFE0F Functional View \u2013 Activity Diagram"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                children: [
                                    "The ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                        children: "functional view"
                                    }),
                                    " illustrates the main activities and internal processes of the system. It highlights the sequence of actions, decisions, and logic that define the key operations of the project."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(Toolbar, {
                        onImport: handleImport,
                        onExport: handleExport,
                        onReset: handleReset,
                        onDownload: handleDownloadPDF,
                        downloading: downloading
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "vp-container",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("iframe", {
                            ref: iframeRef,
                            title: "Visual Paradigm \u2013 Functional View",
                            className: "vp-editor-frame",
                            src: "https://online.visual-paradigm.com/app/diagrams/#diagram:proj=0&type=ActivityDiagram&width=11&height=8.5&unit=inch",
                            allowFullScreen: true
                        })
                    })
                ]
            }),
            message && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                style: {
                    textAlign: "center",
                    color: message.startsWith("\u2705") ? "green" : "black",
                    marginTop: "10px",
                    fontWeight: 500
                },
                children: message
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "icam-navigation",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                        to: "/process-view-1",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            className: "icam-nav-btn",
                            children: "Back"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                        to: "/decisional-model-1",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            className: "icam-nav-btn",
                            children: "Continue"
                        })
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["Link","b9X5n"],["useHistory","ditZI"]],"html2canvas":"3eyQ5","jspdf":"hkJ4Q","./PhysicalModel1.css":"jAwVw","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jAwVw":[function() {},{}],"7Tp7Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ExistingCompanies);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _existingCaseCss = require("./ExistingCase.css");
/* ----------------------------------------------------
   à°Å¸â€�Â¹ Company Card (ONE COMPANY)
---------------------------------------------------- */ const CompanyCard = /*#__PURE__*/ (0, _reactDefault.default).memo(({ company })=>{
    const formatDate = (date)=>{
        if (!date) return "Unknown date";
        return new Date(date).toLocaleDateString("en-US");
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "case-card",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                children: company.company_name
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "case-details",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                children: "Sector:"
                            }),
                            " ",
                            company.activity_sector || "Not specified"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                children: "Size:"
                            }),
                            " ",
                            company.company_size || "Not specified",
                            " employees"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                children: "Added:"
                            }),
                            " ",
                            formatDate(company.date_added)
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                to: `/company-cases/${company._id}`,
                className: "view-case-btn",
                children: "View Company Cases"
            })
        ]
    });
});
/* ----------------------------------------------------
    Search bar
---------------------------------------------------- */ const SearchBar = /*#__PURE__*/ (0, _reactDefault.default).memo(({ onSearch })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "search-bar",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                type: "text",
                placeholder: "Search a company...",
                onChange: (e)=>onSearch(e.target.value),
                className: "search-input"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "search-icon"
            })
        ]
    });
});
/* ----------------------------------------------------
   à°Å¸â€�Å½ Filter by sector
---------------------------------------------------- */ const FilterBar = /*#__PURE__*/ (0, _reactDefault.default).memo(({ sectors, onFilter })=>{
    const [active, setActive] = (0, _react.useState)("all");
    const choose = (sector)=>{
        setActive(sector);
        onFilter(sector);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "filter-bar",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "filter-label",
                children: "Filter by sector:"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "filter-options",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: `filter-btn ${active === "all" ? "active" : ""}`,
                        onClick: ()=>choose("all"),
                        children: "All"
                    }),
                    sectors.map((sec, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            className: `filter-btn ${active === sec ? "active" : ""}`,
                            onClick: ()=>choose(sec),
                            children: sec
                        }, idx))
                ]
            })
        ]
    });
});
/* ----------------------------------------------------
   à°Å¸â€�Â¢ Pagination
---------------------------------------------------- */ const Pagination = /*#__PURE__*/ (0, _reactDefault.default).memo(({ total, perPage, current, onChange })=>{
    const totalPages = Math.ceil(total / perPage);
    if (totalPages <= 1) return null;
    const pages = [
        ...Array(totalPages).keys()
    ].map((n)=>n + 1);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "pagination",
        children: pages.map((page)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                className: `pagination-number ${page === current ? "active" : ""}`,
                onClick: ()=>onChange(page),
                children: page
            }, page))
    });
});
function ExistingCompanies() {
    const [companies, setCompanies] = (0, _react.useState)([]);
    const [filtered, setFiltered] = (0, _react.useState)([]);
    const [loading, setLoading] = (0, _react.useState)(true);
    const [search, setSearch] = (0, _react.useState)("");
    const [filterSector, setFilterSector] = (0, _react.useState)("all");
    const [page, setPage] = (0, _react.useState)(1);
    const perPage = 6;
    /* -----------------------------------------
     1à¯Â¸Â�à¢Æ’Â£ Fetch all enterprises from MongoDB
  ----------------------------------------- */ const fetchCompanies = (0, _react.useCallback)(async ()=>{
        try {
            setLoading(true);
            const res = await fetch(`${"/api"}/api/enterprises`, {
                headers: {
                    "ngrok-skip-browser-warning": "true"
                }
            });
            const data = await res.json();
            console.log("API enterprises \xe0\xa2\xe2\u20AC\xa0\xe2\u20AC\u2122", data);
            // à°Å¸â€�Â¥ Universal safe extraction
            const list = Array.isArray(data) ? data : Array.isArray(data.enterprises) ? data.enterprises : Array.isArray(data.data) ? data.data : data.found && Array.isArray(data.items) ? data.items : [];
            setCompanies(list);
            setFiltered(list);
            setLoading(false);
        } catch (err) {
            console.error("Error fetching enterprises:", err);
            setCompanies([]);
            setFiltered([]);
            setLoading(false);
        }
    }, []);
    (0, _react.useEffect)(()=>{
        fetchCompanies();
    }, [
        fetchCompanies
    ]);
    /* -----------------------------------------
     2à¯Â¸Â�à¢Æ’Â£ Compute unique sectors
  ----------------------------------------- */ const sectors = (0, _react.useMemo)(()=>{
        if (!Array.isArray(companies)) return [];
        return [
            ...new Set(companies.map((c)=>c.activity_sector))
        ].filter(Boolean);
    }, [
        companies
    ]);
    /* -----------------------------------------
     3à¯Â¸Â�à¢Æ’Â£ Apply search + filter
  ----------------------------------------- */ (0, _react.useEffect)(()=>{
        let list = [
            ...companies
        ];
        if (filterSector !== "all") list = list.filter((c)=>c.activity_sector === filterSector);
        if (search.trim()) {
            const s = search.toLowerCase();
            list = list.filter((c)=>c.company_name.toLowerCase().includes(s));
        }
        setFiltered(list);
        setPage(1);
    }, [
        companies,
        search,
        filterSector
    ]);
    /* -----------------------------------------
     4à¯Â¸Â�à¢Æ’Â£ Paginate
  ----------------------------------------- */ const paginated = (0, _react.useMemo)(()=>{
        const start = (page - 1) * perPage;
        return filtered.slice(start, start + perPage);
    }, [
        filtered,
        page
    ]);
    /* -----------------------------------------
     5à¯Â¸Â�à¢Æ’Â£ Render
  ----------------------------------------- */ return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "existing-case-63 screen",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "main-content",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "page-header",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                className: "page-title",
                                children: "Existing Companies"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "new-case-container",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                    to: "/acquisition",
                                    className: "create-new-btn",
                                    children: "New Company"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "controls-container",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SearchBar, {
                                onSearch: setSearch
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: "refresh-btn",
                                onClick: fetchCompanies,
                                children: "Refresh"
                            })
                        ]
                    }),
                    filtered.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)(FilterBar, {
                        sectors: sectors,
                        onFilter: setFilterSector
                    }),
                    loading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "loading-message",
                        children: "Loading companies..."
                    }) : filtered.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "no-results-message",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                children: "No companies match your criteria."
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: "reset-filters-btn",
                                onClick: ()=>{
                                    setSearch("");
                                    setFilterSector("all");
                                },
                                children: "Reset filters"
                            })
                        ]
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "cases-grid",
                                children: paginated.map((company)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(CompanyCard, {
                                        company: company
                                    }, company._id))
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Pagination, {
                                total: filtered.length,
                                perPage: perPage,
                                current: page,
                                onChange: setPage
                            })
                        ]
                    })
                ]
            })
        })
    });
}

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"b9X5n","./ExistingCase.css":"jxqRr","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jxqRr":[function() {},{}],"9qNYl":[function(require,module,exports,__globalThis) {
// src/components/DecisionalModel1/index.jsx
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _html2Canvas = require("html2canvas");
var _html2CanvasDefault = parcelHelpers.interopDefault(_html2Canvas);
var _jspdf = require("jspdf");
var _graieditor = require("../GRAIEditor");
var _graieditorDefault = parcelHelpers.interopDefault(_graieditor);
var _decisionalModel1Css = require("./DecisionalModel1.css");
function DecisionalModel1(props) {
    const history = (0, _reactRouterDom.useHistory)();
    const [downloading, setDownloading] = (0, _react.useState)(false);
    const [message, setMessage] = (0, _react.useState)("");
    // PDF haute qualité + redirection
    const handleDownloadPDF = (0, _react.useCallback)(async ()=>{
        try {
            const element = document.querySelector(".decisional-model-1-1");
            if (!element) {
                alert("Error: Unable to find the content to export!");
                return;
            }
            setDownloading(true);
            window.scrollTo(0, 0);
            const canvas = await (0, _html2CanvasDefault.default)(element, {
                scale: 2.5,
                backgroundColor: "#ffffff",
                useCORS: true,
                logging: false,
                scrollX: 0,
                scrollY: 0,
                windowWidth: document.documentElement.scrollWidth,
                windowHeight: document.documentElement.scrollHeight
            });
            const imgData = canvas.toDataURL("image/png", 1.0);
            const pdf = new (0, _jspdf.jsPDF)("p", "mm", "a4");
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = canvas.height * pdfWidth / canvas.width;
            let position = 0;
            const pageHeight = pdf.internal.pageSize.getHeight();
            while(position < pdfHeight){
                pdf.addImage(imgData, "PNG", 0, -position, pdfWidth, pdfHeight);
                position += pageHeight;
                if (position < pdfHeight) pdf.addPage();
            }
            pdf.save("decisional-model.pdf");
            setDownloading(false);
            setMessage("\u2705 PDF automatically saved to your Downloads folder!");
            setTimeout(()=>{
                history.push("/informational-model-1");
            }, 1500);
        } catch (err) {
            console.error("Error generating PDF:", err);
            alert("Error during PDF generation.");
            setDownloading(false);
        }
    }, [
        history
    ]);
    const handleDownloadPDF2 = (0, _react.useCallback)(async ()=>{
        try {
            const element = document.querySelector(".decisional-model-1-1");
            if (!element) {
                alert("Error: Unable to find the content to export!");
                return;
            }
            setDownloading(true);
            window.scrollTo(0, 0);
            const canvas = await (0, _html2CanvasDefault.default)(element, {
                scale: 2.5,
                backgroundColor: "#ffffff",
                useCORS: true,
                logging: false,
                scrollX: 0,
                scrollY: 0,
                windowWidth: document.documentElement.scrollWidth,
                windowHeight: document.documentElement.scrollHeight
            });
            const imgData = canvas.toDataURL("image/png", 1.0);
            const pdf = new (0, _jspdf.jsPDF)("p", "mm", "a4");
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = canvas.height * pdfWidth / canvas.width;
            let position = 0;
            const pageHeight = pdf.internal.pageSize.getHeight();
            while(position < pdfHeight){
                pdf.addImage(imgData, "PNG", 0, -position, pdfWidth, pdfHeight);
                position += pageHeight;
                if (position < pdfHeight) pdf.addPage();
            }
            pdf.save("decisional-model.pdf");
            setDownloading(false);
            setMessage("\u2705 PDF automatically saved to your Downloads folder!");
            setTimeout(()=>{
                history.push("/conception");
            }, 1500);
        } catch (err) {
            console.error("Error generating PDF:", err);
            alert("Error during PDF generation.");
            setDownloading(false);
        }
    }, [
        history
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "container-center-horizontal",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "decisional-model-1-1 screen",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "decisional-model-content",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _graieditorDefault.default), {
                        instanceId: "grai_decisional",
                        storageKey: "graiGridData_decisional",
                        title: "Decisional Model \u2013 GRAI Grid"
                    })
                })
            }),
            message && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                style: {
                    textAlign: "center",
                    color: message.startsWith("\u2705") ? "green" : "black",
                    marginTop: "10px",
                    fontWeight: 500
                },
                children: message
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "icam-navigation",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                        to: "/physical-model-1",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            className: "icam-nav-btn",
                            children: "Back"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                        to: "/informational-model-1",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            className: "icam-nav-btn",
                            children: "Continue"
                        })
                    })
                ]
            })
        ]
    });
}
exports.default = DecisionalModel1;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["Link","b9X5n"],["useHistory","ditZI"]],"html2canvas":"3eyQ5","jspdf":"hkJ4Q","../GRAIEditor":"ayjON","./DecisionalModel1.css":"8KvQr","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ayjON":[function(require,module,exports,__globalThis) {
// src/components/GRAIEditor/index.jsx
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _graieditorCss = require("./GRAIEditor.css");
var _reactflow = require("reactflow");
var _reactflowDefault = parcelHelpers.interopDefault(_reactflow);
var _styleCss = require("reactflow/dist/style.css");
var _html2Canvas = require("html2canvas");
var _html2CanvasDefault = parcelHelpers.interopDefault(_html2Canvas);
var _jspdf = require("jspdf");
var _jspdfDefault = parcelHelpers.interopDefault(_jspdf);
// Composants internes
var _gridHeader = require("./GridHeader");
var _gridHeaderDefault = parcelHelpers.interopDefault(_gridHeader);
var _gridCell = require("./GridCell");
var _gridCellDefault = parcelHelpers.interopDefault(_gridCell);
var _arrowManager = require("./ArrowManager");
var _arrowManagerDefault = parcelHelpers.interopDefault(_arrowManager);
var _toolbar = require("./Toolbar");
var _toolbarDefault = parcelHelpers.interopDefault(_toolbar);
var _externalSource = require("./ExternalSource");
var _externalSourceDefault = parcelHelpers.interopDefault(_externalSource);
const GRAIEditor = ({ instanceId = "grai_default", storageKey: customStorageKey, title = "Grille GRAI" })=>{
    // 🔑 Clé de stockage propre à chaque instance
    const storageKey = (0, _react.useMemo)(()=>customStorageKey || `graiGridData_${instanceId}`, [
        customStorageKey,
        instanceId
    ]);
    // --------------------
    // ÉTATS PRINCIPAUX
    // --------------------
    const [columns, setColumns] = (0, _react.useState)([
        {
            id: 1,
            title: "Informations externes",
            isPseudoFunction: true,
            isObligatory: true,
            isFixed: true
        },
        {
            id: 2,
            title: "G\xe9rer les produits",
            isObligatory: true
        },
        {
            id: 3,
            title: "Planifier",
            isObligatory: true
        },
        {
            id: 4,
            title: "G\xe9rer les ressources",
            isObligatory: true
        },
        {
            id: 5,
            title: "Informations internes",
            isPseudoFunction: true,
            isObligatory: true,
            isFixed: true
        }
    ]);
    const [rows, setRows] = (0, _react.useState)([
        {
            id: 1,
            title: "2 ans",
            horizon: "H1",
            period: 730
        },
        {
            id: 2,
            title: "1 an",
            horizon: "H2",
            period: 365
        },
        {
            id: 3,
            title: "6 mois",
            horizon: "H3",
            period: 180
        },
        {
            id: 4,
            title: "1 mois",
            horizon: "H4",
            period: 30
        }
    ]);
    const [cells, setCells] = (0, _react.useState)({});
    const [arrows, setArrows] = (0, _react.useState)([]);
    const [externalSources, setExternalSources] = (0, _react.useState)([
        {
            id: 1,
            position: "top",
            title: "Pr\xe9visions commerciales"
        },
        {
            id: 2,
            position: "left",
            title: "Historique des ventes"
        },
        {
            id: 3,
            position: "right",
            title: "Stocks PF"
        }
    ]);
    const [isExporting, setIsExporting] = (0, _react.useState)(false);
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const [zoomLevel, setZoomLevel] = (0, _react.useState)(100);
    const [isDragging, setIsDragging] = (0, _react.useState)(false);
    const [startPoint, setStartPoint] = (0, _react.useState)({
        x: 0,
        y: 0
    });
    const [scrollPosition, setScrollPosition] = (0, _react.useState)({
        x: 0,
        y: 0
    });
    const gridRef = (0, _react.useRef)(null);
    const gridContentRef = (0, _react.useRef)(null);
    const arrowManagerRef = (0, _react.useRef)(null);
    // "cell", "arrow-info", "arrow-decision", "delete"
    const [editorMode, setEditorMode] = (0, _react.useState)("cell");
    const [arrowStart, setArrowStart] = (0, _react.useState)(null);
    const [notification, setNotification] = (0, _react.useState)(null);
    const [connectedCells, setConnectedCells] = (0, _react.useState)({});
    const [tooltip, setTooltip] = (0, _react.useState)({
        visible: false,
        text: "",
        x: 0,
        y: 0
    });
    const [validationErrors, setValidationErrors] = (0, _react.useState)([]);
    const [showValidationErrors, setShowValidationErrors] = (0, _react.useState)(false);
    const [automaticValidation, setAutomaticValidation] = (0, _react.useState)(true);
    // --- Sous-éditeur ---
    const [activeCell, setActiveCell] = (0, _react.useState)(null);
    const [cellDiagrams, setCellDiagrams] = (0, _react.useState)({});
    const [subNodes, setSubNodes] = (0, _react.useState)([]);
    const [subEdges, setSubEdges] = (0, _react.useState)([]);
    (0, _react.useEffect)(()=>{
        console.log(`\u{1F9E9} [${instanceId}] Cellule active :`, activeCell);
    }, [
        activeCell,
        instanceId
    ]);
    const [arrowTooltip, setArrowTooltip] = (0, _react.useState)({
        visible: false,
        text: "",
        x: 0,
        y: 0,
        arrowId: null
    });
    // Sécurité anti-NaN tooltips
    (0, _react.useEffect)(()=>{
        if (!Number.isFinite(tooltip.x) || !Number.isFinite(tooltip.y)) {
            console.warn("\uD83E\uDDE9 Tooltip invalide d\xe9tect\xe9 :", tooltip);
            setTooltip((prev)=>({
                    ...prev,
                    x: 0,
                    y: 0
                }));
        }
        if (!Number.isFinite(arrowTooltip.x) || !Number.isFinite(arrowTooltip.y)) {
            console.warn("\uD83E\uDDE9 ArrowTooltip invalide d\xe9tect\xe9 :", arrowTooltip);
            setArrowTooltip((prev)=>({
                    ...prev,
                    x: 0,
                    y: 0
                }));
        }
    }, [
        tooltip,
        arrowTooltip
    ]);
    const normalize = (text)=>text.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    // --------------------
    // AJOUT / MODIF COLONNES / LIGNES
    // --------------------
    const addColumn = (title, position = "end")=>{
        const newColumn = {
            id: Date.now(),
            title,
            type: "Bonus",
            color: "#FACC15",
            isBonus: true
        };
        setColumns((prevColumns)=>{
            const updated = [
                ...prevColumns
            ];
            const indexProduct = updated.findIndex((col)=>col.title?.toLowerCase().includes("g\xe9rer les produits") || col.title?.toLowerCase().includes("g\xe9rer produits"));
            const indexResource = updated.findIndex((col)=>col.title?.toLowerCase().includes("g\xe9rer les ressources") || col.title?.toLowerCase().includes("g\xe9rer ressources"));
            if (position === "beforeProduct" && indexProduct !== -1) updated.splice(indexProduct, 0, newColumn);
            else if (position === "afterResource" && indexResource !== -1) updated.splice(indexResource + 1, 0, newColumn);
            else updated.push(newColumn);
            return updated;
        });
        showNotification(`Colonne "${title}" ajout\xe9e (type Bonus)`, "success");
    };
    const addRow = (title, horizon)=>{
        let period = 0;
        const periodMatch = title.toLowerCase().match(/(\d+)\s*(an|ans|mois|semaine|semaines|jour|jours|heure|heures)/);
        if (periodMatch) {
            const value = parseInt(periodMatch[1]);
            const unit = periodMatch[2];
            switch(unit){
                case "an":
                case "ans":
                    period = value * 365;
                    break;
                case "mois":
                    period = value * 30;
                    break;
                case "semaine":
                case "semaines":
                    period = value * 7;
                    break;
                case "jour":
                case "jours":
                    period = value;
                    break;
                case "heure":
                case "heures":
                    period = value / 24;
                    break;
                default:
                    period = 0;
            }
        }
        let insertIndex = 0;
        while(insertIndex < rows.length && rows[insertIndex].period >= period)insertIndex++;
        const newRowId = Math.max(...rows.map((row)=>row.id), 0) + 1;
        const newRow = {
            id: newRowId,
            title,
            horizon,
            period
        };
        const newRows = [
            ...rows
        ];
        newRows.splice(insertIndex, 0, newRow);
        setRows(newRows);
        if (automaticValidation) setTimeout(()=>validateGraiRules(), 0);
    };
    const updateCell = (rowId, colId, content)=>{
        setCells((prev)=>({
                ...prev,
                [`${rowId}-${colId}`]: {
                    ...prev[`${rowId}-${colId}`],
                    content
                }
            }));
        const cellElement = document.getElementById(`cell-${rowId}-${colId}`);
        if (cellElement) {
            cellElement.classList.add("animate-pulse");
            setTimeout(()=>{
                cellElement.classList.remove("animate-pulse");
            }, 1500);
        }
    };
    // --------------------
    // CLIC SUR CELLULE
    // --------------------
    const handleCellClick = (rowId, colId, e)=>{
        // Double clic → sous-éditeur
        if (e && e.detail === 2) {
            const key = `${rowId}-${colId}`;
            setActiveCell(key);
            const existing = cellDiagrams[key];
            setSubNodes(existing?.nodes || []);
            setSubEdges(existing?.edges || []);
            return;
        }
        if (editorMode === "cell") return;
        if (editorMode === "arrow-info" || editorMode === "arrow-decision") {
            if (!arrowStart) {
                setArrowStart({
                    rowId,
                    colId
                });
                showNotification("Cellule de d\xe9part s\xe9lectionn\xe9e.", "info");
                return;
            }
            const newArrowId = arrows.length > 0 ? Math.max(...arrows.map((a)=>a.id)) + 1 : 1;
            const newArrow = {
                id: newArrowId,
                start: {
                    ...arrowStart
                },
                end: {
                    rowId,
                    colId
                },
                created: Date.now(),
                type: editorMode === "arrow-info" ? "information" : "decision",
                color: editorMode === "arrow-info" ? "#EF4444" : "#3B82F6",
                thickness: editorMode === "arrow-info" ? 2 : 8
            };
            setArrows((prev)=>[
                    ...prev,
                    newArrow
                ]);
            setArrowStart(null);
            showNotification(`Fl\xe8che ${newArrow.type} ajout\xe9e avec succ\xe8s`, "success");
        }
    };
    // --------------------
    // HIGHLIGHT / CONNECTÉ
    // --------------------
    const highlightAvailableCells = (sourceRowId, sourceColId)=>{
        const allCells = document.querySelectorAll(".grid-cell");
        allCells.forEach((cell)=>{
            const cellId = cell.id;
            if (!cellId || !cellId.startsWith("cell-")) return;
            const [, rowIdStr, colIdStr] = cellId.split("-");
            const rowId = parseInt(rowIdStr, 10);
            const colId = parseInt(colIdStr, 10);
            if (rowId === sourceRowId && colId === sourceColId) return;
            const sourceColumn = columns.find((col)=>col.id === sourceColId);
            const targetColumn = columns.find((col)=>col.id === colId);
            if (sourceColumn?.isPseudoFunction && targetColumn?.isPseudoFunction) cell.classList.add("connection-not-allowed");
            else cell.classList.add("connection-allowed");
        });
    };
    const clearAvailableCells = ()=>{
        const allCells = document.querySelectorAll(".grid-cell");
        allCells.forEach((cell)=>{
            cell.classList.remove("connection-allowed", "connection-not-allowed");
        });
    };
    const highlightConnectedCells = (rowId, colId, type)=>{
        setConnectedCells((prev)=>({
                ...prev,
                [`${rowId}-${colId}`]: type
            }));
    };
    const clearConnectedCells = ()=>{
        setConnectedCells({});
    };
    // --------------------
    // FLÈCHES
    // --------------------
    const deleteArrow = (arrowId)=>{
        setArrows((prev)=>prev.filter((a)=>a.id !== arrowId));
        showNotification("Relation supprim\xe9e", "success");
    };
    const changeArrowType = (arrowId, type)=>{
        const updatedArrows = arrows.map((a)=>{
            if (a.id === arrowId) {
                let color = "#3B82F6";
                let thickness = 2;
                if (type === "information") color = "#EF4444";
                else if (type === "vertical") {
                    color = "#10B981";
                    thickness = 5;
                }
                return {
                    ...a,
                    type,
                    color,
                    thickness
                };
            }
            return a;
        });
        setArrows(updatedArrows);
        showNotification(`Type de fl\xe8che modifi\xe9 : ${type}`, "info");
    };
    const addExternalSource = (title, position)=>{
        const newId = externalSources.length > 0 ? Math.max(...externalSources.map((s)=>s.id)) + 1 : 1;
        setExternalSources((prev)=>[
                ...prev,
                {
                    id: newId,
                    title,
                    position
                }
            ]);
        showNotification(`Source '${title}' ajout\xe9e`, "success");
    };
    // --------------------
    // EXPORTS
    // --------------------
    const exportAsImage = ()=>{
        if (!gridRef.current) {
            showNotification("Erreur: R\xe9f\xe9rence \xe0 la grille non disponible", "error");
            return;
        }
        const format = window.confirm("Souhaitez-vous exporter en PDF ?\nCliquez sur 'OK' pour PDF, ou 'Annuler' pour PNG.") ? "pdf" : "png";
        setIsExporting(true);
        showNotification(`Pr\xe9paration de l'exportation en ${format.toUpperCase()}...`, "info");
        const currentZoom = zoomLevel;
        setZoomLevel(100);
        setTimeout(()=>{
            try {
                const originalElement = document.querySelector(".grai-grid");
                if (!originalElement) throw new Error("Grille GRAI introuvable dans le DOM");
                const container = document.createElement("div");
                container.style.position = "fixed";
                container.style.top = "0";
                container.style.left = "0";
                container.style.width = `${originalElement.scrollWidth}px`;
                container.style.height = `${originalElement.scrollHeight}px`;
                container.style.backgroundColor = "white";
                container.style.zIndex = "-9999";
                container.style.overflow = "hidden";
                const clone = originalElement.cloneNode(true);
                clone.style.transform = "none";
                clone.style.border = "1px solid #ddd";
                clone.style.boxShadow = "none";
                container.appendChild(clone);
                document.body.appendChild(container);
                setTimeout(()=>{
                    (0, _html2CanvasDefault.default)(clone, {
                        backgroundColor: "#ffffff",
                        scale: 2,
                        useCORS: true,
                        allowTaint: true,
                        logging: false
                    }).then((canvas)=>{
                        document.body.removeChild(container);
                        setZoomLevel(currentZoom);
                        try {
                            const fileName = `decisional-modele-${new Date().toISOString().slice(0, 10)}`;
                            if (format === "pdf") {
                                const imgData = canvas.toDataURL("image/png");
                                const pdf = new (0, _jspdfDefault.default)({
                                    orientation: "landscape",
                                    unit: "px",
                                    format: [
                                        canvas.width,
                                        canvas.height
                                    ]
                                });
                                pdf.addImage(imgData, "PNG", 0, 0, canvas.width, canvas.height);
                                pdf.save(`${fileName}.pdf`);
                                showNotification("Exportation PDF r\xe9ussie !", "success");
                            } else {
                                const dataUrl = canvas.toDataURL("image/png");
                                const link = document.createElement("a");
                                link.href = dataUrl;
                                link.download = `${fileName}.png`;
                                link.click();
                                showNotification("Exportation PNG r\xe9ussie !", "success");
                            }
                            setIsExporting(false);
                        } catch (err) {
                            console.error("Erreur lors de l'exportation:", err);
                            setIsExporting(false);
                            showNotification("Erreur lors de l'exportation", "error");
                        }
                    }).catch((err)=>{
                        console.error("Erreur html2canvas:", err);
                        document.body.removeChild(container);
                        setIsExporting(false);
                        setZoomLevel(currentZoom);
                        showNotification("Erreur lors de la g\xe9n\xe9ration du rendu", "error");
                    });
                }, 500);
            } catch (error) {
                console.error("Erreur lors de la pr\xe9paration de l'exportation:", error);
                setIsExporting(false);
                setZoomLevel(currentZoom);
                showNotification("Erreur lors de la pr\xe9paration de l'exportation", "error");
            }
        }, 300);
    };
    const exportAsImageAlternative = ()=>{
        if (!gridRef.current) {
            showNotification("Erreur: R\xe9f\xe9rence \xe0 la grille non disponible", "error");
            return;
        }
        setIsExporting(true);
        showNotification("Pr\xe9paration de l'exportation (m\xe9thode alternative)...", "info");
        try {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");
            const gridElement = document.querySelector(".grai-grid");
            if (!gridElement) throw new Error("\xc9l\xe9ment de grille introuvable");
            const width = gridElement.offsetWidth;
            const height = gridElement.offsetHeight;
            canvas.width = width * 2;
            canvas.height = height * 2;
            ctx.scale(2, 2);
            ctx.fillStyle = "#ffffff";
            ctx.fillRect(0, 0, width, height);
            ctx.strokeStyle = "#dddddd";
            ctx.lineWidth = 1;
            ctx.strokeRect(0, 0, width, height);
            ctx.fillStyle = "#333333";
            ctx.font = "bold 18px Arial";
            ctx.textAlign = "center";
            ctx.fillText("Grille GRAI", width / 2, 30);
            const cellWidth = (width - 100) / columns.length;
            const cellHeight = 40;
            const startX = 100;
            const startY = 60;
            ctx.fillStyle = "#f0f0f0";
            ctx.fillRect(0, startY, startX, cellHeight);
            columns.forEach((column, colIndex)=>{
                const x = startX + colIndex * cellWidth;
                ctx.fillStyle = "#f0f0f0";
                ctx.fillRect(x, startY, cellWidth, cellHeight);
                ctx.strokeStyle = "#cccccc";
                ctx.strokeRect(x, startY, cellWidth, cellHeight);
                ctx.fillStyle = "#333333";
                ctx.font = "bold 12px Arial";
                ctx.textAlign = "center";
                ctx.fillText(column.title.length > 15 ? column.title.substring(0, 15) + "..." : column.title, x + cellWidth / 2, startY + 25);
            });
            rows.forEach((row, rowIndex)=>{
                const y = startY + (rowIndex + 1) * cellHeight;
                ctx.fillStyle = "#f0f0f0";
                ctx.fillRect(0, y, startX, cellHeight);
                ctx.strokeStyle = "#cccccc";
                ctx.strokeRect(0, y, startX, cellHeight);
                ctx.fillStyle = "#333333";
                ctx.font = "bold 12px Arial";
                ctx.textAlign = "center";
                ctx.fillText(row.title, startX / 2, y + 25);
                columns.forEach((column, colIndex)=>{
                    const x = startX + colIndex * cellWidth;
                    ctx.fillStyle = "#ffffff";
                    ctx.fillRect(x, y, cellWidth, cellHeight);
                    ctx.strokeStyle = "#cccccc";
                    ctx.strokeRect(x, y, cellWidth, cellHeight);
                    const cellContent = cells[`${row.id}-${column.id}`]?.content || "";
                    ctx.fillStyle = "#333333";
                    ctx.font = "11px Arial";
                    ctx.textAlign = "center";
                    const maxCharsPerLine = 20;
                    let yOffset = 15;
                    if (cellContent.length <= maxCharsPerLine) ctx.fillText(cellContent, x + cellWidth / 2, y + yOffset);
                    else {
                        let remainingText = cellContent;
                        while(remainingText.length > 0 && yOffset < cellHeight - 5){
                            let lineText;
                            if (remainingText.length > maxCharsPerLine) {
                                let cutIndex = remainingText.substring(0, maxCharsPerLine).lastIndexOf(" ");
                                if (cutIndex === -1) cutIndex = maxCharsPerLine;
                                lineText = remainingText.substring(0, cutIndex);
                                remainingText = remainingText.substring(cutIndex + 1);
                            } else {
                                lineText = remainingText;
                                remainingText = "";
                            }
                            ctx.fillText(lineText, x + cellWidth / 2, y + yOffset);
                            yOffset += 15;
                        }
                    }
                });
            });
            arrows.forEach((arrow)=>{
                const startRow = rows.findIndex((r)=>r.id === arrow.start.rowId);
                const startCol = columns.findIndex((c)=>c.id === arrow.start.colId);
                const endRow = rows.findIndex((r)=>r.id === arrow.end.rowId);
                const endCol = columns.findIndex((c)=>c.id === arrow.end.colId);
                if (startRow === -1 || startCol === -1 || endRow === -1 || endCol === -1) return;
                const startX1 = startX + startCol * cellWidth + cellWidth / 2;
                const startY1 = startY + (startRow + 1) * cellHeight + cellHeight / 2;
                const endX1 = startX + endCol * cellWidth + cellWidth / 2;
                const endY1 = startY + (endRow + 1) * cellHeight + cellHeight / 2;
                ctx.beginPath();
                ctx.moveTo(startX1, startY1);
                ctx.lineTo(endX1, endY1);
                ctx.strokeStyle = arrow.color || (arrow.type === "decision" ? "#3b82f6" : "#ef4444");
                ctx.lineWidth = arrow.thickness || 2;
                ctx.stroke();
                const angle = Math.atan2(endY1 - startY1, endX1 - startX1);
                const arrowSize = arrow.type === "vertical" ? 12 : 8;
                ctx.beginPath();
                ctx.moveTo(endX1, endY1);
                ctx.lineTo(endX1 - arrowSize * Math.cos(angle - Math.PI / 6), endY1 - arrowSize * Math.sin(angle - Math.PI / 6));
                ctx.lineTo(endX1 - arrowSize * Math.cos(angle + Math.PI / 6), endY1 - arrowSize * Math.sin(angle + Math.PI / 6));
                ctx.closePath();
                ctx.fillStyle = arrow.type === "decision" ? "#3b82f6" : "#ef4444";
                ctx.fill();
            });
            const dataUrl = canvas.toDataURL("image/png");
            const link = document.createElement("a");
            link.href = dataUrl;
            link.download = `grille-grai-${new Date().toISOString().slice(0, 10)}-alt.png`;
            link.click();
            setIsExporting(false);
            showNotification("Exportation alternative r\xe9ussie! L'image a \xe9t\xe9 t\xe9l\xe9charg\xe9e.", "success");
        } catch (error) {
            console.error("Erreur lors de l'exportation alternative:", error);
            setIsExporting(false);
            showNotification("Erreur lors de l'exportation alternative", "error");
        }
    };
    const exportWithOptions = ()=>{
        if (window.confirm("Choisir une m\xe9thode d'exportation:\n\n- OK pour la m\xe9thode standard\n- Annuler pour la m\xe9thode alternative (recommand\xe9e si l'image est blanche)")) exportAsImage();
        else exportAsImageAlternative();
    };
    // --------------------
    // SAUVEGARDE / CHARGEMENT
    // --------------------
    const saveGrid = ()=>{
        const gridData = {
            columns,
            rows,
            cells,
            arrows,
            externalSources,
            cellDiagrams
        };
        try {
            localStorage.setItem(storageKey, JSON.stringify(gridData));
            showNotification("Grille sauvegard\xe9e avec succ\xe8s", "success");
            console.log(`[${instanceId}] Grid saved`, gridData);
        } catch (error) {
            console.error("Erreur lors de la sauvegarde", error);
            showNotification("Erreur lors de la sauvegarde", "error");
        }
    };
    const loadGrid = ()=>{
        try {
            setIsLoading(true);
            const savedData = localStorage.getItem(storageKey);
            if (savedData) {
                const parsedData = JSON.parse(savedData);
                setColumns(parsedData.columns || []);
                setRows(parsedData.rows || []);
                setCells(parsedData.cells || {});
                setArrows(parsedData.arrows || []);
                setExternalSources(parsedData.externalSources || []);
                setCellDiagrams(parsedData.cellDiagrams || {});
                showNotification("Grille charg\xe9e avec succ\xe8s", "success");
            } else showNotification("Aucune grille sauvegard\xe9e trouv\xe9e", "info");
            setTimeout(()=>{
                setIsLoading(false);
            }, 500);
        } catch (error) {
            console.error("Erreur lors du chargement", error);
            showNotification("Erreur lors du chargement des donn\xe9es", "error");
            setIsLoading(false);
        }
    };
    const loadEmptyTemplate = ()=>{
        if (window.confirm("\xcates-vous s\xfbr de vouloir cr\xe9er un nouveau mod\xe8le? Toutes les donn\xe9es non sauvegard\xe9es seront perdues.")) {
            setIsLoading(true);
            setColumns([]);
            setRows([]);
            setCells({});
            setArrows([]);
            setExternalSources([]);
            setCellDiagrams({});
            setTimeout(()=>{
                setIsLoading(false);
                showNotification("Nouveau mod\xe8le cr\xe9\xe9", "success");
            }, 300);
        }
    };
    // Chargement initial
    (0, _react.useEffect)(()=>{
        setIsLoading(true);
        const savedData = localStorage.getItem(storageKey);
        if (savedData) try {
            const parsedData = JSON.parse(savedData);
            setColumns(parsedData.columns || []);
            setRows(parsedData.rows || []);
            setCells(parsedData.cells || {});
            setArrows(parsedData.arrows || []);
            setExternalSources(parsedData.externalSources || []);
            setCellDiagrams(parsedData.cellDiagrams || {});
        } catch (error) {
            console.error("Error loading saved data", error);
            showNotification("Erreur lors du chargement des donn\xe9es sauvegard\xe9es", "error");
        }
        setTimeout(()=>{
            setIsLoading(false);
        }, 500);
    }, [
        storageKey
    ]); // 🔑 dépend de la clé
    // --------------------
    // ZOOM
    // --------------------
    const handleZoomIn = ()=>{
        if (zoomLevel < 200) setZoomLevel((prevZoom)=>Math.min(prevZoom + 10, 200));
    };
    const handleZoomOut = ()=>{
        if (zoomLevel > 50) setZoomLevel((prevZoom)=>Math.max(prevZoom - 10, 50));
    };
    const handleZoomReset = ()=>{
        setZoomLevel(100);
    };
    const handleWheel = (0, _react.useCallback)((e)=>{
        if (e.ctrlKey || e.metaKey) {
            e.preventDefault();
            if (e.deltaY < 0) handleZoomIn();
            else handleZoomOut();
        }
    }, [] // on utilise directement handleZoomIn/out qui lisent l'état
    );
    // --------------------
    // TOOLTIP / NOTIFS
    // --------------------
    const handleShowTooltip = (e, text)=>{
        if (!text) return;
        if (typeof e === "string") {
            text = e;
            setTooltip({
                visible: true,
                text,
                x: window.innerWidth / 2,
                y: window.innerHeight / 2
            });
            return;
        }
        if (!e || !e.currentTarget) {
            setTooltip({
                visible: true,
                text,
                x: window.innerWidth / 2,
                y: window.innerHeight / 2
            });
            return;
        }
        const rect = e.currentTarget.getBoundingClientRect();
        setTooltip({
            visible: true,
            text,
            x: rect.left + rect.width / 2,
            y: rect.bottom + 10
        });
    };
    const handleHideTooltip = ()=>{
        setTooltip((prev)=>({
                ...prev,
                visible: false
            }));
    };
    const showNotification = (message, type = "info")=>{
        setNotification({
            message,
            type
        });
        setTimeout(()=>{
            setNotification(null);
        }, 3000);
    };
    // --------------------
    // MODES ÉDITEUR
    // --------------------
    const changeEditorMode = (mode)=>{
        setEditorMode(mode);
        if (mode !== "arrow-info" && mode !== "arrow-decision") {
            setArrowStart(null);
            clearAvailableCells();
        }
        const container = document.querySelector(".grai-editor-container");
        if (container) {
            container.classList.remove("cell-mode", "arrow-info-mode", "arrow-decision-mode", "delete-mode");
            container.classList.add(`${mode}-mode`);
        }
        const gridElement = document.querySelector(".grai-grid");
        if (gridElement) {
            if (mode === "arrow-info" || mode === "arrow-decision") gridElement.style.cursor = "crosshair";
            else if (mode === "delete") gridElement.style.cursor = "not-allowed";
            else gridElement.style.cursor = "default";
        }
    };
    // --------------------
    // DRAG POUR DÉFILEMENT
    // --------------------
    const handleMouseDown = (0, _react.useCallback)((e)=>{
        if (e.button === 1 || e.button === 0 && e.altKey) {
            e.preventDefault();
            if (gridContentRef.current) {
                setIsDragging(true);
                setStartPoint({
                    x: e.clientX,
                    y: e.clientY
                });
                setScrollPosition({
                    x: gridContentRef.current.scrollLeft,
                    y: gridContentRef.current.scrollTop
                });
                gridContentRef.current.classList.add("can-scroll");
            }
        }
    }, []);
    const handleMouseMove = (0, _react.useCallback)((e)=>{
        if (!isDragging || !gridContentRef.current) return;
        const dx = e.clientX - startPoint.x;
        const dy = e.clientY - startPoint.y;
        gridContentRef.current.scrollLeft = scrollPosition.x - dx;
        gridContentRef.current.scrollTop = scrollPosition.y - dy;
    }, [
        isDragging,
        startPoint,
        scrollPosition
    ]);
    const handleMouseUp = (0, _react.useCallback)(()=>{
        if (isDragging && gridContentRef.current) {
            setIsDragging(false);
            gridContentRef.current.classList.remove("can-scroll");
        }
    }, [
        isDragging
    ]);
    (0, _react.useEffect)(()=>{
        if (gridRef.current) {
            const gridElement = gridRef.current;
            gridElement.addEventListener("wheel", handleWheel, {
                passive: false
            });
            gridElement.addEventListener("mousedown", handleMouseDown);
            document.addEventListener("mousemove", handleMouseMove);
            document.addEventListener("mouseup", handleMouseUp);
            return ()=>{
                gridElement.removeEventListener("wheel", handleWheel);
                gridElement.removeEventListener("mousedown", handleMouseDown);
                document.removeEventListener("mousemove", handleMouseMove);
                document.removeEventListener("mouseup", handleMouseUp);
            };
        }
    }, [
        handleWheel,
        handleMouseDown,
        handleMouseMove,
        handleMouseUp
    ]);
    // --------------------
    // REDIMENSIONNEMENT COLONNES
    // --------------------
    (0, _react.useEffect)(()=>{
        let isResizing = false;
        let currentColumn = null;
        let startX = 0;
        let startWidth = 0;
        const initColumnResize = ()=>{
            const headerCells = document.querySelectorAll(".grid-header-cell.column-header");
            headerCells.forEach((cell)=>{
                const resizer = document.createElement("div");
                resizer.className = "column-resizer";
                resizer.style.position = "absolute";
                resizer.style.top = "0";
                resizer.style.right = "0";
                resizer.style.width = "8px";
                resizer.style.height = "100%";
                resizer.style.cursor = "col-resize";
                resizer.style.zIndex = "20";
                cell.style.position = "relative";
                cell.appendChild(resizer);
                resizer.addEventListener("mousedown", (e)=>{
                    isResizing = true;
                    currentColumn = cell;
                    startX = e.pageX;
                    startWidth = cell.offsetWidth;
                    document.body.classList.add("column-resizing");
                    e.preventDefault();
                    e.stopPropagation();
                });
            });
            const onMouseMove = (e)=>{
                if (!isResizing || !currentColumn) return;
                const width = startWidth + (e.pageX - startX);
                if (width >= 100) {
                    const columnIndex = Array.from(currentColumn.parentNode.children).indexOf(currentColumn);
                    const columnCells = document.querySelectorAll(`.grid-row > *:nth-child(${columnIndex + 1})`);
                    currentColumn.style.width = `${width}px`;
                    currentColumn.style.minWidth = `${width}px`;
                    columnCells.forEach((cell)=>{
                        cell.style.width = `${width}px`;
                        cell.style.minWidth = `${width}px`;
                    });
                }
            };
            const onMouseUp = ()=>{
                if (isResizing) {
                    isResizing = false;
                    currentColumn = null;
                    document.body.classList.remove("column-resizing");
                }
            };
            document.addEventListener("mousemove", onMouseMove);
            document.addEventListener("mouseup", onMouseUp);
            return ()=>{
                document.removeEventListener("mousemove", onMouseMove);
                document.removeEventListener("mouseup", onMouseUp);
            };
        };
        if (gridRef.current && columns.length > 0 && rows.length > 0) setTimeout(initColumnResize, 500);
        return ()=>{
            const resizers = document.querySelectorAll(".column-resizer");
            resizers.forEach((resizer)=>{
                resizer.parentNode?.removeChild(resizer);
            });
        };
    }, [
        columns.length,
        rows.length
    ]);
    // --------------------
    // STYLE ZOOM
    // --------------------
    const gridStyle = {
        transform: `scale(${zoomLevel / 100})`,
        transformOrigin: "top left",
        transition: "transform 0.2s ease"
    };
    // --------------------
    // CLASSES CONNECTÉS + ERREURS
    // --------------------
    const connectedCellsClasses = (0, _react.useMemo)(()=>{
        const classes = {};
        if (validationErrors.length > 0) validationErrors.forEach((error)=>{
            if (error.elements) error.elements.forEach((elementId)=>{
                if (elementId.startsWith("cell-")) classes[elementId.replace("cell-", "")] = "validation-error";
            });
        });
        arrows.forEach((arrow)=>{
            const startKey = `${arrow.start.rowId}-${arrow.start.colId}`;
            const endKey = `${arrow.end.rowId}-${arrow.end.colId}`;
            const hasError = validationErrors.some((error)=>error.arrowId === arrow.id);
            classes[startKey] = `${classes[startKey] || ""} connected-cell arrow-start${hasError ? " validation-error" : ""}`.trim();
            classes[endKey] = `${classes[endKey] || ""} connected-cell arrow-end${hasError ? " validation-error" : ""}`.trim();
        });
        return classes;
    }, [
        arrows,
        connectedCells,
        validationErrors
    ]);
    const getColumnHeaderClass = (0, _react.useCallback)((columnId)=>{
        const hasError = validationErrors.some((error)=>error.elements && error.elements.includes(`header-col-${columnId}`));
        return hasError ? "validation-error" : "";
    }, [
        validationErrors
    ]);
    const getRowHeaderClass = (0, _react.useCallback)((rowId)=>{
        const hasError = validationErrors.some((error)=>error.elements && error.elements.includes(`header-row-${rowId}`));
        return hasError ? "validation-error" : "";
    }, [
        validationErrors
    ]);
    const getArrowClass = (0, _react.useCallback)((arrowId)=>{
        const hasError = validationErrors.some((error)=>error.arrowId === arrowId);
        return hasError ? "validation-error" : "";
    }, [
        validationErrors
    ]);
    // --------------------
    // VALIDATION GRAI
    // --------------------
    const validateGraiRules = (0, _react.useCallback)(()=>{
        const errors = [];
        // CMG1
        arrows.forEach((arrow)=>{
            if (arrow.type === "decision" && arrow.start.rowId === arrow.end.rowId && arrow.start.colId === arrow.end.colId) errors.push({
                rule: "CMG1",
                message: "Un cadre de d\xe9cision ne peut \xeatre re\xe7u par ce m\xeame centre",
                elements: [
                    `cell-${arrow.start.rowId}-${arrow.start.colId}`
                ],
                arrowId: arrow.id
            });
        });
        // CMG2 & CMG4
        arrows.forEach((arrow)=>{
            if (arrow.type === "decision") {
                const startColumn = columns.find((col)=>col.id === arrow.start.colId);
                const endColumn = columns.find((col)=>col.id === arrow.end.colId);
                if (startColumn?.isPseudoFunction && endColumn?.isPseudoFunction) errors.push({
                    rule: "CMG2/4",
                    message: "Un cadre de d\xe9cision ne peut \xeatre \xe9mis d'une pseudo-fonction \xe0 une autre",
                    elements: [
                        `cell-${arrow.start.rowId}-${arrow.start.colId}`,
                        `cell-${arrow.end.rowId}-${arrow.end.colId}`
                    ],
                    arrowId: arrow.id
                });
            }
        });
        // CMG3
        const externalInfoColumn = columns.find((col)=>col.title.toLowerCase().includes("informations externes"));
        if (externalInfoColumn && externalInfoColumn.id !== 1) errors.push({
            rule: "CMG3",
            message: "La fonction 'informations externes' doit \xeatre plac\xe9e en colonne 1",
            elements: [
                `header-col-${externalInfoColumn.id}`
            ]
        });
        // CMG5
        const internalInfoColumn = columns.find((col)=>col.title.toLowerCase().includes("informations internes"));
        if (internalInfoColumn && internalInfoColumn.id !== columns.length) errors.push({
            rule: "CMG5",
            message: "La fonction 'informations internes' doit \xeatre plac\xe9e en derni\xe8re colonne",
            elements: [
                `header-col-${internalInfoColumn.id}`
            ]
        });
        // CMG6, 7, 8
        const requiredFunctions = [
            {
                name: "G\xe9rer les produits",
                rule: "CMG6"
            },
            {
                name: "G\xe9rer les ressources",
                rule: "CMG7"
            },
            {
                name: "Planifier",
                rule: "CMG8"
            }
        ];
        requiredFunctions.forEach((func)=>{
            if (!columns.some((col)=>col.title.toLowerCase().includes(func.name.toLowerCase()))) errors.push({
                rule: func.rule,
                message: `La fonction '${func.name}' ne peut \xeatre absente de la grille`,
                elements: []
            });
        });
        // CMG9
        for(let i = 1; i < rows.length; i++)if (rows[i].period > rows[i - 1].period) {
            errors.push({
                rule: "CMG9",
                message: "Les p\xe9riodes des niveaux d\xe9cisionnels doivent \xeatre class\xe9es par ordre d\xe9croissant",
                elements: [
                    `header-row-${rows[i - 1].id}`,
                    `header-row-${rows[i].id}`
                ]
            });
            break;
        }
        // CMG10
        if (rows.length < 3) errors.push({
            rule: "CMG10",
            message: "Les niveaux d\xe9cisionnels ne peuvent \xeatre moins de trois dans une grille GRAI",
            elements: []
        });
        // CMG12
        const internalInfoCount = columns.filter((col)=>col.title.toLowerCase().includes("informations internes")).length;
        if (internalInfoCount > 1) {
            const internalInfoColumns = columns.filter((col)=>col.title.toLowerCase().includes("informations internes")).map((col)=>`header-col-${col.id}`);
            errors.push({
                rule: "CMG12",
                message: "Une grille GRAI ne peut contenir qu'une seule fonction 'informations internes'",
                elements: internalInfoColumns
            });
        }
        // CMG13
        const externalInfoCount = columns.filter((col)=>col.title.toLowerCase().includes("informations externes")).length;
        if (externalInfoCount > 1) {
            const externalInfoColumns = columns.filter((col)=>col.title.toLowerCase().includes("informations externes")).map((col)=>`header-col-${col.id}`);
            errors.push({
                rule: "CMG13",
                message: "Une grille GRAI ne peut contenir qu'une seule fonction 'informations externes'",
                elements: externalInfoColumns
            });
        }
        setValidationErrors(errors);
        return errors.length === 0;
    }, [
        columns,
        rows,
        arrows
    ]);
    (0, _react.useEffect)(()=>{
        if (automaticValidation) validateGraiRules();
    }, [
        columns,
        rows,
        arrows,
        automaticValidation,
        validateGraiRules
    ]);
    // --------------------
    // SUPPRESSION COL / LIGNE
    // --------------------
    const deleteColumn = (columnId)=>{
        const columnToDelete = columns.find((col)=>col.id === columnId);
        if (columnToDelete?.isObligatory) {
            const columnTitle = columnToDelete.title.toLowerCase();
            const isUniqueObligatory = !columns.some((col)=>col.id !== columnId && col.title.toLowerCase() === columnTitle);
            if (isUniqueObligatory) {
                alert(`Cette fonction est obligatoire selon les r\xe8gles GRAI et ne peut \xeatre supprim\xe9e.`);
                return;
            }
        }
        if (columnToDelete?.isFixed) {
            alert(`Cette fonction ne peut pas \xeatre supprim\xe9e car elle a une position fixe dans la grille GRAI.`);
            return;
        }
        const newColumns = columns.filter((col)=>col.id !== columnId).map((col, index)=>({
                ...col,
                id: index + 1
            }));
        setColumns(newColumns);
        const newArrows = arrows.filter((arrow)=>arrow.start.colId !== columnId && arrow.end.colId !== columnId);
        setArrows(newArrows);
        const newCells = {
            ...cells
        };
        rows.forEach((row)=>{
            delete newCells[`${row.id}-${columnId}`];
        });
        setCells(newCells);
        if (automaticValidation) setTimeout(()=>validateGraiRules(), 0);
    };
    const deleteRow = (rowId)=>{
        if (rows.length <= 3) {
            alert("CMG10: Les niveaux d\xe9cisionnels ne peuvent \xeatre moins de trois dans une grille GRAI.");
            return;
        }
        const newRows = rows.filter((row)=>row.id !== rowId);
        setRows(newRows);
        const newArrows = arrows.filter((arrow)=>arrow.start.rowId !== rowId && arrow.end.rowId !== rowId);
        setArrows(newArrows);
        const newCells = {
            ...cells
        };
        columns.forEach((col)=>{
            delete newCells[`${rowId}-${col.id}`];
        });
        setCells(newCells);
        if (automaticValidation) setTimeout(()=>validateGraiRules(), 0);
    };
    // --------------------
    // TOOLTIP FLÈCHES
    // --------------------
    const handleArrowHover = (0, _react.useCallback)((arrow, position)=>{
        const startCell = cells[`${arrow.start.rowId}-${arrow.start.colId}`] || {};
        const endCell = cells[`${arrow.end.rowId}-${arrow.end.colId}`] || {};
        const startColumn = columns.find((col)=>col.id === arrow.start.colId) || {};
        const endColumn = columns.find((col)=>col.id === arrow.end.colId) || {};
        const startRow = rows.find((row)=>row.id === arrow.start.rowId) || {};
        const endRow = rows.find((row)=>row.id === arrow.end.rowId) || {};
        const typeLabel = arrow.type === "decision" ? "D\xe9cision" : "Information";
        let tooltipText = `${typeLabel}: ${startRow.title || "Horizon"} / ${startColumn.title || "Fonction"} \u{2192} ${endRow.title || "Horizon"} / ${endColumn.title || "Fonction"}`;
        if (startCell.content && endCell.content) {
            tooltipText += `\nDe: "${startCell.content.substring(0, 30)}${startCell.content.length > 30 ? "..." : ""}"`;
            tooltipText += `\nVers: "${endCell.content.substring(0, 30)}${endCell.content.length > 30 ? "..." : ""}"`;
        }
        setArrowTooltip({
            visible: true,
            text: tooltipText,
            x: position.x,
            y: position.y,
            arrowId: arrow.id
        });
    }, [
        cells,
        columns,
        rows
    ]);
    const handleArrowLeave = (0, _react.useCallback)(()=>{
        setArrowTooltip((prev)=>({
                ...prev,
                visible: false
            }));
    }, []);
    // --------------------
    // NOEUDS SOUS-ÉDITEUR
    // --------------------
    const addNode = (label, style)=>{
        const newNode = {
            id: `${Date.now()}`,
            type: "default",
            data: {
                label,
                style
            },
            style,
            position: {
                x: Math.random() * 400,
                y: Math.random() * 300
            }
        };
        setSubNodes((prev)=>[
                ...prev,
                newNode
            ]);
    };
    // --------------------
    // RENDU
    // --------------------
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `grai-editor-container ${isExporting ? "exporting" : ""}`,
        "data-instance-id": instanceId,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "grai-editor-header",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                        className: "grai-editor-title",
                        children: title
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toolbarDefault.default), {
                        editorMode: editorMode,
                        setEditorMode: changeEditorMode,
                        addColumn: addColumn,
                        addRow: addRow,
                        addExternalSource: addExternalSource,
                        exportAsImage: exportWithOptions,
                        saveGrid: saveGrid,
                        loadGrid: loadGrid,
                        loadEmptyTemplate: loadEmptyTemplate,
                        zoomLevel: zoomLevel,
                        onShowTooltip: handleShowTooltip,
                        onHideTooltip: handleHideTooltip,
                        validateGrid: validateGraiRules,
                        validationErrors: validationErrors,
                        showValidationErrors: showValidationErrors,
                        setShowValidationErrors: setShowValidationErrors,
                        automaticValidation: automaticValidation,
                        setAutomaticValidation: setAutomaticValidation
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: `grai-grid-container ${isDragging ? "dragging" : ""}`,
                ref: gridRef,
                children: [
                    isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "grid-loading",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "grid-loading-spinner"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                children: "Chargement de la grille..."
                            })
                        ]
                    }),
                    showValidationErrors && validationErrors.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "grai-validation-errors",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h3", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "16",
                                        height: "16",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: "currentColor",
                                        strokeWidth: "2",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                                cx: "12",
                                                cy: "12",
                                                r: "10"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                                x1: "12",
                                                y1: "8",
                                                x2: "12",
                                                y2: "12"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                                x1: "12",
                                                y1: "16",
                                                x2: "12.01",
                                                y2: "16"
                                            })
                                        ]
                                    }),
                                    "Erreurs de validation (",
                                    validationErrors.length,
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
                                className: "validation-error-list",
                                children: validationErrors.map((error, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                        className: "validation-error-item",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("strong", {
                                                children: [
                                                    error.rule,
                                                    ":"
                                                ]
                                            }),
                                            " ",
                                            error.message
                                        ]
                                    }, index))
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "validation-actions",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    className: "toolbar-button",
                                    onClick: ()=>setShowValidationErrors(false),
                                    children: "Fermer"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "external-sources-top",
                        children: externalSources.filter((source)=>source.position === "top").map((source)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _externalSourceDefault.default), {
                                source: source,
                                onDelete: ()=>{
                                    setExternalSources((prev)=>prev.filter((s)=>s.id !== source.id));
                                },
                                editorMode: editorMode
                            }, source.id))
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "grai-grid-sides",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "external-sources-left",
                                children: externalSources.filter((source)=>source.position === "left").map((source)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _externalSourceDefault.default), {
                                        source: source,
                                        onDelete: ()=>{
                                            setExternalSources((prev)=>prev.filter((s)=>s.id !== source.id));
                                        },
                                        editorMode: editorMode
                                    }, source.id))
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "grai-grid-content",
                                ref: gridContentRef,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "grai-grid",
                                    style: gridStyle,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "grid-header",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "header-corner",
                                                    children: "Horizon / Fonction"
                                                }),
                                                columns.map((column)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridHeaderDefault.default), {
                                                        header: column,
                                                        isColumn: true,
                                                        onUpdate: (title)=>{
                                                            setColumns((prev)=>prev.map((col)=>col.id === column.id ? {
                                                                        ...col,
                                                                        title
                                                                    } : col));
                                                        },
                                                        onDelete: ()=>{
                                                            if (window.confirm(`Supprimer la fonction "${column.title}" ?`)) deleteColumn(column.id);
                                                        },
                                                        editorMode: editorMode,
                                                        className: getColumnHeaderClass(column.id),
                                                        style: {
                                                            backgroundColor: column.color || "#3B82F6",
                                                            color: "white",
                                                            borderTop: `4px solid ${column.color || "#3B82F6"}`
                                                        }
                                                    }, column.id))
                                            ]
                                        }),
                                        rows.map((row)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "grid-row",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridHeaderDefault.default), {
                                                        header: row,
                                                        isColumn: false,
                                                        onUpdate: (data)=>{
                                                            setRows((prev)=>prev.map((r)=>r.id === row.id ? {
                                                                        ...r,
                                                                        ...data
                                                                    } : r));
                                                        },
                                                        onDelete: ()=>{
                                                            if (window.confirm(`Supprimer l'horizon "${row.title}" ?`)) deleteRow(row.id);
                                                        },
                                                        editorMode: editorMode,
                                                        className: getRowHeaderClass(row.id)
                                                    }),
                                                    columns.map((column)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridCellDefault.default), {
                                                            id: `cell-${row.id}-${column.id}`,
                                                            rowId: row.id,
                                                            colId: column.id,
                                                            content: cells[`${row.id}-${column.id}`]?.content || "",
                                                            onClick: (e)=>handleCellClick(row.id, column.id, e),
                                                            onUpdate: (content)=>updateCell(row.id, column.id, content),
                                                            editorMode: editorMode,
                                                            isStart: arrowStart && arrowStart.rowId === row.id && arrowStart.colId === column.id,
                                                            className: connectedCellsClasses[`${row.id}-${column.id}`],
                                                            onOpenSubEditor: (r, c)=>{
                                                                const key = `${r}-${c}`;
                                                                setActiveCell(key);
                                                                const existing = cellDiagrams[key];
                                                                setSubNodes(existing?.nodes || []);
                                                                setSubEdges(existing?.edges || []);
                                                            }
                                                        }, `${row.id}-${column.id}`))
                                                ]
                                            }, row.id)),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrowManagerDefault.default), {
                                            ref: arrowManagerRef,
                                            arrows: arrows,
                                            columns: columns,
                                            rows: rows,
                                            containerRef: gridContentRef,
                                            zoomLevel: zoomLevel,
                                            editorMode: editorMode,
                                            deleteArrow: deleteArrow,
                                            changeArrowType: changeArrowType,
                                            getArrowClass: (arrow)=>validationErrors.find((e)=>e.arrowId === arrow.id) ? "validation-error" : "",
                                            onArrowHover: (arrow, position)=>{
                                                const startCell = columns.find((c)=>c.id === arrow.start.colId)?.title;
                                                const endCell = columns.find((c)=>c.id === arrow.end.colId)?.title;
                                                const startRow = rows.find((r)=>r.id === arrow.start.rowId)?.title;
                                                const endRow = rows.find((r)=>r.id === arrow.end.rowId)?.title;
                                                const arrowTypeLabel = arrow.type === "decision" ? "D\xe9cision (Bleu)" : arrow.type === "information" ? "Information (Rouge)" : "Relation verticale (Vert)";
                                                const tooltipText = `${arrowTypeLabel}: ${startCell} (${startRow}) \u{2192} ${endCell} (${endRow})`;
                                                setArrowTooltip({
                                                    visible: true,
                                                    text: tooltipText,
                                                    x: position.x,
                                                    y: position.y,
                                                    arrowId: arrow.id
                                                });
                                            },
                                            onArrowLeave: ()=>{
                                                setArrowTooltip((prev)=>({
                                                        ...prev,
                                                        visible: false
                                                    }));
                                            }
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "external-sources-right",
                                children: externalSources.filter((source)=>source.position === "right").map((source)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _externalSourceDefault.default), {
                                        source: source,
                                        onDelete: ()=>{
                                            setExternalSources((prev)=>prev.filter((s)=>s.id !== source.id));
                                        },
                                        editorMode: editorMode
                                    }, source.id))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "external-sources-bottom",
                        children: externalSources.filter((source)=>source.position === "bottom").map((source)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _externalSourceDefault.default), {
                                source: source,
                                onDelete: ()=>{
                                    setExternalSources((prev)=>prev.filter((s)=>s.id !== source.id));
                                },
                                editorMode: editorMode
                            }, source.id))
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "grai-zoom-controls",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: "zoom-button",
                                onClick: handleZoomOut,
                                disabled: zoomLevel <= 50,
                                onMouseEnter: (e)=>handleShowTooltip(e, "R\xe9duire"),
                                onMouseLeave: handleHideTooltip,
                                children: "\u2212"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                className: "zoom-level",
                                children: [
                                    zoomLevel,
                                    "%"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: "zoom-button",
                                onClick: handleZoomReset,
                                onMouseEnter: (e)=>handleShowTooltip(e, "R\xe9initialiser"),
                                onMouseLeave: handleHideTooltip,
                                children: "\u2299"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: "zoom-button",
                                onClick: handleZoomIn,
                                disabled: zoomLevel >= 200,
                                onMouseEnter: (e)=>handleShowTooltip(e, "Agrandir"),
                                onMouseLeave: handleHideTooltip,
                                children: "+"
                            })
                        ]
                    })
                ]
            }),
            isExporting && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "export-loading",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "export-loading-content",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "export-loading-spinner"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                            children: "Pr\xe9paration de l'exportation"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: "Veuillez patienter pendant que nous pr\xe9parons votre grille GRAI pour l'exportation..."
                        })
                    ]
                })
            }),
            notification && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: `grai-notification ${notification.type}`,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "notification-content",
                    children: [
                        notification.type === "success" && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                            width: "20",
                            height: "20",
                            viewBox: "0 0 20 20",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M10 18.333C14.6024 18.333 18.333 14.6024 18.333 10C18.333 5.39763 14.6024 1.66667 10 1.66667C5.39762 1.66667 1.66666 5.39763 1.66666 10C1.66666 14.6024 5.39762 18.333 10 18.333Z",
                                    stroke: "#10B981",
                                    strokeWidth: "1.5",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M6.66666 10L9.16666 12.5L13.3333 8.33334",
                                    stroke: "#10B981",
                                    strokeWidth: "1.5",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                })
                            ]
                        }),
                        notification.type === "error" && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                            width: "20",
                            height: "20",
                            viewBox: "0 0 20 20",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M10 18.333C14.6024 18.333 18.333 14.6024 18.333 10C18.333 5.39763 14.6024 1.66667 10 1.66667C5.39762 1.66667 1.66666 5.39763 1.66666 10C1.66666 14.6024 5.39762 18.333 10 18.333Z",
                                    stroke: "#EF4444",
                                    strokeWidth: "1.5",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M12.5 7.5L7.5 12.5",
                                    stroke: "#EF4444",
                                    strokeWidth: "1.5",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M7.5 7.5L12.5 12.5",
                                    stroke: "#EF4444",
                                    strokeWidth: "1.5",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                })
                            ]
                        }),
                        notification.type === "info" && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                            width: "20",
                            height: "20",
                            viewBox: "0 0 20 20",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M10 18.333C14.6024 18.333 18.333 14.6024 18.333 10C18.333 5.39763 14.6024 1.66667 10 1.66667C5.39762 1.66667 1.66666 5.39763 1.66666 10C1.66666 14.6024 5.39762 18.333 10 18.333Z",
                                    stroke: "#3B82F6",
                                    strokeWidth: "1.5",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M10 6.66667V10",
                                    stroke: "#3B82F6",
                                    strokeWidth: "1.5",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M10 13.333H10.0083",
                                    stroke: "#3B82F6",
                                    strokeWidth: "1.5",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                })
                            ]
                        }),
                        notification.message
                    ]
                })
            }),
            activeCell && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "subeditor-overlay",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "subeditor-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "subeditor-header",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h3", {
                                    children: [
                                        "Diagramme pour la cellule ",
                                        activeCell
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    className: "subeditor-close",
                                    onClick: ()=>setActiveCell(null),
                                    children: "\u2715"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "subeditor-toolbar",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    onClick: ()=>addNode("Activit\xe9", {
                                            background: "#e0f2fe",
                                            border: "2px solid #2563eb",
                                            borderRadius: 6,
                                            width: 140,
                                            height: 60
                                        }),
                                    children: "\uD83D\uDFE6 Activit\xe9"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    onClick: ()=>addNode("D\xe9cision", {
                                            background: "#fef9c3",
                                            border: "2px solid #eab308",
                                            shape: "diamond",
                                            width: 100,
                                            height: 100
                                        }),
                                    children: "\uD83D\uDD36 D\xe9cision"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    onClick: ()=>addNode("Donn\xe9e", {
                                            background: "#ecfdf5",
                                            border: "2px solid #10b981",
                                            shape: "parallelogram",
                                            width: 150,
                                            height: 60
                                        }),
                                    children: "\uD83D\uDCC4 Donn\xe9e"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    onClick: ()=>addNode("D\xe9but", {
                                            background: "#dcfce7",
                                            border: "2px solid #16a34a",
                                            borderRadius: "50%",
                                            width: 70,
                                            height: 70
                                        }),
                                    children: "\uD83D\uDFE2 D\xe9but"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    onClick: ()=>addNode("Fin", {
                                            background: "#fee2e2",
                                            border: "2px solid #ef4444",
                                            borderRadius: "50%",
                                            width: 70,
                                            height: 70
                                        }),
                                    children: "\uD83D\uDD34 Fin"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    onClick: ()=>addNode("Commentaire", {
                                            background: "#f3f4f6",
                                            border: "1px dashed #6b7280",
                                            padding: "8px 12px",
                                            fontStyle: "italic",
                                            color: "#374151"
                                        }),
                                    children: "\uD83D\uDCAC Commentaire"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    onClick: ()=>setSubEdges((prev)=>prev.slice(0, -1)),
                                    style: {
                                        color: "red"
                                    },
                                    children: "\uD83D\uDDD1 Supprimer fl\xe8che"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    onClick: ()=>{
                                        if (window.confirm("Effacer tout le diagramme ?")) {
                                            setSubNodes([]);
                                            setSubEdges([]);
                                        }
                                    },
                                    style: {
                                        color: "darkred"
                                    },
                                    children: "\u274C Tout effacer"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "subeditor-body",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactflowDefault.default), {
                                nodes: subNodes.map((node)=>({
                                        ...node,
                                        type: "editable"
                                    })),
                                edges: subEdges,
                                onNodesChange: (changes)=>setSubNodes((nds)=>(0, _reactflow.applyNodeChanges)(changes, nds)),
                                onEdgesChange: (changes)=>setSubEdges((eds)=>(0, _reactflow.applyEdgeChanges)(changes, eds)),
                                onConnect: (params)=>setSubEdges((eds)=>[
                                            ...eds,
                                            {
                                                ...params,
                                                type: "orthogonal",
                                                markerEnd: "url(#arrow)",
                                                style: {
                                                    stroke: "#111",
                                                    strokeWidth: 1.6
                                                }
                                            }
                                        ]),
                                fitView: true,
                                panOnDrag: true,
                                zoomOnScroll: true,
                                nodesDraggable: true,
                                nodesConnectable: true,
                                elementsSelectable: true,
                                defaultEdgeOptions: {
                                    type: "orthogonal",
                                    markerEnd: "url(#arrow)",
                                    style: {
                                        stroke: "#111",
                                        strokeWidth: 1.6
                                    }
                                },
                                nodeTypes: {
                                    editable: ({ id, data })=>{
                                        const [isEditing, setIsEditing] = (0, _reactDefault.default).useState(false);
                                        const [text, setText] = (0, _reactDefault.default).useState(data.label || "");
                                        const handleSave = ()=>{
                                            setIsEditing(false);
                                            setSubNodes((prev)=>prev.map((n)=>n.id === id ? {
                                                        ...n,
                                                        data: {
                                                            ...n.data,
                                                            label: text
                                                        }
                                                    } : n));
                                        };
                                        const style = {
                                            ...data.style || {},
                                            cursor: isEditing ? "text" : "move",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            userSelect: "none",
                                            position: "relative",
                                            textAlign: "center",
                                            overflow: "hidden"
                                        };
                                        if (data.style?.shape === "diamond") style.clipPath = "polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%)";
                                        else if (data.style?.shape === "parallelogram") style.clipPath = "polygon(15% 0%, 100% 0%, 85% 100%, 0% 100%)";
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            style: style,
                                            onDoubleClick: (e)=>{
                                                e.stopPropagation();
                                                setIsEditing(true);
                                            },
                                            children: isEditing ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                value: text,
                                                onChange: (e)=>setText(e.target.value),
                                                onBlur: handleSave,
                                                onKeyDown: (e)=>e.key === "Enter" && handleSave(),
                                                autoFocus: true,
                                                style: {
                                                    width: "90%",
                                                    border: "none",
                                                    outline: "none",
                                                    background: "transparent",
                                                    textAlign: "center",
                                                    fontWeight: "inherit",
                                                    color: "inherit"
                                                },
                                                onClick: (e)=>e.stopPropagation()
                                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: text
                                            })
                                        });
                                    }
                                },
                                style: {
                                    width: "100%",
                                    height: "100%"
                                },
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                        style: {
                                            height: 0,
                                            width: 0,
                                            position: "absolute"
                                        },
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("marker", {
                                                id: "arrow",
                                                markerWidth: "12",
                                                markerHeight: "12",
                                                refX: "12",
                                                refY: "6",
                                                orient: "auto",
                                                markerUnits: "strokeWidth",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                    d: "M0,0 L12,6 L0,12 L4,6 z",
                                                    fill: "#111"
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactflow.MiniMap), {}),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactflow.Controls), {}),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactflow.Background), {
                                        color: "#ddd",
                                        gap: 16
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "subeditor-footer",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                onClick: ()=>{
                                    setCellDiagrams({
                                        ...cellDiagrams,
                                        [activeCell]: {
                                            nodes: subNodes,
                                            edges: subEdges
                                        }
                                    });
                                    setActiveCell(null);
                                    showNotification("Sous-diagramme sauvegard\xe9", "success");
                                },
                                className: "subeditor-save",
                                children: "\uD83D\uDCBE Enregistrer"
                            })
                        })
                    ]
                })
            }),
            tooltip.visible && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "grai-tooltip visible",
                style: {
                    top: `${Number.isFinite(tooltip.y) ? tooltip.y : 0}px`,
                    left: `${Number.isFinite(tooltip.x) ? tooltip.x : 0}px`,
                    transform: `translateX(-50%)`
                },
                children: tooltip.text
            }),
            arrowTooltip.visible && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "arrow-tooltip visible",
                style: {
                    left: `${Number.isFinite(arrowTooltip.x) ? arrowTooltip.x + 15 : 0}px`,
                    top: `${Number.isFinite(arrowTooltip.y) ? arrowTooltip.y - 10 : 0}px`
                },
                children: arrowTooltip.text.split("\n").map((line, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        children: line
                    }, i))
            })
        ]
    });
};
exports.default = GRAIEditor;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./GRAIEditor.css":"dQrt9","reactflow":[["applyEdgeChanges","jvp3v"],["applyNodeChanges","jvp3v"],["default","jvp3v","ReactFlow"],["Background","lA6mU"],["Controls","9o7DF"],["MiniMap","bawIp"]],"reactflow/dist/style.css":"BZvWP","html2canvas":"3eyQ5","jspdf":"hkJ4Q","./GridHeader":"2IX98","./GridCell":"61cKY","./ArrowManager":"hWuHm","./Toolbar":"969kX","./ExternalSource":"4DgUn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dQrt9":[function() {},{}],"BZvWP":[function() {},{}],"2IX98":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const GridHeader = ({ header, isColumn, onUpdate, onDelete, editorMode, className = '' })=>{
    const [isEditing, setIsEditing] = (0, _react.useState)(false);
    const [title, setTitle] = (0, _react.useState)(header.title || '');
    const [horizon, setHorizon] = (0, _react.useState)(header.horizon || '');
    const [isHovered, setIsHovered] = (0, _react.useState)(false);
    const inputRef = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        if (isEditing && inputRef.current) inputRef.current.focus();
    }, [
        isEditing
    ]);
    const handleEdit = ()=>{
        if (editorMode === 'cell') setIsEditing(true);
    };
    const handleSave = ()=>{
        if (isColumn) onUpdate(title);
        else onUpdate({
            title,
            horizon
        });
        setIsEditing(false);
    };
    const handleCancel = ()=>{
        setTitle(header.title);
        setHorizon(header.horizon || '');
        setIsEditing(false);
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter') {
            e.preventDefault();
            handleSave();
        } else if (e.key === 'Escape') {
            e.preventDefault();
            handleCancel();
        }
    };
    // Gérer le survol
    const handleMouseEnter = ()=>{
        setIsHovered(true);
    };
    const handleMouseLeave = ()=>{
        setIsHovered(false);
    };
    // Déterminer si l'en-tête est obligatoire
    const isObligatory = header.isObligatory || false;
    const isPseudoFunction = header.isPseudoFunction || false;
    // Classe conditionnelle pour les en-têtes obligatoires ou pseudo-fonctions
    const headerTypeClass = isObligatory ? 'obligatory' : '';
    const pseudoFunctionClass = isPseudoFunction ? 'pseudo-function' : '';
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `grid-header-cell ${isColumn ? 'column-header' : 'row-header'} ${headerTypeClass} ${pseudoFunctionClass} ${className}`,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        "data-id": isColumn ? `header-col-${header.id}` : `header-row-${header.id}`,
        children: [
            isEditing ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "header-edit-form",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        ref: inputRef,
                        type: "text",
                        value: title,
                        onChange: (e)=>setTitle(e.target.value),
                        onKeyDown: handleKeyDown,
                        className: "header-input",
                        placeholder: isColumn ? "Titre de la fonction" : "Titre de l'horizon"
                    }),
                    !isColumn && /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        type: "text",
                        value: horizon,
                        onChange: (e)=>setHorizon(e.target.value),
                        onKeyDown: handleKeyDown,
                        className: "header-input",
                        placeholder: "Code horizon (ex: H1)"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "header-edit-buttons",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                onClick: handleSave,
                                className: "header-button confirm",
                                children: "\u2713"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                onClick: handleCancel,
                                className: "header-button cancel",
                                children: "\u2717"
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "header-content",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "header-title",
                        children: [
                            title,
                            title && title.length > 20 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "header-title-tooltip",
                                children: title
                            })
                        ]
                    }),
                    !isColumn && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "header-subtitle",
                        children: horizon
                    }),
                    editorMode === 'cell' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: `header-action-buttons ${isHovered ? 'visible' : ''}`,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                onClick: handleEdit,
                                className: "header-button edit",
                                title: "Modifier",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "12",
                                    height: "12",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    strokeWidth: "2",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M17 3a2.85 2.85 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"
                                    })
                                })
                            }),
                            !header.isFixed && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                onClick: onDelete,
                                className: "header-button delete",
                                title: "Supprimer",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "12",
                                    height: "12",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    strokeWidth: "2",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                            d: "M3 6h18"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                            d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            isObligatory && !isEditing && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "obligatory-indicator",
                title: "Fonction obligatoire",
                children: "*"
            }),
            isPseudoFunction && !isEditing && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "pseudo-function-indicator",
                title: "Pseudo-fonction",
                children: "P"
            })
        ]
    });
};
exports.default = GridHeader;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"61cKY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const GridCell = ({ content, onClick, onUpdate, editorMode, isArrowStart, className, id, rowId, colId, onOpenSubEditor })=>{
    const [isEditing, setIsEditing] = (0, _react.useState)(false);
    const [cellContent, setCellContent] = (0, _react.useState)(content || '');
    const [isHovered, setIsHovered] = (0, _react.useState)(false);
    const [isExpanded, setIsExpanded] = (0, _react.useState)(false);
    const [hasLongContent, setHasLongContent] = (0, _react.useState)(false);
    // États pour le redimensionnement
    const [cellHeight, setCellHeight] = (0, _react.useState)(null);
    const [cellWidth, setCellWidth] = (0, _react.useState)(null);
    const [isResizing, setIsResizing] = (0, _react.useState)(false);
    const [resizeDirection, setResizeDirection] = (0, _react.useState)(null); // 'vertical' ou 'horizontal'
    const inputRef = (0, _react.useRef)(null);
    const cellRef = (0, _react.useRef)(null);
    const contentRef = (0, _react.useRef)(null);
    // Mettre à jour le contenu local lorsque la prop content change
    (0, _react.useEffect)(()=>{
        setCellContent(content || '');
    }, [
        content
    ]);
    // Détecter les contenus longs qui pourraient nécessiter un bouton d'expansion
    (0, _react.useEffect)(()=>{
        if (contentRef.current && content) {
            // Vérifier si le contenu dépasse la taille visible de la cellule
            const isContentOverflowing = content.length > 150 || // Texte très long
            content.split('\n').length > 3 || // Plusieurs lignes
            contentRef.current.scrollHeight > contentRef.current.clientHeight || contentRef.current.scrollWidth > contentRef.current.clientWidth;
            setHasLongContent(isContentOverflowing);
        }
    }, [
        content,
        contentRef
    ]);
    // Focus sur l'input lors de l'entrée en mode édition
    (0, _react.useEffect)(()=>{
        if (isEditing && inputRef.current) {
            inputRef.current.focus();
            inputRef.current.select();
        }
    }, [
        isEditing
    ]);
    // Animer la cellule après modification
    (0, _react.useEffect)(()=>{
        if (!isEditing && cellRef.current && cellContent !== content) {
            cellRef.current.classList.add('animate-pulse');
            const timer = setTimeout(()=>{
                if (cellRef.current) cellRef.current.classList.remove('animate-pulse');
            }, 1500);
            return ()=>clearTimeout(timer);
        }
    }, [
        isEditing,
        content,
        cellContent
    ]);
    // Déterminer si la cellule est éditable
    const canEdit = editorMode === 'cell';
    // Gérer le clic sur la cellule
    const handleCellClick = ()=>{
        if (canEdit) setIsEditing(true);
        else onClick();
    };
    // Gérer l'enregistrement des modifications
    const handleSave = ()=>{
        if (cellContent !== content) onUpdate(cellContent);
        setIsEditing(false);
    };
    // Gérer la touche Entrée pendant l'édition
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleSave();
        } else if (e.key === 'Escape') {
            setIsEditing(false);
            setCellContent(content || '');
        }
    };
    // Basculer l'état d'expansion
    const toggleExpand = (e)=>{
        e.stopPropagation();
        setIsExpanded(!isExpanded);
    };
    // Fonctions pour le redimensionnement vertical des cellules
    const handleResizeVerticalStart = (e)=>{
        e.stopPropagation();
        e.preventDefault();
        if (!cellRef.current) return;
        setIsResizing(true);
        setResizeDirection('vertical');
        const startY = e.clientY;
        const startHeight = cellRef.current.offsetHeight;
        const handleMouseMove = (moveEvent)=>{
            const newHeight = startHeight + (moveEvent.clientY - startY);
            if (newHeight >= 40) {
                setCellHeight(newHeight);
                if (cellRef.current) {
                    cellRef.current.style.height = `${newHeight}px`;
                    cellRef.current.classList.add('has-custom-height');
                }
            }
        };
        const handleMouseUp = ()=>{
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
            setIsResizing(false);
            setResizeDirection(null);
            // Enregistrer la hauteur dans localStorage pour cette cellule spécifique
            if (cellHeight) {
                const cellSizes = JSON.parse(localStorage.getItem('graiCellSizes') || '{}');
                cellSizes[`${rowId}-${colId}`] = {
                    ...cellSizes[`${rowId}-${colId}`] || {},
                    height: cellHeight
                };
                localStorage.setItem('graiCellSizes', JSON.stringify(cellSizes));
            }
        };
        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
    };
    // Fonctions pour le redimensionnement horizontal des cellules
    const handleResizeHorizontalStart = (e)=>{
        e.stopPropagation();
        e.preventDefault();
        if (!cellRef.current) return;
        setIsResizing(true);
        setResizeDirection('horizontal');
        const startX = e.clientX;
        const startWidth = cellRef.current.offsetWidth;
        const handleMouseMove = (moveEvent)=>{
            const newWidth = startWidth + (moveEvent.clientX - startX);
            if (newWidth >= 100) {
                setCellWidth(newWidth);
                if (cellRef.current) {
                    cellRef.current.style.width = `${newWidth}px`;
                    cellRef.current.style.minWidth = `${newWidth}px`;
                    cellRef.current.style.maxWidth = `${newWidth}px`;
                    cellRef.current.classList.add('has-custom-width');
                }
            }
        };
        const handleMouseUp = ()=>{
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
            setIsResizing(false);
            setResizeDirection(null);
            // Enregistrer la largeur dans localStorage pour cette cellule spécifique
            if (cellWidth) {
                const cellSizes = JSON.parse(localStorage.getItem('graiCellSizes') || '{}');
                cellSizes[`${rowId}-${colId}`] = {
                    ...cellSizes[`${rowId}-${colId}`] || {},
                    width: cellWidth
                };
                localStorage.setItem('graiCellSizes', JSON.stringify(cellSizes));
            }
        };
        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
    };
    // Charger les dimensions sauvegardées au montage
    (0, _react.useEffect)(()=>{
        const cellSizes = JSON.parse(localStorage.getItem('graiCellSizes') || '{}');
        const savedSize = cellSizes[`${rowId}-${colId}`];
        if (savedSize && cellRef.current) {
            if (savedSize.height) {
                setCellHeight(savedSize.height);
                cellRef.current.style.height = `${savedSize.height}px`;
                cellRef.current.classList.add('has-custom-height');
            }
            if (savedSize.width) {
                setCellWidth(savedSize.width);
                cellRef.current.style.width = `${savedSize.width}px`;
                cellRef.current.style.minWidth = `${savedSize.width}px`;
                cellRef.current.style.maxWidth = `${savedSize.width}px`;
                cellRef.current.classList.add('has-custom-width');
            }
        }
    }, [
        rowId,
        colId
    ]);
    // Réinitialiser les dimensions
    const resetDimensions = (e, type)=>{
        e.stopPropagation();
        if (!cellRef.current) return;
        const cellSizes = JSON.parse(localStorage.getItem('graiCellSizes') || '{}');
        const existingSize = cellSizes[`${rowId}-${colId}`] || {};
        if (type === 'height' || type === 'all') {
            setCellHeight(null);
            cellRef.current.style.height = '';
            cellRef.current.classList.remove('has-custom-height');
            delete existingSize.height;
        }
        if (type === 'width' || type === 'all') {
            setCellWidth(null);
            cellRef.current.style.width = '';
            cellRef.current.style.minWidth = '';
            cellRef.current.style.maxWidth = '';
            cellRef.current.classList.remove('has-custom-width');
            delete existingSize.width;
        }
        // Mettre à jour ou supprimer l'entrée dans localStorage
        if (Object.keys(existingSize).length > 0) cellSizes[`${rowId}-${colId}`] = existingSize;
        else delete cellSizes[`${rowId}-${colId}`];
        localStorage.setItem('graiCellSizes', JSON.stringify(cellSizes));
    };
    // Déterminer les classes CSS
    const cellClasses = [
        'grid-cell',
        canEdit ? 'editable' : '',
        isArrowStart ? 'is-arrow-start' : '',
        editorMode === 'arrow' ? 'arrow-mode' : '',
        isHovered && canEdit ? 'cell-hovered' : '',
        hasLongContent ? 'has-long-content' : '',
        isExpanded ? 'expanded' : '',
        isResizing ? `resizing resizing-${resizeDirection}` : '',
        cellHeight ? 'has-custom-height' : '',
        cellWidth ? 'has-custom-width' : '',
        className || ''
    ].filter(Boolean).join(' ');
    // Gérer le survol
    const handleMouseEnter = ()=>{
        setIsHovered(true);
    };
    const handleMouseLeave = ()=>{
        setIsHovered(false);
    };
    // Contenu de la cellule
    const cellContentElement = isEditing ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
        ref: inputRef,
        value: cellContent,
        onChange: (e)=>setCellContent(e.target.value),
        onBlur: handleSave,
        onKeyDown: handleKeyDown,
        className: "cell-input",
        onClick: (e)=>e.stopPropagation(),
        placeholder: "Entrez le contenu ici..."
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "grid-cell-content",
        ref: contentRef,
        children: cellContent ? cellContent.split('\n').map((line, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                children: [
                    line,
                    index < cellContent.split('\n').length - 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {})
                ]
            }, index)) : canEdit && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "empty-cell-indicator",
            children: isHovered && /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "18",
                height: "18",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M17 3a2.85 2.85 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"
                })
            })
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        ref: cellRef,
        className: cellClasses,
        onClick: handleCellClick,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        title: canEdit ? "Cliquez pour \xe9diter" : editorMode === 'arrow' ? "Cliquez pour cr\xe9er une relation" : "",
        id: id,
        children: [
            cellContentElement,
            isHovered && canEdit && !isEditing && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "cell-edit-indicator",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "14",
                    height: "14",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M17 3a2.85 2.85 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"
                    })
                })
            }),
            !isEditing && hasLongContent && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                className: "cell-expand-button",
                onClick: toggleExpand,
                title: isExpanded ? "R\xe9duire" : "Afficher tout le contenu",
                children: isExpanded ? "\u2212" : "+"
            }),
            canEdit && !isEditing && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "cell-resize-handle-bottom",
                onMouseDown: handleResizeVerticalStart,
                title: "Redimensionner la hauteur",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "resize-handle-indicator"
                })
            }),
            canEdit && !isEditing && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "cell-resize-handle-right",
                onMouseDown: handleResizeHorizontalStart,
                title: "Redimensionner la largeur",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "resize-handle-indicator"
                })
            }),
            canEdit && !isEditing && (cellHeight || cellWidth) && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "cell-dimensions-controls",
                children: [
                    cellHeight && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        className: "cell-reset-size reset-height",
                        onClick: (e)=>resetDimensions(e, 'height'),
                        title: "R\xe9initialiser la hauteur",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "12",
                                height: "12",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M3 2v6h6"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M3 13a9 9 0 1 0 3-7.7L3 8"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "dimension-icon",
                                children: "\u2195"
                            })
                        ]
                    }),
                    cellWidth && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        className: "cell-reset-size reset-width",
                        onClick: (e)=>resetDimensions(e, 'width'),
                        title: "R\xe9initialiser la largeur",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "12",
                                height: "12",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M3 2v6h6"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M3 13a9 9 0 1 0 3-7.7L3 8"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "dimension-icon",
                                children: "\u2194"
                            })
                        ]
                    }),
                    cellHeight && cellWidth && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: "cell-reset-size reset-all",
                        onClick: (e)=>resetDimensions(e, 'all'),
                        title: "R\xe9initialiser toutes les dimensions",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "12",
                            height: "12",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            strokeWidth: "2",
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M3 2v6h6"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M3 13a9 9 0 1 0 3-7.7L3 8"
                                })
                            ]
                        })
                    })
                ]
            }),
            isHovered && !isEditing && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                className: "cell-subeditor-button",
                onClick: (e)=>{
                    e.stopPropagation();
                    if (onOpenSubEditor) onOpenSubEditor(rowId, colId);
                },
                title: "Ouvrir le sous-\xe9diteur",
                children: "+"
            })
        ]
    });
};
exports.default = GridCell;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hWuHm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const ArrowManager = /*#__PURE__*/ (0, _react.forwardRef)(({ arrows, columns, rows, deleteArrow, changeArrowType, containerRef, zoomLevel, editorMode, getArrowClass, onArrowHover, onArrowLeave }, ref)=>{
    const [cellPositions, setCellPositions] = (0, _react.useState)({});
    const [activeArrow, setActiveArrow] = (0, _react.useState)(null);
    const [menuPosition, setMenuPosition] = (0, _react.useState)({
        x: 0,
        y: 0
    });
    // ✅ Sécurisation anti-NaN dès le départ
    (0, _react.useEffect)(()=>{
        if (!menuPosition || !Number.isFinite(menuPosition.x) || !Number.isFinite(menuPosition.y)) {
            console.warn("\uD83E\uDDE9 Correction automatique d'un menuPosition invalide :", menuPosition);
            setMenuPosition({
                x: 0,
                y: 0
            });
        }
    }, [
        menuPosition
    ]);
    // ✅ Calcul des positions précises des cellules avec zoom + scroll
    const calculateCellPositions = (0, _react.useCallback)(()=>{
        if (!containerRef?.current) return;
        const grid = containerRef.current.querySelector(".grai-grid");
        if (!grid) return;
        const gridRect = grid.getBoundingClientRect();
        const scrollX = containerRef.current.scrollLeft;
        const scrollY = containerRef.current.scrollTop;
        const zoomRatio = zoomLevel / 100;
        const cells = grid.querySelectorAll(".grid-cell");
        const positions = {};
        cells.forEach((cell)=>{
            const id = cell.id;
            if (!id || !id.startsWith("cell-")) return;
            const [, rowStr, colStr] = id.split("-");
            const rowId = parseInt(rowStr);
            const colId = parseInt(colStr);
            if (isNaN(rowId) || isNaN(colId)) return;
            const rect = cell.getBoundingClientRect();
            // ✅ Coordonnées ajustées selon le scroll et le zoom
            const adjustedX = (rect.left - gridRect.left + rect.width / 2 + scrollX) * zoomRatio;
            const adjustedY = (rect.top - gridRect.top + rect.height / 2 + scrollY) * zoomRatio;
            positions[`${rowId}-${colId}`] = {
                x: adjustedX,
                y: adjustedY
            };
        });
        setCellPositions(positions);
    }, [
        containerRef,
        zoomLevel
    ]);
    // ✅ Permet un recalcul externe (depuis GRAIEditor)
    (0, _react.useImperativeHandle)(ref, ()=>({
            calculateCellPositions
        }));
    // ⚙️ Recalcul automatique à chaque changement
    (0, _react.useEffect)(()=>{
        calculateCellPositions();
        const timer = setTimeout(calculateCellPositions, 300);
        return ()=>clearTimeout(timer);
    }, [
        columns,
        rows,
        zoomLevel,
        calculateCellPositions
    ]);
    // ✅ Recalcule aussi en cas de scroll du conteneur
    (0, _react.useEffect)(()=>{
        const handleScroll = ()=>calculateCellPositions();
        if (containerRef.current) containerRef.current.addEventListener("scroll", handleScroll);
        return ()=>{
            if (containerRef.current) containerRef.current.removeEventListener("scroll", handleScroll);
        };
    }, [
        calculateCellPositions
    ]);
    // ✅ Création des flèches avec position exacte centre à centre
    const createArrowPath = (arrow)=>{
        const start = cellPositions[`${arrow.start.rowId}-${arrow.start.colId}`];
        const end = cellPositions[`${arrow.end.rowId}-${arrow.end.colId}`];
        if (!start || !end) return null;
        return {
            path: `M ${start.x} ${start.y} L ${end.x} ${end.y}`,
            color: arrow.type === "decision" ? "#2563EB" : "#DC2626",
            thickness: arrow.type === "decision" ? 7 : 2
        };
    };
    // ✅ Gestion du clic sur une flèche
    const handleArrowClick = (e, arrow)=>{
        if (editorMode === "delete") {
            deleteArrow(arrow.id);
            return;
        }
        e.stopPropagation();
        const rect = containerRef?.current?.getBoundingClientRect?.() || {
            left: 0,
            top: 0
        };
        const rawX = Number(e?.clientX) || 0;
        const rawY = Number(e?.clientY) || 0;
        const left = Number(rect?.left) || 0;
        const top = Number(rect?.top) || 0;
        const x = rawX - left;
        const y = rawY - top;
        setMenuPosition({
            x: Number.isFinite(x) ? x : 0,
            y: Number.isFinite(y) ? y : 0
        });
        setActiveArrow(arrow);
    };
    // ✅ Changement de type ou suppression
    const handleTypeChange = (type)=>{
        if (activeArrow) {
            changeArrowType(activeArrow.id, type);
            setActiveArrow(null);
        }
    };
    const handleDelete = ()=>{
        if (activeArrow) {
            deleteArrow(activeArrow.id);
            setActiveArrow(null);
        }
    };
    // ✅ Valeurs sécurisées
    const safeX = menuPosition && Number.isFinite(menuPosition.x) ? menuPosition.x : 0;
    const safeY = menuPosition && Number.isFinite(menuPosition.y) ? menuPosition.y : 0;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "arrow-container",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                className: "arrow-svg",
                width: containerRef.current?.scrollWidth || "100%",
                height: containerRef.current?.scrollHeight || "100%",
                style: {
                    position: "absolute",
                    top: 0,
                    left: 0,
                    pointerEvents: "none",
                    zIndex: 10
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("marker", {
                                id: "arrowhead-decision",
                                markerWidth: "14",
                                markerHeight: "14",
                                refX: "12",
                                refY: "7",
                                orient: "auto",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("polygon", {
                                    points: "0 0, 14 7, 0 14",
                                    fill: "#3B82F6"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("marker", {
                                id: "arrowhead-information",
                                markerWidth: "10",
                                markerHeight: "6",
                                refX: "10",
                                refY: "3",
                                orient: "auto",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("polygon", {
                                    points: "0 0, 10 3, 0 6",
                                    fill: "#EF4444"
                                })
                            })
                        ]
                    }),
                    arrows.map((arrow)=>{
                        const pathData = createArrowPath(arrow);
                        if (!pathData) return null;
                        const markerId = arrow.type === "decision" ? "arrowhead-decision" : "arrowhead-information";
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            id: `arrow-${arrow.id}`,
                            d: pathData.path,
                            fill: "none",
                            stroke: pathData.color,
                            strokeWidth: pathData.thickness,
                            markerEnd: `url(#${markerId})`,
                            style: {
                                pointerEvents: "stroke",
                                cursor: "pointer"
                            },
                            onClick: (e)=>handleArrowClick(e, arrow),
                            onMouseEnter: (e)=>onArrowHover?.(arrow, e),
                            onMouseLeave: onArrowLeave
                        }, arrow.id);
                    })
                ]
            }),
            activeArrow && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "arrow-control-panel",
                style: {
                    position: "absolute",
                    left: `${safeX}px`,
                    top: `${safeY}px`,
                    zIndex: 1000,
                    background: "#fff",
                    border: "1px solid #ccc",
                    borderRadius: "8px",
                    padding: "10px"
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                        children: "Type de relation :"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: ()=>handleTypeChange("information"),
                        children: "Fl\xe8che d\u2019information"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: ()=>handleTypeChange("decision"),
                        children: "Fl\xe8che de d\xe9cision"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: handleDelete,
                        children: "Supprimer"
                    })
                ]
            })
        ]
    });
});
exports.default = ArrowManager;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"969kX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const Toolbar = ({ editorMode, setEditorMode, addColumn, addRow, addExternalSource, exportAsImage, saveGrid, loadGrid, loadEmptyTemplate, zoomLevel, onZoomIn, onZoomOut, onZoomReset, onShowTooltip, onHideTooltip, validateGrid, validationErrors, showValidationErrors, setShowValidationErrors, automaticValidation, setAutomaticValidation })=>{
    // États pour les formulaires
    const [newColumnTitle, setNewColumnTitle] = (0, _react.useState)('');
    const [newRowTitle, setNewRowTitle] = (0, _react.useState)('');
    const [newRowHorizon, setNewRowHorizon] = (0, _react.useState)('H');
    const [newSourceTitle, setNewSourceTitle] = (0, _react.useState)('');
    const [newSourcePosition, setNewSourcePosition] = (0, _react.useState)('top');
    const [columnInsertPosition, setColumnInsertPosition] = (0, _react.useState)('end');
    // États pour les modales
    const [showColumnModal, setShowColumnModal] = (0, _react.useState)(false);
    const [showRowModal, setShowRowModal] = (0, _react.useState)(false);
    const [showSourceModal, setShowSourceModal] = (0, _react.useState)(false);
    const [showHelpModal, setShowHelpModal] = (0, _react.useState)(false);
    const [showZoomControls, setShowZoomControls] = (0, _react.useState)(false);
    // Gérer l'ajout d'une colonne
    const handleAddColumn = ()=>{
        if (newColumnTitle.trim()) {
            addColumn(newColumnTitle, columnInsertPosition);
            setNewColumnTitle('');
            setColumnInsertPosition('end');
            setShowColumnModal(false);
        }
    };
    // Gérer l'ajout d'une ligne
    const handleAddRow = ()=>{
        if (newRowTitle.trim() && newRowHorizon.trim()) {
            addRow(newRowTitle, newRowHorizon);
            setNewRowTitle('');
            setNewRowHorizon('H');
            setShowRowModal(false);
        }
    };
    // Gérer l'ajout d'une source externe
    const handleAddSource = ()=>{
        if (newSourceTitle.trim()) {
            addExternalSource(newSourceTitle, newSourcePosition);
            setNewSourceTitle('');
            setShowSourceModal(false);
        }
    };
    // Annuler l'ajout
    const handleCancel = (modalSetter)=>{
        modalSetter(false);
    };
    // Gérer les touches dans les champs de texte
    const handleKeyDown = (e, submitHandler)=>{
        if (e.key === 'Enter') {
            e.preventDefault();
            submitHandler();
        } else if (e.key === 'Escape') {
            e.preventDefault();
            if (showColumnModal) handleCancel(setShowColumnModal);
            if (showRowModal) handleCancel(setShowRowModal);
            if (showSourceModal) handleCancel(setShowSourceModal);
        }
    };
    // Ajouter une nouvelle section dans la toolbar pour la validation GRAI
    const validationSection = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "toolbar-section",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                className: `toolbar-button ${validationErrors.length > 0 ? 'has-errors' : ''}`,
                onClick: ()=>{
                    validateGrid();
                    setShowValidationErrors(true);
                },
                title: "V\xe9rifier les r\xe8gles GRAI",
                onMouseEnter: (e)=>onShowTooltip(e, "Valider la conformit\xe9 aux r\xe8gles GRAI"),
                onMouseLeave: onHideTooltip,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "16",
                        height: "16",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                d: "M22 11.08V12a10 10 0 1 1-5.93-9.14"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                                points: "22 4 12 14.01 9 11.01"
                            })
                        ]
                    }),
                    "Validation",
                    validationErrors.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "validation-badge",
                        children: validationErrors.length
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "toolbar-toggle",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        type: "checkbox",
                        id: "auto-validation",
                        checked: automaticValidation,
                        onChange: ()=>setAutomaticValidation(!automaticValidation)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                        htmlFor: "auto-validation",
                        title: "Activer/d\xe9sactiver la validation automatique",
                        onMouseEnter: (e)=>onShowTooltip(e, "Validation en temps r\xe9el"),
                        onMouseLeave: onHideTooltip,
                        children: "Validation auto"
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "grai-toolbar",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "toolbar-section",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        className: `toolbar-button ${editorMode === 'cell' ? 'active' : ''}`,
                        onClick: ()=>setEditorMode('cell'),
                        title: "Mode \xc9dition",
                        onMouseEnter: (e)=>onShowTooltip(e, "Mode \xe9dition des cellules"),
                        onMouseLeave: onHideTooltip,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "16",
                                height: "16",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M17 3a2.85 2.85 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"
                                })
                            }),
                            "\xc9diter"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "toolbar-group",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                children: "Relations"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "relation-buttons",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        className: `toolbar-button ${editorMode === 'arrow-info' ? 'active' : ''}`,
                                        onClick: ()=>setEditorMode('arrow-info'),
                                        title: "Fl\xe8che d'information",
                                        onMouseEnter: (e)=>onShowTooltip(e, "Cr\xe9er une fl\xe8che d'information (rouge, horizontale)"),
                                        onMouseLeave: onHideTooltip,
                                        children: "\u279C Fl\xe8che d\u2019information"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        className: `toolbar-button ${editorMode === 'arrow-decision' ? 'active' : ''}`,
                                        onClick: ()=>setEditorMode('arrow-decision'),
                                        title: "Fl\xe8che de d\xe9cision",
                                        onMouseEnter: (e)=>onShowTooltip(e, "Cr\xe9er une fl\xe8che de d\xe9cision (bleue, verticale)"),
                                        onMouseLeave: onHideTooltip,
                                        children: "\u2B07 Fl\xe8che de d\xe9cision"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "toolbar-divider"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "toolbar-section",
                children: [
                    !showColumnModal ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        className: "toolbar-button",
                        onClick: ()=>setShowColumnModal(true),
                        title: "Ajouter une fonction",
                        onMouseEnter: (e)=>onShowTooltip(e, "Ajouter une nouvelle colonne"),
                        onMouseLeave: onHideTooltip,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "16",
                                height: "16",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                        x1: "12",
                                        y1: "5",
                                        x2: "12",
                                        y2: "19"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                        x1: "5",
                                        y1: "12",
                                        x2: "19",
                                        y2: "12"
                                    })
                                ]
                            }),
                            "Colonne"
                        ]
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "toolbar-modal",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                type: "text",
                                value: newColumnTitle,
                                onChange: (e)=>setNewColumnTitle(e.target.value),
                                onKeyDown: (e)=>handleKeyDown(e, handleAddColumn),
                                className: "toolbar-input",
                                placeholder: "Nom de la fonction",
                                autoFocus: true
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("select", {
                                value: columnInsertPosition,
                                onChange: (e)=>setColumnInsertPosition(e.target.value),
                                className: "toolbar-input",
                                title: "Choisir la position d'insertion",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                        value: "end",
                                        children: "\xc0 la fin"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                        value: "beforeProduct",
                                        children: "Avant \u201CG\xe9rer produits\u201D"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                        value: "afterResource",
                                        children: "Apr\xe8s \u201CG\xe9rer ressources\u201D"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: "toolbar-button confirm",
                                onClick: handleAddColumn,
                                title: "Confirmer",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "16",
                                    height: "16",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    strokeWidth: "2",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                                        points: "20 6 9 17 4 12"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: "toolbar-button cancel",
                                onClick: ()=>handleCancel(setShowColumnModal),
                                title: "Annuler",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "16",
                                    height: "16",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    strokeWidth: "2",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                            x1: "18",
                                            y1: "6",
                                            x2: "6",
                                            y2: "18"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                            x1: "6",
                                            y1: "6",
                                            x2: "18",
                                            y2: "18"
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    !showRowModal ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        className: "toolbar-button",
                        onClick: ()=>setShowRowModal(true),
                        title: "Ajouter un horizon temporel",
                        onMouseEnter: (e)=>onShowTooltip(e, "Ajouter un nouvel horizon"),
                        onMouseLeave: onHideTooltip,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "16",
                                height: "16",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                        x1: "12",
                                        y1: "5",
                                        x2: "12",
                                        y2: "19"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                        x1: "5",
                                        y1: "12",
                                        x2: "19",
                                        y2: "12"
                                    })
                                ]
                            }),
                            "Ligne"
                        ]
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "toolbar-modal",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "modal-form",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                        type: "text",
                                        value: newRowTitle,
                                        onChange: (e)=>setNewRowTitle(e.target.value),
                                        onKeyDown: (e)=>handleKeyDown(e, handleAddRow),
                                        className: "toolbar-input",
                                        placeholder: "Description (ex: 1 an)",
                                        autoFocus: true
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                        type: "text",
                                        value: newRowHorizon,
                                        onChange: (e)=>setNewRowHorizon(e.target.value),
                                        onKeyDown: (e)=>handleKeyDown(e, handleAddRow),
                                        className: "toolbar-input horizon-input",
                                        placeholder: "Code (ex: H1)"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: "toolbar-button confirm",
                                onClick: handleAddRow,
                                title: "Confirmer",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "16",
                                    height: "16",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    strokeWidth: "2",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                                        points: "20 6 9 17 4 12"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: "toolbar-button cancel",
                                onClick: ()=>handleCancel(setShowRowModal),
                                title: "Annuler",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "16",
                                    height: "16",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    strokeWidth: "2",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                            x1: "18",
                                            y1: "6",
                                            x2: "6",
                                            y2: "18"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                            x1: "6",
                                            y1: "6",
                                            x2: "18",
                                            y2: "18"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "toolbar-divider"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "toolbar-section",
                children: !showSourceModal ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                    className: "toolbar-button",
                    onClick: ()=>setShowSourceModal(true),
                    title: "Ajouter une source d'information",
                    onMouseEnter: (e)=>onShowTooltip(e, "Ajouter une source externe"),
                    onMouseLeave: onHideTooltip,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "16",
                            height: "16",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            strokeWidth: "2",
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M12 5v14"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M5 12h14"
                                })
                            ]
                        }),
                        "Source"
                    ]
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "toolbar-modal",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                            type: "text",
                            value: newSourceTitle,
                            onChange: (e)=>setNewSourceTitle(e.target.value),
                            onKeyDown: (e)=>handleKeyDown(e, handleAddSource),
                            className: "toolbar-input",
                            placeholder: "Nom de la source",
                            autoFocus: true
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("select", {
                            value: newSourcePosition,
                            onChange: (e)=>setNewSourcePosition(e.target.value),
                            className: "toolbar-input",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                    value: "top",
                                    children: "Haut"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                    value: "right",
                                    children: "Droite"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                    value: "bottom",
                                    children: "Bas"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                    value: "left",
                                    children: "Gauche"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            className: "toolbar-button confirm",
                            onClick: handleAddSource,
                            title: "Confirmer",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "16",
                                height: "16",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                                    points: "20 6 9 17 4 12"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            className: "toolbar-button cancel",
                            onClick: ()=>handleCancel(setShowSourceModal),
                            title: "Annuler",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "16",
                                height: "16",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                        x1: "18",
                                        y1: "6",
                                        x2: "6",
                                        y2: "18"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                        x1: "6",
                                        y1: "6",
                                        x2: "18",
                                        y2: "18"
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "toolbar-divider"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "toolbar-section",
                children: !showZoomControls ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                    className: "toolbar-button",
                    onClick: ()=>setShowZoomControls(true),
                    title: "Contr\xf4les de zoom",
                    onMouseEnter: (e)=>onShowTooltip(e, "Ajuster le niveau de zoom"),
                    onMouseLeave: onHideTooltip,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "16",
                            height: "16",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            strokeWidth: "2",
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                    cx: "11",
                                    cy: "11",
                                    r: "8"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                    x1: "21",
                                    y1: "21",
                                    x2: "16.65",
                                    y2: "16.65"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                    x1: "11",
                                    y1: "8",
                                    x2: "11",
                                    y2: "14"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                    x1: "8",
                                    y1: "11",
                                    x2: "14",
                                    y2: "11"
                                })
                            ]
                        }),
                        "Zoom ",
                        zoomLevel,
                        "%"
                    ]
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "toolbar-modal",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            className: "toolbar-button",
                            onClick: onZoomOut,
                            disabled: zoomLevel <= 50,
                            title: "Zoom arri\xe8re",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "16",
                                height: "16",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                        cx: "11",
                                        cy: "11",
                                        r: "8"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                        x1: "21",
                                        y1: "21",
                                        x2: "16.65",
                                        y2: "16.65"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                        x1: "8",
                                        y1: "11",
                                        x2: "14",
                                        y2: "11"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "zoom-level",
                            children: [
                                zoomLevel,
                                "%"
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            className: "toolbar-button",
                            onClick: onZoomReset,
                            title: "R\xe9initialiser le zoom",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "16",
                                height: "16",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M3 3v5h5"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            className: "toolbar-button",
                            onClick: onZoomIn,
                            disabled: zoomLevel >= 200,
                            title: "Zoom avant",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "16",
                                height: "16",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                        cx: "11",
                                        cy: "11",
                                        r: "8"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                        x1: "21",
                                        y1: "21",
                                        x2: "16.65",
                                        y2: "16.65"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                        x1: "11",
                                        y1: "8",
                                        x2: "11",
                                        y2: "14"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                        x1: "8",
                                        y1: "11",
                                        x2: "14",
                                        y2: "11"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            className: "toolbar-button cancel",
                            onClick: ()=>setShowZoomControls(false),
                            title: "Fermer",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "16",
                                height: "16",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                        x1: "18",
                                        y1: "6",
                                        x2: "6",
                                        y2: "18"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                        x1: "6",
                                        y1: "6",
                                        x2: "18",
                                        y2: "18"
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "toolbar-divider"
            }),
            validationSection,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "toolbar-divider"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "toolbar-section",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        className: "toolbar-button save",
                        onClick: saveGrid,
                        title: "Sauvegarder la grille",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "16",
                                height: "16",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                                        points: "17 21 17 13 7 13 7 21"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                                        points: "7 3 7 8 15 8"
                                    })
                                ]
                            }),
                            "Sauvegarder"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        className: "toolbar-button",
                        onClick: loadGrid,
                        title: "Charger une grille sauvegard\xe9e",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "16",
                                height: "16",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                                        points: "7 10 12 15 17 10"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                        x1: "12",
                                        y1: "15",
                                        x2: "12",
                                        y2: "3"
                                    })
                                ]
                            }),
                            "Charger"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        className: "toolbar-button export",
                        onClick: exportAsImage,
                        title: "Exporter en image",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "16",
                                height: "16",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                        x: "3",
                                        y: "3",
                                        width: "18",
                                        height: "18",
                                        rx: "2",
                                        ry: "2"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                        cx: "8.5",
                                        cy: "8.5",
                                        r: "1.5"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                                        points: "21 15 16 10 5 21"
                                    })
                                ]
                            }),
                            "Exporter"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "toolbar-divider"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "toolbar-section",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        className: "toolbar-button",
                        onClick: loadEmptyTemplate,
                        title: "Nouveau mod\xe8le vide",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "16",
                                height: "16",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M3 6h18"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
                                    })
                                ]
                            }),
                            "Nouveau"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        className: "toolbar-button",
                        onClick: ()=>setShowHelpModal(!showHelpModal),
                        title: "Aide sur l'outil GRAI",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "16",
                                height: "16",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                        cx: "12",
                                        cy: "12",
                                        r: "10"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                        x1: "12",
                                        y1: "17",
                                        x2: "12.01",
                                        y2: "17"
                                    })
                                ]
                            }),
                            "Aide"
                        ]
                    })
                ]
            }),
            showHelpModal && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "grai-help",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                        children: "Guide de l'\xe9diteur GRAI"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "L'\xe9diteur GRAI vous permet de cr\xe9er des mod\xe8les d\xe9cisionnels selon la m\xe9thode GRAI. Voici comment l'utiliser :"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("ul", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                        children: "\xc9diter les cellules"
                                    }),
                                    " : Cliquez sur une cellule pour \xe9diter son contenu"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                        children: "Ajouter des fl\xe8ches"
                                    }),
                                    ' : Utilisez le mode "Relations" puis cliquez sur une cellule de d\xe9part puis sur une cellule d\'arriv\xe9e'
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                        children: "Types de fl\xe8ches"
                                    }),
                                    " : Flux de d\xe9cision (bleu) ou Flux d'information (rouge)"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                        children: "Sources externes"
                                    }),
                                    " : Informations provenant de l'ext\xe9rieur du syst\xe8me"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                        children: "Navigation"
                                    }),
                                    " : Utilisez la molette de souris (avec Ctrl) pour zoomer, ou cliquez et faites glisser avec le bouton du milieu (ou Alt+clic gauche) pour d\xe9placer la grille"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                        children: "R\xe8gles GRAI appliqu\xe9es"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("ul", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                        children: "CMG1"
                                    }),
                                    " : Un cadre de d\xe9cision ne peut \xeatre re\xe7u par ce m\xeame centre"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                        children: "CMG2/4"
                                    }),
                                    " : Un cadre de d\xe9cision ne peut \xeatre \xe9mis d'une pseudo-fonction \xe0 une autre"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                        children: "CMG3"
                                    }),
                                    " : La fonction 'informations externes' est plac\xe9e exclusivement en colonne 1"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                        children: "CMG5"
                                    }),
                                    " : La fonction 'informations internes' est plac\xe9e exclusivement en derni\xe8re colonne"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                        children: "CMG6/7/8"
                                    }),
                                    " : Les fonctions 'g\xe9rer les produits', 'g\xe9rer les ressources', et 'planifier' sont obligatoires"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                        children: "CMG9"
                                    }),
                                    " : Les p\xe9riodes des niveaux d\xe9cisionnels doivent \xeatre class\xe9es par ordre d\xe9croissant"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                        children: "CMG10"
                                    }),
                                    " : Les niveaux d\xe9cisionnels ne peuvent \xeatre moins de trois dans une grille GRAI"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "Pour plus d'informations sur la m\xe9thode GRAI, consultez la documentation technique."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: "toolbar-button",
                        onClick: ()=>setShowHelpModal(false),
                        children: "Fermer"
                    })
                ]
            })
        ]
    });
};
exports.default = Toolbar;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4DgUn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const ExternalSource = ({ source, onDelete })=>{
    const [isEditing, setIsEditing] = (0, _react.useState)(false);
    const [title, setTitle] = (0, _react.useState)(source.title);
    const inputRef = (0, _react.useRef)(null);
    // Mettre à jour le titre local lorsque le titre de la source change
    (0, _react.useEffect)(()=>{
        setTitle(source.title);
    }, [
        source.title
    ]);
    // Focus sur l'input lors de l'entrée en mode édition
    (0, _react.useEffect)(()=>{
        if (isEditing && inputRef.current) inputRef.current.focus();
    }, [
        isEditing
    ]);
    // Gérer le début de l'édition
    const handleEditStart = ()=>{
        setIsEditing(true);
    };
    // Gérer l'enregistrement des modifications
    const handleSave = ()=>{
        // On pourrait ajouter une fonction de mise à jour dans les props
        setIsEditing(false);
    };
    // Gérer la touche Entrée pendant l'édition
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter') {
            e.preventDefault();
            handleSave();
        } else if (e.key === 'Escape') {
            setIsEditing(false);
            setTitle(source.title);
        }
    };
    // Déterminer les classes CSS en fonction de la position
    const sourceClasses = [
        'external-source',
        `position-${source.position}`
    ].join(' ');
    // Contenu de la source
    const sourceContent = isEditing ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
        ref: inputRef,
        type: "text",
        value: title,
        onChange: (e)=>setTitle(e.target.value),
        onBlur: handleSave,
        onKeyDown: handleKeyDown,
        className: "external-source-input",
        onClick: (e)=>e.stopPropagation()
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "external-source-content",
        onClick: handleEditStart,
        children: title
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: sourceClasses,
        children: [
            sourceContent,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                className: "external-source-delete",
                onClick: onDelete,
                title: "Supprimer",
                children: "\xd7"
            })
        ]
    });
};
exports.default = ExternalSource;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8KvQr":[function() {},{}],"bc8s9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ProcessView1);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _modeler = require("bpmn-js/lib/Modeler");
var _modelerDefault = parcelHelpers.interopDefault(_modeler);
var _html2Canvas = require("html2canvas");
var _html2CanvasDefault = parcelHelpers.interopDefault(_html2Canvas);
var _jspdf = require("jspdf");
var _diagramJsCss = require("bpmn-js/dist/assets/diagram-js.css");
var _bpmnCss = require("bpmn-js/dist/assets/bpmn-font/css/bpmn.css");
var _bpmnCodesCss = require("bpmn-js/dist/assets/bpmn-font/css/bpmn-codes.css");
var _bpmnEmbeddedCss = require("bpmn-js/dist/assets/bpmn-font/css/bpmn-embedded.css");
var _processView1Css = require("./ProcessView1.css");
function ProcessView1() {
    const containerRef = (0, _react.useRef)(null);
    const modelerRef = (0, _react.useRef)(null);
    const history = (0, _reactRouterDom.useHistory)();
    const [downloading, setDownloading] = (0, _react.useState)(false);
    const [message, setMessage] = (0, _react.useState)("");
    // BPMN initialisation
    (0, _react.useEffect)(()=>{
        const additionalModules = [
            require("11a54eed4894bceb").default,
            require("770d6ca842149d3b").default,
            require("6913ea06564c3f80").default,
            require("662d15856753707c").default,
            require("faf5f96ae4440bc6").default,
            require("a6658a0b2ba6a7bb").default,
            require("eb85b693e3c02ee4").default,
            require("57302d8fd6b53788").default,
            require("77cf91a60392f815").default,
            require("44b5cb3ff6451e91").default,
            require("466127462e8c413f").default,
            require("eb0801d857d8b67f").default
        ];
        modelerRef.current = new (0, _modelerDefault.default)({
            container: containerRef.current,
            keyboard: {
                bindTo: window
            },
            additionalModules
        });
        const initialDiagram = `<?xml version="1.0" encoding="UTF-8"?>
<bpmn:definitions xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"
                  xmlns:bpmn="http://www.omg.org/spec/BPMN/20100524/MODEL"
                  xmlns:bpmndi="http://www.omg.org/spec/BPMN/20100524/DI"
                  xmlns:dc="http://www.omg.org/spec/DD/20100524/DC"
                  xmlns:di="http://www.omg.org/spec/DD/20100524/DI"
                  targetNamespace="http://bpmn.io/schema/bpmn">
  <bpmn:process id="Process_1" isExecutable="false">
    <bpmn:startEvent id="StartEvent_1" name="Start">
      <bpmn:outgoing>Flow_1</bpmn:outgoing>
    </bpmn:startEvent>
    <bpmn:task id="Task_1" name="Example Task">
      <bpmn:incoming>Flow_1</bpmn:incoming>
    </bpmn:task>
    <bpmn:sequenceFlow id="Flow_1" sourceRef="StartEvent_1" targetRef="Task_1" />
  </bpmn:process>
  <bpmndi:BPMNDiagram id="BPMNDiagram_1">
    <bpmndi:BPMNPlane id="BPMNPlane_1" bpmnElement="Process_1">
      <bpmndi:BPMNShape id="StartEvent_1_di" bpmnElement="StartEvent_1">
        <dc:Bounds x="150" y="150" width="36" height="36"/>
      </bpmndi:BPMNShape>
      <bpmndi:BPMNShape id="Task_1_di" bpmnElement="Task_1">
        <dc:Bounds x="240" y="138" width="100" height="60"/>
      </bpmndi:BPMNShape>
      <bpmndi:BPMNEdge id="Flow_1_di" bpmnElement="Flow_1">
        <di:waypoint x="186" y="168"/>
        <di:waypoint x="240" y="168"/>
      </bpmndi:BPMNEdge>
    </bpmndi:BPMNPlane>
  </bpmndi:BPMNDiagram>
</bpmn:definitions>`;
        modelerRef.current.importXML(initialDiagram).then(()=>{
            modelerRef.current.get("canvas").zoom("fit-viewport");
        }).catch((err)=>console.error("BPMN import error:", err));
        return ()=>modelerRef.current.destroy();
    }, []);
    // Import BPMN file
    const handleImport = async (event)=>{
        const file = event.target.files[0];
        if (!file) return;
        const text = await file.text();
        try {
            await modelerRef.current.importXML(text);
            modelerRef.current.get("canvas").zoom("fit-viewport");
        } catch (err) {
            console.error("BPMN import error:", err);
        }
    };
    // Export BPMN XML
    const handleExport = async ()=>{
        try {
            const { xml } = await modelerRef.current.saveXML({
                format: true
            });
            const blob = new Blob([
                xml
            ], {
                type: "text/xml"
            });
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "diagram.bpmn";
            a.click();
            URL.revokeObjectURL(url);
        } catch (err) {
            console.error("XML export error:", err);
        }
    };
    // Reset diagram
    const handleReset = async ()=>{
        const { xml } = await modelerRef.current.saveXML({
            format: true
        });
        await modelerRef.current.importXML(xml);
        modelerRef.current.get("canvas").zoom("fit-viewport");
    };
    // Export PDF + auto redirect
    const handleDownloadPDF = (0, _react.useCallback)(async ()=>{
        try {
            const element = document.querySelector(".bpmn-wrapper");
            if (!element) {
                alert("Error: Diagram not found!");
                return;
            }
            setDownloading(true);
            window.scrollTo(0, 0);
            const canvas = await (0, _html2CanvasDefault.default)(element, {
                scale: 2.5,
                backgroundColor: "#ffffff",
                useCORS: true,
                logging: false,
                scrollX: 0,
                scrollY: 0
            });
            const imgData = canvas.toDataURL("image/png", 1.0);
            const pdf = new (0, _jspdf.jsPDF)("p", "mm", "a4");
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = canvas.height * pdfWidth / canvas.width;
            let position = 0;
            const pageHeight = pdf.internal.pageSize.getHeight();
            while(position < pdfHeight){
                pdf.addImage(imgData, "PNG", 0, -position, pdfWidth, pdfHeight);
                position += pageHeight;
                if (position < pdfHeight) pdf.addPage();
            }
            pdf.save("process-view.pdf");
            setDownloading(false);
            setMessage("\u2705 PDF successfully downloaded!");
            setTimeout(()=>{
                history.push("/physical-model-1");
            }, 1500);
        } catch (err) {
            console.error("PDF export error:", err);
            alert("Error during PDF generation.");
            setDownloading(false);
        }
    }, [
        history
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "bpmn-wrapper",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    ref: containerRef,
                    className: "bpmn-container"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "toolbar",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: handleReset,
                        children: "\u267B\uFE0F Reset"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: handleExport,
                        children: "\uD83D\uDCBE Export your diagram"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: handleDownloadPDF,
                        disabled: downloading,
                        className: "pdf-download-btn",
                        children: downloading ? "Downloading..." : "\uD83D\uDCBE Save your diagram"
                    })
                ]
            }),
            message && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                style: {
                    textAlign: "center",
                    color: message.startsWith("\u2705") ? "green" : "black",
                    marginTop: "10px",
                    fontWeight: 500
                },
                children: message
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "icam-navigation",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                        to: "/functional-view-1",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            className: "icam-nav-btn",
                            children: "Back"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: "icam-nav-btn",
                        onClick: handleDownloadPDF,
                        disabled: downloading,
                        children: downloading ? "Downloading..." : "Download & Continue"
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["Link","b9X5n"],["useHistory","ditZI"]],"bpmn-js/lib/Modeler":"5JFM2","html2canvas":"3eyQ5","jspdf":"hkJ4Q","bpmn-js/dist/assets/diagram-js.css":"55Ura","bpmn-js/dist/assets/bpmn-font/css/bpmn.css":"7eeEz","bpmn-js/dist/assets/bpmn-font/css/bpmn-codes.css":"4Eyc5","bpmn-js/dist/assets/bpmn-font/css/bpmn-embedded.css":"877BL","./ProcessView1.css":"dBR5B","11a54eed4894bceb":"e4Zt0","770d6ca842149d3b":"ktSXO","6913ea06564c3f80":"OPcPX","662d15856753707c":"jLrPF","faf5f96ae4440bc6":"5n6b5","a6658a0b2ba6a7bb":"euMEP","eb85b693e3c02ee4":"gKt0S","57302d8fd6b53788":"43EOh","77cf91a60392f815":"eKu3X","44b5cb3ff6451e91":"i8lgi","466127462e8c413f":"cXtIQ","eb0801d857d8b67f":"8KY8q","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"55Ura":[function() {},{}],"7eeEz":[function() {},{}],"4Eyc5":[function() {},{}],"877BL":[function() {},{}],"dBR5B":[function() {},{}],"gzd05":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouterDom = require("react-router-dom");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _html2Canvas = require("html2canvas");
var _html2CanvasDefault = parcelHelpers.interopDefault(_html2Canvas);
var _jspdf = require("jspdf");
var _jspdfDefault = parcelHelpers.interopDefault(_jspdf);
var _informationalModel1Css = require("./InformationalModel1.css");
function InformationalModel1() {
    const [nodes, setNodes] = (0, _react.useState)([
        {
            id: 1,
            name: "Company",
            x: 600,
            y: 80,
            width: 250,
            attributes: [
                {
                    visibility: "-",
                    name: "id",
                    type: "int"
                },
                {
                    visibility: "-",
                    name: "name",
                    type: "string"
                }
            ],
            methods: [
                {
                    visibility: "+",
                    name: "getName",
                    params: "",
                    returnType: "string"
                }
            ]
        },
        {
            id: 2,
            name: "Employee",
            x: 280,
            y: 260,
            width: 250,
            attributes: [
                {
                    visibility: "-",
                    name: "id",
                    type: "int"
                },
                {
                    visibility: "-",
                    name: "salary",
                    type: "float"
                }
            ],
            methods: [
                {
                    visibility: "+",
                    name: "getSalary",
                    params: "",
                    returnType: "float"
                }
            ]
        }
    ]);
    const [links, setLinks] = (0, _react.useState)([]);
    const [zoom, setZoom] = (0, _react.useState)(1);
    const [dragging, setDragging] = (0, _react.useState)(null);
    const [editing, setEditing] = (0, _react.useState)(null);
    const [connectMode, setConnectMode] = (0, _react.useState)(false);
    const [pendingFrom, setPendingFrom] = (0, _react.useState)(null);
    const [selected, setSelected] = (0, _react.useState)(null);
    const svgRef = (0, _react.useRef)(null);
    const editorRef = (0, _react.useRef)(null);
    const [downloading, setDownloading] = (0, _react.useState)(false);
    const HEADER_H = 25;
    const PAD = 10;
    const LINE_H = 18;
    const GAP_SEC = 10;
    const handleZoom = (e)=>setZoom(parseFloat(e.target.value));
    const isInteractiveTarget = (t)=>{
        const tag = t?.tagName?.toLowerCase();
        return [
            "input",
            "textarea",
            "select",
            "button"
        ].includes(tag);
    };
    // —————————————————————————————————————
    // Drag
    const onMouseDown = (e, id)=>{
        if (isInteractiveTarget(e.target)) return;
        e.stopPropagation();
        setSelected(id);
        const node = nodes.find((n)=>n.id === id);
        setDragging({
            id,
            offsetX: e.clientX - node.x,
            offsetY: e.clientY - node.y
        });
    };
    const onMouseMove = (e)=>{
        if (!dragging) return;
        setNodes((prev)=>prev.map((n)=>n.id === dragging.id ? {
                    ...n,
                    x: e.clientX - dragging.offsetX,
                    y: e.clientY - dragging.offsetY
                } : n));
    };
    const onMouseUp = ()=>setDragging(null);
    // —————————————————————————————————————
    // Parsing helpers
    const parseAttrLine = (text, prev)=>{
        const m = text.trim().match(/^([+\-#])?\s*([A-Za-z_]\w*)?(?:\s*:\s*([\w\[\]<>]+))?$/);
        return {
            visibility: m?.[1] || prev.visibility || "+",
            name: m?.[2] || prev.name || "attr",
            type: m?.[3] || prev.type || "type"
        };
    };
    const parseMethodLine = (text, prev)=>{
        const m = text.trim().match(/^([+\-#])?\s*([A-Za-z_]\w*)?(?:\s*\(([^)]*)\))?(?:\s*:\s*([\w\[\]<>]+))?$/);
        return {
            visibility: m?.[1] || prev.visibility || "+",
            name: m?.[2] || prev.name || "method",
            params: m?.[3] ?? prev.params ?? "",
            returnType: m?.[4] || prev.returnType || "void"
        };
    };
    // —————————————————————————————————————
    // Classes
    const addClass = ()=>{
        const id = nodes.length ? Math.max(...nodes.map((n)=>n.id)) + 1 : 1;
        setNodes([
            ...nodes,
            {
                id,
                name: `Class${id}`,
                x: 420 + id * 20,
                y: 200 + id * 20,
                width: 250,
                attributes: [],
                methods: []
            }
        ]);
    };
    const deleteSelected = ()=>{
        if (!selected) return alert("Select a class to delete.");
        setLinks(links.filter((l)=>l.from !== selected && l.to !== selected));
        setNodes(nodes.filter((n)=>n.id !== selected));
        setSelected(null);
    };
    const renameClass = (id, newName)=>setNodes(nodes.map((n)=>n.id === id ? {
                ...n,
                name: newName
            } : n));
    // —————————————————————————————————————
    // Attributes & Methods
    const addAttribute = (id)=>setNodes(nodes.map((n)=>n.id === id ? {
                ...n,
                attributes: [
                    ...n.attributes,
                    {
                        visibility: "-",
                        name: "newAttr",
                        type: "type"
                    }
                ]
            } : n));
    const addMethod = (id)=>setNodes(nodes.map((n)=>n.id === id ? {
                ...n,
                methods: [
                    ...n.methods,
                    {
                        visibility: "+",
                        name: "newMethod",
                        params: "",
                        returnType: "void"
                    }
                ]
            } : n));
    const removeAttribute = (id, i)=>setNodes(nodes.map((n)=>n.id === id ? {
                ...n,
                attributes: n.attributes.filter((_, k)=>k !== i)
            } : n));
    const removeMethod = (id, i)=>setNodes(nodes.map((n)=>n.id === id ? {
                ...n,
                methods: n.methods.filter((_, k)=>k !== i)
            } : n));
    // —————————————————————————————————————
    // Connections
    const onClassClick = (id)=>{
        if (!connectMode || connectMode === "menu") return;
        if (!pendingFrom) setPendingFrom(id);
        else if (pendingFrom !== id) {
            const chosenType = connectMode;
            setLinks((prev)=>[
                    ...prev,
                    {
                        id: prev.length + 1,
                        from: pendingFrom,
                        to: id,
                        type: chosenType,
                        cardFrom: "1",
                        cardTo: "*"
                    }
                ]);
            setPendingFrom(null);
            setConnectMode(false);
        }
    };
    const changeCardinality = (id)=>{
        const newCard = prompt("Enter cardinality:", "1..*");
        if (newCard) setLinks(links.map((l)=>l.id === id ? {
                ...l,
                cardinality: newCard
            } : l));
    };
    // —————————————————————————————————————
    // Export as PNG
    const downloadDiagram = ()=>{
        const svg = svgRef.current;
        const svgData = new XMLSerializer().serializeToString(svg);
        const svgBlob = new Blob([
            svgData
        ], {
            type: "image/svg+xml;charset=utf-8"
        });
        const url = URL.createObjectURL(svgBlob);
        const img = new Image();
        img.onload = ()=>{
            const canvas = document.createElement("canvas");
            canvas.width = svg.clientWidth * 2;
            canvas.height = svg.clientHeight * 2;
            const ctx = canvas.getContext("2d");
            ctx.scale(2, 2);
            ctx.drawImage(img, 0, 0);
            URL.revokeObjectURL(url);
            const pngUrl = canvas.toDataURL("image/png");
            const a = document.createElement("a");
            a.href = pngUrl;
            a.download = "information-model.png";
            a.click();
        };
        img.src = url;
    };
    const exportToPDF = async ()=>{
        const element = editorRef.current;
        const canvas = await (0, _html2CanvasDefault.default)(element, {
            scale: 2
        });
        const imgData = canvas.toDataURL("image/png");
        const pdf = new (0, _jspdfDefault.default)({
            orientation: "landscape",
            unit: "px",
            format: [
                canvas.width / 2,
                canvas.height / 2
            ]
        });
        pdf.addImage(imgData, "PNG", 0, 0, canvas.width / 2, canvas.height / 2);
        pdf.save("information-model.pdf");
    };
    // —————————————————————————————————————
    // Update Fields
    const updateField = (id, section, index, value)=>{
        setNodes((prev)=>prev.map((n)=>{
                if (n.id !== id) return n;
                const current = section === "attributes" ? n.attributes[index] : n.methods[index];
                const parsed = section === "attributes" ? parseAttrLine(value, current) : parseMethodLine(value, current);
                const copy = section === "attributes" ? [
                    ...n.attributes
                ] : [
                    ...n.methods
                ];
                copy[index] = parsed;
                return {
                    ...n,
                    [section]: copy
                };
            }));
    };
    // —————————————————————————————————————
    // Layout computation
    const layoutFor = (n)=>{
        const attrY0 = HEADER_H + GAP_SEC + 15;
        const methodsY0 = attrY0 + (n.attributes.length ? n.attributes.length * LINE_H + GAP_SEC : GAP_SEC + 6);
        const totalHeight = Math.max(HEADER_H + 2 * GAP_SEC + 40, methodsY0 + (n.methods.length ? n.methods.length * LINE_H : 0) + GAP_SEC);
        return {
            attrY0,
            methodsY0,
            totalHeight
        };
    };
    // —————————————————————————————————————
    // Edge points for links
    const edgePoint = (cx, cy, w, h, tx, ty)=>{
        const dx = tx - cx;
        const dy = ty - cy;
        if (dx === 0 && dy === 0) return {
            x: cx,
            y: cy
        };
        const hw = w / 2;
        const hh = h / 2;
        const absDx = Math.abs(dx);
        const absDy = Math.abs(dy);
        if (absDx * hh > absDy * hw) {
            const scale = hw / absDx;
            return {
                x: cx + Math.sign(dx) * hw,
                y: cy + dy * scale
            };
        } else {
            const scale = hh / absDy;
            return {
                x: cx + dx * scale,
                y: cy + Math.sign(dy) * hh
            };
        }
    };
    // —————————————————————————————————————
    // High-quality PDF capture
    const handleDownloadPDF = async ()=>{
        try {
            const element = editorRef.current;
            if (!element) {
                alert("Error: Unable to find content to export!");
                return;
            }
            window.scrollTo(0, 0);
            const canvas = await (0, _html2CanvasDefault.default)(element, {
                scale: 2.5,
                backgroundColor: "#ffffff",
                useCORS: true,
                logging: false
            });
            const imgData = canvas.toDataURL("image/png", 1.0);
            const pdf = new (0, _jspdfDefault.default)("l", "mm", "a4");
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = canvas.height * pdfWidth / canvas.width;
            let position = 0;
            const pageHeight = pdf.internal.pageSize.getHeight();
            while(position < pdfHeight){
                pdf.addImage(imgData, "PNG", 0, -position, pdfWidth, pdfHeight);
                position += pageHeight;
                if (position < pdfHeight) pdf.addPage();
            }
            pdf.save("informational-model.pdf");
            alert("\u2705 PDF downloaded successfully!");
        } catch (err) {
            console.error("Error generating PDF:", err);
            alert("\uD83D\uDEA8 Error generating PDF.");
        }
    };
    // —————————————————————————————————————
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "informational-model-1-1",
        ref: editorRef,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "nav-items-4-6",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    className: "x1200px-logo_icam_-_2008-1-8",
                    src: "https://upload.wikimedia.org/wikipedia/commons/f/f2/ICAM_logo.png",
                    alt: "icam logo"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "icam-editor",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "icam-sidebar",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: "icam-btn",
                                onClick: addClass,
                                children: "+ Class"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                style: {
                                    position: "relative"
                                },
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        className: `icam-btn ${connectMode ? "active" : ""}`,
                                        onClick: ()=>{
                                            if (connectMode && connectMode !== "menu") {
                                                setConnectMode("menu");
                                                setPendingFrom(null);
                                            } else {
                                                setConnectMode(connectMode === "menu" ? false : "menu");
                                                setPendingFrom(null);
                                            }
                                        },
                                        children: connectMode === "menu" ? "Choose link type" : connectMode ? "Delete link" : "Links"
                                    }),
                                    connectMode === "menu" && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        style: {
                                            position: "absolute",
                                            top: "40px",
                                            left: 0,
                                            background: "white",
                                            border: "1px solid #ccc",
                                            borderRadius: "6px",
                                            padding: "4px",
                                            zIndex: 20,
                                            boxShadow: "0 2px 6px rgba(0,0,0,0.2)"
                                        },
                                        children: [
                                            {
                                                label: "\uD83D\uDD17 Association",
                                                value: "association"
                                            },
                                            {
                                                label: "\u2B06\uFE0F Inheritance",
                                                value: "generalization"
                                            },
                                            {
                                                label: "\u25C7 Aggregation",
                                                value: "aggregation"
                                            },
                                            {
                                                label: "\u25C6 Composition",
                                                value: "composition"
                                            }
                                        ].map((opt)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                style: {
                                                    padding: "4px 8px",
                                                    cursor: "pointer",
                                                    fontSize: "14px"
                                                },
                                                onMouseEnter: (e)=>e.currentTarget.style.background = "#eee",
                                                onMouseLeave: (e)=>e.currentTarget.style.background = "white",
                                                onClick: ()=>{
                                                    setConnectMode(opt.value);
                                                    setPendingFrom(null);
                                                },
                                                children: opt.label
                                            }, opt.value))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: "icam-btn",
                                onClick: deleteSelected,
                                children: "\uD83D\uDDD1 Delete"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: "icam-btn",
                                onClick: exportToPDF,
                                children: "\uD83D\uDCC4 Save"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "icam-zoom",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                        children: "Zoom"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                        type: "range",
                                        min: "0.5",
                                        max: "2",
                                        step: "0.1",
                                        value: zoom,
                                        onChange: handleZoom
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "icam-canvas",
                        onMouseMove: onMouseMove,
                        onMouseUp: onMouseUp,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                            ref: svgRef,
                            width: "100%",
                            height: "100%",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("marker", {
                                            id: "arrowhead",
                                            markerWidth: "10",
                                            markerHeight: "7",
                                            refX: "10",
                                            refY: "3.5",
                                            orient: "auto",
                                            markerUnits: "strokeWidth",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M0,0 L10,3.5 L0,7 Z",
                                                fill: "black"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("marker", {
                                            id: "triangle",
                                            markerWidth: "20",
                                            markerHeight: "20",
                                            refX: "20",
                                            refY: "10",
                                            orient: "auto",
                                            markerUnits: "strokeWidth",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M0,0 L20,10 L0,20 Z",
                                                fill: "white",
                                                stroke: "black",
                                                strokeWidth: "1.5"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("marker", {
                                            id: "diamondEmpty",
                                            markerWidth: "40",
                                            markerHeight: "20",
                                            refX: "-1",
                                            refY: "5",
                                            orient: "auto",
                                            markerUnits: "strokeWidth",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M0,5 L5,0 L10,5 L5,10 Z",
                                                fill: "white",
                                                stroke: "black",
                                                strokeWidth: "1"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("marker", {
                                            id: "diamondFilled",
                                            markerWidth: "40",
                                            markerHeight: "20",
                                            refX: "-1",
                                            refY: "5",
                                            orient: "auto",
                                            markerUnits: "strokeWidth",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M0,5 L5,0 L10,5 L5,10 Z",
                                                fill: "black",
                                                stroke: "black",
                                                strokeWidth: "1"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                    transform: `scale(${zoom})`,
                                    children: [
                                        links.map((l)=>{
                                            const a = nodes.find((n)=>n.id === l.from);
                                            const b = nodes.find((n)=>n.id === l.to);
                                            if (!a || !b) return null;
                                            const aH = layoutFor(a).totalHeight;
                                            const bH = layoutFor(b).totalHeight;
                                            const acx = a.x + a.width / 2;
                                            const acy = a.y + aH / 2;
                                            const bcx = b.x + b.width / 2;
                                            const bcy = b.y + bH / 2;
                                            const p1 = edgePoint(acx, acy, a.width, aH, bcx, bcy);
                                            const p2 = edgePoint(bcx, bcy, b.width, bH, acx, acy);
                                            let markerStart = null;
                                            let markerEnd = null;
                                            switch(l.type){
                                                case "association":
                                                    markerStart = null;
                                                    markerEnd = null;
                                                    break;
                                                case "generalization":
                                                    markerEnd = "url(#triangle)";
                                                    break;
                                                case "aggregation":
                                                    markerStart = "url(#diamondEmpty)";
                                                    break;
                                                case "composition":
                                                    markerStart = "url(#diamondFilled)";
                                                    break;
                                                default:
                                                    markerStart = null;
                                                    markerEnd = null;
                                            }
                                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                                style: {
                                                    cursor: "pointer"
                                                },
                                                onClick: ()=>changeCardinality(l.id),
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                                        x1: p1.x,
                                                        y1: p1.y,
                                                        x2: p2.x,
                                                        y2: p2.y,
                                                        stroke: "black",
                                                        strokeWidth: "2",
                                                        markerStart: markerStart,
                                                        markerEnd: markerEnd,
                                                        strokeLinecap: "round"
                                                    }),
                                                    l.type !== "generalization" && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                                                x: p1.x + (p2.x - p1.x) * 0.1,
                                                                y: p1.y + (p2.y - p1.y) * 0.1 - 5,
                                                                fontSize: "12",
                                                                fill: "black",
                                                                textAnchor: "middle",
                                                                onClick: (e)=>{
                                                                    e.stopPropagation();
                                                                    const newCard = prompt("Cardinality A side:", l.cardFrom || "1");
                                                                    if (newCard) setLinks((prev)=>prev.map((link)=>link.id === l.id ? {
                                                                                ...link,
                                                                                cardFrom: newCard
                                                                            } : link));
                                                                },
                                                                children: l.cardFrom
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                                                x: p2.x - (p2.x - p1.x) * 0.1,
                                                                y: p2.y - (p2.y - p1.y) * 0.1 - 5,
                                                                fontSize: "12",
                                                                fill: "black",
                                                                textAnchor: "middle",
                                                                onClick: (e)=>{
                                                                    e.stopPropagation();
                                                                    const newCard = prompt("Cardinality B side:", l.cardTo || "*");
                                                                    if (newCard) setLinks((prev)=>prev.map((link)=>link.id === l.id ? {
                                                                                ...link,
                                                                                cardTo: newCard
                                                                            } : link));
                                                                },
                                                                children: l.cardTo
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }, l.id);
                                        }),
                                        nodes.map((n)=>{
                                            const { attrY0, methodsY0, totalHeight } = layoutFor(n);
                                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                                transform: `translate(${n.x}, ${n.y})`,
                                                onMouseDown: (e)=>onMouseDown(e, n.id),
                                                onClick: ()=>onClassClick(n.id),
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                        width: n.width,
                                                        height: totalHeight,
                                                        rx: "5",
                                                        ry: "5",
                                                        className: `icam-class-body ${selected === n.id ? "selected" : ""}`
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                        width: n.width,
                                                        height: HEADER_H,
                                                        rx: "5",
                                                        ry: "5",
                                                        className: "icam-class-header"
                                                    }),
                                                    editing?.id === n.id && editing?.section === "className" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("foreignObject", {
                                                        x: PAD,
                                                        y: 4,
                                                        width: n.width - PAD * 2,
                                                        height: HEADER_H - 8,
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                            type: "text",
                                                            value: n.name,
                                                            onChange: (e)=>renameClass(n.id, e.target.value),
                                                            onBlur: ()=>setEditing(null),
                                                            autoFocus: true,
                                                            style: {
                                                                width: "100%",
                                                                border: "none",
                                                                outline: "none",
                                                                fontWeight: "bold"
                                                            }
                                                        })
                                                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                                        x: PAD,
                                                        y: 17,
                                                        className: "icam-class-title",
                                                        onDoubleClick: (e)=>{
                                                            e.stopPropagation();
                                                            setEditing({
                                                                id: n.id,
                                                                section: "className"
                                                            });
                                                        },
                                                        children: n.name
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                                        x: n.width - PAD - 11,
                                                        y: attrY0 - 9,
                                                        fontSize: "16",
                                                        fill: "green",
                                                        style: {
                                                            cursor: "pointer"
                                                        },
                                                        onClick: (e)=>{
                                                            e.stopPropagation();
                                                            addAttribute(n.id);
                                                        },
                                                        children: "\uFF0B"
                                                    }),
                                                    n.attributes.map((a, i)=>{
                                                        const y = attrY0 + i * LINE_H;
                                                        const editThis = editing?.id === n.id && editing?.section === "attr" && editing?.index === i;
                                                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                                            children: [
                                                                editThis ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("foreignObject", {
                                                                    x: PAD,
                                                                    y: y - 14,
                                                                    width: n.width - PAD * 2 - 20,
                                                                    height: 20,
                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                                        type: "text",
                                                                        value: `${a.visibility} ${a.name} : ${a.type}`,
                                                                        onChange: (e)=>updateField(n.id, "attributes", i, e.target.value),
                                                                        onBlur: ()=>setEditing(null),
                                                                        autoFocus: true,
                                                                        style: {
                                                                            width: "100%",
                                                                            border: "none",
                                                                            outline: "none",
                                                                            fontSize: "12px"
                                                                        }
                                                                    })
                                                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("text", {
                                                                    x: PAD,
                                                                    y: y,
                                                                    fontSize: "12",
                                                                    fill: "#0f172a",
                                                                    onDoubleClick: (e)=>{
                                                                        e.stopPropagation();
                                                                        setEditing({
                                                                            id: n.id,
                                                                            section: "attr",
                                                                            index: i
                                                                        });
                                                                    },
                                                                    children: [
                                                                        a.visibility,
                                                                        " ",
                                                                        a.name,
                                                                        " : ",
                                                                        a.type
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                                                    x: n.width - PAD - 10,
                                                                    y: y,
                                                                    fontSize: "12",
                                                                    fill: "red",
                                                                    style: {
                                                                        cursor: "pointer"
                                                                    },
                                                                    onClick: (e)=>{
                                                                        e.stopPropagation();
                                                                        removeAttribute(n.id, i);
                                                                    },
                                                                    children: "\u2715"
                                                                })
                                                            ]
                                                        }, i);
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                                        x1: 0,
                                                        y1: methodsY0 - GAP_SEC - 11,
                                                        x2: n.width,
                                                        y2: methodsY0 - GAP_SEC - 11,
                                                        stroke: "#1e293b",
                                                        strokeWidth: "1"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                                        x: n.width - PAD - 10,
                                                        y: methodsY0 - 8,
                                                        fontSize: "14",
                                                        fill: "green",
                                                        style: {
                                                            cursor: "pointer"
                                                        },
                                                        onClick: (e)=>{
                                                            e.stopPropagation();
                                                            addMethod(n.id);
                                                        },
                                                        children: "\uFF0B"
                                                    }),
                                                    n.methods.map((m, i)=>{
                                                        const y = methodsY0 + i * LINE_H;
                                                        const editThis = editing?.id === n.id && editing?.section === "method" && editing?.index === i;
                                                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                                            children: [
                                                                editThis ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("foreignObject", {
                                                                    x: PAD,
                                                                    y: y - 14,
                                                                    width: n.width - PAD * 2 - 20,
                                                                    height: 20,
                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                                        type: "text",
                                                                        value: `${m.visibility} ${m.name}(${m.params}) : ${m.returnType}`,
                                                                        onChange: (e)=>updateField(n.id, "methods", i, e.target.value),
                                                                        onBlur: ()=>setEditing(null),
                                                                        autoFocus: true,
                                                                        style: {
                                                                            width: "100%",
                                                                            border: "none",
                                                                            outline: "none",
                                                                            fontSize: "12px"
                                                                        }
                                                                    })
                                                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("text", {
                                                                    x: PAD,
                                                                    y: y,
                                                                    fontSize: "12",
                                                                    fill: "#0f172a",
                                                                    onDoubleClick: (e)=>{
                                                                        e.stopPropagation();
                                                                        setEditing({
                                                                            id: n.id,
                                                                            section: "method",
                                                                            index: i
                                                                        });
                                                                    },
                                                                    children: [
                                                                        m.visibility,
                                                                        " ",
                                                                        m.name,
                                                                        "(",
                                                                        m.params,
                                                                        ") : ",
                                                                        m.returnType
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                                                    x: n.width - PAD - 10,
                                                                    y: y,
                                                                    fontSize: "12",
                                                                    fill: "red",
                                                                    style: {
                                                                        cursor: "pointer"
                                                                    },
                                                                    onClick: (e)=>{
                                                                        e.stopPropagation();
                                                                        removeMethod(n.id, i);
                                                                    },
                                                                    children: "\u2715"
                                                                })
                                                            ]
                                                        }, i);
                                                    })
                                                ]
                                            }, n.id);
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "icam-navigation",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                        to: "/decisional-model-1",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            className: "icam-nav-btn",
                            children: "Back"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                        to: "/lean-vsm-1",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            className: "icam-nav-btn",
                            children: "Continue"
                        })
                    })
                ]
            })
        ]
    });
}
exports.default = InformationalModel1;

},{"react/jsx-runtime":"gonF6","react-router-dom":"b9X5n","react":"bmhQu","html2canvas":"3eyQ5","jspdf":"hkJ4Q","./InformationalModel1.css":"3arLb","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3arLb":[function() {},{}],"aCokB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "e_allData1", ()=>e_allData1);
parcelHelpers.export(exports, "yes_Count1", ()=>yes_Count1);
parcelHelpers.export(exports, "e_final", ()=>e_final);
parcelHelpers.export(exports, "e_yesCount1", ()=>e_yesCount1);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _frame113 = require("../Frame113");
var _frame113Default = parcelHelpers.interopDefault(_frame113);
var _frame114 = require("../Frame114");
var _frame114Default = parcelHelpers.interopDefault(_frame114);
var _frame115 = require("../Frame115");
var _frame115Default = parcelHelpers.interopDefault(_frame115);
var _frame116 = require("../Frame116");
var _frame116Default = parcelHelpers.interopDefault(_frame116);
var _frame117 = require("../Frame117");
var _frame117Default = parcelHelpers.interopDefault(_frame117);
var _environmental1Css = require("./Environmental1.css");
var _styleguideCss = require("../../styleguide.css");
let e_allData1 = [];
let yes_Count1 = 0;
let e_final = 0;
let e_yesCount1 = 0;
function Environmental1(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [yesCount1, setYesCount1] = (0, _react.useState)(0);
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const [isSaving, setIsSaving] = (0, _react.useState)(false);
    const { x1200PxLogo_Icam__20081, navItems3Props, frame113Props, frame117Props } = props;
    const history = (0, _reactRouterDom.useHistory)();
    (0, _react.useEffect)(()=>{
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []);
    function clicked(question, option) {
        if (selectedOptions[question] === option) {
            setSelectedOptions((prevSelectedOptions)=>{
                const newOptions = {
                    ...prevSelectedOptions
                };
                delete newOptions[question];
                return newOptions;
            });
            if (option === "Yes") yes_Count1--;
            return;
        }
        const previousOption = selectedOptions[question];
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        if (option === "Yes" && previousOption !== "Yes") yes_Count1++;
        else if (option === "No" && previousOption === "Yes") yes_Count1--;
    }
    function saveData() {
        setIsSaving(true);
        setErrorMessage("");
        console.log("D\xe9but de sauvegarde des donn\xe9es Environmental1");
        const enterpriseId = localStorage.getItem("enterpriseId");
        const userId = localStorage.getItem("userId");
        if (!enterpriseId) {
            console.error("ERREUR: ID d'entreprise manquant");
            setErrorMessage("ID d'entreprise manquant. Veuillez retourner \xe0\xa0 la s\xe9lection d'entreprise.");
            setIsSaving(false);
            return;
        }
        // Définir toutes les questions possibles
        const allQuestions = [
            "Do you have a policy for reducing greenhouse gas emissions?",
            "Do you monitor and report your carbon footprint?",
            "Do you use renewable energy sources in your operations?"
        ];
        // Créer un tableau de questions/réponses pour toutes les questions
        const data = allQuestions.map((question)=>{
            const answer = selectedOptions[question] || "No";
            return {
                question: question,
                answer: answer,
                category: "environmental",
                enterpriseId: enterpriseId,
                userId: userId || "",
                section: "environmental-1",
                timestamp: new Date().toISOString()
            };
        });
        // Vérifier que les données sont correctement formatées
        const isValidData = data.every((item)=>item.question && item.answer && item.category && item.enterpriseId);
        if (!isValidData) {
            console.error("Donn\xe9es invalides:", data);
            setErrorMessage("Format de donn\xe9es invalide");
            setIsSaving(false);
            return;
        }
        console.log("Donn\xe9es \xe0\xa0 envoyer:", JSON.stringify(data, null, 2));
        // Appel API pour sauvegarder les données
        fetch("/api/api/save-answers", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
            },
            body: JSON.stringify(data)
        }).then((response)=>{
            if (!response.ok) throw new Error(`Erreur de sauvegarde (${response.status})`);
            return response.json();
        }).then((result)=>{
            console.log("Data saved successfully:", result);
            // Sauvegarder le score dans le localStorage
            localStorage.setItem('environmental1Score', yes_Count1);
            console.log(`Score environmental1 mis \xe0\xa0 jour: ${yes_Count1}`);
            setIsSaving(false);
            history.push("/environmental-2");
        }).catch((error)=>{
            console.error("Error saving data:", error);
            setErrorMessage("Error saving data. Please try again.");
            console.error("D\xe9tails de l'erreur:", error.message);
            setIsSaving(false);
            history.push("/environmental-2");
        });
    }
    function calculateProgressPercentage() {
        if (totalQuestions === 0) return 0;
        return Math.round(yes_Count1 / totalQuestions * 100);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "environmental-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "environmental-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    className: "environmental-title",
                    children: "PLEASE ANSWER THE FOLLOWING QUESTIONS"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "progress-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "progress-bar",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "progress-fill",
                                style: {
                                    width: `${calculateProgressPercentage()}%`
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "progress-text",
                            children: [
                                "Your score: ",
                                yes_Count1,
                                " / ",
                                totalQuestions,
                                " (",
                                calculateProgressPercentage(),
                                "%)"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questions-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have a policy for reducing greenhouse gas emissions?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a policy for reducing greenhouse gas emissions?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have a policy for reducing greenhouse gas emissions?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a policy for reducing greenhouse gas emissions?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have a policy for reducing greenhouse gas emissions?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you monitor and report your carbon footprint?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you monitor and report your carbon footprint?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you monitor and report your carbon footprint?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you monitor and report your carbon footprint?", "No"),
                                            className: `btn-option ${selectedOptions["Do you monitor and report your carbon footprint?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you use renewable energy sources in your operations?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you use renewable energy sources in your operations?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you use renewable energy sources in your operations?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you use renewable energy sources in your operations?", "No"),
                                            className: `btn-option ${selectedOptions["Do you use renewable energy sources in your operations?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "form-actions",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/measuring-form",
                            className: "btn-secondary",
                            children: "Back"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "btn-primary",
                            disabled: isSaving,
                            children: isSaving ? "Saving..." : "Continue to Next Section"
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Environmental1;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["Link","b9X5n"],["useHistory","ditZI"]],"../NavItems3":"fOarC","../Frame113":"l7UEw","../Frame114":"aUtEd","../Frame115":"gPV9Y","../Frame116":"70lZ5","../Frame117":"ijwBg","./Environmental1.css":"gkMJx","../../styleguide.css":"8Y7Ec","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fOarC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame1142 = require("../Frame1142");
var _frame1142Default = parcelHelpers.interopDefault(_frame1142);
var _frame1152 = require("../Frame1152");
var _frame1152Default = parcelHelpers.interopDefault(_frame1152);
var _frame11722 = require("../Frame11722");
var _frame11722Default = parcelHelpers.interopDefault(_frame11722);
var _frame11622 = require("../Frame11622");
var _frame11622Default = parcelHelpers.interopDefault(_frame11622);
var _frame11322 = require("../Frame11322");
var _frame11322Default = parcelHelpers.interopDefault(_frame11322);
var _functionalViewButton = require("../FunctionalViewButton");
var _functionalViewButtonDefault = parcelHelpers.interopDefault(_functionalViewButton);
var _navItems3Css = require("./NavItems3.css");
function NavItems3(props) {
    const { className, frame1172Props, frame1162Props, frame1132Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `nav-items-3-1 nav-items-primary ${className || ""}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1142Default.default), {
                className: "nav-item-button"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1152Default.default), {
                className: "nav-item-button"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _functionalViewButtonDefault.default), {
                className: "nav-item-button"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11722Default.default), {
                className: "nav-item-button",
                children: frame1172Props.children
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11622Default.default), {
                className: "nav-item-button",
                children: frame1162Props.children
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11322Default.default), {
                className: `nav-item-button ${frame1132Props.className || ""}`
            })
        ]
    });
}
exports.default = NavItems3;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","../Frame1142":"lCMhE","../Frame1152":"fymBe","../Frame11722":"eafco","../Frame11622":"jvSOx","../Frame11322":"ju7Cp","../FunctionalViewButton":"bMWdY","./NavItems3.css":"4Wwbm","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lCMhE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame1142Css = require("./Frame1142.css");
var _reactRouterDom = require("react-router-dom");
function Frame1142(props) {
    const { className } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
        to: "/home",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: `frame-114-90 home-button ${className || ""}`,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "place-4 valign-text-middle inter-medium-star-dust-18px",
                children: "Home"
            })
        })
    });
}
exports.default = Frame1142;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./Frame1142.css":"8wc06","react-router-dom":"b9X5n","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8wc06":[function() {},{}],"fymBe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame1152Css = require("./Frame1152.css");
var _reactRouterDom = require("react-router-dom");
function Frame1152(props) {
    const { className } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
        to: "/acquisition",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: `frame-115-100 ${className || ""}`,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "new-case-5 valign-text-middle inter-medium-sonic-silver-18px",
                children: "New case"
            })
        })
    });
}
exports.default = Frame1152;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./Frame1152.css":"h2uPx","react-router-dom":"b9X5n","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"h2uPx":[function() {},{}],"eafco":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame11722Css = require("./Frame11722.css");
var _reactRouterDom = require("react-router-dom");
function Frame11722(props) {
    const { children } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
        to: "/process-view-1",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "frame-117-1",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "process-view valign-text-middle inter-medium-star-dust-18px",
                children: children
            })
        })
    });
}
exports.default = Frame11722;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./Frame11722.css":"72PXF","react-router-dom":"b9X5n","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"72PXF":[function() {},{}],"jvSOx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame11622Css = require("./Frame11622.css");
var _reactRouterDom = require("react-router-dom");
function Frame11622(props) {
    const { children } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
        to: "/decisional-model-1",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "frame-115-88",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "decisional-model valign-text-middle inter-medium-star-dust-18px",
                children: children
            })
        })
    });
}
exports.default = Frame11622;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./Frame11622.css":"hMQCu","react-router-dom":"b9X5n","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hMQCu":[function() {},{}],"bMWdY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _functionalViewButtonCss = require("./FunctionalViewButton.css");
var _reactRouterDom = require("react-router-dom");
function FunctionalViewButton(props) {
    const { className } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
        to: "/functional-view-1",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: `functional-view-button ${className || ""}`,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "functional-view-text valign-text-middle",
                children: "Functional View"
            })
        })
    });
}
exports.default = FunctionalViewButton;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./FunctionalViewButton.css":"9CVsW","react-router-dom":"b9X5n","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9CVsW":[function() {},{}],"4Wwbm":[function() {},{}],"l7UEw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame113Css = require("./Frame113.css");
var _reactRouterDom = require("react-router-dom");
function Frame113(props) {
    const { className } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
        to: "/acquisition",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: `frame-113-28 ${className || ""}`,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "aquisition-28 valign-text-middle inter-medium-white-18px",
                children: "Acquisition"
            })
        })
    });
}
exports.default = Frame113;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./Frame113.css":"6VJzl","react-router-dom":"b9X5n","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6VJzl":[function() {},{}],"aUtEd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame114Css = require("./Frame114.css");
var _reactRouterDom = require("react-router-dom");
function Frame114() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "frame-114-71",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
            to: "/functional-view-1",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "functional-view-4 valign-text-middle inter-medium-white-18px",
                children: "Modeling"
            })
        })
    });
}
exports.default = Frame114;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./Frame114.css":"6uq72","react-router-dom":"b9X5n","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6uq72":[function() {},{}],"gPV9Y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame115Css = require("./Frame115.css");
var _reactRouterDom = require("react-router-dom");
function Frame115() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
        to: "/analysis",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "frame-115",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "analysis valign-text-middle inter-medium-star-dust-18px",
                children: "Analysis"
            })
        })
    });
}
exports.default = Frame115;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./Frame115.css":"15Jvl","react-router-dom":"b9X5n","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"15Jvl":[function() {},{}],"70lZ5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame116Css = require("./Frame116.css");
var _reactRouterDom = require("react-router-dom");
function Frame116(props) {
    const { children, className } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
        to: "/cur-performance",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: `frame-116 ${className || ""}`,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "result-performance valign-text-middle inter-medium-white-18px",
                children: children
            })
        })
    });
}
exports.default = Frame116;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./Frame116.css":"9xH7u","react-router-dom":"b9X5n","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9xH7u":[function() {},{}],"ijwBg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame117Css = require("./Frame117.css");
var _reactRouterDom = require("react-router-dom");
function Frame117(props) {
    const { className } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `frame-117-2 ${className || ""}`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
            to: "/functional-view-1",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "functional-view valign-text-middle inter-medium-white-18px",
                children: "Functional View"
            })
        })
    });
}
exports.default = Frame117;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./Frame117.css":"776a2","react-router-dom":"b9X5n","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"776a2":[function() {},{}],"gkMJx":[function() {},{}],"8Y7Ec":[function() {},{}],"8ypM1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "e_allData1", ()=>e_allData1);
parcelHelpers.export(exports, "yes_Count1", ()=>yes_Count1);
parcelHelpers.export(exports, "e_final", ()=>e_final);
parcelHelpers.export(exports, "e_yesCount1", ()=>e_yesCount1);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _frame113 = require("../Frame113");
var _frame113Default = parcelHelpers.interopDefault(_frame113);
var _frame114 = require("../Frame114");
var _frame114Default = parcelHelpers.interopDefault(_frame114);
var _frame115 = require("../Frame115");
var _frame115Default = parcelHelpers.interopDefault(_frame115);
var _frame116 = require("../Frame116");
var _frame116Default = parcelHelpers.interopDefault(_frame116);
var _frame117 = require("../Frame117");
var _frame117Default = parcelHelpers.interopDefault(_frame117);
var _environmental1Css = require("./Environmental1_.css");
var _styleguideCss = require("../../styleguide.css");
let e_allData1 = [];
let yes_Count1 = 0;
let e_final = 0;
let e_yesCount1 = 0;
function Environmental1_(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [yesCount1, setYesCount1] = (0, _react.useState)(0);
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const [isSaving, setIsSaving] = (0, _react.useState)(false);
    const { x1200PxLogo_Icam__20081, navItems3Props, frame113Props, frame117Props } = props;
    const history = (0, _reactRouterDom.useHistory)();
    (0, _react.useEffect)(()=>{
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []);
    function clicked(question, option) {
        if (selectedOptions[question] === option) {
            setSelectedOptions((prevSelectedOptions)=>{
                const newOptions = {
                    ...prevSelectedOptions
                };
                delete newOptions[question];
                return newOptions;
            });
            if (option === "Yes") yes_Count1--;
            return;
        }
        const previousOption = selectedOptions[question];
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        if (option === "Yes" && previousOption !== "Yes") yes_Count1++;
        else if (option === "No" && previousOption === "Yes") yes_Count1--;
    }
    function saveData() {
        setIsSaving(true);
        setErrorMessage("");
        console.log("D\xe9but de sauvegarde des donn\xe9es Environmental1");
        const enterpriseId = localStorage.getItem("enterpriseId");
        const userId = localStorage.getItem("userId");
        if (!enterpriseId) {
            console.error("ERREUR: ID d'entreprise manquant");
            setErrorMessage("ID d'entreprise manquant. Veuillez retourner \xe0\xa0 la s\xe9lection d'entreprise.");
            setIsSaving(false);
            return;
        }
        // Définir toutes les questions possibles
        const allQuestions = [
            "Do you have a policy for reducing greenhouse gas emissions?",
            "Do you monitor and report your carbon footprint?",
            "Do you use renewable energy sources in your operations?"
        ];
        // Créer un tableau de questions/réponses pour toutes les questions
        const data = allQuestions.map((question)=>{
            const answer = selectedOptions[question] || "No";
            return {
                question: question,
                answer: answer,
                category: "environmental",
                enterpriseId: enterpriseId,
                userId: userId || "",
                section: "environmental-1",
                timestamp: new Date().toISOString()
            };
        });
        // Vérifier que les données sont correctement formatées
        const isValidData = data.every((item)=>item.question && item.answer && item.category && item.enterpriseId);
        if (!isValidData) {
            console.error("Donn\xe9es invalides:", data);
            setErrorMessage("Format de donn\xe9es invalide");
            setIsSaving(false);
            return;
        }
        console.log("Donn\xe9es \xe0\xa0 envoyer:", JSON.stringify(data, null, 2));
        // Appel API pour sauvegarder les données
        fetch("/api/api/save-evaluation", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
            },
            body: JSON.stringify(data)
        }).then((response)=>{
            if (!response.ok) throw new Error(`Erreur de sauvegarde (${response.status})`);
            return response.json();
        }).then((result)=>{
            console.log("Data saved successfully:", result);
            // Sauvegarder le score dans le localStorage
            localStorage.setItem('environmental1Score', yes_Count1);
            console.log(`Score environmental1 mis \xe0\xa0 jour: ${yes_Count1}`);
            setIsSaving(false);
            history.push("/environmental-2_");
        }).catch((error)=>{
            console.error("Error saving data:", error);
            setErrorMessage("Error saving data. Please try again.");
            console.error("D\xe9tails de l'erreur:", error.message);
            setIsSaving(false);
            history.push("/environmental-2_");
        });
    }
    function calculateProgressPercentage() {
        if (totalQuestions === 0) return 0;
        return Math.round(yes_Count1 / totalQuestions * 100);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "environmental-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "environmental-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    className: "environmental-title",
                    children: "PLEASE ANSWER THE FOLLOWING QUESTIONS"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "progress-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "progress-bar",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "progress-fill",
                                style: {
                                    width: `${calculateProgressPercentage()}%`
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "progress-text",
                            children: [
                                "Your score: ",
                                yes_Count1,
                                " / ",
                                totalQuestions,
                                " (",
                                calculateProgressPercentage(),
                                "%)"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questions-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have a policy for reducing greenhouse gas emissions?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a policy for reducing greenhouse gas emissions?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have a policy for reducing greenhouse gas emissions?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a policy for reducing greenhouse gas emissions?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have a policy for reducing greenhouse gas emissions?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you monitor and report your carbon footprint?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you monitor and report your carbon footprint?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you monitor and report your carbon footprint?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you monitor and report your carbon footprint?", "No"),
                                            className: `btn-option ${selectedOptions["Do you monitor and report your carbon footprint?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you use renewable energy sources in your operations?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you use renewable energy sources in your operations?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you use renewable energy sources in your operations?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you use renewable energy sources in your operations?", "No"),
                                            className: `btn-option ${selectedOptions["Do you use renewable energy sources in your operations?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "form-actions",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/measuring-form_",
                            className: "btn-secondary",
                            children: "Back"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "btn-primary",
                            disabled: isSaving,
                            children: isSaving ? "Saving..." : "Continue to Next Section"
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Environmental1_;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["Link","b9X5n"],["useHistory","ditZI"]],"../NavItems3":"fOarC","../Frame113":"l7UEw","../Frame114":"aUtEd","../Frame115":"gPV9Y","../Frame116":"70lZ5","../Frame117":"ijwBg","./Environmental1_.css":"dIu1v","../../styleguide.css":"8Y7Ec","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dIu1v":[function() {},{}],"8Y7Ec":[function() {},{}],"aKgLj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _measuringFormCss = require("./MeasuringForm.css");
function MeasuringForm(props) {
    const { ellipse116, x1200PxLogo_Icam__20081, criteriaMeasurementForm, environnementCriteria1, environnementCriteria2, x4LeadTimeCriteria, x2SocialCriteria, x5CostCriteria, x3ModernizationCriteria, x6QualityCriteria, navItems3Props } = props;
    // State to track the completion status of each section
    const [completionStatus, setCompletionStatus] = (0, _react.useState)({
        environmental: false,
        social: false,
        modernization: false,
        leadTime: false,
        cost: false,
        quality: false,
        clientConsommateur: false
    });
    // Simulate retrieving status from an API or localStorage
    (0, _react.useEffect)(()=>{
        const fetchStatusData = ()=>{
            const storedStatus = localStorage.getItem('criteriaCompletionStatus');
            if (storedStatus) setCompletionStatus(JSON.parse(storedStatus));
        };
        fetchStatusData();
    }, []);
    // Save status to localStorage when it changes
    (0, _react.useEffect)(()=>{
        localStorage.setItem('criteriaCompletionStatus', JSON.stringify(completionStatus));
    }, [
        completionStatus
    ]);
    // Define criteria with their links and status keys
    const criteria = [
        {
            name: environnementCriteria1 || "Environmental Criteria",
            path: "/environmental-1",
            icon: "\uD83C\uDF3F",
            statusKey: "environmental"
        },
        {
            name: x2SocialCriteria || "Social Criteria",
            path: "/social-1",
            icon: "\uD83D\uDC65",
            statusKey: "social"
        },
        {
            name: x3ModernizationCriteria || "Modernization Criteria",
            path: "/modernization-1",
            icon: "\uD83D\uDD04",
            statusKey: "modernization"
        },
        {
            name: x4LeadTimeCriteria || "Lead Time Criteria",
            path: "/lead-time-1",
            icon: "\u23F1\uFE0F",
            statusKey: "leadTime"
        },
        {
            name: x5CostCriteria || "Cost Criteria",
            path: "/cost-1",
            icon: "\uD83D\uDCB0",
            statusKey: "cost"
        },
        {
            name: x6QualityCriteria || "Quality Criteria",
            path: "/quality-1",
            icon: "\u2705",
            statusKey: "quality"
        },
        {
            name: "Client Consumer",
            path: "/client-consommateur-1",
            icon: "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
            statusKey: "clientConsommateur"
        }
    ];
    // Handle form submission
    const submitForm = ()=>{
        const allCompleted = Object.values(completionStatus).every((status)=>status === true);
        if (allCompleted) {
            alert("Form submitted successfully!");
            window.location.href = "/functional-view-1";
        } else alert("Please complete all sections before submitting the form.");
    };
    // Update the status of a section (used when a section is completed)
    const updateSectionStatus = (statusKey, isCompleted)=>{
        setCompletionStatus((prevStatus)=>({
                ...prevStatus,
                [statusKey]: isCompleted
            }));
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "measuring-form-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "measuring-form-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    className: "measuring-form-title",
                    children: criteriaMeasurementForm || "CRITERIA MEASUREMENT FORM"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "measuring-form-description",
                    children: "Please select a criterion to evaluate from the options below."
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "criteria-grid",
                    children: criteria.map((criterion, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Link), {
                            to: criterion.path,
                            className: `criterion-card ${completionStatus[criterion.statusKey] ? 'completed' : 'incomplete'}`,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "criterion-icon",
                                    children: criterion.icon
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                    className: "criterion-name",
                                    children: criterion.name
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "status-indicator",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "status-dot"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "status-text",
                                            children: completionStatus[criterion.statusKey] ? "Completed" : "To be completed"
                                        })
                                    ]
                                })
                            ]
                        }, index))
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "form-actions",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/acquisition",
                            className: "btn-secondary",
                            children: "Back to Company Information"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: submitForm,
                            className: "btn-primary",
                            children: "Submit and Proceed to Analysis Models"
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = MeasuringForm;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"b9X5n","../NavItems3":"fOarC","../NavItems2":"bnQuI","./MeasuringForm.css":"6YO7c","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bnQuI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame113 = require("../Frame113");
var _frame113Default = parcelHelpers.interopDefault(_frame113);
var _frame114 = require("../Frame114");
var _frame114Default = parcelHelpers.interopDefault(_frame114);
var _frame115 = require("../Frame115");
var _frame115Default = parcelHelpers.interopDefault(_frame115);
var _frame116 = require("../Frame116");
var _frame116Default = parcelHelpers.interopDefault(_frame116);
var _frame117 = require("../Frame117");
var _frame117Default = parcelHelpers.interopDefault(_frame117);
var _navItems2Css = require("./NavItems2.css");
function NavItems2(props) {
    const { className } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `nav-items-2-2 ${className || ""}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame113Default.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame114Default.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame115Default.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame116Default.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame117Default.default), {})
        ]
    });
}
exports.default = NavItems2;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","../Frame113":"l7UEw","../Frame114":"aUtEd","../Frame115":"gPV9Y","../Frame116":"70lZ5","../Frame117":"ijwBg","./NavItems2.css":"d0tTZ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"d0tTZ":[function() {},{}],"6YO7c":[function() {},{}],"kpXB8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _measuringFormCss = require("./MeasuringForm_.css");
function MeasuringForm_(props) {
    const { ellipse116, x1200PxLogo_Icam__20081, criteriaMeasurementForm, environnementCriteria1, environnementCriteria2, x4LeadTimeCriteria, x2SocialCriteria, x5CostCriteria, x3ModernizationCriteria, x6QualityCriteria, navItems3Props } = props;
    // State to track the completion status of each section
    const [completionStatus, setCompletionStatus] = (0, _react.useState)({
        environmental: false,
        social: false,
        modernization: false,
        leadTime: false,
        cost: false,
        quality: false,
        clientConsommateur: false
    });
    // Simulate retrieving status from an API or localStorage
    (0, _react.useEffect)(()=>{
        const fetchStatusData = ()=>{
            const storedStatus = localStorage.getItem('criteriaCompletionStatus');
            if (storedStatus) setCompletionStatus(JSON.parse(storedStatus));
        };
        fetchStatusData();
    }, []);
    // Save status to localStorage when it changes
    (0, _react.useEffect)(()=>{
        localStorage.setItem('criteriaCompletionStatus', JSON.stringify(completionStatus));
    }, [
        completionStatus
    ]);
    // Define criteria with their links and status keys
    const criteria = [
        {
            name: environnementCriteria1 || "Environmental Criteria",
            path: "/environmental-1_",
            icon: "\uD83C\uDF3F",
            statusKey: "environmental"
        },
        {
            name: x2SocialCriteria || "Social Criteria",
            path: "/social-1_",
            icon: "\uD83D\uDC65",
            statusKey: "social"
        },
        {
            name: x3ModernizationCriteria || "Modernization Criteria",
            path: "/modernization-1_",
            icon: "\uD83D\uDD04",
            statusKey: "modernization"
        },
        {
            name: x4LeadTimeCriteria || "Lead Time Criteria",
            path: "/lead-time-1_",
            icon: "\u23F1\uFE0F",
            statusKey: "leadTime"
        },
        {
            name: x5CostCriteria || "Cost Criteria",
            path: "/cost-1",
            icon: "\uD83D\uDCB0",
            statusKey: "cost_"
        },
        {
            name: x6QualityCriteria || "Quality Criteria",
            path: "/quality-1_",
            icon: "\u2705",
            statusKey: "quality"
        },
        {
            name: "Client Consumer",
            path: "/client-consommateur-1_",
            icon: "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
            statusKey: "clientConsommateur"
        }
    ];
    // Handle form submission
    const submitForm = ()=>{
        const allCompleted = Object.values(completionStatus).every((status)=>status === true);
        if (allCompleted) {
            alert("Form submitted successfully!");
            window.location.href = "/implementation";
        } else alert("Please complete all sections before submitting the form.");
    };
    // Update the status of a section (used when a section is completed)
    const updateSectionStatus = (statusKey, isCompleted)=>{
        setCompletionStatus((prevStatus)=>({
                ...prevStatus,
                [statusKey]: isCompleted
            }));
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "measuring-form-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "measuring-form-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    className: "measuring-form-title",
                    children: criteriaMeasurementForm || "CRITERIA MEASUREMENT FORM"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "measuring-form-description",
                    children: "Please select a criterion to evaluate from the options below."
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "criteria-grid",
                    children: criteria.map((criterion, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Link), {
                            to: criterion.path,
                            className: `criterion-card ${completionStatus[criterion.statusKey] ? 'completed' : 'incomplete'}`,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "criterion-icon",
                                    children: criterion.icon
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                    className: "criterion-name",
                                    children: criterion.name
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "status-indicator",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "status-dot"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "status-text",
                                            children: completionStatus[criterion.statusKey] ? "Completed" : "To be completed"
                                        })
                                    ]
                                })
                            ]
                        }, index))
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "form-actions",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: submitForm,
                        className: "btn-primary",
                        children: "Submit and Proceed to Evaluation"
                    })
                })
            ]
        })
    });
}
exports.default = MeasuringForm_;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"b9X5n","../NavItems3":"fOarC","../NavItems2":"bnQuI","./MeasuringForm_.css":"53yqD","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"53yqD":[function() {},{}],"6l9fD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _leanVSM1Css = require("./LeanVSM1.css");
var _jspdf = require("jspdf");
var _jspdfDefault = parcelHelpers.interopDefault(_jspdf);
var _html2Canvas = require("html2canvas");
var _html2CanvasDefault = parcelHelpers.interopDefault(_html2Canvas);
function LeanVSM1(props) {
    const { x1200PxLogo_Icam__20081 } = props;
    const [hasImplemented, setHasImplemented] = (0, _react.useState)(false);
    const [showQuestionnaire, setShowQuestionnaire] = (0, _react.useState)(false);
    const [showImport, setShowImport] = (0, _react.useState)(false);
    const [currentStep, setCurrentStep] = (0, _react.useState)(1);
    const [answers, setAnswers] = (0, _react.useState)({
        // Part 1: Understand the current state
        processSteps: "",
        cycleTimes: "",
        leadTimes: "",
        valueAddedPercentage: "",
        processTypes: "",
        physicalFlows: "",
        stockTypes: "",
        orderTransmission: "",
        informationSystems: "",
        dataUpdateFrequency: "",
        identifiedWaste: "",
        errorSteps: "",
        defectRates: "",
        // Part 2: Future vision
        futureObjectives: "",
        kpiToImprove: "",
        targetCycleTime: "",
        stepsToEliminate: "",
        wasteToEliminate: "",
        leanTools: "",
        plannedChanges: "",
        plannedTraining: "",
        transformationConstraints: "",
        // Part 3: Comparison and roadmap
        measuredGaps: "",
        trackedKPIs: "",
        roadmap: ""
    });
    const [uploadStatus, setUploadStatus] = (0, _react.useState)({
        isUploading: false,
        progress: 0,
        error: null,
        success: false,
        fileName: ""
    });
    const fileInputRef = (0, _react.useRef)(null);
    const questionnaireRef = (0, _react.useRef)(null);
    const handleImportClick = ()=>{
        fileInputRef.current.click();
    };
    const handleFileUpload = async (event)=>{
        const file = event.target.files[0];
        if (!file) return;
        // File type check
        const allowedTypes = [
            'application/pdf',
            'image/jpeg',
            'image/png',
            'image/svg+xml',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.ms-excel',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/msword'
        ];
        if (!allowedTypes.includes(file.type)) {
            setUploadStatus({
                ...uploadStatus,
                error: "Unsupported file type. Please use PDF, JPG, PNG, SVG, Excel or Word.",
                success: false
            });
            return;
        }
        // Max size
        const maxSize = 10485760;
        if (file.size > maxSize) {
            setUploadStatus({
                ...uploadStatus,
                error: "File too large. Maximum size: 10MB.",
                success: false
            });
            return;
        }
        try {
            setUploadStatus({
                isUploading: true,
                progress: 0,
                error: null,
                success: false,
                fileName: file.name
            });
            const formData = new FormData();
            formData.append('file', file);
            formData.append('answers', JSON.stringify(answers));
            const xhr = new XMLHttpRequest();
            xhr.upload.onprogress = (event)=>{
                if (event.lengthComputable) {
                    const progress = Math.round(event.loaded / event.total * 100);
                    setUploadStatus((prev)=>({
                            ...prev,
                            progress
                        }));
                }
            };
            const uploadPromise = new Promise((resolve, reject)=>{
                xhr.onload = ()=>{
                    if (xhr.status === 200) resolve(JSON.parse(xhr.response));
                    else reject(new Error(`Upload failed with status ${xhr.status}`));
                };
                xhr.onerror = ()=>reject(new Error("Upload failed"));
            });
            xhr.open('POST', '/api/vsm/upload');
            xhr.send(formData);
            const response = await uploadPromise;
            setUploadStatus({
                isUploading: false,
                progress: 100,
                error: null,
                success: true,
                fileName: file.name,
                fileId: response.file_id
            });
        } catch (error) {
            setUploadStatus({
                isUploading: false,
                progress: 0,
                error: "An error occurred during upload. Please try again.",
                success: false,
                fileName: ""
            });
        }
    };
    const handleAnswerChange = (field, value)=>{
        setAnswers({
            ...answers,
            [field]: value
        });
    };
    const handleNextStep = ()=>{
        if (currentStep < 3) {
            setCurrentStep(currentStep + 1);
            if (questionnaireRef.current) questionnaireRef.current.scrollTop = 0;
        } else setShowImport(true);
    };
    const handlePrevStep = ()=>{
        if (currentStep > 1) {
            setCurrentStep(currentStep - 1);
            if (questionnaireRef.current) questionnaireRef.current.scrollTop = 0;
        }
    };
    const handleYesClick = ()=>{
        setHasImplemented(true);
        setShowQuestionnaire(true);
    };
    // Progress indicator
    const renderProgressIndicator = ()=>{
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "progress-indicator",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: `progress-step ${currentStep >= 1 ? 'active' : ''} ${currentStep > 1 ? 'completed' : ''}`,
                    children: "1"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: `progress-step ${currentStep >= 2 ? 'active' : ''} ${currentStep > 2 ? 'completed' : ''}`,
                    children: "2"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: `progress-step ${currentStep >= 3 ? 'active' : ''}`,
                    children: "3"
                })
            ]
        });
    };
    // Questionnaire rendering
    const renderQuestionnaire = ()=>{
        switch(currentStep){
            case 1:
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questionnaire-step",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                            className: "step-title",
                            children: "Part 1: Understanding the current value stream"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "question-group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                    className: "question-group-title",
                                    children: "Processes & physical flows:"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "processSteps",
                                            children: "What are the main steps in your process, from customer order to delivery?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "processSteps",
                                            value: answers.processSteps,
                                            onChange: (e)=>handleAnswerChange('processSteps', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "cycleTimes",
                                            children: "What are the cycle times for each key step?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "cycleTimes",
                                            value: answers.cycleTimes,
                                            onChange: (e)=>handleAnswerChange('cycleTimes', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "leadTimes",
                                            children: "What are the waiting times (lead time) between each step?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "leadTimes",
                                            value: answers.leadTimes,
                                            onChange: (e)=>handleAnswerChange('leadTimes', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "valueAddedPercentage",
                                            children: "Have you measured the percentage of value-added time vs total process time?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "valueAddedPercentage",
                                            value: answers.valueAddedPercentage,
                                            onChange: (e)=>handleAnswerChange('valueAddedPercentage', e.target.value),
                                            rows: "2"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "processTypes",
                                            children: "Which steps are manual, automated, or hybrid?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "processTypes",
                                            value: answers.processTypes,
                                            onChange: (e)=>handleAnswerChange('processTypes', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "physicalFlows",
                                            children: "What are the current physical flows from raw materials to finished products?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "physicalFlows",
                                            value: answers.physicalFlows,
                                            onChange: (e)=>handleAnswerChange('physicalFlows', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "stockTypes",
                                            children: "What types of stock (WIP, safety, buffer) are held at each step?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "stockTypes",
                                            value: answers.stockTypes,
                                            onChange: (e)=>handleAnswerChange('stockTypes', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "question-group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                    className: "question-group-title",
                                    children: "Information flows:"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "orderTransmission",
                                            children: "How are customer orders transmitted through the system?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "orderTransmission",
                                            value: answers.orderTransmission,
                                            onChange: (e)=>handleAnswerChange('orderTransmission', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "informationSystems",
                                            children: "What tools or information systems do you use to manage information flows?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "informationSystems",
                                            value: answers.informationSystems,
                                            onChange: (e)=>handleAnswerChange('informationSystems', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "dataUpdateFrequency",
                                            children: "How frequently are supply chain data updated in your system?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "dataUpdateFrequency",
                                            value: answers.dataUpdateFrequency,
                                            onChange: (e)=>handleAnswerChange('dataUpdateFrequency', e.target.value),
                                            rows: "2"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "question-group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                    className: "question-group-title",
                                    children: "\xe2\u0161\xa0\xef\xb8\x8f Waste (Muda):"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "identifiedWaste",
                                            children: "What forms of waste have you identified (overproduction, waiting, unnecessary movement, etc.)?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "identifiedWaste",
                                            value: answers.identifiedWaste,
                                            onChange: (e)=>handleAnswerChange('identifiedWaste', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "errorSteps",
                                            children: "At which steps are errors or rework most common?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "errorSteps",
                                            value: answers.errorSteps,
                                            onChange: (e)=>handleAnswerChange('errorSteps', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "defectRates",
                                            children: "Have you measured defect or non-conformity rates in the process?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "defectRates",
                                            value: answers.defectRates,
                                            onChange: (e)=>handleAnswerChange('defectRates', e.target.value),
                                            rows: "2"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                });
            /* ----------------- PART 2 (translated) ----------------- */ case 2:
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questionnaire-step",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                            className: "step-title",
                            children: "Part 2: Future vision / desired state"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "question-group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                    className: "question-group-title",
                                    children: "Objectives & strategy:"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "futureObjectives",
                                            children: "What are the main objectives of your desired future state (lead time reduction, quality improvement, stock reduction, etc.)?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "futureObjectives",
                                            value: answers.futureObjectives,
                                            onChange: (e)=>handleAnswerChange('futureObjectives', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "kpiToImprove",
                                            children: "Which KPIs do you intend to improve (OTD, Takt Time, logistics cost, service rate\xe2\u20AC\xa6)?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "kpiToImprove",
                                            value: answers.kpiToImprove,
                                            onChange: (e)=>handleAnswerChange('kpiToImprove', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "targetCycleTime",
                                            children: "What is the target for cycle time and lead time?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "targetCycleTime",
                                            value: answers.targetCycleTime,
                                            onChange: (e)=>handleAnswerChange('targetCycleTime', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "stepsToEliminate",
                                            children: "Do you plan to remove or merge any process steps?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "stepsToEliminate",
                                            value: answers.stepsToEliminate,
                                            onChange: (e)=>handleAnswerChange('stepsToEliminate', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "wasteToEliminate",
                                            children: "Which wastes do you want to eliminate first?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "wasteToEliminate",
                                            value: answers.wasteToEliminate,
                                            onChange: (e)=>handleAnswerChange('wasteToEliminate', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "question-group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                    className: "question-group-title",
                                    children: "Lean tools & transformation:"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "leanTools",
                                            children: "Which Lean tools do you plan to introduce or strengthen (Kanban, 5S, Heijunka, SMED, etc.)?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "leanTools",
                                            value: answers.leanTools,
                                            onChange: (e)=>handleAnswerChange('leanTools', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "plannedChanges",
                                            children: "What organizational or technological changes are planned to reach this future state?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "plannedChanges",
                                            value: answers.plannedChanges,
                                            onChange: (e)=>handleAnswerChange('plannedChanges', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "plannedTraining",
                                            children: "Have you planned training or upskilling actions for your teams?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "plannedTraining",
                                            value: answers.plannedTraining,
                                            onChange: (e)=>handleAnswerChange('plannedTraining', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "transformationConstraints",
                                            children: "What constraints or resistance have you identified for the transformation?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "transformationConstraints",
                                            value: answers.transformationConstraints,
                                            onChange: (e)=>handleAnswerChange('transformationConstraints', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                });
            /* ----------------- PART 3 (translated) ----------------- */ case 3:
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questionnaire-step",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                            className: "step-title",
                            children: "Part 3: Gap analysis & transformation monitoring"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "question-group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                    className: "question-group-title",
                                    children: "Gap analysis:"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "measuredGaps",
                                            children: "What are the main gaps identified between the current state and the target state?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "measuredGaps",
                                            value: answers.measuredGaps,
                                            onChange: (e)=>handleAnswerChange('measuredGaps', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "trackedKPIs",
                                            children: "Which KPIs are being monitored to manage the transition?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "trackedKPIs",
                                            value: answers.trackedKPIs,
                                            onChange: (e)=>handleAnswerChange('trackedKPIs', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "roadmap",
                                            children: "What is your roadmap to reach the future state (milestones, responsibilities, tools)?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "roadmap",
                                            value: answers.roadmap,
                                            onChange: (e)=>handleAnswerChange('roadmap', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                });
            default:
                return null;
        }
    };
    /* ------------------ PDF BUTTON TEXT TRANSLATED ------------------ */ const handleDownloadPDF = async ()=>{
        try {
            const element = document.querySelector(".lean-vsm-1");
            if (!element) {
                alert("\xe2\x9d\u0152 Element not found!");
                return;
            }
            document.querySelectorAll("*").forEach((el)=>{
                const bgImage = window.getComputedStyle(el).backgroundImage;
                if (bgImage && bgImage.includes("gradient")) el.style.backgroundImage = "none";
                const bgColor = window.getComputedStyle(el).backgroundColor;
                if (bgColor.includes("var(") || bgColor === "transparent" || bgColor === "rgba(0, 0, 0, 0)") el.style.backgroundColor = "#ffffff";
            });
            const canvas = await (0, _html2CanvasDefault.default)(element, {
                scale: 2,
                useCORS: true,
                allowTaint: true,
                backgroundColor: "#ffffff",
                logging: false
            });
            const imgData = canvas.toDataURL("image/png");
            const pdf = new (0, _jspdfDefault.default)("p", "mm", "a4");
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = pdf.internal.pageSize.getHeight();
            const imgWidth = pdfWidth;
            const imgHeight = canvas.height * pdfWidth / canvas.width;
            let heightLeft = imgHeight;
            let position = 0;
            pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
            heightLeft -= pdfHeight;
            while(heightLeft > 0){
                position = heightLeft - imgHeight;
                pdf.addPage();
                pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
                heightLeft -= pdfHeight;
            }
            const date = new Date().toISOString().slice(0, 10);
            pdf.save(`LeanVSM_${date}.pdf`);
            alert("PDF generated successfully!");
        } catch (err) {
            console.error("PDF error:", err);
            alert("PDF error: " + (err.message || "unknown"));
        }
    };
    const saveLeanAnswers = async (moduleName)=>{
        try {
            const caseId = localStorage.getItem("caseId");
            if (!caseId) {
                alert("No active case found!");
                return;
            }
            const response = await fetch(`${"/api"}/api/lean/${moduleName}/save`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    case_id: caseId,
                    answers: answers
                })
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.detail || `Saving error (${response.status}): ${data.message}`);
            alert(`\xe2\u{153}\u{2026} ${moduleName.toUpperCase()} answers saved successfully!`);
            handleNextStep();
        } catch (error) {
            alert("\xe2\x9d\u0152 " + error.message);
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "lean-vsm-1 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "header",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                        to: "/home",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "x1200px-logo_icam_-_2008-1-11",
                            src: x1200PxLogo_Icam__20081,
                            alt: "icam logo"
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questionnaire-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                            className: "question-title",
                            children: "Value Stream Mapping (VSM)"
                        }),
                        !showQuestionnaire ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "question-section",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Have you already implemented the VSM methodology in your company?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "buttons-container",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            className: `choice-button ${hasImplemented ? 'active' : ''}`,
                                            onClick: handleYesClick,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            className: `choice-button ${!hasImplemented ? 'active' : ''}`,
                                            onClick: ()=>setHasImplemented(false),
                                            children: "No"
                                        })
                                    ]
                                }),
                                !hasImplemented && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "redirect-section",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "redirect-text",
                                            children: "We recommend starting with the 5S method:"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                            to: "/5s-1",
                                            className: "redirect-button",
                                            children: "Go to the 5S method"
                                        })
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                            children: !showImport ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "questionnaire-container-inner",
                                ref: questionnaireRef,
                                children: [
                                    renderProgressIndicator(),
                                    renderQuestionnaire(),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "navigation-buttons",
                                        children: [
                                            currentStep > 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                className: "nav-button prev-button",
                                                onClick: handlePrevStep,
                                                children: "Previous"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                className: "nav-button next-button",
                                                onClick: ()=>saveLeanAnswers("vsm"),
                                                children: currentStep < 3 ? "Next" : "Finish"
                                            })
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "file-upload-section",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                        className: "upload-title",
                                        children: "Import your existing documents"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "upload-description",
                                        children: "You can now import your VSM diagrams, documents or spreadsheets:"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "upload-container",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                type: "file",
                                                ref: fileInputRef,
                                                className: "hidden-file-input",
                                                accept: ".pdf,.jpg,.jpeg,.png,.svg,.xlsx,.xls,.doc,.docx",
                                                onChange: handleFileUpload,
                                                disabled: uploadStatus.isUploading
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                className: "import-button",
                                                onClick: handleImportClick,
                                                disabled: uploadStatus.isUploading,
                                                children: uploadStatus.isUploading ? "Uploading..." : "Import a file"
                                            }),
                                            uploadStatus.isUploading && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "upload-progress",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "progress-bar",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "progress-bar-fill",
                                                            style: {
                                                                width: `${uploadStatus.progress}%`
                                                            }
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                        className: "progress-text",
                                                        children: [
                                                            "Uploading... ",
                                                            uploadStatus.progress,
                                                            "%"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            uploadStatus.error && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "upload-error",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                    children: uploadStatus.error
                                                })
                                            }),
                                            uploadStatus.success && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "upload-success",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                        children: [
                                                            "The file ",
                                                            uploadStatus.fileName,
                                                            " was uploaded successfully!"
                                                        ]
                                                    }),
                                                    uploadStatus.fileId && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                        className: "download-button",
                                                        onClick: ()=>window.open(`/api/vsm/${uploadStatus.fileId}`, "_blank"),
                                                        children: "View file"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "navigation-buttons",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                className: "nav-button prev-button",
                                                onClick: ()=>setShowImport(false),
                                                children: "Back to questionnaire"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                                to: "/lean-vsm-2",
                                                className: "nav-button next-button",
                                                children: "Continue"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    className: "download-button",
                    onClick: handleDownloadPDF,
                    disabled: uploadStatus.isUploading,
                    children: uploadStatus.isUploading ? "Generating PDF..." : "Download as PDF"
                })
            ]
        })
    });
}
exports.default = LeanVSM1;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"b9X5n","./LeanVSM1.css":"cp9nA","jspdf":"hkJ4Q","html2canvas":"3eyQ5","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cp9nA":[function() {},{}],"5Jnfl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _x5S1Css = require("./X5S1.css");
var _jspdf = require("jspdf");
var _jspdfDefault = parcelHelpers.interopDefault(_jspdf);
var _html2Canvas = require("html2canvas");
var _html2CanvasDefault = parcelHelpers.interopDefault(_html2Canvas);
function X5S1(props) {
    const { x1200PxLogo_Icam__20081 } = props;
    const [hasImplemented, setHasImplemented] = (0, _react.useState)(false);
    const [showQuestionnaire, setShowQuestionnaire] = (0, _react.useState)(false);
    const [showImport, setShowImport] = (0, _react.useState)(false);
    const [currentStep, setCurrentStep] = (0, _react.useState)(1);
    const [answers, setAnswers] = (0, _react.useState)({
        // Part 1: Current state - 5S application today
        // 1. Seiri (Sort)
        identifiedUselessItems: "",
        criteriaForNecessity: "",
        actionPlanForElimination: "",
        // 2. Seiton (Set in order)
        definedLocations: "",
        organizationLogic: "",
        easyToFind: "",
        // 3. Seiso (Shine)
        regularCleaning: "",
        formalCleaningPlan: "",
        anomalyIdentification: "",
        // 4. Seiketsu (Standardize)
        visualStandards: "",
        documentedStandards: "",
        standardsRevisionFrequency: "",
        // 5. Shitsuke (Sustain)
        fiveSCulture: "",
        internalAudits: "",
        deviationManagement: "",
        // Part 2: Future desired state - Vision and objectives
        idealVision: "",
        objectives: "",
        extensionToOtherDepartments: "",
        expectedBehaviorChanges: "",
        digitalTools: "",
        // Part 3: Gap analysis, monitoring, and change management
        projectManager: "",
        performanceIndicators: "",
        mainDifficulties: "",
        trainingActions: "",
        bestPractices: ""
    });
    const [uploadStatus, setUploadStatus] = (0, _react.useState)({
        isUploading: false,
        progress: 0,
        error: null,
        success: false,
        fileName: ""
    });
    const fileInputRef = (0, _react.useRef)(null);
    const questionnaireRef = (0, _react.useRef)(null);
    const handleImportClick = ()=>{
        fileInputRef.current.click();
    };
    const handleFileUpload = async (event)=>{
        const file = event.target.files[0];
        if (!file) return;
        // File type validation
        const allowedTypes = [
            'application/pdf',
            'image/jpeg',
            'image/png',
            'image/svg+xml',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.ms-excel',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/msword'
        ];
        if (!allowedTypes.includes(file.type)) {
            setUploadStatus({
                ...uploadStatus,
                error: "Unsupported file type. Please use PDF, JPG, PNG, SVG, Excel, or Word.",
                success: false
            });
            return;
        }
        // File size validation (max 10MB)
        const maxSize = 10485760; // 10MB
        if (file.size > maxSize) {
            setUploadStatus({
                ...uploadStatus,
                error: "File too large. Maximum size: 10MB",
                success: false
            });
            return;
        }
        try {
            setUploadStatus({
                isUploading: true,
                progress: 0,
                error: null,
                success: false,
                fileName: file.name
            });
            const formData = new FormData();
            formData.append('file', file);
            formData.append('answers', JSON.stringify(answers));
            const xhr = new XMLHttpRequest();
            xhr.upload.onprogress = (event)=>{
                if (event.lengthComputable) {
                    const progress = Math.round(event.loaded / event.total * 100);
                    setUploadStatus((prev)=>({
                            ...prev,
                            progress
                        }));
                }
            };
            const uploadPromise = new Promise((resolve, reject)=>{
                xhr.onload = ()=>{
                    if (xhr.status === 200) resolve(JSON.parse(xhr.response));
                    else reject(new Error(`Upload failed with status ${xhr.status}`));
                };
                xhr.onerror = ()=>reject(new Error('Upload failed'));
            });
            xhr.open('POST', '/api/5s/upload');
            xhr.send(formData);
            const response = await uploadPromise;
            setUploadStatus({
                isUploading: false,
                progress: 100,
                error: null,
                success: true,
                fileName: file.name,
                fileId: response.file_id
            });
        } catch (error) {
            setUploadStatus({
                isUploading: false,
                progress: 0,
                error: "An error occurred during upload. Please try again.",
                success: false,
                fileName: ""
            });
        }
    };
    const handleAnswerChange = (field, value)=>{
        setAnswers({
            ...answers,
            [field]: value
        });
    };
    const handleNextStep = ()=>{
        if (currentStep < 3) {
            setCurrentStep(currentStep + 1);
            if (questionnaireRef.current) questionnaireRef.current.scrollTop = 0;
        } else setShowImport(true);
    };
    const handlePrevStep = ()=>{
        if (currentStep > 1) {
            setCurrentStep(currentStep - 1);
            if (questionnaireRef.current) questionnaireRef.current.scrollTop = 0;
        }
    };
    const handleYesClick = ()=>{
        setHasImplemented(true);
        setShowQuestionnaire(true);
    };
    // Progress indicator
    const renderProgressIndicator = ()=>{
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "progress-indicator",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: `progress-step ${currentStep >= 1 ? 'active' : ''} ${currentStep > 1 ? 'completed' : ''}`,
                    children: "1"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: `progress-step ${currentStep >= 2 ? 'active' : ''} ${currentStep > 2 ? 'completed' : ''}`,
                    children: "2"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: `progress-step ${currentStep >= 3 ? 'active' : ''}`,
                    children: "3"
                })
            ]
        });
    };
    const renderQuestionnaire = ()=>{
        switch(currentStep){
            case 1:
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questionnaire-step",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                            className: "step-title",
                            children: "Part 1: Current State - How 5S is applied today"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "step-description",
                            children: "The 5S are: Seiri (Sort), Seiton (Set in order), Seiso (Shine), Seiketsu (Standardize), Shitsuke (Sustain)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "question-group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                    className: "question-group-title",
                                    children: "1. Seiri (Sort)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "identifiedUselessItems",
                                            children: "Have you identified unnecessary items at your workstations?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "identifiedUselessItems",
                                            value: answers.identifiedUselessItems,
                                            onChange: (e)=>handleAnswerChange('identifiedUselessItems', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "criteriaForNecessity",
                                            children: "What criteria do you use to decide whether a tool, document, or material is necessary?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "criteriaForNecessity",
                                            value: answers.criteriaForNecessity,
                                            onChange: (e)=>handleAnswerChange('criteriaForNecessity', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "actionPlanForElimination",
                                            children: "Is there an action plan to eliminate superfluous items?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "actionPlanForElimination",
                                            value: answers.actionPlanForElimination,
                                            onChange: (e)=>handleAnswerChange('actionPlanForElimination', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "question-group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                    className: "question-group-title",
                                    children: "2. Seiton (Set in order)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "definedLocations",
                                            children: "Do tools, equipment, and documents have defined and labeled locations?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "definedLocations",
                                            value: answers.definedLocations,
                                            onChange: (e)=>handleAnswerChange('definedLocations', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "organizationLogic",
                                            children: "Have you implemented an organization system based on frequency of use?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "organizationLogic",
                                            value: answers.organizationLogic,
                                            onChange: (e)=>handleAnswerChange('organizationLogic', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "easyToFind",
                                            children: "Is it easy for a newcomer to find what they need without assistance?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "easyToFind",
                                            value: answers.easyToFind,
                                            onChange: (e)=>handleAnswerChange('easyToFind', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "question-group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                    className: "question-group-title",
                                    children: "3. Seiso (Shine)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "regularCleaning",
                                            children: "Is workstation cleanliness ensured regularly?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "regularCleaning",
                                            value: answers.regularCleaning,
                                            onChange: (e)=>handleAnswerChange('regularCleaning', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "formalCleaningPlan",
                                            children: "Is there a formal cleaning plan assigned to each area/workstation?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "formalCleaningPlan",
                                            value: answers.formalCleaningPlan,
                                            onChange: (e)=>handleAnswerChange('formalCleaningPlan', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "anomalyIdentification",
                                            children: "Are anomalies or leaks systematically identified during cleaning?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "anomalyIdentification",
                                            value: answers.anomalyIdentification,
                                            onChange: (e)=>handleAnswerChange('anomalyIdentification', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "question-group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                    className: "question-group-title",
                                    children: "4. Seiketsu (Standardize)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "visualStandards",
                                            children: "Do you have visual standards (signs, colors, floor markings) in the workshop or warehouse?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "visualStandards",
                                            value: answers.visualStandards,
                                            onChange: (e)=>handleAnswerChange('visualStandards', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "documentedStandards",
                                            children: "Are standards documented and shared with all concerned employees?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "documentedStandards",
                                            value: answers.documentedStandards,
                                            onChange: (e)=>handleAnswerChange('documentedStandards', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "standardsRevisionFrequency",
                                            children: "How often do you revise your 5S standards?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "standardsRevisionFrequency",
                                            value: answers.standardsRevisionFrequency,
                                            onChange: (e)=>handleAnswerChange('standardsRevisionFrequency', e.target.value),
                                            rows: "2"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "question-group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                    className: "question-group-title",
                                    children: "5. Shitsuke (Sustain)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "fiveSCulture",
                                            children: "Are 5S practices part of the company culture or only applied occasionally?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "fiveSCulture",
                                            value: answers.fiveSCulture,
                                            onChange: (e)=>handleAnswerChange('fiveSCulture', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "internalAudits",
                                            children: "Are internal 5S audits carried out regularly? By whom?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "internalAudits",
                                            value: answers.internalAudits,
                                            onChange: (e)=>handleAnswerChange('internalAudits', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "deviationManagement",
                                            children: "How are 5S deviations handled and communicated to the team?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "deviationManagement",
                                            value: answers.deviationManagement,
                                            onChange: (e)=>handleAnswerChange('deviationManagement', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                });
            case 2:
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questionnaire-step",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                            className: "step-title",
                            children: "Part 2: Future Desired State - 5S Vision and Objectives"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "question-group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                    className: "question-group-title",
                                    children: "Vision and ambition"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "idealVision",
                                            children: "What is your ideal vision of a successful 5S environment?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "idealVision",
                                            value: answers.idealVision,
                                            onChange: (e)=>handleAnswerChange('idealVision', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "objectives",
                                            children: "What quantitative or qualitative objectives do you aim to achieve with 5S (ex: reduced search time, improved safety, fewer accidents)?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "objectives",
                                            value: answers.objectives,
                                            onChange: (e)=>handleAnswerChange('objectives', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "extensionToOtherDepartments",
                                            children: "Do you intend to extend the 5S approach to other departments (offices, maintenance, logistics, etc.)?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "extensionToOtherDepartments",
                                            value: answers.extensionToOtherDepartments,
                                            onChange: (e)=>handleAnswerChange('extensionToOtherDepartments', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "expectedBehaviorChanges",
                                            children: "What behavior changes do you expect from your teams with better 5S adoption?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "expectedBehaviorChanges",
                                            value: answers.expectedBehaviorChanges,
                                            onChange: (e)=>handleAnswerChange('expectedBehaviorChanges', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "digitalTools",
                                            children: "Are you planning to use digital tools to support or automate 5S activities (digital checklists, QR codes, audit apps)?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "digitalTools",
                                            value: answers.digitalTools,
                                            onChange: (e)=>handleAnswerChange('digitalTools', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                });
            case 3:
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questionnaire-step",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                            className: "step-title",
                            children: "Part 3: Gap Analysis, Monitoring, and Change Management"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "question-group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                    className: "question-group-title",
                                    children: "Deployment management"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "projectManager",
                                            children: "Who is responsible for managing and monitoring the 5S project?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "projectManager",
                                            value: answers.projectManager,
                                            onChange: (e)=>handleAnswerChange('projectManager', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "performanceIndicators",
                                            children: "How do you track improvements over time? Have you implemented performance indicators?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "performanceIndicators",
                                            value: answers.performanceIndicators,
                                            onChange: (e)=>handleAnswerChange('performanceIndicators', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "mainDifficulties",
                                            children: "What are the main difficulties encountered in sustainably applying 5S?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "mainDifficulties",
                                            value: answers.mainDifficulties,
                                            onChange: (e)=>handleAnswerChange('mainDifficulties', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "trainingActions",
                                            children: "What training or awareness actions have you implemented or planned?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "trainingActions",
                                            value: answers.trainingActions,
                                            onChange: (e)=>handleAnswerChange('trainingActions', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "bestPractices",
                                            children: "What success stories or best practices have you already observed that you want to generalize across the company?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "bestPractices",
                                            value: answers.bestPractices,
                                            onChange: (e)=>handleAnswerChange('bestPractices', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                });
            default:
                return null;
        }
    };
    const handleDownloadPDF = async ()=>{
        try {
            const element = document.querySelector(".x5s1-page");
            if (!element) {
                alert("\xe2\x9d\u0152 Element not found!");
                return;
            }
            document.querySelectorAll("*").forEach((el)=>{
                const bgImage = window.getComputedStyle(el).backgroundImage;
                if (bgImage && bgImage.includes("gradient")) el.style.backgroundImage = "none";
                const bgColor = window.getComputedStyle(el).backgroundColor;
                if (bgColor.includes("var(") || bgColor === "transparent" || bgColor === "rgba(0, 0, 0, 0)") el.style.backgroundColor = "#ffffff";
            });
            const canvas = await (0, _html2CanvasDefault.default)(element, {
                scale: 2,
                useCORS: true,
                allowTaint: true,
                backgroundColor: "#ffffff",
                logging: false
            });
            const imgData = canvas.toDataURL("image/png");
            const pdf = new (0, _jspdfDefault.default)("p", "mm", "a4");
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = pdf.internal.pageSize.getHeight();
            const imgWidth = pdfWidth;
            const imgHeight = canvas.height * pdfWidth / canvas.width;
            let heightLeft = imgHeight;
            let position = 0;
            pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
            heightLeft -= pdfHeight;
            while(heightLeft > 0){
                position = heightLeft - imgHeight;
                pdf.addPage();
                pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
                heightLeft -= pdfHeight;
            }
            const date = new Date().toISOString().slice(0, 10);
            pdf.save(`5s_${date}.pdf`);
            alert("\xe2\u0153\u2026 PDF successfully generated!");
        } catch (err) {
            console.error("PDF Error:", err);
            alert("\xe2\x9d\u0152 PDF Error: " + (err.message || "unknown"));
        }
    };
    const saveLeanAnswers = async (moduleName)=>{
        try {
            const caseId = localStorage.getItem("caseId");
            if (!caseId) {
                alert("No active case found!");
                return;
            }
            console.log(`Saving answers for ${moduleName} in case ${caseId}`);
            const response = await fetch(`${"/api"}/api/lean/${moduleName}/save`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    case_id: caseId,
                    answers: answers
                })
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.detail || `Save error (${response.status}): ${data.message}`);
            alert(`\xe2\u{153}\u{2026} ${moduleName.toUpperCase()} answers saved successfully!`);
            handleNextStep();
        } catch (error) {
            console.error("\xe2\x9d\u0152 saveLeanAnswers Error:", error);
            alert("\xe2\x9d\u0152 " + error.message);
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "x5s1-page screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "header",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                        to: "/home",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "logo-icam",
                            src: "/img/1200px-logo-icam---2008-1@2x.png",
                            alt: "ICAM Logo"
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questionnaire-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                            className: "question-title",
                            children: "5S Methodology"
                        }),
                        !showQuestionnaire ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "question-section",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Has your company already implemented the 5S methodology?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "buttons-container",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            className: `choice-button ${hasImplemented ? 'active' : ''}`,
                                            onClick: handleYesClick,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            className: `choice-button ${!hasImplemented ? 'active' : ''}`,
                                            onClick: ()=>setHasImplemented(false),
                                            children: "No"
                                        })
                                    ]
                                }),
                                !hasImplemented && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "redirect-section",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "redirect-text",
                                            children: "We recommend starting by understanding the basic Lean principles:"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                            to: "/Kaizen-1",
                                            className: "redirect-button",
                                            children: "Go to the Kaizen Method"
                                        })
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                            children: !showImport ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "questionnaire-container-inner",
                                ref: questionnaireRef,
                                children: [
                                    renderProgressIndicator(),
                                    renderQuestionnaire(),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "navigation-buttons",
                                        children: [
                                            currentStep > 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                className: "nav-button prev-button",
                                                onClick: handlePrevStep,
                                                children: "Previous"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                className: "nav-button next-button",
                                                onClick: ()=>saveLeanAnswers("5s"),
                                                children: currentStep < 3 ? "Next" : "Finish"
                                            })
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "file-upload-section",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                        className: "upload-title",
                                        children: "Import your existing documents"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "upload-description",
                                        children: "You can now import your existing 5S documents, checklists, or photos:"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "upload-container",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                type: "file",
                                                ref: fileInputRef,
                                                className: "hidden-file-input",
                                                accept: ".pdf,.jpg,.jpeg,.png,.svg,.xlsx,.xls,.doc,.docx",
                                                onChange: handleFileUpload,
                                                disabled: uploadStatus.isUploading
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                className: "import-button",
                                                onClick: handleImportClick,
                                                disabled: uploadStatus.isUploading,
                                                children: uploadStatus.isUploading ? 'Uploading...' : 'Import a file'
                                            }),
                                            uploadStatus.isUploading && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "upload-progress",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "progress-bar",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "progress-bar-fill",
                                                            style: {
                                                                width: `${uploadStatus.progress}%`
                                                            }
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                        className: "progress-text",
                                                        children: [
                                                            "Uploading... ",
                                                            uploadStatus.progress,
                                                            "%"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            uploadStatus.error && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "upload-error",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                    children: uploadStatus.error
                                                })
                                            }),
                                            uploadStatus.success && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "upload-success",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                        children: [
                                                            "The file ",
                                                            uploadStatus.fileName,
                                                            " was successfully uploaded!"
                                                        ]
                                                    }),
                                                    uploadStatus.fileId && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                        className: "download-button",
                                                        onClick: ()=>window.open(`/api/5s/${uploadStatus.fileId}`, '_blank'),
                                                        children: "View file"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "navigation-buttons",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                className: "nav-button prev-button",
                                                onClick: ()=>setShowImport(false),
                                                children: "Back to questionnaire"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                                to: "/5s-2",
                                                className: "nav-button next-button",
                                                children: "Continue"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    className: "download-button",
                    onClick: handleDownloadPDF,
                    disabled: uploadStatus.isUploading,
                    children: uploadStatus.isUploading ? "Generating PDF..." : "Download PDF"
                })
            ]
        })
    });
}
exports.default = X5S1;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"b9X5n","./X5S1.css":"37FV0","jspdf":"hkJ4Q","html2canvas":"3eyQ5","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"37FV0":[function() {},{}],"42miY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _frame222 = require("../Frame222");
var _frame222Default = parcelHelpers.interopDefault(_frame222);
var _jspdf = require("jspdf");
var _jspdfDefault = parcelHelpers.interopDefault(_jspdf);
var _analysisCss = require("./Analysis.css");
// ==============================
//     CONFIG API
// ==============================
const API_URL = "/api";
const MODEL_KEYWORDS = {
    "Functional View": "functional",
    "Process View": "process",
    "Physical View": "physical",
    "Decisional View": "decisional",
    "Information Model": "information"
};
const MANAGEMENT_KEYWORDS = {
    "VSM": "vsm",
    "5S": "5s",
    "Kaizen": "kaizen",
    "SMED": "smed",
    "Kanban": "kanban",
    "Visual Management": "visual"
};
function Analysis(props) {
    const { place, formalismesEnFonct, frame222Props } = props;
    // à‰tats principaux
    const [activeTab, setActiveTab] = (0, _react.useState)("acquisition");
    const [activeCase, setActiveCase] = (0, _react.useState)(null);
    const [enterpriseScores, setEnterpriseScores] = (0, _react.useState)(null);
    const [result, setResult] = (0, _react.useState)(null);
    const [uploadStatus, setUploadStatus] = (0, _react.useState)(null);
    const [isUploading, setIsUploading] = (0, _react.useState)(false);
    const [dragActive, setDragActive] = (0, _react.useState)(false);
    const [loadingCase, setLoadingCase] = (0, _react.useState)(true);
    const [loadingScores, setLoadingScores] = (0, _react.useState)(false);
    const [errorMessage, setErrorMessage] = (0, _react.useState)(null);
    const [selectedDomain, setSelectedDomain] = (0, _react.useState)(null);
    const [selectedModel, setSelectedModel] = (0, _react.useState)(null);
    const [selectedManagement, setSelectedManagement] = (0, _react.useState)(null);
    const [domainReport, setDomainReport] = (0, _react.useState)(null);
    const [domainDetailedReport, setDomainDetailedReport] = (0, _react.useState)(null);
    const [modelReport, setModelReport] = (0, _react.useState)(null);
    const [managementReport, setManagementReport] = (0, _react.useState)(null);
    // IDs stockés localement
    const activeCaseId = localStorage.getItem("caseId");
    const activeEnterpriseId = localStorage.getItem("activeEnterpriseId");
    const token = localStorage.getItem("token");
    // ==============================
    // 1ï¸âƒ£ Chargement du cas actif
    // ==============================
    const fetchActiveCase = (0, _react.useCallback)(async ()=>{
        if (!activeCaseId) {
            setLoadingCase(false);
            setErrorMessage("Aucun cas actif s\xe9lectionn\xe9.");
            return;
        }
        try {
            setLoadingCase(true);
            const response = await fetch(`${API_URL}/api/case-details/${activeCaseId}`, {
                headers: {
                    Authorization: token ? `Bearer ${token}` : ""
                }
            });
            if (!response.ok) throw new Error("Impossible de charger le cas actif.");
            const data = await response.json();
            if (!data.found) throw new Error("Cas introuvable c\xe0\xb4t\xe9 serveur.");
            setActiveCase(data.case);
            // ðŸ‘‡ AJOUT OBLIGATOIRE POUR CORRIGER LE SPAM 404
            if (data.case.enterpriseId) localStorage.setItem("activeEnterpriseId", data.case.enterpriseId);
        } catch (err) {
            setErrorMessage(err.message);
        } finally{
            setLoadingCase(false);
        }
    }, [
        activeCaseId,
        token
    ]);
    // ==============================
    // 2ï¸âƒ£ Chargement des scores
    // ==============================
    const fetchEnterpriseScores = (0, _react.useCallback)(async ()=>{
        if (!activeEnterpriseId) return;
        try {
            setLoadingScores(true);
            const response = await fetch(`${API_URL}/api/enterprise-scores/${activeEnterpriseId}`);
            if (response.status === 404) {
                console.warn("Aucun score trouv\xe9 pour cet ID");
                setEnterpriseScores(null);
                return;
            }
            if (!response.ok) throw new Error("Erreur lors du chargement des scores.");
            const data = await response.json();
            setEnterpriseScores(data); // <-- LA VERSION CORRECTE
        } catch (err) {
            console.error("Erreur scores:", err);
            setEnterpriseScores(null);
        } finally{
            setLoadingScores(false);
        }
    }, [
        activeEnterpriseId
    ]);
    // Chargement initial
    (0, _react.useEffect)(()=>{
        fetchActiveCase();
        fetchEnterpriseScores();
    }, [
        fetchActiveCase,
        fetchEnterpriseScores
    ]);
    // ðŸ”„ Recharge les scores quand le case est chargé
    (0, _react.useEffect)(()=>{
        if (activeCase?.enterpriseId) fetchEnterpriseScores();
    }, [
        activeCase
    ]);
    // ==============================
    // 3ï¸âƒ£ UPLOAD IMAGE â€” Acquisition
    // ==============================
    const handleFileUpload = (0, _react.useCallback)(async (event)=>{
        const file = event.target.files[0];
        if (!file) return;
        if (!file.type.startsWith("image/")) {
            setUploadStatus("Erreur : fichier non valide.");
            return;
        }
        try {
            setIsUploading(true);
            setUploadStatus("T\xe9l\xe9chargement en cours...");
            const formData = new FormData();
            formData.append("file", file);
            const response = await fetch(`${API_URL}/upload`, {
                method: "POST",
                body: formData
            });
            if (!response.ok) throw new Error("Erreur serveur pendant l'upload.");
            setUploadStatus("Image import\xe9e avec succ\xe8s !");
        } catch (error) {
            setUploadStatus(`Erreur : ${error.message}`);
        } finally{
            setIsUploading(false);
        }
    }, []);
    // ==============================
    // 4ï¸âƒ£ Drag & Drop
    // ==============================
    const handleDrag = (0, _react.useCallback)((e)=>{
        e.preventDefault();
        e.stopPropagation();
        if ([
            "dragenter",
            "dragover"
        ].includes(e.type)) setDragActive(true);
        if (e.type === "dragleave") setDragActive(false);
    }, []);
    const handleDrop = (0, _react.useCallback)((e)=>{
        e.preventDefault();
        e.stopPropagation();
        setDragActive(false);
        if (e.dataTransfer.files?.[0]) handleFileUpload({
            target: {
                files: e.dataTransfer.files
            }
        });
    }, [
        handleFileUpload
    ]);
    // ==============================
    // 5ï¸âƒ£ Exécution PyKE â€” MODELES
    // ==============================
    const inference = (0, _react.useCallback)(async ()=>{
        try {
            setIsUploading(true);
            setUploadStatus("Analyse PyKE en cours...");
            setResult(null);
            const response = await fetch(`${API_URL}/inferences`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                }
            });
            if (!response.ok) {
                if (response.status === 404) throw new Error("Aucun fichier trouv\xe9.");
                throw new Error("Erreur backend PyKE.");
            }
            const data = await response.json();
            if (data.errors) setResult(data.errors);
            else if (data.message) setResult([
                data.message
            ]);
            else throw new Error("R\xe9ponse PyKE invalide.");
            setUploadStatus("Analyse termin\xe9e !");
        } catch (err) {
            setUploadStatus(`Erreur : ${err.message}`);
        } finally{
            setIsUploading(false);
        }
    }, []);
    // ==============================
    // 6ï¸âƒ£ Génération PDF
    // ==============================
    const saveAsPDF = (0, _react.useCallback)(()=>{
        if (!result?.length) return;
        const pdf = new (0, _jspdfDefault.default)();
        let y = 20;
        pdf.setFont("helvetica", "bold");
        pdf.setFontSize(18);
        pdf.text("Rapport d'Analyse PyKE", 105, y, {
            align: "center"
        });
        y += 20;
        pdf.setLineWidth(0.5);
        pdf.line(10, y, 200, y);
        y += 10;
        result.forEach((err, index)=>{
            const text = typeof err === "string" ? err : JSON.stringify(err);
            const lines = pdf.splitTextToSize(`${index + 1}. ${text}`, 180);
            if (y + lines.length * 8 > 280) {
                pdf.addPage();
                y = 20;
            }
            pdf.text(lines, 10, y);
            y += lines.length * 8;
        });
        pdf.save("analyse_pyke.pdf");
    }, [
        result
    ]);
    // ==============================
    // 7ï¸âƒ£ RENDU DES SECTIONS
    // ==============================
    const fetchFullAcquisitionReport = (0, _react.useCallback)(async ()=>{
        if (!selectedDomain || !activeEnterpriseId) return;
        try {
            setLoadingScores(true);
            setDomainReport(null);
            setDomainDetailedReport(null);
            // 1ï¸âƒ£ Detailed + vrai score calculé cà´té backend
            const detailedRes = await fetch(`${API_URL}/expert/evaluate?enterpriseId=${activeEnterpriseId}&domain=${encodeURIComponent(selectedDomain)}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify([])
            });
            if (!detailedRes.ok) throw new Error("Erreur Detailed Report");
            const detailedData = await detailedRes.json();
            // questions NO + suggestions
            setDomainDetailedReport(detailedData.mongo_data || []);
            // âœ… score calculé avec : (Yes * 20 / total)
            const score = detailedData.score || 0;
            // 2ï¸âƒ£ Global report basé sur ce score
            const globalRes = await fetch(`${API_URL}/expert/global-report?domain=${encodeURIComponent(selectedDomain)}&score=${score}`);
            if (!globalRes.ok) throw new Error("Erreur Global Report");
            const globalData = await globalRes.json();
            setDomainReport(globalData);
        } catch (err) {
            setErrorMessage(err.message);
        } finally{
            setLoadingScores(false);
        }
    }, [
        selectedDomain,
        activeEnterpriseId
    ]);
    const renderAcquisition = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
            className: "analysis-section",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                    className: "section-title",
                    children: " Acquisition"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "section-subtitle",
                    children: "Choose a domain to analyse."
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "acq-buttons-grid",
                    children: [
                        "Environmental",
                        "Social",
                        "Modernization",
                        "Lead Time",
                        "Cost",
                        "Quality",
                        "Client Consumer"
                    ].map((domain)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            className: `acq-btn ${selectedDomain === domain ? "active" : ""}`,
                            onClick: ()=>setSelectedDomain(domain),
                            children: domain
                        }, domain))
                }),
                selectedDomain && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "report-section",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "report-header",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "report-icon"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                    className: "report-title",
                                    children: [
                                        "Reports for ",
                                        selectedDomain
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "report-buttons",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: "report-btn",
                                onClick: fetchFullAcquisitionReport,
                                children: "Generate report"
                            })
                        }),
                        domainReport && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "global-report-box",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                    children: "Global Report"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                            children: "Domain:"
                                        }),
                                        " ",
                                        domainReport.domain
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                            children: "Score:"
                                        }),
                                        " ",
                                        domainReport.score
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    children: domainReport.global_message
                                })
                            ]
                        }),
                        domainDetailedReport && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "detailed-report-box",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                    children: "Detailed Report"
                                }),
                                domainDetailedReport.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    children: "No issues found for this domain."
                                }) : domainDetailedReport.map((item, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "detailed-item",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                        children: "Question:"
                                                    }),
                                                    " ",
                                                    item.question
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                        children: "Answer:"
                                                    }),
                                                    " ",
                                                    item.answer
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                        children: "Suggestion:"
                                                    }),
                                                    " ",
                                                    item.suggestion
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {})
                                        ]
                                    }, idx))
                            ]
                        })
                    ]
                })
            ]
        });
    const fetchModelReport = (0, _react.useCallback)(async ()=>{
        if (!selectedModel) return;
        try {
            setLoadingScores(true);
            setModelReport(null);
            // ðŸ”¥ ON UTILISE LE BON MOT-CLà‰
            const mappedKeyword = MODEL_KEYWORDS[selectedModel];
            const response = await fetch(`${API_URL}/expert/analyse-pdf-by-name?keyword=${mappedKeyword}`);
            if (!response.ok) throw new Error("Erreur lors de l'analyse des mod\xe8les.");
            const data = await response.json();
            setModelReport(data);
        } catch (err) {
            setErrorMessage(err.message);
        } finally{
            setLoadingScores(false);
        }
    }, [
        selectedModel
    ]);
    const renderModeles = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
            className: "analysis-section",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                    className: "section-title",
                    children: "Models"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "section-subtitle",
                    children: "Choose a model to analyse."
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "model-buttons-grid",
                    children: [
                        "Functional View",
                        "Process View",
                        "Physical View",
                        "Decisional View",
                        "Information Model"
                    ].map((name)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            className: `model-btn ${selectedModel === name ? "active" : ""}`,
                            onClick: ()=>setSelectedModel(name),
                            children: name
                        }, name))
                }),
                selectedModel && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "report-section",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "report-header",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "report-icon"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                    className: "report-title",
                                    children: [
                                        "Reports for ",
                                        selectedModel
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "report-buttons",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: "report-btn",
                                onClick: fetchModelReport,
                                children: "Generate analysis"
                            })
                        }),
                        modelReport && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "global-report-box",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                            children: "Model Analysis Summary"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                    children: "View Type:"
                                                }),
                                                " ",
                                                modelReport.view_type
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                    children: "PDFs analyzed:"
                                                }),
                                                " ",
                                                modelReport.pdf_found_count
                                            ]
                                        })
                                    ]
                                }),
                                modelReport.results.map((pdf, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "detailed-report-box",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                                children: pdf.filename
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                        children: "Nodes:"
                                                    }),
                                                    " ",
                                                    pdf.nodes
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                        children: "Arrows:"
                                                    }),
                                                    " ",
                                                    pdf.arrows
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                        children: "Total Shapes:"
                                                    }),
                                                    " ",
                                                    pdf.total_shapes
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                        children: "Score:"
                                                    }),
                                                    " ",
                                                    pdf.score,
                                                    " / 20"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                        children: "Interpretation:"
                                                    }),
                                                    " ",
                                                    pdf.interpretation
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                                children: "Rules Evaluation"
                                            }),
                                            pdf.rules_evaluation.map((rule, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "detailed-item",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                                    children: "Rule:"
                                                                }),
                                                                " ",
                                                                rule.rule
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                                    children: "Status:"
                                                                }),
                                                                " ",
                                                                rule.passed ? "\xe2\u0153\u2026 Passed" : "\xe2\x9d\u0152 Failed"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                                    children: "Detail:"
                                                                }),
                                                                " ",
                                                                rule.detail
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {})
                                                    ]
                                                }, idx))
                                        ]
                                    }, index))
                            ]
                        })
                    ]
                })
            ]
        });
    const fetchManagementReport = (0, _react.useCallback)(async ()=>{
        if (!selectedManagement) return;
        try {
            setLoadingScores(true);
            setManagementReport(null);
            const mappedKeyword = MANAGEMENT_KEYWORDS[selectedManagement];
            const response = await fetch(`${API_URL}/expert/analyse-pdf-by-name?keyword=${mappedKeyword}`);
            if (!response.ok) throw new Error("Erreur lors de l\xe2\u20AC\u2122analyse du management.");
            const data = await response.json();
            setManagementReport(data);
        } catch (err) {
            setErrorMessage(err.message);
        } finally{
            setLoadingScores(false);
        }
    }, [
        selectedManagement
    ]);
    const renderManagements = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
            className: "analysis-section",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                    className: "section-title",
                    children: "Managements"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "section-subtitle",
                    children: "Choose a lean management tool."
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "management-buttons-grid",
                    children: [
                        "VSM",
                        "5S",
                        "Kaizen",
                        "SMED",
                        "Kanban",
                        "Visual Management"
                    ].map((tool)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            className: `mgmt-btn ${selectedManagement === tool ? "active" : ""}`,
                            onClick: ()=>setSelectedManagement(tool),
                            children: tool
                        }, tool))
                }),
                selectedManagement && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "report-section",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "report-header",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "report-icon"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                    className: "report-title",
                                    children: [
                                        "Reports for ",
                                        selectedManagement
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "report-buttons",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: "report-btn",
                                onClick: fetchManagementReport,
                                children: "Generate analysis"
                            })
                        }),
                        managementReport && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "global-report-box",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                            children: "Management Tool Analysis Summary"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                    children: "Keyword:"
                                                }),
                                                " ",
                                                managementReport.view_type
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                    children: "PDFs analyzed:"
                                                }),
                                                " ",
                                                managementReport.pdf_found_count
                                            ]
                                        })
                                    ]
                                }),
                                managementReport.results.map((pdf, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "detailed-report-box",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                                children: pdf.filename
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                        children: "Nodes:"
                                                    }),
                                                    " ",
                                                    pdf.nodes
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                        children: "Arrows:"
                                                    }),
                                                    " ",
                                                    pdf.arrows
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                        children: "Total Shapes:"
                                                    }),
                                                    " ",
                                                    pdf.total_shapes
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                        children: "Score:"
                                                    }),
                                                    " ",
                                                    pdf.score,
                                                    " / 20"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                        children: "Interpretation:"
                                                    }),
                                                    " ",
                                                    pdf.interpretation
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                                children: "Rules Evaluation"
                                            }),
                                            pdf.rules_evaluation.map((rule, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "detailed-item",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                                    children: "Rule:"
                                                                }),
                                                                " ",
                                                                rule.rule
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                                    children: "Status:"
                                                                }),
                                                                " ",
                                                                rule.passed ? "\xe2\u0153\u2026 Passed" : "\xe2\x9d\u0152 Failed"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                                    children: "Detail:"
                                                                }),
                                                                " ",
                                                                rule.detail
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {})
                                                    ]
                                                }, idx))
                                        ]
                                    }, index))
                            ]
                        })
                    ]
                })
            ]
        });
    // ==============================
    // 8ï¸âƒ£ RENDU FINAL
    // ==============================
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "analysis-container",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("main", {
                    className: "analysis-main",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("section", {
                            className: "case-header",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "case-card improved-case-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                        className: "case-title improved-case-title",
                                        children: activeCase?.company_name || "Active case"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "case-subtitle improved-case-subtitle",
                                        children: activeCase ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                    className: "case-info-item",
                                                    children: [
                                                        "Sector :",
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("strong", {
                                                            children: [
                                                                " ",
                                                                activeCase.activity_sector || "N/A"
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "case-divider"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                    className: "case-info-item",
                                                    children: [
                                                        "Company size :",
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("strong", {
                                                            children: [
                                                                " ",
                                                                activeCase.company_size || "N/A"
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }) : "No case selected"
                                    }),
                                    activeCase && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                        className: "case-created improved-case-created",
                                        children: [
                                            "Created on :",
                                            " ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                children: activeCase.date_created || activeCase.timestamp || "Unknown date"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                        className: "case-id-display improved-case-id",
                                        children: [
                                            "Case ID : ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                children: activeCaseId || "\xe2\u20AC\u201D"
                                            })
                                        ]
                                    }),
                                    errorMessage && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "case-error improved-case-error",
                                        children: errorMessage
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "tabs-section",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    className: `tab-button ${activeTab === "acquisition" ? "active" : ""}`,
                                    onClick: ()=>setActiveTab("acquisition"),
                                    children: " Acquisition"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    className: `tab-button ${activeTab === "modeles" ? "active" : ""}`,
                                    onClick: ()=>setActiveTab("modeles"),
                                    children: "Models"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    className: `tab-button ${activeTab === "managements" ? "active" : ""}`,
                                    onClick: ()=>setActiveTab("managements"),
                                    children: "Managements"
                                })
                            ]
                        }),
                        activeTab === "acquisition" && renderAcquisition(),
                        activeTab === "modeles" && renderModeles(),
                        activeTab === "managements" && renderManagements()
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "icam-navigation",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                        to: "/pdf-uploader",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            className: "icam-nav-btn",
                            children: "Back to saving"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                        to: "/conception",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            className: "icam-nav-btn",
                            children: "Move to conception"
                        })
                    })
                ]
            })
        ]
    });
}
exports.default = Analysis;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"b9X5n","../Frame222":"8cNiy","jspdf":"hkJ4Q","./Analysis.css":"17Su0","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8cNiy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame222Css = require("./Frame222.css");
function Frame222(props) {
    const { children } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "frame-2-11",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "continue-6 valign-text-middle inter-bold-mineral-green-18px",
            children: children
        })
    });
}
exports.default = Frame222;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./Frame222.css":"2pcoa","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2pcoa":[function() {},{}],"17Su0":[function() {},{}],"fkaAq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _frame222 = require("../Frame222");
var _frame222Default = parcelHelpers.interopDefault(_frame222);
var _jspdf = require("jspdf");
var _jspdfDefault = parcelHelpers.interopDefault(_jspdf);
var _analysisBetaCss = require("./AnalysisBeta.css");
// ==============================
//     CONFIG API
// ==============================
const API_URL = "/api";
const MANAGEMENT_KEYWORDS = {
    VSM: "vsm",
    "5S": "5s",
    Kaizen: "kaizen",
    SMED: "smed",
    Kanban: "kanban",
    "Visual Management": "visual"
};
function Analysis(props) {
    const { place, formalismesEnFonct, frame222Props } = props;
    // à‰tats principaux
    const [activeTab, setActiveTab] = (0, _react.useState)("acquisition");
    const [activeCase, setActiveCase] = (0, _react.useState)(null);
    const [enterpriseScores, setEnterpriseScores] = (0, _react.useState)(null);
    const [result, setResult] = (0, _react.useState)(null);
    const [uploadStatus, setUploadStatus] = (0, _react.useState)(null);
    const [isUploading, setIsUploading] = (0, _react.useState)(false);
    const [dragActive, setDragActive] = (0, _react.useState)(false);
    const [loadingCase, setLoadingCase] = (0, _react.useState)(true);
    const [loadingScores, setLoadingScores] = (0, _react.useState)(false);
    const [errorMessage, setErrorMessage] = (0, _react.useState)(null);
    const [selectedDomain, setSelectedDomain] = (0, _react.useState)(null);
    const [selectedModel, setSelectedModel] = (0, _react.useState)(null);
    const [selectedManagementTool, setSelectedManagementTool] = (0, _react.useState)(null);
    const [selectedManagementFileId, setSelectedManagementFileId] = (0, _react.useState)(null);
    const [domainReport, setDomainReport] = (0, _react.useState)(null);
    const [domainDetailedReport, setDomainDetailedReport] = (0, _react.useState)(null);
    const [modelReport, setModelReport] = (0, _react.useState)(null);
    const [managementExpertReport, setManagementExpertReport] = (0, _react.useState)(null);
    const [managementAIReport, setManagementAIReport] = (0, _react.useState)(null);
    const [aiCaseAnalysis, setAiCaseAnalysis] = (0, _react.useState)(null);
    const [aiAcquisitionAnalysis, setAiAcquisitionAnalysis] = (0, _react.useState)(null);
    const [aiModelsAnalysis, setAiModelsAnalysis] = (0, _react.useState)(null);
    const [graiModels, setGraiModels] = (0, _react.useState)([]);
    const [selectedModelId, setSelectedModelId] = (0, _react.useState)(null);
    const [modelAnalysisMode, setModelAnalysisMode] = (0, _react.useState)("expert"); // "expert" ou "ai"
    const [managementAnalysisMode, setManagementAnalysisMode] = (0, _react.useState)("expert"); // "expert" | "ai"
    // ==============================
    // âœ… RULES ENGINE (NEW)
    // ==============================
    // ==============================
    // âœ… RULES CRUD (NEW)
    // ==============================
    const [rulesCatalog, setRulesCatalog] = (0, _react.useState)([]);
    const [rulesLoading, setRulesLoading] = (0, _react.useState)(false);
    const [rulesError, setRulesError] = (0, _react.useState)(null);
    // --- Create form
    const [newRule, setNewRule] = (0, _react.useState)({
        rule_type: "model",
        target: "",
        code: "",
        title: "",
        description: "",
        condition: "{}",
        weight: 1.0,
        enabled: true,
        created_by: ""
    });
    const [createStatus, setCreateStatus] = (0, _react.useState)(null);
    // --- Update form (optional but very useful)
    const [selectedRuleId, setSelectedRuleId] = (0, _react.useState)("");
    const [editRule, setEditRule] = (0, _react.useState)({
        title: "",
        description: "",
        condition: "{}",
        weight: 1.0,
        enabled: true
    });
    const [updateStatus, setUpdateStatus] = (0, _react.useState)(null);
    const [deleteStatus, setDeleteStatus] = (0, _react.useState)(null);
    const MODEL_KEYWORDS = {
        "Functional View": "functional",
        "Process View": "process",
        "Physical View": "physical",
        "Decisional View": "decisional",
        "Information Model": "information"
    };
    // IDs stockés localement
    const activeCaseId = localStorage.getItem("caseId");
    const activeEnterpriseId = localStorage.getItem("activeEnterpriseId");
    const token = localStorage.getItem("token");
    // ==============================
    // 1ï¸âƒ£ Chargement du cas actif
    // ==============================
    const fetchActiveCase = (0, _react.useCallback)(async ()=>{
        if (!activeCaseId) {
            setLoadingCase(false);
            setErrorMessage("Aucun cas actif s\xe9lectionn\xe9.");
            return;
        }
        try {
            setLoadingCase(true);
            const response = await fetch(`${API_URL}/api/case-details/${activeCaseId}`, {
                headers: {
                    Authorization: token ? `Bearer ${token}` : ""
                }
            });
            if (!response.ok) throw new Error("Impossible de charger le cas actif.");
            const data = await response.json();
            if (!data.found) throw new Error("Cas introuvable c\xe0\xb4t\xe9 serveur.");
            setActiveCase(data.case);
            // ðŸ‘‡ AJOUT OBLIGATOIRE POUR CORRIGER LE SPAM 404
            if (data.case.enterpriseId) localStorage.setItem("activeEnterpriseId", data.case.enterpriseId);
        } catch (err) {
            setErrorMessage(err.message);
        } finally{
            setLoadingCase(false);
        }
    }, [
        activeCaseId,
        token
    ]);
    const fetchGraiModels = (0, _react.useCallback)(async ()=>{
        if (!activeEnterpriseId) return;
        try {
            const res = await fetch(`${API_URL}/api/models/${activeEnterpriseId}`);
            if (!res.ok) throw new Error("Impossible de charger les mod\xe8les");
            const data = await res.json();
            setGraiModels(data.models || []);
        } catch (err) {
            setErrorMessage(err.message);
        }
    }, [
        activeEnterpriseId
    ]);
    (0, _react.useEffect)(()=>{
        fetchGraiModels();
    }, [
        fetchGraiModels
    ]);
    (0, _react.useEffect)(()=>{
        if (modelAnalysisMode === "expert") {
            setSelectedModelId(null);
            setAiModelsAnalysis(null);
        } else {
            setSelectedModel(null);
            setModelReport(null);
        }
    }, [
        modelAnalysisMode
    ]);
    const inferModelType = (filename)=>{
        const name = (filename || "").toLowerCase();
        if (name.includes("functional")) return "functional";
        if (name.includes("process")) return "process";
        if (name.includes("physical")) return "physical";
        if (name.includes("decision")) return "decisional";
        if (name.includes("information")) return "information";
        return null;
    };
    // ==============================
    // 2ï¸âƒ£ Chargement des scores
    // ==============================
    const fetchEnterpriseScores = (0, _react.useCallback)(async ()=>{
        if (!activeEnterpriseId) return;
        try {
            setLoadingScores(true);
            const response = await fetch(`${API_URL}/api/enterprise-scores/${activeEnterpriseId}`);
            if (response.status === 404) {
                console.warn("\xe2\u0161\xa0\xef\xb8\x8f Aucun score trouv\xe9 pour cet ID");
                setEnterpriseScores(null);
                return;
            }
            if (!response.ok) throw new Error("Erreur lors du chargement des scores.");
            const data = await response.json();
            setEnterpriseScores(data);
        } catch (err) {
            console.error("Erreur scores:", err);
            setEnterpriseScores(null);
        } finally{
            setLoadingScores(false);
        }
    }, [
        activeEnterpriseId
    ]);
    // Chargement initial
    (0, _react.useEffect)(()=>{
        fetchActiveCase();
        fetchEnterpriseScores();
    }, [
        fetchActiveCase,
        fetchEnterpriseScores
    ]);
    // ðŸ”„ Recharge les scores quand le case est chargé
    (0, _react.useEffect)(()=>{
        if (activeCase?.enterpriseId) fetchEnterpriseScores();
    }, [
        activeCase,
        fetchEnterpriseScores
    ]);
    // ==============================
    // 3ï¸âƒ£ UPLOAD IMAGE â€” Acquisition
    // ==============================
    const handleFileUpload = (0, _react.useCallback)(async (event)=>{
        const file = event.target.files[0];
        if (!file) return;
        if (!file.type.startsWith("image/")) {
            setUploadStatus("Erreur : fichier non valide.");
            return;
        }
        try {
            setIsUploading(true);
            setUploadStatus("T\xe9l\xe9chargement en cours...");
            const formData = new FormData();
            formData.append("file", file);
            const response = await fetch(`${API_URL}/upload`, {
                method: "POST",
                body: formData
            });
            if (!response.ok) throw new Error("Erreur serveur pendant l'upload.");
            setUploadStatus("Image import\xe9e avec succ\xe8s !");
        } catch (error) {
            setUploadStatus(`Erreur : ${error.message}`);
        } finally{
            setIsUploading(false);
        }
    }, []);
    // ==============================
    // 4ï¸âƒ£ Drag & Drop
    // ==============================
    const handleDrag = (0, _react.useCallback)((e)=>{
        e.preventDefault();
        e.stopPropagation();
        if ([
            "dragenter",
            "dragover"
        ].includes(e.type)) setDragActive(true);
        if (e.type === "dragleave") setDragActive(false);
    }, []);
    const handleDrop = (0, _react.useCallback)((e)=>{
        e.preventDefault();
        e.stopPropagation();
        setDragActive(false);
        if (e.dataTransfer.files?.[0]) handleFileUpload({
            target: {
                files: e.dataTransfer.files
            }
        });
    }, [
        handleFileUpload
    ]);
    // ==============================
    // 5ï¸âƒ£ Exécution PyKE â€” MODELES
    // ==============================
    const inference = (0, _react.useCallback)(async ()=>{
        try {
            setIsUploading(true);
            setUploadStatus("Analyse PyKE en cours...");
            setResult(null);
            const response = await fetch(`${API_URL}/inferences`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                }
            });
            if (!response.ok) {
                if (response.status === 404) throw new Error("Aucun fichier trouv\xe9.");
                throw new Error("Erreur backend PyKE.");
            }
            const data = await response.json();
            if (data.errors) setResult(data.errors);
            else if (data.message) setResult([
                data.message
            ]);
            else throw new Error("R\xe9ponse PyKE invalide.");
            setUploadStatus("Analyse termin\xe9e !");
        } catch (err) {
            setUploadStatus(`Erreur : ${err.message}`);
        } finally{
            setIsUploading(false);
        }
    }, []);
    const renderAI = (text)=>{
        try {
            const obj = JSON.parse(text);
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("pre", {
                className: "ai-json-box",
                children: JSON.stringify(obj, null, 2)
            });
        } catch (e) {
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("pre", {
                className: "ai-text-box",
                children: text
            });
        }
    };
    const fetchAICaseAnalysis = (0, _react.useCallback)(async ()=>{
        if (!activeCaseId) return;
        try {
            setLoadingScores(true);
            setAiCaseAnalysis(null);
            const response = await fetch(`${API_URL}/api/ai/analyse-case`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    case_id: activeCaseId
                })
            });
            if (!response.ok) throw new Error("Erreur IA analyse case");
            const data = await response.json();
            setAiCaseAnalysis(data.analysis);
        } catch (err) {
            setErrorMessage(err.message);
        } finally{
            setLoadingScores(false);
        }
    }, [
        activeCaseId
    ]);
    const fetchAIAcquisitionAnalysis = (0, _react.useCallback)(async ()=>{
        if (!activeEnterpriseId) return;
        try {
            setLoadingScores(true);
            setAiAcquisitionAnalysis(null);
            const response = await fetch(`${API_URL}/api/ai/analyse-acquisition/${activeEnterpriseId}`);
            const data = await response.json();
            if (!response.ok) {
                setAiAcquisitionAnalysis("\xe2\u0161\xa0\xef\xb8\x8f No acquisition data found for this enterprise.");
                return;
            }
            setAiAcquisitionAnalysis(data.analysis);
        } catch (err) {
            setErrorMessage(err.message);
        } finally{
            setLoadingScores(false);
        }
    }, [
        activeEnterpriseId
    ]);
    const fetchAIModelsAnalysis = (0, _react.useCallback)(async ()=>{
        if (!selectedModelId) return;
        try {
            setLoadingScores(true);
            setAiModelsAnalysis(null);
            const model = graiModels.find((m)=>m._id === selectedModelId);
            if (!model) throw new Error("Model not found");
            const modelType = inferModelType(model.filename);
            if (!modelType) {
                setAiModelsAnalysis("\xe2\x9d\u0152 Type de mod\xe8le non reconnu.");
                return;
            }
            const response = await fetch(`${API_URL}/api/ai/analyse-model/${model._id}/${modelType}`);
            if (!response.ok) throw new Error("Erreur IA mod\xe8le");
            const data = await response.json();
            setAiModelsAnalysis(data.analysis);
        } catch (err) {
            setErrorMessage(err.message);
        } finally{
            setLoadingScores(false);
        }
    }, [
        selectedModelId,
        graiModels
    ]);
    // ==============================
    // 6ï¸âƒ£ Génération PDF (PyKE)
    // ==============================
    const saveAsPDF = (0, _react.useCallback)(()=>{
        if (!result?.length) return;
        const pdf = new (0, _jspdfDefault.default)();
        let y = 20;
        pdf.setFont("helvetica", "bold");
        pdf.setFontSize(18);
        pdf.text("Rapport d'Analyse PyKE", 105, y, {
            align: "center"
        });
        y += 20;
        pdf.setLineWidth(0.5);
        pdf.line(10, y, 200, y);
        y += 10;
        result.forEach((err, index)=>{
            const text = typeof err === "string" ? err : JSON.stringify(err);
            const lines = pdf.splitTextToSize(`${index + 1}. ${text}`, 180);
            if (y + lines.length * 8 > 280) {
                pdf.addPage();
                y = 20;
            }
            pdf.text(lines, 10, y);
            y += lines.length * 8;
        });
        pdf.save("analyse_pyke.pdf");
    }, [
        result
    ]);
    // ==============================
    // PDF helper (generic)
    // ==============================
    const downloadAnalysisPDF = (title, content)=>{
        if (!content) return;
        const pdf = new (0, _jspdfDefault.default)("p", "mm", "a4");
        const marginX = 15;
        let y = 20;
        const pageHeight = pdf.internal.pageSize.height;
        pdf.setFont("helvetica", "bold");
        pdf.setFontSize(18);
        pdf.text(title, marginX, y);
        y += 10;
        pdf.setLineWidth(0.5);
        pdf.line(marginX, y, 195, y);
        y += 10;
        pdf.setFont("helvetica", "normal");
        pdf.setFontSize(12);
        const lines = pdf.splitTextToSize(content, 180);
        lines.forEach((line)=>{
            if (y > pageHeight - 15) {
                pdf.addPage();
                y = 20;
            }
            pdf.text(line, marginX, y);
            y += 7;
        });
        pdf.save(`${title.replace(/\s+/g, "_").toLowerCase()}.pdf`);
    };
    // ==============================
    // 7ï¸âƒ£ RENDU DES SECTIONS
    // ==============================
    const fetchFullAcquisitionReport = (0, _react.useCallback)(async ()=>{
        if (!selectedDomain || !activeEnterpriseId) return;
        try {
            setLoadingScores(true);
            setDomainReport(null);
            setDomainDetailedReport(null);
            const detailedRes = await fetch(`${API_URL}/expert/evaluate?enterpriseId=${activeEnterpriseId}&domain=${encodeURIComponent(selectedDomain)}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify([])
            });
            if (!detailedRes.ok) throw new Error("Erreur Detailed Report");
            const detailedData = await detailedRes.json();
            setDomainDetailedReport(detailedData.mongo_data || []);
            const score = detailedData.score || 0;
            const globalRes = await fetch(`${API_URL}/expert/global-report?domain=${encodeURIComponent(selectedDomain)}&score=${score}`);
            if (!globalRes.ok) throw new Error("Erreur Global Report");
            const globalData = await globalRes.json();
            setDomainReport(globalData);
        } catch (err) {
            setErrorMessage(err.message);
        } finally{
            setLoadingScores(false);
        }
    }, [
        selectedDomain,
        activeEnterpriseId
    ]);
    const buildAcquisitionPDFContent = ()=>{
        if (!domainReport) return "";
        let content = `
Domain: ${domainReport.domain}
Score: ${domainReport.score}

Global Analysis:
${domainReport.global_message}
`.trim();
        if (domainDetailedReport && domainDetailedReport.length > 0) {
            content += "\n\nDetailed Analysis:\n";
            domainDetailedReport.forEach((item, index)=>{
                content += `
${index + 1}. Question: ${item.question}
Answer: ${item.answer}
Suggestion: ${item.suggestion}
`.trim();
                content += "\n\n";
            });
        }
        return content.trim();
    };
    const renderAcquisition = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
            className: "analysis-section",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                    className: "section-title",
                    children: " Acquisition"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "section-subtitle",
                    children: "Choose a domain to analyse."
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "acq-buttons-grid",
                    children: [
                        "Environmental",
                        "Social",
                        "Modernization",
                        "Lead Time",
                        "Cost",
                        "Quality",
                        "Client Consumer"
                    ].map((domain)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            className: `acq-btn ${selectedDomain === domain ? "active" : ""}`,
                            onClick: ()=>setSelectedDomain(domain),
                            children: domain
                        }, domain))
                }),
                selectedDomain && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "report-section",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "report-header",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "report-icon"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                    className: "report-title",
                                    children: [
                                        "Reports for ",
                                        selectedDomain
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "report-buttons",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    className: "report-btn",
                                    onClick: fetchFullAcquisitionReport,
                                    children: "Generate report"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    className: "report-btn ai-btn",
                                    disabled: !domainReport,
                                    onClick: ()=>downloadAnalysisPDF(`Acquisition Analysis - ${selectedDomain}`, buildAcquisitionPDFContent()),
                                    children: "Download PDF"
                                })
                            ]
                        }),
                        domainReport && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "global-report-box",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                    children: "Global Report"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                            children: "Domain:"
                                        }),
                                        " ",
                                        domainReport.domain
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                            children: "Score:"
                                        }),
                                        " ",
                                        domainReport.score
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    children: domainReport.global_message
                                })
                            ]
                        }),
                        domainDetailedReport && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "detailed-report-box",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                    children: "Detailed Report"
                                }),
                                domainDetailedReport.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    children: "No issues found for this domain."
                                }) : domainDetailedReport.map((item, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "detailed-item",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                        children: "Question:"
                                                    }),
                                                    " ",
                                                    item.question
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                        children: "Answer:"
                                                    }),
                                                    " ",
                                                    item.answer
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                        children: "Suggestion:"
                                                    }),
                                                    " ",
                                                    item.suggestion
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {})
                                        ]
                                    }, idx))
                            ]
                        })
                    ]
                })
            ]
        });
    const fetchModelReport = (0, _react.useCallback)(async ()=>{
        if (!selectedModel) return;
        try {
            setLoadingScores(true);
            setModelReport(null);
            const mappedKeyword = MODEL_KEYWORDS[selectedModel];
            const response = await fetch(`${API_URL}/expert/analyse-pdf-by-name?keyword=${mappedKeyword}`);
            if (!response.ok) throw new Error("Erreur lors de l\xe2\u20AC\u2122analyse des mod\xe8les.");
            const data = await response.json();
            setModelReport(data);
        } catch (err) {
            setErrorMessage(err.message);
        } finally{
            setLoadingScores(false);
        }
    }, [
        selectedModel
    ]);
    const ALLOWED_MODEL_KEYWORDS = [
        "functional",
        "process",
        "physical",
        "decisional",
        "information"
    ];
    const filteredGraiModels = graiModels.filter((model)=>{
        const name = (model.filename || "").toLowerCase();
        return ALLOWED_MODEL_KEYWORDS.some((keyword)=>name.includes(keyword));
    });
    const cleanAI = (text)=>{
        if (!text) return "";
        text = text.replace(/```json/gi, "").replace(/```/g, "");
        let obj = null;
        try {
            obj = JSON.parse(text);
        } catch  {
            return text;
        }
        let final = "";
        const writeSection = (title, content)=>{
            final += `\n\n ${title}\n`;
            if (Array.isArray(content)) content.forEach((item)=>final += `${item}\n`);
            else if (typeof content === "string") final += content + "\n";
            else if (typeof content === "object" && content !== null) Object.entries(content).forEach(([k, v])=>final += `${k} : ${v}\n`);
        };
        Object.entries(obj).forEach(([key, value])=>{
            const title = key.replace(/_/g, " ").replace(/([A-Z])/g, " $1").replace(/^./, (c)=>c.toUpperCase());
            writeSection(title, value);
        });
        return final.trim();
    };
    const renderModeles = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
            className: "analysis-section",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                    className: "section-title",
                    children: "Models"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "section-subtitle",
                    children: "Analyse models using expert rules or AI interpretation."
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "model-buttons-grid",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            className: `model-btn ${modelAnalysisMode === "expert" ? "active" : ""}`,
                            onClick: ()=>setModelAnalysisMode("expert"),
                            children: "Expert Structure Analysis"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            className: `model-btn ${modelAnalysisMode === "ai" ? "active" : ""}`,
                            onClick: ()=>setModelAnalysisMode("ai"),
                            children: "AI PDF Analysis"
                        })
                    ]
                }),
                modelAnalysisMode === "expert" && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "section-subtitle",
                            children: "Select a view to analyse."
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "model-buttons-grid",
                            children: [
                                "Functional View",
                                "Process View",
                                "Physical View",
                                "Decisional View",
                                "Information Model"
                            ].map((name)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    className: `model-btn ${selectedModel === name ? "active" : ""}`,
                                    onClick: ()=>setSelectedModel(name),
                                    children: name
                                }, name))
                        }),
                        selectedModel && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "report-section",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "report-header",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "report-icon"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                            className: "report-title",
                                            children: [
                                                "Expert report for ",
                                                selectedModel
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "report-buttons",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        className: "report-btn",
                                        onClick: fetchModelReport,
                                        children: "Generate analysis"
                                    })
                                }),
                                modelReport && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "global-report-box",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                                    children: "Model Analysis Summary"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                            children: "View Type:"
                                                        }),
                                                        " ",
                                                        modelReport.view_type
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                            children: "PDFs analyzed:"
                                                        }),
                                                        " ",
                                                        modelReport.pdf_found_count
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "report-buttons",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                className: "report-btn",
                                                onClick: ()=>downloadAnalysisPDF(`GRAI Expert Analysis - ${selectedModel}`, JSON.stringify(modelReport, null, 2)),
                                                children: "Download PDF"
                                            })
                                        }),
                                        Array.isArray(modelReport.results) && modelReport.results.map((pdf, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "detailed-report-box",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                                        children: pdf.filename
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                                children: "Nodes:"
                                                            }),
                                                            " ",
                                                            pdf.nodes
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                                children: "Arrows:"
                                                            }),
                                                            " ",
                                                            pdf.arrows
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                                children: "Total Shapes:"
                                                            }),
                                                            " ",
                                                            pdf.total_shapes
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                                children: "Score:"
                                                            }),
                                                            " ",
                                                            pdf.score,
                                                            " / 20"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                                children: "Interpretation:"
                                                            }),
                                                            " ",
                                                            pdf.interpretation
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                                        children: "Rules Evaluation"
                                                    }),
                                                    pdf.rules_evaluation.map((rule, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "detailed-item",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                                            children: "Rule:"
                                                                        }),
                                                                        " ",
                                                                        rule.rule
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                                            children: "Status:"
                                                                        }),
                                                                        " ",
                                                                        rule.passed ? "\xe2\u0153\u2026 Passed" : "\xe2\x9d\u0152 Failed"
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                                            children: "Detail:"
                                                                        }),
                                                                        " ",
                                                                        rule.detail
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {})
                                                            ]
                                                        }, idx))
                                                ]
                                            }, index))
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                modelAnalysisMode === "ai" && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "section-subtitle",
                            children: "Select a uploaded model (PDF)."
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("select", {
                            className: "model-select",
                            value: selectedModelId || "",
                            onChange: (e)=>setSelectedModelId(e.target.value),
                            disabled: filteredGraiModels.length === 0,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                    value: "",
                                    children: filteredGraiModels.length === 0 ? "-- No valid model available --" : "-- Select a model to analyse --"
                                }),
                                filteredGraiModels.map((model)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                        value: model._id,
                                        children: model.filename
                                    }, model._id))
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "report-buttons",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: "report-btn ai-btn",
                                disabled: !selectedModelId,
                                onClick: fetchAIModelsAnalysis,
                                children: "Generate AI Model Analysis"
                            })
                        }),
                        aiModelsAnalysis && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "ai-report-box",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                    children: "AI Interpretation"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("pre", {
                                    className: "ai-clean-text",
                                    children: cleanAI(aiModelsAnalysis)
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "report-buttons",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        className: "report-btn",
                                        onClick: ()=>downloadAnalysisPDF("GRAI Model AI Analysis", cleanAI(aiModelsAnalysis)),
                                        children: "Download PDF"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    const fetchManagementReport = (0, _react.useCallback)(async ()=>{
        if (!selectedManagementTool) return;
        try {
            setLoadingScores(true);
            setManagementExpertReport(null);
            const mappedKeyword = MANAGEMENT_KEYWORDS[selectedManagementTool];
            if (!mappedKeyword) return;
            const response = await fetch(`${API_URL}/expert/analyse-pdf-by-name?keyword=${mappedKeyword}`);
            if (!response.ok) throw new Error("Erreur lors de l\xe2\u20AC\u2122analyse du management.");
            const data = await response.json();
            setManagementExpertReport(data);
        } catch (err) {
            setErrorMessage(err.message);
        } finally{
            setLoadingScores(false);
        }
    }, [
        selectedManagementTool
    ]);
    const ALLOWED_MANAGEMENT_KEYWORDS = [
        "vsm",
        "5s",
        "kaizen",
        "smed",
        "kanban",
        "visual"
    ];
    const filteredManagementFiles = graiModels.filter((model)=>{
        const name = (model.filename || "").toLowerCase();
        return ALLOWED_MANAGEMENT_KEYWORDS.some((keyword)=>name.includes(keyword));
    });
    const inferManagementTool = (filename)=>{
        const name = (filename || "").toLowerCase();
        if (name.includes("vsm")) return "vsm";
        if (name.includes("5s")) return "5s";
        if (name.includes("kaizen")) return "kaizen";
        if (name.includes("smed")) return "smed";
        if (name.includes("kanban")) return "kanban";
        if (name.includes("visual")) return "visual";
        return null;
    };
    const fetchAIManagementAnalysis = (0, _react.useCallback)(async ()=>{
        if (!activeEnterpriseId || !selectedManagementFileId) return;
        try {
            setLoadingScores(true);
            setManagementAIReport(null);
            const file = filteredManagementFiles.find((f)=>f._id === selectedManagementFileId);
            if (!file) {
                setManagementAIReport("\xe2\x9d\u0152 Management file not found.");
                return;
            }
            const toolKey = inferManagementTool(file.filename);
            if (!toolKey) {
                setManagementAIReport("\xe2\x9d\u0152 Unable to detect management type.");
                return;
            }
            const response = await fetch(`${API_URL}/api/ai/analyse-management/${activeEnterpriseId}/${toolKey}`);
            if (!response.ok) throw new Error("Erreur IA management");
            const data = await response.json();
            setManagementAIReport(data.analysis);
        } catch (err) {
            setErrorMessage(err.message);
        } finally{
            setLoadingScores(false);
        }
    }, [
        activeEnterpriseId,
        selectedManagementFileId,
        filteredManagementFiles
    ]);
    const renderManagements = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
            className: "analysis-section",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                    className: "section-title",
                    children: "Managements"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "section-subtitle",
                    children: "Analyse Lean Management either by expert rules or real uploaded documents."
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "model-buttons-grid",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            className: `model-btn ${managementAnalysisMode === "expert" ? "active" : ""}`,
                            onClick: ()=>setManagementAnalysisMode("expert"),
                            children: "Expert Structure Analysis"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            className: `model-btn ${managementAnalysisMode === "ai" ? "active" : ""}`,
                            onClick: ()=>setManagementAnalysisMode("ai"),
                            children: "AI PDF Analysis"
                        })
                    ]
                }),
                managementAnalysisMode === "expert" && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "section-subtitle",
                            style: {
                                marginTop: "20px"
                            },
                            children: "Choose a Lean management tool."
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "management-buttons-grid",
                            children: [
                                "VSM",
                                "5S",
                                "Kaizen",
                                "SMED",
                                "Kanban",
                                "Visual Management"
                            ].map((tool)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    className: `mgmt-btn ${selectedManagementTool === tool ? "active" : ""}`,
                                    onClick: ()=>setSelectedManagementTool(tool),
                                    children: tool
                                }, tool))
                        }),
                        selectedManagementTool && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "report-section",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "report-header",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "report-icon"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                            className: "report-title",
                                            children: [
                                                "Reports for ",
                                                selectedManagementTool
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "report-buttons",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        className: "report-btn",
                                        onClick: fetchManagementReport,
                                        children: "Generate analysis"
                                    })
                                }),
                                managementExpertReport && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "global-report-box",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                                    children: "Management Tool Analysis Summary"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                            children: "Keyword:"
                                                        }),
                                                        " ",
                                                        managementExpertReport.view_type
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                            children: "PDFs analyzed:"
                                                        }),
                                                        " ",
                                                        managementExpertReport.pdf_found_count
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "report-buttons",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                className: "report-btn",
                                                onClick: ()=>downloadAnalysisPDF(`Lean Management Expert Analysis - ${selectedManagementTool}`, JSON.stringify(managementExpertReport, null, 2)),
                                                children: "Download PDF"
                                            })
                                        }),
                                        Array.isArray(managementExpertReport.results) && managementExpertReport.results.map((pdf, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "detailed-report-box",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                                        children: pdf.filename
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                                children: "Nodes:"
                                                            }),
                                                            " ",
                                                            pdf.nodes
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                                children: "Arrows:"
                                                            }),
                                                            " ",
                                                            pdf.arrows
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                                children: "Total Shapes:"
                                                            }),
                                                            " ",
                                                            pdf.total_shapes
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                                children: "Score:"
                                                            }),
                                                            " ",
                                                            pdf.score,
                                                            " / 20"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                                children: "Interpretation:"
                                                            }),
                                                            " ",
                                                            pdf.interpretation
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                                        children: "Rules Evaluation"
                                                    }),
                                                    pdf.rules_evaluation.map((rule, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "detailed-item",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                                            children: "Rule:"
                                                                        }),
                                                                        " ",
                                                                        rule.rule
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                                            children: "Status:"
                                                                        }),
                                                                        " ",
                                                                        rule.passed ? "\xe2\u0153\u2026 Passed" : "\xe2\x9d\u0152 Failed"
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                                            children: "Detail:"
                                                                        }),
                                                                        " ",
                                                                        rule.detail
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {})
                                                            ]
                                                        }, idx))
                                                ]
                                            }, index))
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                managementAnalysisMode === "ai" && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "section-subtitle",
                            style: {
                                marginTop: "20px"
                            },
                            children: "Select a real uploaded Lean Management document (PDF)."
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("select", {
                            className: "model-select",
                            value: selectedManagementFileId || "",
                            onChange: (e)=>setSelectedManagementFileId(e.target.value),
                            disabled: filteredManagementFiles.length === 0,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                    value: "",
                                    children: filteredManagementFiles.length === 0 ? "-- No management document available --" : "-- Select a management to analyse --"
                                }),
                                filteredManagementFiles.map((file)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                        value: file._id,
                                        children: file.filename
                                    }, file._id))
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "report-buttons",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: "report-btn ai-btn",
                                disabled: !selectedManagementFileId,
                                onClick: fetchAIManagementAnalysis,
                                children: "Generate AI Management Analysis"
                            })
                        }),
                        managementAIReport && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "ai-report-box",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                    children: "AI Interpretation"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("pre", {
                                    className: "ai-clean-text",
                                    children: cleanAI(managementAIReport)
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "report-buttons",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        className: "report-btn",
                                        onClick: ()=>downloadAnalysisPDF("Lean Management AI Analysis", cleanAI(managementAIReport)),
                                        children: "Download PDF"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    // ==============================
    // âœ… RULES CRUD (API Calls)
    // ==============================
    const fetchRulesCatalog = (0, _react.useCallback)(async ()=>{
        try {
            setRulesLoading(true);
            setRulesError(null);
            const res = await fetch(`${API_URL}/api/rules`, {
                method: "GET",
                headers: {
                    Authorization: token ? `Bearer ${token}` : ""
                }
            });
            if (!res.ok) throw new Error("Impossible de charger la liste des r\xe8gles.");
            const data = await res.json();
            setRulesCatalog(data.rules || []);
        } catch (e) {
            setRulesError(e.message);
        } finally{
            setRulesLoading(false);
        }
    }, [
        token
    ]);
    const createRule = (0, _react.useCallback)(async ()=>{
        try {
            setCreateStatus(null);
            setRulesError(null);
            setRulesLoading(true);
            let conditionObj = {};
            try {
                conditionObj = newRule.condition ? JSON.parse(newRule.condition) : {};
            } catch  {
                throw new Error("Le champ condition doit \xe0\xaatre un JSON valide.");
            }
            if (!newRule.rule_type || !newRule.target || !newRule.code || !newRule.title) throw new Error("Merci de remplir: rule_type, target, code, title.");
            const payload = {
                rule_type: newRule.rule_type,
                target: newRule.target.trim().toLowerCase(),
                code: newRule.code.trim().toUpperCase(),
                title: newRule.title,
                description: newRule.description || null,
                condition: conditionObj,
                weight: Number(newRule.weight) || 1.0,
                enabled: Boolean(newRule.enabled),
                created_by: newRule.created_by || null
            };
            const res = await fetch(`${API_URL}/api/rules`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: token ? `Bearer ${token}` : ""
                },
                body: JSON.stringify(payload)
            });
            const data = await res.json().catch(()=>({}));
            if (!res.ok) throw new Error(data?.detail || data?.message || "Erreur cr\xe9ation r\xe8gle.");
            setCreateStatus("Rule created successfully.");
            await fetchRulesCatalog();
            setNewRule((prev)=>({
                    ...prev,
                    target: "",
                    code: "",
                    title: "",
                    description: "",
                    condition: "{}",
                    weight: 1.0,
                    enabled: true
                }));
        } catch (e) {
            setRulesError(e.message);
        } finally{
            setRulesLoading(false);
        }
    }, [
        token,
        newRule,
        fetchRulesCatalog
    ]);
    const loadRuleIntoEditor = (0, _react.useCallback)((rule)=>{
        if (!rule?._id) return;
        setSelectedRuleId(rule._id);
        setEditRule({
            title: rule.title || "",
            description: rule.description || "",
            condition: JSON.stringify(rule.condition || {}, null, 2),
            weight: rule.weight ?? 1.0,
            enabled: rule.enabled ?? true
        });
        setUpdateStatus(null);
        setDeleteStatus(null);
    }, []);
    const updateRule = (0, _react.useCallback)(async ()=>{
        if (!selectedRuleId) return;
        try {
            setRulesLoading(true);
            setRulesError(null);
            setUpdateStatus(null);
            let conditionObj = {};
            try {
                conditionObj = editRule.condition ? JSON.parse(editRule.condition) : {};
            } catch  {
                throw new Error("Condition (edit) doit \xe0\xaatre un JSON valide.");
            }
            const payload = {
                title: editRule.title,
                description: editRule.description,
                condition: conditionObj,
                weight: Number(editRule.weight) || 1.0,
                enabled: Boolean(editRule.enabled)
            };
            const res = await fetch(`${API_URL}/api/rules/${selectedRuleId}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: token ? `Bearer ${token}` : ""
                },
                body: JSON.stringify(payload)
            });
            const data = await res.json().catch(()=>({}));
            if (!res.ok) throw new Error(data?.detail || data?.message || "Erreur update r\xe8gle.");
            setUpdateStatus("\xe2\u0153\u2026 Rule updated.");
            await fetchRulesCatalog();
        } catch (e) {
            setRulesError(e.message);
        } finally{
            setRulesLoading(false);
        }
    }, [
        token,
        selectedRuleId,
        editRule,
        fetchRulesCatalog
    ]);
    const deleteRule = (0, _react.useCallback)(async ()=>{
        if (!selectedRuleId) return;
        try {
            setRulesLoading(true);
            setRulesError(null);
            setDeleteStatus(null);
            const res = await fetch(`${API_URL}/api/rules/${selectedRuleId}`, {
                method: "DELETE",
                headers: {
                    Authorization: token ? `Bearer ${token}` : ""
                }
            });
            const data = await res.json().catch(()=>({}));
            if (!res.ok) throw new Error(data?.detail || data?.message || "Erreur suppression r\xe8gle.");
            setDeleteStatus("\xe2\u0153\u2026 Rule deleted.");
            setSelectedRuleId("");
            await fetchRulesCatalog();
        } catch (e) {
            setRulesError(e.message);
        } finally{
            setRulesLoading(false);
        }
    }, [
        token,
        selectedRuleId,
        fetchRulesCatalog
    ]);
    // auto-load when opening Rules tab
    (0, _react.useEffect)(()=>{
        if (activeTab === "rules") fetchRulesCatalog();
    }, [
        activeTab,
        fetchRulesCatalog
    ]);
    // Styles (avoid ReferenceError)
    const inputStyle = {
        width: "100%",
        padding: "10px 12px",
        borderRadius: 8,
        border: "1px solid #ddd",
        outline: "none"
    };
    const textareaStyle = {
        width: "100%",
        padding: "10px 12px",
        borderRadius: 8,
        border: "1px solid #ddd",
        outline: "none",
        resize: "vertical"
    };
    const textareaStyleMono = {
        ...textareaStyle,
        fontFamily: "monospace",
        fontSize: 12
    };
    const renderRules = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
            className: "analysis-section",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                    className: "section-title",
                    children: "Rules"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "section-subtitle",
                    children: "Create and manage expert rules stored in MongoDB (backend: /api/rules)."
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "report-section",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "report-header",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "report-icon"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "report-title",
                                    children: "Create a new rule"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "report-buttons",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: "report-btn",
                                onClick: fetchRulesCatalog,
                                children: "Refresh rules list"
                            })
                        }),
                        rulesLoading && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "loading-message",
                            children: "Loading..."
                        }),
                        rulesError && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "case-error",
                            children: rulesError
                        }),
                        createStatus && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "success-message",
                            children: createStatus
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            style: {
                                marginTop: 16,
                                display: "grid",
                                gap: 10
                            },
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    style: {
                                        display: "grid",
                                        gap: 8
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            style: {
                                                fontWeight: 600
                                            },
                                            children: "Rule type"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("select", {
                                            className: "model-select",
                                            value: newRule.rule_type,
                                            onChange: (e)=>setNewRule((p)=>({
                                                        ...p,
                                                        rule_type: e.target.value
                                                    })),
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                                    value: "model",
                                                    children: "model"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                                    value: "management",
                                                    children: "management"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    style: {
                                        display: "grid",
                                        gap: 8
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            style: {
                                                fontWeight: 600
                                            },
                                            children: "Target *"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                            value: newRule.target,
                                            onChange: (e)=>setNewRule((p)=>({
                                                        ...p,
                                                        target: e.target.value
                                                    })),
                                            placeholder: "ex: functional, process, environmental, cost...",
                                            style: inputStyle
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    style: {
                                        display: "grid",
                                        gap: 8
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            style: {
                                                fontWeight: 600
                                            },
                                            children: "Code *"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                            value: newRule.code,
                                            onChange: (e)=>setNewRule((p)=>({
                                                        ...p,
                                                        code: e.target.value
                                                    })),
                                            placeholder: "ex: FV_R1, ESG_R3...",
                                            style: inputStyle
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    style: {
                                        display: "grid",
                                        gap: 8
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            style: {
                                                fontWeight: 600
                                            },
                                            children: "Title *"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                            value: newRule.title,
                                            onChange: (e)=>setNewRule((p)=>({
                                                        ...p,
                                                        title: e.target.value
                                                    })),
                                            placeholder: "Short readable title",
                                            style: inputStyle
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    style: {
                                        display: "grid",
                                        gap: 8
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            style: {
                                                fontWeight: 600
                                            },
                                            children: "Description"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            value: newRule.description,
                                            onChange: (e)=>setNewRule((p)=>({
                                                        ...p,
                                                        description: e.target.value
                                                    })),
                                            rows: 3,
                                            style: textareaStyle
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    style: {
                                        display: "grid",
                                        gap: 8
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            style: {
                                                fontWeight: 600
                                            },
                                            children: "Condition (JSON)"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            value: newRule.condition,
                                            onChange: (e)=>setNewRule((p)=>({
                                                        ...p,
                                                        condition: e.target.value
                                                    })),
                                            rows: 8,
                                            style: textareaStyleMono
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    style: {
                                        display: "grid",
                                        gridTemplateColumns: "1fr 1fr",
                                        gap: 10
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            style: {
                                                display: "grid",
                                                gap: 8
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                    style: {
                                                        fontWeight: 600
                                                    },
                                                    children: "Weight"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    type: "number",
                                                    step: "0.1",
                                                    value: newRule.weight,
                                                    onChange: (e)=>setNewRule((p)=>({
                                                                ...p,
                                                                weight: e.target.value
                                                            })),
                                                    style: inputStyle
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            style: {
                                                display: "grid",
                                                gap: 8
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                    style: {
                                                        fontWeight: 600
                                                    },
                                                    children: "Enabled"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("select", {
                                                    className: "model-select",
                                                    value: newRule.enabled ? "true" : "false",
                                                    onChange: (e)=>setNewRule((p)=>({
                                                                ...p,
                                                                enabled: e.target.value === "true"
                                                            })),
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                                            value: "true",
                                                            children: "true"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                                            value: "false",
                                                            children: "false"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    style: {
                                        display: "grid",
                                        gap: 8
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            style: {
                                                fontWeight: 600
                                            },
                                            children: "Created by"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                            value: newRule.created_by,
                                            onChange: (e)=>setNewRule((p)=>({
                                                        ...p,
                                                        created_by: e.target.value
                                                    })),
                                            placeholder: "ex: admin@icam / Emmanuel",
                                            style: inputStyle
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "report-buttons",
                                    style: {
                                        marginTop: 8
                                    },
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        className: "report-btn ai-btn",
                                        onClick: createRule,
                                        disabled: rulesLoading,
                                        children: "Create rule"
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "report-section",
                    style: {
                        marginTop: 20
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "report-header",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "report-icon"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "report-title",
                                    children: "Existing rules"
                                })
                            ]
                        }),
                        updateStatus && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "success-message",
                            children: updateStatus
                        }),
                        deleteStatus && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "success-message",
                            children: deleteStatus
                        }),
                        rulesCatalog.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            style: {
                                opacity: 0.8,
                                marginTop: 10
                            },
                            children: "No rules yet."
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    style: {
                                        marginTop: 12
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            style: {
                                                fontWeight: 600
                                            },
                                            children: "Select a rule to edit"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("select", {
                                            className: "model-select",
                                            value: selectedRuleId,
                                            onChange: (e)=>{
                                                const id = e.target.value;
                                                setSelectedRuleId(id);
                                                const r = rulesCatalog.find((x)=>x._id === id);
                                                if (r) loadRuleIntoEditor(r);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                                    value: "",
                                                    children: "-- Choose a rule --"
                                                }),
                                                rulesCatalog.map((r)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("option", {
                                                        value: r._id,
                                                        children: [
                                                            r.code,
                                                            " ",
                                                            r.title,
                                                            " (",
                                                            r.rule_type,
                                                            "/",
                                                            r.target,
                                                            ")"
                                                        ]
                                                    }, r._id))
                                            ]
                                        })
                                    ]
                                }),
                                selectedRuleId && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    style: {
                                        marginTop: 16,
                                        display: "grid",
                                        gap: 10
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            style: {
                                                display: "grid",
                                                gap: 8
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                    style: {
                                                        fontWeight: 600
                                                    },
                                                    children: "Title"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    value: editRule.title,
                                                    onChange: (e)=>setEditRule((p)=>({
                                                                ...p,
                                                                title: e.target.value
                                                            })),
                                                    style: inputStyle
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            style: {
                                                display: "grid",
                                                gap: 8
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                    style: {
                                                        fontWeight: 600
                                                    },
                                                    children: "Description"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                                    value: editRule.description,
                                                    onChange: (e)=>setEditRule((p)=>({
                                                                ...p,
                                                                description: e.target.value
                                                            })),
                                                    rows: 3,
                                                    style: textareaStyle
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            style: {
                                                display: "grid",
                                                gap: 8
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                    style: {
                                                        fontWeight: 600
                                                    },
                                                    children: "Condition (JSON)"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                                    value: editRule.condition,
                                                    onChange: (e)=>setEditRule((p)=>({
                                                                ...p,
                                                                condition: e.target.value
                                                            })),
                                                    rows: 8,
                                                    style: textareaStyleMono
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            style: {
                                                display: "grid",
                                                gridTemplateColumns: "1fr 1fr",
                                                gap: 10
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    style: {
                                                        display: "grid",
                                                        gap: 8
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                            style: {
                                                                fontWeight: 600
                                                            },
                                                            children: "Weight"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                            type: "number",
                                                            step: "0.1",
                                                            value: editRule.weight,
                                                            onChange: (e)=>setEditRule((p)=>({
                                                                        ...p,
                                                                        weight: e.target.value
                                                                    })),
                                                            style: inputStyle
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    style: {
                                                        display: "grid",
                                                        gap: 8
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                            style: {
                                                                fontWeight: 600
                                                            },
                                                            children: "Enabled"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("select", {
                                                            className: "model-select",
                                                            value: editRule.enabled ? "true" : "false",
                                                            onChange: (e)=>setEditRule((p)=>({
                                                                        ...p,
                                                                        enabled: e.target.value === "true"
                                                                    })),
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                                                    value: "true",
                                                                    children: "true"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                                                    value: "false",
                                                                    children: "false"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "report-buttons",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                    className: "report-btn ai-btn",
                                                    onClick: updateRule,
                                                    disabled: rulesLoading,
                                                    children: "Update rule"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                    className: "report-btn",
                                                    onClick: deleteRule,
                                                    disabled: rulesLoading,
                                                    children: "Delete rule"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                    className: "report-btn",
                                                    onClick: ()=>downloadAnalysisPDF(`Rule - ${selectedRuleId}`, JSON.stringify(rulesCatalog.find((x)=>x._id === selectedRuleId), null, 2)),
                                                    disabled: !selectedRuleId,
                                                    children: "Download PDF"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    // auto-load catalog when tab = rules
    (0, _react.useEffect)(()=>{
        if (activeTab === "rules") fetchRulesCatalog();
    }, [
        activeTab,
        fetchRulesCatalog
    ]);
    // ==============================
    // 8ï¸âƒ£ RENDU FINAL
    // ==============================
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "analysis-container",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("main", {
                    className: "analysis-main",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("section", {
                            className: "case-header",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "case-card improved-case-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                        className: "case-title improved-case-title",
                                        children: activeCase?.company_name || "Active case"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "case-subtitle improved-case-subtitle",
                                        children: activeCase ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                    className: "case-info-item",
                                                    children: [
                                                        "Sector :",
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("strong", {
                                                            children: [
                                                                " ",
                                                                activeCase.activity_sector || "N/A"
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "case-divider"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                    className: "case-info-item",
                                                    children: [
                                                        "Company size :",
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("strong", {
                                                            children: [
                                                                " ",
                                                                activeCase.company_size || "N/A"
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }) : "No case selected"
                                    }),
                                    activeCase && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                        className: "case-created improved-case-created",
                                        children: [
                                            "Created on :",
                                            " ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                children: activeCase.date_created || activeCase.timestamp || "Unknown date"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                        className: "case-id-display improved-case-id",
                                        children: [
                                            "Case ID : ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                children: activeCaseId || ""
                                            })
                                        ]
                                    }),
                                    errorMessage && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "case-error improved-case-error",
                                        children: errorMessage
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "tabs-section",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    className: `tab-button ${activeTab === "acquisition" ? "active" : ""}`,
                                    onClick: ()=>setActiveTab("acquisition"),
                                    children: "Acquisition"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    className: `tab-button ${activeTab === "modeles" ? "active" : ""}`,
                                    onClick: ()=>setActiveTab("modeles"),
                                    children: "Models"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    className: `tab-button ${activeTab === "managements" ? "active" : ""}`,
                                    onClick: ()=>setActiveTab("managements"),
                                    children: "Managements"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    className: `tab-button ${activeTab === "rules" ? "active" : ""}`,
                                    onClick: ()=>setActiveTab("rules"),
                                    children: "Rules"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "analysis-section",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                    className: "section-title",
                                    children: "Global Case AI Analysis"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    className: "report-btn ai-btn",
                                    onClick: fetchAICaseAnalysis,
                                    children: "Analyse full case with AI"
                                }),
                                aiCaseAnalysis && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "ai-report-box",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("pre", {
                                            className: "ai-clean-text",
                                            children: cleanAI(aiCaseAnalysis)
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "report-buttons",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                className: "report-btn",
                                                onClick: ()=>downloadAnalysisPDF("Global Case AI Analysis", cleanAI(aiCaseAnalysis)),
                                                children: "Download PDF"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        activeTab === "acquisition" && renderAcquisition(),
                        activeTab === "modeles" && renderModeles(),
                        activeTab === "managements" && renderManagements(),
                        activeTab === "rules" && renderRules()
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "icam-navigation",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                        to: "/pdf-uploader",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            className: "icam-nav-btn",
                            children: "Back to saving"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                        to: "/conception",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            className: "icam-nav-btn",
                            children: "Move to conception"
                        })
                    })
                ]
            })
        ]
    });
}
exports.default = Analysis;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"b9X5n","../Frame222":"8cNiy","jspdf":"hkJ4Q","./AnalysisBeta.css":"3o909","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3o909":[function() {},{}],"2wBag":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _visualManagement1Css = require("./VisualManagement1.css");
var _jspdf = require("jspdf");
var _jspdfDefault = parcelHelpers.interopDefault(_jspdf);
var _html2Canvas = require("html2canvas");
var _html2CanvasDefault = parcelHelpers.interopDefault(_html2Canvas);
function VisualManagement1() {
    const history = (0, _reactRouterDom.useHistory)();
    const [hasImplemented, setHasImplemented] = (0, _react.useState)(null);
    const [showQuestionnaire, setShowQuestionnaire] = (0, _react.useState)(false);
    const [showFileUpload, setShowFileUpload] = (0, _react.useState)(false);
    const [currentStep, setCurrentStep] = (0, _react.useState)(1);
    const [selectedFile, setSelectedFile] = (0, _react.useState)(null);
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [isGeneratingPDF, setIsGeneratingPDF] = (0, _react.useState)(false);
    const [formData, setFormData] = (0, _react.useState)({
        // Part 1: Current state - What is in place today
        // Objectives and intentions
        visualManagementObjectives: "",
        implementationTime: "",
        visualSupports: "",
        coveredAreas: "",
        designStandard: "",
        // Content of visuals
        displayedInformation: "",
        indicatorsUpdate: "",
        visualsComprehension: "",
        flowManagementVisuals: "",
        visualsMaintenance: "",
        // Part 2: Desired state - Target vision of visual management
        // Ambitions and vision
        expectedContributions: "",
        interactiveData: "",
        additionalInformation: "",
        operatorsAutonomy: "",
        additionalVisuals: "",
        // Part 3: Monitoring, ownership and continuous improvement
        // Management & reactivity
        indicatorsResponsible: "",
        fieldRituals: "",
        anomaliesDetection: "",
        escalationSystem: "",
        visualsReview: "",
        // Lean involvement and culture
        teamsParticipation: "",
        visualManagementTraining: "",
        visualsAdaptation: "",
        teamImpact: "",
        roadmap: ""
    });
    const questionnaireRef = (0, _react.useRef)(null);
    const handleFileChange = (event)=>{
        setSelectedFile(event.target.files[0]);
    };
    const handleSubmit = async (event)=>{
        event.preventDefault();
        if (!selectedFile) {
            setErrorMessage("Please select a file");
            return;
        }
        setIsLoading(true);
        setErrorMessage("");
        try {
            console.log("Selected file:", selectedFile);
            setTimeout(()=>{
                history.push("/visual-management-2");
                setIsLoading(false);
            }, 1500);
        } catch (error) {
            console.error("Error while uploading the file:", error);
            setErrorMessage("An error occurred while uploading. Please try again.");
            setIsLoading(false);
        }
    };
    const handleInputChange = (e)=>{
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };
    const handleQuestionsSubmit = async (e)=>{
        e.preventDefault();
        setIsLoading(true);
        setErrorMessage("");
        try {
            console.log("Questionnaire data:", formData);
            setTimeout(()=>{
                history.push("/visual-management-2");
                setIsLoading(false);
            }, 1500);
        } catch (error) {
            console.error("Error sending questionnaire data:", error);
            setErrorMessage("An error occurred while sending the form. Please try again.");
            setIsLoading(false);
        }
    };
    const handleNextStep = ()=>{
        if (currentStep < 3) {
            setCurrentStep(currentStep + 1);
            if (questionnaireRef.current) questionnaireRef.current.scrollTop = 0;
        }
    };
    const handlePrevStep = ()=>{
        if (currentStep > 1) {
            setCurrentStep(currentStep - 1);
            if (questionnaireRef.current) questionnaireRef.current.scrollTop = 0;
        }
    };
    const renderProgressIndicator = ()=>{
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "progress-indicator",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: `progress-step ${currentStep >= 1 ? 'active' : ''} ${currentStep > 1 ? 'completed' : ''}`,
                    children: "1"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "progress-bar-line"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: `progress-step ${currentStep >= 2 ? 'active' : ''} ${currentStep > 2 ? 'completed' : ''}`,
                    children: "2"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "progress-bar-line"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: `progress-step ${currentStep >= 3 ? 'active' : ''}`,
                    children: "3"
                })
            ]
        });
    };
    const renderQuestionnaire = ()=>{
        switch(currentStep){
            case 1:
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questionnaire-step",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                            className: "step-title",
                            children: "Part 1 : Current state - What is in place today"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "question-group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                    className: "question-group-title",
                                    children: "Objectives and intentions"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "form-group",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "visualManagementObjectives",
                                            children: "What are the objectives sought through the use of visual management (performance monitoring, safety, flow, communication\xe2\u20AC\xa6)?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "visualManagementObjectives",
                                            name: "visualManagementObjectives",
                                            value: formData.visualManagementObjectives,
                                            onChange: handleInputChange,
                                            required: true,
                                            className: "form-textarea",
                                            placeholder: "Describe the objectives sought..."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "form-group",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "implementationTime",
                                            children: "Since when has visual management been in place in your organization?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "implementationTime",
                                            name: "implementationTime",
                                            value: formData.implementationTime,
                                            onChange: handleInputChange,
                                            required: true,
                                            className: "form-textarea",
                                            placeholder: "Specify the implementation period..."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "form-group",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "visualSupports",
                                            children: "What types of visual supports are currently used (boards, screens, floor markings, QR codes, LED, etc.)?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "visualSupports",
                                            name: "visualSupports",
                                            value: formData.visualSupports,
                                            onChange: handleInputChange,
                                            required: true,
                                            className: "form-textarea",
                                            placeholder: "List the visual supports used..."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "form-group",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "coveredAreas",
                                            children: "Which processes or areas are covered by visual management (production, logistics, quality, offices, etc.)?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "coveredAreas",
                                            name: "coveredAreas",
                                            value: formData.coveredAreas,
                                            onChange: handleInputChange,
                                            required: true,
                                            className: "form-textarea",
                                            placeholder: "Describe the areas covered..."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "form-group",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "designStandard",
                                            children: "Do you have a design standard or a visual charter common to the company?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "designStandard",
                                            name: "designStandard",
                                            value: formData.designStandard,
                                            onChange: handleInputChange,
                                            required: true,
                                            className: "form-textarea",
                                            placeholder: "Describe your design standards..."
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "question-group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                    className: "question-group-title",
                                    children: "Content of visuals"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "form-group",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "displayedInformation",
                                            children: "What types of information are displayed (indicators, planning, safety, incidents, quality, production)?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "displayedInformation",
                                            name: "displayedInformation",
                                            value: formData.displayedInformation,
                                            onChange: handleInputChange,
                                            required: true,
                                            className: "form-textarea",
                                            placeholder: "List the types of displayed information..."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "form-group",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "indicatorsUpdate",
                                            children: "Are the indicators updated in real time, manually or automatically?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "indicatorsUpdate",
                                            name: "indicatorsUpdate",
                                            value: formData.indicatorsUpdate,
                                            onChange: handleInputChange,
                                            required: true,
                                            className: "form-textarea",
                                            placeholder: "Describe the update process..."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "form-group",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "visualsComprehension",
                                            children: "Are visual supports understandable by all staff without explanation?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "visualsComprehension",
                                            name: "visualsComprehension",
                                            value: formData.visualsComprehension,
                                            onChange: handleInputChange,
                                            required: true,
                                            className: "form-textarea",
                                            placeholder: "Evaluate the understanding of visuals..."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "form-group",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "flowManagementVisuals",
                                            children: "Do you have visuals for physical flow management (pull flow, Kanban zones, WIP, etc.)?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "flowManagementVisuals",
                                            name: "flowManagementVisuals",
                                            value: formData.flowManagementVisuals,
                                            onChange: handleInputChange,
                                            required: true,
                                            className: "form-textarea",
                                            placeholder: "Describe your flow management visuals..."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "form-group",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "visualsMaintenance",
                                            children: "Are the visual supports regularly maintained, organized, cleaned, and relevant?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "visualsMaintenance",
                                            name: "visualsMaintenance",
                                            value: formData.visualsMaintenance,
                                            onChange: handleInputChange,
                                            required: true,
                                            className: "form-textarea",
                                            placeholder: "Describe the maintenance of your visual supports..."
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                });
            case 2:
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questionnaire-step",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                            className: "step-title",
                            children: "Part 2 : Desired state - Target vision of visual management"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "question-group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                    className: "question-group-title",
                                    children: "Ambitions and vision"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "form-group",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "expectedContributions",
                                            children: "What would be, according to you, the expected contributions of a fully deployed visual management system?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "expectedContributions",
                                            name: "expectedContributions",
                                            value: formData.expectedContributions,
                                            onChange: handleInputChange,
                                            required: true,
                                            className: "form-textarea",
                                            placeholder: "Describe the expected contributions..."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "form-group",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "interactiveData",
                                            children: "Would you like to make your data more interactive (dynamic screens, connected displays, digital andon\xe2\u20AC\xa6)?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "interactiveData",
                                            name: "interactiveData",
                                            value: formData.interactiveData,
                                            onChange: handleInputChange,
                                            required: true,
                                            className: "form-textarea",
                                            placeholder: "Describe your interactivity wishes..."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "form-group",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "additionalInformation",
                                            children: "What types of additional information would you like to see displayed visually?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "additionalInformation",
                                            name: "additionalInformation",
                                            value: formData.additionalInformation,
                                            onChange: handleInputChange,
                                            required: true,
                                            className: "form-textarea",
                                            placeholder: "List desired additional information..."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "form-group",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "operatorsAutonomy",
                                            children: "Are you aiming for increased autonomy for operators or technicians through the use of visuals?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "operatorsAutonomy",
                                            name: "operatorsAutonomy",
                                            value: formData.operatorsAutonomy,
                                            onChange: handleInputChange,
                                            required: true,
                                            className: "form-textarea",
                                            placeholder: "Describe your autonomy objectives..."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "form-group",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "additionalVisuals",
                                            children: "Do you want to integrate more visuals related to safety, quality, or field performance?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "additionalVisuals",
                                            name: "additionalVisuals",
                                            value: formData.additionalVisuals,
                                            onChange: handleInputChange,
                                            required: true,
                                            className: "form-textarea",
                                            placeholder: "Specify desired additional visuals..."
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                });
            case 3:
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questionnaire-step",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                            className: "step-title",
                            children: "Part 3 : Monitoring, ownership and continuous improvement"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "question-group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                    className: "question-group-title",
                                    children: "Management & reactivity"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "form-group",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "indicatorsResponsible",
                                            children: "Who is responsible for updating and monitoring the visual indicators?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "indicatorsResponsible",
                                            name: "indicatorsResponsible",
                                            value: formData.indicatorsResponsible,
                                            onChange: handleInputChange,
                                            required: true,
                                            className: "form-textarea",
                                            placeholder: "Identify the responsible people..."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "form-group",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "fieldRituals",
                                            children: "Do you use visual supports to conduct field rituals (TOP 5, Gemba, safety briefing\xe2\u20AC\xa6)?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "fieldRituals",
                                            name: "fieldRituals",
                                            value: formData.fieldRituals,
                                            onChange: handleInputChange,
                                            required: true,
                                            className: "form-textarea",
                                            placeholder: "Describe your field rituals..."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "form-group",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "anomaliesDetection",
                                            children: "Are deviations or anomalies visible and easily detectable through visual management?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "anomaliesDetection",
                                            name: "anomaliesDetection",
                                            value: formData.anomaliesDetection,
                                            onChange: handleInputChange,
                                            required: true,
                                            className: "form-textarea",
                                            placeholder: "Evaluate anomaly visibility..."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "form-group",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "escalationSystem",
                                            children: "Do you have an escalation or rapid resolution system based on visuals (traffic lights, andon, QRQC\xe2\u20AC\xa6)?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "escalationSystem",
                                            name: "escalationSystem",
                                            value: formData.escalationSystem,
                                            onChange: handleInputChange,
                                            required: true,
                                            className: "form-textarea",
                                            placeholder: "Describe your escalation system..."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "form-group",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "visualsReview",
                                            children: "How often are the visuals reviewed, adjusted, or removed if they are no longer relevant?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "visualsReview",
                                            name: "visualsReview",
                                            value: formData.visualsReview,
                                            onChange: handleInputChange,
                                            required: true,
                                            className: "form-textarea",
                                            placeholder: "Specify the review frequency..."
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "question-group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                    className: "question-group-title",
                                    children: "Lean involvement and culture"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "form-group",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "teamsParticipation",
                                            children: "Do field teams participate in the creation or improvement of visual supports?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "teamsParticipation",
                                            name: "teamsParticipation",
                                            value: formData.teamsParticipation,
                                            onChange: handleInputChange,
                                            required: true,
                                            className: "form-textarea",
                                            placeholder: "Describe team participation..."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "form-group",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "visualManagementTraining",
                                            children: "Has any training or awareness on visual management been implemented?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "visualManagementTraining",
                                            name: "visualManagementTraining",
                                            value: formData.visualManagementTraining,
                                            onChange: handleInputChange,
                                            required: true,
                                            className: "form-textarea",
                                            placeholder: "Describe your visual management training..."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "form-group",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "visualsAdaptation",
                                            children: "Is visual management adapted to different profiles (languages, literacy, roles)?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "visualsAdaptation",
                                            name: "visualsAdaptation",
                                            value: formData.visualsAdaptation,
                                            onChange: handleInputChange,
                                            required: true,
                                            className: "form-textarea",
                                            placeholder: "Evaluate adaptation to profiles..."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "form-group",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "teamImpact",
                                            children: "Do you observe a real impact of visuals on team engagement or responsiveness?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "teamImpact",
                                            name: "teamImpact",
                                            value: formData.teamImpact,
                                            onChange: handleInputChange,
                                            required: true,
                                            className: "form-textarea",
                                            placeholder: "Describe the observed impact..."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "form-group",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "roadmap",
                                            children: "What is your roadmap to develop or strengthen the visual culture in the next 6 to 12 months?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "roadmap",
                                            name: "roadmap",
                                            value: formData.roadmap,
                                            onChange: handleInputChange,
                                            required: true,
                                            className: "form-textarea",
                                            placeholder: "Describe your roadmap..."
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                });
            default:
                return null;
        }
    };
    const handleDownloadPDF = async ()=>{
        try {
            setIsGeneratingPDF(true);
            const element = document.querySelector(".visual-management-page");
            if (!element) {
                alert("Element not found!");
                return;
            }
            document.querySelectorAll("*").forEach((el)=>{
                const style = window.getComputedStyle(el);
                if (style.backgroundImage && style.backgroundImage.includes("gradient")) el.style.backgroundImage = "none";
                if (style.backgroundColor === "transparent" || style.backgroundColor === "rgba(0, 0, 0, 0)" || style.backgroundColor.includes("var(")) el.style.backgroundColor = "#ffffff";
            });
            const canvas = await (0, _html2CanvasDefault.default)(element, {
                scale: 2,
                useCORS: true,
                allowTaint: true,
                backgroundColor: "#ffffff",
                logging: false,
                scrollX: 0,
                scrollY: -window.scrollY,
                windowWidth: document.documentElement.scrollWidth,
                windowHeight: document.documentElement.scrollHeight,
                onclone: (clonedDoc)=>{
                    clonedDoc.querySelectorAll("*").forEach((el)=>{
                        const position = window.getComputedStyle(el).position;
                        if (position === "sticky" || position === "fixed") el.style.position = "static";
                    });
                }
            });
            const imgData = canvas.toDataURL("image/png");
            const pdf = new (0, _jspdfDefault.default)("p", "mm", "a4");
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = pdf.internal.pageSize.getHeight();
            const imgHeight = canvas.height * pdfWidth / canvas.width;
            let heightLeft = imgHeight;
            let position = 0;
            pdf.addImage(imgData, "PNG", 0, position, pdfWidth, imgHeight);
            heightLeft -= pdfHeight;
            while(heightLeft > 0){
                position = heightLeft - imgHeight;
                pdf.addPage();
                pdf.addImage(imgData, "PNG", 0, position, pdfWidth, imgHeight);
                heightLeft -= pdfHeight;
            }
            const date = new Date().toISOString().slice(0, 10);
            pdf.save(`VisualManagement_${date}.pdf`);
            alert("\xe2\u0153\u2026 PDF generated successfully!");
        } catch (err) {
            console.error("PDF Error:", err);
            alert("\xe2\x9d\u0152 PDF Error: " + (err.message || "unknown"));
        } finally{
            setIsGeneratingPDF(false);
        }
    };
    const saveLeanAnswers = async (moduleName)=>{
        try {
            const caseId = localStorage.getItem("caseId");
            if (!caseId) {
                alert("No active case found!");
                console.warn("LocalStorage is empty. Current content:", localStorage);
                return;
            }
            console.log(`Saving ${moduleName} answers for case ${caseId}`);
            const API_URL = "/api";
            const response = await fetch(`${API_URL}/api/lean/${moduleName}/save`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    case_id: caseId,
                    answers: formData
                })
            });
            const result = await response.json();
            if (!response.ok) throw new Error(result.detail || `Saving error (${response.status}) : ${result.message}`);
            alert(`\xe2\u{153}\u{2026} ${moduleName.toUpperCase()} answers saved successfully!`);
            handleNextStep();
        } catch (error) {
            console.error("\xe2\x9d\u0152 saveLeanAnswers Error:", error);
            alert("\xe2\x9d\u0152 " + error.message);
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "visual-management-page screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "header",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                        to: "/home",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "logo-icam",
                            src: "/img/1200px-logo-icam---2008-1@2x.png",
                            alt: "Logo ICAM"
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "content-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                            className: "page-title",
                            children: "Visual Management - Effective Communication"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "question-section",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Has your company already implemented Visual Management?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "buttons-container",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            className: `choice-button ${hasImplemented === true ? 'active' : ''}`,
                                            onClick: ()=>{
                                                setHasImplemented(true);
                                                setShowFileUpload(true);
                                                setShowQuestionnaire(true);
                                                setErrorMessage("");
                                            },
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            className: `choice-button ${hasImplemented === false ? 'active' : ''}`,
                                            onClick: ()=>{
                                                setHasImplemented(false);
                                                setShowFileUpload(false);
                                                setShowQuestionnaire(false);
                                                setErrorMessage("");
                                            },
                                            children: "No"
                                        })
                                    ]
                                }),
                                errorMessage && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "error-message",
                                    children: errorMessage
                                }),
                                showFileUpload && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "file-upload-section",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "upload-text",
                                            children: "Please upload your existing Visual Management documentation:"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                                            onSubmit: handleSubmit,
                                            className: "upload-form",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    type: "file",
                                                    onChange: handleFileChange,
                                                    accept: ".pdf,.doc,.docx,.png,.jpg,.jpeg",
                                                    className: "file-input"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                    type: "submit",
                                                    className: "submit-button",
                                                    disabled: isLoading,
                                                    children: isLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "spinner"
                                                            }),
                                                            "Uploading..."
                                                        ]
                                                    }) : "Upload"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                showQuestionnaire && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "questions-section",
                                    ref: questionnaireRef,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                            className: "questions-title",
                                            children: "Assessment of your current situation"
                                        }),
                                        renderProgressIndicator(),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                                            onSubmit: handleQuestionsSubmit,
                                            className: "questions-form",
                                            children: [
                                                renderQuestionnaire(),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "form-actions",
                                                    children: [
                                                        currentStep > 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                            type: "button",
                                                            className: "nav-button prev-button",
                                                            onClick: handlePrevStep,
                                                            children: "Previous"
                                                        }),
                                                        currentStep < 3 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                            type: "button",
                                                            className: "nav-button next-button",
                                                            onClick: ()=>saveLeanAnswers("visual-management"),
                                                            children: "Next"
                                                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                            type: "submit",
                                                            className: "submit-button",
                                                            disabled: isLoading,
                                                            children: isLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                        className: "spinner"
                                                                    }),
                                                                    "Sending..."
                                                                ]
                                                            }) : "Finish"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                hasImplemented === false && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "redirect-section",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "redirect-text",
                                            children: "We recommend that you start by understanding the principles of Visual Management:"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                            to: "/pdf-uploader",
                                            className: "redirect-button",
                                            children: "Go to saving"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    className: "download-button",
                    onClick: handleDownloadPDF,
                    disabled: isGeneratingPDF,
                    children: isGeneratingPDF ? "Generating PDF..." : "Download PDF"
                })
            ]
        })
    });
}
exports.default = VisualManagement1;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["Link","b9X5n"],["useHistory","ditZI"]],"./VisualManagement1.css":"73f3D","jspdf":"hkJ4Q","html2canvas":"3eyQ5","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"73f3D":[function() {},{}],"4hPSM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems22 = require("../NavItems22");
var _navItems22Default = parcelHelpers.interopDefault(_navItems22);
var _frame52 = require("../Frame52");
var _frame52Default = parcelHelpers.interopDefault(_frame52);
var _pricing3 = require("../Pricing3");
var _pricing3Default = parcelHelpers.interopDefault(_pricing3);
var _objectivesCss = require("./Objectives.css");
function Objectives(props) {
    const { x1200PxLogo_Icam__20081, place1, notesAtteindre, place2, inputType1, inputPlaceholder1, line211, leadTime, inputType2, inputPlaceholder2, line212, environment, inputType3, inputPlaceholder3, line213, xcontinue, navItems3Props, navItems22Props, pricing31Props, pricing32Props, pricing33Props, pricing34Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
            className: "objectives screen",
            name: "form7",
            action: "form7",
            method: "post",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-col-34",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "overlap-group-16",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                    to: "/home",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        className: "x1200px-logo_icam_-_2008-1-16",
                                        src: x1200PxLogo_Icam__20081,
                                        alt: "1200px-Logo_ICAM_-_2008 1"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-container-5",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                                            className: navItems3Props.className,
                                            frame1172Props: navItems3Props.frame1172Props,
                                            frame1162Props: navItems3Props.frame1162Props,
                                            frame1132Props: navItems3Props.frame1132Props
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems22Default.default), {
                                            frame11332Props: navItems22Props.frame11332Props
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-row-50",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame52Default.default), {}),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                    to: "/cur-performance",
                                    className: "align-self-flex-center",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "frame-6-8",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "place-77 valign-text-middle inter-bold-tropical-rain-forest-18px",
                                            children: place1
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "notes-atteindre valign-text-middle bevan-normal-white-20px",
                                    children: notesAtteindre
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "pricing-container",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "pricing-1",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                            className: "place-78 inter-bold-mineral-green-24px",
                                            children: place2
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            className: "x25-1 inter-bold-mineral-green-56px",
                                            name: "25",
                                            placeholder: inputPlaceholder1,
                                            type: inputType1
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "line-21-1",
                                            src: line211,
                                            alt: "Line 21"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pricing3Default.default), {
                                    cost: pricing31Props.cost
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "pricing-2",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "lead-time inter-bold-mineral-green-24px",
                                            children: leadTime
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            className: "x25-2 inter-bold-mineral-green-56px",
                                            name: "25",
                                            placeholder: inputPlaceholder2,
                                            type: inputType2
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "line-21",
                                            src: line212,
                                            alt: "Line 21"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pricing3Default.default), {
                                    cost: pricing32Props.cost,
                                    className: pricing32Props.className
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-51",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pricing3Default.default), {
                            cost: pricing33Props.cost,
                            className: pricing33Props.className
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-col-35",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "pricing-6",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "environment inter-bold-mineral-green-24px",
                                            children: environment
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            className: "x25-3 inter-bold-mineral-green-56px",
                                            name: "25",
                                            placeholder: inputPlaceholder3,
                                            type: inputType3
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "line-21",
                                            src: line213,
                                            alt: "Line 21"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                    href: "javascript:SubmitForm('form7')",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "frame-2-13",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "continue-8 valign-text-middle inter-bold-mineral-green-18px",
                                            children: xcontinue
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pricing3Default.default), {
                            cost: pricing34Props.cost,
                            className: pricing34Props.className
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Objectives;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"b9X5n","../NavItems3":"fOarC","../NavItems22":"ibMuV","../Frame52":"2x1PC","../Pricing3":"4ShqD","./Objectives.css":"akK6b","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ibMuV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame11332 = require("../Frame11332");
var _frame11332Default = parcelHelpers.interopDefault(_frame11332);
var _frame114 = require("../Frame114");
var _frame114Default = parcelHelpers.interopDefault(_frame114);
var _frame115 = require("../Frame115");
var _frame115Default = parcelHelpers.interopDefault(_frame115);
var _frame117 = require("../Frame117");
var _frame117Default = parcelHelpers.interopDefault(_frame117);
var _navItems22Css = require("./NavItems22.css");
function NavItems22(props) {
    const { className, frame11332Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `nav-items-2-20 ${className || ""}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11332Default.default), {
                className: frame11332Props.className
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame114Default.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame115Default.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "frame-116-175",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "result-objectives-84 valign-text-middle inter-medium-white-18px",
                    children: "Result & Objectives"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame117Default.default), {})
        ]
    });
}
exports.default = NavItems22;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","../Frame11332":"2UwVc","../Frame114":"aUtEd","../Frame115":"gPV9Y","../Frame117":"ijwBg","./NavItems22.css":"lNGhg","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2UwVc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame11332Css = require("./Frame11332.css");
function Frame11332(props) {
    const { className } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `frame-113 ${className || ""}`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "aquisition valign-text-middle inter-medium-star-dust-18px",
            children: "Acquisition"
        })
    });
}
exports.default = Frame11332;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./Frame11332.css":"NRlUM","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"NRlUM":[function() {},{}],"lNGhg":[function() {},{}],"2x1PC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame52Css = require("./Frame52.css");
function Frame52() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "frame-5-11",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "place-79 valign-text-middle inter-bold-tropical-rain-forest-18px",
            children: "Back"
        })
    });
}
exports.default = Frame52;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./Frame52.css":"6qRgD","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6qRgD":[function() {},{}],"4ShqD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _pricing3Css = require("./Pricing3.css");
function Pricing3(props) {
    const { cost, className } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `pricing-3 ${className || ""}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "cost inter-bold-rum-swizzle-24px",
                children: cost
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                className: "x25-4 inter-bold-rum-swizzle-56px",
                htmlFor: "25",
                children: "/25"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                className: "line-21-2",
                src: "/img/line-21-1@2x.png",
                alt: "Line 21"
            })
        ]
    });
}
exports.default = Pricing3;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./Pricing3.css":"3ByTj","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3ByTj":[function() {},{}],"akK6b":[function() {},{}],"66Jb8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _frame11432 = require("../Frame11432");
var _frame11432Default = parcelHelpers.interopDefault(_frame11432);
var _frame1152 = require("../Frame1152");
var _frame1152Default = parcelHelpers.interopDefault(_frame1152);
var _headerMenuDefault2 = require("../HeaderMenuDefault2");
var _headerMenuDefault2Default = parcelHelpers.interopDefault(_headerMenuDefault2);
var _frame11322 = require("../Frame11322");
var _frame11322Default = parcelHelpers.interopDefault(_frame11322);
var _frame1144 = require("../Frame1144");
var _frame1144Default = parcelHelpers.interopDefault(_frame1144);
var _frame232 = require("../Frame232");
var _frame232Default = parcelHelpers.interopDefault(_frame232);
var _frame101 = require("../Frame101");
var _frame101Default = parcelHelpers.interopDefault(_frame101);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _frame102 = require("../Frame102");
var _frame102Default = parcelHelpers.interopDefault(_frame102);
var _frame11732 = require("../Frame11732");
var _frame11732Default = parcelHelpers.interopDefault(_frame11732);
var _smed2Css = require("./SMED2.css");
function SMED2(props) {
    const { x1200PxLogo_Icam__20081, label1, aquisition, analysis, label2, pleaseAnswerTheFollowingQuestions, frame11432Props, frame1152Props, headerMenuDefault2Props, frame11322Props, frame1144Props, frame232Props, frame101Props, toggleProps, frame102Props, frame11732Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "smed-2-1 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-col-46",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "overlap-group-20",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                    to: "/home",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        className: "x1200px-logo_icam_-_2008-1-20",
                                        src: x1200PxLogo_Icam__20081,
                                        alt: "1200px-Logo_ICAM_-_2008 1"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-container-6",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "nav-items-3-66",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11432Default.default), {
                                                    className: frame11432Props.className
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1152Default.default), {
                                                    className: frame1152Props.className
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                                    to: "/existing-case",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "frame-2-17",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefault2Default.default), {
                                                            children: headerMenuDefault2Props.children
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                                    to: "/cur-performance",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "label-128 inter-medium-sonic-silver-18-1px",
                                                        children: label1
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11322Default.default), {
                                                    className: frame11322Props.className
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "nav-items-2-34",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "frame-113-48",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "aquisition-90 valign-text-middle inter-medium-rum-swizzle-18px",
                                                        children: aquisition
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1144Default.default), {
                                                    className: frame1144Props.className
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "frame-115-116",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "analysis-90 valign-text-middle inter-medium-sonic-silver-18px",
                                                        children: analysis
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame232Default.default), {
                                                    headerMenuDefault2Props: frame232Props.headerMenuDefault2Props
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                                    to: "/functionnal-view-1",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "label-128 inter-medium-sonic-silver-18-1px",
                                                        children: label2
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "please-answer-the-following-questions-1 valign-text-middle bevan-normal-white-20px",
                            children: pleaseAnswerTheFollowingQuestions
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-67",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-col-47",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame101Default.default), {
                                    toggleProps: frame101Props.toggleProps,
                                    group1021Props: frame101Props.group1021Props,
                                    group1022Props: frame101Props.group1022Props,
                                    group1023Props: frame101Props.group1023Props,
                                    group1024Props: frame101Props.group1024Props,
                                    group1025Props: frame101Props.group1025Props
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggleProps.className,
                                    buttonSecondaryProps: toggleProps.buttonSecondaryProps
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "frame-container-9",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame102Default.default), {
                                    toggleProps: frame102Props.toggleProps,
                                    group1021Props: frame102Props.group1021Props,
                                    group1022Props: frame102Props.group1022Props,
                                    group1023Props: frame102Props.group1023Props,
                                    group1024Props: frame102Props.group1024Props,
                                    group1025Props: frame102Props.group1025Props
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11732Default.default), {
                                    className: frame11732Props.className
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = SMED2;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"b9X5n","../Frame11432":"h1Iow","../Frame1152":"fymBe","../HeaderMenuDefault2":"ixaJ9","../Frame11322":"ju7Cp","../Frame1144":"kz89G","../Frame232":"4B3A5","../Frame101":"dLcbc","../Toggle":"dSqDu","../Frame102":"fva7h","../Frame11732":"gSRJf","./SMED2.css":"4v5AJ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"h1Iow":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame11432Css = require("./Frame11432.css");
var _reactRouterDom = require("react-router-dom");
function Frame11432(props) {
    const { className } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
        to: "/home",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: `frame-114-86 ${className || ""}`,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "place-1 valign-text-middle inter-medium-sonic-silver-18px",
                children: "Home"
            })
        })
    });
}
exports.default = Frame11432;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./Frame11432.css":"cxVbY","react-router-dom":"b9X5n","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cxVbY":[function() {},{}],"ixaJ9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _headerMenuDefault2Css = require("./HeaderMenuDefault2.css");
function HeaderMenuDefault2(props) {
    const { children, className } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `menu-item-default-20 ${className || ""}`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "label-100 inter-medium-star-dust-14px",
            children: children
        })
    });
}
exports.default = HeaderMenuDefault2;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"b9X5n","./HeaderMenuDefault2.css":"f4tq1","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"f4tq1":[function() {},{}],"kz89G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame1144Css = require("./Frame1144.css");
function Frame1144(props) {
    const { className } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `frame-114-95 ${className || ""}`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "modeling-88 valign-text-middle inter-medium-sonic-silver-18px",
            children: "Modeling"
        })
    });
}
exports.default = Frame1144;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./Frame1144.css":"iq0em","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iq0em":[function() {},{}],"4B3A5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _headerMenuDefault2 = require("../HeaderMenuDefault2");
var _headerMenuDefault2Default = parcelHelpers.interopDefault(_headerMenuDefault2);
var _frame232Css = require("./Frame232.css");
function Frame232(props) {
    const { headerMenuDefault2Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "frame-2-7",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefault2Default.default), {
            className: headerMenuDefault2Props.className,
            children: headerMenuDefault2Props.children
        })
    });
}
exports.default = Frame232;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","../HeaderMenuDefault2":"ixaJ9","./Frame232.css":"hpV1k","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hpV1k":[function() {},{}],"dLcbc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _group102 = require("../Group102");
var _group102Default = parcelHelpers.interopDefault(_group102);
var _frame101Css = require("./Frame101.css");
function Frame101(props) {
    const { className, toggleProps, group1021Props, group1022Props, group1023Props, group1024Props, group1025Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `frame-101 ${className || ""}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                className: toggleProps.className,
                buttonSecondaryProps: toggleProps.buttonSecondaryProps
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "a-quelle-frquence-re subtitel",
                name: "aquellefr\xe9quencerenouvelezvousvotrestock",
                placeholder: "A quelle fr\xe9quence renouvelez vous votre stock?",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1021Props.line24,
                className: group1021Props.className
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "combien-de-temps-en subtitel",
                name: "combiendetempsenmoyenneunarticleeffectuedansvotremagazin",
                placeholder: "combien de temps en moyenne un article effectue dans votre magazin?",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1022Props.line24,
                className: group1022Props.className
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "vous subtitel",
                name: "vousarrive-t-ildavoirdesrupturesdestocksioui\xe0quellefr\xe9quence",
                placeholder: "Vous arrive-t-il d\u2019avoir des ruptures de stock? Si oui, \xe0 quelle fr\xe9quence?",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1023Props.line24,
                className: group1023Props.className
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "vous subtitel",
                name: "avezvousmisenplacedemesuresdam\xe9lioration",
                placeholder: "Avez vous mis en place de mesures d\u2019am\xe9lioration?",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1024Props.line24,
                className: group1024Props.className
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "x subtitel",
                name: "*******************************************",
                placeholder: "*******************************************",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1025Props.line24,
                className: group1025Props.className
            })
        ]
    });
}
exports.default = Frame101;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","../Toggle":"dSqDu","../Group102":"cllgP","./Frame101.css":"fRiDS","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dSqDu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _buttonSecondary = require("../ButtonSecondary");
var _buttonSecondaryDefault = parcelHelpers.interopDefault(_buttonSecondary);
var _toggleCss = require("./Toggle.css");
function Toggle(props) {
    const { className, buttonSecondaryProps } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `toggle-32 ${className || ""}`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonSecondaryDefault.default), {
            className: buttonSecondaryProps.className,
            children: buttonSecondaryProps.children
        })
    });
}
exports.default = Toggle;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"b9X5n","../ButtonSecondary":"eDLzj","./Toggle.css":"5mR1c","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eDLzj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _buttonSecondaryCss = require("./ButtonSecondary.css");
function ButtonSecondary(props) {
    const { children, className } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `button-secondary-101 ${className || ""}`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "label-88 inter-bold-mineral-green-16px",
            children: children
        })
    });
}
exports.default = ButtonSecondary;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./ButtonSecondary.css":"i3Pd0","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"i3Pd0":[function() {},{}],"5mR1c":[function() {},{}],"cllgP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _group102Css = require("./Group102.css");
function Group102(props) {
    const { line24, className } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `group-23 ${className || ""}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "tap-here-7 subtitel",
                name: "taphere",
                placeholder: "tap here",
                type: "text",
                required: true
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                className: "line-24",
                src: line24,
                alt: "Line 24"
            })
        ]
    });
}
exports.default = Group102;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./Group102.css":"5fBcn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5fBcn":[function() {},{}],"fRiDS":[function() {},{}],"fva7h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _group102 = require("../Group102");
var _group102Default = parcelHelpers.interopDefault(_group102);
var _frame102Css = require("./Frame102.css");
function Frame102(props) {
    const { className, toggleProps, group1021Props, group1022Props, group1023Props, group1024Props, group1025Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `frame-102 ${className || ""}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                className: toggleProps.className,
                buttonSecondaryProps: toggleProps.buttonSecondaryProps
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "dans-quel-rayon-se-situe-vos-clients subtitel",
                name: "dansquelrayonsesituevosclients",
                placeholder: "Dans quel rayon se situe vos clients?",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1021Props.line24,
                className: group1021Props.className
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "quel subtitel",
                name: "aquellefr\xe9quenceeffectuezvousdeslivraisons",
                placeholder: "A quelle fr\xe9quence effectuez vous des livraisons?",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1022Props.line24,
                className: group1022Props.className
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "quel subtitel",
                name: "quelestvotretauxdeservice",
                placeholder: "Quel est votre taux de service?",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1023Props.line24,
                className: group1023Props.className
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "quel-est-votre-taux-de-retard subtitel",
                name: "quelestvotretauxderetard",
                placeholder: "Quel est votre taux de retard?",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1024Props.line24,
                className: group1024Props.className
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "x-9 subtitel",
                name: "*************************************",
                placeholder: "*************************************",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1025Props.line24,
                className: group1025Props.className
            })
        ]
    });
}
exports.default = Frame102;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","../Toggle":"dSqDu","../Group102":"cllgP","./Frame102.css":"jjbCT","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jjbCT":[function() {},{}],"gSRJf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame11732Css = require("./Frame11732.css");
function Frame11732(props) {
    const { className } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `frame-112 ${className || ""}`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "next valign-text-middle inter-bold-mineral-green-18px",
            children: "Next"
        })
    });
}
exports.default = Frame11732;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./Frame11732.css":"7fyCF","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7fyCF":[function() {},{}],"4v5AJ":[function() {},{}],"6GSi3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _frame101 = require("../Frame101");
var _frame101Default = parcelHelpers.interopDefault(_frame101);
var _frame102 = require("../Frame102");
var _frame102Default = parcelHelpers.interopDefault(_frame102);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _smed3Css = require("./SMED3.css");
function SMED3(props) {
    const { x1200PxLogo_Icam__20081, pleaseAnswerTheFollowingQuestions, visualManagement, navItems2Props, navItems3Props, frame101Props, frame102Props, toggleProps } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "smed-3-1 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-21",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "rectangle-3-8"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {
                            className: navItems2Props.className
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                            className: navItems3Props.className,
                            frame1172Props: navItems3Props.frame1172Props,
                            frame1162Props: navItems3Props.frame1162Props,
                            frame1132Props: navItems3Props.frame1132Props
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-21",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "please-answer-the-following-questions-2 valign-text-middle bevan-normal-white-20px",
                            children: pleaseAnswerTheFollowingQuestions
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame101Default.default), {
                            className: frame101Props.className,
                            toggleProps: frame101Props.toggleProps,
                            group1021Props: frame101Props.group1021Props,
                            group1022Props: frame101Props.group1022Props,
                            group1023Props: frame101Props.group1023Props,
                            group1024Props: frame101Props.group1024Props,
                            group1025Props: frame101Props.group1025Props
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame102Default.default), {
                            className: frame102Props.className,
                            toggleProps: frame102Props.toggleProps,
                            group1021Props: frame102Props.group1021Props,
                            group1022Props: frame102Props.group1022Props,
                            group1023Props: frame102Props.group1023Props,
                            group1024Props: frame102Props.group1024Props,
                            group1025Props: frame102Props.group1025Props
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-68",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            className: toggleProps.className,
                            buttonSecondaryProps: toggleProps.buttonSecondaryProps
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "frame-117-93",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "visual-management-14 valign-text-middle inter-bold-mineral-green-18px",
                                children: visualManagement
                            })
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = SMED3;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"b9X5n","../NavItems2":"bnQuI","../NavItems3":"fOarC","../Frame101":"dLcbc","../Frame102":"fva7h","../Toggle":"dSqDu","./SMED3.css":"cgPCX","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cgPCX":[function() {},{}],"gd4Xt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _frame101 = require("../Frame101");
var _frame101Default = parcelHelpers.interopDefault(_frame101);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _frame102 = require("../Frame102");
var _frame102Default = parcelHelpers.interopDefault(_frame102);
var _frame11732 = require("../Frame11732");
var _frame11732Default = parcelHelpers.interopDefault(_frame11732);
var _visualManagement2Css = require("./VisualManagement2.css");
function VisualManagement2(props) {
    const { x1200PxLogo_Icam__20081, pleaseAnswerTheFollowingQuestions, navItems2Props, navItems3Props, frame101Props, toggleProps, frame102Props, frame11732Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "visual-management-2-1 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-22",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "rectangle-3-9"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {
                            className: navItems2Props.className
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                            className: navItems3Props.className,
                            frame1172Props: navItems3Props.frame1172Props,
                            frame1162Props: navItems3Props.frame1162Props,
                            frame1132Props: navItems3Props.frame1132Props
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-22",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "please-answer-the-following-questions-3 valign-text-middle bevan-normal-white-20px",
                            children: pleaseAnswerTheFollowingQuestions
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-69",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-col-48",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame101Default.default), {
                                    toggleProps: frame101Props.toggleProps,
                                    group1021Props: frame101Props.group1021Props,
                                    group1022Props: frame101Props.group1022Props,
                                    group1023Props: frame101Props.group1023Props,
                                    group1024Props: frame101Props.group1024Props,
                                    group1025Props: frame101Props.group1025Props
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggleProps.className,
                                    buttonSecondaryProps: toggleProps.buttonSecondaryProps
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "frame-container-10",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame102Default.default), {
                                    toggleProps: frame102Props.toggleProps,
                                    group1021Props: frame102Props.group1021Props,
                                    group1022Props: frame102Props.group1022Props,
                                    group1023Props: frame102Props.group1023Props,
                                    group1024Props: frame102Props.group1024Props,
                                    group1025Props: frame102Props.group1025Props
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11732Default.default), {
                                    className: frame11732Props.className
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = VisualManagement2;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"b9X5n","../NavItems2":"bnQuI","../NavItems3":"fOarC","../Frame101":"dLcbc","../Toggle":"dSqDu","../Frame102":"fva7h","../Frame11732":"gSRJf","./VisualManagement2.css":"1LoLg","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1LoLg":[function() {},{}],"bJ6py":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _frame101 = require("../Frame101");
var _frame101Default = parcelHelpers.interopDefault(_frame101);
var _frame102 = require("../Frame102");
var _frame102Default = parcelHelpers.interopDefault(_frame102);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _kaizen3Css = require("./Kaizen3.css");
function Kaizen3(props) {
    const { x1200PxLogo_Icam__20081, pleaseAnswerTheFollowingQuestions, smed, navItems2Props, navItems3Props, frame101Props, frame102Props, toggleProps } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "kaizen-3-1 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-23",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "rectangle-3-10"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {
                            className: navItems2Props.className
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                            className: navItems3Props.className,
                            frame1172Props: navItems3Props.frame1172Props,
                            frame1162Props: navItems3Props.frame1162Props,
                            frame1132Props: navItems3Props.frame1132Props
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-23",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "please-answer-the-following-questions-4 valign-text-middle bevan-normal-white-20px",
                            children: pleaseAnswerTheFollowingQuestions
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame101Default.default), {
                            className: frame101Props.className,
                            toggleProps: frame101Props.toggleProps,
                            group1021Props: frame101Props.group1021Props,
                            group1022Props: frame101Props.group1022Props,
                            group1023Props: frame101Props.group1023Props,
                            group1024Props: frame101Props.group1024Props,
                            group1025Props: frame101Props.group1025Props
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame102Default.default), {
                            className: frame102Props.className,
                            toggleProps: frame102Props.toggleProps,
                            group1021Props: frame102Props.group1021Props,
                            group1022Props: frame102Props.group1022Props,
                            group1023Props: frame102Props.group1023Props,
                            group1024Props: frame102Props.group1024Props,
                            group1025Props: frame102Props.group1025Props
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-70",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            className: toggleProps.className,
                            buttonSecondaryProps: toggleProps.buttonSecondaryProps
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "frame-117-94",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "smed-12 valign-text-middle inter-bold-mineral-green-18px",
                                children: smed
                            })
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Kaizen3;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"b9X5n","../NavItems2":"bnQuI","../NavItems3":"fOarC","../Frame101":"dLcbc","../Frame102":"fva7h","../Toggle":"dSqDu","./Kaizen3.css":"1EKVQ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1EKVQ":[function() {},{}],"2vPVJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _visualManagement3Css = require("./VisualManagement3.css");
function VisualManagement3(props) {
    const { x1200PxLogo_Icam__20081, pleaseAnswerTheFollowingQuestions, goOnToTheNextStep, navItems2Props, navItems3Props, toggleProps } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "visual-management-3-1 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-24",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "rectangle-3-11"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {
                            className: navItems2Props.className
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                            className: navItems3Props.className,
                            frame1172Props: navItems3Props.frame1172Props,
                            frame1162Props: navItems3Props.frame1162Props,
                            frame1132Props: navItems3Props.frame1132Props
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-24",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "please-answer-the-following-questions-5 valign-text-middle bevan-normal-white-20px",
                            children: pleaseAnswerTheFollowingQuestions
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-71",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            className: toggleProps.className,
                            buttonSecondaryProps: toggleProps.buttonSecondaryProps
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/functional-view-1",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "frame-116-177",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "go-on-to-the-next-step valign-text-middle inter-bold-mineral-green-18px",
                                    children: goOnToTheNextStep
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = VisualManagement3;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"b9X5n","../NavItems2":"bnQuI","../NavItems3":"fOarC","../Toggle":"dSqDu","./VisualManagement3.css":"kjld3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kjld3":[function() {},{}],"ff5Hz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
var _inscriptionCss = require("./Inscription.css");
var _1200PxLogoIcam20081432XPng = require("../../static/img/1200px-logo-icam---2008-1-43@2x.png");
var _1200PxLogoIcam20081432XPngDefault = parcelHelpers.interopDefault(_1200PxLogoIcam20081432XPng);
var _authContext = require("../../context/AuthContext");
function Inscription() {
    const [username, setUsername] = (0, _react.useState)("");
    const [password, setPassword] = (0, _react.useState)("");
    const [confirmPassword, setConfirmPassword] = (0, _react.useState)("");
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const [error, setError] = (0, _react.useState)("");
    const history = (0, _reactRouterDom.useHistory)();
    const { login } = (0, _authContext.useAuth)();
    const handleRegister = async (e)=>{
        e.preventDefault();
        setError("");
        if (password !== confirmPassword) {
            setError("Passwords do not match");
            return;
        }
        if (password.length < 6) {
            setError("Password must contain at least 6 characters");
            return;
        }
        setIsLoading(true);
        try {
            console.log("Tentative d'inscription avec:", {
                username
            });
            const response = await (0, _axiosDefault.default).post("/api/register", {
                username,
                password
            }, {
                headers: {
                    "Content-Type": "application/json",
                    "ngrok-skip-browser-warning": "true"
                }
            });
            console.log("R\xe9ponse du serveur:", response.data);
            // ðŸ”‘ Récupérer token dans tous les cas possibles
            const token = response.data?.access_token || response.data?.token || response.data?.jwt || response.data?.authToken || response.data?.user?.token || null;
            if (!token) {
                localStorage.removeItem("token");
                localStorage.removeItem("isAuthenticated");
                localStorage.removeItem("isAdmin");
                localStorage.setItem("username", username);
                history.push("/login");
                return;
            }
            // âœ”ï¸ Stocker token
            localStorage.setItem("token", token);
            console.log("\xf0\u0178\u201D\x90 Token stock\xe9 :", token);
            // ðŸ‘¤ âœ”ï¸ Stocker userId et enterpriseId si renvoyés
            if (response.data?.user) {
                if (response.data.user.id) {
                    localStorage.setItem("userId", response.data.user.id);
                    console.log("userId stock\xe9 :", response.data.user.id);
                }
                if (response.data.user.enterpriseId) {
                    localStorage.setItem("enterpriseId", response.data.user.enterpriseId);
                    console.log("enterpriseId stock\xe9 :", response.data.user.enterpriseId);
                }
            }
            // âœ”ï¸ Stocker état d'authentification
            localStorage.setItem("isAuthenticated", "true");
            localStorage.setItem("isAdmin", "false");
            localStorage.setItem("username", username);
            // âœ”ï¸ Mise à  jour du contexte
            login(false);
            // ðŸ” Redirection
            setTimeout(()=>{
                window.location.href = "/home";
            }, 100);
        } catch (error) {
            console.error("Erreur d'inscription:", error);
            if (error.response && error.response.status === 400) setError("This username already exists");
            else if (error.response) setError(`Error ${error.response.status}: ${error.response.data.detail || "Registration error"}`);
            else if (error.request) setError("Server not responding. Check your connection or backend.");
            else setError(error.message || "Registration error.");
        } finally{
            setIsLoading(false);
        }
    };
    const navigateToLogin = ()=>{
        history.push("/");
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "inscription-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "inscription-card",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "inscription-left",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "inscription-form-container",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                className: "inscription-title",
                                children: "Create an Account"
                            }),
                            error && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "inscription-error",
                                children: error
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                                onSubmit: handleRegister,
                                className: "inscription-form",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "inscription-input-group",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                htmlFor: "username",
                                                children: "Username"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                type: "text",
                                                id: "username",
                                                value: username,
                                                onChange: (e)=>setUsername(e.target.value),
                                                required: true,
                                                placeholder: "Choose a username"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "inscription-input-group",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                htmlFor: "password",
                                                children: "Password"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                type: "password",
                                                id: "password",
                                                value: password,
                                                onChange: (e)=>setPassword(e.target.value),
                                                required: true,
                                                placeholder: "Create a password"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "inscription-input-group",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                htmlFor: "confirmPassword",
                                                children: "Confirm Password"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                type: "password",
                                                id: "confirmPassword",
                                                value: confirmPassword,
                                                onChange: (e)=>setConfirmPassword(e.target.value),
                                                required: true,
                                                placeholder: "Confirm your password"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        type: "submit",
                                        className: "inscription-button",
                                        disabled: isLoading,
                                        children: isLoading ? "Registering..." : "Register"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "inscription-footer",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        children: "Already have an account?"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        type: "button",
                                        onClick: navigateToLogin,
                                        className: "login-link",
                                        children: "Login"
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "inscription-right",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "inscription-logo-container",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                src: (0, _1200PxLogoIcam20081432XPngDefault.default),
                                alt: "ICAM Logo",
                                className: "inscription-logo"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                            className: "inscription-welcome",
                            children: "Join the Supply Chain Platform"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "inscription-description",
                            children: "Create your account to access all our services and manage your supply chain projects."
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Inscription;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"ditZI","axios":"kL5AO","./Inscription.css":"1I68Z","../../static/img/1200px-logo-icam---2008-1-43@2x.png":"fcd5E","../../context/AuthContext":"5fsmo","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1I68Z":[function() {},{}],"fcd5E":[function() {},{}],"3OEIe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cc_sum", ()=>cc_sum);
parcelHelpers.export(exports, "cc_allData2", ()=>cc_allData2);
parcelHelpers.export(exports, "cc_yesCount2", ()=>cc_yesCount2);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _clientConsommateur2Css = require("./ClientConsommateur2.css");
var _styleguideCss = require("../../styleguide.css");
var _jspdf = require("jspdf");
var _jspdfDefault = parcelHelpers.interopDefault(_jspdf);
var _clientConsommateur1 = require("../ClientConsommateur1");
var _social6 = require("../Social6");
var _acquisition = require("../Acquisition");
var _environmental5 = require("../Environmental5");
var _modernization4 = require("../Modernization4");
var _leadTime2 = require("../LeadTime2");
var _cost2 = require("../Cost2");
var _quality6 = require("../Quality6");
var _scoreHelper = require("../../utils/scoreHelper");
let cc_sum = 0;
let cc_allData2 = [];
let cc_yesCount2 = 0;
function ClientConsommateur2(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const [message, setMessage] = (0, _react.useState)("");
    const [scoreState, setScoreState] = (0, _react.useState)(0); // score du ClientConsommateur2
    const [ccYesCount1, setCcYesCount1] = (0, _react.useState)(0); // score récupéré du ClientConsommateur1
    const { x1200PxLogo_Icam__20081, navItems3Props } = props;
    (0, _react.useEffect)(()=>{
        // Reset le score du composant 2
        cc_yesCount2 = 0;
        setScoreState(0);
        // Récupérer le score de ClientConsommateur1 depuis le localStorage
        const clientConsommateur1Score = parseInt(localStorage.getItem('clientConsommateur1Score') || 0);
        setCcYesCount1(clientConsommateur1Score); // on met à  jour le state pour React
        console.log(`Score ClientConsommateur1 r\xe9cup\xe9r\xe9: ${clientConsommateur1Score}`);
        // Calculate total questions
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
        // Utilise la variable locale pour calculer cc_sum
        cc_sum = clientConsommateur1Score + cc_yesCount2;
        console.log(`cc_sum initial: ${cc_sum} (cc_yesCount1: ${clientConsommateur1Score}, cc_yesCount2: ${cc_yesCount2})`);
    }, []);
    // Exécuter seulement au montage du composant, pas à  chaque changement de cc_yesCount2
    function clicked(question, option) {
        console.log(`Option clicked: ${option} for question: ${question}`);
        // If the clicked option is the same as the already selected one, deselect it
        if (selectedOptions[question] === option) {
            setSelectedOptions((prevSelectedOptions)=>{
                const newOptions = {
                    ...prevSelectedOptions
                };
                delete newOptions[question];
                return newOptions;
            });
            // If we deselect a "Yes", decrement the score
            if (option === "Yes") {
                cc_yesCount2--;
                setScoreState(cc_yesCount2);
                console.log(`Score apr\xe8s d\xe9s\xe9lection: ${cc_yesCount2}`);
            }
            return;
        }
        // Otherwise, update the selection
        const previousOption = selectedOptions[question];
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        // If changing from "No" to "Yes", increment the score
        if (option === "Yes" && previousOption !== "Yes") {
            cc_yesCount2++;
            setScoreState(cc_yesCount2);
            console.log(`Score apr\xe8s s\xe9lection Yes: ${cc_yesCount2}`);
        } else if (option === "No" && previousOption === "Yes") {
            cc_yesCount2--;
            setScoreState(cc_yesCount2);
            console.log(`Score apr\xe8s s\xe9lection No: ${cc_yesCount2}`);
        }
        // Mettre à  jour cc_sum après modification du score
        cc_sum = ccYesCount1 + cc_yesCount2;
        console.log(`cc_sum mis \xe0\xa0 jour: ${cc_sum}`);
    }
    const history = (0, _reactRouterDom.useHistory)();
    function saveData() {
        setIsLoading(true);
        setErrorMessage("");
        console.log("D\xe9but de sauvegarde des donn\xe9es ClientConsommateur2");
        const enterpriseId = localStorage.getItem("enterpriseId");
        const userId = localStorage.getItem("userId");
        if (!enterpriseId) {
            console.error("ERREUR: ID d'entreprise manquant");
            setErrorMessage("ID d'entreprise manquant. Veuillez retourner \xe0\xa0 la s\xe9lection d'entreprise.");
            setIsLoading(false);
            return;
        }
        // Définir toutes les questions qui apparaissent dans le composant
        const allQuestions = [
            "Is your complaint rate above 75%?",
            "Do you have a Warehouse Management System (WMS) to manage product movement and storage?",
            "Do you take measures for data protection?",
            "Do you have justified complaints about privacy violations or customer data loss?"
        ];
        // Créer un tableau de questions/réponses pour toutes les questions
        const data = allQuestions.map((question)=>{
            const answer = selectedOptions[question] || "No";
            return {
                question: question,
                answer: answer,
                category: "client-consommateur",
                enterpriseId: enterpriseId,
                userId: userId || "",
                section: "client-consommateur-2",
                timestamp: new Date().toISOString()
            };
        });
        // Vérifier que les données sont correctement formatées
        const isValidData = data.every((item)=>item.question && item.answer && item.category && item.enterpriseId);
        if (!isValidData) {
            console.error("Donn\xe9es invalides:", data);
            setErrorMessage("Format de donn\xe9es invalide");
            setIsLoading(false);
            return;
        }
        // Sauvegarder les données pour une utilisation ultérieure
        cc_allData2 = [
            ...data
        ];
        console.log("Donn\xe9es \xe0\xa0 envoyer:", JSON.stringify(data, null, 2));
        // Calculer la somme des scores Cost1 et Cost2
        const clientConsommateur1Score = parseInt(localStorage.getItem('clientConsommateur1Score') || 0);
        cc_sum = clientConsommateur1Score + scoreState;
        console.log("Score total ClientConsommateur:", cc_sum);
        // Appel API pour sauvegarder les données
        fetch("/api/api/save-answers", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
            },
            body: JSON.stringify(data)
        }).then((response)=>{
            if (!response.ok) throw new Error(`Erreur de sauvegarde (${response.status})`);
            return response.json();
        }).then((result)=>{
            console.log("Data saved successfully:", result);
            // Sauvegarder le score dans le localStorage
            localStorage.setItem('clientConsommateur2Score', scoreState);
            console.log(`Score clientConsommateur2 mis \xe0\xa0 jour: ${scoreState}`);
            // Sauvegarder également le score total clientConsommateur
            const scoreData = [
                {
                    question: "ClientConsommateur Total Score Final",
                    answer: cc_sum.toString(),
                    category: "client-consommateur",
                    enterpriseId: enterpriseId,
                    userId: userId || "",
                    section: "client-consommateur-total-final",
                    timestamp: new Date().toISOString()
                }
            ];
            console.log("Envoi du score total clientConsommateur:", JSON.stringify(scoreData, null, 2));
            // Appel API pour sauvegarder le score total
            return fetch("/api/api/save-answers", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
                },
                body: JSON.stringify(scoreData)
            });
        }).then((response)=>{
            if (!response || !response.ok) throw new Error("Failed to save total score");
            return response.json();
        }).then((scoreResponse)=>{
            console.log("Score total clientConsommateur enregistr\xe9 avec succ\xe8s:", scoreResponse);
            // Récupérer correctement les données de tous les composants
            const allClientConsommateurData = [];
            try {
                if (Array.isArray((0, _clientConsommateur1.cc_allData1)) && (0, _clientConsommateur1.cc_allData1).length > 0) allClientConsommateurData.push(...(0, _clientConsommateur1.cc_allData1));
                if (Array.isArray(cc_allData2) && cc_allData2.length > 0) allClientConsommateurData.push(...cc_allData2);
            } catch (error) {
                console.error("Erreur lors de la concat\xe9nation des donn\xe9es:", error);
            }
            console.log("Toutes les donn\xe9es ClientConsommateur pour le PDF:", allClientConsommateurData.length, "questions");
            // Générer le PDF avec toutes les données
            generatePdf(allClientConsommateurData);
            // Récupération des scores de toutes les catégories
            const social_value = parseInt(localStorage.getItem('social6Score') || 0);
            const environmental_value = parseInt(localStorage.getItem('environmental5Score') || 0);
            const quality_value = parseInt(localStorage.getItem('quality3Score') || 0);
            const cost_value = parseInt(localStorage.getItem('cost2Score') || 0);
            const leadTime_value = parseInt(localStorage.getItem('leadtime2Score') || 0);
            const modernization_value = parseInt(localStorage.getItem('modernization4Score') || 0);
            // S'assurer que cc_sum est à  jour avec les dernières valeurs
            cc_sum = ccYesCount1 + scoreState;
            const clientConsumer_value = cc_sum;
            console.log("Valeurs r\xe9cup\xe9r\xe9es pour chaque cat\xe9gorie:", {
                social: social_value,
                environmental: environmental_value,
                quality: quality_value,
                cost: cost_value,
                leadTime: leadTime_value,
                modernization: modernization_value,
                clientConsumer: clientConsumer_value
            });
            // Créer un objet avec tous les scores - S'assurer que la clé est exactement "clientConsumer"
            const allScores = {
                social: social_value,
                environmental: environmental_value,
                quality: quality_value,
                cost: cost_value,
                leadTime: leadTime_value,
                modernization: modernization_value,
                clientConsumer: clientConsumer_value // Vérifier que cette clé est correcte pour la base de données
            };
            // Afficher les scores avant l'envoi pour vérification
            console.log("SCORES \xe0\xa0 envoyer \xe0\xa0 saveAllScores:", JSON.stringify(allScores, null, 2));
            // Récupérer le nom de l'entreprise
            const company_name = localStorage.getItem("company_name") || "Entreprise sans nom";
            // Appeler la fonction centralisée pour sauvegarder tous les scores
            return (0, _scoreHelper.saveAllScores)(allScores, company_name, enterpriseId, userId);
        }).then((result)=>{
            console.log("Tous les scores ont \xe9t\xe9 sauvegard\xe9s avec succ\xe8s:", result);
            // Recalculer cc_sum pour s'assurer qu'il est à  jour
            const clientConsommateur1Score = parseInt(localStorage.getItem('clientConsommateur1Score') || 0);
            cc_sum = clientConsommateur1Score + scoreState;
            console.log(`Score clientConsumer avant sauvegarde s\xe9par\xe9e: ${cc_sum} (${clientConsommateur1Score} + ${scoreState})`);
            // Sauvegarder séparément le score clientConsumer pour s'assurer qu'il est bien enregistré
            return (0, _scoreHelper.saveCategoryScore)("clientConsumer", cc_sum, localStorage.getItem("enterpriseId"), localStorage.getItem("userId"));
        }).then((categoryResult)=>{
            console.log("Score clientConsumer sauvegard\xe9 s\xe9par\xe9ment:", categoryResult);
            setIsLoading(false);
            setMessage("Scores enregistr\xe9s avec succ\xe8s !");
            setTimeout(()=>{
                setMessage("");
                history.push("/cur-performance");
            }, 2000);
        }).catch((error)=>{
            console.error("Error saving data:", error);
            setErrorMessage("Error saving data. Please try again.");
            console.error("D\xe9tails de l'erreur:", error.message);
            // Màªme en cas d'erreur, essayer de générer le PDF avec les données disponibles
            const allClientConsommateurData = [];
            try {
                if (Array.isArray((0, _clientConsommateur1.cc_allData1)) && (0, _clientConsommateur1.cc_allData1).length > 0) allClientConsommateurData.push(...(0, _clientConsommateur1.cc_allData1));
                if (Array.isArray(cc_allData2) && cc_allData2.length > 0) allClientConsommateurData.push(...cc_allData2);
            } catch (error) {
                console.error("Erreur lors de la concat\xe9nation des donn\xe9es:", error);
            }
            generatePdf(allClientConsommateurData);
            setIsLoading(false);
            history.push("/cur-performance");
        });
    }
    function generatePdf(cc_allData) {
        // Check if data exists
        if (!cc_allData || cc_allData.length === 0) {
            console.error("No data available to generate PDF");
            return;
        }
        console.log("Generating PDF with", cc_allData.length, "questions");
        // Create a new PDF document
        const doc = new (0, _jspdfDefault.default)();
        const lineHeight = 10;
        const pageHeight = doc.internal.pageSize.height - 20;
        const pageWidth = doc.internal.pageSize.width - 20;
        let y = 20;
        // Add a title
        doc.setFontSize(16);
        doc.text("Client/Consumer Assessment Results", 105, y, {
            align: "center"
        });
        y += 15;
        // Add total score
        doc.setFontSize(14);
        doc.text(`Total score: ${cc_sum} / ${cc_allData.length}`, 105, y, {
            align: "center"
        });
        y += 15;
        doc.setFontSize(12);
        // Go through the data and add each question and answer to the PDF document
        cc_allData.forEach((data, index)=>{
            // Check if data is valid
            if (!data || !data.question) {
                console.error("Invalid data for item", index);
                return;
            }
            const question = `Question ${index + 1}: ${data.question}`;
            const answer = `Answer: ${data.answer || 'No answer'}`;
            // Estimate text height after division to better manage page breaks
            const splitQuestion = doc.splitTextToSize(question, pageWidth);
            const estimatedHeight = splitQuestion.length * lineHeight + lineHeight * 2;
            // Check if we need to go to a new page
            if (y + estimatedHeight > pageHeight) {
                doc.addPage();
                y = 20;
            }
            // Write the question and answer to the PDF
            doc.text(splitQuestion, 10, y);
            y += splitQuestion.length * lineHeight;
            doc.text(answer, 10, y);
            y += lineHeight * 2; // Add some space between questions
        });
        // Add a summary page
        doc.addPage();
        y = 20;
        doc.setFontSize(16);
        doc.text("Client/Consumer Assessment Summary", 105, y, {
            align: "center"
        });
        y += 20;
        doc.setFontSize(12);
        doc.text(`Total number of questions: ${cc_allData.length}`, 10, y);
        y += lineHeight;
        doc.text(`Total "Yes" answers: ${cc_sum}`, 10, y);
        y += lineHeight;
        doc.text(`Score percentage: ${Math.round(cc_sum / cc_allData.length * 100)}%`, 10, y);
        y += lineHeight * 2;
        // Add details for each section
        doc.text("Scores by section:", 10, y);
        y += lineHeight * 1.5;
        doc.text(`Client/Consumer 1: ${ccYesCount1}`, 20, y);
        y += lineHeight;
        doc.text(`Client/Consumer 2: ${scoreState}`, 20, y);
        y += lineHeight * 2;
        const date = new Date();
        doc.text(`Generated on: ${date.toLocaleDateString()} at ${date.toLocaleTimeString()}`, 10, y);
        // Save the PDF document
        doc.save("Client_Consumer_Assessment_Complete.pdf");
        console.log("Client/Consumer PDF generated successfully");
    }
    function calculateProgressPercentage() {
        const totalQuestions = document.getElementsByTagName("section").length;
        if (totalQuestions === 0) return 0;
        return Math.round(scoreState / totalQuestions * 100);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "environmental-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "environmental-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    className: "environmental-title",
                    children: "PLEASE ANSWER THE FOLLOWING QUESTIONS"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "progress-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "progress-bar",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "progress-fill",
                                style: {
                                    width: `${calculateProgressPercentage()}%`
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "progress-text",
                            children: [
                                "Your score: ",
                                scoreState,
                                " / ",
                                totalQuestions,
                                " (",
                                calculateProgressPercentage(),
                                "%)"
                            ]
                        })
                    ]
                }),
                errorMessage && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "error-message",
                    children: errorMessage
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questions-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Is your complaint rate above 75%?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Is your complaint rate above 75%?", "Yes"),
                                            className: `btn-option ${selectedOptions["Is your complaint rate above 75%?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Is your complaint rate above 75%?", "No"),
                                            className: `btn-option ${selectedOptions["Is your complaint rate above 75%?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have a Warehouse Management System (WMS) to manage product movement and storage?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a Warehouse Management System (WMS) to manage product movement and storage?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have a Warehouse Management System (WMS) to manage product movement and storage?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a Warehouse Management System (WMS) to manage product movement and storage?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have a Warehouse Management System (WMS) to manage product movement and storage?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you take measures for data protection?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you take measures for data protection?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you take measures for data protection?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you take measures for data protection?", "No"),
                                            className: `btn-option ${selectedOptions["Do you take measures for data protection?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have justified complaints about privacy violations or customer data loss?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have justified complaints about privacy violations or customer data loss?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have justified complaints about privacy violations or customer data loss?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have justified complaints about privacy violations or customer data loss?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have justified complaints about privacy violations or customer data loss?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "form-actions",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/client-consommateur-1",
                            className: "btn-secondary",
                            children: "Back"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: ()=>saveData(),
                            className: "btn-primary",
                            children: "Save and Continue"
                        })
                    ]
                }),
                isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "loading-indicator",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "spinner"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: message
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = ClientConsommateur2;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["Link","b9X5n"],["useHistory","ditZI"]],"../NavItems3":"fOarC","../NavItems2":"bnQuI","./ClientConsommateur2.css":"36dUa","../../styleguide.css":"8Y7Ec","jspdf":"hkJ4Q","../ClientConsommateur1":"erE99","../Social6":"jqrFa","../Acquisition":"h8aqW","../Environmental5":"leUWw","../Modernization4":"3hH0I","../LeadTime2":"5LCGo","../Cost2":"eoJTs","../Quality6":"ebrQE","../../utils/scoreHelper":"5js5u","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"36dUa":[function() {},{}],"8Y7Ec":[function() {},{}],"erE99":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cc_allData1", ()=>cc_allData1);
parcelHelpers.export(exports, "cc_yesCount1", ()=>cc_yesCount1);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _clientConsommateur1Css = require("./ClientConsommateur1.css");
var _styleguideCss = require("../../styleguide.css");
let cc_allData1 = [];
let cc_yesCount1 = 0;
function ClientConsommateur1(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const { x1200PxLogo_Icam__20081, navItems3Props } = props;
    const history = (0, _reactRouterDom.useHistory)();
    (0, _react.useEffect)(()=>{
        // Reset the count when component mounts to avoid residual values
        cc_yesCount1 = 0;
        // Calculate the total number of questions based on sections
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []); // Run this effect only once when the component mounts
    function clicked(question, option) {
        // If the clicked option is the same as the already selected one, deselect it
        if (selectedOptions[question] === option) {
            setSelectedOptions((prevSelectedOptions)=>{
                const newOptions = {
                    ...prevSelectedOptions
                };
                delete newOptions[question];
                return newOptions;
            });
            // If we deselect a "Yes", decrement the score
            if (option === "Yes") cc_yesCount1--;
            return;
        }
        // Otherwise, update the selection
        const previousOption = selectedOptions[question];
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        // If changing from "No" to "Yes", increment the score
        if (option === "Yes" && previousOption !== "Yes") cc_yesCount1++;
        else if (option === "No" && previousOption === "Yes") cc_yesCount1--;
    }
    function saveData() {
        setIsLoading(true);
        setErrorMessage("");
        console.log("D\xe9but de sauvegarde des donn\xe9es ClientConsommateur1");
        const enterpriseId = localStorage.getItem("enterpriseId");
        const userId = localStorage.getItem("userId");
        if (!enterpriseId) {
            console.error("ERREUR: ID d'entreprise manquant");
            setErrorMessage("ID d'entreprise manquant. Veuillez retourner \xe0\xa0 la s\xe9lection d'entreprise.");
            setIsLoading(false);
            return;
        }
        // Définir toutes les questions possibles
        const allQuestions = [
            "Do you transmit information about product progress to customers?",
            "Number of disputes and/or amicable settlements concerning the company (Do you have disputes and/or amicable settlements?)",
            "Are you audited by organizations such as data protection authorities?",
            "Do you have a communication plan with communities, NGOs and other external structures?",
            "Do you have a plan for improvement in client/consumer relations?",
            "Are your employees aware of best practices in terms of fair information, transparency, and fair contractual practices?",
            "Do your products have a description of the hazards?",
            "Do your products have safety warnings?",
            "Are your products tested before being put on the market?"
        ];
        // Créer un tableau de questions/réponses pour toutes les questions
        const data = allQuestions.map((question)=>{
            const answer = selectedOptions[question] || "No";
            return {
                question: question,
                answer: answer,
                category: "client-consommateur",
                enterpriseId: enterpriseId,
                userId: userId || "",
                section: "client-consommateur-1",
                timestamp: new Date().toISOString()
            };
        });
        // Vérifier que les données sont correctement formatées
        const isValidData = data.every((item)=>item.question && item.answer && item.category && item.enterpriseId);
        if (!isValidData) {
            console.error("Donn\xe9es invalides:", data);
            setErrorMessage("Format de donn\xe9es invalide");
            setIsLoading(false);
            return;
        }
        // Sauvegarder les données pour une utilisation ultérieure
        cc_allData1 = [
            ...data
        ];
        console.log("Donn\xe9es \xe0\xa0 envoyer:", JSON.stringify(data, null, 2));
        // Sauvegarder le score pour ClientConsommateur2
        localStorage.setItem('clientConsommateur1Score', cc_yesCount1);
        console.log(`Score clientConsommateur1 enregistr\xe9: ${cc_yesCount1}`);
        // Appel API pour sauvegarder les données
        fetch("/api/api/save-answers", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
            },
            body: JSON.stringify(data)
        }).then((response)=>{
            if (!response.ok) throw new Error(`Erreur de sauvegarde (${response.status})`);
            return response.json();
        }).then((result)=>{
            console.log("Data saved successfully:", result);
            setIsLoading(false);
            history.push("/client-consommateur-2");
        }).catch((error)=>{
            console.error("Error saving data:", error);
            setErrorMessage("Error saving data. Please try again.");
            console.error("D\xe9tails de l'erreur:", error.message);
            setIsLoading(false);
            history.push("/client-consommateur-2");
        });
    }
    function calculateProgressPercentage() {
        const totalQuestions = document.getElementsByTagName("section").length;
        if (totalQuestions === 0) return 0;
        return Math.round(cc_yesCount1 / totalQuestions * 100);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "environmental-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "environmental-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    className: "environmental-title",
                    children: "PLEASE ANSWER THE FOLLOWING QUESTIONS"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "progress-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "progress-bar",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "progress-fill",
                                style: {
                                    width: `${calculateProgressPercentage()}%`
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "progress-text",
                            children: [
                                "Your score: ",
                                cc_yesCount1,
                                " / ",
                                totalQuestions,
                                " (",
                                calculateProgressPercentage(),
                                "%)"
                            ]
                        })
                    ]
                }),
                errorMessage && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "error-message",
                    children: errorMessage
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questions-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you transmit information about product progress to customers?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you transmit information about product progress to customers?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you transmit information about product progress to customers?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you transmit information about product progress to customers?", "No"),
                                            className: `btn-option ${selectedOptions["Do you transmit information about product progress to customers?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Number of disputes and/or amicable settlements concerning the company (Do you have disputes and/or amicable settlements?)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Number of disputes and/or amicable settlements concerning the company (Do you have disputes and/or amicable settlements?)", "Yes"),
                                            className: `btn-option ${selectedOptions["Number of disputes and/or amicable settlements concerning the company (Do you have disputes and/or amicable settlements?)"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Number of disputes and/or amicable settlements concerning the company (Do you have disputes and/or amicable settlements?)", "No"),
                                            className: `btn-option ${selectedOptions["Number of disputes and/or amicable settlements concerning the company (Do you have disputes and/or amicable settlements?)"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Are you audited by organizations such as data protection authorities?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Are you audited by organizations such as data protection authorities?", "Yes"),
                                            className: `btn-option ${selectedOptions["Are you audited by organizations such as data protection authorities?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Are you audited by organizations such as data protection authorities?", "No"),
                                            className: `btn-option ${selectedOptions["Are you audited by organizations such as data protection authorities?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have safety notices?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have safety notices?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have safety notices?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have safety notices?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have safety notices?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have a recall procedure?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a recall procedure?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have a recall procedure?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a recall procedure?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have a recall procedure?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "form-actions",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/quality-6",
                            className: "btn-secondary",
                            children: "Back"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "btn-primary",
                            children: "Next"
                        })
                    ]
                }),
                isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "loading-indicator",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "spinner"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: "Saving data..."
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = ClientConsommateur1;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["Link","b9X5n"],["useHistory","ditZI"]],"../NavItems3":"fOarC","../NavItems2":"bnQuI","./ClientConsommateur1.css":"kVEZr","../../styleguide.css":"8Y7Ec","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kVEZr":[function() {},{}],"8Y7Ec":[function() {},{}],"jqrFa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "s_sum", ()=>s_sum);
parcelHelpers.export(exports, "yes_Count6", ()=>yes_Count6);
parcelHelpers.export(exports, "s_yesCount6", ()=>s_yesCount6);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _social6Css = require("./Social6.css");
var _social1 = require("../Social1");
var _social2 = require("../Social2");
var _social3 = require("../Social3");
var _social4 = require("../Social4");
var _social5 = require("../Social5");
var _jspdf = require("jspdf");
var _jspdfDefault = parcelHelpers.interopDefault(_jspdf);
let s_sum = 0;
let yes_Count6 = 0;
let s_yesCount6 = 0;
function Social6(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [yesCount6, setYesCount6] = (0, _react.useState)(0); // Initialize yesCount state
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const { x1200PxLogo_Icam__20081, modernizationCriteria, navItems3Props, toggle1Props, toggle2Props, toggle3Props, toggle4Props } = props;
    (0, _react.useEffect)(()=>{
        // Calculate the total number of questions based on sections
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []); // Run this effect only once when the component mounts
    function clicked(question, option) {
        // Si l'option cliquée est la màªme que celle déjà  sélectionnée, on la désélectionne
        if (selectedOptions[question] === option) {
            setSelectedOptions((prevSelectedOptions)=>{
                const newOptions = {
                    ...prevSelectedOptions
                };
                delete newOptions[question];
                return newOptions;
            });
            // Si on désélectionne un "Yes", on décrémente le score
            if (option === "Yes") {
                s_yesCount6--;
                yes_Count6 = s_yesCount6; // Synchroniser les deux variables
            }
            return;
        }
        // Sinon, on met à  jour la sélection
        const previousOption = selectedOptions[question];
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        // Si on passe de "No" à  "Yes", on incrémente le score
        if (option === "Yes" && previousOption !== "Yes") {
            s_yesCount6++;
            yes_Count6 = s_yesCount6; // Synchroniser les deux variables
        } else if (option === "No" && previousOption === "Yes") {
            s_yesCount6--;
            yes_Count6 = s_yesCount6; // Synchroniser les deux variables
        }
    }
    const history = (0, _reactRouterDom.useHistory)();
    let s_allData6 = [];
    function saveData() {
        setErrorMessage("");
        setIsLoading(true);
        console.log("D\xe9but de sauvegarde des donn\xe9es Social6");
        const enterpriseId = localStorage.getItem("enterpriseId");
        const userId = localStorage.getItem("userId");
        if (!enterpriseId) {
            console.error("ERREUR: ID d'entreprise manquant");
            setErrorMessage("ID d'entreprise manquant. Veuillez retourner \xe0\xa0 la s\xe9lection d'entreprise.");
            setIsLoading(false);
            return;
        }
        // Définir toutes les questions possibles
        const allQuestions = [
            "Do you contribute to the development of the regions where you are located?",
            "Do you regularly consult with local communities to ensure that your activities do not have a negative impact?",
            "Do you engage in direct dialogue with communities affected by your activities?",
            "Do you have a positive impact on employment in the regions where you are located?",
            "Do you contribute to the economic development of the regions where you are located?",
            "Do you maintain a high level of safety and physical, mental and social well-being of workers (the notion of worker encompasses all populations of employed workers: company employees, seconded workers, self-employed workers, temporary workers, trainees, apprentices...)?",
            "Are staff trained in occupational health and safety?",
            "Is there a budget for health and safety?",
            "Do you prevent and protect employees from negative health effects resulting from working conditions?",
            "Are job descriptions provided to prevention workers (good practices, etc.)?",
            "Percentage of the number of dangerous situations dealt with out of the number of dangerous situations detected",
            "Do you have a work environment that is adapted to the physiological and psychological needs of workers?"
        ];
        // Créer un tableau de questions/réponses pour toutes les questions
        const data = allQuestions.map((question)=>{
            const answer = selectedOptions[question] || "No";
            return {
                question: question,
                answer: answer,
                category: "social",
                enterpriseId: enterpriseId,
                userId: userId || "",
                section: "social-6",
                timestamp: new Date().toISOString()
            };
        });
        // Vérifier que les données sont correctement formatées
        const isValidData = data.every((item)=>item.question && item.answer && item.category && item.enterpriseId);
        if (!isValidData) {
            console.error("Donn\xe9es invalides:", data);
            setErrorMessage("Format de donn\xe9es invalide");
            setIsLoading(false);
            return;
        }
        // Sauvegarder les données pour une utilisation ultérieure
        s_allData6 = [
            ...data
        ];
        console.log("Donn\xe9es \xe0\xa0 envoyer:", JSON.stringify(data, null, 2));
        // Appel API pour sauvegarder les données
        fetch("/api/api/save-answers", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
            },
            body: JSON.stringify(data)
        }).then((response)=>{
            if (!response.ok) throw new Error(`Erreur de sauvegarde (${response.status})`);
            return response.json();
        }).then((result)=>{
            console.log("Data saved successfully:", result);
            // Sauvegarder le score dans le localStorage
            localStorage.setItem('social6Score', yes_Count6);
            console.log(`Score social6 mis \xe0\xa0 jour: ${yes_Count6}`);
            // Récupérer tous les scores sociaux du localStorage
            const social1Score = parseInt(localStorage.getItem('social1Score') || 0);
            const social2Score = parseInt(localStorage.getItem('social2Score') || 0);
            const social3Score = parseInt(localStorage.getItem('social3Score') || 0);
            const social4Score = parseInt(localStorage.getItem('social4Score') || 0);
            const social5Score = parseInt(localStorage.getItem('social5Score') || 0);
            const social6Score = parseInt(localStorage.getItem('social6Score') || 0);
            // Calculer le score total social
            s_sum = social1Score + social2Score + social3Score + social4Score + social5Score + social6Score;
            console.log("Score total social calcul\xe9:", s_sum);
            console.log("Scores individuels:", {
                social1Score,
                social2Score,
                social3Score,
                social4Score,
                social5Score,
                social6Score
            });
            // Sauvegarder également le score total social final
            const scoreData = [
                {
                    question: "Social Total Score Final",
                    answer: s_sum.toString(),
                    category: "social",
                    enterpriseId: enterpriseId,
                    userId: userId || "",
                    section: "social-total-final",
                    timestamp: new Date().toISOString()
                }
            ];
            console.log("Envoi du score total social:", JSON.stringify(scoreData, null, 2));
            // Appel API pour sauvegarder le score total
            return fetch("/api/api/save-answers", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
                },
                body: JSON.stringify(scoreData)
            });
        }).then((response)=>{
            if (!response || !response.ok) throw new Error("Failed to save total score");
            return response.json();
        }).then((scoreResponse)=>{
            console.log("Score total social enregistr\xe9 avec succ\xe8s:", scoreResponse);
            // Récupérer correctement les données de tous les composants
            const allSocialData = [];
            // Utiliser des try/catch pour éviter les erreurs si certaines données sont manquantes
            try {
                if (Array.isArray((0, _social1.s_allData1)) && (0, _social1.s_allData1).length > 0) allSocialData.push(...(0, _social1.s_allData1));
                if (Array.isArray((0, _social2.s_allData2)) && (0, _social2.s_allData2).length > 0) allSocialData.push(...(0, _social2.s_allData2));
                if (Array.isArray((0, _social3.s_allData3)) && (0, _social3.s_allData3).length > 0) allSocialData.push(...(0, _social3.s_allData3));
                if (Array.isArray((0, _social4.s_allData4)) && (0, _social4.s_allData4).length > 0) allSocialData.push(...(0, _social4.s_allData4));
                if (Array.isArray((0, _social5.s_allData5)) && (0, _social5.s_allData5).length > 0) allSocialData.push(...(0, _social5.s_allData5));
                if (Array.isArray(s_allData6) && s_allData6.length > 0) allSocialData.push(...s_allData6);
            } catch (error) {
                console.error("Erreur lors de la concat\xe9nation des donn\xe9es:", error);
            }
            console.log("Toutes les donn\xe9es sociales pour le PDF:", allSocialData.length, "questions");
            // Générer le PDF avec toutes les données sociales
            generatePdf(allSocialData);
            // Redirection vers la page suivante
            setIsLoading(false);
            history.push("/modernization-1");
        }).catch((error)=>{
            console.error("Error saving data:", error);
            setErrorMessage("Error saving data. Please try again.");
            console.error("D\xe9tails de l'erreur:", error.message);
            // Màªme en cas d'erreur, essayer de générer le PDF avec les données disponibles
            const allSocialData = [];
            try {
                if (Array.isArray((0, _social1.s_allData1)) && (0, _social1.s_allData1).length > 0) allSocialData.push(...(0, _social1.s_allData1));
                if (Array.isArray((0, _social2.s_allData2)) && (0, _social2.s_allData2).length > 0) allSocialData.push(...(0, _social2.s_allData2));
                if (Array.isArray((0, _social3.s_allData3)) && (0, _social3.s_allData3).length > 0) allSocialData.push(...(0, _social3.s_allData3));
                if (Array.isArray((0, _social4.s_allData4)) && (0, _social4.s_allData4).length > 0) allSocialData.push(...(0, _social4.s_allData4));
                if (Array.isArray((0, _social5.s_allData5)) && (0, _social5.s_allData5).length > 0) allSocialData.push(...(0, _social5.s_allData5));
                if (Array.isArray(s_allData6) && s_allData6.length > 0) allSocialData.push(...s_allData6);
            } catch (error) {
                console.error("Erreur lors de la concat\xe9nation des donn\xe9es:", error);
            }
            generatePdf(allSocialData);
            // Continuer quand màªme vers la page suivante en cas d'erreur
            setIsLoading(false);
            history.push("/modernization-1");
        });
    }
    function generatePdf(s_allData) {
        // Vérifier si des données existent
        if (!s_allData || s_allData.length === 0) {
            console.error("Aucune donn\xe9e disponible pour g\xe9n\xe9rer le PDF");
            return;
        }
        console.log("G\xe9n\xe9ration du PDF avec", s_allData.length, "questions");
        // Créer un nouveau document PDF
        const doc = new (0, _jspdfDefault.default)();
        const lineHeight = 10;
        const pageHeight = doc.internal.pageSize.height - 20;
        const pageWidth = doc.internal.pageSize.width - 20;
        let y = 20;
        // Ajouter un titre
        doc.setFontSize(16);
        doc.text("Social Assessment Results", 105, y, {
            align: "center"
        });
        y += 15;
        // Ajouter le score total
        doc.setFontSize(14);
        doc.text(`Total Score: ${s_sum} / ${s_allData.length}`, 105, y, {
            align: "center"
        });
        y += 15;
        doc.setFontSize(12);
        // Parcourir les données dans s_allData et ajouter chaque question et réponse au document PDF
        s_allData.forEach((data, index)=>{
            // Vérifier si les données sont valides
            if (!data || !data.question) {
                console.error("Donn\xe9es invalides pour l'\xe9l\xe9ment", index);
                return;
            }
            const question = `Question ${index + 1}: ${data.question}`;
            const answer = `Answer: ${data.answer || 'No answer'}`;
            // Vérifier si la position y actuelle plus la hauteur de la question dépasse la hauteur maximale de la page
            // Estimer la hauteur du texte après division
            const splitQuestion = doc.splitTextToSize(question, pageWidth);
            const estimatedHeight = splitQuestion.length * lineHeight + lineHeight * 2;
            if (y + estimatedHeight > pageHeight) {
                // Ajouter une nouvelle page et réinitialiser la position y
                doc.addPage();
                y = 20;
            }
            // Séparer la question sur plusieurs lignes si elle est trop longue
            doc.text(splitQuestion, 10, y);
            y += splitQuestion.length * lineHeight;
            doc.text(answer, 10, y);
            y += lineHeight * 2; // Ajouter un peu d'espace entre les questions
        });
        // Ajouter une page de résumé
        doc.addPage();
        y = 20;
        doc.setFontSize(16);
        doc.text("Summary of Social Assessment", 105, y, {
            align: "center"
        });
        y += 20;
        doc.setFontSize(12);
        doc.text(`Total number of questions: ${s_allData.length}`, 10, y);
        y += lineHeight;
        doc.text(`Total "Yes" answers: ${s_sum}`, 10, y);
        y += lineHeight;
        doc.text(`Score percentage: ${Math.round(s_sum / s_allData.length * 100)}%`, 10, y);
        y += lineHeight * 2;
        const date = new Date();
        doc.text(`Generated on: ${date.toLocaleDateString()} at ${date.toLocaleTimeString()}`, 10, y);
        // Enregistrer le document PDF
        doc.save("Social_Assessment_Complete.pdf");
        console.log("PDF g\xe9n\xe9r\xe9 avec succ\xe8s");
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "modernization-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "modernization-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    className: "modernization-title",
                    children: "PLEASE ANSWER THE FOLLOWING QUESTIONS"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "progress-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "progress-bar",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "progress-fill",
                                style: {
                                    width: `${Object.keys(selectedOptions).length / totalQuestions * 100}%`
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "progress-text",
                            children: [
                                "Your score: ",
                                yes_Count6,
                                " / ",
                                totalQuestions,
                                " (",
                                Math.round(yes_Count6 / totalQuestions * 100) || 0,
                                "%)"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questions-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you maintain a high level of safety and physical, mental and social well-being of workers (the notion of worker encompasses all populations of employed workers: company employees, seconded workers, self-employed workers, temporary workers, trainees, apprentices...)?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you maintain a high level of safety and physical, mental and social well-being of workers (the notion of worker encompasses all populations of employed workers: company employees, seconded workers, self-employed workers, temporary workers, trainees, apprentices...)?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you maintain a high level of safety and physical, mental and social well-being of workers (the notion of worker encompasses all populations of employed workers: company employees, seconded workers, self-employed workers, temporary workers, trainees, apprentices...)?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you maintain a high level of safety and physical, mental and social well-being of workers (the notion of worker encompasses all populations of employed workers: company employees, seconded workers, self-employed workers, temporary workers, trainees, apprentices...)?", "No"),
                                            className: `btn-option ${selectedOptions["Do you maintain a high level of safety and physical, mental and social well-being of workers (the notion of worker encompasses all populations of employed workers: company employees, seconded workers, self-employed workers, temporary workers, trainees, apprentices...)?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Are staff trained in occupational health and safety?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Are staff trained in occupational health and safety?", "Yes"),
                                            className: `btn-option ${selectedOptions["Are staff trained in occupational health and safety?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Are staff trained in occupational health and safety?", "No"),
                                            className: `btn-option ${selectedOptions["Are staff trained in occupational health and safety?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Is there a budget for health and safety?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Is there a budget for health and safety?", "Yes"),
                                            className: `btn-option ${selectedOptions["Is there a budget for health and safety?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Is there a budget for health and safety?", "No"),
                                            className: `btn-option ${selectedOptions["Is there a budget for health and safety?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you prevent and protect employees from negative health effects resulting from working conditions?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you prevent and protect employees from negative health effects resulting from working conditions?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you prevent and protect employees from negative health effects resulting from working conditions?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you prevent and protect employees from negative health effects resulting from working conditions?", "No"),
                                            className: `btn-option ${selectedOptions["Do you prevent and protect employees from negative health effects resulting from working conditions?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Are job descriptions provided to prevention workers (good practices, etc.)?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Are job descriptions provided to prevention workers (good practices, etc.)?", "Yes"),
                                            className: `btn-option ${selectedOptions["Are job descriptions provided to prevention workers (good practices, etc.)?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Are job descriptions provided to prevention workers (good practices, etc.)?", "No"),
                                            className: `btn-option ${selectedOptions["Are job descriptions provided to prevention workers (good practices, etc.)?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Percentage of the number of dangerous situations dealt with out of the number of dangerous situations detected"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Percentage of the number of dangerous situations dealt with out of the number of dangerous situations detected", "Yes"),
                                            className: `btn-option ${selectedOptions["Percentage of the number of dangerous situations dealt with out of the number of dangerous situations detected"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Percentage of the number of dangerous situations dealt with out of the number of dangerous situations detected", "No"),
                                            className: `btn-option ${selectedOptions["Percentage of the number of dangerous situations dealt with out of the number of dangerous situations detected"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have a work environment that is adapted to the physiological and psychological needs of workers?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a work environment that is adapted to the physiological and psychological needs of workers?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have a work environment that is adapted to the physiological and psychological needs of workers?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a work environment that is adapted to the physiological and psychological needs of workers?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have a work environment that is adapted to the physiological and psychological needs of workers?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "form-actions",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/social-5",
                            className: "btn-secondary",
                            children: "Back"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "btn-primary",
                            children: "Submit Social Assessment"
                        })
                    ]
                }),
                isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "loading-indicator",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "spinner"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: "Saving data and generating PDF..."
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Social6;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["Link","b9X5n"],["useHistory","ditZI"]],"../NavItems3":"fOarC","../NavItems2":"bnQuI","../Toggle":"dSqDu","./Social6.css":"3A72U","../Social1":"838rz","../Social2":"g4OlW","../Social3":"12PLV","../Social4":"haOmR","../Social5":"iwvBq","jspdf":"hkJ4Q","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3A72U":[function() {},{}],"838rz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "s_allData1", ()=>s_allData1);
parcelHelpers.export(exports, "s_final", ()=>s_final);
parcelHelpers.export(exports, "yes_Count1", ()=>yes_Count1);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _frame113 = require("../Frame113");
var _frame113Default = parcelHelpers.interopDefault(_frame113);
var _frame114 = require("../Frame114");
var _frame114Default = parcelHelpers.interopDefault(_frame114);
var _frame115 = require("../Frame115");
var _frame115Default = parcelHelpers.interopDefault(_frame115);
var _frame116 = require("../Frame116");
var _frame116Default = parcelHelpers.interopDefault(_frame116);
var _frame117 = require("../Frame117");
var _frame117Default = parcelHelpers.interopDefault(_frame117);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _social1Css = require("./Social1.css");
var _styleguideCss = require("../../styleguide.css");
let s_allData1 = [];
let s_final = 0;
let yes_Count1 = 0;
function Social1(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [yesCount1, setYesCount1] = (0, _react.useState)(0); // Initialize yesCount state
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const [isSaving, setIsSaving] = (0, _react.useState)(false);
    const { x1200PxLogo_Icam__20081, pleaseAnswerTheFollowingQuestions, navItems3Props, frame113Props, frame117Props, toggle1Props, toggle2Props, toggle3Props } = props;
    (0, _react.useEffect)(()=>{
        // Calculate the total number of questions based on sections
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []); // Run this effect only once when the component mounts
    function clicked(question, option) {
        // Si l'option cliquée est la màªme que celle déjà  sélectionnée, on la désélectionne
        if (selectedOptions[question] === option) {
            setSelectedOptions((prevSelectedOptions)=>{
                const newOptions = {
                    ...prevSelectedOptions
                };
                delete newOptions[question];
                return newOptions;
            });
            // Si on désélectionne un "Yes", on décrémente le score
            if (option === "Yes") yes_Count1--;
            return;
        }
        // Sinon, on met à  jour la sélection
        const previousOption = selectedOptions[question];
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        // Si on passe de "No" à  "Yes", on incrémente le score
        if (option === "Yes" && previousOption !== "Yes") yes_Count1++;
        else if (option === "No" && previousOption === "Yes") yes_Count1--;
    }
    const history = (0, _reactRouterDom.useHistory)();
    function saveData() {
        setIsSaving(true);
        setErrorMessage("");
        console.log("D\xe9but de sauvegarde des donn\xe9es Social1");
        const enterpriseId = localStorage.getItem("enterpriseId");
        const userId = localStorage.getItem("userId");
        if (!enterpriseId) {
            console.error("ERREUR: ID d'entreprise manquant");
            setErrorMessage("ID d'entreprise manquant. Veuillez retourner \xe0\xa0 la s\xe9lection d'entreprise.");
            setIsSaving(false);
            return;
        }
        // Définir toutes les questions possibles
        const allQuestions = [
            "Do you limit any type of discrimination between employees, in order to ensure equal opportunities and equal treatment, especially for men and women?",
            "Do you have a percentage of incidents of discrimination that have been remedied?",
            "Do you make efforts to recruit people with disabilities?"
        ];
        // Créer un tableau de questions/réponses pour toutes les questions
        const data = allQuestions.map((question)=>{
            const answer = selectedOptions[question] || "No";
            return {
                question: question,
                answer: answer,
                category: "social",
                enterpriseId: enterpriseId,
                userId: userId || "",
                section: "social-1",
                timestamp: new Date().toISOString()
            };
        });
        // Vérifier que les données sont correctement formatées
        const isValidData = data.every((item)=>item.question && item.answer && item.category && item.enterpriseId);
        if (!isValidData) {
            console.error("Donn\xe9es invalides:", data);
            setErrorMessage("Format de donn\xe9es invalide");
            setIsSaving(false);
            return;
        }
        // Sauvegarder les données pour une utilisation ultérieure
        s_allData1 = [
            ...data
        ];
        console.log("Donn\xe9es \xe0\xa0 envoyer:", JSON.stringify(data, null, 2));
        // Appel API pour sauvegarder les données
        fetch("/api/api/save-answers", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
            },
            body: JSON.stringify(data)
        }).then((response)=>{
            if (!response.ok) throw new Error(`Erreur de sauvegarde (${response.status})`);
            return response.json();
        }).then((result)=>{
            console.log("Data saved successfully:", result);
            // Sauvegarder le score dans le localStorage
            localStorage.setItem('social1Score', yes_Count1);
            console.log(`Score social1 mis \xe0\xa0 jour: ${yes_Count1}`);
            setIsSaving(false);
            history.push("/social-2");
        }).catch((error)=>{
            console.error("Error saving data:", error);
            setErrorMessage("Error saving data. Please try again.");
            console.error("D\xe9tails de l'erreur:", error.message);
            setIsSaving(false);
            history.push("/social-2");
        });
    }
    function calculateProgressPercentage() {
        const totalQuestions = document.getElementsByTagName("section").length;
        if (totalQuestions === 0) return 0;
        return Math.round(yes_Count1 / totalQuestions * 100);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "environmental-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "environmental-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    className: "environmental-title",
                    children: "PLEASE ANSWER THE FOLLOWING QUESTIONS"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "progress-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "progress-bar",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "progress-fill",
                                style: {
                                    width: `${calculateProgressPercentage()}%`
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "progress-text",
                            children: [
                                "Your score: ",
                                yes_Count1,
                                " / ",
                                totalQuestions,
                                " (",
                                calculateProgressPercentage(),
                                "%)"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questions-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you limit any type of discrimination between employees, in order to ensure equal opportunities and equal treatment, especially for men and women?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you limit any type of discrimination between employees, in order to ensure equal opportunities and equal treatment, especially for men and women?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you limit any type of discrimination between employees, in order to ensure equal opportunities and equal treatment, especially for men and women?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you limit any type of discrimination between employees, in order to ensure equal opportunities and equal treatment, especially for men and women?", "No"),
                                            className: `btn-option ${selectedOptions["Do you limit any type of discrimination between employees, in order to ensure equal opportunities and equal treatment, especially for men and women?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have a percentage of incidents of discrimination that have been remedied?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a percentage of incidents of discrimination that have been remedied?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have a percentage of incidents of discrimination that have been remedied?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a percentage of incidents of discrimination that have been remedied?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have a percentage of incidents of discrimination that have been remedied?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you manage your employees' diversity of ages, gender, and nationality?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you manage your employees' diversity of ages, gender, and nationality?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you manage your employees' diversity of ages, gender, and nationality?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you manage your employees' diversity of ages, gender, and nationality?", "No"),
                                            className: `btn-option ${selectedOptions["Do you manage your employees' diversity of ages, gender, and nationality?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "form-actions",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/environmental-5",
                            className: "btn-secondary",
                            children: "Back"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "btn-primary",
                            children: "Continue to Next Section"
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Social1;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["Link","b9X5n"],["useHistory","ditZI"]],"../NavItems3":"fOarC","../Frame113":"l7UEw","../Frame114":"aUtEd","../Frame115":"gPV9Y","../Frame116":"70lZ5","../Frame117":"ijwBg","../Toggle":"dSqDu","./Social1.css":"6uCkj","../../styleguide.css":"8Y7Ec","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6uCkj":[function() {},{}],"8Y7Ec":[function() {},{}],"g4OlW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "s_allData2", ()=>s_allData2);
parcelHelpers.export(exports, "yes_Count2", ()=>yes_Count2);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _social2Css = require("./Social2.css");
var _styleguideCss = require("../../styleguide.css");
let s_allData2 = [];
let yes_Count2 = 0;
function Social2(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [yesCount2, setYesCount2] = (0, _react.useState)(0); // Initialize yesCount state
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const [isLoading, setIsLoading] = (0, _react.useState)(false); // Déplacé ici depuis saveData
    const { x1200PxLogo_Icam__20081, navItems3Props, toggle1Props, toggle2Props } = props;
    (0, _react.useEffect)(()=>{
        // Calculate the total number of questions based on sections
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []); // Run this effect only once when the component mounts
    function clicked(question, option) {
        // Si l'option cliquée est la màªme que celle déjà  sélectionnée, on la désélectionne
        if (selectedOptions[question] === option) {
            setSelectedOptions((prevSelectedOptions)=>{
                const newOptions = {
                    ...prevSelectedOptions
                };
                delete newOptions[question];
                return newOptions;
            });
            // Si on désélectionne un "Yes", on décrémente le score
            if (option === "Yes") yes_Count2--;
            return;
        }
        // Sinon, on met à  jour la sélection
        const previousOption = selectedOptions[question];
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        // Si on passe de "No" à  "Yes", on incrémente le score
        if (option === "Yes" && previousOption !== "Yes") yes_Count2++;
        else if (option === "No" && previousOption === "Yes") yes_Count2--;
    }
    const history = (0, _reactRouterDom.useHistory)();
    function saveData() {
        setErrorMessage("");
        setIsLoading(true);
        console.log("D\xe9but de sauvegarde des donn\xe9es Social2");
        const enterpriseId = localStorage.getItem("enterpriseId");
        const userId = localStorage.getItem("userId");
        if (!enterpriseId) {
            console.error("ERREUR: ID d'entreprise manquant");
            setErrorMessage("ID d'entreprise manquant. Veuillez retourner \xe0\xa0 la s\xe9lection d'entreprise.");
            setIsLoading(false);
            return;
        }
        // Définir toutes les questions possibles
        const allQuestions = [
            "Do you promote stability of employment, and therefore of employment contracts?",
            "Do you prefer to hire permanent employees?",
            "Do you have a high employee turnover rate?",
            "Do you have a percentage of incidents related to freedom of association that have been resolved?"
        ];
        // Créer un tableau de questions/réponses pour toutes les questions
        const data = allQuestions.map((question)=>{
            const answer = selectedOptions[question] || "No";
            return {
                question: question,
                answer: answer,
                category: "social",
                enterpriseId: enterpriseId,
                userId: userId || "",
                section: "social-2",
                timestamp: new Date().toISOString()
            };
        });
        // Vérifier que les données sont correctement formatées
        const isValidData = data.every((item)=>item.question && item.answer && item.category && item.enterpriseId);
        if (!isValidData) {
            console.error("Donn\xe9es invalides:", data);
            setErrorMessage("Format de donn\xe9es invalide");
            setIsLoading(false);
            return;
        }
        // Sauvegarder les données pour une utilisation ultérieure
        s_allData2 = [
            ...data
        ];
        console.log("Donn\xe9es \xe0\xa0 envoyer:", JSON.stringify(data, null, 2));
        // Appel API pour sauvegarder les données
        fetch("/api/api/save-answers", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
            },
            body: JSON.stringify(data)
        }).then((response)=>{
            if (!response.ok) throw new Error(`Erreur de sauvegarde (${response.status})`);
            return response.json();
        }).then((result)=>{
            console.log("Data saved successfully:", result);
            // Sauvegarder le score dans le localStorage
            localStorage.setItem('social2Score', yes_Count2);
            console.log(`Score social2 mis \xe0\xa0 jour: ${yes_Count2}`);
            setIsLoading(false);
            history.push("/social-3");
        }).catch((error)=>{
            console.error("Error saving data:", error);
            setErrorMessage("Error saving data. Please try again.");
            console.error("D\xe9tails de l'erreur:", error.message);
            setIsLoading(false);
            history.push("/social-3");
        });
    }
    function calculateProgressPercentage() {
        const totalQuestions = document.getElementsByTagName("section").length;
        if (totalQuestions === 0) return 0;
        return Math.round(yes_Count2 / totalQuestions * 100);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "environmental-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "environmental-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    className: "environmental-title",
                    children: "PLEASE ANSWER THE FOLLOWING QUESTIONS"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "progress-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "progress-bar",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "progress-fill",
                                style: {
                                    width: `${calculateProgressPercentage()}%`
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "progress-text",
                            children: [
                                "Your score: ",
                                yes_Count2,
                                " / ",
                                totalQuestions,
                                " (",
                                calculateProgressPercentage(),
                                "%)"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questions-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you promote stability of employment, and therefore of employment contracts?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you promote stability of employment, and therefore of employment contracts?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you promote stability of employment, and therefore of employment contracts?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you promote stability of employment, and therefore of employment contracts?", "No"),
                                            className: `btn-option ${selectedOptions["Do you promote stability of employment, and therefore of employment contracts?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you prefer to hire permanent employees?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you prefer to hire permanent employees?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you prefer to hire permanent employees?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you prefer to hire permanent employees?", "No"),
                                            className: `btn-option ${selectedOptions["Do you prefer to hire permanent employees?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have a high employee turnover rate?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a high employee turnover rate?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have a high employee turnover rate?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a high employee turnover rate?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have a high employee turnover rate?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have a percentage of incidents related to freedom of association that have been resolved?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a percentage of incidents related to freedom of association that have been resolved?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have a percentage of incidents related to freedom of association that have been resolved?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a percentage of incidents related to freedom of association that have been resolved?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have a percentage of incidents related to freedom of association that have been resolved?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "form-actions",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/social-1",
                            className: "btn-secondary",
                            children: "Back"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "btn-primary",
                            children: "Next"
                        })
                    ]
                }),
                isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "loading-indicator",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "spinner"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: "Saving data..."
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Social2;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["Link","b9X5n"],["useHistory","ditZI"]],"../NavItems3":"fOarC","../NavItems2":"bnQuI","../Toggle":"dSqDu","./Social2.css":"7g3pT","../../styleguide.css":"8Y7Ec","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7g3pT":[function() {},{}],"8Y7Ec":[function() {},{}],"12PLV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "s_allData3", ()=>s_allData3);
parcelHelpers.export(exports, "yes_Count3", ()=>yes_Count3);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _social3Css = require("./Social3.css");
var _styleguideCss = require("../../styleguide.css");
var _social1 = require("../Social1");
var _social2 = require("../Social2");
let s_allData3 = [];
let yes_Count3 = 0;
function Social3(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [yesCount3, setYesCount3] = (0, _react.useState)(0); // Initialize yesCount state
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const [isLoading, setIsLoading] = (0, _react.useState)(false); // Déplacé ici depuis saveData
    const { x1200PxLogo_Icam__20081, navItems3Props, toggle1Props, toggle2Props, toggle3Props } = props;
    (0, _react.useEffect)(()=>{
        // Calculate the total number of questions based on sections
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []); // Run this effect only once when the component mounts
    function clicked(question, option) {
        // Si l'option cliquée est la màªme que celle déjà  sélectionnée, on la désélectionne
        if (selectedOptions[question] === option) {
            setSelectedOptions((prevSelectedOptions)=>{
                const newOptions = {
                    ...prevSelectedOptions
                };
                delete newOptions[question];
                return newOptions;
            });
            // Si on désélectionne un "Yes", on décrémente le score
            if (option === "Yes") yes_Count3--;
            return;
        }
        // Sinon, on met à  jour la sélection
        const previousOption = selectedOptions[question];
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        // Si on passe de "No" à  "Yes", on incrémente le score
        if (option === "Yes" && previousOption !== "Yes") yes_Count3++;
        else if (option === "No" && previousOption === "Yes") yes_Count3--;
    }
    const history = (0, _reactRouterDom.useHistory)();
    function saveData() {
        setErrorMessage("");
        setIsLoading(true);
        console.log("D\xe9but de sauvegarde des donn\xe9es Social3");
        const enterpriseId = localStorage.getItem("enterpriseId");
        const userId = localStorage.getItem("userId");
        if (!enterpriseId) {
            console.error("ERREUR: ID d'entreprise manquant");
            setErrorMessage("ID d'entreprise manquant. Veuillez retourner \xe0\xa0 la s\xe9lection d'entreprise.");
            setIsLoading(false);
            return;
        }
        // Définir toutes les questions possibles
        const allQuestions = [
            "Do you comply with the fundamental principles of the International Labour Organisation?",
            "Have you conducted employee surveys on the collective agreement?",
            "Does the work performed respect the legal framework of the employment contract?",
            "Do you have a policy against child labor in your organization?",
            "Do you have a policy against forced labor in your organization?"
        ];
        // Créer un tableau de questions/réponses pour toutes les questions
        const data = allQuestions.map((question)=>{
            const answer = selectedOptions[question] || "No";
            return {
                question: question,
                answer: answer,
                category: "social",
                enterpriseId: enterpriseId,
                userId: userId || "",
                section: "social-3",
                timestamp: new Date().toISOString()
            };
        });
        // Vérifier que les données sont correctement formatées
        const isValidData = data.every((item)=>item.question && item.answer && item.category && item.enterpriseId);
        if (!isValidData) {
            console.error("Donn\xe9es invalides:", data);
            setErrorMessage("Format de donn\xe9es invalide");
            setIsLoading(false);
            return;
        }
        // Sauvegarder les données pour une utilisation ultérieure
        s_allData3 = [
            ...data
        ];
        console.log("Donn\xe9es \xe0\xa0 envoyer:", JSON.stringify(data, null, 2));
        // Appel API pour sauvegarder les données
        fetch("/api/api/save-answers", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
            },
            body: JSON.stringify(data)
        }).then((response)=>{
            if (!response.ok) throw new Error(`Erreur de sauvegarde (${response.status})`);
            return response.json();
        }).then((result)=>{
            console.log("Data saved successfully:", result);
            // Sauvegarder le score dans le localStorage
            localStorage.setItem('social3Score', yes_Count3);
            console.log(`Score social3 mis \xe0\xa0 jour: ${yes_Count3}`);
            setIsLoading(false);
            history.push("/social-4");
        }).catch((error)=>{
            console.error("Error saving data:", error);
            setErrorMessage("Error saving data. Please try again.");
            console.error("D\xe9tails de l'erreur:", error.message);
            setIsLoading(false);
            history.push("/social-4");
        });
    }
    function calculateProgressPercentage() {
        const totalQuestions = document.getElementsByTagName("section").length;
        if (totalQuestions === 0) return 0;
        return Math.round(yes_Count3 / totalQuestions * 100);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "environmental-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "environmental-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    className: "environmental-title",
                    children: "PLEASE ANSWER THE FOLLOWING QUESTIONS"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "progress-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "progress-bar",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "progress-fill",
                                style: {
                                    width: `${calculateProgressPercentage()}%`
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "progress-text",
                            children: [
                                "Your score: ",
                                yes_Count3,
                                " / ",
                                totalQuestions,
                                " (",
                                calculateProgressPercentage(),
                                "%)"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questions-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you comply with the fundamental principles of the International Labour Organisation?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you comply with the fundamental principles of the International Labour Organisation?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you comply with the fundamental principles of the International Labour Organisation?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you comply with the fundamental principles of the International Labour Organisation?", "No"),
                                            className: `btn-option ${selectedOptions["Do you comply with the fundamental principles of the International Labour Organisation?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Have you conducted employee surveys on the collective agreement?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Have you conducted employee surveys on the collective agreement?", "Yes"),
                                            className: `btn-option ${selectedOptions["Have you conducted employee surveys on the collective agreement?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Have you conducted employee surveys on the collective agreement?", "No"),
                                            className: `btn-option ${selectedOptions["Have you conducted employee surveys on the collective agreement?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Does the work performed respect the legal framework of the employment contract?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Does the work performed respect the legal framework of the employment contract?", "Yes"),
                                            className: `btn-option ${selectedOptions["Does the work performed respect the legal framework of the employment contract?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Does the work performed respect the legal framework of the employment contract?", "No"),
                                            className: `btn-option ${selectedOptions["Does the work performed respect the legal framework of the employment contract?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have a policy against child labor in your organization?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a policy against child labor in your organization?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have a policy against child labor in your organization?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a policy against child labor in your organization?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have a policy against child labor in your organization?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have a policy against forced labor in your organization?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a policy against forced labor in your organization?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have a policy against forced labor in your organization?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a policy against forced labor in your organization?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have a policy against forced labor in your organization?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "form-actions",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/social-2",
                            className: "btn-secondary",
                            children: "Back"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "btn-primary",
                            children: "Next"
                        })
                    ]
                }),
                isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "loading-indicator",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "spinner"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: "Saving data..."
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Social3;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["Link","b9X5n"],["useHistory","ditZI"]],"../NavItems3":"fOarC","../NavItems2":"bnQuI","../Toggle":"dSqDu","./Social3.css":"8F5fB","../../styleguide.css":"8Y7Ec","../Social1":"838rz","../Social2":"g4OlW","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8F5fB":[function() {},{}],"8Y7Ec":[function() {},{}],"haOmR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "s_allData4", ()=>s_allData4);
parcelHelpers.export(exports, "yes_Count4", ()=>yes_Count4);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _social4Css = require("./Social4.css");
var _styleguideCss = require("../../styleguide.css");
var _social1 = require("../Social1");
var _social2 = require("../Social2");
var _social3 = require("../Social3");
let s_allData4 = [];
let yes_Count4 = 0;
function Social4(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [yesCount4, setYesCount4] = (0, _react.useState)(0); // Initialize yesCount state
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const [isLoading, setIsLoading] = (0, _react.useState)(false); // Déplacé ici depuis saveData
    const { x1200PxLogo_Icam__20081, navItems3Props, toggle1Props, toggle2Props, toggle3Props, toggle4Props } = props;
    (0, _react.useEffect)(()=>{
        // Calculate the total number of questions based on sections
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []); // Run this effect only once when the component mounts
    function clicked(question, option) {
        // Si l'option cliquée est la màªme que celle déjà  sélectionnée, on la désélectionne
        if (selectedOptions[question] === option) {
            setSelectedOptions((prevSelectedOptions)=>{
                const newOptions = {
                    ...prevSelectedOptions
                };
                delete newOptions[question];
                return newOptions;
            });
            // Si on désélectionne un "Yes", on décrémente le score
            if (option === "Yes") yes_Count4--;
            return;
        }
        // Sinon, on met à  jour la sélection
        const previousOption = selectedOptions[question];
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        // Si on passe de "No" à  "Yes", on incrémente le score
        if (option === "Yes" && previousOption !== "Yes") yes_Count4++;
        else if (option === "No" && previousOption === "Yes") yes_Count4--;
    }
    const history = (0, _reactRouterDom.useHistory)();
    function saveData() {
        setErrorMessage("");
        setIsLoading(true);
        console.log("D\xe9but de sauvegarde des donn\xe9es Social4");
        const enterpriseId = localStorage.getItem("enterpriseId");
        const userId = localStorage.getItem("userId");
        if (!enterpriseId) {
            console.error("ERREUR: ID d'entreprise manquant");
            setErrorMessage("ID d'entreprise manquant. Veuillez retourner \xe0\xa0 la s\xe9lection d'entreprise.");
            setIsLoading(false);
            return;
        }
        // Définir toutes les questions possibles
        const allQuestions = [
            "Do you have an occupational health and safety policy?",
            "Do you implement actions to prevent occupational accidents and diseases?",
            "Do you track your workplace accident rate?",
            "Do you track your occupational disease rate?",
            "Do you provide health and safety training to your employees?"
        ];
        // Créer un tableau de questions/réponses pour toutes les questions
        const data = allQuestions.map((question)=>{
            const answer = selectedOptions[question] || "No";
            return {
                question: question,
                answer: answer,
                category: "social",
                enterpriseId: enterpriseId,
                userId: userId || "",
                section: "social-4",
                timestamp: new Date().toISOString()
            };
        });
        // Vérifier que les données sont correctement formatées
        const isValidData = data.every((item)=>item.question && item.answer && item.category && item.enterpriseId);
        if (!isValidData) {
            console.error("Donn\xe9es invalides:", data);
            setErrorMessage("Format de donn\xe9es invalide");
            setIsLoading(false);
            return;
        }
        // Sauvegarder les données pour une utilisation ultérieure
        s_allData4 = [
            ...data
        ];
        console.log("Donn\xe9es \xe0\xa0 envoyer:", JSON.stringify(data, null, 2));
        // Appel API pour sauvegarder les données
        fetch("/api/api/save-answers", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
            },
            body: JSON.stringify(data)
        }).then((response)=>{
            if (!response.ok) throw new Error(`Erreur de sauvegarde (${response.status})`);
            return response.json();
        }).then((result)=>{
            console.log("Data saved successfully:", result);
            // Sauvegarder le score dans le localStorage
            localStorage.setItem('social4Score', yes_Count4);
            console.log(`Score social4 mis \xe0\xa0 jour: ${yes_Count4}`);
            setIsLoading(false);
            history.push("/social-5");
        }).catch((error)=>{
            console.error("Error saving data:", error);
            setErrorMessage("Error saving data. Please try again.");
            console.error("D\xe9tails de l'erreur:", error.message);
            setIsLoading(false);
            history.push("/social-5");
        });
    }
    function calculateProgressPercentage() {
        const totalQuestions = document.getElementsByTagName("section").length;
        if (totalQuestions === 0) return 0;
        return Math.round(yes_Count4 / totalQuestions * 100);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "environmental-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "environmental-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    className: "environmental-title",
                    children: "PLEASE ANSWER THE FOLLOWING QUESTIONS"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "progress-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "progress-bar",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "progress-fill",
                                style: {
                                    width: `${calculateProgressPercentage()}%`
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "progress-text",
                            children: [
                                "Your score: ",
                                yes_Count4,
                                " / ",
                                totalQuestions,
                                " (",
                                calculateProgressPercentage(),
                                "%)"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questions-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have an occupational health and safety policy?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have an occupational health and safety policy?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have an occupational health and safety policy?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have an occupational health and safety policy?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have an occupational health and safety policy?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you implement actions to prevent occupational accidents and diseases?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you implement actions to prevent occupational accidents and diseases?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you implement actions to prevent occupational accidents and diseases?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you implement actions to prevent occupational accidents and diseases?", "No"),
                                            className: `btn-option ${selectedOptions["Do you implement actions to prevent occupational accidents and diseases?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you track your workplace accident rate?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you track your workplace accident rate?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you track your workplace accident rate?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you track your workplace accident rate?", "No"),
                                            className: `btn-option ${selectedOptions["Do you track your workplace accident rate?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you track your occupational disease rate?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you track your occupational disease rate?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you track your occupational disease rate?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you track your occupational disease rate?", "No"),
                                            className: `btn-option ${selectedOptions["Do you track your occupational disease rate?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you provide health and safety training to your employees?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you provide health and safety training to your employees?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you provide health and safety training to your employees?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you provide health and safety training to your employees?", "No"),
                                            className: `btn-option ${selectedOptions["Do you provide health and safety training to your employees?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "form-actions",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/social-3",
                            className: "btn-secondary",
                            children: "Back"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "btn-primary",
                            children: "Next"
                        })
                    ]
                }),
                isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "loading-indicator",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "spinner"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: "Saving data..."
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Social4;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["Link","b9X5n"],["useHistory","ditZI"]],"../NavItems3":"fOarC","../NavItems2":"bnQuI","../Toggle":"dSqDu","./Social4.css":"4lEwY","../../styleguide.css":"8Y7Ec","../Social1":"838rz","../Social2":"g4OlW","../Social3":"12PLV","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4lEwY":[function() {},{}],"8Y7Ec":[function() {},{}],"iwvBq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "s_allData5", ()=>s_allData5);
parcelHelpers.export(exports, "yes_Count5", ()=>yes_Count5);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _social5Css = require("./Social5.css");
var _styleguideCss = require("../../styleguide.css");
var _social1 = require("../Social1");
var _social2 = require("../Social2");
var _social3 = require("../Social3");
var _social4 = require("../Social4");
let s_allData5 = [];
let yes_Count5 = 0;
function Social5(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [yesCount5, setYesCount5] = (0, _react.useState)(0); // Initialize yesCount state
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const [isLoading, setIsLoading] = (0, _react.useState)(false); // Déplacé ici depuis saveData
    const { x1200PxLogo_Icam__20081, navItems3Props, toggle1Props, toggle2Props, toggle3Props, toggle4Props } = props;
    (0, _react.useEffect)(()=>{
        // Calculate the total number of questions based on sections
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []); // Run this effect only once when the component mounts
    function clicked(question, option) {
        // Si l'option cliquée est la màªme que celle déjà  sélectionnée, on la désélectionne
        if (selectedOptions[question] === option) {
            setSelectedOptions((prevSelectedOptions)=>{
                const newOptions = {
                    ...prevSelectedOptions
                };
                delete newOptions[question];
                return newOptions;
            });
            // Si on désélectionne un "Yes", on décrémente le score
            if (option === "Yes") yes_Count5--;
            return;
        }
        // Sinon, on met à  jour la sélection
        const previousOption = selectedOptions[question];
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        // Si on passe de "No" à  "Yes", on incrémente le score
        if (option === "Yes" && previousOption !== "Yes") yes_Count5++;
        else if (option === "No" && previousOption === "Yes") yes_Count5--;
    }
    const history = (0, _reactRouterDom.useHistory)();
    function saveData() {
        setErrorMessage("");
        setIsLoading(true);
        console.log("D\xe9but de sauvegarde des donn\xe9es Social5");
        const enterpriseId = localStorage.getItem("enterpriseId");
        const userId = localStorage.getItem("userId");
        if (!enterpriseId) {
            console.error("ERREUR: ID d'entreprise manquant");
            setErrorMessage("ID d'entreprise manquant. Veuillez retourner \xe0\xa0 la s\xe9lection d'entreprise.");
            setIsLoading(false);
            return;
        }
        // Définir toutes les questions possibles
        const allQuestions = [
            "Do you provide employee training opportunities?",
            "Do you have a career development program for your employees?",
            "Do you track employee skills development?",
            "Do you have measures to promote employee well-being?",
            "Do you conduct regular employee satisfaction surveys?"
        ];
        // Créer un tableau de questions/réponses pour toutes les questions
        const data = allQuestions.map((question)=>{
            const answer = selectedOptions[question] || "No";
            return {
                question: question,
                answer: answer,
                category: "social",
                enterpriseId: enterpriseId,
                userId: userId || "",
                section: "social-5",
                timestamp: new Date().toISOString()
            };
        });
        // Vérifier que les données sont correctement formatées
        const isValidData = data.every((item)=>item.question && item.answer && item.category && item.enterpriseId);
        if (!isValidData) {
            console.error("Donn\xe9es invalides:", data);
            setErrorMessage("Format de donn\xe9es invalide");
            setIsLoading(false);
            return;
        }
        // Sauvegarder les données pour une utilisation ultérieure
        s_allData5 = [
            ...data
        ];
        console.log("Donn\xe9es \xe0\xa0 envoyer:", JSON.stringify(data, null, 2));
        // Appel API pour sauvegarder les données
        fetch("/api/api/save-answers", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
            },
            body: JSON.stringify(data)
        }).then((response)=>{
            if (!response.ok) throw new Error(`Erreur de sauvegarde (${response.status})`);
            return response.json();
        }).then((result)=>{
            console.log("Data saved successfully:", result);
            // Sauvegarder le score dans le localStorage
            localStorage.setItem('social5Score', yes_Count5);
            console.log(`Score social5 mis \xe0\xa0 jour: ${yes_Count5}`);
            setIsLoading(false);
            history.push("/social-6");
        }).catch((error)=>{
            console.error("Error saving data:", error);
            setErrorMessage("Error saving data. Please try again.");
            console.error("D\xe9tails de l'erreur:", error.message);
            setIsLoading(false);
            history.push("/social-6");
        });
    }
    function calculateProgressPercentage() {
        const totalQuestions = document.getElementsByTagName("section").length;
        if (totalQuestions === 0) return 0;
        return Math.round(yes_Count5 / totalQuestions * 100);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "environmental-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "environmental-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    className: "environmental-title",
                    children: "PLEASE ANSWER THE FOLLOWING QUESTIONS"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "progress-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "progress-bar",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "progress-fill",
                                style: {
                                    width: `${calculateProgressPercentage()}%`
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "progress-text",
                            children: [
                                "Your score: ",
                                yes_Count5,
                                " / ",
                                totalQuestions,
                                " (",
                                calculateProgressPercentage(),
                                "%)"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questions-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you provide employee training opportunities?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you provide employee training opportunities?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you provide employee training opportunities?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you provide employee training opportunities?", "No"),
                                            className: `btn-option ${selectedOptions["Do you provide employee training opportunities?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have a career development program for your employees?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a career development program for your employees?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have a career development program for your employees?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a career development program for your employees?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have a career development program for your employees?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you track employee skills development?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you track employee skills development?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you track employee skills development?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you track employee skills development?", "No"),
                                            className: `btn-option ${selectedOptions["Do you track employee skills development?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have measures to promote employee well-being?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have measures to promote employee well-being?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have measures to promote employee well-being?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have measures to promote employee well-being?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have measures to promote employee well-being?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you conduct regular employee satisfaction surveys?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you conduct regular employee satisfaction surveys?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you conduct regular employee satisfaction surveys?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you conduct regular employee satisfaction surveys?", "No"),
                                            className: `btn-option ${selectedOptions["Do you conduct regular employee satisfaction surveys?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "form-actions",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/social-4",
                            className: "btn-secondary",
                            children: "Back"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "btn-primary",
                            children: "Next"
                        })
                    ]
                }),
                isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "loading-indicator",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "spinner"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: "Saving data..."
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Social5;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["Link","b9X5n"],["useHistory","ditZI"]],"../NavItems3":"fOarC","../NavItems2":"bnQuI","../Toggle":"dSqDu","./Social5.css":"f1Afh","../../styleguide.css":"8Y7Ec","../Social1":"838rz","../Social2":"g4OlW","../Social3":"12PLV","../Social4":"haOmR","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"f1Afh":[function() {},{}],"8Y7Ec":[function() {},{}],"leUWw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "e_sum", ()=>e_sum);
parcelHelpers.export(exports, "yes_Count5", ()=>yes_Count5);
parcelHelpers.export(exports, "e_yesCount5", ()=>e_yesCount5);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _environmental5Css = require("./Environmental5.css");
var _styleguideCss = require("../../styleguide.css");
var _jspdf = require("jspdf");
var _jspdfDefault = parcelHelpers.interopDefault(_jspdf);
var _environmental1 = require("../Environmental1");
var _environmental2 = require("../Environmental2");
var _environmental3 = require("../Environmental3");
var _environmental4 = require("../Environmental4");
let e_sum = 0;
let yes_Count5 = 0;
let e_yesCount5 = 0;
function Environmental5(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [yesCount5, setYesCount5] = (0, _react.useState)(0); // Initialize yesCount state
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const [isLoading, setIsLoading] = (0, _react.useState)(false); // Ajout de l'état isLoading manquant
    const { x1200PxLogo_Icam__20082, socialCriteria, navItems3Props, toggle1Props, toggle2Props, toggle3Props } = props;
    (0, _react.useEffect)(()=>{
        // Calculate the total number of questions based on sections
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []); // Run this effect only once when the component mounts
    //let e_yesCount5 = 0;
    function clicked(question, option) {
        // Si l'option cliquée est la màªme que celle déjà  sélectionnée, on la désélectionne
        if (selectedOptions[question] === option) {
            setSelectedOptions((prevSelectedOptions)=>{
                const newOptions = {
                    ...prevSelectedOptions
                };
                delete newOptions[question];
                return newOptions;
            });
            // Si on désélectionne un "Yes", on décrémente le score
            if (option === "Yes") {
                e_yesCount5--;
                yes_Count5 = e_yesCount5; // Synchroniser les deux variables
            }
            return;
        }
        // Sinon, on met à  jour la sélection
        const previousOption = selectedOptions[question];
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        // Si on passe de "No" à  "Yes", on incrémente le score
        if (option === "Yes" && previousOption !== "Yes") {
            e_yesCount5++;
            yes_Count5 = e_yesCount5; // Synchroniser les deux variables
        } else if (option === "No" && previousOption === "Yes") {
            e_yesCount5--;
            yes_Count5 = e_yesCount5; // Synchroniser les deux variables
        }
    }
    const history = (0, _reactRouterDom.useHistory)();
    let e_allData5 = [];
    function saveData() {
        setIsLoading(true);
        setErrorMessage("");
        console.log("D\xe9but de sauvegarde des donn\xe9es Environmental5");
        const enterpriseId = localStorage.getItem("enterpriseId");
        const userId = localStorage.getItem("userId");
        if (!enterpriseId) {
            console.error("ERREUR: ID d'entreprise manquant");
            setErrorMessage("ID d'entreprise manquant. Veuillez retourner \xe0\xa0 la s\xe9lection d'entreprise.");
            setIsLoading(false);
            return;
        }
        // Définir toutes les questions possibles pour Environmental5
        const allQuestions = [
            "Are you implementing environmental management tools?",
            "Do you have environmental certifications?",
            "Have you had environmental non-compliance issues in the past 3 years?",
            "Have you communicated with your community about potential negative impacts of your activities?",
            "Do you communicate about environmental issues with your suppliers?"
        ];
        // Créer un tableau de questions/réponses pour toutes les questions
        const data = allQuestions.map((question)=>{
            const answer = selectedOptions[question] || "No";
            return {
                question: question,
                answer: answer,
                category: "environmental",
                enterpriseId: enterpriseId,
                userId: userId || "",
                section: "environmental-5",
                timestamp: new Date().toISOString()
            };
        });
        // Vérifier que les données sont correctement formatées
        const isValidData = data.every((item)=>item.question && item.answer && item.category && item.enterpriseId);
        if (!isValidData) {
            console.error("Donn\xe9es invalides:", data);
            setErrorMessage("Format de donn\xe9es invalide");
            setIsLoading(false);
            return;
        }
        e_allData5 = [
            ...data
        ]; // Sauvegarder les données pour le PDF
        console.log("Donn\xe9es \xe0\xa0 envoyer:", JSON.stringify(data, null, 2));
        // Appel API pour sauvegarder les données
        fetch("/api/api/save-answers", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
            },
            body: JSON.stringify(data)
        }).then((response)=>{
            if (!response.ok) throw new Error(`Erreur de sauvegarde (${response.status})`);
            return response.json();
        }).then((result)=>{
            console.log("Data saved successfully:", result);
            // Calculer le score total environnemental
            e_sum = (0, _environmental1.yes_Count1) + (0, _environmental2.yes_Count2) + (0, _environmental3.yes_Count3) + (0, _environmental4.yes_Count4) + yes_Count5;
            console.log("Score total environnemental calcul\xe9:", e_sum);
            // Sauvegarder le score dans le localStorage
            localStorage.setItem('environmental5Score', yes_Count5);
            console.log(`Score environmental5 mis \xe0\xa0 jour: ${yes_Count5}`);
            // Sauvegarder le score total environnemental
            const scoreData = [
                {
                    question: "Environmental Total Score",
                    answer: e_sum.toString(),
                    category: "environmental",
                    enterpriseId: enterpriseId,
                    userId: userId || "",
                    section: "environmental-total",
                    timestamp: new Date().toISOString()
                }
            ];
            console.log("Envoi du score total:", JSON.stringify(scoreData, null, 2));
            // Appel API pour sauvegarder le score total
            return fetch("/api/api/save-answers", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
                },
                body: JSON.stringify(scoreData)
            });
        }).then((response)=>{
            if (!response || !response.ok) throw new Error("Failed to save total score");
            return response.json();
        }).then((scoreResponse)=>{
            console.log("Score total enregistr\xe9 avec succ\xe8s:", scoreResponse);
            // Récupérer correctement les données de tous les composants
            const allEnvironmentalData = [];
            // Utiliser des try/catch pour éviter les erreurs si certaines données sont manquantes
            try {
                if (Array.isArray((0, _environmental1.e_allData1)) && (0, _environmental1.e_allData1).length > 0) allEnvironmentalData.push(...(0, _environmental1.e_allData1));
                if (Array.isArray((0, _environmental2.e_allData2)) && (0, _environmental2.e_allData2).length > 0) allEnvironmentalData.push(...(0, _environmental2.e_allData2));
                if (Array.isArray((0, _environmental3.e_allData3)) && (0, _environmental3.e_allData3).length > 0) allEnvironmentalData.push(...(0, _environmental3.e_allData3));
                if (Array.isArray((0, _environmental4.e_allData4)) && (0, _environmental4.e_allData4).length > 0) allEnvironmentalData.push(...(0, _environmental4.e_allData4));
                if (Array.isArray(e_allData5) && e_allData5.length > 0) allEnvironmentalData.push(...e_allData5);
            } catch (error) {
                console.error("Erreur lors de la concat\xe9nation des donn\xe9es:", error);
            }
            console.log("Toutes les donn\xe9es environnementales pour le PDF:", allEnvironmentalData.length, "questions");
            // Générer le PDF avec toutes les données environnementales
            generatePdf(allEnvironmentalData);
            // Redirection vers la page suivante après sauvegarde réussie
            setIsLoading(false);
            history.push("/social-1");
        }).catch((error)=>{
            console.error("Error saving data:", error);
            setErrorMessage("Error saving data. Please try again.");
            console.error("D\xe9tails de l'erreur:", error.message);
            // Màªme en cas d'erreur, essayer de générer le PDF avec les données disponibles
            const allEnvironmentalData = [];
            try {
                if (Array.isArray((0, _environmental1.e_allData1)) && (0, _environmental1.e_allData1).length > 0) allEnvironmentalData.push(...(0, _environmental1.e_allData1));
                if (Array.isArray((0, _environmental2.e_allData2)) && (0, _environmental2.e_allData2).length > 0) allEnvironmentalData.push(...(0, _environmental2.e_allData2));
                if (Array.isArray((0, _environmental3.e_allData3)) && (0, _environmental3.e_allData3).length > 0) allEnvironmentalData.push(...(0, _environmental3.e_allData3));
                if (Array.isArray((0, _environmental4.e_allData4)) && (0, _environmental4.e_allData4).length > 0) allEnvironmentalData.push(...(0, _environmental4.e_allData4));
                if (Array.isArray(e_allData5) && e_allData5.length > 0) allEnvironmentalData.push(...e_allData5);
            } catch (error) {
                console.error("Erreur lors de la concat\xe9nation des donn\xe9es:", error);
            }
            generatePdf(allEnvironmentalData);
            // Redirection malgré l'erreur
            setIsLoading(false);
            history.push("/social-1");
        });
    }
    function generatePdf(e_allData) {
        // Vérifier si des données existent
        if (!e_allData || e_allData.length === 0) {
            console.error("Aucune donn\xe9e disponible pour g\xe9n\xe9rer le PDF");
            return;
        }
        console.log("G\xe9n\xe9ration du PDF avec", e_allData.length, "questions");
        // Créer un nouveau document PDF
        const doc = new (0, _jspdfDefault.default)();
        const lineHeight = 10;
        const pageHeight = doc.internal.pageSize.height - 20;
        const pageWidth = doc.internal.pageSize.width - 20;
        let y = 20;
        // Ajouter un titre
        doc.setFontSize(16);
        doc.text("Environmental Assessment Results", 105, y, {
            align: "center"
        });
        y += 15;
        // Ajouter le score total
        doc.setFontSize(14);
        doc.text(`Total Score: ${e_sum} / ${e_allData.length}`, 105, y, {
            align: "center"
        });
        y += 15;
        doc.setFontSize(12);
        // Parcourir les données dans e_allData et ajouter chaque question et réponse au document PDF
        e_allData.forEach((data, index)=>{
            // Vérifier si les données sont valides
            if (!data || !data.question) {
                console.error("Donn\xe9es invalides pour l'\xe9l\xe9ment", index);
                return;
            }
            const question = `Question ${index + 1}: ${data.question}`;
            const answer = `Answer: ${data.answer || 'No answer'}`;
            // Estimer la hauteur du texte après division pour mieux gérer les sauts de page
            const splitQuestion = doc.splitTextToSize(question, pageWidth);
            const estimatedHeight = splitQuestion.length * lineHeight + lineHeight * 2;
            // Vérifier si la position y actuelle plus la hauteur de la question dépasse la hauteur maximale de la page
            if (y + estimatedHeight > pageHeight) {
                // Ajouter une nouvelle page et réinitialiser la position y
                doc.addPage();
                y = 20;
            }
            // à‰crire la question et la réponse dans le PDF
            doc.text(splitQuestion, 10, y);
            y += splitQuestion.length * lineHeight;
            doc.text(answer, 10, y);
            y += lineHeight * 2; // Ajouter un peu d'espace entre les questions
        });
        // Ajouter une page de résumé
        doc.addPage();
        y = 20;
        doc.setFontSize(16);
        doc.text("Summary of Environmental Assessment", 105, y, {
            align: "center"
        });
        y += 20;
        doc.setFontSize(12);
        doc.text(`Total number of questions: ${e_allData.length}`, 10, y);
        y += lineHeight;
        doc.text(`Total "Yes" answers: ${e_sum}`, 10, y);
        y += lineHeight;
        doc.text(`Score percentage: ${Math.round(e_sum / e_allData.length * 100)}%`, 10, y);
        y += lineHeight * 2;
        const date = new Date();
        doc.text(`Generated on: ${date.toLocaleDateString()} at ${date.toLocaleTimeString()}`, 10, y);
        // Enregistrer le document PDF
        doc.save("Environmental_Assessment_Complete.pdf");
        console.log("PDF environnemental g\xe9n\xe9r\xe9 avec succ\xe8s");
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "environmental-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "environmental-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    className: "environmental-title",
                    children: "PLEASE ANSWER THE FOLLOWING QUESTIONS"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "progress-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "progress-bar",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "progress-fill",
                                style: {
                                    width: `${Object.keys(selectedOptions).length / totalQuestions * 100}%`
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "progress-text",
                            children: [
                                "Your score: ",
                                yes_Count5,
                                " / ",
                                totalQuestions,
                                " (",
                                Math.round(yes_Count5 / totalQuestions * 100) || 0,
                                "%)"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questions-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Are you implementing environmental management tools?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Are you implementing environmental management tools?", "Yes"),
                                            className: `btn-option ${selectedOptions["Are you implementing environmental management tools?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Are you implementing environmental management tools?", "No"),
                                            className: `btn-option ${selectedOptions["Are you implementing environmental management tools?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have environmental certifications?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have environmental certifications?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have environmental certifications?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have environmental certifications?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have environmental certifications?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Have you had environmental non-compliance issues in the past 3 years?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Have you had environmental non-compliance issues in the past 3 years?", "Yes"),
                                            className: `btn-option ${selectedOptions["Have you had environmental non-compliance issues in the past 3 years?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Have you had environmental non-compliance issues in the past 3 years?", "No"),
                                            className: `btn-option ${selectedOptions["Have you had environmental non-compliance issues in the past 3 years?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Have you communicated with your community about potential negative impacts of your activities?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Have you communicated with your community about potential negative impacts of your activities?", "Yes"),
                                            className: `btn-option ${selectedOptions["Have you communicated with your community about potential negative impacts of your activities?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Have you communicated with your community about potential negative impacts of your activities?", "No"),
                                            className: `btn-option ${selectedOptions["Have you communicated with your community about potential negative impacts of your activities?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you communicate about environmental issues with your suppliers?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you communicate about environmental issues with your suppliers?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you communicate about environmental issues with your suppliers?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you communicate about environmental issues with your suppliers?", "No"),
                                            className: `btn-option ${selectedOptions["Do you communicate about environmental issues with your suppliers?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "form-actions",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/environmental-4",
                            className: "btn-secondary",
                            children: "Back"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "btn-primary",
                            children: "Submit Environmental Assessment"
                        })
                    ]
                }),
                isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "loading-indicator",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "spinner"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: "Enregistrement des donn\xe9es en cours..."
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Environmental5;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["Link","b9X5n"],["useHistory","ditZI"]],"../NavItems3":"fOarC","../NavItems2":"bnQuI","../Toggle":"dSqDu","./Environmental5.css":"api4M","../../styleguide.css":"8Y7Ec","jspdf":"hkJ4Q","../Environmental1":"aCokB","../Environmental2":"2OiAJ","../Environmental3":"aRvrz","../Environmental4":"lXQfO","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"api4M":[function() {},{}],"8Y7Ec":[function() {},{}],"2OiAJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "e_allData2", ()=>e_allData2);
parcelHelpers.export(exports, "yes_Count2", ()=>yes_Count2);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _environmental2Css = require("./Environmental2.css");
var _styleguideCss = require("../../styleguide.css");
let e_allData2 = [];
let yes_Count2 = 0;
function Environmental2(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [yesCount2, setYesCount2] = (0, _react.useState)(0); // Initialize yesCount state
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const [isLoading, setIsLoading] = (0, _react.useState)(false); // Ajout de l'état isLoading
    const { navItems3Props, toggle1Props, toggle2Props, toggle3Props } = props;
    (0, _react.useEffect)(()=>{
        // Calculate the total number of questions based on sections
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []); // Run this effect only once when the component mounts
    function clicked(question, option) {
        // Si l'option cliquée est la màªme que celle déjà  sélectionnée, on la désélectionne
        if (selectedOptions[question] === option) {
            setSelectedOptions((prevSelectedOptions)=>{
                const newOptions = {
                    ...prevSelectedOptions
                };
                delete newOptions[question];
                return newOptions;
            });
            // Si on désélectionne un "Yes", on décrémente le score
            if (option === "Yes") yes_Count2--;
            return;
        }
        // Sinon, on met à  jour la sélection
        const previousOption = selectedOptions[question];
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        // Si on passe de "No" à  "Yes", on incrémente le score
        if (option === "Yes" && previousOption !== "Yes") yes_Count2++;
        else if (option === "No" && previousOption === "Yes") yes_Count2--;
    }
    const history = (0, _reactRouterDom.useHistory)();
    function saveData() {
        setIsLoading(true);
        setErrorMessage("");
        console.log("D\xe9but de sauvegarde des donn\xe9es Environmental2");
        const enterpriseId = localStorage.getItem("enterpriseId");
        const userId = localStorage.getItem("userId");
        if (!enterpriseId) {
            console.error("ERREUR: ID d'entreprise manquant");
            setErrorMessage("ID d'entreprise manquant. Veuillez retourner \xe0\xa0 la s\xe9lection d'entreprise.");
            setIsLoading(false);
            return;
        }
        // Définir toutes les questions possibles
        const allQuestions = [
            "Do you control and limit liquid pollutant emissions into water and soil related to your activities?",
            "Do you monitor your water consumption volume?",
            "Have you invested in water recovery and treatment technologies?",
            "Do you control and limit air emissions related to your activities?",
            "Do you monitor non-renewable energy consumption related to your activities?"
        ];
        // Créer un tableau de questions/réponses pour toutes les questions
        const data = allQuestions.map((question)=>{
            const answer = selectedOptions[question] || "No";
            return {
                question: question,
                answer: answer,
                category: "environmental",
                enterpriseId: enterpriseId,
                userId: userId || "",
                section: "environmental-2",
                timestamp: new Date().toISOString()
            };
        });
        // Vérifier que les données sont correctement formatées
        const isValidData = data.every((item)=>item.question && item.answer && item.category && item.enterpriseId);
        if (!isValidData) {
            console.error("Donn\xe9es invalides:", data);
            setErrorMessage("Format de donn\xe9es invalide");
            setIsLoading(false);
            return;
        }
        console.log("Donn\xe9es \xe0\xa0 envoyer:", JSON.stringify(data, null, 2));
        // Appel API pour sauvegarder les données
        fetch("/api/api/save-answers", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
            },
            body: JSON.stringify(data)
        }).then((response)=>{
            if (!response.ok) throw new Error(`Erreur de sauvegarde (${response.status})`);
            return response.json();
        }).then((result)=>{
            console.log("Data saved successfully:", result);
            // Sauvegarder le score dans le localStorage
            localStorage.setItem('environmental2Score', yes_Count2);
            console.log(`Score environmental2 mis \xe0\xa0 jour: ${yes_Count2}`);
            setIsLoading(false);
            history.push("/environmental-3");
        }).catch((error)=>{
            console.error("Error saving data:", error);
            setErrorMessage("Error saving data. Please try again.");
            console.error("D\xe9tails de l'erreur:", error.message);
            setIsLoading(false);
            history.push("/environmental-3");
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "environmental-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "environmental-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    className: "environmental-title",
                    children: "PLEASE ANSWER THE FOLLOWING QUESTIONS"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "progress-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "progress-bar",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "progress-fill",
                                style: {
                                    width: `${Object.keys(selectedOptions).length / totalQuestions * 100}%`
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "progress-text",
                            children: [
                                "Your score: ",
                                yes_Count2,
                                " / ",
                                totalQuestions,
                                " (",
                                Math.round(yes_Count2 / totalQuestions * 100) || 0,
                                "%)"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questions-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you control and limit liquid pollutant emissions into water and soil related to your activities?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you control and limit liquid pollutant emissions into water and soil related to your activities?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you control and limit liquid pollutant emissions into water and soil related to your activities?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you control and limit liquid pollutant emissions into water and soil related to your activities?", "No"),
                                            className: `btn-option ${selectedOptions["Do you control and limit liquid pollutant emissions into water and soil related to your activities?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you monitor your water consumption volume?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you monitor your water consumption volume?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you monitor your water consumption volume?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you monitor your water consumption volume?", "No"),
                                            className: `btn-option ${selectedOptions["Do you monitor your water consumption volume?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Have you invested in water recovery and treatment technologies?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Have you invested in water recovery and treatment technologies?", "Yes"),
                                            className: `btn-option ${selectedOptions["Have you invested in water recovery and treatment technologies?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Have you invested in water recovery and treatment technologies?", "No"),
                                            className: `btn-option ${selectedOptions["Have you invested in water recovery and treatment technologies?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you control and limit air emissions related to your activities?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you control and limit air emissions related to your activities?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you control and limit air emissions related to your activities?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you control and limit air emissions related to your activities?", "No"),
                                            className: `btn-option ${selectedOptions["Do you control and limit air emissions related to your activities?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you monitor non-renewable energy consumption related to your activities?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you monitor non-renewable energy consumption related to your activities?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you monitor non-renewable energy consumption related to your activities?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you monitor non-renewable energy consumption related to your activities?", "No"),
                                            className: `btn-option ${selectedOptions["Do you monitor non-renewable energy consumption related to your activities?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "form-actions",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/environmental-1",
                            className: "btn-secondary",
                            children: "Back"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "btn-primary",
                            children: "Continue to Next Section"
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Environmental2;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["Link","b9X5n"],["useHistory","ditZI"]],"../NavItems3":"fOarC","../NavItems2":"bnQuI","../Toggle":"dSqDu","./Environmental2.css":"ja2JY","../../styleguide.css":"8Y7Ec","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ja2JY":[function() {},{}],"8Y7Ec":[function() {},{}],"aRvrz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "e_allData3", ()=>e_allData3);
parcelHelpers.export(exports, "yes_Count3", ()=>yes_Count3);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _ouinon = require("../Ouinon");
var _ouinonDefault = parcelHelpers.interopDefault(_ouinon);
var _frame11732 = require("../Frame11732");
var _frame11732Default = parcelHelpers.interopDefault(_frame11732);
var _environmental3Css = require("./Environmental3.css");
var _styleguideCss = require("../../styleguide.css");
let e_allData3 = [];
let yes_Count3 = 0;
function Environmental3(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [yesCount3, setYesCount3] = (0, _react.useState)(0); // Initialize yesCount state
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const [isLoading, setIsLoading] = (0, _react.useState)(false); // Ajout de l'état isLoading
    const { x1200PxLogo_Icam__20081, navItems3Props, toggle1Props, toggle2Props, toggle3Props } = props;
    (0, _react.useEffect)(()=>{
        // Calculate the total number of questions based on sections
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []); // Run this effect only once when the component mounts
    function clicked(question, option) {
        // Si l'option cliquée est la màªme que celle déjà  sélectionnée, on la désélectionne
        if (selectedOptions[question] === option) {
            setSelectedOptions((prevSelectedOptions)=>{
                const newOptions = {
                    ...prevSelectedOptions
                };
                delete newOptions[question];
                return newOptions;
            });
            // Si on désélectionne un "Yes", on décrémente le score
            if (option === "Yes") yes_Count3--;
            return;
        }
        // Sinon, on met à  jour la sélection
        const previousOption = selectedOptions[question];
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        // Si on passe de "No" à  "Yes", on incrémente le score
        if (option === "Yes" && previousOption !== "Yes") yes_Count3++;
        else if (option === "No" && previousOption === "Yes") yes_Count3--;
    }
    const history = (0, _reactRouterDom.useHistory)();
    function saveData() {
        setIsLoading(true);
        setErrorMessage("");
        console.log("D\xe9but de sauvegarde des donn\xe9es Environmental3");
        const enterpriseId = localStorage.getItem("enterpriseId");
        const userId = localStorage.getItem("userId");
        if (!enterpriseId) {
            console.error("ERREUR: ID d'entreprise manquant");
            setErrorMessage("ID d'entreprise manquant. Veuillez retourner \xe0\xa0 la s\xe9lection d'entreprise.");
            setIsLoading(false);
            return;
        }
        // Définir toutes les questions possibles
        const allQuestions = [
            "Do you control and limit your energy consumption?",
            "Do you measure your energy consumption?",
            "Have you taken measures to reduce your energy consumption?",
            "Do you have sites located in or near protected areas?",
            "Do you have sites located in Natura 2000 areas?",
            "Do you favor buying from local suppliers to reduce transportation?"
        ];
        // Créer un tableau de questions/réponses pour toutes les questions
        const data = allQuestions.map((question)=>{
            const answer = selectedOptions[question] || "No";
            return {
                question: question,
                answer: answer,
                category: "environmental",
                enterpriseId: enterpriseId,
                userId: userId || "",
                section: "environmental-3",
                timestamp: new Date().toISOString()
            };
        });
        // Vérifier que les données sont correctement formatées
        const isValidData = data.every((item)=>item.question && item.answer && item.category && item.enterpriseId);
        if (!isValidData) {
            console.error("Donn\xe9es invalides:", data);
            setErrorMessage("Format de donn\xe9es invalide");
            setIsLoading(false);
            return;
        }
        console.log("Donn\xe9es \xe0\xa0 envoyer:", JSON.stringify(data, null, 2));
        // Appel API pour sauvegarder les données
        fetch("/api/api/save-answers", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
            },
            body: JSON.stringify(data)
        }).then((response)=>{
            if (!response.ok) throw new Error(`Erreur de sauvegarde (${response.status})`);
            return response.json();
        }).then((result)=>{
            console.log("Data saved successfully:", result);
            // Sauvegarder le score dans le localStorage
            localStorage.setItem('environmental3Score', yes_Count3);
            console.log(`Score environmental3 mis \xe0\xa0 jour: ${yes_Count3}`);
            setIsLoading(false);
            history.push("/environmental-4");
        }).catch((error)=>{
            console.error("Error saving data:", error);
            setErrorMessage("Error saving data. Please try again.");
            console.error("D\xe9tails de l'erreur:", error.message);
            setIsLoading(false);
            history.push("/environmental-4");
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "environmental-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "environmental-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    className: "environmental-title",
                    children: "PLEASE ANSWER THE FOLLOWING QUESTIONS"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "progress-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "progress-bar",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "progress-fill",
                                style: {
                                    width: `${Object.keys(selectedOptions).length / totalQuestions * 100}%`
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "progress-text",
                            children: [
                                "Your score: ",
                                yes_Count3,
                                " / ",
                                totalQuestions,
                                " (",
                                Math.round(yes_Count3 / totalQuestions * 100) || 0,
                                "%)"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questions-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you control and limit your energy consumption?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you control and limit your energy consumption?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you control and limit your energy consumption?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you control and limit your energy consumption?", "No"),
                                            className: `btn-option ${selectedOptions["Do you control and limit your energy consumption?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you measure your energy consumption?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you measure your energy consumption?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you measure your energy consumption?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you measure your energy consumption?", "No"),
                                            className: `btn-option ${selectedOptions["Do you measure your energy consumption?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Have you taken measures to reduce your energy consumption?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Have you taken measures to reduce your energy consumption?", "Yes"),
                                            className: `btn-option ${selectedOptions["Have you taken measures to reduce your energy consumption?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Have you taken measures to reduce your energy consumption?", "No"),
                                            className: `btn-option ${selectedOptions["Have you taken measures to reduce your energy consumption?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have sites located in or near protected areas?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have sites located in or near protected areas?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have sites located in or near protected areas?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have sites located in or near protected areas?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have sites located in or near protected areas?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have sites located in Natura 2000 areas?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have sites located in Natura 2000 areas?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have sites located in Natura 2000 areas?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have sites located in Natura 2000 areas?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have sites located in Natura 2000 areas?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you favor buying from local suppliers to reduce transportation?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you favor buying from local suppliers to reduce transportation?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you favor buying from local suppliers to reduce transportation?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you favor buying from local suppliers to reduce transportation?", "No"),
                                            className: `btn-option ${selectedOptions["Do you favor buying from local suppliers to reduce transportation?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "form-actions",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/environmental-2",
                            className: "btn-secondary",
                            children: "Back"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "btn-primary",
                            children: "Continue to Next Section"
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Environmental3;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["Link","b9X5n"],["useHistory","ditZI"]],"../NavItems3":"fOarC","../NavItems2":"bnQuI","../Toggle":"dSqDu","../Ouinon":"ln8KR","../Frame11732":"gSRJf","./Environmental3.css":"5b9rM","../../styleguide.css":"8Y7Ec","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ln8KR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _ouinonCss = require("./Ouinon.css");
function Ouinon(props) {
    const { yes, place, className } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `ouinon-45 ${className || ""}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "frame-4-5",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "yes subtitel",
                    children: yes
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "frame-4-6",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "place-80 subtitel",
                    children: place
                })
            })
        ]
    });
}
exports.default = Ouinon;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./Ouinon.css":"5QZdu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5QZdu":[function() {},{}],"5b9rM":[function() {},{}],"8Y7Ec":[function() {},{}],"lXQfO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "e_allData4", ()=>e_allData4);
parcelHelpers.export(exports, "yes_Count4", ()=>yes_Count4);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _ouinon2 = require("../Ouinon2");
var _ouinon2Default = parcelHelpers.interopDefault(_ouinon2);
var _ouinon = require("../Ouinon");
var _ouinonDefault = parcelHelpers.interopDefault(_ouinon);
var _frame11732 = require("../Frame11732");
var _frame11732Default = parcelHelpers.interopDefault(_frame11732);
var _environmental4Css = require("./Environmental4.css");
var _styleguideCss = require("../../styleguide.css");
let e_allData4 = [];
let yes_Count4 = 0;
function Environmental4(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [yesCount4, setYesCount4] = (0, _react.useState)(0); // Initialize yesCount state
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const [isLoading, setIsLoading] = (0, _react.useState)(false); // Ajout de l'état isLoading
    const { x1200PxLogo_Icam__20082, inputType1, inputPlaceholder1, inputType2, inputPlaceholder2, inputType3, inputPlaceholder3, inputType4, inputPlaceholder4, inputType5, inputPlaceholder5, inputType6, inputPlaceholder6, inputType7, inputPlaceholder7, navItems3Props, toggle1Props, ouinon21Props, ouinon22Props, toggle2Props, ouinon23Props, ouinon24Props, toggle3Props, ouinon1Props, ouinon2Props, ouinon3Props, toggle4Props } = props;
    (0, _react.useEffect)(()=>{
        // Calculate the total number of questions based on sections
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []); // Run this effect only once when the component mounts
    function clicked(question, option) {
        // Si l'option cliquée est la màªme que celle déjà  sélectionnée, on la désélectionne
        if (selectedOptions[question] === option) {
            setSelectedOptions((prevSelectedOptions)=>{
                const newOptions = {
                    ...prevSelectedOptions
                };
                delete newOptions[question];
                return newOptions;
            });
            // Si on désélectionne un "Yes", on décrémente le score
            if (option === "Yes") yes_Count4--;
            return;
        }
        // Sinon, on met à  jour la sélection
        const previousOption = selectedOptions[question];
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        // Si on passe de "No" à  "Yes", on incrémente le score
        if (option === "Yes" && previousOption !== "Yes") yes_Count4++;
        else if (option === "No" && previousOption === "Yes") yes_Count4--;
    }
    const history = (0, _reactRouterDom.useHistory)();
    function saveData() {
        setIsLoading(true);
        setErrorMessage("");
        console.log("D\xe9but de sauvegarde des donn\xe9es Environmental4");
        const enterpriseId = localStorage.getItem("enterpriseId");
        const userId = localStorage.getItem("userId");
        if (!enterpriseId) {
            console.error("ERREUR: ID d'entreprise manquant");
            setErrorMessage("ID d'entreprise manquant. Veuillez retourner \xe0\xa0 la s\xe9lection d'entreprise.");
            setIsLoading(false);
            return;
        }
        // Définir toutes les questions possibles
        const allQuestions = [
            "Do you try to reduce waste at the source?",
            "Do you import, export, or transport hazardous waste?",
            "Do you promote waste recycling?",
            "What percentage of your waste do you recycle out of your total waste?",
            "Do you promote the reuse of waste?",
            "Do you sell your recoverable waste?",
            "Do you have partners who collect your waste for reuse?"
        ];
        // Créer un tableau de questions/réponses pour toutes les questions
        const data = allQuestions.map((question)=>{
            const answer = selectedOptions[question] || "No";
            return {
                question: question,
                answer: answer,
                category: "environmental",
                enterpriseId: enterpriseId,
                userId: userId || "",
                section: "environmental-4",
                timestamp: new Date().toISOString()
            };
        });
        // Vérifier que les données sont correctement formatées
        const isValidData = data.every((item)=>item.question && item.answer && item.category && item.enterpriseId);
        if (!isValidData) {
            console.error("Donn\xe9es invalides:", data);
            setErrorMessage("Format de donn\xe9es invalide");
            setIsLoading(false);
            return;
        }
        console.log("Donn\xe9es \xe0\xa0 envoyer:", JSON.stringify(data, null, 2));
        // Appel API pour sauvegarder les données
        fetch("/api/api/save-answers", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
            },
            body: JSON.stringify(data)
        }).then((response)=>{
            if (!response.ok) throw new Error(`Erreur de sauvegarde (${response.status})`);
            return response.json();
        }).then((result)=>{
            console.log("Data saved successfully:", result);
            // Sauvegarder le score dans le localStorage
            localStorage.setItem('environmental4Score', yes_Count4);
            console.log(`Score environmental4 mis \xe0\xa0 jour: ${yes_Count4}`);
            setIsLoading(false);
            history.push("/environmental-5");
        }).catch((error)=>{
            console.error("Error saving data:", error);
            setErrorMessage("Error saving data. Please try again.");
            console.error("D\xe9tails de l'erreur:", error.message);
            setIsLoading(false);
            history.push("/environmental-5");
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "environmental-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "environmental-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    className: "environmental-title",
                    children: "PLEASE ANSWER THE FOLLOWING QUESTIONS"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "progress-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "progress-bar",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "progress-fill",
                                style: {
                                    width: `${Object.keys(selectedOptions).length / totalQuestions * 100}%`
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "progress-text",
                            children: [
                                "Your score: ",
                                yes_Count4,
                                " / ",
                                totalQuestions,
                                " (",
                                Math.round(yes_Count4 / totalQuestions * 100) || 0,
                                "%)"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questions-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you try to reduce waste at the source?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you try to reduce waste at the source?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you try to reduce waste at the source?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you try to reduce waste at the source?", "No"),
                                            className: `btn-option ${selectedOptions["Do you try to reduce waste at the source?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you import, export, or transport hazardous waste?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you import, export, or transport hazardous waste?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you import, export, or transport hazardous waste?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you import, export, or transport hazardous waste?", "No"),
                                            className: `btn-option ${selectedOptions["Do you import, export, or transport hazardous waste?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you promote waste recycling?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you promote waste recycling?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you promote waste recycling?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you promote waste recycling?", "No"),
                                            className: `btn-option ${selectedOptions["Do you promote waste recycling?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "What percentage of your waste do you recycle out of your total waste?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("What percentage of your waste do you recycle out of your total waste?", "Yes"),
                                            className: `btn-option ${selectedOptions["What percentage of your waste do you recycle out of your total waste?"] === "Yes" ? "enabled" : ""}`,
                                            children: "More than 50%"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("What percentage of your waste do you recycle out of your total waste?", "No"),
                                            className: `btn-option ${selectedOptions["What percentage of your waste do you recycle out of your total waste?"] === "No" ? "enabled" : ""}`,
                                            children: "Less than 50%"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you promote the reuse of waste?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you promote the reuse of waste?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you promote the reuse of waste?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you promote the reuse of waste?", "No"),
                                            className: `btn-option ${selectedOptions["Do you promote the reuse of waste?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you sell your recoverable waste?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you sell your recoverable waste?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you sell your recoverable waste?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you sell your recoverable waste?", "No"),
                                            className: `btn-option ${selectedOptions["Do you sell your recoverable waste?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have partners who collect your waste for reuse?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have partners who collect your waste for reuse?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have partners who collect your waste for reuse?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have partners who collect your waste for reuse?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have partners who collect your waste for reuse?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "form-actions",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/environmental-3",
                            className: "btn-secondary",
                            children: "Back"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "btn-primary",
                            children: "Continue to Next Section"
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Environmental4;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["Link","b9X5n"],["useHistory","ditZI"]],"../NavItems3":"fOarC","../NavItems2":"bnQuI","../Toggle":"dSqDu","../Ouinon2":"7gKpJ","../Ouinon":"ln8KR","../Frame11732":"gSRJf","./Environmental4.css":"lFkog","../../styleguide.css":"8Y7Ec","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7gKpJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame42 = require("../Frame42");
var _frame42Default = parcelHelpers.interopDefault(_frame42);
var _frame43 = require("../Frame43");
var _frame43Default = parcelHelpers.interopDefault(_frame43);
var _ouinon2Css = require("./Ouinon2.css");
function Ouinon2(props) {
    const { className, frame42Props, frame43Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `ouinon-48 ${className || ""}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame42Default.default), {
                className: frame42Props.className
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame43Default.default), {
                className: frame43Props.className
            })
        ]
    });
}
exports.default = Ouinon2;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","../Frame42":"1DQ0y","../Frame43":"e1r1D","./Ouinon2.css":"bWCbg","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1DQ0y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame42Css = require("./Frame42.css");
function Frame42(props) {
    const { className } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `frame-4-52-1 ${className || ""}`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "yes-37 subtitel",
            children: "Yes"
        })
    });
}
exports.default = Frame42;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./Frame42.css":"2zWss","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2zWss":[function() {},{}],"e1r1D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame43Css = require("./Frame43.css");
function Frame43(props) {
    const { className } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `frame-4-60 ${className || ""}`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "place-251 subtitel",
            children: "No"
        })
    });
}
exports.default = Frame43;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./Frame43.css":"1iIHE","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1iIHE":[function() {},{}],"bWCbg":[function() {},{}],"lFkog":[function() {},{}],"8Y7Ec":[function() {},{}],"3hH0I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "m_sum", ()=>m_sum);
parcelHelpers.export(exports, "m_yesCount4", ()=>m_yesCount4);
parcelHelpers.export(exports, "m_allData4", ()=>m_allData4);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _modernization4Css = require("./Modernization4.css");
var _styleguideCss = require("../../styleguide.css");
var _jspdf = require("jspdf");
var _jspdfDefault = parcelHelpers.interopDefault(_jspdf);
var _modernization1 = require("../Modernization1");
var _modernization2 = require("../Modernization2");
var _modernization3 = require("../Modernization3");
let m_sum = 0;
let m_yesCount4 = 0;
let m_allData4 = [];
function Modernization4(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const { x1200PxLogo_Icam__20081, navItems2Props, navItems3Props } = props;
    (0, _react.useEffect)(()=>{
        // Calculate the total number of questions based on sections
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []); // Run this effect only once when the component mounts
    function clicked(question, option) {
        // Si l'option cliquée est la màªme que celle déjà  sélectionnée, on la désélectionne
        if (selectedOptions[question] === option) {
            setSelectedOptions((prevSelectedOptions)=>{
                const newOptions = {
                    ...prevSelectedOptions
                };
                delete newOptions[question];
                return newOptions;
            });
            // Si on désélectionne un "Yes", on décrémente le score
            if (option === "Yes") m_yesCount4--;
            return;
        }
        // Sinon, on met à  jour la sélection
        const previousOption = selectedOptions[question];
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        // Si on passe de "No" à  "Yes", on incrémente le score
        if (option === "Yes" && previousOption !== "Yes") m_yesCount4++;
        else if (option === "No" && previousOption === "Yes") m_yesCount4--;
    }
    const history = (0, _reactRouterDom.useHistory)();
    function saveData() {
        setIsLoading(true);
        setErrorMessage("");
        console.log("D\xe9but de sauvegarde des donn\xe9es Modernization4");
        const enterpriseId = localStorage.getItem("enterpriseId");
        const userId = localStorage.getItem("userId");
        if (!enterpriseId) {
            console.error("ERREUR: ID d'entreprise manquant");
            setErrorMessage("ID d'entreprise manquant. Veuillez retourner \xe0\xa0 la s\xe9lection d'entreprise.");
            setIsLoading(false);
            return;
        }
        // Définir toutes les questions possibles
        const allQuestions = [
            "Are your different systems able to communicate with each other?",
            "Do you have any means of communication?",
            "Is it paper?",
            "Is it oral?",
            "Is it by mail?",
            "Is it an Application Suite like Google, Microsoft?",
            "Is the data produced used to make decisions?",
            "Do operators have access to an intelligent user interface?"
        ];
        // Créer un tableau de questions/réponses pour toutes les questions
        const data = allQuestions.map((question)=>{
            const answer = selectedOptions[question] || "No";
            return {
                question: question,
                answer: answer,
                category: "modernization",
                enterpriseId: enterpriseId,
                userId: userId || "",
                section: "modernization-4",
                timestamp: new Date().toISOString()
            };
        });
        // Vérifier que les données sont correctement formatées
        const isValidData = data.every((item)=>item.question && item.answer && item.category && item.enterpriseId);
        if (!isValidData) {
            console.error("Donn\xe9es invalides:", data);
            setErrorMessage("Format de donn\xe9es invalide");
            setIsLoading(false);
            return;
        }
        // Sauvegarder les données pour une utilisation ultérieure
        m_allData4 = [
            ...data
        ];
        console.log("Donn\xe9es \xe0\xa0 envoyer:", JSON.stringify(data, null, 2));
        // Calculer la somme des scores
        const modernization1Score = parseInt(localStorage.getItem('modernization1Score') || 0);
        const modernization2Score = parseInt(localStorage.getItem('modernization2Score') || 0);
        const modernization3Score = parseInt(localStorage.getItem('modernization3Score') || 0);
        m_sum = modernization1Score + modernization2Score + modernization3Score + m_yesCount4;
        console.log("Score total Modernization:", m_sum);
        // Appel API pour sauvegarder les données
        fetch("/api/api/save-answers", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
            },
            body: JSON.stringify(data)
        }).then((response)=>{
            if (!response.ok) throw new Error(`Erreur de sauvegarde (${response.status})`);
            return response.json();
        }).then((result)=>{
            console.log("Data saved successfully:", result);
            // Sauvegarder le score dans le localStorage
            localStorage.setItem('modernization4Score', m_yesCount4);
            console.log(`Score modernization4 mis \xe0\xa0 jour: ${m_yesCount4}`);
            // Sauvegarder également le score total modernization
            const scoreData = [
                {
                    question: "Modernization Total Score Final",
                    answer: m_sum.toString(),
                    category: "modernization",
                    enterpriseId: enterpriseId,
                    userId: userId || "",
                    section: "modernization-total-final",
                    timestamp: new Date().toISOString()
                }
            ];
            console.log("Envoi du score total modernization:", JSON.stringify(scoreData, null, 2));
            // Appel API pour sauvegarder le score total
            return fetch("/api/api/save-answers", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
                },
                body: JSON.stringify(scoreData)
            });
        }).then((response)=>{
            if (!response || !response.ok) throw new Error("Failed to save total score");
            return response.json();
        }).then((scoreResponse)=>{
            console.log("Score total modernization enregistr\xe9 avec succ\xe8s:", scoreResponse);
            // Récupérer correctement les données de tous les composants
            const allModernizationData = [];
            // Utiliser des try/catch pour éviter les erreurs si certaines données sont manquantes
            try {
                if (Array.isArray((0, _modernization1.m_allData1)) && (0, _modernization1.m_allData1).length > 0) allModernizationData.push(...(0, _modernization1.m_allData1));
                if (Array.isArray((0, _modernization2.m_allData2)) && (0, _modernization2.m_allData2).length > 0) allModernizationData.push(...(0, _modernization2.m_allData2));
                if (Array.isArray((0, _modernization3.m_allData3)) && (0, _modernization3.m_allData3).length > 0) allModernizationData.push(...(0, _modernization3.m_allData3));
                if (Array.isArray(m_allData4) && m_allData4.length > 0) allModernizationData.push(...m_allData4);
            } catch (error) {
                console.error("Erreur lors de la concat\xe9nation des donn\xe9es:", error);
            }
            console.log("Toutes les donn\xe9es Modernization pour le PDF:", allModernizationData.length, "questions");
            // Générer le PDF avec toutes les données
            generatePdf(allModernizationData);
            // Redirection vers la page suivante
            setIsLoading(false);
            history.push("/lead-time-1");
        }).catch((error)=>{
            console.error("Error saving data:", error);
            setErrorMessage("Error saving data. Please try again.");
            console.error("D\xe9tails de l'erreur:", error.message);
            // Màªme en cas d'erreur, essayer de générer le PDF avec les données disponibles
            const allModernizationData = [];
            try {
                if (Array.isArray((0, _modernization1.m_allData1)) && (0, _modernization1.m_allData1).length > 0) allModernizationData.push(...(0, _modernization1.m_allData1));
                if (Array.isArray((0, _modernization2.m_allData2)) && (0, _modernization2.m_allData2).length > 0) allModernizationData.push(...(0, _modernization2.m_allData2));
                if (Array.isArray((0, _modernization3.m_allData3)) && (0, _modernization3.m_allData3).length > 0) allModernizationData.push(...(0, _modernization3.m_allData3));
                if (Array.isArray(m_allData4) && m_allData4.length > 0) allModernizationData.push(...m_allData4);
            } catch (error) {
                console.error("Erreur lors de la concat\xe9nation des donn\xe9es:", error);
            }
            generatePdf(allModernizationData);
            // Redirection malgré l'erreur
            setIsLoading(false);
            history.push("/lead-time-1");
        });
    }
    function generatePdf(m_allData) {
        // Vérifier si des données existent
        if (!m_allData || m_allData.length === 0) {
            console.error("Aucune donn\xe9e disponible pour g\xe9n\xe9rer le PDF");
            return;
        }
        console.log("G\xe9n\xe9ration du PDF avec", m_allData.length, "questions");
        // Créer un nouveau document PDF
        const doc = new (0, _jspdfDefault.default)();
        const lineHeight = 10;
        const pageHeight = doc.internal.pageSize.height - 20;
        const pageWidth = doc.internal.pageSize.width - 20;
        let y = 20;
        // Ajouter un titre
        doc.setFontSize(16);
        doc.text("Modernization Assessment Results", 105, y, {
            align: "center"
        });
        y += 15;
        // Ajouter le score total
        doc.setFontSize(14);
        doc.text(`Total Score: ${m_sum} / ${m_allData.length}`, 105, y, {
            align: "center"
        });
        y += 15;
        doc.setFontSize(12);
        // Parcourir les données et ajouter chaque question et réponse au document PDF
        m_allData.forEach((data, index)=>{
            // Vérifier si les données sont valides
            if (!data || !data.question) {
                console.error("Donn\xe9es invalides pour l'\xe9l\xe9ment", index);
                return;
            }
            const question = `Question ${index + 1}: ${data.question}`;
            const answer = `Answer: ${data.answer || 'No answer'}`;
            // Estimer la hauteur du texte après division pour mieux gérer les sauts de page
            const splitQuestion = doc.splitTextToSize(question, pageWidth);
            const estimatedHeight = splitQuestion.length * lineHeight + lineHeight * 2;
            // Vérifier si on doit passer à  une nouvelle page
            if (y + estimatedHeight > pageHeight) {
                doc.addPage();
                y = 20;
            }
            // à‰crire la question et la réponse dans le PDF
            doc.text(splitQuestion, 10, y);
            y += splitQuestion.length * lineHeight;
            doc.text(answer, 10, y);
            y += lineHeight * 2; // Ajouter un peu d'espace entre les questions
        });
        // Ajouter une page de résumé
        doc.addPage();
        y = 20;
        doc.setFontSize(16);
        doc.text("Summary of Modernization Assessment", 105, y, {
            align: "center"
        });
        y += 20;
        doc.setFontSize(12);
        doc.text(`Total number of questions: ${m_allData.length}`, 10, y);
        y += lineHeight;
        doc.text(`Total "Yes" answers: ${m_sum}`, 10, y);
        y += lineHeight;
        doc.text(`Score percentage: ${Math.round(m_sum / m_allData.length * 100)}%`, 10, y);
        y += lineHeight * 2;
        const date = new Date();
        doc.text(`Generated on: ${date.toLocaleDateString()} at ${date.toLocaleTimeString()}`, 10, y);
        // Enregistrer le document PDF
        doc.save("Modernization_Assessment_Complete.pdf");
        console.log("PDF Modernization g\xe9n\xe9r\xe9 avec succ\xe8s");
    }
    function calculateProgressPercentage() {
        const totalQuestionsCount = document.getElementsByTagName("section").length;
        if (totalQuestionsCount === 0) return 0;
        return Math.round(m_yesCount4 / totalQuestionsCount * 100);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "environmental-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "environmental-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    className: "environmental-title",
                    children: "SCORE MODERNIZATION"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "progress-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "progress-bar",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "progress-fill",
                                style: {
                                    width: `${calculateProgressPercentage()}%`
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "progress-text",
                            children: [
                                "Your score: ",
                                m_yesCount4,
                                " / ",
                                totalQuestions,
                                " (",
                                calculateProgressPercentage(),
                                "%)"
                            ]
                        })
                    ]
                }),
                errorMessage && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "error-message",
                    children: errorMessage
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questions-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Are your different systems able to communicate with each other?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Are your different systems able to communicate with each other?", "Yes"),
                                            className: `btn-option ${selectedOptions["Are your different systems able to communicate with each other?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Are your different systems able to communicate with each other?", "No"),
                                            className: `btn-option ${selectedOptions["Are your different systems able to communicate with each other?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have any means of communication?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have any means of communication?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have any means of communication?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have any means of communication?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have any means of communication?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Is it paper?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Is it paper?", "Yes"),
                                            className: `btn-option ${selectedOptions["Is it paper?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Is it paper?", "No"),
                                            className: `btn-option ${selectedOptions["Is it paper?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Is it oral?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Is it oral?", "Yes"),
                                            className: `btn-option ${selectedOptions["Is it oral?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Is it oral?", "No"),
                                            className: `btn-option ${selectedOptions["Is it oral?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Is it by mail?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Is it by mail?", "Yes"),
                                            className: `btn-option ${selectedOptions["Is it by mail?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Is it by mail?", "No"),
                                            className: `btn-option ${selectedOptions["Is it by mail?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Is it an Application Suite like Google, Microsoft?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Is it an Application Suite like Google, Microsoft?", "Yes"),
                                            className: `btn-option ${selectedOptions["Is it an Application Suite like Google, Microsoft?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Is it an Application Suite like Google, Microsoft?", "No"),
                                            className: `btn-option ${selectedOptions["Is it an Application Suite like Google, Microsoft?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Is the data produced used to make decisions?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Is the data produced used to make decisions?", "Yes"),
                                            className: `btn-option ${selectedOptions["Is the data produced used to make decisions?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Is the data produced used to make decisions?", "No"),
                                            className: `btn-option ${selectedOptions["Is the data produced used to make decisions?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do operators have access to an intelligent user interface?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do operators have access to an intelligent user interface?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do operators have access to an intelligent user interface?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do operators have access to an intelligent user interface?", "No"),
                                            className: `btn-option ${selectedOptions["Do operators have access to an intelligent user interface?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "form-actions",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/modernization-3",
                            className: "btn-secondary",
                            children: "Back"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "btn-primary",
                            children: "Complete Assessment and Continue"
                        })
                    ]
                }),
                isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "loading-indicator",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "spinner"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: "Saving data and generating PDF..."
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Modernization4;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["Link","b9X5n"],["useHistory","ditZI"]],"../NavItems2":"bnQuI","../NavItems3":"fOarC","./Modernization4.css":"jPeZX","../../styleguide.css":"8Y7Ec","jspdf":"hkJ4Q","../Modernization1":"9pvUI","../Modernization2":"kq01z","../Modernization3":"lUkob","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jPeZX":[function() {},{}],"8Y7Ec":[function() {},{}],"9pvUI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "m_allData1", ()=>m_allData1);
parcelHelpers.export(exports, "m_yesCount1", ()=>m_yesCount1);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _modernization1Css = require("./Modernization1.css");
var _styleguideCss = require("../../styleguide.css");
let m_allData1 = [];
let m_yesCount1 = 0;
function Modernization1(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const { x1200PxLogo_Icam__20081, navItems2Props, navItems3Props } = props;
    (0, _react.useEffect)(()=>{
        // Calculate the total number of questions based on sections
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []); // Run this effect only once when the component mounts
    function clicked(question, option) {
        // Si l'option cliquée est la màªme que celle déjà  sélectionnée, on la désélectionne
        if (selectedOptions[question] === option) {
            setSelectedOptions((prevSelectedOptions)=>{
                const newOptions = {
                    ...prevSelectedOptions
                };
                delete newOptions[question];
                return newOptions;
            });
            // Si on désélectionne un "Yes", on décrémente le score
            if (option === "Yes") m_yesCount1--;
            return;
        }
        // Sinon, on met à  jour la sélection
        const previousOption = selectedOptions[question];
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        // Si on passe de "No" à  "Yes", on incrémente le score
        if (option === "Yes" && previousOption !== "Yes") m_yesCount1++;
        else if (option === "No" && previousOption === "Yes") m_yesCount1--;
    }
    const history = (0, _reactRouterDom.useHistory)();
    function saveData() {
        setIsLoading(true);
        setErrorMessage("");
        console.log("D\xe9but de sauvegarde des donn\xe9es Modernization1");
        const enterpriseId = localStorage.getItem("enterpriseId");
        const userId = localStorage.getItem("userId");
        if (!enterpriseId) {
            console.error("ERREUR: ID d'entreprise manquant");
            setErrorMessage("ID d'entreprise manquant. Veuillez retourner \xe0\xa0 la s\xe9lection d'entreprise.");
            setIsLoading(false);
            return;
        }
        // Définir toutes les questions possibles
        const allQuestions = [
            "Do you have AI models that can solve problems?",
            "Do you use intelligent agents to solve simulation problems?",
            "Do you have any models for forecasting sales?",
            "Do you have models for sales forecasting?",
            "Do you have models for forecasting purchases?",
            "Do you have robots that can be autonomous on complex tasks?",
            "Do you have a cybersecurity system using AI models?"
        ];
        // Créer un tableau de questions/réponses pour toutes les questions
        const data = allQuestions.map((question)=>{
            const answer = selectedOptions[question] || "No";
            return {
                question: question,
                answer: answer,
                category: "modernization",
                enterpriseId: enterpriseId,
                userId: userId || "",
                section: "modernization-1",
                timestamp: new Date().toISOString()
            };
        });
        // Vérifier que les données sont correctement formatées
        const isValidData = data.every((item)=>item.question && item.answer && item.category && item.enterpriseId);
        if (!isValidData) {
            console.error("Donn\xe9es invalides:", data);
            setErrorMessage("Format de donn\xe9es invalide");
            setIsLoading(false);
            return;
        }
        // Sauvegarder les données pour une utilisation ultérieure
        m_allData1 = [
            ...data
        ];
        console.log("Donn\xe9es \xe0\xa0 envoyer:", JSON.stringify(data, null, 2));
        // Appel API pour sauvegarder les données
        fetch("/api/api/save-answers", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
            },
            body: JSON.stringify(data)
        }).then((response)=>{
            if (!response.ok) throw new Error(`Erreur de sauvegarde (${response.status})`);
            return response.json();
        }).then((result)=>{
            console.log("Data saved successfully:", result);
            // Sauvegarder le score dans le localStorage
            localStorage.setItem('modernization1Score', m_yesCount1);
            console.log(`Score modernization1 mis \xe0\xa0 jour: ${m_yesCount1}`);
            setIsLoading(false);
            history.push("/modernization-2");
        }).catch((error)=>{
            console.error("Error saving data:", error);
            setErrorMessage("Error saving data. Please try again.");
            console.error("D\xe9tails de l'erreur:", error.message);
            setIsLoading(false);
            history.push("/modernization-2");
        });
    }
    function calculateProgressPercentage() {
        const totalQuestions = document.getElementsByTagName("section").length;
        if (totalQuestions === 0) return 0;
        return Math.round(m_yesCount1 / totalQuestions * 100);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "environmental-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "environmental-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    className: "environmental-title",
                    children: "PLEASE ANSWER THE FOLLOWING QUESTIONS"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "progress-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "progress-bar",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "progress-fill",
                                style: {
                                    width: `${calculateProgressPercentage()}%`
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "progress-text",
                            children: [
                                "Your score: ",
                                m_yesCount1,
                                " / ",
                                totalQuestions,
                                " (",
                                calculateProgressPercentage(),
                                "%)"
                            ]
                        })
                    ]
                }),
                errorMessage && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "error-message",
                    children: errorMessage
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questions-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have AI models that can solve problems?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have AI models that can solve problems?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have AI models that can solve problems?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have AI models that can solve problems?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have AI models that can solve problems?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you use intelligent agents to solve simulation problems?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you use intelligent agents to solve simulation problems?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you use intelligent agents to solve simulation problems?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you use intelligent agents to solve simulation problems?", "No"),
                                            className: `btn-option ${selectedOptions["Do you use intelligent agents to solve simulation problems?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have any models for forecasting sales?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have any models for forecasting sales?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have any models for forecasting sales?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have any models for forecasting sales?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have any models for forecasting sales?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have models for sales forecasting?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have models for sales forecasting?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have models for sales forecasting?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have models for sales forecasting?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have models for sales forecasting?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have models for forecasting purchases?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have models for forecasting purchases?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have models for forecasting purchases?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have models for forecasting purchases?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have models for forecasting purchases?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have robots that can be autonomous on complex tasks?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have robots that can be autonomous on complex tasks?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have robots that can be autonomous on complex tasks?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have robots that can be autonomous on complex tasks?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have robots that can be autonomous on complex tasks?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have a cybersecurity system using AI models?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a cybersecurity system using AI models?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have a cybersecurity system using AI models?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a cybersecurity system using AI models?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have a cybersecurity system using AI models?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "form-actions",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/social-6",
                            className: "btn-secondary",
                            children: "Back"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "btn-primary",
                            children: "Next"
                        })
                    ]
                }),
                isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "loading-indicator",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "spinner"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: "Saving data..."
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Modernization1;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["Link","b9X5n"],["useHistory","ditZI"]],"../NavItems2":"bnQuI","../NavItems3":"fOarC","./Modernization1.css":"etHL4","../../styleguide.css":"8Y7Ec","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"etHL4":[function() {},{}],"8Y7Ec":[function() {},{}],"kq01z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "m_allData2", ()=>m_allData2);
parcelHelpers.export(exports, "m_yesCount2", ()=>m_yesCount2);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _modernization2Css = require("./Modernization2.css");
var _styleguideCss = require("../../styleguide.css");
let m_allData2 = [];
let m_yesCount2 = 0;
function Modernization2(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const { x1200PxLogo_Icam__20081, navItems2Props, navItems3Props } = props;
    (0, _react.useEffect)(()=>{
        // Calculate the total number of questions based on sections
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []); // Run this effect only once when the component mounts
    function clicked(question, option) {
        // Si l'option cliquée est la màªme que celle déjà  sélectionnée, on la désélectionne
        if (selectedOptions[question] === option) {
            setSelectedOptions((prevSelectedOptions)=>{
                const newOptions = {
                    ...prevSelectedOptions
                };
                delete newOptions[question];
                return newOptions;
            });
            // Si on désélectionne un "Yes", on décrémente le score
            if (option === "Yes") m_yesCount2--;
            return;
        }
        // Sinon, on met à  jour la sélection
        const previousOption = selectedOptions[question];
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        // Si on passe de "No" à  "Yes", on incrémente le score
        if (option === "Yes" && previousOption !== "Yes") m_yesCount2++;
        else if (option === "No" && previousOption === "Yes") m_yesCount2--;
    }
    const history = (0, _reactRouterDom.useHistory)();
    function saveData() {
        setIsLoading(true);
        setErrorMessage("");
        console.log("D\xe9but de sauvegarde des donn\xe9es Modernization2");
        const enterpriseId = localStorage.getItem("enterpriseId");
        const userId = localStorage.getItem("userId");
        if (!enterpriseId) {
            console.error("ERREUR: ID d'entreprise manquant");
            setErrorMessage("ID d'entreprise manquant. Veuillez retourner \xe0\xa0 la s\xe9lection d'entreprise.");
            setIsLoading(false);
            return;
        }
        // Définir toutes les questions possibles
        const allQuestions = [
            "For programming, are there people in the company who know how to code in Python?",
            "For programming, are there people in the company who know how to code in Java?",
            "For programming, are there people in the company who know how to code in C++?",
            "For programming, are there people in the company who know how to code in JavaScript?",
            "For programming, are there people in the company who know how to code in PHP?",
            "Do you have people in the company who have an operational knowledge of Deep Learning libraries (KERAS, TensorFlow, PyCaret, PyTorch)?"
        ];
        // Créer un tableau de questions/réponses pour toutes les questions
        const data = allQuestions.map((question)=>{
            const answer = selectedOptions[question] || "No";
            return {
                question: question,
                answer: answer,
                category: "modernization",
                enterpriseId: enterpriseId,
                userId: userId || "",
                section: "modernization-2",
                timestamp: new Date().toISOString()
            };
        });
        // Vérifier que les données sont correctement formatées
        const isValidData = data.every((item)=>item.question && item.answer && item.category && item.enterpriseId);
        if (!isValidData) {
            console.error("Donn\xe9es invalides:", data);
            setErrorMessage("Format de donn\xe9es invalide");
            setIsLoading(false);
            return;
        }
        // Sauvegarder les données pour une utilisation ultérieure
        m_allData2 = [
            ...data
        ];
        console.log("Donn\xe9es \xe0\xa0 envoyer:", JSON.stringify(data, null, 2));
        // Appel API pour sauvegarder les données
        fetch("/api/api/save-answers", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
            },
            body: JSON.stringify(data)
        }).then((response)=>{
            if (!response.ok) throw new Error(`Erreur de sauvegarde (${response.status})`);
            return response.json();
        }).then((result)=>{
            console.log("Data saved successfully:", result);
            // Sauvegarder le score dans le localStorage
            localStorage.setItem('modernization2Score', m_yesCount2);
            console.log(`Score modernization2 mis \xe0\xa0 jour: ${m_yesCount2}`);
            setIsLoading(false);
            history.push("/modernization-3");
        }).catch((error)=>{
            console.error("Error saving data:", error);
            setErrorMessage("Error saving data. Please try again.");
            console.error("D\xe9tails de l'erreur:", error.message);
            setIsLoading(false);
            history.push("/modernization-3");
        });
    }
    function calculateProgressPercentage() {
        const totalQuestions = document.getElementsByTagName("section").length;
        if (totalQuestions === 0) return 0;
        return Math.round(m_yesCount2 / totalQuestions * 100);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "environmental-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "environmental-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    className: "environmental-title",
                    children: "PLEASE ANSWER THE FOLLOWING QUESTIONS"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "progress-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "progress-bar",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "progress-fill",
                                style: {
                                    width: `${calculateProgressPercentage()}%`
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "progress-text",
                            children: [
                                "Your score: ",
                                m_yesCount2,
                                " / ",
                                totalQuestions,
                                " (",
                                calculateProgressPercentage(),
                                "%)"
                            ]
                        })
                    ]
                }),
                errorMessage && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "error-message",
                    children: errorMessage
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questions-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "For programming, are there people in the company who know how to code in Python?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("For programming, are there people in the company who know how to code in Python?", "Yes"),
                                            className: `btn-option ${selectedOptions["For programming, are there people in the company who know how to code in Python?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("For programming, are there people in the company who know how to code in Python?", "No"),
                                            className: `btn-option ${selectedOptions["For programming, are there people in the company who know how to code in Python?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "For programming, are there people in the company who know how to code in Java?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("For programming, are there people in the company who know how to code in Java?", "Yes"),
                                            className: `btn-option ${selectedOptions["For programming, are there people in the company who know how to code in Java?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("For programming, are there people in the company who know how to code in Java?", "No"),
                                            className: `btn-option ${selectedOptions["For programming, are there people in the company who know how to code in Java?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "For programming, are there people in the company who know how to code in C++?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("For programming, are there people in the company who know how to code in C++?", "Yes"),
                                            className: `btn-option ${selectedOptions["For programming, are there people in the company who know how to code in C++?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("For programming, are there people in the company who know how to code in C++?", "No"),
                                            className: `btn-option ${selectedOptions["For programming, are there people in the company who know how to code in C++?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "For programming, are there people in the company who know how to code in JavaScript?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("For programming, are there people in the company who know how to code in JavaScript?", "Yes"),
                                            className: `btn-option ${selectedOptions["For programming, are there people in the company who know how to code in JavaScript?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("For programming, are there people in the company who know how to code in JavaScript?", "No"),
                                            className: `btn-option ${selectedOptions["For programming, are there people in the company who know how to code in JavaScript?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "For programming, are there people in the company who know how to code in PHP?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("For programming, are there people in the company who know how to code in PHP?", "Yes"),
                                            className: `btn-option ${selectedOptions["For programming, are there people in the company who know how to code in PHP?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("For programming, are there people in the company who know how to code in PHP?", "No"),
                                            className: `btn-option ${selectedOptions["For programming, are there people in the company who know how to code in PHP?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have people in the company who have an operational knowledge of Deep Learning libraries (KERAS, TensorFlow, PyCaret, PyTorch)?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have people in the company who have an operational knowledge of Deep Learning libraries (KERAS, TensorFlow, PyCaret, PyTorch)?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have people in the company who have an operational knowledge of Deep Learning libraries (KERAS, TensorFlow, PyCaret, PyTorch)?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have people in the company who have an operational knowledge of Deep Learning libraries (KERAS, TensorFlow, PyCaret, PyTorch)?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have people in the company who have an operational knowledge of Deep Learning libraries (KERAS, TensorFlow, PyCaret, PyTorch)?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "form-actions",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/modernization-1",
                            className: "btn-secondary",
                            children: "Back"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "btn-primary",
                            children: "Next"
                        })
                    ]
                }),
                isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "loading-indicator",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "spinner"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: "Saving data..."
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Modernization2;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["Link","b9X5n"],["useHistory","ditZI"]],"../NavItems2":"bnQuI","../NavItems3":"fOarC","./Modernization2.css":"7YH4I","../../styleguide.css":"8Y7Ec","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7YH4I":[function() {},{}],"8Y7Ec":[function() {},{}],"lUkob":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "m_allData3", ()=>m_allData3);
parcelHelpers.export(exports, "m_yesCount3", ()=>m_yesCount3);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _modernization3Css = require("./Modernization3.css");
var _styleguideCss = require("../../styleguide.css");
let m_allData3 = [];
let m_yesCount3 = 0;
function Modernization3(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const { x1200PxLogo_Icam__20081, navItems2Props, navItems3Props } = props;
    (0, _react.useEffect)(()=>{
        // Calculate the total number of questions based on sections
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []); // Run this effect only once when the component mounts
    function clicked(question, option) {
        // Si l'option cliquée est la màªme que celle déjà  sélectionnée, on la désélectionne
        if (selectedOptions[question] === option) {
            setSelectedOptions((prevSelectedOptions)=>{
                const newOptions = {
                    ...prevSelectedOptions
                };
                delete newOptions[question];
                return newOptions;
            });
            // Si on désélectionne un "Yes", on décrémente le score
            if (option === "Yes") m_yesCount3--;
            return;
        }
        // Sinon, on met à  jour la sélection
        const previousOption = selectedOptions[question];
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        // Si on passe de "No" à  "Yes", on incrémente le score
        if (option === "Yes" && previousOption !== "Yes") m_yesCount3++;
        else if (option === "No" && previousOption === "Yes") m_yesCount3--;
    }
    const history = (0, _reactRouterDom.useHistory)();
    function saveData() {
        setIsLoading(true);
        setErrorMessage("");
        console.log("D\xe9but de sauvegarde des donn\xe9es Modernization3");
        const enterpriseId = localStorage.getItem("enterpriseId");
        const userId = localStorage.getItem("userId");
        if (!enterpriseId) {
            console.error("ERREUR: ID d'entreprise manquant");
            setErrorMessage("ID d'entreprise manquant. Veuillez retourner \xe0\xa0 la s\xe9lection d'entreprise.");
            setIsLoading(false);
            return;
        }
        // Définir toutes les questions possibles
        const allQuestions = [
            "For the visualization of your data, do you use Power BI?",
            "For the visualization of your data, do you use AWS?",
            "For the visualization of your data, do you use GCP?",
            "For the visualization of your data, do you use Python?",
            "For the visualization of your data, do you use others?",
            "Do you have models for data visualization?"
        ];
        // Créer un tableau de questions/réponses pour toutes les questions
        const data = allQuestions.map((question)=>{
            const answer = selectedOptions[question] || "No";
            return {
                question: question,
                answer: answer,
                category: "modernization",
                enterpriseId: enterpriseId,
                userId: userId || "",
                section: "modernization-3",
                timestamp: new Date().toISOString()
            };
        });
        // Vérifier que les données sont correctement formatées
        const isValidData = data.every((item)=>item.question && item.answer && item.category && item.enterpriseId);
        if (!isValidData) {
            console.error("Donn\xe9es invalides:", data);
            setErrorMessage("Format de donn\xe9es invalide");
            setIsLoading(false);
            return;
        }
        // Sauvegarder les données pour une utilisation ultérieure
        m_allData3 = [
            ...data
        ];
        console.log("Donn\xe9es \xe0\xa0 envoyer:", JSON.stringify(data, null, 2));
        // Appel API pour sauvegarder les données
        fetch("/api/api/save-answers", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
            },
            body: JSON.stringify(data)
        }).then((response)=>{
            if (!response.ok) throw new Error(`Erreur de sauvegarde (${response.status})`);
            return response.json();
        }).then((result)=>{
            console.log("Data saved successfully:", result);
            // Sauvegarder le score dans le localStorage
            localStorage.setItem('modernization3Score', m_yesCount3);
            console.log(`Score modernization3 mis \xe0\xa0 jour: ${m_yesCount3}`);
            setIsLoading(false);
            history.push("/modernization-4");
        }).catch((error)=>{
            console.error("Error saving data:", error);
            setErrorMessage("Error saving data. Please try again.");
            console.error("D\xe9tails de l'erreur:", error.message);
            setIsLoading(false);
            history.push("/modernization-4");
        });
    }
    function calculateProgressPercentage() {
        const totalQuestions = document.getElementsByTagName("section").length;
        if (totalQuestions === 0) return 0;
        return Math.round(m_yesCount3 / totalQuestions * 100);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "environmental-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "environmental-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    className: "environmental-title",
                    children: "PLEASE ANSWER THE FOLLOWING QUESTIONS"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "progress-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "progress-bar",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "progress-fill",
                                style: {
                                    width: `${calculateProgressPercentage()}%`
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "progress-text",
                            children: [
                                "Your score: ",
                                m_yesCount3,
                                " / ",
                                totalQuestions,
                                " (",
                                calculateProgressPercentage(),
                                "%)"
                            ]
                        })
                    ]
                }),
                errorMessage && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "error-message",
                    children: errorMessage
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questions-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "For the visualization of your data, do you use Power BI?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("For the visualization of your data, do you use Power BI?", "Yes"),
                                            className: `btn-option ${selectedOptions["For the visualization of your data, do you use Power BI?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("For the visualization of your data, do you use Power BI?", "No"),
                                            className: `btn-option ${selectedOptions["For the visualization of your data, do you use Power BI?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "For the visualization of your data, do you use AWS?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("For the visualization of your data, do you use AWS?", "Yes"),
                                            className: `btn-option ${selectedOptions["For the visualization of your data, do you use AWS?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("For the visualization of your data, do you use AWS?", "No"),
                                            className: `btn-option ${selectedOptions["For the visualization of your data, do you use AWS?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "For the visualization of your data, do you use GCP?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("For the visualization of your data, do you use GCP?", "Yes"),
                                            className: `btn-option ${selectedOptions["For the visualization of your data, do you use GCP?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("For the visualization of your data, do you use GCP?", "No"),
                                            className: `btn-option ${selectedOptions["For the visualization of your data, do you use GCP?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "For the visualization of your data, do you use Python?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("For the visualization of your data, do you use Python?", "Yes"),
                                            className: `btn-option ${selectedOptions["For the visualization of your data, do you use Python?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("For the visualization of your data, do you use Python?", "No"),
                                            className: `btn-option ${selectedOptions["For the visualization of your data, do you use Python?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "For the visualization of your data, do you use others?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("For the visualization of your data, do you use others?", "Yes"),
                                            className: `btn-option ${selectedOptions["For the visualization of your data, do you use others?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("For the visualization of your data, do you use others?", "No"),
                                            className: `btn-option ${selectedOptions["For the visualization of your data, do you use others?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have models for data visualization?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have models for data visualization?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have models for data visualization?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have models for data visualization?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have models for data visualization?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "form-actions",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/modernization-2",
                            className: "btn-secondary",
                            children: "Back"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "btn-primary",
                            children: "Next"
                        })
                    ]
                }),
                isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "loading-indicator",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "spinner"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: "Saving data..."
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Modernization3;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["Link","b9X5n"],["useHistory","ditZI"]],"../NavItems2":"bnQuI","../NavItems3":"fOarC","./Modernization3.css":"4UHfR","../../styleguide.css":"8Y7Ec","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4UHfR":[function() {},{}],"8Y7Ec":[function() {},{}],"5LCGo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "l_sum", ()=>l_sum);
parcelHelpers.export(exports, "l_allData2", ()=>l_allData2);
parcelHelpers.export(exports, "l_yesCount2", ()=>l_yesCount2);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _leadTime2Css = require("./LeadTime2.css");
var _styleguideCss = require("../../styleguide.css");
var _jspdf = require("jspdf");
var _jspdfDefault = parcelHelpers.interopDefault(_jspdf);
var _leadTime1 = require("../LeadTime1");
let l_sum = 0;
let l_allData2 = [];
let l_yesCount2 = 0;
function LeadTime2(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const { x1200PxLogo_Ical__20081, navItems3Props } = props;
    (0, _react.useEffect)(()=>{
        // Calculate the total number of questions based on sections
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []); // Run this effect only once when the component mounts
    function clicked(question, option) {
        // Si l'option cliquée est la màªme que celle déjà  sélectionnée, on la désélectionne
        if (selectedOptions[question] === option) {
            setSelectedOptions((prevSelectedOptions)=>{
                const newOptions = {
                    ...prevSelectedOptions
                };
                delete newOptions[question];
                return newOptions;
            });
            // Si on désélectionne un "Yes", on décrémente le score
            if (option === "Yes") l_yesCount2--;
            return;
        }
        // Sinon, on met à  jour la sélection
        const previousOption = selectedOptions[question];
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        // Si on passe de "No" à  "Yes", on incrémente le score
        if (option === "Yes" && previousOption !== "Yes") l_yesCount2++;
        else if (option === "No" && previousOption === "Yes") l_yesCount2--;
    }
    const history = (0, _reactRouterDom.useHistory)();
    function saveData() {
        setIsLoading(true);
        setErrorMessage("");
        console.log("D\xe9but de sauvegarde des donn\xe9es LeadTime2");
        const enterpriseId = localStorage.getItem("enterpriseId");
        const userId = localStorage.getItem("userId");
        if (!enterpriseId) {
            console.error("ERREUR: ID d'entreprise manquant");
            setErrorMessage("ID d'entreprise manquant. Veuillez retourner \xe0\xa0 la s\xe9lection d'entreprise.");
            setIsLoading(false);
            return;
        }
        // Définir toutes les questions possibles
        const allQuestions = [
            "Are you experiencing production delays due to technical problems?",
            "Have measures been put in place to avoid these inconveniences?",
            "Are you experiencing delays in product (or service) delivery to your customers?",
            "Do you have shipping delay problems when delivering to your customers?",
            "Do you feel that your customers are satisfied with your delivery times?",
            "Are your customers accepting of your delivery times?"
        ];
        // Créer un tableau de questions/réponses pour toutes les questions
        const data = allQuestions.map((question)=>{
            const answer = selectedOptions[question] || "No";
            return {
                question: question,
                answer: answer,
                category: "leadTime",
                enterpriseId: enterpriseId,
                userId: userId || "",
                section: "leadtime-2",
                timestamp: new Date().toISOString()
            };
        });
        // Vérifier que les données sont correctement formatées
        const isValidData = data.every((item)=>item.question && item.answer && item.category && item.enterpriseId);
        if (!isValidData) {
            console.error("Donn\xe9es invalides:", data);
            setErrorMessage("Format de donn\xe9es invalide");
            setIsLoading(false);
            return;
        }
        // Sauvegarder les données pour une utilisation ultérieure
        l_allData2 = [
            ...data
        ];
        console.log("Donn\xe9es \xe0\xa0 envoyer:", JSON.stringify(data, null, 2));
        // Calculer la somme des scores
        const leadTime1Score = parseInt(localStorage.getItem('leadTime1Score') || 0);
        l_sum = leadTime1Score + l_yesCount2;
        console.log("Score total Leadtime:", l_sum);
        // Appel API pour sauvegarder les données
        fetch("/api/api/save-answers", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
            },
            body: JSON.stringify(data)
        }).then((response)=>{
            if (!response.ok) throw new Error(`Erreur de sauvegarde (${response.status})`);
            return response.json();
        }).then((result)=>{
            console.log("Data saved successfully:", result);
            // Sauvegarder le score dans le localStorage
            localStorage.setItem('leadTime2Score', l_yesCount2);
            console.log(`Score leadTime2 mis \xe0\xa0 jour: ${l_yesCount2}`);
            // Sauvegarder également le score total leadtime
            const scoreData = [
                {
                    question: "LeadTime Total Score Final",
                    answer: l_sum.toString(),
                    category: "leadTime",
                    enterpriseId: enterpriseId,
                    userId: userId || "",
                    section: "leadtime-total-final",
                    timestamp: new Date().toISOString()
                }
            ];
            console.log("Envoi du score total leadTime:", JSON.stringify(scoreData, null, 2));
            // Appel API pour sauvegarder le score total
            return fetch("/api/api/save-answers", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
                },
                body: JSON.stringify(scoreData)
            });
        }).then((response)=>{
            if (!response || !response.ok) throw new Error("Failed to save total score");
            return response.json();
        }).then((scoreResponse)=>{
            console.log("Score total leadTime enregistr\xe9 avec succ\xe8s:", scoreResponse);
            // Récupérer correctement les données de tous les composants
            const allLeadtimeData = [];
            // Utiliser des try/catch pour éviter les erreurs si certaines données sont manquantes
            try {
                if (Array.isArray((0, _leadTime1.l_allData1)) && (0, _leadTime1.l_allData1).length > 0) allLeadtimeData.push(...(0, _leadTime1.l_allData1));
                if (Array.isArray(l_allData2) && l_allData2.length > 0) allLeadtimeData.push(...l_allData2);
            } catch (error) {
                console.error("Erreur lors de la concat\xe9nation des donn\xe9es:", error);
            }
            console.log("Toutes les donn\xe9es LeadTime pour le PDF:", allLeadtimeData.length, "questions");
            // Générer le PDF avec toutes les données
            generatePdf(allLeadtimeData);
            // Redirection vers la page suivante
            setIsLoading(false);
            history.push("/cost-1");
        }).catch((error)=>{
            console.error("Error saving data:", error);
            setErrorMessage("Error saving data. Please try again.");
            console.error("D\xe9tails de l'erreur:", error.message);
            // Màªme en cas d'erreur, essayer de générer le PDF avec les données disponibles
            const allLeadtimeData = [];
            try {
                if (Array.isArray((0, _leadTime1.l_allData1)) && (0, _leadTime1.l_allData1).length > 0) allLeadTimeData.push(...(0, _leadTime1.l_allData1));
                if (Array.isArray(l_allData2) && l_allData2.length > 0) allLeadTimeData.push(...l_allData2);
            } catch (error) {
                console.error("Erreur lors de la concat\xe9nation des donn\xe9es:", error);
            }
            generatePdf(allLeadtimeData);
            // Redirection malgré l'erreur
            setIsLoading(false);
            history.push("/cost-1");
        });
    }
    function generatePdf(l_allData) {
        // Vérifier si des données existent
        if (!l_allData || l_allData.length === 0) {
            console.error("Aucune donn\xe9e disponible pour g\xe9n\xe9rer le PDF");
            return;
        }
        console.log("G\xe9n\xe9ration du PDF avec", l_allData.length, "questions");
        // Créer un nouveau document PDF
        const doc = new (0, _jspdfDefault.default)();
        const lineHeight = 10;
        const pageHeight = doc.internal.pageSize.height - 20;
        const pageWidth = doc.internal.pageSize.width - 20;
        let y = 20;
        // Ajouter un titre
        doc.setFontSize(16);
        doc.text("Lead Time Assessment Results", 105, y, {
            align: "center"
        });
        y += 15;
        // Ajouter le score total
        doc.setFontSize(14);
        doc.text(`Total Score: ${l_sum} / ${l_allData.length}`, 105, y, {
            align: "center"
        });
        y += 15;
        doc.setFontSize(12);
        // Parcourir les données et ajouter chaque question et réponse au document PDF
        l_allData.forEach((data, index)=>{
            // Vérifier si les données sont valides
            if (!data || !data.question) {
                console.error("Donn\xe9es invalides pour l'\xe9l\xe9ment", index);
                return;
            }
            const question = `Question ${index + 1}: ${data.question}`;
            const answer = `Answer: ${data.answer || 'No answer'}`;
            // Estimer la hauteur du texte après division pour mieux gérer les sauts de page
            const splitQuestion = doc.splitTextToSize(question, pageWidth);
            const estimatedHeight = splitQuestion.length * lineHeight + lineHeight * 2;
            // Vérifier si on doit passer à  une nouvelle page
            if (y + estimatedHeight > pageHeight) {
                doc.addPage();
                y = 20;
            }
            // à‰crire la question et la réponse dans le PDF
            doc.text(splitQuestion, 10, y);
            y += splitQuestion.length * lineHeight;
            doc.text(answer, 10, y);
            y += lineHeight * 2; // Ajouter un peu d'espace entre les questions
        });
        // Ajouter une page de résumé
        doc.addPage();
        y = 20;
        doc.setFontSize(16);
        doc.text("Summary of Lead Time Assessment", 105, y, {
            align: "center"
        });
        y += 20;
        doc.setFontSize(12);
        doc.text(`Total number of questions: ${l_allData.length}`, 10, y);
        y += lineHeight;
        doc.text(`Total "Yes" answers: ${l_sum}`, 10, y);
        y += lineHeight;
        doc.text(`Score percentage: ${Math.round(l_sum / l_allData.length * 100)}%`, 10, y);
        y += lineHeight * 2;
        const date = new Date();
        doc.text(`Generated on: ${date.toLocaleDateString()} at ${date.toLocaleTimeString()}`, 10, y);
        // Enregistrer le document PDF
        doc.save("LeadTime_Assessment_Complete.pdf");
        console.log("PDF Lead Time g\xe9n\xe9r\xe9 avec succ\xe8s");
    }
    function calculateProgressPercentage() {
        const totalQuestions = document.getElementsByTagName("section").length;
        if (totalQuestions === 0) return 0;
        return Math.round(l_yesCount2 / totalQuestions * 100);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "environmental-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "environmental-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    className: "environmental-title",
                    children: "PLEASE ANSWER THE FOLLOWING QUESTIONS"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "progress-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "progress-bar",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "progress-fill",
                                style: {
                                    width: `${calculateProgressPercentage()}%`
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "progress-text",
                            children: [
                                "Your score: ",
                                l_yesCount2,
                                " / ",
                                totalQuestions,
                                " (",
                                calculateProgressPercentage(),
                                "%)"
                            ]
                        })
                    ]
                }),
                errorMessage && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "error-message",
                    children: errorMessage
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questions-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Are you experiencing production delays due to technical problems?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Are you experiencing production delays due to technical problems?", "Yes"),
                                            className: `btn-option ${selectedOptions["Are you experiencing production delays due to technical problems?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Are you experiencing production delays due to technical problems?", "No"),
                                            className: `btn-option ${selectedOptions["Are you experiencing production delays due to technical problems?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Have measures been put in place to avoid these inconveniences?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Have measures been put in place to avoid these inconveniences?", "Yes"),
                                            className: `btn-option ${selectedOptions["Have measures been put in place to avoid these inconveniences?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Have measures been put in place to avoid these inconveniences?", "No"),
                                            className: `btn-option ${selectedOptions["Have measures been put in place to avoid these inconveniences?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Are you experiencing delays in product (or service) delivery to your customers?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Are you experiencing delays in product (or service) delivery to your customers?", "Yes"),
                                            className: `btn-option ${selectedOptions["Are you experiencing delays in product (or service) delivery to your customers?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Are you experiencing delays in product (or service) delivery to your customers?", "No"),
                                            className: `btn-option ${selectedOptions["Are you experiencing delays in product (or service) delivery to your customers?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have shipping delay problems when delivering to your customers?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have shipping delay problems when delivering to your customers?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have shipping delay problems when delivering to your customers?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have shipping delay problems when delivering to your customers?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have shipping delay problems when delivering to your customers?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you feel that your customers are satisfied with your delivery times?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you feel that your customers are satisfied with your delivery times?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you feel that your customers are satisfied with your delivery times?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you feel that your customers are satisfied with your delivery times?", "No"),
                                            className: `btn-option ${selectedOptions["Do you feel that your customers are satisfied with your delivery times?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Are your customers accepting of your delivery times?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Are your customers accepting of your delivery times?", "Yes"),
                                            className: `btn-option ${selectedOptions["Are your customers accepting of your delivery times?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Are your customers accepting of your delivery times?", "No"),
                                            className: `btn-option ${selectedOptions["Are your customers accepting of your delivery times?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "form-actions",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/lead-time-1",
                            className: "btn-secondary",
                            children: "Back"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "btn-primary",
                            children: "Submit Lead Time Assessment"
                        })
                    ]
                }),
                isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "loading-indicator",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "spinner"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: "Saving data and generating PDF..."
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = LeadTime2;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["Link","b9X5n"],["useHistory","ditZI"]],"../NavItems3":"fOarC","../NavItems2":"bnQuI","./LeadTime2.css":"4gRdd","../../styleguide.css":"8Y7Ec","jspdf":"hkJ4Q","../LeadTime1":"jxVZX","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4gRdd":[function() {},{}],"8Y7Ec":[function() {},{}],"jxVZX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "l_allData1", ()=>l_allData1);
parcelHelpers.export(exports, "l_yesCount1", ()=>l_yesCount1);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _leadTime1Css = require("./LeadTime1.css");
var _styleguideCss = require("../../styleguide.css");
let l_allData1 = [];
let l_yesCount1 = 0;
function LeadTime1(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const { x1200PxLogo_Icam__20081, navItems3Props } = props;
    (0, _react.useEffect)(()=>{
        // Calculate the total number of questions based on sections
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []); // Run this effect only once when the component mounts
    function clicked(question, option) {
        // Si l'option cliquée est la màªme que celle déjà  sélectionnée, on la désélectionne
        if (selectedOptions[question] === option) {
            setSelectedOptions((prevSelectedOptions)=>{
                const newOptions = {
                    ...prevSelectedOptions
                };
                delete newOptions[question];
                return newOptions;
            });
            // Si on désélectionne un "Yes", on décrémente le score
            if (option === "Yes") l_yesCount1--;
            return;
        }
        // Sinon, on met à  jour la sélection
        const previousOption = selectedOptions[question];
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        // Si on passe de "No" à  "Yes", on incrémente le score
        if (option === "Yes" && previousOption !== "Yes") l_yesCount1++;
        else if (option === "No" && previousOption === "Yes") l_yesCount1--;
    }
    const history = (0, _reactRouterDom.useHistory)();
    function saveData() {
        setIsLoading(true);
        setErrorMessage("");
        console.log("D\xe9but de sauvegarde des donn\xe9es LeadTime1");
        const enterpriseId = localStorage.getItem("enterpriseId");
        const userId = localStorage.getItem("userId");
        if (!enterpriseId) {
            console.error("ERREUR: ID d'entreprise manquant");
            setErrorMessage("ID d'entreprise manquant. Veuillez retourner \xe0\xa0 la s\xe9lection d'entreprise.");
            setIsLoading(false);
            return;
        }
        // Définir toutes les questions possibles
        const allQuestions = [
            "Do you have a delay rate?",
            "If so, how much is it?",
            "What are the causes of the delay?",
            "What is the average lead time in days?",
            "Are your lead times documented (process mapping)?",
            "Do you have systems to manage and monitor lead time?",
            "Is lead time a KPI for you?",
            "Do you have an on-time delivery rate?",
            "Do you have a standard lead time (Takt time)?"
        ];
        // Créer un tableau de questions/réponses pour toutes les questions
        const data = allQuestions.map((question)=>{
            const answer = selectedOptions[question] || "No";
            return {
                question: question,
                answer: answer,
                category: "leadTime",
                enterpriseId: enterpriseId,
                userId: userId || "",
                section: "leadtime-1",
                timestamp: new Date().toISOString()
            };
        });
        // Vérifier que les données sont correctement formatées
        const isValidData = data.every((item)=>item.question && item.answer && item.category && item.enterpriseId);
        if (!isValidData) {
            console.error("Donn\xe9es invalides:", data);
            setErrorMessage("Format de donn\xe9es invalide");
            setIsLoading(false);
            return;
        }
        // Sauvegarder les données pour une utilisation ultérieure
        l_allData1 = [
            ...data
        ];
        console.log("Donn\xe9es \xe0\xa0 envoyer:", JSON.stringify(data, null, 2));
        // Appel API pour sauvegarder les données
        fetch("/api/api/save-answers", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
            },
            body: JSON.stringify(data)
        }).then((response)=>{
            if (!response.ok) throw new Error(`Erreur de sauvegarde (${response.status})`);
            return response.json();
        }).then((result)=>{
            console.log("Data saved successfully:", result);
            // Sauvegarder le score dans le localStorage
            localStorage.setItem('leadTime1Score', l_yesCount1);
            console.log(`Score leadTime1 mis \xe0\xa0 jour: ${l_yesCount1}`);
            setIsLoading(false);
            history.push("/lead-time-2");
        }).catch((error)=>{
            console.error("Error saving data:", error);
            setErrorMessage("Error saving data. Please try again.");
            console.error("D\xe9tails de l'erreur:", error.message);
            setIsLoading(false);
            history.push("/lead-time-2");
        });
    }
    function calculateProgressPercentage() {
        const totalQuestions = document.getElementsByTagName("section").length;
        if (totalQuestions === 0) return 0;
        return Math.round(l_yesCount1 / totalQuestions * 100);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "environmental-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "environmental-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    className: "environmental-title",
                    children: "PLEASE ANSWER THE FOLLOWING QUESTIONS"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "progress-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "progress-bar",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "progress-fill",
                                style: {
                                    width: `${calculateProgressPercentage()}%`
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "progress-text",
                            children: [
                                "Your score: ",
                                l_yesCount1,
                                " / ",
                                totalQuestions,
                                " (",
                                calculateProgressPercentage(),
                                "%)"
                            ]
                        })
                    ]
                }),
                errorMessage && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "error-message",
                    children: errorMessage
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questions-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have a delay rate?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a delay rate?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have a delay rate?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a delay rate?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have a delay rate?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "If so, how much is it?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("If so, how much is it?", "Yes"),
                                            className: `btn-option ${selectedOptions["If so, how much is it?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("If so, how much is it?", "No"),
                                            className: `btn-option ${selectedOptions["If so, how much is it?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Can your suppliers be flexible to your demand?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Can your suppliers be flexible to your demand?", "Yes"),
                                            className: `btn-option ${selectedOptions["Can your suppliers be flexible to your demand?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Can your suppliers be flexible to your demand?", "No"),
                                            className: `btn-option ${selectedOptions["Can your suppliers be flexible to your demand?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "If not, can you change suppliers quickly if the supplier does not meet your expectations?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("If not, can you change suppliers quickly if the supplier does not meet your expectations?", "Yes"),
                                            className: `btn-option ${selectedOptions["If not, can you change suppliers quickly if the supplier does not meet your expectations?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("If not, can you change suppliers quickly if the supplier does not meet your expectations?", "No"),
                                            className: `btn-option ${selectedOptions["If not, can you change suppliers quickly if the supplier does not meet your expectations?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "If no, can you change suppliers quickly if the supplier does not meet your expectations?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("If no, can you change suppliers quickly if the supplier does not meet your expectations?", "Yes"),
                                            className: `btn-option ${selectedOptions["If no, can you change suppliers quickly if the supplier does not meet your expectations?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("If no, can you change suppliers quickly if the supplier does not meet your expectations?", "No"),
                                            className: `btn-option ${selectedOptions["If no, can you change suppliers quickly if the supplier does not meet your expectations?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have calculation methods for making purchase forecasts?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have calculation methods for making purchase forecasts?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have calculation methods for making purchase forecasts?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have calculation methods for making purchase forecasts?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have calculation methods for making purchase forecasts?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have a safety stock?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a safety stock?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have a safety stock?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a safety stock?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have a safety stock?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have buffer stocks?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have buffer stocks?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have buffer stocks?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have buffer stocks?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have buffer stocks?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "form-actions",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/modernization-4",
                            className: "btn-secondary",
                            children: "Back"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "btn-primary",
                            children: "Next"
                        })
                    ]
                }),
                isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "loading-indicator",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "spinner"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: "Saving data..."
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = LeadTime1;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["Link","b9X5n"],["useHistory","ditZI"]],"../NavItems3":"fOarC","../NavItems2":"bnQuI","./LeadTime1.css":"7x6oZ","../../styleguide.css":"8Y7Ec","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7x6oZ":[function() {},{}],"8Y7Ec":[function() {},{}],"eoJTs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "c_allData2", ()=>c_allData2);
parcelHelpers.export(exports, "c_yesCount2", ()=>c_yesCount2);
parcelHelpers.export(exports, "c_sum", ()=>c_sum);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _cost2Css = require("./Cost2.css");
var _styleguideCss = require("../../styleguide.css");
var _jspdf = require("jspdf");
var _jspdfDefault = parcelHelpers.interopDefault(_jspdf);
var _cost1 = require("../Cost1");
let c_allData2 = [];
let c_yesCount2 = 0;
let c_sum = 0;
function Cost2(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const { x1200PxLogo_Icac__20081, qualityCriteria } = props;
    (0, _react.useEffect)(()=>{
        // Calculate the total number of questions based on sections
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []); // Run this effect only once when the component mounts
    function clicked(question, option) {
        // Si l'option cliquée est la màªme que celle déjà  sélectionnée, on la désélectionne
        if (selectedOptions[question] === option) {
            setSelectedOptions((prevSelectedOptions)=>{
                const newOptions = {
                    ...prevSelectedOptions
                };
                delete newOptions[question];
                return newOptions;
            });
            // Si on désélectionne un "Yes", on décrémente le score
            if (option === "Yes") c_yesCount2--;
            return;
        }
        // Sinon, on met à  jour la sélection
        const previousOption = selectedOptions[question];
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        // Si on passe de "No" à  "Yes", on incrémente le score
        if (option === "Yes" && previousOption !== "Yes") c_yesCount2++;
        else if (option === "No" && previousOption === "Yes") c_yesCount2--;
    }
    const history = (0, _reactRouterDom.useHistory)();
    function saveData() {
        setIsLoading(true);
        setErrorMessage("");
        console.log("D\xe9but de sauvegarde des donn\xe9es Cost2");
        const enterpriseId = localStorage.getItem("enterpriseId");
        const userId = localStorage.getItem("userId");
        if (!enterpriseId) {
            console.error("ERREUR: ID d'entreprise manquant");
            setErrorMessage("ID d'entreprise manquant. Veuillez retourner \xe0\xa0 la s\xe9lection d'entreprise.");
            setIsLoading(false);
            return;
        }
        // Définir toutes les questions possibles
        const allQuestions = [
            "Do you have a method to calculate production costs?",
            "Do you have a method of analysis for the costs of non-quality?",
            "Do you monitor your obsolete inventory?",
            "Have you identified your costs that do not add value to your product?",
            "Do you have a method of assessing supply chain cost risks?",
            "Do you measure the cost of shipping materials?",
            "Do you know the cost of capital employed?",
            "Do you know your employee productivity rates and costs for each operation?",
            "Do you have a budget system (annual or multi-year)?"
        ];
        // Créer un tableau de questions/réponses pour toutes les questions
        const data = allQuestions.map((question)=>{
            const answer = selectedOptions[question] || "No";
            return {
                question: question,
                answer: answer,
                category: "cost",
                enterpriseId: enterpriseId,
                userId: userId || "",
                section: "cost-2",
                timestamp: new Date().toISOString()
            };
        });
        // Vérifier que les données sont correctement formatées
        const isValidData = data.every((item)=>item.question && item.answer && item.category && item.enterpriseId);
        if (!isValidData) {
            console.error("Donn\xe9es invalides:", data);
            setErrorMessage("Format de donn\xe9es invalide");
            setIsLoading(false);
            return;
        }
        // Sauvegarder les données pour une utilisation ultérieure
        c_allData2 = [
            ...data
        ];
        console.log("Donn\xe9es \xe0\xa0 envoyer:", JSON.stringify(data, null, 2));
        // Calculer la somme des scores Cost1 et Cost2
        const cost1Score = parseInt(localStorage.getItem('cost1Score') || 0);
        c_sum = cost1Score + c_yesCount2;
        console.log("Score total Cost:", c_sum);
        // Appel API pour sauvegarder les données
        fetch("/api/api/save-answers", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
            },
            body: JSON.stringify(data)
        }).then((response)=>{
            if (!response.ok) throw new Error(`Erreur de sauvegarde (${response.status})`);
            return response.json();
        }).then((result)=>{
            console.log("Data saved successfully:", result);
            // Sauvegarder le score dans le localStorage
            localStorage.setItem('cost2Score', c_yesCount2);
            console.log(`Score cost2 mis \xe0\xa0 jour: ${c_yesCount2}`);
            // Sauvegarder également le score total cost
            const scoreData = [
                {
                    question: "Cost Total Score Final",
                    answer: c_sum.toString(),
                    category: "cost",
                    enterpriseId: enterpriseId,
                    userId: userId || "",
                    section: "cost-total-final",
                    timestamp: new Date().toISOString()
                }
            ];
            console.log("Envoi du score total cost:", JSON.stringify(scoreData, null, 2));
            // Appel API pour sauvegarder le score total
            return fetch("/api/api/save-answers", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
                },
                body: JSON.stringify(scoreData)
            });
        }).then((response)=>{
            if (!response || !response.ok) throw new Error("Failed to save total score");
            return response.json();
        }).then((scoreResponse)=>{
            console.log("Score total cost enregistr\xe9 avec succ\xe8s:", scoreResponse);
            // Récupérer correctement les données de tous les composants
            const allCostData = [];
            // Utiliser des try/catch pour éviter les erreurs si certaines données sont manquantes
            try {
                if (Array.isArray((0, _cost1.c_allData1)) && (0, _cost1.c_allData1).length > 0) allCostData.push(...(0, _cost1.c_allData1));
                if (Array.isArray(c_allData2) && c_allData2.length > 0) allCostData.push(...c_allData2);
            } catch (error) {
                console.error("Erreur lors de la concat\xe9nation des donn\xe9es:", error);
            }
            console.log("Toutes les donn\xe9es Cost pour le PDF:", allCostData.length, "questions");
            // Générer le PDF avec toutes les données
            generatePdf(allCostData);
            // Redirection vers la page suivante
            setIsLoading(false);
            history.push("/Quality-1");
        }).catch((error)=>{
            console.error("Error saving data:", error);
            setErrorMessage("Error saving data. Please try again.");
            console.error("D\xe9tails de l'erreur:", error.message);
            // Màªme en cas d'erreur, essayer de générer le PDF avec les données disponibles
            const allCostData = [];
            try {
                if (Array.isArray((0, _cost1.c_allData1)) && (0, _cost1.c_allData1).length > 0) allCostData.push(...(0, _cost1.c_allData1));
                if (Array.isArray(c_allData2) && c_allData2.length > 0) allCostData.push(...c_allData2);
            } catch (error) {
                console.error("Erreur lors de la concat\xe9nation des donn\xe9es:", error);
            }
            generatePdf(allCostData);
            // Redirection malgré l'erreur
            setIsLoading(false);
            history.push("/Quality-1");
        });
    }
    function generatePdf(allData) {
        // Vérifier si des données existent
        if (!allData || allData.length === 0) {
            console.error("Aucune donn\xe9e disponible pour g\xe9n\xe9rer le PDF");
            return;
        }
        console.log("G\xe9n\xe9ration du PDF avec", allData.length, "questions");
        // Créer un nouveau document PDF
        const doc = new (0, _jspdfDefault.default)();
        const lineHeight = 10;
        const pageHeight = doc.internal.pageSize.height - 20;
        const pageWidth = doc.internal.pageSize.width - 20;
        let y = 20;
        // Ajouter un titre
        doc.setFontSize(16);
        doc.text("Cost Assessment Results", 105, y, {
            align: "center"
        });
        y += 15;
        // Ajouter le score total
        doc.setFontSize(14);
        doc.text(`Total Score: ${c_sum} / ${allData.length}`, 105, y, {
            align: "center"
        });
        y += 15;
        doc.setFontSize(12);
        // Parcourir les données et ajouter chaque question et réponse au document PDF
        allData.forEach((data, index)=>{
            // Vérifier si les données sont valides
            if (!data || !data.question) {
                console.error("Donn\xe9es invalides pour l'\xe9l\xe9ment", index);
                return;
            }
            const question = `Question ${index + 1}: ${data.question}`;
            const answer = `Answer: ${data.answer || 'No answer'}`;
            // Estimer la hauteur du texte après division pour mieux gérer les sauts de page
            const splitQuestion = doc.splitTextToSize(question, pageWidth);
            const estimatedHeight = splitQuestion.length * lineHeight + lineHeight * 2;
            // Vérifier si on doit passer à  une nouvelle page
            if (y + estimatedHeight > pageHeight) {
                doc.addPage();
                y = 20;
            }
            // à‰crire la question et la réponse dans le PDF
            doc.text(splitQuestion, 10, y);
            y += splitQuestion.length * lineHeight;
            doc.text(answer, 10, y);
            y += lineHeight * 2; // Ajouter un peu d'espace entre les questions
        });
        // Ajouter une page de résumé
        doc.addPage();
        y = 20;
        doc.setFontSize(16);
        doc.text("Summary of Cost Assessment", 105, y, {
            align: "center"
        });
        y += 20;
        doc.setFontSize(12);
        doc.text(`Total number of questions: ${allData.length}`, 10, y);
        y += lineHeight;
        doc.text(`Total "Yes" answers: ${c_sum}`, 10, y);
        y += lineHeight;
        doc.text(`Score percentage: ${Math.round(c_sum / allData.length * 100)}%`, 10, y);
        y += lineHeight * 2;
        const date = new Date();
        doc.text(`Generated on: ${date.toLocaleDateString()} at ${date.toLocaleTimeString()}`, 10, y);
        // Enregistrer le document PDF
        doc.save("Cost_Assessment_Complete.pdf");
        console.log("PDF Cost g\xe9n\xe9r\xe9 avec succ\xe8s");
    }
    function calculateProgressPercentage() {
        if (totalQuestions === 0) return 0;
        return Math.round(c_yesCount2 / totalQuestions * 100);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "environmental-container",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("app-header", {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "environmental-content",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                        className: "environmental-title",
                        children: "COST ASSESSMENT - PART 2"
                    }),
                    errorMessage && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "error-message",
                        children: errorMessage
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "progress-container",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "progress-bar",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "progress-fill",
                                    style: {
                                        width: `${calculateProgressPercentage()}%`
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                className: "progress-text",
                                children: [
                                    "Your score: ",
                                    c_yesCount2,
                                    " / ",
                                    totalQuestions,
                                    " (",
                                    calculateProgressPercentage(),
                                    "%)"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "questions-container",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                className: "question-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "question-text",
                                        children: "Do you have a budget for machine maintenance?"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "question-actions",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>clicked("Do you have a budget for machine maintenance?", "Yes"),
                                                className: `btn-option ${selectedOptions["Do you have a budget for machine maintenance?"] === "Yes" ? "enabled" : ""}`,
                                                children: "Yes"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>clicked("Do you have a budget for machine maintenance?", "No"),
                                                className: `btn-option ${selectedOptions["Do you have a budget for machine maintenance?"] === "No" ? "enabled" : ""}`,
                                                children: "No"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                className: "question-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "question-text",
                                        children: "Have you defined a budget for external services?"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "question-actions",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>clicked("Have you defined a budget for external services?", "Yes"),
                                                className: `btn-option ${selectedOptions["Have you defined a budget for external services?"] === "Yes" ? "enabled" : ""}`,
                                                children: "Yes"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>clicked("Have you defined a budget for external services?", "No"),
                                                className: `btn-option ${selectedOptions["Have you defined a budget for external services?"] === "No" ? "enabled" : ""}`,
                                                children: "No"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                className: "question-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "question-text",
                                        children: "Do you have different suppliers?"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "question-actions",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>clicked("Do you have different suppliers?", "Yes"),
                                                className: `btn-option ${selectedOptions["Do you have different suppliers?"] === "Yes" ? "enabled" : ""}`,
                                                children: "Yes"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>clicked("Do you have different suppliers?", "No"),
                                                className: `btn-option ${selectedOptions["Do you have different suppliers?"] === "No" ? "enabled" : ""}`,
                                                children: "No"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                className: "question-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "question-text",
                                        children: "Are you able to change suppliers depending on prices?"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "question-actions",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>clicked("Are you able to change suppliers depending on prices?", "Yes"),
                                                className: `btn-option ${selectedOptions["Are you able to change suppliers depending on prices?"] === "Yes" ? "enabled" : ""}`,
                                                children: "Yes"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>clicked("Are you able to change suppliers depending on prices?", "No"),
                                                className: `btn-option ${selectedOptions["Are you able to change suppliers depending on prices?"] === "No" ? "enabled" : ""}`,
                                                children: "No"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                className: "question-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "question-text",
                                        children: "Do you control your transport costs?"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "question-actions",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>clicked("Do you control your transport costs?", "Yes"),
                                                className: `btn-option ${selectedOptions["Do you control your transport costs?"] === "Yes" ? "enabled" : ""}`,
                                                children: "Yes"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>clicked("Do you control your transport costs?", "No"),
                                                className: `btn-option ${selectedOptions["Do you control your transport costs?"] === "No" ? "enabled" : ""}`,
                                                children: "No"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                className: "question-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "question-text",
                                        children: "Do you know the price of the product excluding raw materials?"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "question-actions",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>clicked("Do you know the price of the product excluding raw materials?", "Yes"),
                                                className: `btn-option ${selectedOptions["Do you know the price of the product excluding raw materials?"] === "Yes" ? "enabled" : ""}`,
                                                children: "Yes"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>clicked("Do you know the price of the product excluding raw materials?", "No"),
                                                className: `btn-option ${selectedOptions["Do you know the price of the product excluding raw materials?"] === "No" ? "enabled" : ""}`,
                                                children: "No"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                className: "question-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "question-text",
                                        children: "Do you know the economic losses linked to the non-conforming product (disquality)?"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "question-actions",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>clicked("Do you know the economic losses linked to the non-conforming product (disquality)?", "Yes"),
                                                className: `btn-option ${selectedOptions["Do you know the economic losses linked to the non-conforming product (disquality)?"] === "Yes" ? "enabled" : ""}`,
                                                children: "Yes"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>clicked("Do you know the economic losses linked to the non-conforming product (disquality)?", "No"),
                                                className: `btn-option ${selectedOptions["Do you know the economic losses linked to the non-conforming product (disquality)?"] === "No" ? "enabled" : ""}`,
                                                children: "No"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                className: "question-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "question-text",
                                        children: 'Do you plan a budget for non-voluntary "breakage"?'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "question-actions",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>clicked("Do you plan a budget for non-voluntary \"breakage\"?", "Yes"),
                                                className: `btn-option ${selectedOptions["Do you plan a budget for non-voluntary \"breakage\"?"] === "Yes" ? "enabled" : ""}`,
                                                children: "Yes"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>clicked("Do you plan a budget for non-voluntary \"breakage\"?", "No"),
                                                className: `btn-option ${selectedOptions["Do you plan a budget for non-voluntary \"breakage\"?"] === "No" ? "enabled" : ""}`,
                                                children: "No"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                className: "question-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "question-text",
                                        children: "Do you know your optimal quantity of product to be profitable?"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "question-actions",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>clicked("Do you know your optimal quantity of product to be profitable?", "Yes"),
                                                className: `btn-option ${selectedOptions["Do you know your optimal quantity of product to be profitable?"] === "Yes" ? "enabled" : ""}`,
                                                children: "Yes"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>clicked("Do you know your optimal quantity of product to be profitable?", "No"),
                                                className: `btn-option ${selectedOptions["Do you know your optimal quantity of product to be profitable?"] === "No" ? "enabled" : ""}`,
                                                children: "No"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "form-actions",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                to: "/cost-1",
                                className: "btn-secondary",
                                children: "Back"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                onClick: saveData,
                                className: "btn-primary",
                                children: qualityCriteria || "Continue to Next Section"
                            })
                        ]
                    })
                ]
            }),
            isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "loading-indicator",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "spinner"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "Saving data and generating PDF..."
                    })
                ]
            })
        ]
    });
}
exports.default = Cost2;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["Link","b9X5n"],["useHistory","ditZI"]],"./Cost2.css":"8zPSX","../../styleguide.css":"8Y7Ec","jspdf":"hkJ4Q","../Cost1":"iIT4b","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8zPSX":[function() {},{}],"8Y7Ec":[function() {},{}],"iIT4b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "c_allData1", ()=>c_allData1);
parcelHelpers.export(exports, "c_yesCount1", ()=>c_yesCount1);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _frame136 = require("../Frame136");
var _frame136Default = parcelHelpers.interopDefault(_frame136);
var _frame144 = require("../Frame144");
var _frame144Default = parcelHelpers.interopDefault(_frame144);
var _frame11732 = require("../Frame11732");
var _frame11732Default = parcelHelpers.interopDefault(_frame11732);
var _cost1Css = require("./Cost1.css");
var _styleguideCss = require("../../styleguide.css");
let c_allData1 = [];
let c_yesCount1 = 0;
function Cost1(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const { x1200PxLogo_Icam__20081, pleaseAnswerTheFollowingQuestions, toggle1Props, toggle2Props, toggle3Props, toggle4Props } = props;
    (0, _react.useEffect)(()=>{
        // Calculate the total number of questions based on sections
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []); // Run this effect only once when the component mounts
    function clicked(question, option) {
        // Si l'option cliquée est la màªme que celle déjà  sélectionnée, on la désélectionne
        if (selectedOptions[question] === option) {
            setSelectedOptions((prevSelectedOptions)=>{
                const newOptions = {
                    ...prevSelectedOptions
                };
                delete newOptions[question];
                return newOptions;
            });
            // Si on désélectionne un "Yes", on décrémente le score
            if (option === "Yes") c_yesCount1--;
            return;
        }
        // Sinon, on met à  jour la sélection
        const previousOption = selectedOptions[question];
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        // Si on passe de "No" à  "Yes", on incrémente le score
        if (option === "Yes" && previousOption !== "Yes") c_yesCount1++;
        else if (option === "No" && previousOption === "Yes") c_yesCount1--;
    }
    const history = (0, _reactRouterDom.useHistory)();
    function saveData() {
        setIsLoading(true);
        setErrorMessage("");
        console.log("D\xe9but de sauvegarde des donn\xe9es Cost1");
        const enterpriseId = localStorage.getItem("enterpriseId");
        const userId = localStorage.getItem("userId");
        if (!enterpriseId) {
            console.error("ERREUR: ID d'entreprise manquant");
            setErrorMessage("ID d'entreprise manquant. Veuillez retourner \xe0\xa0 la s\xe9lection d'entreprise.");
            setIsLoading(false);
            return;
        }
        // Définir toutes les questions possibles
        const allQuestions = [
            "Do you have a follow-up of raw materials, stocks... (ex: ERP)?",
            "Do you have a current average cost price?",
            "Do you have a margin calculation?",
            "Do you have a material replenishment system?",
            "Do you have dedicated resources who are responsible for purchasing and managing inventory?",
            "Do you have a method of receiving orders and forecasts from your customers?",
            "Do you have a specific system to monitor profitability?",
            "Do you have defined KPIs for cost efficiency?",
            "Do you carry out periodic stock inventory control?"
        ];
        // Créer un tableau de questions/réponses pour toutes les questions
        const data = allQuestions.map((question)=>{
            const answer = selectedOptions[question] || "No";
            return {
                question: question,
                answer: answer,
                category: "cost",
                enterpriseId: enterpriseId,
                userId: userId || "",
                section: "cost-1",
                timestamp: new Date().toISOString()
            };
        });
        // Vérifier que les données sont correctement formatées
        const isValidData = data.every((item)=>item.question && item.answer && item.category && item.enterpriseId);
        if (!isValidData) {
            console.error("Donn\xe9es invalides:", data);
            setErrorMessage("Format de donn\xe9es invalide");
            setIsLoading(false);
            return;
        }
        // Sauvegarder les données pour une utilisation ultérieure
        c_allData1 = [
            ...data
        ];
        console.log("Donn\xe9es \xe0\xa0 envoyer:", JSON.stringify(data, null, 2));
        // Appel API pour sauvegarder les données
        fetch("/api/api/save-answers", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
            },
            body: JSON.stringify(data)
        }).then((response)=>{
            if (!response.ok) throw new Error(`Erreur de sauvegarde (${response.status})`);
            return response.json();
        }).then((result)=>{
            console.log("Data saved successfully:", result);
            // Sauvegarder le score dans le localStorage
            localStorage.setItem('cost1Score', c_yesCount1);
            console.log(`Score cost1 mis \xe0\xa0 jour: ${c_yesCount1}`);
            setIsLoading(false);
            history.push("/cost-2");
        }).catch((error)=>{
            console.error("Error saving data:", error);
            setErrorMessage("Error saving data. Please try again.");
            console.error("D\xe9tails de l'erreur:", error.message);
            setIsLoading(false);
            history.push("/cost-2");
        });
    }
    function calculateProgressPercentage() {
        if (totalQuestions === 0) return 0;
        return Math.round(c_yesCount1 / totalQuestions * 100);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "environmental-container",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("app-header", {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "environmental-content",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                        className: "environmental-title",
                        children: pleaseAnswerTheFollowingQuestions || "COST ASSESSMENT"
                    }),
                    errorMessage && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "error-message",
                        children: errorMessage
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "progress-container",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "progress-bar",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "progress-fill",
                                    style: {
                                        width: `${calculateProgressPercentage()}%`
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                className: "progress-text",
                                children: [
                                    "Your score: ",
                                    c_yesCount1,
                                    " / ",
                                    totalQuestions,
                                    " (",
                                    calculateProgressPercentage(),
                                    "%)"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "questions-container",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                className: "question-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "question-text",
                                        children: "Do you have a follow-up of raw materials, stocks... (ex: ERP)?"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "question-actions",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>clicked("Do you have a follow-up of raw materials, stocks... (ex: ERP)?", "Yes"),
                                                className: `btn-option ${selectedOptions["Do you have a follow-up of raw materials, stocks... (ex: ERP)?"] === "Yes" ? "enabled" : ""}`,
                                                children: "Yes"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>clicked("Do you have a follow-up of raw materials, stocks... (ex: ERP)?", "No"),
                                                className: `btn-option ${selectedOptions["Do you have a follow-up of raw materials, stocks... (ex: ERP)?"] === "No" ? "enabled" : ""}`,
                                                children: "No"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                className: "question-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "question-text",
                                        children: "Do you have a current average cost price?"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "question-actions",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>clicked("Do you have a current average cost price?", "Yes"),
                                                className: `btn-option ${selectedOptions["Do you have a current average cost price?"] === "Yes" ? "enabled" : ""}`,
                                                children: "Yes"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>clicked("Do you have a current average cost price?", "No"),
                                                className: `btn-option ${selectedOptions["Do you have a current average cost price?"] === "No" ? "enabled" : ""}`,
                                                children: "No"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                className: "question-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "question-text",
                                        children: "Are your raw material costs fixed?"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "question-actions",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>clicked("Are your raw material costs fixed?", "Yes"),
                                                className: `btn-option ${selectedOptions["Are your raw material costs fixed?"] === "Yes" ? "enabled" : ""}`,
                                                children: "Yes"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>clicked("Are your raw material costs fixed?", "No"),
                                                className: `btn-option ${selectedOptions["Are your raw material costs fixed?"] === "No" ? "enabled" : ""}`,
                                                children: "No"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                className: "question-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "question-text",
                                        children: "Do you use the FIFO method?"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "question-actions",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>clicked("Do you use the FIFO method?", "Yes"),
                                                className: `btn-option ${selectedOptions["Do you use the FIFO method?"] === "Yes" ? "enabled" : ""}`,
                                                children: "Yes"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>clicked("Do you use the FIFO method?", "No"),
                                                className: `btn-option ${selectedOptions["Do you use the FIFO method?"] === "No" ? "enabled" : ""}`,
                                                children: "No"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                className: "question-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "question-text",
                                        children: "Do you analyse stock data in real time?"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "question-actions",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>clicked("Do you analyse stock data in real time?", "Yes"),
                                                className: `btn-option ${selectedOptions["Do you analyse stock data in real time?"] === "Yes" ? "enabled" : ""}`,
                                                children: "Yes"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>clicked("Do you analyse stock data in real time?", "No"),
                                                className: `btn-option ${selectedOptions["Do you analyse stock data in real time?"] === "No" ? "enabled" : ""}`,
                                                children: "No"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                className: "question-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "question-text",
                                        children: "Do you have a rounding stock system to make the most of the space?"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "question-actions",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>clicked("Do you have a rounding stock system to make the most of the space?", "Yes"),
                                                className: `btn-option ${selectedOptions["Do you have a rounding stock system to make the most of the space?"] === "Yes" ? "enabled" : ""}`,
                                                children: "Yes"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>clicked("Do you have a rounding stock system to make the most of the space?", "No"),
                                                className: `btn-option ${selectedOptions["Do you have a rounding stock system to make the most of the space?"] === "No" ? "enabled" : ""}`,
                                                children: "No"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                className: "question-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "question-text",
                                        children: "In case of shortage, do you have a safety stock?"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "question-actions",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>clicked("In case of shortage, do you have a safety stock?", "Yes"),
                                                className: `btn-option ${selectedOptions["In case of shortage, do you have a safety stock?"] === "Yes" ? "enabled" : ""}`,
                                                children: "Yes"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>clicked("In case of shortage, do you have a safety stock?", "No"),
                                                className: `btn-option ${selectedOptions["In case of shortage, do you have a safety stock?"] === "No" ? "enabled" : ""}`,
                                                children: "No"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                className: "question-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "question-text",
                                        children: "Calculation of the cost of the stock?"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "question-actions",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>clicked("Calculation of the cost of the stock?", "Yes"),
                                                className: `btn-option ${selectedOptions["Calculation of the cost of the stock?"] === "Yes" ? "enabled" : ""}`,
                                                children: "Yes"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>clicked("Calculation of the cost of the stock?", "No"),
                                                className: `btn-option ${selectedOptions["Calculation of the cost of the stock?"] === "No" ? "enabled" : ""}`,
                                                children: "No"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "form-actions",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                to: "/lead-time-2",
                                className: "btn-secondary",
                                children: "Back"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                onClick: saveData,
                                className: "btn-primary",
                                children: "Continue to Next Section"
                            })
                        ]
                    }),
                    isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "loading-indicator",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "spinner"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                children: "Saving data..."
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
exports.default = Cost1;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["Link","b9X5n"],["useHistory","ditZI"]],"../Toggle":"dSqDu","../Frame136":"6Kf28","../Frame144":"3hDtN","../Frame11732":"gSRJf","./Cost1.css":"fYi67","../../styleguide.css":"8Y7Ec","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6Kf28":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _ouinon = require("../Ouinon");
var _ouinonDefault = parcelHelpers.interopDefault(_ouinon);
var _frame136Css = require("./Frame136.css");
function Frame136(props) {
    const { className, ouinonProps } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `frame-13-1 ${className || ""}`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _ouinonDefault.default), {
            yes: ouinonProps.yes,
            place: ouinonProps.place
        })
    });
}
exports.default = Frame136;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","../Ouinon":"ln8KR","./Frame136.css":"19vll","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"19vll":[function() {},{}],"3hDtN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame133 = require("../Frame133");
var _frame133Default = parcelHelpers.interopDefault(_frame133);
var _frame144Css = require("./Frame144.css");
function Frame144(props) {
    const { frame133Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "frame-144",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame133Default.default), {
            frame136Props: frame133Props.frame136Props
        })
    });
}
exports.default = Frame144;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","../Frame133":"dIpvK","./Frame144.css":"6wNmE","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dIpvK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame136 = require("../Frame136");
var _frame136Default = parcelHelpers.interopDefault(_frame136);
var _frame133Css = require("./Frame133.css");
function Frame133(props) {
    const { className, frame136Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `frame-152 ${className || ""}`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame136Default.default), {
            className: frame136Props.className,
            ouinonProps: frame136Props.ouinonProps
        })
    });
}
exports.default = Frame133;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","../Frame136":"6Kf28","./Frame133.css":"fq7WB","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fq7WB":[function() {},{}],"6wNmE":[function() {},{}],"fYi67":[function() {},{}],"8Y7Ec":[function() {},{}],"ebrQE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "q_sum", ()=>q_sum);
parcelHelpers.export(exports, "q_allData6", ()=>q_allData6);
parcelHelpers.export(exports, "q_yesCount6", ()=>q_yesCount6);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _quality6Css = require("./Quality6.css");
var _styleguideCss = require("../../styleguide.css");
var _jspdf = require("jspdf");
var _jspdfDefault = parcelHelpers.interopDefault(_jspdf);
var _quality1 = require("../Quality1");
var _quality2 = require("../Quality2");
var _quality3 = require("../Quality3");
var _quality4 = require("../Quality4");
var _quality5 = require("../Quality5");
let q_sum = 0;
let q_allData6 = [];
let q_yesCount6 = 0;
function Quality6(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const { x1200PxLogo_Icam__20081, navItems3Props } = props;
    (0, _react.useEffect)(()=>{
        // Calculate the total number of questions based on sections
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []); // Run this effect only once when the component mounts
    function clicked(question, option) {
        // Si l'option cliquée est la màªme que celle déjà  sélectionnée, on la désélectionne
        if (selectedOptions[question] === option) {
            setSelectedOptions((prevSelectedOptions)=>{
                const newOptions = {
                    ...prevSelectedOptions
                };
                delete newOptions[question];
                return newOptions;
            });
            // Si on désélectionne un "Yes", on décrémente le score
            if (option === "Yes") q_yesCount6--;
            return;
        }
        // Sinon, on met à  jour la sélection
        const previousOption = selectedOptions[question];
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        // Si on passe de "No" à  "Yes", on incrémente le score
        if (option === "Yes" && previousOption !== "Yes") q_yesCount6++;
        else if (option === "No" && previousOption === "Yes") q_yesCount6--;
    }
    const history = (0, _reactRouterDom.useHistory)();
    function saveData() {
        setIsLoading(true);
        setErrorMessage("");
        console.log("D\xe9but de sauvegarde des donn\xe9es Quality6");
        const enterpriseId = localStorage.getItem("enterpriseId");
        const userId = localStorage.getItem("userId");
        if (!enterpriseId) {
            console.error("ERREUR: ID d'entreprise manquant");
            setErrorMessage("ID d'entreprise manquant. Veuillez retourner \xe0\xa0 la s\xe9lection d'entreprise.");
            setIsLoading(false);
            return;
        }
        // Définir toutes les questions possibles
        const allQuestions = [
            "Do you have a policy to evaluate, select, monitor supplier performance and their re-evaluation?",
            "Is this policy available in digital form?",
            "Do you periodically track supplier performance against measurable objectives and targets?",
            "Do suppliers receive performance feedback on a regular basis?",
            "Do you have corrective action plan in place for suppliers who aren't achieving performance objectives?",
            "Are the decision-makers made aware of this supplier performance assessment?",
            "Is it used to make decisions?",
            "Do you have a system for managing supplier contracts?",
            "Do you ensure your suppliers comply with all relevant governmental requirements?"
        ];
        // Créer un tableau de questions/réponses pour toutes les questions
        const data = allQuestions.map((question)=>{
            const answer = selectedOptions[question] || "No";
            return {
                question: question,
                answer: answer,
                category: "quality",
                enterpriseId: enterpriseId,
                userId: userId || "",
                section: "quality-6",
                timestamp: new Date().toISOString()
            };
        });
        // Vérifier que les données sont correctement formatées
        const isValidData = data.every((item)=>item.question && item.answer && item.category && item.enterpriseId);
        if (!isValidData) {
            console.error("Donn\xe9es invalides:", data);
            setErrorMessage("Format de donn\xe9es invalide");
            setIsLoading(false);
            return;
        }
        // Sauvegarder les données pour une utilisation ultérieure
        q_allData6 = [
            ...data
        ];
        console.log("Donn\xe9es \xe0\xa0 envoyer:", JSON.stringify(data, null, 2));
        // Calculer la somme totale
        q_sum = (0, _quality1.q_yesCount1) + (0, _quality2.q_yesCount2) + (0, _quality3.q_yesCount3) + (0, _quality4.q_yesCount4) + (0, _quality5.q_yesCount5) + q_yesCount6;
        console.log("Score total Quality:", q_sum);
        // Appel API pour sauvegarder les données
        fetch("/api/api/save-answers", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
            },
            body: JSON.stringify(data)
        }).then((response)=>{
            if (!response.ok) throw new Error(`Erreur de sauvegarde (${response.status})`);
            return response.json();
        }).then((result)=>{
            console.log("Data saved successfully:", result);
            // Sauvegarder le score dans le localStorage
            localStorage.setItem('quality6Score', q_yesCount6);
            console.log(`Score quality6 mis \xe0\xa0 jour: ${q_yesCount6}`);
            // Sauvegarder également le score total quality
            const scoreData = [
                {
                    question: "Quality Total Score",
                    answer: q_sum.toString(),
                    category: "quality",
                    enterpriseId: enterpriseId,
                    userId: userId || "",
                    section: "quality-total",
                    timestamp: new Date().toISOString()
                }
            ];
            console.log("Envoi du score total quality:", JSON.stringify(scoreData, null, 2));
            // Appel API pour sauvegarder le score total
            return fetch("/api/api/save-answers", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
                },
                body: JSON.stringify(scoreData)
            });
        }).then((response)=>{
            if (!response || !response.ok) throw new Error("Failed to save total score");
            return response.json();
        }).then((scoreResponse)=>{
            console.log("Score total quality enregistr\xe9 avec succ\xe8s:", scoreResponse);
            // Récupérer correctement les données de tous les composants
            const allQualityData = [];
            // Utiliser des try/catch pour éviter les erreurs si certaines données sont manquantes
            try {
                if (Array.isArray((0, _quality1.q_allData1)) && (0, _quality1.q_allData1).length > 0) allQualityData.push(...(0, _quality1.q_allData1));
                if (Array.isArray((0, _quality2.q_allData2)) && (0, _quality2.q_allData2).length > 0) allQualityData.push(...(0, _quality2.q_allData2));
                if (Array.isArray((0, _quality3.q_allData3)) && (0, _quality3.q_allData3).length > 0) allQualityData.push(...(0, _quality3.q_allData3));
                if (Array.isArray((0, _quality4.q_allData4)) && (0, _quality4.q_allData4).length > 0) allQualityData.push(...(0, _quality4.q_allData4));
                if (Array.isArray((0, _quality5.q_allData5)) && (0, _quality5.q_allData5).length > 0) allQualityData.push(...(0, _quality5.q_allData5));
                if (Array.isArray(q_allData6) && q_allData6.length > 0) allQualityData.push(...q_allData6);
            } catch (error) {
                console.error("Erreur lors de la concat\xe9nation des donn\xe9es:", error);
            }
            console.log("Toutes les donn\xe9es Quality pour le PDF:", allQualityData.length, "questions");
            // Générer le PDF avec toutes les données
            generatePdf(allQualityData);
            // Redirection vers la page suivante
            setIsLoading(false);
            history.push("/client-consommateur-1");
        }).catch((error)=>{
            console.error("Error saving data:", error);
            setErrorMessage("Error saving data. Please try again.");
            console.error("D\xe9tails de l'erreur:", error.message);
            // Màªme en cas d'erreur, essayer de générer le PDF avec les données disponibles
            const allQualityData = [];
            try {
                if (Array.isArray((0, _quality1.q_allData1)) && (0, _quality1.q_allData1).length > 0) allQualityData.push(...(0, _quality1.q_allData1));
                if (Array.isArray((0, _quality2.q_allData2)) && (0, _quality2.q_allData2).length > 0) allQualityData.push(...(0, _quality2.q_allData2));
                if (Array.isArray((0, _quality3.q_allData3)) && (0, _quality3.q_allData3).length > 0) allQualityData.push(...(0, _quality3.q_allData3));
                if (Array.isArray((0, _quality4.q_allData4)) && (0, _quality4.q_allData4).length > 0) allQualityData.push(...(0, _quality4.q_allData4));
                if (Array.isArray((0, _quality5.q_allData5)) && (0, _quality5.q_allData5).length > 0) allQualityData.push(...(0, _quality5.q_allData5));
                if (Array.isArray(q_allData6) && q_allData6.length > 0) allQualityData.push(...q_allData6);
            } catch (error) {
                console.error("Erreur lors de la concat\xe9nation des donn\xe9es:", error);
            }
            generatePdf(allQualityData);
            // Redirection malgré l'erreur
            setIsLoading(false);
            history.push("/client-consommateur-1");
        });
    }
    function generatePdf(q_allData) {
        // Vérifier si des données existent
        if (!q_allData || q_allData.length === 0) {
            console.error("Aucune donn\xe9e disponible pour g\xe9n\xe9rer le PDF");
            return;
        }
        console.log("G\xe9n\xe9ration du PDF avec", q_allData.length, "questions");
        // Créer un nouveau document PDF
        const doc = new (0, _jspdfDefault.default)();
        const lineHeight = 10;
        const pageHeight = doc.internal.pageSize.height - 20;
        const pageWidth = doc.internal.pageSize.width - 20;
        let y = 20;
        // Ajouter un titre
        doc.setFontSize(16);
        doc.text("Quality Assessment Results", 105, y, {
            align: "center"
        });
        y += 15;
        // Ajouter le score total
        doc.setFontSize(14);
        doc.text(`Total Score: ${q_sum} / ${q_allData.length}`, 105, y, {
            align: "center"
        });
        y += 15;
        doc.setFontSize(12);
        // Parcourir les données et ajouter chaque question et réponse au document PDF
        q_allData.forEach((data, index)=>{
            // Vérifier si les données sont valides
            if (!data || !data.question) {
                console.error("Donn\xe9es invalides pour l'\xe9l\xe9ment", index);
                return;
            }
            const question = `Question ${index + 1}: ${data.question}`;
            const answer = `Answer: ${data.answer || 'No answer'}`;
            // Estimer la hauteur du texte après division pour mieux gérer les sauts de page
            const splitQuestion = doc.splitTextToSize(question, pageWidth);
            const estimatedHeight = splitQuestion.length * lineHeight + lineHeight * 2;
            // Vérifier si on doit passer à  une nouvelle page
            if (y + estimatedHeight > pageHeight) {
                doc.addPage();
                y = 20;
            }
            // à‰crire la question et la réponse dans le PDF
            doc.text(splitQuestion, 10, y);
            y += splitQuestion.length * lineHeight;
            doc.text(answer, 10, y);
            y += lineHeight * 2; // Ajouter un peu d'espace entre les questions
        });
        // Ajouter une page de résumé
        doc.addPage();
        y = 20;
        doc.setFontSize(16);
        doc.text("Summary of Quality Assessment", 105, y, {
            align: "center"
        });
        y += 20;
        doc.setFontSize(12);
        doc.text(`Total number of questions: ${q_allData.length}`, 10, y);
        y += lineHeight;
        doc.text(`Total "Yes" answers: ${q_sum}`, 10, y);
        y += lineHeight;
        doc.text(`Score percentage: ${Math.round(q_sum / q_allData.length * 100)}%`, 10, y);
        y += lineHeight * 2;
        // Ajouter des détails par section
        doc.text("Score breakdown by section:", 10, y);
        y += lineHeight;
        const quality1Score = parseInt(localStorage.getItem('quality1Score') || '0');
        const quality2Score = parseInt(localStorage.getItem('quality2Score') || '0');
        const quality3Score = parseInt(localStorage.getItem('quality3Score') || '0');
        const quality4Score = parseInt(localStorage.getItem('quality4Score') || '0');
        const quality5Score = parseInt(localStorage.getItem('quality5Score') || '0');
        const quality6Score = parseInt(localStorage.getItem('quality6Score') || '0');
        doc.text(`Quality Section 1: ${quality1Score}`, 20, y);
        y += lineHeight;
        doc.text(`Quality Section 2: ${quality2Score}`, 20, y);
        y += lineHeight;
        doc.text(`Quality Section 3: ${quality3Score}`, 20, y);
        y += lineHeight;
        doc.text(`Quality Section 4: ${quality4Score}`, 20, y);
        y += lineHeight;
        doc.text(`Quality Section 5: ${quality5Score}`, 20, y);
        y += lineHeight;
        doc.text(`Quality Section 6: ${quality6Score}`, 20, y);
        y += lineHeight * 2;
        const date = new Date();
        doc.text(`Generated on: ${date.toLocaleDateString()} at ${date.toLocaleTimeString()}`, 10, y);
        // Enregistrer le document PDF
        doc.save("Quality_Assessment_Complete.pdf");
        console.log("PDF Quality g\xe9n\xe9r\xe9 avec succ\xe8s");
    }
    function calculateProgressPercentage() {
        const totalQuestions = document.getElementsByTagName("section").length;
        if (totalQuestions === 0) return 0;
        return Math.round(q_yesCount6 / totalQuestions * 100);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "environmental-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "environmental-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    className: "environmental-title",
                    children: "PLEASE ANSWER THE FOLLOWING QUESTIONS"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "progress-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "progress-bar",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "progress-fill",
                                style: {
                                    width: `${calculateProgressPercentage()}%`
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "progress-text",
                            children: [
                                "Your score: ",
                                q_yesCount6,
                                " / ",
                                totalQuestions,
                                " (",
                                calculateProgressPercentage(),
                                "%)"
                            ]
                        })
                    ]
                }),
                errorMessage && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "error-message",
                    children: errorMessage
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questions-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have a quality policy?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a quality policy?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have a quality policy?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a quality policy?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have a quality policy?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Have you developed quality objectives?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Have you developed quality objectives?", "Yes"),
                                            className: `btn-option ${selectedOptions["Have you developed quality objectives?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Have you developed quality objectives?", "No"),
                                            className: `btn-option ${selectedOptions["Have you developed quality objectives?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Is your quality policy appropriate to the purpose of your organization?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Is your quality policy appropriate to the purpose of your organization?", "Yes"),
                                            className: `btn-option ${selectedOptions["Is your quality policy appropriate to the purpose of your organization?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Is your quality policy appropriate to the purpose of your organization?", "No"),
                                            className: `btn-option ${selectedOptions["Is your quality policy appropriate to the purpose of your organization?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Does your quality policy include a commitment to satisfy applicable requirements?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Does your quality policy include a commitment to satisfy applicable requirements?", "Yes"),
                                            className: `btn-option ${selectedOptions["Does your quality policy include a commitment to satisfy applicable requirements?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Does your quality policy include a commitment to satisfy applicable requirements?", "No"),
                                            className: `btn-option ${selectedOptions["Does your quality policy include a commitment to satisfy applicable requirements?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Does your quality policy include a commitment to continual improvement of the QMS?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Does your quality policy include a commitment to continual improvement of the QMS?", "Yes"),
                                            className: `btn-option ${selectedOptions["Does your quality policy include a commitment to continual improvement of the QMS?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Does your quality policy include a commitment to continual improvement of the QMS?", "No"),
                                            className: `btn-option ${selectedOptions["Does your quality policy include a commitment to continual improvement of the QMS?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do the quality objectives take into account the requirements?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do the quality objectives take into account the requirements?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do the quality objectives take into account the requirements?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do the quality objectives take into account the requirements?", "No"),
                                            className: `btn-option ${selectedOptions["Do the quality objectives take into account the requirements?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Are the quality objectives monitored and communicated?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Are the quality objectives monitored and communicated?", "Yes"),
                                            className: `btn-option ${selectedOptions["Are the quality objectives monitored and communicated?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Are the quality objectives monitored and communicated?", "No"),
                                            className: `btn-option ${selectedOptions["Are the quality objectives monitored and communicated?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "form-actions",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/quality-5",
                            className: "btn-secondary",
                            children: "Back"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "btn-primary",
                            children: "Submit and move to Client/Consommateur"
                        })
                    ]
                }),
                isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "loading-indicator",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "spinner"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: "Saving data and generating PDF..."
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Quality6;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["Link","b9X5n"],["useHistory","ditZI"]],"../NavItems3":"fOarC","../NavItems2":"bnQuI","./Quality6.css":"2tJ7J","../../styleguide.css":"8Y7Ec","jspdf":"hkJ4Q","../Quality1":"gkdwu","../Quality2":"hWTAB","../Quality3":"km669","../Quality4":"iCqMu","../Quality5":"5iZrh","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2tJ7J":[function() {},{}],"8Y7Ec":[function() {},{}],"gkdwu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "q_allData1", ()=>q_allData1);
parcelHelpers.export(exports, "q_yesCount1", ()=>q_yesCount1);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _quality1Css = require("./Quality1.css");
var _styleguideCss = require("../../styleguide.css");
let q_allData1 = [];
let q_yesCount1 = 0;
function Quality1(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const { x1200PxLogo_Icam__20081, navItems3Props } = props;
    (0, _react.useEffect)(()=>{
        // Calculate the total number of questions based on sections
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []); // Run this effect only once when the component mounts
    function clicked(question, option) {
        // Si l'option cliquée est la màªme que celle déjà  sélectionnée, on la désélectionne
        if (selectedOptions[question] === option) {
            setSelectedOptions((prevSelectedOptions)=>{
                const newOptions = {
                    ...prevSelectedOptions
                };
                delete newOptions[question];
                return newOptions;
            });
            // Si on désélectionne un "Yes", on décrémente le score
            if (option === "Yes") q_yesCount1--;
            return;
        }
        // Sinon, on met à  jour la sélection
        const previousOption = selectedOptions[question];
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        // Si on passe de "No" à  "Yes", on incrémente le score
        if (option === "Yes" && previousOption !== "Yes") q_yesCount1++;
        else if (option === "No" && previousOption === "Yes") q_yesCount1--;
    }
    const history = (0, _reactRouterDom.useHistory)();
    function saveData() {
        setIsLoading(true);
        setErrorMessage("");
        console.log("D\xe9but de sauvegarde des donn\xe9es Quality1");
        const enterpriseId = localStorage.getItem("enterpriseId");
        const userId = localStorage.getItem("userId");
        if (!enterpriseId) {
            console.error("ERREUR: ID d'entreprise manquant");
            setErrorMessage("ID d'entreprise manquant. Veuillez retourner \xe0\xa0 la s\xe9lection d'entreprise.");
            setIsLoading(false);
            return;
        }
        // Définir toutes les questions possibles
        const allQuestions = [
            "Do you do reviews?",
            "In paper format?",
            "In digital format?",
            "Do you have a review specifying requirements not formulated by the customer but necessary for the specified use?",
            "Do you have a review specifying the requirements of the organisation?"
        ];
        // Créer un tableau de questions/réponses pour toutes les questions
        const data = allQuestions.map((question)=>{
            const answer = selectedOptions[question] || "No";
            return {
                question: question,
                answer: answer,
                category: "quality",
                enterpriseId: enterpriseId,
                userId: userId || "",
                section: "quality-1",
                timestamp: new Date().toISOString()
            };
        });
        // Vérifier que les données sont correctement formatées
        const isValidData = data.every((item)=>item.question && item.answer && item.category && item.enterpriseId);
        if (!isValidData) {
            console.error("Donn\xe9es invalides:", data);
            setErrorMessage("Format de donn\xe9es invalide");
            setIsLoading(false);
            return;
        }
        // Sauvegarder les données pour une utilisation ultérieure
        q_allData1 = [
            ...data
        ];
        console.log("Donn\xe9es \xe0\xa0 envoyer:", JSON.stringify(data, null, 2));
        // Appel API pour sauvegarder les données
        fetch("/api/api/save-answers", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
            },
            body: JSON.stringify(data)
        }).then((response)=>{
            if (!response.ok) throw new Error(`Erreur de sauvegarde (${response.status})`);
            return response.json();
        }).then((result)=>{
            console.log("Data saved successfully:", result);
            // Sauvegarder le score dans le localStorage
            localStorage.setItem('quality1Score', q_yesCount1);
            console.log(`Score quality1 mis \xe0\xa0 jour: ${q_yesCount1}`);
            // Redirection vers la page suivante
            setIsLoading(false);
            history.push("/Quality-2");
        }).catch((error)=>{
            console.error("Error saving data:", error);
            setErrorMessage("Error saving data. Please try again.");
            console.error("D\xe9tails de l'erreur:", error.message);
            // Redirection malgré l'erreur
            setIsLoading(false);
            history.push("/Quality-2");
        });
    }
    function calculateProgressPercentage() {
        const totalQuestions = document.getElementsByTagName("section").length;
        if (totalQuestions === 0) return 0;
        return Math.round(q_yesCount1 / totalQuestions * 100);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "environmental-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "environmental-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    className: "environmental-title",
                    children: "PLEASE ANSWER THE FOLLOWING QUESTIONS"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "progress-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "progress-bar",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "progress-fill",
                                style: {
                                    width: `${calculateProgressPercentage()}%`
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "progress-text",
                            children: [
                                "Your score: ",
                                q_yesCount1,
                                " / ",
                                totalQuestions,
                                " (",
                                calculateProgressPercentage(),
                                "%)"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questions-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you do reviews?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you do reviews?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you do reviews?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you do reviews?", "No"),
                                            className: `btn-option ${selectedOptions["Do you do reviews?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "In paper format?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("In paper format?", "Yes"),
                                            className: `btn-option ${selectedOptions["In paper format?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("In paper format?", "No"),
                                            className: `btn-option ${selectedOptions["In paper format?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "In digital format?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("In digital format?", "Yes"),
                                            className: `btn-option ${selectedOptions["In digital format?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("In digital format?", "No"),
                                            className: `btn-option ${selectedOptions["In digital format?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have a review specifying requirements not formulated by the customer but necessary for the specified use?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a review specifying requirements not formulated by the customer but necessary for the specified use?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have a review specifying requirements not formulated by the customer but necessary for the specified use?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a review specifying requirements not formulated by the customer but necessary for the specified use?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have a review specifying requirements not formulated by the customer but necessary for the specified use?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have a review specifying the requirements of the organisation?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a review specifying the requirements of the organisation?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have a review specifying the requirements of the organisation?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a review specifying the requirements of the organisation?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have a review specifying the requirements of the organisation?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "form-actions",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/cost-2",
                            className: "btn-secondary",
                            children: "Back"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "btn-primary",
                            children: "Continue to Next Section"
                        })
                    ]
                }),
                isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "loading-indicator",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "spinner"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: "Saving data..."
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Quality1;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["Link","b9X5n"],["useHistory","ditZI"]],"../NavItems3":"fOarC","../NavItems2":"bnQuI","./Quality1.css":"llgU9","../../styleguide.css":"8Y7Ec","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"llgU9":[function() {},{}],"8Y7Ec":[function() {},{}],"hWTAB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "q_allData2", ()=>q_allData2);
parcelHelpers.export(exports, "q_yesCount2", ()=>q_yesCount2);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _quality2Css = require("./Quality2.css");
var _styleguideCss = require("../../styleguide.css");
var _quality1 = require("../Quality1");
let q_allData2 = [];
let q_yesCount2 = 0;
function Quality2(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const { x1200PxLogo_Icam__20081, navItems3Props } = props;
    (0, _react.useEffect)(()=>{
        // Calculate the total number of questions based on sections
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []); // Run this effect only once when the component mounts
    function clicked(question, option) {
        // Si l'option cliquée est la màªme que celle déjà  sélectionnée, on la désélectionne
        if (selectedOptions[question] === option) {
            setSelectedOptions((prevSelectedOptions)=>{
                const newOptions = {
                    ...prevSelectedOptions
                };
                delete newOptions[question];
                return newOptions;
            });
            // Si on désélectionne un "Yes", on décrémente le score
            if (option === "Yes") q_yesCount2--;
            return;
        }
        // Sinon, on met à  jour la sélection
        const previousOption = selectedOptions[question];
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        // Si on passe de "No" à  "Yes", on incrémente le score
        if (option === "Yes" && previousOption !== "Yes") q_yesCount2++;
        else if (option === "No" && previousOption === "Yes") q_yesCount2--;
    }
    const history = (0, _reactRouterDom.useHistory)();
    function saveData() {
        setIsLoading(true);
        setErrorMessage("");
        console.log("D\xe9but de sauvegarde des donn\xe9es Quality2");
        const enterpriseId = localStorage.getItem("enterpriseId");
        const userId = localStorage.getItem("userId");
        if (!enterpriseId) {
            console.error("ERREUR: ID d'entreprise manquant");
            setErrorMessage("ID d'entreprise manquant. Veuillez retourner \xe0\xa0 la s\xe9lection d'entreprise.");
            setIsLoading(false);
            return;
        }
        // Définir toutes les questions possibles
        const allQuestions = [
            "Do you have a customer satisfaction percentage?",
            "Is it below 30%?",
            "Is it between 30% and 50%?",
            "Is it between 50% and 80%?",
            "Is it above 80%?"
        ];
        // Créer un tableau de questions/réponses pour toutes les questions
        const data = allQuestions.map((question)=>{
            const answer = selectedOptions[question] || "No";
            return {
                question: question,
                answer: answer,
                category: "quality",
                enterpriseId: enterpriseId,
                userId: userId || "",
                section: "quality-2",
                timestamp: new Date().toISOString()
            };
        });
        // Vérifier que les données sont correctement formatées
        const isValidData = data.every((item)=>item.question && item.answer && item.category && item.enterpriseId);
        if (!isValidData) {
            console.error("Donn\xe9es invalides:", data);
            setErrorMessage("Format de donn\xe9es invalide");
            setIsLoading(false);
            return;
        }
        // Sauvegarder les données pour une utilisation ultérieure
        q_allData2 = [
            ...data
        ];
        console.log("Donn\xe9es \xe0\xa0 envoyer:", JSON.stringify(data, null, 2));
        // Appel API pour sauvegarder les données
        fetch("/api/api/save-answers", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
            },
            body: JSON.stringify(data)
        }).then((response)=>{
            if (!response.ok) throw new Error(`Erreur de sauvegarde (${response.status})`);
            return response.json();
        }).then((result)=>{
            console.log("Data saved successfully:", result);
            // Sauvegarder le score dans le localStorage
            localStorage.setItem('quality2Score', q_yesCount2);
            console.log(`Score quality2 mis \xe0\xa0 jour: ${q_yesCount2}`);
            // Redirection vers la page suivante
            setIsLoading(false);
            history.push("/Quality-3");
        }).catch((error)=>{
            console.error("Error saving data:", error);
            setErrorMessage("Error saving data. Please try again.");
            console.error("D\xe9tails de l'erreur:", error.message);
            // Redirection malgré l'erreur
            setIsLoading(false);
            history.push("/Quality-3");
        });
    }
    function calculateProgressPercentage() {
        const totalQuestions = document.getElementsByTagName("section").length;
        if (totalQuestions === 0) return 0;
        return Math.round(q_yesCount2 / totalQuestions * 100);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "environmental-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "environmental-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    className: "environmental-title",
                    children: "PLEASE ANSWER THE FOLLOWING QUESTIONS"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "progress-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "progress-bar",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "progress-fill",
                                style: {
                                    width: `${calculateProgressPercentage()}%`
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "progress-text",
                            children: [
                                "Your score: ",
                                q_yesCount2,
                                " / ",
                                totalQuestions,
                                " (",
                                calculateProgressPercentage(),
                                "%)"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questions-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have a customer satisfaction percentage?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a customer satisfaction percentage?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have a customer satisfaction percentage?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a customer satisfaction percentage?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have a customer satisfaction percentage?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Is it below 30%?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Is it below 30%?", "Yes"),
                                            className: `btn-option ${selectedOptions["Is it below 30%?"] === "Yes" ? "enabled" : ""}`,
                                            disabled: selectedOptions["Is it below 30%?"] === "No",
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Is it below 30%?", "No"),
                                            className: `btn-option ${selectedOptions["Is it below 30%?"] === "No" ? "enabled" : ""}`,
                                            disabled: selectedOptions["Is it below 30%?"] === "Yes",
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Is it between 30% and 60%?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Is it between 30% and 60%?", "Yes"),
                                            className: `btn-option ${selectedOptions["Is it between 30% and 60%?"] === "Yes" ? "enabled" : ""}`,
                                            disabled: selectedOptions["Is it between 30% and 60%?"] === "No",
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Is it between 30% and 60%?", "No"),
                                            className: `btn-option ${selectedOptions["Is it between 30% and 60%?"] === "No" ? "enabled" : ""}`,
                                            disabled: selectedOptions["Is it between 30% and 60%?"] === "Yes",
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Is it between 60% and 90%?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Is it between 60% and 90%?", "Yes"),
                                            className: `btn-option ${selectedOptions["Is it between 60% and 90%?"] === "Yes" ? "enabled" : ""}`,
                                            disabled: selectedOptions["Is it between 60% and 90%?"] === "No",
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Is it between 60% and 90%?", "No"),
                                            className: `btn-option ${selectedOptions["Is it between 60% and 90%?"] === "No" ? "enabled" : ""}`,
                                            disabled: selectedOptions["Is it between 60% and 90%?"] === "Yes",
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Is it higher than 90%?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Is it higher than 90%?", "Yes"),
                                            className: `btn-option ${selectedOptions["Is it higher than 90%?"] === "Yes" ? "enabled" : ""}`,
                                            disabled: selectedOptions["Is it higher than 90%?"] === "No",
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Is it higher than 90%?", "No"),
                                            className: `btn-option ${selectedOptions["Is it higher than 90%?"] === "No" ? "enabled" : ""}`,
                                            disabled: selectedOptions["Is it higher than 90%?"] === "Yes",
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Does the manager ensure that customer requirements are met?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Does the manager ensure that customer requirements are met?", "Yes"),
                                            className: `btn-option ${selectedOptions["Does the manager ensure that customer requirements are met?"] === "Yes" ? "enabled" : ""}`,
                                            disabled: selectedOptions["Does the manager ensure that customer requirements are met?"] === "No",
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Does the manager ensure that customer requirements are met?", "No"),
                                            className: `btn-option ${selectedOptions["Does the manager ensure that customer requirements are met?"] === "No" ? "enabled" : ""}`,
                                            disabled: selectedOptions["Does the manager ensure that customer requirements are met?"] === "Yes",
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you communicate to employees the points of attention where product and service compliance is at risk?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you communicate to employees the points of attention where product and service compliance is at risk?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you communicate to employees the points of attention where product and service compliance is at risk?"] === "Yes" ? "enabled" : ""}`,
                                            disabled: selectedOptions["Do you communicate to employees the points of attention where product and service compliance is at risk?"] === "No",
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you communicate to employees the points of attention where product and service compliance is at risk?", "No"),
                                            className: `btn-option ${selectedOptions["Do you communicate to employees the points of attention where product and service compliance is at risk?"] === "No" ? "enabled" : ""}`,
                                            disabled: selectedOptions["Do you communicate to employees the points of attention where product and service compliance is at risk?"] === "Yes",
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "form-actions",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/quality-1",
                            className: "btn-secondary",
                            children: "Back"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "btn-primary",
                            children: "Next"
                        })
                    ]
                }),
                isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "loading-indicator",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "spinner"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: "Saving data..."
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Quality2;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["Link","b9X5n"],["useHistory","ditZI"]],"../NavItems3":"fOarC","../NavItems2":"bnQuI","./Quality2.css":"jaGRg","../../styleguide.css":"8Y7Ec","../Quality1":"gkdwu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jaGRg":[function() {},{}],"8Y7Ec":[function() {},{}],"km669":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "q_allData3", ()=>q_allData3);
parcelHelpers.export(exports, "q_yesCount3", ()=>q_yesCount3);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _quality3Css = require("./Quality3.css");
var _styleguideCss = require("../../styleguide.css");
var _quality1 = require("../Quality1");
var _quality2 = require("../Quality2");
let q_allData3 = [];
let q_yesCount3 = 0;
function Quality3(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const { x1200PxLogo_Icam__20081, navItems3Props } = props;
    (0, _react.useEffect)(()=>{
        // Calculate the total number of questions based on sections
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []); // Run this effect only once when the component mounts
    function clicked(question, option) {
        // Si l'option cliquée est la màªme que celle déjà  sélectionnée, on la désélectionne
        if (selectedOptions[question] === option) {
            setSelectedOptions((prevSelectedOptions)=>{
                const newOptions = {
                    ...prevSelectedOptions
                };
                delete newOptions[question];
                return newOptions;
            });
            // Si on désélectionne un "Yes", on décrémente le score
            if (option === "Yes") q_yesCount3--;
            return;
        }
        // Sinon, on met à  jour la sélection
        const previousOption = selectedOptions[question];
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        // Si on passe de "No" à  "Yes", on incrémente le score
        if (option === "Yes" && previousOption !== "Yes") q_yesCount3++;
        else if (option === "No" && previousOption === "Yes") q_yesCount3--;
    }
    const history = (0, _reactRouterDom.useHistory)();
    function saveData() {
        setIsLoading(true);
        setErrorMessage("");
        console.log("D\xe9but de sauvegarde des donn\xe9es Quality3");
        const enterpriseId = localStorage.getItem("enterpriseId");
        const userId = localStorage.getItem("userId");
        if (!enterpriseId) {
            console.error("ERREUR: ID d'entreprise manquant");
            setErrorMessage("ID d'entreprise manquant. Veuillez retourner \xe0\xa0 la s\xe9lection d'entreprise.");
            setIsLoading(false);
            return;
        }
        // Définir toutes les questions possibles
        const allQuestions = [
            "Do you communicate the importance of having an effective quality management system?",
            "Do you have objectives in the form of KPIs concerning quality?",
            "Do you monitor the achievement of quality objectives?",
            "Do you have a quality management process established?",
            "Are the members of your organisation informed about the necessary quality improvements?",
            "Is there quality assurance planning?",
            "Is there a documented quality procedure in your company?"
        ];
        // Créer un tableau de questions/réponses pour toutes les questions
        const data = allQuestions.map((question)=>{
            const answer = selectedOptions[question] || "No";
            return {
                question: question,
                answer: answer,
                category: "quality",
                enterpriseId: enterpriseId,
                userId: userId || "",
                section: "quality-3",
                timestamp: new Date().toISOString()
            };
        });
        // Vérifier que les données sont correctement formatées
        const isValidData = data.every((item)=>item.question && item.answer && item.category && item.enterpriseId);
        if (!isValidData) {
            console.error("Donn\xe9es invalides:", data);
            setErrorMessage("Format de donn\xe9es invalide");
            setIsLoading(false);
            return;
        }
        // Sauvegarder les données pour une utilisation ultérieure
        q_allData3 = [
            ...data
        ];
        console.log("Donn\xe9es \xe0\xa0 envoyer:", JSON.stringify(data, null, 2));
        // Appel API pour sauvegarder les données
        fetch("/api/api/save-answers", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
            },
            body: JSON.stringify(data)
        }).then((response)=>{
            if (!response.ok) throw new Error(`Erreur de sauvegarde (${response.status})`);
            return response.json();
        }).then((result)=>{
            console.log("Data saved successfully:", result);
            // Sauvegarder le score dans le localStorage
            localStorage.setItem('quality3Score', q_yesCount3);
            console.log(`Score quality3 mis \xe0\xa0 jour: ${q_yesCount3}`);
            // Redirection vers la page suivante
            setIsLoading(false);
            history.push("/Quality-4");
        }).catch((error)=>{
            console.error("Error saving data:", error);
            setErrorMessage("Error saving data. Please try again.");
            console.error("D\xe9tails de l'erreur:", error.message);
            // Redirection malgré l'erreur
            setIsLoading(false);
            history.push("/Quality-4");
        });
    }
    function calculateProgressPercentage() {
        const totalQuestions = document.getElementsByTagName("section").length;
        if (totalQuestions === 0) return 0;
        return Math.round(q_yesCount3 / totalQuestions * 100);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "environmental-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "environmental-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    className: "environmental-title",
                    children: "PLEASE ANSWER THE FOLLOWING QUESTIONS"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "progress-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "progress-bar",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "progress-fill",
                                style: {
                                    width: `${calculateProgressPercentage()}%`
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "progress-text",
                            children: [
                                "Your score: ",
                                q_yesCount3,
                                " / ",
                                totalQuestions,
                                " (",
                                calculateProgressPercentage(),
                                "%)"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questions-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you communicate the importance of having an effective quality management system?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you communicate the importance of having an effective quality management system?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you communicate the importance of having an effective quality management system?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you communicate the importance of having an effective quality management system?", "No"),
                                            className: `btn-option ${selectedOptions["Do you communicate the importance of having an effective quality management system?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have objectives in the form of KPIs concerning quality?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have objectives in the form of KPIs concerning quality?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have objectives in the form of KPIs concerning quality?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have objectives in the form of KPIs concerning quality?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have objectives in the form of KPIs concerning quality?"] === "No" ? "enabled" : ""}`,
                                            disabled: selectedOptions["Do you have objectives in the form of KPIs concerning quality?"] === "Yes",
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you monitor the achievement of quality objectives?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you monitor the achievement of quality objectives?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you monitor the achievement of quality objectives?"] === "Yes" ? "enabled" : ""}`,
                                            disabled: selectedOptions["Do you monitor the achievement of quality objectives?"] === "No",
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you monitor the achievement of quality objectives?", "No"),
                                            className: `btn-option ${selectedOptions["Do you monitor the achievement of quality objectives?"] === "No" ? "enabled" : ""}`,
                                            disabled: selectedOptions["Do you monitor the achievement of quality objectives?"] === "Yes",
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have a quality management process established?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a quality management process established?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have a quality management process established?"] === "Yes" ? "enabled" : ""}`,
                                            disabled: selectedOptions["Do you have a quality management process established?"] === "No",
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a quality management process established?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have a quality management process established?"] === "No" ? "enabled" : ""}`,
                                            disabled: selectedOptions["Do you have a quality management process established?"] === "Yes",
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Are you improving these processes?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Are you improving these processes?", "Yes"),
                                            className: `btn-option ${selectedOptions["Are you improving these processes?"] === "Yes" ? "enabled" : ""}`,
                                            disabled: selectedOptions["Are you improving these processes?"] === "No",
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Are you improving these processes?", "No"),
                                            className: `btn-option ${selectedOptions["Are you improving these processes?"] === "No" ? "enabled" : ""}`,
                                            disabled: selectedOptions["Are you improving these processes?"] === "Yes",
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you conduct internal or external audits to ensure performance and effectiveness of the QMS (including internal audits and third-party audits)?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you conduct internal or external audits to ensure performance and effectiveness of the QMS (including internal audits and third-party audits)?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you conduct internal or external audits to ensure performance and effectiveness of the QMS (including internal audits and third-party audits)?"] === "Yes" ? "enabled" : ""}`,
                                            disabled: selectedOptions["Do you conduct internal or external audits to ensure performance and effectiveness of the QMS (including internal audits and third-party audits)?"] === "No",
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you conduct internal or external audits to ensure performance and effectiveness of the QMS (including internal audits and third-party audits)?", "No"),
                                            className: `btn-option ${selectedOptions["Do you conduct internal or external audits to ensure performance and effectiveness of the QMS (including internal audits and third-party audits)?"] === "No" ? "enabled" : ""}`,
                                            disabled: selectedOptions["Do you conduct internal or external audits to ensure performance and effectiveness of the QMS (including internal audits and third-party audits)?"] === "Yes",
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "form-actions",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/quality-2",
                            className: "btn-secondary",
                            children: "Back"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "btn-primary",
                            children: "Next"
                        })
                    ]
                }),
                isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "loading-indicator",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "spinner"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: "Saving data..."
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Quality3;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["Link","b9X5n"],["useHistory","ditZI"]],"../NavItems3":"fOarC","../NavItems2":"bnQuI","./Quality3.css":"jS70b","../../styleguide.css":"8Y7Ec","../Quality1":"gkdwu","../Quality2":"hWTAB","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jS70b":[function() {},{}],"8Y7Ec":[function() {},{}],"iCqMu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "q_allData4", ()=>q_allData4);
parcelHelpers.export(exports, "q_yesCount4", ()=>q_yesCount4);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _quality4Css = require("./Quality4.css");
var _styleguideCss = require("../../styleguide.css");
var _quality1 = require("../Quality1");
var _quality2 = require("../Quality2");
var _quality3 = require("../Quality3");
let q_allData4 = [];
let q_yesCount4 = 0;
function Quality4(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const { x1200PxLogo_Icam__20081, navItems3Props } = props;
    (0, _react.useEffect)(()=>{
        // Calculate the total number of questions based on sections
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []); // Run this effect only once when the component mounts
    function clicked(question, option) {
        // Si l'option cliquée est la màªme que celle déjà  sélectionnée, on la désélectionne
        if (selectedOptions[question] === option) {
            setSelectedOptions((prevSelectedOptions)=>{
                const newOptions = {
                    ...prevSelectedOptions
                };
                delete newOptions[question];
                return newOptions;
            });
            // Si on désélectionne un "Yes", on décrémente le score
            if (option === "Yes") q_yesCount4--;
            return;
        }
        // Sinon, on met à  jour la sélection
        const previousOption = selectedOptions[question];
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        // Si on passe de "No" à  "Yes", on incrémente le score
        if (option === "Yes" && previousOption !== "Yes") q_yesCount4++;
        else if (option === "No" && previousOption === "Yes") q_yesCount4--;
    }
    const history = (0, _reactRouterDom.useHistory)();
    function saveData() {
        setIsLoading(true);
        setErrorMessage("");
        console.log("D\xe9but de sauvegarde des donn\xe9es Quality4");
        const enterpriseId = localStorage.getItem("enterpriseId");
        const userId = localStorage.getItem("userId");
        if (!enterpriseId) {
            console.error("ERREUR: ID d'entreprise manquant");
            setErrorMessage("ID d'entreprise manquant. Veuillez retourner \xe0\xa0 la s\xe9lection d'entreprise.");
            setIsLoading(false);
            return;
        }
        // Définir toutes les questions possibles
        const allQuestions = [
            "Do you have a quality manager?",
            "Are the necessary competences of the person(s) working on the performance and effectiveness of the quality management system defined?",
            "Does the organization ensure that these persons are competent on the basis of appropriate education, training, or experience?",
            "Are the results of audits reported to management?",
            "Does the management team ensure that the QMS processes are integrated into the company's business processes?",
            "Are the responsibilities in the quality department distributed effectively?",
            "Does your organization manage the QMS documentation effectively?"
        ];
        // Créer un tableau de questions/réponses pour toutes les questions
        const data = allQuestions.map((question)=>{
            const answer = selectedOptions[question] || "No";
            return {
                question: question,
                answer: answer,
                category: "quality",
                enterpriseId: enterpriseId,
                userId: userId || "",
                section: "quality-4",
                timestamp: new Date().toISOString()
            };
        });
        // Vérifier que les données sont correctement formatées
        const isValidData = data.every((item)=>item.question && item.answer && item.category && item.enterpriseId);
        if (!isValidData) {
            console.error("Donn\xe9es invalides:", data);
            setErrorMessage("Format de donn\xe9es invalide");
            setIsLoading(false);
            return;
        }
        // Sauvegarder les données pour une utilisation ultérieure
        q_allData4 = [
            ...data
        ];
        console.log("Donn\xe9es \xe0\xa0 envoyer:", JSON.stringify(data, null, 2));
        // Appel API pour sauvegarder les données
        fetch("/api/api/save-answers", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
            },
            body: JSON.stringify(data)
        }).then((response)=>{
            if (!response.ok) throw new Error(`Erreur de sauvegarde (${response.status})`);
            return response.json();
        }).then((result)=>{
            console.log("Data saved successfully:", result);
            // Sauvegarder le score dans le localStorage
            localStorage.setItem('quality4Score', q_yesCount4);
            console.log(`Score quality4 mis \xe0\xa0 jour: ${q_yesCount4}`);
            // Redirection vers la page suivante
            setIsLoading(false);
            history.push("/Quality-5");
        }).catch((error)=>{
            console.error("Error saving data:", error);
            setErrorMessage("Error saving data. Please try again.");
            console.error("D\xe9tails de l'erreur:", error.message);
            // Redirection malgré l'erreur
            setIsLoading(false);
            history.push("/Quality-5");
        });
    }
    function calculateProgressPercentage() {
        const totalQuestions = document.getElementsByTagName("section").length;
        if (totalQuestions === 0) return 0;
        return Math.round(q_yesCount4 / totalQuestions * 100);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "environmental-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "environmental-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    className: "environmental-title",
                    children: "PLEASE ANSWER THE FOLLOWING QUESTIONS"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "progress-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "progress-bar",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "progress-fill",
                                style: {
                                    width: `${calculateProgressPercentage()}%`
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "progress-text",
                            children: [
                                "Your score: ",
                                q_yesCount4,
                                " / ",
                                totalQuestions,
                                " (",
                                calculateProgressPercentage(),
                                "%)"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questions-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have a quality manager?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a quality manager?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have a quality manager?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a quality manager?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have a quality manager?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Are the necessary competences of the person(s) working on the performance and effectiveness of the quality management system defined?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Are the necessary competences of the person(s) working on the performance and effectiveness of the quality management system defined?", "Yes"),
                                            className: `btn-option ${selectedOptions["Are the necessary competences of the person(s) working on the performance and effectiveness of the quality management system defined?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Are the necessary competences of the person(s) working on the performance and effectiveness of the quality management system defined?", "No"),
                                            className: `btn-option ${selectedOptions["Are the necessary competences of the person(s) working on the performance and effectiveness of the quality management system defined?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Does the organization ensure that these persons are competent on the basis of appropriate education, training, or experience?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Does the organization ensure that these persons are competent on the basis of appropriate education, training, or experience?", "Yes"),
                                            className: `btn-option ${selectedOptions["Does the organization ensure that these persons are competent on the basis of appropriate education, training, or experience?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Does the organization ensure that these persons are competent on the basis of appropriate education, training, or experience?", "No"),
                                            className: `btn-option ${selectedOptions["Does the organization ensure that these persons are competent on the basis of appropriate education, training, or experience?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Are the results of audits reported to management?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Are the results of audits reported to management?", "Yes"),
                                            className: `btn-option ${selectedOptions["Are the results of audits reported to management?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Are the results of audits reported to management?", "No"),
                                            className: `btn-option ${selectedOptions["Are the results of audits reported to management?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Does the management team ensure that the QMS processes are integrated into the company's business processes?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Does the management team ensure that the QMS processes are integrated into the company's business processes?", "Yes"),
                                            className: `btn-option ${selectedOptions["Does the management team ensure that the QMS processes are integrated into the company's business processes?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Does the management team ensure that the QMS processes are integrated into the company's business processes?", "No"),
                                            className: `btn-option ${selectedOptions["Does the management team ensure that the QMS processes are integrated into the company's business processes?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Does the organization retain documented information as evidence of competence?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Does the organization retain documented information as evidence of competence?", "Yes"),
                                            className: `btn-option ${selectedOptions["Does the organization retain documented information as evidence of competence?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Does the organization retain documented information as evidence of competence?", "No"),
                                            className: `btn-option ${selectedOptions["Does the organization retain documented information as evidence of competence?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "form-actions",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/quality-3",
                            className: "btn-secondary",
                            children: "Back"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "btn-primary",
                            children: "Next"
                        })
                    ]
                }),
                isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "loading-indicator",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "spinner"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: "Saving data..."
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Quality4;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["Link","b9X5n"],["useHistory","ditZI"]],"../NavItems3":"fOarC","../NavItems2":"bnQuI","./Quality4.css":"9LCWL","../../styleguide.css":"8Y7Ec","../Quality1":"gkdwu","../Quality2":"hWTAB","../Quality3":"km669","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9LCWL":[function() {},{}],"8Y7Ec":[function() {},{}],"5iZrh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "q_allData5", ()=>q_allData5);
parcelHelpers.export(exports, "q_yesCount5", ()=>q_yesCount5);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _quality5Css = require("./Quality5.css");
var _styleguideCss = require("../../styleguide.css");
var _quality1 = require("../Quality1");
var _quality2 = require("../Quality2");
var _quality3 = require("../Quality3");
var _quality4 = require("../Quality4");
let q_allData5 = [];
let q_yesCount5 = 0;
function Quality5(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const { x1200PxLogo_Icam__20081, navItems3Props } = props;
    (0, _react.useEffect)(()=>{
        // Calculate the total number of questions based on sections
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []); // Run this effect only once when the component mounts
    function clicked(question, option) {
        // Si l'option cliquée est la màªme que celle déjà  sélectionnée, on la désélectionne
        if (selectedOptions[question] === option) {
            setSelectedOptions((prevSelectedOptions)=>{
                const newOptions = {
                    ...prevSelectedOptions
                };
                delete newOptions[question];
                return newOptions;
            });
            // Si on désélectionne un "Yes", on décrémente le score
            if (option === "Yes") q_yesCount5--;
            return;
        }
        // Sinon, on met à  jour la sélection
        const previousOption = selectedOptions[question];
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        // Si on passe de "No" à  "Yes", on incrémente le score
        if (option === "Yes" && previousOption !== "Yes") q_yesCount5++;
        else if (option === "No" && previousOption === "Yes") q_yesCount5--;
    }
    const history = (0, _reactRouterDom.useHistory)();
    function saveData() {
        setIsLoading(true);
        setErrorMessage("");
        console.log("D\xe9but de sauvegarde des donn\xe9es Quality5");
        const enterpriseId = localStorage.getItem("enterpriseId");
        const userId = localStorage.getItem("userId");
        if (!enterpriseId) {
            console.error("ERREUR: ID d'entreprise manquant");
            setErrorMessage("ID d'entreprise manquant. Veuillez retourner \xe0\xa0 la s\xe9lection d'entreprise.");
            setIsLoading(false);
            return;
        }
        // Définir toutes les questions possibles
        const allQuestions = [
            "Do you carry out internal audits at planned intervals to determine whether the QMS complies with the organisation's requirements?",
            "Is the planning and execution of the audit programme organised on a process-by-process basis?",
            "Does the organization plan, establish, implement and maintain an audit programme(s)?",
            "Does the organization use the results of previous audits to assess the effectiveness of actions taken to address the risks and opportunities?",
            "Does the organization ensure that the results of the audits are reported to relevant management?",
            "Does the organization take appropriate corrections and corrective actions without undue delay?",
            "Does the organization retain documented information as evidence of the implementation of the audit programme and the audit results?"
        ];
        // Créer un tableau de questions/réponses pour toutes les questions
        const data = allQuestions.map((question)=>{
            const answer = selectedOptions[question] || "No";
            return {
                question: question,
                answer: answer,
                category: "quality",
                enterpriseId: enterpriseId,
                userId: userId || "",
                section: "quality-5",
                timestamp: new Date().toISOString()
            };
        });
        // Vérifier que les données sont correctement formatées
        const isValidData = data.every((item)=>item.question && item.answer && item.category && item.enterpriseId);
        if (!isValidData) {
            console.error("Donn\xe9es invalides:", data);
            setErrorMessage("Format de donn\xe9es invalide");
            setIsLoading(false);
            return;
        }
        // Sauvegarder les données pour une utilisation ultérieure
        q_allData5 = [
            ...data
        ];
        console.log("Donn\xe9es \xe0\xa0 envoyer:", JSON.stringify(data, null, 2));
        // Appel API pour sauvegarder les données
        fetch("/api/api/save-answers", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
            },
            body: JSON.stringify(data)
        }).then((response)=>{
            if (!response.ok) throw new Error(`Erreur de sauvegarde (${response.status})`);
            return response.json();
        }).then((result)=>{
            console.log("Data saved successfully:", result);
            // Sauvegarder le score dans le localStorage
            localStorage.setItem('quality5Score', q_yesCount5);
            console.log(`Score quality5 mis \xe0\xa0 jour: ${q_yesCount5}`);
            // Redirection vers la page suivante
            setIsLoading(false);
            history.push("/Quality-6");
        }).catch((error)=>{
            console.error("Error saving data:", error);
            setErrorMessage("Error saving data. Please try again.");
            console.error("D\xe9tails de l'erreur:", error.message);
            // Redirection malgré l'erreur
            setIsLoading(false);
            history.push("/Quality-6");
        });
    }
    function calculateProgressPercentage() {
        const totalQuestions = document.getElementsByTagName("section").length;
        if (totalQuestions === 0) return 0;
        return Math.round(q_yesCount5 / totalQuestions * 100);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "environmental-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "environmental-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    className: "environmental-title",
                    children: "PLEASE ANSWER THE FOLLOWING QUESTIONS"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "progress-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "progress-bar",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "progress-fill",
                                style: {
                                    width: `${calculateProgressPercentage()}%`
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "progress-text",
                            children: [
                                "Your score: ",
                                q_yesCount5,
                                " / ",
                                totalQuestions,
                                " (",
                                calculateProgressPercentage(),
                                "%)"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questions-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you carry out internal audits at planned intervals to determine whether the QMS complies with the organisation's requirements?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you carry out internal audits at planned intervals to determine whether the QMS complies with the organisation's requirements?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you carry out internal audits at planned intervals to determine whether the QMS complies with the organisation's requirements?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you carry out internal audits at planned intervals to determine whether the QMS complies with the organisation's requirements?", "No"),
                                            className: `btn-option ${selectedOptions["Do you carry out internal audits at planned intervals to determine whether the QMS complies with the organisation's requirements?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Is the planning and execution of the audit programme organised on a process-by-process basis?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Is the planning and execution of the audit programme organised on a process-by-process basis?", "Yes"),
                                            className: `btn-option ${selectedOptions["Is the planning and execution of the audit programme organised on a process-by-process basis?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Is the planning and execution of the audit programme organised on a process-by-process basis?", "No"),
                                            className: `btn-option ${selectedOptions["Is the planning and execution of the audit programme organised on a process-by-process basis?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Does the organization plan, establish, implement and maintain an audit programme(s)?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Does the organization plan, establish, implement and maintain an audit programme(s)?", "Yes"),
                                            className: `btn-option ${selectedOptions["Does the organization plan, establish, implement and maintain an audit programme(s)?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Does the organization plan, establish, implement and maintain an audit programme(s)?", "No"),
                                            className: `btn-option ${selectedOptions["Does the organization plan, establish, implement and maintain an audit programme(s)?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Does the organization use the results of previous audits to assess the effectiveness of actions taken to address the risks and opportunities?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Does the organization use the results of previous audits to assess the effectiveness of actions taken to address the risks and opportunities?", "Yes"),
                                            className: `btn-option ${selectedOptions["Does the organization use the results of previous audits to assess the effectiveness of actions taken to address the risks and opportunities?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Does the organization use the results of previous audits to assess the effectiveness of actions taken to address the risks and opportunities?", "No"),
                                            className: `btn-option ${selectedOptions["Does the organization use the results of previous audits to assess the effectiveness of actions taken to address the risks and opportunities?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Does the organization ensure that the results of the audits are reported to relevant management?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Does the organization ensure that the results of the audits are reported to relevant management?", "Yes"),
                                            className: `btn-option ${selectedOptions["Does the organization ensure that the results of the audits are reported to relevant management?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Does the organization ensure that the results of the audits are reported to relevant management?", "No"),
                                            className: `btn-option ${selectedOptions["Does the organization ensure that the results of the audits are reported to relevant management?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Are these audit results also visible to employees?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Are these audit results also visible to employees?", "Yes"),
                                            className: `btn-option ${selectedOptions["Are these audit results also visible to employees?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Are these audit results also visible to employees?", "No"),
                                            className: `btn-option ${selectedOptions["Are these audit results also visible to employees?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "form-actions",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/quality-4",
                            className: "btn-secondary",
                            children: "Back"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "btn-primary",
                            children: "Next"
                        })
                    ]
                }),
                isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "loading-indicator",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "spinner"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: "Saving data..."
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Quality5;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["Link","b9X5n"],["useHistory","ditZI"]],"../NavItems3":"fOarC","../NavItems2":"bnQuI","./Quality5.css":"6gEr1","../../styleguide.css":"8Y7Ec","../Quality1":"gkdwu","../Quality2":"hWTAB","../Quality3":"km669","../Quality4":"iCqMu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6gEr1":[function() {},{}],"8Y7Ec":[function() {},{}],"5js5u":[function(require,module,exports,__globalThis) {
/**
 * Utilitaire pour la gestion des scores
 * Ce fichier centralise la logique de sauvegarde des scores
 * pour garantir l'uniformité des noms de catégories
 */ /**
 * Sauvegarde les scores totaux de toutes les catégories
 * @param {Object} scores - Objet contenant les scores de chaque catégorie
 * @param {string} companyName - Nom de l'entreprise
 * @param {string} enterpriseId - ID de l'entreprise
 * @param {string} userId - ID de l'utilisateur
 * @returns {Promise} Promesse résolue après la sauvegarde
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "saveAllScores", ()=>saveAllScores);
parcelHelpers.export(exports, "saveCategoryScore", ()=>saveCategoryScore);
const saveAllScores = async (scores, companyName, enterpriseId, userId)=>{
    console.log("Appel \xe0\xa0 saveAllScores avec les param\xe8tres:", {
        scores: scores ? "Pr\xe9sent" : "Absent",
        companyName: companyName || "Non fourni",
        enterpriseId: enterpriseId || "Non fourni",
        userId: userId || "Non fourni"
    });
    // Vérifier que scores est bien défini
    if (!scores || typeof scores !== 'object') {
        console.error("ERREUR CRITIQUE: scores n'est pas un objet valide", scores);
        scores = {}; // Initialiser avec un objet vide plutà´t que de planter
    }
    // Vérifier la présence de l'ID d'entreprise
    if (!enterpriseId) {
        console.error("ERREUR CRITIQUE: enterpriseId manquant lors de la sauvegarde des scores");
        enterpriseId = localStorage.getItem("enterpriseId");
        console.log(`Tentative de r\xe9cup\xe9ration depuis le localStorage: ${enterpriseId}`);
        if (!enterpriseId) throw new Error("Impossible de sauvegarder les scores: ID d'entreprise manquant");
    }
    // Liste des catégories requises
    const requiredCategories = [
        "social",
        "environmental",
        "quality",
        "cost",
        "leadTime",
        "modernization",
        "clientConsumer"
    ];
    // Valider ou initialiser chaque catégorie de score
    const validatedScores = {};
    requiredCategories.forEach((category)=>{
        // Récupérer la valeur depuis l'objet scores
        const value = scores && scores[category] !== undefined ? scores[category] : 0;
        // Convertir en nombre et s'assurer qu'elle est valide
        const numericValue = parseInt(value, 10);
        validatedScores[category] = isNaN(numericValue) ? 0 : numericValue;
        console.log(`Score ${category}: ${validatedScores[category]} (original: ${value})`);
    });
    // Vérifier si au moins un score est non-nul
    const hasNonZeroScores = Object.values(validatedScores).some((value)=>value > 0);
    if (!hasNonZeroScores) console.warn("ATTENTION: Tous les scores sont \xe0\xa0 z\xe9ro. V\xe9rifiez que l'\xe9valuation a bien \xe9t\xe9 compl\xe9t\xe9e.");
    // Structure uniforme avec les noms de catégories standardisés
    const allScoresData = {
        enterprise: {
            name: companyName || "Entreprise non sp\xe9cifi\xe9e"
        },
        // Utiliser les valeurs validées pour chaque catégorie
        social: {
            Total: validatedScores.social
        },
        environmental: {
            Total: validatedScores.environmental
        },
        quality: {
            Total: validatedScores.quality
        },
        cost: {
            Total: validatedScores.cost
        },
        leadTime: {
            Total: validatedScores.leadTime
        },
        modernization: {
            Total: validatedScores.modernization
        },
        clientConsumer: {
            Total: validatedScores.clientConsumer
        },
        // Métadonnées
        enterpriseId: enterpriseId,
        userId: userId,
        timestamp: new Date().toISOString()
    };
    console.log("Sauvegarde des scores totaux:", JSON.stringify(allScoresData, null, 2));
    // Vérifier que les données ne sont pas vides
    if (!allScoresData || Object.keys(allScoresData).length === 0) {
        console.error("ERREUR CRITIQUE: Les donn\xe9es \xe0\xa0 envoyer sont vides");
        throw new Error("Impossible de sauvegarder: donn\xe9es vides");
    }
    try {
        const response = await fetch(`${"/api"}/api/save-points`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
            },
            body: JSON.stringify(allScoresData)
        });
        if (!response.ok) {
            const errorText = await response.text();
            console.error(`Erreur lors de la sauvegarde (${response.status}): ${errorText}`);
            throw new Error(`Erreur lors de la sauvegarde (${response.status}): ${errorText}`);
        }
        const result = await response.json();
        console.log("R\xe9sultat de la sauvegarde:", result);
        // Vérification si l'ID d'entreprise a été correctement utilisé
        if (result.had_enterprise_id === false) console.warn("L'ID d'entreprise n'a pas \xe9t\xe9 correctement enregistr\xe9!");
        // Vérifier que toutes les catégories ont été correctement sauvegardées
        if (result.categories_status) {
            console.log("Statut des cat\xe9gories sauvegard\xe9es:");
            Object.entries(result.categories_status).forEach(([category, status])=>{
                console.log(`  - ${category}: ${status}`);
            });
        }
        return result;
    } catch (error) {
        console.error("Erreur lors de la sauvegarde des scores:", error);
        throw error;
    }
};
const saveCategoryScore = async (category, score, enterpriseId, userId)=>{
    console.log("Appel \xe0\xa0 saveCategoryScore avec les param\xe8tres:", {
        category: category || "Non fournie",
        score: score !== undefined ? score : "Non fourni",
        enterpriseId: enterpriseId || "Non fourni",
        userId: userId || "Non fourni"
    });
    // Vérifier que la catégorie est bien définie
    if (!category) {
        console.error("ERREUR: Cat\xe9gorie non sp\xe9cifi\xe9e");
        throw new Error("Impossible de sauvegarder le score: cat\xe9gorie manquante");
    }
    // Vérifier que le score est bien défini
    if (score === undefined || score === null) {
        console.error("ERREUR: Score non sp\xe9cifi\xe9");
        score = 0; // Valeur par défaut
    }
    // Convertir le score en nombre
    const numericScore = parseInt(score, 10);
    if (isNaN(numericScore)) {
        console.warn(`Score invalide: ${score}, utilisation de 0 par d\xe9faut`);
        score = 0;
    } else score = numericScore;
    // Récupérer l'ID d'entreprise du localStorage si non fourni
    if (!enterpriseId) {
        console.warn("ID d'entreprise non fourni, tentative de r\xe9cup\xe9ration depuis localStorage");
        enterpriseId = localStorage.getItem("enterpriseId");
        if (!enterpriseId) {
            console.error("ERREUR: Impossible de trouver l'ID d'entreprise");
            throw new Error("ID d'entreprise manquant");
        }
    }
    const categoryKey = getCategoryKey(category);
    console.log(`Utilisation de la cl\xe9 de cat\xe9gorie standardis\xe9e: ${categoryKey}`);
    const scoreData = [
        {
            question: `${categoryKey} Total Score`,
            answer: score.toString(),
            category: categoryKey,
            section: "summary",
            enterpriseId: enterpriseId,
            userId: userId,
            timestamp: new Date().toISOString()
        }
    ];
    console.log("Donn\xe9es \xe0\xa0 envoyer:", JSON.stringify(scoreData, null, 2));
    try {
        console.log(`Envoi de la requ\xe0\xaate \xe0\xa0 ${"/api"}/api/save-answers`);
        const response = await fetch(`${"/api"}/api/save-answers`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
            },
            body: JSON.stringify(scoreData)
        });
        if (!response.ok) {
            const errorText = await response.text();
            console.error(`Erreur serveur (${response.status}): ${errorText}`);
            throw new Error(`Erreur lors de la sauvegarde (${response.status}): ${errorText}`);
        }
        const result = await response.json();
        console.log("R\xe9sultat de la sauvegarde:", result);
        return result;
    } catch (error) {
        console.error(`Erreur lors de la sauvegarde du score ${category}:`, error);
        throw error;
    }
};
/**
 * Convertit un nom de catégorie quelconque en clé standardisée
 * @param {string} category - Nom de catégorie (peut àªtre n'importe quel format)
 * @returns {string} Clé standardisée
 */ const getCategoryKey = (category)=>{
    // Table de correspondance pour assurer l'uniformité
    const categoryMap = {
        // Standardisé (retourné tel quel)
        'environmental': 'environmental',
        'social': 'social',
        'modernization': 'modernization',
        'leadTime': 'leadTime',
        'cost': 'cost',
        'quality': 'quality',
        'clientConsumer': 'clientConsumer'
    };
    // Simplifier la catégorie pour la recherche (minuscules)
    const simplifiedCategory = category.toLowerCase();
    // Trouver la correspondance ou retourner la catégorie originale
    for (const [key, value] of Object.entries(categoryMap)){
        if (key.toLowerCase() === simplifiedCategory) return value;
    }
    console.warn(`Cat\xe9gorie non reconnue: ${category}, utilisation telle quelle`);
    return category;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eVcW8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cc_sum", ()=>cc_sum);
parcelHelpers.export(exports, "cc_allData2", ()=>cc_allData2);
parcelHelpers.export(exports, "cc_yesCount2", ()=>cc_yesCount2);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _clientConsommateur2Css = require("./ClientConsommateur2_.css");
var _styleguideCss = require("../../styleguide.css");
var _jspdf = require("jspdf");
var _jspdfDefault = parcelHelpers.interopDefault(_jspdf);
var _clientConsommateur1 = require("../ClientConsommateur1_");
var _social6 = require("../Social6_");
var _acquisition = require("../Acquisition");
var _environmental5 = require("../Environmental5_");
var _modernization4 = require("../Modernization4_");
var _leadTime2 = require("../LeadTime2_");
var _cost2 = require("../Cost2_");
var _quality6 = require("../Quality6_");
var _scoreHelper = require("../../utils/scoreHelper");
let cc_sum = 0;
let cc_allData2 = [];
let cc_yesCount2 = 0;
function ClientConsommateur2_(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const [message, setMessage] = (0, _react.useState)("");
    const [scoreState, setScoreState] = (0, _react.useState)(0); // score du ClientConsommateur2
    const [ccYesCount1, setCcYesCount1] = (0, _react.useState)(0); // score récupéré du ClientConsommateur1
    const { x1200PxLogo_Icam__20081, navItems3Props } = props;
    (0, _react.useEffect)(()=>{
        // Reset le score du composant 2
        cc_yesCount2 = 0;
        setScoreState(0);
        // Récupérer le score de ClientConsommateur1 depuis le localStorage
        const clientConsommateur1Score = parseInt(localStorage.getItem('clientConsommateur1Score') || 0);
        setCcYesCount1(clientConsommateur1Score); // on met à  jour le state pour React
        console.log(`Score ClientConsommateur1 r\xe9cup\xe9r\xe9: ${clientConsommateur1Score}`);
        // Calculate total questions
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
        // Utilise la variable locale pour calculer cc_sum
        cc_sum = clientConsommateur1Score + cc_yesCount2;
        console.log(`cc_sum initial: ${cc_sum} (cc_yesCount1: ${clientConsommateur1Score}, cc_yesCount2: ${cc_yesCount2})`);
    }, []);
    // Exécuter seulement au montage du composant, pas à  chaque changement de cc_yesCount2
    function clicked(question, option) {
        console.log(`Option clicked: ${option} for question: ${question}`);
        // If the clicked option is the same as the already selected one, deselect it
        if (selectedOptions[question] === option) {
            setSelectedOptions((prevSelectedOptions)=>{
                const newOptions = {
                    ...prevSelectedOptions
                };
                delete newOptions[question];
                return newOptions;
            });
            // If we deselect a "Yes", decrement the score
            if (option === "Yes") {
                cc_yesCount2--;
                setScoreState(cc_yesCount2);
                console.log(`Score apr\xe8s d\xe9s\xe9lection: ${cc_yesCount2}`);
            }
            return;
        }
        // Otherwise, update the selection
        const previousOption = selectedOptions[question];
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        // If changing from "No" to "Yes", increment the score
        if (option === "Yes" && previousOption !== "Yes") {
            cc_yesCount2++;
            setScoreState(cc_yesCount2);
            console.log(`Score apr\xe8s s\xe9lection Yes: ${cc_yesCount2}`);
        } else if (option === "No" && previousOption === "Yes") {
            cc_yesCount2--;
            setScoreState(cc_yesCount2);
            console.log(`Score apr\xe8s s\xe9lection No: ${cc_yesCount2}`);
        }
        // Mettre à  jour cc_sum après modification du score
        cc_sum = ccYesCount1 + cc_yesCount2;
        console.log(`cc_sum mis \xe0\xa0 jour: ${cc_sum}`);
    }
    const history = (0, _reactRouterDom.useHistory)();
    function saveData() {
        setIsLoading(true);
        setErrorMessage("");
        console.log("D\xe9but de sauvegarde des donn\xe9es ClientConsommateur2");
        const enterpriseId = localStorage.getItem("enterpriseId");
        const userId = localStorage.getItem("userId");
        if (!enterpriseId) {
            console.error("ERREUR: ID d'entreprise manquant");
            setErrorMessage("ID d'entreprise manquant. Veuillez retourner \xe0\xa0 la s\xe9lection d'entreprise.");
            setIsLoading(false);
            return;
        }
        // Définir toutes les questions qui apparaissent dans le composant
        const allQuestions = [
            "Is your complaint rate above 75%?",
            "Do you have a Warehouse Management System (WMS) to manage product movement and storage?",
            "Do you take measures for data protection?",
            "Do you have justified complaints about privacy violations or customer data loss?"
        ];
        // Créer un tableau de questions/réponses pour toutes les questions
        const data = allQuestions.map((question)=>{
            const answer = selectedOptions[question] || "No";
            return {
                question: question,
                answer: answer,
                category: "client-consommateur",
                enterpriseId: enterpriseId,
                userId: userId || "",
                section: "client-consommateur-2",
                timestamp: new Date().toISOString()
            };
        });
        // Vérifier que les données sont correctement formatées
        const isValidData = data.every((item)=>item.question && item.answer && item.category && item.enterpriseId);
        if (!isValidData) {
            console.error("Donn\xe9es invalides:", data);
            setErrorMessage("Format de donn\xe9es invalide");
            setIsLoading(false);
            return;
        }
        // Sauvegarder les données pour une utilisation ultérieure
        cc_allData2 = [
            ...data
        ];
        console.log("Donn\xe9es \xe0\xa0 envoyer:", JSON.stringify(data, null, 2));
        // Calculer la somme des scores Cost1 et Cost2
        const clientConsommateur1Score = parseInt(localStorage.getItem('clientConsommateur1Score') || 0);
        cc_sum = clientConsommateur1Score + scoreState;
        console.log("Score total ClientConsommateur:", cc_sum);
        // Appel API pour sauvegarder les données
        fetch("/api/api/save-evaluation", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
            },
            body: JSON.stringify(data)
        }).then((response)=>{
            if (!response.ok) throw new Error(`Erreur de sauvegarde (${response.status})`);
            return response.json();
        }).then((result)=>{
            console.log("Data saved successfully:", result);
            // Sauvegarder le score dans le localStorage
            localStorage.setItem('clientConsommateur2Score', scoreState);
            console.log(`Score clientConsommateur2 mis \xe0\xa0 jour: ${scoreState}`);
            // Sauvegarder également le score total clientConsommateur
            const scoreData = [
                {
                    question: "ClientConsommateur Total Score Final",
                    answer: cc_sum.toString(),
                    category: "client-consommateur",
                    enterpriseId: enterpriseId,
                    userId: userId || "",
                    section: "client-consommateur-total-final",
                    timestamp: new Date().toISOString()
                }
            ];
            console.log("Envoi du score total clientConsommateur:", JSON.stringify(scoreData, null, 2));
            // Appel API pour sauvegarder le score total
            return fetch("/api/api/save-evaluation", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
                },
                body: JSON.stringify(scoreData)
            });
        }).then((response)=>{
            if (!response || !response.ok) throw new Error("Failed to save total score");
            return response.json();
        }).then((scoreResponse)=>{
            console.log("Score total clientConsommateur enregistr\xe9 avec succ\xe8s:", scoreResponse);
            // Récupérer correctement les données de tous les composants
            const allClientConsommateurData = [];
            try {
                if (Array.isArray((0, _clientConsommateur1.cc_allData1)) && (0, _clientConsommateur1.cc_allData1).length > 0) allClientConsommateurData.push(...(0, _clientConsommateur1.cc_allData1));
                if (Array.isArray(cc_allData2) && cc_allData2.length > 0) allClientConsommateurData.push(...cc_allData2);
            } catch (error) {
                console.error("Erreur lors de la concat\xe9nation des donn\xe9es:", error);
            }
            console.log("Toutes les donn\xe9es ClientConsommateur pour le PDF:", allClientConsommateurData.length, "questions");
            // Générer le PDF avec toutes les données
            generatePdf(allClientConsommateurData);
            // Récupération des scores de toutes les catégories
            const social_value = parseInt(localStorage.getItem('social6Score') || 0);
            const environmental_value = parseInt(localStorage.getItem('environmental5Score') || 0);
            const quality_value = parseInt(localStorage.getItem('quality3Score') || 0);
            const cost_value = parseInt(localStorage.getItem('cost2Score') || 0);
            const leadTime_value = parseInt(localStorage.getItem('leadtime2Score') || 0);
            const modernization_value = parseInt(localStorage.getItem('modernization4Score') || 0);
            // S'assurer que cc_sum est à  jour avec les dernières valeurs
            cc_sum = ccYesCount1 + scoreState;
            const clientConsumer_value = cc_sum;
            console.log("Valeurs r\xe9cup\xe9r\xe9es pour chaque cat\xe9gorie:", {
                social: social_value,
                environmental: environmental_value,
                quality: quality_value,
                cost: cost_value,
                leadTime: leadTime_value,
                modernization: modernization_value,
                clientConsumer: clientConsumer_value
            });
            // Créer un objet avec tous les scores - S'assurer que la clé est exactement "clientConsumer"
            const allScores = {
                social: social_value,
                environmental: environmental_value,
                quality: quality_value,
                cost: cost_value,
                leadTime: leadTime_value,
                modernization: modernization_value,
                clientConsumer: clientConsumer_value // Vérifier que cette clé est correcte pour la base de données
            };
            // Afficher les scores avant l'envoi pour vérification
            console.log("SCORES \xe0\xa0 envoyer \xe0\xa0 saveAllScores:", JSON.stringify(allScores, null, 2));
            // Récupérer le nom de l'entreprise
            const company_name = localStorage.getItem("company_name") || "Entreprise sans nom";
            // Appeler la fonction centralisée pour sauvegarder tous les scores
            return (0, _scoreHelper.saveAllScores)(allScores, company_name, enterpriseId, userId);
        }).then((result)=>{
            console.log("Tous les scores ont \xe9t\xe9 sauvegard\xe9s avec succ\xe8s:", result);
            // Recalculer cc_sum pour s'assurer qu'il est à  jour
            const clientConsommateur1Score = parseInt(localStorage.getItem('clientConsommateur1Score') || 0);
            cc_sum = clientConsommateur1Score + scoreState;
            console.log(`Score clientConsumer avant sauvegarde s\xe9par\xe9e: ${cc_sum} (${clientConsommateur1Score} + ${scoreState})`);
            // Sauvegarder séparément le score clientConsumer pour s'assurer qu'il est bien enregistré
            return (0, _scoreHelper.saveCategoryScore)("clientConsumer", cc_sum, localStorage.getItem("enterpriseId"), localStorage.getItem("userId"));
        }).then((categoryResult)=>{
            console.log("Score clientConsumer sauvegard\xe9 s\xe9par\xe9ment:", categoryResult);
            setIsLoading(false);
            setMessage("Scores enregistr\xe9s avec succ\xe8s !");
            setTimeout(()=>{
                setMessage("");
                history.push("/cur-performance_");
            }, 2000);
        }).catch((error)=>{
            console.error("Error saving data:", error);
            setErrorMessage("Error saving data. Please try again.");
            console.error("D\xe9tails de l'erreur:", error.message);
            // Màªme en cas d'erreur, essayer de générer le PDF avec les données disponibles
            const allClientConsommateurData = [];
            try {
                if (Array.isArray((0, _clientConsommateur1.cc_allData1)) && (0, _clientConsommateur1.cc_allData1).length > 0) allClientConsommateurData.push(...(0, _clientConsommateur1.cc_allData1));
                if (Array.isArray(cc_allData2) && cc_allData2.length > 0) allClientConsommateurData.push(...cc_allData2);
            } catch (error) {
                console.error("Erreur lors de la concat\xe9nation des donn\xe9es:", error);
            }
            generatePdf(allClientConsommateurData);
            setIsLoading(false);
            history.push("/cur-performance_");
        });
    }
    function generatePdf(cc_allData) {
        // Check if data exists
        if (!cc_allData || cc_allData.length === 0) {
            console.error("No data available to generate PDF");
            return;
        }
        console.log("Generating PDF with", cc_allData.length, "questions");
        // Create a new PDF document
        const doc = new (0, _jspdfDefault.default)();
        const lineHeight = 10;
        const pageHeight = doc.internal.pageSize.height - 20;
        const pageWidth = doc.internal.pageSize.width - 20;
        let y = 20;
        // Add a title
        doc.setFontSize(16);
        doc.text("Client/Consumer Assessment Results", 105, y, {
            align: "center"
        });
        y += 15;
        // Add total score
        doc.setFontSize(14);
        doc.text(`Total score: ${cc_sum} / ${cc_allData.length}`, 105, y, {
            align: "center"
        });
        y += 15;
        doc.setFontSize(12);
        // Go through the data and add each question and answer to the PDF document
        cc_allData.forEach((data, index)=>{
            // Check if data is valid
            if (!data || !data.question) {
                console.error("Invalid data for item", index);
                return;
            }
            const question = `Question ${index + 1}: ${data.question}`;
            const answer = `Answer: ${data.answer || 'No answer'}`;
            // Estimate text height after division to better manage page breaks
            const splitQuestion = doc.splitTextToSize(question, pageWidth);
            const estimatedHeight = splitQuestion.length * lineHeight + lineHeight * 2;
            // Check if we need to go to a new page
            if (y + estimatedHeight > pageHeight) {
                doc.addPage();
                y = 20;
            }
            // Write the question and answer to the PDF
            doc.text(splitQuestion, 10, y);
            y += splitQuestion.length * lineHeight;
            doc.text(answer, 10, y);
            y += lineHeight * 2; // Add some space between questions
        });
        // Add a summary page
        doc.addPage();
        y = 20;
        doc.setFontSize(16);
        doc.text("Client/Consumer Assessment Summary", 105, y, {
            align: "center"
        });
        y += 20;
        doc.setFontSize(12);
        doc.text(`Total number of questions: ${cc_allData.length}`, 10, y);
        y += lineHeight;
        doc.text(`Total "Yes" answers: ${cc_sum}`, 10, y);
        y += lineHeight;
        doc.text(`Score percentage: ${Math.round(cc_sum / cc_allData.length * 100)}%`, 10, y);
        y += lineHeight * 2;
        // Add details for each section
        doc.text("Scores by section:", 10, y);
        y += lineHeight * 1.5;
        doc.text(`Client/Consumer 1: ${ccYesCount1}`, 20, y);
        y += lineHeight;
        doc.text(`Client/Consumer 2: ${scoreState}`, 20, y);
        y += lineHeight * 2;
        const date = new Date();
        doc.text(`Generated on: ${date.toLocaleDateString()} at ${date.toLocaleTimeString()}`, 10, y);
        // Save the PDF document
        doc.save("Client_Consumer_Assessment_Complete.pdf");
        console.log("Client/Consumer PDF generated successfully");
    }
    function calculateProgressPercentage() {
        const totalQuestions = document.getElementsByTagName("section").length;
        if (totalQuestions === 0) return 0;
        return Math.round(scoreState / totalQuestions * 100);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "environmental-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "environmental-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    className: "environmental-title",
                    children: "PLEASE ANSWER THE FOLLOWING QUESTIONS"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "progress-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "progress-bar",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "progress-fill",
                                style: {
                                    width: `${calculateProgressPercentage()}%`
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "progress-text",
                            children: [
                                "Your score: ",
                                scoreState,
                                " / ",
                                totalQuestions,
                                " (",
                                calculateProgressPercentage(),
                                "%)"
                            ]
                        })
                    ]
                }),
                errorMessage && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "error-message",
                    children: errorMessage
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questions-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Is your complaint rate above 75%?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Is your complaint rate above 75%?", "Yes"),
                                            className: `btn-option ${selectedOptions["Is your complaint rate above 75%?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Is your complaint rate above 75%?", "No"),
                                            className: `btn-option ${selectedOptions["Is your complaint rate above 75%?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have a Warehouse Management System (WMS) to manage product movement and storage?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a Warehouse Management System (WMS) to manage product movement and storage?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have a Warehouse Management System (WMS) to manage product movement and storage?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a Warehouse Management System (WMS) to manage product movement and storage?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have a Warehouse Management System (WMS) to manage product movement and storage?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you take measures for data protection?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you take measures for data protection?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you take measures for data protection?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you take measures for data protection?", "No"),
                                            className: `btn-option ${selectedOptions["Do you take measures for data protection?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have justified complaints about privacy violations or customer data loss?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have justified complaints about privacy violations or customer data loss?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have justified complaints about privacy violations or customer data loss?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have justified complaints about privacy violations or customer data loss?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have justified complaints about privacy violations or customer data loss?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "form-actions",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/client-consommateur-1_",
                            className: "btn-secondary",
                            children: "Back"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: ()=>saveData(),
                            className: "btn-primary",
                            children: "Save and Continue"
                        })
                    ]
                }),
                isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "loading-indicator",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "spinner"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: message
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = ClientConsommateur2_;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["Link","b9X5n"],["useHistory","ditZI"]],"../NavItems3":"fOarC","../NavItems2":"bnQuI","./ClientConsommateur2_.css":"hirNQ","../../styleguide.css":"8Y7Ec","jspdf":"hkJ4Q","../ClientConsommateur1_":"fhIrc","../Social6_":"4BDEv","../Acquisition":"h8aqW","../Environmental5_":"98DT2","../Modernization4_":"hsKo8","../LeadTime2_":"2qrDc","../Cost2_":"cEV7C","../Quality6_":"2MHU2","../../utils/scoreHelper":"5js5u","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hirNQ":[function() {},{}],"8Y7Ec":[function() {},{}],"fhIrc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cc_allData1", ()=>cc_allData1);
parcelHelpers.export(exports, "cc_yesCount1", ()=>cc_yesCount1);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _clientConsommateur1Css = require("./ClientConsommateur1_.css");
var _styleguideCss = require("../../styleguide.css");
let cc_allData1 = [];
let cc_yesCount1 = 0;
function ClientConsommateur1_(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const { x1200PxLogo_Icam__20081, navItems3Props } = props;
    const history = (0, _reactRouterDom.useHistory)();
    (0, _react.useEffect)(()=>{
        // Reset the count when component mounts to avoid residual values
        cc_yesCount1 = 0;
        // Calculate the total number of questions based on sections
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []); // Run this effect only once when the component mounts
    function clicked(question, option) {
        // If the clicked option is the same as the already selected one, deselect it
        if (selectedOptions[question] === option) {
            setSelectedOptions((prevSelectedOptions)=>{
                const newOptions = {
                    ...prevSelectedOptions
                };
                delete newOptions[question];
                return newOptions;
            });
            // If we deselect a "Yes", decrement the score
            if (option === "Yes") cc_yesCount1--;
            return;
        }
        // Otherwise, update the selection
        const previousOption = selectedOptions[question];
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        // If changing from "No" to "Yes", increment the score
        if (option === "Yes" && previousOption !== "Yes") cc_yesCount1++;
        else if (option === "No" && previousOption === "Yes") cc_yesCount1--;
    }
    function saveData() {
        setIsLoading(true);
        setErrorMessage("");
        console.log("D\xe9but de sauvegarde des donn\xe9es ClientConsommateur1");
        const enterpriseId = localStorage.getItem("enterpriseId");
        const userId = localStorage.getItem("userId");
        if (!enterpriseId) {
            console.error("ERREUR: ID d'entreprise manquant");
            setErrorMessage("ID d'entreprise manquant. Veuillez retourner \xe0\xa0 la s\xe9lection d'entreprise.");
            setIsLoading(false);
            return;
        }
        // Définir toutes les questions possibles
        const allQuestions = [
            "Do you transmit information about product progress to customers?",
            "Number of disputes and/or amicable settlements concerning the company (Do you have disputes and/or amicable settlements?)",
            "Are you audited by organizations such as data protection authorities?",
            "Do you have a communication plan with communities, NGOs and other external structures?",
            "Do you have a plan for improvement in client/consumer relations?",
            "Are your employees aware of best practices in terms of fair information, transparency, and fair contractual practices?",
            "Do your products have a description of the hazards?",
            "Do your products have safety warnings?",
            "Are your products tested before being put on the market?"
        ];
        // Créer un tableau de questions/réponses pour toutes les questions
        const data = allQuestions.map((question)=>{
            const answer = selectedOptions[question] || "No";
            return {
                question: question,
                answer: answer,
                category: "client-consommateur",
                enterpriseId: enterpriseId,
                userId: userId || "",
                section: "client-consommateur-1",
                timestamp: new Date().toISOString()
            };
        });
        // Vérifier que les données sont correctement formatées
        const isValidData = data.every((item)=>item.question && item.answer && item.category && item.enterpriseId);
        if (!isValidData) {
            console.error("Donn\xe9es invalides:", data);
            setErrorMessage("Format de donn\xe9es invalide");
            setIsLoading(false);
            return;
        }
        // Sauvegarder les données pour une utilisation ultérieure
        cc_allData1 = [
            ...data
        ];
        console.log("Donn\xe9es \xe0\xa0 envoyer:", JSON.stringify(data, null, 2));
        // Sauvegarder le score pour ClientConsommateur2
        localStorage.setItem('clientConsommateur1Score', cc_yesCount1);
        console.log(`Score clientConsommateur1 enregistr\xe9: ${cc_yesCount1}`);
        // Appel API pour sauvegarder les données
        fetch("/api/api/save-evaluation", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
            },
            body: JSON.stringify(data)
        }).then((response)=>{
            if (!response.ok) throw new Error(`Erreur de sauvegarde (${response.status})`);
            return response.json();
        }).then((result)=>{
            console.log("Data saved successfully:", result);
            setIsLoading(false);
            history.push("/client-consommateur-2_");
        }).catch((error)=>{
            console.error("Error saving data:", error);
            setErrorMessage("Error saving data. Please try again.");
            console.error("D\xe9tails de l'erreur:", error.message);
            setIsLoading(false);
            history.push("/client-consommateur-2_");
        });
    }
    function calculateProgressPercentage() {
        const totalQuestions = document.getElementsByTagName("section").length;
        if (totalQuestions === 0) return 0;
        return Math.round(cc_yesCount1 / totalQuestions * 100);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "environmental-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "environmental-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    className: "environmental-title",
                    children: "PLEASE ANSWER THE FOLLOWING QUESTIONS"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "progress-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "progress-bar",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "progress-fill",
                                style: {
                                    width: `${calculateProgressPercentage()}%`
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "progress-text",
                            children: [
                                "Your score: ",
                                cc_yesCount1,
                                " / ",
                                totalQuestions,
                                " (",
                                calculateProgressPercentage(),
                                "%)"
                            ]
                        })
                    ]
                }),
                errorMessage && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "error-message",
                    children: errorMessage
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questions-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you transmit information about product progress to customers?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you transmit information about product progress to customers?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you transmit information about product progress to customers?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you transmit information about product progress to customers?", "No"),
                                            className: `btn-option ${selectedOptions["Do you transmit information about product progress to customers?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Number of disputes and/or amicable settlements concerning the company (Do you have disputes and/or amicable settlements?)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Number of disputes and/or amicable settlements concerning the company (Do you have disputes and/or amicable settlements?)", "Yes"),
                                            className: `btn-option ${selectedOptions["Number of disputes and/or amicable settlements concerning the company (Do you have disputes and/or amicable settlements?)"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Number of disputes and/or amicable settlements concerning the company (Do you have disputes and/or amicable settlements?)", "No"),
                                            className: `btn-option ${selectedOptions["Number of disputes and/or amicable settlements concerning the company (Do you have disputes and/or amicable settlements?)"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Are you audited by organizations such as data protection authorities?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Are you audited by organizations such as data protection authorities?", "Yes"),
                                            className: `btn-option ${selectedOptions["Are you audited by organizations such as data protection authorities?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Are you audited by organizations such as data protection authorities?", "No"),
                                            className: `btn-option ${selectedOptions["Are you audited by organizations such as data protection authorities?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have safety notices?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have safety notices?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have safety notices?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have safety notices?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have safety notices?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have a recall procedure?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a recall procedure?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have a recall procedure?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a recall procedure?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have a recall procedure?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "form-actions",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/quality-6_",
                            className: "btn-secondary",
                            children: "Back"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "btn-primary",
                            children: "Next"
                        })
                    ]
                }),
                isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "loading-indicator",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "spinner"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: "Saving data..."
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = ClientConsommateur1_;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["Link","b9X5n"],["useHistory","ditZI"]],"../NavItems3":"fOarC","../NavItems2":"bnQuI","./ClientConsommateur1_.css":"eODhr","../../styleguide.css":"8Y7Ec","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eODhr":[function() {},{}],"8Y7Ec":[function() {},{}],"4BDEv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "s_sum", ()=>s_sum);
parcelHelpers.export(exports, "yes_Count6", ()=>yes_Count6);
parcelHelpers.export(exports, "s_yesCount6", ()=>s_yesCount6);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _social6Css = require("./Social6_.css");
var _social1 = require("../Social1_");
var _social2 = require("../Social2_");
var _social3 = require("../Social3_");
var _social4 = require("../Social4_");
var _social5 = require("../Social5_");
var _jspdf = require("jspdf");
var _jspdfDefault = parcelHelpers.interopDefault(_jspdf);
let s_sum = 0;
let yes_Count6 = 0;
let s_yesCount6 = 0;
function Social6_(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [yesCount6, setYesCount6] = (0, _react.useState)(0); // Initialize yesCount state
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const { x1200PxLogo_Icam__20081, modernizationCriteria, navItems3Props, toggle1Props, toggle2Props, toggle3Props, toggle4Props } = props;
    (0, _react.useEffect)(()=>{
        // Calculate the total number of questions based on sections
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []); // Run this effect only once when the component mounts
    function clicked(question, option) {
        // Si l'option cliquée est la màªme que celle déjà  sélectionnée, on la désélectionne
        if (selectedOptions[question] === option) {
            setSelectedOptions((prevSelectedOptions)=>{
                const newOptions = {
                    ...prevSelectedOptions
                };
                delete newOptions[question];
                return newOptions;
            });
            // Si on désélectionne un "Yes", on décrémente le score
            if (option === "Yes") {
                s_yesCount6--;
                yes_Count6 = s_yesCount6; // Synchroniser les deux variables
            }
            return;
        }
        // Sinon, on met à  jour la sélection
        const previousOption = selectedOptions[question];
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        // Si on passe de "No" à  "Yes", on incrémente le score
        if (option === "Yes" && previousOption !== "Yes") {
            s_yesCount6++;
            yes_Count6 = s_yesCount6; // Synchroniser les deux variables
        } else if (option === "No" && previousOption === "Yes") {
            s_yesCount6--;
            yes_Count6 = s_yesCount6; // Synchroniser les deux variables
        }
    }
    const history = (0, _reactRouterDom.useHistory)();
    let s_allData6 = [];
    function saveData() {
        setErrorMessage("");
        setIsLoading(true);
        console.log("D\xe9but de sauvegarde des donn\xe9es Social6");
        const enterpriseId = localStorage.getItem("enterpriseId");
        const userId = localStorage.getItem("userId");
        if (!enterpriseId) {
            console.error("ERREUR: ID d'entreprise manquant");
            setErrorMessage("ID d'entreprise manquant. Veuillez retourner \xe0\xa0 la s\xe9lection d'entreprise.");
            setIsLoading(false);
            return;
        }
        // Définir toutes les questions possibles
        const allQuestions = [
            "Do you contribute to the development of the regions where you are located?",
            "Do you regularly consult with local communities to ensure that your activities do not have a negative impact?",
            "Do you engage in direct dialogue with communities affected by your activities?",
            "Do you have a positive impact on employment in the regions where you are located?",
            "Do you contribute to the economic development of the regions where you are located?",
            "Do you maintain a high level of safety and physical, mental and social well-being of workers (the notion of worker encompasses all populations of employed workers: company employees, seconded workers, self-employed workers, temporary workers, trainees, apprentices...)?",
            "Are staff trained in occupational health and safety?",
            "Is there a budget for health and safety?",
            "Do you prevent and protect employees from negative health effects resulting from working conditions?",
            "Are job descriptions provided to prevention workers (good practices, etc.)?",
            "Percentage of the number of dangerous situations dealt with out of the number of dangerous situations detected",
            "Do you have a work environment that is adapted to the physiological and psychological needs of workers?"
        ];
        // Créer un tableau de questions/réponses pour toutes les questions
        const data = allQuestions.map((question)=>{
            const answer = selectedOptions[question] || "No";
            return {
                question: question,
                answer: answer,
                category: "social",
                enterpriseId: enterpriseId,
                userId: userId || "",
                section: "social-6",
                timestamp: new Date().toISOString()
            };
        });
        // Vérifier que les données sont correctement formatées
        const isValidData = data.every((item)=>item.question && item.answer && item.category && item.enterpriseId);
        if (!isValidData) {
            console.error("Donn\xe9es invalides:", data);
            setErrorMessage("Format de donn\xe9es invalide");
            setIsLoading(false);
            return;
        }
        // Sauvegarder les données pour une utilisation ultérieure
        s_allData6 = [
            ...data
        ];
        console.log("Donn\xe9es \xe0\xa0 envoyer:", JSON.stringify(data, null, 2));
        // Appel API pour sauvegarder les données
        fetch("/api/api/save-evaluation", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
            },
            body: JSON.stringify(data)
        }).then((response)=>{
            if (!response.ok) throw new Error(`Erreur de sauvegarde (${response.status})`);
            return response.json();
        }).then((result)=>{
            console.log("Data saved successfully:", result);
            // Sauvegarder le score dans le localStorage
            localStorage.setItem('social6Score', yes_Count6);
            console.log(`Score social6 mis \xe0\xa0 jour: ${yes_Count6}`);
            // Récupérer tous les scores sociaux du localStorage
            const social1Score = parseInt(localStorage.getItem('social1Score') || 0);
            const social2Score = parseInt(localStorage.getItem('social2Score') || 0);
            const social3Score = parseInt(localStorage.getItem('social3Score') || 0);
            const social4Score = parseInt(localStorage.getItem('social4Score') || 0);
            const social5Score = parseInt(localStorage.getItem('social5Score') || 0);
            const social6Score = parseInt(localStorage.getItem('social6Score') || 0);
            // Calculer le score total social
            s_sum = social1Score + social2Score + social3Score + social4Score + social5Score + social6Score;
            console.log("Score total social calcul\xe9:", s_sum);
            console.log("Scores individuels:", {
                social1Score,
                social2Score,
                social3Score,
                social4Score,
                social5Score,
                social6Score
            });
            // Sauvegarder également le score total social final
            const scoreData = [
                {
                    question: "Social Total Score Final",
                    answer: s_sum.toString(),
                    category: "social",
                    enterpriseId: enterpriseId,
                    userId: userId || "",
                    section: "social-total-final",
                    timestamp: new Date().toISOString()
                }
            ];
            console.log("Envoi du score total social:", JSON.stringify(scoreData, null, 2));
            // Appel API pour sauvegarder le score total
            return fetch("/api/api/save-evaluation", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
                },
                body: JSON.stringify(scoreData)
            });
        }).then((response)=>{
            if (!response || !response.ok) throw new Error("Failed to save total score");
            return response.json();
        }).then((scoreResponse)=>{
            console.log("Score total social enregistr\xe9 avec succ\xe8s:", scoreResponse);
            // Récupérer correctement les données de tous les composants
            const allSocialData = [];
            // Utiliser des try/catch pour éviter les erreurs si certaines données sont manquantes
            try {
                if (Array.isArray((0, _social1.s_allData1)) && (0, _social1.s_allData1).length > 0) allSocialData.push(...(0, _social1.s_allData1));
                if (Array.isArray((0, _social2.s_allData2)) && (0, _social2.s_allData2).length > 0) allSocialData.push(...(0, _social2.s_allData2));
                if (Array.isArray((0, _social3.s_allData3)) && (0, _social3.s_allData3).length > 0) allSocialData.push(...(0, _social3.s_allData3));
                if (Array.isArray((0, _social4.s_allData4)) && (0, _social4.s_allData4).length > 0) allSocialData.push(...(0, _social4.s_allData4));
                if (Array.isArray((0, _social5.s_allData5)) && (0, _social5.s_allData5).length > 0) allSocialData.push(...(0, _social5.s_allData5));
                if (Array.isArray(s_allData6) && s_allData6.length > 0) allSocialData.push(...s_allData6);
            } catch (error) {
                console.error("Erreur lors de la concat\xe9nation des donn\xe9es:", error);
            }
            console.log("Toutes les donn\xe9es sociales pour le PDF:", allSocialData.length, "questions");
            // Générer le PDF avec toutes les données sociales
            generatePdf(allSocialData);
            // Redirection vers la page suivante
            setIsLoading(false);
            history.push("/modernization-1_");
        }).catch((error)=>{
            console.error("Error saving data:", error);
            setErrorMessage("Error saving data. Please try again.");
            console.error("D\xe9tails de l'erreur:", error.message);
            // Màªme en cas d'erreur, essayer de générer le PDF avec les données disponibles
            const allSocialData = [];
            try {
                if (Array.isArray((0, _social1.s_allData1)) && (0, _social1.s_allData1).length > 0) allSocialData.push(...(0, _social1.s_allData1));
                if (Array.isArray((0, _social2.s_allData2)) && (0, _social2.s_allData2).length > 0) allSocialData.push(...(0, _social2.s_allData2));
                if (Array.isArray((0, _social3.s_allData3)) && (0, _social3.s_allData3).length > 0) allSocialData.push(...(0, _social3.s_allData3));
                if (Array.isArray((0, _social4.s_allData4)) && (0, _social4.s_allData4).length > 0) allSocialData.push(...(0, _social4.s_allData4));
                if (Array.isArray((0, _social5.s_allData5)) && (0, _social5.s_allData5).length > 0) allSocialData.push(...(0, _social5.s_allData5));
                if (Array.isArray(s_allData6) && s_allData6.length > 0) allSocialData.push(...s_allData6);
            } catch (error) {
                console.error("Erreur lors de la concat\xe9nation des donn\xe9es:", error);
            }
            generatePdf(allSocialData);
            // Continuer quand màªme vers la page suivante en cas d'erreur
            setIsLoading(false);
            history.push("/modernization-1_");
        });
    }
    function generatePdf(s_allData) {
        // Vérifier si des données existent
        if (!s_allData || s_allData.length === 0) {
            console.error("Aucune donn\xe9e disponible pour g\xe9n\xe9rer le PDF");
            return;
        }
        console.log("G\xe9n\xe9ration du PDF avec", s_allData.length, "questions");
        // Créer un nouveau document PDF
        const doc = new (0, _jspdfDefault.default)();
        const lineHeight = 10;
        const pageHeight = doc.internal.pageSize.height - 20;
        const pageWidth = doc.internal.pageSize.width - 20;
        let y = 20;
        // Ajouter un titre
        doc.setFontSize(16);
        doc.text("Social Assessment Results", 105, y, {
            align: "center"
        });
        y += 15;
        // Ajouter le score total
        doc.setFontSize(14);
        doc.text(`Total Score: ${s_sum} / ${s_allData.length}`, 105, y, {
            align: "center"
        });
        y += 15;
        doc.setFontSize(12);
        // Parcourir les données dans s_allData et ajouter chaque question et réponse au document PDF
        s_allData.forEach((data, index)=>{
            // Vérifier si les données sont valides
            if (!data || !data.question) {
                console.error("Donn\xe9es invalides pour l'\xe9l\xe9ment", index);
                return;
            }
            const question = `Question ${index + 1}: ${data.question}`;
            const answer = `Answer: ${data.answer || 'No answer'}`;
            // Vérifier si la position y actuelle plus la hauteur de la question dépasse la hauteur maximale de la page
            // Estimer la hauteur du texte après division
            const splitQuestion = doc.splitTextToSize(question, pageWidth);
            const estimatedHeight = splitQuestion.length * lineHeight + lineHeight * 2;
            if (y + estimatedHeight > pageHeight) {
                // Ajouter une nouvelle page et réinitialiser la position y
                doc.addPage();
                y = 20;
            }
            // Séparer la question sur plusieurs lignes si elle est trop longue
            doc.text(splitQuestion, 10, y);
            y += splitQuestion.length * lineHeight;
            doc.text(answer, 10, y);
            y += lineHeight * 2; // Ajouter un peu d'espace entre les questions
        });
        // Ajouter une page de résumé
        doc.addPage();
        y = 20;
        doc.setFontSize(16);
        doc.text("Summary of Social Assessment", 105, y, {
            align: "center"
        });
        y += 20;
        doc.setFontSize(12);
        doc.text(`Total number of questions: ${s_allData.length}`, 10, y);
        y += lineHeight;
        doc.text(`Total "Yes" answers: ${s_sum}`, 10, y);
        y += lineHeight;
        doc.text(`Score percentage: ${Math.round(s_sum / s_allData.length * 100)}%`, 10, y);
        y += lineHeight * 2;
        const date = new Date();
        doc.text(`Generated on: ${date.toLocaleDateString()} at ${date.toLocaleTimeString()}`, 10, y);
        // Enregistrer le document PDF
        doc.save("Social_Assessment_Complete.pdf");
        console.log("PDF g\xe9n\xe9r\xe9 avec succ\xe8s");
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "modernization-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "modernization-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    className: "modernization-title",
                    children: "PLEASE ANSWER THE FOLLOWING QUESTIONS"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "progress-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "progress-bar",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "progress-fill",
                                style: {
                                    width: `${Object.keys(selectedOptions).length / totalQuestions * 100}%`
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "progress-text",
                            children: [
                                "Your score: ",
                                yes_Count6,
                                " / ",
                                totalQuestions,
                                " (",
                                Math.round(yes_Count6 / totalQuestions * 100) || 0,
                                "%)"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questions-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you maintain a high level of safety and physical, mental and social well-being of workers (the notion of worker encompasses all populations of employed workers: company employees, seconded workers, self-employed workers, temporary workers, trainees, apprentices...)?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you maintain a high level of safety and physical, mental and social well-being of workers (the notion of worker encompasses all populations of employed workers: company employees, seconded workers, self-employed workers, temporary workers, trainees, apprentices...)?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you maintain a high level of safety and physical, mental and social well-being of workers (the notion of worker encompasses all populations of employed workers: company employees, seconded workers, self-employed workers, temporary workers, trainees, apprentices...)?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you maintain a high level of safety and physical, mental and social well-being of workers (the notion of worker encompasses all populations of employed workers: company employees, seconded workers, self-employed workers, temporary workers, trainees, apprentices...)?", "No"),
                                            className: `btn-option ${selectedOptions["Do you maintain a high level of safety and physical, mental and social well-being of workers (the notion of worker encompasses all populations of employed workers: company employees, seconded workers, self-employed workers, temporary workers, trainees, apprentices...)?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Are staff trained in occupational health and safety?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Are staff trained in occupational health and safety?", "Yes"),
                                            className: `btn-option ${selectedOptions["Are staff trained in occupational health and safety?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Are staff trained in occupational health and safety?", "No"),
                                            className: `btn-option ${selectedOptions["Are staff trained in occupational health and safety?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Is there a budget for health and safety?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Is there a budget for health and safety?", "Yes"),
                                            className: `btn-option ${selectedOptions["Is there a budget for health and safety?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Is there a budget for health and safety?", "No"),
                                            className: `btn-option ${selectedOptions["Is there a budget for health and safety?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you prevent and protect employees from negative health effects resulting from working conditions?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you prevent and protect employees from negative health effects resulting from working conditions?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you prevent and protect employees from negative health effects resulting from working conditions?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you prevent and protect employees from negative health effects resulting from working conditions?", "No"),
                                            className: `btn-option ${selectedOptions["Do you prevent and protect employees from negative health effects resulting from working conditions?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Are job descriptions provided to prevention workers (good practices, etc.)?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Are job descriptions provided to prevention workers (good practices, etc.)?", "Yes"),
                                            className: `btn-option ${selectedOptions["Are job descriptions provided to prevention workers (good practices, etc.)?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Are job descriptions provided to prevention workers (good practices, etc.)?", "No"),
                                            className: `btn-option ${selectedOptions["Are job descriptions provided to prevention workers (good practices, etc.)?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Percentage of the number of dangerous situations dealt with out of the number of dangerous situations detected"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Percentage of the number of dangerous situations dealt with out of the number of dangerous situations detected", "Yes"),
                                            className: `btn-option ${selectedOptions["Percentage of the number of dangerous situations dealt with out of the number of dangerous situations detected"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Percentage of the number of dangerous situations dealt with out of the number of dangerous situations detected", "No"),
                                            className: `btn-option ${selectedOptions["Percentage of the number of dangerous situations dealt with out of the number of dangerous situations detected"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have a work environment that is adapted to the physiological and psychological needs of workers?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a work environment that is adapted to the physiological and psychological needs of workers?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have a work environment that is adapted to the physiological and psychological needs of workers?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a work environment that is adapted to the physiological and psychological needs of workers?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have a work environment that is adapted to the physiological and psychological needs of workers?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "form-actions",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/social-5_",
                            className: "btn-secondary",
                            children: "Back"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "btn-primary",
                            children: "Submit Social Assessment"
                        })
                    ]
                }),
                isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "loading-indicator",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "spinner"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: "Saving data and generating PDF..."
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Social6_;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["Link","b9X5n"],["useHistory","ditZI"]],"../NavItems3":"fOarC","../NavItems2":"bnQuI","../Toggle":"dSqDu","./Social6_.css":"7z4lr","../Social1_":"9IXzw","../Social2_":"ahoL9","../Social3_":"3xLfp","../Social4_":"faPBh","../Social5_":"7gq3N","jspdf":"hkJ4Q","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7z4lr":[function() {},{}],"9IXzw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "s_allData1", ()=>s_allData1);
parcelHelpers.export(exports, "s_final", ()=>s_final);
parcelHelpers.export(exports, "yes_Count1", ()=>yes_Count1);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _frame113 = require("../Frame113");
var _frame113Default = parcelHelpers.interopDefault(_frame113);
var _frame114 = require("../Frame114");
var _frame114Default = parcelHelpers.interopDefault(_frame114);
var _frame115 = require("../Frame115");
var _frame115Default = parcelHelpers.interopDefault(_frame115);
var _frame116 = require("../Frame116");
var _frame116Default = parcelHelpers.interopDefault(_frame116);
var _frame117 = require("../Frame117");
var _frame117Default = parcelHelpers.interopDefault(_frame117);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _social1Css = require("./Social1_.css");
var _styleguideCss = require("../../styleguide.css");
let s_allData1 = [];
let s_final = 0;
let yes_Count1 = 0;
function Social1_(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [yesCount1, setYesCount1] = (0, _react.useState)(0); // Initialize yesCount state
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const [isSaving, setIsSaving] = (0, _react.useState)(false);
    const { x1200PxLogo_Icam__20081, pleaseAnswerTheFollowingQuestions, navItems3Props, frame113Props, frame117Props, toggle1Props, toggle2Props, toggle3Props } = props;
    (0, _react.useEffect)(()=>{
        // Calculate the total number of questions based on sections
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []); // Run this effect only once when the component mounts
    function clicked(question, option) {
        // Si l'option cliquée est la màªme que celle déjà  sélectionnée, on la désélectionne
        if (selectedOptions[question] === option) {
            setSelectedOptions((prevSelectedOptions)=>{
                const newOptions = {
                    ...prevSelectedOptions
                };
                delete newOptions[question];
                return newOptions;
            });
            // Si on désélectionne un "Yes", on décrémente le score
            if (option === "Yes") yes_Count1--;
            return;
        }
        // Sinon, on met à  jour la sélection
        const previousOption = selectedOptions[question];
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        // Si on passe de "No" à  "Yes", on incrémente le score
        if (option === "Yes" && previousOption !== "Yes") yes_Count1++;
        else if (option === "No" && previousOption === "Yes") yes_Count1--;
    }
    const history = (0, _reactRouterDom.useHistory)();
    function saveData() {
        setIsSaving(true);
        setErrorMessage("");
        console.log("D\xe9but de sauvegarde des donn\xe9es Social1");
        const enterpriseId = localStorage.getItem("enterpriseId");
        const userId = localStorage.getItem("userId");
        if (!enterpriseId) {
            console.error("ERREUR: ID d'entreprise manquant");
            setErrorMessage("ID d'entreprise manquant. Veuillez retourner \xe0\xa0 la s\xe9lection d'entreprise.");
            setIsSaving(false);
            return;
        }
        // Définir toutes les questions possibles
        const allQuestions = [
            "Do you limit any type of discrimination between employees, in order to ensure equal opportunities and equal treatment, especially for men and women?",
            "Do you have a percentage of incidents of discrimination that have been remedied?",
            "Do you make efforts to recruit people with disabilities?"
        ];
        // Créer un tableau de questions/réponses pour toutes les questions
        const data = allQuestions.map((question)=>{
            const answer = selectedOptions[question] || "No";
            return {
                question: question,
                answer: answer,
                category: "social",
                enterpriseId: enterpriseId,
                userId: userId || "",
                section: "social-1",
                timestamp: new Date().toISOString()
            };
        });
        // Vérifier que les données sont correctement formatées
        const isValidData = data.every((item)=>item.question && item.answer && item.category && item.enterpriseId);
        if (!isValidData) {
            console.error("Donn\xe9es invalides:", data);
            setErrorMessage("Format de donn\xe9es invalide");
            setIsSaving(false);
            return;
        }
        // Sauvegarder les données pour une utilisation ultérieure
        s_allData1 = [
            ...data
        ];
        console.log("Donn\xe9es \xe0\xa0 envoyer:", JSON.stringify(data, null, 2));
        // Appel API pour sauvegarder les données
        fetch("/api/api/save-evaluation", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
            },
            body: JSON.stringify(data)
        }).then((response)=>{
            if (!response.ok) throw new Error(`Erreur de sauvegarde (${response.status})`);
            return response.json();
        }).then((result)=>{
            console.log("Data saved successfully:", result);
            // Sauvegarder le score dans le localStorage
            localStorage.setItem('social1Score', yes_Count1);
            console.log(`Score social1 mis \xe0\xa0 jour: ${yes_Count1}`);
            setIsSaving(false);
            history.push("/social-2_");
        }).catch((error)=>{
            console.error("Error saving data:", error);
            setErrorMessage("Error saving data. Please try again.");
            console.error("D\xe9tails de l'erreur:", error.message);
            setIsSaving(false);
            history.push("/social-2_");
        });
    }
    function calculateProgressPercentage() {
        const totalQuestions = document.getElementsByTagName("section").length;
        if (totalQuestions === 0) return 0;
        return Math.round(yes_Count1 / totalQuestions * 100);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "environmental-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "environmental-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    className: "environmental-title",
                    children: "PLEASE ANSWER THE FOLLOWING QUESTIONS"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "progress-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "progress-bar",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "progress-fill",
                                style: {
                                    width: `${calculateProgressPercentage()}%`
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "progress-text",
                            children: [
                                "Your score: ",
                                yes_Count1,
                                " / ",
                                totalQuestions,
                                " (",
                                calculateProgressPercentage(),
                                "%)"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questions-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you limit any type of discrimination between employees, in order to ensure equal opportunities and equal treatment, especially for men and women?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you limit any type of discrimination between employees, in order to ensure equal opportunities and equal treatment, especially for men and women?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you limit any type of discrimination between employees, in order to ensure equal opportunities and equal treatment, especially for men and women?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you limit any type of discrimination between employees, in order to ensure equal opportunities and equal treatment, especially for men and women?", "No"),
                                            className: `btn-option ${selectedOptions["Do you limit any type of discrimination between employees, in order to ensure equal opportunities and equal treatment, especially for men and women?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have a percentage of incidents of discrimination that have been remedied?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a percentage of incidents of discrimination that have been remedied?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have a percentage of incidents of discrimination that have been remedied?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a percentage of incidents of discrimination that have been remedied?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have a percentage of incidents of discrimination that have been remedied?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you manage your employees' diversity of ages, gender, and nationality?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you manage your employees' diversity of ages, gender, and nationality?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you manage your employees' diversity of ages, gender, and nationality?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you manage your employees' diversity of ages, gender, and nationality?", "No"),
                                            className: `btn-option ${selectedOptions["Do you manage your employees' diversity of ages, gender, and nationality?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "form-actions",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/environmental-5_",
                            className: "btn-secondary",
                            children: "Back"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "btn-primary",
                            children: "Continue to Next Section"
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Social1_;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["Link","b9X5n"],["useHistory","ditZI"]],"../NavItems3":"fOarC","../Frame113":"l7UEw","../Frame114":"aUtEd","../Frame115":"gPV9Y","../Frame116":"70lZ5","../Frame117":"ijwBg","../Toggle":"dSqDu","./Social1_.css":"jIx3s","../../styleguide.css":"8Y7Ec","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jIx3s":[function() {},{}],"8Y7Ec":[function() {},{}],"ahoL9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "s_allData2", ()=>s_allData2);
parcelHelpers.export(exports, "yes_Count2", ()=>yes_Count2);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _social2Css = require("./Social2_.css");
var _styleguideCss = require("../../styleguide.css");
let s_allData2 = [];
let yes_Count2 = 0;
function Social2_(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [yesCount2, setYesCount2] = (0, _react.useState)(0); // Initialize yesCount state
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const [isLoading, setIsLoading] = (0, _react.useState)(false); // Déplacé ici depuis saveData
    const { x1200PxLogo_Icam__20081, navItems3Props, toggle1Props, toggle2Props } = props;
    (0, _react.useEffect)(()=>{
        // Calculate the total number of questions based on sections
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []); // Run this effect only once when the component mounts
    function clicked(question, option) {
        // Si l'option cliquée est la màªme que celle déjà  sélectionnée, on la désélectionne
        if (selectedOptions[question] === option) {
            setSelectedOptions((prevSelectedOptions)=>{
                const newOptions = {
                    ...prevSelectedOptions
                };
                delete newOptions[question];
                return newOptions;
            });
            // Si on désélectionne un "Yes", on décrémente le score
            if (option === "Yes") yes_Count2--;
            return;
        }
        // Sinon, on met à  jour la sélection
        const previousOption = selectedOptions[question];
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        // Si on passe de "No" à  "Yes", on incrémente le score
        if (option === "Yes" && previousOption !== "Yes") yes_Count2++;
        else if (option === "No" && previousOption === "Yes") yes_Count2--;
    }
    const history = (0, _reactRouterDom.useHistory)();
    function saveData() {
        setErrorMessage("");
        setIsLoading(true);
        console.log("D\xe9but de sauvegarde des donn\xe9es Social2");
        const enterpriseId = localStorage.getItem("enterpriseId");
        const userId = localStorage.getItem("userId");
        if (!enterpriseId) {
            console.error("ERREUR: ID d'entreprise manquant");
            setErrorMessage("ID d'entreprise manquant. Veuillez retourner \xe0\xa0 la s\xe9lection d'entreprise.");
            setIsLoading(false);
            return;
        }
        // Définir toutes les questions possibles
        const allQuestions = [
            "Do you promote stability of employment, and therefore of employment contracts?",
            "Do you prefer to hire permanent employees?",
            "Do you have a high employee turnover rate?",
            "Do you have a percentage of incidents related to freedom of association that have been resolved?"
        ];
        // Créer un tableau de questions/réponses pour toutes les questions
        const data = allQuestions.map((question)=>{
            const answer = selectedOptions[question] || "No";
            return {
                question: question,
                answer: answer,
                category: "social",
                enterpriseId: enterpriseId,
                userId: userId || "",
                section: "social-2",
                timestamp: new Date().toISOString()
            };
        });
        // Vérifier que les données sont correctement formatées
        const isValidData = data.every((item)=>item.question && item.answer && item.category && item.enterpriseId);
        if (!isValidData) {
            console.error("Donn\xe9es invalides:", data);
            setErrorMessage("Format de donn\xe9es invalide");
            setIsLoading(false);
            return;
        }
        // Sauvegarder les données pour une utilisation ultérieure
        s_allData2 = [
            ...data
        ];
        console.log("Donn\xe9es \xe0\xa0 envoyer:", JSON.stringify(data, null, 2));
        // Appel API pour sauvegarder les données
        fetch("/api/api/save-evaluation", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
            },
            body: JSON.stringify(data)
        }).then((response)=>{
            if (!response.ok) throw new Error(`Erreur de sauvegarde (${response.status})`);
            return response.json();
        }).then((result)=>{
            console.log("Data saved successfully:", result);
            // Sauvegarder le score dans le localStorage
            localStorage.setItem('social2Score', yes_Count2);
            console.log(`Score social2 mis \xe0\xa0 jour: ${yes_Count2}`);
            setIsLoading(false);
            history.push("/social-3_");
        }).catch((error)=>{
            console.error("Error saving data:", error);
            setErrorMessage("Error saving data. Please try again.");
            console.error("D\xe9tails de l'erreur:", error.message);
            setIsLoading(false);
            history.push("/social-3_");
        });
    }
    function calculateProgressPercentage() {
        const totalQuestions = document.getElementsByTagName("section").length;
        if (totalQuestions === 0) return 0;
        return Math.round(yes_Count2 / totalQuestions * 100);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "environmental-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "environmental-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    className: "environmental-title",
                    children: "PLEASE ANSWER THE FOLLOWING QUESTIONS"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "progress-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "progress-bar",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "progress-fill",
                                style: {
                                    width: `${calculateProgressPercentage()}%`
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "progress-text",
                            children: [
                                "Your score: ",
                                yes_Count2,
                                " / ",
                                totalQuestions,
                                " (",
                                calculateProgressPercentage(),
                                "%)"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questions-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you promote stability of employment, and therefore of employment contracts?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you promote stability of employment, and therefore of employment contracts?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you promote stability of employment, and therefore of employment contracts?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you promote stability of employment, and therefore of employment contracts?", "No"),
                                            className: `btn-option ${selectedOptions["Do you promote stability of employment, and therefore of employment contracts?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you prefer to hire permanent employees?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you prefer to hire permanent employees?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you prefer to hire permanent employees?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you prefer to hire permanent employees?", "No"),
                                            className: `btn-option ${selectedOptions["Do you prefer to hire permanent employees?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have a high employee turnover rate?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a high employee turnover rate?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have a high employee turnover rate?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a high employee turnover rate?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have a high employee turnover rate?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have a percentage of incidents related to freedom of association that have been resolved?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a percentage of incidents related to freedom of association that have been resolved?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have a percentage of incidents related to freedom of association that have been resolved?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a percentage of incidents related to freedom of association that have been resolved?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have a percentage of incidents related to freedom of association that have been resolved?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "form-actions",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/social-1_",
                            className: "btn-secondary",
                            children: "Back"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "btn-primary",
                            children: "Next"
                        })
                    ]
                }),
                isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "loading-indicator",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "spinner"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: "Saving data..."
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Social2_;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["Link","b9X5n"],["useHistory","ditZI"]],"../NavItems3":"fOarC","../NavItems2":"bnQuI","../Toggle":"dSqDu","./Social2_.css":"hnqTE","../../styleguide.css":"8Y7Ec","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hnqTE":[function() {},{}],"8Y7Ec":[function() {},{}],"3xLfp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "s_allData3", ()=>s_allData3);
parcelHelpers.export(exports, "yes_Count3", ()=>yes_Count3);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _social3Css = require("./Social3_.css");
var _styleguideCss = require("../../styleguide.css");
var _social1 = require("../Social1_");
var _social2 = require("../Social2_");
let s_allData3 = [];
let yes_Count3 = 0;
function Social3_(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [yesCount3, setYesCount3] = (0, _react.useState)(0); // Initialize yesCount state
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const [isLoading, setIsLoading] = (0, _react.useState)(false); // Déplacé ici depuis saveData
    const { x1200PxLogo_Icam__20081, navItems3Props, toggle1Props, toggle2Props, toggle3Props } = props;
    (0, _react.useEffect)(()=>{
        // Calculate the total number of questions based on sections
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []); // Run this effect only once when the component mounts
    function clicked(question, option) {
        // Si l'option cliquée est la màªme que celle déjà  sélectionnée, on la désélectionne
        if (selectedOptions[question] === option) {
            setSelectedOptions((prevSelectedOptions)=>{
                const newOptions = {
                    ...prevSelectedOptions
                };
                delete newOptions[question];
                return newOptions;
            });
            // Si on désélectionne un "Yes", on décrémente le score
            if (option === "Yes") yes_Count3--;
            return;
        }
        // Sinon, on met à  jour la sélection
        const previousOption = selectedOptions[question];
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        // Si on passe de "No" à  "Yes", on incrémente le score
        if (option === "Yes" && previousOption !== "Yes") yes_Count3++;
        else if (option === "No" && previousOption === "Yes") yes_Count3--;
    }
    const history = (0, _reactRouterDom.useHistory)();
    function saveData() {
        setErrorMessage("");
        setIsLoading(true);
        console.log("D\xe9but de sauvegarde des donn\xe9es Social3");
        const enterpriseId = localStorage.getItem("enterpriseId");
        const userId = localStorage.getItem("userId");
        if (!enterpriseId) {
            console.error("ERREUR: ID d'entreprise manquant");
            setErrorMessage("ID d'entreprise manquant. Veuillez retourner \xe0\xa0 la s\xe9lection d'entreprise.");
            setIsLoading(false);
            return;
        }
        // Définir toutes les questions possibles
        const allQuestions = [
            "Do you comply with the fundamental principles of the International Labour Organisation?",
            "Have you conducted employee surveys on the collective agreement?",
            "Does the work performed respect the legal framework of the employment contract?",
            "Do you have a policy against child labor in your organization?",
            "Do you have a policy against forced labor in your organization?"
        ];
        // Créer un tableau de questions/réponses pour toutes les questions
        const data = allQuestions.map((question)=>{
            const answer = selectedOptions[question] || "No";
            return {
                question: question,
                answer: answer,
                category: "social",
                enterpriseId: enterpriseId,
                userId: userId || "",
                section: "social-3",
                timestamp: new Date().toISOString()
            };
        });
        // Vérifier que les données sont correctement formatées
        const isValidData = data.every((item)=>item.question && item.answer && item.category && item.enterpriseId);
        if (!isValidData) {
            console.error("Donn\xe9es invalides:", data);
            setErrorMessage("Format de donn\xe9es invalide");
            setIsLoading(false);
            return;
        }
        // Sauvegarder les données pour une utilisation ultérieure
        s_allData3 = [
            ...data
        ];
        console.log("Donn\xe9es \xe0\xa0 envoyer:", JSON.stringify(data, null, 2));
        // Appel API pour sauvegarder les données
        fetch("/api/api/save-evaluation", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
            },
            body: JSON.stringify(data)
        }).then((response)=>{
            if (!response.ok) throw new Error(`Erreur de sauvegarde (${response.status})`);
            return response.json();
        }).then((result)=>{
            console.log("Data saved successfully:", result);
            // Sauvegarder le score dans le localStorage
            localStorage.setItem('social3Score', yes_Count3);
            console.log(`Score social3 mis \xe0\xa0 jour: ${yes_Count3}`);
            setIsLoading(false);
            history.push("/social-4_");
        }).catch((error)=>{
            console.error("Error saving data:", error);
            setErrorMessage("Error saving data. Please try again.");
            console.error("D\xe9tails de l'erreur:", error.message);
            setIsLoading(false);
            history.push("/social-4_");
        });
    }
    function calculateProgressPercentage() {
        const totalQuestions = document.getElementsByTagName("section").length;
        if (totalQuestions === 0) return 0;
        return Math.round(yes_Count3 / totalQuestions * 100);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "environmental-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "environmental-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    className: "environmental-title",
                    children: "PLEASE ANSWER THE FOLLOWING QUESTIONS"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "progress-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "progress-bar",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "progress-fill",
                                style: {
                                    width: `${calculateProgressPercentage()}%`
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "progress-text",
                            children: [
                                "Your score: ",
                                yes_Count3,
                                " / ",
                                totalQuestions,
                                " (",
                                calculateProgressPercentage(),
                                "%)"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questions-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you comply with the fundamental principles of the International Labour Organisation?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you comply with the fundamental principles of the International Labour Organisation?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you comply with the fundamental principles of the International Labour Organisation?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you comply with the fundamental principles of the International Labour Organisation?", "No"),
                                            className: `btn-option ${selectedOptions["Do you comply with the fundamental principles of the International Labour Organisation?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Have you conducted employee surveys on the collective agreement?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Have you conducted employee surveys on the collective agreement?", "Yes"),
                                            className: `btn-option ${selectedOptions["Have you conducted employee surveys on the collective agreement?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Have you conducted employee surveys on the collective agreement?", "No"),
                                            className: `btn-option ${selectedOptions["Have you conducted employee surveys on the collective agreement?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Does the work performed respect the legal framework of the employment contract?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Does the work performed respect the legal framework of the employment contract?", "Yes"),
                                            className: `btn-option ${selectedOptions["Does the work performed respect the legal framework of the employment contract?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Does the work performed respect the legal framework of the employment contract?", "No"),
                                            className: `btn-option ${selectedOptions["Does the work performed respect the legal framework of the employment contract?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have a policy against child labor in your organization?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a policy against child labor in your organization?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have a policy against child labor in your organization?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a policy against child labor in your organization?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have a policy against child labor in your organization?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have a policy against forced labor in your organization?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a policy against forced labor in your organization?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have a policy against forced labor in your organization?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a policy against forced labor in your organization?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have a policy against forced labor in your organization?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "form-actions",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/social-2_",
                            className: "btn-secondary",
                            children: "Back"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "btn-primary",
                            children: "Next"
                        })
                    ]
                }),
                isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "loading-indicator",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "spinner"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: "Saving data..."
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Social3_;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["Link","b9X5n"],["useHistory","ditZI"]],"../NavItems3":"fOarC","../NavItems2":"bnQuI","../Toggle":"dSqDu","./Social3_.css":"5KjPR","../../styleguide.css":"8Y7Ec","../Social1_":"9IXzw","../Social2_":"ahoL9","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5KjPR":[function() {},{}],"8Y7Ec":[function() {},{}],"faPBh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "s_allData4", ()=>s_allData4);
parcelHelpers.export(exports, "yes_Count4", ()=>yes_Count4);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _social4Css = require("./Social4_.css");
var _styleguideCss = require("../../styleguide.css");
var _social1 = require("../Social1_");
var _social2 = require("../Social2_");
var _social3 = require("../Social3_");
let s_allData4 = [];
let yes_Count4 = 0;
function Social4_(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [yesCount4, setYesCount4] = (0, _react.useState)(0); // Initialize yesCount state
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const [isLoading, setIsLoading] = (0, _react.useState)(false); // Déplacé ici depuis saveData
    const { x1200PxLogo_Icam__20081, navItems3Props, toggle1Props, toggle2Props, toggle3Props, toggle4Props } = props;
    (0, _react.useEffect)(()=>{
        // Calculate the total number of questions based on sections
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []); // Run this effect only once when the component mounts
    function clicked(question, option) {
        // Si l'option cliquée est la màªme que celle déjà  sélectionnée, on la désélectionne
        if (selectedOptions[question] === option) {
            setSelectedOptions((prevSelectedOptions)=>{
                const newOptions = {
                    ...prevSelectedOptions
                };
                delete newOptions[question];
                return newOptions;
            });
            // Si on désélectionne un "Yes", on décrémente le score
            if (option === "Yes") yes_Count4--;
            return;
        }
        // Sinon, on met à  jour la sélection
        const previousOption = selectedOptions[question];
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        // Si on passe de "No" à  "Yes", on incrémente le score
        if (option === "Yes" && previousOption !== "Yes") yes_Count4++;
        else if (option === "No" && previousOption === "Yes") yes_Count4--;
    }
    const history = (0, _reactRouterDom.useHistory)();
    function saveData() {
        setErrorMessage("");
        setIsLoading(true);
        console.log("D\xe9but de sauvegarde des donn\xe9es Social4");
        const enterpriseId = localStorage.getItem("enterpriseId");
        const userId = localStorage.getItem("userId");
        if (!enterpriseId) {
            console.error("ERREUR: ID d'entreprise manquant");
            setErrorMessage("ID d'entreprise manquant. Veuillez retourner \xe0\xa0 la s\xe9lection d'entreprise.");
            setIsLoading(false);
            return;
        }
        // Définir toutes les questions possibles
        const allQuestions = [
            "Do you have an occupational health and safety policy?",
            "Do you implement actions to prevent occupational accidents and diseases?",
            "Do you track your workplace accident rate?",
            "Do you track your occupational disease rate?",
            "Do you provide health and safety training to your employees?"
        ];
        // Créer un tableau de questions/réponses pour toutes les questions
        const data = allQuestions.map((question)=>{
            const answer = selectedOptions[question] || "No";
            return {
                question: question,
                answer: answer,
                category: "social",
                enterpriseId: enterpriseId,
                userId: userId || "",
                section: "social-4",
                timestamp: new Date().toISOString()
            };
        });
        // Vérifier que les données sont correctement formatées
        const isValidData = data.every((item)=>item.question && item.answer && item.category && item.enterpriseId);
        if (!isValidData) {
            console.error("Donn\xe9es invalides:", data);
            setErrorMessage("Format de donn\xe9es invalide");
            setIsLoading(false);
            return;
        }
        // Sauvegarder les données pour une utilisation ultérieure
        s_allData4 = [
            ...data
        ];
        console.log("Donn\xe9es \xe0\xa0 envoyer:", JSON.stringify(data, null, 2));
        // Appel API pour sauvegarder les données
        fetch("/api/api/save-evaluation", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
            },
            body: JSON.stringify(data)
        }).then((response)=>{
            if (!response.ok) throw new Error(`Erreur de sauvegarde (${response.status})`);
            return response.json();
        }).then((result)=>{
            console.log("Data saved successfully:", result);
            // Sauvegarder le score dans le localStorage
            localStorage.setItem('social4Score', yes_Count4);
            console.log(`Score social4 mis \xe0\xa0 jour: ${yes_Count4}`);
            setIsLoading(false);
            history.push("/social-5_");
        }).catch((error)=>{
            console.error("Error saving data:", error);
            setErrorMessage("Error saving data. Please try again.");
            console.error("D\xe9tails de l'erreur:", error.message);
            setIsLoading(false);
            history.push("/social-5_");
        });
    }
    function calculateProgressPercentage() {
        const totalQuestions = document.getElementsByTagName("section").length;
        if (totalQuestions === 0) return 0;
        return Math.round(yes_Count4 / totalQuestions * 100);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "environmental-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "environmental-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    className: "environmental-title",
                    children: "PLEASE ANSWER THE FOLLOWING QUESTIONS"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "progress-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "progress-bar",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "progress-fill",
                                style: {
                                    width: `${calculateProgressPercentage()}%`
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "progress-text",
                            children: [
                                "Your score: ",
                                yes_Count4,
                                " / ",
                                totalQuestions,
                                " (",
                                calculateProgressPercentage(),
                                "%)"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questions-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have an occupational health and safety policy?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have an occupational health and safety policy?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have an occupational health and safety policy?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have an occupational health and safety policy?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have an occupational health and safety policy?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you implement actions to prevent occupational accidents and diseases?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you implement actions to prevent occupational accidents and diseases?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you implement actions to prevent occupational accidents and diseases?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you implement actions to prevent occupational accidents and diseases?", "No"),
                                            className: `btn-option ${selectedOptions["Do you implement actions to prevent occupational accidents and diseases?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you track your workplace accident rate?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you track your workplace accident rate?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you track your workplace accident rate?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you track your workplace accident rate?", "No"),
                                            className: `btn-option ${selectedOptions["Do you track your workplace accident rate?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you track your occupational disease rate?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you track your occupational disease rate?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you track your occupational disease rate?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you track your occupational disease rate?", "No"),
                                            className: `btn-option ${selectedOptions["Do you track your occupational disease rate?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you provide health and safety training to your employees?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you provide health and safety training to your employees?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you provide health and safety training to your employees?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you provide health and safety training to your employees?", "No"),
                                            className: `btn-option ${selectedOptions["Do you provide health and safety training to your employees?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "form-actions",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/social-3_",
                            className: "btn-secondary",
                            children: "Back"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "btn-primary",
                            children: "Next"
                        })
                    ]
                }),
                isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "loading-indicator",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "spinner"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: "Saving data..."
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Social4_;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["Link","b9X5n"],["useHistory","ditZI"]],"../NavItems3":"fOarC","../NavItems2":"bnQuI","../Toggle":"dSqDu","./Social4_.css":"kmspp","../../styleguide.css":"8Y7Ec","../Social1_":"9IXzw","../Social2_":"ahoL9","../Social3_":"3xLfp","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kmspp":[function() {},{}],"8Y7Ec":[function() {},{}],"7gq3N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "s_allData5", ()=>s_allData5);
parcelHelpers.export(exports, "yes_Count5", ()=>yes_Count5);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _social5Css = require("./Social5_.css");
var _styleguideCss = require("../../styleguide.css");
var _social1 = require("../Social1_");
var _social2 = require("../Social2_");
var _social3 = require("../Social3_");
var _social4 = require("../Social4_");
let s_allData5 = [];
let yes_Count5 = 0;
function Social5_(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [yesCount5, setYesCount5] = (0, _react.useState)(0); // Initialize yesCount state
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const [isLoading, setIsLoading] = (0, _react.useState)(false); // Déplacé ici depuis saveData
    const { x1200PxLogo_Icam__20081, navItems3Props, toggle1Props, toggle2Props, toggle3Props, toggle4Props } = props;
    (0, _react.useEffect)(()=>{
        // Calculate the total number of questions based on sections
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []); // Run this effect only once when the component mounts
    function clicked(question, option) {
        // Si l'option cliquée est la màªme que celle déjà  sélectionnée, on la désélectionne
        if (selectedOptions[question] === option) {
            setSelectedOptions((prevSelectedOptions)=>{
                const newOptions = {
                    ...prevSelectedOptions
                };
                delete newOptions[question];
                return newOptions;
            });
            // Si on désélectionne un "Yes", on décrémente le score
            if (option === "Yes") yes_Count5--;
            return;
        }
        // Sinon, on met à  jour la sélection
        const previousOption = selectedOptions[question];
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        // Si on passe de "No" à  "Yes", on incrémente le score
        if (option === "Yes" && previousOption !== "Yes") yes_Count5++;
        else if (option === "No" && previousOption === "Yes") yes_Count5--;
    }
    const history = (0, _reactRouterDom.useHistory)();
    function saveData() {
        setErrorMessage("");
        setIsLoading(true);
        console.log("D\xe9but de sauvegarde des donn\xe9es Social5");
        const enterpriseId = localStorage.getItem("enterpriseId");
        const userId = localStorage.getItem("userId");
        if (!enterpriseId) {
            console.error("ERREUR: ID d'entreprise manquant");
            setErrorMessage("ID d'entreprise manquant. Veuillez retourner \xe0\xa0 la s\xe9lection d'entreprise.");
            setIsLoading(false);
            return;
        }
        // Définir toutes les questions possibles
        const allQuestions = [
            "Do you provide employee training opportunities?",
            "Do you have a career development program for your employees?",
            "Do you track employee skills development?",
            "Do you have measures to promote employee well-being?",
            "Do you conduct regular employee satisfaction surveys?"
        ];
        // Créer un tableau de questions/réponses pour toutes les questions
        const data = allQuestions.map((question)=>{
            const answer = selectedOptions[question] || "No";
            return {
                question: question,
                answer: answer,
                category: "social",
                enterpriseId: enterpriseId,
                userId: userId || "",
                section: "social-5",
                timestamp: new Date().toISOString()
            };
        });
        // Vérifier que les données sont correctement formatées
        const isValidData = data.every((item)=>item.question && item.answer && item.category && item.enterpriseId);
        if (!isValidData) {
            console.error("Donn\xe9es invalides:", data);
            setErrorMessage("Format de donn\xe9es invalide");
            setIsLoading(false);
            return;
        }
        // Sauvegarder les données pour une utilisation ultérieure
        s_allData5 = [
            ...data
        ];
        console.log("Donn\xe9es \xe0\xa0 envoyer:", JSON.stringify(data, null, 2));
        // Appel API pour sauvegarder les données
        fetch("/api/api/save-evaluation", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
            },
            body: JSON.stringify(data)
        }).then((response)=>{
            if (!response.ok) throw new Error(`Erreur de sauvegarde (${response.status})`);
            return response.json();
        }).then((result)=>{
            console.log("Data saved successfully:", result);
            // Sauvegarder le score dans le localStorage
            localStorage.setItem('social5Score', yes_Count5);
            console.log(`Score social5 mis \xe0\xa0 jour: ${yes_Count5}`);
            setIsLoading(false);
            history.push("/social-6_");
        }).catch((error)=>{
            console.error("Error saving data:", error);
            setErrorMessage("Error saving data. Please try again.");
            console.error("D\xe9tails de l'erreur:", error.message);
            setIsLoading(false);
            history.push("/social-6_");
        });
    }
    function calculateProgressPercentage() {
        const totalQuestions = document.getElementsByTagName("section").length;
        if (totalQuestions === 0) return 0;
        return Math.round(yes_Count5 / totalQuestions * 100);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "environmental-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "environmental-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    className: "environmental-title",
                    children: "PLEASE ANSWER THE FOLLOWING QUESTIONS"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "progress-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "progress-bar",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "progress-fill",
                                style: {
                                    width: `${calculateProgressPercentage()}%`
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "progress-text",
                            children: [
                                "Your score: ",
                                yes_Count5,
                                " / ",
                                totalQuestions,
                                " (",
                                calculateProgressPercentage(),
                                "%)"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questions-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you provide employee training opportunities?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you provide employee training opportunities?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you provide employee training opportunities?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you provide employee training opportunities?", "No"),
                                            className: `btn-option ${selectedOptions["Do you provide employee training opportunities?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have a career development program for your employees?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a career development program for your employees?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have a career development program for your employees?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a career development program for your employees?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have a career development program for your employees?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you track employee skills development?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you track employee skills development?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you track employee skills development?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you track employee skills development?", "No"),
                                            className: `btn-option ${selectedOptions["Do you track employee skills development?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have measures to promote employee well-being?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have measures to promote employee well-being?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have measures to promote employee well-being?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have measures to promote employee well-being?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have measures to promote employee well-being?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you conduct regular employee satisfaction surveys?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you conduct regular employee satisfaction surveys?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you conduct regular employee satisfaction surveys?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you conduct regular employee satisfaction surveys?", "No"),
                                            className: `btn-option ${selectedOptions["Do you conduct regular employee satisfaction surveys?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "form-actions",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/social-4_",
                            className: "btn-secondary",
                            children: "Back"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "btn-primary",
                            children: "Next"
                        })
                    ]
                }),
                isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "loading-indicator",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "spinner"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: "Saving data..."
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Social5_;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["Link","b9X5n"],["useHistory","ditZI"]],"../NavItems3":"fOarC","../NavItems2":"bnQuI","../Toggle":"dSqDu","./Social5_.css":"fafsP","../../styleguide.css":"8Y7Ec","../Social1_":"9IXzw","../Social2_":"ahoL9","../Social3_":"3xLfp","../Social4_":"faPBh","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fafsP":[function() {},{}],"8Y7Ec":[function() {},{}],"98DT2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "e_sum", ()=>e_sum);
parcelHelpers.export(exports, "yes_Count5", ()=>yes_Count5);
parcelHelpers.export(exports, "e_yesCount5", ()=>e_yesCount5);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _environmental5Css = require("./Environmental5_.css");
var _styleguideCss = require("../../styleguide.css");
var _jspdf = require("jspdf");
var _jspdfDefault = parcelHelpers.interopDefault(_jspdf);
var _environmental1 = require("../Environmental1_");
var _environmental2 = require("../Environmental2_");
var _environmental3 = require("../Environmental3_");
var _environmental4 = require("../Environmental4_");
let e_sum = 0;
let yes_Count5 = 0;
let e_yesCount5 = 0;
function Environmental5_(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [yesCount5, setYesCount5] = (0, _react.useState)(0); // Initialize yesCount state
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const [isLoading, setIsLoading] = (0, _react.useState)(false); // Ajout de l'état isLoading manquant
    const { x1200PxLogo_Icam__20082, socialCriteria, navItems3Props, toggle1Props, toggle2Props, toggle3Props } = props;
    (0, _react.useEffect)(()=>{
        // Calculate the total number of questions based on sections
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []); // Run this effect only once when the component mounts
    //let e_yesCount5 = 0;
    function clicked(question, option) {
        // Si l'option cliquée est la màªme que celle déjà  sélectionnée, on la désélectionne
        if (selectedOptions[question] === option) {
            setSelectedOptions((prevSelectedOptions)=>{
                const newOptions = {
                    ...prevSelectedOptions
                };
                delete newOptions[question];
                return newOptions;
            });
            // Si on désélectionne un "Yes", on décrémente le score
            if (option === "Yes") {
                e_yesCount5--;
                yes_Count5 = e_yesCount5; // Synchroniser les deux variables
            }
            return;
        }
        // Sinon, on met à  jour la sélection
        const previousOption = selectedOptions[question];
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        // Si on passe de "No" à  "Yes", on incrémente le score
        if (option === "Yes" && previousOption !== "Yes") {
            e_yesCount5++;
            yes_Count5 = e_yesCount5; // Synchroniser les deux variables
        } else if (option === "No" && previousOption === "Yes") {
            e_yesCount5--;
            yes_Count5 = e_yesCount5; // Synchroniser les deux variables
        }
    }
    const history = (0, _reactRouterDom.useHistory)();
    let e_allData5 = [];
    function saveData() {
        setIsLoading(true);
        setErrorMessage("");
        console.log("D\xe9but de sauvegarde des donn\xe9es Environmental5");
        const enterpriseId = localStorage.getItem("enterpriseId");
        const userId = localStorage.getItem("userId");
        if (!enterpriseId) {
            console.error("ERREUR: ID d'entreprise manquant");
            setErrorMessage("ID d'entreprise manquant. Veuillez retourner \xe0\xa0 la s\xe9lection d'entreprise.");
            setIsLoading(false);
            return;
        }
        // Définir toutes les questions possibles pour Environmental5
        const allQuestions = [
            "Are you implementing environmental management tools?",
            "Do you have environmental certifications?",
            "Have you had environmental non-compliance issues in the past 3 years?",
            "Have you communicated with your community about potential negative impacts of your activities?",
            "Do you communicate about environmental issues with your suppliers?"
        ];
        // Créer un tableau de questions/réponses pour toutes les questions
        const data = allQuestions.map((question)=>{
            const answer = selectedOptions[question] || "No";
            return {
                question: question,
                answer: answer,
                category: "environmental",
                enterpriseId: enterpriseId,
                userId: userId || "",
                section: "environmental-5",
                timestamp: new Date().toISOString()
            };
        });
        // Vérifier que les données sont correctement formatées
        const isValidData = data.every((item)=>item.question && item.answer && item.category && item.enterpriseId);
        if (!isValidData) {
            console.error("Donn\xe9es invalides:", data);
            setErrorMessage("Format de donn\xe9es invalide");
            setIsLoading(false);
            return;
        }
        e_allData5 = [
            ...data
        ]; // Sauvegarder les données pour le PDF
        console.log("Donn\xe9es \xe0\xa0 envoyer:", JSON.stringify(data, null, 2));
        // Appel API pour sauvegarder les données
        fetch("/api/api/save-evaluation", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
            },
            body: JSON.stringify(data)
        }).then((response)=>{
            if (!response.ok) throw new Error(`Erreur de sauvegarde (${response.status})`);
            return response.json();
        }).then((result)=>{
            console.log("Data saved successfully:", result);
            // Calculer le score total environnemental
            e_sum = (0, _environmental1.yes_Count1) + (0, _environmental2.yes_Count2) + (0, _environmental3.yes_Count3) + (0, _environmental4.yes_Count4) + yes_Count5;
            console.log("Score total environnemental calcul\xe9:", e_sum);
            // Sauvegarder le score dans le localStorage
            localStorage.setItem('environmental5Score', yes_Count5);
            console.log(`Score environmental5 mis \xe0\xa0 jour: ${yes_Count5}`);
            // Sauvegarder le score total environnemental
            const scoreData = [
                {
                    question: "Environmental Total Score",
                    answer: e_sum.toString(),
                    category: "environmental",
                    enterpriseId: enterpriseId,
                    userId: userId || "",
                    section: "environmental-total",
                    timestamp: new Date().toISOString()
                }
            ];
            console.log("Envoi du score total:", JSON.stringify(scoreData, null, 2));
            // Appel API pour sauvegarder le score total
            return fetch("/api/api/save-evaluation", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
                },
                body: JSON.stringify(scoreData)
            });
        }).then((response)=>{
            if (!response || !response.ok) throw new Error("Failed to save total score");
            return response.json();
        }).then((scoreResponse)=>{
            console.log("Score total enregistr\xe9 avec succ\xe8s:", scoreResponse);
            // Récupérer correctement les données de tous les composants
            const allEnvironmentalData = [];
            // Utiliser des try/catch pour éviter les erreurs si certaines données sont manquantes
            try {
                if (Array.isArray((0, _environmental1.e_allData1)) && (0, _environmental1.e_allData1).length > 0) allEnvironmentalData.push(...(0, _environmental1.e_allData1));
                if (Array.isArray((0, _environmental2.e_allData2)) && (0, _environmental2.e_allData2).length > 0) allEnvironmentalData.push(...(0, _environmental2.e_allData2));
                if (Array.isArray((0, _environmental3.e_allData3)) && (0, _environmental3.e_allData3).length > 0) allEnvironmentalData.push(...(0, _environmental3.e_allData3));
                if (Array.isArray((0, _environmental4.e_allData4)) && (0, _environmental4.e_allData4).length > 0) allEnvironmentalData.push(...(0, _environmental4.e_allData4));
                if (Array.isArray(e_allData5) && e_allData5.length > 0) allEnvironmentalData.push(...e_allData5);
            } catch (error) {
                console.error("Erreur lors de la concat\xe9nation des donn\xe9es:", error);
            }
            console.log("Toutes les donn\xe9es environnementales pour le PDF:", allEnvironmentalData.length, "questions");
            // Générer le PDF avec toutes les données environnementales
            generatePdf(allEnvironmentalData);
            // Redirection vers la page suivante après sauvegarde réussie
            setIsLoading(false);
            history.push("/social-1_");
        }).catch((error)=>{
            console.error("Error saving data:", error);
            setErrorMessage("Error saving data. Please try again.");
            console.error("D\xe9tails de l'erreur:", error.message);
            // Màªme en cas d'erreur, essayer de générer le PDF avec les données disponibles
            const allEnvironmentalData = [];
            try {
                if (Array.isArray((0, _environmental1.e_allData1)) && (0, _environmental1.e_allData1).length > 0) allEnvironmentalData.push(...(0, _environmental1.e_allData1));
                if (Array.isArray((0, _environmental2.e_allData2)) && (0, _environmental2.e_allData2).length > 0) allEnvironmentalData.push(...(0, _environmental2.e_allData2));
                if (Array.isArray((0, _environmental3.e_allData3)) && (0, _environmental3.e_allData3).length > 0) allEnvironmentalData.push(...(0, _environmental3.e_allData3));
                if (Array.isArray((0, _environmental4.e_allData4)) && (0, _environmental4.e_allData4).length > 0) allEnvironmentalData.push(...(0, _environmental4.e_allData4));
                if (Array.isArray(e_allData5) && e_allData5.length > 0) allEnvironmentalData.push(...e_allData5);
            } catch (error) {
                console.error("Erreur lors de la concat\xe9nation des donn\xe9es:", error);
            }
            generatePdf(allEnvironmentalData);
            // Redirection malgré l'erreur
            setIsLoading(false);
            history.push("/social-1_");
        });
    }
    function generatePdf(e_allData) {
        // Vérifier si des données existent
        if (!e_allData || e_allData.length === 0) {
            console.error("Aucune donn\xe9e disponible pour g\xe9n\xe9rer le PDF");
            return;
        }
        console.log("G\xe9n\xe9ration du PDF avec", e_allData.length, "questions");
        // Créer un nouveau document PDF
        const doc = new (0, _jspdfDefault.default)();
        const lineHeight = 10;
        const pageHeight = doc.internal.pageSize.height - 20;
        const pageWidth = doc.internal.pageSize.width - 20;
        let y = 20;
        // Ajouter un titre
        doc.setFontSize(16);
        doc.text("Environmental Assessment Results", 105, y, {
            align: "center"
        });
        y += 15;
        // Ajouter le score total
        doc.setFontSize(14);
        doc.text(`Total Score: ${e_sum} / ${e_allData.length}`, 105, y, {
            align: "center"
        });
        y += 15;
        doc.setFontSize(12);
        // Parcourir les données dans e_allData et ajouter chaque question et réponse au document PDF
        e_allData.forEach((data, index)=>{
            // Vérifier si les données sont valides
            if (!data || !data.question) {
                console.error("Donn\xe9es invalides pour l'\xe9l\xe9ment", index);
                return;
            }
            const question = `Question ${index + 1}: ${data.question}`;
            const answer = `Answer: ${data.answer || 'No answer'}`;
            // Estimer la hauteur du texte après division pour mieux gérer les sauts de page
            const splitQuestion = doc.splitTextToSize(question, pageWidth);
            const estimatedHeight = splitQuestion.length * lineHeight + lineHeight * 2;
            // Vérifier si la position y actuelle plus la hauteur de la question dépasse la hauteur maximale de la page
            if (y + estimatedHeight > pageHeight) {
                // Ajouter une nouvelle page et réinitialiser la position y
                doc.addPage();
                y = 20;
            }
            // à‰crire la question et la réponse dans le PDF
            doc.text(splitQuestion, 10, y);
            y += splitQuestion.length * lineHeight;
            doc.text(answer, 10, y);
            y += lineHeight * 2; // Ajouter un peu d'espace entre les questions
        });
        // Ajouter une page de résumé
        doc.addPage();
        y = 20;
        doc.setFontSize(16);
        doc.text("Summary of Environmental Assessment", 105, y, {
            align: "center"
        });
        y += 20;
        doc.setFontSize(12);
        doc.text(`Total number of questions: ${e_allData.length}`, 10, y);
        y += lineHeight;
        doc.text(`Total "Yes" answers: ${e_sum}`, 10, y);
        y += lineHeight;
        doc.text(`Score percentage: ${Math.round(e_sum / e_allData.length * 100)}%`, 10, y);
        y += lineHeight * 2;
        const date = new Date();
        doc.text(`Generated on: ${date.toLocaleDateString()} at ${date.toLocaleTimeString()}`, 10, y);
        // Enregistrer le document PDF
        doc.save("Environmental_Assessment_Complete.pdf");
        console.log("PDF environnemental g\xe9n\xe9r\xe9 avec succ\xe8s");
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "environmental-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "environmental-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    className: "environmental-title",
                    children: "PLEASE ANSWER THE FOLLOWING QUESTIONS"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "progress-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "progress-bar",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "progress-fill",
                                style: {
                                    width: `${Object.keys(selectedOptions).length / totalQuestions * 100}%`
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "progress-text",
                            children: [
                                "Your score: ",
                                yes_Count5,
                                " / ",
                                totalQuestions,
                                " (",
                                Math.round(yes_Count5 / totalQuestions * 100) || 0,
                                "%)"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questions-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Are you implementing environmental management tools?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Are you implementing environmental management tools?", "Yes"),
                                            className: `btn-option ${selectedOptions["Are you implementing environmental management tools?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Are you implementing environmental management tools?", "No"),
                                            className: `btn-option ${selectedOptions["Are you implementing environmental management tools?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have environmental certifications?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have environmental certifications?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have environmental certifications?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have environmental certifications?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have environmental certifications?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Have you had environmental non-compliance issues in the past 3 years?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Have you had environmental non-compliance issues in the past 3 years?", "Yes"),
                                            className: `btn-option ${selectedOptions["Have you had environmental non-compliance issues in the past 3 years?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Have you had environmental non-compliance issues in the past 3 years?", "No"),
                                            className: `btn-option ${selectedOptions["Have you had environmental non-compliance issues in the past 3 years?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Have you communicated with your community about potential negative impacts of your activities?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Have you communicated with your community about potential negative impacts of your activities?", "Yes"),
                                            className: `btn-option ${selectedOptions["Have you communicated with your community about potential negative impacts of your activities?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Have you communicated with your community about potential negative impacts of your activities?", "No"),
                                            className: `btn-option ${selectedOptions["Have you communicated with your community about potential negative impacts of your activities?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you communicate about environmental issues with your suppliers?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you communicate about environmental issues with your suppliers?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you communicate about environmental issues with your suppliers?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you communicate about environmental issues with your suppliers?", "No"),
                                            className: `btn-option ${selectedOptions["Do you communicate about environmental issues with your suppliers?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "form-actions",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/environmental-4_",
                            className: "btn-secondary",
                            children: "Back"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "btn-primary",
                            children: "Submit Environmental Assessment"
                        })
                    ]
                }),
                isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "loading-indicator",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "spinner"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: "Enregistrement des donn\xe9es en cours..."
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Environmental5_;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["Link","b9X5n"],["useHistory","ditZI"]],"../NavItems3":"fOarC","../NavItems2":"bnQuI","../Toggle":"dSqDu","./Environmental5_.css":"lNurc","../../styleguide.css":"8Y7Ec","jspdf":"hkJ4Q","../Environmental1_":"8ypM1","../Environmental2_":"4pDoS","../Environmental3_":"dhZsW","../Environmental4_":"gyJLd","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lNurc":[function() {},{}],"8Y7Ec":[function() {},{}],"4pDoS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "e_allData2", ()=>e_allData2);
parcelHelpers.export(exports, "yes_Count2", ()=>yes_Count2);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _environmental2Css = require("./Environmental2_.css");
var _styleguideCss = require("../../styleguide.css");
let e_allData2 = [];
let yes_Count2 = 0;
function Environmental2_(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [yesCount2, setYesCount2] = (0, _react.useState)(0); // Initialize yesCount state
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const [isLoading, setIsLoading] = (0, _react.useState)(false); // Ajout de l'état isLoading
    const { navItems3Props, toggle1Props, toggle2Props, toggle3Props } = props;
    (0, _react.useEffect)(()=>{
        // Calculate the total number of questions based on sections
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []); // Run this effect only once when the component mounts
    function clicked(question, option) {
        // Si l'option cliquée est la màªme que celle déjà  sélectionnée, on la désélectionne
        if (selectedOptions[question] === option) {
            setSelectedOptions((prevSelectedOptions)=>{
                const newOptions = {
                    ...prevSelectedOptions
                };
                delete newOptions[question];
                return newOptions;
            });
            // Si on désélectionne un "Yes", on décrémente le score
            if (option === "Yes") yes_Count2--;
            return;
        }
        // Sinon, on met à  jour la sélection
        const previousOption = selectedOptions[question];
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        // Si on passe de "No" à  "Yes", on incrémente le score
        if (option === "Yes" && previousOption !== "Yes") yes_Count2++;
        else if (option === "No" && previousOption === "Yes") yes_Count2--;
    }
    const history = (0, _reactRouterDom.useHistory)();
    function saveData() {
        setIsLoading(true);
        setErrorMessage("");
        console.log("D\xe9but de sauvegarde des donn\xe9es Environmental2");
        const enterpriseId = localStorage.getItem("enterpriseId");
        const userId = localStorage.getItem("userId");
        if (!enterpriseId) {
            console.error("ERREUR: ID d'entreprise manquant");
            setErrorMessage("ID d'entreprise manquant. Veuillez retourner \xe0\xa0 la s\xe9lection d'entreprise.");
            setIsLoading(false);
            return;
        }
        // Définir toutes les questions possibles
        const allQuestions = [
            "Do you control and limit liquid pollutant emissions into water and soil related to your activities?",
            "Do you monitor your water consumption volume?",
            "Have you invested in water recovery and treatment technologies?",
            "Do you control and limit air emissions related to your activities?",
            "Do you monitor non-renewable energy consumption related to your activities?"
        ];
        // Créer un tableau de questions/réponses pour toutes les questions
        const data = allQuestions.map((question)=>{
            const answer = selectedOptions[question] || "No";
            return {
                question: question,
                answer: answer,
                category: "environmental",
                enterpriseId: enterpriseId,
                userId: userId || "",
                section: "environmental-2",
                timestamp: new Date().toISOString()
            };
        });
        // Vérifier que les données sont correctement formatées
        const isValidData = data.every((item)=>item.question && item.answer && item.category && item.enterpriseId);
        if (!isValidData) {
            console.error("Donn\xe9es invalides:", data);
            setErrorMessage("Format de donn\xe9es invalide");
            setIsLoading(false);
            return;
        }
        console.log("Donn\xe9es \xe0\xa0 envoyer:", JSON.stringify(data, null, 2));
        // Appel API pour sauvegarder les données
        fetch("/api/api/save-evaluation", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
            },
            body: JSON.stringify(data)
        }).then((response)=>{
            if (!response.ok) throw new Error(`Erreur de sauvegarde (${response.status})`);
            return response.json();
        }).then((result)=>{
            console.log("Data saved successfully:", result);
            // Sauvegarder le score dans le localStorage
            localStorage.setItem('environmental2Score', yes_Count2);
            console.log(`Score environmental2 mis \xe0\xa0 jour: ${yes_Count2}`);
            setIsLoading(false);
            history.push("/environmental-3_");
        }).catch((error)=>{
            console.error("Error saving data:", error);
            setErrorMessage("Error saving data. Please try again.");
            console.error("D\xe9tails de l'erreur:", error.message);
            setIsLoading(false);
            history.push("/environmental-3_");
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "environmental-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "environmental-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    className: "environmental-title",
                    children: "PLEASE ANSWER THE FOLLOWING QUESTIONS"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "progress-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "progress-bar",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "progress-fill",
                                style: {
                                    width: `${Object.keys(selectedOptions).length / totalQuestions * 100}%`
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "progress-text",
                            children: [
                                "Your score: ",
                                yes_Count2,
                                " / ",
                                totalQuestions,
                                " (",
                                Math.round(yes_Count2 / totalQuestions * 100) || 0,
                                "%)"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questions-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you control and limit liquid pollutant emissions into water and soil related to your activities?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you control and limit liquid pollutant emissions into water and soil related to your activities?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you control and limit liquid pollutant emissions into water and soil related to your activities?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you control and limit liquid pollutant emissions into water and soil related to your activities?", "No"),
                                            className: `btn-option ${selectedOptions["Do you control and limit liquid pollutant emissions into water and soil related to your activities?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you monitor your water consumption volume?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you monitor your water consumption volume?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you monitor your water consumption volume?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you monitor your water consumption volume?", "No"),
                                            className: `btn-option ${selectedOptions["Do you monitor your water consumption volume?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Have you invested in water recovery and treatment technologies?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Have you invested in water recovery and treatment technologies?", "Yes"),
                                            className: `btn-option ${selectedOptions["Have you invested in water recovery and treatment technologies?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Have you invested in water recovery and treatment technologies?", "No"),
                                            className: `btn-option ${selectedOptions["Have you invested in water recovery and treatment technologies?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you control and limit air emissions related to your activities?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you control and limit air emissions related to your activities?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you control and limit air emissions related to your activities?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you control and limit air emissions related to your activities?", "No"),
                                            className: `btn-option ${selectedOptions["Do you control and limit air emissions related to your activities?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you monitor non-renewable energy consumption related to your activities?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you monitor non-renewable energy consumption related to your activities?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you monitor non-renewable energy consumption related to your activities?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you monitor non-renewable energy consumption related to your activities?", "No"),
                                            className: `btn-option ${selectedOptions["Do you monitor non-renewable energy consumption related to your activities?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "form-actions",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/environmental-1_",
                            className: "btn-secondary",
                            children: "Back"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "btn-primary",
                            children: "Continue to Next Section"
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Environmental2_;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["Link","b9X5n"],["useHistory","ditZI"]],"../NavItems3":"fOarC","../NavItems2":"bnQuI","../Toggle":"dSqDu","./Environmental2_.css":"dIr9E","../../styleguide.css":"8Y7Ec","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dIr9E":[function() {},{}],"8Y7Ec":[function() {},{}],"dhZsW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "e_allData3", ()=>e_allData3);
parcelHelpers.export(exports, "yes_Count3", ()=>yes_Count3);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _ouinon = require("../Ouinon");
var _ouinonDefault = parcelHelpers.interopDefault(_ouinon);
var _frame11732 = require("../Frame11732");
var _frame11732Default = parcelHelpers.interopDefault(_frame11732);
var _environmental3Css = require("./Environmental3_.css");
var _styleguideCss = require("../../styleguide.css");
let e_allData3 = [];
let yes_Count3 = 0;
function Environmental3_(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [yesCount3, setYesCount3] = (0, _react.useState)(0); // Initialize yesCount state
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const [isLoading, setIsLoading] = (0, _react.useState)(false); // Ajout de l'état isLoading
    const { x1200PxLogo_Icam__20081, navItems3Props, toggle1Props, toggle2Props, toggle3Props } = props;
    (0, _react.useEffect)(()=>{
        // Calculate the total number of questions based on sections
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []); // Run this effect only once when the component mounts
    function clicked(question, option) {
        // Si l'option cliquée est la màªme que celle déjà  sélectionnée, on la désélectionne
        if (selectedOptions[question] === option) {
            setSelectedOptions((prevSelectedOptions)=>{
                const newOptions = {
                    ...prevSelectedOptions
                };
                delete newOptions[question];
                return newOptions;
            });
            // Si on désélectionne un "Yes", on décrémente le score
            if (option === "Yes") yes_Count3--;
            return;
        }
        // Sinon, on met à  jour la sélection
        const previousOption = selectedOptions[question];
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        // Si on passe de "No" à  "Yes", on incrémente le score
        if (option === "Yes" && previousOption !== "Yes") yes_Count3++;
        else if (option === "No" && previousOption === "Yes") yes_Count3--;
    }
    const history = (0, _reactRouterDom.useHistory)();
    function saveData() {
        setIsLoading(true);
        setErrorMessage("");
        console.log("D\xe9but de sauvegarde des donn\xe9es Environmental3");
        const enterpriseId = localStorage.getItem("enterpriseId");
        const userId = localStorage.getItem("userId");
        if (!enterpriseId) {
            console.error("ERREUR: ID d'entreprise manquant");
            setErrorMessage("ID d'entreprise manquant. Veuillez retourner \xe0\xa0 la s\xe9lection d'entreprise.");
            setIsLoading(false);
            return;
        }
        // Définir toutes les questions possibles
        const allQuestions = [
            "Do you control and limit your energy consumption?",
            "Do you measure your energy consumption?",
            "Have you taken measures to reduce your energy consumption?",
            "Do you have sites located in or near protected areas?",
            "Do you have sites located in Natura 2000 areas?",
            "Do you favor buying from local suppliers to reduce transportation?"
        ];
        // Créer un tableau de questions/réponses pour toutes les questions
        const data = allQuestions.map((question)=>{
            const answer = selectedOptions[question] || "No";
            return {
                question: question,
                answer: answer,
                category: "environmental",
                enterpriseId: enterpriseId,
                userId: userId || "",
                section: "environmental-3",
                timestamp: new Date().toISOString()
            };
        });
        // Vérifier que les données sont correctement formatées
        const isValidData = data.every((item)=>item.question && item.answer && item.category && item.enterpriseId);
        if (!isValidData) {
            console.error("Donn\xe9es invalides:", data);
            setErrorMessage("Format de donn\xe9es invalide");
            setIsLoading(false);
            return;
        }
        console.log("Donn\xe9es \xe0\xa0 envoyer:", JSON.stringify(data, null, 2));
        // Appel API pour sauvegarder les données
        fetch("/api/api/save-evaluation", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
            },
            body: JSON.stringify(data)
        }).then((response)=>{
            if (!response.ok) throw new Error(`Erreur de sauvegarde (${response.status})`);
            return response.json();
        }).then((result)=>{
            console.log("Data saved successfully:", result);
            // Sauvegarder le score dans le localStorage
            localStorage.setItem('environmental3Score', yes_Count3);
            console.log(`Score environmental3 mis \xe0\xa0 jour: ${yes_Count3}`);
            setIsLoading(false);
            history.push("/environmental-4_");
        }).catch((error)=>{
            console.error("Error saving data:", error);
            setErrorMessage("Error saving data. Please try again.");
            console.error("D\xe9tails de l'erreur:", error.message);
            setIsLoading(false);
            history.push("/environmental-4_");
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "environmental-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "environmental-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    className: "environmental-title",
                    children: "PLEASE ANSWER THE FOLLOWING QUESTIONS"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "progress-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "progress-bar",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "progress-fill",
                                style: {
                                    width: `${Object.keys(selectedOptions).length / totalQuestions * 100}%`
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "progress-text",
                            children: [
                                "Your score: ",
                                yes_Count3,
                                " / ",
                                totalQuestions,
                                " (",
                                Math.round(yes_Count3 / totalQuestions * 100) || 0,
                                "%)"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questions-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you control and limit your energy consumption?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you control and limit your energy consumption?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you control and limit your energy consumption?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you control and limit your energy consumption?", "No"),
                                            className: `btn-option ${selectedOptions["Do you control and limit your energy consumption?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you measure your energy consumption?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you measure your energy consumption?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you measure your energy consumption?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you measure your energy consumption?", "No"),
                                            className: `btn-option ${selectedOptions["Do you measure your energy consumption?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Have you taken measures to reduce your energy consumption?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Have you taken measures to reduce your energy consumption?", "Yes"),
                                            className: `btn-option ${selectedOptions["Have you taken measures to reduce your energy consumption?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Have you taken measures to reduce your energy consumption?", "No"),
                                            className: `btn-option ${selectedOptions["Have you taken measures to reduce your energy consumption?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have sites located in or near protected areas?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have sites located in or near protected areas?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have sites located in or near protected areas?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have sites located in or near protected areas?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have sites located in or near protected areas?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have sites located in Natura 2000 areas?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have sites located in Natura 2000 areas?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have sites located in Natura 2000 areas?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have sites located in Natura 2000 areas?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have sites located in Natura 2000 areas?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you favor buying from local suppliers to reduce transportation?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you favor buying from local suppliers to reduce transportation?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you favor buying from local suppliers to reduce transportation?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you favor buying from local suppliers to reduce transportation?", "No"),
                                            className: `btn-option ${selectedOptions["Do you favor buying from local suppliers to reduce transportation?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "form-actions",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/environmental-2_",
                            className: "btn-secondary",
                            children: "Back"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "btn-primary",
                            children: "Continue to Next Section"
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Environmental3_;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["Link","b9X5n"],["useHistory","ditZI"]],"../NavItems3":"fOarC","../NavItems2":"bnQuI","../Toggle":"dSqDu","../Ouinon":"ln8KR","../Frame11732":"gSRJf","./Environmental3_.css":"cyrB8","../../styleguide.css":"8Y7Ec","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cyrB8":[function() {},{}],"8Y7Ec":[function() {},{}],"gyJLd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "e_allData4", ()=>e_allData4);
parcelHelpers.export(exports, "yes_Count4", ()=>yes_Count4);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _ouinon2 = require("../Ouinon2");
var _ouinon2Default = parcelHelpers.interopDefault(_ouinon2);
var _ouinon = require("../Ouinon");
var _ouinonDefault = parcelHelpers.interopDefault(_ouinon);
var _frame11732 = require("../Frame11732");
var _frame11732Default = parcelHelpers.interopDefault(_frame11732);
var _environmental4Css = require("./Environmental4_.css");
var _styleguideCss = require("../../styleguide.css");
let e_allData4 = [];
let yes_Count4 = 0;
function Environmental4_(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [yesCount4, setYesCount4] = (0, _react.useState)(0); // Initialize yesCount state
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const [isLoading, setIsLoading] = (0, _react.useState)(false); // Ajout de l'état isLoading
    const { x1200PxLogo_Icam__20082, inputType1, inputPlaceholder1, inputType2, inputPlaceholder2, inputType3, inputPlaceholder3, inputType4, inputPlaceholder4, inputType5, inputPlaceholder5, inputType6, inputPlaceholder6, inputType7, inputPlaceholder7, navItems3Props, toggle1Props, ouinon21Props, ouinon22Props, toggle2Props, ouinon23Props, ouinon24Props, toggle3Props, ouinon1Props, ouinon2Props, ouinon3Props, toggle4Props } = props;
    (0, _react.useEffect)(()=>{
        // Calculate the total number of questions based on sections
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []); // Run this effect only once when the component mounts
    function clicked(question, option) {
        // Si l'option cliquée est la màªme que celle déjà  sélectionnée, on la désélectionne
        if (selectedOptions[question] === option) {
            setSelectedOptions((prevSelectedOptions)=>{
                const newOptions = {
                    ...prevSelectedOptions
                };
                delete newOptions[question];
                return newOptions;
            });
            // Si on désélectionne un "Yes", on décrémente le score
            if (option === "Yes") yes_Count4--;
            return;
        }
        // Sinon, on met à  jour la sélection
        const previousOption = selectedOptions[question];
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        // Si on passe de "No" à  "Yes", on incrémente le score
        if (option === "Yes" && previousOption !== "Yes") yes_Count4++;
        else if (option === "No" && previousOption === "Yes") yes_Count4--;
    }
    const history = (0, _reactRouterDom.useHistory)();
    function saveData() {
        setIsLoading(true);
        setErrorMessage("");
        console.log("D\xe9but de sauvegarde des donn\xe9es Environmental4");
        const enterpriseId = localStorage.getItem("enterpriseId");
        const userId = localStorage.getItem("userId");
        if (!enterpriseId) {
            console.error("ERREUR: ID d'entreprise manquant");
            setErrorMessage("ID d'entreprise manquant. Veuillez retourner \xe0\xa0 la s\xe9lection d'entreprise.");
            setIsLoading(false);
            return;
        }
        // Définir toutes les questions possibles
        const allQuestions = [
            "Do you try to reduce waste at the source?",
            "Do you import, export, or transport hazardous waste?",
            "Do you promote waste recycling?",
            "What percentage of your waste do you recycle out of your total waste?",
            "Do you promote the reuse of waste?",
            "Do you sell your recoverable waste?",
            "Do you have partners who collect your waste for reuse?"
        ];
        // Créer un tableau de questions/réponses pour toutes les questions
        const data = allQuestions.map((question)=>{
            const answer = selectedOptions[question] || "No";
            return {
                question: question,
                answer: answer,
                category: "environmental",
                enterpriseId: enterpriseId,
                userId: userId || "",
                section: "environmental-4",
                timestamp: new Date().toISOString()
            };
        });
        // Vérifier que les données sont correctement formatées
        const isValidData = data.every((item)=>item.question && item.answer && item.category && item.enterpriseId);
        if (!isValidData) {
            console.error("Donn\xe9es invalides:", data);
            setErrorMessage("Format de donn\xe9es invalide");
            setIsLoading(false);
            return;
        }
        console.log("Donn\xe9es \xe0\xa0 envoyer:", JSON.stringify(data, null, 2));
        // Appel API pour sauvegarder les données
        fetch("/api/api/save-evaluation", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
            },
            body: JSON.stringify(data)
        }).then((response)=>{
            if (!response.ok) throw new Error(`Erreur de sauvegarde (${response.status})`);
            return response.json();
        }).then((result)=>{
            console.log("Data saved successfully:", result);
            // Sauvegarder le score dans le localStorage
            localStorage.setItem('environmental4Score', yes_Count4);
            console.log(`Score environmental4 mis \xe0\xa0 jour: ${yes_Count4}`);
            setIsLoading(false);
            history.push("/environmental-5_");
        }).catch((error)=>{
            console.error("Error saving data:", error);
            setErrorMessage("Error saving data. Please try again.");
            console.error("D\xe9tails de l'erreur:", error.message);
            setIsLoading(false);
            history.push("/environmental-5_");
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "environmental-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "environmental-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    className: "environmental-title",
                    children: "PLEASE ANSWER THE FOLLOWING QUESTIONS"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "progress-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "progress-bar",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "progress-fill",
                                style: {
                                    width: `${Object.keys(selectedOptions).length / totalQuestions * 100}%`
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "progress-text",
                            children: [
                                "Your score: ",
                                yes_Count4,
                                " / ",
                                totalQuestions,
                                " (",
                                Math.round(yes_Count4 / totalQuestions * 100) || 0,
                                "%)"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questions-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you try to reduce waste at the source?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you try to reduce waste at the source?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you try to reduce waste at the source?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you try to reduce waste at the source?", "No"),
                                            className: `btn-option ${selectedOptions["Do you try to reduce waste at the source?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you import, export, or transport hazardous waste?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you import, export, or transport hazardous waste?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you import, export, or transport hazardous waste?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you import, export, or transport hazardous waste?", "No"),
                                            className: `btn-option ${selectedOptions["Do you import, export, or transport hazardous waste?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you promote waste recycling?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you promote waste recycling?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you promote waste recycling?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you promote waste recycling?", "No"),
                                            className: `btn-option ${selectedOptions["Do you promote waste recycling?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "What percentage of your waste do you recycle out of your total waste?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("What percentage of your waste do you recycle out of your total waste?", "Yes"),
                                            className: `btn-option ${selectedOptions["What percentage of your waste do you recycle out of your total waste?"] === "Yes" ? "enabled" : ""}`,
                                            children: "More than 50%"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("What percentage of your waste do you recycle out of your total waste?", "No"),
                                            className: `btn-option ${selectedOptions["What percentage of your waste do you recycle out of your total waste?"] === "No" ? "enabled" : ""}`,
                                            children: "Less than 50%"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you promote the reuse of waste?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you promote the reuse of waste?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you promote the reuse of waste?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you promote the reuse of waste?", "No"),
                                            className: `btn-option ${selectedOptions["Do you promote the reuse of waste?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you sell your recoverable waste?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you sell your recoverable waste?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you sell your recoverable waste?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you sell your recoverable waste?", "No"),
                                            className: `btn-option ${selectedOptions["Do you sell your recoverable waste?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have partners who collect your waste for reuse?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have partners who collect your waste for reuse?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have partners who collect your waste for reuse?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have partners who collect your waste for reuse?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have partners who collect your waste for reuse?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "form-actions",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/environmental-3_",
                            className: "btn-secondary",
                            children: "Back"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "btn-primary",
                            children: "Continue to Next Section"
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Environmental4_;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["Link","b9X5n"],["useHistory","ditZI"]],"../NavItems3":"fOarC","../NavItems2":"bnQuI","../Toggle":"dSqDu","../Ouinon2":"7gKpJ","../Ouinon":"ln8KR","../Frame11732":"gSRJf","./Environmental4_.css":"UHFoR","../../styleguide.css":"8Y7Ec","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"UHFoR":[function() {},{}],"8Y7Ec":[function() {},{}],"hsKo8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "m_sum", ()=>m_sum);
parcelHelpers.export(exports, "m_yesCount4", ()=>m_yesCount4);
parcelHelpers.export(exports, "m_allData4", ()=>m_allData4);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _modernization4Css = require("./Modernization4_.css");
var _styleguideCss = require("../../styleguide.css");
var _jspdf = require("jspdf");
var _jspdfDefault = parcelHelpers.interopDefault(_jspdf);
var _modernization1 = require("../Modernization1_");
var _modernization2 = require("../Modernization2_");
var _modernization3 = require("../Modernization3_");
let m_sum = 0;
let m_yesCount4 = 0;
let m_allData4 = [];
function Modernization4_(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const { x1200PxLogo_Icam__20081, navItems2Props, navItems3Props } = props;
    (0, _react.useEffect)(()=>{
        // Calculate the total number of questions based on sections
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []); // Run this effect only once when the component mounts
    function clicked(question, option) {
        // Si l'option cliquée est la màªme que celle déjà  sélectionnée, on la désélectionne
        if (selectedOptions[question] === option) {
            setSelectedOptions((prevSelectedOptions)=>{
                const newOptions = {
                    ...prevSelectedOptions
                };
                delete newOptions[question];
                return newOptions;
            });
            // Si on désélectionne un "Yes", on décrémente le score
            if (option === "Yes") m_yesCount4--;
            return;
        }
        // Sinon, on met à  jour la sélection
        const previousOption = selectedOptions[question];
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        // Si on passe de "No" à  "Yes", on incrémente le score
        if (option === "Yes" && previousOption !== "Yes") m_yesCount4++;
        else if (option === "No" && previousOption === "Yes") m_yesCount4--;
    }
    const history = (0, _reactRouterDom.useHistory)();
    function saveData() {
        setIsLoading(true);
        setErrorMessage("");
        console.log("D\xe9but de sauvegarde des donn\xe9es Modernization4");
        const enterpriseId = localStorage.getItem("enterpriseId");
        const userId = localStorage.getItem("userId");
        if (!enterpriseId) {
            console.error("ERREUR: ID d'entreprise manquant");
            setErrorMessage("ID d'entreprise manquant. Veuillez retourner \xe0\xa0 la s\xe9lection d'entreprise.");
            setIsLoading(false);
            return;
        }
        // Définir toutes les questions possibles
        const allQuestions = [
            "Are your different systems able to communicate with each other?",
            "Do you have any means of communication?",
            "Is it paper?",
            "Is it oral?",
            "Is it by mail?",
            "Is it an Application Suite like Google, Microsoft?",
            "Is the data produced used to make decisions?",
            "Do operators have access to an intelligent user interface?"
        ];
        // Créer un tableau de questions/réponses pour toutes les questions
        const data = allQuestions.map((question)=>{
            const answer = selectedOptions[question] || "No";
            return {
                question: question,
                answer: answer,
                category: "modernization",
                enterpriseId: enterpriseId,
                userId: userId || "",
                section: "modernization-4",
                timestamp: new Date().toISOString()
            };
        });
        // Vérifier que les données sont correctement formatées
        const isValidData = data.every((item)=>item.question && item.answer && item.category && item.enterpriseId);
        if (!isValidData) {
            console.error("Donn\xe9es invalides:", data);
            setErrorMessage("Format de donn\xe9es invalide");
            setIsLoading(false);
            return;
        }
        // Sauvegarder les données pour une utilisation ultérieure
        m_allData4 = [
            ...data
        ];
        console.log("Donn\xe9es \xe0\xa0 envoyer:", JSON.stringify(data, null, 2));
        // Calculer la somme des scores
        const modernization1Score = parseInt(localStorage.getItem('modernization1Score') || 0);
        const modernization2Score = parseInt(localStorage.getItem('modernization2Score') || 0);
        const modernization3Score = parseInt(localStorage.getItem('modernization3Score') || 0);
        m_sum = modernization1Score + modernization2Score + modernization3Score + m_yesCount4;
        console.log("Score total Modernization:", m_sum);
        // Appel API pour sauvegarder les données
        fetch("/api/api/save-evaluation", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
            },
            body: JSON.stringify(data)
        }).then((response)=>{
            if (!response.ok) throw new Error(`Erreur de sauvegarde (${response.status})`);
            return response.json();
        }).then((result)=>{
            console.log("Data saved successfully:", result);
            // Sauvegarder le score dans le localStorage
            localStorage.setItem('modernization4Score', m_yesCount4);
            console.log(`Score modernization4 mis \xe0\xa0 jour: ${m_yesCount4}`);
            // Sauvegarder également le score total modernization
            const scoreData = [
                {
                    question: "Modernization Total Score Final",
                    answer: m_sum.toString(),
                    category: "modernization",
                    enterpriseId: enterpriseId,
                    userId: userId || "",
                    section: "modernization-total-final",
                    timestamp: new Date().toISOString()
                }
            ];
            console.log("Envoi du score total modernization:", JSON.stringify(scoreData, null, 2));
            // Appel API pour sauvegarder le score total
            return fetch("/api/api/save-answers", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
                },
                body: JSON.stringify(scoreData)
            });
        }).then((response)=>{
            if (!response || !response.ok) throw new Error("Failed to save total score");
            return response.json();
        }).then((scoreResponse)=>{
            console.log("Score total modernization enregistr\xe9 avec succ\xe8s:", scoreResponse);
            // Récupérer correctement les données de tous les composants
            const allModernizationData = [];
            // Utiliser des try/catch pour éviter les erreurs si certaines données sont manquantes
            try {
                if (Array.isArray((0, _modernization1.m_allData1)) && (0, _modernization1.m_allData1).length > 0) allModernizationData.push(...(0, _modernization1.m_allData1));
                if (Array.isArray((0, _modernization2.m_allData2)) && (0, _modernization2.m_allData2).length > 0) allModernizationData.push(...(0, _modernization2.m_allData2));
                if (Array.isArray((0, _modernization3.m_allData3)) && (0, _modernization3.m_allData3).length > 0) allModernizationData.push(...(0, _modernization3.m_allData3));
                if (Array.isArray(m_allData4) && m_allData4.length > 0) allModernizationData.push(...m_allData4);
            } catch (error) {
                console.error("Erreur lors de la concat\xe9nation des donn\xe9es:", error);
            }
            console.log("Toutes les donn\xe9es Modernization pour le PDF:", allModernizationData.length, "questions");
            // Générer le PDF avec toutes les données
            generatePdf(allModernizationData);
            // Redirection vers la page suivante
            setIsLoading(false);
            history.push("/lead-time-1_");
        }).catch((error)=>{
            console.error("Error saving data:", error);
            setErrorMessage("Error saving data. Please try again.");
            console.error("D\xe9tails de l'erreur:", error.message);
            // Màªme en cas d'erreur, essayer de générer le PDF avec les données disponibles
            const allModernizationData = [];
            try {
                if (Array.isArray((0, _modernization1.m_allData1)) && (0, _modernization1.m_allData1).length > 0) allModernizationData.push(...(0, _modernization1.m_allData1));
                if (Array.isArray((0, _modernization2.m_allData2)) && (0, _modernization2.m_allData2).length > 0) allModernizationData.push(...(0, _modernization2.m_allData2));
                if (Array.isArray((0, _modernization3.m_allData3)) && (0, _modernization3.m_allData3).length > 0) allModernizationData.push(...(0, _modernization3.m_allData3));
                if (Array.isArray(m_allData4) && m_allData4.length > 0) allModernizationData.push(...m_allData4);
            } catch (error) {
                console.error("Erreur lors de la concat\xe9nation des donn\xe9es:", error);
            }
            generatePdf(allModernizationData);
            // Redirection malgré l'erreur
            setIsLoading(false);
            history.push("/lead-time-1_");
        });
    }
    function generatePdf(m_allData) {
        // Vérifier si des données existent
        if (!m_allData || m_allData.length === 0) {
            console.error("Aucune donn\xe9e disponible pour g\xe9n\xe9rer le PDF");
            return;
        }
        console.log("G\xe9n\xe9ration du PDF avec", m_allData.length, "questions");
        // Créer un nouveau document PDF
        const doc = new (0, _jspdfDefault.default)();
        const lineHeight = 10;
        const pageHeight = doc.internal.pageSize.height - 20;
        const pageWidth = doc.internal.pageSize.width - 20;
        let y = 20;
        // Ajouter un titre
        doc.setFontSize(16);
        doc.text("Modernization Assessment Results", 105, y, {
            align: "center"
        });
        y += 15;
        // Ajouter le score total
        doc.setFontSize(14);
        doc.text(`Total Score: ${m_sum} / ${m_allData.length}`, 105, y, {
            align: "center"
        });
        y += 15;
        doc.setFontSize(12);
        // Parcourir les données et ajouter chaque question et réponse au document PDF
        m_allData.forEach((data, index)=>{
            // Vérifier si les données sont valides
            if (!data || !data.question) {
                console.error("Donn\xe9es invalides pour l'\xe9l\xe9ment", index);
                return;
            }
            const question = `Question ${index + 1}: ${data.question}`;
            const answer = `Answer: ${data.answer || 'No answer'}`;
            // Estimer la hauteur du texte après division pour mieux gérer les sauts de page
            const splitQuestion = doc.splitTextToSize(question, pageWidth);
            const estimatedHeight = splitQuestion.length * lineHeight + lineHeight * 2;
            // Vérifier si on doit passer à  une nouvelle page
            if (y + estimatedHeight > pageHeight) {
                doc.addPage();
                y = 20;
            }
            // à‰crire la question et la réponse dans le PDF
            doc.text(splitQuestion, 10, y);
            y += splitQuestion.length * lineHeight;
            doc.text(answer, 10, y);
            y += lineHeight * 2; // Ajouter un peu d'espace entre les questions
        });
        // Ajouter une page de résumé
        doc.addPage();
        y = 20;
        doc.setFontSize(16);
        doc.text("Summary of Modernization Assessment", 105, y, {
            align: "center"
        });
        y += 20;
        doc.setFontSize(12);
        doc.text(`Total number of questions: ${m_allData.length}`, 10, y);
        y += lineHeight;
        doc.text(`Total "Yes" answers: ${m_sum}`, 10, y);
        y += lineHeight;
        doc.text(`Score percentage: ${Math.round(m_sum / m_allData.length * 100)}%`, 10, y);
        y += lineHeight * 2;
        const date = new Date();
        doc.text(`Generated on: ${date.toLocaleDateString()} at ${date.toLocaleTimeString()}`, 10, y);
        // Enregistrer le document PDF
        doc.save("Modernization_Assessment_Complete.pdf");
        console.log("PDF Modernization g\xe9n\xe9r\xe9 avec succ\xe8s");
    }
    function calculateProgressPercentage() {
        const totalQuestionsCount = document.getElementsByTagName("section").length;
        if (totalQuestionsCount === 0) return 0;
        return Math.round(m_yesCount4 / totalQuestionsCount * 100);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "environmental-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "environmental-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    className: "environmental-title",
                    children: "SCORE MODERNIZATION"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "progress-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "progress-bar",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "progress-fill",
                                style: {
                                    width: `${calculateProgressPercentage()}%`
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "progress-text",
                            children: [
                                "Your score: ",
                                m_yesCount4,
                                " / ",
                                totalQuestions,
                                " (",
                                calculateProgressPercentage(),
                                "%)"
                            ]
                        })
                    ]
                }),
                errorMessage && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "error-message",
                    children: errorMessage
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questions-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Are your different systems able to communicate with each other?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Are your different systems able to communicate with each other?", "Yes"),
                                            className: `btn-option ${selectedOptions["Are your different systems able to communicate with each other?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Are your different systems able to communicate with each other?", "No"),
                                            className: `btn-option ${selectedOptions["Are your different systems able to communicate with each other?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have any means of communication?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have any means of communication?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have any means of communication?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have any means of communication?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have any means of communication?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Is it paper?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Is it paper?", "Yes"),
                                            className: `btn-option ${selectedOptions["Is it paper?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Is it paper?", "No"),
                                            className: `btn-option ${selectedOptions["Is it paper?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Is it oral?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Is it oral?", "Yes"),
                                            className: `btn-option ${selectedOptions["Is it oral?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Is it oral?", "No"),
                                            className: `btn-option ${selectedOptions["Is it oral?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Is it by mail?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Is it by mail?", "Yes"),
                                            className: `btn-option ${selectedOptions["Is it by mail?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Is it by mail?", "No"),
                                            className: `btn-option ${selectedOptions["Is it by mail?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Is it an Application Suite like Google, Microsoft?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Is it an Application Suite like Google, Microsoft?", "Yes"),
                                            className: `btn-option ${selectedOptions["Is it an Application Suite like Google, Microsoft?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Is it an Application Suite like Google, Microsoft?", "No"),
                                            className: `btn-option ${selectedOptions["Is it an Application Suite like Google, Microsoft?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Is the data produced used to make decisions?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Is the data produced used to make decisions?", "Yes"),
                                            className: `btn-option ${selectedOptions["Is the data produced used to make decisions?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Is the data produced used to make decisions?", "No"),
                                            className: `btn-option ${selectedOptions["Is the data produced used to make decisions?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do operators have access to an intelligent user interface?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do operators have access to an intelligent user interface?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do operators have access to an intelligent user interface?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do operators have access to an intelligent user interface?", "No"),
                                            className: `btn-option ${selectedOptions["Do operators have access to an intelligent user interface?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "form-actions",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/modernization-3_",
                            className: "btn-secondary",
                            children: "Back"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "btn-primary",
                            children: "Complete Assessment and Continue"
                        })
                    ]
                }),
                isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "loading-indicator",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "spinner"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: "Saving data and generating PDF..."
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Modernization4_;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["Link","b9X5n"],["useHistory","ditZI"]],"../NavItems2":"bnQuI","../NavItems3":"fOarC","./Modernization4_.css":"j2Xjq","../../styleguide.css":"8Y7Ec","jspdf":"hkJ4Q","../Modernization1_":"kRVwW","../Modernization2_":"ik8P8","../Modernization3_":"f85ZL","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"j2Xjq":[function() {},{}],"8Y7Ec":[function() {},{}],"kRVwW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "m_allData1", ()=>m_allData1);
parcelHelpers.export(exports, "m_yesCount1", ()=>m_yesCount1);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _modernization1Css = require("./Modernization1_.css");
var _styleguideCss = require("../../styleguide.css");
let m_allData1 = [];
let m_yesCount1 = 0;
function Modernization1_(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const { x1200PxLogo_Icam__20081, navItems2Props, navItems3Props } = props;
    (0, _react.useEffect)(()=>{
        // Calculate the total number of questions based on sections
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []); // Run this effect only once when the component mounts
    function clicked(question, option) {
        // Si l'option cliquée est la màªme que celle déjà  sélectionnée, on la désélectionne
        if (selectedOptions[question] === option) {
            setSelectedOptions((prevSelectedOptions)=>{
                const newOptions = {
                    ...prevSelectedOptions
                };
                delete newOptions[question];
                return newOptions;
            });
            // Si on désélectionne un "Yes", on décrémente le score
            if (option === "Yes") m_yesCount1--;
            return;
        }
        // Sinon, on met à  jour la sélection
        const previousOption = selectedOptions[question];
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        // Si on passe de "No" à  "Yes", on incrémente le score
        if (option === "Yes" && previousOption !== "Yes") m_yesCount1++;
        else if (option === "No" && previousOption === "Yes") m_yesCount1--;
    }
    const history = (0, _reactRouterDom.useHistory)();
    function saveData() {
        setIsLoading(true);
        setErrorMessage("");
        console.log("D\xe9but de sauvegarde des donn\xe9es Modernization1");
        const enterpriseId = localStorage.getItem("enterpriseId");
        const userId = localStorage.getItem("userId");
        if (!enterpriseId) {
            console.error("ERREUR: ID d'entreprise manquant");
            setErrorMessage("ID d'entreprise manquant. Veuillez retourner \xe0\xa0 la s\xe9lection d'entreprise.");
            setIsLoading(false);
            return;
        }
        // Définir toutes les questions possibles
        const allQuestions = [
            "Do you have AI models that can solve problems?",
            "Do you use intelligent agents to solve simulation problems?",
            "Do you have any models for forecasting sales?",
            "Do you have models for sales forecasting?",
            "Do you have models for forecasting purchases?",
            "Do you have robots that can be autonomous on complex tasks?",
            "Do you have a cybersecurity system using AI models?"
        ];
        // Créer un tableau de questions/réponses pour toutes les questions
        const data = allQuestions.map((question)=>{
            const answer = selectedOptions[question] || "No";
            return {
                question: question,
                answer: answer,
                category: "modernization",
                enterpriseId: enterpriseId,
                userId: userId || "",
                section: "modernization-1",
                timestamp: new Date().toISOString()
            };
        });
        // Vérifier que les données sont correctement formatées
        const isValidData = data.every((item)=>item.question && item.answer && item.category && item.enterpriseId);
        if (!isValidData) {
            console.error("Donn\xe9es invalides:", data);
            setErrorMessage("Format de donn\xe9es invalide");
            setIsLoading(false);
            return;
        }
        // Sauvegarder les données pour une utilisation ultérieure
        m_allData1 = [
            ...data
        ];
        console.log("Donn\xe9es \xe0\xa0 envoyer:", JSON.stringify(data, null, 2));
        // Appel API pour sauvegarder les données
        fetch("/api/api/save-evaluation", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
            },
            body: JSON.stringify(data)
        }).then((response)=>{
            if (!response.ok) throw new Error(`Erreur de sauvegarde (${response.status})`);
            return response.json();
        }).then((result)=>{
            console.log("Data saved successfully:", result);
            // Sauvegarder le score dans le localStorage
            localStorage.setItem('modernization1Score', m_yesCount1);
            console.log(`Score modernization1 mis \xe0\xa0 jour: ${m_yesCount1}`);
            setIsLoading(false);
            history.push("/modernization-2_");
        }).catch((error)=>{
            console.error("Error saving data:", error);
            setErrorMessage("Error saving data. Please try again.");
            console.error("D\xe9tails de l'erreur:", error.message);
            setIsLoading(false);
            history.push("/modernization-2_");
        });
    }
    function calculateProgressPercentage() {
        const totalQuestions = document.getElementsByTagName("section").length;
        if (totalQuestions === 0) return 0;
        return Math.round(m_yesCount1 / totalQuestions * 100);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "environmental-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "environmental-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    className: "environmental-title",
                    children: "PLEASE ANSWER THE FOLLOWING QUESTIONS"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "progress-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "progress-bar",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "progress-fill",
                                style: {
                                    width: `${calculateProgressPercentage()}%`
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "progress-text",
                            children: [
                                "Your score: ",
                                m_yesCount1,
                                " / ",
                                totalQuestions,
                                " (",
                                calculateProgressPercentage(),
                                "%)"
                            ]
                        })
                    ]
                }),
                errorMessage && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "error-message",
                    children: errorMessage
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questions-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have AI models that can solve problems?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have AI models that can solve problems?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have AI models that can solve problems?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have AI models that can solve problems?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have AI models that can solve problems?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you use intelligent agents to solve simulation problems?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you use intelligent agents to solve simulation problems?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you use intelligent agents to solve simulation problems?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you use intelligent agents to solve simulation problems?", "No"),
                                            className: `btn-option ${selectedOptions["Do you use intelligent agents to solve simulation problems?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have any models for forecasting sales?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have any models for forecasting sales?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have any models for forecasting sales?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have any models for forecasting sales?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have any models for forecasting sales?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have models for sales forecasting?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have models for sales forecasting?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have models for sales forecasting?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have models for sales forecasting?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have models for sales forecasting?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have models for forecasting purchases?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have models for forecasting purchases?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have models for forecasting purchases?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have models for forecasting purchases?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have models for forecasting purchases?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have robots that can be autonomous on complex tasks?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have robots that can be autonomous on complex tasks?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have robots that can be autonomous on complex tasks?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have robots that can be autonomous on complex tasks?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have robots that can be autonomous on complex tasks?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have a cybersecurity system using AI models?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a cybersecurity system using AI models?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have a cybersecurity system using AI models?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a cybersecurity system using AI models?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have a cybersecurity system using AI models?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "form-actions",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/social-6_",
                            className: "btn-secondary",
                            children: "Back"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "btn-primary",
                            children: "Next"
                        })
                    ]
                }),
                isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "loading-indicator",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "spinner"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: "Saving data..."
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Modernization1_;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["Link","b9X5n"],["useHistory","ditZI"]],"../NavItems2":"bnQuI","../NavItems3":"fOarC","./Modernization1_.css":"gCwMT","../../styleguide.css":"8Y7Ec","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gCwMT":[function() {},{}],"8Y7Ec":[function() {},{}],"ik8P8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "m_allData2", ()=>m_allData2);
parcelHelpers.export(exports, "m_yesCount2", ()=>m_yesCount2);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _modernization2Css = require("./Modernization2_.css");
var _styleguideCss = require("../../styleguide.css");
let m_allData2 = [];
let m_yesCount2 = 0;
function Modernization2_(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const { x1200PxLogo_Icam__20081, navItems2Props, navItems3Props } = props;
    (0, _react.useEffect)(()=>{
        // Calculate the total number of questions based on sections
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []); // Run this effect only once when the component mounts
    function clicked(question, option) {
        // Si l'option cliquée est la màªme que celle déjà  sélectionnée, on la désélectionne
        if (selectedOptions[question] === option) {
            setSelectedOptions((prevSelectedOptions)=>{
                const newOptions = {
                    ...prevSelectedOptions
                };
                delete newOptions[question];
                return newOptions;
            });
            // Si on désélectionne un "Yes", on décrémente le score
            if (option === "Yes") m_yesCount2--;
            return;
        }
        // Sinon, on met à  jour la sélection
        const previousOption = selectedOptions[question];
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        // Si on passe de "No" à  "Yes", on incrémente le score
        if (option === "Yes" && previousOption !== "Yes") m_yesCount2++;
        else if (option === "No" && previousOption === "Yes") m_yesCount2--;
    }
    const history = (0, _reactRouterDom.useHistory)();
    function saveData() {
        setIsLoading(true);
        setErrorMessage("");
        console.log("D\xe9but de sauvegarde des donn\xe9es Modernization2");
        const enterpriseId = localStorage.getItem("enterpriseId");
        const userId = localStorage.getItem("userId");
        if (!enterpriseId) {
            console.error("ERREUR: ID d'entreprise manquant");
            setErrorMessage("ID d'entreprise manquant. Veuillez retourner \xe0\xa0 la s\xe9lection d'entreprise.");
            setIsLoading(false);
            return;
        }
        // Définir toutes les questions possibles
        const allQuestions = [
            "For programming, are there people in the company who know how to code in Python?",
            "For programming, are there people in the company who know how to code in Java?",
            "For programming, are there people in the company who know how to code in C++?",
            "For programming, are there people in the company who know how to code in JavaScript?",
            "For programming, are there people in the company who know how to code in PHP?",
            "Do you have people in the company who have an operational knowledge of Deep Learning libraries (KERAS, TensorFlow, PyCaret, PyTorch)?"
        ];
        // Créer un tableau de questions/réponses pour toutes les questions
        const data = allQuestions.map((question)=>{
            const answer = selectedOptions[question] || "No";
            return {
                question: question,
                answer: answer,
                category: "modernization",
                enterpriseId: enterpriseId,
                userId: userId || "",
                section: "modernization-2",
                timestamp: new Date().toISOString()
            };
        });
        // Vérifier que les données sont correctement formatées
        const isValidData = data.every((item)=>item.question && item.answer && item.category && item.enterpriseId);
        if (!isValidData) {
            console.error("Donn\xe9es invalides:", data);
            setErrorMessage("Format de donn\xe9es invalide");
            setIsLoading(false);
            return;
        }
        // Sauvegarder les données pour une utilisation ultérieure
        m_allData2 = [
            ...data
        ];
        console.log("Donn\xe9es \xe0\xa0 envoyer:", JSON.stringify(data, null, 2));
        // Appel API pour sauvegarder les données
        fetch("/api/api/save-evaluation", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
            },
            body: JSON.stringify(data)
        }).then((response)=>{
            if (!response.ok) throw new Error(`Erreur de sauvegarde (${response.status})`);
            return response.json();
        }).then((result)=>{
            console.log("Data saved successfully:", result);
            // Sauvegarder le score dans le localStorage
            localStorage.setItem('modernization2Score', m_yesCount2);
            console.log(`Score modernization2 mis \xe0\xa0 jour: ${m_yesCount2}`);
            setIsLoading(false);
            history.push("/modernization-3_");
        }).catch((error)=>{
            console.error("Error saving data:", error);
            setErrorMessage("Error saving data. Please try again.");
            console.error("D\xe9tails de l'erreur:", error.message);
            setIsLoading(false);
            history.push("/modernization-3_");
        });
    }
    function calculateProgressPercentage() {
        const totalQuestions = document.getElementsByTagName("section").length;
        if (totalQuestions === 0) return 0;
        return Math.round(m_yesCount2 / totalQuestions * 100);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "environmental-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "environmental-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    className: "environmental-title",
                    children: "PLEASE ANSWER THE FOLLOWING QUESTIONS"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "progress-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "progress-bar",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "progress-fill",
                                style: {
                                    width: `${calculateProgressPercentage()}%`
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "progress-text",
                            children: [
                                "Your score: ",
                                m_yesCount2,
                                " / ",
                                totalQuestions,
                                " (",
                                calculateProgressPercentage(),
                                "%)"
                            ]
                        })
                    ]
                }),
                errorMessage && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "error-message",
                    children: errorMessage
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questions-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "For programming, are there people in the company who know how to code in Python?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("For programming, are there people in the company who know how to code in Python?", "Yes"),
                                            className: `btn-option ${selectedOptions["For programming, are there people in the company who know how to code in Python?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("For programming, are there people in the company who know how to code in Python?", "No"),
                                            className: `btn-option ${selectedOptions["For programming, are there people in the company who know how to code in Python?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "For programming, are there people in the company who know how to code in Java?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("For programming, are there people in the company who know how to code in Java?", "Yes"),
                                            className: `btn-option ${selectedOptions["For programming, are there people in the company who know how to code in Java?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("For programming, are there people in the company who know how to code in Java?", "No"),
                                            className: `btn-option ${selectedOptions["For programming, are there people in the company who know how to code in Java?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "For programming, are there people in the company who know how to code in C++?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("For programming, are there people in the company who know how to code in C++?", "Yes"),
                                            className: `btn-option ${selectedOptions["For programming, are there people in the company who know how to code in C++?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("For programming, are there people in the company who know how to code in C++?", "No"),
                                            className: `btn-option ${selectedOptions["For programming, are there people in the company who know how to code in C++?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "For programming, are there people in the company who know how to code in JavaScript?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("For programming, are there people in the company who know how to code in JavaScript?", "Yes"),
                                            className: `btn-option ${selectedOptions["For programming, are there people in the company who know how to code in JavaScript?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("For programming, are there people in the company who know how to code in JavaScript?", "No"),
                                            className: `btn-option ${selectedOptions["For programming, are there people in the company who know how to code in JavaScript?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "For programming, are there people in the company who know how to code in PHP?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("For programming, are there people in the company who know how to code in PHP?", "Yes"),
                                            className: `btn-option ${selectedOptions["For programming, are there people in the company who know how to code in PHP?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("For programming, are there people in the company who know how to code in PHP?", "No"),
                                            className: `btn-option ${selectedOptions["For programming, are there people in the company who know how to code in PHP?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have people in the company who have an operational knowledge of Deep Learning libraries (KERAS, TensorFlow, PyCaret, PyTorch)?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have people in the company who have an operational knowledge of Deep Learning libraries (KERAS, TensorFlow, PyCaret, PyTorch)?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have people in the company who have an operational knowledge of Deep Learning libraries (KERAS, TensorFlow, PyCaret, PyTorch)?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have people in the company who have an operational knowledge of Deep Learning libraries (KERAS, TensorFlow, PyCaret, PyTorch)?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have people in the company who have an operational knowledge of Deep Learning libraries (KERAS, TensorFlow, PyCaret, PyTorch)?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "form-actions",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/modernization-1_",
                            className: "btn-secondary",
                            children: "Back"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "btn-primary",
                            children: "Next"
                        })
                    ]
                }),
                isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "loading-indicator",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "spinner"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: "Saving data..."
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Modernization2_;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["Link","b9X5n"],["useHistory","ditZI"]],"../NavItems2":"bnQuI","../NavItems3":"fOarC","./Modernization2_.css":"eIqj0","../../styleguide.css":"8Y7Ec","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eIqj0":[function() {},{}],"8Y7Ec":[function() {},{}],"f85ZL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "m_allData3", ()=>m_allData3);
parcelHelpers.export(exports, "m_yesCount3", ()=>m_yesCount3);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _modernization3Css = require("./Modernization3_.css");
var _styleguideCss = require("../../styleguide.css");
let m_allData3 = [];
let m_yesCount3 = 0;
function Modernization3_(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const { x1200PxLogo_Icam__20081, navItems2Props, navItems3Props } = props;
    (0, _react.useEffect)(()=>{
        // Calculate the total number of questions based on sections
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []); // Run this effect only once when the component mounts
    function clicked(question, option) {
        // Si l'option cliquée est la màªme que celle déjà  sélectionnée, on la désélectionne
        if (selectedOptions[question] === option) {
            setSelectedOptions((prevSelectedOptions)=>{
                const newOptions = {
                    ...prevSelectedOptions
                };
                delete newOptions[question];
                return newOptions;
            });
            // Si on désélectionne un "Yes", on décrémente le score
            if (option === "Yes") m_yesCount3--;
            return;
        }
        // Sinon, on met à  jour la sélection
        const previousOption = selectedOptions[question];
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        // Si on passe de "No" à  "Yes", on incrémente le score
        if (option === "Yes" && previousOption !== "Yes") m_yesCount3++;
        else if (option === "No" && previousOption === "Yes") m_yesCount3--;
    }
    const history = (0, _reactRouterDom.useHistory)();
    function saveData() {
        setIsLoading(true);
        setErrorMessage("");
        console.log("D\xe9but de sauvegarde des donn\xe9es Modernization3");
        const enterpriseId = localStorage.getItem("enterpriseId");
        const userId = localStorage.getItem("userId");
        if (!enterpriseId) {
            console.error("ERREUR: ID d'entreprise manquant");
            setErrorMessage("ID d'entreprise manquant. Veuillez retourner \xe0\xa0 la s\xe9lection d'entreprise.");
            setIsLoading(false);
            return;
        }
        // Définir toutes les questions possibles
        const allQuestions = [
            "For the visualization of your data, do you use Power BI?",
            "For the visualization of your data, do you use AWS?",
            "For the visualization of your data, do you use GCP?",
            "For the visualization of your data, do you use Python?",
            "For the visualization of your data, do you use others?",
            "Do you have models for data visualization?"
        ];
        // Créer un tableau de questions/réponses pour toutes les questions
        const data = allQuestions.map((question)=>{
            const answer = selectedOptions[question] || "No";
            return {
                question: question,
                answer: answer,
                category: "modernization",
                enterpriseId: enterpriseId,
                userId: userId || "",
                section: "modernization-3",
                timestamp: new Date().toISOString()
            };
        });
        // Vérifier que les données sont correctement formatées
        const isValidData = data.every((item)=>item.question && item.answer && item.category && item.enterpriseId);
        if (!isValidData) {
            console.error("Donn\xe9es invalides:", data);
            setErrorMessage("Format de donn\xe9es invalide");
            setIsLoading(false);
            return;
        }
        // Sauvegarder les données pour une utilisation ultérieure
        m_allData3 = [
            ...data
        ];
        console.log("Donn\xe9es \xe0\xa0 envoyer:", JSON.stringify(data, null, 2));
        // Appel API pour sauvegarder les données
        fetch("/api/api/save-evaluation", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
            },
            body: JSON.stringify(data)
        }).then((response)=>{
            if (!response.ok) throw new Error(`Erreur de sauvegarde (${response.status})`);
            return response.json();
        }).then((result)=>{
            console.log("Data saved successfully:", result);
            // Sauvegarder le score dans le localStorage
            localStorage.setItem('modernization3Score', m_yesCount3);
            console.log(`Score modernization3 mis \xe0\xa0 jour: ${m_yesCount3}`);
            setIsLoading(false);
            history.push("/modernization-4_");
        }).catch((error)=>{
            console.error("Error saving data:", error);
            setErrorMessage("Error saving data. Please try again.");
            console.error("D\xe9tails de l'erreur:", error.message);
            setIsLoading(false);
            history.push("/modernization-4_");
        });
    }
    function calculateProgressPercentage() {
        const totalQuestions = document.getElementsByTagName("section").length;
        if (totalQuestions === 0) return 0;
        return Math.round(m_yesCount3 / totalQuestions * 100);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "environmental-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "environmental-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    className: "environmental-title",
                    children: "PLEASE ANSWER THE FOLLOWING QUESTIONS"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "progress-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "progress-bar",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "progress-fill",
                                style: {
                                    width: `${calculateProgressPercentage()}%`
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "progress-text",
                            children: [
                                "Your score: ",
                                m_yesCount3,
                                " / ",
                                totalQuestions,
                                " (",
                                calculateProgressPercentage(),
                                "%)"
                            ]
                        })
                    ]
                }),
                errorMessage && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "error-message",
                    children: errorMessage
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questions-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "For the visualization of your data, do you use Power BI?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("For the visualization of your data, do you use Power BI?", "Yes"),
                                            className: `btn-option ${selectedOptions["For the visualization of your data, do you use Power BI?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("For the visualization of your data, do you use Power BI?", "No"),
                                            className: `btn-option ${selectedOptions["For the visualization of your data, do you use Power BI?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "For the visualization of your data, do you use AWS?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("For the visualization of your data, do you use AWS?", "Yes"),
                                            className: `btn-option ${selectedOptions["For the visualization of your data, do you use AWS?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("For the visualization of your data, do you use AWS?", "No"),
                                            className: `btn-option ${selectedOptions["For the visualization of your data, do you use AWS?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "For the visualization of your data, do you use GCP?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("For the visualization of your data, do you use GCP?", "Yes"),
                                            className: `btn-option ${selectedOptions["For the visualization of your data, do you use GCP?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("For the visualization of your data, do you use GCP?", "No"),
                                            className: `btn-option ${selectedOptions["For the visualization of your data, do you use GCP?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "For the visualization of your data, do you use Python?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("For the visualization of your data, do you use Python?", "Yes"),
                                            className: `btn-option ${selectedOptions["For the visualization of your data, do you use Python?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("For the visualization of your data, do you use Python?", "No"),
                                            className: `btn-option ${selectedOptions["For the visualization of your data, do you use Python?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "For the visualization of your data, do you use others?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("For the visualization of your data, do you use others?", "Yes"),
                                            className: `btn-option ${selectedOptions["For the visualization of your data, do you use others?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("For the visualization of your data, do you use others?", "No"),
                                            className: `btn-option ${selectedOptions["For the visualization of your data, do you use others?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have models for data visualization?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have models for data visualization?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have models for data visualization?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have models for data visualization?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have models for data visualization?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "form-actions",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/modernization-2_",
                            className: "btn-secondary",
                            children: "Back"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "btn-primary",
                            children: "Next"
                        })
                    ]
                }),
                isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "loading-indicator",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "spinner"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: "Saving data..."
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Modernization3_;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["Link","b9X5n"],["useHistory","ditZI"]],"../NavItems2":"bnQuI","../NavItems3":"fOarC","./Modernization3_.css":"1BbBs","../../styleguide.css":"8Y7Ec","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1BbBs":[function() {},{}],"8Y7Ec":[function() {},{}],"2qrDc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "l_sum", ()=>l_sum);
parcelHelpers.export(exports, "l_allData2", ()=>l_allData2);
parcelHelpers.export(exports, "l_yesCount2", ()=>l_yesCount2);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _leadTime2Css = require("./LeadTime2_.css");
var _styleguideCss = require("../../styleguide.css");
var _jspdf = require("jspdf");
var _jspdfDefault = parcelHelpers.interopDefault(_jspdf);
var _leadTime1 = require("../LeadTime1_");
let l_sum = 0;
let l_allData2 = [];
let l_yesCount2 = 0;
function LeadTime2_(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const { x1200PxLogo_Ical__20081, navItems3Props } = props;
    (0, _react.useEffect)(()=>{
        // Calculate the total number of questions based on sections
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []); // Run this effect only once when the component mounts
    function clicked(question, option) {
        // Si l'option cliquée est la màªme que celle déjà  sélectionnée, on la désélectionne
        if (selectedOptions[question] === option) {
            setSelectedOptions((prevSelectedOptions)=>{
                const newOptions = {
                    ...prevSelectedOptions
                };
                delete newOptions[question];
                return newOptions;
            });
            // Si on désélectionne un "Yes", on décrémente le score
            if (option === "Yes") l_yesCount2--;
            return;
        }
        // Sinon, on met à  jour la sélection
        const previousOption = selectedOptions[question];
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        // Si on passe de "No" à  "Yes", on incrémente le score
        if (option === "Yes" && previousOption !== "Yes") l_yesCount2++;
        else if (option === "No" && previousOption === "Yes") l_yesCount2--;
    }
    const history = (0, _reactRouterDom.useHistory)();
    function saveData() {
        setIsLoading(true);
        setErrorMessage("");
        console.log("D\xe9but de sauvegarde des donn\xe9es LeadTime2");
        const enterpriseId = localStorage.getItem("enterpriseId");
        const userId = localStorage.getItem("userId");
        if (!enterpriseId) {
            console.error("ERREUR: ID d'entreprise manquant");
            setErrorMessage("ID d'entreprise manquant. Veuillez retourner \xe0\xa0 la s\xe9lection d'entreprise.");
            setIsLoading(false);
            return;
        }
        // Définir toutes les questions possibles
        const allQuestions = [
            "Are you experiencing production delays due to technical problems?",
            "Have measures been put in place to avoid these inconveniences?",
            "Are you experiencing delays in product (or service) delivery to your customers?",
            "Do you have shipping delay problems when delivering to your customers?",
            "Do you feel that your customers are satisfied with your delivery times?",
            "Are your customers accepting of your delivery times?"
        ];
        // Créer un tableau de questions/réponses pour toutes les questions
        const data = allQuestions.map((question)=>{
            const answer = selectedOptions[question] || "No";
            return {
                question: question,
                answer: answer,
                category: "leadTime",
                enterpriseId: enterpriseId,
                userId: userId || "",
                section: "leadtime-2",
                timestamp: new Date().toISOString()
            };
        });
        // Vérifier que les données sont correctement formatées
        const isValidData = data.every((item)=>item.question && item.answer && item.category && item.enterpriseId);
        if (!isValidData) {
            console.error("Donn\xe9es invalides:", data);
            setErrorMessage("Format de donn\xe9es invalide");
            setIsLoading(false);
            return;
        }
        // Sauvegarder les données pour une utilisation ultérieure
        l_allData2 = [
            ...data
        ];
        console.log("Donn\xe9es \xe0\xa0 envoyer:", JSON.stringify(data, null, 2));
        // Calculer la somme des scores
        const leadTime1Score = parseInt(localStorage.getItem('leadTime1Score') || 0);
        l_sum = leadTime1Score + l_yesCount2;
        console.log("Score total Leadtime:", l_sum);
        // Appel API pour sauvegarder les données
        fetch("/api/api/save-evaluation", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
            },
            body: JSON.stringify(data)
        }).then((response)=>{
            if (!response.ok) throw new Error(`Erreur de sauvegarde (${response.status})`);
            return response.json();
        }).then((result)=>{
            console.log("Data saved successfully:", result);
            // Sauvegarder le score dans le localStorage
            localStorage.setItem('leadTime2Score', l_yesCount2);
            console.log(`Score leadTime2 mis \xe0\xa0 jour: ${l_yesCount2}`);
            // Sauvegarder également le score total leadtime
            const scoreData = [
                {
                    question: "LeadTime Total Score Final",
                    answer: l_sum.toString(),
                    category: "leadTime",
                    enterpriseId: enterpriseId,
                    userId: userId || "",
                    section: "leadtime-total-final",
                    timestamp: new Date().toISOString()
                }
            ];
            console.log("Envoi du score total leadTime:", JSON.stringify(scoreData, null, 2));
            // Appel API pour sauvegarder le score total
            return fetch("/api/api/save-evaluation", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
                },
                body: JSON.stringify(scoreData)
            });
        }).then((response)=>{
            if (!response || !response.ok) throw new Error("Failed to save total score");
            return response.json();
        }).then((scoreResponse)=>{
            console.log("Score total leadTime enregistr\xe9 avec succ\xe8s:", scoreResponse);
            // Récupérer correctement les données de tous les composants
            const allLeadtimeData = [];
            // Utiliser des try/catch pour éviter les erreurs si certaines données sont manquantes
            try {
                if (Array.isArray((0, _leadTime1.l_allData1)) && (0, _leadTime1.l_allData1).length > 0) allLeadtimeData.push(...(0, _leadTime1.l_allData1));
                if (Array.isArray(l_allData2) && l_allData2.length > 0) allLeadtimeData.push(...l_allData2);
            } catch (error) {
                console.error("Erreur lors de la concat\xe9nation des donn\xe9es:", error);
            }
            console.log("Toutes les donn\xe9es LeadTime pour le PDF:", allLeadtimeData.length, "questions");
            // Générer le PDF avec toutes les données
            generatePdf(allLeadtimeData);
            // Redirection vers la page suivante
            setIsLoading(false);
            history.push("/cost-1_");
        }).catch((error)=>{
            console.error("Error saving data:", error);
            setErrorMessage("Error saving data. Please try again.");
            console.error("D\xe9tails de l'erreur:", error.message);
            // Màªme en cas d'erreur, essayer de générer le PDF avec les données disponibles
            const allLeadtimeData = [];
            try {
                if (Array.isArray((0, _leadTime1.l_allData1)) && (0, _leadTime1.l_allData1).length > 0) allLeadTimeData.push(...(0, _leadTime1.l_allData1));
                if (Array.isArray(l_allData2) && l_allData2.length > 0) allLeadTimeData.push(...l_allData2);
            } catch (error) {
                console.error("Erreur lors de la concat\xe9nation des donn\xe9es:", error);
            }
            generatePdf(allLeadtimeData);
            // Redirection malgré l'erreur
            setIsLoading(false);
            history.push("/cost-1_");
        });
    }
    function generatePdf(l_allData) {
        // Vérifier si des données existent
        if (!l_allData || l_allData.length === 0) {
            console.error("Aucune donn\xe9e disponible pour g\xe9n\xe9rer le PDF");
            return;
        }
        console.log("G\xe9n\xe9ration du PDF avec", l_allData.length, "questions");
        // Créer un nouveau document PDF
        const doc = new (0, _jspdfDefault.default)();
        const lineHeight = 10;
        const pageHeight = doc.internal.pageSize.height - 20;
        const pageWidth = doc.internal.pageSize.width - 20;
        let y = 20;
        // Ajouter un titre
        doc.setFontSize(16);
        doc.text("Lead Time Assessment Results", 105, y, {
            align: "center"
        });
        y += 15;
        // Ajouter le score total
        doc.setFontSize(14);
        doc.text(`Total Score: ${l_sum} / ${l_allData.length}`, 105, y, {
            align: "center"
        });
        y += 15;
        doc.setFontSize(12);
        // Parcourir les données et ajouter chaque question et réponse au document PDF
        l_allData.forEach((data, index)=>{
            // Vérifier si les données sont valides
            if (!data || !data.question) {
                console.error("Donn\xe9es invalides pour l'\xe9l\xe9ment", index);
                return;
            }
            const question = `Question ${index + 1}: ${data.question}`;
            const answer = `Answer: ${data.answer || 'No answer'}`;
            // Estimer la hauteur du texte après division pour mieux gérer les sauts de page
            const splitQuestion = doc.splitTextToSize(question, pageWidth);
            const estimatedHeight = splitQuestion.length * lineHeight + lineHeight * 2;
            // Vérifier si on doit passer à  une nouvelle page
            if (y + estimatedHeight > pageHeight) {
                doc.addPage();
                y = 20;
            }
            // à‰crire la question et la réponse dans le PDF
            doc.text(splitQuestion, 10, y);
            y += splitQuestion.length * lineHeight;
            doc.text(answer, 10, y);
            y += lineHeight * 2; // Ajouter un peu d'espace entre les questions
        });
        // Ajouter une page de résumé
        doc.addPage();
        y = 20;
        doc.setFontSize(16);
        doc.text("Summary of Lead Time Assessment", 105, y, {
            align: "center"
        });
        y += 20;
        doc.setFontSize(12);
        doc.text(`Total number of questions: ${l_allData.length}`, 10, y);
        y += lineHeight;
        doc.text(`Total "Yes" answers: ${l_sum}`, 10, y);
        y += lineHeight;
        doc.text(`Score percentage: ${Math.round(l_sum / l_allData.length * 100)}%`, 10, y);
        y += lineHeight * 2;
        const date = new Date();
        doc.text(`Generated on: ${date.toLocaleDateString()} at ${date.toLocaleTimeString()}`, 10, y);
        // Enregistrer le document PDF
        doc.save("LeadTime_Assessment_Complete.pdf");
        console.log("PDF Lead Time g\xe9n\xe9r\xe9 avec succ\xe8s");
    }
    function calculateProgressPercentage() {
        const totalQuestions = document.getElementsByTagName("section").length;
        if (totalQuestions === 0) return 0;
        return Math.round(l_yesCount2 / totalQuestions * 100);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "environmental-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "environmental-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    className: "environmental-title",
                    children: "PLEASE ANSWER THE FOLLOWING QUESTIONS"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "progress-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "progress-bar",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "progress-fill",
                                style: {
                                    width: `${calculateProgressPercentage()}%`
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "progress-text",
                            children: [
                                "Your score: ",
                                l_yesCount2,
                                " / ",
                                totalQuestions,
                                " (",
                                calculateProgressPercentage(),
                                "%)"
                            ]
                        })
                    ]
                }),
                errorMessage && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "error-message",
                    children: errorMessage
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questions-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Are you experiencing production delays due to technical problems?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Are you experiencing production delays due to technical problems?", "Yes"),
                                            className: `btn-option ${selectedOptions["Are you experiencing production delays due to technical problems?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Are you experiencing production delays due to technical problems?", "No"),
                                            className: `btn-option ${selectedOptions["Are you experiencing production delays due to technical problems?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Have measures been put in place to avoid these inconveniences?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Have measures been put in place to avoid these inconveniences?", "Yes"),
                                            className: `btn-option ${selectedOptions["Have measures been put in place to avoid these inconveniences?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Have measures been put in place to avoid these inconveniences?", "No"),
                                            className: `btn-option ${selectedOptions["Have measures been put in place to avoid these inconveniences?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Are you experiencing delays in product (or service) delivery to your customers?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Are you experiencing delays in product (or service) delivery to your customers?", "Yes"),
                                            className: `btn-option ${selectedOptions["Are you experiencing delays in product (or service) delivery to your customers?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Are you experiencing delays in product (or service) delivery to your customers?", "No"),
                                            className: `btn-option ${selectedOptions["Are you experiencing delays in product (or service) delivery to your customers?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have shipping delay problems when delivering to your customers?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have shipping delay problems when delivering to your customers?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have shipping delay problems when delivering to your customers?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have shipping delay problems when delivering to your customers?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have shipping delay problems when delivering to your customers?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you feel that your customers are satisfied with your delivery times?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you feel that your customers are satisfied with your delivery times?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you feel that your customers are satisfied with your delivery times?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you feel that your customers are satisfied with your delivery times?", "No"),
                                            className: `btn-option ${selectedOptions["Do you feel that your customers are satisfied with your delivery times?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Are your customers accepting of your delivery times?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Are your customers accepting of your delivery times?", "Yes"),
                                            className: `btn-option ${selectedOptions["Are your customers accepting of your delivery times?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Are your customers accepting of your delivery times?", "No"),
                                            className: `btn-option ${selectedOptions["Are your customers accepting of your delivery times?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "form-actions",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/lead-time-1_",
                            className: "btn-secondary",
                            children: "Back"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "btn-primary",
                            children: "Submit Lead Time Assessment"
                        })
                    ]
                }),
                isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "loading-indicator",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "spinner"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: "Saving data and generating PDF..."
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = LeadTime2_;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["Link","b9X5n"],["useHistory","ditZI"]],"../NavItems3":"fOarC","../NavItems2":"bnQuI","./LeadTime2_.css":"4uQJF","../../styleguide.css":"8Y7Ec","jspdf":"hkJ4Q","../LeadTime1_":"eH8qo","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4uQJF":[function() {},{}],"8Y7Ec":[function() {},{}],"eH8qo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "l_allData1", ()=>l_allData1);
parcelHelpers.export(exports, "l_yesCount1", ()=>l_yesCount1);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _leadTime1Css = require("./LeadTime1_.css");
var _styleguideCss = require("../../styleguide.css");
let l_allData1 = [];
let l_yesCount1 = 0;
function LeadTime1_(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const { x1200PxLogo_Icam__20081, navItems3Props } = props;
    (0, _react.useEffect)(()=>{
        // Calculate the total number of questions based on sections
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []); // Run this effect only once when the component mounts
    function clicked(question, option) {
        // Si l'option cliquée est la màªme que celle déjà  sélectionnée, on la désélectionne
        if (selectedOptions[question] === option) {
            setSelectedOptions((prevSelectedOptions)=>{
                const newOptions = {
                    ...prevSelectedOptions
                };
                delete newOptions[question];
                return newOptions;
            });
            // Si on désélectionne un "Yes", on décrémente le score
            if (option === "Yes") l_yesCount1--;
            return;
        }
        // Sinon, on met à  jour la sélection
        const previousOption = selectedOptions[question];
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        // Si on passe de "No" à  "Yes", on incrémente le score
        if (option === "Yes" && previousOption !== "Yes") l_yesCount1++;
        else if (option === "No" && previousOption === "Yes") l_yesCount1--;
    }
    const history = (0, _reactRouterDom.useHistory)();
    function saveData() {
        setIsLoading(true);
        setErrorMessage("");
        console.log("D\xe9but de sauvegarde des donn\xe9es LeadTime1");
        const enterpriseId = localStorage.getItem("enterpriseId");
        const userId = localStorage.getItem("userId");
        if (!enterpriseId) {
            console.error("ERREUR: ID d'entreprise manquant");
            setErrorMessage("ID d'entreprise manquant. Veuillez retourner \xe0\xa0 la s\xe9lection d'entreprise.");
            setIsLoading(false);
            return;
        }
        // Définir toutes les questions possibles
        const allQuestions = [
            "Do you have a delay rate?",
            "If so, how much is it?",
            "What are the causes of the delay?",
            "What is the average lead time in days?",
            "Are your lead times documented (process mapping)?",
            "Do you have systems to manage and monitor lead time?",
            "Is lead time a KPI for you?",
            "Do you have an on-time delivery rate?",
            "Do you have a standard lead time (Takt time)?"
        ];
        // Créer un tableau de questions/réponses pour toutes les questions
        const data = allQuestions.map((question)=>{
            const answer = selectedOptions[question] || "No";
            return {
                question: question,
                answer: answer,
                category: "leadTime",
                enterpriseId: enterpriseId,
                userId: userId || "",
                section: "leadtime-1",
                timestamp: new Date().toISOString()
            };
        });
        // Vérifier que les données sont correctement formatées
        const isValidData = data.every((item)=>item.question && item.answer && item.category && item.enterpriseId);
        if (!isValidData) {
            console.error("Donn\xe9es invalides:", data);
            setErrorMessage("Format de donn\xe9es invalide");
            setIsLoading(false);
            return;
        }
        // Sauvegarder les données pour une utilisation ultérieure
        l_allData1 = [
            ...data
        ];
        console.log("Donn\xe9es \xe0\xa0 envoyer:", JSON.stringify(data, null, 2));
        // Appel API pour sauvegarder les données
        fetch("/api/api/save-evaluation", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
            },
            body: JSON.stringify(data)
        }).then((response)=>{
            if (!response.ok) throw new Error(`Erreur de sauvegarde (${response.status})`);
            return response.json();
        }).then((result)=>{
            console.log("Data saved successfully:", result);
            // Sauvegarder le score dans le localStorage
            localStorage.setItem('leadTime1Score', l_yesCount1);
            console.log(`Score leadTime1 mis \xe0\xa0 jour: ${l_yesCount1}`);
            setIsLoading(false);
            history.push("/lead-time-2_");
        }).catch((error)=>{
            console.error("Error saving data:", error);
            setErrorMessage("Error saving data. Please try again.");
            console.error("D\xe9tails de l'erreur:", error.message);
            setIsLoading(false);
            history.push("/lead-time-2_");
        });
    }
    function calculateProgressPercentage() {
        const totalQuestions = document.getElementsByTagName("section").length;
        if (totalQuestions === 0) return 0;
        return Math.round(l_yesCount1 / totalQuestions * 100);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "environmental-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "environmental-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    className: "environmental-title",
                    children: "PLEASE ANSWER THE FOLLOWING QUESTIONS"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "progress-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "progress-bar",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "progress-fill",
                                style: {
                                    width: `${calculateProgressPercentage()}%`
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "progress-text",
                            children: [
                                "Your score: ",
                                l_yesCount1,
                                " / ",
                                totalQuestions,
                                " (",
                                calculateProgressPercentage(),
                                "%)"
                            ]
                        })
                    ]
                }),
                errorMessage && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "error-message",
                    children: errorMessage
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questions-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have a delay rate?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a delay rate?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have a delay rate?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a delay rate?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have a delay rate?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "If so, how much is it?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("If so, how much is it?", "Yes"),
                                            className: `btn-option ${selectedOptions["If so, how much is it?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("If so, how much is it?", "No"),
                                            className: `btn-option ${selectedOptions["If so, how much is it?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Can your suppliers be flexible to your demand?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Can your suppliers be flexible to your demand?", "Yes"),
                                            className: `btn-option ${selectedOptions["Can your suppliers be flexible to your demand?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Can your suppliers be flexible to your demand?", "No"),
                                            className: `btn-option ${selectedOptions["Can your suppliers be flexible to your demand?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "If not, can you change suppliers quickly if the supplier does not meet your expectations?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("If not, can you change suppliers quickly if the supplier does not meet your expectations?", "Yes"),
                                            className: `btn-option ${selectedOptions["If not, can you change suppliers quickly if the supplier does not meet your expectations?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("If not, can you change suppliers quickly if the supplier does not meet your expectations?", "No"),
                                            className: `btn-option ${selectedOptions["If not, can you change suppliers quickly if the supplier does not meet your expectations?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "If no, can you change suppliers quickly if the supplier does not meet your expectations?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("If no, can you change suppliers quickly if the supplier does not meet your expectations?", "Yes"),
                                            className: `btn-option ${selectedOptions["If no, can you change suppliers quickly if the supplier does not meet your expectations?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("If no, can you change suppliers quickly if the supplier does not meet your expectations?", "No"),
                                            className: `btn-option ${selectedOptions["If no, can you change suppliers quickly if the supplier does not meet your expectations?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have calculation methods for making purchase forecasts?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have calculation methods for making purchase forecasts?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have calculation methods for making purchase forecasts?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have calculation methods for making purchase forecasts?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have calculation methods for making purchase forecasts?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have a safety stock?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a safety stock?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have a safety stock?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a safety stock?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have a safety stock?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have buffer stocks?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have buffer stocks?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have buffer stocks?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have buffer stocks?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have buffer stocks?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "form-actions",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/modernization-4_",
                            className: "btn-secondary",
                            children: "Back"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "btn-primary",
                            children: "Next"
                        })
                    ]
                }),
                isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "loading-indicator",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "spinner"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: "Saving data..."
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = LeadTime1_;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["Link","b9X5n"],["useHistory","ditZI"]],"../NavItems3":"fOarC","../NavItems2":"bnQuI","./LeadTime1_.css":"gpRTU","../../styleguide.css":"8Y7Ec","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gpRTU":[function() {},{}],"8Y7Ec":[function() {},{}],"cEV7C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "c_allData2", ()=>c_allData2);
parcelHelpers.export(exports, "c_yesCount2", ()=>c_yesCount2);
parcelHelpers.export(exports, "c_sum", ()=>c_sum);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _cost2Css = require("./Cost2_.css");
var _styleguideCss = require("../../styleguide.css");
var _jspdf = require("jspdf");
var _jspdfDefault = parcelHelpers.interopDefault(_jspdf);
var _cost1 = require("../Cost1_");
let c_allData2 = [];
let c_yesCount2 = 0;
let c_sum = 0;
function Cost2_(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const { x1200PxLogo_Icac__20081, qualityCriteria } = props;
    (0, _react.useEffect)(()=>{
        // Calculate the total number of questions based on sections
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []); // Run this effect only once when the component mounts
    function clicked(question, option) {
        // Si l'option cliquée est la màªme que celle déjà  sélectionnée, on la désélectionne
        if (selectedOptions[question] === option) {
            setSelectedOptions((prevSelectedOptions)=>{
                const newOptions = {
                    ...prevSelectedOptions
                };
                delete newOptions[question];
                return newOptions;
            });
            // Si on désélectionne un "Yes", on décrémente le score
            if (option === "Yes") c_yesCount2--;
            return;
        }
        // Sinon, on met à  jour la sélection
        const previousOption = selectedOptions[question];
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        // Si on passe de "No" à  "Yes", on incrémente le score
        if (option === "Yes" && previousOption !== "Yes") c_yesCount2++;
        else if (option === "No" && previousOption === "Yes") c_yesCount2--;
    }
    const history = (0, _reactRouterDom.useHistory)();
    function saveData() {
        setIsLoading(true);
        setErrorMessage("");
        console.log("D\xe9but de sauvegarde des donn\xe9es Cost2");
        const enterpriseId = localStorage.getItem("enterpriseId");
        const userId = localStorage.getItem("userId");
        if (!enterpriseId) {
            console.error("ERREUR: ID d'entreprise manquant");
            setErrorMessage("ID d'entreprise manquant. Veuillez retourner \xe0\xa0 la s\xe9lection d'entreprise.");
            setIsLoading(false);
            return;
        }
        // Définir toutes les questions possibles
        const allQuestions = [
            "Do you have a method to calculate production costs?",
            "Do you have a method of analysis for the costs of non-quality?",
            "Do you monitor your obsolete inventory?",
            "Have you identified your costs that do not add value to your product?",
            "Do you have a method of assessing supply chain cost risks?",
            "Do you measure the cost of shipping materials?",
            "Do you know the cost of capital employed?",
            "Do you know your employee productivity rates and costs for each operation?",
            "Do you have a budget system (annual or multi-year)?"
        ];
        // Créer un tableau de questions/réponses pour toutes les questions
        const data = allQuestions.map((question)=>{
            const answer = selectedOptions[question] || "No";
            return {
                question: question,
                answer: answer,
                category: "cost",
                enterpriseId: enterpriseId,
                userId: userId || "",
                section: "cost-2",
                timestamp: new Date().toISOString()
            };
        });
        // Vérifier que les données sont correctement formatées
        const isValidData = data.every((item)=>item.question && item.answer && item.category && item.enterpriseId);
        if (!isValidData) {
            console.error("Donn\xe9es invalides:", data);
            setErrorMessage("Format de donn\xe9es invalide");
            setIsLoading(false);
            return;
        }
        // Sauvegarder les données pour une utilisation ultérieure
        c_allData2 = [
            ...data
        ];
        console.log("Donn\xe9es \xe0\xa0 envoyer:", JSON.stringify(data, null, 2));
        // Calculer la somme des scores Cost1 et Cost2
        const cost1Score = parseInt(localStorage.getItem('cost1Score') || 0);
        c_sum = cost1Score + c_yesCount2;
        console.log("Score total Cost:", c_sum);
        // Appel API pour sauvegarder les données
        fetch("/api/api/save-evaluation", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
            },
            body: JSON.stringify(data)
        }).then((response)=>{
            if (!response.ok) throw new Error(`Erreur de sauvegarde (${response.status})`);
            return response.json();
        }).then((result)=>{
            console.log("Data saved successfully:", result);
            // Sauvegarder le score dans le localStorage
            localStorage.setItem('cost2Score', c_yesCount2);
            console.log(`Score cost2 mis \xe0\xa0 jour: ${c_yesCount2}`);
            // Sauvegarder également le score total cost
            const scoreData = [
                {
                    question: "Cost Total Score Final",
                    answer: c_sum.toString(),
                    category: "cost",
                    enterpriseId: enterpriseId,
                    userId: userId || "",
                    section: "cost-total-final",
                    timestamp: new Date().toISOString()
                }
            ];
            console.log("Envoi du score total cost:", JSON.stringify(scoreData, null, 2));
            // Appel API pour sauvegarder le score total
            return fetch("/api/api/save-answers", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
                },
                body: JSON.stringify(scoreData)
            });
        }).then((response)=>{
            if (!response || !response.ok) throw new Error("Failed to save total score");
            return response.json();
        }).then((scoreResponse)=>{
            console.log("Score total cost enregistr\xe9 avec succ\xe8s:", scoreResponse);
            // Récupérer correctement les données de tous les composants
            const allCostData = [];
            // Utiliser des try/catch pour éviter les erreurs si certaines données sont manquantes
            try {
                if (Array.isArray((0, _cost1.c_allData1)) && (0, _cost1.c_allData1).length > 0) allCostData.push(...(0, _cost1.c_allData1));
                if (Array.isArray(c_allData2) && c_allData2.length > 0) allCostData.push(...c_allData2);
            } catch (error) {
                console.error("Erreur lors de la concat\xe9nation des donn\xe9es:", error);
            }
            console.log("Toutes les donn\xe9es Cost pour le PDF:", allCostData.length, "questions");
            // Générer le PDF avec toutes les données
            generatePdf(allCostData);
            // Redirection vers la page suivante
            setIsLoading(false);
            history.push("/Quality-1_");
        }).catch((error)=>{
            console.error("Error saving data:", error);
            setErrorMessage("Error saving data. Please try again.");
            console.error("D\xe9tails de l'erreur:", error.message);
            // Màªme en cas d'erreur, essayer de générer le PDF avec les données disponibles
            const allCostData = [];
            try {
                if (Array.isArray((0, _cost1.c_allData1)) && (0, _cost1.c_allData1).length > 0) allCostData.push(...(0, _cost1.c_allData1));
                if (Array.isArray(c_allData2) && c_allData2.length > 0) allCostData.push(...c_allData2);
            } catch (error) {
                console.error("Erreur lors de la concat\xe9nation des donn\xe9es:", error);
            }
            generatePdf(allCostData);
            // Redirection malgré l'erreur
            setIsLoading(false);
            history.push("/Quality-1_");
        });
    }
    function generatePdf(allData) {
        // Vérifier si des données existent
        if (!allData || allData.length === 0) {
            console.error("Aucune donn\xe9e disponible pour g\xe9n\xe9rer le PDF");
            return;
        }
        console.log("G\xe9n\xe9ration du PDF avec", allData.length, "questions");
        // Créer un nouveau document PDF
        const doc = new (0, _jspdfDefault.default)();
        const lineHeight = 10;
        const pageHeight = doc.internal.pageSize.height - 20;
        const pageWidth = doc.internal.pageSize.width - 20;
        let y = 20;
        // Ajouter un titre
        doc.setFontSize(16);
        doc.text("Cost Assessment Results", 105, y, {
            align: "center"
        });
        y += 15;
        // Ajouter le score total
        doc.setFontSize(14);
        doc.text(`Total Score: ${c_sum} / ${allData.length}`, 105, y, {
            align: "center"
        });
        y += 15;
        doc.setFontSize(12);
        // Parcourir les données et ajouter chaque question et réponse au document PDF
        allData.forEach((data, index)=>{
            // Vérifier si les données sont valides
            if (!data || !data.question) {
                console.error("Donn\xe9es invalides pour l'\xe9l\xe9ment", index);
                return;
            }
            const question = `Question ${index + 1}: ${data.question}`;
            const answer = `Answer: ${data.answer || 'No answer'}`;
            // Estimer la hauteur du texte après division pour mieux gérer les sauts de page
            const splitQuestion = doc.splitTextToSize(question, pageWidth);
            const estimatedHeight = splitQuestion.length * lineHeight + lineHeight * 2;
            // Vérifier si on doit passer à  une nouvelle page
            if (y + estimatedHeight > pageHeight) {
                doc.addPage();
                y = 20;
            }
            // à‰crire la question et la réponse dans le PDF
            doc.text(splitQuestion, 10, y);
            y += splitQuestion.length * lineHeight;
            doc.text(answer, 10, y);
            y += lineHeight * 2; // Ajouter un peu d'espace entre les questions
        });
        // Ajouter une page de résumé
        doc.addPage();
        y = 20;
        doc.setFontSize(16);
        doc.text("Summary of Cost Assessment", 105, y, {
            align: "center"
        });
        y += 20;
        doc.setFontSize(12);
        doc.text(`Total number of questions: ${allData.length}`, 10, y);
        y += lineHeight;
        doc.text(`Total "Yes" answers: ${c_sum}`, 10, y);
        y += lineHeight;
        doc.text(`Score percentage: ${Math.round(c_sum / allData.length * 100)}%`, 10, y);
        y += lineHeight * 2;
        const date = new Date();
        doc.text(`Generated on: ${date.toLocaleDateString()} at ${date.toLocaleTimeString()}`, 10, y);
        // Enregistrer le document PDF
        doc.save("Cost_Assessment_Complete.pdf");
        console.log("PDF Cost g\xe9n\xe9r\xe9 avec succ\xe8s");
    }
    function calculateProgressPercentage() {
        if (totalQuestions === 0) return 0;
        return Math.round(c_yesCount2 / totalQuestions * 100);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "environmental-container",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("app-header", {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "environmental-content",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                        className: "environmental-title",
                        children: "COST ASSESSMENT - PART 2"
                    }),
                    errorMessage && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "error-message",
                        children: errorMessage
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "progress-container",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "progress-bar",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "progress-fill",
                                    style: {
                                        width: `${calculateProgressPercentage()}%`
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                className: "progress-text",
                                children: [
                                    "Your score: ",
                                    c_yesCount2,
                                    " / ",
                                    totalQuestions,
                                    " (",
                                    calculateProgressPercentage(),
                                    "%)"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "questions-container",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                className: "question-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "question-text",
                                        children: "Do you have a budget for machine maintenance?"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "question-actions",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>clicked("Do you have a budget for machine maintenance?", "Yes"),
                                                className: `btn-option ${selectedOptions["Do you have a budget for machine maintenance?"] === "Yes" ? "enabled" : ""}`,
                                                children: "Yes"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>clicked("Do you have a budget for machine maintenance?", "No"),
                                                className: `btn-option ${selectedOptions["Do you have a budget for machine maintenance?"] === "No" ? "enabled" : ""}`,
                                                children: "No"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                className: "question-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "question-text",
                                        children: "Have you defined a budget for external services?"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "question-actions",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>clicked("Have you defined a budget for external services?", "Yes"),
                                                className: `btn-option ${selectedOptions["Have you defined a budget for external services?"] === "Yes" ? "enabled" : ""}`,
                                                children: "Yes"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>clicked("Have you defined a budget for external services?", "No"),
                                                className: `btn-option ${selectedOptions["Have you defined a budget for external services?"] === "No" ? "enabled" : ""}`,
                                                children: "No"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                className: "question-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "question-text",
                                        children: "Do you have different suppliers?"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "question-actions",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>clicked("Do you have different suppliers?", "Yes"),
                                                className: `btn-option ${selectedOptions["Do you have different suppliers?"] === "Yes" ? "enabled" : ""}`,
                                                children: "Yes"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>clicked("Do you have different suppliers?", "No"),
                                                className: `btn-option ${selectedOptions["Do you have different suppliers?"] === "No" ? "enabled" : ""}`,
                                                children: "No"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                className: "question-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "question-text",
                                        children: "Are you able to change suppliers depending on prices?"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "question-actions",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>clicked("Are you able to change suppliers depending on prices?", "Yes"),
                                                className: `btn-option ${selectedOptions["Are you able to change suppliers depending on prices?"] === "Yes" ? "enabled" : ""}`,
                                                children: "Yes"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>clicked("Are you able to change suppliers depending on prices?", "No"),
                                                className: `btn-option ${selectedOptions["Are you able to change suppliers depending on prices?"] === "No" ? "enabled" : ""}`,
                                                children: "No"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                className: "question-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "question-text",
                                        children: "Do you control your transport costs?"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "question-actions",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>clicked("Do you control your transport costs?", "Yes"),
                                                className: `btn-option ${selectedOptions["Do you control your transport costs?"] === "Yes" ? "enabled" : ""}`,
                                                children: "Yes"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>clicked("Do you control your transport costs?", "No"),
                                                className: `btn-option ${selectedOptions["Do you control your transport costs?"] === "No" ? "enabled" : ""}`,
                                                children: "No"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                className: "question-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "question-text",
                                        children: "Do you know the price of the product excluding raw materials?"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "question-actions",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>clicked("Do you know the price of the product excluding raw materials?", "Yes"),
                                                className: `btn-option ${selectedOptions["Do you know the price of the product excluding raw materials?"] === "Yes" ? "enabled" : ""}`,
                                                children: "Yes"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>clicked("Do you know the price of the product excluding raw materials?", "No"),
                                                className: `btn-option ${selectedOptions["Do you know the price of the product excluding raw materials?"] === "No" ? "enabled" : ""}`,
                                                children: "No"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                className: "question-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "question-text",
                                        children: "Do you know the economic losses linked to the non-conforming product (disquality)?"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "question-actions",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>clicked("Do you know the economic losses linked to the non-conforming product (disquality)?", "Yes"),
                                                className: `btn-option ${selectedOptions["Do you know the economic losses linked to the non-conforming product (disquality)?"] === "Yes" ? "enabled" : ""}`,
                                                children: "Yes"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>clicked("Do you know the economic losses linked to the non-conforming product (disquality)?", "No"),
                                                className: `btn-option ${selectedOptions["Do you know the economic losses linked to the non-conforming product (disquality)?"] === "No" ? "enabled" : ""}`,
                                                children: "No"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                className: "question-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "question-text",
                                        children: 'Do you plan a budget for non-voluntary "breakage"?'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "question-actions",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>clicked("Do you plan a budget for non-voluntary \"breakage\"?", "Yes"),
                                                className: `btn-option ${selectedOptions["Do you plan a budget for non-voluntary \"breakage\"?"] === "Yes" ? "enabled" : ""}`,
                                                children: "Yes"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>clicked("Do you plan a budget for non-voluntary \"breakage\"?", "No"),
                                                className: `btn-option ${selectedOptions["Do you plan a budget for non-voluntary \"breakage\"?"] === "No" ? "enabled" : ""}`,
                                                children: "No"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                className: "question-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "question-text",
                                        children: "Do you know your optimal quantity of product to be profitable?"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "question-actions",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>clicked("Do you know your optimal quantity of product to be profitable?", "Yes"),
                                                className: `btn-option ${selectedOptions["Do you know your optimal quantity of product to be profitable?"] === "Yes" ? "enabled" : ""}`,
                                                children: "Yes"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>clicked("Do you know your optimal quantity of product to be profitable?", "No"),
                                                className: `btn-option ${selectedOptions["Do you know your optimal quantity of product to be profitable?"] === "No" ? "enabled" : ""}`,
                                                children: "No"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "form-actions",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                to: "/cost-1_",
                                className: "btn-secondary",
                                children: "Back"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                onClick: saveData,
                                className: "btn-primary",
                                children: qualityCriteria || "Continue to Next Section"
                            })
                        ]
                    })
                ]
            }),
            isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "loading-indicator",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "spinner"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "Saving data and generating PDF..."
                    })
                ]
            })
        ]
    });
}
exports.default = Cost2_;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["Link","b9X5n"],["useHistory","ditZI"]],"./Cost2_.css":"c5oBq","../../styleguide.css":"8Y7Ec","jspdf":"hkJ4Q","../Cost1_":"fIT9W","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"c5oBq":[function() {},{}],"8Y7Ec":[function() {},{}],"fIT9W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "c_allData1", ()=>c_allData1);
parcelHelpers.export(exports, "c_yesCount1", ()=>c_yesCount1);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _frame136 = require("../Frame136");
var _frame136Default = parcelHelpers.interopDefault(_frame136);
var _frame144 = require("../Frame144");
var _frame144Default = parcelHelpers.interopDefault(_frame144);
var _frame11732 = require("../Frame11732");
var _frame11732Default = parcelHelpers.interopDefault(_frame11732);
var _cost1Css = require("./Cost1_.css");
var _styleguideCss = require("../../styleguide.css");
let c_allData1 = [];
let c_yesCount1 = 0;
function Cost1_(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const { x1200PxLogo_Icam__20081, pleaseAnswerTheFollowingQuestions, toggle1Props, toggle2Props, toggle3Props, toggle4Props } = props;
    (0, _react.useEffect)(()=>{
        // Calculate the total number of questions based on sections
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []); // Run this effect only once when the component mounts
    function clicked(question, option) {
        // Si l'option cliquée est la màªme que celle déjà  sélectionnée, on la désélectionne
        if (selectedOptions[question] === option) {
            setSelectedOptions((prevSelectedOptions)=>{
                const newOptions = {
                    ...prevSelectedOptions
                };
                delete newOptions[question];
                return newOptions;
            });
            // Si on désélectionne un "Yes", on décrémente le score
            if (option === "Yes") c_yesCount1--;
            return;
        }
        // Sinon, on met à  jour la sélection
        const previousOption = selectedOptions[question];
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        // Si on passe de "No" à  "Yes", on incrémente le score
        if (option === "Yes" && previousOption !== "Yes") c_yesCount1++;
        else if (option === "No" && previousOption === "Yes") c_yesCount1--;
    }
    const history = (0, _reactRouterDom.useHistory)();
    function saveData() {
        setIsLoading(true);
        setErrorMessage("");
        console.log("D\xe9but de sauvegarde des donn\xe9es Cost1");
        const enterpriseId = localStorage.getItem("enterpriseId");
        const userId = localStorage.getItem("userId");
        if (!enterpriseId) {
            console.error("ERREUR: ID d'entreprise manquant");
            setErrorMessage("ID d'entreprise manquant. Veuillez retourner \xe0\xa0 la s\xe9lection d'entreprise.");
            setIsLoading(false);
            return;
        }
        // Définir toutes les questions possibles
        const allQuestions = [
            "Do you have a follow-up of raw materials, stocks... (ex: ERP)?",
            "Do you have a current average cost price?",
            "Do you have a margin calculation?",
            "Do you have a material replenishment system?",
            "Do you have dedicated resources who are responsible for purchasing and managing inventory?",
            "Do you have a method of receiving orders and forecasts from your customers?",
            "Do you have a specific system to monitor profitability?",
            "Do you have defined KPIs for cost efficiency?",
            "Do you carry out periodic stock inventory control?"
        ];
        // Créer un tableau de questions/réponses pour toutes les questions
        const data = allQuestions.map((question)=>{
            const answer = selectedOptions[question] || "No";
            return {
                question: question,
                answer: answer,
                category: "cost",
                enterpriseId: enterpriseId,
                userId: userId || "",
                section: "cost-1",
                timestamp: new Date().toISOString()
            };
        });
        // Vérifier que les données sont correctement formatées
        const isValidData = data.every((item)=>item.question && item.answer && item.category && item.enterpriseId);
        if (!isValidData) {
            console.error("Donn\xe9es invalides:", data);
            setErrorMessage("Format de donn\xe9es invalide");
            setIsLoading(false);
            return;
        }
        // Sauvegarder les données pour une utilisation ultérieure
        c_allData1 = [
            ...data
        ];
        console.log("Donn\xe9es \xe0\xa0 envoyer:", JSON.stringify(data, null, 2));
        // Appel API pour sauvegarder les données
        fetch("/api/api/save-evaluation", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
            },
            body: JSON.stringify(data)
        }).then((response)=>{
            if (!response.ok) throw new Error(`Erreur de sauvegarde (${response.status})`);
            return response.json();
        }).then((result)=>{
            console.log("Data saved successfully:", result);
            // Sauvegarder le score dans le localStorage
            localStorage.setItem('cost1Score', c_yesCount1);
            console.log(`Score cost1 mis \xe0\xa0 jour: ${c_yesCount1}`);
            setIsLoading(false);
            history.push("/cost-2_");
        }).catch((error)=>{
            console.error("Error saving data:", error);
            setErrorMessage("Error saving data. Please try again.");
            console.error("D\xe9tails de l'erreur:", error.message);
            setIsLoading(false);
            history.push("/cost-2_");
        });
    }
    function calculateProgressPercentage() {
        if (totalQuestions === 0) return 0;
        return Math.round(c_yesCount1 / totalQuestions * 100);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "environmental-container",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("app-header", {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "environmental-content",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                        className: "environmental-title",
                        children: pleaseAnswerTheFollowingQuestions || "COST ASSESSMENT"
                    }),
                    errorMessage && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "error-message",
                        children: errorMessage
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "progress-container",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "progress-bar",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "progress-fill",
                                    style: {
                                        width: `${calculateProgressPercentage()}%`
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                className: "progress-text",
                                children: [
                                    "Your score: ",
                                    c_yesCount1,
                                    " / ",
                                    totalQuestions,
                                    " (",
                                    calculateProgressPercentage(),
                                    "%)"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "questions-container",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                className: "question-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "question-text",
                                        children: "Do you have a follow-up of raw materials, stocks... (ex: ERP)?"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "question-actions",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>clicked("Do you have a follow-up of raw materials, stocks... (ex: ERP)?", "Yes"),
                                                className: `btn-option ${selectedOptions["Do you have a follow-up of raw materials, stocks... (ex: ERP)?"] === "Yes" ? "enabled" : ""}`,
                                                children: "Yes"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>clicked("Do you have a follow-up of raw materials, stocks... (ex: ERP)?", "No"),
                                                className: `btn-option ${selectedOptions["Do you have a follow-up of raw materials, stocks... (ex: ERP)?"] === "No" ? "enabled" : ""}`,
                                                children: "No"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                className: "question-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "question-text",
                                        children: "Do you have a current average cost price?"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "question-actions",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>clicked("Do you have a current average cost price?", "Yes"),
                                                className: `btn-option ${selectedOptions["Do you have a current average cost price?"] === "Yes" ? "enabled" : ""}`,
                                                children: "Yes"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>clicked("Do you have a current average cost price?", "No"),
                                                className: `btn-option ${selectedOptions["Do you have a current average cost price?"] === "No" ? "enabled" : ""}`,
                                                children: "No"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                className: "question-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "question-text",
                                        children: "Are your raw material costs fixed?"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "question-actions",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>clicked("Are your raw material costs fixed?", "Yes"),
                                                className: `btn-option ${selectedOptions["Are your raw material costs fixed?"] === "Yes" ? "enabled" : ""}`,
                                                children: "Yes"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>clicked("Are your raw material costs fixed?", "No"),
                                                className: `btn-option ${selectedOptions["Are your raw material costs fixed?"] === "No" ? "enabled" : ""}`,
                                                children: "No"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                className: "question-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "question-text",
                                        children: "Do you use the FIFO method?"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "question-actions",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>clicked("Do you use the FIFO method?", "Yes"),
                                                className: `btn-option ${selectedOptions["Do you use the FIFO method?"] === "Yes" ? "enabled" : ""}`,
                                                children: "Yes"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>clicked("Do you use the FIFO method?", "No"),
                                                className: `btn-option ${selectedOptions["Do you use the FIFO method?"] === "No" ? "enabled" : ""}`,
                                                children: "No"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                className: "question-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "question-text",
                                        children: "Do you analyse stock data in real time?"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "question-actions",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>clicked("Do you analyse stock data in real time?", "Yes"),
                                                className: `btn-option ${selectedOptions["Do you analyse stock data in real time?"] === "Yes" ? "enabled" : ""}`,
                                                children: "Yes"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>clicked("Do you analyse stock data in real time?", "No"),
                                                className: `btn-option ${selectedOptions["Do you analyse stock data in real time?"] === "No" ? "enabled" : ""}`,
                                                children: "No"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                className: "question-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "question-text",
                                        children: "Do you have a rounding stock system to make the most of the space?"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "question-actions",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>clicked("Do you have a rounding stock system to make the most of the space?", "Yes"),
                                                className: `btn-option ${selectedOptions["Do you have a rounding stock system to make the most of the space?"] === "Yes" ? "enabled" : ""}`,
                                                children: "Yes"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>clicked("Do you have a rounding stock system to make the most of the space?", "No"),
                                                className: `btn-option ${selectedOptions["Do you have a rounding stock system to make the most of the space?"] === "No" ? "enabled" : ""}`,
                                                children: "No"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                className: "question-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "question-text",
                                        children: "In case of shortage, do you have a safety stock?"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "question-actions",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>clicked("In case of shortage, do you have a safety stock?", "Yes"),
                                                className: `btn-option ${selectedOptions["In case of shortage, do you have a safety stock?"] === "Yes" ? "enabled" : ""}`,
                                                children: "Yes"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>clicked("In case of shortage, do you have a safety stock?", "No"),
                                                className: `btn-option ${selectedOptions["In case of shortage, do you have a safety stock?"] === "No" ? "enabled" : ""}`,
                                                children: "No"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                className: "question-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "question-text",
                                        children: "Calculation of the cost of the stock?"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "question-actions",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>clicked("Calculation of the cost of the stock?", "Yes"),
                                                className: `btn-option ${selectedOptions["Calculation of the cost of the stock?"] === "Yes" ? "enabled" : ""}`,
                                                children: "Yes"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>clicked("Calculation of the cost of the stock?", "No"),
                                                className: `btn-option ${selectedOptions["Calculation of the cost of the stock?"] === "No" ? "enabled" : ""}`,
                                                children: "No"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "form-actions",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                to: "/lead-time-2_",
                                className: "btn-secondary",
                                children: "Back"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                onClick: saveData,
                                className: "btn-primary",
                                children: "Continue to Next Section"
                            })
                        ]
                    }),
                    isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "loading-indicator",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "spinner"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                children: "Saving data..."
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
exports.default = Cost1_;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["Link","b9X5n"],["useHistory","ditZI"]],"../Toggle":"dSqDu","../Frame136":"6Kf28","../Frame144":"3hDtN","../Frame11732":"gSRJf","./Cost1_.css":"58vwR","../../styleguide.css":"8Y7Ec","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"58vwR":[function() {},{}],"8Y7Ec":[function() {},{}],"2MHU2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "q_sum", ()=>q_sum);
parcelHelpers.export(exports, "q_allData6", ()=>q_allData6);
parcelHelpers.export(exports, "q_yesCount6", ()=>q_yesCount6);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _quality6Css = require("./Quality6_.css");
var _styleguideCss = require("../../styleguide.css");
var _jspdf = require("jspdf");
var _jspdfDefault = parcelHelpers.interopDefault(_jspdf);
var _quality1 = require("../Quality1_");
var _quality2 = require("../Quality2_");
var _quality3 = require("../Quality3_");
var _quality4 = require("../Quality4_");
var _quality5 = require("../Quality5_");
let q_sum = 0;
let q_allData6 = [];
let q_yesCount6 = 0;
function Quality6_(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const { x1200PxLogo_Icam__20081, navItems3Props } = props;
    (0, _react.useEffect)(()=>{
        // Calculate the total number of questions based on sections
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []); // Run this effect only once when the component mounts
    function clicked(question, option) {
        // Si l'option cliquée est la màªme que celle déjà  sélectionnée, on la désélectionne
        if (selectedOptions[question] === option) {
            setSelectedOptions((prevSelectedOptions)=>{
                const newOptions = {
                    ...prevSelectedOptions
                };
                delete newOptions[question];
                return newOptions;
            });
            // Si on désélectionne un "Yes", on décrémente le score
            if (option === "Yes") q_yesCount6--;
            return;
        }
        // Sinon, on met à  jour la sélection
        const previousOption = selectedOptions[question];
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        // Si on passe de "No" à  "Yes", on incrémente le score
        if (option === "Yes" && previousOption !== "Yes") q_yesCount6++;
        else if (option === "No" && previousOption === "Yes") q_yesCount6--;
    }
    const history = (0, _reactRouterDom.useHistory)();
    function saveData() {
        setIsLoading(true);
        setErrorMessage("");
        console.log("D\xe9but de sauvegarde des donn\xe9es Quality6");
        const enterpriseId = localStorage.getItem("enterpriseId");
        const userId = localStorage.getItem("userId");
        if (!enterpriseId) {
            console.error("ERREUR: ID d'entreprise manquant");
            setErrorMessage("ID d'entreprise manquant. Veuillez retourner \xe0\xa0 la s\xe9lection d'entreprise.");
            setIsLoading(false);
            return;
        }
        // Définir toutes les questions possibles
        const allQuestions = [
            "Do you have a policy to evaluate, select, monitor supplier performance and their re-evaluation?",
            "Is this policy available in digital form?",
            "Do you periodically track supplier performance against measurable objectives and targets?",
            "Do suppliers receive performance feedback on a regular basis?",
            "Do you have corrective action plan in place for suppliers who aren't achieving performance objectives?",
            "Are the decision-makers made aware of this supplier performance assessment?",
            "Is it used to make decisions?",
            "Do you have a system for managing supplier contracts?",
            "Do you ensure your suppliers comply with all relevant governmental requirements?"
        ];
        // Créer un tableau de questions/réponses pour toutes les questions
        const data = allQuestions.map((question)=>{
            const answer = selectedOptions[question] || "No";
            return {
                question: question,
                answer: answer,
                category: "quality",
                enterpriseId: enterpriseId,
                userId: userId || "",
                section: "quality-6",
                timestamp: new Date().toISOString()
            };
        });
        // Vérifier que les données sont correctement formatées
        const isValidData = data.every((item)=>item.question && item.answer && item.category && item.enterpriseId);
        if (!isValidData) {
            console.error("Donn\xe9es invalides:", data);
            setErrorMessage("Format de donn\xe9es invalide");
            setIsLoading(false);
            return;
        }
        // Sauvegarder les données pour une utilisation ultérieure
        q_allData6 = [
            ...data
        ];
        console.log("Donn\xe9es \xe0\xa0 envoyer:", JSON.stringify(data, null, 2));
        // Calculer la somme totale
        q_sum = (0, _quality1.q_yesCount1) + (0, _quality2.q_yesCount2) + (0, _quality3.q_yesCount3) + (0, _quality4.q_yesCount4) + (0, _quality5.q_yesCount5) + q_yesCount6;
        console.log("Score total Quality:", q_sum);
        // Appel API pour sauvegarder les données
        fetch("/api/api/save-evaluation", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
            },
            body: JSON.stringify(data)
        }).then((response)=>{
            if (!response.ok) throw new Error(`Erreur de sauvegarde (${response.status})`);
            return response.json();
        }).then((result)=>{
            console.log("Data saved successfully:", result);
            // Sauvegarder le score dans le localStorage
            localStorage.setItem('quality6Score', q_yesCount6);
            console.log(`Score quality6 mis \xe0\xa0 jour: ${q_yesCount6}`);
            // Sauvegarder également le score total quality
            const scoreData = [
                {
                    question: "Quality Total Score",
                    answer: q_sum.toString(),
                    category: "quality",
                    enterpriseId: enterpriseId,
                    userId: userId || "",
                    section: "quality-total",
                    timestamp: new Date().toISOString()
                }
            ];
            console.log("Envoi du score total quality:", JSON.stringify(scoreData, null, 2));
            // Appel API pour sauvegarder le score total
            return fetch("/api/api/save-evaluation", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
                },
                body: JSON.stringify(scoreData)
            });
        }).then((response)=>{
            if (!response || !response.ok) throw new Error("Failed to save total score");
            return response.json();
        }).then((scoreResponse)=>{
            console.log("Score total quality enregistr\xe9 avec succ\xe8s:", scoreResponse);
            // Récupérer correctement les données de tous les composants
            const allQualityData = [];
            // Utiliser des try/catch pour éviter les erreurs si certaines données sont manquantes
            try {
                if (Array.isArray((0, _quality1.q_allData1)) && (0, _quality1.q_allData1).length > 0) allQualityData.push(...(0, _quality1.q_allData1));
                if (Array.isArray((0, _quality2.q_allData2)) && (0, _quality2.q_allData2).length > 0) allQualityData.push(...(0, _quality2.q_allData2));
                if (Array.isArray((0, _quality3.q_allData3)) && (0, _quality3.q_allData3).length > 0) allQualityData.push(...(0, _quality3.q_allData3));
                if (Array.isArray((0, _quality4.q_allData4)) && (0, _quality4.q_allData4).length > 0) allQualityData.push(...(0, _quality4.q_allData4));
                if (Array.isArray((0, _quality5.q_allData5)) && (0, _quality5.q_allData5).length > 0) allQualityData.push(...(0, _quality5.q_allData5));
                if (Array.isArray(q_allData6) && q_allData6.length > 0) allQualityData.push(...q_allData6);
            } catch (error) {
                console.error("Erreur lors de la concat\xe9nation des donn\xe9es:", error);
            }
            console.log("Toutes les donn\xe9es Quality pour le PDF:", allQualityData.length, "questions");
            // Générer le PDF avec toutes les données
            generatePdf(allQualityData);
            // Redirection vers la page suivante
            setIsLoading(false);
            history.push("/client-consommateur-1_");
        }).catch((error)=>{
            console.error("Error saving data:", error);
            setErrorMessage("Error saving data. Please try again.");
            console.error("D\xe9tails de l'erreur:", error.message);
            // Màªme en cas d'erreur, essayer de générer le PDF avec les données disponibles
            const allQualityData = [];
            try {
                if (Array.isArray((0, _quality1.q_allData1)) && (0, _quality1.q_allData1).length > 0) allQualityData.push(...(0, _quality1.q_allData1));
                if (Array.isArray((0, _quality2.q_allData2)) && (0, _quality2.q_allData2).length > 0) allQualityData.push(...(0, _quality2.q_allData2));
                if (Array.isArray((0, _quality3.q_allData3)) && (0, _quality3.q_allData3).length > 0) allQualityData.push(...(0, _quality3.q_allData3));
                if (Array.isArray((0, _quality4.q_allData4)) && (0, _quality4.q_allData4).length > 0) allQualityData.push(...(0, _quality4.q_allData4));
                if (Array.isArray((0, _quality5.q_allData5)) && (0, _quality5.q_allData5).length > 0) allQualityData.push(...(0, _quality5.q_allData5));
                if (Array.isArray(q_allData6) && q_allData6.length > 0) allQualityData.push(...q_allData6);
            } catch (error) {
                console.error("Erreur lors de la concat\xe9nation des donn\xe9es:", error);
            }
            generatePdf(allQualityData);
            // Redirection malgré l'erreur
            setIsLoading(false);
            history.push("/client-consommateur-1_");
        });
    }
    function generatePdf(q_allData) {
        // Vérifier si des données existent
        if (!q_allData || q_allData.length === 0) {
            console.error("Aucune donn\xe9e disponible pour g\xe9n\xe9rer le PDF");
            return;
        }
        console.log("G\xe9n\xe9ration du PDF avec", q_allData.length, "questions");
        // Créer un nouveau document PDF
        const doc = new (0, _jspdfDefault.default)();
        const lineHeight = 10;
        const pageHeight = doc.internal.pageSize.height - 20;
        const pageWidth = doc.internal.pageSize.width - 20;
        let y = 20;
        // Ajouter un titre
        doc.setFontSize(16);
        doc.text("Quality Assessment Results", 105, y, {
            align: "center"
        });
        y += 15;
        // Ajouter le score total
        doc.setFontSize(14);
        doc.text(`Total Score: ${q_sum} / ${q_allData.length}`, 105, y, {
            align: "center"
        });
        y += 15;
        doc.setFontSize(12);
        // Parcourir les données et ajouter chaque question et réponse au document PDF
        q_allData.forEach((data, index)=>{
            // Vérifier si les données sont valides
            if (!data || !data.question) {
                console.error("Donn\xe9es invalides pour l'\xe9l\xe9ment", index);
                return;
            }
            const question = `Question ${index + 1}: ${data.question}`;
            const answer = `Answer: ${data.answer || 'No answer'}`;
            // Estimer la hauteur du texte après division pour mieux gérer les sauts de page
            const splitQuestion = doc.splitTextToSize(question, pageWidth);
            const estimatedHeight = splitQuestion.length * lineHeight + lineHeight * 2;
            // Vérifier si on doit passer à  une nouvelle page
            if (y + estimatedHeight > pageHeight) {
                doc.addPage();
                y = 20;
            }
            // à‰crire la question et la réponse dans le PDF
            doc.text(splitQuestion, 10, y);
            y += splitQuestion.length * lineHeight;
            doc.text(answer, 10, y);
            y += lineHeight * 2; // Ajouter un peu d'espace entre les questions
        });
        // Ajouter une page de résumé
        doc.addPage();
        y = 20;
        doc.setFontSize(16);
        doc.text("Summary of Quality Assessment", 105, y, {
            align: "center"
        });
        y += 20;
        doc.setFontSize(12);
        doc.text(`Total number of questions: ${q_allData.length}`, 10, y);
        y += lineHeight;
        doc.text(`Total "Yes" answers: ${q_sum}`, 10, y);
        y += lineHeight;
        doc.text(`Score percentage: ${Math.round(q_sum / q_allData.length * 100)}%`, 10, y);
        y += lineHeight * 2;
        // Ajouter des détails par section
        doc.text("Score breakdown by section:", 10, y);
        y += lineHeight;
        const quality1Score = parseInt(localStorage.getItem('quality1Score') || '0');
        const quality2Score = parseInt(localStorage.getItem('quality2Score') || '0');
        const quality3Score = parseInt(localStorage.getItem('quality3Score') || '0');
        const quality4Score = parseInt(localStorage.getItem('quality4Score') || '0');
        const quality5Score = parseInt(localStorage.getItem('quality5Score') || '0');
        const quality6Score = parseInt(localStorage.getItem('quality6Score') || '0');
        doc.text(`Quality Section 1: ${quality1Score}`, 20, y);
        y += lineHeight;
        doc.text(`Quality Section 2: ${quality2Score}`, 20, y);
        y += lineHeight;
        doc.text(`Quality Section 3: ${quality3Score}`, 20, y);
        y += lineHeight;
        doc.text(`Quality Section 4: ${quality4Score}`, 20, y);
        y += lineHeight;
        doc.text(`Quality Section 5: ${quality5Score}`, 20, y);
        y += lineHeight;
        doc.text(`Quality Section 6: ${quality6Score}`, 20, y);
        y += lineHeight * 2;
        const date = new Date();
        doc.text(`Generated on: ${date.toLocaleDateString()} at ${date.toLocaleTimeString()}`, 10, y);
        // Enregistrer le document PDF
        doc.save("Quality_Assessment_Complete.pdf");
        console.log("PDF Quality g\xe9n\xe9r\xe9 avec succ\xe8s");
    }
    function calculateProgressPercentage() {
        const totalQuestions = document.getElementsByTagName("section").length;
        if (totalQuestions === 0) return 0;
        return Math.round(q_yesCount6 / totalQuestions * 100);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "environmental-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "environmental-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    className: "environmental-title",
                    children: "PLEASE ANSWER THE FOLLOWING QUESTIONS"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "progress-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "progress-bar",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "progress-fill",
                                style: {
                                    width: `${calculateProgressPercentage()}%`
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "progress-text",
                            children: [
                                "Your score: ",
                                q_yesCount6,
                                " / ",
                                totalQuestions,
                                " (",
                                calculateProgressPercentage(),
                                "%)"
                            ]
                        })
                    ]
                }),
                errorMessage && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "error-message",
                    children: errorMessage
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questions-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have a quality policy?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a quality policy?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have a quality policy?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a quality policy?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have a quality policy?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Have you developed quality objectives?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Have you developed quality objectives?", "Yes"),
                                            className: `btn-option ${selectedOptions["Have you developed quality objectives?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Have you developed quality objectives?", "No"),
                                            className: `btn-option ${selectedOptions["Have you developed quality objectives?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Is your quality policy appropriate to the purpose of your organization?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Is your quality policy appropriate to the purpose of your organization?", "Yes"),
                                            className: `btn-option ${selectedOptions["Is your quality policy appropriate to the purpose of your organization?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Is your quality policy appropriate to the purpose of your organization?", "No"),
                                            className: `btn-option ${selectedOptions["Is your quality policy appropriate to the purpose of your organization?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Does your quality policy include a commitment to satisfy applicable requirements?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Does your quality policy include a commitment to satisfy applicable requirements?", "Yes"),
                                            className: `btn-option ${selectedOptions["Does your quality policy include a commitment to satisfy applicable requirements?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Does your quality policy include a commitment to satisfy applicable requirements?", "No"),
                                            className: `btn-option ${selectedOptions["Does your quality policy include a commitment to satisfy applicable requirements?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Does your quality policy include a commitment to continual improvement of the QMS?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Does your quality policy include a commitment to continual improvement of the QMS?", "Yes"),
                                            className: `btn-option ${selectedOptions["Does your quality policy include a commitment to continual improvement of the QMS?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Does your quality policy include a commitment to continual improvement of the QMS?", "No"),
                                            className: `btn-option ${selectedOptions["Does your quality policy include a commitment to continual improvement of the QMS?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do the quality objectives take into account the requirements?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do the quality objectives take into account the requirements?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do the quality objectives take into account the requirements?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do the quality objectives take into account the requirements?", "No"),
                                            className: `btn-option ${selectedOptions["Do the quality objectives take into account the requirements?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Are the quality objectives monitored and communicated?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Are the quality objectives monitored and communicated?", "Yes"),
                                            className: `btn-option ${selectedOptions["Are the quality objectives monitored and communicated?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Are the quality objectives monitored and communicated?", "No"),
                                            className: `btn-option ${selectedOptions["Are the quality objectives monitored and communicated?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "form-actions",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/quality-5_",
                            className: "btn-secondary",
                            children: "Back"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "btn-primary",
                            children: "Submit and move to Client/Consommateur"
                        })
                    ]
                }),
                isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "loading-indicator",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "spinner"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: "Saving data and generating PDF..."
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Quality6_;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["Link","b9X5n"],["useHistory","ditZI"]],"../NavItems3":"fOarC","../NavItems2":"bnQuI","./Quality6_.css":"gdG4e","../../styleguide.css":"8Y7Ec","jspdf":"hkJ4Q","../Quality1_":"dcV9a","../Quality2_":"jEnvw","../Quality3_":"ck4So","../Quality4_":"jJhwl","../Quality5_":"82KlE","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gdG4e":[function() {},{}],"8Y7Ec":[function() {},{}],"dcV9a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "q_allData1", ()=>q_allData1);
parcelHelpers.export(exports, "q_yesCount1", ()=>q_yesCount1);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _quality1Css = require("./Quality1_.css");
var _styleguideCss = require("../../styleguide.css");
let q_allData1 = [];
let q_yesCount1 = 0;
function Quality1_(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const { x1200PxLogo_Icam__20081, navItems3Props } = props;
    (0, _react.useEffect)(()=>{
        // Calculate the total number of questions based on sections
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []); // Run this effect only once when the component mounts
    function clicked(question, option) {
        // Si l'option cliquée est la màªme que celle déjà  sélectionnée, on la désélectionne
        if (selectedOptions[question] === option) {
            setSelectedOptions((prevSelectedOptions)=>{
                const newOptions = {
                    ...prevSelectedOptions
                };
                delete newOptions[question];
                return newOptions;
            });
            // Si on désélectionne un "Yes", on décrémente le score
            if (option === "Yes") q_yesCount1--;
            return;
        }
        // Sinon, on met à  jour la sélection
        const previousOption = selectedOptions[question];
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        // Si on passe de "No" à  "Yes", on incrémente le score
        if (option === "Yes" && previousOption !== "Yes") q_yesCount1++;
        else if (option === "No" && previousOption === "Yes") q_yesCount1--;
    }
    const history = (0, _reactRouterDom.useHistory)();
    function saveData() {
        setIsLoading(true);
        setErrorMessage("");
        console.log("D\xe9but de sauvegarde des donn\xe9es Quality1");
        const enterpriseId = localStorage.getItem("enterpriseId");
        const userId = localStorage.getItem("userId");
        if (!enterpriseId) {
            console.error("ERREUR: ID d'entreprise manquant");
            setErrorMessage("ID d'entreprise manquant. Veuillez retourner \xe0\xa0 la s\xe9lection d'entreprise.");
            setIsLoading(false);
            return;
        }
        // Définir toutes les questions possibles
        const allQuestions = [
            "Do you do reviews?",
            "In paper format?",
            "In digital format?",
            "Do you have a review specifying requirements not formulated by the customer but necessary for the specified use?",
            "Do you have a review specifying the requirements of the organisation?"
        ];
        // Créer un tableau de questions/réponses pour toutes les questions
        const data = allQuestions.map((question)=>{
            const answer = selectedOptions[question] || "No";
            return {
                question: question,
                answer: answer,
                category: "quality",
                enterpriseId: enterpriseId,
                userId: userId || "",
                section: "quality-1",
                timestamp: new Date().toISOString()
            };
        });
        // Vérifier que les données sont correctement formatées
        const isValidData = data.every((item)=>item.question && item.answer && item.category && item.enterpriseId);
        if (!isValidData) {
            console.error("Donn\xe9es invalides:", data);
            setErrorMessage("Format de donn\xe9es invalide");
            setIsLoading(false);
            return;
        }
        // Sauvegarder les données pour une utilisation ultérieure
        q_allData1 = [
            ...data
        ];
        console.log("Donn\xe9es \xe0\xa0 envoyer:", JSON.stringify(data, null, 2));
        // Appel API pour sauvegarder les données
        fetch("/api/api/save-evaluation", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
            },
            body: JSON.stringify(data)
        }).then((response)=>{
            if (!response.ok) throw new Error(`Erreur de sauvegarde (${response.status})`);
            return response.json();
        }).then((result)=>{
            console.log("Data saved successfully:", result);
            // Sauvegarder le score dans le localStorage
            localStorage.setItem('quality1Score', q_yesCount1);
            console.log(`Score quality1 mis \xe0\xa0 jour: ${q_yesCount1}`);
            // Redirection vers la page suivante
            setIsLoading(false);
            history.push("/Quality-2_");
        }).catch((error)=>{
            console.error("Error saving data:", error);
            setErrorMessage("Error saving data. Please try again.");
            console.error("D\xe9tails de l'erreur:", error.message);
            // Redirection malgré l'erreur
            setIsLoading(false);
            history.push("/Quality-2_");
        });
    }
    function calculateProgressPercentage() {
        const totalQuestions = document.getElementsByTagName("section").length;
        if (totalQuestions === 0) return 0;
        return Math.round(q_yesCount1 / totalQuestions * 100);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "environmental-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "environmental-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    className: "environmental-title",
                    children: "PLEASE ANSWER THE FOLLOWING QUESTIONS"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "progress-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "progress-bar",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "progress-fill",
                                style: {
                                    width: `${calculateProgressPercentage()}%`
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "progress-text",
                            children: [
                                "Your score: ",
                                q_yesCount1,
                                " / ",
                                totalQuestions,
                                " (",
                                calculateProgressPercentage(),
                                "%)"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questions-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you do reviews?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you do reviews?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you do reviews?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you do reviews?", "No"),
                                            className: `btn-option ${selectedOptions["Do you do reviews?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "In paper format?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("In paper format?", "Yes"),
                                            className: `btn-option ${selectedOptions["In paper format?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("In paper format?", "No"),
                                            className: `btn-option ${selectedOptions["In paper format?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "In digital format?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("In digital format?", "Yes"),
                                            className: `btn-option ${selectedOptions["In digital format?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("In digital format?", "No"),
                                            className: `btn-option ${selectedOptions["In digital format?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have a review specifying requirements not formulated by the customer but necessary for the specified use?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a review specifying requirements not formulated by the customer but necessary for the specified use?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have a review specifying requirements not formulated by the customer but necessary for the specified use?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a review specifying requirements not formulated by the customer but necessary for the specified use?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have a review specifying requirements not formulated by the customer but necessary for the specified use?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have a review specifying the requirements of the organisation?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a review specifying the requirements of the organisation?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have a review specifying the requirements of the organisation?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a review specifying the requirements of the organisation?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have a review specifying the requirements of the organisation?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "form-actions",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/cost-2_",
                            className: "btn-secondary",
                            children: "Back"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "btn-primary",
                            children: "Continue to Next Section"
                        })
                    ]
                }),
                isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "loading-indicator",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "spinner"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: "Saving data..."
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Quality1_;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["Link","b9X5n"],["useHistory","ditZI"]],"../NavItems3":"fOarC","../NavItems2":"bnQuI","./Quality1_.css":"eepPX","../../styleguide.css":"8Y7Ec","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eepPX":[function() {},{}],"8Y7Ec":[function() {},{}],"jEnvw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "q_allData2", ()=>q_allData2);
parcelHelpers.export(exports, "q_yesCount2", ()=>q_yesCount2);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _quality2Css = require("./Quality2_.css");
var _styleguideCss = require("../../styleguide.css");
var _quality1 = require("../Quality1_");
let q_allData2 = [];
let q_yesCount2 = 0;
function Quality2_(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const { x1200PxLogo_Icam__20081, navItems3Props } = props;
    (0, _react.useEffect)(()=>{
        // Calculate the total number of questions based on sections
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []); // Run this effect only once when the component mounts
    function clicked(question, option) {
        // Si l'option cliquée est la màªme que celle déjà  sélectionnée, on la désélectionne
        if (selectedOptions[question] === option) {
            setSelectedOptions((prevSelectedOptions)=>{
                const newOptions = {
                    ...prevSelectedOptions
                };
                delete newOptions[question];
                return newOptions;
            });
            // Si on désélectionne un "Yes", on décrémente le score
            if (option === "Yes") q_yesCount2--;
            return;
        }
        // Sinon, on met à  jour la sélection
        const previousOption = selectedOptions[question];
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        // Si on passe de "No" à  "Yes", on incrémente le score
        if (option === "Yes" && previousOption !== "Yes") q_yesCount2++;
        else if (option === "No" && previousOption === "Yes") q_yesCount2--;
    }
    const history = (0, _reactRouterDom.useHistory)();
    function saveData() {
        setIsLoading(true);
        setErrorMessage("");
        console.log("D\xe9but de sauvegarde des donn\xe9es Quality2");
        const enterpriseId = localStorage.getItem("enterpriseId");
        const userId = localStorage.getItem("userId");
        if (!enterpriseId) {
            console.error("ERREUR: ID d'entreprise manquant");
            setErrorMessage("ID d'entreprise manquant. Veuillez retourner \xe0\xa0 la s\xe9lection d'entreprise.");
            setIsLoading(false);
            return;
        }
        // Définir toutes les questions possibles
        const allQuestions = [
            "Do you have a customer satisfaction percentage?",
            "Is it below 30%?",
            "Is it between 30% and 50%?",
            "Is it between 50% and 80%?",
            "Is it above 80%?"
        ];
        // Créer un tableau de questions/réponses pour toutes les questions
        const data = allQuestions.map((question)=>{
            const answer = selectedOptions[question] || "No";
            return {
                question: question,
                answer: answer,
                category: "quality",
                enterpriseId: enterpriseId,
                userId: userId || "",
                section: "quality-2",
                timestamp: new Date().toISOString()
            };
        });
        // Vérifier que les données sont correctement formatées
        const isValidData = data.every((item)=>item.question && item.answer && item.category && item.enterpriseId);
        if (!isValidData) {
            console.error("Donn\xe9es invalides:", data);
            setErrorMessage("Format de donn\xe9es invalide");
            setIsLoading(false);
            return;
        }
        // Sauvegarder les données pour une utilisation ultérieure
        q_allData2 = [
            ...data
        ];
        console.log("Donn\xe9es \xe0\xa0 envoyer:", JSON.stringify(data, null, 2));
        // Appel API pour sauvegarder les données
        fetch("/api/api/save-evaluation", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
            },
            body: JSON.stringify(data)
        }).then((response)=>{
            if (!response.ok) throw new Error(`Erreur de sauvegarde (${response.status})`);
            return response.json();
        }).then((result)=>{
            console.log("Data saved successfully:", result);
            // Sauvegarder le score dans le localStorage
            localStorage.setItem('quality2Score', q_yesCount2);
            console.log(`Score quality2 mis \xe0\xa0 jour: ${q_yesCount2}`);
            // Redirection vers la page suivante
            setIsLoading(false);
            history.push("/Quality-3_");
        }).catch((error)=>{
            console.error("Error saving data:", error);
            setErrorMessage("Error saving data. Please try again.");
            console.error("D\xe9tails de l'erreur:", error.message);
            // Redirection malgré l'erreur
            setIsLoading(false);
            history.push("/Quality-3_");
        });
    }
    function calculateProgressPercentage() {
        const totalQuestions = document.getElementsByTagName("section").length;
        if (totalQuestions === 0) return 0;
        return Math.round(q_yesCount2 / totalQuestions * 100);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "environmental-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "environmental-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    className: "environmental-title",
                    children: "PLEASE ANSWER THE FOLLOWING QUESTIONS"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "progress-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "progress-bar",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "progress-fill",
                                style: {
                                    width: `${calculateProgressPercentage()}%`
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "progress-text",
                            children: [
                                "Your score: ",
                                q_yesCount2,
                                " / ",
                                totalQuestions,
                                " (",
                                calculateProgressPercentage(),
                                "%)"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questions-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have a customer satisfaction percentage?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a customer satisfaction percentage?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have a customer satisfaction percentage?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a customer satisfaction percentage?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have a customer satisfaction percentage?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Is it below 30%?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Is it below 30%?", "Yes"),
                                            className: `btn-option ${selectedOptions["Is it below 30%?"] === "Yes" ? "enabled" : ""}`,
                                            disabled: selectedOptions["Is it below 30%?"] === "No",
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Is it below 30%?", "No"),
                                            className: `btn-option ${selectedOptions["Is it below 30%?"] === "No" ? "enabled" : ""}`,
                                            disabled: selectedOptions["Is it below 30%?"] === "Yes",
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Is it between 30% and 60%?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Is it between 30% and 60%?", "Yes"),
                                            className: `btn-option ${selectedOptions["Is it between 30% and 60%?"] === "Yes" ? "enabled" : ""}`,
                                            disabled: selectedOptions["Is it between 30% and 60%?"] === "No",
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Is it between 30% and 60%?", "No"),
                                            className: `btn-option ${selectedOptions["Is it between 30% and 60%?"] === "No" ? "enabled" : ""}`,
                                            disabled: selectedOptions["Is it between 30% and 60%?"] === "Yes",
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Is it between 60% and 90%?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Is it between 60% and 90%?", "Yes"),
                                            className: `btn-option ${selectedOptions["Is it between 60% and 90%?"] === "Yes" ? "enabled" : ""}`,
                                            disabled: selectedOptions["Is it between 60% and 90%?"] === "No",
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Is it between 60% and 90%?", "No"),
                                            className: `btn-option ${selectedOptions["Is it between 60% and 90%?"] === "No" ? "enabled" : ""}`,
                                            disabled: selectedOptions["Is it between 60% and 90%?"] === "Yes",
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Is it higher than 90%?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Is it higher than 90%?", "Yes"),
                                            className: `btn-option ${selectedOptions["Is it higher than 90%?"] === "Yes" ? "enabled" : ""}`,
                                            disabled: selectedOptions["Is it higher than 90%?"] === "No",
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Is it higher than 90%?", "No"),
                                            className: `btn-option ${selectedOptions["Is it higher than 90%?"] === "No" ? "enabled" : ""}`,
                                            disabled: selectedOptions["Is it higher than 90%?"] === "Yes",
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Does the manager ensure that customer requirements are met?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Does the manager ensure that customer requirements are met?", "Yes"),
                                            className: `btn-option ${selectedOptions["Does the manager ensure that customer requirements are met?"] === "Yes" ? "enabled" : ""}`,
                                            disabled: selectedOptions["Does the manager ensure that customer requirements are met?"] === "No",
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Does the manager ensure that customer requirements are met?", "No"),
                                            className: `btn-option ${selectedOptions["Does the manager ensure that customer requirements are met?"] === "No" ? "enabled" : ""}`,
                                            disabled: selectedOptions["Does the manager ensure that customer requirements are met?"] === "Yes",
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you communicate to employees the points of attention where product and service compliance is at risk?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you communicate to employees the points of attention where product and service compliance is at risk?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you communicate to employees the points of attention where product and service compliance is at risk?"] === "Yes" ? "enabled" : ""}`,
                                            disabled: selectedOptions["Do you communicate to employees the points of attention where product and service compliance is at risk?"] === "No",
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you communicate to employees the points of attention where product and service compliance is at risk?", "No"),
                                            className: `btn-option ${selectedOptions["Do you communicate to employees the points of attention where product and service compliance is at risk?"] === "No" ? "enabled" : ""}`,
                                            disabled: selectedOptions["Do you communicate to employees the points of attention where product and service compliance is at risk?"] === "Yes",
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "form-actions",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/quality-1_",
                            className: "btn-secondary",
                            children: "Back"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "btn-primary",
                            children: "Next"
                        })
                    ]
                }),
                isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "loading-indicator",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "spinner"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: "Saving data..."
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Quality2_;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["Link","b9X5n"],["useHistory","ditZI"]],"../NavItems3":"fOarC","../NavItems2":"bnQuI","./Quality2_.css":"fXaex","../../styleguide.css":"8Y7Ec","../Quality1_":"dcV9a","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fXaex":[function() {},{}],"8Y7Ec":[function() {},{}],"ck4So":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "q_allData3", ()=>q_allData3);
parcelHelpers.export(exports, "q_yesCount3", ()=>q_yesCount3);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _quality3Css = require("./Quality3_.css");
var _styleguideCss = require("../../styleguide.css");
var _quality1 = require("../Quality1_");
var _quality2 = require("../Quality2_");
let q_allData3 = [];
let q_yesCount3 = 0;
function Quality3_(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const { x1200PxLogo_Icam__20081, navItems3Props } = props;
    (0, _react.useEffect)(()=>{
        // Calculate the total number of questions based on sections
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []); // Run this effect only once when the component mounts
    function clicked(question, option) {
        // Si l'option cliquée est la màªme que celle déjà  sélectionnée, on la désélectionne
        if (selectedOptions[question] === option) {
            setSelectedOptions((prevSelectedOptions)=>{
                const newOptions = {
                    ...prevSelectedOptions
                };
                delete newOptions[question];
                return newOptions;
            });
            // Si on désélectionne un "Yes", on décrémente le score
            if (option === "Yes") q_yesCount3--;
            return;
        }
        // Sinon, on met à  jour la sélection
        const previousOption = selectedOptions[question];
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        // Si on passe de "No" à  "Yes", on incrémente le score
        if (option === "Yes" && previousOption !== "Yes") q_yesCount3++;
        else if (option === "No" && previousOption === "Yes") q_yesCount3--;
    }
    const history = (0, _reactRouterDom.useHistory)();
    function saveData() {
        setIsLoading(true);
        setErrorMessage("");
        console.log("D\xe9but de sauvegarde des donn\xe9es Quality3");
        const enterpriseId = localStorage.getItem("enterpriseId");
        const userId = localStorage.getItem("userId");
        if (!enterpriseId) {
            console.error("ERREUR: ID d'entreprise manquant");
            setErrorMessage("ID d'entreprise manquant. Veuillez retourner \xe0\xa0 la s\xe9lection d'entreprise.");
            setIsLoading(false);
            return;
        }
        // Définir toutes les questions possibles
        const allQuestions = [
            "Do you communicate the importance of having an effective quality management system?",
            "Do you have objectives in the form of KPIs concerning quality?",
            "Do you monitor the achievement of quality objectives?",
            "Do you have a quality management process established?",
            "Are the members of your organisation informed about the necessary quality improvements?",
            "Is there quality assurance planning?",
            "Is there a documented quality procedure in your company?"
        ];
        // Créer un tableau de questions/réponses pour toutes les questions
        const data = allQuestions.map((question)=>{
            const answer = selectedOptions[question] || "No";
            return {
                question: question,
                answer: answer,
                category: "quality",
                enterpriseId: enterpriseId,
                userId: userId || "",
                section: "quality-3",
                timestamp: new Date().toISOString()
            };
        });
        // Vérifier que les données sont correctement formatées
        const isValidData = data.every((item)=>item.question && item.answer && item.category && item.enterpriseId);
        if (!isValidData) {
            console.error("Donn\xe9es invalides:", data);
            setErrorMessage("Format de donn\xe9es invalide");
            setIsLoading(false);
            return;
        }
        // Sauvegarder les données pour une utilisation ultérieure
        q_allData3 = [
            ...data
        ];
        console.log("Donn\xe9es \xe0\xa0 envoyer:", JSON.stringify(data, null, 2));
        // Appel API pour sauvegarder les données
        fetch("/api/api/save-evaluation", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
            },
            body: JSON.stringify(data)
        }).then((response)=>{
            if (!response.ok) throw new Error(`Erreur de sauvegarde (${response.status})`);
            return response.json();
        }).then((result)=>{
            console.log("Data saved successfully:", result);
            // Sauvegarder le score dans le localStorage
            localStorage.setItem('quality3Score', q_yesCount3);
            console.log(`Score quality3 mis \xe0\xa0 jour: ${q_yesCount3}`);
            // Redirection vers la page suivante
            setIsLoading(false);
            history.push("/Quality-4_");
        }).catch((error)=>{
            console.error("Error saving data:", error);
            setErrorMessage("Error saving data. Please try again.");
            console.error("D\xe9tails de l'erreur:", error.message);
            // Redirection malgré l'erreur
            setIsLoading(false);
            history.push("/Quality-4_");
        });
    }
    function calculateProgressPercentage() {
        const totalQuestions = document.getElementsByTagName("section").length;
        if (totalQuestions === 0) return 0;
        return Math.round(q_yesCount3 / totalQuestions * 100);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "environmental-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "environmental-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    className: "environmental-title",
                    children: "PLEASE ANSWER THE FOLLOWING QUESTIONS"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "progress-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "progress-bar",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "progress-fill",
                                style: {
                                    width: `${calculateProgressPercentage()}%`
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "progress-text",
                            children: [
                                "Your score: ",
                                q_yesCount3,
                                " / ",
                                totalQuestions,
                                " (",
                                calculateProgressPercentage(),
                                "%)"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questions-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you communicate the importance of having an effective quality management system?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you communicate the importance of having an effective quality management system?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you communicate the importance of having an effective quality management system?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you communicate the importance of having an effective quality management system?", "No"),
                                            className: `btn-option ${selectedOptions["Do you communicate the importance of having an effective quality management system?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have objectives in the form of KPIs concerning quality?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have objectives in the form of KPIs concerning quality?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have objectives in the form of KPIs concerning quality?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have objectives in the form of KPIs concerning quality?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have objectives in the form of KPIs concerning quality?"] === "No" ? "enabled" : ""}`,
                                            disabled: selectedOptions["Do you have objectives in the form of KPIs concerning quality?"] === "Yes",
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you monitor the achievement of quality objectives?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you monitor the achievement of quality objectives?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you monitor the achievement of quality objectives?"] === "Yes" ? "enabled" : ""}`,
                                            disabled: selectedOptions["Do you monitor the achievement of quality objectives?"] === "No",
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you monitor the achievement of quality objectives?", "No"),
                                            className: `btn-option ${selectedOptions["Do you monitor the achievement of quality objectives?"] === "No" ? "enabled" : ""}`,
                                            disabled: selectedOptions["Do you monitor the achievement of quality objectives?"] === "Yes",
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have a quality management process established?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a quality management process established?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have a quality management process established?"] === "Yes" ? "enabled" : ""}`,
                                            disabled: selectedOptions["Do you have a quality management process established?"] === "No",
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a quality management process established?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have a quality management process established?"] === "No" ? "enabled" : ""}`,
                                            disabled: selectedOptions["Do you have a quality management process established?"] === "Yes",
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Are you improving these processes?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Are you improving these processes?", "Yes"),
                                            className: `btn-option ${selectedOptions["Are you improving these processes?"] === "Yes" ? "enabled" : ""}`,
                                            disabled: selectedOptions["Are you improving these processes?"] === "No",
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Are you improving these processes?", "No"),
                                            className: `btn-option ${selectedOptions["Are you improving these processes?"] === "No" ? "enabled" : ""}`,
                                            disabled: selectedOptions["Are you improving these processes?"] === "Yes",
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you conduct internal or external audits to ensure performance and effectiveness of the QMS (including internal audits and third-party audits)?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you conduct internal or external audits to ensure performance and effectiveness of the QMS (including internal audits and third-party audits)?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you conduct internal or external audits to ensure performance and effectiveness of the QMS (including internal audits and third-party audits)?"] === "Yes" ? "enabled" : ""}`,
                                            disabled: selectedOptions["Do you conduct internal or external audits to ensure performance and effectiveness of the QMS (including internal audits and third-party audits)?"] === "No",
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you conduct internal or external audits to ensure performance and effectiveness of the QMS (including internal audits and third-party audits)?", "No"),
                                            className: `btn-option ${selectedOptions["Do you conduct internal or external audits to ensure performance and effectiveness of the QMS (including internal audits and third-party audits)?"] === "No" ? "enabled" : ""}`,
                                            disabled: selectedOptions["Do you conduct internal or external audits to ensure performance and effectiveness of the QMS (including internal audits and third-party audits)?"] === "Yes",
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "form-actions",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/quality-2_",
                            className: "btn-secondary",
                            children: "Back"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "btn-primary",
                            children: "Next"
                        })
                    ]
                }),
                isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "loading-indicator",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "spinner"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: "Saving data..."
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Quality3_;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["Link","b9X5n"],["useHistory","ditZI"]],"../NavItems3":"fOarC","../NavItems2":"bnQuI","./Quality3_.css":"2f2Md","../../styleguide.css":"8Y7Ec","../Quality1_":"dcV9a","../Quality2_":"jEnvw","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2f2Md":[function() {},{}],"8Y7Ec":[function() {},{}],"jJhwl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "q_allData4", ()=>q_allData4);
parcelHelpers.export(exports, "q_yesCount4", ()=>q_yesCount4);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _quality4Css = require("./Quality4_.css");
var _styleguideCss = require("../../styleguide.css");
var _quality1 = require("../Quality1_");
var _quality2 = require("../Quality2_");
var _quality3 = require("../Quality3_");
let q_allData4 = [];
let q_yesCount4 = 0;
function Quality4_(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const { x1200PxLogo_Icam__20081, navItems3Props } = props;
    (0, _react.useEffect)(()=>{
        // Calculate the total number of questions based on sections
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []); // Run this effect only once when the component mounts
    function clicked(question, option) {
        // Si l'option cliquée est la màªme que celle déjà  sélectionnée, on la désélectionne
        if (selectedOptions[question] === option) {
            setSelectedOptions((prevSelectedOptions)=>{
                const newOptions = {
                    ...prevSelectedOptions
                };
                delete newOptions[question];
                return newOptions;
            });
            // Si on désélectionne un "Yes", on décrémente le score
            if (option === "Yes") q_yesCount4--;
            return;
        }
        // Sinon, on met à  jour la sélection
        const previousOption = selectedOptions[question];
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        // Si on passe de "No" à  "Yes", on incrémente le score
        if (option === "Yes" && previousOption !== "Yes") q_yesCount4++;
        else if (option === "No" && previousOption === "Yes") q_yesCount4--;
    }
    const history = (0, _reactRouterDom.useHistory)();
    function saveData() {
        setIsLoading(true);
        setErrorMessage("");
        console.log("D\xe9but de sauvegarde des donn\xe9es Quality4");
        const enterpriseId = localStorage.getItem("enterpriseId");
        const userId = localStorage.getItem("userId");
        if (!enterpriseId) {
            console.error("ERREUR: ID d'entreprise manquant");
            setErrorMessage("ID d'entreprise manquant. Veuillez retourner \xe0\xa0 la s\xe9lection d'entreprise.");
            setIsLoading(false);
            return;
        }
        // Définir toutes les questions possibles
        const allQuestions = [
            "Do you have a quality manager?",
            "Are the necessary competences of the person(s) working on the performance and effectiveness of the quality management system defined?",
            "Does the organization ensure that these persons are competent on the basis of appropriate education, training, or experience?",
            "Are the results of audits reported to management?",
            "Does the management team ensure that the QMS processes are integrated into the company's business processes?",
            "Are the responsibilities in the quality department distributed effectively?",
            "Does your organization manage the QMS documentation effectively?"
        ];
        // Créer un tableau de questions/réponses pour toutes les questions
        const data = allQuestions.map((question)=>{
            const answer = selectedOptions[question] || "No";
            return {
                question: question,
                answer: answer,
                category: "quality",
                enterpriseId: enterpriseId,
                userId: userId || "",
                section: "quality-4",
                timestamp: new Date().toISOString()
            };
        });
        // Vérifier que les données sont correctement formatées
        const isValidData = data.every((item)=>item.question && item.answer && item.category && item.enterpriseId);
        if (!isValidData) {
            console.error("Donn\xe9es invalides:", data);
            setErrorMessage("Format de donn\xe9es invalide");
            setIsLoading(false);
            return;
        }
        // Sauvegarder les données pour une utilisation ultérieure
        q_allData4 = [
            ...data
        ];
        console.log("Donn\xe9es \xe0\xa0 envoyer:", JSON.stringify(data, null, 2));
        // Appel API pour sauvegarder les données
        fetch("/api/api/save-evaluation", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
            },
            body: JSON.stringify(data)
        }).then((response)=>{
            if (!response.ok) throw new Error(`Erreur de sauvegarde (${response.status})`);
            return response.json();
        }).then((result)=>{
            console.log("Data saved successfully:", result);
            // Sauvegarder le score dans le localStorage
            localStorage.setItem('quality4Score', q_yesCount4);
            console.log(`Score quality4 mis \xe0\xa0 jour: ${q_yesCount4}`);
            // Redirection vers la page suivante
            setIsLoading(false);
            history.push("/Quality-5_");
        }).catch((error)=>{
            console.error("Error saving data:", error);
            setErrorMessage("Error saving data. Please try again.");
            console.error("D\xe9tails de l'erreur:", error.message);
            // Redirection malgré l'erreur
            setIsLoading(false);
            history.push("/Quality-5_");
        });
    }
    function calculateProgressPercentage() {
        const totalQuestions = document.getElementsByTagName("section").length;
        if (totalQuestions === 0) return 0;
        return Math.round(q_yesCount4 / totalQuestions * 100);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "environmental-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "environmental-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    className: "environmental-title",
                    children: "PLEASE ANSWER THE FOLLOWING QUESTIONS"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "progress-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "progress-bar",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "progress-fill",
                                style: {
                                    width: `${calculateProgressPercentage()}%`
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "progress-text",
                            children: [
                                "Your score: ",
                                q_yesCount4,
                                " / ",
                                totalQuestions,
                                " (",
                                calculateProgressPercentage(),
                                "%)"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questions-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you have a quality manager?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a quality manager?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you have a quality manager?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you have a quality manager?", "No"),
                                            className: `btn-option ${selectedOptions["Do you have a quality manager?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Are the necessary competences of the person(s) working on the performance and effectiveness of the quality management system defined?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Are the necessary competences of the person(s) working on the performance and effectiveness of the quality management system defined?", "Yes"),
                                            className: `btn-option ${selectedOptions["Are the necessary competences of the person(s) working on the performance and effectiveness of the quality management system defined?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Are the necessary competences of the person(s) working on the performance and effectiveness of the quality management system defined?", "No"),
                                            className: `btn-option ${selectedOptions["Are the necessary competences of the person(s) working on the performance and effectiveness of the quality management system defined?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Does the organization ensure that these persons are competent on the basis of appropriate education, training, or experience?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Does the organization ensure that these persons are competent on the basis of appropriate education, training, or experience?", "Yes"),
                                            className: `btn-option ${selectedOptions["Does the organization ensure that these persons are competent on the basis of appropriate education, training, or experience?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Does the organization ensure that these persons are competent on the basis of appropriate education, training, or experience?", "No"),
                                            className: `btn-option ${selectedOptions["Does the organization ensure that these persons are competent on the basis of appropriate education, training, or experience?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Are the results of audits reported to management?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Are the results of audits reported to management?", "Yes"),
                                            className: `btn-option ${selectedOptions["Are the results of audits reported to management?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Are the results of audits reported to management?", "No"),
                                            className: `btn-option ${selectedOptions["Are the results of audits reported to management?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Does the management team ensure that the QMS processes are integrated into the company's business processes?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Does the management team ensure that the QMS processes are integrated into the company's business processes?", "Yes"),
                                            className: `btn-option ${selectedOptions["Does the management team ensure that the QMS processes are integrated into the company's business processes?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Does the management team ensure that the QMS processes are integrated into the company's business processes?", "No"),
                                            className: `btn-option ${selectedOptions["Does the management team ensure that the QMS processes are integrated into the company's business processes?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Does the organization retain documented information as evidence of competence?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Does the organization retain documented information as evidence of competence?", "Yes"),
                                            className: `btn-option ${selectedOptions["Does the organization retain documented information as evidence of competence?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Does the organization retain documented information as evidence of competence?", "No"),
                                            className: `btn-option ${selectedOptions["Does the organization retain documented information as evidence of competence?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "form-actions",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/quality-3_",
                            className: "btn-secondary",
                            children: "Back"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "btn-primary",
                            children: "Next"
                        })
                    ]
                }),
                isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "loading-indicator",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "spinner"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: "Saving data..."
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Quality4_;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["Link","b9X5n"],["useHistory","ditZI"]],"../NavItems3":"fOarC","../NavItems2":"bnQuI","./Quality4_.css":"gyhaH","../../styleguide.css":"8Y7Ec","../Quality1_":"dcV9a","../Quality2_":"jEnvw","../Quality3_":"ck4So","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gyhaH":[function() {},{}],"8Y7Ec":[function() {},{}],"82KlE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "q_allData5", ()=>q_allData5);
parcelHelpers.export(exports, "q_yesCount5", ()=>q_yesCount5);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _quality5Css = require("./Quality5_.css");
var _styleguideCss = require("../../styleguide.css");
var _quality1 = require("../Quality1_");
var _quality2 = require("../Quality2_");
var _quality3 = require("../Quality3_");
var _quality4 = require("../Quality4_");
let q_allData5 = [];
let q_yesCount5 = 0;
function Quality5_(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const { x1200PxLogo_Icam__20081, navItems3Props } = props;
    (0, _react.useEffect)(()=>{
        // Calculate the total number of questions based on sections
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []); // Run this effect only once when the component mounts
    function clicked(question, option) {
        // Si l'option cliquée est la màªme que celle déjà  sélectionnée, on la désélectionne
        if (selectedOptions[question] === option) {
            setSelectedOptions((prevSelectedOptions)=>{
                const newOptions = {
                    ...prevSelectedOptions
                };
                delete newOptions[question];
                return newOptions;
            });
            // Si on désélectionne un "Yes", on décrémente le score
            if (option === "Yes") q_yesCount5--;
            return;
        }
        // Sinon, on met à  jour la sélection
        const previousOption = selectedOptions[question];
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        // Si on passe de "No" à  "Yes", on incrémente le score
        if (option === "Yes" && previousOption !== "Yes") q_yesCount5++;
        else if (option === "No" && previousOption === "Yes") q_yesCount5--;
    }
    const history = (0, _reactRouterDom.useHistory)();
    function saveData() {
        setIsLoading(true);
        setErrorMessage("");
        console.log("D\xe9but de sauvegarde des donn\xe9es Quality5");
        const enterpriseId = localStorage.getItem("enterpriseId");
        const userId = localStorage.getItem("userId");
        if (!enterpriseId) {
            console.error("ERREUR: ID d'entreprise manquant");
            setErrorMessage("ID d'entreprise manquant. Veuillez retourner \xe0\xa0 la s\xe9lection d'entreprise.");
            setIsLoading(false);
            return;
        }
        // Définir toutes les questions possibles
        const allQuestions = [
            "Do you carry out internal audits at planned intervals to determine whether the QMS complies with the organisation's requirements?",
            "Is the planning and execution of the audit programme organised on a process-by-process basis?",
            "Does the organization plan, establish, implement and maintain an audit programme(s)?",
            "Does the organization use the results of previous audits to assess the effectiveness of actions taken to address the risks and opportunities?",
            "Does the organization ensure that the results of the audits are reported to relevant management?",
            "Does the organization take appropriate corrections and corrective actions without undue delay?",
            "Does the organization retain documented information as evidence of the implementation of the audit programme and the audit results?"
        ];
        // Créer un tableau de questions/réponses pour toutes les questions
        const data = allQuestions.map((question)=>{
            const answer = selectedOptions[question] || "No";
            return {
                question: question,
                answer: answer,
                category: "quality",
                enterpriseId: enterpriseId,
                userId: userId || "",
                section: "quality-5",
                timestamp: new Date().toISOString()
            };
        });
        // Vérifier que les données sont correctement formatées
        const isValidData = data.every((item)=>item.question && item.answer && item.category && item.enterpriseId);
        if (!isValidData) {
            console.error("Donn\xe9es invalides:", data);
            setErrorMessage("Format de donn\xe9es invalide");
            setIsLoading(false);
            return;
        }
        // Sauvegarder les données pour une utilisation ultérieure
        q_allData5 = [
            ...data
        ];
        console.log("Donn\xe9es \xe0\xa0 envoyer:", JSON.stringify(data, null, 2));
        // Appel API pour sauvegarder les données
        fetch("/api/api/save-evaluation", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
            },
            body: JSON.stringify(data)
        }).then((response)=>{
            if (!response.ok) throw new Error(`Erreur de sauvegarde (${response.status})`);
            return response.json();
        }).then((result)=>{
            console.log("Data saved successfully:", result);
            // Sauvegarder le score dans le localStorage
            localStorage.setItem('quality5Score', q_yesCount5);
            console.log(`Score quality5 mis \xe0\xa0 jour: ${q_yesCount5}`);
            // Redirection vers la page suivante
            setIsLoading(false);
            history.push("/Quality-6_");
        }).catch((error)=>{
            console.error("Error saving data:", error);
            setErrorMessage("Error saving data. Please try again.");
            console.error("D\xe9tails de l'erreur:", error.message);
            // Redirection malgré l'erreur
            setIsLoading(false);
            history.push("/Quality-6_");
        });
    }
    function calculateProgressPercentage() {
        const totalQuestions = document.getElementsByTagName("section").length;
        if (totalQuestions === 0) return 0;
        return Math.round(q_yesCount5 / totalQuestions * 100);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "environmental-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "environmental-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    className: "environmental-title",
                    children: "PLEASE ANSWER THE FOLLOWING QUESTIONS"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "progress-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "progress-bar",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "progress-fill",
                                style: {
                                    width: `${calculateProgressPercentage()}%`
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "progress-text",
                            children: [
                                "Your score: ",
                                q_yesCount5,
                                " / ",
                                totalQuestions,
                                " (",
                                calculateProgressPercentage(),
                                "%)"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questions-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you carry out internal audits at planned intervals to determine whether the QMS complies with the organisation's requirements?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you carry out internal audits at planned intervals to determine whether the QMS complies with the organisation's requirements?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you carry out internal audits at planned intervals to determine whether the QMS complies with the organisation's requirements?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you carry out internal audits at planned intervals to determine whether the QMS complies with the organisation's requirements?", "No"),
                                            className: `btn-option ${selectedOptions["Do you carry out internal audits at planned intervals to determine whether the QMS complies with the organisation's requirements?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Is the planning and execution of the audit programme organised on a process-by-process basis?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Is the planning and execution of the audit programme organised on a process-by-process basis?", "Yes"),
                                            className: `btn-option ${selectedOptions["Is the planning and execution of the audit programme organised on a process-by-process basis?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Is the planning and execution of the audit programme organised on a process-by-process basis?", "No"),
                                            className: `btn-option ${selectedOptions["Is the planning and execution of the audit programme organised on a process-by-process basis?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Does the organization plan, establish, implement and maintain an audit programme(s)?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Does the organization plan, establish, implement and maintain an audit programme(s)?", "Yes"),
                                            className: `btn-option ${selectedOptions["Does the organization plan, establish, implement and maintain an audit programme(s)?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Does the organization plan, establish, implement and maintain an audit programme(s)?", "No"),
                                            className: `btn-option ${selectedOptions["Does the organization plan, establish, implement and maintain an audit programme(s)?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Does the organization use the results of previous audits to assess the effectiveness of actions taken to address the risks and opportunities?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Does the organization use the results of previous audits to assess the effectiveness of actions taken to address the risks and opportunities?", "Yes"),
                                            className: `btn-option ${selectedOptions["Does the organization use the results of previous audits to assess the effectiveness of actions taken to address the risks and opportunities?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Does the organization use the results of previous audits to assess the effectiveness of actions taken to address the risks and opportunities?", "No"),
                                            className: `btn-option ${selectedOptions["Does the organization use the results of previous audits to assess the effectiveness of actions taken to address the risks and opportunities?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Does the organization ensure that the results of the audits are reported to relevant management?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Does the organization ensure that the results of the audits are reported to relevant management?", "Yes"),
                                            className: `btn-option ${selectedOptions["Does the organization ensure that the results of the audits are reported to relevant management?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Does the organization ensure that the results of the audits are reported to relevant management?", "No"),
                                            className: `btn-option ${selectedOptions["Does the organization ensure that the results of the audits are reported to relevant management?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Are these audit results also visible to employees?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Are these audit results also visible to employees?", "Yes"),
                                            className: `btn-option ${selectedOptions["Are these audit results also visible to employees?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Are these audit results also visible to employees?", "No"),
                                            className: `btn-option ${selectedOptions["Are these audit results also visible to employees?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "form-actions",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/quality-4_",
                            className: "btn-secondary",
                            children: "Back"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "btn-primary",
                            children: "Next"
                        })
                    ]
                }),
                isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "loading-indicator",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "spinner"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: "Saving data..."
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Quality5_;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["Link","b9X5n"],["useHistory","ditZI"]],"../NavItems3":"fOarC","../NavItems2":"bnQuI","./Quality5_.css":"9LIYd","../../styleguide.css":"8Y7Ec","../Quality1_":"dcV9a","../Quality2_":"jEnvw","../Quality3_":"ck4So","../Quality4_":"jJhwl","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9LIYd":[function() {},{}],"8Y7Ec":[function() {},{}],"6o8sp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _frame11732 = require("../Frame11732");
var _frame11732Default = parcelHelpers.interopDefault(_frame11732);
var _informationalModel3Css = require("./InformationalModel3.css");
function InformationalModel3(props) {
    const { x1200PxLogo_Icam__20081, pleaseAnswerTheFollowingQuestions, navItems2Props, navItems3Props, toggleProps } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "informational-model-3-1 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-41",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "rectangle-3-15"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {
                            className: navItems2Props.className
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                            className: navItems3Props.className,
                            frame1172Props: navItems3Props.frame1172Props,
                            frame1162Props: navItems3Props.frame1162Props,
                            frame1132Props: navItems3Props.frame1132Props
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-40",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "please-answer-the-following-questions-12 valign-text-middle bevan-normal-white-20px",
                            children: pleaseAnswerTheFollowingQuestions
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-88",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            className: toggleProps.className,
                            buttonSecondaryProps: toggleProps.buttonSecondaryProps
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11732Default.default), {})
                    ]
                })
            ]
        })
    });
}
exports.default = InformationalModel3;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"b9X5n","../NavItems2":"bnQuI","../NavItems3":"fOarC","../Toggle":"dSqDu","../Frame11732":"gSRJf","./InformationalModel3.css":"i3LMp","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"i3LMp":[function() {},{}],"4oRpq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _group102 = require("../Group102");
var _group102Default = parcelHelpers.interopDefault(_group102);
var _frame97 = require("../Frame97");
var _frame97Default = parcelHelpers.interopDefault(_frame97);
var _frame11732 = require("../Frame11732");
var _frame11732Default = parcelHelpers.interopDefault(_frame11732);
var _informationalModel2Css = require("./InformationalModel2.css");
function InformationalModel2(props) {
    const { x1200PxLogo_Icam__20081, pleaseAnswerTheFollowingQuestions, inputType1, inputPlaceholder1, inputType2, inputPlaceholder2, inputType3, inputPlaceholder3, inputType4, inputPlaceholder4, inputType5, inputPlaceholder5, navItems3Props, toggle1Props, toggle2Props, group1021Props, group1022Props, group1023Props, group1024Props, group1025Props, frame97Props, frame11732Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "informational-model-2-1 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-col-52",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "overlap-group-42",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                    to: "/home",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        className: "x1200px-logo_icam_-_2008-1-41",
                                        src: x1200PxLogo_Icam__20081,
                                        alt: "1200px-Logo_ICAM_-_2008 1"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-container-19",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                                            className: navItems3Props.className,
                                            frame1172Props: navItems3Props.frame1172Props,
                                            frame1162Props: navItems3Props.frame1162Props,
                                            frame1132Props: navItems3Props.frame1132Props
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {})
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "please-answer-the-following-questions-13 valign-text-middle bevan-normal-white-20px",
                            children: pleaseAnswerTheFollowingQuestions
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-89",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "overlap-group1-33",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggle1Props.className,
                                    buttonSecondaryProps: toggle1Props.buttonSecondaryProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "frame-96-3",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                            className: toggle2Props.className,
                                            buttonSecondaryProps: toggle2Props.buttonSecondaryProps
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                            className: "vos-employs-sont-ils subtitel",
                                            name: "vosemploy\xe9ssont-ilsforcedepropositionsconcernantlesinnovations",
                                            placeholder: inputPlaceholder1,
                                            type: inputType1
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                                            line24: group1021Props.line24
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                            className: "avez-vous-un-managem subtitel",
                                            name: "avezvousunmanagementquifavoriselcr\xe9ativit\xe9dessalari\xe9s",
                                            placeholder: inputPlaceholder2,
                                            type: inputType2
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                                            line24: group1022Props.line24
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                            className: "sez-vous subtitel",
                                            name: "garantissezvousl\xe9galit\xe9deschancesdetouslestravailleurscomment",
                                            placeholder: inputPlaceholder3,
                                            type: inputType3
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                                            line24: group1023Props.line24
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                            className: "sez-vous subtitel",
                                            name: "quelmanagementutilisezvous",
                                            placeholder: inputPlaceholder4,
                                            type: inputType4
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                                            line24: group1024Props.line24
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                            className: "est-ce-que-les-journ subtitel",
                                            name: "est-cequelesjourn\xe9esdetravailsontadapt\xe9esauvolumedetravail",
                                            placeholder: inputPlaceholder5,
                                            type: inputType5
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                                            line24: group1025Props.line24
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "frame-container-11",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame97Default.default), {
                                    toggleProps: frame97Props.toggleProps,
                                    group1021Props: frame97Props.group1021Props,
                                    group1022Props: frame97Props.group1022Props,
                                    group1023Props: frame97Props.group1023Props,
                                    group1024Props: frame97Props.group1024Props,
                                    group1025Props: frame97Props.group1025Props
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11732Default.default), {
                                    className: frame11732Props.className
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = InformationalModel2;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"b9X5n","../NavItems3":"fOarC","../NavItems2":"bnQuI","../Toggle":"dSqDu","../Group102":"cllgP","../Frame97":"2DMi4","../Frame11732":"gSRJf","./InformationalModel2.css":"5i6ql","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2DMi4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _group102 = require("../Group102");
var _group102Default = parcelHelpers.interopDefault(_group102);
var _frame97Css = require("./Frame97.css");
function Frame97(props) {
    const { className, toggleProps, group1021Props, group1022Props, group1023Props, group1024Props, group1025Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `frame-97-4 ${className || ""}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                className: toggleProps.className,
                buttonSecondaryProps: toggleProps.buttonSecondaryProps
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "aprs-combien-de-temp subtitel",
                name: "apr\xe8scombiendetempsunemploy\xe9peutpr\xe9tendre\xe0uneaugmentation",
                placeholder: "Apr\xe8s combien de temps un employ\xe9 peut pr\xe9tendre \xe0 une augmentation?",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1021Props.line24,
                className: group1021Props.className
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "x-de subtitel",
                name: "queltypederecrutementprivil\xe9giezvousinterneouexterne",
                placeholder: "Quel type de recrutement privil\xe9giez vous? Interne ou externe",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1022Props.line24,
                className: group1022Props.className
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "x-de subtitel",
                name: "arbitrezvousdefa\xe7on\xe9quilibr\xe9eentrelesbesoinsdelorganisationetceuxdespartiesprenantes",
                placeholder: "Arbitrez vous de fa\xe7on \xe9quilibr\xe9e entre les besoins de l\u2019organisation et ceux des parties prenantes?",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1023Props.line24,
                className: group1023Props.className
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "accompagnez-vous-les subtitel",
                name: "accompagnezvouslestravailleursquiveulentmonterleurpropreorganisation",
                placeholder: "Accompagnez vous les travailleurs qui veulent monter leur propre organisation?",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1024Props.line24,
                className: group1024Props.className
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "quel-est-le-turnover subtitel",
                name: "quelestleturnoverdelentreprisepluselleestgrandemoinslesemploy\xe9srestent",
                placeholder: "Quel est le turnover de l\u2019entreprise (plus elle est  grande moins les employ\xe9s restent)?",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1025Props.line24,
                className: group1025Props.className
            })
        ]
    });
}
exports.default = Frame97;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","../Toggle":"dSqDu","../Group102":"cllgP","./Frame97.css":"b1fhh","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"b1fhh":[function() {},{}],"5i6ql":[function() {},{}],"c3pxU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _frame96 = require("../Frame96");
var _frame96Default = parcelHelpers.interopDefault(_frame96);
var _frame97 = require("../Frame97");
var _frame97Default = parcelHelpers.interopDefault(_frame97);
var _frame11732 = require("../Frame11732");
var _frame11732Default = parcelHelpers.interopDefault(_frame11732);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _processView2Css = require("./ProcessView2.css");
function ProcessView2(props) {
    const { x1200PxLogo_Icam__20081, pleaseAnswerTheFollowingQuestions, navItems2Props, navItems3Props, frame96Props, frame97Props, frame11732Props, toggleProps } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "process-view-2-1 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-43",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "rectangle-3-16"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {
                            className: navItems2Props.className
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                            className: navItems3Props.className,
                            frame1172Props: navItems3Props.frame1172Props,
                            frame1162Props: navItems3Props.frame1162Props,
                            frame1132Props: navItems3Props.frame1132Props
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-42",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "please-answer-the-following-questions-14 valign-text-middle bevan-normal-white-20px",
                            children: pleaseAnswerTheFollowingQuestions
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame96Default.default), {
                            toggleProps: frame96Props.toggleProps,
                            group1021Props: frame96Props.group1021Props,
                            group1022Props: frame96Props.group1022Props,
                            group1023Props: frame96Props.group1023Props,
                            group1024Props: frame96Props.group1024Props,
                            group1025Props: frame96Props.group1025Props
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame97Default.default), {
                            className: frame97Props.className,
                            toggleProps: frame97Props.toggleProps,
                            group1021Props: frame97Props.group1021Props,
                            group1022Props: frame97Props.group1022Props,
                            group1023Props: frame97Props.group1023Props,
                            group1024Props: frame97Props.group1024Props,
                            group1025Props: frame97Props.group1025Props
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11732Default.default), {
                    className: frame11732Props.className
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                    className: toggleProps.className,
                    buttonSecondaryProps: toggleProps.buttonSecondaryProps
                })
            ]
        })
    });
}
exports.default = ProcessView2;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"b9X5n","../NavItems2":"bnQuI","../NavItems3":"fOarC","../Frame96":"hkhn3","../Frame97":"2DMi4","../Frame11732":"gSRJf","../Toggle":"dSqDu","./ProcessView2.css":"2uiMN","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hkhn3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _group102 = require("../Group102");
var _group102Default = parcelHelpers.interopDefault(_group102);
var _frame96Css = require("./Frame96.css");
function Frame96(props) {
    const { className, toggleProps, group1021Props, group1022Props, group1023Props, group1024Props, group1025Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `frame-96-4 ${className || ""}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                className: toggleProps.className,
                buttonSecondaryProps: toggleProps.buttonSecondaryProps
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "vos-employs-sont-ils-1 subtitel",
                name: "vosemploy\xe9ssont-ilsforcedepropositionsconcernantlesinnovations",
                placeholder: "Vos employ\xe9s sont-ils force de propositions concernant les innovations?",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1021Props.line24
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "avez-vous-un-managem-1 subtitel",
                name: "avezvousunmanagementquifavoriselcr\xe9ativit\xe9dessalari\xe9s",
                placeholder: "Avez vous un management qui favorise l cr\xe9ativit\xe9 des salari\xe9s?",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1022Props.line24
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "sez-vous-1 subtitel",
                name: "garantissezvousl\xe9galit\xe9deschancesdetouslestravailleurscomment",
                placeholder: "Garantissez vous l\u2019\xe9galit\xe9 des chances de tous les travailleurs? Comment?",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1023Props.line24,
                className: group1023Props.className
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "sez-vous-1 subtitel",
                name: "quelmanagementutilisezvous",
                placeholder: "Quel management utilisez vous?",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1024Props.line24,
                className: group1024Props.className
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "est-ce-que-les-journ-1 subtitel",
                name: "est-cequelesjourn\xe9esdetravailsontadapt\xe9esauvolumedetravail",
                placeholder: "Est-ce que les journ\xe9es de travail sont adapt\xe9es au volume de travail?",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1025Props.line24,
                className: group1025Props.className
            })
        ]
    });
}
exports.default = Frame96;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","../Toggle":"dSqDu","../Group102":"cllgP","./Frame96.css":"48uSc","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"48uSc":[function() {},{}],"2uiMN":[function() {},{}],"jM7Tw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _processView3Css = require("./ProcessView3.css");
function ProcessView3(props) {
    const { x1200PxLogo_Icam__20081, pleaseAnswerTheFollowingQuestions, informationalModel, navItems2Props, navItems3Props, toggleProps } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "process-view-3-1 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-45",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "rectangle-3-17"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {
                            className: navItems2Props.className
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                            className: navItems3Props.className,
                            frame1172Props: navItems3Props.frame1172Props,
                            frame1162Props: navItems3Props.frame1162Props,
                            frame1132Props: navItems3Props.frame1132Props
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-44",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "please-answer-the-following-questions-15 valign-text-middle bevan-normal-white-20px",
                            children: pleaseAnswerTheFollowingQuestions
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-91",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            className: toggleProps.className,
                            buttonSecondaryProps: toggleProps.buttonSecondaryProps
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "frame-113-55",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "informational-model-11 valign-text-middle inter-bold-mineral-green-18px",
                                children: informationalModel
                            })
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = ProcessView3;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"b9X5n","../NavItems2":"bnQuI","../NavItems3":"fOarC","../Toggle":"dSqDu","./ProcessView3.css":"haw3f","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"haw3f":[function() {},{}],"dToUM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _frame11732 = require("../Frame11732");
var _frame11732Default = parcelHelpers.interopDefault(_frame11732);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _frame96 = require("../Frame96");
var _frame96Default = parcelHelpers.interopDefault(_frame96);
var _frame97 = require("../Frame97");
var _frame97Default = parcelHelpers.interopDefault(_frame97);
var _decisionalView2Css = require("./DecisionalView2.css");
function DecisionalView2(props) {
    const { x1200PxLogo_Icam__20081, pleaseAnswerTheFollowingQuestions, navItems2Props, navItems3Props, frame11732Props, toggleProps, frame96Props, frame97Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "decisional-view-2 screen",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "overlap-group-46",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "rectangle-3-18"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {
                        className: navItems2Props.className
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                        className: navItems3Props.className,
                        frame1172Props: navItems3Props.frame1172Props,
                        frame1162Props: navItems3Props.frame1162Props,
                        frame1132Props: navItems3Props.frame1132Props
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11732Default.default), {
                        className: frame11732Props.className
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                        to: "/home",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "x1200px-logo_icam_-_2008-1-45",
                            src: x1200PxLogo_Icam__20081,
                            alt: "1200px-Logo_ICAM_-_2008 1"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "please-answer-the-following-questions-16 valign-text-middle bevan-normal-white-20px",
                        children: pleaseAnswerTheFollowingQuestions
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                        className: toggleProps.className,
                        buttonSecondaryProps: toggleProps.buttonSecondaryProps
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame96Default.default), {
                        className: frame96Props.className,
                        toggleProps: frame96Props.toggleProps,
                        group1021Props: frame96Props.group1021Props,
                        group1022Props: frame96Props.group1022Props,
                        group1023Props: frame96Props.group1023Props,
                        group1024Props: frame96Props.group1024Props,
                        group1025Props: frame96Props.group1025Props
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame97Default.default), {
                        className: frame97Props.className,
                        toggleProps: frame97Props.toggleProps,
                        group1021Props: frame97Props.group1021Props,
                        group1022Props: frame97Props.group1022Props,
                        group1023Props: frame97Props.group1023Props,
                        group1024Props: frame97Props.group1024Props,
                        group1025Props: frame97Props.group1025Props
                    })
                ]
            })
        })
    });
}
exports.default = DecisionalView2;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"b9X5n","../NavItems2":"bnQuI","../NavItems3":"fOarC","../Frame11732":"gSRJf","../Toggle":"dSqDu","../Frame96":"hkhn3","../Frame97":"2DMi4","./DecisionalView2.css":"jfoFV","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jfoFV":[function() {},{}],"5osad":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _frame92 = require("../Frame92");
var _frame92Default = parcelHelpers.interopDefault(_frame92);
var _frame11732 = require("../Frame11732");
var _frame11732Default = parcelHelpers.interopDefault(_frame11732);
var _frame97 = require("../Frame97");
var _frame97Default = parcelHelpers.interopDefault(_frame97);
var _physicalModel2Css = require("./PhysicalModel2.css");
function PhysicalModel2(props) {
    const { x1200PxLogo_Icam__20081, pleaseAnswerTheFollowingQuestions, navItems2Props, navItems3Props, toggleProps, frame92Props, frame11732Props, frame97Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "physical-model-2-1 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-47",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "rectangle-3-19"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {
                            className: navItems2Props.className
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                            className: navItems3Props.className,
                            frame1172Props: navItems3Props.frame1172Props,
                            frame1162Props: navItems3Props.frame1162Props,
                            frame1132Props: navItems3Props.frame1132Props
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-46",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "please-answer-the-following-questions-17 valign-text-middle bevan-normal-white-20px",
                            children: pleaseAnswerTheFollowingQuestions
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            className: toggleProps.className,
                            buttonSecondaryProps: toggleProps.buttonSecondaryProps
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame92Default.default), {
                            toggleProps: frame92Props.toggleProps,
                            group1021Props: frame92Props.group1021Props,
                            group1022Props: frame92Props.group1022Props,
                            group1023Props: frame92Props.group1023Props,
                            group1024Props: frame92Props.group1024Props,
                            group1025Props: frame92Props.group1025Props
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11732Default.default), {
                    className: frame11732Props.className
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame97Default.default), {
                    className: frame97Props.className,
                    toggleProps: frame97Props.toggleProps,
                    group1021Props: frame97Props.group1021Props,
                    group1022Props: frame97Props.group1022Props,
                    group1023Props: frame97Props.group1023Props,
                    group1024Props: frame97Props.group1024Props,
                    group1025Props: frame97Props.group1025Props
                })
            ]
        })
    });
}
exports.default = PhysicalModel2;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"b9X5n","../NavItems2":"bnQuI","../NavItems3":"fOarC","../Toggle":"dSqDu","../Frame92":"5oCBl","../Frame11732":"gSRJf","../Frame97":"2DMi4","./PhysicalModel2.css":"gbnsa","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5oCBl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _group102 = require("../Group102");
var _group102Default = parcelHelpers.interopDefault(_group102);
var _frame92Css = require("./Frame92.css");
function Frame92(props) {
    const { className, toggleProps, group1021Props, group1022Props, group1023Props, group1024Props, group1025Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `frame-92 ${className || ""}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                className: toggleProps.className,
                buttonSecondaryProps: toggleProps.buttonSecondaryProps
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "vos-employs-sont-ils-3 subtitel",
                name: "vosemploy\xe9ssont-ilsforcedepropositionsconcernantlesinnovations",
                placeholder: "Vos employ\xe9s sont-ils force de propositions concernant les innovations?",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1021Props.line24,
                className: group1021Props.className
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "avez-vous-un-managem-3 subtitel",
                name: "avezvousunmanagementquifavoriselcr\xe9ativit\xe9dessalari\xe9s",
                placeholder: "Avez vous un management qui favorise l cr\xe9ativit\xe9 des salari\xe9s?",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1022Props.line24,
                className: group1022Props.className
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "sez-vous-3 subtitel",
                name: "garantissezvousl\xe9galit\xe9deschancesdetouslestravailleurscomment",
                placeholder: "Garantissez vous l\u2019\xe9galit\xe9 des chances de tous les travailleurs? Comment?",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1023Props.line24,
                className: group1023Props.className
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "sez-vous-3 subtitel",
                name: "quelmanagementutilisezvous",
                placeholder: "Quel management utilisez vous?",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1024Props.line24,
                className: group1024Props.className
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "est-ce-que-les-journ-3 subtitel",
                name: "est-cequelesjourn\xe9esdetravailsontadapt\xe9esauvolumedetravail",
                placeholder: "Est-ce que les journ\xe9es de travail sont adapt\xe9es au volume de travail?",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1025Props.line24,
                className: group1025Props.className
            })
        ]
    });
}
exports.default = Frame92;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","../Toggle":"dSqDu","../Group102":"cllgP","./Frame92.css":"a4wwD","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"a4wwD":[function() {},{}],"gbnsa":[function() {},{}],"g4ujd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _frame92 = require("../Frame92");
var _frame92Default = parcelHelpers.interopDefault(_frame92);
var _frame93 = require("../Frame93");
var _frame93Default = parcelHelpers.interopDefault(_frame93);
var _decisionalView3Css = require("./DecisionalView3.css");
function DecisionalView3(props) {
    const { x1200PxLogo_Icam__20081, pleaseAnswerTheFollowingQuestions, procesView, navItems2Props, navItems3Props, toggleProps, frame92Props, frame93Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "decisional-view-3 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-48",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "rectangle-3-20"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {
                            className: navItems2Props.className
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                            className: navItems3Props.className,
                            frame1172Props: navItems3Props.frame1172Props,
                            frame1162Props: navItems3Props.frame1162Props,
                            frame1132Props: navItems3Props.frame1132Props
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-47",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "please-answer-the-following-questions-18 valign-text-middle bevan-normal-white-20px",
                            children: pleaseAnswerTheFollowingQuestions
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            className: toggleProps.className,
                            buttonSecondaryProps: toggleProps.buttonSecondaryProps
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame92Default.default), {
                            className: frame92Props.className,
                            toggleProps: frame92Props.toggleProps,
                            group1021Props: frame92Props.group1021Props,
                            group1022Props: frame92Props.group1022Props,
                            group1023Props: frame92Props.group1023Props,
                            group1024Props: frame92Props.group1024Props,
                            group1025Props: frame92Props.group1025Props
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame93Default.default), {
                            toggleProps: frame93Props.toggleProps,
                            group1021Props: frame93Props.group1021Props,
                            group1022Props: frame93Props.group1022Props,
                            group1023Props: frame93Props.group1023Props,
                            group1024Props: frame93Props.group1024Props,
                            group1025Props: frame93Props.group1025Props
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "frame-113-57",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "proces-view valign-text-middle inter-bold-mineral-green-18px",
                        children: procesView
                    })
                })
            ]
        })
    });
}
exports.default = DecisionalView3;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"b9X5n","../NavItems2":"bnQuI","../NavItems3":"fOarC","../Toggle":"dSqDu","../Frame92":"5oCBl","../Frame93":"2W23F","./DecisionalView3.css":"9Td9L","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2W23F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _group102 = require("../Group102");
var _group102Default = parcelHelpers.interopDefault(_group102);
var _frame93Css = require("./Frame93.css");
function Frame93(props) {
    const { className, toggleProps, group1021Props, group1022Props, group1023Props, group1024Props, group1025Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `frame-93-1 ${className || ""}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                className: toggleProps.className,
                buttonSecondaryProps: toggleProps.buttonSecondaryProps
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "aprs-combien-de-temp-4 subtitel",
                name: "apr\xe8scombiendetempsunemploy\xe9peutpr\xe9tendre\xe0uneaugmentation",
                placeholder: "Apr\xe8s combien de temps un employ\xe9 peut pr\xe9tendre \xe0 une augmentation?",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1021Props.line24,
                className: group1021Props.className
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "x-de-4 subtitel",
                name: "queltypederecrutementprivil\xe9giezvousinterneouexterne",
                placeholder: "Quel type de recrutement privil\xe9giez vous? Interne ou externe",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1022Props.line24,
                className: group1022Props.className
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "x-de-4 subtitel",
                name: "arbitrezvousdefa\xe7on\xe9quilibr\xe9eentrelesbesoinsdelorganisationetceuxdespartiesprenantes",
                placeholder: "Arbitrez vous de fa\xe7on \xe9quilibr\xe9e entre les besoins de l\u2019organisation et ceux des parties prenantes?",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1023Props.line24,
                className: group1023Props.className
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "accompagnez-vous-les-4 subtitel",
                name: "accompagnezvouslestravailleursquiveulentmonterleurpropreorganisation",
                placeholder: "Accompagnez vous les travailleurs qui veulent monter leur propre organisation?",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1024Props.line24,
                className: group1024Props.className
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "quel-est-le-turnover-4 subtitel",
                name: "quelestleturnoverdelentreprisepluselleestgrandemoinslesemploy\xe9srestent",
                placeholder: "Quel est le turnover de l\u2019entreprise (plus elle est  grande moins les employ\xe9s restent)?",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1025Props.line24,
                className: group1025Props.className
            })
        ]
    });
}
exports.default = Frame93;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","../Toggle":"dSqDu","../Group102":"cllgP","./Frame93.css":"9UDOI","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9UDOI":[function() {},{}],"9Td9L":[function() {},{}],"3Qna7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _frame92 = require("../Frame92");
var _frame92Default = parcelHelpers.interopDefault(_frame92);
var _frame93 = require("../Frame93");
var _frame93Default = parcelHelpers.interopDefault(_frame93);
var _physicalModel3Css = require("./PhysicalModel3.css");
function PhysicalModel3(props) {
    const { x1200PxLogo_Icam__20081, pleaseAnswerTheFollowingQuestions, decisionalView, navItems2Props, navItems3Props, toggleProps, frame92Props, frame93Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "physical-model-3-1 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-50",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "rectangle-3-21"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {
                            className: navItems2Props.className
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                            className: navItems3Props.className,
                            frame1172Props: navItems3Props.frame1172Props,
                            frame1162Props: navItems3Props.frame1162Props,
                            frame1132Props: navItems3Props.frame1132Props
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-49",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "please-answer-the-following-questions-19 valign-text-middle bevan-normal-white-20px",
                            children: pleaseAnswerTheFollowingQuestions
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            className: toggleProps.className,
                            buttonSecondaryProps: toggleProps.buttonSecondaryProps
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame92Default.default), {
                            className: frame92Props.className,
                            toggleProps: frame92Props.toggleProps,
                            group1021Props: frame92Props.group1021Props,
                            group1022Props: frame92Props.group1022Props,
                            group1023Props: frame92Props.group1023Props,
                            group1024Props: frame92Props.group1024Props,
                            group1025Props: frame92Props.group1025Props
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame93Default.default), {
                            className: frame93Props.className,
                            toggleProps: frame93Props.toggleProps,
                            group1021Props: frame93Props.group1021Props,
                            group1022Props: frame93Props.group1022Props,
                            group1023Props: frame93Props.group1023Props,
                            group1024Props: frame93Props.group1024Props,
                            group1025Props: frame93Props.group1025Props
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "frame-113-58",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "decisional-view valign-text-middle inter-bold-mineral-green-18px",
                        children: decisionalView
                    })
                })
            ]
        })
    });
}
exports.default = PhysicalModel3;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"b9X5n","../NavItems2":"bnQuI","../NavItems3":"fOarC","../Toggle":"dSqDu","../Frame92":"5oCBl","../Frame93":"2W23F","./PhysicalModel3.css":"8LdhO","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8LdhO":[function() {},{}],"a8FJe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _frame922 = require("../Frame922");
var _frame922Default = parcelHelpers.interopDefault(_frame922);
var _frame93 = require("../Frame93");
var _frame93Default = parcelHelpers.interopDefault(_frame93);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _frame11732 = require("../Frame11732");
var _frame11732Default = parcelHelpers.interopDefault(_frame11732);
var _functionnalView2Css = require("./FunctionnalView2.css");
function FunctionnalView2(props) {
    const { x1200PxLogo_Icam__20081, pleaseAnswerTheFollowingQuestions, navItems2Props, navItems3Props, frame922Props, frame93Props, toggleProps } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "functionnal-view-2 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group1-34",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "overlap-group-51",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "rectangle-3-22"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {
                                    className: navItems2Props.className
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                                    className: navItems3Props.className,
                                    frame1172Props: navItems3Props.frame1172Props,
                                    frame1162Props: navItems3Props.frame1162Props,
                                    frame1132Props: navItems3Props.frame1132Props
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                    to: "/home",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        className: "x1200px-logo_icam_-_2008-1-50",
                                        src: x1200PxLogo_Icam__20081,
                                        alt: "1200px-Logo_ICAM_-_2008 1"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "please-answer-the-following-questions-20 valign-text-middle bevan-normal-white-20px",
                                    children: pleaseAnswerTheFollowingQuestions
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame922Default.default), {
                                    toggleProps: frame922Props.toggleProps,
                                    group1021Props: frame922Props.group1021Props,
                                    group1022Props: frame922Props.group1022Props,
                                    group1023Props: frame922Props.group1023Props,
                                    group1024Props: frame922Props.group1024Props,
                                    group1025Props: frame922Props.group1025Props
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame93Default.default), {
                            className: frame93Props.className,
                            toggleProps: frame93Props.toggleProps,
                            group1021Props: frame93Props.group1021Props,
                            group1022Props: frame93Props.group1022Props,
                            group1023Props: frame93Props.group1023Props,
                            group1024Props: frame93Props.group1024Props,
                            group1025Props: frame93Props.group1025Props
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-93",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            className: toggleProps.className,
                            buttonSecondaryProps: toggleProps.buttonSecondaryProps
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11732Default.default), {})
                    ]
                })
            ]
        })
    });
}
exports.default = FunctionnalView2;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"b9X5n","../NavItems2":"bnQuI","../NavItems3":"fOarC","../Frame922":"3TvAG","../Frame93":"2W23F","../Toggle":"dSqDu","../Frame11732":"gSRJf","./FunctionnalView2.css":"f30z8","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3TvAG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _group102 = require("../Group102");
var _group102Default = parcelHelpers.interopDefault(_group102);
var _frame922Css = require("./Frame922.css");
function Frame922(props) {
    const { className, toggleProps, group1021Props, group1022Props, group1023Props, group1024Props, group1025Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `frame-92-2 ${className || ""}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                className: toggleProps.className,
                buttonSecondaryProps: toggleProps.buttonSecondaryProps
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "vos-employs-sont-ils-6 subtitel",
                name: "vosemploy\xe9ssont-ilsforcedepropositionsconcernantlesinnovations",
                placeholder: "Vos employ\xe9s sont-ils force de propositions concernant les innovations?",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1021Props.line24,
                className: group1021Props.className
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "avez-vous-un-managem-6 subtitel",
                name: "avezvousunmanagementquifavoriselcr\xe9ativit\xe9dessalari\xe9s",
                placeholder: "Avez vous un management qui favorise l cr\xe9ativit\xe9 des salari\xe9s?",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1022Props.line24,
                className: group1022Props.className
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "sez-vous-6 subtitel",
                name: "garantissezvousl\xe9galit\xe9deschancesdetouslestravailleurscomment",
                placeholder: "Garantissez vous l\u2019\xe9galit\xe9 des chances de tous les travailleurs? Comment?",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1023Props.line24,
                className: group1023Props.className
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "sez-vous-6 subtitel",
                name: "quelmanagementutilisezvous",
                placeholder: "Quel management utilisez vous?",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1024Props.line24,
                className: group1024Props.className
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "est-ce-que-les-journ-6 subtitel",
                name: "est-cequelesjourn\xe9esdetravailsontadapt\xe9esauvolumedetravail",
                placeholder: "Est-ce que les journ\xe9es de travail sont adapt\xe9es au volume de travail?",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1025Props.line24,
                className: group1025Props.className
            })
        ]
    });
}
exports.default = Frame922;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","../Toggle":"dSqDu","../Group102":"cllgP","./Frame922.css":"ejMnz","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ejMnz":[function() {},{}],"f30z8":[function() {},{}],"dr1m3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _frame922 = require("../Frame922");
var _frame922Default = parcelHelpers.interopDefault(_frame922);
var _frame93 = require("../Frame93");
var _frame93Default = parcelHelpers.interopDefault(_frame93);
var _frame11732 = require("../Frame11732");
var _frame11732Default = parcelHelpers.interopDefault(_frame11732);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _functionnalView3Css = require("./FunctionnalView3.css");
function FunctionnalView3(props) {
    const { x1200PxLogo_Icam__20081, pleaseAnswerTheFollowingQuestions, navItems2Props, navItems3Props, frame922Props, frame93Props, frame11732Props, toggleProps } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "functionnal-view-3 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-52",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "rectangle-3-23"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {
                            className: navItems2Props.className
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                            className: navItems3Props.className,
                            frame1172Props: navItems3Props.frame1172Props,
                            frame1162Props: navItems3Props.frame1162Props,
                            frame1132Props: navItems3Props.frame1132Props
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-51",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "please-answer-the-following-questions-21 valign-text-middle bevan-normal-white-20px",
                            children: pleaseAnswerTheFollowingQuestions
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame922Default.default), {
                            className: frame922Props.className,
                            toggleProps: frame922Props.toggleProps,
                            group1021Props: frame922Props.group1021Props,
                            group1022Props: frame922Props.group1022Props,
                            group1023Props: frame922Props.group1023Props,
                            group1024Props: frame922Props.group1024Props,
                            group1025Props: frame922Props.group1025Props
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame93Default.default), {
                            className: frame93Props.className,
                            toggleProps: frame93Props.toggleProps,
                            group1021Props: frame93Props.group1021Props,
                            group1022Props: frame93Props.group1022Props,
                            group1023Props: frame93Props.group1023Props,
                            group1024Props: frame93Props.group1024Props,
                            group1025Props: frame93Props.group1025Props
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11732Default.default), {
                    className: frame11732Props.className
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                    className: toggleProps.className,
                    buttonSecondaryProps: toggleProps.buttonSecondaryProps
                })
            ]
        })
    });
}
exports.default = FunctionnalView3;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"b9X5n","../NavItems2":"bnQuI","../NavItems3":"fOarC","../Frame922":"3TvAG","../Frame93":"2W23F","../Frame11732":"gSRJf","../Toggle":"dSqDu","./FunctionnalView3.css":"a4x5o","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"a4x5o":[function() {},{}],"fNcXj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _group102 = require("../Group102");
var _group102Default = parcelHelpers.interopDefault(_group102);
var _functionnalView4Css = require("./FunctionnalView4.css");
function FunctionnalView4(props) {
    const { x1200PxLogo_Icam__20081, pleaseAnswerTheFollowingQuestions, inputType1, inputPlaceholder1, inputType2, inputPlaceholder2, inputType3, inputPlaceholder3, inputType4, inputPlaceholder4, physicalModel, navItems3Props, toggle1Props, group1021Props, group1022Props, group1023Props, group1024Props, toggle2Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "functionnal-view-4 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-53",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-52",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "nav-items-container-22",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                                    className: navItems3Props.className,
                                    frame1172Props: navItems3Props.frame1172Props,
                                    frame1162Props: navItems3Props.frame1162Props,
                                    frame1132Props: navItems3Props.frame1132Props
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {})
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "please-answer-the-following-questions-22 valign-text-middle bevan-normal-white-20px",
                    children: pleaseAnswerTheFollowingQuestions
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "frame-85-2",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            className: toggle1Props.className,
                            buttonSecondaryProps: toggle1Props.buttonSecondaryProps
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                            className: "traitez-vous-vos-dchets subtitel",
                            name: "traitezvousvosd\xe9chets",
                            placeholder: inputPlaceholder1,
                            type: inputType1
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                            line24: group1021Props.line24,
                            className: group1021Props.className
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                            className: "quel-type-demballage-utilisez-vous subtitel",
                            name: "queltypedemballageutilisezvous",
                            placeholder: inputPlaceholder2,
                            type: inputType2
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                            line24: group1022Props.line24,
                            className: group1022Props.className
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                            className: "frame-85-item subtitel",
                            name: "lagestiondeseauxus\xe9esfaitellepartiedevotrepolitique",
                            placeholder: inputPlaceholder3,
                            type: inputType3
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                            line24: group1023Props.line24
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                            className: "frame-85-item subtitel",
                            name: "yat-ilunetra\xe7abilit\xe9dutraitementdevosd\xe9chets",
                            placeholder: inputPlaceholder4,
                            type: inputType4
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                            line24: group1024Props.line24
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-94",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            className: toggle2Props.className,
                            buttonSecondaryProps: toggle2Props.buttonSecondaryProps
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/physical-model-2",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "frame-113-59",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "physical-model-11 valign-text-middle inter-bold-mineral-green-18px",
                                    children: physicalModel
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = FunctionnalView4;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"b9X5n","../NavItems3":"fOarC","../NavItems2":"bnQuI","../Toggle":"dSqDu","../Group102":"cllgP","./FunctionnalView4.css":"cMfXU","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cMfXU":[function() {},{}],"674ZU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _frame112 = require("../Frame112");
var _frame112Default = parcelHelpers.interopDefault(_frame112);
var _loadingPageCss = require("./LoadingPage.css");
function LoadingPage(props) {
    const { x1200PxLogo_Icam__20081, inViewOfTheAnswe, navItems3Props, frame112Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "loading-page screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-54",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-53",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "nav-items-container-23",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                                    className: navItems3Props.className,
                                    frame1172Props: navItems3Props.frame1172Props,
                                    frame1162Props: navItems3Props.frame1162Props,
                                    frame1132Props: navItems3Props.frame1132Props
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {})
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "in-view-of-the-answe valign-text-middle bevan-normal-white-20px",
                    children: inViewOfTheAnswe
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame112Default.default), {
                    children: frame112Props.children
                })
            ]
        })
    });
}
exports.default = LoadingPage;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"b9X5n","../NavItems3":"fOarC","../NavItems2":"bnQuI","../Frame112":"ad5n2","./LoadingPage.css":"4gmdL","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ad5n2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _frame112Css = require("./Frame112.css");
function Frame112(props) {
    const { children, className } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `frame-112-6 ${className || ""}`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "click-here valign-text-middle inter-bold-mineral-green-18px",
            children: children
        })
    });
}
exports.default = Frame112;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"b9X5n","./Frame112.css":"jYjQy","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jYjQy":[function() {},{}],"4gmdL":[function() {},{}],"hBp5q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _kaizen1Css = require("./Kaizen1.css");
var _jspdf = require("jspdf");
var _jspdfDefault = parcelHelpers.interopDefault(_jspdf);
var _html2Canvas = require("html2canvas");
var _html2CanvasDefault = parcelHelpers.interopDefault(_html2Canvas);
function Kaizen1(props) {
    const { x1200PxLogo_Icam__20081 } = props;
    const [hasImplemented, setHasImplemented] = (0, _react.useState)(false);
    const [showQuestionnaire, setShowQuestionnaire] = (0, _react.useState)(false);
    const [showImport, setShowImport] = (0, _react.useState)(false);
    const [currentStep, setCurrentStep] = (0, _react.useState)(1);
    const [answers, setAnswers] = (0, _react.useState)({
        // Part 1: Current State - Kaizen Application Today
        // Kaizen Culture & Organization
        dedicatedStructure: "",
        participationPercentage: "",
        improvementIdeasCount: "",
        suggestionsAnalysis: "",
        problemTypes: "",
        // Kaizen Actions Implementation
        ideasFormalization: "",
        kaizenMethodology: "",
        implementationDelay: "",
        measurableGains: "",
        regularReviews: "",
        // Part 2: Vision and Desired Future State
        // Kaizen Ambitions
        volumeObjectives: "",
        teamsIntegration: "",
        teamAutonomy: "",
        supportTools: "",
        cultureReinforcement: "",
        // Part 3: Monitoring, Gap Analysis & Continuous Improvement Governance
        // Governance & Indicators
        performanceIndicators: "",
        dedicatedDashboard: "",
        biggestSuccesses: "",
        obstacles: "",
        failureManagement: "",
        // Training & Engagement
        employeeTraining: "",
        managerTraining: "",
        bestPracticesValorization: "",
        kaizenRituals: "",
        roadmap: ""
    });
    const [uploadStatus, setUploadStatus] = (0, _react.useState)({
        isUploading: false,
        progress: 0,
        error: null,
        success: false,
        fileName: ""
    });
    const fileInputRef = (0, _react.useRef)(null);
    const questionnaireRef = (0, _react.useRef)(null);
    const handleImportClick = ()=>{
        fileInputRef.current.click();
    };
    const handleFileUpload = async (event)=>{
        const file = event.target.files[0];
        if (!file) return;
        // File type validation
        const allowedTypes = [
            'application/pdf',
            'image/jpeg',
            'image/png',
            'image/svg+xml',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.ms-excel',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/msword'
        ];
        if (!allowedTypes.includes(file.type)) {
            setUploadStatus({
                ...uploadStatus,
                error: "Unsupported file type. Please upload PDF, JPG, PNG, SVG, Excel or Word formats.",
                success: false
            });
            return;
        }
        // File size validation (max 10MB)
        const maxSize = 10485760; // 10MB
        if (file.size > maxSize) {
            setUploadStatus({
                ...uploadStatus,
                error: "File too large. Maximum allowed size: 10MB.",
                success: false
            });
            return;
        }
        try {
            setUploadStatus({
                isUploading: true,
                progress: 0,
                error: null,
                success: false,
                fileName: file.name
            });
            // Prepare FormData
            const formData = new FormData();
            formData.append('file', file);
            formData.append('answers', JSON.stringify(answers));
            const xhr = new XMLHttpRequest();
            xhr.upload.onprogress = (event)=>{
                if (event.lengthComputable) {
                    const progress = Math.round(event.loaded / event.total * 100);
                    setUploadStatus((prev)=>({
                            ...prev,
                            progress
                        }));
                }
            };
            const uploadPromise = new Promise((resolve, reject)=>{
                xhr.onload = ()=>{
                    if (xhr.status === 200) resolve(JSON.parse(xhr.response));
                    else reject(new Error(`Upload failed with status ${xhr.status}`));
                };
                xhr.onerror = ()=>reject(new Error('Upload failed'));
            });
            xhr.open('POST', '/api/kaizen/upload');
            xhr.send(formData);
            const response = await uploadPromise;
            setUploadStatus({
                isUploading: false,
                progress: 100,
                error: null,
                success: true,
                fileName: file.name,
                fileId: response.file_id
            });
        } catch (error) {
            setUploadStatus({
                isUploading: false,
                progress: 0,
                error: "An error occurred during upload. Please try again.",
                success: false,
                fileName: ""
            });
        }
    };
    const handleAnswerChange = (field, value)=>{
        setAnswers({
            ...answers,
            [field]: value
        });
    };
    const handleNextStep = ()=>{
        if (currentStep < 3) {
            setCurrentStep(currentStep + 1);
            if (questionnaireRef.current) questionnaireRef.current.scrollTop = 0;
        } else setShowImport(true);
    };
    const handlePrevStep = ()=>{
        if (currentStep > 1) {
            setCurrentStep(currentStep - 1);
            if (questionnaireRef.current) questionnaireRef.current.scrollTop = 0;
        }
    };
    const handleYesClick = ()=>{
        setHasImplemented(true);
        setShowQuestionnaire(true);
    };
    const renderProgressIndicator = ()=>{
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "progress-indicator",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: `progress-step ${currentStep >= 1 ? 'active' : ''} ${currentStep > 1 ? 'completed' : ''}`,
                    children: "1"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: `progress-step ${currentStep >= 2 ? 'active' : ''} ${currentStep > 2 ? 'completed' : ''}`,
                    children: "2"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: `progress-step ${currentStep >= 3 ? 'active' : ''}`,
                    children: "3"
                })
            ]
        });
    };
    const renderQuestionnaire = ()=>{
        switch(currentStep){
            case 1:
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questionnaire-step",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                            className: "step-title",
                            children: "Part 1: Current State - Kaizen Application Today"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "question-group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                    className: "question-group-title",
                                    children: "Kaizen Culture & Organization"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "dedicatedStructure",
                                            children: "Do you have a dedicated structure or Kaizen manager?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "dedicatedStructure",
                                            value: answers.dedicatedStructure,
                                            onChange: (e)=>handleAnswerChange('dedicatedStructure', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "participationPercentage",
                                            children: "What percentage of employees actively contribute to Kaizen initiatives?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "participationPercentage",
                                            value: answers.participationPercentage,
                                            onChange: (e)=>handleAnswerChange('participationPercentage', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "improvementIdeasCount",
                                            children: "How many continuous improvement ideas are proposed each month or quarter?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "improvementIdeasCount",
                                            value: answers.improvementIdeasCount,
                                            onChange: (e)=>handleAnswerChange('improvementIdeasCount', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "suggestionsAnalysis",
                                            children: "Are employees' suggestions always analyzed, prioritized, and tracked?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "suggestionsAnalysis",
                                            value: answers.suggestionsAnalysis,
                                            onChange: (e)=>handleAnswerChange('suggestionsAnalysis', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "problemTypes",
                                            children: "What types of problems are most often addressed? (Safety, quality, delays, waste\xe2\u20AC\xa6)"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "problemTypes",
                                            value: answers.problemTypes,
                                            onChange: (e)=>handleAnswerChange('problemTypes', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "question-group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                    className: "question-group-title",
                                    children: "Kaizen Actions Implementation"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "ideasFormalization",
                                            children: "How are Kaizen ideas formalized? (paper form, digital tool\xe2\u20AC\xa6)"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "ideasFormalization",
                                            value: answers.ideasFormalization,
                                            onChange: (e)=>handleAnswerChange('ideasFormalization', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "kaizenMethodology",
                                            children: "Do you have a structured Kaizen methodology? (PDCA, A3, DMAIC\xe2\u20AC\xa6)"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "kaizenMethodology",
                                            value: answers.kaizenMethodology,
                                            onChange: (e)=>handleAnswerChange('kaizenMethodology', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "implementationDelay",
                                            children: "What is the average delay between the idea proposal and its implementation?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "implementationDelay",
                                            value: answers.implementationDelay,
                                            onChange: (e)=>handleAnswerChange('implementationDelay', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "measurableGains",
                                            children: "Are Kaizen actions oriented toward measurable gains? (time, quality, cost\xe2\u20AC\xa6)"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "measurableGains",
                                            value: answers.measurableGains,
                                            onChange: (e)=>handleAnswerChange('measurableGains', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "regularReviews",
                                            children: "Do you conduct regular reviews or presentations of completed Kaizen actions?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "regularReviews",
                                            value: answers.regularReviews,
                                            onChange: (e)=>handleAnswerChange('regularReviews', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                });
            case 2:
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questionnaire-step",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                            className: "step-title",
                            children: " Part 2: Vision & Desired Future State"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "question-group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                    className: "question-group-title",
                                    children: " Kaizen Ambitions"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "volumeObjectives",
                                            children: "What objectives do you have regarding Kaizen volume or impact for the coming year?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "volumeObjectives",
                                            value: answers.volumeObjectives,
                                            onChange: (e)=>handleAnswerChange('volumeObjectives', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "teamsIntegration",
                                            children: "Do you want to engage more teams in Kaizen? (support functions, management, procurement\xe2\u20AC\xa6)"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "teamsIntegration",
                                            value: answers.teamsIntegration,
                                            onChange: (e)=>handleAnswerChange('teamsIntegration', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "teamAutonomy",
                                            children: "Are you aiming for full team autonomy in identifying and solving problems?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "teamAutonomy",
                                            value: answers.teamAutonomy,
                                            onChange: (e)=>handleAnswerChange('teamAutonomy', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "supportTools",
                                            children: "What tools or systems do you want to deploy to support Kaizen (visual boards, digital ideas system\xe2\u20AC\xa6)?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "supportTools",
                                            value: answers.supportTools,
                                            onChange: (e)=>handleAnswerChange('supportTools', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "cultureReinforcement",
                                            children: "Do you want to strengthen the Kaizen culture through challenges or rewards?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "cultureReinforcement",
                                            value: answers.cultureReinforcement,
                                            onChange: (e)=>handleAnswerChange('cultureReinforcement', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                });
            case 3:
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questionnaire-step",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                            className: "step-title",
                            children: "Part 3: Monitoring, Gap Analysis & Continuous Improvement Governance"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "question-group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                    className: "question-group-title",
                                    children: "Governance & Indicators"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "performanceIndicators",
                                            children: "Which performance indicators do you use to evaluate Kaizen efficiency? (number of ideas, implementation rate, ROI\xe2\u20AC\xa6)"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "performanceIndicators",
                                            value: answers.performanceIndicators,
                                            onChange: (e)=>handleAnswerChange('performanceIndicators', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "dedicatedDashboard",
                                            children: "Do you have a dedicated continuous improvement dashboard?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "dedicatedDashboard",
                                            value: answers.dedicatedDashboard,
                                            onChange: (e)=>handleAnswerChange('dedicatedDashboard', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "biggestSuccesses",
                                            children: "What are the greatest successes obtained thanks to Kaizen?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "biggestSuccesses",
                                            value: answers.biggestSuccesses,
                                            onChange: (e)=>handleAnswerChange('biggestSuccesses', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "obstacles",
                                            children: "What obstacles or resistance have you faced when implementing Kaizen?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "obstacles",
                                            value: answers.obstacles,
                                            onChange: (e)=>handleAnswerChange('obstacles', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "failureManagement",
                                            children: "How do you manage failures or ideas that do not lead to an action?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "failureManagement",
                                            value: answers.failureManagement,
                                            onChange: (e)=>handleAnswerChange('failureManagement', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "question-group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                    className: "question-group-title",
                                    children: " Training & Engagement"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "employeeTraining",
                                            children: "Have your employees been trained in Kaizen principles and tools?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "employeeTraining",
                                            value: answers.employeeTraining,
                                            onChange: (e)=>handleAnswerChange('employeeTraining', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "managerTraining",
                                            children: "Are frontline managers trained and involved in leading Kaizen initiatives?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "managerTraining",
                                            value: answers.managerTraining,
                                            onChange: (e)=>handleAnswerChange('managerTraining', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "bestPracticesValorization",
                                            children: "How do you highlight Kaizen best practices and success stories?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "bestPracticesValorization",
                                            value: answers.bestPracticesValorization,
                                            onChange: (e)=>handleAnswerChange('bestPracticesValorization', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "kaizenRituals",
                                            children: "Do you have daily, weekly, or monthly Kaizen rituals? (meetings, briefings, Gemba walk\xe2\u20AC\xa6)"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "kaizenRituals",
                                            value: answers.kaizenRituals,
                                            onChange: (e)=>handleAnswerChange('kaizenRituals', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "roadmap",
                                            children: "What is your roadmap for making Kaizen a strategic competitiveness lever?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "roadmap",
                                            value: answers.roadmap,
                                            onChange: (e)=>handleAnswerChange('roadmap', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                });
            default:
                return null;
        }
    };
    const handleDownloadPDF = async ()=>{
        try {
            const element = document.querySelector(".kaizen1-page");
            if (!element) {
                alert("\xe2\x9d\u0152 Element not found!");
                return;
            }
            document.querySelectorAll("*").forEach((el)=>{
                const bgImage = window.getComputedStyle(el).backgroundImage;
                if (bgImage && bgImage.includes("gradient")) el.style.backgroundImage = "none";
                const bgColor = window.getComputedStyle(el).backgroundColor;
                if (bgColor.includes("var(") || bgColor === "transparent" || bgColor === "rgba(0, 0, 0, 0)") el.style.backgroundColor = "#ffffff";
            });
            const canvas = await (0, _html2CanvasDefault.default)(element, {
                scale: 2,
                useCORS: true,
                allowTaint: true,
                backgroundColor: "#ffffff",
                logging: false
            });
            const imgData = canvas.toDataURL("image/png");
            const pdf = new (0, _jspdfDefault.default)("p", "mm", "a4");
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = pdf.internal.pageSize.getHeight();
            const imgWidth = pdfWidth;
            const imgHeight = canvas.height * pdfWidth / canvas.width;
            let heightLeft = imgHeight;
            let position = 0;
            pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
            heightLeft -= pdfHeight;
            while(heightLeft > 0){
                position = heightLeft - imgHeight;
                pdf.addPage();
                pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
                heightLeft -= pdfHeight;
            }
            const date = new Date().toISOString().slice(0, 10);
            pdf.save(`Kaizen_${date}.pdf`);
            alert("\xe2\u0153\u2026 PDF successfully generated!");
        } catch (err) {
            console.error("PDF Error:", err);
            alert("\xe2\x9d\u0152 PDF Error: " + (err.message || "unknown"));
        }
    };
    const saveLeanAnswers = async (moduleName)=>{
        try {
            const caseId = localStorage.getItem("caseId");
            if (!caseId) {
                alert("No active case found!");
                console.warn("LocalStorage is empty. Current content:", localStorage);
                return;
            }
            console.log(`\xf0\u{178}\u{2019}\xbe Saving ${moduleName} answers for case ${caseId}`);
            const response = await fetch(`${"/api"}/api/lean/${moduleName}/save`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    case_id: caseId,
                    answers: answers
                })
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.detail || `Saving error (${response.status}): ${data.message}`);
            alert(`\xe2\u{153}\u{2026} ${moduleName.toUpperCase()} answers saved successfully!`);
            handleNextStep();
        } catch (error) {
            console.error("\xe2\x9d\u0152 saveLeanAnswers error:", error);
            alert("\xe2\x9d\u0152 " + error.message);
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "kaizen1-page screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "header",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                        to: "/home",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "logo-icam",
                            src: "/img/1200px-logo-icam---2008-1@2x.png",
                            alt: "ICAM Logo"
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questionnaire-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                            className: "question-title",
                            children: "Kaizen Methodology - Continuous Improvement"
                        }),
                        !showQuestionnaire ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "question-section",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Has your company already implemented the Kaizen methodology?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "buttons-container",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            className: `choice-button ${hasImplemented ? 'active' : ''}`,
                                            onClick: handleYesClick,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            className: `choice-button ${!hasImplemented ? 'active' : ''}`,
                                            onClick: ()=>setHasImplemented(false),
                                            children: "No"
                                        })
                                    ]
                                }),
                                !hasImplemented && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "redirect-section",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "redirect-text",
                                            children: "We recommend starting with the basic Lean principles:"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                            to: "/smed-1",
                                            className: "redirect-button",
                                            children: "Go to SMED"
                                        })
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                            children: !showImport ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "questionnaire-container-inner",
                                ref: questionnaireRef,
                                children: [
                                    renderProgressIndicator(),
                                    renderQuestionnaire(),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "navigation-buttons",
                                        children: [
                                            currentStep > 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                className: "nav-button prev-button",
                                                onClick: handlePrevStep,
                                                children: "Previous"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                className: "nav-button next-button",
                                                onClick: ()=>saveLeanAnswers("kaizen"),
                                                children: currentStep < 3 ? "Next" : "Finish"
                                            })
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "file-upload-section",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                        className: "upload-title",
                                        children: "Import your existing documents"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "upload-description",
                                        children: "You can now import your Kaizen documents, dashboards, or improvement sheets:"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "upload-container",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                type: "file",
                                                ref: fileInputRef,
                                                className: "hidden-file-input",
                                                accept: ".pdf,.jpg,.jpeg,.png,.svg,.xlsx,.xls,.doc,.docx",
                                                onChange: handleFileUpload,
                                                disabled: uploadStatus.isUploading
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                className: "import-button",
                                                onClick: handleImportClick,
                                                disabled: uploadStatus.isUploading,
                                                children: uploadStatus.isUploading ? 'Uploading...' : 'Import file'
                                            }),
                                            uploadStatus.isUploading && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "upload-progress",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "progress-bar",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "progress-bar-fill",
                                                            style: {
                                                                width: `${uploadStatus.progress}%`
                                                            }
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                        className: "progress-text",
                                                        children: [
                                                            "Uploading... ",
                                                            uploadStatus.progress,
                                                            "%"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            uploadStatus.error && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "upload-error",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                    children: uploadStatus.error
                                                })
                                            }),
                                            uploadStatus.success && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "upload-success",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                        children: [
                                                            "The file ",
                                                            uploadStatus.fileName,
                                                            " was uploaded successfully!"
                                                        ]
                                                    }),
                                                    uploadStatus.fileId && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                        className: "download-button",
                                                        onClick: ()=>window.open(`/api/kaizen/${uploadStatus.fileId}`, '_blank'),
                                                        children: "View file"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "navigation-buttons",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                className: "nav-button prev-button",
                                                onClick: ()=>setShowImport(false),
                                                children: "Back to questionnaire"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                                to: "/kaizen1-1",
                                                className: "nav-button next-button",
                                                children: "Continue"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    className: "download-button",
                    onClick: handleDownloadPDF,
                    disabled: uploadStatus.isUploading,
                    children: uploadStatus.isUploading ? "Generating PDF..." : "Download PDF"
                })
            ]
        })
    });
}
exports.default = Kaizen1;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"b9X5n","./Kaizen1.css":"nESu2","jspdf":"hkJ4Q","html2canvas":"3eyQ5","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"nESu2":[function() {},{}],"fyYAC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _existingSystemsCss = require("./ExistingSystems.css");
function ExistingSystems(props) {
    const { ellipse116, x1200PxLogo_Icam__20081, existingSystems, graiMethodologyModels, x2SupplementaryModels, navItems3Props, toggle1Props, toggle2Props, toggle3Props, toggle4Props, toggle5Props, toggle6Props, toggle7Props, toggle8Props, toggle9Props, toggle10Props, toggle11Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "existing-systems-2 bevan-normal-white-20px screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    className: "ellipse-116-2",
                    src: ellipse116,
                    alt: "Ellipse 116"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-56",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-55",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "nav-items-container-25",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                                    className: navItems3Props.className,
                                    frame1172Props: navItems3Props.frame1172Props,
                                    frame1162Props: navItems3Props.frame1162Props,
                                    frame1132Props: navItems3Props.frame1132Props
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {})
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "existing-systems valign-text-middle",
                    children: existingSystems
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "y-models-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "y-models valign-text-middle",
                            children: graiMethodologyModels
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "y-models valign-text-middle",
                            children: x2SupplementaryModels
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "group-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "group-81",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex-row-101",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "toggle-container",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                                    className: toggle1Props.className,
                                                    buttonSecondaryProps: toggle1Props.buttonSecondaryProps
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                                    className: toggle2Props.className,
                                                    buttonSecondaryProps: toggle2Props.buttonSecondaryProps
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "toggle-container-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                                    className: toggle3Props.className,
                                                    buttonSecondaryProps: toggle3Props.buttonSecondaryProps
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                                    className: toggle4Props.className,
                                                    buttonSecondaryProps: toggle4Props.buttonSecondaryProps
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggle5Props.className,
                                    buttonSecondaryProps: toggle5Props.buttonSecondaryProps
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "group-82",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "toggle-container-2",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                            className: toggle6Props.className,
                                            buttonSecondaryProps: toggle6Props.buttonSecondaryProps
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                            className: toggle7Props.className,
                                            buttonSecondaryProps: toggle7Props.buttonSecondaryProps
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "toggle-container-3",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                            className: toggle8Props.className,
                                            buttonSecondaryProps: toggle8Props.buttonSecondaryProps
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                            className: toggle9Props.className,
                                            buttonSecondaryProps: toggle9Props.buttonSecondaryProps
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "toggle-container-4",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                            className: toggle10Props.className,
                                            buttonSecondaryProps: toggle10Props.buttonSecondaryProps
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                            className: toggle11Props.className,
                                            buttonSecondaryProps: toggle11Props.buttonSecondaryProps
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = ExistingSystems;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"b9X5n","../NavItems3":"fOarC","../NavItems2":"bnQuI","../Toggle":"dSqDu","./ExistingSystems.css":"iSQOH","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iSQOH":[function() {},{}],"aG5dh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _kanban1Css = require("./Kanban1.css");
var _jspdf = require("jspdf");
var _jspdfDefault = parcelHelpers.interopDefault(_jspdf);
var _html2Canvas = require("html2canvas");
var _html2CanvasDefault = parcelHelpers.interopDefault(_html2Canvas);
function Kanban1(props) {
    const { x1200PxLogo_Icam__20081 } = props;
    const [hasImplemented, setHasImplemented] = (0, _react.useState)(false);
    const [showQuestionnaire, setShowQuestionnaire] = (0, _react.useState)(false);
    const [showImport, setShowImport] = (0, _react.useState)(false);
    const [currentStep, setCurrentStep] = (0, _react.useState)(1);
    const [answers, setAnswers] = (0, _react.useState)({
        // Part 1: Current state - Use of Kanban today
        // Physical flow management
        fluxTypes: "",
        kanbanSystem: "",
        kanbanLoops: "",
        cardsNumber: "",
        kanbanUnits: "",
        // Operating logic
        replenishmentFrequency: "",
        cardsRules: "",
        stockoutManagement: "",
        loopsAdjustment: "",
        replenishmentDelay: "",
        // Part 2: Desired future state - Target vision of the Kanban system
        // Objectives and ambitions
        performanceObjectives: "",
        kanbanExtension: "",
        mrpReplacement: "",
        stockTargets: "",
        digitalization: "",
        // Part 3: Monitoring, gaps and continuous improvement
        // KPIs and governance
        kanbanKPIs: "",
        loopsResponsible: "",
        anomaliesManagement: "",
        parametersReview: "",
        implementedImprovements: "",
        // Organization and culture
        operatorsTraining: "",
        suppliersIntegration: "",
        visualSupport: "",
        culturalResistance: "",
        roadmap: ""
    });
    const [uploadStatus, setUploadStatus] = (0, _react.useState)({
        isUploading: false,
        progress: 0,
        error: null,
        success: false,
        fileName: ""
    });
    const fileInputRef = (0, _react.useRef)(null);
    const questionnaireRef = (0, _react.useRef)(null);
    const handleImportClick = ()=>{
        fileInputRef.current.click();
    };
    const handleFileUpload = async (event)=>{
        const file = event.target.files[0];
        if (!file) return;
        // File type validation
        const allowedTypes = [
            'application/pdf',
            'image/jpeg',
            'image/png',
            'image/svg+xml',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.ms-excel',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/msword'
        ];
        if (!allowedTypes.includes(file.type)) {
            setUploadStatus({
                ...uploadStatus,
                error: "Unsupported file type. Please upload PDF, JPG, PNG, SVG, Excel or Word.",
                success: false
            });
            return;
        }
        // Size validation (max 10MB)
        const maxSize = 10485760; // 10MB
        if (file.size > maxSize) {
            setUploadStatus({
                ...uploadStatus,
                error: "File is too large. Maximum size: 10MB",
                success: false
            });
            return;
        }
        try {
            setUploadStatus({
                isUploading: true,
                progress: 0,
                error: null,
                success: false,
                fileName: file.name
            });
            // Creating FormData for upload
            const formData = new FormData();
            formData.append('file', file);
            formData.append('answers', JSON.stringify(answers));
            const xhr = new XMLHttpRequest();
            xhr.upload.onprogress = (event)=>{
                if (event.lengthComputable) {
                    const progress = Math.round(event.loaded / event.total * 100);
                    setUploadStatus((prev)=>({
                            ...prev,
                            progress
                        }));
                }
            };
            const uploadPromise = new Promise((resolve, reject)=>{
                xhr.onload = ()=>{
                    if (xhr.status === 200) resolve(JSON.parse(xhr.response));
                    else reject(new Error(`Upload failed with status ${xhr.status}`));
                };
                xhr.onerror = ()=>reject(new Error('Upload failed'));
            });
            xhr.open('POST', '/api/kanban/upload');
            xhr.send(formData);
            const response = await uploadPromise;
            setUploadStatus({
                isUploading: false,
                progress: 100,
                error: null,
                success: true,
                fileName: file.name,
                fileId: response.file_id
            });
        } catch (error) {
            setUploadStatus({
                isUploading: false,
                progress: 0,
                error: "An error occurred during upload. Please try again.",
                success: false,
                fileName: ""
            });
        }
    };
    const handleAnswerChange = (field, value)=>{
        setAnswers({
            ...answers,
            [field]: value
        });
    };
    const handleNextStep = ()=>{
        if (currentStep < 3) {
            setCurrentStep(currentStep + 1);
            if (questionnaireRef.current) questionnaireRef.current.scrollTop = 0;
        } else setShowImport(true);
    };
    const handlePrevStep = ()=>{
        if (currentStep > 1) {
            setCurrentStep(currentStep - 1);
            if (questionnaireRef.current) questionnaireRef.current.scrollTop = 0;
        }
    };
    const handleYesClick = ()=>{
        setHasImplemented(true);
        setShowQuestionnaire(true);
    };
    // Progress indicator
    const renderProgressIndicator = ()=>{
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "progress-indicator",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: `progress-step ${currentStep >= 1 ? 'active' : ''} ${currentStep > 1 ? 'completed' : ''}`,
                    children: "1"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: `progress-step ${currentStep >= 2 ? 'active' : ''} ${currentStep > 2 ? 'completed' : ''}`,
                    children: "2"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: `progress-step ${currentStep >= 3 ? 'active' : ''}`,
                    children: "3"
                })
            ]
        });
    };
    // Questionnaire rendering according to step
    const renderQuestionnaire = ()=>{
        switch(currentStep){
            case 1:
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questionnaire-step",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                            className: "step-title",
                            children: "Part 1: Current state - Use of Kanban today"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "question-group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                    className: "question-group-title",
                                    children: "Physical flow management"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "fluxTypes",
                                            children: "Which types of flows are currently managed with Kanban (raw materials, parts, WIP, finished goods)?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "fluxTypes",
                                            value: answers.fluxTypes,
                                            onChange: (e)=>handleAnswerChange('fluxTypes', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "kanbanSystem",
                                            children: "Do you use a physical Kanban system (cards, bins) or an electronic one (e-Kanban, ERP, mobile apps)?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "kanbanSystem",
                                            value: answers.kanbanSystem,
                                            onChange: (e)=>handleAnswerChange('kanbanSystem', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "kanbanLoops",
                                            children: "How many Kanban loops exist in your organization?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "kanbanLoops",
                                            value: answers.kanbanLoops,
                                            onChange: (e)=>handleAnswerChange('kanbanLoops', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "cardsNumber",
                                            children: "How is the number of cards or stock level per loop defined?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "cardsNumber",
                                            value: answers.cardsNumber,
                                            onChange: (e)=>handleAnswerChange('cardsNumber', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "kanbanUnits",
                                            children: "What are the Kanban units used (fixed quantity, container, pallet, product, etc.)?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "kanbanUnits",
                                            value: answers.kanbanUnits,
                                            onChange: (e)=>handleAnswerChange('kanbanUnits', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "question-group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                    className: "question-group-title",
                                    children: "Operating logic"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "replenishmentFrequency",
                                            children: "What is the replenishment frequency in your Kanban cycle?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "replenishmentFrequency",
                                            value: answers.replenishmentFrequency,
                                            onChange: (e)=>handleAnswerChange('replenishmentFrequency', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "cardsRules",
                                            children: "Do you have clear rules for withdrawing and returning Kanban cards?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "cardsRules",
                                            value: answers.cardsRules,
                                            onChange: (e)=>handleAnswerChange('cardsRules', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "stockoutManagement",
                                            children: "How do you handle stockouts or early stockout risks?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "stockoutManagement",
                                            value: answers.stockoutManagement,
                                            onChange: (e)=>handleAnswerChange('stockoutManagement', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "loopsAdjustment",
                                            children: "Are Kanban loops adjusted based on actual demand (Takt Time, seasonality, etc.)?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "loopsAdjustment",
                                            value: answers.loopsAdjustment,
                                            onChange: (e)=>handleAnswerChange('loopsAdjustment', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "replenishmentDelay",
                                            children: "What are the average replenishment lead times on your current loops?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "replenishmentDelay",
                                            value: answers.replenishmentDelay,
                                            onChange: (e)=>handleAnswerChange('replenishmentDelay', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                });
            case 2:
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questionnaire-step",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                            className: "step-title",
                            children: " Part 2: Desired future state - Target vision of the Kanban system"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "question-group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                    className: "question-group-title",
                                    children: " Objectives and ambitions"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "performanceObjectives",
                                            children: "What performance objectives do you aim to achieve with Kanban (zero stockout, pull flow, stock reduction, flow improvements)?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "performanceObjectives",
                                            value: answers.performanceObjectives,
                                            onChange: (e)=>handleAnswerChange('performanceObjectives', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "kanbanExtension",
                                            children: "Do you plan to extend Kanban to other flows or departments (maintenance, logistics, support functions)?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "kanbanExtension",
                                            value: answers.kanbanExtension,
                                            onChange: (e)=>handleAnswerChange('kanbanExtension', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "mrpReplacement",
                                            children: "Do you intend to replace an MRP system with Kanban for some products?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "mrpReplacement",
                                            value: answers.mrpReplacement,
                                            onChange: (e)=>handleAnswerChange('mrpReplacement', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "stockTargets",
                                            children: "What is your target stock level or expected inventory reduction?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "stockTargets",
                                            value: answers.stockTargets,
                                            onChange: (e)=>handleAnswerChange('stockTargets', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "digitalization",
                                            children: "Do you plan to further digitalize your system (e-Kanban, ERP API, QR/NFC scanning)?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "digitalization",
                                            value: answers.digitalization,
                                            onChange: (e)=>handleAnswerChange('digitalization', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                });
            case 3:
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questionnaire-step",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                            className: "step-title",
                            children: "Part 3: Monitoring, gaps and continuous improvement"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "question-group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                    className: "question-group-title",
                                    children: "KPIs and governance"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "kanbanKPIs",
                                            children: "Which KPIs are monitored to evaluate Kanban performance (stockout rate, card reuse rate, cycle time, average stock)?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "kanbanKPIs",
                                            value: answers.kanbanKPIs,
                                            onChange: (e)=>handleAnswerChange('kanbanKPIs', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "loopsResponsible",
                                            children: "Who is responsible for the daily monitoring of Kanban loops?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "loopsResponsible",
                                            value: answers.loopsResponsible,
                                            onChange: (e)=>handleAnswerChange('loopsResponsible', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "anomaliesManagement",
                                            children: "How are incidents or anomalies recorded and resolved?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "anomaliesManagement",
                                            value: answers.anomaliesManagement,
                                            onChange: (e)=>handleAnswerChange('anomaliesManagement', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "parametersReview",
                                            children: "How often are Kanban loop parameters reviewed?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "parametersReview",
                                            value: answers.parametersReview,
                                            onChange: (e)=>handleAnswerChange('parametersReview', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "implementedImprovements",
                                            children: "What improvements have already been implemented in your Kanban system over the past 12 months?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "implementedImprovements",
                                            value: answers.implementedImprovements,
                                            onChange: (e)=>handleAnswerChange('implementedImprovements', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "question-group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                    className: "question-group-title",
                                    children: "Organization and culture"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "operatorsTraining",
                                            children: "Are operators/handlers trained on Kanban rules and discipline?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "operatorsTraining",
                                            value: answers.operatorsTraining,
                                            onChange: (e)=>handleAnswerChange('operatorsTraining', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "suppliersIntegration",
                                            children: "Are external suppliers or logistics partners integrated into the Kanban system?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "suppliersIntegration",
                                            value: answers.suppliersIntegration,
                                            onChange: (e)=>handleAnswerChange('suppliersIntegration', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "visualSupport",
                                            children: "Do you have effective visual support (boards, markings, color labels, etc.) for field management?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "visualSupport",
                                            value: answers.visualSupport,
                                            onChange: (e)=>handleAnswerChange('visualSupport', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "culturalResistance",
                                            children: "Do you face cultural or organizational resistance to using Kanban?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "culturalResistance",
                                            value: answers.culturalResistance,
                                            onChange: (e)=>handleAnswerChange('culturalResistance', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "roadmap",
                                            children: "What is your roadmap to stabilize, simplify or automate the Kanban system within the next 6-12 months?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "roadmap",
                                            value: answers.roadmap,
                                            onChange: (e)=>handleAnswerChange('roadmap', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                });
            default:
                return null;
        }
    };
    const handleDownloadPDF = async ()=>{
        try {
            const element = document.querySelector(".kanban-page");
            if (!element) {
                alert("\xe2\x9d\u0152 Element not found!");
                return;
            }
            document.querySelectorAll("*").forEach((el)=>{
                const bgImage = window.getComputedStyle(el).backgroundImage;
                if (bgImage && bgImage.includes("gradient")) el.style.backgroundImage = "none";
                const bgColor = window.getComputedStyle(el).backgroundColor;
                if (bgColor.includes("var(") || bgColor === "transparent" || bgColor === "rgba(0, 0, 0, 0)") el.style.backgroundColor = "#ffffff";
            });
            const canvas = await (0, _html2CanvasDefault.default)(element, {
                scale: 2,
                useCORS: true,
                allowTaint: true,
                backgroundColor: "#ffffff",
                logging: false
            });
            const imgData = canvas.toDataURL("image/png");
            const pdf = new (0, _jspdfDefault.default)("p", "mm", "a4");
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = pdf.internal.pageSize.getHeight();
            const imgWidth = pdfWidth;
            const imgHeight = canvas.height * pdfWidth / canvas.width;
            let heightLeft = imgHeight;
            let position = 0;
            pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
            heightLeft -= pdfHeight;
            while(heightLeft > 0){
                position = heightLeft - imgHeight;
                pdf.addPage();
                pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
                heightLeft -= pdfHeight;
            }
            const date = new Date().toISOString().slice(0, 10);
            pdf.save(`Kanban_${date}.pdf`);
            alert("\xe2\u0153\u2026 PDF generated successfully!");
        } catch (err) {
            console.error("PDF Error:", err);
            alert("\xe2\x9d\u0152 PDF Error: " + (err.message || "unknown error"));
        }
    };
    const saveLeanAnswers = async (moduleName)=>{
        try {
            const caseId = localStorage.getItem("caseId");
            if (!caseId) {
                alert("No active case found!");
                console.warn("LocalStorage is empty. Current content:", localStorage);
                return;
            }
            console.log(`Saving ${moduleName} answers for case ${caseId}`);
            const response = await fetch(`${"/api"}/api/lean/${moduleName}/save`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    case_id: caseId,
                    answers: answers
                })
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.detail || `Save error (${response.status}) : ${data.message}`);
            alert(`\xe2\u{153}\u{2026} ${moduleName.toUpperCase()} answers saved successfully!`);
            handleNextStep();
        } catch (error) {
            console.error("\xe2\x9d\u0152 saveLeanAnswers Error:", error);
            alert("\xe2\x9d\u0152 " + error.message);
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "kanban-page screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "header",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                        to: "/home",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "logo-icam",
                            src: "/img/1200px-logo-icam---2008-1@2x.png",
                            alt: "Logo ICAM"
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questionnaire-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                            className: "question-title",
                            children: "Kanban Methodology - Flow Management"
                        }),
                        !showQuestionnaire ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "question-section",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Has your company already implemented the Kanban methodology?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "buttons-container",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            className: `choice-button ${hasImplemented ? 'active' : ''}`,
                                            onClick: handleYesClick,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            className: `choice-button ${!hasImplemented ? 'active' : ''}`,
                                            onClick: ()=>setHasImplemented(false),
                                            children: "No"
                                        })
                                    ]
                                }),
                                !hasImplemented && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "redirect-section",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "redirect-text",
                                            children: "We recommend starting by understanding the fundamentals of Lean:"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                            to: "/visual-management-1",
                                            className: "redirect-button",
                                            children: "Go to Visual Management method"
                                        })
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                            children: !showImport ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "questionnaire-container-inner",
                                ref: questionnaireRef,
                                children: [
                                    renderProgressIndicator(),
                                    renderQuestionnaire(),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "navigation-buttons",
                                        children: [
                                            currentStep > 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                className: "nav-button prev-button",
                                                onClick: handlePrevStep,
                                                children: "Previous"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                className: "nav-button next-button",
                                                onClick: ()=>saveLeanAnswers("kanban"),
                                                children: currentStep < 3 ? "Next" : "Finish"
                                            })
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "file-upload-section",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                        className: "upload-title",
                                        children: "Import your existing documents"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "upload-description",
                                        children: "You can now upload your existing Kanban documents, dashboards, or tracking forms:"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "upload-container",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                type: "file",
                                                ref: fileInputRef,
                                                className: "hidden-file-input",
                                                accept: ".pdf,.jpg,.jpeg,.png,.svg,.xlsx,.xls,.doc,.docx",
                                                onChange: handleFileUpload,
                                                disabled: uploadStatus.isUploading
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                className: "import-button",
                                                onClick: handleImportClick,
                                                disabled: uploadStatus.isUploading,
                                                children: uploadStatus.isUploading ? "Uploading\xe2\u20AC\xa6" : 'Upload a file'
                                            }),
                                            uploadStatus.isUploading && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "upload-progress",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "progress-bar",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "progress-bar-fill",
                                                            style: {
                                                                width: `${uploadStatus.progress}%`
                                                            }
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                        className: "progress-text",
                                                        children: [
                                                            "Uploading\xe2\u20AC\xa6 ",
                                                            uploadStatus.progress,
                                                            "%"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            uploadStatus.error && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "upload-error",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                    children: uploadStatus.error
                                                })
                                            }),
                                            uploadStatus.success && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "upload-success",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                        children: [
                                                            "The file ",
                                                            uploadStatus.fileName,
                                                            " was uploaded successfully!"
                                                        ]
                                                    }),
                                                    uploadStatus.fileId && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                        className: "download-button",
                                                        onClick: ()=>window.open(`/api/kanban/${uploadStatus.fileId}`, '_blank'),
                                                        children: "View file"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "navigation-buttons",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                className: "nav-button prev-button",
                                                onClick: ()=>setShowImport(false),
                                                children: "Back to questionnaire"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                                to: "/kanban-2",
                                                className: "nav-button next-button",
                                                children: "Continue"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    className: "download-button",
                    onClick: handleDownloadPDF,
                    disabled: uploadStatus.isUploading,
                    children: uploadStatus.isUploading ? "Generating PDF\xe2\u20AC\xa6" : "Download PDF"
                })
            ]
        })
    });
}
exports.default = Kanban1;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"b9X5n","./Kanban1.css":"9jhRW","jspdf":"hkJ4Q","html2canvas":"3eyQ5","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9jhRW":[function() {},{}],"32u0v":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _frame11332 = require("../Frame11332");
var _frame11332Default = parcelHelpers.interopDefault(_frame11332);
var _frame114 = require("../Frame114");
var _frame114Default = parcelHelpers.interopDefault(_frame114);
var _frame115 = require("../Frame115");
var _frame115Default = parcelHelpers.interopDefault(_frame115);
var _frame116 = require("../Frame116");
var _frame116Default = parcelHelpers.interopDefault(_frame116);
var _frame11322 = require("../Frame11322");
var _frame11322Default = parcelHelpers.interopDefault(_frame11322);
var _frame1146 = require("../Frame1146");
var _frame1146Default = parcelHelpers.interopDefault(_frame1146);
var _frame1154 = require("../Frame1154");
var _frame1154Default = parcelHelpers.interopDefault(_frame1154);
var _frame1164 = require("../Frame1164");
var _frame1164Default = parcelHelpers.interopDefault(_frame1164);
var _frame11742 = require("../Frame11742");
var _frame11742Default = parcelHelpers.interopDefault(_frame11742);
var _frame118 = require("../Frame118");
var _frame118Default = parcelHelpers.interopDefault(_frame118);
var _headerMenuDefault4 = require("../HeaderMenuDefault4");
var _headerMenuDefault4Default = parcelHelpers.interopDefault(_headerMenuDefault4);
var _leanVSMCss = require("./LeanVSM.css");
function LeanVSM(props) {
    const { x1200PxLogo_Icam__20081, design, leanVsm, arrow4, arrow6, arrow5, rectangle7, xcontinue, arrow1, arrow2, rectangle6, line2, label1, textFormat, label2, line1, place, arrow3, modeling, clickOnModeling, frame118Props, headerMenuDefault41Props, headerMenuDefault42Props, headerMenuDefault43Props, headerMenuDefault44Props, headerMenuDefault45Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "lean-vsm-8 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group2-15",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-57",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "nav-items-container-27",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-2-39",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11332Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame114Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame115Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame116Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "frame-117-97",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "design-78 valign-text-middle inter-medium-sonic-silver-18px",
                                                children: design
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11322Default.default), {})
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-3-70",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                            to: "/lean-vsm",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "frame-113-60",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "lean-vsm-9 valign-text-middle inter-medium-white-18px",
                                                    children: leanVsm
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1146Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1154Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1164Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11742Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame118Default.default), {
                                            className: frame118Props.className,
                                            children: frame118Props.children
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-105",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "arrow-4-9",
                            src: arrow4,
                            alt: "Arrow 4"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "overlap-group3-14",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefault4Default.default), {
                                children: headerMenuDefault41Props.children
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "arrow-6-11",
                            src: arrow6,
                            alt: "Arrow 6"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-col-66",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "overlap-group1-37",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "rectangle-5-4"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "arrow-5-9",
                                            src: arrow5,
                                            alt: "Arrow 5"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "rectangle-7-4",
                                            src: rectangle7,
                                            alt: "Rectangle 7"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefault4Default.default), {
                                            className: headerMenuDefault42Props.className,
                                            children: headerMenuDefault42Props.children
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefault4Default.default), {
                                            className: headerMenuDefault43Props.className,
                                            children: headerMenuDefault43Props.children
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                    to: "/5s",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "frame-2-20",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "continue-14 valign-text-middle inter-bold-mineral-green-18px",
                                            children: xcontinue
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-106",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-col-67 inter-medium-rum-swizzle-18-1px",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "arrow-container-15",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "arrow-1-12",
                                            src: arrow1,
                                            alt: "Arrow 1"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "arrow-2-11",
                                            src: arrow2,
                                            alt: "Arrow 2"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "ellipse-88-2"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "rectangle-3-24"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    className: "rectangle-6-5",
                                    src: rectangle6,
                                    alt: "Rectangle 6"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "overlap-group-58",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "line-2-14",
                                            src: line2,
                                            alt: "Line 2"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "ellipse-86-14"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "label-133",
                                    children: label1
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    className: "text-format-15",
                                    src: textFormat,
                                    alt: "Text format"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "label-134",
                                    children: label2
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "line-1-14",
                            src: line1,
                            alt: "Line 1"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "overlap-group4-11",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefault4Default.default), {
                        className: headerMenuDefault44Props.className,
                        children: headerMenuDefault44Props.children
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-col-68",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/informational-model-1",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "frame-6-9",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "place-257 valign-text-middle inter-bold-tropical-rain-forest-18px",
                                    children: place
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "overlap-group5-9",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    className: "arrow-3-9",
                                    src: arrow3,
                                    alt: "Arrow 3"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "ellipse-87-2"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefault4Default.default), {
                                    className: headerMenuDefault45Props.className,
                                    children: headerMenuDefault45Props.children
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "frame-10-4",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                        href: "https://app.diagrams.net/",
                        target: "_blank",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "modeling-103 valign-text-middle inter-bold-tropical-rain-forest-18px",
                            children: modeling
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "click-on-modeling-13 valign-text-middle bevan-normal-white-20px",
                    children: clickOnModeling
                })
            ]
        })
    });
}
exports.default = LeanVSM;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"b9X5n","../Frame11332":"2UwVc","../Frame114":"aUtEd","../Frame115":"gPV9Y","../Frame116":"70lZ5","../Frame11322":"ju7Cp","../Frame1146":"5jzi1","../Frame1154":"YWwMr","../Frame1164":"eReDS","../Frame11742":"kufPP","../Frame118":"buB7M","../HeaderMenuDefault4":"jbQow","./LeanVSM.css":"7TiUc","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5jzi1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame1146Css = require("./Frame1146.css");
function Frame1146() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "frame-114-96",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "x5-s valign-text-middle inter-medium-star-dust-18px",
            children: "5S"
        })
    });
}
exports.default = Frame1146;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./Frame1146.css":"9PAYw","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9PAYw":[function() {},{}],"YWwMr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame1154Css = require("./Frame1154.css");
function Frame1154() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "frame-115-104",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "kaizen valign-text-middle inter-medium-star-dust-18px",
            children: "Kaizen"
        })
    });
}
exports.default = Frame1154;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./Frame1154.css":"6cZAg","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6cZAg":[function() {},{}],"eReDS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame1164Css = require("./Frame1164.css");
function Frame1164() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "frame-116-163",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "smed valign-text-middle inter-medium-star-dust-18px",
            children: "SMED"
        })
    });
}
exports.default = Frame1164;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./Frame1164.css":"kS7FS","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kS7FS":[function() {},{}],"kufPP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame11742Css = require("./Frame11742.css");
var _reactRouterDom = require("react-router-dom");
function Frame11742() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
        to: "/kanban-1",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "frame-117-76",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "kanban valign-text-middle inter-medium-star-dust-18px",
                children: "Kanban"
            })
        })
    });
}
exports.default = Frame11742;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./Frame11742.css":"1Hyys","react-router-dom":"b9X5n","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1Hyys":[function() {},{}],"buB7M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame118Css = require("./Frame118.css");
var _reactRouterDom = require("react-router-dom");
function Frame118(props) {
    const { children, className } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
        to: "/informational-model-1",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: `frame-118-2 ${className || ""}`,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "informational-model-3 valign-text-middle inter-medium-star-dust-18px",
                children: children
            })
        })
    });
}
exports.default = Frame118;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./Frame118.css":"dm7aC","react-router-dom":"b9X5n","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dm7aC":[function() {},{}],"jbQow":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _headerMenuDefault4Css = require("./HeaderMenuDefault4.css");
function HeaderMenuDefault4(props) {
    const { children, className } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `menu-item-default-23-1 ${className || ""}`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "label-135 inter-medium-dark-fern-14px",
            children: children
        })
    });
}
exports.default = HeaderMenuDefault4;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./HeaderMenuDefault4.css":"5xNTM","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5xNTM":[function() {},{}],"7TiUc":[function() {},{}],"jhMfZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _smed1Css = require("./SMED1.css");
var _jspdf = require("jspdf");
var _jspdfDefault = parcelHelpers.interopDefault(_jspdf);
var _html2Canvas = require("html2canvas");
var _html2CanvasDefault = parcelHelpers.interopDefault(_html2Canvas);
function SMED1(props) {
    const { x1200PxLogo_Icam__20081 } = props;
    const [hasImplemented, setHasImplemented] = (0, _react.useState)(false);
    const [showQuestionnaire, setShowQuestionnaire] = (0, _react.useState)(false);
    const [showImport, setShowImport] = (0, _react.useState)(false);
    const [currentStep, setCurrentStep] = (0, _react.useState)(1);
    const [answers, setAnswers] = (0, _react.useState)({
        // Part 1: Current state - SMED implementation today
        // Changeover time diagnosis
        timesMeasured: "",
        averageChangeoverTime: "",
        equipmentTypes: "",
        operationsDistinction: "",
        wasteIdentification: "",
        // Methodology and structuring
        structuredApproach: "",
        videoAnalysis: "",
        operatorsInvolvement: "",
        standardizedProcedures: "",
        concreteGains: "",
        // Part 2: Desired future state - Targets & SMED vision
        // Ambitions and expected gains
        targetChangeoverTime: "",
        smedExpansion: "",
        productionFlexibility: "",
        leanIntegration: "",
        automationPlans: "",
        // Part 3: Monitoring, control & gaps
        // Performance measurement
        smedIndicators: "",
        changeoverFrequency: "",
        progressIntegration: "",
        deviationsTracking: "",
        trainingPlan: "",
        // Organization and improvement dynamics
        teamLeadersRole: "",
        bestPracticesDocumentation: "",
        resistanceManagement: "",
        improvementPlan: "",
        roadmap: ""
    });
    const [uploadStatus, setUploadStatus] = (0, _react.useState)({
        isUploading: false,
        progress: 0,
        error: null,
        success: false,
        fileName: ""
    });
    const fileInputRef = (0, _react.useRef)(null);
    const questionnaireRef = (0, _react.useRef)(null);
    const handleImportClick = ()=>{
        fileInputRef.current.click();
    };
    const handleFileUpload = async (event)=>{
        const file = event.target.files[0];
        if (!file) return;
        // File type validation
        const allowedTypes = [
            'application/pdf',
            'image/jpeg',
            'image/png',
            'image/svg+xml',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.ms-excel',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/msword'
        ];
        if (!allowedTypes.includes(file.type)) {
            setUploadStatus({
                ...uploadStatus,
                error: "Unsupported file type. Please use PDF, JPG, PNG, SVG, Excel or Word.",
                success: false
            });
            return;
        }
        // Size validation (max 10MB)
        const maxSize = 10485760;
        if (file.size > maxSize) {
            setUploadStatus({
                ...uploadStatus,
                error: "The file is too large. Maximum size: 10MB",
                success: false
            });
            return;
        }
        try {
            setUploadStatus({
                isUploading: true,
                progress: 0,
                error: null,
                success: false,
                fileName: file.name
            });
            const formData = new FormData();
            formData.append('file', file);
            formData.append('answers', JSON.stringify(answers));
            const xhr = new XMLHttpRequest();
            xhr.upload.onprogress = (event)=>{
                if (event.lengthComputable) {
                    const progress = Math.round(event.loaded / event.total * 100);
                    setUploadStatus((prev)=>({
                            ...prev,
                            progress
                        }));
                }
            };
            const uploadPromise = new Promise((resolve, reject)=>{
                xhr.onload = ()=>{
                    if (xhr.status === 200) resolve(JSON.parse(xhr.response));
                    else reject(new Error(`Upload failed with status ${xhr.status}`));
                };
                xhr.onerror = ()=>reject(new Error('Upload failed'));
            });
            xhr.open('POST', '/api/smed/upload');
            xhr.send(formData);
            const response = await uploadPromise;
            setUploadStatus({
                isUploading: false,
                progress: 100,
                error: null,
                success: true,
                fileName: file.name,
                fileId: response.file_id
            });
        } catch (error) {
            setUploadStatus({
                isUploading: false,
                progress: 0,
                error: "An error occurred during upload. Please try again.",
                success: false,
                fileName: ""
            });
        }
    };
    const handleAnswerChange = (field, value)=>{
        setAnswers({
            ...answers,
            [field]: value
        });
    };
    const handleNextStep = ()=>{
        if (currentStep < 3) {
            setCurrentStep(currentStep + 1);
            if (questionnaireRef.current) questionnaireRef.current.scrollTop = 0;
        } else setShowImport(true);
    };
    const handlePrevStep = ()=>{
        if (currentStep > 1) {
            setCurrentStep(currentStep - 1);
            if (questionnaireRef.current) questionnaireRef.current.scrollTop = 0;
        }
    };
    const handleYesClick = ()=>{
        setHasImplemented(true);
        setShowQuestionnaire(true);
    };
    // Progress indicator
    const renderProgressIndicator = ()=>{
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "progress-indicator",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: `progress-step ${currentStep >= 1 ? 'active' : ''} ${currentStep > 1 ? 'completed' : ''}`,
                    children: "1"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: `progress-step ${currentStep >= 2 ? 'active' : ''} ${currentStep > 2 ? 'completed' : ''}`,
                    children: "2"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: `progress-step ${currentStep >= 3 ? 'active' : ''}`,
                    children: "3"
                })
            ]
        });
    };
    // Render questions
    const renderQuestionnaire = ()=>{
        switch(currentStep){
            case 1:
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questionnaire-step",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                            className: "step-title",
                            children: "Part 1: Current state - SMED implementation today"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "question-group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                    className: "question-group-title",
                                    children: "Changeover Time Diagnosis"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "timesMeasured",
                                            children: "Have you precisely measured your changeover times (before/after SMED)?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "timesMeasured",
                                            value: answers.timesMeasured,
                                            onChange: (e)=>handleAnswerChange('timesMeasured', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "averageChangeoverTime",
                                            children: "What is the current average changeover time on your critical machines or workstations?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "averageChangeoverTime",
                                            value: answers.averageChangeoverTime,
                                            onChange: (e)=>handleAnswerChange('averageChangeoverTime', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "equipmentTypes",
                                            children: "Which types of equipment are involved in the SMED implementation?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "equipmentTypes",
                                            value: answers.equipmentTypes,
                                            onChange: (e)=>handleAnswerChange('equipmentTypes', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "operationsDistinction",
                                            children: "Do you clearly distinguish external operations (done while machine runs) from internal operations (done only when stopped)?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "operationsDistinction",
                                            value: answers.operationsDistinction,
                                            onChange: (e)=>handleAnswerChange('operationsDistinction', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "wasteIdentification",
                                            children: "Have you identified wastes and downtime related to current changeovers?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "wasteIdentification",
                                            value: answers.wasteIdentification,
                                            onChange: (e)=>handleAnswerChange('wasteIdentification', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "question-group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                    className: "question-group-title",
                                    children: "Methodology & Structuring"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "structuredApproach",
                                            children: "Have you implemented a structured SMED approach (steps, tools, indicators)?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "structuredApproach",
                                            value: answers.structuredApproach,
                                            onChange: (e)=>handleAnswerChange('structuredApproach', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "videoAnalysis",
                                            children: "Do you use videos or field observations to analyze changeovers?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "videoAnalysis",
                                            value: answers.videoAnalysis,
                                            onChange: (e)=>handleAnswerChange('videoAnalysis', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "operatorsInvolvement",
                                            children: "Are operators involved in the analysis and reorganization of changeovers?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "operatorsInvolvement",
                                            value: answers.operatorsInvolvement,
                                            onChange: (e)=>handleAnswerChange('operatorsInvolvement', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "standardizedProcedures",
                                            children: "Have you standardized format/tool change procedures?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "standardizedProcedures",
                                            value: answers.standardizedProcedures,
                                            onChange: (e)=>handleAnswerChange('standardizedProcedures', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "concreteGains",
                                            children: "What concrete gains have already been obtained (time reduction, quality, flexibility)?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "concreteGains",
                                            value: answers.concreteGains,
                                            onChange: (e)=>handleAnswerChange('concreteGains', e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                });
            case 2:
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questionnaire-step",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                            className: "step-title",
                            children: "Part 2: Desired state - SMED goals & future vision"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "question-group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                    className: "question-group-title",
                                    children: "Ambitions & Expected Gains"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "targetChangeoverTime",
                                            children: "What is your target changeover time per machine or key process?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "targetChangeoverTime",
                                            value: answers.targetChangeoverTime,
                                            onChange: (e)=>handleAnswerChange("targetChangeoverTime", e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "smedExpansion",
                                            children: "Do you plan to extend the SMED approach to other workstations or production lines?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "smedExpansion",
                                            value: answers.smedExpansion,
                                            onChange: (e)=>handleAnswerChange("smedExpansion", e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "productionFlexibility",
                                            children: "Are you aiming for a more flexible production system (more changeovers, smaller batches)?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "productionFlexibility",
                                            value: answers.productionFlexibility,
                                            onChange: (e)=>handleAnswerChange("productionFlexibility", e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "leanIntegration",
                                            children: "Would you like to combine SMED with other Lean tools (TPM, 5S, Kanban\xe2\u20AC\xa6)?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "leanIntegration",
                                            value: answers.leanIntegration,
                                            onChange: (e)=>handleAnswerChange("leanIntegration", e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "automationPlans",
                                            children: "Do you plan to automate certain changeover steps (automatic adjustments, quick-change tools)?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "automationPlans",
                                            value: answers.automationPlans,
                                            onChange: (e)=>handleAnswerChange("automationPlans", e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                });
            case 3:
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questionnaire-step",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                            className: "step-title",
                            children: "Part 3: Monitoring, Control & Gap Analysis"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "question-group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                    className: "question-group-title",
                                    children: "Performance Measurement"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "smedIndicators",
                                            children: "Do you have clear SMED indicators monitored regularly?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "smedIndicators",
                                            value: answers.smedIndicators,
                                            onChange: (e)=>handleAnswerChange("smedIndicators", e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "changeoverFrequency",
                                            children: "Do you measure the frequency of changeovers and their impact on overall productivity?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "changeoverFrequency",
                                            value: answers.changeoverFrequency,
                                            onChange: (e)=>handleAnswerChange("changeoverFrequency", e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "progressIntegration",
                                            children: "Are SMED improvements integrated into your management rituals (performance reviews, visual boards, QRQC)?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "progressIntegration",
                                            value: answers.progressIntegration,
                                            onChange: (e)=>handleAnswerChange("progressIntegration", e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "deviationsTracking",
                                            children: "How do you track deviations or regressions after optimization?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "deviationsTracking",
                                            value: answers.deviationsTracking,
                                            onChange: (e)=>handleAnswerChange("deviationsTracking", e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "trainingPlan",
                                            children: "Do you have a training and upskilling plan for SMED?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "trainingPlan",
                                            value: answers.trainingPlan,
                                            onChange: (e)=>handleAnswerChange("trainingPlan", e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "question-group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                    className: "question-group-title",
                                    children: "Organization & Improvement Dynamics"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "teamLeadersRole",
                                            children: "What is the role of team leaders or methods technicians in SMED deployment?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "teamLeadersRole",
                                            value: answers.teamLeadersRole,
                                            onChange: (e)=>handleAnswerChange("teamLeadersRole", e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "bestPracticesDocumentation",
                                            children: "Do you have a structured approach to documenting and capitalizing on best practices?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "bestPracticesDocumentation",
                                            value: answers.bestPracticesDocumentation,
                                            onChange: (e)=>handleAnswerChange("bestPracticesDocumentation", e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "resistanceManagement",
                                            children: "How do you manage resistance to change when reducing changeover times?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "resistanceManagement",
                                            value: answers.resistanceManagement,
                                            onChange: (e)=>handleAnswerChange("resistanceManagement", e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "improvementPlan",
                                            children: "Have you implemented an improvement plan related to SMED?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "improvementPlan",
                                            value: answers.improvementPlan,
                                            onChange: (e)=>handleAnswerChange("improvementPlan", e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "roadmap",
                                            children: "What is your roadmap to reach an advanced SMED maturity level in the coming months?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "roadmap",
                                            value: answers.roadmap,
                                            onChange: (e)=>handleAnswerChange("roadmap", e.target.value),
                                            rows: "3"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                });
            default:
                return null;
        }
    };
    const handleDownloadPDF = async ()=>{
        try {
            const element = document.querySelector(".smed-page");
            if (!element) {
                alert("\xe2\x9d\u0152 Element not found!");
                return;
            }
            // Remove gradients and CSS vars
            document.querySelectorAll("*").forEach((el)=>{
                const bgImage = window.getComputedStyle(el).backgroundImage;
                if (bgImage && bgImage.includes("gradient")) el.style.backgroundImage = "none";
                const bgColor = window.getComputedStyle(el).backgroundColor;
                if (bgColor.includes("var(") || bgColor === "transparent" || bgColor === "rgba(0, 0, 0, 0)") el.style.backgroundColor = "#ffffff";
            });
            const canvas = await (0, _html2CanvasDefault.default)(element, {
                scale: 2,
                useCORS: true,
                allowTaint: true,
                backgroundColor: "#ffffff",
                logging: false
            });
            const imgData = canvas.toDataURL("image/png");
            const pdf = new (0, _jspdfDefault.default)("p", "mm", "a4");
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = pdf.internal.pageSize.getHeight();
            const imgWidth = pdfWidth;
            const imgHeight = canvas.height * pdfWidth / canvas.width;
            let heightLeft = imgHeight;
            let position = 0;
            pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
            heightLeft -= pdfHeight;
            while(heightLeft > 0){
                position = heightLeft - imgHeight;
                pdf.addPage();
                pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
                heightLeft -= pdfHeight;
            }
            const date = new Date().toISOString().slice(0, 10);
            pdf.save(`SMED_${date}.pdf`);
            alert("\xe2\u0153\u2026 PDF generated successfully!");
        } catch (err) {
            console.error("PDF error:", err);
            alert("\xe2\x9d\u0152 PDF error: " + (err.message || "unknown"));
        }
    };
    const saveLeanAnswers = async (moduleName)=>{
        try {
            const caseId = localStorage.getItem("caseId");
            if (!caseId) {
                alert("No active case found!");
                return;
            }
            const response = await fetch(`${"/api"}/api/lean/${moduleName}/save`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    case_id: caseId,
                    answers: answers
                })
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.detail || `Save error (${response.status}): ${data.message}`);
            alert(`\xe2\u{153}\u{2026} ${moduleName.toUpperCase()} answers saved successfully!`);
            handleNextStep();
        } catch (error) {
            alert("" + error.message);
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "smed-page screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "header",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                        to: "/home",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "logo-icam",
                            src: "/img/1200px-logo-icam---2008-1@2x.png",
                            alt: "ICAM Logo"
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questionnaire-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                            className: "question-title",
                            children: "SMED Methodology - Reducing Changeover Times"
                        }),
                        !showQuestionnaire ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "question-section",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Has your company already implemented the SMED methodology?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "buttons-container",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            className: `choice-button ${hasImplemented ? "active" : ""}`,
                                            onClick: handleYesClick,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            className: `choice-button ${!hasImplemented ? "active" : ""}`,
                                            onClick: ()=>setHasImplemented(false),
                                            children: "No"
                                        })
                                    ]
                                }),
                                !hasImplemented && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "redirect-section",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "redirect-text",
                                            children: "We recommend starting by understanding the basics of Lean:"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                            to: "/Kanban-1",
                                            className: "redirect-button",
                                            children: "Go to the Kanban method"
                                        })
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                            children: !showImport ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "questionnaire-container-inner",
                                ref: questionnaireRef,
                                children: [
                                    renderProgressIndicator(),
                                    renderQuestionnaire(),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "navigation-buttons",
                                        children: [
                                            currentStep > 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                className: "nav-button prev-button",
                                                onClick: handlePrevStep,
                                                children: "Previous"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                className: "nav-button next-button",
                                                onClick: ()=>saveLeanAnswers("smed"),
                                                children: currentStep < 3 ? "Next" : "Finish"
                                            })
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "file-upload-section",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                        className: "upload-title",
                                        children: "Import your existing documents"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "upload-description",
                                        children: "You can now import your SMED documents, timing sheets or existing procedures:"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "upload-container",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                type: "file",
                                                ref: fileInputRef,
                                                className: "hidden-file-input",
                                                accept: ".pdf,.jpg,.jpeg,.png,.svg,.xlsx,.xls,.doc,.docx",
                                                onChange: handleFileUpload,
                                                disabled: uploadStatus.isUploading
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                className: "import-button",
                                                onClick: handleImportClick,
                                                disabled: uploadStatus.isUploading,
                                                children: uploadStatus.isUploading ? "Uploading\xe2\u20AC\xa6" : "Import a file"
                                            }),
                                            uploadStatus.isUploading && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "upload-progress",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "progress-bar",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "progress-bar-fill",
                                                            style: {
                                                                width: `${uploadStatus.progress}%`
                                                            }
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                        className: "progress-text",
                                                        children: [
                                                            "Upload in progress... ",
                                                            uploadStatus.progress,
                                                            "%"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            uploadStatus.error && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "upload-error",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                    children: uploadStatus.error
                                                })
                                            }),
                                            uploadStatus.success && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "upload-success",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                        children: [
                                                            "File ",
                                                            uploadStatus.fileName,
                                                            " uploaded successfully!"
                                                        ]
                                                    }),
                                                    uploadStatus.fileId && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                        className: "download-button",
                                                        onClick: ()=>window.open(`/api/smed/${uploadStatus.fileId}`, "_blank"),
                                                        children: "View file"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "navigation-buttons",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                className: "nav-button prev-button",
                                                onClick: ()=>setShowImport(false),
                                                children: "Back to questionnaire"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                                to: "/smed-2",
                                                className: "nav-button next-button",
                                                children: "Continue"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    className: "download-button",
                    onClick: handleDownloadPDF,
                    disabled: uploadStatus.isUploading,
                    children: uploadStatus.isUploading ? "Generating PDF..." : "Download as PDF"
                })
            ]
        })
    });
}
exports.default = SMED1;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"b9X5n","./SMED1.css":"fZq2m","jspdf":"hkJ4Q","html2canvas":"3eyQ5","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fZq2m":[function() {},{}],"dwI3H":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _frame11332 = require("../Frame11332");
var _frame11332Default = parcelHelpers.interopDefault(_frame11332);
var _frame114 = require("../Frame114");
var _frame114Default = parcelHelpers.interopDefault(_frame114);
var _frame115 = require("../Frame115");
var _frame115Default = parcelHelpers.interopDefault(_frame115);
var _frame116 = require("../Frame116");
var _frame116Default = parcelHelpers.interopDefault(_frame116);
var _frame11322 = require("../Frame11322");
var _frame11322Default = parcelHelpers.interopDefault(_frame11322);
var _frame1147 = require("../Frame1147");
var _frame1147Default = parcelHelpers.interopDefault(_frame1147);
var _frame1154 = require("../Frame1154");
var _frame1154Default = parcelHelpers.interopDefault(_frame1154);
var _frame1164 = require("../Frame1164");
var _frame1164Default = parcelHelpers.interopDefault(_frame1164);
var _frame11742 = require("../Frame11742");
var _frame11742Default = parcelHelpers.interopDefault(_frame11742);
var _frame118 = require("../Frame118");
var _frame118Default = parcelHelpers.interopDefault(_frame118);
var _x5SCss = require("./X5S.css");
function X5S(props) {
    const { x1200PxLogo_Icam__20081, design, leanVsm, arrow12, arrow13, line2, label1, textFormat, label2, line23, place, seiri, arrow7, disposal, clickOnModeling, arrow3, seiton, arrow8, putAway, modeling, arrow4, seison, arrow9, clean, arrow6, seiketsu, shitsuke, arrow10, arrow11, arrow5, rectangle7, standardize, respect, xcontinue, frame118Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "x5s screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group3-16",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-59",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "nav-items-container-29",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-2-45",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11332Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame114Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame115Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame116Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "frame-117-98",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "design-79 valign-text-middle inter-medium-sonic-silver-18px",
                                                children: design
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11322Default.default), {})
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-3-72",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                            to: "/lean-vsm",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "frame-113-61",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "lean-vsm-10 valign-text-middle inter-medium-star-dust-18px",
                                                    children: leanVsm
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1147Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1154Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1164Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11742Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame118Default.default), {
                                            className: frame118Props.className,
                                            children: frame118Props.children
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-111",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-col-71",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "arrow-container-17",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "arrow-12-2",
                                            src: arrow12,
                                            alt: "Arrow 12"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "arrow-13-2",
                                            src: arrow13,
                                            alt: "Arrow 13"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "ellipse-86-16"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "rectangle-23-1"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "frame-8-5"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "rectangle-24-1"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "group-86",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "overlap-group-60",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "line-2-16",
                                                    src: line2,
                                                    alt: "Line 2"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "ellipse-86-17"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "label-140 inter-medium-rum-swizzle-18-1px",
                                            children: label1
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "group-85",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "text-format-17",
                                            src: textFormat,
                                            alt: "Text format"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "label-141 inter-medium-rum-swizzle-18-1px",
                                            children: label2
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-row-112",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    className: "line-23",
                                    src: line23,
                                    alt: "Line 23"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex-col-72",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                            to: "/lean-vsm",
                                            className: "align-self-flex-start",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "frame-5-17",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "place-259 valign-text-middle inter-bold-tropical-rain-forest-18px",
                                                    children: place
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "seiri-1 inter-medium-white-18-1px",
                                            children: seiri
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "arrow-7-8",
                                            src: arrow7,
                                            alt: "Arrow 7"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "overlap-group2-17",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "ellipse-87-3"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "ellipse-89-1"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "disposal-1 inter-medium-dark-fern-18-1px",
                                                    children: disposal
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex-col-73",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "click-on-modeling-15 valign-text-middle bevan-normal-white-20px",
                                            children: clickOnModeling
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex-row-113",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "flex-col-74",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "flex-row-114",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                    className: "arrow-3-10",
                                                                    src: arrow3,
                                                                    alt: "Arrow 3"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "flex-col-75",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "seiton-1 inter-medium-white-18-1px",
                                                                            children: seiton
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                            className: "arrow-8-10",
                                                                            src: arrow8,
                                                                            alt: "Arrow 8"
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "overlap-group5-11",
                                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "put-away-1 inter-medium-dark-fern-18-1px",
                                                                                children: putAway
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "frame-9-5",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                                                href: "https://app.diagrams.net/",
                                                                target: "_blank",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "modeling-105 valign-text-middle inter-bold-tropical-rain-forest-18px",
                                                                    children: modeling
                                                                })
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "flex-row-115",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-4-10",
                                                            src: arrow4,
                                                            alt: "Arrow 4"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "flex-col-76",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "seison-1 inter-medium-white-18-1px",
                                                                    children: seison
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                    className: "arrow-9-11",
                                                                    src: arrow9,
                                                                    alt: "Arrow 9"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "overlap-group4-13",
                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "clean inter-medium-dark-fern-18-1px",
                                                                        children: clean
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-6-12",
                                                            src: arrow6,
                                                            alt: "Arrow 6"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "flex-col-77",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "flex-row-116 inter-medium-white-18-1px",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "seiketsu-1",
                                                                            children: seiketsu
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "shitsuke-1",
                                                                            children: shitsuke
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "arrow-container-18",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                            className: "arrow-1-13",
                                                                            src: arrow10,
                                                                            alt: "Arrow 10"
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                            className: "arrow-1-13",
                                                                            src: arrow11,
                                                                            alt: "Arrow 11"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "overlap-group1-39 inter-medium-dark-fern-18-1px",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "rectangle-5-5"
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                            className: "arrow-5-11",
                                                                            src: arrow5,
                                                                            alt: "Arrow 5"
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                            className: "rectangle-7-5",
                                                                            src: rectangle7,
                                                                            alt: "Rectangle 7"
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "standardize-1",
                                                                            children: standardize
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "respect-1",
                                                                            children: respect
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                                                    to: "/kaizen",
                                                                    className: "align-self-flex-start",
                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "frame-2-22",
                                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "continue-16 valign-text-middle inter-bold-mineral-green-18px",
                                                                            children: xcontinue
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = X5S;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"b9X5n","../Frame11332":"2UwVc","../Frame114":"aUtEd","../Frame115":"gPV9Y","../Frame116":"70lZ5","../Frame11322":"ju7Cp","../Frame1147":"fNcZW","../Frame1154":"YWwMr","../Frame1164":"eReDS","../Frame11742":"kufPP","../Frame118":"buB7M","./X5S.css":"3zls7","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fNcZW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame1147Css = require("./Frame1147.css");
function Frame1147() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "frame-114-110",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "x5-s-12 valign-text-middle inter-medium-white-18px",
            children: "5S"
        })
    });
}
exports.default = Frame1147;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./Frame1147.css":"aFKnf","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aFKnf":[function() {},{}],"3zls7":[function() {},{}],"l6wcX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _frame11332 = require("../Frame11332");
var _frame11332Default = parcelHelpers.interopDefault(_frame11332);
var _frame114 = require("../Frame114");
var _frame114Default = parcelHelpers.interopDefault(_frame114);
var _frame115 = require("../Frame115");
var _frame115Default = parcelHelpers.interopDefault(_frame115);
var _frame116 = require("../Frame116");
var _frame116Default = parcelHelpers.interopDefault(_frame116);
var _frame11322 = require("../Frame11322");
var _frame11322Default = parcelHelpers.interopDefault(_frame11322);
var _frame1146 = require("../Frame1146");
var _frame1146Default = parcelHelpers.interopDefault(_frame1146);
var _frame1157 = require("../Frame1157");
var _frame1157Default = parcelHelpers.interopDefault(_frame1157);
var _frame1164 = require("../Frame1164");
var _frame1164Default = parcelHelpers.interopDefault(_frame1164);
var _frame11742 = require("../Frame11742");
var _frame11742Default = parcelHelpers.interopDefault(_frame11742);
var _frame118 = require("../Frame118");
var _frame118Default = parcelHelpers.interopDefault(_frame118);
var _frame8 = require("../Frame8");
var _frame8Default = parcelHelpers.interopDefault(_frame8);
var _frame82 = require("../Frame82");
var _frame82Default = parcelHelpers.interopDefault(_frame82);
var _frame9 = require("../Frame9");
var _frame9Default = parcelHelpers.interopDefault(_frame9);
var _kaizen12Css = require("./Kaizen12.css");
function Kaizen12(props) {
    const { x1200PxLogo_Icam__20081, label1, leanVsm, label2, overlapGroup8, arrow9, overlapGroup5, arrow10, line4, line2, label3, label4, overlapGroup9, textFormat, label5, label6, overlapGroup4, line1, place, x1IdentificatonDuProblemeATraiter, x2EtudeDeLaSituation, arrow6, x6AuditDesContreMesures, arrow16, arrow13, arrow14, arrow15, arrow17, x7StandardisationDesBonnesMesures, modeling, xcontinue, frame11332Props, frame11322Props, frame118Props, frame8Props, frame82Props, frame9Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "kaizen1 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-col-78",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "overlap-group1-40",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                    to: "/home",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        className: "x1200px-logo_icam_-_2008-1-60",
                                        src: x1200PxLogo_Icam__20081,
                                        alt: "1200px-Logo_ICAM_-_2008 1"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-container-30",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "nav-items-2-47",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11332Default.default), {
                                                    className: frame11332Props.className
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame114Default.default), {}),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame115Default.default), {}),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame116Default.default), {}),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                                    to: "/functional-view-1",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "label-143 inter-medium-sonic-silver-18-1px",
                                                        children: label1
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11322Default.default), {
                                                    className: frame11322Props.className
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "nav-items-3-73",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                                    to: "/lean-vsm",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "frame-113-62",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "lean-vsm-11 valign-text-middle inter-medium-star-dust-18px",
                                                            children: leanVsm
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1146Default.default), {}),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1157Default.default), {}),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1164Default.default), {}),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11742Default.default), {}),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame118Default.default), {
                                                    className: frame118Props.className,
                                                    children: frame118Props.children
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "label-144 inter-medium-cultured-pearl-20px",
                            children: label2
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-117",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-col-79 inter-medium-rum-swizzle-18-1px",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "overlap-group-container-11",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "overlap-group8-1",
                                            style: {
                                                backgroundImage: `url(${overlapGroup8})`
                                            },
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                className: "arrow-9-12",
                                                src: arrow9,
                                                alt: "Arrow 9"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "overlap-group5-12",
                                            style: {
                                                backgroundImage: `url(${overlapGroup5})`
                                            },
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                className: "arrow-10-6",
                                                src: arrow10,
                                                alt: "Arrow 10"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "ellipse-container",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "ellipse-87-4"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "ellipse-85-12"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "rectangle-10-2"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "overlap-group11-1",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "frame-5-18"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "overlap-group3-17",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "line-5",
                                            src: line4,
                                            alt: "Line 4"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "ellipse-8-1"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "line-5",
                                            src: line2,
                                            alt: "Line 2"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "ellipse-8-1"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "label-container-2",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "label-142",
                                            children: label3
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "label-142",
                                            children: label4
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "overlap-group9-1",
                                    style: {
                                        backgroundImage: `url(${overlapGroup9})`
                                    },
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        className: "text-format-18",
                                        src: textFormat,
                                        alt: "Text format"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "label-container-3",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "label-142",
                                            children: label5
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "label-142",
                                            children: label6
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-row-118",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex-row-119",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "overlap-group4-14",
                                            style: {
                                                backgroundImage: `url(${overlapGroup4})`
                                            },
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                className: "line-1-16",
                                                src: line1,
                                                alt: "Line 1"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                            to: "/kaizen",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "frame-8-6",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "place-260 valign-text-middle inter-bold-tropical-rain-forest-18px",
                                                    children: place
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex-col-80",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "overlap-group12-3 inter-medium-dark-fern-18-1px",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "frame-7-4",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                        className: "x1-identificaton-du-probleme-a-traiter inter-medium-dark-fern-18-1px",
                                                        children: x1IdentificatonDuProblemeATraiter
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "overlap-group10",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "frame-8-7",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                className: "x2-etude-de-la-situation",
                                                                children: x2EtudeDeLaSituation
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-6-13",
                                                            src: arrow6,
                                                            alt: "Arrow 6"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "overlap-group-61",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "frame-10-5",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "x6-audit-des-contre-mesures",
                                                                children: x6AuditDesContreMesures
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame8Default.default), {
                                                            children: frame8Props.children
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame82Default.default), {
                                                            children: frame82Props.children
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame9Default.default), {
                                                            children: frame9Props.children
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-16-2",
                                                            src: arrow16,
                                                            alt: "Arrow 16"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-13-3",
                                                            src: arrow13,
                                                            alt: "Arrow 13"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-14-2",
                                                            src: arrow14,
                                                            alt: "Arrow 14"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-15-2",
                                                            src: arrow15,
                                                            alt: "Arrow 15"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "arrow-17-1",
                                            src: arrow17,
                                            alt: "Arrow 17"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "frame-container-14",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "frame-8-8",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "x7-standardisation-des-bonnes-mesures inter-medium-dark-fern-18-1px",
                                                        children: x7StandardisationDesBonnesMesures
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "frame-10-6",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                                        href: "https://app.diagrams.net/",
                                                        target: "_blank",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "modeling-106 valign-text-middle inter-bold-tropical-rain-forest-18px",
                                                            children: modeling
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                                    to: "/smed",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "frame-2-23",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "continue-17 valign-text-middle inter-bold-mineral-green-18px",
                                                            children: xcontinue
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Kaizen12;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"b9X5n","../Frame11332":"2UwVc","../Frame114":"aUtEd","../Frame115":"gPV9Y","../Frame116":"70lZ5","../Frame11322":"ju7Cp","../Frame1146":"5jzi1","../Frame1157":"7MJwy","../Frame1164":"eReDS","../Frame11742":"kufPP","../Frame118":"buB7M","../Frame8":"1bzV5","../Frame82":"aKNzA","../Frame9":"3Urvc","./Kaizen12.css":"2p4hj","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7MJwy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame1157Css = require("./Frame1157.css");
function Frame1157() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "frame-115-117",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "kaizen-10 valign-text-middle inter-medium-white-18px",
            children: "Kaizen"
        })
    });
}
exports.default = Frame1157;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./Frame1157.css":"fqZpc","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fqZpc":[function() {},{}],"1bzV5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame8Css = require("./Frame8.css");
function Frame8(props) {
    const { children } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "frame-8-9",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
            className: "x5-mise-en-action-des-contre-mesures",
            children: children
        })
    });
}
exports.default = Frame8;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./Frame8.css":"8v4E5","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8v4E5":[function() {},{}],"aKNzA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame82Css = require("./Frame82.css");
function Frame82(props) {
    const { children } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "frame-8-11",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "x4-identification-des-contre-mesures",
            children: children
        })
    });
}
exports.default = Frame82;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./Frame82.css":"6JgrV","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6JgrV":[function() {},{}],"3Urvc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame9Css = require("./Frame9.css");
function Frame9(props) {
    const { children } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "frame-9-6",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "x3-etude-des-causes",
            children: children
        })
    });
}
exports.default = Frame9;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./Frame9.css":"1iUOr","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1iUOr":[function() {},{}],"2p4hj":[function() {},{}],"e4lAZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _frame11332 = require("../Frame11332");
var _frame11332Default = parcelHelpers.interopDefault(_frame11332);
var _frame114 = require("../Frame114");
var _frame114Default = parcelHelpers.interopDefault(_frame114);
var _frame115 = require("../Frame115");
var _frame115Default = parcelHelpers.interopDefault(_frame115);
var _frame116 = require("../Frame116");
var _frame116Default = parcelHelpers.interopDefault(_frame116);
var _frame11322 = require("../Frame11322");
var _frame11322Default = parcelHelpers.interopDefault(_frame11322);
var _frame1146 = require("../Frame1146");
var _frame1146Default = parcelHelpers.interopDefault(_frame1146);
var _frame1157 = require("../Frame1157");
var _frame1157Default = parcelHelpers.interopDefault(_frame1157);
var _frame1164 = require("../Frame1164");
var _frame1164Default = parcelHelpers.interopDefault(_frame1164);
var _frame11742 = require("../Frame11742");
var _frame11742Default = parcelHelpers.interopDefault(_frame11742);
var _frame118 = require("../Frame118");
var _frame118Default = parcelHelpers.interopDefault(_frame118);
var _headerMenuDefault = require("../HeaderMenuDefault");
var _headerMenuDefaultDefault = parcelHelpers.interopDefault(_headerMenuDefault);
var _kaizenCss = require("./Kaizen.css");
function Kaizen(props) {
    const { x1200PxLogo_Icam__20081, design, leanVsm, arrow12, arrow13, line2, label1, textFormat, label2, line23, place1, input, clickOnModeling, arrow5, arrow1, place2, arrow3, arrow7, act, xdo, arrow4, arrow6, check, arrow2, arrow8, modeling, xcontinue, output, frame118Props, headerMenuDefault1Props, headerMenuDefault2Props, headerMenuDefault3Props, headerMenuDefault4Props, headerMenuDefault5Props, headerMenuDefault6Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "kaizen-14 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group4-15",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-62",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "nav-items-container-32",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-2-48",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11332Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame114Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame115Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame116Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "frame-117-99",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "design-80 valign-text-middle inter-medium-sonic-silver-18px",
                                                children: design
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11322Default.default), {})
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-3-74",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                            to: "/lean-vsm",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "frame-113-63",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "lean-vsm-12 valign-text-middle inter-medium-star-dust-18px",
                                                    children: leanVsm
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1146Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1157Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1164Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11742Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame118Default.default), {
                                            className: frame118Props.className,
                                            children: frame118Props.children
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-121",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-col-81",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "arrow-container-19",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "arrow-12-3",
                                            src: arrow12,
                                            alt: "Arrow 12"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "arrow-13-4",
                                            src: arrow13,
                                            alt: "Arrow 13"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "ellipse-86-18"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "rectangle-23-2"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "frame-8-13"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "rectangle-24-2"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "group-86-1",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "overlap-group-63",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "line-2-17",
                                                    src: line2,
                                                    alt: "Line 2"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "ellipse-86-19"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "label-145 inter-medium-rum-swizzle-18-1px",
                                            children: label1
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "group-85-1",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "text-format-19",
                                            src: textFormat,
                                            alt: "Text format"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "label-146 inter-medium-rum-swizzle-18-1px",
                                            children: label2
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-row-122",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex-row-123",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "line-23-1",
                                            src: line23,
                                            alt: "Line 23"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex-col-82",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                                    to: "/5s",
                                                    className: "align-self-flex-start",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "frame-7-5",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "place-261 valign-text-middle inter-bold-tropical-rain-forest-18px",
                                                            children: place1
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "overlap-group8-2",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "input-1 valign-text-middle inter-bold-mineral-green-20px",
                                                        children: input
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefaultDefault.default), {
                                                    className: headerMenuDefault1Props.className,
                                                    children: headerMenuDefault1Props.children
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex-col-83",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "click-on-modeling-16 valign-text-middle bevan-normal-white-20px",
                                            children: clickOnModeling
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex-row-124",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "arrow-5-12",
                                                    src: arrow5,
                                                    alt: "Arrow 5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "arrow-1-14",
                                                    src: arrow1,
                                                    alt: "Arrow 1"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "flex-col-84",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "overlap-group3-18",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                                                className: "place-262 valign-text-middle inter-bold-mineral-green-24px",
                                                                children: place2
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefaultDefault.default), {
                                                            className: headerMenuDefault2Props.className,
                                                            children: headerMenuDefault2Props.children
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "arrow-3-11",
                                                    src: arrow3,
                                                    alt: "Arrow 3"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "arrow-7-9",
                                                    src: arrow7,
                                                    alt: "Arrow 7"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex-col-85",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "overlap-group-container-12",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "overlap-group9-2",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "act-1 valign-text-middle inter-bold-mineral-green-24px",
                                                                children: act
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "overlap-group7-3",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "do-1 valign-text-middle inter-bold-mineral-green-24px",
                                                                children: xdo
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "flex-row-125",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "overlap-group-container-13",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "overlap-group5-13",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefaultDefault.default), {
                                                                            className: headerMenuDefault3Props.className,
                                                                            children: headerMenuDefault3Props.children
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                            className: "arrow-4-11",
                                                                            src: arrow4,
                                                                            alt: "Arrow 4"
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                            className: "arrow-6-14",
                                                                            src: arrow6,
                                                                            alt: "Arrow 6"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "overlap-group6-5",
                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "check-1 valign-text-middle inter-bold-mineral-green-24px",
                                                                        children: check
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "overlap-group2-18",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefaultDefault.default), {
                                                                    className: headerMenuDefault4Props.className,
                                                                    children: headerMenuDefault4Props.children
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                    className: "arrow-2-12",
                                                                    src: arrow2,
                                                                    alt: "Arrow 2"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-8-11",
                                                            src: arrow8,
                                                            alt: "Arrow 8"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "flex-row-126",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "frame-5-19",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                                                href: "https://app.diagrams.net/",
                                                                target: "_blank",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "modeling-107 valign-text-middle inter-bold-tropical-rain-forest-18px",
                                                                    children: modeling
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefaultDefault.default), {
                                                            className: headerMenuDefault5Props.className,
                                                            children: headerMenuDefault5Props.children
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                                            to: "/kaizen1",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "frame-2-24",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "continue-18 valign-text-middle inter-bold-mineral-green-18px",
                                                                    children: xcontinue
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex-col-86",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "overlap-group1-41",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "output-1 valign-text-middle inter-bold-mineral-green-20px",
                                                children: output
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefaultDefault.default), {
                                            className: headerMenuDefault6Props.className,
                                            children: headerMenuDefault6Props.children
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Kaizen;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"b9X5n","../Frame11332":"2UwVc","../Frame114":"aUtEd","../Frame115":"gPV9Y","../Frame116":"70lZ5","../Frame11322":"ju7Cp","../Frame1146":"5jzi1","../Frame1157":"7MJwy","../Frame1164":"eReDS","../Frame11742":"kufPP","../Frame118":"buB7M","../HeaderMenuDefault":"bD1BI","./Kaizen.css":"aqAPK","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aqAPK":[function() {},{}],"c78yP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _frame11332 = require("../Frame11332");
var _frame11332Default = parcelHelpers.interopDefault(_frame11332);
var _frame114 = require("../Frame114");
var _frame114Default = parcelHelpers.interopDefault(_frame114);
var _frame115 = require("../Frame115");
var _frame115Default = parcelHelpers.interopDefault(_frame115);
var _frame116 = require("../Frame116");
var _frame116Default = parcelHelpers.interopDefault(_frame116);
var _frame11322 = require("../Frame11322");
var _frame11322Default = parcelHelpers.interopDefault(_frame11322);
var _frame1146 = require("../Frame1146");
var _frame1146Default = parcelHelpers.interopDefault(_frame1146);
var _frame1154 = require("../Frame1154");
var _frame1154Default = parcelHelpers.interopDefault(_frame1154);
var _frame1165 = require("../Frame1165");
var _frame1165Default = parcelHelpers.interopDefault(_frame1165);
var _frame11742 = require("../Frame11742");
var _frame11742Default = parcelHelpers.interopDefault(_frame11742);
var _frame118 = require("../Frame118");
var _frame118Default = parcelHelpers.interopDefault(_frame118);
var _frame6 = require("../Frame6");
var _frame6Default = parcelHelpers.interopDefault(_frame6);
var _smedCss = require("./SMED.css");
function SMED(props) {
    const { x1200PxLogo_Icam__20081, design, leanVsm, arrow121, arrow131, line2, label1, textFormat, label2, line23, place, clickOnModeling, label3, arrow5, label4, arrow15, arrow122, arrow132, dernierePieceBonneSerieA, changementOutillage, reglage, nettoyage, arrow18, arrow17, arrow16, premierePieceBonneSerieB, arrow14, modeling, arrow11, xcontinue, frame118Props, frame6Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "smed-15 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group2-19",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-63",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "nav-items-container-33",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-2-49",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11332Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame114Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame115Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame116Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "frame-117-100",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "design-81 valign-text-middle inter-medium-sonic-silver-18px",
                                                children: design
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11322Default.default), {})
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-3-75",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                            to: "/lean-vsm",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "frame-113-64",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "lean-vsm-13 valign-text-middle inter-medium-star-dust-18px",
                                                    children: leanVsm
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1146Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1154Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1165Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11742Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame118Default.default), {
                                            className: frame118Props.className,
                                            children: frame118Props.children
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-127",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-col-87",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "arrow-container-20",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "arrow-12-4",
                                            src: arrow121,
                                            alt: "Arrow 12"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "arrow-13-5",
                                            src: arrow131,
                                            alt: "Arrow 13"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "ellipse-86-20"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "rectangle-23-3"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "frame-8-14"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "rectangle-24-3"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "group-86-2",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "overlap-group-64",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "line-2-18",
                                                    src: line2,
                                                    alt: "Line 2"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "ellipse-86-21"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "label-147 inter-medium-rum-swizzle-18-1px",
                                            children: label1
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "group-85-2",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "text-format-20",
                                            src: textFormat,
                                            alt: "Text format"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "label-148 inter-medium-rum-swizzle-18-1px",
                                            children: label2
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-row-128",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex-row-129",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "line-23-2",
                                            src: line23,
                                            alt: "Line 23"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                            to: "/kaizen1",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "frame-7-6",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "place-263 valign-text-middle inter-bold-tropical-rain-forest-18px",
                                                    children: place
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex-col-88",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "click-on-modeling-17 valign-text-middle bevan-normal-white-20px",
                                            children: clickOnModeling
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "overlap-group-container-14 inter-medium-cultured-pearl-18-1px",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "overlap-group4-16",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "label-149",
                                                            children: label3
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-5-13",
                                                            src: arrow5,
                                                            alt: "Arrow 5"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "overlap-group3-19",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "label-150",
                                                            children: label4
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-15-3",
                                                            src: arrow15,
                                                            alt: "Arrow 15"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "overlap-group1-42 inter-medium-dark-fern-18-1px",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "rectangle-8-1"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-12-5",
                                                            src: arrow122,
                                                            alt: "Arrow 12"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-13-6",
                                                            src: arrow132,
                                                            alt: "Arrow 13"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "rectangle-10-3"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                            className: "derniere-piece-bonne-serie-a-1",
                                                            children: dernierePieceBonneSerieA
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "rectangle-11-2"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "changement-outillage-1",
                                                            children: changementOutillage
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "reglage-1",
                                                            children: reglage
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "nettoyage-1",
                                                            children: nettoyage
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-18-1",
                                                            src: arrow18,
                                                            alt: "Arrow 18"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-17-2",
                                                            src: arrow17,
                                                            alt: "Arrow 17"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-16-3",
                                                            src: arrow16,
                                                            alt: "Arrow 16"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                            className: "premiere-piece-bonne-serie-b-1",
                                                            children: premierePieceBonneSerieB
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex-row-130",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "flex-col-89",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-14-3",
                                                            src: arrow14,
                                                            alt: "Arrow 14"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "frame-5-20",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                                                href: "https://app.diagrams.net/",
                                                                target: "_blank",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "modeling-108 valign-text-middle inter-bold-tropical-rain-forest-18px",
                                                                    children: modeling
                                                                })
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame6Default.default), {
                                                    className: frame6Props.className
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "flex-col-90",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-11-5",
                                                            src: arrow11,
                                                            alt: "Arrow 11"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                                            to: "/kanban-1",
                                                            className: "align-self-flex-end",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "frame-2-25",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "continue-19 valign-text-middle inter-bold-mineral-green-18px",
                                                                    children: xcontinue
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = SMED;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"b9X5n","../Frame11332":"2UwVc","../Frame114":"aUtEd","../Frame115":"gPV9Y","../Frame116":"70lZ5","../Frame11322":"ju7Cp","../Frame1146":"5jzi1","../Frame1154":"YWwMr","../Frame1165":"hOII7","../Frame11742":"kufPP","../Frame118":"buB7M","../Frame6":"iBQug","./SMED.css":"93FnA","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hOII7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame1165Css = require("./Frame1165.css");
function Frame1165() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "frame-116-178",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "smed-13 valign-text-middle inter-medium-white-18px",
            children: "SMED"
        })
    });
}
exports.default = Frame1165;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./Frame1165.css":"l17CG","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"l17CG":[function() {},{}],"iBQug":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame6Css = require("./Frame6.css");
function Frame6(props) {
    const { className } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `frame-6-10 ${className || ""}`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "machine-arretee inter-medium-dark-fern-18-1px",
            children: "MACHINE ARRETEE"
        })
    });
}
exports.default = Frame6;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./Frame6.css":"6mv93","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6mv93":[function() {},{}],"93FnA":[function() {},{}],"j6uQm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _frame11332 = require("../Frame11332");
var _frame11332Default = parcelHelpers.interopDefault(_frame11332);
var _frame114 = require("../Frame114");
var _frame114Default = parcelHelpers.interopDefault(_frame114);
var _frame115 = require("../Frame115");
var _frame115Default = parcelHelpers.interopDefault(_frame115);
var _frame116 = require("../Frame116");
var _frame116Default = parcelHelpers.interopDefault(_frame116);
var _frame11322 = require("../Frame11322");
var _frame11322Default = parcelHelpers.interopDefault(_frame11322);
var _frame1146 = require("../Frame1146");
var _frame1146Default = parcelHelpers.interopDefault(_frame1146);
var _frame1154 = require("../Frame1154");
var _frame1154Default = parcelHelpers.interopDefault(_frame1154);
var _frame1164 = require("../Frame1164");
var _frame1164Default = parcelHelpers.interopDefault(_frame1164);
var _frame11742 = require("../Frame11742");
var _frame11742Default = parcelHelpers.interopDefault(_frame11742);
var _frame1136 = require("../Frame1136");
var _frame1136Default = parcelHelpers.interopDefault(_frame1136);
var _visualManagementCss = require("./VisualManagement.css");
function VisualManagement(props) {
    const { x1200PxLogo_Icam__20081, design, leanVsm, arrow9, arrow10, line2, label1, textFormat, label2, line1, place, clickOnModeling, connaissancesCompetences, collaborateursEquipes, strategiesProjets, ideesInformations, tempsPriorites, arrow11, arrow16, arrow13, arrow14, mieuxManager, arrow12, arrow15, problemesDecision, modeling, analyzeTheFuturPerformances, frame1136Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "visual-management-15 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group1-43",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-64",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "nav-items-container-34",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-2-50",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11332Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame114Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame115Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame116Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "frame-117-101",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "design-82 valign-text-middle inter-medium-sonic-silver-18px",
                                                children: design
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11322Default.default), {})
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-3-76",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                            to: "/lean-vsm",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "frame-113-65",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "lean-vsm-14 valign-text-middle inter-medium-star-dust-18px",
                                                    children: leanVsm
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1146Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1154Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1164Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11742Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1136Default.default), {
                                            className: frame1136Props.className,
                                            children: frame1136Props.children
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-131",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-row-132",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex-col-91 inter-medium-rum-swizzle-18-1px",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "arrow-container-21",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "arrow-9-13",
                                                    src: arrow9,
                                                    alt: "Arrow 9"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "arrow-10-7",
                                                    src: arrow10,
                                                    alt: "Arrow 10"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "ellipse-85-13"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "rectangle-9-4"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "frame-5-21"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "overlap-group2-20",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "line-2-19",
                                                    src: line2,
                                                    alt: "Line 2"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "ellipse-86-22"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "label-151",
                                            children: label1
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "text-format-21",
                                            src: textFormat,
                                            alt: "Text format"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "label-152",
                                            children: label2
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex-row-133",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "line-1-17",
                                            src: line1,
                                            alt: "Line 1"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                            to: "/kanban-1",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "frame-11-10",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "place-264 valign-text-middle inter-bold-tropical-rain-forest-18px",
                                                    children: place
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-col-92",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "click-on-modeling-18 valign-text-middle bevan-normal-white-20px",
                                    children: clickOnModeling
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "overlap-group3-20 inter-medium-dark-fern-18-1px",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "overlap-group2-21",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "frame-6-12",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "connaissances-competences",
                                                        children: connaissancesCompetences
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "frame-7-7",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "collaborateurs-equipes",
                                                        children: collaborateursEquipes
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "frame-10-7",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "strategies-projets",
                                                        children: strategiesProjets
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "frame-8-15",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "idees-informations",
                                                        children: ideesInformations
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "overlap-group-65",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "frame-6-13",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "temps-priorites",
                                                                children: tempsPriorites
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-11-6",
                                                            src: arrow11,
                                                            alt: "Arrow 11"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-16-4",
                                                            src: arrow16,
                                                            alt: "Arrow 16"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-13-7",
                                                            src: arrow13,
                                                            alt: "Arrow 13"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-14-4",
                                                            src: arrow14,
                                                            alt: "Arrow 14"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "ellipse-87-5"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                            className: "mieux-manager",
                                                            children: mieuxManager
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "arrow-12-6",
                                                    src: arrow12,
                                                    alt: "Arrow 12"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "arrow-15-4",
                                                    src: arrow15,
                                                    alt: "Arrow 15"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "frame-9-8",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "problemes-decision",
                                                children: problemesDecision
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "frame-container-15",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "frame-8-16",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                                href: "https://app.diagrams.net/",
                                                target: "_blank",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "modeling-109 valign-text-middle inter-bold-tropical-rain-forest-18px",
                                                    children: modeling
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                            to: "/environmental-1",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "frame-2-26",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "analyze-the-futur-performances valign-text-middle inter-bold-tropical-rain-forest-18px",
                                                    children: analyzeTheFuturPerformances
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = VisualManagement;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"b9X5n","../Frame11332":"2UwVc","../Frame114":"aUtEd","../Frame115":"gPV9Y","../Frame116":"70lZ5","../Frame11322":"ju7Cp","../Frame1146":"5jzi1","../Frame1154":"YWwMr","../Frame1164":"eReDS","../Frame11742":"kufPP","../Frame1136":"MRQ9D","./VisualManagement.css":"dougE","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"MRQ9D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame1136Css = require("./Frame1136.css");
function Frame1136(props) {
    const { children, className } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `frame-118 ${className || ""}`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "informational-model-1 valign-text-middle inter-medium-white-18px",
            children: children
        })
    });
}
exports.default = Frame1136;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./Frame1136.css":"5cfy1","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5cfy1":[function() {},{}],"dougE":[function() {},{}],"9JHHR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _frame11332 = require("../Frame11332");
var _frame11332Default = parcelHelpers.interopDefault(_frame11332);
var _frame114 = require("../Frame114");
var _frame114Default = parcelHelpers.interopDefault(_frame114);
var _frame115 = require("../Frame115");
var _frame115Default = parcelHelpers.interopDefault(_frame115);
var _frame116 = require("../Frame116");
var _frame116Default = parcelHelpers.interopDefault(_frame116);
var _frame11322 = require("../Frame11322");
var _frame11322Default = parcelHelpers.interopDefault(_frame11322);
var _frame1146 = require("../Frame1146");
var _frame1146Default = parcelHelpers.interopDefault(_frame1146);
var _frame1154 = require("../Frame1154");
var _frame1154Default = parcelHelpers.interopDefault(_frame1154);
var _frame1164 = require("../Frame1164");
var _frame1164Default = parcelHelpers.interopDefault(_frame1164);
var _frame1175 = require("../Frame1175");
var _frame1175Default = parcelHelpers.interopDefault(_frame1175);
var _frame118 = require("../Frame118");
var _frame118Default = parcelHelpers.interopDefault(_frame118);
var _kanbanCss = require("./Kanban.css");
function Kanban(props) {
    const { x1200PxLogo_Icam__20081, design, leanVsm, arrow9, arrow10, rectangle23, line2, label1, textFormat, label2, line22, place1, clickOnModeling, place2, arrow11, line4, urgence, aFaire, termine, enAttente, enCours, line3, modeling, xcontinue, frame118Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "kanban-14 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group2-22",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-65",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "nav-items-container-35",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-2-51",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11332Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame114Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame115Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame116Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "frame-117-102",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "design-83 valign-text-middle inter-medium-sonic-silver-18px",
                                                children: design
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11322Default.default), {})
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-3-77",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                            to: "/lean-vsm",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "frame-113-66",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "lean-vsm-15 valign-text-middle inter-medium-star-dust-18px",
                                                    children: leanVsm
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1146Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1154Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1164Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1175Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame118Default.default), {
                                            className: frame118Props.className,
                                            children: frame118Props.children
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-134",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-col-94",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex-col-95",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "arrow-container-22",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "arrow-9-14",
                                                    src: arrow9,
                                                    alt: "Arrow 9"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "arrow-10-8",
                                                    src: arrow10,
                                                    alt: "Arrow 10"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "ellipse-85-14"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "rectangle-9-5"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "frame-5-22"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex-row-135",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex-col-93",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "rectangle-23-4",
                                                    src: rectangle23,
                                                    alt: "Rectangle 23"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "rectangle-25-1"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex-col-93",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "rectangle-24-4"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "rectangle-26-1"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "group-container-2",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "group-84-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "overlap-group-66",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "line-2-20",
                                                            src: line2,
                                                            alt: "Line 2"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "ellipse-86-23"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "label-153 inter-medium-rum-swizzle-18-1px",
                                                    children: label1
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "group-83-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "text-format-22",
                                                    src: textFormat,
                                                    alt: "Text format"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "label-154 inter-medium-rum-swizzle-18-1px",
                                                    children: label2
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-row-136",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    className: "line-22-1",
                                    src: line22,
                                    alt: "Line 22"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                    to: "/smed",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "frame-7-8",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "place-265 valign-text-middle inter-bold-tropical-rain-forest-18px",
                                            children: place1
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex-col-96",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "click-on-modeling-19 valign-text-middle bevan-normal-white-20px",
                                            children: clickOnModeling
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "overlap-group3-21",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                                    className: "place-266 valign-text-middle inter-bold-mineral-green-24px",
                                                    children: place2
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "overlap-group1-44",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "rectangle-10-4"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "rectangle-13-1"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "rectangle-12-1"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "rectangle-11-3"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-11-7",
                                                            src: arrow11,
                                                            alt: "Arrow 11"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "line-4-5",
                                                            src: line4,
                                                            alt: "Line 4"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "urgence-1 inter-medium-dark-fern-15px",
                                                            children: urgence
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "rectangle-17-1"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "rectangle-16-1"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "rectangle-14-1"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "rectangle-15-1"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "rectangle-18-1"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "rectangle-19-1"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "rectangle-21-1"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "a-faire inter-medium-dark-fern-18-1px",
                                                    children: aFaire
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "termine inter-medium-dark-fern-18-1px",
                                                    children: termine
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "en-attente inter-medium-dark-fern-18-1px",
                                                    children: enAttente
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "en-cours inter-medium-dark-fern-18-1px",
                                                    children: enCours
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "line-3-7",
                                                    src: line3,
                                                    alt: "Line 3"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "frame-container-16",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "frame-8-17",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                                        href: "https://app.diagrams.net/",
                                                        target: "_blank",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "modeling-110 valign-text-middle inter-bold-tropical-rain-forest-18px",
                                                            children: modeling
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                                    to: "/visual-management",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "frame-2-27",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "continue-20 valign-text-middle inter-bold-mineral-green-18px",
                                                            children: xcontinue
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Kanban;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"b9X5n","../Frame11332":"2UwVc","../Frame114":"aUtEd","../Frame115":"gPV9Y","../Frame116":"70lZ5","../Frame11322":"ju7Cp","../Frame1146":"5jzi1","../Frame1154":"YWwMr","../Frame1164":"eReDS","../Frame1175":"i6XzM","../Frame118":"buB7M","./Kanban.css":"eNAKD","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"i6XzM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame1175Css = require("./Frame1175.css");
function Frame1175() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "frame-117-95",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "kanban-12 valign-text-middle inter-medium-white-18px",
            children: "Kanban"
        })
    });
}
exports.default = Frame1175;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./Frame1175.css":"5LKt9","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5LKt9":[function() {},{}],"eNAKD":[function() {},{}],"c7S5d":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _frame101 = require("../Frame101");
var _frame101Default = parcelHelpers.interopDefault(_frame101);
var _frame102 = require("../Frame102");
var _frame102Default = parcelHelpers.interopDefault(_frame102);
var _frame11732 = require("../Frame11732");
var _frame11732Default = parcelHelpers.interopDefault(_frame11732);
var _kaizen2Css = require("./Kaizen2.css");
function Kaizen2(props) {
    const { x1200PxLogo_Icam__20081, pleaseAnswerTheFollowingQuestions, navItems2Props, navItems3Props, toggleProps, frame101Props, frame102Props, frame11732Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "kaizen-2-1 screen",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "overlap-group-67",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "rectangle-3-25"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {
                        className: navItems2Props.className
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                        className: navItems3Props.className,
                        frame1172Props: navItems3Props.frame1172Props,
                        frame1162Props: navItems3Props.frame1162Props,
                        frame1132Props: navItems3Props.frame1132Props
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                        to: "/home",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "x1200px-logo_icam_-_2008-1-66",
                            src: x1200PxLogo_Icam__20081,
                            alt: "1200px-Logo_ICAM_-_2008 1"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                        className: toggleProps.className,
                        buttonSecondaryProps: toggleProps.buttonSecondaryProps
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "please-answer-the-following-questions-23 valign-text-middle bevan-normal-white-20px",
                        children: pleaseAnswerTheFollowingQuestions
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame101Default.default), {
                        className: frame101Props.className,
                        toggleProps: frame101Props.toggleProps,
                        group1021Props: frame101Props.group1021Props,
                        group1022Props: frame101Props.group1022Props,
                        group1023Props: frame101Props.group1023Props,
                        group1024Props: frame101Props.group1024Props,
                        group1025Props: frame101Props.group1025Props
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame102Default.default), {
                        className: frame102Props.className,
                        toggleProps: frame102Props.toggleProps,
                        group1021Props: frame102Props.group1021Props,
                        group1022Props: frame102Props.group1022Props,
                        group1023Props: frame102Props.group1023Props,
                        group1024Props: frame102Props.group1024Props,
                        group1025Props: frame102Props.group1025Props
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11732Default.default), {
                        className: frame11732Props.className
                    })
                ]
            })
        })
    });
}
exports.default = Kaizen2;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"b9X5n","../NavItems2":"bnQuI","../NavItems3":"fOarC","../Toggle":"dSqDu","../Frame101":"dLcbc","../Frame102":"fva7h","../Frame11732":"gSRJf","./Kaizen2.css":"hDdKD","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hDdKD":[function() {},{}],"kRGAr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _frame101 = require("../Frame101");
var _frame101Default = parcelHelpers.interopDefault(_frame101);
var _frame102 = require("../Frame102");
var _frame102Default = parcelHelpers.interopDefault(_frame102);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _kanban3Css = require("./Kanban3.css");
function Kanban3(props) {
    const { x1200PxLogo_Icam__20081, pleaseAnswerTheFollowingQuestions, kaizen, navItems3Props, frame101Props, frame102Props, toggleProps } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "kanban-3-1 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group1-45",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-67",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "nav-items-container-36",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                                    className: navItems3Props.className,
                                    frame1172Props: navItems3Props.frame1172Props,
                                    frame1162Props: navItems3Props.frame1162Props,
                                    frame1132Props: navItems3Props.frame1132Props
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {})
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group2-23",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "overlap-group-68",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "please-answer-the-following-questions-24 valign-text-middle bevan-normal-white-20px",
                                    children: pleaseAnswerTheFollowingQuestions
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame101Default.default), {
                                    className: frame101Props.className,
                                    toggleProps: frame101Props.toggleProps,
                                    group1021Props: frame101Props.group1021Props,
                                    group1022Props: frame101Props.group1022Props,
                                    group1023Props: frame101Props.group1023Props,
                                    group1024Props: frame101Props.group1024Props,
                                    group1025Props: frame101Props.group1025Props
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame102Default.default), {
                                    className: frame102Props.className,
                                    toggleProps: frame102Props.toggleProps,
                                    group1021Props: frame102Props.group1021Props,
                                    group1022Props: frame102Props.group1022Props,
                                    group1023Props: frame102Props.group1023Props,
                                    group1024Props: frame102Props.group1024Props,
                                    group1025Props: frame102Props.group1025Props
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "frame-117-103",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "kaizen-15 valign-text-middle inter-bold-mineral-green-18px",
                                        children: kaizen
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            className: toggleProps.className,
                            buttonSecondaryProps: toggleProps.buttonSecondaryProps
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Kanban3;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"b9X5n","../NavItems3":"fOarC","../NavItems2":"bnQuI","../Frame101":"dLcbc","../Frame102":"fva7h","../Toggle":"dSqDu","./Kanban3.css":"5S1UY","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5S1UY":[function() {},{}],"773Hj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _frame11332 = require("../Frame11332");
var _frame11332Default = parcelHelpers.interopDefault(_frame11332);
var _frame114 = require("../Frame114");
var _frame114Default = parcelHelpers.interopDefault(_frame114);
var _frame115 = require("../Frame115");
var _frame115Default = parcelHelpers.interopDefault(_frame115);
var _frame116 = require("../Frame116");
var _frame116Default = parcelHelpers.interopDefault(_frame116);
var _frame11322 = require("../Frame11322");
var _frame11322Default = parcelHelpers.interopDefault(_frame11322);
var _headerMenuDefault5 = require("../HeaderMenuDefault5");
var _headerMenuDefault5Default = parcelHelpers.interopDefault(_headerMenuDefault5);
var _headerMenuDefault2 = require("../HeaderMenuDefault2");
var _headerMenuDefault2Default = parcelHelpers.interopDefault(_headerMenuDefault2);
var _frame232 = require("../Frame232");
var _frame232Default = parcelHelpers.interopDefault(_frame232);
var _frame7 = require("../Frame7");
var _frame7Default = parcelHelpers.interopDefault(_frame7);
var _pricing3 = require("../Pricing3");
var _pricing3Default = parcelHelpers.interopDefault(_pricing3);
var _mesureDePerformancesFuturesCss = require("./MesureDePerformancesFutures.css");
function MesureDePerformancesFutures(props) {
    const { x1200PxLogo_Icam__20081, design, label1, label2, notesAtteintesPourChaqueCritre, place, inputType1, inputPlaceholder1, line211, leadTime, inputType2, inputPlaceholder2, line212, environment, inputType3, inputPlaceholder3, line213, xcontinue, headerMenuDefault5Props, headerMenuDefault21Props, headerMenuDefault22Props, frame232Props, pricing31Props, pricing32Props, pricing33Props, pricing34Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
            className: "mesure-de-performances-futures screen",
            name: "form9",
            action: "form9",
            method: "post",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-col-97",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "overlap-group-69",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                    to: "/home",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        className: "x1200px-logo_icam_-_2008-1-68",
                                        src: x1200PxLogo_Icam__20081,
                                        alt: "1200px-Logo_ICAM_-_2008 1"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-container-37",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "nav-items-2-52",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11332Default.default), {}),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame114Default.default), {}),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame115Default.default), {}),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame116Default.default), {}),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "frame-117-104",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "design-84 valign-text-middle inter-medium-sonic-silver-18px",
                                                        children: design
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11322Default.default), {})
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "nav-items",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefault5Default.default), {
                                                    children: headerMenuDefault5Props.children
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefault2Default.default), {
                                                    className: headerMenuDefault21Props.className,
                                                    children: headerMenuDefault21Props.children
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefault2Default.default), {
                                                    className: headerMenuDefault22Props.className,
                                                    children: headerMenuDefault22Props.children
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame232Default.default), {
                                                    headerMenuDefault2Props: frame232Props.headerMenuDefault2Props
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                                    to: "/functional-view-1",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "label-155 inter-medium-sonic-silver-18-1px",
                                                        children: label1
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "label-156 inter-medium-gravel-18-1px",
                                                    children: label2
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-row-137",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame7Default.default), {}),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "notes-atteintes-pour-chaque-critre valign-text-middle bevan-normal-white-20px",
                                    children: notesAtteintesPourChaqueCritre
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "pricing-container-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "pricing-1-2",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                            className: "place-267 inter-bold-mineral-green-24px",
                                            children: place
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            className: "x25-19 inter-bold-mineral-green-56px",
                                            name: "25",
                                            placeholder: inputPlaceholder1,
                                            type: inputType1
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "line-21-8",
                                            src: line211,
                                            alt: "Line 21"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pricing3Default.default), {
                                    cost: pricing31Props.cost
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "pricing-2-2",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "lead-time-3 inter-bold-mineral-green-24px",
                                            children: leadTime
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            className: "x25-20 inter-bold-mineral-green-56px",
                                            name: "25",
                                            placeholder: inputPlaceholder2,
                                            type: inputType2
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "line-21-7",
                                            src: line212,
                                            alt: "Line 21"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pricing3Default.default), {
                                    cost: pricing32Props.cost,
                                    className: pricing32Props.className
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-138",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pricing3Default.default), {
                            cost: pricing33Props.cost,
                            className: pricing33Props.className
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-col-98",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "pricing-6-2",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "environment-2 inter-bold-mineral-green-24px",
                                            children: environment
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            className: "x25-21 inter-bold-mineral-green-56px",
                                            name: "25",
                                            placeholder: inputPlaceholder3,
                                            type: inputType3
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "line-21-7",
                                            src: line213,
                                            alt: "Line 21"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                    to: "/mesure-de-performances-futures-1",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "frame-2-28",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "continue-21 valign-text-middle inter-bold-mineral-green-18px",
                                            children: xcontinue
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pricing3Default.default), {
                            cost: pricing34Props.cost,
                            className: pricing34Props.className
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = MesureDePerformancesFutures;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"b9X5n","../Frame11332":"2UwVc","../Frame114":"aUtEd","../Frame115":"gPV9Y","../Frame116":"70lZ5","../Frame11322":"ju7Cp","../HeaderMenuDefault5":"lDhvq","../HeaderMenuDefault2":"ixaJ9","../Frame232":"4B3A5","../Frame7":"2Zpmx","../Pricing3":"4ShqD","./MesureDePerformancesFutures.css":"Ez0Qt","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lDhvq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _headerMenuDefault5Css = require("./HeaderMenuDefault5.css");
function HeaderMenuDefault5(props) {
    const { children, className } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
        to: "/acquisition",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: `menu-item-default-30 ${className || ""}`,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "label-161 inter-medium-sonic-silver-14px",
                children: children
            })
        })
    });
}
exports.default = HeaderMenuDefault5;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"b9X5n","./HeaderMenuDefault5.css":"l44Kl","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"l44Kl":[function() {},{}],"2Zpmx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame7Css = require("./Frame7.css");
function Frame7(props) {
    const { className } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `frame-7-9 ${className || ""}`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "place-268 valign-text-middle inter-bold-tropical-rain-forest-18px",
            children: "Back"
        })
    });
}
exports.default = Frame7;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./Frame7.css":"g9qwc","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"g9qwc":[function() {},{}],"Ez0Qt":[function() {},{}],"i9LiC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _frame101 = require("../Frame101");
var _frame101Default = parcelHelpers.interopDefault(_frame101);
var _frame102 = require("../Frame102");
var _frame102Default = parcelHelpers.interopDefault(_frame102);
var _frame11732 = require("../Frame11732");
var _frame11732Default = parcelHelpers.interopDefault(_frame11732);
var _x5S2Css = require("./X5s2.css");
function X5s2(props) {
    const { x1200PxLogo_Icam__20081, pleaseAnswerTheFollowingQuestions, navItems2Props, navItems3Props, toggleProps, frame101Props, frame102Props, frame11732Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "x5s-2 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-70",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "rectangle-3-26"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {
                            className: navItems2Props.className
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                            className: navItems3Props.className,
                            frame1172Props: navItems3Props.frame1172Props,
                            frame1162Props: navItems3Props.frame1162Props,
                            frame1132Props: navItems3Props.frame1132Props
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-69",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "please-answer-the-following-questions-25 valign-text-middle bevan-normal-white-20px",
                            children: pleaseAnswerTheFollowingQuestions
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-139",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "overlap-group1-46",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggleProps.className,
                                    buttonSecondaryProps: toggleProps.buttonSecondaryProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame101Default.default), {
                                    className: frame101Props.className,
                                    toggleProps: frame101Props.toggleProps,
                                    group1021Props: frame101Props.group1021Props,
                                    group1022Props: frame101Props.group1022Props,
                                    group1023Props: frame101Props.group1023Props,
                                    group1024Props: frame101Props.group1024Props,
                                    group1025Props: frame101Props.group1025Props
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "frame-container-17",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame102Default.default), {
                                    className: frame102Props.className,
                                    toggleProps: frame102Props.toggleProps,
                                    group1021Props: frame102Props.group1021Props,
                                    group1022Props: frame102Props.group1022Props,
                                    group1023Props: frame102Props.group1023Props,
                                    group1024Props: frame102Props.group1024Props,
                                    group1025Props: frame102Props.group1025Props
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11732Default.default), {
                                    className: frame11732Props.className
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = X5s2;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"b9X5n","../NavItems2":"bnQuI","../NavItems3":"fOarC","../Toggle":"dSqDu","../Frame101":"dLcbc","../Frame102":"fva7h","../Frame11732":"gSRJf","./X5s2.css":"izqdU","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"izqdU":[function() {},{}],"4HgvK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _frame101 = require("../Frame101");
var _frame101Default = parcelHelpers.interopDefault(_frame101);
var _frame102 = require("../Frame102");
var _frame102Default = parcelHelpers.interopDefault(_frame102);
var _frame11732 = require("../Frame11732");
var _frame11732Default = parcelHelpers.interopDefault(_frame11732);
var _kanban2Css = require("./Kanban2.css");
function Kanban2(props) {
    const { x1200PxLogo_Icam__20081, pleaseAnswerTheFollowingQuestions, navItems2Props, navItems3Props, toggleProps, frame101Props, frame102Props, frame11732Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "kanban-2-1 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-71",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "rectangle-3-27"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {
                            className: navItems2Props.className
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                            className: navItems3Props.className,
                            frame1172Props: navItems3Props.frame1172Props,
                            frame1162Props: navItems3Props.frame1162Props,
                            frame1132Props: navItems3Props.frame1132Props
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-70",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "please-answer-the-following-questions-26 valign-text-middle bevan-normal-white-20px",
                            children: pleaseAnswerTheFollowingQuestions
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group1-47",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            className: toggleProps.className,
                            buttonSecondaryProps: toggleProps.buttonSecondaryProps
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame101Default.default), {
                            className: frame101Props.className,
                            toggleProps: frame101Props.toggleProps,
                            group1021Props: frame101Props.group1021Props,
                            group1022Props: frame101Props.group1022Props,
                            group1023Props: frame101Props.group1023Props,
                            group1024Props: frame101Props.group1024Props,
                            group1025Props: frame101Props.group1025Props
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame102Default.default), {
                            className: frame102Props.className,
                            toggleProps: frame102Props.toggleProps,
                            group1021Props: frame102Props.group1021Props,
                            group1022Props: frame102Props.group1022Props,
                            group1023Props: frame102Props.group1023Props,
                            group1024Props: frame102Props.group1024Props,
                            group1025Props: frame102Props.group1025Props
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11732Default.default), {
                            className: frame11732Props.className
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Kanban2;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"b9X5n","../NavItems2":"bnQuI","../NavItems3":"fOarC","../Toggle":"dSqDu","../Frame101":"dLcbc","../Frame102":"fva7h","../Frame11732":"gSRJf","./Kanban2.css":"b3Gji","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"b3Gji":[function() {},{}],"1XWTT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _frame101 = require("../Frame101");
var _frame101Default = parcelHelpers.interopDefault(_frame101);
var _frame102 = require("../Frame102");
var _frame102Default = parcelHelpers.interopDefault(_frame102);
var _x5S3Css = require("./X5s3.css");
function X5s3(props) {
    const { x1200PxLogo_Icam__20081, pleaseAnswerTheFollowingQuestions, kanban, navItems2Props, navItems3Props, toggleProps, frame101Props, frame102Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "x5s-3 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-72",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "rectangle-3-28"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {
                            className: navItems2Props.className
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                            className: navItems3Props.className,
                            frame1172Props: navItems3Props.frame1172Props,
                            frame1162Props: navItems3Props.frame1162Props,
                            frame1132Props: navItems3Props.frame1132Props
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-71",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "please-answer-the-following-questions-27 valign-text-middle bevan-normal-white-20px",
                            children: pleaseAnswerTheFollowingQuestions
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            className: toggleProps.className,
                            buttonSecondaryProps: toggleProps.buttonSecondaryProps
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame101Default.default), {
                            className: frame101Props.className,
                            toggleProps: frame101Props.toggleProps,
                            group1021Props: frame101Props.group1021Props,
                            group1022Props: frame101Props.group1022Props,
                            group1023Props: frame101Props.group1023Props,
                            group1024Props: frame101Props.group1024Props,
                            group1025Props: frame101Props.group1025Props
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame102Default.default), {
                            className: frame102Props.className,
                            toggleProps: frame102Props.toggleProps,
                            group1021Props: frame102Props.group1021Props,
                            group1022Props: frame102Props.group1022Props,
                            group1023Props: frame102Props.group1023Props,
                            group1024Props: frame102Props.group1024Props,
                            group1025Props: frame102Props.group1025Props
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "frame-117-105",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "kanban-15 valign-text-middle inter-bold-mineral-green-18px",
                        children: kanban
                    })
                })
            ]
        })
    });
}
exports.default = X5s3;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"b9X5n","../NavItems2":"bnQuI","../NavItems3":"fOarC","../Toggle":"dSqDu","../Frame101":"dLcbc","../Frame102":"fva7h","./X5s3.css":"cng4i","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cng4i":[function() {},{}],"6CMW1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _group102 = require("../Group102");
var _group102Default = parcelHelpers.interopDefault(_group102);
var _frame11732 = require("../Frame11732");
var _frame11732Default = parcelHelpers.interopDefault(_frame11732);
var _leanVSM3Css = require("./LeanVSM3.css");
function LeanVSM3(props) {
    const { x1200PxLogo_Icam__20081, pleaseAnswerTheFollowingQuestions, inputType1, inputPlaceholder1, inputType2, inputPlaceholder2, inputType3, inputPlaceholder3, inputType4, inputPlaceholder4, inputType5, inputPlaceholder5, inputType6, inputPlaceholder6, inputType7, inputPlaceholder7, inputType8, inputPlaceholder8, inputType9, inputPlaceholder9, inputType10, inputPlaceholder10, navItems3Props, toggle1Props, group1021Props, group1022Props, group1023Props, group1024Props, group1025Props, toggle2Props, group1026Props, group1027Props, group1028Props, group1029Props, group10210Props, frame11732Props, toggle3Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "lean-vsm-3-1 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group1-48",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-72",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "nav-items-container-38",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                                    className: navItems3Props.className,
                                    frame1172Props: navItems3Props.frame1172Props,
                                    frame1162Props: navItems3Props.frame1162Props,
                                    frame1132Props: navItems3Props.frame1132Props
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {})
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group2-24",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "overlap-group3-22",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "overlap-group-73",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "please-answer-the-following-questions-28 valign-text-middle bevan-normal-white-20px",
                                            children: pleaseAnswerTheFollowingQuestions
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "frame-93-3",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                                    className: toggle1Props.className,
                                                    buttonSecondaryProps: toggle1Props.buttonSecondaryProps
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    className: "a-quelle-frquence-re-9 subtitel",
                                                    name: "aquellefr\xe9quencerenouvelezvousvotrestock",
                                                    placeholder: inputPlaceholder1,
                                                    type: inputType1
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                                                    line24: group1021Props.line24
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    className: "combien-de-temps-en-9 subtitel",
                                                    name: "combiendetempsenmoyenneunarticleeffectuedansvotremagazin",
                                                    placeholder: inputPlaceholder2,
                                                    type: inputType2
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                                                    line24: group1022Props.line24
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    className: "vous-9 subtitel",
                                                    name: "vousarrive-t-ildavoirdesrupturesdestocksioui\xe0quellefr\xe9quence",
                                                    placeholder: inputPlaceholder3,
                                                    type: inputType3
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                                                    line24: group1023Props.line24
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    className: "vous-9 subtitel",
                                                    name: "avezvousmisenplacedemesuresdam\xe9lioration",
                                                    placeholder: inputPlaceholder4,
                                                    type: inputType4
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                                                    line24: group1024Props.line24
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    className: "x-19 subtitel",
                                                    name: "*******************************************",
                                                    placeholder: inputPlaceholder5,
                                                    type: inputType5
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                                                    line24: group1025Props.line24
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "frame-94-3",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                                    className: toggle2Props.className,
                                                    buttonSecondaryProps: toggle2Props.buttonSecondaryProps
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    className: "dans-quel-rayon-se-situe-vos-clients-10 subtitel",
                                                    name: "dansquelrayonsesituevosclients",
                                                    placeholder: inputPlaceholder6,
                                                    type: inputType6
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                                                    line24: group1026Props.line24
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    className: "a-quelle-frquence-ef subtitel",
                                                    name: "aquellefr\xe9quenceeffectuezvousdeslivraisons",
                                                    placeholder: inputPlaceholder7,
                                                    type: inputType7
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                                                    line24: group1027Props.line24
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    className: "quel-est-votre-taux-de-service subtitel",
                                                    name: "quelestvotretauxdeservice",
                                                    placeholder: inputPlaceholder8,
                                                    type: inputType8
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                                                    line24: group1028Props.line24
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    className: "quel-est-votre-taux-de-retard-10 subtitel",
                                                    name: "quelestvotretauxderetard",
                                                    placeholder: inputPlaceholder9,
                                                    type: inputType9
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                                                    line24: group1029Props.line24
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    className: "x-20 subtitel",
                                                    name: "*************************************",
                                                    placeholder: inputPlaceholder10,
                                                    type: inputType10
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                                                    line24: group10210Props.line24
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11732Default.default), {
                                    className: frame11732Props.className
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            className: toggle3Props.className,
                            buttonSecondaryProps: toggle3Props.buttonSecondaryProps
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = LeanVSM3;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"b9X5n","../NavItems3":"fOarC","../NavItems2":"bnQuI","../Toggle":"dSqDu","../Group102":"cllgP","../Frame11732":"gSRJf","./LeanVSM3.css":"9AAuh","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9AAuh":[function() {},{}],"2YMz8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _group102 = require("../Group102");
var _group102Default = parcelHelpers.interopDefault(_group102);
var _frame11732 = require("../Frame11732");
var _frame11732Default = parcelHelpers.interopDefault(_frame11732);
var _leanVSM2Css = require("./LeanVSM2.css");
function LeanVSM2(props) {
    const { x1200PxLogo_Icam__20081, pleaseAnswerTheFollowingQuestions, inputType1, inputPlaceholder1, inputType2, inputPlaceholder2, inputType3, inputPlaceholder3, inputType4, inputPlaceholder4, inputType5, inputPlaceholder5, inputType6, inputPlaceholder6, inputType7, inputPlaceholder7, inputType8, inputPlaceholder8, inputType9, inputPlaceholder9, inputType10, inputPlaceholder10, navItems2Props, navItems3Props, toggle1Props, group1021Props, group1022Props, group1023Props, group1024Props, group1025Props, toggle2Props, toggle3Props, group1026Props, group1027Props, group1028Props, group1029Props, group10210Props, frame11732Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "lean-vsm-2-1 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-74",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "rectangle-3-29"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {
                            className: navItems2Props.className
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                            className: navItems3Props.className,
                            frame1172Props: navItems3Props.frame1172Props,
                            frame1162Props: navItems3Props.frame1162Props,
                            frame1132Props: navItems3Props.frame1132Props
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-73",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "please-answer-the-following-questions-29 valign-text-middle bevan-normal-white-20px",
                            children: pleaseAnswerTheFollowingQuestions
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "frame-89",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggle1Props.className,
                                    buttonSecondaryProps: toggle1Props.buttonSecondaryProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    className: "a-quelle-frquence-re-10 subtitel",
                                    name: "aquellefr\xe9quencerenouvelezvousvotrestock",
                                    placeholder: inputPlaceholder1,
                                    type: inputType1
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                                    line24: group1021Props.line24
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    className: "combien-de-temps-en-10 subtitel",
                                    name: "combiendetempsenmoyenneunarticleeffectuedansvotremagazin",
                                    placeholder: inputPlaceholder2,
                                    type: inputType2
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                                    line24: group1022Props.line24
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    className: "vous-10 subtitel",
                                    name: "vousarrive-t-ildavoirdesrupturesdestocksioui\xe0quellefr\xe9quence",
                                    placeholder: inputPlaceholder3,
                                    type: inputType3
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                                    line24: group1023Props.line24
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    className: "vous-10 subtitel",
                                    name: "avezvousmisenplacedemesuresdam\xe9lioration",
                                    placeholder: inputPlaceholder4,
                                    type: inputType4
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                                    line24: group1024Props.line24
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    className: "x-21 subtitel",
                                    name: "*******************************************",
                                    placeholder: inputPlaceholder5,
                                    type: inputType5
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                                    line24: group1025Props.line24
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                    className: toggle2Props.className,
                    buttonSecondaryProps: toggle2Props.buttonSecondaryProps
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "frame-90",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            className: toggle3Props.className,
                            buttonSecondaryProps: toggle3Props.buttonSecondaryProps
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                            className: "dans-quel-rayon-se-situe-vos-clients-11 subtitel",
                            name: "dansquelrayonsesituevosclients",
                            placeholder: inputPlaceholder6,
                            type: inputType6
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                            line24: group1026Props.line24
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                            className: "a-quelle-frquence-ef-1 subtitel",
                            name: "aquellefr\xe9quenceeffectuezvousdeslivraisons",
                            placeholder: inputPlaceholder7,
                            type: inputType7
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                            line24: group1027Props.line24
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                            className: "quel-est-votre-taux-de-service-1 subtitel",
                            name: "quelestvotretauxdeservice",
                            placeholder: inputPlaceholder8,
                            type: inputType8
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                            line24: group1028Props.line24
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                            className: "quel-est-votre-taux-de-retard-11 subtitel",
                            name: "quelestvotretauxderetard",
                            placeholder: inputPlaceholder9,
                            type: inputType9
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                            line24: group1029Props.line24
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                            className: "x-22 subtitel",
                            name: "*************************************",
                            placeholder: inputPlaceholder10,
                            type: inputType10
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                            line24: group10210Props.line24
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11732Default.default), {
                    className: frame11732Props.className
                })
            ]
        })
    });
}
exports.default = LeanVSM2;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"b9X5n","../NavItems2":"bnQuI","../NavItems3":"fOarC","../Toggle":"dSqDu","../Group102":"cllgP","../Frame11732":"gSRJf","./LeanVSM2.css":"eCcLU","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eCcLU":[function() {},{}],"k8iyX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _kaizen11Css = require("./Kaizen11.css");
function Kaizen11() {
    const [hasImplementedKaizen2, setHasImplementedKaizen2] = (0, _react.useState)(false);
    const [showFileUpload, setShowFileUpload] = (0, _react.useState)(false);
    const [selectedFile, setSelectedFile] = (0, _react.useState)(null);
    const handleFileChange = (event)=>{
        setSelectedFile(event.target.files[0]);
    };
    const handleSubmit = (event)=>{
        event.preventDefault();
        // Ici vous pouvez ajouter la logique pour traiter le fichier
        console.log("Fichier s\xe9lectionn\xe9:", selectedFile);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "kaizen2-page screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "header",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                        to: "/home",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "logo-icam",
                            src: "/img/1200px-logo-icam---2008-1@2x.png",
                            alt: "Logo ICAM"
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "content-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                            className: "page-title",
                            children: "M\xe9thodologie Kaizen - \xc9tape 2"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "question-section",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Avez-vous d\xe9j\xe0 mis en place des actions d'am\xe9lioration continue dans votre entreprise ?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "buttons-container",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            className: `choice-button ${hasImplementedKaizen2 ? 'active' : ''}`,
                                            onClick: ()=>{
                                                setHasImplementedKaizen2(true);
                                                setShowFileUpload(true);
                                            },
                                            children: "Oui"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            className: `choice-button ${!hasImplementedKaizen2 ? 'active' : ''}`,
                                            onClick: ()=>{
                                                setHasImplementedKaizen2(false);
                                                setShowFileUpload(false);
                                            },
                                            children: "Non"
                                        })
                                    ]
                                }),
                                showFileUpload && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "file-upload-section",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "upload-text",
                                            children: "Veuillez importer votre documentation sur les actions d'am\xe9lioration continue :"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                                            onSubmit: handleSubmit,
                                            className: "upload-form",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    type: "file",
                                                    onChange: handleFileChange,
                                                    accept: ".pdf,.doc,.docx,.png,.jpg,.jpeg",
                                                    className: "file-input"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                    type: "submit",
                                                    className: "submit-button",
                                                    children: "Importer"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                !hasImplementedKaizen2 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "redirect-section",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "redirect-text",
                                            children: "Nous vous recommandons de passer \xe0 la m\xe9thode SMED pour continuer votre d\xe9marche d'am\xe9lioration :"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                            to: "/smed-1",
                                            className: "redirect-button",
                                            children: "Passer \xe0 la m\xe9thode SMED"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Kaizen11;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"b9X5n","./Kaizen11.css":"tU0Zt","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"tU0Zt":[function() {},{}],"iYCdE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _group102 = require("../Group102");
var _group102Default = parcelHelpers.interopDefault(_group102);
var _frame102 = require("../Frame102");
var _frame102Default = parcelHelpers.interopDefault(_frame102);
var _leanVSM4Css = require("./LeanVSM4.css");
function LeanVSM4(props) {
    const { x1200PxLogo_Icam__20081, pleaseAnswerTheFollowingQuestions, inputType1, inputPlaceholder1, inputType2, inputPlaceholder2, inputType3, inputPlaceholder3, inputType4, inputPlaceholder4, inputType5, inputPlaceholder5, x5S, navItems2Props, navItems3Props, toggle1Props, toggle2Props, group1021Props, group1022Props, group1023Props, group1024Props, group1025Props, frame102Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "lean-vsm-4-1 screen",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "overlap-group-76",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "rectangle-3-30"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {
                        className: navItems2Props.className
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                        className: navItems3Props.className,
                        frame1172Props: navItems3Props.frame1172Props,
                        frame1162Props: navItems3Props.frame1162Props,
                        frame1132Props: navItems3Props.frame1132Props
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                        to: "/home",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "x1200px-logo_icam_-_2008-1-76",
                            src: x1200PxLogo_Icam__20081,
                            alt: "1200px-Logo_ICAM_-_2008 1"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "please-answer-the-following-questions-30 valign-text-middle bevan-normal-white-20px",
                        children: pleaseAnswerTheFollowingQuestions
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                        className: toggle1Props.className,
                        buttonSecondaryProps: toggle1Props.buttonSecondaryProps
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "frame-95-5",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                className: toggle2Props.className,
                                buttonSecondaryProps: toggle2Props.buttonSecondaryProps
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                className: "a-quelle-frquence-re-11 subtitel",
                                name: "aquellefr\xe9quencerenouvelezvousvotrestock",
                                placeholder: inputPlaceholder1,
                                type: inputType1
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                                line24: group1021Props.line24,
                                className: group1021Props.className
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                className: "combien-de-temps-en-11 subtitel",
                                name: "combiendetempsenmoyenneunarticleeffectuedansvotremagazin",
                                placeholder: inputPlaceholder2,
                                type: inputType2
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                                line24: group1022Props.line24,
                                className: group1022Props.className
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                className: "vous-11 subtitel",
                                name: "vousarrive-t-ildavoirdesrupturesdestocksioui\xe0quellefr\xe9quence",
                                placeholder: inputPlaceholder3,
                                type: inputType3
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                                line24: group1023Props.line24,
                                className: group1023Props.className
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                className: "vous-11 subtitel",
                                name: "avezvousmisenplacedemesuresdam\xe9lioration",
                                placeholder: inputPlaceholder4,
                                type: inputType4
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                                line24: group1024Props.line24,
                                className: group1024Props.className
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                className: "x-23 subtitel",
                                name: "*******************************************",
                                placeholder: inputPlaceholder5,
                                type: inputType5
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                                line24: group1025Props.line24,
                                className: group1025Props.className
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame102Default.default), {
                        className: frame102Props.className,
                        toggleProps: frame102Props.toggleProps,
                        group1021Props: frame102Props.group1021Props,
                        group1022Props: frame102Props.group1022Props,
                        group1023Props: frame102Props.group1023Props,
                        group1024Props: frame102Props.group1024Props,
                        group1025Props: frame102Props.group1025Props
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "frame-117-106",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "x5-s-14 valign-text-middle inter-bold-mineral-green-18px",
                            children: x5S
                        })
                    })
                ]
            })
        })
    });
}
exports.default = LeanVSM4;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"b9X5n","../NavItems2":"bnQuI","../NavItems3":"fOarC","../Toggle":"dSqDu","../Group102":"cllgP","../Frame102":"fva7h","./LeanVSM4.css":"6LSCZ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6LSCZ":[function() {},{}],"6sgVa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _frame11332 = require("../Frame11332");
var _frame11332Default = parcelHelpers.interopDefault(_frame11332);
var _frame114 = require("../Frame114");
var _frame114Default = parcelHelpers.interopDefault(_frame114);
var _frame115 = require("../Frame115");
var _frame115Default = parcelHelpers.interopDefault(_frame115);
var _frame116 = require("../Frame116");
var _frame116Default = parcelHelpers.interopDefault(_frame116);
var _frame11322 = require("../Frame11322");
var _frame11322Default = parcelHelpers.interopDefault(_frame11322);
var _headerMenuDefault5 = require("../HeaderMenuDefault5");
var _headerMenuDefault5Default = parcelHelpers.interopDefault(_headerMenuDefault5);
var _frame232 = require("../Frame232");
var _frame232Default = parcelHelpers.interopDefault(_frame232);
var _frame7 = require("../Frame7");
var _frame7Default = parcelHelpers.interopDefault(_frame7);
var _mesureDePerformancesFutures1Css = require("./MesureDePerformancesFutures1.css");
function MesureDePerformancesFutures1(props) {
    const { x1200PxLogo_Icam__20081, design, label1, label2, finish, headerMenuDefault51Props, headerMenuDefault52Props, headerMenuDefault53Props, frame232Props, frame7Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
            className: "mesure-de-performances-futures-1 screen",
            name: "form10",
            action: "form10",
            method: "post",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-77",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-77",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "nav-items-container-41",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-2-54",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11332Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame114Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame115Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame116Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "frame-117-107",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "design-85 valign-text-middle inter-medium-sonic-silver-18px",
                                                children: design
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11322Default.default), {})
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-1",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefault5Default.default), {
                                            children: headerMenuDefault51Props.children
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefault5Default.default), {
                                            className: headerMenuDefault52Props.className,
                                            children: headerMenuDefault52Props.children
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefault5Default.default), {
                                            className: headerMenuDefault53Props.className,
                                            children: headerMenuDefault53Props.children
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame232Default.default), {
                                            headerMenuDefault2Props: frame232Props.headerMenuDefault2Props
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                            to: "/functional-view-1",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "label-162 inter-medium-sonic-silver-18-1px",
                                                children: label1
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "label-166 inter-medium-gravel-18-1px",
                                            children: label2
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame7Default.default), {
                    className: frame7Props.className
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                    to: "/existing-case",
                    className: "align-self-flex-end",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "frame-3-6",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "finish-1 valign-text-middle inter-bold-tropical-rain-forest-18px",
                            children: finish
                        })
                    })
                })
            ]
        })
    });
}
exports.default = MesureDePerformancesFutures1;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"b9X5n","../Frame11332":"2UwVc","../Frame114":"aUtEd","../Frame115":"gPV9Y","../Frame116":"70lZ5","../Frame11322":"ju7Cp","../HeaderMenuDefault5":"lDhvq","../Frame232":"4B3A5","../Frame7":"2Zpmx","./MesureDePerformancesFutures1.css":"dXsz1","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dXsz1":[function() {},{}],"3hjTg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _frame112 = require("../Frame112");
var _frame112Default = parcelHelpers.interopDefault(_frame112);
var _existingSystems2Css = require("./ExistingSystems2.css");
function ExistingSystems2(props) {
    const { x1200PxLogo_Icam__20081, existingSystems, x2SupplementaryModels, leanVsm, x4Kaizen, x25S, x5Smed, x6VisualManagement, ellipse116, navItems3Props, frame112Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "existing-systems-1 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-78",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-78",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "nav-items-container-42",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                                    className: navItems3Props.className,
                                    frame1172Props: navItems3Props.frame1172Props,
                                    frame1162Props: navItems3Props.frame1162Props,
                                    frame1132Props: navItems3Props.frame1132Props
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {})
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "existing-systems-3 valign-text-middle bevan-normal-white-20px",
                    children: existingSystems
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "x2-supplementary-models valign-text-middle bevan-normal-white-20px",
                    children: x2SupplementaryModels
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "group-110",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "frame-container-19",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "frame-11-11",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "lean-vsm-16 valign-text-middle inter-bold-mineral-green-18px",
                                        children: leanVsm
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "frame-11-11",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "x4-kaizen valign-text-middle inter-bold-mineral-green-18px",
                                        children: x4Kaizen
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "frame-container-20",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "frame-113-68",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "x2-5-s valign-text-middle inter-bold-mineral-green-18px",
                                        children: x25S
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "frame-11-11",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "x5-smed valign-text-middle inter-bold-mineral-green-18px",
                                        children: x5Smed
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "frame-container-21",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame112Default.default), {
                                    className: frame112Props.className,
                                    children: frame112Props.children
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "frame-11-11",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "x6-visual-management valign-text-middle inter-bold-mineral-green-18px",
                                        children: x6VisualManagement
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    className: "ellipse-116-3",
                    src: ellipse116,
                    alt: "Ellipse 116"
                })
            ]
        })
    });
}
exports.default = ExistingSystems2;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"b9X5n","../NavItems3":"fOarC","../NavItems2":"bnQuI","../Frame112":"ad5n2","./ExistingSystems2.css":"7yf72","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7yf72":[function() {},{}],"7STBG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _frame136 = require("../Frame136");
var _frame136Default = parcelHelpers.interopDefault(_frame136);
var _frame144 = require("../Frame144");
var _frame144Default = parcelHelpers.interopDefault(_frame144);
var _clientConsommateur3Css = require("./ClientConsommateur3.css");
function ClientConsommateur3(props) {
    const { x1200PxLogo_Icam__20081, pleaseAnswerTheFollowingQuestions, inputType1, inputPlaceholder1, inputType2, inputPlaceholder2, inputType3, inputPlaceholder3, inputType4, inputPlaceholder4, inputType5, inputPlaceholder5, inputType6, inputPlaceholder6, inputType7, inputPlaceholder7, inputType8, inputPlaceholder8, inputType9, inputPlaceholder9, goOnToTheNextStep, navItems2Props, navItems3Props, toggle1Props, frame1361Props, frame1362Props, frame1363Props, toggle2Props, frame1364Props, frame1365Props, frame1366Props, toggle3Props, frame1367Props, frame144Props, frame1368Props, toggle4Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "client-consommateur-3 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-86",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "rectangle-3-31"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {
                            className: navItems2Props.className
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                            className: navItems3Props.className,
                            frame1172Props: navItems3Props.frame1172Props,
                            frame1162Props: navItems3Props.frame1162Props,
                            frame1132Props: navItems3Props.frame1132Props
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-86",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "please-answer-the-following-questions-31 valign-text-middle bevan-normal-white-20px",
                            children: pleaseAnswerTheFollowingQuestions
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "emploirelation-employeur-employ-15",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "emploi-relation-employeur-employ-1-12",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggle1Props.className,
                                    buttonSecondaryProps: toggle1Props.buttonSecondaryProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    className: "do-you-do-reviews-1 subtitel",
                                    name: "doyoudoreviews",
                                    placeholder: inputPlaceholder1,
                                    type: inputType1
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame136Default.default), {
                                    ouinonProps: frame1361Props.ouinonProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    className: "in-paper-format-3 subtitel",
                                    name: "inpaperformat",
                                    placeholder: inputPlaceholder2,
                                    type: inputType2
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame136Default.default), {
                                    ouinonProps: frame1362Props.ouinonProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    className: "in-digital-format-3 subtitel",
                                    name: "indigitalformat",
                                    placeholder: inputPlaceholder3,
                                    type: inputType3
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame136Default.default), {
                                    ouinonProps: frame1363Props.ouinonProps
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "emploi-relation-employeur-employ-3-4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggle2Props.className,
                                    buttonSecondaryProps: toggle2Props.buttonSecondaryProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                    className: "do-you-have-a-review-2 subtitel",
                                    name: "doyouhaveareviewspecifyingrequirementsnotformulatedbythecustomerbutnecessaryforthespecifieduse",
                                    placeholder: inputPlaceholder4,
                                    type: inputType4
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame136Default.default), {
                                    ouinonProps: frame1364Props.ouinonProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    className: "in-paper-format-4 subtitel",
                                    name: "inpaperformat",
                                    placeholder: inputPlaceholder5,
                                    type: inputType5
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame136Default.default), {
                                    ouinonProps: frame1365Props.ouinonProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    className: "in-digital-format-4 subtitel",
                                    name: "indigitalformat",
                                    placeholder: inputPlaceholder6,
                                    type: inputType6
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame136Default.default), {
                                    ouinonProps: frame1366Props.ouinonProps
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "emploi-relation-employeur-employ-2-13",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggle3Props.className,
                                    buttonSecondaryProps: toggle3Props.buttonSecondaryProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    className: "do-you-have-a-review-3 subtitel",
                                    name: "doyouhaveareviewspecifyingtherequirementsoftheorganisation",
                                    placeholder: inputPlaceholder7,
                                    type: inputType7
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame136Default.default), {
                                    ouinonProps: frame1367Props.ouinonProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    className: "in-paper-format-5 subtitel",
                                    name: "inpaperformat",
                                    placeholder: inputPlaceholder8,
                                    type: inputType8
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame144Default.default), {
                                    frame133Props: frame144Props.frame133Props
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    className: "in-digital-format-5 subtitel",
                                    name: "indigitalformat",
                                    placeholder: inputPlaceholder9,
                                    type: inputType9
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame136Default.default), {
                                    ouinonProps: frame1368Props.ouinonProps
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-153",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            className: toggle4Props.className,
                            buttonSecondaryProps: toggle4Props.buttonSecondaryProps
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "frame-113-69",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "go-on-to-the-next-step-1 valign-text-middle inter-bold-mineral-green-18px",
                                children: goOnToTheNextStep
                            })
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = ClientConsommateur3;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"b9X5n","../NavItems2":"bnQuI","../NavItems3":"fOarC","../Toggle":"dSqDu","../Frame136":"6Kf28","../Frame144":"3hDtN","./ClientConsommateur3.css":"8FxiL","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8FxiL":[function() {},{}],"5JrYP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _frame136 = require("../Frame136");
var _frame136Default = parcelHelpers.interopDefault(_frame136);
var _frame144 = require("../Frame144");
var _frame144Default = parcelHelpers.interopDefault(_frame144);
var _clientConsommateur3Css = require("./ClientConsommateur3_.css");
function ClientConsommateur3_(props) {
    const { x1200PxLogo_Icam__20081, pleaseAnswerTheFollowingQuestions, inputType1, inputPlaceholder1, inputType2, inputPlaceholder2, inputType3, inputPlaceholder3, inputType4, inputPlaceholder4, inputType5, inputPlaceholder5, inputType6, inputPlaceholder6, inputType7, inputPlaceholder7, inputType8, inputPlaceholder8, inputType9, inputPlaceholder9, goOnToTheNextStep, navItems2Props, navItems3Props, toggle1Props, frame1361Props, frame1362Props, frame1363Props, toggle2Props, frame1364Props, frame1365Props, frame1366Props, toggle3Props, frame1367Props, frame144Props, frame1368Props, toggle4Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "client-consommateur-3 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-86",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "rectangle-3-31"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {
                            className: navItems2Props.className
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                            className: navItems3Props.className,
                            frame1172Props: navItems3Props.frame1172Props,
                            frame1162Props: navItems3Props.frame1162Props,
                            frame1132Props: navItems3Props.frame1132Props
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-86",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "please-answer-the-following-questions-31 valign-text-middle bevan-normal-white-20px",
                            children: pleaseAnswerTheFollowingQuestions
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "emploirelation-employeur-employ-15",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "emploi-relation-employeur-employ-1-12",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggle1Props.className,
                                    buttonSecondaryProps: toggle1Props.buttonSecondaryProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    className: "do-you-do-reviews-1 subtitel",
                                    name: "doyoudoreviews",
                                    placeholder: inputPlaceholder1,
                                    type: inputType1
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame136Default.default), {
                                    ouinonProps: frame1361Props.ouinonProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    className: "in-paper-format-3 subtitel",
                                    name: "inpaperformat",
                                    placeholder: inputPlaceholder2,
                                    type: inputType2
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame136Default.default), {
                                    ouinonProps: frame1362Props.ouinonProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    className: "in-digital-format-3 subtitel",
                                    name: "indigitalformat",
                                    placeholder: inputPlaceholder3,
                                    type: inputType3
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame136Default.default), {
                                    ouinonProps: frame1363Props.ouinonProps
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "emploi-relation-employeur-employ-3-4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggle2Props.className,
                                    buttonSecondaryProps: toggle2Props.buttonSecondaryProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                    className: "do-you-have-a-review-2 subtitel",
                                    name: "doyouhaveareviewspecifyingrequirementsnotformulatedbythecustomerbutnecessaryforthespecifieduse",
                                    placeholder: inputPlaceholder4,
                                    type: inputType4
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame136Default.default), {
                                    ouinonProps: frame1364Props.ouinonProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    className: "in-paper-format-4 subtitel",
                                    name: "inpaperformat",
                                    placeholder: inputPlaceholder5,
                                    type: inputType5
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame136Default.default), {
                                    ouinonProps: frame1365Props.ouinonProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    className: "in-digital-format-4 subtitel",
                                    name: "indigitalformat",
                                    placeholder: inputPlaceholder6,
                                    type: inputType6
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame136Default.default), {
                                    ouinonProps: frame1366Props.ouinonProps
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "emploi-relation-employeur-employ-2-13",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggle3Props.className,
                                    buttonSecondaryProps: toggle3Props.buttonSecondaryProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    className: "do-you-have-a-review-3 subtitel",
                                    name: "doyouhaveareviewspecifyingtherequirementsoftheorganisation",
                                    placeholder: inputPlaceholder7,
                                    type: inputType7
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame136Default.default), {
                                    ouinonProps: frame1367Props.ouinonProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    className: "in-paper-format-5 subtitel",
                                    name: "inpaperformat",
                                    placeholder: inputPlaceholder8,
                                    type: inputType8
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame144Default.default), {
                                    frame133Props: frame144Props.frame133Props
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    className: "in-digital-format-5 subtitel",
                                    name: "indigitalformat",
                                    placeholder: inputPlaceholder9,
                                    type: inputType9
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame136Default.default), {
                                    ouinonProps: frame1368Props.ouinonProps
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-153",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            className: toggle4Props.className,
                            buttonSecondaryProps: toggle4Props.buttonSecondaryProps
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "frame-113-69",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "go-on-to-the-next-step-1 valign-text-middle inter-bold-mineral-green-18px",
                                children: goOnToTheNextStep
                            })
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = ClientConsommateur3_;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"b9X5n","../NavItems2":"bnQuI","../NavItems3":"fOarC","../Toggle":"dSqDu","../Frame136":"6Kf28","../Frame144":"3hDtN","./ClientConsommateur3_.css":"3UX8k","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3UX8k":[function() {},{}],"9DdZc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _frame11332 = require("../Frame11332");
var _frame11332Default = parcelHelpers.interopDefault(_frame11332);
var _frame114 = require("../Frame114");
var _frame114Default = parcelHelpers.interopDefault(_frame114);
var _frame115 = require("../Frame115");
var _frame115Default = parcelHelpers.interopDefault(_frame115);
var _frame117 = require("../Frame117");
var _frame117Default = parcelHelpers.interopDefault(_frame117);
var _frame1142 = require("../Frame1142");
var _frame1142Default = parcelHelpers.interopDefault(_frame1142);
var _frame11532 = require("../Frame11532");
var _frame11532Default = parcelHelpers.interopDefault(_frame11532);
var _frame11322 = require("../Frame11322");
var _frame11322Default = parcelHelpers.interopDefault(_frame11322);
var _referencesCss = require("./References.css");
var _environmental5 = require("../Environmental5");
var _social6 = require("../Social6");
var _modernization4 = require("../Modernization4");
function References(props) {
    const { resultsPropositions, label1, label2, x1200PxLogo_Icam__20081, inputType1, inputPlaceholder1, tracbility, place1, vector371, vector372, vector38, product, validation, iso9001Isf, vector373, processValidation, line211, cost, inputType2, inputPlaceholder2, line212, vector374, vector375, vector376, vector377, transportCost, manufacturingCost, deliveryCost, exportCost, modernisation, inputType3, inputPlaceholder3, line213, vector378, vector379, vector3710, vector3711, supplyChain40, informationSystem, ergonomics, newTechnologiesAiRoboticsEtc, leadTime, inputType4, inputPlaceholder4, line214, vector3712, vector3713, vector3714, manufacturingTime, deliveryTime, storageTime, place2, propositions, frame11332Props, frame117Props, frame1142Props, frame11322Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "references screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group9-4",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "overlap-group8-3",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "rectangle-2-2"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-2-55",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11332Default.default), {
                                            className: frame11332Props.className
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame114Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame115Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "frame-116-180",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "results-propositions valign-text-middle inter-medium-white-18px",
                                                children: resultsPropositions
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame117Default.default), {
                                            className: frame117Props.className
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-3-79",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1142Default.default), {
                                            className: frame1142Props.className
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11532Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                            to: "/existing-case",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "label-167 inter-medium-star-dust-18-1px",
                                                children: label1
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                            to: "/cur-performance",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "label-167 inter-medium-sonic-silver-18-1px",
                                                children: label2
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11322Default.default), {
                                            className: frame11322Props.className
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                    to: "/home",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        className: "x1200px-logo_icam_-_2008-1-87",
                                        src: x1200PxLogo_Icam__20081,
                                        alt: "1200px-Logo_ICAM_-_2008 1"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "frame-3-7"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "overlap-group4-18",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "rectangle-4359"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                            className: "x25-22 inter-bold-mineral-green-56px",
                                            htmlFor: "25",
                                            children: [
                                                (0, _environmental5.e_sum),
                                                "/35"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "tracbility valign-text-middle inter-medium-black-14px",
                                            children: tracbility
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                            className: "place-271 inter-bold-mineral-green-24px",
                                            children: place1
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "pricing-features",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "overlap-group-container-16",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "overlap-group1-52",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                className: "vector-3",
                                                                src: vector371,
                                                                alt: "Vector 37"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "overlap-group2-26",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                className: "vector-3",
                                                                src: vector372,
                                                                alt: "Vector 37"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "overlap-group3-24",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                className: "vector-3",
                                                                src: vector38,
                                                                alt: "Vector 38"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "flex-col-105 inter-medium-black-14px",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "product valign-text-middle",
                                                            children: product
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "validation valign-text-middle",
                                                            children: validation
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "iso-9001-isf valign-text-middle",
                                                            children: iso9001Isf
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "overlap-group-90",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                    className: "vector-37",
                                                                    src: vector373,
                                                                    alt: "Vector 37"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "process-validation valign-text-middle inter-medium-black-14px",
                                                                    children: processValidation
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "line-21-9",
                                            src: line211,
                                            alt: "Line 21"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "frame-6-14"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "overlap-group5-15",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "cost-3 inter-bold-rum-swizzle-24px",
                                    children: cost
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                    className: "x25-23 inter-bold-rum-swizzle-56px",
                                    htmlFor: "25",
                                    children: [
                                        (0, _social6.s_sum),
                                        "/38"
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    className: "line-21-10",
                                    src: line212,
                                    alt: "Line 21"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "pricing-features-1",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "overlap-group-container-17",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "overlap-group-87",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                        className: "vector-3",
                                                        src: vector374,
                                                        alt: "Vector 37"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "overlap-group-88",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                        className: "vector-3",
                                                        src: vector375,
                                                        alt: "Vector 37"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "overlap-group-87",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                        className: "vector-3",
                                                        src: vector376,
                                                        alt: "Vector 37"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "overlap-group-88",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                        className: "vector-3",
                                                        src: vector377,
                                                        alt: "Vector 37"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "cost-container inter-medium-rum-swizzle-14px",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "transport-cost valign-text-middle",
                                                    children: transportCost
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "manufacturing-cost valign-text-middle",
                                                    children: manufacturingCost
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "delivery-cost valign-text-middle",
                                                    children: deliveryCost
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "export-cost valign-text-middle",
                                                    children: exportCost
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "overlap-group6-7",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "modernisation inter-bold-rum-swizzle-24px",
                                    children: modernisation
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                    className: "x25-24 inter-bold-rum-swizzle-56px",
                                    htmlFor: "25",
                                    children: [
                                        (0, _modernization4.m_sum),
                                        "/26"
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    className: "line-21-11",
                                    src: line213,
                                    alt: "Line 21"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "pricing-features-2",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "overlap-group-container-18",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "overlap-group-87",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                        className: "vector-3",
                                                        src: vector378,
                                                        alt: "Vector 37"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "overlap-group-88",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                        className: "vector-3",
                                                        src: vector379,
                                                        alt: "Vector 37"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "overlap-group-87",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                        className: "vector-3",
                                                        src: vector3710,
                                                        alt: "Vector 37"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "overlap-group-88",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                        className: "vector-3",
                                                        src: vector3711,
                                                        alt: "Vector 37"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex-col-106 inter-medium-rum-swizzle-14px",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "supply-chain-40 valign-text-middle",
                                                    children: supplyChain40
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "flex-col-item valign-text-middle",
                                                    children: informationSystem
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "flex-col-item valign-text-middle",
                                                    children: ergonomics
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                    className: "new-technologies-ai-robotics-etc valign-text-middle",
                                                    children: newTechnologiesAiRoboticsEtc
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "overlap-group7-5",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "lead-time-4 inter-bold-mineral-green-24px",
                                    children: leadTime
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                    className: "x25-25 inter-bold-mineral-green-56px",
                                    name: "25",
                                    placeholder: inputPlaceholder4,
                                    type: inputType4
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    className: "line-21-12",
                                    src: line214,
                                    alt: "Line 21"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "pricing-features-3",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "overlap-group-container-19",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "overlap-group2-27",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                        className: "vector-3",
                                                        src: vector3712,
                                                        alt: "Vector 37"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "overlap-group-89",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                        className: "vector-3",
                                                        src: vector3713,
                                                        alt: "Vector 37"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "overlap-group-89",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                        className: "vector-3",
                                                        src: vector3714,
                                                        alt: "Vector 37"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "time-container inter-medium-black-14px",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "manufacturing-time valign-text-middle",
                                                    children: manufacturingTime
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "delivery-time valign-text-middle",
                                                    children: deliveryTime
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "storage-time valign-text-middle",
                                                    children: storageTime
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "frame-5-24",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "place-272 valign-text-middle inter-bold-tropical-rain-forest-18px",
                                    children: place2
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                    to: "/objectives",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "frame-2-30",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "propositions-1 valign-text-middle inter-bold-tropical-rain-forest-18px",
                            children: propositions
                        })
                    })
                })
            ]
        })
    });
}
exports.default = References;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"b9X5n","../Frame11332":"2UwVc","../Frame114":"aUtEd","../Frame115":"gPV9Y","../Frame117":"ijwBg","../Frame1142":"lCMhE","../Frame11532":"lTEBu","../Frame11322":"ju7Cp","./References.css":"9VFc9","../Environmental5":"leUWw","../Social6":"jqrFa","../Modernization4":"3hH0I","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lTEBu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame11532Css = require("./Frame11532.css");
var _reactRouterDom = require("react-router-dom");
function Frame11532() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
        to: "/acquisition",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "frame-115-96",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "new-case-1 valign-text-middle inter-medium-star-dust-18px",
                children: "New case"
            })
        })
    });
}
exports.default = Frame11532;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./Frame11532.css":"hZ8U1","react-router-dom":"b9X5n","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hZ8U1":[function() {},{}],"9VFc9":[function() {},{}],"276Lb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _frame11332 = require("../Frame11332");
var _frame11332Default = parcelHelpers.interopDefault(_frame11332);
var _frame114 = require("../Frame114");
var _frame114Default = parcelHelpers.interopDefault(_frame114);
var _frame115 = require("../Frame115");
var _frame115Default = parcelHelpers.interopDefault(_frame115);
var _frame117 = require("../Frame117");
var _frame117Default = parcelHelpers.interopDefault(_frame117);
var _curPerformanceCss = require("./CurPerformance.css");
var _enterpriseContext = require("../../context/EnterpriseContext");
var _html2Canvas = require("html2canvas");
var _html2CanvasDefault = parcelHelpers.interopDefault(_html2Canvas);
var _jspdf = require("jspdf");
var _jspdfDefault = parcelHelpers.interopDefault(_jspdf);
// Optimized metric card component with React.memo
const MetricCard = /*#__PURE__*/ (0, _reactDefault.default).memo(({ metricKey, label, score, maxScore = 20, isVisible })=>{
    const scoreValue = score !== undefined ? score : 'N/A';
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `metric-card ${isVisible ? 'slide-in-right' : ''} responsive-metric-card`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                className: "metric-title responsive-metric-title",
                children: label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "metric-value responsive-metric-value",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "score-value",
                        children: scoreValue
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                        className: "score-max",
                        children: [
                            "/",
                            maxScore
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "score-bar responsive-score-bar",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "score-fill",
                    style: {
                        width: isVisible ? `${score !== undefined ? score / maxScore * 100 : 0}%` : '0%'
                    }
                })
            })
        ]
    });
});
// Optimized enterprise information panel component
const EnterpriseInfoPanel = /*#__PURE__*/ (0, _reactDefault.default).memo(({ enterpriseInfo })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "enterprise-info-panel responsive-info-panel",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                className: "enterprise-info-title responsive-info-title",
                children: "Company Information"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "enterprise-info-content responsive-info-content",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "enterprise-info-item responsive-info-item",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "info-label",
                                children: "Name:"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "info-value",
                                children: enterpriseInfo.company_name || "N/A"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "enterprise-info-item responsive-info-item",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "info-label",
                                children: "Size:"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "info-value",
                                children: enterpriseInfo.company_size ? `${enterpriseInfo.company_size} employees` : "N/A"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "enterprise-info-item responsive-info-item",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "info-label",
                                children: "Business sector:"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "info-value",
                                children: enterpriseInfo.activity_sector || "N/A"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "enterprise-info-item responsive-info-item",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "info-label",
                                children: "Country:"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "info-value",
                                children: enterpriseInfo.country || "N/A"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "enterprise-info-item responsive-info-item",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "info-label",
                                children: "Assessment date:"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "info-value",
                                children: enterpriseInfo.date_created || enterpriseInfo.date_added || "N/A"
                            })
                        ]
                    })
                ]
            })
        ]
    });
});
// Main component
function CurPerformance(props) {
    const { x1200PxLogo_Icam__20081, resultPropositions, place, formalismesEnFonct, navItems3Props, frame11332Props, currentResults = {}, enterpriseData = {} } = props;
    // Hook to access enterprise context
    const { enterpriseId, updateScores } = (0, _enterpriseContext.useEnterprise)();
    // States
    const [animate, setAnimate] = (0, _react.useState)(false);
    const [metricsVisible, setMetricsVisible] = (0, _react.useState)({});
    const [scores, setScores] = (0, _react.useState)({});
    const [loading, setLoading] = (0, _react.useState)(true);
    const [error, setError] = (0, _react.useState)("");
    const [enterpriseInfo, setEnterpriseInfo] = (0, _react.useState)(enterpriseData);
    const [apiResults, setApiResults] = (0, _react.useState)(currentResults);
    // Maximum number of questions per category - memoized
    const maxQuestionsPerCategory = (0, _react.useMemo)(()=>({
            environmental: 25,
            social: 35,
            modernization: 27,
            leadTime: 15,
            cost: 18,
            quality: 35,
            clientConsumer: 18
        }), []);
    // Metrics names - memoized
    const metrics = (0, _react.useMemo)(()=>({
            environmental: "Environment",
            social: "Social",
            modernization: "Modernization",
            leadTime: "Lead Time",
            cost: "Cost",
            quality: "Quality",
            clientConsumer: "Client / Consumer"
        }), []);
    // Function to retrieve scores from API - optimized with useCallback
    const fetchScores = (0, _react.useCallback)(async ()=>{
        if (!enterpriseId) {
            console.error("Enterprise ID not available.");
            setError("Enterprise ID not available. Please complete the acquisition section.");
            setLoading(false);
            return;
        }
        try {
            setLoading(true);
            const controller = new AbortController();
            const signal = controller.signal;
            const apiUrl = `${"/api"}/api/enterprise-scores/${enterpriseId}`;
            const response = await fetch(apiUrl, {
                headers: {
                    "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
                },
                signal
            });
            if (!response.ok) throw new Error(`API Error (${response.status}): ${await response.text()}`);
            const data = await response.json();
            if (data.found === false) {
                console.warn("No case found for this company");
                setError("No case found for this company. Please complete the questionnaires first.");
                setLoading(false);
                return;
            }
            setApiResults(data);
            try {
                const enterpriseUrl = `${"/api"}/api/enterprise/${enterpriseId}`;
                const enterpriseResponse = await fetch(enterpriseUrl, {
                    headers: {
                        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
                    },
                    signal
                });
                if (enterpriseResponse.ok) {
                    const enterpriseData = await enterpriseResponse.json();
                    setEnterpriseInfo(enterpriseData.enterprise || {});
                    console.log("Enterprise data retrieved:", enterpriseData.enterprise);
                } else console.warn("Unable to retrieve enterprise information");
            } catch (err) {
                if (!signal.aborted) console.error("Error retrieving company data:", err);
            }
            setLoading(false);
            return ()=>controller.abort();
        } catch (err) {
            if (err.name !== "AbortError") {
                console.error("Error retrieving scores:", err);
                setError("Connection error. Please check your internet connection and try again.");
                setLoading(false);
            }
        }
    }, [
        enterpriseId
    ]);
    // Load scores when component mounts with cleanup
    (0, _react.useEffect)(()=>{
        const abortHandler = fetchScores();
        return ()=>{
            if (abortHandler && typeof abortHandler === 'function') abortHandler();
        };
    }, [
        fetchScores
    ]);
    // Data processing and calculation of scores out of 20
    (0, _react.useEffect)(()=>{
        if (apiResults && Object.keys(apiResults).length > 0) {
            const calculatedScores = {};
            Object.entries(apiResults).forEach(([category, value])=>{
                if (category in maxQuestionsPerCategory && typeof value === 'number') {
                    const maxQuestions = maxQuestionsPerCategory[category];
                    const scoreOn20 = value / maxQuestions * 20;
                    calculatedScores[category] = Math.round(scoreOn20 * 10) / 10;
                }
            });
            const scoresChanged = JSON.stringify(calculatedScores) !== JSON.stringify(scores);
            if (scoresChanged) {
                setScores(calculatedScores);
                if (typeof updateScores === 'function') updateScores(calculatedScores);
            }
        }
    }, [
        apiResults,
        maxQuestionsPerCategory,
        updateScores,
        scores
    ]);
    // Trigger animations on component mount
    (0, _react.useEffect)(()=>{
        setAnimate(true);
        const allVisible = Object.keys(metrics).every((key)=>metricsVisible[key]);
        if (!allVisible) Object.keys(metrics).forEach((key, index)=>{
            setTimeout(()=>{
                setMetricsVisible((prev)=>({
                        ...prev,
                        [key]: true
                    }));
            }, 300 + index * 100);
        });
    }, [
        metrics,
        metricsVisible
    ]);
    // Global score calculation - memoized
    const globalScore = (0, _react.useMemo)(()=>{
        if (Object.keys(scores).length === 0) return "N/A";
        const total = Object.values(scores).reduce((sum, score)=>sum + score, 0);
        return (total / Object.keys(scores).length).toFixed(1);
    }, [
        scores
    ]);
    // Optimized event handlers
    const handlePrint = (0, _react.useCallback)(()=>{
        window.print();
    }, []);
    const handleNavigateHome = (0, _react.useCallback)(()=>{
        window.location.href = '/home';
    }, []);
    const handleNavigateAnalysis = (0, _react.useCallback)(()=>{
        window.location.href = '/functional-view-1';
    }, []);
    const renderMetricsGrid = (0, _react.useCallback)(()=>{
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "metrics-grid responsive-metrics-grid",
            children: Object.entries(metrics).map(([key, label], index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(MetricCard, {
                    metricKey: key,
                    label: label,
                    score: scores[key],
                    isVisible: metricsVisible[key]
                }, `metric-${key}`))
        });
    }, [
        metrics,
        scores,
        metricsVisible
    ]);
    const handlePageToPDF = async ()=>{
        try {
            const element = document.getElementById("curPerformancePage");
            if (!element) {
                alert("\xe2\x9d\u0152 Unable to find the element to capture!");
                return;
            }
            const canvas = await (0, _html2CanvasDefault.default)(element, {
                scale: 2,
                useCORS: true,
                logging: false,
                backgroundColor: "#ffffff"
            });
            const imgData = canvas.toDataURL("image/png");
            const pdf = new (0, _jspdfDefault.default)("p", "mm", "a4");
            const imgWidth = 210;
            const pageHeight = 295;
            const imgHeight = canvas.height * imgWidth / canvas.width;
            let heightLeft = imgHeight;
            let position = 0;
            pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;
            while(heightLeft > 0){
                position -= pageHeight; // âœ… plus propre pour pagination
                pdf.addPage();
                pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
                heightLeft -= pageHeight;
            }
            const fileName = `performance_${enterpriseInfo?.company_name || "unknown"}_${new Date().toISOString().replace(/[:.]/g, "-")}.pdf`;
            const pdfBlob = pdf.output("blob");
            const formData = new FormData();
            formData.append("file", pdfBlob, fileName);
            const enterprise_id = enterpriseData?._id || enterpriseData?.enterpriseId || enterpriseInfo?._id || enterpriseInfo?.enterpriseId || enterpriseId || localStorage.getItem("enterpriseId");
            if (!enterprise_id) {
                alert("\xe2\x9d\u0152 No enterprise_id detected!");
                return;
            }
            formData.append("enterprise_id", enterprise_id);
            // âœ… Base URL unique (sans /api à  la fin)
            const API_BASE = "/api";
            const endpoint = `${API_BASE}/api/save-performance-pdf`; // âœ… /api ici une seule fois
            console.log("Uploading PDF to:", endpoint, "enterprise_id:", enterprise_id);
            const token = localStorage.getItem("token");
            const response = await fetch(endpoint, {
                method: "POST",
                headers: {
                    ...token ? {
                        Authorization: `Bearer ${token}`
                    } : {}
                },
                body: formData
            });
            // âœ… lecture robuste (JSON ou texte)
            const raw = await response.text();
            let data = null;
            try {
                data = raw ? JSON.parse(raw) : null;
            } catch  {
                data = null;
            }
            if (!response.ok) {
                console.error("API Error:", {
                    status: response.status,
                    statusText: response.statusText,
                    url: response.url,
                    body: data ?? raw
                });
                const msg = data && (data.detail || data.message) || (typeof raw === "string" ? raw.slice(0, 300) : "Unknown error");
                alert(`\xe2\x9d\u{152} Error during save: ${msg}`);
                return;
            }
            const file_id = data?.file_id || data?.id;
            alert(`\xe2\u{153}\u{2026} PDF saved successfully! ID: ${file_id || "OK"}`);
            // téléchargement local
            const fileUrl = URL.createObjectURL(pdfBlob);
            const downloadLink = document.createElement("a");
            downloadLink.href = fileUrl;
            downloadLink.download = fileName;
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
            URL.revokeObjectURL(fileUrl);
            setTimeout(()=>{
                window.location.href = "/functional-view-1";
            }, 1200);
        } catch (err) {
            console.error("Error generating PDF:", err);
            alert("\xe2\x9d\u0152 An error occurred during PDF generation. Check console for details.");
        }
    };
    const handlePageToPDF2 = async ()=>{
        try {
            const element = document.getElementById("curPerformancePage");
            if (!element) {
                alert("\xe2\x9d\u0152 Unable to find the element to capture!");
                return;
            }
            const canvas = await (0, _html2CanvasDefault.default)(element, {
                scale: 2,
                useCORS: true,
                logging: false
            });
            const imgData = canvas.toDataURL("image/png");
            const pdf = new (0, _jspdfDefault.default)("p", "mm", "a4");
            const imgWidth = 210;
            const pageHeight = 295;
            const imgHeight = canvas.height * imgWidth / canvas.width;
            let heightLeft = imgHeight;
            let position = 0;
            pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;
            while(heightLeft > 0){
                position = heightLeft - imgHeight;
                pdf.addPage();
                pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
                heightLeft -= pageHeight;
            }
            const fileName = `performance_${enterpriseData?.company_name || "unknown"}_${new Date().toISOString().replace(/[:.]/g, "-")}.pdf`;
            const pdfBlob = pdf.output("blob");
            const formData = new FormData();
            formData.append("file", pdfBlob, fileName);
            const enterprise_id = enterpriseData?._id || enterpriseData?.enterpriseId || enterpriseInfo?._id || enterpriseInfo?.enterpriseId || enterpriseId || localStorage.getItem("enterpriseId");
            if (!enterprise_id) {
                alert("\xe2\x9d\u0152 No enterprise_id detected!");
                return;
            }
            formData.append("enterprise_id", enterprise_id);
            console.log("Sending PDF for enterprise_id =", enterprise_id);
            const API_URL = "/api";
            const response = await fetch(`${API_URL}/api/save-performance-pdf`, {
                method: "POST",
                body: formData
            });
            const result = await response.json();
            if (!response.ok) {
                console.error("API Error:", result);
                alert(`\xe2\x9d\u{152} Error during save: ${result.detail || result.message}`);
                return;
            }
            const file_id = result.file_id;
            alert(`\xe2\u{153}\u{2026} PDF saved successfully! ID: ${file_id}`);
            const fileUrl = URL.createObjectURL(pdfBlob);
            const downloadLink = document.createElement("a");
            downloadLink.href = fileUrl;
            downloadLink.download = fileName;
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
            URL.revokeObjectURL(fileUrl);
            setTimeout(()=>{
                window.location.href = "/pdf-uploader";
            }, 1200);
        } catch (err) {
            console.error("Error generating PDF:", err);
            alert("\xe2\x9d\u0152 An error occurred during PDF generation. Check console for details.");
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal responsive-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "cur-performance-10 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-91 responsive-header",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-88 responsive-logo",
                                src: x1200PxLogo_Icam__20081,
                                alt: "ICAM Logo",
                                loading: "lazy"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "nav-items-container-52 responsive-nav",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                                    className: navItems3Props.className,
                                    frame1172Props: navItems3Props.frame1172Props,
                                    frame1162Props: navItems3Props.frame1162Props,
                                    frame1132Props: navItems3Props.frame1132Props
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-2-56 responsive-nav-items",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11332Default.default), {
                                            className: frame11332Props.className
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame114Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame115Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "frame-116-181",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "result-propositions valign-text-middle inter-medium-white-18px",
                                                children: resultPropositions
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame117Default.default), {})
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-154 responsive-breadcrumb",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/functional-view-1",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "frame-5-25",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "place-273 valign-text-middle inter-bold-tropical-rain-forest-18px",
                                    children: place
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "formalismes-en-fonct-1 valign-text-middle bevan-normal-white-20px responsive-title",
                            children: formalismesEnFonct
                        })
                    ]
                }),
                loading ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "loading-container responsive-section",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "loading-spinner"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "loading-text",
                            children: "Loading data..."
                        })
                    ]
                }) : error ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "error-container responsive-section",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "error-message",
                            children: error
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            className: "retry-button",
                            onClick: fetchScores,
                            children: "Try again"
                        })
                    ]
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    id: "curPerformancePage",
                    className: `results-container ${animate ? 'fade-in' : ''} responsive-results`,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                            className: "results-title responsive-heading",
                            children: "Assessment Results"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(EnterpriseInfoPanel, {
                            enterpriseInfo: enterpriseInfo
                        }),
                        renderMetricsGrid(),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: `global-score always-visible ${animate ? 'bounce-effect' : ''} responsive-global-score`,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "global-score-container",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "global-score-circle",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "circle-content",
                                            children: globalScore
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "global-score-details",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "global-score-label",
                                                children: "Global Score"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "global-score-description",
                                                children: "Overall performance across all categories"
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "actions-container responsive-actions",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "actions-row",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                        onClick: handleNavigateHome,
                                        className: "action-button back-button responsive-button",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "button-icon",
                                                children: "\xe2\u2020\x90"
                                            }),
                                            " Back"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                        onClick: handlePageToPDF,
                                        className: "action-button analysis-button functional-view-button responsive-button",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "button-icon"
                                            }),
                                            " Modeling"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                        onClick: handlePrint,
                                        className: "action-button print-button responsive-button",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "button-icon"
                                            }),
                                            " Print"
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = /*#__PURE__*/ (0, _reactDefault.default).memo(CurPerformance);

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"b9X5n","../NavItems3":"fOarC","../Frame11332":"2UwVc","../Frame114":"aUtEd","../Frame115":"gPV9Y","../Frame117":"ijwBg","./CurPerformance.css":"cbf5D","../../context/EnterpriseContext":"jRUQi","html2canvas":"3eyQ5","jspdf":"hkJ4Q","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cbf5D":[function() {},{}],"dfVjL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _frame11332 = require("../Frame11332");
var _frame11332Default = parcelHelpers.interopDefault(_frame11332);
var _frame114 = require("../Frame114");
var _frame114Default = parcelHelpers.interopDefault(_frame114);
var _frame115 = require("../Frame115");
var _frame115Default = parcelHelpers.interopDefault(_frame115);
var _frame117 = require("../Frame117");
var _frame117Default = parcelHelpers.interopDefault(_frame117);
var _curperformanceCss = require("./Curperformance_.css");
var _enterpriseContext = require("../../context/EnterpriseContext");
var _html2Canvas = require("html2canvas");
var _html2CanvasDefault = parcelHelpers.interopDefault(_html2Canvas);
var _jspdf = require("jspdf");
var _jspdfDefault = parcelHelpers.interopDefault(_jspdf);
// Optimized metric card component with React.memo
const MetricCard = /*#__PURE__*/ (0, _reactDefault.default).memo(({ metricKey, label, score, maxScore = 20, isVisible })=>{
    const scoreValue = score !== undefined ? score : 'N/A';
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `metric-card ${isVisible ? 'slide-in-right' : ''} responsive-metric-card`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                className: "metric-title responsive-metric-title",
                children: label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "metric-value responsive-metric-value",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "score-value",
                        children: scoreValue
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                        className: "score-max",
                        children: [
                            "/",
                            maxScore
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "score-bar responsive-score-bar",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "score-fill",
                    style: {
                        width: isVisible ? `${score !== undefined ? score / maxScore * 100 : 0}%` : '0%'
                    }
                })
            })
        ]
    });
});
// Optimized enterprise information panel component
const EnterpriseInfoPanel = /*#__PURE__*/ (0, _reactDefault.default).memo(({ enterpriseInfo })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "enterprise-info-panel responsive-info-panel",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                className: "enterprise-info-title responsive-info-title",
                children: "Company Information"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "enterprise-info-content responsive-info-content",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "enterprise-info-item responsive-info-item",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "info-label",
                                children: "Name:"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "info-value",
                                children: enterpriseInfo.company_name || "N/A"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "enterprise-info-item responsive-info-item",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "info-label",
                                children: "Size:"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "info-value",
                                children: enterpriseInfo.company_size ? `${enterpriseInfo.company_size} employees` : "N/A"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "enterprise-info-item responsive-info-item",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "info-label",
                                children: "Business sector:"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "info-value",
                                children: enterpriseInfo.activity_sector || "N/A"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "enterprise-info-item responsive-info-item",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "info-label",
                                children: "Country:"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "info-value",
                                children: enterpriseInfo.country || "N/A"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "enterprise-info-item responsive-info-item",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "info-label",
                                children: "Assessment date:"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "info-value",
                                children: enterpriseInfo.date_created || enterpriseInfo.date_added || "N/A"
                            })
                        ]
                    })
                ]
            })
        ]
    });
});
// Main component
function CurPerformance_(props) {
    const { x1200PxLogo_Icam__20081, resultPropositions, place, formalismesEnFonct, navItems3Props, frame11332Props, currentResults = {}, enterpriseData = {} } = props;
    // Hook to access enterprise context
    const { enterpriseId, updateScores } = (0, _enterpriseContext.useEnterprise)();
    // States
    const [animate, setAnimate] = (0, _react.useState)(false);
    const [metricsVisible, setMetricsVisible] = (0, _react.useState)({});
    const [scores, setScores] = (0, _react.useState)({});
    const [loading, setLoading] = (0, _react.useState)(true);
    const [error, setError] = (0, _react.useState)("");
    const [enterpriseInfo, setEnterpriseInfo] = (0, _react.useState)(enterpriseData);
    const [apiResults, setApiResults] = (0, _react.useState)(currentResults);
    // Maximum number of questions per category - memoized
    const maxQuestionsPerCategory = (0, _react.useMemo)(()=>({
            environmental: 25,
            social: 35,
            modernization: 27,
            leadTime: 15,
            cost: 18,
            quality: 35,
            clientConsumer: 18
        }), []);
    // Metrics names - memoized
    const metrics = (0, _react.useMemo)(()=>({
            environmental: "Environment",
            social: "Social",
            modernization: "Modernization",
            leadTime: "Lead Time",
            cost: "Cost",
            quality: "Quality",
            clientConsumer: "Client / Consumer"
        }), []);
    // Function to retrieve scores from API - optimized with useCallback
    const fetchScores = (0, _react.useCallback)(async ()=>{
        if (!enterpriseId) {
            console.error("Enterprise ID not available.");
            setError("Enterprise ID not available. Please complete the acquisition section.");
            setLoading(false);
            return;
        }
        try {
            setLoading(true);
            const controller = new AbortController();
            const signal = controller.signal;
            const apiUrl = `${"/api"}/api/enterprise-scores/${enterpriseId}`;
            const response = await fetch(apiUrl, {
                headers: {
                    "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
                },
                signal
            });
            if (!response.ok) throw new Error(`API Error (${response.status}): ${await response.text()}`);
            const data = await response.json();
            if (data.found === false) {
                console.warn("No case found for this company");
                setError("No case found for this company. Please complete the questionnaires first.");
                setLoading(false);
                return;
            }
            setApiResults(data);
            try {
                const enterpriseUrl = `${"/api"}/api/enterprise/${enterpriseId}`;
                const enterpriseResponse = await fetch(enterpriseUrl, {
                    headers: {
                        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
                    },
                    signal
                });
                if (enterpriseResponse.ok) {
                    const enterpriseData = await enterpriseResponse.json();
                    setEnterpriseInfo(enterpriseData.enterprise || {});
                    console.log("Enterprise data retrieved:", enterpriseData.enterprise);
                } else console.warn("Unable to retrieve enterprise information");
            } catch (err) {
                if (!signal.aborted) console.error("Error retrieving company data:", err);
            }
            setLoading(false);
            return ()=>controller.abort();
        } catch (err) {
            if (err.name !== "AbortError") {
                console.error("Error retrieving scores:", err);
                setError("Connection error. Please check your internet connection and try again.");
                setLoading(false);
            }
        }
    }, [
        enterpriseId
    ]);
    // Load scores when component mounts with cleanup
    (0, _react.useEffect)(()=>{
        const abortHandler = fetchScores();
        return ()=>{
            if (abortHandler && typeof abortHandler === 'function') abortHandler();
        };
    }, [
        fetchScores
    ]);
    // Data processing and calculation of scores out of 20
    (0, _react.useEffect)(()=>{
        if (apiResults && Object.keys(apiResults).length > 0) {
            const calculatedScores = {};
            Object.entries(apiResults).forEach(([category, value])=>{
                if (category in maxQuestionsPerCategory && typeof value === 'number') {
                    const maxQuestions = maxQuestionsPerCategory[category];
                    const scoreOn20 = value / maxQuestions * 20;
                    calculatedScores[category] = Math.round(scoreOn20 * 10) / 10;
                }
            });
            const scoresChanged = JSON.stringify(calculatedScores) !== JSON.stringify(scores);
            if (scoresChanged) {
                setScores(calculatedScores);
                if (typeof updateScores === 'function') updateScores(calculatedScores);
            }
        }
    }, [
        apiResults,
        maxQuestionsPerCategory,
        updateScores,
        scores
    ]);
    // Trigger animations on component mount
    (0, _react.useEffect)(()=>{
        setAnimate(true);
        const allVisible = Object.keys(metrics).every((key)=>metricsVisible[key]);
        if (!allVisible) Object.keys(metrics).forEach((key, index)=>{
            setTimeout(()=>{
                setMetricsVisible((prev)=>({
                        ...prev,
                        [key]: true
                    }));
            }, 300 + index * 100);
        });
    }, [
        metrics,
        metricsVisible
    ]);
    // Global score calculation - memoized
    const globalScore = (0, _react.useMemo)(()=>{
        if (Object.keys(scores).length === 0) return "N/A";
        const total = Object.values(scores).reduce((sum, score)=>sum + score, 0);
        return (total / Object.keys(scores).length).toFixed(1);
    }, [
        scores
    ]);
    // Optimized event handlers
    const handlePrint = (0, _react.useCallback)(()=>{
        window.print();
    }, []);
    const handleNavigateHome = (0, _react.useCallback)(()=>{
        window.location.href = '/home';
    }, []);
    const handleNavigateAnalysis = (0, _react.useCallback)(()=>{
        window.location.href = '/functional-view-1';
    }, []);
    const renderMetricsGrid = (0, _react.useCallback)(()=>{
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "metrics-grid responsive-metrics-grid",
            children: Object.entries(metrics).map(([key, label], index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(MetricCard, {
                    metricKey: key,
                    label: label,
                    score: scores[key],
                    isVisible: metricsVisible[key]
                }, `metric-${key}`))
        });
    }, [
        metrics,
        scores,
        metricsVisible
    ]);
    const handlePageToPDF = async ()=>{
        try {
            const element = document.getElementById("curPerformancePage");
            if (!element) {
                alert("\xe2\x9d\u0152 Unable to find the element to capture!");
                return;
            }
            const canvas = await (0, _html2CanvasDefault.default)(element, {
                scale: 2,
                useCORS: true,
                logging: false
            });
            const imgData = canvas.toDataURL("image/png");
            const pdf = new (0, _jspdfDefault.default)("p", "mm", "a4");
            const imgWidth = 210;
            const pageHeight = 295;
            const imgHeight = canvas.height * imgWidth / canvas.width;
            let heightLeft = imgHeight;
            let position = 0;
            pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;
            while(heightLeft > 0){
                position = heightLeft - imgHeight;
                pdf.addPage();
                pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
                heightLeft -= pageHeight;
            }
            const fileName = `performance_${enterpriseData?.company_name || "unknown"}_${new Date().toISOString().replace(/[:.]/g, "-")}.pdf`;
            const pdfBlob = pdf.output("blob");
            const formData = new FormData();
            formData.append("file", pdfBlob, fileName);
            const enterprise_id = enterpriseData?._id || enterpriseData?.enterpriseId || enterpriseInfo?._id || enterpriseInfo?.enterpriseId || enterpriseId || localStorage.getItem("enterpriseId");
            if (!enterprise_id) {
                alert("\xe2\x9d\u0152 No enterprise_id detected!");
                return;
            }
            formData.append("enterprise_id", enterprise_id);
            console.log("Sending PDF for enterprise_id =", enterprise_id);
            const API_URL = "/api";
            const response = await fetch(`${API_URL}/api/save-performance-pdf`, {
                method: "POST",
                body: formData
            });
            const result = await response.json();
            if (!response.ok) {
                console.error("API Error:", result);
                alert(`\xe2\x9d\u{152} Error during save: ${result.detail || result.message}`);
                return;
            }
            const file_id = result.file_id;
            alert(`\xe2\u{153}\u{2026} PDF saved successfully! ID: ${file_id}`);
            const fileUrl = URL.createObjectURL(pdfBlob);
            const downloadLink = document.createElement("a");
            downloadLink.href = fileUrl;
            downloadLink.download = fileName;
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
            URL.revokeObjectURL(fileUrl);
            setTimeout(()=>{
                window.location.href = "/functional-view-1";
            }, 1200);
        } catch (err) {
            console.error("Error generating PDF:", err);
            alert("\xe2\x9d\u0152 An error occurred during PDF generation. Check console for details.");
        }
    };
    const handlePageToPDF2 = async ()=>{
        try {
            const element = document.getElementById("curPerformancePage");
            if (!element) {
                alert("\xe2\x9d\u0152 Unable to find the element to capture!");
                return;
            }
            const canvas = await (0, _html2CanvasDefault.default)(element, {
                scale: 2,
                useCORS: true,
                logging: false
            });
            const imgData = canvas.toDataURL("image/png");
            const pdf = new (0, _jspdfDefault.default)("p", "mm", "a4");
            const imgWidth = 210;
            const pageHeight = 295;
            const imgHeight = canvas.height * imgWidth / canvas.width;
            let heightLeft = imgHeight;
            let position = 0;
            pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;
            while(heightLeft > 0){
                position = heightLeft - imgHeight;
                pdf.addPage();
                pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
                heightLeft -= pageHeight;
            }
            const fileName = `performance_${enterpriseData?.company_name || "unknown"}_${new Date().toISOString().replace(/[:.]/g, "-")}.pdf`;
            const pdfBlob = pdf.output("blob");
            const formData = new FormData();
            formData.append("file", pdfBlob, fileName);
            const enterprise_id = enterpriseData?._id || enterpriseData?.enterpriseId || enterpriseInfo?._id || enterpriseInfo?.enterpriseId || enterpriseId || localStorage.getItem("enterpriseId");
            if (!enterprise_id) {
                alert("\xe2\x9d\u0152 No enterprise_id detected!");
                return;
            }
            formData.append("enterprise_id", enterprise_id);
            console.log("Sending PDF for enterprise_id =", enterprise_id);
            // ===========================================
            // ðŸ”¥ AUTO-SELECTION DU BACKEND (local â†’ prod)
            // ===========================================
            const API_URL = "/api";
            console.log("Using backend:", API_URL);
            const response = await fetch(`${API_URL}/api/save-performance-pdf`, {
                method: "POST",
                body: formData
            });
            const result = await response.json();
            if (!response.ok) {
                console.error("API Error:", result);
                alert(`\xe2\x9d\u{152} Error during save: ${result.detail || result.message}`);
                return;
            }
            const file_id = result.file_id;
            alert(`\xe2\u{153}\u{2026} PDF saved successfully! ID: ${file_id}`);
            // Téléchargement local du PDF
            const fileUrl = URL.createObjectURL(pdfBlob);
            const downloadLink = document.createElement("a");
            downloadLink.href = fileUrl;
            downloadLink.download = fileName;
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
            URL.revokeObjectURL(fileUrl);
            setTimeout(()=>{
                window.location.href = "/implementation";
            }, 1200);
        } catch (err) {
            console.error("Error generating PDF:", err);
            alert("\xe2\x9d\u0152 An error occurred during PDF generation. Check console for details.");
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal responsive-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "cur-performance-10 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-91 responsive-header",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-88 responsive-logo",
                                src: x1200PxLogo_Icam__20081,
                                alt: "ICAM Logo",
                                loading: "lazy"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "nav-items-container-52 responsive-nav",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                                    className: navItems3Props.className,
                                    frame1172Props: navItems3Props.frame1172Props,
                                    frame1162Props: navItems3Props.frame1162Props,
                                    frame1132Props: navItems3Props.frame1132Props
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-2-56 responsive-nav-items",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11332Default.default), {
                                            className: frame11332Props.className
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame114Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame115Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "frame-116-181",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "result-propositions valign-text-middle inter-medium-white-18px",
                                                children: resultPropositions
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame117Default.default), {})
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-154 responsive-breadcrumb",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/functional-view-1",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "frame-5-25",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "place-273 valign-text-middle inter-bold-tropical-rain-forest-18px",
                                    children: place
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "formalismes-en-fonct-1 valign-text-middle bevan-normal-white-20px responsive-title",
                            children: formalismesEnFonct
                        })
                    ]
                }),
                loading ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "loading-container responsive-section",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "loading-spinner"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "loading-text",
                            children: "Loading data..."
                        })
                    ]
                }) : error ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "error-container responsive-section",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "error-message",
                            children: error
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            className: "retry-button",
                            onClick: fetchScores,
                            children: "Try again"
                        })
                    ]
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    id: "curPerformancePage",
                    className: `results-container ${animate ? 'fade-in' : ''} responsive-results`,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                            className: "results-title responsive-heading",
                            children: "Assessment Results"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(EnterpriseInfoPanel, {
                            enterpriseInfo: enterpriseInfo
                        }),
                        renderMetricsGrid(),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: `global-score always-visible ${animate ? 'bounce-effect' : ''} responsive-global-score`,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "global-score-container",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "global-score-circle",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "circle-content",
                                            children: globalScore
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "global-score-details",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "global-score-label",
                                                children: "Global Score"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "global-score-description",
                                                children: "Overall performance across all categories"
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "actions-container responsive-actions",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "actions-row",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                        onClick: handleNavigateHome,
                                        className: "action-button back-button responsive-button",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "button-icon",
                                                children: "\xe2\u2020\x90"
                                            }),
                                            " Back"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                        onClick: handlePageToPDF2,
                                        className: "action-button analysis-button functional-view-button responsive-button",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "button-icon"
                                            }),
                                            " Save"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                        onClick: handlePrint,
                                        className: "action-button print-button responsive-button",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "button-icon"
                                            }),
                                            " Print"
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = /*#__PURE__*/ (0, _reactDefault.default).memo(CurPerformance_);

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"b9X5n","../NavItems3":"fOarC","../Frame11332":"2UwVc","../Frame114":"aUtEd","../Frame115":"gPV9Y","../Frame117":"ijwBg","./Curperformance_.css":"1NYtK","../../context/EnterpriseContext":"jRUQi","html2canvas":"3eyQ5","jspdf":"hkJ4Q","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1NYtK":[function() {},{}],"cCIyL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _leadTimeCss = require("./LeadTime.css");
var _styleguideCss = require("../../styleguide.css");
function LeadTime(props) {
    const { x1200PxLogo_Icam__20081, headerMenuDefault61Props, headerMenuDefault51Props, headerMenuDefault52Props, headerMenuDefaultProps, headerMenuDefault53Props, headerMenuDefault54Props, headerMenuDefault62Props } = props;
    const [selectedOptions, setSelectedOptions] = (0, _reactDefault.default).useState({});
    const [l_yesCount, setL_yesCount] = (0, _reactDefault.default).useState(0);
    function clicked(question, option) {
        // Si l'option cliquée est la même que celle déjà sélectionnée, on la désélectionne
        if (selectedOptions[question] === option) {
            setSelectedOptions((prevSelectedOptions)=>{
                const newOptions = {
                    ...prevSelectedOptions
                };
                delete newOptions[question];
                return newOptions;
            });
            // Si on désélectionne un "Yes", on décrémente le score
            if (option === "Yes") setL_yesCount((prevCount)=>prevCount - 1);
            return;
        }
        // Sinon, on met à jour la sélection
        const previousOption = selectedOptions[question];
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        // Si on passe de "No" à "Yes", on incrémente le score
        if (option === "Yes" && previousOption !== "Yes") setL_yesCount((prevCount)=>prevCount + 1);
        else if (option === "No" && previousOption === "Yes") setL_yesCount((prevCount)=>prevCount - 1);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "environmental-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "environmental-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    className: "environmental-title",
                    children: "LEAD TIME ASSESSMENT"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "lead-time-description",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: "This section will assess your company's lead time management practices. Please proceed to answer questions in the following subsections:"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "lead-time-sections",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Link), {
                                    to: "/lead-time-1",
                                    className: "section-button",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                            className: "icon",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "16",
                                            height: "16",
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            stroke: "currentColor",
                                            strokeWidth: "2",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                    d: "M12 2L2 7l10 5 10-5-10-5z"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                    d: "M2 17l10 5 10-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                    d: "M2 12l10 5 10-5"
                                                })
                                            ]
                                        }),
                                        "Lead Time Part 1"
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Link), {
                                    to: "/lead-time-2",
                                    className: "section-button",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                            className: "icon",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "16",
                                            height: "16",
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            stroke: "currentColor",
                                            strokeWidth: "2",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                    d: "M12 2L2 7l10 5 10-5-10-5z"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                    d: "M2 17l10 5 10-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                    d: "M2 12l10 5 10-5"
                                                })
                                            ]
                                        }),
                                        "Lead Time Part 2"
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("nav", {
                    className: "secondary-nav",
                    "aria-label": "Secondary Navigation",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("ul", {
                        className: "nav-menu",
                        role: "menubar",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                className: "nav-item",
                                role: "none",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Link), {
                                    to: "/acquisition",
                                    className: "nav-link",
                                    role: "menuitem",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                            className: "nav-icon",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "16",
                                            height: "16",
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            stroke: "currentColor",
                                            strokeWidth: "2",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                    d: "M3 3v18h18"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                    d: "M18.4 9l-6-6-3 6-3 3 3 9h9"
                                                })
                                            ]
                                        }),
                                        "Acquisition"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                className: "nav-item",
                                role: "none",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Link), {
                                    to: "/acquisition",
                                    className: "nav-link",
                                    role: "menuitem",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                            className: "nav-icon",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "16",
                                            height: "16",
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            stroke: "currentColor",
                                            strokeWidth: "2",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
                                            })
                                        }),
                                        headerMenuDefault53Props?.children || "Environmental"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                className: "nav-item",
                                role: "none",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Link), {
                                    to: "/acquisition",
                                    className: "nav-link",
                                    role: "menuitem",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                            className: "nav-icon",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "16",
                                            height: "16",
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            stroke: "currentColor",
                                            strokeWidth: "2",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                    d: "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                                    cx: "9",
                                                    cy: "7",
                                                    r: "4"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                    d: "M23 21v-2a4 4 0 0 0-3-3.87"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                    d: "M16 3.13a4 4 0 0 1 0 7.75"
                                                })
                                            ]
                                        }),
                                        headerMenuDefault54Props?.children || "Social"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                className: "nav-item active",
                                role: "none",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Link), {
                                    to: "/acquisition",
                                    className: "nav-link",
                                    role: "menuitem",
                                    "aria-current": "page",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                            className: "nav-icon",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "16",
                                            height: "16",
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            stroke: "currentColor",
                                            strokeWidth: "2",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                                    cx: "12",
                                                    cy: "12",
                                                    r: "10"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                                                    points: "12 6 12 12 16 14"
                                                })
                                            ]
                                        }),
                                        headerMenuDefault62Props?.children || "Lead Time"
                                    ]
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "form-actions",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Link), {
                            to: "/home",
                            className: "btn-secondary",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                    className: "btn-icon",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "16",
                                    height: "16",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    strokeWidth: "2",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                            d: "M19 12H5"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                            d: "M12 19l-7-7 7-7"
                                        })
                                    ]
                                }),
                                "Back"
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Link), {
                            to: "/lead-time-1",
                            className: "btn-primary",
                            children: [
                                "Start Lead Time Assessment",
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                    className: "btn-icon",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "16",
                                    height: "16",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    strokeWidth: "2",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                            d: "M5 12h14"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                            d: "m12 5 7 7-7 7"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = LeadTime;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"b9X5n","./LeadTime.css":"9tAvD","../../styleguide.css":"8Y7Ec","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9tAvD":[function() {},{}],"8Y7Ec":[function() {},{}],"2lryw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _costCss = require("./Cost.css");
var _styleguideCss = require("../../styleguide.css");
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
function Cost(props) {
    const { x1200PxLogo_Icam__20081, pleaseAnswerTheFollowingQuestions, toggle1Props, toggle2Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "environmental-container",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("app-header", {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "environmental-content",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                        className: "environmental-title",
                        children: pleaseAnswerTheFollowingQuestions || "COST ASSESSMENT"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "section-description",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: "This assessment will evaluate your organization's cost management practices across several key areas. The assessment is divided into two sections to thoroughly evaluate your cost management approach. Please respond to all questions to receive a comprehensive evaluation."
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "assessment-options",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Link), {
                                to: "/cost-1",
                                className: "assessment-button",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "button-title",
                                        children: "Section 1"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "button-description",
                                        children: "Raw Materials and Stock Management"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Link), {
                                to: "/cost-2",
                                className: "assessment-button",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "button-title",
                                        children: "Section 2"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "button-description",
                                        children: "Market Analysis and Competition"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "form-actions",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                to: "/home",
                                className: "btn-secondary",
                                children: "Back to Home"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                to: "/cost-1",
                                className: "btn-primary",
                                children: "Start Assessment"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "toggle-wrapper",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                className: toggle1Props.className,
                                buttonSecondaryProps: toggle1Props.buttonSecondaryProps
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                className: toggle2Props.className,
                                buttonSecondaryProps: toggle2Props.buttonSecondaryProps
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
exports.default = Cost;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"b9X5n","./Cost.css":"5n2iw","../../styleguide.css":"8Y7Ec","../Toggle":"dSqDu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5n2iw":[function() {},{}],"8Y7Ec":[function() {},{}],"6Mffp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "m_allData", ()=>m_allData);
parcelHelpers.export(exports, "m_yesCount", ()=>m_yesCount);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _avatars = require("../Avatars");
var _avatarsDefault = parcelHelpers.interopDefault(_avatars);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _headerMenuDefault6 = require("../HeaderMenuDefault6");
var _headerMenuDefault6Default = parcelHelpers.interopDefault(_headerMenuDefault6);
var _headerMenuDefault5 = require("../HeaderMenuDefault5");
var _headerMenuDefault5Default = parcelHelpers.interopDefault(_headerMenuDefault5);
var _headerMenuDefault = require("../HeaderMenuDefault");
var _headerMenuDefaultDefault = parcelHelpers.interopDefault(_headerMenuDefault);
var _headerMenuDefault7 = require("../HeaderMenuDefault7");
var _headerMenuDefault7Default = parcelHelpers.interopDefault(_headerMenuDefault7);
var _group102 = require("../Group102");
var _group102Default = parcelHelpers.interopDefault(_group102);
var _modernizationCss = require("./Modernization.css");
var _styleguideCss = require("../../styleguide.css");
let m_allData = [];
let m_yesCount = 0;
function Modernization(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [yesCount, setYesCount] = (0, _react.useState)(0);
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const { x1200PxLogo_Icam__20081, admin, pleaseAnswerTheFollowingQuestions, label1, label2, inputType1, inputPlaceholder1, inputType2, inputPlaceholder2, inputType3, inputPlaceholder3, inputType4, inputPlaceholder4, inputType5, inputPlaceholder5, inputType6, inputPlaceholder6, inputType7, inputPlaceholder7, inputType8, inputPlaceholder8, inputType9, inputPlaceholder9, inputType10, inputPlaceholder10, avatarsProps, toggle1Props, headerMenuDefault61Props, headerMenuDefault51Props, headerMenuDefault52Props, headerMenuDefaultProps, headerMenuDefault53Props, headerMenuDefault54Props, headerMenuDefault62Props, toggle2Props, group1021Props, group1022Props, group1023Props, group1024Props, group1025Props, toggle3Props, group1026Props, group1027Props, group1028Props, group1029Props, group10210Props, toggle4Props, navItems3Props } = props;
    (0, _react.useEffect)(()=>{
        // Calculate the total number of questions based on sections
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []); // Run this effect only once when the component mounts
    function clicked(question, option) {
        // Si l'option cliquée est la màªme que celle déjà  sélectionnée, on la désélectionne
        if (selectedOptions[question] === option) {
            setSelectedOptions((prevSelectedOptions)=>{
                const newOptions = {
                    ...prevSelectedOptions
                };
                delete newOptions[question];
                return newOptions;
            });
            // Si on désélectionne un "Yes", on décrémente le score
            if (option === "Yes") m_yesCount--;
            return;
        }
        // Sinon, on met à  jour la sélection
        const previousOption = selectedOptions[question];
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        // Si on passe de "No" à  "Yes", on incrémente le score
        if (option === "Yes" && previousOption !== "Yes") m_yesCount++;
        else if (option === "No" && previousOption === "Yes") m_yesCount--;
    }
    const history = (0, _reactRouterDom.useHistory)();
    function saveData() {
        const sections = document.getElementsByTagName("section");
        const data = [];
        for (let section of sections){
            const question = section.querySelector('.question-text').textContent;
            const enabledButton = section.querySelector(".enabled");
            if (enabledButton) {
                const enabledValue = enabledButton.textContent.trim();
                data.push({
                    question,
                    answer: enabledValue
                });
            }
        }
        // Mettre à  jour m_allData
        m_allData = [
            ...data
        ];
        console.log("Collected Data:", m_allData);
        // Sauvegarder les données en base de données
        const enterpriseId = localStorage.getItem("enterpriseId") || "";
        const userId = localStorage.getItem("userId") || "";
        // Préparation des données pour l'API
        const apiData = data.map((item)=>({
                ...item,
                category: "modernization",
                section: "modernization-1",
                enterpriseId: enterpriseId,
                userId: userId,
                timestamp: new Date().toISOString()
            }));
        // Appel API pour sauvegarder les données
        fetch("/api/api/save-answers", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
            },
            body: JSON.stringify(apiData)
        }).then((response)=>{
            if (!response.ok) throw new Error("Network response was not ok");
            return response.json();
        }).then((data)=>{
            console.log("Data saved successfully:", data);
            // Redirection vers la page suivante après sauvegarde réussie
            history.push("/modernization-2");
        }).catch((error)=>{
            console.error("Error saving data:", error);
            // Afficher un message d'erreur
            setErrorMessage("Error saving data. Please try again.");
            // Continuer quand màªme vers la page suivante en cas d'erreur
            history.push("/modernization-2");
        });
    }
    function calculateProgressPercentage() {
        if (totalQuestions === 0) return 0;
        return Math.round(yesCount / totalQuestions * 100);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "modernization-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "modernization-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    className: "modernization-title",
                    children: pleaseAnswerTheFollowingQuestions || "MODERNIZATION ASSESSMENT"
                }),
                errorMessage && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "error-message",
                    children: errorMessage
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "progress-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "progress-bar",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "progress-fill",
                                style: {
                                    width: `${calculateProgressPercentage()}%`
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "progress-text",
                            children: [
                                "Your score: ",
                                yesCount,
                                " / ",
                                totalQuestions,
                                " (",
                                calculateProgressPercentage(),
                                "%)"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "questions-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you use an ERP?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you use an ERP?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you use an ERP?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you use an ERP?", "No"),
                                            className: `btn-option ${selectedOptions["Do you use an ERP?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you use this ERP to place orders?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you use this ERP to place orders?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you use this ERP to place orders?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you use this ERP to place orders?", "No"),
                                            className: `btn-option ${selectedOptions["Do you use this ERP to place orders?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "What communication channel do you use within the company?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "question-actions",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                        type: "text",
                                        className: "form-input",
                                        placeholder: "Enter your answer",
                                        value: selectedOptions["What communication channel do you use within the company?"] || "",
                                        onChange: (e)=>setSelectedOptions({
                                                ...selectedOptions,
                                                "What communication channel do you use within the company?": e.target.value
                                            })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you use robots in your production process?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you use robots in your production process?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you use robots in your production process?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you use robots in your production process?", "No"),
                                            className: `btn-option ${selectedOptions["Do you use robots in your production process?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you use RPA (Robotic Process Automation)?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you use RPA (Robotic Process Automation)?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you use RPA (Robotic Process Automation)?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you use RPA (Robotic Process Automation)?", "No"),
                                            className: `btn-option ${selectedOptions["Do you use RPA (Robotic Process Automation)?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "question-text",
                                    children: "Do you model your processes in 3D for better visibility?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "question-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you model your processes in 3D for better visibility?", "Yes"),
                                            className: `btn-option ${selectedOptions["Do you model your processes in 3D for better visibility?"] === "Yes" ? "enabled" : ""}`,
                                            children: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>clicked("Do you model your processes in 3D for better visibility?", "No"),
                                            className: `btn-option ${selectedOptions["Do you model your processes in 3D for better visibility?"] === "No" ? "enabled" : ""}`,
                                            children: "No"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "navigation-options",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "nav-items-options",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                href: "javascript:SubmitForm('form19')",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "nav-link-option",
                                    children: label1
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefault6Default.default), {
                                children: headerMenuDefault61Props.children
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefault5Default.default), {
                                className: headerMenuDefault51Props.className,
                                children: headerMenuDefault51Props.children
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefault5Default.default), {
                                className: headerMenuDefault52Props.className,
                                children: headerMenuDefault52Props.children
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                href: "javascript:SubmitForm('form19')",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "nav-link-option",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefaultDefault.default), {
                                        children: headerMenuDefaultProps.children
                                    })
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "form-actions",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "toggle-wrapper",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                className: toggle1Props.className,
                                buttonSecondaryProps: toggle1Props.buttonSecondaryProps
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            className: "btn-secondary",
                            children: "Back to Home"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "btn-primary",
                            children: "Continue to Next Section"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "toggle-wrapper",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                className: toggle4Props.className,
                                buttonSecondaryProps: toggle4Props.buttonSecondaryProps
                            })
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Modernization;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["Link","b9X5n"],["useHistory","ditZI"]],"../NavItems3":"fOarC","../NavItems2":"bnQuI","../Avatars":"aC5kW","../Toggle":"dSqDu","../HeaderMenuDefault6":"4VXDc","../HeaderMenuDefault5":"lDhvq","../HeaderMenuDefault":"bD1BI","../HeaderMenuDefault7":"1OItN","../Group102":"cllgP","./Modernization.css":"ghUIT","../../styleguide.css":"8Y7Ec","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aC5kW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _avatarsCss = require("./Avatars.css");
function Avatars(props) {
    const { ellipse83, ellipse81 } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "avatars",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "overlap-group-94",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "mask-group",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "ellipse-83",
                            src: ellipse83,
                            alt: "Ellipse 83"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "ellipse-81",
                            src: ellipse81,
                            alt: "Ellipse 81"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "ellipse-82"
                })
            ]
        })
    });
}
exports.default = Avatars;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./Avatars.css":"bfsTg","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bfsTg":[function() {},{}],"4VXDc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _headerMenuDefault6Css = require("./HeaderMenuDefault6.css");
function HeaderMenuDefault6({ children, className }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `header-menu-default-6 ${className || ""}`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
            to: "/acquisition",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "label-170 inter-medium-gravel-14px",
                children: children
            })
        })
    });
}
exports.default = HeaderMenuDefault6;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"b9X5n","./HeaderMenuDefault6.css":"krfkT","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"krfkT":[function() {},{}],"1OItN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _headerMenuDefault7Css = require("./HeaderMenuDefault7.css");
function HeaderMenuDefault7() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
        to: "/acquisition",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "menu-item-default-41",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "label-171 inter-medium-wild-sand-14px",
                children: "Acquisition"
            })
        })
    });
}
exports.default = HeaderMenuDefault7;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"b9X5n","./HeaderMenuDefault7.css":"d0mn7","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"d0mn7":[function() {},{}],"ghUIT":[function() {},{}],"8Y7Ec":[function() {},{}],"g8BbC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _loginCss = require("./Login.css");
var _reactRouterDom = require("react-router-dom");
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
var _1200PxLogoIcam20081432XPng = require("../../static/img/1200px-logo-icam---2008-1-43@2x.png");
var _1200PxLogoIcam20081432XPngDefault = parcelHelpers.interopDefault(_1200PxLogoIcam20081432XPng);
var _authContext = require("../../context/AuthContext");
function Login() {
    const [username, setUsername] = (0, _react.useState)('');
    const [password, setPassword] = (0, _react.useState)('');
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const [error, setError] = (0, _react.useState)('');
    const history = (0, _reactRouterDom.useHistory)();
    const { login, isAuthenticated } = (0, _authContext.useAuth)();
    // ðŸ”„ Rediriger si déjà  connecté
    (0, _react.useEffect)(()=>{
        console.log("Login - V\xe9rification authentification:", isAuthenticated);
        if (isAuthenticated) {
            console.log("D\xe9j\xe0\xa0 authentifi\xe9 \xe2\u2020\u2019 redirection /home");
            history.push('/home');
        }
    }, [
        isAuthenticated,
        history
    ]);
    // ðŸ” Traitement du Login
    const handleLogin = async (e)=>{
        e.preventDefault();
        setIsLoading(true);
        setError('');
        try {
            console.log("Tentative connexion avec:", username);
            const response = await (0, _axiosDefault.default).post(`${"/api"}/login`, {
                username,
                password
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    'ngrok-skip-browser-warning': 'true'
                }
            });
            console.log("R\xe9ponse login:", response.data);
            // âœ” Détecter rà´le administrateur
            const isAdmin = response.data?.is_admin || false;
            // ðŸ”‘ Récupérer token dans tous les cas possibles
            const token = response.data?.access_token || response.data?.token || response.data?.jwt || response.data?.authToken || response.data?.user?.token || null;
            if (!token) {
                console.error("\xe2\x9d\u0152 Aucun token trouv\xe9 dans la r\xe9ponse !");
                setError("Erreur : aucun token renvoy\xe9 par le serveur.");
                setIsLoading(false);
                return;
            }
            // âœ” Stockage du token
            localStorage.setItem("token", token);
            console.log("\xf0\u0178\u201D\x90 Token stock\xe9 :", token);
            // ï¿½ï¿½ âœ” Stockage userId et enterpriseId
            if (response.data?.user) {
                if (response.data.user.id) {
                    localStorage.setItem("userId", response.data.user.id);
                    console.log("\xf0\u0178\u2018\xa4 userId stock\xe9 :", response.data.user.id);
                }
                if (response.data.user.enterpriseId) {
                    localStorage.setItem("enterpriseId", response.data.user.enterpriseId);
                    console.log("\xf0\u0178\x8f\xa2 enterpriseId stock\xe9 :", response.data.user.enterpriseId);
                }
            } else console.warn("\xe2\u0161\xa0 Aucun userId / enterpriseId renvoy\xe9 par l'API !");
            // âœ” Stockage infos auth
            localStorage.setItem("isAuthenticated", "true");
            localStorage.setItem("isAdmin", isAdmin.toString());
            localStorage.setItem("username", username);
            // âœ” Mise à  jour du contexte global
            login(isAdmin);
            console.log("\xe2\u0153\u201D Connexion r\xe9ussie, \xe9tat auth mis \xe0\xa0 jour");
            // ðŸ” Redirection selon rà´le
            setTimeout(()=>{
                if (isAdmin) window.location.href = "/admin";
                else window.location.href = "/home";
            }, 100);
        } catch (error) {
            console.error("Erreur login:", error);
            if (error.response) setError(`Error ${error.response.status}: ${error.response.data.detail || "Invalid username or password"}`);
            else if (error.request) setError("Server not responding. Check connection or backend status.");
            else setError(error.message || "Error during login.");
        } finally{
            setIsLoading(false);
        }
    };
    // Navigation vers signup
    const navigateToRegister = ()=>{
        history.push('/inscription');
    };
    // ðŸ–¥ï¸ UI
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "login-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "login-card",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "login-left",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "login-logo-container",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                src: (0, _1200PxLogoIcam20081432XPngDefault.default),
                                alt: "ICAM Logo",
                                className: "login-logo"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                            className: "login-welcome",
                            children: "Welcome to the Supply Chain Platform"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "login-description",
                            children: "Log in to access your personal space and manage your projects."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "login-right",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "login-form-container",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                className: "login-title",
                                children: "Login"
                            }),
                            error && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "login-error",
                                children: error
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                                onSubmit: handleLogin,
                                className: "login-form",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "login-input-group",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                htmlFor: "username",
                                                children: "Username"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                type: "text",
                                                id: "username",
                                                value: username,
                                                onChange: (e)=>setUsername(e.target.value),
                                                required: true,
                                                placeholder: "Enter your username"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "login-input-group",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                htmlFor: "password",
                                                children: "Password"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                type: "password",
                                                id: "password",
                                                value: password,
                                                onChange: (e)=>setPassword(e.target.value),
                                                required: true,
                                                placeholder: "Enter your password"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        type: "submit",
                                        className: "login-button",
                                        disabled: isLoading,
                                        children: isLoading ? "Logging in..." : "Login"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "login-footer",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        children: "Don't have an account?"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        type: "button",
                                        onClick: navigateToRegister,
                                        className: "register-link",
                                        children: "Register"
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
}
exports.default = Login;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./Login.css":"lv9Nu","react-router-dom":"ditZI","axios":"kL5AO","../../static/img/1200px-logo-icam---2008-1-43@2x.png":"fcd5E","../../context/AuthContext":"5fsmo","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lv9Nu":[function() {},{}],"fcd5E":[function() {},{}],"1fPt4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _analysisCss = require("./Analysis.css"); // Import the corresponding CSS file
var _reactRouterDom = require("react-router-dom");
function BeautifulPage() {
    const [result, setResult] = (0, _react.useState)(null);
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const [error, setError] = (0, _react.useState)(null);
    function inference() {
        setIsLoading(true);
        setError(null);
        fetch("/api/inferences", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            }
        }).then((response)=>{
            if (!response.ok) throw new Error("Erreur lors de l'analyse");
            return response.json();
        }).then((data)=>{
            console.log("Response from server:", data);
            setResult(data);
            setIsLoading(false);
        }).catch((error)=>{
            console.error(error);
            setError(error.message);
            setIsLoading(false);
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "beautifulpage",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "navbar",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("ul", {
                    className: "nav_links",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                src: "/img/logo.png",
                                alt: "logo",
                                className: "nav-logo"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                to: "/home",
                                children: "Accueil"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                to: "/analysis",
                                className: "active",
                                children: "Analyse"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "main-content",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                        className: "page-title",
                        children: "Analyse des Documents"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "button",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            type: "submit",
                            onClick: inference,
                            disabled: isLoading,
                            className: "analysis-button",
                            children: isLoading ? "Analyse en cours..." : "Lancer l'analyse"
                        })
                    }),
                    error && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "error-message",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: error
                        })
                    }),
                    isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "loading-container",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "loading-spinner"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                children: "Analyse en cours, veuillez patienter..."
                            })
                        ]
                    }),
                    result && !isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "body",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                className: "results-title",
                                children: "R\xe9sultats de l'analyse"
                            }),
                            result.reduce((acc, item)=>{
                                const documentIndex = item.DocumentIndex;
                                const existingItem = acc.find((groupedItem)=>groupedItem.documentIndex === documentIndex);
                                if (existingItem) existingItem.results.push(item);
                                else acc.push({
                                    documentIndex,
                                    results: [
                                        item
                                    ]
                                });
                                return acc;
                            }, []).map((group, groupIndex)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "result-box",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h3", {
                                            className: "document-title",
                                            children: [
                                                "Document ",
                                                group.documentIndex + 1,
                                                " ",
                                                group.doc_name && `- ${group.doc_name}`
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "scrollable-container",
                                            children: group.results.map((item, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "result-item",
                                                    children: [
                                                        item.Element && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                                    className: "analysis-text",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                                            children: "Analyse:"
                                                                        }),
                                                                        " ",
                                                                        item.Analysis
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                                    className: "element-info",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                            className: "info-label",
                                                                            children: "Informations:"
                                                                        }),
                                                                        "Ligne ",
                                                                        item.Element.row,
                                                                        ", Colonne ",
                                                                        item.Element.column,
                                                                        ", En-t\xe0\xaate ",
                                                                        item.Element.heading
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        !item.Element && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                            className: "analysis-text",
                                                            children: item.Analysis
                                                        })
                                                    ]
                                                }, index))
                                        })
                                    ]
                                }, groupIndex))
                        ]
                    })
                ]
            })
        ]
    });
}
exports.default = BeautifulPage;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./Analysis.css":"iKrUf","react-router-dom":"b9X5n","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iKrUf":[function() {},{}],"lTpbR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _implementationCss = require("./Implementation.css");
function Implementation() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "implementation-wrapper",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "implementation-card",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                            className: "implementation-title",
                            children: "Evaluation dashboard"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "implementation-buttons",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Link), {
                                    to: "/measuring-form_",
                                    className: "action-button context",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "button-icon",
                                            children: "\uD83C\uDFE2"
                                        }),
                                        "New Acquisition Context"
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Link), {
                                    to: "/compare-cases",
                                    className: "action-button compare",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "button-icon",
                                            children: "\uD83D\uDCCA"
                                        }),
                                        "Compare Case Progress"
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "icam-navigation",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                    to: "/conception",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: "footer-btn",
                        children: "Back to Conception"
                    })
                })
            })
        ]
    });
}
exports.default = Implementation;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"b9X5n","./Implementation.css":"89wEt","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"89wEt":[function() {},{}],"dLwaS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _pdfUploaderCss = require("./PdfUploader.css");
function PdfUploader() {
    const [pdfFile, setPdfFile] = (0, _react.useState)(null);
    const [pdfUrl, setPdfUrl] = (0, _react.useState)(null);
    const [error, setError] = (0, _react.useState)("");
    const [uploading, setUploading] = (0, _react.useState)(false);
    const [message, setMessage] = (0, _react.useState)("");
    const [caseId, setCaseId] = (0, _react.useState)(null);
    const [caseData, setCaseData] = (0, _react.useState)(null);
    const fileInputRef = (0, _react.useRef)(null);
    const history = (0, _reactRouterDom.useHistory)();
    // âœ… Load caseId from localStorage
    (0, _react.useEffect)(()=>{
        const storedCaseId = localStorage.getItem("caseId");
        if (storedCaseId && storedCaseId !== "undefined" && storedCaseId !== "null") {
            setCaseId(storedCaseId);
            console.log("caseId loaded:", storedCaseId);
        } else {
            console.warn("No valid caseId found in localStorage");
            setError("No active case found.");
        }
    }, []);
    // ðŸ” Load case details only if caseId is valid
    (0, _react.useEffect)(()=>{
        if (!caseId) return; // â— Prevent API call with null/undefined
        const apiUrl = "/api";
        if (!apiUrl) {
            setError("API_URL is not defined in env.js");
            return;
        }
        const fetchCaseDetails = async ()=>{
            try {
                console.log(`Fetching case: ${apiUrl}/api/case-details/${caseId}`);
                const response = await fetch(`${apiUrl}/api/case-details/${caseId}`, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("token") || ""}`
                    }
                });
                if (response.status === 404) {
                    setError("This case does not exist anymore (404).");
                    return;
                }
                if (!response.ok) throw new Error(`Error loading case: ${response.status}`);
                const data = await response.json();
                if (!data || !data.case) {
                    setError("Server returned an empty case.");
                    return;
                }
                setCaseData(data.case);
                console.log("Case data loaded:", data.case);
            } catch (err) {
                console.error("Case loading error:", err);
                setError(`Unable to load case: ${err.message}`);
            }
        };
        fetchCaseDetails();
    }, [
        caseId
    ]);
    // ðŸ“ Select PDF
    const handleFileChange = (event)=>{
        const file = event.target.files[0];
        if (!file) return;
        if (file.type !== "application/pdf") {
            setError("\xe2\x9d\u0152 Please select a valid PDF file.");
            setPdfFile(null);
            setPdfUrl(null);
            return;
        }
        setError("");
        setPdfFile(file);
        setPdfUrl(URL.createObjectURL(file));
    };
    // âŒ Remove PDF
    const handleRemoveFile = ()=>{
        setPdfFile(null);
        setPdfUrl(null);
        setError("");
        setMessage("");
        if (fileInputRef.current) fileInputRef.current.value = null;
    };
    // ðŸš€ Upload to backend
    const handleUpload = async ()=>{
        if (!pdfFile) {
            setError(" No file selected!");
            return;
        }
        if (!caseId) {
            setError(" No case ID detected.");
            return;
        }
        setUploading(true);
        setMessage("\xe2\x8f\xb3 Uploading...");
        setError("");
        try {
            const formData = new FormData();
            formData.append("file", pdfFile);
            const apiUrl = "/api";
            if (!apiUrl) throw new Error("API_URL is not defined!");
            const uploadUrl = `${apiUrl}/api/case/${caseId}/upload-pdf`;
            console.log("Uploading to:", uploadUrl);
            const response = await fetch(uploadUrl, {
                method: "POST",
                body: formData,
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token") || ""}`
                }
            });
            const contentType = response.headers.get("content-type");
            let data = null;
            if (contentType?.includes("application/json")) data = await response.json();
            else throw new Error(`Server returned non-JSON response (${response.status})`);
            if (!response.ok) throw new Error(data?.detail || data?.message || `Server error ${response.status}`);
            setMessage("\xe2\u0153\u2026 PDF successfully uploaded!");
        } catch (err) {
            console.error("Upload FAIL:", err);
            setError(`Upload failed: ${err.message}`);
        } finally{
            setUploading(false);
        }
    };
    // ðŸŽ¨ UI rendering
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "pdf-uploader-container",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "pdf-uploader-card",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                            className: "pdf-uploader-title",
                            children: "Upload Case PDF"
                        }),
                        caseData ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "analysis-header-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                    className: "analysis-company-name",
                                    children: caseData.company_name || caseData.enterpriseName
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                    className: "analysis-info-line",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "analysis-icon"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                            children: "Sector: "
                                        }),
                                        " ",
                                        caseData.activity_sector,
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            style: {
                                                margin: "0 6px"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                            children: "Size: "
                                        }),
                                        " ",
                                        caseData.company_size || "-",
                                        " employees"
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                    className: "analysis-info-line",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "analysis-icon"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                            children: "Created on: "
                                        }),
                                        new Date(caseData.timestamp).toLocaleString()
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            style: {
                                color: "black",
                                fontWeight: "bold"
                            },
                            children: "loading..."
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                            className: "pdf-button upload",
                            children: [
                                "Select PDF",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    ref: fileInputRef,
                                    type: "file",
                                    accept: "application/pdf",
                                    onChange: handleFileChange,
                                    style: {
                                        display: "none"
                                    }
                                })
                            ]
                        }),
                        error && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            style: {
                                color: "red"
                            },
                            children: error
                        }),
                        pdfFile && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    style: {
                                        marginTop: "15px"
                                    },
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                        children: pdfFile.name
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "pdf-buttons",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            className: "pdf-button upload",
                                            onClick: handleUpload,
                                            disabled: uploading,
                                            children: uploading ? "Uploading..." : "Upload"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            className: "pdf-button delete",
                                            onClick: handleRemoveFile,
                                            children: "Remove"
                                        })
                                    ]
                                })
                            ]
                        }),
                        message && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            style: {
                                marginTop: "15px",
                                color: "green",
                                fontWeight: 500
                            },
                            children: message
                        }),
                        pdfUrl && /*#__PURE__*/ (0, _jsxRuntime.jsx)("iframe", {
                            src: pdfUrl,
                            className: "pdf-preview",
                            title: "PDF Preview"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "icam-navigation",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                        to: "/visual-management-1",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            className: "icam-nav-btn",
                            children: "Back to visual management"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                        to: "/analysisbeta",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            className: "icam-nav-btn",
                            children: "Move to Analysis"
                        })
                    })
                ]
            })
        ]
    });
}
exports.default = PdfUploader;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["Link","b9X5n"],["useHistory","ditZI"]],"./PdfUploader.css":"gbRmf","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gbRmf":[function() {},{}],"dIHLo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CompanyCases);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _companyCasesCss = require("./CompanyCases.css");
function CompanyCases() {
    const { companyId } = (0, _reactRouterDom.useParams)();
    const [cases, setCases] = (0, _react.useState)([]);
    const [loading, setLoading] = (0, _react.useState)(true);
    const fetchCases = async ()=>{
        try {
            const res = await fetch(`${"/api"}/api/cases/by-enterprise/${companyId}`, {
                headers: {
                    "ngrok-skip-browser-warning": "true"
                }
            });
            const data = await res.json();
            console.log("CASES FROM BACKEND:", data);
            setCases(data.cases || []);
            setLoading(false);
        } catch (error) {
            console.error("Error loading cases:", error);
            setLoading(false);
        }
    };
    (0, _react.useEffect)(()=>{
        fetchCases();
    }, [
        companyId
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "company-cases-container",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    className: "company-cases-title",
                    children: "Company Cases"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                    to: "/existing-case",
                    className: "back-btn",
                    children: "\xe2\xac\u2026 Back to Companies"
                }),
                loading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "loading",
                    children: "Loading..."
                }) : cases.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "no-cases",
                    children: "No cases found for this company."
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "cases-list",
                    children: cases.map((item)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "case-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                    className: "case-title",
                                    children: item.caseName || "Company Case"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                            children: "Created:"
                                        }),
                                        new Date(item.date_created || item.timestamp).toLocaleDateString()
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                    to: `/case-details/${item._id}`,
                                    className: "view-details-btn",
                                    children: "View Case"
                                })
                            ]
                        }, item._id))
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["Link","b9X5n"],["useParams","ditZI"]],"./CompanyCases.css":"aMHCX","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aMHCX":[function() {},{}],"9rv3R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SavingUploadPage);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _pdfUploader = require("../PdfUploader");
var _pdfUploaderDefault = parcelHelpers.interopDefault(_pdfUploader);
function SavingUploadPage() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        style: {
            padding: "20px"
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pdfUploaderDefault.default), {})
    });
}

},{"react/jsx-runtime":"gonF6","react":"bmhQu","../PdfUploader":"dLwaS","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dVawJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CompareCases);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _compareCasesCss = require("./CompareCases.css");
const API_URL = "/api";
/* =========================
   UTILITAIRES : CAS ACTIF
========================= */ function getActiveCaseId() {
    const qs = new URLSearchParams(window.location.search);
    const fromQuery = qs.get("caseId");
    if (fromQuery) return fromQuery;
    const fromActive = localStorage.getItem("active_case_id");
    if (fromActive) return fromActive;
    const fromLegacy = localStorage.getItem("caseId");
    if (fromLegacy) return fromLegacy;
    return "";
}
function getActiveEnterpriseId() {
    const qs = new URLSearchParams(window.location.search);
    return qs.get("enterpriseId") || localStorage.getItem("active_enterprise_id") || "";
}
/* =========================
   FETCH HELPERS
========================= */ async function fetchJson(url) {
    const token = localStorage.getItem("token") || "";
    const res = await fetch(url, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    const data = await res.json().catch(()=>null);
    if (!res.ok) throw new Error(data?.error || data?.detail || `HTTP ${res.status}`);
    return data;
}
function normalizeCases(payload) {
    if (Array.isArray(payload)) return payload;
    if (payload?.cases) return payload.cases;
    if (payload?.data) return payload.data;
    return [];
}
/**
 * âœ… On charge les cas via l'endpoint qui existe dans ton backend :
 * /api/cases/by-enterprise/{enterpriseId}
 *
 * Si enterpriseId absent, on NE fait pas un call qui 404.
 * On renvoie une liste vide + message clair cà´té UI.
 */ async function fetchCasesList() {
    const enterpriseId = getActiveEnterpriseId();
    if (!enterpriseId) // On ne throw pas pour éviter un écran bloqué : on laisse la page afficher un message
    return {
        list: [],
        error: "Enterprise ID introuvable. Ajoute ?enterpriseId=... dans l\xe2\u20AC\u2122URL (ou d\xe9finis active_enterprise_id)."
    };
    const data = await fetchJson(`${API_URL}/api/cases/by-enterprise/${enterpriseId}`);
    const list = normalizeCases(data);
    return {
        list: Array.isArray(list) ? list : [],
        error: ""
    };
}
/** âœ… Endpoint 8 radars (existe dans ton backend) */ async function postAllRadarsFromCase(caseId, includeAI) {
    const token = localStorage.getItem("token") || "";
    const res = await fetch(`${API_URL}/api/ai/curperformance-all-radars-from-case`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
            case_id: caseId,
            scale: 20,
            include_ai_commentary: includeAI
        })
    });
    const data = await res.json().catch(()=>null);
    if (!res.ok) throw new Error(data?.error || data?.detail || `HTTP ${res.status}`);
    return data;
}
/* =========================
   OUTILS AFFICHAGE
========================= */ function safeJsonParse(str) {
    if (!str || typeof str !== "string") return null;
    try {
        return JSON.parse(str.replace(/```json|```/g, "").trim());
    } catch  {
        return null;
    }
}
function formatCaseLabel(c) {
    const id = c?._id || c?.id || "";
    const name = c?.company_name || c?.companyName || "Entreprise";
    const date = c?.date_created || c?.timestamp || "";
    const shortId = id ? String(id).slice(0, 6) + "\xe2\u20AC\xa6" : "";
    return `${name}${date ? ` \xe2\u{20AC}\u{201D} ${date}` : ""}${shortId ? ` (${shortId})` : ""}`;
}
const ORDERED_KEYS = [
    "Environment",
    "Social",
    "Modernization",
    "Lead Time",
    "Cost",
    "Quality",
    "Client / Consumer"
];
function CompareCases() {
    const [cases, setCases] = (0, _react.useState)([]);
    const [casesLoading, setCasesLoading] = (0, _react.useState)(false);
    const [casesError, setCasesError] = (0, _react.useState)("");
    const [activeCaseId, setActiveCaseId] = (0, _react.useState)(getActiveCaseId());
    const [includeAI, setIncludeAI] = (0, _react.useState)(false);
    const [loading, setLoading] = (0, _react.useState)(false);
    const [error, setError] = (0, _react.useState)("");
    const [companyName, setCompanyName] = (0, _react.useState)("");
    const [pdf, setPdf] = (0, _react.useState)(null);
    const [globalRadarB64, setGlobalRadarB64] = (0, _react.useState)("");
    const [criterionRadars, setCriterionRadars] = (0, _react.useState)({});
    const [missingBreakdowns, setMissingBreakdowns] = (0, _react.useState)([]);
    const [commentary, setCommentary] = (0, _react.useState)(null);
    const commentJson = (0, _react.useMemo)(()=>safeJsonParse(commentary), [
        commentary
    ]);
    /* âœ… synchro multi-pages */ (0, _react.useEffect)(()=>{
        const onStorage = ()=>{
            const newId = getActiveCaseId();
            if (newId && newId !== activeCaseId) setActiveCaseId(newId);
        };
        window.addEventListener("storage", onStorage);
        return ()=>window.removeEventListener("storage", onStorage);
    }, [
        activeCaseId
    ]);
    /* âœ… charger liste des cas */ (0, _react.useEffect)(()=>{
        (async ()=>{
            setCasesLoading(true);
            setCasesError("");
            try {
                const { list, error: listError } = await fetchCasesList();
                setCases(list);
                if (listError) setCasesError(listError);
                // âœ… si pas encore de cas actif, prendre le 1er
                if (!activeCaseId && list.length) {
                    const firstId = String(list[0]._id || list[0].id || "");
                    setActiveCaseId(firstId);
                    localStorage.setItem("active_case_id", firstId);
                }
            } catch (e) {
                setCasesError(e?.message || "Erreur chargement cas");
            } finally{
                setCasesLoading(false);
            }
        })();
    // eslint-disable-next-line
    }, []);
    async function loadRadars(caseId, withAI) {
        setError("");
        setLoading(true);
        setCompanyName("");
        setPdf(null);
        setGlobalRadarB64("");
        setCriterionRadars({});
        setMissingBreakdowns([]);
        setCommentary(null);
        try {
            if (!caseId) throw new Error("Aucun cas s\xe9lectionn\xe9.");
            // âœ… mémoriser enterpriseId si présent (important pour éviter erreurs sur dâ€™autres pages)
            const enterpriseId = getActiveEnterpriseId();
            if (enterpriseId) localStorage.setItem("active_enterprise_id", enterpriseId);
            const data = await postAllRadarsFromCase(caseId, withAI);
            setCompanyName(data.company_name || "");
            setPdf(data.curperformance_pdf || null);
            setGlobalRadarB64(data?.global?.radar_png_base64 || "");
            setCriterionRadars(data?.by_criterion || {});
            setMissingBreakdowns(data?.missing_breakdowns || []);
            setCommentary(data.commentary || null);
            localStorage.setItem("active_case_id", caseId);
        } catch (e) {
            setError(e?.message || String(e));
        } finally{
            setLoading(false);
        }
    }
    (0, _react.useEffect)(()=>{
        if (activeCaseId) loadRadars(activeCaseId, includeAI);
    // eslint-disable-next-line
    }, [
        activeCaseId,
        includeAI
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "compareCasesPage",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "compareCases",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("header", {
                    className: "compareCases__header",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                    className: "compareCases__title",
                                    children: "CurPerformance \xe2\u20AC\u201D Radars"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "compareCases__subtitle",
                                    children: "1 radar global + 7 radars d\xe9taill\xe9s (si sous-scores disponibles)."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                            className: `pill ${includeAI ? "pill--on" : "pill--off"}`,
                            children: [
                                "IA ",
                                includeAI ? "ON" : "OFF"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "ccCard ccActiveCard",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "ccField",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "ccFieldHead",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "ccLabel",
                                            children: "Cas actif"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "ccHintBadge",
                                            children: casesLoading ? "Loading\xe2\u20AC\xa6" : `${cases.length} cas`
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("select", {
                                    className: "ccSelect",
                                    value: activeCaseId,
                                    onChange: (e)=>setActiveCaseId(e.target.value),
                                    disabled: casesLoading || !cases.length,
                                    children: [
                                        !cases.length && /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                            value: "",
                                            children: "Aucun cas"
                                        }),
                                        cases.map((c)=>{
                                            const id = String(c._id || c.id || "");
                                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                                value: id,
                                                children: formatCaseLabel(c)
                                            }, id);
                                        })
                                    ]
                                }),
                                casesError && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "ccMiniError",
                                    children: casesError
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                            className: "ccToggleRow",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    type: "checkbox",
                                    checked: includeAI,
                                    onChange: (e)=>setIncludeAI(e.target.checked),
                                    disabled: !activeCaseId
                                }),
                                "Commentaire IA"
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "ccActions",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    className: "ccBtn ccBtn--primary",
                                    onClick: ()=>loadRadars(activeCaseId, includeAI),
                                    disabled: loading || !activeCaseId,
                                    children: loading ? "G\xe9n\xe9ration..." : "R\xe9g\xe9n\xe9rer"
                                }),
                                pdf?.file_id && /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                    className: "ccBtn ccBtn--ghost",
                                    href: `${API_URL}/api/pdf/${encodeURIComponent(pdf.file_id)}`,
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: "Ouvrir PDF CurPerformance"
                                })
                            ]
                        })
                    ]
                }),
                error && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "ccError",
                    children: error
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "ccCard radarCard",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "radarCard__top",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                className: "radarCard__title",
                                children: companyName || "Entreprise"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "radarGrid",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "radarTile radarTile--global",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "radarTile__head",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "radarTile__title",
                                                    children: "Global"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "radarTile__sub",
                                                    children: "7 crit\xe8res"
                                                })
                                            ]
                                        }),
                                        globalRadarB64 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "radarTile__imgWrap",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                className: "radarTile__img",
                                                src: `data:image/png;base64,${globalRadarB64}`,
                                                alt: "Radar Global"
                                            })
                                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "radarTile__placeholder",
                                            children: loading ? "G\xe9n\xe9ration..." : "Aucun radar"
                                        })
                                    ]
                                }),
                                ORDERED_KEYS.map((k)=>{
                                    const b64 = criterionRadars?.[k];
                                    const isMissing = Array.isArray(missingBreakdowns) && missingBreakdowns.includes(k);
                                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "radarTile",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "radarTile__head",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "radarTile__title",
                                                        children: k
                                                    }),
                                                    isMissing ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "radarTile__badge radarTile__badge--warn",
                                                        children: "Sous-scores manquants"
                                                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "radarTile__badge",
                                                        children: "D\xe9tail"
                                                    })
                                                ]
                                            }),
                                            b64 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "radarTile__imgWrap",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "radarTile__img",
                                                    src: `data:image/png;base64,${b64}`,
                                                    alt: `Radar ${k}`
                                                })
                                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "radarTile__placeholder",
                                                children: loading ? "G\xe9n\xe9ration..." : "Pas de radar d\xe9taill\xe9"
                                            })
                                        ]
                                    }, k);
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "radarCard__comment",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "radarCard__commentHeader",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                            className: "radarCard__sectionTitle",
                                            children: "Commentaire"
                                        }),
                                        !includeAI && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "radarCard__badge",
                                            children: "IA d\xe9sactiv\xe9e"
                                        })
                                    ]
                                }),
                                !includeAI && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "radarCard__hint",
                                    children: "Active \xe2\u20AC\u0153Commentaire IA\xe2\u20AC\x9d pour g\xe9n\xe9rer l\xe2\u20AC\u2122analyse."
                                }),
                                includeAI && !commentary && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "radarCard__hint",
                                    children: "Commentaire non fourni."
                                }),
                                commentJson ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("pre", {
                                    className: "radarCard__pre",
                                    children: JSON.stringify(commentJson, null, 2)
                                }) : commentary && /*#__PURE__*/ (0, _jsxRuntime.jsx)("pre", {
                                    className: "radarCard__pre",
                                    children: commentary
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./CompareCases.css":"3DzM5","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3DzM5":[function() {},{}]},["lfXpc"], "lfXpc", "parcelRequire3745", {})

//# sourceMappingURL=app.81979c38.js.map
